// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  var $parcel$bundleURL;function $parcel$resolve(url) {  url = importMap[url] || url;  if (!$parcel$bundleURL) {    try {      throw new Error();    } catch (err) {      var matches = ('' + err.stack).match(        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,      );      if (matches) {        $parcel$bundleURL = matches[0];      } else {        return distDir + url;      }    }  }  return new URL(distDir + url, $parcel$bundleURL).toString();}newRequire.resolve = $parcel$resolve;

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"idGTa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _prepareStore = require("./src/app/store/prepareStore");
var _deps = require("./src/app/deps");
var _handlers = require("./src/app/handlers");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _startDom = require("./startDom");
var _initSentry = require("./initSentry");
var _initAmplitude = require("./src/app/deps/initAmplitude");
(0, _initSentry.initSentry)();
var _prepareStore1 = (0, _prepareStore.prepareStore)(), store = _prepareStore1.store, eventBus = _prepareStore1.eventBus;
var deps = (0, _deps.prepareDeps)(store, eventBus);
(0, _initAmplitude.initAmplitude)(deps);
(0, _handlers.initHandlers)({
    eventBus: eventBus,
    deps: deps
});
(0, _startDom.startDom)({
    store: store,
    eventBus: eventBus,
    deps: deps
});

},{"./src/app/store/prepareStore":"drAFe","./src/app/deps":"9JzsQ","./src/app/handlers":"hlIB1","react":"c8CN1","./startDom":"iwlTF","./initSentry":"3RamT","./src/app/deps/initAmplitude":"Hjlgq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"drAFe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "prepareStore", function() {
    return prepareStore;
});
var _redux = require("redux");
var _reduxDevtoolsExtension = require("redux-devtools-extension");
var _std = require("@reglo/std");
var _rootReducer = require("./rootReducer");
var _browser = require("@sentry/browser");
function prepareStore() {
    var _prepareEventBus = (0, _std.prepareEventBus)(), eventBus = _prepareEventBus.eventBus, eventBusMiddleware = _prepareEventBus.eventBusMiddleware;
    var store = (0, _redux.createStore)((0, _rootReducer.rootReducer), (0, _reduxDevtoolsExtension.composeWithDevTools)((0, _redux.applyMiddleware)(eventBusMiddleware)));
    eventBus.onResult(function(result) {
        return result ? store.dispatch(result) : undefined;
    });
    eventBus.onError(function(error) {
        _browser.captureException(error);
        throw error;
    });
    return {
        store: store,
        eventBus: eventBus
    };
}

},{"redux":"lKoa8","redux-devtools-extension":"5NEaL","@reglo/std":"1USo0","./rootReducer":"l6DuW","@sentry/browser":"g8Lrm","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"lKoa8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__DO_NOT_USE__ActionTypes", function() {
    return ActionTypes;
});
parcelHelpers.export(exports, "applyMiddleware", function() {
    return applyMiddleware;
});
parcelHelpers.export(exports, "bindActionCreators", function() {
    return bindActionCreators;
});
parcelHelpers.export(exports, "combineReducers", function() {
    return combineReducers;
});
parcelHelpers.export(exports, "compose", function() {
    return compose;
});
parcelHelpers.export(exports, "createStore", function() {
    return createStore;
});
parcelHelpers.export(exports, "legacy_createStore", function() {
    return legacy_createStore;
});
var _objectSpread2 = require("@babel/runtime/helpers/esm/objectSpread2");
var _objectSpread2Default = parcelHelpers.interopDefault(_objectSpread2);
/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}
// Inlined version of the `symbol-observable` polyfill
var $$observable = function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var randomString = function randomString() {
    return Math.random().toString(36).substring(7).split('').join('.');
};
var ActionTypes = {
    INIT: "@@redux/INIT" + randomString(),
    REPLACE: "@@redux/REPLACE" + randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function isPlainObject(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function miniKindOf(val) {
    if (val === void 0) return 'undefined';
    if (val === null) return 'null';
    var type = typeof val;
    switch(type){
        case 'boolean':
        case 'string':
        case 'number':
        case 'symbol':
        case 'function':
            return type;
    }
    if (Array.isArray(val)) return 'array';
    if (isDate(val)) return 'date';
    if (isError(val)) return 'error';
    var constructorName = ctorName(val);
    switch(constructorName){
        case 'Symbol':
        case 'Promise':
        case 'WeakMap':
        case 'WeakSet':
        case 'Map':
        case 'Set':
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}
function ctorName(val) {
    return typeof val.constructor === 'function' ? val.constructor.name : null;
}
function isError(val) {
    return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}
function isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}
function kindOf(val) {
    var typeOfVal = typeof val;
    typeOfVal = miniKindOf(val);
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function createStore(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') throw new Error("It looks like you are passing several store enhancers to createStore(). This is not supported. Instead, compose them together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.");
    if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== 'undefined') {
        if (typeof enhancer !== 'function') throw new Error("Expected the enhancer to be a function. Instead, received: '" + kindOf(enhancer) + "'");
        return enhancer(createStore)(reducer, preloadedState);
    }
    if (typeof reducer !== 'function') throw new Error("Expected the root reducer to be a function. Instead, received: '" + kindOf(reducer) + "'");
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error("You may not call store.getState() while the reducer is executing. The reducer has already received the state as an argument. Pass it down from the top reducer instead of reading it from the store.");
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== 'function') throw new Error("Expected the listener to be a function. Instead, received: '" + kindOf(listener) + "'");
        if (isDispatching) throw new Error("You may not call store.subscribe() while the reducer is executing. If you would like to be notified after the store has been updated, subscribe from a component and invoke store.getState() in the callback to access the latest state. See https://redux.js.org/api/store#subscribelistener for more details.");
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error("You may not unsubscribe from a store listener while the reducer is executing. See https://redux.js.org/api/store#subscribelistener for more details.");
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!isPlainObject(action)) throw new Error("Actions must be plain objects. Instead, the actual type was: '" + kindOf(action) + "'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.");
        if (typeof action.type === 'undefined') throw new Error('Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
        if (isDispatching) throw new Error('Reducers may not dispatch actions.');
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== 'function') throw new Error("Expected the nextReducer to be a function. Instead, received: '" + kindOf(nextReducer));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: ActionTypes.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) throw new Error("Expected the observer to be an object. Instead, received: '" + kindOf(observer) + "'");
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: ActionTypes.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var legacy_createStore = createStore;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function warning(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!isPlainObject(inputState)) return "The " + argumentName + " has unexpected type of \"" + kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === ActionTypes.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
}
function assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: ActionTypes.INIT
        });
        if (typeof initialState === 'undefined') throw new Error("The slice reducer for key \"" + key + "\" returned undefined during initialization. " + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
        if (typeof reducer(undefined, {
            type: ActionTypes.PROBE_UNKNOWN_ACTION()
        }) === 'undefined') throw new Error("The slice reducer for key \"" + key + "\" returned undefined when probed with a random type. " + ("Don't try to handle '" + ActionTypes.INIT + "' or other actions in \"redux/*\" ") + "namespace. They are considered private. Instead, you must return the " + "current state for any unknown actions, unless it is undefined, " + "in which case you must return the initial state, regardless of the " + "action type. The initial state may not be undefined, but can be null.");
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function combineReducers(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === 'undefined') warning("No reducer provided for key \"" + key + "\"");
        if (typeof reducers[key] === 'function') finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    unexpectedKeyCache = {};
    var shapeAssertionError;
    try {
        assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
        if (warningMessage) warning(warningMessage);
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === 'undefined') {
                var actionType = action && action.type;
                throw new Error("When called with an action of type " + (actionType ? "\"" + String(actionType) + "\"" : '(unknown type)') + ", the slice reducer for key \"" + _key + "\" returned undefined. " + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.");
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function bindActionCreators(actionCreators, dispatch) {
    if (typeof actionCreators === 'function') return bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== 'object' || actionCreators === null) throw new Error("bindActionCreators expected an object or a function, but instead received: '" + kindOf(actionCreators) + "'. " + "Did you write \"import ActionCreators from\" instead of \"import * as ActionCreators from\"?");
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function compose() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function applyMiddleware() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error("Dispatching while constructing your middleware is not allowed. Other middleware would not be applied to this dispatch.");
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = compose.apply(void 0, chain)(store.dispatch);
            return (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}

},{"@babel/runtime/helpers/esm/objectSpread2":"1qUc9","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1qUc9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _objectSpread2;
});
var _definePropertyJs = require("./defineProperty.js");
var _definePropertyJsDefault = parcelHelpers.interopDefault(_definePropertyJs);
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            (0, _definePropertyJsDefault.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

},{"./defineProperty.js":"hxCfo","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"hxCfo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _defineProperty;
});
var _toPropertyKeyJs = require("./toPropertyKey.js");
var _toPropertyKeyJsDefault = parcelHelpers.interopDefault(_toPropertyKeyJs);
function _defineProperty(e, r, t) {
    return (r = (0, _toPropertyKeyJsDefault.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

},{"./toPropertyKey.js":"f3cuC","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"f3cuC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return toPropertyKey;
});
var _typeofJs = require("./typeof.js");
var _typeofJsDefault = parcelHelpers.interopDefault(_typeofJs);
var _toPrimitiveJs = require("./toPrimitive.js");
var _toPrimitiveJsDefault = parcelHelpers.interopDefault(_toPrimitiveJs);
function toPropertyKey(t) {
    var i = (0, _toPrimitiveJsDefault.default)(t, "string");
    return "symbol" == (0, _typeofJsDefault.default)(i) ? i : i + "";
}

},{"./typeof.js":"iu2gT","./toPrimitive.js":"fUsV5","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"iu2gT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _typeof;
});
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5iBF5":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function get() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"fUsV5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return toPrimitive;
});
var _typeofJs = require("./typeof.js");
var _typeofJsDefault = parcelHelpers.interopDefault(_typeofJs);
function toPrimitive(t, r) {
    if ("object" != (0, _typeofJsDefault.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, _typeofJsDefault.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

},{"./typeof.js":"iu2gT","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5NEaL":[function(require,module,exports,__globalThis) {
'use strict';
var compose = require("b73e31d231234c76").compose;
exports.__esModule = true;
exports.composeWithDevTools = typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return undefined;
    if (typeof arguments[0] === 'object') return compose;
    return compose.apply(null, arguments);
};
exports.devToolsEnhancer = typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop) {
        return noop;
    };
};

},{"b73e31d231234c76":"lKoa8"}],"1USo0":[function(require,module,exports,__globalThis) {
"use strict";
var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __exportStar = this && this.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) __createBinding(exports1, m, p);
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
__exportStar(require("404b088b886a2995"), exports);
__exportStar(require("7a880fa16bb53f72"), exports);
__exportStar(require("c4cc45d486bc3f95"), exports);
__exportStar(require("9a65876083e547ce"), exports);
__exportStar(require("e0129c895a538c20"), exports);
__exportStar(require("7582ace27dd564d7"), exports);
__exportStar(require("192c2e0eaf984b6e"), exports);
__exportStar(require("72e4052cc67aa76"), exports);
__exportStar(require("d2a8d11195e97429"), exports);
__exportStar(require("26ce7cc9c32b03d2"), exports);
__exportStar(require("a8e4f155b49cf3f"), exports);
__exportStar(require("5b23ce6c3bdf4b9f"), exports);
__exportStar(require("59eea5533f612d0b"), exports);
__exportStar(require("c5fa510242d74cfa"), exports);
__exportStar(require("62e3f3997c48f2b0"), exports);
__exportStar(require("fa0a150899b4bbf4"), exports);
__exportStar(require("69bdd20f902ff090"), exports);
__exportStar(require("ae439f349b0872a6"), exports);

},{"404b088b886a2995":"jHIZU","7a880fa16bb53f72":"5ejPf","c4cc45d486bc3f95":"7TO5i","9a65876083e547ce":"lUB6u","e0129c895a538c20":"iXNqV","7582ace27dd564d7":"fLclU","192c2e0eaf984b6e":"fP6xK","72e4052cc67aa76":"d5Rms","d2a8d11195e97429":"buf01","26ce7cc9c32b03d2":"7edD1","a8e4f155b49cf3f":"ehcMf","5b23ce6c3bdf4b9f":"guq4I","59eea5533f612d0b":"dNBH4","c5fa510242d74cfa":"hcLIU","62e3f3997c48f2b0":"7cIy6","fa0a150899b4bbf4":"7a5Xv","69bdd20f902ff090":"j4V6v","ae439f349b0872a6":"g4MAO"}],"jHIZU":[function(require,module,exports,__globalThis) {
var _defineProperty = require("@swc/helpers/_/_define_property");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.REVIEW_TAGS_LABELS = exports.ReviewTag = exports.CancellationReason = exports.DogSize = exports.AccountState = exports.CountryCode = exports.Carrier = exports.Variant = exports.SKU = exports.Symptoms = exports.AnimalActivity = exports.ReviewType = exports.ProductType = exports.AnimalType = exports.Animal = exports.KittenReviewWeightTag = exports.KittenReviewAgeTag = exports.KittenReviewPickyTag = exports.CatReviewWeightTag = exports.CatReviewAgeTag = exports.CatReviewPickyTag = exports.PuppyReviewWeightTag = exports.PuppyReviewAgeTag = exports.PuppyReviewAllergicTag = exports.DogReviewWeightTag = exports.DogReviewAgeTag = exports.DogReviewAllergicTag = exports.ReviewRating = exports.ReviewCollection = exports.ReviewStatus = exports.getEnumKey = void 0;
var unwrap_1 = require("b12ad63db4dbd3ca");
function getEnumKey(myEnum, enumValue) {
    return (0, unwrap_1.unwrap)(Object.keys(myEnum).filter(function(x) {
        return myEnum[x] == enumValue;
    })[0]);
}
exports.getEnumKey = getEnumKey;
var ReviewStatus;
(function(ReviewStatus) {
    ReviewStatus["APPROVED"] = "approved";
    ReviewStatus["REJECTED"] = "rejected";
    ReviewStatus["PENDING"] = "pending";
})(ReviewStatus = exports.ReviewStatus || (exports.ReviewStatus = {}));
var ReviewCollection;
(function(ReviewCollection) {
    ReviewCollection["ALL"] = "all";
    ReviewCollection["CAT"] = "cat";
    ReviewCollection["DOG"] = "dog";
})(ReviewCollection = exports.ReviewCollection || (exports.ReviewCollection = {}));
var ReviewRating;
(function(ReviewRating) {
    ReviewRating[ReviewRating["ONE"] = 1] = "ONE";
    ReviewRating[ReviewRating["TWO"] = 2] = "TWO";
    ReviewRating[ReviewRating["THREE"] = 3] = "THREE";
    ReviewRating[ReviewRating["FOUR"] = 4] = "FOUR";
    ReviewRating[ReviewRating["FIVE"] = 5] = "FIVE";
})(ReviewRating = exports.ReviewRating || (exports.ReviewRating = {}));
var DogReviewAllergicTag;
(function(DogReviewAllergicTag) {
    DogReviewAllergicTag["TRUE"] = "true";
    DogReviewAllergicTag["FALSE"] = "false";
})(DogReviewAllergicTag = exports.DogReviewAllergicTag || (exports.DogReviewAllergicTag = {}));
var DogReviewAgeTag;
(function(DogReviewAgeTag) {
    DogReviewAgeTag["THREE_OR_LESS"] = "three_or_less";
    DogReviewAgeTag["THREE_TO_EIGHT"] = "three_to_eight";
    DogReviewAgeTag["EIGHT_OR_MORE"] = "eight_or_more";
})(DogReviewAgeTag = exports.DogReviewAgeTag || (exports.DogReviewAgeTag = {}));
var DogReviewWeightTag;
(function(DogReviewWeightTag) {
    DogReviewWeightTag["TEN_OR_LESS"] = "ten_or_less";
    DogReviewWeightTag["TEN_TO_TWENTY_FIVE"] = "ten_to_twenty_five";
    DogReviewWeightTag["TWENTY_FIVE_OR_MORE"] = "twenty_five_or_more";
})(DogReviewWeightTag = exports.DogReviewWeightTag || (exports.DogReviewWeightTag = {}));
var PuppyReviewAllergicTag;
(function(PuppyReviewAllergicTag) {
    PuppyReviewAllergicTag["TRUE"] = "true";
    PuppyReviewAllergicTag["FALSE"] = "false";
})(PuppyReviewAllergicTag = exports.PuppyReviewAllergicTag || (exports.PuppyReviewAllergicTag = {}));
var PuppyReviewAgeTag;
(function(PuppyReviewAgeTag) {
    PuppyReviewAgeTag["SIX_MONTHS_OR_LESS"] = "six_months_or_less";
    PuppyReviewAgeTag["SIX_MONTHS_TO_TWELVE"] = "six_months_to_twelve";
    PuppyReviewAgeTag["TWELVE_OR_MORE"] = "twelve_or_more";
})(PuppyReviewAgeTag = exports.PuppyReviewAgeTag || (exports.PuppyReviewAgeTag = {}));
var PuppyReviewWeightTag;
(function(PuppyReviewWeightTag) {
    PuppyReviewWeightTag["FIVE_OR_LESS"] = "five_or_less";
    PuppyReviewWeightTag["FIVE_TO_FIFTEEN"] = "five_to_fifteen";
    PuppyReviewWeightTag["FIFTEEN_OR_MORE"] = "fifteen_or_more";
})(PuppyReviewWeightTag = exports.PuppyReviewWeightTag || (exports.PuppyReviewWeightTag = {}));
var CatReviewPickyTag;
(function(CatReviewPickyTag) {
    CatReviewPickyTag["TRUE"] = "true";
    CatReviewPickyTag["FALSE"] = "false";
})(CatReviewPickyTag = exports.CatReviewPickyTag || (exports.CatReviewPickyTag = {}));
var CatReviewAgeTag;
(function(CatReviewAgeTag) {
    CatReviewAgeTag["THREE_OR_LESS"] = "three_or_less";
    CatReviewAgeTag["THREE_TO_EIGHT"] = "three_to_eight";
    CatReviewAgeTag["EIGHT_OR_MORE"] = "eight_or_more";
})(CatReviewAgeTag = exports.CatReviewAgeTag || (exports.CatReviewAgeTag = {}));
var CatReviewWeightTag;
(function(CatReviewWeightTag) {
    CatReviewWeightTag["THREE_OR_LESS"] = "three_or_less";
    CatReviewWeightTag["THREE_TO_SIX"] = "three_to_six";
    CatReviewWeightTag["SIX_OR_MORE"] = "six_or_more";
})(CatReviewWeightTag = exports.CatReviewWeightTag || (exports.CatReviewWeightTag = {}));
var KittenReviewPickyTag;
(function(KittenReviewPickyTag) {
    KittenReviewPickyTag["TRUE"] = "true";
    KittenReviewPickyTag["FALSE"] = "false";
})(KittenReviewPickyTag = exports.KittenReviewPickyTag || (exports.KittenReviewPickyTag = {}));
var KittenReviewAgeTag;
(function(KittenReviewAgeTag) {
    KittenReviewAgeTag["FOUR_MONTHS_OR_LESS"] = "four_months_or_less";
    KittenReviewAgeTag["FOUR_MONTHS_TO_EIGHT"] = "four_months_to_eight";
    KittenReviewAgeTag["EIGHT_OR_MORE"] = "eight_or_more";
})(KittenReviewAgeTag = exports.KittenReviewAgeTag || (exports.KittenReviewAgeTag = {}));
var KittenReviewWeightTag;
(function(KittenReviewWeightTag) {
    KittenReviewWeightTag["ONE_OR_LESS"] = "one_or_less";
    KittenReviewWeightTag["ONE_TO_THREE"] = "one_to_three";
    KittenReviewWeightTag["THREE_OR_MORE"] = "three_or_more";
})(KittenReviewWeightTag = exports.KittenReviewWeightTag || (exports.KittenReviewWeightTag = {}));
var Animal;
(function(Animal) {
    Animal["CAT"] = "cat";
    Animal["DOG"] = "dog";
})(Animal = exports.Animal || (exports.Animal = {}));
var AnimalType;
(function(AnimalType) {
    AnimalType["CAT"] = "cat";
    AnimalType["KITTEN"] = "kitten";
    AnimalType["DOG"] = "dog";
    AnimalType["PUPPY"] = "puppy";
})(AnimalType = exports.AnimalType || (exports.AnimalType = {}));
var ProductType;
(function(ProductType) {
    ProductType["OIL"] = "OIL";
    ProductType["CHIEN_STICK"] = "CHIEN-STICK";
    ProductType["CHIEN_BISCUITS"] = "CHIEN-BISCUITS";
    ProductType["CHIEN_LOWGRAIN_S"] = "CHIEN-LOWGRAIN-S";
    ProductType["CHIEN_LOWGRAIN_M"] = "CHIEN-LOWGRAIN-M";
    ProductType["CHIEN_LOWGRAIN_L"] = "CHIEN-LOWGRAIN-L";
    ProductType["CHIEN_GRAINFREE_S"] = "CHIEN-GRAINFREE-S";
    ProductType["CHIEN_GRAINFREE_M"] = "CHIEN-GRAINFREE-M";
    ProductType["CHIEN_GRAINFREE_L"] = "CHIEN-GRAINFREE-L";
    ProductType["CHIEN_HYPO_S"] = "CHIEN-HYPO-S";
    ProductType["CHIEN_HYPO_M"] = "CHIEN-HYPO-M";
    ProductType["CHIEN_HYPO_L"] = "CHIEN-HYPO-L";
    ProductType["CHIOT_LOWGRAIN_SM"] = "CHIOT-LOWGRAIN-SM";
    ProductType["CHIOT_LOWGRAIN_L"] = "CHIOT-LOWGRAIN-L";
    ProductType["CHIOT_GRAINFREE"] = "CHIOT-GRAINFREE";
    ProductType["CHIEN_LIGHT"] = "CHIEN-LIGHT";
    ProductType["CHIEN_SENIOR"] = "CHIEN-SENIOR";
})(ProductType = exports.ProductType || (exports.ProductType = {}));
var ReviewType;
(function(ReviewType) {
    ReviewType["DOG"] = "dog";
    ReviewType["CAT"] = "cat";
    ReviewType["PUPPY"] = "puppy";
    ReviewType["KITTEN"] = "kitten";
    ReviewType["OIL"] = "oil";
    ReviewType["STICK"] = "stick";
    ReviewType["BISCUITS"] = "biscuits";
})(ReviewType = exports.ReviewType || (exports.ReviewType = {}));
var AnimalActivity;
(function(AnimalActivity) {
    AnimalActivity["LOW"] = "low";
    AnimalActivity["MEDIUM"] = "medium";
    AnimalActivity["HIGH"] = "high";
})(AnimalActivity = exports.AnimalActivity || (exports.AnimalActivity = {}));
var Symptoms;
(function(Symptoms) {
    Symptoms["FLATULENCE"] = "flatulence";
    Symptoms["LOOSE_STOOLS"] = "loose_stools";
    Symptoms["DIARHEA"] = "diarhea";
    Symptoms["SCRATCHING"] = "scratching";
    Symptoms["OTITIS"] = "otitis";
    Symptoms["PAWS_INFLAMATION"] = "paws_inflamation";
})(Symptoms = exports.Symptoms || (exports.Symptoms = {}));
var SKU;
(function(SKU) {
    SKU["DCNS"] = "DCNS";
    SKU["DCNL"] = "DCNL";
    SKU["DCNT"] = "DCNT";
    SKU["DCNS2"] = "DCNS2";
    SKU["DCNL2"] = "DCNL2";
    SKU["DCNL3"] = "DCNL3";
    SKU["DCNS2_BIENETRE"] = "NPI_DCNS2_BIENETRE";
    SKU["DCNL2_BIENETRE"] = "NPI_DCNL2_BIENETRE";
    SKU["DCNS2_ALLERGIE"] = "NPI_DCNS2_ALLERGIE";
    SKU["DCNL2_ALLERGIE"] = "NPI_DCNL2_ALLERGIE";
    SKU["BUNDLE_5_DCNS"] = "NPI_BUNDLE_5_DCNS";
    SKU["BUNDLE_KIT_DECOUVERTE"] = "NPI_BUNDLE_KIT_DECOUVERTE";
    SKU["BUNDLE_KIT_DECOUVERTE_2"] = "NPI_BUNDLE_KIT_DECOUVERTE_2";
    SKU["PCNM"] = "PCNM";
    SKU["PCNL"] = "PCNL";
    SKU["CCNM"] = "CCNM";
    SKU["CCNL"] = "CCNL";
    SKU["CCNS2"] = "CCNS2";
    SKU["CCNL2"] = "CCNL2";
    SKU["CCNL3"] = "CCNL3";
    SKU["BUNDLE_3_CCNM"] = "NPI_BUNDLE_3_CCNM";
    SKU["BUNDLE_3_CCNS2"] = "NPI_BUNDLE_3_CCNS2";
    SKU["KCNM"] = "KCNM";
    SKU["KCNL"] = "KCNL";
    SKU["WELCOMEKIT"] = "WELCOMEKIT";
    SKU["WELCOME_CHIEN"] = "WELCOME_CHIEN";
    SKU["WELCOME_CHIOT"] = "WELCOME_CHIOT";
    SKU["WELCOME_CHAT"] = "WELCOME_CHAT";
    SKU["WELCOME_CHATON"] = "WELCOME_CHATON";
    SKU["FLY_BIE_CHI_2"] = "FLY-BIE-CHI-2";
    SKU["FLY_BIE_CHA_2"] = "FLY-BIE-CHA-2";
    SKU["FLY_CARTE_POSTALE"] = "FLY-CARTE-POSTALE";
    SKU["FLY_GUIDE_TEST_ALLERGIES"] = "FLY-GUIDE-TEST-ALLERGIES";
    SKU["FLY_BATONNETS_MEILLEURS_CLIENTS"] = "FLY-BATONNETS-MEILLEURS-CLIENTS";
    SKU["REFERRALKIT"] = "REFERRALKIT";
    SKU["NULL"] = "NULL";
    SKU["NPI_CHOIX_TRANSPORTEUR"] = "NPI-CHOIX-TRANSPORTEUR";
    SKU["HCS"] = "HCS";
    SKU["HCL"] = "HCL";
    SKU["HCXL"] = "HCXL";
    SKU["GOO_GOB"] = "GOO-GOB";
    SKU["GAZETTE_N_1"] = "GAZETTE_N_1";
    SKU["GAZETTE_N_2"] = "GAZETTE_N_2";
    SKU["CHIOT_LOWGRAIN_SM_3"] = "CHIOT-LOWGRAIN-SM-3";
    SKU["CHIOT_LOWGRAIN_SM_12"] = "CHIOT-LOWGRAIN-SM-12";
    SKU["CHIOT_LOWGRAIN_L_3"] = "CHIOT-LOWGRAIN-L-3";
    SKU["CHIOT_LOWGRAIN_L_12"] = "CHIOT-LOWGRAIN-L-12";
    SKU["CHIOT_GRAINFREE_3"] = "CHIOT-GRAINFREE-3";
    SKU["CHIOT_GRAINFREE_12"] = "CHIOT-GRAINFREE-12";
    SKU["CHIEN_LOWGRAIN_S_2"] = "CHIEN-LOWGRAIN-S-2";
    SKU["CHIEN_LOWGRAIN_S_6"] = "CHIEN-LOWGRAIN-S-6";
    SKU["CHIEN_LOWGRAIN_M_3"] = "CHIEN-LOWGRAIN-M-3";
    SKU["CHIEN_LOWGRAIN_M_12"] = "CHIEN-LOWGRAIN-M-12";
    SKU["CHIEN_LOWGRAIN_L_3"] = "CHIEN-LOWGRAIN-L-3";
    SKU["CHIEN_LOWGRAIN_L_12"] = "CHIEN-LOWGRAIN-L-12";
    SKU["CHIEN_GRAINFREE_S_2"] = "CHIEN-GRAINFREE-S-2";
    SKU["CHIEN_GRAINFREE_S_6"] = "CHIEN-GRAINFREE-S-6";
    SKU["CHIEN_GRAINFREE_M_3"] = "CHIEN-GRAINFREE-M-3";
    SKU["CHIEN_GRAINFREE_M_12"] = "CHIEN-GRAINFREE-M-12";
    SKU["CHIEN_GRAINFREE_L_3"] = "CHIEN-GRAINFREE-L-3";
    SKU["CHIEN_GRAINFREE_L_12"] = "CHIEN-GRAINFREE-L-12";
    SKU["CHIEN_HYPO_S_2"] = "CHIEN-HYPO-S-2";
    SKU["CHIEN_HYPO_S_6"] = "CHIEN-HYPO-S-6";
    SKU["CHIEN_HYPO_M_3"] = "CHIEN-HYPO-M-3";
    SKU["CHIEN_HYPO_M_12"] = "CHIEN-HYPO-M-12";
    SKU["CHIEN_HYPO_L_3"] = "CHIEN-HYPO-L-3";
    SKU["CHIEN_HYPO_L_12"] = "CHIEN-HYPO-L-12";
    SKU["CHIEN_LIGHT_3"] = "CHIEN-LIGHT-3";
    SKU["CHIEN_LIGHT_12"] = "CHIEN-LIGHT-12";
    SKU["CHIEN_SENIOR_3"] = "CHIEN-SENIOR-3";
    SKU["CHIEN_SENIOR_12"] = "CHIEN-SENIOR-12";
    SKU["CHIEN_STICK_SM"] = "CHIEN-STICK-SM";
    SKU["CHIEN_STICK_L"] = "CHIEN-STICK-L";
    SKU["CHIEN_BISCUITS"] = "CHIEN-BISCUITS";
})(SKU = exports.SKU || (exports.SKU = {}));
var Variant;
(function(Variant) {
    Variant["DCNS"] = "32123851866247";
    Variant["DCNL"] = "32123851899015";
    Variant["DCNS2"] = "44290901213436";
    Variant["DCNL2"] = "44290901246204";
    Variant["BUNDLE_5_DCNS"] = "44282400997628";
    Variant["BUNDLE_KIT_DECOUVERTE"] = "46767301591385";
    Variant["PCNM"] = "42993881186556";
    Variant["PCNL"] = "42993881219324";
    Variant["CCNM"] = "41297039392925";
    Variant["CCNL"] = "41297039425693";
    Variant["BUNDLE_3_CCNM"] = "44223898681596";
    Variant["CCNS2"] = "46498944614745";
    Variant["CCNL2"] = "46498944647513";
    Variant["BUNDLE_3_CCNS2"] = "46720179044697";
    Variant["KCNM"] = "42993898062076";
    Variant["KCNL"] = "42993898094844";
    Variant["WELCOME_CHIEN"] = "43778256961788";
    Variant["WELCOME_CHIOT"] = "43778256994556";
    Variant["WELCOME_CHAT"] = "43778257027324";
    Variant["WELCOME_CHATON"] = "43778257060092";
    Variant["FLY_HC"] = "46686168809817";
    Variant["FLY_BIE_CHI_2"] = "46686168056153";
    Variant["FLY_BIE_CHA_2"] = "46696393048409";
    Variant["FLY_CARTE_POSTALE"] = "47259208253785";
    Variant["CARRIER_CHOICE"] = "42942401872124";
    Variant["HCS"] = "46510588789081";
    Variant["HCL"] = "46510588821849";
    Variant["GOO_GOB"] = "46686136402265";
    Variant["GAZETTE_N_1"] = "46762364010841";
    Variant["GAZETTE_N_2"] = "47080549319001";
})(Variant = exports.Variant || (exports.Variant = {}));
var Carrier;
(function(Carrier) {
    Carrier["DPD"] = "DPD";
    Carrier["GLS"] = "GLS";
    Carrier["MONDIAL_RELAY"] = "MONDIAL_RELAY";
    Carrier["COLISSIMO"] = "COLISSIMO";
    Carrier["CHRONOPOST"] = "CHRONOPOST";
    Carrier["KUEHNE"] = "KUEHNE";
})(Carrier = exports.Carrier || (exports.Carrier = {}));
var CountryCode;
(function(CountryCode) {
    CountryCode["FR"] = "FR";
    CountryCode["BE"] = "BE";
    CountryCode["LU"] = "LU";
    CountryCode["MC"] = "MC";
})(CountryCode = exports.CountryCode || (exports.CountryCode = {}));
var AccountState;
(function(AccountState) {
    AccountState[AccountState["HasAccount"] = 0] = "HasAccount";
    AccountState[AccountState["RequireActivation"] = 1] = "RequireActivation";
    AccountState[AccountState["HasNoAccount"] = 2] = "HasNoAccount";
})(AccountState = exports.AccountState || (exports.AccountState = {}));
var DogSize;
(function(DogSize) {
    DogSize["Small"] = "petit";
    DogSize["Medium"] = "moyen";
    DogSize["Large"] = "grand";
})(DogSize = exports.DogSize || (exports.DogSize = {}));
var CancellationReason;
(function(CancellationReason) {
    CancellationReason["TROP_CHER"] = "trop_cher";
    CancellationReason["ABONNE_PAR_ERREUR"] = "abonne_par_erreur";
    CancellationReason["PROBLEME_LIVRAISON"] = "probleme_livraison";
    CancellationReason["ANIMAL_NAIME_PAS"] = "animal_naime_pas";
    CancellationReason["PROBLEME_DIGESTION"] = "probleme_digestion";
    CancellationReason["TROP_DE_STOCK"] = "trop_de_stock";
    CancellationReason["RECOMMANDATION_VETERINAIRE"] = "recommandation_veterinaire";
    CancellationReason["PROBLEME_PRODUIT"] = "probleme_produit";
    CancellationReason["PREFERE_SANS_ABONNEMENT"] = "prefere_sans_abonnement";
    CancellationReason["DECES_ANIMAL"] = "deces_animal";
    CancellationReason["NARRIVE_PAS_A_MODIFIER_ABONNEMENT"] = "narrive_pas_a_modifier_abonnement";
})(CancellationReason = exports.CancellationReason || (exports.CancellationReason = {}));
var ReviewTag;
(function(ReviewTag) {
    ReviewTag["POILS"] = "poils";
    ReviewTag["PEAU"] = "peau";
    ReviewTag["ALLERGIES"] = "allergies";
    ReviewTag["DEMANGEAISONS"] = "demangeaisons";
    ReviewTag["VETERINAIRE"] = "veterinaire";
    ReviewTag["DIGESTION"] = "digestion";
    ReviewTag["GOUT"] = "gout";
    ReviewTag["ENERGIE"] = "energie";
    ReviewTag["LIVRAISON"] = "livraison";
    ReviewTag["ETHIQUE"] = "ethique";
    ReviewTag["VEGETARIEN"] = "vegetarien";
})(ReviewTag = exports.ReviewTag || (exports.ReviewTag = {}));
var _obj;
exports.REVIEW_TAGS_LABELS = (_obj = {}, (0, _defineProperty._)(_obj, ReviewTag.POILS, 'Poils'), (0, _defineProperty._)(_obj, ReviewTag.PEAU, 'Peau'), (0, _defineProperty._)(_obj, ReviewTag.ALLERGIES, 'Allergies'), (0, _defineProperty._)(_obj, ReviewTag.DEMANGEAISONS, "D\xe9mangeaisons"), (0, _defineProperty._)(_obj, ReviewTag.VETERINAIRE, "V\xe9t\xe9rinaire"), (0, _defineProperty._)(_obj, ReviewTag.DIGESTION, 'Digestion'), (0, _defineProperty._)(_obj, ReviewTag.GOUT, "Go\xfbt"), (0, _defineProperty._)(_obj, ReviewTag.ENERGIE, "\xc9nergie"), (0, _defineProperty._)(_obj, ReviewTag.LIVRAISON, 'Livraison'), (0, _defineProperty._)(_obj, ReviewTag.ETHIQUE, "\xc9thique"), (0, _defineProperty._)(_obj, ReviewTag.VEGETARIEN, "V\xe9g\xe9tarien"), _obj);

},{"@swc/helpers/_/_define_property":"54Zvk","b12ad63db4dbd3ca":"iXNqV"}],"54Zvk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _define_property;
});
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"iXNqV":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isSome = exports.unwrap = void 0;
function unwrap(value) {
    if (isSome(value)) return value;
    throw new Error('Value must be non null, non undefined value');
}
exports.unwrap = unwrap;
function isSome(value) {
    return value !== null && value !== undefined;
}
exports.isSome = isSome;

},{}],"5ejPf":[function(require,module,exports,__globalThis) {
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.wrapGetState = void 0;
function wrapGetState(getState) {
    return function(selector) {
        for(var _len = arguments.length, parameters = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            parameters[_key - 1] = arguments[_key];
        }
        return selector.apply(void 0, [
            getState()
        ].concat((0, _toConsumableArray._)(parameters)));
    };
}
exports.wrapGetState = wrapGetState;

},{"@swc/helpers/_/_to_consumable_array":"eqNDD"}],"eqNDD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _to_consumable_array;
});
var _arrayWithoutHolesJs = require("./_array_without_holes.js");
var _iterableToArrayJs = require("./_iterable_to_array.js");
var _nonIterableSpreadJs = require("./_non_iterable_spread.js");
var _unsupportedIterableToArrayJs = require("./_unsupported_iterable_to_array.js");
function _to_consumable_array(arr) {
    return (0, _arrayWithoutHolesJs._)(arr) || (0, _iterableToArrayJs._)(arr) || (0, _unsupportedIterableToArrayJs._)(arr) || (0, _nonIterableSpreadJs._)();
}

},{"./_array_without_holes.js":"hFNcn","./_iterable_to_array.js":"aWBXo","./_non_iterable_spread.js":"ckZC7","./_unsupported_iterable_to_array.js":"fAMhu","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"hFNcn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _array_without_holes;
});
var _arrayLikeToArrayJs = require("./_array_like_to_array.js");
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return (0, _arrayLikeToArrayJs._)(arr);
}

},{"./_array_like_to_array.js":"enG3Y","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"enG3Y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _array_like_to_array;
});
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"aWBXo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _iterable_to_array;
});
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"ckZC7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _non_iterable_spread;
});
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"fAMhu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _unsupported_iterable_to_array;
});
var _arrayLikeToArrayJs = require("./_array_like_to_array.js");
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, _arrayLikeToArrayJs._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, _arrayLikeToArrayJs._)(o, minLen);
}

},{"./_array_like_to_array.js":"enG3Y","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7TO5i":[function(require,module,exports,__globalThis) {
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.debounce = exports.waitAtLeast = exports.doNotWaitFor = exports.wait = void 0;
var throttle_debounce_1 = require("3af8ee4dd82a1962");
function wait(milliseconds) {
    return _wait.apply(this, arguments);
}
function _wait() {
    _wait = (0, _asyncToGenerator._)(function(milliseconds) {
        return (0, _tsGenerator._)(this, function(_state) {
            return [
                2,
                new Promise(function(resolve) {
                    return setTimeout(resolve, milliseconds);
                })
            ];
        });
    });
    return _wait.apply(this, arguments);
}
exports.wait = wait;
function doNotWaitFor(promise) {
    return _doNotWaitFor.apply(this, arguments);
}
function _doNotWaitFor() {
    _doNotWaitFor = (0, _asyncToGenerator._)(function(promise) {
        return (0, _tsGenerator._)(this, function(_state) {
            return [
                2
            ];
        });
    });
    return _doNotWaitFor.apply(this, arguments);
}
exports.doNotWaitFor = doNotWaitFor;
function waitAtLeast(promise, milliseconds) {
    return _waitAtLeast.apply(this, arguments);
}
function _waitAtLeast() {
    _waitAtLeast = (0, _asyncToGenerator._)(function(promise, milliseconds) {
        var results;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        Promise.all([
                            promise,
                            wait(milliseconds)
                        ])
                    ];
                case 1:
                    results = _state.sent();
                    return [
                        2,
                        results[0]
                    ];
            }
        });
    });
    return _waitAtLeast.apply(this, arguments);
}
exports.waitAtLeast = waitAtLeast;
function debounce(callback) {
    var throttlers = {};
    return function(element, key, delay) {
        if (throttlers[key]) throttlers[key].cancel();
        throttlers[key] = (0, throttle_debounce_1.debounce)(delay, function(lastElement) {
            return callback(lastElement);
        });
        throttlers[key](element);
    };
}
exports.debounce = debounce;

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_ts_generator":"f2hGH","3af8ee4dd82a1962":"a6OjO"}],"j0yZk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _async_to_generator;
});
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"f2hGH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return 0, _tslib.__generator;
});
var _tslib = require("tslib");

},{"tslib":"C7UIb","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"C7UIb":[function(require,module,exports,__globalThis) {
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", function() {
    return __extends;
});
parcelHelpers.export(exports, "__assign", function() {
    return __assign;
});
parcelHelpers.export(exports, "__rest", function() {
    return __rest;
});
parcelHelpers.export(exports, "__decorate", function() {
    return __decorate;
});
parcelHelpers.export(exports, "__param", function() {
    return __param;
});
parcelHelpers.export(exports, "__esDecorate", function() {
    return __esDecorate;
});
parcelHelpers.export(exports, "__runInitializers", function() {
    return __runInitializers;
});
parcelHelpers.export(exports, "__propKey", function() {
    return __propKey;
});
parcelHelpers.export(exports, "__setFunctionName", function() {
    return __setFunctionName;
});
parcelHelpers.export(exports, "__metadata", function() {
    return __metadata;
});
parcelHelpers.export(exports, "__awaiter", function() {
    return __awaiter;
});
parcelHelpers.export(exports, "__generator", function() {
    return __generator;
});
parcelHelpers.export(exports, "__createBinding", function() {
    return __createBinding;
});
parcelHelpers.export(exports, "__exportStar", function() {
    return __exportStar;
});
parcelHelpers.export(exports, "__values", function() {
    return __values;
});
parcelHelpers.export(exports, "__read", function() {
    return __read;
});
/** @deprecated */ parcelHelpers.export(exports, "__spread", function() {
    return __spread;
});
/** @deprecated */ parcelHelpers.export(exports, "__spreadArrays", function() {
    return __spreadArrays;
});
parcelHelpers.export(exports, "__spreadArray", function() {
    return __spreadArray;
});
parcelHelpers.export(exports, "__await", function() {
    return __await;
});
parcelHelpers.export(exports, "__asyncGenerator", function() {
    return __asyncGenerator;
});
parcelHelpers.export(exports, "__asyncDelegator", function() {
    return __asyncDelegator;
});
parcelHelpers.export(exports, "__asyncValues", function() {
    return __asyncValues;
});
parcelHelpers.export(exports, "__makeTemplateObject", function() {
    return __makeTemplateObject;
});
parcelHelpers.export(exports, "__importStar", function() {
    return __importStar;
});
parcelHelpers.export(exports, "__importDefault", function() {
    return __importDefault;
});
parcelHelpers.export(exports, "__classPrivateFieldGet", function() {
    return __classPrivateFieldGet;
});
parcelHelpers.export(exports, "__classPrivateFieldSet", function() {
    return __classPrivateFieldSet;
});
parcelHelpers.export(exports, "__classPrivateFieldIn", function() {
    return __classPrivateFieldIn;
});
parcelHelpers.export(exports, "__addDisposableResource", function() {
    return __addDisposableResource;
});
parcelHelpers.export(exports, "__disposeResources", function() {
    return __disposeResources;
});
parcelHelpers.export(exports, "__rewriteRelativeImportExtension", function() {
    return __rewriteRelativeImportExtension;
});
var extendStatics = function extendStatics1(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function __assign1() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function __runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function __propKey(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function __setFunctionName(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var __createBinding = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function __exportStar(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var __setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var ownKeys = function ownKeys1(o) {
    ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return ownKeys(o);
};
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") __createBinding(result, mod, k[i]);
    }
    __setModuleDefault(result, mod);
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function __addDisposableResource(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function dispose() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function __disposeResources(env) {
    function fail(e) {
        env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function __rewriteRelativeImportExtension(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
exports.default = {
    __extends: __extends,
    __assign: __assign,
    __rest: __rest,
    __decorate: __decorate,
    __param: __param,
    __esDecorate: __esDecorate,
    __runInitializers: __runInitializers,
    __propKey: __propKey,
    __setFunctionName: __setFunctionName,
    __metadata: __metadata,
    __awaiter: __awaiter,
    __generator: __generator,
    __createBinding: __createBinding,
    __exportStar: __exportStar,
    __values: __values,
    __read: __read,
    __spread: __spread,
    __spreadArrays: __spreadArrays,
    __spreadArray: __spreadArray,
    __await: __await,
    __asyncGenerator: __asyncGenerator,
    __asyncDelegator: __asyncDelegator,
    __asyncValues: __asyncValues,
    __makeTemplateObject: __makeTemplateObject,
    __importStar: __importStar,
    __importDefault: __importDefault,
    __classPrivateFieldGet: __classPrivateFieldGet,
    __classPrivateFieldSet: __classPrivateFieldSet,
    __classPrivateFieldIn: __classPrivateFieldIn,
    __addDisposableResource: __addDisposableResource,
    __disposeResources: __disposeResources,
    __rewriteRelativeImportExtension: __rewriteRelativeImportExtension
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"a6OjO":[function(require,module,exports,__globalThis) {
/* eslint-disable no-undefined,no-param-reassign,no-shadow */ /**
 * Throttle execution of a function. Especially useful for rate limiting
 * execution of handlers on events like resize and scroll.
 *
 * @param {number} delay -                  A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher)
 *                                            are most useful.
 * @param {Function} callback -               A function to be executed after delay milliseconds. The `this` context and all arguments are passed through,
 *                                            as-is, to `callback` when the throttled-function is executed.
 * @param {object} [options] -              An object to configure options.
 * @param {boolean} [options.noTrailing] -   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds
 *                                            while the throttled-function is being called. If noTrailing is false or unspecified, callback will be executed
 *                                            one final time after the last throttled-function call. (After the throttled-function has not been called for
 *                                            `delay` milliseconds, the internal counter is reset).
 * @param {boolean} [options.noLeading] -   Optional, defaults to false. If noLeading is false, the first throttled-function call will execute callback
 *                                            immediately. If noLeading is true, the first the callback execution will be skipped. It should be noted that
 *                                            callback will never executed if both noLeading = true and noTrailing = true.
 * @param {boolean} [options.debounceMode] - If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is
 *                                            false (at end), schedule `callback` to execute after `delay` ms.
 *
 * @returns {Function} A new, throttled, function.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "debounce", function() {
    return debounce;
});
parcelHelpers.export(exports, "throttle", function() {
    return throttle;
});
function throttle(delay, callback, options) {
    var _ref = options || {}, _ref$noTrailing = _ref.noTrailing, noTrailing = _ref$noTrailing === void 0 ? false : _ref$noTrailing, _ref$noLeading = _ref.noLeading, noLeading = _ref$noLeading === void 0 ? false : _ref$noLeading, _ref$debounceMode = _ref.debounceMode, debounceMode = _ref$debounceMode === void 0 ? undefined : _ref$debounceMode;
    /*
   * After wrapper has stopped being called, this timeout ensures that
   * `callback` is executed at the proper times in `throttle` and `end`
   * debounce modes.
   */ var timeoutID;
    var cancelled = false; // Keep track of the last time `callback` was executed.
    var lastExec = 0; // Function to clear existing timeout
    function clearExistingTimeout() {
        if (timeoutID) clearTimeout(timeoutID);
    } // Function to cancel next exec
    function cancel() {
        clearExistingTimeout();
        cancelled = true;
    }
    /*
   * The `wrapper` function encapsulates all of the throttling / debouncing
   * functionality and when executed will limit the rate at which `callback`
   * is executed.
   */ function wrapper() {
        for(var _len = arguments.length, arguments_ = new Array(_len), _key = 0; _key < _len; _key++)arguments_[_key] = arguments[_key];
        var self = this;
        var elapsed = Date.now() - lastExec;
        if (cancelled) return;
         // Execute `callback` and update the `lastExec` timestamp.
        function exec() {
            lastExec = Date.now();
            callback.apply(self, arguments_);
        }
        /*
     * If `debounceMode` is true (at begin) this is used to clear the flag
     * to allow future `callback` executions.
     */ function clear() {
            timeoutID = undefined;
        }
        if (!noLeading && debounceMode && !timeoutID) /*
       * Since `wrapper` is being called for the first time and
       * `debounceMode` is true (at begin), execute `callback`
       * and noLeading != true.
       */ exec();
        clearExistingTimeout();
        if (debounceMode === undefined && elapsed > delay) {
            if (noLeading) {
                /*
         * In throttle mode with noLeading, if `delay` time has
         * been exceeded, update `lastExec` and schedule `callback`
         * to execute after `delay` ms.
         */ lastExec = Date.now();
                if (!noTrailing) timeoutID = setTimeout(debounceMode ? clear : exec, delay);
            } else /*
         * In throttle mode without noLeading, if `delay` time has been exceeded, execute
         * `callback`.
         */ exec();
        } else if (noTrailing !== true) /*
       * In trailing throttle mode, since `delay` time has not been
       * exceeded, schedule `callback` to execute `delay` ms after most
       * recent execution.
       *
       * If `debounceMode` is true (at begin), schedule `clear` to execute
       * after `delay` ms.
       *
       * If `debounceMode` is false (at end), schedule `callback` to
       * execute after `delay` ms.
       */ timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
    }
    wrapper.cancel = cancel; // Return the wrapper function.
    return wrapper;
}
/* eslint-disable no-undefined */ /**
 * Debounce execution of a function. Debouncing, unlike throttling,
 * guarantees that a function is only executed a single time, either at the
 * very beginning of a series of calls, or at the very end.
 *
 * @param {number} delay -         A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param {boolean} [atBegin] -     Optional, defaults to false. If atBegin is false or unspecified, callback will only be executed `delay` milliseconds
 *                                  after the last debounced-function call. If atBegin is true, callback will be executed only at the first debounced-function call.
 *                                  (After the throttled-function has not been called for `delay` milliseconds, the internal counter is reset).
 * @param {Function} callback -      A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                  to `callback` when the debounced-function is executed.
 *
 * @returns {Function} A new, debounced function.
 */ function debounce(delay, atBegin, callback) {
    return callback === undefined ? throttle(delay, atBegin, {
        debounceMode: false
    }) : throttle(delay, callback, {
        debounceMode: atBegin !== false
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"lUB6u":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.abstractUseDispatchCallback = void 0;
function abstractUseDispatchCallback(useDispatch) {
    return function() {
        var dispatch = useDispatch();
        return function(event) {
            if (event) return function() {
                dispatch(event);
            };
            return function() {
                return undefined;
            };
        };
    };
}
exports.abstractUseDispatchCallback = abstractUseDispatchCallback;

},{}],"fLclU":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.eventFactory = void 0;
function eventFactory(type) {
    return function() {
        return function() {
            for(var _len = arguments.length, payload = new Array(_len), _key = 0; _key < _len; _key++){
                payload[_key] = arguments[_key];
            }
            return {
                type: type,
                payload: payload[0]
            };
        };
    };
}
exports.eventFactory = eventFactory;

},{}],"fP6xK":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.assertNever = void 0;
/**
 * Raise a compile error when accessing this function.
 * This is useful for exhaustive switch check.
 */ function assertNever(subject) {
    var error = new TypeError(subject);
    // @ts-ignore framesToPop is not defined
    error.framesToPop = 1; // Ignore call to assertNever() in stacktrace
    throw error;
}
exports.assertNever = assertNever;

},{}],"d5Rms":[function(require,module,exports,__globalThis) {
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.insertAt = exports.filterNullValues = exports.extractSingleElementOfArray = exports.validateArraySize = exports.reduceWithoutDuplicates = exports.uniq = exports.waitForAll = exports.reduceAsync = exports.forEachAsync = exports.mapAsyncSequential = exports.filterAsync = exports.mapAsync = void 0;
var unwrap_1 = require("d9ecb409931dc584");
function mapAsync(array, callback) {
    return Promise.all(array.map(callback));
}
exports.mapAsync = mapAsync;
function filterAsync(array, callback) {
    return _filterAsync.apply(this, arguments);
}
function _filterAsync() {
    _filterAsync = (0, _asyncToGenerator._)(function(array, callback) {
        var fail, testedArray;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    fail = Symbol();
                    return [
                        4,
                        mapAsync(array, /*#__PURE__*/ function() {
                            var _ref = (0, _asyncToGenerator._)(function(element) {
                                return (0, _tsGenerator._)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                callback(element)
                                            ];
                                        case 1:
                                            if (_state.sent()) return [
                                                2,
                                                element
                                            ];
                                            return [
                                                2,
                                                fail
                                            ];
                                    }
                                });
                            });
                            return function(element) {
                                return _ref.apply(this, arguments);
                            };
                        }())
                    ];
                case 1:
                    testedArray = _state.sent();
                    return [
                        2,
                        testedArray.filter(function(element) {
                            return element !== fail;
                        })
                    ];
            }
        });
    });
    return _filterAsync.apply(this, arguments);
}
exports.filterAsync = filterAsync;
function mapAsyncSequential(array, callback) {
    return _mapAsyncSequential.apply(this, arguments);
}
function _mapAsyncSequential() {
    _mapAsyncSequential = (0, _asyncToGenerator._)(function(array, callback) {
        var result, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, element, _, err;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    result = [];
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        8
                    ]);
                    _iterator = array[Symbol.iterator]();
                    _state.label = 2;
                case 2:
                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                        3,
                        5
                    ];
                    element = _step.value;
                    _ = result.push;
                    return [
                        4,
                        callback(element)
                    ];
                case 3:
                    _.apply(result, [
                        _state.sent()
                    ]);
                    _state.label = 4;
                case 4:
                    _iteratorNormalCompletion = true;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        8
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        8
                    ];
                case 7:
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                    return [
                        7
                    ];
                case 8:
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return _mapAsyncSequential.apply(this, arguments);
}
exports.mapAsyncSequential = mapAsyncSequential;
function forEachAsync(array, callback) {
    return _forEachAsync.apply(this, arguments);
}
function _forEachAsync() {
    _forEachAsync = (0, _asyncToGenerator._)(function(array, callback) {
        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, element, err;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        8
                    ]);
                    _iterator = array[Symbol.iterator]();
                    _state.label = 2;
                case 2:
                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                        3,
                        5
                    ];
                    element = _step.value;
                    return [
                        4,
                        callback(element)
                    ];
                case 3:
                    _state.sent();
                    _state.label = 4;
                case 4:
                    _iteratorNormalCompletion = true;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        8
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        8
                    ];
                case 7:
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                    return [
                        7
                    ];
                case 8:
                    return [
                        2
                    ];
            }
        });
    });
    return _forEachAsync.apply(this, arguments);
}
exports.forEachAsync = forEachAsync;
function reduceAsync(array, callback, emptyAccumulator) {
    return _reduceAsync.apply(this, arguments);
}
function _reduceAsync() {
    _reduceAsync = (0, _asyncToGenerator._)(function(array, callback, emptyAccumulator) {
        var accumulator, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, element, err;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    accumulator = emptyAccumulator;
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        8
                    ]);
                    _iterator = array[Symbol.iterator]();
                    _state.label = 2;
                case 2:
                    if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                        3,
                        5
                    ];
                    element = _step.value;
                    return [
                        4,
                        callback(accumulator, element)
                    ];
                case 3:
                    accumulator = _state.sent();
                    _state.label = 4;
                case 4:
                    _iteratorNormalCompletion = true;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        8
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        8
                    ];
                case 7:
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                    return [
                        7
                    ];
                case 8:
                    return [
                        2,
                        accumulator
                    ];
            }
        });
    });
    return _reduceAsync.apply(this, arguments);
}
exports.reduceAsync = reduceAsync;
function waitForAll(promises) {
    return _waitForAll.apply(this, arguments);
}
function _waitForAll() {
    _waitForAll = (0, _asyncToGenerator._)(function(promises) {
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        Promise.all(promises)
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return _waitForAll.apply(this, arguments);
}
exports.waitForAll = waitForAll;
function uniq(array) {
    return (0, _toConsumableArray._)(new Set(array));
}
exports.uniq = uniq;
function reduceWithoutDuplicates(elements, nextElement) {
    var hasItemAlready = elements.find(function(element) {
        return element === nextElement;
    });
    if (hasItemAlready) return elements;
    return (0, _toConsumableArray._)(elements).concat([
        nextElement
    ]);
}
exports.reduceWithoutDuplicates = reduceWithoutDuplicates;
function validateArraySize(size) {
    return function(array) {
        if (array.length !== size) throw new Error(`List size should be ${size}, actual size: ${array.length})`);
        return array;
    };
}
exports.validateArraySize = validateArraySize;
function extractSingleElementOfArray(array) {
    validateArraySize(1)(array);
    return array[0];
}
exports.extractSingleElementOfArray = extractSingleElementOfArray;
function filterNullValues(array) {
    return array.filter(unwrap_1.isSome);
}
exports.filterNullValues = filterNullValues;
function insertAt(array, index) {
    for(var _len = arguments.length, newItems = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        newItems[_key - 2] = arguments[_key];
    }
    return (0, _toConsumableArray._)(array.slice(0, index)).concat((0, _toConsumableArray._)(newItems), (0, _toConsumableArray._)(array.slice(index)));
}
exports.insertAt = insertAt;

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_to_consumable_array":"eqNDD","@swc/helpers/_/_ts_generator":"f2hGH","d9ecb409931dc584":"iXNqV"}],"buf01":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.chain = void 0;
function chain(value) {
    return {
        value: value,
        then: function(f) {
            var result = f(this.value);
            if (result instanceof Promise) return {
                value: result,
                then: function(g) {
                    var nextResult = result.then(g);
                    return chain(nextResult);
                },
                unwrap: function() {
                    return this.value;
                }
            };
            return chain(result);
        },
        unwrap: function() {
            return this.value;
        }
    };
}
exports.chain = chain;

},{}],"7edD1":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.addLeadingZeros = void 0;
function addLeadingZeros(number, length) {
    var result = number.toString();
    while(result.length < length)result = '0' + result;
    return result;
}
exports.addLeadingZeros = addLeadingZeros;

},{}],"ehcMf":[function(require,module,exports,__globalThis) {
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.importImplicitDefault = void 0;
function importImplicitDefault(promise) {
    return _importImplicitDefault.apply(this, arguments);
}
function _importImplicitDefault() {
    _importImplicitDefault = (0, _asyncToGenerator._)(function(promise) {
        var module;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        promise
                    ];
                case 1:
                    module = _state.sent();
                    return [
                        2,
                        module
                    ];
            }
        });
    });
    return _importImplicitDefault.apply(this, arguments);
}
exports.importImplicitDefault = importImplicitDefault;

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_ts_generator":"f2hGH"}],"guq4I":[function(require,module,exports,__globalThis) {
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.prepareEventBus = void 0;
function prepareEventBus() {
    var eventBus = {
        publishEvent: publishEvent,
        subscribeTo: subscribeTo,
        unsubscribeTo: unsubscribeTo,
        subscribeToAll: subscribeToAll,
        unsubscribeToAll: unsubscribeToAll,
        onError: onError,
        onResult: onResult
    };
    var eventBusMiddleware = function() {
        return function(next) {
            return function(action) {
                var result = next(action);
                publishEvent(action);
                return result;
            };
        };
    };
    var subscribeToHandlers = {};
    var subscribeToAllHandlers = [];
    var onErrorHandlers = [];
    var onResultHandlers = [];
    function publishEvent(event) {
        getHandlers(event.type).map(triggerHandler(event));
        subscribeToAllHandlers.map(triggerHandler(event));
    }
    function triggerHandler(event) {
        return /*#__PURE__*/ function() {
            var _ref = (0, _asyncToGenerator._)(function(handler) {
                var result, error;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                handler(event)
                            ];
                        case 1:
                            result = _state.sent();
                            onResultHandlers.map(function(resultHandler) {
                                return resultHandler(result);
                            });
                            return [
                                3,
                                3
                            ];
                        case 2:
                            error = _state.sent();
                            onErrorHandlers.map(function(errorHandler) {
                                return errorHandler(error);
                            });
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(handler) {
                return _ref.apply(this, arguments);
            };
        }();
    }
    function getHandlers(key) {
        if (!subscribeToHandlers[key]) subscribeToHandlers[key] = [];
        return subscribeToHandlers[key];
    }
    function updateHandlers(key, update) {
        if (!subscribeToHandlers[key]) subscribeToHandlers[key] = [];
        return subscribeToHandlers[key] = update(subscribeToHandlers[key]);
    }
    function subscribeTo(key, handler) {
        updateHandlers(key, function(handlers) {
            return (0, _toConsumableArray._)(handlers).concat([
                handler
            ]);
        });
    }
    function unsubscribeTo(key, handler) {
        updateHandlers(key, function(handlers) {
            return handlers.filter(function(activeHandler) {
                return activeHandler !== handler;
            });
        });
    }
    function subscribeToAll(handler) {
        subscribeToAllHandlers.push(handler);
    }
    function unsubscribeToAll(handler) {
        subscribeToAllHandlers.filter(function(activeHandler) {
            return activeHandler !== handler;
        });
    }
    function onError(handler) {
        onErrorHandlers.push(handler);
    }
    function onResult(handler) {
        onResultHandlers.push(handler);
    }
    return {
        eventBus: eventBus,
        eventBusMiddleware: eventBusMiddleware
    };
}
exports.prepareEventBus = prepareEventBus;

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_to_consumable_array":"eqNDD","@swc/helpers/_/_ts_generator":"f2hGH"}],"dNBH4":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.uuid = void 0;
var uuid_1 = require("627f20eda704d3ab");
Object.defineProperty(exports, "uuid", {
    enumerable: true,
    get: function get() {
        return uuid_1.v4;
    }
});

},{"627f20eda704d3ab":"3icXD"}],"3icXD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "v1", function() {
    return 0, _v1JsDefault.default;
});
parcelHelpers.export(exports, "v3", function() {
    return 0, _v3JsDefault.default;
});
parcelHelpers.export(exports, "v4", function() {
    return 0, _v4JsDefault.default;
});
parcelHelpers.export(exports, "v5", function() {
    return 0, _v5JsDefault.default;
});
parcelHelpers.export(exports, "NIL", function() {
    return 0, _nilJsDefault.default;
});
parcelHelpers.export(exports, "version", function() {
    return 0, _versionJsDefault.default;
});
parcelHelpers.export(exports, "validate", function() {
    return 0, _validateJsDefault.default;
});
parcelHelpers.export(exports, "stringify", function() {
    return 0, _stringifyJsDefault.default;
});
parcelHelpers.export(exports, "parse", function() {
    return 0, _parseJsDefault.default;
});
var _v1Js = require("./v1.js");
var _v1JsDefault = parcelHelpers.interopDefault(_v1Js);
var _v3Js = require("./v3.js");
var _v3JsDefault = parcelHelpers.interopDefault(_v3Js);
var _v4Js = require("./v4.js");
var _v4JsDefault = parcelHelpers.interopDefault(_v4Js);
var _v5Js = require("./v5.js");
var _v5JsDefault = parcelHelpers.interopDefault(_v5Js);
var _nilJs = require("./nil.js");
var _nilJsDefault = parcelHelpers.interopDefault(_nilJs);
var _versionJs = require("./version.js");
var _versionJsDefault = parcelHelpers.interopDefault(_versionJs);
var _validateJs = require("./validate.js");
var _validateJsDefault = parcelHelpers.interopDefault(_validateJs);
var _stringifyJs = require("./stringify.js");
var _stringifyJsDefault = parcelHelpers.interopDefault(_stringifyJs);
var _parseJs = require("./parse.js");
var _parseJsDefault = parcelHelpers.interopDefault(_parseJs);

},{"./v1.js":"i5xZM","./v3.js":"aqKdQ","./v4.js":"7q6st","./v5.js":"8Q1Fl","./nil.js":"dK2jD","./version.js":"8Ppb4","./validate.js":"aAq2W","./stringify.js":"3OsGs","./parse.js":"l5KrY","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"i5xZM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rngJs = require("./rng.js");
var _rngJsDefault = parcelHelpers.interopDefault(_rngJs);
var _stringifyJs = require("./stringify.js"); // **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var _nodeId;
var _clockseq; // Previous uuid creation time
var _lastMSecs = 0;
var _lastNSecs = 0; // See https://github.com/uuidjs/uuid for API details
function v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || new Array(16);
    options = options || {};
    var node = options.node || _nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq; // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = options.random || (options.rng || (0, _rngJsDefault.default))();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = _nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    } // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : Date.now(); // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1; // Time since last uuid creation (in msecs)
    var dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000; // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
     // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) nsecs = 0;
     // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
    _lastMSecs = msecs;
    _lastNSecs = nsecs;
    _clockseq = clockseq; // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000; // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff; // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff; // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff; // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80; // `clock_seq_low`
    b[i++] = clockseq & 0xff; // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf || (0, _stringifyJs.unsafeStringify)(b);
}
exports.default = v1;

},{"./rng.js":"fP2kO","./stringify.js":"3OsGs","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"fP2kO":[function(require,module,exports,__globalThis) {
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return rng;
});
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
    return getRandomValues(rnds8);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3OsGs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unsafeStringify", function() {
    return unsafeStringify;
});
var _validateJs = require("./validate.js");
var _validateJsDefault = parcelHelpers.interopDefault(_validateJs);
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var byteToHex = [];
for(var i = 0; i < 256; ++i)byteToHex.push((i + 0x100).toString(16).slice(1));
function unsafeStringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]];
}
function stringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    var uuid = unsafeStringify(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, _validateJsDefault.default)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
exports.default = stringify;

},{"./validate.js":"aAq2W","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"aAq2W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _regexJs = require("./regex.js");
var _regexJsDefault = parcelHelpers.interopDefault(_regexJs);
function validate(uuid) {
    return typeof uuid === 'string' && (0, _regexJsDefault.default).test(uuid);
}
exports.default = validate;

},{"./regex.js":"cnjq7","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"cnjq7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"aqKdQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _v35Js = require("./v35.js");
var _v35JsDefault = parcelHelpers.interopDefault(_v35Js);
var _md5Js = require("./md5.js");
var _md5JsDefault = parcelHelpers.interopDefault(_md5Js);
var v3 = (0, _v35JsDefault.default)('v3', 0x30, (0, _md5JsDefault.default));
exports.default = v3;

},{"./v35.js":"jtYHK","./md5.js":"huzy4","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jtYHK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DNS", function() {
    return DNS;
});
parcelHelpers.export(exports, "URL", function() {
    return URL;
});
parcelHelpers.export(exports, "default", function() {
    return v35;
});
var _stringifyJs = require("./stringify.js");
var _parseJs = require("./parse.js");
var _parseJsDefault = parcelHelpers.interopDefault(_parseJs);
function stringToBytes(str) {
    str = unescape(encodeURIComponent(str)); // UTF8 escape
    var bytes = [];
    for(var i = 0; i < str.length; ++i)bytes.push(str.charCodeAt(i));
    return bytes;
}
var DNS = '6ba7b810-9dad-11d1-80b4-00c04fd430c8';
var URL = '6ba7b811-9dad-11d1-80b4-00c04fd430c8';
function v35(name, version, hashfunc) {
    function generateUUID(value, namespace, buf, offset) {
        var _namespace;
        if (typeof value === 'string') value = stringToBytes(value);
        if (typeof namespace === 'string') namespace = (0, _parseJsDefault.default)(namespace);
        if (((_namespace = namespace) === null || _namespace === void 0 ? void 0 : _namespace.length) !== 16) throw TypeError('Namespace must be array-like (16 iterable integer values, 0-255)');
         // Compute hash of namespace and value, Per 4.3
        // Future: Use spread syntax when supported on all platforms, e.g. `bytes =
        // hashfunc([...namespace, ... value])`
        var bytes = new Uint8Array(16 + value.length);
        bytes.set(namespace);
        bytes.set(value, namespace.length);
        bytes = hashfunc(bytes);
        bytes[6] = bytes[6] & 0x0f | version;
        bytes[8] = bytes[8] & 0x3f | 0x80;
        if (buf) {
            offset = offset || 0;
            for(var i = 0; i < 16; ++i)buf[offset + i] = bytes[i];
            return buf;
        }
        return (0, _stringifyJs.unsafeStringify)(bytes);
    } // Function#name is not settable on some platforms (#270)
    try {
        generateUUID.name = name; // eslint-disable-next-line no-empty
    } catch (err) {} // For CommonJS default export support
    generateUUID.DNS = DNS;
    generateUUID.URL = URL;
    return generateUUID;
}

},{"./stringify.js":"3OsGs","./parse.js":"l5KrY","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"l5KrY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _validateJs = require("./validate.js");
var _validateJsDefault = parcelHelpers.interopDefault(_validateJs);
function parse(uuid) {
    if (!(0, _validateJsDefault.default)(uuid)) throw TypeError('Invalid UUID');
    var v;
    var arr = new Uint8Array(16); // Parse ########-....-....-....-............
    arr[0] = (v = parseInt(uuid.slice(0, 8), 16)) >>> 24;
    arr[1] = v >>> 16 & 0xff;
    arr[2] = v >>> 8 & 0xff;
    arr[3] = v & 0xff; // Parse ........-####-....-....-............
    arr[4] = (v = parseInt(uuid.slice(9, 13), 16)) >>> 8;
    arr[5] = v & 0xff; // Parse ........-....-####-....-............
    arr[6] = (v = parseInt(uuid.slice(14, 18), 16)) >>> 8;
    arr[7] = v & 0xff; // Parse ........-....-....-####-............
    arr[8] = (v = parseInt(uuid.slice(19, 23), 16)) >>> 8;
    arr[9] = v & 0xff; // Parse ........-....-....-....-############
    // (Use "/" to avoid 32-bit truncation when bit-shifting high-order bytes)
    arr[10] = (v = parseInt(uuid.slice(24, 36), 16)) / 0x10000000000 & 0xff;
    arr[11] = v / 0x100000000 & 0xff;
    arr[12] = v >>> 24 & 0xff;
    arr[13] = v >>> 16 & 0xff;
    arr[14] = v >>> 8 & 0xff;
    arr[15] = v & 0xff;
    return arr;
}
exports.default = parse;

},{"./validate.js":"aAq2W","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"huzy4":[function(require,module,exports,__globalThis) {
/*
 * Browser-compatible JavaScript MD5
 *
 * Modification of JavaScript MD5
 * https://github.com/blueimp/JavaScript-MD5
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 *
 * Based on
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function md5(bytes) {
    if (typeof bytes === 'string') {
        var msg = unescape(encodeURIComponent(bytes)); // UTF8 escape
        bytes = new Uint8Array(msg.length);
        for(var i = 0; i < msg.length; ++i)bytes[i] = msg.charCodeAt(i);
    }
    return md5ToHexEncodedArray(wordsToMd5(bytesToWords(bytes), bytes.length * 8));
}
/*
 * Convert an array of little-endian words to an array of bytes
 */ function md5ToHexEncodedArray(input) {
    var output = [];
    var length32 = input.length * 32;
    var hexTab = '0123456789abcdef';
    for(var i = 0; i < length32; i += 8){
        var x = input[i >> 5] >>> i % 32 & 0xff;
        var hex = parseInt(hexTab.charAt(x >>> 4 & 0x0f) + hexTab.charAt(x & 0x0f), 16);
        output.push(hex);
    }
    return output;
}
/**
 * Calculate output length with padding and bit length
 */ function getOutputLength(inputLength8) {
    return (inputLength8 + 64 >>> 9 << 4) + 14 + 1;
}
/*
 * Calculate the MD5 of an array of little-endian words, and a bit length.
 */ function wordsToMd5(x, len) {
    /* append padding */ x[len >> 5] |= 0x80 << len % 32;
    x[getOutputLength(len) - 1] = len;
    var a = 1732584193;
    var b = -271733879;
    var c = -1732584194;
    var d = 271733878;
    for(var i = 0; i < x.length; i += 16){
        var olda = a;
        var oldb = b;
        var oldc = c;
        var oldd = d;
        a = md5ff(a, b, c, d, x[i], 7, -680876936);
        d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
        c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
        b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
        a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
        d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
        c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
        b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
        a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
        d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
        c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
        b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
        a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
        d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
        c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
        b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);
        a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
        d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
        c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
        b = md5gg(b, c, d, a, x[i], 20, -373897302);
        a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
        d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
        c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
        b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
        a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
        d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
        c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
        b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
        a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
        d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
        c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
        b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);
        a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
        d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
        c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
        b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
        a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
        d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
        c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
        b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
        a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
        d = md5hh(d, a, b, c, x[i], 11, -358537222);
        c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
        b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
        a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
        d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
        c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
        b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);
        a = md5ii(a, b, c, d, x[i], 6, -198630844);
        d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
        c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
        b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
        a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
        d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
        c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
        b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
        a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
        d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
        c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
        b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
        a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
        d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
        c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
        b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);
        a = safeAdd(a, olda);
        b = safeAdd(b, oldb);
        c = safeAdd(c, oldc);
        d = safeAdd(d, oldd);
    }
    return [
        a,
        b,
        c,
        d
    ];
}
/*
 * Convert an array bytes to an array of little-endian words
 * Characters >255 have their high-byte silently ignored.
 */ function bytesToWords(input) {
    if (input.length === 0) return [];
    var length8 = input.length * 8;
    var output = new Uint32Array(getOutputLength(length8));
    for(var i = 0; i < length8; i += 8)output[i >> 5] |= (input[i / 8] & 0xff) << i % 32;
    return output;
}
/*
 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
 * to work around bugs in some JS interpreters.
 */ function safeAdd(x, y) {
    var lsw = (x & 0xffff) + (y & 0xffff);
    var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
    return msw << 16 | lsw & 0xffff;
}
/*
 * Bitwise rotate a 32-bit number to the left.
 */ function bitRotateLeft(num, cnt) {
    return num << cnt | num >>> 32 - cnt;
}
/*
 * These functions implement the four basic operations the algorithm uses.
 */ function md5cmn(q, a, b, x, s, t) {
    return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
}
function md5ff(a, b, c, d, x, s, t) {
    return md5cmn(b & c | ~b & d, a, b, x, s, t);
}
function md5gg(a, b, c, d, x, s, t) {
    return md5cmn(b & d | c & ~d, a, b, x, s, t);
}
function md5hh(a, b, c, d, x, s, t) {
    return md5cmn(b ^ c ^ d, a, b, x, s, t);
}
function md5ii(a, b, c, d, x, s, t) {
    return md5cmn(c ^ (b | ~d), a, b, x, s, t);
}
exports.default = md5;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7q6st":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _nativeJs = require("./native.js");
var _nativeJsDefault = parcelHelpers.interopDefault(_nativeJs);
var _rngJs = require("./rng.js");
var _rngJsDefault = parcelHelpers.interopDefault(_rngJs);
var _stringifyJs = require("./stringify.js");
function v4(options, buf, offset) {
    if ((0, _nativeJsDefault.default).randomUUID && !buf && !options) return (0, _nativeJsDefault.default).randomUUID();
    options = options || {};
    var rnds = options.random || (options.rng || (0, _rngJsDefault.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, _stringifyJs.unsafeStringify)(rnds);
}
exports.default = v4;

},{"./native.js":"lkyaU","./rng.js":"fP2kO","./stringify.js":"3OsGs","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"lkyaU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
exports.default = {
    randomUUID: randomUUID
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8Q1Fl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _v35Js = require("./v35.js");
var _v35JsDefault = parcelHelpers.interopDefault(_v35Js);
var _sha1Js = require("./sha1.js");
var _sha1JsDefault = parcelHelpers.interopDefault(_sha1Js);
var v5 = (0, _v35JsDefault.default)('v5', 0x50, (0, _sha1JsDefault.default));
exports.default = v5;

},{"./v35.js":"jtYHK","./sha1.js":"d5Zvl","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"d5Zvl":[function(require,module,exports,__globalThis) {
// Adapted from Chris Veness' SHA1 code at
// http://www.movable-type.co.uk/scripts/sha1.html
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function f(s, x, y, z) {
    switch(s){
        case 0:
            return x & y ^ ~x & z;
        case 1:
            return x ^ y ^ z;
        case 2:
            return x & y ^ x & z ^ y & z;
        case 3:
            return x ^ y ^ z;
    }
}
function ROTL(x, n) {
    return x << n | x >>> 32 - n;
}
function sha1(bytes) {
    var K = [
        0x5a827999,
        0x6ed9eba1,
        0x8f1bbcdc,
        0xca62c1d6
    ];
    var H = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    if (typeof bytes === 'string') {
        var msg = unescape(encodeURIComponent(bytes)); // UTF8 escape
        bytes = [];
        for(var i = 0; i < msg.length; ++i)bytes.push(msg.charCodeAt(i));
    } else if (!Array.isArray(bytes)) // Convert Array-like to Array
    bytes = Array.prototype.slice.call(bytes);
    bytes.push(0x80);
    var l = bytes.length / 4 + 2;
    var N = Math.ceil(l / 16);
    var M = new Array(N);
    for(var i1 = 0; i1 < N; ++i1){
        var arr = new Uint32Array(16);
        for(var j = 0; j < 16; ++j)arr[j] = bytes[i1 * 64 + j * 4] << 24 | bytes[i1 * 64 + j * 4 + 1] << 16 | bytes[i1 * 64 + j * 4 + 2] << 8 | bytes[i1 * 64 + j * 4 + 3];
        M[i1] = arr;
    }
    M[N - 1][14] = (bytes.length - 1) * 8 / Math.pow(2, 32);
    M[N - 1][14] = Math.floor(M[N - 1][14]);
    M[N - 1][15] = (bytes.length - 1) * 8 & 0xffffffff;
    for(var i2 = 0; i2 < N; ++i2){
        var W = new Uint32Array(80);
        for(var t = 0; t < 16; ++t)W[t] = M[i2][t];
        for(var t1 = 16; t1 < 80; ++t1)W[t1] = ROTL(W[t1 - 3] ^ W[t1 - 8] ^ W[t1 - 14] ^ W[t1 - 16], 1);
        var a = H[0];
        var b = H[1];
        var c = H[2];
        var d = H[3];
        var e = H[4];
        for(var t2 = 0; t2 < 80; ++t2){
            var s = Math.floor(t2 / 20);
            var T = ROTL(a, 5) + f(s, b, c, d) + e + K[s] + W[t2] >>> 0;
            e = d;
            d = c;
            c = ROTL(b, 30) >>> 0;
            b = a;
            a = T;
        }
        H[0] = H[0] + a >>> 0;
        H[1] = H[1] + b >>> 0;
        H[2] = H[2] + c >>> 0;
        H[3] = H[3] + d >>> 0;
        H[4] = H[4] + e >>> 0;
    }
    return [
        H[0] >> 24 & 0xff,
        H[0] >> 16 & 0xff,
        H[0] >> 8 & 0xff,
        H[0] & 0xff,
        H[1] >> 24 & 0xff,
        H[1] >> 16 & 0xff,
        H[1] >> 8 & 0xff,
        H[1] & 0xff,
        H[2] >> 24 & 0xff,
        H[2] >> 16 & 0xff,
        H[2] >> 8 & 0xff,
        H[2] & 0xff,
        H[3] >> 24 & 0xff,
        H[3] >> 16 & 0xff,
        H[3] >> 8 & 0xff,
        H[3] & 0xff,
        H[4] >> 24 & 0xff,
        H[4] >> 16 & 0xff,
        H[4] >> 8 & 0xff,
        H[4] & 0xff
    ];
}
exports.default = sha1;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"dK2jD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = '00000000-0000-0000-0000-000000000000';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8Ppb4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _validateJs = require("./validate.js");
var _validateJsDefault = parcelHelpers.interopDefault(_validateJs);
function version(uuid) {
    if (!(0, _validateJsDefault.default)(uuid)) throw TypeError('Invalid UUID');
    return parseInt(uuid.slice(14, 15), 16);
}
exports.default = version;

},{"./validate.js":"aAq2W","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"hcLIU":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.pickProperties = exports.setNullIfUndefined = exports.getRecordKeys = void 0;
function getRecordKeys(record) {
    return Object.keys(record);
}
exports.getRecordKeys = getRecordKeys;
function setNullIfUndefined(obj, keys) {
    var _a;
    var output = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            output[key] = (_a = obj[key]) !== null && _a !== void 0 ? _a : null;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return output;
}
exports.setNullIfUndefined = setNullIfUndefined;
function pickProperties(obj, keys) {
    var picked = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            picked[key] = obj[key];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return picked;
}
exports.pickProperties = pickProperties;

},{}],"7cIy6":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.cancellationReasonText = void 0;
var assertNever_1 = require("70f115bab78f5d48");
var enum_1 = require("ff6eac277c694ad0");
function cancellationReasonText(reason) {
    switch(reason){
        case enum_1.CancellationReason.TROP_CHER:
            return `Les produits sont trop chers`;
        case enum_1.CancellationReason.ABONNE_PAR_ERREUR:
            return `Je me suis abonn\xe9 par erreur`;
        case enum_1.CancellationReason.PROBLEME_LIVRAISON:
            return `Probl\xe8me de livraison`;
        case enum_1.CancellationReason.ANIMAL_NAIME_PAS:
            return `Mon animal n'aime pas`;
        case enum_1.CancellationReason.PROBLEME_DIGESTION:
            return `Probl\xe8me de digestion`;
        case enum_1.CancellationReason.TROP_DE_STOCK:
            return `J'ai trop de stock`;
        case enum_1.CancellationReason.RECOMMANDATION_VETERINAIRE:
            return `Mon v\xe9t\xe9rinaire me le recommande`;
        case enum_1.CancellationReason.PROBLEME_PRODUIT:
            return `Probl\xe8me sur les produits`;
        case enum_1.CancellationReason.PREFERE_SANS_ABONNEMENT:
            return `Je pr\xe9f\xe8re commander sans abonnement`;
        case enum_1.CancellationReason.DECES_ANIMAL:
            return `Mon animal est d\xe9c\xe9d\xe9`;
        case enum_1.CancellationReason.NARRIVE_PAS_A_MODIFIER_ABONNEMENT:
            return `Je n'arrive pas \xe0 modifier mon abonnement`;
        default:
            (0, assertNever_1.assertNever)(reason);
    }
}
exports.cancellationReasonText = cancellationReasonText;

},{"70f115bab78f5d48":"fP6xK","ff6eac277c694ad0":"jHIZU"}],"7a5Xv":[function(require,module,exports,__globalThis) {
var _asyncIterator = require("@swc/helpers/_/_async_iterator");
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.asyncIterableToArray = void 0;
function asyncIterableToArray(gen) {
    return _asyncIterableToArray.apply(this, arguments);
}
function _asyncIterableToArray() {
    _asyncIterableToArray = (0, _asyncToGenerator._)(function(gen) {
        var output, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, x, err;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    output = [];
                    _iteratorAbruptCompletion = false, _didIteratorError = false;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        6,
                        7,
                        12
                    ]);
                    _iterator = (0, _asyncIterator._)(gen);
                    _state.label = 2;
                case 2:
                    return [
                        4,
                        _iterator.next()
                    ];
                case 3:
                    if (!(_iteratorAbruptCompletion = !(_step = _state.sent()).done)) return [
                        3,
                        5
                    ];
                    _value = _step.value;
                    x = _value;
                    output.push(x);
                    _state.label = 4;
                case 4:
                    _iteratorAbruptCompletion = false;
                    return [
                        3,
                        2
                    ];
                case 5:
                    return [
                        3,
                        12
                    ];
                case 6:
                    err = _state.sent();
                    _didIteratorError = true;
                    _iteratorError = err;
                    return [
                        3,
                        12
                    ];
                case 7:
                    _state.trys.push([
                        7,
                        ,
                        10,
                        11
                    ]);
                    if (!(_iteratorAbruptCompletion && _iterator.return != null)) return [
                        3,
                        9
                    ];
                    return [
                        4,
                        _iterator.return()
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    return [
                        3,
                        11
                    ];
                case 10:
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                    return [
                        7
                    ];
                case 11:
                    return [
                        7
                    ];
                case 12:
                    return [
                        2,
                        output
                    ];
            }
        });
    });
    return _asyncIterableToArray.apply(this, arguments);
}
exports.asyncIterableToArray = asyncIterableToArray;

},{"@swc/helpers/_/_async_iterator":"9BjSN","@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_ts_generator":"f2hGH"}],"9BjSN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _async_iterator;
});
function _async_iterator(iterable) {
    var method, async, sync, retry = 2;
    for("undefined" != typeof Symbol && (async = Symbol.asyncIterator, sync = Symbol.iterator); retry--;){
        if (async && null != (method = iterable[async])) return method.call(iterable);
        if (sync && null != (method = iterable[sync])) return new AsyncFromSyncIterator(method.call(iterable));
        async = "@@asyncIterator", sync = "@@iterator";
    }
    throw new TypeError("Object is not async iterable");
}
function AsyncFromSyncIterator(s) {
    function AsyncFromSyncIteratorContinuation(r) {
        if (Object(r) !== r) return Promise.reject(new TypeError(r + " is not an object."));
        var done = r.done;
        return Promise.resolve(r.value).then(function(value) {
            return {
                value: value,
                done: done
            };
        });
    }
    return AsyncFromSyncIterator = function(s) {
        this.s = s, this.n = s.next;
    }, AsyncFromSyncIterator.prototype = {
        s: null,
        n: null,
        next: function() {
            return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments));
        },
        return: function(value) {
            var ret = this.s.return;
            return void 0 === ret ? Promise.resolve({
                value: value,
                done: !0
            }) : AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments));
        },
        throw: function(value) {
            var thr = this.s.return;
            return void 0 === thr ? Promise.reject(value) : AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments));
        }
    }, new AsyncFromSyncIterator(s);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"j4V6v":[function(require,module,exports,__globalThis) {
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
"use strict";
var __importDefault = undefined && undefined.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.formatRange = exports.formatDate = exports.isRegloWorking = exports.isWarehouseWorking = exports.isPublicHolidays = exports.isCarrierWorking = exports.calculateEstimatedDeliveryDateRange = void 0;
var enum_1 = require("ab4116fa3f6cb835");
var date_holidays_1 = __importDefault(require("6baec05daa8c5d1d"));
var date_fns_1 = require("fde4b13f5b478626");
var date_fns_2 = require("fde4b13f5b478626");
var locale_1 = require("34bb0a8389743632");
var date_fns_tz_1 = require("8c5a8b1a29f710f7");
function calculateEstimatedDeliveryDateRange(shippingDate, carrier) {
    return {
        start: deliveryDateRangeStart(),
        end: deliveryDateRangeEnd()
    };
    function actualShippingDate() {
        var date = shippingDate;
        if (isAfterPreparationDeadline(date)) date = (0, date_fns_1.addDays)(date, 1);
        while(true){
            if (isWarehouseWorking(date)) return keepDateOnly(date);
            date = (0, date_fns_1.addDays)(date, 1);
        }
    }
    function isAfterPreparationDeadline(date) {
        var _split = (0, _slicedToArray._)((0, date_fns_tz_1.formatInTimeZone)(date, 'Europe/Paris', 'HH,mm').split(','), 2), hours = _split[0], minutes = _split[1];
        return Number(hours) * 60 + Number(minutes) >= 825;
    }
    function keepDateOnly(date) {
        return (0, date_fns_1.setHours)((0, date_fns_1.setMinutes)((0, date_fns_1.setSeconds)((0, date_fns_1.setMilliseconds)(date, 0), 0), 0), 0);
    }
    function deliveryDateRangeStart() {
        var date = (0, date_fns_1.addDays)(actualShippingDate(), carrierRangeStart());
        while(true){
            if (isCarrierWorking(date)) return date;
            date = (0, date_fns_1.addDays)(date, 1);
        }
    }
    function deliveryDateRangeEnd() {
        var date = (0, date_fns_1.addDays)(deliveryDateRangeStart(), carrierRangeLength());
        while(true){
            if (isCarrierWorking(date) && !(0, date_fns_1.isSaturday)(date)) return date;
            date = (0, date_fns_1.addDays)(date, 1);
        }
    }
    function carrierRangeStart() {
        return selectedCarrier() === enum_1.Carrier.CHRONOPOST ? 1 : 2;
    }
    function carrierRangeLength() {
        return selectedCarrier() === enum_1.Carrier.CHRONOPOST ? 0 : 1;
    }
    function selectedCarrier() {
        return carrier !== null && carrier !== void 0 ? carrier : enum_1.Carrier.DPD;
    }
}
exports.calculateEstimatedDeliveryDateRange = calculateEstimatedDeliveryDateRange;
function isCarrierWorking(date) {
    return !(0, date_fns_1.isSunday)(date) && !isPublicHolidays(date);
}
exports.isCarrierWorking = isCarrierWorking;
function isPublicHolidays(date) {
    return !!new date_holidays_1.default('FR').isHoliday(date);
}
exports.isPublicHolidays = isPublicHolidays;
function isWarehouseWorking(date) {
    return !(0, date_fns_1.isSaturday)(date) && !(0, date_fns_1.isSunday)(date) && !isPublicHolidays(date) || (0, date_fns_1.isSameDay)(date, new Date('2025-06-09'));
}
exports.isWarehouseWorking = isWarehouseWorking;
function isRegloWorking(date) {
    return !(0, date_fns_1.isSaturday)(date) && !(0, date_fns_1.isSunday)(date) && !isPublicHolidays(date) || (0, date_fns_1.isSameDay)(date, new Date('2025-06-09'));
}
exports.isRegloWorking = isRegloWorking;
function formatDate(date, options) {
    var yearFormat = (options === null || options === void 0 ? void 0 : options.withYear) ? ` yyyy` : ``;
    var timeFormat = (options === null || options === void 0 ? void 0 : options.withTime) ? ` \xe0 HH'h'mm` : ``;
    var monthFormat = (options === null || options === void 0 ? void 0 : options.withShortMonth) ? `LLL` : `LLLL`;
    var formatString = `EEEE d ${monthFormat}${yearFormat}${timeFormat}`;
    return (0, date_fns_2.format)(date, formatString, {
        locale: locale_1.fr
    });
}
exports.formatDate = formatDate;
function formatRange(range) {
    var isNotSameMonth = (0, date_fns_2.getMonth)(range.start) !== (0, date_fns_2.getMonth)(range.start);
    var isSameDay = (0, date_fns_2.differenceInDays)(range.start, range.end) === 0;
    if (isSameDay) return (0, date_fns_2.format)(range.start, `EEEE d LLL`, {
        locale: locale_1.fr
    });
    var startDate = (0, date_fns_2.format)(range.start, `EEEE d${isNotSameMonth ? ' LLL' : ''}`, {
        locale: locale_1.fr
    });
    var endDate = (0, date_fns_2.format)(range.end, 'EEEE d LLL', {
        locale: locale_1.fr
    });
    return `${startDate} - ${endDate}`;
}
exports.formatRange = formatRange;

},{"@swc/helpers/_/_sliced_to_array":"ha6sq","ab4116fa3f6cb835":"jHIZU","6baec05daa8c5d1d":"eHsVw","fde4b13f5b478626":"gBKRn","34bb0a8389743632":"4HYME","8c5a8b1a29f710f7":"c1e6y"}],"ha6sq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _sliced_to_array;
});
var _arrayWithHolesJs = require("./_array_with_holes.js");
var _iterableToArrayLimitJs = require("./_iterable_to_array_limit.js");
var _nonIterableRestJs = require("./_non_iterable_rest.js");
var _unsupportedIterableToArrayJs = require("./_unsupported_iterable_to_array.js");
function _sliced_to_array(arr, i) {
    return (0, _arrayWithHolesJs._)(arr) || (0, _iterableToArrayLimitJs._)(arr, i) || (0, _unsupportedIterableToArrayJs._)(arr, i) || (0, _nonIterableRestJs._)();
}

},{"./_array_with_holes.js":"5YhNB","./_iterable_to_array_limit.js":"hHfAh","./_non_iterable_rest.js":"9PKKT","./_unsupported_iterable_to_array.js":"fAMhu","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5YhNB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _array_with_holes;
});
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"hHfAh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _iterable_to_array_limit;
});
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"9PKKT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _non_iterable_rest;
});
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"eHsVw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return 0, _holidaysJs.Holidays;
});
var _holidaysJs = require("./Holidays.js");

},{"./Holidays.js":"kFJx1","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"kFJx1":[function(require,module,exports,__globalThis) {
/**
 * @copyright 2015-present (c) commenthol
 * @license ISC
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Holidays", function() {
    return Holidays;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _inherits = require("@swc/helpers/_/_inherits");
var _dateHolidaysParser = require("date-holidays-parser");
var _dateHolidaysParserDefault = parcelHelpers.interopDefault(_dateHolidaysParser);
var _dataJs = require("./data.js");
var Holidays = /*#__PURE__*/ function(HolidaysParser) {
    "use strict";
    (0, _inherits._)(Holidays, HolidaysParser);
    function Holidays(country, state, region, opts) {
        (0, _classCallCheck._)(this, Holidays);
        return (0, _callSuper._)(this, Holidays, [
            (0, _dataJs.data),
            country,
            state,
            region,
            opts
        ]);
    }
    return Holidays;
}((0, _dateHolidaysParserDefault.default));

},{"@swc/helpers/_/_call_super":"5oPMc","@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_inherits":"j8HRi","date-holidays-parser":"6WlGc","./data.js":"01dHL","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5oPMc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _call_super;
});
var _getPrototypeOfJs = require("./_get_prototype_of.js");
var _isNativeReflectConstructJs = require("./_is_native_reflect_construct.js");
var _possibleConstructorReturnJs = require("./_possible_constructor_return.js");
function _call_super(_this, derived, args) {
    // Super
    derived = (0, _getPrototypeOfJs._)(derived);
    return (0, _possibleConstructorReturnJs._)(_this, (0, _isNativeReflectConstructJs._)() ? Reflect.construct(derived, args || [], (0, _getPrototypeOfJs._)(_this).constructor) : derived.apply(_this, args));
}

},{"./_get_prototype_of.js":"fF8vn","./_is_native_reflect_construct.js":"3Bx8P","./_possible_constructor_return.js":"1T3mz","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"fF8vn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _get_prototype_of;
});
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3Bx8P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _is_native_reflect_construct;
});
function _is_native_reflect_construct() {
    // Since Reflect.construct can't be properly polyfilled, some
    // implementations (e.g. core-js@2) don't set the correct internal slots.
    // Those polyfills don't allow us to subclass built-ins, so we need to
    // use our fallback implementation.
    try {
        // If the internal slots aren't set, this throws an error similar to
        //   TypeError: this is not a Boolean object.
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1T3mz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _possible_constructor_return;
});
var _assertThisInitializedJs = require("./_assert_this_initialized.js");
var _typeOfJs = require("./_type_of.js");
function _possible_constructor_return(self, call) {
    if (call && ((0, _typeOfJs._)(call) === "object" || typeof call === "function")) return call;
    return (0, _assertThisInitializedJs._)(self);
}

},{"./_assert_this_initialized.js":"3GMNw","./_type_of.js":"c3ItR","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3GMNw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _assert_this_initialized;
});
function _assert_this_initialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"c3ItR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _type_of;
});
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6UdKs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _class_call_check;
});
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"j8HRi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _inherits;
});
var _setPrototypeOfJs = require("./_set_prototype_of.js");
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, _setPrototypeOfJs._)(subClass, superClass);
}

},{"./_set_prototype_of.js":"gh9Xk","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gh9Xk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _set_prototype_of;
});
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6WlGc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return 0, _holidaysJs.Holidays;
});
var _holidaysJs = require("./Holidays.js");
var _holidayRuleJs = require("./HolidayRule.js");
parcelHelpers.exportAll(_holidayRuleJs, exports);

},{"./Holidays.js":"49Kkv","./HolidayRule.js":"8qPqR","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"49Kkv":[function(require,module,exports,__globalThis) {
/**
 * @copyright 2016- (c) commenthol
 * @license ISC
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Holidays", function() {
    return Holidays;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _caldate = require("caldate");
var _caldateDefault = parcelHelpers.interopDefault(_caldate);
var _utilsJs = require("./utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _utilsJs1 = require("./internal/utils.js");
var _dataJs = require("./Data.js");
var _dataJsDefault = parcelHelpers.interopDefault(_dataJs);
var _dateFnJs = require("./DateFn.js");
var _dateFnJsDefault = parcelHelpers.interopDefault(_dateFnJs);
var _holidayRuleJs = require("./HolidayRule.js");
// priority in ascending order (low ... high)
var TYPES = [
    'observance',
    'optional',
    'school',
    'bank',
    'public'
];
var Holidays = /*#__PURE__*/ function() {
    "use strict";
    function Holidays(data, country, state, region, opts) {
        (0, _classCallCheck._)(this, Holidays);
        if (!data) throw new TypeError('need holiday data');
        this._data = data;
        this.init(country, state, region, opts);
    }
    (0, _createClass._)(Holidays, [
        {
            /**
   * initialize holidays for a country/state/region
   * @param {String|Object} country - if object, use `{ country: {String}, state: {String}, region: {String} }`
   * @param {String} [state] - specifies state
   * @param {String} [region] - specifies region
   * @param {Object} [opts] - options
   * @param {Array|String} [opts.languages] - set language(s) with ISO 639-1 shortcodes
   * @param {String} [opts.timezone] - set timezone
   * @param {Array} [opts.types] - holiday types to consider; priority is in ascending order (low ... high)
   */ key: "init",
            value: function init() {
                var _this = this;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _getArgs_apply = (0, _slicedToArray._)(getArgs.apply(void 0, (0, _toConsumableArray._)(args)), 4), country = _getArgs_apply[0], state = _getArgs_apply[1], region = _getArgs_apply[2], opts = _getArgs_apply[3];
                // reset settings
                this.__conf = null;
                this.__types = opts.types && opts.types.length ? opts.types : TYPES;
                this.holidays = {};
                this.setLanguages();
                this.__conf = (0, _dataJsDefault.default).splitName(country, state, region);
                this.__data = new (0, _dataJsDefault.default)(opts.data || this._data, this.__conf);
                if (opts.languages) this.setLanguages(opts.languages);
                else this.setLanguages(this.__data.getLanguages(this.__conf));
                var holidays = this.__data.getRules();
                if (holidays) {
                    this.__timezone = opts.timezone || this.__data.getTimezones()[0];
                    Object.keys(holidays).forEach(function(rule) {
                        _this.setHoliday(rule, holidays[rule]);
                    });
                    return true;
                }
            }
        },
        {
            /**
   * set (custom) holiday
   * @throws {TypeError}
   * @param {String} rule - rule for holiday (check supported grammar) or date in ISO Format, e.g. 12-31 for 31st Dec
   * @param {Object|String} [opts] - holiday options (if String, then opts is used as name)
   * @param {Object} opts.name - translated holiday names e.g. `{ en: 'name', es: 'nombre', ... }`
   * @param {String} opts.type - holiday type `public|bank|school|observance`
   * @returns {Boolean} `true` if holiday could be set
   */ key: "setHoliday",
            value: function setHoliday(rule, opts) {
                // remove days
                if (opts === false) {
                    if (this.holidays[rule]) {
                        this.holidays[rule] = false;
                        return true;
                    }
                    return false;
                }
                // assign a name to rule
                if (!opts || typeof opts === 'string') {
                    opts = opts || rule;
                    var lang = this.getLanguages()[0];
                    opts = (0, _utilsJsDefault.default).set({
                        type: 'public'
                    }, [
                        'name',
                        lang
                    ], opts);
                }
                // convert active properties to Date
                if (opts.active) {
                    if (!Array.isArray(opts.active)) throw TypeError('.active is not of type Array: ' + rule);
                    opts.active = opts.active.map(function(a) {
                        var from = (0, _utilsJs1.toDate)(a.from);
                        var to = (0, _utilsJs1.toDate)(a.to);
                        if (!(from || to)) throw TypeError('.active needs .from or .to property: ' + rule);
                        return {
                            from: from,
                            to: to
                        };
                    });
                }
                // check for supported type
                if (!this.__types.includes(opts.type)) return false;
                this.holidays[rule] = opts;
                var fn = new (0, _dateFnJsDefault.default)(rule, this.holidays);
                if (fn.ok) {
                    this.holidays[rule].fn = fn;
                    return true;
                } else // throw Error('could not parse rule: ' + rule) // NEXT
                console.error('could not parse rule: ' + rule) // eslint-disable-line
                ;
                return false;
            }
        },
        {
            /**
   * get all holidays for `year` with names using preferred `language`
   * @param {String|Date} [year] - if omitted, the current year is chosen
   * @param {String} [language] - ISO 639-1 code for language
   * @returns {Holiday[]} of found holidays in given year sorted by Date:
   * ```
   * {String} date - ISO Date String of (start)-date in local format
   * {Date} start - start date of holiday
   * {Date} end - end date of holiday
   * {String} name - name of holiday using `language` (if available)
   * {String} type - type of holiday `public|bank|school|observance`
   * ```
   */ key: "getHolidays",
            value: function getHolidays(year, language) {
                var _this = this;
                year = (0, _utilsJs1.toYear)(year);
                var langs = this.getLanguages();
                if (language) langs.unshift(language);
                var startSorter = function(a, b) {
                    return +a.start - +b.start;
                };
                var typeIndex = function(a) {
                    return _this.__types.indexOf(a.type);
                };
                var typeSorter = function(a, b) {
                    return typeIndex(b) - typeIndex(a);
                };
                var ruleIndex = function(a) {
                    return /substitutes|and if /.test(a.rule) ? 1 : 0;
                };
                var ruleLength = function(a) {
                    return String(a.rule || '').length;
                };
                var ruleSorter = function(a, b) {
                    return ruleIndex(a) - ruleIndex(b) || ruleLength(a) - ruleLength(b);
                };
                var filterMap = {};
                var arr = Object.keys(this.holidays).reduce(function(arr, rule) {
                    if (_this.holidays[rule].fn) _this._dateByRule(year, rule).forEach(function(o) {
                        arr.push((0, _objectSpreadProps._)((0, _objectSpread._)({}, _this._translate(o, langs)), {
                            rule: rule
                        }));
                    });
                    return arr;
                }, [])// sort by date and type to filter by duplicate
                .sort(function(a, b) {
                    return startSorter(a, b) || typeSorter(a, b) || ruleSorter(a, b);
                }).filter(function(item) {
                    var hash = item.name + +item.start;
                    if (!filterMap[hash]) {
                        filterMap[hash] = true;
                        return true;
                    }
                    return false;
                });
                return arr;
            }
        },
        {
            /**
   * check whether `date` is a holiday or not
   * @param {Date|String} [date]
   * @returns {Holiday[]|false} holiday:
   * ```
   * {String} date - ISO Date String of (start)-date in local format
   * {Date} start - start date of holiday
   * {Date} end - end date of holiday
   * {String} name - name of holiday using `language` (if available)
   * {String} type - type of holiday `public|bank|school|observance`
   * ```
   */ key: "isHoliday",
            value: function isHoliday(date) {
                date = date ? new Date(date) : new Date();
                var d = new (0, _caldateDefault.default)();
                d.fromTimezone(date, this.__timezone);
                var year = d.year;
                var rules = Object.keys(this.holidays);
                var days = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = rules[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var rule = _step.value;
                        var hd = [].concat(this._dateByRule(year, rule));
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = hd[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var hdrule = _step1.value;
                                if (hdrule && date >= hdrule.start && date < hdrule.end) days.push(this._translate(hdrule));
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return days.length ? days : false;
            }
        },
        {
            /**
   * set or update rule
   * @param {HolidayRule|object} holidayRule
   * @returns {boolean} `true` if holiday could be set, returns `true`
   */ key: "setRule",
            value: function setRule(holidayRule) {
                var rule = holidayRule.rule, opts = (0, _objectWithoutProperties._)(holidayRule, [
                    "rule"
                ]);
                return this.setHoliday(rule, opts);
            }
        },
        {
            /**
   * unset rule
   * @param {String} rule - rule for holiday (check supported grammar) or date in ISO Format, e.g. 12-31 for 31st Dec
   * @returns {boolean} `true` if holiday could be set, returns `true`
   */ key: "unsetRule",
            value: function unsetRule(rule) {
                return this.setHoliday(rule, false);
            }
        },
        {
            /**
   * get available rules for selected country, (state, region)
   * @returns {HolidayRule[]}
   */ key: "getRules",
            value: function getRules() {
                return Object.entries(this.holidays).map(function(param) {
                    var _param = (0, _slicedToArray._)(param, 2), ruleStr = _param[0], obj = _param[1];
                    return new (0, _holidayRuleJs.HolidayRule)((0, _objectSpreadProps._)((0, _objectSpread._)({}, obj), {
                        rule: ruleStr
                    }));
                });
            }
        },
        {
            /**
   * get rule for selected country, (state, region)
   * @param {String} rule - rule for holiday (check supported grammar) or date in ISO Format, e.g. 12-31 for 31st Dec
   * @returns {HolidayRule|undefined}
   */ key: "getRule",
            value: function getRule(rule) {
                if (this.holidays[rule]) return new (0, _holidayRuleJs.HolidayRule)((0, _objectSpreadProps._)((0, _objectSpread._)({}, this.holidays[rule]), {
                    rule: rule
                }));
            }
        },
        {
            /**
   * Query for available Countries, States, Regions
   * @param {String} [country]
   * @param {String} [state]
   * @param {String} [lang] - ISO-639 language shortcode
   * @returns {Object} shortcode, name pairs of supported countries, states, regions
   */ key: "query",
            value: function query(country, state, lang) {
                var o = (0, _dataJsDefault.default).splitName(country, state);
                if (!o || !o.country) return this.getCountries(lang);
                else if (!o.state) return this.getStates(o.country, lang);
                else return this.getRegions(o.country, o.state, lang);
            }
        },
        {
            /**
   * get supported countries
   * @param {String} [lang] - ISO-639 language shortcode
   * @returns {Object} shortcode, name pairs of supported countries
   * ```js
   * { AD: 'Andorra',
   *   US: 'United States' }
   * ```
   */ key: "getCountries",
            value: function getCountries(lang) {
                return this.__data.getCountries(lang);
            }
        },
        {
            /**
   * get supported states for a given country
   * @param {String} country - shortcode of country
   * @param {String} [lang] - ISO-639 language shortcode
   * @returns {Object} shortcode, name pairs of supported states, regions
   * ```js
   * { al: 'Alabama', ...
   *   wy: 'Wyoming' }
   * ```
   */ key: "getStates",
            value: function getStates(country, lang) {
                return this.__data.getStates(country, lang);
            }
        },
        {
            /**
   * get supported regions for a given country, state
   * @param {String} country - shortcode of country
   * @param {String} state - shortcode of state
   * @param {String} [lang] - ISO-639 language shortcode
   * @returns {Object} shortcode, name pairs of supported regions
   * ```js
   * { no: 'New Orleans' }
   * ```
   */ key: "getRegions",
            value: function getRegions(country, state, lang) {
                return this.__data.getRegions(country, state, lang);
            }
        },
        {
            /**
   * sets timezone
   * @param {String} timezone - see `moment-timezone`
   * if `timezone` is `undefined`, then all dates are considered local dates
   */ key: "setTimezone",
            value: function setTimezone(timezone) {
                this.__timezone = timezone;
            }
        },
        {
            /**
   * get timezones for country, state, region
   * @returns {Array} of {String}s containing the timezones
   */ key: "getTimezones",
            value: function getTimezones() {
                if (this.__data) return this.__data.getTimezones();
            }
        },
        {
            /**
   * set language(s) for holiday names
   * @param {Array|String} language
   * @returns {Array} set languages
   */ key: "setLanguages",
            value: function setLanguages(language) {
                if (typeof language === 'string') language = [
                    language
                ];
                var tmp = {};
                this.__languages = [].concat(language, this.__conf ? this.__data.getLanguages(this.__conf) : [], 'en').filter(function(l) {
                    if (!l || tmp[l]) return false;
                    tmp[l] = 1;
                    return true;
                });
            }
        },
        {
            /**
   * get languages for selected country, state, region
   * @returns {Array} containing ISO 639-1 language shortcodes
   */ key: "getLanguages",
            value: function getLanguages() {
                return this.__languages;
            }
        },
        {
            /**
   * get default day off as weekday
   * @returns {String} weekday of day off
   */ key: "getDayOff",
            value: function getDayOff() {
                if (this.__conf) return this.__data.getDayOff();
            }
        },
        {
            /**
   * @private
   * @param {Number} year
   * @param {String} rule
   */ key: "_dateByRule",
            value: function _dateByRule(year, rule) {
                var _rule = this.holidays[rule];
                if (!_rule || !_rule.fn || !_rule.fn.inYear) return [];
                var dates = _rule.fn.inYear(year).get(this.__timezone).map(function(date) {
                    var odate = (0, _utilsJsDefault.default).merge({}, (0, _utilsJsDefault.default).omit(date, [
                        'substitute'
                    ]), (0, _utilsJsDefault.default).omit(_rule, [
                        'fn',
                        'enable',
                        'disable',
                        'substitute',
                        'active'
                    ]));
                    if (_rule.substitute && date.substitute) odate.substitute = true;
                    return odate;
                });
                return dates;
            }
        },
        {
            /**
   * translate holiday object `o` to a language
   * @private
   * @param {Object} o
   * @param {Array} langs - languages for translation
   * @returns {Object} translated holiday object
   */ key: "_translate",
            value: function _translate(o, langs) {
                if (o && typeof o.name === 'object') {
                    langs = langs || this.getLanguages();
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = langs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var lang = _step.value;
                            var name = o.name[lang];
                            if (name) {
                                o.name = name;
                                break;
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    if (o.substitute) try {
                        for(var _iterator1 = langs[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var lang1 = _step1.value;
                            var subst = this.__data.getSubstitueNames();
                            var name1 = subst[lang1];
                            if (name1) {
                                o.name += ' (' + name1 + ')';
                                break;
                            }
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                }
                return o;
            }
        }
    ]);
    return Holidays;
}();
function getArgs(country, state, region, opts) {
    if (typeof region === 'object') {
        opts = region;
        region = null;
    } else if (typeof state === 'object') {
        opts = state;
        state = null;
    } else if (typeof country === 'object' && !country.country) opts = country;
    opts = opts || {};
    return [
        country,
        state,
        region,
        opts
    ];
}

},{"@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_object_spread_props":"fLCYP","@swc/helpers/_/_object_without_properties":"1waVD","@swc/helpers/_/_sliced_to_array":"ha6sq","@swc/helpers/_/_to_consumable_array":"eqNDD","caldate":"he6lr","./utils.js":"bGmqb","./internal/utils.js":"iCH29","./Data.js":"d7SrC","./DateFn.js":"TFC8O","./HolidayRule.js":"8qPqR","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3Y9J0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _create_class;
});
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4bEWH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _object_spread;
});
var _definePropertyJs = require("./_define_property.js");
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, _definePropertyJs._)(target, key, source[key]);
        });
    }
    return target;
}

},{"./_define_property.js":"54Zvk","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"fLCYP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _object_spread_props;
});
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1waVD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _object_without_properties;
});
var _objectWithoutPropertiesLooseJs = require("./_object_without_properties_loose.js");
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = (0, _objectWithoutPropertiesLooseJs._)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

},{"./_object_without_properties_loose.js":"jLzao","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jLzao":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _object_without_properties_loose;
});
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"he6lr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return 0, _calDateJs.CalDate;
});
var _calDateJs = require("./CalDate.js");

},{"./CalDate.js":"dDpRj","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"dDpRj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CalDate", function() {
    return CalDate;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _momentTimezone = require("moment-timezone");
var _momentTimezoneDefault = parcelHelpers.interopDefault(_momentTimezone);
var _utilsJs = require("./utils.js");
var PROPS = [
    'year',
    'month',
    'day',
    'hour',
    'minute',
    'second'
];
var CalDate = /*#__PURE__*/ function() {
    "use strict";
    function CalDate(opts) {
        (0, _classCallCheck._)(this, CalDate);
        this.set(opts);
    }
    (0, _createClass._)(CalDate, [
        {
            /**
   * set calendar date
   * @param {Object|Date} [opts] - defaults to `1900-01-01`
   * @param {String} opts.year
   * @param {String} opts.month - January equals to 1, December to 12
   * @param {String} opts.day
   * @param {String} opts.hour
   * @param {String} opts.minute
   * @param {String} opts.second
   * @param {String} opts.duration - defaults to 24 hours
   */ key: "set",
            value: function set(opts) {
                var _this = this;
                opts = opts || {
                    year: 1900,
                    month: 1,
                    day: 1
                };
                if ((0, _utilsJs.isDate)(opts)) {
                    this.year = opts.getFullYear();
                    this.month = opts.getMonth() + 1;
                    this.day = opts.getDate();
                    this.hour = opts.getHours();
                    this.minute = opts.getMinutes();
                    this.second = opts.getSeconds();
                } else {
                    PROPS.forEach(function(p) {
                        _this[p] = (0, _utilsJs.toNumber)(opts[p]) || 0;
                    });
                    this.month = this.month || 1;
                    this.day = this.day || 1;
                }
                this.duration = opts.duration || 24 // duration is in hours
                ;
                return this;
            }
        },
        {
            /**
   * checks if Date is equal to `calDate`
   * @param {CalDate} calDate
   * @return {Boolean} true if date matches
   */ key: "isEqualDate",
            value: function isEqualDate(calDate) {
                var _this = this;
                var res = true;
                this.update();
                [
                    'year',
                    'month',
                    'day'
                ].forEach(function(p) {
                    res &= _this[p] === calDate[p];
                });
                return !!res;
            }
        },
        {
            /**
   * get day of week
   * @return {Number} day of week 0=sunday, 1=monday, ...
   */ key: "getDay",
            value: function getDay() {
                return this.toDate().getDay();
            }
        },
        {
            /**
   * set offset per unit
   * @param {Number} number
   * @param {String} [unit='d'] - Unit in days `d`, hours `h, minutes `m`
   * @return {Object} this
   */ key: "setOffset",
            value: function setOffset(number, unit) {
                if (number) {
                    if (typeof number === 'object') {
                        unit = number.unit;
                        number = number.number;
                    }
                    unit = unit || 'd';
                    number = parseFloat(number, 10);
                    if (isNaN(number)) throw new Error('Number required');
                    var o = {
                        day: 0
                    };
                    if (unit === 'd') {
                        o.day = number | 0;
                        number -= o.day;
                        number *= 24;
                    }
                    if (unit === 'd' || unit === 'h') {
                        o.hour = number % 24 | 0;
                        number -= o.hour;
                        number *= 60;
                    }
                    o.minute = number % 60 | 0;
                    number -= o.minute;
                    number *= 60;
                    o.second = number % 60 | 0;
                    this.day += o.day;
                    this.hour += o.hour;
                    this.minute += o.minute;
                    this.second += o.second;
                }
                this.update();
                return this;
            }
        },
        {
            /**
   * set time per hour, minute or second while maintaining duration at midnight
   * @param {Number} [hour]
   * @param {Number} [minute]
   * @param {Number} [second]
   * @return {Object} this
   */ key: "setTime",
            value: function setTime(hour, minute, second) {
                hour = hour || 0;
                minute = minute || 0;
                second = second || 0;
                // the holiday usually ends at midnight - if this is not the case set different duration explicitely
                this.duration = 24 - (hour + minute / 60 + second / 3600);
                this.hour = hour;
                this.minute = minute;
                this.second = second;
                this.update();
                return this;
            }
        },
        {
            /**
   * set duration in hours
   * @param {Number} duration in hours
   * @return {Object} this
   */ key: "setDuration",
            value: function setDuration(duration) {
                this.duration = duration;
                return this;
            }
        },
        {
            /**
   * update internal data to real date
   * @return {Object} this
   */ key: "update",
            value: function update() {
                var _this = this;
                if (this.year) {
                    var d = new CalDate(this.toDate());
                    PROPS.forEach(function(p) {
                        _this[p] = d[p];
                    });
                }
                return this;
            }
        },
        {
            /**
   * get end date of calendar date
   * @return {CalDate}
   */ key: "toEndDate",
            value: function toEndDate() {
                var d = new CalDate(this.toDate());
                d.minute += this.duration * 60 | 0;
                d.update();
                return d;
            }
        },
        {
            /**
   * move internal date to a date in `timezone`
   * @param {String} timezone - e.g. 'America/New_York'
   * @return {Date}
   */ key: "toTimezone",
            value: function toTimezone(timezone) {
                if (timezone) return new Date((0, _momentTimezoneDefault.default).tz(this.toString(), timezone).format());
                else return this.toDate();
            }
        },
        {
            /**
   * set date from a given `timezone`
   * @param {Date} dateUTC - date in UTC
   * @param {String} [timezone] - timezone of dateUTC, e.g. 'America/New_York'
   * @return {CalDate} self
   */ key: "fromTimezone",
            value: function fromTimezone(dateUTC, timezone) {
                if (timezone) {
                    var m = (0, _momentTimezoneDefault.default).tz(dateUTC, timezone);
                    this.year = m.year();
                    this.month = m.month() + 1;
                    this.day = m.date();
                    this.hour = m.hours();
                    this.minute = m.minutes();
                    this.second = m.seconds();
                } else this.set(dateUTC);
                return this;
            }
        },
        {
            /**
   * convert to Date
   * @return {Date}
   */ key: "toDate",
            value: function toDate() {
                return new Date(this.year, this.month - 1, this.day, this.hour, this.minute, this.second, 0);
            }
        },
        {
            /**
   * get Date in ISO format
   */ key: "toISOString",
            value: function toISOString() {
                return this.toString(true);
            }
        },
        {
            /**
   * get Date as String `YYYY-MM-DD HH:MM:SS`
   */ key: "toString",
            value: function toString(iso) {
                var d = new CalDate(this.toDate());
                return (0, _utilsJs.pad0)(d.year, 4) + '-' + (0, _utilsJs.pad0)(d.month) + '-' + (0, _utilsJs.pad0)(d.day) + (iso ? 'T' : ' ') + (0, _utilsJs.pad0)(d.hour) + ':' + (0, _utilsJs.pad0)(d.minute) + ':' + (0, _utilsJs.pad0)(d.second) + (iso ? 'Z' : '');
            }
        }
    ], [
        {
            key: "toYear",
            value: function toYear(year) {
                return (0, _utilsJs.toYear)(year);
            }
        }
    ]);
    return CalDate;
}();

},{"@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","moment-timezone":"6gZ5H","./utils.js":"3UhYH","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6gZ5H":[function(require,module,exports,__globalThis) {
var moment = module.exports = require("2872784e1d2d2259");
moment.tz.load(require("546ecf582afd0a46"));

},{"2872784e1d2d2259":"7Kqo2","546ecf582afd0a46":"kwItP"}],"7Kqo2":[function(require,module,exports,__globalThis) {
//! moment-timezone.js
//! version : 0.5.48
//! Copyright (c) JS Foundation and other contributors
//! license : MIT
//! github.com/moment/moment-timezone
(function(root, factory) {
    "use strict";
    /*global define*/ if (0, module.exports) module.exports = factory(require("579775f5c90f7a01")); // Node
    else if (typeof define === 'function' && define.amd) define([
        'moment'
    ], factory); // AMD
    else factory(root.moment); // Browser
})(this, function(moment) {
    "use strict";
    // Resolves es6 module loading issue
    if (moment.version === undefined && moment.default) moment = moment.default;
    // Do not load moment-timezone a second time.
    // if (moment.tz !== undefined) {
    // 	logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
    // 	return moment;
    // }
    var VERSION = "0.5.48", zones = {}, links = {}, countries = {}, names = {}, guesses = {}, cachedGuess;
    if (!moment || typeof moment.version !== 'string') logError('Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/');
    var momentVersion = moment.version.split('.'), major = +momentVersion[0], minor = +momentVersion[1];
    // Moment.js version check
    if (major < 2 || major === 2 && minor < 6) logError('Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js ' + moment.version + '. See momentjs.com');
    /************************************
		Unpacking
	************************************/ function charCodeToInt(charCode) {
        if (charCode > 96) return charCode - 87;
        else if (charCode > 64) return charCode - 29;
        return charCode - 48;
    }
    function unpackBase60(string) {
        var i = 0, parts = string.split('.'), whole = parts[0], fractional = parts[1] || '', multiplier = 1, num, out = 0, sign = 1;
        // handle negative numbers
        if (string.charCodeAt(0) === 45) {
            i = 1;
            sign = -1;
        }
        // handle digits before the decimal
        for(i; i < whole.length; i++){
            num = charCodeToInt(whole.charCodeAt(i));
            out = 60 * out + num;
        }
        // handle digits after the decimal
        for(i = 0; i < fractional.length; i++){
            multiplier = multiplier / 60;
            num = charCodeToInt(fractional.charCodeAt(i));
            out += num * multiplier;
        }
        return out * sign;
    }
    function arrayToInt(array) {
        for(var i = 0; i < array.length; i++)array[i] = unpackBase60(array[i]);
    }
    function intToUntil(array, length) {
        for(var i = 0; i < length; i++)array[i] = Math.round((array[i - 1] || 0) + array[i] * 60000); // minutes to milliseconds
        array[length - 1] = Infinity;
    }
    function mapIndices(source, indices) {
        var out = [], i;
        for(i = 0; i < indices.length; i++)out[i] = source[indices[i]];
        return out;
    }
    function unpack(string) {
        var data = string.split('|'), offsets = data[2].split(' '), indices = data[3].split(''), untils = data[4].split(' ');
        arrayToInt(offsets);
        arrayToInt(indices);
        arrayToInt(untils);
        intToUntil(untils, indices.length);
        return {
            name: data[0],
            abbrs: mapIndices(data[1].split(' '), indices),
            offsets: mapIndices(offsets, indices),
            untils: untils,
            population: data[5] | 0
        };
    }
    /************************************
		Zone object
	************************************/ function Zone(packedString) {
        if (packedString) this._set(unpack(packedString));
    }
    function closest(num, arr) {
        var len = arr.length;
        if (num < arr[0]) return 0;
        else if (len > 1 && arr[len - 1] === Infinity && num >= arr[len - 2]) return len - 1;
        else if (num >= arr[len - 1]) return -1;
        var mid;
        var lo = 0;
        var hi = len - 1;
        while(hi - lo > 1){
            mid = Math.floor((lo + hi) / 2);
            if (arr[mid] <= num) lo = mid;
            else hi = mid;
        }
        return hi;
    }
    Zone.prototype = {
        _set: function _set(unpacked) {
            this.name = unpacked.name;
            this.abbrs = unpacked.abbrs;
            this.untils = unpacked.untils;
            this.offsets = unpacked.offsets;
            this.population = unpacked.population;
        },
        _index: function _index(timestamp) {
            var target = +timestamp, untils = this.untils, i;
            i = closest(target, untils);
            if (i >= 0) return i;
        },
        countries: function countries1() {
            var zone_name = this.name;
            return Object.keys(countries).filter(function(country_code) {
                return countries[country_code].zones.indexOf(zone_name) !== -1;
            });
        },
        parse: function parse(timestamp) {
            var target = +timestamp, offsets = this.offsets, untils = this.untils, max = untils.length - 1, offset, offsetNext, offsetPrev, i;
            for(i = 0; i < max; i++){
                offset = offsets[i];
                offsetNext = offsets[i + 1];
                offsetPrev = offsets[i ? i - 1 : i];
                if (offset < offsetNext && tz.moveAmbiguousForward) offset = offsetNext;
                else if (offset > offsetPrev && tz.moveInvalidForward) offset = offsetPrev;
                if (target < untils[i] - offset * 60000) return offsets[i];
            }
            return offsets[max];
        },
        abbr: function abbr(mom) {
            return this.abbrs[this._index(mom)];
        },
        offset: function offset(mom) {
            logError("zone.offset has been deprecated in favor of zone.utcOffset");
            return this.offsets[this._index(mom)];
        },
        utcOffset: function utcOffset(mom) {
            return this.offsets[this._index(mom)];
        }
    };
    /************************************
		Country object
	************************************/ function Country(country_name, zone_names) {
        this.name = country_name;
        this.zones = zone_names;
    }
    /************************************
		Current Timezone
	************************************/ function OffsetAt(at) {
        var timeString = at.toTimeString();
        var abbr = timeString.match(/\([a-z ]+\)/i);
        if (abbr && abbr[0]) {
            // 17:56:31 GMT-0600 (CST)
            // 17:56:31 GMT-0600 (Central Standard Time)
            abbr = abbr[0].match(/[A-Z]/g);
            abbr = abbr ? abbr.join('') : undefined;
        } else {
            // 17:56:31 CST
            // 17:56:31 GMT+0800 (台北標準時間)
            abbr = timeString.match(/[A-Z]{3,5}/g);
            abbr = abbr ? abbr[0] : undefined;
        }
        if (abbr === 'GMT') abbr = undefined;
        this.at = +at;
        this.abbr = abbr;
        this.offset = at.getTimezoneOffset();
    }
    function ZoneScore(zone) {
        this.zone = zone;
        this.offsetScore = 0;
        this.abbrScore = 0;
    }
    ZoneScore.prototype.scoreOffsetAt = function(offsetAt) {
        this.offsetScore += Math.abs(this.zone.utcOffset(offsetAt.at) - offsetAt.offset);
        if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, '') !== offsetAt.abbr) this.abbrScore++;
    };
    function findChange(low, high) {
        var mid, diff;
        while(diff = ((high.at - low.at) / 12e4 | 0) * 6e4){
            mid = new OffsetAt(new Date(low.at + diff));
            if (mid.offset === low.offset) low = mid;
            else high = mid;
        }
        return low;
    }
    function userOffsets() {
        var startYear = new Date().getFullYear() - 2, last = new OffsetAt(new Date(startYear, 0, 1)), lastOffset = last.offset, offsets = [
            last
        ], change, next, nextOffset, i;
        for(i = 1; i < 48; i++){
            nextOffset = new Date(startYear, i, 1).getTimezoneOffset();
            if (nextOffset !== lastOffset) {
                // Create OffsetAt here to avoid unnecessary abbr parsing before checking offsets
                next = new OffsetAt(new Date(startYear, i, 1));
                change = findChange(last, next);
                offsets.push(change);
                offsets.push(new OffsetAt(new Date(change.at + 6e4)));
                last = next;
                lastOffset = nextOffset;
            }
        }
        for(i = 0; i < 4; i++){
            offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
            offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
        }
        return offsets;
    }
    function sortZoneScores(a, b) {
        if (a.offsetScore !== b.offsetScore) return a.offsetScore - b.offsetScore;
        if (a.abbrScore !== b.abbrScore) return a.abbrScore - b.abbrScore;
        if (a.zone.population !== b.zone.population) return b.zone.population - a.zone.population;
        return b.zone.name.localeCompare(a.zone.name);
    }
    function addToGuesses(name, offsets) {
        var i, offset;
        arrayToInt(offsets);
        for(i = 0; i < offsets.length; i++){
            offset = offsets[i];
            guesses[offset] = guesses[offset] || {};
            guesses[offset][name] = true;
        }
    }
    function guessesForUserOffsets(offsets) {
        var offsetsLength = offsets.length, filteredGuesses = {}, out = [], checkedOffsets = {}, i, j, offset, guessesOffset;
        for(i = 0; i < offsetsLength; i++){
            offset = offsets[i].offset;
            if (checkedOffsets.hasOwnProperty(offset)) continue;
            guessesOffset = guesses[offset] || {};
            for(j in guessesOffset)if (guessesOffset.hasOwnProperty(j)) filteredGuesses[j] = true;
            checkedOffsets[offset] = true;
        }
        for(i in filteredGuesses)if (filteredGuesses.hasOwnProperty(i)) out.push(names[i]);
        return out;
    }
    function rebuildGuess() {
        // use Intl API when available and returning valid time zone
        try {
            var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
            if (intlName && intlName.length > 3) {
                var name = names[normalizeName(intlName)];
                if (name) return name;
                logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
            }
        } catch (e) {
        // Intl unavailable, fall back to manual guessing.
        }
        var offsets = userOffsets(), offsetsLength = offsets.length, guesses = guessesForUserOffsets(offsets), zoneScores = [], zoneScore, i, j;
        for(i = 0; i < guesses.length; i++){
            zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
            for(j = 0; j < offsetsLength; j++)zoneScore.scoreOffsetAt(offsets[j]);
            zoneScores.push(zoneScore);
        }
        zoneScores.sort(sortZoneScores);
        return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
    }
    function guess(ignoreCache) {
        if (!cachedGuess || ignoreCache) cachedGuess = rebuildGuess();
        return cachedGuess;
    }
    /************************************
		Global Methods
	************************************/ function normalizeName(name) {
        return (name || '').toLowerCase().replace(/\//g, '_');
    }
    function addZone(packed) {
        var i, name, split, normalized;
        if (typeof packed === "string") packed = [
            packed
        ];
        for(i = 0; i < packed.length; i++){
            split = packed[i].split('|');
            name = split[0];
            normalized = normalizeName(name);
            zones[normalized] = packed[i];
            names[normalized] = name;
            addToGuesses(normalized, split[2].split(' '));
        }
    }
    function getZone(name, caller) {
        name = normalizeName(name);
        var zone = zones[name];
        var link;
        if (zone instanceof Zone) return zone;
        if (typeof zone === 'string') {
            zone = new Zone(zone);
            zones[name] = zone;
            return zone;
        }
        // Pass getZone to prevent recursion more than 1 level deep
        if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
            zone = zones[name] = new Zone();
            zone._set(link);
            zone.name = names[name];
            return zone;
        }
        return null;
    }
    function getNames() {
        var i, out = [];
        for(i in names)if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) out.push(names[i]);
        return out.sort();
    }
    function getCountryNames() {
        return Object.keys(countries);
    }
    function addLink(aliases) {
        var i, alias, normal0, normal1;
        if (typeof aliases === "string") aliases = [
            aliases
        ];
        for(i = 0; i < aliases.length; i++){
            alias = aliases[i].split('|');
            normal0 = normalizeName(alias[0]);
            normal1 = normalizeName(alias[1]);
            links[normal0] = normal1;
            names[normal0] = alias[0];
            links[normal1] = normal0;
            names[normal1] = alias[1];
        }
    }
    function addCountries(data) {
        var i, country_code, country_zones, split;
        if (!data || !data.length) return;
        for(i = 0; i < data.length; i++){
            split = data[i].split('|');
            country_code = split[0].toUpperCase();
            country_zones = split[1].split(' ');
            countries[country_code] = new Country(country_code, country_zones);
        }
    }
    function getCountry(name) {
        name = name.toUpperCase();
        return countries[name] || null;
    }
    function zonesForCountry(country, with_offset) {
        country = getCountry(country);
        if (!country) return null;
        var zones = country.zones.sort();
        if (with_offset) return zones.map(function(zone_name) {
            var zone = getZone(zone_name);
            return {
                name: zone_name,
                offset: zone.utcOffset(new Date())
            };
        });
        return zones;
    }
    function loadData(data) {
        addZone(data.zones);
        addLink(data.links);
        addCountries(data.countries);
        tz.dataVersion = data.version;
    }
    function zoneExists(name) {
        if (!zoneExists.didShowError) {
            zoneExists.didShowError = true;
            logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
        }
        return !!getZone(name);
    }
    function needsOffset(m) {
        var isUnixTimestamp = m._f === 'X' || m._f === 'x';
        return !!(m._a && m._tzm === undefined && !isUnixTimestamp);
    }
    function logError(message) {
        if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    }
    /************************************
		moment.tz namespace
	************************************/ function tz(input) {
        var args = Array.prototype.slice.call(arguments, 0, -1), name = arguments[arguments.length - 1], out = moment.utc.apply(null, args), zone;
        if (!moment.isMoment(input) && needsOffset(out) && (zone = getZone(name))) out.add(zone.parse(out), 'minutes');
        out.tz(name);
        return out;
    }
    tz.version = VERSION;
    tz.dataVersion = '';
    tz._zones = zones;
    tz._links = links;
    tz._names = names;
    tz._countries = countries;
    tz.add = addZone;
    tz.link = addLink;
    tz.load = loadData;
    tz.zone = getZone;
    tz.zoneExists = zoneExists; // deprecated in 0.1.0
    tz.guess = guess;
    tz.names = getNames;
    tz.Zone = Zone;
    tz.unpack = unpack;
    tz.unpackBase60 = unpackBase60;
    tz.needsOffset = needsOffset;
    tz.moveInvalidForward = true;
    tz.moveAmbiguousForward = false;
    tz.countries = getCountryNames;
    tz.zonesForCountry = zonesForCountry;
    /************************************
		Interface with Moment.js
	************************************/ var fn = moment.fn;
    moment.tz = tz;
    moment.defaultZone = null;
    moment.updateOffset = function(mom, keepTime) {
        var zone = moment.defaultZone, offset;
        if (mom._z === undefined) {
            if (zone && needsOffset(mom) && !mom._isUTC && mom.isValid()) {
                mom._d = moment.utc(mom._a)._d;
                mom.utc().add(zone.parse(mom), 'minutes');
            }
            mom._z = zone;
        }
        if (mom._z) {
            offset = mom._z.utcOffset(mom);
            if (Math.abs(offset) < 16) offset = offset / 60;
            if (mom.utcOffset !== undefined) {
                var z = mom._z;
                mom.utcOffset(-offset, keepTime);
                mom._z = z;
            } else mom.zone(offset, keepTime);
        }
    };
    fn.tz = function(name, keepTime) {
        if (name) {
            if (typeof name !== 'string') throw new Error('Time zone name must be a string, got ' + name + ' [' + typeof name + ']');
            this._z = getZone(name);
            if (this._z) moment.updateOffset(this, keepTime);
            else logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
            return this;
        }
        if (this._z) return this._z.name;
    };
    function abbrWrap(old) {
        return function() {
            if (this._z) return this._z.abbr(this);
            return old.call(this);
        };
    }
    function resetZoneWrap(old) {
        return function() {
            this._z = null;
            return old.apply(this, arguments);
        };
    }
    function resetZoneWrap2(old) {
        return function() {
            if (arguments.length > 0) this._z = null;
            return old.apply(this, arguments);
        };
    }
    fn.zoneName = abbrWrap(fn.zoneName);
    fn.zoneAbbr = abbrWrap(fn.zoneAbbr);
    fn.utc = resetZoneWrap(fn.utc);
    fn.local = resetZoneWrap(fn.local);
    fn.utcOffset = resetZoneWrap2(fn.utcOffset);
    moment.tz.setDefault = function(name) {
        if (major < 2 || major === 2 && minor < 9) logError('Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js ' + moment.version + '.');
        moment.defaultZone = name ? getZone(name) : null;
        return moment;
    };
    // Cloning a moment should include the _z property.
    var momentProperties = moment.momentProperties;
    if (Object.prototype.toString.call(momentProperties) === '[object Array]') {
        // moment 2.8.1+
        momentProperties.push('_z');
        momentProperties.push('_a');
    } else if (momentProperties) // moment 2.7.0
    momentProperties._z = null;
    // INJECT DATA
    return moment;
});

},{"579775f5c90f7a01":"8Hx2b"}],"8Hx2b":[function(require,module,exports,__globalThis) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, 'toString')) a.toString = b.toString;
        if (hasOwnProp(b, 'valueOf')) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function some(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) console.warn('Deprecation warning: ' + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ': ' + arguments[0][key] + ', ';
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this['_' + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function keys(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L'
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') func = function func() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, '');
        return input.replace(/\\/g, '');
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = '', i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };
    function longDateFormat(key) {
        var _$format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (_$format || !formatUpper) return _$format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') return tok.slice(1);
            return tok;
        }).join('');
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = 'Invalid date';
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = '%d', defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }
    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years'
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var _$format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(_$format) ? _$format(output) : _$format.replace(/%s/i, output);
    }
    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year'
    };
    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === 'string') token = [
            token
        ];
        if (isNumber(callback)) func = function func(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken('Y', 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });
    addFormatToken(0, [
        'YY',
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        'YYYY',
        4
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYY',
        5
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYYY',
        6,
        true
    ], 0, 'year');
    // PARSING
    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);
    addParseToken([
        'YYYYY',
        'YYYYYY'
    ], YEAR);
    addParseToken('YYYY', function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet('FullYear', true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function indexOf(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken('M', [
        'MM',
        2
    ], 'Mo', function() {
        return this.month() + 1;
    });
    addFormatToken('MMM', 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken('MMMM', 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        'M',
        'MM'
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        'MMM',
        'MMMM'
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'), defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months['standalone'];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, 'Month');
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken('w', [
        'ww',
        2
    ], 'wo', 'week');
    addFormatToken('W', [
        'WW',
        2
    ], 'Wo', 'isoWeek');
    // PARSING
    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);
    addWeekParseToken([
        'w',
        'ww',
        'W',
        'WW'
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    // FORMATTING
    addFormatToken('d', 0, 'do', 'day');
    addFormatToken('dd', 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken('ddd', 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken('dddd', 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');
    // PARSING
    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        'dd',
        'ddd',
        'dddd'
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        'd',
        'e',
        'E'
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== 'string') return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === 'number') return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'), defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'), defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken('H', [
        'HH',
        2
    ], 0, 'hour');
    addFormatToken('h', [
        'hh',
        2
    ], 0, hFormat);
    addFormatToken('k', [
        'kk',
        2
    ], 0, kFormat);
    addFormatToken('hmm', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken('hmmss', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken('Hmm', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken('Hmmss', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem('a', true);
    meridiem('A', false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);
    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);
    addParseToken([
        'H',
        'HH'
    ], HOUR);
    addParseToken([
        'k',
        'kk'
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        'a',
        'A'
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        'h',
        'hh'
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet('Hours', true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? 'pm' : 'PM';
        else return isLower ? 'am' : 'AM';
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, _$locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while(j > 0){
                _$locale = loadLocale(split.slice(0, j).join('-'));
                if (_$locale) return _$locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire('./locale/' + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== 'undefined' && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn('Locale ' + key + ' not found. Did you forget to load it?');
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var _$locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride', "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    _$locale = loadLocale(config.parentLocale);
                    if (_$locale != null) parentConfig = _$locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var _$locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                _$locale = new Locale(config);
                _$locale.parentLocale = locales[name];
                locales[name] = _$locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var _$locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            _$locale = loadLocale(key);
            if (_$locale) return _$locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            'YYYYYY-MM-DD',
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            'YYYY-MM-DD',
            /\d{4}-\d\d-\d\d/
        ],
        [
            'GGGG-[W]WW-E',
            /\d{4}-W\d\d-\d/
        ],
        [
            'GGGG-[W]WW',
            /\d{4}-W\d\d/,
            false
        ],
        [
            'YYYY-DDD',
            /\d{4}-\d{3}/
        ],
        [
            'YYYY-MM',
            /\d{4}-\d\d/,
            false
        ],
        [
            'YYYYYYMMDD',
            /[+-]\d{10}/
        ],
        [
            'YYYYMMDD',
            /\d{8}/
        ],
        [
            'GGGG[W]WWE',
            /\d{4}W\d{3}/
        ],
        [
            'GGGG[W]WW',
            /\d{4}W\d{2}/,
            false
        ],
        [
            'YYYYDDD',
            /\d{7}/
        ],
        [
            'YYYYMM',
            /\d{6}/,
            false
        ],
        [
            'YYYY',
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            'HH:mm:ss.SSSS',
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            'HH:mm:ss,SSSS',
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            'HH:mm:ss',
            /\d\d:\d\d:\d\d/
        ],
        [
            'HH:mm',
            /\d\d:\d\d/
        ],
        [
            'HHmmss.SSSS',
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            'HHmmss,SSSS',
            /\d\d\d\d\d\d,\d+/
        ],
        [
            'HHmmss',
            /\d\d\d\d\d\d/
        ],
        [
            'HHmm',
            /\d\d\d\d/
        ],
        [
            'HH',
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = 'Z';
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, _$format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || _$format === undefined && input === '') return createInvalid({
            nullInput: true
        });
        if (typeof input === 'string') config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(_$format)) configFromStringAndArray(config);
        else if (_$format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === 'string') configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isBefore', args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isAfter', args);
    }
    var now = function now() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond'
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, _$weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + _$weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var _$offset = this.utcOffset(), sign = '+';
            if (_$offset < 0) {
                _$offset = -_$offset;
                sign = '-';
            }
            return sign + zeroFill(~~(_$offset / 60), 2) + separator + zeroFill(~~_$offset % 60, 2);
        });
    }
    offset('Z', ':');
    offset('ZZ', '');
    // PARSING
    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken([
        'Z',
        'ZZ'
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || [
            '-',
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, _$diff;
        if (model._isUTC) {
            res = model.clone();
            _$diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + _$diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var _$offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, 'm');
            if (_$offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - _$offset, 'm'), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? _$offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), 'm');
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, '_locale')) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, '_isValid')) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, 'M');
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, 'Month') + months * isAdding);
        if (days) set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, 'add'), subtract = createAdder(-1, 'subtract');
    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'years',
            'year',
            'y',
            'months',
            'month',
            'M',
            'days',
            'day',
            'd',
            'dates',
            'date',
            'D',
            'hours',
            'hour',
            'h',
            'minutes',
            'minute',
            'm',
            'seconds',
            'second',
            's',
            'milliseconds',
            'millisecond',
            'ms'
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'sameDay',
            'nextDay',
            'lastDay',
            'nextWeek',
            'lastWeek',
            'sameElse'
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var _$diff = myMoment.diff(now, 'days', true);
        return _$diff < -6 ? 'sameElse' : _$diff < -1 ? 'lastWeek' : _$diff < 0 ? 'lastDay' : _$diff < 1 ? 'sameDay' : _$diff < 2 ? 'nextDay' : _$diff < 7 ? 'nextWeek' : 'sameElse';
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf('day'), _$format = hooks.calendarFormat(this, sod) || 'sameElse', output = formats && (isFunction(formats[_$format]) ? formats[_$format].call(this, now) : formats[_$format]);
        return this.format(output || this.localeData().calendar(_$format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return 'moment.invalid(/* ' + this._i + ' */)';
        var func = 'moment', zone = '', prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
    addFormatToken('y', [
        'y',
        1
    ], 'yo', 'eraYear');
    addFormatToken('y', [
        'yy',
        2
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyy',
        3
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyyy',
        4
    ], 0, 'eraYear');
    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);
    addParseToken([
        'N',
        'NN',
        'NNN',
        'NNNN',
        'NNNNN'
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);
    addParseToken([
        'y',
        'yy',
        'yyy',
        'yyyy'
    ], YEAR);
    addParseToken([
        'yo'
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale('en')._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case 'undefined':
                    eras[i].until = Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case 'N':
                case 'NN':
                case 'NNN':
                    if (abbr === eraName) return eras[i];
                    break;
                case 'NNNN':
                    if (name === eraName) return eras[i];
                    break;
                case 'NNNNN':
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return '';
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return '';
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return '';
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    addFormatToken(0, [
        'gg',
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        'GG',
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
    // ALIASES
    // PARSING
    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);
    addWeekParseToken([
        'gggg',
        'ggggg',
        'GGGG',
        'GGGGG'
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        'gg',
        'GG'
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken('Q', 0, 'Qo', 'quarter');
    // PARSING
    addRegexToken('Q', match1);
    addParseToken('Q', function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken('D', [
        'DD',
        2
    ], 'Do', 'date');
    // PARSING
    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        'D',
        'DD'
    ], DATE);
    addParseToken('Do', function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet('Date', true);
    // FORMATTING
    addFormatToken('DDD', [
        'DDDD',
        3
    ], 'DDDo', 'dayOfYear');
    // PARSING
    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken([
        'DDD',
        'DDDD'
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }
    // FORMATTING
    addFormatToken('m', [
        'mm',
        2
    ], 0, 'minute');
    // PARSING
    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken([
        'm',
        'mm'
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet('Minutes', false);
    // FORMATTING
    addFormatToken('s', [
        'ss',
        2
    ], 0, 'second');
    // PARSING
    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken([
        's',
        'ss'
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet('Seconds', false);
    // FORMATTING
    addFormatToken('S', 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        'SS',
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        'SSS',
        3
    ], 0, 'millisecond');
    addFormatToken(0, [
        'SSSS',
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        'SSSSS',
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        'SSSSSS',
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        'SSSSSSS',
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        'SSSSSSSS',
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        'SSSSSSSSS',
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);
    var token, getSetMillisecond;
    for(token = 'SSSS'; token.length <= 9; token += 'S')addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }
    for(token = 'S'; token.length <= 9; token += 'S')addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet('Milliseconds', false);
    // FORMATTING
    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }
    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) proto[Symbol.for('nodejs.util.inspect.custom')] = function() {
        return 'Moment<' + this.format() + '>';
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var _$locale = getLocale(), utc = createUTC().set(setter, index);
        return _$locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || '';
        if (index != null) return get$1(format, index, field, 'month');
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, 'month');
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        }
        var _$locale = getLocale(), shift = localeSorted ? _$locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, 'day');
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, 'day');
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }
    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD'
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC'
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function ordinal(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs('ms'), asSeconds = makeAs('s'), asMinutes = makeAs('m'), asHours = makeAs('h'), asDays = makeAs('d'), asWeeks = makeAs('w'), asMonths = makeAs('M'), asQuarters = makeAs('Q'), asYears = makeAs('y'), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter('milliseconds'), seconds = makeGetter('seconds'), minutes = makeGetter('minutes'), hours = makeGetter('hours'), days = makeGetter('days'), months = makeGetter('months'), years = makeGetter('years');
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as('s')), minutes = round(duration.as('m')), hours = round(duration.as('h')), days = round(duration.as('d')), months = round(duration.as('M')), _$weeks = round(duration.as('w')), years = round(duration.as('y')), a = seconds <= thresholds.ss && [
            's',
            seconds
        ] || seconds < thresholds.s && [
            'ss',
            seconds
        ] || minutes <= 1 && [
            'm'
        ] || minutes < thresholds.m && [
            'mm',
            minutes
        ] || hours <= 1 && [
            'h'
        ] || hours < thresholds.h && [
            'hh',
            hours
        ] || days <= 1 && [
            'd'
        ] || days < thresholds.d && [
            'dd',
            days
        ];
        if (thresholds.w != null) a = a || _$weeks <= 1 && [
            'w'
        ] || _$weeks < thresholds.w && [
            'ww',
            _$weeks
        ];
        a = a || months <= 1 && [
            'M'
        ] || months < thresholds.M && [
            'MM',
            months
        ] || years <= 1 && [
            'y'
        ] || [
            'yy',
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === 's') thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, _$locale, output;
        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') withSuffix = argWithSuffix;
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        _$locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, _$locale);
        if (withSuffix) output = _$locale.pastFuture(+this, output);
        return _$locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
        return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');
    // PARSING
    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = '2.30.1';
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
        DATE: 'YYYY-MM-DD',
        TIME: 'HH:mm',
        TIME_SECONDS: 'HH:mm:ss',
        TIME_MS: 'HH:mm:ss.SSS',
        WEEK: 'GGGG-[W]WW',
        MONTH: 'YYYY-MM'
    };
    return hooks;
});

},{}],"kwItP":[function(require,module,exports,__globalThis) {
module.exports = JSON.parse("{\"version\":\"2025b\",\"zones\":[\"Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5\",\"Africa/Nairobi|LMT +0230 EAT +0245|-2r.g -2u -30 -2J|012132|-2ua2r.g N6nV.g 3Fbu h1cu dzbJ|47e5\",\"Africa/Algiers|LMT PMT WET WEST CET CEST|-c.c -9.l 0 -10 -10 -20|01232323232323232454542423234542324|-3bQ0c.c MDA2.P cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5\",\"Africa/Lagos|LMT GMT +0030 WAT|-d.z 0 -u -10|01023|-2B40d.z 7iod.z dnXK.p dLzH.z|17e6\",\"Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4\",\"Africa/Maputo|LMT CAT|-2a.i -20|01|-2sw2a.i|26e5\",\"Africa/Cairo|LMT EET EEST|-25.9 -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBC5.9 1AQM5.9 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0 kSp0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0|15e6\",\"Africa/Casablanca|LMT +00 +01|u.k 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|32e5\",\"Africa/Ceuta|LMT WET WEST CET CEST|l.g 0 -10 -10 -20|0121212121212121212121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2M0M0 GdX0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|85e3\",\"Africa/El_Aaiun|LMT -01 +00 +01|Q.M 10 0 -10|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|20e4\",\"Africa/Johannesburg|LMT SAST SAST SAST|-1Q -1u -20 -30|0123232|-39EpQ qTcm 1Ajdu 1cL0 1cN0 1cL0|84e5\",\"Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|012121212121212121212121212121212131|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 PeX0|\",\"Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5\",\"Africa/Monrovia|LMT MMT MMT GMT|H.8 H.8 I.u 0|0123|-3ygng.Q 1usM0 28G01.m|11e5\",\"Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5\",\"Africa/Sao_Tome|LMT LMT GMT WAT|-q.U A.J 0 -10|01232|-3tooq.U 18aoq.U 4i6N0 2q00|\",\"Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5\",\"Africa/Tunis|LMT PMT CET CEST|-E.I -9.l -10 -20|01232323232323232323232323232323232|-3zO0E.I 1cBAv.n 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5\",\"Africa/Windhoek|LMT +0130 SAST SAST CAT WAT|-18.o -1u -20 -30 -20 -10|012324545454545454545454545454545454545454545454545454|-39Ep8.o qTbC.o 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4\",\"America/Adak|LMT LMT NST NWT NPT BST BDT AHST HST HDT|-cd.m bK.C b0 a0 a0 b0 a0 a0 a0 90|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVzf.p 1EX1d.m 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326\",\"America/Anchorage|LMT LMT AST AWT APT AHST AHDT YST AKST AKDT|-e0.o 9X.A a0 90 90 a0 90 90 90 80|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVxs.n 1EX20.o 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4\",\"America/Puerto_Rico|LMT AST AWT APT|4o.p 40 30 30|01231|-2Qi7z.z 1IUbz.z 7XT0 iu0|24e5\",\"America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4\",\"America/Argentina/Buenos_Aires|LMT CMT -04 -03 -02|3R.M 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343434343|-331U6.c 125cn pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0|\",\"America/Argentina/Catamarca|LMT CMT -04 -03 -02|4n.8 4g.M 40 30 20|012323232323232323232323232323232323232323234343434243432343|-331TA.Q 125bR.E pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0|\",\"America/Argentina/Cordoba|LMT CMT -04 -03 -02|4g.M 4g.M 40 30 20|012323232323232323232323232323232323232323234343434243434343|-331TH.c 125c0 pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0|\",\"America/Argentina/Jujuy|LMT CMT -04 -03 -02|4l.c 4g.M 40 30 20|0123232323232323232323232323232323232323232343434232434343|-331TC.M 125bT.A pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0|\",\"America/Argentina/La_Rioja|LMT CMT -04 -03 -02|4r.o 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342343432343|-331Tw.A 125bN.o pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|\",\"America/Argentina/Mendoza|LMT CMT -04 -03 -02|4z.g 4g.M 40 30 20|012323232323232323232323232323232323232323234343423232432343|-331To.I 125bF.w pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0|\",\"America/Argentina/Rio_Gallegos|LMT CMT -04 -03 -02|4A.Q 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343432343|-331Tn.8 125bD.U pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|\",\"America/Argentina/Salta|LMT CMT -04 -03 -02|4l.E 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342434343|-331TC.k 125bT.8 pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0|\",\"America/Argentina/San_Juan|LMT CMT -04 -03 -02|4y.4 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342343432343|-331Tp.U 125bG.I pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0|\",\"America/Argentina/San_Luis|LMT CMT -04 -03 -02|4p.o 4g.M 40 30 20|0123232323232323232323232323232323232323232343434232323432323|-331Ty.A 125bP.o pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0|\",\"America/Argentina/Tucuman|LMT CMT -04 -03 -02|4k.Q 4g.M 40 30 20|01232323232323232323232323232323232323232323434343424343234343|-331TD.8 125bT.U pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0|\",\"America/Argentina/Ushuaia|LMT CMT -04 -03 -02|4x.c 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343432343|-331Tq.M 125bH.A pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0|\",\"America/Asuncion|LMT AMT -04 -03|3O.E 3O.E 40 30|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-3eLw9.k 1FGo0 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0|28e5\",\"America/Panama|LMT CMT EST|5i.8 5j.A 50|012|-3eLuF.Q Iy01.s|15e5\",\"America/Bahia_Banderas|LMT MST CST MDT CDT|71 70 60 60 50|01213121313131313131313131313131313142424242424242424242424242|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 otX0 2bmP0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|84e3\",\"America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5\",\"America/Barbados|LMT AST ADT -0330|3W.t 40 30 3u|0121213121212121|-2m4k1.v 1eAN1.v RB0 1Bz0 Op0 1rb0 11d0 1jJc0 IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4\",\"America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5\",\"America/Belize|LMT CST -0530 CWT CPT CDT|5Q.M 60 5u 50 50 50|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121215151|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu Rcu 7Bt0 Ni0 4nd0 Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu e9Au qn0 lxB0 mn0|57e3\",\"America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2\",\"America/Bogota|LMT BMT -05 -04|4U.g 4U.g 50 40|01232|-3sTv3.I 1eIo0 38yo3.I 1PX0|90e5\",\"America/Boise|LMT PST PDT MST MWT MPT MDT|7I.N 80 70 70 60 60 60|01212134536363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-3tFE0 1nEe0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4\",\"America/Cambridge_Bay|-00 MST MWT MPT MDT CST CDT EST|0 70 60 60 60 60 50 50|012314141414141414141414141414141414141414141414141414141414567541414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-21Jc0 RO90 8x20 ix0 14HB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2\",\"America/Campo_Grande|LMT -04 -03|3C.s 40 30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|77e4\",\"America/Cancun|LMT CST EST CDT EDT|5L.4 60 50 50 40|01213132431313131313131313131313131313131312|-1UQG0 2q3C0 2tx0 wgP0 1lb0 14p0 1lb0 14o0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4\",\"America/Caracas|LMT CMT -0430 -04|4r.I 4r.E 4u 40|012323|-3eLvw.g ROnX.U 28KM2.k 1IwOu kqo0|29e5\",\"America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3\",\"America/Chicago|LMT CST CDT EST CWT CPT|5O.A 60 50 50 50 50|012121212121212121212121212121212121213121212121214512121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5\",\"America/Chihuahua|LMT MST CST MDT CDT|74.k 70 60 60 50|0121312424231313131313131313131313131313131313131313131313132|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|81e4\",\"America/Ciudad_Juarez|LMT MST CST MDT CDT|75.U 70 60 60 50|01213124242313131313131313131313131313131313131313131313131321313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1wn0 cm0 EP0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|\",\"America/Costa_Rica|LMT SJMT CST CDT|5A.d 5A.d 60 50|01232323232|-3eLun.L 1fyo0 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5\",\"America/Coyhaique|LMT SMT -05 -04 -03|4M.g 4G.J 50 40 30|012131323232323232323434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLvb.I MJbS.t fJAh.f 5knG.J 1Vzh.f jRAG.J 1pbh.f 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0|\",\"America/Phoenix|LMT MST MDT MWT|7s.i 70 60 60|012121313121|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5\",\"America/Cuiaba|LMT -04 -03|3I.k 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|54e4\",\"America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8\",\"America/Dawson_Creek|LMT PST PDT PWT PPT MST|80.U 80 70 70 70 70|01213412121212121212121212121212121212121212121212121212125|-3tofX.4 1nspX.4 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3\",\"America/Dawson|LMT YST YDT YWT YPT YDDT PST PDT MST|9h.E 90 80 80 80 70 80 70 70|0121213415167676767676767676767676767676767676767676767676767676767676767676767676767676767678|-2MSeG.k GWpG.k 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|13e2\",\"America/Denver|LMT MST MDT MWT MPT|6X.U 70 60 60 60|012121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFF0 1nEe0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5\",\"America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|0123425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 JxX1 SMX 1cN0 1cL0 aW10 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5\",\"America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|0121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 XQp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5\",\"America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3\",\"America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5\",\"America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 4Q00 8mp0 8lz0 SN0 1cL0 pHB0 83r0 AU0 5MN0 1Rz0 38N0 Wn0 1qP0 11z0 1o10 11z0 3NA0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5\",\"America/Fort_Nelson|LMT PST PDT PWT PPT MST|8a.L 80 70 70 70 70|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121215|-3tofN.d 1nspN.d 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2\",\"America/Fort_Wayne|LMT CST CDT CWT CPT EST EDT|5I.C 60 50 50 50 50 40|0121212134121212121212121212151565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|\",\"America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5\",\"America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3\",\"America/Godthab|LMT -03 -02 -01|3q.U 30 20 10|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 2so0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e3\",\"America/Goose_Bay|LMT NST NDT NST NDT NWT NPT AST ADT ADDT|41.E 3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|0121343434343434356343434343434343434343434343434343434343437878787878787878787878787878787878787878787879787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787|-3tojW.k 1nspt.c 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2\",\"America/Grand_Turk|LMT KMT EST EDT AST|4I.w 57.a 50 40 40|01232323232323232323232323232323232323232323232323232323232323232323232323243232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLvf.s RK0m.C 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 7jA0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2\",\"America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5\",\"America/Guayaquil|LMT QMT -05 -04|5j.k 5e 50 40|01232|-3eLuE.E 1DNzS.E 2uILK rz0|27e5\",\"America/Guyana|LMT -04 -0345 -03|3Q.D 40 3J 30|01231|-2mf87.l 8Hc7.l 2r7bJ Ey0f|80e4\",\"America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4\",\"America/Havana|LMT HMT CST CDT|5t.s 5t.A 50 40|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLuu.w 1qx00.8 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5\",\"America/Hermosillo|LMT MST CST MDT|7n.Q 70 60 60|01213121313131|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 otX0 2bmP0 1lb0 14p0 1lb0 14p0 1lb0|64e4\",\"America/Indiana/Knox|LMT CST CDT CWT CPT EST|5K.u 60 50 50 50 50|01212134121212121212121212121212121212151212121212121212121212121212121212121212121212121252121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|\",\"America/Indiana/Marengo|LMT CST CDT CWT CPT EST EDT|5J.n 60 50 50 50 50 40|01212134121212121212121215656565656525656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|\",\"America/Indiana/Petersburg|LMT CST CDT CWT CPT EST EDT|5N.7 60 50 50 50 50 40|012121341212121212121212121215121212121212121212121252125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|\",\"America/Indiana/Tell_City|LMT CST CDT CWT CPT EST EDT|5L.3 60 50 50 50 50 40|012121341212121212121212121512165652121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 8wn0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|\",\"America/Indiana/Vevay|LMT CST CDT CWT CPT EST EDT|5E.g 60 50 50 50 50 40|0121213415656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|\",\"America/Indiana/Vincennes|LMT CST CDT CWT CPT EST EDT|5O.7 60 50 50 50 50 40|012121341212121212121212121212121565652125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|\",\"America/Indiana/Winamac|LMT CST CDT CWT CPT EST EDT|5K.p 60 50 50 50 50 40|012121341212121212121212121212121212121565652165656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|\",\"America/Inuvik|-00 PST PDT MDT MST|0 80 70 60 70|01212121212121213434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-FnA0 L3K0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2\",\"America/Iqaluit|-00 EWT EPT EST EDT CST CDT|0 40 40 50 40 60 50|0123434343434343434343434343434343434343434343434343434343456343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-16K00 7nX0 iv0 14HB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2\",\"America/Jamaica|LMT KMT EST EDT|57.a 57.a 50 40|01232323232323232323232|-3eLuQ.O RK00 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4\",\"America/Juneau|LMT LMT PST PWT PPT PDT YDT YST AKST AKDT|-f2.j 8V.F 80 70 70 70 80 90 90 80|0123425252525252525252525252625252578989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVwq.s 1EX12.j 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3\",\"America/Kentucky/Louisville|LMT CST CDT CWT CPT EST EDT|5H.2 60 50 50 50 50 40|01212121213412121212121212121212121212565656565656525656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 1nX1 e0X 9vd0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|\",\"America/Kentucky/Monticello|LMT CST CDT CWT CPT EST EDT|5D.o 60 50 50 50 50 40|01212134121212121212121212121212121212121212121212121212121212121212121212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|\",\"America/La_Paz|LMT CMT BST -04|4w.A 4w.A 3w.A 40|0123|-3eLvr.o 1FIo0 13b0|19e5\",\"America/Lima|LMT LMT -05 -04|58.c 58.A 50 40|01232323232323232|-3eLuP.M JcM0.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6\",\"America/Los_Angeles|LMT PST PDT PWT PPT|7Q.W 80 70 70 70|0121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFE0 1nEe0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6\",\"America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4\",\"America/Managua|LMT MMT CST EST CDT|5J.8 5J.c 60 50 50|01232424232324242|-3eLue.Q 1Mhc0.4 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5\",\"America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5\",\"America/Martinique|LMT FFMT AST ADT|44.k 44.k 40 30|01232|-3eLvT.E PTA0 2LPbT.E 19X0|39e4\",\"America/Matamoros|LMT CST CDT|6u 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4\",\"America/Mazatlan|LMT MST CST MDT|75.E 70 60 60|01213121313131313131313131313131313131313131313131313131313131|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 otX0 2bmP0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|44e4\",\"America/Menominee|LMT CST CDT CWT CPT EST|5O.r 60 50 50 50 50|012121341212152121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3pdG9.x 1jce9.x 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2\",\"America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131|-1UQG0 2q3C0 24n0 wG10 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|11e5\",\"America/Metlakatla|LMT LMT PST PWT PPT PDT AKST AKDT|-fd.G 8K.i 80 70 70 70 90 80|0123425252525252525252525252525252526767672676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-48Pzs.L 1jVwf.5 1EX1d.G 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2\",\"America/Mexico_City|LMT MST CST MDT CDT CWT|6A.A 70 60 60 50 50|012131242425242424242424242424242424242424242424242424242424242424242|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|20e6\",\"America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mxUf.k 2LHcf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2\",\"America/Moncton|LMT EST AST ADT AWT APT|4j.8 50 40 30 30 30|0123232323232323232323245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3txvE.Q J4ME.Q CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3\",\"America/Monterrey|LMT MST CST MDT CDT|6F.g 70 60 60 50|012131242424242424242424242424242424242424242424242424242424242|-1UQG0 dep0 8lz0 16p0 11z0 1dd0 2gmp0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|41e5\",\"America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5\",\"America/Toronto|LMT EST EDT EWT EPT|5h.w 50 40 40 40|012121212121212121212121212121212121212121212123412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-32B6G.s UFdG.s 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1qL0 11B0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5\",\"America/New_York|LMT EST EDT EWT EPT|4U.2 50 40 40 40|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFH0 1nEe0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6\",\"America/Nome|LMT LMT NST NWT NPT BST BDT YST AKST AKDT|-cW.m b1.C b0 a0 a0 b0 a0 90 90 80|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVyu.p 1EX1W.m 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2\",\"America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2\",\"America/North_Dakota/Beulah|LMT MST MDT MWT MPT CST CDT|6L.7 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|\",\"America/North_Dakota/Center|LMT MST MDT MWT MPT CST CDT|6J.c 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|\",\"America/North_Dakota/New_Salem|LMT MST MDT MWT MPT CST CDT|6J.D 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212121212121212121212121212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|\",\"America/Ojinaga|LMT MST CST MDT CDT|6V.E 70 60 60 50|0121312424231313131313131313131313131313131313131313131313132424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1wn0 Rc0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3\",\"America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4\",\"America/Port-au-Prince|LMT PPMT EST EDT|4N.k 4N 50 40|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLva.E 15RLX.E 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5\",\"America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4\",\"America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4\",\"America/Punta_Arenas|LMT SMT -05 -04 -03|4H.E 4G.J 50 40 30|01213132323232323232343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLvg.k MJbX.5 fJAh.f 5knG.J 1Vzh.f jRAG.J 1pbh.f 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|\",\"America/Winnipeg|LMT CST CDT CWT CPT|6s.A 60 50 50 50|0121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3kLtv.o 1a3bv.o WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4\",\"America/Rankin_Inlet|-00 CST CDT EST|0 60 50 50|01212121212121212121212121212121212121212121212121212121212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-vDc0 Bjk0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2\",\"America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5\",\"America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4\",\"America/Resolute|-00 CST CDT EST|0 60 50 50|01212121212121212121212121212121212121212121212121212121212321212121212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-SnA0 103I0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229\",\"America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4\",\"America/Santiago|LMT SMT -05 -04 -03|4G.J 4G.J 50 40 30|0121313232323232323432343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLvh.f MJc0 fJAh.f 5knG.J 1Vzh.f jRAG.J 1pbh.f 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 hX0 1q10 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0|62e5\",\"America/Santo_Domingo|LMT SDMT EST EDT -0430 AST|4D.A 4E 50 40 4u 40|012324242424242525|-3eLvk.o 1Jic0.o 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5\",\"America/Sao_Paulo|LMT -03 -02|36.s 30 20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|20e6\",\"America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|012132323232323232323232323232323232323232323232323232323232323232323232323232323232323232121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 2pA0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|452\",\"America/Sitka|LMT LMT PST PWT PPT PDT YST AKST AKDT|-eW.L 91.d 80 70 70 70 90 90 80|0123425252525252525252525252525252567878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787|-48Pzs.L 1jVwu 1EX0W.L 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2\",\"America/St_Johns|LMT NST NDT NST NDT NWT NPT NDDT|3u.Q 3u.Q 2u.Q 3u 2u 2u 2u 1u|012121212121212121212121212121212121213434343434343435634343434343434343434343434343434343434343434343434343434343434343434343434343434343437343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3tokt.8 1l020 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4\",\"America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3\",\"America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5\",\"America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656\",\"America/Vancouver|LMT PST PDT PWT PPT|8c.s 80 70 70 70|01213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tofL.w 1nspL.w 1in0 UGp0 8x10 iy0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5\",\"America/Whitehorse|LMT YST YDT YWT YPT YDDT PST PDT MST|90.c 90 80 80 80 70 80 70 70|0121213415167676767676767676767676767676767676767676767676767676767676767676767676767676767678|-2MSeX.M GWpX.M 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 LA0 ytd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|23e3\",\"America/Yakutat|LMT LMT YST YWT YPT YDT AKST AKDT|-eF.5 9i.T 90 80 80 80 90 80|0123425252525252525252525252525252526767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-48Pzs.L 1jVwL.G 1EX1F.5 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642\",\"Antarctica/Casey|-00 +08 +11|0 -80 -b0|012121212121212121|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10 1o30 14k0 1kr0 12l0 1o01 14kX 1lf1 14kX 1lf1 13bX|10\",\"Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70\",\"Pacific/Port_Moresby|LMT PMMT +10|-9M.E -9M.w -a0|012|-3D8VM.E AvA0.8|25e4\",\"Antarctica/Macquarie|-00 AEST AEDT|0 -a0 -b0|0121012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2OPc0 Fb40 1a00 4SK0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 3Co0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|1\",\"Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60\",\"Pacific/Auckland|LMT NZMT NZST NZST NZDT|-bD.4 -bu -cu -c0 -d0|012131313131313131313131313134343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-46jLD.4 2nEO9.4 Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00|14e5\",\"Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40\",\"Antarctica/Rothera|-00 -03|0 30|01|gOo0|130\",\"Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5\",\"Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|40\",\"Antarctica/Vostok|-00 +07 +05|0 -70 -50|01012|-tjA0 1rWh0 1Nj0 1aTv0|25\",\"Europe/Berlin|LMT CET CEST CEMT|-R.s -10 -20 -30|012121212121212321212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-36RcR.s UbWR.s 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|41e5\",\"Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|0123232323232323232323212323232323232323232323232321|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 L4m0|15e5\",\"Asia/Amman|LMT EET EEST +03|-2n.I -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212123|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 LA0 1C00|25e5\",\"Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3\",\"Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4\",\"Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4\",\"Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4\",\"Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|\",\"Asia/Baghdad|LMT BMT +03 +04|-2V.E -2V.A -30 -40|0123232323232323232323232323232323232323232323232323232|-3eLCV.E 18ao0.4 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5\",\"Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4\",\"Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5\",\"Asia/Bangkok|LMT BMT +07|-6G.4 -6G.4 -70|012|-3D8SG.4 1C000|15e6\",\"Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|\",\"Asia/Beirut|LMT EET EEST|-2m -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3D8Om 1BWom 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|22e5\",\"Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4\",\"Asia/Brunei|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|42e4\",\"Asia/Kolkata|LMT HMT MMT IST +0630|-5R.s -5R.k -5l.a -5u -6u|01234343|-4Fg5R.s BKo0.8 1rDcw.a 1r2LP.a 1un0 HB0 7zX0|15e6\",\"Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4\",\"Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5\",\"Asia/Shanghai|LMT CST CDT|-85.H -80 -90|012121212121212121212121212121|-2M0U5.H Iuo5.H 18n0 OjB0 Rz0 11d0 1wL0 A10 8HX0 1G10 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 aL0 1tU30 Rb0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6\",\"Asia/Colombo|LMT MMT +0530 +06 +0630|-5j.o -5j.w -5u -60 -6u|012342432|-3D8Rj.o 13inX.Q 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5\",\"Asia/Dhaka|LMT HMT +0630 +0530 +06 +07|-61.E -5R.k -6u -5u -60 -70|01232454|-3eLG1.E 26008.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6\",\"Asia/Damascus|LMT EET EEST +03|-2p.c -20 -30 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212123|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0|26e5\",\"Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le80 1dnX0 1nfA0 Xld0|19e4\",\"Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5\",\"Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4\",\"Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|\",\"Asia/Gaza|LMT EET EEST IST IDT|-2h.Q -20 -30 -20 -30|0121212121212121212121212121212121234343434343434343434343434343431212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBCh.Q 1Azeh.Q MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 XA0 1qp0 1cN0 1cL0 1a10 1fz0 17d0 1in0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1lb0 14p0 1in0 17d0 1cL0 1cN0 19X0 1fB0 14n0 jB0 2L0 11B0 WL0 gN0 8n0 11B0 TX0 gN0 bb0 11B0 On0 jB0 dX0 11B0 Lz0 gN0 mn0 WN0 IL0 gN0 pb0 WN0 Db0 jB0 rX0 11B0 xz0 gN0 xz0 11B0 rX0 jB0 An0 11B0 pb0 gN0 IL0 WN0 mn0 gN0 Lz0 WN0 gL0 jB0 On0 11B0 bb0 gN0 TX0 11B0 5z0 jB0 WL0 11B0 2L0 jB0 11z0 1ip0 19X0 1cN0 1cL0 17d0 1in0 14p0 1lb0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1nX0 14p0 1in0 17d0 1fz0 1a10 19X0 1fB0 17b0 gN0 2L0 WN0 14n0 gN0 5z0 WN0 WL0 jB0 8n0 11B0 Rb0 gN0 dX0 11B0 Lz0 jB0 gL0 11B0 IL0 jB0 mn0 WN0 FX0 gN0 rX0 WN0 An0 jB0 uL0 11B0 uL0 gN0 An0 11B0 rX0 gN0 Db0 11B0 mn0 jB0 FX0 11B0 jz0 gN0 On0 WN0 dX0 jB0 Rb0 WN0 bb0 jB0 TX0 11B0 5z0 gN0 11z0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|18e5\",\"Asia/Hebron|LMT EET EEST IST IDT|-2k.n -20 -30 -20 -30|012121212121212121212121212121212123434343434343434343434343434343121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBCk.n 1Azek.n MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 XA0 1qp0 1cN0 1cL0 1a10 1fz0 17d0 1in0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1lb0 14p0 1in0 17d0 1cL0 1cN0 19X0 1fB0 14n0 jB0 2L0 11B0 WL0 gN0 8n0 11B0 TX0 gN0 bb0 11B0 On0 jB0 dX0 11B0 Lz0 gN0 mn0 WN0 IL0 gN0 pb0 WN0 Db0 jB0 rX0 11B0 xz0 gN0 xz0 11B0 rX0 jB0 An0 11B0 pb0 gN0 IL0 WN0 mn0 gN0 Lz0 WN0 gL0 jB0 On0 11B0 bb0 gN0 TX0 11B0 5z0 jB0 WL0 11B0 2L0 jB0 11z0 1ip0 19X0 1cN0 1cL0 17d0 1in0 14p0 1lb0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1nX0 14p0 1in0 17d0 1fz0 1a10 19X0 1fB0 17b0 gN0 2L0 WN0 14n0 gN0 5z0 WN0 WL0 jB0 8n0 11B0 Rb0 gN0 dX0 11B0 Lz0 jB0 gL0 11B0 IL0 jB0 mn0 WN0 FX0 gN0 rX0 WN0 An0 jB0 uL0 11B0 uL0 gN0 An0 11B0 rX0 gN0 Db0 11B0 mn0 jB0 FX0 11B0 jz0 gN0 On0 WN0 dX0 jB0 Rb0 WN0 bb0 jB0 TX0 11B0 5z0 gN0 11z0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|25e4\",\"Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.u -76.u -70 -80 -90|0123423232|-2yC76.u bK00 1h7b6.u 5lz0 18o0 3Oq0 k5c0 aVX0 BAM0|90e5\",\"Asia/Hong_Kong|LMT HKT HKST HKWT JST|-7A.G -80 -90 -8u -90|0123412121212121212121212121212121212121212121212121212121212121212121|-2CFH0 1taO0 Hc0 xUu 9tBu 11z0 1tDu Rc0 1wo0 11A0 1cM0 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5\",\"Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3\",\"Asia/Irkutsk|LMT IMT +07 +08 +09|-6V.5 -6V.5 -70 -80 -90|012343434343434343434343234343434343434343434343434343434343434343|-3D8SV.5 1Bxc0 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4\",\"Europe/Istanbul|LMT IMT EET EEST +03 +04|-1T.Q -1U.U -20 -30 -30 -40|01232323232323232323232323232323232323232323232345423232323232323232323232323232323232323232323232323232323232323234|-3D8NT.Q 1ePXW.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSN0 CL0 mp0 1Vz0 1gN0 8yn0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1ip0 19X0 1ip0 17b0 qdB0 38L0 1jd0 Tz0 l6O0 11A0 WN0 1qL0 TB0 1tX0 U10 1tz0 11B0 1in0 17d0 z90 cne0 pb0 2Cp0 1800 14o0 1dc0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6\",\"Asia/Jakarta|LMT BMT +0720 +0730 +09 +08 WIB|-77.c -77.c -7k -7u -90 -80 -70|012343536|-49jH7.c 2hiLL.c luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6\",\"Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4\",\"Asia/Jerusalem|LMT JMT IST IDT IDDT|-2k.S -2k.E -20 -30 -40|012323232323232432323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3D8Ok.S 1wvA0.e SyOk.E MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 3LA0 Eo0 oo0 1co0 1dA0 16o0 10M0 1jc0 1tA0 14o0 1cM0 1a00 11A0 1Nc0 Ao0 1Nc0 Ao0 1Ko0 LA0 1o00 WM0 EQK0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0|81e4\",\"Asia/Kabul|LMT +04 +0430|-4A.M -40 -4u|012|-3eLEA.M 2dTcA.M|46e5\",\"Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4\",\"Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6\",\"Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5\",\"Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5\",\"Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2\",\"Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5\",\"Asia/Kuala_Lumpur|LMT SMT +07 +0720 +0730 +09 +08|-6T.p -6T.p -70 -7k -7u -90 -80|01234546|-2M0ST.p aIM0 17anT.p l5XE 17bO 8Fyu 1so10|71e5\",\"Asia/Macau|LMT CST +09 +10 CDT|-7y.a -80 -90 -a0 -90|012323214141414141414141414141414141414141414141414141414141414141414141|-2CFHy.a 1uqKy.a PX0 1kn0 15B0 11b0 4Qq0 1oM0 11c0 1ko0 1u00 11A0 1cM0 11c0 1o00 11A0 1o00 11A0 1oo0 1400 1o00 11A0 1o00 U00 1tA0 U00 1wo0 Rc0 1wru U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cK0 1cO0 1cK0 1cO0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|57e4\",\"Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3\",\"Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5\",\"Asia/Manila|LMT LMT PST PDT JST|fU.8 -83.Q -80 -90 -90|012323432323232|-54m83.Q 2d8A3.Q 1urM0 un0 bW10 nb0 7qo0 1MM0 klB0 lz0 TwN0 1bb0 uNB0 rz0|24e6\",\"Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|32e4\",\"Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4\",\"Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5\",\"Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5\",\"Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4\",\"Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4\",\"Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BA0|29e5\",\"Asia/Qostanay|LMT +04 +05 +06|-4e.s -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc4e.s eUoe.s 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 Mv90|\",\"Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|01232323232323232323232323232323232323232323232|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 zQl0|73e4\",\"Asia/Rangoon|LMT RMT +0630 +09|-6o.L -6o.L -6u -90|01232|-3D8So.L 1BnA0 SmnS.L 7j9u|48e5\",\"Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4\",\"Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4\",\"Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -a0 -9u|012343434343151515151515134343|-2um8r.Q 97XV.Q 1m1zu 6CM0 Fz0 1kN0 14n0 1kN0 14L0 1zd0 On0 69B0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6\",\"Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2\",\"Asia/Taipei|LMT CST JST CDT|-86 -80 -90 -90|012131313131313131313131313131313131313131|-30bk6 1FDc6 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5\",\"Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5\",\"Asia/Tbilisi|LMT TBMT +03 +04 +05|-2X.b -2X.b -30 -40 -50|01234343434343434343434323232343434343434343434323|-3D8OX.b 1LUM0 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5\",\"Asia/Tehran|LMT TMT +0330 +0430 +04 +05|-3p.I -3p.I -3u -4u -40 -50|012345423232323232323232323232323232323232323232323232323232323232323232|-2btDp.I Llc0 1FHaT.I 1pc0 120u Rc0 Dc0 1iMu JX0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0|14e6\",\"Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3\",\"Asia/Tokyo|LMT JST JDT|-9i.X -90 -a0|0121212121|-3jE90 2qSo0 Rc0 1lc0 14o0 1zc0 Oo0 1zc0 Oo0|38e6\",\"Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5\",\"Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2\",\"Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4\",\"Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4\",\"Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5\",\"Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5\",\"Atlantic/Azores|LMT HMT -02 -01 +00 WET WEST|1G.E 1S.w 20 10 0 0 -10|012323232323232323232323232323232323232323232343234323432343232323232323232323232323232323232323232323434343434343434343434356434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3tomh.k 18aoh.k aPX0 Sp0 M00 1vb0 SN0 1vb0 SN0 1vb0 Td0 1vb0 SN0 1vb0 6600 18o0 3I00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1uo0 1c00 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 CT90 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 Ap0 An0 wo0 Eo0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|25e4\",\"Atlantic/Bermuda|LMT BMT BST AST ADT|4j.i 4j.i 3j.i 40 30|0121213434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3eLvE.G 16mo0 1bb0 1i10 11X0 ru30 thbE.G 1PX0 11B0 1tz0 Rd0 1zb0 Op0 1zb0 3I10 Lz0 1EN0 FX0 1HB0 FX0 1Kp0 Db0 1Kp0 Db0 1Kp0 FX0 93d0 11z0 GAp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3\",\"Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|54e4\",\"Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4\",\"Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|49e3\",\"Atlantic/Madeira|LMT FMT -01 +00 +01 WET WEST|17.A 17.A 10 0 -10 0 -10|01232323232323232323232323232323232323232323234323432343234323232323232323232323232323232323232323232356565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tomQ.o 18anQ.o aPX0 Sp0 M00 1vb0 SN0 1vb0 SN0 1vb0 Td0 1vb0 SN0 1vb0 6600 18o0 3I00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1uo0 1c00 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 BJ90 1a00 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e4\",\"Atlantic/South_Georgia|LMT -02|2q.8 20|01|-3eLxx.Q|30\",\"Atlantic/Stanley|LMT SMT -04 -03 -02|3P.o 3P.o 40 30 20|0123232323232323434323232323232323232323232323232323232323232323232323|-3eLw8.A S200 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2\",\"Australia/Sydney|LMT AEST AEDT|-a4.Q -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-32oW4.Q RlC4.Q xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|40e5\",\"Australia/Adelaide|LMT ACST ACST ACDT|-9e.k -90 -9u -au|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-32oVe.k ak0e.k H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|11e5\",\"Australia/Brisbane|LMT AEST AEDT|-ac.8 -a0 -b0|012121212121212121|-32Bmc.8 Ry2c.8 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5\",\"Australia/Broken_Hill|LMT AEST ACST ACST ACDT|-9p.M -a0 -90 -9u -au|0123434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-32oVp.M 3Lzp.M 6wp0 H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|18e3\",\"Australia/Hobart|LMT AEST AEDT|-9N.g -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-3109N.g Pk1N.g 1a00 1qM0 Oo0 1zc0 Oo0 TAo0 yM0 1cM0 1cM0 1fA0 1a00 VfA0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|21e4\",\"Australia/Darwin|LMT ACST ACST ACDT|-8H.k -90 -9u -au|01232323232|-32oUH.k ajXH.k H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00|12e4\",\"Australia/Eucla|LMT +0845 +0945|-8z.s -8J -9J|01212121212121212121|-30nIz.s PkpO.s xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368\",\"Australia/Lord_Howe|LMT AEST +1030 +1130 +11|-aA.k -a0 -au -bu -b0|01232323232424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424|-32oWA.k 3tzAA.k 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu|347\",\"Australia/Lindeman|LMT AEST AEDT|-9T.U -a0 -b0|0121212121212121212121|-32BlT.U Ry1T.U xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10\",\"Australia/Melbourne|LMT AEST AEDT|-9D.Q -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-32oVD.Q RlBD.Q xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|39e5\",\"Australia/Perth|LMT AWST AWDT|-7H.o -80 -90|01212121212121212121|-30nHH.o PkpH.o xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5\",\"Europe/Brussels|LMT BMT WET CET CEST WEST|-h.u -h.u 0 -10 -20 -10|012343434325252525252525252525252525252525252525252525434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3D8Mh.u u1Ah.u SO00 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|21e5\",\"Pacific/Easter|LMT EMT -07 -06 -05|7h.s 7h.s 70 60 50|0123232323232323232323232323234343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLsG.w 1HRc0 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0|30e2\",\"Europe/Athens|LMT AMT EET EEST CEST CET|-1y.Q -1y.Q -20 -30 -20 -10|0123234545232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-30SNy.Q OMM1 CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|35e5\",\"Europe/Dublin|LMT DMT IST GMT BST IST|p.l p.l -y.D 0 -10 -10|012343434343435353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353|-3BHby.D 1ra20 Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5\",\"Etc/GMT-0|GMT|0|0||\",\"Etc/GMT-1|+01|-10|0||\",\"Etc/GMT-10|+10|-a0|0||\",\"Etc/GMT-11|+11|-b0|0||\",\"Etc/GMT-12|+12|-c0|0||\",\"Etc/GMT-13|+13|-d0|0||\",\"Etc/GMT-14|+14|-e0|0||\",\"Etc/GMT-2|+02|-20|0||\",\"Etc/GMT-3|+03|-30|0||\",\"Etc/GMT-4|+04|-40|0||\",\"Etc/GMT-5|+05|-50|0||\",\"Etc/GMT-6|+06|-60|0||\",\"Etc/GMT-7|+07|-70|0||\",\"Etc/GMT-8|+08|-80|0||\",\"Etc/GMT-9|+09|-90|0||\",\"Etc/GMT+1|-01|10|0||\",\"Etc/GMT+10|-10|a0|0||\",\"Etc/GMT+11|-11|b0|0||\",\"Etc/GMT+12|-12|c0|0||\",\"Etc/GMT+2|-02|20|0||\",\"Etc/GMT+3|-03|30|0||\",\"Etc/GMT+4|-04|40|0||\",\"Etc/GMT+5|-05|50|0||\",\"Etc/GMT+6|-06|60|0||\",\"Etc/GMT+7|-07|70|0||\",\"Etc/GMT+8|-08|80|0||\",\"Etc/GMT+9|-09|90|0||\",\"Etc/UTC|UTC|0|0||\",\"Europe/Andorra|LMT WET CET CEST|-6.4 0 -10 -20|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2M0M6.4 1Pnc6.4 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|79e3\",\"Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|10e5\",\"Europe/London|LMT GMT BST BDST|1.f 0 -10 -20|01212121212121212121212121212121212121212121212121232323232321212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-4VgnW.J 2KHdW.J Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|10e6\",\"Europe/Belgrade|LMT CET CEST|-1m -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3topm 2juLm 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5\",\"Europe/Prague|LMT PMT CET CEST GMT|-V.I -V.I -10 -20 0|0123232323232323232423232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4QbAV.I 1FDc0 XPaV.I 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|13e5\",\"Europe/Bucharest|LMT BMT EET EEST|-1I.o -1I.o -20 -30|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3awpI.o 1AU00 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|19e5\",\"Europe/Budapest|LMT CET CEST|-1g.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3cK1g.k 124Lg.k 11d0 1iO0 11A0 1o00 11A0 1oo0 11c0 1lc0 17c0 O1V0 3Nf0 WM0 1fA0 1cM0 1cM0 1oJ0 1dd0 1020 1fX0 1cp0 1cM0 1cM0 1cM0 1fA0 1a00 bhy0 Rb0 1wr0 Rc0 1C00 LA0 1C00 LA0 SNW0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cO0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e5\",\"Europe/Zurich|LMT BMT CET CEST|-y.8 -t.K -10 -20|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4HyMy.8 1Dw04.m 1SfAt.K 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|38e4\",\"Europe/Chisinau|LMT CMT BMT EET EEST CEST CET MSK MSD|-1T.k -1T -1I.o -20 -30 -20 -10 -30 -40|0123434343434343434345656578787878787878787878434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3D8NT.k 1wNA0.k wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|67e4\",\"Europe/Gibraltar|LMT GMT BST BDST CET CEST|l.o 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123232323232121232121212121212121212145454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-3BHbC.A 1ra1C.A Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|30e3\",\"Europe/Helsinki|LMT HMT EET EEST|-1D.N -1D.N -20 -30|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3H0ND.N 1Iu00 OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5\",\"Europe/Kaliningrad|LMT CET CEST EET EEST MSK MSD +03|-1m -10 -20 -20 -30 -30 -40 -30|012121212121212343565656565656565654343434343434343434343434343434343434343434373|-36Rdm UbXm 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 390 7A0 1en0 12N0 1pbb0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4\",\"Europe/Kiev|LMT KMT EET MSK CEST CET MSD EEST|-22.4 -22.4 -20 -30 -20 -10 -40 -30|01234545363636363636363636367272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-3D8O2.4 1LUM0 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o10 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|34e5\",\"Europe/Kirov|LMT +03 +04 +05 MSD MSK MSK|-3i.M -30 -40 -50 -40 -30 -40|0123232323232323232454524545454545454545454545454545454545454565|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 2pz0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4\",\"Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121212124121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 M00 1vb0 SN0 1vb0 SN0 1vb0 Td0 1vb0 SN0 1vb0 6600 18o0 3I00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1uo0 1c00 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 oiK0 1cM0 1cM0 1fB0 1cM0 1cM0 1cM0 1fA0 1a00 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5\",\"Europe/Madrid|LMT WET WEST WEMT CET CEST|e.I 0 -10 -20 -10 -20|0121212121212121212321454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2M0M0 G5z0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|62e5\",\"Europe/Malta|LMT CET CEST|-W.4 -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-35rcW.4 SXzW.4 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|42e4\",\"Europe/Minsk|LMT MMT EET MSK CEST CET MSD EEST +03|-1O.g -1O -20 -30 -20 -10 -40 -30 -30|012345454363636363636363636372727272727272727272727272727272727272728|-3D8NO.g 1LUM0.g eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5\",\"Europe/Paris|LMT PMT WET WEST CEST CET WEMT|-9.l -9.l 0 -10 -20 -10 -20|01232323232323232323232323232323232323232323232323234545463654545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-3bQ09.l MDA0 cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|11e6\",\"Europe/Moscow|LMT MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|01232434565756865656565656565656565698656565656565656565656565656565656565656a6|-3D8Ou.h 1sQM0 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6\",\"Europe/Riga|LMT RMT LST EET MSK CEST CET MSD EEST|-1A.y -1A.y -2A.y -20 -30 -20 -10 -40 -30|0121213456565647474747474747474838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383|-3D8NA.y 1xde0 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|64e4\",\"Europe/Rome|LMT RMT CET CEST|-N.U -N.U -10 -20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4aU0N.U 15snN.U T000 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|39e5\",\"Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5\",\"Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810|\",\"Europe/Simferopol|LMT SMT EET MSK CEST CET MSD EEST MSK|-2g.o -2g -20 -30 -20 -10 -40 -30 -40|0123454543636363636363636363272727636363727272727272727272727272727272727283|-3D8Og.o 1LUM0.o eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eN0 1cM0 1cM0 1cM0 1cM0 dV0 WO0 1cM0 1cM0 1fy0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4\",\"Europe/Sofia|LMT IMT EET CET CEST EEST|-1x.g -1U.U -20 -10 -20 -30|0123434325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-3D8Nx.g AiLA.k 1UFeU.U WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5\",\"Europe/Tallinn|LMT TMT CET CEST EET MSK MSD EEST|-1D -1D -10 -20 -20 -30 -40 -30|0123214532323565656565656565657474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474|-3D8ND 1wI00 teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|41e4\",\"Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|42e4\",\"Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|13e5\",\"Europe/Vienna|LMT CET CEST|-15.l -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-36Rd5.l UbX5.l 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1ao0 1co0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|18e5\",\"Europe/Vilnius|LMT WMT KMT CET EET MSK CEST MSD EEST|-1F.g -1o -1z.A -10 -20 -30 -20 -40 -30|0123435636365757575757575757584848484848484848463648484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484|-3D8NF.g 1u5Ah.g 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|54e4\",\"Europe/Volgograd|LMT +03 +04 +05 MSD MSK MSK|-2V.E -30 -40 -50 -40 -30 -40|012323232323232324545452454545454545454545454545454545454545456525|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1fA0 1cM0 2pz0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 9Jd0 5gn0|10e5\",\"Europe/Warsaw|LMT WMT CET CEST EET EEST|-1o -1o -10 -20 -20 -30|0123232345423232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3D8No 1qDA0 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e5\",\"Pacific/Honolulu|LMT HST HDT HWT HPT HST|av.q au 9u 9u 9u a0|01213415|-3061s.y 1uMdW.y 8x0 lef0 8wWu iAu 46p0|37e4\",\"Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2\",\"Indian/Maldives|LMT MMT +05|-4S -4S -50|012|-3D8QS 3eLA0|35e4\",\"Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4\",\"Pacific/Kwajalein|LMT +11 +10 +09 -12 +12|-b9.k -b0 -a0 -90 c0 -c0|0123145|-2M0X9.k 1rDA9.k akp0 6Up0 12ry0 Wan0|14e3\",\"Pacific/Chatham|LMT +1215 +1245 +1345|-cd.M -cf -cJ -dJ|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-46jMd.M 37RbW.M 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00|600\",\"Pacific/Apia|LMT LMT -1130 -11 -10 +14 +13|-cx.4 bq.U bu b0 a0 -e0 -d0|012343456565656565656565656|-38Fox.4 J1A0 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0|37e3\",\"Pacific/Bougainville|LMT PMMT +10 +09 +11|-am.g -9M.w -a0 -90 -b0|012324|-3D8Wm.g AvAx.I 1TCLM.w 7CN0 2MQp0|18e4\",\"Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|012121212121212121212121|-2l9nd.g 2uNXd.g Dc0 n610 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3\",\"Pacific/Enderbury|-00 -12 -11 +13|0 c0 b0 -d0|0123|-1iIo0 1GsA0 B7X0|1\",\"Pacific/Fakaofo|LMT -11 +13|bo.U b0 -d0|012|-2M0Az.4 4ufXz.4|483\",\"Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|012121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 20o0 pc0 2hc0 bc0|88e4\",\"Pacific/Tarawa|LMT +12|-bw.4 -c0|01|-2M0Xw.4|29e3\",\"Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3\",\"Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125\",\"Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4\",\"Pacific/Guam|LMT LMT GST +09 GDT ChST|el -9D -a0 -90 -b0 -a0|0123242424242424242425|-54m9D 2glc0 1DFbD 6pB0 AhB0 3QL0 g2p0 3p91 WOX rX0 1zd0 Rb0 1wp0 Rb0 5xd0 rX0 5sN0 zb1 1C0X On0 ULb0|17e4\",\"Pacific/Kiritimati|LMT -1040 -10 +14|at.k aE a0 -e0|0123|-2M0Bu.E 3bIMa.E B7Xk|51e2\",\"Pacific/Kosrae|LMT LMT +11 +09 +10 +12|d8.4 -aP.U -b0 -90 -a0 -c0|0123243252|-54maP.U 2glc0 xsnP.U axC0 HBy0 akp0 axd0 WOK0 1bdz0|66e2\",\"Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2\",\"Pacific/Pago_Pago|LMT LMT SST|-cB.c bm.M b0|012|-38FoB.c J1A0|37e2\",\"Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E QCnB.E 7mqu 1lnbu|10e3\",\"Pacific/Niue|LMT -1120 -11|bj.E bk b0|012|-FScE.k suo0.k|12e2\",\"Pacific/Norfolk|LMT +1112 +1130 +1230 +11 +12|-bb.Q -bc -bu -cu -b0 -c0|0123245454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2M0Xb.Q 21ILX.Q W01G Oo0 1COo0 9Jcu 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|25e4\",\"Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3\",\"Pacific/Palau|LMT LMT +09|f2.4 -8V.U -90|012|-54m8V.U 2glc0|21e3\",\"Pacific/Pitcairn|LMT -0830 -08|8E.k 8u 80|012|-2M0Dj.E 3UVXN.E|56\",\"Pacific/Rarotonga|LMT LMT -1030 -0930 -10|-dk.U aD.4 au 9u a0|01234343434343434343434343434|-2Otpk.U 28zc0 13tbO.U IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3\",\"Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4\",\"Pacific/Tongatapu|LMT +1220 +13 +14|-cj.c -ck -d0 -e0|01232323232|-XbMj.c BgLX.c 1yndk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3\"],\"links\":[\"Africa/Abidjan|Africa/Accra\",\"Africa/Abidjan|Africa/Bamako\",\"Africa/Abidjan|Africa/Banjul\",\"Africa/Abidjan|Africa/Conakry\",\"Africa/Abidjan|Africa/Dakar\",\"Africa/Abidjan|Africa/Freetown\",\"Africa/Abidjan|Africa/Lome\",\"Africa/Abidjan|Africa/Nouakchott\",\"Africa/Abidjan|Africa/Ouagadougou\",\"Africa/Abidjan|Africa/Timbuktu\",\"Africa/Abidjan|Atlantic/Reykjavik\",\"Africa/Abidjan|Atlantic/St_Helena\",\"Africa/Abidjan|Iceland\",\"Africa/Cairo|Egypt\",\"Africa/Johannesburg|Africa/Maseru\",\"Africa/Johannesburg|Africa/Mbabane\",\"Africa/Lagos|Africa/Bangui\",\"Africa/Lagos|Africa/Brazzaville\",\"Africa/Lagos|Africa/Douala\",\"Africa/Lagos|Africa/Kinshasa\",\"Africa/Lagos|Africa/Libreville\",\"Africa/Lagos|Africa/Luanda\",\"Africa/Lagos|Africa/Malabo\",\"Africa/Lagos|Africa/Niamey\",\"Africa/Lagos|Africa/Porto-Novo\",\"Africa/Maputo|Africa/Blantyre\",\"Africa/Maputo|Africa/Bujumbura\",\"Africa/Maputo|Africa/Gaborone\",\"Africa/Maputo|Africa/Harare\",\"Africa/Maputo|Africa/Kigali\",\"Africa/Maputo|Africa/Lubumbashi\",\"Africa/Maputo|Africa/Lusaka\",\"Africa/Nairobi|Africa/Addis_Ababa\",\"Africa/Nairobi|Africa/Asmara\",\"Africa/Nairobi|Africa/Asmera\",\"Africa/Nairobi|Africa/Dar_es_Salaam\",\"Africa/Nairobi|Africa/Djibouti\",\"Africa/Nairobi|Africa/Kampala\",\"Africa/Nairobi|Africa/Mogadishu\",\"Africa/Nairobi|Indian/Antananarivo\",\"Africa/Nairobi|Indian/Comoro\",\"Africa/Nairobi|Indian/Mayotte\",\"Africa/Tripoli|Libya\",\"America/Adak|America/Atka\",\"America/Adak|US/Aleutian\",\"America/Anchorage|US/Alaska\",\"America/Argentina/Buenos_Aires|America/Buenos_Aires\",\"America/Argentina/Catamarca|America/Argentina/ComodRivadavia\",\"America/Argentina/Catamarca|America/Catamarca\",\"America/Argentina/Cordoba|America/Cordoba\",\"America/Argentina/Cordoba|America/Rosario\",\"America/Argentina/Jujuy|America/Jujuy\",\"America/Argentina/Mendoza|America/Mendoza\",\"America/Chicago|CST6CDT\",\"America/Chicago|US/Central\",\"America/Denver|America/Shiprock\",\"America/Denver|MST7MDT\",\"America/Denver|Navajo\",\"America/Denver|US/Mountain\",\"America/Detroit|US/Michigan\",\"America/Edmonton|America/Yellowknife\",\"America/Edmonton|Canada/Mountain\",\"America/Fort_Wayne|America/Indiana/Indianapolis\",\"America/Fort_Wayne|America/Indianapolis\",\"America/Fort_Wayne|US/East-Indiana\",\"America/Godthab|America/Nuuk\",\"America/Halifax|Canada/Atlantic\",\"America/Havana|Cuba\",\"America/Indiana/Knox|America/Knox_IN\",\"America/Indiana/Knox|US/Indiana-Starke\",\"America/Iqaluit|America/Pangnirtung\",\"America/Jamaica|Jamaica\",\"America/Kentucky/Louisville|America/Louisville\",\"America/Los_Angeles|PST8PDT\",\"America/Los_Angeles|US/Pacific\",\"America/Manaus|Brazil/West\",\"America/Mazatlan|Mexico/BajaSur\",\"America/Mexico_City|Mexico/General\",\"America/New_York|EST5EDT\",\"America/New_York|US/Eastern\",\"America/Noronha|Brazil/DeNoronha\",\"America/Panama|America/Atikokan\",\"America/Panama|America/Cayman\",\"America/Panama|America/Coral_Harbour\",\"America/Panama|EST\",\"America/Phoenix|America/Creston\",\"America/Phoenix|MST\",\"America/Phoenix|US/Arizona\",\"America/Puerto_Rico|America/Anguilla\",\"America/Puerto_Rico|America/Antigua\",\"America/Puerto_Rico|America/Aruba\",\"America/Puerto_Rico|America/Blanc-Sablon\",\"America/Puerto_Rico|America/Curacao\",\"America/Puerto_Rico|America/Dominica\",\"America/Puerto_Rico|America/Grenada\",\"America/Puerto_Rico|America/Guadeloupe\",\"America/Puerto_Rico|America/Kralendijk\",\"America/Puerto_Rico|America/Lower_Princes\",\"America/Puerto_Rico|America/Marigot\",\"America/Puerto_Rico|America/Montserrat\",\"America/Puerto_Rico|America/Port_of_Spain\",\"America/Puerto_Rico|America/St_Barthelemy\",\"America/Puerto_Rico|America/St_Kitts\",\"America/Puerto_Rico|America/St_Lucia\",\"America/Puerto_Rico|America/St_Thomas\",\"America/Puerto_Rico|America/St_Vincent\",\"America/Puerto_Rico|America/Tortola\",\"America/Puerto_Rico|America/Virgin\",\"America/Regina|Canada/Saskatchewan\",\"America/Rio_Branco|America/Porto_Acre\",\"America/Rio_Branco|Brazil/Acre\",\"America/Santiago|Chile/Continental\",\"America/Sao_Paulo|Brazil/East\",\"America/St_Johns|Canada/Newfoundland\",\"America/Tijuana|America/Ensenada\",\"America/Tijuana|America/Santa_Isabel\",\"America/Tijuana|Mexico/BajaNorte\",\"America/Toronto|America/Montreal\",\"America/Toronto|America/Nassau\",\"America/Toronto|America/Nipigon\",\"America/Toronto|America/Thunder_Bay\",\"America/Toronto|Canada/Eastern\",\"America/Vancouver|Canada/Pacific\",\"America/Whitehorse|Canada/Yukon\",\"America/Winnipeg|America/Rainy_River\",\"America/Winnipeg|Canada/Central\",\"Asia/Ashgabat|Asia/Ashkhabad\",\"Asia/Bangkok|Asia/Phnom_Penh\",\"Asia/Bangkok|Asia/Vientiane\",\"Asia/Bangkok|Indian/Christmas\",\"Asia/Brunei|Asia/Kuching\",\"Asia/Dhaka|Asia/Dacca\",\"Asia/Dubai|Asia/Muscat\",\"Asia/Dubai|Indian/Mahe\",\"Asia/Dubai|Indian/Reunion\",\"Asia/Ho_Chi_Minh|Asia/Saigon\",\"Asia/Hong_Kong|Hongkong\",\"Asia/Jerusalem|Asia/Tel_Aviv\",\"Asia/Jerusalem|Israel\",\"Asia/Kathmandu|Asia/Katmandu\",\"Asia/Kolkata|Asia/Calcutta\",\"Asia/Kuala_Lumpur|Asia/Singapore\",\"Asia/Kuala_Lumpur|Singapore\",\"Asia/Macau|Asia/Macao\",\"Asia/Makassar|Asia/Ujung_Pandang\",\"Asia/Nicosia|Europe/Nicosia\",\"Asia/Qatar|Asia/Bahrain\",\"Asia/Rangoon|Asia/Yangon\",\"Asia/Rangoon|Indian/Cocos\",\"Asia/Riyadh|Antarctica/Syowa\",\"Asia/Riyadh|Asia/Aden\",\"Asia/Riyadh|Asia/Kuwait\",\"Asia/Seoul|ROK\",\"Asia/Shanghai|Asia/Chongqing\",\"Asia/Shanghai|Asia/Chungking\",\"Asia/Shanghai|Asia/Harbin\",\"Asia/Shanghai|PRC\",\"Asia/Taipei|ROC\",\"Asia/Tehran|Iran\",\"Asia/Thimphu|Asia/Thimbu\",\"Asia/Tokyo|Japan\",\"Asia/Ulaanbaatar|Asia/Choibalsan\",\"Asia/Ulaanbaatar|Asia/Ulan_Bator\",\"Asia/Urumqi|Asia/Kashgar\",\"Atlantic/Faroe|Atlantic/Faeroe\",\"Australia/Adelaide|Australia/South\",\"Australia/Brisbane|Australia/Queensland\",\"Australia/Broken_Hill|Australia/Yancowinna\",\"Australia/Darwin|Australia/North\",\"Australia/Hobart|Australia/Currie\",\"Australia/Hobart|Australia/Tasmania\",\"Australia/Lord_Howe|Australia/LHI\",\"Australia/Melbourne|Australia/Victoria\",\"Australia/Perth|Australia/West\",\"Australia/Sydney|Australia/ACT\",\"Australia/Sydney|Australia/Canberra\",\"Australia/Sydney|Australia/NSW\",\"Etc/GMT-0|Etc/GMT\",\"Etc/GMT-0|Etc/GMT+0\",\"Etc/GMT-0|Etc/GMT0\",\"Etc/GMT-0|Etc/Greenwich\",\"Etc/GMT-0|GMT\",\"Etc/GMT-0|GMT+0\",\"Etc/GMT-0|GMT-0\",\"Etc/GMT-0|GMT0\",\"Etc/GMT-0|Greenwich\",\"Etc/UTC|Etc/UCT\",\"Etc/UTC|Etc/Universal\",\"Etc/UTC|Etc/Zulu\",\"Etc/UTC|UCT\",\"Etc/UTC|UTC\",\"Etc/UTC|Universal\",\"Etc/UTC|Zulu\",\"Europe/Athens|EET\",\"Europe/Belgrade|Europe/Ljubljana\",\"Europe/Belgrade|Europe/Podgorica\",\"Europe/Belgrade|Europe/Sarajevo\",\"Europe/Belgrade|Europe/Skopje\",\"Europe/Belgrade|Europe/Zagreb\",\"Europe/Berlin|Arctic/Longyearbyen\",\"Europe/Berlin|Atlantic/Jan_Mayen\",\"Europe/Berlin|Europe/Copenhagen\",\"Europe/Berlin|Europe/Oslo\",\"Europe/Berlin|Europe/Stockholm\",\"Europe/Brussels|CET\",\"Europe/Brussels|Europe/Amsterdam\",\"Europe/Brussels|Europe/Luxembourg\",\"Europe/Brussels|MET\",\"Europe/Chisinau|Europe/Tiraspol\",\"Europe/Dublin|Eire\",\"Europe/Helsinki|Europe/Mariehamn\",\"Europe/Istanbul|Asia/Istanbul\",\"Europe/Istanbul|Turkey\",\"Europe/Kiev|Europe/Kyiv\",\"Europe/Kiev|Europe/Uzhgorod\",\"Europe/Kiev|Europe/Zaporozhye\",\"Europe/Lisbon|Portugal\",\"Europe/Lisbon|WET\",\"Europe/London|Europe/Belfast\",\"Europe/London|Europe/Guernsey\",\"Europe/London|Europe/Isle_of_Man\",\"Europe/London|Europe/Jersey\",\"Europe/London|GB\",\"Europe/London|GB-Eire\",\"Europe/Moscow|W-SU\",\"Europe/Paris|Europe/Monaco\",\"Europe/Prague|Europe/Bratislava\",\"Europe/Rome|Europe/San_Marino\",\"Europe/Rome|Europe/Vatican\",\"Europe/Warsaw|Poland\",\"Europe/Zurich|Europe/Busingen\",\"Europe/Zurich|Europe/Vaduz\",\"Indian/Maldives|Indian/Kerguelen\",\"Pacific/Auckland|Antarctica/McMurdo\",\"Pacific/Auckland|Antarctica/South_Pole\",\"Pacific/Auckland|NZ\",\"Pacific/Chatham|NZ-CHAT\",\"Pacific/Easter|Chile/EasterIsland\",\"Pacific/Enderbury|Pacific/Kanton\",\"Pacific/Guadalcanal|Pacific/Pohnpei\",\"Pacific/Guadalcanal|Pacific/Ponape\",\"Pacific/Guam|Pacific/Saipan\",\"Pacific/Honolulu|HST\",\"Pacific/Honolulu|Pacific/Johnston\",\"Pacific/Honolulu|US/Hawaii\",\"Pacific/Kwajalein|Kwajalein\",\"Pacific/Pago_Pago|Pacific/Midway\",\"Pacific/Pago_Pago|Pacific/Samoa\",\"Pacific/Pago_Pago|US/Samoa\",\"Pacific/Port_Moresby|Antarctica/DumontDUrville\",\"Pacific/Port_Moresby|Pacific/Chuuk\",\"Pacific/Port_Moresby|Pacific/Truk\",\"Pacific/Port_Moresby|Pacific/Yap\",\"Pacific/Tarawa|Pacific/Funafuti\",\"Pacific/Tarawa|Pacific/Majuro\",\"Pacific/Tarawa|Pacific/Wake\",\"Pacific/Tarawa|Pacific/Wallis\"],\"countries\":[\"AD|Europe/Andorra\",\"AE|Asia/Dubai\",\"AF|Asia/Kabul\",\"AG|America/Puerto_Rico America/Antigua\",\"AI|America/Puerto_Rico America/Anguilla\",\"AL|Europe/Tirane\",\"AM|Asia/Yerevan\",\"AO|Africa/Lagos Africa/Luanda\",\"AQ|Antarctica/Casey Antarctica/Davis Antarctica/Mawson Antarctica/Palmer Antarctica/Rothera Antarctica/Troll Antarctica/Vostok Pacific/Auckland Pacific/Port_Moresby Asia/Riyadh Asia/Singapore Antarctica/McMurdo Antarctica/DumontDUrville Antarctica/Syowa\",\"AR|America/Argentina/Buenos_Aires America/Argentina/Cordoba America/Argentina/Salta America/Argentina/Jujuy America/Argentina/Tucuman America/Argentina/Catamarca America/Argentina/La_Rioja America/Argentina/San_Juan America/Argentina/Mendoza America/Argentina/San_Luis America/Argentina/Rio_Gallegos America/Argentina/Ushuaia\",\"AS|Pacific/Pago_Pago\",\"AT|Europe/Vienna\",\"AU|Australia/Lord_Howe Antarctica/Macquarie Australia/Hobart Australia/Melbourne Australia/Sydney Australia/Broken_Hill Australia/Brisbane Australia/Lindeman Australia/Adelaide Australia/Darwin Australia/Perth Australia/Eucla Asia/Tokyo\",\"AW|America/Puerto_Rico America/Aruba\",\"AX|Europe/Helsinki Europe/Mariehamn\",\"AZ|Asia/Baku\",\"BA|Europe/Belgrade Europe/Sarajevo\",\"BB|America/Barbados\",\"BD|Asia/Dhaka\",\"BE|Europe/Brussels\",\"BF|Africa/Abidjan Africa/Ouagadougou\",\"BG|Europe/Sofia\",\"BH|Asia/Qatar Asia/Bahrain\",\"BI|Africa/Maputo Africa/Bujumbura\",\"BJ|Africa/Lagos Africa/Porto-Novo\",\"BL|America/Puerto_Rico America/St_Barthelemy\",\"BM|Atlantic/Bermuda\",\"BN|Asia/Kuching Asia/Brunei\",\"BO|America/La_Paz\",\"BQ|America/Puerto_Rico America/Kralendijk\",\"BR|America/Noronha America/Belem America/Fortaleza America/Recife America/Araguaina America/Maceio America/Bahia America/Sao_Paulo America/Campo_Grande America/Cuiaba America/Santarem America/Porto_Velho America/Boa_Vista America/Manaus America/Eirunepe America/Rio_Branco\",\"BS|America/Toronto America/Nassau\",\"BT|Asia/Thimphu\",\"BW|Africa/Maputo Africa/Gaborone\",\"BY|Europe/Minsk\",\"BZ|America/Belize\",\"CA|America/St_Johns America/Halifax America/Glace_Bay America/Moncton America/Goose_Bay America/Toronto America/Iqaluit America/Winnipeg America/Resolute America/Rankin_Inlet America/Regina America/Swift_Current America/Edmonton America/Cambridge_Bay America/Inuvik America/Dawson_Creek America/Fort_Nelson America/Whitehorse America/Dawson America/Vancouver America/Panama America/Puerto_Rico America/Phoenix America/Blanc-Sablon America/Atikokan America/Creston\",\"CC|Asia/Yangon Indian/Cocos\",\"CD|Africa/Maputo Africa/Lagos Africa/Kinshasa Africa/Lubumbashi\",\"CF|Africa/Lagos Africa/Bangui\",\"CG|Africa/Lagos Africa/Brazzaville\",\"CH|Europe/Zurich\",\"CI|Africa/Abidjan\",\"CK|Pacific/Rarotonga\",\"CL|America/Santiago America/Coyhaique America/Punta_Arenas Pacific/Easter\",\"CM|Africa/Lagos Africa/Douala\",\"CN|Asia/Shanghai Asia/Urumqi\",\"CO|America/Bogota\",\"CR|America/Costa_Rica\",\"CU|America/Havana\",\"CV|Atlantic/Cape_Verde\",\"CW|America/Puerto_Rico America/Curacao\",\"CX|Asia/Bangkok Indian/Christmas\",\"CY|Asia/Nicosia Asia/Famagusta\",\"CZ|Europe/Prague\",\"DE|Europe/Zurich Europe/Berlin Europe/Busingen\",\"DJ|Africa/Nairobi Africa/Djibouti\",\"DK|Europe/Berlin Europe/Copenhagen\",\"DM|America/Puerto_Rico America/Dominica\",\"DO|America/Santo_Domingo\",\"DZ|Africa/Algiers\",\"EC|America/Guayaquil Pacific/Galapagos\",\"EE|Europe/Tallinn\",\"EG|Africa/Cairo\",\"EH|Africa/El_Aaiun\",\"ER|Africa/Nairobi Africa/Asmara\",\"ES|Europe/Madrid Africa/Ceuta Atlantic/Canary\",\"ET|Africa/Nairobi Africa/Addis_Ababa\",\"FI|Europe/Helsinki\",\"FJ|Pacific/Fiji\",\"FK|Atlantic/Stanley\",\"FM|Pacific/Kosrae Pacific/Port_Moresby Pacific/Guadalcanal Pacific/Chuuk Pacific/Pohnpei\",\"FO|Atlantic/Faroe\",\"FR|Europe/Paris\",\"GA|Africa/Lagos Africa/Libreville\",\"GB|Europe/London\",\"GD|America/Puerto_Rico America/Grenada\",\"GE|Asia/Tbilisi\",\"GF|America/Cayenne\",\"GG|Europe/London Europe/Guernsey\",\"GH|Africa/Abidjan Africa/Accra\",\"GI|Europe/Gibraltar\",\"GL|America/Nuuk America/Danmarkshavn America/Scoresbysund America/Thule\",\"GM|Africa/Abidjan Africa/Banjul\",\"GN|Africa/Abidjan Africa/Conakry\",\"GP|America/Puerto_Rico America/Guadeloupe\",\"GQ|Africa/Lagos Africa/Malabo\",\"GR|Europe/Athens\",\"GS|Atlantic/South_Georgia\",\"GT|America/Guatemala\",\"GU|Pacific/Guam\",\"GW|Africa/Bissau\",\"GY|America/Guyana\",\"HK|Asia/Hong_Kong\",\"HN|America/Tegucigalpa\",\"HR|Europe/Belgrade Europe/Zagreb\",\"HT|America/Port-au-Prince\",\"HU|Europe/Budapest\",\"ID|Asia/Jakarta Asia/Pontianak Asia/Makassar Asia/Jayapura\",\"IE|Europe/Dublin\",\"IL|Asia/Jerusalem\",\"IM|Europe/London Europe/Isle_of_Man\",\"IN|Asia/Kolkata\",\"IO|Indian/Chagos\",\"IQ|Asia/Baghdad\",\"IR|Asia/Tehran\",\"IS|Africa/Abidjan Atlantic/Reykjavik\",\"IT|Europe/Rome\",\"JE|Europe/London Europe/Jersey\",\"JM|America/Jamaica\",\"JO|Asia/Amman\",\"JP|Asia/Tokyo\",\"KE|Africa/Nairobi\",\"KG|Asia/Bishkek\",\"KH|Asia/Bangkok Asia/Phnom_Penh\",\"KI|Pacific/Tarawa Pacific/Kanton Pacific/Kiritimati\",\"KM|Africa/Nairobi Indian/Comoro\",\"KN|America/Puerto_Rico America/St_Kitts\",\"KP|Asia/Pyongyang\",\"KR|Asia/Seoul\",\"KW|Asia/Riyadh Asia/Kuwait\",\"KY|America/Panama America/Cayman\",\"KZ|Asia/Almaty Asia/Qyzylorda Asia/Qostanay Asia/Aqtobe Asia/Aqtau Asia/Atyrau Asia/Oral\",\"LA|Asia/Bangkok Asia/Vientiane\",\"LB|Asia/Beirut\",\"LC|America/Puerto_Rico America/St_Lucia\",\"LI|Europe/Zurich Europe/Vaduz\",\"LK|Asia/Colombo\",\"LR|Africa/Monrovia\",\"LS|Africa/Johannesburg Africa/Maseru\",\"LT|Europe/Vilnius\",\"LU|Europe/Brussels Europe/Luxembourg\",\"LV|Europe/Riga\",\"LY|Africa/Tripoli\",\"MA|Africa/Casablanca\",\"MC|Europe/Paris Europe/Monaco\",\"MD|Europe/Chisinau\",\"ME|Europe/Belgrade Europe/Podgorica\",\"MF|America/Puerto_Rico America/Marigot\",\"MG|Africa/Nairobi Indian/Antananarivo\",\"MH|Pacific/Tarawa Pacific/Kwajalein Pacific/Majuro\",\"MK|Europe/Belgrade Europe/Skopje\",\"ML|Africa/Abidjan Africa/Bamako\",\"MM|Asia/Yangon\",\"MN|Asia/Ulaanbaatar Asia/Hovd\",\"MO|Asia/Macau\",\"MP|Pacific/Guam Pacific/Saipan\",\"MQ|America/Martinique\",\"MR|Africa/Abidjan Africa/Nouakchott\",\"MS|America/Puerto_Rico America/Montserrat\",\"MT|Europe/Malta\",\"MU|Indian/Mauritius\",\"MV|Indian/Maldives\",\"MW|Africa/Maputo Africa/Blantyre\",\"MX|America/Mexico_City America/Cancun America/Merida America/Monterrey America/Matamoros America/Chihuahua America/Ciudad_Juarez America/Ojinaga America/Mazatlan America/Bahia_Banderas America/Hermosillo America/Tijuana\",\"MY|Asia/Kuching Asia/Singapore Asia/Kuala_Lumpur\",\"MZ|Africa/Maputo\",\"NA|Africa/Windhoek\",\"NC|Pacific/Noumea\",\"NE|Africa/Lagos Africa/Niamey\",\"NF|Pacific/Norfolk\",\"NG|Africa/Lagos\",\"NI|America/Managua\",\"NL|Europe/Brussels Europe/Amsterdam\",\"NO|Europe/Berlin Europe/Oslo\",\"NP|Asia/Kathmandu\",\"NR|Pacific/Nauru\",\"NU|Pacific/Niue\",\"NZ|Pacific/Auckland Pacific/Chatham\",\"OM|Asia/Dubai Asia/Muscat\",\"PA|America/Panama\",\"PE|America/Lima\",\"PF|Pacific/Tahiti Pacific/Marquesas Pacific/Gambier\",\"PG|Pacific/Port_Moresby Pacific/Bougainville\",\"PH|Asia/Manila\",\"PK|Asia/Karachi\",\"PL|Europe/Warsaw\",\"PM|America/Miquelon\",\"PN|Pacific/Pitcairn\",\"PR|America/Puerto_Rico\",\"PS|Asia/Gaza Asia/Hebron\",\"PT|Europe/Lisbon Atlantic/Madeira Atlantic/Azores\",\"PW|Pacific/Palau\",\"PY|America/Asuncion\",\"QA|Asia/Qatar\",\"RE|Asia/Dubai Indian/Reunion\",\"RO|Europe/Bucharest\",\"RS|Europe/Belgrade\",\"RU|Europe/Kaliningrad Europe/Moscow Europe/Simferopol Europe/Kirov Europe/Volgograd Europe/Astrakhan Europe/Saratov Europe/Ulyanovsk Europe/Samara Asia/Yekaterinburg Asia/Omsk Asia/Novosibirsk Asia/Barnaul Asia/Tomsk Asia/Novokuznetsk Asia/Krasnoyarsk Asia/Irkutsk Asia/Chita Asia/Yakutsk Asia/Khandyga Asia/Vladivostok Asia/Ust-Nera Asia/Magadan Asia/Sakhalin Asia/Srednekolymsk Asia/Kamchatka Asia/Anadyr\",\"RW|Africa/Maputo Africa/Kigali\",\"SA|Asia/Riyadh\",\"SB|Pacific/Guadalcanal\",\"SC|Asia/Dubai Indian/Mahe\",\"SD|Africa/Khartoum\",\"SE|Europe/Berlin Europe/Stockholm\",\"SG|Asia/Singapore\",\"SH|Africa/Abidjan Atlantic/St_Helena\",\"SI|Europe/Belgrade Europe/Ljubljana\",\"SJ|Europe/Berlin Arctic/Longyearbyen\",\"SK|Europe/Prague Europe/Bratislava\",\"SL|Africa/Abidjan Africa/Freetown\",\"SM|Europe/Rome Europe/San_Marino\",\"SN|Africa/Abidjan Africa/Dakar\",\"SO|Africa/Nairobi Africa/Mogadishu\",\"SR|America/Paramaribo\",\"SS|Africa/Juba\",\"ST|Africa/Sao_Tome\",\"SV|America/El_Salvador\",\"SX|America/Puerto_Rico America/Lower_Princes\",\"SY|Asia/Damascus\",\"SZ|Africa/Johannesburg Africa/Mbabane\",\"TC|America/Grand_Turk\",\"TD|Africa/Ndjamena\",\"TF|Asia/Dubai Indian/Maldives Indian/Kerguelen\",\"TG|Africa/Abidjan Africa/Lome\",\"TH|Asia/Bangkok\",\"TJ|Asia/Dushanbe\",\"TK|Pacific/Fakaofo\",\"TL|Asia/Dili\",\"TM|Asia/Ashgabat\",\"TN|Africa/Tunis\",\"TO|Pacific/Tongatapu\",\"TR|Europe/Istanbul\",\"TT|America/Puerto_Rico America/Port_of_Spain\",\"TV|Pacific/Tarawa Pacific/Funafuti\",\"TW|Asia/Taipei\",\"TZ|Africa/Nairobi Africa/Dar_es_Salaam\",\"UA|Europe/Simferopol Europe/Kyiv\",\"UG|Africa/Nairobi Africa/Kampala\",\"UM|Pacific/Pago_Pago Pacific/Tarawa Pacific/Midway Pacific/Wake\",\"US|America/New_York America/Detroit America/Kentucky/Louisville America/Kentucky/Monticello America/Indiana/Indianapolis America/Indiana/Vincennes America/Indiana/Winamac America/Indiana/Marengo America/Indiana/Petersburg America/Indiana/Vevay America/Chicago America/Indiana/Tell_City America/Indiana/Knox America/Menominee America/North_Dakota/Center America/North_Dakota/New_Salem America/North_Dakota/Beulah America/Denver America/Boise America/Phoenix America/Los_Angeles America/Anchorage America/Juneau America/Sitka America/Metlakatla America/Yakutat America/Nome America/Adak Pacific/Honolulu\",\"UY|America/Montevideo\",\"UZ|Asia/Samarkand Asia/Tashkent\",\"VA|Europe/Rome Europe/Vatican\",\"VC|America/Puerto_Rico America/St_Vincent\",\"VE|America/Caracas\",\"VG|America/Puerto_Rico America/Tortola\",\"VI|America/Puerto_Rico America/St_Thomas\",\"VN|Asia/Bangkok Asia/Ho_Chi_Minh\",\"VU|Pacific/Efate\",\"WF|Pacific/Tarawa Pacific/Wallis\",\"WS|Pacific/Apia\",\"YE|Asia/Riyadh Asia/Aden\",\"YT|Africa/Nairobi Indian/Mayotte\",\"ZA|Africa/Johannesburg\",\"ZM|Africa/Maputo Africa/Lusaka\",\"ZW|Africa/Maputo Africa/Harare\"]}");

},{}],"3UhYH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isObject", function() {
    return isObject;
});
parcelHelpers.export(exports, "isDate", function() {
    return isDate;
});
/**
 * pad number with `0`
 * @param {number} number
 * @param {number} [len] - length
 * @return {string} padded string
 */ parcelHelpers.export(exports, "pad0", function() {
    return pad0;
});
/**
 * convert string to number
 * @private
 * @param {String} str
 * @return {Number} converted number or undefined
 */ parcelHelpers.export(exports, "toNumber", function() {
    return toNumber;
});
/**
 * extract or set year
 * @private
 * @param {Number|Date|String} year
 * @return {Number} year
 */ parcelHelpers.export(exports, "toYear", function() {
    return toYear;
});
function objectToString(o) {
    return Object.prototype.toString.call(o);
}
function isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
function isDate(d) {
    return isObject(d) && objectToString(d) === '[object Date]';
}
function pad0(number, len) {
    len = len || 2;
    number = Array(len).join('0') + number.toString();
    return number.substr(number.length - len, len);
}
function toNumber(str) {
    var num = parseInt(str, 10);
    if (!isNaN(num)) return num;
}
function toYear(year) {
    if (!year) year = new Date().getFullYear();
    else if (isDate(year)) year = year.getFullYear();
    else if (typeof year === 'string') year = toNumber(year);
    return year;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"bGmqb":[function(require,module,exports,__globalThis) {
/**
 * lodash compatible methods
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "get", function() {
    return get;
});
parcelHelpers.export(exports, "set", function() {
    return set;
});
parcelHelpers.export(exports, "omit", function() {
    return omit;
});
parcelHelpers.export(exports, "merge", function() {
    return merge;
});
parcelHelpers.export(exports, "toNumber", function() {
    return toNumber;
});
var _deepmerge = require("deepmerge");
var _deepmergeDefault = parcelHelpers.interopDefault(_deepmerge);
var get = function(obj) {
    var keys = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], def = arguments.length > 2 ? arguments[2] : void 0;
    var o = obj;
    if (typeof keys === 'string') keys = keys.split('.');
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            if (o && o[key]) o = o[key];
            else return def;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return o;
};
var set = function(obj) {
    var keys = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], value = arguments.length > 2 ? arguments[2] : void 0;
    var key;
    var ref;
    var o = obj;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            key = _step.value;
            ref = o;
            if (toString.call(o[key]) !== '[object Object]') o[key] = {};
            o = o[key];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    ref[key] = value;
    return obj;
};
var omit = function(object) {
    var props = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    return Object.keys(object).filter(function(p) {
        return !~props.indexOf(p);
    }).reduce(function(o, p) {
        p in object && (o[p] = object[p]);
        return o;
    }, {});
};
var merge = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return (0, _deepmergeDefault.default).all(args);
};
var toNumber = function(num, def) {
    var _num = Number(num);
    return isNaN(_num) ? def : _num;
};
exports.default = {
    get: get,
    set: set,
    omit: omit,
    merge: merge
};

},{"deepmerge":"jPsrF","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jPsrF":[function(require,module,exports,__globalThis) {
'use strict';
var isMergeableObject = function isMergeableObject(value) {
    return isNonNullObject(value) && !isSpecial(value);
};
function isNonNullObject(value) {
    return !!value && typeof value === 'object';
}
function isSpecial(value) {
    var stringValue = Object.prototype.toString.call(value);
    return stringValue === '[object RegExp]' || stringValue === '[object Date]' || isReactElement(value);
}
// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;
function isReactElement(value) {
    return value.$$typeof === REACT_ELEMENT_TYPE;
}
function emptyTarget(val) {
    return Array.isArray(val) ? [] : {};
}
function cloneUnlessOtherwiseSpecified(value, options) {
    return options.clone !== false && options.isMergeableObject(value) ? deepmerge(emptyTarget(value), value, options) : value;
}
function defaultArrayMerge(target, source, options) {
    return target.concat(source).map(function(element) {
        return cloneUnlessOtherwiseSpecified(element, options);
    });
}
function getMergeFunction(key, options) {
    if (!options.customMerge) return deepmerge;
    var customMerge = options.customMerge(key);
    return typeof customMerge === 'function' ? customMerge : deepmerge;
}
function getEnumerableOwnPropertySymbols(target) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target).filter(function(symbol) {
        return Object.propertyIsEnumerable.call(target, symbol);
    }) : [];
}
function getKeys(target) {
    return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target));
}
function propertyIsOnObject(object, property) {
    try {
        return property in object;
    } catch (_) {
        return false;
    }
}
// Protects from prototype poisoning and unexpected merging up the prototype chain.
function propertyIsUnsafe(target, key) {
    return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
     && !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
     && Object.propertyIsEnumerable.call(target, key) // and also unsafe if they're nonenumerable.
    );
}
function mergeObject(target, source, options) {
    var destination = {};
    if (options.isMergeableObject(target)) getKeys(target).forEach(function(key) {
        destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
    });
    getKeys(source).forEach(function(key) {
        if (propertyIsUnsafe(target, key)) return;
        if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
        else destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
    });
    return destination;
}
function deepmerge(target, source, options) {
    options = options || {};
    options.arrayMerge = options.arrayMerge || defaultArrayMerge;
    options.isMergeableObject = options.isMergeableObject || isMergeableObject;
    // cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
    // implementations can use it. The caller may not replace it.
    options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
    if (!sourceAndTargetTypesMatch) return cloneUnlessOtherwiseSpecified(source, options);
    else if (sourceIsArray) return options.arrayMerge(target, source, options);
    else return mergeObject(target, source, options);
}
deepmerge.all = function deepmergeAll(array, options) {
    if (!Array.isArray(array)) throw new Error('first argument should be an array');
    return array.reduce(function(prev, next) {
        return deepmerge(prev, next, options);
    }, {});
};
var deepmerge_1 = deepmerge;
module.exports = deepmerge_1;

},{}],"iCH29":[function(require,module,exports,__globalThis) {
/**
 * {
 *   0: 'sunday', ...
 *   sunday: 0, ...
 * }
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DAYS", function() {
    return DAYS;
});
parcelHelpers.export(exports, "isObject", function() {
    return isObject;
});
parcelHelpers.export(exports, "isDate", function() {
    return isDate;
});
parcelHelpers.export(exports, "isNil", function() {
    return isNil;
});
/**
 * pad number with `0`
 * @param {number} number
 * @param {number} [len] - length
 * @return {string} padded string
 */ parcelHelpers.export(exports, "pad0", function() {
    return pad0;
});
/**
 * convert string to number
 * @private
 * @param {String} str
 * @return {Number} converted number or undefined
 */ parcelHelpers.export(exports, "toNumber", function() {
    return toNumber;
});
/**
 * extract or set year
 * @private
 * @param {Number|Date|String} year
 * @return {Number} year
 */ parcelHelpers.export(exports, "toYear", function() {
    return toYear;
});
/**
 * convert string to Date.
 * 2017        : year = 2017, month = 1, day = 1
 * '2017-07'   : year = 2017, month = 7, day = 1
 * '2017-07-03': year = 2017, month = 7, day = 3
 * @param {String} str
 * @param {Boolean} isUTC - return date in UTC
 * @return {Date}
 */ parcelHelpers.export(exports, "toDate", function() {
    return toDate;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var DAYS = function() {
    var o = {};
    'sunday|monday|tuesday|wednesday|thursday|friday|saturday'.split('|').forEach(function(name, idx) {
        o[name] = idx;
        o[idx] = name;
    });
    return o;
}();
function objectToString(o) {
    return Object.prototype.toString.call(o);
}
function isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
function isDate(d) {
    return isObject(d) && objectToString(d) === '[object Date]';
}
var isNil = function(v) {
    return v === null || v === undefined;
};
function pad0(number, len) {
    len = len || 2;
    number = Array(len).join('0') + number.toString();
    return number.substr(number.length - len, len);
}
function toNumber(str) {
    var num = parseInt(str, 10);
    if (!isNaN(num)) return num;
}
function toYear(year) {
    if (!year) year = new Date().getFullYear();
    else if (year instanceof Date) year = year.getFullYear();
    else if (typeof year === 'string') year = toNumber(year);
    return year;
}
function toDate(str, isUTC) {
    var m = /^(\d{4})(?:-(\d{2})(?:-(\d{2}))?)?.*$/.exec((str || '').toString());
    if (m) {
        m.shift();
        var _m_map = (0, _slicedToArray._)(m.map(function(num) {
            return parseInt(num || 1, 10);
        }), 3), year = _m_map[0], month = _m_map[1], day = _m_map[2];
        if (isUTC) return new Date(Date.UTC(year, month - 1, day));
        else return new Date(year, month - 1, day);
    }
}

},{"@swc/helpers/_/_sliced_to_array":"ha6sq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"d7SrC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Handler for holiday data provided in the Json file
 * @class
 * @param {Object} [data]
 * @param {Object|String} [country]
 * @param {String} [state]
 * @param {String} [region]
 */ parcelHelpers.export(exports, "default", function() {
    return Data;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _utilsJs = require("./utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var Data = /*#__PURE__*/ function() {
    "use strict";
    function Data(data, country, state, region) {
        (0, _classCallCheck._)(this, Data);
        this.opts = Data.splitName(country, state, region) || {};
        this.data = data || {};
    }
    (0, _createClass._)(Data, [
        {
            /**
   * get all countries from the data
   * @param {String} lang - Iso-639 shortcode
   * @return {Object} shortcode-name value pairs. E.g. `{ AT: 'Österreich', ... }`
   */ key: "getCountries",
            value: function getCountries(lang) {
                var _this = this;
                var o = {};
                var countries = (0, _utilsJsDefault.default).get(this.data, 'holidays', {});
                Object.keys(countries).forEach(function(country) {
                    o[country] = _this._name(countries, country, lang, {
                        country: country
                    });
                });
                return o;
            }
        },
        {
            /**
   * get all states for a given country from the data
   * @param {String|Object} country
   * @param {String} [lang] - Iso-639 shortcode
   * @return {Object} shortcode-name value pairs. E.g. `{ b: 'Burgenland', ... }`
   */ key: "getStates",
            value: function getStates(country, lang) {
                var _this = this;
                var opts = Object.assign({}, Data.splitName(country));
                var states = (0, _utilsJsDefault.default).get(this.data, [
                    'holidays',
                    opts.country,
                    'states'
                ]) || (0, _utilsJsDefault.default).get(this.data, [
                    'holidays',
                    opts.country,
                    'regions'
                ]);
                if (states) {
                    var o = {};
                    Object.keys(states).forEach(function(state) {
                        opts.state = state;
                        o[state] = _this._name(states, state, lang, opts);
                    });
                    return o;
                }
            }
        },
        {
            /**
   * get all regions for a given country/ state from the data
   * @param {String} country
   * @param {String} state
   * @param {String} [lang] - Iso-639 shortcode
   * @return {Object} shortcode-name value pairs.
   */ key: "getRegions",
            value: function getRegions(country, state, lang) {
                var _this = this;
                var opts = Object.assign({}, Data.splitName(country, state));
                var regions = (0, _utilsJsDefault.default).get(this.data, [
                    'holidays',
                    opts.country,
                    'states',
                    opts.state,
                    'regions'
                ]);
                if (regions) {
                    var o = {};
                    Object.keys(regions).forEach(function(region) {
                        opts.region = region;
                        o[region] = _this._name(regions, region, lang, opts);
                    });
                    return o;
                }
            }
        },
        {
            /**
   * @private
   */ key: "_name",
            value: function _name(obj, key, lang, opts) {
                var names = obj[key].names;
                var _lang = lang || this.getLanguages(opts)[0] || Object.keys(names)[0];
                var mlang = Data.majorLang(_lang);
                var name = obj[key].name || names[_lang] || names[mlang] || names[Object.keys(names)[0]];
                return name;
            }
        },
        {
            /**
   * get languages for selected country, state, region
   * @return {Array} containing ISO 639-1 language shortcodes
   */ key: "getLanguages",
            value: function getLanguages(opts) {
                return this._getValue('langs', opts) || [];
            }
        },
        {
            /**
   * get default day off as weekday
   * @return {String} weekday of day off
   */ key: "getDayOff",
            value: function getDayOff() {
                return this._getValue('dayoff');
            }
        },
        {
            /**
   * get timezones for country, state, region
   * @return {Array} of {String}s containing the timezones
   */ key: "getTimezones",
            value: function getTimezones() {
                return this._getValue('zones') || [];
            }
        },
        {
            /**
   * get list of raw holiday rules for country/ state/ region
   * @param {Object|String} [country]
   * @param {String} [state]
   * @param {String} [region]
   * @return {Object} holidayname <-> unparsed rule or date pairs
   */ key: "getRules",
            value: function getRules(country, state, region) {
                var _this = this;
                var rules = {};
                var opts = Data.splitName(country, state, region) || this.opts;
                if (!(opts && opts.country)) return rules;
                country = opts.country.toUpperCase();
                state = opts.state;
                region = opts.region;
                var tmp = (0, _utilsJsDefault.default).get(this.data, [
                    'holidays',
                    country
                ]);
                if (tmp) {
                    this._assign(rules, tmp);
                    if (state && tmp.regions && (tmp = tmp.regions[state]) || state && tmp.states && (tmp = tmp.states[state])) {
                        this._assign(rules, tmp);
                        if (region && tmp.regions && (tmp = tmp.regions[region])) this._assign(rules, tmp);
                    }
                    Object.keys(rules).forEach(function(key) {
                        // assign name references with `_name`
                        var _name = rules[key]._name;
                        if (_name && _this.data.names[_name]) {
                            delete rules[key]._name;
                            rules[key] = (0, _utilsJsDefault.default).merge({}, _this.data.names[_name], rules[key]);
                        }
                    });
                }
                return rules;
            }
        },
        {
            /**
   * get name for substitute name
   * @return {Object} translations of substitute day names
   */ key: "getSubstitueNames",
            value: function getSubstitueNames() {
                return (0, _utilsJsDefault.default).get(this.data, [
                    'names',
                    'substitutes',
                    'name'
                ]);
            }
        },
        {
            /**
   * helper to assign objects based on properties
   * @private
   * @param {Object} out - object where obj gets assigned into
   * @param {Object} obj - input obj
   * @return {Object}
   */ key: "_assign",
            value: function _assign(out, obj) {
                var days = {};
                if (obj._days) {
                    var path = [
                        'holidays'
                    ].concat(obj._days, 'days');
                    var ref = (0, _utilsJsDefault.default).get(this.data, path);
                    if (!ref) throw new Error('unknown path for _days: ' + path.join('.'));
                    days = Object.assign({}, ref);
                }
                if (days || obj.days) {
                    days = Object.assign(days, obj.days);
                    Object.keys(days).forEach(function(p) {
                        if (days[p] === false) {
                            if (out[p]) delete out[p];
                            return;
                        }
                        out[p] = Object.assign({}, out[p], days[p]);
                        if (!days[p].type) out[p].type = 'public';
                    });
                }
                return out;
            }
        },
        {
            /**
   * get a object from the data tree
   * @private
   * @param {String} key - key to look at
   * @return {Object} return object
   */ key: "_getValue",
            value: function _getValue(key) {
                var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.opts;
                return (0, _utilsJsDefault.default).get(this.data, [
                    'holidays',
                    opts.country,
                    'states',
                    opts.state,
                    'regions',
                    opts.regions,
                    key
                ]) || (0, _utilsJsDefault.default).get(this.data, [
                    'holidays',
                    opts.country,
                    'states',
                    opts.state,
                    key
                ]) || (0, _utilsJsDefault.default).get(this.data, [
                    'holidays',
                    opts.country,
                    key
                ]);
            }
        }
    ]);
    return Data;
}();
// static functions
/**
 * split country state names if they appear in concatenated format e.g. 'at.b'
 * @param {String|Object} country
 * @param {String} [state]
 * @param {String} [region]
 * @return {Object}
 */ Data.splitName = function(country, state, region) {
    if (typeof country === 'object' && country.country) return toUpperCase(country);
    else if (typeof country === 'string') {
        var a = country.split(/[.-]/);
        var o = {
            country: a.shift(),
            state: a.shift() || state,
            region: a.shift() || region
        };
        return toUpperCase(o);
    }
};
Data.majorLang = function(lang) {
    return (lang || '').split(/-/)[0];
};
/**
 * @private
 */ function toUpperCase(obj) {
    [
        'country',
        'state',
        'region'
    ].forEach(function(key) {
        if (typeof obj[key] === 'string') obj[key] = obj[key].toUpperCase();
    });
    return obj;
}

},{"@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","./utils.js":"bGmqb","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"TFC8O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * handles one rule
 */ parcelHelpers.export(exports, "default", function() {
    return DateFn;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _parserJs = require("./Parser.js");
var _parserJsDefault = parcelHelpers.interopDefault(_parserJs);
var _ruleJs = require("./Rule.js");
var _ruleJsDefault = parcelHelpers.interopDefault(_ruleJs);
var _postRuleJs = require("./PostRule.js");
var _postRuleJsDefault = parcelHelpers.interopDefault(_postRuleJs);
var _calEventFactoryJs = require("./CalEventFactory.js");
var _calEventFactoryJsDefault = parcelHelpers.interopDefault(_calEventFactoryJs);
var DateFn = /*#__PURE__*/ function() {
    "use strict";
    function DateFn(ruleStr, holidays) {
        (0, _classCallCheck._)(this, DateFn);
        var parser = new (0, _parserJsDefault.default)();
        this.ruleStr = ruleStr;
        this.rules = parser.parse(ruleStr);
        this.ok = !parser.error;
        this.holidays = holidays;
        this.opts = holidays ? holidays[ruleStr] : {};
        this.event = undefined;
        this.cache = new Map();
    }
    (0, _createClass._)(DateFn, [
        {
            /**
   * @param {number} year
   * @returns {this}
   */ key: "inYear",
            value: function inYear(year) {
                if (this.cache.has(year)) {
                    this.event = this.cache.get(year);
                    return this;
                }
                var ruleFn // current rule
                ;
                var postProc = new (0, _postRuleJsDefault.default)(this.ruleStr, this.opts, this.holidays);
                this.rules.forEach(function(rule) {
                    if (rule.fn) {
                        var calEvent = new (0, _calEventFactoryJsDefault.default)(rule).inYear(year - 1) // run over neighboring dates to catch overlaps
                        .inYear(year).inYear(year + 1);
                        postProc.push(calEvent);
                        ruleFn = new (0, _ruleJsDefault.default)(calEvent);
                    } else if (ruleFn.resolve(rule)) postProc.resolve(rule, year);
                });
                var event = postProc.getEvent(year);
                this.cache.set(year, event);
                this.event = event;
                return this;
            }
        },
        {
            key: "get",
            value: function get(timezone) {
                return this.event.get(timezone);
            }
        }
    ]);
    return DateFn;
}();

},{"@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","./Parser.js":"5EVHL","./Rule.js":"l2Z6w","./PostRule.js":"g0UlE","./CalEventFactory.js":"ao0Bw","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5EVHL":[function(require,module,exports,__globalThis) {
/* eslint
   no-spaced-func: 0,
   no-unexpected-multiline: 0
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// console.log(grammar)
parcelHelpers.export(exports, "default", function() {
    return Parser;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _utilsJs = require("./internal/utils.js");
var WEEKDAYS = 'Sunday|Monday|Tuesday|Wednesday|Thursday|Friday|Saturday'.split('|');
var lowerCaseWeekday = function(weekday) {
    return WEEKDAYS.includes(weekday) ? weekday.toLowerCase() : weekday;
};
var lowerCaseWeekdayWithoutDay = function(weekday) {
    return weekday === 'day' ? undefined : lowerCaseWeekday(weekday);
};
/**
 * regular expressions to parse holiday statements
 */ var grammar = function() {
    /**
   * combines different regexes
   * @private
   * @return {RegExp} combined regex
   */ function replace(regex, opt) {
        regex = regex.source;
        opt = opt || '';
        return function self(name, val) {
            if (!name) return new RegExp(regex, opt);
            val = val.source || val;
            val = val.replace(/(^|[^[])\^/g, '$1');
            regex = regex.replace(name, val);
            return self;
        };
    }
    // raw rules
    var raw = {
        _weekdays: '[Ss]unday|[Mm]onday|[Tt]uesday|[Ww]ednesday|[Tt]hursday|[Ff]riday|[Ss]aturday|day',
        _months: 'January|February|March|April|May|June|July|August|September|October|November|December',
        _islamicMonths: 'Muharram|Safar|Rabi al-awwal|Rabi al-thani|Jumada al-awwal|Jumada al-thani|Rajab|Shaban|Ramadan|Shawwal|Dhu al-Qidah|Dhu al-Hijjah',
        _hebrewMonths: 'Nisan|Iyyar|Sivan|Tamuz|Av|Elul|Tishrei|Cheshvan|Kislev|Tevet|Shvat|AdarII|Adar',
        _jalaaliMonths: 'Farvardin|Ordibehesht|Khordad|Tir|Mordad|Shahrivar|Mehr|Aban|Azar|Dey|Bahman|Esfand',
        _days: /(_weekdays)s?/,
        _direction: /(before|after|next|previous|in)/,
        _counts: /(\d+)(?:st|nd|rd|th)?/,
        _count_days: /([-+]?\d{1,2}) ?(?:days?|d)?/,
        _timezone: / in ([^\s]*|[+-]\d{2}:\d{2})/,
        _type: /(public|bank|school|observance|optional)/,
        dateMonth: /^(_months)/,
        date: /^(?:0*(\d{1,4})-)?0?(\d{1,2})-0?(\d{1,2})/,
        time: /^(?:T?0?(\d{1,2}):0?(\d{1,2})|T0?(\d{1,2}))/,
        duration: /^P(?:(\d+)D)?(?:T(?:(\d+)H)?(?:(\d+)M)?)?/,
        julian: /^julian date/,
        easter: /^(easter|orthodox)(?: _count_days)?/,
        equinox: /^([Mm]arch|[Jj]une|[Ss]eptember|[Dd]ecember) (?:equinox|solstice)(?:_timezone)?/,
        hebrew: /^0?(\d{1,2}) (_hebrewMonths)(?: 0*(\d{1,}))?/,
        islamic: /^0?(\d{1,2}) (_islamicMonths)(?: 0*(\d{1,}))?/,
        jalaali: /^0?(\d{1,2}) (_jalaaliMonths)(?: 0*(\d{1,}))?/,
        chineseLunar: /^(chinese|korean|vietnamese) (?:(\d+)-(\d{1,2})-)?(\d{1,2})-([01])-(\d{1,2})/,
        chineseSolar: /^(chinese|korean|vietnamese) (?:(\d+)-(\d{1,2})-)?(\d{1,2})-(\d{1,2}) solarterm/,
        bengaliRevised: /^(bengali-revised) (?:-?0*(\d{1,4})-)?0?(\d{1,2})-0?(\d{1,2})/,
        modifier: /^(substitutes|and|if equal|then|if)\b/,
        rule_year: /^(?:in (even|odd|leap|non-leap) years|every (\d+) years? since 0*(\d{1,4}))/,
        rule_weekday: /(not )?on ((?:(?:_weekdays)(?:,\s?)?)*)/,
        rule_date_if_then: /^if ((?:(?:_weekdays)(?:,\s?)?)*) then (?:_direction _days)?/,
        rule_day_dir_date: /^(?:_counts )?_days _direction/,
        rule_bridge: /^is (?:_type )?holiday/,
        rule_if_holiday: /^if is (?:_type )?holiday then (?:_counts )?(?:_direction _days)?(?: omit ((?:(?:_weekdays)(?:,\s?)?)*))?/,
        rule_same_day: /^#\d+/,
        rule_active_from: /^since (0*\d{1,4})(?:-0*(\d{1,2})(?:-0*(\d{1,2})|)|)(?: and|)/,
        rule_active_to: /^prior to (0*\d{1,4})(?:-0*(\d{1,2})(?:-0*(\d{1,2})|)|)/,
        // rule_type_if_then: /if ((?:(?:_weekdays)(?:,\s?)?)*) then/,
        // rule_type_dir: /_days _direction$/,
        // rule_type_bridge: / if .* is .* holiday$/,
        space: /^\s+/
    };
    /* eslint-disable func-call-spacing */ raw._days = replace(raw._days)(/_weekdays/, raw._weekdays)();
    raw.julian = replace(raw.julian, '')(/date/, raw.date)();
    raw.easter = replace(raw.easter, '')(/_count_days/, raw._count_days)();
    raw.equinox = replace(raw.equinox, '')(/_count_days/g, raw._count_days)(/_direction/g, raw._direction)(/_timezone/g, raw._timezone)();
    raw.hebrew = replace(raw.hebrew, '')(/_hebrewMonths/, raw._hebrewMonths)();
    raw.islamic = replace(raw.islamic, '')(/_islamicMonths/, raw._islamicMonths)();
    raw.jalaali = replace(raw.jalaali, '')(/_jalaaliMonths/, raw._jalaaliMonths)();
    raw.dateMonth = replace(raw.dateMonth)(/_months/, raw._months)();
    raw.rule_weekday = replace(raw.rule_weekday, '')(/_weekdays/g, raw._weekdays)();
    raw.rule_date_if_then = replace(raw.rule_date_if_then, '')(/_direction/g, raw._direction)(/_weekdays/g, raw._weekdays)(/_days/g, raw._days)();
    raw.rule_bridge = replace(raw.rule_bridge, '')(/_type/g, raw._type)();
    raw.rule_if_holiday = replace(raw.rule_if_holiday, '')(/_type/g, raw._type)(/_counts/g, raw._counts)(/_direction/g, raw._direction)(/_days/g, raw._days)(/_weekdays/g, raw._weekdays)();
    raw.rule_day_dir_date = replace(raw.rule_day_dir_date, '')(/_counts/, raw._counts)(/_days/g, raw._days)(/_direction/g, raw._direction)();
    // raw.rule_type_if_then = replace(raw.rule_type_if_then, '')
    // (/_direction/g, raw._direction)
    // (/_days/g, raw._days)
    // ()
    var i = 1;
    raw.months = {};
    raw._months.split('|').forEach(function(m) {
        raw.months[m] = i++;
    });
    i = 1;
    raw.islamicMonths = {};
    raw._islamicMonths.split('|').forEach(function(m) {
        raw.islamicMonths[m] = i++;
    });
    i = 1;
    raw.hebrewMonths = {};
    raw._hebrewMonths.split('|').forEach(function(m) {
        raw.hebrewMonths[m] = i++;
    });
    // parser regex needs larger string before shorter AdarII and Adar pos needs correction
    raw.hebrewMonths.Adar = 12;
    raw.hebrewMonths.AdarII = 13;
    i = 1;
    raw.jalaaliMonths = {};
    raw._jalaaliMonths.split('|').forEach(function(m) {
        raw.jalaaliMonths[m] = i++;
    });
    return raw;
/* eslint-enable */ }();
var Parser = /*#__PURE__*/ function() {
    "use strict";
    function Parser(fns) {
        (0, _classCallCheck._)(this, Parser);
        this.fns = fns || [
            '_julian',
            '_date',
            '_easter',
            '_islamic',
            '_hebrew',
            '_jalaali',
            '_equinox',
            '_chineseSolar',
            '_chineseLunar',
            '_bengaliRevised',
            '_dateMonth',
            '_ruleDateIfThen',
            '_ruleWeekday',
            '_ruleYear',
            '_ruleDateDir',
            '_ruleIfHoliday',
            '_ruleBridge',
            '_ruleTime',
            '_ruleDuration',
            '_ruleModifier',
            '_ruleSameDay',
            '_ruleActiveFrom',
            '_ruleActiveTo'
        ];
        this.tokens = [];
    }
    (0, _createClass._)(Parser, [
        {
            key: "parse",
            value: function parse(rule) {
                this.setup = {
                    str: rule,
                    rule: rule
                };
                this.error = 0;
                this.tokens = [];
                this._tokenize(this.setup);
                this._reorder();
                return this.tokens;
            }
        },
        {
            /**
   * reorder set of tokens for rule dateDir
   * dateDir: [dateDir2, dateDir1, fn] --> [fn, dateDir1, dateDir2]
   * dateIfThen: [fn, dateIfThen1, dateIfThen2] --> [fn, dateIfThen1, dateIfThen2]
   */ key: "_reorder",
            value: function _reorder() {
                var tmp = [];
                var res = [];
                this.tokens.forEach(function(token) {
                    if (token.rule === 'dateDir') tmp.push(token);
                    else {
                        res.push(token);
                        if (tmp.length) while(tmp.length)res.push(tmp.pop());
                    }
                    // no modifiers before a date
                    if (token.fn && res[0].modifier) while(res[0].modifier)res.push(res.shift());
                });
                this.tokens = res;
            }
        },
        {
            key: "_tokenize",
            value: function _tokenize(o) {
                var last;
                while(o.str){
                    for(var i = 0; i < this.fns.length; i++){
                        if (this[this.fns[i]](o)) break;
                    }
                    this._space(o);
                    if (last === o.str) {
                        this.error++;
                        break;
                    }
                    last = o.str;
                }
            }
        },
        {
            key: "_shorten",
            value: function _shorten(o, cap0) {
                o.str = o.str.substr(cap0.length, o.str.length);
            }
        },
        {
            key: "_date",
            value: function _date(o) {
                var cap;
                if (cap = grammar.date.exec(o.str)) {
                    this._shorten(o, cap[0]);
                    cap.shift();
                    var res = {
                        fn: 'gregorian',
                        year: (0, _utilsJs.toNumber)(cap.shift()),
                        month: (0, _utilsJs.toNumber)(cap.shift()),
                        day: (0, _utilsJs.toNumber)(cap.shift())
                    };
                    this.tokens.push(res);
                    return true;
                }
            }
        },
        {
            key: "_julian",
            value: function _julian(o) {
                var cap;
                if (cap = grammar.julian.exec(o.str)) {
                    this._shorten(o, cap[0]);
                    cap.shift();
                    var res = {
                        fn: 'julian',
                        year: (0, _utilsJs.toNumber)(cap.shift()),
                        month: (0, _utilsJs.toNumber)(cap.shift()),
                        day: (0, _utilsJs.toNumber)(cap.shift())
                    };
                    this.tokens.push(res);
                    return true;
                }
            }
        },
        {
            key: "_easter",
            value: function _easter(o) {
                var cap;
                if (cap = grammar.easter.exec(o.str)) {
                    this._shorten(o, cap[0]);
                    cap.shift();
                    var res = {
                        fn: 'easter',
                        type: cap.shift(),
                        offset: (0, _utilsJs.toNumber)(cap.shift()) || 0
                    };
                    this.tokens.push(res);
                    return true;
                }
            }
        },
        {
            key: "_equinox",
            value: function _equinox(o) {
                var cap;
                if (cap = grammar.equinox.exec(o.str)) {
                    this._shorten(o, cap[0]);
                    cap.shift();
                    var res = {
                        fn: 'equinox',
                        season: cap.shift().toLowerCase(),
                        timezone: cap.shift() || 'GMT'
                    };
                    this.tokens.push(res);
                    return true;
                }
            }
        },
        {
            key: "_hebrew",
            value: function _hebrew(o) {
                var cap;
                if (cap = grammar.hebrew.exec(o.str)) {
                    this._shorten(o, cap[0]);
                    cap.shift();
                    var res = {
                        fn: 'hebrew',
                        day: (0, _utilsJs.toNumber)(cap.shift()),
                        month: grammar.hebrewMonths[cap.shift()],
                        year: (0, _utilsJs.toNumber)(cap.shift())
                    };
                    this.tokens.push(res);
                    return true;
                }
            }
        },
        {
            key: "_islamic",
            value: function _islamic(o) {
                var cap;
                if (cap = grammar.islamic.exec(o.str)) {
                    this._shorten(o, cap[0]);
                    cap.shift();
                    var res = {
                        fn: 'islamic',
                        day: (0, _utilsJs.toNumber)(cap.shift()),
                        month: grammar.islamicMonths[cap.shift()],
                        year: (0, _utilsJs.toNumber)(cap.shift())
                    };
                    this.tokens.push(res);
                    return true;
                }
            }
        },
        {
            key: "_jalaali",
            value: function _jalaali(o) {
                var cap;
                if (cap = grammar.jalaali.exec(o.str)) {
                    this._shorten(o, cap[0]);
                    cap.shift();
                    var res = {
                        fn: 'jalaali',
                        day: (0, _utilsJs.toNumber)(cap.shift()),
                        month: grammar.jalaaliMonths[cap.shift()],
                        year: (0, _utilsJs.toNumber)(cap.shift())
                    };
                    this.tokens.push(res);
                    return true;
                }
            }
        },
        {
            key: "_chineseSolar",
            value: function _chineseSolar(o) {
                var cap;
                if (cap = grammar.chineseSolar.exec(o.str)) {
                    this._shorten(o, cap[0]);
                    cap.shift();
                    var res = {
                        fn: cap.shift(),
                        cycle: (0, _utilsJs.toNumber)(cap.shift()),
                        year: (0, _utilsJs.toNumber)(cap.shift()),
                        solarterm: (0, _utilsJs.toNumber)(cap.shift()),
                        day: (0, _utilsJs.toNumber)(cap.shift()),
                        timezone: cap.shift()
                    };
                    this.tokens.push(res);
                    return true;
                }
            }
        },
        {
            key: "_chineseLunar",
            value: function _chineseLunar(o) {
                var cap;
                if (cap = grammar.chineseLunar.exec(o.str)) {
                    this._shorten(o, cap[0]);
                    cap.shift();
                    var res = {
                        fn: cap.shift(),
                        cycle: (0, _utilsJs.toNumber)(cap.shift()),
                        year: (0, _utilsJs.toNumber)(cap.shift()),
                        month: (0, _utilsJs.toNumber)(cap.shift()),
                        leapMonth: !!(0, _utilsJs.toNumber)(cap.shift()),
                        day: (0, _utilsJs.toNumber)(cap.shift()),
                        timezone: cap.shift()
                    };
                    this.tokens.push(res);
                    return true;
                }
            }
        },
        {
            key: "_bengaliRevised",
            value: function _bengaliRevised(o) {
                var cap;
                if (cap = grammar.bengaliRevised.exec(o.str)) {
                    this._shorten(o, cap[0]);
                    cap.shift();
                    var res = {
                        fn: cap.shift(),
                        year: (0, _utilsJs.toNumber)(cap.shift()),
                        month: (0, _utilsJs.toNumber)(cap.shift()),
                        day: (0, _utilsJs.toNumber)(cap.shift())
                    };
                    this.tokens.push(res);
                    return true;
                }
            }
        },
        {
            key: "_dateMonth",
            value: function _dateMonth(o) {
                var cap;
                if (cap = grammar.dateMonth.exec(o.str)) {
                    this._shorten(o, cap[0]);
                    cap.shift();
                    var res = {
                        fn: 'gregorian',
                        day: 1,
                        month: grammar.months[cap.shift()],
                        year: undefined
                    };
                    this.tokens.push(res);
                    return true;
                }
            }
        },
        {
            key: "_space",
            value: function _space(o) {
                var cap;
                if (cap = grammar.space.exec(o.str)) {
                    this._shorten(o, cap[0]);
                    return true;
                }
            }
        },
        {
            key: "_ruleSameDay",
            value: function _ruleSameDay(o) {
                var cap;
                if (cap = grammar.rule_same_day.exec(o.str)) {
                    this._shorten(o, cap[0]);
                    return true;
                }
            }
        },
        {
            key: "_ruleModifier",
            value: function _ruleModifier(o) {
                var cap;
                if (cap = grammar.modifier.exec(o.str)) {
                    this._shorten(o, cap[0]);
                    cap.shift();
                    var res = {
                        modifier: cap.shift()
                    };
                    this.tokens.push(res);
                    return true;
                }
            }
        },
        {
            key: "_ruleTime",
            value: function _ruleTime(o) {
                var cap;
                if (cap = grammar.time.exec(o.str)) {
                    this._shorten(o, cap[0]);
                    cap.shift();
                    var res = {
                        rule: 'time',
                        hour: (0, _utilsJs.toNumber)(cap.shift()) || 0,
                        minute: (0, _utilsJs.toNumber)(cap.shift()) || 0
                    };
                    res.hour = res.hour || (0, _utilsJs.toNumber)(cap.shift()) || 0;
                    this.tokens.push(res);
                    return true;
                }
            }
        },
        {
            key: "_ruleDuration",
            value: function _ruleDuration(o) {
                var cap;
                if (cap = grammar.duration.exec(o.str)) {
                    this._shorten(o, cap[0]);
                    cap.shift();
                    var tmp = {
                        days: (0, _utilsJs.toNumber)(cap.shift()) || 0,
                        hours: (0, _utilsJs.toNumber)(cap.shift()) || 0,
                        minutes: (0, _utilsJs.toNumber)(cap.shift()) || 0
                    };
                    var res = {
                        rule: 'duration',
                        // duration is calculated in hours
                        duration: tmp.days * 24 + tmp.hours + tmp.minutes / 60
                    };
                    this.tokens.push(res);
                    return true;
                }
            }
        },
        {
            key: "_ruleDateIfThen",
            value: function _ruleDateIfThen(o) {
                var cap;
                if (cap = grammar.rule_date_if_then.exec(o.str)) {
                    this._shorten(o, cap[0]);
                    cap.shift();
                    var res = {
                        rule: 'dateIfThen',
                        if: cap.shift().split(/(?:,\s?)/).map(lowerCaseWeekday),
                        direction: cap.shift(),
                        then: lowerCaseWeekday(cap.shift())
                    };
                    // create a sub-parser to only check for time, duration
                    var p = new Parser([
                        '_ruleTime',
                        '_ruleDuration'
                    ]);
                    p.parse(o.str);
                    if (p.tokens.length) res.rules = p.tokens;
                    o.str = ' ' + p.setup.str // ' ' required such that the _tokenize function finalizes the loop
                    ;
                    this.tokens.push(res);
                    return true;
                }
            }
        },
        {
            key: "_ruleWeekday",
            value: function _ruleWeekday(o) {
                var cap;
                if (cap = grammar.rule_weekday.exec(o.str)) {
                    this._shorten(o, cap[0]);
                    cap.shift();
                    var res = {
                        rule: 'weekday',
                        not: !!cap.shift(),
                        if: cap.shift().split(/(?:,\s?)/).map(lowerCaseWeekday)
                    };
                    this.tokens.push(res);
                    return true;
                }
            }
        },
        {
            key: "_ruleDateDir",
            value: function _ruleDateDir(o) {
                var cap;
                if (cap = grammar.rule_day_dir_date.exec(o.str)) {
                    this._shorten(o, cap[0]);
                    cap.shift();
                    var res = {
                        rule: 'dateDir',
                        count: (0, _utilsJs.toNumber)(cap.shift()) || 1,
                        weekday: lowerCaseWeekday(cap.shift()),
                        direction: cap.shift()
                    };
                    if (res.direction === 'in') res.direction = 'after';
                    this.tokens.push(res);
                    return true;
                }
            }
        },
        {
            key: "_ruleYear",
            value: function _ruleYear(o) {
                var cap;
                if (cap = grammar.rule_year.exec(o.str)) {
                    this._shorten(o, cap[0]);
                    cap.shift();
                    var res = {
                        rule: 'year',
                        cardinality: cap.shift(),
                        every: (0, _utilsJs.toNumber)(cap.shift()),
                        since: (0, _utilsJs.toNumber)(cap.shift())
                    };
                    this.tokens.push(res);
                    return true;
                }
            }
        },
        {
            key: "_ruleIfHoliday",
            value: function _ruleIfHoliday(o) {
                var cap;
                if (cap = grammar.rule_if_holiday.exec(o.str)) {
                    this._shorten(o, cap[0]);
                    cap.shift();
                    var res = {
                        rule: 'ruleIfHoliday',
                        type: cap.shift(),
                        count: (0, _utilsJs.toNumber)(cap.shift()) || 1,
                        direction: cap.shift(),
                        weekday: lowerCaseWeekday(cap.shift()),
                        omit: (cap.shift() || '').split(/(?:,\s?)/).map(lowerCaseWeekdayWithoutDay).filter(Boolean)
                    };
                    this.tokens.push(res);
                    return true;
                }
            }
        },
        {
            key: "_ruleBridge",
            value: function _ruleBridge(o) {
                var cap;
                if (cap = grammar.rule_bridge.exec(o.str)) {
                    this._shorten(o, cap[0]);
                    cap.shift();
                    var res = {
                        rule: 'bridge',
                        type: cap.shift()
                    };
                    this.tokens.push(res);
                    return true;
                }
            }
        },
        {
            key: "_ruleActiveFrom",
            value: function _ruleActiveFrom(o) {
                var cap;
                if (cap = grammar.rule_active_from.exec(o.str)) {
                    this._shorten(o, cap[0]);
                    cap.shift();
                    var res = {
                        rule: 'activeFrom',
                        year: (0, _utilsJs.toNumber)(cap.shift()),
                        month: (0, _utilsJs.toNumber)(cap.shift()) || 1,
                        day: (0, _utilsJs.toNumber)(cap.shift()) || 1
                    };
                    this.tokens.push(res);
                    return true;
                }
            }
        },
        {
            key: "_ruleActiveTo",
            value: function _ruleActiveTo(o) {
                var cap;
                if (cap = grammar.rule_active_to.exec(o.str)) {
                    this._shorten(o, cap[0]);
                    cap.shift();
                    var res = {
                        rule: 'activeTo',
                        year: (0, _utilsJs.toNumber)(cap.shift()),
                        month: (0, _utilsJs.toNumber)(cap.shift()) || 1,
                        day: (0, _utilsJs.toNumber)(cap.shift()) || 1
                    };
                    this.tokens.push(res);
                    return true;
                }
            }
        }
    ]);
    return Parser;
}();

},{"@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","./internal/utils.js":"iCH29","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"l2Z6w":[function(require,module,exports,__globalThis) {
/**
 * handle rule per event
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return Rule;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _caldate = require("caldate");
var _caldateDefault = parcelHelpers.interopDefault(_caldate);
var _utilsJs = require("./internal/utils.js");
var Rule = /*#__PURE__*/ function() {
    "use strict";
    function Rule(calEvent) {
        (0, _classCallCheck._)(this, Rule);
        this.calEvent = calEvent;
    }
    (0, _createClass._)(Rule, [
        {
            /**
   * @param {CalEvent} calEvent
   */ key: "setEvent",
            value: function setEvent(calEvent) {
                this.calEvent = calEvent;
                return this;
            }
        },
        {
            /**
   * @return {CalEvent}
   */ key: "getEvent",
            value: function getEvent() {
                return this.calEvent;
            }
        },
        {
            /**
   * @param {string} modifier
   */ key: "setModifier",
            value: function setModifier(modifier) {
                this.modifier = modifier;
            }
        },
        {
            /**
   * resolves rule to function
   * @param {object} rule
   */ key: "resolve",
            value: function resolve(rule) {
                if (rule.rule && typeof this[rule.rule] === 'function') this[rule.rule](rule);
                else if (rule.modifier) this.modifier = rule.modifier;
                return this;
            }
        },
        {
            /**
   * @param {CalEvent} [calEvent]
   * @param {object} rule
   * {
   *   rule: "dateDir",
   *   count: 1,
   *   weekday: "tuesday",
   *   direction: "after",
   *   omit: ['sunday']
   * }
   */ key: "dateDir",
            value: function dateDir(rule) {
                var omitWeekdays = [].concat(rule.omit).map(function(weekday) {
                    return (0, _utilsJs.DAYS)[weekday];
                }).filter(function(v) {
                    return !(0, _utilsJs.isNil)(v);
                });
                var isOmitDay = function(offset, weekday) {
                    var wd = offset + weekday;
                    while(wd < 0)wd += 70;
                    return omitWeekdays.includes(wd % 7);
                };
                this.calEvent.dates.forEach(function(date) {
                    var offset;
                    var count = rule.count - 1;
                    var weekday = date.getDay();
                    var ruleWeekday = (0, _utilsJs.DAYS)[rule.weekday];
                    var isDirBefore = [
                        'before',
                        'previous'
                    ].includes(rule.direction);
                    // correct count if weekday is same for next direction
                    if (rule.direction === 'next' && weekday === ruleWeekday) count += 1;
                    if (rule.weekday === 'day') {
                        var i = 0;
                        if (isDirBefore) {
                            offset = (count + 1) * -1;
                            while(i++ < 7 && isOmitDay(offset, weekday))offset -= 1;
                        } else {
                            offset = count + 1;
                            while(i++ < 7 && isOmitDay(offset, weekday))offset += 1;
                        }
                    } else if (isDirBefore) {
                        if (weekday === ruleWeekday) count++;
                        offset = ((7 + weekday - ruleWeekday) % 7 + count * 7) * -1;
                    } else offset = (7 - weekday + ruleWeekday) % 7 + count * 7;
                    if (offset) date.setOffset(offset);
                });
            }
        },
        {
            /**
   * @param {object} rule
   * {
   *   rule: "dateIfThen",
   *   if: ["sunday"],
   *   direction: "next",
   *   then: "sunday"
   * }
   */ key: "dateIfThen",
            value: function dateIfThen(rule) {
                var _this = this;
                var dates = [];
                this.calEvent.dates = this.calEvent.dates.map(function(date) {
                    if (date._lock) return date;
                    var weekday = date.getDay();
                    if (~rule.if.indexOf((0, _utilsJs.DAYS)[weekday])) {
                        if (_this.modifier === 'and') {
                            dates.push(new (0, _caldateDefault.default)(date));
                            date.substitute = true;
                        }
                        date._filter = false;
                        var offset = 0;
                        var then = (0, _utilsJs.DAYS)[rule.then];
                        if (rule.then && then !== 'undefined') {
                            if (rule.direction === 'previous') {
                                offset = -1 * ((7 + weekday - then) % 7);
                                if (!offset) offset = -7;
                            } else {
                                offset = (7 - weekday + then) % 7;
                                if (!offset) offset = 7;
                            }
                            date.setOffset(offset);
                            date._lock = true;
                            if (_this.modifier === 'substitutes') date.substitute = true;
                        }
                        (rule.rules || []).forEach(function(rule) {
                            switch(rule.rule){
                                case 'time':
                                    date.setTime(rule.hour, rule.minute);
                                    break;
                                case 'duration':
                                    date.duration = rule.duration;
                                    break;
                            }
                        });
                    } else if (_this.modifier === 'substitutes') date._filter = true;
                    return date;
                });
                this.calEvent.dates = dates.concat(this.calEvent.dates);
            }
        },
        {
            /**
   * @param {object} rule
   * {
   *   rule: "weekday",
   *   if: ["sunday", "saturday"],
   *   not: false,
   * }
   */ key: "weekday",
            value: function weekday(rule) {
                this.calEvent.dates = this.calEvent.dates.map(function(date) {
                    var weekday = date.getDay();
                    var match = rule.if.indexOf((0, _utilsJs.DAYS)[weekday]) !== -1;
                    if (rule.not) match = !match;
                    if (match) return date;
                }).filter(function(date) {
                    return date;
                });
            }
        },
        {
            key: "time",
            value: function time(rule) {
                this.calEvent.dates.forEach(function(date) {
                    date.setTime(rule.hour, rule.minute);
                });
            }
        },
        {
            key: "duration",
            value: function duration(rule) {
                this.calEvent.dates.forEach(function(date) {
                    date.duration = rule.duration;
                });
            }
        },
        {
            key: "bridge",
            value: function bridge() {
                return true // needs postprocessing
                ;
            }
        },
        {
            key: "ruleIfHoliday",
            value: function ruleIfHoliday() {
                return true // needs postprocessing
                ;
            }
        },
        {
            key: "activeFrom",
            value: function activeFrom(rule) {
                this.calEvent.setActive({
                    from: new (0, _caldateDefault.default)(rule).toDate()
                });
            }
        },
        {
            key: "activeTo",
            value: function activeTo(rule) {
                this.calEvent.setActive({
                    to: new (0, _caldateDefault.default)(rule).toDate()
                });
            }
        },
        {
            /**
   * @param {object} rule
   * {
   *   rule: "year",
   *   cardinality: "leap",
   *   every: undefined,
   *   since: undefined
   * }
   */ key: "year",
            value: function year(rule) {
                var _this = this;
                this.calEvent.dates = this.calEvent.dates.map(function(date) {
                    if (rule.cardinality) {
                        if (rule.cardinality === 'leap' && _this._isLeapYear(date.year)) return date;
                        else if (rule.cardinality === 'non-leap' && !_this._isLeapYear(date.year)) return date;
                        else if (rule.cardinality === 'even' && (date.year + 1) % 2) return date;
                        else if (rule.cardinality === 'odd' && date.year % 2) return date;
                    } else if (rule.every !== undefined && rule.since !== undefined) {
                        var tmp = (date.year - rule.since) % rule.every;
                        if (tmp === 0) return date;
                    }
                }).filter(function(date) {
                    return date;
                });
            }
        },
        {
            /**
   * @private
   * @return {Boolean} if true year is a leap year
   */ key: "_isLeapYear",
            value: function _isLeapYear(year) {
                if (year % 400 === 0 || year % 4 === 0 && year % 100 !== 0) return true;
                return false;
            }
        }
    ]);
    return Rule;
}();

},{"@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","caldate":"he6lr","./internal/utils.js":"iCH29","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"g0UlE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return PostRule;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _utilsJs = require("./utils.js");
var _ruleJs = require("./Rule.js");
var _ruleJsDefault = parcelHelpers.interopDefault(_ruleJs);
var _calEventJs = require("./CalEvent.js");
var _calEventJsDefault = parcelHelpers.interopDefault(_calEventJs);
var PostRule = /*#__PURE__*/ function() {
    "use strict";
    function PostRule(ruleStr, opts, holidays) {
        (0, _classCallCheck._)(this, PostRule);
        this.opts = opts;
        this.ruleStr = ruleStr;
        this.ruleSet = holidays && holidays[ruleStr];
        this.holidays = holidays;
        this.events = [];
    }
    (0, _createClass._)(PostRule, [
        {
            key: "push",
            value: function push(calEvent) {
                this.events.push(calEvent);
            }
        },
        {
            /**
   * @param {number} year
   * @returns {CalEvent}
   */ key: "getEvent",
            value: function getEvent(year) {
                var active = this.ruleSet && this.ruleSet.active;
                this.disable(year);
                var ev = this.events[0];
                ev.filterActive(year, active);
                return ev;
            }
        },
        {
            /**
   * @param {Array} rule
   * @param {number} year
   */ key: "resolve",
            value: function resolve(rule, year) {
                if (rule.rule && typeof this[rule.rule] === 'function') this[rule.rule](rule, year);
            }
        },
        {
            /**
   * @param {Array} rule
   * @param {number} year
   */ key: "bridge",
            value: function bridge(rule, year) {
                var found = new Array(this.events.length).fill(false);
                found[0] = true;
                var type = rule.type || 'public';
                // get all holidays of the given year
                for(var ruleStr in this.holidays){
                    var dateFn = this.holidays[ruleStr].fn;
                    if (dateFn && dateFn.ruleStr !== this.ruleStr) {
                        var tmpEv = dateFn.inYear(year);
                        var tmpEvType = (0, _utilsJs.get)(tmpEv, 'opts.type') || 'public';
                        for(var i = 1; i < this.events.length; i++){
                            if (found[i]) continue;
                            var isEqualDate = tmpEv.event.isEqualDate(this.events[i]);
                            if (isEqualDate && tmpEvType === type) found[i] = true;
                        }
                    }
                    if (!~found.indexOf(false)) break;
                }
                if (~found.indexOf(false)) this.events[0].reset();
            }
        },
        {
            key: "ruleIfHoliday",
            value: function ruleIfHoliday(rule, year) {
                var type = rule.type || 'public';
                // get all holidays of the given year
                for(var ruleStr in this.holidays){
                    var dateFn = this.holidays[ruleStr].fn;
                    if (dateFn && dateFn.ruleStr !== this.ruleStr) {
                        var tmpEv = dateFn.inYear(year);
                        var tmpEvType = (0, _utilsJs.get)(tmpEv, 'opts.type') || 'public';
                        for(var i = 0; i < this.events.length; i++){
                            var isEqualDate = tmpEv.event.isEqualDate(this.events[i]);
                            if (isEqualDate && tmpEvType === type) {
                                new (0, _ruleJsDefault.default)(this.events[i]).resolve((0, _objectSpreadProps._)((0, _objectSpread._)({}, rule), {
                                    rule: 'dateDir'
                                }));
                                return;
                            }
                        }
                    }
                }
            }
        },
        {
            /**
   * @param {number} year
   */ key: "disable",
            value: function disable(year) {
                var _ref = this.opts || {}, disable = _ref.disable, enable = _ref.enable;
                if (!disable || !disable.length) return;
                var ev = this.events[0];
                // check if exact event was disabled or moved
                var tmpEv = _findEventInYear(year, disable);
                if (tmpEv) {
                    if (tmpEv.isEqualDate(ev)) {
                        ev.reset();
                        tmpEv = _findEventInYear(year, enable);
                        if (tmpEv) this.events[0] = tmpEv;
                    }
                    return;
                }
                // simply check if the event can be disabled for year-(month)
                var _$_findDisabled = (0, _slicedToArray._)(_findDisabled(year, disable), 2), _year = _$_findDisabled[0], _month = _$_findDisabled[1];
                ev.filterDisabled(_year, _month);
            }
        }
    ]);
    return PostRule;
}();
var isoDate = function(isoDateStr) {
    return String(isoDateStr).split('-').map(function(v) {
        return (0, _utilsJs.toNumber)(v);
    });
};
function _findEventInYear(_year) {
    var arr = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = arr[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            var _isoDate = (0, _slicedToArray._)(isoDate(item), 3), year = _isoDate[0], month = _isoDate[1], day = _isoDate[2];
            if (year === _year && month && day) return new (0, _calEventJsDefault.default)({
                year: year,
                month: month,
                day: day
            }).inYear(year);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function _findDisabled(_year) {
    var arr = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = arr[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var isoDateStr = _step.value;
            var _isoDate = (0, _slicedToArray._)(isoDate(isoDateStr), 2), year = _isoDate[0], month = _isoDate[1];
            if (_year === year) return [
                year,
                month
            ];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return [];
}

},{"@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_object_spread_props":"fLCYP","@swc/helpers/_/_sliced_to_array":"ha6sq","./utils.js":"bGmqb","./Rule.js":"l2Z6w","./CalEvent.js":"jJ8pL","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jJ8pL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return CalEvent;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _utilsJs = require("./internal/utils.js");
var _caldate = require("caldate");
var _caldateDefault = parcelHelpers.interopDefault(_caldate);
var CalEvent = /*#__PURE__*/ function() {
    "use strict";
    function CalEvent(opts) {
        (0, _classCallCheck._)(this, CalEvent);
        opts = opts || {};
        this.substitute = opts.substitute;
        this.opts = opts;
        this.offset = opts.offset;
        this.dates = [];
        this.active = undefined // active props from prior to rule
        ;
        if ((0, _utilsJs.isDate)(opts)) this.opts = new (0, _caldateDefault.default)(opts);
    }
    (0, _createClass._)(CalEvent, [
        {
            /**
   * @param {number} year
   * @returns {this}
   */ key: "inYear",
            value: function inYear(year) {
                var d = new (0, _caldateDefault.default)(this.opts).setOffset(this.offset);
                if (!(d.year && d.year !== year)) {
                    d.year = year;
                    this.dates.push(d);
                }
                return this;
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.dates = [];
            }
        },
        {
            /**
   * @param {CalEvent} calEvent
   * @returns {boolean}
   */ key: "isEqualDate",
            value: function isEqualDate(calEvent) {
                var res = false;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator = this.dates[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                        var thisDate = _step.value;
                        try {
                            for(var _iterator1 = calEvent.dates[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                                var date = _step1.value;
                                res |= thisDate.isEqualDate(date);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                return !!res;
            }
        },
        {
            /**
   * Filter out disabled dates
   * @param {number} year
   * @param {number} month
   * @returns {this}
   */ key: "filterDisabled",
            value: function filterDisabled(year, month) {
                if (!year) return this;
                this.dates = this.dates.filter(function(date) {
                    var disable = month ? date.year === year && date.month === month : date.year === year;
                    return !disable;
                });
                return this;
            }
        },
        {
            /**
   * @param {number} year - year to filter
   * @param {object[]} active - definition of active ranges `{from: {Date}, [to]: {Date}}`
   * @return {this} for chaining
   */ key: "filterActive",
            value: function filterActive(year) {
                var active = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.active;
                this.dates = this.dates.filter(function(date) {
                    if (!date._filter && isActive(date, year, active)) return date;
                });
                return this;
            }
        },
        {
            /**
   * @param {object} active
   * @param {Date} [active.from ]
   * @param {Date} [active.to]
   * @returns
   */ key: "setActive",
            value: function setActive(active) {
                var from = active.from, to = active.to;
                var pushIt = true;
                this.active = this.active || [];
                if (to && !from) {
                    var last = this.active[this.active.length - 1];
                    if (last && last.from && !last.to) {
                        last.to = to;
                        pushIt = false;
                    }
                }
                if (pushIt) this.active.push(active);
                return this;
            }
        },
        {
            /**
   * @param {CalEvent} calEvent
   */ key: "push",
            value: function push(calEvent) {
                if (calEvent && Array.isArray(calEvent.dates)) this.dates = this.dates.concat(calEvent.dates);
            }
        },
        {
            /**
   * @param {string} timezone
   * @returns
   */ key: "get",
            value: function get(timezone) {
                var _this = this;
                var arr = this.dates.map(function(date) {
                    var cdate = new (0, _caldateDefault.default)(date);
                    var o = {
                        date: cdate.toString(),
                        start: cdate.toTimezone(timezone),
                        end: cdate.toEndDate().toTimezone(timezone)
                    };
                    _this._addSubstitute(date, o);
                    return o;
                });
                return arr;
            }
        },
        {
            key: "_addSubstitute",
            value: function _addSubstitute(date, obj) {
                if (this.substitute || date.substitute) obj.substitute = true;
            }
        }
    ]);
    return CalEvent;
}();
function isActive(date, year, active) {
    if (!active) return date.year === year;
    var _date = date.toDate();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = active[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var a = _step.value;
            var from = a.from, to = a.to;
            if (date.year === year && (from && to && from <= _date && to > _date || from && !to && from <= _date || !from && to && to > _date)) return true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}

},{"@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","./internal/utils.js":"iCH29","caldate":"he6lr","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"ao0Bw":[function(require,module,exports,__globalThis) {
/* eslint spaced-comment:0 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// #endif
parcelHelpers.export(exports, "default", function() {
    return CalEventFactory;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _calEventJs = require("./CalEvent.js");
var _calEventJsDefault = parcelHelpers.interopDefault(_calEventJs);
var _easterJs = require("./Easter.js");
var _easterJsDefault = parcelHelpers.interopDefault(_easterJs);
// --- pre-processor instructions for prepin ---
// #ifndef nojulian
var _julianJs = require("./Julian.js");
var _julianJsDefault = parcelHelpers.interopDefault(_julianJs);
// #endif
// #ifndef nohebrew
var _hebrewJs = require("./Hebrew.js");
var _hebrewJsDefault = parcelHelpers.interopDefault(_hebrewJs);
// #endif
// #ifndef noislamic
var _hijriJs = require("./Hijri.js");
var _hijriJsDefault = parcelHelpers.interopDefault(_hijriJs);
// #endif
// #ifndef nojalaali
var _jalaaliJs = require("./Jalaali.js");
var _jalaaliJsDefault = parcelHelpers.interopDefault(_jalaaliJs);
// #endif
// #ifndef noequinox
var _equinoxJs = require("./Equinox.js");
var _equinoxJsDefault = parcelHelpers.interopDefault(_equinoxJs);
// #endif
// #ifndef nochinese
var _chineseJs = require("./Chinese.js");
var _chineseJsDefault = parcelHelpers.interopDefault(_chineseJs);
// #endif
// #ifndef nobengali
var _bengaliRevisedJs = require("./BengaliRevised.js");
var _bengaliRevisedJsDefault = parcelHelpers.interopDefault(_bengaliRevisedJs);
var CalEventFactory = function CalEventFactory(opts) {
    "use strict";
    (0, _classCallCheck._)(this, CalEventFactory);
    switch(opts.fn){
        case 'easter':
            return new (0, _easterJsDefault.default)(opts);
        // #ifndef nojulian
        case 'julian':
            return new (0, _julianJsDefault.default)(opts);
        // #endif
        // #ifndef nohebrew
        case 'hebrew':
            return new (0, _hebrewJsDefault.default)(opts);
        // #endif
        // #ifndef noislamic
        case 'islamic':
            return new (0, _hijriJsDefault.default)(opts);
        // #endif
        // #ifndef nojalaali
        case 'jalaali':
            return new (0, _jalaaliJsDefault.default)(opts);
        // #endif
        // #ifndef noequinox
        case 'equinox':
            return new (0, _equinoxJsDefault.default)(opts);
        // #endif
        // #ifndef nochinese
        case 'chinese':
        case 'korean':
        case 'vietnamese':
            return new (0, _chineseJsDefault.default)(opts);
        // #endif
        // #ifndef nobengali
        case 'bengali-revised':
            return new (0, _bengaliRevisedJsDefault.default)(opts);
        // #endif
        default:
            return new (0, _calEventJsDefault.default)(opts);
    }
};

},{"@swc/helpers/_/_class_call_check":"6UdKs","./CalEvent.js":"jJ8pL","./Easter.js":"S49Yh","./Julian.js":"fcVqT","./Hebrew.js":"3Tj3D","./Hijri.js":"1a37f","./Jalaali.js":"1Kzzt","./Equinox.js":"6BQ2F","./Chinese.js":"1fwX5","./BengaliRevised.js":"1TGGS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"S49Yh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return Easter;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _dateEaster = require("date-easter");
var _dateEasterDefault = parcelHelpers.interopDefault(_dateEaster);
var _caldate = require("caldate");
var _caldateDefault = parcelHelpers.interopDefault(_caldate);
var _calEventJs = require("./CalEvent.js");
var _calEventJsDefault = parcelHelpers.interopDefault(_calEventJs);
var Easter = /*#__PURE__*/ function(CalEvent) {
    "use strict";
    (0, _inherits._)(Easter, CalEvent);
    function Easter(opts) {
        (0, _classCallCheck._)(this, Easter);
        var _this;
        opts = opts || {};
        _this = (0, _callSuper._)(this, Easter, [
            opts
        ]);
        _this._fn = (0, _dateEasterDefault.default).easter;
        if (opts.type === 'orthodox') _this._fn = (0, _dateEasterDefault.default).orthodoxEaster;
        return _this;
    }
    (0, _createClass._)(Easter, [
        {
            key: "inYear",
            value: function inYear(year) {
                var d = new (0, _caldateDefault.default)(this._fn(year)).setOffset(this.offset);
                this.dates.push(d);
                return this;
            }
        }
    ]);
    return Easter;
}((0, _calEventJsDefault.default));

},{"@swc/helpers/_/_call_super":"5oPMc","@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","@swc/helpers/_/_inherits":"j8HRi","date-easter":"c5f75","caldate":"he6lr","./CalEvent.js":"jJ8pL","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"c5f75":[function(require,module,exports,__globalThis) {
/**
 * @private
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EasterDate", function() {
    return EasterDate;
});
/**
 * Calculate easter sunday in the gregorian calendar
 * @param {Date|Number} year
 * @return {EasterDate}
 */ parcelHelpers.export(exports, "gregorianEaster", function() {
    return gregorianEaster;
});
parcelHelpers.export(exports, "easter", function() {
    return easter;
});
/**
 * Calculate easter sunday in the julian calendar
 * @param {Date|Number} year
 * @return {EasterDate}
 */ parcelHelpers.export(exports, "julianEaster", function() {
    return julianEaster;
});
/**
 * Orthodox Easter in gregorian calender
 * @param {Date|Number} year
 * @return {EasterDate}
 */ parcelHelpers.export(exports, "orthodoxEaster", function() {
    return orthodoxEaster;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
function _toYear(year) {
    if (!year) year = new Date().getFullYear();
    else if (year instanceof Date) year = year.getFullYear();
    else if (typeof year === 'string') year = parseInt(year, 10);
    return year;
}
function pre(num, l) {
    l = l || 2;
    var s = '0000' + num;
    return s.substr(s.length - l, l);
}
var EasterDate = /*#__PURE__*/ function() {
    "use strict";
    function EasterDate(year, month, day) {
        (0, _classCallCheck._)(this, EasterDate);
        this.year = year;
        this.month = month;
        this.day = day;
    }
    (0, _createClass._)(EasterDate, [
        {
            key: "toString",
            value: function toString() {
                return [
                    pre(this.year, 4),
                    pre(this.month),
                    pre(this.day)
                ].join('-');
            }
        }
    ]);
    return EasterDate;
}();
/**
 * from https://de.wikipedia.org/wiki/Gau%C3%9Fsche_Osterformel
 * ergänzte Formel
 */ function _easter(year, julian, gregorian) {
    year = _toYear(year);
    var k = Math.floor(year / 100);
    var m = 15 + Math.floor((3 * k + 3) / 4) - Math.floor((8 * k + 13) / 25);
    var s = 2 - Math.floor((3 * k + 3) / 4);
    if (julian) {
        m = 15;
        s = 0;
    }
    var a = year % 19;
    var d = (19 * a + m) % 30;
    var r = Math.floor((d + a / 11) / 29);
    var og = 21 + d - r;
    var sz = 7 - Math.floor(year + year / 4 + s) % 7;
    var oe = 7 - (og - sz) % 7;
    var os = og + oe;
    if (gregorian) os = os + Math.floor(year / 100) - Math.floor(year / 400) - 2;
    //                        1   2   3   4   5   6   7   8
    var daysPerMonth = [
        0,
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31
    ];
    var day = os;
    var month;
    for(month = 3; month < 8; month++){
        if (day <= daysPerMonth[month]) break;
        day -= daysPerMonth[month];
    }
    return new EasterDate(year, month, day);
}
function gregorianEaster(year) {
    return _easter(year);
}
var easter = gregorianEaster;
function julianEaster(year) {
    return _easter(year, true);
}
function orthodoxEaster(year) {
    return _easter(year, true, true);
}
exports.default = {
    easter: easter,
    gregorianEaster: gregorianEaster,
    julianEaster: julianEaster,
    orthodoxEaster: orthodoxEaster
};

},{"@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"fcVqT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return Julian;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _astronomia = require("astronomia");
var _caldate = require("caldate");
var _caldateDefault = parcelHelpers.interopDefault(_caldate);
var _calEventJs = require("./CalEvent.js");
var _calEventJsDefault = parcelHelpers.interopDefault(_calEventJs);
var Julian = /*#__PURE__*/ function(CalEvent) {
    "use strict";
    (0, _inherits._)(Julian, CalEvent);
    function Julian() {
        (0, _classCallCheck._)(this, Julian);
        return (0, _callSuper._)(this, Julian, arguments);
    }
    (0, _createClass._)(Julian, [
        {
            key: "inYear",
            value: function inYear(year) {
                if (this.opts.year && this.opts.year !== year) return this;
                var cal = new (0, _astronomia.julian).CalendarJulian(year, this.opts.month, this.opts.day).toGregorian();
                var d = new (0, _caldateDefault.default)(cal).setOffset(this.offset);
                this.dates.push(d);
                return this;
            }
        }
    ]);
    return Julian;
}((0, _calEventJsDefault.default));

},{"@swc/helpers/_/_call_super":"5oPMc","@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","@swc/helpers/_/_inherits":"j8HRi","astronomia":"03wmo","caldate":"he6lr","./CalEvent.js":"jJ8pL","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"03wmo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "angle", function() {
    return 0, _angleJsDefault.default;
});
parcelHelpers.export(exports, "apparent", function() {
    return 0, _apparentJsDefault.default;
});
parcelHelpers.export(exports, "apsis", function() {
    return 0, _apsisJsDefault.default;
});
parcelHelpers.export(exports, "base", function() {
    return 0, _baseJsDefault.default;
});
parcelHelpers.export(exports, "binary", function() {
    return 0, _binaryJsDefault.default;
});
parcelHelpers.export(exports, "coord", function() {
    return 0, _coordJsDefault.default;
});
parcelHelpers.export(exports, "conjunction", function() {
    return 0, _conjunctionJsDefault.default;
});
parcelHelpers.export(exports, "circle", function() {
    return 0, _circleJsDefault.default;
});
parcelHelpers.export(exports, "deltat", function() {
    return 0, _deltatJsDefault.default;
});
parcelHelpers.export(exports, "elementequinox", function() {
    return 0, _elementequinoxJsDefault.default;
});
parcelHelpers.export(exports, "elliptic", function() {
    return 0, _ellipticJsDefault.default;
});
parcelHelpers.export(exports, "eclipse", function() {
    return 0, _eclipseJsDefault.default;
});
parcelHelpers.export(exports, "elp", function() {
    return 0, _elpJsDefault.default;
});
parcelHelpers.export(exports, "eqtime", function() {
    return 0, _eqtimeJsDefault.default;
});
parcelHelpers.export(exports, "fit", function() {
    return 0, _fitJsDefault.default;
});
parcelHelpers.export(exports, "globe", function() {
    return 0, _globeJsDefault.default;
});
parcelHelpers.export(exports, "illum", function() {
    return 0, _illumJsDefault.default;
});
parcelHelpers.export(exports, "interpolation", function() {
    return 0, _interpolationJsDefault.default;
});
parcelHelpers.export(exports, "iterate", function() {
    return 0, _iterateJsDefault.default;
});
parcelHelpers.export(exports, "jm", function() {
    return 0, _jmJsDefault.default;
});
parcelHelpers.export(exports, "julian", function() {
    return 0, _julianJsDefault.default;
});
parcelHelpers.export(exports, "jupiter", function() {
    return 0, _jupiterJsDefault.default;
});
parcelHelpers.export(exports, "jupitermoons", function() {
    return 0, _jupitermoonsJsDefault.default;
});
parcelHelpers.export(exports, "kepler", function() {
    return 0, _keplerJsDefault.default;
});
parcelHelpers.export(exports, "line", function() {
    return 0, _lineJsDefault.default;
});
parcelHelpers.export(exports, "nearparabolic", function() {
    return 0, _nearparabolicJsDefault.default;
});
parcelHelpers.export(exports, "node", function() {
    return 0, _nodeJsDefault.default;
});
parcelHelpers.export(exports, "nutation", function() {
    return 0, _nutationJsDefault.default;
});
parcelHelpers.export(exports, "mars", function() {
    return 0, _marsJsDefault.default;
});
parcelHelpers.export(exports, "moon", function() {
    return 0, _moonJsDefault.default;
});
parcelHelpers.export(exports, "moonillum", function() {
    return 0, _moonillumJsDefault.default;
});
parcelHelpers.export(exports, "moonmaxdec", function() {
    return 0, _moonmaxdecJsDefault.default;
});
parcelHelpers.export(exports, "moonnode", function() {
    return 0, _moonnodeJsDefault.default;
});
parcelHelpers.export(exports, "moonphase", function() {
    return 0, _moonphaseJsDefault.default;
});
parcelHelpers.export(exports, "moonposition", function() {
    return 0, _moonpositionJsDefault.default;
});
parcelHelpers.export(exports, "parabolic", function() {
    return 0, _parabolicJsDefault.default;
});
parcelHelpers.export(exports, "parallax", function() {
    return 0, _parallaxJsDefault.default;
});
parcelHelpers.export(exports, "parallactic", function() {
    return 0, _parallacticJsDefault.default;
});
parcelHelpers.export(exports, "perihelion", function() {
    return 0, _perihelionJsDefault.default;
});
parcelHelpers.export(exports, "planetary", function() {
    return 0, _planetaryJsDefault.default;
});
parcelHelpers.export(exports, "planetposition", function() {
    return 0, _planetpositionJsDefault.default;
});
parcelHelpers.export(exports, "planetelements", function() {
    return 0, _planetelementsJsDefault.default;
});
parcelHelpers.export(exports, "pluto", function() {
    return 0, _plutoJsDefault.default;
});
parcelHelpers.export(exports, "precess", function() {
    return 0, _precessJsDefault.default;
});
parcelHelpers.export(exports, "refraction", function() {
    return 0, _refractionJsDefault.default;
});
parcelHelpers.export(exports, "rise", function() {
    return 0, _riseJsDefault.default;
});
parcelHelpers.export(exports, "saturnmoons", function() {
    return 0, _saturnmoonsJsDefault.default;
});
parcelHelpers.export(exports, "saturnring", function() {
    return 0, _saturnringJsDefault.default;
});
parcelHelpers.export(exports, "sexagesimal", function() {
    return 0, _sexagesimalJsDefault.default;
});
parcelHelpers.export(exports, "sidereal", function() {
    return 0, _siderealJsDefault.default;
});
parcelHelpers.export(exports, "solar", function() {
    return 0, _solarJsDefault.default;
});
parcelHelpers.export(exports, "solardisk", function() {
    return 0, _solardiskJsDefault.default;
});
parcelHelpers.export(exports, "solarxyz", function() {
    return 0, _solarxyzJsDefault.default;
});
parcelHelpers.export(exports, "solstice", function() {
    return 0, _solsticeJsDefault.default;
});
parcelHelpers.export(exports, "stellar", function() {
    return 0, _stellarJsDefault.default;
});
parcelHelpers.export(exports, "sundial", function() {
    return 0, _sundialJsDefault.default;
});
parcelHelpers.export(exports, "sunrise", function() {
    return 0, _sunriseJsDefault.default;
});
var _angleJs = require("./angle.js");
var _angleJsDefault = parcelHelpers.interopDefault(_angleJs);
var _apparentJs = require("./apparent.js");
var _apparentJsDefault = parcelHelpers.interopDefault(_apparentJs);
var _apsisJs = require("./apsis.js");
var _apsisJsDefault = parcelHelpers.interopDefault(_apsisJs);
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var _binaryJs = require("./binary.js");
var _binaryJsDefault = parcelHelpers.interopDefault(_binaryJs);
var _coordJs = require("./coord.js");
var _coordJsDefault = parcelHelpers.interopDefault(_coordJs);
var _conjunctionJs = require("./conjunction.js");
var _conjunctionJsDefault = parcelHelpers.interopDefault(_conjunctionJs);
var _circleJs = require("./circle.js");
var _circleJsDefault = parcelHelpers.interopDefault(_circleJs);
var _deltatJs = require("./deltat.js");
var _deltatJsDefault = parcelHelpers.interopDefault(_deltatJs);
var _elementequinoxJs = require("./elementequinox.js");
var _elementequinoxJsDefault = parcelHelpers.interopDefault(_elementequinoxJs);
var _ellipticJs = require("./elliptic.js");
var _ellipticJsDefault = parcelHelpers.interopDefault(_ellipticJs);
var _eclipseJs = require("./eclipse.js");
var _eclipseJsDefault = parcelHelpers.interopDefault(_eclipseJs);
var _elpJs = require("./elp.js");
var _elpJsDefault = parcelHelpers.interopDefault(_elpJs);
var _eqtimeJs = require("./eqtime.js");
var _eqtimeJsDefault = parcelHelpers.interopDefault(_eqtimeJs);
var _fitJs = require("./fit.js");
var _fitJsDefault = parcelHelpers.interopDefault(_fitJs);
var _globeJs = require("./globe.js");
var _globeJsDefault = parcelHelpers.interopDefault(_globeJs);
var _illumJs = require("./illum.js");
var _illumJsDefault = parcelHelpers.interopDefault(_illumJs);
var _interpolationJs = require("./interpolation.js");
var _interpolationJsDefault = parcelHelpers.interopDefault(_interpolationJs);
var _iterateJs = require("./iterate.js");
var _iterateJsDefault = parcelHelpers.interopDefault(_iterateJs);
var _jmJs = require("./jm.js");
var _jmJsDefault = parcelHelpers.interopDefault(_jmJs);
var _julianJs = require("./julian.js");
var _julianJsDefault = parcelHelpers.interopDefault(_julianJs);
var _jupiterJs = require("./jupiter.js");
var _jupiterJsDefault = parcelHelpers.interopDefault(_jupiterJs);
var _jupitermoonsJs = require("./jupitermoons.js");
var _jupitermoonsJsDefault = parcelHelpers.interopDefault(_jupitermoonsJs);
var _keplerJs = require("./kepler.js");
var _keplerJsDefault = parcelHelpers.interopDefault(_keplerJs);
var _lineJs = require("./line.js");
var _lineJsDefault = parcelHelpers.interopDefault(_lineJs);
var _nearparabolicJs = require("./nearparabolic.js");
var _nearparabolicJsDefault = parcelHelpers.interopDefault(_nearparabolicJs);
var _nodeJs = require("./node.js");
var _nodeJsDefault = parcelHelpers.interopDefault(_nodeJs);
var _nutationJs = require("./nutation.js");
var _nutationJsDefault = parcelHelpers.interopDefault(_nutationJs);
var _marsJs = require("./mars.js");
var _marsJsDefault = parcelHelpers.interopDefault(_marsJs);
var _moonJs = require("./moon.js");
var _moonJsDefault = parcelHelpers.interopDefault(_moonJs);
var _moonillumJs = require("./moonillum.js");
var _moonillumJsDefault = parcelHelpers.interopDefault(_moonillumJs);
var _moonmaxdecJs = require("./moonmaxdec.js");
var _moonmaxdecJsDefault = parcelHelpers.interopDefault(_moonmaxdecJs);
var _moonnodeJs = require("./moonnode.js");
var _moonnodeJsDefault = parcelHelpers.interopDefault(_moonnodeJs);
var _moonphaseJs = require("./moonphase.js");
var _moonphaseJsDefault = parcelHelpers.interopDefault(_moonphaseJs);
var _moonpositionJs = require("./moonposition.js");
var _moonpositionJsDefault = parcelHelpers.interopDefault(_moonpositionJs);
var _parabolicJs = require("./parabolic.js");
var _parabolicJsDefault = parcelHelpers.interopDefault(_parabolicJs);
var _parallaxJs = require("./parallax.js");
var _parallaxJsDefault = parcelHelpers.interopDefault(_parallaxJs);
var _parallacticJs = require("./parallactic.js");
var _parallacticJsDefault = parcelHelpers.interopDefault(_parallacticJs);
var _perihelionJs = require("./perihelion.js");
var _perihelionJsDefault = parcelHelpers.interopDefault(_perihelionJs);
var _planetaryJs = require("./planetary.js");
var _planetaryJsDefault = parcelHelpers.interopDefault(_planetaryJs);
var _planetpositionJs = require("./planetposition.js");
var _planetpositionJsDefault = parcelHelpers.interopDefault(_planetpositionJs);
var _planetelementsJs = require("./planetelements.js");
var _planetelementsJsDefault = parcelHelpers.interopDefault(_planetelementsJs);
var _plutoJs = require("./pluto.js");
var _plutoJsDefault = parcelHelpers.interopDefault(_plutoJs);
var _precessJs = require("./precess.js");
var _precessJsDefault = parcelHelpers.interopDefault(_precessJs);
var _refractionJs = require("./refraction.js");
var _refractionJsDefault = parcelHelpers.interopDefault(_refractionJs);
var _riseJs = require("./rise.js");
var _riseJsDefault = parcelHelpers.interopDefault(_riseJs);
var _saturnmoonsJs = require("./saturnmoons.js");
var _saturnmoonsJsDefault = parcelHelpers.interopDefault(_saturnmoonsJs);
var _saturnringJs = require("./saturnring.js");
var _saturnringJsDefault = parcelHelpers.interopDefault(_saturnringJs);
var _sexagesimalJs = require("./sexagesimal.js");
var _sexagesimalJsDefault = parcelHelpers.interopDefault(_sexagesimalJs);
var _siderealJs = require("./sidereal.js");
var _siderealJsDefault = parcelHelpers.interopDefault(_siderealJs);
var _solarJs = require("./solar.js");
var _solarJsDefault = parcelHelpers.interopDefault(_solarJs);
var _solardiskJs = require("./solardisk.js");
var _solardiskJsDefault = parcelHelpers.interopDefault(_solardiskJs);
var _solarxyzJs = require("./solarxyz.js");
var _solarxyzJsDefault = parcelHelpers.interopDefault(_solarxyzJs);
var _solsticeJs = require("./solstice.js");
var _solsticeJsDefault = parcelHelpers.interopDefault(_solsticeJs);
var _stellarJs = require("./stellar.js");
var _stellarJsDefault = parcelHelpers.interopDefault(_stellarJs);
var _sundialJs = require("./sundial.js");
var _sundialJsDefault = parcelHelpers.interopDefault(_sundialJs);
var _sunriseJs = require("./sunrise.js");
var _sunriseJsDefault = parcelHelpers.interopDefault(_sunriseJs);

},{"./angle.js":"kpRCF","./apparent.js":"5Tqj8","./apsis.js":"hPOFS","./base.js":"lEDxD","./binary.js":"8sMWx","./coord.js":"kTRDS","./conjunction.js":"22rsu","./circle.js":"1DoWK","./deltat.js":"7sn4F","./elementequinox.js":"kF9iX","./elliptic.js":"01gWQ","./eclipse.js":"c4LIa","./elp.js":"8Jwzm","./eqtime.js":"gGIfy","./fit.js":"ir22U","./globe.js":"fqyqU","./illum.js":"9pTbU","./interpolation.js":"1h22R","./iterate.js":"gw6ZZ","./jm.js":"kzx1b","./julian.js":"hLXQt","./jupiter.js":"5XjXz","./jupitermoons.js":"24N44","./kepler.js":"hqcOu","./line.js":"8Z5Fc","./nearparabolic.js":"ldiBl","./node.js":"eaFAI","./nutation.js":"jqV8z","./mars.js":"imh40","./moon.js":"d0IPX","./moonillum.js":"kORfy","./moonmaxdec.js":"htGUq","./moonnode.js":"1IQvk","./moonphase.js":"3ttcq","./moonposition.js":"hSxi8","./parabolic.js":"fvyBD","./parallax.js":"7CD6n","./parallactic.js":"b1Fva","./perihelion.js":"jwmNT","./planetary.js":"9utPC","./planetposition.js":"8l87z","./planetelements.js":"jVTYS","./pluto.js":"a7zDU","./precess.js":"iqQIL","./refraction.js":"axMFf","./rise.js":"dhSt3","./saturnmoons.js":"leX0f","./saturnring.js":"kZPfC","./sexagesimal.js":"aLUGo","./sidereal.js":"c4ZrF","./solar.js":"d2aLm","./solardisk.js":"h2Ie1","./solarxyz.js":"bIzgX","./solstice.js":"203jz","./stellar.js":"f5H0X","./sundial.js":"6ivgv","./sunrise.js":"iTup9","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"kpRCF":[function(require,module,exports,__globalThis) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module angle
 */ /**
 * Angle: Chapter 17: Angular Separation.
 *
 * Functions in this package are useful for Ecliptic, Equatorial, or any
 * similar coordinate frame.  To avoid suggestion of a particular frame,
 * function parameters are specified simply as "r1, d1" to correspond to a
 * right ascenscion, declination pair or to a longitude, latitude pair.
 *
 * In function Sep, Meeus recommends 10 arc min as a threshold.  This
 * value is in package base as base.SmallAngle because it has general utility.
 *
 * All angles are in radians.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * `sep` returns the angular separation between two celestial bodies.
 *
 * The algorithm is numerically naïve, and while patched up a bit for
 * small separations, remains unstable for separations near π.
 *
 * @param {Coord} c1 - coordinate of celestial body 1
 * @param {Coord} c2 - coordinate of celestial body 2
 * @return {Number} angular separation between two celestial bodies
 */ parcelHelpers.export(exports, "sep", function() {
    return sep;
});
/**
 * `minSep` returns the minimum separation between two moving objects.
 *
 * The motion is represented as an ephemeris of three rows, equally spaced
 * in time.  Jd1, jd3 are julian day times of the first and last rows.
 * R1, d1, r2, d2 are coordinates at the three times.  They must each be
 * slices of length 3.0
 *
 * Result is obtained by computing separation at each of the three times
 * and interpolating a minimum.  This may be invalid for sufficiently close
 * approaches.
 *
 * @throws Error
 * @param {Number} jd1 - Julian day - time at cs1[0], cs2[0]
 * @param {Number} jd3 - Julian day - time at cs1[2], cs2[2]
 * @param {Coord[]} cs1 - 3 coordinates of moving object 1
 * @param {Coord[]} cs2 - 3 coordinates of moving object 2
 * @param {function} [fnSep] - alternative `sep` function e.g. `angle.sepPauwels`, `angle.sepHav`
 * @return {Number} angular separation between two celestial bodies
 */ parcelHelpers.export(exports, "minSep", function() {
    return minSep;
});
/**
 * `minSepRect` returns the minimum separation between two moving objects.
 *
 * Like `minSep`, but using a method of rectangular coordinates that gives
 * accurate results even for close approaches.
 *
 * @throws Error
 * @param {Number} jd1 - Julian day - time at cs1[0], cs2[0]
 * @param {Number} jd3 - Julian day - time at cs1[2], cs2[2]
 * @param {Coord[]} cs1 - 3 coordinates of moving object 1
 * @param {Coord[]} cs2 - 3 coordinates of moving object 2
 * @return {Number} angular separation between two celestial bodies
 */ parcelHelpers.export(exports, "minSepRect", function() {
    return minSepRect;
});
/**
 * haversine function (17.5) p. 115
 */ parcelHelpers.export(exports, "hav", function() {
    return hav;
});
/**
 * `sepHav` returns the angular separation between two celestial bodies.
 *
 * The algorithm uses the haversine function and is superior to the naïve
 * algorithm of the Sep function.
 *
 * @param {Coord} c1 - coordinate of celestial body 1
 * @param {Coord} c2 - coordinate of celestial body 2
 * @return {Number} angular separation between two celestial bodies
 */ parcelHelpers.export(exports, "sepHav", function() {
    return sepHav;
});
/**
 * Same as `minSep` but uses function `sepHav` to return the minimum separation
 * between two moving objects.
 */ parcelHelpers.export(exports, "minSepHav", function() {
    return minSepHav;
});
/**
 * `sepPauwels` returns the angular separation between two celestial bodies.
 *
 * The algorithm is a numerically stable form of that used in `sep`.
 *
 * @param {Coord} c1 - coordinate of celestial body 1
 * @param {Coord} c2 - coordinate of celestial body 2
 * @return {Number} angular separation between two celestial bodies
 */ parcelHelpers.export(exports, "sepPauwels", function() {
    return sepPauwels;
});
/**
 * Same as `minSep` but uses function `sepPauwels` to return the minimum
 * separation between two moving objects.
 */ parcelHelpers.export(exports, "minSepPauwels", function() {
    return minSepPauwels;
});
/**
 * RelativePosition returns the position angle of one body with respect to
 * another.
 *
 * The position angle result `p` is measured counter-clockwise from North.
 * If negative then `p` is in the range of 90° ... 270°
 *
 * ````
 *                  North
 *                    |
 *             (p)  ..|
 *                 .  |
 *                V   |
 *    c1 x------------x c2
 *                    |
 * ````
 *
 * @param {Coord} c1 - coordinate of celestial body 1
 * @param {Coord} c2 - coordinate of celestial body 2
 * @return {Number} position angle (p)
 */ parcelHelpers.export(exports, "relativePosition", function() {
    return relativePosition;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _baseJs = require("./base.js"); // eslint-disable-line no-unused-vars
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var _interpolationJs = require("./interpolation.js");
var _interpolationJsDefault = parcelHelpers.interopDefault(_interpolationJs);
var abs = Math.abs, acos = Math.acos, asin = Math.asin, atan2 = Math.atan2, cos = Math.cos, hypot = Math.hypot, sin = Math.sin, sqrt = Math.sqrt, tan = Math.tan;
function sep(c1, c2) {
    var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(c1.dec), 2), sind1 = _base_sincos[0], cosd1 = _base_sincos[1];
    var _base_sincos1 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(c2.dec), 2), sind2 = _base_sincos1[0], cosd2 = _base_sincos1[1];
    var cd = sind1 * sind2 + cosd1 * cosd2 * cos(c1.ra - c2.ra) // (17.1) p. 109
    ;
    if (cd < (0, _baseJsDefault.default).CosSmallAngle) return acos(cd);
    else {
        var cosd = cos((c2.dec + c1.dec) / 2) // average dec of two bodies
        ;
        return hypot((c2.ra - c1.ra) * cosd, c2.dec - c1.dec) // (17.2) p. 109
        ;
    }
}
function minSep(jd1, jd3, cs1, cs2, fnSep) {
    fnSep = fnSep || sep;
    if (cs1.length !== 3 || cs2.length !== 3) throw (0, _interpolationJsDefault.default).errorNot3;
    var y = new Array(3);
    cs1.forEach(function(c, x) {
        y[x] = sep(cs1[x], cs2[x]);
    });
    var d3 = new (0, _interpolationJsDefault.default).Len3(jd1, jd3, y);
    var dMin = d3.extremum()[1];
    return dMin;
}
function minSepRect(jd1, jd3, cs1, cs2) {
    if (cs1.length !== 3 || cs2.length !== 3) throw (0, _interpolationJsDefault.default).ErrorNot3;
    var uv = function uv(c1, c2) {
        var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(c1.dec), 2), sind1 = _base_sincos[0], cosd1 = _base_sincos[1];
        var \u0394r = c2.ra - c1.ra;
        var tan\u0394r = tan(\u0394r);
        var tanh\u0394r = tan(\u0394r / 2);
        var K = 1 / (1 + sind1 * sind1 * tan\u0394r * tanh\u0394r);
        var sin\u0394d = sin(c2.dec - c1.dec);
        var u = -K * (1 - sind1 / cosd1 * sin\u0394d) * cosd1 * tan\u0394r;
        var v = K * (sin\u0394d + sind1 * cosd1 * tan\u0394r * tanh\u0394r);
        return [
            u,
            v
        ];
    };
    var us = new Array(3).fill(0);
    var vs = new Array(3).fill(0);
    cs1.forEach(function(c, x) {
        var ref;
        ref = (0, _slicedToArray._)(uv(cs1[x], cs2[x]), 2), us[x] = ref[0], vs[x] = ref[1], ref;
    });
    var u3 = new (0, _interpolationJsDefault.default).Len3(-1, 1, us) // if line throws then bug not caller's fault.
    ;
    var v3 = new (0, _interpolationJsDefault.default).Len3(-1, 1, vs) // if line throws then bug not caller's fault.
    ;
    var up0 = (us[2] - us[0]) / 2;
    var vp0 = (vs[2] - vs[0]) / 2;
    var up1 = us[0] + us[2] - 2 * us[1];
    var vp1 = vs[0] + vs[2] - 2 * vs[1];
    var up = up0;
    var vp = vp0;
    var dn = -(us[1] * up + vs[1] * vp) / (up * up + vp * vp);
    var n = dn;
    var u;
    var v;
    for(var limit = 0; limit < 10; limit++){
        u = u3.interpolateN(n);
        v = v3.interpolateN(n);
        if (abs(dn) < 1e-5) return hypot(u, v) // success
        ;
        var up2 = up0 + n * up1;
        var vp2 = vp0 + n * vp1;
        dn = -(u * up2 + v * vp2) / (up2 * up2 + vp2 * vp2);
        n += dn;
    }
    throw new Error('minSepRect: failure to converge');
}
function hav(a) {
    return 0.5 * (1 - Math.cos(a));
}
function sepHav(c1, c2) {
    // using (17.5) p. 115
    return 2 * asin(sqrt(hav(c2.dec - c1.dec) + cos(c1.dec) * cos(c2.dec) * hav(c2.ra - c1.ra)));
}
function minSepHav(jd1, jd3, cs1, cs2) {
    return minSep(jd1, jd3, cs1, cs2, sepHav);
}
function sepPauwels(c1, c2) {
    var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(c1.dec), 2), sind1 = _base_sincos[0], cosd1 = _base_sincos[1];
    var _base_sincos1 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(c2.dec), 2), sind2 = _base_sincos1[0], cosd2 = _base_sincos1[1];
    var cosdr = cos(c2.ra - c1.ra);
    var x = cosd1 * sind2 - sind1 * cosd2 * cosdr;
    var y = cosd2 * sin(c2.ra - c1.ra);
    var z = sind1 * sind2 + cosd1 * cosd2 * cosdr;
    return atan2(hypot(x, y), z);
}
function minSepPauwels(jd1, jd3, cs1, cs2) {
    return minSep(jd1, jd3, cs1, cs2, sepPauwels);
}
function relativePosition(c1, c2) {
    var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(c1.ra - c2.ra), 2), sin\u0394r = _base_sincos[0], cos\u0394r = _base_sincos[1];
    var _base_sincos1 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(c2.dec), 2), sind2 = _base_sincos1[0], cosd2 = _base_sincos1[1];
    var p = atan2(sin\u0394r, cosd2 * tan(c1.dec) - sind2 * cos\u0394r);
    return p;
}
exports.default = {
    sep: sep,
    minSep: minSep,
    minSepRect: minSepRect,
    hav: hav,
    sepHav: sepHav,
    minSepHav: minSepHav,
    sepPauwels: sepPauwels,
    minSepPauwels: minSepPauwels,
    relativePosition: relativePosition
};

},{"@swc/helpers/_/_sliced_to_array":"ha6sq","./base.js":"lEDxD","./interpolation.js":"1h22R","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"lEDxD":[function(require,module,exports,__globalThis) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module base
 */ /**
 * Base: Functions and other definitions useful with multiple packages.
 *
 * Base contains various definitions and support functions useful in multiple
 * chapters.
 *
 * Bessellian and Julian Year
 *
 * Chapter 21, Precession actually contains these definitions.  They are moved
 * here because of their general utility.
 *
 * Chapter 22, Nutation contains the function for Julian centuries since J2000.
 *
 * Phase angle functions
 *
 * Two functions, Illuminated and Limb, concern the illumnated phase of a body
 * and are given in two chapters, 41 an 48.  They are collected here because
 * the identical functions apply in both chapters.
 *
 * General purpose math functions
 *
 * SmallAngle is recommended in chapter 17, p. 109.
 *
 * PMod addresses the issue on p. 7, chapter 1, in the section "Trigonometric
 * functions of large angles", but the function is not written to be specific
 * to angles and so has more general utility.
 *
 * Horner is described on p. 10, chapter 1.
 *
 * FloorDiv and FloorDiv64 are optimizations for the INT function described
 * on p. 60, chapter 7.
*/ // ---- constants ----
/** K is the Gaussian gravitational constant. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "K", function() {
    return K;
});
parcelHelpers.export(exports, "AU", function() {
    return AU;
});
parcelHelpers.export(exports, "SOblJ2000", function() {
    return SOblJ2000;
});
parcelHelpers.export(exports, "COblJ2000", function() {
    return COblJ2000;
});
// SOblJ2000, COblJ2000 from ch 33, p. 228, for example
/**
 * lightTime returns time for light to travel a given distance.
 * `dist` is distance in to earth in AU. √(x² + y² + z²)
 * Result in seconds of time.
 * @param {Number} dist - distance in to earth in AU
 * @returns {Number} time for light to travel a given distance in seconds
 */ parcelHelpers.export(exports, "lightTime", function() {
    return lightTime;
});
parcelHelpers.export(exports, "JMod", function() {
    return JMod;
});
parcelHelpers.export(exports, "J2000", function() {
    return J2000;
});
parcelHelpers.export(exports, "J1900", function() {
    return J1900;
});
parcelHelpers.export(exports, "B1900", function() {
    return B1900;
});
parcelHelpers.export(exports, "B1950", function() {
    return B1950;
});
parcelHelpers.export(exports, "JulianYear", function() {
    return JulianYear;
});
parcelHelpers.export(exports, "JulianCentury", function() {
    return JulianCentury;
});
parcelHelpers.export(exports, "BesselianYear", function() {
    return BesselianYear;
});
parcelHelpers.export(exports, "meanSiderealYear", function() {
    return meanSiderealYear;
});
/**
 * JulianYearToJDE returns the Julian ephemeris day for a Julian year.
 * @param {Number} jy - Julian year
 * @returns {Number} jde - Julian ephemeris day
 */ parcelHelpers.export(exports, "JulianYearToJDE", function() {
    return JulianYearToJDE;
});
/**
 * JDEToJulianYear returns a Julian year for a Julian ephemeris day.
 * @param {Number} jde - Julian ephemeris day
 * @returns {Number} jy - Julian year
 */ parcelHelpers.export(exports, "JDEToJulianYear", function() {
    return JDEToJulianYear;
});
/**
 * BesselianYearToJDE returns the Julian ephemeris day for a Besselian year.
 * @param {Number} by - Besselian year
 * @returns {Number} jde - Julian ephemeris day
 */ parcelHelpers.export(exports, "BesselianYearToJDE", function() {
    return BesselianYearToJDE;
});
/**
 * JDEToBesselianYear returns the Besselian year for a Julian ephemeris day.
 * @param {Number} jde - Julian ephemeris day
 * @returns {Number} by - Besselian year
 */ parcelHelpers.export(exports, "JDEToBesselianYear", function() {
    return JDEToBesselianYear;
});
/**
 * J2000Century returns the number of Julian centuries since J2000.
 *
 * The quantity appears as T in a number of time series.
 * @param {Number} jde - Julian ephemeris day
 * @returns {Number} number of Julian centuries since J2000
 */ parcelHelpers.export(exports, "J2000Century", function() {
    return J2000Century;
});
// ---- phase ----
/**
 * illuminated returns the illuminated fraction of a body's disk.
 *
 * The illuminated body can be the Moon or a planet.
 *
 * @param {Number} i - phase angle in radians.
 * @returns {Number} illuminated fraction of a body's disk.
 */ parcelHelpers.export(exports, "illuminated", function() {
    return illuminated;
});
parcelHelpers.export(exports, "Coord", function() {
    return Coord;
});
/**
 * Limb returns the position angle of the midpoint of an illuminated limb.
 *
 * The illuminated body can be the Moon or a planet.
 *
 * @param {Coord} equ - equatorial coordinates of the body `{ra, dec}` (in radians)
 * @param {Coord} appSun - apparent coordinates of the Sun `{ra, dec}` (In radians).
 * @returns {Number} position angle of the midpoint (in radians).
 */ parcelHelpers.export(exports, "limb", function() {
    return limb;
});
parcelHelpers.export(exports, "SmallAngle", function() {
    return SmallAngle;
});
parcelHelpers.export(exports, "CosSmallAngle", function() {
    return CosSmallAngle;
});
/**
 * pmod returns a positive floating-point x mod y.
 *
 * For a positive argument y, it returns a value in the range [0,y).
 *
 * @param {Number} x
 * @param {Number} y
 * @returns {Number} x % y - The result may not be useful if y is negative.
 */ parcelHelpers.export(exports, "pmod", function() {
    return pmod;
});
/**
 * horner evaluates a polynomal with coefficients c at x.  The constant
 * term is c[0].
 * @param {Number} x
 * @param {Number[]} c - coefficients; c[0] may be of type Number[]
 * @returns {Number}
 */ parcelHelpers.export(exports, "horner", function() {
    return horner;
});
/**
 * FloorDiv returns the integer floor of the fractional value (x / y).
 * @param {Number} x
 * @param {Number} y
 * @returns {Number} (int)
 */ parcelHelpers.export(exports, "floorDiv", function() {
    return floorDiv;
});
/**
 * Cmp compares two float64s and returns -1, 0, or 1 if a is <, ==, or > b,
 * respectively.
 * .
 * @param {Number} a
 * @param {Number} b
 * @returns {Number} comparison result
 */ parcelHelpers.export(exports, "cmp", function() {
    return cmp;
});
/**
 * shorthand function for Math.sin, Math.cos
 * @param {Number} ε
 * @returns {Number[]} [sin(ε), cos(ε)]
 */ parcelHelpers.export(exports, "sincos", function() {
    return sincos;
});
/**
 * Convert degrees to radians
 * @param  {Number} deg - Angle in degrees
 * @return {Number} Angle in radians
 */ parcelHelpers.export(exports, "toRad", function() {
    return toRad;
});
/**
 * Convert radians to degrees
 * @param  {Number} rad - Angle in radians
 * @return {Number} Angle in degrees
 */ parcelHelpers.export(exports, "toDeg", function() {
    return toDeg;
});
/**
 * separate fix `i` from fraction `f`
 * @param {Number} float
 * @returns {Array} [i, f]
 *  {Number} i - (int) fix value
 *  {Number} f - (float) fractional portion; always > 1
 */ parcelHelpers.export(exports, "modf", function() {
    return modf;
});
/**
 * Rounds `float` value by precision
 * @param {Number} float - value to round
 * @param {Number} [precision] - (int) number of post decimal positions
 * @return {Number} rounded `float`
 */ parcelHelpers.export(exports, "round", function() {
    return round;
});
parcelHelpers.export(exports, "errorCode", function() {
    return errorCode;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var K = 0.01720209895;
var AU = 149597870;
var SOblJ2000 = 0.397777156;
var COblJ2000 = 0.917482062;
function lightTime(dist) {
    // Formula given as (33.3) p. 224.
    return 0.0057755183 * dist;
}
var JMod = 2400000.5;
var J2000 = 2451545.0;
var J1900 = 2415020.0;
var B1900 = 2415020.3135;
var B1950 = 2433282.4235;
var JulianYear = 365.25 // days
;
var JulianCentury = 36525 // days
;
var BesselianYear = 365.2421988 // days
;
var meanSiderealYear = 365.25636 // days
;
function JulianYearToJDE(jy) {
    return J2000 + JulianYear * (jy - 2000);
}
function JDEToJulianYear(jde) {
    return 2000 + (jde - J2000) / JulianYear;
}
function BesselianYearToJDE(by) {
    return B1900 + BesselianYear * (by - 1900);
}
function JDEToBesselianYear(jde) {
    return 1900 + (jde - B1900) / BesselianYear;
}
function J2000Century(jde) {
    // The formula is given in a number of places in the book, for example
    // (12.1) p. 87.
    // (22.1) p. 143.
    // (25.1) p. 163.
    return (jde - J2000) / JulianCentury;
}
function illuminated(i) {
    // (41.1) p. 283, also (48.1) p. 345.
    return (1 + Math.cos(i)) * 0.5;
}
var Coord = /*#__PURE__*/ function() {
    "use strict";
    function Coord(ra, dec, range, elongation) {
        (0, _classCallCheck._)(this, Coord);
        this._ra = ra || 0;
        this._dec = dec || 0;
        this.range = range;
        this.elongation = elongation;
    }
    (0, _createClass._)(Coord, [
        {
            key: "ra",
            get: /**
   * right ascension
   * @return {number}
   */ function get() {
                return this._ra;
            },
            set: function set(ra) {
                this._ra = ra;
            }
        },
        {
            key: "dec",
            get: /**
   * declination
   * @return {number}
   */ function get() {
                return this._dec;
            },
            set: function set(dec) {
                this._dec = dec;
            }
        },
        {
            key: "lon",
            get: /**
   * right ascension (or longitude)
   * @return {number}
   */ function get() {
                return this._ra;
            },
            set: function set(ra) {
                this._ra = ra;
            }
        },
        {
            key: "lat",
            get: /**
   * declination (or latitude)
   * @return {number}
   */ function get() {
                return this._dec;
            },
            set: function set(dec) {
                this._dec = dec;
            }
        }
    ]);
    return Coord;
}();
function limb(equ, appSun) {
    var \u03B1 = equ.ra;
    var \u03B4 = equ.dec;
    var \u03B10 = appSun.ra;
    var \u03B40 = appSun.dec;
    // Mentioned in ch 41, p. 283.  Formula (48.5) p. 346
    var s\u03B4 = Math.sin(\u03B4);
    var c\u03B4 = Math.cos(\u03B4);
    var s\u03B40 = Math.sin(\u03B40);
    var c\u03B40 = Math.cos(\u03B40);
    var s\u03B10\u03B1 = Math.sin(\u03B10 - \u03B1);
    var c\u03B10\u03B1 = Math.cos(\u03B10 - \u03B1);
    var \u03C7 = Math.atan2(c\u03B40 * s\u03B10\u03B1, s\u03B40 * c\u03B4 - c\u03B40 * s\u03B4 * c\u03B10\u03B1);
    if (\u03C7 < 0) \u03C7 += 2 * Math.PI;
    return \u03C7;
}
var SmallAngle = 10 * Math.PI / 180 / 60 // about .003 radians
;
var CosSmallAngle = Math.cos(SmallAngle) // about .999996
;
function pmod(x, y) {
    var r = x % y;
    if (r < 0) r += y;
    return r;
}
function horner(x) {
    for(var _len = arguments.length, c = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        c[_key - 1] = arguments[_key];
    }
    if (Array.isArray(c[0])) c = c[0];
    var i = c.length - 1;
    var y = c[i];
    while(i > 0){
        i--;
        y = y * x + c[i];
    }
    return y;
}
function floorDiv(x, y) {
    var q = x / y;
    return Math.floor(q);
}
function cmp(a, b) {
    if (a < b) return -1;
    if (a > b) return 1;
    return 0;
}
function sincos(\u03B5) {
    return [
        Math.sin(\u03B5),
        Math.cos(\u03B5)
    ];
}
function toRad(deg) {
    return Math.PI / 180.0 * deg;
}
function toDeg(rad) {
    return 180.0 / Math.PI * rad;
}
function modf(float) {
    var i = Math.trunc(float);
    var f = Math.abs(float - i);
    return [
        i,
        f
    ];
}
function round(float) {
    var precision = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 14;
    return parseFloat(float.toFixed(precision));
}
function errorCode(msg, code) {
    var err = new Error(msg);
    // @ts-ignore
    err.code = code;
    return err;
}
exports.default = {
    K: K,
    AU: AU,
    SOblJ2000: SOblJ2000,
    COblJ2000: COblJ2000,
    lightTime: lightTime,
    JMod: JMod,
    J2000: J2000,
    J1900: J1900,
    B1900: B1900,
    B1950: B1950,
    JulianYear: JulianYear,
    JulianCentury: JulianCentury,
    BesselianYear: BesselianYear,
    meanSiderealYear: meanSiderealYear,
    JulianYearToJDE: JulianYearToJDE,
    JDEToJulianYear: JDEToJulianYear,
    BesselianYearToJDE: BesselianYearToJDE,
    JDEToBesselianYear: JDEToBesselianYear,
    J2000Century: J2000Century,
    illuminated: illuminated,
    Coord: Coord,
    limb: limb,
    SmallAngle: SmallAngle,
    CosSmallAngle: CosSmallAngle,
    pmod: pmod,
    horner: horner,
    floorDiv: floorDiv,
    cmp: cmp,
    sincos: sincos,
    toRad: toRad,
    toDeg: toDeg,
    modf: modf,
    round: round,
    errorCode: errorCode
};

},{"@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1h22R":[function(require,module,exports,__globalThis) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module interpolation
 */ /**
 * Interp: Chapter 3, Interpolation.
 *
 * Len3 and Len5 types
 *
 * These types allow interpolation from a table of equidistant x values
 * and corresponding y values.  Since the x values are equidistant,
 * only the first and last values are supplied as arguments to the
 * constructors.  The interior x values are implicit.  All y values must be
 * supplied however.  They are passed as a slice, and the length of y is fixed.
 * For Len3 it must be 3 and for (Len5 it must be 5.0
 *
 * For these Len3 and Len5 functions, Meeus notes the importance of choosing
 * the 3 or 5 rows of a larger table that will minimize the interpolating
 * factor n.  He does not provide algorithms for doing this however.
 *
 * For an example of a selection function, see len3ForInterpolateX. This
 * was useful for computing Delta T.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "errorNot3", function() {
    return errorNot3;
});
parcelHelpers.export(exports, "errorNot4", function() {
    return errorNot4;
});
parcelHelpers.export(exports, "errorNot5", function() {
    return errorNot5;
});
parcelHelpers.export(exports, "errorNoXRange", function() {
    return errorNoXRange;
});
parcelHelpers.export(exports, "errorNOutOfRange", function() {
    return errorNOutOfRange;
});
parcelHelpers.export(exports, "errorNoExtremum", function() {
    return errorNoExtremum;
});
parcelHelpers.export(exports, "errorExtremumOutside", function() {
    return errorExtremumOutside;
});
parcelHelpers.export(exports, "errorZeroOutside", function() {
    return errorZeroOutside;
});
parcelHelpers.export(exports, "errorNoConverge", function() {
    return errorNoConverge;
});
parcelHelpers.export(exports, "Len3", function() {
    return Len3;
});
/**
 * Len3ForInterpolateX is a special purpose Len3 constructor.
 *
 * Like NewLen3, it takes a table of x and y values, but it is not limited
 * to tables of 3 rows.  An X value is also passed that represents the
 * interpolation target x value.  Len3ForInterpolateX will locate the
 * appropriate three rows of the table for interpolating for x, and initialize
 * the Len3 object for those rows.
 *
 * @param {Number} x - is the target for interpolation
 * @param {Number} x1 - is the x value corresponding to the first y value of the table.
 * @param {Number} xN - is the x value corresponding to the last y value of the table.
 * @param {Number[]} y - is all y values in the table.  y.length should be >= 3.0
 * @returns {Len3} interpolation value
 */ parcelHelpers.export(exports, "len3ForInterpolateX", function() {
    return len3ForInterpolateX;
});
parcelHelpers.export(exports, "iterate", function() {
    return iterate;
});
/**
 * Len4Half interpolates a center value from a table of four rows.
 * @param {Number[]} y - 4 values
 * @returns {Number} interpolation result
 */ parcelHelpers.export(exports, "len4Half", function() {
    return len4Half;
});
parcelHelpers.export(exports, "Len5", function() {
    return Len5;
});
/**
 * Lagrange performs interpolation with unequally-spaced abscissae.
 *
 * Given a table of X and Y values, interpolate a new y value for argument x.
 *
 * X values in the table do not have to be equally spaced; they do not even
 * have to be in order. They must however, be distinct.
 *
 * @param {Number} x - x-value of interpolation
 * @param {Array} table - `[[x0, y0], ... [xN, yN]]` of x, y values
 * @returns {Number} interpolation result `y` of `x`
 */ parcelHelpers.export(exports, "lagrange", function() {
    return lagrange;
});
/**
 * LagrangePoly uses the formula of Lagrange to produce an interpolating
 * polynomial.
 *
 * X values in the table do not have to be equally spaced; they do not even
 * have to be in order.  They must however, be distinct.
 *
 * The returned polynomial will be of degree n-1 where n is the number of rows
 * in the table.  It can be evaluated for x using base.horner.
 *
 * @param {Array} table - `[[x0, y0], ... [xN, yN]]`
 * @returns {Array} - polynomial array
 */ parcelHelpers.export(exports, "lagrangePoly", function() {
    return lagrangePoly;
});
/**
 * Linear Interpolation of x
 */ parcelHelpers.export(exports, "linear", function() {
    return linear;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var int = Math.trunc;
var errorNot3 = new Error('Argument y must be length 3');
var errorNot4 = new Error('Argument y must be length 4');
var errorNot5 = new Error('Argument y must be length 5');
var errorNoXRange = new Error('Argument x3 (or x5) cannot equal x1');
var errorNOutOfRange = new Error('Interpolating factor n must be in range -1 to 1');
var errorNoExtremum = new Error('No extremum in table');
var errorExtremumOutside = new Error('Extremum falls outside of table');
var errorZeroOutside = new Error('Zero falls outside of table');
var errorNoConverge = new Error('Failure to converge');
var Len3 = /*#__PURE__*/ function() {
    "use strict";
    function Len3(x1, x3, y) {
        (0, _classCallCheck._)(this, Len3);
        if (y.length !== 3) throw errorNot3;
        if (x3 === x1) throw errorNoXRange;
        this.x1 = x1;
        this.x3 = x3;
        this.y = y;
        // differences. (3.1) p. 23
        this.a = y[1] - y[0];
        this.b = y[2] - y[1];
        this.c = this.b - this.a;
        // other intermediate values
        this.abSum = this.a + this.b;
        this.xSum = x3 + x1;
        this.xDiff = x3 - x1;
    }
    (0, _createClass._)(Len3, [
        {
            /**
   * InterpolateX interpolates for a given x value.
   */ key: "interpolateX",
            value: function interpolateX(x) {
                var n = (2 * x - this.xSum) / this.xDiff;
                return this.interpolateN(n);
            }
        },
        {
            /**
   * InterpolateXStrict interpolates for a given x value,
   * restricting x to the range x1 to x3 given to the constructor NewLen3.
   */ key: "interpolateXStrict",
            value: function interpolateXStrict(x) {
                var n = (2 * x - this.xSum) / this.xDiff;
                var y = this.interpolateNStrict(n);
                return y;
            }
        },
        {
            /**
   * InterpolateN interpolates for (a given interpolating factor n.
   *
   * This is interpolation formula (3.3)
   *
   * @param n - The interpolation factor n is x-x2 in units of the tabular x interval.
   * (See Meeus p. 24.)
   * @return {number} interpolation value
   */ key: "interpolateN",
            value: function interpolateN(n) {
                return this.y[1] + n * 0.5 * (this.abSum + n * this.c);
            }
        },
        {
            /**
   * InterpolateNStrict interpolates for (a given interpolating factor n.
   *
   * @param {number} n - n is restricted to the range [-1..1] corresponding to the range x1 to x3
   * given to the constructor of Len3.
   * @return {number} interpolation value
   */ key: "interpolateNStrict",
            value: function interpolateNStrict(n) {
                if (n < -1 || n > 1) throw errorNOutOfRange;
                return this.interpolateN(n);
            }
        },
        {
            /**
   * Extremum returns the x and y values at the extremum.
   *
   * Results are restricted to the range of the table given to the constructor
   * new Len3.
   */ key: "extremum",
            value: function extremum() {
                if (this.c === 0) throw errorNoExtremum;
                var n = this.abSum / (-2 * this.c // (3.5), p. 25
                );
                if (n < -1 || n > 1) throw errorExtremumOutside;
                var x = 0.5 * (this.xSum + this.xDiff * n);
                var y = this.y[1] - this.abSum * this.abSum / (8 * this.c // (3.4), p. 25
                );
                return [
                    x,
                    y
                ];
            }
        },
        {
            /**
   * Len3Zero finds a zero of the quadratic function represented by the table.
   *
   * That is, it returns an x value that yields y=0.
   *
   * Argument strong switches between two strategies for the estimation step.
   * when iterating to converge on the zero.
   *
   * Strong=false specifies a quick and dirty estimate that works well
   * for gentle curves, but can work poorly or fail on more dramatic curves.
   *
   * Strong=true specifies a more sophisticated and thus somewhat more
   * expensive estimate.  However, if the curve has quick changes, This estimate
   * will converge more reliably and in fewer steps, making it a better choice.
   *
   * Results are restricted to the range of the table given to the constructor
   * NewLen3.
   */ key: "zero",
            value: function zero(strong) {
                var _this = this;
                var f;
                if (strong) // (3.7), p. 27
                f = function(n0) {
                    return n0 - (2 * _this.y[1] + n0 * (_this.abSum + _this.c * n0)) / (_this.abSum + 2 * _this.c * n0);
                };
                else // (3.6), p. 26
                f = function(n0) {
                    return -2 * _this.y[1] / (_this.abSum + _this.c * n0);
                };
                var _iterate = (0, _slicedToArray._)(iterate(0, f), 2), n0 = _iterate[0], ok = _iterate[1];
                if (!ok) throw errorNoConverge;
                if (n0 > 1 || n0 < -1) throw errorZeroOutside;
                return 0.5 * (this.xSum + this.xDiff * n0 // success
                );
            }
        }
    ]);
    return Len3;
}();
function len3ForInterpolateX(x, x1, xN, y) {
    var y3 = y;
    if (y.length > 3) {
        var interval = (xN - x1) / (y.length - 1);
        if (interval === 0) throw errorNoXRange;
        var nearestX = int((x - x1) / interval + 0.5);
        if (nearestX < 1) nearestX = 1;
        else if (nearestX > y.length - 2) nearestX = y.length - 2;
        y3 = y.slice(nearestX - 1, nearestX + 2);
        xN = x1 + (nearestX + 1) * interval;
        x1 = x1 + (nearestX - 1) * interval;
    }
    return new Len3(x1, xN, y3);
}
var iterate = function iterate(n0, f) {
    for(var limit = 0; limit < 50; limit++){
        var n1 = f(n0);
        if (!isFinite(n1) || isNaN(n1)) break; // failure to converge
        if (Math.abs((n1 - n0) / n0) < 1e-15) return [
            n1,
            true
        ] // success
        ;
        n0 = n1;
    }
    return [
        0,
        false
    ] // failure to converge
    ;
};
function len4Half(y) {
    if (y.length !== 4) throw errorNot4;
    // (3.12) p. 32
    return (9 * (y[1] + y[2]) - y[0] - y[3]) / 16;
}
var Len5 = /*#__PURE__*/ function() {
    "use strict";
    function Len5(x1, x5, y) {
        (0, _classCallCheck._)(this, Len5);
        if (y.length !== 5) throw errorNot5;
        if (x5 === x1) throw errorNoXRange;
        this.x1 = x1;
        this.x5 = x5;
        this.y = y;
        this.y3 = y[2];
        // differences
        this.a = y[1] - y[0];
        this.b = y[2] - y[1];
        this.c = y[3] - y[2];
        this.d = y[4] - y[3];
        this.e = this.b - this.a;
        this.f = this.c - this.b;
        this.g = this.d - this.c;
        this.h = this.f - this.e;
        this.j = this.g - this.f;
        this.k = this.j - this.h;
        // other intermediate values
        this.xSum = x5 + x1;
        this.xDiff = x5 - x1;
        this.interpCoeff = [
            this.y3,
            (this.b + this.c) / 2 - (this.h + this.j) / 12,
            this.f / 2 - this.k / 24,
            (this.h + this.j) / 12,
            this.k / 24
        ];
    }
    (0, _createClass._)(Len5, [
        {
            /**
   * InterpolateX interpolates for (a given x value.
   */ key: "interpolateX",
            value: function interpolateX(x) {
                var n = (4 * x - 2 * this.xSum) / this.xDiff;
                return this.interpolateN(n);
            }
        },
        {
            /**
   * InterpolateXStrict interpolates for a given x value,
   * restricting x to the range x1 to x5 given to the the constructor NewLen5.
   */ key: "interpolateXStrict",
            value: function interpolateXStrict(x) {
                var n = (4 * x - 2 * this.xSum) / this.xDiff;
                var y = this.interpolateNStrict(n);
                return y;
            }
        },
        {
            /**
   * InterpolateN interpolates for (a given interpolating factor n.
   *
   * The interpolation factor n is x-x3 in units of the tabular x interval.
   * (See Meeus p. 28.)
   */ key: "interpolateN",
            value: function interpolateN(n) {
                var _base;
                return (_base = (0, _baseJsDefault.default)).horner.apply(_base, [
                    n
                ].concat((0, _toConsumableArray._)(this.interpCoeff)));
            }
        },
        {
            /**
   * InterpolateNStrict interpolates for (a given interpolating factor n.
   *
   * N is restricted to the range [-1..1].  This is only half the range given
   * to the constructor NewLen5, but is the recommendation given on p. 31.0
   */ key: "interpolateNStrict",
            value: function interpolateNStrict(n) {
                var _base;
                if (n < -1 || n > 1) throw errorNOutOfRange;
                return (_base = (0, _baseJsDefault.default)).horner.apply(_base, [
                    n
                ].concat((0, _toConsumableArray._)(this.interpCoeff)));
            }
        },
        {
            /**
   * Extremum returns the x and y values at the extremum.
   *
   * Results are restricted to the range of the table given to the constructor
   * NewLen5.  (Meeus actually recommends restricting the range to one unit of
   * the tabular interval, but that seems a little harsh.)
   */ key: "extremum",
            value: function extremum() {
                var _base;
                // (3.9) p. 29
                var nCoeff = [
                    6 * (this.b + this.c) - this.h - this.j,
                    0,
                    3 * (this.h + this.j),
                    2 * this.k
                ];
                var den = this.k - 12 * this.f;
                if (den === 0) throw errorExtremumOutside;
                var _iterate = (0, _slicedToArray._)(iterate(0, function(n0) {
                    var _base;
                    return (_base = (0, _baseJsDefault.default)).horner.apply(_base, [
                        n0
                    ].concat((0, _toConsumableArray._)(nCoeff))) / den;
                }), 2), n0 = _iterate[0], ok = _iterate[1];
                if (!ok) throw errorNoConverge;
                if (n0 < -2 || n0 > 2) throw errorExtremumOutside;
                var x = 0.5 * this.xSum + 0.25 * this.xDiff * n0;
                var y = (_base = (0, _baseJsDefault.default)).horner.apply(_base, [
                    n0
                ].concat((0, _toConsumableArray._)(this.interpCoeff)));
                return [
                    x,
                    y
                ];
            }
        },
        {
            /**
   * Len5Zero finds a zero of the quartic function represented by the table.
   *
   * That is, it returns an x value that yields y=0.
   *
   * Argument strong switches between two strategies for the estimation step.
   * when iterating to converge on the zero.
   *
   * Strong=false specifies a quick and dirty estimate that works well
   * for gentle curves, but can work poorly or fail on more dramatic curves.
   *
   * Strong=true specifies a more sophisticated and thus somewhat more
   * expensive estimate.  However, if the curve has quick changes, This estimate
   * will converge more reliably and in fewer steps, making it a better choice.
   *
   * Results are restricted to the range of the table given to the constructor
   * NewLen5.
   */ key: "zero",
            value: function zero(strong) {
                var f;
                if (strong) {
                    // (3.11), p. 29
                    var M = this.k / 24;
                    var N = (this.h + this.j) / 12;
                    var P = this.f / 2 - M;
                    var Q = (this.b + this.c) / 2 - N;
                    var numCoeff = [
                        this.y3,
                        Q,
                        P,
                        N,
                        M
                    ];
                    var denCoeff = [
                        Q,
                        2 * P,
                        3 * N,
                        4 * M
                    ];
                    f = function f(n0) {
                        var _base, _base1;
                        return n0 - (_base = (0, _baseJsDefault.default)).horner.apply(_base, [
                            n0
                        ].concat((0, _toConsumableArray._)(numCoeff))) / (_base1 = (0, _baseJsDefault.default)).horner.apply(_base1, [
                            n0
                        ].concat((0, _toConsumableArray._)(denCoeff)));
                    };
                } else {
                    // (3.10), p. 29
                    var numCoeff1 = [
                        -24 * this.y3,
                        0,
                        this.k - 12 * this.f,
                        -2 * (this.h + this.j),
                        -this.k
                    ];
                    var den = 12 * (this.b + this.c) - 2 * (this.h + this.j);
                    f = function f(n0) {
                        var _base;
                        return (_base = (0, _baseJsDefault.default)).horner.apply(_base, [
                            n0
                        ].concat((0, _toConsumableArray._)(numCoeff1))) / den;
                    };
                }
                var _iterate = (0, _slicedToArray._)(iterate(0, f), 2), n0 = _iterate[0], ok = _iterate[1];
                if (!ok) throw errorNoConverge;
                if (n0 > 2 || n0 < -2) throw errorZeroOutside;
                var x = 0.5 * this.xSum + 0.25 * this.xDiff * n0;
                return x;
            }
        }
    ]);
    return Len5;
}();
function lagrange(x, table) {
    // method of BASIC program, p. 33.0
    var sum = 0;
    table.forEach(function(ti, i) {
        var xi = ti[0];
        var prod = 1.0;
        table.forEach(function(tj, j) {
            if (i !== j) {
                var xj = tj[0];
                prod *= (x - xj) / (xi - xj);
            }
        });
        sum += ti[1] * prod;
    });
    return sum;
}
function lagrangePoly(table) {
    var _loop = function(i) {
        var xi = table[i][0] || table[i].x || 0;
        var yi = table[i][1] || table[i].y || 0;
        prod[last] = 1;
        var den = 1.0;
        var n = last;
        for(var j = 0; j < table.length; j++)if (i !== j) {
            var xj = table[j][0] || table[j].x || 0;
            prod[n - 1] = prod[n] * -xj;
            for(var k = n; k < last; k++)prod[k] -= prod[k + 1] * xj;
            n--;
            den *= xi - xj;
        }
        prod.forEach(function(pj, j) {
            sum[j] += yi * pj / den;
        });
    };
    // Method not fully described by Meeus, but needed for (numerical solution
    // to Example 3.g.
    var sum = new Array(table.length).fill(0);
    var prod = new Array(table.length).fill(0);
    var last = table.length - 1;
    for(var i = 0; i < table.length; i++)_loop(i);
    return sum;
}
function linear(x, x1, xN, y) {
    var interval = (xN - x1) / (y.length - 1);
    if (interval === 0) throw errorNoXRange;
    var nearestX = Math.floor((x - x1) / interval);
    if (nearestX < 0) nearestX = 0;
    else if (nearestX > y.length - 2) nearestX = y.length - 2;
    var y2 = y.slice(nearestX, nearestX + 2);
    var x01 = x1 + nearestX * interval;
    return y2[0] + (y[1] - y[0]) * (x - x01) / interval;
}
exports.default = {
    errorNot3: errorNot3,
    errorNot4: errorNot4,
    errorNot5: errorNot5,
    errorNoXRange: errorNoXRange,
    errorNOutOfRange: errorNOutOfRange,
    errorNoExtremum: errorNoExtremum,
    errorExtremumOutside: errorExtremumOutside,
    errorZeroOutside: errorZeroOutside,
    errorNoConverge: errorNoConverge,
    Len3: Len3,
    len3ForInterpolateX: len3ForInterpolateX,
    iterate: iterate,
    len4Half: len4Half,
    Len5: Len5,
    lagrange: lagrange,
    lagrangePoly: lagrangePoly,
    linear: linear
};

},{"@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","@swc/helpers/_/_sliced_to_array":"ha6sq","@swc/helpers/_/_to_consumable_array":"eqNDD","./base.js":"lEDxD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5Tqj8":[function(require,module,exports,__globalThis) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module apparent
 */ /**
 * Apparent: Chapter 23, Apparent Place of a Star
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Nutation returns corrections due to nutation for equatorial coordinates
 * of an object.
 *
 * Results are invalid for objects very near the celestial poles.
 * @param {Number} α - right ascension
 * @param {Number} δ - declination
 * @param {Number} jd - Julian Day
 * @return {Number[]} [Δα1, Δδ1] -
*/ parcelHelpers.export(exports, "nutation", function() {
    return nutation;
});
/**
 * longitude of perihelian of Earth's orbit.
 */ parcelHelpers.export(exports, "perihelion", function() {
    return perihelion;
});
/**
 * EclipticAberration returns corrections due to aberration for ecliptic
 * coordinates of an object.
 */ parcelHelpers.export(exports, "eclipticAberration", function() {
    return eclipticAberration;
});
/**
 * Aberration returns corrections due to aberration for equatorial
 * coordinates of an object.
 */ parcelHelpers.export(exports, "aberration", function() {
    return aberration;
});
/**
 * Position computes the apparent position of an object.
 *
 * Position is computed for equatorial coordinates in eqFrom, considering
 * proper motion, precession, nutation, and aberration.  Result is in
 * eqTo.  EqFrom and eqTo must be non-nil, but may point to the same struct.
 */ parcelHelpers.export(exports, "position", function() {
    return position;
});
/**
 * AberrationRonVondrak uses the Ron-Vondrák expression to compute corrections
 * due to aberration for equatorial coordinates of an object.
 */ parcelHelpers.export(exports, "aberrationRonVondrak", function() {
    return aberrationRonVondrak;
});
/**
 * PositionRonVondrak computes the apparent position of an object using
 * the Ron-Vondrák expression for aberration.
 *
 * Position is computed for equatorial coordinates in eqFrom, considering
 * proper motion, aberration, precession, and _nutation.  Result is in
 * eqTo.  EqFrom and eqTo must be non-nil, but may point to the same struct.
 *
 * Note the Ron-Vondrák expression is only valid for the epoch J2000.
 * EqFrom must be coordinates at epoch J2000.
 */ parcelHelpers.export(exports, "positionRonVondrak", function() {
    return positionRonVondrak;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var _coordJs = require("./coord.js");
var _coordJsDefault = parcelHelpers.interopDefault(_coordJs);
var _nutationJs = require("./nutation.js");
var _nutationJsDefault = parcelHelpers.interopDefault(_nutationJs);
var _precessJs = require("./precess.js");
var _precessJsDefault = parcelHelpers.interopDefault(_precessJs);
var _solarJs = require("./solar.js");
var _solarJsDefault = parcelHelpers.interopDefault(_solarJs);
var cos = Math.cos, tan = Math.tan;
function nutation(\u03B1, \u03B4, jd) {
    var \u03B5 = (0, _nutationJsDefault.default).meanObliquity(jd);
    var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03B5), 2), sin\u03B5 = _base_sincos[0], cos\u03B5 = _base_sincos[1];
    var _nutation_nutation = (0, _slicedToArray._)((0, _nutationJsDefault.default).nutation(jd), 2), \u0394\u03C8 = _nutation_nutation[0], \u0394\u03B5 = _nutation_nutation[1];
    var _base_sincos1 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03B1), 2), sin\u03B1 = _base_sincos1[0], cos\u03B1 = _base_sincos1[1];
    var tan\u03B4 = tan(\u03B4);
    // (23.1) p. 151
    var \u0394\u03B11 = (cos\u03B5 + sin\u03B5 * sin\u03B1 * tan\u03B4) * \u0394\u03C8 - cos\u03B1 * tan\u03B4 * \u0394\u03B5;
    var \u0394\u03B41 = sin\u03B5 * cos\u03B1 * \u0394\u03C8 + sin\u03B1 * \u0394\u03B5;
    return [
        \u0394\u03B11,
        \u0394\u03B41
    ];
}
/**
 * κ is the constant of aberration in radians.
 */ var \u03BA = 20.49552 * Math.PI / 180 / 3600;
function perihelion(T) {
    return (0, _baseJsDefault.default).horner(T, 102.93735, 1.71946, 0.00046) * Math.PI / 180;
}
function eclipticAberration(\u03BB, \u03B2, jd) {
    var T = (0, _baseJsDefault.default).J2000Century(jd);
    var _solar_trueLongitude // eslint-disable-line no-unused-vars
     = (0, _solarJsDefault.default).trueLongitude(T), lon = _solar_trueLongitude.lon, ano = _solar_trueLongitude.ano;
    var e = (0, _solarJsDefault.default).eccentricity(T);
    var \u03C0 = perihelion(T);
    var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03B2), 2), s\u03B2 = _base_sincos[0], c\u03B2 = _base_sincos[1];
    var _base_sincos1 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(lon - \u03BB), 2), ss\u03BB = _base_sincos1[0], cs\u03BB = _base_sincos1[1];
    var _base_sincos2 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03C0 - \u03BB), 2), sin\u03C0\u03BB = _base_sincos2[0], cos\u03C0\u03BB = _base_sincos2[1];
    // (23.2) p. 151
    var \u0394\u03BB = \u03BA * (e * cos\u03C0\u03BB - cs\u03BB) / c\u03B2;
    var \u0394\u03B2 = -\u03BA * s\u03B2 * (ss\u03BB - e * sin\u03C0\u03BB);
    return [
        \u0394\u03BB,
        \u0394\u03B2
    ];
}
function aberration(\u03B1, \u03B4, jd) {
    var \u03B5 = (0, _nutationJsDefault.default).meanObliquity(jd);
    var T = (0, _baseJsDefault.default).J2000Century(jd);
    var _solar_trueLongitude // eslint-disable-line no-unused-vars
     = (0, _solarJsDefault.default).trueLongitude(T), lon = _solar_trueLongitude.lon, ano = _solar_trueLongitude.ano;
    var e = (0, _solarJsDefault.default).eccentricity(T);
    var \u03C0 = perihelion(T);
    var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03B1), 2), sin\u03B1 = _base_sincos[0], cos\u03B1 = _base_sincos[1];
    var _base_sincos1 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03B4), 2), sin\u03B4 = _base_sincos1[0], cos\u03B4 = _base_sincos1[1];
    var _base_sincos2 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(lon), 2), sins = _base_sincos2[0], coss = _base_sincos2[1];
    var _base_sincos3 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03C0), 2), sin\u03C0 = _base_sincos3[0], cos\u03C0 = _base_sincos3[1];
    var cos\u03B5 = cos(\u03B5);
    var q1 = cos\u03B1 * cos\u03B5;
    // (23.3) p. 152
    var \u0394\u03B12 = \u03BA * (e * (q1 * cos\u03C0 + sin\u03B1 * sin\u03C0) - (q1 * coss + sin\u03B1 * sins)) / cos\u03B4;
    var q2 = cos\u03B5 * (tan(\u03B5) * cos\u03B4 - sin\u03B1 * sin\u03B4);
    var q3 = cos\u03B1 * sin\u03B4;
    var \u0394\u03B42 = \u03BA * (e * (cos\u03C0 * q2 + sin\u03C0 * q3) - (coss * q2 + sins * q3));
    return [
        \u0394\u03B12,
        \u0394\u03B42
    ];
}
function position(eqFrom, epochFrom, epochTo, m\u03B1, m\u03B4) {
    var eqTo = (0, _precessJsDefault.default).position(eqFrom, epochFrom, epochTo, m\u03B1, m\u03B4);
    var jd = (0, _baseJsDefault.default).JulianYearToJDE(epochTo);
    var _nutation = (0, _slicedToArray._)(nutation(eqTo.ra, eqTo.dec, jd), 2), \u0394\u03B11 = _nutation[0], \u0394\u03B41 = _nutation[1];
    var _aberration = (0, _slicedToArray._)(aberration(eqTo.ra, eqTo.dec, jd), 2), \u0394\u03B12 = _aberration[0], \u0394\u03B42 = _aberration[1];
    eqTo.ra += \u0394\u03B11 + \u0394\u03B12;
    eqTo.dec += \u0394\u03B41 + \u0394\u03B42;
    return eqTo;
}
function aberrationRonVondrak(\u03B1, \u03B4, jd) {
    var T = (0, _baseJsDefault.default).J2000Century(jd);
    var r = {
        T: T,
        L2: 3.1761467 + 1021.3285546 * T,
        L3: 1.7534703 + 628.3075849 * T,
        L4: 6.2034809 + 334.0612431 * T,
        L5: 0.5995465 + 52.9690965 * T,
        L6: 0.8740168 + 21.3299095 * T,
        L7: 5.4812939 + 7.4781599 * T,
        L8: 5.3118863 + 3.8133036 * T,
        Lp: 3.8103444 + 8399.6847337 * T,
        D: 5.1984667 + 7771.3771486 * T,
        Mp: 2.3555559 + 8328.6914289 * T,
        F: 1.6279052 + 8433.4661601 * T
    };
    var Xp = 0;
    var Yp = 0;
    var Zp = 0;
    // sum smaller terms first
    for(var i = 35; i >= 0; i--){
        var _rvTerm_i = (0, _slicedToArray._)(rvTerm[i](r), 3), x = _rvTerm_i[0], y = _rvTerm_i[1], z = _rvTerm_i[2];
        Xp += x;
        Yp += y;
        Zp += z;
    }
    var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03B1), 2), sin\u03B1 = _base_sincos[0], cos\u03B1 = _base_sincos[1];
    var _base_sincos1 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03B4), 2), sin\u03B4 = _base_sincos1[0], cos\u03B4 = _base_sincos1[1];
    // (23.4) p. 156
    return [
        (Yp * cos\u03B1 - Xp * sin\u03B1) / (c * cos\u03B4),
        -((Xp * cos\u03B1 + Yp * sin\u03B1) * sin\u03B4 - Zp * cos\u03B4) / c
    ];
}
var c = 17314463350 // unit is 1e-8 AU / day
;
// r = {T, L2, L3, L4, L5, L6, L7, L8, Lp, D, Mp, F}
var rvTerm = [
    function(r) {
        var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(r.L3), 2), sinA = _base_sincos[0], cosA = _base_sincos[1];
        return [
            (-1719914 - 2 * r.T) * sinA - 25 * cosA,
            (25 - 13 * r.T) * sinA + (1578089 + 156 * r.T) * cosA,
            (10 + 32 * r.T) * sinA + (684185 - 358 * r.T) * cosA
        ];
    },
    function(r) {
        var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(2 * r.L3), 2), sinA = _base_sincos[0], cosA = _base_sincos[1];
        return [
            (6434 + 141 * r.T) * sinA + (28007 - 107 * r.T) * cosA,
            (25697 - 95 * r.T) * sinA + (-5904 - 130 * r.T) * cosA,
            (11141 - 48 * r.T) * sinA + (-2559 - 55 * r.T) * cosA
        ];
    },
    function(r) {
        var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(r.L5), 2), sinA = _base_sincos[0], cosA = _base_sincos[1];
        return [
            715 * sinA,
            6 * sinA - 657 * cosA,
            -15 * sinA - 282 * cosA
        ];
    },
    function(r) {
        var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(r.Lp), 2), sinA = _base_sincos[0], cosA = _base_sincos[1];
        return [
            715 * sinA,
            -656 * cosA,
            -285 * cosA
        ];
    },
    function(r) {
        var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(3 * r.L3), 2), sinA = _base_sincos[0], cosA = _base_sincos[1];
        return [
            (486 - 5 * r.T) * sinA + (-236 - 4 * r.T) * cosA,
            (-216 - 4 * r.T) * sinA + (-446 + 5 * r.T) * cosA,
            -94 * sinA - 193 * cosA
        ];
    },
    function(r) {
        var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(r.L6), 2), sinA = _base_sincos[0], cosA = _base_sincos[1];
        return [
            159 * sinA,
            2 * sinA - 147 * cosA,
            -6 * sinA - 61 * cosA
        ];
    },
    function(r) {
        var cosA = Math.cos(r.F);
        return [
            0,
            26 * cosA,
            -59 * cosA
        ];
    },
    function(r) {
        var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(r.Lp + r.Mp), 2), sinA = _base_sincos[0], cosA = _base_sincos[1];
        return [
            39 * sinA,
            -36 * cosA,
            -16 * cosA
        ];
    },
    function(r) {
        var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(2 * r.L5), 2), sinA = _base_sincos[0], cosA = _base_sincos[1];
        return [
            33 * sinA - 10 * cosA,
            -9 * sinA - 30 * cosA,
            -5 * sinA - 13 * cosA
        ];
    },
    function(r) {
        var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(2 * r.L3 - r.L5), 2), sinA = _base_sincos[0], cosA = _base_sincos[1];
        return [
            31 * sinA + cosA,
            sinA - 28 * cosA,
            -12 * cosA
        ];
    },
    function(r) {
        var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(3 * r.L3 - 8 * r.L4 + 3 * r.L5), 2), sinA = _base_sincos[0], cosA = _base_sincos[1];
        return [
            8 * sinA - 28 * cosA,
            25 * sinA + 8 * cosA,
            11 * sinA + 3 * cosA
        ];
    },
    function(r) {
        var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(5 * r.L3 - 8 * r.L4 + 3 * r.L5), 2), sinA = _base_sincos[0], cosA = _base_sincos[1];
        return [
            8 * sinA - 28 * cosA,
            -25 * sinA - 8 * cosA,
            -11 * sinA + -3 * cosA
        ];
    },
    function(r) {
        var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(2 * r.L2 - r.L3), 2), sinA = _base_sincos[0], cosA = _base_sincos[1];
        return [
            21 * sinA,
            -19 * cosA,
            -8 * cosA
        ];
    },
    function(r) {
        var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(r.L2), 2), sinA = _base_sincos[0], cosA = _base_sincos[1];
        return [
            -19 * sinA,
            17 * cosA,
            8 * cosA
        ];
    },
    function(r) {
        var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(r.L7), 2), sinA = _base_sincos[0], cosA = _base_sincos[1];
        return [
            17 * sinA,
            -16 * cosA,
            -7 * cosA
        ];
    },
    function(r) {
        var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(r.L3 - 2 * r.L5), 2), sinA = _base_sincos[0], cosA = _base_sincos[1];
        return [
            16 * sinA,
            15 * cosA,
            sinA + 7 * cosA
        ];
    },
    function(r) {
        var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(r.L8), 2), sinA = _base_sincos[0], cosA = _base_sincos[1];
        return [
            16 * sinA,
            sinA - 15 * cosA,
            -3 * sinA - 6 * cosA
        ];
    },
    function(r) {
        var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(r.L3 + r.L5), 2), sinA = _base_sincos[0], cosA = _base_sincos[1];
        return [
            11 * sinA - cosA,
            -sinA - 10 * cosA,
            -sinA - 5 * cosA
        ];
    },
    function(r) {
        var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(2 * r.L2 - 2 * r.L3), 2), sinA = _base_sincos[0], cosA = _base_sincos[1];
        return [
            -11 * cosA,
            -10 * sinA,
            -4 * sinA
        ];
    },
    function(r) {
        var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(r.L3 - r.L5), 2), sinA = _base_sincos[0], cosA = _base_sincos[1];
        return [
            -11 * sinA - 2 * cosA,
            -2 * sinA + 9 * cosA,
            -sinA + 4 * cosA
        ];
    },
    function(r) {
        var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(4 * r.L3), 2), sinA = _base_sincos[0], cosA = _base_sincos[1];
        return [
            -7 * sinA - 8 * cosA,
            -8 * sinA + 6 * cosA,
            -3 * sinA + 3 * cosA
        ];
    },
    function(r) {
        var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(3 * r.L3 - 2 * r.L5), 2), sinA = _base_sincos[0], cosA = _base_sincos[1];
        return [
            -10 * sinA,
            9 * cosA,
            4 * cosA
        ];
    },
    function(r) {
        var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(r.L2 - 2 * r.L3), 2), sinA = _base_sincos[0], cosA = _base_sincos[1];
        return [
            -9 * sinA,
            -9 * cosA,
            -4 * cosA
        ];
    },
    function(r) {
        var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(2 * r.L2 - 3 * r.L3), 2), sinA = _base_sincos[0], cosA = _base_sincos[1];
        return [
            -9 * sinA,
            -8 * cosA,
            -4 * cosA
        ];
    },
    function(r) {
        var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(2 * r.L6), 2), sinA = _base_sincos[0], cosA = _base_sincos[1];
        return [
            -9 * cosA,
            -8 * sinA,
            -3 * sinA
        ];
    },
    function(r) {
        var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(2 * r.L2 - 4 * r.L3), 2), sinA = _base_sincos[0], cosA = _base_sincos[1];
        return [
            -9 * cosA,
            8 * sinA,
            3 * sinA
        ];
    },
    function(r) {
        var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(3 * r.L3 - 2 * r.L4), 2), sinA = _base_sincos[0], cosA = _base_sincos[1];
        return [
            8 * sinA,
            -8 * cosA,
            -3 * cosA
        ];
    },
    function(r) {
        var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(r.Lp + 2 * r.D - r.Mp), 2), sinA = _base_sincos[0], cosA = _base_sincos[1];
        return [
            8 * sinA,
            -7 * cosA,
            -3 * cosA
        ];
    },
    function(r) {
        var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(8 * r.L2 - 12 * r.L3), 2), sinA = _base_sincos[0], cosA = _base_sincos[1];
        return [
            -4 * sinA - 7 * cosA,
            -6 * sinA + 4 * cosA,
            -3 * sinA + 2 * cosA
        ];
    },
    function(r) {
        var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(8 * r.L2 - 14 * r.L3), 2), sinA = _base_sincos[0], cosA = _base_sincos[1];
        return [
            -4 * sinA - 7 * cosA,
            6 * sinA - 4 * cosA,
            3 * sinA - 2 * cosA
        ];
    },
    function(r) {
        var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(2 * r.L4), 2), sinA = _base_sincos[0], cosA = _base_sincos[1];
        return [
            -6 * sinA - 5 * cosA,
            -4 * sinA + 5 * cosA,
            -2 * sinA + 2 * cosA
        ];
    },
    function(r) {
        var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(3 * r.L2 - 4 * r.L3), 2), sinA = _base_sincos[0], cosA = _base_sincos[1];
        return [
            -sinA - cosA,
            -2 * sinA - 7 * cosA,
            sinA - 4 * cosA
        ];
    },
    function(r) {
        var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(2 * r.L3 - 2 * r.L5), 2), sinA = _base_sincos[0], cosA = _base_sincos[1];
        return [
            4 * sinA - 6 * cosA,
            -5 * sinA - 4 * cosA,
            -2 * sinA - 2 * cosA
        ];
    },
    function(r) {
        var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(3 * r.L2 - 3 * r.L3), 2), sinA = _base_sincos[0], cosA = _base_sincos[1];
        return [
            -7 * cosA,
            -6 * sinA,
            -3 * sinA
        ];
    },
    function(r) {
        var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(2 * r.L3 - 2 * r.L4), 2), sinA = _base_sincos[0], cosA = _base_sincos[1];
        return [
            5 * sinA - 5 * cosA,
            -4 * sinA - 5 * cosA,
            -2 * sinA - 2 * cosA
        ];
    },
    function(r) {
        var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(r.Lp - 2 * r.D), 2), sinA = _base_sincos[0], cosA = _base_sincos[1];
        return [
            5 * sinA,
            -5 * cosA,
            -2 * cosA
        ];
    }
];
function positionRonVondrak(eqFrom, epochTo, m\u03B1, m\u03B4) {
    var t = epochTo - 2000;
    var eqTo = new (0, _coordJsDefault.default).Equatorial();
    eqTo.ra = eqFrom.ra + m\u03B1.rad() * t;
    eqTo.dec = eqFrom.dec + m\u03B4.rad() * t;
    var jd = (0, _baseJsDefault.default).JulianYearToJDE(epochTo);
    var _aberrationRonVondrak = (0, _slicedToArray._)(aberrationRonVondrak(eqTo.ra, eqTo.dec, jd), 2), \u0394\u03B1 = _aberrationRonVondrak[0], \u0394\u03B4 = _aberrationRonVondrak[1];
    eqTo.ra += \u0394\u03B1;
    eqTo.dec += \u0394\u03B4;
    eqTo = (0, _precessJsDefault.default).position(eqTo, 2000, epochTo, 0, 0);
    var _nutation = (0, _slicedToArray._)(nutation(eqTo.ra, eqTo.dec, jd), 2), \u0394\u03B11 = _nutation[0], \u0394\u03B41 = _nutation[1];
    eqTo.ra += \u0394\u03B11;
    eqTo.dec += \u0394\u03B41;
    return eqTo;
}
exports.default = {
    nutation: nutation,
    perihelion: perihelion,
    eclipticAberration: eclipticAberration,
    aberration: aberration,
    position: position,
    aberrationRonVondrak: aberrationRonVondrak,
    positionRonVondrak: positionRonVondrak
};

},{"@swc/helpers/_/_sliced_to_array":"ha6sq","./base.js":"lEDxD","./coord.js":"kTRDS","./nutation.js":"jqV8z","./precess.js":"iqQIL","./solar.js":"d2aLm","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"kTRDS":[function(require,module,exports,__globalThis) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module coord
 */ /**
 * Coord: Chapter 13, Transformation of Coordinates.
 *
 * Transforms in this package are provided in two forms, function and method.
 * The results of the two forms should be identical.
 *
 * The function forms pass all arguments and results as single values.  These
 * forms are best used when you are transforming a single pair of coordinates
 * and wish to avoid memory allocation.
 *
 * The method forms take and return pointers to structs.  These forms are best
 * used when you are transforming multiple coordinates and can reuse one or
 * more of the structs.  In this case reuse of structs will minimize
 * allocations, and the struct pointers will pass more efficiently on the
 * stack.  These methods transform their arguments, placing the result in
 * the receiver.  The receiver is then returned for convenience.
 *
 * A number of the functions take sine and cosine of the obliquity of the
 * ecliptic.  This becomes an advantage when you doing multiple transformations
 * with the same obliquity.  The efficiency of computing sine and cosine once
 * and reuse these values far outweighs the overhead of passing one number as
 * opposed to two.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Ecliptic", function() {
    return Ecliptic;
});
parcelHelpers.export(exports, "Equatorial", function() {
    return Equatorial;
});
parcelHelpers.export(exports, "Horizontal", function() {
    return Horizontal;
});
parcelHelpers.export(exports, "Galactic", function() {
    return Galactic;
});
parcelHelpers.export(exports, "galacticNorth", function() {
    return galacticNorth;
});
parcelHelpers.export(exports, "galacticNorth1950", function() {
    return galacticNorth1950;
});
parcelHelpers.export(exports, "galacticLon0", function() {
    return galacticLon0;
});
parcelHelpers.export(exports, "galactic0Lon1950", function() {
    return galactic0Lon1950;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var _sexagesimalJs = require("./sexagesimal.js");
var _sexagesimalJsDefault = parcelHelpers.interopDefault(_sexagesimalJs);
var _globeJs = require("./globe.js"); // eslint-disable-line no-unused-vars
var Ecliptic = /*#__PURE__*/ function() {
    "use strict";
    function Ecliptic(lon, lat) {
        (0, _classCallCheck._)(this, Ecliptic);
        if (typeof lon === 'object') {
            lat = lon.lat;
            lon = lon.lon;
        }
        this.lon = lon || 0;
        this.lat = lat || 0;
    }
    (0, _createClass._)(Ecliptic, [
        {
            /**
   * converts ecliptic coordinates to equatorial coordinates.
   * @param {Number} ε - Obliquity
   * @returns {Equatorial}
   */ key: "toEquatorial",
            value: function toEquatorial(\u03B5) {
                var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03B5), 2), \u03B5sin = _base_sincos[0], \u03B5cos = _base_sincos[1];
                var _base_sincos1 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(this.lat), 2), s\u03B2 = _base_sincos1[0], c\u03B2 = _base_sincos1[1];
                var _base_sincos2 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(this.lon), 2), s\u03BB = _base_sincos2[0], c\u03BB = _base_sincos2[1];
                var ra = Math.atan2(s\u03BB * \u03B5cos - s\u03B2 / c\u03B2 * \u03B5sin, c\u03BB) // (13.3) p. 93
                ;
                if (ra < 0) ra += 2 * Math.PI;
                var dec = Math.asin(s\u03B2 * \u03B5cos + c\u03B2 * \u03B5sin * s\u03BB) // (13.4) p. 93
                ;
                return new Equatorial(ra, dec);
            }
        }
    ]);
    return Ecliptic;
}();
var Equatorial = /*#__PURE__*/ function() {
    "use strict";
    function Equatorial() {
        var ra = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, dec = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        (0, _classCallCheck._)(this, Equatorial);
        this.ra = ra;
        this.dec = dec;
    }
    (0, _createClass._)(Equatorial, [
        {
            /**
   * EqToEcl converts equatorial coordinates to ecliptic coordinates.
   * @param {Number} ε - Obliquity
   * @returns {Ecliptic}
   */ key: "toEcliptic",
            value: function toEcliptic(\u03B5) {
                var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03B5), 2), \u03B5sin = _base_sincos[0], \u03B5cos = _base_sincos[1];
                var _base_sincos1 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(this.ra), 2), s\u03B1 = _base_sincos1[0], c\u03B1 = _base_sincos1[1];
                var _base_sincos2 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(this.dec), 2), s\u03B4 = _base_sincos2[0], c\u03B4 = _base_sincos2[1];
                var lon = Math.atan2(s\u03B1 * \u03B5cos + s\u03B4 / c\u03B4 * \u03B5sin, c\u03B1) // (13.1) p. 93
                ;
                var lat = Math.asin(s\u03B4 * \u03B5cos - c\u03B4 * \u03B5sin * s\u03B1) // (13.2) p. 93
                ;
                return new Ecliptic(lon, lat);
            }
        },
        {
            /**
   * EqToHz computes Horizontal coordinates from equatorial coordinates.
   *
   * Argument g is the location of the observer on the Earth.  Argument st
   * is the sidereal time at Greenwich.
   *
   * Sidereal time must be consistent with the equatorial coordinates.
   * If coordinates are apparent, sidereal time must be apparent as well.
   *
   * @param {GlobeCoord} g - coordinates of observer on Earth
   * @param {Number} st - sidereal time at Greenwich at time of observation
   * @returns {Horizontal}
   */ key: "toHorizontal",
            value: function toHorizontal(g, st) {
                var H = new (0, _sexagesimalJsDefault.default).Time(st).rad() - g.lon - this.ra;
                var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(H), 2), sH = _base_sincos[0], cH = _base_sincos[1];
                var _base_sincos1 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(g.lat), 2), s\u03C6 = _base_sincos1[0], c\u03C6 = _base_sincos1[1];
                var _base_sincos2 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(this.dec), 2), s\u03B4 = _base_sincos2[0], c\u03B4 = _base_sincos2[1];
                var azimuth = Math.atan2(sH, cH * s\u03C6 - s\u03B4 / c\u03B4 * c\u03C6) // (13.5) p. 93
                ;
                var altitude = Math.asin(s\u03C6 * s\u03B4 + c\u03C6 * c\u03B4 * cH) // (13.6) p. 93
                ;
                return new Horizontal(azimuth, altitude);
            }
        },
        {
            /**
   * EqToGal converts equatorial coordinates to galactic coordinates.
   *
   * Equatorial coordinates must be referred to the standard equinox of B1950.0.
   * For conversion to B1950, see package precess and utility functions in
   * package "common".
   *
   * @returns {Galactic}
   */ key: "toGalactic",
            value: function toGalactic() {
                var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(galacticNorth1950.ra - this.ra), 2), sd\u03B1 = _base_sincos[0], cd\u03B1 = _base_sincos[1];
                var _base_sincos1 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(galacticNorth1950.dec), 2), sg\u03B4 = _base_sincos1[0], cg\u03B4 = _base_sincos1[1];
                var _base_sincos2 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(this.dec), 2), s\u03B4 = _base_sincos2[0], c\u03B4 = _base_sincos2[1];
                var x = Math.atan2(sd\u03B1, cd\u03B1 * sg\u03B4 - s\u03B4 / c\u03B4 * cg\u03B4) // (13.7) p. 94
                ;
                // (galactic0Lon1950 + 1.5*math.Pi) = magic number of 303 deg
                var lon = (galactic0Lon1950 + 1.5 * Math.PI - x) % (2 * Math.PI // (13.8) p. 94
                );
                var lat = Math.asin(s\u03B4 * sg\u03B4 + c\u03B4 * cg\u03B4 * cd\u03B1);
                return new Galactic(lon, lat);
            }
        }
    ]);
    return Equatorial;
}();
var Horizontal = /*#__PURE__*/ function() {
    "use strict";
    function Horizontal() {
        var az = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, alt = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        (0, _classCallCheck._)(this, Horizontal);
        this.az = az;
        this.alt = alt;
    }
    (0, _createClass._)(Horizontal, [
        {
            /**
   * transforms horizontal coordinates to equatorial coordinates.
   *
   * Sidereal time must be consistent with the equatorial coordinates.
   * If coordinates are apparent, sidereal time must be apparent as well.
   * @param {GlobeCoord} g - coordinates of observer on Earth (lat, lon)
   * @param {Number} st - sidereal time at Greenwich at time of observation.
   * @returns {Equatorial} (right ascension, declination)
   */ key: "toEquatorial",
            value: function toEquatorial(g, st) {
                var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(this.az), 2), sA = _base_sincos[0], cA = _base_sincos[1];
                var _base_sincos1 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(this.alt), 2), sh = _base_sincos1[0], ch = _base_sincos1[1];
                var _base_sincos2 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(g.lat), 2), s\u03C6 = _base_sincos2[0], c\u03C6 = _base_sincos2[1];
                var H = Math.atan2(sA, cA * s\u03C6 + sh / ch * c\u03C6);
                var ra = (0, _baseJsDefault.default).pmod(new (0, _sexagesimalJsDefault.default).Time(st).rad() - g.lon - H, 2 * Math.PI);
                var dec = Math.asin(s\u03C6 * sh - c\u03C6 * ch * cA);
                return new Equatorial(ra, dec);
            }
        }
    ]);
    return Horizontal;
}();
var Galactic = /*#__PURE__*/ function() {
    "use strict";
    function Galactic() {
        var lon = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, lat = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        (0, _classCallCheck._)(this, Galactic);
        this.lon = lon;
        this.lat = lat;
    }
    (0, _createClass._)(Galactic, [
        {
            /**
   * GalToEq converts galactic coordinates to equatorial coordinates.
   *
   * Resulting equatorial coordinates will be referred to the standard equinox of
   * B1950.0.  For subsequent conversion to other epochs, see package precess and
   * utility functions in package meeus.
   *
   * @returns {Equatorial} (right ascension, declination)
   */ key: "toEquatorial",
            value: function toEquatorial() {
                // (-galactic0Lon1950 - math.Pi/2) = magic number of -123 deg
                var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(this.lon - galactic0Lon1950 - Math.PI / 2), 2), sdLon = _base_sincos[0], cdLon = _base_sincos[1];
                var _base_sincos1 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(galacticNorth1950.dec), 2), sg\u03B4 = _base_sincos1[0], cg\u03B4 = _base_sincos1[1];
                var _base_sincos2 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(this.lat), 2), sb = _base_sincos2[0], cb = _base_sincos2[1];
                var y = Math.atan2(sdLon, cdLon * sg\u03B4 - sb / cb * cg\u03B4);
                // (galacticNorth1950.RA.Rad() - math.Pi) = magic number of 12.25 deg
                var ra = (0, _baseJsDefault.default).pmod(y + galacticNorth1950.ra - Math.PI, 2 * Math.PI);
                var dec = Math.asin(sb * sg\u03B4 + cb * cg\u03B4 * cdLon);
                return new Equatorial(ra, dec);
            }
        }
    ]);
    return Galactic;
}();
var galacticNorth = new Equatorial(new (0, _sexagesimalJsDefault.default).RA(12, 49, 0).rad(), 27.4 * Math.PI / 180);
var galacticNorth1950 = galacticNorth;
var galacticLon0 = 33 * Math.PI / 180;
var galactic0Lon1950 = galacticLon0;
exports.default = {
    Ecliptic: Ecliptic,
    Equatorial: Equatorial,
    Horizontal: Horizontal,
    Galactic: Galactic,
    galacticNorth: galacticNorth,
    galacticNorth1950: galacticNorth1950,
    galacticLon0: galacticLon0,
    galactic0Lon1950: galactic0Lon1950
};

},{"@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","@swc/helpers/_/_sliced_to_array":"ha6sq","./base.js":"lEDxD","./sexagesimal.js":"aLUGo","./globe.js":"fqyqU","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"aLUGo":[function(require,module,exports,__globalThis) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module sexagesimal
 */ /**
 * Sexagesimal functions
 */ /**
 * Angle represents a general purpose angle.
 * Unit is radians.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Angle", function() {
    return Angle;
});
parcelHelpers.export(exports, "HourAngle", function() {
    return HourAngle;
});
/**
 * DMSToDeg converts from parsed sexagesimal angle components to decimal
 * degrees.
 * @param {Boolean} neg - sign, true if negative
 * @param {Number} d - (int) degree
 * @param {Number} m - (int) minute
 * @param {Number} s - (float) second
 * @returns {Number} angle in degree
 */ parcelHelpers.export(exports, "DMSToDeg", function() {
    return DMSToDeg;
});
/**
 * DegToDMS converts from decimal degrees to parsed sexagesimal angle component.
 * @param {Number} deg - angle in degree
 * @returns {Array} [neg, d, m, s]
 *  {Boolean} neg - sign, true if negative
 *  {Number} d - (int) degree
 *  {Number} m - (int) minute
 *  {Number} s - (float) second
 */ parcelHelpers.export(exports, "degToDMS", function() {
    return degToDMS;
});
parcelHelpers.export(exports, "RA", function() {
    return RA;
});
parcelHelpers.export(exports, "Time", function() {
    return Time;
});
parcelHelpers.export(exports, "angleFromDeg", function() {
    return angleFromDeg;
});
parcelHelpers.export(exports, "angleFromMin", function() {
    return angleFromMin;
});
parcelHelpers.export(exports, "angleFromSec", function() {
    return angleFromSec;
});
parcelHelpers.export(exports, "degFromAngle", function() {
    return degFromAngle;
});
parcelHelpers.export(exports, "secFromAngle", function() {
    return secFromAngle;
});
parcelHelpers.export(exports, "secFromHourAngle", function() {
    return secFromHourAngle;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var Angle = /*#__PURE__*/ function() {
    "use strict";
    function Angle(angleOrNeg, d, m, s) {
        (0, _classCallCheck._)(this, Angle);
        if (arguments.length === 1) this.angle = Number(angleOrNeg);
        else this.setDMS(!!angleOrNeg, d, m, s);
    }
    (0, _createClass._)(Angle, [
        {
            /**
   * SetDMS sets the value of an FAngle from sign, degree, minute, and second
   * components.
   * The receiver is returned as a convenience.
   * @param {Boolean} neg - sign, true if negative
   * @param {Number} d - (int) degree
   * @param {Number} m - (int) minute
   * @param {Number} s - (float) second
   * @returns {Angle}
   */ key: "setDMS",
            value: function setDMS() {
                var neg = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, d = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, m = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0.0;
                this.angle = DMSToDeg(neg, d, m, s) * Math.PI / 180;
                return this;
            }
        },
        {
            /**
   * sets angle
   * @param {Number} angle - (float) angle in radians
   * @returns {Angle}
   */ key: "setAngle",
            value: function setAngle(angle) {
                this.angle = angle;
                return this;
            }
        },
        {
            /**
   * Rad returns the angle in radians.
   * @returns {Number} angle in radians
   */ key: "rad",
            value: function rad() {
                return this.angle;
            }
        },
        {
            /**
   * Deg returns the angle in degrees.
   * @returns {Number} angle in degree
   */ key: "deg",
            value: function deg() {
                return this.angle * 180 / Math.PI;
            }
        },
        {
            /**
   * toDMS converts to parsed sexagesimal angle component.
   */ key: "toDMS",
            value: function toDMS() {
                return degToDMS(this.deg());
            }
        },
        {
            /**
   * Print angle in degree using `d°m´s.ss″`
   * @param {Number} [precision] - precision of `s.ss`
   * @returns {String}
   */ key: "toString",
            value: function toString(precision) {
                var _this_toDMS = (0, _slicedToArray._)(this.toDMS(), 4), neg = _this_toDMS[0], d = _this_toDMS[1], m = _this_toDMS[2], s = _this_toDMS[3];
                s = round(s, precision).toString().replace(/^0\./, '.');
                var str = (neg ? '-' : '') + (d + "\xb0") + (m + "\u2032") + (s + "\u2033");
                return str;
            }
        },
        {
            /**
   * Print angle in degree using `d°.ff`
   * @param {Number} [precision] - precision of `.ff`
   * @returns {String}
   */ key: "toDegString",
            value: function toDegString(precision) {
                var _modf = (0, _slicedToArray._)(modf(this.deg()), 2), i = _modf[0], s = _modf[1];
                s = round(s, precision).toString().replace(/^0\./, '.');
                var str = i + "\xb0" + s;
                return str;
            }
        }
    ]);
    return Angle;
}();
var HourAngle = /*#__PURE__*/ function(Angle) {
    "use strict";
    (0, _inherits._)(HourAngle, Angle);
    function HourAngle() {
        (0, _classCallCheck._)(this, HourAngle);
        return (0, _callSuper._)(this, HourAngle, arguments);
    }
    (0, _createClass._)(HourAngle, [
        {
            /**
   * NewHourAngle constructs a new HourAngle value from sign, hour, minute,
   * and second components.
   * @param {Boolean} neg
   * @param {Number} h - (int)
   * @param {Number} m - (int)
   * @param {Number} s - (float)
   * @constructor
   */ /**
   * SetDMS sets the value of an FAngle from sign, degree, minute, and second
   * components.
   * The receiver is returned as a convenience.
   * @param {Boolean} neg - sign, true if negative
   * @param {Number} h - (int) hour
   * @param {Number} m - (int) minute
   * @param {Number} s - (float) second
   * @returns {Angle}
   */ key: "setDMS",
            value: function setDMS() {
                var neg = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, h = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, m = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0.0;
                this.angle = DMSToDeg(neg, h, m, s) * 15 * Math.PI / 180;
                return this;
            }
        },
        {
            /**
   * Hour returns the hour angle as hours of time.
   * @returns hour angle
   */ key: "hour",
            value: function hour() {
                return this.angle * 12 / Math.PI // 12 = 180 / 15
                ;
            }
        },
        {
            key: "deg",
            value: function deg() {
                return this.hour();
            }
        },
        {
            /**
   * Print angle in `HʰMᵐs.ssˢ`
   * @param {Number} precision - precision of `s.ss`
   * @returns {String}
   */ key: "toString",
            value: function toString(precision) {
                var _this_toDMS = (0, _slicedToArray._)(this.toDMS(), 4), neg = _this_toDMS[0], h = _this_toDMS[1], m = _this_toDMS[2], s = _this_toDMS[3];
                s = round(s, precision).toString().replace(/^0\./, '.');
                var str = (neg ? '-' : '') + (h + "\u02B0") + (m + "\u1D50") + (s + "\u02E2");
                return str;
            }
        }
    ]);
    return HourAngle;
}(Angle);
function DMSToDeg(neg, d, m, s) {
    s = ((d * 60 + m) * 60 + s) / 3600;
    if (neg) return -s;
    return s;
}
function degToDMS(deg) {
    var neg = deg < 0;
    deg = Math.abs(deg);
    var _modf = (0, _slicedToArray._)(modf(deg % 360), 2), d = _modf[0], s = _modf[1];
    var _modf1 = (0, _slicedToArray._)(modf(s * 60), 2), m = _modf1[0], s1 = _modf1[1];
    s = round(s1 * 60) // may introduce an error < 1e13
    ;
    return [
        neg,
        d,
        m,
        s
    ];
}
var RA = /*#__PURE__*/ function(HourAngle) {
    "use strict";
    (0, _inherits._)(RA, HourAngle);
    function RA() {
        var h = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, m = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
        (0, _classCallCheck._)(this, RA);
        var _this;
        _this = (0, _callSuper._)(this, RA, [
            false,
            h,
            m,
            s
        ]);
        var args = [].slice.call(arguments);
        if (args.length === 1) _this.angle = h;
        else {
            var hr = DMSToDeg(false, h, m, s) % 24;
            _this.angle = hr * 15 * Math.PI / 180;
        }
        return _this;
    }
    (0, _createClass._)(RA, [
        {
            key: "hour",
            value: function hour() {
                var h = this.angle * 12 / Math.PI;
                return (24 + h % 24) % 24;
            }
        }
    ]);
    return RA;
}(HourAngle);
var Time = /*#__PURE__*/ function() {
    "use strict";
    function Time(negOrTimeInSecs, h, m, s) {
        (0, _classCallCheck._)(this, Time);
        if (typeof negOrTimeInSecs === 'number') this.time = negOrTimeInSecs;
        else this.setHMS(negOrTimeInSecs, h, m, s);
    }
    (0, _createClass._)(Time, [
        {
            key: "setHMS",
            value: function setHMS() {
                var neg = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, h = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, m = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
                s += (h * 60 + m) * 60;
                if (neg) s = -s;
                this.time = s;
            }
        },
        {
            /**
   * @returns {Number} time in seconds.
   */ key: "sec",
            value: function sec() {
                return this.time;
            }
        },
        {
            /**
   * @returns {Number} time in minutes.
   */ key: "min",
            value: function min() {
                return this.time / 60;
            }
        },
        {
            /**
   * @returns {Number} time in hours.
   */ key: "hour",
            value: function hour() {
                return this.time / 3600;
            }
        },
        {
            /**
   * @returns {Number} time in days.
   */ key: "day",
            value: function day() {
                return this.time / 3600 / 24;
            }
        },
        {
            /**
   * @returns {Number} time in radians, where 1 day = 2 Pi radians.
   */ key: "rad",
            value: function rad() {
                return this.time * Math.PI / 12 / 3600;
            }
        },
        {
            /**
   * convert time to HMS
   * @returns {Array} [neg, h, m, s]
   *  {Boolean} neg - sign, true if negative
   *  {Number} h - (int) hour
   *  {Number} m - (int) minute
   *  {Number} s - (float) second
   */ key: "toHMS",
            value: function toHMS() {
                var t = this.time;
                var neg = t < 0;
                t = neg ? -t : t;
                var h = Math.trunc(t / 3600);
                t = t - h * 3600;
                var m = Math.trunc(t / 60);
                var s = t - m * 60;
                return [
                    neg,
                    h,
                    m,
                    s
                ];
            }
        },
        {
            /**
   * Print time using `HʰMᵐsˢ.ss`
   * @param {Number} precision - precision of `.ss`
   * @returns {String}
   */ key: "toString",
            value: function toString(precision) {
                var _this_toHMS = (0, _slicedToArray._)(this.toHMS(), 4), neg = _this_toHMS[0], h = _this_toHMS[1], m = _this_toHMS[2], s = _this_toHMS[3];
                var _modf = (0, _slicedToArray._)(modf(s), 2), si = _modf[0], sf = _modf[1];
                if (precision === 0) {
                    si = round(s, 0);
                    sf = 0;
                } else sf = round(sf, precision).toString().substr(1);
                var str = (neg ? '-' : '') + (h + "\u02B0") + (m + "\u1D50") + (si + "\u02E2") + (sf || '');
                return str;
            }
        }
    ]);
    return Time;
}();
var angleFromDeg = function(deg) {
    return deg * Math.PI / 180;
};
var angleFromMin = function(min) {
    return min / 60 * Math.PI / 180;
};
var angleFromSec = function(sec) {
    return sec / 3600 * Math.PI / 180;
};
var degFromAngle = function(angle) {
    return angle * 180 / Math.PI;
};
var secFromAngle = function(angle) {
    return angle * 648000 / Math.PI;
};
var secFromHourAngle = function(ha) {
    return ha * 43200 / Math.PI;
};
/**
 * separate fix `i` from fraction `f`
 * @private
 * @param {Number} float
 * @returns {Array} [i, f]
 *  {Number} i - (int) fix value
 *  {Number} f - (float) fractional portion; always > 1
 */ function modf(float) {
    var i = Math.trunc(float);
    var f = Math.abs(float - i);
    return [
        i,
        f
    ];
}
/**
 * Rounds `float` value by precision
 * @private
 * @param {Number} float - value to round
 * @param {Number} [precision] - (int) number of post decimal positions
 * @return {Number} rounded `float`
 */ function round(float) {
    var precision = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 10;
    return parseFloat(float.toFixed(precision));
}
exports.default = {
    Angle: Angle,
    HourAngle: HourAngle,
    DMSToDeg: DMSToDeg,
    degToDMS: degToDMS,
    RA: RA,
    Time: Time,
    angleFromDeg: angleFromDeg,
    angleFromMin: angleFromMin,
    angleFromSec: angleFromSec,
    degFromAngle: degFromAngle,
    secFromAngle: secFromAngle,
    secFromHourAngle: secFromHourAngle
};

},{"@swc/helpers/_/_call_super":"5oPMc","@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","@swc/helpers/_/_inherits":"j8HRi","@swc/helpers/_/_sliced_to_array":"ha6sq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"fqyqU":[function(require,module,exports,__globalThis) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module globe
 */ /**
 * Globe: Chapter 11, The Earth's Globe.
 *
 * Globe contains functions concerning the surface of the Earth idealized as
 * an ellipsoid of revolution.
 */ /**
 * Ellipsoid represents an ellipsoid of revolution. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Ellipsoid", function() {
    return Ellipsoid;
});
parcelHelpers.export(exports, "Earth76", function() {
    return Earth76;
});
parcelHelpers.export(exports, "RotationRate1996_5", function() {
    return RotationRate1996_5;
});
/**
 * oneDegreeOfLongitude returns the length of one degree of longitude.
 *
 * Argument `rp` is the radius in Km of a circle that is a parallel of latitude
 * (as returned by Ellipsoid.radiusAtLatitude.)
 * Result is distance in Km along one degree of the circle.
 *
 * @param {number} rp
 * @return {number} distance in Km
 */ parcelHelpers.export(exports, "oneDegreeOfLongitude", function() {
    return oneDegreeOfLongitude;
});
/**
 * oneDegreeOfLatitude returns the length of one degree of latitude.
 *
 * Argument `rm` is the radius in Km of curvature along a meridian.
 * (as returned by Ellipsoid.radiusOfCurvature.)
 * Result is distance in Km along one degree of the meridian.
 *
 * @param {number} rm
 * @return {number} distance in Km
 */ parcelHelpers.export(exports, "oneDegreeOfLatitude", function() {
    return oneDegreeOfLatitude;
});
/**
 * geocentricLatitudeDifference returns geographic latitude - geocentric
 * latitude (φ - φ′) with given geographic latitude (φ).
 *
 * Units are radians.
 * @param {number} φ
 * @returns {number} difference in Deg
 */ parcelHelpers.export(exports, "geocentricLatitudeDifference", function() {
    return geocentricLatitudeDifference;
});
parcelHelpers.export(exports, "Coord", function() {
    return Coord;
});
/**
 * approxAngularDistance returns the cosine of the angle between two points.
 *
 * The accuracy deteriorates at small angles.
 *
 * @param {Coord} p1 - Point 1
 * @param {Coord} p2 - Point 2
 * @returns {number} cosine `cos` of the angle between two points.
 * Use `d = Math.acos(cos)` to obtain geocentric angular distance in radians
 */ parcelHelpers.export(exports, "approxAngularDistance", function() {
    return approxAngularDistance;
});
/**
 * approxLinearDistance computes a distance across the surface of the Earth.
 *
 * Approximating the Earth as a sphere, the function takes a geocentric angular
 * distance in radians and returns the corresponding linear distance in Km.
 *
 * @param {number} d - geocentric angular distance in radians
 * @returns linear distance in Km
 */ parcelHelpers.export(exports, "approxLinearDistance", function() {
    return approxLinearDistance;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var Ellipsoid = /*#__PURE__*/ function() {
    "use strict";
    function Ellipsoid(radius, flat) {
        (0, _classCallCheck._)(this, Ellipsoid);
        this.radius = radius;
        this.flat = flat;
    }
    (0, _createClass._)(Ellipsoid, [
        {
            /** A is a common identifier for equatorial radius. */ key: "A",
            value: function A() {
                return this.radius;
            }
        },
        {
            /** B is a common identifier for polar radius. */ key: "B",
            value: function B() {
                return this.radius * (1 - this.flat);
            }
        },
        {
            /** eccentricity of a meridian. */ key: "eccentricity",
            value: function eccentricity() {
                return Math.sqrt((2 - this.flat) * this.flat);
            }
        },
        {
            /**
   * parallaxConstants computes parallax constants ρ sin φ′ and ρ cos φ′.
   *
   * Arguments are geographic latitude φ in radians and height h
   * in meters above the ellipsoid.
   *
   * @param {number} φ - geographic latitude in radians
   * @param {number} h - height in meters above the ellipsoid
   * @return {number[]} [ρ sin φ′, ρ cos φ] parallax constants [ρsφ, ρcφ]
   */ key: "parallaxConstants",
            value: function parallaxConstants(\u03C6, h) {
                var boa = 1 - this.flat;
                var su = Math.sin(Math.atan(boa * Math.tan(\u03C6)));
                var cu = Math.cos(Math.atan(boa * Math.tan(\u03C6)));
                var s = Math.sin(\u03C6);
                var c = Math.cos(\u03C6);
                var hoa = h * 1e-3 / this.radius;
                // (s, c float)
                var \u03C1s\u03C6 = su * boa + hoa * s;
                var \u03C1c\u03C6 = cu + hoa * c;
                return [
                    \u03C1s\u03C6,
                    \u03C1c\u03C6
                ];
            }
        },
        {
            /**
   * rho is distance from Earth center to a point on the ellipsoid.
   *
   * Result unit is fraction of the equatorial radius.
   * @param {number} φ - geographic latitude in radians
   * @returns {number} // TODO
   */ key: "rho",
            value: function rho(\u03C6) {
                // Magic numbers...
                return 0.9983271 + 0.0016764 * Math.cos(2 * \u03C6) - 0.0000035 * Math.cos(4 * \u03C6);
            }
        },
        {
            /**
   * radiusAtLatitude returns the radius of the circle that is the parallel of
   * latitude at φ.
   *
   * Result unit is Km.
   *
   * @param {number} φ
   * @return {number} radius in km
   */ key: "radiusAtLatitude",
            value: function radiusAtLatitude(\u03C6) {
                var s = Math.sin(\u03C6);
                var c = Math.cos(\u03C6);
                return this.A() * c / Math.sqrt(1 - (2 - this.flat) * this.flat * s * s);
            }
        },
        {
            /**
   * radiusOfCurvature of meridian at latitude φ.
   *
   * Result unit is Km.
   *
   * @param {number} φ
   * @return {number} radius in km
   */ key: "radiusOfCurvature",
            value: function radiusOfCurvature(\u03C6) {
                var s = Math.sin(\u03C6);
                var e2 = (2 - this.flat) * this.flat;
                return this.A() * (1 - e2) / Math.pow(1 - e2 * s * s, 1.5);
            }
        },
        {
            /**
   * distance is distance between two points measured along the surface
   * of an ellipsoid.
   *
   * Accuracy is much better than that of approxAngularDistance or
   * approxLinearDistance.
   *
   * Result unit is Km.
   *
   * @param {Coord} c1
   * @param {Coord} c2
   * @return {number} radius in km
   */ key: "distance",
            value: function distance(c1, c2) {
                // From AA, ch 11, p 84.
                var _sincos2 = (0, _slicedToArray._)(sincos2((c1.lat + c2.lat) / 2), 2), s2f = _sincos2[0], c2f = _sincos2[1];
                var _sincos21 = (0, _slicedToArray._)(sincos2((c1.lat - c2.lat) / 2), 2), s2g = _sincos21[0], c2g = _sincos21[1];
                var _sincos22 = (0, _slicedToArray._)(sincos2((c1.lon - c2.lon) / 2), 2), s2\u03BB = _sincos22[0], c2\u03BB = _sincos22[1];
                var s = s2g * c2\u03BB + c2f * s2\u03BB;
                var c = c2g * c2\u03BB + s2f * s2\u03BB;
                var \u03C9 = Math.atan(Math.sqrt(s / c));
                var r = Math.sqrt(s * c) / \u03C9;
                var d = 2 * \u03C9 * this.radius;
                var h1 = (3 * r - 1) / (2 * c);
                var h2 = (3 * r + 1) / (2 * s);
                return d * (1 + this.flat * (h1 * s2f * c2g - h2 * c2f * s2g));
            }
        }
    ]);
    return Ellipsoid;
}();
var Earth76 = new Ellipsoid(6378.14, 1 / 298.257);
var RotationRate1996_5 = 7.292114992e-5 // eslint-disable-line camelcase
;
function oneDegreeOfLongitude(rp) {
    return rp * Math.PI / 180;
}
function oneDegreeOfLatitude(rm) {
    return rm * Math.PI / 180;
}
function geocentricLatitudeDifference(\u03C6) {
    // This appears to be an approximation with hard coded magic numbers.
    // No explanation is given in the text. The ellipsoid is not specified.
    // Perhaps the approximation works well enough for all ellipsoids?
    return (692.73 * Math.sin(2 * \u03C6) - 1.16 * Math.sin(4 * \u03C6)) * Math.PI / 648000;
}
var Coord = function Coord() {
    "use strict";
    var lat = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, lon = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    (0, _classCallCheck._)(this, Coord);
    this.lat = lat;
    this.lon = lon;
};
function approxAngularDistance(p1, p2) {
    var s1 = Math.sin(p1.lat);
    var c1 = Math.cos(p1.lat);
    var s2 = Math.sin(p2.lat);
    var c2 = Math.cos(p2.lat);
    return s1 * s2 + c1 * c2 * Math.cos(p1.lon - p2.lon);
}
function approxLinearDistance(d) {
    return 6371 * d;
}
/**
 * @private
 */ function sincos2(x) {
    var s = Math.sin(x);
    var c = Math.cos(x);
    return [
        s * s,
        c * c
    ];
}
exports.default = {
    Ellipsoid: Ellipsoid,
    Earth76: Earth76,
    // eslint-disable-next-line camelcase
    RotationRate1996_5: RotationRate1996_5,
    oneDegreeOfLongitude: oneDegreeOfLongitude,
    oneDegreeOfLatitude: oneDegreeOfLatitude,
    geocentricLatitudeDifference: geocentricLatitudeDifference,
    Coord: Coord,
    approxAngularDistance: approxAngularDistance,
    approxLinearDistance: approxLinearDistance
};

},{"@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","@swc/helpers/_/_sliced_to_array":"ha6sq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jqV8z":[function(require,module,exports,__globalThis) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module nutation
 */ /**
 * Nutation: Chapter 22, Nutation and the Obliquity of the Ecliptic.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Nutation: Chapter 22, Nutation and the Obliquity of the Ecliptic.
/**
 * Nutation returns nutation in longitude (Δψ) and nutation in obliquity (Δε)
 * for a given JDE.
 *
 * JDE = UT + ΔT, see package.
 *
 * Computation is by 1980 IAU theory, with terms < .0003″ neglected.
 *
 * Result units are radians.
 *
 * @param {number} jde - Julian ephemeris day
 * @return {number[]} [Δψ, Δε] - [longitude, obliquity] in radians
 */ parcelHelpers.export(exports, "nutation", function() {
    return nutation;
});
/**
 * ApproxNutation returns a fast approximation of nutation in longitude (Δψ)
 * and nutation in obliquity (Δε) for a given JDE.
 *
 * Accuracy is 0.5″ in Δψ, 0.1″ in Δε.
 *
 * Result units are radians.
 *
 * @param {number} jde - Julian ephemeris day
 * @return {number[]} [Δψ, Δε] - [longitude, obliquity] in radians
 */ parcelHelpers.export(exports, "approxNutation", function() {
    return approxNutation;
});
/**
 * MeanObliquity returns mean obliquity (ε₀) following the IAU 1980
 * polynomial.
 *
 * Accuracy is 1″ over the range 1000 to 3000 years and 10″ over the range
 * 0 to 4000 years.
 *
 * Result unit is radians.
 *
 * @param {number} jde - Julian ephemeris day
 * @return {number} mean obliquity (ε₀)
 */ parcelHelpers.export(exports, "meanObliquity", function() {
    return meanObliquity;
});
/**
 * MeanObliquityLaskar returns mean obliquity (ε₀) following the Laskar
 * 1986 polynomial.
 *
 * Accuracy over the range 1000 to 3000 years is .01″.
 *
 * Accuracy over the valid date range of -8000 to +12000 years is
 * "a few seconds."
 *
 * Result unit is radians.
 *
 * @param {number} jde - Julian ephemeris day
 * @return {number} mean obliquity (ε₀)
 */ parcelHelpers.export(exports, "meanObliquityLaskar", function() {
    return meanObliquityLaskar;
});
/**
 * NutationInRA returns "nutation in right ascension" or "equation of the
 * equinoxes."
 *
 * Result is an angle in radians.
 *
 * @param {number} jde - Julian ephemeris day
 * @return {number} nutation in right ascension
 */ parcelHelpers.export(exports, "nutationInRA", function() {
    return nutationInRA;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var _sexagesimalJs = require("./sexagesimal.js");
var _sexagesimalJsDefault = parcelHelpers.interopDefault(_sexagesimalJs);
function nutation(jde) {
    var T = (0, _baseJsDefault.default).J2000Century(jde);
    // Mean elongation of the Moon from the sun
    var D = (0, _baseJsDefault.default).horner(T, 297.85036, 445267.11148, -0.0019142, 1.0 / 189474) * Math.PI / 180;
    // Mean anomaly of the Sun (Earth)
    var M = (0, _baseJsDefault.default).horner(T, 357.52772, 35999.050340, -0.0001603, -1 / 300000) * Math.PI / 180;
    // Mean anomaly of the Moon
    var N = (0, _baseJsDefault.default).horner(T, 134.96298, 477198.867398, 0.0086972, 1.0 / 56250) * Math.PI / 180;
    // Moon's argument of latitude
    var F = (0, _baseJsDefault.default).horner(T, 93.27191, 483202.017538, -0.0036825, 1.0 / 327270) * Math.PI / 180;
    // Longitude of the ascending node of the Moon's mean orbit on the ecliptic, measured from mean equinox of date
    var \u03A9 = (0, _baseJsDefault.default).horner(T, 125.04452, -1934.136261, 0.0020708, 1.0 / 450000) * Math.PI / 180;
    var \u0394\u03C8 = 0;
    var \u0394\u03B5 = 0;
    // sum in reverse order to accumulate smaller terms first
    for(var i = table22A.length - 1; i >= 0; i--){
        var row = table22A[i];
        var arg = row.d * D + row.m * M + row.n * N + row.f * F + row.\u03C9 * \u03A9;
        var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(arg), 2), s = _base_sincos[0], c = _base_sincos[1];
        \u0394\u03C8 += s * (row.s0 + row.s1 * T);
        \u0394\u03B5 += c * (row.c0 + row.c1 * T);
    }
    \u0394\u03C8 *= 0.0001 / 3600 * (Math.PI / 180);
    \u0394\u03B5 *= 0.0001 / 3600 * (Math.PI / 180);
    return [
        \u0394\u03C8,
        \u0394\u03B5
    ] // (Δψ, Δε float)
    ;
}
function approxNutation(jde) {
    var T = (jde - (0, _baseJsDefault.default).J2000) / 36525;
    var \u03A9 = (125.04452 - 1934.136261 * T) * Math.PI / 180;
    var L = (280.4665 + 36000.7698 * T) * Math.PI / 180;
    var N = (218.3165 + 481267.8813 * T) * Math.PI / 180;
    var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03A9), 2), s\u03A9 = _base_sincos[0], c\u03A9 = _base_sincos[1];
    var _base_sincos1 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(2 * L), 2), s2L = _base_sincos1[0], c2L = _base_sincos1[1];
    var _base_sincos2 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(2 * N), 2), s2N = _base_sincos2[0], c2N = _base_sincos2[1];
    var _base_sincos3 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(2 * \u03A9), 2), s2\u03A9 = _base_sincos3[0], c2\u03A9 = _base_sincos3[1];
    var \u0394\u03C8 = (-17.2 * s\u03A9 - 1.32 * s2L - 0.23 * s2N + 0.21 * s2\u03A9) / 3600 * (Math.PI / 180);
    var \u0394\u03B5 = (9.2 * c\u03A9 + 0.57 * c2L + 0.1 * c2N - 0.09 * c2\u03A9) / 3600 * (Math.PI / 180);
    return [
        \u0394\u03C8,
        \u0394\u03B5
    ] // (Δψ, Δε float)
    ;
}
function meanObliquity(jde) {
    // (22.2) p. 147
    return (0, _baseJsDefault.default).horner((0, _baseJsDefault.default).J2000Century(jde), new (0, _sexagesimalJsDefault.default).Angle(false, 23, 26, 21.448).rad(), -46.815 / 3600 * (Math.PI / 180), -0.00059 / 3600 * (Math.PI / 180), 0.001813 / 3600 * (Math.PI / 180));
}
function meanObliquityLaskar(jde) {
    // (22.3) p. 147
    return (0, _baseJsDefault.default).horner((0, _baseJsDefault.default).J2000Century(jde) * 0.01, new (0, _sexagesimalJsDefault.default).Angle(false, 23, 26, 21.448).rad(), -4680.93 / 3600 * (Math.PI / 180), -1.55 / 3600 * (Math.PI / 180), 1999.25 / 3600 * (Math.PI / 180), -51.38 / 3600 * (Math.PI / 180), -249.67 / 3600 * (Math.PI / 180), -39.05 / 3600 * (Math.PI / 180), 7.12 / 3600 * (Math.PI / 180), 27.87 / 3600 * (Math.PI / 180), 5.79 / 3600 * (Math.PI / 180), 2.45 / 3600 * (Math.PI / 180));
}
function nutationInRA(jde) {
    var _nutation = (0, _slicedToArray._)(nutation(jde), 2), \u0394\u03C8 = _nutation[0], \u0394\u03B5 = _nutation[1];
    var \u03B50 = meanObliquity(jde);
    return \u0394\u03C8 * Math.cos(\u03B50 + \u0394\u03B5);
}
var table22A = function() {
    var PROPS = "d,m,n,f,\u03C9,s0,s1,c0,c1".split(',');
    var tab = [
        [
            0,
            0,
            0,
            0,
            1,
            -171996,
            -174.2,
            92025,
            8.9
        ],
        [
            -2,
            0,
            0,
            2,
            2,
            -13187,
            -1.6,
            5736,
            -3.1
        ],
        [
            0,
            0,
            0,
            2,
            2,
            -2274,
            -0.2,
            977,
            -0.5
        ],
        [
            0,
            0,
            0,
            0,
            2,
            2062,
            0.2,
            -895,
            0.5
        ],
        [
            0,
            1,
            0,
            0,
            0,
            1426,
            -3.4,
            54,
            -0.1
        ],
        [
            0,
            0,
            1,
            0,
            0,
            712,
            0.1,
            -7,
            0
        ],
        [
            -2,
            1,
            0,
            2,
            2,
            -517,
            1.2,
            224,
            -0.6
        ],
        [
            0,
            0,
            0,
            2,
            1,
            -386,
            -0.4,
            200,
            0
        ],
        [
            0,
            0,
            1,
            2,
            2,
            -301,
            0,
            129,
            -0.1
        ],
        [
            -2,
            -1,
            0,
            2,
            2,
            217,
            -0.5,
            -95,
            0.3
        ],
        [
            -2,
            0,
            1,
            0,
            0,
            -158,
            0,
            0,
            0
        ],
        [
            -2,
            0,
            0,
            2,
            1,
            129,
            0.1,
            -70,
            0
        ],
        [
            0,
            0,
            -1,
            2,
            2,
            123,
            0,
            -53,
            0
        ],
        [
            2,
            0,
            0,
            0,
            0,
            63,
            0,
            0,
            0
        ],
        [
            0,
            0,
            1,
            0,
            1,
            63,
            0.1,
            -33,
            0
        ],
        [
            2,
            0,
            -1,
            2,
            2,
            -59,
            0,
            26,
            0
        ],
        [
            0,
            0,
            -1,
            0,
            1,
            -58,
            -0.1,
            32,
            0
        ],
        [
            0,
            0,
            1,
            2,
            1,
            -51,
            0,
            27,
            0
        ],
        [
            -2,
            0,
            2,
            0,
            0,
            48,
            0,
            0,
            0
        ],
        [
            0,
            0,
            -2,
            2,
            1,
            46,
            0,
            -24,
            0
        ],
        [
            2,
            0,
            0,
            2,
            2,
            -38,
            0,
            16,
            0
        ],
        [
            0,
            0,
            2,
            2,
            2,
            -31,
            0,
            13,
            0
        ],
        [
            0,
            0,
            2,
            0,
            0,
            29,
            0,
            0,
            0
        ],
        [
            -2,
            0,
            1,
            2,
            2,
            29,
            0,
            -12,
            0
        ],
        [
            0,
            0,
            0,
            2,
            0,
            26,
            0,
            0,
            0
        ],
        [
            -2,
            0,
            0,
            2,
            0,
            -22,
            0,
            0,
            0
        ],
        [
            0,
            0,
            -1,
            2,
            1,
            21,
            0,
            -10,
            0
        ],
        [
            0,
            2,
            0,
            0,
            0,
            17,
            -0.1,
            0,
            0
        ],
        [
            2,
            0,
            -1,
            0,
            1,
            16,
            0,
            -8,
            0
        ],
        [
            -2,
            2,
            0,
            2,
            2,
            -16,
            0.1,
            7,
            0
        ],
        [
            0,
            1,
            0,
            0,
            1,
            -15,
            0,
            9,
            0
        ],
        [
            -2,
            0,
            1,
            0,
            1,
            -13,
            0,
            7,
            0
        ],
        [
            0,
            -1,
            0,
            0,
            1,
            -12,
            0,
            6,
            0
        ],
        [
            0,
            0,
            2,
            -2,
            0,
            11,
            0,
            0,
            0
        ],
        [
            2,
            0,
            -1,
            2,
            1,
            -10,
            0,
            5,
            0
        ],
        [
            2,
            0,
            1,
            2,
            2,
            -8,
            0,
            3,
            0
        ],
        [
            0,
            1,
            0,
            2,
            2,
            7,
            0,
            -3,
            0
        ],
        [
            -2,
            1,
            1,
            0,
            0,
            -7,
            0,
            0,
            0
        ],
        [
            0,
            -1,
            0,
            2,
            2,
            -7,
            0,
            3,
            0
        ],
        [
            2,
            0,
            0,
            2,
            1,
            -7,
            0,
            3,
            0
        ],
        [
            2,
            0,
            1,
            0,
            0,
            6,
            0,
            0,
            0
        ],
        [
            -2,
            0,
            2,
            2,
            2,
            6,
            0,
            -3,
            0
        ],
        [
            -2,
            0,
            1,
            2,
            1,
            6,
            0,
            -3,
            0
        ],
        [
            2,
            0,
            -2,
            0,
            1,
            -6,
            0,
            3,
            0
        ],
        [
            2,
            0,
            0,
            0,
            1,
            -6,
            0,
            3,
            0
        ],
        [
            0,
            -1,
            1,
            0,
            0,
            5,
            0,
            0,
            0
        ],
        [
            -2,
            -1,
            0,
            2,
            1,
            -5,
            0,
            3,
            0
        ],
        [
            -2,
            0,
            0,
            0,
            1,
            -5,
            0,
            3,
            0
        ],
        [
            0,
            0,
            2,
            2,
            1,
            -5,
            0,
            3,
            0
        ],
        [
            -2,
            0,
            2,
            0,
            1,
            4,
            0,
            0,
            0
        ],
        [
            -2,
            1,
            0,
            2,
            1,
            4,
            0,
            0,
            0
        ],
        [
            0,
            0,
            1,
            -2,
            0,
            4,
            0,
            0,
            0
        ],
        [
            -1,
            0,
            1,
            0,
            0,
            -4,
            0,
            0,
            0
        ],
        [
            -2,
            1,
            0,
            0,
            0,
            -4,
            0,
            0,
            0
        ],
        [
            1,
            0,
            0,
            0,
            0,
            -4,
            0,
            0,
            0
        ],
        [
            0,
            0,
            1,
            2,
            0,
            3,
            0,
            0,
            0
        ],
        [
            0,
            0,
            -2,
            2,
            2,
            -3,
            0,
            0,
            0
        ],
        [
            -1,
            -1,
            1,
            0,
            0,
            -3,
            0,
            0,
            0
        ],
        [
            0,
            1,
            1,
            0,
            0,
            -3,
            0,
            0,
            0
        ],
        [
            0,
            -1,
            1,
            2,
            2,
            -3,
            0,
            0,
            0
        ],
        [
            2,
            -1,
            -1,
            2,
            2,
            -3,
            0,
            0,
            0
        ],
        [
            0,
            0,
            3,
            2,
            2,
            -3,
            0,
            0,
            0
        ],
        [
            2,
            -1,
            0,
            2,
            2,
            -3,
            0,
            0,
            0
        ]
    ];
    return tab.map(function(row) {
        var o = {};
        PROPS.forEach(function(p, i) {
            o[p] = row[i];
        });
        return o;
    });
}();
exports.default = {
    nutation: nutation,
    approxNutation: approxNutation,
    meanObliquity: meanObliquity,
    meanObliquityLaskar: meanObliquityLaskar,
    nutationInRA: nutationInRA
};

},{"@swc/helpers/_/_sliced_to_array":"ha6sq","./base.js":"lEDxD","./sexagesimal.js":"aLUGo","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"iqQIL":[function(require,module,exports,__globalThis) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module precess
 */ /**
 * Precession: Chapter 21, Precession.
 *
 * Functions in this package take Julian epoch argurments rather than Julian
 * days.  Use base.JDEToJulianYear() to convert.
 *
 * Also in package base are some definitions related to the Besselian and
 * Julian Year.
 *
 * Partial:  Precession from FK4 not implemented.  Meeus gives no test cases.
 * It's a fair amount of code and data, representing significant chances for
 * errors.  And precession from FK4 would seem to be of little interest today.
 *
 * Proper motion units
 *
 * Meeus gives some example annual proper motions in units of seconds of
 * right ascension and seconds of declination.  To make units clear,
 * functions in this package take proper motions with argument types of
 * sexa.HourAngle and sexa.Angle respectively.  Error-prone conversions
 * can be avoided by using the constructors for these base types.
 *
 * For example, given an annual proper motion in right ascension of -0ˢ.03847,
 * rather than
 *
 * mra = -0.03847 / 13751 // as Meeus suggests
 *
 * or
 *
 * mra = -0.03847 * (15/3600) * (pi/180) // less magic
 *
 * use
 *
 * mra = new sexa.HourAngle(false, 0, 0, -0.03847)
 *
 * Unless otherwise indicated, functions in this library expect proper motions
 * to be annual proper motions, so the unit denominator is years.
 * (The code, following Meeus's example, technically treats it as Julian years.)
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * approxAnnualPrecession returns approximate annual precision in right
 * ascension and declination.
 *
 * The two epochs should be within a few hundred years.
 * The declinations should not be too close to the poles.
 *
 * @param {Equatorial} eqFrom
 * @param {Number} epochFrom - use `base.JDEToJulianYear(year)` to get epoch
 * @param {Number} epochTo - use `base.JDEToJulianYear(year)` to get epoch
 * @returns {Object}
 *  {sexa.HourAngle} seconds of right ascension
 *  {sexa.Angle} seconds of Declination
 */ parcelHelpers.export(exports, "approxAnnualPrecession", function() {
    return approxAnnualPrecession;
});
/**
 * @param {Number} epochFrom - use `base.JDEToJulianYear(year)` to get epoch
 * @param {Number} epochTo - use `base.JDEToJulianYear(year)` to get epoch
 * @returns {Number[]}
 */ parcelHelpers.export(exports, "mn", function() {
    return mn;
});
/**
 * ApproxPosition uses ApproxAnnualPrecession to compute a simple and quick
 * precession while still considering proper motion.
 *
 * @param {Equatorial} eqFrom
 * @param {Number} epochFrom
 * @param {Number} epochTo
 * @param {Number} mα - in radians
 * @param {Number} mδ - in radians
 * @returns {Equatorial} eqTo
 */ parcelHelpers.export(exports, "approxPosition", function() {
    return approxPosition;
});
parcelHelpers.export(exports, "Precessor", function() {
    return Precessor;
});
/**
 * Position precesses equatorial coordinates from one epoch to another,
 * including proper motions.
 *
 * If proper motions are not to be considered or are not applicable, pass 0, 0
 * for mα, mδ
 *
 * Both eqFrom and eqTo must be non-nil, although they may point to the same
 * struct.  EqTo is returned for convenience.
 * @param {Equatorial} eqFrom
 * @param {Number} epochFrom
 * @param {Number} epochTo
 * @param {Number} mα - in radians
 * @param {Number} mδ - in radians
 * @returns {Equatorial} [eqTo]
 */ parcelHelpers.export(exports, "position", function() {
    return position;
});
parcelHelpers.export(exports, "EclipticPrecessor", function() {
    return EclipticPrecessor;
});
/**
 * eclipticPosition precesses ecliptic coordinates from one epoch to another,
 * including proper motions.
 * While eclFrom is given as ecliptic coordinates, proper motions mα, mδ are
 * still expected to be equatorial.  If proper motions are not to be considered
 * or are not applicable, pass 0, 0.
 * Both eclFrom and eclTo must be non-nil, although they may point to the same
 * struct.  EclTo is returned for convenience.
 *
 * @param {Ecliptic} eclFrom,
 * @param {Number} epochFrom
 * @param {HourAngle} [mα]
 * @param {Angle} [mδ]
 * @returns {Ecliptic} eclTo
 */ parcelHelpers.export(exports, "eclipticPosition", function() {
    return eclipticPosition;
});
/**
 * @param {Number} mα - anual proper motion (ra)
 * @param {Number} mδ - anual proper motion (dec)
 * @param {Number} epoch
 * @param {Ecliptic} ecl
 * @returns {Ecliptic} {lon, lat}
 */ parcelHelpers.export(exports, "properMotion", function() {
    return properMotion;
});
/**
 * ProperMotion3D takes the 3D equatorial coordinates of an object
 * at one epoch and computes its coordinates at a new epoch, considering
 * proper motion and radial velocity.
 *
 * Radial distance (r) must be in parsecs, radial velocitiy (mr) in
 * parsecs per year.
 *
 * Both eqFrom and eqTo must be non-nil, although they may point to the same
 * struct.  EqTo is returned for convenience.
 *
 * @param {Equatorial} eqFrom,
 * @param {Number} epochFrom
 * @param {Number} r
 * @param {Number} mr
 * @param {HourAngle} mα
 * @param {Angle} mδ
 * @returns {Equatorial} eqTo
 */ parcelHelpers.export(exports, "properMotion3D", function() {
    return properMotion3D;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var _coordJs = require("./coord.js");
var _elementequinoxJs = require("./elementequinox.js");
var _nutationJs = require("./nutation.js");
var _nutationJsDefault = parcelHelpers.interopDefault(_nutationJs);
var _sexagesimalJs = require("./sexagesimal.js");
function approxAnnualPrecession(eqFrom, epochFrom, epochTo) {
    var _mn = (0, _slicedToArray._)(mn(epochFrom, epochTo), 3), m = _mn[0], na = _mn[1], nd = _mn[2];
    var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(eqFrom.ra), 2), sa = _base_sincos[0], ca = _base_sincos[1];
    // (21.1) p. 132
    var \u0394\u03B1s = m + na * sa * Math.tan(eqFrom.dec) // seconds of RA
    ;
    var \u0394\u03B4s = nd * ca // seconds of Dec
    ;
    var ra = new (0, _sexagesimalJs.HourAngle)(false, 0, 0, \u0394\u03B1s).rad();
    var dec = new (0, _sexagesimalJs.Angle)(false, 0, 0, \u0394\u03B4s).rad();
    return {
        ra: ra,
        dec: dec
    };
}
function mn(epochFrom, epochTo) {
    var T = (epochTo - epochFrom) * 0.01;
    var m = 3.07496 + 0.00186 * T;
    var na = 1.33621 - 0.00057 * T;
    var nd = 20.0431 - 0.0085 * T;
    return [
        m,
        na,
        nd
    ];
}
function approxPosition(eqFrom, epochFrom, epochTo, m\u03B1, m\u03B4) {
    var _approxAnnualPrecession = approxAnnualPrecession(eqFrom, epochFrom, epochTo), ra = _approxAnnualPrecession.ra, dec = _approxAnnualPrecession.dec;
    var dy = epochTo - epochFrom;
    var eqTo = new (0, _coordJs.Equatorial)();
    eqTo.ra = eqFrom.ra + (ra + m\u03B1) * dy;
    eqTo.dec = eqFrom.dec + (dec + m\u03B4) * dy;
    return eqTo;
}
// constants
var d = Math.PI / 180;
var s = d / 3600;
// coefficients from (21.2) p. 134
var \u03B6T = [
    2306.2181 * s,
    1.39656 * s,
    -0.000139 * s
];
var zT = [
    2306.2181 * s,
    1.39656 * s,
    -0.000139 * s
];
var \u03B8T = [
    2004.3109 * s,
    -0.8533 * s,
    -0.000217 * s
];
// coefficients from (21.3) p. 134
var \u03B6t = [
    2306.2181 * s,
    0.30188 * s,
    0.017998 * s
];
var zt = [
    2306.2181 * s,
    1.09468 * s,
    0.018203 * s
];
var \u03B8t = [
    2004.3109 * s,
    -0.42665 * s,
    -0.041833 * s
];
var Precessor = /*#__PURE__*/ function() {
    "use strict";
    function Precessor(epochFrom, epochTo) {
        var _base, _base1, _base2;
        (0, _classCallCheck._)(this, Precessor);
        // (21.2) p. 134
        var \u03B6Coeff = \u03B6t;
        var zCoeff = zt;
        var \u03B8Coeff = \u03B8t;
        if (epochFrom !== 2000) {
            var _base3, _base4, _base5;
            var T = (epochFrom - 2000) * 0.01;
            \u03B6Coeff = [
                (_base3 = (0, _baseJsDefault.default)).horner.apply(_base3, [
                    T
                ].concat((0, _toConsumableArray._)(\u03B6T))),
                0.30188 * s - 0.000344 * s * T,
                0.017998 * s
            ];
            zCoeff = [
                (_base4 = (0, _baseJsDefault.default)).horner.apply(_base4, [
                    T
                ].concat((0, _toConsumableArray._)(zT))),
                1.09468 * s + 0.000066 * s * T,
                0.018203 * s
            ];
            \u03B8Coeff = [
                (_base5 = (0, _baseJsDefault.default)).horner.apply(_base5, [
                    T
                ].concat((0, _toConsumableArray._)(\u03B8T))),
                -0.42665 * s - 0.000217 * s * T,
                -0.041833 * s
            ];
        }
        var t = (epochTo - epochFrom) * 0.01;
        this.\u03B6 = (_base = (0, _baseJsDefault.default)).horner.apply(_base, [
            t
        ].concat((0, _toConsumableArray._)(\u03B6Coeff))) * t;
        this.z = (_base1 = (0, _baseJsDefault.default)).horner.apply(_base1, [
            t
        ].concat((0, _toConsumableArray._)(zCoeff))) * t;
        var \u03B8 = (_base2 = (0, _baseJsDefault.default)).horner.apply(_base2, [
            t
        ].concat((0, _toConsumableArray._)(\u03B8Coeff))) * t;
        this.s\u03B8 = Math.sin(\u03B8);
        this.c\u03B8 = Math.cos(\u03B8);
    }
    (0, _createClass._)(Precessor, [
        {
            /**
   * Precess precesses coordinates eqFrom, leaving result in eqTo.
   *
   * @param {Equatorial} eqFrom
   * @returns {Equatorial} eqTo
   */ key: "precess",
            value: function precess(eqFrom) {
                // (21.4) p. 134
                var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(eqFrom.dec), 2), s\u03B4 = _base_sincos[0], c\u03B4 = _base_sincos[1];
                var _base_sincos1 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(eqFrom.ra + this.\u03B6), 2), s\u03B1\u03B6 = _base_sincos1[0], c\u03B1\u03B6 = _base_sincos1[1];
                var A = c\u03B4 * s\u03B1\u03B6;
                var B = this.c\u03B8 * c\u03B4 * c\u03B1\u03B6 - this.s\u03B8 * s\u03B4;
                var C = this.s\u03B8 * c\u03B4 * c\u03B1\u03B6 + this.c\u03B8 * s\u03B4;
                var eqTo = new (0, _coordJs.Equatorial)();
                eqTo.ra = Math.atan2(A, B) + this.z;
                if (C < (0, _baseJsDefault.default).CosSmallAngle) eqTo.dec = Math.asin(C);
                else eqTo.dec = Math.acos(Math.hypot(A, B)) // near pole
                ;
                return eqTo;
            }
        }
    ]);
    return Precessor;
}();
function position(eqFrom, epochFrom, epochTo, m\u03B1, m\u03B4) {
    var p = new Precessor(epochFrom, epochTo);
    var t = epochTo - epochFrom;
    var eqTo = new (0, _coordJs.Equatorial)();
    eqTo.ra = eqFrom.ra + m\u03B1 * t;
    eqTo.dec = eqFrom.dec + m\u03B4 * t;
    return p.precess(eqTo);
}
// coefficients from (21.5) p. 136
var \u03B7T = [
    47.0029 * s,
    -0.06603 * s,
    0.000598 * s
];
var \u03C0T = [
    174.876384 * d,
    3289.4789 * s,
    0.60622 * s
];
var pT = [
    5029.0966 * s,
    2.22226 * s,
    -0.000042 * s
];
var \u03B7t = [
    47.0029 * s,
    -0.03302 * s,
    0.000060 * s
];
var \u03C0t = [
    174.876384 * d,
    -869.8089 * s,
    0.03536 * s
];
var pt = [
    5029.0966 * s,
    1.11113 * s,
    -0.000006 * s
];
var EclipticPrecessor = /*#__PURE__*/ function() {
    "use strict";
    function EclipticPrecessor(epochFrom, epochTo) {
        var _base, _base1, _base2;
        (0, _classCallCheck._)(this, EclipticPrecessor);
        // (21.5) p. 136
        var \u03B7Coeff = \u03B7t;
        var \u03C0Coeff = \u03C0t;
        var pCoeff = pt;
        if (epochFrom !== 2000) {
            var _base3, _base4, _base5;
            var T = (epochFrom - 2000) * 0.01;
            \u03B7Coeff = [
                (_base3 = (0, _baseJsDefault.default)).horner.apply(_base3, [
                    T
                ].concat((0, _toConsumableArray._)(\u03B7T))),
                -0.03302 * s + 0.000598 * s * T,
                0.000060 * s
            ];
            \u03C0Coeff = [
                (_base4 = (0, _baseJsDefault.default)).horner.apply(_base4, [
                    T
                ].concat((0, _toConsumableArray._)(\u03C0T))),
                -869.8089 * s - 0.50491 * s * T,
                0.03536 * s
            ];
            pCoeff = [
                (_base5 = (0, _baseJsDefault.default)).horner.apply(_base5, [
                    T
                ].concat((0, _toConsumableArray._)(pT))),
                1.11113 * s - 0.000042 * s * T,
                -0.000006 * s
            ];
        }
        var t = (epochTo - epochFrom) * 0.01;
        this.\u03C0 = (_base = (0, _baseJsDefault.default)).horner.apply(_base, [
            t
        ].concat((0, _toConsumableArray._)(\u03C0Coeff)));
        this.p = (_base1 = (0, _baseJsDefault.default)).horner.apply(_base1, [
            t
        ].concat((0, _toConsumableArray._)(pCoeff))) * t;
        var \u03B7 = (_base2 = (0, _baseJsDefault.default)).horner.apply(_base2, [
            t
        ].concat((0, _toConsumableArray._)(\u03B7Coeff))) * t;
        this.s\u03B7 = Math.sin(\u03B7);
        this.c\u03B7 = Math.cos(\u03B7);
    }
    (0, _createClass._)(EclipticPrecessor, [
        {
            /**
   * EclipticPrecess precesses coordinates eclFrom, leaving result in eclTo.
   *
   * The same struct may be used for eclFrom and eclTo.
   * EclTo is returned for convenience.
   * @param {Ecliptic} eclFrom
   * @returns {Ecliptic} [eclTo]
   */ key: "precess",
            value: function precess(eclFrom) {
                // (21.7) p. 137
                var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(eclFrom.lat), 2), s\u03B2 = _base_sincos[0], c\u03B2 = _base_sincos[1];
                var _base_sincos1 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(this.\u03C0 - eclFrom.lon), 2), sd = _base_sincos1[0], cd = _base_sincos1[1];
                var A = this.c\u03B7 * c\u03B2 * sd - this.s\u03B7 * s\u03B2;
                var B = c\u03B2 * cd;
                var C = this.c\u03B7 * s\u03B2 + this.s\u03B7 * c\u03B2 * sd;
                var eclTo = new (0, _coordJs.Ecliptic)(this.p + this.\u03C0 - Math.atan2(A, B));
                if (C < (0, _baseJsDefault.default).CosSmallAngle) eclTo.lat = Math.asin(C);
                else eclTo.lat = Math.acos(Math.hypot(A, B)) // near pole
                ;
                return eclTo;
            }
        },
        {
            /**
   * ReduceElements reduces orbital elements of a solar system body from one
   * equinox to another.
   *
   * This function is described in chapter 24, but is located in this
   * package so it can be a method of EclipticPrecessor.
   *
   * @param {Elements} eFrom
   * @returns {Elements} eTo
   */ key: "reduceElements",
            value: function reduceElements(eFrom) {
                var \u03C8 = this.\u03C0 + this.p;
                var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(eFrom.inc), 2), si = _base_sincos[0], ci = _base_sincos[1];
                var _base_sincos1 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(eFrom.node - this.\u03C0), 2), snp = _base_sincos1[0], cnp = _base_sincos1[1];
                var eTo = new (0, _elementequinoxJs.Elements)();
                // (24.1) p. 159
                eTo.inc = Math.acos(ci * this.c\u03B7 + si * this.s\u03B7 * cnp);
                // (24.2) p. 159
                eTo.node = Math.atan2(si * snp, this.c\u03B7 * si * cnp - this.s\u03B7 * ci) + \u03C8;
                // (24.3) p. 159
                eTo.peri = Math.atan2(-this.s\u03B7 * snp, si * this.c\u03B7 - ci * this.s\u03B7 * cnp) + eFrom.peri;
                return eTo;
            }
        }
    ]);
    return EclipticPrecessor;
}();
function eclipticPosition(eclFrom, epochFrom, epochTo, m\u03B1, m\u03B4) {
    var p = new EclipticPrecessor(epochFrom, epochTo);
    if (m\u03B1 && m\u03B4 && (m\u03B1.rad() !== 0 || m\u03B4.rad() !== 0)) {
        var _properMotion = properMotion(m\u03B1.rad(), m\u03B4.rad(), epochFrom, eclFrom), lon = _properMotion.lon, lat = _properMotion.lat;
        var t = epochTo - epochFrom;
        eclFrom.lon += lon * t;
        eclFrom.lat += lat * t;
    }
    return p.precess(eclFrom);
}
function properMotion(m\u03B1, m\u03B4, epoch, ecl) {
    var \u03B5 = (0, _nutationJsDefault.default).meanObliquity((0, _baseJsDefault.default).JulianYearToJDE(epoch));
    var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03B5), 2), \u03B5sin = _base_sincos[0], \u03B5cos = _base_sincos[1];
    var _ecl_toEquatorial = ecl.toEquatorial(\u03B5), ra = _ecl_toEquatorial.ra, dec = _ecl_toEquatorial.dec;
    var _base_sincos1 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(ra), 2), s\u03B1 = _base_sincos1[0], c\u03B1 = _base_sincos1[1];
    var _base_sincos2 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(dec), 2), s\u03B4 = _base_sincos2[0], c\u03B4 = _base_sincos2[1];
    var c\u03B2 = Math.cos(ecl.lat);
    var lon = (m\u03B4 * \u03B5sin * c\u03B1 + m\u03B1 * c\u03B4 * (\u03B5cos * c\u03B4 + \u03B5sin * s\u03B4 * s\u03B1)) / (c\u03B2 * c\u03B2);
    var lat = (m\u03B4 * (\u03B5cos * c\u03B4 + \u03B5sin * s\u03B4 * s\u03B1) - m\u03B1 * \u03B5sin * c\u03B1 * c\u03B4) / c\u03B2;
    return new (0, _coordJs.Ecliptic)(lon, lat);
}
function properMotion3D(eqFrom, epochFrom, epochTo, r, mr, m\u03B1, m\u03B4) {
    var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(eqFrom.ra), 2), s\u03B1 = _base_sincos[0], c\u03B1 = _base_sincos[1];
    var _base_sincos1 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(eqFrom.dec), 2), s\u03B4 = _base_sincos1[0], c\u03B4 = _base_sincos1[1];
    var x = r * c\u03B4 * c\u03B1;
    var y = r * c\u03B4 * s\u03B1;
    var z = r * s\u03B4;
    var mrr = mr / r;
    var zm\u03B4 = z * m\u03B4.rad();
    var mx = x * mrr - zm\u03B4 * c\u03B1 - y * m\u03B1.rad();
    var my = y * mrr - zm\u03B4 * s\u03B1 + x * m\u03B1.rad();
    var mz = z * mrr + r * m\u03B4.rad() * c\u03B4;
    var t = epochTo - epochFrom;
    var xp = x + t * mx;
    var yp = y + t * my;
    var zp = z + t * mz;
    var eqTo = new (0, _coordJs.Equatorial)();
    eqTo.ra = Math.atan2(yp, xp);
    eqTo.dec = Math.atan2(zp, Math.hypot(xp, yp));
    return eqTo;
}
exports.default = {
    approxAnnualPrecession: approxAnnualPrecession,
    mn: mn,
    approxPosition: approxPosition,
    Precessor: Precessor,
    position: position,
    EclipticPrecessor: EclipticPrecessor,
    eclipticPosition: eclipticPosition,
    properMotion: properMotion,
    properMotion3D: properMotion3D
};

},{"@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","@swc/helpers/_/_sliced_to_array":"ha6sq","@swc/helpers/_/_to_consumable_array":"eqNDD","./base.js":"lEDxD","./coord.js":"kTRDS","./elementequinox.js":"kF9iX","./nutation.js":"jqV8z","./sexagesimal.js":"aLUGo","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"kF9iX":[function(require,module,exports,__globalThis) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module elementequinox
 */ /**
 * Elementequinox: Chapter 24, Reduction of Ecliptical Elements
 * from one Equinox to another one.
 *
 * See package precess for the method EclipticPrecessor.ReduceElements and
 * associated example.  The method is described in this chapter but located
 * in package precess so that it can be a method of EclipticPrecessor.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Elements", function() {
    return Elements;
});
/**
 * ReduceB1950ToJ2000 reduces orbital elements of a solar system body from
 * equinox B1950 to J2000.
 *
 * @param {Elements} eFrom
 * @returns {Elements} eTo
 */ parcelHelpers.export(exports, "reduceB1950ToJ2000", function() {
    return reduceB1950ToJ2000;
});
/**
 * ReduceB1950ToJ2000 reduces orbital elements of a solar system body from
 * equinox B1950 in the FK4 system to equinox J2000 in the FK5 system.
 *
 * @param {Elements} eFrom
 * @returns {Elements} eTo
 */ parcelHelpers.export(exports, "reduceB1950FK4ToJ2000FK5", function() {
    return reduceB1950FK4ToJ2000FK5;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var Elements = function Elements(inc, node, peri) {
    "use strict";
    (0, _classCallCheck._)(this, Elements);
    if (typeof inc === 'object') {
        node = inc.pode;
        peri = inc.peri;
        inc = inc.inc;
    }
    this.inc = inc || 0;
    this.node = node || 0;
    this.peri = peri || 0;
};
// (24.4) p. 161
var S = 0.0001139788;
var C = 0.9999999935;
function reduceB1950ToJ2000(eFrom) {
    var W = eFrom.node - 174.298782 * Math.PI / 180;
    var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(eFrom.inc), 2), si = _base_sincos[0], ci = _base_sincos[1];
    var _base_sincos1 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(W), 2), sW = _base_sincos1[0], cW = _base_sincos1[1];
    var A = si * sW;
    var B = C * si * cW - S * ci;
    var eTo = new Elements();
    eTo.inc = Math.asin(Math.hypot(A, B));
    eTo.node = (0, _baseJsDefault.default).pmod(174.997194 * Math.PI / 180 + Math.atan2(A, B), 2 * Math.PI);
    eTo.peri = (0, _baseJsDefault.default).pmod(eFrom.peri + Math.atan2(-S * sW, C * si - S * ci * cW), 2 * Math.PI);
    return eTo;
}
var Lp = 4.50001688 * Math.PI / 180;
var L = 5.19856209 * Math.PI / 180;
var J = 0.00651966 * Math.PI / 180;
function reduceB1950FK4ToJ2000FK5(eFrom) {
    var W = L + eFrom.node;
    var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(eFrom.inc), 2), si = _base_sincos[0], ci = _base_sincos[1];
    var _base_sincos1 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(J), 2), sJ = _base_sincos1[0], cJ = _base_sincos1[1];
    var _base_sincos2 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(W), 2), sW = _base_sincos2[0], cW = _base_sincos2[1];
    var eTo = new Elements();
    eTo.inc = Math.acos(ci * cJ - si * sJ * cW);
    eTo.node = (0, _baseJsDefault.default).pmod(Math.atan2(si * sW, ci * sJ + si * cJ * cW) - Lp, 2 * Math.PI);
    eTo.peri = (0, _baseJsDefault.default).pmod(eFrom.peri + Math.atan2(sJ * sW, si * cJ + ci * sJ * cW), 2 * Math.PI);
    return eTo;
}
exports.default = {
    Elements: Elements,
    reduceB1950ToJ2000: reduceB1950ToJ2000,
    reduceB1950FK4ToJ2000FK5: reduceB1950FK4ToJ2000FK5
};

},{"@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_sliced_to_array":"ha6sq","./base.js":"lEDxD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"d2aLm":[function(require,module,exports,__globalThis) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module solar
 */ /**
 * Solar: Chapter 25, Solar Coordinates.
 *
 * Partial implementation:
 *
 * 1. Higher accuracy positions are not computed with Appendix III but with
 * full VSOP87 as implemented in package planetposition.
 *
 * 2. Higher accuracy correction for aberration (using the formula for
 * variation Δλ on p. 168) is not implemented.  Results for example 25.b
 * already match the full VSOP87 values on p. 165 even with the low accuracy
 * correction for aberration, thus there are no more significant digits that
 * would check a more accurate result.  Also the size of the formula presents
 * significant chance of typographical error.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * True returns true geometric longitude and anomaly of the sun referenced to the mean equinox of date.
 *
 * @param {Number} T - number of Julian centuries since J2000. See base.J2000Century.
 * @returns {Object}
 *   {Number} lon = true geometric longitude, ☉, in radians
 *   {Number} ano = true anomaly in radians
 */ parcelHelpers.export(exports, "trueLongitude", function() {
    return trueLongitude;
});
/**
 * meanAnomaly returns the mean anomaly of Earth at the given T.
 *
 * @param {Number} T - number of Julian centuries since J2000. See base.J2000Century.
 * @returns {Number} Result is in radians and is not normalized to the range 0..2π.
 */ parcelHelpers.export(exports, "meanAnomaly", function() {
    return meanAnomaly;
});
/**
 * eccentricity returns eccentricity of the Earth's orbit around the sun.
 *
 * @param {Number} T - number of Julian centuries since J2000. See base.J2000Century.
 * @returns {Number} eccentricity of the Earth's orbit around the sun.
 */ parcelHelpers.export(exports, "eccentricity", function() {
    return eccentricity;
});
/**
 * Radius returns the Sun-Earth distance in AU.
 *
 * @param {Number} T - number of Julian centuries since J2000. See base.J2000Century.
 * @returns {Number} Sun-Earth distance in AU
 */ parcelHelpers.export(exports, "radius", function() {
    return radius;
});
/**
 * ApparentLongitude returns apparent longitude of the Sun referenced to the true equinox of date.
 * Result includes correction for nutation and aberration.  Unit is radians.
 *
 * @param {Number} T - number of Julian centuries since J2000. See base.J2000Century.
 * @returns {Number} apparent longitude of the Sun referenced to the true equinox of date.
 */ parcelHelpers.export(exports, "apparentLongitude", function() {
    return apparentLongitude;
});
/**
 * true2000 returns true geometric longitude and anomaly of the sun referenced to equinox J2000.
 * Results are accurate to .01 degree for years 1900 to 2100.
 *
 * @param {Number} T - number of Julian centuries since J2000. See base.J2000Century.
 * @returns {Object}
 *   {Number} lon - true geometric longitude, ☉, in radians
 *   {Number} ano - true anomaly in radians
 */ parcelHelpers.export(exports, "true2000", function() {
    return true2000;
});
/**
 * trueEquatorial returns the true geometric position of the Sun as equatorial coordinates.
 *
 * @param {Number} jde - Julian ephemeris day
 * @returns {Coord}
 *   {Number} ra - right ascension in radians
 *   {Number} dec - declination in radians
 */ parcelHelpers.export(exports, "trueEquatorial", function() {
    return trueEquatorial;
});
/**
 * apparentEquatorial returns the apparent position of the Sun as equatorial coordinates.
 *
 * @param {Number} jde - Julian ephemeris day
 * @returns {Coord}
 *   {Number} ra - right ascension in radians
 *   {Number} dec - declination in radians
 */ parcelHelpers.export(exports, "apparentEquatorial", function() {
    return apparentEquatorial;
});
/**
 * trueVSOP87 returns the true geometric position of the sun as ecliptic coordinates.
 *
 * Result computed by full VSOP87 theory.  Result is at equator and equinox
 * of date in the FK5 frame.  It does not include nutation or aberration.
 *
 * @param {Planet} planet
 * @param {Number} jde - Julian ephemeris day
 * @returns {Object}
 *   {Number} lon - ecliptic longitude in radians
 *   {Number} lat - ecliptic latitude in radians
 *   {Number} range - range in AU
 */ parcelHelpers.export(exports, "trueVSOP87", function() {
    return trueVSOP87;
});
/**
 * apparentVSOP87 returns the apparent position of the sun as ecliptic coordinates.
 *
 * Result computed by VSOP87, at equator and equinox of date in the FK5 frame,
 * and includes effects of nutation and aberration.
 *
 * @param {Planet} planet
 * @param {Number} jde - Julian ephemeris day
 * @returns {Coord}
 *   {Number} lon - ecliptic longitude in radians
 *   {Number} lat - ecliptic latitude in radians
 *   {Number} range - range in AU
 */ parcelHelpers.export(exports, "apparentVSOP87", function() {
    return apparentVSOP87;
});
/**
 * apparentEquatorialVSOP87 returns the apparent position of the sun as equatorial coordinates.
 *
 * Result computed by VSOP87, at equator and equinox of date in the FK5 frame,
 * and includes effects of nutation and aberration.
 *
 * @param {Planet} planet
 * @param {Number} jde - Julian ephemeris day
 * @returns {Coord}
 *   {Number} ra - right ascension in radians
 *   {Number} dec - declination in radians
 *   {Number} range - range in AU
 */ parcelHelpers.export(exports, "apparentEquatorialVSOP87", function() {
    return apparentEquatorialVSOP87;
});
/**
 * Low precision formula.  The high precision formula is not implemented
 * because the low precision formula already gives position results to the
 * accuracy given on p. 165.  The high precision formula represents lots
 * of typing with associated chance of typos, and no way to test the result.
 * @param {Number} range
 * @returns {Number} aberation
 */ parcelHelpers.export(exports, "aberration", function() {
    return aberration;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var _planetpositionJs = require("./planetposition.js"); // eslint-disable-line no-unused-vars
var _coordJs = require("./coord.js");
var _coordJsDefault = parcelHelpers.interopDefault(_coordJs);
var _nutationJs = require("./nutation.js");
var _nutationJsDefault = parcelHelpers.interopDefault(_nutationJs);
function trueLongitude(T) {
    // (25.2) p. 163
    var L0 = (0, _baseJsDefault.default).horner(T, 280.46646, 36000.76983, 0.0003032) * Math.PI / 180;
    var m = meanAnomaly(T);
    var C = ((0, _baseJsDefault.default).horner(T, 1.914602, -0.004817, -0.000014) * Math.sin(m) + (0.019993 - 0.000101 * T) * Math.sin(2 * m) + 0.000289 * Math.sin(3 * m)) * Math.PI / 180;
    var lon = (0, _baseJsDefault.default).pmod(L0 + C, 2 * Math.PI);
    var ano = (0, _baseJsDefault.default).pmod(m + C, 2 * Math.PI);
    return {
        lon: lon,
        ano: ano
    };
}
function meanAnomaly(T) {
    // (25.3) p. 163
    return (0, _baseJsDefault.default).horner(T, 357.52911, 35999.05029, -0.0001537) * Math.PI / 180;
}
function eccentricity(T) {
    // (25.4) p. 163
    return (0, _baseJsDefault.default).horner(T, 0.016708634, -0.000042037, -0.0000001267);
}
function radius(T) {
    var _trueLongitude // eslint-disable-line
     = trueLongitude(T), lon = _trueLongitude.lon, ano = _trueLongitude.ano;
    var e = eccentricity(T);
    // (25.5) p. 164
    return 1.000001018 * (1 - e * e) / (1 + e * Math.cos(ano));
}
function apparentLongitude(T) {
    var \u03A9 = node(T);
    var _trueLongitude // eslint-disable-line
     = trueLongitude(T), lon = _trueLongitude.lon, ano = _trueLongitude.ano;
    return lon - 0.00569 * Math.PI / 180 - 0.00478 * Math.PI / 180 * Math.sin(\u03A9);
}
/**
 * @private
 */ function node(T) {
    return 125.04 * Math.PI / 180 - 1934.136 * Math.PI / 180 * T;
}
function true2000(T) {
    var _trueLongitude = trueLongitude(T), lon = _trueLongitude.lon, ano = _trueLongitude.ano;
    lon -= 0.01397 * Math.PI / 180 * T * 100;
    return {
        lon: lon,
        ano: ano
    };
}
function trueEquatorial(jde) {
    var _trueLongitude // eslint-disable-line
     = trueLongitude((0, _baseJsDefault.default).J2000Century(jde)), lon = _trueLongitude.lon, ano = _trueLongitude.ano;
    var \u03B5 = (0, _nutationJsDefault.default).meanObliquity(jde);
    var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(lon), 2), ss = _base_sincos[0], cs = _base_sincos[1];
    var _base_sincos1 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03B5), 2), s\u03B5 = _base_sincos1[0], c\u03B5 = _base_sincos1[1];
    // (25.6, 25.7) p. 165
    var ra = Math.atan2(c\u03B5 * ss, cs);
    var dec = s\u03B5 * ss;
    return new (0, _baseJsDefault.default).Coord(ra, dec);
}
function apparentEquatorial(jde) {
    var T = (0, _baseJsDefault.default).J2000Century(jde);
    var \u03BB = apparentLongitude(T);
    var \u03B5 = (0, _nutationJsDefault.default).meanObliquity(jde);
    var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03BB), 2), s\u03BB = _base_sincos[0], c\u03BB = _base_sincos[1];
    // (25.8) p. 165
    var _base_sincos1 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03B5 + 0.00256 * Math.PI / 180 * Math.cos(node(T))), 2), s\u03B5 = _base_sincos1[0], c\u03B5 = _base_sincos1[1];
    var ra = Math.atan2(c\u03B5 * s\u03BB, c\u03BB);
    var dec = Math.asin(s\u03B5 * s\u03BB);
    return new (0, _baseJsDefault.default).Coord(ra, dec);
}
function trueVSOP87(planet, jde) {
    var _planet_position = planet.position(jde), lon = _planet_position.lon, lat = _planet_position.lat, range = _planet_position.range;
    var s = lon + Math.PI;
    // FK5 correction.
    var \u03BBp = (0, _baseJsDefault.default).horner((0, _baseJsDefault.default).J2000Century(jde), s, -1.397 * Math.PI / 180, -0.00031 * Math.PI / 180);
    var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03BBp), 2), s\u03BBp = _base_sincos[0], c\u03BBp = _base_sincos[1];
    var \u0394\u03B2 = 0.03916 / 3600 * Math.PI / 180 * (c\u03BBp - s\u03BBp);
    // (25.9) p. 166
    lon = (0, _baseJsDefault.default).pmod(s - 0.09033 / 3600 * Math.PI / 180, 2 * Math.PI);
    lat = \u0394\u03B2 - lat;
    return new (0, _baseJsDefault.default).Coord(lon, lat, range);
}
function apparentVSOP87(planet, jde) {
    // note: see duplicated code in ApparentEquatorialVSOP87.
    var _trueVSOP87 = trueVSOP87(planet, jde), lon = _trueVSOP87.lon, lat = _trueVSOP87.lat, range = _trueVSOP87.range;
    var \u0394\u03C8 = (0, _nutationJsDefault.default).nutation(jde)[0];
    var a = aberration(range);
    lon = lon + \u0394\u03C8 + a;
    return new (0, _baseJsDefault.default).Coord(lon, lat, range);
}
function apparentEquatorialVSOP87(planet, jde) {
    // note: duplicate code from ApparentVSOP87 so we can keep Δε.
    // see also duplicate code in time.E().
    var _trueVSOP87 = trueVSOP87(planet, jde), lon = _trueVSOP87.lon, lat = _trueVSOP87.lat, range = _trueVSOP87.range;
    var _nutation_nutation = (0, _slicedToArray._)((0, _nutationJsDefault.default).nutation(jde), 2), \u0394\u03C8 = _nutation_nutation[0], \u0394\u03B5 = _nutation_nutation[1];
    var a = aberration(range);
    var \u03BB = lon + \u0394\u03C8 + a;
    var \u03B5 = (0, _nutationJsDefault.default).meanObliquity(jde) + \u0394\u03B5;
    var _toEquatorial = new (0, _coordJsDefault.default).Ecliptic(\u03BB, lat).toEquatorial(\u03B5), ra = _toEquatorial.ra, dec = _toEquatorial.dec;
    return new (0, _baseJs.Coord)(ra, dec, range);
}
function aberration(range) {
    // (25.10) p. 167
    return -20.4898 / 3600 * Math.PI / 180 / range;
}
exports.default = {
    trueLongitude: trueLongitude,
    true: trueLongitude,
    meanAnomaly: meanAnomaly,
    eccentricity: eccentricity,
    radius: radius,
    apparentLongitude: apparentLongitude,
    true2000: true2000,
    trueEquatorial: trueEquatorial,
    apparentEquatorial: apparentEquatorial,
    trueVSOP87: trueVSOP87,
    apparentVSOP87: apparentVSOP87,
    apparentEquatorialVSOP87: apparentEquatorialVSOP87,
    aberration: aberration
};

},{"@swc/helpers/_/_sliced_to_array":"ha6sq","./base.js":"lEDxD","./planetposition.js":"8l87z","./coord.js":"kTRDS","./nutation.js":"jqV8z","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8l87z":[function(require,module,exports,__globalThis) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module planetposition
 */ /**
 * Planetposition: Chapter 32, Positions of the Planets.
 *
 * Incomplete:
 *
 * 1. The package does not implement algorithms that use appendix III,
 * but instead implements a full VSOP87 solution.  I do not have a copy
 * of the supplimentary disk with appendix III in machine readable form
 * and as the appendix is rather large, retyping it by hand is problematic.
 * The full VSOP87 data set on the other hand is freely downloadable from
 * the internet, so I implement here code that can use that data directly.
 *
 * 2. The formula for accuracy of results is not implemented.  It is
 * not needed for full VSOP87 solutions.
 *
 * 3. Polynomial expressions are not implemented.  Again, implementation
 * would involve typing rather large tables of numbers with associated
 * risk of typographical errors.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Planet", function() {
    return Planet;
});
/**
 * ToFK5 converts ecliptic longitude and latitude from dynamical frame to FK5.
 *
 * @param {Number} lon - ecliptic longitude in radians
 * @param {Number} lat - ecliptic latitude in radians
 * @param {Number} jde - Julian ephemeris day
 * @return {Coord}
 *    {Number} lon - FK5 longitude
 *    {Number} lat - FK5 latitude
 */ parcelHelpers.export(exports, "toFK5", function() {
    return toFK5;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _baseJs = require("./base.js"); // eslint-disable-line no-unused-vars
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var _sexagesimalJs = require("./sexagesimal.js");
var _sexagesimalJsDefault = parcelHelpers.interopDefault(_sexagesimalJs);
var _coordJs = require("./coord.js");
var _coordJsDefault = parcelHelpers.interopDefault(_coordJs);
var _precessJs = require("./precess.js");
var _precessJsDefault = parcelHelpers.interopDefault(_precessJs);
function sum(t, series) {
    var _base;
    var coeffs = [];
    Object.keys(series).forEach(function(x) {
        coeffs[x] = 0;
        var y = series[x].length - 1;
        for(y; y >= 0; y--){
            var term = {
                a: series[x][y][0],
                b: series[x][y][1],
                c: series[x][y][2]
            };
            coeffs[x] += term.a * Math.cos(term.b + term.c * t);
        }
    });
    var res = (_base = (0, _baseJsDefault.default)).horner.apply(_base, [
        t
    ].concat((0, _toConsumableArray._)(coeffs)));
    return res;
}
var Planet = /*#__PURE__*/ function() {
    "use strict";
    function Planet(planet) {
        (0, _classCallCheck._)(this, Planet);
        if (typeof planet !== 'object') throw new TypeError('need planet vsop87 data');
        this.name = planet.name;
        this.type = planet.type || 'B';
        this.series = planet;
    }
    (0, _createClass._)(Planet, [
        {
            /**
   * Position2000 returns ecliptic position of planets by full VSOP87 theory.
   *
   * @param {Number} jde - the date for which positions are desired.
   * @returns {Coord} Results are for the dynamical equinox and ecliptic J2000.
   *  {Number} lon - heliocentric longitude in radians.
   *  {Number} lat - heliocentric latitude in radians.
   *  {Number} range - heliocentric range in AU.
   */ key: "position2000",
            value: function position2000(jde) {
                var T = (0, _baseJsDefault.default).J2000Century(jde);
                var \u03C4 = T * 0.1;
                var lon = (0, _baseJsDefault.default).pmod(sum(\u03C4, this.series.L), 2 * Math.PI);
                var lat = sum(\u03C4, this.series.B);
                var range = sum(\u03C4, this.series.R);
                switch(this.type){
                    case 'B':
                        return new (0, _baseJsDefault.default).Coord(lon, lat, range);
                    case 'D':
                        {
                            var eclFrom = new (0, _coordJsDefault.default).Ecliptic(lon, lat);
                            var epochFrom = (0, _baseJsDefault.default).JDEToJulianYear(jde);
                            var epochTo = 2000.0;
                            var eclTo = (0, _precessJsDefault.default).eclipticPosition(eclFrom, epochFrom, epochTo);
                            return new (0, _baseJsDefault.default).Coord(eclTo.lon, eclTo.lat, range);
                        }
                }
            }
        },
        {
            /**
   * Position returns ecliptic position of planets at equinox and ecliptic of date.
   *
   * @param {Number} jde - the date for which positions are desired.
   * @returns {Coord} Results are positions consistent with those from Meeus's
   * Apendix III, that is, at equinox and ecliptic of date.
   *  {Number} lon - heliocentric longitude in radians.
   *  {Number} lat - heliocentric latitude in radians.
   *  {Number} range - heliocentric range in AU.
   */ key: "position",
            value: function position(jde) {
                var T = (0, _baseJsDefault.default).J2000Century(jde);
                var \u03C4 = T * 0.1;
                var lon = (0, _baseJsDefault.default).pmod(sum(\u03C4, this.series.L), 2 * Math.PI);
                var lat = sum(\u03C4, this.series.B);
                var range = sum(\u03C4, this.series.R);
                switch(this.type){
                    case 'B':
                        {
                            var eclFrom = new (0, _coordJsDefault.default).Ecliptic(lon, lat);
                            var epochFrom = 2000.0;
                            var epochTo = (0, _baseJsDefault.default).JDEToJulianYear(jde);
                            var eclTo = (0, _precessJsDefault.default).eclipticPosition(eclFrom, epochFrom, epochTo);
                            return new (0, _baseJsDefault.default).Coord(eclTo.lon, eclTo.lat, range);
                        }
                    case 'D':
                        return new (0, _baseJsDefault.default).Coord(lon, lat, range);
                }
            }
        }
    ]);
    return Planet;
}();
function toFK5(lon, lat, jde) {
    // formula 32.3, p. 219.
    var T = (0, _baseJsDefault.default).J2000Century(jde);
    // const Lp = lon - 1.397 * Math.PI / 180 * T - 0.00031 * Math.PI / 180 * T * T
    var Lp = lon - (0, _sexagesimalJsDefault.default).angleFromDeg((1.397 + 0.00031 * T) * T);
    var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(Lp), 2), sLp = _base_sincos[0], cLp = _base_sincos[1];
    // (32.3) p. 219
    var L5 = lon + (0, _sexagesimalJsDefault.default).angleFromSec(-0.09033 + 0.03916 * (cLp + sLp) * Math.tan(lat));
    var B5 = lat + (0, _sexagesimalJsDefault.default).angleFromSec(0.03916 * (cLp - sLp));
    return new (0, _baseJsDefault.default).Coord(L5, B5);
}
exports.default = {
    Planet: Planet,
    toFK5: toFK5
};

},{"@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","@swc/helpers/_/_sliced_to_array":"ha6sq","@swc/helpers/_/_to_consumable_array":"eqNDD","./base.js":"lEDxD","./sexagesimal.js":"aLUGo","./coord.js":"kTRDS","./precess.js":"iqQIL","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"hPOFS":[function(require,module,exports,__globalThis) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module apsis
 */ /**
 * Apsis: Chapter 50, Perigee and apogee of the Moon
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EARTH_RADIUS", function() {
    return EARTH_RADIUS;
});
parcelHelpers.export(exports, "MOON_RADIUS", function() {
    return MOON_RADIUS;
});
/**
 * meanPerigee returns the jde of the mean perigee of the Moon nearest the given date.
 *
 * @param {Number} year - is a decimal year specifying a date.
 * @return {Number} jde - Julian ephemeris day
 */ parcelHelpers.export(exports, "meanPerigee", function() {
    return meanPerigee;
});
/**
 * perigee returns the jde of perigee of the Moon nearest the given date.
 *
 * @param {Number} year - is a decimal year specifying a date.
 * @return {Number} jde - Julian ephemeris day
 */ parcelHelpers.export(exports, "perigee", function() {
    return perigee;
});
/**
 * meanApogee returns the jde of the mean apogee of the Moon nearest the given date.
 *
 * @param {Number} year - is a decimal year specifying a date.
 * @return {Number} jde - Julian ephemeris day
 */ parcelHelpers.export(exports, "meanApogee", function() {
    return meanApogee;
});
/**
 * apogee returns the jde of apogee of the Moon nearest the given date.
 *
 * @param {Number} year - is a decimal year specifying a date.
 * @return {Number} jde - Julian ephemeris day
 */ parcelHelpers.export(exports, "apogee", function() {
    return apogee;
});
/**
 * apogeeParallax returns equatorial horizontal parallax of the Moon at the Apogee nearest the given date.
 *
 * @param {Number} year - is a decimal year specifying a date.
 * @return {Number} equatorial horizontal parallax in radians
 */ parcelHelpers.export(exports, "apogeeParallax", function() {
    return apogeeParallax;
});
/**
 * perigeeParallax returns equatorial horizontal parallax of the Moon at the Apogee nearest the given date.
 *
 * @param {Number} year - is a decimal year specifying a date.
 * @return {Number} equatorial horizontal parallax in radians
 */ parcelHelpers.export(exports, "perigeeParallax", function() {
    return perigeeParallax;
});
/**
 * Calculate the distance earth - moon (center to center) using the parallax angle in radians
 *
 * @param {Number} parallax - parallax angle in radians
 * @return {Number} distance in `km`
 */ parcelHelpers.export(exports, "distance", function() {
    return distance;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var sin = Math.sin, cos = Math.cos;
/**
 * conversion factor from k to T, given in (50.3) p. 356
 */ var ck = 1 / 1325.55;
var D2R = Math.PI / 180;
var EARTH_RADIUS = 6378.137 // km
;
var MOON_RADIUS = 1738.1 // km
;
/**
 * mean time of perigee or apogee
 * (50.1) p. 355
 */ var mean = function mean(T) {
    return (0, _baseJsDefault.default).horner(T, 2451534.6698, 27.55454989 / ck, -0.0006691, -0.000001098, 0.0000000052);
};
/**
 * snap returns k at half h nearest year y.
 */ var snap = function snap(y, h) {
    var k = (y - 1999.97) * 13.2555 // (50.2) p. 355
    ;
    return Math.floor(k - h + 0.5) + h;
};
function meanPerigee(year) {
    return mean(snap(year, 0) * ck);
}
function perigee(year) {
    var l = new La(year, 0);
    return mean(l.T) + l.perigeeCorr();
}
function meanApogee(year) {
    return mean(snap(year, 0.5) * ck);
}
function apogee(year) {
    var l = new La(year, 0.5);
    return mean(l.T) + l.apogeeCorr();
}
function apogeeParallax(year) {
    return new La(year, 0.5).apogeeParallax();
}
function perigeeParallax(year) {
    return new La(year, 0).perigeeParallax();
}
function distance(parallax) {
    return EARTH_RADIUS / sin(parallax);
}
var La = /*#__PURE__*/ function() {
    "use strict";
    function La(y, h) {
        (0, _classCallCheck._)(this, La);
        this.k = snap(y, h);
        this.T = this.k * ck // (50.3) p. 350
        ;
        this.D = (0, _baseJsDefault.default).horner(this.T, 171.9179 * D2R, 335.9106046 * D2R / ck, -0.0100383 * D2R, -0.00001156 * D2R, 0.000000055 * D2R);
        this.M = (0, _baseJsDefault.default).horner(this.T, 347.3477 * D2R, 27.1577721 * D2R / ck, -0.000813 * D2R, -0.000001 * D2R);
        this.F = (0, _baseJsDefault.default).horner(this.T, 316.6109 * D2R, 364.5287911 * D2R / ck, -0.0125053 * D2R, -0.0000148 * D2R);
        return this;
    }
    (0, _createClass._)(La, [
        {
            /**
   * perigee correction
   */ key: "perigeeCorr",
            value: function perigeeCorr() {
                var l = this;
                return -1.6769 * sin(2 * l.D) + 0.4589 * sin(4 * l.D) + -0.1856 * sin(6 * l.D) + 0.0883 * sin(8 * l.D) + (-0.0773 + 0.00019 * l.T) * sin(2 * l.D - l.M) + (0.0502 - 0.00013 * l.T) * sin(l.M) + -0.046 * sin(10 * l.D) + (0.0422 - 0.00011 * l.T) * sin(4 * l.D - l.M) + -0.0256 * sin(6 * l.D - l.M) + 0.0253 * sin(12 * l.D) + 0.0237 * sin(l.D) + 0.0162 * sin(8 * l.D - l.M) + -0.0145 * sin(14 * l.D) + 0.0129 * sin(2 * l.F) + -0.0112 * sin(3 * l.D) + -0.0104 * sin(10 * l.D - l.M) + 0.0086 * sin(16 * l.D) + 0.0069 * sin(12 * l.D - l.M) + 0.0066 * sin(5 * l.D) + -0.0053 * sin(2 * (l.D + l.F)) + -0.0052 * sin(18 * l.D) + -0.0046 * sin(14 * l.D - l.M) + -0.0041 * sin(7 * l.D) + 0.004 * sin(2 * l.D + l.M) + 0.0032 * sin(20 * l.D) + -0.0032 * sin(l.D + l.M) + 0.0031 * sin(16 * l.D - l.M) + -0.0029 * sin(4 * l.D + l.M) + 0.0027 * sin(9 * l.D) + 0.0027 * sin(4 * l.D + 2 * l.F) + -0.0027 * sin(2 * (l.D - l.M)) + 0.0024 * sin(4 * l.D - 2 * l.M) + -0.0021 * sin(6 * l.D - 2 * l.M) + -0.0021 * sin(22 * l.D) + -0.0021 * sin(18 * l.D - l.M) + 0.0019 * sin(6 * l.D + l.M) + -0.0018 * sin(11 * l.D) + -0.0014 * sin(8 * l.D + l.M) + -0.0014 * sin(4 * l.D - 2 * l.F) + -0.0014 * sin(6 * l.D + 2 * l.F) + 0.0014 * sin(3 * l.D + l.M) + -0.0014 * sin(5 * l.D + l.M) + 0.0013 * sin(13 * l.D) + 0.0013 * sin(20 * l.D - l.M) + 0.0011 * sin(3 * l.D + 2 * l.M) + -0.0011 * sin(2 * (2 * l.D + l.F - l.M)) + -0.001 * sin(l.D + 2 * l.M) + -0.0009 * sin(22 * l.D - l.M) + -0.0008 * sin(4 * l.F) + 0.0008 * sin(6 * l.D - 2 * l.F) + 0.0008 * sin(2 * (l.D - l.F) + l.M) + 0.0007 * sin(2 * l.M) + 0.0007 * sin(2 * l.F - l.M) + 0.0007 * sin(2 * l.D + 4 * l.F) + -0.0006 * sin(2 * (l.F - l.M)) + -0.0006 * sin(2 * (l.D - l.F + l.M)) + 0.0006 * sin(24 * l.D) + 0.0005 * sin(4 * (l.D - l.F)) + 0.0005 * sin(2 * (l.D + l.M)) + -0.0004 * sin(l.D - l.M);
            }
        },
        {
            /**
   * apogee correction
   */ key: "apogeeCorr",
            value: function apogeeCorr() {
                var l = this;
                return 0.4392 * sin(2 * l.D) + 0.0684 * sin(4 * l.D) + (0.0456 - 0.00011 * l.T) * sin(l.M) + (0.0426 - 0.00011 * l.T) * sin(2 * l.D - l.M) + 0.0212 * sin(2 * l.F) + -0.0189 * sin(l.D) + 0.0144 * sin(6 * l.D) + 0.0113 * sin(4 * l.D - l.M) + 0.0047 * sin(2 * (l.D + l.F)) + 0.0036 * sin(l.D + l.M) + 0.0035 * sin(8 * l.D) + 0.0034 * sin(6 * l.D - l.M) + -0.0034 * sin(2 * (l.D - l.F)) + 0.0022 * sin(2 * (l.D - l.M)) + -0.0017 * sin(3 * l.D) + 0.0013 * sin(4 * l.D + 2 * l.F) + 0.0011 * sin(8 * l.D - l.M) + 0.001 * sin(4 * l.D - 2 * l.M) + 0.0009 * sin(10 * l.D) + 0.0007 * sin(3 * l.D + l.M) + 0.0006 * sin(2 * l.M) + 0.0005 * sin(2 * l.D + l.M) + 0.0005 * sin(2 * (l.D + l.M)) + 0.0004 * sin(6 * l.D + 2 * l.F) + 0.0004 * sin(6 * l.D - 2 * l.M) + 0.0004 * sin(10 * l.D - l.M) + -0.0004 * sin(5 * l.D) + -0.0004 * sin(4 * l.D - 2 * l.F) + 0.0003 * sin(2 * l.F + l.M) + 0.0003 * sin(12 * l.D) + 0.0003 * sin(2 * l.D + 2 * l.F - l.M) + -0.0003 * sin(l.D - l.M);
            }
        },
        {
            /**
   * apogee parallax
   */ key: "apogeeParallax",
            value: function apogeeParallax() {
                var s = Math.PI / 180 / 3600;
                var l = this;
                return 3245.251 * s + -9.147 * s * cos(2 * l.D) + -0.841 * s * cos(l.D) + 0.697 * s * cos(2 * l.F) + (-0.656 * s + 0.0016 * s * l.T) * cos(l.M) + 0.355 * s * cos(4 * l.D) + 0.159 * s * cos(2 * l.D - l.M) + 0.127 * s * cos(l.D + l.M) + 0.065 * s * cos(4 * l.D - l.M) + 0.052 * s * cos(6 * l.D) + 0.043 * s * cos(2 * l.D + l.M) + 0.031 * s * cos(2 * (l.D + l.F)) + -0.023 * s * cos(2 * (l.D - l.F)) + 0.022 * s * cos(2 * (l.D - l.M)) + 0.019 * s * cos(2 * (l.D + l.M)) + -0.016 * s * cos(2 * l.M) + 0.014 * s * cos(6 * l.D - l.M) + 0.01 * s * cos(8 * l.D);
            }
        },
        {
            /**
   * perigee parallax
   */ key: "perigeeParallax",
            value: function perigeeParallax() {
                var s = Math.PI / 180 / 3600;
                var l = this;
                return 3629.215 * s + 63.224 * s * cos(2 * l.D) + -6.99 * s * cos(4 * l.D) + (2.834 * s - 0.0071 * l.T * s) * cos(2 * l.D - l.M) + 1.927 * s * cos(6 * l.D) + -1.263 * s * cos(l.D) + -0.702 * s * cos(8 * l.D) + (0.696 * s - 0.0017 * l.T * s) * cos(l.M) + -0.69 * s * cos(2 * l.F) + (-0.629 * s + 0.0016 * l.T * s) * cos(4 * l.D - l.M) + -0.392 * s * cos(2 * (l.D - l.F)) + 0.297 * s * cos(10 * l.D) + 0.260 * s * cos(6 * l.D - l.M) + 0.201 * s * cos(3 * l.D) + -0.161 * s * cos(2 * l.D + l.M) + 0.157 * s * cos(l.D + l.M) + -0.138 * s * cos(12 * l.D) + -0.127 * s * cos(8 * l.D - l.M) + 0.104 * s * cos(2 * (l.D + l.F)) + 0.104 * s * cos(2 * (l.D - l.M)) + -0.079 * s * cos(5 * l.D) + 0.068 * s * cos(14 * l.D) + 0.067 * s * cos(10 * l.D - l.M) + 0.054 * s * cos(4 * l.D + l.M) + -0.038 * s * cos(12 * l.D - l.M) + -0.038 * s * cos(4 * l.D - 2 * l.M) + 0.037 * s * cos(7 * l.D) + -0.037 * s * cos(4 * l.D + 2 * l.F) + -0.035 * s * cos(16 * l.D) + -0.03 * s * cos(3 * l.D + l.M) + 0.029 * s * cos(l.D - l.M) + -0.025 * s * cos(6 * l.D + l.M) + 0.023 * s * cos(2 * l.M) + 0.023 * s * cos(14 * l.D - l.M) + -0.023 * s * cos(2 * (l.D + l.M)) + 0.022 * s * cos(6 * l.D - 2 * l.M) + -0.021 * s * cos(2 * l.D - 2 * l.F - l.M) + -0.02 * s * cos(9 * l.D) + 0.019 * s * cos(18 * l.D) + 0.017 * s * cos(6 * l.D + 2 * l.F) + 0.014 * s * cos(2 * l.F - l.M) + -0.014 * s * cos(16 * l.D - l.M) + 0.013 * s * cos(4 * l.D - 2 * l.F) + 0.012 * s * cos(8 * l.D + l.M) + 0.011 * s * cos(11 * l.D) + 0.010 * s * cos(5 * l.D + l.M) + -0.01 * s * cos(20 * l.D);
            }
        }
    ]);
    return La;
}();
exports.default = {
    EARTH_RADIUS: EARTH_RADIUS,
    MOON_RADIUS: MOON_RADIUS,
    meanPerigee: meanPerigee,
    perigee: perigee,
    meanApogee: meanApogee,
    apogee: apogee,
    apogeeParallax: apogeeParallax,
    perigeeParallax: perigeeParallax,
    distance: distance
};

},{"@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","./base.js":"lEDxD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8sMWx":[function(require,module,exports,__globalThis) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module binary
 */ /**
 * Binary: Chapter 57, Binary Stars
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * computes mean anomaly for the given date.
 *
 * @param {Number} year - is a decimal year specifying the date
 * @param {Number} T - is time of periastron, as a decimal year
 * @param {Number} P - is period of revolution in mean solar years
 * @returns {Number} mean anomaly in radians.
 */ parcelHelpers.export(exports, "meanAnomaly", function() {
    return meanAnomaly;
});
/**
 * Position computes apparent position angle and angular distance of
 * components of a binary star.
 *
 * @param {Number} a - is apparent semimajor axis in arc seconds
 * @param {Number} e - is eccentricity of the true orbit
 * @param {Number} i - is inclination relative to the line of sight
 * @param {Number} Ω - is position angle of the ascending node
 * @param {Number} ω - is longitude of periastron
 * @param {Number} E - is eccentric anomaly, computed for example with package kepler
 *  and the mean anomaly as returned by function M in this package.
 * @returns {Number[]} [θ, ρ]
 *  {Number} θ -is the apparent position angle in radians,
 *  {Number} ρ is the angular distance in arc seconds.
 */ parcelHelpers.export(exports, "position", function() {
    return position;
});
/**
 * ApparentEccentricity returns apparent eccenticity of a binary star
 * given true orbital elements.
 *
 * @param {Number} e - is eccentricity of the true orbit
 * @param {Number} i - is inclination relative to the line of sight
 * @param {Number} ω - is longitude of periastron
 * @returns {Number} apparent eccenticity of a binary star
 */ parcelHelpers.export(exports, "apparentEccentricity", function() {
    return apparentEccentricity;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var atan = Math.atan, atan2 = Math.atan2, cos = Math.cos, sqrt = Math.sqrt, tan = Math.tan;
function meanAnomaly(year, T, P) {
    var n = 2 * Math.PI / P;
    return (0, _baseJsDefault.default).pmod(n * (year - T), 2 * Math.PI);
}
function position(a, e, i, \u03A9, \u03C9, E) {
    var r = a * (1 - e * cos(E));
    var \u03BD = 2 * atan(sqrt((1 + e) / (1 - e)) * tan(E / 2));
    var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03BD + \u03C9), 2), sin\u03BD\u03C9 = _base_sincos[0], cos\u03BD\u03C9 = _base_sincos[1];
    var cosi = cos(i);
    var num = sin\u03BD\u03C9 * cosi;
    var \u03B8 = atan2(num, cos\u03BD\u03C9) + \u03A9;
    if (\u03B8 < 0) \u03B8 += 2 * Math.PI;
    var \u03C1 = r * sqrt(num * num + cos\u03BD\u03C9 * cos\u03BD\u03C9);
    return [
        \u03B8,
        \u03C1
    ];
}
function apparentEccentricity(e, i, \u03C9) {
    var cosi = cos(i);
    var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03C9), 2), sin\u03C9 = _base_sincos[0], cos\u03C9 = _base_sincos[1];
    var A = (1 - e * e * cos\u03C9 * cos\u03C9) * cosi * cosi;
    var B = e * e * sin\u03C9 * cos\u03C9 * cosi;
    var C = 1 - e * e * sin\u03C9 * sin\u03C9;
    var d = A - C;
    var sqrtD = sqrt(d * d + 4 * B * B);
    return sqrt(2 * sqrtD / (A + C + sqrtD));
}
exports.default = {
    meanAnomaly: meanAnomaly,
    position: position,
    apparentEccentricity: apparentEccentricity
};

},{"@swc/helpers/_/_sliced_to_array":"ha6sq","./base.js":"lEDxD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"22rsu":[function(require,module,exports,__globalThis) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module conjunction
 */ /**
 * Conjunction: Chapter 18: Planetary Conjunctions.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Planetary computes a conjunction between two moving objects, such as planets.
 *
 * Conjunction is found with interpolation against length 5 ephemerides.
 *
 * t1, t5 are times of first and last rows of ephemerides.  The scale is
 * arbitrary.
 *
 * cs1 is the ephemeris of the first object. The columns may be celestial
 * coordinates in right ascension and declination or ecliptic coordinates in
 * longitude and latitude.
 *
 * cs2 is the ephemeris of the second object, in the same frame as the first.
 *
 * Return value t is time of conjunction in the scale of t1, t5.
 *
 * @param {Number} t1 - julian ephemeris day of first row
 * @param {Number} t5 - julian ephemeris day of fifth row
 * @param {Coord[]} cs1 - ephemeris of first moving object
 * @param {Coord[]} cs2 - ephemeris of decond moving object
 * @return {Array}
 *    {Number} t - time of conjunction in JDE
 *    {Number} Δd - is the amount that object 2 was "above" object 1 at the time of conjunction.
 */ parcelHelpers.export(exports, "planetary", function() {
    return planetary;
});
/**
 * Stellar computes a conjunction between a moving and non-moving object.
 *
 * Arguments and return values same as with Planetary, except the non-moving
 * object is c1.  The ephemeris of the moving object is cs2.
 *
 * @param {Number} t1 - julian ephemeris day of first row
 * @param {Number} t5 - julian ephemeris day of fifth row
 * @param {Coord} c1 - ephemeris of non-moving object
 * @param {Coord[]} cs2 - ephemeris of moving object
 * @return {Array}
 *    {Number} t - time of conjunction in JDE
 *    {Number} Δd - is the amount that object 2 was "above" object 1 at the time of conjunction.
 */ parcelHelpers.export(exports, "stellar", function() {
    return stellar;
});
var _baseJs = require("./base.js"); // eslint-disable-line no-unused-vars
var _interpolationJs = require("./interpolation.js");
var _interpolationJsDefault = parcelHelpers.interopDefault(_interpolationJs);
function planetary(t1, t5, cs1, cs2) {
    if (cs1.length !== 5 || cs2.length !== 5) throw new Error('Five rows required in ephemerides');
    var dr = new Array(5);
    var dd = new Array(5);
    cs1.forEach(function(r, i) {
        dr[i] = cs2[i].ra - cs1[i].ra;
        dd[i] = cs2[i].dec - cs1[i].dec;
    });
    return conj(t1, t5, dr, dd);
}
function stellar(t1, t5, c1, cs2) {
    if (cs2.length !== 5) throw new Error('Five rows required in ephemerides');
    var dr = new Array(5);
    var dd = new Array(5);
    cs2.forEach(function(r, i) {
        dr[i] = cs2[i].ra - c1.ra;
        dd[i] = cs2[i].dec - c1.dec;
    });
    return conj(t1, t5, dr, dd);
}
var conj = function conj(t1, t5, dr, dd) {
    var l5 = new (0, _interpolationJsDefault.default).Len5(t1, t5, dr);
    var t = l5.zero(true);
    l5 = new (0, _interpolationJsDefault.default).Len5(t1, t5, dd);
    var \u0394d = l5.interpolateXStrict(t);
    return [
        t,
        \u0394d
    ];
};
exports.default = {
    planetary: planetary,
    stellar: stellar
};

},{"./base.js":"lEDxD","./interpolation.js":"1h22R","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1DoWK":[function(require,module,exports,__globalThis) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module circle
 */ /**
 * Circle: Chapter 20, Smallest Circle containing three Celestial Bodies.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Smallest finds the smallest circle containing three points.
 *
 * Arguments should represent coordinates in right ascension and declination
 * or longitude and latitude.  Result Δ is the diameter of the circle, typeI
 * is true if solution is of type I.
 *
 * @param {Coord} c1 - ra, dec point 1
 * @param {Coord} c2 - ra, dec point 2
 * @param {Coord} c3 - ra, dec point 3
 * @returns {Array} [Δ, typeI]
 *  {Number} Δ - diameter of the circle
 *  {Number} typeI - true - Two points on circle, one interior.
 *                   false - All three points on circle.
 */ parcelHelpers.export(exports, "smallest", function() {
    return smallest;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _baseJs = require("./base.js"); // eslint-disable-line no-unused-vars
function smallest(c1, c2, c3) {
    // Using haversine formula
    var cd1 = Math.cos(c1.dec);
    var cd2 = Math.cos(c2.dec);
    var cd3 = Math.cos(c3.dec);
    var a = 2 * Math.asin(Math.sqrt(hav(c2.dec - c1.dec) + cd1 * cd2 * hav(c2.ra - c1.ra)));
    var b = 2 * Math.asin(Math.sqrt(hav(c3.dec - c2.dec) + cd2 * cd3 * hav(c3.ra - c2.ra)));
    var c = 2 * Math.asin(Math.sqrt(hav(c1.dec - c3.dec) + cd3 * cd1 * hav(c1.ra - c3.ra)));
    var ref;
    if (b > a) ref = (0, _slicedToArray._)(noswap(b, a), 2), a = ref[0], b = ref[1], ref;
    var ref1;
    if (c > a) ref1 = (0, _slicedToArray._)(noswap(c, a), 2), a = ref1[0], c = ref1[1], ref1;
    if (a * a >= b * b + c * c) return [
        a,
        true
    ];
    // (20.1) p. 128
    return [
        2 * a * b * c / Math.sqrt((a + b + c) * (a + b - c) * (b + c - a) * (a + c - b)),
        false
    ];
}
var noswap = function noswap(a, b) {
    return [
        a,
        b
    ];
};
/**
 * haversine function (17.5) p. 115
 */ var hav = function hav(a) {
    return 0.5 * (1 - Math.cos(a));
};
exports.default = {
    smallest: smallest
};

},{"@swc/helpers/_/_sliced_to_array":"ha6sq","./base.js":"lEDxD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7sn4F":[function(require,module,exports,__globalThis) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module deltat
 */ /**
 * DeltaT: Chapter 10, Dynamical Time and Universal Time.
 *
 * This package uses no functions from the Chapter. Polynoms are from
 * <http://eclipse.gsfc.nasa.gov/SEcat5/deltatpoly.html>, data sets are from
 * <http://maia.usno.navy.mil/ser7/>
 *
 * Functions in this package compute ΔT for various ranges of dates.
 *
 * ΔT = TD - UT1
 *
 * TD = "Dynamical Time", which is related to:
 *   ET "Ephermis Time", an older term.
 *   TDB "Barycentric Dynamical Time", very close to TD.
 *   TDT "Terrestrial Dynamical Time", a more correct term.
 *   TT "Terrestrial Time", a newer and more correct term.
 *
 * UT = "Universal Time", which is related (if ambiguously) to GMT "Greenwich
 * Mean Time".
 *
 * Terrestrial Time is effectively equal to International Atomic Time (TAI)
 * plus 32.184 seconds exactly: TT = TAI + 32.184
 * The epoch designated "J2000.0" is specified as Julian date 2451545.0 TT,
 * or 2000 January 1, 12h TT. This epoch can also be expressed as
 * 2000 January 1, 11:59:27.816 TAI or 2000 January 1, 11:58:55.816 UTC.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * deltaT returns the difference ΔT = TD - UT between Dynamical Time TD and
 * Univeral Time (GMT+12) in seconds
 *
 * Polynoms are from <http://eclipse.gsfc.nasa.gov/SEcat5/deltatpoly.html>
 * and <http://www.staff.science.uu.nl/~gent0113/deltat/deltat_old.htm>
 *
 * @param {Number} dyear - decimal year
 * @returns {Number} ΔT in seconds.
 */ parcelHelpers.export(exports, "deltaT", function() {
    return deltaT;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var _interpolationJs = require("./interpolation.js");
var _interpolationJsDefault = parcelHelpers.interopDefault(_interpolationJs);
var _deltatJs = require("../data/deltat.js");
var _deltatJsDefault = parcelHelpers.interopDefault(_deltatJs);
// avoids ciclic import { LeapYearGregorian } from './julian.js'
function LeapYearGregorian(y) {
    return y % 4 === 0 && y % 100 !== 0 || y % 400 === 0;
}
function deltaT(dyear) {
    var \u0394T;
    if (dyear < -500) \u0394T = (0, _baseJsDefault.default).horner((dyear - 1820) * 0.01, -20, 0, 32);
    else if (dyear < 500) \u0394T = (0, _baseJsDefault.default).horner(dyear * 0.01, 10583.6, -1014.41, 33.78311, -5.952053, -0.1798452, 0.022174192, 0.0090316521);
    else if (dyear < 1600) \u0394T = (0, _baseJsDefault.default).horner((dyear - 1000) * 0.01, 1574.2, -556.01, 71.23472, 0.319781, -0.8503463, -0.005050998, 0.0083572073);
    else if (dyear < (0, _deltatJsDefault.default).historic.first) \u0394T = (0, _baseJsDefault.default).horner(dyear - 1600, 120, -0.9808, -0.01532, 1 / 7129);
    else if (dyear < (0, _deltatJsDefault.default).data.first) \u0394T = interpolate(dyear, (0, _deltatJsDefault.default).historic);
    else if (dyear < (0, _deltatJsDefault.default).data.last - 0.25) \u0394T = interpolateData(dyear, (0, _deltatJsDefault.default).data);
    else if (dyear < (0, _deltatJsDefault.default).prediction.last) \u0394T = interpolate(dyear, (0, _deltatJsDefault.default).prediction);
    else if (dyear < 2050) \u0394T = (0, _baseJsDefault.default).horner((dyear - 2000) / 100, 62.92, 32.217, 55.89);
    else if (dyear < 2150) \u0394T = (0, _baseJsDefault.default).horner((dyear - 1820) / 100, -205.72, 56.28, 32);
    else {
        var u = (dyear - 1820) / 100;
        \u0394T = -20 + 32 * u * u;
    }
    return \u0394T;
}
/**
 * interpolation of dataset
 * @private
 * @param {Number} dyear - julian year
 * @returns {Number} ΔT in seconds.
 */ function interpolate(dyear, data) {
    var d3 = (0, _interpolationJsDefault.default).len3ForInterpolateX(dyear, data.first, data.last, data.table);
    return d3.interpolateX(dyear);
}
/**
 * interpolation of dataset from finals2000A with is one entry per month
 * linear interpolation over whole dataset is inaccurate as points per month
 * are not equidistant. Therefore points are approximated using 2nd diff. interpolation
 * from current month using the following two points
 *
 * @private
 * @param {Number} dyear - julian year
 * @returns {Number} ΔT in seconds.
 */ function interpolateData(dyear, data) {
    var _data_firstYM = (0, _slicedToArray._)(data.firstYM, 2), fyear = _data_firstYM[0], fmonth = _data_firstYM[1];
    var _monthOfYear = monthOfYear(dyear), year = _monthOfYear.year, month = _monthOfYear.month, first = _monthOfYear.first, last = _monthOfYear.last;
    var pos = 12 * (year - fyear) + (month - fmonth);
    var table = data.table.slice(pos, pos + 3);
    var d3 = new (0, _interpolationJsDefault.default).Len3(first, last, table);
    return d3.interpolateX(dyear);
}
/**
 * Get month of Year from fraction. Fraction differs at leap years.
 * @private
 * @param {Number} dyear - decimal year
 * @return {Object} `{year: Number, month: Number, first: Number, last}`
 */ function monthOfYear(dyear) {
    // if (!monthOfYear.data) { // memoize yearly fractions per month
    //   monthOfYear.data = { 0: [], 1: [] }
    //   for (let m = 0; m <= 12; m++) {
    //     monthOfYear.data[0][m] = new Calendar(1999, m, 1).toYear() - 1999 // non leap year
    //     monthOfYear.data[1][m] = new Calendar(2000, m, 1).toYear() - 2000 // leap year
    //   }
    // }
    // console.log(monthOfYear)
    var year = dyear | 0;
    var f = dyear - year;
    var d = LeapYearGregorian(year) ? 1 : 0;
    var data = monthOfYear.data[d];
    var month = 12 // TODO loop could be improved
    ;
    while(month > 0 && data[month] > f)month--;
    var first = year + data[month];
    var last = month < 11 ? year + data[month + 2] : year + 1 + data[(month + 2) % 12];
    return {
        year: year,
        month: month,
        first: first,
        last: last
    };
}
/**
  monthOfYear.data[0][m] = new Calendar(1999, m, 1).toYear() - 1999 // non leap year
  monthOfYear.data[1][m] = new Calendar(2000, m, 1).toYear() - 2000 // leap year
 */ monthOfYear.data = [
    [
        0,
        0,
        0.08493150684921602,
        0.16164383561635987,
        0.24657534246580326,
        0.3287671232876619,
        0.4136986301368779,
        0.4958904109589639,
        0.5808219178081799,
        0.6657534246576233,
        0.747945205479482,
        0.832876712328698,
        0.915068493150784
    ],
    [
        0,
        0,
        0.08743169398917416,
        0.1639344262296163,
        0.24863387978143692,
        0.3306010928961314,
        0.4153005464481794,
        0.49726775956287383,
        0.5819672131146945,
        0.6666666666667425,
        0.7486338797814369,
        0.8333333333332575,
        0.9153005464481794
    ]
];
exports.default = {
    deltaT: deltaT
};

},{"@swc/helpers/_/_sliced_to_array":"ha6sq","./base.js":"lEDxD","./interpolation.js":"1h22R","../data/deltat.js":"3HgKQ","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3HgKQ":[function(require,module,exports,__globalThis) {
/**
 * DO NOT EDIT MANUALLY
 * Use `scripts/deltat.js` to generate file.
 * Datasets are from <https://maia.usno.navy.mil/ser7> and
 * <ftp://ftp.iers.org/products/eop/rapid/standard>
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var m = {
    historic: {
        table: [
            44,
            43,
            43,
            41,
            40,
            39,
            38,
            37,
            37,
            36,
            36,
            36,
            37,
            37,
            38,
            37,
            36,
            36,
            35,
            35,
            34,
            33,
            33,
            32,
            32,
            31,
            31,
            30,
            30,
            29,
            29,
            29,
            29,
            29,
            28,
            28,
            27,
            27,
            26,
            26,
            25,
            25,
            25,
            26,
            26,
            26,
            26,
            25,
            25,
            25,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            24,
            23,
            23,
            23,
            23,
            22,
            22,
            22,
            22,
            22,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            20,
            20,
            20,
            20,
            20,
            20,
            20,
            20,
            20,
            21,
            21,
            21,
            20,
            20,
            20,
            20,
            20,
            19,
            19,
            19,
            19,
            19,
            20,
            20,
            20,
            20,
            19,
            20,
            20,
            20,
            20,
            20,
            20,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21,
            21.1,
            21,
            21,
            21,
            20.9,
            20.8,
            20.7,
            20.6,
            20.4,
            20.2,
            20,
            19.7,
            19.4,
            19.1,
            18.7,
            18.3,
            17.8,
            17.4,
            17,
            16.8,
            16.6,
            16.4,
            16.1,
            15.9,
            15.7,
            15.5,
            15.3,
            15,
            14.7,
            14.5,
            14.3,
            14.2,
            14.1,
            14.1,
            14.1,
            13.9,
            13.7,
            13.6,
            13.5,
            13.5,
            13.5,
            13.5,
            13.4,
            13.4,
            13.4,
            13.4,
            13.3,
            13.3,
            13.2,
            13.2,
            13.2,
            13.1,
            13.1,
            13.1,
            13,
            13.2,
            13.3,
            13.4,
            13.5,
            13.6,
            13.7,
            13.8,
            13.9,
            14,
            14,
            14.1,
            14.1,
            14.1,
            14.1,
            14.2,
            14.3,
            14.4,
            14.4,
            14.5,
            14.6,
            14.6,
            14.7,
            14.7,
            14.7,
            14.8,
            14.8,
            14.9,
            14.9,
            15,
            15,
            15.1,
            15.2,
            15.3,
            15.4,
            15.5,
            15.6,
            15.6,
            15.6,
            15.8,
            15.9,
            15.9,
            15.9,
            15.8,
            15.7,
            15.8,
            15.7,
            15.7,
            15.7,
            15.8,
            15.9,
            16.1,
            16.1,
            16,
            15.9,
            15.9,
            15.7,
            15.4,
            15.3,
            15.4,
            15.5,
            15.6,
            15.6,
            15.6,
            15.6,
            15.6,
            15.6,
            15.6,
            15.5,
            15.5,
            15.4,
            15.3,
            15.2,
            15.1,
            14.9,
            14.8,
            14.6,
            14.4,
            14.3,
            14.2,
            14.1,
            14.2,
            14.2,
            13.9,
            13.7,
            13.5,
            13.3,
            13.1,
            13,
            13.2,
            13.2,
            13.1,
            13.1,
            13.2,
            13.3,
            13.5,
            13.5,
            13.4,
            13.2,
            13.2,
            13.1,
            13.1,
            13,
            12.8,
            12.6,
            12.7,
            12.6,
            12.3,
            12,
            11.9,
            11.8,
            11.6,
            11.4,
            11.2,
            11.1,
            11.1,
            11.1,
            11.1,
            11.1,
            11.2,
            11.1,
            11.1,
            11.2,
            11.4,
            11.5,
            11.3,
            11.2,
            11.4,
            11.7,
            11.9,
            11.9,
            11.9,
            11.8,
            11.7,
            11.8,
            11.8,
            11.8,
            11.7,
            11.6,
            11.6,
            11.5,
            11.5,
            11.4,
            11.4,
            11.3,
            11.3,
            11.13,
            11.16,
            10.94,
            10.72,
            10.29,
            10.04,
            9.94,
            9.91,
            9.88,
            9.86,
            9.72,
            9.67,
            9.66,
            9.64,
            9.51,
            9.4,
            9.21,
            9,
            8.6,
            8.29,
            7.95,
            7.73,
            7.59,
            7.49,
            7.36,
            7.26,
            7.1,
            7,
            6.89,
            6.82,
            6.73,
            6.64,
            6.39,
            6.28,
            6.25,
            6.27,
            6.25,
            6.27,
            6.22,
            6.24,
            6.22,
            6.27,
            6.3,
            6.36,
            6.35,
            6.37,
            6.32,
            6.33,
            6.33,
            6.37,
            6.37,
            6.41,
            6.4,
            6.44,
            6.46,
            6.51,
            6.48,
            6.51,
            6.53,
            6.58,
            6.55,
            6.61,
            6.69,
            6.8,
            6.84,
            6.94,
            7.03,
            7.13,
            7.15,
            7.22,
            7.26,
            7.3,
            7.23,
            7.22,
            7.21,
            7.2,
            6.99,
            6.98,
            7.19,
            7.36,
            7.35,
            7.39,
            7.41,
            7.45,
            7.36,
            7.18,
            6.95,
            6.72,
            6.45,
            6.24,
            5.92,
            5.59,
            5.15,
            4.67,
            4.11,
            3.52,
            2.94,
            2.47,
            1.97,
            1.52,
            1.04,
            0.6,
            0.11,
            -0.34,
            -0.82,
            -1.25,
            -1.7,
            -2.08,
            -2.48,
            -2.82,
            -3.19,
            -3.5,
            -3.84,
            -4.14,
            -4.43,
            -4.59,
            -4.79,
            -4.92,
            -5.09,
            -5.24,
            -5.36,
            -5.34,
            -5.37,
            -5.32,
            -5.34,
            -5.33,
            -5.4,
            -5.47,
            -5.58,
            -5.66,
            -5.74,
            -5.68,
            -5.69,
            -5.65,
            -5.67,
            -5.68,
            -5.73,
            -5.72,
            -5.78,
            -5.79,
            -5.86,
            -5.89,
            -6.01,
            -6.13,
            -6.28,
            -6.41,
            -6.53,
            -6.49,
            -6.5,
            -6.45,
            -6.41,
            -6.26,
            -6.11,
            -5.9,
            -5.63,
            -5.13,
            -4.68,
            -4.19,
            -3.72,
            -3.21,
            -2.7,
            -2.09,
            -1.48,
            -0.75,
            -0.08,
            0.62,
            1.26,
            1.95,
            2.59,
            3.28,
            3.92,
            4.61,
            5.2,
            5.73,
            6.29,
            7,
            7.68,
            8.45,
            9.13,
            9.78,
            10.38,
            10.99,
            11.64,
            12.47,
            13.23,
            14,
            14.69,
            15.38,
            16,
            16.64,
            17.19,
            17.72,
            18.19,
            18.67,
            19.13,
            19.69,
            20.14,
            20.54,
            20.86,
            21.14,
            21.41,
            21.78,
            22.06,
            22.3,
            22.51,
            22.79,
            23.01,
            23.29,
            23.46,
            23.55,
            23.63,
            23.8,
            23.95,
            24.25,
            24.39,
            24.42,
            24.34,
            24.22,
            24.1,
            24.08,
            24.02,
            24.04,
            23.98,
            23.91,
            23.89,
            23.95,
            23.93,
            23.92,
            23.88,
            23.94,
            23.91,
            23.82,
            23.76,
            23.87,
            23.91,
            23.95,
            23.96,
            24,
            24.04,
            24.2,
            24.35,
            24.61,
            24.82,
            25.09,
            25.3,
            25.56,
            25.77,
            26.05,
            26.27,
            26.54,
            26.76,
            27.04,
            27.27,
            27.55,
            27.77,
            28.03,
            28.25,
            28.5,
            28.7,
            28.95,
            29.15,
            29.38,
            29.57,
            29.8,
            29.97,
            30.19,
            30.36,
            30.57,
            30.72,
            30.93,
            31.07,
            31.24,
            31.349,
            31.516,
            31.677,
            31.923,
            32.166,
            32.449,
            32.671,
            32.919,
            33.15,
            33.397,
            33.584,
            33.804,
            33.992,
            34.24,
            34.466,
            34.731,
            35.03,
            35.4,
            35.738,
            36.147,
            36.546,
            36.995,
            37.429,
            37.879,
            38.291,
            38.753,
            39.204,
            39.707,
            40.182,
            40.706,
            41.17,
            41.686,
            42.227,
            42.825,
            43.373,
            43.959,
            44.486,
            44.997,
            45.477,
            45.983,
            46.458,
            46.997,
            47.521,
            48.034,
            48.535,
            49.099,
            49.589,
            50.102,
            50.54,
            50.975,
            51.382,
            51.81,
            52.168,
            52.572,
            52.957,
            53.434,
            53.789,
            54.087
        ],
        first: 1657,
        last: 1984.5
    },
    data: {
        table: [
            43.4724372,
            43.5648351,
            43.6736863,
            43.7782156,
            43.8763273,
            43.9562443,
            44.0314956,
            44.1131788,
            44.1982187,
            44.2951747,
            44.3936471,
            44.4840562,
            44.5646335,
            44.6425099,
            44.7385767,
            44.8370135,
            44.9302138,
            44.9986146,
            45.0583549,
            45.1283911,
            45.2063835,
            45.2980068,
            45.3897017,
            45.476138,
            45.5632485,
            45.6450189,
            45.7374593,
            45.8283721,
            45.9132976,
            45.9819705,
            46.0407484,
            46.1067084,
            46.1825041,
            46.2788561,
            46.3713351,
            46.4567207,
            46.544486,
            46.6310899,
            46.7302231,
            46.8283588,
            46.9247443,
            46.9969757,
            47.0709148,
            47.1450515,
            47.2361542,
            47.3413241,
            47.4319364,
            47.5213815,
            47.6049313,
            47.6837388,
            47.7781381,
            47.8770756,
            47.9687104,
            48.0348257,
            48.0942021,
            48.1608205,
            48.2460028,
            48.3438529,
            48.4355405,
            48.5344163,
            48.6324506,
            48.7293718,
            48.8365414,
            48.9353232,
            49.0318781,
            49.1013205,
            49.1590844,
            49.2285534,
            49.3069683,
            49.4017939,
            49.4945263,
            49.5861495,
            49.6804907,
            49.7602264,
            49.8555805,
            49.9489224,
            50.0346777,
            50.1018531,
            50.1621723,
            50.2260014,
            50.2967905,
            50.3831254,
            50.4598772,
            50.5387068,
            50.6160484,
            50.6865941,
            50.7658362,
            50.8453698,
            50.918672,
            50.9761148,
            51.0278017,
            51.084323,
            51.1537928,
            51.2318645,
            51.306308,
            51.3807849,
            51.4526292,
            51.5160394,
            51.5985479,
            51.680924,
            51.7572854,
            51.8133335,
            51.8532385,
            51.9014358,
            51.9603433,
            52.0328072,
            52.0984957,
            52.1667826,
            52.2316418,
            52.2938376,
            52.3679897,
            52.4465221,
            52.5179552,
            52.5751485,
            52.6178012,
            52.666816,
            52.7340036,
            52.8055792,
            52.8792189,
            52.9564838,
            53.0444971,
            53.126769,
            53.2196749,
            53.3024139,
            53.3746645,
            53.4335399,
            53.4778015,
            53.5299937,
            53.5845392,
            53.6522628,
            53.7255844,
            53.7882418,
            53.8366625,
            53.8829665,
            53.9442904,
            54.0042478,
            54.0536342,
            54.085644,
            54.1084122,
            54.1462942,
            54.1913988,
            54.2452023,
            54.2957622,
            54.3427024,
            54.3910864,
            54.4319877,
            54.4897699,
            54.545636,
            54.597741,
            54.6354962,
            54.6532352,
            54.677594,
            54.7173643,
            54.7740957,
            54.8253023,
            54.8712512,
            54.916146,
            54.9580535,
            54.9997186,
            55.047571,
            55.0911778,
            55.1132386,
            55.132774,
            55.1532423,
            55.1898003,
            55.2415531,
            55.283803,
            55.3222105,
            55.3612676,
            55.406262,
            55.4628719,
            55.5110909,
            55.5523777,
            55.5811877,
            55.6004372,
            55.626202,
            55.6656271,
            55.7167999,
            55.7698097,
            55.8196609,
            55.8615028,
            55.9129883,
            55.9663474,
            56.0220102,
            56.0700015,
            56.0939035,
            56.110463,
            56.1313736,
            56.1610839,
            56.2068432,
            56.2582503,
            56.3000349,
            56.339902,
            56.3789995,
            56.4282839,
            56.4803947,
            56.5352164,
            56.5697487,
            56.5983102,
            56.6328326,
            56.6738814,
            56.7332116,
            56.7971596,
            56.8552701,
            56.9111378,
            56.9754725,
            57.0470772,
            57.1136128,
            57.173831,
            57.2226068,
            57.259731,
            57.3072742,
            57.3643368,
            57.4334281,
            57.5015747,
            57.5653127,
            57.6333396,
            57.6972844,
            57.7710774,
            57.8407427,
            57.9057801,
            57.9575663,
            57.9974929,
            58.0425517,
            58.1043319,
            58.1679128,
            58.2389092,
            58.3091659,
            58.3833021,
            58.4536748,
            58.5401438,
            58.6227714,
            58.6916662,
            58.7409628,
            58.7836189,
            58.8405543,
            58.898579,
            58.9713678,
            59.043837,
            59.1218414,
            59.2002687,
            59.274737,
            59.3574134,
            59.4433827,
            59.5242416,
            59.5849787,
            59.6343497,
            59.6927827,
            59.758805,
            59.8386448,
            59.9110567,
            59.9844537,
            60.056435,
            60.123065,
            60.2042185,
            60.2803745,
            60.3530352,
            60.4011891,
            60.4439959,
            60.4900257,
            60.5578054,
            60.6324446,
            60.7058569,
            60.7853482,
            60.8663504,
            60.9386672,
            61.0276757,
            61.1103448,
            61.1870458,
            61.2453891,
            61.2881024,
            61.3377799,
            61.4036165,
            61.4760366,
            61.5524599,
            61.6286593,
            61.6845819,
            61.743306,
            61.8132425,
            61.8823203,
            61.9496762,
            61.9968743,
            62.0342938,
            62.0714108,
            62.1202315,
            62.1809508,
            62.2382046,
            62.2950486,
            62.3506479,
            62.3995381,
            62.475395,
            62.5463091,
            62.6136031,
            62.6570739,
            62.6941742,
            62.7383271,
            62.7926305,
            62.8566986,
            62.9145607,
            62.9658689,
            63.0216632,
            63.0807052,
            63.1461718,
            63.2052946,
            63.2599441,
            63.2844088,
            63.2961369,
            63.3126092,
            63.3421622,
            63.3871303,
            63.4339302,
            63.4673369,
            63.4978642,
            63.5319327,
            63.5679441,
            63.6104432,
            63.6444291,
            63.6641815,
            63.6739403,
            63.692603,
            63.7147066,
            63.7518055,
            63.792717,
            63.8285221,
            63.8556871,
            63.8803854,
            63.9075025,
            63.9392787,
            63.9690744,
            63.9798604,
            63.9833077,
            63.9938011,
            64.0093384,
            64.0399621,
            64.0670429,
            64.0907881,
            64.1068077,
            64.1282125,
            64.1584211,
            64.1832722,
            64.2093975,
            64.2116628,
            64.2073173,
            64.2115565,
            64.2222858,
            64.2499625,
            64.2760973,
            64.2998037,
            64.3191858,
            64.345013,
            64.3734584,
            64.3943291,
            64.4151156,
            64.4132064,
            64.4118464,
            64.4096536,
            64.4167832,
            64.43292,
            64.4510529,
            64.4734276,
            64.4893377,
            64.5053342,
            64.5269189,
            64.5470942,
            64.5596729,
            64.5512293,
            64.5370906,
            64.5359472,
            64.5414947,
            64.5543634,
            64.5654298,
            64.5736111,
            64.5891142,
            64.6014759,
            64.6176147,
            64.6374397,
            64.6548674,
            64.6530021,
            64.6379271,
            64.637161,
            64.6399614,
            64.6543152,
            64.6723164,
            64.6876311,
            64.7051905,
            64.7313433,
            64.7575312,
            64.7811143,
            64.8000929,
            64.7994561,
            64.7876424,
            64.783095,
            64.7920604,
            64.8096421,
            64.8310888,
            64.8451826,
            64.8597013,
            64.8849929,
            64.9174991,
            64.9480298,
            64.9793881,
            64.9894772,
            65.0028155,
            65.0138193,
            65.0371432,
            65.0772597,
            65.112197,
            65.1464034,
            65.1832638,
            65.2145358,
            65.2493713,
            65.2920645,
            65.3279403,
            65.3413366,
            65.3451881,
            65.34964,
            65.3711307,
            65.3971998,
            65.4295547,
            65.4573487,
            65.486752,
            65.5152012,
            65.5449916,
            65.5780768,
            65.612728,
            65.6287505,
            65.6370091,
            65.6493375,
            65.6759928,
            65.7096966,
            65.746092,
            65.7768362,
            65.8024614,
            65.8236695,
            65.8595036,
            65.8973008,
            65.932291,
            65.950911,
            65.9534105,
            65.962833,
            65.9838647,
            66.0146733,
            66.042049,
            66.0699217,
            66.0961343,
            66.1310116,
            66.1682713,
            66.2071627,
            66.2355846,
            66.2408549,
            66.2335423,
            66.2349107,
            66.2441095,
            66.2751123,
            66.3054334,
            66.3245568,
            66.3405713,
            66.3624433,
            66.3957101,
            66.428903,
            66.4618675,
            66.4748837,
            66.4751281,
            66.4828678,
            66.5056165,
            66.5382912,
            66.5705628,
            66.6030198,
            66.6339689,
            66.6569117,
            66.6925011,
            66.7288729,
            66.7578719,
            66.7707625,
            66.7740427,
            66.7846288,
            66.810324,
            66.840048,
            66.8778601,
            66.9069091,
            66.944259,
            66.9762508,
            67.0258126,
            67.0716286,
            67.1100184,
            67.1266401,
            67.1331391,
            67.145797,
            67.17174,
            67.2091069,
            67.2459812,
            67.2810383,
            67.3136452,
            67.3456968,
            67.389003,
            67.4318433,
            67.4666209,
            67.4858459,
            67.4989147,
            67.5110936,
            67.5352658,
            67.571103,
            67.6070253,
            67.6439167,
            67.6765272,
            67.7116693,
            67.7590634,
            67.8011542,
            67.840213,
            67.8606318,
            67.8821576,
            67.9120101,
            67.9546462,
            68.0054839,
            68.051412,
            68.1024205,
            68.1577127,
            68.2043653,
            68.2664507,
            68.3188171,
            68.3703564,
            68.3964356,
            68.4094472,
            68.4304611,
            68.4629791,
            68.507818,
            68.5537018,
            68.5927179,
            68.6298107,
            68.6670627,
            68.7135208,
            68.7622755,
            68.8032843,
            68.8244838,
            68.8373427,
            68.847693,
            68.8688567,
            68.9005814,
            68.9354999,
            68.9676423,
            68.9875354,
            69.0175527,
            69.0499081,
            69.0823433,
            69.1070034,
            69.1134027,
            69.1141898,
            69.1207203,
            69.1355578,
            69.16459,
            69.1964228,
            69.2201632,
            69.2451564,
            69.2732758,
            69.3031979,
            69.3325675,
            69.3540507,
            69.3581722,
            69.3441594,
            69.3376329,
            69.3377424,
            69.3432191,
            69.3540144,
            69.3611554,
            69.3751703,
            69.3889904,
            69.4091639,
            69.4264662,
            69.4386335,
            69.4241335,
            69.3921241,
            69.3693422,
            69.3574782,
            69.3593242,
            69.3630244,
            69.359334,
            69.3510133,
            69.3537917,
            69.3582217,
            69.367306,
            69.3678649,
            69.3514228,
            69.3273414,
            69.3033273,
            69.2892463,
            69.2880419,
            69.2908014,
            69.2944974,
            69.2913953,
            69.286149,
            69.2835153,
            69.2815422,
            69.2806375,
            69.2553511,
            69.2125426,
            69.1847287,
            69.17207,
            69.1691531,
            69.173303,
            69.1698064,
            69.1589095,
            69.1556275,
            69.1672253,
            69.1771384
        ],
        first: 1973.0849315068492,
        firstYM: [
            1973,
            2
        ],
        last: 2023.3287671232877,
        lastYM: [
            2023,
            5
        ]
    },
    prediction: {
        table: [
            67.87818,
            67.96817999999999,
            68.02817999999999,
            68.04818,
            68.12818,
            68.21817999999999,
            68.26818,
            68.28818,
            68.36818,
            68.44818,
            68.50818,
            68.51818,
            68.59818,
            68.68818,
            68.73818,
            68.74817999999999,
            68.82818,
            68.91817999999999,
            68.96817999999999,
            68.98818,
            69.06818,
            69.14818,
            69.20818,
            69.22818,
            69.30818,
            69.39818,
            69.46817999999999,
            69.48818,
            69.57818,
            69.66817999999999,
            69.73818,
            69.75818,
            69.85817999999999,
            69.95818,
            70.02817999999999,
            70.05818,
            70.15818,
            70.25818,
            70.33818,
            70.36818,
            70.46817999999999
        ],
        first: 2022,
        last: 2032
    }
};
exports.default = m;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"01gWQ":[function(require,module,exports,__globalThis) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module elliptic
 */ /**
 * Elliptic: Chapter 33, Elliptic Motion.
 *
 * Partial: Various formulas and algorithms are unimplemented for lack of
 * examples or test cases.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Position returns observed equatorial coordinates of a planet at a given time.
 *
 * Argument p must be a valid V87Planet object for the observed planet.
 * Argument earth must be a valid V87Planet object for Earth.
 *
 * Results are right ascension and declination, α and δ in radians.
 */ parcelHelpers.export(exports, "position", function() {
    return position;
});
parcelHelpers.export(exports, "Elements", function() {
    return Elements;
});
/**
 * AstrometricJ2000 is a utility function for computing astrometric coordinates.
 *
 * It is used internally and only exported so that it can be used from
 * multiple packages.  It is not otherwise expected to be used.
 *
 * Argument f is a function that returns J2000 equatorial rectangular
 * coodinates of a body.
 *
 * Results are J2000 right ascention, declination, and elongation.
 */ parcelHelpers.export(exports, "astrometricJ2000", function() {
    return astrometricJ2000;
});
/**
 * Velocity returns instantaneous velocity of a body in elliptical orbit around the Sun.
 *
 * Argument a is the semimajor axis of the body, r is the instaneous distance
 * to the Sun, both in AU.
 *
 * Result is in Km/sec.
 */ parcelHelpers.export(exports, "velocity", function() {
    return velocity;
});
/**
 * Velocity returns the velocity of a body at aphelion.
 *
 * Argument a is the semimajor axis of the body in AU, e is eccentricity.
 *
 * Result is in Km/sec.
 */ parcelHelpers.export(exports, "vAphelion", function() {
    return vAphelion;
});
/**
 * Velocity returns the velocity of a body at perihelion.
 *
 * Argument a is the semimajor axis of the body in AU, e is eccentricity.
 *
 * Result is in Km/sec.
 */ parcelHelpers.export(exports, "vPerihelion", function() {
    return vPerihelion;
});
/**
 * Length1 returns Ramanujan's approximation for the length of an elliptical
 * orbit.
 *
 * Argument a is semimajor axis, e is eccentricity.
 *
 * Result is in units used for semimajor axis, typically AU.
 */ parcelHelpers.export(exports, "length1", function() {
    return length1;
});
/**
 * Length2 returns an alternate approximation for the length of an elliptical
 * orbit.
 *
 * Argument a is semimajor axis, e is eccentricity.
 *
 * Result is in units used for semimajor axis, typically AU.
 */ parcelHelpers.export(exports, "length2", function() {
    return length2;
});
/**
 * Length3 returns the length of an elliptical orbit.
 *
 * Argument a is semimajor axis, e is eccentricity.
 *
 * Result is exact, and in units used for semimajor axis, typically AU.
 */ /* As Meeus notes, Length4 converges faster.  There is no reason to use
this function
export function length3 (a, e) { // (a, e float64)  float64
  const sum0 = 1.0
  const e2 = e * e
  const term = e2 * 0.25
  const sum1 = 1.0 - term
  const nf = 1.0
  const df = 2.0
  while (sum1 !== sum0) {
    term *= nf
    nf += 2
    df += 2
    term *= nf * e2 / (df * df)
    sum0 = sum1
    sum1 -= term
  }
  return 2 * Math.PI * a * sum0
} */ /**
 * Length4 returns the length of an elliptical orbit.
 *
 * Argument a is semimajor axis, e is eccentricity.
 *
 * Result is exact, and in units used for semimajor axis, typically AU.
 */ parcelHelpers.export(exports, "length4", function() {
    return length4;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _apparentJs = require("./apparent.js");
var _apparentJsDefault = parcelHelpers.interopDefault(_apparentJs);
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var _coordJs = require("./coord.js");
var _coordJsDefault = parcelHelpers.interopDefault(_coordJs);
var _keplerJs = require("./kepler.js");
var _keplerJsDefault = parcelHelpers.interopDefault(_keplerJs);
var _nutationJs = require("./nutation.js");
var _nutationJsDefault = parcelHelpers.interopDefault(_nutationJs);
var _planetpositionJs = require("./planetposition.js");
var _planetpositionJsDefault = parcelHelpers.interopDefault(_planetpositionJs);
var _solarxyzJs = require("./solarxyz.js");
var _solarxyzJsDefault = parcelHelpers.interopDefault(_solarxyzJs);
function position(planet, earth, jde) {
    var x = 0;
    var y = 0;
    var z = 0;
    var posEarth = earth.position(jde);
    var _ref = [
        posEarth.lon,
        posEarth.lat,
        posEarth.range
    ], L0 = _ref[0], B0 = _ref[1], R0 = _ref[2];
    var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(B0), 2), sB0 = _base_sincos[0], cB0 = _base_sincos[1];
    var _base_sincos1 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(L0), 2), sL0 = _base_sincos1[0], cL0 = _base_sincos1[1];
    function pos() {
        var \u03C4 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
        var _$pos = planet.position(jde - \u03C4);
        var _ref = [
            _$pos.lon,
            _$pos.lat,
            _$pos.range
        ], L = _ref[0], B = _ref[1], R = _ref[2];
        var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(B), 2), sB = _base_sincos[0], cB = _base_sincos[1];
        var _base_sincos1 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(L), 2), sL = _base_sincos1[0], cL = _base_sincos1[1];
        x = R * cB * cL - R0 * cB0 * cL0;
        y = R * cB * sL - R0 * cB0 * sL0;
        z = R * sB - R0 * sB0;
    }
    pos();
    var \u0394 = Math.sqrt(x * x + y * y + z * z) // (33.4) p. 224
    ;
    var \u03C4 = (0, _baseJsDefault.default).lightTime(\u0394);
    // repeating with jde-τ
    pos(\u03C4);
    var \u03BB = Math.atan2(y, x) // (33.1) p. 223
    ;
    var \u03B2 = Math.atan2(z, Math.hypot(x, y)) // (33.2) p. 223
    ;
    var _apparent_eclipticAberration = (0, _slicedToArray._)((0, _apparentJsDefault.default).eclipticAberration(\u03BB, \u03B2, jde), 2), \u0394\u03BB = _apparent_eclipticAberration[0], \u0394\u03B2 = _apparent_eclipticAberration[1];
    var fk5 = (0, _planetpositionJsDefault.default).toFK5(\u03BB + \u0394\u03BB, \u03B2 + \u0394\u03B2, jde);
    \u03BB = fk5.lon;
    \u03B2 = fk5.lat;
    var _nutation_nutation = (0, _slicedToArray._)((0, _nutationJsDefault.default).nutation(jde), 2), \u0394\u03C8 = _nutation_nutation[0], \u0394\u03B5 = _nutation_nutation[1];
    \u03BB += \u0394\u03C8;
    var \u03B5 = (0, _nutationJsDefault.default).meanObliquity(jde) + \u0394\u03B5;
    return new (0, _coordJsDefault.default).Ecliptic(\u03BB, \u03B2).toEquatorial(\u03B5);
// Meeus gives a formula for elongation but doesn't spell out how to
// obtaion term λ0 and doesn't give an example solution.
}
var Elements = /*#__PURE__*/ function() {
    "use strict";
    function Elements(axis, ecc, inc, argP, node, timeP) {
        (0, _classCallCheck._)(this, Elements);
        var o = {};
        if (typeof axis === 'object') o = axis;
        this.axis = o.axis || axis;
        this.ecc = o.ecc || ecc;
        this.inc = o.inc || inc;
        this.argP = o.argP || argP;
        this.node = o.node || node;
        this.timeP = o.timeP || timeP;
    }
    (0, _createClass._)(Elements, [
        {
            /**
   * Position returns observed equatorial coordinates of a body with Keplerian elements.
   *
   * Argument e must be a valid V87Planet object for Earth.
   *
   * Results are right ascension and declination α and δ, and elongation ψ,
   * all in radians.
   */ key: "position",
            value: function position(jde, earth) {
                var _this = this;
                // (33.6) p. 227
                var n = (0, _baseJsDefault.default).K / this.axis / Math.sqrt(this.axis);
                var s\u03B5 = (0, _baseJsDefault.default).SOblJ2000;
                var c\u03B5 = (0, _baseJsDefault.default).COblJ2000;
                var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(this.node), 2), s\u03A9 = _base_sincos[0], c\u03A9 = _base_sincos[1];
                var _base_sincos1 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(this.inc), 2), si = _base_sincos1[0], ci = _base_sincos1[1];
                // (33.7) p. 228
                var F = c\u03A9;
                var G = s\u03A9 * c\u03B5;
                var H = s\u03A9 * s\u03B5;
                var P = -s\u03A9 * ci;
                var Q = c\u03A9 * ci * c\u03B5 - si * s\u03B5;
                var R = c\u03A9 * ci * s\u03B5 + si * c\u03B5;
                // (33.8) p. 229
                var A = Math.atan2(F, P);
                var B = Math.atan2(G, Q);
                var C = Math.atan2(H, R);
                var a = Math.hypot(F, P);
                var b = Math.hypot(G, Q);
                var c = Math.hypot(H, R);
                var f = function(jde) {
                    var M = n * (jde - _this.timeP);
                    var E;
                    try {
                        E = (0, _keplerJsDefault.default).kepler2b(_this.ecc, M, 15);
                    } catch (e) {
                        E = (0, _keplerJsDefault.default).kepler3(_this.ecc, M);
                    }
                    var \u03BD = (0, _keplerJsDefault.default).trueAnomaly(E, _this.ecc);
                    var r = (0, _keplerJsDefault.default).radius(E, _this.ecc, _this.axis);
                    // (33.9) p. 229
                    var x = r * a * Math.sin(A + _this.argP + \u03BD);
                    var y = r * b * Math.sin(B + _this.argP + \u03BD);
                    var z = r * c * Math.sin(C + _this.argP + \u03BD);
                    return {
                        x: x,
                        y: y,
                        z: z
                    };
                };
                return astrometricJ2000(f, jde, earth);
            }
        }
    ]);
    return Elements;
}();
function astrometricJ2000(f, jde, earth) {
    var sol = (0, _solarxyzJsDefault.default).positionJ2000(earth, jde);
    var _ref = [
        sol.x,
        sol.y,
        sol.z
    ], X = _ref[0], Y = _ref[1], Z = _ref[2];
    var \u03BE = 0;
    var \u03B7 = 0;
    var \u03B6 = 0;
    var \u0394 = 0;
    function fn() {
        var \u03C4 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
        // (33.10) p. 229
        var _f = f(jde - \u03C4), x = _f.x, y = _f.y, z = _f.z;
        \u03BE = X + x;
        \u03B7 = Y + y;
        \u03B6 = Z + z;
        \u0394 = Math.sqrt(\u03BE * \u03BE + \u03B7 * \u03B7 + \u03B6 * \u03B6);
    }
    fn();
    var \u03C4 = (0, _baseJsDefault.default).lightTime(\u0394);
    fn(\u03C4);
    var \u03B1 = Math.atan2(\u03B7, \u03BE);
    if (\u03B1 < 0) \u03B1 += 2 * Math.PI;
    var \u03B4 = Math.asin(\u03B6 / \u0394);
    var R0 = Math.sqrt(X * X + Y * Y + Z * Z);
    var \u03C8 = Math.acos((\u03BE * X + \u03B7 * Y + \u03B6 * Z) / R0 / \u0394);
    return new (0, _baseJsDefault.default).Coord(\u03B1, \u03B4, undefined, \u03C8);
}
function velocity(a, r) {
    return 42.1219 * Math.sqrt(1 / r - 0.5 / a);
}
function vAphelion(a, e) {
    return 29.7847 * Math.sqrt((1 - e) / (1 + e) / a);
}
function vPerihelion(a, e) {
    return 29.7847 * Math.sqrt((1 + e) / (1 - e) / a);
}
function length1(a, e) {
    var b = a * Math.sqrt(1 - e * e);
    return Math.PI * (3 * (a + b) - Math.sqrt((a + 3 * b) * (3 * a + b)));
}
function length2(a, e) {
    var b = a * Math.sqrt(1 - e * e);
    var s = a + b;
    var p = a * b;
    var A = s * 0.5;
    var G = Math.sqrt(p);
    var H = 2 * p / s;
    return Math.PI * (21 * A - 2 * G - 3 * H) * 0.125;
}
function length4(a, e) {
    var b = a * Math.sqrt(1 - e * e);
    var m = (a - b) / (a + b);
    var m2 = m * m;
    var sum0 = 1.0;
    var term = m2 * 0.25;
    var sum1 = 1.0 + term;
    var nf = -1;
    var df = 2.0;
    while(sum1 !== sum0){
        nf += 2;
        df += 2;
        term *= nf * nf * m2 / (df * df);
        sum0 = sum1;
        sum1 += term;
    }
    return 2 * Math.PI * a * sum0 / (1 + m);
}
exports.default = {
    position: position,
    Elements: Elements,
    astrometricJ2000: astrometricJ2000,
    velocity: velocity,
    vAphelion: vAphelion,
    vPerihelion: vPerihelion,
    length1: length1,
    length2: length2,
    // length3,
    length4: length4
};

},{"@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","@swc/helpers/_/_sliced_to_array":"ha6sq","./apparent.js":"5Tqj8","./base.js":"lEDxD","./coord.js":"kTRDS","./kepler.js":"hqcOu","./nutation.js":"jqV8z","./planetposition.js":"8l87z","./solarxyz.js":"bIzgX","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"hqcOu":[function(require,module,exports,__globalThis) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module kepler
 */ /**
 * Kepler: Chapter 30, Equation of Kepler.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * True returns true anomaly ν for given eccentric anomaly E.
 *
 * @param {number} e - eccentricity
 * @param {number} E - eccentric anomaly in radians.
 * @return true anomaly ν in radians.
 */ parcelHelpers.export(exports, "trueAnomaly", function() {
    return trueAnomaly;
});
/**
 * Radius returns radius distance r for given eccentric anomaly E.
 *
 * Result unit is the unit of semimajor axis a (typically AU.)
 *
 * @param {number} e - eccentricity
 * @param {number} E - eccentric anomaly in radians
 * @param {number} a - semimajor axis
 * @return {number} radius distance in unit of `a`
 */ parcelHelpers.export(exports, "radius", function() {
    return radius;
});
/**
 * Kepler1 solves Kepler's equation by iteration.
 *
 * The iterated formula is
 *
 *  E1 = m + e * sin(E0)
 *
 * For some vaues of e and M it will fail to converge and the
 * function will return an error.
 *
 * @throws Error
 * @param {number} e - eccentricity
 * @param {number} m - mean anomaly in radians
 * @param {number} places - (int) desired number of decimal places in the result
 * @return {number} eccentric anomaly `E` in radians.
 */ parcelHelpers.export(exports, "kepler1", function() {
    return kepler1;
});
/**
 * Kepler2 solves Kepler's equation by iteration.
 *
 * The iterated formula is
 *
 *  E1 = E0 + (m + e * sin(E0) - E0) / (1 - e * cos(E0))
 *
 * The function converges over a wider range of inputs than does Kepler1
 * but it also fails to converge for some values of e and M.
 *
 * @throws Error
 * @param {number} e - eccentricity
 * @param {number} m - mean anomaly in radians
 * @param {number} places - (int) desired number of decimal places in the result
 * @return {number} eccentric anomaly `E` in radians.
 */ parcelHelpers.export(exports, "kepler2", function() {
    return kepler2;
});
/**
 * Kepler2a solves Kepler's equation by iteration.
 *
 * The iterated formula is the same as in Kepler2 but a limiting function
 * avoids divergence.
 *
 * @throws Error
 * @param {number} e - eccentricity
 * @param {number} m - mean anomaly in radians
 * @param {number} places - (int) desired number of decimal places in the result
 * @return {number} eccentric anomaly `E` in radians.
 */ parcelHelpers.export(exports, "kepler2a", function() {
    return kepler2a;
});
/**
 * Kepler2b solves Kepler's equation by iteration.
 *
 * The iterated formula is the same as in Kepler2 but a (different) limiting
 * function avoids divergence.
 *
 * @throws Error
 * @param {number} e - eccentricity
 * @param {number} m - mean anomaly in radians
 * @param {number} places - (int) desired number of decimal places in the result
 * @return {number} eccentric anomaly `E` in radians.
 */ parcelHelpers.export(exports, "kepler2b", function() {
    return kepler2b;
});
/**
 * Kepler3 solves Kepler's equation by binary search.
 *
 * @throws Error
 * @param {number} e - eccentricity
 * @param {number} m - mean anomaly in radians
 * @return {number} eccentric anomaly `E` in radians.
 */ parcelHelpers.export(exports, "kepler3", function() {
    return kepler3;
});
/**
 * Kepler4 returns an approximate solution to Kepler's equation.
 *
 * It is valid only for small values of e.
 *
 * @param {number} e - eccentricity
 * @param {number} m - mean anomaly in radians
 * @return {number} eccentric anomaly `E` in radians.
 */ parcelHelpers.export(exports, "kepler4", function() {
    return kepler4;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var _iterateJs = require("./iterate.js");
var _iterateJsDefault = parcelHelpers.interopDefault(_iterateJs);
function trueAnomaly(E, e) {
    // (30.1) p. 195
    return 2 * Math.atan(Math.sqrt((1 + e) / (1 - e)) * Math.tan(E * 0.5));
}
function radius(E, e, a) {
    // (30.2) p. 195
    return a * (1 - e * Math.cos(E));
}
function kepler1(e, m, places) {
    var f = function f(E0) {
        return m + e * Math.sin(E0) // (30.5) p. 195
        ;
    };
    return (0, _iterateJsDefault.default).decimalPlaces(f, m, places, places * 5);
}
function kepler2(e, m, places) {
    var f = function f(E0) {
        var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(E0), 2), se = _base_sincos[0], ce = _base_sincos[1];
        return E0 + (m + e * se - E0) / (1 - e * ce // (30.7) p. 199
        );
    };
    return (0, _iterateJsDefault.default).decimalPlaces(f, m, places, places);
}
function kepler2a(e, m, places) {
    var f = function f(E0) {
        var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(E0), 2), se = _base_sincos[0], ce = _base_sincos[1];
        // method of Leingärtner, p. 205
        return E0 + Math.asin(Math.sin((m + e * se - E0) / (1 - e * ce)));
    };
    return (0, _iterateJsDefault.default).decimalPlaces(f, m, places, places * 5);
}
function kepler2b(e, m, places) {
    var f = function f(E0) {
        var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(E0), 2), se = _base_sincos[0], ce = _base_sincos[1];
        var d = (m + e * se - E0) / (1 - e * ce);
        // method of Steele, p. 205
        if (d > 0.5) d = 0.5;
        else if (d < -0.5) d = -0.5;
        return E0 + d;
    };
    return (0, _iterateJsDefault.default).decimalPlaces(f, m, places, places);
}
function kepler3(e, m) {
    // adapted from BASIC, p. 206
    m = (0, _baseJsDefault.default).pmod(m, 2 * Math.PI);
    var f = 1;
    if (m > Math.PI) {
        f = -1;
        m = 2 * Math.PI - m;
    }
    var E0 = Math.PI * 0.5;
    var d = Math.PI * 0.25;
    for(var i = 0; i < 53; i++){
        var M1 = E0 - e * Math.sin(E0);
        if (m - M1 < 0) E0 -= d;
        else E0 += d;
        d *= 0.5;
    }
    if (f < 0) return -E0;
    return E0;
}
function kepler4(e, m) {
    var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(m), 2), sm = _base_sincos[0], cm = _base_sincos[1];
    return Math.atan2(sm, cm - e) // (30.8) p. 206
    ;
}
exports.default = {
    trueAnomaly: trueAnomaly,
    true: trueAnomaly,
    radius: radius,
    kepler1: kepler1,
    kepler2: kepler2,
    kepler2a: kepler2a,
    kepler2b: kepler2b,
    kepler3: kepler3,
    kepler4: kepler4
};

},{"@swc/helpers/_/_sliced_to_array":"ha6sq","./base.js":"lEDxD","./iterate.js":"gw6ZZ","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gw6ZZ":[function(require,module,exports,__globalThis) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module iterate
 */ /**
 * Iterate: Chapter 5, Iteration.
 *
 * This package is best considered illustrative.  While the functions are
 * usable, they are minimal in showing the points of the chapter text.  More
 * robust functions would handle more cases of overflow, loss of precision,
 * and divergence.
 */ /**
 * decimalPlaces iterates to a fixed number of decimal places.
 *
 * Inputs are an improvement function, a starting value, the number of
 * decimal places desired in the result, and an iteration limit.
 *
 * @throws Error
 * @param {Function} better
 * @param {Number} start - (float)
 * @param {Number} places - (int)
 * @param {Number} maxIterations - (int)
 * @returns {Number}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "decimalPlaces", function() {
    return decimalPlaces;
});
/**
 * fullPrecison iterates to (nearly) the full precision of a float64.
 *
 * To allow for a little bit of floating point jitter, FullPrecision iterates
 * to 15 significant figures, which is the maximum number of full significant
 * figures representable in a float64, but still a couple of bits shy of the
 * full representable precision.
 *
 * @throws Error
 * @param {Function} better
 * @param {Number} start - (float)
 * @param {Number} maxIterations - (int)
 * @returns {Number}
 */ parcelHelpers.export(exports, "fullPrecision", function() {
    return fullPrecision;
});
/**
 * binaryRoot finds a root between given bounds by binary search.
 *
 * Inputs are a function on x and the bounds on x.  A root must exist between
 * the given bounds, otherwise the result is not meaningful.
 *
 * @param {Function} f - root function
 * @param {Number} lower - (float)
 * @param {Number} upper - (float)
 * @returns {Number}
 */ parcelHelpers.export(exports, "binaryRoot", function() {
    return binaryRoot;
});
function decimalPlaces(better, start, places, maxIterations) {
    var d = Math.pow(10, -places);
    for(var i = 0; i < maxIterations; i++){
        var n = better(start);
        if (Math.abs(n - start) < d) return n;
        start = n;
    }
    throw new Error('Maximum iterations reached');
}
function fullPrecision(better, start, maxIterations) {
    for(var i = 0; i < maxIterations; i++){
        var n = better(start);
        if (Math.abs((n - start) / n) < 1e-15) return n;
        start = n;
    }
    throw new Error('Maximum iterations reached');
}
function binaryRoot(f, lower, upper) {
    var yLower = f(lower);
    var mid = 0;
    for(var j = 0; j < 52; j++){
        mid = (lower + upper) / 2;
        var yMid = f(mid);
        if (yMid === 0) break;
        if (signbit(yLower) === signbit(yMid)) {
            lower = mid;
            yLower = yMid;
        } else upper = mid;
    }
    return mid;
}
function signbit(v) {
    return v < 0;
}
exports.default = {
    decimalPlaces: decimalPlaces,
    fullPrecision: fullPrecision,
    binaryRoot: binaryRoot
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"bIzgX":[function(require,module,exports,__globalThis) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module solarxyz
 */ /**
 * Solarxyz: Chapter 26, Rectangular Coordinates of the Sun.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Position returns rectangular coordinates referenced to the mean equinox of date.
 * @param {planetposition.Planet} earth - VSOP87Planet Earth
 * @param {Number} jde - Julian ephemeris day
 * @return {object} rectangular coordinates
 *   {Number} x
 *   {Number} y
 *   {Number} z
 */ parcelHelpers.export(exports, "position", function() {
    return position;
});
/**
 * LongitudeJ2000 returns geometric longitude referenced to equinox J2000.
 * @param {planetposition.Planet} earth - VSOP87Planet Earth
 * @param {Number} jde - Julian ephemeris day
 * @return {Number} geometric longitude referenced to equinox J2000.
 */ parcelHelpers.export(exports, "longitudeJ2000", function() {
    return longitudeJ2000;
});
/**
 * PositionJ2000 returns rectangular coordinates referenced to equinox J2000.
 * @param {planetposition.Planet} earth - VSOP87Planet Earth
 * @param {Number} jde - Julian ephemeris day
 * @return {object} rectangular coordinates
 *   {Number} x
 *   {Number} y
 *   {Number} z
 */ parcelHelpers.export(exports, "positionJ2000", function() {
    return positionJ2000;
});
parcelHelpers.export(exports, "xyz", function() {
    return xyz;
});
/**
 * PositionB1950 returns rectangular coordinates referenced to B1950.
 *
 * Results are referenced to the mean equator and equinox of the epoch B1950
 * in the FK5 system, not FK4.
 *
 * @param {planetposition.Planet} earth - VSOP87Planet Earth
 * @param {Number} jde - Julian ephemeris day
 * @return {object} rectangular coordinates
 *   {Number} x
 *   {Number} y
 *   {Number} z
 */ parcelHelpers.export(exports, "positionB1950", function() {
    return positionB1950;
});
/**
 * PositionEquinox returns rectangular coordinates referenced to an arbitrary epoch.
 *
 * Position will be computed for given Julian day "jde" but referenced to mean
 * equinox "epoch" (year).
 *
 * @param {planetposition.Planet} earth - VSOP87Planet Earth
 * @param {Number} jde - Julian ephemeris day
 * @param {Number} epoch
 * @return {object} rectangular coordinates
 *   {Number} x
 *   {Number} y
 *   {Number} z
 */ parcelHelpers.export(exports, "positionEquinox", function() {
    return positionEquinox;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var _nutationJs = require("./nutation.js");
var _nutationJsDefault = parcelHelpers.interopDefault(_nutationJs);
var _solarJs = require("./solar.js");
var _solarJsDefault = parcelHelpers.interopDefault(_solarJs);
function position(earth, jde) {
    // (26.1) p. 171
    var _solar_trueVSOP87 = (0, _solarJsDefault.default).trueVSOP87(earth, jde), lon = _solar_trueVSOP87.lon, lat = _solar_trueVSOP87.lat, range = _solar_trueVSOP87.range;
    var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos((0, _nutationJsDefault.default).meanObliquity(jde)), 2), s\u03B5 = _base_sincos[0], c\u03B5 = _base_sincos[1];
    var _base_sincos1 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(lon), 2), ss = _base_sincos1[0], cs = _base_sincos1[1];
    var s\u03B2 = Math.sin(lat);
    var x = range * cs;
    var y = range * (ss * c\u03B5 - s\u03B2 * s\u03B5);
    var z = range * (ss * s\u03B5 + s\u03B2 * c\u03B5);
    return {
        x: x,
        y: y,
        z: z
    };
}
function longitudeJ2000(earth, jde) {
    var lon = earth.position2000(jde).lon;
    return (0, _baseJsDefault.default).pmod(lon + Math.PI - 0.09033 / 3600 * Math.PI / 180, 2 * Math.PI);
}
function positionJ2000(earth, jde) {
    var _xyz = xyz(earth, jde), x = _xyz.x, y = _xyz.y, z = _xyz.z;
    // (26.3) p. 174
    return {
        x: x + 0.00000044036 * y - 0.000000190919 * z,
        y: -0.000000479966 * x + 0.917482137087 * y - 0.397776982902 * z,
        z: 0.397776982902 * y + 0.917482137087 * z
    };
}
function xyz(earth, jde) {
    var _earth_position2000 = earth.position2000(jde), lon = _earth_position2000.lon, lat = _earth_position2000.lat, range = _earth_position2000.range;
    var s = lon + Math.PI;
    var \u03B2 = -lat;
    var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(s), 2), ss = _base_sincos[0], cs = _base_sincos[1];
    var _base_sincos1 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03B2), 2), s\u03B2 = _base_sincos1[0], c\u03B2 = _base_sincos1[1];
    // (26.2) p. 172
    var x = range * c\u03B2 * cs;
    var y = range * c\u03B2 * ss;
    var z = range * s\u03B2;
    return {
        x: x,
        y: y,
        z: z
    };
}
function positionB1950(earth, jde) {
    var _xyz = xyz(earth, jde), x = _xyz.x, y = _xyz.y, z = _xyz.z;
    return {
        x: 0.999925702634 * x + 0.012189716217 * y + 0.000011134016 * z,
        y: -0.011179418036 * x + 0.917413998946 * y - 0.397777041885 * z,
        z: -0.004859003787 * x + 0.397747363646 * y + 0.917482111428 * z
    };
}
var \u03B6t = [
    2306.2181,
    0.30188,
    0.017998
];
var zt = [
    2306.2181,
    1.09468,
    0.018203
];
var \u03B8t = [
    2004.3109,
    -0.42665,
    -0.041833
];
function positionEquinox(earth, jde, epoch) {
    var _$xyz = positionJ2000(earth, jde);
    var x0 = _$xyz.x;
    var y0 = _$xyz.y;
    var z0 = _$xyz.z;
    var t = (epoch - 2000) * 0.01;
    var \u03B6 = (0, _baseJsDefault.default).horner(t, \u03B6t) * t * Math.PI / 180 / 3600;
    var z = (0, _baseJsDefault.default).horner(t, zt) * t * Math.PI / 180 / 3600;
    var \u03B8 = (0, _baseJsDefault.default).horner(t, \u03B8t) * t * Math.PI / 180 / 3600;
    var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03B6), 2), s\u03B6 = _base_sincos[0], c\u03B6 = _base_sincos[1];
    var _base_sincos1 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(z), 2), sz = _base_sincos1[0], cz = _base_sincos1[1];
    var _base_sincos2 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03B8), 2), s\u03B8 = _base_sincos2[0], c\u03B8 = _base_sincos2[1];
    var xx = c\u03B6 * cz * c\u03B8 - s\u03B6 * sz;
    var xy = s\u03B6 * cz + c\u03B6 * sz * c\u03B8;
    var xz = c\u03B6 * s\u03B8;
    var yx = -c\u03B6 * sz - s\u03B6 * cz * c\u03B8;
    var yy = c\u03B6 * cz - s\u03B6 * sz * c\u03B8;
    var yz = -s\u03B6 * s\u03B8;
    var zx = -cz * s\u03B8;
    var zy = -sz * s\u03B8;
    var zz = c\u03B8;
    return {
        x: xx * x0 + yx * y0 + zx * z0,
        y: xy * x0 + yy * y0 + zy * z0,
        z: xz * x0 + yz * y0 + zz * z0
    };
}
exports.default = {
    position: position,
    longitudeJ2000: longitudeJ2000,
    positionJ2000: positionJ2000,
    xyz: xyz,
    positionB1950: positionB1950,
    positionEquinox: positionEquinox
};

},{"@swc/helpers/_/_sliced_to_array":"ha6sq","./base.js":"lEDxD","./nutation.js":"jqV8z","./solar.js":"d2aLm","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"c4LIa":[function(require,module,exports,__globalThis) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module eclipse
 */ /**
 * Eclipse: Chapter 54, Eclipses.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TYPE", function() {
    return TYPE;
});
/**
 * Solar computes quantities related to solar eclipses.
 *
 * Argument year is a decimal year specifying a date.
 *
 * eclipseType will be None, Partial, Annular, AnnularTotal, or Total.
 * If None, none of the other return values may be meaningful.
 *
 * central is true if the center of the eclipse shadow touches the Earth.
 *
 * jdeMax is the jde when the center of the eclipse shadow is closest to the
 * Earth center, in a plane through the center of the Earth.
 *
 * γ is the distance from the eclipse shadow center to the Earth center
 * at time jdeMax.
 *
 * u is the radius of the Moon's umbral cone in the plane of the Earth.
 *
 * p is the radius of the penumbral cone.
 *
 * mag is eclipse magnitude for partial eclipses.  It is not valid for other
 * eclipse types.
 *
 * γ, u, and p are in units of equatorial Earth radii.
 */ parcelHelpers.export(exports, "solar", function() {
    return solar;
});
/**
 * Lunar computes quantities related to lunar eclipses.
 *
 * Argument year is a decimal year specifying a date.
 *
 * eclipseType will be None, Penumbral, Umbral, or Total.
 * If None, none of the other return values may be meaningful.
 *
 * jdeMax is the jde when the center of the eclipse shadow is closest to the
 * Moon center, in a plane through the center of the Moon.
 *
 * γ is the distance from the eclipse shadow center to the moon center
 * at time jdeMax.
 *
 * σ is the radius of the umbral cone in the plane of the Moon.
 *
 * ρ is the radius of the penumbral cone.
 *
 * mag is eclipse magnitude.
 *
 * sd- return values are semidurations of the phases of the eclipse, in days.
 *
 * γ, σ, and ρ are in units of equatorial Earth radii.
 */ parcelHelpers.export(exports, "lunar", function() {
    return lunar;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var _moonphaseJs = require("./moonphase.js");
var _moonphaseJsDefault = parcelHelpers.interopDefault(_moonphaseJs);
/**
 * @private
 */ var g = function g(k, jm, c1, c2) {
    var ck = 1 / 1236.85;
    var p = Math.PI / 180;
    var T = k * ck;
    var F = (0, _baseJsDefault.default).horner(T, 160.7108 * p, 390.67050284 * p / ck, -0.0016118 * p, -0.00000227 * p, 0.000000011 * p);
    if (Math.abs(Math.sin(F)) > 0.36) return [
        false
    ] // no eclipse
    ;
    var eclipse = true;
    var E = (0, _baseJsDefault.default).horner(T, 1, -0.002516, -0.0000074);
    var M = (0, _baseJsDefault.default).horner(T, 2.5534 * p, 29.1053567 * p / ck, -0.0000014 * p, -0.00000011 * p);
    var M\u02B9 = (0, _baseJsDefault.default).horner(T, 201.5643 * p, 385.81693528 * p / ck, 0.0107582 * p, 0.00001238 * p, -0.000000058 * p);
    var \u03A9 = (0, _baseJsDefault.default).horner(T, 124.7746 * p, -1.56375588 * p / ck, 0.0020672 * p, 0.00000215 * p);
    var s\u03A9 = Math.sin(\u03A9);
    var F1 = F - 0.02665 * p * s\u03A9;
    var A1 = (0, _baseJsDefault.default).horner(T, 299.77 * p, 0.107408 * p / ck, -0.009173 * p);
    // (54.1) p. 380
    var jdeMax = jm + c1 * Math.sin(M\u02B9) + c2 * Math.sin(M) * E + 0.0161 * Math.sin(2 * M\u02B9) + -0.0097 * Math.sin(2 * F1) + 0.0073 * Math.sin(M\u02B9 - M) * E + -0.005 * Math.sin(M\u02B9 + M) * E + -0.0023 * Math.sin(M\u02B9 - 2 * F1) + 0.0021 * Math.sin(2 * M) * E + 0.0012 * Math.sin(M\u02B9 + 2 * F1) + 0.0006 * Math.sin(2 * M\u02B9 + M) * E + -0.0004 * Math.sin(3 * M\u02B9) + -0.0003 * Math.sin(M + 2 * F1) * E + 0.0003 * Math.sin(A1) + -0.0002 * Math.sin(M - 2 * F1) * E + -0.0002 * Math.sin(2 * M\u02B9 - M) * E + -0.0002 * s\u03A9;
    var P = 0.207 * Math.sin(M) * E + 0.0024 * Math.sin(2 * M) * E + -0.0392 * Math.sin(M\u02B9) + 0.0116 * Math.sin(2 * M\u02B9) + -0.0073 * Math.sin(M\u02B9 + M) * E + 0.0067 * Math.sin(M\u02B9 - M) * E + 0.0118 * Math.sin(2 * F1);
    var Q = 5.2207 + -0.0048 * Math.cos(M) * E + 0.002 * Math.cos(2 * M) * E + -0.3299 * Math.cos(M\u02B9) + -0.006 * Math.cos(M\u02B9 + M) * E + 0.0041 * Math.cos(M\u02B9 - M) * E;
    var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(F1), 2), sF1 = _base_sincos[0], cF1 = _base_sincos[1];
    var W = Math.abs(cF1);
    var \u03B3 = (P * cF1 + Q * sF1) * (1 - 0.0048 * W);
    var u = 0.0059 + 0.0046 * Math.cos(M) * E + -0.0182 * Math.cos(M\u02B9) + 0.0004 * Math.cos(2 * M\u02B9) + -0.0005 * Math.cos(M + M\u02B9);
    return [
        eclipse,
        jdeMax,
        \u03B3,
        u,
        M\u02B9
    ] // (eclipse bool, jdeMax, γ, u, Mʹ float64)
    ;
};
var TYPE = {
    None: 0,
    Partial: 1,
    Annular: 2,
    AnnularTotal: 3,
    Penumbral: 4,
    Umbral: 5,
    Total: 6 // solar or lunar
};
/**
 * Snap returns k at specified quarter q nearest year y.
 * Cut and paste from moonphase.  Time corresponding to k needed in these
 * algorithms but otherwise not meaningful enough to export from moonphase.
 */ var snap = function snap(y, q) {
    var k = (y - 2000) * 12.3685 // (49.2) p. 350
    ;
    return Math.floor(k - q + 0.5) + q;
};
function solar(year) {
    var eclipseType = TYPE.None;
    var mag;
    var _g // eslint-disable-line no-unused-vars
     = (0, _slicedToArray._)(g(snap(year, 0), (0, _moonphaseJsDefault.default).meanNew(year), -0.4075, 0.1721), 5), e = _g[0], jdeMax = _g[1], \u03B3 = _g[2], u = _g[3], _ = _g[4];
    var p = u + 0.5461;
    if (!e) return {
        type: eclipseType
    } // no eclipse
    ;
    var a\u03B3 = Math.abs(\u03B3);
    if (a\u03B3 > 1.5433 + u) return {
        type: eclipseType
    } // no eclipse
    ;
    var central = a\u03B3 < 0.9972 // eclipse center touches Earth
    ;
    if (!central) {
        eclipseType = TYPE.Partial // most common case
        ;
        if (a\u03B3 < 1.026) {
            if (a\u03B3 < 0.9972 + Math.abs(u)) eclipseType = TYPE.Total // report total in both cases
            ;
        }
    } else if (u < 0) eclipseType = TYPE.Total;
    else if (u > 0.0047) eclipseType = TYPE.Annular;
    else {
        var \u03C9 = 0.00464 * Math.sqrt(1 - \u03B3 * \u03B3);
        if (u < \u03C9) eclipseType = TYPE.AnnularTotal;
        else eclipseType = TYPE.Annular;
    }
    if (eclipseType === TYPE.Partial) // (54.2) p. 382
    mag = (1.5433 + u - a\u03B3) / (0.5461 + 2 * u);
    return {
        type: eclipseType,
        central: central,
        jdeMax: jdeMax,
        magnitude: mag,
        distance: \u03B3,
        umbral: u,
        penumbral: p
    };
}
function lunar(year) {
    var eclipseType = TYPE.None;
    var mag;
    var sdTotal;
    var sdPartial;
    var sdPenumbral;
    var _g = (0, _slicedToArray._)(g(snap(year, 0.5), (0, _moonphaseJsDefault.default).meanFull(year), -0.4065, 0.1727), 5), e = _g[0], jdeMax = _g[1], \u03B3 = _g[2], u = _g[3], M\u02B9 = _g[4];
    if (!e) return {
        type: eclipseType
    } // no eclipse
    ;
    var \u03C1 = 1.2848 + u;
    var \u03C3 = 0.7403 - u;
    var a\u03B3 = Math.abs(\u03B3);
    mag = (1.0128 - u - a\u03B3) / 0.545 // (54.3) p. 382
    ;
    if (mag > 1) eclipseType = TYPE.Total;
    else if (mag > 0) eclipseType = TYPE.Umbral;
    else {
        mag = (1.5573 + u - a\u03B3) / 0.545 // (54.4) p. 382
        ;
        if (mag < 0) return {
            type: eclipseType
        } // no eclipse
        ;
        eclipseType = TYPE.Penumbral;
    }
    var p = 1.0128 - u;
    var t = 0.4678 - u;
    var n = 0.5458 + 0.04 * Math.cos(M\u02B9);
    var \u03B32 = \u03B3 * \u03B3;
    /* eslint-disable no-fallthrough */ switch(eclipseType){
        case TYPE.Total:
            sdTotal = Math.sqrt(t * t - \u03B32) / n / 24;
        case TYPE.Umbral:
            sdPartial = Math.sqrt(p * p - \u03B32) / n / 24;
        default:
            {
                var h = 1.5573 + u;
                sdPenumbral = Math.sqrt(h * h - \u03B32) / n / 24;
            }
    }
    /* eslint-enable */ return {
        type: eclipseType,
        jdeMax: jdeMax,
        magnitude: mag,
        distance: \u03B3,
        umbral: \u03C3,
        penumbral: \u03C1,
        sdTotal: sdTotal,
        sdPartial: sdPartial,
        sdPenumbral: sdPenumbral
    };
}
exports.default = {
    TYPE: TYPE,
    solar: solar,
    lunar: lunar
};

},{"@swc/helpers/_/_sliced_to_array":"ha6sq","./base.js":"lEDxD","./moonphase.js":"3ttcq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3ttcq":[function(require,module,exports,__globalThis) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module moonphase
 */ /**
 * Moonphase: Chapter 49, Phases of the Moon
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "meanLunarMonth", function() {
    return meanLunarMonth;
});
/**
 * MeanNew returns the jde of the mean New Moon nearest the given datthis.
 * The mean date is within 0.5 day of the true date of New Moon.
 *
 * @param {Number} year - decimal year
 * @returns {Number} jde
 */ parcelHelpers.export(exports, "meanNew", function() {
    return meanNew;
});
/**
 * MeanFirst returns the jde of the mean First Quarter Moon nearest the given datthis.
 * The mean date is within 0.5 day of the true date of First Quarter Moon.
 *
 * @param {Number} year - decimal year
 * @returns {Number} jde
 */ parcelHelpers.export(exports, "meanFirst", function() {
    return meanFirst;
});
/**
 * MeanFull returns the jde of the mean Full Moon nearest the given datthis.
 * The mean date is within 0.5 day of the true date of Full Moon.
 *
 * @param {Number} year - decimal year
 * @returns {Number} jde
 */ parcelHelpers.export(exports, "meanFull", function() {
    return meanFull;
});
/**
 * MeanLast returns the jde of the mean Last Quarter Moon nearest the given datthis.
 * The mean date is within 0.5 day of the true date of Last Quarter Moon.
 *
 * @param {Number} year - decimal year
 * @returns {Number} jde
 */ parcelHelpers.export(exports, "meanLast", function() {
    return meanLast;
});
/**
 * New returns the jde of New Moon nearest the given date.
 *
 * @param {Number} year - decimal year
 * @returns {Number} jde
 */ parcelHelpers.export(exports, "newMoon", function() {
    return newMoon;
});
/**
 * First returns the jde of First Quarter Moon nearest the given datthis.
 *
 * @param {Number} year - decimal year
 * @returns {Number} jde
 */ parcelHelpers.export(exports, "first", function() {
    return first;
});
/**
 * Full returns the jde of Full Moon nearest the given datthis.
 *
 * @param {Number} year - decimal year
 * @returns {Number} jde
 */ parcelHelpers.export(exports, "full", function() {
    return full;
});
/**
 * Last returns the jde of Last Quarter Moon nearest the given datthis.
 *
 * @param {Number} year - decimal year
 * @returns {Number} jde
 */ parcelHelpers.export(exports, "last", function() {
    return last;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var sin = Math.sin, cos = Math.cos;
var ck = 1 / 1236.85;
var D2R = Math.PI / 180;
var meanLunarMonth = 29.530588861;
// (49.1) p. 349
function mean(T) {
    return (0, _baseJsDefault.default).horner(T, 2451550.09766, 29.530588861 / ck, 0.00015437, -0.00000015, 0.00000000073);
}
/** snap returns k at specified quarter q nearest year y. */ function snap(y, q) {
    var k = (y - 2000) * 12.3685 // (49.2) p. 350
    ;
    return Math.floor(k - q + 0.5) + q;
}
function meanNew(year) {
    return mean(snap(year, 0) * ck);
}
function meanFirst(year) {
    return mean(snap(year, 0.25) * ck);
}
function meanFull(year) {
    return mean(snap(year, 0.5) * ck);
}
function meanLast(year) {
    return mean(snap(year, 0.75) * ck);
}
function newMoon(year) {
    var m = new Mp(year, 0);
    return mean(m.T) + m.nfc(nc) + m.a();
}
function first(year) {
    var m = new Mp(year, 0.25);
    return mean(m.T) + m.flc() + m.w() + m.a();
}
function full(year) {
    var m = new Mp(year, 0.5);
    return mean(m.T) + m.nfc(fc) + m.a();
}
function last(year) {
    var m = new Mp(year, 0.75);
    return mean(m.T) + m.flc() - m.w() + m.a();
}
var Mp = /*#__PURE__*/ function() {
    "use strict";
    function Mp(y, q) {
        (0, _classCallCheck._)(this, Mp);
        this.A = new Array(14);
        var k = this.k = snap(y, q);
        var T = this.T = this.k * ck // (49.3) p. 350
        ;
        this.E = (0, _baseJsDefault.default).horner(T, 1, -0.002516, -0.0000074);
        this.M = (0, _baseJsDefault.default).horner(T, 2.5534 * D2R, 29.1053567 * D2R / ck, -0.0000014 * D2R, -0.00000011 * D2R);
        this.M_ = (0, _baseJsDefault.default).horner(T, 201.5643 * D2R, 385.81693528 * D2R / ck, 0.0107582 * D2R, 0.00001238 * D2R, -0.000000058 * D2R);
        this.F = (0, _baseJsDefault.default).horner(T, 160.7108 * D2R, 390.67050284 * D2R / ck, -0.0016118 * D2R, -0.00000227 * D2R, 0.000000011 * D2R);
        this.\u03A9 = (0, _baseJsDefault.default).horner(T, 124.7746 * D2R, -1.56375588 * D2R / ck, 0.0020672 * D2R, 0.00000215 * D2R);
        this.A[0] = 299.7 * D2R + 0.107408 * D2R * k - 0.009173 * T * T;
        this.A[1] = 251.88 * D2R + 0.016321 * D2R * k;
        this.A[2] = 251.83 * D2R + 26.651886 * D2R * k;
        this.A[3] = 349.42 * D2R + 36.412478 * D2R * k;
        this.A[4] = 84.66 * D2R + 18.206239 * D2R * k;
        this.A[5] = 141.74 * D2R + 53.303771 * D2R * k;
        this.A[6] = 207.17 * D2R + 2.453732 * D2R * k;
        this.A[7] = 154.84 * D2R + 7.30686 * D2R * k;
        this.A[8] = 34.52 * D2R + 27.261239 * D2R * k;
        this.A[9] = 207.19 * D2R + 0.121824 * D2R * k;
        this.A[10] = 291.34 * D2R + 1.844379 * D2R * k;
        this.A[11] = 161.72 * D2R + 24.198154 * D2R * k;
        this.A[12] = 239.56 * D2R + 25.513099 * D2R * k;
        this.A[13] = 331.55 * D2R + 3.592518 * D2R * k;
    }
    (0, _createClass._)(Mp, [
        {
            // new or full corrections
            key: "nfc",
            value: function nfc(c) {
                var _this = this, M = _this.M, M_ = _this.M_, E = _this.E, F = _this.F, \u03A9 = _this.\u03A9;
                return c[0] * sin(M_) + c[1] * sin(M) * E + c[2] * sin(2 * M_) + c[3] * sin(2 * F) + c[4] * sin(M_ - M) * E + c[5] * sin(M_ + M) * E + c[6] * sin(2 * M) * E * E + c[7] * sin(M_ - 2 * F) + c[8] * sin(M_ + 2 * F) + c[9] * sin(2 * M_ + M) * E + c[10] * sin(3 * M_) + c[11] * sin(M + 2 * F) * E + c[12] * sin(M - 2 * F) * E + c[13] * sin(2 * M_ - M) * E + c[14] * sin(\u03A9) + c[15] * sin(M_ + 2 * M) + c[16] * sin(2 * (M_ - F)) + c[17] * sin(3 * M) + c[18] * sin(M_ + M - 2 * F) + c[19] * sin(2 * (M_ + F)) + c[20] * sin(M_ + M + 2 * F) + c[21] * sin(M_ - M + 2 * F) + c[22] * sin(M_ - M - 2 * F) + c[23] * sin(3 * M_ + M) + c[24] * sin(4 * M_);
            }
        },
        {
            // first or last corrections
            key: "flc",
            value: function flc() {
                var _this = this, M = _this.M, M_ = _this.M_, E = _this.E, F = _this.F, \u03A9 = _this.\u03A9;
                return -0.62801 * sin(M_) + 0.17172 * sin(M) * E + -0.01183 * sin(M_ + M) * E + 0.00862 * sin(2 * M_) + 0.00804 * sin(2 * F) + 0.00454 * sin(M_ - M) * E + 0.00204 * sin(2 * M) * E * E + -0.0018 * sin(M_ - 2 * F) + -0.0007 * sin(M_ + 2 * F) + -0.0004 * sin(3 * M_) + -0.00034 * sin(2 * M_ - M) * E + 0.00032 * sin(M + 2 * F) * E + 0.00032 * sin(M - 2 * F) * E + -0.00028 * sin(M_ + 2 * M) * E * E + 0.00027 * sin(2 * M_ + M) * E + -0.00017 * sin(\u03A9) + -0.00005 * sin(M_ - M - 2 * F) + 0.00004 * sin(2 * M_ + 2 * F) + -0.00004 * sin(M_ + M + 2 * F) + 0.00004 * sin(M_ - 2 * M) + 0.00003 * sin(M_ + M - 2 * F) + 0.00003 * sin(3 * M) + 0.00002 * sin(2 * M_ - 2 * F) + 0.00002 * sin(M_ - M + 2 * F) + -0.00002 * sin(3 * M_ + M);
            }
        },
        {
            key: "w",
            value: function w() {
                var _this = this, M = _this.M, M_ = _this.M_, E = _this.E, F = _this.F;
                return 0.00306 - 0.00038 * E * cos(M) + 0.00026 * cos(M_) - 0.00002 * (cos(M_ - M) - cos(M_ + M) - cos(2 * F));
            }
        },
        {
            // additional corrections
            key: "a",
            value: function a() {
                var _this = this;
                var a = 0;
                ac.forEach(function(c, i) {
                    a += c * sin(_this.A[i]);
                });
                return a;
            }
        }
    ]);
    return Mp;
}();
// new coefficients
var nc = [
    -0.4072,
    0.17241,
    0.01608,
    0.01039,
    0.00739,
    -0.00514,
    0.00208,
    -0.00111,
    -0.00057,
    0.00056,
    -0.00042,
    0.00042,
    0.00038,
    -0.00024,
    -0.00017,
    -0.00007,
    0.00004,
    0.00004,
    0.00003,
    0.00003,
    -0.00003,
    0.00003,
    -0.00002,
    -0.00002,
    0.00002
];
// full coefficients
var fc = [
    -0.40614,
    0.17302,
    0.01614,
    0.01043,
    0.00734,
    -0.00515,
    0.00209,
    -0.00111,
    -0.00057,
    0.00056,
    -0.00042,
    0.00042,
    0.00038,
    -0.00024,
    -0.00017,
    -0.00007,
    0.00004,
    0.00004,
    0.00003,
    0.00003,
    -0.00003,
    0.00003,
    -0.00002,
    -0.00002,
    0.00002
];
// additional corrections
var ac = [
    0.000325,
    0.000165,
    0.000164,
    0.000126,
    0.00011,
    0.000062,
    0.00006,
    0.000056,
    0.000047,
    0.000042,
    0.000040,
    0.000037,
    0.000035,
    0.000023
];
exports.default = {
    meanLunarMonth: meanLunarMonth,
    meanNew: meanNew,
    meanFirst: meanFirst,
    meanFull: meanFull,
    meanLast: meanLast,
    newMoon: newMoon,
    new: newMoon,
    first: first,
    full: full,
    last: last
};

},{"@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","./base.js":"lEDxD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8Jwzm":[function(require,module,exports,__globalThis) {
/**
 * @copyright 2020 mdmunir
 * @copyright 2020 commenthol
 * @license MIT
 * @module elp
 */ /**
 * Elp Mpp02
 * source ftp://cyrano-se.obspm.fr/pub/2_lunar_solutions/2_elpmpp02/elpmpp02.pdf
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Moon", function() {
    return Moon;
});
/**
 * Position returns the true geometric position of the moon as ecliptic coordinates.
 *
 * Result computed by Elp theory.  Result is at equator and equinox
 * of date in the FK5 frame.  It does not include nutation or aberration.
 *
 * @param {Object} elpData
 * @param {Number} jde - Julian ephemeris day
 * @returns {Object}
 *   {Number} lon - ecliptic longitude in radians
 *   {Number} lat - ecliptic latitude in radians
 *   {Number} range - range in KM
 */ parcelHelpers.export(exports, "position", function() {
    return position;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var SEC2RAD = 1 / 3600 * Math.PI / 180;
function sum(T, series) {
    var _base;
    var coeffs = [];
    Object.keys(series).forEach(function(x) {
        coeffs[x] = 0.0;
        var y = series[x].length - 1;
        for(y; y >= 0; y--){
            // A, t0, t1, t2, t3, t4
            var row = series[x][y];
            var \u03C6 = (0, _baseJsDefault.default).horner(T, row.slice(1));
            coeffs[x] += row[0] * Math.sin(\u03C6);
        }
    });
    return (_base = (0, _baseJsDefault.default)).horner.apply(_base, [
        T
    ].concat((0, _toConsumableArray._)(coeffs)));
}
var Moon = /*#__PURE__*/ function() {
    "use strict";
    function Moon(data) {
        (0, _classCallCheck._)(this, Moon);
        if (typeof data !== 'object') throw new TypeError('need Elp data');
        this.series = data;
    }
    (0, _createClass._)(Moon, [
        {
            key: "_calcLBR",
            value: function _calcLBR(T) {
                var L = (0, _baseJsDefault.default).horner(T, this.series.W1) + sum(T, this.series.L) * SEC2RAD;
                var B = sum(T, this.series.B) * SEC2RAD;
                var R = sum(T, this.series.R);
                return {
                    L: (0, _baseJsDefault.default).pmod(L, 2 * Math.PI),
                    B: B,
                    R: R
                };
            }
        },
        {
            /**
   * Position returns rectangular coordinates referred to the inertial mean ecliptic and equinox of J2000.
   * @param {Number} jde - Julian ephemeris day
   * @return {object} rectangular coordinates
   *   {Number} x
   *   {Number} y
   *   {Number} z
   */ key: "positionXYZ",
            value: function positionXYZ(jde) {
                var T = (0, _baseJsDefault.default).J2000Century(jde);
                var _this__calcLBR = this._calcLBR(T), L = _this__calcLBR.L, B = _this__calcLBR.B, R = _this__calcLBR.R;
                var x = R * Math.cos(L) * Math.cos(B);
                var y = R * Math.sin(L) * Math.cos(B);
                var z = R * Math.sin(B);
                var P = (0, _baseJsDefault.default).horner(T, 0, 0.10180391e-4, 0.47020439e-6, -0.0000000005417367, -0.000000000002507948, 0.463486e-14);
                var Q = (0, _baseJsDefault.default).horner(T, 0, -0.000113469002, 0.12372674e-6, 0.12654170e-8, -0.000000000001371808, -0.00000000000000320334);
                var sq = Math.sqrt(1 - P * P - Q * Q);
                var p11 = 1 - 2 * P * P;
                var p12 = 2 * P * Q;
                var p13 = 2 * P * sq;
                var p21 = 2 * P * Q;
                var p22 = 1 - 2 * Q * Q;
                var p23 = -2 * Q * sq;
                var p31 = -2 * P * sq;
                var p32 = 2 * Q * sq;
                var p33 = 1 - 2 * P * P - 2 * Q * Q;
                var result = {
                    x: p11 * x + p12 * y + p13 * z,
                    y: p21 * x + p22 * y + p23 * z,
                    z: p31 * x + p32 * y + p33 * z
                };
                return result;
            }
        },
        {
            /**
   * Delay effect of light time
   *
   * @param {Number} jde - Julian ephemeris day
   * @returns {Number} Delay time in days
   */ key: "lightTime",
            value: function lightTime(jde) {
                var T = (0, _baseJsDefault.default).J2000Century(jde);
                var R = sum(T, this.series.R);
                return (0, _baseJsDefault.default).lightTime(R / (0, _baseJsDefault.default).AU);
            }
        },
        {
            /**
   * Position returns ecliptic position of moon at equinox and ecliptic of date.
   *
   * @param {Number} jde - the date for which positions are desired.
   * @returns {Coord} Results are positions consistent with those elp data,
   * that is, at equinox and ecliptic of date.
   *  {Number} lon - geocentric longitude in radians.
   *  {Number} lat - geocentric latitude in radians.
   *  {Number} range - geocentric range in KM.
   */ key: "position",
            value: function position(jde) {
                var T = (0, _baseJsDefault.default).J2000Century(jde);
                var _this__calcLBR = this._calcLBR(T), L = _this__calcLBR.L, B = _this__calcLBR.B, R = _this__calcLBR.R;
                // precession
                var pA = (0, _baseJsDefault.default).horner(T, 0, 5028.79695, 1.1120, 0.000077, -0.00002353) * SEC2RAD;
                return new (0, _baseJs.Coord)((0, _baseJsDefault.default).pmod(L + pA, 2 * Math.PI), B, R);
            }
        }
    ]);
    return Moon;
}();
function position(elpData, jde) {
    var moon = new Moon(elpData);
    return moon.position(jde);
}
exports.default = {
    Moon: Moon,
    position: position
};

},{"@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","@swc/helpers/_/_to_consumable_array":"eqNDD","./base.js":"lEDxD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gGIfy":[function(require,module,exports,__globalThis) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module eqtime
 */ /**
 * Eqtime: Chapter 28, Equation of time.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * e computes the "equation of time" for the given JDE.
 *
 * Parameter planet must be a planetposition.Planet object for Earth obtained
 * with `new planetposition.Planet('earth')`.
 *
 * @param {Number} jde - Julian ephemeris day
 * @param {planetposition.Planet} earth - VSOP87 planet
 * @returns {Number} equation of time as an hour angle in radians.
 */ parcelHelpers.export(exports, "e", function() {
    return e;
});
/**
 * eSmart computes the "equation of time" for the given JDE.
 *
 * Result is less accurate that e() but the function has the advantage
 * of not requiring the V87Planet object.
 *
 * @param {Number} jde - Julian ephemeris day
 * @returns {Number} equation of time as an hour angle in radians.
 */ parcelHelpers.export(exports, "eSmart", function() {
    return eSmart;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var _coordJs = require("./coord.js");
var _coordJsDefault = parcelHelpers.interopDefault(_coordJs);
var _nutationJs = require("./nutation.js");
var _nutationJsDefault = parcelHelpers.interopDefault(_nutationJs);
var _solarJs = require("./solar.js");
var _solarJsDefault = parcelHelpers.interopDefault(_solarJs);
var cos = Math.cos, sin = Math.sin, tan = Math.tan;
function e(jde, earth) {
    var \u03C4 = (0, _baseJsDefault.default).J2000Century(jde) * 0.1;
    var L0 = l0(\u03C4);
    // code duplicated from solar.ApparentEquatorialVSOP87 so that
    // we can keep Δψ and cε
    var _solar_trueVSOP87 = (0, _solarJsDefault.default).trueVSOP87(earth, jde), lon = _solar_trueVSOP87.lon, lat = _solar_trueVSOP87.lat, range = _solar_trueVSOP87.range;
    var _nutation_nutation = (0, _slicedToArray._)((0, _nutationJsDefault.default).nutation(jde), 2), \u0394\u03C8 = _nutation_nutation[0], \u0394\u03B5 = _nutation_nutation[1];
    var a = -20.4898 / 3600 * Math.PI / 180 / range;
    var \u03BB = lon + \u0394\u03C8 + a;
    var \u03B5 = (0, _nutationJsDefault.default).meanObliquity(jde) + \u0394\u03B5;
    var eq = new (0, _coordJsDefault.default).Ecliptic(\u03BB, lat).toEquatorial(\u03B5);
    // (28.1) p. 183
    var E = L0 - 0.0057183 * Math.PI / 180 - eq.ra + \u0394\u03C8 * cos(\u03B5);
    return (0, _baseJsDefault.default).pmod(E + Math.PI, 2 * Math.PI) - Math.PI;
}
/**
 * (28.2) p. 183
 */ var l0 = function l0(\u03C4) {
    return (0, _baseJsDefault.default).horner(\u03C4, 280.4664567, 360007.6982779, 0.03032028, 1.0 / 49931, -1 / 15300, -0.0000005) * Math.PI / 180;
};
function eSmart(jde) {
    var \u03B5 = (0, _nutationJsDefault.default).meanObliquity(jde);
    var t = tan(\u03B5 * 0.5);
    var y = t * t;
    var T = (0, _baseJsDefault.default).J2000Century(jde);
    var L0 = l0(T * 0.1);
    var _$e = (0, _solarJsDefault.default).eccentricity(T);
    var M = (0, _solarJsDefault.default).meanAnomaly(T);
    var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(2 * L0), 2), sin2L0 = _base_sincos[0], cos2L0 = _base_sincos[1];
    var sinM = sin(M);
    // (28.3) p. 185
    return y * sin2L0 - 2 * _$e * sinM + 4 * _$e * y * sinM * cos2L0 - y * y * sin2L0 * cos2L0 - 1.25 * _$e * _$e * sin(2 * M);
}
exports.default = {
    e: e,
    eSmart: eSmart
};

},{"@swc/helpers/_/_sliced_to_array":"ha6sq","./base.js":"lEDxD","./coord.js":"kTRDS","./nutation.js":"jqV8z","./solar.js":"d2aLm","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"ir22U":[function(require,module,exports,__globalThis) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module fit
 */ /**
 * Fit: Chapter 4, Curve Fitting.
 */ /**
 * Linear fits a line to sample data.
 *
 * Argument p is a list of data points.  Results a and b are coefficients
 * of the best fit line y = ax + b.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "linear", function() {
    return linear;
});
/**
 * CorrelationCoefficient returns a correlation coefficient for sample data.
 */ parcelHelpers.export(exports, "correlationCoefficient", function() {
    return correlationCoefficient;
});
/**
 * Quadratic fits y = ax² + bx + c to sample data.
 *
 * Argument p is a list of data points.  Results a, b, and c are coefficients
 * of the best fit quadratic y = ax² + bx + c.
 */ parcelHelpers.export(exports, "quadratic", function() {
    return quadratic;
});
/**
 * Func3 implements multiple linear regression for a linear combination
 * of three functions.
 *
 * Given sample data and three functions in x, Func3 returns coefficients
 * a, b, and c fitting y = aƒ₀(x) + bƒ₁(x) + cƒ₂(x) to sample data.
 */ parcelHelpers.export(exports, "func3", function() {
    return func3;
});
/**
 * Func1 fits a linear multiple of a function to sample data.
 *
 * Given sample data and a function in x, Func1 returns coefficient
 * a fitting y = aƒ(x).
 */ parcelHelpers.export(exports, "func1", function() {
    return func1;
});
function linear(points) {
    var sx = 0;
    var sy = 0;
    var sx2 = 0;
    var sxy = 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = points[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var p = _step.value;
            var x = p.x;
            var y = p.y;
            sx += x;
            sy += y;
            sx2 += x * x;
            sxy += x * y;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var n = points.length;
    var d = n * sx2 - sx * sx;
    // (4.2) p. 36
    var a = (n * sxy - sx * sy) / d;
    var b = (sy * sx2 - sx * sxy) / d;
    return [
        a,
        b
    ];
}
function correlationCoefficient(points) {
    var sx = 0;
    var sy = 0;
    var sx2 = 0;
    var sy2 = 0;
    var sxy = 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = points[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var p = _step.value;
            var x = p.x;
            var y = p.y;
            sx += x;
            sy += y;
            sx2 += x * x;
            sy2 += y * y;
            sxy += x * y;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var n = points.length;
    // (4.3) p. 38
    return (n * sxy - sx * sy) / (Math.sqrt(n * sx2 - sx * sx) * Math.sqrt(n * sy2 - sy * sy));
}
function quadratic(points) {
    var P = 0;
    var Q = 0;
    var R = 0;
    var S = 0;
    var T = 0;
    var U = 0;
    var V = 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = points[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var p = _step.value;
            var x = p.x;
            var y = p.y;
            var x2 = x * x;
            P += x;
            Q += x2;
            R += x * x2;
            S += x2 * x2;
            T += y;
            U += x * y;
            V += x2 * y;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var N = points.length;
    // (4.5) p. 43
    var D = N * Q * S + 2 * P * Q * R - Q * Q * Q - P * P * S - N * R * R;
    // (4.6) p. 43
    var a = (N * Q * V + P * R * T + P * Q * U - Q * Q * T - P * P * V - N * R * U) / D;
    var b = (N * S * U + P * Q * V + Q * R * T - Q * Q * U - P * S * T - N * R * V) / D;
    var c = (Q * S * T + Q * R * U + P * R * V - Q * Q * V - P * S * U - R * R * T) / D;
    return [
        a,
        b,
        c
    ];
}
function func3(points, f0, f1, f2) {
    var M = 0;
    var P = 0;
    var Q = 0;
    var R = 0;
    var S = 0;
    var T = 0;
    var U = 0;
    var V = 0;
    var W = 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = points[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var p = _step.value;
            var x = p.x;
            var y = p.y;
            var y0 = f0(x);
            var y1 = f1(x);
            var y2 = f2(x);
            M += y0 * y0;
            P += y0 * y1;
            Q += y0 * y2;
            R += y1 * y1;
            S += y1 * y2;
            T += y2 * y2;
            U += y * y0;
            V += y * y1;
            W += y * y2;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    // (4.7) p. 44
    var D = M * R * T + 2 * P * Q * S - M * S * S - R * Q * Q - T * P * P;
    var a = (U * (R * T - S * S) + V * (Q * S - P * T) + W * (P * S - Q * R)) / D;
    var b = (U * (S * Q - P * T) + V * (M * T - Q * Q) + W * (P * Q - M * S)) / D;
    var c = (U * (P * S - R * Q) + V * (P * Q - M * S) + W * (M * R - P * P)) / D;
    return [
        a,
        b,
        c
    ];
}
function func1(points, f) {
    var syf = 0;
    var sf2 = 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // (4.8) p. 45
        for(var _iterator = points[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var p = _step.value;
            var fx = f(p.x);
            var y = p.y;
            syf += y * fx;
            sf2 += fx * fx;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return syf / sf2;
}
exports.default = {
    linear: linear,
    correlationCoefficient: correlationCoefficient,
    quadratic: quadratic,
    func3: func3,
    func1: func1
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"9pTbU":[function(require,module,exports,__globalThis) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module illum
 */ /**
 * Illum: Chapter 41, Illuminated Fraction of the Disk and Magnitude of a Planet.
 *
 * Also see functions `illuminated` and `limb` in package base.  While this
 * chapter title includes "illumnated fraction," the function for computing
 * illuminated fraction given a phase angle is `base.illuminated`.
 * `base.limb` is the function mentioned at the bottom of p. 283.0
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * PhaseAngle computes the phase angle of a planet.
 *
 * Argument r is planet's distance to Sun, Δ its distance to Earth, and R
 * the distance from Sun to Earth.  All distances in AU.
 *
 * Result in radians.
 */ parcelHelpers.export(exports, "phaseAngle", function() {
    return phaseAngle;
});
/**
 * Fraction computes the illuminated fraction of the disk of a planet.
 *
 * Argument r is planet's distance to Sun, Δ its distance to Earth, and R
 * the distance from Sun to Earth.  All distances in AU.
 */ parcelHelpers.export(exports, "fraction", function() {
    return fraction;
});
/**
 * PhaseAngle2 computes the phase angle of a planet.
 *
 * Arguments L, B, R are heliocentric ecliptical coordinates of the planet.
 * L0, R0 are longitude and radius for Earth, Δ is distance from Earth to
 * the planet.  All distances in AU, angles in radians.
 *
 * The phase angle result is in radians.
 */ parcelHelpers.export(exports, "phaseAngle2", function() {
    return phaseAngle2;
});
/**
 * PhaseAngle3 computes the phase angle of a planet.
 *
 * Arguments L, B are heliocentric ecliptical longitude and latitude of the
 * planet.  x, y, z are cartesian coordinates of the planet, Δ is distance
 * from Earth to the planet.  All distances in AU, angles in radians.
 *
 * The phase angle result is in radians.
 */ parcelHelpers.export(exports, "phaseAngle3", function() {
    return phaseAngle3;
});
/**
 * FractionVenus computes an approximation of the illumanted fraction of Venus.
 */ parcelHelpers.export(exports, "fractionVenus", function() {
    return fractionVenus;
});
/**
 * Mercury computes the visual magnitude of Mercury.
 * Formula by G. Müller
 *
 * Argument r is the planet's distance from the Sun, Δ the distance from Earth,
 * and i the phase angle in radians.
 */ parcelHelpers.export(exports, "mercury", function() {
    return mercury;
});
/**
 * Venus computes the visual magnitude of Venus.
 * Formula by G. Müller
 *
 * Argument r is the planet's distance from the Sun, Δ the distance from Earth,
 * and i the phase angle in radians.
 */ parcelHelpers.export(exports, "venus", function() {
    return venus;
});
/**
 * Mars computes the visual magnitude of Mars.
 * Formula by G. Müller
 *
 * Argument r is the planet's distance from the Sun, Δ the distance from Earth,
 * and i the phase angle in radians.
 */ parcelHelpers.export(exports, "mars", function() {
    return mars;
});
/**
 * Jupiter computes the visual magnitude of Jupiter.
 * Formula by G. Müller
 * Effect of phase not considered
 *
 * Argument r is the planet's distance from the Sun, Δ the distance from Earth.
 */ parcelHelpers.export(exports, "jupiter", function() {
    return jupiter;
});
/**
 * Saturn computes the visual magnitude of Saturn.
 * Formula by G. Müller
 * Sun's altitude above the plane of the ring is not considered.
 *
 * Argument r is the planet's distance from the Sun, Δ the distance from Earth.
 * B is the Saturnicentric latitude of the Earth referred to the plane of
 * Saturn's ring.
 * ΔU (in radians) is the difference between the Saturnicentric longitudes
 * of the Sun and the Earth, measured in the plane of the ring.
 * You can use saturndisk.Disk() to obtain B and ΔU.
 */ parcelHelpers.export(exports, "saturn", function() {
    return saturn;
});
/**
 * Uranus computes the visual magnitude of Uranus.
 * Formula by G. Müller
 *
 * Argument r is the planet's distance from the Sun, Δ the distance from Earth.
 */ parcelHelpers.export(exports, "uranus", function() {
    return uranus;
});
/**
 * Neptune computes the visual magnitude of Neptune.
 * Formulae by G. Müller
 *
 * Argument r is the planet's distance from the Sun, Δ the distance from Earth.
 */ parcelHelpers.export(exports, "neptune", function() {
    return neptune;
});
/**
 * Mercury84 computes the visual magnitude of Mercury.
 * The formula is that adopted in "Astronomical Almanac" in 1984.0
 *
 * Argument r is the planet's distance from the Sun, Δ the distance from Earth,
 * and i the phase angle in radians.
 */ parcelHelpers.export(exports, "mercury84", function() {
    return mercury84;
});
/**
 * Venus84 computes the visual magnitude of Venus.
 * The formula is that adopted in "Astronomical Almanac" in 1984.0
 *
 * Argument r is the planet's distance from the Sun, Δ the distance from Earth,
 * and i the phase angle in radians.
 */ parcelHelpers.export(exports, "venus84", function() {
    return venus84;
});
/**
 * Mars84 computes the visual magnitude of Mars.
 * The formula is that adopted in "Astronomical Almanac" in 1984.0
 *
 * Argument r is the planet's distance from the Sun, Δ the distance from Earth,
 * and i the phase angle in radians.
 */ parcelHelpers.export(exports, "mars84", function() {
    return mars84;
});
/**
 * Jupiter84 computes the visual magnitude of Jupiter.
 * The formula is that adopted in "Astronomical Almanac" in 1984.0
 *
 * Argument r is the planet's distance from the Sun, Δ the distance from Earth,
 * and i the phase angle in radians.
 */ parcelHelpers.export(exports, "jupiter84", function() {
    return jupiter84;
});
/**
 * Saturn84 computes the visual magnitude of Saturn.
 * The formula is that adopted in "Astronomical Almanac" in 1984.0
 *
 * Argument r is the planet's distance from the Sun, Δ the distance from Earth.
 * B is the Saturnicentric latitude of the Earth referred to the plane of
 * Saturn's ring.
 * ΔU (in radians) is the difference between the Saturnicentric longitudes
 * of the Sun and the Earth, measured in the plane of the ring.
 */ parcelHelpers.export(exports, "saturn84", function() {
    return saturn84;
});
/**
 * Uranus84 computes the visual magnitude of Uranus.
 * The formula is that adopted in "Astronomical Almanac" in 1984.0
 *
 * Argument r is the planet's distance from the Sun, Δ the distance from Earth.
 */ parcelHelpers.export(exports, "uranus84", function() {
    return uranus84;
});
/**
 * Neptune84 computes the visual magnitude of Neptune.
 * The formula is that adopted in "Astronomical Almanac" in 1984.0
 *
 * Argument r is the planet's distance from the Sun, Δ the distance from Earth.
 */ parcelHelpers.export(exports, "neptune84", function() {
    return neptune84;
});
/**
 * Pluto84 computes the visual magnitude of Pluto.
 * The formula is that adopted in "Astronomical Almanac" in 1984.0
 *
 * Argument r is the planet's distance from the Sun, Δ the distance from Earth.
 */ parcelHelpers.export(exports, "pluto84", function() {
    return pluto84;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var toDeg = (0, _baseJsDefault.default).toDeg;
var D2R = Math.PI / 180;
function phaseAngle(r, \u0394, R) {
    return Math.acos((r * r + \u0394 * \u0394 - R * R) / (2 * r * \u0394));
}
function fraction(r, \u0394, R) {
    // (41.2) p. 283
    var s = r + \u0394;
    return (s * s - R * R) / (4 * r * \u0394);
}
function phaseAngle2(L, B, R, L0, R0, \u0394) {
    // (41.3) p. 283
    return Math.acos((R - R0 * Math.cos(B) * Math.cos(L - L0)) / \u0394);
}
function phaseAngle3(L, B, x, y, z, \u0394) {
    // (41.4) p. 283
    var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(L), 2), sL = _base_sincos[0], cL = _base_sincos[1];
    var _base_sincos1 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(B), 2), sB = _base_sincos1[0], cB = _base_sincos1[1];
    return Math.acos((x * cB * cL + y * cB * sL + z * sB) / \u0394);
}
function fractionVenus(jde) {
    var T = (0, _baseJsDefault.default).J2000Century(jde);
    var V = (261.51 + 22518.443 * T) * D2R;
    var M = (177.53 + 35999.05 * T) * D2R;
    var N = (50.42 + 58517.811 * T) * D2R;
    var W = V + (1.91 * Math.sin(M) + 0.78 * Math.sin(N)) * D2R;
    var \u0394 = Math.sqrt(1.52321 + 1.44666 * Math.cos(W));
    var s = 0.72333 + \u0394;
    return (s * s - 1) / 2.89332 / \u0394;
}
function mercury(r, \u0394, i) {
    var s = toDeg(i) - 50;
    return 1.16 + 5 * Math.log10(r * \u0394) + (0.02838 + 0.0001023 * s) * s;
}
function venus(r, \u0394, i) {
    var iDeg = toDeg(i);
    return -4 + 5 * Math.log10(r * \u0394) + (0.01322 + 0.0000004247 * iDeg * iDeg) * iDeg;
}
function mars(r, \u0394, i) {
    return -1.3 + 5 * Math.log10(r * \u0394) + 0.01486 * toDeg(i);
}
function jupiter(r, \u0394) {
    return -8.93 + 5 * Math.log10(r * \u0394);
}
function saturn(r, \u0394, B, \u0394U) {
    var s = Math.sin(Math.abs(B));
    return -8.68 + 5 * Math.log10(r * \u0394) + 0.044 * Math.abs(toDeg(\u0394U)) - 2.6 * s + 1.25 * s * s;
}
function uranus(r, \u0394) {
    return -6.85 + 5 * Math.log10(r * \u0394);
}
function neptune(r, \u0394) {
    return -7.05 + 5 * Math.log10(r * \u0394);
}
function mercury84(r, \u0394, i) {
    return (0, _baseJsDefault.default).horner(toDeg(i), -0.42 + 5 * Math.log10(r * \u0394), 0.038, -0.000273, 0.000002);
}
function venus84(r, \u0394, i) {
    return (0, _baseJsDefault.default).horner(toDeg(i), -4.4 + 5 * Math.log10(r * \u0394), 0.0009, 0.000239, -0.00000065);
}
function mars84(r, \u0394, i) {
    return -1.52 + 5 * Math.log10(r * \u0394) + 0.016 * toDeg(i);
}
function jupiter84(r, \u0394, i) {
    return -9.4 + 5 * Math.log10(r * \u0394) + 0.005 * toDeg(i);
}
function saturn84(r, \u0394, B, \u0394U) {
    var s = Math.sin(Math.abs(B));
    return -8.88 + 5 * Math.log10(r * \u0394) + 0.044 * Math.abs(toDeg(\u0394U)) - 2.6 * s + 1.25 * s * s;
}
function uranus84(r, \u0394) {
    return -7.19 + 5 * Math.log10(r * \u0394);
}
function neptune84(r, \u0394) {
    return -6.87 + 5 * Math.log10(r * \u0394);
}
function pluto84(r, \u0394) {
    return -1 + 5 * Math.log10(r * \u0394);
}
exports.default = {
    phaseAngle: phaseAngle,
    fraction: fraction,
    phaseAngle2: phaseAngle2,
    phaseAngle3: phaseAngle3,
    fractionVenus: fractionVenus,
    mercury: mercury,
    venus: venus,
    mars: mars,
    jupiter: jupiter,
    saturn: saturn,
    uranus: uranus,
    neptune: neptune,
    mercury84: mercury84,
    venus84: venus84,
    mars84: mars84,
    jupiter84: jupiter84,
    saturn84: saturn84,
    uranus84: uranus84,
    neptune84: neptune84,
    pluto84: pluto84
};

},{"@swc/helpers/_/_sliced_to_array":"ha6sq","./base.js":"lEDxD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"kzx1b":[function(require,module,exports,__globalThis) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module jm
 */ /**
 * JM: Chapter 9, Jewish and Moslem Calendars.
 *
 * The Jewish calendar routines are implemented as a monolithic function,
 * because computations of the various results build off of common
 * intermediate results.
 *
 * The Moslem calendar routines break down nicely into some separate functions.
 *
 * Included in these are two functions that convert between Gregorian and
 * Julian calendar days without going through Julian day (JD).  As such,
 * I suppose, these or similar routines are not in chapter 7, Julian Day.
 * Package base might also be a suitable place for these, but I'm not sure
 * they are used anywhere else in the book.  Anyway, they have the quirk
 * that they are not direct inverses:  JulianToGregorian returns the day number
 * of the day of the Gregorian year, but GregorianToJulian wants the Gregorian
 * month and day of month as input.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * JewishCalendar returns interesting dates and facts about a given year.
 *
 * Input is a Julian or Gregorian year.
 *
 * Outputs:
 *  A:      (int) Year number in the Jewish Calendar
 *  mP:     (int) Month number of Pesach.
 *  dP:     (int) Day number of Pesach.
 *  mNY:    (int) Month number of the Jewish new year.
 *  dNY:    (int) Day number of the Jewish new year.
 *  months: (int) Number of months in this year.
 *  days:   (int) Number of days in this year.
 */ parcelHelpers.export(exports, "JewishCalendar", function() {
    return JewishCalendar;
});
/**
 * MoslemToJD converts a Moslem calendar date to a Julian Day.
 * @param {Number} y - year in moslem calendar
 * @param {Number} m - month
 * @param {Number} d - day
 * @returns {Number} jd - Julian day
 */ parcelHelpers.export(exports, "MoslemToJD", function() {
    return MoslemToJD;
});
/**
 * MoslemLeapYear returns true if year y of the Moslem calendar is a leap year.
 * @param {Number} year
 * @returns {Boolean} true if leap year
 */ parcelHelpers.export(exports, "MoslemLeapYear", function() {
    return MoslemLeapYear;
});
/**
 * @typedef {object} DateObj
 * @property {number} year
 * @property {number} month
 * @property {number} day
 */ /**
 * JulianToMoslem takes a year, month, and day of the Julian calendar and returns the equivalent year, month, and day of the Moslem calendar.
 *
 * @param {Number} y - julian year
 * @param {Number} m - julian month
 * @param {Number} d - julian day
 * @returns {DateObj}
 */ parcelHelpers.export(exports, "JulianToMoslem", function() {
    return JulianToMoslem;
});
/**
 * String returns the Romanization of the month ("Muḥarram", "Ṣafar", ...).
 */ parcelHelpers.export(exports, "moslemMonth", function() {
    return moslemMonth;
});
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var _julianJs = require("./julian.js");
var _julianJsDefault = parcelHelpers.interopDefault(_julianJs);
var int = Math.trunc;
function JewishCalendar(y) {
    var A = y + 3760;
    var D = bigD(y);
    var mP = 3;
    var dP = D;
    if (dP > 31) {
        mP++;
        dP -= 31;
    }
    // A simplification of Meeus's rule to add 163 days.  Months of Pesach
    // are either March or April with D based off of March.  Months of New
    // year are either September or August so D+163-(days from March to
    // September == 184) = D-21 must be based off of September.
    var mNY = 9;
    var dNY = D - 21;
    if (dNY > 30) {
        mNY++;
        dNY -= 30;
    }
    var months = 12;
    switch(A % 19){
        case 0:
        case 3:
        case 6:
        case 8:
        case 11:
        case 14:
        case 17:
            months++;
            break;
    }
    // Similarly, A simplification of Meeus's rule to take the difference
    // in calendar days from NY of one year to NY of the next.  NY is based
    // on D, so difference in D is difference in day numbers of year.  Result
    // is sum of this number and the number of days in the Western calandar
    // year.
    var y1 = y + 1;
    var lf = (0, _julianJsDefault.default).LeapYearGregorian;
    if (y1 < 1583) lf = (0, _julianJsDefault.default).LeapYearJulian;
    var days = 365;
    if (lf(y1)) days++;
    days += bigD(y1) - D;
    return [
        A,
        mP,
        dP,
        mNY,
        dNY,
        months,
        days
    ];
}
var bigD = function bigD(y) {
    var C = (0, _baseJsDefault.default).floorDiv(y, 100);
    // const S int
    var S = 0;
    if (y >= 1583) S = int((0, _baseJsDefault.default).floorDiv(3 * C - 5, 4));
    var a = (12 * y + 12) % 19;
    var b = y % 4;
    var Q = -1.904412361576 + 1.554241796621 * a + 0.25 * b - 0.003177794022 * y + S;
    var fq = Math.floor(Q);
    var iq = int(fq);
    var j = (iq + 3 * y + 5 * b + 2 - S) % 7;
    var r = Q - fq;
    // const D int
    var D;
    if (j === 2 || j === 4 || j === 6) D = iq + 23;
    else if (j === 1 && a > 6 && r >= 0.63287037) D = iq + 24;
    else if (j === 0 && a > 11 && r >= 0.897723765) D = iq + 23;
    else D = iq + 22;
    return int(D);
};
function MoslemToJD(y, m, d) {
    var N = d + (0, _baseJsDefault.default).floorDiv(295001 * (m - 1) + 9900, 10000);
    var Q = (0, _baseJsDefault.default).floorDiv(y, 30);
    var R = y % 30;
    var A = (0, _baseJsDefault.default).floorDiv(11 * R + 3, 30);
    var W = 404 * Q + 354 * R + 208 + A;
    var Q1 = (0, _baseJsDefault.default).floorDiv(W, 1461);
    var Q2 = W % 1461;
    var G = 621 + 28 * Q + 4 * Q1;
    var K = (0, _baseJsDefault.default).floorDiv(Q2 * 10000, 3652422);
    var E = (0, _baseJsDefault.default).floorDiv(3652422 * K, 10000);
    var J = Q2 - E + N - 1;
    var X = G + K;
    if (J > 366 && X % 4 === 0) {
        J -= 366;
        X++;
    } else if (J > 365 && X % 4 > 0) {
        J -= 365;
        X++;
    }
    var jd = (0, _baseJsDefault.default).floorDiv(36525 * (X - 1), 100) + 1721423 + J;
    return jd;
}
function MoslemLeapYear(year) {
    var R = year % 30;
    return (11 * R + 3) % 30 > 18;
}
function JulianToMoslem(y, m, d) {
    var W = 2;
    if (y % 4 === 0) W = 1;
    var N = (0, _baseJsDefault.default).floorDiv(275 * m, 9) - W * (0, _baseJsDefault.default).floorDiv(m + 9, 12) + d - 30;
    var A = int(y - 623);
    var B = (0, _baseJsDefault.default).floorDiv(A, 4);
    var C2 = function(A) {
        var C = A % 4;
        var C1 = 365.25001 * C;
        var C2 = Math.floor(C1);
        if (C1 - C2 > 0.5) return int(C2) + 1;
        return int(C2);
    }(A);
    var Dp = 1461 * B + 170 + C2;
    var Q = (0, _baseJsDefault.default).floorDiv(Dp, 10631);
    var R = Dp % 10631;
    var J = (0, _baseJsDefault.default).floorDiv(R, 354);
    var K = R % 354;
    var O = (0, _baseJsDefault.default).floorDiv(11 * J + 14, 30);
    var my = 30 * Q + J + 1;
    var JJ = K - O + N - 1;
    var days = 354;
    if (MoslemLeapYear(y)) days++;
    if (JJ > days) {
        JJ -= days;
        my++;
    }
    var mm;
    var md;
    if (JJ === 355) {
        mm = 12;
        md = 30;
    } else {
        var S = (0, _baseJsDefault.default).floorDiv((JJ - 1) * 10, 295);
        mm = 1 + S;
        md = (0, _baseJsDefault.default).floorDiv(10 * JJ - 295 * S, 10);
    }
    return {
        year: my,
        month: mm,
        day: md
    };
}
/**
 * An MMonth specifies a month of the Moslum Calendar (Muharram = 1, ...).
 *
 * Upgraded to Unicode from the spellings given by Meeus.
 * Source: http://en.wikipedia.org/wiki/Islamic_calendar.
 */ var mmonths = [
    '',
    "Mu\u1E25arram",
    "\u1E62afar",
    "Rab\u012B\u02BF I",
    "Rab\u012B\u02BF II",
    "Jum\u0101d\u0101 I",
    "Jum\u0101d\u0101 II",
    'Rajab',
    "Sha\u02BFb\u0101n",
    "Rama\u1E0D\u0101n",
    "Shaww\u0101l",
    "Dh\u016B al-Qa\u02BFda",
    "Dh\u016B al-\u1E24ijja"
];
function moslemMonth(m) {
    return mmonths[m];
}
exports.default = {
    JewishCalendar: JewishCalendar,
    MoslemToJD: MoslemToJD,
    MoslemLeapYear: MoslemLeapYear,
    JulianToMoslem: JulianToMoslem,
    moslemMonth: moslemMonth
};

},{"./base.js":"lEDxD","./julian.js":"hLXQt","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"hLXQt":[function(require,module,exports,__globalThis) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module julian
 */ /**
 * Julian: Chapter 7, Julian day.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GREGORIAN0JD", function() {
    return GREGORIAN0JD;
});
parcelHelpers.export(exports, "Calendar", function() {
    return Calendar;
});
parcelHelpers.export(exports, "CalendarJulian", function() {
    return CalendarJulian;
});
parcelHelpers.export(exports, "CalendarGregorian", function() {
    return CalendarGregorian;
});
// -----------------------------------------------------------------------------
/**
 * base conversion from calendar date to julian day
 */ parcelHelpers.export(exports, "CalendarToJD", function() {
    return CalendarToJD;
});
/**
 * CalendarGregorianToJD converts a Gregorian year, month, and day of month
 * to Julian day.
 *
 * Negative years are valid, back to JD 0.  The result is not valid for
 * dates before JD 0.
 * @param {number} y - year (int)
 * @param {number} m - month (int)
 * @param {number} d - day (float)
 * @returns {number} jd - Julian day (float)
 */ parcelHelpers.export(exports, "CalendarGregorianToJD", function() {
    return CalendarGregorianToJD;
});
/**
 * CalendarJulianToJD converts a Julian year, month, and day of month to Julian day.
 *
 * Negative years are valid, back to JD 0.  The result is not valid for
 * dates before JD 0.
 * @param {number} y - year (int)
 * @param {number} m - month (int)
 * @param {number} d - day (float)
 * @returns {number} jd - Julian day (float)
 */ parcelHelpers.export(exports, "CalendarJulianToJD", function() {
    return CalendarJulianToJD;
});
/**
 * LeapYearJulian returns true if year y in the Julian calendar is a leap year.
 * @param {number} y - year (int)
 * @returns {boolean} true if leap year in Julian Calendar
 */ parcelHelpers.export(exports, "LeapYearJulian", function() {
    return LeapYearJulian;
});
/**
 * LeapYearGregorian returns true if year y in the Gregorian calendar is a leap year.
 * @param {number} y - year (int)
 * @returns {boolean} true if leap year in Gregorian Calendar
 */ parcelHelpers.export(exports, "LeapYearGregorian", function() {
    return LeapYearGregorian;
});
/**
 * JDToCalendar returns the calendar date for the given jd.
 *
 * Note that this function returns a date in either the Julian or Gregorian
 * Calendar, as appropriate.
 * @param {number} jd - Julian day (float)
 * @param {boolean} isJulian - set true for Julian Calendar, otherwise Gregorian is used
 * @returns {object} `{ (int) year, (int) month, (float) day }`
 */ parcelHelpers.export(exports, "JDToCalendar", function() {
    return JDToCalendar;
});
/**
 * JDToCalendarGregorian returns the calendar date for the given jd in the Gregorian Calendar.
 *
 * @param {number} jd - Julian day (float)
 * @returns {object} `{ (int) year, (int) month, (float) day }`
 */ parcelHelpers.export(exports, "JDToCalendarGregorian", function() {
    return JDToCalendarGregorian;
});
/**
 * JDToCalendarJulian returns the calendar date for the given jd in the Julian Calendar.
 *
 * @param {number} jd - Julian day (float)
 * @returns {object} { (int) year, (int) month, (float) day }
 */ parcelHelpers.export(exports, "JDToCalendarJulian", function() {
    return JDToCalendarJulian;
});
/**
 * isJDCalendarGregorian tests if Julian day `jd` falls into the Gregorian calendar
 * @param {number} jd - Julian day (float)
 * @returns {boolean} true for Gregorian, false for Julian calendar
 */ parcelHelpers.export(exports, "isJDCalendarGregorian", function() {
    return isJDCalendarGregorian;
});
/**
 * isCalendarGregorian tests if date falls into the Gregorian calendar
 * @param {number} year - julian/gregorian year
 * @param {number} [month] - month of julian/gregorian year
 * @param {number} [day] - day of julian/gregorian year
 * @returns {boolean} true for Gregorian, false for Julian calendar
 */ parcelHelpers.export(exports, "isCalendarGregorian", function() {
    return isCalendarGregorian;
});
/**
 * JDToDate converts a Julian day `jd` to a Date Object (Gregorian Calendar)
 *
 * Note: Javascript uses the the ISO-8601 calendar, which is a proleptic Gregorian
 * calendar, i.e. it acts as if this calendar was always in effect, even before
 * its year of introduction in 1582. Therefore dates between 1582-10-05 and
 * 1582-10-14 exists.
 *
 * @param {number} jd - Julian day (float)
 * @returns {Date}
 */ parcelHelpers.export(exports, "JDToDate", function() {
    return JDToDate;
});
/**
 * DateToJD converts a proleptic Gregorian Date into a Julian day `jd`
 * @param {Date} date
 * @returns {number} jd - Julian day (float)
 */ parcelHelpers.export(exports, "DateToJD", function() {
    return DateToJD;
});
/**
 * JDEToDate converts a Julian ephemeris day `jde` to a Date Object (Gregorian Calendar)
 * To obtain "Universal Time" (UT) from "Dynamical Time" (TD) the correction ΔT (in seconds) gets applied
 * ```
 * UT = TD - ΔT
 * ```
 * If your use case does not require such accuracy converting `jde` using `JDToDate` is fine.
 *
 * Note: Javascript uses the the ISO-8601 calendar, which is a proleptic Gregorian
 * calendar, i.e. it acts as if this calendar was always in effect, even before
 * its year of introduction in 1582. Therefore dates between 1582-10-05 and
 * 1582-10-14 exists.
 *
 * @param {number} jde - Julian ephemeris day
 * @returns {Date} Javascript Date Object
 */ parcelHelpers.export(exports, "JDEToDate", function() {
    return JDEToDate;
});
/**
 * DateToJDE converts a Date Object (Gregorian Calendar) to a Julian ephemeris day `jde`
 * To obtain "Dynamical Time" (TD) from "Universal Time" (UT) the correction ΔT (in seconds) gets applied
 * ```
 * TD = UT + ΔT
 * ```
 * If your use case does not require such accuracy converting `Date` using `DateToJD` is fine.
 *
 * @param {Date} date - Javascript Date Object
 * @returns {number} jde - Julian ephemeris day (float)
 */ parcelHelpers.export(exports, "DateToJDE", function() {
    return DateToJDE;
});
/**
 * converts Modified Julian Day `mjd` to Julian Day `jd`
 * @param {Number} mjd - Modified Julian Day
 * @returns {Number} jd - Julian Day
 */ parcelHelpers.export(exports, "MJDToJD", function() {
    return MJDToJD;
});
/**
 * converts Julian Day `jd` to Modified Julian Day `mjd`
 * The MJD sometimes appear when mentioning orbital elements of artificial satellites.
 * Contrary to JD the MJD begins at Greenwich mean midnight.
 * @param {Number} jd - Julian Day
 * @returns {Number} mjd - Modified Julian Day MJD
 */ parcelHelpers.export(exports, "JDToMJD", function() {
    return JDToMJD;
});
/**
 * DayOfWeek determines the day of the week for a given JD.
 *
 * The value returned is an integer in the range 0 to 6, where 0 represents
 * Sunday.  This is the same convention followed in the time package of the
 * Javascript standard library.
 * @param {number} jd - Julian day (float)
 * @returns {number} (int) 0 == sunday; ...; 6 == saturday
 */ parcelHelpers.export(exports, "DayOfWeek", function() {
    return DayOfWeek;
});
/**
 * DayOfYearGregorian computes the day number within the year of the Gregorian
 * calendar.
 * @param {number} y - year (int)
 * @param {number} m - month (int)
 * @param {number} d - day (float)
 * @returns {number} day of year
 */ parcelHelpers.export(exports, "DayOfYearGregorian", function() {
    return DayOfYearGregorian;
});
/**
 * DayOfYearJulian computes the day number within the year of the Julian
 * calendar.
 * @param {number} y - year (int)
 * @param {number} m - month (int)
 * @param {number} d - day (float)
 * @returns {number} day of year
 */ parcelHelpers.export(exports, "DayOfYearJulian", function() {
    return DayOfYearJulian;
});
/**
 * DayOfYear computes the day number within the year.
 *
 * This form of the function is not specific to the Julian or Gregorian
 * calendar, but you must tell it whether the year is a leap year.
 * @param {number} y - year (int)
 * @param {number} m - month (int)
 * @param {number} d - day (float)
 * @param {boolean} leap - set `true` if `y` is leap year
 * @returns {number} day of year
 */ parcelHelpers.export(exports, "DayOfYear", function() {
    return DayOfYear;
});
/**
 * DayOfYearToCalendar returns the calendar month and day for a given
 * day of year and leap year status.
 * @param {number} n - day of year (int)
 * @param {boolean} leap - set `true` if `y` is leap year
 * @returns {object} `{ (int) month, (float) day }`
 */ parcelHelpers.export(exports, "DayOfYearToCalendar", function() {
    return DayOfYearToCalendar;
});
/**
 * DayOfYearToCalendarGregorian returns the calendar month and day for a given
 * day of year.
 * @param {number} year
 * @param {number} n - day of year (int)
 * @returns {CalendarGregorian} { (int) year, (int) month, (float) day }
 */ parcelHelpers.export(exports, "DayOfYearToCalendarGregorian", function() {
    return DayOfYearToCalendarGregorian;
});
/**
 * DayOfYearToCalendarJulian returns the calendar month and day for a given
 * day of year.
 * @param {number} year
 * @param {number} n - day of year (int)
 * @returns {CalendarJulian} { (int) year, (int) month, (float) day }
 */ parcelHelpers.export(exports, "DayOfYearToCalendarJulian", function() {
    return DayOfYearToCalendarJulian;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var _sexagesimalJs = require("./sexagesimal.js");
var _sexagesimalJsDefault = parcelHelpers.interopDefault(_sexagesimalJs);
var _deltatJs = require("./deltat.js");
var _deltatJsDefault = parcelHelpers.interopDefault(_deltatJs);
var int = Math.trunc;
var GREGORIAN0JD = 2299160.5;
var DAYS_OF_YEAR = [
    0,
    0,
    31,
    59,
    90,
    120,
    151,
    181,
    212,
    243,
    273,
    304,
    334
];
var SECS_OF_DAY = 86400 // 24 * 60 * 60
;
var Calendar = /*#__PURE__*/ function() {
    "use strict";
    function Calendar(year) {
        var month = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, day = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
        (0, _classCallCheck._)(this, Calendar);
        if (year instanceof Date) this.fromDate(year);
        else {
            this.year = year;
            this.month = month;
            this.day = day;
        }
    }
    (0, _createClass._)(Calendar, [
        {
            key: "getDate",
            value: function getDate() {
                return {
                    year: this.year,
                    month: this.month,
                    day: Math.floor(this.day)
                };
            }
        },
        {
            key: "getTime",
            value: function getTime() {
                var t = new (0, _sexagesimalJsDefault.default).Time(this.day * SECS_OF_DAY);
                var _t_toHMS // eslint-disable-line no-unused-vars
                 = (0, _slicedToArray._)(t.toHMS(), 4), neg = _t_toHMS[0], h = _t_toHMS[1], m = _t_toHMS[2], _s = _t_toHMS[3];
                var _base_modf = (0, _slicedToArray._)((0, _baseJsDefault.default).modf(_s), 2), s = _base_modf[0], ms = _base_modf[1];
                ms = Math.trunc(ms * 1000);
                return {
                    hour: h % 24,
                    minute: m,
                    second: s,
                    millisecond: ms
                };
            }
        },
        {
            key: "toISOString",
            value: function toISOString() {
                var _this_getDate = this.getDate(), year = _this_getDate.year, month = _this_getDate.month, day = _this_getDate.day;
                var _this_getTime = this.getTime(), hour = _this_getTime.hour, minute = _this_getTime.minute, second = _this_getTime.second, millisecond = _this_getTime.millisecond;
                return `${pad(year, 4)}-${pad(month)}-${pad(day)}T` + `${pad(hour)}:${pad(minute)}:${pad(second)}.${pad(millisecond, 3)}Z`;
            }
        },
        {
            key: "isGregorian",
            value: function isGregorian() {
                return isCalendarGregorian(this.year, this.month, this.day);
            }
        },
        {
            /**
   * Note: Take care for dates < GREGORIAN0JD as `date` is always within the
   * proleptic Gregorian Calender
   * @param {Date} date - proleptic Gregorian date
   */ key: "fromDate",
            value: function fromDate(date) {
                this.year = date.getUTCFullYear();
                this.month = date.getUTCMonth() + 1;
                var day = date.getUTCDate();
                var hour = date.getUTCHours();
                var minute = date.getUTCMinutes();
                var second = date.getUTCSeconds();
                var ms = date.getMilliseconds();
                this.day = day + (hour + (minute + (second + ms / 1000) / 60) / 60) / 24;
                return this;
            }
        },
        {
            /**
   * Note: Take care for dates < GREGORIAN0JD as `date` is always within the
   * proleptic Gregorian Calender
   * @returns {Date} proleptic Gregorian date
   */ key: "toDate",
            value: function toDate() {
                var _base_modf = (0, _slicedToArray._)((0, _baseJsDefault.default).modf(this.day), 2), day = _base_modf[0], fhour = _base_modf[1];
                var _base_modf1 = (0, _slicedToArray._)((0, _baseJsDefault.default).modf(fhour * 24), 2), hour = _base_modf1[0], fminute = _base_modf1[1];
                var _base_modf2 = (0, _slicedToArray._)((0, _baseJsDefault.default).modf(fminute * 60), 2), minute = _base_modf2[0], fsecond = _base_modf2[1];
                var _base_modf3 = (0, _slicedToArray._)((0, _baseJsDefault.default).modf(fsecond * 60), 2), second = _base_modf3[0], fms = _base_modf3[1];
                var date = new Date(Date.UTC(this.year, this.month - 1, day, hour, minute, second, Math.round(fms * 1000)));
                date.setUTCFullYear(this.year);
                return date;
            }
        },
        {
            /**
   * converts a calendar date to decimal year
   * @returns {number} decimal year
   */ key: "toYear",
            value: function toYear() {
                var _base_modf // eslint-disable-line no-unused-vars
                 = (0, _slicedToArray._)((0, _baseJsDefault.default).modf(this.day), 2), d = _base_modf[0], f = _base_modf[1];
                var n = this.dayOfYear() - 1 + f;
                var days = this.isLeapYear() ? 366 : 365;
                var decYear = this.year + n / days;
                return decYear;
            }
        },
        {
            /**
   * converts a decimal year to a calendar date
   * @param {number} year - decimal year
   */ key: "fromYear",
            value: function fromYear(year) {
                var _base_modf = (0, _slicedToArray._)((0, _baseJsDefault.default).modf(year), 2), y = _base_modf[0], f = _base_modf[1];
                this.year = y;
                var days = this.isLeapYear() ? 366 : 365;
                var dayOfYear = (0, _baseJsDefault.default).round(f * days, 5);
                var m = 12;
                while(m > 0 && DAYS_OF_YEAR[m] > dayOfYear)m--;
                this.month = m;
                this.day = 1 + dayOfYear - DAYS_OF_YEAR[this.month];
                return this;
            }
        },
        {
            key: "isLeapYear",
            value: function isLeapYear() {
                if (this.isGregorian()) return LeapYearGregorian(this.year);
                else return LeapYearJulian(this.year);
            }
        },
        {
            key: "toJD",
            value: function toJD() {
                return CalendarToJD(this.year, this.month, this.day, !this.isGregorian());
            }
        },
        {
            key: "fromJD",
            value: function fromJD(jd) {
                var isJulian = !isJDCalendarGregorian(jd);
                var _JDToCalendar = JDToCalendar(jd, isJulian), year = _JDToCalendar.year, month = _JDToCalendar.month, day = _JDToCalendar.day;
                this.year = year;
                this.month = month;
                this.day = day;
                return this;
            }
        },
        {
            key: "fromJDE",
            value: function fromJDE(jde) {
                this.fromJD(jde);
                var dT = (0, _deltatJsDefault.default).deltaT(this.toYear()) // in seconds
                ;
                this.day -= dT / 86400;
                return this;
            }
        },
        {
            key: "toJDE",
            value: function toJDE() {
                var dT = (0, _deltatJsDefault.default).deltaT(this.toYear()) // in seconds
                ;
                this.day += dT / 86400;
                return this.toJD();
            }
        },
        {
            /**
   * set date to midnight UTC
   */ key: "midnight",
            value: function midnight() {
                this.day = Math.floor(this.day);
                return this;
            }
        },
        {
            /**
   * set date to noon UTC
   */ key: "noon",
            value: function noon() {
                this.day = Math.floor(this.day) + 0.5;
                return this;
            }
        },
        {
            /**
   * @param {Boolean} td - if `true` calendar instance is in TD; date gets converted to UT
   *   true  - `UT = TD - ΔT`
   *   false - `TD = UT + ΔT`
   */ key: "deltaT",
            value: function deltaT(td) {
                var dT = (0, _deltatJsDefault.default).deltaT(this.toYear()) // in seconds
                ;
                if (td) this.day -= dT / 86400;
                else this.day += dT / 86400;
                return this;
            }
        },
        {
            key: "dayOfWeek",
            value: function dayOfWeek() {
                return DayOfWeek(this.toJD());
            }
        },
        {
            key: "dayOfYear",
            value: function dayOfYear() {
                if (this.isGregorian()) return DayOfYearGregorian(this.year, this.month, this.day);
                else return DayOfYearJulian(this.year, this.month, this.day);
            }
        }
    ]);
    return Calendar;
}();
var CalendarJulian = /*#__PURE__*/ function(Calendar) {
    "use strict";
    (0, _inherits._)(CalendarJulian, Calendar);
    function CalendarJulian() {
        (0, _classCallCheck._)(this, CalendarJulian);
        return (0, _callSuper._)(this, CalendarJulian, arguments);
    }
    (0, _createClass._)(CalendarJulian, [
        {
            key: "toJD",
            value: function toJD() {
                return CalendarJulianToJD(this.year, this.month, this.day);
            }
        },
        {
            key: "fromJD",
            value: function fromJD(jd) {
                var _JDToCalendarJulian = JDToCalendarJulian(jd), year = _JDToCalendarJulian.year, month = _JDToCalendarJulian.month, day = _JDToCalendarJulian.day;
                this.year = year;
                this.month = month;
                this.day = day;
                return this;
            }
        },
        {
            key: "isLeapYear",
            value: function isLeapYear() {
                return LeapYearJulian(this.year);
            }
        },
        {
            key: "dayOfYear",
            value: function dayOfYear() {
                return DayOfYearJulian(this.year, this.month, this.day);
            }
        },
        {
            /**
   * toGregorian converts a Julian calendar date to a year, month, and day
   * in the Gregorian calendar.
   * @returns {CalendarGregorian}
   */ key: "toGregorian",
            value: function toGregorian() {
                var jd = this.toJD();
                return new CalendarGregorian().fromJD(jd);
            }
        }
    ]);
    return CalendarJulian;
}(Calendar);
var CalendarGregorian = /*#__PURE__*/ function(Calendar) {
    "use strict";
    (0, _inherits._)(CalendarGregorian, Calendar);
    function CalendarGregorian() {
        (0, _classCallCheck._)(this, CalendarGregorian);
        return (0, _callSuper._)(this, CalendarGregorian, arguments);
    }
    (0, _createClass._)(CalendarGregorian, [
        {
            key: "toJD",
            value: function toJD() {
                return CalendarGregorianToJD(this.year, this.month, this.day);
            }
        },
        {
            key: "fromJD",
            value: function fromJD(jd) {
                var _JDToCalendarGregorian = JDToCalendarGregorian(jd), year = _JDToCalendarGregorian.year, month = _JDToCalendarGregorian.month, day = _JDToCalendarGregorian.day;
                this.year = year;
                this.month = month;
                this.day = day;
                return this;
            }
        },
        {
            key: "isLeapYear",
            value: function isLeapYear() {
                return LeapYearGregorian(this.year);
            }
        },
        {
            key: "dayOfYear",
            value: function dayOfYear() {
                return DayOfYearGregorian(this.year, this.month, this.day);
            }
        },
        {
            /*
  * toJulian converts a Gregorian calendar date to a year, month, and day
  * in the Julian calendar.
  * @returns {CalendarJulian}
  */ key: "toJulian",
            value: function toJulian() {
                var jd = this.toJD();
                return new CalendarJulian().fromJD(jd);
            }
        }
    ]);
    return CalendarGregorian;
}(Calendar);
function CalendarToJD(y, m, d, isJulian) {
    var b = 0;
    if (m < 3) {
        y--;
        m += 12;
    }
    if (!isJulian) {
        var a = (0, _baseJsDefault.default).floorDiv(y, 100);
        b = 2 - a + (0, _baseJsDefault.default).floorDiv(a, 4);
    }
    // (7.1) p. 61
    var jd = (0, _baseJsDefault.default).floorDiv(36525 * int(y + 4716), 100) + ((0, _baseJsDefault.default).floorDiv(306 * (m + 1), 10) + b) + d - 1524.5;
    return jd;
}
function CalendarGregorianToJD(y, m, d) {
    return CalendarToJD(y, m, d, false);
}
function CalendarJulianToJD(y, m, d) {
    return CalendarToJD(y, m, d, true);
}
function LeapYearJulian(y) {
    return y % 4 === 0;
}
function LeapYearGregorian(y) {
    return y % 4 === 0 && y % 100 !== 0 || y % 400 === 0;
}
function JDToCalendar(jd, isJulian) {
    var _base_modf = (0, _slicedToArray._)((0, _baseJsDefault.default).modf(jd + 0.5), 2), z = _base_modf[0], f = _base_modf[1];
    var a = z;
    if (!isJulian) {
        var \u03B1 = (0, _baseJsDefault.default).floorDiv(z * 100 - 186721625, 3652425);
        a = z + 1 + \u03B1 - (0, _baseJsDefault.default).floorDiv(\u03B1, 4);
    }
    var b = a + 1524;
    var c = (0, _baseJsDefault.default).floorDiv(b * 100 - 12210, 36525);
    var d = (0, _baseJsDefault.default).floorDiv(36525 * c, 100);
    var e = int((0, _baseJsDefault.default).floorDiv((b - d) * 1e4, 306001));
    // compute return values
    var year;
    var month;
    var day = int(b - d) - (0, _baseJsDefault.default).floorDiv(306001 * e, 1e4) + f;
    if (e === 14 || e === 15) month = e - 13;
    else month = e - 1;
    if (month < 3) year = int(c) - 4715;
    else year = int(c) - 4716;
    return {
        year: year,
        month: month,
        day: day
    };
}
function JDToCalendarGregorian(jd) {
    return JDToCalendar(jd, false);
}
function JDToCalendarJulian(jd) {
    return JDToCalendar(jd, true);
}
function isJDCalendarGregorian(jd) {
    return jd >= GREGORIAN0JD;
}
function isCalendarGregorian(year) {
    var month = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, day = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
    return year > 1582 || year === 1582 && month > 10 || year === 1582 && month === 10 && day >= 15;
}
function JDToDate(jd) {
    return new CalendarGregorian().fromJD(jd).toDate();
}
function DateToJD(date) {
    return new CalendarGregorian().fromDate(date).toJD();
}
function JDEToDate(jde) {
    return new CalendarGregorian().fromJDE(jde).toDate();
}
function DateToJDE(date) {
    return new CalendarGregorian().fromDate(date).toJDE();
}
function MJDToJD(mjd) {
    return mjd + (0, _baseJsDefault.default).JMod;
}
function JDToMJD(jd) {
    return jd - (0, _baseJsDefault.default).JMod;
}
function DayOfWeek(jd) {
    return int(jd + 1.5) % 7;
}
function DayOfYearGregorian(y, m, d) {
    return DayOfYear(y, m, int(d), LeapYearGregorian(y));
}
function DayOfYearJulian(y, m, d) {
    return DayOfYear(y, m, int(d), LeapYearJulian(y));
}
function DayOfYear(y, m, d, leap) {
    var k = 0;
    if (leap && m > 1) k = 1;
    return k + DAYS_OF_YEAR[m] + int(d);
}
function DayOfYearToCalendar(n, leap) {
    var month;
    var k = 0;
    if (leap) k = 1;
    for(month = 1; month <= 12; month++)if (k + DAYS_OF_YEAR[month] > n) {
        month = month - 1;
        break;
    }
    var day = n - k - DAYS_OF_YEAR[month];
    return {
        month: month,
        day: day
    };
}
function DayOfYearToCalendarGregorian(year, n) {
    var _DayOfYearToCalendar = DayOfYearToCalendar(n, LeapYearGregorian(year)), month = _DayOfYearToCalendar.month, day = _DayOfYearToCalendar.day;
    return new CalendarGregorian(year, month, day);
}
function DayOfYearToCalendarJulian(year, n) {
    var _DayOfYearToCalendar = DayOfYearToCalendar(n, LeapYearJulian(year)), month = _DayOfYearToCalendar.month, day = _DayOfYearToCalendar.day;
    return new CalendarJulian(year, month, day);
}
function pad(num, len) {
    len = len || 2;
    var neg = num < 0 ? '-' : '';
    num = Math.abs(num);
    var padded = '0000' + num;
    return neg + padded.substr(padded.length - len, len);
}
exports.default = {
    GREGORIAN0JD: GREGORIAN0JD,
    Calendar: Calendar,
    CalendarJulian: CalendarJulian,
    CalendarGregorian: CalendarGregorian,
    CalendarToJD: CalendarToJD,
    CalendarGregorianToJD: CalendarGregorianToJD,
    CalendarJulianToJD: CalendarJulianToJD,
    LeapYearJulian: LeapYearJulian,
    LeapYearGregorian: LeapYearGregorian,
    JDToCalendar: JDToCalendar,
    JDToCalendarGregorian: JDToCalendarGregorian,
    JDToCalendarJulian: JDToCalendarJulian,
    isJDCalendarGregorian: isJDCalendarGregorian,
    isCalendarGregorian: isCalendarGregorian,
    JDToDate: JDToDate,
    DateToJD: DateToJD,
    JDEToDate: JDEToDate,
    DateToJDE: DateToJDE,
    MJDToJD: MJDToJD,
    JDToMJD: JDToMJD,
    DayOfWeek: DayOfWeek,
    DayOfYearGregorian: DayOfYearGregorian,
    DayOfYearJulian: DayOfYearJulian,
    DayOfYear: DayOfYear,
    DayOfYearToCalendar: DayOfYearToCalendar,
    DayOfYearToCalendarGregorian: DayOfYearToCalendarGregorian,
    DayOfYearToCalendarJulian: DayOfYearToCalendarJulian
};

},{"@swc/helpers/_/_call_super":"5oPMc","@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","@swc/helpers/_/_inherits":"j8HRi","@swc/helpers/_/_sliced_to_array":"ha6sq","./base.js":"lEDxD","./sexagesimal.js":"aLUGo","./deltat.js":"7sn4F","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5XjXz":[function(require,module,exports,__globalThis) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module jupiter
 */ /**
 * Jupiter: Chapter 42, Ephemeris for Physical Observations of Jupiter.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Physical computes quantities for physical observations of Jupiter.
 *
 * All angular results in radians.
 *
 * @param {number} jde - Julian ephemeris day
 * @param {Planet} earth
 * @param {Planet} jupiter
 * @return {Array}
 *    {number} DS - Planetocentric declination of the Sun.
 *    {number} DE - Planetocentric declination of the Earth.
 *    {number} ω1 - Longitude of the System I central meridian of the illuminated disk,
 *                  as seen from Earth.
 *    {number} ω2 - Longitude of the System II central meridian of the illuminated disk,
 *                  as seen from Earth.
 *    {number} P -  Geocentric position angle of Jupiter's northern rotation pole.
 */ parcelHelpers.export(exports, "physical", function() {
    return physical;
});
/**
 * Physical2 computes quantities for physical observations of Jupiter.
 *
 * Results are less accurate than with Physical().
 * All angular results in radians.
 *
 * @param {number} jde - Julian ephemeris day
 * @return {Array}
 *    {number} DS - Planetocentric declination of the Sun.
 *    {number} DE - Planetocentric declination of the Earth.
 *    {number} ω1 - Longitude of the System I central meridian of the illuminated disk,
 *                  as seen from Earth.
 *    {number} ω2 - Longitude of the System II central meridian of the illuminated disk,
 *                  as seen from Earth.
 */ parcelHelpers.export(exports, "physical2", function() {
    return physical2;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var _nutationJs = require("./nutation.js");
var _nutationJsDefault = parcelHelpers.interopDefault(_nutationJs);
var _planetpositionJs = require("./planetposition.js"); // eslint-disable-line no-unused-vars
var _planetpositionJsDefault = parcelHelpers.interopDefault(_planetpositionJs);
function physical(jde, earth, jupiter) {
    // Step 1.0
    var d = jde - 2433282.5;
    var T1 = d / (0, _baseJsDefault.default).JulianCentury;
    var p = Math.PI / 180;
    var \u03B10 = 268 * p + 0.1061 * p * T1;
    var \u03B40 = 64.5 * p - 0.0164 * p * T1;
    // Step 2.0
    var W1 = 17.71 * p + 877.90003539 * p * d;
    var W2 = 16.838 * p + 870.27003539 * p * d;
    // Step 3.0
    var pos = earth.position(jde);
    var _ref = [
        pos.lon,
        pos.lat,
        pos.range
    ], l0 = _ref[0], b0 = _ref[1], R = _ref[2];
    var fk5 = (0, _planetpositionJsDefault.default).toFK5(l0, b0, jde);
    l0 = fk5.lon;
    b0 = fk5.lat;
    // Steps 4-7.
    var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(l0), 2), sl0 = _base_sincos[0], cl0 = _base_sincos[1];
    var sb0 = Math.sin(b0);
    var \u0394 = 4.0 // surely better than 0.0
    ;
    var l = 0;
    var b = 0;
    var r = 0;
    var x = 0;
    var y = 0;
    var z = 0;
    var f = function f() {
        var \u03C4 = (0, _baseJsDefault.default).lightTime(\u0394);
        var pos = jupiter.position(jde - \u03C4);
        l = pos.lon;
        b = pos.lat;
        r = pos.range;
        var fk5 = (0, _planetpositionJsDefault.default).toFK5(l, b, jde);
        l = fk5.lon;
        b = fk5.lat;
        var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(b), 2), sb = _base_sincos[0], cb = _base_sincos[1];
        var _base_sincos1 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(l), 2), sl = _base_sincos1[0], cl = _base_sincos1[1];
        // (42.2) p. 289
        x = r * cb * cl - R * cl0;
        y = r * cb * sl - R * sl0;
        z = r * sb - R * sb0;
        // (42.3) p. 289
        \u0394 = Math.sqrt(x * x + y * y + z * z);
    };
    f();
    f();
    // Step 8.0
    var \u03B50 = (0, _nutationJsDefault.default).meanObliquity(jde);
    // Step 9.0
    var _base_sincos1 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03B50), 2), s\u03B50 = _base_sincos1[0], c\u03B50 = _base_sincos1[1];
    var _base_sincos2 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(l), 2), sl = _base_sincos2[0], cl = _base_sincos2[1];
    var _base_sincos3 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(b), 2), sb = _base_sincos3[0], cb = _base_sincos3[1];
    var \u03B1s = Math.atan2(c\u03B50 * sl - s\u03B50 * sb / cb, cl);
    var \u03B4s = Math.asin(c\u03B50 * sb + s\u03B50 * cb * sl);
    // Step 10.0
    var _base_sincos4 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03B4s), 2), s\u03B4s = _base_sincos4[0], c\u03B4s = _base_sincos4[1];
    var _base_sincos5 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03B40), 2), s\u03B40 = _base_sincos5[0], c\u03B40 = _base_sincos5[1];
    var DS = Math.asin(-s\u03B40 * s\u03B4s - c\u03B40 * c\u03B4s * Math.cos(\u03B10 - \u03B1s));
    // Step 11.0
    var u = y * c\u03B50 - z * s\u03B50;
    var v = y * s\u03B50 + z * c\u03B50;
    var \u03B1 = Math.atan2(u, x);
    var \u03B4 = Math.atan(v / Math.hypot(x, u));
    var _base_sincos6 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03B4), 2), s\u03B4 = _base_sincos6[0], c\u03B4 = _base_sincos6[1];
    var _base_sincos7 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03B10 - \u03B1), 2), s\u03B10\u03B1 = _base_sincos7[0], c\u03B10\u03B1 = _base_sincos7[1];
    var \u03B6 = Math.atan2(s\u03B40 * c\u03B4 * c\u03B10\u03B1 - s\u03B4 * c\u03B40, c\u03B4 * s\u03B10\u03B1);
    // Step 12.0
    var DE = Math.asin(-s\u03B40 * s\u03B4 - c\u03B40 * c\u03B4 * Math.cos(\u03B10 - \u03B1));
    // Step 13.0
    var \u03C91 = W1 - \u03B6 - 5.07033 * p * \u0394;
    var \u03C92 = W2 - \u03B6 - 5.02626 * p * \u0394;
    // Step 14.0
    var C = (2 * r * \u0394 + R * R - r * r - \u0394 * \u0394) / (4 * r * \u0394);
    if (Math.sin(l - l0) < 0) C = -C;
    \u03C91 = (0, _baseJsDefault.default).pmod(\u03C91 + C, 2 * Math.PI);
    \u03C92 = (0, _baseJsDefault.default).pmod(\u03C92 + C, 2 * Math.PI);
    // Step 15.0
    var _nutation_nutation = (0, _slicedToArray._)((0, _nutationJsDefault.default).nutation(jde), 2), \u0394\u03C8 = _nutation_nutation[0], \u0394\u03B5 = _nutation_nutation[1];
    var \u03B5 = \u03B50 + \u0394\u03B5;
    // Step 16.0
    var _base_sincos8 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03B5), 2), s\u03B5 = _base_sincos8[0], c\u03B5 = _base_sincos8[1];
    var _base_sincos9 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03B1), 2), s\u03B1 = _base_sincos9[0], c\u03B1 = _base_sincos9[1];
    \u03B1 += 0.005693 * p * (c\u03B1 * cl0 * c\u03B5 + s\u03B1 * sl0) / c\u03B4;
    \u03B4 += 0.005693 * p * (cl0 * c\u03B5 * (s\u03B5 / c\u03B5 * c\u03B4 - s\u03B1 * s\u03B4) + c\u03B1 * s\u03B4 * sl0);
    // Step 17.0
    var t\u03B4 = s\u03B4 / c\u03B4;
    var \u0394\u03B1 = (c\u03B5 + s\u03B5 * s\u03B1 * t\u03B4) * \u0394\u03C8 - c\u03B1 * t\u03B4 * \u0394\u03B5;
    var \u0394\u03B4 = s\u03B5 * c\u03B1 * \u0394\u03C8 + s\u03B1 * \u0394\u03B5;
    var \u03B1\u02B9 = \u03B1 + \u0394\u03B1;
    var \u03B4\u02B9 = \u03B4 + \u0394\u03B4;
    var _base_sincos10 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03B10), 2), s\u03B10 = _base_sincos10[0], c\u03B10 = _base_sincos10[1];
    var t\u03B40 = s\u03B40 / c\u03B40;
    var \u0394\u03B10 = (c\u03B5 + s\u03B5 * s\u03B10 * t\u03B40) * \u0394\u03C8 - c\u03B10 * t\u03B40 * \u0394\u03B5;
    var \u0394\u03B40 = s\u03B5 * c\u03B10 * \u0394\u03C8 + s\u03B10 * \u0394\u03B5;
    var \u03B10\u02B9 = \u03B10 + \u0394\u03B10;
    var \u03B40\u02B9 = \u03B40 + \u0394\u03B40;
    // Step 18.0
    var _base_sincos11 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03B4\u02B9), 2), s\u03B4\u02B9 = _base_sincos11[0], c\u03B4\u02B9 = _base_sincos11[1];
    var _base_sincos12 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03B40\u02B9), 2), s\u03B40\u02B9 = _base_sincos12[0], c\u03B40\u02B9 = _base_sincos12[1];
    var _base_sincos13 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03B10\u02B9 - \u03B1\u02B9), 2), s\u03B10\u02B9\u03B1\u02B9 = _base_sincos13[0], c\u03B10\u02B9\u03B1\u02B9 = _base_sincos13[1];
    // (42.4) p. 290
    var P = Math.atan2(c\u03B40\u02B9 * s\u03B10\u02B9\u03B1\u02B9, s\u03B40\u02B9 * c\u03B4\u02B9 - c\u03B40\u02B9 * s\u03B4\u02B9 * c\u03B10\u02B9\u03B1\u02B9);
    if (P < 0) P += 2 * Math.PI;
    return [
        DS,
        DE,
        \u03C91,
        \u03C92,
        P
    ];
}
function physical2(jde) {
    var d = jde - (0, _baseJsDefault.default).J2000;
    var p = Math.PI / 180;
    var V = 172.74 * p + 0.00111588 * p * d;
    var M = 357.529 * p + 0.9856003 * p * d;
    var sV = Math.sin(V);
    var N = 20.02 * p + 0.0830853 * p * d + 0.329 * p * sV;
    var J = 66.115 * p + 0.9025179 * p * d - 0.329 * p * sV;
    var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(M), 2), sM = _base_sincos[0], cM = _base_sincos[1];
    var _base_sincos1 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(N), 2), sN = _base_sincos1[0], cN = _base_sincos1[1];
    var _base_sincos2 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(2 * M), 2), s2M = _base_sincos2[0], c2M = _base_sincos2[1];
    var _base_sincos3 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(2 * N), 2), s2N = _base_sincos3[0], c2N = _base_sincos3[1];
    var A = 1.915 * p * sM + 0.02 * p * s2M;
    var B = 5.555 * p * sN + 0.168 * p * s2N;
    var K = J + A - B;
    var R = 1.00014 - 0.01671 * cM - 0.00014 * c2M;
    var r = 5.20872 - 0.25208 * cN - 0.00611 * c2N;
    var _base_sincos4 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(K), 2), sK = _base_sincos4[0], cK = _base_sincos4[1];
    var \u0394 = Math.sqrt(r * r + R * R - 2 * r * R * cK);
    var \u03C8 = Math.asin(R / \u0394 * sK);
    var dd = d - \u0394 / 173;
    var \u03C91 = 210.98 * p + 877.8169088 * p * dd + \u03C8 - B;
    var \u03C92 = 187.23 * p + 870.1869088 * p * dd + \u03C8 - B;
    var C = Math.sin(\u03C8 / 2);
    C *= C;
    if (sK > 0) C = -C;
    \u03C91 = (0, _baseJsDefault.default).pmod(\u03C91 + C, 2 * Math.PI);
    \u03C92 = (0, _baseJsDefault.default).pmod(\u03C92 + C, 2 * Math.PI);
    var \u03BB = 34.35 * p + 0.083091 * p * d + 0.329 * p * sV + B;
    var DS = 3.12 * p * Math.sin(\u03BB + 42.8 * p);
    var DE = DS - 2.22 * p * Math.sin(\u03C8) * Math.cos(\u03BB + 22 * p) - 1.3 * p * (r - \u0394) / \u0394 * Math.sin(\u03BB - 100.5 * p);
    return [
        DS,
        DE,
        \u03C91,
        \u03C92
    ];
}
exports.default = {
    physical: physical,
    physical2: physical2
};

},{"@swc/helpers/_/_sliced_to_array":"ha6sq","./base.js":"lEDxD","./nutation.js":"jqV8z","./planetposition.js":"8l87z","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"24N44":[function(require,module,exports,__globalThis) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module jupitermoons
 */ /**
 * Jupitermoons: Chapter 44, Positions of the Satellites of Jupiter.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "io", function() {
    return io;
});
parcelHelpers.export(exports, "europa", function() {
    return europa;
});
parcelHelpers.export(exports, "ganymede", function() {
    return ganymede;
});
parcelHelpers.export(exports, "callisto", function() {
    return callisto;
});
/**
 * Positions computes positions of moons of Jupiter.
 *
 * Returned coordinates are in units of Jupiter radii.
 *
 * @param {Number} jde - Julian ephemeris day
 * @return {Array} x, y - coordinates of the 4 Satellites of jupiter
 */ parcelHelpers.export(exports, "positions", function() {
    return positions;
});
/**
 * Positions computes positions of moons of Jupiter.
 *
 * High accuracy method based on theory "E5"  Results returned in
 * argument pos, which must not be undefined.  Returned coordinates in units
 * of Jupiter radii.
 *
 * @param {Number} jde - Julian ephemeris day
 * @param {Planet} earth - VSOP87 Planet earth
 * @param {Planet} jupiter - VSOP87 Planet jupiter
 * @param {Array} [pos] - reference to array of positions (same as return value)
 * @return {Array} x, y - coordinates of the 4 Satellites of jupiter
 */ parcelHelpers.export(exports, "e5", function() {
    return e5;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var _planetelementsJs = require("./planetelements.js");
var _planetelementsJsDefault = parcelHelpers.interopDefault(_planetelementsJs);
var _solarJs = require("./solar.js");
var _solarJsDefault = parcelHelpers.interopDefault(_solarJs);
var _planetpositionJs = require("./planetposition.js"); // eslint-disable-line no-unused-vars
var io = 0;
var europa = 1;
var ganymede = 2;
var callisto = 3;
var k = [
    17295,
    21819,
    27558,
    36548
];
/**
 * XY used for returning coordinates of moons.
 * @param {number} x - in units of Jupiter radii
 * @param {number} y - in units of Jupiter radii
 */ function XY(x, y) {
    this.x = x;
    this.y = y;
}
function positions(jde) {
    var d = jde - (0, _baseJsDefault.default).J2000;
    var p = Math.PI / 180;
    var V = 172.74 * p + 0.00111588 * p * d;
    var M = 357.529 * p + 0.9856003 * p * d;
    var sV = Math.sin(V);
    var N = 20.02 * p + 0.0830853 * p * d + 0.329 * p * sV;
    var J = 66.115 * p + 0.9025179 * p * d - 0.329 * p * sV;
    var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(M), 2), sM = _base_sincos[0], cM = _base_sincos[1];
    var _base_sincos1 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(N), 2), sN = _base_sincos1[0], cN = _base_sincos1[1];
    var _base_sincos2 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(2 * M), 2), s2M = _base_sincos2[0], c2M = _base_sincos2[1];
    var _base_sincos3 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(2 * N), 2), s2N = _base_sincos3[0], c2N = _base_sincos3[1];
    var A = 1.915 * p * sM + 0.02 * p * s2M;
    var B = 5.555 * p * sN + 0.168 * p * s2N;
    var K = J + A - B;
    var R = 1.00014 - 0.01671 * cM - 0.00014 * c2M;
    var r = 5.20872 - 0.25208 * cN - 0.00611 * c2N;
    var _base_sincos4 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(K), 2), sK = _base_sincos4[0], cK = _base_sincos4[1];
    var \u0394 = Math.sqrt(r * r + R * R - 2 * r * R * cK);
    var \u03C8 = Math.asin(R / \u0394 * sK);
    var \u03BB = 34.35 * p + 0.083091 * p * d + 0.329 * p * sV + B;
    var DS = 3.12 * p * Math.sin(\u03BB + 42.8 * p);
    var DE = DS - 2.22 * p * Math.sin(\u03C8) * Math.cos(\u03BB + 22 * p) - 1.3 * p * (r - \u0394) / \u0394 * Math.sin(\u03BB - 100.5 * p);
    var dd = d - \u0394 / 173;
    var u1 = 163.8069 * p + 203.4058646 * p * dd + \u03C8 - B;
    var u2 = 358.414 * p + 101.2916335 * p * dd + \u03C8 - B;
    var u3 = 5.7176 * p + 50.234518 * p * dd + \u03C8 - B;
    var u4 = 224.8092 * p + 21.48798 * p * dd + \u03C8 - B;
    var G = 331.18 * p + 50.310482 * p * dd;
    var H = 87.45 * p + 21.569231 * p * dd;
    var _base_sincos5 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(2 * (u1 - u2)), 2), s212 = _base_sincos5[0], c212 = _base_sincos5[1];
    var _base_sincos6 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(2 * (u2 - u3)), 2), s223 = _base_sincos6[0], c223 = _base_sincos6[1];
    var _base_sincos7 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(G), 2), sG = _base_sincos7[0], cG = _base_sincos7[1];
    var _base_sincos8 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(H), 2), sH = _base_sincos8[0], cH = _base_sincos8[1];
    var c1 = 0.473 * p * s212;
    var c2 = 1.065 * p * s223;
    var c3 = 0.165 * p * sG;
    var c4 = 0.843 * p * sH;
    var r1 = 5.9057 - 0.0244 * c212;
    var r2 = 9.3966 - 0.0882 * c223;
    var r3 = 14.9883 - 0.0216 * cG;
    var r4 = 26.3627 - 0.1939 * cH;
    var sDE = Math.sin(DE);
    var xy = function xy(u, r) {
        var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(u), 2), su = _base_sincos[0], cu = _base_sincos[1];
        return new XY(r * su, -r * cu * sDE);
    };
    return [
        xy(u1 + c1, r1),
        xy(u2 + c2, r2),
        xy(u3 + c3, r3),
        xy(u4 + c4, r4)
    ];
}
function e5(jde, earth, jupiter, pos) {
    pos = pos || new Array(4);
    // variables assigned in following block
    var \u03BB0, \u03B20, t;
    var \u0394 = 5.0;
    (function() {
        var _solar_trueVSOP87 = (0, _solarJsDefault.default).trueVSOP87(earth, jde), lon = _solar_trueVSOP87.lon, lat = _solar_trueVSOP87.lat, range = _solar_trueVSOP87.range;
        var _ref = [
            lon,
            lat,
            range
        ], s = _ref[0], \u03B2 = _ref[1], R = _ref[2];
        var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(s), 2), ss = _base_sincos[0], cs = _base_sincos[1];
        var s\u03B2 = Math.sin(\u03B2);
        var \u03C4 = (0, _baseJsDefault.default).lightTime(\u0394);
        var x = 0;
        var y = 0;
        var z = 0;
        function f() {
            var _jupiter_position = jupiter.position(jde - \u03C4), lon = _jupiter_position.lon, lat = _jupiter_position.lat, range = _jupiter_position.range;
            var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(lon), 2), sl = _base_sincos[0], cl = _base_sincos[1];
            var _base_sincos1 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(lat), 2), sb = _base_sincos1[0], cb = _base_sincos1[1];
            x = range * cb * cl + R * cs;
            y = range * cb * sl + R * ss;
            z = range * sb + R * s\u03B2;
            \u0394 = Math.sqrt(x * x + y * y + z * z);
            \u03C4 = (0, _baseJsDefault.default).lightTime(\u0394);
        }
        f();
        f();
        \u03BB0 = Math.atan2(y, x);
        \u03B20 = Math.atan(z / Math.hypot(x, y));
        t = jde - 2443000.5 - \u03C4;
    })();
    var p = Math.PI / 180;
    var l1 = 106.07719 * p + 203.48895579 * p * t;
    var l2 = 175.73161 * p + 101.374724735 * p * t;
    var l3 = 120.55883 * p + 50.317609207 * p * t;
    var l4 = 84.44459 * p + 21.571071177 * p * t;
    var \u03C01 = 97.0881 * p + 0.16138586 * p * t;
    var \u03C02 = 154.8663 * p + 0.04726307 * p * t;
    var \u03C03 = 188.184 * p + 0.00712734 * p * t;
    var \u03C04 = 335.2868 * p + 0.00184 * p * t;
    var \u03C91 = 312.3346 * p - 0.13279386 * p * t;
    var \u03C92 = 100.4411 * p - 0.03263064 * p * t;
    var \u03C93 = 119.1942 * p - 0.00717703 * p * t;
    var \u03C94 = 322.6186 * p - 0.00175934 * p * t;
    var \u0393 = 0.33033 * p * Math.sin(163.679 * p + 0.0010512 * p * t) + 0.03439 * p * Math.sin(34.486 * p - 0.0161731 * p * t);
    var \u03A6\u03BB = 199.6766 * p + 0.1737919 * p * t;
    var \u03C8 = 316.5182 * p - 0.00000208 * p * t;
    var G = 30.23756 * p + 0.0830925701 * p * t + \u0393;
    var G\u02B9 = 31.97853 * p + 0.0334597339 * p * t;
    var \u03A0 = 13.469942 * p;
    var \u03A31 = 0.47259 * p * Math.sin(2 * (l1 - l2)) + -0.03478 * p * Math.sin(\u03C03 - \u03C04) + 0.01081 * p * Math.sin(l2 - 2 * l3 + \u03C03) + 0.00738 * p * Math.sin(\u03A6\u03BB) + 0.00713 * p * Math.sin(l2 - 2 * l3 + \u03C02) + -0.00674 * p * Math.sin(\u03C01 + \u03C03 - 2 * \u03A0 - 2 * G) + 0.00666 * p * Math.sin(l2 - 2 * l3 + \u03C04) + 0.00445 * p * Math.sin(l1 - \u03C03) + -0.00354 * p * Math.sin(l1 - l2) + -0.00317 * p * Math.sin(2 * \u03C8 - 2 * \u03A0) + 0.00265 * p * Math.sin(l1 - \u03C04) + -0.00186 * p * Math.sin(G) + 0.00162 * p * Math.sin(\u03C02 - \u03C03) + 0.00158 * p * Math.sin(4 * (l1 - l2)) + -0.00155 * p * Math.sin(l1 - l3) + -0.00138 * p * Math.sin(\u03C8 + \u03C93 - 2 * \u03A0 - 2 * G) + -0.00115 * p * Math.sin(2 * (l1 - 2 * l2 + \u03C92)) + 0.00089 * p * Math.sin(\u03C02 - \u03C04) + 0.00085 * p * Math.sin(l1 + \u03C03 - 2 * \u03A0 - 2 * G) + 0.00083 * p * Math.sin(\u03C92 - \u03C93) + 0.00053 * p * Math.sin(\u03C8 - \u03C92);
    var \u03A32 = 1.06476 * p * Math.sin(2 * (l2 - l3)) + 0.04256 * p * Math.sin(l1 - 2 * l2 + \u03C03) + 0.03581 * p * Math.sin(l2 - \u03C03) + 0.02395 * p * Math.sin(l1 - 2 * l2 + \u03C04) + 0.01984 * p * Math.sin(l2 - \u03C04) + -0.01778 * p * Math.sin(\u03A6\u03BB) + 0.01654 * p * Math.sin(l2 - \u03C02) + 0.01334 * p * Math.sin(l2 - 2 * l3 + \u03C02) + 0.01294 * p * Math.sin(\u03C03 - \u03C04) + -0.01142 * p * Math.sin(l2 - l3) + -0.01057 * p * Math.sin(G) + -0.00775 * p * Math.sin(2 * (\u03C8 - \u03A0)) + 0.00524 * p * Math.sin(2 * (l1 - l2)) + -0.0046 * p * Math.sin(l1 - l3) + 0.00316 * p * Math.sin(\u03C8 - 2 * G + \u03C93 - 2 * \u03A0) + -0.00203 * p * Math.sin(\u03C01 + \u03C03 - 2 * \u03A0 - 2 * G) + 0.00146 * p * Math.sin(\u03C8 - \u03C93) + -0.00145 * p * Math.sin(2 * G) + 0.00125 * p * Math.sin(\u03C8 - \u03C94) + -0.00115 * p * Math.sin(l1 - 2 * l3 + \u03C03) + -0.00094 * p * Math.sin(2 * (l2 - \u03C92)) + 0.00086 * p * Math.sin(2 * (l1 - 2 * l2 + \u03C92)) + -0.00086 * p * Math.sin(5 * G\u02B9 - 2 * G + 52.225 * p) + -0.00078 * p * Math.sin(l2 - l4) + -0.00064 * p * Math.sin(3 * l3 - 7 * l4 + 4 * \u03C04) + 0.00064 * p * Math.sin(\u03C01 - \u03C04) + -0.00063 * p * Math.sin(l1 - 2 * l3 + \u03C04) + 0.00058 * p * Math.sin(\u03C93 - \u03C94) + 0.00056 * p * Math.sin(2 * (\u03C8 - \u03A0 - G)) + 0.00056 * p * Math.sin(2 * (l2 - l4)) + 0.00055 * p * Math.sin(2 * (l1 - l3)) + 0.00052 * p * Math.sin(3 * l3 - 7 * l4 + \u03C03 + 3 * \u03C04) + -0.00043 * p * Math.sin(l1 - \u03C03) + 0.00041 * p * Math.sin(5 * (l2 - l3)) + 0.00041 * p * Math.sin(\u03C04 - \u03A0) + 0.00032 * p * Math.sin(\u03C92 - \u03C93) + 0.00032 * p * Math.sin(2 * (l3 - G - \u03A0));
    var \u03A33 = 0.1649 * p * Math.sin(l3 - \u03C03) + 0.09081 * p * Math.sin(l3 - \u03C04) + -0.06907 * p * Math.sin(l2 - l3) + 0.03784 * p * Math.sin(\u03C03 - \u03C04) + 0.01846 * p * Math.sin(2 * (l3 - l4)) + -0.0134 * p * Math.sin(G) + -0.01014 * p * Math.sin(2 * (\u03C8 - \u03A0)) + 0.00704 * p * Math.sin(l2 - 2 * l3 + \u03C03) + -0.0062 * p * Math.sin(l2 - 2 * l3 + \u03C02) + -0.00541 * p * Math.sin(l3 - l4) + 0.00381 * p * Math.sin(l2 - 2 * l3 + \u03C04) + 0.00235 * p * Math.sin(\u03C8 - \u03C93) + 0.00198 * p * Math.sin(\u03C8 - \u03C94) + 0.00176 * p * Math.sin(\u03A6\u03BB) + 0.0013 * p * Math.sin(3 * (l3 - l4)) + 0.00125 * p * Math.sin(l1 - l3) + -0.00119 * p * Math.sin(5 * G\u02B9 - 2 * G + 52.225 * p) + 0.00109 * p * Math.sin(l1 - l2) + -0.001 * p * Math.sin(3 * l3 - 7 * l4 + 4 * \u03C04) + 0.00091 * p * Math.sin(\u03C93 - \u03C94) + 0.0008 * p * Math.sin(3 * l3 - 7 * l4 + \u03C03 + 3 * \u03C04) + -0.00075 * p * Math.sin(2 * l2 - 3 * l3 + \u03C03) + 0.00072 * p * Math.sin(\u03C01 + \u03C03 - 2 * \u03A0 - 2 * G) + 0.00069 * p * Math.sin(\u03C04 - \u03A0) + -0.00058 * p * Math.sin(2 * l3 - 3 * l4 + \u03C04) + -0.00057 * p * Math.sin(l3 - 2 * l4 + \u03C04) + 0.00056 * p * Math.sin(l3 + \u03C03 - 2 * \u03A0 - 2 * G) + -0.00052 * p * Math.sin(l2 - 2 * l3 + \u03C01) + -0.0005 * p * Math.sin(\u03C02 - \u03C03) + 0.00048 * p * Math.sin(l3 - 2 * l4 + \u03C03) + -0.00045 * p * Math.sin(2 * l2 - 3 * l3 + \u03C04) + -0.00041 * p * Math.sin(\u03C02 - \u03C04) + -0.00038 * p * Math.sin(2 * G) + -0.00037 * p * Math.sin(\u03C03 - \u03C04 + \u03C93 - \u03C94) + -0.00032 * p * Math.sin(3 * l3 - 7 * l4 + 2 * \u03C03 + 2 * \u03C04) + 0.0003 * p * Math.sin(4 * (l3 - l4)) + 0.00029 * p * Math.sin(l3 + \u03C04 - 2 * \u03A0 - 2 * G) + -0.00028 * p * Math.sin(\u03C93 + \u03C8 - 2 * \u03A0 - 2 * G) + 0.00026 * p * Math.sin(l3 - \u03A0 - G) + 0.00024 * p * Math.sin(l2 - 3 * l3 + 2 * l4) + 0.00021 * p * Math.sin(2 * (l3 - \u03A0 - G)) + -0.00021 * p * Math.sin(l3 - \u03C02) + 0.00017 * p * Math.sin(2 * (l3 - \u03C03));
    var \u03A34 = 0.84287 * p * Math.sin(l4 - \u03C04) + 0.03431 * p * Math.sin(\u03C04 - \u03C03) + -0.03305 * p * Math.sin(2 * (\u03C8 - \u03A0)) + -0.03211 * p * Math.sin(G) + -0.01862 * p * Math.sin(l4 - \u03C03) + 0.01186 * p * Math.sin(\u03C8 - \u03C94) + 0.00623 * p * Math.sin(l4 + \u03C04 - 2 * G - 2 * \u03A0) + 0.00387 * p * Math.sin(2 * (l4 - \u03C04)) + -0.00284 * p * Math.sin(5 * G\u02B9 - 2 * G + 52.225 * p) + -0.00234 * p * Math.sin(2 * (\u03C8 - \u03C04)) + -0.00223 * p * Math.sin(l3 - l4) + -0.00208 * p * Math.sin(l4 - \u03A0) + 0.00178 * p * Math.sin(\u03C8 + \u03C94 - 2 * \u03C04) + 0.00134 * p * Math.sin(\u03C04 - \u03A0) + 0.00125 * p * Math.sin(2 * (l4 - G - \u03A0)) + -0.00117 * p * Math.sin(2 * G) + -0.00112 * p * Math.sin(2 * (l3 - l4)) + 0.00107 * p * Math.sin(3 * l3 - 7 * l4 + 4 * \u03C04) + 0.00102 * p * Math.sin(l4 - G - \u03A0) + 0.00096 * p * Math.sin(2 * l4 - \u03C8 - \u03C94) + 0.00087 * p * Math.sin(2 * (\u03C8 - \u03C94)) + -0.00085 * p * Math.sin(3 * l3 - 7 * l4 + \u03C03 + 3 * \u03C04) + 0.00085 * p * Math.sin(l3 - 2 * l4 + \u03C04) + -0.00081 * p * Math.sin(2 * (l4 - \u03C8)) + 0.00071 * p * Math.sin(l4 + \u03C04 - 2 * \u03A0 - 3 * G) + 0.00061 * p * Math.sin(l1 - l4) + -0.00056 * p * Math.sin(\u03C8 - \u03C93) + -0.00054 * p * Math.sin(l3 - 2 * l4 + \u03C03) + 0.00051 * p * Math.sin(l2 - l4) + 0.00042 * p * Math.sin(2 * (\u03C8 - G - \u03A0)) + 0.00039 * p * Math.sin(2 * (\u03C04 - \u03C94)) + 0.00036 * p * Math.sin(\u03C8 + \u03A0 - \u03C04 - \u03C94) + 0.00035 * p * Math.sin(2 * G\u02B9 - G + 188.37 * p) + -0.00035 * p * Math.sin(l4 - \u03C04 + 2 * \u03A0 - 2 * \u03C8) + -0.00032 * p * Math.sin(l4 + \u03C04 - 2 * \u03A0 - G) + 0.0003 * p * Math.sin(2 * G\u02B9 - 2 * G + 149.15 * p) + 0.00029 * p * Math.sin(3 * l3 - 7 * l4 + 2 * \u03C03 + 2 * \u03C04) + 0.00028 * p * Math.sin(l4 - \u03C04 + 2 * \u03C8 - 2 * \u03A0) + -0.00028 * p * Math.sin(2 * (l4 - \u03C94)) + -0.00027 * p * Math.sin(\u03C03 - \u03C04 + \u03C93 - \u03C94) + -0.00026 * p * Math.sin(5 * G\u02B9 - 3 * G + 188.37 * p) + 0.00025 * p * Math.sin(\u03C94 - \u03C93) + -0.00025 * p * Math.sin(l2 - 3 * l3 + 2 * l4) + -0.00023 * p * Math.sin(3 * (l3 - l4)) + 0.00021 * p * Math.sin(2 * l4 - 2 * \u03A0 - 3 * G) + -0.00021 * p * Math.sin(2 * l3 - 3 * l4 + \u03C04) + 0.00019 * p * Math.sin(l4 - \u03C04 - G) + -0.00019 * p * Math.sin(2 * l4 - \u03C03 - \u03C04) + -0.00018 * p * Math.sin(l4 - \u03C04 + G) + -0.00016 * p * Math.sin(l4 + \u03C03 - 2 * \u03A0 - 2 * G);
    var L1 = l1 + \u03A31;
    var L2 = l2 + \u03A32;
    var L3 = l3 + \u03A33;
    var L4 = l4 + \u03A34;
    // variables assigned in following block
    var I;
    var X = new Array(5).fill(0);
    var Y = new Array(5).fill(0);
    var Z = new Array(5).fill(0);
    var R;
    (function() {
        var L = [
            L1,
            L2,
            L3,
            L4
        ];
        var B = [
            Math.atan(0.0006393 * Math.sin(L1 - \u03C91) + 0.0001825 * Math.sin(L1 - \u03C92) + 0.0000329 * Math.sin(L1 - \u03C93) + -0.0000311 * Math.sin(L1 - \u03C8) + 0.0000093 * Math.sin(L1 - \u03C94) + 0.0000075 * Math.sin(3 * L1 - 4 * l2 - 1.9927 * \u03A31 + \u03C92) + 0.0000046 * Math.sin(L1 + \u03C8 - 2 * \u03A0 - 2 * G)),
            Math.atan(0.0081004 * Math.sin(L2 - \u03C92) + 0.0004512 * Math.sin(L2 - \u03C93) + -0.0003284 * Math.sin(L2 - \u03C8) + 0.0001160 * Math.sin(L2 - \u03C94) + 0.0000272 * Math.sin(l1 - 2 * l3 + 1.0146 * \u03A32 + \u03C92) + -0.0000144 * Math.sin(L2 - \u03C91) + 0.0000143 * Math.sin(L2 + \u03C8 - 2 * \u03A0 - 2 * G) + 0.0000035 * Math.sin(L2 - \u03C8 + G) + -0.0000028 * Math.sin(l1 - 2 * l3 + 1.0146 * \u03A32 + \u03C93)),
            Math.atan(0.0032402 * Math.sin(L3 - \u03C93) + -0.0016911 * Math.sin(L3 - \u03C8) + 0.0006847 * Math.sin(L3 - \u03C94) + -0.0002797 * Math.sin(L3 - \u03C92) + 0.0000321 * Math.sin(L3 + \u03C8 - 2 * \u03A0 - 2 * G) + 0.0000051 * Math.sin(L3 - \u03C8 + G) + -0.0000045 * Math.sin(L3 - \u03C8 - G) + -0.0000045 * Math.sin(L3 + \u03C8 - 2 * \u03A0) + 0.0000037 * Math.sin(L3 + \u03C8 - 2 * \u03A0 - 3 * G) + 0.000003 * Math.sin(2 * l2 - 3 * L3 + 4.03 * \u03A33 + \u03C92) + -0.0000021 * Math.sin(2 * l2 - 3 * L3 + 4.03 * \u03A33 + \u03C93)),
            Math.atan(-0.0076579 * Math.sin(L4 - \u03C8) + 0.0044134 * Math.sin(L4 - \u03C94) + -0.0005112 * Math.sin(L4 - \u03C93) + 0.0000773 * Math.sin(L4 + \u03C8 - 2 * \u03A0 - 2 * G) + 0.0000104 * Math.sin(L4 - \u03C8 + G) + -0.0000102 * Math.sin(L4 - \u03C8 - G) + 0.0000088 * Math.sin(L4 + \u03C8 - 2 * \u03A0 - 3 * G) + -0.0000038 * Math.sin(L4 + \u03C8 - 2 * \u03A0 - G))
        ];
        R = [
            5.90569 * (1 + -0.0041339 * Math.cos(2 * (l1 - l2)) + -0.0000387 * Math.cos(l1 - \u03C03) + -0.0000214 * Math.cos(l1 - \u03C04) + 0.000017 * Math.cos(l1 - l2) + -0.0000131 * Math.cos(4 * (l1 - l2)) + 0.0000106 * Math.cos(l1 - l3) + -0.0000066 * Math.cos(l1 + \u03C03 - 2 * \u03A0 - 2 * G)),
            9.39657 * (1 + 0.0093848 * Math.cos(l1 - l2) + -0.0003116 * Math.cos(l2 - \u03C03) + -0.0001744 * Math.cos(l2 - \u03C04) + -0.0001442 * Math.cos(l2 - \u03C02) + 0.0000553 * Math.cos(l2 - l3) + 0.0000523 * Math.cos(l1 - l3) + -0.000029 * Math.cos(2 * (l1 - l2)) + 0.0000164 * Math.cos(2 * (l2 - \u03C92)) + 0.0000107 * Math.cos(l1 - 2 * l3 + \u03C03) + -0.0000102 * Math.cos(l2 - \u03C01) + -0.0000091 * Math.cos(2 * (l1 - l3))),
            14.98832 * (1 + -0.0014388 * Math.cos(l3 - \u03C03) + -0.0007917 * Math.cos(l3 - \u03C04) + 0.0006342 * Math.cos(l2 - l3) + -0.0001761 * Math.cos(2 * (l3 - l4)) + 0.0000294 * Math.cos(l3 - l4) + -0.0000156 * Math.cos(3 * (l3 - l4)) + 0.0000156 * Math.cos(l1 - l3) + -0.0000153 * Math.cos(l1 - l2) + 0.000007 * Math.cos(2 * l2 - 3 * l3 + \u03C03) + -0.0000051 * Math.cos(l3 + \u03C03 - 2 * \u03A0 - 2 * G)),
            26.36273 * (1 + -0.0073546 * Math.cos(l4 - \u03C04) + 0.0001621 * Math.cos(l4 - \u03C03) + 0.0000974 * Math.cos(l3 - l4) + -0.0000543 * Math.cos(l4 + \u03C04 - 2 * \u03A0 - 2 * G) + -0.0000271 * Math.cos(2 * (l4 - \u03C04)) + 0.0000182 * Math.cos(l4 - \u03A0) + 0.0000177 * Math.cos(2 * (l3 - l4)) + -0.0000167 * Math.cos(2 * l4 - \u03C8 - \u03C94) + 0.0000167 * Math.cos(\u03C8 - \u03C94) + -0.0000155 * Math.cos(2 * (l4 - \u03A0 - G)) + 0.0000142 * Math.cos(2 * (l4 - \u03C8)) + 0.0000105 * Math.cos(l1 - l4) + 0.0000092 * Math.cos(l2 - l4) + -0.0000089 * Math.cos(l4 - \u03A0 - G) + -0.0000062 * Math.cos(l4 + \u03C04 - 2 * \u03A0 - 3 * G) + 0.0000048 * Math.cos(2 * (l4 - \u03C94)))
        ];
        // p. 311
        var T0 = (jde - 2433282.423) / (0, _baseJsDefault.default).JulianCentury;
        var P = (1.3966626 * p + 0.0003088 * p * T0) * T0;
        for(var i in L)L[i] += P;
        \u03C8 += P;
        var T = (jde - (0, _baseJsDefault.default).J1900) / (0, _baseJsDefault.default).JulianCentury;
        I = 3.120262 * p + 0.0006 * p * T;
        for(var i1 in L){
            var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(L[i1] - \u03C8), 2), sL\u03C8 = _base_sincos[0], cL\u03C8 = _base_sincos[1];
            var _base_sincos1 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(B[i1]), 2), sB = _base_sincos1[0], cB = _base_sincos1[1];
            X[i1] = R[i1] * cL\u03C8 * cB;
            Y[i1] = R[i1] * sL\u03C8 * cB;
            Z[i1] = R[i1] * sB;
        }
    })();
    Z[4] = 1;
    // p. 312
    var A = new Array(5).fill(0);
    var B = new Array(5).fill(0);
    var C = new Array(5).fill(0);
    var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(I), 2), sI = _base_sincos[0], cI = _base_sincos[1];
    var \u03A9 = (0, _planetelementsJsDefault.default).node((0, _planetelementsJsDefault.default).jupiter, jde);
    var _base_sincos1 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03A9), 2), s\u03A9 = _base_sincos1[0], c\u03A9 = _base_sincos1[1];
    var _base_sincos2 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03C8 - \u03A9), 2), s\u03A6 = _base_sincos2[0], c\u03A6 = _base_sincos2[1];
    var _base_sincos3 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos((0, _planetelementsJsDefault.default).inc((0, _planetelementsJsDefault.default).jupiter, jde)), 2), si = _base_sincos3[0], ci = _base_sincos3[1];
    var _base_sincos4 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03BB0), 2), s\u03BB0 = _base_sincos4[0], c\u03BB0 = _base_sincos4[1];
    var _base_sincos5 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03B20), 2), s\u03B20 = _base_sincos5[0], c\u03B20 = _base_sincos5[1];
    for(var i in A){
        var a0 = void 0;
        // step 1
        var a = X[i];
        var b = Y[i] * cI - Z[i] * sI;
        var c = Y[i] * sI + Z[i] * cI;
        // step 2
        a0 = a * c\u03A6 - b * s\u03A6;
        b = a * s\u03A6 + b * c\u03A6;
        a = a0;
        // step 3
        var b0 = b * ci - c * si;
        c = b * si + c * ci;
        b = b0;
        // step 4
        a0 = a * c\u03A9 - b * s\u03A9;
        b = a * s\u03A9 + b * c\u03A9;
        a = a0;
        // step 5
        a0 = a * s\u03BB0 - b * c\u03BB0;
        b = a * c\u03BB0 + b * s\u03BB0;
        a = a0;
        // step 6
        A[i] = a;
        B[i] = c * s\u03B20 + b * c\u03B20;
        C[i] = c * c\u03B20 - b * s\u03B20;
    }
    var _base_sincos6 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(Math.atan2(A[4], C[4])), 2), sD = _base_sincos6[0], cD = _base_sincos6[1];
    // p. 313
    for(var i1 = 0; i1 < 4; i1++){
        var x = A[i1] * cD - C[i1] * sD;
        var y = A[i1] * sD + C[i1] * cD;
        var z = B[i1];
        // differential light time
        var d = x / R[i1];
        x += Math.abs(z) / k[i1] * Math.sqrt(1 - d * d);
        // perspective effect
        var W = \u0394 / (\u0394 + z / 2095);
        pos[i1] = new XY(x * W, y * W);
    }
    return pos;
}
exports.default = {
    io: io,
    europa: europa,
    ganymede: ganymede,
    callisto: callisto,
    positions: positions,
    e5: e5
};

},{"@swc/helpers/_/_sliced_to_array":"ha6sq","./base.js":"lEDxD","./planetelements.js":"jVTYS","./solar.js":"d2aLm","./planetposition.js":"8l87z","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jVTYS":[function(require,module,exports,__globalThis) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module planetelements
 */ /**
 * Planetelements: Chapter 31, Elements of Planetary Orbits.
 *
 * Partial:  Only implemented for mean equinox of date.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mercury", function() {
    return mercury;
});
parcelHelpers.export(exports, "venus", function() {
    return venus;
});
parcelHelpers.export(exports, "earth", function() {
    return earth;
});
parcelHelpers.export(exports, "mars", function() {
    return mars;
});
parcelHelpers.export(exports, "jupiter", function() {
    return jupiter;
});
parcelHelpers.export(exports, "saturn", function() {
    return saturn;
});
parcelHelpers.export(exports, "uranus", function() {
    return uranus;
});
parcelHelpers.export(exports, "neptune", function() {
    return neptune;
});
/**
 * Elements contains orbital elements as returned by functions in this package.
 *
 * Some other elements easily derived from these are
 *
 *  Mean Anomolay, M = Lon - Peri
 *  Argument of Perihelion, ω = Peri - Node
 *
 * @param {Number|Object} [lon]  - mean longitude, L
 * @param {Number} [axis] - semimajor axis, a
 * @param {Number} [ecc]  - eccentricity, e
 * @param {Number} [inc]  - inclination, i
 * @param {Number} [node] - longitude of ascending node, Ω
 * @param {Number} [peri] - longitude of perihelion, ϖ (Meeus likes π better)
 */ parcelHelpers.export(exports, "Elements", function() {
    return Elements;
});
/**
 * Mean returns mean orbital elements for a planet
 *
 * Argument p must be a planet const as defined above, argument e is
 * a result parameter.  A valid non-undefined pointer to an Elements struct
 * must be passed in.
 *
 * Results are referenced to mean dynamical ecliptic and equinox of date.
 *
 * Semimajor axis is in AU, angular elements are in radians.
 */ parcelHelpers.export(exports, "mean", function() {
    return mean;
});
/**
 * Inc returns mean inclination for a planet at a date.
 *
 * Result is the same as the Inc field returned by function Mean.  That is,
 * radians, referenced to mean dynamical ecliptic and equinox of date.
 */ parcelHelpers.export(exports, "inc", function() {
    return inc;
});
/**
 * Node returns mean longitude of ascending node for a planet at a date.
 *
 * Result is the same as the Node field returned by function Mean.  That is,
 * radians, referenced to mean dynamical ecliptic and equinox of date.
 */ parcelHelpers.export(exports, "node", function() {
    return node;
});
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var mercury = 'mercury';
var venus = 'venus';
var earth = 'earth';
var mars = 'mars';
var jupiter = 'jupiter';
var saturn = 'saturn';
var uranus = 'uranus';
var neptune = 'neptune';
function Elements(lon, axis, ecc, inc, node, peri) {
    var o = typeof lon === 'object' ? lon : {};
    this.lon = o.lon || lon;
    this.axis = o.axis || axis;
    this.ecc = o.ecc || ecc;
    this.inc = o.inc || inc;
    this.node = o.node || node;
    this.peri = o.peri || peri;
}
/**
 * Table 31.A, p. 212
 */ var cMean = {
    mercury: {
        L: [
            252.250906,
            149474.0722491,
            0.0003035,
            0.000000018
        ],
        a: [
            0.38709831
        ],
        e: [
            0.20563175,
            0.000020407,
            -0.0000000283,
            -0.00000000018
        ],
        i: [
            7.004986,
            0.0018215,
            -0.0000181,
            0.000000056
        ],
        \u03A9: [
            48.330893,
            1.1861883,
            0.00017542,
            0.000000215
        ],
        \u03D6: [
            77.456119,
            1.5564776,
            0.00029544,
            0.000000009
        ]
    },
    venus: {
        L: [
            181.979801,
            58519.2130302,
            0.00031014,
            0.000000015
        ],
        a: [
            0.72332982
        ],
        e: [
            0.00677192,
            -0.000047765,
            0.0000000981,
            0.00000000046
        ],
        i: [
            3.394662,
            0.0010037,
            -0.00000088,
            -0.000000007
        ],
        \u03A9: [
            76.67992,
            0.9011206,
            0.00040618,
            -0.000000093
        ],
        \u03D6: [
            131.563703,
            1.4022288,
            -0.00107618,
            -0.000005678
        ]
    },
    earth: {
        L: [
            100.466457,
            36000.7698278,
            0.00030322,
            0.00000002
        ],
        a: [
            1.000001018
        ],
        e: [
            0.01670863,
            -0.000042037,
            -0.0000001267,
            0.00000000014
        ],
        i: [
            0
        ],
        \u03A9: undefined,
        \u03D6: [
            102.937348,
            1.7195366,
            0.00045688,
            -0.000000018
        ]
    },
    mars: {
        L: [
            355.433,
            19141.6964471,
            0.00031052,
            0.000000016
        ],
        a: [
            1.523679342
        ],
        e: [
            0.09340065,
            0.000090484,
            -0.0000000806,
            -0.00000000025
        ],
        i: [
            1.849726,
            -0.0006011,
            0.00001276,
            -0.000000007
        ],
        \u03A9: [
            49.558093,
            0.7720959,
            0.00001557,
            0.000002267
        ],
        \u03D6: [
            336.060234,
            1.8410449,
            0.00013477,
            0.000000536
        ]
    },
    jupiter: {
        L: [
            34.351519,
            3036.3027748,
            0.0002233,
            0.000000037
        ],
        a: [
            5.202603209,
            0.0000001913
        ],
        e: [
            0.04849793,
            0.000163225,
            -0.0000004714,
            -0.00000000201
        ],
        i: [
            1.303267,
            -0.0054965,
            0.00000466,
            -0.000000002
        ],
        \u03A9: [
            100.464407,
            1.0209774,
            0.00040315,
            0.000000404
        ],
        \u03D6: [
            14.331207,
            1.6126352,
            0.00103042,
            -0.000004464
        ]
    },
    saturn: {
        L: [
            50.077444,
            1223.5110686,
            0.00051908,
            -0.00000003
        ],
        a: [
            9.554909192,
            -0.000002139,
            0.000000004
        ],
        e: [
            0.05554814,
            -0.000346641,
            -0.0000006436,
            0.0000000034
        ],
        i: [
            2.488879,
            -0.0037362,
            -0.00001519,
            0.000000087
        ],
        \u03A9: [
            113.665503,
            0.877088,
            -0.00012176,
            -0.000002249
        ],
        \u03D6: [
            93.057237,
            1.9637613,
            0.00083753,
            0.000004928
        ]
    },
    uranus: {
        L: [
            314.055005,
            429.8640561,
            0.0003039,
            0.000000026
        ],
        a: [
            19.218446062,
            -0.0000000372,
            0.00000000098
        ],
        e: [
            0.04638122,
            -0.000027293,
            0.0000000789,
            0.00000000024
        ],
        i: [
            0.773197,
            0.0007744,
            0.00003749,
            -0.000000092
        ],
        \u03A9: [
            74.005957,
            0.5211278,
            0.00133947,
            0.000018484
        ],
        \u03D6: [
            173.005291,
            1.486379,
            0.00021406,
            0.000000434
        ]
    },
    neptune: {
        L: [
            304.348665,
            219.8833092,
            0.00030882,
            0.000000018
        ],
        a: [
            30.110386869,
            -0.0000001663,
            0.00000000069
        ],
        e: [
            0.00945575,
            0.000006033,
            0,
            -0.00000000005
        ],
        i: [
            1.769953,
            -0.0093082,
            -0.00000708,
            0.000000027
        ],
        \u03A9: [
            131.784057,
            1.1022039,
            0.00025952,
            -0.000000637
        ],
        \u03D6: [
            48.120276,
            1.4262957,
            0.00038434,
            0.00000002
        ]
    }
};
function mean(p, jde, e) {
    var T = (0, _baseJsDefault.default).J2000Century(jde);
    var c = cMean[p];
    e = e || new Elements();
    e.lon = (0, _baseJsDefault.default).pmod((0, _baseJsDefault.default).horner(T, c.L) * Math.PI / 180, 2 * Math.PI);
    e.axis = (0, _baseJsDefault.default).horner(T, c.a);
    e.ecc = (0, _baseJsDefault.default).horner(T, c.e);
    e.inc = (0, _baseJsDefault.default).horner(T, c.i) * Math.PI / 180;
    e.node = (0, _baseJsDefault.default).horner(T, c.\u03A9) * Math.PI / 180;
    e.peri = (0, _baseJsDefault.default).horner(T, c.\u03D6) * Math.PI / 180;
    return e;
}
function inc(p, jde) {
    return (0, _baseJsDefault.default).horner((0, _baseJsDefault.default).J2000Century(jde), cMean[p].i) * Math.PI / 180;
}
function node(p, jde) {
    return (0, _baseJsDefault.default).horner((0, _baseJsDefault.default).J2000Century(jde), cMean[p].\u03A9) * Math.PI / 180;
}
exports.default = {
    mercury: mercury,
    venus: venus,
    earth: earth,
    mars: mars,
    jupiter: jupiter,
    saturn: saturn,
    uranus: uranus,
    neptune: neptune,
    Elements: Elements,
    mean: mean,
    inc: inc,
    node: node
};

},{"./base.js":"lEDxD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8Z5Fc":[function(require,module,exports,__globalThis) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module line
 */ /**
 * Line: Chapter 19, Bodies in Straight Line
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Time computes the time at which a moving body is on a straight line (great
 * circle) between two fixed points, such as stars.
 *
 * Coordinates may be right ascensions and declinations or longitudes and
 * latitudes.  Fixed points are r1, d1, r2, d2.  Moving body is an ephemeris
 * of 5 rows, r3, d3, starting at time t1 and ending at time t5.  Time scale
 * is arbitrary.
 *
 * @throws Error
 * @param {Number} r1 - right ascension Coordinate 1
 * @param {Number} d1 - declination Coordinate 1
 * @param {Number} r2 - right ascension Coordinate 2
 * @param {Number} d2 - declination Coordinate 2
 * @param {Number[]} r3 - right ascension Coordinate 3
 * @param {Number[]} d3 - declination Coordinate 3
 * @param {Number} t1 - time in Julian Days
 * @param {Number} t5 - time in Julian Days
 * @returns {Number} time of alignment in Julian Days
 */ parcelHelpers.export(exports, "time", function() {
    return time;
});
/**
 * Angle returns the angle between great circles defined by three points.
 *
 * Coordinates may be right ascensions and declinations or longitudes and
 * latitudes.  If r1, d1, r2, d2 defines one line and r2, d2, r3, d3 defines
 * another, the result is the angle between the two lines.
 *
 * Algorithm by Meeus.
 */ parcelHelpers.export(exports, "angle", function() {
    return angle;
});
/**
 * Error returns an error angle of three nearly co-linear points.
 *
 * For the line defined by r1, d1, r2, d2, the result is the anglular distance
 * between that line and r0, d0.
 *
 * Algorithm by Meeus.
 */ parcelHelpers.export(exports, "error", function() {
    return error;
});
/**
 * AngleError returns both an angle as in the function Angle, and an error
 * as in the function Error.
 *
 * The algorithm is by B. Pessens.
 *
 * @returns {Number[]} [ψ, ω]
 *  {Number} ψ - angle between great circles defined by three points.
 *  {Number} ω - error angle of three nearly co-linear points
 */ parcelHelpers.export(exports, "angleError", function() {
    return angleError;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var _interpolationJs = require("./interpolation.js");
var _interpolationJsDefault = parcelHelpers.interopDefault(_interpolationJs);
function time(r1, d1, r2, d2, r3, d3, t1, t5) {
    if (r3.length !== 5 || d3.length !== 5) throw new Error('r3, d3 must be length 5');
    var gc = new Array(5);
    r3.forEach(function(r3i, i) {
        // (19.1) p. 121
        gc[i] = Math.tan(d1) * Math.sin(r2 - r3i) + Math.tan(d2) * Math.sin(r3i - r1) + Math.tan(d3[i]) * Math.sin(r1 - r2);
    });
    var l5 = new (0, _interpolationJsDefault.default).Len5(t1, t5, gc);
    return l5.zero(false);
}
function angle(r1, d1, r2, d2, r3, d3) {
    var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(d2), 2), sd2 = _base_sincos[0], cd2 = _base_sincos[1];
    var _base_sincos1 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(r2 - r1), 2), sr21 = _base_sincos1[0], cr21 = _base_sincos1[1];
    var _base_sincos2 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(r3 - r2), 2), sr32 = _base_sincos2[0], cr32 = _base_sincos2[1];
    var C1 = Math.atan2(sr21, cd2 * Math.tan(d1) - sd2 * cr21);
    var C2 = Math.atan2(sr32, cd2 * Math.tan(d3) - sd2 * cr32);
    return C1 + C2;
}
function error(r1, d1, r2, d2, r0, d0) {
    var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(r1), 2), sr1 = _base_sincos[0], cr1 = _base_sincos[1];
    var _base_sincos1 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(d1), 2), sd1 = _base_sincos1[0], cd1 = _base_sincos1[1];
    var _base_sincos2 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(r2), 2), sr2 = _base_sincos2[0], cr2 = _base_sincos2[1];
    var _base_sincos3 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(d2), 2), sd2 = _base_sincos3[0], cd2 = _base_sincos3[1];
    var X1 = cd1 * cr1;
    var X2 = cd2 * cr2;
    var Y1 = cd1 * sr1;
    var Y2 = cd2 * sr2;
    var Z1 = sd1;
    var Z2 = sd2;
    var A = Y1 * Z2 - Z1 * Y2;
    var B = Z1 * X2 - X1 * Z2;
    var C = X1 * Y2 - Y1 * X2;
    var m = Math.tan(r0);
    var n = Math.tan(d0) / Math.cos(r0);
    return Math.asin((A + B * m + C * n) / (Math.sqrt(A * A + B * B + C * C) * Math.sqrt(1 + m * m + n * n)));
}
function angleError(r1, d1, r2, d2, r3, d3) {
    var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(r1), 2), sr1 = _base_sincos[0], cr1 = _base_sincos[1];
    var _base_sincos1 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(d1), 2), c1 = _base_sincos1[0], cd1 = _base_sincos1[1];
    var _base_sincos2 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(r2), 2), sr2 = _base_sincos2[0], cr2 = _base_sincos2[1];
    var _base_sincos3 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(d2), 2), c2 = _base_sincos3[0], cd2 = _base_sincos3[1];
    var _base_sincos4 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(r3), 2), sr3 = _base_sincos4[0], cr3 = _base_sincos4[1];
    var _base_sincos5 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(d3), 2), c3 = _base_sincos5[0], cd3 = _base_sincos5[1];
    var a1 = cd1 * cr1;
    var a2 = cd2 * cr2;
    var a3 = cd3 * cr3;
    var b1 = cd1 * sr1;
    var b2 = cd2 * sr2;
    var b3 = cd3 * sr3;
    var l1 = b1 * c2 - b2 * c1;
    var l2 = b2 * c3 - b3 * c2;
    var l3 = b1 * c3 - b3 * c1;
    var m1 = c1 * a2 - c2 * a1;
    var m2 = c2 * a3 - c3 * a2;
    var m3 = c1 * a3 - c3 * a1;
    var n1 = a1 * b2 - a2 * b1;
    var n2 = a2 * b3 - a3 * b2;
    var n3 = a1 * b3 - a3 * b1;
    var \u03C8 = Math.acos((l1 * l2 + m1 * m2 + n1 * n2) / (Math.sqrt(l1 * l1 + m1 * m1 + n1 * n1) * Math.sqrt(l2 * l2 + m2 * m2 + n2 * n2)));
    var \u03C9 = Math.asin((a2 * l3 + b2 * m3 + c2 * n3) / (Math.sqrt(a2 * a2 + b2 * b2 + c2 * c2) * Math.sqrt(l3 * l3 + m3 * m3 + n3 * n3)));
    return [
        \u03C8,
        \u03C9
    ];
}
exports.default = {
    time: time,
    angle: angle,
    error: error,
    angleError: angleError
};

},{"@swc/helpers/_/_sliced_to_array":"ha6sq","./base.js":"lEDxD","./interpolation.js":"1h22R","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"ldiBl":[function(require,module,exports,__globalThis) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module nearparabolic
 */ /**
 * Nearparabolic: Chapter 35, Near-parabolic Motion.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Elements", function() {
    return Elements;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var Elements = /*#__PURE__*/ function() {
    "use strict";
    function Elements(timeP, pDis, ecc) {
        (0, _classCallCheck._)(this, Elements);
        this.timeP = timeP;
        this.pDis = pDis;
        this.ecc = ecc;
    }
    (0, _createClass._)(Elements, [
        {
            /**
   * AnomalyDistance returns true anomaly and distance for near-parabolic orbits.
   *
   * True anomaly ν returned in radians. Distance r returned in AU.
   * An error is returned if the algorithm fails to converge.
   */ key: "anomalyDistance",
            value: function anomalyDistance(jde) {
                // fairly literal translation of code on p. 246
                var q1 = (0, _baseJsDefault.default).K * Math.sqrt((1 + this.ecc) / this.pDis) / (2 * this.pDis // line 20
                );
                var g = (1 - this.ecc) / (1 + this.ecc // line 20
                );
                var t = jde - this.timeP // line 22
                ;
                if (t === 0) return {
                    ano: 0,
                    dist: this.pDis,
                    err: null
                };
                var d1 = 1e4;
                var d = 1e-9 // line 14
                ;
                var q2 = q1 * t // line 28
                ;
                var s = 2.0 / (3 * Math.abs(q2) // line 30
                );
                s = 2 / Math.tan(2 * Math.atan(Math.cbrt(Math.tan(Math.atan(s) / 2))));
                if (t < 0) s = -s;
                if (this.ecc !== 1) {
                    var l = 0 // line 38
                    ;
                    for(;;){
                        var s0 = s // line 40
                        ;
                        var z = 1.0;
                        var y = s * s;
                        var g1 = -y * s;
                        var q3 = q2 + 2 * g * s * y / 3 // line 42
                        ;
                        for(;;){
                            z += 1 // line 44
                            ;
                            g1 = -g1 * g * y // line 46
                            ;
                            var z1 = (z - (z + 1) * g) / (2 * z + 1 // line 48
                            );
                            var f = z1 * g1 // line 50
                            ;
                            q3 += f // line 52
                            ;
                            if (z > 50 || Math.abs(f) > d1) return {
                                err: new Error('No convergence')
                            };
                            if (Math.abs(f) <= d) break;
                        }
                        l++ // line 58
                        ;
                        if (l > 50) return {
                            err: new Error('No convergence')
                        };
                        for(;;){
                            var s1 = s // line 60
                            ;
                            s = (2 * s * s * s / 3 + q3) / (s * s + 1);
                            if (Math.abs(s - s1) <= d) break;
                        }
                        if (Math.abs(s - s0) <= d) break;
                    }
                }
                var \u03BD = 2 * Math.atan(s) // line 66
                ;
                var r = this.pDis * (1 + this.ecc) / (1 + this.ecc * Math.cos(\u03BD) // line 68
                );
                if (\u03BD < 0) \u03BD += 2 * Math.PI;
                return {
                    ano: \u03BD,
                    dist: r,
                    err: null
                };
            }
        }
    ]);
    return Elements;
}();
exports.default = {
    Elements: Elements
};

},{"@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","./base.js":"lEDxD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"eaFAI":[function(require,module,exports,__globalThis) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module node
 */ /**
 * Node: Chapter 39, Passages through the Nodes.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * EllipticAscending computes time and distance of passage through the ascending node of a body in an elliptical orbit.
 *
 * Argument axis is semimajor axis in AU, ecc is eccentricity, argP is argument
 * of perihelion in radians, timeP is time of perihelion as a jd.
 *
 * Result is jde of the event and distance from the sun in AU.
 */ parcelHelpers.export(exports, "ellipticAscending", function() {
    return ellipticAscending;
});
/**
 * EllipticAscending computes time and distance of passage through the descending node of a body in an elliptical orbit.
 *
 * Argument axis is semimajor axis in AU, ecc is eccentricity, argP is argument
 * of perihelion in radians, timeP is time of perihelion as a jd.
 *
 * Result is jde of the event and distance from the sun in AU.
 */ parcelHelpers.export(exports, "ellipticDescending", function() {
    return ellipticDescending;
});
parcelHelpers.export(exports, "el", function() {
    return el;
});
/**
 * ParabolicAscending computes time and distance of passage through the ascending node of a body in a parabolic orbit.
 *
 * Argument q is perihelion distance in AU, argP is argument of perihelion
 * in radians, timeP is time of perihelion as a jd.
 *
 * Result is jde of the event and distance from the sun in AU.
 */ parcelHelpers.export(exports, "parabolicAscending", function() {
    return parabolicAscending;
});
/**
 * ParabolicDescending computes time and distance of passage through the descending node of a body in a parabolic orbit.
 *
 * Argument q is perihelion distance in AU, argP is argument of perihelion
 * in radians, timeP is time of perihelion as a jd.
 *
 * Result is jde of the event and distance from the sun in AU.
 */ parcelHelpers.export(exports, "parabolicDescending", function() {
    return parabolicDescending;
});
parcelHelpers.export(exports, "pa", function() {
    return pa;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
function ellipticAscending(axis, ecc, argP, timeP) {
    return el(-argP, axis, ecc, timeP);
}
function ellipticDescending(axis, ecc, argP, timeP) {
    return el(Math.PI - argP, axis, ecc, timeP);
}
function el(\u03BD, axis, ecc, timeP) {
    var E = 2 * Math.atan(Math.sqrt((1 - ecc) / (1 + ecc)) * Math.tan(\u03BD * 0.5));
    var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(E), 2), sE = _base_sincos[0], cE = _base_sincos[1];
    var M = E - ecc * sE;
    var n = (0, _baseJsDefault.default).K / axis / Math.sqrt(axis);
    var jde = timeP + M / n;
    var r = axis * (1 - ecc * cE);
    return [
        jde,
        r
    ];
}
function parabolicAscending(q, argP, timeP) {
    return pa(-argP, q, timeP);
}
function parabolicDescending(q, argP, timeP) {
    return pa(Math.PI - argP, q, timeP);
}
function pa(\u03BD, q, timeP) {
    var s = Math.tan(\u03BD * 0.5);
    var jde = timeP + 27.403895 * s * (s * s + 3) * q * Math.sqrt(q);
    var r = q * (1 + s * s);
    return [
        jde,
        r
    ];
}
exports.default = {
    ellipticAscending: ellipticAscending,
    ellipticDescending: ellipticDescending,
    el: el,
    parabolicAscending: parabolicAscending,
    parabolicDescending: parabolicDescending,
    pa: pa
};

},{"@swc/helpers/_/_sliced_to_array":"ha6sq","./base.js":"lEDxD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"imh40":[function(require,module,exports,__globalThis) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module mars
 */ /**
 * Mars: Chapter 42, Ephemeris for Physical Observations of Mars.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Physical computes quantities for physical observations of Mars.
 *
 * Results:
 *  DE  planetocentric declination of the Earth.
 *  DS  planetocentric declination of the Sun.
 *  ω   Areographic longitude of the central meridian, as seen from Earth.
 *  P   Geocentric position angle of Mars' northern rotation pole.
 *  Q   Position angle of greatest defect of illumination.
 *  d   Apparent diameter of Mars.
 *  k   Illuminated fraction of the disk.
 *  q   Greatest defect of illumination.
 *
 * All angular results (all results except k) are in radians.
 *
 * @param {number} jde - Julian ephemeris day
 * @param {Planet} earth
 * @param {Planet} mars
 */ parcelHelpers.export(exports, "physical", function() {
    return physical;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var _coordJs = require("./coord.js");
var _coordJsDefault = parcelHelpers.interopDefault(_coordJs);
var _illumJs = require("./illum.js");
var _illumJsDefault = parcelHelpers.interopDefault(_illumJs);
var _nutationJs = require("./nutation.js");
var _nutationJsDefault = parcelHelpers.interopDefault(_nutationJs);
var _planetpositionJs = require("./planetposition.js"); // eslint-disable-line no-unused-vars
var _planetpositionJsDefault = parcelHelpers.interopDefault(_planetpositionJs);
function physical(jde, earth, mars) {
    // Step 1.0
    var T = (0, _baseJsDefault.default).J2000Century(jde);
    var p = Math.PI / 180;
    // (42.1) p. 288
    var \u03BB0 = 352.9065 * p + 1.1733 * p * T;
    var \u03B20 = 63.2818 * p - 0.00394 * p * T;
    // Step 2.0
    var earthPos = earth.position(jde);
    var R = earthPos.range;
    var fk5 = (0, _planetpositionJsDefault.default).toFK5(earthPos.lon, earthPos.lat, jde);
    var _ref = [
        fk5.lon,
        fk5.lat
    ], l0 = _ref[0], b0 = _ref[1];
    // Steps 3, 4.0
    var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(l0), 2), sl0 = _base_sincos[0], cl0 = _base_sincos[1];
    var sb0 = Math.sin(b0);
    var \u0394 = 0.5 // surely better than 0.0
    ;
    var \u03C4 = (0, _baseJsDefault.default).lightTime(\u0394);
    var l = 0;
    var b = 0;
    var r = 0;
    var x = 0;
    var y = 0;
    var z = 0;
    function f() {
        var marsPos = mars.position(jde - \u03C4);
        r = marsPos.range;
        var fk5 = (0, _planetpositionJsDefault.default).toFK5(marsPos.lon, marsPos.lat, jde);
        l = fk5.lon;
        b = fk5.lat;
        var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(b), 2), sb = _base_sincos[0], cb = _base_sincos[1];
        var _base_sincos1 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(l), 2), sl = _base_sincos1[0], cl = _base_sincos1[1];
        // (42.2) p. 289
        x = r * cb * cl - R * cl0;
        y = r * cb * sl - R * sl0;
        z = r * sb - R * sb0;
        // (42.3) p. 289
        \u0394 = Math.sqrt(x * x + y * y + z * z);
        \u03C4 = (0, _baseJsDefault.default).lightTime(\u0394);
    }
    f();
    f();
    // Step 5.0
    var \u03BB = Math.atan2(y, x);
    var \u03B2 = Math.atan(z / Math.hypot(x, y));
    // Step 6.0
    var _base_sincos1 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03B20), 2), s\u03B20 = _base_sincos1[0], c\u03B20 = _base_sincos1[1];
    var _base_sincos2 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03B2), 2), s\u03B2 = _base_sincos2[0], c\u03B2 = _base_sincos2[1];
    var DE = Math.asin(-s\u03B20 * s\u03B2 - c\u03B20 * c\u03B2 * Math.cos(\u03BB0 - \u03BB));
    // Step 7.0
    var N = 49.5581 * p + 0.7721 * p * T;
    var l\u02B9 = l - 0.00697 * p / r;
    var b\u02B9 = b - 0.000225 * p * Math.cos(l - N) / r;
    // Step 8.0
    var _base_sincos3 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(b\u02B9), 2), sb\u02B9 = _base_sincos3[0], cb\u02B9 = _base_sincos3[1];
    var DS = Math.asin(-s\u03B20 * sb\u02B9 - c\u03B20 * cb\u02B9 * Math.cos(\u03BB0 - l\u02B9));
    // Step 9.0
    var W = 11.504 * p + 350.89200025 * p * (jde - \u03C4 - 2433282.5);
    // Step 10.0
    var \u03B50 = (0, _nutationJsDefault.default).meanObliquity(jde);
    var _base_sincos4 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03B50), 2), s\u03B50 = _base_sincos4[0], c\u03B50 = _base_sincos4[1];
    var eq = new (0, _coordJsDefault.default).Ecliptic(\u03BB0, \u03B20).toEquatorial(\u03B50);
    var _ref1 = [
        eq.ra,
        eq.dec
    ], \u03B10 = _ref1[0], \u03B40 = _ref1[1];
    // Step 11.0
    var u = y * c\u03B50 - z * s\u03B50;
    var v = y * s\u03B50 + z * c\u03B50;
    var \u03B1 = Math.atan2(u, x);
    var \u03B4 = Math.atan(v / Math.hypot(x, u));
    var _base_sincos5 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03B4), 2), s\u03B4 = _base_sincos5[0], c\u03B4 = _base_sincos5[1];
    var _base_sincos6 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03B40), 2), s\u03B40 = _base_sincos6[0], c\u03B40 = _base_sincos6[1];
    var _base_sincos7 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03B10 - \u03B1), 2), s\u03B10\u03B1 = _base_sincos7[0], c\u03B10\u03B1 = _base_sincos7[1];
    var \u03B6 = Math.atan2(s\u03B40 * c\u03B4 * c\u03B10\u03B1 - s\u03B4 * c\u03B40, c\u03B4 * s\u03B10\u03B1);
    // Step 12.0
    var \u03C9 = (0, _baseJsDefault.default).pmod(W - \u03B6, 2 * Math.PI);
    // Step 13.0
    var _nutation_nutation = (0, _slicedToArray._)((0, _nutationJsDefault.default).nutation(jde), 2), \u0394\u03C8 = _nutation_nutation[0], \u0394\u03B5 = _nutation_nutation[1];
    // Step 14.0
    var _base_sincos8 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(l0 - \u03BB), 2), sl0\u03BB = _base_sincos8[0], cl0\u03BB = _base_sincos8[1];
    \u03BB += 0.005693 * p * cl0\u03BB / c\u03B2;
    \u03B2 += 0.005693 * p * sl0\u03BB * s\u03B2;
    // Step 15.0
    \u03BB0 += \u0394\u03C8;
    \u03BB += \u0394\u03C8;
    var \u03B5 = \u03B50 + \u0394\u03B5;
    // Step 16.0
    var _base_sincos9 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03B5), 2), s\u03B5 = _base_sincos9[0], c\u03B5 = _base_sincos9[1];
    eq = new (0, _coordJsDefault.default).Ecliptic(\u03BB0, \u03B20).toEquatorial(\u03B5);
    var _ref2 = [
        eq.ra,
        eq.dec
    ], \u03B10\u02B9 = _ref2[0], \u03B40\u02B9 = _ref2[1];
    eq = new (0, _coordJsDefault.default).Ecliptic(\u03BB, \u03B2).toEquatorial(\u03B5);
    var _ref3 = [
        eq.ra,
        eq.dec
    ], \u03B1\u02B9 = _ref3[0], \u03B4\u02B9 = _ref3[1];
    // Step 17.0
    var _base_sincos10 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03B40\u02B9), 2), s\u03B40\u02B9 = _base_sincos10[0], c\u03B40\u02B9 = _base_sincos10[1];
    var _base_sincos11 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03B4\u02B9), 2), s\u03B4\u02B9 = _base_sincos11[0], c\u03B4\u02B9 = _base_sincos11[1];
    var _base_sincos12 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03B10\u02B9 - \u03B1\u02B9), 2), s\u03B10\u02B9\u03B1\u02B9 = _base_sincos12[0], c\u03B10\u02B9\u03B1\u02B9 = _base_sincos12[1];
    // (42.4) p. 290
    var P = Math.atan2(c\u03B40\u02B9 * s\u03B10\u02B9\u03B1\u02B9, s\u03B40\u02B9 * c\u03B4\u02B9 - c\u03B40\u02B9 * s\u03B4\u02B9 * c\u03B10\u02B9\u03B1\u02B9);
    if (P < 0) P += 2 * Math.PI;
    // Step 18.0
    var s = l0 + Math.PI;
    var _base_sincos13 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(s), 2), ss = _base_sincos13[0], cs = _base_sincos13[1];
    var \u03B1s = Math.atan2(c\u03B5 * ss, cs);
    var \u03B4s = Math.asin(s\u03B5 * ss);
    var _base_sincos14 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03B4s), 2), s\u03B4s = _base_sincos14[0], c\u03B4s = _base_sincos14[1];
    var _base_sincos15 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03B1s - \u03B1), 2), s\u03B1s\u03B1 = _base_sincos15[0], c\u03B1s\u03B1 = _base_sincos15[1];
    var \u03C7 = Math.atan2(c\u03B4s * s\u03B1s\u03B1, s\u03B4s * c\u03B4 - c\u03B4s * s\u03B4 * c\u03B1s\u03B1);
    var Q = \u03C7 + Math.PI;
    // Step 19.0
    var d = 0.0026 * Math.PI / 180 / \u0394;
    var k = (0, _illumJsDefault.default).fraction(r, \u0394, R);
    var q = (1 - k) * d;
    return [
        DE,
        DS,
        \u03C9,
        P,
        Q,
        d,
        k,
        q
    ];
}
exports.default = {
    physical: physical
};

},{"@swc/helpers/_/_sliced_to_array":"ha6sq","./base.js":"lEDxD","./coord.js":"kTRDS","./illum.js":"9pTbU","./nutation.js":"jqV8z","./planetposition.js":"8l87z","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"d0IPX":[function(require,module,exports,__globalThis) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module moon
 */ /**
 * Moon: Chapter 53, Ephemeris for Physical Observations of the Moon.
 *
 * Incomplete.  Topocentric functions are commented out for lack of test data.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Physical returns quantities useful for physical observation of the Moon.
 *
 * Returned l, b are librations in selenographic longitude and latitude.
 * They represent combined optical and physical librations.  Topocentric
 * librations are not considered.
 *
 * Returned P is the the position angle of the Moon's axis of rotation.
 *
 * Returned l0, b0 are the selenographic coordinates of the Sun.
 *
 * Returned values all in radians.

 * @param {number} jde - Julian ephemeris day
 * @param {Planet} earth - VSOP87 Planet Earth
 * @return {Array}
 *    {base.Coord} cMoon - selenographic longitude, latitude of the Moon
 *    {number} P - position angle of the Moon's axis of rotation
 *    {base.Coord} cSun - selenographic longitude, latitude of the Sun.
 */ parcelHelpers.export(exports, "physical", function() {
    return physical;
});
parcelHelpers.export(exports, "Moon", function() {
    return Moon;
});
/* commented out for lack of test data
export function Topocentric (jde, ρsφ_, ρcφ_, L) { // (jde, ρsφ_, ρcφ_, L float64)  (l, b, P float64)
  λ, β, Δ := moonposition.Position(jde) // (λ without nutation)
  Δψ, Δε := nutation.Nutation(jde)
  sε, cε := base.sincos(nutation.MeanObliquity(jde) + Δε)
  α, δ := coord.EclToEq(λ+Δψ, β, sε, cε)
  α, δ = parallax.Topocentric(α, δ, Δ/base.AU, ρsφ_, ρcφ_, L, jde)
  λ, β = coord.EqToEcl(α, δ, sε, cε)
  const m = newMoon(jde)
  l, b = m.lib(λ, β)
  P = m.pa(λ, β, b)
  return
}

export function TopocentricCorrections (jde, b, P, φ, δ, H, π) { // (jde, b, P, φ, δ, H, π float64)  (Δl, Δb, ΔP float64)
  sφ, cφ := base.sincos(φ)
  sH, cH := base.sincos(H)
  sδ, cδ := base.sincos(δ)
  const Q = Math.atan(cφ * sH / (cδ*sφ - sδ*cφ*cH))
  const z = Math.acos(sδ*sφ + cδ*cφ*cH)
  const π_ = π * (sin(z) + 0.0084*sin(2*z))
  sQP, cQP := base.sincos(Q - P)
  Δl = -π_ * sQP / cos(b)
  Δb = π_ * cQP
  ΔP = Δl*sin(b+Δb) - π_*sin(Q)*Math.tan(δ)
  return
}
*/ /**
 * SunAltitude returns altitude of the Sun above the lunar horizon.
 *
 * @param {Coord} cOnMoon - selenographic longitude and latitude of a site on the Moon
 * @param {Coord} cSun - selenographic coordinates of the Sun (as returned by physical(), for example.)
 * @return altitude in radians.
 */ parcelHelpers.export(exports, "sunAltitude", function() {
    return sunAltitude;
});
/**
 * Sunrise returns time of sunrise for a point on the Moon near the given date.
 *
 * @param {Coord} cOnMoon - selenographic longitude and latitude of a site on the Moon
 * @param {Number} jde - Julian ephemeris day
 * @param {Planet} earth - VSOP87 Planet Earth
 * @return time of sunrise as a jde nearest the given jde.
 */ parcelHelpers.export(exports, "sunrise", function() {
    return sunrise;
});
/**
 * Sunset returns time of sunset for a point on the Moon near the given date.
 *
 * @param {Coord} cOnMoon - selenographic longitude and latitude of a site on the Moon
 * @param {Number} jde - Julian ephemeris day
 * @param {Planet} earth - VSOP87 Planet Earth
 * @return time of sunset as a jde nearest the given jde.
 */ parcelHelpers.export(exports, "sunset", function() {
    return sunset;
});
parcelHelpers.export(exports, "selenographic", function() {
    return selenographic;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _baseJs = require("./base.js"); // eslint-disable-line no-unused-vars
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var _coordJs = require("./coord.js");
var _coordJsDefault = parcelHelpers.interopDefault(_coordJs);
var _moonpositionJs = require("./moonposition.js");
var _moonpositionJsDefault = parcelHelpers.interopDefault(_moonpositionJs);
var _nutationJs = require("./nutation.js");
var _nutationJsDefault = parcelHelpers.interopDefault(_nutationJs);
var _solarJs = require("./solar.js");
var _solarJsDefault = parcelHelpers.interopDefault(_solarJs);
var _planetpositionJs = require("./planetposition.js"); // eslint-disable-line no-unused-vars
var sin = Math.sin, cos = Math.cos, asin = Math.asin, atan2 = Math.atan2;
var D2R = Math.PI / 180;
var _I = 1.54242 * D2R // IAU value of inclination of mean lunar equator
;
var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(_I), 2), sI = _base_sincos[0], cI = _base_sincos[1];
function physical(jde, earth) {
    var _moonposition_position // (λ without nutation)
     = (0, _moonpositionJsDefault.default).position(jde), lon = _moonposition_position.lon, lat = _moonposition_position.lat, range = _moonposition_position.range;
    // [λ, β, Δ]
    var m = new Moon(jde);
    var _m_lib = (0, _slicedToArray._)(m.lib(lon, lat), 2), l = _m_lib[0], b = _m_lib[1];
    var P = m.pa(lon, lat, b);
    var _m_sun = (0, _slicedToArray._)(m.sun(lon, lat, range, earth), 2), l0 = _m_sun[0], b0 = _m_sun[1];
    var cMoon = new (0, _baseJsDefault.default).Coord(l, b);
    var cSun = new (0, _baseJsDefault.default).Coord(l0, b0);
    return [
        cMoon,
        P,
        cSun
    ];
}
var Moon = /*#__PURE__*/ function() {
    "use strict";
    function Moon(jde) {
        (0, _classCallCheck._)(this, Moon);
        this.jde = jde;
        // Δψ, F, Ω, p. 372.0
        var _nutation_nutation = (0, _slicedToArray._)((0, _nutationJsDefault.default).nutation(jde), 2), \u0394\u03C8 = _nutation_nutation[0], \u0394\u03B5 = _nutation_nutation[1];
        this.\u0394\u03C8 = \u0394\u03C8;
        var T = (0, _baseJsDefault.default).J2000Century(jde);
        var F = this.F = (0, _baseJsDefault.default).horner(T, 93.272095 * D2R, 483202.0175233 * D2R, -0.0036539 * D2R, -D2R / 3526000, D2R / 863310000);
        this.\u03A9 = (0, _baseJsDefault.default).horner(T, 125.0445479 * D2R, -1934.1362891 * D2R, 0.0020754 * D2R, D2R / 467441, -D2R / 60616000);
        // true ecliptic
        this.\u03B5 = (0, _nutationJsDefault.default).meanObliquity(jde) + \u0394\u03B5;
        this.s\u03B5 = sin(this.\u03B5);
        this.c\u03B5 = cos(this.\u03B5);
        // ρ, σ, τ, p. 372,373
        var D = (0, _baseJsDefault.default).horner(T, 297.8501921 * D2R, 445267.1114034 * D2R, -0.0018819 * D2R, D2R / 545868, -D2R / 113065000);
        var M = (0, _baseJsDefault.default).horner(T, 357.5291092 * D2R, 35999.0502909 * D2R, -0.0001536 * D2R, D2R / 24490000);
        var M_ = (0, _baseJsDefault.default).horner(T, 134.9633964 * D2R, 477198.8675055 * D2R, 0.0087414 * D2R, D2R / 69699, -D2R / 14712000);
        var E = (0, _baseJsDefault.default).horner(T, 1, -0.002516, -0.0000074);
        var K1 = 119.75 * D2R + 131.849 * D2R * T;
        var K2 = 72.56 * D2R + 20.186 * D2R * T;
        this.\u03C1 = -0.02752 * D2R * cos(M_) + -0.02245 * D2R * sin(F) + 0.00684 * D2R * cos(M_ - 2 * F) + -0.00293 * D2R * cos(2 * F) + -0.00085 * D2R * cos(2 * (F - D)) + -0.00054 * D2R * cos(M_ - 2 * D) + -0.0002 * D2R * sin(M_ + F) + -0.0002 * D2R * cos(M_ + 2 * F) + -0.0002 * D2R * cos(M_ - F) + 0.00014 * D2R * cos(M_ + 2 * (F - D));
        this.\u03C3 = -0.02816 * D2R * sin(M_) + 0.02244 * D2R * cos(F) + -0.00682 * D2R * sin(M_ - 2 * F) + -0.00279 * D2R * sin(2 * F) + -0.00083 * D2R * sin(2 * (F - D)) + 0.00069 * D2R * sin(M_ - 2 * D) + 0.0004 * D2R * cos(M_ + F) + -0.00025 * D2R * sin(2 * M_) + -0.00023 * D2R * sin(M_ + 2 * F) + 0.0002 * D2R * cos(M_ - F) + 0.00019 * D2R * sin(M_ - F) + 0.00013 * D2R * sin(M_ + 2 * (F - D)) + -0.0001 * D2R * cos(M_ - 3 * F);
        this.\u03C4 = 0.0252 * D2R * sin(M) * E + 0.00473 * D2R * sin(2 * (M_ - F)) + -0.00467 * D2R * sin(M_) + 0.00396 * D2R * sin(K1) + 0.00276 * D2R * sin(2 * (M_ - D)) + 0.00196 * D2R * sin(this.\u03A9) + -0.00183 * D2R * cos(M_ - F) + 0.00115 * D2R * sin(M_ - 2 * D) + -0.00096 * D2R * sin(M_ - D) + 0.00046 * D2R * sin(2 * (F - D)) + -0.00039 * D2R * sin(M_ - F) + -0.00032 * D2R * sin(M_ - M - D) + 0.00027 * D2R * sin(2 * (M_ - D) - M) + 0.00023 * D2R * sin(K2) + -0.00014 * D2R * sin(2 * D) + 0.00014 * D2R * cos(2 * (M_ - F)) + -0.00012 * D2R * sin(M_ - 2 * F) + -0.00012 * D2R * sin(2 * M_) + 0.00011 * D2R * sin(2 * (M_ - M - D));
    }
    (0, _createClass._)(Moon, [
        {
            /**
   * lib() curiously serves for computing both librations and solar coordinates,
   * depending on the coordinates λ, β passed in.  Quantity A not described in
   * the book, but clearly depends on the λ, β of the current context and so
   * does not belong in the moon struct.  Instead just return it from optical
   * and pass it along to physical.
   */ key: "lib",
            value: function lib(\u03BB, \u03B2) {
                var _this_optical = (0, _slicedToArray._)(this.optical(\u03BB, \u03B2), 3), l_ = _this_optical[0], b_ = _this_optical[1], A = _this_optical[2];
                var _this_physical = (0, _slicedToArray._)(this.physical(A, b_), 2), l$ = _this_physical[0], b$ = _this_physical[1];
                var l = l_ + l$;
                if (l > Math.PI) l -= 2 * Math.PI;
                var b = b_ + b$;
                return [
                    l,
                    b
                ];
            }
        },
        {
            key: "optical",
            value: function optical(\u03BB, \u03B2) {
                // (53.1) p. 372
                var W = \u03BB - this.\u03A9 // (λ without nutation)
                ;
                var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(W), 2), sW = _base_sincos[0], cW = _base_sincos[1];
                var _base_sincos1 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03B2), 2), s\u03B2 = _base_sincos1[0], c\u03B2 = _base_sincos1[1];
                var A = atan2(sW * c\u03B2 * cI - s\u03B2 * sI, cW * c\u03B2);
                var l_ = (0, _baseJsDefault.default).pmod(A - this.F, 2 * Math.PI);
                var b_ = asin(-sW * c\u03B2 * sI - s\u03B2 * cI);
                return [
                    l_,
                    b_,
                    A
                ];
            }
        },
        {
            key: "physical",
            value: function physical(A, b_) {
                // (53.2) p. 373
                var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(A), 2), sA = _base_sincos[0], cA = _base_sincos[1];
                var l$ = -this.\u03C4 + (this.\u03C1 * cA + this.\u03C3 * sA) * Math.tan(b_);
                var b$ = this.\u03C3 * cA - this.\u03C1 * sA;
                return [
                    l$,
                    b$
                ];
            }
        },
        {
            key: "pa",
            value: function pa(\u03BB, \u03B2, b) {
                var V = this.\u03A9 + this.\u0394\u03C8 + this.\u03C3 / sI;
                var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(V), 2), sV = _base_sincos[0], cV = _base_sincos[1];
                var _base_sincos1 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(_I + this.\u03C1), 2), sI\u03C1 = _base_sincos1[0], cI\u03C1 = _base_sincos1[1];
                var X = sI\u03C1 * sV;
                var Y = sI\u03C1 * cV * this.c\u03B5 - cI\u03C1 * this.s\u03B5;
                var \u03C9 = Math.atan2(X, Y);
                var ecl = new (0, _coordJsDefault.default).Ecliptic(\u03BB + this.\u0394\u03C8, \u03B2).toEquatorial(this.\u03B5) // eslint-disable-line no-unused-vars
                ;
                var P = asin(Math.hypot(X, Y) * cos(ecl.ra - \u03C9) / cos(b));
                if (P < 0) P += 2 * Math.PI;
                return P;
            }
        },
        {
            key: "sun",
            value: function sun(\u03BB, \u03B2, \u0394, earth) {
                var _solar_apparentVSOP87 // eslint-disable-line no-unused-vars
                 = (0, _solarJsDefault.default).apparentVSOP87(earth, this.jde), lon = _solar_apparentVSOP87.lon, lat = _solar_apparentVSOP87.lat, range = _solar_apparentVSOP87.range;
                var \u0394R = \u0394 / (range * (0, _baseJsDefault.default).AU);
                var \u03BBH = lon + Math.PI + 57.296 * D2R * \u0394R * cos(\u03B2) * sin(lon - \u03BB);
                var \u03B2H = \u0394R * \u03B2;
                return this.lib(\u03BBH, \u03B2H);
            }
        }
    ]);
    return Moon;
}();
function sunAltitude(cOnMoon, cSun) {
    var c0 = Math.PI / 2 - cSun.lon;
    var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(cSun.lat), 2), sb0 = _base_sincos[0], cb0 = _base_sincos[1];
    var _base_sincos1 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(cOnMoon.lat), 2), s\u03B8 = _base_sincos1[0], c\u03B8 = _base_sincos1[1];
    return asin(sb0 * s\u03B8 + cb0 * c\u03B8 * sin(c0 + cOnMoon.lon));
}
function sunrise(cOnMoon, jde, earth) {
    jde -= srCorr(cOnMoon, jde, earth);
    return jde - srCorr(cOnMoon, jde, earth);
}
function sunset(cOnMoon, jde, earth) {
    jde += srCorr(cOnMoon, jde, earth);
    return jde + srCorr(cOnMoon, jde, earth);
}
/**
 * @private
 */ function srCorr(cOnMoon, jde, earth) {
    var phy = physical(jde, earth);
    var h = sunAltitude(cOnMoon, phy[2]);
    return h / (12.19075 * D2R * cos(cOnMoon.lat));
}
var lunarCoord = function(\u03B7, \u03B8) {
    return new (0, _baseJsDefault.default).Coord(\u03B7 * D2R, \u03B8 * D2R);
};
var selenographic = {
    archimedes: lunarCoord(-3.9, 29.7),
    aristarchus: lunarCoord(-47.5, 23.7),
    aristillus: lunarCoord(1.2, 33.9),
    aristoteles: lunarCoord(17.3, 50.1),
    arzachel: lunarCoord(-1.9, -17.7),
    autolycus: lunarCoord(1.5, 30.7),
    billy: lunarCoord(-50, -13.8),
    birt: lunarCoord(-8.5, -22.3),
    campanus: lunarCoord(-27.7, -28),
    censorinus: lunarCoord(32.7, -0.4),
    clavius: lunarCoord(-14, -58),
    copernicus: lunarCoord(-20, 9.7),
    delambre: lunarCoord(17.5, -1.9),
    dionysius: lunarCoord(17.3, 2.8),
    endymion: lunarCoord(56.4, 53.6),
    eratosthenes: lunarCoord(-11.3, 14.5),
    eudoxus: lunarCoord(16.3, 44.3),
    fracastorius: lunarCoord(33.2, -21),
    fraMauro: lunarCoord(-17, -6),
    gassendi: lunarCoord(-39.9, -17.5),
    goclenius: lunarCoord(45, -10.1),
    grimaldi: lunarCoord(-68.5, -5.8),
    harpalus: lunarCoord(-43.4, 52.6),
    horrocks: lunarCoord(5.9, -4),
    kepler: lunarCoord(-38, 8.1),
    langrenus: lunarCoord(60.9, -8.9),
    lansberg: lunarCoord(-26.6, -0.3),
    letronne: lunarCoord(-43, -10),
    macrobius: lunarCoord(46, 21.2),
    manilius: lunarCoord(9.1, 14.5),
    menelaus: lunarCoord(16, 16.3),
    messier: lunarCoord(47.6, -1.9),
    petavius: lunarCoord(61, -25),
    pico: lunarCoord(-8.8, 45.8),
    pitatus: lunarCoord(-13.5, -29.8),
    piton: lunarCoord(-0.8, 40.8),
    plato: lunarCoord(-9.2, 51.4),
    plinius: lunarCoord(23.6, 15.3),
    posidonius: lunarCoord(30, 31.9),
    proclus: lunarCoord(46.9, 16.1),
    ptolemeusA: lunarCoord(-0.8, -8.5),
    pytheas: lunarCoord(-20.6, 20.5),
    reinhold: lunarCoord(-22.8, 3.2),
    riccioli: lunarCoord(-74.3, -3.2),
    schickard: lunarCoord(-54.5, -44),
    schiller: lunarCoord(-39, -52),
    tauruntius: lunarCoord(46.5, 5.6),
    theophilus: lunarCoord(26.5, -11.4),
    timocharis: lunarCoord(-13.1, 26.7),
    tycho: lunarCoord(-11, -43.2),
    vitruvius: lunarCoord(31.3, 17.6),
    walter: lunarCoord(1, -33)
};
exports.default = {
    physical: physical,
    Moon: Moon,
    // Topocentric,
    // TopocentricCorrections,
    sunAltitude: sunAltitude,
    sunrise: sunrise,
    sunset: sunset,
    selenographic: selenographic
};

},{"@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","@swc/helpers/_/_sliced_to_array":"ha6sq","./base.js":"lEDxD","./coord.js":"kTRDS","./moonposition.js":"hSxi8","./nutation.js":"jqV8z","./solar.js":"d2aLm","./planetposition.js":"8l87z","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"hSxi8":[function(require,module,exports,__globalThis) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module moonposition
 */ /**
 * Moonposition: Chapter 47, Position of the Moon.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * parallax returns equatorial horizontal parallax of the Moon.
 *
 * @param {Number} distance - distance between centers of the Earth and Moon, in km.
 * @returns {Number} Result in radians.
 */ parcelHelpers.export(exports, "parallax", function() {
    return parallax;
});
/**
 * position returns geocentric location of the Moon.
 *
 * Results are referenced to mean equinox of date and do not include
 * the effect of nutation.
 *
 * @param {number} jde - Julian ephemeris day
 * @returns {Coord}
 *  {number} lon - Geocentric longitude λ, in radians.
 *  {number} lat - Geocentric latitude β, in radians.
 *  {number} range - Distance Δ between centers of the Earth and Moon, in km.
 */ parcelHelpers.export(exports, "position", function() {
    return position;
});
/**
 * Node returns longitude of the mean ascending node of the lunar orbit.
 *
 * @param {number} jde - Julian ephemeris day
 * @returns result in radians.
 */ parcelHelpers.export(exports, "node", function() {
    return node;
});
/**
 * perigee returns longitude of perigee of the lunar orbit.
 *
 * @param {number} jde - Julian ephemeris day
 * @returns result in radians.
 */ parcelHelpers.export(exports, "perigee", function() {
    return perigee;
});
/**
 * trueNode returns longitude of the true ascending node.
 *
 * That is, the node of the instantaneous lunar orbit.
 *
 * @param {number} jde - Julian ephemeris day
 * @returns result in radians.
 */ parcelHelpers.export(exports, "trueNode", function() {
    return trueNode;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _baseJs = require("./base.js"); // eslint-disable-line no-unused-vars
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var asin = Math.asin, sin = Math.sin;
var D2R = Math.PI / 180;
var EARTH_RADIUS = 6378.137 // km
;
function parallax(distance) {
    // p. 337
    return asin(EARTH_RADIUS / distance);
}
function dmf(T) {
    var d = (0, _baseJsDefault.default).horner(T, 297.8501921 * D2R, 445267.1114034 * D2R, -0.0018819 * D2R, D2R / 545868, -D2R / 113065000);
    var m = (0, _baseJsDefault.default).horner(T, 357.5291092 * D2R, 35999.0502909 * D2R, -0.0001536 * D2R, D2R / 24490000);
    var m_ = (0, _baseJsDefault.default).horner(T, 134.9633964 * D2R, 477198.8675055 * D2R, 0.0087414 * D2R, D2R / 69699, -D2R / 14712000);
    var f = (0, _baseJsDefault.default).horner(T, 93.272095 * D2R, 483202.0175233 * D2R, -0.0036539 * D2R, -D2R / 3526000, D2R / 863310000);
    return [
        d,
        m,
        m_,
        f
    ];
}
function position(jde) {
    var T = (0, _baseJsDefault.default).J2000Century(jde);
    var l_ = (0, _baseJsDefault.default).horner(T, 218.3164477 * D2R, 481267.88123421 * D2R, -0.0015786 * D2R, D2R / 538841, -D2R / 65194000);
    var _dmf = (0, _slicedToArray._)(dmf(T), 4), d = _dmf[0], m = _dmf[1], m_ = _dmf[2], f = _dmf[3];
    var a1 = 119.75 * D2R + 131.849 * D2R * T;
    var a2 = 53.09 * D2R + 479264.29 * D2R * T;
    var a3 = 313.45 * D2R + 481266.484 * D2R * T;
    var e = (0, _baseJsDefault.default).horner(T, 1, -0.002516, -0.0000074);
    var e2 = e * e;
    var \u03A3l = 3958 * sin(a1) + 1962 * sin(l_ - f) + 318 * sin(a2);
    var \u03A3r = 0.0;
    var \u03A3b = -2235 * sin(l_) + 382 * sin(a3) + 175 * sin(a1 - f) + 175 * sin(a1 + f) + 127 * sin(l_ - m_) - 115 * sin(l_ + m_);
    ta.forEach(function(r) {
        var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(d * r.d + m * r.m + m_ * r.m_ + f * r.f), 2), sina = _base_sincos[0], cosa = _base_sincos[1];
        switch(r.m){
            case 0:
                \u03A3l += r.\u03A3l * sina;
                \u03A3r += r.\u03A3r * cosa;
                break;
            case -1:
            case 1:
                \u03A3l += r.\u03A3l * sina * e;
                \u03A3r += r.\u03A3r * cosa * e;
                break;
            case -2:
            case 2:
                \u03A3l += r.\u03A3l * sina * e2;
                \u03A3r += r.\u03A3r * cosa * e2;
                break;
        }
    });
    tb.forEach(function(r) {
        var sb = sin(d * r.d + m * r.m + m_ * r.m_ + f * r.f);
        switch(r.m){
            case 0:
                \u03A3b += r.\u03A3b * sb;
                break;
            case -1:
            case 1:
                \u03A3b += r.\u03A3b * sb * e;
                break;
            case -2:
            case 2:
                \u03A3b += r.\u03A3b * sb * e2;
                break;
        }
    });
    var lon = (0, _baseJsDefault.default).pmod(l_, 2 * Math.PI) + \u03A3l * 1e-6 * D2R;
    var lat = \u03A3b * 1e-6 * D2R;
    var range = 385000.56 + \u03A3r * 1e-3;
    return new (0, _baseJsDefault.default).Coord(lon, lat, range);
}
var ta = function() {
    var ta = [
        [
            0,
            0,
            1,
            0,
            6288774,
            -20905355
        ],
        [
            2,
            0,
            -1,
            0,
            1274027,
            -3699111
        ],
        [
            2,
            0,
            0,
            0,
            658314,
            -2955968
        ],
        [
            0,
            0,
            2,
            0,
            213618,
            -569925
        ],
        [
            0,
            1,
            0,
            0,
            -185116,
            48888
        ],
        [
            0,
            0,
            0,
            2,
            -114332,
            -3149
        ],
        [
            2,
            0,
            -2,
            0,
            58793,
            246158
        ],
        [
            2,
            -1,
            -1,
            0,
            57066,
            -152138
        ],
        [
            2,
            0,
            1,
            0,
            53322,
            -170733
        ],
        [
            2,
            -1,
            0,
            0,
            45758,
            -204586
        ],
        [
            0,
            1,
            -1,
            0,
            -40923,
            -129620
        ],
        [
            1,
            0,
            0,
            0,
            -34720,
            108743
        ],
        [
            0,
            1,
            1,
            0,
            -30383,
            104755
        ],
        [
            2,
            0,
            0,
            -2,
            15327,
            10321
        ],
        [
            0,
            0,
            1,
            2,
            -12528,
            0
        ],
        [
            0,
            0,
            1,
            -2,
            10980,
            79661
        ],
        [
            4,
            0,
            -1,
            0,
            10675,
            -34782
        ],
        [
            0,
            0,
            3,
            0,
            10034,
            -23210
        ],
        [
            4,
            0,
            -2,
            0,
            8548,
            -21636
        ],
        [
            2,
            1,
            -1,
            0,
            -7888,
            24208
        ],
        [
            2,
            1,
            0,
            0,
            -6766,
            30824
        ],
        [
            1,
            0,
            -1,
            0,
            -5163,
            -8379
        ],
        [
            1,
            1,
            0,
            0,
            4987,
            -16675
        ],
        [
            2,
            -1,
            1,
            0,
            4036,
            -12831
        ],
        [
            2,
            0,
            2,
            0,
            3994,
            -10445
        ],
        [
            4,
            0,
            0,
            0,
            3861,
            -11650
        ],
        [
            2,
            0,
            -3,
            0,
            3665,
            14403
        ],
        [
            0,
            1,
            -2,
            0,
            -2689,
            -7003
        ],
        [
            2,
            0,
            -1,
            2,
            -2602,
            0
        ],
        [
            2,
            -1,
            -2,
            0,
            2390,
            10056
        ],
        [
            1,
            0,
            1,
            0,
            -2348,
            6322
        ],
        [
            2,
            -2,
            0,
            0,
            2236,
            -9884
        ],
        [
            0,
            1,
            2,
            0,
            -2120,
            5751
        ],
        [
            0,
            2,
            0,
            0,
            -2069,
            0
        ],
        [
            2,
            -2,
            -1,
            0,
            2048,
            -4950
        ],
        [
            2,
            0,
            1,
            -2,
            -1773,
            4130
        ],
        [
            2,
            0,
            0,
            2,
            -1595,
            0
        ],
        [
            4,
            -1,
            -1,
            0,
            1215,
            -3958
        ],
        [
            0,
            0,
            2,
            2,
            -1110,
            0
        ],
        [
            3,
            0,
            -1,
            0,
            -892,
            3258
        ],
        [
            2,
            1,
            1,
            0,
            -810,
            2616
        ],
        [
            4,
            -1,
            -2,
            0,
            759,
            -1897
        ],
        [
            0,
            2,
            -1,
            0,
            -713,
            -2117
        ],
        [
            2,
            2,
            -1,
            0,
            -700,
            2354
        ],
        [
            2,
            1,
            -2,
            0,
            691,
            0
        ],
        [
            2,
            -1,
            0,
            -2,
            596,
            0
        ],
        [
            4,
            0,
            1,
            0,
            549,
            -1423
        ],
        [
            0,
            0,
            4,
            0,
            537,
            -1117
        ],
        [
            4,
            -1,
            0,
            0,
            520,
            -1571
        ],
        [
            1,
            0,
            -2,
            0,
            -487,
            -1739
        ],
        [
            2,
            1,
            0,
            -2,
            -399,
            0
        ],
        [
            0,
            0,
            2,
            -2,
            -381,
            -4421
        ],
        [
            1,
            1,
            1,
            0,
            351,
            0
        ],
        [
            3,
            0,
            -2,
            0,
            -340,
            0
        ],
        [
            4,
            0,
            -3,
            0,
            330,
            0
        ],
        [
            2,
            -1,
            2,
            0,
            327,
            0
        ],
        [
            0,
            2,
            1,
            0,
            -323,
            1165
        ],
        [
            1,
            1,
            -1,
            0,
            299,
            0
        ],
        [
            2,
            0,
            3,
            0,
            294,
            0
        ],
        [
            2,
            0,
            -1,
            -2,
            0,
            8752
        ]
    ];
    return ta.map(function(row) {
        var o = {};
        var vals = [
            'd',
            'm',
            'm_',
            'f',
            "\u03A3l",
            "\u03A3r"
        ];
        vals.forEach(function(D2R, i) {
            o[D2R] = row[i];
        });
        return o;
    });
}();
var tb = function() {
    var tb = [
        [
            0,
            0,
            0,
            1,
            5128122
        ],
        [
            0,
            0,
            1,
            1,
            280602
        ],
        [
            0,
            0,
            1,
            -1,
            277693
        ],
        [
            2,
            0,
            0,
            -1,
            173237
        ],
        [
            2,
            0,
            -1,
            1,
            55413
        ],
        [
            2,
            0,
            -1,
            -1,
            46271
        ],
        [
            2,
            0,
            0,
            1,
            32573
        ],
        [
            0,
            0,
            2,
            1,
            17198
        ],
        [
            2,
            0,
            1,
            -1,
            9266
        ],
        [
            0,
            0,
            2,
            -1,
            8822
        ],
        [
            2,
            -1,
            0,
            -1,
            8216
        ],
        [
            2,
            0,
            -2,
            -1,
            4324
        ],
        [
            2,
            0,
            1,
            1,
            4200
        ],
        [
            2,
            1,
            0,
            -1,
            -3359
        ],
        [
            2,
            -1,
            -1,
            1,
            2463
        ],
        [
            2,
            -1,
            0,
            1,
            2211
        ],
        [
            2,
            -1,
            -1,
            -1,
            2065
        ],
        [
            0,
            1,
            -1,
            -1,
            -1870
        ],
        [
            4,
            0,
            -1,
            -1,
            1828
        ],
        [
            0,
            1,
            0,
            1,
            -1794
        ],
        [
            0,
            0,
            0,
            3,
            -1749
        ],
        [
            0,
            1,
            -1,
            1,
            -1565
        ],
        [
            1,
            0,
            0,
            1,
            -1491
        ],
        [
            0,
            1,
            1,
            1,
            -1475
        ],
        [
            0,
            1,
            1,
            -1,
            -1410
        ],
        [
            0,
            1,
            0,
            -1,
            -1344
        ],
        [
            1,
            0,
            0,
            -1,
            -1335
        ],
        [
            0,
            0,
            3,
            1,
            1107
        ],
        [
            4,
            0,
            0,
            -1,
            1021
        ],
        [
            4,
            0,
            -1,
            1,
            833
        ],
        [
            0,
            0,
            1,
            -3,
            777
        ],
        [
            4,
            0,
            -2,
            1,
            671
        ],
        [
            2,
            0,
            0,
            -3,
            607
        ],
        [
            2,
            0,
            2,
            -1,
            596
        ],
        [
            2,
            -1,
            1,
            -1,
            491
        ],
        [
            2,
            0,
            -2,
            1,
            -451
        ],
        [
            0,
            0,
            3,
            -1,
            439
        ],
        [
            2,
            0,
            2,
            1,
            422
        ],
        [
            2,
            0,
            -3,
            -1,
            421
        ],
        [
            2,
            1,
            -1,
            1,
            -366
        ],
        [
            2,
            1,
            0,
            1,
            -351
        ],
        [
            4,
            0,
            0,
            1,
            331
        ],
        [
            2,
            -1,
            1,
            1,
            315
        ],
        [
            2,
            -2,
            0,
            -1,
            302
        ],
        [
            0,
            0,
            1,
            3,
            -283
        ],
        [
            2,
            1,
            1,
            -1,
            -229
        ],
        [
            1,
            1,
            0,
            -1,
            223
        ],
        [
            1,
            1,
            0,
            1,
            223
        ],
        [
            0,
            1,
            -2,
            -1,
            -220
        ],
        [
            2,
            1,
            -1,
            -1,
            -220
        ],
        [
            1,
            0,
            1,
            1,
            -185
        ],
        [
            2,
            -1,
            -2,
            -1,
            181
        ],
        [
            0,
            1,
            2,
            1,
            -177
        ],
        [
            4,
            0,
            -2,
            -1,
            176
        ],
        [
            4,
            -1,
            -1,
            -1,
            166
        ],
        [
            1,
            0,
            1,
            -1,
            -164
        ],
        [
            4,
            0,
            1,
            -1,
            132
        ],
        [
            1,
            0,
            -1,
            -1,
            -119
        ],
        [
            4,
            -1,
            0,
            -1,
            115
        ],
        [
            2,
            -2,
            0,
            1,
            107
        ]
    ];
    return tb.map(function(row) {
        var o = {};
        var vals = [
            'd',
            'm',
            'm_',
            'f',
            "\u03A3b"
        ];
        vals.forEach(function(D2R, i) {
            o[D2R] = row[i];
        });
        return o;
    });
}();
function node(jde) {
    return (0, _baseJsDefault.default).pmod((0, _baseJsDefault.default).horner((0, _baseJsDefault.default).J2000Century(jde), 125.0445479 * D2R, -1934.1362891 * D2R, 0.0020754 * D2R, D2R / 467441, -D2R / 60616000), 2 * Math.PI);
}
function perigee(jde) {
    return (0, _baseJsDefault.default).pmod((0, _baseJsDefault.default).horner((0, _baseJsDefault.default).J2000Century(jde), 83.3532465 * D2R, 4069.0137287 * D2R, -0.01032 * D2R, -D2R / 80053, D2R / 18999000), 2 * Math.PI);
}
function trueNode(jde) {
    var _dmf = (0, _slicedToArray._)(dmf((0, _baseJsDefault.default).J2000Century(jde)), 4), d = _dmf[0], m = _dmf[1], m_ = _dmf[2], f = _dmf[3];
    return node(jde) + -1.4979 * D2R * sin(2 * (d - f)) + -0.15 * D2R * sin(m) + -0.1226 * D2R * sin(2 * d) + 0.1176 * D2R * sin(2 * f) + -0.0801 * D2R * sin(2 * (m_ - f));
}
exports.default = {
    parallax: parallax,
    position: position,
    node: node,
    perigee: perigee,
    trueNode: trueNode
};

},{"@swc/helpers/_/_sliced_to_array":"ha6sq","./base.js":"lEDxD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"kORfy":[function(require,module,exports,__globalThis) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module moonillum
 */ /**
 * Moonillum: Chapter 48, Illuminated Fraction of the Moon's Disk
 *
 * Also see functions `illuminated` and `limb` in package base.  The function
 * for computing illuminated fraction given a phase angle (48.1) is
 * base.illuminated.  Formula (48.3) is implemented as base.limb.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * phaseAngleEquatorial computes the phase angle of the Moon given equatorial coordinates.
 *
 * @param {Coord} cMoon - geocentric right ascension,  declination and distance to the Moon
 * @param {Coord} cSun - coordinates and distance of the Sun
 * @returns {number} phase angle of the Moon in radians
 */ parcelHelpers.export(exports, "phaseAngleEquatorial", function() {
    return phaseAngleEquatorial;
});
/**
 * phaseAngleEquatorial2 computes the phase angle of the Moon given equatorial coordinates.
 *
 * Less accurate than phaseAngleEquatorial.
 *
 * Arguments α, δ are geocentric right ascension and declination of the Moon;
 * α0, δ0  are coordinates of the Sun.  Angles must be in radians.
 *
 * @param {Coord} cMoon - eocentric right ascension and declination of the Moon
 * @param {Coord} cSun - coordinates of the Sun
 * @returns {number} phase angle of the Moon in radians
 */ parcelHelpers.export(exports, "phaseAngleEquatorial2", function() {
    return phaseAngleEquatorial2;
});
/**
 * phaseAngleEcliptic computes the phase angle of the Moon given ecliptic coordinates.
 *
 * Distances must be in the same units as each other.
 *
 * @param {Coord} cMoon - geocentric longitude, latitude and distance to the Moon
 * @param {Coord} cSun -  longitude and distance to the Sun
 * @returns {number} phase angle of the Moon in radians
 */ parcelHelpers.export(exports, "phaseAngleEcliptic", function() {
    return phaseAngleEcliptic;
});
/**
 * phaseAngleEcliptic2 computes the phase angle of the Moon given ecliptic coordinates.
 *
 * Less accurate than phaseAngleEcliptic.
 *
 * Angles must be in radians.
 *
 * @param {Coord} cMoon - geocentric longitude, latitude of the Moon
 * @param {Coord} cSun -  longitude of the Sun
 * @returns {number} phase angle of the Moon in radians
 */ parcelHelpers.export(exports, "phaseAngleEcliptic2", function() {
    return phaseAngleEcliptic2;
});
/**
 * phaseAngle3 computes the phase angle of the Moon given a julian day.
 *
 * Less accurate than phaseAngle functions taking coordinates.
 *
 * Result in radians.
 */ parcelHelpers.export(exports, "phaseAngle3", function() {
    return phaseAngle3;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _baseJs = require("./base.js"); // eslint-disable-line no-unused-vars
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var D2R = Math.PI / 180;
function phaseAngleEquatorial(cMoon, cSun) {
    return pa(cMoon.range, cSun.range, cosEq(cMoon.ra, cMoon.dec, cSun.ra, cSun.dec));
}
/**
 * cos elongation from equatorial coordinates
 * @private
 */ function cosEq(\u03B1, \u03B4, \u03B10, \u03B40) {
    var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03B4), 2), s\u03B4 = _base_sincos[0], c\u03B4 = _base_sincos[1];
    var _base_sincos1 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03B40), 2), s\u03B40 = _base_sincos1[0], c\u03B40 = _base_sincos1[1];
    return s\u03B40 * s\u03B4 + c\u03B40 * c\u03B4 * Math.cos(\u03B10 - \u03B1);
}
/**
 * phase angle from cos elongation and distances
 * @private
 * @param {number} Δ
 * @param {number} R
 * @param {number} cψ
 * @returns {number}
 */ function pa(\u0394, R, c\u03C8) {
    var s\u03C8 = Math.sin(Math.acos(c\u03C8));
    var i = Math.atan(R * s\u03C8 / (\u0394 - R * c\u03C8));
    if (i < 0) i += Math.PI;
    return i;
}
function phaseAngleEquatorial2(cMoon, cSun) {
    return Math.acos(-cosEq(cMoon.ra, cMoon.dec, cSun.ra, cSun.dec));
}
function phaseAngleEcliptic(cMoon, cSun) {
    return pa(cMoon.range, cSun.range, cosEcl(cMoon.lon, cMoon.lat, cSun.lon));
}
/**
 * cos elongation from ecliptic coordinates
 * @private
 */ function cosEcl(\u03BB, \u03B2, \u03BB0) {
    return Math.cos(\u03B2) * Math.cos(\u03BB - \u03BB0);
}
function phaseAngleEcliptic2(cMoon, cSun) {
    return Math.acos(-cosEcl(cMoon.lon, cMoon.lat, cSun.lon));
}
function phaseAngle3(jde) {
    var T = (0, _baseJsDefault.default).J2000Century(jde);
    var D = (0, _baseJsDefault.default).horner(T, 297.8501921 * D2R, 445267.1114034 * D2R, -0.0018819 * D2R, D2R / 545868, -D2R / 113065000);
    var m = (0, _baseJsDefault.default).horner(T, 357.5291092 * D2R, 35999.0502909 * D2R, -0.0001536 * D2R, D2R / 24490000);
    var m_ = (0, _baseJsDefault.default).horner(T, 134.9633964 * D2R, 477198.8675055 * D2R, 0.0087414 * D2R, D2R / 69699, -D2R / 14712000);
    return Math.PI - (0, _baseJsDefault.default).pmod(D, 2 * Math.PI) + -6.289 * D2R * Math.sin(m_) + 2.1 * D2R * Math.sin(m) + -1.274 * D2R * Math.sin(2 * D - m_) + -0.658 * D2R * Math.sin(2 * D) + -0.214 * D2R * Math.sin(2 * m_) + -0.11 * D2R * Math.sin(D);
}
exports.default = {
    phaseAngleEquatorial: phaseAngleEquatorial,
    phaseAngleEquatorial2: phaseAngleEquatorial2,
    phaseAngleEcliptic: phaseAngleEcliptic,
    phaseAngleEcliptic2: phaseAngleEcliptic2,
    phaseAngle3: phaseAngle3
};

},{"@swc/helpers/_/_sliced_to_array":"ha6sq","./base.js":"lEDxD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"htGUq":[function(require,module,exports,__globalThis) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module moonmaxdec
 */ /**
 * Moonmaxdec: Chapter 52, Maximum Declinations of the Moon
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * North computes the maximum northern declination of the Moon near a given date.
 *
 * Argument year is a decimal year specifying a date near the event.
 *
 * Returned is the jde of the event nearest the given date and the declination
 * of the Moon at that time.
 */ parcelHelpers.export(exports, "north", function() {
    return north;
});
/**
 * South computes the maximum southern declination of the Moon near a given date.
 *
 * Argument year is a decimal year specifying a date near the event.
 *
 * Returned is the jde of the event nearest the given date and the declination
 * of the Moon at that time.
 */ parcelHelpers.export(exports, "south", function() {
    return south;
});
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
function north(y) {
    return max(y, nc);
}
function south(y) {
    return max(y, sc);
}
var p = Math.PI / 180;
var ck = 1 / 1336.86;
/**
 * @private
 */ function max(y, c) {
    var k = (y - 2000.03) * 13.3686 // (52.1) p. 367
    ;
    k = Math.floor(k + 0.5);
    var T = k * ck;
    var D = (0, _baseJsDefault.default).horner(T, c.D, 333.0705546 * p / ck, -0.0004214 * p, 0.00000011 * p);
    var m = (0, _baseJsDefault.default).horner(T, c.m, 26.9281592 * p / ck, -0.0000355 * p, -0.0000001 * p);
    var m_ = (0, _baseJsDefault.default).horner(T, c.m_, 356.9562794 * p / ck, 0.0103066 * p, 0.00001251 * p);
    var f = (0, _baseJsDefault.default).horner(T, c.f, 1.4467807 * p / ck, -0.002069 * p, -0.00000215 * p);
    var E = (0, _baseJsDefault.default).horner(T, 1, -0.002516, -0.0000074);
    var jde = (0, _baseJsDefault.default).horner(T, c.JDE, 27.321582247 / ck, 0.000119804, -0.000000141) + c.tc[0] * Math.cos(f) + c.tc[1] * Math.sin(m_) + c.tc[2] * Math.sin(2 * f) + c.tc[3] * Math.sin(2 * D - m_) + c.tc[4] * Math.cos(m_ - f) + c.tc[5] * Math.cos(m_ + f) + c.tc[6] * Math.sin(2 * D) + c.tc[7] * Math.sin(m) * E + c.tc[8] * Math.cos(3 * f) + c.tc[9] * Math.sin(m_ + 2 * f) + c.tc[10] * Math.cos(2 * D - f) + c.tc[11] * Math.cos(2 * D - m_ - f) + c.tc[12] * Math.cos(2 * D - m_ + f) + c.tc[13] * Math.cos(2 * D + f) + c.tc[14] * Math.sin(2 * m_) + c.tc[15] * Math.sin(m_ - 2 * f) + c.tc[16] * Math.cos(2 * m_ - f) + c.tc[17] * Math.sin(m_ + 3 * f) + c.tc[18] * Math.sin(2 * D - m - m_) * E + c.tc[19] * Math.cos(m_ - 2 * f) + c.tc[20] * Math.sin(2 * (D - m_)) + c.tc[21] * Math.sin(f) + c.tc[22] * Math.sin(2 * D + m_) + c.tc[23] * Math.cos(m_ + 2 * f) + c.tc[24] * Math.sin(2 * D - m) * E + c.tc[25] * Math.sin(m_ + f) + c.tc[26] * Math.sin(m - m_) * E + c.tc[27] * Math.sin(m_ - 3 * f) + c.tc[28] * Math.sin(2 * m_ + f) + c.tc[29] * Math.cos(2 * (D - m_) - f) + c.tc[30] * Math.sin(3 * f) + c.tc[31] * Math.cos(m_ + 3 * f) + c.tc[32] * Math.cos(2 * m_) + c.tc[33] * Math.cos(2 * D - m_) + c.tc[34] * Math.cos(2 * D + m_ + f) + c.tc[35] * Math.cos(m_) + c.tc[36] * Math.sin(3 * m_ + f) + c.tc[37] * Math.sin(2 * D - m_ + f) + c.tc[38] * Math.cos(2 * (D - m_)) + c.tc[39] * Math.cos(D + f) + c.tc[40] * Math.sin(m + m_) * E + c.tc[41] * Math.sin(2 * (D - f)) + c.tc[42] * Math.cos(2 * m_ + f) + c.tc[43] * Math.cos(3 * m_ + f);
    var \u03B4 = 23.6961 * p - 0.013004 * p * T + c.dc[0] * Math.sin(f) + c.dc[1] * Math.cos(2 * f) + c.dc[2] * Math.sin(2 * D - f) + c.dc[3] * Math.sin(3 * f) + c.dc[4] * Math.cos(2 * (D - f)) + c.dc[5] * Math.cos(2 * D) + c.dc[6] * Math.sin(m_ - f) + c.dc[7] * Math.sin(m_ + 2 * f) + c.dc[8] * Math.cos(f) + c.dc[9] * Math.sin(2 * D + m - f) * E + c.dc[10] * Math.sin(m_ + 3 * f) + c.dc[11] * Math.sin(D + f) + c.dc[12] * Math.sin(m_ - 2 * f) + c.dc[13] * Math.sin(2 * D - m - f) * E + c.dc[14] * Math.sin(2 * D - m_ - f) + c.dc[15] * Math.cos(m_ + f) + c.dc[16] * Math.cos(m_ + 2 * f) + c.dc[17] * Math.cos(2 * m_ + f) + c.dc[18] * Math.cos(m_ - 3 * f) + c.dc[19] * Math.cos(2 * m_ - f) + c.dc[20] * Math.cos(m_ - 2 * f) + c.dc[21] * Math.sin(2 * m_) + c.dc[22] * Math.sin(3 * m_ + f) + c.dc[23] * Math.cos(2 * D + m - f) * E + c.dc[24] * Math.cos(m_ - f) + c.dc[25] * Math.cos(3 * f) + c.dc[26] * Math.sin(2 * D + f) + c.dc[27] * Math.cos(m_ + 3 * f) + c.dc[28] * Math.cos(D + f) + c.dc[29] * Math.sin(2 * m_ - f) + c.dc[30] * Math.cos(3 * m_ + f) + c.dc[31] * Math.cos(2 * (D + m_) + f) + c.dc[32] * Math.sin(2 * (D - m_) - f) + c.dc[33] * Math.cos(2 * m_) + c.dc[34] * Math.cos(m_) + c.dc[35] * Math.sin(2 * f) + c.dc[36] * Math.sin(m_ + f);
    return {
        jde: jde,
        dec: c.s * \u03B4
    };
}
/**
 * north coefficients
 */ var nc = {
    D: 152.2029 * p,
    m: 14.8591 * p,
    m_: 4.6881 * p,
    f: 325.8867 * p,
    JDE: 2451562.5897,
    s: 1,
    tc: [
        0.8975,
        -0.4726,
        -0.103,
        -0.0976,
        -0.0462,
        -0.0461,
        -0.0438,
        0.0162,
        -0.0157,
        0.0145,
        0.0136,
        -0.0095,
        -0.0091,
        -0.0089,
        0.0075,
        -0.0068,
        0.0061,
        -0.0047,
        -0.0043,
        -0.004,
        -0.0037,
        0.0031,
        0.0030,
        -0.0029,
        -0.0029,
        -0.0027,
        0.0024,
        -0.0021,
        0.0019,
        0.0018,
        0.0018,
        0.0017,
        0.0017,
        -0.0014,
        0.0013,
        0.0013,
        0.0012,
        0.0011,
        -0.0011,
        0.001,
        0.001,
        -0.0009,
        0.0007,
        -0.0007
    ],
    dc: [
        5.1093 * p,
        0.2658 * p,
        0.1448 * p,
        -0.0322 * p,
        0.0133 * p,
        0.0125 * p,
        -0.0124 * p,
        -0.0101 * p,
        0.0097 * p,
        -0.0087 * p,
        0.0074 * p,
        0.0067 * p,
        0.0063 * p,
        0.0060 * p,
        -0.0057 * p,
        -0.0056 * p,
        0.0052 * p,
        0.0041 * p,
        -0.004 * p,
        0.0038 * p,
        -0.0034 * p,
        -0.0029 * p,
        0.0029 * p,
        -0.0028 * p,
        -0.0028 * p,
        -0.0023 * p,
        -0.0021 * p,
        0.0019 * p,
        0.0018 * p,
        0.0017 * p,
        0.0015 * p,
        0.0014 * p,
        -0.0012 * p,
        -0.0012 * p,
        -0.001 * p,
        -0.001 * p,
        0.0006 * p
    ]
};
/**
 * south coefficients
 */ var sc = {
    D: 345.6676 * p,
    m: 1.3951 * p,
    m_: 186.21 * p,
    f: 145.1633 * p,
    JDE: 2451548.9289,
    s: -1,
    tc: [
        -0.8975,
        -0.4726,
        -0.103,
        -0.0976,
        0.0541,
        0.0516,
        -0.0438,
        0.0112,
        0.0157,
        0.0023,
        -0.0136,
        0.011,
        0.0091,
        0.0089,
        0.0075,
        -0.003,
        -0.0061,
        -0.0047,
        -0.0043,
        0.004,
        -0.0037,
        -0.0031,
        0.0030,
        0.0029,
        -0.0029,
        -0.0027,
        0.0024,
        -0.0021,
        -0.0019,
        -0.0006,
        -0.0018,
        -0.0017,
        0.0017,
        0.0014,
        -0.0013,
        -0.0013,
        0.0012,
        0.0011,
        0.0011,
        0.001,
        0.001,
        -0.0009,
        -0.0007,
        -0.0007
    ],
    dc: [
        -5.1093 * p,
        0.2658 * p,
        -0.1448 * p,
        0.0322 * p,
        0.0133 * p,
        0.0125 * p,
        -0.0015 * p,
        0.0101 * p,
        -0.0097 * p,
        0.0087 * p,
        0.0074 * p,
        0.0067 * p,
        -0.0063 * p,
        -0.006 * p,
        0.0057 * p,
        -0.0056 * p,
        -0.0052 * p,
        -0.0041 * p,
        -0.004 * p,
        -0.0038 * p,
        0.0034 * p,
        -0.0029 * p,
        0.0029 * p,
        0.0028 * p,
        -0.0028 * p,
        0.0023 * p,
        0.0021 * p,
        0.0019 * p,
        0.0018 * p,
        -0.0017 * p,
        0.0015 * p,
        0.0014 * p,
        0.0012 * p,
        -0.0012 * p,
        0.001 * p,
        -0.001 * p,
        0.0037 * p
    ]
};
exports.default = {
    north: north,
    south: south
};

},{"./base.js":"lEDxD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1IQvk":[function(require,module,exports,__globalThis) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module moonnode
 */ /**
 * Moonnode: Chapter 51, Passages of the Moon through the Nodes.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Ascending returns the date of passage of the Moon through an ascending node.
 *
 * @param {Number} year - decimal year specifying a date near the event.
 * @returns {Number} jde of the event nearest the given date.
 */ parcelHelpers.export(exports, "ascending", function() {
    return ascending;
});
/**
 * Descending returns the date of passage of the Moon through a descending node.
 *
 * @param {Number} year - decimal year specifying a date near the event.
 * @returns {Number} jde of the event nearest the given date.
 */ parcelHelpers.export(exports, "descending", function() {
    return descending;
});
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
function ascending(year) {
    return node(year, 0);
}
function descending(year) {
    return node(year, 0.5);
}
/**
 * @private
 */ function node(y, h) {
    var k = (y - 2000.05) * 13.4223 // (50.1) p. 355
    ;
    k = Math.floor(k - h + 0.5) + h // snap to half orbit
    ;
    var p = Math.PI / 180;
    var ck = 1 / 1342.23;
    var T = k * ck;
    var D = (0, _baseJsDefault.default).horner(T, 183.638 * p, 331.73735682 * p / ck, 0.0014852 * p, 0.00000209 * p, -0.00000001 * p);
    var M = (0, _baseJsDefault.default).horner(T, 17.4006 * p, 26.8203725 * p / ck, 0.0001186 * p, 0.00000006 * p);
    var m_ = (0, _baseJsDefault.default).horner(T, 38.3776 * p, 355.52747313 * p / ck, 0.0123499 * p, 0.000014627 * p, -0.000000069 * p);
    var \u03A9 = (0, _baseJsDefault.default).horner(T, 123.9767 * p, -1.44098956 * p / ck, 0.0020608 * p, 0.00000214 * p, -0.000000016 * p);
    var V = (0, _baseJsDefault.default).horner(T, 299.75 * p, 132.85 * p, -0.009173 * p);
    var P = \u03A9 + 272.75 * p - 2.3 * p * T;
    var E = (0, _baseJsDefault.default).horner(T, 1, -0.002516, -0.0000074);
    return (0, _baseJsDefault.default).horner(T, 2451565.1619, 27.212220817 / ck, 0.0002762, 0.000000021, -0.000000000088) + -0.4721 * Math.sin(m_) + -0.1649 * Math.sin(2 * D) + -0.0868 * Math.sin(2 * D - m_) + 0.0084 * Math.sin(2 * D + m_) + -0.0083 * Math.sin(2 * D - M) * E + -0.0039 * Math.sin(2 * D - M - m_) * E + 0.0034 * Math.sin(2 * m_) + -0.0031 * Math.sin(2 * (D - m_)) + 0.003 * Math.sin(2 * D + M) * E + 0.0028 * Math.sin(M - m_) * E + 0.0026 * Math.sin(M) * E + 0.0025 * Math.sin(4 * D) + 0.0024 * Math.sin(D) + 0.0022 * Math.sin(M + m_) * E + 0.0017 * Math.sin(\u03A9) + 0.0014 * Math.sin(4 * D - m_) + 0.0005 * Math.sin(2 * D + M - m_) * E + 0.0004 * Math.sin(2 * D - M + m_) * E + -0.0003 * Math.sin(2 * (D - M)) * E + 0.0003 * Math.sin(4 * D - M) * E + 0.0003 * Math.sin(V) + 0.0003 * Math.sin(P);
}
exports.default = {
    ascending: ascending,
    descending: descending
};

},{"./base.js":"lEDxD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"fvyBD":[function(require,module,exports,__globalThis) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module parabolic
 */ /**
 * Parabolic: Chapter 34, Parabolic Motion.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Elements", function() {
    return Elements;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var Elements = /*#__PURE__*/ function() {
    "use strict";
    function Elements(timeP, pDis) {
        (0, _classCallCheck._)(this, Elements);
        this.timeP = timeP;
        this.pDis = pDis;
    }
    (0, _createClass._)(Elements, [
        {
            /**
   * AnomalyDistance returns true anomaly and distance of a body in a parabolic orbit of the Sun.
   *
   * @param {Number} jde - Julian ephemeris day
   * @returns {Object} {ano, dist}
   *   {Number} ano - True anomaly ν in radians.
   *   {Number} dist - Distance r returned in AU.
   */ key: "anomalyDistance",
            value: function anomalyDistance(jde) {
                var W = 3 * (0, _baseJsDefault.default).K / Math.SQRT2 * (jde - this.timeP) / this.pDis / Math.sqrt(this.pDis);
                var G = W * 0.5;
                var Y = Math.cbrt(G + Math.sqrt(G * G + 1));
                var s = Y - 1 / Y;
                var \u03BD = 2 * Math.atan(s);
                var r = this.pDis * (1 + s * s);
                return {
                    ano: \u03BD,
                    dist: r
                };
            }
        }
    ]);
    return Elements;
}();
exports.default = {
    Elements: Elements
};

},{"@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","./base.js":"lEDxD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7CD6n":[function(require,module,exports,__globalThis) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module parallax
 */ /**
 * Parallax: Chapter 40, Correction for Parallax.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Horizontal returns equatorial horizontal parallax of a body.
 *
 * @param {number} Δ - distance in AU.
 * @return {number} parallax in radians.
 */ parcelHelpers.export(exports, "horizontal", function() {
    return horizontal;
});
/**
 * Topocentric returns topocentric positions including parallax.
 *
 * Arguments α, δ are geocentric right ascension and declination in radians.
 * Δ is distance to the observed object in AU. ρsφ, ρcφ are parallax
 * constants (see package globe.) lon is geographic longitude of the observer,
 * jde is time of observation.
 *
 * @param {Coord} c - geocentric right ascension and declination in radians
 * @param {number} ρsφ - parallax constants (see package globe.)
 * @param {number} ρcφ - parallax constants (see package globe.)
 * @param {number} lon - geographic longitude of the observer (measured positively westwards!)
 * @param {number} jde - time of observation
 * @return {Coord} observed topocentric ra and dec in radians.
 */ parcelHelpers.export(exports, "topocentric", function() {
    return topocentric;
});
/**
 * Topocentric2 returns topocentric corrections including parallax.
 *
 * This function implements the "non-rigorous" method descripted in the text.
 *
 * Note that results are corrections, not corrected coordinates.
 *
 * @param {Coord} c - geocentric right ascension and declination in radians
 * @param {number} ρsφ - parallax constants (see package globe.)
 * @param {number} ρcφ - parallax constants (see package globe.)
 * @param {number} lon - geographic longitude of the observer (measured positively westwards!)
 * @param {number} jde - time of observation
 * @return {Coord} observed topocentric ra and dec in radians.
 */ parcelHelpers.export(exports, "topocentric2", function() {
    return topocentric2;
});
/**
 * Topocentric3 returns topocentric hour angle and declination including parallax.
 *
 * This function implements the "alternative" method described in the text.
 * The method should be similarly rigorous to that of Topocentric() and results
 * should be virtually consistent.
 *
 * @param {Coord} c - geocentric right ascension and declination in radians
 * @param {number} ρsφ - parallax constants (see package globe.)
 * @param {number} ρcφ - parallax constants (see package globe.)
 * @param {number} lon - geographic longitude of the observer (measured positively westwards!)
 * @param {number} jde - time of observation
 * @return {Array}
 *    {number} H_ - topocentric hour angle
 *    {number} δ_ - topocentric declination
 */ parcelHelpers.export(exports, "topocentric3", function() {
    return topocentric3;
});
/**
 * TopocentricEcliptical returns topocentric ecliptical coordinates including parallax.
 *
 * Arguments `c` are geocentric ecliptical longitude and latitude of a body,
 * s is its geocentric semidiameter. φ, h are the observer's latitude and
 * and height above the ellipsoid in meters.  ε is the obliquity of the
 * ecliptic, θ is local sidereal time, π is equatorial horizontal parallax
 * of the body (see Horizonal()).
 *
 * All angular parameters and results are in radians.
 *
 * @param {Coord} c - geocentric right ascension and declination in radians
 * @param {number} s - geocentric semidiameter of `c`
 * @param {number} φ - observer's latitude
 * @param {number} h - observer's height above the ellipsoid in meters
 * @param {number} ε - is the obliquity of the ecliptic
 * @param {number} θ - local sidereal time
 * @param {number} π - equatorial horizontal parallax of the body
 * @return {Array}
 *    {number} λ_ - observed topocentric longitude
 *    {number} β_ - observed topocentric latitude
 *    {number} s_ - observed topocentric semidiameter
 */ parcelHelpers.export(exports, "topocentricEcliptical", function() {
    return topocentricEcliptical;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _baseJs = require("./base.js"); // eslint-disable-line no-unused-vars
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var _globeJs = require("./globe.js");
var _globeJsDefault = parcelHelpers.interopDefault(_globeJs);
var _siderealJs = require("./sidereal.js");
var _siderealJsDefault = parcelHelpers.interopDefault(_siderealJs);
var _sexagesimalJs = require("./sexagesimal.js");
var _sexagesimalJsDefault = parcelHelpers.interopDefault(_sexagesimalJs);
var horPar = 8.794 / 3600 * Math.PI / 180 // 8".794 arcseconds in radians
;
function horizontal(\u0394) {
    // (40.1) p. 279
    return Math.asin(Math.sin(horPar) / \u0394);
// return horPar / Δ // with sufficient accuracy
}
function topocentric(c, \u03C1s\u03C6, \u03C1c\u03C6, lon, jde) {
    var _ref = [
        c.ra,
        c.dec,
        c.range
    ], \u03B1 = _ref[0], \u03B4 = _ref[1], \u0394 = _ref[2];
    var \u03C0 = horizontal(\u0394);
    var \u03B80 = new (0, _sexagesimalJsDefault.default).Time((0, _siderealJsDefault.default).apparent(jde)).rad();
    var H = (0, _baseJsDefault.default).pmod(\u03B80 - lon - \u03B1, 2 * Math.PI);
    var s\u03C0 = Math.sin(\u03C0);
    var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(H), 2), sH = _base_sincos[0], cH = _base_sincos[1];
    var _base_sincos1 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03B4), 2), s\u03B4 = _base_sincos1[0], c\u03B4 = _base_sincos1[1];
    var \u0394\u03B1 = Math.atan2(-\u03C1c\u03C6 * s\u03C0 * sH, c\u03B4 - \u03C1c\u03C6 * s\u03C0 * cH) // (40.2) p. 279
    ;
    var \u03B1_ = \u03B1 + \u0394\u03B1;
    var \u03B4_ = Math.atan2((s\u03B4 - \u03C1s\u03C6 * s\u03C0) * Math.cos(\u0394\u03B1), c\u03B4 - \u03C1c\u03C6 * s\u03C0 * cH) // (40.3) p. 279
    ;
    return new (0, _baseJs.Coord)(\u03B1_, \u03B4_);
}
function topocentric2(c, \u03C1s\u03C6, \u03C1c\u03C6, lon, jde) {
    var _ref = [
        c.ra,
        c.dec,
        c.range
    ], \u03B1 = _ref[0], \u03B4 = _ref[1], \u0394 = _ref[2];
    var \u03C0 = horizontal(\u0394);
    var \u03B80 = new (0, _sexagesimalJsDefault.default).Time((0, _siderealJsDefault.default).apparent(jde)).rad();
    var H = (0, _baseJsDefault.default).pmod(\u03B80 - lon - \u03B1, 2 * Math.PI);
    var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(H), 2), sH = _base_sincos[0], cH = _base_sincos[1];
    var _base_sincos1 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03B4), 2), s\u03B4 = _base_sincos1[0], c\u03B4 = _base_sincos1[1];
    var \u0394\u03B1 = -\u03C0 * \u03C1c\u03C6 * sH / c\u03B4 // (40.4) p. 280
    ;
    var \u0394\u03B4 = -\u03C0 * (\u03C1s\u03C6 * c\u03B4 - \u03C1c\u03C6 * cH * s\u03B4 // (40.5) p. 280
    );
    return new (0, _baseJsDefault.default).Coord(\u0394\u03B1, \u0394\u03B4);
}
function topocentric3(c, \u03C1s\u03C6, \u03C1c\u03C6, lon, jde) {
    var _ref = [
        c.ra,
        c.dec,
        c.range
    ], \u03B1 = _ref[0], \u03B4 = _ref[1], \u0394 = _ref[2];
    var \u03C0 = horizontal(\u0394);
    var \u03B80 = new (0, _sexagesimalJsDefault.default).Time((0, _siderealJsDefault.default).apparent(jde)).rad();
    var H = (0, _baseJsDefault.default).pmod(\u03B80 - lon - \u03B1, 2 * Math.PI);
    var s\u03C0 = Math.sin(\u03C0);
    var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(H), 2), sH = _base_sincos[0], cH = _base_sincos[1];
    var _base_sincos1 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03B4), 2), s\u03B4 = _base_sincos1[0], c\u03B4 = _base_sincos1[1];
    var A = c\u03B4 * sH;
    var B = c\u03B4 * cH - \u03C1c\u03C6 * s\u03C0;
    var C = s\u03B4 - \u03C1s\u03C6 * s\u03C0;
    var q = Math.sqrt(A * A + B * B + C * C);
    var H_ = Math.atan2(A, B);
    var \u03B4_ = Math.asin(C / q);
    return [
        H_,
        \u03B4_
    ];
}
function topocentricEcliptical(c, s, \u03C6, h, \u03B5, \u03B8, \u03C0) {
    var _ref = [
        c.lon,
        c.lat
    ], \u03BB = _ref[0], \u03B2 = _ref[1];
    var _globe_Earth76_parallaxConstants = (0, _slicedToArray._)((0, _globeJsDefault.default).Earth76.parallaxConstants(\u03C6, h), 2), S = _globe_Earth76_parallaxConstants[0], C = _globe_Earth76_parallaxConstants[1];
    var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03BB), 2), s\u03BB = _base_sincos[0], c\u03BB = _base_sincos[1];
    var _base_sincos1 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03B2), 2), s\u03B2 = _base_sincos1[0], c\u03B2 = _base_sincos1[1];
    var _base_sincos2 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03B5), 2), s\u03B5 = _base_sincos2[0], c\u03B5 = _base_sincos2[1];
    var _base_sincos3 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03B8), 2), s\u03B8 = _base_sincos3[0], c\u03B8 = _base_sincos3[1];
    var s\u03C0 = Math.sin(\u03C0);
    var N = c\u03BB * c\u03B2 - C * s\u03C0 * c\u03B8;
    var \u03BB_ = Math.atan2(s\u03BB * c\u03B2 - s\u03C0 * (S * s\u03B5 + C * c\u03B5 * s\u03B8), N);
    if (\u03BB_ < 0) \u03BB_ += 2 * Math.PI;
    var c\u03BB_ = Math.cos(\u03BB_);
    var \u03B2_ = Math.atan(c\u03BB_ * (s\u03B2 - s\u03C0 * (S * c\u03B5 - C * s\u03B5 * s\u03B8)) / N);
    var s_ = Math.asin(c\u03BB_ * Math.cos(\u03B2_) * Math.sin(s) / N);
    return [
        \u03BB_,
        \u03B2_,
        s_
    ];
}
exports.default = {
    horizontal: horizontal,
    topocentric: topocentric,
    topocentric2: topocentric2,
    topocentric3: topocentric3,
    topocentricEcliptical: topocentricEcliptical
};

},{"@swc/helpers/_/_sliced_to_array":"ha6sq","./base.js":"lEDxD","./globe.js":"fqyqU","./sidereal.js":"c4ZrF","./sexagesimal.js":"aLUGo","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"c4ZrF":[function(require,module,exports,__globalThis) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module sidereal
 */ /**
 * Sidereal: Chapter 12, Sidereal Time at Greenwich.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * JDToCFrac returns values for use in computing sidereal time at Greenwich.
 *
 * Cen is centuries from J2000 of the JD at 0h UT of argument jd.  This is
 * the value to use for evaluating the IAU sidereal time polynomial.
 * DayFrac is the fraction of jd after 0h UT.  It is used to compute the
 * final value of sidereal time.
 *
 * @param {number} jd - Julian Days
 * @return {number[]} [century, fraction] century and fraction of jd after 0h UT
 */ parcelHelpers.export(exports, "JDToCFrac", function() {
    return JDToCFrac;
});
parcelHelpers.export(exports, "iau82", function() {
    return iau82;
});
/**
 * Mean returns mean sidereal time at Greenwich for a given JD.
 *
 * Computation is by IAU 1982 coefficients.  The result is in seconds of
 * time and is in the range [0,86400).
 *
 * @param {number} jd - Julian Days
 * @return {number}
 */ parcelHelpers.export(exports, "mean", function() {
    return mean;
});
/**
 * Mean0UT returns mean sidereal time at Greenwich at 0h UT on the given JD.
 *
 * The result is in seconds of time and is in the range [0,86400).
 *
 * @param {number} jd - Julian Days
 * @return {number}
 */ parcelHelpers.export(exports, "mean0UT", function() {
    return mean0UT;
});
/**
 * Apparent returns apparent sidereal time at Greenwich for the given JD.
 *
 * Apparent is mean plus the nutation in right ascension.
 *
 * The result is in seconds of time and is in the range [0,86400).
 *
 * @param {number} jd - Julian Days
 * @return {number}
 */ parcelHelpers.export(exports, "apparent", function() {
    return apparent;
});
/**
 * Apparent0UT returns apparent sidereal time at Greenwich at 0h UT
 * on the given JD.
 *
 * The result is in seconds of time and is in the range [0,86400).
 *
 * @param {number} jd - Julian Days
 * @return {number}
 */ parcelHelpers.export(exports, "apparent0UT", function() {
    return apparent0UT;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var _nutationJs = require("./nutation.js");
var _nutationJsDefault = parcelHelpers.interopDefault(_nutationJs);
function JDToCFrac(jd) {
    var _base_modf = (0, _slicedToArray._)((0, _baseJsDefault.default).modf(jd + 0.5), 2), j0 = _base_modf[0], f = _base_modf[1];
    return [
        (0, _baseJsDefault.default).J2000Century(j0 - 0.5),
        f
    ] // (cen, dayFrac /* float */)
    ;
}
var iau82 = [
    24110.54841,
    8640184.812866,
    0.093104,
    -0.0000062
];
function mean(jd) {
    return (0, _baseJsDefault.default).pmod(_mean(jd), 86400);
}
/**
 * @private
 */ function _mean(jd) {
    var _$_mean0UT = (0, _slicedToArray._)(_mean0UT(jd), 2), s = _$_mean0UT[0], f = _$_mean0UT[1];
    return s + f * 86636.55536784;
}
function mean0UT(jd /* float */ ) {
    var _$_mean0UT // eslint-disable-line
     = (0, _slicedToArray._)(_mean0UT(jd), 2), s = _$_mean0UT[0], _ = _$_mean0UT[1];
    return (0, _baseJsDefault.default).pmod(s, 86400);
}
/**
 * @private
 */ function _mean0UT(jd /* float */ ) {
    var _base;
    var _JDToCFrac = (0, _slicedToArray._)(JDToCFrac(jd), 2), cen = _JDToCFrac[0], f = _JDToCFrac[1];
    // (12.2) p. 87
    return [
        (_base = (0, _baseJsDefault.default)).horner.apply(_base, [
            cen
        ].concat((0, _toConsumableArray._)(iau82))),
        f
    ] // (sidereal, dayFrac /* float */)
    ;
}
function apparent(jd) {
    var s = _mean(jd) // seconds of time
    ;
    var n = (0, _nutationJsDefault.default).nutationInRA(jd) // angle (radians) of RA
    ;
    var ns = n * 648000 / Math.PI / 15 // convert RA to time in seconds
    ;
    return (0, _baseJsDefault.default).pmod(s + ns, 86400);
}
function apparent0UT(jd) {
    var _base;
    var _base_modf = (0, _slicedToArray._)((0, _baseJsDefault.default).modf(jd + 0.5), 2), j0 = _base_modf[0], f = _base_modf[1];
    var cen = (j0 - 0.5 - (0, _baseJsDefault.default).J2000) / 36525;
    var s = (_base = (0, _baseJsDefault.default)).horner.apply(_base, [
        cen
    ].concat((0, _toConsumableArray._)(iau82))) + f * 86636.55536784;
    var n = (0, _nutationJsDefault.default).nutationInRA(j0) // angle (radians) of RA
    ;
    var ns = n * 648000 / Math.PI / 15 // convert RA to time in seconds
    ;
    return (0, _baseJsDefault.default).pmod(s + ns, 86400);
}
exports.default = {
    JDToCFrac: JDToCFrac,
    iau82: iau82,
    mean: mean,
    mean0UT: mean0UT,
    apparent: apparent,
    apparent0UT: apparent0UT
};

},{"@swc/helpers/_/_sliced_to_array":"ha6sq","@swc/helpers/_/_to_consumable_array":"eqNDD","./base.js":"lEDxD","./nutation.js":"jqV8z","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"b1Fva":[function(require,module,exports,__globalThis) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module parallactic
 */ /**
 * Parallactic: Chapter 14, The Parallactic Angle, and three other Topics.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * ParallacticAngle returns parallactic angle of a celestial object.
 *
 *  φ is geographic latitude of observer.
 *  δ is declination of observed object.
 *  H is hour angle of observed object.
 *
 * All angles including result are in radians.
 */ parcelHelpers.export(exports, "parallacticAngle", function() {
    return parallacticAngle;
});
/**
 * ParallacticAngleOnHorizon is a special case of ParallacticAngle.
 *
 * The hour angle is not needed as an input and the math inside simplifies.
 */ parcelHelpers.export(exports, "parallacticAngleOnHorizon", function() {
    return parallacticAngleOnHorizon;
});
/**
 * EclipticAtHorizon computes how the plane of the ecliptic intersects
 * the horizon at a given local sidereal time as observed from a given
 * geographic latitude.
 *
 *  ε is obliquity of the ecliptic.
 *  φ is geographic latitude of observer.
 *  θ is local sidereal time expressed as an hour angle.
 *
 *  λ1 and λ2 are ecliptic longitudes where the ecliptic intersects the horizon.
 *  I is the angle at which the ecliptic intersects the horizon.
 *
 * All angles, arguments and results, are in radians.
 */ parcelHelpers.export(exports, "eclipticAtHorizon", function() {
    return eclipticAtHorizon;
});
/**
 * EclipticAtEquator computes the angle between the ecliptic and the parallels
 * of ecliptic latitude at a given ecliptic longitude.
 *
 * (The function name EclipticAtEquator is for consistency with the Meeus text,
 * and works if you consider the equator a nominal parallel of latitude.)
 *
 *  λ is ecliptic longitude.
 *  ε is obliquity of the ecliptic.
 *
 * All angles in radians.
 */ parcelHelpers.export(exports, "eclipticAtEquator", function() {
    return eclipticAtEquator;
});
/**
 * DiurnalPathAtHorizon computes the angle of the path a celestial object
 * relative to the horizon at the time of its rising or setting.
 *
 *  δ is declination of the object.
 *  φ is geographic latitude of observer.
 *
 * All angles in radians.
 */ parcelHelpers.export(exports, "diurnalPathAtHorizon", function() {
    return diurnalPathAtHorizon;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
function parallacticAngle(\u03C6, \u03B4, H) {
    var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03B4), 2), s\u03B4 = _base_sincos[0], c\u03B4 = _base_sincos[1];
    var _base_sincos1 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(H), 2), sH = _base_sincos1[0], cH = _base_sincos1[1];
    return Math.atan2(sH, Math.tan(\u03C6) * c\u03B4 - s\u03B4 * cH) // (14.1) p. 98
    ;
}
function parallacticAngleOnHorizon(\u03C6, \u03B4) {
    return Math.acos(Math.sin(\u03C6) / Math.cos(\u03B4));
}
function eclipticAtHorizon(\u03B5, \u03C6, \u03B8) {
    var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03B5), 2), s\u03B5 = _base_sincos[0], c\u03B5 = _base_sincos[1];
    var _base_sincos1 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03C6), 2), s\u03C6 = _base_sincos1[0], c\u03C6 = _base_sincos1[1];
    var _base_sincos2 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03B8), 2), s\u03B8 = _base_sincos2[0], c\u03B8 = _base_sincos2[1];
    var \u03BB = Math.atan2(-c\u03B8, s\u03B5 * (s\u03C6 / c\u03C6) + c\u03B5 * s\u03B8) // (14.2) p. 99
    ;
    if (\u03BB < 0) \u03BB += Math.PI;
    return [
        \u03BB,
        \u03BB + Math.PI,
        Math.acos(c\u03B5 * s\u03C6 - s\u03B5 * c\u03C6 * s\u03B8)
    ] // (14.3) p. 99
    ;
}
function eclipticAtEquator(\u03BB, \u03B5) {
    return Math.atan(-Math.cos(\u03BB) * Math.tan(\u03B5));
}
function diurnalPathAtHorizon(\u03B4, \u03C6) {
    var t\u03C6 = Math.tan(\u03C6);
    var b = Math.tan(\u03B4) * t\u03C6;
    var c = Math.sqrt(1 - b * b);
    return Math.atan(c * Math.cos(\u03B4) / t\u03C6);
}
exports.default = {
    parallacticAngle: parallacticAngle,
    parallacticAngleOnHorizon: parallacticAngleOnHorizon,
    eclipticAtHorizon: eclipticAtHorizon,
    eclipticAtEquator: eclipticAtEquator,
    diurnalPathAtHorizon: diurnalPathAtHorizon
};

},{"@swc/helpers/_/_sliced_to_array":"ha6sq","./base.js":"lEDxD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jwmNT":[function(require,module,exports,__globalThis) {
/* eslint-disable n/no-callback-literal */ /**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module perihelion
 */ /**
 * Perihelion: Chapter 38, Planets in Perihelion and Aphelion.
 *
 * Functions Aphelion and Perihelion implement algorithms from the book
 * to return approximate results.
 *
 * For accurate results, Meeus describes the general technique of
 * interpolating from a precise ephemeris but does not give a complete
 * algorithm.  The algorithm implemented here for Aphelion2 and Perihelion2
 * is to start with the approximate result and then crawl along the curve
 * at the specified time resolution until the desired extremum is found.
 * This algorithm slows down as higher accuracy is demanded.  1 day accuracy
 * is generally quick for planets other than Neptune.
 *
 * Meeus doesn't give an algorithm to handle the double extrema of Neptune.
 * The algorithm here is to pick starting points several years either side
 * of the approximate date and follow the slopes inward.  The consequence of
 * starting farther from the extremum is that these functions are particularly
 * slow for Neptune.  They are offered here though as a simple implementation
 * of Meeus's presentation in the book.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mercury", function() {
    return mercury;
});
parcelHelpers.export(exports, "venus", function() {
    return venus;
});
parcelHelpers.export(exports, "earth", function() {
    return earth;
});
parcelHelpers.export(exports, "mars", function() {
    return mars;
});
parcelHelpers.export(exports, "jupiter", function() {
    return jupiter;
});
parcelHelpers.export(exports, "saturn", function() {
    return saturn;
});
parcelHelpers.export(exports, "uranus", function() {
    return uranus;
});
parcelHelpers.export(exports, "neptune", function() {
    return neptune;
});
parcelHelpers.export(exports, "embary", function() {
    return embary;
});
/**
 * Perihelion returns an approximate jde of the perihelion event nearest the given time.
 *
 * @param {planetsEnum} p - planet constant from above
 * @param {Number} year - year number indicating a time near the perihelion event.
 * @returns {Number} jde - time of the event
 */ parcelHelpers.export(exports, "perihelion", function() {
    return perihelion;
});
/**
 * Aphelion returns an approximate jde of the aphelion event nearest the given time.
 *
 * @param {planetsEnum} p - planet constant from above
 * @param {Number} year - year number indicating a time near the aphelion event.
 * @returns {Number} jde - time of the event
 */ parcelHelpers.export(exports, "aphelion", function() {
    return aphelion;
});
/**
 * Perihelion2 returns the perihelion event nearest the given time.
 *
 * @param {Planet} planet - VSOP87 planet (EMBary is not allowed)
 * @param {Number} year - (float) decimal year number near the perihelion event
 * @param {Number} precision - desired precision of the time result, in days
 * @param {Function} [cb] - callback function for asynchronous processing `cb([jde, r])`
 * @returns {Array} [jde, r]
 *   {Number} jde - time of the event
 *   {Number} r - the distance of the planet from the Sun in AU.
 */ parcelHelpers.export(exports, "perihelion2", function() {
    return perihelion2;
});
/**
 * Aphelion2 returns the aphelion event nearest the given time.
 *
 * @param {Planet} planet - VSOP87 planet (EMBary is not allowed)
 * @param {Number} year - (float) decimal year number near the perihelion event
 * @param {Number} precision - desired precision of the time result, in days
 * @param {Function} [cb] - callback function for asynchronous processing `cb([jde, r])`
 * @returns {Array} [jde, r]
 *   {Number} jde - time of the event
 *   {Number} r - the distance of the planet from the Sun in AU.
 */ parcelHelpers.export(exports, "aphelion2", function() {
    return aphelion2;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var _interpolationJs = require("./interpolation.js");
var _interpolationJsDefault = parcelHelpers.interopDefault(_interpolationJs);
var _planetpositionJs = require("./planetposition.js"); // eslint-disable-line no-unused-vars
/**
 * Planet constants for first argument of Perihelion and Aphelion functions.
 * @enum {number}
 */ var planetsEnum = {
    mercury: 0,
    venus: 1,
    earth: 2,
    mars: 3,
    jupiter: 4,
    saturn: 5,
    uranus: 6,
    neptune: 7,
    embary: 8
};
var mercury = planetsEnum.mercury;
var venus = planetsEnum.venus;
var earth = planetsEnum.earth;
var mars = planetsEnum.mars;
var jupiter = planetsEnum.jupiter;
var saturn = planetsEnum.saturn;
var uranus = planetsEnum.uranus;
var neptune = planetsEnum.neptune;
var embary = planetsEnum.embary;
function perihelion(p, year) {
    return ap(p, year, false, pf);
}
function aphelion(p, year) {
    return ap(p, year, true, af);
}
var pf = function pf(x) {
    return Math.floor(x + 0.5);
};
var af = function af(x) {
    return Math.floor(x) + 0.5;
};
var ap = function ap(p, y, a, f) {
    var _base;
    var i = p;
    if (i === embary) i = earth;
    var k = f(ka[i].a * (y - ka[i].b));
    var j = (_base = (0, _baseJsDefault.default)).horner.apply(_base, [
        k
    ].concat((0, _toConsumableArray._)(c[i])));
    if (p === earth) {
        var c1 = ep;
        if (a) c1 = ea;
        for(var i1 = 0; i1 < 5; i1++)j += c1[i1] * Math.sin((ec[i1].a + ec[i1].b * k) * Math.PI / 180);
    }
    return j;
};
var ka = [
    {
        a: 4.15201,
        b: 2000.12
    },
    {
        a: 1.62549,
        b: 2000.53
    },
    {
        a: 0.99997,
        b: 2000.01
    },
    {
        a: 0.53166,
        b: 2001.78
    },
    {
        a: 0.0843,
        b: 2011.2
    },
    {
        a: 0.03393,
        b: 2003.52
    },
    {
        a: 0.0119,
        b: 2051.1
    },
    {
        a: 0.00607,
        b: 2047.5
    } // neptune
];
var c = [
    [
        2451590.257,
        87.96934963
    ],
    [
        2451738.233,
        224.7008188,
        -0.0000000327
    ],
    [
        2451547.507,
        365.2596358,
        0.0000000156
    ],
    [
        2452195.026,
        686.9957857,
        -0.0000001187
    ],
    [
        2455636.936,
        4332.897065,
        0.0001367
    ],
    [
        2452830.12,
        10764.21676,
        0.000827
    ],
    [
        2470213.5,
        30694.8767,
        -0.00541
    ],
    [
        2468895.1,
        60190.33,
        0.03429
    ] // neptune
];
var ec = [
    {
        a: 328.41,
        b: 132.788585
    },
    {
        a: 316.13,
        b: 584.903153
    },
    {
        a: 346.2,
        b: 450.380738
    },
    {
        a: 136.95,
        b: 659.306737
    },
    {
        a: 249.52,
        b: 329.653368
    }
];
var ep = [
    1.278,
    -0.055,
    -0.091,
    -0.056,
    -0.045
];
var ea = [
    -1.352,
    0.061,
    0.062,
    0.029,
    0.031
];
function perihelion2(planet, year, precision, cb) {
    return ap2(planetsEnum[planet.name], year, precision, planet, false, pf, cb);
}
function aphelion2(planet, year, precision, cb) {
    return ap2(planetsEnum[planet.name], year, precision, planet, true, af, cb);
}
if (typeof setImmediate !== 'function') {
    var _$setImmediate = setTimeout // eslint-disable-line no-unused-vars
    ;
}
var ap2 = function ap2(p, y, d, v, a, f, cb) {
    var j1 = ap(p, y, a, f);
    if (p !== neptune) return ap2a(j1, d, a, v, cb);
    // handle the double extrema of Neptune
    if (cb) ap2a(j1 - 5000, d, a, v, function(param) {
        var _param = (0, _slicedToArray._)(param, 2), j0 = _param[0], r0 = _param[1];
        ap2a(j1 + 5000, d, a, v, function(param) {
            var _param = (0, _slicedToArray._)(param, 2), j2 = _param[0], r2 = _param[1];
            if (r0 > r2 === a) {
                cb([
                    j0,
                    r0
                ]);
                return;
            }
            cb([
                j2,
                r2
            ]);
        });
    });
    else {
        var _ap2a = (0, _slicedToArray._)(ap2a(j1 - 5000, d, a, v), 2), j0 = _ap2a[0], r0 = _ap2a[1];
        var _ap2a1 = (0, _slicedToArray._)(ap2a(j1 + 5000, d, a, v), 2), j2 = _ap2a1[0], r2 = _ap2a1[1];
        if (r0 > r2 === a) return [
            j0,
            r0
        ];
        return [
            j2,
            r2
        ];
    }
};
var ap2a = function ap2a(j1, d, a, v, cb) {
    var j0 = j1 - d;
    var j2 = j1 + d;
    var rr = new Array(3);
    rr[1] = v.position2000(j1).range;
    rr[0] = v.position2000(j0).range;
    rr[2] = v.position2000(j2).range;
    function end() {
        var l = new (0, _interpolationJsDefault.default).Len3(j0, j2, rr);
        var _l_extremum = (0, _slicedToArray._)(l.extremum(), 2), jde = _l_extremum[0], r = _l_extremum[1];
        return [
            jde,
            r
        ];
    }
    function run() {
        if (a) {
            if (rr[1] > rr[0] && rr[1] > rr[2]) {
                cb && cb(end());
                return true;
            }
        } else if (rr[1] < rr[0] && rr[1] < rr[2]) {
            cb && cb(end());
            return true;
        }
        if (rr[0] < rr[2] === a) {
            j0 = j1;
            j1 = j2;
            j2 += d;
            rr[0] = rr[1];
            rr[1] = rr[2];
            rr[2] = v.position2000(j2).range;
        } else {
            j2 = j1;
            j1 = j0;
            j0 -= d;
            rr[2] = rr[1];
            rr[1] = rr[0];
            rr[0] = v.position2000(j0).range;
        }
        if (cb) setImmediate(run, 0);
    }
    if (cb) run();
    else for(;;){
        if (run()) return end();
    }
};
exports.default = {
    mercury: mercury,
    venus: venus,
    earth: earth,
    mars: mars,
    jupiter: jupiter,
    saturn: saturn,
    uranus: uranus,
    neptune: neptune,
    embary: embary,
    perihelion: perihelion,
    aphelion: aphelion,
    perihelion2: perihelion2,
    aphelion2: aphelion2
};

},{"@swc/helpers/_/_sliced_to_array":"ha6sq","@swc/helpers/_/_to_consumable_array":"eqNDD","./base.js":"lEDxD","./interpolation.js":"1h22R","./planetposition.js":"8l87z","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"9utPC":[function(require,module,exports,__globalThis) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module planetary
 */ /**
 * Planetary: Chapter 36, The Calculation of some Planetary Phenomena.
 *
 * Incomplete: Some functions unimplemented for lack of test data.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Mean computes some intermediate values for a mean planetary configuration
 * given a year and a row of coefficients from Table 36.A, p. 250.0
 */ parcelHelpers.export(exports, "mean", function() {
    return mean;
});
/**
 * Sum computes a sum of periodic terms.
 */ parcelHelpers.export(exports, "sum", function() {
    return sum;
});
/**
 * ms returns a mean time corrected by a sum.
 */ parcelHelpers.export(exports, "ms", function() {
    return ms;
});
/**
 * MercuryInfConj returns the time of an inferior conjunction of Mercury.
 *
 * Result is time (as a jde) of the event nearest the given time (as a
 * decimal year.)
 */ parcelHelpers.export(exports, "mercuryInfConj", function() {
    return mercuryInfConj;
});
/**
 * MercurySupConj returns the time of a superior conjunction of Mercury.
 *
 * Result is time (as a jde) of the event nearest the given time (as a
 * decimal year.)
 */ parcelHelpers.export(exports, "mercurySupConj", function() {
    return mercurySupConj;
});
/**
 * VenusInfConj returns the time of an inferior conjunction of Venus.
 *
 * Result is time (as a jde) of the event nearest the given time (as a
 * decimal year.)
 */ parcelHelpers.export(exports, "venusInfConj", function() {
    return venusInfConj;
});
/**
 * MarsOpp returns the time of an opposition of Mars.
 *
 * Result is time (as a jde) of the event nearest the given time (as a
 * decimal year.)
 */ parcelHelpers.export(exports, "marsOpp", function() {
    return marsOpp;
});
/**
 * SumA computes the sum of periodic terms with "additional angles"
 */ parcelHelpers.export(exports, "sumA", function() {
    return sumA;
});
/**
 * Msa returns a mean time corrected by a sum.
 */ parcelHelpers.export(exports, "msa", function() {
    return msa;
});
/**
 * JupiterOpp returns the time of an opposition of Jupiter.
 *
 * Result is time (as a jde) of the event nearest the given time (as a
 * decimal year.)
 */ parcelHelpers.export(exports, "jupiterOpp", function() {
    return jupiterOpp;
});
/**
 * SaturnOpp returns the time of an opposition of Saturn.
 *
 * Result is time (as a jde) of the event nearest the given time (as a
 * decimal year.)
 */ parcelHelpers.export(exports, "saturnOpp", function() {
    return saturnOpp;
});
/**
 * SaturnConj returns the time of a conjunction of Saturn.
 *
 * Result is time (as a jde) of the event nearest the given time (as a
 * decimal year.)
 */ parcelHelpers.export(exports, "saturnConj", function() {
    return saturnConj;
});
/**
 * UranusOpp returns the time of an opposition of Uranus.
 *
 * Result is time (as a jde) of the event nearest the given time (as a
 * decimal year.)
 */ parcelHelpers.export(exports, "uranusOpp", function() {
    return uranusOpp;
});
/**
 * NeptuneOpp returns the time of an opposition of Neptune.
 *
 * Result is time (as a jde) of the event nearest the given time (as a
 * decimal year.)
 */ parcelHelpers.export(exports, "neptuneOpp", function() {
    return neptuneOpp;
});
/**
 * El computes time and elongation of a greatest elongation event.
 */ parcelHelpers.export(exports, "el", function() {
    return el;
});
/**
 * MercuryEastElongation returns the time and elongation of a greatest eastern elongation of Mercury.
 *
 * Result is time (as a jde) of the event nearest the given time (as a
 * decimal year.)
 */ parcelHelpers.export(exports, "mercuryEastElongation", function() {
    return mercuryEastElongation;
});
/**
 * MercuryWestElongation returns the time and elongation of a greatest western elongation of Mercury.
 *
 * Result is time (as a jde) of the event nearest the given time (as a
 * decimal year.)
 */ parcelHelpers.export(exports, "mercuryWestElongation", function() {
    return mercuryWestElongation;
});
parcelHelpers.export(exports, "marsStation2", function() {
    return marsStation2;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
function mean(y, a) {
    // (36.1) p. 250
    var k = Math.floor((365.2425 * y + 1721060 - a.A) / a.B + 0.5);
    var J = a.A + k * a.B;
    var M = (0, _baseJsDefault.default).pmod(a.M0 + k * a.M1, 360) * Math.PI / 180;
    var T = (0, _baseJsDefault.default).J2000Century(J);
    return [
        J,
        M,
        T
    ];
}
function sum(T, M, c) {
    var j = (0, _baseJsDefault.default).horner(T, c[0]);
    var mm = 0.0;
    for(var i = 1; i < c.length; i++){
        mm += M;
        var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(mm), 2), smm = _base_sincos[0], cmm = _base_sincos[1];
        j += smm * (0, _baseJsDefault.default).horner(T, c[i]);
        i++;
        j += cmm * (0, _baseJsDefault.default).horner(T, c[i]);
    }
    return j;
}
function ms(y, a, c) {
    var _mean = (0, _slicedToArray._)(mean(y, a), 3), J = _mean[0], M = _mean[1], T = _mean[2];
    return J + sum(T, M, c);
}
function mercuryInfConj(y) {
    return ms(y, micA, micB);
}
function mercurySupConj(y) {
    return ms(y, mscA, mscB);
}
function venusInfConj(y) {
    return ms(y, vicA, vicB);
}
function marsOpp(y) {
    return ms(y, moA, moB);
}
function sumA(T, M, c, aa) {
    var i = c.length - 2 * aa.length;
    var j = sum(T, M, c.slice(0, i));
    for(var k = 0; k < aa.length; k++){
        var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos((aa[k].c + aa[k].f * T) * Math.PI / 180), 2), saa = _base_sincos[0], caa = _base_sincos[1];
        j += saa * (0, _baseJsDefault.default).horner(T, c[i]);
        i++;
        j += caa * (0, _baseJsDefault.default).horner(T, c[i]);
        i++;
    }
    return j;
}
function msa(y, a, c, aa) {
    var _mean = (0, _slicedToArray._)(mean(y, a), 3), J = _mean[0], M = _mean[1], T = _mean[2];
    return J + sumA(T, M, c, aa);
}
function jupiterOpp(y) {
    return msa(y, joA, joB, jaa);
}
function saturnOpp(y) {
    return msa(y, soA, soB, saa);
}
function saturnConj(y) {
    return msa(y, scA, scB, saa);
}
function uranusOpp(y) {
    return msa(y, uoA, uoB, uaa);
}
function neptuneOpp(y) {
    return msa(y, noA, noB, naa);
}
function el(y, a, t, e) {
    var _mean = (0, _slicedToArray._)(mean(y, micA), 3), J = _mean[0], M = _mean[1], T = _mean[2];
    return [
        J + sum(T, M, t),
        sum(T, M, e) * Math.PI / 180
    ];
}
function mercuryEastElongation(y) {
    return el(y, micA, met, mee);
}
function mercuryWestElongation(y) {
    return el(y, micA, mwt, mwe);
}
function marsStation2(y) {
    var _mean = (0, _slicedToArray._)(mean(y, moA), 3), J = _mean[0], M = _mean[1], T = _mean[2];
    return J + sum(T, M, ms2);
}
/**
 * ca holds coefficients from one line of table 36.A, p. 250
 */ function Ca(A, B, M0, M1) {
    this.A = A;
    this.B = B;
    this.M0 = M0;
    this.M1 = M1;
}
/**
 * Table 36.A, p. 250
 */ var micA = new Ca(2451612.023, 115.8774771, 63.5867, 114.2088742);
var mscA = new Ca(2451554.084, 115.8774771, 6.4822, 114.2088742);
var vicA = new Ca(2451996.706, 583.921361, 82.7311, 215.513058);
var moA = new Ca(2452097.382, 779.936104, 181.9573, 48.705244);
var joA = new Ca(2451870.628, 398.884046, 318.4681, 33.140229);
var soA = new Ca(2451870.17, 378.091904, 318.0172, 12.647487);
var scA = new Ca(2451681.124, 378.091904, 131.6934, 12.647487);
var uoA = new Ca(2451764.317, 369.656035, 213.6884, 4.333093);
var noA = new Ca(2451753.122, 367.486703, 202.6544, 2.194998);
/**
 * caa holds coefficients for "additional angles" for outer planets
 * as given on p. 251
 */ function Caa(c, f) {
    this.c = c;
    this.f = f;
}
var jaa = [
    new Caa(82.74, 40.76)
];
var saa = [
    new Caa(82.74, 40.76),
    new Caa(29.86, 1181.36),
    new Caa(14.13, 590.68),
    new Caa(220.02, 1262.87)
];
var uaa = [
    new Caa(207.83, 8.51),
    new Caa(108.84, 419.96)
];
var naa = [
    new Caa(207.83, 8.51),
    new Caa(276.74, 209.98)
];
/**
 * Table 33.B, p. 256
 */ /**
 * Mercury inferior conjunction
 */ var micB = [
    [
        0.0545,
        0.0002
    ],
    [
        -6.2008,
        0.0074,
        0.00003
    ],
    [
        -3.275,
        -0.0197,
        0.00001
    ],
    [
        0.4737,
        -0.0052,
        -0.00001
    ],
    [
        0.8111,
        0.0033,
        -0.00002
    ],
    [
        0.0037,
        0.0018
    ],
    [
        -0.1768,
        0,
        0.00001
    ],
    [
        -0.0211,
        -0.0004
    ],
    [
        0.0326,
        -0.0003
    ],
    [
        0.0083,
        0.0001
    ],
    [
        -0.004,
        0.0001
    ]
];
/**
 * Mercury superior conjunction
 */ var mscB = [
    [
        -0.0548,
        -0.0002
    ],
    [
        7.3894,
        -0.01,
        -0.00003
    ],
    [
        3.22,
        0.0197,
        -0.00001
    ],
    [
        0.8383,
        -0.0064,
        -0.00001
    ],
    [
        0.9666,
        0.0039,
        -0.00003
    ],
    [
        0.077,
        -0.0026
    ],
    [
        0.2758,
        0.0002,
        -0.00002
    ],
    [
        -0.0128,
        -0.0008
    ],
    [
        0.0734,
        -0.0004,
        -0.00001
    ],
    [
        -0.0122,
        -0.0002
    ],
    [
        0.0173,
        -0.0002
    ]
];
/**
 * Venus inferior conjunction
 */ var vicB = [
    [
        -0.0096,
        0.0002,
        -0.00001
    ],
    [
        2.0009,
        -0.0033,
        -0.00001
    ],
    [
        0.598,
        -0.0104,
        0.00001
    ],
    [
        0.0967,
        -0.0018,
        -0.00003
    ],
    [
        0.0913,
        0.0009,
        -0.00002
    ],
    [
        0.0046,
        -0.0002
    ],
    [
        0.0079,
        0.0001
    ]
];
/**
 * Mars opposition
 */ var moB = [
    [
        -0.3088,
        0,
        0.00002
    ],
    [
        -17.6965,
        0.0363,
        0.00005
    ],
    [
        18.3131,
        0.0467,
        -0.00006
    ],
    [
        -0.2162,
        -0.0198,
        -0.00001
    ],
    [
        -4.5028,
        -0.0019,
        0.00007
    ],
    [
        0.8987,
        0.0058,
        -0.00002
    ],
    [
        0.7666,
        -0.005,
        -0.00003
    ],
    [
        -0.3636,
        -0.0001,
        0.00002
    ],
    [
        0.0402,
        0.0032
    ],
    [
        0.0737,
        -0.0008
    ],
    [
        -0.098,
        -0.0011
    ]
];
/**
 * Jupiter opposition
 */ var joB = [
    [
        -0.1029,
        0,
        -0.00009
    ],
    [
        -1.9658,
        -0.0056,
        0.00007
    ],
    [
        6.1537,
        0.021,
        -0.00006
    ],
    [
        -0.2081,
        -0.0013
    ],
    [
        -0.1116,
        -0.001
    ],
    [
        0.0074,
        0.0001
    ],
    [
        -0.0097,
        -0.0001
    ],
    [
        0,
        0.0144,
        -0.00008
    ],
    [
        0.3642,
        -0.0019,
        -0.00029
    ]
];
/**
 * Saturn opposition
 */ var soB = [
    [
        -0.0209,
        0.0006,
        0.00023
    ],
    [
        4.5795,
        -0.0312,
        -0.00017
    ],
    [
        1.1462,
        -0.0351,
        0.00011
    ],
    [
        0.0985,
        -0.0015
    ],
    [
        0.0733,
        -0.0031,
        0.00001
    ],
    [
        0.0025,
        -0.0001
    ],
    [
        0.005,
        -0.0002
    ],
    [
        0,
        -0.0337,
        0.00018
    ],
    [
        -0.851,
        0.0044,
        0.00068
    ],
    [
        0,
        -0.0064,
        0.00004
    ],
    [
        0.2397,
        -0.0012,
        -0.00008
    ],
    [
        0,
        -0.001
    ],
    [
        0.1245,
        0.0006
    ],
    [
        0,
        0.0024,
        -0.00003
    ],
    [
        0.0477,
        -0.0005,
        -0.00006
    ]
];
/**
 * Saturn conjunction
 */ var scB = [
    [
        0.0172,
        -0.0006,
        0.00023
    ],
    [
        -8.5885,
        0.0411,
        0.00020
    ],
    [
        -1.147,
        0.0352,
        -0.00011
    ],
    [
        0.3331,
        -0.0034,
        -0.00001
    ],
    [
        0.1145,
        -0.0045,
        0.00002
    ],
    [
        -0.0169,
        0.0002
    ],
    [
        -0.0109,
        0.0004
    ],
    [
        0,
        -0.0337,
        0.00018
    ],
    [
        -0.851,
        0.0044,
        0.00068
    ],
    [
        0,
        -0.0064,
        0.00004
    ],
    [
        0.2397,
        -0.0012,
        -0.00008
    ],
    [
        0,
        -0.001
    ],
    [
        0.1245,
        0.0006
    ],
    [
        0,
        0.0024,
        -0.00003
    ],
    [
        0.0477,
        -0.0005,
        -0.00006
    ]
];
/**
 * Uranus opposition
 */ var uoB = [
    [
        0.0844,
        -0.0006
    ],
    [
        -0.1048,
        0.0246
    ],
    [
        -5.1221,
        0.0104,
        0.00003
    ],
    [
        -0.1428,
        0.0005
    ],
    [
        -0.0148,
        -0.0013
    ],
    [
        0
    ],
    [
        0.0055
    ],
    [
        0
    ],
    [
        0.885
    ],
    [
        0
    ],
    [
        0.2153
    ]
];
/**
 * Neptune opposition [
 */ var noB = [
    [
        -0.014,
        0,
        0.00001
    ],
    [
        -1.3486,
        0.001,
        0.00001
    ],
    [
        0.8597,
        0.0037
    ],
    [
        -0.0082,
        -0.0002,
        0.00001
    ],
    [
        0.0037,
        -0.0003
    ],
    [
        0
    ],
    [
        -0.5964
    ],
    [
        0
    ],
    [
        0.0728
    ]
];
/**
 * Table 36.C, p. 259
 */ /**
 * Mercury east time correction
 */ var met = [
    [
        -21.6106,
        0.0002
    ],
    [
        -1.9803,
        -0.006,
        0.00001
    ],
    [
        1.4151,
        -0.0072,
        -0.00001
    ],
    [
        0.5528,
        -0.0005,
        -0.00001
    ],
    [
        0.2905,
        0.0034,
        0.00001
    ],
    [
        -0.1121,
        -0.0001,
        0.00001
    ],
    [
        -0.0098,
        -0.0015
    ],
    [
        0.0192
    ],
    [
        0.0111,
        0.0004
    ],
    [
        -0.0061
    ],
    [
        -0.0032,
        -0.0001
    ]
];
/**
 * Mercury east elongation
 */ var mee = [
    [
        22.4697
    ],
    [
        -4.2666,
        0.0054,
        0.00002
    ],
    [
        -1.8537,
        -0.0137
    ],
    [
        0.3598,
        0.0008,
        -0.00001
    ],
    [
        -0.068,
        0.0026
    ],
    [
        -0.0524,
        -0.0003
    ],
    [
        0.0052,
        -0.0006
    ],
    [
        0.0107,
        0.0001
    ],
    [
        -0.0013,
        0.0001
    ],
    [
        -0.0021
    ],
    [
        0.0003
    ]
];
/**
 * Mercury west time correction
 */ var mwt = [
    [
        21.6249,
        -0.0002
    ],
    [
        0.1306,
        0.0065
    ],
    [
        -2.7661,
        -0.0011,
        0.00001
    ],
    [
        0.2438,
        -0.0024,
        -0.00001
    ],
    [
        0.5767,
        0.0023
    ],
    [
        0.1041
    ],
    [
        -0.0184,
        0.0007
    ],
    [
        -0.0051,
        -0.0001
    ],
    [
        0.0048,
        0.0001
    ],
    [
        0.0026
    ],
    [
        0.0037
    ]
];
/**
 * Mercury west elongation
 */ var mwe = [
    [
        22.4143,
        -0.0001
    ],
    [
        4.3651,
        -0.0048,
        -0.00002
    ],
    [
        2.3787,
        0.0121,
        -0.00001
    ],
    [
        0.2674,
        0.0022
    ],
    [
        -0.3873,
        0.0008,
        0.00001
    ],
    [
        -0.0369,
        -0.0001
    ],
    [
        0.0017,
        -0.0001
    ],
    [
        0.0059
    ],
    [
        0.0061,
        0.0001
    ],
    [
        0.0007
    ],
    [
        -0.0011
    ]
];
/**
 * Table 36.D, p. 261
 */ /**
 * Mars Station 2
 */ var ms2 = [
    [
        36.7191,
        0.0016,
        0.00003
    ],
    [
        -12.6163,
        0.0417,
        -0.00001
    ],
    [
        20.1218,
        0.0379,
        -0.00006
    ],
    [
        -1.636,
        -0.019
    ],
    [
        -3.9657,
        0.0045,
        0.00007
    ],
    [
        1.1546,
        0.0029,
        -0.00003
    ],
    [
        0.2888,
        -0.0073,
        -0.00002
    ],
    [
        -0.3128,
        0.0017,
        0.00002
    ],
    [
        0.2513,
        0.0026,
        -0.00002
    ],
    [
        -0.0021,
        -0.0016
    ],
    [
        -0.1497,
        -0.0006
    ]
];
exports.default = {
    mean: mean,
    sum: sum,
    ms: ms,
    mercuryInfConj: mercuryInfConj,
    mercurySupConj: mercurySupConj,
    venusInfConj: venusInfConj,
    marsOpp: marsOpp,
    sumA: sumA,
    msa: msa,
    jupiterOpp: jupiterOpp,
    saturnOpp: saturnOpp,
    saturnConj: saturnConj,
    uranusOpp: uranusOpp,
    neptuneOpp: neptuneOpp,
    el: el,
    mercuryEastElongation: mercuryEastElongation,
    mercuryWestElongation: mercuryWestElongation,
    marsStation2: marsStation2
};

},{"@swc/helpers/_/_sliced_to_array":"ha6sq","./base.js":"lEDxD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"a7zDU":[function(require,module,exports,__globalThis) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module pluto
 */ /**
 * Pluto: Chapter 37, Pluto.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Heliocentric returns J2000 heliocentric coordinates of Pluto.
 *
 * Results l, b are solar longitude and latitude in radians.
 * Result r is distance in AU.
 */ parcelHelpers.export(exports, "heliocentric", function() {
    return heliocentric;
});
/**
 * Astrometric returns J2000 astrometric coordinates of Pluto.
 */ parcelHelpers.export(exports, "astrometric", function() {
    return astrometric;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var _ellipticJs = require("./elliptic.js");
var _ellipticJsDefault = parcelHelpers.interopDefault(_ellipticJs);
function heliocentric(jde) {
    var l = 0;
    var b = 0;
    var r = 0;
    var T = (0, _baseJsDefault.default).J2000Century(jde);
    var J = 34.35 + 3034.9057 * T;
    var S = 50.08 + 1222.1138 * T;
    var P = 238.96 + 144.96 * T;
    for(var i in t37){
        var t = t37[i];
        var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos((t.i * J + t.j * S + t.k * P) * Math.PI / 180), 2), s\u03B1 = _base_sincos[0], c\u03B1 = _base_sincos[1];
        l += t.lA * s\u03B1 + t.lB * c\u03B1;
        b += t.bA * s\u03B1 + t.bB * c\u03B1;
        r += t.rA * s\u03B1 + t.rB * c\u03B1;
    }
    l = (l + 238.958116 + 144.96 * T) * Math.PI / 180;
    b = (b - 3.908239) * Math.PI / 180;
    r += 40.7241346;
    return {
        lon: l,
        lat: b,
        range: r
    };
}
function astrometric(jde, earth) {
    var s\u03B5 = (0, _baseJsDefault.default).SOblJ2000;
    var c\u03B5 = (0, _baseJsDefault.default).COblJ2000;
    var f = function f(jde) {
        var _heliocentric = heliocentric(jde), lon = _heliocentric.lon, lat = _heliocentric.lat, range = _heliocentric.range;
        var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(lon), 2), sl = _base_sincos[0], cl = _base_sincos[1];
        var _base_sincos1 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(lat), 2), sb = _base_sincos1[0], cb = _base_sincos1[1];
        // (37.1) p. 264
        var x = range * cl * cb;
        var y = range * (sl * cb * c\u03B5 - sb * s\u03B5);
        var z = range * (sl * cb * s\u03B5 + sb * c\u03B5);
        return {
            x: x,
            y: y,
            z: z
        };
    };
    var c = (0, _ellipticJsDefault.default).astrometricJ2000(f, jde, earth) // eslint-disable-line no-unused-vars
    ;
    return new (0, _baseJsDefault.default).Coord(c.ra, c.dec);
}
function Pt(i, j, k, lA, lB, bA, bB, rA, rB) {
    this.i = i;
    this.j = j;
    this.k = k;
    this.lA = lA;
    this.lB = lB;
    this.bA = bA;
    this.bB = bB;
    this.rA = rA;
    this.rB = rB;
}
var t37 = [
    new Pt(0, 0, 1, -19.799805, 19.850055, -5.452852, -14.974862, 6.6865439, 6.8951812),
    new Pt(0, 0, 2, 0.897144, -4.954829, 3.527812, 1.67279, -1.1827535, -0.0332538),
    new Pt(0, 0, 3, 0.611149, 1.211027, -1.050748, 0.327647, 0.1593179, -0.143889),
    new Pt(0, 0, 4, -0.341243, -0.189585, 0.17869, -0.292153, -0.0018444, 0.048322),
    new Pt(0, 0, 5, 0.129287, -0.034992, 0.01865, 0.10034, -0.0065977, -0.0085431),
    new Pt(0, 0, 6, -0.038164, 0.030893, -0.030697, -0.025823, 0.0031174, -0.0006032),
    new Pt(0, 1, -1, 0.020442, -0.009987, 0.004878, 0.011248, -0.0005794, 0.0022161),
    new Pt(0, 1, 0, -0.004063, -0.005071, 0.000226, -0.000064, 0.0004601, 0.0004032),
    new Pt(0, 1, 1, -0.006016, -0.003336, 0.00203, -0.000836, -0.0001729, 0.0000234),
    new Pt(0, 1, 2, -0.003956, 0.003039, 0.000069, -0.000604, -0.0000415, 0.0000702),
    new Pt(0, 1, 3, -0.000667, 0.003572, -0.000247, -0.000567, 0.0000239, 0.0000723),
    new Pt(0, 2, -2, 0.001276, 0.000501, -0.000057, 0.000001, 0.0000067, -0.0000067),
    new Pt(0, 2, -1, 0.001152, -0.000917, -0.000122, 0.000175, 0.0001034, -0.0000451),
    new Pt(0, 2, 0, 0.00063, -0.001277, -0.000049, -0.000164, -0.0000129, 0.0000504),
    new Pt(1, -1, 0, 0.002571, -0.000459, -0.000197, 0.000199, 0.000048, -0.0000231),
    new Pt(1, -1, 1, 0.000899, -0.001449, -0.000025, 0.000217, 0.0000002, -0.0000441),
    new Pt(1, 0, -3, -0.001016, 0.001043, 0.000589, -0.000248, -0.0003359, 0.0000265),
    new Pt(1, 0, -2, -0.002343, -0.001012, -0.000269, 0.000711, 0.0007856, -0.0007832),
    new Pt(1, 0, -1, 0.007042, 0.000788, 0.000185, 0.000193, 0.0000036, 0.0045763),
    new Pt(1, 0, 0, 0.001199, -0.000338, 0.000315, 0.000807, 0.0008663, 0.0008547),
    new Pt(1, 0, 1, 0.000418, -0.000067, -0.00013, -0.000043, -0.0000809, -0.0000769),
    new Pt(1, 0, 2, 0.00012, -0.000274, 0.000005, 0.000003, 0.0000263, -0.0000144),
    new Pt(1, 0, 3, -0.00006, -0.000159, 0.000002, 0.000017, -0.0000126, 0.0000032),
    new Pt(1, 0, 4, -0.000082, -0.000029, 0.000002, 0.000005, -0.0000035, -0.0000016),
    new Pt(1, 1, -3, -0.000036, -0.000029, 0.000002, 0.000003, -0.0000019, -0.0000004),
    new Pt(1, 1, -2, -0.00004, 0.000007, 0.000003, 0.000001, -0.0000015, 0.0000008),
    new Pt(1, 1, -1, -0.000014, 0.000022, 0.000002, -0.000001, -0.0000004, 0.0000012),
    new Pt(1, 1, 0, 0.000004, 0.000013, 0.000001, -0.000001, 0.0000005, 0.0000006),
    new Pt(1, 1, 1, 0.000005, 0.000002, 0, -0.000001, 0.0000003, 0.0000001),
    new Pt(1, 1, 3, -0.000001, 0, 0, 0, 0.0000006, -0.0000002),
    new Pt(2, 0, -6, 0.000002, 0, 0, -0.000002, 0.0000002, 0.0000002),
    new Pt(2, 0, -5, -0.000004, 0.000005, 0.000002, 0.000002, -0.0000002, -0.0000002),
    new Pt(2, 0, -4, 0.000004, -0.000007, -0.000007, 0, 0.0000014, 0.0000013),
    new Pt(2, 0, -3, 0.000014, 0.000024, 0.00001, -0.000008, -0.0000063, 0.0000013),
    new Pt(2, 0, -2, -0.000049, -0.000034, -0.000003, 0.00002, 0.0000136, -0.0000236),
    new Pt(2, 0, -1, 0.000163, -0.000048, 0.000006, 0.000005, 0.0000273, 0.0001065),
    new Pt(2, 0, 0, 0.000009, -0.000024, 0.000014, 0.000017, 0.0000251, 0.0000149),
    new Pt(2, 0, 1, -0.000004, 0.000001, -0.000002, 0, -0.0000025, -0.0000009),
    new Pt(2, 0, 2, -0.000003, 0.000001, 0, 0, 0.0000009, -0.0000002),
    new Pt(2, 0, 3, 0.000001, 0.000003, 0, 0, -0.0000008, 0.0000007),
    new Pt(3, 0, -2, -0.000003, -0.000001, 0, 0.000001, 0.0000002, -0.000001),
    new Pt(3, 0, -1, 0.000005, -0.000003, 0, 0, 0.0000019, 0.0000035),
    new Pt(3, 0, 0, 0, 0, 0.000001, 0, 0.000001, 0.0000003)
];
exports.default = {
    heliocentric: heliocentric,
    astrometric: astrometric
};

},{"@swc/helpers/_/_sliced_to_array":"ha6sq","./base.js":"lEDxD","./elliptic.js":"01gWQ","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"axMFf":[function(require,module,exports,__globalThis) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module refraction
 */ /**
 * Refraction: Chapter 16: Atmospheric Refraction.
 *
 * Functions here assume atmospheric pressure of 1010 mb, temperature of
 * 10°C, and yellow light.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * gt15True returns refraction for obtaining true altitude when altitude
 * is greater than 15 degrees (about 0.26 radians.)
 *
 * h0 must be a measured apparent altitude of a celestial body in radians.
 *
 * Result is refraction to be subtracted from h0 to obtain the true altitude
 * of the body.  Unit is radians.
 */ parcelHelpers.export(exports, "gt15True", function() {
    return gt15True;
});
/**
 * gt15Apparent returns refraction for obtaining apparent altitude when
 * altitude is greater than 15 degrees (about 0.26 radians.)
 *
 * h must be a computed true "airless" altitude of a celestial body in radians.
 *
 * Result is refraction to be added to h to obtain the apparent altitude
 * of the body.  Unit is radians.
 */ parcelHelpers.export(exports, "gt15Apparent", function() {
    return gt15Apparent;
});
/**
 * Bennett returns refraction for obtaining true altitude.
 *
 * h0 must be a measured apparent altitude of a celestial body in radians.
 *
 * Results are accurate to 0.07 arc min from horizon to zenith.
 *
 * Result is refraction to be subtracted from h0 to obtain the true altitude
 * of the body.  Unit is radians.
 */ parcelHelpers.export(exports, "bennett", function() {
    return bennett;
});
/**
 * Bennett2 returns refraction for obtaining true altitude.
 *
 * Similar to Bennett, but a correction is applied to give a more accurate
 * result.
 *
 * Results are accurate to 0.015 arc min.  Result unit is radians.
 */ parcelHelpers.export(exports, "bennett2", function() {
    return bennett2;
});
/**
 * Saemundsson returns refraction for obtaining apparent altitude.
 *
 * h must be a computed true "airless" altitude of a celestial body in radians.
 *
 * Result is refraction to be added to h to obtain the apparent altitude
 * of the body.
 *
 * Results are consistent with Bennett to within 4 arc sec.
 * Result unit is radians.
 */ parcelHelpers.export(exports, "saemundsson", function() {
    return saemundsson;
});
var _sexagesimalJs = require("./sexagesimal.js");
var _sexagesimalJsDefault = parcelHelpers.interopDefault(_sexagesimalJs);
var sin = Math.sin, tan = Math.tan;
var D2R = Math.PI / 180;
var gt15true1 = new (0, _sexagesimalJsDefault.default).Angle(false, 0, 0, 58.294).rad();
var gt15true2 = new (0, _sexagesimalJsDefault.default).Angle(false, 0, 0, 0.0668).rad();
var gt15app1 = new (0, _sexagesimalJsDefault.default).Angle(false, 0, 0, 58.276).rad();
var gt15app2 = new (0, _sexagesimalJsDefault.default).Angle(false, 0, 0, 0.0824).rad();
function gt15True(h0) {
    // (16.1) p. 105
    var t = tan(Math.PI / 2 - h0);
    return gt15true1 * t - gt15true2 * t * t * t;
}
function gt15Apparent(h) {
    // (16.2) p. 105
    var t = tan(Math.PI / 2 - h);
    return gt15app1 * t - gt15app2 * t * t * t;
}
function bennett(h0) {
    // (16.3) p. 106
    var c1 = D2R / 60;
    var c731 = 7.31 * D2R * D2R;
    var c44 = 4.4 * D2R;
    return c1 / tan(h0 + c731 / (h0 + c44));
}
function bennett2(h0) {
    var cMin = 60 / D2R;
    var c06 = 0.06 / cMin;
    var c147 = 14.7 * cMin * D2R;
    var c13 = 13 * D2R;
    var R = bennett(h0);
    return R - c06 * sin(c147 * R + c13);
}
function saemundsson(h) {
    // (16.4) p. 106
    var c102 = 1.02 * D2R / 60;
    var c103 = 10.3 * D2R * D2R;
    var c511 = 5.11 * D2R;
    return c102 / tan(h + c103 / (h + c511));
}
exports.default = {
    gt15True: gt15True,
    gt15Apparent: gt15Apparent,
    bennett: bennett,
    bennett2: bennett2,
    saemundsson: saemundsson
};

},{"./sexagesimal.js":"aLUGo","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"dhSt3":[function(require,module,exports,__globalThis) {
/* eslint key-spacing: 1 */ /**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module rise
 */ /**
 * Rise: Chapter 15, Rising, Transit, and Setting.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "errorAboveHorizon", function() {
    return errorAboveHorizon;
});
parcelHelpers.export(exports, "errorBelowHorizon", function() {
    return errorBelowHorizon;
});
parcelHelpers.export(exports, "meanRefraction", function() {
    return meanRefraction;
});
parcelHelpers.export(exports, "stdh0", function() {
    return stdh0;
});
/**
 * Helper function to obtain corrected refraction
 * @param {number} h0 - altitude of the body in radians containing `meanRefraction` of 0°34'
 * @param {number} [corr] - the calcluated refraction e.g. from package `refraction` in radians
 * @return {number} refraction value in radians
 */ parcelHelpers.export(exports, "refraction", function() {
    return refraction;
});
parcelHelpers.export(exports, "stdh0Stellar", function() {
    return stdh0Stellar;
});
parcelHelpers.export(exports, "Stdh0Stellar", function() {
    return Stdh0Stellar;
});
parcelHelpers.export(exports, "stdh0Solar", function() {
    return stdh0Solar;
});
parcelHelpers.export(exports, "Stdh0Solar", function() {
    return Stdh0Solar;
});
parcelHelpers.export(exports, "stdh0LunarMean", function() {
    return stdh0LunarMean;
});
parcelHelpers.export(exports, "Stdh0LunarMean", function() {
    return Stdh0LunarMean;
});
parcelHelpers.export(exports, "stdh0Lunar", function() {
    return stdh0Lunar;
});
parcelHelpers.export(exports, "Stdh0Lunar", function() {
    return Stdh0Lunar;
});
/**
 * @return {number} local angle in radians
 */ parcelHelpers.export(exports, "hourAngle", function() {
    return hourAngle;
});
/**
 * ApproxTimes computes approximate UT rise, transit and set times for
 * a celestial object on a day of interest.
 *
 * The function argurments do not actually include the day, but do include
 * values computed from the day.
 *
 * @param {GlobeCoord} p - is geographic coordinates of observer.
 * @param {number} h0 - is "standard altitude" of the body in radians
 * @param {number} Th0 - is apparent sidereal time at 0h UT at Greenwich in seconds
 *        (range 0...86400) must be the time on the day of interest, in seconds.
 *        See sidereal.apparent0UT
 * @param {number} α - right ascension (radians)
 * @param {number} δ - declination (radians)
 * @return {RiseObj} Result units are seconds and are in the range [0,86400)
 * @throws Error
 */ parcelHelpers.export(exports, "approxTimes", function() {
    return approxTimes;
});
/**
 * Times computes UT rise, transit and set times for a celestial object on
 * a day of interest.
 *
 * The function argurments do not actually include the day, but do include
 * a number of values computed from the day.
 *
 * @param {GlobeCoord} p - is geographic coordinates of observer.
 * @param {number} ΔT - is delta T in seconds
 * @param {number} h0 - is "standard altitude" of the body in radians
 * @param {number} Th0 - is apparent sidereal time at 0h UT at Greenwich in seconds
 *        (range 0...86400) must be the time on the day of interest, in seconds.
 *        See sidereal.apparent0UT
 * @param {Array<number>} α3 - slices of three right ascensions
 * @param {Array<number>} δ3 - slices of three declinations.
 *        α3, δ3 must be values at 0h dynamical time for the day before, the day of,
 *        and the day after the day of interest.  Units are radians.
 *
 * @return {RiseObj} Result units are seconds and are in the range [0,86400)
 * @throws Error
 */ parcelHelpers.export(exports, "times", function() {
    return times;
});
parcelHelpers.export(exports, "PlanetRise", function() {
    return PlanetRise;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var _deltatJs = require("./deltat.js");
var _deltatJsDefault = parcelHelpers.interopDefault(_deltatJs);
var _ellipticJs = require("./elliptic.js");
var _ellipticJsDefault = parcelHelpers.interopDefault(_ellipticJs);
var _interpolationJs = require("./interpolation.js");
var _interpolationJsDefault = parcelHelpers.interopDefault(_interpolationJs);
var _julianJs = require("./julian.js");
var _julianJsDefault = parcelHelpers.interopDefault(_julianJs);
var _sexagesimalJs = require("./sexagesimal.js");
var _sexagesimalJsDefault = parcelHelpers.interopDefault(_sexagesimalJs);
var _siderealJs = require("./sidereal.js");
var _siderealJsDefault = parcelHelpers.interopDefault(_siderealJs);
var _globeJs = require("./globe.js"); // eslint-disable-line no-unused-vars
var _planetpositionJs = require("./planetposition.js"); // eslint-disable-line no-unused-vars
var acos = Math.acos, asin = Math.asin, cos = Math.cos, sin = Math.sin;
/**
 * @typedef {object} RiseObj
 * @property {number} rise - in seconds
 * @property {number} transit - in seconds
 * @property {number} set - in seconds
 */ var SECS_PER_DEGREE = 240 // = 86400 / 360
;
var SECS_PER_DAY = 86400;
var D2R = Math.PI / 180;
var errorAboveHorizon = (0, _baseJsDefault.default).errorCode('always above horizon', -1);
var errorBelowHorizon = (0, _baseJsDefault.default).errorCode('always below horizon', 1);
var meanRefraction = new (0, _sexagesimalJsDefault.default).Angle(false, 0, 34, 0).rad();
var stdh0 = {
    stellar: -meanRefraction,
    solar: new (0, _sexagesimalJsDefault.default).Angle(true, 0, 50, 0).rad(),
    // not containing meanRefraction
    lunar: (0, _sexagesimalJsDefault.default).angleFromDeg(0.7275),
    lunarMean: (0, _sexagesimalJsDefault.default).angleFromDeg(0.125)
};
function refraction(h0, corr) {
    if (!corr) return h0;
    else return h0 - meanRefraction - corr;
}
var stdh0Stellar = function(_refraction) {
    return refraction(stdh0.stellar, _refraction);
};
var Stdh0Stellar = stdh0Stellar() // for backward-compatibility
;
var stdh0Solar = function(_refraction) {
    return refraction(stdh0.solar, _refraction);
};
var Stdh0Solar = stdh0Solar() // for backward-compatibility
;
var stdh0LunarMean = function(_refraction) {
    return stdh0.lunarMean - refraction(_refraction);
};
var Stdh0LunarMean = stdh0LunarMean() // for backward-compatibility
;
var stdh0Lunar = function(\u03C0, refraction) {
    return stdh0.lunar * \u03C0 - (refraction || meanRefraction);
};
var Stdh0Lunar = stdh0Lunar // for backward-compatibility
;
function hourAngle(lat, h0, \u03B4) {
    // approximate local hour angle
    var cosH = (sin(h0) - sin(lat) * sin(\u03B4)) / (cos(lat) * cos(\u03B4) // (15.1) p. 102
    );
    if (cosH < -1) throw errorAboveHorizon;
    else if (cosH > 1) throw errorBelowHorizon;
    var H = acos(cosH);
    return H;
}
/**
 * @param {number} lon - longitude in radians
 * @param {number} α - right ascension in radians
 * @param {number} th0 - sidereal.apparent0UT in seconds of day `[0...86400[`
 * @return {number} time of transit in seconds of day `[0, 86400[`
 */ function _mt(lon, \u03B1, th0) {
    // const mt = (((lon + α) * 180 / Math.PI - (th0 * 360 / 86400)) * 86400 / 360)
    var mt = (lon + \u03B1) * SECS_PER_DEGREE * 180 / Math.PI - th0;
    return mt;
}
/**
 * @param {number} Th0 - sidereal.apparent0UT in seconds of day `[0...86400[`
 * @param {number} m - motion in seconds of day `[0...86400[`
 * @return {number} new siderial time seconds of day `[0...86400[`
 */ function _th0(Th0, m) {
    // in original formula Th0 = 0...360 and m = 0...1 -> return value would be in 0...360 degrees
    // Th0 /= 240
    // m /= 86400
    var th0 = (0, _baseJsDefault.default).pmod(Th0 + m * 360.985647 / 360, SECS_PER_DAY) // p103
    ;
    return th0 // 0...86400 in seconds angle
    ;
}
/**
 * maintain backward compatibility - will be removed in v2
 * return value in future will be an object not an array
 * @private
 * @param {RiseObj} rs
 * @return {RiseObj}
 */ function _compatibility(rs) {
    var _rs = [
        rs.rise,
        rs.transit,
        rs.set
    ];
    _rs.rise = rs.rise;
    _rs.transit = rs.transit;
    _rs.set = rs.set;
    return _rs;
}
function approxTimes(p, h0, Th0, \u03B1, \u03B4) {
    var H0 = hourAngle(p.lat, h0, \u03B4) * SECS_PER_DEGREE * 180 / Math.PI // in degrees per day === seconds
    ;
    // approximate transit, rise, set times.
    // (15.2) p. 102.0
    var mt = _mt(p.lon, \u03B1, Th0);
    var rs = {};
    rs.transit = (0, _baseJsDefault.default).pmod(mt, SECS_PER_DAY);
    rs.rise = (0, _baseJsDefault.default).pmod(mt - H0, SECS_PER_DAY);
    rs.set = (0, _baseJsDefault.default).pmod(mt + H0, SECS_PER_DAY);
    return _compatibility(rs);
}
function times(p, \u0394T, h0, Th0, \u03B13, \u03B43) {
    var rs = approxTimes(p, h0, Th0, \u03B13[1], \u03B43[1]);
    var d3\u03B1 = new (0, _interpolationJsDefault.default).Len3(-SECS_PER_DAY, SECS_PER_DAY, \u03B13);
    var d3\u03B4 = new (0, _interpolationJsDefault.default).Len3(-SECS_PER_DAY, SECS_PER_DAY, \u03B43);
    // adjust mTransit
    var ut = rs.transit + \u0394T;
    var \u03B1 = d3\u03B1.interpolateX(ut);
    var th0 = _th0(Th0, rs.transit);
    var H = -1 * _mt(p.lon, \u03B1, th0) // in secs // Hmeus = 0...360
    ;
    rs.transit -= H;
    // adjust mRise, mSet
    var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(p.lat), 2), sLat = _base_sincos[0], cLat = _base_sincos[1];
    var adjustRS = function adjustRS(m) {
        var ut = m + \u0394T;
        var \u03B1 = d3\u03B1.interpolateX(ut);
        var \u03B4 = d3\u03B4.interpolateX(ut);
        var th0 = _th0(Th0, m);
        var H = -1 * _mt(p.lon, \u03B1, th0);
        var Hrad = H / SECS_PER_DEGREE * D2R;
        var h = asin(sLat * sin(\u03B4) + cLat * cos(\u03B4) * cos(Hrad)) // formula 13.6
        ;
        var \u0394m = SECS_PER_DAY * (h - h0) / (cos(\u03B4) * cLat * sin(Hrad) * 2 * Math.PI) // formula p103 3
        ;
        return m + \u0394m;
    };
    rs.rise = adjustRS(rs.rise);
    rs.set = adjustRS(rs.set);
    return _compatibility(rs);
}
var PlanetRise = /*#__PURE__*/ function() {
    "use strict";
    function PlanetRise(jd, lat, lon, earth, planet, opts) {
        (0, _classCallCheck._)(this, PlanetRise);
        this.opts = opts || {};
        this.refraction = this.opts.refraction || stdh0Stellar();
        if (jd instanceof Date) jd = new (0, _julianJsDefault.default).Calendar().fromDate(jd).toJD();
        this.jd = Math.floor(jd - 0.5) + 0.5 // start at midnight
        ;
        this.lat = lat * D2R // convert to radians
        ;
        this.lon = lon * D2R;
        var cal = new (0, _julianJsDefault.default).Calendar().fromJD(this.jd);
        this.jde = cal.toJDE();
        this.\u0394T = (0, _deltatJsDefault.default).deltaT(cal.toYear());
        this.earth = earth;
        this.planet = planet;
    }
    (0, _createClass._)(PlanetRise, [
        {
            key: "approxTimes",
            value: function approxTimes1() {
                var body = (0, _ellipticJsDefault.default).position(this.planet, this.earth, this.jde);
                var Th0 = (0, _siderealJsDefault.default).apparent0UT(this.jd);
                var rs = approxTimes({
                    lat: this.lat,
                    lon: this.lon
                }, this.refraction, Th0, body.ra, body.dec);
                return this._rsToJD(rs);
            }
        },
        {
            key: "times",
            value: function times1() {
                var body = [
                    (0, _ellipticJsDefault.default).position(this.planet, this.earth, this.jde - 1),
                    (0, _ellipticJsDefault.default).position(this.planet, this.earth, this.jde),
                    (0, _ellipticJsDefault.default).position(this.planet, this.earth, this.jde + 1)
                ];
                var Th0 = (0, _siderealJsDefault.default).apparent0UT(this.jd);
                var rs = times({
                    lat: this.lat,
                    lon: this.lon
                }, this.\u0394T, this.refraction, Th0, this._toArr(body, 'ra'), this._toArr(body, 'dec'));
                return this._rsToJD(rs);
            }
        },
        {
            /** @private */ key: "_toArr",
            value: function _toArr(body, p) {
                return body.map(function(item) {
                    return item[p];
                });
            }
        },
        {
            /** @private */ key: "_rsToJD",
            value: function _rsToJD(rs) {
                return {
                    rise: this._toJD(rs.rise),
                    transit: this._toJD(rs.transit),
                    set: this._toJD(rs.set)
                };
            }
        },
        {
            /** @private */ key: "_toJD",
            value: function _toJD(secs) {
                var jd = this.jd + secs / 86400;
                if (this.opts.date) return new (0, _julianJsDefault.default).Calendar().fromJD(jd).toDate();
                else return jd;
            }
        }
    ]);
    return PlanetRise;
}();
exports.default = {
    errorAboveHorizon: errorAboveHorizon,
    errorBelowHorizon: errorBelowHorizon,
    meanRefraction: meanRefraction,
    stdh0: stdh0,
    refraction: refraction,
    stdh0Stellar: stdh0Stellar,
    Stdh0Stellar: Stdh0Stellar,
    stdh0Solar: stdh0Solar,
    Stdh0Solar: Stdh0Solar,
    stdh0LunarMean: stdh0LunarMean,
    Stdh0LunarMean: Stdh0LunarMean,
    stdh0Lunar: stdh0Lunar,
    Stdh0Lunar: Stdh0Lunar,
    hourAngle: hourAngle,
    approxTimes: approxTimes,
    times: times,
    PlanetRise: PlanetRise
};

},{"@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","@swc/helpers/_/_sliced_to_array":"ha6sq","./base.js":"lEDxD","./deltat.js":"7sn4F","./elliptic.js":"01gWQ","./interpolation.js":"1h22R","./julian.js":"hLXQt","./sexagesimal.js":"aLUGo","./sidereal.js":"c4ZrF","./globe.js":"fqyqU","./planetposition.js":"8l87z","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"leX0f":[function(require,module,exports,__globalThis) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module saturnmoons
 */ /**
 * Saturnmoons: Chapter 46, Positions of the Satellites of Saturn
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mimas", function() {
    return mimas;
});
parcelHelpers.export(exports, "enceladus", function() {
    return enceladus;
});
parcelHelpers.export(exports, "tethys", function() {
    return tethys;
});
parcelHelpers.export(exports, "dione", function() {
    return dione;
});
parcelHelpers.export(exports, "rhea", function() {
    return rhea;
});
parcelHelpers.export(exports, "titan", function() {
    return titan;
});
parcelHelpers.export(exports, "hyperion", function() {
    return hyperion;
});
parcelHelpers.export(exports, "iapetus", function() {
    return iapetus;
});
/**
 * Positions returns positions of the eight major moons of Saturn.
 *
 * Results returned in argument pos, which must not be undefined.
 *
 * Result units are Saturn radii.
 *
 * @param {number} jde - Julian ephemeris day
 * @param {Planet} earth - VSOP87 planet Earth // eslint-disable-line no-unused-vars
 * @param {Planet} saturn - VSOP87 planet Saturn // eslint-disable-line no-unused-vars
 * @return {XY[]} Array of Moon Positions in `XY`
 *   Use `M.mimas ... M.iapetus` to resolve to Moon and its position at `jde`
 */ parcelHelpers.export(exports, "positions", function() {
    return positions;
});
parcelHelpers.export(exports, "Qs", function() {
    return Qs;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var _coordJs = require("./coord.js");
var _coordJsDefault = parcelHelpers.interopDefault(_coordJs);
var _planetpositionJs = require("./planetposition.js"); // eslint-disable-line no-unused-vars
var _planetpositionJsDefault = parcelHelpers.interopDefault(_planetpositionJs);
var _precessJs = require("./precess.js");
var _precessJsDefault = parcelHelpers.interopDefault(_precessJs);
var _solarJs = require("./solar.js");
var _solarJsDefault = parcelHelpers.interopDefault(_solarJs);
var mimas = 0;
var enceladus = 1;
var tethys = 2;
var dione = 3;
var rhea = 4;
var titan = 5;
var hyperion = 6;
var iapetus = 7;
/**
 * XY holds coordinates returned from positions().
 */ function XY(x, y) {
    this.x = x;
    this.y = y;
}
var d = Math.PI / 180;
function positions(jde, earth, saturn) {
    var sol = (0, _solarJsDefault.default).trueVSOP87(earth, jde);
    var _ref = [
        sol.lon,
        sol.lat,
        sol.range
    ], s = _ref[0], \u03B2 = _ref[1], R = _ref[2];
    var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(s), 2), ss = _base_sincos[0], cs = _base_sincos[1];
    var s\u03B2 = Math.sin(\u03B2);
    var \u0394 = 9.0;
    var x;
    var y;
    var z = 0;
    var _jde;
    var f = function f() {
        var \u03C4 = (0, _baseJsDefault.default).lightTime(\u0394);
        _jde = jde - \u03C4;
        var _saturn_position = saturn.position(_jde), lon = _saturn_position.lon, lat = _saturn_position.lat, range = _saturn_position.range;
        var fk5 = (0, _planetpositionJsDefault.default).toFK5(lon, lat, _jde) // eslint-disable-line no-unused-vars
        ;
        var _ref = [
            fk5.lon,
            fk5.lat
        ], l = _ref[0], b = _ref[1];
        var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(l), 2), sl = _base_sincos[0], cl = _base_sincos[1];
        var _base_sincos1 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(b), 2), sb = _base_sincos1[0], cb = _base_sincos1[1];
        x = range * cb * cl + R * cs;
        y = range * cb * sl + R * ss;
        z = range * sb + R * s\u03B2;
        \u0394 = Math.sqrt(x * x + y * y + z * z);
    };
    f();
    f();
    var \u03BB0 = Math.atan2(y, x);
    var \u03B20 = Math.atan(z / Math.hypot(x, y));
    var ecl = new (0, _coordJsDefault.default).Ecliptic(\u03BB0, \u03B20);
    ecl = (0, _precessJsDefault.default).eclipticPosition(ecl, (0, _baseJsDefault.default).JDEToJulianYear(jde), (0, _baseJsDefault.default).JDEToJulianYear((0, _baseJsDefault.default).B1950));
    \u03BB0 = ecl.lon;
    \u03B20 = ecl.lat;
    var q = new Qs(_jde);
    var s4 = [
        new R4(),
        q.mimas(),
        q.enceladus(),
        q.tethys(),
        q.dione(),
        q.rhea(),
        q.titan(),
        q.hyperion(),
        q.iapetus()
    ];
    var X = new Array(9).fill(0);
    var Y = new Array(9).fill(0);
    var Z = new Array(9).fill(0);
    for(var j = 1; j <= 8; j++){
        var u = s4[j].\u03BB - s4[j].\u03A9;
        var w = s4[j].\u03A9 - 168.8112 * d;
        var _base_sincos1 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(u), 2), su = _base_sincos1[0], cu = _base_sincos1[1];
        var _base_sincos2 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(w), 2), sw = _base_sincos2[0], cw = _base_sincos2[1];
        var _base_sincos3 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(s4[j].\u03B3), 2), s\u03B3 = _base_sincos3[0], c\u03B3 = _base_sincos3[1];
        var r = s4[j].r;
        X[j] = r * (cu * cw - su * c\u03B3 * sw);
        Y[j] = r * (su * cw * c\u03B3 + cu * sw);
        Z[j] = r * su * s\u03B3;
    }
    Z[0] = 1;
    var _base_sincos4 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03BB0), 2), s\u03BB0 = _base_sincos4[0], c\u03BB0 = _base_sincos4[1];
    var _base_sincos5 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03B20), 2), s\u03B20 = _base_sincos5[0], c\u03B20 = _base_sincos5[1];
    var A = new Array(9).fill(0);
    var B = new Array(9).fill(0);
    var C = new Array(9).fill(0);
    for(var j1 in X){
        var a = X[j1];
        var b = q.c1 * Y[j1] - q.s1 * Z[j1];
        var c = q.s1 * Y[j1] + q.c1 * Z[j1];
        var a0 = q.c2 * a - q.s2 * b;
        b = q.s2 * a + q.c2 * b;
        a = a0;
        A[j1] = a * s\u03BB0 - b * c\u03BB0;
        b = a * c\u03BB0 + b * s\u03BB0;
        B[j1] = b * c\u03B20 + c * s\u03B20;
        C[j1] = c * c\u03B20 - b * s\u03B20;
    }
    var pos = new Array(9);
    var D = Math.atan2(A[0], C[0]);
    var _base_sincos6 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(D), 2), sD = _base_sincos6[0], cD = _base_sincos6[1];
    for(var j2 = 1; j2 <= 8; j2++){
        X[j2] = A[j2] * cD - C[j2] * sD;
        Y[j2] = A[j2] * sD + C[j2] * cD;
        Z[j2] = B[j2];
        var d1 = X[j2] / s4[j2].r;
        X[j2] += Math.abs(Z[j2]) / k[j2] * Math.sqrt(1 - d1 * d1);
        var W = \u0394 / (\u0394 + Z[j2] / 2475);
        pos[j2 - 1] = new XY(X[j2] * W, Y[j2] * W);
    }
    return pos;
}
var k = [
    0,
    20947,
    23715,
    26382,
    29876,
    35313,
    53800,
    59222,
    91820
];
function R4(\u03BB, r, \u03B3, \u03A9) {
    this.\u03BB = \u03BB || 0;
    this.r = r || 0;
    this.\u03B3 = \u03B3 || 0;
    this.\u03A9 = \u03A9 || 0;
}
function Qs(jde) {
    this.t1 = jde - 2411093;
    this.t2 = this.t1 / 365.25;
    this.t3 = (jde - 2433282.423) / 365.25 + 1950;
    this.t4 = jde - 2411368;
    this.t5 = this.t4 / 365.25;
    this.t6 = jde - 2415020;
    this.t7 = this.t6 / 36525;
    this.t8 = this.t6 / 365.25;
    this.t9 = (jde - 2442000.5) / 365.25;
    this.t10 = jde - 2409786;
    this.t11 = this.t10 / 36525;
    this.W0 = 5.095 * d * (this.t3 - 1866.39);
    this.W1 = 74.4 * d + 32.39 * d * this.t2;
    this.W2 = 134.3 * d + 92.62 * d * this.t2;
    this.W3 = 42 * d - 0.5118 * d * this.t5;
    this.W4 = 276.59 * d + 0.5118 * d * this.t5;
    this.W5 = 267.2635 * d + 1222.1136 * d * this.t7;
    this.W6 = 175.4762 * d + 1221.5515 * d * this.t7;
    this.W7 = 2.4891 * d + 0.002435 * d * this.t7;
    this.W8 = 113.35 * d - 0.2597 * d * this.t7;
    this.s1 = Math.sin(28.0817 * d);
    this.c1 = Math.cos(28.0817 * d);
    this.s2 = Math.sin(168.8112 * d);
    this.c2 = Math.cos(168.8112 * d);
    this.e1 = 0.05589 - 0.000346 * this.t7;
    this.sW0 = Math.sin(this.W0);
    this.s3W0 = Math.sin(3 * this.W0);
    this.s5W0 = Math.sin(5 * this.W0);
    this.sW1 = Math.sin(this.W1);
    this.sW2 = Math.sin(this.W2);
    this.sW3 = Math.sin(this.W3);
    this.cW3 = Math.cos(this.W3);
    this.sW4 = Math.sin(this.W4);
    this.cW4 = Math.cos(this.W4);
    this.sW7 = Math.sin(this.W7);
    this.cW7 = Math.cos(this.W7);
    return this;
}
Qs.prototype.mimas = function() {
    var r = new R4();
    var L = 127.64 * d + 381.994497 * d * this.t1 - 43.57 * d * this.sW0 - 0.72 * d * this.s3W0 - 0.02144 * d * this.s5W0;
    var p = 106.1 * d + 365.549 * d * this.t2;
    var M = L - p;
    var C = 2.18287 * d * Math.sin(M) + 0.025988 * d * Math.sin(2 * M) + 0.00043 * d * Math.sin(3 * M);
    r.\u03BB = L + C;
    r.r = 3.06879 / (1 + 0.01905 * Math.cos(M + C));
    r.\u03B3 = 1.563 * d;
    r.\u03A9 = 54.5 * d - 365.072 * d * this.t2;
    return r;
};
Qs.prototype.enceladus = function() {
    var r = new R4();
    var L = 200.317 * d + 262.7319002 * d * this.t1 + 0.25667 * d * this.sW1 + 0.20883 * d * this.sW2;
    var p = 309.107 * d + 123.44121 * d * this.t2;
    var M = L - p;
    var C = 0.55577 * d * Math.sin(M) + 0.00168 * d * Math.sin(2 * M);
    r.\u03BB = L + C;
    r.r = 3.94118 / (1 + 0.00485 * Math.cos(M + C));
    r.\u03B3 = 0.0262 * d;
    r.\u03A9 = 348 * d - 151.95 * d * this.t2;
    return r;
};
Qs.prototype.tethys = function() {
    var r = new R4();
    r.\u03BB = 285.306 * d + 190.69791226 * d * this.t1 + 2.063 * d * this.sW0 + 0.03409 * d * this.s3W0 + 0.001015 * d * this.s5W0;
    r.r = 4.880998;
    r.\u03B3 = 1.0976 * d;
    r.\u03A9 = 111.33 * d - 72.2441 * d * this.t2;
    return r;
};
Qs.prototype.dione = function() {
    var r = new R4();
    var L = 254.712 * d + 131.53493193 * d * this.t1 - 0.0215 * d * this.sW1 - 0.01733 * d * this.sW2;
    var p = 174.8 * d + 30.82 * d * this.t2;
    var M = L - p;
    var C = 0.24717 * d * Math.sin(M) + 0.00033 * d * Math.sin(2 * M);
    r.\u03BB = L + C;
    r.r = 6.24871 / (1 + 0.002157 * Math.cos(M + C));
    r.\u03B3 = 0.0139 * d;
    r.\u03A9 = 232 * d - 30.27 * d * this.t2;
    return r;
};
Qs.prototype.rhea = function() {
    var p\u02B9 = 342.7 * d + 10.057 * d * this.t2;
    var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(p\u02B9), 2), sp\u02B9 = _base_sincos[0], cp\u02B9 = _base_sincos[1];
    var a1 = 0.000265 * sp\u02B9 + 0.001 * this.sW4;
    var a2 = 0.000265 * cp\u02B9 + 0.001 * this.cW4;
    var e = Math.hypot(a1, a2);
    var p = Math.atan2(a1, a2);
    var N = 345 * d - 10.057 * d * this.t2;
    var _base_sincos1 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(N), 2), sN = _base_sincos1[0], cN = _base_sincos1[1];
    var \u03BB\u02B9 = 359.244 * d + 79.6900472 * d * this.t1 + 0.086754 * d * sN;
    var i = 28.0362 * d + 0.346898 * d * cN + 0.0193 * d * this.cW3;
    var \u03A9 = 168.8034 * d + 0.736936 * d * sN + 0.041 * d * this.sW3;
    var a = 8.725924;
    return this.subr(\u03BB\u02B9, p, e, a, \u03A9, i);
};
Qs.prototype.subr = function(\u03BB\u02B9, p, e, a, \u03A9, i) {
    var r = new R4();
    var M = \u03BB\u02B9 - p;
    var e2 = e * e;
    var e3 = e2 * e;
    var e4 = e2 * e2;
    var e5 = e3 * e2;
    var C = (2 * e - 0.25 * e3 + 0.0520833333 * e5) * Math.sin(M) + (1.25 * e2 - 0.458333333 * e4) * Math.sin(2 * M) + (1.083333333 * e3 - 0.671875 * e5) * Math.sin(3 * M) + 1.072917 * e4 * Math.sin(4 * M) + 1.142708 * e5 * Math.sin(5 * M);
    r.r = a * (1 - e2) / (1 + e * Math.cos(M + C) // return value
    );
    var g = \u03A9 - 168.8112 * d;
    var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(i), 2), si = _base_sincos[0], ci = _base_sincos[1];
    var _base_sincos1 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(g), 2), sg = _base_sincos1[0], cg = _base_sincos1[1];
    var a1 = si * sg;
    var a2 = this.c1 * si * cg - this.s1 * ci;
    r.\u03B3 = Math.asin(Math.hypot(a1, a2)) // return value
    ;
    var u = Math.atan2(a1, a2);
    r.\u03A9 = 168.8112 * d + u // return value (w)
    ;
    var h = this.c1 * si - this.s1 * ci * cg;
    var \u03C8 = Math.atan2(this.s1 * sg, h);
    r.\u03BB = \u03BB\u02B9 + C + u - g - \u03C8 // return value
    ;
    return r;
};
Qs.prototype.titan = function() {
    var _this = this;
    var L = 261.1582 * d + 22.57697855 * d * this.t4 + 0.074025 * d * this.sW3;
    var i\u02B9 = 27.45141 * d + 0.295999 * d * this.cW3;
    var \u03A9\u02B9 = 168.66925 * d + 0.628808 * d * this.sW3;
    var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(i\u02B9), 2), si\u02B9 = _base_sincos[0], ci\u02B9 = _base_sincos[1];
    var _base_sincos1 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03A9\u02B9 - this.W8), 2), s\u03A9\u02B9W8 = _base_sincos1[0], c\u03A9\u02B9W8 = _base_sincos1[1];
    var a1 = this.sW7 * s\u03A9\u02B9W8;
    var a2 = this.cW7 * si\u02B9 - this.sW7 * ci\u02B9 * c\u03A9\u02B9W8;
    var g0 = 102.8623 * d;
    var \u03C8 = Math.atan2(a1, a2);
    var s = Math.hypot(a1, a2);
    var g = this.W4 - \u03A9\u02B9 - \u03C8;
    var \u03D6 = 0;
    var _base_sincos2 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(2 * g0), 2), s2g0 = _base_sincos2[0], c2g0 = _base_sincos2[1];
    var f = function() {
        \u03D6 = _this.W4 + 0.37515 * d * (Math.sin(2 * g) - s2g0);
        g = \u03D6 - \u03A9\u02B9 - \u03C8;
    };
    f();
    f();
    f();
    var e\u02B9 = 0.029092 + 0.00019048 * (Math.cos(2 * g) - c2g0);
    var qq = 2 * (this.W5 - \u03D6);
    var b1 = si\u02B9 * s\u03A9\u02B9W8;
    var b2 = this.cW7 * si\u02B9 * c\u03A9\u02B9W8 - this.sW7 * ci\u02B9;
    var \u03B8 = Math.atan2(b1, b2) + this.W8;
    var _base_sincos3 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(qq), 2), sq = _base_sincos3[0], cq = _base_sincos3[1];
    var e = e\u02B9 + 0.002778797 * e\u02B9 * cq;
    var p = \u03D6 + 0.159215 * d * sq;
    var u = 2 * this.W5 - 2 * \u03B8 + \u03C8;
    var _base_sincos4 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(u), 2), su = _base_sincos4[0], cu = _base_sincos4[1];
    var h = 0.9375 * e\u02B9 * e\u02B9 * sq + 0.1875 * s * s * Math.sin(2 * (this.W5 - \u03B8));
    var \u03BB\u02B9 = L - 0.254744 * d * (this.e1 * Math.sin(this.W6) + 0.75 * this.e1 * this.e1 * Math.sin(2 * this.W6) + h);
    var i = i\u02B9 + 0.031843 * d * s * cu;
    var \u03A9 = \u03A9\u02B9 + 0.031843 * d * s * su / si\u02B9;
    var a = 20.216193;
    return this.subr(\u03BB\u02B9, p, e, a, \u03A9, i);
};
Qs.prototype.hyperion = function() {
    var \u03B7 = 92.39 * d + 0.5621071 * d * this.t6;
    var \u03B6 = 148.19 * d - 19.18 * d * this.t8;
    var \u03B8 = 184.8 * d - 35.41 * d * this.t9;
    var \u03B8\u02B9 = \u03B8 - 7.5 * d;
    var as = 176 * d + 12.22 * d * this.t8;
    var bs = 8 * d + 24.44 * d * this.t8;
    var cs = bs + 5 * d;
    var \u03D6 = 69.898 * d - 18.67088 * d * this.t8;
    var \u03C6 = 2 * (\u03D6 - this.W5);
    var \u03C7 = 94.9 * d - 2.292 * d * this.t8;
    var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03B7), 2), s\u03B7 = _base_sincos[0], c\u03B7 = _base_sincos[1];
    var _base_sincos1 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03B6), 2), s\u03B6 = _base_sincos1[0], c\u03B6 = _base_sincos1[1];
    var _base_sincos2 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(2 * \u03B6), 2), s2\u03B6 = _base_sincos2[0], c2\u03B6 = _base_sincos2[1];
    var _base_sincos3 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(3 * \u03B6), 2), s3\u03B6 = _base_sincos3[0], c3\u03B6 = _base_sincos3[1];
    var _base_sincos4 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03B6 + \u03B7), 2), s\u03B6p\u03B7 = _base_sincos4[0], c\u03B6p\u03B7 = _base_sincos4[1];
    var _base_sincos5 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03B6 - \u03B7), 2), s\u03B6m\u03B7 = _base_sincos5[0], c\u03B6m\u03B7 = _base_sincos5[1];
    var _base_sincos6 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03C6), 2), s\u03C6 = _base_sincos6[0], c\u03C6 = _base_sincos6[1];
    var _base_sincos7 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03C7), 2), s\u03C7 = _base_sincos7[0], c\u03C7 = _base_sincos7[1];
    var _base_sincos8 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(cs), 2), scs = _base_sincos8[0], ccs = _base_sincos8[1];
    var a = 24.50601 - 0.08686 * c\u03B7 - 0.00166 * c\u03B6p\u03B7 + 0.00175 * c\u03B6m\u03B7;
    var e = 0.103458 - 0.004099 * c\u03B7 - 0.000167 * c\u03B6p\u03B7 + 0.000235 * c\u03B6m\u03B7 + 0.02303 * c\u03B6 - 0.00212 * c2\u03B6 + 0.000151 * c3\u03B6 + 0.00013 * c\u03C6;
    var p = \u03D6 + 0.15648 * d * s\u03C7 - 0.4457 * d * s\u03B7 - 0.2657 * d * s\u03B6p\u03B7 - 0.3573 * d * s\u03B6m\u03B7 - 12.872 * d * s\u03B6 + 1.668 * d * s2\u03B6 - 0.2419 * d * s3\u03B6 - 0.07 * d * s\u03C6;
    var \u03BB\u02B9 = 177.047 * d + 16.91993829 * d * this.t6 + 0.15648 * d * s\u03C7 + 9.142 * d * s\u03B7 + 0.007 * d * Math.sin(2 * \u03B7) - 0.014 * d * Math.sin(3 * \u03B7) + 0.2275 * d * s\u03B6p\u03B7 + 0.2112 * d * s\u03B6m\u03B7 - 0.26 * d * s\u03B6 - 0.0098 * d * s2\u03B6 - 0.013 * d * Math.sin(as) + 0.017 * d * Math.sin(bs) - 0.0303 * d * s\u03C6;
    var i = 27.3347 * d + 0.6434886 * d * c\u03C7 + 0.315 * d * this.cW3 + 0.018 * d * Math.cos(\u03B8) - 0.018 * d * ccs;
    var \u03A9 = 168.6812 * d + 1.40136 * d * c\u03C7 + 0.68599 * d * this.sW3 - 0.0392 * d * scs + 0.0366 * d * Math.sin(\u03B8\u02B9);
    return this.subr(\u03BB\u02B9, p, e, a, \u03A9, i);
};
Qs.prototype.iapetus = function() {
    var L = 261.1582 * d + 22.57697855 * d * this.t4;
    var \u03D6\u02B9 = 91.796 * d + 0.562 * d * this.t7;
    var \u03C8 = 4.367 * d - 0.195 * d * this.t7;
    var \u03B8 = 146.819 * d - 3.198 * d * this.t7;
    var \u03C6 = 60.47 * d + 1.521 * d * this.t7;
    var \u03A6 = 205.055 * d - 2.091 * d * this.t7;
    var e\u02B9 = 0.028298 + 0.001156 * this.t11;
    var \u03D60 = 352.91 * d + 11.71 * d * this.t11;
    var \u03BC = 76.3852 * d + 4.53795125 * d * this.t10;
    var i\u02B9 = (0, _baseJsDefault.default).horner(this.t11, 18.4602 * d, -0.9518 * d, -0.072 * d, 0.0054 * d);
    var \u03A9\u02B9 = (0, _baseJsDefault.default).horner(this.t11, 143.198 * d, -3.919 * d, 0.116 * d, 0.008 * d);
    var l = \u03BC - \u03D60;
    var g = \u03D60 - \u03A9\u02B9 - \u03C8;
    var g1 = \u03D60 - \u03A9\u02B9 - \u03C6;
    var ls = this.W5 - \u03D6\u02B9;
    var gs = \u03D6\u02B9 - \u03B8;
    var lT = L - this.W4;
    var gT = this.W4 - \u03A6;
    var u1 = 2 * (l + g - ls - gs);
    var u2 = l + g1 - lT - gT;
    var u3 = l + 2 * (g - ls - gs);
    var u4 = lT + gT - g1;
    var u5 = 2 * (ls + gs);
    var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(l), 2), sl = _base_sincos[0], cl = _base_sincos[1];
    var _base_sincos1 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(u1), 2), su1 = _base_sincos1[0], cu1 = _base_sincos1[1];
    var _base_sincos2 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(u2), 2), su2 = _base_sincos2[0], cu2 = _base_sincos2[1];
    var _base_sincos3 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(u3), 2), su3 = _base_sincos3[0], cu3 = _base_sincos3[1];
    var _base_sincos4 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(u4), 2), su4 = _base_sincos4[0], cu4 = _base_sincos4[1];
    var _base_sincos5 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(l + u2), 2), slu2 = _base_sincos5[0], clu2 = _base_sincos5[1];
    var _base_sincos6 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(g1 - gT), 2), sg1gT = _base_sincos6[0], cg1gT = _base_sincos6[1];
    var _base_sincos7 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(u5 - 2 * g), 2), su52g = _base_sincos7[0], cu52g = _base_sincos7[1];
    var _base_sincos8 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(u5 + \u03C8), 2), su5\u03C8 = _base_sincos8[0], cu5\u03C8 = _base_sincos8[1];
    var _base_sincos9 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(u2 + \u03C6), 2), su2\u03C6 = _base_sincos9[0], cu2\u03C6 = _base_sincos9[1];
    var _base_sincos10 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(l + g1 + lT + gT + \u03C6), 2), s5 = _base_sincos10[0], c5 = _base_sincos10[1];
    var a = 58.935028 + 0.004638 * cu1 + 0.058222 * cu2;
    var e = e\u02B9 - 0.0014097 * cg1gT + 0.0003733 * cu52g + 0.000118 * cu3 + 0.0002408 * cl + 0.0002849 * clu2 + 0.000619 * cu4;
    var w = 0.08077 * d * sg1gT + 0.02139 * d * su52g - 0.00676 * d * su3 + 0.0138 * d * sl + 0.01632 * d * slu2 + 0.03547 * d * su4;
    var p = \u03D60 + w / e\u02B9;
    var \u03BB\u02B9 = \u03BC - 0.04299 * d * su2 - 0.00789 * d * su1 - 0.06312 * d * Math.sin(ls) - 0.00295 * d * Math.sin(2 * ls) - 0.02231 * d * Math.sin(u5) + 0.0065 * d * su5\u03C8;
    var i = i\u02B9 + 0.04204 * d * cu5\u03C8 + 0.00235 * d * c5 + 0.0036 * d * cu2\u03C6;
    var w\u02B9 = 0.04204 * d * su5\u03C8 + 0.00235 * d * s5 + 0.00358 * d * su2\u03C6;
    var \u03A9 = \u03A9\u02B9 + w\u02B9 / Math.sin(i\u02B9);
    return this.subr(\u03BB\u02B9, p, e, a, \u03A9, i);
};
exports.default = {
    mimas: mimas,
    enceladus: enceladus,
    tethys: tethys,
    dione: dione,
    rhea: rhea,
    titan: titan,
    hyperion: hyperion,
    iapetus: iapetus,
    positions: positions,
    Qs: Qs
};

},{"@swc/helpers/_/_sliced_to_array":"ha6sq","./base.js":"lEDxD","./coord.js":"kTRDS","./planetposition.js":"8l87z","./precess.js":"iqQIL","./solar.js":"d2aLm","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"kZPfC":[function(require,module,exports,__globalThis) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module saturnring
 */ /**
 * Saturnrings: Chapter 45, The Ring of Saturn
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Ring computes quantities of the ring of Saturn.
 *
 *  B  Saturnicentric latitude of the Earth referred to the plane of the ring.
 *  Bʹ  Saturnicentric latitude of the Sun referred to the plane of the ring.
 *  ΔU  Difference between Saturnicentric longitudes of the Sun and the Earth.
 *  P  Geometric position angle of the northern semiminor axis of the ring.
 *  aEdge  Major axis of the out edge of the outer ring.
 *  bEdge  Minor axis of the out edge of the outer ring.
 *
 * All results in radians.
 */ parcelHelpers.export(exports, "ring", function() {
    return ring;
});
/**
 * UB computes quantities required by illum.Saturn().
 *
 * Same as ΔU and B returned by Ring().  Results in radians.
 */ parcelHelpers.export(exports, "ub", function() {
    return ub;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var _coordJs = require("./coord.js");
var _coordJsDefault = parcelHelpers.interopDefault(_coordJs);
var _nutationJs = require("./nutation.js");
var _nutationJsDefault = parcelHelpers.interopDefault(_nutationJs);
var _planetpositionJs = require("./planetposition.js");
var _planetpositionJsDefault = parcelHelpers.interopDefault(_planetpositionJs);
function ring(jde, earth, saturn) {
    var _cl = (0, _slicedToArray._)(cl(jde, earth, saturn), 2), f1 = _cl[0], f2 = _cl[1];
    var _f1 = (0, _slicedToArray._)(f1(), 2), \u0394U = _f1[0], B = _f1[1];
    var _f2 = (0, _slicedToArray._)(f2(), 4), B\u02B9 = _f2[0], P = _f2[1], aEdge = _f2[2], bEdge = _f2[3];
    return [
        B,
        B\u02B9,
        \u0394U,
        P,
        aEdge,
        bEdge
    ];
}
function ub(jde, earth, saturn) {
    var _cl // eslint-disable-line no-unused-vars
     = (0, _slicedToArray._)(cl(jde, earth, saturn), 2), f1 = _cl[0], f2 = _cl[1];
    return f1();
}
/**
 * cl splits the work into two closures.
 */ function cl(jde, earth, saturn) {
    // f2 func() (Bʹ, P, aEdge, bEdge float64))
    var p = Math.PI / 180;
    var i, \u03A9;
    var l0, b0, R;
    var \u0394 = 9.0;
    var \u03BB, \u03B2;
    var si, ci, s\u03B2, c\u03B2, sB;
    var sb\u02B9, cb\u02B9, sl\u02B9\u03A9, cl\u02B9\u03A9;
    var f1 = function f1() {
        // (45.1), p. 318
        var T = (0, _baseJsDefault.default).J2000Century(jde);
        i = (0, _baseJsDefault.default).horner(T, 28.075216 * p, -0.012998 * p, 0.000004 * p);
        \u03A9 = (0, _baseJsDefault.default).horner(T, 169.50847 * p, 1.394681 * p, 0.000412 * p);
        // Step 2.0
        var earthPos = earth.position(jde);
        R = earthPos.range;
        var fk5 = (0, _planetpositionJsDefault.default).toFK5(earthPos.lon, earthPos.lat, jde);
        l0 = fk5.lon;
        b0 = fk5.lat;
        var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(l0), 2), sl0 = _base_sincos[0], cl0 = _base_sincos[1];
        var sb0 = Math.sin(b0);
        // Steps 3, 4.0
        var l = 0;
        var b = 0;
        var r = 0;
        var x = 0;
        var y = 0;
        var z = 0;
        var f = function f() {
            var \u03C4 = (0, _baseJsDefault.default).lightTime(\u0394);
            var saturnPos = saturn.position(jde - \u03C4);
            r = saturnPos.range;
            var fk5 = (0, _planetpositionJsDefault.default).toFK5(saturnPos.lon, saturnPos.lat, jde);
            l = fk5.lon;
            b = fk5.lat;
            var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(l), 2), sl = _base_sincos[0], cl = _base_sincos[1];
            var _base_sincos1 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(b), 2), sb = _base_sincos1[0], cb = _base_sincos1[1];
            x = r * cb * cl - R * cl0;
            y = r * cb * sl - R * sl0;
            z = r * sb - R * sb0;
            \u0394 = Math.sqrt(x * x + y * y + z * z);
        };
        f();
        f();
        // Step 5.0
        \u03BB = Math.atan2(y, x);
        \u03B2 = Math.atan(z / Math.hypot(x, y));
        // First part of step 6.0
        si = Math.sin(i);
        ci = Math.cos(i);
        s\u03B2 = Math.sin(\u03B2);
        c\u03B2 = Math.cos(\u03B2);
        sB = si * c\u03B2 * Math.sin(\u03BB - \u03A9) - ci * s\u03B2;
        var B = Math.asin(sB) // return value
        ;
        // Step 7.0
        var N = 113.6655 * p + 0.8771 * p * T;
        var l\u02B9 = l - 0.01759 * p / r;
        var b\u02B9 = b - 0.000764 * p * Math.cos(l - N) / r;
        // Setup for steps 8, 9.0
        sb\u02B9 = Math.sin(b\u02B9);
        cb\u02B9 = Math.cos(b\u02B9);
        sl\u02B9\u03A9 = Math.sin(l\u02B9 - \u03A9);
        cl\u02B9\u03A9 = Math.cos(l\u02B9 - \u03A9);
        // Step 9.0
        var _base_sincos1 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03BB - \u03A9), 2), s\u03BB\u03A9 = _base_sincos1[0], c\u03BB\u03A9 = _base_sincos1[1];
        var U1 = Math.atan2(si * sb\u02B9 + ci * cb\u02B9 * sl\u02B9\u03A9, cb\u02B9 * cl\u02B9\u03A9);
        var U2 = Math.atan2(si * s\u03B2 + ci * c\u03B2 * s\u03BB\u03A9, c\u03B2 * c\u03BB\u03A9);
        var \u0394U = Math.abs(U1 - U2) // return value
        ;
        return [
            \u0394U,
            B
        ];
    };
    var f2 = function f2() {
        // Remainder of step 6.0
        var aEdge = 375.35 / 3600 * p / \u0394 // return value
        ;
        var bEdge = aEdge * Math.abs(sB) // return value
        ;
        // Step 8.0
        var sB\u02B9 = si * cb\u02B9 * sl\u02B9\u03A9 - ci * sb\u02B9;
        var B\u02B9 = Math.asin(sB\u02B9) // return value
        ;
        // Step 10.0
        var _nutation_nutation = (0, _slicedToArray._)((0, _nutationJsDefault.default).nutation(jde), 2), \u0394\u03C8 = _nutation_nutation[0], \u0394\u03B5 = _nutation_nutation[1];
        var \u03B5 = (0, _nutationJsDefault.default).meanObliquity(jde) + \u0394\u03B5;
        // Step 11.0
        var \u03BB0 = \u03A9 - Math.PI / 2;
        var \u03B20 = Math.PI / 2 - i;
        // Step 12.0
        var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(l0 - \u03BB), 2), sl0\u03BB = _base_sincos[0], cl0\u03BB = _base_sincos[1];
        \u03BB += 0.005693 * p * cl0\u03BB / c\u03B2;
        \u03B2 += 0.005693 * p * sl0\u03BB * s\u03B2;
        // Step 13.0
        \u03BB0 += \u0394\u03C8;
        \u03BB += \u0394\u03C8;
        // Step 14.0
        var eq = new (0, _coordJsDefault.default).Ecliptic(\u03BB0, \u03B20).toEquatorial(\u03B5);
        var _ref = [
            eq.ra,
            eq.dec
        ], \u03B10 = _ref[0], \u03B40 = _ref[1];
        eq = new (0, _coordJsDefault.default).Ecliptic(\u03BB, \u03B2).toEquatorial(\u03B5);
        var _ref1 = [
            eq.ra,
            eq.dec
        ], \u03B1 = _ref1[0], \u03B4 = _ref1[1];
        // Step 15.0
        var _base_sincos1 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03B40), 2), s\u03B40 = _base_sincos1[0], c\u03B40 = _base_sincos1[1];
        var _base_sincos2 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03B4), 2), s\u03B4 = _base_sincos2[0], c\u03B4 = _base_sincos2[1];
        var _base_sincos3 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03B10 - \u03B1), 2), s\u03B10\u03B1 = _base_sincos3[0], c\u03B10\u03B1 = _base_sincos3[1];
        var P = Math.atan2(c\u03B40 * s\u03B10\u03B1, s\u03B40 * c\u03B4 - c\u03B40 * s\u03B4 * c\u03B10\u03B1) // return value
        ;
        return [
            B\u02B9,
            P,
            aEdge,
            bEdge
        ];
    };
    return [
        f1,
        f2
    ];
}
exports.default = {
    ring: ring,
    ub: ub
};

},{"@swc/helpers/_/_sliced_to_array":"ha6sq","./base.js":"lEDxD","./coord.js":"kTRDS","./nutation.js":"jqV8z","./planetposition.js":"8l87z","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"h2Ie1":[function(require,module,exports,__globalThis) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module solardisk
 */ /**
 * Solardisk: Chapter 29, Ephemeris for Physical Observations of the Sun.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Ephemeris returns the apparent orientation of the sun at the given jd.
 *
 * Results:
 *  P:  Position angle of the solar north pole.
 *  B0: Heliographic latitude of the center of the solar disk.
 *  L0: Heliographic longitude of the center of the solar disk.
 *
 * All results in radians.
 */ parcelHelpers.export(exports, "ephemeris", function() {
    return ephemeris;
});
/**
 * Cycle returns the jd of the start of the given synodic rotation.
 *
 * Argument c is the "Carrington" cycle number.
 *
 * Result is a dynamical time (not UT).
 */ parcelHelpers.export(exports, "cycle", function() {
    return cycle;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var _nutationJs = require("./nutation.js");
var _nutationJsDefault = parcelHelpers.interopDefault(_nutationJs);
var _solarJs = require("./solar.js");
var _solarJsDefault = parcelHelpers.interopDefault(_solarJs);
function ephemeris(jd, earth) {
    var \u03B8 = (jd - 2398220) * 2 * Math.PI / 25.38;
    var I = 7.25 * Math.PI / 180;
    var K = 73.6667 * Math.PI / 180 + 1.3958333 * Math.PI / 180 * (jd - 2396758) / (0, _baseJsDefault.default).JulianCentury;
    var solarPos = (0, _solarJsDefault.default).trueVSOP87(earth, jd);
    var L = solarPos.lon;
    var R = solarPos.range;
    var _nutation_nutation = (0, _slicedToArray._)((0, _nutationJsDefault.default).nutation(jd), 2), \u0394\u03C8 = _nutation_nutation[0], \u0394\u03B5 = _nutation_nutation[1];
    var \u03B50 = (0, _nutationJsDefault.default).meanObliquity(jd);
    var \u03B5 = \u03B50 + \u0394\u03B5;
    var \u03BB = L - 20.4898 / 3600 * Math.PI / 180 / R;
    var \u03BBp = \u03BB + \u0394\u03C8;
    var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03BB - K), 2), s\u03BBK = _base_sincos[0], c\u03BBK = _base_sincos[1];
    var _base_sincos1 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(I), 2), sI = _base_sincos1[0], cI = _base_sincos1[1];
    var tx = -Math.cos(\u03BBp) * Math.tan(\u03B5);
    var ty = -c\u03BBK * Math.tan(I);
    var P = Math.atan(tx) + Math.atan(ty);
    var B0 = Math.asin(s\u03BBK * sI);
    var \u03B7 = Math.atan2(-s\u03BBK * cI, -c\u03BBK);
    var L0 = (0, _baseJsDefault.default).pmod(\u03B7 - \u03B8, 2 * Math.PI);
    return [
        P,
        B0,
        L0
    ];
}
function cycle(c) {
    var jde = 2398140.227 + 27.2752316 * c;
    var m = 281.96 * Math.PI / 180 + 26.882476 * Math.PI / 180 * c;
    var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(2 * m), 2), s2m = _base_sincos[0], c2m = _base_sincos[1];
    return jde + 0.1454 * Math.sin(m) - 0.0085 * s2m - 0.0141 * c2m;
}
exports.default = {
    ephemeris: ephemeris,
    cycle: cycle
};

},{"@swc/helpers/_/_sliced_to_array":"ha6sq","./base.js":"lEDxD","./nutation.js":"jqV8z","./solar.js":"d2aLm","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"203jz":[function(require,module,exports,__globalThis) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module solstice
 */ /**
 * Solstice: Chapter 27: Equinoxes and Solstices.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * March returns the JDE of the March equinox for the given year.
 *
 * Results are valid for the years -1000 to +3000.
 *
 * Accuracy is within one minute of time for the years 1951-2050.
 * @param {Number} y - (int) year
 * @returns {Number} JDE
 */ parcelHelpers.export(exports, "march", function() {
    return march;
});
/**
 * June returns the JDE of the June solstice for the given year.
 *
 * Results are valid for the years -1000 to +3000.
 *
 * Accuracy is within one minute of time for the years 1951-2050.
 * @param {Number} y - (int) year
 * @returns {Number} JDE
 */ parcelHelpers.export(exports, "june", function() {
    return june;
});
/**
 * September returns the JDE of the September equinox for the given year.
 *
 * Results are valid for the years -1000 to +3000.
 *
 * Accuracy is within one minute of time for the years 1951-2050.
 * @param {Number} y - (int) year
 * @returns {Number} JDE
 */ parcelHelpers.export(exports, "september", function() {
    return september;
});
/**
 * December returns the JDE of the December solstice for a given year.
 *
 * Results are valid for the years -1000 to +3000.
 *
 * Accuracy is within one minute of time for the years 1951-2050.
 * @param {Number} y - (int) year
 * @returns {Number} JDE
 */ parcelHelpers.export(exports, "december", function() {
    return december;
});
/**
 * March2 returns a more accurate JDE of the March equinox.
 *
 * Result is accurate to one second of time.
 *
 * @param {Number} year - (int) year
 * @param {planetposition.Planet} planet - must be a V87Planet object representing Earth, obtained with
 * the package planetposition
 * @returns {Number} JDE
 */ parcelHelpers.export(exports, "march2", function() {
    return march2;
});
/**
 * June2 returns a more accurate JDE of the June solstice.
 *
 * Result is accurate to one second of time.
 *
 * @param {Number} year - (int) year
 * @param {planetposition.Planet} planet - must be a V87Planet object representing Earth, obtained with
 * the package planetposition
 * @returns {Number} JDE
 */ parcelHelpers.export(exports, "june2", function() {
    return june2;
});
/**
 * September2 returns a more accurate JDE of the September equinox.
 *
 * Result is accurate to one second of time.
 *
 * @param {Number} year - (int) year
 * @param {planetposition.Planet} planet - must be a V87Planet object representing Earth, obtained with
 * the package planetposition
 * @returns {Number} JDE
 */ parcelHelpers.export(exports, "september2", function() {
    return september2;
});
/**
 * December2 returns a more accurate JDE of the December solstice.
 *
 * Result is accurate to one second of time.
 *
 * @param {Number} year - (int) year
 * @param {planetposition.Planet} planet - must be a V87Planet object representing Earth, obtained with
 * the package planetposition
 * @returns {Number} JDE
 */ parcelHelpers.export(exports, "december2", function() {
    return december2;
});
/**
 * Longitude returns the JDE for a given `year`, VSOP87 Planet `planet` at a
 * given geocentric solar longitude `lon`
 * @param {Number} year - (int)
 * @param {planetposition.Planet} planet
 * @param {Number} lon - geocentric solar longitude in radians
 * @returns {Number} JDE
 */ parcelHelpers.export(exports, "longitude", function() {
    return longitude;
});
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var _solarJs = require("./solar.js");
var _solarJsDefault = parcelHelpers.interopDefault(_solarJs);
var abs = Math.abs, cos = Math.cos, sin = Math.sin;
var D2R = Math.PI / 180;
// table 27.a - for years from -1000 to +1000
var mc0 = [
    1721139.29189,
    365242.13740,
    0.06134,
    0.00111,
    -0.00071
];
var jc0 = [
    1721233.25401,
    365241.72562,
    -0.05323,
    0.00907,
    0.00025
];
var sc0 = [
    1721325.70455,
    365242.49558,
    -0.11677,
    -0.00297,
    0.00074
];
var dc0 = [
    1721414.39987,
    365242.88257,
    -0.00769,
    -0.00933,
    -0.00006
];
// table 27.b - for years from +1000 to +3000
var mc2 = [
    2451623.80984,
    365242.37404,
    0.05169,
    -0.00411,
    -0.00057
];
var jc2 = [
    2451716.56767,
    365241.62603,
    0.00325,
    0.00888,
    -0.0003
];
var sc2 = [
    2451810.21715,
    365242.01767,
    -0.11575,
    0.00337,
    0.00078
];
var dc2 = [
    2451900.05952,
    365242.74049,
    -0.06223,
    -0.00823,
    0.00032
];
// table 27.c
var terms = function() {
    var term = [
        [
            485,
            324.96,
            1934.136
        ],
        [
            203,
            337.23,
            32964.467
        ],
        [
            199,
            342.08,
            20.186
        ],
        [
            182,
            27.85,
            445267.112
        ],
        [
            156,
            73.14,
            45036.886
        ],
        [
            136,
            171.52,
            22518.443
        ],
        [
            77,
            222.54,
            65928.934
        ],
        [
            74,
            296.72,
            3034.906
        ],
        [
            70,
            243.58,
            9037.513
        ],
        [
            58,
            119.81,
            33718.147
        ],
        [
            52,
            297.17,
            150.678
        ],
        [
            50,
            21.02,
            2281.226
        ],
        [
            45,
            247.54,
            29929.562
        ],
        [
            44,
            325.15,
            31555.956
        ],
        [
            29,
            60.93,
            4443.417
        ],
        [
            18,
            155.12,
            67555.328
        ],
        [
            17,
            288.79,
            4562.452
        ],
        [
            16,
            198.04,
            62894.029
        ],
        [
            14,
            199.76,
            31436.921
        ],
        [
            12,
            95.39,
            14577.848
        ],
        [
            12,
            287.11,
            31931.756
        ],
        [
            12,
            320.81,
            34777.259
        ],
        [
            9,
            227.73,
            1222.114
        ],
        [
            8,
            15.45,
            16859.074
        ]
    ];
    return term.map(function(t) {
        return {
            a: t[0],
            b: t[1],
            c: t[2]
        };
    });
}();
function march(y) {
    if (y < 1000) return eq(y, mc0);
    return eq(y - 2000, mc2);
}
function june(y) {
    if (y < 1000) return eq(y, jc0);
    return eq(y - 2000, jc2);
}
function september(y) {
    if (y < 1000) return eq(y, sc0);
    return eq(y - 2000, sc2);
}
function december(y) {
    if (y < 1000) return eq(y, dc0);
    return eq(y - 2000, dc2);
}
/**
 * Fast calculation of solstices/ equinoxes
 * Accuracy is within one minute of time for the years 1951-2050.
 *
 * @param {Number} y - (int) year
 * @param {Array} c - term from table 27.a / 27.b
 * @returns {Number} JDE
 */ function eq(y, c) {
    var J0 = (0, _baseJsDefault.default).horner(y * 0.001, c);
    var T = (0, _baseJsDefault.default).J2000Century(J0);
    var W = 35999.373 * D2R * T - 2.47 * D2R;
    var \u0394\u03BB = 1 + 0.0334 * cos(W) + 0.0007 * cos(2 * W);
    var S = 0;
    for(var i = terms.length - 1; i >= 0; i--){
        var t = terms[i];
        S += t.a * cos((t.b + t.c * T) * D2R);
    }
    return J0 + 0.00001 * S / \u0394\u03BB;
}
function march2(year, planet) {
    return longitude(year, planet, 0);
}
function june2(year, planet) {
    return longitude(year, planet, Math.PI / 2);
}
function september2(year, planet) {
    return longitude(year, planet, Math.PI);
}
function december2(year, planet) {
    return longitude(year, planet, Math.PI * 3 / 2);
}
function longitude(year, planet, lon) {
    var c;
    var ct;
    if (year < 1000) ct = [
        mc0,
        jc0,
        sc0,
        dc0
    ];
    else {
        ct = [
            mc2,
            jc2,
            sc2,
            dc2
        ];
        year -= 2000;
    }
    lon = lon % (Math.PI * 2);
    if (lon < Math.PI / 2) c = ct[0];
    else if (lon < Math.PI) c = ct[1];
    else if (lon < Math.PI * 3 / 2) c = ct[2];
    else c = ct[3];
    return eq2(year, planet, lon, c);
}
/**
  * Accurate calculation of solstices/ equinoxes
  * Result is accurate to one second of time.
  *
  * @param {Number} year - (int) year
  * @param {planetposition.Planet} planet - vsop87 planet
  * @param {Number} lon - longitude in radians
  * @param {Array} c - term from table 27.a / 27.b
  * @returns {Number} JDE
  */ function eq2(year, planet, lon, c) {
    var J0 = (0, _baseJsDefault.default).horner(year * 0.001, c);
    for(;;){
        var a = (0, _solarJsDefault.default).apparentVSOP87(planet, J0);
        var _$c = 58 * sin(lon - a.lon) // (27.1) p. 180
        ;
        J0 += _$c;
        if (abs(_$c) < 0.000005) break;
    }
    return J0;
}
exports.default = {
    march: march,
    june: june,
    september: september,
    december: december,
    march2: march2,
    june2: june2,
    september2: september2,
    december2: december2,
    longitude: longitude
};

},{"./base.js":"lEDxD","./solar.js":"d2aLm","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"f5H0X":[function(require,module,exports,__globalThis) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module stellar
 */ /**
 * Stellar: Chapter 56, Stellar Magnitudes.
 */ /**
 * Sum returns the combined apparent magnitude of two stars.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sum", function() {
    return sum;
});
/**
 * SumN returns the combined apparent magnitude of a number of stars.
 */ parcelHelpers.export(exports, "sumN", function() {
    return sumN;
});
/**
 * Ratio returns the brightness ratio of two stars.
 *
 * Arguments m1, m2 are apparent magnitudes.
 */ parcelHelpers.export(exports, "ratio", function() {
    return ratio;
});
/**
 * Difference returns the difference in apparent magnitude of two stars
 * given their brightness ratio.
 */ parcelHelpers.export(exports, "difference", function() {
    return difference;
});
/**
 * AbsoluteByParallax returns absolute magnitude given annual parallax.
 *
 * Argument m is apparent magnitude, π is annual parallax in arc seconds.
 */ parcelHelpers.export(exports, "absoluteByParallax", function() {
    return absoluteByParallax;
});
/**
 * AbsoluteByDistance returns absolute magnitude given distance.
 *
 * Argument m is apparent magnitude, d is distance in parsecs.
 */ parcelHelpers.export(exports, "absoluteByDistance", function() {
    return absoluteByDistance;
});
function sum(m1, m2) {
    var x = 0.4 * (m2 - m1);
    return m2 - 2.5 * Math.log10(Math.pow(10, x) + 1);
}
function sumN(m) {
    var s = 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = m[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var mi = _step.value;
            s += Math.pow(10, -0.4 * mi);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return -2.5 * Math.log10(s);
}
function ratio(m1, m2) {
    var x = 0.4 * (m2 - m1);
    return Math.pow(10, x);
}
function difference(ratio) {
    return 2.5 * Math.log10(ratio);
}
function absoluteByParallax(m, \u03C0) {
    return m + 5 + 5 * Math.log10(\u03C0);
}
function absoluteByDistance(m, d) {
    return m + 5 - 5 * Math.log10(d);
}
exports.default = {
    sum: sum,
    sumN: sumN,
    ratio: ratio,
    difference: difference,
    absoluteByParallax: absoluteByParallax,
    absoluteByDistance: absoluteByDistance
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6ivgv":[function(require,module,exports,__globalThis) {
/**
 * @copyright 2013 Sonia Keys
 * @copyright 2016 commenthol
 * @license MIT
 * @module sundial
 */ /**
 * Sundial: Chapter 58, Calculation of a Planar Sundial.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * General computes data for the general case of a planar sundial.
 *
 * Argument φ is geographic latitude at which the sundial will be located.
 * D is gnomonic declination, the azimuth of the perpendicular to the plane
 * of the sundial, measured from the southern meridian towards the west.
 * Argument a is the length of a straight stylus perpendicular to the plane
 * of the sundial, z is zenithal distance of the direction defined by the
 * stylus.  Angles φ, D, and z are in radians.  Units of stylus length a
 * are arbitrary.
 *
 * Results consist of a set of lines, a center point, u, the length of a
 * polar stylus, and ψ, the angle which the polar stylus makes with the plane
 * of the sundial.  The center point, the points defining the hour lines, and
 * u are in units of a, the stylus length.  ψ is in radians.
 */ parcelHelpers.export(exports, "general", function() {
    return general;
});
/**
 * Equatorial computes data for a sundial level with the equator.
 *
 * Argument φ is geographic latitude at which the sundial will be located;
 * a is the length of a straight stylus perpendicular to the plane of the
 * sundial.
 *
 * The sundial will have two sides, north and south.  Results n and s define
 * lines on the north and south sides of the sundial.  Result coordinates
 * are in units of a, the stylus length.
 */ parcelHelpers.export(exports, "equatorial", function() {
    return equatorial;
});
/**
 * Horizontal computes data for a horizontal sundial.
 *
 * Argument φ is geographic latitude at which the sundial will be located,
 * a is the length of a straight stylus perpendicular to the plane of the
 * sundial.
 *
 * Results consist of a set of lines, a center point, and u, the length of a
 * polar stylus.  They are in units of a, the stylus length.
 */ parcelHelpers.export(exports, "horizontal", function() {
    return horizontal;
});
/**
 * Vertical computes data for a vertical sundial.
 *
 * Argument φ is geographic latitude at which the sundial will be located.
 * D is gnomonic declination, the azimuth of the perpendicular to the plane
 * of the sundial, measured from the southern meridian towards the west.
 * Argument a is the length of a straight stylus perpendicular to the plane
 * of the sundial.
 *
 * Results consist of a set of lines, a center point, and u, the length of a
 * polar stylus.  They are in units of a, the stylus length.
 */ parcelHelpers.export(exports, "vertical", function() {
    return vertical;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
/**
 * Point return type represents a point to be used in constructing the sundial.
 */ function Point(x, y) {
    this.x = x || 0;
    this.y = y || 0;
}
/**
 * Line holds data to draw an hour line on the sundial.
 */ function Line(hour, points) {
    this.hour = hour // 0 to 24
    ;
    this.points = points || [] // One or more points corresponding to the hour.
    ;
}
var m = [
    -23.44,
    -20.15,
    -11.47,
    0,
    11.47,
    20.15,
    23.44
];
function general(\u03C6, D, a, z) {
    var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03C6), 2), s\u03C6 = _base_sincos[0], c\u03C6 = _base_sincos[1];
    var t\u03C6 = s\u03C6 / c\u03C6;
    var _base_sincos1 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(D), 2), sD = _base_sincos1[0], cD = _base_sincos1[1];
    var _base_sincos2 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(z), 2), sz = _base_sincos2[0], cz = _base_sincos2[1];
    var P = s\u03C6 * cz - c\u03C6 * sz * cD;
    var lines = [];
    for(var i = 0; i < 24; i++){
        var l = new Line(i);
        var H = (i - 12) * 15 * Math.PI / 180;
        var aH = Math.abs(H);
        var _base_sincos3 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(H), 2), sH = _base_sincos3[0], cH = _base_sincos3[1];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = m[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var d = _step.value;
                var t\u03B4 = Math.tan(d * Math.PI / 180);
                var H0 = Math.acos(-t\u03C6 * t\u03B4);
                if (aH > H0) continue; // sun below horizon
                var Q = sD * sz * sH + (c\u03C6 * cz + s\u03C6 * sz * cD) * cH + P * t\u03B4;
                if (Q < 0) continue; // sun below plane of sundial
                var Nx = cD * sH - sD * (s\u03C6 * cH - c\u03C6 * t\u03B4);
                var Ny = cz * sD * sH - (c\u03C6 * sz - s\u03C6 * cz * cD) * cH - (s\u03C6 * sz + c\u03C6 * cz * cD) * t\u03B4;
                l.points.push(new Point(a * Nx / Q, a * Ny / Q));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (l.points.length > 0) lines.push(l);
    }
    var center = new Point();
    center.x = a / P * c\u03C6 * sD;
    center.y = -a / P * (s\u03C6 * sz + c\u03C6 * cz * cD);
    var aP = Math.abs(P);
    var u = a / aP;
    var \u03C8 = Math.asin(aP);
    return {
        lines: lines,
        center: center,
        length: u,
        angle: \u03C8
    };
}
function equatorial(\u03C6, a) {
    var t\u03C6 = Math.tan(\u03C6);
    var n = [];
    var s = [];
    for(var i = 0; i < 24; i++){
        var nl = new Line(i);
        var sl = new Line(i);
        var H = (i - 12) * 15 * Math.PI / 180;
        var aH = Math.abs(H);
        var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(H), 2), sH = _base_sincos[0], cH = _base_sincos[1];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = m[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var d = _step.value;
                var t\u03B4 = Math.tan(d * Math.PI / 180);
                var H0 = Math.acos(-t\u03C6 * t\u03B4);
                if (aH > H0) continue;
                var x = -a * sH / t\u03B4;
                var yy = a * cH / t\u03B4;
                if (t\u03B4 < 0) sl.points.push(new Point(x, yy));
                else nl.points.push(new Point(x, -yy));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (nl.points.length > 0) n.push(nl);
        if (sl.points.length > 0) s.push(sl);
    }
    return {
        north: n,
        south: s
    };
}
function horizontal(\u03C6, a) {
    var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03C6), 2), s\u03C6 = _base_sincos[0], c\u03C6 = _base_sincos[1];
    var t\u03C6 = s\u03C6 / c\u03C6;
    var lines = [];
    for(var i = 0; i < 24; i++){
        var l = new Line(i);
        var H = (i - 12) * 15 * Math.PI / 180;
        var aH = Math.abs(H);
        var _base_sincos1 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(H), 2), sH = _base_sincos1[0], cH = _base_sincos1[1];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = m[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var d = _step.value;
                var t\u03B4 = Math.tan(d * Math.PI / 180);
                var H0 = Math.acos(-t\u03C6 * t\u03B4);
                if (aH > H0) continue; // sun below horizon
                var Q = c\u03C6 * cH + s\u03C6 * t\u03B4;
                var x = a * sH / Q;
                var y = a * (s\u03C6 * cH - c\u03C6 * t\u03B4) / Q;
                l.points.push(new Point(x, y));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (l.points.length > 0) lines.push(l);
    }
    var center = new Point(0, -a / t\u03C6);
    var u = a / Math.abs(s\u03C6);
    return {
        lines: lines,
        center: center,
        length: u
    };
}
function vertical(\u03C6, D, a) {
    var _base_sincos = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(\u03C6), 2), s\u03C6 = _base_sincos[0], c\u03C6 = _base_sincos[1];
    var t\u03C6 = s\u03C6 / c\u03C6;
    var _base_sincos1 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(D), 2), sD = _base_sincos1[0], cD = _base_sincos1[1];
    var lines = [];
    for(var i = 0; i < 24; i++){
        var l = new Line(i);
        var H = (i - 12) * 15 * Math.PI / 180;
        var aH = Math.abs(H);
        var _base_sincos2 = (0, _slicedToArray._)((0, _baseJsDefault.default).sincos(H), 2), sH = _base_sincos2[0], cH = _base_sincos2[1];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = m[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var d = _step.value;
                var t\u03B4 = Math.tan(d * Math.PI / 180);
                var H0 = Math.acos(-t\u03C6 * t\u03B4);
                if (aH > H0) continue; // sun below horizon
                var Q = sD * sH + s\u03C6 * cD * cH - c\u03C6 * cD * t\u03B4;
                if (Q < 0) continue; // sun below plane of sundial
                var x = a * (cD * sH - s\u03C6 * sD * cH + c\u03C6 * sD * t\u03B4) / Q;
                var y = -a * (c\u03C6 * cH + s\u03C6 * t\u03B4) / Q;
                l.points.push(new Point(x, y));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (l.points.length > 0) lines.push(l);
    }
    var center = new Point();
    center.x = -a * sD / cD;
    center.y = a * t\u03C6 / cD;
    var u = a / Math.abs(c\u03C6 * cD);
    return {
        lines: lines,
        center: center,
        length: u
    };
}
exports.default = {
    general: general,
    equatorial: equatorial,
    horizontal: horizontal,
    vertical: vertical
};

},{"@swc/helpers/_/_sliced_to_array":"ha6sq","./base.js":"lEDxD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"iTup9":[function(require,module,exports,__globalThis) {
/**
 * @copyright 2016 commenthol
 * @license MIT
 * @module sunrise
 */ /**
 * Sunrise: Compute rise, noon, set of the Sun for an earth observer
 */ /* eslint key-spacing: 0 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Sunrise", function() {
    return Sunrise;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _baseJs = require("./base.js");
var _baseJsDefault = parcelHelpers.interopDefault(_baseJs);
var _eqtimeJs = require("./eqtime.js");
var _eqtimeJsDefault = parcelHelpers.interopDefault(_eqtimeJs);
var _sexagesimalJs = require("./sexagesimal.js");
var _sexagesimalJsDefault = parcelHelpers.interopDefault(_sexagesimalJs);
var _solarJs = require("./solar.js");
var _solarJsDefault = parcelHelpers.interopDefault(_solarJs);
var _julianJs = require("./julian.js");
var _julianJsDefault = parcelHelpers.interopDefault(_julianJs);
var _riseJs = require("./rise.js");
var _riseJsDefault = parcelHelpers.interopDefault(_riseJs);
var stdh0 = {
    sunrise: new (0, _sexagesimalJsDefault.default).Angle(true, 0, 50, 0).rad(),
    sunriseEnd: new (0, _sexagesimalJsDefault.default).Angle(true, 0, 18, 0).rad(),
    twilight: new (0, _sexagesimalJsDefault.default).Angle(true, 6, 0, 0).rad(),
    nauticalTwilight: new (0, _sexagesimalJsDefault.default).Angle(true, 12, 0, 0).rad(),
    night: new (0, _sexagesimalJsDefault.default).Angle(true, 18, 0, 0).rad(),
    goldenHour: new (0, _sexagesimalJsDefault.default).Angle(false, 6, 0, 0).rad()
};
var stdh0Sunrise = function(refraction) {
    return (0, _riseJsDefault.default).refraction(stdh0.sunrise, refraction);
};
var stdh0SunriseEnd = function(refraction) {
    return (0, _riseJsDefault.default).refraction(stdh0.sunriseEnd, refraction);
};
var stdh0Twilight = function(refraction) {
    return (0, _riseJsDefault.default).refraction(stdh0.twilight, refraction);
};
var stdh0NauticalTwilight = function(refraction) {
    return (0, _riseJsDefault.default).refraction(stdh0.nauticalTwilight, refraction);
};
var stdh0Night = function(refraction) {
    return (0, _riseJsDefault.default).refraction(stdh0.night, refraction);
};
var stdh0GoldenHour = function(refraction) {
    return (0, _riseJsDefault.default).refraction(stdh0.goldenHour, refraction);
};
var Sunrise = /*#__PURE__*/ function() {
    "use strict";
    function Sunrise(date, lat, lon, refraction) {
        (0, _classCallCheck._)(this, Sunrise);
        this.date = date;
        this.jde = date.midnight().toJDE();
        this.lat = (0, _sexagesimalJsDefault.default).angleFromDeg(lat);
        this.lon = (0, _sexagesimalJsDefault.default).angleFromDeg(lon);
        this.refraction = refraction;
    }
    (0, _createClass._)(Sunrise, [
        {
            key: "_calcNoon",
            value: function _calcNoon(jde) {
                var etime = (0, _sexagesimalJsDefault.default).secFromHourAngle((0, _eqtimeJsDefault.default).eSmart(jde));
                var delta = (0, _sexagesimalJsDefault.default).secFromHourAngle(this.lon);
                var time = 43200 /* noon */  + delta - etime // in seconds
                ;
                return (0, _baseJsDefault.default).pmod(time / 86400, 86400);
            }
        },
        {
            key: "_calcRiseOrSet",
            value: function _calcRiseOrSet(jde, h0, isSet) {
                var etime = (0, _sexagesimalJsDefault.default).secFromHourAngle((0, _eqtimeJsDefault.default).eSmart(jde));
                var solarDec = (0, _solarJsDefault.default).apparentEquatorial(jde).dec;
                var ha = (0, _riseJsDefault.default).hourAngle(this.lat, h0, solarDec);
                if (isSet) ha = -ha;
                var delta = (0, _sexagesimalJsDefault.default).secFromHourAngle(ha - this.lon);
                var time = 43200 /* noon */  - delta - etime // in seconds
                ;
                return time / 86400;
            }
        },
        {
            key: "_calcPolarDayNight",
            value: function _calcPolarDayNight(h0, isSet, step) {
                var jde = this.jde;
                var t;
                var failCnt = 0;
                while(failCnt < 190){
                    jde += step;
                    try {
                        t = this._calcRiseOrSet(jde, h0, isSet);
                        t = this._calcRiseOrSet(jde + t, h0, isSet);
                        break;
                    } catch (e) {
                        t = undefined;
                        failCnt++;
                    }
                }
                if (t === undefined) return;
                return new (0, _julianJsDefault.default).Calendar().fromJDE(jde + t);
            }
        },
        {
            key: "_calc",
            value: function _calc(h0, isSet) {
                var t;
                var jde = this.jde;
                // calc 2times for higher accuracy
                try {
                    t = this._calcRiseOrSet(jde, h0, isSet);
                    t = this._calcRiseOrSet(jde + t, h0, isSet);
                    return new (0, _julianJsDefault.default).Calendar().fromJDE(jde + t);
                } catch (e) {
                    var step = isSet ? -1 : 1;
                    var doy = this.date.dayOfYear();
                    if (this.lat > 0 && doy > 76 && doy < 267 || // northern hemisphere
                    this.lat < 0 && (doy < 83 || doy > 262) // southern hemisphere
                    ) step = -step;
                    return this._calcPolarDayNight(h0, isSet, step);
                }
            }
        },
        {
            /**
   * time of solar transit
   * @return {julian.Calendar} time of noon
   */ key: "noon",
            value: function noon() {
                var jde = this.jde;
                // calc 2times for higher accuracy
                var t = this._calcNoon(jde + this.lon / (2 * Math.PI));
                t = this._calcNoon(jde + t);
                return new (0, _julianJsDefault.default).Calendar().fromJDE(jde + t);
            }
        },
        {
            /**
   * Solar limb appears over the easter horizon in the morning
   * @return {julian.Calendar} time of sunrise
   */ key: "rise",
            value: function rise() {
                return this._calc(stdh0Sunrise(this.refraction), false);
            }
        },
        {
            /**
   * @return {julian.Calendar} time of sunset
   * Solar limb disappears on the western horizon in the evening
   */ key: "set",
            value: function set() {
                return this._calc(stdh0Sunrise(this.refraction), true);
            }
        },
        {
            /**
   * Solar limb is fully visible at the easter horizon
   * @return {julian.Calendar} time of sunrise end
   */ key: "riseEnd",
            value: function riseEnd() {
                return this._calc(stdh0SunriseEnd(this.refraction), false);
            }
        },
        {
            /**
   * Solar limb starts disappearing on the western horizon in the evening
   * @return {julian.Calendar} time of sunset start
   */ key: "setStart",
            value: function setStart() {
                return this._calc(stdh0SunriseEnd(this.refraction), true);
            }
        },
        {
            /**
   * Dawn, there is still enough light for objects to be distinguishable,
   * @return {julian.Calendar} time of dawn
   */ key: "dawn",
            value: function dawn() {
                return this._calc(stdh0Twilight(this.refraction), false);
            }
        },
        {
            /**
   * Dusk, there is still enough light for objects to be distinguishable
   * Bright stars and planets are visible by naked eye
   * @return {julian.Calendar} time of dusk
   */ key: "dusk",
            value: function dusk() {
                return this._calc(stdh0Twilight(this.refraction), true);
            }
        },
        {
            /**
   * nautical dawn - Horizon gets visible by naked eye
   * @return {julian.Calendar} time of nautical dawn
   */ key: "nauticalDawn",
            value: function nauticalDawn() {
                return this._calc(stdh0NauticalTwilight(this.refraction), false);
            }
        },
        {
            /**
   * nautical dusk - Horizon is no longer visible by naked eye
   * @return {julian.Calendar} time of nautical dusk
   */ key: "nauticalDusk",
            value: function nauticalDusk() {
                return this._calc(stdh0NauticalTwilight(this.refraction), true);
            }
        },
        {
            /**
   * night starts - No sunlight illumination of the sky, such no intereferance
   * with astronomical observations.
   * @return {julian.Calendar} time of start of night
   */ key: "nightStart",
            value: function nightStart() {
                return this._calc(stdh0Night(this.refraction), true);
            }
        },
        {
            /**
   * night end - Sunlight starts illumination of the sky and interferes
   * with astronomical observations.
   * @return {julian.Calendar} time of end of night
   */ key: "nightEnd",
            value: function nightEnd() {
                return this._calc(stdh0Night(this.refraction), false);
            }
        },
        {
            /**
   * Start of "golden hour" before sunset
   * @return {julian.Calendar} time of start of golden hour
   */ key: "goldenHourStart",
            value: function goldenHourStart() {
                return this._calc(stdh0GoldenHour(this.refraction), true);
            }
        },
        {
            /**
   * End of "golden hour" after sunrise
   * @return {julian.Calendar} time of end of golden hour
   */ key: "goldenHourEnd",
            value: function goldenHourEnd() {
                return this._calc(stdh0GoldenHour(this.refraction), false);
            }
        }
    ]);
    return Sunrise;
}();
exports.default = {
    Sunrise: Sunrise
};

},{"@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","./base.js":"lEDxD","./eqtime.js":"gGIfy","./sexagesimal.js":"aLUGo","./solar.js":"d2aLm","./julian.js":"hLXQt","./rise.js":"dhSt3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3Tj3D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return Hebrew;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _caldate = require("caldate");
var _caldateDefault = parcelHelpers.interopDefault(_caldate);
var _calEventMapJs = require("./CalEventMap.js");
var _calEventMapJsDefault = parcelHelpers.interopDefault(_calEventMapJs);
var _hebrewCalendarJs = require("./internal/hebrew-calendar.js");
var Hebrew = /*#__PURE__*/ function(CalEventMap) {
    "use strict";
    (0, _inherits._)(Hebrew, CalEventMap);
    function Hebrew(opts) {
        (0, _classCallCheck._)(this, Hebrew);
        var _this;
        _this = (0, _callSuper._)(this, Hebrew, [
            opts
        ]);
        _this.calendar = (0, _hebrewCalendarJs.calendar);
        return _this;
    }
    (0, _createClass._)(Hebrew, [
        {
            key: "get",
            value: function get(timezone) {
                var _this = this;
                var arr = this.dates.map(function(date) {
                    var cdate = new (0, _caldateDefault.default)(date);
                    var o = {
                        date: cdate.toString() + ' -0600',
                        start: cdate.setOffset(-6, 'h').toTimezone(timezone),
                        end: cdate.toEndDate().toTimezone(timezone)
                    };
                    _this._addSubstitute(date, o);
                    return o;
                });
                return arr;
            }
        }
    ]);
    return Hebrew;
}((0, _calEventMapJsDefault.default));

},{"@swc/helpers/_/_call_super":"5oPMc","@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","@swc/helpers/_/_inherits":"j8HRi","caldate":"he6lr","./CalEventMap.js":"ltG5M","./internal/hebrew-calendar.js":"6xFoE","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"ltG5M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Mapper class for mapped calenders like hijri and hebrew
 * `this.calender` needs to be set in child classes
 */ parcelHelpers.export(exports, "default", function() {
    return CalEventMap;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _calEventJs = require("./CalEvent.js");
var _calEventJsDefault = parcelHelpers.interopDefault(_calEventJs);
var _caldate = require("caldate");
var _caldateDefault = parcelHelpers.interopDefault(_caldate);
var CalEventMap = /*#__PURE__*/ function(CalEvent) {
    "use strict";
    (0, _inherits._)(CalEventMap, CalEvent);
    function CalEventMap(opts) {
        (0, _classCallCheck._)(this, CalEventMap);
        var _this;
        _this = (0, _callSuper._)(this, CalEventMap, [
            opts
        ]);
        _this.calendar = {};
        return _this;
    }
    (0, _createClass._)(CalEventMap, [
        {
            key: "inYear",
            value: function inYear(year) {
                if (!(this.calendar[year] && this.calendar[year + 1] && this.calendar[year - 1])) return this;
                for(var y = year - 1; y <= year + 1; y++){
                    // resolve date in `calendar` as gregorian date
                    var firstDays = this.calendar[y][this.opts.month - 1];
                    // firstDays `[M, D, diffYear, ...] | null`
                    if (!firstDays) continue;
                    for(var i = 0; i < firstDays.length; i += 3){
                        if (this.opts.year) {
                            var calYear = this.calendar.year + firstDays[i + 2];
                            if (this.opts.year !== calYear) continue;
                        }
                        var d = new (0, _caldateDefault.default)({
                            year: y,
                            month: firstDays[i] + 1,
                            day: firstDays[i + 1]
                        }).setOffset(this.opts.day - 1);
                        if (d.year === year) this.dates.push(d);
                    }
                }
                return this;
            }
        }
    ]);
    return CalEventMap;
}((0, _calEventJsDefault.default));

},{"@swc/helpers/_/_call_super":"5oPMc","@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","@swc/helpers/_/_inherits":"j8HRi","./CalEvent.js":"jJ8pL","caldate":"he6lr","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6xFoE":[function(require,module,exports,__globalThis) {
/*eslint-disable*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calendar", function() {
    return calendar;
});
var calendar = {
    1968: [
        null,
        null,
        null,
        null,
        null,
        null,
        [
            8,
            23,
            0
        ],
        [
            9,
            23,
            0
        ],
        [
            10,
            22,
            0
        ],
        [
            11,
            22,
            0
        ]
    ],
    1969: [
        [
            2,
            20,
            0
        ],
        [
            3,
            19,
            0
        ],
        [
            4,
            18,
            0
        ],
        [
            5,
            17,
            0
        ],
        [
            6,
            16,
            0
        ],
        [
            7,
            15,
            0
        ],
        [
            8,
            13,
            1
        ],
        [
            9,
            13,
            1
        ],
        [
            10,
            11,
            1
        ],
        [
            11,
            10,
            1
        ],
        [
            0,
            20,
            0
        ],
        [
            1,
            19,
            0
        ],
        [
            1,
            19,
            0
        ]
    ],
    1970: [
        [
            3,
            7,
            1
        ],
        [
            4,
            7,
            1
        ],
        [
            5,
            5,
            1
        ],
        [
            6,
            5,
            1
        ],
        [
            7,
            3,
            1
        ],
        [
            8,
            2,
            1
        ],
        [
            9,
            1,
            2
        ],
        [
            9,
            31,
            2
        ],
        [
            10,
            29,
            2
        ],
        [
            11,
            29,
            2
        ],
        [
            0,
            8,
            1
        ],
        [
            1,
            7,
            1
        ],
        [
            2,
            9,
            1
        ]
    ],
    1971: [
        [
            2,
            27,
            2
        ],
        [
            3,
            26,
            2
        ],
        [
            4,
            25,
            2
        ],
        [
            5,
            24,
            2
        ],
        [
            6,
            23,
            2
        ],
        [
            7,
            22,
            2
        ],
        [
            8,
            20,
            3
        ],
        [
            9,
            20,
            3
        ],
        [
            10,
            19,
            3
        ],
        [
            11,
            19,
            3
        ],
        [
            0,
            27,
            2
        ],
        [
            1,
            26,
            2
        ],
        [
            1,
            26,
            2
        ]
    ],
    1972: [
        [
            2,
            16,
            3
        ],
        [
            3,
            15,
            3
        ],
        [
            4,
            14,
            3
        ],
        [
            5,
            13,
            3
        ],
        [
            6,
            12,
            3
        ],
        [
            7,
            11,
            3
        ],
        [
            8,
            9,
            4
        ],
        [
            9,
            9,
            4
        ],
        [
            10,
            7,
            4
        ],
        [
            11,
            6,
            4
        ],
        [
            0,
            17,
            3
        ],
        [
            1,
            16,
            3
        ],
        [
            1,
            16,
            3
        ]
    ],
    1973: [
        [
            3,
            3,
            4
        ],
        [
            4,
            3,
            4
        ],
        [
            5,
            1,
            4
        ],
        [
            6,
            1,
            4
        ],
        [
            6,
            30,
            4
        ],
        [
            7,
            29,
            4
        ],
        [
            8,
            27,
            5
        ],
        [
            9,
            27,
            5
        ],
        [
            10,
            26,
            5
        ],
        [
            11,
            26,
            5
        ],
        [
            0,
            4,
            4
        ],
        [
            1,
            3,
            4
        ],
        [
            2,
            5,
            4
        ]
    ],
    1974: [
        [
            2,
            24,
            5
        ],
        [
            3,
            23,
            5
        ],
        [
            4,
            22,
            5
        ],
        [
            5,
            21,
            5
        ],
        [
            6,
            20,
            5
        ],
        [
            7,
            19,
            5
        ],
        [
            8,
            17,
            6
        ],
        [
            9,
            17,
            6
        ],
        [
            10,
            15,
            6
        ],
        [
            11,
            15,
            6
        ],
        [
            0,
            24,
            5
        ],
        [
            1,
            23,
            5
        ],
        [
            1,
            23,
            5
        ]
    ],
    1975: [
        [
            2,
            13,
            6
        ],
        [
            3,
            12,
            6
        ],
        [
            4,
            11,
            6
        ],
        [
            5,
            10,
            6
        ],
        [
            6,
            9,
            6
        ],
        [
            7,
            8,
            6
        ],
        [
            8,
            6,
            7
        ],
        [
            9,
            6,
            7
        ],
        [
            10,
            5,
            7
        ],
        [
            11,
            5,
            7
        ],
        [
            0,
            13,
            6
        ],
        [
            1,
            12,
            6
        ],
        [
            1,
            12,
            6
        ]
    ],
    1976: [
        [
            3,
            1,
            7
        ],
        [
            4,
            1,
            7
        ],
        [
            4,
            30,
            7
        ],
        [
            5,
            29,
            7
        ],
        [
            6,
            28,
            7
        ],
        [
            7,
            27,
            7
        ],
        [
            8,
            25,
            8
        ],
        [
            9,
            25,
            8
        ],
        [
            10,
            23,
            8
        ],
        [
            11,
            22,
            8
        ],
        [
            0,
            3,
            7
        ],
        [
            1,
            2,
            7
        ],
        [
            2,
            3,
            7
        ]
    ],
    1977: [
        [
            2,
            20,
            8
        ],
        [
            3,
            19,
            8
        ],
        [
            4,
            18,
            8
        ],
        [
            5,
            17,
            8
        ],
        [
            6,
            16,
            8
        ],
        [
            7,
            15,
            8
        ],
        [
            8,
            13,
            9
        ],
        [
            9,
            13,
            9
        ],
        [
            10,
            11,
            9
        ],
        [
            11,
            11,
            9
        ],
        [
            0,
            20,
            8
        ],
        [
            1,
            19,
            8
        ],
        [
            1,
            19,
            8
        ]
    ],
    1978: [
        [
            3,
            8,
            9
        ],
        [
            4,
            8,
            9
        ],
        [
            5,
            6,
            9
        ],
        [
            6,
            6,
            9
        ],
        [
            7,
            4,
            9
        ],
        [
            8,
            3,
            9
        ],
        [
            9,
            2,
            10
        ],
        [
            10,
            1,
            10
        ],
        [
            11,
            1,
            10
        ],
        [
            11,
            31,
            10
        ],
        [
            0,
            9,
            9
        ],
        [
            1,
            8,
            9
        ],
        [
            2,
            10,
            9
        ]
    ],
    1979: [
        [
            2,
            29,
            10
        ],
        [
            3,
            28,
            10
        ],
        [
            4,
            27,
            10
        ],
        [
            5,
            26,
            10
        ],
        [
            6,
            25,
            10
        ],
        [
            7,
            24,
            10
        ],
        [
            8,
            22,
            11
        ],
        [
            9,
            22,
            11
        ],
        [
            10,
            21,
            11
        ],
        [
            11,
            21,
            11
        ],
        [
            0,
            29,
            10
        ],
        [
            1,
            28,
            10
        ],
        [
            1,
            28,
            10
        ]
    ],
    1980: [
        [
            2,
            18,
            11
        ],
        [
            3,
            17,
            11
        ],
        [
            4,
            16,
            11
        ],
        [
            5,
            15,
            11
        ],
        [
            6,
            14,
            11
        ],
        [
            7,
            13,
            11
        ],
        [
            8,
            11,
            12
        ],
        [
            9,
            11,
            12
        ],
        [
            10,
            9,
            12
        ],
        [
            11,
            8,
            12
        ],
        [
            0,
            19,
            11
        ],
        [
            1,
            18,
            11
        ],
        [
            1,
            18,
            11
        ]
    ],
    1981: [
        [
            3,
            5,
            12
        ],
        [
            4,
            5,
            12
        ],
        [
            5,
            3,
            12
        ],
        [
            6,
            3,
            12
        ],
        [
            7,
            1,
            12
        ],
        [
            7,
            31,
            12
        ],
        [
            8,
            29,
            13
        ],
        [
            9,
            29,
            13
        ],
        [
            10,
            27,
            13
        ],
        [
            11,
            27,
            13
        ],
        [
            0,
            6,
            12
        ],
        [
            1,
            5,
            12
        ],
        [
            2,
            7,
            12
        ]
    ],
    1982: [
        [
            2,
            25,
            13
        ],
        [
            3,
            24,
            13
        ],
        [
            4,
            23,
            13
        ],
        [
            5,
            22,
            13
        ],
        [
            6,
            21,
            13
        ],
        [
            7,
            20,
            13
        ],
        [
            8,
            18,
            14
        ],
        [
            9,
            18,
            14
        ],
        [
            10,
            17,
            14
        ],
        [
            11,
            17,
            14
        ],
        [
            0,
            25,
            13
        ],
        [
            1,
            24,
            13
        ],
        [
            1,
            24,
            13
        ]
    ],
    1983: [
        [
            2,
            15,
            14
        ],
        [
            3,
            14,
            14
        ],
        [
            4,
            13,
            14
        ],
        [
            5,
            12,
            14
        ],
        [
            6,
            11,
            14
        ],
        [
            7,
            10,
            14
        ],
        [
            8,
            8,
            15
        ],
        [
            9,
            8,
            15
        ],
        [
            10,
            7,
            15
        ],
        [
            11,
            7,
            15
        ],
        [
            0,
            15,
            14
        ],
        [
            1,
            14,
            14
        ],
        [
            1,
            14,
            14
        ]
    ],
    1984: [
        [
            3,
            3,
            15
        ],
        [
            4,
            3,
            15
        ],
        [
            5,
            1,
            15
        ],
        [
            6,
            1,
            15
        ],
        [
            6,
            30,
            15
        ],
        [
            7,
            29,
            15
        ],
        [
            8,
            27,
            16
        ],
        [
            9,
            27,
            16
        ],
        [
            10,
            25,
            16
        ],
        [
            11,
            25,
            16
        ],
        [
            0,
            5,
            15
        ],
        [
            1,
            4,
            15
        ],
        [
            2,
            5,
            15
        ]
    ],
    1985: [
        [
            2,
            23,
            16
        ],
        [
            3,
            22,
            16
        ],
        [
            4,
            21,
            16
        ],
        [
            5,
            20,
            16
        ],
        [
            6,
            19,
            16
        ],
        [
            7,
            18,
            16
        ],
        [
            8,
            16,
            17
        ],
        [
            9,
            16,
            17
        ],
        [
            10,
            14,
            17
        ],
        [
            11,
            13,
            17
        ],
        [
            0,
            23,
            16
        ],
        [
            1,
            22,
            16
        ],
        [
            1,
            22,
            16
        ]
    ],
    1986: [
        [
            3,
            10,
            17
        ],
        [
            4,
            10,
            17
        ],
        [
            5,
            8,
            17
        ],
        [
            6,
            8,
            17
        ],
        [
            7,
            6,
            17
        ],
        [
            8,
            5,
            17
        ],
        [
            9,
            4,
            18
        ],
        [
            10,
            3,
            18
        ],
        [
            11,
            3,
            18
        ],
        null,
        [
            0,
            11,
            17
        ],
        [
            1,
            10,
            17
        ],
        [
            2,
            12,
            17
        ]
    ],
    1987: [
        [
            2,
            31,
            18
        ],
        [
            3,
            30,
            18
        ],
        [
            4,
            29,
            18
        ],
        [
            5,
            28,
            18
        ],
        [
            6,
            27,
            18
        ],
        [
            7,
            26,
            18
        ],
        [
            8,
            24,
            19
        ],
        [
            9,
            24,
            19
        ],
        [
            10,
            22,
            19
        ],
        [
            0,
            2,
            18,
            11,
            22,
            19
        ],
        [
            0,
            31,
            18
        ],
        [
            2,
            2,
            18
        ],
        [
            2,
            2,
            18
        ]
    ],
    1988: [
        [
            2,
            19,
            19
        ],
        [
            3,
            18,
            19
        ],
        [
            4,
            17,
            19
        ],
        [
            5,
            16,
            19
        ],
        [
            6,
            15,
            19
        ],
        [
            7,
            14,
            19
        ],
        [
            8,
            12,
            20
        ],
        [
            9,
            12,
            20
        ],
        [
            10,
            10,
            20
        ],
        [
            11,
            9,
            20
        ],
        [
            0,
            20,
            19
        ],
        [
            1,
            19,
            19
        ],
        [
            1,
            19,
            19
        ]
    ],
    1989: [
        [
            3,
            6,
            20
        ],
        [
            4,
            6,
            20
        ],
        [
            5,
            4,
            20
        ],
        [
            6,
            4,
            20
        ],
        [
            7,
            2,
            20
        ],
        [
            8,
            1,
            20
        ],
        [
            8,
            30,
            21
        ],
        [
            9,
            30,
            21
        ],
        [
            10,
            29,
            21
        ],
        [
            11,
            29,
            21
        ],
        [
            0,
            7,
            20
        ],
        [
            1,
            6,
            20
        ],
        [
            2,
            8,
            20
        ]
    ],
    1990: [
        [
            2,
            27,
            21
        ],
        [
            3,
            26,
            21
        ],
        [
            4,
            25,
            21
        ],
        [
            5,
            24,
            21
        ],
        [
            6,
            23,
            21
        ],
        [
            7,
            22,
            21
        ],
        [
            8,
            20,
            22
        ],
        [
            9,
            20,
            22
        ],
        [
            10,
            18,
            22
        ],
        [
            11,
            18,
            22
        ],
        [
            0,
            27,
            21
        ],
        [
            1,
            26,
            21
        ],
        [
            1,
            26,
            21
        ]
    ],
    1991: [
        [
            2,
            16,
            22
        ],
        [
            3,
            15,
            22
        ],
        [
            4,
            14,
            22
        ],
        [
            5,
            13,
            22
        ],
        [
            6,
            12,
            22
        ],
        [
            7,
            11,
            22
        ],
        [
            8,
            9,
            23
        ],
        [
            9,
            9,
            23
        ],
        [
            10,
            8,
            23
        ],
        [
            11,
            8,
            23
        ],
        [
            0,
            16,
            22
        ],
        [
            1,
            15,
            22
        ],
        [
            1,
            15,
            22
        ]
    ],
    1992: [
        [
            3,
            4,
            23
        ],
        [
            4,
            4,
            23
        ],
        [
            5,
            2,
            23
        ],
        [
            6,
            2,
            23
        ],
        [
            6,
            31,
            23
        ],
        [
            7,
            30,
            23
        ],
        [
            8,
            28,
            24
        ],
        [
            9,
            28,
            24
        ],
        [
            10,
            26,
            24
        ],
        [
            11,
            25,
            24
        ],
        [
            0,
            6,
            23
        ],
        [
            1,
            5,
            23
        ],
        [
            2,
            6,
            23
        ]
    ],
    1993: [
        [
            2,
            23,
            24
        ],
        [
            3,
            22,
            24
        ],
        [
            4,
            21,
            24
        ],
        [
            5,
            20,
            24
        ],
        [
            6,
            19,
            24
        ],
        [
            7,
            18,
            24
        ],
        [
            8,
            16,
            25
        ],
        [
            9,
            16,
            25
        ],
        [
            10,
            15,
            25
        ],
        [
            11,
            15,
            25
        ],
        [
            0,
            23,
            24
        ],
        [
            1,
            22,
            24
        ],
        [
            1,
            22,
            24
        ]
    ],
    1994: [
        [
            2,
            13,
            25
        ],
        [
            3,
            12,
            25
        ],
        [
            4,
            11,
            25
        ],
        [
            5,
            10,
            25
        ],
        [
            6,
            9,
            25
        ],
        [
            7,
            8,
            25
        ],
        [
            8,
            6,
            26
        ],
        [
            9,
            6,
            26
        ],
        [
            10,
            4,
            26
        ],
        [
            11,
            4,
            26
        ],
        [
            0,
            13,
            25
        ],
        [
            1,
            12,
            25
        ],
        [
            1,
            12,
            25
        ]
    ],
    1995: [
        [
            3,
            1,
            26
        ],
        [
            4,
            1,
            26
        ],
        [
            4,
            30,
            26
        ],
        [
            5,
            29,
            26
        ],
        [
            6,
            28,
            26
        ],
        [
            7,
            27,
            26
        ],
        [
            8,
            25,
            27
        ],
        [
            9,
            25,
            27
        ],
        [
            10,
            24,
            27
        ],
        [
            11,
            24,
            27
        ],
        [
            0,
            2,
            26
        ],
        [
            1,
            1,
            26
        ],
        [
            2,
            3,
            26
        ]
    ],
    1996: [
        [
            2,
            21,
            27
        ],
        [
            3,
            20,
            27
        ],
        [
            4,
            19,
            27
        ],
        [
            5,
            18,
            27
        ],
        [
            6,
            17,
            27
        ],
        [
            7,
            16,
            27
        ],
        [
            8,
            14,
            28
        ],
        [
            9,
            14,
            28
        ],
        [
            10,
            12,
            28
        ],
        [
            11,
            11,
            28
        ],
        [
            0,
            22,
            27
        ],
        [
            1,
            21,
            27
        ],
        [
            1,
            21,
            27
        ]
    ],
    1997: [
        [
            3,
            8,
            28
        ],
        [
            4,
            8,
            28
        ],
        [
            5,
            6,
            28
        ],
        [
            6,
            6,
            28
        ],
        [
            7,
            4,
            28
        ],
        [
            8,
            3,
            28
        ],
        [
            9,
            2,
            29
        ],
        [
            10,
            1,
            29
        ],
        [
            10,
            30,
            29
        ],
        [
            11,
            30,
            29
        ],
        [
            0,
            9,
            28
        ],
        [
            1,
            8,
            28
        ],
        [
            2,
            10,
            28
        ]
    ],
    1998: [
        [
            2,
            28,
            29
        ],
        [
            3,
            27,
            29
        ],
        [
            4,
            26,
            29
        ],
        [
            5,
            25,
            29
        ],
        [
            6,
            24,
            29
        ],
        [
            7,
            23,
            29
        ],
        [
            8,
            21,
            30
        ],
        [
            9,
            21,
            30
        ],
        [
            10,
            20,
            30
        ],
        [
            11,
            20,
            30
        ],
        [
            0,
            28,
            29
        ],
        [
            1,
            27,
            29
        ],
        [
            1,
            27,
            29
        ]
    ],
    1999: [
        [
            2,
            18,
            30
        ],
        [
            3,
            17,
            30
        ],
        [
            4,
            16,
            30
        ],
        [
            5,
            15,
            30
        ],
        [
            6,
            14,
            30
        ],
        [
            7,
            13,
            30
        ],
        [
            8,
            11,
            31
        ],
        [
            9,
            11,
            31
        ],
        [
            10,
            10,
            31
        ],
        [
            11,
            10,
            31
        ],
        [
            0,
            18,
            30
        ],
        [
            1,
            17,
            30
        ],
        [
            1,
            17,
            30
        ]
    ],
    2000: [
        [
            3,
            6,
            31
        ],
        [
            4,
            6,
            31
        ],
        [
            5,
            4,
            31
        ],
        [
            6,
            4,
            31
        ],
        [
            7,
            2,
            31
        ],
        [
            8,
            1,
            31
        ],
        [
            8,
            30,
            32
        ],
        [
            9,
            30,
            32
        ],
        [
            10,
            28,
            32
        ],
        [
            11,
            27,
            32
        ],
        [
            0,
            8,
            31
        ],
        [
            1,
            7,
            31
        ],
        [
            2,
            8,
            31
        ]
    ],
    2001: [
        [
            2,
            25,
            32
        ],
        [
            3,
            24,
            32
        ],
        [
            4,
            23,
            32
        ],
        [
            5,
            22,
            32
        ],
        [
            6,
            21,
            32
        ],
        [
            7,
            20,
            32
        ],
        [
            8,
            18,
            33
        ],
        [
            9,
            18,
            33
        ],
        [
            10,
            16,
            33
        ],
        [
            11,
            16,
            33
        ],
        [
            0,
            25,
            32
        ],
        [
            1,
            24,
            32
        ],
        [
            1,
            24,
            32
        ]
    ],
    2002: [
        [
            2,
            14,
            33
        ],
        [
            3,
            13,
            33
        ],
        [
            4,
            12,
            33
        ],
        [
            5,
            11,
            33
        ],
        [
            6,
            10,
            33
        ],
        [
            7,
            9,
            33
        ],
        [
            8,
            7,
            34
        ],
        [
            9,
            7,
            34
        ],
        [
            10,
            6,
            34
        ],
        [
            11,
            6,
            34
        ],
        [
            0,
            14,
            33
        ],
        [
            1,
            13,
            33
        ],
        [
            1,
            13,
            33
        ]
    ],
    2003: [
        [
            3,
            3,
            34
        ],
        [
            4,
            3,
            34
        ],
        [
            5,
            1,
            34
        ],
        [
            6,
            1,
            34
        ],
        [
            6,
            30,
            34
        ],
        [
            7,
            29,
            34
        ],
        [
            8,
            27,
            35
        ],
        [
            9,
            27,
            35
        ],
        [
            10,
            26,
            35
        ],
        [
            11,
            26,
            35
        ],
        [
            0,
            4,
            34
        ],
        [
            1,
            3,
            34
        ],
        [
            2,
            5,
            34
        ]
    ],
    2004: [
        [
            2,
            23,
            35
        ],
        [
            3,
            22,
            35
        ],
        [
            4,
            21,
            35
        ],
        [
            5,
            20,
            35
        ],
        [
            6,
            19,
            35
        ],
        [
            7,
            18,
            35
        ],
        [
            8,
            16,
            36
        ],
        [
            9,
            16,
            36
        ],
        [
            10,
            14,
            36
        ],
        [
            11,
            13,
            36
        ],
        [
            0,
            24,
            35
        ],
        [
            1,
            23,
            35
        ],
        [
            1,
            23,
            35
        ]
    ],
    2005: [
        [
            3,
            10,
            36
        ],
        [
            4,
            10,
            36
        ],
        [
            5,
            8,
            36
        ],
        [
            6,
            8,
            36
        ],
        [
            7,
            6,
            36
        ],
        [
            8,
            5,
            36
        ],
        [
            9,
            4,
            37
        ],
        [
            10,
            3,
            37
        ],
        [
            11,
            2,
            37
        ],
        null,
        [
            0,
            11,
            36
        ],
        [
            1,
            10,
            36
        ],
        [
            2,
            12,
            36
        ]
    ],
    2006: [
        [
            2,
            30,
            37
        ],
        [
            3,
            29,
            37
        ],
        [
            4,
            28,
            37
        ],
        [
            5,
            27,
            37
        ],
        [
            6,
            26,
            37
        ],
        [
            7,
            25,
            37
        ],
        [
            8,
            23,
            38
        ],
        [
            9,
            23,
            38
        ],
        [
            10,
            22,
            38
        ],
        [
            0,
            1,
            37,
            11,
            22,
            38
        ],
        [
            0,
            30,
            37
        ],
        [
            2,
            1,
            37
        ],
        [
            2,
            1,
            37
        ]
    ],
    2007: [
        [
            2,
            20,
            38
        ],
        [
            3,
            19,
            38
        ],
        [
            4,
            18,
            38
        ],
        [
            5,
            17,
            38
        ],
        [
            6,
            16,
            38
        ],
        [
            7,
            15,
            38
        ],
        [
            8,
            13,
            39
        ],
        [
            9,
            13,
            39
        ],
        [
            10,
            11,
            39
        ],
        [
            11,
            10,
            39
        ],
        [
            0,
            20,
            38
        ],
        [
            1,
            19,
            38
        ],
        [
            1,
            19,
            38
        ]
    ],
    2008: [
        [
            3,
            6,
            39
        ],
        [
            4,
            6,
            39
        ],
        [
            5,
            4,
            39
        ],
        [
            6,
            4,
            39
        ],
        [
            7,
            2,
            39
        ],
        [
            8,
            1,
            39
        ],
        [
            8,
            30,
            40
        ],
        [
            9,
            30,
            40
        ],
        [
            10,
            28,
            40
        ],
        [
            11,
            28,
            40
        ],
        [
            0,
            8,
            39
        ],
        [
            1,
            7,
            39
        ],
        [
            2,
            8,
            39
        ]
    ],
    2009: [
        [
            2,
            26,
            40
        ],
        [
            3,
            25,
            40
        ],
        [
            4,
            24,
            40
        ],
        [
            5,
            23,
            40
        ],
        [
            6,
            22,
            40
        ],
        [
            7,
            21,
            40
        ],
        [
            8,
            19,
            41
        ],
        [
            9,
            19,
            41
        ],
        [
            10,
            18,
            41
        ],
        [
            11,
            18,
            41
        ],
        [
            0,
            26,
            40
        ],
        [
            1,
            25,
            40
        ],
        [
            1,
            25,
            40
        ]
    ],
    2010: [
        [
            2,
            16,
            41
        ],
        [
            3,
            15,
            41
        ],
        [
            4,
            14,
            41
        ],
        [
            5,
            13,
            41
        ],
        [
            6,
            12,
            41
        ],
        [
            7,
            11,
            41
        ],
        [
            8,
            9,
            42
        ],
        [
            9,
            9,
            42
        ],
        [
            10,
            8,
            42
        ],
        [
            11,
            8,
            42
        ],
        [
            0,
            16,
            41
        ],
        [
            1,
            15,
            41
        ],
        [
            1,
            15,
            41
        ]
    ],
    2011: [
        [
            3,
            5,
            42
        ],
        [
            4,
            5,
            42
        ],
        [
            5,
            3,
            42
        ],
        [
            6,
            3,
            42
        ],
        [
            7,
            1,
            42
        ],
        [
            7,
            31,
            42
        ],
        [
            8,
            29,
            43
        ],
        [
            9,
            29,
            43
        ],
        [
            10,
            27,
            43
        ],
        [
            11,
            27,
            43
        ],
        [
            0,
            6,
            42
        ],
        [
            1,
            5,
            42
        ],
        [
            2,
            7,
            42
        ]
    ],
    2012: [
        [
            2,
            24,
            43
        ],
        [
            3,
            23,
            43
        ],
        [
            4,
            22,
            43
        ],
        [
            5,
            21,
            43
        ],
        [
            6,
            20,
            43
        ],
        [
            7,
            19,
            43
        ],
        [
            8,
            17,
            44
        ],
        [
            9,
            17,
            44
        ],
        [
            10,
            15,
            44
        ],
        [
            11,
            14,
            44
        ],
        [
            0,
            25,
            43
        ],
        [
            1,
            24,
            43
        ],
        [
            1,
            24,
            43
        ]
    ],
    2013: [
        [
            2,
            12,
            44
        ],
        [
            3,
            11,
            44
        ],
        [
            4,
            10,
            44
        ],
        [
            5,
            9,
            44
        ],
        [
            6,
            8,
            44
        ],
        [
            7,
            7,
            44
        ],
        [
            8,
            5,
            45
        ],
        [
            9,
            5,
            45
        ],
        [
            10,
            4,
            45
        ],
        [
            11,
            4,
            45
        ],
        [
            0,
            12,
            44
        ],
        [
            1,
            11,
            44
        ],
        [
            1,
            11,
            44
        ]
    ],
    2014: [
        [
            3,
            1,
            45
        ],
        [
            4,
            1,
            45
        ],
        [
            4,
            30,
            45
        ],
        [
            5,
            29,
            45
        ],
        [
            6,
            28,
            45
        ],
        [
            7,
            27,
            45
        ],
        [
            8,
            25,
            46
        ],
        [
            9,
            25,
            46
        ],
        [
            10,
            23,
            46
        ],
        [
            11,
            23,
            46
        ],
        [
            0,
            2,
            45
        ],
        [
            1,
            1,
            45
        ],
        [
            2,
            3,
            45
        ]
    ],
    2015: [
        [
            2,
            21,
            46
        ],
        [
            3,
            20,
            46
        ],
        [
            4,
            19,
            46
        ],
        [
            5,
            18,
            46
        ],
        [
            6,
            17,
            46
        ],
        [
            7,
            16,
            46
        ],
        [
            8,
            14,
            47
        ],
        [
            9,
            14,
            47
        ],
        [
            10,
            13,
            47
        ],
        [
            11,
            13,
            47
        ],
        [
            0,
            21,
            46
        ],
        [
            1,
            20,
            46
        ],
        [
            1,
            20,
            46
        ]
    ],
    2016: [
        [
            3,
            9,
            47
        ],
        [
            4,
            9,
            47
        ],
        [
            5,
            7,
            47
        ],
        [
            6,
            7,
            47
        ],
        [
            7,
            5,
            47
        ],
        [
            8,
            4,
            47
        ],
        [
            9,
            3,
            48
        ],
        [
            10,
            2,
            48
        ],
        [
            11,
            1,
            48
        ],
        [
            11,
            30,
            48
        ],
        [
            0,
            11,
            47
        ],
        [
            1,
            10,
            47
        ],
        [
            2,
            11,
            47
        ]
    ],
    2017: [
        [
            2,
            28,
            48
        ],
        [
            3,
            27,
            48
        ],
        [
            4,
            26,
            48
        ],
        [
            5,
            25,
            48
        ],
        [
            6,
            24,
            48
        ],
        [
            7,
            23,
            48
        ],
        [
            8,
            21,
            49
        ],
        [
            9,
            21,
            49
        ],
        [
            10,
            19,
            49
        ],
        [
            11,
            19,
            49
        ],
        [
            0,
            28,
            48
        ],
        [
            1,
            27,
            48
        ],
        [
            1,
            27,
            48
        ]
    ],
    2018: [
        [
            2,
            17,
            49
        ],
        [
            3,
            16,
            49
        ],
        [
            4,
            15,
            49
        ],
        [
            5,
            14,
            49
        ],
        [
            6,
            13,
            49
        ],
        [
            7,
            12,
            49
        ],
        [
            8,
            10,
            50
        ],
        [
            9,
            10,
            50
        ],
        [
            10,
            9,
            50
        ],
        [
            11,
            9,
            50
        ],
        [
            0,
            17,
            49
        ],
        [
            1,
            16,
            49
        ],
        [
            1,
            16,
            49
        ]
    ],
    2019: [
        [
            3,
            6,
            50
        ],
        [
            4,
            6,
            50
        ],
        [
            5,
            4,
            50
        ],
        [
            6,
            4,
            50
        ],
        [
            7,
            2,
            50
        ],
        [
            8,
            1,
            50
        ],
        [
            8,
            30,
            51
        ],
        [
            9,
            30,
            51
        ],
        [
            10,
            29,
            51
        ],
        [
            11,
            29,
            51
        ],
        [
            0,
            7,
            50
        ],
        [
            1,
            6,
            50
        ],
        [
            2,
            8,
            50
        ]
    ],
    2020: [
        [
            2,
            26,
            51
        ],
        [
            3,
            25,
            51
        ],
        [
            4,
            24,
            51
        ],
        [
            5,
            23,
            51
        ],
        [
            6,
            22,
            51
        ],
        [
            7,
            21,
            51
        ],
        [
            8,
            19,
            52
        ],
        [
            9,
            19,
            52
        ],
        [
            10,
            17,
            52
        ],
        [
            11,
            16,
            52
        ],
        [
            0,
            27,
            51
        ],
        [
            1,
            26,
            51
        ],
        [
            1,
            26,
            51
        ]
    ],
    2021: [
        [
            2,
            14,
            52
        ],
        [
            3,
            13,
            52
        ],
        [
            4,
            12,
            52
        ],
        [
            5,
            11,
            52
        ],
        [
            6,
            10,
            52
        ],
        [
            7,
            9,
            52
        ],
        [
            8,
            7,
            53
        ],
        [
            9,
            7,
            53
        ],
        [
            10,
            5,
            53
        ],
        [
            11,
            5,
            53
        ],
        [
            0,
            14,
            52
        ],
        [
            1,
            13,
            52
        ],
        [
            1,
            13,
            52
        ]
    ],
    2022: [
        [
            3,
            2,
            53
        ],
        [
            4,
            2,
            53
        ],
        [
            4,
            31,
            53
        ],
        [
            5,
            30,
            53
        ],
        [
            6,
            29,
            53
        ],
        [
            7,
            28,
            53
        ],
        [
            8,
            26,
            54
        ],
        [
            9,
            26,
            54
        ],
        [
            10,
            25,
            54
        ],
        [
            11,
            25,
            54
        ],
        [
            0,
            3,
            53
        ],
        [
            1,
            2,
            53
        ],
        [
            2,
            4,
            53
        ]
    ],
    2023: [
        [
            2,
            23,
            54
        ],
        [
            3,
            22,
            54
        ],
        [
            4,
            21,
            54
        ],
        [
            5,
            20,
            54
        ],
        [
            6,
            19,
            54
        ],
        [
            7,
            18,
            54
        ],
        [
            8,
            16,
            55
        ],
        [
            9,
            16,
            55
        ],
        [
            10,
            14,
            55
        ],
        [
            11,
            13,
            55
        ],
        [
            0,
            23,
            54
        ],
        [
            1,
            22,
            54
        ],
        [
            1,
            22,
            54
        ]
    ],
    2024: [
        [
            3,
            9,
            55
        ],
        [
            4,
            9,
            55
        ],
        [
            5,
            7,
            55
        ],
        [
            6,
            7,
            55
        ],
        [
            7,
            5,
            55
        ],
        [
            8,
            4,
            55
        ],
        [
            9,
            3,
            56
        ],
        [
            10,
            2,
            56
        ],
        [
            11,
            2,
            56
        ],
        null,
        [
            0,
            11,
            55
        ],
        [
            1,
            10,
            55
        ],
        [
            2,
            11,
            55
        ]
    ],
    2025: [
        [
            2,
            30,
            56
        ],
        [
            3,
            29,
            56
        ],
        [
            4,
            28,
            56
        ],
        [
            5,
            27,
            56
        ],
        [
            6,
            26,
            56
        ],
        [
            7,
            25,
            56
        ],
        [
            8,
            23,
            57
        ],
        [
            9,
            23,
            57
        ],
        [
            10,
            21,
            57
        ],
        [
            0,
            1,
            56,
            11,
            21,
            57
        ],
        [
            0,
            30,
            56
        ],
        [
            2,
            1,
            56
        ],
        [
            2,
            1,
            56
        ]
    ],
    2026: [
        [
            2,
            19,
            57
        ],
        [
            3,
            18,
            57
        ],
        [
            4,
            17,
            57
        ],
        [
            5,
            16,
            57
        ],
        [
            6,
            15,
            57
        ],
        [
            7,
            14,
            57
        ],
        [
            8,
            12,
            58
        ],
        [
            9,
            12,
            58
        ],
        [
            10,
            11,
            58
        ],
        [
            11,
            11,
            58
        ],
        [
            0,
            19,
            57
        ],
        [
            1,
            18,
            57
        ],
        [
            1,
            18,
            57
        ]
    ],
    2027: [
        [
            3,
            8,
            58
        ],
        [
            4,
            8,
            58
        ],
        [
            5,
            6,
            58
        ],
        [
            6,
            6,
            58
        ],
        [
            7,
            4,
            58
        ],
        [
            8,
            3,
            58
        ],
        [
            9,
            2,
            59
        ],
        [
            10,
            1,
            59
        ],
        [
            11,
            1,
            59
        ],
        [
            11,
            31,
            59
        ],
        [
            0,
            9,
            58
        ],
        [
            1,
            8,
            58
        ],
        [
            2,
            10,
            58
        ]
    ],
    2028: [
        [
            2,
            28,
            59
        ],
        [
            3,
            27,
            59
        ],
        [
            4,
            26,
            59
        ],
        [
            5,
            25,
            59
        ],
        [
            6,
            24,
            59
        ],
        [
            7,
            23,
            59
        ],
        [
            8,
            21,
            60
        ],
        [
            9,
            21,
            60
        ],
        [
            10,
            19,
            60
        ],
        [
            11,
            19,
            60
        ],
        [
            0,
            29,
            59
        ],
        [
            1,
            28,
            59
        ],
        [
            1,
            28,
            59
        ]
    ],
    2029: [
        [
            2,
            17,
            60
        ],
        [
            3,
            16,
            60
        ],
        [
            4,
            15,
            60
        ],
        [
            5,
            14,
            60
        ],
        [
            6,
            13,
            60
        ],
        [
            7,
            12,
            60
        ],
        [
            8,
            10,
            61
        ],
        [
            9,
            10,
            61
        ],
        [
            10,
            8,
            61
        ],
        [
            11,
            7,
            61
        ],
        [
            0,
            17,
            60
        ],
        [
            1,
            16,
            60
        ],
        [
            1,
            16,
            60
        ]
    ],
    2030: [
        [
            3,
            4,
            61
        ],
        [
            4,
            4,
            61
        ],
        [
            5,
            2,
            61
        ],
        [
            6,
            2,
            61
        ],
        [
            6,
            31,
            61
        ],
        [
            7,
            30,
            61
        ],
        [
            8,
            28,
            62
        ],
        [
            9,
            28,
            62
        ],
        [
            10,
            27,
            62
        ],
        [
            11,
            27,
            62
        ],
        [
            0,
            5,
            61
        ],
        [
            1,
            4,
            61
        ],
        [
            2,
            6,
            61
        ]
    ],
    2031: [
        [
            2,
            25,
            62
        ],
        [
            3,
            24,
            62
        ],
        [
            4,
            23,
            62
        ],
        [
            5,
            22,
            62
        ],
        [
            6,
            21,
            62
        ],
        [
            7,
            20,
            62
        ],
        [
            8,
            18,
            63
        ],
        [
            9,
            18,
            63
        ],
        [
            10,
            16,
            63
        ],
        [
            11,
            16,
            63
        ],
        [
            0,
            25,
            62
        ],
        [
            1,
            24,
            62
        ],
        [
            1,
            24,
            62
        ]
    ],
    2032: [
        [
            2,
            13,
            63
        ],
        [
            3,
            12,
            63
        ],
        [
            4,
            11,
            63
        ],
        [
            5,
            10,
            63
        ],
        [
            6,
            9,
            63
        ],
        [
            7,
            8,
            63
        ],
        [
            8,
            6,
            64
        ],
        [
            9,
            6,
            64
        ],
        [
            10,
            4,
            64
        ],
        [
            11,
            3,
            64
        ],
        [
            0,
            14,
            63
        ],
        [
            1,
            13,
            63
        ],
        [
            1,
            13,
            63
        ]
    ],
    2033: [
        [
            2,
            31,
            64
        ],
        [
            3,
            30,
            64
        ],
        [
            4,
            29,
            64
        ],
        [
            5,
            28,
            64
        ],
        [
            6,
            27,
            64
        ],
        [
            7,
            26,
            64
        ],
        [
            8,
            24,
            65
        ],
        [
            9,
            24,
            65
        ],
        [
            10,
            23,
            65
        ],
        [
            11,
            23,
            65
        ],
        [
            0,
            1,
            64
        ],
        [
            0,
            31,
            64
        ],
        [
            2,
            2,
            64
        ]
    ],
    2034: [
        [
            2,
            21,
            65
        ],
        [
            3,
            20,
            65
        ],
        [
            4,
            19,
            65
        ],
        [
            5,
            18,
            65
        ],
        [
            6,
            17,
            65
        ],
        [
            7,
            16,
            65
        ],
        [
            8,
            14,
            66
        ],
        [
            9,
            14,
            66
        ],
        [
            10,
            13,
            66
        ],
        [
            11,
            13,
            66
        ],
        [
            0,
            21,
            65
        ],
        [
            1,
            20,
            65
        ],
        [
            1,
            20,
            65
        ]
    ],
    2035: [
        [
            3,
            10,
            66
        ],
        [
            4,
            10,
            66
        ],
        [
            5,
            8,
            66
        ],
        [
            6,
            8,
            66
        ],
        [
            7,
            6,
            66
        ],
        [
            8,
            5,
            66
        ],
        [
            9,
            4,
            67
        ],
        [
            10,
            3,
            67
        ],
        [
            11,
            2,
            67
        ],
        null,
        [
            0,
            11,
            66
        ],
        [
            1,
            10,
            66
        ],
        [
            2,
            12,
            66
        ]
    ],
    2036: [
        [
            2,
            29,
            67
        ],
        [
            3,
            28,
            67
        ],
        [
            4,
            27,
            67
        ],
        [
            5,
            26,
            67
        ],
        [
            6,
            25,
            67
        ],
        [
            7,
            24,
            67
        ],
        [
            8,
            22,
            68
        ],
        [
            9,
            22,
            68
        ],
        [
            10,
            20,
            68
        ],
        [
            0,
            1,
            67,
            11,
            19,
            68
        ],
        [
            0,
            30,
            67
        ],
        [
            1,
            29,
            67
        ],
        [
            1,
            29,
            67
        ]
    ],
    2037: [
        [
            2,
            17,
            68
        ],
        [
            3,
            16,
            68
        ],
        [
            4,
            15,
            68
        ],
        [
            5,
            14,
            68
        ],
        [
            6,
            13,
            68
        ],
        [
            7,
            12,
            68
        ],
        [
            8,
            10,
            69
        ],
        [
            9,
            10,
            69
        ],
        [
            10,
            9,
            69
        ],
        [
            11,
            9,
            69
        ],
        [
            0,
            17,
            68
        ],
        [
            1,
            16,
            68
        ],
        [
            1,
            16,
            68
        ]
    ],
    2038: [
        [
            3,
            6,
            69
        ],
        [
            4,
            6,
            69
        ],
        [
            5,
            4,
            69
        ],
        [
            6,
            4,
            69
        ],
        [
            7,
            2,
            69
        ],
        [
            8,
            1,
            69
        ],
        [
            8,
            30,
            70
        ],
        [
            9,
            30,
            70
        ],
        [
            10,
            28,
            70
        ],
        [
            11,
            28,
            70
        ],
        [
            0,
            7,
            69
        ],
        [
            1,
            6,
            69
        ],
        [
            2,
            8,
            69
        ]
    ],
    2039: [
        [
            2,
            26,
            70
        ],
        [
            3,
            25,
            70
        ],
        [
            4,
            24,
            70
        ],
        [
            5,
            23,
            70
        ],
        [
            6,
            22,
            70
        ],
        [
            7,
            21,
            70
        ],
        [
            8,
            19,
            71
        ],
        [
            9,
            19,
            71
        ],
        [
            10,
            18,
            71
        ],
        [
            11,
            18,
            71
        ],
        [
            0,
            26,
            70
        ],
        [
            1,
            25,
            70
        ],
        [
            1,
            25,
            70
        ]
    ],
    2040: [
        [
            2,
            15,
            71
        ],
        [
            3,
            14,
            71
        ],
        [
            4,
            13,
            71
        ],
        [
            5,
            12,
            71
        ],
        [
            6,
            11,
            71
        ],
        [
            7,
            10,
            71
        ],
        [
            8,
            8,
            72
        ],
        [
            9,
            8,
            72
        ],
        [
            10,
            6,
            72
        ],
        [
            11,
            5,
            72
        ],
        [
            0,
            16,
            71
        ],
        [
            1,
            15,
            71
        ],
        [
            1,
            15,
            71
        ]
    ],
    2041: [
        [
            3,
            2,
            72
        ],
        [
            4,
            2,
            72
        ],
        [
            4,
            31,
            72
        ],
        [
            5,
            30,
            72
        ],
        [
            6,
            29,
            72
        ],
        [
            7,
            28,
            72
        ],
        [
            8,
            26,
            73
        ],
        [
            9,
            26,
            73
        ],
        [
            10,
            24,
            73
        ],
        [
            11,
            24,
            73
        ],
        [
            0,
            3,
            72
        ],
        [
            1,
            2,
            72
        ],
        [
            2,
            4,
            72
        ]
    ],
    2042: [
        [
            2,
            22,
            73
        ],
        [
            3,
            21,
            73
        ],
        [
            4,
            20,
            73
        ],
        [
            5,
            19,
            73
        ],
        [
            6,
            18,
            73
        ],
        [
            7,
            17,
            73
        ],
        [
            8,
            15,
            74
        ],
        [
            9,
            15,
            74
        ],
        [
            10,
            14,
            74
        ],
        [
            11,
            14,
            74
        ],
        [
            0,
            22,
            73
        ],
        [
            1,
            21,
            73
        ],
        [
            1,
            21,
            73
        ]
    ],
    2043: [
        [
            3,
            11,
            74
        ],
        [
            4,
            11,
            74
        ],
        [
            5,
            9,
            74
        ],
        [
            6,
            9,
            74
        ],
        [
            7,
            7,
            74
        ],
        [
            8,
            6,
            74
        ],
        [
            9,
            5,
            75
        ],
        [
            10,
            4,
            75
        ],
        [
            11,
            3,
            75
        ],
        null,
        [
            0,
            12,
            74
        ],
        [
            1,
            11,
            74
        ],
        [
            2,
            13,
            74
        ]
    ],
    2044: [
        [
            2,
            29,
            75
        ],
        [
            3,
            28,
            75
        ],
        [
            4,
            27,
            75
        ],
        [
            5,
            26,
            75
        ],
        [
            6,
            25,
            75
        ],
        [
            7,
            24,
            75
        ],
        [
            8,
            22,
            76
        ],
        [
            9,
            22,
            76
        ],
        [
            10,
            21,
            76
        ],
        [
            0,
            1,
            75,
            11,
            21,
            76
        ],
        [
            0,
            30,
            75
        ],
        [
            1,
            29,
            75
        ],
        [
            1,
            29,
            75
        ]
    ],
    2045: [
        [
            2,
            19,
            76
        ],
        [
            3,
            18,
            76
        ],
        [
            4,
            17,
            76
        ],
        [
            5,
            16,
            76
        ],
        [
            6,
            15,
            76
        ],
        [
            7,
            14,
            76
        ],
        [
            8,
            12,
            77
        ],
        [
            9,
            12,
            77
        ],
        [
            10,
            10,
            77
        ],
        [
            11,
            10,
            77
        ],
        [
            0,
            19,
            76
        ],
        [
            1,
            18,
            76
        ],
        [
            1,
            18,
            76
        ]
    ],
    2046: [
        [
            3,
            7,
            77
        ],
        [
            4,
            7,
            77
        ],
        [
            5,
            5,
            77
        ],
        [
            6,
            5,
            77
        ],
        [
            7,
            3,
            77
        ],
        [
            8,
            2,
            77
        ],
        [
            9,
            1,
            78
        ],
        [
            9,
            31,
            78
        ],
        [
            10,
            30,
            78
        ],
        [
            11,
            30,
            78
        ],
        [
            0,
            8,
            77
        ],
        [
            1,
            7,
            77
        ],
        [
            2,
            9,
            77
        ]
    ],
    2047: [
        [
            2,
            28,
            78
        ],
        [
            3,
            27,
            78
        ],
        [
            4,
            26,
            78
        ],
        [
            5,
            25,
            78
        ],
        [
            6,
            24,
            78
        ],
        [
            7,
            23,
            78
        ],
        [
            8,
            21,
            79
        ],
        [
            9,
            21,
            79
        ],
        [
            10,
            19,
            79
        ],
        [
            11,
            18,
            79
        ],
        [
            0,
            28,
            78
        ],
        [
            1,
            27,
            78
        ],
        [
            1,
            27,
            78
        ]
    ],
    2048: [
        [
            2,
            15,
            79
        ],
        [
            3,
            14,
            79
        ],
        [
            4,
            13,
            79
        ],
        [
            5,
            12,
            79
        ],
        [
            6,
            11,
            79
        ],
        [
            7,
            10,
            79
        ],
        [
            8,
            8,
            80
        ],
        [
            9,
            8,
            80
        ],
        [
            10,
            6,
            80
        ],
        [
            11,
            6,
            80
        ],
        [
            0,
            16,
            79
        ],
        [
            1,
            15,
            79
        ],
        [
            1,
            15,
            79
        ]
    ],
    2049: [
        [
            3,
            3,
            80
        ],
        [
            4,
            3,
            80
        ],
        [
            5,
            1,
            80
        ],
        [
            6,
            1,
            80
        ],
        [
            6,
            30,
            80
        ],
        [
            7,
            29,
            80
        ],
        [
            8,
            27,
            81
        ],
        [
            9,
            27,
            81
        ],
        [
            10,
            26,
            81
        ],
        [
            11,
            26,
            81
        ],
        [
            0,
            4,
            80
        ],
        [
            1,
            3,
            80
        ],
        [
            2,
            5,
            80
        ]
    ],
    2050: [
        [
            2,
            24,
            81
        ],
        [
            3,
            23,
            81
        ],
        [
            4,
            22,
            81
        ],
        [
            5,
            21,
            81
        ],
        [
            6,
            20,
            81
        ],
        [
            7,
            19,
            81
        ],
        [
            8,
            17,
            82
        ],
        [
            9,
            17,
            82
        ],
        [
            10,
            16,
            82
        ],
        [
            11,
            16,
            82
        ],
        [
            0,
            24,
            81
        ],
        [
            1,
            23,
            81
        ],
        [
            1,
            23,
            81
        ]
    ],
    2051: [
        [
            2,
            14,
            82
        ],
        [
            3,
            13,
            82
        ],
        [
            4,
            12,
            82
        ],
        [
            5,
            11,
            82
        ],
        [
            6,
            10,
            82
        ],
        [
            7,
            9,
            82
        ],
        [
            8,
            7,
            83
        ],
        [
            9,
            7,
            83
        ],
        [
            10,
            5,
            83
        ],
        [
            11,
            4,
            83
        ],
        [
            0,
            14,
            82
        ],
        [
            1,
            13,
            82
        ],
        [
            1,
            13,
            82
        ]
    ],
    2052: [
        [
            2,
            31,
            83
        ],
        [
            3,
            30,
            83
        ],
        [
            4,
            29,
            83
        ],
        [
            5,
            28,
            83
        ],
        [
            6,
            27,
            83
        ],
        [
            7,
            26,
            83
        ],
        [
            8,
            24,
            84
        ],
        [
            9,
            24,
            84
        ],
        [
            10,
            22,
            84
        ],
        [
            11,
            22,
            84
        ],
        [
            0,
            2,
            83
        ],
        [
            1,
            1,
            83
        ],
        [
            2,
            2,
            83
        ]
    ],
    2053: [
        [
            2,
            20,
            84
        ],
        [
            3,
            19,
            84
        ],
        [
            4,
            18,
            84
        ],
        [
            5,
            17,
            84
        ],
        [
            6,
            16,
            84
        ],
        [
            7,
            15,
            84
        ],
        [
            8,
            13,
            85
        ],
        [
            9,
            13,
            85
        ],
        [
            10,
            12,
            85
        ],
        [
            11,
            12,
            85
        ],
        [
            0,
            20,
            84
        ],
        [
            1,
            19,
            84
        ],
        [
            1,
            19,
            84
        ]
    ],
    2054: [
        [
            3,
            9,
            85
        ],
        [
            4,
            9,
            85
        ],
        [
            5,
            7,
            85
        ],
        [
            6,
            7,
            85
        ],
        [
            7,
            5,
            85
        ],
        [
            8,
            4,
            85
        ],
        [
            9,
            3,
            86
        ],
        [
            10,
            2,
            86
        ],
        [
            11,
            2,
            86
        ],
        null,
        [
            0,
            10,
            85
        ],
        [
            1,
            9,
            85
        ],
        [
            2,
            11,
            85
        ]
    ],
    2055: [
        [
            2,
            30,
            86
        ],
        [
            3,
            29,
            86
        ],
        [
            4,
            28,
            86
        ],
        [
            5,
            27,
            86
        ],
        [
            6,
            26,
            86
        ],
        [
            7,
            25,
            86
        ],
        [
            8,
            23,
            87
        ],
        [
            9,
            23,
            87
        ],
        [
            10,
            21,
            87
        ],
        [
            0,
            1,
            86,
            11,
            21,
            87
        ],
        [
            0,
            30,
            86
        ],
        [
            2,
            1,
            86
        ],
        [
            2,
            1,
            86
        ]
    ],
    2056: [
        [
            2,
            18,
            87
        ],
        [
            3,
            17,
            87
        ],
        [
            4,
            16,
            87
        ],
        [
            5,
            15,
            87
        ],
        [
            6,
            14,
            87
        ],
        [
            7,
            13,
            87
        ],
        [
            8,
            11,
            88
        ],
        [
            9,
            11,
            88
        ],
        [
            10,
            9,
            88
        ],
        [
            11,
            8,
            88
        ],
        [
            0,
            19,
            87
        ],
        [
            1,
            18,
            87
        ],
        [
            1,
            18,
            87
        ]
    ],
    2057: [
        [
            3,
            5,
            88
        ],
        [
            4,
            5,
            88
        ],
        [
            5,
            3,
            88
        ],
        [
            6,
            3,
            88
        ],
        [
            7,
            1,
            88
        ],
        [
            7,
            31,
            88
        ],
        [
            8,
            29,
            89
        ],
        [
            9,
            29,
            89
        ],
        [
            10,
            28,
            89
        ],
        [
            11,
            28,
            89
        ],
        [
            0,
            6,
            88
        ],
        [
            1,
            5,
            88
        ],
        [
            2,
            7,
            88
        ]
    ],
    2058: [
        [
            2,
            26,
            89
        ],
        [
            3,
            25,
            89
        ],
        [
            4,
            24,
            89
        ],
        [
            5,
            23,
            89
        ],
        [
            6,
            22,
            89
        ],
        [
            7,
            21,
            89
        ],
        [
            8,
            19,
            90
        ],
        [
            9,
            19,
            90
        ],
        [
            10,
            17,
            90
        ],
        [
            11,
            17,
            90
        ],
        [
            0,
            26,
            89
        ],
        [
            1,
            25,
            89
        ],
        [
            1,
            25,
            89
        ]
    ],
    2059: [
        [
            2,
            15,
            90
        ],
        [
            3,
            14,
            90
        ],
        [
            4,
            13,
            90
        ],
        [
            5,
            12,
            90
        ],
        [
            6,
            11,
            90
        ],
        [
            7,
            10,
            90
        ],
        [
            8,
            8,
            91
        ],
        [
            9,
            8,
            91
        ],
        [
            10,
            6,
            91
        ],
        [
            11,
            5,
            91
        ],
        [
            0,
            15,
            90
        ],
        [
            1,
            14,
            90
        ],
        [
            1,
            14,
            90
        ]
    ],
    2060: [
        [
            3,
            1,
            91
        ],
        [
            4,
            1,
            91
        ],
        [
            4,
            30,
            91
        ],
        [
            5,
            29,
            91
        ],
        [
            6,
            28,
            91
        ],
        [
            7,
            27,
            91
        ],
        [
            8,
            25,
            92
        ],
        [
            9,
            25,
            92
        ],
        [
            10,
            24,
            92
        ],
        [
            11,
            24,
            92
        ],
        [
            0,
            3,
            91
        ],
        [
            1,
            2,
            91
        ],
        [
            2,
            3,
            91
        ]
    ],
    2061: [
        [
            2,
            22,
            92
        ],
        [
            3,
            21,
            92
        ],
        [
            4,
            20,
            92
        ],
        [
            5,
            19,
            92
        ],
        [
            6,
            18,
            92
        ],
        [
            7,
            17,
            92
        ],
        [
            8,
            15,
            93
        ],
        [
            9,
            15,
            93
        ],
        [
            10,
            14,
            93
        ],
        [
            11,
            14,
            93
        ],
        [
            0,
            22,
            92
        ],
        [
            1,
            21,
            92
        ],
        [
            1,
            21,
            92
        ]
    ],
    2062: [
        [
            3,
            11,
            93
        ],
        [
            4,
            11,
            93
        ],
        [
            5,
            9,
            93
        ],
        [
            6,
            9,
            93
        ],
        [
            7,
            7,
            93
        ],
        [
            8,
            6,
            93
        ],
        [
            9,
            5,
            94
        ],
        [
            10,
            4,
            94
        ],
        [
            11,
            3,
            94
        ],
        null,
        [
            0,
            12,
            93
        ],
        [
            1,
            11,
            93
        ],
        [
            2,
            13,
            93
        ]
    ],
    2063: [
        [
            2,
            31,
            94
        ],
        [
            3,
            30,
            94
        ],
        [
            4,
            29,
            94
        ],
        [
            5,
            28,
            94
        ],
        [
            6,
            27,
            94
        ],
        [
            7,
            26,
            94
        ],
        [
            8,
            24,
            95
        ],
        [
            9,
            24,
            95
        ],
        [
            10,
            22,
            95
        ],
        [
            0,
            2,
            94,
            11,
            21,
            95
        ],
        [
            0,
            31,
            94
        ],
        [
            2,
            2,
            94
        ],
        [
            2,
            2,
            94
        ]
    ],
    2064: [
        [
            2,
            18,
            95
        ],
        [
            3,
            17,
            95
        ],
        [
            4,
            16,
            95
        ],
        [
            5,
            15,
            95
        ],
        [
            6,
            14,
            95
        ],
        [
            7,
            13,
            95
        ],
        [
            8,
            11,
            96
        ],
        [
            9,
            11,
            96
        ],
        [
            10,
            10,
            96
        ],
        [
            11,
            10,
            96
        ],
        [
            0,
            19,
            95
        ],
        [
            1,
            18,
            95
        ],
        [
            1,
            18,
            95
        ]
    ],
    2065: [
        [
            3,
            7,
            96
        ],
        [
            4,
            7,
            96
        ],
        [
            5,
            5,
            96
        ],
        [
            6,
            5,
            96
        ],
        [
            7,
            3,
            96
        ],
        [
            8,
            2,
            96
        ],
        [
            9,
            1,
            97
        ],
        [
            9,
            31,
            97
        ],
        [
            10,
            29,
            97
        ],
        [
            11,
            29,
            97
        ],
        [
            0,
            8,
            96
        ],
        [
            1,
            7,
            96
        ],
        [
            2,
            9,
            96
        ]
    ],
    2066: [
        [
            2,
            27,
            97
        ],
        [
            3,
            26,
            97
        ],
        [
            4,
            25,
            97
        ],
        [
            5,
            24,
            97
        ],
        [
            6,
            23,
            97
        ],
        [
            7,
            22,
            97
        ],
        [
            8,
            20,
            98
        ],
        [
            9,
            20,
            98
        ],
        [
            10,
            19,
            98
        ],
        [
            11,
            19,
            98
        ],
        [
            0,
            27,
            97
        ],
        [
            1,
            26,
            97
        ],
        [
            1,
            26,
            97
        ]
    ],
    2067: [
        [
            2,
            17,
            98
        ],
        [
            3,
            16,
            98
        ],
        [
            4,
            15,
            98
        ],
        [
            5,
            14,
            98
        ],
        [
            6,
            13,
            98
        ],
        [
            7,
            12,
            98
        ],
        [
            8,
            10,
            99
        ],
        [
            9,
            10,
            99
        ],
        [
            10,
            8,
            99
        ],
        [
            11,
            7,
            99
        ],
        [
            0,
            17,
            98
        ],
        [
            1,
            16,
            98
        ],
        [
            1,
            16,
            98
        ]
    ],
    2068: [
        [
            3,
            3,
            99
        ],
        [
            4,
            3,
            99
        ],
        [
            5,
            1,
            99
        ],
        [
            6,
            1,
            99
        ],
        [
            6,
            30,
            99
        ],
        [
            7,
            29,
            99
        ],
        [
            8,
            27,
            100
        ],
        [
            9,
            27,
            100
        ],
        [
            10,
            25,
            100
        ],
        [
            11,
            25,
            100
        ],
        [
            0,
            5,
            99
        ],
        [
            1,
            4,
            99
        ],
        [
            2,
            5,
            99
        ]
    ],
    2069: [
        [
            2,
            23,
            100
        ],
        [
            3,
            22,
            100
        ],
        [
            4,
            21,
            100
        ],
        [
            5,
            20,
            100
        ],
        [
            6,
            19,
            100
        ],
        [
            7,
            18,
            100
        ],
        [
            8,
            16,
            101
        ],
        [
            9,
            16,
            101
        ],
        [
            10,
            15,
            101
        ],
        [
            11,
            15,
            101
        ],
        [
            0,
            23,
            100
        ],
        [
            1,
            22,
            100
        ],
        [
            1,
            22,
            100
        ]
    ],
    2070: [
        [
            2,
            13,
            101
        ],
        [
            3,
            12,
            101
        ],
        [
            4,
            11,
            101
        ],
        [
            5,
            10,
            101
        ],
        [
            6,
            9,
            101
        ],
        [
            7,
            8,
            101
        ],
        [
            8,
            6,
            102
        ],
        [
            9,
            6,
            102
        ],
        [
            10,
            4,
            102
        ],
        [
            11,
            3,
            102
        ],
        [
            0,
            13,
            101
        ],
        [
            1,
            12,
            101
        ],
        [
            1,
            12,
            101
        ]
    ],
    2071: [
        [
            2,
            31,
            102
        ],
        [
            3,
            30,
            102
        ],
        [
            4,
            29,
            102
        ],
        [
            5,
            28,
            102
        ],
        [
            6,
            27,
            102
        ],
        [
            7,
            26,
            102
        ],
        [
            8,
            24,
            103
        ],
        [
            9,
            24,
            103
        ],
        [
            10,
            23,
            103
        ],
        [
            11,
            23,
            103
        ],
        [
            0,
            1,
            102
        ],
        [
            0,
            31,
            102
        ],
        [
            2,
            2,
            102
        ]
    ],
    2072: [
        [
            2,
            20,
            103
        ],
        [
            3,
            19,
            103
        ],
        [
            4,
            18,
            103
        ],
        [
            5,
            17,
            103
        ],
        [
            6,
            16,
            103
        ],
        [
            7,
            15,
            103
        ],
        [
            8,
            13,
            104
        ],
        [
            9,
            13,
            104
        ],
        [
            10,
            11,
            104
        ],
        [
            11,
            11,
            104
        ],
        [
            0,
            21,
            103
        ],
        [
            1,
            20,
            103
        ],
        [
            1,
            20,
            103
        ]
    ],
    2073: [
        [
            3,
            8,
            104
        ],
        [
            4,
            8,
            104
        ],
        [
            5,
            6,
            104
        ],
        [
            6,
            6,
            104
        ],
        [
            7,
            4,
            104
        ],
        [
            8,
            3,
            104
        ],
        [
            9,
            2,
            105
        ],
        [
            10,
            1,
            105
        ],
        [
            11,
            1,
            105
        ],
        [
            11,
            31,
            105
        ],
        [
            0,
            9,
            104
        ],
        [
            1,
            8,
            104
        ],
        [
            2,
            10,
            104
        ]
    ],
    2074: [
        [
            2,
            29,
            105
        ],
        [
            3,
            28,
            105
        ],
        [
            4,
            27,
            105
        ],
        [
            5,
            26,
            105
        ],
        [
            6,
            25,
            105
        ],
        [
            7,
            24,
            105
        ],
        [
            8,
            22,
            106
        ],
        [
            9,
            22,
            106
        ],
        [
            10,
            20,
            106
        ],
        [
            11,
            19,
            106
        ],
        [
            0,
            29,
            105
        ],
        [
            1,
            28,
            105
        ],
        [
            1,
            28,
            105
        ]
    ],
    2075: [
        [
            2,
            17,
            106
        ],
        [
            3,
            16,
            106
        ],
        [
            4,
            15,
            106
        ],
        [
            5,
            14,
            106
        ],
        [
            6,
            13,
            106
        ],
        [
            7,
            12,
            106
        ],
        [
            8,
            10,
            107
        ],
        [
            9,
            10,
            107
        ],
        [
            10,
            8,
            107
        ],
        [
            11,
            8,
            107
        ],
        [
            0,
            17,
            106
        ],
        [
            1,
            16,
            106
        ],
        [
            1,
            16,
            106
        ]
    ],
    2076: [
        [
            3,
            4,
            107
        ],
        [
            4,
            4,
            107
        ],
        [
            5,
            2,
            107
        ],
        [
            6,
            2,
            107
        ],
        [
            6,
            31,
            107
        ],
        [
            7,
            30,
            107
        ],
        [
            8,
            28,
            108
        ],
        [
            9,
            28,
            108
        ],
        [
            10,
            27,
            108
        ],
        [
            11,
            27,
            108
        ],
        [
            0,
            6,
            107
        ],
        [
            1,
            5,
            107
        ],
        [
            2,
            6,
            107
        ]
    ],
    2077: [
        [
            2,
            25,
            108
        ],
        [
            3,
            24,
            108
        ],
        [
            4,
            23,
            108
        ],
        [
            5,
            22,
            108
        ],
        [
            6,
            21,
            108
        ],
        [
            7,
            20,
            108
        ],
        [
            8,
            18,
            109
        ],
        [
            9,
            18,
            109
        ],
        [
            10,
            17,
            109
        ],
        [
            11,
            17,
            109
        ],
        [
            0,
            25,
            108
        ],
        [
            1,
            24,
            108
        ],
        [
            1,
            24,
            108
        ]
    ],
    2078: [
        [
            2,
            15,
            109
        ],
        [
            3,
            14,
            109
        ],
        [
            4,
            13,
            109
        ],
        [
            5,
            12,
            109
        ],
        [
            6,
            11,
            109
        ],
        [
            7,
            10,
            109
        ],
        [
            8,
            8,
            110
        ],
        [
            9,
            8,
            110
        ],
        [
            10,
            6,
            110
        ],
        [
            11,
            5,
            110
        ],
        [
            0,
            15,
            109
        ],
        [
            1,
            14,
            109
        ],
        [
            1,
            14,
            109
        ]
    ],
    2079: [
        [
            3,
            2,
            110
        ],
        [
            4,
            2,
            110
        ],
        [
            4,
            31,
            110
        ],
        [
            5,
            30,
            110
        ],
        [
            6,
            29,
            110
        ],
        [
            7,
            28,
            110
        ],
        [
            8,
            26,
            111
        ],
        [
            9,
            26,
            111
        ],
        [
            10,
            24,
            111
        ],
        [
            11,
            24,
            111
        ],
        [
            0,
            3,
            110
        ],
        [
            1,
            2,
            110
        ],
        [
            2,
            4,
            110
        ]
    ],
    2080: [
        [
            2,
            21,
            111
        ],
        [
            3,
            20,
            111
        ],
        [
            4,
            19,
            111
        ],
        [
            5,
            18,
            111
        ],
        [
            6,
            17,
            111
        ],
        [
            7,
            16,
            111
        ],
        [
            8,
            14,
            112
        ],
        [
            9,
            14,
            112
        ],
        [
            10,
            13,
            112
        ],
        [
            11,
            13,
            112
        ],
        [
            0,
            22,
            111
        ],
        [
            1,
            21,
            111
        ],
        [
            1,
            21,
            111
        ]
    ],
    2081: [
        [
            3,
            10,
            112
        ],
        [
            4,
            10,
            112
        ],
        [
            5,
            8,
            112
        ],
        [
            6,
            8,
            112
        ],
        [
            7,
            6,
            112
        ],
        [
            8,
            5,
            112
        ],
        [
            9,
            4,
            113
        ],
        [
            10,
            3,
            113
        ],
        [
            11,
            3,
            113
        ],
        null,
        [
            0,
            11,
            112
        ],
        [
            1,
            10,
            112
        ],
        [
            2,
            12,
            112
        ]
    ],
    2082: [
        [
            2,
            31,
            113
        ],
        [
            3,
            30,
            113
        ],
        [
            4,
            29,
            113
        ],
        [
            5,
            28,
            113
        ],
        [
            6,
            27,
            113
        ],
        [
            7,
            26,
            113
        ],
        [
            8,
            24,
            114
        ],
        [
            9,
            24,
            114
        ],
        [
            10,
            22,
            114
        ],
        [
            0,
            2,
            113,
            11,
            22,
            114
        ],
        [
            0,
            31,
            113
        ],
        [
            2,
            2,
            113
        ],
        [
            2,
            2,
            113
        ]
    ],
    2083: [
        [
            2,
            20,
            114
        ],
        [
            3,
            19,
            114
        ],
        [
            4,
            18,
            114
        ],
        [
            5,
            17,
            114
        ],
        [
            6,
            16,
            114
        ],
        [
            7,
            15,
            114
        ],
        [
            8,
            13,
            115
        ],
        [
            9,
            13,
            115
        ],
        [
            10,
            11,
            115
        ],
        [
            11,
            10,
            115
        ],
        [
            0,
            20,
            114
        ],
        [
            1,
            19,
            114
        ],
        [
            1,
            19,
            114
        ]
    ],
    2084: [
        [
            3,
            6,
            115
        ],
        [
            4,
            6,
            115
        ],
        [
            5,
            4,
            115
        ],
        [
            6,
            4,
            115
        ],
        [
            7,
            2,
            115
        ],
        [
            8,
            1,
            115
        ],
        [
            8,
            30,
            116
        ],
        [
            9,
            30,
            116
        ],
        [
            10,
            29,
            116
        ],
        [
            11,
            29,
            116
        ],
        [
            0,
            8,
            115
        ],
        [
            1,
            7,
            115
        ],
        [
            2,
            8,
            115
        ]
    ],
    2085: [
        [
            2,
            27,
            116
        ],
        [
            3,
            26,
            116
        ],
        [
            4,
            25,
            116
        ],
        [
            5,
            24,
            116
        ],
        [
            6,
            23,
            116
        ],
        [
            7,
            22,
            116
        ],
        [
            8,
            20,
            117
        ],
        [
            9,
            20,
            117
        ],
        [
            10,
            18,
            117
        ],
        [
            11,
            18,
            117
        ],
        [
            0,
            27,
            116
        ],
        [
            1,
            26,
            116
        ],
        [
            1,
            26,
            116
        ]
    ],
    2086: [
        [
            2,
            16,
            117
        ],
        [
            3,
            15,
            117
        ],
        [
            4,
            14,
            117
        ],
        [
            5,
            13,
            117
        ],
        [
            6,
            12,
            117
        ],
        [
            7,
            11,
            117
        ],
        [
            8,
            9,
            118
        ],
        [
            9,
            9,
            118
        ],
        [
            10,
            7,
            118
        ],
        [
            11,
            6,
            118
        ],
        [
            0,
            16,
            117
        ],
        [
            1,
            15,
            117
        ],
        [
            1,
            15,
            117
        ]
    ],
    2087: [
        [
            3,
            3,
            118
        ],
        [
            4,
            3,
            118
        ],
        [
            5,
            1,
            118
        ],
        [
            6,
            1,
            118
        ],
        [
            6,
            30,
            118
        ],
        [
            7,
            29,
            118
        ],
        [
            8,
            27,
            119
        ],
        [
            9,
            27,
            119
        ],
        [
            10,
            26,
            119
        ],
        [
            11,
            26,
            119
        ],
        [
            0,
            4,
            118
        ],
        [
            1,
            3,
            118
        ],
        [
            2,
            5,
            118
        ]
    ],
    2088: [
        [
            2,
            23,
            119
        ],
        [
            3,
            22,
            119
        ],
        [
            4,
            21,
            119
        ],
        [
            5,
            20,
            119
        ],
        [
            6,
            19,
            119
        ],
        [
            7,
            18,
            119
        ],
        [
            8,
            16,
            120
        ],
        [
            9,
            16,
            120
        ],
        [
            10,
            14,
            120
        ],
        [
            11,
            14,
            120
        ],
        [
            0,
            24,
            119
        ],
        [
            1,
            23,
            119
        ],
        [
            1,
            23,
            119
        ]
    ],
    2089: [
        [
            2,
            12,
            120
        ],
        [
            3,
            11,
            120
        ],
        [
            4,
            10,
            120
        ],
        [
            5,
            9,
            120
        ],
        [
            6,
            8,
            120
        ],
        [
            7,
            7,
            120
        ],
        [
            8,
            5,
            121
        ],
        [
            9,
            5,
            121
        ],
        [
            10,
            4,
            121
        ],
        [
            11,
            4,
            121
        ],
        [
            0,
            12,
            120
        ],
        [
            1,
            11,
            120
        ],
        [
            1,
            11,
            120
        ]
    ],
    2090: [
        [
            3,
            1,
            121
        ],
        [
            4,
            1,
            121
        ],
        [
            4,
            30,
            121
        ],
        [
            5,
            29,
            121
        ],
        [
            6,
            28,
            121
        ],
        [
            7,
            27,
            121
        ],
        [
            8,
            25,
            122
        ],
        [
            9,
            25,
            122
        ],
        [
            10,
            23,
            122
        ],
        [
            11,
            22,
            122
        ],
        [
            0,
            2,
            121
        ],
        [
            1,
            1,
            121
        ],
        [
            2,
            3,
            121
        ]
    ],
    2091: [
        [
            2,
            20,
            122
        ],
        [
            3,
            19,
            122
        ],
        [
            4,
            18,
            122
        ],
        [
            5,
            17,
            122
        ],
        [
            6,
            16,
            122
        ],
        [
            7,
            15,
            122
        ],
        [
            8,
            13,
            123
        ],
        [
            9,
            13,
            123
        ],
        [
            10,
            12,
            123
        ],
        [
            11,
            12,
            123
        ],
        [
            0,
            20,
            122
        ],
        [
            1,
            19,
            122
        ],
        [
            1,
            19,
            122
        ]
    ],
    2092: [
        [
            3,
            8,
            123
        ],
        [
            4,
            8,
            123
        ],
        [
            5,
            6,
            123
        ],
        [
            6,
            6,
            123
        ],
        [
            7,
            4,
            123
        ],
        [
            8,
            3,
            123
        ],
        [
            9,
            2,
            124
        ],
        [
            10,
            1,
            124
        ],
        [
            10,
            30,
            124
        ],
        [
            11,
            30,
            124
        ],
        [
            0,
            10,
            123
        ],
        [
            1,
            9,
            123
        ],
        [
            2,
            10,
            123
        ]
    ],
    2093: [
        [
            2,
            28,
            124
        ],
        [
            3,
            27,
            124
        ],
        [
            4,
            26,
            124
        ],
        [
            5,
            25,
            124
        ],
        [
            6,
            24,
            124
        ],
        [
            7,
            23,
            124
        ],
        [
            8,
            21,
            125
        ],
        [
            9,
            21,
            125
        ],
        [
            10,
            20,
            125
        ],
        [
            11,
            20,
            125
        ],
        [
            0,
            28,
            124
        ],
        [
            1,
            27,
            124
        ],
        [
            1,
            27,
            124
        ]
    ],
    2094: [
        [
            2,
            18,
            125
        ],
        [
            3,
            17,
            125
        ],
        [
            4,
            16,
            125
        ],
        [
            5,
            15,
            125
        ],
        [
            6,
            14,
            125
        ],
        [
            7,
            13,
            125
        ],
        [
            8,
            11,
            126
        ],
        [
            9,
            11,
            126
        ],
        [
            10,
            9,
            126
        ],
        [
            11,
            8,
            126
        ],
        [
            0,
            18,
            125
        ],
        [
            1,
            17,
            125
        ],
        [
            1,
            17,
            125
        ]
    ],
    2095: [
        [
            3,
            5,
            126
        ],
        [
            4,
            5,
            126
        ],
        [
            5,
            3,
            126
        ],
        [
            6,
            3,
            126
        ],
        [
            7,
            1,
            126
        ],
        [
            7,
            31,
            126
        ],
        [
            8,
            29,
            127
        ],
        [
            9,
            29,
            127
        ],
        [
            10,
            27,
            127
        ],
        [
            11,
            27,
            127
        ],
        [
            0,
            6,
            126
        ],
        [
            1,
            5,
            126
        ],
        [
            2,
            7,
            126
        ]
    ],
    2096: [
        [
            2,
            24,
            127
        ],
        [
            3,
            23,
            127
        ],
        [
            4,
            22,
            127
        ],
        [
            5,
            21,
            127
        ],
        [
            6,
            20,
            127
        ],
        [
            7,
            19,
            127
        ],
        [
            8,
            17,
            128
        ],
        [
            9,
            17,
            128
        ],
        [
            10,
            16,
            128
        ],
        [
            11,
            16,
            128
        ],
        [
            0,
            25,
            127
        ],
        [
            1,
            24,
            127
        ],
        [
            1,
            24,
            127
        ]
    ],
    2097: [
        [
            2,
            14,
            128
        ],
        [
            3,
            13,
            128
        ],
        [
            4,
            12,
            128
        ],
        [
            5,
            11,
            128
        ],
        [
            6,
            10,
            128
        ],
        [
            7,
            9,
            128
        ],
        [
            8,
            7,
            129
        ],
        [
            9,
            7,
            129
        ],
        [
            10,
            6,
            129
        ],
        [
            11,
            6,
            129
        ],
        [
            0,
            14,
            128
        ],
        [
            1,
            13,
            128
        ],
        [
            1,
            13,
            128
        ]
    ],
    2098: [
        [
            3,
            3,
            129
        ],
        [
            4,
            3,
            129
        ],
        [
            5,
            1,
            129
        ],
        [
            6,
            1,
            129
        ],
        [
            6,
            30,
            129
        ],
        [
            7,
            29,
            129
        ],
        [
            8,
            27,
            130
        ],
        [
            9,
            27,
            130
        ],
        [
            10,
            25,
            130
        ],
        [
            11,
            24,
            130
        ],
        [
            0,
            4,
            129
        ],
        [
            1,
            3,
            129
        ],
        [
            2,
            5,
            129
        ]
    ],
    2099: [
        [
            2,
            22,
            130
        ],
        [
            3,
            21,
            130
        ],
        [
            4,
            20,
            130
        ],
        [
            5,
            19,
            130
        ],
        [
            6,
            18,
            130
        ],
        [
            7,
            17,
            130
        ],
        [
            8,
            15,
            131
        ],
        [
            9,
            15,
            131
        ],
        [
            10,
            13,
            131
        ],
        [
            11,
            13,
            131
        ],
        [
            0,
            22,
            130
        ],
        [
            1,
            21,
            130
        ],
        [
            1,
            21,
            130
        ]
    ],
    2100: [
        [
            3,
            10,
            131
        ],
        [
            4,
            10,
            131
        ],
        [
            5,
            8,
            131
        ],
        [
            6,
            8,
            131
        ],
        [
            7,
            6,
            131
        ],
        [
            8,
            5,
            131
        ],
        null,
        null,
        null,
        null,
        [
            0,
            11,
            131
        ],
        [
            1,
            10,
            131
        ],
        [
            2,
            12,
            131
        ]
    ],
    months: 13,
    year: 5729
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1a37f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return Hijri;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _caldate = require("caldate");
var _caldateDefault = parcelHelpers.interopDefault(_caldate);
var _calEventMapJs = require("./CalEventMap.js");
var _calEventMapJsDefault = parcelHelpers.interopDefault(_calEventMapJs);
var _hijriCalendarJs = require("./internal/hijri-calendar.js");
var Hijri = /*#__PURE__*/ function(CalEventMap) {
    "use strict";
    (0, _inherits._)(Hijri, CalEventMap);
    function Hijri(opts) {
        (0, _classCallCheck._)(this, Hijri);
        var _this;
        _this = (0, _callSuper._)(this, Hijri, [
            opts
        ]);
        _this.calendar = (0, _hijriCalendarJs.calendar);
        return _this;
    }
    (0, _createClass._)(Hijri, [
        {
            key: "get",
            value: function get(timezone) {
                var _this = this;
                var arr = this.dates.map(function(date) {
                    var cdate = new (0, _caldateDefault.default)(date);
                    var o = {
                        date: cdate.toString() + ' -0600',
                        start: cdate.setOffset(-6, 'h').toTimezone(timezone),
                        end: cdate.toEndDate().toTimezone(timezone)
                    };
                    _this._addSubstitute(date, o);
                    return o;
                });
                return arr;
            }
        }
    ]);
    return Hijri;
}((0, _calEventMapJsDefault.default));

},{"@swc/helpers/_/_call_super":"5oPMc","@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","@swc/helpers/_/_inherits":"j8HRi","caldate":"he6lr","./CalEventMap.js":"ltG5M","./internal/hijri-calendar.js":"c5xff","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"c5xff":[function(require,module,exports,__globalThis) {
/*eslint-disable*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calendar", function() {
    return calendar;
});
var calendar = {
    1969: [
        [
            2,
            19,
            0
        ],
        [
            3,
            18,
            0
        ],
        [
            4,
            17,
            0
        ],
        [
            5,
            16,
            0
        ],
        [
            6,
            15,
            0
        ],
        [
            7,
            14,
            0
        ],
        [
            8,
            12,
            0
        ],
        [
            9,
            12,
            0
        ],
        [
            10,
            10,
            0
        ],
        [
            11,
            10,
            0
        ]
    ],
    1970: [
        [
            2,
            9,
            1
        ],
        [
            3,
            8,
            1
        ],
        [
            4,
            7,
            1
        ],
        [
            5,
            6,
            1
        ],
        [
            6,
            5,
            1
        ],
        [
            7,
            4,
            1
        ],
        [
            8,
            2,
            1
        ],
        [
            9,
            2,
            1
        ],
        [
            10,
            1,
            1
        ],
        [
            10,
            30,
            1
        ],
        [
            0,
            8,
            0,
            11,
            30,
            1
        ],
        [
            1,
            7,
            0
        ]
    ],
    1971: [
        [
            1,
            26,
            2
        ],
        [
            2,
            28,
            2
        ],
        [
            3,
            26,
            2
        ],
        [
            4,
            26,
            2
        ],
        [
            5,
            24,
            2
        ],
        [
            6,
            24,
            2
        ],
        [
            7,
            22,
            2
        ],
        [
            8,
            21,
            2
        ],
        [
            9,
            20,
            2
        ],
        [
            10,
            19,
            2
        ],
        [
            11,
            18,
            2
        ],
        [
            0,
            28,
            1
        ]
    ],
    1972: [
        [
            1,
            16,
            3
        ],
        [
            2,
            16,
            3
        ],
        [
            3,
            14,
            3
        ],
        [
            4,
            14,
            3
        ],
        [
            5,
            12,
            3
        ],
        [
            6,
            12,
            3
        ],
        [
            7,
            10,
            3
        ],
        [
            8,
            9,
            3
        ],
        [
            9,
            8,
            3
        ],
        [
            10,
            7,
            3
        ],
        [
            11,
            6,
            3
        ],
        [
            0,
            17,
            2
        ]
    ],
    1973: [
        [
            1,
            4,
            4
        ],
        [
            2,
            6,
            4
        ],
        [
            3,
            4,
            4
        ],
        [
            4,
            4,
            4
        ],
        [
            5,
            2,
            4
        ],
        [
            6,
            1,
            4
        ],
        [
            6,
            30,
            4
        ],
        [
            7,
            29,
            4
        ],
        [
            8,
            27,
            4
        ],
        [
            9,
            27,
            4
        ],
        [
            10,
            25,
            4
        ],
        [
            0,
            5,
            3,
            11,
            25,
            4
        ]
    ],
    1974: [
        [
            0,
            24,
            5
        ],
        [
            1,
            23,
            5
        ],
        [
            2,
            24,
            5
        ],
        [
            3,
            23,
            5
        ],
        [
            4,
            22,
            5
        ],
        [
            5,
            21,
            5
        ],
        [
            6,
            20,
            5
        ],
        [
            7,
            19,
            5
        ],
        [
            8,
            17,
            5
        ],
        [
            9,
            16,
            5
        ],
        [
            10,
            15,
            5
        ],
        [
            11,
            15,
            5
        ]
    ],
    1975: [
        [
            0,
            13,
            6
        ],
        [
            1,
            12,
            6
        ],
        [
            2,
            13,
            6
        ],
        [
            3,
            12,
            6
        ],
        [
            4,
            12,
            6
        ],
        [
            5,
            10,
            6
        ],
        [
            6,
            10,
            6
        ],
        [
            7,
            8,
            6
        ],
        [
            8,
            6,
            6
        ],
        [
            9,
            6,
            6
        ],
        [
            10,
            4,
            6
        ],
        [
            11,
            4,
            6
        ]
    ],
    1976: [
        [
            0,
            2,
            7,
            11,
            22,
            8
        ],
        [
            1,
            1,
            7
        ],
        [
            2,
            1,
            7
        ],
        [
            2,
            31,
            7
        ],
        [
            3,
            30,
            7
        ],
        [
            4,
            30,
            7
        ],
        [
            5,
            28,
            7
        ],
        [
            6,
            28,
            7
        ],
        [
            7,
            26,
            7
        ],
        [
            8,
            24,
            7
        ],
        [
            9,
            24,
            7
        ],
        [
            10,
            22,
            7
        ]
    ],
    1977: [
        [
            11,
            11,
            9
        ],
        [
            0,
            20,
            8
        ],
        [
            1,
            19,
            8
        ],
        [
            2,
            20,
            8
        ],
        [
            3,
            19,
            8
        ],
        [
            4,
            19,
            8
        ],
        [
            5,
            17,
            8
        ],
        [
            6,
            17,
            8
        ],
        [
            7,
            15,
            8
        ],
        [
            8,
            14,
            8
        ],
        [
            9,
            13,
            8
        ],
        [
            10,
            12,
            8
        ]
    ],
    1978: [
        [
            11,
            1,
            10
        ],
        [
            0,
            10,
            9,
            11,
            30,
            10
        ],
        [
            1,
            8,
            9
        ],
        [
            2,
            10,
            9
        ],
        [
            3,
            8,
            9
        ],
        [
            4,
            8,
            9
        ],
        [
            5,
            6,
            9
        ],
        [
            6,
            6,
            9
        ],
        [
            7,
            5,
            9
        ],
        [
            8,
            3,
            9
        ],
        [
            9,
            3,
            9
        ],
        [
            10,
            1,
            9
        ]
    ],
    1979: [
        [
            10,
            20,
            11
        ],
        [
            11,
            20,
            11
        ],
        [
            0,
            29,
            10
        ],
        [
            1,
            27,
            10
        ],
        [
            2,
            29,
            10
        ],
        [
            3,
            27,
            10
        ],
        [
            4,
            27,
            10
        ],
        [
            5,
            25,
            10
        ],
        [
            6,
            25,
            10
        ],
        [
            7,
            23,
            10
        ],
        [
            8,
            22,
            10
        ],
        [
            9,
            22,
            10
        ]
    ],
    1980: [
        [
            10,
            9,
            12
        ],
        [
            11,
            8,
            12
        ],
        [
            0,
            19,
            11
        ],
        [
            1,
            17,
            11
        ],
        [
            2,
            18,
            11
        ],
        [
            3,
            16,
            11
        ],
        [
            4,
            15,
            11
        ],
        [
            5,
            14,
            11
        ],
        [
            6,
            13,
            11
        ],
        [
            7,
            12,
            11
        ],
        [
            8,
            10,
            11
        ],
        [
            9,
            10,
            11
        ]
    ],
    1981: [
        [
            9,
            28,
            13
        ],
        [
            10,
            27,
            13
        ],
        [
            0,
            7,
            12,
            11,
            27,
            13
        ],
        [
            1,
            5,
            12
        ],
        [
            2,
            7,
            12
        ],
        [
            3,
            5,
            12
        ],
        [
            4,
            5,
            12
        ],
        [
            5,
            3,
            12
        ],
        [
            6,
            2,
            12
        ],
        [
            7,
            1,
            12
        ],
        [
            7,
            30,
            12
        ],
        [
            8,
            29,
            12
        ]
    ],
    1982: [
        [
            9,
            18,
            14
        ],
        [
            10,
            16,
            14
        ],
        [
            11,
            16,
            14
        ],
        [
            0,
            26,
            13
        ],
        [
            1,
            24,
            13
        ],
        [
            2,
            26,
            13
        ],
        [
            3,
            24,
            13
        ],
        [
            4,
            24,
            13
        ],
        [
            5,
            22,
            13
        ],
        [
            6,
            21,
            13
        ],
        [
            7,
            20,
            13
        ],
        [
            8,
            18,
            13
        ]
    ],
    1983: [
        [
            9,
            7,
            15
        ],
        [
            10,
            5,
            15
        ],
        [
            11,
            5,
            15
        ],
        [
            0,
            15,
            14
        ],
        [
            1,
            14,
            14
        ],
        [
            2,
            15,
            14
        ],
        [
            3,
            14,
            14
        ],
        [
            4,
            13,
            14
        ],
        [
            5,
            12,
            14
        ],
        [
            6,
            11,
            14
        ],
        [
            7,
            9,
            14
        ],
        [
            8,
            8,
            14
        ]
    ],
    1984: [
        [
            8,
            26,
            16
        ],
        [
            9,
            25,
            16
        ],
        [
            10,
            23,
            16
        ],
        [
            0,
            4,
            15,
            11,
            23,
            16
        ],
        [
            1,
            2,
            15
        ],
        [
            2,
            3,
            15
        ],
        [
            3,
            2,
            15
        ],
        [
            4,
            2,
            15
        ],
        [
            4,
            31,
            15
        ],
        [
            5,
            30,
            15
        ],
        [
            6,
            29,
            15
        ],
        [
            7,
            27,
            15
        ]
    ],
    1985: [
        [
            8,
            15,
            17
        ],
        [
            9,
            15,
            17
        ],
        [
            10,
            13,
            17
        ],
        [
            11,
            13,
            17
        ],
        [
            0,
            22,
            16
        ],
        [
            1,
            20,
            16
        ],
        [
            2,
            22,
            16
        ],
        [
            3,
            21,
            16
        ],
        [
            4,
            20,
            16
        ],
        [
            5,
            19,
            16
        ],
        [
            6,
            18,
            16
        ],
        [
            7,
            17,
            16
        ]
    ],
    1986: [
        [
            8,
            5,
            18
        ],
        [
            9,
            4,
            18
        ],
        [
            10,
            3,
            18
        ],
        [
            11,
            2,
            18
        ],
        [
            0,
            11,
            17
        ],
        [
            1,
            10,
            17
        ],
        [
            2,
            11,
            17
        ],
        [
            3,
            10,
            17
        ],
        [
            4,
            9,
            17
        ],
        [
            5,
            8,
            17
        ],
        [
            6,
            8,
            17
        ],
        [
            7,
            6,
            17
        ]
    ],
    1987: [
        [
            7,
            25,
            19
        ],
        [
            8,
            24,
            19
        ],
        [
            9,
            23,
            19
        ],
        [
            10,
            22,
            19
        ],
        [
            0,
            1,
            18,
            11,
            21,
            19
        ],
        [
            0,
            30,
            18
        ],
        [
            2,
            1,
            18
        ],
        [
            2,
            30,
            18
        ],
        [
            3,
            29,
            18
        ],
        [
            4,
            28,
            18
        ],
        [
            5,
            27,
            18
        ],
        [
            6,
            26,
            18
        ]
    ],
    1988: [
        [
            7,
            13,
            20
        ],
        [
            8,
            12,
            20
        ],
        [
            9,
            11,
            20
        ],
        [
            10,
            10,
            20
        ],
        [
            11,
            10,
            20
        ],
        [
            0,
            20,
            19
        ],
        [
            1,
            18,
            19
        ],
        [
            2,
            19,
            19
        ],
        [
            3,
            17,
            19
        ],
        [
            4,
            16,
            19
        ],
        [
            5,
            15,
            19
        ],
        [
            6,
            14,
            19
        ]
    ],
    1989: [
        [
            7,
            2,
            21
        ],
        [
            8,
            1,
            21
        ],
        [
            8,
            30,
            21
        ],
        [
            9,
            30,
            21
        ],
        [
            10,
            29,
            21
        ],
        [
            0,
            8,
            20,
            11,
            29,
            21
        ],
        [
            1,
            7,
            20
        ],
        [
            2,
            8,
            20
        ],
        [
            3,
            7,
            20
        ],
        [
            4,
            6,
            20
        ],
        [
            5,
            4,
            20
        ],
        [
            6,
            4,
            20
        ]
    ],
    1990: [
        [
            6,
            23,
            22
        ],
        [
            7,
            21,
            22
        ],
        [
            8,
            20,
            22
        ],
        [
            9,
            19,
            22
        ],
        [
            10,
            18,
            22
        ],
        [
            11,
            18,
            22
        ],
        [
            0,
            27,
            21
        ],
        [
            1,
            26,
            21
        ],
        [
            2,
            27,
            21
        ],
        [
            3,
            26,
            21
        ],
        [
            4,
            25,
            21
        ],
        [
            5,
            23,
            21
        ]
    ],
    1991: [
        [
            6,
            12,
            23
        ],
        [
            7,
            11,
            23
        ],
        [
            8,
            9,
            23
        ],
        [
            9,
            8,
            23
        ],
        [
            10,
            7,
            23
        ],
        [
            11,
            7,
            23
        ],
        [
            0,
            16,
            22
        ],
        [
            1,
            15,
            22
        ],
        [
            2,
            17,
            22
        ],
        [
            3,
            15,
            22
        ],
        [
            4,
            15,
            22
        ],
        [
            5,
            13,
            22
        ]
    ],
    1992: [
        [
            6,
            1,
            24
        ],
        [
            6,
            30,
            24
        ],
        [
            7,
            29,
            24
        ],
        [
            8,
            27,
            24
        ],
        [
            9,
            26,
            24
        ],
        [
            10,
            25,
            24
        ],
        [
            0,
            5,
            23,
            11,
            25,
            24
        ],
        [
            1,
            4,
            23
        ],
        [
            2,
            5,
            23
        ],
        [
            3,
            4,
            23
        ],
        [
            4,
            3,
            23
        ],
        [
            5,
            2,
            23
        ]
    ],
    1993: [
        [
            5,
            21,
            25
        ],
        [
            6,
            20,
            25
        ],
        [
            7,
            18,
            25
        ],
        [
            8,
            17,
            25
        ],
        [
            9,
            16,
            25
        ],
        [
            10,
            14,
            25
        ],
        [
            11,
            14,
            25
        ],
        [
            0,
            23,
            24
        ],
        [
            1,
            22,
            24
        ],
        [
            2,
            24,
            24
        ],
        [
            3,
            22,
            24
        ],
        [
            4,
            22,
            24
        ]
    ],
    1994: [
        [
            5,
            10,
            26
        ],
        [
            6,
            9,
            26
        ],
        [
            7,
            8,
            26
        ],
        [
            8,
            6,
            26
        ],
        [
            9,
            6,
            26
        ],
        [
            10,
            4,
            26
        ],
        [
            11,
            3,
            26
        ],
        [
            0,
            12,
            25
        ],
        [
            1,
            11,
            25
        ],
        [
            2,
            13,
            25
        ],
        [
            3,
            12,
            25
        ],
        [
            4,
            11,
            25
        ]
    ],
    1995: [
        [
            4,
            30,
            27
        ],
        [
            5,
            29,
            27
        ],
        [
            6,
            28,
            27
        ],
        [
            7,
            27,
            27
        ],
        [
            8,
            25,
            27
        ],
        [
            9,
            25,
            27
        ],
        [
            10,
            23,
            27
        ],
        [
            0,
            2,
            26,
            11,
            23,
            27
        ],
        [
            0,
            31,
            26
        ],
        [
            2,
            2,
            26
        ],
        [
            3,
            1,
            26
        ],
        [
            3,
            30,
            26
        ]
    ],
    1996: [
        [
            4,
            18,
            28
        ],
        [
            5,
            17,
            28
        ],
        [
            6,
            16,
            28
        ],
        [
            7,
            15,
            28
        ],
        [
            8,
            13,
            28
        ],
        [
            9,
            13,
            28
        ],
        [
            10,
            12,
            28
        ],
        [
            11,
            11,
            28
        ],
        [
            0,
            21,
            27
        ],
        [
            1,
            19,
            27
        ],
        [
            2,
            20,
            27
        ],
        [
            3,
            18,
            27
        ]
    ],
    1997: [
        [
            4,
            7,
            29
        ],
        [
            5,
            6,
            29
        ],
        [
            6,
            5,
            29
        ],
        [
            7,
            4,
            29
        ],
        [
            8,
            2,
            29
        ],
        [
            9,
            2,
            29
        ],
        [
            10,
            1,
            29
        ],
        [
            11,
            1,
            29
        ],
        [
            0,
            10,
            28,
            11,
            30,
            29
        ],
        [
            1,
            8,
            28
        ],
        [
            2,
            10,
            28
        ],
        [
            3,
            8,
            28
        ]
    ],
    1998: [
        [
            3,
            27,
            30
        ],
        [
            4,
            26,
            30
        ],
        [
            5,
            25,
            30
        ],
        [
            6,
            24,
            30
        ],
        [
            7,
            23,
            30
        ],
        [
            8,
            21,
            30
        ],
        [
            9,
            21,
            30
        ],
        [
            10,
            20,
            30
        ],
        [
            11,
            19,
            30
        ],
        [
            0,
            29,
            29
        ],
        [
            1,
            27,
            29
        ],
        [
            2,
            29,
            29
        ]
    ],
    1999: [
        [
            3,
            17,
            31
        ],
        [
            4,
            16,
            31
        ],
        [
            5,
            15,
            31
        ],
        [
            6,
            14,
            31
        ],
        [
            7,
            12,
            31
        ],
        [
            8,
            11,
            31
        ],
        [
            9,
            10,
            31
        ],
        [
            10,
            9,
            31
        ],
        [
            11,
            9,
            31
        ],
        [
            0,
            18,
            30
        ],
        [
            1,
            17,
            30
        ],
        [
            2,
            18,
            30
        ]
    ],
    2000: [
        [
            3,
            6,
            32
        ],
        [
            4,
            5,
            32
        ],
        [
            5,
            3,
            32
        ],
        [
            6,
            3,
            32
        ],
        [
            7,
            1,
            32
        ],
        [
            7,
            30,
            32
        ],
        [
            8,
            28,
            32
        ],
        [
            9,
            28,
            32
        ],
        [
            10,
            27,
            32
        ],
        [
            0,
            8,
            31,
            11,
            27,
            32
        ],
        [
            1,
            7,
            31
        ],
        [
            2,
            7,
            31
        ]
    ],
    2001: [
        [
            2,
            26,
            33
        ],
        [
            3,
            25,
            33
        ],
        [
            4,
            24,
            33
        ],
        [
            5,
            22,
            33
        ],
        [
            6,
            22,
            33
        ],
        [
            7,
            20,
            33
        ],
        [
            8,
            18,
            33
        ],
        [
            9,
            17,
            33
        ],
        [
            10,
            16,
            33
        ],
        [
            11,
            16,
            33
        ],
        [
            0,
            26,
            32
        ],
        [
            1,
            24,
            32
        ]
    ],
    2002: [
        [
            2,
            15,
            34
        ],
        [
            3,
            14,
            34
        ],
        [
            4,
            13,
            34
        ],
        [
            5,
            12,
            34
        ],
        [
            6,
            11,
            34
        ],
        [
            7,
            10,
            34
        ],
        [
            8,
            8,
            34
        ],
        [
            9,
            7,
            34
        ],
        [
            10,
            6,
            34
        ],
        [
            11,
            5,
            34
        ],
        [
            0,
            15,
            33
        ],
        [
            1,
            13,
            33
        ]
    ],
    2003: [
        [
            2,
            4,
            35
        ],
        [
            3,
            3,
            35
        ],
        [
            4,
            2,
            35
        ],
        [
            5,
            1,
            35
        ],
        [
            6,
            1,
            35
        ],
        [
            6,
            30,
            35
        ],
        [
            7,
            29,
            35
        ],
        [
            8,
            27,
            35
        ],
        [
            9,
            26,
            35
        ],
        [
            10,
            25,
            35
        ],
        [
            0,
            4,
            34,
            11,
            24,
            35
        ],
        [
            1,
            2,
            34
        ]
    ],
    2004: [
        [
            1,
            21,
            36
        ],
        [
            2,
            22,
            36
        ],
        [
            3,
            20,
            36
        ],
        [
            4,
            20,
            36
        ],
        [
            5,
            19,
            36
        ],
        [
            6,
            18,
            36
        ],
        [
            7,
            17,
            36
        ],
        [
            8,
            15,
            36
        ],
        [
            9,
            15,
            36
        ],
        [
            10,
            14,
            36
        ],
        [
            11,
            13,
            36
        ],
        [
            0,
            23,
            35
        ]
    ],
    2005: [
        [
            1,
            10,
            37
        ],
        [
            2,
            11,
            37
        ],
        [
            3,
            10,
            37
        ],
        [
            4,
            9,
            37
        ],
        [
            5,
            8,
            37
        ],
        [
            6,
            7,
            37
        ],
        [
            7,
            6,
            37
        ],
        [
            8,
            5,
            37
        ],
        [
            9,
            4,
            37
        ],
        [
            10,
            3,
            37
        ],
        [
            11,
            3,
            37
        ],
        [
            0,
            12,
            36
        ]
    ],
    2006: [
        [
            0,
            31,
            38
        ],
        [
            2,
            1,
            38
        ],
        [
            2,
            30,
            38
        ],
        [
            3,
            29,
            38
        ],
        [
            4,
            28,
            38
        ],
        [
            5,
            26,
            38
        ],
        [
            6,
            26,
            38
        ],
        [
            7,
            25,
            38
        ],
        [
            8,
            24,
            38
        ],
        [
            9,
            23,
            38
        ],
        [
            10,
            22,
            38
        ],
        [
            0,
            1,
            37,
            11,
            22,
            38
        ]
    ],
    2007: [
        [
            0,
            20,
            39
        ],
        [
            1,
            19,
            39
        ],
        [
            2,
            20,
            39
        ],
        [
            3,
            18,
            39
        ],
        [
            4,
            18,
            39
        ],
        [
            5,
            16,
            39
        ],
        [
            6,
            15,
            39
        ],
        [
            7,
            14,
            39
        ],
        [
            8,
            13,
            39
        ],
        [
            9,
            13,
            39
        ],
        [
            10,
            11,
            39
        ],
        [
            11,
            11,
            39
        ]
    ],
    2008: [
        [
            0,
            10,
            40,
            11,
            29,
            41
        ],
        [
            1,
            8,
            40
        ],
        [
            2,
            9,
            40
        ],
        [
            3,
            7,
            40
        ],
        [
            4,
            6,
            40
        ],
        [
            5,
            5,
            40
        ],
        [
            6,
            4,
            40
        ],
        [
            7,
            2,
            40
        ],
        [
            8,
            1,
            40
        ],
        [
            9,
            1,
            40
        ],
        [
            9,
            30,
            40
        ],
        [
            10,
            29,
            40
        ]
    ],
    2009: [
        [
            11,
            18,
            42
        ],
        [
            0,
            27,
            41
        ],
        [
            1,
            26,
            41
        ],
        [
            2,
            28,
            41
        ],
        [
            3,
            26,
            41
        ],
        [
            4,
            25,
            41
        ],
        [
            5,
            24,
            41
        ],
        [
            6,
            23,
            41
        ],
        [
            7,
            22,
            41
        ],
        [
            8,
            20,
            41
        ],
        [
            9,
            20,
            41
        ],
        [
            10,
            18,
            41
        ]
    ],
    2010: [
        [
            11,
            7,
            43
        ],
        [
            0,
            16,
            42
        ],
        [
            1,
            15,
            42
        ],
        [
            2,
            17,
            42
        ],
        [
            3,
            15,
            42
        ],
        [
            4,
            15,
            42
        ],
        [
            5,
            13,
            42
        ],
        [
            6,
            13,
            42
        ],
        [
            7,
            11,
            42
        ],
        [
            8,
            10,
            42
        ],
        [
            9,
            9,
            42
        ],
        [
            10,
            7,
            42
        ]
    ],
    2011: [
        [
            10,
            26,
            44
        ],
        [
            0,
            5,
            43,
            11,
            26,
            44
        ],
        [
            1,
            4,
            43
        ],
        [
            2,
            6,
            43
        ],
        [
            3,
            5,
            43
        ],
        [
            4,
            4,
            43
        ],
        [
            5,
            3,
            43
        ],
        [
            6,
            2,
            43
        ],
        [
            7,
            1,
            43
        ],
        [
            7,
            30,
            43
        ],
        [
            8,
            29,
            43
        ],
        [
            9,
            28,
            43
        ]
    ],
    2012: [
        [
            10,
            15,
            45
        ],
        [
            11,
            14,
            45
        ],
        [
            0,
            24,
            44
        ],
        [
            1,
            23,
            44
        ],
        [
            2,
            24,
            44
        ],
        [
            3,
            22,
            44
        ],
        [
            4,
            22,
            44
        ],
        [
            5,
            21,
            44
        ],
        [
            6,
            20,
            44
        ],
        [
            7,
            19,
            44
        ],
        [
            8,
            17,
            44
        ],
        [
            9,
            17,
            44
        ]
    ],
    2013: [
        [
            10,
            4,
            46
        ],
        [
            11,
            4,
            46
        ],
        [
            0,
            13,
            45
        ],
        [
            1,
            11,
            45
        ],
        [
            2,
            13,
            45
        ],
        [
            3,
            11,
            45
        ],
        [
            4,
            11,
            45
        ],
        [
            5,
            10,
            45
        ],
        [
            6,
            9,
            45
        ],
        [
            7,
            8,
            45
        ],
        [
            8,
            7,
            45
        ],
        [
            9,
            6,
            45
        ]
    ],
    2014: [
        [
            9,
            25,
            47
        ],
        [
            10,
            23,
            47
        ],
        [
            0,
            2,
            46,
            11,
            23,
            47
        ],
        [
            1,
            1,
            46
        ],
        [
            2,
            2,
            46
        ],
        [
            3,
            1,
            46
        ],
        [
            3,
            30,
            46
        ],
        [
            4,
            30,
            46
        ],
        [
            5,
            28,
            46
        ],
        [
            6,
            28,
            46
        ],
        [
            7,
            27,
            46
        ],
        [
            8,
            25,
            46
        ]
    ],
    2015: [
        [
            9,
            14,
            48
        ],
        [
            10,
            13,
            48
        ],
        [
            11,
            12,
            48
        ],
        [
            0,
            21,
            47
        ],
        [
            1,
            20,
            47
        ],
        [
            2,
            21,
            47
        ],
        [
            3,
            20,
            47
        ],
        [
            4,
            19,
            47
        ],
        [
            5,
            18,
            47
        ],
        [
            6,
            17,
            47
        ],
        [
            7,
            16,
            47
        ],
        [
            8,
            14,
            47
        ]
    ],
    2016: [
        [
            9,
            2,
            49
        ],
        [
            10,
            1,
            49
        ],
        [
            10,
            30,
            49
        ],
        [
            0,
            11,
            48,
            11,
            30,
            49
        ],
        [
            1,
            10,
            48
        ],
        [
            2,
            10,
            48
        ],
        [
            3,
            8,
            48
        ],
        [
            4,
            8,
            48
        ],
        [
            5,
            6,
            48
        ],
        [
            6,
            6,
            48
        ],
        [
            7,
            4,
            48
        ],
        [
            8,
            2,
            48
        ]
    ],
    2017: [
        [
            8,
            21,
            50
        ],
        [
            9,
            21,
            50
        ],
        [
            10,
            19,
            50
        ],
        [
            11,
            19,
            50
        ],
        [
            0,
            29,
            49
        ],
        [
            1,
            28,
            49
        ],
        [
            2,
            29,
            49
        ],
        [
            3,
            27,
            49
        ],
        [
            4,
            27,
            49
        ],
        [
            5,
            25,
            49
        ],
        [
            6,
            24,
            49
        ],
        [
            7,
            23,
            49
        ]
    ],
    2018: [
        [
            8,
            11,
            51
        ],
        [
            9,
            10,
            51
        ],
        [
            10,
            9,
            51
        ],
        [
            11,
            8,
            51
        ],
        [
            0,
            18,
            50
        ],
        [
            1,
            17,
            50
        ],
        [
            2,
            18,
            50
        ],
        [
            3,
            17,
            50
        ],
        [
            4,
            16,
            50
        ],
        [
            5,
            15,
            50
        ],
        [
            6,
            14,
            50
        ],
        [
            7,
            12,
            50
        ]
    ],
    2019: [
        [
            7,
            31,
            52
        ],
        [
            8,
            30,
            52
        ],
        [
            9,
            29,
            52
        ],
        [
            10,
            28,
            52
        ],
        [
            0,
            7,
            51,
            11,
            27,
            52
        ],
        [
            1,
            6,
            51
        ],
        [
            2,
            8,
            51
        ],
        [
            3,
            6,
            51
        ],
        [
            4,
            6,
            51
        ],
        [
            5,
            4,
            51
        ],
        [
            6,
            4,
            51
        ],
        [
            7,
            2,
            51
        ]
    ],
    2020: [
        [
            7,
            20,
            53
        ],
        [
            8,
            18,
            53
        ],
        [
            9,
            18,
            53
        ],
        [
            10,
            16,
            53
        ],
        [
            11,
            16,
            53
        ],
        [
            0,
            26,
            52
        ],
        [
            1,
            25,
            52
        ],
        [
            2,
            25,
            52
        ],
        [
            3,
            24,
            52
        ],
        [
            4,
            24,
            52
        ],
        [
            5,
            22,
            52
        ],
        [
            6,
            22,
            52
        ]
    ],
    2021: [
        [
            7,
            9,
            54
        ],
        [
            8,
            8,
            54
        ],
        [
            9,
            7,
            54
        ],
        [
            10,
            6,
            54
        ],
        [
            11,
            5,
            54
        ],
        [
            0,
            14,
            53
        ],
        [
            1,
            13,
            53
        ],
        [
            2,
            14,
            53
        ],
        [
            3,
            13,
            53
        ],
        [
            4,
            13,
            53
        ],
        [
            5,
            11,
            53
        ],
        [
            6,
            11,
            53
        ]
    ],
    2022: [
        [
            6,
            30,
            55
        ],
        [
            7,
            28,
            55
        ],
        [
            8,
            27,
            55
        ],
        [
            9,
            26,
            55
        ],
        [
            10,
            25,
            55
        ],
        [
            0,
            4,
            54,
            11,
            25,
            55
        ],
        [
            1,
            2,
            54
        ],
        [
            2,
            4,
            54
        ],
        [
            3,
            2,
            54
        ],
        [
            4,
            2,
            54
        ],
        [
            4,
            31,
            54
        ],
        [
            5,
            30,
            54
        ]
    ],
    2023: [
        [
            6,
            19,
            56
        ],
        [
            7,
            17,
            56
        ],
        [
            8,
            16,
            56
        ],
        [
            9,
            16,
            56
        ],
        [
            10,
            15,
            56
        ],
        [
            11,
            14,
            56
        ],
        [
            0,
            23,
            55
        ],
        [
            1,
            21,
            55
        ],
        [
            2,
            23,
            55
        ],
        [
            3,
            21,
            55
        ],
        [
            4,
            21,
            55
        ],
        [
            5,
            19,
            55
        ]
    ],
    2024: [
        [
            6,
            7,
            57
        ],
        [
            7,
            5,
            57
        ],
        [
            8,
            4,
            57
        ],
        [
            9,
            4,
            57
        ],
        [
            10,
            3,
            57
        ],
        [
            11,
            3,
            57
        ],
        [
            0,
            13,
            56
        ],
        [
            1,
            11,
            56
        ],
        [
            2,
            11,
            56
        ],
        [
            3,
            10,
            56
        ],
        [
            4,
            9,
            56
        ],
        [
            5,
            7,
            56
        ]
    ],
    2025: [
        [
            5,
            26,
            58
        ],
        [
            6,
            26,
            58
        ],
        [
            7,
            24,
            58
        ],
        [
            8,
            23,
            58
        ],
        [
            9,
            23,
            58
        ],
        [
            10,
            22,
            58
        ],
        [
            0,
            1,
            57,
            11,
            21,
            58
        ],
        [
            0,
            31,
            57
        ],
        [
            2,
            1,
            57
        ],
        [
            2,
            30,
            57
        ],
        [
            3,
            29,
            57
        ],
        [
            4,
            28,
            57
        ]
    ],
    2026: [
        [
            5,
            16,
            59
        ],
        [
            6,
            15,
            59
        ],
        [
            7,
            14,
            59
        ],
        [
            8,
            12,
            59
        ],
        [
            9,
            12,
            59
        ],
        [
            10,
            11,
            59
        ],
        [
            11,
            10,
            59
        ],
        [
            0,
            20,
            58
        ],
        [
            1,
            18,
            58
        ],
        [
            2,
            20,
            58
        ],
        [
            3,
            18,
            58
        ],
        [
            4,
            18,
            58
        ]
    ],
    2027: [
        [
            5,
            6,
            60
        ],
        [
            6,
            5,
            60
        ],
        [
            7,
            3,
            60
        ],
        [
            8,
            2,
            60
        ],
        [
            9,
            1,
            60
        ],
        [
            9,
            31,
            60
        ],
        [
            10,
            29,
            60
        ],
        [
            0,
            9,
            59,
            11,
            29,
            60
        ],
        [
            1,
            8,
            59
        ],
        [
            2,
            9,
            59
        ],
        [
            3,
            8,
            59
        ],
        [
            4,
            7,
            59
        ]
    ],
    2028: [
        [
            4,
            25,
            61
        ],
        [
            5,
            24,
            61
        ],
        [
            6,
            23,
            61
        ],
        [
            7,
            22,
            61
        ],
        [
            8,
            20,
            61
        ],
        [
            9,
            19,
            61
        ],
        [
            10,
            18,
            61
        ],
        [
            11,
            17,
            61
        ],
        [
            0,
            28,
            60
        ],
        [
            1,
            26,
            60
        ],
        [
            2,
            27,
            60
        ],
        [
            3,
            26,
            60
        ]
    ],
    2029: [
        [
            4,
            14,
            62
        ],
        [
            5,
            13,
            62
        ],
        [
            6,
            13,
            62
        ],
        [
            7,
            11,
            62
        ],
        [
            8,
            10,
            62
        ],
        [
            9,
            9,
            62
        ],
        [
            10,
            7,
            62
        ],
        [
            11,
            7,
            62
        ],
        [
            0,
            16,
            61
        ],
        [
            1,
            14,
            61
        ],
        [
            2,
            16,
            61
        ],
        [
            3,
            15,
            61
        ]
    ],
    2030: [
        [
            4,
            3,
            63
        ],
        [
            5,
            2,
            63
        ],
        [
            6,
            2,
            63
        ],
        [
            7,
            1,
            63
        ],
        [
            7,
            30,
            63
        ],
        [
            8,
            29,
            63
        ],
        [
            9,
            28,
            63
        ],
        [
            10,
            26,
            63
        ],
        [
            0,
            5,
            62,
            11,
            26,
            63
        ],
        [
            1,
            4,
            62
        ],
        [
            2,
            5,
            62
        ],
        [
            3,
            4,
            62
        ]
    ],
    2031: [
        [
            3,
            23,
            64
        ],
        [
            4,
            22,
            64
        ],
        [
            5,
            21,
            64
        ],
        [
            6,
            21,
            64
        ],
        [
            7,
            20,
            64
        ],
        [
            8,
            18,
            64
        ],
        [
            9,
            17,
            64
        ],
        [
            10,
            16,
            64
        ],
        [
            11,
            15,
            64
        ],
        [
            0,
            24,
            63
        ],
        [
            1,
            23,
            63
        ],
        [
            2,
            24,
            63
        ]
    ],
    2032: [
        [
            3,
            11,
            65
        ],
        [
            4,
            10,
            65
        ],
        [
            5,
            9,
            65
        ],
        [
            6,
            9,
            65
        ],
        [
            7,
            8,
            65
        ],
        [
            8,
            6,
            65
        ],
        [
            9,
            6,
            65
        ],
        [
            10,
            4,
            65
        ],
        [
            11,
            4,
            65
        ],
        [
            0,
            14,
            64
        ],
        [
            1,
            12,
            64
        ],
        [
            2,
            13,
            64
        ]
    ],
    2033: [
        [
            3,
            1,
            66
        ],
        [
            3,
            30,
            66
        ],
        [
            4,
            29,
            66
        ],
        [
            5,
            28,
            66
        ],
        [
            6,
            28,
            66
        ],
        [
            7,
            26,
            66
        ],
        [
            8,
            25,
            66
        ],
        [
            9,
            24,
            66
        ],
        [
            10,
            23,
            66
        ],
        [
            0,
            2,
            65,
            11,
            23,
            66
        ],
        [
            1,
            1,
            65
        ],
        [
            2,
            2,
            65
        ]
    ],
    2034: [
        [
            2,
            21,
            67
        ],
        [
            3,
            20,
            67
        ],
        [
            4,
            19,
            67
        ],
        [
            5,
            17,
            67
        ],
        [
            6,
            17,
            67
        ],
        [
            7,
            15,
            67
        ],
        [
            8,
            14,
            67
        ],
        [
            9,
            13,
            67
        ],
        [
            10,
            12,
            67
        ],
        [
            11,
            12,
            67
        ],
        [
            0,
            21,
            66
        ],
        [
            1,
            20,
            66
        ]
    ],
    2035: [
        [
            2,
            11,
            68
        ],
        [
            3,
            9,
            68
        ],
        [
            4,
            9,
            68
        ],
        [
            5,
            7,
            68
        ],
        [
            6,
            6,
            68
        ],
        [
            7,
            5,
            68
        ],
        [
            8,
            3,
            68
        ],
        [
            9,
            2,
            68
        ],
        [
            10,
            1,
            68
        ],
        [
            11,
            1,
            68
        ],
        [
            0,
            11,
            67,
            11,
            30,
            68
        ],
        [
            1,
            9,
            67
        ]
    ],
    2036: [
        [
            1,
            28,
            69
        ],
        [
            2,
            29,
            69
        ],
        [
            3,
            27,
            69
        ],
        [
            4,
            27,
            69
        ],
        [
            5,
            25,
            69
        ],
        [
            6,
            24,
            69
        ],
        [
            7,
            23,
            69
        ],
        [
            8,
            21,
            69
        ],
        [
            9,
            20,
            69
        ],
        [
            10,
            19,
            69
        ],
        [
            11,
            19,
            69
        ],
        [
            0,
            29,
            68
        ]
    ],
    2037: [
        [
            1,
            16,
            70
        ],
        [
            2,
            18,
            70
        ],
        [
            3,
            17,
            70
        ],
        [
            4,
            16,
            70
        ],
        [
            5,
            15,
            70
        ],
        [
            6,
            14,
            70
        ],
        [
            7,
            12,
            70
        ],
        [
            8,
            11,
            70
        ],
        [
            9,
            10,
            70
        ],
        [
            10,
            8,
            70
        ],
        [
            11,
            8,
            70
        ],
        [
            0,
            17,
            69
        ]
    ],
    2038: [
        [
            1,
            5,
            71
        ],
        [
            2,
            7,
            71
        ],
        [
            3,
            6,
            71
        ],
        [
            4,
            5,
            71
        ],
        [
            5,
            4,
            71
        ],
        [
            6,
            3,
            71
        ],
        [
            7,
            2,
            71
        ],
        [
            7,
            31,
            71
        ],
        [
            8,
            30,
            71
        ],
        [
            9,
            29,
            71
        ],
        [
            10,
            27,
            71
        ],
        [
            0,
            7,
            70,
            11,
            27,
            71
        ]
    ],
    2039: [
        [
            0,
            26,
            72
        ],
        [
            1,
            24,
            72
        ],
        [
            2,
            26,
            72
        ],
        [
            3,
            24,
            72
        ],
        [
            4,
            24,
            72
        ],
        [
            5,
            23,
            72
        ],
        [
            6,
            22,
            72
        ],
        [
            7,
            21,
            72
        ],
        [
            8,
            19,
            72
        ],
        [
            9,
            19,
            72
        ],
        [
            10,
            17,
            72
        ],
        [
            11,
            17,
            72
        ]
    ],
    2040: [
        [
            0,
            15,
            73
        ],
        [
            1,
            14,
            73
        ],
        [
            2,
            14,
            73
        ],
        [
            3,
            13,
            73
        ],
        [
            4,
            12,
            73
        ],
        [
            5,
            11,
            73
        ],
        [
            6,
            10,
            73
        ],
        [
            7,
            9,
            73
        ],
        [
            8,
            7,
            73
        ],
        [
            9,
            7,
            73
        ],
        [
            10,
            6,
            73
        ],
        [
            11,
            5,
            73
        ]
    ],
    2041: [
        [
            0,
            4,
            74,
            11,
            24,
            75
        ],
        [
            1,
            2,
            74
        ],
        [
            2,
            4,
            74
        ],
        [
            3,
            2,
            74
        ],
        [
            4,
            1,
            74
        ],
        [
            4,
            31,
            74
        ],
        [
            5,
            29,
            74
        ],
        [
            6,
            29,
            74
        ],
        [
            7,
            28,
            74
        ],
        [
            8,
            26,
            74
        ],
        [
            9,
            26,
            74
        ],
        [
            10,
            25,
            74
        ]
    ],
    2042: [
        [
            11,
            14,
            76
        ],
        [
            0,
            23,
            75
        ],
        [
            1,
            21,
            75
        ],
        [
            2,
            23,
            75
        ],
        [
            3,
            21,
            75
        ],
        [
            4,
            20,
            75
        ],
        [
            5,
            19,
            75
        ],
        [
            6,
            18,
            75
        ],
        [
            7,
            17,
            75
        ],
        [
            8,
            15,
            75
        ],
        [
            9,
            15,
            75
        ],
        [
            10,
            14,
            75
        ]
    ],
    2043: [
        [
            11,
            3,
            77
        ],
        [
            0,
            12,
            76
        ],
        [
            1,
            11,
            76
        ],
        [
            2,
            12,
            76
        ],
        [
            3,
            11,
            76
        ],
        [
            4,
            10,
            76
        ],
        [
            5,
            8,
            76
        ],
        [
            6,
            8,
            76
        ],
        [
            7,
            6,
            76
        ],
        [
            8,
            4,
            76
        ],
        [
            9,
            4,
            76
        ],
        [
            10,
            3,
            76
        ]
    ],
    2044: [
        [
            10,
            21,
            78
        ],
        [
            0,
            2,
            77,
            11,
            21,
            78
        ],
        [
            0,
            31,
            77
        ],
        [
            2,
            1,
            77
        ],
        [
            2,
            30,
            77
        ],
        [
            3,
            29,
            77
        ],
        [
            4,
            28,
            77
        ],
        [
            5,
            26,
            77
        ],
        [
            6,
            26,
            77
        ],
        [
            7,
            24,
            77
        ],
        [
            8,
            23,
            77
        ],
        [
            9,
            22,
            77
        ]
    ],
    2045: [
        [
            10,
            10,
            79
        ],
        [
            11,
            10,
            79
        ],
        [
            0,
            19,
            78
        ],
        [
            1,
            18,
            78
        ],
        [
            2,
            20,
            78
        ],
        [
            3,
            18,
            78
        ],
        [
            4,
            18,
            78
        ],
        [
            5,
            16,
            78
        ],
        [
            6,
            15,
            78
        ],
        [
            7,
            14,
            78
        ],
        [
            8,
            12,
            78
        ],
        [
            9,
            12,
            78
        ]
    ],
    2046: [
        [
            9,
            31,
            80
        ],
        [
            10,
            29,
            80
        ],
        [
            0,
            8,
            79,
            11,
            28,
            80
        ],
        [
            1,
            7,
            79
        ],
        [
            2,
            9,
            79
        ],
        [
            3,
            7,
            79
        ],
        [
            4,
            7,
            79
        ],
        [
            5,
            5,
            79
        ],
        [
            6,
            5,
            79
        ],
        [
            7,
            3,
            79
        ],
        [
            8,
            2,
            79
        ],
        [
            9,
            1,
            79
        ]
    ],
    2047: [
        [
            9,
            20,
            81
        ],
        [
            10,
            19,
            81
        ],
        [
            11,
            18,
            81
        ],
        [
            0,
            27,
            80
        ],
        [
            1,
            26,
            80
        ],
        [
            2,
            27,
            80
        ],
        [
            3,
            26,
            80
        ],
        [
            4,
            26,
            80
        ],
        [
            5,
            24,
            80
        ],
        [
            6,
            24,
            80
        ],
        [
            7,
            23,
            80
        ],
        [
            8,
            21,
            80
        ]
    ],
    2048: [
        [
            9,
            9,
            82
        ],
        [
            10,
            7,
            82
        ],
        [
            11,
            7,
            82
        ],
        [
            0,
            16,
            81
        ],
        [
            1,
            15,
            81
        ],
        [
            2,
            16,
            81
        ],
        [
            3,
            14,
            81
        ],
        [
            4,
            14,
            81
        ],
        [
            5,
            12,
            81
        ],
        [
            6,
            12,
            81
        ],
        [
            7,
            11,
            81
        ],
        [
            8,
            10,
            81
        ]
    ],
    2049: [
        [
            8,
            28,
            83
        ],
        [
            9,
            28,
            83
        ],
        [
            10,
            26,
            83
        ],
        [
            0,
            5,
            82,
            11,
            26,
            83
        ],
        [
            1,
            3,
            82
        ],
        [
            2,
            5,
            82
        ],
        [
            3,
            3,
            82
        ],
        [
            4,
            3,
            82
        ],
        [
            5,
            2,
            82
        ],
        [
            6,
            1,
            82
        ],
        [
            6,
            31,
            82
        ],
        [
            7,
            30,
            82
        ]
    ],
    2050: [
        [
            8,
            17,
            84
        ],
        [
            9,
            17,
            84
        ],
        [
            10,
            15,
            84
        ],
        [
            11,
            15,
            84
        ],
        [
            0,
            24,
            83
        ],
        [
            1,
            23,
            83
        ],
        [
            2,
            24,
            83
        ],
        [
            3,
            22,
            83
        ],
        [
            4,
            22,
            83
        ],
        [
            5,
            20,
            83
        ],
        [
            6,
            20,
            83
        ],
        [
            7,
            19,
            83
        ]
    ],
    2051: [
        [
            8,
            6,
            85
        ],
        [
            9,
            6,
            85
        ],
        [
            10,
            5,
            85
        ],
        [
            11,
            4,
            85
        ],
        [
            0,
            14,
            84
        ],
        [
            1,
            12,
            84
        ],
        [
            2,
            14,
            84
        ],
        [
            3,
            12,
            84
        ],
        [
            4,
            11,
            84
        ],
        [
            5,
            10,
            84
        ],
        [
            6,
            9,
            84
        ],
        [
            7,
            8,
            84
        ]
    ],
    2052: [
        [
            7,
            26,
            86
        ],
        [
            8,
            24,
            86
        ],
        [
            9,
            24,
            86
        ],
        [
            10,
            22,
            86
        ],
        [
            0,
            3,
            85,
            11,
            22,
            86
        ],
        [
            1,
            2,
            85
        ],
        [
            2,
            2,
            85
        ],
        [
            3,
            1,
            85
        ],
        [
            3,
            30,
            85
        ],
        [
            4,
            29,
            85
        ],
        [
            5,
            28,
            85
        ],
        [
            6,
            27,
            85
        ]
    ],
    2053: [
        [
            7,
            15,
            87
        ],
        [
            8,
            13,
            87
        ],
        [
            9,
            13,
            87
        ],
        [
            10,
            11,
            87
        ],
        [
            11,
            11,
            87
        ],
        [
            0,
            21,
            86
        ],
        [
            1,
            20,
            86
        ],
        [
            2,
            21,
            86
        ],
        [
            3,
            20,
            86
        ],
        [
            4,
            19,
            86
        ],
        [
            5,
            17,
            86
        ],
        [
            6,
            17,
            86
        ]
    ],
    2054: [
        [
            7,
            5,
            88
        ],
        [
            8,
            3,
            88
        ],
        [
            9,
            2,
            88
        ],
        [
            10,
            1,
            88
        ],
        [
            10,
            30,
            88
        ],
        [
            0,
            10,
            87,
            11,
            30,
            88
        ],
        [
            1,
            9,
            87
        ],
        [
            2,
            10,
            87
        ],
        [
            3,
            9,
            87
        ],
        [
            4,
            9,
            87
        ],
        [
            5,
            7,
            87
        ],
        [
            6,
            6,
            87
        ]
    ],
    2055: [
        [
            6,
            25,
            89
        ],
        [
            7,
            24,
            89
        ],
        [
            8,
            22,
            89
        ],
        [
            9,
            21,
            89
        ],
        [
            10,
            20,
            89
        ],
        [
            11,
            19,
            89
        ],
        [
            0,
            29,
            88
        ],
        [
            1,
            27,
            88
        ],
        [
            2,
            29,
            88
        ],
        [
            3,
            28,
            88
        ],
        [
            4,
            28,
            88
        ],
        [
            5,
            26,
            88
        ]
    ],
    2056: [
        [
            6,
            14,
            90
        ],
        [
            7,
            12,
            90
        ],
        [
            8,
            11,
            90
        ],
        [
            9,
            10,
            90
        ],
        [
            10,
            8,
            90
        ],
        [
            11,
            8,
            90
        ],
        [
            0,
            18,
            89
        ],
        [
            1,
            17,
            89
        ],
        [
            2,
            17,
            89
        ],
        [
            3,
            16,
            89
        ],
        [
            4,
            16,
            89
        ],
        [
            5,
            14,
            89
        ]
    ],
    2057: [
        [
            6,
            3,
            91
        ],
        [
            7,
            1,
            91
        ],
        [
            7,
            31,
            91
        ],
        [
            8,
            30,
            91
        ],
        [
            9,
            29,
            91
        ],
        [
            10,
            27,
            91
        ],
        [
            0,
            6,
            90,
            11,
            27,
            91
        ],
        [
            1,
            5,
            90
        ],
        [
            2,
            6,
            90
        ],
        [
            3,
            5,
            90
        ],
        [
            4,
            5,
            90
        ],
        [
            5,
            3,
            90
        ]
    ],
    2058: [
        [
            5,
            22,
            92
        ],
        [
            6,
            21,
            92
        ],
        [
            7,
            20,
            92
        ],
        [
            8,
            19,
            92
        ],
        [
            9,
            18,
            92
        ],
        [
            10,
            17,
            92
        ],
        [
            11,
            17,
            92
        ],
        [
            0,
            25,
            91
        ],
        [
            1,
            24,
            91
        ],
        [
            2,
            25,
            91
        ],
        [
            3,
            24,
            91
        ],
        [
            4,
            23,
            91
        ]
    ],
    2059: [
        [
            5,
            11,
            93
        ],
        [
            6,
            11,
            93
        ],
        [
            7,
            9,
            93
        ],
        [
            8,
            8,
            93
        ],
        [
            9,
            8,
            93
        ],
        [
            10,
            6,
            93
        ],
        [
            11,
            6,
            93
        ],
        [
            0,
            15,
            92
        ],
        [
            1,
            14,
            92
        ],
        [
            2,
            15,
            92
        ],
        [
            3,
            13,
            92
        ],
        [
            4,
            13,
            92
        ]
    ],
    2060: [
        [
            4,
            31,
            94
        ],
        [
            5,
            29,
            94
        ],
        [
            6,
            28,
            94
        ],
        [
            7,
            27,
            94
        ],
        [
            8,
            26,
            94
        ],
        [
            9,
            25,
            94
        ],
        [
            10,
            24,
            94
        ],
        [
            0,
            5,
            93,
            11,
            24,
            94
        ],
        [
            1,
            3,
            93
        ],
        [
            2,
            4,
            93
        ],
        [
            3,
            2,
            93
        ],
        [
            4,
            1,
            93
        ]
    ],
    2061: [
        [
            4,
            20,
            95
        ],
        [
            5,
            19,
            95
        ],
        [
            6,
            18,
            95
        ],
        [
            7,
            16,
            95
        ],
        [
            8,
            15,
            95
        ],
        [
            9,
            15,
            95
        ],
        [
            10,
            13,
            95
        ],
        [
            11,
            13,
            95
        ],
        [
            0,
            23,
            94
        ],
        [
            1,
            21,
            94
        ],
        [
            2,
            23,
            94
        ],
        [
            3,
            21,
            94
        ]
    ],
    2062: [
        [
            4,
            10,
            96
        ],
        [
            5,
            8,
            96
        ],
        [
            6,
            8,
            96
        ],
        [
            7,
            6,
            96
        ],
        [
            8,
            4,
            96
        ],
        [
            9,
            4,
            96
        ],
        [
            10,
            3,
            96
        ],
        [
            11,
            2,
            96
        ],
        [
            0,
            12,
            95
        ],
        [
            1,
            10,
            95
        ],
        [
            2,
            12,
            95
        ],
        [
            3,
            11,
            95
        ]
    ],
    2063: [
        [
            3,
            30,
            97
        ],
        [
            4,
            29,
            97
        ],
        [
            5,
            27,
            97
        ],
        [
            6,
            27,
            97
        ],
        [
            7,
            25,
            97
        ],
        [
            8,
            24,
            97
        ],
        [
            9,
            23,
            97
        ],
        [
            10,
            22,
            97
        ],
        [
            0,
            1,
            96,
            11,
            21,
            97
        ],
        [
            0,
            31,
            96
        ],
        [
            2,
            1,
            96
        ],
        [
            2,
            31,
            96
        ]
    ],
    2064: [
        [
            3,
            18,
            98
        ],
        [
            4,
            17,
            98
        ],
        [
            5,
            16,
            98
        ],
        [
            6,
            15,
            98
        ],
        [
            7,
            14,
            98
        ],
        [
            8,
            12,
            98
        ],
        [
            9,
            12,
            98
        ],
        [
            10,
            10,
            98
        ],
        [
            11,
            9,
            98
        ],
        [
            0,
            20,
            97
        ],
        [
            1,
            18,
            97
        ],
        [
            2,
            19,
            97
        ]
    ],
    2065: [
        [
            3,
            7,
            99
        ],
        [
            4,
            6,
            99
        ],
        [
            5,
            5,
            99
        ],
        [
            6,
            5,
            99
        ],
        [
            7,
            3,
            99
        ],
        [
            8,
            2,
            99
        ],
        [
            9,
            1,
            99
        ],
        [
            9,
            31,
            99
        ],
        [
            10,
            29,
            99
        ],
        [
            0,
            8,
            98,
            11,
            28,
            99
        ],
        [
            1,
            6,
            98
        ],
        [
            2,
            8,
            98
        ]
    ],
    2066: [
        [
            2,
            27,
            100
        ],
        [
            3,
            25,
            100
        ],
        [
            4,
            25,
            100
        ],
        [
            5,
            24,
            100
        ],
        [
            6,
            24,
            100
        ],
        [
            7,
            22,
            100
        ],
        [
            8,
            21,
            100
        ],
        [
            9,
            20,
            100
        ],
        [
            10,
            19,
            100
        ],
        [
            11,
            18,
            100
        ],
        [
            0,
            27,
            99
        ],
        [
            1,
            25,
            99
        ]
    ],
    2067: [
        [
            2,
            16,
            101
        ],
        [
            3,
            15,
            101
        ],
        [
            4,
            14,
            101
        ],
        [
            5,
            13,
            101
        ],
        [
            6,
            13,
            101
        ],
        [
            7,
            11,
            101
        ],
        [
            8,
            10,
            101
        ],
        [
            9,
            10,
            101
        ],
        [
            10,
            8,
            101
        ],
        [
            11,
            8,
            101
        ],
        [
            0,
            16,
            100
        ],
        [
            1,
            15,
            100
        ]
    ],
    2068: [
        [
            2,
            5,
            102
        ],
        [
            3,
            3,
            102
        ],
        [
            4,
            3,
            102
        ],
        [
            5,
            1,
            102
        ],
        [
            6,
            1,
            102
        ],
        [
            6,
            30,
            102
        ],
        [
            7,
            29,
            102
        ],
        [
            8,
            28,
            102
        ],
        [
            9,
            27,
            102
        ],
        [
            10,
            26,
            102
        ],
        [
            0,
            6,
            101,
            11,
            25,
            102
        ],
        [
            1,
            4,
            101
        ]
    ],
    2069: [
        [
            1,
            23,
            103
        ],
        [
            2,
            24,
            103
        ],
        [
            3,
            22,
            103
        ],
        [
            4,
            22,
            103
        ],
        [
            5,
            20,
            103
        ],
        [
            6,
            20,
            103
        ],
        [
            7,
            18,
            103
        ],
        [
            8,
            17,
            103
        ],
        [
            9,
            16,
            103
        ],
        [
            10,
            15,
            103
        ],
        [
            11,
            15,
            103
        ],
        [
            0,
            24,
            102
        ]
    ],
    2070: [
        [
            1,
            12,
            104
        ],
        [
            2,
            14,
            104
        ],
        [
            3,
            12,
            104
        ],
        [
            4,
            11,
            104
        ],
        [
            5,
            10,
            104
        ],
        [
            6,
            9,
            104
        ],
        [
            7,
            8,
            104
        ],
        [
            8,
            6,
            104
        ],
        [
            9,
            5,
            104
        ],
        [
            10,
            4,
            104
        ],
        [
            11,
            4,
            104
        ],
        [
            0,
            13,
            103
        ]
    ],
    2071: [
        [
            1,
            1,
            105
        ],
        [
            2,
            3,
            105
        ],
        [
            3,
            2,
            105
        ],
        [
            4,
            1,
            105
        ],
        [
            4,
            30,
            105
        ],
        [
            5,
            29,
            105
        ],
        [
            6,
            28,
            105
        ],
        [
            7,
            26,
            105
        ],
        [
            8,
            25,
            105
        ],
        [
            9,
            24,
            105
        ],
        [
            10,
            23,
            105
        ],
        [
            0,
            2,
            104,
            11,
            22,
            105
        ]
    ],
    2072: [
        [
            0,
            21,
            106
        ],
        [
            1,
            20,
            106
        ],
        [
            2,
            21,
            106
        ],
        [
            3,
            19,
            106
        ],
        [
            4,
            19,
            106
        ],
        [
            5,
            17,
            106
        ],
        [
            6,
            17,
            106
        ],
        [
            7,
            15,
            106
        ],
        [
            8,
            13,
            106
        ],
        [
            9,
            13,
            106
        ],
        [
            10,
            11,
            106
        ],
        [
            11,
            11,
            106
        ]
    ],
    2073: [
        [
            0,
            9,
            107,
            11,
            30,
            108
        ],
        [
            1,
            8,
            107
        ],
        [
            2,
            10,
            107
        ],
        [
            3,
            9,
            107
        ],
        [
            4,
            8,
            107
        ],
        [
            5,
            7,
            107
        ],
        [
            6,
            6,
            107
        ],
        [
            7,
            5,
            107
        ],
        [
            8,
            3,
            107
        ],
        [
            9,
            2,
            107
        ],
        [
            10,
            1,
            107
        ],
        [
            10,
            30,
            107
        ]
    ],
    2074: [
        [
            11,
            19,
            109
        ],
        [
            0,
            28,
            108
        ],
        [
            1,
            27,
            108
        ],
        [
            2,
            29,
            108
        ],
        [
            3,
            27,
            108
        ],
        [
            4,
            27,
            108
        ],
        [
            5,
            26,
            108
        ],
        [
            6,
            25,
            108
        ],
        [
            7,
            23,
            108
        ],
        [
            8,
            22,
            108
        ],
        [
            9,
            21,
            108
        ],
        [
            10,
            20,
            108
        ]
    ],
    2075: [
        [
            11,
            9,
            110
        ],
        [
            0,
            18,
            109
        ],
        [
            1,
            16,
            109
        ],
        [
            2,
            18,
            109
        ],
        [
            3,
            16,
            109
        ],
        [
            4,
            16,
            109
        ],
        [
            5,
            15,
            109
        ],
        [
            6,
            14,
            109
        ],
        [
            7,
            13,
            109
        ],
        [
            8,
            11,
            109
        ],
        [
            9,
            11,
            109
        ],
        [
            10,
            9,
            109
        ]
    ],
    2076: [
        [
            10,
            27,
            111
        ],
        [
            0,
            7,
            110,
            11,
            27,
            111
        ],
        [
            1,
            6,
            110
        ],
        [
            2,
            6,
            110
        ],
        [
            3,
            5,
            110
        ],
        [
            4,
            4,
            110
        ],
        [
            5,
            3,
            110
        ],
        [
            6,
            2,
            110
        ],
        [
            7,
            1,
            110
        ],
        [
            7,
            30,
            110
        ],
        [
            8,
            29,
            110
        ],
        [
            9,
            29,
            110
        ]
    ],
    2077: [
        null,
        null,
        [
            0,
            26,
            111
        ],
        [
            1,
            24,
            111
        ],
        [
            2,
            25,
            111
        ],
        [
            3,
            24,
            111
        ],
        [
            4,
            23,
            111
        ],
        [
            5,
            21,
            111
        ],
        [
            6,
            21,
            111
        ],
        [
            7,
            19,
            111
        ],
        [
            8,
            18,
            111
        ],
        [
            9,
            18,
            111
        ]
    ],
    year: 1389
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1Kzzt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return Jalaali;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _caldate = require("caldate");
var _caldateDefault = parcelHelpers.interopDefault(_caldate);
var _calEventJs = require("./CalEvent.js");
var _calEventJsDefault = parcelHelpers.interopDefault(_calEventJs);
var _jalaaliJs = require("jalaali-js");
var _jalaaliJsDefault = parcelHelpers.interopDefault(_jalaaliJs);
var toJalaali = (0, _jalaaliJsDefault.default).toJalaali, toGregorian = (0, _jalaaliJsDefault.default).toGregorian;
var Jalaali = /*#__PURE__*/ function(CalEvent) {
    "use strict";
    (0, _inherits._)(Jalaali, CalEvent);
    function Jalaali() {
        (0, _classCallCheck._)(this, Jalaali);
        return (0, _callSuper._)(this, Jalaali, arguments);
    }
    (0, _createClass._)(Jalaali, [
        {
            /**
   * @param {number} year gregorian year
   * @returns
   */ key: "inYear",
            value: function inYear(year) {
                var nowruz = toJalaali(year, 1, 1);
                if (this.opts.year && nowruz.jy !== this.opts.year) return this;
                var _toGregorian = toGregorian(this.opts.year || nowruz.jy, this.opts.month, this.opts.day), gy = _toGregorian.gy, gm = _toGregorian.gm, gd = _toGregorian.gd;
                var d = new (0, _caldateDefault.default)({
                    year: gy,
                    month: gm,
                    day: gd
                }).setOffset(this.offset);
                this.dates.push(d);
                return this;
            }
        }
    ]);
    return Jalaali;
}((0, _calEventJsDefault.default));

},{"@swc/helpers/_/_call_super":"5oPMc","@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","@swc/helpers/_/_inherits":"j8HRi","caldate":"he6lr","./CalEvent.js":"jJ8pL","jalaali-js":"6uOTT","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6uOTT":[function(require,module,exports,__globalThis) {
/*
  Expose functions.
*/ module.exports = {
    toJalaali: toJalaali,
    toGregorian: toGregorian,
    isValidJalaaliDate: isValidJalaaliDate,
    isLeapJalaaliYear: isLeapJalaaliYear,
    jalaaliMonthLength: jalaaliMonthLength,
    jalCal: jalCal,
    j2d: j2d,
    d2j: d2j,
    g2d: g2d,
    d2g: d2g,
    jalaaliToDateObject: jalaaliToDateObject,
    jalaaliWeek: jalaaliWeek
};
/*
  Jalaali years starting the 33-year rule.
*/ var breaks = [
    -61,
    9,
    38,
    199,
    426,
    686,
    756,
    818,
    1111,
    1181,
    1210,
    1635,
    2060,
    2097,
    2192,
    2262,
    2324,
    2394,
    2456,
    3178
];
/*
  Converts a Gregorian date to Jalaali.
*/ function toJalaali(gy, gm, gd) {
    if (Object.prototype.toString.call(gy) === '[object Date]') {
        gd = gy.getDate();
        gm = gy.getMonth() + 1;
        gy = gy.getFullYear();
    }
    return d2j(g2d(gy, gm, gd));
}
/*
  Converts a Jalaali date to Gregorian.
*/ function toGregorian(jy, jm, jd) {
    return d2g(j2d(jy, jm, jd));
}
/*
  Checks whether a Jalaali date is valid or not.
*/ function isValidJalaaliDate(jy, jm, jd) {
    return jy >= -61 && jy <= 3177 && jm >= 1 && jm <= 12 && jd >= 1 && jd <= jalaaliMonthLength(jy, jm);
}
/*
  Is this a leap year or not?
*/ function isLeapJalaaliYear(jy) {
    return jalCalLeap(jy) === 0;
}
/*
  Number of days in a given month in a Jalaali year.
*/ function jalaaliMonthLength(jy, jm) {
    if (jm <= 6) return 31;
    if (jm <= 11) return 30;
    if (isLeapJalaaliYear(jy)) return 30;
    return 29;
}
/*
    This function determines if the Jalaali (Persian) year is
    leap (366-day long) or is the common year (365 days)

    @param jy Jalaali calendar year (-61 to 3177)
    @returns number of years since the last leap year (0 to 4)
 */ function jalCalLeap(jy) {
    var bl = breaks.length, jp = breaks[0], jm, jump, leap, n, i;
    if (jy < jp || jy >= breaks[bl - 1]) throw new Error('Invalid Jalaali year ' + jy);
    for(i = 1; i < bl; i += 1){
        jm = breaks[i];
        jump = jm - jp;
        if (jy < jm) break;
        jp = jm;
    }
    n = jy - jp;
    if (jump - n < 6) n = n - jump + div(jump + 4, 33) * 33;
    leap = mod(mod(n + 1, 33) - 1, 4);
    if (leap === -1) leap = 4;
    return leap;
}
/*
  This function determines if the Jalaali (Persian) year is
  leap (366-day long) or is the common year (365 days), and
  finds the day in March (Gregorian calendar) of the first
  day of the Jalaali year (jy).

  @param jy Jalaali calendar year (-61 to 3177)
  @param withoutLeap when don't need leap (true or false) default is false
  @return
    leap: number of years since the last leap year (0 to 4)
    gy: Gregorian year of the beginning of Jalaali year
    march: the March day of Farvardin the 1st (1st day of jy)
  @see: http://www.astro.uni.torun.pl/~kb/Papers/EMP/PersianC-EMP.htm
  @see: http://www.fourmilab.ch/documents/calendar/
*/ function jalCal(jy, withoutLeap) {
    var bl = breaks.length, gy = jy + 621, leapJ = -14, jp = breaks[0], jm, jump, leap, leapG, march, n, i;
    if (jy < jp || jy >= breaks[bl - 1]) throw new Error('Invalid Jalaali year ' + jy);
    // Find the limiting years for the Jalaali year jy.
    for(i = 1; i < bl; i += 1){
        jm = breaks[i];
        jump = jm - jp;
        if (jy < jm) break;
        leapJ = leapJ + div(jump, 33) * 8 + div(mod(jump, 33), 4);
        jp = jm;
    }
    n = jy - jp;
    // Find the number of leap years from AD 621 to the beginning
    // of the current Jalaali year in the Persian calendar.
    leapJ = leapJ + div(n, 33) * 8 + div(mod(n, 33) + 3, 4);
    if (mod(jump, 33) === 4 && jump - n === 4) leapJ += 1;
    // And the same in the Gregorian calendar (until the year gy).
    leapG = div(gy, 4) - div((div(gy, 100) + 1) * 3, 4) - 150;
    // Determine the Gregorian date of Farvardin the 1st.
    march = 20 + leapJ - leapG;
    // return with gy and march when we don't need leap
    if (withoutLeap) return {
        gy: gy,
        march: march
    };
    // Find how many years have passed since the last leap year.
    if (jump - n < 6) n = n - jump + div(jump + 4, 33) * 33;
    leap = mod(mod(n + 1, 33) - 1, 4);
    if (leap === -1) leap = 4;
    return {
        leap: leap,
        gy: gy,
        march: march
    };
}
/*
  Converts a date of the Jalaali calendar to the Julian Day number.

  @param jy Jalaali year (1 to 3100)
  @param jm Jalaali month (1 to 12)
  @param jd Jalaali day (1 to 29/31)
  @return Julian Day number
*/ function j2d(jy, jm, jd) {
    var r = jalCal(jy, true);
    return g2d(r.gy, 3, r.march) + (jm - 1) * 31 - div(jm, 7) * (jm - 7) + jd - 1;
}
/*
  Converts the Julian Day number to a date in the Jalaali calendar.

  @param jdn Julian Day number
  @return
    jy: Jalaali year (1 to 3100)
    jm: Jalaali month (1 to 12)
    jd: Jalaali day (1 to 29/31)
*/ function d2j(jdn) {
    var gy = d2g(jdn).gy // Calculate Gregorian year (gy).
    , jy = gy - 621, r = jalCal(jy, false), jdn1f = g2d(gy, 3, r.march), jd, jm, k;
    // Find number of days that passed since 1 Farvardin.
    k = jdn - jdn1f;
    if (k >= 0) {
        if (k <= 185) {
            // The first 6 months.
            jm = 1 + div(k, 31);
            jd = mod(k, 31) + 1;
            return {
                jy: jy,
                jm: jm,
                jd: jd
            };
        } else // The remaining months.
        k -= 186;
    } else {
        // Previous Jalaali year.
        jy -= 1;
        k += 179;
        if (r.leap === 1) k += 1;
    }
    jm = 7 + div(k, 30);
    jd = mod(k, 30) + 1;
    return {
        jy: jy,
        jm: jm,
        jd: jd
    };
}
/*
  Calculates the Julian Day number from Gregorian or Julian
  calendar dates. This integer number corresponds to the noon of
  the date (i.e. 12 hours of Universal Time).
  The procedure was tested to be good since 1 March, -100100 (of both
  calendars) up to a few million years into the future.

  @param gy Calendar year (years BC numbered 0, -1, -2, ...)
  @param gm Calendar month (1 to 12)
  @param gd Calendar day of the month (1 to 28/29/30/31)
  @return Julian Day number
*/ function g2d(gy, gm, gd) {
    var d = div((gy + div(gm - 8, 6) + 100100) * 1461, 4) + div(153 * mod(gm + 9, 12) + 2, 5) + gd - 34840408;
    d = d - div(div(gy + 100100 + div(gm - 8, 6), 100) * 3, 4) + 752;
    return d;
}
/*
  Calculates Gregorian and Julian calendar dates from the Julian Day number
  (jdn) for the period since jdn=-34839655 (i.e. the year -100100 of both
  calendars) to some millions years ahead of the present.

  @param jdn Julian Day number
  @return
    gy: Calendar year (years BC numbered 0, -1, -2, ...)
    gm: Calendar month (1 to 12)
    gd: Calendar day of the month M (1 to 28/29/30/31)
*/ function d2g(jdn) {
    var j, i, gd, gm, gy;
    j = 4 * jdn + 139361631;
    j = j + div(div(4 * jdn + 183187720, 146097) * 3, 4) * 4 - 3908;
    i = div(mod(j, 1461), 4) * 5 + 308;
    gd = div(mod(i, 153), 5) + 1;
    gm = mod(div(i, 153), 12) + 1;
    gy = div(j, 1461) - 100100 + div(8 - gm, 6);
    return {
        gy: gy,
        gm: gm,
        gd: gd
    };
}
/**
 * Return Saturday and Friday day of current week(week start in Saturday)
 * @param {number} jy jalaali year
 * @param {number} jm jalaali month
 * @param {number} jd jalaali day
 * @returns Saturday and Friday of current week
 */ function jalaaliWeek(jy, jm, jd) {
    var dayOfWeek = jalaaliToDateObject(jy, jm, jd).getDay();
    var startDayDifference = dayOfWeek == 6 ? 0 : -(dayOfWeek + 1);
    var endDayDifference = 6 + startDayDifference;
    return {
        saturday: d2j(j2d(jy, jm, jd + startDayDifference)),
        friday: d2j(j2d(jy, jm, jd + endDayDifference))
    };
}
/**
 * Convert Jalaali calendar dates to javascript Date object
 * @param {number} jy jalaali year
 * @param {number} jm jalaali month
 * @param {number} jd jalaali day
 * @param {number} [h] hours
 * @param {number} [m] minutes
 * @param {number} [s] seconds
 * @param {number} [ms] milliseconds
 * @returns Date object of the jalaali calendar dates
 */ function jalaaliToDateObject(jy, jm, jd, h, m, s, ms) {
    var gregorianCalenderDate = toGregorian(jy, jm, jd);
    return new Date(gregorianCalenderDate.gy, gregorianCalenderDate.gm - 1, gregorianCalenderDate.gd, h || 0, m || 0, s || 0, ms || 0);
}
/*
  Utility helper functions.
*/ function div(a, b) {
    return ~~(a / b);
}
function mod(a, b) {
    return a - ~~(a / b) * b;
}

},{}],"6BQ2F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return Equinox;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _astronomia = require("astronomia");
var _vsop87BearthJs = require("./vsop87Bearth.js");
var _momentTimezone = require("moment-timezone");
var _momentTimezoneDefault = parcelHelpers.interopDefault(_momentTimezone);
var _caldate = require("caldate");
var _caldateDefault = parcelHelpers.interopDefault(_caldate);
var _calEventJs = require("./CalEvent.js");
var _calEventJsDefault = parcelHelpers.interopDefault(_calEventJs);
var earth = new (0, _astronomia.planetposition).Planet((0, _vsop87BearthJs.vsop87Bearth));
var Equinox = /*#__PURE__*/ function(CalEvent) {
    "use strict";
    (0, _inherits._)(Equinox, CalEvent);
    function Equinox(opts) {
        (0, _classCallCheck._)(this, Equinox);
        var _this;
        opts = opts || {};
        _this = (0, _callSuper._)(this, Equinox, [
            opts
        ]);
        _this._season = opts.season;
        _this._timezone = opts.timezone || 'GMT';
        return _this;
    }
    (0, _createClass._)(Equinox, [
        {
            key: "inYear",
            value: function inYear(year) {
                var jde;
                switch(this._season){
                    case 'march':
                        jde = (0, _astronomia.solstice).march2(year, earth);
                        break;
                    case 'june':
                        jde = (0, _astronomia.solstice).june2(year, earth);
                        break;
                    case 'september':
                        jde = (0, _astronomia.solstice).september2(year, earth);
                        break;
                    case 'december':
                        jde = (0, _astronomia.solstice).december2(year, earth);
                        break;
                }
                var str = new (0, _astronomia.julian).Calendar().fromJDE(jde).toDate().toISOString();
                var date;
                if (/^[+-]\d{2}:\d{2}?$/.test(this._timezone)) date = (0, _momentTimezoneDefault.default)(str).utcOffset(this._timezone);
                else date = (0, _momentTimezoneDefault.default)(str).tz(this._timezone) // move to timezone
                ;
                var floorDate = {
                    year: year,
                    month: date.month() + 1,
                    day: date.date()
                };
                var d = new (0, _caldateDefault.default)(floorDate).setOffset(this.offset);
                this.dates.push(d);
                return this;
            }
        }
    ]);
    return Equinox;
}((0, _calEventJsDefault.default));

},{"@swc/helpers/_/_call_super":"5oPMc","@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","@swc/helpers/_/_inherits":"j8HRi","astronomia":"03wmo","./vsop87Bearth.js":"95Knz","moment-timezone":"6gZ5H","caldate":"he6lr","./CalEvent.js":"jJ8pL","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"95Knz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "vsop87Bearth", function() {
    return vsop87Bearth;
});
var _vsop87Bearth = require("astronomia/data/vsop87Bearth");
var _vsop87BearthDefault = parcelHelpers.interopDefault(_vsop87Bearth);
var vsop87Bearth = (0, _vsop87BearthDefault.default);

},{"astronomia/data/vsop87Bearth":"1UHob","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1UHob":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var m = {
    L: {
        "0": [
            [
                1.75347045673,
                0,
                0
            ],
            [
                0.03341656453,
                4.66925680415,
                6283.0758499914
            ],
            [
                0.00034894275,
                4.62610242189,
                12566.1516999828
            ],
            [
                0.00003417572,
                2.82886579754,
                3.523118349
            ],
            [
                0.00003497056,
                2.74411783405,
                5753.3848848968
            ],
            [
                0.00003135899,
                3.62767041756,
                77713.7714681205
            ],
            [
                0.00002676218,
                4.41808345438,
                7860.4193924392
            ],
            [
                0.00002342691,
                6.13516214446,
                3930.2096962196
            ],
            [
                0.00001273165,
                2.03709657878,
                529.6909650946
            ],
            [
                0.00001324294,
                0.74246341673,
                11506.7697697936
            ],
            [
                0.00000901854,
                2.04505446477,
                26.2983197998
            ],
            [
                0.00001199167,
                1.10962946234,
                1577.3435424478
            ],
            [
                0.00000857223,
                3.50849152283,
                398.1490034082
            ],
            [
                0.00000779786,
                1.17882681962,
                5223.6939198022
            ],
            [
                0.0000099025,
                5.23268072088,
                5884.9268465832
            ],
            [
                0.00000753141,
                2.53339052847,
                5507.5532386674
            ],
            [
                0.00000505267,
                4.58292599973,
                18849.2275499742
            ],
            [
                0.00000492392,
                4.20505711826,
                775.522611324
            ],
            [
                0.00000356672,
                2.91954114478,
                0.0673103028
            ],
            [
                0.00000284125,
                1.89869240932,
                796.2980068164
            ],
            [
                0.00000242879,
                0.34481445893,
                5486.777843175
            ],
            [
                0.00000317087,
                5.84901948512,
                11790.6290886588
            ],
            [
                0.00000271112,
                0.31486255375,
                10977.078804699
            ],
            [
                0.00000206217,
                4.80646631478,
                2544.3144198834
            ],
            [
                0.00000205478,
                1.86953770281,
                5573.1428014331
            ],
            [
                0.00000202318,
                2.45767790232,
                6069.7767545534
            ],
            [
                0.00000126225,
                1.08295459501,
                20.7753954924
            ],
            [
                0.00000155516,
                0.83306084617,
                213.299095438
            ],
            [
                0.00000115132,
                0.64544911683,
                0.9803210682
            ],
            [
                0.00000102851,
                0.63599845579,
                4694.0029547076
            ],
            [
                0.00000101724,
                4.2667980198,
                7.1135470008
            ],
            [
                9.9206e-7,
                6.20992926918,
                2146.1654164752
            ],
            [
                0.00000132212,
                3.41118292683,
                2942.4634232916
            ],
            [
                9.7607e-7,
                0.68101342359,
                155.4203994342
            ],
            [
                8.5128e-7,
                1.29870764804,
                6275.9623029906
            ],
            [
                7.4651e-7,
                1.755089133,
                5088.6288397668
            ],
            [
                0.00000101895,
                0.97569280312,
                15720.8387848784
            ],
            [
                8.4711e-7,
                3.67080093031,
                71430.69561812909
            ],
            [
                7.3547e-7,
                4.67926633877,
                801.8209311238
            ],
            [
                7.3874e-7,
                3.50319414955,
                3154.6870848956
            ],
            [
                7.8757e-7,
                3.03697458703,
                12036.4607348882
            ],
            [
                7.9637e-7,
                1.80791287082,
                17260.1546546904
            ],
            [
                8.5803e-7,
                5.9832263126,
                161000.6857376741
            ],
            [
                5.6963e-7,
                2.78430458592,
                6286.5989683404
            ],
            [
                6.1148e-7,
                1.81839892984,
                7084.8967811152
            ],
            [
                6.9627e-7,
                0.83297621398,
                9437.762934887
            ],
            [
                5.6116e-7,
                4.38694865354,
                14143.4952424306
            ],
            [
                6.2449e-7,
                3.97763912806,
                8827.3902698748
            ],
            [
                5.1145e-7,
                0.28306832879,
                5856.4776591154
            ],
            [
                5.5577e-7,
                3.47006059924,
                6279.5527316424
            ],
            [
                4.1036e-7,
                5.36817592855,
                8429.2412664666
            ],
            [
                5.1605e-7,
                1.33282739866,
                1748.016413067
            ],
            [
                5.1992e-7,
                0.18914947184,
                12139.5535091068
            ],
            [
                4.9e-7,
                0.48735014197,
                1194.4470102246
            ],
            [
                3.92e-7,
                6.16833020996,
                10447.3878396044
            ],
            [
                3.557e-7,
                1.775968892,
                6812.766815086
            ],
            [
                3.677e-7,
                6.04133863162,
                10213.285546211
            ],
            [
                3.6596e-7,
                2.56957481827,
                1059.3819301892
            ],
            [
                3.3296e-7,
                0.59310278598,
                17789.845619785
            ],
            [
                3.5954e-7,
                1.70875808777,
                2352.8661537718
            ],
            [
                4.0938e-7,
                2.39850938714,
                19651.048481098
            ],
            [
                3.0047e-7,
                2.73975124088,
                1349.8674096588
            ],
            [
                3.0412e-7,
                0.44294464169,
                83996.84731811189
            ],
            [
                2.3663e-7,
                0.48473622521,
                8031.0922630584
            ],
            [
                2.3574e-7,
                2.06528133162,
                3340.6124266998
            ],
            [
                2.1089e-7,
                4.14825468851,
                951.7184062506
            ],
            [
                2.4738e-7,
                0.21484762138,
                3.5904286518
            ],
            [
                2.5352e-7,
                3.16470891653,
                4690.4798363586
            ],
            [
                2.2823e-7,
                5.22195230819,
                4705.7323075436
            ],
            [
                2.1419e-7,
                1.42563910473,
                16730.4636895958
            ],
            [
                2.1891e-7,
                5.55594302779,
                553.5694028424
            ],
            [
                1.7481e-7,
                4.56052900312,
                135.0650800354
            ],
            [
                1.9927e-7,
                5.22209149316,
                12168.0026965746
            ],
            [
                1.986e-7,
                5.77470242235,
                6309.3741697912
            ],
            [
                2.03e-7,
                0.37133792946,
                283.8593188652
            ],
            [
                1.4421e-7,
                4.19315052005,
                242.728603974
            ],
            [
                1.6225e-7,
                5.98837767951,
                11769.8536931664
            ],
            [
                1.5077e-7,
                4.1956716337,
                6256.7775301916
            ],
            [
                1.9124e-7,
                3.82219958698,
                23581.2581773176
            ],
            [
                1.8888e-7,
                5.38626892076,
                149854.4001348079
            ],
            [
                1.4346e-7,
                3.72355084422,
                38.0276726358
            ],
            [
                1.7898e-7,
                2.21490566029,
                13367.9726311066
            ],
            [
                1.2054e-7,
                2.62229602614,
                955.5997416086
            ],
            [
                1.1287e-7,
                0.17739329984,
                4164.311989613
            ],
            [
                1.3973e-7,
                4.40134615007,
                6681.2248533996
            ],
            [
                1.3621e-7,
                1.88934516495,
                7632.9432596502
            ],
            [
                1.2503e-7,
                1.13052412208,
                5.5229243074
            ],
            [
                1.0498e-7,
                5.35909979317,
                1592.5960136328
            ],
            [
                9.803e-8,
                0.99948172646,
                11371.7046897582
            ],
            [
                9.22e-8,
                4.57138585348,
                4292.3308329504
            ],
            [
                1.0327e-7,
                6.19982170609,
                6438.4962494256
            ],
            [
                1.2003e-7,
                1.00351462266,
                632.7837393132
            ],
            [
                1.0827e-7,
                0.32734523824,
                103.0927742186
            ],
            [
                8.356e-8,
                4.53902748706,
                25132.3033999656
            ],
            [
                1.0005e-7,
                6.0291496328,
                5746.271337896
            ],
            [
                8.409e-8,
                3.29946177848,
                7234.794256242
            ],
            [
                8.006e-8,
                5.82145271855,
                28.4491874678
            ],
            [
                1.0523e-7,
                0.93870455544,
                11926.2544136688
            ],
            [
                7.686e-8,
                3.1214364064,
                7238.6755916
            ],
            [
                9.378e-8,
                2.62413793196,
                5760.4984318976
            ],
            [
                8.127e-8,
                6.11227839253,
                4732.0306273434
            ],
            [
                9.232e-8,
                0.48344234496,
                522.5774180938
            ],
            [
                9.802e-8,
                5.24413877132,
                27511.4678735372
            ],
            [
                7.871e-8,
                0.99590133077,
                5643.1785636774
            ],
            [
                8.123e-8,
                6.27053020099,
                426.598190876
            ],
            [
                9.048e-8,
                5.33686323585,
                6386.16862421
            ],
            [
                8.621e-8,
                4.16537179089,
                7058.5984613154
            ],
            [
                6.297e-8,
                4.71723143652,
                6836.6452528338
            ],
            [
                7.575e-8,
                3.97381357237,
                11499.6562227928
            ],
            [
                7.756e-8,
                2.95728422442,
                23013.5395395872
            ],
            [
                7.314e-8,
                0.60652522715,
                11513.8833167944
            ],
            [
                5.955e-8,
                2.87641047954,
                6283.14316029419
            ],
            [
                6.534e-8,
                5.79046406784,
                18073.7049386502
            ],
            [
                7.188e-8,
                3.99831461988,
                74.7815985673
            ],
            [
                7.346e-8,
                4.38582423903,
                316.3918696566
            ],
            [
                5.413e-8,
                5.39199023275,
                419.4846438752
            ],
            [
                5.127e-8,
                2.36059551778,
                10973.55568635
            ],
            [
                7.056e-8,
                0.32258442532,
                263.0839233728
            ],
            [
                6.624e-8,
                3.6647416584,
                17298.1823273262
            ],
            [
                6.762e-8,
                5.91131766896,
                90955.5516944961
            ],
            [
                4.938e-8,
                5.73672172371,
                9917.6968745098
            ],
            [
                5.547e-8,
                2.45152589382,
                12352.8526045448
            ],
            [
                5.958e-8,
                3.3205134466,
                6283.0085396886
            ],
            [
                4.471e-8,
                2.06386138131,
                7079.3738568078
            ],
            [
                6.153e-8,
                1.45823347458,
                233141.3144043615
            ],
            [
                4.348e-8,
                4.42338625285,
                5216.5803728014
            ],
            [
                6.124e-8,
                1.07494838623,
                19804.8272915828
            ],
            [
                4.488e-8,
                3.65285033073,
                206.1855484372
            ],
            [
                4.02e-8,
                0.83995823171,
                20.3553193988
            ],
            [
                5.188e-8,
                4.06503864016,
                6208.2942514241
            ],
            [
                5.307e-8,
                0.38216728132,
                31441.6775697568
            ],
            [
                3.785e-8,
                2.34369213733,
                3.881335358
            ],
            [
                4.497e-8,
                3.27230792447,
                11015.1064773348
            ],
            [
                4.132e-8,
                0.92129851256,
                3738.761430108
            ],
            [
                3.521e-8,
                5.9784480361,
                3894.1818295422
            ],
            [
                4.215e-8,
                1.90601721876,
                245.8316462294
            ],
            [
                3.701e-8,
                5.03067498875,
                536.8045120954
            ],
            [
                3.866e-8,
                1.82632980909,
                11856.2186514245
            ],
            [
                3.652e-8,
                1.01840564429,
                16200.7727245012
            ],
            [
                3.39e-8,
                0.97784870142,
                8635.9420037632
            ],
            [
                3.737e-8,
                2.9537891957,
                3128.3887650958
            ],
            [
                3.507e-8,
                3.71291946317,
                6290.1893969922
            ],
            [
                3.086e-8,
                3.64646921512,
                10.6366653498
            ],
            [
                3.397e-8,
                1.10589356888,
                14712.317116458
            ],
            [
                3.334e-8,
                0.83684903082,
                6496.3749454294
            ],
            [
                2.805e-8,
                2.58503711584,
                14314.1681130498
            ],
            [
                3.65e-8,
                1.08344142571,
                88860.05707098669
            ],
            [
                3.388e-8,
                3.20182380957,
                5120.6011455836
            ],
            [
                3.252e-8,
                3.47857474229,
                6133.5126528568
            ],
            [
                2.553e-8,
                3.9486902726,
                1990.745017041
            ],
            [
                3.52e-8,
                2.05559692878,
                244287.60000722768
            ],
            [
                2.565e-8,
                1.56072409371,
                23543.23050468179
            ],
            [
                2.621e-8,
                3.85639359951,
                266.6070417218
            ],
            [
                2.954e-8,
                3.39692614359,
                9225.539273283
            ],
            [
                2.876e-8,
                6.02633318445,
                154717.6098876827
            ],
            [
                2.395e-8,
                1.16130078696,
                10984.1923516998
            ],
            [
                3.161e-8,
                1.32798862116,
                10873.9860304804
            ],
            [
                3.163e-8,
                5.08946546862,
                21228.3920235458
            ],
            [
                2.361e-8,
                4.27212461943,
                6040.3472460174
            ],
            [
                3.03e-8,
                1.80210001168,
                35371.8872659764
            ],
            [
                2.343e-8,
                3.57688971514,
                10969.9652576982
            ],
            [
                2.618e-8,
                2.57870151918,
                22483.84857449259
            ],
            [
                2.113e-8,
                3.71711179417,
                65147.6197681377
            ],
            [
                2.019e-8,
                0.81393923319,
                170.6728706192
            ],
            [
                2.003e-8,
                0.38091017375,
                6172.869528772
            ],
            [
                2.506e-8,
                3.74378169126,
                10575.4066829418
            ],
            [
                2.381e-8,
                0.10581361289,
                7.046236698
            ],
            [
                1.949e-8,
                4.86892513469,
                36.0278666774
            ],
            [
                2.074e-8,
                4.22802468213,
                5650.2921106782
            ],
            [
                1.924e-8,
                5.59460549844,
                6282.0955289232
            ],
            [
                1.949e-8,
                1.06999605576,
                5230.807466803
            ],
            [
                1.988e-8,
                5.19734705445,
                6262.300454499
            ],
            [
                1.887e-8,
                3.74365662683,
                23.8784377478
            ],
            [
                1.787e-8,
                1.25929659066,
                12559.038152982
            ],
            [
                1.883e-8,
                1.90364058477,
                15.252471185
            ],
            [
                1.816e-8,
                3.68083794819,
                15110.4661198662
            ],
            [
                1.701e-8,
                4.41109562589,
                110.2063212194
            ],
            [
                1.99e-8,
                3.93295788548,
                6206.8097787158
            ],
            [
                2.103e-8,
                0.75354936681,
                13521.7514415914
            ],
            [
                1.774e-8,
                0.48750515837,
                1551.045222648
            ],
            [
                1.882e-8,
                0.86685462305,
                22003.9146348698
            ],
            [
                1.924e-8,
                1.22901099088,
                709.9330485583
            ],
            [
                2.073e-8,
                4.62531597856,
                6037.244203762
            ],
            [
                1.924e-8,
                0.60231842492,
                6284.0561710596
            ],
            [
                1.596e-8,
                3.98332879712,
                13916.0191096416
            ],
            [
                1.664e-8,
                4.41947015623,
                8662.240323563
            ],
            [
                1.971e-8,
                1.04560686192,
                18209.33026366019
            ],
            [
                1.942e-8,
                4.31335979989,
                6244.9428143536
            ],
            [
                1.476e-8,
                0.93274523818,
                2379.1644735716
            ],
            [
                1.81e-8,
                0.49112137707,
                1.4844727083
            ],
            [
                1.346e-8,
                1.51574753411,
                4136.9104335162
            ],
            [
                1.528e-8,
                5.61833568587,
                6127.6554505572
            ],
            [
                1.791e-8,
                3.22191142746,
                39302.096962196
            ],
            [
                1.747e-8,
                3.05595292589,
                18319.5365848796
            ],
            [
                1.432e-8,
                4.51123984264,
                20426.571092422
            ],
            [
                1.695e-8,
                0.22049418623,
                25158.6017197654
            ],
            [
                1.242e-8,
                4.46665354536,
                17256.6315363414
            ],
            [
                1.463e-8,
                4.69248613506,
                14945.3161735544
            ],
            [
                1.205e-8,
                1.86911906771,
                4590.910180489
            ],
            [
                1.19e-8,
                2.74169967367,
                12569.6748183318
            ],
            [
                1.222e-8,
                5.18120087481,
                5333.9002410216
            ],
            [
                1.39e-8,
                5.42888623322,
                143571.32428481648
            ],
            [
                1.473e-8,
                1.70487100866,
                11712.9553182308
            ],
            [
                1.362e-8,
                2.61069503292,
                6062.6632075526
            ],
            [
                1.148e-8,
                6.0300843061,
                3634.6210245184
            ],
            [
                1.198e-8,
                5.15296117339,
                10177.2576795336
            ],
            [
                1.266e-8,
                0.11422490557,
                18422.62935909819
            ],
            [
                1.411e-8,
                1.09910890045,
                3496.032826134
            ],
            [
                1.349e-8,
                2.99804623019,
                17654.7805397496
            ],
            [
                1.253e-8,
                2.79844902576,
                167283.7615876655
            ],
            [
                1.311e-8,
                1.609410743,
                5481.2549188676
            ],
            [
                1.079e-8,
                6.20304501787,
                3.2863574178
            ],
            [
                1.181e-8,
                1.20653777627,
                131.5419616864
            ],
            [
                1.254e-8,
                5.45103277799,
                6076.8903015542
            ],
            [
                1.036e-8,
                2.32136959491,
                7342.4577801806
            ],
            [
                1.117e-8,
                0.38842340979,
                949.1756089698
            ],
            [
                9.66e-9,
                3.18352079941,
                11087.2851259184
            ],
            [
                1.171e-8,
                3.39635167732,
                12562.6285816338
            ],
            [
                1.121e-8,
                0.72631814699,
                220.4126424388
            ],
            [
                1.024e-8,
                2.19381113265,
                11403.676995575
            ],
            [
                8.88e-9,
                3.91167196431,
                4686.8894077068
            ],
            [
                9.1e-9,
                1.98802695087,
                735.8765135318
            ],
            [
                8.23e-9,
                0.48822202854,
                24072.9214697764
            ],
            [
                1.096e-8,
                6.17377835617,
                5436.9930152402
            ],
            [
                9.08e-9,
                0.44959148878,
                7477.522860216
            ],
            [
                9.74e-9,
                1.52996313552,
                9623.6882766912
            ],
            [
                8.4e-9,
                1.79540573407,
                5429.8794682394
            ],
            [
                7.78e-9,
                6.17703744517,
                38.1330356378
            ],
            [
                7.76e-9,
                4.09859968447,
                14.2270940016
            ],
            [
                1.068e-8,
                4.64209577648,
                43232.3066584156
            ],
            [
                9.54e-9,
                1.49985885818,
                1162.4747044078
            ],
            [
                9.07e-9,
                0.86986870809,
                10344.2950653858
            ],
            [
                9.31e-9,
                4.06049877517,
                28766.924424484
            ],
            [
                7.39e-9,
                5.04368192034,
                639.897286314
            ],
            [
                9.65e-9,
                3.44286716197,
                1589.0728952838
            ],
            [
                7.63e-9,
                5.86304776787,
                16858.4825329332
            ],
            [
                9.53e-9,
                4.20801492835,
                11190.377900137
            ],
            [
                7.08e-9,
                1.72432323967,
                13095.8426650774
            ],
            [
                9.69e-9,
                1.64437243011,
                29088.811415985
            ],
            [
                7.17e-9,
                0.16688678895,
                11.729352836
            ],
            [
                9.62e-9,
                3.53101876172,
                12416.5885028482
            ],
            [
                7.45e-9,
                5.77741082302,
                12592.4500197826
            ],
            [
                6.72e-9,
                1.91091228744,
                3.9321532631
            ],
            [
                6.71e-9,
                5.46240758839,
                18052.9295431578
            ],
            [
                6.75e-9,
                6.28311649798,
                4535.0594369244
            ],
            [
                6.84e-9,
                0.39975011401,
                5849.3641121146
            ],
            [
                7.99e-9,
                0.29859056777,
                12132.439962106
            ],
            [
                7.58e-9,
                0.96370719224,
                1052.2683831884
            ],
            [
                7.82e-9,
                5.33875702541,
                13517.8701062334
            ],
            [
                7.3e-9,
                1.70114998543,
                17267.26820169119
            ],
            [
                7.49e-9,
                2.59607005624,
                11609.8625440122
            ],
            [
                7.34e-9,
                2.7842049778,
                640.8776073822
            ],
            [
                6.88e-9,
                5.15097673557,
                16496.3613962024
            ],
            [
                7.7e-9,
                1.62459252416,
                4701.1165017084
            ],
            [
                6.33e-9,
                2.20588443066,
                25934.1243310894
            ],
            [
                7.6e-9,
                4.21317219403,
                377.3736079158
            ],
            [
                5.84e-9,
                2.13420121623,
                10557.5941608238
            ],
            [
                5.72e-9,
                0.24649745829,
                9779.1086761254
            ],
            [
                5.73e-9,
                3.16435264609,
                533.2140834436
            ],
            [
                6.85e-9,
                3.19344289472,
                12146.6670561076
            ],
            [
                6.75e-9,
                0.96179234176,
                10454.5013866052
            ],
            [
                6.48e-9,
                1.46327342554,
                6268.8487559898
            ],
            [
                5.89e-9,
                2.50543543638,
                3097.88382272579
            ],
            [
                5.51e-9,
                5.28106257475,
                9388.0059094152
            ],
            [
                6.96e-9,
                3.6534215555,
                4804.209275927
            ],
            [
                6.69e-9,
                2.5103005926,
                2388.8940204492
            ],
            [
                5.5e-9,
                0.06883090057,
                20199.094959633
            ],
            [
                6.29e-9,
                4.13350997495,
                45892.73043315699
            ],
            [
                6.78e-9,
                6.09190163533,
                135.62532501
            ],
            [
                5.93e-9,
                1.50129499103,
                226858.23855437007
            ],
            [
                5.42e-9,
                3.58582033525,
                6148.010769956
            ],
            [
                5.99e-9,
                6.12058050643,
                18875.525869774
            ],
            [
                6.82e-9,
                5.0221361683,
                17253.04110768959
            ],
            [
                5.65e-9,
                4.29309214275,
                11933.3679606696
            ],
            [
                4.86e-9,
                0.77746204893,
                27.4015560968
            ],
            [
                5.03e-9,
                0.58974557727,
                15671.0817594066
            ],
            [
                6.16e-9,
                4.06539884128,
                227.476132789
            ],
            [
                5.37e-9,
                2.15064382406,
                21954.15760939799
            ],
            [
                6.69e-9,
                6.06995500278,
                47162.5163546352
            ],
            [
                5.4e-9,
                2.83444221432,
                5326.7866940208
            ],
            [
                4.74e-9,
                0.40346826846,
                6915.8595893046
            ],
            [
                5.32e-9,
                5.26131065063,
                10988.808157535
            ],
            [
                5.82e-9,
                3.24533095664,
                153.7788104848
            ],
            [
                6.41e-9,
                3.24711790399,
                2107.0345075424
            ],
            [
                6.19e-9,
                3.08302108547,
                33019.0211122046
            ],
            [
                4.66e-9,
                3.14982369789,
                10440.2742926036
            ],
            [
                4.66e-9,
                0.90708835651,
                5966.6839803348
            ],
            [
                5.28e-9,
                0.8192645447,
                813.5502839598
            ],
            [
                6.03e-9,
                3.81378921927,
                316428.22867391503
            ],
            [
                5.59e-9,
                1.8189498573,
                17996.0311682222
            ],
            [
                4.37e-9,
                2.28631745987,
                6303.8512454838
            ],
            [
                5.18e-9,
                4.86068318058,
                20597.2439630412
            ],
            [
                4.24e-9,
                6.23520018697,
                6489.2613984286
            ],
            [
                5.18e-9,
                6.17617826756,
                0.2438174835
            ],
            [
                4.04e-9,
                5.72804304258,
                5642.1982426092
            ],
            [
                4.58e-9,
                1.34117773914,
                6287.0080032545
            ],
            [
                5.48e-9,
                5.6845445832,
                155427.542936241
            ],
            [
                5.47e-9,
                1.03391472434,
                3646.3503773544
            ],
            [
                4.28e-9,
                4.6980968782,
                846.0828347512
            ],
            [
                4.13e-9,
                6.0252069939,
                6279.4854213396
            ],
            [
                5.34e-9,
                3.03030638223,
                66567.48586525429
            ],
            [
                3.83e-9,
                1.4905558804,
                19800.9459562248
            ],
            [
                4.11e-9,
                5.28384176408,
                18451.07854656599
            ],
            [
                3.52e-9,
                4.68891600525,
                4907.3020501456
            ],
            [
                4.8e-9,
                5.36572651091,
                348.924420448
            ],
            [
                3.44e-9,
                5.89157452889,
                6546.1597733642
            ],
            [
                3.4e-9,
                0.37557440365,
                13119.72110282519
            ],
            [
                4.34e-9,
                4.98417856239,
                6702.5604938666
            ],
            [
                3.32e-9,
                2.6890934443,
                29296.6153895786
            ],
            [
                4.48e-9,
                2.16478480251,
                5905.7022420756
            ],
            [
                3.44e-9,
                2.06546633735,
                49.7570254718
            ],
            [
                3.15e-9,
                1.24023810969,
                4061.2192153944
            ],
            [
                3.24e-9,
                2.30897526929,
                5017.508371365
            ],
            [
                4.13e-9,
                0.17171692945,
                6286.6662786432
            ],
            [
                4.31e-9,
                3.8660110138,
                12489.8856287072
            ],
            [
                3.49e-9,
                4.55372493131,
                4933.2084403326
            ],
            [
                3.23e-9,
                0.41971136084,
                10770.8932562618
            ],
            [
                3.41e-9,
                2.68612860807,
                11.0457002639
            ],
            [
                3.16e-9,
                3.52966641606,
                17782.7320727842
            ],
            [
                3.15e-9,
                5.63357264999,
                568.8218740274
            ],
            [
                3.4e-9,
                3.83571212349,
                10660.6869350424
            ],
            [
                2.96e-9,
                0.62703270489,
                20995.3929664494
            ],
            [
                4.05e-9,
                1.00084965393,
                16460.33352952499
            ],
            [
                4.14e-9,
                1.21998752076,
                51092.7260508548
            ],
            [
                3.36e-9,
                4.71465945215,
                6179.9830757728
            ],
            [
                3.61e-9,
                3.71235613733,
                28237.2334593894
            ],
            [
                3.27e-9,
                1.05606504715,
                11919.140866668
            ],
            [
                3.27e-9,
                6.1422242098,
                6254.6266625236
            ],
            [
                2.68e-9,
                2.47224339737,
                664.75604513
            ],
            [
                2.69e-9,
                1.86210872453,
                23141.5583829246
            ],
            [
                3.45e-9,
                0.93461290184,
                6058.7310542895
            ],
            [
                3.53e-9,
                4.50033650657,
                36949.2308084242
            ],
            [
                3.44e-9,
                6.26166140367,
                24356.7807886416
            ],
            [
                3e-9,
                4.46964001975,
                6418.1409300268
            ],
            [
                2.6e-9,
                4.04967464725,
                6525.8044539654
            ],
            [
                2.98e-9,
                2.20018811054,
                156137.47598479927
            ],
            [
                2.53e-9,
                3.49930797865,
                29864.334027309
            ],
            [
                2.54e-9,
                2.44883530154,
                5331.3574437408
            ],
            [
                2.96e-9,
                0.84341183907,
                5729.506447149
            ],
            [
                2.41e-9,
                2.00721298729,
                16737.5772365966
            ],
            [
                3.11e-9,
                1.23668016336,
                6281.5913772831
            ],
            [
                3.32e-9,
                3.55576945724,
                7668.6374249425
            ],
            [
                2.36e-9,
                2.47437156031,
                6245.0481773556
            ],
            [
                2.64e-9,
                4.43924412283,
                12964.300703391
            ],
            [
                2.57e-9,
                1.79654471948,
                11080.1715789176
            ],
            [
                2.6e-9,
                3.3307759606,
                5888.4499649322
            ],
            [
                2.85e-9,
                0.3088636143,
                11823.1616394502
            ],
            [
                2.9e-9,
                5.70141882483,
                77.673770428
            ],
            [
                2.55e-9,
                4.00939662024,
                5881.4037282342
            ],
            [
                2.53e-9,
                4.73318512715,
                16723.350142595
            ],
            [
                2.28e-9,
                0.95333661324,
                5540.0857894588
            ],
            [
                2.81e-9,
                1.29199646396,
                22805.7355659936
            ],
            [
                3.19e-9,
                1.38633229189,
                163096.18036118348
            ],
            [
                2.24e-9,
                1.65156322696,
                10027.9031957292
            ],
            [
                2.26e-9,
                0.34125379653,
                17796.9591667858
            ],
            [
                2.36e-9,
                4.19817431922,
                19.66976089979
            ],
            [
                2.81e-9,
                4.14114899916,
                12539.853380183
            ],
            [
                2.75e-9,
                5.50306930248,
                32.5325507914
            ],
            [
                2.23e-9,
                5.23334210294,
                56.8983749356
            ],
            [
                2.17e-9,
                6.08598789777,
                6805.6532680852
            ],
            [
                2.28e-9,
                5.17114391778,
                11720.0688652316
            ],
            [
                2.74e-9,
                4.50716805713,
                6016.4688082696
            ],
            [
                2.45e-9,
                3.96486270306,
                22.7752014508
            ],
            [
                2.2e-9,
                4.7207808197,
                6.62855890001
            ],
            [
                2.07e-9,
                5.71701403951,
                41.5507909848
            ],
            [
                2.04e-9,
                3.9122741125,
                2699.7348193176
            ],
            [
                2.09e-9,
                0.86881969024,
                6321.1035226272
            ],
            [
                2e-9,
                2.11984442601,
                4274.5183108324
            ],
            [
                2e-9,
                5.39839888151,
                6019.9919266186
            ],
            [
                2.09e-9,
                5.67606291663,
                11293.4706743556
            ],
            [
                2.52e-9,
                1.6496572935,
                9380.9596727172
            ],
            [
                2.75e-9,
                5.04826903506,
                73.297125859
            ],
            [
                2.08e-9,
                1.88207277133,
                11300.5842213564
            ],
            [
                2.06e-9,
                5.0728488933,
                6277.552925684
            ],
            [
                2.72e-9,
                0.74640924904,
                1975.492545856
            ],
            [
                1.99e-9,
                3.30813142103,
                22743.4093795164
            ],
            [
                2.69e-9,
                4.48560812155,
                64471.99124174489
            ],
            [
                1.92e-9,
                2.17463565107,
                5863.5912061162
            ],
            [
                2.28e-9,
                5.85373115869,
                128.0188433374
            ],
            [
                2.61e-9,
                2.64321183295,
                55022.9357470744
            ],
            [
                1.96e-9,
                2.4853762232,
                16062.1845261168
            ],
            [
                1.87e-9,
                1.3189176028,
                29826.3063546732
            ],
            [
                2.2e-9,
                5.75012110079,
                29.429508536
            ],
            [
                1.87e-9,
                4.03230554718,
                467.9649903544
            ],
            [
                2e-9,
                5.60555262896,
                1066.49547719
            ],
            [
                2.31e-9,
                1.09802712785,
                12341.8069042809
            ],
            [
                1.98e-9,
                0.29474229005,
                149.5631971346
            ],
            [
                2.49e-9,
                5.1047702317,
                7875.6718636242
            ],
            [
                1.79e-9,
                0.87066197995,
                12721.572099417
            ],
            [
                2.03e-9,
                1.56914310573,
                28286.9904848612
            ],
            [
                1.98e-9,
                3.54061588502,
                30.914125635
            ],
            [
                1.71e-9,
                3.45366018621,
                5327.4761083828
            ],
            [
                1.83e-9,
                0.72325421604,
                6272.0301497275
            ],
            [
                2.16e-9,
                2.97175184412,
                19402.7969528166
            ],
            [
                1.68e-9,
                2.51559879907,
                23937.856389741
            ],
            [
                1.95e-9,
                0.09045393425,
                156.4007205024
            ],
            [
                2.16e-9,
                0.42162375972,
                23539.7073863328
            ],
            [
                1.89e-9,
                0.37542530191,
                9814.6041002912
            ],
            [
                2.07e-9,
                2.01752547259,
                238004.5241572363
            ],
            [
                2.18e-9,
                2.36835893645,
                16627.3709153772
            ],
            [
                1.66e-9,
                4.23182960518,
                16840.67001081519
            ],
            [
                2e-9,
                2.02153258098,
                16097.6799502826
            ],
            [
                1.69e-9,
                0.91318727,
                95.9792272178
            ],
            [
                2.11e-9,
                5.73370637657,
                151.8972810852
            ],
            [
                2.04e-9,
                0.42643085174,
                515.463871093
            ],
            [
                2.12e-9,
                3.00223140894,
                12043.574281889
            ],
            [
                1.92e-9,
                5.46153589821,
                6379.0550772092
            ],
            [
                1.6e-9,
                6.23798383332,
                202.2533951741
            ],
            [
                2.15e-9,
                0.20889073407,
                5621.8429232104
            ],
            [
                1.5e-9,
                3.12999753018,
                799.8211251654
            ],
            [
                1.87e-9,
                2.12345787867,
                491.6632924588
            ],
            [
                1.92e-9,
                1.33928820063,
                394.6258850592
            ],
            [
                1.49e-9,
                2.65697593276,
                21.335640467
            ],
            [
                1.46e-9,
                5.58021191726,
                412.3710968744
            ],
            [
                1.56e-9,
                3.7565767638,
                12323.4230960088
            ],
            [
                1.43e-9,
                3.28248547724,
                29.8214381488
            ],
            [
                1.44e-9,
                1.07862546598,
                1265.5674786264
            ],
            [
                1.48e-9,
                0.2338663109,
                10021.8372800994
            ],
            [
                1.64e-9,
                0.94288727597,
                14919.0178537546
            ],
            [
                1.93e-9,
                5.92751083827,
                40879.4405046438
            ],
            [
                1.4e-9,
                4.97612440269,
                158.9435177832
            ],
            [
                1.48e-9,
                2.61651818006,
                17157.0618804718
            ],
            [
                1.4e-9,
                3.66947933935,
                26084.0218062162
            ],
            [
                1.47e-9,
                5.09968173403,
                661.232926781
            ],
            [
                1.47e-9,
                1.36976712162,
                4171.4255366138
            ],
            [
                1.34e-9,
                4.79432636012,
                111.1866422876
            ],
            [
                1.4e-9,
                1.27748013377,
                107.6635239386
            ],
            [
                1.71e-9,
                2.77586207403,
                26735.9452622132
            ],
            [
                1.83e-9,
                5.43418358741,
                369.6998159404
            ],
            [
                1.34e-9,
                3.09132862833,
                17.812522118
            ],
            [
                1.32e-9,
                3.05633896779,
                22490.9621214934
            ],
            [
                1.81e-9,
                4.22950689891,
                966.9708774356
            ],
            [
                1.66e-9,
                3.67660435776,
                15508.6151232744
            ],
            [
                1.52e-9,
                5.28885813387,
                12669.2444742014
            ],
            [
                1.5e-9,
                5.86819430895,
                97238.62754448749
            ],
            [
                1.45e-9,
                5.07330784304,
                87.30820453981
            ],
            [
                1.33e-9,
                5.65471067133,
                31.9723058168
            ],
            [
                1.24e-9,
                2.83326216907,
                12566.2190102856
            ],
            [
                1.4e-9,
                5.84212721453,
                22476.73502749179
            ],
            [
                1.34e-9,
                3.12858101887,
                32217.2001810808
            ],
            [
                1.37e-9,
                0.86487461904,
                9924.8104215106
            ],
            [
                1.72e-9,
                1.98369595114,
                174242.4659640497
            ],
            [
                1.7e-9,
                4.41115280254,
                327574.51427678124
            ],
            [
                1.28e-9,
                4.49087631612,
                31415.379249957
            ],
            [
                1.51e-9,
                0.46542092001,
                39609.6545831656
            ],
            [
                1.53e-9,
                3.78801830344,
                17363.24742890899
            ],
            [
                1.65e-9,
                5.31654110459,
                16943.7627850338
            ],
            [
                1.65e-9,
                4.06747587817,
                58953.145443294
            ],
            [
                1.18e-9,
                0.63846333239,
                6.0659156298
            ],
            [
                1.59e-9,
                0.86086959274,
                221995.02880149524
            ],
            [
                1.19e-9,
                5.96432932413,
                1385.8952763362
            ],
            [
                1.14e-9,
                5.16516114595,
                25685.872802808
            ],
            [
                1.12e-9,
                4.92889233335,
                56.8032621698
            ],
            [
                1.19e-9,
                2.40626699328,
                18635.9284545362
            ],
            [
                1.15e-9,
                0.23374479051,
                418.9243989006
            ],
            [
                1.13e-9,
                2.7938757674,
                6272.4391846416
            ],
            [
                1.22e-9,
                0.936940724,
                24492.40611365159
            ],
            [
                1.33e-9,
                4.87155573413,
                22345.2603761082
            ],
            [
                1.13e-9,
                3.80362889046,
                6293.7125153412
            ],
            [
                1.3e-9,
                3.72996018683,
                12573.2652469836
            ],
            [
                1.07e-9,
                3.40227152756,
                21393.5419698576
            ],
            [
                1.22e-9,
                1.00385670948,
                95143.1329209781
            ],
            [
                1.4e-9,
                1.094130757,
                44809.6502008634
            ],
            [
                1.12e-9,
                6.05462382871,
                433.7117378768
            ],
            [
                1.23e-9,
                4.55640196386,
                239424.39025435288
            ],
            [
                1.04e-9,
                1.54931540602,
                127.9515330346
            ],
            [
                1.11e-9,
                3.04186517428,
                8982.810669309
            ],
            [
                1.02e-9,
                4.12448497391,
                15664.03552270859
            ],
            [
                1.07e-9,
                4.67919356465,
                77690.75950573849
            ],
            [
                1.18e-9,
                4.5232017012,
                19004.6479494084
            ],
            [
                1.07e-9,
                5.71774478555,
                77736.78343050249
            ],
            [
                1.03e-9,
                4.79332126649,
                33794.5437235286
            ],
            [
                1.43e-9,
                1.81201813018,
                4214.0690150848
            ],
            [
                1.02e-9,
                3.7581778657,
                58864.5439181463
            ],
            [
                1.25e-9,
                1.14419195615,
                625.6701923124
            ],
            [
                1.24e-9,
                3.27736513892,
                12566.08438968
            ],
            [
                1.1e-9,
                1.08705709966,
                2787.0430238574
            ],
            [
                1.02e-9,
                4.75119578149,
                12242.6462833254
            ],
            [
                1.01e-9,
                4.91289409429,
                401.6721217572
            ],
            [
                1.38e-9,
                2.89578979744,
                9411.4646150872
            ],
            [
                1.29e-9,
                1.23516042371,
                12029.3471878874
            ],
            [
                1.38e-9,
                2.45654707076,
                7576.560073574
            ],
            [
                9.8e-10,
                5.4477176502,
                29026.48522950779
            ],
            [
                1.34e-9,
                1.43105174912,
                86464.6133168312
            ],
            [
                1.08e-9,
                0.9898977494,
                5636.0650166766
            ],
            [
                1.17e-9,
                5.17362847134,
                34520.3093093808
            ],
            [
                9.7e-10,
                3.34717130592,
                16310.9790457206
            ],
            [
                1.07e-9,
                2.94547931851,
                24602.61243487099
            ],
            [
                9.8e-10,
                4.37041908717,
                34513.2630726828
            ],
            [
                1.25e-9,
                2.72182830814,
                24065.80792277559
            ],
            [
                1.11e-9,
                0.58899131543,
                6303.4311693902
            ],
            [
                1.02e-9,
                0.66938025772,
                10239.5838660108
            ],
            [
                1.19e-9,
                1.21666517886,
                1478.8665740644
            ],
            [
                1.11e-9,
                1.04321934681,
                16522.6597160022
            ],
            [
                9.4e-10,
                4.31076339857,
                26880.3198130326
            ],
            [
                9.8e-10,
                4.14248433763,
                6599.467719648
            ],
            [
                9.5e-10,
                2.89807657534,
                34911.412076091
            ],
            [
                9.7e-10,
                0.89642320201,
                71980.63357473118
            ],
            [
                9.5e-10,
                0.65717727948,
                6288.5987742988
            ],
            [
                1.16e-9,
                4.19967201116,
                206.7007372966
            ],
            [
                9.5e-10,
                1.78315464297,
                18139.2945014159
            ],
            [
                9.9e-10,
                1.37437847718,
                1039.0266107904
            ],
            [
                1.26e-9,
                3.21642544972,
                305281.9430710488
            ],
            [
                9.4e-10,
                0.6899503186,
                7834.1210726394
            ],
            [
                9.5e-10,
                5.58111421744,
                3104.9300594238
            ],
            [
                1.08e-9,
                0.52696637156,
                276.7457718644
            ],
            [
                1.24e-9,
                3.43899862683,
                172146.9713405403
            ],
            [
                8.7e-10,
                1.18764938806,
                18842.11400297339
            ],
            [
                8.7e-10,
                0.09094166389,
                15141.390794312
            ],
            [
                1.08e-9,
                1.03363414379,
                82576.9812209953
            ],
            [
                1.19e-9,
                2.86729109648,
                90394.82301305079
            ],
            [
                1.04e-9,
                3.39218586218,
                290.972865866
            ],
            [
                9.4e-10,
                5.68284937444,
                32367.0976562076
            ],
            [
                1.17e-9,
                0.78475956902,
                83286.91426955358
            ],
            [
                1.05e-9,
                3.96551057233,
                6357.8574485587
            ],
            [
                9.4e-10,
                4.03443174853,
                13341.6743113068
            ],
            [
                9.6e-10,
                0.92742567538,
                1062.9050485382
            ],
            [
                8.9e-10,
                4.45371820659,
                792.7748884674
            ],
            [
                8.7e-10,
                0.40013481685,
                90279.92316810328
            ],
            [
                1.13e-9,
                2.48165313368,
                48739.859897083
            ],
            [
                8.7e-10,
                3.43122851097,
                27707.5424942948
            ],
            [
                1.01e-9,
                5.32081603011,
                2301.58581590939
            ],
            [
                8.4e-10,
                0.67020912458,
                28628.3362260996
            ],
            [
                8.2e-10,
                0.87060089842,
                10241.2022911672
            ],
            [
                8.6e-10,
                4.6206479229,
                36147.4098773004
            ],
            [
                8e-10,
                4.77649625396,
                6819.8803620868
            ],
            [
                9.5e-10,
                2.87032913492,
                23020.65308658799
            ],
            [
                1.07e-9,
                5.77864921649,
                34115.1140692746
            ],
            [
                1.1e-9,
                3.32898859416,
                72140.6286666874
            ],
            [
                8.7e-10,
                4.40657711727,
                142.1786270362
            ],
            [
                1.03e-9,
                4.2250672681,
                30666.1549584328
            ],
            [
                8.2e-10,
                3.89404392552,
                5547.1993364596
            ],
            [
                1.09e-9,
                1.94546065204,
                24279.10701821359
            ],
            [
                8.7e-10,
                4.32472045435,
                742.9900605326
            ],
            [
                1.07e-9,
                4.91580912547,
                277.0349937414
            ],
            [
                8.8e-10,
                2.10180817713,
                26482.1708096244
            ],
            [
                8.6e-10,
                4.01895021483,
                12491.3701014155
            ],
            [
                1.06e-9,
                5.49092372854,
                62883.3551395136
            ],
            [
                8e-10,
                6.1978570495,
                6709.6740408674
            ],
            [
                1.05e-9,
                2.44166529175,
                6298.3283211764
            ],
            [
                8.3e-10,
                4.90662164029,
                51.28033786241
            ],
            [
                7.4e-10,
                2.34622575625,
                7018.9523635232
            ],
            [
                7.8e-10,
                6.06947270265,
                148434.53403769128
            ],
            [
                7.9e-10,
                3.03048221644,
                838.9692877504
            ],
            [
                7.3e-10,
                3.05008665738,
                567.7186377304
            ],
            [
                1.02e-9,
                3.59223815483,
                22380.755800274
            ],
            [
                8.4e-10,
                0.46604373274,
                45.1412196366
            ],
            [
                9.2e-10,
                4.12917744733,
                18216.443810661
            ],
            [
                9.1e-10,
                0.49382398887,
                6453.7487206106
            ],
            [
                7.3e-10,
                1.72446569088,
                21424.4666443034
            ],
            [
                6.9e-10,
                1.4937267773,
                21548.9623692918
            ],
            [
                6.9e-10,
                4.73181018058,
                8858.3149443206
            ],
            [
                7.7e-10,
                0.47683782532,
                11520.9968637952
            ],
            [
                7.8e-10,
                5.4394263099,
                15265.8865193004
            ],
            [
                7.7e-10,
                2.53773750372,
                76.2660712756
            ],
            [
                6.9e-10,
                2.53932635192,
                9910.583327509
            ],
            [
                7.5e-10,
                0.1559472921,
                23006.42599258639
            ],
            [
                7.8e-10,
                2.41004950269,
                6393.2821712108
            ],
            [
                6.7e-10,
                5.05152846816,
                57375.8019008462
            ],
            [
                7.7e-10,
                3.9107560486,
                24383.0791084414
            ],
            [
                6.7e-10,
                0.78239147387,
                12779.4507954208
            ],
            [
                7.1e-10,
                1.24817900687,
                10419.9862835076
            ],
            [
                6.7e-10,
                5.7785122776,
                6311.5250374592
            ],
            [
                6.1e-10,
                2.66705754411,
                18852.7506683232
            ],
            [
                7.9e-10,
                1.89137330427,
                6528.9074962208
            ],
            [
                8.4e-10,
                5.11523704221,
                50317.2034395308
            ],
            [
                5.9e-10,
                3.38290426621,
                35707.7100829074
            ],
            [
                6.5e-10,
                4.66767908854,
                26709.6469424134
            ],
            [
                7.9e-10,
                5.59773848156,
                71960.38658322369
            ],
            [
                6.1e-10,
                3.30733768968,
                18845.7044316252
            ],
            [
                5.7e-10,
                3.90831298022,
                5999.2165311262
            ],
            [
                5.8e-10,
                3.92572820333,
                30348.883772767
            ],
            [
                6.1e-10,
                0.05695045822,
                7856.89627409019
            ],
            [
                6.1e-10,
                5.63297960691,
                7863.9425107882
            ],
            [
                6.8e-10,
                2.53986117507,
                20452.8694122218
            ],
            [
                5.3e-10,
                5.44021645443,
                32370.9789915656
            ],
            [
                5.9e-10,
                4.95695131145,
                11925.2740926006
            ],
            [
                5.9e-10,
                5.34668243273,
                137288.2484348251
            ],
            [
                5.6e-10,
                4.05779957425,
                17892.93839400359
            ],
            [
                5.3e-10,
                3.94182462468,
                18624.8827542723
            ],
            [
                4.9e-10,
                2.11782803206,
                22594.05489571199
            ],
            [
                6.2e-10,
                2.47154086715,
                12345.739057544
            ],
            [
                4.9e-10,
                5.7659693738,
                18606.4989460002
            ],
            [
                5.2e-10,
                6.20902099741,
                21947.1113727
            ],
            [
                5.1e-10,
                3.13287981215,
                33326.5787331742
            ],
            [
                5.7e-10,
                6.17003357597,
                61306.0115970658
            ],
            [
                6.4e-10,
                5.66596451842,
                34596.3646546524
            ],
            [
                6.6e-10,
                3.922623355,
                69853.3520756813
            ],
            [
                5.3e-10,
                5.51119362049,
                77710.24834977149
            ],
            [
                5.3e-10,
                4.88573986965,
                77717.29458646949
            ],
            [
                4.8e-10,
                2.71399112516,
                20760.4270331914
            ],
            [
                4.6e-10,
                6.08376164442,
                29822.7832363242
            ],
            [
                5.2e-10,
                0.3139748138,
                37724.7534197482
            ],
            [
                4.5e-10,
                5.53587248663,
                6262.7205305926
            ],
            [
                5.9e-10,
                2.45437896854,
                69166.430989505
            ],
            [
                6e-10,
                5.24261569842,
                56600.2792895222
            ],
            [
                5.1e-10,
                6.15794342172,
                11616.976091013
            ],
            [
                6e-10,
                1.74758109828,
                44034.1275895394
            ],
            [
                4.9e-10,
                5.08973141046,
                33990.6183442862
            ],
            [
                4.4e-10,
                3.28270864884,
                29424.634232916
            ],
            [
                5.2e-10,
                5.34866947943,
                28313.288804661
            ],
            [
                5.9e-10,
                2.12384971916,
                36173.7081971002
            ],
            [
                5e-10,
                0.46480931695,
                25287.7237993998
            ],
            [
                4.4e-10,
                2.0550351721,
                63658.8777508376
            ],
            [
                4.4e-10,
                1.71009200258,
                13362.4497067992
            ],
            [
                4.1e-10,
                3.91721318316,
                6279.1945146334
            ],
            [
                4.2e-10,
                1.52106001448,
                23550.34405168259
            ],
            [
                4.2e-10,
                3.10938258068,
                84672.47584450469
            ],
            [
                4.1e-10,
                3.78863023321,
                35050.00027447539
            ],
            [
                4.2e-10,
                5.57543459263,
                38500.2760310722
            ],
            [
                4e-10,
                5.55145719363,
                12565.1713789146
            ],
            [
                5.4e-10,
                0.889354921,
                50290.905119731
            ],
            [
                5.5e-10,
                2.50268487636,
                77828.671313068
            ],
            [
                5.4e-10,
                4.16257918787,
                22910.44676536859
            ],
            [
                4.1e-10,
                2.32141215064,
                6286.9571853494
            ],
            [
                4.5e-10,
                3.18590576311,
                45585.1728121874
            ],
            [
                4.5e-10,
                2.24348941683,
                23646.32327890039
            ],
            [
                4.3e-10,
                3.8789211095,
                6549.6828917132
            ],
            [
                4.8e-10,
                2.11364139445,
                31570.7996493912
            ],
            [
                4.3e-10,
                5.55099558987,
                12359.9661515456
            ],
            [
                4.1e-10,
                4.88191569433,
                23536.11695768099
            ],
            [
                4.9e-10,
                2.44790922235,
                13613.804277336
            ],
            [
                4.7e-10,
                3.5818169391,
                4797.0957289262
            ]
        ],
        "1": [
            [
                6283.0758499914,
                0,
                0
            ],
            [
                0.00206058863,
                2.67823455808,
                6283.0758499914
            ],
            [
                0.00004303419,
                2.63512233481,
                12566.1516999828
            ],
            [
                0.00000425264,
                1.59046982018,
                3.523118349
            ],
            [
                0.00000109017,
                2.96631010675,
                1577.3435424478
            ],
            [
                9.3479e-7,
                2.59211109542,
                18849.2275499742
            ],
            [
                0.00000119305,
                5.79555765566,
                26.2983197998
            ],
            [
                7.2121e-7,
                1.13840581212,
                529.6909650946
            ],
            [
                6.7784e-7,
                1.87453300345,
                398.1490034082
            ],
            [
                6.735e-7,
                4.40932832004,
                5507.5532386674
            ],
            [
                5.9045e-7,
                2.88815790631,
                5223.6939198022
            ],
            [
                5.5976e-7,
                2.17471740035,
                155.4203994342
            ],
            [
                4.5411e-7,
                0.39799502896,
                796.2980068164
            ],
            [
                3.6298e-7,
                0.46875437227,
                775.522611324
            ],
            [
                2.8962e-7,
                2.64732254645,
                7.1135470008
            ],
            [
                1.9097e-7,
                1.84628376049,
                5486.777843175
            ],
            [
                2.0844e-7,
                5.34138275149,
                0.9803210682
            ],
            [
                1.8508e-7,
                4.96855179468,
                213.299095438
            ],
            [
                1.6233e-7,
                0.03216587315,
                2544.3144198834
            ],
            [
                1.7293e-7,
                2.9911676063,
                6275.9623029906
            ],
            [
                1.5832e-7,
                1.43049301283,
                2146.1654164752
            ],
            [
                1.4608e-7,
                1.2046979369,
                10977.078804699
            ],
            [
                1.1877e-7,
                3.25805082007,
                5088.6288397668
            ],
            [
                1.1514e-7,
                2.07502080082,
                4694.0029547076
            ],
            [
                9.721e-8,
                4.2392586526,
                1349.8674096588
            ],
            [
                9.969e-8,
                1.30263423409,
                6286.5989683404
            ],
            [
                9.452e-8,
                2.69956827011,
                242.728603974
            ],
            [
                1.2461e-7,
                2.83432282119,
                1748.016413067
            ],
            [
                1.1808e-7,
                5.27379760438,
                1194.4470102246
            ],
            [
                8.577e-8,
                5.6447608598,
                951.7184062506
            ],
            [
                1.0641e-7,
                0.76614722966,
                553.5694028424
            ],
            [
                7.576e-8,
                5.30056172859,
                2352.8661537718
            ],
            [
                5.764e-8,
                1.77228445837,
                1059.3819301892
            ],
            [
                6.385e-8,
                2.65034514038,
                9437.762934887
            ],
            [
                5.223e-8,
                5.66135782131,
                71430.69561812909
            ],
            [
                5.315e-8,
                0.91110018969,
                3154.6870848956
            ],
            [
                6.101e-8,
                4.66633726278,
                4690.4798363586
            ],
            [
                4.335e-8,
                0.23934560382,
                6812.766815086
            ],
            [
                5.041e-8,
                1.42489704722,
                6438.4962494256
            ],
            [
                4.259e-8,
                0.77355543889,
                10447.3878396044
            ],
            [
                5.2e-8,
                1.85528830215,
                801.8209311238
            ],
            [
                3.744e-8,
                2.00119905572,
                8031.0922630584
            ],
            [
                3.553e-8,
                2.42789590229,
                14143.4952424306
            ],
            [
                3.372e-8,
                3.86210786421,
                1592.5960136328
            ],
            [
                3.38e-8,
                0.88545388924,
                12036.4607348882
            ],
            [
                3.196e-8,
                3.19713328141,
                4705.7323075436
            ],
            [
                3.221e-8,
                0.6160104899,
                8429.2412664666
            ],
            [
                4.132e-8,
                5.23992584671,
                7084.8967811152
            ],
            [
                2.97e-8,
                6.07029819073,
                4292.3308329504
            ],
            [
                2.9e-8,
                2.32464208411,
                20.3553193988
            ],
            [
                3.504e-8,
                4.79976712702,
                6279.5527316424
            ],
            [
                2.95e-8,
                1.43108874817,
                5746.271337896
            ],
            [
                2.697e-8,
                4.80365209201,
                7234.794256242
            ],
            [
                2.531e-8,
                6.22289990904,
                6836.6452528338
            ],
            [
                2.745e-8,
                0.93466065396,
                5760.4984318976
            ],
            [
                3.25e-8,
                3.39951915286,
                7632.9432596502
            ],
            [
                2.278e-8,
                5.00339914806,
                17789.845619785
            ],
            [
                2.076e-8,
                3.95551309007,
                10213.285546211
            ],
            [
                2.061e-8,
                2.2240771919,
                5856.4776591154
            ],
            [
                2.252e-8,
                5.67166717686,
                11499.6562227928
            ],
            [
                2.148e-8,
                5.20182663314,
                11513.8833167944
            ],
            [
                1.886e-8,
                0.53198539077,
                3340.6124266998
            ],
            [
                1.875e-8,
                4.73511969924,
                83996.84731811189
            ],
            [
                2.06e-8,
                2.54985307819,
                25132.3033999656
            ],
            [
                1.794e-8,
                1.47435300254,
                4164.311989613
            ],
            [
                1.778e-8,
                3.02473091781,
                5.5229243074
            ],
            [
                2.036e-8,
                0.90908165072,
                6256.7775301916
            ],
            [
                2.064e-8,
                2.27051326957,
                522.5774180938
            ],
            [
                1.773e-8,
                3.03090500693,
                5753.3848848968
            ],
            [
                1.569e-8,
                6.12406216872,
                5216.5803728014
            ],
            [
                1.59e-8,
                4.63713748247,
                3.2863574178
            ],
            [
                1.533e-8,
                4.20305593883,
                13367.9726311066
            ],
            [
                1.427e-8,
                1.19087535126,
                3894.1818295422
            ],
            [
                1.376e-8,
                4.24955891338,
                426.598190876
            ],
            [
                1.375e-8,
                3.09301252193,
                135.0650800354
            ],
            [
                1.308e-8,
                3.0849213889,
                5643.1785636774
            ],
            [
                1.34e-8,
                5.76513167968,
                6040.3472460174
            ],
            [
                1.25e-8,
                3.07748196332,
                11926.2544136688
            ],
            [
                1.551e-8,
                3.07664090662,
                6681.2248533996
            ],
            [
                1.148e-8,
                3.24144202282,
                12168.0026965746
            ],
            [
                1.268e-8,
                2.09201189992,
                6290.1893969922
            ],
            [
                1.248e-8,
                3.44506939791,
                536.8045120954
            ],
            [
                1.118e-8,
                2.31830078762,
                16730.4636895958
            ],
            [
                1.105e-8,
                5.31966001019,
                23.8784377478
            ],
            [
                1.012e-8,
                3.74953487087,
                7860.4193924392
            ],
            [
                1.025e-8,
                2.4468377161,
                1990.745017041
            ],
            [
                9.62e-9,
                0.81771017882,
                3.881335358
            ],
            [
                9.11e-9,
                0.41724352112,
                7079.3738568078
            ],
            [
                1.091e-8,
                3.98233608618,
                11506.7697697936
            ],
            [
                9.57e-9,
                4.07671436153,
                6127.6554505572
            ],
            [
                8.35e-9,
                5.28348689371,
                11790.6290886588
            ],
            [
                8.02e-9,
                3.88779080089,
                10973.55568635
            ],
            [
                7.73e-9,
                2.41044394817,
                1589.0728952838
            ],
            [
                7.58e-9,
                1.30034365873,
                103.0927742186
            ],
            [
                7.49e-9,
                4.96281442361,
                6496.3749454294
            ],
            [
                7.65e-9,
                3.36312388424,
                36.0278666774
            ],
            [
                9.15e-9,
                5.41549763095,
                206.1855484372
            ],
            [
                7.76e-9,
                2.57589060224,
                11371.7046897582
            ],
            [
                7.72e-9,
                3.98363364977,
                955.5997416086
            ],
            [
                7.49e-9,
                5.17900231417,
                10969.9652576982
            ],
            [
                8.06e-9,
                0.34226117299,
                9917.6968745098
            ],
            [
                7.28e-9,
                5.20962563787,
                38.0276726358
            ],
            [
                6.85e-9,
                2.77592961854,
                20.7753954924
            ],
            [
                6.36e-9,
                4.28242193632,
                28.4491874678
            ],
            [
                6.08e-9,
                5.63278510221,
                10984.1923516998
            ],
            [
                7.04e-9,
                5.60739437733,
                3738.761430108
            ],
            [
                6.85e-9,
                0.38876148682,
                15.252471185
            ],
            [
                6.01e-9,
                0.73489602442,
                419.4846438752
            ],
            [
                7.16e-9,
                2.65286869987,
                6309.3741697912
            ],
            [
                5.84e-9,
                5.54508741381,
                17298.1823273262
            ],
            [
                6.28e-9,
                1.11733054796,
                7058.5984613154
            ],
            [
                6.88e-9,
                2.59684132401,
                3496.032826134
            ],
            [
                4.85e-9,
                0.44470714066,
                12352.8526045448
            ],
            [
                5.62e-9,
                2.82510352358,
                3930.2096962196
            ],
            [
                5.97e-9,
                5.27675789973,
                10575.4066829418
            ],
            [
                5.83e-9,
                3.1893153986,
                4732.0306273434
            ],
            [
                5.26e-9,
                5.01737745304,
                5884.9268465832
            ],
            [
                5.4e-9,
                1.29182747488,
                640.8776073822
            ],
            [
                4.81e-9,
                5.49721461067,
                5230.807466803
            ],
            [
                4.06e-9,
                5.21253018484,
                220.4126424388
            ],
            [
                3.95e-9,
                1.87489912123,
                16200.7727245012
            ],
            [
                3.67e-9,
                0.88533542945,
                6283.14316029419
            ],
            [
                3.69e-9,
                3.84778078192,
                18073.7049386502
            ],
            [
                3.79e-9,
                0.37991716505,
                10177.2576795336
            ],
            [
                3.56e-9,
                3.84152910109,
                11712.9553182308
            ],
            [
                3.74e-9,
                5.01577520608,
                7.046236698
            ],
            [
                3.81e-9,
                4.30250406634,
                6062.6632075526
            ],
            [
                4.71e-9,
                0.86388942467,
                6069.7767545534
            ],
            [
                3.67e-9,
                1.3294383993,
                6283.0085396886
            ],
            [
                4.6e-9,
                5.19667219582,
                6284.0561710596
            ],
            [
                3.33e-9,
                5.54250425107,
                4686.8894077068
            ],
            [
                3.41e-9,
                4.36524495363,
                7238.6755916
            ],
            [
                3.36e-9,
                4.00205876835,
                3097.88382272579
            ],
            [
                3.59e-9,
                6.22679790284,
                245.8316462294
            ],
            [
                3.07e-9,
                2.35299010924,
                170.6728706192
            ],
            [
                3.43e-9,
                3.77164927142,
                6076.8903015542
            ],
            [
                2.96e-9,
                5.44138799494,
                17260.1546546904
            ],
            [
                3.28e-9,
                0.13817705132,
                11015.1064773348
            ],
            [
                2.69e-9,
                1.13308244952,
                12569.6748183318
            ],
            [
                2.63e-9,
                0.0055073751,
                4136.9104335162
            ],
            [
                2.82e-9,
                5.04399588559,
                7477.522860216
            ],
            [
                2.8e-9,
                3.13703211405,
                12559.038152982
            ],
            [
                2.59e-9,
                0.93882269388,
                5642.1982426092
            ],
            [
                2.92e-9,
                1.98426314297,
                12132.439962106
            ],
            [
                2.47e-9,
                3.84244798673,
                5429.8794682394
            ],
            [
                3.19e-9,
                5.0417014879,
                90617.7374312997
            ],
            [
                2.45e-9,
                5.70469737024,
                65147.6197681377
            ],
            [
                3.18e-9,
                1.35581968834,
                78051.5857313169
            ],
            [
                2.41e-9,
                0.99469787369,
                3634.6210245184
            ],
            [
                2.46e-9,
                3.06168069393,
                110.2063212194
            ],
            [
                2.39e-9,
                6.11854529589,
                11856.2186514245
            ],
            [
                2.67e-9,
                0.65297608414,
                21228.3920235458
            ],
            [
                2.62e-9,
                1.51070507866,
                12146.6670561076
            ],
            [
                2.3e-9,
                1.75923794017,
                9779.1086761254
            ],
            [
                2.23e-9,
                2.00967043606,
                6172.869528772
            ],
            [
                2.46e-9,
                1.10411690861,
                6282.0955289232
            ],
            [
                2.14e-9,
                4.03840492266,
                14314.1681130498
            ],
            [
                2.12e-9,
                2.13695623228,
                5849.3641121146
            ],
            [
                2.07e-9,
                3.07724246401,
                11.729352836
            ],
            [
                2.07e-9,
                6.10303325026,
                23543.23050468179
            ],
            [
                2.66e-9,
                1.00720021877,
                2388.8940204492
            ],
            [
                2.17e-9,
                6.27840212312,
                17267.26820169119
            ],
            [
                2.31e-9,
                5.37372783468,
                13916.0191096416
            ],
            [
                2.04e-9,
                2.34615348695,
                266.6070417218
            ],
            [
                1.95e-9,
                5.55015549753,
                6133.5126528568
            ],
            [
                2.03e-9,
                4.65616806503,
                24072.9214697764
            ],
            [
                1.88e-9,
                2.52682282169,
                6525.8044539654
            ],
            [
                1.77e-9,
                1.73426919199,
                154717.6098876827
            ],
            [
                1.87e-9,
                4.76501318048,
                4535.0594369244
            ],
            [
                1.86e-9,
                4.63080493407,
                10440.2742926036
            ],
            [
                1.83e-9,
                3.20060840641,
                8635.9420037632
            ],
            [
                1.72e-9,
                1.45551703877,
                9225.539273283
            ],
            [
                1.62e-9,
                3.30665137166,
                639.897286314
            ],
            [
                1.68e-9,
                2.17671416605,
                27.4015560968
            ],
            [
                1.6e-9,
                1.6816871275,
                15110.4661198662
            ],
            [
                1.94e-9,
                2.79243768345,
                7342.4577801806
            ],
            [
                1.83e-9,
                0.56273524797,
                13517.8701062334
            ],
            [
                1.72e-9,
                5.97039514134,
                4701.1165017084
            ],
            [
                1.79e-9,
                3.58450811616,
                87.30820453981
            ],
            [
                1.52e-9,
                2.84070476839,
                5650.2921106782
            ],
            [
                1.56e-9,
                1.07156076421,
                18319.5365848796
            ],
            [
                1.82e-9,
                0.44053620124,
                17253.04110768959
            ],
            [
                1.42e-9,
                1.4629013752,
                11087.2851259184
            ],
            [
                1.31e-9,
                5.40912137746,
                2699.7348193176
            ],
            [
                1.44e-9,
                2.07312089638,
                25158.6017197654
            ],
            [
                1.47e-9,
                6.15107800602,
                9623.6882766912
            ],
            [
                1.41e-9,
                5.55739979498,
                10454.5013866052
            ],
            [
                1.35e-9,
                0.0609812943,
                16723.350142595
            ],
            [
                1.23e-9,
                5.81194797368,
                17256.6315363414
            ],
            [
                1.24e-9,
                2.36269386269,
                4933.2084403326
            ],
            [
                1.26e-9,
                3.47483886466,
                22483.84857449259
            ],
            [
                1.59e-9,
                5.63944722033,
                5729.506447149
            ],
            [
                1.37e-9,
                1.93811728826,
                20426.571092422
            ],
            [
                1.23e-9,
                3.92815962825,
                17996.0311682222
            ],
            [
                1.48e-9,
                3.02542567608,
                1551.045222648
            ],
            [
                1.21e-9,
                0.05537321071,
                13095.8426650774
            ],
            [
                1.2e-9,
                5.91904349732,
                6206.8097787158
            ],
            [
                1.34e-9,
                3.11122937825,
                21954.15760939799
            ],
            [
                1.19e-9,
                5.52143897201,
                709.9330485583
            ],
            [
                1.22e-9,
                3.00840036775,
                19800.9459562248
            ],
            [
                1.27e-9,
                1.37534182407,
                14945.3161735544
            ],
            [
                1.41e-9,
                2.56886299638,
                1052.2683831884
            ],
            [
                1.23e-9,
                2.83671175442,
                11919.140866668
            ],
            [
                1.18e-9,
                0.81918292547,
                5331.3574437408
            ],
            [
                1.51e-9,
                2.68728567951,
                11769.8536931664
            ],
            [
                1.19e-9,
                5.08654046247,
                5481.2549188676
            ],
            [
                1.13e-9,
                4.42675663942,
                18422.62935909819
            ],
            [
                1.53e-9,
                2.46021790779,
                11933.3679606696
            ],
            [
                1.08e-9,
                1.04936452151,
                11403.676995575
            ],
            [
                1.28e-9,
                0.99810456461,
                8827.3902698748
            ],
            [
                1.44e-9,
                2.54869747042,
                227.476132789
            ],
            [
                1.5e-9,
                4.50631437136,
                2379.1644735716
            ],
            [
                1.09e-9,
                0.29269062317,
                16737.5772365966
            ],
            [
                1.22e-9,
                4.23040027813,
                29.429508536
            ],
            [
                1.11e-9,
                5.16970710025,
                17782.7320727842
            ],
            [
                1.05e-9,
                1.61738153441,
                13119.72110282519
            ],
            [
                1e-9,
                3.52204690579,
                18052.9295431578
            ],
            [
                1.08e-9,
                1.08493117155,
                16858.4825329332
            ],
            [
                1.35e-9,
                3.2016061697,
                6262.300454499
            ],
            [
                1.06e-9,
                1.96085069786,
                74.7815985673
            ],
            [
                1.29e-9,
                4.85949366504,
                16496.3613962024
            ],
            [
                1.1e-9,
                2.30605777952,
                16460.33352952499
            ],
            [
                9.7e-10,
                3.5091894021,
                5333.9002410216
            ],
            [
                9.9e-10,
                3.56417337974,
                735.8765135318
            ],
            [
                9.6e-10,
                3.40918487598,
                15720.8387848784
            ],
            [
                9.4e-10,
                5.01601027363,
                3128.3887650958
            ],
            [
                9.7e-10,
                1.65579893894,
                533.2140834436
            ],
            [
                9.2e-10,
                0.89219199493,
                29296.6153895786
            ],
            [
                1.23e-9,
                3.16062062663,
                9380.9596727172
            ],
            [
                1.02e-9,
                1.20493500565,
                23020.65308658799
            ],
            [
                8.8e-10,
                2.21265504437,
                12721.572099417
            ],
            [
                8.9e-10,
                1.5432266957,
                20199.094959633
            ],
            [
                1.21e-9,
                6.19860353182,
                9388.0059094152
            ],
            [
                8.9e-10,
                4.08082274765,
                22805.7355659936
            ],
            [
                9.8e-10,
                1.09176668094,
                12043.574281889
            ],
            [
                8.6e-10,
                1.13649001466,
                143571.32428481648
            ],
            [
                8.8e-10,
                5.96980472191,
                107.6635239386
            ],
            [
                8.2e-10,
                5.01561173481,
                22003.9146348698
            ],
            [
                9.4e-10,
                1.69615700473,
                23006.42599258639
            ],
            [
                8.1e-10,
                3.00664741995,
                2118.7638603784
            ],
            [
                9.8e-10,
                1.39215287161,
                8662.240323563
            ],
            [
                8e-10,
                5.16340988714,
                17796.9591667858
            ],
            [
                8.2e-10,
                5.86893959287,
                2787.0430238574
            ],
            [
                7.7e-10,
                0.80723694712,
                167283.7615876655
            ],
            [
                9.1e-10,
                5.74902425304,
                21424.4666443034
            ],
            [
                7.6e-10,
                5.67183650604,
                14.2270940016
            ],
            [
                8.1e-10,
                6.16619455699,
                1039.0266107904
            ],
            [
                7.6e-10,
                3.21449884756,
                111.1866422876
            ],
            [
                7.8e-10,
                1.37531518377,
                21947.1113727
            ],
            [
                7.4e-10,
                3.58814195051,
                11609.8625440122
            ],
            [
                7.7e-10,
                4.84846488388,
                22743.4093795164
            ],
            [
                9e-10,
                1.48869013606,
                15671.0817594066
            ],
            [
                8.2e-10,
                3.48618398216,
                29088.811415985
            ],
            [
                7.1e-10,
                2.2159156119,
                12029.3471878874
            ],
            [
                6.9e-10,
                1.93625656075,
                135.62532501
            ],
            [
                7e-10,
                2.66552760898,
                18875.525869774
            ],
            [
                6.9e-10,
                5.41478093731,
                26735.9452622132
            ],
            [
                7.9e-10,
                5.15158156951,
                12323.4230960088
            ],
            [
                7.8e-10,
                4.17014063638,
                1066.49547719
            ],
            [
                6.5e-10,
                5.64584720343,
                12139.5535091068
            ],
            [
                7.1e-10,
                3.89804774037,
                22779.4372461938
            ],
            [
                6.3e-10,
                4.53968787714,
                8982.810669309
            ],
            [
                7.6e-10,
                3.29088891716,
                2942.4634232916
            ],
            [
                6.9e-10,
                0.94232113005,
                14919.0178537546
            ],
            [
                6.3e-10,
                4.0918653549,
                16062.1845261168
            ],
            [
                6.5e-10,
                3.34580407184,
                51.28033786241
            ],
            [
                6.5e-10,
                5.75757544877,
                52670.0695933026
            ],
            [
                5.7e-10,
                5.25050277534,
                20995.3929664494
            ],
            [
                6.1e-10,
                1.92290673861,
                6805.6532680852
            ],
            [
                6.1e-10,
                0.08878901558,
                13362.4497067992
            ],
            [
                7.6e-10,
                1.86947679415,
                25287.7237993998
            ],
            [
                5.6e-10,
                4.25396542622,
                6709.6740408674
            ],
            [
                5.8e-10,
                4.79429715781,
                6286.3622074092
            ],
            [
                7.3e-10,
                0.53299090807,
                2301.58581590939
            ],
            [
                7e-10,
                4.31243357502,
                19402.7969528166
            ],
            [
                6.7e-10,
                2.53852336668,
                377.3736079158
            ],
            [
                5.6e-10,
                3.20816844695,
                24889.5747959916
            ],
            [
                5.4e-10,
                5.17336469511,
                26084.0218062162
            ],
            [
                5.3e-10,
                3.17675406016,
                18451.07854656599
            ],
            [
                5.3e-10,
                3.61529270216,
                77.673770428
            ],
            [
                5.3e-10,
                0.45467549335,
                30666.1549584328
            ],
            [
                5.3e-10,
                2.97761644192,
                21548.9623692918
            ],
            [
                6.1e-10,
                0.14805728543,
                23013.5395395872
            ],
            [
                5.1e-10,
                3.32803972907,
                56.8983749356
            ],
            [
                5.2e-10,
                3.41304011355,
                23141.5583829246
            ],
            [
                5.8e-10,
                3.13638677202,
                309.2783226558
            ],
            [
                5.4e-10,
                1.60896548545,
                13341.6743113068
            ],
            [
                5.3e-10,
                5.81426394852,
                16193.65917750039
            ],
            [
                6.7e-10,
                6.27917920454,
                22345.2603761082
            ],
            [
                5e-10,
                0.42577644151,
                25685.872802808
            ],
            [
                4.8e-10,
                0.70204553352,
                1162.4747044078
            ],
            [
                6.6e-10,
                3.64350022359,
                15265.8865193004
            ],
            [
                5e-10,
                5.7438291744,
                19.66976089979
            ],
            [
                5.4e-10,
                1.97277370837,
                23581.2581773176
            ],
            [
                5.1e-10,
                1.23713196525,
                12539.853380183
            ],
            [
                4.6e-10,
                5.41431704639,
                33019.0211122046
            ],
            [
                4.6e-10,
                4.80640843261,
                19651.048481098
            ],
            [
                5e-10,
                1.23847511223,
                22476.73502749179
            ],
            [
                5.1e-10,
                4.91913434178,
                12592.4500197826
            ],
            [
                4.6e-10,
                2.41369976086,
                98068.53671630539
            ],
            [
                4.5e-10,
                3.45227074337,
                30774.5016425748
            ],
            [
                4.5e-10,
                4.39659083856,
                433.7117378768
            ],
            [
                4.5e-10,
                3.71921056816,
                18209.33026366019
            ],
            [
                4.4e-10,
                2.47683925106,
                24356.7807886416
            ],
            [
                4.9e-10,
                2.17835058609,
                13521.7514415914
            ],
            [
                4.6e-10,
                0.26142733448,
                11.0457002639
            ],
            [
                4.5e-10,
                2.46230645202,
                51868.2486621788
            ],
            [
                4.3e-10,
                4.29458463014,
                28230.18722269139
            ],
            [
                4.8e-10,
                0.89551707131,
                56600.2792895222
            ],
            [
                4.2e-10,
                3.63410684699,
                4590.910180489
            ],
            [
                4.9e-10,
                3.17757670967,
                6303.8512454838
            ],
            [
                4.3e-10,
                4.93350349236,
                10021.8372800994
            ],
            [
                5.2e-10,
                3.65410195699,
                7872.1487452752
            ],
            [
                4.1e-10,
                4.82166756935,
                10988.808157535
            ],
            [
                4e-10,
                1.81891629936,
                34596.3646546524
            ],
            [
                4.3e-10,
                1.94164978061,
                1903.4368125012
            ],
            [
                4.1e-10,
                0.74461854136,
                23937.856389741
            ],
            [
                4.5e-10,
                5.4557501753,
                60530.4889857418
            ],
            [
                5e-10,
                5.67355640472,
                18216.443810661
            ],
            [
                4e-10,
                0.04502010161,
                38526.574350872
            ],
            [
                5.3e-10,
                3.64807615995,
                11925.2740926006
            ],
            [
                4.2e-10,
                5.19292937193,
                19004.6479494084
            ],
            [
                4.1e-10,
                0.94309683296,
                9924.8104215106
            ],
            [
                3.9e-10,
                4.61184303844,
                95.9792272178
            ],
            [
                4.9e-10,
                2.05532526216,
                12573.2652469836
            ],
            [
                4.5e-10,
                3.73717824543,
                7875.6718636242
            ],
            [
                4.3e-10,
                1.14078465002,
                49.7570254718
            ],
            [
                3.9e-10,
                1.70539366023,
                32217.2001810808
            ],
            [
                3.7e-10,
                1.29390383811,
                310.8407988684
            ],
            [
                3.8e-10,
                0.9597092595,
                664.75604513
            ],
            [
                3.9e-10,
                0.85957361635,
                16522.6597160022
            ],
            [
                4e-10,
                1.00170796001,
                36949.2308084242
            ],
            [
                4e-10,
                3.78164718776,
                55798.4583583984
            ],
            [
                3.7e-10,
                5.42237070904,
                6286.6662786432
            ],
            [
                3.6e-10,
                1.68167662194,
                10344.2950653858
            ],
            [
                4e-10,
                5.13217319067,
                15664.03552270859
            ],
            [
                4.9e-10,
                3.62741283878,
                77713.7714681205
            ],
            [
                4.5e-10,
                6.15877872538,
                28286.9904848612
            ],
            [
                3.6e-10,
                3.32158458257,
                16207.886271502
            ],
            [
                3.5e-10,
                5.83917764292,
                6321.1035226272
            ],
            [
                3.6e-10,
                1.80784164083,
                6279.7894925736
            ],
            [
                3.5e-10,
                4.60279245362,
                28237.2334593894
            ],
            [
                3.3e-10,
                0.47301775923,
                18635.9284545362
            ],
            [
                3.5e-10,
                4.36571027474,
                48739.859897083
            ],
            [
                3.1e-10,
                3.06828028412,
                6819.8803620868
            ],
            [
                3.1e-10,
                2.4020319848,
                28628.3362260996
            ],
            [
                3.4e-10,
                1.90096411242,
                12964.300703391
            ],
            [
                2.9e-10,
                6.09291010354,
                18606.4989460002
            ],
            [
                2.8e-10,
                3.42046112698,
                6288.5987742988
            ],
            [
                2.8e-10,
                3.437361406,
                34115.1140692746
            ],
            [
                2.9e-10,
                1.48920816078,
                6489.2613984286
            ],
            [
                2.8e-10,
                3.07474749886,
                29822.7832363242
            ],
            [
                3.8e-10,
                2.44608264663,
                31415.379249957
            ],
            [
                2.8e-10,
                2.98392582088,
                6277.552925684
            ],
            [
                2.7e-10,
                5.03556015623,
                12779.4507954208
            ],
            [
                2.7e-10,
                5.40812977287,
                26087.9031415742
            ],
            [
                3.8e-10,
                5.56439937893,
                27832.0382192832
            ],
            [
                2.6e-10,
                3.87685883153,
                6262.7205305926
            ],
            [
                2.7e-10,
                6.1556539284,
                28759.81087748319
            ],
            [
                2.5e-10,
                5.17122153205,
                6915.8595893046
            ],
            [
                2.7e-10,
                4.03132006944,
                9910.583327509
            ],
            [
                3.3e-10,
                3.97763407373,
                12410.7313005486
            ],
            [
                2.4e-10,
                5.31307120044,
                29026.48522950779
            ],
            [
                2.5e-10,
                0.81055213297,
                36173.7081971002
            ],
            [
                2.4e-10,
                1.2870610131,
                24491.4257925834
            ],
            [
                2.1e-10,
                2.02548478742,
                28766.924424484
            ],
            [
                2.1e-10,
                6.07545114034,
                18139.2945014159
            ],
            [
                2.2e-10,
                2.31199937131,
                6303.4311693902
            ],
            [
                2.3e-10,
                1.35235057478,
                49515.382508407
            ],
            [
                2.3e-10,
                2.92765926961,
                65236.2212932854
            ],
            [
                1.9e-10,
                0.03636659763,
                29864.334027309
            ],
            [
                2e-10,
                0.91374066194,
                45585.1728121874
            ],
            [
                2.1e-10,
                4.45003013294,
                22490.9621214934
            ],
            [
                2.2e-10,
                1.97119365888,
                34513.2630726828
            ],
            [
                2e-10,
                4.11682669951,
                17157.0618804718
            ],
            [
                2.4e-10,
                1.40243942415,
                14712.317116458
            ],
            [
                2.2e-10,
                2.19759737115,
                31570.7996493912
            ],
            [
                2.1e-10,
                1.48739821208,
                61306.0115970658
            ],
            [
                2.5e-10,
                5.71465573409,
                25934.1243310894
            ]
        ],
        "2": [
            [
                0.00008721859,
                1.07253635559,
                6283.0758499914
            ],
            [
                0.0000099099,
                3.14159265359,
                0
            ],
            [
                0.00000294833,
                0.43717350256,
                12566.1516999828
            ],
            [
                2.7338e-7,
                0.05295636147,
                3.523118349
            ],
            [
                1.6333e-7,
                5.18820215724,
                26.2983197998
            ],
            [
                1.5745e-7,
                3.68504712183,
                155.4203994342
            ],
            [
                9.425e-8,
                0.29667114694,
                18849.2275499742
            ],
            [
                8.938e-8,
                2.05706319592,
                77713.7714681205
            ],
            [
                6.94e-8,
                0.82691541038,
                775.522611324
            ],
            [
                5.061e-8,
                4.6624323168,
                1577.3435424478
            ],
            [
                4.06e-8,
                1.03067032318,
                7.1135470008
            ],
            [
                3.464e-8,
                5.14021224609,
                796.2980068164
            ],
            [
                3.172e-8,
                6.05479318507,
                5507.5532386674
            ],
            [
                3.02e-8,
                1.19240008524,
                242.728603974
            ],
            [
                2.885e-8,
                6.11705865396,
                529.6909650946
            ],
            [
                3.809e-8,
                3.44043369494,
                5573.1428014331
            ],
            [
                2.719e-8,
                0.30363248164,
                398.1490034082
            ],
            [
                2.365e-8,
                4.37666117992,
                5223.6939198022
            ],
            [
                2.538e-8,
                2.27966434314,
                553.5694028424
            ],
            [
                2.078e-8,
                3.75435095487,
                0.9803210682
            ],
            [
                1.675e-8,
                0.90149951436,
                951.7184062506
            ],
            [
                1.534e-8,
                5.75895831192,
                1349.8674096588
            ],
            [
                1.224e-8,
                2.97285792195,
                2146.1654164752
            ],
            [
                1.449e-8,
                4.36401639552,
                1748.016413067
            ],
            [
                1.341e-8,
                3.72019379666,
                1194.4470102246
            ],
            [
                1.253e-8,
                2.9488872631,
                6438.4962494256
            ],
            [
                9.99e-9,
                5.98665341008,
                6286.5989683404
            ],
            [
                9.17e-9,
                4.79722195184,
                5088.6288397668
            ],
            [
                8.29e-9,
                3.31021398862,
                213.299095438
            ],
            [
                1.102e-8,
                1.27094359244,
                161000.6857376741
            ],
            [
                7.64e-9,
                3.41231607038,
                5486.777843175
            ],
            [
                1.046e-8,
                0.60374190029,
                3154.6870848956
            ],
            [
                8.87e-9,
                5.23364022595,
                7084.8967811152
            ],
            [
                6.44e-9,
                1.59974355582,
                2544.3144198834
            ],
            [
                6.81e-9,
                3.42742947469,
                4694.0029547076
            ],
            [
                6.06e-9,
                2.47688996663,
                10977.078804699
            ],
            [
                7.06e-9,
                6.19369692903,
                4690.4798363586
            ],
            [
                6.43e-9,
                1.98119869589,
                801.8209311238
            ],
            [
                5.02e-9,
                1.44415463861,
                6836.6452528338
            ],
            [
                4.9e-9,
                2.33889753806,
                1592.5960136328
            ],
            [
                4.58e-9,
                1.30867922972,
                4292.3308329504
            ],
            [
                4.31e-9,
                0.03542536476,
                7234.794256242
            ],
            [
                3.49e-9,
                0.98779272263,
                6040.3472460174
            ],
            [
                3.85e-9,
                1.57065592218,
                71430.69561812909
            ],
            [
                3.71e-9,
                3.16149051601,
                6309.3741697912
            ],
            [
                3.48e-9,
                0.64980950594,
                1059.3819301892
            ],
            [
                4.58e-9,
                3.81505682017,
                149854.4001348079
            ],
            [
                3.02e-9,
                1.91723873447,
                10447.3878396044
            ],
            [
                3.06e-9,
                3.55405857884,
                8031.0922630584
            ],
            [
                3.95e-9,
                4.93742673052,
                7632.9432596502
            ],
            [
                3.14e-9,
                3.18058352846,
                2352.8661537718
            ],
            [
                2.81e-9,
                4.41751404023,
                9437.762934887
            ],
            [
                2.76e-9,
                2.71075791682,
                3894.1818295422
            ],
            [
                2.98e-9,
                2.52045757001,
                6127.6554505572
            ],
            [
                2.72e-9,
                0.24370191144,
                25132.3033999656
            ],
            [
                2.51e-9,
                0.55449375765,
                6279.5527316424
            ],
            [
                2.24e-9,
                1.40790249012,
                4705.7323075436
            ],
            [
                2.58e-9,
                5.29510765044,
                6812.766815086
            ],
            [
                1.78e-9,
                0.92636669742,
                1990.745017041
            ],
            [
                2.17e-9,
                0.68543630022,
                6256.7775301916
            ],
            [
                1.54e-9,
                0.77808632062,
                14143.4952424306
            ],
            [
                1.5e-9,
                2.40636982736,
                426.598190876
            ],
            [
                1.96e-9,
                6.06877865012,
                640.8776073822
            ],
            [
                1.37e-9,
                2.21947617717,
                8429.2412664666
            ],
            [
                1.27e-9,
                5.47380312768,
                12036.4607348882
            ],
            [
                1.21e-9,
                3.32740512021,
                17789.845619785
            ],
            [
                1.23e-9,
                2.16004509785,
                10213.285546211
            ],
            [
                1.16e-9,
                0.49705139709,
                7058.5984613154
            ],
            [
                1.38e-9,
                2.36181661472,
                11506.7697697936
            ],
            [
                1.01e-9,
                0.86299995919,
                6290.1893969922
            ],
            [
                1.18e-9,
                5.82317768355,
                7860.4193924392
            ],
            [
                9.2e-10,
                5.11639978593,
                7079.3738568078
            ],
            [
                1.25e-9,
                2.65424538513,
                88860.05707098669
            ],
            [
                8.8e-10,
                4.3118823616,
                83996.84731811189
            ],
            [
                8.4e-10,
                3.57682769713,
                16730.4636895958
            ],
            [
                9.7e-10,
                5.58011309774,
                13367.9726311066
            ],
            [
                1.02e-9,
                2.05853060226,
                87.30820453981
            ],
            [
                8e-10,
                4.73827128421,
                11926.2544136688
            ],
            [
                8e-10,
                5.41344057121,
                10973.55568635
            ],
            [
                1.06e-9,
                4.10978997399,
                3496.032826134
            ],
            [
                7.5e-10,
                4.89166898876,
                5643.1785636774
            ],
            [
                1e-9,
                3.62645659087,
                244287.60000722768
            ],
            [
                9.6e-10,
                1.39443577787,
                6681.2248533996
            ],
            [
                6.9e-10,
                1.88399189965,
                10177.2576795336
            ],
            [
                8.7e-10,
                0.40842153208,
                11015.1064773348
            ],
            [
                6.6e-10,
                0.99444831932,
                6525.8044539654
            ],
            [
                6.6e-10,
                1.42471816453,
                9917.6968745098
            ],
            [
                6.7e-10,
                5.5124099707,
                3097.88382272579
            ],
            [
                7.6e-10,
                2.7156469351,
                4164.311989613
            ],
            [
                8.5e-10,
                0.4965552367,
                10575.4066829418
            ],
            [
                7.7e-10,
                3.51693861509,
                11856.2186514245
            ],
            [
                6.2e-10,
                3.6258762869,
                16496.3613962024
            ],
            [
                5.4e-10,
                5.25957420065,
                3340.6124266998
            ],
            [
                5.3e-10,
                1.10902178415,
                8635.9420037632
            ],
            [
                4.9e-10,
                5.65761054625,
                20426.571092422
            ],
            [
                6.4e-10,
                5.79211164779,
                2388.8940204492
            ],
            [
                4.6e-10,
                5.45092696155,
                6275.9623029906
            ],
            [
                5.7e-10,
                4.97077155798,
                14945.3161735544
            ],
            [
                4.3e-10,
                3.30685683359,
                9779.1086761254
            ],
            [
                4.2e-10,
                1.61412785248,
                12168.0026965746
            ],
            [
                4.9e-10,
                3.92715473768,
                5729.506447149
            ],
            [
                4.2e-10,
                0.6348125893,
                2699.7348193176
            ],
            [
                5.6e-10,
                4.34038639086,
                90955.5516944961
            ],
            [
                4e-10,
                5.66871428338,
                11712.9553182308
            ],
            [
                3.9e-10,
                3.10911294009,
                16200.7727245012
            ],
            [
                4e-10,
                5.71338386146,
                709.9330485583
            ],
            [
                5.3e-10,
                6.17067257683,
                233141.3144043615
            ],
            [
                3.7e-10,
                0.32095173508,
                24356.7807886416
            ],
            [
                3.5e-10,
                0.95557073457,
                17298.1823273262
            ],
            [
                3.5e-10,
                0.64913397996,
                25158.6017197654
            ],
            [
                4.1e-10,
                1.53850422484,
                65147.6197681377
            ],
            [
                3.5e-10,
                0.77655626359,
                13916.0191096416
            ],
            [
                3.1e-10,
                5.35897350775,
                5331.3574437408
            ],
            [
                3e-10,
                4.48114682755,
                23543.23050468179
            ],
            [
                3.2e-10,
                3.45976963453,
                7477.522860216
            ],
            [
                2.9e-10,
                3.46648040769,
                13119.72110282519
            ],
            [
                3.8e-10,
                2.90863974625,
                12721.572099417
            ],
            [
                2.9e-10,
                3.13390968321,
                4136.9104335162
            ],
            [
                3.5e-10,
                3.79717126309,
                143571.32428481648
            ],
            [
                2.7e-10,
                0.95726093828,
                12559.038152982
            ],
            [
                2.6e-10,
                4.9532687703,
                5753.3848848968
            ],
            [
                3.2e-10,
                3.49943896928,
                6284.0561710596
            ],
            [
                2.6e-10,
                4.59276256636,
                5884.9268465832
            ],
            [
                2.6e-10,
                1.53958920253,
                154717.6098876827
            ],
            [
                2.3e-10,
                4.88012908735,
                13095.8426650774
            ],
            [
                2.3e-10,
                0.35935706511,
                31415.379249957
            ],
            [
                2.4e-10,
                5.11515116629,
                18319.5365848796
            ],
            [
                2.1e-10,
                5.73872879912,
                12569.6748183318
            ],
            [
                2.1e-10,
                1.32901200081,
                10988.808157535
            ],
            [
                1.9e-10,
                2.24263229491,
                18073.7049386502
            ],
            [
                1.9e-10,
                3.14253175605,
                6496.3749454294
            ],
            [
                2.1e-10,
                2.80122025076,
                6282.0955289232
            ],
            [
                2.3e-10,
                0.14288760398,
                6283.0085396886
            ],
            [
                1.9e-10,
                4.28209473754,
                3930.2096962196
            ],
            [
                1.6e-10,
                0.25933207663,
                11790.6290886588
            ],
            [
                1.5e-10,
                6.0962350124,
                13517.8701062334
            ],
            [
                2e-10,
                5.06358906224,
                6283.14316029419
            ],
            [
                1.5e-10,
                1.0768066315,
                4933.2084403326
            ],
            [
                1.9e-10,
                5.74000581249,
                3128.3887650958
            ],
            [
                1.6e-10,
                6.18924226747,
                7342.4577801806
            ],
            [
                1.3e-10,
                1.69105044945,
                4535.0594369244
            ],
            [
                1.5e-10,
                3.36968394452,
                17260.1546546904
            ],
            [
                1e-10,
                3.78885035015,
                22003.9146348698
            ],
            [
                1.1e-10,
                2.12851973876,
                7875.6718636242
            ]
        ],
        "3": [
            [
                0.00000289058,
                5.84173149732,
                6283.0758499914
            ],
            [
                2.0712e-7,
                6.0498393902,
                12566.1516999828
            ],
            [
                2.962e-8,
                5.1956057957,
                155.4203994342
            ],
            [
                2.527e-8,
                3.14159265359,
                0
            ],
            [
                1.288e-8,
                4.7219761197,
                3.523118349
            ],
            [
                6.35e-9,
                5.96904899168,
                242.728603974
            ],
            [
                5.7e-9,
                5.54182903238,
                18849.2275499742
            ],
            [
                4.02e-9,
                3.78606612895,
                553.5694028424
            ],
            [
                7.2e-10,
                4.37131884946,
                6286.5989683404
            ],
            [
                6.7e-10,
                0.91133898967,
                6127.6554505572
            ],
            [
                3.7e-10,
                5.28611190997,
                6438.4962494256
            ],
            [
                2.1e-10,
                2.94917211527,
                6309.3741697912
            ],
            [
                1.5e-10,
                3.63037493932,
                71430.69561812909
            ],
            [
                1.1e-10,
                4.83261533939,
                25132.3033999656
            ],
            [
                1.1e-10,
                5.84259014283,
                6525.8044539654
            ],
            [
                1.2e-10,
                3.82296977522,
                7058.5984613154
            ],
            [
                1.3e-10,
                2.39991715131,
                5729.506447149
            ],
            [
                8e-11,
                0.55390332094,
                6040.3472460174
            ],
            [
                8e-11,
                1.46298993048,
                11856.2186514245
            ],
            [
                8e-11,
                5.07535888338,
                6256.7775301916
            ],
            [
                6e-11,
                2.88803526743,
                5507.5532386674
            ],
            [
                5e-11,
                3.87019253131,
                12036.4607348882
            ],
            [
                5e-11,
                2.70838853362,
                83996.84731811189
            ]
        ],
        "4": [
            [
                7.714e-8,
                4.14117321449,
                6283.0758499914
            ],
            [
                1.016e-8,
                3.27573644241,
                12566.1516999828
            ],
            [
                4.2e-9,
                0.41892851415,
                155.4203994342
            ],
            [
                4.7e-10,
                3.50591071186,
                18849.2275499742
            ],
            [
                4.1e-10,
                3.14032562331,
                3.523118349
            ],
            [
                3.5e-10,
                5.0111077,
                5573.1428014331
            ],
            [
                1e-10,
                5.64816633449,
                6127.6554505572
            ],
            [
                1.3e-10,
                0.48609240774,
                77713.7714681205
            ],
            [
                7e-11,
                2.84139222289,
                161000.6857376741
            ],
            [
                4e-11,
                3.6550904707,
                25132.3033999656
            ],
            [
                2e-11,
                0.54880603487,
                6438.4962494256
            ]
        ],
        "5": [
            [
                1.72e-9,
                2.74854172392,
                6283.0758499914
            ],
            [
                5e-10,
                2.01352986713,
                155.4203994342
            ],
            [
                2.8e-10,
                2.93369985477,
                12566.1516999828
            ],
            [
                5e-11,
                1.93829214518,
                18849.2275499742
            ]
        ]
    },
    B: {
        "0": [
            [
                0.0000027962,
                3.19870156017,
                84334.66158130829
            ],
            [
                0.00000101643,
                5.42248619256,
                5507.5532386674
            ],
            [
                8.0445e-7,
                3.88013204458,
                5223.6939198022
            ],
            [
                4.3806e-7,
                3.70444689759,
                2352.8661537718
            ],
            [
                3.1933e-7,
                4.00026369781,
                1577.3435424478
            ],
            [
                2.2724e-7,
                3.9847383156,
                1047.7473117547
            ],
            [
                1.6392e-7,
                3.56456119782,
                5856.4776591154
            ],
            [
                1.8141e-7,
                4.98367470262,
                6283.0758499914
            ],
            [
                1.4443e-7,
                3.70275614915,
                9437.762934887
            ],
            [
                1.4304e-7,
                3.41117857526,
                10213.285546211
            ],
            [
                1.1246e-7,
                4.82820690527,
                14143.4952424306
            ],
            [
                1.09e-7,
                2.08574562329,
                6812.766815086
            ],
            [
                9.714e-8,
                3.47303947751,
                4694.0029547076
            ],
            [
                1.0367e-7,
                4.05663927945,
                71092.88135493269
            ],
            [
                8.775e-8,
                4.44016515666,
                5753.3848848968
            ],
            [
                8.366e-8,
                4.99251512183,
                7084.8967811152
            ],
            [
                6.921e-8,
                4.32559054073,
                6275.9623029906
            ],
            [
                9.145e-8,
                1.14182646613,
                6620.8901131878
            ],
            [
                7.194e-8,
                3.60193205744,
                529.6909650946
            ],
            [
                7.698e-8,
                5.55425745881,
                167621.5758508619
            ],
            [
                5.285e-8,
                2.48446991536,
                4705.7323075436
            ],
            [
                5.208e-8,
                6.24992674532,
                18073.7049386502
            ],
            [
                4.529e-8,
                2.33827747356,
                6309.3741697912
            ],
            [
                5.579e-8,
                4.41023653719,
                7860.4193924392
            ],
            [
                4.743e-8,
                0.70995680136,
                5884.9268465832
            ],
            [
                4.301e-8,
                1.10255777773,
                6681.2248533996
            ],
            [
                3.849e-8,
                1.82229412532,
                5486.777843175
            ],
            [
                4.093e-8,
                5.11700141197,
                13367.9726311066
            ],
            [
                3.681e-8,
                0.43793170336,
                3154.6870848956
            ],
            [
                3.42e-8,
                5.42034800952,
                6069.7767545534
            ],
            [
                3.617e-8,
                6.04641937568,
                3930.2096962196
            ],
            [
                3.67e-8,
                4.58210192227,
                12194.0329146209
            ],
            [
                2.918e-8,
                1.95463881136,
                10977.078804699
            ],
            [
                2.797e-8,
                5.61259274877,
                11790.6290886588
            ],
            [
                2.502e-8,
                0.60499729368,
                6496.3749454294
            ],
            [
                2.319e-8,
                5.01648216088,
                1059.3819301892
            ],
            [
                2.684e-8,
                1.39470396487,
                22003.9146348698
            ],
            [
                2.428e-8,
                3.24183056545,
                78051.5857313169
            ],
            [
                2.12e-8,
                4.30691000285,
                5643.1785636774
            ],
            [
                2.257e-8,
                3.15557225087,
                90617.7374312997
            ],
            [
                1.813e-8,
                3.75574218286,
                3340.6124266998
            ],
            [
                2.226e-8,
                2.79699346673,
                12036.4607348882
            ],
            [
                1.888e-8,
                0.86991545944,
                8635.9420037632
            ],
            [
                1.517e-8,
                1.9585205571,
                398.1490034082
            ],
            [
                1.581e-8,
                3.19976230948,
                5088.6288397668
            ],
            [
                1.421e-8,
                6.25530883828,
                2544.3144198834
            ],
            [
                1.595e-8,
                0.25619915132,
                17298.1823273262
            ],
            [
                1.391e-8,
                4.69964175574,
                7058.5984613154
            ],
            [
                1.478e-8,
                2.81808207569,
                25934.1243310894
            ],
            [
                1.481e-8,
                3.6582355461,
                11506.7697697936
            ],
            [
                1.693e-8,
                4.95689385293,
                156475.2902479957
            ],
            [
                1.183e-8,
                1.29343060777,
                775.522611324
            ],
            [
                1.114e-8,
                2.37889311847,
                3738.761430108
            ],
            [
                9.94e-9,
                4.30088900425,
                9225.539273283
            ],
            [
                9.24e-9,
                3.06451026809,
                4164.311989613
            ],
            [
                8.67e-9,
                0.55606931068,
                8429.2412664666
            ],
            [
                9.88e-9,
                5.97286104208,
                7079.3738568078
            ],
            [
                8.24e-9,
                1.50984806177,
                10447.3878396044
            ],
            [
                9.15e-9,
                0.12635654605,
                11015.1064773348
            ],
            [
                7.42e-9,
                1.99159139281,
                26087.9031415742
            ],
            [
                1.039e-8,
                3.14159265359,
                0
            ],
            [
                8.5e-9,
                4.24120016095,
                29864.334027309
            ],
            [
                7.55e-9,
                2.89631873314,
                4732.0306273434
            ],
            [
                7.14e-9,
                1.37548118605,
                2146.1654164752
            ],
            [
                7.08e-9,
                1.91406542362,
                8031.0922630584
            ],
            [
                7.46e-9,
                0.57893808622,
                796.2980068164
            ],
            [
                8.02e-9,
                5.12339137235,
                2942.4634232916
            ],
            [
                7.51e-9,
                1.67479850166,
                21228.3920235458
            ],
            [
                6.02e-9,
                4.099765389,
                64809.80550494129
            ],
            [
                5.94e-9,
                3.49580704849,
                16496.3613962024
            ],
            [
                5.92e-9,
                4.59481504319,
                4690.4798363586
            ],
            [
                5.3e-9,
                5.73979295194,
                8827.3902698748
            ],
            [
                5.03e-9,
                5.66433137112,
                33794.5437235286
            ],
            [
                4.83e-9,
                1.57106522322,
                801.8209311238
            ],
            [
                4.38e-9,
                0.0670773372,
                3128.3887650958
            ],
            [
                4.23e-9,
                2.86944596145,
                12566.1516999828
            ],
            [
                5.04e-9,
                3.2620766916,
                7632.9432596502
            ],
            [
                5.52e-9,
                1.02926440457,
                239762.20451754928
            ],
            [
                4.27e-9,
                3.67434378208,
                213.299095438
            ],
            [
                4.04e-9,
                1.4619329736,
                15720.8387848784
            ],
            [
                5.03e-9,
                4.85802444134,
                6290.1893969922
            ],
            [
                4.17e-9,
                0.81920713533,
                5216.5803728014
            ],
            [
                3.65e-9,
                0.01002966145,
                12168.0026965746
            ],
            [
                3.63e-9,
                1.28376436579,
                6206.8097787158
            ],
            [
                3.53e-9,
                4.7005913311,
                7234.794256242
            ],
            [
                4.15e-9,
                0.96862624176,
                4136.9104335162
            ],
            [
                3.87e-9,
                3.09145061418,
                25158.6017197654
            ],
            [
                3.73e-9,
                2.65119262808,
                7342.4577801806
            ],
            [
                3.61e-9,
                2.97762937735,
                9623.6882766912
            ],
            [
                4.18e-9,
                3.75759994446,
                5230.807466803
            ],
            [
                3.96e-9,
                1.22507712354,
                6438.4962494256
            ],
            [
                3.22e-9,
                1.21162178805,
                8662.240323563
            ],
            [
                2.84e-9,
                5.64170320179,
                1589.0728952838
            ],
            [
                3.79e-9,
                1.72248432756,
                14945.3161735544
            ],
            [
                3.2e-9,
                3.94161159658,
                7330.8231617461
            ],
            [
                3.13e-9,
                5.47602376451,
                1194.4470102246
            ],
            [
                2.92e-9,
                1.38971327568,
                11769.8536931664
            ],
            [
                3.05e-9,
                0.80429352049,
                37724.7534197482
            ],
            [
                2.57e-9,
                5.81382810029,
                426.598190876
            ],
            [
                2.65e-9,
                6.10358507671,
                6836.6452528338
            ],
            [
                2.5e-9,
                4.56452895547,
                7477.522860216
            ],
            [
                2.66e-9,
                2.62926282354,
                7238.6755916
            ],
            [
                2.63e-9,
                6.22089501237,
                6133.5126528568
            ],
            [
                3.06e-9,
                2.79682380532,
                1748.016413067
            ],
            [
                2.36e-9,
                2.46093023707,
                11371.7046897582
            ],
            [
                3.16e-9,
                1.62662805006,
                250908.4901204155
            ],
            [
                2.16e-9,
                3.68721275185,
                5849.3641121146
            ],
            [
                2.3e-9,
                0.36165162947,
                5863.5912061162
            ],
            [
                2.33e-9,
                5.03509933618,
                20426.571092422
            ],
            [
                2e-9,
                5.86073159059,
                4535.0594369244
            ],
            [
                2.77e-9,
                4.65400292395,
                82239.1669577989
            ],
            [
                2.09e-9,
                3.72323200803,
                10973.55568635
            ],
            [
                1.99e-9,
                5.05186622555,
                5429.8794682394
            ],
            [
                2.56e-9,
                2.40923279886,
                19651.048481098
            ],
            [
                2.1e-9,
                4.50691909144,
                29088.811415985
            ],
            [
                1.81e-9,
                6.00294783127,
                4292.3308329504
            ],
            [
                2.49e-9,
                0.12900984422,
                154379.7956244863
            ],
            [
                2.09e-9,
                3.87759458541,
                17789.845619785
            ],
            [
                2.25e-9,
                3.18339652605,
                18875.525869774
            ],
            [
                1.91e-9,
                4.53897489216,
                18477.1087646123
            ],
            [
                1.72e-9,
                2.0969418273,
                13095.8426650774
            ],
            [
                1.82e-9,
                3.16107943487,
                16730.4636895958
            ],
            [
                1.88e-9,
                2.22746128596,
                41654.9631159678
            ],
            [
                1.64e-9,
                5.18686274999,
                5481.2549188676
            ],
            [
                1.6e-9,
                2.4929885502,
                12592.4500197826
            ],
            [
                1.55e-9,
                1.59595438224,
                10021.8372800994
            ],
            [
                1.35e-9,
                0.21349051305,
                10988.808157535
            ],
            [
                1.78e-9,
                3.80375178044,
                23581.2581773176
            ],
            [
                1.23e-9,
                1.66800739151,
                15110.4661198662
            ],
            [
                1.22e-9,
                2.72678272224,
                18849.2275499742
            ],
            [
                1.26e-9,
                1.17675512872,
                14919.0178537546
            ],
            [
                1.42e-9,
                3.95053440992,
                337.8142631964
            ],
            [
                1.16e-9,
                6.06340906212,
                6709.6740408674
            ],
            [
                1.37e-9,
                3.52143246244,
                12139.5535091068
            ],
            [
                1.36e-9,
                2.92179113491,
                32217.2001810808
            ],
            [
                1.1e-9,
                3.51203379263,
                18052.9295431578
            ],
            [
                1.47e-9,
                4.63371971408,
                22805.7355659936
            ],
            [
                1.08e-9,
                5.45280815225,
                7.1135470008
            ],
            [
                1.48e-9,
                0.65447253687,
                95480.9471841745
            ],
            [
                1.19e-9,
                5.92110458985,
                33019.0211122046
            ],
            [
                1.1e-9,
                5.34824206403,
                639.897286314
            ],
            [
                1.06e-9,
                3.71081682614,
                14314.1681130498
            ],
            [
                1.39e-9,
                6.17607198262,
                24356.7807886416
            ],
            [
                1.18e-9,
                5.59738712949,
                161338.5000008705
            ],
            [
                1.17e-9,
                3.6506527164,
                45585.1728121874
            ],
            [
                1.27e-9,
                4.74596574209,
                49515.382508407
            ],
            [
                1.2e-9,
                1.04211499785,
                6915.8595893046
            ],
            [
                1.2e-9,
                5.60638811846,
                5650.2921106782
            ],
            [
                1.15e-9,
                3.10668213303,
                14712.317116458
            ],
            [
                9.9e-10,
                0.6901893993,
                12779.4507954208
            ],
            [
                9.7e-10,
                1.07908724794,
                9917.6968745098
            ],
            [
                9.3e-10,
                2.62295197146,
                17260.1546546904
            ],
            [
                9.9e-10,
                4.45774681732,
                4933.2084403326
            ],
            [
                1.23e-9,
                1.37488921994,
                28286.9904848612
            ],
            [
                1.21e-9,
                5.19767249869,
                27511.4678735372
            ],
            [
                1.05e-9,
                0.87192268229,
                77375.95720492408
            ],
            [
                8.7e-10,
                3.9363781295,
                17654.7805397496
            ],
            [
                1.22e-9,
                2.2395606868,
                83997.09113559539
            ],
            [
                8.7e-10,
                4.18201600921,
                22779.4372461938
            ],
            [
                1.04e-9,
                4.59580877285,
                1349.8674096588
            ],
            [
                1.02e-9,
                2.83545248595,
                12352.8526045448
            ],
            [
                1.02e-9,
                3.97386522171,
                10818.1352869158
            ],
            [
                1.01e-9,
                4.32892825818,
                36147.4098773004
            ],
            [
                9.4e-10,
                5.00001709338,
                150192.2143980043
            ],
            [
                7.7e-10,
                3.971993693,
                1592.5960136328
            ],
            [
                1e-9,
                6.07733097102,
                26735.9452622132
            ],
            [
                8.6e-10,
                5.2602963825,
                28313.288804661
            ],
            [
                9.3e-10,
                4.31900620254,
                44809.6502008634
            ],
            [
                7.6e-10,
                6.22743405935,
                13521.7514415914
            ],
            [
                7.2e-10,
                1.55820597747,
                6256.7775301916
            ],
            [
                8.2e-10,
                4.95202664555,
                10575.4066829418
            ],
            [
                8.2e-10,
                1.69647647075,
                1990.745017041
            ],
            [
                7.5e-10,
                2.29836095644,
                3634.6210245184
            ],
            [
                7.5e-10,
                2.66367876557,
                16200.7727245012
            ],
            [
                8.7e-10,
                0.26630214764,
                31441.6775697568
            ],
            [
                7.7e-10,
                2.25530952876,
                5235.3285382367
            ],
            [
                7.6e-10,
                1.09869730334,
                12903.9659631792
            ],
            [
                5.8e-10,
                4.28246137794,
                12559.038152982
            ],
            [
                6.4e-10,
                5.51112829602,
                173904.65170085328
            ],
            [
                5.6e-10,
                2.60133794851,
                73188.3759784421
            ],
            [
                5.5e-10,
                5.81483150022,
                143233.51002162008
            ],
            [
                5.4e-10,
                3.38482031504,
                323049.11878710287
            ],
            [
                3.9e-10,
                3.28500401937,
                71768.50988132549
            ],
            [
                3.9e-10,
                3.11239910096,
                96900.81328129109
            ]
        ],
        "1": [
            [
                0.00227777722,
                3.4137662053,
                6283.0758499914
            ],
            [
                0.00003805678,
                3.37063423795,
                12566.1516999828
            ],
            [
                0.00003619589,
                0,
                0
            ],
            [
                7.1542e-7,
                3.32777549735,
                18849.2275499742
            ],
            [
                7.655e-8,
                1.79489607186,
                5223.6939198022
            ],
            [
                8.107e-8,
                3.89190403643,
                5507.5532386674
            ],
            [
                6.456e-8,
                5.1978942475,
                2352.8661537718
            ],
            [
                3.894e-8,
                2.15568517178,
                6279.5527316424
            ],
            [
                3.892e-8,
                1.53021064904,
                6286.5989683404
            ],
            [
                3.897e-8,
                4.87293945629,
                10213.285546211
            ],
            [
                3.812e-8,
                1.43523182316,
                12036.4607348882
            ],
            [
                3.577e-8,
                2.32913869227,
                83996.84731811189
            ],
            [
                3.57e-8,
                4.92637739003,
                71430.69561812909
            ],
            [
                3.494e-8,
                2.20864641831,
                529.6909650946
            ],
            [
                2.421e-8,
                6.22876183393,
                7860.4193924392
            ],
            [
                2.056e-8,
                3.06747139741,
                14143.4952424306
            ],
            [
                1.399e-8,
                0.50107877909,
                6309.3741697912
            ],
            [
                1.417e-8,
                3.28454570977,
                25132.3033999656
            ],
            [
                1.544e-8,
                1.82062047625,
                5856.4776591154
            ],
            [
                1.457e-8,
                1.75339303307,
                5884.9268465832
            ],
            [
                1.497e-8,
                2.19673914456,
                9437.762934887
            ],
            [
                1.549e-8,
                5.73650061398,
                17789.845619785
            ],
            [
                1.277e-8,
                3.9672171733,
                4705.7323075436
            ],
            [
                1.038e-8,
                2.9481870117,
                6256.7775301916
            ],
            [
                1.018e-8,
                2.24114547164,
                6681.2248533996
            ],
            [
                1.021e-8,
                1.4679502613,
                11790.6290886588
            ],
            [
                9.16e-9,
                3.72965830745,
                1059.3819301892
            ],
            [
                1.156e-8,
                6.04591336669,
                398.1490034082
            ],
            [
                1.24e-8,
                0.77195902957,
                6812.766815086
            ],
            [
                1.115e-8,
                3.92255876225,
                12168.0026965746
            ],
            [
                9.08e-9,
                1.78447918237,
                3930.2096962196
            ],
            [
                8.33e-9,
                0.09941579828,
                11506.7697697936
            ],
            [
                7.9e-9,
                2.45555993228,
                775.522611324
            ],
            [
                6.66e-9,
                4.40761401665,
                5753.3848848968
            ],
            [
                5.2e-9,
                1.60179602491,
                4694.0029547076
            ],
            [
                3.82e-9,
                0.26754532042,
                1577.3435424478
            ],
            [
                4.05e-9,
                1.97558286872,
                6283.0085396886
            ],
            [
                4.05e-9,
                1.53147989887,
                6283.14316029419
            ],
            [
                3.88e-9,
                2.59563818411,
                7058.5984613154
            ],
            [
                3.41e-9,
                3.61275156842,
                13367.9726311066
            ],
            [
                2.8e-9,
                4.63052251735,
                796.2980068164
            ],
            [
                2.76e-9,
                0.43350778219,
                7079.3738568078
            ],
            [
                3.11e-9,
                5.28219636656,
                17260.1546546904
            ],
            [
                2.75e-9,
                5.27597553634,
                11769.8536931664
            ],
            [
                2.86e-9,
                2.98639716345,
                6275.9623029906
            ],
            [
                2.51e-9,
                2.81315684448,
                6290.1893969922
            ],
            [
                2.39e-9,
                5.77837903893,
                10977.078804699
            ],
            [
                2.28e-9,
                0.14375973844,
                3738.761430108
            ],
            [
                2.27e-9,
                2.51020991853,
                7084.8967811152
            ],
            [
                2.11e-9,
                4.7202946547,
                6496.3749454294
            ],
            [
                2.34e-9,
                3.1153527401,
                709.9330485583
            ],
            [
                2.34e-9,
                0.5707581762,
                11856.2186514245
            ],
            [
                2.37e-9,
                2.38791907394,
                213.299095438
            ],
            [
                2.27e-9,
                1.12059781634,
                12352.8526045448
            ],
            [
                1.69e-9,
                3.20148089605,
                5486.777843175
            ],
            [
                1.59e-9,
                3.14604135756,
                8827.3902698748
            ],
            [
                1.6e-9,
                1.14784478002,
                5643.1785636774
            ],
            [
                1.44e-9,
                5.23285657431,
                78051.5857313169
            ],
            [
                1.44e-9,
                1.16454654602,
                90617.7374312997
            ],
            [
                1.44e-9,
                3.81203756929,
                6262.300454499
            ],
            [
                1.43e-9,
                5.97809021355,
                6303.8512454838
            ],
            [
                1.38e-9,
                4.29829933273,
                1589.0728952838
            ],
            [
                1.61e-9,
                3.03298851492,
                20426.571092422
            ],
            [
                1.65e-9,
                5.09134896587,
                17298.1823273262
            ],
            [
                1.28e-9,
                4.41590143012,
                6127.6554505572
            ],
            [
                1.58e-9,
                2.00984506334,
                5230.807466803
            ],
            [
                1.3e-9,
                1.44170683802,
                12569.6748183318
            ],
            [
                1.25e-9,
                1.69950379498,
                3128.3887650958
            ],
            [
                1.52e-9,
                4.96946111415,
                65147.6197681377
            ],
            [
                1.31e-9,
                4.24961399629,
                6282.0955289232
            ],
            [
                1.31e-9,
                5.54051222995,
                6284.0561710596
            ],
            [
                1.61e-9,
                3.32421999691,
                6283.3196674749
            ],
            [
                1.23e-9,
                2.93221463795,
                15720.8387848784
            ],
            [
                1.52e-9,
                1.56488157456,
                18319.5365848796
            ],
            [
                1.14e-9,
                1.89110005546,
                18073.7049386502
            ],
            [
                1.13e-9,
                4.95214866677,
                4136.9104335162
            ],
            [
                1.11e-9,
                4.79699611405,
                8429.2412664666
            ],
            [
                1.18e-9,
                3.06184958762,
                22003.9146348698
            ],
            [
                1.28e-9,
                2.09693027395,
                12562.6285816338
            ],
            [
                1.38e-9,
                0.84648544836,
                6069.7767545534
            ],
            [
                1e-9,
                0.41938790104,
                5481.2549188676
            ],
            [
                1.01e-9,
                4.43791289246,
                19651.048481098
            ],
            [
                1.16e-9,
                1.87002428935,
                77713.7714681205
            ],
            [
                9.5e-10,
                0.68638183645,
                3340.6124266998
            ],
            [
                1.04e-9,
                4.90822646457,
                8635.9420037632
            ],
            [
                1.14e-9,
                0.36008214928,
                23543.23050468179
            ],
            [
                9.1e-10,
                1.1761121931,
                9225.539273283
            ],
            [
                9.1e-10,
                2.74682631104,
                5216.5803728014
            ],
            [
                8.6e-10,
                3.09315282195,
                1194.4470102246
            ],
            [
                9.3e-10,
                6.2764351319,
                12559.038152982
            ],
            [
                8.7e-10,
                3.64926989547,
                7.1135470008
            ],
            [
                8.3e-10,
                0.37008971174,
                11371.7046897582
            ],
            [
                9.8e-10,
                4.68473306376,
                167283.7615876655
            ],
            [
                9.8e-10,
                0.99865886857,
                154717.6098876827
            ],
            [
                8.6e-10,
                4.41152307486,
                25934.1243310894
            ],
            [
                9.8e-10,
                4.98209568932,
                16496.3613962024
            ],
            [
                8.5e-10,
                2.35438163823,
                3154.6870848956
            ],
            [
                8.3e-10,
                0.24859477658,
                21228.3920235458
            ],
            [
                7.6e-10,
                5.46661600296,
                29864.334027309
            ],
            [
                6.9e-10,
                3.22045334237,
                801.8209311238
            ],
            [
                6.8e-10,
                2.19928242745,
                37724.7534197482
            ],
            [
                7e-10,
                5.33711014698,
                2544.3144198834
            ],
            [
                5.5e-10,
                5.37872238211,
                11015.1064773348
            ],
            [
                5.1e-10,
                5.03600618727,
                5863.5912061162
            ],
            [
                5.9e-10,
                3.54984809612,
                4535.0594369244
            ],
            [
                5.3e-10,
                1.50812064137,
                7342.4577801806
            ],
            [
                4.4e-10,
                1.33712241647,
                4164.311989613
            ],
            [
                5.5e-10,
                5.38460045253,
                7477.522860216
            ],
            [
                4.9e-10,
                5.61844340512,
                24072.9214697764
            ],
            [
                5.7e-10,
                6.17973522898,
                8031.0922630584
            ],
            [
                5.2e-10,
                4.24379064407,
                5088.6288397668
            ],
            [
                4.1e-10,
                3.41960196246,
                26087.9031415742
            ],
            [
                5.2e-10,
                1.68150981131,
                25158.6017197654
            ],
            [
                5.3e-10,
                0.11041408311,
                29088.811415985
            ],
            [
                4.3e-10,
                0.53354396923,
                2146.1654164752
            ],
            [
                5e-10,
                0.60270799844,
                33794.5437235286
            ],
            [
                4.5e-10,
                1.69577010458,
                6702.5604938666
            ],
            [
                3.7e-10,
                6.09033460795,
                64809.80550494129
            ],
            [
                4.4e-10,
                2.67993061247,
                15110.4661198662
            ],
            [
                4.7e-10,
                3.62555676035,
                41654.9631159678
            ],
            [
                3.6e-10,
                0.47219666269,
                13095.8426650774
            ],
            [
                3.5e-10,
                5.99520523215,
                23581.2581773176
            ],
            [
                4.3e-10,
                4.08726331262,
                156137.47598479927
            ],
            [
                4.3e-10,
                5.17376496602,
                18422.62935909819
            ],
            [
                3.4e-10,
                2.14460100274,
                4933.2084403326
            ],
            [
                3e-10,
                4.12992793541,
                426.598190876
            ],
            [
                3.6e-10,
                2.28596930002,
                90279.92316810328
            ],
            [
                3.2e-10,
                0.81117747619,
                26.2983197998
            ],
            [
                2.8e-10,
                4.07036560467,
                14712.317116458
            ],
            [
                2.5e-10,
                1.92905243842,
                1748.016413067
            ],
            [
                2.4e-10,
                5.06152880842,
                16730.4636895958
            ],
            [
                2.3e-10,
                3.24047012195,
                31415.379249957
            ],
            [
                2.7e-10,
                3.90672018305,
                18451.07854656599
            ],
            [
                2.1e-10,
                3.51419811826,
                10447.3878396044
            ]
        ],
        "2": [
            [
                0.00009721424,
                5.1519280992,
                6283.0758499914
            ],
            [
                0.00000233002,
                3.14159265359,
                0
            ],
            [
                0.00000134188,
                0.64406212977,
                12566.1516999828
            ],
            [
                6.504e-8,
                1.07333397797,
                18849.2275499742
            ],
            [
                1.662e-8,
                1.62746869551,
                84334.66158130829
            ],
            [
                6.35e-9,
                3.51985338656,
                6279.5527316424
            ],
            [
                4.92e-9,
                2.41382223971,
                1047.7473117547
            ],
            [
                3.07e-9,
                6.10181422085,
                5223.6939198022
            ],
            [
                3.22e-9,
                0.37660897389,
                6286.5989683404
            ],
            [
                3.26e-9,
                2.35727931602,
                5507.5532386674
            ],
            [
                2.74e-9,
                1.65307581765,
                7860.4193924392
            ],
            [
                2.28e-9,
                1.14082932988,
                25132.3033999656
            ],
            [
                2.02e-9,
                0.4983668253,
                2352.8661537718
            ],
            [
                2.01e-9,
                0.155527656,
                10213.285546211
            ],
            [
                1.67e-9,
                3.98005254015,
                529.6909650946
            ],
            [
                1.7e-9,
                5.28668290523,
                6256.7775301916
            ],
            [
                1.66e-9,
                3.04613930284,
                12036.4607348882
            ],
            [
                1.53e-9,
                4.06779216239,
                83996.84731811189
            ],
            [
                1.5e-9,
                3.18772213951,
                71430.69561812909
            ],
            [
                1.2e-9,
                3.13558669517,
                5884.9268465832
            ],
            [
                1.23e-9,
                4.17102530625,
                6309.3741697912
            ],
            [
                1e-9,
                1.46356761368,
                11506.7697697936
            ],
            [
                1e-9,
                3.00322421365,
                11790.6290886588
            ],
            [
                7.7e-10,
                1.65643898948,
                4705.7323075436
            ],
            [
                6.8e-10,
                6.03791904123,
                6812.766815086
            ],
            [
                7.5e-10,
                4.85191600582,
                14143.4952424306
            ],
            [
                7.9e-10,
                4.12628805658,
                5753.3848848968
            ],
            [
                6.4e-10,
                2.7194416046,
                6127.6554505572
            ],
            [
                6.3e-10,
                0.78655326011,
                6438.4962494256
            ],
            [
                7.5e-10,
                0.84213523741,
                167621.5758508619
            ],
            [
                5.1e-10,
                4.55059044701,
                5486.777843175
            ],
            [
                5e-10,
                5.29314320585,
                7079.3738568078
            ],
            [
                4.5e-10,
                0.33147576416,
                775.522611324
            ],
            [
                4.3e-10,
                3.6179371164,
                1577.3435424478
            ],
            [
                5.7e-10,
                6.15295833679,
                12194.0329146209
            ],
            [
                4.5e-10,
                1.18274698508,
                17789.845619785
            ],
            [
                4.7e-10,
                1.11643162773,
                398.1490034082
            ],
            [
                4.7e-10,
                5.5298423843,
                12168.0026965746
            ],
            [
                4.2e-10,
                2.6437530062,
                10988.808157535
            ],
            [
                3.7e-10,
                0.31226891972,
                6681.2248533996
            ],
            [
                4.6e-10,
                3.38617099014,
                156475.2902479957
            ],
            [
                3.3e-10,
                1.26266496002,
                6290.1893969922
            ],
            [
                3.3e-10,
                2.25067065498,
                6275.9623029906
            ],
            [
                2.7e-10,
                1.72859626293,
                1059.3819301892
            ],
            [
                2.8e-10,
                2.88681054153,
                796.2980068164
            ],
            [
                3e-10,
                5.52021264181,
                7058.5984613154
            ],
            [
                2.1e-10,
                6.22275008403,
                6069.7767545534
            ],
            [
                2.4e-10,
                5.83690442827,
                6282.0955289232
            ],
            [
                2.4e-10,
                3.95322179797,
                6284.0561710596
            ],
            [
                2.1e-10,
                4.87022458966,
                3738.761430108
            ],
            [
                2.1e-10,
                3.58048145762,
                6496.3749454294
            ],
            [
                2.2e-10,
                1.97770318395,
                7.1135470008
            ],
            [
                1.9e-10,
                3.4597988877,
                4136.9104335162
            ],
            [
                1.5e-10,
                2.81379880771,
                1589.0728952838
            ],
            [
                1.5e-10,
                1.61313151838,
                1194.4470102246
            ],
            [
                1.5e-10,
                0.63083434831,
                11769.8536931664
            ],
            [
                1.9e-10,
                0.28082047767,
                17260.1546546904
            ],
            [
                1.7e-10,
                1.35165136146,
                78051.5857313169
            ],
            [
                1.5e-10,
                2.3094159956,
                11856.2186514245
            ],
            [
                1.2e-10,
                1.12997370513,
                90617.7374312997
            ],
            [
                1.2e-10,
                0.00611601597,
                18073.7049386502
            ],
            [
                1.2e-10,
                1.70058636365,
                12559.038152982
            ]
        ],
        "3": [
            [
                0.00000275993,
                0.59480097092,
                6283.0758499914
            ],
            [
                1.7034e-7,
                3.14159265359,
                0
            ],
            [
                3.617e-8,
                0.11750575325,
                12566.1516999828
            ],
            [
                3.39e-9,
                5.66087461682,
                18849.2275499742
            ],
            [
                5.6e-10,
                5.02765554835,
                6279.5527316424
            ],
            [
                1.9e-10,
                5.99007646261,
                6256.7775301916
            ],
            [
                1.8e-10,
                3.80004734567,
                6309.3741697912
            ],
            [
                1.8e-10,
                1.21049250774,
                6127.6554505572
            ],
            [
                1.8e-10,
                2.29734567137,
                6438.4962494256
            ],
            [
                1.5e-10,
                4.72881467263,
                6286.5989683404
            ],
            [
                1.2e-10,
                0.41481671808,
                83996.84731811189
            ],
            [
                1.3e-10,
                5.54637369296,
                25132.3033999656
            ],
            [
                1e-10,
                2.91937214232,
                71430.69561812909
            ],
            [
                6e-11,
                2.1417324121,
                11856.2186514245
            ]
        ],
        "4": [
            [
                5.745e-8,
                2.26734029843,
                6283.0758499914
            ],
            [
                8.7e-9,
                0,
                0
            ],
            [
                1.19e-9,
                4.26807972611,
                12566.1516999828
            ],
            [
                1.7e-10,
                4.0742262044,
                18849.2275499742
            ],
            [
                5e-11,
                0.84308705203,
                1047.7473117547
            ],
            [
                5e-11,
                0.05711572303,
                84334.66158130829
            ]
        ],
        "5": [
            [
                1.14e-9,
                4.31455980099,
                6283.0758499914
            ],
            [
                2.4e-10,
                0,
                0
            ]
        ]
    },
    R: {
        "0": [
            [
                1.00013988784,
                0,
                0
            ],
            [
                0.01670699632,
                3.09846350258,
                6283.0758499914
            ],
            [
                0.00013956024,
                3.05524609456,
                12566.1516999828
            ],
            [
                0.0000308372,
                5.19846674381,
                77713.7714681205
            ],
            [
                0.00001628463,
                1.17387558054,
                5753.3848848968
            ],
            [
                0.00001575572,
                2.84685214877,
                7860.4193924392
            ],
            [
                0.00000924799,
                5.45292236722,
                11506.7697697936
            ],
            [
                0.00000542439,
                4.56409151453,
                3930.2096962196
            ],
            [
                0.0000047211,
                3.66100022149,
                5884.9268465832
            ],
            [
                0.0000032878,
                5.89983686142,
                5223.6939198022
            ],
            [
                0.00000345969,
                0.96368627272,
                5507.5532386674
            ],
            [
                0.00000306784,
                0.29867139512,
                5573.1428014331
            ],
            [
                0.00000174844,
                3.01193636733,
                18849.2275499742
            ],
            [
                0.00000243181,
                4.2734953079,
                11790.6290886588
            ],
            [
                0.00000211836,
                5.84714461348,
                1577.3435424478
            ],
            [
                0.0000018574,
                5.02199710705,
                10977.078804699
            ],
            [
                0.00000109835,
                5.0551063586,
                5486.777843175
            ],
            [
                9.8316e-7,
                0.88681311278,
                6069.7767545534
            ],
            [
                8.65e-7,
                5.68956418946,
                15720.8387848784
            ],
            [
                8.5831e-7,
                1.27079125277,
                161000.6857376741
            ],
            [
                6.2917e-7,
                0.92177053978,
                529.6909650946
            ],
            [
                5.7056e-7,
                2.01374292245,
                83996.84731811189
            ],
            [
                6.4908e-7,
                0.27251341435,
                17260.1546546904
            ],
            [
                4.9384e-7,
                3.24501240359,
                2544.3144198834
            ],
            [
                5.5736e-7,
                5.2415979917,
                71430.69561812909
            ],
            [
                4.252e-7,
                6.01110257982,
                6275.9623029906
            ],
            [
                4.6966e-7,
                2.57799853213,
                775.522611324
            ],
            [
                3.8963e-7,
                5.36063832897,
                4694.0029547076
            ],
            [
                4.4666e-7,
                5.53715663816,
                9437.762934887
            ],
            [
                3.5661e-7,
                1.67447135798,
                12036.4607348882
            ],
            [
                3.1922e-7,
                0.18368299942,
                5088.6288397668
            ],
            [
                3.1846e-7,
                1.77775642078,
                398.1490034082
            ],
            [
                3.3193e-7,
                0.24370221704,
                7084.8967811152
            ],
            [
                3.8245e-7,
                2.39255343973,
                8827.3902698748
            ],
            [
                2.8468e-7,
                1.21344887533,
                6286.5989683404
            ],
            [
                3.7486e-7,
                0.82961281844,
                19651.048481098
            ],
            [
                3.6957e-7,
                4.90107587287,
                12139.5535091068
            ],
            [
                3.4537e-7,
                1.84270693281,
                2942.4634232916
            ],
            [
                2.6275e-7,
                4.58896863104,
                10447.3878396044
            ],
            [
                2.4596e-7,
                3.78660838036,
                8429.2412664666
            ],
            [
                2.3587e-7,
                0.26866098169,
                796.2980068164
            ],
            [
                2.7795e-7,
                1.89934427832,
                6279.5527316424
            ],
            [
                2.3927e-7,
                4.99598548145,
                5856.4776591154
            ],
            [
                2.0345e-7,
                4.65282190725,
                2146.1654164752
            ],
            [
                2.3287e-7,
                2.80783632869,
                14143.4952424306
            ],
            [
                2.2099e-7,
                1.95002636847,
                3154.6870848956
            ],
            [
                1.9509e-7,
                5.38233922479,
                2352.8661537718
            ],
            [
                1.7958e-7,
                0.1987136996,
                6812.766815086
            ],
            [
                1.7178e-7,
                4.43322156854,
                10213.285546211
            ],
            [
                1.619e-7,
                5.23159323213,
                17789.845619785
            ],
            [
                1.7315e-7,
                6.15224075188,
                16730.4636895958
            ],
            [
                1.3814e-7,
                5.18962074032,
                8031.0922630584
            ],
            [
                1.8834e-7,
                0.67280058021,
                149854.4001348079
            ],
            [
                1.833e-7,
                2.25348717053,
                23581.2581773176
            ],
            [
                1.3639e-7,
                3.68511810757,
                4705.7323075436
            ],
            [
                1.3142e-7,
                0.65267698994,
                13367.9726311066
            ],
            [
                1.0414e-7,
                4.33285688501,
                11769.8536931664
            ],
            [
                9.978e-8,
                4.20126336356,
                6309.3741697912
            ],
            [
                1.017e-7,
                1.59366684542,
                4690.4798363586
            ],
            [
                7.564e-8,
                2.62560597391,
                6256.7775301916
            ],
            [
                9.654e-8,
                3.67583728703,
                27511.4678735372
            ],
            [
                6.743e-8,
                0.56269927047,
                3340.6124266998
            ],
            [
                8.743e-8,
                6.06359123461,
                1748.016413067
            ],
            [
                7.786e-8,
                3.67371235367,
                12168.0026965746
            ],
            [
                6.633e-8,
                5.66149277789,
                11371.7046897582
            ],
            [
                7.712e-8,
                0.31242577788,
                7632.9432596502
            ],
            [
                6.586e-8,
                3.13580054586,
                801.8209311238
            ],
            [
                7.46e-8,
                5.6475806666,
                11926.2544136688
            ],
            [
                6.933e-8,
                2.92384586372,
                6681.2248533996
            ],
            [
                6.805e-8,
                1.42327153767,
                23013.5395395872
            ],
            [
                6.118e-8,
                5.13395999022,
                1194.4470102246
            ],
            [
                6.477e-8,
                2.64986648493,
                19804.8272915828
            ],
            [
                5.233e-8,
                4.62432817299,
                6438.4962494256
            ],
            [
                6.147e-8,
                3.02863936662,
                233141.3144043615
            ],
            [
                4.608e-8,
                1.72194702724,
                7234.794256242
            ],
            [
                4.221e-8,
                1.55697533726,
                7238.6755916
            ],
            [
                5.31e-8,
                2.40821524293,
                11499.6562227928
            ],
            [
                5.128e-8,
                5.3239896569,
                11513.8833167944
            ],
            [
                4.77e-8,
                0.2555431173,
                11856.2186514245
            ],
            [
                5.519e-8,
                2.09089153789,
                17298.1823273262
            ],
            [
                5.625e-8,
                4.34052903053,
                90955.5516944961
            ],
            [
                4.578e-8,
                4.4656964157,
                5746.271337896
            ],
            [
                3.788e-8,
                4.9072829481,
                4164.311989613
            ],
            [
                5.337e-8,
                5.09957905103,
                31441.6775697568
            ],
            [
                3.967e-8,
                1.20054555175,
                1349.8674096588
            ],
            [
                4.005e-8,
                3.02853885902,
                1059.3819301892
            ],
            [
                3.48e-8,
                0.76066308841,
                10973.55568635
            ],
            [
                4.232e-8,
                1.05485713117,
                5760.4984318976
            ],
            [
                4.582e-8,
                3.76570026763,
                6386.16862421
            ],
            [
                3.335e-8,
                3.13829943354,
                6836.6452528338
            ],
            [
                3.42e-8,
                3.00043974511,
                4292.3308329504
            ],
            [
                3.595e-8,
                5.70703236079,
                5643.1785636774
            ],
            [
                3.236e-8,
                4.16387400645,
                9917.6968745098
            ],
            [
                4.154e-8,
                2.59940749519,
                7058.5984613154
            ],
            [
                3.362e-8,
                4.54577164994,
                4732.0306273434
            ],
            [
                2.978e-8,
                1.3056126882,
                6283.14316029419
            ],
            [
                2.765e-8,
                0.51311975671,
                26.2983197998
            ],
            [
                2.807e-8,
                5.66230537649,
                8635.9420037632
            ],
            [
                2.927e-8,
                5.7378783408,
                16200.7727245012
            ],
            [
                3.167e-8,
                1.691817599,
                11015.1064773348
            ],
            [
                2.598e-8,
                2.96244118358,
                25132.3033999656
            ],
            [
                3.519e-8,
                3.62639325753,
                244287.60000722768
            ],
            [
                2.676e-8,
                4.20727719487,
                18073.7049386502
            ],
            [
                2.978e-8,
                1.74971565805,
                6283.0085396886
            ],
            [
                2.287e-8,
                1.06976449088,
                14314.1681130498
            ],
            [
                2.863e-8,
                5.92838917309,
                14712.317116458
            ],
            [
                3.071e-8,
                0.23793217,
                35371.8872659764
            ],
            [
                2.656e-8,
                0.89959301615,
                12352.8526045448
            ],
            [
                2.415e-8,
                2.799751768,
                709.9330485583
            ],
            [
                2.811e-8,
                3.51513864541,
                21228.3920235458
            ],
            [
                1.977e-8,
                2.61358297551,
                951.7184062506
            ],
            [
                2.548e-8,
                2.47684686575,
                6208.2942514241
            ],
            [
                1.999e-8,
                0.56090396506,
                7079.3738568078
            ],
            [
                2.305e-8,
                1.05376463592,
                22483.84857449259
            ],
            [
                1.855e-8,
                2.86093570752,
                5216.5803728014
            ],
            [
                2.157e-8,
                1.31395211105,
                154717.6098876827
            ],
            [
                1.97e-8,
                4.36931551625,
                167283.7615876655
            ],
            [
                1.754e-8,
                2.14452400686,
                6290.1893969922
            ],
            [
                1.628e-8,
                5.85704450617,
                10984.1923516998
            ],
            [
                2.154e-8,
                6.03828353794,
                10873.9860304804
            ],
            [
                1.714e-8,
                3.70158195222,
                1592.5960136328
            ],
            [
                1.541e-8,
                6.21599512982,
                23543.23050468179
            ],
            [
                1.602e-8,
                1.99860679677,
                10969.9652576982
            ],
            [
                1.712e-8,
                1.34295218697,
                3128.3887650958
            ],
            [
                1.647e-8,
                5.54948299069,
                6496.3749454294
            ],
            [
                1.495e-8,
                5.43980459648,
                155.4203994342
            ],
            [
                1.827e-8,
                5.91227480351,
                3738.761430108
            ],
            [
                1.726e-8,
                2.16765465036,
                10575.4066829418
            ],
            [
                1.532e-8,
                5.35683107063,
                13521.7514415914
            ],
            [
                1.824e-8,
                1.66056145084,
                39302.096962196
            ],
            [
                1.605e-8,
                1.90930973224,
                6133.5126528568
            ],
            [
                1.282e-8,
                2.46013372544,
                13916.0191096416
            ],
            [
                1.211e-8,
                4.4136063155,
                3894.1818295422
            ],
            [
                1.394e-8,
                1.7780192925,
                9225.539273283
            ],
            [
                1.571e-8,
                4.95512957606,
                25158.6017197654
            ],
            [
                1.205e-8,
                1.19212756308,
                3.523118349
            ],
            [
                1.132e-8,
                2.69830084955,
                6040.3472460174
            ],
            [
                1.504e-8,
                5.77577388271,
                18209.33026366019
            ],
            [
                1.393e-8,
                1.62625077326,
                5120.6011455836
            ],
            [
                1.081e-8,
                2.93726744446,
                17256.6315363414
            ],
            [
                1.232e-8,
                0.71651766504,
                143571.32428481648
            ],
            [
                1.087e-8,
                0.99769687961,
                955.5997416086
            ],
            [
                1.068e-8,
                5.28472576591,
                65147.6197681377
            ],
            [
                1.169e-8,
                3.11663802316,
                14945.3161735544
            ],
            [
                9.75e-9,
                5.1088726078,
                6172.869528772
            ],
            [
                1.202e-8,
                4.02992510403,
                553.5694028424
            ],
            [
                9.79e-9,
                2.00000879106,
                15110.4661198662
            ],
            [
                9.62e-9,
                4.023807714,
                6282.0955289232
            ],
            [
                9.99e-9,
                3.6264300279,
                6262.300454499
            ],
            [
                1.03e-8,
                5.84987815239,
                213.299095438
            ],
            [
                1.014e-8,
                2.84227679965,
                8662.240323563
            ],
            [
                1.185e-8,
                1.51330629149,
                17654.7805397496
            ],
            [
                9.67e-9,
                2.67081017562,
                5650.2921106782
            ],
            [
                1.222e-8,
                2.65423784904,
                88860.05707098669
            ],
            [
                9.86e-9,
                2.36212814824,
                6206.8097787158
            ],
            [
                1.034e-8,
                0.13634950642,
                11712.9553182308
            ],
            [
                1.103e-8,
                3.08477302937,
                43232.3066584156
            ],
            [
                7.81e-9,
                2.53374971725,
                16496.3613962024
            ],
            [
                1.019e-8,
                3.04569392376,
                6037.244203762
            ],
            [
                7.95e-9,
                5.80662989126,
                5230.807466803
            ],
            [
                8.13e-9,
                3.57702871938,
                10177.2576795336
            ],
            [
                9.62e-9,
                5.31470594766,
                6284.0561710596
            ],
            [
                7.17e-9,
                5.95797471837,
                12559.038152982
            ],
            [
                9.67e-9,
                2.74413738053,
                6244.9428143536
            ],
            [
                9.21e-9,
                0.1016016083,
                29088.811415985
            ],
            [
                7.19e-9,
                5.91788189939,
                4136.9104335162
            ],
            [
                6.88e-9,
                3.89489045092,
                1589.0728952838
            ],
            [
                7.72e-9,
                4.05505380285,
                6127.6554505572
            ],
            [
                7.06e-9,
                5.49323197725,
                22003.9146348698
            ],
            [
                6.65e-9,
                1.60002747134,
                11087.2851259184
            ],
            [
                6.9e-9,
                4.50539825729,
                426.598190876
            ],
            [
                8.54e-9,
                3.2610464506,
                20426.571092422
            ],
            [
                6.56e-9,
                4.3241018294,
                16858.4825329332
            ],
            [
                8.4e-9,
                2.59572585212,
                28766.924424484
            ],
            [
                6.86e-9,
                0.61944033771,
                11403.676995575
            ],
            [
                7e-9,
                3.40901412473,
                7.1135470008
            ],
            [
                7.28e-9,
                0.04050185963,
                5481.2549188676
            ],
            [
                6.53e-9,
                1.0386945123,
                6062.6632075526
            ],
            [
                5.59e-9,
                4.79221805695,
                20199.094959633
            ],
            [
                6.33e-9,
                5.70229959167,
                45892.73043315699
            ],
            [
                5.91e-9,
                6.10986487621,
                9623.6882766912
            ],
            [
                5.2e-9,
                3.62310356479,
                5333.9002410216
            ],
            [
                6.02e-9,
                5.58381898589,
                10344.2950653858
            ],
            [
                4.96e-9,
                2.21027756314,
                1990.745017041
            ],
            [
                6.91e-9,
                1.96733114988,
                12416.5885028482
            ],
            [
                6.4e-9,
                1.59062417043,
                18319.5365848796
            ],
            [
                6.25e-9,
                3.82358168221,
                13517.8701062334
            ],
            [
                4.75e-9,
                1.1702590418,
                12569.6748183318
            ],
            [
                6.6e-9,
                5.08498512995,
                283.8593188652
            ],
            [
                6.64e-9,
                4.50029469969,
                47162.5163546352
            ],
            [
                5.69e-9,
                0.16318535463,
                17267.26820169119
            ],
            [
                5.68e-9,
                3.86100969474,
                6076.8903015542
            ],
            [
                4.62e-9,
                0.26368763517,
                4590.910180489
            ],
            [
                5.35e-9,
                4.83225423196,
                18422.62935909819
            ],
            [
                4.66e-9,
                0.75873879417,
                7342.4577801806
            ],
            [
                5.41e-9,
                3.07212190556,
                226858.23855437007
            ],
            [
                6.1e-9,
                1.53597089605,
                33019.0211122046
            ],
            [
                6.17e-9,
                2.62356328726,
                11190.377900137
            ],
            [
                5.48e-9,
                4.55798855803,
                18875.525869774
            ],
            [
                6.33e-9,
                4.60110281228,
                66567.48586525429
            ],
            [
                5.87e-9,
                5.78087907808,
                632.7837393132
            ],
            [
                6.03e-9,
                5.38458554802,
                316428.22867391503
            ],
            [
                5.25e-9,
                5.01522072363,
                12132.439962106
            ],
            [
                4.69e-9,
                0.59975173763,
                21954.15760939799
            ],
            [
                5.48e-9,
                3.50627043672,
                17253.04110768959
            ],
            [
                5.02e-9,
                0.98804327589,
                11609.8625440122
            ],
            [
                5.68e-9,
                1.98497313089,
                7668.6374249425
            ],
            [
                4.82e-9,
                1.62460405687,
                12146.6670561076
            ],
            [
                3.91e-9,
                3.68718382972,
                18052.9295431578
            ],
            [
                4.57e-9,
                3.7721489661,
                156137.47598479927
            ],
            [
                4.01e-9,
                5.2922154024,
                15671.0817594066
            ],
            [
                4.69e-9,
                1.80963351735,
                12562.6285816338
            ],
            [
                5.14e-9,
                3.37031288919,
                20597.2439630412
            ],
            [
                4.52e-9,
                5.66811219778,
                10454.5013866052
            ],
            [
                3.75e-9,
                4.98528185039,
                9779.1086761254
            ],
            [
                5.23e-9,
                0.97215560834,
                155427.542936241
            ],
            [
                4.03e-9,
                5.1394818977,
                1551.045222648
            ],
            [
                3.72e-9,
                3.69883738807,
                9388.0059094152
            ],
            [
                3.67e-9,
                4.43875659833,
                4535.0594369244
            ],
            [
                4.06e-9,
                4.20863156497,
                12592.4500197826
            ],
            [
                3.62e-9,
                2.55099560446,
                242.728603974
            ],
            [
                4.71e-9,
                4.61907324819,
                5436.9930152402
            ],
            [
                3.88e-9,
                4.960209284,
                24356.7807886416
            ],
            [
                4.41e-9,
                5.83872966262,
                3496.032826134
            ],
            [
                3.49e-9,
                6.16307810648,
                19800.9459562248
            ],
            [
                3.56e-9,
                0.2381908124,
                5429.8794682394
            ],
            [
                3.46e-9,
                5.60809622572,
                2379.1644735716
            ],
            [
                3.8e-9,
                2.72105213132,
                11933.3679606696
            ],
            [
                4.32e-9,
                0.24215988572,
                17996.0311682222
            ],
            [
                3.78e-9,
                5.22516848076,
                7477.522860216
            ],
            [
                3.37e-9,
                5.10885555836,
                5849.3641121146
            ],
            [
                3.15e-9,
                0.57827745123,
                10557.5941608238
            ],
            [
                3.18e-9,
                4.4994900732,
                3634.6210245184
            ],
            [
                3.23e-9,
                1.55850824803,
                10440.2742926036
            ],
            [
                3.14e-9,
                5.77154773334,
                20.7753954924
            ],
            [
                3.03e-9,
                2.34615580398,
                4686.8894077068
            ],
            [
                4.14e-9,
                5.9323760231,
                51092.7260508548
            ],
            [
                3.62e-9,
                2.17561997119,
                28237.2334593894
            ],
            [
                2.88e-9,
                0.18377405421,
                13095.8426650774
            ],
            [
                2.77e-9,
                5.1295220503,
                13119.72110282519
            ],
            [
                3.25e-9,
                6.18608287927,
                6268.8487559898
            ],
            [
                2.73e-9,
                0.30522428863,
                23141.5583829246
            ],
            [
                2.67e-9,
                5.76152585786,
                5966.6839803348
            ],
            [
                3.45e-9,
                2.94246040875,
                36949.2308084242
            ],
            [
                2.53e-9,
                5.20994580359,
                24072.9214697764
            ],
            [
                3.42e-9,
                5.76212804329,
                16460.33352952499
            ],
            [
                3.07e-9,
                6.01039067183,
                22805.7355659936
            ],
            [
                2.61e-9,
                2.00304796059,
                6148.010769956
            ],
            [
                2.38e-9,
                5.08241964961,
                6915.8595893046
            ],
            [
                2.49e-9,
                2.94762789744,
                135.0650800354
            ],
            [
                3.06e-9,
                3.89765478921,
                10988.808157535
            ],
            [
                3.08e-9,
                0.05451027736,
                4701.1165017084
            ],
            [
                3.19e-9,
                2.95712862064,
                163096.18036118348
            ],
            [
                2.72e-9,
                2.07967681309,
                4804.209275927
            ],
            [
                2.09e-9,
                4.43768461442,
                6546.1597733642
            ],
            [
                2.17e-9,
                0.73691592312,
                6303.8512454838
            ],
            [
                2.03e-9,
                0.32033085531,
                25934.1243310894
            ],
            [
                2.05e-9,
                5.22936478995,
                20995.3929664494
            ],
            [
                2.13e-9,
                0.20671418919,
                28286.9904848612
            ],
            [
                1.97e-9,
                0.4828613129,
                16737.5772365966
            ],
            [
                2.3e-9,
                6.06567392849,
                6287.0080032545
            ],
            [
                2.19e-9,
                1.291942163,
                5326.7866940208
            ],
            [
                2.01e-9,
                1.74700937253,
                22743.4093795164
            ],
            [
                2.07e-9,
                4.45440927276,
                6279.4854213396
            ],
            [
                2.69e-9,
                6.0564044503,
                64471.99124174489
            ],
            [
                1.9e-9,
                0.99261116842,
                29296.6153895786
            ],
            [
                1.94e-9,
                3.82656562755,
                419.4846438752
            ],
            [
                2.62e-9,
                5.26961924126,
                522.5774180938
            ],
            [
                2.1e-9,
                4.68618183158,
                6254.6266625236
            ],
            [
                1.97e-9,
                2.80624554186,
                4933.2084403326
            ],
            [
                2.52e-9,
                4.3622015462,
                40879.4405046438
            ],
            [
                2.61e-9,
                1.07241516738,
                55022.9357470744
            ],
            [
                2.33e-9,
                5.41751014958,
                39609.6545831656
            ],
            [
                1.85e-9,
                4.14324541379,
                5642.1982426092
            ],
            [
                2.47e-9,
                3.44855612987,
                6702.5604938666
            ],
            [
                2.05e-9,
                4.04424043226,
                536.8045120954
            ],
            [
                1.91e-9,
                3.15807087926,
                16723.350142595
            ],
            [
                2.22e-9,
                5.16259496507,
                23539.7073863328
            ],
            [
                1.8e-9,
                4.56214752149,
                6489.2613984286
            ],
            [
                2.27e-9,
                0.60156339452,
                5905.7022420756
            ],
            [
                1.7e-9,
                0.93185903228,
                16062.1845261168
            ],
            [
                1.59e-9,
                0.92751013112,
                23937.856389741
            ],
            [
                1.57e-9,
                4.69607868164,
                6805.6532680852
            ],
            [
                2.18e-9,
                0.8553337343,
                16627.3709153772
            ],
            [
                1.69e-9,
                0.94641052064,
                3097.88382272579
            ],
            [
                2.07e-9,
                4.88410451334,
                6286.6662786432
            ],
            [
                1.6e-9,
                4.95943826819,
                10021.8372800994
            ],
            [
                1.75e-9,
                6.12762824563,
                239424.39025435288
            ],
            [
                1.73e-9,
                3.13887234973,
                6179.9830757728
            ],
            [
                1.57e-9,
                3.62822057807,
                18451.07854656599
            ],
            [
                2.06e-9,
                5.74617821138,
                3646.3503773544
            ],
            [
                1.57e-9,
                4.67695912207,
                6709.6740408674
            ],
            [
                1.46e-9,
                3.09506069745,
                4907.3020501456
            ],
            [
                1.65e-9,
                2.2713912876,
                10660.6869350424
            ],
            [
                1.44e-9,
                3.96947747592,
                6019.9919266186
            ],
            [
                1.71e-9,
                5.91302216729,
                6058.7310542895
            ],
            [
                1.44e-9,
                2.1315565512,
                26084.0218062162
            ],
            [
                1.51e-9,
                0.67417383565,
                2388.8940204492
            ],
            [
                1.96e-9,
                1.67718461229,
                2107.0345075424
            ],
            [
                1.46e-9,
                5.10373877968,
                10770.8932562618
            ],
            [
                1.87e-9,
                1.23915444627,
                19402.7969528166
            ],
            [
                1.37e-9,
                1.26247412216,
                12566.2190102856
            ],
            [
                1.91e-9,
                5.03547476279,
                263.0839233728
            ],
            [
                1.37e-9,
                3.52825454595,
                639.897286314
            ],
            [
                1.35e-9,
                0.73840670927,
                5017.508371365
            ],
            [
                1.64e-9,
                2.39195095081,
                6357.8574485587
            ],
            [
                1.68e-9,
                0.05515907462,
                9380.9596727172
            ],
            [
                1.61e-9,
                1.15721259392,
                26735.9452622132
            ],
            [
                1.44e-9,
                1.76097645199,
                5888.4499649322
            ],
            [
                1.31e-9,
                2.51859277344,
                6599.467719648
            ],
            [
                1.42e-9,
                2.43802911123,
                5881.4037282342
            ],
            [
                1.59e-9,
                5.90325893762,
                6281.5913772831
            ],
            [
                1.51e-9,
                3.72338532519,
                12669.2444742014
            ],
            [
                1.32e-9,
                2.38417741883,
                6525.8044539654
            ],
            [
                1.27e-9,
                0.00254936441,
                10027.9031957292
            ],
            [
                1.48e-9,
                2.85102145528,
                6418.1409300268
            ],
            [
                1.43e-9,
                5.7446027956,
                26087.9031415742
            ],
            [
                1.72e-9,
                0.4128996224,
                174242.4659640497
            ],
            [
                1.36e-9,
                4.15497742275,
                6311.5250374592
            ],
            [
                1.7e-9,
                5.98194913129,
                327574.51427678124
            ],
            [
                1.36e-9,
                2.48430537541,
                13341.6743113068
            ],
            [
                1.49e-9,
                0.33002271275,
                245.8316462294
            ],
            [
                1.65e-9,
                2.496679246,
                58953.145443294
            ],
            [
                1.23e-9,
                1.67328384813,
                32217.2001810808
            ],
            [
                1.23e-9,
                3.45660563754,
                6277.552925684
            ],
            [
                1.17e-9,
                0.86065134175,
                6245.0481773556
            ],
            [
                1.49e-9,
                5.61358281003,
                5729.506447149
            ],
            [
                1.28e-9,
                0.71204006448,
                103.0927742186
            ],
            [
                1.59e-9,
                2.43166592149,
                221995.02880149524
            ],
            [
                1.37e-9,
                1.706577092,
                12566.08438968
            ],
            [
                1.29e-9,
                2.80667872683,
                6016.4688082696
            ],
            [
                1.13e-9,
                3.58302904101,
                25685.872802808
            ],
            [
                1.09e-9,
                3.26403795962,
                6819.8803620868
            ],
            [
                1.22e-9,
                0.34120688202,
                1162.4747044078
            ],
            [
                1.06e-9,
                1.59721172719,
                17782.7320727842
            ],
            [
                1.44e-9,
                2.28891651774,
                12489.8856287072
            ],
            [
                1.37e-9,
                5.82029768354,
                44809.6502008634
            ],
            [
                1.34e-9,
                1.26539983018,
                5331.3574437408
            ],
            [
                1.03e-9,
                5.96518130595,
                6321.1035226272
            ],
            [
                1.09e-9,
                0.33808549034,
                11300.5842213564
            ],
            [
                1.29e-9,
                5.8918727719,
                12029.3471878874
            ],
            [
                1.22e-9,
                5.77325634636,
                11919.140866668
            ],
            [
                1.07e-9,
                6.2499898935,
                77690.75950573849
            ],
            [
                1.07e-9,
                1.00535580713,
                77736.78343050249
            ],
            [
                1.15e-9,
                5.86963518266,
                12721.572099417
            ],
            [
                1.02e-9,
                5.66283467269,
                5540.0857894588
            ],
            [
                1.43e-9,
                0.24122178432,
                4214.0690150848
            ],
            [
                1.43e-9,
                0.88529649733,
                7576.560073574
            ],
            [
                1.07e-9,
                2.92124030351,
                31415.379249957
            ],
            [
                1e-9,
                5.99485644501,
                4061.2192153944
            ],
            [
                1.03e-9,
                2.41941934525,
                5547.1993364596
            ],
            [
                1.04e-9,
                4.44106051277,
                2118.7638603784
            ],
            [
                1.1e-9,
                0.37559635174,
                5863.5912061162
            ],
            [
                1.24e-9,
                2.55619029611,
                12539.853380183
            ],
            [
                1.1e-9,
                3.66952094465,
                238004.5241572363
            ],
            [
                1.12e-9,
                4.32512422724,
                97238.62754448749
            ],
            [
                1.2e-9,
                1.26895630075,
                12043.574281889
            ],
            [
                9.7e-10,
                5.42612959752,
                7834.1210726394
            ],
            [
                9.4e-10,
                2.56461130309,
                19004.6479494084
            ],
            [
                1.05e-9,
                5.68272475301,
                16522.6597160022
            ],
            [
                1.17e-9,
                3.65425622684,
                34520.3093093808
            ],
            [
                1.08e-9,
                1.24206843948,
                84672.47584450469
            ],
            [
                9.8e-10,
                0.13589994287,
                11080.1715789176
            ],
            [
                9.7e-10,
                2.46722096722,
                71980.63357473118
            ],
            [
                9.5e-10,
                5.36958330451,
                6288.5987742988
            ],
            [
                9.6e-10,
                0.20796618776,
                18139.2945014159
            ],
            [
                1.11e-9,
                5.01961920313,
                11823.1616394502
            ],
            [
                9e-10,
                2.72355843779,
                26880.3198130326
            ],
            [
                9.9e-10,
                0.90164266199,
                18635.9284545362
            ],
            [
                1.26e-9,
                4.78722177847,
                305281.9430710488
            ],
            [
                1.24e-9,
                5.00979495566,
                172146.9713405403
            ],
            [
                9e-10,
                4.50544881196,
                40077.61957352
            ],
            [
                1.04e-9,
                5.6367968071,
                2787.0430238574
            ],
            [
                9.1e-10,
                5.43564326147,
                6272.0301497275
            ],
            [
                1e-9,
                2.00639461597,
                12323.4230960088
            ],
            [
                1.17e-9,
                2.35555589778,
                83286.91426955358
            ],
            [
                1.05e-9,
                2.59824000109,
                30666.1549584328
            ],
            [
                9e-10,
                2.35779490026,
                12491.3701014155
            ],
            [
                8.9e-10,
                3.57152453732,
                11720.0688652316
            ],
            [
                9.5e-10,
                5.67015349858,
                14919.0178537546
            ],
            [
                8.7e-10,
                1.86043406047,
                27707.5424942948
            ],
            [
                1.06e-9,
                3.04150600352,
                22345.2603761082
            ],
            [
                8.2e-10,
                5.58298993353,
                10241.2022911672
            ],
            [
                8.3e-10,
                3.10607039533,
                36147.4098773004
            ],
            [
                9.4e-10,
                5.47749711149,
                9924.8104215106
            ],
            [
                8.2e-10,
                4.71988314145,
                15141.390794312
            ],
            [
                9.6e-10,
                3.89073946348,
                6379.0550772092
            ],
            [
                1.1e-9,
                4.92131611151,
                5621.8429232104
            ],
            [
                1.1e-9,
                4.89978492291,
                72140.6286666874
            ],
            [
                9.7e-10,
                5.20764563059,
                6303.4311693902
            ],
            [
                8.5e-10,
                1.61269222311,
                33326.5787331742
            ],
            [
                9.3e-10,
                1.32651591333,
                23020.65308658799
            ],
            [
                9e-10,
                0.5773301638,
                26482.1708096244
            ],
            [
                7.8e-10,
                3.99588630754,
                11293.4706743556
            ],
            [
                1.06e-9,
                3.92012705073,
                62883.3551395136
            ],
            [
                9.8e-10,
                2.94397773524,
                316.3918696566
            ],
            [
                7.6e-10,
                3.96310417608,
                29026.48522950779
            ],
            [
                9.8e-10,
                0.95914722366,
                48739.859897083
            ],
            [
                7.8e-10,
                1.97068528043,
                90279.92316810328
            ],
            [
                7.6e-10,
                0.23027966596,
                21424.4666443034
            ],
            [
                7.9e-10,
                1.46227790922,
                8982.810669309
            ],
            [
                7.8e-10,
                2.28840998832,
                266.6070417218
            ],
            [
                7.1e-10,
                1.5194076559,
                33794.5437235286
            ],
            [
                7.6e-10,
                0.22880641443,
                57375.8019008462
            ],
            [
                9.7e-10,
                0.39449562097,
                24279.10701821359
            ],
            [
                7.5e-10,
                2.77638584795,
                12964.300703391
            ],
            [
                7.7e-10,
                5.18846946344,
                11520.9968637952
            ],
            [
                6.8e-10,
                0.50006599129,
                4274.5183108324
            ],
            [
                7.5e-10,
                2.07323762803,
                15664.03552270859
            ],
            [
                7.7e-10,
                0.4666517878,
                16207.886271502
            ],
            [
                8.1e-10,
                4.10452219483,
                161710.6187862324
            ],
            [
                7.1e-10,
                3.91415328513,
                7875.6718636242
            ],
            [
                8.1e-10,
                0.91938383406,
                74.7815985673
            ],
            [
                8.3e-10,
                4.69916218791,
                23006.42599258639
            ],
            [
                6.9e-10,
                0.98999300277,
                6393.2821712108
            ],
            [
                6.5e-10,
                5.41938745446,
                28628.3362260996
            ],
            [
                7.3e-10,
                2.45564765251,
                15508.6151232744
            ],
            [
                6.5e-10,
                3.02336771694,
                5959.570433334
            ],
            [
                6.4e-10,
                0.18375587635,
                1066.49547719
            ],
            [
                8e-10,
                5.81239171612,
                12341.8069042809
            ],
            [
                6.6e-10,
                2.15105504851,
                38.0276726358
            ],
            [
                6.7e-10,
                5.14047250153,
                9814.6041002912
            ],
            [
                6.2e-10,
                2.43313614978,
                10138.1095169486
            ],
            [
                6.8e-10,
                2.24442548639,
                24383.0791084414
            ],
            [
                7.8e-10,
                1.39649333997,
                9411.4646150872
            ],
            [
                5.9e-10,
                4.95362151577,
                35707.7100829074
            ],
            [
                7.3e-10,
                1.35229143121,
                5327.4761083828
            ],
            [
                5.7e-10,
                3.16018882154,
                5490.300961524
            ],
            [
                7.2e-10,
                5.91833527334,
                10881.0995774812
            ],
            [
                6.7e-10,
                0.66414713064,
                29864.334027309
            ],
            [
                6.5e-10,
                0.30352816135,
                7018.9523635232
            ],
            [
                5.9e-10,
                5.36231868425,
                10239.5838660108
            ],
            [
                5.6e-10,
                3.22196331515,
                2636.725472637
            ],
            [
                6.8e-10,
                5.32086226658,
                3116.6594122598
            ],
            [
                5.9e-10,
                1.63156134967,
                61306.0115970658
            ],
            [
                5.4e-10,
                4.29491690425,
                21947.1113727
            ],
            [
                7e-10,
                0.29271565928,
                6528.9074962208
            ],
            [
                5.7e-10,
                5.89190132575,
                34513.2630726828
            ],
            [
                5.4e-10,
                2.51856815404,
                6279.1945146334
            ],
            [
                7.4e-10,
                1.38235845304,
                9967.4538999816
            ],
            [
                5.4e-10,
                0.92276712152,
                6286.9571853494
            ],
            [
                7e-10,
                5.00933012248,
                6453.7487206106
            ],
            [
                5.3e-10,
                3.86543309344,
                32370.9789915656
            ],
            [
                5.5e-10,
                4.51794544854,
                34911.412076091
            ],
            [
                6.3e-10,
                5.41479412056,
                11502.8376165305
            ],
            [
                6.3e-10,
                2.34416220742,
                11510.7019230567
            ],
            [
                5.6e-10,
                0.91310629913,
                9910.583327509
            ],
            [
                6.7e-10,
                4.03308763854,
                34596.3646546524
            ],
            [
                6e-10,
                5.57024703495,
                5756.9080032458
            ],
            [
                7.2e-10,
                2.80863088166,
                10866.8724834796
            ],
            [
                6.6e-10,
                6.12047940728,
                12074.488407524
            ],
            [
                5.1e-10,
                2.59519527563,
                11396.5634485742
            ],
            [
                6.2e-10,
                5.14746754396,
                25287.7237993998
            ],
            [
                5.4e-10,
                2.50994032776,
                5999.2165311262
            ],
            [
                5.1e-10,
                4.51195861837,
                29822.7832363242
            ],
            [
                5.9e-10,
                0.44167237876,
                250570.6758572191
            ],
            [
                5.1e-10,
                3.6884906676,
                6262.7205305926
            ],
            [
                4.9e-10,
                0.54704693048,
                22594.05489571199
            ],
            [
                6.5e-10,
                2.38423614501,
                52670.0695933026
            ],
            [
                6.9e-10,
                5.34363738671,
                66813.5648357332
            ],
            [
                5.6e-10,
                2.67216180349,
                17892.93839400359
            ],
            [
                4.9e-10,
                4.18361320516,
                18606.4989460002
            ],
            [
                5.5e-10,
                0.83886167974,
                20452.8694122218
            ],
            [
                5e-10,
                1.46327331958,
                37455.7264959744
            ],
            [
                5.8e-10,
                3.34847975377,
                33990.6183442862
            ],
            [
                6.5e-10,
                1.45522693982,
                76251.32777062019
            ],
            [
                5.6e-10,
                2.356506642,
                37724.7534197482
            ],
            [
                4.8e-10,
                1.80689447612,
                206.1855484372
            ],
            [
                5.6e-10,
                3.84224878744,
                5483.254724826
            ],
            [
                5.3e-10,
                0.17334326094,
                77717.29458646949
            ],
            [
                5.3e-10,
                0.79879700631,
                77710.24834977149
            ],
            [
                4.7e-10,
                0.43240779709,
                735.8765135318
            ],
            [
                5.3e-10,
                4.58786566028,
                11616.976091013
            ],
            [
                4.8e-10,
                6.20230111054,
                4171.4255366138
            ],
            [
                5.2e-10,
                2.9171905303,
                6993.0088985497
            ],
            [
                5.7e-10,
                3.42008310383,
                50317.2034395308
            ],
            [
                4.8e-10,
                0.12356889012,
                13362.4497067992
            ],
            [
                6e-10,
                5.52056066934,
                949.1756089698
            ],
            [
                4.5e-10,
                3.37963782356,
                10763.779709261
            ],
            [
                4.7e-10,
                5.50958184902,
                12779.4507954208
            ],
            [
                5.2e-10,
                5.42770349015,
                310145.1528239236
            ],
            [
                6.1e-10,
                2.93237974631,
                5791.4125575326
            ],
            [
                4.4e-10,
                2.87440620802,
                8584.6616659008
            ],
            [
                4.6e-10,
                4.0314179656,
                10667.8004820432
            ],
            [
                4.4e-10,
                1.21579107625,
                6272.4391846416
            ],
            [
                4.7e-10,
                2.57670800912,
                11492.542675792
            ],
            [
                4.4e-10,
                3.62570223167,
                63658.8777508376
            ],
            [
                5.1e-10,
                0.84531181151,
                12345.739057544
            ],
            [
                4.6e-10,
                1.17584556517,
                149.5631971346
            ],
            [
                4.3e-10,
                0.01524970172,
                37853.8754993826
            ],
            [
                4.3e-10,
                0.79038834934,
                640.8776073822
            ],
            [
                4.4e-10,
                2.22554419931,
                6293.7125153412
            ],
            [
                4.9e-10,
                1.01528394907,
                149144.46708624958
            ],
            [
                4.1e-10,
                3.27146326065,
                8858.3149443206
            ],
            [
                4.5e-10,
                3.03765521215,
                65236.2212932854
            ],
            [
                5.8e-10,
                5.45843180927,
                1975.492545856
            ],
            [
                4.1e-10,
                1.32190847146,
                2547.8375382324
            ],
            [
                4.7e-10,
                3.67626039848,
                28313.288804661
            ],
            [
                4.7e-10,
                6.21438985953,
                10991.3058987006
            ],
            [
                4e-10,
                2.37237751212,
                8273.8208670324
            ],
            [
                5.6e-10,
                1.09773690181,
                77376.2010224076
            ],
            [
                4e-10,
                2.35698541041,
                2699.7348193176
            ],
            [
                4.3e-10,
                5.28030897946,
                17796.9591667858
            ],
            [
                5.4e-10,
                2.59175932091,
                22910.44676536859
            ],
            [
                5.5e-10,
                0.07988985505,
                83467.15635301729
            ],
            [
                4.1e-10,
                4.47510694062,
                5618.3198048614
            ],
            [
                4e-10,
                1.35670430524,
                27177.8515292002
            ],
            [
                4.1e-10,
                2.48011323946,
                6549.6828917132
            ],
            [
                5e-10,
                2.56387920528,
                82576.9812209953
            ],
            [
                4.2e-10,
                4.78798367468,
                7856.89627409019
            ],
            [
                4.7e-10,
                2.75482175292,
                18202.21671665939
            ],
            [
                3.9e-10,
                1.97008298629,
                24491.4257925834
            ],
            [
                4.2e-10,
                4.04346599946,
                7863.9425107882
            ],
            [
                3.9e-10,
                3.0103393642,
                853.196381752
            ],
            [
                3.8e-10,
                0.49178679251,
                38650.173506199
            ],
            [
                4.4e-10,
                1.35931241699,
                21393.5419698576
            ],
            [
                3.6e-10,
                4.86047906533,
                4157.1984426122
            ],
            [
                4.3e-10,
                5.64354880978,
                1062.9050485382
            ],
            [
                3.9e-10,
                3.92736779879,
                3903.9113764198
            ],
            [
                4e-10,
                5.3969491832,
                9498.2122306346
            ],
            [
                4.3e-10,
                2.40863861919,
                29424.634232916
            ],
            [
                4.6e-10,
                2.08022244271,
                12573.2652469836
            ],
            [
                5e-10,
                6.15760345261,
                78051.34191383338
            ]
        ],
        "1": [
            [
                0.00103018607,
                1.10748968172,
                6283.0758499914
            ],
            [
                0.00001721238,
                1.06442300386,
                12566.1516999828
            ],
            [
                0.00000702217,
                3.14159265359,
                0
            ],
            [
                3.2345e-7,
                1.02168583254,
                18849.2275499742
            ],
            [
                3.0801e-7,
                2.84358443952,
                5507.5532386674
            ],
            [
                2.4978e-7,
                1.31906570344,
                5223.6939198022
            ],
            [
                1.8487e-7,
                1.42428709076,
                1577.3435424478
            ],
            [
                1.0077e-7,
                5.91385248388,
                10977.078804699
            ],
            [
                8.635e-8,
                0.27158192945,
                5486.777843175
            ],
            [
                8.654e-8,
                1.42046854427,
                6275.9623029906
            ],
            [
                5.069e-8,
                1.68613408916,
                5088.6288397668
            ],
            [
                4.985e-8,
                6.01402338185,
                6286.5989683404
            ],
            [
                4.667e-8,
                5.98749245692,
                529.6909650946
            ],
            [
                4.395e-8,
                0.51800423445,
                4694.0029547076
            ],
            [
                3.87e-8,
                4.74932206877,
                2544.3144198834
            ],
            [
                3.755e-8,
                5.07053801166,
                796.2980068164
            ],
            [
                4.1e-8,
                1.08424801084,
                9437.762934887
            ],
            [
                3.518e-8,
                0.02290216978,
                83996.84731811189
            ],
            [
                3.436e-8,
                0.94937503872,
                71430.69561812909
            ],
            [
                3.221e-8,
                6.15628775321,
                2146.1654164752
            ],
            [
                3.418e-8,
                5.4115158188,
                775.522611324
            ],
            [
                2.863e-8,
                5.48433323746,
                10447.3878396044
            ],
            [
                2.525e-8,
                0.24296913555,
                398.1490034082
            ],
            [
                2.205e-8,
                4.94892172085,
                6812.766815086
            ],
            [
                2.186e-8,
                0.41991932164,
                8031.0922630584
            ],
            [
                2.828e-8,
                3.41986300734,
                2352.8661537718
            ],
            [
                2.554e-8,
                6.13241770582,
                6438.4962494256
            ],
            [
                1.932e-8,
                5.31374587091,
                8429.2412664666
            ],
            [
                2.427e-8,
                3.09118902115,
                4690.4798363586
            ],
            [
                1.73e-8,
                1.53685999718,
                4705.7323075436
            ],
            [
                2.25e-8,
                3.6883639562,
                7084.8967811152
            ],
            [
                2.094e-8,
                1.281690604,
                1748.016413067
            ],
            [
                1.483e-8,
                3.22226346483,
                7234.794256242
            ],
            [
                1.434e-8,
                0.81293662216,
                14143.4952424306
            ],
            [
                1.754e-8,
                3.22883705112,
                6279.5527316424
            ],
            [
                1.583e-8,
                4.09815978783,
                11499.6562227928
            ],
            [
                1.575e-8,
                5.53890314149,
                3154.6870848956
            ],
            [
                1.847e-8,
                1.82041234937,
                7632.9432596502
            ],
            [
                1.499e-8,
                3.63177937611,
                11513.8833167944
            ],
            [
                1.337e-8,
                4.64442556061,
                6836.6452528338
            ],
            [
                1.275e-8,
                2.69329661394,
                1349.8674096588
            ],
            [
                1.348e-8,
                6.15284035323,
                5746.271337896
            ],
            [
                1.126e-8,
                3.35676107739,
                17789.845619785
            ],
            [
                1.47e-8,
                3.65282991735,
                1194.4470102246
            ],
            [
                1.101e-8,
                4.4974742767,
                4292.3308329504
            ],
            [
                1.168e-8,
                2.58033028504,
                13367.9726311066
            ],
            [
                1.236e-8,
                5.64980098028,
                5760.4984318976
            ],
            [
                9.85e-9,
                0.65326301914,
                5856.4776591154
            ],
            [
                9.28e-9,
                2.3255501829,
                10213.285546211
            ],
            [
                1.073e-8,
                5.82672338169,
                12036.4607348882
            ],
            [
                9.18e-9,
                0.76907130762,
                16730.4636895958
            ],
            [
                8.76e-9,
                1.50335727807,
                11926.2544136688
            ],
            [
                1.023e-8,
                5.62071200879,
                6256.7775301916
            ],
            [
                8.53e-9,
                0.6567813463,
                155.4203994342
            ],
            [
                8.02e-9,
                4.10519132094,
                951.7184062506
            ],
            [
                8.59e-9,
                1.42880883564,
                5753.3848848968
            ],
            [
                9.92e-9,
                1.1423800161,
                1059.3819301892
            ],
            [
                8.14e-9,
                1.63584008733,
                6681.2248533996
            ],
            [
                6.64e-9,
                4.55039663226,
                5216.5803728014
            ],
            [
                6.27e-9,
                1.50782904323,
                5643.1785636774
            ],
            [
                6.44e-9,
                4.19480024859,
                6040.3472460174
            ],
            [
                5.9e-9,
                6.18371704849,
                4164.311989613
            ],
            [
                6.35e-9,
                0.5242358477,
                6290.1893969922
            ],
            [
                6.5e-9,
                0.97935492869,
                25132.3033999656
            ],
            [
                5.68e-9,
                2.30121525349,
                10973.55568635
            ],
            [
                5.49e-9,
                5.26737827342,
                3340.6124266998
            ],
            [
                5.47e-9,
                2.20143332641,
                1592.5960136328
            ],
            [
                5.26e-9,
                0.92464258271,
                11371.7046897582
            ],
            [
                4.93e-9,
                5.91036281399,
                3894.1818295422
            ],
            [
                4.83e-9,
                1.6600571154,
                12168.0026965746
            ],
            [
                5.14e-9,
                3.59683072524,
                10969.9652576982
            ],
            [
                5.16e-9,
                3.97164781773,
                17298.1823273262
            ],
            [
                5.29e-9,
                5.0353867768,
                9917.6968745098
            ],
            [
                4.87e-9,
                2.50544745305,
                6127.6554505572
            ],
            [
                4.19e-9,
                4.05235655996,
                10984.1923516998
            ],
            [
                5.38e-9,
                5.54081539813,
                553.5694028424
            ],
            [
                4.02e-9,
                2.16859478359,
                7860.4193924392
            ],
            [
                5.52e-9,
                2.32219865498,
                11506.7697697936
            ],
            [
                3.67e-9,
                3.39145698451,
                6496.3749454294
            ],
            [
                3.6e-9,
                5.34467204596,
                7079.3738568078
            ],
            [
                3.34e-9,
                3.61346365667,
                11790.6290886588
            ],
            [
                4.54e-9,
                0.28755421898,
                801.8209311238
            ],
            [
                4.19e-9,
                3.69613970002,
                10575.4066829418
            ],
            [
                3.19e-9,
                0.30793759304,
                16200.7727245012
            ],
            [
                3.76e-9,
                5.81560210508,
                7058.5984613154
            ],
            [
                3.64e-9,
                1.08425056923,
                6309.3741697912
            ],
            [
                2.94e-9,
                4.54798604178,
                11856.2186514245
            ],
            [
                2.9e-9,
                1.26451946335,
                8635.9420037632
            ],
            [
                3.94e-9,
                4.15683669084,
                26.2983197998
            ],
            [
                2.6e-9,
                5.09424572996,
                10177.2576795336
            ],
            [
                2.41e-9,
                2.25766000302,
                11712.9553182308
            ],
            [
                2.39e-9,
                1.06936978753,
                242.728603974
            ],
            [
                2.76e-9,
                3.44260568764,
                5884.9268465832
            ],
            [
                2.55e-9,
                5.38496803122,
                21228.3920235458
            ],
            [
                3.07e-9,
                4.24313885601,
                3738.761430108
            ],
            [
                2.13e-9,
                3.44661200485,
                213.299095438
            ],
            [
                1.98e-9,
                0.69427265195,
                1990.745017041
            ],
            [
                1.95e-9,
                5.16563409007,
                12352.8526045448
            ],
            [
                2.13e-9,
                3.89937836808,
                13916.0191096416
            ],
            [
                2.14e-9,
                4.00445200772,
                5230.807466803
            ],
            [
                1.84e-9,
                5.59805976614,
                6283.14316029419
            ],
            [
                1.84e-9,
                2.85275392124,
                7238.6755916
            ],
            [
                1.79e-9,
                2.54259058252,
                14314.1681130498
            ],
            [
                2.36e-9,
                5.58826125715,
                6069.7767545534
            ],
            [
                1.89e-9,
                2.72689937708,
                6062.6632075526
            ],
            [
                1.84e-9,
                6.04216273598,
                6283.0085396886
            ],
            [
                2.25e-9,
                1.66128561344,
                4732.0306273434
            ],
            [
                2.3e-9,
                3.62591335086,
                6284.0561710596
            ],
            [
                1.72e-9,
                0.97566476085,
                3930.2096962196
            ],
            [
                1.62e-9,
                2.19467339429,
                18073.7049386502
            ],
            [
                2.15e-9,
                1.04672844028,
                3496.032826134
            ],
            [
                1.82e-9,
                5.17782354566,
                17253.04110768959
            ],
            [
                1.67e-9,
                2.17754938066,
                6076.8903015542
            ],
            [
                1.67e-9,
                4.75672473773,
                17267.26820169119
            ],
            [
                1.49e-9,
                0.80944185798,
                709.9330485583
            ],
            [
                1.49e-9,
                0.17584214812,
                9779.1086761254
            ],
            [
                1.92e-9,
                5.00680790235,
                11015.1064773348
            ],
            [
                1.41e-9,
                4.38420380014,
                4136.9104335162
            ],
            [
                1.58e-9,
                4.60969054283,
                9623.6882766912
            ],
            [
                1.33e-9,
                3.30507062245,
                154717.6098876827
            ],
            [
                1.66e-9,
                6.13191098325,
                3.523118349
            ],
            [
                1.81e-9,
                1.60715321141,
                7.1135470008
            ],
            [
                1.5e-9,
                5.28136702046,
                13517.8701062334
            ],
            [
                1.42e-9,
                0.49788089569,
                25158.6017197654
            ],
            [
                1.24e-9,
                6.03440459813,
                9225.539273283
            ],
            [
                1.24e-9,
                0.99251562639,
                65147.6197681377
            ],
            [
                1.28e-9,
                1.92032744711,
                22483.84857449259
            ],
            [
                1.24e-9,
                3.99739675184,
                4686.8894077068
            ],
            [
                1.21e-9,
                2.37814805239,
                167283.7615876655
            ],
            [
                1.23e-9,
                5.6231511294,
                5642.1982426092
            ],
            [
                1.17e-9,
                5.81755956156,
                12569.6748183318
            ],
            [
                1.57e-9,
                3.40236948518,
                16496.3613962024
            ],
            [
                1.3e-9,
                2.10499918142,
                1589.0728952838
            ],
            [
                1.16e-9,
                0.55839966736,
                5849.3641121146
            ],
            [
                1.23e-9,
                5.81645568991,
                6282.0955289232
            ],
            [
                1.1e-9,
                0.42176497674,
                6172.869528772
            ],
            [
                1.5e-9,
                4.26279600865,
                3128.3887650958
            ],
            [
                1.06e-9,
                2.27436561182,
                5429.8794682394
            ],
            [
                1.14e-9,
                1.52894564202,
                12559.038152982
            ],
            [
                1.21e-9,
                0.39459045915,
                12132.439962106
            ],
            [
                1.04e-9,
                2.41845930933,
                426.598190876
            ],
            [
                1.09e-9,
                5.82786999856,
                16858.4825329332
            ],
            [
                1.02e-9,
                4.4662648491,
                23543.23050468179
            ],
            [
                1e-9,
                2.93812275274,
                4535.0594369244
            ],
            [
                9.7e-10,
                3.97935904984,
                6133.5126528568
            ],
            [
                9.8e-10,
                0.87616810121,
                6525.8044539654
            ],
            [
                1.1e-9,
                6.22339014386,
                12146.6670561076
            ],
            [
                9.8e-10,
                3.17344332543,
                10440.2742926036
            ],
            [
                9.6e-10,
                2.44128701699,
                3097.88382272579
            ],
            [
                9.9e-10,
                5.75642493267,
                7342.4577801806
            ],
            [
                9e-10,
                0.18984343165,
                13119.72110282519
            ],
            [
                9.9e-10,
                5.58884724219,
                2388.8940204492
            ],
            [
                9.1e-10,
                6.04278320182,
                20426.571092422
            ],
            [
                8e-10,
                1.29028142103,
                5650.2921106782
            ],
            [
                8.6e-10,
                3.94529200528,
                10454.5013866052
            ],
            [
                8.5e-10,
                1.92836879835,
                29088.811415985
            ],
            [
                7.6e-10,
                2.70726317966,
                143571.32428481648
            ],
            [
                9.1e-10,
                5.63859073351,
                8827.3902698748
            ],
            [
                7.6e-10,
                1.80783856698,
                28286.9904848612
            ],
            [
                7.5e-10,
                3.40858032804,
                5481.2549188676
            ],
            [
                7e-10,
                4.53719487231,
                17256.6315363414
            ],
            [
                8.9e-10,
                1.10064490942,
                11769.8536931664
            ],
            [
                6.6e-10,
                2.78384937771,
                536.8045120954
            ],
            [
                6.8e-10,
                3.88199295043,
                17260.1546546904
            ],
            [
                8.8e-10,
                3.88075269535,
                7477.522860216
            ],
            [
                6.1e-10,
                6.17558202197,
                11087.2851259184
            ],
            [
                6e-10,
                4.34824715818,
                6206.8097787158
            ],
            [
                8.2e-10,
                4.59843208943,
                9388.0059094152
            ],
            [
                7.9e-10,
                1.63139280394,
                4933.2084403326
            ],
            [
                8.1e-10,
                1.55550779371,
                9380.9596727172
            ],
            [
                7.8e-10,
                4.20905757519,
                5729.506447149
            ],
            [
                5.8e-10,
                5.76889633224,
                3634.6210245184
            ],
            [
                6e-10,
                0.93813100594,
                12721.572099417
            ],
            [
                7.1e-10,
                6.11408885148,
                8662.240323563
            ],
            [
                5.7e-10,
                5.48112524468,
                18319.5365848796
            ],
            [
                7e-10,
                0.01749174864,
                14945.3161735544
            ],
            [
                7.4e-10,
                1.0997604582,
                16460.33352952499
            ],
            [
                5.6e-10,
                1.63036186739,
                15720.8387848784
            ],
            [
                5.5e-10,
                4.86788348404,
                13095.8426650774
            ],
            [
                6e-10,
                5.93729841267,
                12539.853380183
            ],
            [
                5.4e-10,
                0.22608242982,
                15110.4661198662
            ],
            [
                5.4e-10,
                2.30250047594,
                16062.1845261168
            ],
            [
                6.4e-10,
                2.13513754101,
                7875.6718636242
            ],
            [
                5.9e-10,
                5.87963500139,
                5331.3574437408
            ],
            [
                5.8e-10,
                2.30546168615,
                955.5997416086
            ],
            [
                4.9e-10,
                1.93839278478,
                5333.9002410216
            ],
            [
                5.4e-10,
                5.80331607119,
                12043.574281889
            ],
            [
                5.4e-10,
                4.44671053809,
                4701.1165017084
            ],
            [
                4.9e-10,
                0.30241161485,
                6805.6532680852
            ],
            [
                4.6e-10,
                2.76898193028,
                6709.6740408674
            ],
            [
                4.6e-10,
                3.98449608961,
                98068.53671630539
            ],
            [
                4.9e-10,
                3.72022009896,
                12323.4230960088
            ],
            [
                4.5e-10,
                3.30065998328,
                22003.9146348698
            ],
            [
                4.8e-10,
                0.71071357303,
                6303.4311693902
            ],
            [
                6.1e-10,
                1.66030429494,
                6262.300454499
            ],
            [
                4.7e-10,
                1.26317154881,
                11919.140866668
            ],
            [
                5.1e-10,
                1.08020906825,
                10988.808157535
            ],
            [
                4.5e-10,
                0.89150445122,
                51868.2486621788
            ],
            [
                4.3e-10,
                0.57756724285,
                24356.7807886416
            ],
            [
                4.3e-10,
                1.61526242998,
                6277.552925684
            ],
            [
                4.5e-10,
                2.96132920534,
                8982.810669309
            ],
            [
                4.3e-10,
                5.74295325645,
                11403.676995575
            ],
            [
                5.5e-10,
                3.14274403422,
                33019.0211122046
            ],
            [
                5.7e-10,
                0.06379726305,
                15671.0817594066
            ],
            [
                4.1e-10,
                2.53761820726,
                6262.7205305926
            ],
            [
                4e-10,
                1.53130436944,
                18451.07854656599
            ],
            [
                5.2e-10,
                1.71451922581,
                1551.045222648
            ],
            [
                5.5e-10,
                0.89439119424,
                11933.3679606696
            ],
            [
                4.5e-10,
                3.88495384656,
                60530.4889857418
            ],
            [
                4e-10,
                4.75740908001,
                38526.574350872
            ],
            [
                4e-10,
                3.77498297348,
                26087.9031415742
            ],
            [
                3.9e-10,
                2.97113832621,
                2118.7638603784
            ],
            [
                4e-10,
                3.36050962605,
                10021.8372800994
            ],
            [
                4.7e-10,
                1.67051113434,
                6303.8512454838
            ],
            [
                5.2e-10,
                5.21827368711,
                77713.7714681205
            ],
            [
                4.7e-10,
                4.26356628717,
                21424.4666443034
            ],
            [
                3.7e-10,
                1.66712389942,
                6819.8803620868
            ],
            [
                3.7e-10,
                0.65746800933,
                12029.3471878874
            ],
            [
                3.5e-10,
                3.36255650927,
                24072.9214697764
            ],
            [
                3.6e-10,
                0.11087914947,
                10344.2950653858
            ],
            [
                4e-10,
                4.14725582115,
                2787.0430238574
            ],
            [
                3.5e-10,
                5.93650887012,
                31570.7996493912
            ],
            [
                3.6e-10,
                2.15108874765,
                30774.5016425748
            ],
            [
                3.6e-10,
                1.75078825382,
                16207.886271502
            ],
            [
                3.4e-10,
                2.75708224536,
                12139.5535091068
            ],
            [
                3.4e-10,
                6.168913788,
                24491.4257925834
            ],
            [
                3.4e-10,
                2.31528650443,
                55798.4583583984
            ],
            [
                3.2e-10,
                4.21446357042,
                15664.03552270859
            ],
            [
                3.4e-10,
                3.19783054699,
                32217.2001810808
            ],
            [
                3.9e-10,
                1.24979117796,
                6418.1409300268
            ],
            [
                3.8e-10,
                5.89832942685,
                640.8776073822
            ],
            [
                3.3e-10,
                4.80200120107,
                16723.350142595
            ],
            [
                3.2e-10,
                1.72442327688,
                27433.88921587499
            ],
            [
                3.5e-10,
                4.44608896525,
                18202.21671665939
            ],
            [
                3.1e-10,
                4.5279073128,
                6702.5604938666
            ],
            [
                3.4e-10,
                3.96287980676,
                18216.443810661
            ],
            [
                3e-10,
                5.06259854444,
                226858.23855437007
            ],
            [
                3.4e-10,
                1.43910280005,
                49515.382508407
            ],
            [
                3e-10,
                0.29303163371,
                13521.7514415914
            ],
            [
                2.9e-10,
                2.0263384022,
                11609.8625440122
            ],
            [
                3e-10,
                2.5492323024,
                9924.8104215106
            ],
            [
                3.2e-10,
                4.91793198558,
                11300.5842213564
            ],
            [
                3e-10,
                0.23284423547,
                23581.2581773176
            ],
            [
                2.9e-10,
                1.62807736495,
                639.897286314
            ],
            [
                2.8e-10,
                3.84568936822,
                2699.7348193176
            ],
            [
                2.9e-10,
                1.83149729794,
                29822.7832363242
            ],
            [
                3.3e-10,
                4.60320094415,
                19004.6479494084
            ],
            [
                2.7e-10,
                1.86151121799,
                6288.5987742988
            ],
            [
                3e-10,
                4.4649407224,
                36147.4098773004
            ],
            [
                2.8e-10,
                5.19684492912,
                5863.5912061162
            ],
            [
                3.5e-10,
                4.52695674113,
                36949.2308084242
            ],
            [
                2.7e-10,
                3.52528177609,
                10770.8932562618
            ],
            [
                2.6e-10,
                1.48499438453,
                11080.1715789176
            ],
            [
                3.5e-10,
                2.82154380962,
                19402.7969528166
            ],
            [
                2.5e-10,
                2.46339998836,
                6279.4854213396
            ],
            [
                2.6e-10,
                4.97688894643,
                16737.5772365966
            ],
            [
                2.7e-10,
                0.408271125,
                12964.300703391
            ],
            [
                2.9e-10,
                4.15148654061,
                45892.73043315699
            ],
            [
                2.6e-10,
                4.56404104286,
                17796.9591667858
            ],
            [
                2.5e-10,
                2.89309528854,
                6286.6662786432
            ],
            [
                2.6e-10,
                4.82914580957,
                1066.49547719
            ],
            [
                3.1e-10,
                3.93096113738,
                29864.334027309
            ],
            [
                2.4e-10,
                6.14987193584,
                18606.4989460002
            ],
            [
                2.4e-10,
                3.74225964547,
                29026.48522950779
            ],
            [
                2.5e-10,
                5.70460621565,
                27707.5424942948
            ],
            [
                2.5e-10,
                5.33928840652,
                15141.390794312
            ],
            [
                2.3e-10,
                2.37624087345,
                17996.0311682222
            ],
            [
                2.6e-10,
                1.34231351782,
                18875.525869774
            ],
            [
                2.2e-10,
                5.5079162612,
                6245.0481773556
            ],
            [
                2.4e-10,
                1.33998410121,
                19800.9459562248
            ],
            [
                2.3e-10,
                0.2251228089,
                6279.7894925736
            ],
            [
                2.2e-10,
                1.17576471775,
                11925.2740926006
            ],
            [
                2.2e-10,
                3.5860360664,
                6915.8595893046
            ],
            [
                2.3e-10,
                3.21621246666,
                6286.3622074092
            ],
            [
                2.9e-10,
                2.09564449439,
                15265.8865193004
            ],
            [
                2.2e-10,
                4.74660932338,
                28230.18722269139
            ],
            [
                2.1e-10,
                2.30688751432,
                5999.2165311262
            ],
            [
                2.8e-10,
                3.92087592807,
                18208.349942592
            ],
            [
                2.1e-10,
                3.22643339385,
                25934.1243310894
            ],
            [
                2.1e-10,
                3.04956726238,
                6566.9351688566
            ],
            [
                2.7e-10,
                5.35645770522,
                33794.5437235286
            ],
            [
                2.5e-10,
                5.91542362188,
                6489.2613984286
            ],
            [
                2e-10,
                1.52296293311,
                135.0650800354
            ],
            [
                1.9e-10,
                1.78134428631,
                156137.47598479927
            ],
            [
                1.9e-10,
                0.34388684087,
                5327.4761083828
            ],
            [
                2.6e-10,
                3.41701003233,
                25287.7237993998
            ],
            [
                1.9e-10,
                2.86664271911,
                18422.62935909819
            ],
            [
                1.9e-10,
                4.71432851499,
                77690.75950573849
            ],
            [
                1.9e-10,
                2.54227398241,
                77736.78343050249
            ],
            [
                2e-10,
                5.91915117116,
                48739.859897083
            ]
        ],
        "2": [
            [
                0.00004359385,
                5.78455133808,
                6283.0758499914
            ],
            [
                0.00000123633,
                5.57935427994,
                12566.1516999828
            ],
            [
                1.2342e-7,
                3.14159265359,
                0
            ],
            [
                8.792e-8,
                3.62777893099,
                77713.7714681205
            ],
            [
                5.689e-8,
                1.86958905084,
                5573.1428014331
            ],
            [
                3.302e-8,
                5.47034879713,
                18849.2275499742
            ],
            [
                1.471e-8,
                4.47964125007,
                5507.5532386674
            ],
            [
                1.013e-8,
                2.81323115556,
                5223.6939198022
            ],
            [
                8.54e-9,
                3.107765669,
                1577.3435424478
            ],
            [
                1.102e-8,
                2.84173992403,
                161000.6857376741
            ],
            [
                6.48e-9,
                5.47348203398,
                775.522611324
            ],
            [
                6.08e-9,
                1.37894173533,
                6438.4962494256
            ],
            [
                4.99e-9,
                4.4164924225,
                6286.5989683404
            ],
            [
                4.16e-9,
                0.90332697974,
                10977.078804699
            ],
            [
                4.04e-9,
                3.2056726953,
                5088.6288397668
            ],
            [
                3.51e-9,
                1.81081728907,
                5486.777843175
            ],
            [
                4.66e-9,
                3.65086758149,
                7084.8967811152
            ],
            [
                4.58e-9,
                5.38585314743,
                149854.4001348079
            ],
            [
                3.04e-9,
                3.51015066341,
                796.2980068164
            ],
            [
                2.66e-9,
                6.17413982699,
                6836.6452528338
            ],
            [
                2.81e-9,
                1.8387467254,
                4694.0029547076
            ],
            [
                2.62e-9,
                1.41420110644,
                2146.1654164752
            ],
            [
                2.64e-9,
                3.14103683911,
                71430.69561812909
            ],
            [
                3.19e-9,
                5.35037932146,
                3154.6870848956
            ],
            [
                2.38e-9,
                2.17695432424,
                155.4203994342
            ],
            [
                2.29e-9,
                4.7596958807,
                7234.794256242
            ],
            [
                2.91e-9,
                4.61776401638,
                4690.4798363586
            ],
            [
                2.11e-9,
                0.21864885298,
                4705.7323075436
            ],
            [
                2.04e-9,
                4.22895113488,
                1349.8674096588
            ],
            [
                1.95e-9,
                4.58550676556,
                529.6909650946
            ],
            [
                2.55e-9,
                2.81442711144,
                1748.016413067
            ],
            [
                1.82e-9,
                5.70454011389,
                6040.3472460174
            ],
            [
                1.8e-9,
                6.02147727878,
                4292.3308329504
            ],
            [
                1.86e-9,
                1.58690991244,
                6309.3741697912
            ],
            [
                1.67e-9,
                2.88802733052,
                9437.762934887
            ],
            [
                1.66e-9,
                1.99990574734,
                8031.0922630584
            ],
            [
                1.6e-9,
                0.04412738495,
                2544.3144198834
            ],
            [
                1.97e-9,
                2.01089431842,
                1194.4470102246
            ],
            [
                1.65e-9,
                5.78372596774,
                83996.84731811189
            ],
            [
                2.14e-9,
                3.38300910371,
                7632.9432596502
            ],
            [
                1.4e-9,
                0.36669664351,
                10447.3878396044
            ],
            [
                1.51e-9,
                0.95519595275,
                6127.6554505572
            ],
            [
                1.36e-9,
                1.48417295645,
                2352.8661537718
            ],
            [
                1.28e-9,
                5.48057748834,
                951.7184062506
            ],
            [
                1.26e-9,
                5.26866506592,
                6279.5527316424
            ],
            [
                1.27e-9,
                3.77552907014,
                6812.766815086
            ],
            [
                1.03e-9,
                4.95897533789,
                398.1490034082
            ],
            [
                1.04e-9,
                0.70183576826,
                1592.5960136328
            ],
            [
                1.01e-9,
                1.14481598642,
                3894.1818295422
            ],
            [
                1.31e-9,
                0.76624310306,
                553.5694028424
            ],
            [
                1.09e-9,
                5.41063597567,
                6256.7775301916
            ],
            [
                7.8e-10,
                5.84775340741,
                242.728603974
            ],
            [
                9.7e-10,
                1.94685257714,
                11856.2186514245
            ],
            [
                1e-9,
                5.19725292131,
                244287.60000722768
            ],
            [
                7.6e-10,
                0.70480774041,
                8429.2412664666
            ],
            [
                8e-10,
                6.18430772683,
                1059.3819301892
            ],
            [
                6.8e-10,
                5.29561709093,
                14143.4952424306
            ],
            [
                8.5e-10,
                5.39487308005,
                25132.3033999656
            ],
            [
                5.5e-10,
                5.16874637579,
                7058.5984613154
            ],
            [
                6.3e-10,
                0.48494730699,
                801.8209311238
            ],
            [
                5.8e-10,
                4.07254840265,
                13367.9726311066
            ],
            [
                5.1e-10,
                3.89696552232,
                12036.4607348882
            ],
            [
                5.1e-10,
                5.56335232286,
                1990.745017041
            ],
            [
                6e-10,
                2.2504659671,
                8635.9420037632
            ],
            [
                4.9e-10,
                5.58163417371,
                6290.1893969922
            ],
            [
                5.1e-10,
                3.87240194908,
                26.2983197998
            ],
            [
                5.1e-10,
                4.19300909995,
                7860.4193924392
            ],
            [
                4.1e-10,
                3.97169191582,
                10973.55568635
            ],
            [
                4.1e-10,
                3.5708091923,
                7079.3738568078
            ],
            [
                5.6e-10,
                2.76959005761,
                90955.5516944961
            ],
            [
                4.2e-10,
                1.91461189163,
                7477.522860216
            ],
            [
                4.2e-10,
                0.42775891995,
                10213.285546211
            ],
            [
                4.2e-10,
                1.06925480488,
                709.9330485583
            ],
            [
                3.8e-10,
                6.17935925345,
                9917.6968745098
            ],
            [
                5e-10,
                0.81691517401,
                11506.7697697936
            ],
            [
                5.3e-10,
                1.45828359397,
                233141.3144043615
            ],
            [
                3.8e-10,
                3.32444534628,
                5643.1785636774
            ],
            [
                4.7e-10,
                6.21543665927,
                6681.2248533996
            ],
            [
                3.7e-10,
                0.3635930998,
                10177.2576795336
            ],
            [
                4.5e-10,
                5.29587706357,
                10575.4066829418
            ],
            [
                3.4e-10,
                5.63446915337,
                6525.8044539654
            ],
            [
                3.4e-10,
                5.36385158519,
                4933.2084403326
            ],
            [
                3.5e-10,
                5.36152295839,
                25158.6017197654
            ],
            [
                4.2e-10,
                5.08837645072,
                11015.1064773348
            ],
            [
                4.2e-10,
                4.22496037505,
                88860.05707098669
            ],
            [
                3.9e-10,
                1.99171699618,
                6284.0561710596
            ],
            [
                2.9e-10,
                3.1908862817,
                11926.2544136688
            ],
            [
                2.9e-10,
                0.14996158324,
                12168.0026965746
            ],
            [
                3e-10,
                1.58346276808,
                9779.1086761254
            ],
            [
                2.6e-10,
                4.16210340581,
                12569.6748183318
            ],
            [
                3.6e-10,
                2.74684637873,
                3738.761430108
            ],
            [
                2.6e-10,
                0.7282491532,
                1589.0728952838
            ],
            [
                3.1e-10,
                5.34906371821,
                143571.32428481648
            ],
            [
                2.5e-10,
                0.10240267494,
                22483.84857449259
            ],
            [
                3e-10,
                3.47110495524,
                14945.3161735544
            ],
            [
                2.6e-10,
                3.89359701125,
                5753.3848848968
            ],
            [
                2.4e-10,
                1.18744224678,
                4535.0594369244
            ],
            [
                3.3e-10,
                2.99317143244,
                3930.2096962196
            ],
            [
                2.4e-10,
                1.57253767584,
                6496.3749454294
            ],
            [
                2.4e-10,
                3.47434797542,
                4136.9104335162
            ],
            [
                2.2e-10,
                3.91230073719,
                6275.9623029906
            ],
            [
                2.5e-10,
                4.02978941287,
                3128.3887650958
            ],
            [
                2.3e-10,
                1.07724492065,
                12721.572099417
            ],
            [
                2.1e-10,
                1.89591807148,
                16730.4636895958
            ],
            [
                2.5e-10,
                2.42198937013,
                5729.506447149
            ],
            [
                2e-10,
                1.78163489101,
                17789.845619785
            ],
            [
                2.1e-10,
                0.49258939822,
                29088.811415985
            ],
            [
                2.6e-10,
                4.14947806747,
                2388.8940204492
            ],
            [
                2.7e-10,
                2.54785812264,
                3496.032826134
            ],
            [
                2e-10,
                4.29944129273,
                16858.4825329332
            ],
            [
                2.1e-10,
                5.97796936723,
                7.1135470008
            ],
            [
                1.9e-10,
                0.80292033311,
                16062.1845261168
            ],
            [
                2.4e-10,
                4.89894141052,
                17260.1546546904
            ],
            [
                2.5e-10,
                1.37003752175,
                6282.0955289232
            ],
            [
                2.2e-10,
                4.92663152168,
                18875.525869774
            ],
            [
                2.3e-10,
                5.68902059771,
                16460.33352952499
            ],
            [
                2.3e-10,
                3.03021283729,
                66567.48586525429
            ],
            [
                1.6e-10,
                3.89713736666,
                5331.3574437408
            ],
            [
                1.6e-10,
                5.68562539832,
                12559.038152982
            ],
            [
                1.6e-10,
                3.95085099736,
                3097.88382272579
            ],
            [
                1.6e-10,
                3.99041783945,
                6283.14316029419
            ],
            [
                2e-10,
                6.106439191,
                167283.7615876655
            ],
            [
                1.5e-10,
                4.09775914607,
                11712.9553182308
            ],
            [
                1.6e-10,
                5.717699407,
                17298.1823273262
            ],
            [
                1.6e-10,
                3.28894009404,
                5884.9268465832
            ],
            [
                1.5e-10,
                4.4256424368,
                13517.8701062334
            ],
            [
                1.6e-10,
                4.4345208093,
                6283.0085396886
            ],
            [
                1.4e-10,
                1.44384279999,
                4164.311989613
            ],
            [
                1.4e-10,
                4.47380919159,
                11790.6290886588
            ],
            [
                1.4e-10,
                4.77646531825,
                7342.4577801806
            ],
            [
                1.1e-10,
                2.56768522896,
                5481.2549188676
            ],
            [
                1.1e-10,
                1.514433322,
                16200.7727245012
            ],
            [
                1.1e-10,
                0.88708889185,
                21228.3920235458
            ],
            [
                1.4e-10,
                4.50116508534,
                640.8776073822
            ]
        ],
        "3": [
            [
                0.00000144595,
                4.27319433901,
                6283.0758499914
            ],
            [
                6.729e-8,
                3.91706261708,
                12566.1516999828
            ],
            [
                7.74e-9,
                0,
                0
            ],
            [
                2.47e-9,
                3.73021571217,
                18849.2275499742
            ],
            [
                3.6e-10,
                2.8008140905,
                6286.5989683404
            ],
            [
                3.3e-10,
                5.62990083112,
                6127.6554505572
            ],
            [
                1.8e-10,
                3.72826142555,
                6438.4962494256
            ],
            [
                1.6e-10,
                4.26011484232,
                6525.8044539654
            ],
            [
                1.4e-10,
                3.47817116396,
                6256.7775301916
            ],
            [
                1.2e-10,
                3.55747379482,
                25132.3033999656
            ],
            [
                1e-10,
                4.43995693209,
                4705.7323075436
            ],
            [
                1e-10,
                4.2804525547,
                83996.84731811189
            ],
            [
                9e-11,
                5.36457057335,
                6040.3472460174
            ],
            [
                8e-11,
                1.78458957263,
                5507.5532386674
            ],
            [
                9e-11,
                0.4727519993,
                6279.5527316424
            ],
            [
                9e-11,
                1.34741231639,
                6309.3741697912
            ],
            [
                9e-11,
                0.77092900708,
                5729.506447149
            ],
            [
                7e-11,
                3.50146897332,
                7058.5984613154
            ],
            [
                5e-11,
                2.890710617,
                775.522611324
            ],
            [
                6e-11,
                2.36514111314,
                6836.6452528338
            ]
        ],
        "4": [
            [
                3.858e-8,
                2.56389016346,
                6283.0758499914
            ],
            [
                3.06e-9,
                2.26911740541,
                12566.1516999828
            ],
            [
                5.3e-10,
                3.44031471924,
                5573.1428014331
            ],
            [
                1.5e-10,
                2.03136359366,
                18849.2275499742
            ],
            [
                1.3e-10,
                2.05688873673,
                77713.7714681205
            ],
            [
                7e-11,
                4.4121885448,
                161000.6857376741
            ],
            [
                4e-11,
                5.33854414781,
                6438.4962494256
            ],
            [
                6e-11,
                3.81514213664,
                149854.4001348079
            ],
            [
                4e-11,
                4.26602478239,
                6127.6554505572
            ]
        ],
        "5": [
            [
                8.6e-10,
                1.21805304895,
                6283.0758499914
            ],
            [
                1.2e-10,
                0.65572878044,
                12566.1516999828
            ]
        ]
    },
    name: "earth",
    type: "B"
};
exports.default = m;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1fwX5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return Chinese;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _dateChinese = require("date-chinese");
var _calEventJs = require("./CalEvent.js");
var _calEventJsDefault = parcelHelpers.interopDefault(_calEventJs);
var _caldate = require("caldate");
var _caldateDefault = parcelHelpers.interopDefault(_caldate);
var Chinese = /*#__PURE__*/ function(CalEvent) {
    "use strict";
    (0, _inherits._)(Chinese, CalEvent);
    function Chinese(opts) {
        (0, _classCallCheck._)(this, Chinese);
        var _this;
        opts = opts || {};
        _this = (0, _callSuper._)(this, Chinese, [
            opts
        ]);
        switch(opts.fn){
            case 'chinese':
                _this.cal = new (0, _dateChinese.CalendarChinese)();
                break;
            case 'korean':
                _this.cal = new (0, _dateChinese.CalendarKorean)();
                break;
            case 'vietnamese':
                _this.cal = new (0, _dateChinese.CalendarVietnamese)();
                break;
        }
        return _this;
    }
    (0, _createClass._)(Chinese, [
        {
            key: "inYear",
            value: function inYear(year) {
                var d;
                var jde;
                var date;
                var opts = this.opts;
                if (opts.solarterm) {
                    jde = this.cal.solarTerm(opts.solarterm, year);
                    date = this.cal.fromJDE(jde).toGregorian();
                    d = new (0, _caldateDefault.default)(date).setOffset(opts.day - 1);
                } else {
                    this.cal.set(opts.cycle, opts.year, opts.month, opts.leapMonth, opts.day);
                    jde = this.cal.toJDE(year);
                    date = this.cal.fromJDE(jde).toGregorian();
                    d = new (0, _caldateDefault.default)(date);
                }
                this.dates.push(d);
                return this;
            }
        }
    ]);
    return Chinese;
}((0, _calEventJsDefault.default));

},{"@swc/helpers/_/_call_super":"5oPMc","@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","@swc/helpers/_/_inherits":"j8HRi","date-chinese":"5knGJ","./CalEvent.js":"jJ8pL","caldate":"he6lr","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5knGJ":[function(require,module,exports,__globalThis) {
/**
 * @copyright 2016 commenthol
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CalendarChinese", function() {
    return 0, _chineseJsDefault.default;
});
parcelHelpers.export(exports, "CalendarKorean", function() {
    return 0, _koreanJsDefault.default;
});
parcelHelpers.export(exports, "CalendarVietnamese", function() {
    return 0, _vietnameseJsDefault.default;
});
parcelHelpers.export(exports, "CalendarJapanese", function() {
    return 0, _japaneseJsDefault.default;
});
var _chineseJs = require("./Chinese.js");
var _chineseJsDefault = parcelHelpers.interopDefault(_chineseJs);
var _koreanJs = require("./Korean.js");
var _koreanJsDefault = parcelHelpers.interopDefault(_koreanJs);
var _vietnameseJs = require("./Vietnamese.js");
var _vietnameseJsDefault = parcelHelpers.interopDefault(_vietnameseJs);
var _japaneseJs = require("./Japanese.js");
var _japaneseJsDefault = parcelHelpers.interopDefault(_japaneseJs);

},{"./Chinese.js":"8fNen","./Korean.js":"3w1H4","./Vietnamese.js":"LFFU0","./Japanese.js":"7IzLb","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8fNen":[function(require,module,exports,__globalThis) {
/**
 * @copyright 2016 commenthol
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return CalendarChinese;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _astronomia = require("astronomia");
var _vsop87BearthJs = require("./vsop87Bearth.js");
var earth = new (0, _astronomia.planetposition).Planet((0, _vsop87BearthJs.vsop87Bearth));
var lunarOffset = (0, _astronomia.moonphase).meanLunarMonth / 2;
var p = 180 / Math.PI;
// Start of Chinese Calendar in 2636 BCE by Chalmers
var epochY = -2636;
var epoch = new (0, _astronomia.julian).CalendarGregorian(epochY, 2, 15).toJDE();
function toYear(jde) {
    return new (0, _astronomia.julian).CalendarGregorian().fromJDE(jde).toYear();
}
// prevent rounding errors
function toFixed(val, e) {
    return parseFloat(val.toFixed(e), 10);
}
var CalendarChinese = /*#__PURE__*/ function() {
    "use strict";
    function CalendarChinese(cycle, year, month, leap, day) {
        (0, _classCallCheck._)(this, CalendarChinese);
        this.set(cycle, year, month, leap, day);
        this._epochY = epochY;
        this._epoch = epoch;
        this._cache = {
            lon: {},
            sue: {},
            ny: {}
        };
    }
    (0, _createClass._)(CalendarChinese, [
        {
            /**
   * set a new chinese date
   *
   * @param {Number|Array|Object} cycle - chinese 60 year cicle; if `{Array}` than `[cycle, year, ..., day]`
   * @param {Number} year - chinese year of cycle
   * @param {Number} month - chinese month
   * @param {Number} leap - `true` if leap month
   * @param {Number} day - chinese day
   */ key: "set",
            value: function set(cycle, year, month, leap, day) {
                if (cycle instanceof CalendarChinese) {
                    this.cycle = cycle.cycle;
                    this.year = cycle.year;
                    this.month = cycle.month;
                    this.leap = cycle.leap;
                    this.day = cycle.day;
                } else if (Array.isArray(cycle)) {
                    this.cycle = cycle[0];
                    this.year = cycle[1];
                    this.month = cycle[2];
                    this.leap = cycle[3];
                    this.day = cycle[4];
                } else {
                    this.cycle = cycle;
                    this.year = year;
                    this.month = month;
                    this.leap = leap;
                    this.day = day;
                }
                return this;
            }
        },
        {
            /**
   * returns chinese date
   * @returns {Array}
   */ key: "get",
            value: function get() {
                return [
                    this.cycle,
                    this.year,
                    this.month,
                    this.leap,
                    this.day
                ];
            }
        },
        {
            /**
   * get Gregorian year from Epoch / Cycle
   * @return {Number} year
   */ key: "yearFromEpochCycle",
            value: function yearFromEpochCycle() {
                return this._epochY + (this.cycle - 1) * 60 + (this.year - 1);
            }
        },
        {
            /**
   * convert gregorian date to chinese calendar date
   *
   * @param {Number} year - (int) year in Gregorian or Julian Calendar
   * @param {Number} month - (int)
   * @param {Number} day - needs to be in correct (chinese) timezone
   * @return {Object} this
   */ key: "fromGregorian",
            value: function fromGregorian(year, month, day) {
                var j = this.midnight(new (0, _astronomia.julian).CalendarGregorian(year, month, day).toJDE());
                if (month === 1 && day <= 20) year-- // chinese new year never starts before 20/01
                ;
                this._from(j, year);
                return this;
            }
        },
        {
            /**
   * convert date to chinese calendar date
   *
   * @param {Date} date - javascript date object
   * @return {Object} this
   */ key: "fromDate",
            value: function fromDate(date) {
                var j = this.midnight(new (0, _astronomia.julian).CalendarGregorian().fromDate(date).toJDE());
                this._from(j, date.getFullYear());
                return this;
            }
        },
        {
            /**
   * convert JDE to chinese calendar date
   *
   * @param {Number} jde - date in JDE
   * @return {Object} this
   */ key: "fromJDE",
            value: function fromJDE(jde) {
                var j = this.midnight(jde);
                var gc = new (0, _astronomia.julian).CalendarGregorian().fromJDE(j);
                if (gc.month === 1 && gc.day < 20) gc.year-- // chinese new year never starts before 20/01
                ;
                this._from(j, gc.year);
                return this;
            }
        },
        {
            /**
   * common conversion from JDE, year to chinese date
   *
   * @private
   * @param {Number} j - date in JDE
   * @param {Number} year - gregorian year
   */ key: "_from",
            value: function _from(j, year) {
                var ny = this.newYear(year);
                if (ny > j) ny = this.newYear(year - 1);
                var nm = this.previousNewMoon(j);
                if (nm < ny) nm = ny;
                var years = 1.5 + (ny - this._epoch) / (0, _astronomia.base).BesselianYear;
                this.cycle = 1 + Math.trunc((years - 1) / 60);
                this.year = 1 + Math.trunc((years - 1) % 60);
                this.month = this.inMajorSolarTerm(nm).term;
                var m = Math.round((nm - ny) / (0, _astronomia.moonphase).meanLunarMonth);
                if (m === 0) {
                    this.month = 1;
                    this.leap = false;
                } else this.leap = this.isLeapMonth(nm);
                if (m > this.month) this.month = m;
                else if (this.leap) this.month--;
                this.day = 1 + Math.trunc(toFixed(j, 3) - toFixed(nm, 3));
            }
        },
        {
            /**
   * convert chinese date to gregorian date
   *
   * @param {Number} [gyear] - (int) gregorian year
   * @return {Object} date in gregorian (preleptic) calendar; Timezone is Standard Chinese / Bejing Time
   *   {Number} year - (int)
   *   {Number} month - (int)
   *   {Number} day - (int)
   */ key: "toGregorian",
            value: function toGregorian(gyear) {
                var jde = this.toJDE(gyear);
                var gc = new (0, _astronomia.julian).CalendarGregorian().fromJDE(jde + 0.5) // add 0.5 as day get truncated
                ;
                return {
                    year: gc.year,
                    month: gc.month,
                    day: Math.trunc(gc.day)
                };
            }
        },
        {
            /**
   * convert chinese date to Date
   *
   * @param {Number} [gyear] - (int) gregorian year
   * @return {Date} javascript date object in gregorian (preleptic) calendar
   */ key: "toDate",
            value: function toDate(gyear) {
                var jde = this.toJDE(gyear);
                return new (0, _astronomia.julian).CalendarGregorian().fromJDE(toFixed(jde, 4)).toDate();
            }
        },
        {
            /**
   * convert chinese date to JDE
   *
   * @param {Number} [gyear] - (int) gregorian year
   * @return {Number} date in JDE
   */ key: "toJDE",
            value: function toJDE(gyear) {
                var years = gyear || this.yearFromEpochCycle();
                var ny = this.newYear(years);
                var nm = ny;
                if (this.month > 1) {
                    nm = this.previousNewMoon(ny + this.month * 29);
                    var st = this.inMajorSolarTerm(nm).term;
                    var lm = this.isLeapMonth(nm);
                    if (st > this.month) nm = this.previousNewMoon(nm - 1);
                    else if (st < this.month || lm && !this.leap) nm = this.nextNewMoon(nm + 1);
                }
                if (this.leap) nm = this.nextNewMoon(nm + 1);
                var jde = nm + this.day - 1;
                return jde;
            }
        },
        {
            /**
   * timeshift to UTC
   *
   * @param {CalendarGregorian} gcal - gregorian calendar date
   * @return {Number} timeshift in fraction of day
   */ key: "timeshiftUTC",
            value: function timeshiftUTC(gcal) {
                if (gcal.toYear() >= 1929) return 8 / 24 // +8:00:00h Standard China time zone (120° East)
                ;
                return 1397 / 180 / 24 // +7:45:40h Beijing (116°25´ East)
                ;
            }
        },
        {
            /**
   * time/date at midnight - truncate `jde` to actual day
   *
   * @param {Number} jde - julian ephemeris day
   * @return {Number} truncated jde
   */ key: "midnight",
            value: function midnight(jde) {
                var gcal = new (0, _astronomia.julian).CalendarGregorian().fromJDE(jde);
                var ts = 0.5 - this.timeshiftUTC(gcal);
                var mn = Math.trunc(gcal.toJD() - ts) + ts;
                mn = gcal.fromJD(mn).toJDE();
                if (toFixed(jde, 5) === toFixed(mn, 5) + 1) return jde;
                return mn;
            }
        },
        {
            /**
   * get major solar term `Z1...Z12` for a given date in JDE
   *
   * @param {Number} jde - date of new moon
   * @returns {Number} major solar term part of that month
   */ key: "inMajorSolarTerm",
            value: function inMajorSolarTerm(jde) {
                var lon = this._cache.lon[jde] || (0, _astronomia.solar).apparentVSOP87(earth, jde).lon;
                this._cache.lon[jde] = lon;
                var lonDeg = lon * p - 1e-13;
                var term = (2 + Math.floor(lonDeg / 30)) % 12 + 1;
                return {
                    term: term,
                    lon: lonDeg
                };
            }
        },
        {
            /**
   * Test if date `jde` is inside a leap month
   * `jde` and previous new moon need to have the same major solar term
   *
   * @param {Number} jde - date of new moon
   * @returns {Boolean} `true` if previous new moon falls into same solar term
   */ key: "isLeapMonth",
            value: function isLeapMonth(jde) {
                var t1 = this.inMajorSolarTerm(jde);
                var next = this.nextNewMoon(this.midnight(jde + lunarOffset));
                var t2 = this.inMajorSolarTerm(next);
                var r = t1.term === t2.term;
                return r;
            }
        },
        {
            /**
   * next new moon since `jde`
   *
   * @param {Number} jde - date in julian ephemeris days
   * @return {Number} jde at midnight
   */ key: "nextNewMoon",
            value: function nextNewMoon(jde) {
                var nm = this.midnight((0, _astronomia.moonphase).newMoon(toYear(jde)));
                var cnt = 0;
                while(nm < jde && cnt++ < 4)nm = this.midnight((0, _astronomia.moonphase).newMoon(toYear(jde + cnt * lunarOffset)));
                return nm;
            }
        },
        {
            /**
   * next new moon since `jde`
   *
   * @param {Number} jde - date in julian ephemeris days
   * @return {Number} jde at midnight
   */ key: "previousNewMoon",
            value: function previousNewMoon(jde) {
                var nm = this.midnight((0, _astronomia.moonphase).newMoon(toYear(jde)));
                var cnt = 0;
                while(nm > jde && cnt++ < 4)nm = this.midnight((0, _astronomia.moonphase).newMoon(toYear(jde - cnt * lunarOffset)));
                return nm;
            }
        },
        {
            /**
   * chinese new year for a given gregorian year
   *
   * @param {Number} gyear - gregorian year (int)
   * @param {Number} jde at midnight
   */ key: "newYear",
            value: function newYear(gyear) {
                gyear = Math.trunc(gyear);
                if (this._cache.ny[gyear]) return this._cache.ny[gyear];
                var sue1 = this._cache.sue[gyear - 1] || (0, _astronomia.solstice).december2(gyear - 1, earth);
                var sue2 = this._cache.sue[gyear] || (0, _astronomia.solstice).december2(gyear, earth);
                this._cache.sue[gyear - 1] = sue1;
                this._cache.sue[gyear] = sue2;
                var m11n = this.previousNewMoon(this.midnight(sue2 + 1));
                var m12 = this.nextNewMoon(this.midnight(sue1 + 1));
                var m13 = this.nextNewMoon(this.midnight(m12 + lunarOffset));
                this.leapSui = Math.round((m11n - m12) / (0, _astronomia.moonphase).meanLunarMonth) === 12;
                var ny = m13;
                if (this.leapSui && (this.isLeapMonth(m12) || this.isLeapMonth(m13))) ny = this.nextNewMoon(this.midnight(m13 + (0, _astronomia.moonphase).meanLunarMonth / 2));
                this._cache.ny[gyear] = ny;
                return ny;
            }
        },
        {
            /**
   * get solar term from solar longitude
   *
   * @param {Number} term - jiéqì solar term 1 .. 24
   * @param {Number} [gyear] - (int) gregorian year
   * @returns {Number} jde at midnight
   */ key: "solarTerm",
            value: function solarTerm(term, gyear) {
                if (gyear && term <= 3) gyear--;
                var years = gyear || this.yearFromEpochCycle();
                var lon = (term + 20) % 24 * 15 % 360;
                var st = (0, _astronomia.solstice).longitude(years, earth, lon / p);
                st = this.midnight(st);
                return st;
            }
        },
        {
            /**
   * get major solar term
   *
   * @param {Number} term - zhōngqì solar term Z1 .. Z12
   * @param {Number} [gyear] - (int) gregorian year
   * @returns {Number} jde at midnight
   */ key: "majorSolarTerm",
            value: function majorSolarTerm(term, gyear) {
                return this.solarTerm(term * 2, gyear);
            }
        },
        {
            /**
   * get minor solar term
   *
   * @param {Number} term - jiéqì solar term J1 .. J12
   * @param {Number} [gyear] - (int) gregorian year
   * @returns {Number} jde at midnight
   */ key: "minorSolarTerm",
            value: function minorSolarTerm(term, gyear) {
                return this.solarTerm(term * 2 - 1, gyear);
            }
        },
        {
            /**
   * Qı̄ngmíng - Pure brightness Festival
   *
   * @param {Number} [gyear] - (int) gregorian year
   * @returns {Number} jde at midnight
   */ key: "qingming",
            value: function qingming(gyear) {
                return this.solarTerm(5, gyear);
            }
        }
    ]);
    return CalendarChinese;
}();

},{"@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","astronomia":"03wmo","./vsop87Bearth.js":"bjdnT","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"bjdnT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "vsop87Bearth", function() {
    return vsop87Bearth;
});
var _vsop87Bearth = require("astronomia/data/vsop87Bearth");
var _vsop87BearthDefault = parcelHelpers.interopDefault(_vsop87Bearth);
var vsop87Bearth = (0, _vsop87BearthDefault.default);

},{"astronomia/data/vsop87Bearth":"1UHob","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3w1H4":[function(require,module,exports,__globalThis) {
/**
 * @copyright 2016 commenthol
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return CalendarKorean;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _astronomia = require("astronomia");
var _chineseJs = require("./Chinese.js");
var _chineseJsDefault = parcelHelpers.interopDefault(_chineseJs);
// Start of Korean Calendar in 2333 BCE (단군기원 http://ko.wikipedia.org/wiki/단기)
var epochY = -2333;
var epoch = new (0, _astronomia.julian).CalendarGregorian(epochY, 1, 27).toJDE();
/**
 * change of timezone shifts during the last century
 * @see https://en.wikipedia.org/wiki/Time_in_South_Korea
 */ var UTC_DATES = [
    {
        date: new Date('1961-10-09T15:00:00.000Z'),
        shift: 9 / 24
    },
    {
        date: new Date('1954-03-20T15:30:00.000Z'),
        shift: 8.5 / 24
    },
    {
        date: new Date('1911-12-31T15:00:00.000Z'),
        shift: 9 / 24
    },
    {
        date: new Date('1908-03-31T15:30:00.000Z'),
        shift: 8.5 / 24
    }
];
var CalendarKorean = /*#__PURE__*/ function(CalendarChinese) {
    "use strict";
    (0, _inherits._)(CalendarKorean, CalendarChinese);
    function CalendarKorean(cycle, year, month, leap, day) {
        (0, _classCallCheck._)(this, CalendarKorean);
        var _this;
        _this = (0, _callSuper._)(this, CalendarKorean, [
            cycle,
            year,
            month,
            leap,
            day
        ]);
        _this._epochY = epochY;
        _this._epoch = epoch;
        return _this;
    }
    (0, _createClass._)(CalendarKorean, [
        {
            /**
   * timeshift to UTC
   *
   * @param {CalendarGregorian} gcal - gregorian calendar date
   * @return {Number} timeshift in fraction of day
   */ key: "timeshiftUTC",
            value: function timeshiftUTC(gcal) {
                var date = gcal.toDate();
                for(var i in UTC_DATES){
                    if (date >= UTC_DATES[i].date) return UTC_DATES[i].shift;
                }
                return 3809 / 450 / 24 // +8:27:52h Seoul City Hall 126°58'E
                ;
            }
        }
    ]);
    return CalendarKorean;
}((0, _chineseJsDefault.default));

},{"@swc/helpers/_/_call_super":"5oPMc","@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","@swc/helpers/_/_inherits":"j8HRi","astronomia":"03wmo","./Chinese.js":"8fNen","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"LFFU0":[function(require,module,exports,__globalThis) {
/**
 * @copyright 2016 commenthol
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return CalendarVietnamese;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _chineseJs = require("./Chinese.js");
var _chineseJsDefault = parcelHelpers.interopDefault(_chineseJs);
var CalendarVietnamese = /*#__PURE__*/ function(CalendarChinese) {
    "use strict";
    (0, _inherits._)(CalendarVietnamese, CalendarChinese);
    function CalendarVietnamese() {
        (0, _classCallCheck._)(this, CalendarVietnamese);
        return (0, _callSuper._)(this, CalendarVietnamese, arguments);
    }
    (0, _createClass._)(CalendarVietnamese, [
        {
            /**
   * timeshift to UTC
   *
   * @param {CalendarGregorian} gcal - gregorian calendar date
   * @return {Number} timeshift in fraction of day
   */ key: "timeshiftUTC",
            value: function timeshiftUTC(gcal) {
                if (gcal.toYear() >= 1968) return 7 / 24 // +7:00:00h
                ;
                return 8 / 24 // +8:00:00h Standard China time zone (120° East)
                ;
            }
        }
    ]);
    return CalendarVietnamese;
}((0, _chineseJsDefault.default));

},{"@swc/helpers/_/_call_super":"5oPMc","@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","@swc/helpers/_/_inherits":"j8HRi","./Chinese.js":"8fNen","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7IzLb":[function(require,module,exports,__globalThis) {
/**
 * @copyright 2016 commenthol
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Note: I could not find details about the epoch(s) for the year zero of the
 * Japanese calendar dating before 1873. Therefore this calendar uses (wrongly)
 * the Chinese epoch.
 *
 * According to <https://en.wikipedia.org/wiki/History_of_Japan> the eras are:
 *
 * Yayoi  300 BC – 250 AD
 * Kofun  250 – 538
 * Asuka  538 – 710
 * Nara   710 – 794
 * Heian  794 – 1185
 * Kamakura   1185 – 1333
 * Kenmu Restoration  1333 – 1336
 * Muromachi 1336 – 1573
 * Azuchi–Momoyama 1568 – 1603
 * Edo  1603 – 1868
 * Meiji  1868 – 1912
 * Taishō 1912 – 1926
 * Shōwa  1926 – 1989
 * Heisei 1989 – present
 *
 * Unfortunately the linking from era to calendar era (especially to the Chinese
 * pre 1873 one) is unknown to me.
 */ parcelHelpers.export(exports, "default", function() {
    return CalendarJapanese;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _chineseJs = require("./Chinese.js");
var _chineseJsDefault = parcelHelpers.interopDefault(_chineseJs);
/**
 * @see http://law.e-gov.go.jp/htmldata/M19/M19CO051.html
 */ var UTC_DATES = [
    {
        date: new Date('1888-02-11T15:00:00.000Z'),
        shift: 9 / 24
    } // +9:00:00h (135° East) Japanese standard meridian
];
var CalendarJapanese = /*#__PURE__*/ function(CalendarChinese) {
    "use strict";
    (0, _inherits._)(CalendarJapanese, CalendarChinese);
    function CalendarJapanese() {
        (0, _classCallCheck._)(this, CalendarJapanese);
        return (0, _callSuper._)(this, CalendarJapanese, arguments);
    }
    (0, _createClass._)(CalendarJapanese, [
        {
            /**
   * timeshift to UTC
   *
   * @param {CalendarGregorian} gcal - gregorian calendar date
   * @return {Number} timeshift in fraction of day
   */ key: "timeshiftUTC",
            value: function timeshiftUTC(gcal) {
                var date = gcal.toDate();
                for(var i in UTC_DATES){
                    if (date >= UTC_DATES[i].date) return UTC_DATES[i].shift;
                }
                return 4193 / 450 / 24 // +9:19:04h (139°46'E)
                ;
            }
        }
    ]);
    return CalendarJapanese;
}((0, _chineseJsDefault.default));

},{"@swc/helpers/_/_call_super":"5oPMc","@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","@swc/helpers/_/_inherits":"j8HRi","./Chinese.js":"8fNen","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1TGGS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return BengaliRevised;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _dateBengaliRevised = require("date-bengali-revised");
var _dateBengaliRevisedDefault = parcelHelpers.interopDefault(_dateBengaliRevised);
var _caldate = require("caldate");
var _caldateDefault = parcelHelpers.interopDefault(_caldate);
var _calEventJs = require("./CalEvent.js");
var _calEventJsDefault = parcelHelpers.interopDefault(_calEventJs);
var BengaliRevised = /*#__PURE__*/ function(CalEvent) {
    "use strict";
    (0, _inherits._)(BengaliRevised, CalEvent);
    function BengaliRevised(opts) {
        (0, _classCallCheck._)(this, BengaliRevised);
        opts = opts || {};
        return (0, _callSuper._)(this, BengaliRevised, [
            opts
        ]);
    }
    (0, _createClass._)(BengaliRevised, [
        {
            key: "inYear",
            value: function inYear(year) {
                var opts = this.opts;
                var date = new (0, _dateBengaliRevisedDefault.default)(year - 593, opts.month, opts.day).toGregorian();
                var d = new (0, _caldateDefault.default)(date);
                this.dates.push(d);
                return this;
            }
        }
    ]);
    return BengaliRevised;
}((0, _calEventJsDefault.default));

},{"@swc/helpers/_/_call_super":"5oPMc","@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","@swc/helpers/_/_inherits":"j8HRi","date-bengali-revised":"7YgFR","caldate":"he6lr","./CalEvent.js":"jJ8pL","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7YgFR":[function(require,module,exports,__globalThis) {
/**
 * @copyright 2018-present commenthol
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CalendarBengaliRevised", function() {
    return CalendarBengaliRevised;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _convertJs = require("./convert.js");
var YEAR0 = 593;
var MILLISECONDS_PER_DAY = 86400000;
var monthDaysNorm = [
    31,
    31,
    31,
    31,
    31,
    30,
    30,
    30,
    30,
    30,
    30,
    30
];
var monthDaysLeap = [
    31,
    31,
    31,
    31,
    31,
    30,
    30,
    30,
    30,
    30,
    31,
    30
];
var isLeapYear = function(year) {
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
};
var UTC6 = 6 // timezone offset UTC+6
;
var toEpoch = function(year) {
    return Date.UTC(year, 3, 13, UTC6);
};
var CalendarBengaliRevised = /*#__PURE__*/ function() {
    "use strict";
    function CalendarBengaliRevised(year, month, day) {
        (0, _classCallCheck._)(this, CalendarBengaliRevised);
        Object.assign(this, {
            year: (0, _convertJs.banglaToDigit)(year),
            month: (0, _convertJs.banglaToDigit)(month) || 1,
            day: (0, _convertJs.banglaToDigit)(day) || 1
        });
    }
    (0, _createClass._)(CalendarBengaliRevised, [
        {
            /**
   * convert gregorian date to bengali calendar date
   * @param {Number} year - (int) year in Gregorian Calendar
   * @param {Number} month - (int)
   * @param {Number} day - (int)
   * @return {Object} this
   */ key: "fromGregorian",
            value: function fromGregorian(year, month, day) {
                var monthDays = isLeapYear(year) ? monthDaysLeap : monthDaysNorm;
                var _year = year;
                if (month < 4 || month === 4 && day < 14) _year -= 1;
                this.year = _year - YEAR0;
                var date = Date.UTC(year, month - 1, day, UTC6);
                var days = Math.floor((date - toEpoch(_year)) / MILLISECONDS_PER_DAY);
                for(var i = 0; i < monthDays.length; i++){
                    if (days <= monthDays[i]) {
                        this.month = i + 1;
                        break;
                    }
                    days -= monthDays[i];
                }
                this.day = days;
                return this;
            }
        },
        {
            /**
   * convert date to bengali calendar date
   * @param {Date} date - javascript date object - uses local date
   * @return {Object} this
   */ key: "fromDate",
            value: function fromDate(date) {
                return this.fromGregorian(date.getFullYear(), date.getMonth() + 1, date.getDate());
            }
        },
        {
            /**
   * convert bengali date to gregorian date
   * @return {Object} date in gregorian (preleptic) calendar
   *   {Number} year - (int)
   *   {Number} month - (int) 1...12
   *   {Number} day - (int) 1...31
   */ key: "toGregorian",
            value: function toGregorian() {
                var date = this.toDate();
                return {
                    year: date.getUTCFullYear(),
                    month: date.getUTCMonth() + 1,
                    day: date.getUTCDate()
                };
            }
        },
        {
            /**
   * convert bengali date to Date
   * @return {Date} javascript date object in gregorian (preleptic) calendar
   */ key: "toDate",
            value: function toDate() {
                var year = this.year + YEAR0;
                var epoch = toEpoch(year);
                var _year = this.month > 10 ? year + 1 : year;
                var monthDays = isLeapYear(_year) ? monthDaysLeap : monthDaysNorm;
                var days = this.day;
                for(var i = 0; i < this.month - 1; i++)days += monthDays[i];
                var date = new Date(days * MILLISECONDS_PER_DAY + epoch);
                return date;
            }
        },
        {
            /**
   * format date in bengali
   * @param {String} formatStr - string formatter
   *
   * | Input | Description  |
   * | ----- | ------------ |
   * | Y     | Year with any number of digits and sign |
   * | Q     | Season Name  |
   * | M     | Month number |
   * | MMMM  | Month name   |
   * | D     | Day of month |
   * | dddd  | Day name     |
   *
   * @return {String}
   */ key: "format",
            value: function format(formatStr) {
                formatStr = formatStr || 'D M, Y';
                if (/dddd/.test(formatStr)) {
                    var date = this.toDate();
                    formatStr = formatStr.replace(/dddd/g, (0, _convertJs.weekDay)(date.getUTCDay()));
                }
                return formatStr.replace(/Y/g, (0, _convertJs.digitToBangla)(this.year)).replace(/Q/g, (0, _convertJs.seasonName)(this.month)).replace(/MMMM/g, (0, _convertJs.monthName)(this.month)).replace(/M/g, (0, _convertJs.digitToBangla)(this.month)).replace(/D/g, (0, _convertJs.digitToBangla)(this.day));
            }
        }
    ]);
    return CalendarBengaliRevised;
}();
exports.default = CalendarBengaliRevised;

},{"@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","./convert.js":"2tc9u","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2tc9u":[function(require,module,exports,__globalThis) {
/**
 * bengali names were taken from https://github.com/nuhil/bangla-calendar - MIT licensed
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "digitToBangla", function() {
    return digitToBangla;
});
parcelHelpers.export(exports, "banglaToDigit", function() {
    return banglaToDigit;
});
parcelHelpers.export(exports, "weekDay", function() {
    return weekDay;
});
parcelHelpers.export(exports, "monthName", function() {
    return monthName;
});
parcelHelpers.export(exports, "seasonName", function() {
    return seasonName;
});
var monthNames = [
    "\u09AC\u09C8\u09B6\u09BE\u0996",
    "\u099C\u09CD\u09AF\u09C8\u09B7\u09CD\u09A0",
    "\u0986\u09B7\u09BE\u09A2\u09BC",
    "\u09B6\u09CD\u09B0\u09BE\u09AC\u09A3",
    "\u09AD\u09BE\u09A6\u09CD\u09B0",
    "\u0986\u09B6\u09CD\u09AC\u09BF\u09A8",
    "\u0995\u09BE\u09B0\u09CD\u09A4\u09BF\u0995",
    "\u0985\u0997\u09CD\u09B0\u09B9\u09BE\u09AF\u09BC\u09A3",
    "\u09AA\u09CC\u09B7",
    "\u09AE\u09BE\u0998",
    "\u09AB\u09BE\u09B2\u09CD\u0997\u09C1\u09A8",
    "\u099A\u09C8\u09A4\u09CD\u09B0"
];
var weekDays = [
    "\u09B0\u09AC\u09BF\u09AC\u09BE\u09B0",
    "\u09B8\u09CB\u09AE\u09AC\u09BE\u09B0",
    "\u09AE\u0999\u09CD\u0997\u09B2\u09AC\u09BE\u09B0",
    "\u09AC\u09C1\u09A7\u09AC\u09BE\u09B0",
    "\u09AC\u09C3\u09B9\u09B8\u09CD\u09AA\u09A4\u09BF\u09AC\u09BE\u09B0",
    "\u09B6\u09C1\u0995\u09CD\u09B0\u09AC\u09BE\u09B0",
    "\u09B6\u09A8\u09BF\u09AC\u09BE\u09B0"
];
var seasonNames = [
    "\u0997\u09CD\u09B0\u09C0\u09B7\u09CD\u09AE",
    "\u09AC\u09B0\u09CD\u09B7\u09BE",
    "\u09B6\u09B0\u09CE",
    "\u09B9\u09C7\u09AE\u09A8\u09CD\u09A4",
    "\u09B6\u09C0\u09A4",
    "\u09AC\u09B8\u09A8\u09CD\u09A4"
];
var digits = [
    "\u09E6",
    "\u09E7",
    "\u09E8",
    "\u09E9",
    "\u09EA",
    "\u09EB",
    "\u09EC",
    "\u09ED",
    "\u09EE",
    "\u09EF"
];
var banglas;
var createBanglas = function() {
    banglas = digits.reduce(function(o, c, i) {
        o[c] = i;
        return o;
    }, {});
};
var digitToBangla = function(number) {
    return String(number).replace(/\d/g, function(digit) {
        return digits[digit];
    });
};
var banglaToDigit = function(bangla) {
    if (!banglas) createBanglas() // memoize
    ;
    var month = monthNames.indexOf(bangla);
    var str = month !== -1 ? month + 1 : String(bangla).replace(/./g, function(bangla) {
        var r = banglas[bangla];
        return r !== undefined ? r : bangla;
    });
    return Number(str);
};
var weekDay = function(day) {
    return weekDays[day];
};
var monthName = function(month) {
    return monthNames[month - 1];
};
var seasonName = function(month) {
    return seasonNames[Math.floor((month - 1) / 2)] // ('পৌষ' + 'মাঘ') = 'শীত'. Every consecutive two index in 'banglaMonths' indicates a single index in 'banglaSeasons'.
    ;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8qPqR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HolidayRule", function() {
    return HolidayRule;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _utilsJs = require("./internal/utils.js");
var HolidayRule = /*#__PURE__*/ function() {
    "use strict";
    function HolidayRule(ruleObj) {
        (0, _classCallCheck._)(this, HolidayRule);
        var rule = ruleObj.rule, fn = ruleObj.fn, opts = ruleObj.opts, other = (0, _objectWithoutProperties._)(ruleObj, [
            "rule",
            "fn",
            "opts"
        ]);
        Object.assign(this, (0, _objectSpread._)({
            rule: rule
        }, other));
    }
    (0, _createClass._)(HolidayRule, [
        {
            /**
   * disable rule in year (month)
   * @param {number} year
   * @param {number} [month] - 1..12
   */ key: "disableIn",
            value: function disableIn(year, month) {
                if (!(0, _utilsJs.toNumber)(year)) return;
                month = month < 1 && month > 12 ? undefined : month < 10 ? '0' + Number(month) : month;
                var dateStr = [
                    year,
                    month
                ].filter(Boolean).join('-');
                this.disable = (this.disable || []).concat(dateStr).sort();
            }
        }
    ]);
    return HolidayRule;
}();

},{"@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_object_without_properties":"1waVD","./internal/utils.js":"iCH29","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"01dHL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "data", function() {
    return data;
});
var data = {
    version: '2025-03-16',
    license: 'CC-BY-SA-3',
    holidays: {
        AD: {
            names: {
                ca: 'Andorra',
                es: 'Andorra',
                en: 'Andorra'
            },
            dayoff: 'sunday',
            langs: [
                'ca',
                'es'
            ],
            zones: [
                'Europe/Andorra'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '01-06': {
                    _name: '01-06'
                },
                '03-14': {
                    _name: 'Constitution Day'
                },
                '05-01': {
                    _name: '05-01'
                },
                '08-15': {
                    _name: '08-15'
                },
                '09-08': {
                    name: {
                        en: 'Our Lady of Meritxell',
                        es: 'Nuestra Sra. De Meritxell',
                        ca: "Mare de D\xe9u de Meritxell"
                    }
                },
                '11-01': {
                    _name: '11-01'
                },
                '12-08': {
                    _name: '12-08'
                },
                '12-24': {
                    type: 'bank',
                    _name: '12-24'
                },
                '12-25': {
                    _name: '12-25'
                },
                '12-26': {
                    _name: '12-26'
                },
                'easter -47': {
                    _name: 'easter -47'
                },
                'easter -3 14:00': {
                    type: 'bank',
                    _name: 'easter -3'
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                easter: {
                    _name: 'easter'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                'easter 49': {
                    _name: 'easter 49'
                },
                'easter 50': {
                    _name: 'easter 50'
                }
            },
            regions: {
                '07': {
                    name: 'Andorra la Vella',
                    days: {
                        '1st saturday in August P3D': {
                            name: {
                                en: 'Andorra La Vella Festival',
                                ca: 'Andorra La Vella Festival'
                            }
                        }
                    }
                }
            }
        },
        AE: {
            names: {
                en: 'United Arab Emirates',
                ar: "\u062F\u0648\u0644\u0629 \u0627\u0644\u0625\u0645\u0627\u0631\u0627\u062A \u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0627\u0644\u0645\u062A\u062D\u062F\u0629"
            },
            langs: [
                'ar'
            ],
            zones: [
                'Asia/Dubai'
            ],
            dayoff: '',
            days: {
                '01-01': {
                    _name: '01-01',
                    name: {
                        ar: "\u0631\u0623\u0633 \u0627\u0644\u0633\u0646\u0629 \u0627\u0644\u0645\u064A\u0644\u0627\u062F\u064A\u0629"
                    }
                },
                '12-02': {
                    name: {
                        en: 'National Day',
                        ar: "\u0627\u0644\u064A\u0648\u0645 \u0627\u0644\u0648\u0637\u0646\u064A"
                    }
                },
                '1 Muharram': {
                    _name: '1 Muharram'
                },
                '1 Shawwal P3D': {
                    _name: '1 Shawwal'
                },
                '10 Dhu al-Hijjah P3D': {
                    _name: '10 Dhu al-Hijjah'
                },
                '27 Rajab': {
                    _name: '27 Rajab'
                },
                '1 Ramadan': {
                    _name: '1 Ramadan'
                },
                '12 Rabi al-awwal': {
                    _name: '12 Rabi al-awwal'
                }
            }
        },
        AG: {
            names: {
                en: 'Antigua & Barbuda'
            },
            langs: [
                'en'
            ],
            dayoff: 'sunday',
            weekend: [
                'saturday',
                'sunday'
            ],
            zones: [
                'America/Port_of_Spain'
            ],
            days: {
                '01-01 and if sunday then next monday': {
                    substitute: true,
                    _name: '01-01'
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                easter: {
                    _name: 'easter',
                    type: 'observance'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '05-01': {
                    _name: '05-01'
                },
                'easter 49': {
                    _name: 'easter 49',
                    type: 'observance'
                },
                'easter 50': {
                    _name: 'easter 50'
                },
                '08-01': {
                    name: {
                        en: "J'Ouvert Morning"
                    }
                },
                '08-02': {
                    name: {
                        en: 'Last Lap'
                    }
                },
                '11-01 if saturday,sunday then next monday': {
                    _name: 'Independence Day'
                },
                '12-09': {
                    name: {
                        en: 'V.C Bird Day'
                    }
                },
                '12-25 and if saturday then next monday if sunday then next tuesday': {
                    _name: '12-25',
                    substitute: true
                },
                '12-26 and if sunday then next monday': {
                    _name: '12-26',
                    substitute: true
                }
            },
            regions: {
                10: {
                    name: 'Barbuda',
                    days: {
                        'easter 47 P4D': {
                            name: {
                                en: 'Caribana'
                            },
                            type: 'observance'
                        }
                    }
                }
            }
        },
        AI: {
            names: {
                en: 'Anguilla'
            },
            langs: [
                'en'
            ],
            dayoff: 'sunday',
            weekend: [
                'saturday',
                'sunday'
            ],
            zones: [
                'America/Port_of_Spain'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '03-02': {
                    name: {
                        en: 'James Ronald Webster Day'
                    }
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                easter: {
                    _name: 'easter',
                    type: 'observance'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '05-01': {
                    _name: '05-01'
                },
                '05-30': {
                    name: {
                        en: 'Anguilla Day'
                    }
                },
                'easter 49': {
                    _name: 'easter 49',
                    type: 'observance'
                },
                'easter 50': {
                    _name: 'easter 50'
                },
                '2nd monday in June': {
                    name: {
                        en: 'Celebration of the Birthday of Her Majesty the Queen'
                    }
                },
                '1st monday in August': {
                    name: {
                        en: 'August Monday'
                    }
                },
                '1st thursday in August': {
                    name: {
                        en: 'August Thursday'
                    }
                },
                '1st friday in August': {
                    _name: 'Constitution Day'
                },
                '12-19': {
                    name: {
                        en: 'National Heroes and Heroines Day'
                    }
                },
                '12-25 and if saturday then next monday if sunday then next tuesday': {
                    _name: '12-25',
                    substitute: true
                },
                '12-26 and if sunday then next monday': {
                    _name: '12-26',
                    substitute: true
                }
            }
        },
        AL: {
            names: {
                sq: "Shqip\xebri",
                en: 'Albania'
            },
            dayoff: 'sunday',
            langs: [
                'sq',
                'es'
            ],
            zones: [
                'Europe/Tirane'
            ],
            days: {
                '01-01 and if sunday then next tuesday': {
                    _name: '01-01',
                    substitute: true
                },
                '01-02 and if sunday then next monday': {
                    name: {
                        sq: "Festa e Vitit t\xeb Ri",
                        en: 'New Year Holiday'
                    },
                    substitute: true
                },
                '03-02': {
                    name: {
                        sq: "Dita e Bes\xeblidhjes s\xeb Lezh\xebs",
                        en: "League of Lezh\xeb day"
                    },
                    type: 'observance'
                },
                '03-07': {
                    name: {
                        sq: "Dita e M\xebsuesit",
                        en: "Teacher's Day"
                    },
                    type: 'observance'
                },
                '03-08': {
                    _name: 'Mothers Day',
                    type: 'observance'
                },
                '03-14 and if sunday then next monday': {
                    name: {
                        sq: "Dita e Ver\xebs",
                        en: 'Summer Day'
                    },
                    substitute: true
                },
                '03-22 and if sunday then next monday': {
                    name: {
                        sq: 'Dita e Sulltan Nevruzit',
                        en: "Sultan Nevruz's Day"
                    },
                    substitute: true
                },
                '04-01': {
                    _name: '04-01',
                    type: 'observance'
                },
                easter: {
                    name: {
                        sq: "Pashk\xebt Katolike",
                        en: 'Catholic Easter'
                    }
                },
                'easter 1': {
                    name: {
                        sq: "Pashk\xebt Katolike",
                        en: 'Catholic Easter'
                    }
                },
                orthodox: {
                    name: {
                        sq: "Pashk\xebt Ortodokse",
                        en: 'Orthodox Easter'
                    }
                },
                'orthodox 1': {
                    name: {
                        sq: "Pashk\xebt Ortodokse",
                        en: 'Orthodox Easter'
                    }
                },
                '05-01 and if sunday then next monday': {
                    _name: '05-01',
                    substitute: true
                },
                '06-01': {
                    name: {
                        sq: "Dita Nd\xebrkomb\xebtare e F\xebmij\xebve",
                        en: "Children's Day"
                    },
                    type: 'observance'
                },
                '10-19 and if sunday then next monday': {
                    name: {
                        sq: "Dita e N\xebn\xeb Terez\xebs",
                        en: 'Mother Teresa Day'
                    },
                    substitute: true,
                    active: [
                        {
                            from: 2004
                        }
                    ]
                },
                '11-22': {
                    name: {
                        sq: 'Dita e Alfabetit',
                        en: 'Alphabet Day'
                    },
                    type: 'observance'
                },
                '11-28 and if sunday then next monday': {
                    _name: 'Independence Day',
                    substitute: true
                },
                '11-29 and if sunday then next monday': {
                    _name: 'Liberation Day',
                    substitute: true
                },
                '12-08 and if sunday then next monday': {
                    name: {
                        sq: "Dita Komb\xebtare e Rinis\xeb",
                        en: 'Youth Day'
                    },
                    substitute: true,
                    active: [
                        {
                            from: 2010
                        }
                    ]
                },
                '12-24': {
                    _name: '12-24',
                    type: 'bank'
                },
                '12-25 and if sunday then next monday': {
                    _name: '12-25',
                    substitute: true
                },
                '1 Shawwal': {
                    _name: '1 Shawwal'
                },
                '10 Dhu al-Hijjah': {
                    _name: '10 Dhu al-Hijjah'
                }
            },
            regions: {}
        },
        AM: {
            names: {
                hy: "\u0540\u0561\u0575\u0561\u057D\u057F\u0561\u0576",
                en: 'Armenia'
            },
            dayoff: 'sunday',
            langs: [
                'hy'
            ],
            zones: [
                'Asia/Yerevan'
            ],
            days: {
                '12-31': {
                    _name: '12-31'
                },
                '01-01 P2D': {
                    _name: '01-01'
                },
                '01-03 P3D': {
                    name: {
                        en: 'Pre-Christmas holidays',
                        hy: "\u0546\u0561\u056D\u0561\u056E\u0576\u0576\u0564\u0575\u0561\u0576 \u057F\u0578\u0576\u0565\u0580"
                    }
                },
                '01-06': {
                    _name: '12-25'
                },
                '01-28': {
                    name: {
                        en: 'Army Day',
                        hy: "\u0532\u0561\u0576\u0561\u056F\u056B \u0585\u0580"
                    }
                },
                '02-21': {
                    name: {
                        en: 'Mother Language Day',
                        hy: "\u0544\u0561\u0575\u0580\u0565\u0576\u056B \u056C\u0565\u0566\u057E\u056B \u0585\u0580"
                    },
                    type: 'observance'
                },
                'easter -52': {
                    name: {
                        en: 'St. Vartan the good work and the duty days',
                        hy: "\u054D\u0578\u0582\u0580\u0562 \u054E\u0561\u0580\u0564\u0561\u0576\u0561\u0576\u0581 \u057F\u0578\u0576\u055D \u0562\u0561\u0580\u056B \u0563\u0578\u0580\u056E\u056B \u0565\u0582 \u0561\u0566\u0563\u0561\u0575\u056B\u0576 \u057F\u0578\u0582\u0580\u0584\u056B \u0585\u0580"
                    },
                    type: 'observance'
                },
                '03-08': {
                    _name: '03-08'
                },
                '04-07': {
                    name: {
                        en: 'Motherhood and Beauty Day',
                        hy: "\u0544\u0561\u0575\u0580\u0578\u0582\u0569\u0575\u0561\u0576, \u0563\u0565\u0572\u0565\u0581\u056F\u0578\u0582\u0569\u0575\u0561\u0576 \u0565\u0582 \u057D\u056B\u0580\u0578 \u057F\u0578\u0576"
                    },
                    type: 'observance'
                },
                '04-24': {
                    _name: 'Mothers Day'
                },
                '05-01': {
                    _name: '05-01'
                },
                '05-08': {
                    name: {
                        en: 'Yerkrapah Day',
                        hy: "\u0535\u0580\u056F\u0580\u0561\u057A\u0561\u0570\u056B \u0585\u0580"
                    },
                    type: 'observance'
                },
                '05-09': {
                    name: {
                        en: 'Victory and Peace Day',
                        hy: "\u0540\u0561\u0572\u0569\u0561\u0576\u0561\u056F\u056B \u0565\u0582 \u053D\u0561\u0572\u0561\u0572\u0578\u0582\u0569\u0575\u0561\u0576 \u057F\u0578\u0576"
                    }
                },
                '05-28': {
                    name: {
                        en: 'Republic Day',
                        hy: "\u0540\u0561\u0576\u0580\u0561\u057A\u0565\u057F\u0578\u0582\u0569\u0575\u0561\u0576 \u0585\u0580"
                    }
                },
                '06-01': {
                    name: {
                        en: 'The day of protection of children rights',
                        hy: "\u0535\u0580\u0565\u056D\u0561\u0576\u0565\u0580\u056B \u056B\u0580\u0561\u057E\u0578\u0582\u0576\u0584\u0576\u0565\u0580\u056B \u057A\u0561\u0577\u057F\u057A\u0561\u0576\u0578\u0582\u0569\u0575\u0561\u0576 \u0585\u0580"
                    },
                    type: 'observance'
                },
                '07-05': {
                    _name: 'Constitution Day'
                },
                '09-01': {
                    name: {
                        en: 'Knowledge, Literacy and Education Day',
                        hy: "\u0533\u056B\u057F\u0565\u056C\u056B\u0584\u056B, \u0563\u0580\u056B \u0565\u0582 \u0564\u057A\u0580\u0578\u0582\u0569\u0575\u0561\u0576 \u0585\u0580"
                    },
                    type: 'observance'
                },
                '09-21': {
                    _name: 'Independence Day'
                },
                '2nd saturday in October': {
                    name: {
                        en: "Translator's Day",
                        hy: "\u0539\u0561\u0580\u0563\u0574\u0561\u0576\u0579\u0561\u0581 \u057F\u0578\u0576"
                    },
                    type: 'observance'
                },
                '12-07': {
                    name: {
                        en: 'Earthquake Remembrance Day',
                        hy: "\u0535\u0580\u056F\u0580\u0561\u0577\u0561\u0580\u056A\u056B \u0566\u0578\u0570\u0565\u0580\u056B \u0570\u056B\u0577\u0561\u057F\u0561\u056F\u056B \u0585\u0580"
                    },
                    type: 'observance'
                }
            }
        },
        AO: {
            names: {
                pt: 'Angola',
                en: 'Angola'
            },
            dayoff: 'sunday',
            zones: [
                'Africa/Lagos'
            ],
            langs: [
                'pt'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '02-04': {
                    name: {
                        pt: "Dia do In\xedcio da Luta Armada de Liberta\xe7\xe3o Nacional",
                        en: 'Liberation Day'
                    }
                },
                'easter -47': {
                    _name: 'easter -47'
                },
                '03-08': {
                    name: {
                        pt: 'Dia Internacional da Mulher',
                        en: "International Woman's Day"
                    }
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                easter: {
                    _name: 'easter',
                    type: 'observance'
                },
                '04-04': {
                    name: {
                        pt: 'Dia da Paz',
                        en: 'Peace Day'
                    }
                },
                '05-01': {
                    _name: '05-01'
                },
                '1st sunday in May': {
                    _name: 'Mothers Day',
                    type: 'observance'
                },
                '09-17': {
                    name: {
                        pt: "Fundador da Na\xe7\xe3o e Dia dos Her\xf3is Nacionais",
                        en: 'National Hero Day'
                    }
                },
                '11-02': {
                    _name: '11-02'
                },
                '11-11': {
                    _name: 'Independence Day'
                },
                '12-25': {
                    _name: '12-25'
                }
            }
        },
        AR: {
            names: {
                es: 'Argentina',
                en: 'Argentina'
            },
            dayoff: 'sunday',
            langs: [
                'es'
            ],
            zones: [
                'America/Argentina/Buenos_Aires',
                'America/Argentina/Cordoba',
                'America/Argentina/Salta',
                'America/Argentina/Jujuy',
                'America/Argentina/Tucuman',
                'America/Argentina/Catamarca',
                'America/Argentina/La_Rioja',
                'America/Argentina/San_Juan',
                'America/Argentina/Mendoza',
                'America/Argentina/San_Luis',
                'America/Argentina/Rio_Gallegos',
                'America/Argentina/Ushuaia'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '2013-01-31': {
                    name: {
                        en: 'Bicentennial of the Assembly of the Year XIII',
                        es: 'Bicentenario de la Asamblea General Constituyente de 1813'
                    }
                },
                '2013-02-20': {
                    name: {
                        en: 'Bicentennial of the Battle of Salta',
                        es: 'Bicentenario de la Batalla de Salta'
                    }
                },
                '2012-02-27': {
                    name: {
                        en: 'Bicentennial of the Creation and First Oath of Allegiance to the Argentine Flag',
                        es: "Bicentenario de la creaci\xf3n y primera jura de la bandera argentina"
                    }
                },
                'easter -48': {
                    _name: 'easter -48',
                    active: [
                        {
                            to: '1976-06-14'
                        },
                        {
                            from: '2010-11-03'
                        }
                    ]
                },
                'easter -47': {
                    _name: 'easter -47',
                    active: [
                        {
                            to: '1976-06-14'
                        },
                        {
                            from: '2010-11-03'
                        }
                    ]
                },
                '03-24': {
                    name: {
                        en: 'Day of Remembrance for Truth and Justice',
                        es: "D\xeda Nacional de la Memoria por la Verdad y la Justicia"
                    },
                    active: [
                        {
                            from: '2006-03-21'
                        }
                    ]
                },
                'easter -3': {
                    _name: 'easter -3',
                    type: 'bank'
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                '1983-04-02': {
                    name: {
                        en: 'Day of the Malvinas, South Georgia and South Sandwich Islands',
                        es: "D\xeda de las Islas Malvinas, Georgias del Sur y Sandwich del Sur"
                    }
                },
                '04-02 if tuesday,wednesday then previous monday if thursday,friday then next monday': {
                    name: {
                        en: 'Day of the Veterans and the Fallen in the Malvinas War',
                        es: "D\xeda del Veterano y de los Ca\xeddos en la guerra en Malvinas"
                    },
                    active: [
                        {
                            from: '2000-12-22',
                            to: '2006-06-30'
                        }
                    ]
                },
                '04-02': {
                    name: {
                        en: 'Day of the Veterans and the Fallen in the Malvinas War',
                        es: "D\xeda del Veterano y de los Ca\xeddos en la Guerra de Malvinas"
                    },
                    active: [
                        {
                            from: '2006-07-01'
                        }
                    ],
                    disable: [
                        '2020-04-02'
                    ],
                    enable: [
                        '2020-03-31'
                    ]
                },
                '05-01': {
                    _name: '05-01'
                },
                '2010-05-24': {
                    name: {
                        en: 'National Holiday for the Bicentennial of the May Revolution',
                        es: "Feriado Nacional por el Bicentenario de la Revoluci\xf3n de Mayo"
                    }
                },
                '2022-05-18': {
                    name: {
                        en: 'National Census 2022',
                        es: 'Censo Nacional 2022'
                    }
                },
                '05-25': {
                    name: {
                        en: 'Day of the First National Government',
                        es: 'Primer Gobierno Patrio'
                    }
                },
                '06-10': {
                    name: {
                        en: 'Day of Affirmation of Argentine Rights over the Malvinas, Islands and Antarctic Sector',
                        es: "D\xeda de la Afirmaci\xf3n de los Derechos Argentinos sobre las Malvinas, Islas y Sector Ant\xe1rtico"
                    },
                    active: [
                        {
                            from: '1984-03-23',
                            to: '1988-05-17'
                        }
                    ]
                },
                '06-10 if tuesday,wednesday then previous monday if thursday,friday then next monday': {
                    name: {
                        en: 'Day of Affirmation of Argentine Rights over the Malvinas, Islands and Antarctic Sector',
                        es: "D\xeda de la Afirmaci\xf3n de los Derechos Argentinos sobre las Malvinas, Islas y Sector Ant\xe1rtico"
                    },
                    active: [
                        {
                            from: '1988-05-18',
                            to: '2000-12-15'
                        }
                    ]
                },
                '06-17 if tuesday,wednesday then previous monday if thursday then next monday': {
                    name: {
                        en: "Anniversary of the Passing to Immortality of General Mart\xedn Miguel de G\xfcemes",
                        es: "D\xeda Paso a la Inmortalidad del General Mart\xedn Miguel de G\xfcemes"
                    },
                    active: [
                        {
                            from: '2016-06-11'
                        }
                    ]
                },
                '06-20': {
                    name: {
                        en: 'National Flag Day',
                        es: "D\xeda de la Bandera"
                    },
                    active: [
                        {
                            from: '1938-06-08',
                            to: '1988-05-23'
                        },
                        {
                            from: '1991-12-18',
                            to: '1995-01-10'
                        },
                        {
                            from: '2010-11-03'
                        }
                    ]
                },
                '06-20 if tuesday,wednesday then previous monday if thursday,friday then next monday': {
                    name: {
                        en: 'National Flag Day',
                        es: "D\xeda de la Bandera"
                    },
                    active: [
                        {
                            from: '1988-05-24',
                            to: '1991-12-17'
                        }
                    ]
                },
                '3rd monday in June': {
                    name: {
                        en: 'National Flag Day',
                        es: "D\xeda de la Bandera"
                    },
                    active: [
                        {
                            from: '1995-01-11',
                            to: '2010-11-02'
                        }
                    ]
                },
                '07-09': {
                    _name: 'Independence Day'
                },
                '08-17': {
                    name: {
                        en: "Anniversary of the Passing to Immortality of General Jos\xe9 de San Mart\xedn",
                        es: "Paso a la Inmortalidad del General Jos\xe9 de San Mart\xedn"
                    },
                    active: [
                        {
                            from: '1938-09-01',
                            to: '1988-05-23'
                        },
                        {
                            from: '1994-09-30',
                            to: '1995-01-10'
                        }
                    ]
                },
                '08-17 if tuesday,wednesday then previous monday if thursday,friday then next monday': {
                    name: {
                        en: "Anniversary of the Passing to Immortality of General Jos\xe9 de San Mart\xedn",
                        es: "Paso a la Inmortalidad del General Jos\xe9 de San Mart\xedn"
                    },
                    active: [
                        {
                            from: '1988-05-24',
                            to: '1994-09-29'
                        },
                        {
                            from: '2017-01-24'
                        }
                    ]
                },
                '3rd monday in August': {
                    name: {
                        en: "Anniversary of the Passing to Immortality of General Jos\xe9 de San Mart\xedn",
                        es: "Paso a la Inmortalidad del General Jos\xe9 de San Mart\xedn"
                    },
                    active: [
                        {
                            from: '1995-01-11',
                            to: '2017-01-23'
                        }
                    ],
                    disable: [
                        '2011-08-15'
                    ],
                    enable: [
                        '2011-08-22'
                    ]
                },
                '2012-09-24': {
                    name: {
                        en: "Bicentennial of the Battle of Tucum\xe1n",
                        es: "Bicentenario de la Batalla de Tucum\xe1n"
                    }
                },
                '10-12': {
                    name: {
                        en: 'The Day of the Race',
                        es: "D\xeda de la Raza"
                    },
                    active: [
                        {
                            to: '1976-06-14'
                        },
                        {
                            from: '1982-10-12',
                            to: '1988-05-23'
                        }
                    ]
                },
                '10-12 if tuesday,wednesday then previous monday if thursday,friday then next monday #1': {
                    name: {
                        en: 'The Day of the Race',
                        es: "D\xeda de la Raza"
                    },
                    active: [
                        {
                            from: '1988-05-24',
                            to: '2008-10-02'
                        }
                    ],
                    disable: [
                        '2001-10-15',
                        '2002-10-12'
                    ],
                    enable: [
                        '2001-10-08',
                        '2002-10-14'
                    ]
                },
                '10-12 if tuesday,wednesday then previous monday if thursday,friday,saturday,sunday then next monday': {
                    name: {
                        en: 'The Day of the Race',
                        es: "D\xeda de la Raza"
                    },
                    active: [
                        {
                            from: '2008-10-03',
                            to: '2010-11-02'
                        }
                    ]
                },
                '2nd monday in October': {
                    name: {
                        en: 'Day of Respect for Cultural Diversity',
                        es: "D\xeda del Respeto a la Diversidad Cultural"
                    },
                    active: [
                        {
                            from: '2010-11-03',
                            to: '2017-01-23'
                        }
                    ]
                },
                '10-12 if tuesday,wednesday then previous monday if thursday,friday then next monday #2': {
                    name: {
                        en: 'Day of Respect for Cultural Diversity',
                        es: "D\xeda del Respeto a la Diversidad Cultural"
                    },
                    active: [
                        {
                            from: '2017-01-24'
                        }
                    ]
                },
                '2010-10-27': {
                    name: {
                        en: 'National Census 2010',
                        es: 'Censo Nacional 2010'
                    }
                },
                '4th monday in November': {
                    name: {
                        en: 'Day of National Sovereignty',
                        es: "D\xeda de la Soberan\xeda Nacional"
                    },
                    active: [
                        {
                            from: '2010-11-03',
                            to: '2017-01-23'
                        }
                    ],
                    disable: [
                        '2015-11-23'
                    ],
                    enable: [
                        '2015-11-27'
                    ]
                },
                '11-20 if tuesday,wednesday then previous monday if thursday,friday then next monday': {
                    name: {
                        en: 'Day of National Sovereignty',
                        es: "D\xeda de la Soberan\xeda Nacional"
                    },
                    active: [
                        {
                            from: '2017-01-24'
                        }
                    ]
                },
                '12-08': {
                    _name: '12-08',
                    active: [
                        {
                            from: '1995-01-11'
                        }
                    ]
                },
                '12-24 12:00': {
                    _name: '12-24',
                    type: 'optional'
                },
                '12-25': {
                    _name: '12-25'
                },
                '12-31 12:00': {
                    _name: '12-31',
                    type: 'optional'
                },
                '2011-03-25': {
                    _name: 'Bridge Day'
                },
                '2011-12-09': {
                    _name: 'Bridge Day'
                },
                '2012-04-30': {
                    _name: 'Bridge Day'
                },
                '2012-12-24': {
                    _name: 'Bridge Day'
                },
                '2013-04-01': {
                    _name: 'Bridge Day'
                },
                '2013-06-21': {
                    _name: 'Bridge Day'
                },
                '2014-05-02': {
                    _name: 'Bridge Day'
                },
                '2014-12-26': {
                    _name: 'Bridge Day'
                },
                '2015-03-23': {
                    _name: 'Bridge Day'
                },
                '2015-12-07': {
                    _name: 'Bridge Day'
                },
                '2016-07-08': {
                    _name: 'Bridge Day'
                },
                '2016-12-09': {
                    _name: 'Bridge Day'
                },
                '2018-04-30': {
                    _name: 'Bridge Day',
                    type: 'bank'
                },
                '2018-12-24': {
                    _name: 'Bridge Day',
                    type: 'bank'
                },
                '2018-12-31': {
                    _name: 'Bridge Day',
                    type: 'bank'
                },
                '2019-07-08': {
                    _name: 'Bridge Day',
                    type: 'bank'
                },
                '2019-08-19': {
                    _name: 'Bridge Day',
                    type: 'bank'
                },
                '2019-10-14': {
                    _name: 'Bridge Day',
                    type: 'bank'
                },
                '2020-03-23': {
                    _name: 'Bridge Day'
                },
                '2020-07-10': {
                    _name: 'Bridge Day'
                },
                '2020-12-07': {
                    _name: 'Bridge Day'
                },
                '2021-05-24': {
                    _name: 'Bridge Day'
                },
                '2021-10-08': {
                    _name: 'Bridge Day'
                },
                '2021-11-22': {
                    _name: 'Bridge Day'
                },
                '2022-10-07': {
                    _name: 'Bridge Day'
                },
                '2022-11-21': {
                    _name: 'Bridge Day'
                },
                '2022-12-09': {
                    _name: 'Bridge Day'
                },
                '2023-05-26': {
                    _name: 'Bridge Day'
                },
                '2023-06-19': {
                    _name: 'Bridge Day'
                },
                '2023-10-13': {
                    _name: 'Bridge Day'
                },
                '2024-04-01': {
                    _name: 'Bridge Day'
                },
                '2024-06-21': {
                    _name: 'Bridge Day'
                },
                '2024-10-11': {
                    _name: 'Bridge Day'
                },
                '2025-05-02': {
                    _name: 'Bridge Day',
                    type: 'bank'
                },
                '2025-08-15': {
                    _name: 'Bridge Day',
                    type: 'bank'
                },
                '2025-11-21': {
                    _name: 'Bridge Day',
                    type: 'bank'
                }
            }
        },
        AS: {
            names: {
                en: 'American Samoa'
            },
            dayoff: 'sunday',
            zones: [
                'Pacific/Pago_Pago'
            ],
            langs: [
                'en'
            ],
            _days: [
                'US'
            ],
            days: {
                '3rd monday in February': {
                    name: {
                        en: "Washington's Birthday"
                    }
                },
                '03-17': false,
                '04-15 if friday then next monday if saturday,sunday then next tuesday': false,
                '04-17 and if sunday then next monday': {
                    name: {
                        en: 'American Samoa Flag Day'
                    },
                    substitute: true
                },
                '07-16': {
                    name: {
                        en: "Manu'a Cession Day"
                    },
                    type: 'optional',
                    note: 'Goverment offices closed'
                },
                '2nd sunday in October': {
                    name: {
                        en: 'White Sunday'
                    },
                    type: 'observance',
                    note: 'christian'
                },
                '12-24 12:00': {
                    _name: '12-24',
                    type: 'bank'
                },
                '12-31 12:00': {
                    _name: '12-31',
                    type: 'bank'
                }
            }
        },
        AT: {
            names: {
                'de-at': "\xd6sterreich",
                en: 'Austria'
            },
            dayoff: 'sunday',
            zones: [
                'Europe/Vienna'
            ],
            langs: [
                'de-at',
                'de'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '01-06': {
                    _name: '01-06'
                },
                'easter -2 prior to 2019': {
                    _name: 'easter -2',
                    type: 'optional'
                },
                'easter -1': {
                    _name: 'easter -1',
                    type: 'observance'
                },
                easter: {
                    _name: 'easter'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '05-01': {
                    name: {
                        'de-at': 'Staatsfeiertag'
                    }
                },
                '2nd sunday in May': {
                    _name: 'Mothers Day',
                    type: 'observance'
                },
                'easter 39': {
                    _name: 'easter 39'
                },
                'easter 49': {
                    _name: 'easter 49'
                },
                'easter 50': {
                    _name: 'easter 50'
                },
                'easter 60': {
                    _name: 'easter 60'
                },
                '08-15': {
                    _name: '08-15'
                },
                '10-26': {
                    _name: 'National Holiday'
                },
                '11-01': {
                    _name: '11-01'
                },
                '12-08': {
                    _name: '12-08'
                },
                '12-24 14:00 if sunday then 00:00': {
                    _name: '12-24',
                    type: 'bank'
                },
                '12-25': {
                    _name: '12-25'
                },
                '12-26': {
                    _name: '12-26'
                },
                '12-31 14:00 if sunday then 00:00': {
                    _name: '12-31',
                    type: 'bank'
                }
            },
            states: {
                1: {
                    name: 'Burgenland',
                    days: {
                        '11-11': {
                            name: {
                                'de-at': 'Martinstag'
                            }
                        }
                    }
                },
                2: {
                    names: {
                        de: "K\xe4rnten",
                        en: 'Carinthia'
                    },
                    days: {
                        '03-19': {
                            _name: '03-19',
                            type: 'school'
                        },
                        '10-10': {
                            name: {
                                'de-at': 'Tag der Volksabstimmung'
                            }
                        }
                    }
                },
                3: {
                    names: {
                        de: "Nieder\xf6sterreich",
                        en: 'Lower Austria'
                    },
                    days: {
                        '11-15': {
                            name: {
                                'de-at': 'Leopoldi-Tag'
                            },
                            type: 'optional',
                            note: "In Nieder\xf6sterreich haben nur Sch\xfcler und Beamten frei"
                        }
                    }
                },
                4: {
                    names: {
                        de: "Ober\xf6sterreich",
                        en: 'Upper Austria'
                    },
                    days: {
                        '05-04': {
                            name: {
                                'de-at': 'Florian'
                            }
                        }
                    }
                },
                5: {
                    names: {
                        de: 'Land Salzburg',
                        en: 'Salzburg'
                    },
                    days: {
                        '09-24': {
                            name: {
                                'de-at': 'Rupert'
                            }
                        }
                    }
                },
                6: {
                    names: {
                        de: 'Steiermark',
                        en: 'Styria'
                    },
                    days: {
                        '03-19': {
                            _name: '03-19',
                            type: 'school'
                        }
                    }
                },
                7: {
                    names: {
                        de: 'Tirol',
                        en: 'Tyrol'
                    },
                    days: {
                        '03-19': {
                            _name: '03-19',
                            type: 'school'
                        }
                    }
                },
                8: {
                    name: 'Vorarlberg',
                    days: {
                        '03-19': {
                            _name: '03-19',
                            type: 'school'
                        }
                    }
                },
                9: {
                    names: {
                        de: 'Wien',
                        en: 'Vienna'
                    },
                    days: {
                        '11-15': {
                            name: {
                                'de-at': 'Leopoldi-Tag'
                            },
                            type: 'optional',
                            note: "In Wien haben nur Sch\xfcler frei"
                        }
                    }
                }
            }
        },
        AU: {
            names: {
                en: 'Australia'
            },
            dayoff: 'sunday',
            langs: [
                'en'
            ],
            zones: [
                'Australia/Sydney',
                'Australia/Lord_Howe',
                'Antarctica/Macquarie',
                'Australia/Hobart',
                'Australia/Currie',
                'Australia/Melbourne',
                'Australia/Broken_Hill',
                'Australia/Brisbane',
                'Australia/Lindeman',
                'Australia/Adelaide',
                'Australia/Darwin',
                'Australia/Perth',
                'Australia/Eucla'
            ],
            days: {
                '01-01 and if saturday,sunday then next monday': {
                    _name: '01-01'
                },
                '01-26 if saturday,sunday then next monday': {
                    substitute: true,
                    name: {
                        en: 'Australia Day'
                    }
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                'easter -1': {
                    _name: 'easter -1'
                },
                easter: {
                    _name: 'easter'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '04-25': {
                    name: {
                        en: 'Anzac Day'
                    }
                },
                '2nd sunday in May': {
                    _name: 'Mothers Day',
                    type: 'observance'
                },
                '1st sunday in September': {
                    _name: 'Fathers Day',
                    type: 'observance'
                },
                '12-25 and if saturday then next monday if sunday then next tuesday': {
                    substitute: true,
                    _name: '12-25'
                },
                '12-26 and if saturday then next monday if sunday then next tuesday': {
                    substitute: true,
                    _name: '12-26'
                },
                '2022-09-22': {
                    name: {
                        en: 'National Day of Mourning for Queen Elizabeth II'
                    }
                }
            },
            states: {
                ACT: {
                    name: 'Australian Capital Territory',
                    zones: [
                        'Australia/Sydney'
                    ],
                    days: {
                        '2nd monday in March': {
                            name: {
                                en: 'Canberra Day'
                            }
                        },
                        '04-25': false,
                        '04-25 if sunday then next monday': {
                            substitute: true,
                            name: {
                                en: 'Anzac Day'
                            }
                        },
                        '2020-04-27': {
                            name: {
                                en: 'Declared public holiday'
                            },
                            type: 'public'
                        },
                        'monday after 05-27': {
                            name: {
                                en: 'Reconciliation Day'
                            }
                        },
                        '2nd monday in June': {
                            name: {
                                en: "Queen's Birthday"
                            },
                            active: [
                                {
                                    to: '2022-09-08'
                                }
                            ]
                        },
                        '2nd monday in June #1': {
                            name: {
                                en: "King's Birthday"
                            },
                            active: [
                                {
                                    from: '2022-09-09'
                                }
                            ]
                        },
                        '1st monday in October': {
                            name: {
                                en: 'Labour Day'
                            }
                        }
                    }
                },
                NSW: {
                    name: 'New South Wales',
                    zones: [
                        'Australia/Sydney'
                    ],
                    days: {
                        '2nd monday in June': {
                            name: {
                                en: "Queen's Birthday"
                            },
                            active: [
                                {
                                    to: '2022-09-08'
                                }
                            ]
                        },
                        '2nd monday in June #1': {
                            name: {
                                en: "King's Birthday"
                            },
                            active: [
                                {
                                    from: '2022-09-09'
                                }
                            ]
                        },
                        '1st monday in August': {
                            name: {
                                en: 'Bank Holiday'
                            },
                            type: 'bank'
                        },
                        '1st monday in October': {
                            name: {
                                en: 'Labour Day'
                            }
                        }
                    }
                },
                NT: {
                    name: 'Northern Territory',
                    zones: [
                        'Australia/Darwin'
                    ],
                    days: {
                        easter: false,
                        '04-25': false,
                        '04-25 if sunday then next monday': {
                            substitute: true,
                            name: {
                                en: 'Anzac Day'
                            }
                        },
                        '1st monday in May': {
                            name: {
                                en: 'May Day'
                            }
                        },
                        '2nd monday in June': {
                            name: {
                                en: "Queen's Birthday"
                            },
                            active: [
                                {
                                    to: '2022-09-08'
                                }
                            ]
                        },
                        '2nd monday in June #1': {
                            name: {
                                en: "King's Birthday"
                            },
                            active: [
                                {
                                    from: '2022-09-09'
                                }
                            ]
                        },
                        '1st monday in August': {
                            name: {
                                en: 'Picnic Day'
                            }
                        },
                        '1st monday in October': false,
                        '12-24 19:00': {
                            _name: '12-24'
                        },
                        '12-25 and if saturday then next monday if sunday then next tuesday': false,
                        '12-25 if saturday then next monday if sunday then next tuesday': {
                            substitute: true,
                            _name: '12-25'
                        },
                        '12-26 and if saturday then next monday if sunday then next tuesday': false,
                        '12-26 if saturday then next monday if sunday then next tuesday': {
                            substitute: true,
                            _name: '12-26'
                        },
                        '12-31 19:00': {
                            _name: '12-31'
                        }
                    }
                },
                QLD: {
                    name: 'Queensland',
                    zones: [
                        'Australia/Brisbane',
                        'Australia/Lindeman'
                    ],
                    days: {
                        '04-25': false,
                        '04-25 if sunday then next monday': {
                            substitute: true,
                            name: {
                                en: 'Anzac Day'
                            }
                        },
                        '1st monday in May': {
                            name: {
                                en: 'Labour Day'
                            }
                        },
                        '2nd monday in June': false,
                        '1st monday in October': {
                            name: {
                                en: "Queen's Birthday"
                            },
                            active: [
                                {
                                    to: '2022-09-08'
                                }
                            ]
                        },
                        '1st monday in October #1': {
                            name: "King's Birthday",
                            active: [
                                {
                                    from: '2022-09-09'
                                }
                            ]
                        },
                        '12-24 18:00': {
                            _name: '12-24'
                        }
                    }
                },
                SA: {
                    name: 'South Australia',
                    zones: [
                        'Australia/Adelaide'
                    ],
                    days: {
                        easter: false,
                        '2nd monday in March': {
                            name: {
                                en: 'Adelaide Cup Day'
                            }
                        },
                        '2nd monday in June': {
                            name: {
                                en: "Queen's Birthday"
                            },
                            active: [
                                {
                                    to: '2022-09-08'
                                }
                            ]
                        },
                        '2nd monday in June #1': {
                            name: {
                                en: "King's Birthday"
                            },
                            active: [
                                {
                                    from: '2022-09-09'
                                }
                            ]
                        },
                        '1st monday in October': {
                            name: {
                                en: 'Labour Day'
                            }
                        },
                        '12-24 19:00': {
                            _name: '12-24'
                        },
                        '12-25 and if saturday then next monday if sunday then next tuesday': false,
                        '12-25 if saturday then next monday if sunday then next tuesday': {
                            substitute: true,
                            _name: '12-25'
                        },
                        '12-26 and if saturday then next monday if sunday then next tuesday': false,
                        '12-26 if saturday then next monday if sunday then next tuesday': {
                            substitute: true,
                            name: 'Proclamation Day'
                        },
                        '12-31 19:00': {
                            _name: '12-31'
                        }
                    }
                },
                TAS: {
                    name: 'Tasmania',
                    zones: [
                        'Australia/Hobart'
                    ],
                    days: {
                        '01-01 and if saturday,sunday then next monday': false,
                        '01-01 if saturday then next monday if sunday then next tuesday': {
                            substitute: true,
                            _name: '01-01'
                        },
                        '2nd monday in March': {
                            name: {
                                en: 'Eight Hours Day'
                            }
                        },
                        'easter -1': false,
                        easter: false,
                        'easter +2': {
                            name: 'Easter Tuesday',
                            type: 'optional',
                            note: 'Public Service employees or contract dependent'
                        },
                        '2nd monday in June': {
                            name: {
                                en: "Queen's Birthday"
                            },
                            active: [
                                {
                                    to: '2022-09-08'
                                }
                            ]
                        },
                        '2nd monday in June #1': {
                            name: {
                                en: "King's Birthday"
                            },
                            active: [
                                {
                                    from: '2022-09-09'
                                }
                            ]
                        },
                        '1st monday in October': false,
                        '12-26 and if saturday then next monday if sunday then next tuesday': false,
                        '12-26 if saturday then next monday if sunday then next tuesday': {
                            substitute: true,
                            _name: '12-26'
                        }
                    }
                },
                VIC: {
                    name: 'Victoria',
                    zones: [
                        'Australia/Melbourne'
                    ],
                    days: {
                        '2nd monday in March': {
                            name: {
                                en: 'Labour Day'
                            }
                        },
                        '2nd monday in June': {
                            name: {
                                en: "Queen's Birthday"
                            },
                            active: [
                                {
                                    to: '2022-09-08'
                                }
                            ]
                        },
                        '2nd monday in June #1': {
                            name: {
                                en: "King's Birthday"
                            },
                            active: [
                                {
                                    from: '2022-09-09'
                                }
                            ]
                        },
                        '1st monday in October': false,
                        '1st friday before October': {
                            name: {
                                en: 'AFL Grand Final Friday'
                            },
                            note: 'Date might differ as dependent on AFL schedule'
                        },
                        '1st tuesday in November': {
                            name: {
                                en: 'Melbourne Cup'
                            }
                        }
                    }
                },
                WA: {
                    name: 'Western Australia',
                    zones: [
                        'Australia/Perth',
                        'Australia/Eucla'
                    ],
                    days: {
                        '1st monday in March': {
                            name: {
                                en: 'Labour Day'
                            }
                        },
                        'easter -1': false,
                        easter: false,
                        '04-25': false,
                        '04-25 and if saturday,sunday then next monday': {
                            substitute: true,
                            name: {
                                en: 'Anzac Day'
                            }
                        },
                        '1st monday in June': {
                            name: {
                                en: 'Western Australia Day'
                            }
                        },
                        '2nd monday in June': false,
                        'monday before October': {
                            name: {
                                en: "Queen's Birthday"
                            },
                            note: 'Might be on a different day; is proclaimed by Governor',
                            active: [
                                {
                                    to: '2022-09-08'
                                }
                            ]
                        },
                        'monday before October #1': {
                            name: {
                                en: "King's Birthday"
                            },
                            note: 'Might be on a different day; is proclaimed by Governor',
                            active: [
                                {
                                    from: '2022-09-09'
                                }
                            ],
                            disable: [
                                '2024-09-30'
                            ],
                            enable: [
                                '2024-09-23'
                            ]
                        },
                        '1st monday in October': false
                    }
                }
            }
        },
        AW: {
            names: {
                pap: 'Aruba',
                nl: 'Aruba',
                en: 'Aruba'
            },
            dayoff: 'sunday',
            zones: [
                'America/Curacao'
            ],
            langs: [
                'pap',
                'nl'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '01-25': {
                    name: {
                        pap: 'Dia di Betico',
                        nl: 'Herdenking G. F. Croes',
                        en: 'Betico Croes Day'
                    }
                },
                'easter -48': {
                    _name: 'easter -48'
                },
                '03-18 and if saturday then previous friday if sunday then next monday': {
                    substitute: true,
                    name: {
                        pap: 'Dia di Himno y Bandera',
                        nl: 'Herdenking Vlag en Volkslied',
                        en: 'National Anthem and Flag Day'
                    }
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                easter: {
                    _name: 'easter',
                    type: 'observance'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '04-27': {
                    name: {
                        pap: "A\xf1a di Rey",
                        nl: 'Koningsdag',
                        en: 'Kings Day'
                    }
                },
                '05-01 if sunday then next monday': {
                    _name: '05-01'
                },
                '06-24': {
                    name: {
                        pap: 'Dera Gai',
                        nl: 'Dera Gai',
                        en: 'Dera Gai'
                    },
                    type: 'observance'
                },
                'easter 39': {
                    _name: 'easter 39'
                },
                '12-05': {
                    name: {
                        nl: 'Sinterklaasavond',
                        en: "St. Nicholas' Eve"
                    },
                    type: 'observance'
                },
                '12-25': {
                    _name: '12-25'
                },
                '12-26': {
                    _name: '12-26'
                }
            }
        },
        AX: {
            names: {
                sv: "Landskapet \xc5land",
                en: "\xc5land Islands"
            },
            dayoff: 'sunday',
            zones: [
                'Europe/Helsinki'
            ],
            langs: [
                'sv'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '01-06': {
                    _name: '01-06'
                },
                '03-30': {
                    name: {
                        sv: "\xc5lands demilitariseringsdag",
                        en: 'Demilitarization Day'
                    }
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                easter: {
                    _name: 'easter',
                    type: 'observance'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '05-01': {
                    _name: '05-01'
                },
                'easter 39': {
                    _name: 'easter 39'
                },
                'easter 49': {
                    _name: 'easter 49',
                    type: 'observance'
                },
                '06-09': {
                    name: {
                        sv: "Sj\xe4lvstyrelsedagen",
                        en: 'Autonomy Day'
                    }
                },
                'friday after 06-19': {
                    name: {
                        sv: 'Midsommarafton',
                        en: 'Midsummer Eve'
                    },
                    type: 'bank'
                },
                'saturday after 06-20': {
                    name: {
                        sv: 'Midsommardagen',
                        en: 'Midsummer Day'
                    }
                },
                '12-06': {
                    _name: 'Independence Day'
                },
                '12-24 12:00': {
                    _name: '12-24',
                    type: 'bank'
                },
                '12-25': {
                    _name: '12-25'
                },
                '12-26': {
                    _name: '12-26'
                },
                '12-31 12:00': {
                    _name: '12-31',
                    type: 'bank'
                }
            }
        },
        AZ: {
            names: {
                az: "Az\u0259rbaycan Respublikas\u0131",
                en: 'Azerbaijan'
            },
            dayoff: 'sunday',
            weekend: [
                'saturday',
                'sunday'
            ],
            zones: [
                'Asia/Baku'
            ],
            langs: [
                'az'
            ],
            days: {
                '01-01 and if saturday then next monday if sunday then next tuesday': {
                    substitute: true,
                    _name: '01-01'
                },
                '01-02 and if saturday then next monday if sunday then next tuesday': {
                    substitute: true,
                    _name: '01-01'
                },
                '01-20': {
                    name: {
                        az: 'Qara Yanvar',
                        en: "Martyrs' Day"
                    },
                    type: 'observance'
                },
                '03-08 and if saturday,sunday then next monday': {
                    substitute: true,
                    _name: '03-08'
                },
                '03-20': {
                    name: {
                        az: 'Novruz',
                        en: 'Spring Festival'
                    },
                    active: [
                        {
                            from: 2011
                        }
                    ]
                },
                '05-09 and if saturday,sunday then next monday': {
                    substitute: true,
                    name: {
                        az: "Fa\u015Fizm \xfcz\u0259rind\u0259 q\u0259l\u0259b\u0259 g\xfcn\xfc",
                        en: 'Day of Victory over Fascism'
                    }
                },
                '05-28 and if saturday,sunday then next monday': {
                    substitute: true,
                    name: {
                        az: "Respublika g\xfcn\xfc",
                        en: 'Republic Day'
                    }
                },
                '06-15 and if saturday,sunday then next monday': {
                    substitute: true,
                    name: {
                        az: "Az\u0259rbaycan xalq\u0131n\u0131n Milli Qurtulu\u015F g\xfcn\xfc",
                        en: 'National Salvation Day'
                    }
                },
                '06-26 and if saturday,sunday then next monday': {
                    substitute: true,
                    name: {
                        az: "Az\u0259rbaycan Respublikas\u0131n\u0131n Silahl\u0131 Q\xfcvv\u0259l\u0259ri g\xfcn\xfc",
                        en: 'Azerbaijan Armed Forces Day'
                    }
                },
                '10-18 and if saturday,sunday then next monday': {
                    substitute: true,
                    name: {
                        az: "D\xf6vl\u0259t M\xfcst\u0259qilliyi g\xfcn\xfc",
                        en: 'Independence Day'
                    }
                },
                '11-09 and if saturday,sunday then next monday': {
                    substitute: true,
                    name: {
                        az: "D\xf6vl\u0259t Bayra\u011F\u0131 g\xfcn\xfc",
                        en: 'Flag Day'
                    }
                },
                '11-12': {
                    name: {
                        az: "Konstitusiya g\xfcn\xfc",
                        en: 'Constitution Day'
                    }
                },
                '11-17': {
                    name: {
                        az: "Milli Dir\xe7\u0259li\u015F g\xfcn\xfc",
                        en: 'National Revival Day'
                    }
                },
                '12-31 and if saturday,sunday then next monday': {
                    substitute: true,
                    name: {
                        az: "D\xfcnya az\u0259rbaycanl\u0131lar\u0131n h\u0259mr\u0259yliyi g\xfcn\xfc",
                        en: 'International Solidarity Day of Azerbaijanis'
                    }
                },
                '1 Shawwal and if saturday then next monday if sunday then next tuesday': {
                    substitute: true,
                    _name: '1 Shawwal'
                },
                '2 Shawwal and if saturday then next monday if sunday then next tuesday': {
                    substitute: true,
                    _name: '1 Shawwal'
                },
                '10 Dhu al-Hijjah and if saturday then next monday if sunday then next tuesday': {
                    substitute: true,
                    _name: '10 Dhu al-Hijjah'
                },
                '11 Dhu al-Hijjah and if saturday then next monday if sunday then next tuesday': {
                    substitute: true,
                    _name: '10 Dhu al-Hijjah'
                }
            }
        },
        BA: {
            names: {
                bs: 'Bosna i Hercegovina',
                sr: "\u0411\u043E\u0441\u043Da \u0438 \u0425\u0435\u0440\u0446\u0435\u0433\u043E\u0432\u0438\u043D\u0430",
                hr: 'Bosna i Hercegovina',
                en: 'Bosnia and Herzegovina'
            },
            langs: [
                'bs',
                'sr',
                'hr'
            ],
            zones: [
                'Europe/Belgrade'
            ],
            dayoff: 'sunday',
            days: {
                '01-01 and if sunday then next tuesday': {
                    _name: '01-01',
                    substitute: true
                },
                '01-02 and if sunday then next monday': {
                    name: {
                        en: '2nd day of the New Year',
                        bs: 'Drugi dan Nove Godine'
                    },
                    substitute: true
                },
                '05-01 and if sunday then next tuesday': {
                    _name: '05-01',
                    substitute: true
                },
                '05-02 and if sunday then next monday': {
                    name: {
                        en: '2nd day of the Labour Day',
                        bs: 'Drugi dan Dana rada'
                    },
                    substitute: true
                },
                '01-06': {
                    _name: '01-06'
                },
                easter: {
                    _name: 'easter'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                'easter 60': {
                    _name: 'easter 60'
                },
                '08-15': {
                    _name: '08-15'
                },
                '11-01': {
                    _name: '11-01'
                },
                '11-02': {
                    _name: '11-02'
                },
                '12-25': {
                    _name: '12-25'
                },
                '12-26': {
                    _name: '12-26'
                },
                'julian 01-01': {
                    _name: 'julian 01-01'
                },
                orthodox: {
                    _name: 'orthodox'
                },
                'julian 08-15': {
                    _name: '08-15',
                    note: 'orthodox'
                },
                'julian 12-25': {
                    _name: 'julian 12-25'
                },
                '1 Muharram': {
                    _name: '1 Muharram'
                },
                '12 Rabi al-awwal': {
                    _name: '12 Rabi al-awwal'
                },
                '10 Dhu al-Hijjah P4D': {
                    _name: '10 Dhu al-Hijjah'
                },
                '1 Shawwal P3D': {
                    _name: '1 Shawwal'
                }
            },
            states: {
                BIH: {
                    name: 'Federation of Bosnia and Herzegovina',
                    days: {
                        '03-01': {
                            _name: 'Independence Day'
                        },
                        '11-25': {
                            name: {
                                en: 'Statehood Day',
                                bs: "Dan dr\u017Eavnosti"
                            }
                        }
                    },
                    regions: {
                        W: {
                            name: 'Western Herzegovina',
                            days: {
                                '11-25': false
                            }
                        }
                    }
                },
                BRC: {
                    name: "Br\u010Dko District",
                    days: {
                        '03-08': {
                            name: {
                                en: 'Day of the Establishment of the District'
                            }
                        }
                    }
                },
                SRP: {
                    name: 'Republika Srpska',
                    days: {
                        '01-09': {
                            name: {
                                en: 'Republic Day',
                                bs: 'Dan Republike'
                            }
                        },
                        '05-09': {
                            name: {
                                en: 'Victory Day',
                                bs: 'Dan pobjede'
                            }
                        },
                        '11-21': {
                            name: {
                                en: 'Dayton Agreement Day',
                                bs: "Dan uspostave Op\u0161teg okvirnog sporazuma za mir u Bosni i Hercegovini"
                            }
                        }
                    }
                }
            }
        },
        BB: {
            names: {
                en: 'Barbados'
            },
            dayoff: 'sunday',
            langs: [
                'en'
            ],
            zones: [
                'America/Barbados'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '01-21': {
                    name: {
                        en: 'Errol Barrow Day'
                    }
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                easter: {
                    _name: 'easter',
                    type: 'observance'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '04-28': {
                    name: {
                        en: 'National Heroes Day'
                    }
                },
                '05-01 if sunday then next monday': {
                    name: {
                        en: 'May Day'
                    }
                },
                'easter 49': {
                    _name: 'easter 49'
                },
                'easter 50': {
                    _name: 'easter 50'
                },
                '08-01': {
                    name: {
                        en: 'Emancipation Day'
                    }
                },
                '1st monday in August': {
                    name: {
                        en: 'Kadooment Day'
                    }
                },
                '11-30': {
                    _name: 'Independence Day'
                },
                '12-25': {
                    _name: '12-25'
                },
                'substitutes 12-25 if sunday then next tuesday': {
                    _name: 'Public Holiday'
                },
                '12-26': {
                    _name: '12-26'
                },
                'substitutes 12-26 if sunday then next monday': {
                    _name: 'Public Holiday'
                }
            }
        },
        BD: {
            names: {
                bn: "\u0997\u09A3\u09AA\u09CD\u09B0\u099C\u09BE\u09A4\u09A8\u09CD\u09A4\u09CD\u09B0\u09C0 \u09AC\u09BE\u0982\u09B2\u09BE\u09A6\u09C7\u09B6",
                en: "People's Republic of Bangladesh"
            },
            langs: [
                'bn'
            ],
            zones: [
                'Asia/Dhaka'
            ],
            dayoff: 'friday',
            weekend: [
                'friday',
                'saturday'
            ],
            days: {
                'bengali-revised 11-9': {
                    name: {
                        bn: "\u09B6\u09B9\u09C0\u09A6 \u09A6\u09BF\u09AC\u09B8",
                        en: "Language Martyrs' Day"
                    }
                },
                'bengali-revised 12-3': {
                    name: {
                        bn: "\u09AE\u09C1\u099C\u09BF\u09AC \u099C\u09AF\u09BC\u09A8",
                        en: "Mujib's Birthday & Children's Day"
                    }
                },
                'bengali-revised 12-12': {
                    name: {
                        bn: "\u09B8\u09CD\u09AC\u09BE\u09A7\u09C0\u09A8\u09A4\u09BE \u09A6\u09BF\u09AC\u09B8",
                        en: 'Independence Day'
                    }
                },
                'bengali-revised 1-1': {
                    name: {
                        bn: "\u09AA\u09B9\u09C7\u09B2\u09BE \u09AC\u09C8\u09B6\u09BE\u0996",
                        en: "Bengali New Year's Day"
                    }
                },
                'bengali-revised 1-18': {
                    _name: '05-01',
                    name: {
                        bn: "\u09AE\u09C7 \u09A6\u09BF\u09AC\u09B8",
                        en: 'May Day'
                    }
                },
                'bengali-revised 4-31': {
                    name: {
                        bn: "\u099C\u09BE\u09A4\u09C0\u09AF\u09BC \u09B6\u09CB\u0995 \u09A6\u09BF\u09AC\u09B8",
                        en: 'National Mourning Day'
                    }
                },
                'bengali-revised 9-2': {
                    name: {
                        bn: "\u09AC\u09BF\u099C\u09AF\u09BC \u09A6\u09BF\u09AC\u09B8",
                        en: 'Victory Day'
                    }
                },
                '10 Muharram': {
                    _name: '10 Muharram'
                },
                '12 Rabi al-awwal': {
                    _name: '12 Rabi al-awwal'
                },
                '1 Shawwal P3D': {
                    _name: '1 Shawwal'
                },
                '10 Dhu al-Hijjah P3D': {
                    _name: '10 Dhu al-Hijjah'
                },
                '05-19': {
                    name: {
                        bn: "\u09AC\u09C1\u09A6\u09CD\u09A7 \u09AA\u09C2\u09B0\u09CD\u09A3\u09BF\u09AE\u09BE",
                        en: "Buddha's Birthday"
                    },
                    enable: [
                        '2016-05-21',
                        '2017-05-10',
                        '2018-04-29',
                        '2019-05-19',
                        '2020-05-07'
                    ],
                    disable: [
                        '2016-05-19',
                        '2017-05-19',
                        '2018-05-19',
                        '2019-05-19',
                        '2020-05-19'
                    ]
                },
                '08-24': {
                    name: {
                        bn: "\u099C\u09A8\u09CD\u09AE\u09BE\u09B7\u09CD\u099F\u09AE\u09C0",
                        en: 'Krishna Janmashtami'
                    },
                    enable: [
                        '2016-08-25',
                        '2017-08-14',
                        '2018-09-02',
                        '2019-08-24',
                        '2020-08-11'
                    ],
                    disable: [
                        '2016-08-24',
                        '2017-08-24',
                        '2018-08-24',
                        '2019-08-24',
                        '2020-08-24'
                    ]
                },
                '10-08': {
                    name: {
                        bn: "\u09A6\u09C1\u09B0\u09CD\u0997\u09BE \u09AA\u09C2\u099C\u09BE",
                        en: 'Durga Puja'
                    },
                    enable: [
                        '2016-10-11',
                        '2017-09-30',
                        '2018-10-19',
                        '2019-10-08',
                        '2020-10-25'
                    ],
                    disable: [
                        '2016-10-08',
                        '2017-10-08',
                        '2018-10-08',
                        '2019-10-08',
                        '2020-10-08'
                    ]
                },
                'bengali-revised 9-11': {
                    _name: '12-25'
                },
                '03-25': {
                    name: {
                        en: 'Genocide Remembrance Day'
                    },
                    type: 'observance'
                },
                '11-21': {
                    name: {
                        en: 'Armed Forces Day'
                    },
                    type: 'observance'
                },
                '12-14': {
                    name: {
                        en: 'Martyred Intellectuals Day'
                    },
                    type: 'observance'
                }
            }
        },
        BE: {
            names: {
                fr: 'Belgique',
                nl: "Belgi\xeb",
                de: 'Belgien',
                en: 'Belgium'
            },
            dayoff: 'sunday',
            zones: [
                'Europe/Brussels'
            ],
            langs: [
                'fr',
                'nl',
                'de'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '01-06': {
                    _name: '01-06',
                    name: {
                        de: 'Erscheinung des Herrn'
                    },
                    type: 'observance'
                },
                '02-14': {
                    _name: '02-14',
                    type: 'observance'
                },
                easter: {
                    _name: 'easter',
                    type: 'observance'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '05-01': {
                    _name: '05-01'
                },
                '2nd sunday in May': {
                    _name: 'Mothers Day',
                    type: 'observance'
                },
                'easter 39': {
                    _name: 'easter 39'
                },
                'easter 49': {
                    _name: 'easter 49',
                    type: 'observance'
                },
                'easter 50': {
                    _name: 'easter 50'
                },
                '07-21': {
                    _name: 'National Holiday'
                },
                '08-15': {
                    _name: '08-15'
                },
                '11-01': {
                    _name: '11-01'
                },
                '11-02': {
                    _name: '11-02',
                    type: 'observance'
                },
                '11-11': {
                    name: {
                        de: 'Waffenstillstand',
                        fr: 'Armistice',
                        nl: 'Wapenstilstand'
                    }
                },
                '11-15': {
                    name: {
                        nl: 'Koningsdag',
                        fr: "F\xeate du Roi",
                        de: "Festtag des K\xf6nigs"
                    },
                    type: 'observance'
                },
                '12-06': {
                    _name: '12-06',
                    type: 'observance'
                },
                '12-25': {
                    _name: '12-25'
                }
            },
            states: {
                BRU: {
                    name: 'Bruxelles',
                    langs: [
                        'fr',
                        'nl'
                    ],
                    days: {
                        '05-08': {
                            name: {
                                nl: 'Feest van de Iris',
                                fr: "F\xeate de l'Iris"
                            },
                            type: 'observance'
                        }
                    }
                },
                DE: {
                    name: 'Deutschsprachige Gemeinschaft',
                    langs: [
                        'de'
                    ],
                    days: {
                        '11-15': {
                            name: {
                                de: 'Tag der Deutschsprachigen Gemeinschaft',
                                fr: "Jour de la Communaut\xe9 Germanophone",
                                nl: 'Feestdag van de Duitstalige Gemeenschap'
                            },
                            type: 'observance'
                        }
                    }
                },
                VLG: {
                    name: 'Vlaamse Gemeenschap',
                    langs: [
                        'nl'
                    ],
                    days: {
                        '07-11': {
                            name: {
                                de: 'Festtag der Wallonischen Region',
                                fr: "F\xeate de la R\xe9gion wallonne",
                                nl: 'Feestdag van de Vlaamse Gemeenschap'
                            },
                            type: 'observance'
                        },
                        '11-02': {
                            _name: '11-02',
                            type: 'observance',
                            note: 'day-off for employees of the flemish government'
                        },
                        '11-15': {
                            name: {
                                nl: 'Koningsdag',
                                fr: "F\xeate du Roi",
                                de: "Festtag des K\xf6nigs"
                            },
                            type: 'observance',
                            note: 'day-off for employees of the flemish government'
                        },
                        '12-26': {
                            _name: '12-26',
                            type: 'observance',
                            note: 'day-off for employees of the flemish government'
                        }
                    }
                },
                WAL: {
                    name: "Communaut\xe9 fran\xe7aise",
                    langs: [
                        'fr'
                    ],
                    days: {
                        '09-27': {
                            name: {
                                de: "Tag der Franz\xf6sischsprachigen Gemeinschaft",
                                fr: "La f\xeate de la communaut\xe9 fran\xe7aise",
                                nl: 'Feestdag van de Franse Gemeenschap'
                            },
                            type: 'observance'
                        }
                    }
                }
            }
        },
        BF: {
            names: {
                fr: 'Burkina Faso',
                en: 'Burkina Faso'
            },
            langs: [
                'fr'
            ],
            zones: [
                'Africa/Abidjan'
            ],
            dayoff: '',
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '01-03': {
                    name: {
                        fr: "Soul\xe8vement populaire",
                        en: "Anniversary of the 1966 Upper Voltan coup d'\xe9tat"
                    }
                },
                '03-08': {
                    _name: '03-08'
                },
                easter: {
                    _name: 'easter'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                'easter 39': {
                    _name: 'easter 39'
                },
                'easter 49': {
                    _name: 'easter 49'
                },
                '05-01': {
                    _name: '05-01'
                },
                '08-05': {
                    _name: 'Independence Day'
                },
                '08-15': {
                    _name: '08-15'
                },
                '11-01': {
                    _name: '11-01'
                },
                '12-11': {
                    name: {
                        fr: "F\xeate nationale",
                        en: 'Proclamation of the Republic'
                    }
                },
                '12-25': {
                    _name: '12-25'
                },
                '12 Rabi al-awwal': {
                    _name: '12 Rabi al-awwal'
                },
                '1 Shawwal': {
                    _name: '1 Shawwal'
                },
                '10 Dhu al-Hijjah': {
                    _name: '10 Dhu al-Hijjah'
                }
            }
        },
        BG: {
            names: {
                bg: "\u0411\u044A\u043B\u0433\u0430\u0440\u0438\u044F",
                en: 'Bulgaria'
            },
            langs: [
                'bg'
            ],
            zones: [
                'Europe/Sofia'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '03-01': {
                    name: {
                        bg: "\u0411\u0430\u0431\u0430 \u041C\u0430\u0440\u0442\u0430",
                        en: 'Granny March Day'
                    },
                    type: 'observance'
                },
                '03-03': {
                    name: {
                        bg: "\u0414\u0435\u043D \u043D\u0430 \u041E\u0441\u0432\u043E\u0431\u043E\u0436\u0434\u0435\u043D\u0438\u0435\u0442\u043E \u043D\u0430 \u0411\u044A\u043B\u0433\u0430\u0440\u0438\u044F \u043E\u0442 \u041E\u0441\u043C\u0430\u043D\u0441\u043A\u0430\u0442\u0430 \u0418\u043C\u043F\u0435\u0440\u0438\u044F",
                        en: 'Liberation Day'
                    }
                },
                '03-08': {
                    _name: '03-08',
                    type: 'observance'
                },
                'orthodox -2': {
                    _name: 'easter -2'
                },
                orthodox: {
                    _name: 'easter'
                },
                'orthodox 1': {
                    _name: 'easter 1'
                },
                '05-01': {
                    _name: '05-01'
                },
                '05-06': {
                    name: {
                        bg: "\u0413\u0435\u0440\u0433\u044C\u043E\u0432\u0434\u0435\u043D",
                        en: "St. George's Day"
                    }
                },
                '05-07': {
                    name: {
                        bg: "\u0414\u0435\u043D \u043D\u0430 \u0440\u0430\u0434\u0438\u043E\u0442\u043E \u0438 \u0442\u0435\u043B\u0435\u0432\u0438\u0437\u0438\u044F\u0442\u0430",
                        en: 'Radio and Television Day'
                    },
                    type: 'observance'
                },
                '05-24': {
                    name: {
                        bg: "\u0414\u0435\u043D \u043D\u0430 \u0430\u0437\u0431\u0443\u043A\u0430\u0442\u0430, \u043A\u0443\u043B\u0442\u0443\u0440\u0430\u0442\u0430 \u0438 \u043F\u0440\u043E\u0441\u0432\u0435\u0442\u0430\u0442\u0430",
                        en: 'Bulgarian Education and Culture, and Slavonic Literature Day'
                    }
                },
                '09-06': {
                    name: {
                        bg: "\u0414\u0435\u043D \u043D\u0430 \u0441\u044A\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435\u0442\u043E",
                        en: 'Unification Day'
                    }
                },
                '09-22': {
                    _name: 'Independence Day'
                },
                '11-01': {
                    name: {
                        bg: "\u0414\u0435\u043D \u043D\u0430 \u043D\u0430\u0440\u043E\u0434\u043D\u0438\u0442\u0435 \u0431\u0443\u0434\u0438\u0442\u0435\u043B\u0438",
                        en: "Revival Leaders' Day"
                    },
                    type: 'school'
                },
                '12-24': {
                    _name: '12-24'
                },
                '12-25': {
                    _name: '12-25'
                },
                '12-26': {
                    _name: '12-26',
                    type: 'observance'
                }
            }
        },
        BH: {
            names: {
                ar: "\u0645\u0645\u0644\u0643\u0629 \u0627\u0644\u0628\u062D\u0631\u064A\u0646",
                en: 'Bahrain'
            },
            langs: [
                'ar'
            ],
            zones: [
                'Asia/Qatar'
            ],
            dayoff: '',
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '05-01': {
                    _name: '05-01',
                    name: {
                        ar: "\u064A\u0648\u0645 \u0627\u0644\u0639\u0645\u0627\u0644"
                    }
                },
                '12-16': {
                    name: {
                        ar: "\u0627\u0644\u064A\u0648\u0645 \u0627\u0644\u0648\u0637\u0646\u064A",
                        en: 'National Day'
                    }
                },
                '12-17': {
                    name: {
                        ar: "\u064A\u0648\u0645 \u0627\u0644\u062C\u0644\u0648\u0633",
                        en: 'Accession Day'
                    }
                },
                '1 Muharram': {
                    _name: '1 Muharram'
                },
                '10 Muharram': {
                    _name: '10 Muharram'
                },
                '12 Rabi al-awwal': {
                    _name: '12 Rabi al-awwal'
                },
                '1 Shawwal': {
                    _name: '1 Shawwal'
                },
                '9 Dhu al-Hijjah': {
                    _name: '9 Dhu al-Hijjah'
                },
                '10 Dhu al-Hijjah P3D': {
                    _name: '10 Dhu al-Hijjah'
                }
            }
        },
        BI: {
            names: {
                rn: "Republika y'Uburundi",
                fr: "R\xe9publique du Burundi",
                en: 'Burundi'
            },
            dayoff: 'sunday',
            langs: [
                'fr',
                'en'
            ],
            zones: [
                'Africa/Maputo'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '02-05': {
                    name: {
                        fr: "Jour de l'Unit\xe9",
                        en: 'Unity Day'
                    }
                },
                '04-06': {
                    name: {
                        fr: 'Jour de Ntaryamira',
                        en: 'Ntaryamira Day'
                    }
                },
                '05-01': {
                    _name: '05-01'
                },
                'easter 39': {
                    _name: 'easter 39'
                },
                '07-01': {
                    _name: 'Independence Day'
                },
                '08-15': {
                    _name: '08-15'
                },
                '10-13': {
                    name: {
                        fr: 'Jour de Rwagasore',
                        en: 'Rwagasore Day'
                    }
                },
                '10-21': {
                    name: {
                        fr: 'Jour de Ndadaye',
                        en: 'Ndadaye Day'
                    }
                },
                '11-01': {
                    _name: '11-01'
                },
                '12-25': {
                    _name: '12-25'
                },
                '1 Shawwal': {
                    _name: '1 Shawwal'
                },
                '10 Dhu al-Hijjah': {
                    _name: '10 Dhu al-Hijjah'
                },
                '2015-07-24': {
                    _name: 'Public Holiday',
                    name: {
                        fr: "Jour l'\xe9lection des S\xe9nateurs"
                    }
                }
            }
        },
        BJ: {
            names: {
                fr: "R\xe9publique du B\xe9nin",
                en: 'Benin'
            },
            langs: [
                'fr'
            ],
            zones: [
                'Africa/Lagos'
            ],
            dayoff: '',
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '01-10': {
                    name: {
                        fr: "F\xeate du Vodoun"
                    }
                },
                easter: {
                    _name: 'easter',
                    type: 'observance'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                'easter 39': {
                    _name: 'easter 39'
                },
                'easter 49': {
                    _name: 'easter 49',
                    type: 'observance'
                },
                'easter 50': {
                    _name: 'easter 50'
                },
                '05-01': {
                    _name: '05-01'
                },
                '08-01': {
                    _name: 'Independence Day',
                    name: {
                        fr: "F\xeate Nationale"
                    }
                },
                '08-15': {
                    _name: '08-15'
                },
                '11-01': {
                    _name: '11-01'
                },
                '12-25': {
                    _name: '12-25'
                },
                '1 Shawwal': {
                    _name: '1 Shawwal'
                },
                '10 Dhu al-Hijjah': {
                    _name: '10 Dhu al-Hijjah'
                },
                '12 Rabi al-awwal': {
                    _name: '12 Rabi al-awwal'
                }
            }
        },
        BL: {
            names: {
                fr: "St. Barth\xe9lemy",
                en: 'St. Barths'
            },
            langs: [
                'fr'
            ],
            zones: [
                'America/St_Barthelemy'
            ],
            _days: 'FR',
            days: {
                'easter -48': {
                    _name: 'easter -48',
                    type: 'observance'
                },
                'easter -47': {
                    _name: 'easter -47',
                    type: 'Observance'
                },
                'easter -46': {
                    _name: 'easter -46',
                    type: 'observance'
                },
                'easter -21': {
                    name: {
                        fr: "Mi-Car\xeame",
                        en: 'Laetare Sunday'
                    },
                    type: 'observance'
                },
                'easter -2': {
                    _name: 'easter -2',
                    type: 'bank'
                },
                easter: {
                    _name: 'easter',
                    type: 'observance'
                },
                '08-24': {
                    name: {
                        fr: "F\xeate de Saint Barth\xe9lemy",
                        en: 'Saint Barth'
                    },
                    type: 'observance'
                },
                '10-09': {
                    _name: 'Abolition of Slavery'
                },
                '12-25': {
                    _name: '12-25'
                }
            }
        },
        BM: {
            names: {
                en: 'Bermuda'
            },
            langs: [
                'en'
            ],
            zones: [
                'Atlantic/Bermuda'
            ],
            dayoff: 'sunday',
            days: {
                '01-01': {
                    _name: '01-01'
                },
                'substitutes 01-01 if saturday, sunday then next monday': {
                    _name: '01-01',
                    substitute: true,
                    type: 'bank',
                    note: 'Goverment offices close'
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                'friday before 06-01': {
                    name: {
                        en: 'Bermuda Day'
                    }
                },
                '3nd monday in June': {
                    name: {
                        en: 'National Heroes Day'
                    }
                },
                'thursday before 08-04': {
                    name: {
                        en: 'Emancipation Day'
                    }
                },
                'friday before 08-05': {
                    name: {
                        en: "Somers' Day"
                    }
                },
                'monday after 09-01': {
                    name: {
                        en: 'Labour Day'
                    }
                },
                '11-11': {
                    name: {
                        en: 'Remembrance Day'
                    }
                },
                'substitutes 11-11 if saturday, sunday then next monday': {
                    name: {
                        en: 'Remembrance Day'
                    },
                    substitute: true,
                    type: 'bank',
                    note: 'Goverment offices close'
                },
                '12-25': {
                    _name: '12-25'
                },
                'substitutes 12-25 if saturday then next monday if sunday then next tuesday': {
                    _name: '12-25',
                    substitute: true,
                    type: 'bank',
                    note: 'Goverment offices close'
                },
                '12-26': {
                    _name: '12-26'
                },
                'substitutes 12-26 if saturday then next monday if sunday then next tuesday': {
                    _name: '12-26',
                    substitute: true,
                    type: 'bank',
                    note: 'Goverment offices close'
                }
            }
        },
        BN: {
            names: {
                ms: 'Negara Brunei Darussalam',
                en: 'Brunei'
            },
            langs: [
                'ms',
                'en'
            ],
            zones: [
                'Asia/Brunei'
            ],
            dayoff: '',
            days: {
                '01-01': {
                    _name: '01-01',
                    name: {
                        ms: 'Awal Tahun Masihi'
                    }
                },
                '02-23': {
                    name: {
                        en: 'National Day',
                        ms: 'Hari Kebangsaan'
                    }
                },
                '03-31': {
                    name: {
                        en: 'Armed Forces Day',
                        ms: 'Hari Angkatan Bersenjata Diraja Brunei'
                    }
                },
                '07-15': {
                    name: {
                        en: "Sultan's Birthday",
                        ms: 'Hari Keputeraan KDYMM Sultan Brunei'
                    }
                },
                '1 Ramadan': {
                    _name: '1 Ramadan'
                },
                '17 Ramadan': {
                    name: {
                        en: 'Nuzul Al-Quran',
                        ms: 'Hari Nuzul Al-Quran'
                    }
                },
                '1 Shawwal P3D': {
                    _name: '1 Shawwal'
                },
                '10 Dhu al-Hijjah': {
                    _name: '10 Dhu al-Hijjah'
                },
                '1 Muharram': {
                    _name: '1 Muharram'
                },
                '12 Rabi al-awwal': {
                    _name: '12 Rabi al-awwal'
                },
                '27 Rajab': {
                    _name: '27 Rajab'
                },
                '12-25': {
                    _name: '12-25'
                },
                'chinese 01-0-01': {
                    name: {
                        en: 'Chinese New Year',
                        ms: 'Tahun Baru Cina'
                    }
                }
            }
        },
        BO: {
            names: {
                es: 'Bolivia',
                en: 'Bolivia'
            },
            dayoff: 'sunday',
            langs: [
                'es',
                'qu',
                'ay'
            ],
            zones: [
                'America/La_Paz'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                'substitutes 01-01 if sunday then next monday': {
                    name: {
                        en: "New Year's Day (substitutes)",
                        es: "A\xf1o Nuevo (substituto)"
                    }
                },
                '01-22': {
                    name: {
                        en: 'Plurinational State Foundation Day',
                        es: "D\xeda de la Creaci\xf3n del Estado Plurinacional de Bolivia"
                    }
                },
                'substitutes 01-22 if sunday then next monday': {
                    name: {
                        en: 'Plurinational State Foundation Day (substitutes)',
                        es: "D\xeda de la Creaci\xf3n del Estado Plurinacional de Bolivia (substituto)"
                    }
                },
                '02-02': {
                    name: {
                        en: 'Feast of the Virgin of Candelaria',
                        qu: 'Mamacha Candelaria',
                        es: 'Fiesta de la Virgen de Candelaria'
                    },
                    type: 'observance'
                },
                'easter -48': {
                    _name: 'easter -48',
                    name: {
                        es: 'Lunes de Carnaval'
                    }
                },
                'easter -47': {
                    _name: 'easter -47',
                    name: {
                        es: 'Martes de Carnaval'
                    }
                },
                '03-19': {
                    name: {
                        en: "Father's Day",
                        es: "D\xeda del Padre"
                    },
                    type: 'observance'
                },
                '03-23': {
                    name: {
                        en: 'Day of the Sea',
                        es: "D\xeda del Mar"
                    },
                    type: 'observance'
                },
                'easter -3': {
                    _name: 'easter -3',
                    type: 'observance'
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                '04-12': {
                    name: {
                        en: "Children's Day",
                        es: "D\xeda del Ni\xf1o"
                    },
                    type: 'observance'
                },
                '05-01': {
                    _name: '05-01'
                },
                'substitutes 05-01 if sunday then next monday': {
                    _name: '05-01',
                    name: {
                        en: 'Labour Day (substitutes)',
                        es: "D\xeda del Trabajo (substituto)"
                    }
                },
                '05-27': {
                    name: {
                        en: "Mother's Day",
                        es: "D\xeda de la Madre"
                    },
                    type: 'observance'
                },
                '06-06': {
                    name: {
                        en: "Teacher's Day",
                        es: "D\xeda del Maestro"
                    },
                    type: 'observance'
                },
                'easter 60': {
                    _name: 'easter 60'
                },
                '06-21': {
                    name: {
                        en: "Andean Amazonian Chaque\xf1o New Year",
                        ay: 'Willkakuti',
                        es: "A\xf1o Nuevo Andino Amaz\xf3nico Chaque\xf1o"
                    }
                },
                'substitutes 06-21 if sunday then next monday': {
                    name: {
                        en: 'Andean Amazonic Chacoan New Year (substitutes)',
                        ay: 'Willkakuti (substituto)',
                        es: "A\xf1o Nuevo Andino Amaz\xf3nico Chaque\xf1o (substituto)"
                    }
                },
                '08-06': {
                    _name: 'Independence Day'
                },
                'substitutes 08-06 if sunday then next monday': {
                    name: {
                        en: 'Independence Day (substitutes)',
                        es: "D\xeda de la Independencia (substituto)"
                    }
                },
                '08-17': {
                    name: {
                        en: 'Flag Day',
                        es: "D\xeda de la Bandera"
                    },
                    type: 'observance'
                },
                '09-21': {
                    name: {
                        en: "Student's Day",
                        es: "D\xeda del Estudiante"
                    },
                    type: 'observance'
                },
                '10-11': {
                    name: {
                        es: "D\xeda de la Mujer Boliviana",
                        en: "Bolivian Woman's Day"
                    },
                    type: 'observance'
                },
                '11-01': {
                    _name: '11-01',
                    name: {
                        es: 'Todos Santos'
                    },
                    type: 'observance'
                },
                '11-02': {
                    _name: '11-02',
                    name: {
                        es: 'Todos Santos'
                    }
                },
                '12-25': {
                    _name: '12-25'
                },
                'substitutes 12-25 if sunday then next monday': {
                    _name: '12-25',
                    name: {
                        en: 'Christmas Day (substitutes)',
                        es: 'Navidad (substituto)'
                    }
                }
            },
            states: {
                B: {
                    name: 'Beni',
                    days: {
                        '11-18': {
                            name: {
                                es: "Efem\xe9rides del Beni",
                                en: 'Beni Day'
                            }
                        },
                        'substitutes 11-18 if sunday then next monday': {
                            name: {
                                es: "Efem\xe9rides del Beni (substituto)",
                                en: 'Beni Day (substitutes)'
                            }
                        }
                    }
                },
                C: {
                    name: 'Cochabamba',
                    days: {
                        '09-14': {
                            name: {
                                es: "Efem\xe9rides de Cochabamba",
                                en: 'Cochabamba Day'
                            }
                        },
                        'substitutes 09-14 if sunday then next monday': {
                            name: {
                                es: "Efem\xe9rides de Cochabamba (substituto)",
                                en: 'Cochabamba Day (substitutes)'
                            }
                        }
                    }
                },
                H: {
                    name: 'Chuquisaca',
                    days: {
                        '05-25': {
                            name: {
                                es: "Efem\xe9rides de Chuquisaca",
                                en: 'Chuquisaca Day'
                            }
                        },
                        'substitutes 05-25 if sunday then next monday': {
                            name: {
                                es: "Efem\xe9rides de Chuquisaca (substituto)",
                                en: 'Chuquisaca Day (substitutes)'
                            }
                        }
                    }
                },
                L: {
                    name: 'La Paz',
                    days: {
                        '07-16': {
                            name: {
                                es: "Efem\xe9rides de La Paz",
                                en: 'La Paz Day'
                            }
                        },
                        'substitutes 07-16 if sunday then next monday': {
                            name: {
                                es: "Efem\xe9rides de La Paz (substituto)",
                                en: 'La Paz Day (substitutes)'
                            }
                        }
                    }
                },
                N: {
                    name: 'Pando',
                    days: {
                        '09-24': {
                            name: {
                                es: "Efem\xe9rides de Pando",
                                en: 'Pando Day'
                            }
                        },
                        'substitutes 09-24 if sunday then next monday': {
                            name: {
                                es: "Efem\xe9rides de Pando (substituto)",
                                en: 'Pando Day (substitutes)'
                            }
                        }
                    }
                },
                O: {
                    name: 'Oruro',
                    days: {
                        '02-10': {
                            name: {
                                es: "Efem\xe9rides de Oruro",
                                en: 'Oruro Day'
                            }
                        },
                        'substitutes 02-10 if sunday then next monday': {
                            name: {
                                es: "Efem\xe9rides de Oruro (substituto)",
                                en: 'Oruro Day (substitutes)'
                            }
                        }
                    }
                },
                P: {
                    name: "Potos\xed",
                    days: {
                        '11-10': {
                            name: {
                                es: "Efem\xe9rides de Potos\xed",
                                en: "Potos\xed Day"
                            }
                        },
                        'substitutes 11-10 if sunday then next monday': {
                            name: {
                                es: "Efem\xe9rides de Potos\xed (substituto)",
                                en: "Potos\xed Day (substitutes)"
                            }
                        }
                    }
                },
                S: {
                    name: 'Santa Cruz',
                    days: {
                        '09-24': {
                            name: {
                                es: "Efem\xe9rides de Santa Cruz",
                                en: 'Santa Cruz Day'
                            }
                        },
                        'substitutes 09-24 if sunday then next monday': {
                            name: {
                                es: "Efem\xe9rides de Santa Cruz (substituto)",
                                en: 'Santa Cruz Day (substitutes)'
                            }
                        }
                    }
                },
                T: {
                    name: 'Tarija',
                    days: {
                        '04-15': {
                            name: {
                                es: "Efem\xe9rides de Tarija",
                                en: 'Tarija Day'
                            }
                        },
                        'substitutes 04-15 if sunday then next monday': {
                            name: {
                                es: "Efem\xe9rides de Tarija (substituto)",
                                en: 'Tarija Day (substitutes)'
                            }
                        }
                    }
                }
            }
        },
        BQ: {
            names: {
                nl: 'Caribisch Nederland',
                en: 'Caribbean Netherlands'
            },
            dayoff: 'sunday',
            zones: [
                'America/Curacao'
            ],
            langs: [
                'nl',
                'en',
                'pap'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                easter: {
                    _name: 'easter',
                    type: 'observance'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '04-27': {
                    name: {
                        pap: "A\xf1a di Rey",
                        nl: 'Koningsdag',
                        en: 'Kings Day'
                    }
                },
                '05-01 if sunday then next monday': {
                    substitute: true,
                    _name: '05-01'
                },
                '2nd sunday in May': {
                    _name: 'Mothers Day',
                    type: 'observance'
                },
                '3rd sunday in June': {
                    _name: 'Fathers Day',
                    type: 'observance'
                },
                'easter 39': {
                    _name: 'easter 39'
                },
                '12-05': {
                    name: {
                        nl: 'Sinterklaasavond',
                        en: "St. Nicholas' Eve"
                    },
                    type: 'observance'
                },
                '12-15': {
                    name: {
                        pap: 'Dia di Reino',
                        nl: 'Koninkrijksdag',
                        en: 'Kingdom Day'
                    }
                },
                '12-25': {
                    _name: '12-25'
                },
                '12-26': {
                    _name: '12-26'
                }
            },
            regions: {
                BO: {
                    name: 'Bonaire',
                    days: {
                        'easter -48': {
                            _name: 'easter -48',
                            name: {
                                en: 'Carnival Monday'
                            }
                        },
                        '04-30': {
                            name: {
                                en: 'Rincon Day',
                                pap: 'Dia di Rincon'
                            }
                        },
                        '09-06': {
                            name: {
                                nl: 'Boneiru Dag',
                                en: 'Bonaire Day',
                                pap: 'Dia di Boneiru'
                            }
                        }
                    }
                },
                SA: {
                    name: 'Saba',
                    days: {
                        '1st monday in August': {
                            _name: 'easter -48',
                            name: {
                                en: 'Carnival Monday'
                            }
                        },
                        '1st friday in December': {
                            name: {
                                en: 'Saba Day'
                            }
                        }
                    }
                },
                SE: {
                    name: 'Sint Eustatius',
                    days: {
                        '08-01': {
                            name: {
                                en: 'Emancipation Day'
                            }
                        },
                        '11-16': {
                            name: {
                                en: 'Statia Day'
                            }
                        }
                    }
                }
            }
        },
        BR: {
            names: {
                pt: 'Brasil',
                en: 'Brazil'
            },
            dayoff: 'sunday',
            langs: [
                'pt'
            ],
            zones: [
                'America/Sao_Paulo',
                'America/Noronha',
                'America/Belem',
                'America/Fortaleza',
                'America/Recife',
                'America/Araguaina',
                'America/Maceio',
                'America/Bahia',
                'America/Campo_Grande',
                'America/Cuiaba',
                'America/Santarem',
                'America/Porto_Velho',
                'America/Boa_Vista',
                'America/Manaus',
                'America/Eirunepe',
                'America/Rio_Branco'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '04-21': {
                    name: {
                        pt: 'Dia de Tiradentes',
                        en: "Tiradentes' Day"
                    }
                },
                'easter -50 PT110H': {
                    name: {
                        pt: 'Carnaval',
                        en: 'Carnival'
                    },
                    type: 'optional'
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                easter: {
                    _name: 'easter',
                    type: 'observance'
                },
                '05-01': {
                    _name: '05-01'
                },
                '2nd sunday in May': {
                    _name: 'Mothers Day',
                    type: 'observance'
                },
                'easter 60': {
                    _name: 'easter 60',
                    type: 'optional'
                },
                '06-12': {
                    name: {
                        pt: 'Dia dos Namorados',
                        en: "Lovers' Day"
                    },
                    type: 'observance'
                },
                '2nd sunday in August': {
                    _name: 'Fathers Day',
                    type: 'observance'
                },
                '09-07': {
                    _name: 'Independence Day'
                },
                '10-12': {
                    name: {
                        pt: 'Nossa Senhora Aparecida',
                        en: 'Our Lady of Aparecida'
                    }
                },
                '1st sunday in October in even years': {
                    name: {
                        pt: "Dia de Elei\xe7\xe3o",
                        en: 'Election Day'
                    }
                },
                '1st sunday before 11-01 in even years': {
                    name: {
                        pt: "Dia de Elei\xe7\xe3o",
                        en: 'Election Day'
                    }
                },
                '11-02': {
                    _name: '11-02'
                },
                '11-15': {
                    name: {
                        pt: "Proclama\xe7\xe3o da Rep\xfablica",
                        en: 'Republic Day'
                    }
                },
                '11-20': {
                    name: {
                        pt: "Dia da Consci\xeancia Negra",
                        en: 'Black Awareness Day'
                    },
                    active: [
                        {
                            from: '2023-12-21T00:00:00.000Z'
                        }
                    ]
                },
                '12-24 14:00': {
                    _name: '12-24',
                    type: 'optional'
                },
                '12-25': {
                    _name: '12-25'
                },
                '12-31 14:00': {
                    _name: '12-31',
                    type: 'optional'
                }
            },
            states: {
                AC: {
                    name: 'Acre',
                    zones: [
                        'America/Rio_Branco'
                    ],
                    days: {
                        '01-12': {
                            name: {
                                pt: "Dia do evang\xe9lico"
                            },
                            active: [
                                {
                                    from: '2004-01-29T00:00:00.000Z'
                                }
                            ]
                        },
                        '03-08': {
                            name: {
                                pt: 'Alusivo ao Dia Internacional da Mulher'
                            },
                            active: [
                                {
                                    from: '2001-09-14T00:00:00.000Z'
                                }
                            ]
                        },
                        '06-15': {
                            name: {
                                pt: "Anivers\xe1rio do estado"
                            },
                            active: [
                                {
                                    from: '1964-09-02T00:00:00.000Z'
                                }
                            ]
                        },
                        '09-05': {
                            name: {
                                pt: "Dia da Amaz\xf4nia"
                            },
                            active: [
                                {
                                    from: '2004-01-05T00:00:00.000Z'
                                }
                            ]
                        },
                        '11-17': {
                            name: {
                                pt: "Assinatura do Tratado de Petr\xf3polis"
                            },
                            type: 'optional',
                            active: [
                                {
                                    from: '2012-02-21T00:00:00.000Z'
                                }
                            ]
                        }
                    }
                },
                AL: {
                    name: 'Alagoas',
                    zones: [
                        'America/Maceio'
                    ],
                    days: {
                        '06-24': {
                            name: {
                                pt: "S\xe3o Jo\xe3o"
                            },
                            active: [
                                {
                                    from: '1993-07-07T00:00:00.000Z'
                                }
                            ]
                        },
                        '06-29': {
                            name: {
                                pt: "S\xe3o Pedro"
                            },
                            active: [
                                {
                                    from: '1993-07-07T00:00:00.000Z'
                                }
                            ]
                        },
                        '09-16': {
                            name: {
                                pt: "Emancipa\xe7\xe3o pol\xedtica"
                            }
                        },
                        '11-20': {
                            name: {
                                pt: 'Morte de Zumbi dos Palmares'
                            },
                            active: [
                                {
                                    from: '1995-08-01T00:00:00.000Z'
                                }
                            ]
                        }
                    }
                },
                AM: {
                    name: 'Amazonas',
                    zones: [
                        'America/Manaus'
                    ],
                    days: {
                        '09-05': {
                            name: {
                                pt: "Eleva\xe7\xe3o do Amazonas \xe0 categoria de prov\xedncia"
                            },
                            active: [
                                {
                                    from: '1977-12-21T00:00:00.000Z'
                                }
                            ]
                        },
                        '11-20': {
                            name: {
                                pt: "Dia da Consci\xeancia Negra"
                            },
                            active: [
                                {
                                    from: '2010-07-08T00:00:00.000Z',
                                    to: '2023-12-21T00:00:00.000Z'
                                }
                            ]
                        }
                    }
                },
                AP: {
                    name: "Amap\xe1",
                    zones: [
                        'America/Belem'
                    ],
                    days: {
                        '03-19': {
                            name: {
                                pt: "Dia de S\xe3o Jos\xe9"
                            },
                            note: "Santo padroeiro do Estado do Amap\xe1",
                            active: [
                                {
                                    from: '2002-04-16T00:00:00.000Z'
                                }
                            ]
                        },
                        '09-13': {
                            name: {
                                pt: "Cria\xe7\xe3o do Territ\xf3rio Federal"
                            }
                        }
                    }
                },
                BA: {
                    name: 'Bahia',
                    zones: [
                        'America/Bahia'
                    ],
                    days: {
                        '07-02': {
                            name: {
                                pt: "Independ\xeancia da Bahia"
                            }
                        }
                    }
                },
                CE: {
                    name: "Cear\xe1",
                    zones: [
                        'America/Fortaleza'
                    ],
                    days: {
                        '03-25': {
                            name: {
                                pt: 'Data magna do estado'
                            },
                            active: [
                                {
                                    from: '2011-12-01T00:00:00.000Z'
                                }
                            ]
                        }
                    }
                },
                DF: {
                    name: 'Distrito Federal',
                    zones: [
                        'America/Sao_Paulo'
                    ],
                    days: {
                        '04-21': {
                            name: {
                                pt: "Funda\xe7\xe3o de Bras\xedlia"
                            }
                        },
                        '11-30': {
                            name: {
                                pt: "Dia do Evang\xe9lico"
                            },
                            type: 'public',
                            active: [
                                {
                                    from: '1995-12-04T00:00:00.000Z'
                                }
                            ]
                        }
                    }
                },
                MA: {
                    name: "Maranh\xe3o",
                    zones: [
                        'America/Belem'
                    ],
                    days: {
                        '07-28': {
                            name: {
                                pt: "Ades\xe3o do Maranh\xe3o \xe0 independ\xeancia do Brasil"
                            },
                            active: [
                                {
                                    from: '1964-10-02T00:00:00.000Z'
                                }
                            ]
                        }
                    }
                },
                MG: {
                    name: 'Minas Gerais',
                    zones: [
                        'America/Sao_Paulo'
                    ],
                    days: {
                        '04-21': {
                            name: {
                                pt: 'Data magna do estado'
                            }
                        }
                    },
                    regions: {
                        BH: {
                            name: 'Belo Horizonte',
                            days: {
                                '08-15': {
                                    _name: '08-15',
                                    name: {
                                        pt: "Assun\xe7\xe3o de Nossa Senhora"
                                    },
                                    type: 'public'
                                },
                                '12-08': {
                                    _name: '12-08',
                                    type: 'public'
                                }
                            }
                        }
                    }
                },
                MS: {
                    name: 'Mato Grosso do Sul',
                    zones: [
                        'America/Campo_Grande'
                    ],
                    days: {
                        '10-11': {
                            name: {
                                pt: "Cria\xe7\xe3o do estado"
                            },
                            active: [
                                {
                                    from: '1979-10-29T00:00:00.000Z'
                                }
                            ]
                        }
                    }
                },
                MT: {
                    name: 'Mato Grosso',
                    zones: [
                        'America/Cuiaba'
                    ],
                    days: {
                        '11-20': {
                            name: {
                                pt: "Dia da Consci\xeancia Negra"
                            },
                            active: [
                                {
                                    from: '2002-12-27T00:00:00.000Z',
                                    to: '2023-12-21T00:00:00.000Z'
                                }
                            ]
                        }
                    }
                },
                PA: {
                    name: "Par\xe1",
                    zones: [
                        'America/Santarem'
                    ],
                    days: {
                        '08-15': {
                            name: {
                                pt: "Ades\xe3o do Gr\xe3o-Par\xe1 \xe0 independ\xeancia do Brasil"
                            },
                            active: [
                                {
                                    from: '1996-09-10T00:00:00.000Z'
                                }
                            ]
                        }
                    }
                },
                PB: {
                    name: "Para\xedba",
                    zones: [
                        'America/Recife'
                    ],
                    days: {
                        '07-26': {
                            name: {
                                pt: "Homenagem \xe0 mem\xf3ria do ex-presidente Jo\xe3o Pessoa"
                            }
                        },
                        '08-05': {
                            name: {
                                pt: 'Nossa Senhora das Neves'
                            },
                            note: "Funda\xe7\xe3o do Estado em 1585 e dia da sua padroeira",
                            active: [
                                {
                                    from: '1967-08-30T00:00:00.000Z'
                                }
                            ]
                        }
                    }
                },
                PE: {
                    name: 'Pernambuco',
                    zones: [
                        'America/Recife'
                    ],
                    days: {
                        '1st sunday in March': {
                            name: {
                                pt: "Revolu\xe7\xe3o Pernambucana de 1817"
                            },
                            active: [
                                {
                                    from: '2009-07-02T00:00:00.000Z'
                                }
                            ]
                        }
                    },
                    regions: {
                        RE: {
                            name: 'Recife',
                            days: {
                                '06-24': {
                                    name: {
                                        pt: "S\xe3o Jo\xe3o",
                                        en: "Saint John's Day"
                                    },
                                    type: 'public'
                                },
                                '07-16': {
                                    name: {
                                        pt: 'Nossa Senhora do Carmo'
                                    },
                                    type: 'public'
                                },
                                '12-08': {
                                    _name: '12-08',
                                    name: {
                                        pt: "Nossa Senhora da Concei\xe7\xe3o"
                                    },
                                    type: 'public'
                                }
                            }
                        }
                    }
                },
                PI: {
                    name: "Piau\xed",
                    zones: [
                        'America/Fortaleza'
                    ],
                    days: {
                        '10-19': {
                            name: {
                                pt: "Dia do Piau\xed"
                            },
                            active: [
                                {
                                    from: '1937-01-01T00:00:00.000Z'
                                }
                            ]
                        }
                    }
                },
                PR: {
                    name: "Paran\xe1",
                    zones: [
                        'America/Sao_Paulo'
                    ],
                    days: {
                        '12-19': {
                            name: {
                                pt: "Emancipa\xe7\xe3o pol\xedtica do estado do Paran\xe1"
                            },
                            active: [
                                {
                                    from: '1962-12-18T00:00:00.000Z'
                                }
                            ]
                        }
                    },
                    regions: {
                        CU: {
                            name: 'Curitiba',
                            days: {
                                '09-08': {
                                    name: {
                                        pt: 'Nossa Senhora da Luz dos Pinhais'
                                    },
                                    type: 'public'
                                }
                            }
                        }
                    }
                },
                RJ: {
                    name: 'Rio de Janeiro',
                    zones: [
                        'America/Sao_Paulo'
                    ],
                    days: {
                        'easter -47': {
                            name: {
                                pt: 'Carnaval'
                            },
                            active: [
                                {
                                    from: '2008-05-14T00:00:00.000Z'
                                }
                            ]
                        },
                        '04-23': {
                            name: {
                                pt: "Dia de S\xe3o Jorge"
                            },
                            active: [
                                {
                                    from: '2008-03-05T00:00:00.000Z'
                                }
                            ]
                        },
                        '3rd tuesday in October': {
                            name: {
                                pt: "Dia do Com\xe9rcio"
                            },
                            type: 'observance',
                            note: "feriado para os comerciantes e trabalhadores da constru\xe7\xe3o civil"
                        },
                        '11-20': {
                            name: {
                                pt: "Dia da Consci\xeancia Negra"
                            },
                            active: [
                                {
                                    from: '2002-11-11T00:00:00.000Z',
                                    to: '2023-12-21T00:00:00.000Z'
                                }
                            ]
                        }
                    },
                    regions: {
                        RJ: {
                            name: 'Rio de Janeiro',
                            days: {
                                '01-20': {
                                    name: {
                                        pt: "Dia de S\xe3o Sebasti\xe3o"
                                    },
                                    type: 'public',
                                    active: [
                                        {
                                            from: '1988-06-27T00:00:00.000Z'
                                        }
                                    ]
                                }
                            }
                        }
                    }
                },
                RN: {
                    name: 'Rio Grande do Norte',
                    zones: [
                        'America/Recife'
                    ],
                    days: {
                        '10-03': {
                            name: {
                                pt: "M\xe1rtires de Cunha\xfa e Urua\xe7u"
                            },
                            active: [
                                {
                                    from: '2006-12-06T00:00:00.000Z'
                                }
                            ]
                        }
                    }
                },
                RO: {
                    name: "Rond\xf4nia",
                    zones: [
                        'America/Porto_Velho'
                    ],
                    days: {
                        '01-04': {
                            name: {
                                pt: "Cria\xe7\xe3o do estado"
                            },
                            active: [
                                {
                                    from: '2010-04-22T00:00:00.000Z'
                                }
                            ]
                        },
                        '06-18': {
                            name: {
                                pt: "Dia do evang\xe9lico"
                            },
                            active: [
                                {
                                    from: '2001-12-20T00:00:00.000Z'
                                }
                            ]
                        }
                    }
                },
                RR: {
                    name: 'Roraima',
                    zones: [
                        'America/Boa_Vista'
                    ],
                    days: {
                        '10-05': {
                            name: {
                                pt: "Cria\xe7\xe3o do estado"
                            }
                        }
                    }
                },
                RS: {
                    name: 'Rio Grande do Sul',
                    zones: [
                        'America/Sao_Paulo'
                    ],
                    days: {
                        '09-20': {
                            name: {
                                pt: "Proclama\xe7\xe3o da Rep\xfablica Rio-Grandense"
                            }
                        }
                    }
                },
                SC: {
                    name: 'Santa Catarina',
                    zones: [
                        'America/Sao_Paulo'
                    ],
                    days: {
                        '08-11': {
                            name: {
                                pt: 'Dia de Santa Catarina'
                            },
                            active: [
                                {
                                    from: '2004-01-22T00:00:00.000Z',
                                    to: '2005-07-15T00:00:00.000Z'
                                }
                            ]
                        },
                        '08-11 if monday,tuesday,wednesday,thursday,friday,saturday then next sunday': {
                            name: {
                                pt: 'Dia de Santa Catarina'
                            },
                            active: [
                                {
                                    from: '2005-07-15T00:00:00.000Z'
                                }
                            ]
                        },
                        '11-25': {
                            name: {
                                pt: 'Dia de Santa Catarina de Alexandria'
                            },
                            active: [
                                {
                                    from: '1996-12-26T00:00:00.000Z',
                                    to: '2005-07-15T00:00:00.000Z'
                                }
                            ]
                        },
                        '11-25 if monday,tuesday,wednesday,thursday,friday,saturday then next sunday': {
                            name: {
                                pt: 'Dia de Santa Catarina de Alexandria'
                            },
                            active: [
                                {
                                    from: '2005-07-15T00:00:00.000Z'
                                }
                            ]
                        }
                    }
                },
                SE: {
                    name: 'Sergipe',
                    zones: [
                        'America/Recife'
                    ],
                    days: {
                        '07-08': {
                            name: {
                                pt: "Emancipa\xe7\xe3o pol\xedtica de Sergipe"
                            }
                        }
                    }
                },
                SP: {
                    name: "S\xe3o Paulo",
                    zones: [
                        'America/Sao_Paulo'
                    ],
                    days: {
                        '07-09': {
                            name: {
                                pt: "Revolu\xe7\xe3o Constitucionalista"
                            },
                            active: [
                                {
                                    from: '1997-03-05T00:00:00.000Z'
                                }
                            ]
                        },
                        '11-20': {
                            name: {
                                pt: "Dia da Consci\xeancia Negra"
                            },
                            active: [
                                {
                                    from: '2023-09-12T00:00:00.000Z',
                                    to: '2023-12-21T00:00:00.000Z'
                                }
                            ]
                        }
                    },
                    regions: {
                        SP: {
                            name: "S\xe3o Paulo",
                            days: {
                                'easter 60': {
                                    _name: 'easter 60',
                                    type: 'public'
                                },
                                '01-25': {
                                    name: {
                                        pt: "Anivers\xe1rio da Cidade",
                                        en: 'City Birthday'
                                    },
                                    type: 'public'
                                },
                                '11-20': {
                                    name: {
                                        pt: "Dia da Consci\xeancia Negra"
                                    },
                                    active: [
                                        {
                                            from: '2004-01-07T00:00:00.000Z'
                                        }
                                    ]
                                }
                            }
                        }
                    }
                },
                TO: {
                    name: 'Tocantins',
                    zones: [
                        'America/Araguaina'
                    ],
                    days: {
                        '10-05': {
                            name: {
                                pt: "Cria\xe7\xe3o do estado"
                            },
                            active: [
                                {
                                    from: '1989-11-17T00:00:00.000Z'
                                }
                            ]
                        },
                        '03-18': {
                            name: {
                                pt: 'Autonomia do Estado'
                            },
                            active: [
                                {
                                    from: '1998-03-17T00:00:00.000Z'
                                }
                            ]
                        },
                        '09-08': {
                            name: {
                                pt: 'Nossa Senhora da Natividade'
                            },
                            note: 'Padroeira do Estado',
                            active: [
                                {
                                    from: '1993-12-28T00:00:00.000Z'
                                }
                            ]
                        }
                    }
                }
            }
        },
        BS: {
            names: {
                en: 'Bahamas'
            },
            dayoff: 'sunday',
            langs: [
                'en'
            ],
            zones: [
                'America/Nassau'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '01-10 and if saturday,sunday then next monday': {
                    substitute: true,
                    name: {
                        en: 'Majority Rule Day'
                    }
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                easter: {
                    _name: 'easter',
                    type: 'observance'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '2nd sunday in May': {
                    _name: 'Mothers Day',
                    type: 'observance'
                },
                'easter 49': {
                    _name: 'easter 49',
                    type: 'observance'
                },
                'easter 50': {
                    _name: 'easter 50'
                },
                '1st friday in June': {
                    _name: '05-01',
                    name: {
                        en: 'Randol Fawkes Labour Day'
                    }
                },
                '07-10 and if saturday,sunday then next monday': {
                    substitute: true,
                    _name: 'Independence Day'
                },
                '1st monday in August': {
                    name: {
                        en: 'Emancipation Day'
                    }
                },
                '10-12 and if saturday,sunday then next monday': {
                    substitute: true,
                    name: {
                        en: "National Heroes' Day"
                    }
                },
                '12-25': {
                    _name: '12-25'
                },
                '12-26': {
                    _name: '12-26'
                }
            }
        },
        BW: {
            names: {
                en: 'Botswana'
            },
            dayoff: 'sunday',
            langs: [
                'en'
            ],
            zones: [
                'Africa/Maputo'
            ],
            days: {
                '01-01': {
                    _name: '01-01',
                    note: 'except mining industy'
                },
                '01-02': {
                    name: {
                        en: "New Year's Holiday"
                    },
                    note: 'except mining industy'
                },
                'substitutes 01-02 if monday then next tuesday': {
                    name: {
                        en: 'Public Holiday'
                    },
                    note: 'except mining industy'
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                'easter -1': {
                    _name: 'easter -1',
                    note: 'except mining industy'
                },
                easter: {
                    _name: 'easter',
                    type: 'observance'
                },
                'easter 1': {
                    _name: 'easter 1',
                    note: 'except mining industy'
                },
                'easter 39': {
                    _name: 'easter 39',
                    note: 'except mining industy'
                },
                '05-01': {
                    _name: '05-01',
                    note: 'except mining industy'
                },
                'substitutes 05-01 if sunday then next monday': {
                    name: {
                        en: 'Public Holiday'
                    },
                    note: 'except mining industy'
                },
                '2nd sunday in May': {
                    _name: 'Mothers Day',
                    type: 'observance'
                },
                '07-01': {
                    name: {
                        en: 'Sir Seretse Khama Day'
                    },
                    note: 'except mining industy'
                },
                'substitutes 07-01 if sunday then next monday': {
                    name: {
                        en: 'Public Holiday'
                    },
                    note: 'except mining industy'
                },
                '3rd monday in July': {
                    name: {
                        en: "President\u2019s Day"
                    },
                    note: 'except mining industy'
                },
                'tuesday after 3rd monday in July': {
                    name: {
                        en: "President\u2019s Day Holiday"
                    },
                    note: 'except mining industy'
                },
                '09-30': {
                    name: {
                        en: 'Botswana Day'
                    }
                },
                'substitutes 09-30 if saturday,sunday then next monday': {
                    name: {
                        en: 'Public Holiday'
                    }
                },
                '12-25': {
                    _name: '12-25'
                },
                '12-26': {
                    _name: '12-26',
                    name: {
                        en: 'Family Day'
                    },
                    note: 'except mining industy'
                },
                'substitutes 12-26 if monday then next tuesday': {
                    name: {
                        en: 'Public Holiday'
                    }
                }
            }
        },
        BY: {
            names: {
                be: "\u0420\u044D\u0441\u043F\u0443\u0431\u043B\u0456\u043A\u0430 \u0411\u0435\u043B\u0430\u0440\u0443\u0441\u044C",
                ru: "\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0411\u0435\u043B\u0430\u0440\u0443\u0441\u044C",
                en: 'Belarus'
            },
            zones: [
                'Europe/Minsk'
            ],
            langs: [
                'be',
                'ru'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                'julian 12-25': {
                    _name: '12-25',
                    name: {
                        be: "\u041A\u0430\u043B\u044F\u0434\u044B \u043F\u0440\u0430\u0432\u0430\u0441\u043B\u0430\u045E\u043D\u044B\u044F"
                    }
                },
                easter: {
                    _name: 'easter',
                    name: {
                        be: "\u0412\u044F\u043Bi\u043A\u0434\u0437\u0435\u043D\u044C \u043A\u0430\u0442\u0430\u043Bi\u0446\u043Ai"
                    },
                    type: 'observance'
                },
                orthodox: {
                    name: {
                        en: 'Orthodox Easter',
                        be: "\u0412\u044F\u043Bi\u043A\u0434\u0437\u0435\u043D\u044C \u043F\u0440\u0430\u0432\u0430\u0441\u043B\u0430\u045E\u043D\u044B"
                    },
                    type: 'observance'
                },
                'orthodox +9': {
                    name: {
                        en: 'Commemoration Day',
                        be: "\u0420\u0430\u0434\u0443\u043Di\u0446\u0430"
                    }
                },
                '03-08': {
                    _name: '03-08'
                },
                '05-01': {
                    _name: '05-01'
                },
                '05-09': {
                    name: {
                        en: 'Victory Day',
                        be: "\u0414\u0437\u0435\u043D\u044C \u041F\u0435\u0440\u0430\u043C\u043E\u0433i"
                    }
                },
                '07-03': {
                    _name: 'Independence Day',
                    active: [
                        {
                            from: 1996
                        }
                    ]
                },
                '11-07': {
                    name: {
                        en: 'October Revolution Day',
                        be: "\u0414\u0437\u0435\u043D\u044C \u041A\u0430\u0441\u0442\u0440\u044B\u0447\u043D\u0456\u0446\u043A\u0430\u0439 \u0440\u044D\u0432\u0430\u043B\u044E\u0446\u044B\u0456"
                    }
                },
                '12-25': {
                    _name: '12-25',
                    name: {
                        be: "\u041A\u0430\u043B\u044F\u0434\u044B \u043A\u0430\u0442\u0430\u043Bi\u0446\u043Ai\u044F"
                    }
                }
            }
        },
        BZ: {
            names: {
                en: 'Belize'
            },
            dayoff: 'sunday',
            langs: [
                'en'
            ],
            zones: [
                'America/Belize'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '03-09 if friday,saturday,sunday then next monday if tuesday,wednesday,thursday then previous monday': {
                    name: {
                        en: 'Baron Bliss Day'
                    }
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                'easter -1': {
                    _name: 'easter -1'
                },
                easter: {
                    _name: 'easter',
                    type: 'observance'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '05-01 if sunday then next monday': {
                    _name: '05-01'
                },
                '05-24 if friday,saturday,sunday then next monday if tuesday,wednesday,thursday then previous monday': {
                    name: {
                        en: "Commonwealth Day, Sovereign's Day"
                    }
                },
                '09-10 if sunday then next monday': {
                    name: {
                        en: "Saint George's Caye Day, National Day"
                    }
                },
                '09-21 if sunday then next monday': {
                    _name: 'Independence Day'
                },
                '10-12 if friday,saturday,sunday then next monday if tuesday,wednesday,thursday then previous monday': {
                    name: {
                        en: 'Day of the Americas'
                    }
                },
                '11-19 if sunday then next monday': {
                    name: {
                        en: 'Garifuna Settlement Day'
                    }
                },
                '12-25 and if sunday then next tuesday': {
                    _name: '12-25',
                    substitute: true
                },
                '12-26 and if sunday then next monday': {
                    _name: '12-26',
                    substitute: true
                }
            }
        },
        CA: {
            names: {
                en: 'Canada',
                fr: 'Canada'
            },
            zones: [
                'America/Toronto',
                'America/St_Johns',
                'America/Halifax',
                'America/Glace_Bay',
                'America/Moncton',
                'America/Goose_Bay',
                'America/Blanc-Sablon',
                'America/Nipigon',
                'America/Thunder_Bay',
                'America/Iqaluit',
                'America/Pangnirtung',
                'America/Resolute',
                'America/Atikokan',
                'America/Rankin_Inlet',
                'America/Winnipeg',
                'America/Rainy_River',
                'America/Regina',
                'America/Swift_Current',
                'America/Edmonton',
                'America/Cambridge_Bay',
                'America/Yellowknife',
                'America/Inuvik',
                'America/Creston',
                'America/Dawson_Creek',
                'America/Fort_Nelson',
                'America/Vancouver',
                'America/Whitehorse',
                'America/Dawson'
            ],
            langs: [
                'en',
                'fr'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '02-02': {
                    name: {
                        en: 'Groundhog Day',
                        fr: 'Jour de la marmotte'
                    },
                    type: 'observance'
                },
                '02-14': {
                    _name: '02-14',
                    type: 'observance'
                },
                '03-17': {
                    name: {
                        en: "St. Patrick\u2019s Day",
                        fr: "F\xeate de la Saint-Patrick"
                    },
                    type: 'observance'
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                easter: {
                    _name: 'easter'
                },
                '2nd sunday after 05-01': {
                    _name: 'Mothers Day',
                    type: 'observance'
                },
                'monday before 05-25': {
                    name: {
                        en: 'Victoria Day',
                        fr: "F\xeate de la Reine"
                    }
                },
                '3rd sunday after 06-01': {
                    _name: 'Fathers Day',
                    type: 'observance'
                },
                '07-01': {
                    name: {
                        en: 'Canada Day',
                        fr: "F\xeate du Canada"
                    }
                },
                'monday after 08-01': {
                    name: {
                        en: 'Civic Holiday',
                        fr: "Premier lundi d\u2019ao\xfbt"
                    }
                },
                '1st monday in September': {
                    _name: '05-01'
                },
                '09-30 since 2021': {
                    name: {
                        en: 'National Day for Truth and Reconciliation',
                        fr: "Journ\xe9e nationale de la v\xe9rit\xe9 et de la r\xe9conciliation"
                    }
                },
                '2nd monday after 10-01': {
                    name: {
                        en: 'Thanksgiving',
                        fr: "Action de gr\xe2ce"
                    }
                },
                '10-31 18:00': {
                    name: {
                        en: 'Halloween',
                        fr: "l'Halloween"
                    },
                    type: 'observance'
                },
                '11-11': {
                    name: {
                        en: 'Remembrance Day',
                        fr: 'Jour du Souvenir'
                    }
                },
                '12-25': {
                    _name: '12-25'
                },
                '12-26': {
                    _name: '12-26'
                }
            },
            states: {
                AB: {
                    name: 'Alberta',
                    zones: [
                        'America/Edmonton'
                    ],
                    days: {
                        '3rd monday after 02-01': {
                            name: {
                                en: 'Family Day',
                                fr: "F\xeate de la famille"
                            }
                        },
                        'easter 1': {
                            _name: 'easter 1',
                            type: 'optional'
                        },
                        'monday after 08-01': {
                            name: {
                                en: 'Heritage Day',
                                fr: "F\xeate du patrimoine"
                            },
                            type: 'optional'
                        }
                    }
                },
                BC: {
                    name: 'British Columbia',
                    zones: [
                        'America/Vancouver',
                        'America/Edmonton',
                        'America/Creston',
                        'America/Dawson_Creek'
                    ],
                    days: {
                        '2nd monday after 02-01': {
                            name: {
                                en: 'Family Day',
                                fr: "F\xeate de la famille"
                            },
                            active: [
                                {
                                    to: 2019
                                }
                            ]
                        },
                        '3rd monday after 02-01': {
                            name: {
                                en: 'Family Day',
                                fr: "F\xeate de la famille"
                            },
                            active: [
                                {
                                    from: 2019
                                }
                            ]
                        }
                    }
                },
                MB: {
                    name: 'Manitoba',
                    zones: [
                        'America/Winnipeg'
                    ],
                    days: {
                        '3rd monday after 02-01': {
                            name: {
                                en: 'Louis Riel Day',
                                fr: "Journ\xe9e Louis Riel"
                            }
                        }
                    }
                },
                NB: {
                    name: 'New Brunswick',
                    zones: [
                        'America/Moncton'
                    ],
                    days: {
                        'monday after 08-01': {
                            name: {
                                en: 'New Brunswick Day',
                                fr: 'Jour de Nouveau Brunswick'
                            }
                        }
                    }
                },
                NL: {
                    name: 'Newfoundland and Labrador',
                    zones: [
                        'America/St_Johns',
                        'America/Goose_Bay'
                    ],
                    days: {
                        '03-17': {
                            name: {
                                en: "Saint Patrick's Day",
                                fr: 'Jour de la Saint-Patrick'
                            },
                            type: 'optional'
                        },
                        '04-23': {
                            name: {
                                en: "Saint George's Day",
                                fr: 'Jour de St. George'
                            },
                            type: 'optional'
                        },
                        '06-24': {
                            name: {
                                en: 'Discovery Day',
                                fr: "Journ\xe9e d\xe9couverte"
                            },
                            type: 'optional'
                        },
                        '07-12': {
                            name: {
                                en: "Orangemen's Day",
                                fr: "F\xeate des orangistes"
                            },
                            type: 'optional'
                        },
                        '11-11': {
                            name: {
                                en: 'Armistice Day',
                                fr: "Jour de l'Armistice"
                            }
                        }
                    }
                },
                NS: {
                    name: 'Nova Scotia',
                    zones: [
                        'America/Halifax',
                        'America/Moncton'
                    ],
                    days: {
                        '3rd monday after 02-01': {
                            name: {
                                en: 'Heritage Day',
                                fr: "F\xeate du Patrimoine"
                            }
                        },
                        'monday after 08-01': {
                            name: {
                                en: 'Natal Day',
                                fr: 'Jour de la Fondation'
                            }
                        }
                    }
                },
                NT: {
                    name: 'Northwest Territories',
                    zones: [
                        'America/Yellowknife',
                        'America/Inuvik'
                    ],
                    days: {
                        '06-21': {
                            name: {
                                en: 'National Indigenous Peoples Day',
                                fr: "Journ\xe9e nationale des Autochthones"
                            }
                        }
                    }
                },
                NU: {
                    name: 'Nunavut',
                    zones: [
                        'America/Iqaluit',
                        'America/Pangnirtung',
                        'America/Resolute',
                        'America/Rankin_Inlet',
                        'America/Atikokan',
                        'America/Cambridge_Bay'
                    ],
                    days: {
                        '07-09': {
                            name: {
                                en: 'Nunavut Day'
                            },
                            type: 'bank'
                        }
                    }
                },
                ON: {
                    name: 'Ontario',
                    zones: [
                        'America/Toronto',
                        'America/Nipigon',
                        'America/Thunder_Bay',
                        'America/Atikokan',
                        'America/Rainy_River',
                        'America/Winnipeg'
                    ],
                    days: {
                        '3rd monday after 02-01': {
                            name: {
                                en: 'Family Day',
                                fr: "F\xeate de la famille"
                            }
                        },
                        'easter 1': {
                            _name: 'easter 1'
                        }
                    }
                },
                PE: {
                    name: 'Prince Edward Island',
                    days: {
                        '3rd monday after 02-01': {
                            name: {
                                en: 'Islander Day',
                                fr: "F\xeate des Insulaires"
                            }
                        },
                        'easter 1': {
                            _name: 'easter 1',
                            type: 'optional'
                        },
                        '3rd friday after 08-01': {
                            name: {
                                en: 'Gold Cup Parade Day',
                                fr: "D\xe9fil\xe9 de la Coupe d'or"
                            }
                        }
                    }
                },
                QC: {
                    name: 'Quebec',
                    zones: [
                        'America/Blanc-Sablon',
                        'America/Toronto',
                        'America/Nipigon'
                    ],
                    days: {
                        'easter -2': {
                            _name: 'easter -2',
                            note: "Either Good Friday or Easter Monday, at the employer\u2019s option"
                        },
                        'easter 1': {
                            _name: 'easter 1',
                            note: "Either Good Friday or Easter Monday, at the employer\u2019s option"
                        },
                        'monday before 05-25': {
                            name: {
                                en: "National Patriots' Day",
                                fr: "Journ\xe9e nationale des patriotes"
                            }
                        },
                        '06-24': {
                            name: {
                                en: 'National Holiday',
                                fr: "F\xeate nationale du Qu\xe9bec"
                            }
                        },
                        'monday after 08-01': false
                    }
                },
                SK: {
                    name: 'Saskatchewan',
                    zones: [
                        'America/Regina',
                        'America/Swift_Current',
                        'America/Edmonton'
                    ],
                    days: {
                        '3rd monday after 02-01': {
                            name: {
                                en: 'Family Day',
                                fr: "F\xeate de la famille"
                            }
                        },
                        '3rd monday after 08-01': {
                            name: {
                                en: 'Saskatchewan Day'
                            }
                        }
                    }
                },
                YT: {
                    name: 'Yukon',
                    zones: [
                        'America/Whitehorse',
                        'America/Dawson'
                    ],
                    days: {
                        'easter 1': {
                            _name: 'easter 1'
                        },
                        '3rd monday after 08-01': {
                            name: {
                                en: 'Discovery Day',
                                fr: "Jour de la D\xe9couverte"
                            }
                        }
                    }
                }
            }
        },
        CC: {
            names: {
                en: 'Cocos (Keeling) Islands'
            },
            langs: [
                'en'
            ],
            zones: [
                'Indian/Cocos'
            ],
            dayoff: 'sunday',
            days: {
                'chinese 01-0-01 and if sunday then next tuesday if saturday then next monday': {
                    name: {
                        en: 'Chinese New Year'
                    },
                    substitute: true
                },
                'chinese 01-0-02 and if sunday then next tuesday if saturday then next monday': {
                    name: {
                        en: 'Chinese New Year (2nd Day)'
                    },
                    substitute: true
                },
                '01-01': {
                    _name: '01-01'
                },
                '01-26': {
                    name: {
                        en: 'Australia Day'
                    }
                },
                '03-20': {
                    name: {
                        en: 'Labour Day'
                    }
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '04-06': {
                    name: {
                        en: 'Self Determination Day'
                    }
                },
                '04-25': {
                    name: {
                        en: 'Anzac Day'
                    }
                },
                '12-25 and if sunday then next tuesday': {
                    _name: '12-25',
                    substitute: true
                },
                '12-26 and if sunday then next monday': {
                    _name: '12-26',
                    substitute: true
                },
                '1 Muharram and if sunday then next monday': {
                    substitute: true,
                    _name: '1 Muharram'
                },
                '1 Shawwal and if sunday then next monday': {
                    substitute: true,
                    _name: '1 Shawwal',
                    name: {
                        en: 'Hari Raya Puasa'
                    }
                },
                '10 Dhu al-Hijjah and if sunday then next monday': {
                    substitute: true,
                    _name: '10 Dhu al-Hijjah',
                    name: {
                        en: 'Hari Raya Haji'
                    }
                },
                '12 Rabi al-awwal and if sunday then next monday': {
                    substitute: true,
                    _name: '12 Rabi al-awwal',
                    name: {
                        en: 'Hari Maulaud Nabi'
                    }
                }
            }
        },
        CD: {
            names: {
                fr: "R\xe9publique d\xe9mocratique du Congo",
                en: 'Democratic Republic of the Congo'
            },
            dayoff: 'sunday',
            langs: [
                'fr'
            ],
            zones: [
                'Africa/Maputo',
                'Africa/Lagos'
            ],
            days: {
                '01-01 and if sunday then next monday': {
                    substitute: true,
                    _name: '01-01'
                },
                '01-04 and if sunday then next monday': {
                    substitute: true,
                    name: {
                        fr: "Martyrs de l'Ind\xe9pendance",
                        en: 'Day of the Martyrs'
                    }
                },
                '01-16 and if sunday then next tuesday': {
                    substitute: true,
                    name: {
                        fr: "Journ\xe9e du H\xe9ro National Laurent D\xe9sir\xe9 Kabila",
                        en: 'Anniversary of President Laurent Kabila'
                    }
                },
                '01-17 and if sunday then next monday': {
                    substitute: true,
                    name: {
                        fr: "Journ\xe9e du H\xe9ro National Patrice Emery Lumumba",
                        en: 'Anniversary of Prime Minister Patrice Emery Lumumba'
                    }
                },
                '05-01 and if sunday then next monday': {
                    substitute: true,
                    _name: '05-01'
                },
                '05-17 and if sunday then next monday': {
                    substitute: true,
                    name: {
                        fr: "Journ\xe9e de la R\xe9volution et des Forces Arm\xe9es",
                        en: 'Liberation Day'
                    }
                },
                '06-30 and if sunday then next monday': {
                    substitute: true,
                    _name: 'Independence Day',
                    name: {
                        fr: "Anniversaire de Ind\xe9pendance"
                    }
                },
                '08-01 and if sunday then next monday': {
                    substitute: true,
                    name: {
                        fr: "F\xeate des parents",
                        en: "Parents' Day"
                    }
                },
                '12-25 and if sunday then next monday': {
                    substitute: true,
                    _name: '12-25'
                },
                '2016-01-15': {
                    _name: 'Public Holiday'
                }
            }
        },
        CF: {
            names: {
                fr: "R\xe9publique centrafricaine",
                sg: "K\xf6d\xf6r\xf6s\xease t\xee B\xeaafr\xeeka",
                en: 'Central African Republic'
            },
            dayoff: 'sunday',
            langs: [
                'fr',
                'sg'
            ],
            zones: [
                'Africa/Lagos'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '03-29': {
                    name: {
                        fr: "D\xe9c\xe8s du Fondateur Barth\xe9l\xe9my Boganda",
                        en: 'Boganda Day'
                    }
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '05-01': {
                    _name: '05-01'
                },
                'easter 39': {
                    _name: 'easter 39'
                },
                'easter 50': {
                    _name: 'easter 50'
                },
                '06-30': {
                    name: {
                        fr: "Journ\xe9e de pri\xe8re",
                        en: 'General Prayer Day'
                    }
                },
                '08-13': {
                    _name: 'Independence Day'
                },
                '08-15': {
                    _name: '08-15'
                },
                '11-01': {
                    _name: '11-01'
                },
                '12-01': {
                    name: {
                        fr: "Jour de la R\xe9publique",
                        en: 'Republic Day'
                    }
                },
                '12-25': {
                    _name: '12-25'
                },
                '1 Shawwal': {
                    _name: '1 Shawwal'
                },
                '10 Dhu al-Hijjah': {
                    _name: '10 Dhu al-Hijjah'
                }
            }
        },
        CG: {
            names: {
                fr: "R\xe9publique du Congo",
                en: 'Republic of the Congo'
            },
            dayoff: 'sunday',
            langs: [
                'fr',
                'en'
            ],
            zones: [
                'Africa/Lagos'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '05-01': {
                    _name: '05-01'
                },
                'easter 39': {
                    _name: 'easter 39'
                },
                'easter 49': {
                    _name: 'easter 49'
                },
                'easter 50': {
                    _name: 'easter 50'
                },
                '06-10': {
                    name: {
                        fr: "F\xeate de la comm\xe9moration de la conf\xe9rence nationale souveraine"
                    }
                },
                '08-15': {
                    _name: '08-15'
                },
                '11-01': {
                    _name: '11-01'
                },
                '11-28': {
                    name: {
                        fr: "Journ\xe9e nationale de la R\xe9publique"
                    }
                },
                '12-25': {
                    _name: '12-25'
                }
            }
        },
        CH: {
            names: {
                de: 'Schweiz',
                fr: 'Suisse',
                it: 'Svizzera',
                en: 'Switzerland'
            },
            dayoff: 'sunday',
            langs: [
                'de-ch',
                'de',
                'fr',
                'it'
            ],
            zones: [
                'Europe/Zurich'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                'easter -3': {
                    _name: 'easter -3',
                    type: 'observance'
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                easter: {
                    _name: 'easter'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                'easter 39': {
                    _name: 'easter 39',
                    name: {
                        de: 'Auffahrt'
                    }
                },
                'easter 49': {
                    _name: 'easter 49'
                },
                'easter 50': {
                    _name: 'easter 50'
                },
                '2nd sunday in May': {
                    _name: 'Mothers Day',
                    type: 'observance'
                },
                '1st sunday in June': {
                    name: {
                        de: "V\xe4tertag",
                        fr: "F\xeate des p\xe8res"
                    },
                    type: 'observance',
                    active: [
                        {
                            from: '2009-01-01'
                        }
                    ]
                },
                '08-01': {
                    name: {
                        de: 'Bundesfeiertag',
                        fr: "F\xeate nationale",
                        it: 'Giorno festivo federale'
                    }
                },
                '3rd sunday after 09-01': {
                    name: {
                        de: 'Eidg. Dank-, Buss- und Bettag',
                        fr: "Je\xfbne f\xe9d\xe9ral",
                        it: 'Digiuno federale',
                        en: 'Federal Day of Thanksgiving, Repentance and Prayer'
                    }
                },
                '12-25': {
                    _name: '12-25',
                    name: {
                        de: 'Weihnachtstag'
                    }
                },
                '12-26': {
                    _name: '12-26',
                    name: {
                        de: 'Stephanstag',
                        fr: 'Saint-Etienne'
                    }
                }
            },
            states: {
                ZH: {
                    names: {
                        de: "Kanton Z\xfcrich",
                        fr: 'Canton de Zurich',
                        it: 'Canton Zurigo',
                        en: "Canton of Z\xfcrich"
                    },
                    days: {
                        '01-02': {
                            name: {
                                de: 'Berchtoldstag',
                                fr: 'Saint-Berthold'
                            },
                            type: 'optional'
                        },
                        '05-01': {
                            _name: '05-01'
                        },
                        'easter 50': {
                            _name: 'easter 50'
                        },
                        'monday after 2nd saturday in September 13:00': {
                            name: {
                                de: 'Knabenschiessen'
                            },
                            type: 'optional'
                        }
                    }
                },
                BE: {
                    names: {
                        de: 'Kanton Bern',
                        fr: 'Canton de Berne',
                        it: 'Canton Berna',
                        en: 'Canton of Bern'
                    },
                    days: {
                        '01-02': {
                            name: {
                                de: 'Berchtoldstag',
                                fr: '2 janvier'
                            }
                        }
                    }
                },
                LU: {
                    names: {
                        de: 'Kanton Luzern',
                        fr: 'Canton de Lucerne',
                        it: 'Canton Lucerna',
                        en: 'Canton of Lucerne'
                    },
                    days: {
                        '01-02': {
                            name: {
                                de: 'Berchtoldstag',
                                fr: 'Saint-Berthold'
                            },
                            type: 'optional'
                        },
                        '03-19': {
                            _name: '03-19',
                            type: 'observance'
                        },
                        'easter 1': {
                            _name: 'easter 1',
                            type: 'optional'
                        },
                        'easter 50': {
                            _name: 'easter 50',
                            type: 'optional'
                        },
                        'easter 60': {
                            _name: 'easter 60'
                        },
                        '08-15': {
                            _name: '08-15'
                        },
                        '11-01': {
                            _name: '11-01'
                        },
                        '12-08': {
                            _name: '12-08'
                        }
                    }
                },
                UR: {
                    names: {
                        de: 'Kanton Uri',
                        fr: "Canton d'Uri",
                        it: 'Canton Uri',
                        en: 'Canton of Uri'
                    },
                    days: {
                        '01-06': {
                            _name: '01-06'
                        },
                        '03-19': {
                            _name: '03-19'
                        },
                        'easter 60': {
                            _name: 'easter 60'
                        },
                        '08-15': {
                            _name: '08-15'
                        },
                        '11-01': {
                            _name: '11-01'
                        },
                        '12-08': {
                            _name: '12-08'
                        },
                        '12-26': false,
                        '12-26 not on monday, friday': {
                            _name: '12-26'
                        }
                    }
                },
                SZ: {
                    names: {
                        de: 'Kanton Schwyz',
                        fr: 'Canton de Schwytz',
                        it: 'Canton Svitto',
                        en: 'Canton of Schwyz'
                    },
                    days: {
                        '01-06': {
                            _name: '01-06'
                        },
                        '03-19': {
                            _name: '03-19'
                        },
                        'easter 60': {
                            _name: 'easter 60'
                        },
                        '08-15': {
                            _name: '08-15'
                        },
                        '11-01': {
                            _name: '11-01'
                        },
                        '12-08': {
                            _name: '12-08'
                        }
                    }
                },
                OW: {
                    names: {
                        de: 'Kanton Obwalden',
                        fr: "Canton d'Obwald",
                        it: 'Canton Obvaldo',
                        en: 'Canton of Obwalden'
                    },
                    days: {
                        '01-02': {
                            name: {
                                de: 'Berchtoldstag',
                                fr: 'Saint-Berthold'
                            },
                            type: 'optional'
                        },
                        'easter 1': {
                            _name: 'easter 1',
                            type: 'optional'
                        },
                        'easter 50': {
                            _name: 'easter 50',
                            type: 'optional'
                        },
                        'easter 60': {
                            _name: 'easter 60'
                        },
                        '08-15': {
                            _name: '08-15'
                        },
                        '09-25': {
                            name: {
                                de: 'Bruderklausenfest',
                                fr: "Saint-Nicholas-de-Fl\xfce",
                                en: "Saint Nicholas of Fl\xfce"
                            }
                        },
                        '11-01': {
                            _name: '11-01'
                        },
                        '12-08': {
                            _name: '12-08'
                        },
                        '12-26': {
                            _name: '12-26',
                            type: 'optional'
                        }
                    }
                },
                NW: {
                    names: {
                        de: 'Kanton Nidwalden',
                        fr: 'Canton de Nidwald',
                        it: 'Canton Nidvaldo',
                        en: 'Canton of Nidwalden'
                    },
                    days: {
                        '01-02': {
                            name: {
                                de: 'Berchtoldstag',
                                fr: 'Saint-Berthold'
                            },
                            type: 'bank'
                        },
                        '03-19': {
                            _name: '03-19'
                        },
                        'easter 1': {
                            _name: 'easter 1',
                            type: 'optional'
                        },
                        'easter 50': {
                            _name: 'easter 50',
                            type: 'optional'
                        },
                        'easter 60': {
                            _name: 'easter 60'
                        },
                        '08-15': {
                            _name: '08-15'
                        },
                        '11-01': {
                            _name: '11-01'
                        },
                        '12-08': {
                            _name: '12-08'
                        },
                        '12-26': {
                            _name: '12-26',
                            type: 'optional'
                        }
                    }
                },
                GL: {
                    sources: [
                        'https://www.gl.ch/verwaltung/staatskanzlei/oeffentliche-feiertage.html/1335'
                    ],
                    names: {
                        de: 'Kanton Glarus',
                        fr: 'Canton de Glaris',
                        it: 'Canton Glarona',
                        en: 'Canton of Glarus'
                    },
                    days: {
                        '01-02': {
                            name: {
                                de: 'Berchtoldstag',
                                fr: 'Saint-Berthold'
                            },
                            type: 'optional'
                        },
                        'Thursday after 04-02 if is observance holiday then next Thursday': {
                            name: {
                                de: "N\xe4felser Fahrt",
                                fr: "Bataille de N\xe4fels"
                            }
                        },
                        '3rd sunday after 09-01': false,
                        '11-01': {
                            _name: '11-01'
                        },
                        '12-24': {
                            _name: '12-24'
                        },
                        '12-31': {
                            _name: '12-31'
                        }
                    }
                },
                ZG: {
                    names: {
                        de: 'Kanton Zug',
                        fr: 'Canton de Zoug',
                        it: 'Canton Zugo',
                        en: 'Canton of Zug'
                    },
                    days: {
                        '01-02': {
                            name: {
                                de: 'Berchtoldstag',
                                fr: 'Saint-Berthold'
                            },
                            type: 'optional'
                        },
                        'easter 1': {
                            _name: 'easter 1',
                            type: 'optional'
                        },
                        'easter 50': {
                            _name: 'easter 50',
                            type: 'optional'
                        },
                        'easter 60': {
                            _name: 'easter 60'
                        },
                        '08-15': {
                            _name: '08-15'
                        },
                        '11-01': {
                            _name: '11-01'
                        },
                        '12-08': {
                            _name: '12-08'
                        },
                        '12-26': {
                            _name: '12-26',
                            type: 'optional'
                        }
                    }
                },
                FR: {
                    names: {
                        fr: 'Canton de Fribourg',
                        de: 'Kanton Freiburg',
                        it: 'Canton Friburgo',
                        en: 'Canton of Fribourg'
                    },
                    langs: [
                        'fr',
                        'de-ch',
                        'de',
                        'it'
                    ],
                    days: {
                        '01-02': {
                            name: {
                                de: 'Berchtoldstag',
                                fr: 'Saint-Berthold'
                            },
                            type: 'optional'
                        },
                        'easter 1': {
                            _name: 'easter 1',
                            type: 'optional'
                        },
                        'easter 50': {
                            _name: 'easter 50',
                            type: 'optional'
                        },
                        'easter 60': {
                            _name: 'easter 60',
                            note: "excluding communities: Agriswil, Altavilla, B\xfcchslen, Cordast, Courgevaux, Courlevon, Fr\xe4schels, Galmiz, Gempenach, Greng, Jeuss, Kerzers, Lurtigen, Meyriez, Muntelier, Murten, Ried bei Kerzers (halb), Salvenach, Ulmiz, Bas-Vully, Haut-Vully\n"
                        },
                        '08-15': {
                            _name: '08-15',
                            note: "excluding communities: Agriswil, Altavilla, B\xfcchslen, Cordast, Courgevaux, Courlevon, Fr\xe4schels, Galmiz, Gempenach, Greng, Jeuss, Kerzers, Lurtigen, Meyriez, Muntelier, Murten, Ried bei Kerzers (halb), Salvenach, Ulmiz, Bas-Vully, Haut-Vully\n"
                        },
                        '11-01': {
                            _name: '11-01',
                            note: "excluding communities: Agriswil, Altavilla, B\xfcchslen, Cordast, Courgevaux, Courlevon, Fr\xe4schels, Galmiz, Gempenach, Greng, Jeuss, Kerzers, Lurtigen, Meyriez, Muntelier, Murten, Ried bei Kerzers (halb), Salvenach, Ulmiz, Bas-Vully, Haut-Vully\n"
                        },
                        '12-08': {
                            _name: '12-08',
                            note: "excluding communities: Agriswil, Altavilla, B\xfcchslen, Cordast, Courgevaux, Courlevon, Fr\xe4schels, Galmiz, Gempenach, Greng, Jeuss, Kerzers, Lurtigen, Meyriez, Muntelier, Murten, Ried bei Kerzers (halb), Salvenach, Ulmiz, Bas-Vully, Haut-Vully\n"
                        },
                        '12-26': {
                            _name: '12-26',
                            type: 'optional'
                        }
                    }
                },
                SO: {
                    names: {
                        de: 'Kanton Solothurn',
                        fr: 'Canton de Soleure',
                        it: 'Canton Soletta',
                        en: 'Canton of Solothurn'
                    },
                    days: {
                        '01-02': {
                            name: {
                                de: 'Berchtoldstag',
                                fr: 'Saint-Berthold'
                            },
                            type: 'optional'
                        },
                        '03-19': {
                            _name: '03-19',
                            note: "Only in communities: Fulenbach, Walterswil, Wisen, Metzerlen, Nulgar-St. Pantaleon, Rodersdorf, B\xe4rschwil, B\xfcsserach\n"
                        },
                        'easter 1': {
                            _name: 'easter 1',
                            type: 'optional'
                        },
                        '05-01 12:00': {
                            _name: '05-01'
                        },
                        'easter 50': {
                            _name: 'easter 50',
                            type: 'optional'
                        },
                        'easter 60': {
                            _name: 'easter 60',
                            note: 'is optional in Bucheggberg'
                        },
                        '08-15': {
                            _name: '08-15',
                            note: 'is optional in Bucheggberg'
                        },
                        '11-01': {
                            _name: '11-01',
                            note: 'is optional in Bucheggberg'
                        },
                        '12-26': {
                            _name: '12-26',
                            type: 'optional'
                        }
                    }
                },
                BS: {
                    names: {
                        de: 'Kanton Basel-Stadt',
                        fr: "Canton de B\xe2le-Ville",
                        it: "Canton Basilea Citt\xe0",
                        en: 'Canton of Basel-City'
                    },
                    days: {
                        '05-01': {
                            _name: '05-01'
                        }
                    }
                },
                BL: {
                    names: {
                        de: 'Kanton Basel-Landschaft',
                        fr: "Canton de B\xe2le-Campagne",
                        it: 'Canton Basilea Campagna',
                        en: 'Canton of Basel-Country'
                    },
                    days: {
                        '05-01': {
                            _name: '05-01'
                        },
                        'easter 60': {
                            _name: 'easter 60',
                            type: 'observance'
                        }
                    }
                },
                SH: {
                    names: {
                        de: 'Kanton Schaffhausen',
                        fr: 'Canton de Schaffhouse',
                        it: 'Canton Sciaffusa',
                        en: 'Canton of Schaffhausen'
                    },
                    days: {
                        '01-02': {
                            name: {
                                de: 'Berchtoldstag',
                                fr: 'Saint-Berthold'
                            },
                            type: 'optional'
                        },
                        '05-01': {
                            _name: '05-01'
                        }
                    }
                },
                AR: {
                    names: {
                        de: 'Kanton Appenzell Ausserrhoden',
                        fr: "Canton d'Appenzell Rhodes-Ext\xe9rieures",
                        it: 'Canton Appenzello Esterno',
                        en: 'Canton of Appenzell Outer Rhodes'
                    },
                    days: {
                        '12-26': false,
                        '12-26 not on monday': {
                            _name: '12-26'
                        }
                    }
                },
                AI: {
                    names: {
                        de: 'Kanton Appenzell Innerrhoden',
                        fr: "Canton d'Appenzell Rhodes-Int\xe9rieures",
                        it: 'Canton Appenzello Interno',
                        en: 'Canton of Appenzell Inner-Rhodes'
                    },
                    days: {
                        'easter 60': {
                            _name: 'easter 60'
                        },
                        '08-15': {
                            _name: '08-15'
                        },
                        '09-22': {
                            name: {
                                de: 'Mauritiustag'
                            },
                            note: 'excluding: Bezirk Oberegg\n'
                        },
                        '11-01': {
                            _name: '11-01'
                        },
                        '12-26': {
                            type: 'observance'
                        },
                        '12-26 not on tuesday, saturday': {
                            _name: '12-26'
                        }
                    }
                },
                SG: {
                    names: {
                        de: 'Kanton St. Gallen',
                        fr: 'Canton de Saint-Gall',
                        it: 'Canton San Gallo',
                        en: 'Canton of St. Gallen'
                    },
                    days: {
                        '11-01': {
                            _name: '11-01'
                        }
                    }
                },
                GR: {
                    names: {
                        de: "Kanton Graub\xfcnden",
                        it: 'Cantone dei Grigioni',
                        fr: 'Canton des Grisons',
                        en: 'Canton of Grisons'
                    },
                    langs: [
                        'de-ch',
                        'de',
                        'it',
                        'fr'
                    ],
                    days: {
                        '01-06': {
                            _name: '01-06',
                            type: 'observance'
                        },
                        '03-19': {
                            _name: '03-19',
                            type: 'observance'
                        },
                        'easter -2': {
                            _name: 'easter -2',
                            type: 'optional'
                        },
                        'easter 60': {
                            _name: 'easter 60',
                            type: 'observance'
                        },
                        '08-15': {
                            _name: '08-15',
                            type: 'observance'
                        },
                        '11-01': {
                            _name: '11-01',
                            type: 'observance'
                        },
                        '12-08': {
                            _name: '12-08',
                            type: 'observance'
                        }
                    }
                },
                AG: {
                    names: {
                        de: 'Kanton Aargau',
                        fr: "Canton d'Argovie",
                        it: 'Canton Argovia',
                        en: 'Canton of Aargau'
                    },
                    days: {
                        '01-02': {
                            name: {
                                de: 'Berchtoldstag',
                                fr: 'Saint-Berthold'
                            }
                        },
                        '05-01': {
                            _name: '05-01'
                        },
                        'easter 60': {
                            _name: 'easter 60'
                        },
                        '08-15': {
                            _name: '08-15'
                        },
                        '11-01': {
                            _name: '11-01'
                        },
                        '12-08': {
                            _name: '12-08'
                        }
                    }
                },
                TG: {
                    names: {
                        de: 'Kanton Thurgau',
                        fr: 'Canton de Thurgovie',
                        it: 'Canton Turgovia',
                        en: 'Canton of Thurgau'
                    },
                    days: {
                        '01-02': {
                            name: {
                                de: 'Berchtoldstag',
                                fr: 'Saint-Berthold'
                            }
                        },
                        '05-01': {
                            _name: '05-01'
                        }
                    }
                },
                TI: {
                    names: {
                        it: 'Canton Ticino',
                        de: 'Kanton Tessin',
                        fr: 'Canton du Tessin',
                        en: 'Canton of Ticino'
                    },
                    langs: [
                        'it',
                        'de-ch',
                        'de',
                        'fr'
                    ],
                    days: {
                        '01-02': {
                            name: {
                                de: 'Berchtoldstag',
                                fr: 'Saint-Berthold'
                            },
                            type: 'bank'
                        },
                        '01-06': {
                            _name: '01-06',
                            name: {
                                it: 'Epifania'
                            }
                        },
                        '03-19': {
                            _name: '03-19'
                        },
                        'easter -2': false,
                        'easter 60': {
                            _name: 'easter 60'
                        },
                        '05-01': {
                            _name: '05-01'
                        },
                        '06-29': {
                            _name: '06-29'
                        },
                        '1st sunday in June': false,
                        '08-15': {
                            _name: '08-15',
                            name: {
                                it: 'Assunzione'
                            }
                        },
                        '11-01': {
                            _name: '11-01'
                        },
                        '12-08': {
                            _name: '12-08'
                        }
                    }
                },
                VD: {
                    names: {
                        fr: 'Canton de Vaud',
                        de: 'Kanton Waadt',
                        it: 'Canton Vaud',
                        en: 'Canton of Vaud'
                    },
                    langs: [
                        'fr',
                        'de-ch',
                        'de',
                        'it'
                    ],
                    days: {
                        '01-02': {
                            name: {
                                de: 'Berchtoldstag',
                                fr: '2 Janvier'
                            }
                        },
                        'monday after 3rd sunday in September': {
                            name: {
                                de: 'Bettagsmontag',
                                fr: "Lundi du Je\xfbne F\xe9d\xe9ral",
                                en: 'Monday after Federal Day of Thanksgiving, Repentance and Prayer'
                            }
                        },
                        '12-26': false
                    }
                },
                VS: {
                    names: {
                        fr: 'Canton du Valais',
                        de: 'Kanton Wallis',
                        it: 'Canton Vallese',
                        en: 'Canton of Valais'
                    },
                    langs: [
                        'fr',
                        'de-ch',
                        'de',
                        'it'
                    ],
                    days: {
                        '01-02': {
                            name: {
                                de: 'Berchtoldstag',
                                fr: 'Saint-Berthold'
                            },
                            type: 'bank'
                        },
                        '03-19': {
                            _name: '03-19'
                        },
                        'easter -2': false,
                        'easter 1': {
                            _name: 'easter 1',
                            type: 'optional'
                        },
                        '05-01 12:00': {
                            _name: '05-01'
                        },
                        'easter 50': {
                            _name: 'easter 50'
                        },
                        'easter 60': {
                            _name: 'easter 60'
                        },
                        '08-15': {
                            _name: '08-15'
                        },
                        'monday after 3rd sunday after 09-01': {
                            name: {
                                de: 'Bettagsmontag',
                                fr: "Lundi du Je\xfbne F\xe9d\xe9ral",
                                en: 'Monday after Federal Day of Thanksgiving, Repentance and Prayer'
                            },
                            type: 'bank'
                        },
                        '11-01': {
                            _name: '11-01'
                        },
                        '12-08': {
                            _name: '12-08'
                        },
                        '12-24 12:00': {
                            _name: '12-24'
                        },
                        '12-26': {
                            type: 'optional'
                        }
                    }
                },
                NE: {
                    names: {
                        fr: "Canton de Neuch\xe2tel",
                        de: 'Kanton Neuenburg',
                        it: "Canton Neuch\xe2tel",
                        en: "Canton of Neuch\xe2tel"
                    },
                    langs: [
                        'fr',
                        'de-ch',
                        'de',
                        'it'
                    ],
                    days: {
                        '01-02 on monday': {
                            name: {
                                de: 'Berchtoldstag',
                                fr: '2 Janvier'
                            }
                        },
                        '01-02': {
                            name: {
                                de: 'Berchtoldstag',
                                fr: '2 Janvier'
                            },
                            type: 'observance'
                        },
                        '03-01': {
                            name: {
                                fr: "Instauration de la R\xe9publique",
                                de: 'Jahrestag Ausrufung der Republik'
                            }
                        },
                        'easter -2': {
                            _name: 'easter -2'
                        },
                        '05-01': {
                            _name: '05-01'
                        },
                        'easter 50': {
                            _name: 'easter 50',
                            type: 'observance'
                        },
                        'easter 60': {
                            _name: 'easter 60'
                        },
                        'monday after 3rd sunday in September': {
                            name: {
                                de: 'Bettagsmontag',
                                fr: "Lundi du Je\xfbne F\xe9d\xe9ral",
                                en: 'Monday after Federal Day of Thanksgiving, Repentance and Prayer'
                            },
                            type: 'optional'
                        },
                        '12-26': {
                            type: 'observance'
                        },
                        '12-26 on monday': {
                            _name: '12-26'
                        }
                    }
                },
                GE: {
                    names: {
                        fr: "Canton de Gen\xe8ve",
                        de: 'Kanton Genf',
                        it: 'Canton Ginevra',
                        en: 'Canton of Geneva'
                    },
                    langs: [
                        'fr',
                        'de-ch',
                        'de',
                        'it'
                    ],
                    days: {
                        '01-02': {
                            name: {
                                de: 'Berchtoldstag',
                                fr: '2 Janvier'
                            },
                            type: 'bank'
                        },
                        'thursday after 1st sunday after 09-01': {
                            name: {
                                de: 'Genfer Bettag',
                                fr: "Je\xfbne Genevois"
                            }
                        },
                        '12-26': {
                            type: 'bank'
                        },
                        '12-31': {
                            name: {
                                de: 'Wiederherstellung der Republik',
                                fr: "Restauration de la R\xe9publique",
                                en: 'Restoration of the Republic'
                            }
                        },
                        '3rd sunday after 09-01': false
                    }
                },
                JU: {
                    names: {
                        fr: 'Canton du Jura',
                        de: 'Kanton Jura',
                        it: 'Canton Giura',
                        en: 'Canton of Jura'
                    },
                    langs: [
                        'fr',
                        'de-ch',
                        'de',
                        'it'
                    ],
                    days: {
                        '01-02': {
                            name: {
                                de: 'Berchtoldstag',
                                fr: '2 Janvier'
                            }
                        },
                        '05-01': {
                            _name: '05-01'
                        },
                        'easter 60': {
                            _name: 'easter 60'
                        },
                        '06-23': {
                            name: {
                                fr: "Pl\xe9biscite jurassien",
                                en: 'Jura Plebiscite',
                                de: "Fest der Unabh\xe4ngigkeit"
                            }
                        },
                        '08-15': {
                            _name: '08-15'
                        },
                        '11-01': {
                            _name: '11-01'
                        },
                        '12-26': false
                    }
                }
            }
        },
        CI: {
            names: {
                fr: "R\xe9publique de C\xf4te d'Ivoire",
                en: "Republic of C\xf4te d'Ivoire"
            },
            langs: [
                'fr',
                'en'
            ],
            zones: [
                'Africa/Abidjan'
            ],
            dayoff: 'sunday',
            days: {
                '01-01': {
                    _name: '01-01'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '05-01': {
                    _name: '05-01'
                },
                'easter 39': {
                    _name: 'easter 39'
                },
                'easter 50': {
                    _name: 'easter 50'
                },
                '08-07 since 1960': {
                    _name: 'Independence Day'
                },
                '08-15': {
                    _name: '08-15'
                },
                '11-01': {
                    _name: '11-01'
                },
                '11-15 since 1996': {
                    name: {
                        en: 'National Peace Day'
                    }
                },
                '12-25': {
                    _name: '12-25'
                },
                '12 Rabi al-awwal': {
                    _name: '12 Rabi al-awwal'
                },
                '27 Ramadan': {
                    _name: '27 Ramadan'
                },
                '1 Shawwal': {
                    _name: '1 Shawwal'
                },
                '10 Dhu al-Hijjah': {
                    _name: '10 Dhu al-Hijjah'
                }
            }
        },
        CK: {
            names: {
                rar: "K\u016Bki '\u0100irani",
                en: 'Cook Islands'
            },
            langs: [
                'en',
                'rar'
            ],
            zones: [
                'Pacific/Rarotonga'
            ],
            dayoff: 'sunday',
            days: {
                '01-01 and if Saturday, Sunday then next Monday': {
                    substitute: true,
                    _name: '01-01'
                },
                '01-02 and if Saturday then next Monday if Monday, Sunday then next Tuesday': {
                    substitute: true,
                    name: {
                        en: "Day after New Year's Day"
                    }
                },
                '04-25': {
                    name: {
                        en: 'Anzac Day'
                    }
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '1st Monday in June': {
                    name: {
                        en: "Queen's Birthday"
                    }
                },
                '1st Friday in July': {
                    name: {
                        en: 'Ra o te Ui Ariki (House of Ariki)',
                        rar: 'Ra o te Ui Ariki'
                    }
                },
                '08-04 and if Saturday, Sunday then next Monday': {
                    substitute: true,
                    _name: 'Constitution Day'
                },
                '10-26 and if Saturday, Sunday then next Monday': {
                    substitute: true,
                    name: {
                        en: 'National Gospel Day'
                    }
                },
                '12-25 and if Saturday, Sunday then next Monday': {
                    substitute: true,
                    _name: '12-25'
                },
                '12-26 and if Saturday then next Monday if Monday, Sunday then next Tuesday': {
                    substitute: true,
                    _name: '12-26'
                }
            },
            states: {
                Aitutaki: {
                    names: {
                        en: 'Aitutaki'
                    },
                    days: {
                        '10-26 and if Saturday, Sunday then next Monday': {
                            substitute: true,
                            name: {
                                en: 'Aitutaki Gospel Day'
                            }
                        }
                    }
                },
                Atiu: {
                    names: {
                        en: 'Atiu'
                    },
                    days: {
                        '07-19 and if Saturday, Sunday then next Monday': {
                            substitute: true,
                            name: {
                                en: 'Atiu Gospel Day'
                            }
                        }
                    }
                },
                Mangaia: {
                    names: {
                        en: 'Mangaia'
                    },
                    days: {
                        '06-15 and if Saturday, Sunday then next Monday': {
                            substitute: true,
                            name: {
                                en: 'Mangaia Gospel Day'
                            }
                        }
                    }
                },
                Manihiki: {
                    names: {
                        en: 'Manihiki'
                    },
                    days: {
                        '08-08 and if Saturday, Sunday then next Monday': {
                            substitute: true,
                            name: {
                                en: 'Manihiki Gospel Day'
                            }
                        }
                    }
                },
                Mitiaro: {
                    names: {
                        en: 'Mitiaro'
                    },
                    days: {
                        '07-21 and if Saturday, Sunday then next Monday': {
                            substitute: true,
                            name: {
                                en: 'Mitiaro Gospel Day'
                            }
                        }
                    }
                },
                Palmerston: {
                    names: {
                        en: 'Palmerston'
                    },
                    days: {
                        '05-25 and if Saturday, Sunday then next Monday': {
                            substitute: true,
                            name: {
                                en: 'Palmerston Gospel Day'
                            }
                        }
                    }
                },
                Penrhyn: {
                    names: {
                        en: 'Penrhyn'
                    },
                    days: {
                        '05-13 and if Saturday, Sunday then next Monday': {
                            substitute: true,
                            name: {
                                en: 'Penrhyn Gospel Day'
                            }
                        }
                    }
                },
                Pukapuka: {
                    names: {
                        en: 'Pukapuka'
                    },
                    days: {
                        '12-06 and if Saturday, Sunday then next Monday': {
                            substitute: true,
                            name: {
                                en: 'Pukapuka Gospel Day'
                            }
                        }
                    }
                },
                Rakahanga: {
                    names: {
                        en: 'Rakahanga'
                    },
                    days: {
                        '08-15 and if Saturday, Sunday then next Monday': {
                            substitute: true,
                            name: {
                                en: 'Rakahanga Gospel Day'
                            }
                        }
                    }
                },
                Rarotonga: {
                    names: {
                        en: 'Rarotonga'
                    },
                    days: {
                        '07-25 and if Saturday, Sunday then next Monday': {
                            substitute: true,
                            name: {
                                en: 'Rarotonga Gospel Day'
                            }
                        }
                    }
                }
            }
        },
        CL: {
            names: {
                es: 'Chile',
                en: 'Chile'
            },
            dayoff: 'sunday',
            langs: [
                'es'
            ],
            zones: [
                'America/Santiago',
                'Pacific/Easter'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '01-02 on monday since 2017': {
                    name: "D\xeda adicional",
                    active: [
                        {
                            from: 2017
                        }
                    ]
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                easter: {
                    _name: 'easter'
                },
                '05-01': {
                    _name: '05-01'
                },
                '05-21': {
                    name: {
                        en: 'Navy Day',
                        es: "D\xeda de las Glorias Navales"
                    }
                },
                '06-21 since 2021 prior to 2022': {
                    name: {
                        en: "Indigenous People's Day",
                        es: "D\xeda de los Pueblos Ind\xedgenas"
                    }
                },
                'june solstice in America/Santiago since 2022': {
                    name: {
                        en: "Indigenous People's Day",
                        es: "D\xeda de los Pueblos Ind\xedgenas"
                    }
                },
                '06-29 if tuesday, wednesday, thursday then previous monday if friday then next monday': {
                    _name: '06-29'
                },
                '07-16': {
                    name: {
                        en: 'Our Lady of Mount Carmel',
                        es: 'Virgen del Carmen'
                    }
                },
                '08-15': {
                    _name: '08-15'
                },
                '2022-09-16': {
                    name: {
                        es: 'Fiestas Patrias',
                        en: 'National Holiday'
                    }
                },
                '09-17 on friday, monday since 2017': {
                    name: {
                        en: 'National holiday',
                        es: 'Feriado Adicional Fiestas Patrias'
                    }
                },
                '09-18': {
                    name: {
                        en: 'National holiday',
                        es: 'Fiestas Patrias'
                    }
                },
                '09-19': {
                    name: {
                        en: 'Army Day',
                        es: "D\xeda de las Glorias del Ej\xe9rcito"
                    }
                },
                '09-20 on friday': {
                    name: {
                        es: 'Feriado Adicional Fiestas Patrias',
                        en: 'National Holiday'
                    }
                },
                '10-12 if tuesday, wednesday, thursday then previous monday if friday then next monday': {
                    name: {
                        en: 'Columbus Day',
                        es: 'Encuentro de Dos Mundos'
                    }
                },
                '10-31 if wednesday then next friday if tuesday then previous friday': {
                    _name: 'Reformation Day'
                },
                '11-01': {
                    _name: '11-01'
                },
                '12-08': {
                    _name: '12-08'
                },
                '12-25': {
                    _name: '12-25'
                },
                '12-31': {
                    _name: '12-31',
                    type: 'bank'
                }
            },
            states: {
                AP: {
                    name: 'Arica y Parinacota',
                    days: {
                        '06-07': {
                            name: {
                                en: 'Battle of Arica',
                                es: 'Asalto y Toma del Morro de Arica'
                            }
                        }
                    }
                },
                BI: {
                    name: "Biob\xedo",
                    regions: {
                        CH: {
                            name: "Chill\xe1n y Chill\xe1n Viejo",
                            days: {
                                '08-20': {
                                    name: {
                                        en: "Nativity of Liberator Bernardo O'Higgins",
                                        es: "Nacimiento del Pr\xf3cer de la Independencia"
                                    },
                                    active: [
                                        {
                                            to: '2017-08-19'
                                        }
                                    ]
                                }
                            }
                        }
                    }
                },
                NU: {
                    name: "\xd1uble",
                    regions: {
                        CH: {
                            name: "Chill\xe1n y Chill\xe1n Viejo",
                            days: {
                                '08-20': {
                                    name: {
                                        en: "Nativity of Liberator Bernardo O'Higgins",
                                        es: "Nacimiento del Pr\xf3cer de la Independencia"
                                    },
                                    active: [
                                        {
                                            from: '2017-08-19'
                                        }
                                    ]
                                }
                            }
                        }
                    }
                },
                TA: {
                    name: "Tarapac\xe1",
                    days: {
                        '08-10': {
                            name: {
                                en: 'Saint Lawrence',
                                es: "San Lorenzo de Tarapac\xe1"
                            },
                            type: 'observance',
                            disable: [
                                2015
                            ]
                        },
                        '2015-08-10': {
                            name: {
                                en: 'Saint Lawrence',
                                es: "San Lorenzo de Tarapac\xe1"
                            }
                        }
                    }
                }
            }
        },
        CM: {
            names: {
                fr: 'Cameroun',
                en: 'Cameroon'
            },
            dayoff: 'sunday',
            langs: [
                'fr',
                'en'
            ],
            zones: [
                'Africa/Lagos'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '02-11': {
                    name: {
                        fr: "F\xeate de la Jeunesse",
                        en: 'Youth Day'
                    }
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                '05-01 if sunday then next monday': {
                    _name: '05-01'
                },
                '05-20': {
                    name: {
                        fr: "F\xeate nationale ou de l'unit\xe9",
                        en: 'National Day'
                    }
                },
                'easter 39': {
                    _name: 'easter 39'
                },
                '08-15': {
                    _name: '08-15'
                },
                '12-25': {
                    _name: '12-25'
                },
                '1 Shawwal': {
                    _name: '1 Shawwal'
                },
                '10 Dhu al-Hijjah': {
                    _name: '10 Dhu al-Hijjah'
                }
            }
        },
        CN: {
            names: {
                en: 'China',
                zh: "\u4E2D\u534E\u4EBA\u6C11\u5171\u548C\u56FD"
            },
            dayoff: 'sunday',
            langs: [
                'zh',
                'en'
            ],
            zones: [
                'Asia/Shanghai',
                'Asia/Urumqi'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '03-08 12:00': {
                    _name: '03-08',
                    note: 'Women'
                },
                '05-01': {
                    _name: '05-01'
                },
                '05-04 12:00': {
                    name: {
                        en: 'Youth Day',
                        zh: "\u9752\u5E74\u8282"
                    },
                    note: 'Youth from the age of 14 to 28'
                },
                '06-01': {
                    name: {
                        en: "Children's Day",
                        zh: "\u516D\u4E00\u513F\u7AE5\u8282"
                    },
                    note: 'Children below the age of 14'
                },
                '08-01 12:00': {
                    name: {
                        en: 'Army Day',
                        zh: "\u5EFA\u519B\u8282"
                    },
                    note: 'Military personnel in active service'
                },
                '10-01': {
                    name: {
                        en: 'National Day',
                        zh: "\u56FD\u5E86\u8282"
                    }
                },
                '10-02': {
                    name: {
                        en: 'National Day',
                        zh: "\u56FD\u5E86\u8282"
                    }
                },
                '10-03': {
                    name: {
                        en: 'National Day',
                        zh: "\u56FD\u5E86\u8282"
                    }
                },
                'chinese 01-0-00': {
                    name: {
                        en: 'Spring Festival',
                        zh: "\u6625\u8282"
                    }
                },
                'chinese 01-0-01': {
                    name: {
                        en: 'Spring Festival',
                        zh: "\u6625\u8282"
                    }
                },
                'chinese 01-0-02': {
                    name: {
                        en: 'Spring Festival',
                        zh: "\u6625\u8282"
                    }
                },
                'chinese 5-01 solarterm': {
                    name: {
                        en: 'Qingming Festival',
                        zh: "\u6E05\u660E\u8282 \u6E05\u660E\u7BC0"
                    }
                },
                'chinese 05-0-05': {
                    name: {
                        en: 'Dragon Boat Festival',
                        zh: "\u7AEF\u5348\u8282"
                    }
                },
                'chinese 08-0-15': {
                    name: {
                        en: 'Mid-Autumn Festival',
                        zh: "\u4E2D\u79CB\u8282"
                    }
                },
                '2021-01-02': {
                    _name: '01-01'
                },
                '2021-01-03': {
                    _name: '01-01'
                },
                '2021-02-14': {
                    name: {
                        en: 'Spring Festival',
                        zh: "\u6625\u8282"
                    },
                    note: 'Work on Sun February 7 and Sat February 20.'
                },
                '2021-02-15': {
                    name: {
                        en: 'Spring Festival',
                        zh: "\u6625\u8282"
                    }
                },
                '2021-02-16': {
                    name: {
                        en: 'Spring Festival',
                        zh: "\u6625\u8282"
                    }
                },
                '2021-02-17': {
                    name: {
                        en: 'Spring Festival',
                        zh: "\u6625\u8282"
                    }
                },
                '2021-04-03': {
                    name: {
                        en: 'Qingming Festival',
                        zh: "\u6E05\u660E\u8282 \u6E05\u660E\u7BC0"
                    }
                },
                '2021-04-05': {
                    name: {
                        en: 'Qingming Festival',
                        zh: "\u6E05\u660E\u8282 \u6E05\u660E\u7BC0"
                    }
                },
                '2021-05-02': {
                    _name: '05-01',
                    note: 'Work on Sun April 25 and Sat May 8.'
                },
                '2021-05-03': {
                    _name: '05-01'
                },
                '2021-05-04': {
                    _name: '05-01'
                },
                '2021-05-05': {
                    _name: '05-01'
                },
                '2021-06-12': {
                    name: {
                        en: 'Dragon Boat Festival',
                        zh: "\u7AEF\u5348\u8282"
                    }
                },
                '2021-06-13': {
                    name: {
                        en: 'Dragon Boat Festival',
                        zh: "\u7AEF\u5348\u8282"
                    }
                },
                '2021-09-19': {
                    name: {
                        en: 'Mid-Autumn Festival',
                        zh: "\u4E2D\u79CB\u8282"
                    },
                    note: 'Work on Sat September 18.'
                },
                '2021-09-20': {
                    name: {
                        en: 'Mid-Autumn Festival',
                        zh: "\u4E2D\u79CB\u8282"
                    }
                },
                '2021-10-04': {
                    name: {
                        en: 'National Day',
                        zh: "\u56FD\u5E86\u8282"
                    },
                    note: 'Work on Sun September 26 and Sat October 9.'
                },
                '2021-10-05': {
                    name: {
                        en: 'National Day',
                        zh: "\u56FD\u5E86\u8282"
                    }
                },
                '2021-10-06': {
                    name: {
                        en: 'National Day',
                        zh: "\u56FD\u5E86\u8282"
                    }
                },
                '2021-10-07': {
                    name: {
                        en: 'National Day',
                        zh: "\u56FD\u5E86\u8282"
                    }
                }
            }
        },
        CO: {
            names: {
                es: 'Colombia',
                en: 'Colombia'
            },
            dayoff: 'sunday',
            langs: [
                'es'
            ],
            zones: [
                'America/Bogota'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                'monday after 01-06': {
                    _name: '01-06'
                },
                'monday after 03-19': {
                    _name: '03-19'
                },
                'easter -7': {
                    _name: 'easter -7',
                    type: 'observance'
                },
                'easter -3': {
                    _name: 'easter -3'
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                easter: {
                    _name: 'easter'
                },
                '05-01': {
                    _name: '05-01'
                },
                'easter 43': {
                    _name: 'easter 39'
                },
                'easter 64': {
                    _name: 'easter 60'
                },
                'easter 71': {
                    name: {
                        es: "Sagrado Coraz\xf3n de Jes\xfas",
                        en: 'Sacred Heart'
                    }
                },
                'monday after 06-29': {
                    _name: '06-29'
                },
                '07-20': {
                    _name: 'Independence Day'
                },
                '08-07': {
                    name: {
                        en: "Battle of Boyac\xe1",
                        es: "Batalla de Boyac\xe1"
                    }
                },
                'monday after 08-15': {
                    _name: '08-15'
                },
                'monday after 10-12': {
                    name: {
                        es: "D\xeda de la Raza",
                        en: 'Columbus Day'
                    }
                },
                '1st monday in November': {
                    _name: '11-01'
                },
                'monday after 11-11': {
                    name: {
                        es: 'Independencia de Cartagena',
                        en: 'Independence of Cartagena'
                    }
                },
                '12-08': {
                    _name: '12-08'
                },
                '12-25': {
                    _name: '12-25'
                }
            }
        },
        CR: {
            names: {
                es: 'Costa Rica',
                en: 'Costa Rica'
            },
            dayoff: 'sunday',
            langs: [
                'es'
            ],
            zones: [
                'America/Costa_Rica'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                'easter -3': {
                    _name: 'easter -3'
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                easter: {
                    _name: 'easter',
                    type: 'observance'
                },
                '04-11': {
                    name: {
                        es: "Gesta Heroica de Juan Santamar\xeda"
                    }
                },
                '05-01': {
                    _name: '05-01'
                },
                '07-25': {
                    name: {
                        en: 'Guanacaste Day',
                        es: "Anexi\xf3n del Partido de Nicoya"
                    }
                },
                '08-02': {
                    name: {
                        en: "Our Lady of Los \xc1ngeles",
                        es: "D\xeda de la Virgen de los \xc1ngeles"
                    }
                },
                '08-15': {
                    _name: 'Mothers Day'
                },
                '09-15': {
                    _name: 'Independence Day'
                },
                '10-12 if monday then previous friday': {
                    name: {
                        en: 'Columbus Day',
                        es: "D\xeda de la Raza"
                    }
                },
                '12-25': {
                    _name: '12-25'
                }
            }
        },
        CU: {
            names: {
                es: 'Cuba',
                en: 'Cuba'
            },
            dayoff: 'sunday',
            langs: [
                'es'
            ],
            zones: [
                'America/Havana'
            ],
            days: {
                '01-01': {
                    name: {
                        es: "Triunfo de la Revoluci\xf3n",
                        en: 'Triumph of the Revolution'
                    }
                },
                '01-02': {
                    name: {
                        es: "D\xeda de Victoria de las Fuerzas Armadas",
                        en: 'Victory of Armed Forces Day'
                    }
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                '05-01': {
                    _name: '05-01'
                },
                '07-25': {
                    name: {
                        es: "Conmemoraci\xf3n del asalto a Moncada",
                        en: 'Day before the Commemoration of the Assault of the Moncada garrison'
                    }
                },
                '07-26': {
                    name: {
                        es: "D\xeda de la Rebeld\xeda Nacional",
                        en: 'Commemoration of the Assault of the Moncada garrison'
                    }
                },
                '07-27': {
                    name: {
                        es: "Conmemoraci\xf3n del asalto a Moncada",
                        en: 'Day after the Commemoration of the Assault of the Moncada garrison'
                    }
                },
                '10-10': {
                    _name: 'Independence Day'
                },
                '12-25': {
                    _name: '12-25'
                }
            }
        },
        CV: {
            names: {
                pt: "Rep\xfablica de Cabo Verde",
                en: 'Cape Verde'
            },
            langs: [
                'pt'
            ],
            zones: [
                'Atlantic/Cape_Verde'
            ],
            dayoff: 'sunday',
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '01-13': {
                    name: {
                        pt: 'Dia da Democracia',
                        en: 'Democracy Day'
                    }
                },
                '01-20': {
                    name: {
                        pt: "Dia dos Her\xf3is Nacionais",
                        en: "Heroes' Day"
                    }
                },
                'easter -47': {
                    _name: 'easter -47'
                },
                'easter -46': {
                    _name: 'easter -46'
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                easter: {
                    _name: 'easter',
                    type: 'observance'
                },
                '05-01': {
                    _name: '05-01'
                },
                '06-01': {
                    name: {
                        pt: "Dia das Crian\xe7as",
                        en: "Children's Day"
                    }
                },
                '07-05': {
                    _name: 'Independence Day'
                },
                '08-15': {
                    _name: '08-15',
                    name: {
                        pt: 'Dia da Padroeira Nacional'
                    }
                },
                '09-12': {
                    name: {
                        pt: 'Dia Nacional',
                        en: 'National Day'
                    }
                },
                '11-01': {
                    _name: '11-01'
                },
                '12-25': {
                    _name: '12-25'
                }
            },
            states: {
                S: {
                    name: 'Sotavento Islands',
                    regions: {
                        PR: {
                            name: 'Praia',
                            days: {
                                '05-19': {
                                    name: {
                                        pt: "Dia do Munic\xedpio da Praia"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        CW: {
            names: {
                nl: "Cura\xe7ao",
                pap: "K\xf2rsou",
                en: "Cura\xe7ao"
            },
            langs: [
                'nl',
                'pap',
                'en'
            ],
            zones: [
                'America/Curacao'
            ],
            dayoff: 'sunday',
            days: {
                '01-01': {
                    _name: '01-01'
                },
                'easter -48': {
                    _name: 'easter -48',
                    name: {
                        en: 'Carnival Monday'
                    }
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                easter: {
                    _name: 'easter',
                    type: 'observance'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '04-27': {
                    name: {
                        pap: "A\xf1a di Rey",
                        nl: 'Koningsdag',
                        en: 'Kings Day'
                    }
                },
                '05-01 if sunday then next monday': {
                    _name: '05-01'
                },
                '2nd sunday in May': {
                    _name: 'Mothers Day',
                    type: 'observance'
                },
                '1st sunday in June': {
                    _name: 'Fathers Day',
                    type: 'observance'
                },
                'easter 39': {
                    _name: 'easter 39',
                    name: {
                        nl: 'Hemelvaartsdag'
                    }
                },
                '07-02': {
                    name: {
                        nl: 'Dag van het volkslied en de Vlag',
                        pap: 'Dia di Himno i Bandera',
                        en: 'Flag Day'
                    }
                },
                '10-10': {
                    name: {
                        nl: "Dag van het land Cura\xe7ao",
                        pap: "Pais K\xf2rsou",
                        en: "Cura\xe7ao Day"
                    }
                },
                '12-25': {
                    _name: '12-25'
                },
                '12-26': {
                    _name: '12-26'
                },
                '12-31 12:00': {
                    _name: '12-31'
                }
            }
        },
        CX: {
            names: {
                en: 'Christmas Island'
            },
            langs: [
                'en',
                'ms'
            ],
            zones: [
                'Indian/Christmas'
            ],
            dayoff: 'sunday',
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '01-26': {
                    name: {
                        en: 'Australia Day'
                    }
                },
                'chinese 01-0-01 P2D': {
                    name: {
                        en: 'Chinese New Year',
                        zh: "\u6625\u8282"
                    }
                },
                '4th monday in March': {
                    _name: '05-01'
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                '04-25': {
                    name: {
                        en: 'Anzac Day'
                    }
                },
                '1 Shawwal': {
                    _name: '1 Shawwal',
                    name: {
                        ms: 'Hari Raya Puasa'
                    }
                },
                '10 Dhu al-Hijjah': {
                    _name: '10 Dhu al-Hijjah',
                    name: {
                        ms: 'Hari Raya Haji'
                    }
                },
                '10-06': {
                    name: {
                        en: 'Territory Day'
                    }
                },
                '12-25': {
                    _name: '12-25'
                },
                '12-26': {
                    _name: '12-26'
                }
            }
        },
        CY: {
            names: {
                el: "\u039A\u03CD\u03C0\u03C1\u03BF\u03C2",
                en: 'Cyprus'
            },
            dayoff: '',
            langs: [
                'el'
            ],
            zones: [
                'Asia/Nicosia'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '01-06': {
                    _name: '01-06'
                },
                'orthodox -48': {
                    name: {
                        el: "\u039A\u03B1\u03B8\u03B1\u03C1\u03AC \u0394\u03B5\u03C5\u03C4\u03AD\u03C1\u03B1",
                        en: 'Ash Sunday'
                    },
                    type: 'observance'
                },
                'orthodox -47': {
                    name: {
                        el: "\u039A\u03B1\u03B8\u03B1\u03C1\u03AC \u0394\u03B5\u03C5\u03C4\u03AD\u03C1\u03B1",
                        en: 'Clean Monday'
                    }
                },
                '03-25': {
                    name: {
                        el: "\u0395\u03C5\u03B1\u03B3\u03B3\u03B5\u03BB\u03B9\u03C3\u03BC\u03CC\u03C2, \u0395\u03B8\u03BD\u03B9\u03BA\u03AE \u0395\u03BF\u03C1\u03C4\u03AE",
                        en: 'Annunciation, Anniversary of 1821 Revolution'
                    }
                },
                '04-01': {
                    name: {
                        en: 'Cyprus National Day',
                        el: "\u039A\u03CD\u03C0\u03C1\u03BF\u03C2 \u0395\u03B8\u03BD\u03B9\u03BA\u03AE \u0395\u03BF\u03C1\u03C4\u03AE"
                    }
                },
                'orthodox -2': {
                    _name: 'easter -2'
                },
                orthodox: {
                    _name: 'easter'
                },
                'orthodox 1': {
                    _name: 'easter 1'
                },
                '05-01': {
                    _name: '05-01'
                },
                'orthodox 49': {
                    _name: 'easter 49'
                },
                '2nd sunday in May': {
                    _name: 'Mothers Day',
                    type: 'observance'
                },
                '08-15': {
                    _name: '08-15'
                },
                '10-01': {
                    name: {
                        en: 'Cyprus Independence Day',
                        el: "\u0397\u03BC\u03AD\u03C1\u03B1 \u03C4\u03B7\u03C2 \u0391\u03BD\u03B5\u03BE\u03B1\u03C1\u03C4\u03B7\u03C3\u03AF\u03B1\u03C2 \u039A\u03CD\u03C0\u03C1\u03BF\u03C2"
                    }
                },
                '10-28': {
                    _name: 'National Holiday',
                    name: {
                        el: "\u0395\u03C0\u03AD\u03C4\u03B5\u03B9\u03BF\u03C2 \u03C4\u03BF\u03C5 \u038C\u03C7\u03B9"
                    }
                },
                '12-25': {
                    _name: '12-25'
                },
                '12-26': {
                    _name: '12-26'
                }
            }
        },
        CZ: {
            names: {
                cz: "\u010Cesk\xe1 republika",
                en: 'Czech Republic'
            },
            langs: [
                'cz'
            ],
            zones: [
                'Europe/Prague'
            ],
            days: {
                '01-01': {
                    _name: '01-01',
                    name: {
                        cz: "Nov\xfd rok a Den obnovy samostatn\xe9ho \u010Desk\xe9ho st\xe1tu"
                    }
                },
                'easter -4': {
                    name: {
                        cz: "\u0160kared\xe1 st\u0159eda",
                        en: 'Ugly Wednesday'
                    },
                    type: 'observance'
                },
                'easter -3': {
                    _name: 'easter -3',
                    type: 'observance'
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                'easter -1': {
                    _name: 'easter -1',
                    type: 'observance'
                },
                easter: {
                    _name: 'easter',
                    type: 'observance'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '05-01': {
                    _name: '05-01'
                },
                '05-08': {
                    name: {
                        cz: "Den v\xedt\u011Bzstv\xed",
                        en: 'Liberation Day'
                    }
                },
                '2nd sunday in May': {
                    _name: 'Mothers Day',
                    type: 'observance'
                },
                '07-05': {
                    name: {
                        cz: "Den slovansk\xfdch v\u011Brozv\u011Bst\u016F Cyrila a Metod\u011Bje",
                        en: 'Saints Cyril and Methodius Day'
                    }
                },
                '07-06': {
                    name: {
                        cz: "Den up\xe1len\xed mistra Jana Husa",
                        en: 'Jan Hus Day'
                    }
                },
                '09-28': {
                    name: {
                        cz: "Den \u010Desk\xe9 st\xe1tnosti",
                        en: 'St. Wenceslas Day (Czech Statehood Day)'
                    }
                },
                '10-28': {
                    name: {
                        cz: "Den vzniku samostatn\xe9ho \u010Deskoslovensk\xe9ho st\xe1tu",
                        en: 'Independent Czechoslovak State Day'
                    }
                },
                '11-17': {
                    name: {
                        cz: 'Den boje za svobodu a demokracii',
                        en: 'Struggle for Freedom and Democracy Day'
                    }
                },
                '12-24': {
                    _name: '12-24'
                },
                '12-25': {
                    _name: '12-25'
                },
                '12-26': {
                    _name: '12-26'
                }
            }
        },
        DE: {
            names: {
                de: 'Deutschland',
                en: 'Germany'
            },
            dayoff: 'sunday',
            zones: [
                'Europe/Berlin'
            ],
            langs: [
                'de'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '02-14': {
                    _name: '02-14',
                    type: 'observance'
                },
                'easter -52': {
                    name: {
                        de: 'Weiberfastnacht',
                        en: "Women's Carnival Day"
                    },
                    type: 'observance'
                },
                'easter -48': {
                    name: {
                        de: 'Rosenmontag',
                        en: 'Shrove Monday'
                    },
                    type: 'observance'
                },
                'easter -47 14:00': {
                    _name: 'easter -47',
                    type: 'observance'
                },
                'easter -46': {
                    _name: 'easter -46',
                    type: 'observance'
                },
                'easter -3': {
                    _name: 'easter -3',
                    type: 'observance'
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                easter: {
                    _name: 'easter',
                    type: 'observance'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '05-01': {
                    _name: '05-01',
                    name: {
                        de: 'Maifeiertag'
                    }
                },
                '2nd sunday in May': {
                    _name: 'Mothers Day',
                    type: 'observance'
                },
                'easter 39': {
                    _name: 'easter 39'
                },
                'easter 49': {
                    _name: 'easter 49',
                    type: 'observance'
                },
                'easter 50': {
                    _name: 'easter 50'
                },
                '10-03': {
                    _name: 'National Holiday',
                    name: {
                        de: 'Tag der Deutschen Einheit'
                    }
                },
                '11-01': {
                    _name: '11-01',
                    type: 'observance'
                },
                '11-02': {
                    _name: '11-02',
                    type: 'observance'
                },
                '11-11': {
                    _name: '11-11',
                    type: 'observance'
                },
                'wednesday before 11-23': {
                    _name: "Bu\xdf- und Bettag",
                    type: 'observance'
                },
                '6th sunday before 12-25': {
                    name: {
                        de: 'Volkstrauertag',
                        en: 'Memorial Day'
                    },
                    type: 'observance'
                },
                '5th sunday before 12-25': {
                    name: {
                        de: 'Totensonntag'
                    },
                    type: 'observance'
                },
                '4th sunday before 12-25': {
                    name: {
                        de: '1. Advent'
                    },
                    type: 'observance'
                },
                '3th sunday before 12-25': {
                    name: {
                        de: '2. Advent'
                    },
                    type: 'observance'
                },
                '2nd sunday before 12-25': {
                    name: {
                        de: '3. Advent'
                    },
                    type: 'observance'
                },
                '1st sunday before 12-25': {
                    name: {
                        de: '4. Advent'
                    },
                    type: 'observance'
                },
                '12-24 14:00 if sunday then 00:00': {
                    _name: '12-24',
                    type: 'bank'
                },
                '12-25': {
                    _name: '12-25',
                    name: {
                        de: '1. Weihnachtstag'
                    }
                },
                '12-26': {
                    _name: '12-26'
                },
                '12-31 14:00 if sunday then 00:00': {
                    _name: '12-31',
                    type: 'bank'
                },
                '2017-10-31': {
                    _name: 'Reformation Day'
                }
            },
            states: {
                BB: {
                    name: 'Brandenburg',
                    days: {
                        easter: {
                            _name: 'easter'
                        },
                        'easter 49': {
                            _name: 'easter 49'
                        },
                        '10-31': {
                            _name: 'Reformation Day'
                        }
                    }
                },
                BE: {
                    name: 'Berlin',
                    days: {
                        '03-08': {
                            _name: '03-08',
                            active: [
                                {
                                    from: '2019-01-01T00:00:00.000Z'
                                }
                            ]
                        },
                        easter: {
                            _name: 'easter',
                            type: 'observance'
                        },
                        'easter 49': {
                            _name: 'easter 49',
                            type: 'observance'
                        },
                        '2020-05-08': {
                            name: {
                                de: 'Tag der Befreiung (75. Jahrestag)',
                                en: 'Liberation Day (75th Anniversary)'
                            }
                        },
                        '2025-05-08': {
                            name: {
                                de: 'Tag der Befreiung (80. Jahrestag)',
                                en: 'Liberation Day (80th Anniversary)'
                            }
                        },
                        '2028-06-17': {
                            name: {
                                de: "75-j\xe4hriges Jubil\xe4um des Volksaufstands in der DDR",
                                en: '75th anniversary of the GDR uprising'
                            }
                        }
                    }
                },
                BW: {
                    name: "Baden-W\xfcrttemberg",
                    days: {
                        '01-06': {
                            _name: '01-06'
                        },
                        'easter -3': {
                            _name: 'easter -3',
                            type: 'school'
                        },
                        'easter 60': {
                            _name: 'easter 60'
                        },
                        '10-31': {
                            _name: 'Reformation Day',
                            type: 'school'
                        },
                        '11-01': {
                            _name: '11-01'
                        }
                    }
                },
                BY: {
                    name: 'Bayern',
                    days: {
                        '01-06': {
                            _name: '01-06'
                        },
                        '02-02': {
                            _name: '02-02',
                            type: 'observance'
                        },
                        'easter 60': {
                            _name: 'easter 60'
                        },
                        '08-15': {
                            _name: '08-15'
                        },
                        '11-01': {
                            _name: '11-01'
                        },
                        'wednesday before 11-23': {
                            _name: "Bu\xdf- und Bettag",
                            type: 'school'
                        }
                    },
                    regions: {
                        A: {
                            name: 'Stadt Augsburg',
                            days: {
                                '08-08': {
                                    name: {
                                        de: 'Augsburger Friedensfest',
                                        en: 'Augsburg Peace Festival'
                                    }
                                }
                            }
                        },
                        EVANG: {
                            names: {
                                de: "\xdcberwiegend evangelische Gemeinden",
                                en: 'Predominantly protestant communities'
                            },
                            days: {
                                '08-15': {
                                    _name: '08-15',
                                    type: 'school'
                                }
                            }
                        }
                    }
                },
                HB: {
                    name: 'Hansestadt Bremen',
                    days: {
                        '10-31': {
                            _name: 'Reformation Day',
                            active: [
                                {
                                    from: '2018-01-01T00:00:00.000Z'
                                }
                            ]
                        }
                    }
                },
                HE: {
                    name: 'Hessen',
                    days: {
                        easter: {
                            _name: 'easter'
                        },
                        'easter 49': {
                            _name: 'easter 49'
                        },
                        'easter 60': {
                            _name: 'easter 60'
                        }
                    }
                },
                HH: {
                    name: 'Hansestadt Hamburg',
                    days: {
                        '10-31': {
                            _name: 'Reformation Day',
                            active: [
                                {
                                    from: '2018-01-01T00:00:00.000Z'
                                }
                            ]
                        }
                    }
                },
                MV: {
                    name: 'Mecklenburg Vorpommern',
                    days: {
                        '03-08 since 2023': {
                            _name: '03-08'
                        },
                        '10-31': {
                            _name: 'Reformation Day'
                        }
                    }
                },
                NI: {
                    name: 'Niedersachsen',
                    days: {
                        '10-31': {
                            _name: 'Reformation Day',
                            active: [
                                {
                                    from: '2018-01-01T00:00:00.000Z'
                                }
                            ]
                        }
                    }
                },
                NW: {
                    name: 'Nordrhein-Westfalen',
                    days: {
                        'easter 60': {
                            _name: 'easter 60'
                        },
                        '11-01': {
                            _name: '11-01'
                        }
                    }
                },
                RP: {
                    name: 'Rheinland-Pfalz',
                    days: {
                        'easter 60': {
                            _name: 'easter 60'
                        },
                        '11-01': {
                            _name: '11-01'
                        }
                    }
                },
                SH: {
                    name: 'Schleswig-Holstein',
                    days: {
                        '10-31': {
                            _name: 'Reformation Day',
                            active: [
                                {
                                    from: '2018-01-01T00:00:00.000Z'
                                }
                            ]
                        }
                    }
                },
                SL: {
                    name: 'Saarland',
                    days: {
                        'easter 60': {
                            _name: 'easter 60'
                        },
                        '08-15': {
                            _name: '08-15'
                        },
                        '11-01': {
                            _name: '11-01'
                        }
                    }
                },
                SN: {
                    name: 'Sachsen',
                    days: {
                        'easter 60': {
                            _name: 'easter 60',
                            type: 'observance'
                        },
                        '10-31': {
                            _name: 'Reformation Day'
                        },
                        'wednesday before 11-23': {
                            _name: "Bu\xdf- und Bettag"
                        }
                    },
                    regions: {
                        BZ: {
                            name: 'Landkreis Bautzen',
                            days: {
                                'easter 60': {
                                    _name: 'easter 60',
                                    type: 'public',
                                    note: "Bautzen (nur in den Ortsteilen Bolbritz und Salzenforst), Crostwitz, G\xf6da (nur im Ortsteil Prischwitz), Gro\xdfdubrau (nur im Ortsteil Sdier), Hoyerswerda (nur im Ortsteil D\xf6rgenhausen), K\xf6nigswartha (nicht im Ortsteil Wartha), Nebelsch\xfctz, Neschwitz (nur in den Ortsteilen Neschwitz und Saritsch), Panschwitz-Kuckau, Puschwitz, R\xe4ckelwitz, Radibor, Ralbitz-Rosenthal und Wittichenau."
                                }
                            }
                        }
                    }
                },
                ST: {
                    name: 'Sachsen-Anhalt',
                    days: {
                        '01-06': {
                            _name: '01-06'
                        },
                        '10-31': {
                            _name: 'Reformation Day'
                        }
                    }
                },
                TH: {
                    name: "Th\xfcringen",
                    days: {
                        'easter 60': {
                            _name: 'easter 60',
                            type: 'observance'
                        },
                        '09-20': {
                            name: {
                                de: 'Weltkindertag',
                                en: "International Children's Day"
                            },
                            active: [
                                {
                                    from: 2019
                                }
                            ]
                        },
                        '10-31': {
                            _name: 'Reformation Day'
                        }
                    },
                    regions: {
                        EIC: {
                            name: 'Landkreis Eichfeld',
                            days: {
                                'easter 60': {
                                    _name: 'easter 60',
                                    type: 'public'
                                }
                            }
                        },
                        UH: {
                            name: 'Unstrut-Hainich-Kreis',
                            days: {
                                'easter 60': {
                                    _name: 'easter 60',
                                    type: 'public',
                                    note: "In Anrode (nur in den Ortsteilen Bickenriede und Zella), D\xfcnwald (nur in den Ortsteilen Beberstedt und H\xfcpstedt), Rodeberg (nur im Ortsteil Struth), S\xfcdeichsfeld"
                                }
                            }
                        },
                        WAK: {
                            name: 'Wartburgkreis',
                            days: {
                                'easter 60': {
                                    _name: 'easter 60',
                                    type: 'public',
                                    note: "In Brunnhartshausen (nur in den Ortsteilen F\xf6hlritz und Steinberg), Buttlar, Geisa, Schleid, Zella/Rh\xf6n"
                                }
                            }
                        }
                    }
                }
            }
        },
        DJ: {
            names: {
                fr: "R\xe9publique de Djibouti",
                ar: "\u062C\u0645\u0647\u0648\u0631\u064A\u0629 \u062C\u064A\u0628\u0648\u062A\u064A",
                so: 'Jamhuuriyadda Jabuuti',
                aa: 'Gabuutih Ummuuno',
                en: 'Djibouti'
            },
            langs: [
                'fr',
                'ar',
                'en'
            ],
            zones: [
                'Africa/Nairobi'
            ],
            dayoff: '',
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '05-01': {
                    _name: '05-01'
                },
                '06-27 since 1977': {
                    _name: 'Independence Day'
                },
                '12-25': {
                    _name: '12-25'
                },
                '1 Muharram': {
                    _name: '1 Muharram'
                },
                '12 Rabi al-awwal': {
                    _name: '12 Rabi al-awwal'
                },
                '27 Rajab': {
                    _name: '27 Rajab'
                },
                '1 Shawwal': {
                    _name: '1 Shawwal'
                },
                '9 Dhu al-Hijjah': {
                    _name: '9 Dhu al-Hijjah'
                },
                '10 Dhu al-Hijjah': {
                    _name: '10 Dhu al-Hijjah'
                }
            }
        },
        DK: {
            names: {
                da: 'Danmark',
                en: 'Denmark'
            },
            langs: [
                'da'
            ],
            zones: [
                'Europe/Copenhagen'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                'easter -48': {
                    name: {
                        da: 'Fastelavn'
                    },
                    type: 'observance'
                },
                'easter -3': {
                    _name: 'easter -3'
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                easter: {
                    _name: 'easter'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                'easter 26 prior to 2024': {
                    name: {
                        da: 'Store Bededag',
                        en: 'Prayer Day',
                        de: "Bu\xdf- und Bettag"
                    }
                },
                'easter 39': {
                    _name: 'easter 39'
                },
                '05-01': {
                    _name: '05-01',
                    type: 'observance',
                    note: 'Full holiday for blue collar workers'
                },
                '2nd sunday in May': {
                    _name: 'Mothers Day',
                    type: 'observance'
                },
                '06-05': {
                    _name: 'Constitution Day',
                    type: 'observance',
                    note: 'Shops are closed'
                },
                'easter 49': {
                    _name: 'easter 49'
                },
                'easter 50': {
                    _name: 'easter 50'
                },
                '12-24': {
                    _name: '12-24',
                    type: 'observance',
                    note: 'Shops are closed'
                },
                '12-25': {
                    _name: '12-25'
                },
                '12-26': {
                    _name: '12-26'
                }
            }
        },
        DM: {
            names: {
                en: 'Dominica'
            },
            langs: [
                'en'
            ],
            zones: [
                'America/Port_of_Spain'
            ],
            dayoff: 'sunday',
            days: {
                '01-01 and if sunday then next monday': {
                    _name: '01-01',
                    substitute: true
                },
                'easter -48': {
                    _name: 'easter -48',
                    name: {
                        en: 'Carnival Monday'
                    }
                },
                'easter -47': {
                    _name: 'easter -47',
                    name: {
                        en: 'Carnival Tuesday'
                    }
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                easter: {
                    _name: 'easter',
                    type: 'observance'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '05-01': {
                    _name: '05-01'
                },
                'easter 49': {
                    _name: 'easter 49',
                    type: 'observance'
                },
                'easter 50': {
                    _name: 'easter 50'
                },
                '1st monday in August': {
                    name: {
                        en: 'Emancipation Day'
                    }
                },
                '11-03 if sunday then next monday': {
                    _name: 'Independence Day'
                },
                '11-04 if sunday then next monday if monday then next tuesday': {
                    name: {
                        en: 'National Day of Community Service'
                    }
                },
                '12-25 and if sunday then next tuesday': {
                    _name: '12-25',
                    substitute: true
                },
                '12-26 and if sunday then next monday': {
                    _name: '12-26',
                    substitute: true
                }
            }
        },
        DO: {
            names: {
                es: "Rep\xfablica Dominicana",
                en: 'Dominican Republic'
            },
            dayoff: 'sunday',
            zones: [
                'America/Santo_Domingo'
            ],
            langs: [
                'es'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '01-06 if tuesday,wednesday then previous monday if thursday,friday then next monday': {
                    _name: '01-06'
                },
                '01-21': {
                    name: {
                        es: "Nuestra Se\xf1ora de la Altagracia",
                        en: 'Our Lady of Altagracia'
                    }
                },
                '01-26 if tuesday,wednesday then previous monday if thursday,friday then next monday': {
                    name: {
                        es: "D\xeda de Duarte",
                        en: "Duarte's Birthday"
                    }
                },
                '02-27': {
                    _name: 'Independence Day'
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                '05-01 if tuesday,wednesday then previous monday if thursday,friday,sunday then next monday': {
                    _name: '05-01'
                },
                'easter 60': {
                    _name: 'easter 60'
                },
                '08-16': {
                    name: {
                        es: "D\xeda de la Restauraci\xf3n",
                        en: 'Restoration Day'
                    }
                },
                '09-24': {
                    name: {
                        es: "Nuestra Se\xf1ora de las Mercedes",
                        en: 'Our Lady of las Mercedes'
                    }
                },
                '11-06 if tuesday,wednesday,thursday,friday,saturday then next monday': {
                    _name: 'Constitution Day'
                },
                '12-25': {
                    _name: '12-25'
                }
            }
        },
        DZ: {
            names: {
                ar: "\u0627\u0644\u062C\u0645\u0647\u0648\u0631\u064A\u0629 \u0627\u0644\u062C\u0632\u0627\u0626\u0631\u064A\u0629 \u0627\u0644\u062F\u064A\u0645\u0642\u0631\u0627\u0637\u064A\u0629 \u0627\u0644\u0634\u0639\u0628\u064A\u0629",
                fr: "R\xe9publique alg\xe9rienne d\xe9mocratique et populaire",
                en: 'Algeria'
            },
            langs: [
                'ar',
                'fr',
                'en'
            ],
            zones: [
                'Africa/Algiers'
            ],
            dayoff: 'saturday',
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '01-12': {
                    name: {
                        ar: "\u0631\u0623\u0633 \u0627\u0644\u0633\u0646\u0629 \u0627\u0644\u0623\u0645\u0627\u0632\u064A\u063A\u064A\u0629",
                        fr: 'Nouvel an amazigh',
                        en: 'Amazigh New Year'
                    }
                },
                '05-01': {
                    _name: '05-01'
                },
                '07-05': {
                    _name: 'Independence Day'
                },
                '11-01': {
                    _name: 'Revolution Day'
                },
                '1 Muharram': {
                    _name: '1 Muharram'
                },
                '10 Muharram': {
                    _name: '10 Muharram'
                },
                '12 Rabi al-awwal': {
                    _name: '12 Rabi al-awwal'
                },
                '1 Shawwal': {
                    _name: '1 Shawwal'
                },
                '10 Dhu al-Hijjah': {
                    _name: '10 Dhu al-Hijjah'
                }
            }
        },
        EC: {
            names: {
                es: 'Ecuador',
                en: 'Ecuador'
            },
            dayoff: 'sunday',
            langs: [
                'es'
            ],
            zones: [
                'America/Guayaquil',
                'Pacific/Galapagos'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                'easter -48': {
                    name: {
                        en: 'Carnival',
                        es: 'Carnaval'
                    }
                },
                'easter -47': {
                    _name: 'easter -47'
                },
                'easter -3': {
                    _name: 'easter -3'
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                easter: {
                    _name: 'easter',
                    type: 'observance'
                },
                '05-01': {
                    _name: '05-01'
                },
                '05-24': {
                    name: {
                        en: 'The Battle of Pichincha',
                        es: 'Batalla del Pichincha'
                    }
                },
                '07-24': {
                    name: {
                        en: "The Birthday of Sim\xf3n Bol\xedvar",
                        es: "El Natalicio de Sim\xf3n Bol\xedvar"
                    },
                    type: 'observance'
                },
                '08-10': {
                    name: {
                        en: 'Declaration of Independence of Quito',
                        es: "D\xeda del Primer Grito de Independencia de Quito"
                    }
                },
                '09-10': {
                    name: {
                        en: 'Independence of Guayaquil',
                        es: 'Independencia de Guayaquil'
                    }
                },
                '10-31': {
                    name: {
                        en: 'Flag Day',
                        es: 'Dia de La Bandera'
                    },
                    type: 'observance'
                },
                '11-02': {
                    _name: '11-02'
                },
                '11-03': {
                    name: {
                        en: 'Independence of Cuenca',
                        es: 'Independencia de Cuenca'
                    }
                },
                '12-25': {
                    _name: '12-25'
                },
                '12-31': {
                    _name: '12-31',
                    type: 'observance'
                }
            },
            states: {
                P: {
                    name: 'Pichincha',
                    regions: {
                        QU: {
                            name: 'Quito',
                            days: {
                                '12-06': {
                                    name: {
                                        en: 'Foundation of Quito',
                                        es: "Aniversario de la fundaci\xf3n de Quito"
                                    },
                                    type: 'observance'
                                }
                            }
                        }
                    }
                }
            }
        },
        EE: {
            names: {
                et: 'Eesti',
                en: 'Estonia'
            },
            dayoff: 'sunday',
            langs: [
                'et'
            ],
            zones: [
                'Europe/Tallinn'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '01-06': {
                    _name: '01-06',
                    type: 'observance'
                },
                '02-02': {
                    name: {
                        et: "Tartu rahulepingu aastap\xe4ev",
                        en: 'Anniversary of the Tartu Peace Treaty'
                    },
                    type: 'observance'
                },
                '02-24': {
                    _name: 'Independence Day',
                    type: 'public'
                },
                '03-14': {
                    name: {
                        et: "emakeelep\xe4ev",
                        en: 'Native Language Day'
                    },
                    type: 'observance'
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                easter: {
                    _name: 'easter'
                },
                '05-01': {
                    _name: '05-01'
                },
                '2nd sunday in May': {
                    _name: 'Mothers Day',
                    type: 'observance'
                },
                'easter 49': {
                    _name: 'easter 49'
                },
                '06-04': {
                    name: {
                        et: "Eesti lipu p\xe4ev",
                        en: 'National Flag Day'
                    },
                    type: 'observance'
                },
                '06-14': {
                    name: {
                        et: "leinap\xe4ev",
                        en: 'Day of Mourning and Commemoration'
                    },
                    type: 'observance'
                },
                '06-23': {
                    name: {
                        et: "v\xf5idup\xfcha",
                        en: 'Victory Day'
                    }
                },
                '06-24': {
                    name: {
                        et: "jaanip\xe4ev",
                        en: 'Midsummer Day'
                    }
                },
                '08-20': {
                    name: {
                        et: "taasiseseisvumisp\xe4ev",
                        en: 'Day of Restoration of Independence'
                    }
                },
                '08-23': {
                    name: {
                        et: "kommunismi ja natsismi ohvrite m\xe4lestusp\xe4ev",
                        en: 'European Day of Remembrance for Victims of Stalinism and Nazism'
                    },
                    type: 'observance'
                },
                '2nd sunday in September': {
                    name: {
                        et: "vanavanemate p\xe4ev",
                        en: 'Grandparents Day'
                    },
                    type: 'observance'
                },
                '09-22': {
                    name: {
                        et: "vastupanuv\xf5itluse p\xe4ev",
                        en: 'Resistance Fighting Day'
                    },
                    type: 'observance'
                },
                '11-02': {
                    _name: '11-02',
                    type: 'observance'
                },
                '2nd sunday in November': {
                    _name: 'Fathers Day',
                    type: 'observance'
                },
                '11-16': {
                    name: {
                        et: "taass\xfcnni p\xe4ev",
                        en: 'Day of Declaration of Sovereignty'
                    },
                    type: 'observance'
                },
                '12-24': {
                    _name: '12-24'
                },
                '12-25': {
                    _name: '12-25'
                },
                '12-26': {
                    _name: '12-26'
                }
            }
        },
        EG: {
            names: {
                ar: "\u062C\u0645\u0647\u0648\u0631\u064A\u0629 \u0645\u0635\u0631 \u0627\u0644\u0639\u0631\u0628\u064A\u0629",
                en: 'Egypt'
            },
            langs: [
                'ar',
                'en'
            ],
            zones: [
                'Africa/Cairo'
            ],
            dayoff: 'saturday',
            days: {
                '01-25 since 2011': {
                    name: {
                        ar: "\u0639\u064A\u062F \u062B\u0648\u0631\u0629 25 \u064A\u0646\u0627\u064A\u0631",
                        en: 'Revolution Day 2011'
                    }
                },
                '01-25': {
                    name: {
                        ar: "\u0639\u064A\u062F \u0627\u0644\u0634\u0631\u0637\u0629",
                        en: 'National Police Day'
                    }
                },
                '04-25': {
                    name: {
                        ar: "\u0639\u064A\u062F \u062A\u062D\u0631\u064A\u0631 \u0633\u064A\u0646\u0627\u0621",
                        en: 'Sinai Liberation Day'
                    }
                },
                '05-01': {
                    _name: '05-01'
                },
                '06-30': {
                    name: {
                        ar: "\u0639\u064A\u062F \u062B\u0648\u0631\u0629 30 \u064A\u0648\u0646\u064A\u0648",
                        en: '30 June Day'
                    }
                },
                '07-23': {
                    _name: 'Revolution Day'
                },
                '10-06': {
                    name: {
                        ar: "\u0639\u064A\u062F \u0627\u0644\u0642\u0648\u0627\u062A \u0627\u0644\u0645\u0633\u0644\u062D\u0629",
                        en: 'Armed Forces Day'
                    }
                },
                'orthodox 1': {
                    name: {
                        ar: "\u0634\u0645 \u0627\u0644\u0646\u0633\u064A\u0645",
                        en: 'Sham El Nessim'
                    }
                },
                'julian 12-25': {
                    _name: '12-25'
                },
                '1 Muharram': {
                    _name: '1 Muharram'
                },
                '12 Rabi al-awwal': {
                    _name: '12 Rabi al-awwal'
                },
                '1 Shawwal P3D': {
                    _name: '1 Shawwal'
                },
                '10 Dhu al-Hijjah P4D': {
                    _name: '10 Dhu al-Hijjah'
                }
            }
        },
        EH: {
            names: {
                ar: "\u0627\u0644\u062C\u0645\u0647\u0648\u0631\u064A\u0629 \u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0627\u0644\u0635\u062D\u0631\u0627\u0648\u064A\u0629 \u0627\u0644\u062F\u064A\u0645\u0642\u0631\u0627\u0637\u064A\u0629",
                en: 'Western Sahara'
            },
            langs: [],
            zones: [
                'Africa/El_Aaiun'
            ],
            dayoff: '',
            days: {
                '02-27': {
                    _name: 'Independence Day'
                },
                '03-08': {
                    name: {
                        en: 'First Martyr'
                    }
                },
                '05-10': {
                    name: {
                        en: 'May 20 Revolution'
                    }
                },
                '06-09': {
                    name: {
                        en: 'Day of the Martyrs'
                    }
                },
                '06-17': {
                    name: {
                        en: 'Day of National Unity'
                    }
                },
                '1 Muharram': {
                    _name: '1 Muharram'
                },
                '12 Rabi al-awwal': {
                    _name: '12 Rabi al-awwal'
                },
                '1 Shawwal P2D': {
                    _name: '1 Shawwal'
                },
                '10 Dhu al-Hijjah P2D': {
                    _name: '10 Dhu al-Hijjah'
                }
            }
        },
        ER: {
            names: {
                en: 'Eritrea'
            },
            langs: [
                'ti',
                'en'
            ],
            zones: [
                'Africa/Nairobi'
            ],
            dayoff: '',
            days: {
                '01-01': {
                    _name: '01-01'
                },
                'julian 12-25': {
                    _name: 'julian 12-25'
                },
                'julian 01-06': {
                    _name: '01-06'
                },
                '02-10': {
                    name: {
                        ti: "\u1348\u1295\u1245\u120D",
                        en: 'Fenkil Day'
                    }
                },
                '03-08': {
                    _name: '03-08'
                },
                'orthodox -2': {
                    _name: 'orthodox -2'
                },
                orthodox: {
                    _name: 'orthodox'
                },
                '05-01': {
                    _name: '05-01'
                },
                '05-24': {
                    _name: 'Independence Day'
                },
                '06-20': {
                    name: {
                        en: "Martyrs' Day",
                        ti: "\u1218\u12D3\u120D\u1272 \u1235\u12CD\u12A3\u1275"
                    }
                },
                '09-01': {
                    _name: 'Revolution Day'
                },
                '09-11 in non-leap years': {
                    name: {
                        en: 'Geez New Year',
                        ti: "\u130D\u12D5\u12DD \u12A0\u12F2\u1235 \u12D3\u1218\u1275"
                    }
                },
                '09-12 in leap years': {
                    name: {
                        en: 'Geez New Year',
                        ti: "\u130D\u12D5\u12DD \u12A0\u12F2\u1235 \u12D3\u1218\u1275"
                    }
                },
                '09-27 in non-leap years': {
                    name: {
                        en: 'Meskel'
                    }
                },
                '09-28 in leap years': {
                    name: {
                        en: 'Meskel'
                    }
                },
                '12-25': {
                    _name: '12-25'
                },
                '12 Rabi al-awwal': {
                    _name: '12 Rabi al-awwal'
                },
                '1 Shawwal': {
                    _name: '1 Shawwal'
                },
                '10 Dhu al-Hijjah': {
                    _name: '10 Dhu al-Hijjah'
                }
            }
        },
        ES: {
            names: {
                es: "Espa\xf1a",
                ca: 'Espanya',
                en: 'Spain'
            },
            langs: [
                'es'
            ],
            zones: [
                'Europe/Madrid',
                'Africa/Ceuta',
                'Atlantic/Canary'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                'substitutes 01-01 if sunday then next monday': {
                    type: 'observance',
                    substitute: true,
                    _name: '01-01'
                },
                '01-06': {
                    _name: '01-06'
                },
                'substitutes 01-06 if sunday then next monday': {
                    type: 'observance',
                    substitute: true,
                    _name: '01-06'
                },
                '03-19': {
                    _name: '03-19',
                    type: 'observance'
                },
                'easter -3': {
                    _name: 'easter -3'
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                easter: {
                    _name: 'easter',
                    type: 'observance'
                },
                '05-01': {
                    _name: '05-01'
                },
                '1st sunday in May': {
                    _name: 'Mothers Day',
                    type: 'observance'
                },
                'easter 49': {
                    _name: 'easter 49',
                    type: 'observance'
                },
                '07-25': {
                    name: {
                        es: 'Santiago Apostol'
                    },
                    type: 'observance',
                    note: 'regional'
                },
                '08-15': {
                    _name: '08-15'
                },
                '10-12': {
                    name: {
                        es: "Fiesta Nacional de Espa\xf1a"
                    }
                },
                'substitutes 10-12 if sunday then next monday': {
                    substitute: true,
                    type: 'observance',
                    name: {
                        es: "Fiesta Nacional de Espa\xf1a"
                    }
                },
                '11-01': {
                    _name: '11-01'
                },
                'substitutes 11-01 if sunday then next monday': {
                    substitute: true,
                    type: 'observance',
                    _name: '11-01'
                },
                '12-06': {
                    name: {
                        es: "D\xeda de la Constituci\xf3n Espa\xf1ola"
                    }
                },
                'substitutes 12-06 if sunday then next monday': {
                    type: 'observance',
                    substitute: true,
                    name: {
                        es: "D\xeda de la Constituci\xf3n Espa\xf1ola"
                    }
                },
                '12-08': {
                    _name: '12-08'
                },
                'substitutes 12-08 if sunday then next monday': {
                    type: 'observance',
                    substitute: true,
                    _name: '12-08'
                },
                '12-25': {
                    _name: '12-25'
                },
                'substitutes 12-25 if sunday then next monday': {
                    substitute: true,
                    _name: '12-25'
                }
            },
            states: {
                AN: {
                    name: "Andaluc\xeda",
                    days: {
                        '02-28': {
                            name: {
                                es: "D\xeda de Andaluc\xeda"
                            }
                        },
                        'substitutes 02-28 if Sunday then next Monday': {
                            substitute: true,
                            name: {
                                es: "D\xeda de Andaluc\xeda"
                            }
                        },
                        'substitutes 05-01 if Sunday then next Monday': {
                            substitute: true,
                            _name: '05-01'
                        },
                        'substitutes 08-15 if Sunday then next Monday': {
                            substitute: true,
                            _name: '08-15'
                        },
                        'easter -3': {
                            _name: 'easter -3'
                        }
                    }
                },
                AR: {
                    name: "Arag\xf3n",
                    days: {
                        '04-23': {
                            name: {
                                es: "D\xeda de Arag\xf3n"
                            }
                        },
                        'substitutes 04-23 if Sunday then next Monday': {
                            substitute: true,
                            name: {
                                es: "D\xeda de Arag\xf3n"
                            }
                        },
                        'substitutes 05-01 if Sunday then next Monday': {
                            substitute: true,
                            _name: '05-01'
                        },
                        'substitutes 08-15 if Sunday then next Monday': {
                            substitute: true,
                            _name: '08-15'
                        }
                    }
                },
                AS: {
                    name: 'Asturias',
                    days: {
                        'substitutes 05-01 if Sunday then next Monday': {
                            substitute: true,
                            _name: '05-01'
                        },
                        'substitutes 08-15 if Sunday then next Monday': {
                            substitute: true,
                            _name: '08-15'
                        },
                        '09-08': {
                            name: "D\xeda de Asturias"
                        },
                        'substitutes 09-08 if Sunday then next Monday': {
                            substitute: true,
                            name: "D\xeda de Asturias"
                        }
                    }
                },
                CB: {
                    name: 'Cantabria',
                    days: {
                        '06-28': {
                            name: "D\xeda de las Instituciones de Cantabria"
                        },
                        'substitutes 06-28 if Sunday then next Monday': {
                            name: "D\xeda de las Instituciones de Cantabria"
                        },
                        '09-15': {
                            name: 'La Bien Aparecida'
                        },
                        'substitutes 09-15 if Sunday then next Monday': {
                            name: 'La Bien Aparecida'
                        }
                    }
                },
                CE: {
                    name: 'Ciudad de Ceuta',
                    days: {
                        '08-05': {
                            name: "Nuestra Se\xf1ora de \xc1frica"
                        },
                        'substitutes 08-05 if Sunday then next Monday': {
                            substitute: true,
                            name: "Nuestra Se\xf1ora de \xc1frica"
                        },
                        '09-02': {
                            name: "D\xeda de Ceuta"
                        },
                        'substitutes 09-02 if Sunday then next Monday': {
                            substitute: true,
                            name: "D\xeda de Ceuta"
                        },
                        '9 Dhu al-Hijjah': {
                            _name: '9 Dhu al-Hijjah'
                        }
                    }
                },
                CL: {
                    names: {
                        es: "Castilla y Le\xf3n",
                        en: "Castile and Le\xf3n"
                    },
                    days: {
                        '04-23': {
                            name: "Fiesta de Castilla y Le\xf3n"
                        },
                        'substitutes 04-23 if Sunday then next Monday': {
                            substitute: true,
                            name: "Fiesta de Castilla y Le\xf3n"
                        },
                        'substitutes 05-01 if Sunday then next Monday': {
                            substitute: true,
                            _name: '05-01'
                        },
                        'substitutes 08-15 if Sunday then next Monday': {
                            substitute: true,
                            _name: '08-15'
                        }
                    }
                },
                CM: {
                    name: 'Castile-La Mancha',
                    days: {
                        '05-31 since 2020': {
                            name: "D\xeda de Castilla-La Mancha"
                        },
                        'substitutes 05-31 if Sunday then next Monday since 2020': {
                            substitute: true,
                            name: "D\xeda de Castilla-La Mancha"
                        },
                        'easter 60': {
                            _name: 'easter 60'
                        }
                    }
                },
                CN: {
                    names: {
                        es: 'Islas Canarias',
                        en: 'Canary Islands'
                    },
                    zones: [
                        'Atlantic/Canary'
                    ],
                    dayoff: 'sunday',
                    _days: 'IC',
                    regions: {
                        EH: {
                            names: {
                                es: 'El Hierro'
                            },
                            _days: [
                                'IC',
                                'regions',
                                'EH'
                            ]
                        },
                        FU: {
                            names: {
                                es: 'Fuerteventura'
                            },
                            _days: [
                                'IC',
                                'regions',
                                'FU'
                            ]
                        },
                        GC: {
                            names: {
                                es: 'Gran Canaria'
                            },
                            _days: [
                                'IC',
                                'regions',
                                'GC'
                            ]
                        },
                        LG: {
                            names: {
                                es: 'La Gomera'
                            },
                            _days: [
                                'IC',
                                'regions',
                                'LG'
                            ]
                        },
                        LP: {
                            names: {
                                es: 'La Palma'
                            },
                            _days: [
                                'IC',
                                'regions',
                                'LP'
                            ]
                        },
                        LA: {
                            names: {
                                es: 'Lanzarote'
                            },
                            _days: [
                                'IC',
                                'regions',
                                'LA'
                            ]
                        },
                        TE: {
                            names: {
                                es: 'Tenerife'
                            },
                            _days: [
                                'IC',
                                'regions',
                                'TE'
                            ]
                        }
                    }
                },
                CT: {
                    names: {
                        ca: 'Catalunya',
                        es: "Catalu\xf1a",
                        en: 'Catalonia'
                    },
                    days: {
                        '09-11': {
                            name: {
                                ca: 'Diada de Catalunya',
                                es: "Dia de Catalu\xf1a"
                            }
                        },
                        '06-24': {
                            name: {
                                ca: 'Sant Joan',
                                es: 'San Juan'
                            }
                        },
                        'easter -3': {
                            _name: 'easter -3',
                            type: 'observance'
                        },
                        'easter 1': {
                            _name: 'easter 1'
                        },
                        'easter 50': {
                            _name: 'easter 50'
                        },
                        'substitutes 05-01 if Saturday, Sunday then next Monday': {
                            substitute: true,
                            _name: '05-01'
                        },
                        '09-24 if sunday then next monday': {
                            name: {
                                es: "Mare de D\xe9u de la Merc\xe8"
                            }
                        },
                        '12-26': {
                            name: {
                                ca: 'Sant Esteve',
                                es: 'San Esteban'
                            },
                            type: 'observance'
                        }
                    }
                },
                EX: {
                    name: 'Extremadura',
                    days: {
                        'substitutes 05-01 if Sunday then next Monday': {
                            substitute: true,
                            _name: '05-01'
                        },
                        '09-08': {
                            name: "D\xeda de Extremadura"
                        },
                        'substitutes 09-08 if Sunday then next Monday': {
                            substitute: true,
                            name: "D\xeda de Extremadura"
                        }
                    }
                },
                GA: {
                    name: 'Galicia',
                    days: {
                        '05-17': {
                            name: "D\xeda de las Letras Gallegas"
                        },
                        'substitutes 05-17 if Sunday then next Monday': {
                            substitute: true,
                            name: "D\xeda de las Letras Gallegas"
                        },
                        '07-25': {
                            name: "D\xeda Nacional de Galicia"
                        },
                        'substitutes 07-25 if Sunday then next Monday': {
                            substitute: true,
                            name: "D\xeda Nacional de Galicia"
                        }
                    }
                },
                IB: {
                    names: {
                        es: 'Illes Balears',
                        en: 'Balearic Islands'
                    },
                    days: {
                        '03-01': {
                            name: {
                                es: "D\xeda de les Illes Balears"
                            }
                        },
                        'substitutes 03-01 if Sunday then next Monday': {
                            substitute: true,
                            name: {
                                es: "D\xeda de les Illes Balears"
                            }
                        },
                        'easter 1': {
                            _name: 'easter 1'
                        },
                        '12-26': {
                            name: {
                                es: 'Sant Esteve'
                            },
                            type: 'observance'
                        }
                    }
                },
                MC: {
                    name: 'Murcia Region',
                    days: {
                        'substitutes 05-01 if Sunday then next Monday': {
                            substitute: true,
                            _name: '05-01'
                        }
                    }
                },
                MD: {
                    name: 'Comunidad de Madrid',
                    days: {
                        '05-02 if Sunday then next Monday': {
                            name: {
                                es: "D\xeda de la Comunidad de Madrid"
                            }
                        },
                        'substitutes 05-02 if Sunday then next Monday': {
                            substitute: true,
                            name: {
                                es: "D\xeda de la Comunidad de Madrid"
                            }
                        },
                        '05-16': {
                            name: {
                                es: 'San Isidro Labrador'
                            },
                            type: 'observance'
                        },
                        '07-25': {
                            name: "Santiago Ap\xf3stol"
                        },
                        'substitutes 07-25 if Sunday then next Monday': {
                            substitute: true,
                            name: "Santiago Ap\xf3stol"
                        },
                        '11-09 if sunday then next monday': {
                            name: {
                                es: "Nuestra Se\xf1ora de la Almudena"
                            },
                            type: 'observance'
                        }
                    }
                },
                ML: {
                    name: 'Ciudad de Melilla',
                    days: {
                        '1 Shawwal': {
                            _name: '1 Shawwal'
                        },
                        '10 Dhu al-Hijjah': {
                            _name: '10 Dhu al-Hijjah'
                        }
                    }
                },
                NC: {
                    names: {
                        es: 'Comunidad Foral de Navarra',
                        en: 'Navarra Chartered Community'
                    },
                    days: {
                        'easter 1': {
                            _name: 'easter 1'
                        },
                        '07-25': {
                            name: "Santiago Ap\xf3stol"
                        },
                        'substitutes 07-25 if Sunday then next Monday': {
                            substitute: true,
                            name: "Santiago Ap\xf3stol"
                        }
                    }
                },
                PV: {
                    names: {
                        es: "Pa\xeds Vasco",
                        en: 'Basque Country'
                    },
                    days: {
                        'easter 1': {
                            _name: 'easter 1'
                        },
                        '07-25': {
                            name: "Santiago Ap\xf3stol"
                        },
                        'substitutes 07-25 if Sunday then next Monday': {
                            substitute: true,
                            name: "Santiago Ap\xf3stol"
                        },
                        '2022-09-06': {
                            name: 'V Centenario Vuelta al Mundo'
                        }
                    }
                },
                RI: {
                    name: 'La Rioja',
                    days: {
                        'easter 1': {
                            _name: 'easter 1'
                        }
                    }
                },
                VC: {
                    names: {
                        es: 'Comunitat Valenciana',
                        en: 'Valencian Community'
                    },
                    days: {
                        '03-19': {
                            _name: '03-19'
                        },
                        'easter 1': {
                            _name: 'easter 1'
                        }
                    }
                }
            }
        },
        ET: {
            names: {
                am: "\u12A2\u1275\u12EE\u1335\u12EB",
                en: 'Ethiopia'
            },
            dayoff: 'sunday',
            langs: [
                'am',
                'en'
            ],
            zones: [
                'Africa/Nairobi'
            ],
            days: {
                '01-06 in non-leap years': {
                    _name: '12-25'
                },
                '01-07 in leap years': {
                    _name: '12-25'
                },
                '01-19': {
                    _name: '01-06'
                },
                '03-02': {
                    name: {
                        am: "\u12E8\u12D3\u12F5\u12CB \u12F5\u120D \u1260\u12D3\u120D",
                        en: 'Victory at Adwa Day'
                    }
                },
                '03-28': {
                    name: {
                        am: "\u12E8\u1240\u12ED \u123D\u1265\u122D \u1218\u1273\u1230\u1262\u12EB \u1240\u1295",
                        en: 'Day of Lament'
                    }
                },
                'orthodox -2': {
                    _name: 'easter -2'
                },
                orthodox: {
                    _name: 'easter'
                },
                '05-28': {
                    name: {
                        am: "\u12F0\u122D\u130D \u12E8\u12C8\u12F0\u1240\u1260\u1275 \u1240\u1295",
                        en: 'Derg Downfall Day'
                    }
                },
                '09-11 in non-leap years': {
                    _name: '01-01'
                },
                '09-12 in leap years': {
                    _name: '01-01'
                },
                '09-27 in non-leap years': {
                    name: {
                        am: "\u1265\u122D\u1210\u1290-\u1218\u1235\u1240\u120D",
                        en: 'Finding of the True Cross'
                    }
                },
                '09-28 in leap years': {
                    name: {
                        am: "\u1265\u122D\u1210\u1290-\u1218\u1235\u1240\u120D",
                        en: 'Finding of the True Cross'
                    }
                },
                '1 Ramadan': {
                    _name: '1 Ramadan'
                },
                '12 Rabi al-awwal': {
                    _name: '12 Rabi al-awwal'
                },
                '1 Shawwal': {
                    _name: '1 Shawwal'
                },
                '10 Dhu al-Hijjah': {
                    _name: '10 Dhu al-Hijjah'
                }
            }
        },
        FI: {
            names: {
                fi: 'Suomi',
                en: 'Finland'
            },
            dayoff: 'sunday',
            langs: [
                'fi'
            ],
            zones: [
                'Europe/Helsinki'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '01-06': {
                    _name: '01-06'
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                easter: {
                    _name: 'easter'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '05-01': {
                    _name: '05-01'
                },
                'easter 39': {
                    _name: 'easter 39'
                },
                'easter 49': {
                    _name: 'easter 49'
                },
                '2nd sunday in May': {
                    _name: 'Mothers Day',
                    type: 'observance'
                },
                'friday after 06-19': {
                    name: {
                        fi: 'Juhannusaatto',
                        en: 'Midsummer Eve',
                        sv: 'Midsommarafton'
                    },
                    type: 'bank'
                },
                'saturday after 06-20': {
                    name: {
                        fi: "Juhannusp\xe4iv\xe4",
                        en: 'Midsummer Day',
                        sv: 'Midsommardagen'
                    }
                },
                'saturday after 10-31': {
                    _name: '11-01'
                },
                '2nd sunday in November': {
                    _name: 'Fathers Day',
                    type: 'observance'
                },
                '12-06': {
                    _name: 'Independence Day'
                },
                '12-24': {
                    _name: '12-24',
                    type: 'bank'
                },
                '12-25': {
                    _name: '12-25'
                },
                '12-26': {
                    _name: '12-26'
                },
                '12-31': {
                    _name: '12-31',
                    type: 'bank'
                }
            }
        },
        FJ: {
            names: {
                fj: 'Matanitu Tugalala o Viti',
                en: 'Fiji'
            },
            langs: [
                'fj',
                'en'
            ],
            zones: [
                'Pacific/Fiji'
            ],
            dayoff: 'sunday',
            days: {
                '01-01': {
                    _name: '01-01'
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                'easter -1': {
                    _name: 'easter -1'
                },
                easter: {
                    _name: 'easter',
                    type: 'observance'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '09-07': {
                    _name: 'Constitution Day'
                },
                '10-10 and if Sunday then next Monday': {
                    substitute: true,
                    name: {
                        en: 'Fiji Day'
                    }
                },
                '12-25 if Sunday then next Monday': {
                    _name: '12-25'
                },
                '12-26 if Sunday then next Monday if Monday then next Tuesday': {
                    _name: '12-26'
                },
                '12 Rabi al-awwal': {
                    _name: '12 Rabi al-awwal'
                },
                '2014-10-22': {
                    _name: 'Deepavali',
                    name: {
                        en: 'Diwali'
                    }
                },
                '2015-11-10': {
                    _name: 'Deepavali',
                    name: {
                        en: 'Diwali'
                    }
                },
                '2016-10-29': {
                    _name: 'Deepavali',
                    name: {
                        en: 'Diwali'
                    }
                },
                '2017-10-19': {
                    _name: 'Deepavali',
                    name: {
                        en: 'Diwali'
                    }
                },
                '2018-11-07': {
                    _name: 'Deepavali',
                    name: {
                        en: 'Diwali'
                    }
                },
                '2019-10-27': {
                    _name: 'Deepavali',
                    name: {
                        en: 'Diwali'
                    }
                },
                '2019-10-28': {
                    substitute: true,
                    _name: 'Deepavali',
                    name: {
                        en: 'Diwali'
                    }
                },
                '2020-11-14': {
                    _name: 'Deepavali',
                    name: {
                        en: 'Diwali'
                    }
                },
                '2020-11-16': {
                    substitute: true,
                    _name: 'Deepavali',
                    name: {
                        en: 'Diwali'
                    }
                },
                '2021-11-04': {
                    _name: 'Deepavali',
                    name: {
                        en: 'Diwali'
                    }
                },
                '2022-10-24': {
                    _name: 'Deepavali',
                    name: {
                        en: 'Diwali'
                    }
                },
                '2023-11-12': {
                    _name: 'Deepavali',
                    name: {
                        en: 'Diwali'
                    }
                },
                '2023-11-13': {
                    substitute: true,
                    _name: 'Deepavali',
                    name: {
                        en: 'Diwali'
                    }
                },
                '2024-11-01': {
                    _name: 'Deepavali',
                    name: {
                        en: 'Diwali'
                    }
                },
                '2025-10-21': {
                    _name: 'Deepavali',
                    name: {
                        en: 'Diwali'
                    }
                }
            }
        },
        FO: {
            names: {
                fo: "F\xf8royar",
                da: "F\xe6r\xf8erne",
                en: 'Faroe Islands'
            },
            langs: [
                'fo',
                'da'
            ],
            zones: [
                'Atlantic/Faroe'
            ],
            dayoff: 'sunday',
            days: {
                '01-01': {
                    _name: '01-01'
                },
                'easter -3': {
                    _name: 'easter -3'
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                easter: {
                    _name: 'easter'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '04-24': {
                    name: {
                        fo: 'Flaggdagur',
                        da: 'Flagdag',
                        en: 'Flag Day'
                    }
                },
                'easter 26': {
                    name: {
                        fo: "D\xfdri bi\xf0idagur",
                        en: 'Great Prayer Day'
                    }
                },
                'easter 39': {
                    _name: 'easter 39'
                },
                'easter 49': {
                    _name: 'easter 49'
                },
                'easter 50': {
                    _name: 'easter 50'
                },
                '06-05 12:00 if sunday then 00:00': {
                    _name: 'Constitution Day'
                },
                '07-28 12:00 if sunday then 00:00': {
                    name: {
                        da: 'Sankt Olavsaften',
                        en: "St.Olav's Eve"
                    },
                    note: "half-day holiday for some workers' unions",
                    type: 'observance'
                },
                '07-29': {
                    name: {
                        fo: "\xd3lavs\xf8ka",
                        da: 'Sankt Olavs Dag',
                        en: "St.Olav's Day"
                    },
                    note: "full holiday for most workers' unions",
                    type: 'observance'
                },
                '12-24': {
                    _name: '12-24'
                },
                '12-25': {
                    _name: '12-25'
                },
                '12-26': {
                    _name: '12-26'
                },
                '12-31 12:00 if sunday then 00:00': {
                    _name: '12-31'
                }
            }
        },
        FR: {
            names: {
                fr: 'France',
                en: 'France'
            },
            dayoff: 'sunday',
            zones: [
                'Europe/Paris'
            ],
            langs: [
                'fr'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '05-01': {
                    _name: '05-01'
                },
                '05-08': {
                    name: {
                        fr: "F\xeate de la Victoire 1945",
                        en: 'Victory Day'
                    }
                },
                'easter 39': {
                    _name: 'easter 39'
                },
                'easter 49': {
                    _name: 'easter 49',
                    type: 'observance'
                },
                'easter 50': {
                    _name: 'easter 50'
                },
                'sunday before 06-01': {
                    _name: 'Mothers Day',
                    type: 'observance'
                },
                '07-14': {
                    name: {
                        fr: "F\xeate Nationale de la France",
                        en: 'Bastille Day'
                    }
                },
                '08-15': {
                    _name: '08-15'
                },
                '11-01': {
                    _name: '11-01'
                },
                '11-11': {
                    name: {
                        fr: 'Armistice 1918',
                        en: 'Armistice Day'
                    }
                },
                '12-25': {
                    _name: '12-25'
                }
            },
            states: {
                57: {
                    name: "D\xe9partement Moselle",
                    days: {
                        'easter -2': {
                            _name: 'easter -2'
                        },
                        '12-26': {
                            _name: '12-26'
                        }
                    }
                },
                67: {
                    name: "D\xe9partement Bas-Rhin",
                    days: {
                        'easter -2': {
                            _name: 'easter -2'
                        },
                        '12-26': {
                            _name: '12-26'
                        }
                    }
                },
                68: {
                    name: "D\xe9partement Haut-Rhin",
                    days: {
                        'easter -2': {
                            _name: 'easter -2'
                        },
                        '12-26': {
                            _name: '12-26'
                        }
                    }
                },
                YT: {
                    name: "D\xe9partement et r\xe9gion d'outre-mer Mayotte",
                    zones: [
                        'Africa/Nairobi'
                    ],
                    _days: 'YT'
                },
                MQ: {
                    name: "D\xe9partement et r\xe9gion d'outre-mer Martinique",
                    zones: [
                        'America/Martinique'
                    ],
                    _days: 'MQ'
                },
                GP: {
                    name: "D\xe9partement et r\xe9gion d'outre-mer Guadeloupe",
                    zones: [
                        'America/Port_of_Spain'
                    ],
                    _days: 'GP'
                },
                GF: {
                    name: "D\xe9partement et r\xe9gion d'outre-mer Guyane",
                    zones: [
                        'America/Cayenne'
                    ],
                    _days: 'GF'
                },
                RE: {
                    name: "D\xe9partement et r\xe9gion d'outre-mer La R\xe9union",
                    zones: [
                        'Indian/Reunion'
                    ],
                    _days: 'RE'
                },
                MF: {
                    name: "D\xe9partement et r\xe9gion d'outre-mer Saint Martin",
                    zones: [
                        'America/Marigot'
                    ],
                    _days: 'MF'
                },
                BL: {
                    name: "D\xe9partement et r\xe9gion d'outre-mer Saint Barth\xe9lemy",
                    zones: [
                        'America/St_Barthelemy'
                    ],
                    _days: 'BL'
                }
            }
        },
        GA: {
            names: {
                fr: 'Gabon',
                en: 'Gabon'
            },
            dayoff: 'sunday',
            langs: [
                'fr'
            ],
            zones: [
                'Africa/Lagos'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '04-17': {
                    name: {
                        fr: "Journ\xe9e des droits de la femme",
                        en: "Women's Day"
                    }
                },
                '05-01': {
                    _name: '05-01'
                },
                'easter 50': {
                    _name: 'easter 50'
                },
                '08-15': {
                    _name: '08-15'
                },
                '08-16 P2D': {
                    _name: 'Independence Day'
                },
                '11-01': {
                    _name: '11-01'
                },
                '12-25': {
                    _name: '12-25'
                },
                '1 Shawwal': {
                    _name: '1 Shawwal'
                },
                '10 Dhu al-Hijjah': {
                    _name: '10 Dhu al-Hijjah'
                }
            }
        },
        GB: {
            names: {
                en: 'United Kingdom'
            },
            dayoff: 'sunday',
            zones: [
                'Europe/London'
            ],
            langs: [
                'en'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                'substitutes 01-01 if sunday then next monday': {
                    substitute: true,
                    _name: '01-01'
                },
                'substitutes 01-01 if saturday then next monday': {
                    substitute: true,
                    _name: '01-01'
                },
                'easter -21': {
                    _name: 'Mothers Day',
                    type: 'observance'
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                easter: {
                    _name: 'easter',
                    type: 'observance'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '1st monday in May': {
                    name: {
                        en: 'Early May bank holiday'
                    },
                    disable: [
                        '2020-05-04'
                    ]
                },
                '1st monday before 06-01': {
                    name: {
                        en: 'Spring bank holiday'
                    },
                    disable: [
                        '2022-05-30'
                    ],
                    enable: [
                        '2022-06-02'
                    ]
                },
                '12-25': {
                    _name: '12-25'
                },
                'substitutes 12-25 if saturday then next monday if sunday then next tuesday': {
                    substitute: true,
                    _name: '12-25'
                },
                '12-26': {
                    _name: '12-26'
                },
                'substitutes 12-26 if saturday then next monday if sunday then next tuesday': {
                    substitute: true,
                    _name: '12-26'
                },
                '2012-06-05': {
                    name: {
                        en: "Queen\u2019s Diamond Jubilee"
                    }
                },
                '2020-05-08': {
                    name: {
                        en: 'Early May bank holiday (VE day)'
                    }
                },
                '2022-06-03': {
                    name: {
                        en: "Queen\u2019s Platinum Jubilee"
                    }
                },
                '2022-09-19': {
                    name: {
                        en: "Queen Elizabeth's Funeral Day"
                    }
                },
                '2023-05-08': {
                    name: {
                        en: "King Charles III's Coronation"
                    }
                },
                '3rd sunday in June': {
                    _name: 'Fathers Day',
                    type: 'observance'
                }
            },
            states: {
                ALD: {
                    name: 'Alderney',
                    zones: [
                        'Europe/Guernsey'
                    ],
                    days: {
                        '12-15': {
                            name: {
                                en: 'Homecoming Day'
                            }
                        }
                    }
                },
                ENG: {
                    name: 'England',
                    days: {
                        '1st monday before 09-01': {
                            name: {
                                en: 'Summer bank holiday'
                            }
                        }
                    }
                },
                NIR: {
                    name: 'Northern Ireland',
                    zones: [
                        'Europe/Belfast'
                    ],
                    days: {
                        '03-17': {
                            name: {
                                en: "St Patrick's Day"
                            }
                        },
                        'substitutes 03-17 if saturday then next monday': {
                            substitute: true,
                            name: {
                                en: "St Patrick's Day"
                            }
                        },
                        'substitutes 03-17 if sunday then next monday': {
                            substitute: true,
                            name: {
                                en: "St Patrick's Day"
                            }
                        },
                        '07-12': {
                            name: {
                                en: "Battle of the Boyne, Orangemen\u2019s Day"
                            }
                        },
                        'substitutes 07-12 if saturday then next monday': {
                            substitute: true,
                            name: {
                                en: 'Battle of the Boyne'
                            }
                        },
                        'substitutes 07-12 if sunday then next monday': {
                            substitute: true,
                            name: {
                                en: 'Battle of the Boyne'
                            }
                        },
                        '1st monday before 09-01': {
                            name: {
                                en: 'Summer bank holiday'
                            }
                        }
                    }
                },
                SCT: {
                    name: 'Scotland',
                    days: {
                        'substitutes 01-01 if sunday then next monday': false,
                        'substitutes 01-01 if saturday then next monday': false,
                        'substitutes 01-01 if saturday then next tuesday': {
                            substitute: true,
                            _name: '01-01'
                        },
                        'substitutes 01-01 if sunday then next tuesday': {
                            substitute: true,
                            _name: '01-01'
                        },
                        '01-02': {
                            name: {
                                en: 'January 2nd'
                            }
                        },
                        'substitutes 01-02 if saturday then next monday': {
                            substitute: true,
                            name: {
                                en: 'January 2nd'
                            }
                        },
                        'substitutes 01-02 if sunday then next monday': {
                            substitute: true,
                            name: {
                                en: 'January 2nd'
                            }
                        },
                        'easter 1': {
                            _name: 'easter 1'
                        },
                        '1st monday in August': {
                            name: {
                                en: 'Summer bank holiday'
                            }
                        },
                        '11-30': {
                            name: {
                                en: "St Andrew\u2019s Day"
                            }
                        },
                        'substitutes 11-30 if saturday, sunday then next monday': {
                            substitute: true,
                            name: {
                                en: "St Andrew\u2019s Day"
                            }
                        }
                    }
                },
                WLS: {
                    name: 'Wales',
                    days: {
                        '1st monday before 09-01': {
                            name: {
                                en: 'Summer bank holiday'
                            }
                        }
                    },
                    regions: {}
                }
            }
        },
        GD: {
            names: {
                en: 'Grenada'
            },
            dayoff: 'sunday',
            langs: [
                'en'
            ],
            zones: [
                'America/Port_of_Spain'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '02-07': {
                    _name: 'Independence Day'
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                easter: {
                    _name: 'easter',
                    type: 'observance'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '04-24 P3D': {
                    name: {
                        en: 'Carriacou Maroon and String Band Music Festival'
                    },
                    type: 'observance'
                },
                '05-01': {
                    _name: '05-01'
                },
                'easter 49': {
                    _name: 'easter 49',
                    type: 'observance'
                },
                'easter 50': {
                    _name: 'easter 50'
                },
                'easter 60': {
                    _name: 'easter 60'
                },
                '1st monday in August': {
                    name: {
                        en: 'Emancipation Day'
                    }
                },
                '2nd monday in August': {
                    name: {
                        en: 'Carnival Monday'
                    }
                },
                'tuesday after 2nd monday in August': {
                    name: {
                        en: 'Carnival Tuesday'
                    }
                },
                '09-01': {
                    name: {
                        en: 'Kirani Day'
                    },
                    type: 'observance'
                },
                '10-15 P5D': {
                    name: {
                        en: 'Aunty Tek Spice Word Festival'
                    },
                    type: 'observance'
                },
                '10-25': {
                    name: {
                        en: 'Thanksgiving Day'
                    }
                },
                '12-04 P3D': {
                    name: {
                        en: 'Camerhogne Folk Festival'
                    },
                    type: 'observance'
                },
                '12-25': {
                    _name: '12-25'
                },
                '12-26': {
                    _name: '12-26'
                }
            }
        },
        GE: {
            names: {
                ge: "\u10E1\u10D0\u10E5\u10D0\u10E0\u10D7\u10D5\u10D4\u10DA\u10DD",
                en: 'Georgia'
            },
            langs: [
                'ge'
            ],
            zones: [
                'Asia/Tbilisi'
            ],
            dayoff: 'sunday',
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '01-02': {
                    name: {
                        ge: "\u10D1\u10D4\u10D3\u10DD\u10D1\u10D0",
                        en: 'Bedoba'
                    }
                },
                '01-07': {
                    name: {
                        ge: "\u10E8\u10DD\u10D1\u10D0",
                        en: 'Orthodox Christmas'
                    }
                },
                '01-19': {
                    name: {
                        ge: "\u10DC\u10D0\u10D7\u10DA\u10D8\u10E1\u10E6\u10D4\u10D1\u10D0",
                        en: 'Orthodox Epiphany'
                    }
                },
                '03-03': {
                    name: {
                        ge: "\u10D3\u10D4\u10D3\u10D8\u10E1 \u10D3\u10E6\u10D4",
                        en: "Mother's Day"
                    }
                },
                '03-08': {
                    _name: '03-08'
                },
                '04-09': {
                    name: {
                        ge: "\u10D4\u10E0\u10DD\u10D5\u10DC\u10E3\u10DA\u10D8 \u10D4\u10E0\u10D7\u10D8\u10D0\u10DC\u10DD\u10D1\u10D8\u10E1 \u10D3\u10E6\u10D4",
                        en: 'National Unity Day'
                    }
                },
                'orthodox -2': {
                    _name: 'easter -2'
                },
                'orthodox -1': {
                    _name: 'easter -1'
                },
                orthodox: {
                    _name: 'easter'
                },
                'orthodox 1': {
                    _name: 'easter 1'
                },
                '05-09': {
                    name: {
                        ge: "\u10E4\u10D0\u10E8\u10D8\u10D6\u10DB\u10D6\u10D4 \u10D2\u10D0\u10DB\u10D0\u10E0\u10EF\u10D5\u10D4\u10D1\u10D8\u10E1 \u10D3\u10E6\u10D4",
                        en: 'Victory Day'
                    }
                },
                '05-12': {
                    name: {
                        ge: "\u10EC\u10DB\u10D8\u10DC\u10D3\u10D0 \u10D0\u10DC\u10D3\u10E0\u10D8\u10D0 \u10DE\u10D8\u10E0\u10D5\u10D4\u10DA\u10EC\u10DD\u10D3\u10D4\u10D1\u10E3\u10DA\u10D8\u10E1 \u10EE\u10E1\u10D4\u10DC\u10D4\u10D1\u10D8\u10E1 \u10D3\u10E6\u10D4",
                        en: 'Saint Andrew the First-Called Day'
                    }
                },
                '05-26': {
                    name: {
                        ge: "\u10D3\u10D0\u10DB\u10DD\u10E3\u10D9\u10D8\u10D3\u10D4\u10D1\u10DA\u10DD\u10D1\u10D8\u10E1 \u10D3\u10E6\u10D4",
                        en: 'Independence Day'
                    }
                },
                '08-28': {
                    name: {
                        ge: "\u10DB\u10D0\u10E0\u10D8\u10D0\u10DB\u10DD\u10D1\u10D0",
                        en: "Saint Mary's Day"
                    }
                },
                '10-14': {
                    name: {
                        ge: "\u10E1\u10D5\u10D4\u10E2\u10D8\u10EA\u10EE\u10DD\u10D5\u10DA\u10DD\u10D1\u10D0",
                        en: 'Svetitskhovloba'
                    }
                },
                '11-23': {
                    name: {
                        ge: "\u10D2\u10D8\u10DD\u10E0\u10D2\u10DD\u10D1\u10D0",
                        en: "Saint George's Day"
                    }
                }
            }
        },
        GF: {
            names: {
                fr: 'Guyane',
                en: 'French Guiana'
            },
            langs: [
                'fr'
            ],
            zones: [
                'America/Cayenne'
            ],
            dayoff: 'sunday',
            _days: 'FR',
            days: {
                '06-10': {
                    _name: 'Abolition of Slavery'
                }
            }
        },
        GG: {
            names: {
                en: 'Guernsey'
            },
            dayoff: 'sunday',
            zones: [
                'Europe/Guernsey'
            ],
            langs: [
                'en'
            ],
            _days: [
                'GB'
            ],
            days: {
                '05-09': {
                    name: {
                        en: 'Liberation Day'
                    }
                }
            }
        },
        GH: {
            names: {
                en: 'Ghana'
            },
            langs: [
                'en'
            ],
            zones: [
                'Africa/Accra'
            ],
            dayoff: '',
            days: {
                '01-01 and if Saturday, Sunday then next Monday': {
                    substitute: true,
                    _name: '01-01'
                },
                '01-07 since 2019': {
                    _name: 'Constitution Day'
                },
                '03-06 and if Saturday, Sunday then next Monday': {
                    substitute: true,
                    _name: 'Independence Day'
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                easter: {
                    _name: 'easter',
                    type: 'observance'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '05-01 and if Saturday, Sunday then next Monday': {
                    substitute: true,
                    _name: '05-01'
                },
                '08-04 and if Saturday, Sunday then next Monday': {
                    substitute: true,
                    name: {
                        en: 'Founders Day'
                    }
                },
                '09-21 and if Saturday, Sunday then next Monday': {
                    substitute: true,
                    name: {
                        en: 'Kwame Nkrumah Memorial Day'
                    }
                },
                '1st Friday in December since 1988': {
                    name: {
                        en: 'Farmers Day'
                    }
                },
                '12-25 and if Saturday then next Monday if Sunday then next Tuesday': {
                    substitute: true,
                    _name: '12-25'
                },
                '12-26 and if Saturday then next Monday if Sunday then next Tuesday': {
                    substitute: true,
                    _name: '12-26'
                },
                '1 Shawwal and if Saturday, Sunday then next Monday': {
                    substitute: true,
                    _name: '1 Shawwal'
                },
                '10 Dhu al-Hijjah and if Saturday, Sunday then next Monday': {
                    substitute: true,
                    _name: '10 Dhu al-Hijjah'
                }
            }
        },
        GI: {
            names: {
                en: 'Gibraltar'
            },
            langs: [
                'en'
            ],
            zones: [
                'Europe/Gibraltar'
            ],
            dayoff: 'sunday',
            _days: 'GB',
            days: {
                '2nd monday in March': {
                    name: {
                        en: 'Commonwealth Day'
                    }
                },
                easter: {
                    _name: 'easter',
                    type: 'observance'
                },
                '04-28': {
                    name: {
                        en: 'Workers Memorial Day'
                    },
                    disable: [
                        '2015-04-28'
                    ],
                    enable: [
                        '2015-04-27'
                    ]
                },
                '05-01 if sunday, saturday then next monday': {
                    substitute: true,
                    name: {
                        en: 'May Day'
                    }
                },
                '1st monday in May': false,
                '2020-05-08': {
                    name: {
                        en: 'Victory in Europe Day (VE Day)'
                    }
                },
                'monday before 06-20': {
                    name: {
                        en: "Queen's Birthday"
                    }
                },
                'monday before September': {
                    name: {
                        en: 'Late Summer Bank Holiday'
                    }
                },
                '09-10': {
                    name: {
                        en: 'Gibraltar National Day'
                    },
                    active: [
                        {
                            to: 2015
                        }
                    ]
                },
                '09-10 and if sunday, saturday then previous monday': {
                    substitute: true,
                    name: {
                        en: 'Gibraltar National Day'
                    },
                    active: [
                        {
                            from: 2015
                        }
                    ]
                }
            }
        },
        GL: {
            names: {
                kl: 'Kalaallit Nunaat',
                da: "Gr\xf8nland",
                en: 'Greenland'
            },
            langs: [
                'kl',
                'da'
            ],
            zones: [
                'America/Godthab',
                'America/Danmarkshavn',
                'America/Scoresbysund',
                'America/Thule'
            ],
            dayoff: 'sunday',
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '01-06': {
                    _name: '01-06'
                },
                'easter -3': {
                    _name: 'easter -3'
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                easter: {
                    _name: 'easter'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                'easter 26': {
                    name: {
                        kl: 'tussiarfissuaq',
                        da: 'Store Bededag',
                        en: 'Prayer Day'
                    }
                },
                'easter 39': {
                    _name: 'easter 39'
                },
                '06-21': {
                    name: {
                        kl: 'ullortuneq',
                        da: 'Nationaldag',
                        en: 'National Day'
                    }
                },
                'easter 49': {
                    _name: 'easter 49'
                },
                'easter 50': {
                    _name: 'easter 50'
                },
                '12-24': {
                    _name: '12-24'
                },
                '12-25': {
                    _name: '12-25'
                },
                '12-26': {
                    _name: '12-26'
                }
            }
        },
        GM: {
            names: {
                en: 'The Gambia'
            },
            langs: [
                'en'
            ],
            zones: [
                'Africa/Abidjan'
            ],
            dayoff: '',
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '02-18': {
                    _name: 'Independence Day'
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                easter: {
                    _name: 'easter',
                    type: 'observance'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '05-01': {
                    _name: '05-01'
                },
                '05-25': {
                    name: {
                        en: 'Africa Day'
                    }
                },
                '07-22': {
                    name: {
                        en: 'Revolution Day'
                    }
                },
                '08-15': {
                    _name: '08-15'
                },
                '12-25': {
                    _name: '12-25'
                },
                '10 Muharram': {
                    _name: '10 Muharram'
                },
                '12 Rabi al-awwal': {
                    _name: '12 Rabi al-awwal'
                },
                '23 Ramadan': {
                    _name: '23 Ramadan'
                },
                '1 Shawwal': {
                    _name: '1 Shawwal',
                    name: {
                        en: "Korit\xe9"
                    }
                },
                '10 Dhu al-Hijjah': {
                    _name: '10 Dhu al-Hijjah',
                    name: {
                        en: 'Tabaski'
                    }
                }
            }
        },
        GN: {
            names: {
                fr: "Guin\xe9e",
                en: 'Guinea'
            },
            langs: [
                'fr'
            ],
            zones: [
                'Africa/Abidjan'
            ],
            dayoff: 'sunday',
            days: {
                '01-01': {
                    _name: '01-01'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '04-03': {
                    name: {
                        fr: "F\xeate Nationale de la deuxi\xe8me R\xe9publique",
                        en: 'National Holiday'
                    }
                },
                '05-01': {
                    _name: '05-01'
                },
                '05-25': {
                    name: {
                        fr: "Anniversaire de l'Organisation de l'unit\xe9 africaine (OUA)",
                        en: 'Africa Day'
                    }
                },
                '27 Ramadan': {
                    _name: '27 Ramadan'
                },
                '1 Shawwal': {
                    _name: '1 Shawwal'
                },
                '10 Dhu al-Hijjah': {
                    _name: '10 Dhu al-Hijjah'
                },
                '08-15': {
                    _name: '08-15'
                },
                '10-02': {
                    _name: 'Independence Day'
                },
                '12-25': {
                    _name: '12-25'
                },
                '12 Rabi al-awwal': {
                    _name: '12 Rabi al-awwal'
                }
            }
        },
        GP: {
            names: {
                fr: 'Guadeloupe',
                en: 'Guadeloupe'
            },
            langs: [
                'fr'
            ],
            zones: [
                'America/Port_of_Spain'
            ],
            dayoff: 'sunday',
            _days: 'FR',
            days: {
                'easter 49': false,
                'easter -2': {
                    _name: 'easter -2'
                },
                '05-27': {
                    _name: 'Abolition of Slavery'
                },
                '07-21': {
                    name: {
                        fr: 'Jour de Victor Shoelcher',
                        en: 'Victor Shoelcher Day'
                    }
                }
            }
        },
        GQ: {
            names: {
                es: "Rep\xfablica de Guinea Ecuatorial",
                fr: "R\xe9publique de Guin\xe9e \xe9quatoriale",
                pt: "Rep\xfablica da Guin\xe9 Equatorial",
                en: 'Republic of Equatorial Guinea'
            },
            dayoff: 'sunday',
            weekend: [
                'saturday',
                'sunday'
            ],
            langs: [
                'es',
                'fr',
                'pt'
            ],
            zones: [
                'Africa/Lagos'
            ],
            days: {
                '01-01 and if sunday then next monday': {
                    substitute: true,
                    _name: '01-01'
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                '05-01 and if sunday then next monday': {
                    substitute: true,
                    _name: '05-01'
                },
                'easter 60': {
                    _name: 'easter 60'
                },
                '06-05 and if sunday then next monday': {
                    substitute: true,
                    name: {
                        es: 'Natalicio de Teodoro Obiang',
                        en: "President's Day"
                    }
                },
                '08-03 and if sunday then next monday': {
                    substitute: true,
                    name: {
                        es: "D\xeda del Golpe de Libertad",
                        en: 'Armed Forces Day'
                    }
                },
                '08-15 and if sunday then next monday': {
                    substitute: true,
                    _name: 'Constitution Day'
                },
                '10-12 and if sunday then next monday': {
                    substitute: true,
                    _name: 'Independence Day'
                },
                '12-08 and if sunday then next monday': {
                    substitute: true,
                    _name: '12-08'
                },
                '12-25 and if sunday then next monday': {
                    substitute: true,
                    _name: '12-25'
                }
            }
        },
        GR: {
            names: {
                el: "\u0395\u03BB\u03BB\u03AC\u03B4\u03B1",
                en: 'Greece'
            },
            dayoff: 'sunday',
            zones: [
                'Europe/Athens'
            ],
            langs: [
                'el'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '01-06': {
                    _name: '01-06'
                },
                'orthodox -48': {
                    name: {
                        el: "\u039A\u03B1\u03B8\u03B1\u03C1\u03AC \u0394\u03B5\u03C5\u03C4\u03AD\u03C1\u03B1",
                        en: 'Ash Sunday'
                    }
                },
                '03-25': {
                    name: {
                        el: "\u0395\u03C5\u03B1\u03B3\u03B3\u03B5\u03BB\u03B9\u03C3\u03BC\u03CC\u03C2, \u0395\u03B8\u03BD\u03B9\u03BA\u03AE \u0395\u03BF\u03C1\u03C4\u03AE",
                        en: 'Annunciation, Anniversary of 1821 Revolution'
                    }
                },
                'orthodox -2': {
                    _name: 'easter -2'
                },
                orthodox: {
                    _name: 'easter'
                },
                'orthodox 1': {
                    _name: 'easter 1'
                },
                '05-01': {
                    _name: '05-01'
                },
                'orthodox 49': {
                    _name: 'easter 49'
                },
                'orthodox 50': {
                    _name: 'easter 50'
                },
                '2nd sunday in May': {
                    _name: 'Mothers Day',
                    type: 'observance'
                },
                '08-15': {
                    _name: '08-15'
                },
                '10-28': {
                    _name: 'National Holiday',
                    name: {
                        el: "\u0395\u03C0\u03AD\u03C4\u03B5\u03B9\u03BF\u03C2 \u03C4\u03BF\u03C5 \u038C\u03C7\u03B9"
                    }
                },
                '12-25': {
                    _name: '12-25'
                },
                '12-26': {
                    _name: '12-26'
                }
            }
        },
        GT: {
            names: {
                es: 'Guatemala',
                en: 'Guatemala'
            },
            dayoff: 'sunday',
            langs: [
                'es'
            ],
            zones: [
                'America/Guatemala'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                'easter -3': {
                    _name: 'easter -3'
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                'easter -1': {
                    _name: 'easter -1'
                },
                easter: {
                    _name: 'easter',
                    type: 'observance'
                },
                '05-01': {
                    _name: '05-01'
                },
                '06-30 if tuesday then previous monday if wednesday,thursday then next friday': {
                    name: {
                        es: "D\xeda de las Fuerzas Armadas",
                        en: 'Army Day'
                    }
                },
                '09-15': {
                    _name: 'Independence Day'
                },
                '10-20': {
                    _name: 'Revolution Day'
                },
                '11-01': {
                    _name: '11-01'
                },
                '12-24 12:00': {
                    _name: '12-24'
                },
                '12-25': {
                    _name: '12-25'
                },
                '12-31 12:00': {
                    _name: '12-31'
                }
            }
        },
        GU: {
            names: {
                en: 'Guam'
            },
            dayoff: 'sunday',
            langs: [
                'en-us',
                'en'
            ],
            zones: [
                'Pacific/Guam'
            ],
            _days: [
                'US'
            ],
            days: {
                '3rd monday in February': false,
                '03-17': false,
                '1st monday in March': {
                    name: {
                        en: 'Guam History and Chamorro Heritage Day'
                    }
                },
                'easter -2': {
                    _name: 'easter -2',
                    type: 'observance'
                },
                '07-21 if sunday then next monday': {
                    name: {
                        en: 'Liberation Day'
                    }
                },
                '11-02': {
                    _name: '11-02'
                },
                '12-08 if sunday then next monday': {
                    name: {
                        en: 'Our Lady of Camarin Day'
                    }
                }
            }
        },
        GW: {
            names: {
                pt: "Guin\xe9-Bissau",
                en: 'Guinea-Bissau'
            },
            langs: [
                'pt'
            ],
            zones: [
                'Africa/Bissau'
            ],
            dayoff: '',
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '01-20': {
                    name: {
                        pt: "Dia dos her\xf3is",
                        en: 'Heroes Day'
                    }
                },
                '03-08': {
                    _name: '03-08'
                },
                '05-01': {
                    _name: '05-01'
                },
                '08-03': {
                    name: {
                        pt: 'Pidjiguiti Day'
                    }
                },
                '09-24': {
                    _name: 'Independence Day'
                },
                '11-14': {
                    name: {
                        pt: 'Dia do Movimento de Reajustamento',
                        en: 'Readjustment Movement Day'
                    }
                },
                '12-25': {
                    _name: '12-25'
                },
                '1 Shawwal': {
                    _name: '1 Shawwal'
                },
                '10 Dhu al-Hijjah': {
                    _name: '10 Dhu al-Hijjah'
                }
            }
        },
        GY: {
            names: {
                en: 'Guyana'
            },
            coord: {
                lat: 6.8045,
                lng: -58.1553
            },
            dayoff: 'sunday',
            langs: [
                'en'
            ],
            zones: [
                'America/Guyana'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '02-23': {
                    name: {
                        en: 'Republic Day'
                    }
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '05-01': {
                    _name: '05-01'
                },
                '05-05': {
                    name: {
                        en: 'Arrival Day'
                    }
                },
                '05-26': {
                    _name: 'Independence Day'
                },
                'monday after 07-01': {
                    name: {
                        en: 'CARICOM Day'
                    }
                },
                '08-01': {
                    name: {
                        en: 'Emancipation Day'
                    }
                },
                '12-25': {
                    _name: '12-25'
                },
                '12-26': {
                    _name: '12-26'
                },
                '12 Rabi al-awwal': {
                    _name: '12 Rabi al-awwal',
                    name: {
                        en: 'Youman Nabi'
                    },
                    note: 'tentative',
                    disable: [
                        '2016-12-11',
                        '2015-12-23',
                        '2013-01-24'
                    ],
                    enable: [
                        '2016-12-12',
                        '2015-12-24',
                        '2013-01-23'
                    ]
                },
                '10 Dhu al-Hijjah': {
                    _name: '10 Dhu al-Hijjah',
                    name: {
                        en: 'Eid Ul Adha'
                    },
                    note: 'tentative',
                    disable: [
                        '2015-09-23'
                    ],
                    enable: [
                        '2015-09-24'
                    ]
                },
                '2015-03-05': {
                    name: {
                        en: 'Phagwah'
                    }
                },
                '2016-03-23': {
                    name: {
                        en: 'Phagwah'
                    }
                },
                '2017-03-12': {
                    name: {
                        en: 'Phagwah'
                    }
                },
                '2017-03-13': {
                    substitute: true,
                    name: {
                        en: 'Phagwah'
                    }
                },
                '2018-03-02': {
                    name: {
                        en: 'Phagwah'
                    }
                },
                '2019-03-21': {
                    name: {
                        en: 'Phagwah'
                    }
                },
                '2020-03-10': {
                    name: {
                        en: 'Phagwah'
                    }
                },
                '2021-03-29': {
                    name: {
                        en: 'Phagwah'
                    }
                },
                '2022-03-18': {
                    name: {
                        en: 'Phagwah'
                    }
                },
                '2023-03-07': {
                    name: {
                        en: 'Phagwah'
                    }
                },
                '2024-03-25': {
                    name: {
                        en: 'Phagwah'
                    }
                },
                '2015-11-11': {
                    name: {
                        en: 'Deepavali'
                    }
                },
                '2017-10-18': {
                    name: {
                        en: 'Deepavali'
                    }
                },
                '2018-11-07': {
                    name: {
                        en: 'Deepavali'
                    }
                },
                '2019-10-27': {
                    name: {
                        en: 'Deepavali'
                    }
                },
                '2019-10-28': {
                    substitute: true,
                    name: {
                        en: 'Deepavali'
                    }
                },
                '2020-11-14': {
                    name: {
                        en: 'Deepavali'
                    }
                },
                '2021-11-04': {
                    name: {
                        en: 'Deepavali'
                    }
                },
                '2022-10-24': {
                    name: {
                        en: 'Deepavali'
                    }
                },
                '2023-11-12': {
                    name: {
                        en: 'Deepavali'
                    }
                },
                '2023-11-13': {
                    substitute: true,
                    name: {
                        en: 'Deepavali'
                    }
                },
                '2024-10-31': {
                    name: {
                        en: 'Deepavali'
                    }
                }
            }
        },
        HK: {
            names: {
                zh: "\u9999\u6E2F",
                en: 'Hong Kong'
            },
            langs: [
                'zh',
                'en'
            ],
            zones: [
                'Asia/Hong_Kong'
            ],
            dayoff: 'sunday',
            days: {
                '01-01 and if Sunday then next Monday': {
                    substitute: true,
                    _name: '01-01',
                    name: {
                        zh: "\u4E00\u6708\u4E00\u65E5"
                    }
                },
                'chinese 01-0-01 and if Saturday then next Tuesday': {
                    name: {
                        en: 'Lunar New Year',
                        zh: "\u8FB2\u66C6\u5E74\u521D\u4E00"
                    }
                },
                'chinese 01-0-02 and if Saturday then next Monday': {
                    name: {
                        en: 'The second day of the Lunar New Year',
                        zh: "\u8FB2\u66C6\u5E74\u521D\u4E8C"
                    }
                },
                'chinese 01-0-03 and if Saturday then next Monday': {
                    name: {
                        en: 'The third day of the Lunar New Year',
                        zh: "\u8FB2\u66C6\u5E74\u521D\u4E09"
                    }
                },
                'chinese 5-01 solarterm and if Sunday then next Monday': {
                    name: {
                        en: 'Qingming Festival',
                        zh: "\u6E05\u660E\u7BC0"
                    }
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                'easter -1': {
                    _name: 'easter -1'
                },
                easter: {
                    _name: 'easter'
                },
                'easter 1': {
                    _name: 'easter 1',
                    disable: [
                        '2021-04-05'
                    ],
                    enable: [
                        '2021-04-06'
                    ]
                },
                '05-01 and if Sunday then next Monday': {
                    substitute: true,
                    _name: '05-01'
                },
                'chinese 04-0-08 and if Sunday then next Monday': {
                    name: {
                        en: 'Birthday of the Buddha',
                        zh: "\u4F5B\u8A95"
                    }
                },
                'chinese 05-0-05': {
                    name: {
                        en: 'Dragon Boat Festival',
                        zh: "\u7AEF\u5348\u8282"
                    }
                },
                '07-01 and if Sunday then next Monday': {
                    substitute: true,
                    name: {
                        en: 'Hong Kong Special Administrative Region Establishment Day',
                        zh: "\u9999\u6E2F\u7279\u5225\u884C\u653F\u5340\u6210\u7ACB\u7D00\u5FF5\u65E5"
                    }
                },
                'chinese 08-0-16 and if Sunday then next Monday if is public holiday then next day omit Saturday, Sunday': {
                    substitute: true,
                    name: {
                        en: 'The day following the Chinese Mid-Autumn Festival',
                        zh: "\u4E2D\u79CB\u7BC0\u7FCC\u65E5"
                    }
                },
                '10-01 and if Sunday then next Monday': {
                    substitute: true,
                    name: {
                        en: 'National Day',
                        zh: "\u570B\u6176\u65E5"
                    }
                },
                'chinese 09-0-09 and if Sunday then next Monday': {
                    substitute: true,
                    name: {
                        en: 'Chung Yeung Festival',
                        zh: "\u91CD\u9633\u8282"
                    }
                },
                '12-25 and if Sunday then next Monday': {
                    substitute: true,
                    _name: '12-25'
                },
                '12-26 and if Sunday then next Monday if Monday then next Tuesday': {
                    substitute: true,
                    name: {
                        en: 'The first weekday after Christmas Day',
                        zh: "\u5723\u8BDE\u8282\u540E\u7684\u7B2C\u4E00\u4E2A\u5DE5\u4F5C\u65E5"
                    }
                }
            }
        },
        HN: {
            names: {
                es: 'Honduras',
                en: 'Honduras'
            },
            dayoff: 'sunday',
            langs: [
                'es'
            ],
            zones: [
                'America/Tegucigalpa'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '03-19': {
                    _name: 'Fathers Day',
                    type: 'observance'
                },
                'easter -3': {
                    _name: 'easter -3'
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                easter: {
                    _name: 'easter',
                    type: 'observance'
                },
                '04-14': {
                    name: {
                        es: "D\xeda de las Am\xe9ricas"
                    }
                },
                '05-01': {
                    _name: '05-01'
                },
                '2nd monday in May': {
                    _name: 'Mothers Day',
                    type: 'observance'
                },
                '06-11': {
                    name: {
                        en: "Pupil's Day",
                        es: "D\xeda del Estudiante"
                    },
                    type: 'observance'
                },
                '09-10': {
                    name: {
                        en: "Children's Day",
                        es: "D\xeda del Ni\xf1o"
                    },
                    type: 'observance'
                },
                '09-15': {
                    _name: 'Independence Day'
                },
                '09-17': {
                    name: {
                        en: "Teacher's Day",
                        es: "D\xeda del Maestro"
                    },
                    type: 'observance'
                },
                '10-03': {
                    name: {
                        en: "Soldier's Day",
                        es: "D\xeda del Soldado"
                    }
                },
                '10-12': {
                    name: {
                        es: "D\xeda de la Raza",
                        en: 'Columbus Day'
                    }
                },
                '10-21': {
                    name: {
                        es: "D\xeda de las Fuerzas Armadas",
                        en: 'Armed forces Day'
                    }
                },
                '12-25': {
                    _name: '12-25'
                }
            }
        },
        HR: {
            names: {
                hr: 'Hrvatska',
                en: 'Croatia'
            },
            langs: [
                'hr'
            ],
            zones: [
                'Europe/Belgrade'
            ],
            days: {
                '01-01': {
                    _name: '01-01',
                    type: 'public'
                },
                '01-06': {
                    _name: '01-06',
                    type: 'public'
                },
                'easter -47': {
                    _name: 'easter -47',
                    type: 'observance'
                },
                easter: {
                    _name: 'easter',
                    type: 'public'
                },
                'easter 1': {
                    _name: 'easter 1',
                    type: 'public'
                },
                'easter 60': {
                    _name: 'easter 60',
                    type: 'public'
                },
                '03-08': {
                    _name: '03-08',
                    type: 'observance'
                },
                '05-01': {
                    _name: '05-01',
                    type: 'public'
                },
                '05-30': {
                    name: {
                        hr: "Dan dr\u017Eavnosti",
                        en: 'National Day'
                    },
                    type: 'public',
                    active: [
                        {
                            from: '2020-01-01'
                        }
                    ]
                },
                '2nd sunday in May': {
                    _name: 'Mothers Day',
                    type: 'observance'
                },
                '06-22': {
                    name: {
                        hr: "Dan antifa\u0161isti\u010Dke borbe",
                        en: 'Anti-Fascist Struggle Day'
                    },
                    type: 'public'
                },
                '06-25 #1': {
                    name: {
                        hr: "Dan dr\u017Eavnosti",
                        en: 'Statehood Day'
                    },
                    type: 'public',
                    active: [
                        {
                            to: '2020-01-01'
                        }
                    ]
                },
                '06-25': {
                    name: {
                        hr: 'Dan neovisnosti',
                        en: 'Independence Day'
                    },
                    type: 'observance',
                    active: [
                        {
                            from: '2020-01-01'
                        }
                    ]
                },
                '08-05': {
                    name: {
                        hr: 'Dan pobjede i domovinske zahvalnosti i Dan hrvatskih branitelja',
                        en: 'Victory and Homeland Thanksgiving Day and the Day of Croatian defenders'
                    },
                    type: 'public'
                },
                '08-15': {
                    _name: '08-15',
                    type: 'public'
                },
                '10-08 #1': {
                    name: {
                        hr: 'Dan neovisnosti',
                        en: 'Independence Day'
                    },
                    type: 'public',
                    active: [
                        {
                            to: '2020-01-01'
                        }
                    ]
                },
                '10-08': {
                    name: {
                        hr: 'Dan Hrvatskoga sabora',
                        en: 'Day of the Croatian Parliament'
                    },
                    type: 'observence',
                    active: [
                        {
                            from: '2020-01-01'
                        }
                    ]
                },
                '11-01': {
                    _name: '11-01',
                    type: 'public'
                },
                '11-18 #1': {
                    name: {
                        hr: "Dan sje\u0107anja na \u017Ertvu Vukovara i \u0160kabrnje",
                        en: 'Remembrance Day'
                    },
                    type: 'observance',
                    active: [
                        {
                            to: '2020-01-01'
                        }
                    ]
                },
                '11-18': {
                    name: {
                        hr: "Dan sje\u0107anja na \u017Ertve Domovinskog rata i Dan sje\u0107anja na \u017Ertvu Vukovara i \u0160kabrnje",
                        en: 'Remembrance Day'
                    },
                    type: 'public',
                    active: [
                        {
                            from: '2020-01-01'
                        }
                    ]
                },
                '12-25': {
                    _name: '12-25',
                    type: 'public'
                },
                '12-26': {
                    _name: '12-26',
                    type: 'public'
                },
                orthodox: {
                    _name: 'orthodox',
                    type: 'optional',
                    note: 'Orthodox believers (legally defined as Christians who follow the Julian Calender)'
                },
                'orthodox 1': {
                    _name: 'orthodox 1',
                    type: 'optional',
                    note: 'Orthodox believers (legally defined as Christians who follow the Julian Calender)'
                },
                'julian 12-25': {
                    _name: 'julian 12-25',
                    type: 'optional',
                    note: 'Orthodox believers (legally defined as Christians who follow the Julian Calender)'
                },
                '10 Dhu al-Hijjah': {
                    _name: '10 Dhu al-Hijjah',
                    type: 'optional',
                    note: 'Muslim believers'
                },
                '1 Shawwal': {
                    _name: '1 Shawwal',
                    type: 'optional',
                    note: 'Muslim believers'
                },
                '1 Tishrei': {
                    _name: '10 Tishrei',
                    type: 'optional',
                    note: 'Jewish believers'
                },
                '10 Tishrei': {
                    _name: '10 Tishrei',
                    type: 'optional',
                    note: 'Jewish believers'
                }
            },
            regions: {
                17: {
                    name: 'Split-Dalmatia',
                    days: {
                        '05-07': {
                            name: {
                                hr: 'Sveti Duje',
                                en: 'Saint Domnius'
                            },
                            type: 'optional'
                        }
                    }
                },
                19: {
                    name: 'Dubrovnik-Neretva',
                    days: {
                        '02-03': {
                            name: {
                                hr: 'Sveti Vlaho',
                                en: 'Saint Blaise'
                            },
                            type: 'optional'
                        }
                    }
                }
            }
        },
        HT: {
            names: {
                fr: "Ha\xefti",
                en: 'Haiti'
            },
            dayoff: 'sunday',
            langs: [
                'fr'
            ],
            zones: [
                'America/Port-au-Prince'
            ],
            days: {
                '01-01': {
                    _name: 'Independence Day'
                },
                '01-02': {
                    name: {
                        fr: 'Jour des Aieux',
                        en: 'Ancestry Day'
                    }
                },
                '01-06': {
                    _name: '01-06',
                    name: {
                        fr: 'Le Jour des Rois'
                    },
                    type: 'observance'
                },
                'easter -48 14:00': {
                    name: {
                        fr: 'Lundi Gras',
                        en: 'Lundi Gras'
                    }
                },
                'easter -47': {
                    name: {
                        fr: 'Mardi Gras',
                        en: 'Mardi Gras'
                    }
                },
                'easter -46': {
                    _name: 'easter -46',
                    type: 'observance'
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                easter: {
                    _name: 'easter'
                },
                'easter 39': {
                    _name: 'easter 39'
                },
                'easter 60': {
                    _name: 'easter 60'
                },
                '05-01': {
                    _name: '05-01'
                },
                '05-18': {
                    name: {
                        fr: "Jour du Drapeau et de l'Universit\xe9",
                        en: "Flag and Universities' Day"
                    }
                },
                '08-15': {
                    _name: '08-15'
                },
                '10-17': {
                    name: {
                        fr: 'Anniversaire de la mort de Dessalines',
                        en: 'Anniversary of the death of Dessalines'
                    }
                },
                '11-01': {
                    _name: '11-01'
                },
                '11-02': {
                    _name: '11-02'
                },
                '11-18': {
                    name: {
                        fr: "Verti\xe8res",
                        en: "Battle of Verti\xe8res Day"
                    }
                },
                '12-05': {
                    name: {
                        fr: "D\xe9couverte d'Ha\xefti",
                        en: 'Discovery Day'
                    },
                    type: 'observance'
                },
                '12-25': {
                    _name: '12-25'
                }
            }
        },
        HU: {
            names: {
                hu: "Magyarorsz\xe1g",
                en: 'Hungary'
            },
            dayoff: 'sunday',
            langs: [
                'hu'
            ],
            zones: [
                'Europe/Budapest'
            ],
            days: {
                '01-01': {
                    _name: '01-01',
                    type: 'public'
                },
                '02-01': {
                    name: {
                        hu: "A k\xf6zt\xe1rsas\xe1g eml\xe9knapja",
                        en: 'Memorial Day of the Republic'
                    },
                    type: 'observance'
                },
                '02-25': {
                    name: {
                        hu: "A kommunista diktat\xfar\xe1k \xe1ldozatainak eml\xe9knapja",
                        en: 'Memorial Day for the Victims of the Communist Dictatorships'
                    },
                    type: 'observance'
                },
                '03-08': {
                    _name: '03-08',
                    type: 'observance'
                },
                '03-15': {
                    name: {
                        hu: '1848-as forradalom',
                        en: 'National Day'
                    },
                    type: 'public'
                },
                '04-16': {
                    name: {
                        en: 'Memorial Day for the Victims of the Holocaust',
                        hu: "A holokauszt \xe1ldozatainak eml\xe9knapja"
                    },
                    type: 'observance'
                },
                'easter -2': {
                    _name: 'easter -2',
                    type: 'public',
                    active: [
                        {
                            from: '2017-01-01'
                        }
                    ]
                },
                easter: {
                    _name: 'easter',
                    type: 'public'
                },
                'easter 1': {
                    _name: 'easter 1',
                    type: 'public'
                },
                '05-01': {
                    _name: '05-01',
                    type: 'public'
                },
                '1st sunday in May': {
                    _name: 'Mothers Day',
                    type: 'observance'
                },
                '05-21': {
                    name: {
                        en: 'National Defense Day',
                        hu: "Honv\xe9delmi nap"
                    },
                    type: 'observance'
                },
                'easter 49': {
                    _name: 'easter 49',
                    type: 'public'
                },
                'easter 50': {
                    _name: 'easter 50',
                    type: 'public'
                },
                '06-04': {
                    name: {
                        en: 'Day of National Unity',
                        hu: "A nemzeti \xf6sszetartoz\xe1s napja"
                    },
                    type: 'observance'
                },
                '06-19': {
                    name: {
                        en: 'Day of the Independent Hungary',
                        hu: "A f\xfcggetlen Magyarorsz\xe1g napja"
                    },
                    type: 'observance'
                },
                '08-20': {
                    name: {
                        hu: "Szent Istv\xe1n \xfcnnepe",
                        en: "Saint Stephen's Day"
                    },
                    type: 'public'
                },
                '10-06': {
                    name: {
                        en: 'Memorial Day for the Martyrs of Arad',
                        hu: "Az aradi v\xe9rtan\xfak eml\xe9knapja"
                    },
                    type: 'observance'
                },
                '10-23': {
                    name: {
                        hu: '1956-os forradalom',
                        en: 'National Day'
                    },
                    type: 'public'
                },
                '11-01': {
                    _name: '11-01',
                    type: 'public'
                },
                '12-06': {
                    _name: '12-06',
                    type: 'observance'
                },
                '12-24': {
                    _name: '12-24',
                    type: 'optional'
                },
                '12-25': {
                    _name: '12-25',
                    type: 'public'
                },
                '12-26': {
                    _name: '12-26',
                    type: 'public'
                },
                '12-31': {
                    _name: '12-31',
                    type: 'observance'
                },
                '2023-10-30': {
                    name: {
                        hu: "\u0150szi sz\xfcnet",
                        en: 'Autumn school holiday'
                    },
                    type: 'school'
                },
                '2023-10-31': {
                    name: {
                        hu: "\u0150szi sz\xfcnet",
                        en: 'Autumn school holiday'
                    },
                    type: 'school'
                },
                '2023-11-02': {
                    name: {
                        hu: "\u0150szi sz\xfcnet",
                        en: 'Autumn school holiday'
                    },
                    type: 'school'
                },
                '2023-11-03': {
                    name: {
                        hu: "\u0150szi sz\xfcnet",
                        en: 'Autumn school holiday'
                    },
                    type: 'school'
                },
                '2023-12-22': {
                    name: {
                        hu: "T\xe9li sz\xfcnet",
                        en: 'Winter school holiday'
                    },
                    type: 'school'
                },
                '2023-12-27': {
                    name: {
                        hu: "T\xe9li sz\xfcnet",
                        en: 'Winter school holiday'
                    },
                    type: 'school'
                },
                '2024-01-02': {
                    name: {
                        hu: "T\xe9li sz\xfcnet",
                        en: 'Winter school holiday'
                    },
                    type: 'school'
                },
                '2024-01-03': {
                    name: {
                        hu: "T\xe9li sz\xfcnet",
                        en: 'Winter school holiday'
                    },
                    type: 'school'
                },
                '2024-01-04': {
                    name: {
                        hu: "T\xe9li sz\xfcnet",
                        en: 'Winter school holiday'
                    },
                    type: 'school'
                },
                '2024-01-05': {
                    name: {
                        hu: "T\xe9li sz\xfcnet",
                        en: 'Winter school holiday'
                    },
                    type: 'school'
                }
            }
        },
        IC: {
            names: {
                es: 'Islas Canarias',
                en: 'Canary Islands'
            },
            langs: [
                'es'
            ],
            zones: [
                'Atlantic/Canary'
            ],
            dayoff: 'sunday',
            _days: 'ES',
            days: {
                '05-30': {
                    name: {
                        es: "D\xeda de Canarias",
                        en: 'Canary Islands Day'
                    }
                },
                'substitutes 05-30 if Sunday then next Monday': {
                    substitute: true,
                    name: {
                        es: "D\xeda de Canarias",
                        en: 'Canary Islands Day'
                    }
                },
                'substitutes 08-15 if Sunday then next Monday': {
                    substitute: true,
                    _name: '08-15'
                }
            },
            regions: {
                EH: {
                    names: {
                        es: 'El Hierro'
                    },
                    days: {
                        '09-24': {
                            name: {
                                es: "Nuestra Se\xf1ora de los Reyes"
                            }
                        }
                    }
                },
                FU: {
                    names: {
                        es: 'Fuerteventura'
                    },
                    days: {
                        '09-18': {
                            name: {
                                es: "Nuestra Se\xf1ora de la Pe\xf1a"
                            }
                        }
                    }
                },
                GC: {
                    names: {
                        es: 'Gran Canaria'
                    },
                    days: {
                        '09-08': {
                            name: {
                                es: "Nuestra Se\xf1ora del Pino"
                            }
                        }
                    }
                },
                LG: {
                    names: {
                        es: 'La Gomera'
                    },
                    days: {
                        '10-05': {
                            name: {
                                es: "Nuestra Se\xf1ora de Guadalupe"
                            }
                        }
                    }
                },
                LP: {
                    names: {
                        es: 'La Palma'
                    },
                    days: {
                        '08-05': {
                            name: {
                                es: "Nuestra Se\xf1ora de las Nieves"
                            }
                        }
                    }
                },
                LA: {
                    names: {
                        es: 'Lanzarote'
                    },
                    days: {
                        '09-15': {
                            name: {
                                es: "Nuestra Se\xf1ora de los Dolores"
                            }
                        }
                    }
                },
                TE: {
                    names: {
                        es: 'Tenerife'
                    },
                    days: {
                        '09-07': {
                            name: {
                                es: 'La Bajada de la Virgen del Socorro'
                            }
                        }
                    }
                }
            }
        },
        ID: {
            names: {
                en: 'Indonesia',
                id: 'Indonesia'
            },
            langs: [
                'id'
            ],
            zones: [
                'Asia/Jakarta',
                'Asia/Pontianak',
                'Asia/Makassar',
                'Asia/Jayapura'
            ],
            dayoff: 'sunday',
            days: {
                '01-01': {
                    _name: '01-01'
                },
                'chinese 01-0-01': {
                    name: {
                        en: 'Chinese New Year',
                        id: 'Tahun Baru Imlek'
                    }
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                '05-01': {
                    _name: '05-01'
                },
                'easter 39': {
                    _name: 'easter 39'
                },
                '06-01': {
                    name: {
                        en: 'Pancasila Day',
                        id: 'Hari Lahir Pancasila'
                    }
                },
                '08-17': {
                    _name: 'Independence Day'
                },
                '12-25': {
                    _name: '12-25'
                },
                '1 Muharram': {
                    _name: '1 Muharram'
                },
                '12 Rabi al-awwal': {
                    _name: '12 Rabi al-awwal'
                },
                '27 Rajab': {
                    _name: '27 Rajab'
                },
                '1 Shawwal': {
                    _name: '1 Shawwal'
                },
                '2 Shawwal': {
                    _name: '1 Shawwal'
                },
                '10 Dhu al-Hijjah': {
                    _name: '10 Dhu al-Hijjah'
                },
                '2009-03-26': {
                    name: {
                        en: 'Nyepi',
                        id: 'Hari Raya Nyepi'
                    }
                },
                '2010-03-16': {
                    name: {
                        en: 'Nyepi',
                        id: 'Hari Raya Nyepi'
                    }
                },
                '2011-03-05': {
                    name: {
                        en: 'Nyepi',
                        id: 'Hari Raya Nyepi'
                    }
                },
                '2012-03-23': {
                    name: {
                        en: 'Nyepi',
                        id: 'Hari Raya Nyepi'
                    }
                },
                '2013-03-12': {
                    name: {
                        en: 'Nyepi',
                        id: 'Hari Raya Nyepi'
                    }
                },
                '2014-03-31': {
                    name: {
                        en: 'Nyepi',
                        id: 'Hari Raya Nyepi'
                    }
                },
                '2015-03-21': {
                    name: {
                        en: 'Nyepi',
                        id: 'Hari Raya Nyepi'
                    }
                },
                '2016-03-09': {
                    name: {
                        en: 'Nyepi',
                        id: 'Hari Raya Nyepi'
                    }
                },
                '2017-03-28': {
                    name: {
                        en: 'Nyepi',
                        id: 'Hari Raya Nyepi'
                    }
                },
                '2018-03-17': {
                    name: {
                        en: 'Nyepi',
                        id: 'Hari Raya Nyepi'
                    }
                },
                '2019-03-07': {
                    name: {
                        en: 'Nyepi',
                        id: 'Hari Raya Nyepi'
                    }
                },
                '2020-03-25': {
                    name: {
                        en: 'Nyepi',
                        id: 'Hari Raya Nyepi'
                    }
                },
                '2021-03-14': {
                    name: {
                        en: 'Nyepi',
                        id: 'Hari Raya Nyepi'
                    }
                },
                '2022-03-03': {
                    name: {
                        en: 'Nyepi',
                        id: 'Hari Raya Nyepi'
                    }
                },
                '2023-03-22': {
                    name: {
                        en: 'Nyepi',
                        id: 'Hari Raya Nyepi'
                    }
                },
                '2024-03-11': {
                    name: {
                        en: 'Nyepi',
                        id: 'Hari Raya Nyepi'
                    }
                },
                '2025-03-29': {
                    name: {
                        en: 'Nyepi',
                        id: 'Hari Raya Nyepi'
                    }
                },
                '2026-03-19': {
                    name: {
                        en: 'Nyepi',
                        id: 'Hari Raya Nyepi'
                    }
                },
                '2027-03-08': {
                    name: {
                        en: 'Nyepi',
                        id: 'Hari Raya Nyepi'
                    }
                },
                '2001-05-07': {
                    _name: 'Vesak'
                },
                '2002-05-26': {
                    _name: 'Vesak'
                },
                '2003-05-16': {
                    _name: 'Vesak'
                },
                '2004-06-03': {
                    _name: 'Vesak'
                },
                '2005-05-24': {
                    _name: 'Vesak'
                },
                '2006-05-13': {
                    _name: 'Vesak'
                },
                '2007-06-01': {
                    _name: 'Vesak'
                },
                '2008-05-20': {
                    _name: 'Vesak'
                },
                '2009-05-09': {
                    _name: 'Vesak'
                },
                '2010-05-28': {
                    _name: 'Vesak'
                },
                '2011-05-17': {
                    _name: 'Vesak'
                },
                '2012-05-06': {
                    _name: 'Vesak'
                },
                '2013-05-25': {
                    _name: 'Vesak'
                },
                '2014-05-15': {
                    _name: 'Vesak'
                },
                '2015-06-02': {
                    _name: 'Vesak'
                },
                '2016-05-22': {
                    _name: 'Vesak'
                },
                '2017-05-11': {
                    _name: 'Vesak'
                },
                '2018-05-29': {
                    _name: 'Vesak'
                },
                '2019-05-19': {
                    _name: 'Vesak'
                },
                '2020-05-07': {
                    _name: 'Vesak'
                },
                '2021-05-26': {
                    _name: 'Vesak'
                },
                '2022-05-16': {
                    _name: 'Vesak'
                },
                '2023-05-06': {
                    _name: 'Vesak'
                },
                '2024-05-23': {
                    _name: 'Vesak'
                },
                '2025-05-12': {
                    _name: 'Vesak'
                },
                '2026-05-31': {
                    _name: 'Vesak'
                },
                '2027-05-20': {
                    _name: 'Vesak'
                }
            }
        },
        IE: {
            names: {
                en: 'Ireland'
            },
            dayoff: 'sunday',
            zones: [
                'Europe/Dublin'
            ],
            langs: [
                'en'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '02-01 if Tuesday,Wednesday,Thursday,Saturday,Sunday then next Monday since 2023': {
                    name: {
                        en: "St. Brigid\u2019s Day"
                    }
                },
                '03-17': {
                    name: {
                        en: "St. Patrick\u2019s Day"
                    }
                },
                '03-17 and if saturday then next monday if sunday then next monday': {
                    name: {
                        en: "St. Patrick\u2019s Day"
                    },
                    substitute: true,
                    type: 'bank'
                },
                'easter -21': {
                    _name: 'Mothers Day',
                    type: 'observance'
                },
                'easter -2': {
                    _name: 'easter -2',
                    type: 'bank'
                },
                easter: {
                    _name: 'easter'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '1st monday in May': {
                    name: {
                        en: 'May Day'
                    }
                },
                '1st monday in June': {
                    name: {
                        en: 'First Monday in June'
                    }
                },
                '1st monday in August': {
                    name: {
                        en: 'First Monday in August'
                    }
                },
                '1st Monday before 11-01': {
                    name: {
                        en: 'October Bank Holiday',
                        type: 'bank'
                    }
                },
                '12-25': {
                    _name: '12-25'
                },
                '12-26': {
                    _name: '12-26',
                    name: {
                        en: "St. Stephen's Day"
                    }
                },
                '12-26 and if saturday then next monday if sunday then next monday': {
                    _name: '12-26',
                    name: {
                        en: "St. Stephen's Day"
                    },
                    substitute: true,
                    type: 'bank'
                },
                '3rd sunday in June': {
                    _name: 'Fathers Day',
                    type: 'observance'
                }
            }
        },
        IL: {
            names: {
                he: "\u05DE\u05B0\u05D3\u05B4\u05D9\u05E0\u05B7\u05EA \u05D9\u05B4\u05E9\u05B0\u05C2\u05E8\u05B8\u05D0\u05B5\u05DC",
                en: 'Israel'
            },
            langs: [
                'he'
            ],
            zones: [
                'Asia/Jerusalem'
            ],
            dayoff: 'Saturday',
            days: {
                '1 Tishrei': {
                    name: {
                        he: "\u05E8\u05D0\u05E9 \u05D4\u05E9\u05E0\u05D4",
                        en: 'Rosh Hashanah (Yom Teruah)'
                    }
                },
                '2 Tishrei': {
                    name: {
                        he: "\u05E8\u05D0\u05E9 \u05D4\u05E9\u05E0\u05D4 \u05D9\u05D5\u05DD 2",
                        en: 'Rosh Hashanah (Day 2)'
                    }
                },
                '3 Tishrei if Saturday then next Sunday': {
                    name: {
                        he: "\u05E6\u05D5\u05DD \u05D2\u05D3\u05DC\u05D9\u05D4",
                        en: 'Fast of Gedaliah (Tzom Gedalya)'
                    },
                    type: 'observance'
                },
                '10 Tishrei': {
                    name: {
                        he: "\u05D9\u05D5\u05DD \u05DB\u05D9\u05E4\u05D5\u05E8",
                        en: 'Day of Atonement (Yom Kippur)'
                    }
                },
                '15 Tishrei': {
                    name: {
                        he: "\u05E1\u05D5\u05DB\u05D5\u05EA",
                        en: 'Feast of Tabernacles (Sukkot)'
                    }
                },
                '16 Tishrei P6D': {
                    name: {
                        he: "\u05D7\u05D5\u05DC \u05D4\u05DE\u05D5\u05E2\u05D3 \u05E1\u05D5\u05DB\u05D5\u05EA",
                        en: 'The week of Sukkot'
                    },
                    type: 'school',
                    note: 'Collective paid leave in many businesses and government offices'
                },
                '22 Tishrei': {
                    name: {
                        he: "\u05E9\u05DE\u05D7\u05EA \u05EA\u05D5\u05E8\u05D4/\u05E9\u05DE\u05D9\u05E0\u05D9 \u05E2\u05E6\u05E8\u05EA",
                        en: 'Simchat Torah/ Shmini Atzeret'
                    }
                },
                '12 Cheshvan if Friday,Saturday then previous Thursday since 1997': {
                    name: {
                        he: "\u05D9\u05D5\u05DD \u05E8\u05D1\u05D9\u05DF",
                        en: 'Rabin Day'
                    },
                    type: 'observance',
                    note: 'National remembrance day, business as usual'
                },
                '29 Cheshvan': {
                    name: {
                        he: "\u05E1\u05D9\u05D2\u05D3",
                        en: 'Sigd'
                    },
                    type: 'observance',
                    note: 'Festival of the Ethiopian Jews, optional paid leave, business as usual'
                },
                '6 Kislev if Saturday then next Sunday': {
                    name: {
                        en: 'Ben-Gurion Day',
                        he: "\u05D9\u05D5\u05DD \u05D1\u05DF-\u05D2\u05D5\u05E8\u05D9\u05D5\u05DF"
                    },
                    type: 'observance',
                    note: 'Day marked by the Knesset'
                },
                '25 Kislev P8D': {
                    name: {
                        en: 'Hanukkah',
                        he: "\u05D7\u05E0\u05D5\u05DB\u05D4"
                    },
                    type: 'school'
                },
                '10 Tevet': {
                    name: {
                        en: 'Tenth of Tevet',
                        he: "\u05E6\u05D5\u05DD \u05E2\u05E9\u05E8\u05D4 \u05D1\u05D8\u05D1\u05EA"
                    },
                    type: 'observance'
                },
                '15 Shvat': {
                    name: {
                        en: 'Tu Bishvat (Arbor Day)',
                        he: '\u05D8"\u05D5 \u05D1\u05E9\u05D1\u05D8'
                    },
                    type: 'observance'
                },
                '13 AdarII if Saturday then previous Thursday': {
                    name: {
                        en: 'Fast of Esther',
                        he: "\u05EA\u05E2\u05E0\u05D9\u05EA \u05D0\u05E1\u05EA\u05E8"
                    },
                    type: 'school'
                },
                '14 AdarII P2D': {
                    name: {
                        en: 'Purim',
                        he: "\u05E4\u05D5\u05E8\u05D9\u05DD"
                    },
                    type: 'school',
                    note: 'optional paid leave'
                },
                '10 Nisan': {
                    name: {
                        en: 'Aliyah Day',
                        he: "\u05D9\u05D5\u05DD \u05D4\u05E2\u05DC\u05D9\u05D9\u05D4"
                    },
                    type: 'observance',
                    note: 'Official holiday, business as usual'
                },
                '15 Nisan': {
                    name: {
                        en: 'Passover (Pesach)',
                        he: "\u05E4\u05E1\u05D7"
                    }
                },
                '16 Nisan P5D': {
                    name: {
                        en: 'Passover (intermediate days)',
                        he: "\u05D7\u05D5\u05DC \u05D4\u05DE\u05D5\u05E2\u05D3 \u05E4\u05E1\u05D7"
                    },
                    type: 'school',
                    note: 'School holiday, collective paid leave in many businesses and government offices'
                },
                '21 Nisan': {
                    name: {
                        en: 'Mimouna, Seventh day of Passover',
                        he: "\u05DE\u05D9\u05DE\u05D5\u05E0\u05D4, \u05E9\u05D1\u05D9\u05E2\u05D9 \u05E9\u05DC \u05E4\u05E1\u05D7"
                    }
                },
                '27 Nisan if Friday then previous Thursday if Sunday then next Monday': {
                    name: {
                        en: 'Holocaust Remembrance Day (Yom HaShoah)',
                        he: "\u05D9\u05D5\u05DD \u05D4\u05D6\u05D9\u05DB\u05E8\u05D5\u05DF \u05DC\u05E9\u05D5\u05D0\u05D4 \u05D5\u05DC\u05D2\u05D1\u05D5\u05E8\u05D4"
                    },
                    type: 'observance',
                    note: 'National remembrance day, business as usual except places of public entertainment'
                },
                '05-09': {
                    name: {
                        en: 'Victory in Europe Day',
                        he: "\u05D9\u05D5\u05DD \u05D4\u05E0\u05D9\u05E6\u05D7\u05D5\u05DF \u05E2\u05DC \u05D2\u05E8\u05DE\u05E0\u05D9\u05D4 \u05D4\u05E0\u05D0\u05E6\u05D9\u05EA"
                    },
                    type: 'observance'
                },
                '4 Iyyar if Thursday,Friday then previous Wednesday if Sunday then next Monday': {
                    name: {
                        en: 'Fallen Soldiers and Victims of Terrorism Remembrance Day (Yom HaZikaron)',
                        he: "\u05D9\u05D5\u05DD \u05D4\u05D6\u05D9\u05DB\u05E8\u05D5\u05DF \u05DC\u05D7\u05DC\u05DC\u05D9 \u05DE\u05E2\u05E8\u05DB\u05D5\u05EA \u05D9\u05E9\u05E8\u05D0\u05DC \u05D5\u05E0\u05E4\u05D2\u05E2\u05D9 \u05E4\u05E2\u05D5\u05DC\u05D5\u05EA \u05D4\u05D0\u05D9\u05D1\u05D4"
                    },
                    type: 'observance',
                    note: 'National remembrance day, business as usual except places of public entertainment'
                },
                '5 Iyyar if Friday,Saturday then previous Thursday if Monday then next Tuesday': {
                    name: {
                        en: 'Independence Day (Yom HaAtzmaut)',
                        he: "\u05D9\u05D5\u05DD \u05D4\u05E2\u05E6\u05DE\u05D0\u05D5\u05EA"
                    }
                },
                '10 Iyyar if Saturday then next Sunday since 2004': {
                    name: {
                        en: 'Herzl Day',
                        he: "\u05D9\u05D5\u05DD \u05D4\u05E8\u05E6\u05DC"
                    },
                    type: 'observance',
                    note: 'Day marked by the Knesset'
                },
                '18 Iyyar': {
                    name: {
                        en: 'Lag BaOmer',
                        he: '\u05DC"\u05D2 \u05D1\u05E2\u05D5\u05DE\u05E8'
                    },
                    type: 'school'
                },
                '28 Iyyar': {
                    name: {
                        en: 'Jerusalem Day (Yom Yerushalayim)',
                        he: "\u05D9\u05D5\u05DD \u05D9\u05E8\u05D5\u05E9\u05DC\u05D9\u05DD"
                    },
                    type: 'observance',
                    note: 'Optional paid leave'
                },
                '6 Sivan': {
                    name: {
                        en: 'Shavuot (Feast of Weeks)',
                        he: "\u05E9\u05D1\u05D5\u05E2\u05D5\u05EA"
                    }
                },
                '17 Tamuz if Saturday then next Sunday': {
                    name: {
                        en: 'Seventeenth of Tamuz, fast',
                        he: "\u05E9\u05D1\u05E2\u05D4 \u05E2\u05E9\u05E8 \u05D1\u05EA\u05DE\u05D5\u05D6"
                    },
                    type: 'observance'
                },
                '29 Tamuz if Saturday then next Sunday': {
                    name: {
                        en: 'Jabotinsky Day',
                        he: "\u05D9\u05D5\u05DD \u05D6'\u05D1\u05D5\u05D8\u05D9\u05E0\u05E1\u05E7\u05D9"
                    },
                    type: 'observance',
                    note: 'Day marked by the Knesset'
                },
                '9 Av if Saturday then next Sunday': {
                    name: {
                        en: "Tisha B'Av, fast",
                        he: "\u05EA\u05E9\u05E2\u05D4 \u05D1\u05D0\u05D1"
                    },
                    type: 'observance',
                    note: 'Optional paid leave, business as usual except places of public entertainment'
                },
                '15 Av': {
                    name: {
                        en: "Tu B'Av (Fifteenth of Av)",
                        he: '\u05D8"\u05D5 \u05D1\u05D0\u05D1'
                    },
                    type: 'observance'
                },
                '2015-03-17': {
                    name: {
                        en: 'Election Day',
                        he: "\u05D9\u05D5\u05DD \u05D4\u05D1\u05D7\u05D9\u05E8\u05D5\u05EA"
                    }
                },
                '2019-04-09': {
                    name: {
                        en: 'Election Day',
                        he: "\u05D9\u05D5\u05DD \u05D4\u05D1\u05D7\u05D9\u05E8\u05D5\u05EA"
                    }
                },
                '2019-09-17': {
                    name: {
                        en: 'Election Day',
                        he: "\u05D9\u05D5\u05DD \u05D4\u05D1\u05D7\u05D9\u05E8\u05D5\u05EA"
                    }
                },
                '2020-03-02': {
                    name: {
                        en: 'Election Day',
                        he: "\u05D9\u05D5\u05DD \u05D4\u05D1\u05D7\u05D9\u05E8\u05D5\u05EA"
                    }
                },
                '2021-03-23': {
                    name: {
                        en: 'Election Day',
                        he: "\u05D9\u05D5\u05DD \u05D4\u05D1\u05D7\u05D9\u05E8\u05D5\u05EA"
                    }
                }
            }
        },
        IM: {
            names: {
                en: 'Isle of Man'
            },
            zones: [
                'Europe/Isle_of_Man'
            ],
            langs: [
                'en'
            ],
            _days: [
                'GB'
            ],
            days: {
                '2nd friday in June': {
                    name: {
                        en: 'Tourist Trophy, Senior Race Day'
                    }
                },
                '07-05': {
                    name: {
                        en: 'Tynwald Day'
                    }
                }
            }
        },
        IR: {
            names: {
                fa: "\u062C\u0645\u0647\u0648\u0631\u06CC \u0627\u0633\u0644\u0627\u0645\u06CC \u0627\u06CC\u0631\u0627\u0646",
                en: 'Iran'
            },
            langs: [
                'fa',
                'en'
            ],
            zones: [
                'Asia/Tehran'
            ],
            dayoff: 'Friday',
            days: {
                '1 Farvardin': {
                    name: {
                        fa: "\u0646\u0648\u0631\u0648\u0632",
                        en: 'Nowruz'
                    }
                },
                '2 Farvardin': {
                    name: {
                        fa: "\u0646\u0648\u0631\u0648\u0632",
                        en: 'Nowruz'
                    }
                },
                '3 Farvardin': {
                    name: {
                        fa: "\u0646\u0648\u0631\u0648\u0632",
                        en: 'Nowruz'
                    }
                },
                '4 Farvardin': {
                    name: {
                        fa: "\u0646\u0648\u0631\u0648\u0632",
                        en: 'Nowruz'
                    }
                },
                '12 Farvardin': {
                    name: {
                        fa: "\u0631\u0648\u0632 \u062C\u0645\u0647\u0648\u0631\u06CC \u0627\u0633\u0644\u0627\u0645\u06CC",
                        en: 'Islamic Republic Day'
                    }
                },
                '13 Farvardin': {
                    name: {
                        fa: "\u0633\u06CC\u0632\u062F\u0647 \u0628\u062F\u0631",
                        en: 'Sizdah Bedar'
                    }
                },
                '14 Khordad': {
                    name: {
                        fa: "\u0631\uFEA3\uFEE0\uFE96 \u0627\uFEE3\uFE8E\u0645 \uFEA7\uFEE4\uFBFF\uFEE8\uFBFD",
                        en: "Imam Khomeini's Demise"
                    }
                },
                '15 Khordad': {
                    name: {
                        fa: "\u0642\u06CC\u0627\u0645 \u06F1\u06F5 \u062E\u0631\u062F\u0627\u062F",
                        en: 'Revolt of Khordad 15'
                    }
                },
                '22 Bahman': {
                    name: {
                        fa: "\u0627\u0646\u0642\u0644\u0627\u0628 \u0627\u0633\u0644\u0627\u0645\u06CC \u067E\u0646\u062C\u0627\u0647 \u0648 \u0647\u0641\u062A",
                        en: 'Anniversary of Islamic Revolution'
                    }
                },
                '29 Esfand': {
                    name: {
                        fa: "\u0645\u0644\u06CC \u0634\u062F\u0646 \u0635\u0646\u0639\u062A \u0646\u0641\u062A",
                        en: 'Nationalization of the Iranian oil industry'
                    }
                },
                '9 Muharram': {
                    name: {
                        fa: "\uFE97\uFE8E\uFEB3\uFEEE\uFECB\uFE8E\u06CC \uFEA3\uFEB4\uFBFF\uFEE8\uFBFD",
                        en: 'Tasoua'
                    }
                },
                '10 Muharram': {
                    name: {
                        fa: "\uFECB\uFE8E\uFEB7\uFEEE\u0631\u0627\u06CC \uFEA3\uFEB4\uFBFF\uFEE8\uFBFD",
                        en: 'Ashoura'
                    }
                },
                '20 Safar': {
                    name: {
                        fa: "\u0627\u0631\u0628\u0639\u06CC\u0646 \u062D\u0633\u06CC\u0646\u06CC",
                        en: 'Arbaeen-e Hosseini'
                    }
                },
                '28 Safar': {
                    name: {
                        fa: "\u0631\uFEA3\uFEE0\uFE96 \uFEA3\uFEC0\uFEAE\u062A \u0631\uFEB3\uFEEE\u0644 \u0627\uFB90\uFEAE\u0645 \u0635\u0644\u0651\u06CC \u0627\u0644\u0644\u0647 \u0639\u0644\u06CC\u0647 \u0648\u0622\u0644\u0647 \u0648 \u0633\u0644\u0651\u0645",
                        en: 'Demise of Prophet Muhammad and Imam Hassan (Mujtaba)'
                    }
                },
                '30 Safar': {
                    name: {
                        fa: "\uFEB7\uFEEC\uFE8E\u062F\u062A \uFEA3\uFEC0\uFEAE\u062A \u0627\uFEE3\uFE8E\u0645 \u0631\uFEBF\uFE8E \uFECB\uFEE0\uFBFF\uFEEA\u0627\uFEDF\uFEB4\uFEFC\u0645",
                        en: 'Martyrdom of Imam Reza'
                    }
                },
                '8 Rabi al-awwal': {
                    name: {
                        fa: "\u0634\u0647\u0627\u062F\u062A \u0627\u0645\u0627\u0645 \u062D\u0633\u0646 \u0639\u0633\u0643\u0631\u06CC \u0639\u0644\u06CC\u0647\u200C\u0627\u0644\u0633\u0644\u0627\u0645",
                        en: 'Martyrdom of Imam Hassan'
                    }
                },
                '17 Rabi al-awwal': {
                    name: {
                        fa: "\u0648\u0644\u0627\u062F\u062A \u062D\u0636\u0631\u062A \u0631\u0633\u0648\u0644 \u0627\u06A9\u0631\u0645 \u0635\u0644\u0651\u06CC \u0627\u0644\u0644\u0647 \u0639\u0644\u06CC\u0647 \u0648\u0622\u0644\u0647 \u0648 \u0633\u0644\u0651\u0645",
                        en: 'Birthday of Muhammad Prophet'
                    }
                },
                '3 Jumada al-thani': {
                    name: {
                        fa: "\uFEB7\uFEEC\uFE8E\u062F\u062A \uFEA3\uFEC0\uFEAE\u062A \uFED3\uFE8E\uFEC3\uFEE4\uFEEA \u0632\uFEEB\uFEAE\u0627 \uFEB3\uFEFC\u0645 \u0627\uFDF2 \uFECB\uFEE0\uFBFF\uFEEC\uFE8E",
                        en: 'Martyrdom of Fatima-Zahara'
                    }
                },
                '13 Rajab': {
                    name: {
                        fa: "\u0648\uFEFB\u062F\u062A \uFEA3\uFEC0\uFEAE\u062A \u0627\uFEE3\uFE8E\u0645 \uFECB\uFEE0\uFBFD \uFECB\uFEE0\uFBFF\uFEEA \u0627\uFEDF\uFEB4\uFEFC\u0645",
                        en: 'Birthday of Imam Ali'
                    }
                },
                '27 Rajab': {
                    name: {
                        fa: "\uFEE3\uFE92\uFECC\uFE9A \uFEA3\uFEC0\uFEAE\u062A \u0631\uFEB3\uFEEE\u0644 \u0627\uFB90\uFEAE\u0645 \uFEBB\uFEE0\uFBFD \u0627\uFDF2 \uFECB\uFEE0\uFBFF\uFEEA \u0648 \u0622\uFEDF\uFEEA",
                        en: 'Mabaas of Muhammad'
                    }
                },
                '15 Shaban': {
                    name: {
                        fa: "\u0648\uFEFB\u062F\u062A \uFEA3\uFEC0\uFEAE\u062A \uFED7\uFE8E\uFE8B\uFEE2 \uFECB\uFEA0\uFEDE\u0627\uFDF2 \uFE97\uFECC\uFE8E\uFEDF\uFBFD \uFED3\uFEAE\uFE9F\uFEEA \u0634\u0631\u06CC\u0641",
                        en: 'Birthday of Imam Mahdi'
                    }
                },
                '21 Ramadan': {
                    name: {
                        fa: "\uFEB7\uFEEC\uFE8E\u062F\u062A \uFEA3\uFEC0\uFEAE\u062A \uFECB\uFEE0\uFBFD \uFECB\uFEE0\uFBFF\uFEEA\u0627\uFEDF\uFEB4\uFEFC\u0645",
                        en: 'Martyrdom of Imam Ali'
                    }
                },
                '1 Shawwal': {
                    _name: '1 Shawwal'
                },
                '2 Shawwal': {
                    name: {
                        fa: "\uFE91\uFEEA \uFEE3\uFEE8\uFE8E\uFEB3\uFE92\uFE96 \uFECB\uFBFF\uFEAA \uFEB3\uFECC\uFBFF\uFEAA \uFED3\uFEC4\uFEAE",
                        en: 'Holyday for Fetr Eeid'
                    }
                },
                '25 Shawwal': {
                    name: {
                        fa: "\uFEB7\uFEEC\uFE8E\u062F\u062A \uFEA3\uFEC0\uFEAE\u062A \u0627\uFEE3\uFE8E\u0645 \uFE9F\uFECC\uFED4\uFEAE \uFEBB\uFE8E\u062F\u0642 \uFECB\uFEE0\uFBFF\uFEEA\u0627\uFEDF\uFEB4\uFEFC\u0645",
                        en: 'Martyrdom of Imam Jafar'
                    }
                },
                '10 Dhu al-Hijjah': {
                    _name: '10 Dhu al-Hijjah'
                },
                '18 Dhu al-Hijjah': {
                    name: {
                        fa: "\uFECB\uFBFF\uFEAA \uFEB3\uFECC\uFBFF\uFEAA \uFECF\uFEAA\uFBFE\uFEAE \uFEA7\uFEE2",
                        en: 'Eid al-Ghadeer'
                    }
                }
            }
        },
        IS: {
            names: {
                is: "\xcdsland",
                en: 'Iceland'
            },
            dayoff: 'sunday',
            zones: [
                'Atlantic/Reykjavik'
            ],
            langs: [
                'is'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '01-06': {
                    _name: '01-06',
                    type: 'observance'
                },
                'friday after 01-18': {
                    name: {
                        is: "B\xf3ndadagur"
                    },
                    type: 'observance'
                },
                '02-18': {
                    name: {
                        is: 'Konudagur',
                        en: "Woman's Day"
                    },
                    type: 'observance'
                },
                'easter -48': {
                    name: {
                        is: 'Bolludagur'
                    },
                    type: 'observance'
                },
                'easter -47': {
                    name: {
                        is: 'Sprengidagur'
                    },
                    type: 'observance'
                },
                'easter -46': {
                    _name: 'easter -46',
                    type: 'observance'
                },
                'easter -7': {
                    _name: 'easter -7',
                    type: 'observance'
                },
                'easter -3': {
                    _name: 'easter -3'
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                easter: {
                    _name: 'easter'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                'thursday after 04-18': {
                    name: {
                        is: 'Sumardagurinn fyrsti',
                        en: 'First Day of Summer'
                    }
                },
                '05-01': {
                    _name: '05-01'
                },
                '2nd sunday in May': {
                    _name: 'Mothers Day',
                    type: 'observance'
                },
                'easter 39': {
                    _name: 'easter 39'
                },
                'easter 49': {
                    _name: 'easter 49'
                },
                'easter 50': {
                    _name: 'easter 50'
                },
                '1st sunday in June': {
                    name: {
                        is: "Sj\xf3mannadagurinn",
                        en: "The Seamen's Day"
                    },
                    type: 'observance'
                },
                '06-17': {
                    name: {
                        is: "\xcdslenski \xfej\xf3\xf0h\xe1t\xed\xf0ardagurinn",
                        en: 'Icelandic National Day'
                    }
                },
                '1st monday in August': {
                    name: {
                        is: "Fr\xeddagur verslunarmanna",
                        en: 'Commerce Day'
                    }
                },
                'saturday after 10-21': {
                    name: {
                        is: 'Fyrsti vetrardagur',
                        en: 'First Day of Winter'
                    },
                    type: 'observance'
                },
                '11-16': {
                    name: {
                        is: "Dagur \xedslenskrar tungu",
                        en: 'Icelandic Language Day'
                    },
                    type: 'observance'
                },
                '12-23': {
                    name: {
                        is: "\xdeorl\xe1ksmessa",
                        en: "St \xdeorl\xe1kur's Day"
                    },
                    type: 'observance'
                },
                '12-24 13:00 if sunday then 00:00': {
                    _name: '12-24'
                },
                '12-25': {
                    _name: '12-25'
                },
                '12-26': {
                    _name: '12-26'
                },
                '12-31 13:00 if sunday then 00:00': {
                    _name: '12-31'
                }
            }
        },
        IT: {
            names: {
                it: 'Italia',
                en: 'Italia'
            },
            dayoff: 'sunday',
            zones: [
                'Europe/Rome'
            ],
            langs: [
                'it'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '01-06': {
                    _name: '01-06'
                },
                easter: {
                    _name: 'easter'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '04-25': {
                    name: {
                        it: 'Anniversario della Liberazione',
                        en: 'Liberation Day'
                    }
                },
                '05-01': {
                    _name: '05-01'
                },
                '2nd sunday in May': {
                    _name: 'Mothers Day',
                    type: 'observance'
                },
                '06-02': {
                    name: {
                        it: 'Festa della Repubblica',
                        en: 'Republic Day'
                    }
                },
                '08-15': {
                    _name: '08-15'
                },
                '11-01': {
                    _name: '11-01'
                },
                '12-08': {
                    _name: '12-08'
                },
                '12-25': {
                    _name: '12-25'
                },
                '12-26': {
                    _name: '12-26'
                },
                '2011-03-17': {
                    name: {
                        it: 'Festa Nazionale 2011',
                        en: 'National Day 2011'
                    }
                }
            },
            states: {
                25: {
                    name: 'Lombardy',
                    regions: {
                        MI: {
                            name: 'Milan',
                            days: {
                                '12-07': {
                                    name: {
                                        it: "Sant'Ambrogio",
                                        en: 'Saint Ambrose'
                                    }
                                }
                            }
                        }
                    }
                },
                32: {
                    names: {
                        de: "S\xfcdtirol",
                        it: 'Alto Adige'
                    },
                    days: {
                        'easter 50': {
                            _name: 'easter 50'
                        }
                    }
                },
                52: {
                    names: {
                        it: 'Toscana',
                        en: 'Tuscany'
                    },
                    regions: {
                        FI: {
                            names: {
                                it: 'Firenze',
                                en: 'Florence'
                            },
                            days: {
                                '06-24': {
                                    name: {
                                        it: 'San Giovanni',
                                        en: 'Saint John'
                                    },
                                    type: 'optional',
                                    note: 'patron saint of Florence'
                                }
                            }
                        }
                    }
                },
                62: {
                    name: 'Lazio',
                    regions: {
                        RM: {
                            names: {
                                it: 'Roma',
                                en: 'Rome'
                            },
                            days: {
                                '06-29': {
                                    name: {
                                        it: 'Santi Pietro e Paolo',
                                        en: 'Saints Peter and Paul'
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        JE: {
            names: {
                en: 'Jersey'
            },
            zones: [
                'Europe/Jersey'
            ],
            langs: [
                'en'
            ],
            _days: [
                'GB'
            ],
            days: {
                '05-09': {
                    name: {
                        en: 'Liberation Day'
                    }
                }
            }
        },
        JM: {
            names: {
                en: 'Jamaica'
            },
            dayoff: 'sunday',
            langs: [
                'en'
            ],
            zones: [
                'America/Jamaica'
            ],
            days: {
                '01-01 and if sunday then next monday': {
                    _name: '01-01',
                    substitute: true
                },
                'easter -46': {
                    _name: 'easter -46'
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                easter: {
                    _name: 'easter',
                    type: 'observance'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '05-23 if saturday,sunday then next monday': {
                    _name: '05-01'
                },
                '08-01 if sunday then next monday': {
                    name: {
                        en: 'Emancipation Day'
                    }
                },
                '08-06 and if sunday then next monday': {
                    _name: 'Independence Day',
                    substitute: true
                },
                '3rd monday in October': {
                    name: {
                        en: 'National Heroes Day'
                    }
                },
                '12-25 and if sunday then next tuesday': {
                    _name: '12-25',
                    substitute: true
                },
                '12-26 and if sunday then next monday': {
                    _name: '12-26',
                    substitute: true
                }
            }
        },
        JP: {
            names: {
                jp: "\u65E5\u672C",
                en: 'Japan'
            },
            dayoff: 'sunday',
            langs: [
                'jp'
            ],
            zones: [
                'Asia/Tokyo'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                'substitutes 01-01 if sunday then next monday': {
                    substitute: true,
                    _name: '01-01',
                    active: [
                        {
                            from: '1973-04-12T00:00:00.000Z'
                        }
                    ]
                },
                '01-02': {
                    name: {
                        en: 'January 2nd',
                        jp: "\u9280\u884C\u4F11\u696D\u65E5"
                    },
                    type: 'bank'
                },
                '01-03': {
                    name: {
                        en: 'January 3rd',
                        jp: "\u9280\u884C\u4F11\u696D\u65E5"
                    },
                    type: 'bank'
                },
                '01-15': {
                    name: {
                        en: 'Coming of Age Day',
                        jp: "\u6210\u4EBA\u306E\u65E5"
                    },
                    active: [
                        {
                            from: '1948-07-20T00:00:00.000Z',
                            to: '1999-12-31T00:00:00.000Z'
                        }
                    ]
                },
                'substitutes 01-15 and if sunday then next monday': {
                    substitute: true,
                    name: {
                        en: 'Coming of Age Day',
                        jp: "\u6210\u4EBA\u306E\u65E5"
                    },
                    active: [
                        {
                            from: '1973-04-12T00:00:00.000Z',
                            to: '1999-12-31T00:00:00.000Z'
                        }
                    ]
                },
                '2nd monday in January': {
                    name: {
                        en: 'Coming of Age Day',
                        jp: "\u6210\u4EBA\u306E\u65E5"
                    },
                    active: [
                        {
                            from: '2000-01-01T00:00:00.000Z'
                        }
                    ]
                },
                '02-11': {
                    name: {
                        en: 'Foundation Day',
                        jp: "\u5EFA\u56FD\u8A18\u5FF5\u306E\u65E5"
                    },
                    active: [
                        {
                            from: '1967-01-01T00:00:00.000Z'
                        }
                    ]
                },
                'substitutes 02-11 and if sunday then next monday': {
                    substitute: true,
                    name: {
                        en: 'Foundation Day',
                        jp: "\u5EFA\u56FD\u8A18\u5FF5\u306E\u65E5"
                    },
                    active: [
                        {
                            from: '1973-04-12T00:00:00.000Z'
                        }
                    ]
                },
                '02-23 and if sunday then next monday': {
                    substitute: true,
                    name: {
                        en: "Emperor's Birthday",
                        jp: "\u5929\u7687\u8A95\u751F\u65E5"
                    },
                    active: [
                        {
                            from: '2020-01-01T00:00:00.000Z'
                        }
                    ]
                },
                '1989-02-24': {
                    name: {
                        en: 'State Funeral of Emperor Showa',
                        jp: "\u5927\u55AA\u306E\u793C"
                    }
                },
                'march equinox in +09:00': {
                    name: {
                        en: 'Spring Equinox Day',
                        jp: "\u6625\u5206\u306E\u65E5"
                    },
                    active: [
                        {
                            from: '1948-07-20T00:00:00.000Z'
                        }
                    ]
                },
                'substitutes march equinox in +09:00 and if sunday then next monday': {
                    substitute: true,
                    name: {
                        en: 'Spring Equinox Day',
                        jp: "\u6625\u5206\u306E\u65E5"
                    },
                    active: [
                        {
                            from: '1973-04-12T00:00:00.000Z'
                        }
                    ]
                },
                '1959-04-10': {
                    name: {
                        en: 'Marriage of Crown Prince Akihito',
                        jp: "\u7D50\u5A5A\u306E\u5100"
                    }
                },
                '04-29': {
                    name: {
                        en: "Emperor's Birthday",
                        jp: "\u5929\u7687\u8A95\u751F\u65E5"
                    },
                    active: [
                        {
                            from: '1948-07-20T00:00:00.000Z',
                            to: '1988-12-31T00:00:00.000Z'
                        }
                    ]
                },
                'substitutes 04-29 and if sunday then next monday': {
                    substitute: true,
                    name: {
                        en: "Emperor's Birthday",
                        jp: "\u5929\u7687\u8A95\u751F\u65E5"
                    },
                    active: [
                        {
                            from: '1973-04-12T00:00:00.000Z',
                            to: '1988-12-31T00:00:00.000Z'
                        }
                    ]
                },
                '04-29 and if sunday then next monday #1': {
                    substitute: true,
                    name: {
                        en: 'Greenery Day',
                        jp: "\u307F\u3069\u308A\u306E\u65E5"
                    },
                    active: [
                        {
                            from: '1989-01-01T00:00:00.000Z',
                            to: '2006-12-31T00:00:00.000Z'
                        }
                    ]
                },
                '04-29 and if sunday then next monday #2': {
                    substitute: true,
                    name: {
                        en: 'Showa Day',
                        jp: "\u662D\u548C\u306E\u65E5"
                    },
                    active: [
                        {
                            from: '2007-01-01T00:00:00.000Z'
                        }
                    ]
                },
                '2019-04-30': {
                    name: {
                        en: "Citizens' Holiday",
                        jp: "\u56FD\u6C11\u306E\u4F11\u65E5"
                    }
                },
                '2019-05-01': {
                    name: {
                        en: 'Coronation Day',
                        jp: "\u5373\u4F4D\u306E\u65E5"
                    }
                },
                '2019-05-02': {
                    name: {
                        en: "Citizens' Holiday",
                        jp: "\u56FD\u6C11\u306E\u4F11\u65E5"
                    }
                },
                '05-03': {
                    _name: 'Constitution Day'
                },
                'substitutes 05-03 if sunday then next monday': {
                    substitute: true,
                    _name: 'Constitution Day',
                    active: [
                        {
                            from: '1973-04-12T00:00:00.000Z',
                            to: '2006-12-31T00:00:00.000Z'
                        }
                    ]
                },
                'substitutes 05-03 if sunday then next wednesday': {
                    substitute: true,
                    _name: 'Constitution Day',
                    active: [
                        {
                            from: '2007-01-01T00:00:00.000Z'
                        }
                    ]
                },
                '05-04 not on sunday, monday': {
                    name: {
                        en: "Citizens' Holiday",
                        jp: "\u56FD\u6C11\u306E\u4F11\u65E5"
                    },
                    active: [
                        {
                            from: '1986-01-01T00:00:00.000Z',
                            to: '2006-12-31T00:00:00.000Z'
                        }
                    ]
                },
                '05-04 and if sunday then next tuesday': {
                    substitute: true,
                    name: {
                        en: 'Greenery Day',
                        jp: "\u307F\u3069\u308A\u306E\u65E5"
                    },
                    active: [
                        {
                            from: '2007-01-01T00:00:00.000Z'
                        }
                    ]
                },
                '05-05': {
                    name: {
                        en: "Children's Day",
                        jp: "\u3053\u3069\u3082\u306E\u65E5"
                    }
                },
                'substitutes 05-05 if sunday then next monday': {
                    substitute: true,
                    name: {
                        en: "Children's Day",
                        jp: "\u3053\u3069\u3082\u306E\u65E5"
                    },
                    active: [
                        {
                            from: '1973-04-12T00:00:00.000Z'
                        }
                    ]
                },
                '1993-06-09': {
                    name: {
                        en: 'Marriage of Crown Prince Naruhito',
                        jp: "\u7D50\u5A5A\u306E\u5100"
                    }
                },
                '07-20': {
                    name: {
                        en: 'Marine Day',
                        jp: "\u6D77\u306E\u65E5"
                    },
                    active: [
                        {
                            from: '1996-01-01T00:00:00.000Z',
                            to: '2002-12-31T00:00:00.000Z'
                        }
                    ]
                },
                'substitutes 07-20 if sunday then next monday': {
                    substitute: true,
                    name: {
                        en: 'Marine Day',
                        jp: "\u6D77\u306E\u65E5"
                    },
                    active: [
                        {
                            from: '1996-01-01T00:00:00.000Z',
                            to: '2002-12-31T00:00:00.000Z'
                        }
                    ]
                },
                '3rd monday in July': {
                    name: {
                        en: 'Marine Day',
                        jp: "\u6D77\u306E\u65E5"
                    },
                    disable: [
                        '2020-07-20',
                        '2021-07-19'
                    ],
                    enable: [
                        '2020-07-23',
                        '2021-07-22'
                    ],
                    active: [
                        {
                            from: '2003-01-01T00:00:00.000Z'
                        }
                    ]
                },
                'substitutes 2021-08-08 and if sunday then next monday': {
                    substitute: true,
                    name: {
                        en: 'Mountain Day',
                        jp: "\u5C71\u306E\u65E5"
                    }
                },
                'substitutes 08-11 and if sunday then next monday': {
                    substitute: true,
                    name: {
                        en: 'Mountain Day',
                        jp: "\u5C71\u306E\u65E5"
                    },
                    disable: [
                        '2020-08-11',
                        '2021-08-11'
                    ],
                    enable: [
                        '2020-08-10'
                    ],
                    active: [
                        {
                            from: '2016-01-01T00:00:00.000Z'
                        }
                    ]
                },
                '09-15': {
                    name: {
                        en: 'Respect-for-the-Aged Day',
                        jp: "\u656C\u8001\u306E\u65E5"
                    },
                    active: [
                        {
                            from: '1966-01-01T00:00:00.000Z',
                            to: '2002-12-31T00:00:00.000Z'
                        }
                    ]
                },
                'substitutes 09-15 and if sunday then next monday': {
                    substitute: true,
                    name: {
                        en: 'Respect-for-the-Aged Day',
                        jp: "\u656C\u8001\u306E\u65E5"
                    },
                    active: [
                        {
                            from: '1973-04-12T00:00:00.000Z',
                            to: '2002-12-31T00:00:00.000Z'
                        }
                    ]
                },
                '3rd monday in September': {
                    name: {
                        en: 'Respect-for-the-Aged Day',
                        jp: "\u656C\u8001\u306E\u65E5"
                    },
                    active: [
                        {
                            from: '2003-01-01T00:00:00.000Z'
                        }
                    ]
                },
                '09-22 if 09-21 and 09-23 is public holiday': {
                    name: {
                        en: "Citizens' Holiday",
                        jp: "\u56FD\u6C11\u306E\u4F11\u65E5"
                    }
                },
                'september equinox in +09:00': {
                    name: {
                        en: 'Autumnal Equinox Day',
                        jp: "\u79CB\u5206\u306E\u65E5"
                    },
                    active: [
                        {
                            from: '1948-07-20T00:00:00.000Z'
                        }
                    ]
                },
                'substitutes september equinox in +09:00 and if sunday then next monday': {
                    substitute: true,
                    name: {
                        en: 'Autumnal Equinox Day',
                        jp: "\u79CB\u5206\u306E\u65E5"
                    },
                    active: [
                        {
                            from: '1973-04-12T00:00:00.000Z'
                        }
                    ]
                },
                '10-10': {
                    name: {
                        en: 'Sports Day',
                        jp: "\u4F53\u80B2\u306E\u65E5"
                    },
                    active: [
                        {
                            from: '1966-01-01T00:00:00.000Z',
                            to: '1999-12-31T00:00:00.000Z'
                        }
                    ]
                },
                'substitutes 10-10 and if sunday then next monday': {
                    substitute: true,
                    name: {
                        en: 'Sports Day',
                        jp: "\u4F53\u80B2\u306E\u65E5"
                    },
                    active: [
                        {
                            from: '1973-04-12T00:00:00.000Z',
                            to: '1999-12-31T00:00:00.000Z'
                        }
                    ]
                },
                '2nd monday in October #1': {
                    name: {
                        en: 'Sports Day',
                        jp: "\u4F53\u80B2\u306E\u65E5"
                    },
                    active: [
                        {
                            from: '2000-01-01T00:00:00.000Z',
                            to: '2019-12-31T00:00:00.000Z'
                        }
                    ]
                },
                '2nd monday in October #2': {
                    name: {
                        en: 'Sports Day',
                        jp: "\u30B9\u30DD\u30FC\u30C4\u306E\u65E5"
                    },
                    disable: [
                        '2020-10-12',
                        '2021-10-11'
                    ],
                    enable: [
                        '2020-07-24',
                        '2021-07-23'
                    ],
                    active: [
                        {
                            from: '2020-01-01T00:00:00.000Z'
                        }
                    ]
                },
                '2019-10-22': {
                    name: {
                        en: 'Enthronement Ceremony Day',
                        jp: "\u5373\u4F4D\u793C\u6B63\u6BBF\u306E\u5100"
                    }
                },
                '11-03': {
                    substitute: true,
                    name: {
                        en: 'Culture Day',
                        jp: "\u6587\u5316\u306E\u65E5"
                    },
                    active: [
                        {
                            from: '1948-07-20T00:00:00.000Z'
                        }
                    ]
                },
                'substitutes 11-03 and if sunday then next monday': {
                    substitute: true,
                    name: {
                        en: 'Culture Day',
                        jp: "\u6587\u5316\u306E\u65E5"
                    },
                    active: [
                        {
                            from: '1973-04-12T00:00:00.000Z'
                        }
                    ]
                },
                '1990-11-12': {
                    name: {
                        en: 'Official Enthronement Ceremony of Emperor Heisei (Akihito)',
                        jp: "\u5373\u4F4D\u793C\u6B63\u6BBF\u306E\u5100"
                    }
                },
                '11-15': {
                    name: {
                        en: 'Seven-Five-Three Festival',
                        jp: "\u4E03\u4E94\u4E09"
                    },
                    type: 'observance'
                },
                '11-23': {
                    name: {
                        en: 'Labor Thanksgiving Day',
                        jp: "\u52E4\u52B4\u611F\u8B1D\u306E\u65E5"
                    },
                    active: [
                        {
                            from: '1948-07-20T00:00:00.000Z'
                        }
                    ]
                },
                'substitutes 11-23 and if sunday then next monday': {
                    substitute: true,
                    name: {
                        en: 'Labor Thanksgiving Day',
                        jp: "\u52E4\u52B4\u611F\u8B1D\u306E\u65E5"
                    },
                    active: [
                        {
                            from: '1973-04-12T00:00:00.000Z'
                        }
                    ]
                },
                '12-23 and if sunday then next monday': {
                    substitute: true,
                    name: {
                        en: "Emperor's Birthday",
                        jp: "\u5929\u7687\u8A95\u751F\u65E5"
                    },
                    active: [
                        {
                            from: '1989-01-01T00:00:00.000Z',
                            to: '2018-12-31T00:00:00.000Z'
                        }
                    ]
                },
                '12-25': {
                    _name: '12-25',
                    type: 'observance'
                },
                '12-31': {
                    _name: '12-31',
                    type: 'bank'
                }
            }
        },
        KE: {
            names: {
                en: 'Kenya'
            },
            dayoff: 'sunday',
            langs: [
                'sw',
                'en'
            ],
            zones: [
                'Africa/Nairobi'
            ],
            days: {
                '01-01 and if sunday then next monday': {
                    substitute: true,
                    _name: '01-01'
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                easter: {
                    _name: 'easter'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '05-01 and if sunday then next monday': {
                    substitute: true,
                    _name: '05-01'
                },
                '06-01 and if sunday then next monday': {
                    substitute: true,
                    name: {
                        sw: 'Siku ya Madaraka',
                        en: 'Madaraka Day'
                    }
                },
                '10-10 and if sunday then next monday': {
                    substitute: true,
                    name: {
                        en: 'Moi Day'
                    }
                },
                '10-20 and if sunday then next monday': {
                    substitute: true,
                    name: {
                        sw: 'Siku ya Mashujaa',
                        en: 'Mashujaa Day'
                    }
                },
                '12-12 and if sunday then next monday': {
                    substitute: true,
                    name: {
                        sw: 'Siku ya Jamhuri',
                        en: 'Jamhuri Day'
                    }
                },
                '12-25 and if sunday then next tuesday': {
                    substitute: true,
                    _name: '12-25'
                },
                '12-26 and if sunday then next monday': {
                    substitute: true,
                    _name: '12-26'
                },
                '1 Shawwal': {
                    _name: '1 Shawwal'
                },
                '10 Dhu al-Hijjah': {
                    _name: '10 Dhu al-Hijjah',
                    note: 'For all persons belonging to the Islamic faith.'
                }
            }
        },
        KM: {
            names: {
                fr: 'Union des Comores',
                en: 'Comoros'
            },
            langs: [
                'fr',
                'ar',
                'swb',
                'wlc',
                'wni',
                'zdj'
            ],
            zones: [
                'Africa/Nairobi'
            ],
            dayoff: 'sunday',
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '03-18': {
                    name: {
                        fr: "Journ\xe9e de Cheikh Al Maarouf",
                        en: 'Cheikh Al Maarouf Day'
                    }
                },
                '05-01': {
                    _name: '05-01'
                },
                '07-06': {
                    _name: 'Independence Day'
                },
                '11-12': {
                    name: {
                        fr: "Journ\xe9e Maor\xe9",
                        en: 'Maore Day'
                    }
                },
                '1 Muharram': {
                    _name: '1 Muharram'
                },
                '12 Rabi al-awwal': {
                    _name: '12 Rabi al-awwal'
                },
                '1 Shawwal P3DT0H0M': {
                    _name: '1 Shawwal'
                },
                '10 Dhu al-Hijjah P2DT0H0M': {
                    _name: '10 Dhu al-Hijjah'
                },
                '27 Rajab': {
                    _name: '27 Rajab'
                }
            }
        },
        KN: {
            names: {
                en: 'St. Kitts & Nevis'
            },
            langs: [
                'en'
            ],
            zones: [
                'America/Port_of_Spain'
            ],
            dayoff: 'sunday',
            days: {
                '01-01 and if Saturday then next Monday': {
                    substitute: true,
                    _name: '01-01'
                },
                '01-02': {
                    name: {
                        en: 'Carnival Day'
                    }
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                easter: {
                    _name: 'easter',
                    type: 'observance'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                'easter 49': {
                    _name: 'easter 49',
                    type: 'observance'
                },
                'easter 50': {
                    _name: 'easter 50'
                },
                '1st Monday in May': {
                    _name: '05-01'
                },
                '1st Monday in August': {
                    name: {
                        en: 'Emancipation Day'
                    }
                },
                '1st Tuesday in August': {
                    name: {
                        en: 'Culturama Day'
                    }
                },
                '09-16 and if Sunday then next Monday': {
                    substitute: true,
                    name: {
                        en: "National Heroes' Day"
                    }
                },
                '09-19 if Sunday then next Monday': {
                    substitute: true,
                    _name: 'Independence Day'
                },
                '12-25': {
                    _name: '12-25'
                },
                '12-26': {
                    _name: '12-26'
                }
            }
        },
        KR: {
            names: {
                ko: "\uB300\uD55C\uBBFC\uAD6D",
                en: 'South Korea'
            },
            dayoff: 'sunday',
            langs: [
                'ko'
            ],
            zones: [
                'Asia/Seoul'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                'korean 01-0-01 P3D': {
                    name: {
                        en: 'Korean New Year',
                        ko: "\uC124\uB0A0"
                    }
                },
                '03-01': {
                    name: {
                        en: 'Independence Movement Day',
                        ko: "3\xb71\uC808"
                    }
                },
                '05-05': {
                    name: {
                        en: "Children's Day",
                        ko: "\uC5B4\uB9B0\uC774\uB0A0"
                    }
                },
                'korean 4-0-8': {
                    name: {
                        en: "Buddha's Birthday",
                        ko: "\uC11D\uAC00\uD0C4\uC2E0\uC77C"
                    }
                },
                '06-06': {
                    name: {
                        en: 'Memorial Day',
                        ko: "\uD604\uCDA9\uC77C"
                    }
                },
                '07-17': {
                    _name: 'Constitution Day',
                    type: 'observance'
                },
                '08-15': {
                    name: {
                        en: 'Liberation Day',
                        ko: "\uAD11\uBCF5\uC808"
                    }
                },
                'korean 8-0-15 P3D': {
                    name: {
                        en: 'Korean Thanksgiving',
                        ko: "\uCD94\uC11D"
                    }
                },
                '10-03': {
                    name: {
                        en: 'National Foundation Day',
                        ko: "\uAC1C\uCC9C\uC808"
                    }
                },
                '10-09': {
                    name: {
                        en: 'Hangul Day',
                        ko: "\uD55C\uAE00\uB0A0"
                    }
                },
                '12-25': {
                    _name: '12-25'
                }
            }
        },
        KY: {
            names: {
                en: 'Cayman Islands'
            },
            langs: [
                'en'
            ],
            zones: [
                'America/Panama'
            ],
            dayoff: 'sunday',
            days: {
                '01-01 and if Saturday, Sunday then next Monday': {
                    substitute: true,
                    _name: '01-01'
                },
                '4th Monday in January': {
                    name: {
                        en: 'National Heroes Day'
                    }
                },
                'easter -46': {
                    _name: 'easter -46'
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                easter: {
                    _name: 'easter',
                    type: 'observance'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '3rd Monday in May': {
                    name: {
                        en: 'Discovery Day'
                    }
                },
                '07-02': {
                    name: {
                        en: 'Constitution Day'
                    }
                },
                '12-25': {
                    _name: '12-25'
                },
                '12-26': {
                    _name: '12-26'
                },
                '2017-05-24': {
                    name: 'General Election Day'
                },
                '2021-04-14': {
                    name: 'General Election Day'
                },
                '2016-06-13': {
                    name: {
                        en: "Queen's Birthday"
                    }
                },
                '2017-06-19': {
                    name: {
                        en: "Queen's Birthday"
                    }
                },
                '2018-06-11': {
                    name: {
                        en: "Queen's Birthday"
                    }
                },
                '2019-06-10': {
                    name: {
                        en: "Queen's Birthday"
                    }
                },
                '2020-06-15': {
                    name: {
                        en: "Queen's Birthday"
                    }
                },
                '2021-06-14': {
                    name: {
                        en: "Queen's Birthday"
                    }
                },
                '2022-06-20': {
                    name: {
                        en: "Queen's Birthday"
                    }
                },
                '2023-06-19': {
                    name: {
                        en: "Queen's Birthday"
                    }
                },
                '2024-06-17': {
                    name: {
                        en: "Queen's Birthday"
                    }
                },
                '2025-06-16': {
                    name: {
                        en: "Queen's Birthday"
                    }
                },
                '2026-06-15': {
                    name: {
                        en: "Queen's Birthday"
                    }
                }
            }
        },
        LC: {
            names: {
                en: 'St. Lucia'
            },
            langs: [
                'en'
            ],
            zones: [
                'America/Port_of_Spain'
            ],
            dayoff: 'sunday',
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '01-02': {
                    name: {
                        en: "Second New Year's Day"
                    }
                },
                '02-22': {
                    _name: 'Independence Day'
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '05-01': {
                    _name: '05-01'
                },
                'easter 50': {
                    _name: 'easter 50'
                },
                'easter 60': {
                    _name: 'easter 60'
                },
                '1st Friday after 07-10 P4D': {
                    name: {
                        en: 'Carnival'
                    }
                },
                '08-01': {
                    name: {
                        en: 'Emancipation Day'
                    }
                },
                '1st Monday in October': {
                    name: {
                        en: 'Thanksgiving'
                    }
                },
                '12-13': {
                    name: {
                        en: 'National Day'
                    }
                },
                '12-25': {
                    _name: '12-25'
                },
                '12-26': {
                    _name: '12-26'
                }
            }
        },
        LI: {
            names: {
                de: 'Liechtenstein',
                en: 'Liechtenstein'
            },
            dayoff: 'sunday',
            langs: [
                'de'
            ],
            zones: [
                'Europe/Zurich'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '01-02': {
                    name: {
                        de: 'Berchtoldstag',
                        en: 'Berchtold Day'
                    },
                    type: 'bank'
                },
                '01-06': {
                    _name: '01-06'
                },
                '02-02': {
                    _name: '02-02',
                    type: 'observance'
                },
                '03-19': {
                    _name: '03-19',
                    type: 'observance'
                },
                'easter -47': {
                    _name: 'easter -47',
                    type: 'bank'
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                easter: {
                    _name: 'easter',
                    type: 'observance'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '05-01': {
                    _name: '05-01'
                },
                '2nd sunday in May': {
                    _name: 'Mothers Day',
                    type: 'observance'
                },
                'easter 39': {
                    _name: 'easter 39',
                    name: {
                        de: 'Auffahrt'
                    }
                },
                'easter 40': {
                    name: {
                        de: "Feiertagsbr\xfccke"
                    }
                },
                'easter 49': {
                    _name: 'easter 49',
                    type: 'observance'
                },
                'easter 50': {
                    _name: 'easter 50'
                },
                'easter 60': {
                    _name: 'easter 60'
                },
                'easter 61': {
                    name: {
                        de: "Feiertagsbr\xfccke"
                    }
                },
                '08-15': {
                    name: {
                        de: 'Staatsfeiertag'
                    },
                    type: 'observance'
                },
                '09-08': {
                    name: {
                        de: "Mari\xe4 Geburt"
                    }
                },
                '11-01': {
                    _name: '11-01',
                    type: 'observance'
                },
                '12-08': {
                    _name: '12-08'
                },
                '12-24': {
                    _name: '12-24',
                    type: 'bank'
                },
                '12-25': {
                    _name: '12-25'
                },
                '12-26': {
                    _name: '12-26',
                    name: {
                        de: 'Stephanstag'
                    }
                },
                '12-31': {
                    _name: '12-31',
                    type: 'bank'
                }
            }
        },
        LR: {
            names: {
                en: 'Liberia'
            },
            langs: [
                'en'
            ],
            zones: [
                'Africa/Monrovia'
            ],
            dayoff: 'Sunday',
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '02-11': {
                    name: {
                        en: 'Armed Forces Day'
                    }
                },
                '2nd Wednesday in March': {
                    name: {
                        en: 'Decoration Day'
                    }
                },
                '03-15': {
                    name: {
                        en: "J. J. Robert's Day"
                    }
                },
                '2nd Friday in April': {
                    name: {
                        en: 'Fast and Prayer Day'
                    }
                },
                '05-14': {
                    name: {
                        en: 'National Unification Day'
                    }
                },
                '07-26': {
                    _name: 'Independence Day'
                },
                '08-24': {
                    name: {
                        en: 'Flag Day'
                    }
                },
                '1st Thursday in November': {
                    name: {
                        en: 'Thanksgiving'
                    }
                },
                '11-29': {
                    name: {
                        en: "William Tubman's Birthday"
                    }
                },
                '12-25': {
                    _name: '12-25'
                }
            }
        },
        LS: {
            names: {
                st: "\\'Muso oa Lesotho",
                en: 'Lesotho'
            },
            langs: [
                'st',
                'en'
            ],
            zones: [
                'Africa/Johannesburg'
            ],
            dayoff: 'sunday',
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '03-11': {
                    name: {
                        en: 'Moshoeshoe Day'
                    }
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '05-01': {
                    _name: '05-01',
                    name: {
                        en: "Workers' Day"
                    }
                },
                'easter 39': {
                    _name: 'easter 39'
                },
                '05-25': {
                    name: {
                        en: "Africa Day/ Heroes' Day"
                    }
                },
                '07-17': {
                    name: {
                        en: "King Letsie III's Birthday"
                    }
                },
                '10-04': {
                    _name: 'Independence Day'
                },
                '12-25': {
                    _name: '12-25'
                },
                '12-26': {
                    _name: '12-26'
                }
            }
        },
        LT: {
            names: {
                lt: 'Lietuva',
                en: 'Lithuania'
            },
            dayoff: 'sunday',
            langs: [
                'lt'
            ],
            zones: [
                'Europe/Vilnius'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '02-16': {
                    name: {
                        en: 'Day of Restoration of the State of Lithuania',
                        lt: "Lietuvos valstyb\u0117s atk\u016Brimo diena"
                    }
                },
                '03-11': {
                    name: {
                        en: 'Day of Restoration of Independence of Lithuania',
                        lt: "Lietuvos nepriklausomyb\u0117s atk\u016Brimo diena"
                    }
                },
                easter: {
                    _name: 'easter'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '05-01': {
                    _name: '05-01'
                },
                '1st sunday in May': {
                    _name: 'Mothers Day',
                    type: 'observance'
                },
                '1st sunday in June': {
                    _name: 'Fathers Day',
                    type: 'observance'
                },
                '06-24': {
                    name: {
                        en: "St. John's Day",
                        lt: "Jonin\u0117s, Rasos"
                    }
                },
                '07-06': {
                    name: {
                        en: 'Statehood Day',
                        lt: "Valstyb\u0117s diena"
                    }
                },
                '08-15': {
                    _name: '08-15'
                },
                '11-01': {
                    _name: '11-01'
                },
                '11-02': {
                    _name: '11-02',
                    active: [
                        {
                            from: 2020
                        }
                    ]
                },
                '12-24': {
                    _name: '12-24'
                },
                '12-25': {
                    _name: '12-25'
                },
                '12-26': {
                    _name: '12-26'
                }
            }
        },
        LU: {
            names: {
                fr: 'Luxembourg',
                en: 'Luxembourg',
                de: 'Luxemburg',
                lb: "L\xebtzebuerg",
                pt: 'Luxemburgo'
            },
            langs: [
                'fr',
                'de',
                'lb'
            ],
            zones: [
                'Europe/Luxembourg'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '01-23': {
                    _name: 'National Holiday',
                    active: [
                        {
                            from: '1947-08-08',
                            to: '1961-12-23'
                        }
                    ]
                },
                'easter -2': {
                    _name: 'easter -2',
                    type: 'observance'
                },
                easter: {
                    _name: 'easter',
                    type: 'observance'
                },
                'easter 1': {
                    _name: 'easter 1',
                    active: [
                        {
                            from: '1892-02-16'
                        }
                    ]
                },
                '05-01': {
                    _name: '05-01',
                    name: {
                        fr: '1er mai'
                    },
                    active: [
                        {
                            from: '1946-04-23'
                        }
                    ]
                },
                '05-09': {
                    _name: '05-09',
                    active: [
                        {
                            from: '2019-01-01'
                        }
                    ]
                },
                'easter 39': {
                    _name: 'easter 39'
                },
                'easter 50': {
                    _name: 'easter 50',
                    active: [
                        {
                            from: '1892-02-16'
                        }
                    ]
                },
                '06-23': {
                    _name: 'National Holiday',
                    active: [
                        {
                            from: '1961-12-23'
                        }
                    ]
                },
                '08-15': {
                    _name: '08-15'
                },
                '11-01': {
                    _name: '11-01'
                },
                '12-25': {
                    _name: '12-25'
                },
                '12-26': {
                    _name: '12-26',
                    active: [
                        {
                            from: '1892-02-16'
                        }
                    ]
                }
            }
        },
        LV: {
            names: {
                lv: 'Latvija',
                en: 'Latvia'
            },
            dayoff: 'sunday',
            langs: [
                'lv'
            ],
            zones: [
                'Europe/Riga'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                easter: {
                    _name: 'easter'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '05-01': {
                    _name: '05-01'
                },
                '05-04 and if saturday,sunday then next monday': {
                    substitute: true,
                    name: {
                        en: 'Restoration of Independence day',
                        lv: "Latvijas Republikas Neatkar\u012Bbas atjauno\u0161anas diena"
                    }
                },
                '2nd sunday in May': {
                    _name: 'Mothers Day',
                    type: 'observance'
                },
                '06-23': {
                    name: {
                        en: 'Midsummer Eve',
                        lv: "L\u012Bgo Diena"
                    }
                },
                '06-24': {
                    name: {
                        en: 'Midsummer',
                        lv: "J\u0101\u0146i"
                    }
                },
                '11-18 and if saturday,sunday then next monday': {
                    substitute: true,
                    name: {
                        en: 'Republic Day',
                        lv: "Latvijas Republikas proklam\u0113\u0161anas diena"
                    }
                },
                '12-24': {
                    _name: '12-24'
                },
                '12-25': {
                    _name: '12-25'
                },
                '12-26': {
                    _name: '12-26'
                },
                '12-31': {
                    _name: '12-31'
                },
                '2023-05-29': {
                    name: {
                        en: 'Bronze medal of the Latvian hockey team at the 2023 World Hockey Championship',
                        lv: "Latvijas hokeja komandas 2023. gada Pasaules hokeja \u010Dempion\u0101t\u0101 bronzas meda\u013Ca"
                    }
                }
            }
        },
        LY: {
            names: {
                ar: "\u062F\u0648\u0644\u0629 \u0644\u064A\u0628\u064A\u0627",
                en: 'Libya'
            },
            langs: [
                'ar'
            ],
            zones: [
                'Africa/Tripoli'
            ],
            dayoff: '',
            days: {
                '02-17': {
                    _name: 'Revolution Day'
                },
                '05-01': {
                    _name: '05-01'
                },
                '09-16': {
                    name: {
                        ar: "\u064A\u0648\u0645 \u0627\u0644\u0634\u0647\u062F\u0627\u0621",
                        en: "Martyrs' Day"
                    }
                },
                '10-23': {
                    _name: 'Liberation Day'
                },
                '12-24': {
                    _name: 'Independence Day'
                },
                '1 Muharram': {
                    _name: '1 Muharram'
                },
                '12 Rabi al-awwal': {
                    _name: '12 Rabi al-awwal'
                },
                '1 Shawwal P3D': {
                    _name: '1 Shawwal'
                },
                '9 Dhu al-Hijjah': {
                    _name: '9 Dhu al-Hijjah'
                },
                '10 Dhu al-Hijjah P3D': {
                    _name: '10 Dhu al-Hijjah'
                }
            }
        },
        MA: {
            names: {
                ar: "\u0627\u0644\u0645\u0645\u0644\u0643\u0629 \u0627\u0644\u0645\u063A\u0631\u0628\u064A\u0629",
                fr: 'Royaume du Maroc',
                en: 'Kingdom of Morocco'
            },
            langs: [
                'ar',
                'ber',
                'fr'
            ],
            zones: [
                'Africa/Casablanca'
            ],
            dayoff: 'sunday',
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '01-11': {
                    name: {
                        fr: "Manifeste de l'ind\xe9pendance",
                        ar: "\u0630\u0643\u0631\u0649 \u062A\u0642\u062F\u064A\u0645 \u0648\u062B\u064A\u0642\u0629 \u0627\u0644\u0627\u0633\u062A\u0642\u0644\u0627\u0644",
                        en: 'Anniversary of the Independence Manifesto'
                    }
                },
                '05-01': {
                    _name: '05-01'
                },
                '07-30': {
                    name: {
                        fr: "F\xeate du tr\xf4ne",
                        ar: "\u0639\u064A\u062F \u0627\u0644\u0639\u0631\u0634",
                        en: 'Feast of the Throne'
                    }
                },
                '08-14': {
                    name: {
                        fr: "Journ\xe9e de Oued Ed-Dahab",
                        ar: "\u064A\u0648\u0645 \u0648\u0627\u062F\u064A \u0627\u0644\u0630\u0647\u0628",
                        en: 'Anniversary of the Recovery Oued Ed-Dahab'
                    }
                },
                '08-20': {
                    name: {
                        fr: "F\xeate de la r\xe9volution du roi et du peuple",
                        ar: "\u062B\u0648\u0631\u0629 \u0627\u0644\u0645\u0644\u0643 \u0648\u0627\u0644\u0634\u0639\u0628",
                        en: 'Anniversary of the Revolution of the King and the People'
                    }
                },
                '08-21': {
                    name: {
                        fr: "Journ\xe9e de la jeunesse",
                        ar: "\u0639\u064A\u062F \u0627\u0644\u0634\u0628\u0627\u0628",
                        en: 'Youth Day'
                    }
                },
                '11-06': {
                    name: {
                        fr: 'La Marche verte',
                        ar: "\u0627\u0644\u0645\u0633\u064A\u0631\u0629 \u0627\u0644\u062E\u0636\u0631\u0627\u0621",
                        en: 'Anniversary of the Green March'
                    }
                },
                '11-18': {
                    _name: 'Independence Day',
                    name: {
                        fr: "F\xeate de l'ind\xe9pendance"
                    }
                },
                '1 Muharram': {
                    _name: '1 Muharram'
                },
                '12 Rabi al-awwal': {
                    _name: '12 Rabi al-awwal'
                },
                '1 Shawwal': {
                    _name: '1 Shawwal'
                },
                '10 Dhu al-Hijjah': {
                    _name: '10 Dhu al-Hijjah'
                }
            }
        },
        MC: {
            names: {
                fr: 'Monaco',
                en: 'Monaco'
            },
            dayoff: 'sunday',
            langs: [
                'fr'
            ],
            zones: [
                'Europe/Monaco'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '01-27 and if sunday then next monday': {
                    substitute: true,
                    name: {
                        en: "Saint Devota's Day",
                        fr: "Sainte D\xe9vote"
                    }
                },
                'easter -2': {
                    _name: 'easter -2',
                    type: 'observance'
                },
                easter: {
                    _name: 'easter',
                    type: 'observance'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '05-01 and if sunday then next monday': {
                    substitute: true,
                    _name: '05-01',
                    name: {
                        fr: '1er mai'
                    }
                },
                'easter 39': {
                    _name: 'easter 39'
                },
                'easter 50': {
                    _name: 'easter 50'
                },
                'easter 60': {
                    _name: 'easter 60'
                },
                '08-15': {
                    _name: '08-15'
                },
                '11-01': {
                    _name: '11-01'
                },
                '11-19 and if sunday then next monday': {
                    substitute: true,
                    name: {
                        en: "H.S.H. the Sovereign Prince's Day",
                        fr: "La F\xeate du Prince"
                    }
                },
                '12-08': {
                    _name: '12-08'
                },
                '12-25 and if sunday then next monday': {
                    substitute: true,
                    _name: '12-25'
                }
            }
        },
        MD: {
            names: {
                ro: 'Republica Moldova',
                en: 'Moldova'
            },
            langs: [
                'ro'
            ],
            zones: [
                'Europe/Chisinau'
            ],
            dayoff: 'sunday',
            days: {
                '01-01': {
                    _name: '01-01'
                },
                'julian 12-25 P2D': {
                    _name: 'julian 12-25',
                    name: {
                        ro: 'Craciun pe Rit Vechi'
                    }
                },
                '03-08': {
                    _name: '03-08'
                },
                orthodox: {
                    _name: 'easter'
                },
                'orthodox 1': {
                    _name: 'easter 1'
                },
                'orthodox 8': {
                    name: {
                        ro: "Pa\u015Ftele Bl\u0103jinilor",
                        en: 'Memorial Day'
                    }
                },
                '05-01': {
                    _name: '05-01'
                },
                '05-09': {
                    name: {
                        ro: 'Ziua Victoriei',
                        en: 'Victory Day'
                    }
                },
                '08-27': {
                    _name: 'Independence Day'
                },
                '08-31': {
                    name: {
                        ro: "Limba noastr\u0103",
                        en: 'National Language Day'
                    }
                },
                '1st saturday in October P2D': {
                    name: {
                        ro: 'Ziua vinului',
                        en: 'Wine Day'
                    },
                    type: 'observance',
                    active: [
                        {
                            from: 2013
                        }
                    ]
                },
                '12-25': {
                    _name: '12-25',
                    name: {
                        ro: 'Craciun pe stil Nou'
                    }
                }
            },
            states: {
                CA: {
                    name: 'Cahul',
                    days: {
                        '11-21': {
                            name: {
                                ro: 'Ziua Cahul',
                                en: 'Cahul Day'
                            }
                        }
                    }
                },
                CU: {
                    name: "Chi\u0219in\u0103u",
                    days: {
                        '10-14': {
                            name: {
                                ro: 'Ziua capitalului',
                                en: "Capital's Day"
                            }
                        }
                    }
                }
            }
        },
        ME: {
            names: {
                hr: 'Crna Gora',
                sr: "\u0426\u0440\u043D\u0430 \u0413\u043E\u0440\u0430",
                bs: 'Crna Gora',
                sq: 'Mali i Zi',
                en: 'Montenegro'
            },
            dayoff: 'sunday',
            langs: [
                'hr',
                'sr',
                'bs',
                'sq'
            ],
            zones: [
                'Europe/Belgrade'
            ],
            days: {
                '05-21 and if sunday then next tuesday': {
                    substitute: true,
                    _name: 'Independence Day'
                },
                '05-22 and if sunday then next monday': {
                    substitute: true,
                    _name: 'Independence Day'
                },
                '07-13 and if sunday then next tuesday': {
                    substitute: true,
                    name: {
                        hr: "Dan dr\u017Eavnosti",
                        sr: "\u0414\u0430\u043D \u0434\u0440\u0436\u0430\u0432\u043D\u043E\u0441\u0442\u0438",
                        en: 'Statehood Day'
                    }
                },
                '07-14 and if sunday then next monday': {
                    substitute: true,
                    name: {
                        hr: "Dan dr\u017Eavnosti",
                        sr: "\u0414\u0430\u043D \u0434\u0440\u0436\u0430\u0432\u043D\u043E\u0441\u0442\u0438",
                        en: 'Statehood Day'
                    }
                },
                '01-01 and if sunday then next tuesday': {
                    substitute: true,
                    _name: '01-01'
                },
                '01-02 and if sunday then next monday': {
                    substitute: true,
                    _name: '01-01'
                },
                '05-01 and if sunday then next tuesday': {
                    substitute: true,
                    _name: '05-01'
                },
                '05-02 and if sunday then next monday': {
                    substitute: true,
                    _name: '05-01'
                },
                'julian 12-24': {
                    _name: '12-24'
                },
                'julian 12-25': {
                    _name: '12-25'
                },
                'julian 12-26': {
                    _name: '12-26'
                },
                'julian 01-01': {
                    _name: 'julian 01-01',
                    type: 'observance'
                },
                'orthodox -2': {
                    _name: 'easter -2'
                },
                orthodox: {
                    _name: 'easter'
                },
                '12-24': {
                    _name: '12-24'
                },
                '12-25': {
                    _name: '12-25'
                },
                '12-26': {
                    _name: '12-25'
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                easter: {
                    _name: 'easter'
                },
                'easter 1': {
                    _name: 'easter'
                },
                '08-15': {
                    _name: '08-15',
                    type: 'observance'
                },
                '11-01': {
                    _name: '11-01'
                },
                '1 Shawwal P3D': {
                    _name: '1 Shawwal'
                },
                '10 Dhu al-Hijjah P3D': {
                    _name: '10 Dhu al-Hijjah'
                },
                '1 Muharram': {
                    _name: '1 Muharram',
                    type: 'observance'
                },
                '12 Rabi al-awwal': {
                    _name: '12 Rabi al-awwal',
                    type: 'observance'
                },
                '27 Rajab': {
                    _name: '27 Rajab',
                    type: 'observance'
                },
                '15 Shaban': {
                    _name: '15 Shaban',
                    type: 'observance'
                },
                '1 Ramadan': {
                    _name: '1 Ramadan',
                    type: 'observance'
                },
                '27 Ramadan': {
                    _name: '27 Ramadan',
                    type: 'observance'
                },
                '15 Nisan P2D': {
                    _name: '15 Nisan'
                },
                '1 Tishrei': {
                    _name: '1 Tishrei',
                    type: 'observance'
                },
                '10 Tishrei P2D': {
                    _name: '10 Tishrei'
                }
            }
        },
        MF: {
            names: {
                en: 'St. Martin',
                fr: 'Saint Martin'
            },
            langs: [
                'fr'
            ],
            zones: [
                'America/Marigot'
            ],
            dayoff: 'sunday',
            _days: 'FR',
            days: {
                '05-27': {
                    name: {
                        fr: "Abolition de l'esclavage",
                        en: 'abolition of slavery'
                    }
                }
            }
        },
        MG: {
            names: {
                mg: "Repoblikan'i Madagasikara",
                fr: "R\xe9publique de Madagascar",
                en: 'Madagascar'
            },
            dayoff: 'sunday',
            langs: [
                'mg',
                'fr',
                'en'
            ],
            zones: [
                'Africa/Nairobi'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '03-08': {
                    name: {
                        mg: "Andro iraisam-pirenena ho an'ny vehivavy",
                        fr: "Journ\xe9e internationale de la femme",
                        en: "International Women's Day"
                    },
                    note: 'only for women'
                },
                '03-29': {
                    name: {
                        mg: "Martioran'ny tolona tamin'ny 1947",
                        fr: "Comm\xe9moration des martyrs de l'insurrection de 1947.",
                        en: "Martyrs' Day"
                    }
                },
                easter: {
                    _name: 'easter'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '05-01': {
                    _name: '05-01'
                },
                '05-25': {
                    name: {
                        mg: "Andron'i Afrika",
                        fr: "Jour de l'Afrique",
                        en: 'Africa Day'
                    }
                },
                'easter 39': {
                    _name: 'easter 39'
                },
                'easter 50': {
                    _name: 'easter 50'
                },
                '06-26': {
                    _name: 'Independence Day',
                    name: {
                        mg: 'Fetim-pirenena',
                        fr: "F\xeate Nationale"
                    }
                },
                '08-15': {
                    _name: '08-15'
                },
                '11-01': {
                    _name: '11-01'
                },
                '12-25': {
                    _name: '12-25'
                },
                '1 Shawwal': {
                    _name: '1 Shawwal',
                    note: 'For Muslim'
                },
                '10 Dhu al-Hijjah': {
                    _name: '10 Dhu al-Hijjah',
                    note: 'For Muslim'
                }
            }
        },
        MK: {
            names: {
                mk: "\u0420\u0435\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041C\u0430\u043A\u0435\u0434\u043E\u043D\u0438\u0458\u0430",
                en: 'Macedonia'
            },
            langs: [
                'mk'
            ],
            zones: [
                'Europe/Belgrade'
            ],
            dayoff: 'sunday',
            days: {
                '01-01 and if sunday then next monday': {
                    substitute: true,
                    _name: '01-01'
                },
                'julian 12-25 and if sunday then next monday': {
                    substitute: true,
                    _name: 'julian 12-25'
                },
                orthodox: {
                    _name: 'orthodox'
                },
                'orthodox 1': {
                    _name: 'orthodox 1'
                },
                '05-01 and if sunday then next monday': {
                    substitute: true,
                    _name: '05-01'
                },
                '05-24 and if sunday then next monday': {
                    substitute: true,
                    name: {
                        mk: "\u0421\u0432. \u041A\u0438\u0440\u0438\u043B \u0438 \u041C\u0435\u0442\u043E\u0434\u0438\u0458",
                        en: 'Saints Cyril and Methodius Day'
                    }
                },
                '08-02 and if sunday then next monday': {
                    substitute: true,
                    name: {
                        mk: "\u0414\u0435\u043D \u043D\u0430 \u0420\u0435\u043F\u0443\u0431\u043B\u0438\u043A\u0430\u0442\u0430",
                        en: 'Day of the Republic'
                    }
                },
                '09-08 and if sunday then next monday': {
                    substitute: true,
                    _name: 'Independence Day'
                },
                '10-11 and if sunday then next monday': {
                    substitute: true,
                    name: {
                        mk: "\u0414\u0435\u043D \u043D\u0430 \u0432\u043E\u0441\u0442\u0430\u043D\u0438\u0435\u0442\u043E",
                        en: 'Revolution Day'
                    }
                },
                '10-23 and if sunday then next monday': {
                    substitute: true,
                    name: {
                        mk: "\u0414\u0435\u043D \u043D\u0430 \u043C\u0430\u043A\u0435\u0434\u043E\u043D\u0441\u043A\u0430\u0442\u0430 \u0440\u0435\u0432\u043E\u043B\u0443\u0446\u0438\u043E\u043D\u0435\u0440\u043D\u0430 \u0431\u043E\u0440\u0431\u0430",
                        en: 'Day of the Macedonian Revolutionary Struggle'
                    }
                },
                '12-08 and if sunday then next monday': {
                    substitute: true,
                    name: {
                        mk: "\u0421\u0432. \u041A\u043B\u0438\u043C\u0435\u043D\u0442 \u041E\u0445\u0440\u0438\u0434\u0441\u043A\u0438",
                        en: 'Saint Clement of Ohrid Day'
                    }
                },
                '1 Shawwal and if sunday then next monday': {
                    substitute: true,
                    _name: '1 Shawwal'
                },
                'julian 12-24': {
                    _name: 'julian 12-24',
                    type: 'optional',
                    note: 'Orthodox believers'
                },
                'julian 01-06': {
                    _name: '01-06',
                    type: 'optional',
                    note: 'Orthodox believers'
                },
                'orthodox -2': {
                    _name: 'orthodox -2',
                    type: 'optional',
                    note: 'Orthodox believers'
                },
                'orthodox 47': {
                    name: {
                        mk: "\u043F\u0435\u0442\u043E\u043A \u043F\u0440\u0435\u0434 \u0414\u0443\u0445\u043E\u0432\u0434\u0435\u043D",
                        en: 'Friday before Pentecost'
                    },
                    type: 'optional',
                    note: 'Orthodox believers'
                },
                'orthodox 49': {
                    _name: 'easter 49',
                    type: 'optional',
                    note: 'Orthodox believers'
                },
                'julian 08-15': {
                    _name: '08-15',
                    type: 'optional',
                    note: 'Orthodox believers'
                },
                '10 Dhu al-Hijjah': {
                    _name: '10 Dhu al-Hijjah',
                    type: 'optional',
                    note: 'Muslim believers'
                },
                '10 Tishrei': {
                    _name: '10 Tishrei',
                    type: 'optional',
                    note: 'Jewish believers'
                },
                'easter 1': {
                    _name: 'easter 1',
                    type: 'optional',
                    note: 'Catholic believers'
                },
                '11-01': {
                    _name: '11-01',
                    type: 'optional',
                    note: 'Catholic believers'
                },
                '12-25': {
                    _name: '12-25',
                    type: 'optional',
                    note: 'Catholic believers'
                },
                '11-22': {
                    name: {
                        mk: "\u0414\u0435\u043D \u043D\u0430 \u0410\u043B\u0431\u0430\u043D\u0441\u043A\u0430\u0442\u0430 \u0430\u0437\u0431\u0443\u043A\u0430",
                        en: 'Day of the Albanian Alphabet'
                    },
                    type: 'optional',
                    note: 'For members of the Albanian community'
                },
                '12-21': {
                    name: {
                        mk: "\u0414\u0435\u043D \u043D\u0430 \u043D\u0430\u0441\u0442\u0430\u0432\u0430 \u043D\u0430 \u0442\u0443\u0440\u0441\u043A\u0438 \u0458\u0430\u0437\u0438\u043A",
                        en: 'Turkish Language Day'
                    },
                    type: 'optional',
                    note: 'For members of the the Turkish community'
                },
                '01-27': {
                    name: {
                        mk: "\u0421\u0432\u0435\u0442\u0438 \u0421\u0430\u0432\u0430",
                        en: 'St. Sava'
                    },
                    type: 'optional',
                    note: 'For members of the Serbian community'
                },
                '04-08': {
                    name: {
                        mk: "\u041C\u0435\u0453\u0443\u043D\u0430\u0440\u043E\u0434\u0435\u043D \u0434\u0435\u043D \u043D\u0430 \u0420\u043E\u043C\u0438\u0442\u0435",
                        en: 'International Roma Day'
                    },
                    type: 'optional',
                    note: 'For members of the the Roma community'
                },
                '05-23': {
                    name: {
                        mk: "\u041D\u0430\u0446\u0438\u043E\u043D\u0430\u043B\u0435\u043D \u0434\u0435\u043D \u043D\u0430 \u0412\u043B\u0430\u0441\u0442\u0438\u0442\u0435",
                        en: 'National Day of Authorities'
                    },
                    type: 'optional',
                    note: 'For members of the Vlach community'
                },
                '09-28': {
                    name: {
                        mk: "\u041C\u0435\u0453\u0443\u043D\u0430\u0440\u043E\u0434\u0435\u043D \u0434\u0435\u043D \u043D\u0430 \u0411\u043E\u0448\u045A\u0430\u0446\u0438\u0442\u0435",
                        en: 'International Day of Bosniaks'
                    },
                    type: 'optional',
                    note: 'For Members of the Bosniak community.'
                }
            }
        },
        ML: {
            names: {
                fr: "R\xe9publique du Mali",
                en: 'Republic of Mali'
            },
            langs: [
                'fr',
                'en'
            ],
            zones: [
                'Africa/Abidjan'
            ],
            dayoff: 'sunday',
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '01-20': {
                    name: {
                        fr: "F\xeate de l'arm\xe9e",
                        en: 'Army Day'
                    }
                },
                '03-26': {
                    name: {
                        fr: "Journ\xe9e des Martyrs",
                        en: "Martyrs' Day"
                    }
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '05-01': {
                    _name: '05-01'
                },
                '12-25': {
                    _name: '12-25'
                },
                '1 Shawwal': {
                    _name: '1 Shawwal'
                },
                '05-25': {
                    name: "Jour de l'Afrique"
                },
                '10 Dhu al-Hijjah': {
                    _name: '10 Dhu al-Hijjah'
                },
                '09-22': {
                    _name: 'Independence Day',
                    name: {
                        fr: "F\xeate nationale de l'ind\xe9pendance"
                    }
                },
                '12 Rabi al-awwal': {
                    _name: '12 Rabi al-awwal'
                }
            }
        },
        MQ: {
            names: {
                fr: 'Martinique',
                en: 'Martinique'
            },
            langs: [
                'fr'
            ],
            zones: [
                'America/Martinique'
            ],
            dayoff: 'sunday',
            _days: 'FR',
            days: {
                'easter -2': {
                    _name: 'easter -2'
                },
                '05-22': {
                    _name: 'Abolition of Slavery'
                },
                '07-21': {
                    name: {
                        fr: 'Jour de Victor Schoelcher',
                        en: 'Victor Shoelcher Day'
                    }
                }
            }
        },
        MR: {
            names: {
                ar: "\u0627\u0644\u062C\u0645\u0647\u0648\u0631\u064A\u0629 \u0627\u0644\u0625\u0633\u0644\u0627\u0645\u064A\u0629 \u0627\u0644\u0645\u0648\u0631\u064A\u062A\u0627\u0646\u064A\u0629",
                en: 'Mauritania'
            },
            langs: [
                'ar',
                'fr'
            ],
            zones: [
                'Africa/Abidjan'
            ],
            dayoff: '',
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '05-01': {
                    _name: '05-01'
                },
                '05-25': {
                    name: {
                        ar: "\u064A\u0648\u0645 \u0627\u0641\u0631\u064A\u0642\u064A\u0627",
                        en: 'Africa Day'
                    }
                },
                '11-28': {
                    _name: 'Independence Day'
                },
                '1 Muharram': {
                    _name: '1 Muharram'
                },
                '12 Rabi al-awwal': {
                    _name: '12 Rabi al-awwal'
                },
                '1 Shawwal': {
                    _name: '1 Shawwal'
                },
                '10 Dhu al-Hijjah P3D': {
                    _name: '10 Dhu al-Hijjah'
                }
            }
        },
        MS: {
            names: {
                en: 'Montserrat'
            },
            langs: [
                'en'
            ],
            zones: [
                'America/Port_of_Spain'
            ],
            dayoff: 'sunday',
            days: {
                '01-01 and if Saturday then next Monday if Sunday then next Tuesday': {
                    substitute: true,
                    _name: '01-01'
                },
                '03-17 and if Saturday, Sunday then next Monday': {
                    substitute: true,
                    name: {
                        en: "Saint Patrick's Day"
                    }
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '1st Monday in May': {
                    _name: '05-01'
                },
                'easter 50': {
                    _name: 'easter 50'
                },
                '2nd Monday after 06-02': {
                    name: {
                        en: "Queen's Birthday Celebration"
                    }
                },
                '08-01 if Saturday, Sunday then next Monday': {
                    name: {
                        en: 'Emancipation Day'
                    }
                },
                '12-25 and if Saturday then next Monday if Sunday then next Tuesday': {
                    substitute: true,
                    _name: '12-25'
                },
                '12-26 and if Saturday then next Monday if Sunday then next Tuesday': {
                    substitute: true,
                    _name: '12-26'
                },
                '12-31 and if Saturday then next Monday if Sunday then next Tuesday': {
                    substitute: true,
                    _name: '12-31',
                    name: {
                        en: 'Festival Day'
                    }
                }
            }
        },
        MT: {
            names: {
                mt: 'Malta',
                en: 'Malta'
            },
            dayoff: 'sunday',
            langs: [
                'mt'
            ],
            zones: [
                'Europe/Malta'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '02-10': {
                    name: {
                        en: "Feast of Saint Paul's Shipwreck in Malta",
                        mt: "Nawfra\u0121ju ta' San Pawl"
                    }
                },
                '03-19': {
                    _name: '03-19'
                },
                '03-31': {
                    name: {
                        en: 'Freedom Day',
                        mt: "Jum il-\u0126elsien"
                    }
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                '05-01': {
                    _name: '05-01'
                },
                '06-07': {
                    name: {
                        mt: 'Sette Giugno',
                        en: 'June 7th'
                    }
                },
                '06-29': {
                    _name: '06-29'
                },
                '08-15': {
                    _name: '08-15'
                },
                '09-08': {
                    name: {
                        en: 'Victory Day',
                        mt: 'Jum il-Vitorja'
                    }
                },
                '09-21': {
                    _name: 'Independence Day'
                },
                '12-08': {
                    _name: '12-08'
                },
                '12-13': {
                    name: {
                        en: 'Republic Day',
                        mt: 'Jum ir-Repubblika'
                    }
                },
                '12-25': {
                    _name: '12-25'
                }
            }
        },
        MW: {
            names: {
                en: 'Malawi'
            },
            dayoff: 'sunday',
            langs: [
                'en'
            ],
            zones: [
                'Africa/Maputo'
            ],
            days: {
                '01-01 and if saturday,sunday then next monday': {
                    substitute: true,
                    _name: '01-01'
                },
                '01-15 and if saturday,sunday then next monday': {
                    substitute: true,
                    name: {
                        en: 'John Chilembwe Day'
                    }
                },
                '03-03 and if saturday,sunday then next monday': {
                    name: {
                        en: "Martyrs' Day"
                    }
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                easter: {
                    _name: 'easter',
                    type: 'observance'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '05-01 and if saturday,sunday then next monday': {
                    _name: '05-01'
                },
                '05-14 and if saturday,sunday then next monday': {
                    substitute: true,
                    name: {
                        en: 'Kamuzu Day'
                    }
                },
                '07-06 and if saturday,sunday then next monday': {
                    substitute: true,
                    _name: 'Independence Day'
                },
                '10-15 and if saturday,sunday then next monday': {
                    substitute: true,
                    _name: 'Mothers Day'
                },
                '12-25 and if saturday,sunday then next monday': {
                    substitute: true,
                    _name: '12-25'
                },
                '1 Shawwal and if saturday,sunday then next monday': {
                    substitute: true,
                    _name: '1 Shawwal',
                    name: {
                        en: 'Eid al Fitri'
                    }
                }
            }
        },
        MX: {
            names: {
                es: "M\xe9xico",
                en: 'Mexico'
            },
            dayoff: 'sunday',
            langs: [
                'es'
            ],
            zones: [
                'America/Mexico_City',
                'America/Cancun',
                'America/Merida',
                'America/Monterrey',
                'America/Matamoros',
                'America/Mazatlan',
                'America/Chihuahua',
                'America/Ojinaga',
                'America/Hermosillo',
                'America/Tijuana',
                'America/Santa_Isabel',
                'America/Bahia_Banderas'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '02-05': {
                    _name: 'Constitution Day',
                    active: [
                        {
                            to: '2006-01-17T00:00:00.000Z'
                        }
                    ]
                },
                '1st monday in February': {
                    _name: 'Constitution Day',
                    active: [
                        {
                            from: '2006-01-18T00:00:00.000Z'
                        }
                    ]
                },
                '03-21': {
                    name: {
                        en: "Benito Ju\xe1rez's birthday",
                        es: "Natalicio de Benito Ju\xe1rez"
                    },
                    active: [
                        {
                            to: '2006-12-31T00:00:00.000Z'
                        }
                    ]
                },
                '3rd monday in March': {
                    name: {
                        en: "Benito Ju\xe1rez's birthday",
                        es: "Natalicio de Benito Ju\xe1rez"
                    },
                    active: [
                        {
                            from: '2007-01-01T00:00:00.000Z'
                        }
                    ]
                },
                'easter -3': {
                    _name: 'easter -3',
                    type: 'bank'
                },
                'easter -2': {
                    _name: 'easter -2',
                    type: 'bank'
                },
                '05-01': {
                    _name: '05-01'
                },
                '05-10': {
                    _name: 'Mothers Day',
                    type: 'observance'
                },
                '09-16': {
                    _name: 'Independence Day'
                },
                '11-02': {
                    _name: '11-02',
                    type: 'bank'
                },
                '11-20': {
                    _name: 'Revolution Day',
                    active: [
                        {
                            to: '2006-01-17T00:00:00.000Z'
                        }
                    ]
                },
                '3rd monday in November': {
                    _name: 'Revolution Day',
                    active: [
                        {
                            from: '2006-01-18T00:00:00.000Z'
                        }
                    ]
                },
                '12-01 every 6 years since 1934': {
                    name: {
                        en: 'Change of Federal Government',
                        es: "Transmisi\xf3n del Poder Ejecutivo Federal"
                    }
                },
                '12-12': {
                    name: {
                        en: 'Day of the Virgin of Guadalupe',
                        es: "D\xeda de la Virgen de Guadalupe"
                    },
                    type: 'bank'
                },
                '12-25': {
                    _name: '12-25'
                }
            }
        },
        MY: {
            names: {
                en: 'Malaysia'
            },
            langs: [
                'ms'
            ],
            zones: [
                'Asia/Kuala_Lumpur',
                'Asia/Kuching'
            ],
            dayoff: 'Saturday',
            days: {
                '01-01': {
                    _name: '01-01'
                },
                'substitutes 01-01 if Sunday then next Monday': {
                    substitute: true,
                    _name: '01-01'
                },
                'chinese 01-0-01': {
                    name: {
                        en: 'Chinese New Year',
                        ms: 'Tahun Baru Cina'
                    }
                },
                'chinese 01-0-02': {
                    name: {
                        en: 'Chinese New Year',
                        ms: 'Tahun Baru Cina'
                    }
                },
                'substitutes chinese 01-0-01 if Sunday then next Monday': {
                    substitute: true,
                    name: {
                        en: 'Chinese New Year',
                        ms: 'Tahun Baru Cina'
                    }
                },
                'substitutes chinese 01-0-02 if Sunday then next Monday': {
                    substitute: true,
                    name: {
                        en: 'Chinese New Year',
                        ms: 'Tahun Baru Cina'
                    }
                },
                '05-01': {
                    _name: '05-01'
                },
                'substitutes 05-01 if Sunday then next Monday': {
                    substitute: true,
                    _name: '05-01'
                },
                '1st Monday in June': {
                    name: {
                        en: "Yang di-Pertuan Agong's Birthday",
                        ms: 'Hari Keputeraan Yang di-Pertuan Agong'
                    }
                },
                '08-31': {
                    _name: 'Independence Day'
                },
                'substitutes 08-31 if Sunday then next Monday': {
                    substitute: true,
                    _name: 'Independence Day'
                },
                '09-16': {
                    name: {
                        en: 'Malaysia Day',
                        ms: 'Hari Malaysia'
                    }
                },
                'substitutes 09-16 if Sunday then next Monday': {
                    substitute: true,
                    name: {
                        en: 'Malaysia Day',
                        ms: 'Hari Malaysia'
                    }
                },
                '12-25': {
                    _name: '12-25'
                },
                'substitutes 12-25 if Sunday then next Monday': {
                    substitute: true,
                    _name: '12-25'
                },
                '17 Ramadan': {
                    _name: '17 Ramadan',
                    disable: [
                        '2022-04-18'
                    ],
                    enable: [
                        '2022-04-19'
                    ]
                },
                '1 Shawwal': {
                    _name: '1 Shawwal',
                    disable: [
                        '2022-05-02'
                    ],
                    enable: [
                        '2022-05-03'
                    ]
                },
                '2 Shawwal': {
                    _name: '1 Shawwal',
                    disable: [
                        '2022-05-03'
                    ],
                    enable: [
                        '2022-05-04'
                    ]
                },
                '10 Dhu al-Hijjah': {
                    _name: '10 Dhu al-Hijjah',
                    disable: [
                        '2022-07-09'
                    ],
                    enable: [
                        '2022-07-10'
                    ]
                },
                '1 Muharram': {
                    _name: '1 Muharram'
                },
                '12 Rabi al-awwal': {
                    _name: '12 Rabi al-awwal',
                    disable: [
                        '2022-10-08'
                    ],
                    enable: [
                        '2022-10-09'
                    ]
                },
                '2010-05-28': {
                    _name: 'Vesak'
                },
                '2011-05-17': {
                    _name: 'Vesak'
                },
                '2012-05-06': {
                    _name: 'Vesak'
                },
                '2013-05-25': {
                    _name: 'Vesak'
                },
                '2014-05-15': {
                    _name: 'Vesak'
                },
                '2015-06-02': {
                    _name: 'Vesak'
                },
                '2016-05-22': {
                    _name: 'Vesak'
                },
                '2017-05-10': {
                    _name: 'Vesak'
                },
                '2018-05-29': {
                    _name: 'Vesak'
                },
                '2019-05-19': {
                    _name: 'Vesak'
                },
                '2020-05-07': {
                    _name: 'Vesak'
                },
                '2021-05-26': {
                    _name: 'Vesak'
                },
                '2022-05-15': {
                    _name: 'Vesak'
                },
                '2022-05-16': {
                    substitute: true,
                    _name: 'Vesak'
                },
                '2023-05-04': {
                    _name: 'Vesak'
                },
                '2024-05-22': {
                    _name: 'Vesak'
                },
                '2025-05-12': {
                    _name: 'Vesak'
                },
                '2026-05-31': {
                    _name: 'Vesak'
                },
                '2016-10-29': {
                    _name: 'Deepavali'
                },
                '2017-10-18': {
                    _name: 'Deepavali'
                },
                '2018-11-06': {
                    _name: 'Deepavali'
                },
                '2019-10-27': {
                    _name: 'Deepavali'
                },
                '2019-10-28': {
                    substitute: true,
                    _name: 'Deepavali'
                },
                '2020-11-14': {
                    _name: 'Deepavali'
                },
                '2021-11-04': {
                    _name: 'Deepavali'
                },
                '2022-10-24': {
                    _name: 'Deepavali'
                },
                '2023-11-12': {
                    _name: 'Deepavali'
                },
                '2023-11-13': {
                    substitute: true,
                    _name: 'Deepavali'
                },
                '2024-10-31': {
                    _name: 'Deepavali'
                },
                '2025-10-20': {
                    _name: 'Deepavali'
                },
                '2026-11-09': {
                    _name: 'Deepavali'
                },
                '2027-10-28': {
                    _name: 'Deepavali'
                },
                '2028-11-15': {
                    _name: 'Deepavali'
                },
                '2029-11-05': {
                    _name: 'Deepavali'
                },
                '2030-10-25': {
                    _name: 'Deepavali'
                }
            },
            states: {
                10: {
                    name: 'Selangor',
                    days: {
                        '12-11': {
                            name: {
                                en: "Sultan of Selangor's Birthday",
                                id: 'Hari Keputeraan Sultan Selangor'
                            }
                        },
                        '2016-01-24': {
                            _name: 'Thaipusam'
                        },
                        '2017-02-10': {
                            _name: 'Thaipusam'
                        },
                        '2018-01-31': {
                            _name: 'Thaipusam'
                        },
                        '2019-01-21': {
                            _name: 'Thaipusam'
                        },
                        '2020-02-08': {
                            _name: 'Thaipusam'
                        },
                        '2021-01-28': {
                            _name: 'Thaipusam'
                        },
                        '2022-01-18': {
                            _name: 'Thaipusam'
                        },
                        '2023-02-05': {
                            _name: 'Thaipusam'
                        },
                        '2024-01-25': {
                            _name: 'Thaipusam'
                        },
                        '2025-02-11': {
                            _name: 'Thaipusam'
                        },
                        '2026-02-01': {
                            _name: 'Thaipusam'
                        }
                    }
                },
                11: {
                    name: 'Terengganu',
                    days: {
                        '01-01': false,
                        '03-04': {
                            name: {
                                en: 'Anniversary of Installation of the Sultan of Terengganu',
                                ms: 'Hari Ulang Tahun Pertabalan Sultan Terengganu'
                            }
                        },
                        '04-26': {
                            name: {
                                en: "Sultan of Terengganu's Birthday",
                                ms: 'Hari Keputeraan Sultan Terengganu'
                            }
                        },
                        '27 Rajab': {
                            _name: '27 Rajab'
                        },
                        '9 Dhu al-Hijjah': {
                            _name: '9 Dhu al-Hijjah'
                        },
                        '11 Dhu al-Hijjah': {
                            _name: '10 Dhu al-Hijjah'
                        }
                    }
                },
                12: {
                    name: 'Sabah',
                    days: {
                        'easter -2': {
                            _name: 'easter -2'
                        },
                        '05-30': {
                            name: {
                                en: 'Tadau Kaamatan',
                                ms: 'Pesta Kaamatan'
                            }
                        },
                        '05-31': {
                            name: {
                                en: 'Tadau Kaamatan',
                                ms: 'Pesta Kaamatan'
                            }
                        },
                        '1st Saturday in October': {
                            name: {
                                en: "Sabah State Governor's Birthday",
                                ms: 'Hari Jadi Yang di-Pertua Negeri Sabah'
                            }
                        },
                        '12-24': {
                            _name: '12-24'
                        },
                        '17 Ramadan': false
                    }
                },
                13: {
                    name: 'Sarawak',
                    days: {
                        '2016-10-29': false,
                        '2017-10-18': false,
                        '2018-11-06': false,
                        '2019-10-27': false,
                        '2020-11-14': false,
                        '2021-11-04': false,
                        '2022-10-24': false,
                        '2023-11-13': false,
                        '2024-10-31': false,
                        '2025-10-20': false,
                        '2026-11-09': false,
                        '2027-10-28': false,
                        '2028-11-15': false,
                        '2029-11-05': false,
                        '2030-10-25': false,
                        'easter -2': {
                            _name: 'easter -2'
                        },
                        '06-01': {
                            name: {
                                en: 'Gawai Dayak',
                                ms: 'Perayaan Hari Gawai Dayak'
                            }
                        },
                        '06-02': {
                            name: {
                                en: 'Gawai Dayak',
                                ms: 'Perayaan Hari Gawai Dayak'
                            }
                        },
                        '07-22': {
                            name: {
                                en: 'Sarawak Independence Day',
                                ms: 'Hari Kemerdekaan Sarawak'
                            }
                        },
                        '2nd Saturday in October': {
                            name: {
                                en: "Sarawak State Governor's Birthday",
                                ms: 'Hari Jadi Yang di-Pertua Negeri Sarawak'
                            }
                        },
                        '17 Ramadan': false
                    }
                },
                14: {
                    name: 'Kuala Lumpur',
                    days: {
                        '02-01': {
                            name: {
                                en: 'Federal Territory Day',
                                ms: 'Hari Wilayah Persekutuan'
                            }
                        },
                        '2016-01-24': {
                            _name: 'Thaipusam'
                        },
                        '2017-02-10': {
                            _name: 'Thaipusam'
                        },
                        '2018-01-31': {
                            _name: 'Thaipusam'
                        },
                        '2019-01-21': {
                            _name: 'Thaipusam'
                        },
                        '2020-02-08': {
                            _name: 'Thaipusam'
                        },
                        '2021-01-28': {
                            _name: 'Thaipusam'
                        },
                        '2022-01-18': {
                            _name: 'Thaipusam'
                        },
                        '2023-02-05': {
                            _name: 'Thaipusam'
                        },
                        '2024-01-25': {
                            _name: 'Thaipusam'
                        },
                        '2025-02-11': {
                            _name: 'Thaipusam'
                        },
                        '2026-02-01': {
                            _name: 'Thaipusam'
                        }
                    }
                },
                15: {
                    name: 'Labuan',
                    days: {
                        '02-01': {
                            name: {
                                en: 'Federal Territory Day',
                                ms: 'Hari Wilayah Persekutuan'
                            }
                        },
                        '05-30': {
                            name: {
                                en: 'Tadau Kaamatan',
                                ms: 'Pesta Kaamatan'
                            }
                        },
                        '05-31': {
                            name: {
                                en: 'Tadau Kaamatan',
                                ms: 'Pesta Kaamatan'
                            }
                        }
                    }
                },
                16: {
                    name: 'Putrajaya',
                    days: {
                        '02-01': {
                            name: {
                                en: 'Federal Territory Day',
                                ms: 'Hari Wilayah Persekutuan'
                            }
                        },
                        '2016-01-24': {
                            _name: 'Thaipusam'
                        },
                        '2017-02-10': {
                            _name: 'Thaipusam'
                        },
                        '2018-01-31': {
                            _name: 'Thaipusam'
                        },
                        '2019-01-21': {
                            _name: 'Thaipusam'
                        },
                        '2020-02-08': {
                            _name: 'Thaipusam'
                        },
                        '2021-01-28': {
                            _name: 'Thaipusam'
                        },
                        '2022-01-18': {
                            _name: 'Thaipusam'
                        },
                        '2023-02-05': {
                            _name: 'Thaipusam'
                        },
                        '2024-01-25': {
                            _name: 'Thaipusam'
                        },
                        '2025-02-11': {
                            _name: 'Thaipusam'
                        },
                        '2026-02-01': {
                            _name: 'Thaipusam'
                        }
                    }
                },
                '01': {
                    name: 'Johor',
                    days: {
                        '01-01': false,
                        '03-23': {
                            name: {
                                en: "Sultan of Johor's Birthday",
                                ms: 'Hari Keputeraan Sultan Johor'
                            }
                        },
                        '1 Ramadan': {
                            _name: '1 Ramadan'
                        },
                        '17 Ramadan': false,
                        '6 Safar': {
                            name: {
                                en: 'Hari Hol of Sultan Iskandar of Johor',
                                ms: 'Hari Hol Almarhum Sultan Iskandar'
                            }
                        },
                        '2016-01-24': {
                            _name: 'Thaipusam'
                        },
                        '2017-02-10': {
                            _name: 'Thaipusam'
                        },
                        '2018-01-31': {
                            _name: 'Thaipusam'
                        },
                        '2019-01-21': {
                            _name: 'Thaipusam'
                        },
                        '2020-02-08': {
                            _name: 'Thaipusam'
                        },
                        '2021-01-28': {
                            _name: 'Thaipusam'
                        },
                        '2022-01-18': {
                            _name: 'Thaipusam'
                        },
                        '2023-02-05': {
                            _name: 'Thaipusam'
                        },
                        '2024-01-25': {
                            _name: 'Thaipusam'
                        },
                        '2025-02-11': {
                            _name: 'Thaipusam'
                        },
                        '2026-02-01': {
                            _name: 'Thaipusam'
                        }
                    }
                },
                '02': {
                    name: 'Kedah',
                    days: {
                        '01-01': false,
                        '3rd Sunday in June': {
                            name: {
                                en: "Sultan of Kedah's Birthday",
                                ms: 'Hari Keputeraan Sultan Kedah'
                            }
                        },
                        '27 Rajab': {
                            _name: '27 Rajab'
                        },
                        '1 Ramadan': {
                            _name: '1 Ramadan'
                        },
                        '17 Ramadan': false,
                        '11 Dhu al-Hijjah': {
                            _name: '10 Dhu al-Hijjah'
                        },
                        '2016-01-24': {
                            _name: 'Thaipusam'
                        },
                        '2017-02-10': {
                            _name: 'Thaipusam'
                        },
                        '2018-01-31': {
                            _name: 'Thaipusam'
                        },
                        '2019-01-21': {
                            _name: 'Thaipusam'
                        },
                        '2020-02-08': {
                            _name: 'Thaipusam'
                        },
                        '2021-01-28': {
                            _name: 'Thaipusam'
                        },
                        '2022-01-18': {
                            _name: 'Thaipusam'
                        },
                        '2023-02-05': {
                            _name: 'Thaipusam'
                        },
                        '2024-01-25': {
                            _name: 'Thaipusam'
                        },
                        '2025-02-11': {
                            _name: 'Thaipusam'
                        },
                        '2026-02-01': {
                            _name: 'Thaipusam'
                        }
                    }
                },
                '03': {
                    name: 'Kelantan',
                    days: {
                        '01-01': false,
                        '11 Dhu al-Hijjah': {
                            _name: '10 Dhu al-Hijjah'
                        },
                        '11-11': {
                            name: {
                                en: "Sultan of Kelantan's Birthday",
                                ms: 'Hari Keputeraan Sultan Kelantan'
                            }
                        },
                        '11-12': {
                            name: {
                                en: "Sultan of Kelantan's Birthday",
                                ms: 'Hari Keputeraan Sultan Kelantan'
                            }
                        }
                    }
                },
                '04': {
                    name: 'Malacca',
                    days: {
                        '04-15': {
                            name: {
                                en: 'Declaration of Malacca City as Historical City',
                                ms: 'Hari Perisytiharan Bandar Melaka sebagai Bandaraya Bersejarah'
                            }
                        },
                        '08-24': {
                            name: {
                                en: "Melaka State Governor's Birthday",
                                ms: 'Hari Jadi Yang di-Pertua Negeri Melaka'
                            }
                        },
                        '1 Ramadan': {
                            _name: '1 Ramadan'
                        },
                        '17 Ramadan': false
                    }
                },
                '05': {
                    name: 'Negeri Sembilan',
                    days: {
                        '01-14': {
                            name: {
                                en: "Yang di-Pertuan Besar of Negeri Sembilan's Birthday",
                                ms: 'Hari Keputeraan Yang di-Pertuan Besar Negeri Sembilan'
                            }
                        },
                        '27 Rajab': {
                            _name: '27 Rajab'
                        },
                        '17 Ramadan': false,
                        '2016-01-24': {
                            _name: 'Thaipusam'
                        },
                        '2017-02-10': {
                            _name: 'Thaipusam'
                        },
                        '2018-01-31': {
                            _name: 'Thaipusam'
                        },
                        '2019-01-21': {
                            _name: 'Thaipusam'
                        },
                        '2020-02-08': {
                            _name: 'Thaipusam'
                        },
                        '2021-01-28': {
                            _name: 'Thaipusam'
                        },
                        '2022-01-18': {
                            _name: 'Thaipusam'
                        },
                        '2023-02-05': {
                            _name: 'Thaipusam'
                        },
                        '2024-01-25': {
                            _name: 'Thaipusam'
                        },
                        '2025-02-11': {
                            _name: 'Thaipusam'
                        },
                        '2026-02-01': {
                            _name: 'Thaipusam'
                        }
                    }
                },
                '06': {
                    name: 'Pahang',
                    days: {
                        '05-22': {
                            name: {
                                en: 'Hari Hol of Pahang',
                                ms: 'Hari Hol Pahang'
                            }
                        },
                        '07-30': {
                            name: {
                                en: "Sultan of Pahang's Birthday",
                                ms: 'Hari Keputeraan Sultan Pahang'
                            }
                        }
                    }
                },
                '07': {
                    name: 'Penang',
                    days: {
                        '07-07': {
                            name: {
                                en: 'Declaration of George Town as World Heritage Site',
                                id: 'Hari Ulang Tahun Perisytiharan Tapak Warisan Dunia'
                            }
                        },
                        '2nd Saturday in July': {
                            name: {
                                en: "Penang State Governor's Birthday",
                                ms: 'Hari Jadi Yang di-Pertua Negeri Pulau Pinang'
                            }
                        },
                        '2016-01-24': {
                            _name: 'Thaipusam'
                        },
                        '2017-02-10': {
                            _name: 'Thaipusam'
                        },
                        '2018-01-31': {
                            _name: 'Thaipusam'
                        },
                        '2019-01-21': {
                            _name: 'Thaipusam'
                        },
                        '2020-02-08': {
                            _name: 'Thaipusam'
                        },
                        '2021-01-28': {
                            _name: 'Thaipusam'
                        },
                        '2022-01-18': {
                            _name: 'Thaipusam'
                        },
                        '2023-02-05': {
                            _name: 'Thaipusam'
                        },
                        '2024-01-25': {
                            _name: 'Thaipusam'
                        },
                        '2025-02-11': {
                            _name: 'Thaipusam'
                        },
                        '2026-02-01': {
                            _name: 'Thaipusam'
                        }
                    }
                },
                '08': {
                    name: 'Perak',
                    days: {
                        '1st Friday in November': {
                            name: {
                                en: "Sultan of Perak's Birthday",
                                ms: 'Hari Keputeraan Sultan Perak'
                            }
                        },
                        '2016-01-24': {
                            _name: 'Thaipusam'
                        },
                        '2017-02-10': {
                            _name: 'Thaipusam'
                        },
                        '2018-01-31': {
                            _name: 'Thaipusam'
                        },
                        '2019-01-21': {
                            _name: 'Thaipusam'
                        },
                        '2020-02-08': {
                            _name: 'Thaipusam'
                        },
                        '2021-01-28': {
                            _name: 'Thaipusam'
                        },
                        '2022-01-18': {
                            _name: 'Thaipusam'
                        },
                        '2023-02-05': {
                            _name: 'Thaipusam'
                        },
                        '2024-01-25': {
                            _name: 'Thaipusam'
                        },
                        '2025-02-11': {
                            _name: 'Thaipusam'
                        },
                        '2026-02-01': {
                            _name: 'Thaipusam'
                        }
                    }
                },
                '09': {
                    name: 'Perlis',
                    days: {
                        '01-01': false,
                        '07-17': {
                            name: {
                                en: "Raja of Perlis's Birthday",
                                id: 'Hari Keputeraan Raja Perlis'
                            }
                        },
                        '27 Rajab': {
                            _name: '27 Rajab'
                        },
                        '11 Dhu al-Hijjah': {
                            _name: '10 Dhu al-Hijjah'
                        }
                    }
                }
            }
        },
        MZ: {
            names: {
                pt: "Mo\xe7ambique",
                en: 'Mozambique'
            },
            dayoff: 'sunday',
            langs: [
                'pt'
            ],
            zones: [
                'Africa/Maputo'
            ],
            days: {
                '01-01': {
                    _name: '01-01',
                    name: {
                        pt: 'Dia da Fraternidade universal'
                    }
                },
                'substitutes 01-01 if sunday then next monday': {
                    _name: 'Public Holiday'
                },
                '02-03': {
                    name: {
                        pt: "Dia dos her\xf3is mo\xe7ambicanos",
                        en: "Heroes\u2019 Day"
                    }
                },
                'substitutes 02-03 if sunday then next monday': {
                    _name: 'Public Holiday'
                },
                '04-07': {
                    name: {
                        pt: "Dia da Mulher Mo\xe7ambicana",
                        en: "Women\u2019s Day"
                    }
                },
                'substitutes 04-07 if sunday then next monday': {
                    _name: 'Public Holiday'
                },
                '05-01': {
                    _name: '05-01',
                    name: {
                        pt: 'Dia Internacional dos Trabalhadores',
                        en: "Workers' Day"
                    }
                },
                'substitutes 05-01 if sunday then next monday': {
                    _name: 'Public Holiday'
                },
                '1st sunday in May': {
                    _name: 'Mothers Day',
                    type: 'observance'
                },
                '06-25': {
                    _name: 'Independence Day',
                    name: {
                        pt: "Dia da Independ\xeancia Nacional"
                    }
                },
                'substitutes 06-25 if sunday then next monday': {
                    _name: 'Public Holiday'
                },
                '09-07': {
                    name: {
                        pt: "Dia da Vit\xf3ria",
                        en: 'Lusaka Peace Agreement'
                    }
                },
                'substitutes 09-07 if sunday then next monday': {
                    _name: 'Public Holiday'
                },
                '09-25': {
                    name: {
                        pt: "Dia das For\xe7as Armadas de Liberta\xe7\xe3o Nacional",
                        en: "Defense Force\u2019s Day"
                    }
                },
                'substitutes 09-25 if sunday then next monday': {
                    _name: 'Public Holiday'
                },
                '10-04': {
                    name: {
                        pt: "Dia da Paz e Reconcilia\xe7\xe3o",
                        en: 'Peace and Reconciliation Day'
                    }
                },
                'substitutes 10-04 if sunday then next monday': {
                    _name: 'Public Holiday'
                },
                '12-25': {
                    _name: '12-25',
                    name: {
                        pt: "Dia da Fam\xedlia",
                        en: 'Family Day'
                    }
                },
                'substitutes 12-25 if sunday then next monday': {
                    _name: 'Public Holiday'
                }
            }
        },
        NA: {
            names: {
                en: 'Namibia'
            },
            dayoff: 'sunday',
            langs: [
                'en'
            ],
            zones: [
                'Africa/Windhoek'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                'substitutes 01-01 if sunday then next monday': {
                    name: 'Public Holiday'
                },
                '03-21': {
                    _name: 'Independence Day'
                },
                'substitutes 03-21 if sunday then next monday': {
                    name: 'Public Holiday'
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                easter: {
                    _name: 'easter',
                    type: 'observance'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '05-01': {
                    _name: '05-01',
                    name: {
                        en: 'Workers Day'
                    }
                },
                'substitutes 05-01 if sunday then next monday': {
                    name: 'Public Holiday'
                },
                '05-04': {
                    name: {
                        en: 'Cassinga Day'
                    }
                },
                'substitutes 05-04 if sunday then next monday': {
                    name: 'Public Holiday'
                },
                'easter 39': {
                    _name: 'easter 39'
                },
                '05-25': {
                    name: {
                        en: 'Africa Day'
                    }
                },
                'substitutes 05-25 if sunday then next monday': {
                    name: 'Public Holiday'
                },
                '08-26': {
                    name: {
                        en: "Heroes' Day"
                    }
                },
                'substitutes 08-26 if sunday then next monday': {
                    name: 'Public Holiday'
                },
                '12-10': {
                    name: {
                        en: 'Human Rights Day'
                    }
                },
                'substitutes 12-10 if sunday then next monday': {
                    name: 'Public Holiday'
                },
                '12-25': {
                    _name: '12-25'
                },
                '12-26': {
                    _name: '12-26',
                    name: {
                        en: 'Day of Goodwill'
                    }
                },
                'substitutes 12-26 if sunday then next monday': {
                    name: 'Public Holiday'
                }
            }
        },
        NC: {
            names: {
                fr: "Nouvelle-Cal\xe9donie",
                en: 'New Caledonia'
            },
            dayoff: 'sunday',
            zones: [
                'Pacific/Noumea'
            ],
            langs: [
                'fr'
            ],
            _days: 'FR',
            days: {
                '01-01': {
                    name: {
                        fr: "Jour de l'an"
                    }
                },
                '09-24': {
                    name: {
                        fr: "F\xeate de la Citonneyet\xe9",
                        en: 'New Caledonia Day'
                    }
                }
            }
        },
        NE: {
            names: {
                fr: "R\xe9publique du Niger",
                en: 'Republic of the Niger'
            },
            langs: [
                'fr'
            ],
            zones: [
                'Africa/Lagos'
            ],
            dayoff: 'sunday',
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '04-24': {
                    name: {
                        fr: "Journ\xe9e Nationale de la Concorde",
                        en: 'Concord Day'
                    }
                },
                '05-01': {
                    _name: '05-01'
                },
                '08-03': {
                    _name: 'Independence Day',
                    name: {
                        fr: "Proclamation de l'ind\xe9pendance"
                    }
                },
                '12-18': {
                    name: {
                        fr: "Proclamation de la R\xe9publique",
                        en: 'Republic Day'
                    }
                },
                '12-25': {
                    _name: '12-25'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '1 Shawwal': {
                    _name: '1 Shawwal'
                },
                '10 Dhu al-Hijjah': {
                    _name: '10 Dhu al-Hijjah'
                },
                '12 Rabi al-awwal': {
                    _name: '12 Rabi al-awwal'
                },
                '1 Muharram': {
                    _name: '1 Muharram'
                },
                '27 Ramadan': {
                    _name: '27 Ramadan'
                }
            }
        },
        NG: {
            names: {
                en: 'Nigeria'
            },
            langs: [
                'en'
            ],
            zones: [
                'Africa/Lagos'
            ],
            dayoff: 'Saturday',
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '05-01 and if Saturday then next Monday': {
                    substitute: true,
                    _name: '05-01',
                    name: {
                        en: "Worker's Day"
                    }
                },
                '05-27': {
                    name: {
                        en: "Children's Day",
                        type: 'school'
                    }
                },
                '05-29 prior to 2018': {
                    name: {
                        en: 'Democracy Day'
                    }
                },
                '06-12 prior to 2018': {
                    name: {
                        en: 'M.K.O Abiola Day'
                    }
                },
                '06-12 and if Saturday then next Monday since 2018': {
                    substitute: true,
                    name: {
                        en: 'Democracy Day'
                    }
                },
                '10-01': {
                    _name: 'Independence Day'
                },
                '11-01 since 2020': {
                    name: {
                        en: 'National Youth Day'
                    }
                },
                '12-31': {
                    _name: '12-31',
                    type: 'observance'
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                easter: {
                    _name: 'easter',
                    type: 'observance'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '12-25': {
                    _name: '12-25'
                },
                '12-26': {
                    _name: '12-26'
                },
                '1 Muharram': {
                    _name: '1 Muharram'
                },
                '12 Rabi al-awwal': {
                    _name: '12 Rabi al-awwal'
                },
                '1 Shawwal P2D': {
                    _name: '1 Shawwal',
                    name: {
                        en: 'Id el Fitr'
                    }
                },
                '10 Dhu al-Hijjah P2D': {
                    _name: '10 Dhu al-Hijjah',
                    name: {
                        en: 'Id el Kabir'
                    }
                }
            }
        },
        NI: {
            names: {
                es: 'Nicaragua',
                en: 'Nicaragua'
            },
            dayoff: 'sunday',
            langs: [
                'es'
            ],
            zones: [
                'America/Managua'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '01-18': {
                    name: {
                        en: "Birthday of Rub\xe9n Dar\xedo",
                        es: "Natalicio de Rub\xe9n Dar\xedo"
                    },
                    type: 'observance'
                },
                'easter -3': {
                    _name: 'easter -3'
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                '05-01': {
                    _name: '05-01'
                },
                '05-30': {
                    _name: 'Mothers Day',
                    name: {
                        es: "D\xeda de la madre nicarag\xfcense"
                    },
                    type: 'observance'
                },
                '06-01': {
                    name: {
                        en: "Children's Day",
                        es: "D\xeda del ni\xf1o"
                    }
                },
                '06-23': {
                    _name: 'Fathers Day',
                    name: {
                        es: "D\xeda del padre nicarag\xfcense"
                    },
                    type: 'observance'
                },
                '07-19': {
                    name: {
                        en: 'Revolution Day',
                        es: "Triunfo de la Revoluci\xf3n Popular"
                    }
                },
                '09-14': {
                    name: {
                        en: 'Battle of San Jacinto',
                        es: 'Batalla de San Jacinto'
                    }
                },
                '09-15': {
                    _name: 'Independence Day'
                },
                '10-12': {
                    name: {
                        en: 'Indigenous Resistance Day',
                        es: "D\xeda de la resistencia ind\xedgena"
                    }
                },
                '12-08': {
                    _name: '12-08'
                },
                '12-24': {
                    _name: '12-24',
                    type: 'observance'
                },
                '12-25': {
                    _name: '12-25'
                },
                '12-31': {
                    _name: '12-31',
                    type: 'observance'
                }
            }
        },
        NL: {
            names: {
                nl: 'Nederland',
                en: 'Netherlands',
                de: 'Niederlande',
                fr: 'Les Pays-Bas',
                es: "Pa\xedses Bajos",
                it: 'Paesi Bassi',
                pt: "Pa\xedses Baixos"
            },
            dayoff: 'sunday',
            langs: [
                'nl'
            ],
            zones: [
                'Europe/Amsterdam'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                'easter -2': {
                    _name: 'easter -2',
                    type: 'school'
                },
                easter: {
                    _name: 'easter'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '04-27 if sunday then previous saturday since 2014': {
                    name: {
                        nl: 'Koningsdag',
                        en: "King's Day",
                        de: "K\xf6nigstag",
                        fr: "F\xeate du Roi",
                        es: "D\xeda del Rey",
                        it: 'Giorno del Re',
                        pt: 'Dia do Rei'
                    }
                },
                '04-30 if sunday then next monday since 1949 and prior to 1980': {
                    name: {
                        nl: 'Koninginnedag',
                        en: "Queen's Day",
                        de: "K\xf6niginnentag",
                        fr: "F\xeate de la Reine",
                        es: "D\xeda de la Reina",
                        it: 'Giorno della Regina',
                        pt: 'Dia da Rainha'
                    }
                },
                '04-30 if sunday then previous saturday since 1980 and prior to 2014': {
                    name: {
                        nl: 'Koninginnedag',
                        en: "Queen's Day",
                        de: "K\xf6niginnentag",
                        fr: "F\xeate de la Reine",
                        es: "D\xeda de la Reina",
                        it: 'Giorno della Regina',
                        pt: 'Dia da Rainha'
                    }
                },
                '05-04': {
                    name: {
                        nl: 'Nationale Dodenherdenking',
                        en: 'Remembrance of the Dead',
                        de: 'Nationaler Totengedenktag',
                        fr: "Journ\xe9e nationale du Souvenir",
                        es: "D\xeda Nacional del Recuerdo",
                        it: 'Giorno della Memoria Nazionale',
                        pt: "Dia Nacional da Mem\xf3ria"
                    },
                    type: 'observance'
                },
                '05-05': {
                    name: {
                        nl: 'Bevrijdingsdag',
                        en: 'Liberation Day',
                        de: 'Befreiungstag',
                        fr: "Jour de la Lib\xe9ration",
                        es: "D\xeda de la liberacion",
                        it: 'Giorno della Liberazione',
                        pt: "Dia da Liberta\xe7\xe3o"
                    },
                    type: 'school'
                },
                '2nd sunday in May': {
                    _name: 'Mothers Day',
                    type: 'observance'
                },
                'easter 39': {
                    _name: 'easter 39',
                    name: {
                        nl: 'Hemelvaartsdag',
                        en: 'Ascension Day',
                        de: 'Christi Himmelfahrt',
                        fr: "Jour de l'Ascension",
                        es: "D\xeda de la Ascensi\xf3n",
                        it: "Giorno dell'Ascensione",
                        pt: "Festa da Ascens\xe3o"
                    }
                },
                'easter 49': {
                    _name: 'easter 49'
                },
                'easter 50': {
                    _name: 'easter 50'
                },
                '3rd sunday in June': {
                    _name: 'Fathers Day',
                    type: 'observance'
                },
                '08-31 since 1885 and prior to 1891': {
                    name: {
                        nl: 'Prinsessedag',
                        en: 'Princess Day',
                        de: 'Prinzessinnentag',
                        fr: "Journ\xe9e de la princesse",
                        es: "D\xeda de la princesa",
                        it: 'Giorno della principessa',
                        pt: 'Dia da Princesa'
                    }
                },
                '08-31 since 1891 and prior to 1949': {
                    name: {
                        nl: 'Koninginnedag',
                        en: "Queen's Day",
                        de: "K\xf6niginnentag",
                        fr: "F\xeate de la Reine",
                        es: "D\xeda de la Reina",
                        it: 'Giorno della Regina',
                        pt: 'Dia da Rainha'
                    }
                },
                '3rd tuesday in September': {
                    name: {
                        nl: 'Prinsjesdag',
                        en: "Prince's Day",
                        de: 'Prinzentag',
                        fr: "Journ\xe9e budg\xe9taire",
                        es: "D\xeda del presupuesto",
                        it: 'Giornata del bilancio',
                        pt: "Dia do Pr\xedncipe"
                    },
                    type: 'observance'
                },
                '11-11': {
                    _name: '11-11',
                    type: 'observance'
                },
                '12-05': {
                    name: {
                        nl: 'Sinterklaasavond',
                        en: "St Nicholas' Eve",
                        de: 'Nikolausabend',
                        fr: "Soir\xe9e Saint-Nicolas",
                        es: 'Noche de Sinterklaas',
                        it: 'Serata di Sinterklaas',
                        pt: 'Noite de Sinterklaas'
                    },
                    type: 'observance'
                },
                '12-15': {
                    name: {
                        nl: 'Koninkrijksdag',
                        en: 'Kingdom Day',
                        de: "K\xf6nigreichstag",
                        fr: 'Jour du Royaume',
                        es: "D\xeda del Reino",
                        it: 'Giorno del Regno',
                        pt: 'Dia do Reino'
                    },
                    type: 'observance'
                },
                '12-25': {
                    _name: '12-25'
                },
                '12-26': {
                    _name: '12-26'
                },
                '12-31': {
                    _name: '12-31',
                    type: 'bank'
                }
            },
            states: {
                GR: {
                    names: {
                        nl: 'Groningen',
                        en: 'Groningen',
                        de: 'Groningen',
                        fr: 'Groningue',
                        es: 'Groninga',
                        it: 'Groninga'
                    },
                    regions: {
                        GRN: {
                            names: {
                                nl: 'Groningen',
                                en: 'Groningen',
                                de: 'Groningen',
                                fr: 'Groningue',
                                es: 'Groninga',
                                it: 'Groninga'
                            },
                            days: {
                                '08-28': {
                                    name: {
                                        nl: 'Gronings Ontzet',
                                        en: 'Relief of Groningen',
                                        de: 'Groninger Entsatz',
                                        fr: "Lev\xe9e de si\xe8ge de Groningue",
                                        es: 'Alivio del asedio de Groninga',
                                        it: 'Assedio revocato di Groninga'
                                    },
                                    type: 'observance'
                                }
                            }
                        }
                    }
                },
                NH: {
                    names: {
                        nl: 'Noord-Holland',
                        en: 'North Holland',
                        de: 'Noord-Holland',
                        fr: 'Hollande-Septentrionale',
                        es: 'Holanda Septentrional',
                        it: 'Olanda Settentrionale'
                    },
                    regions: {
                        ALK: {
                            name: 'Alkmaar',
                            days: {
                                '10-08': {
                                    name: {
                                        nl: 'Alkmaars Ontzet',
                                        en: 'Relief of Alkmaar',
                                        de: 'Alkmaarder Entsatz',
                                        fr: "Lev\xe9e de si\xe8ge d\u2019Alkmaar",
                                        es: 'Alivio del asedio de Alkmaar',
                                        it: 'Assedio revocato di Alkmaar'
                                    },
                                    type: 'observance'
                                }
                            }
                        }
                    }
                },
                ZH: {
                    names: {
                        nl: 'Zuid-Holland',
                        en: 'South Holland',
                        de: 'Zuid-Holland',
                        fr: "Hollande-M\xe9ridionale",
                        es: 'Holanda Meridional',
                        it: 'Olanda Meridionale'
                    },
                    regions: {
                        BRL: {
                            name: 'Brielle',
                            days: {
                                '04-01': {
                                    name: {
                                        nl: 'Inname van Den Briel',
                                        en: 'Capture of Brielle',
                                        de: 'Einname van Den Briel',
                                        fr: 'Prise de La Brielle',
                                        es: 'Toma de Brielle',
                                        it: 'Presa di Brielle'
                                    },
                                    type: 'observance'
                                }
                            }
                        },
                        LDN: {
                            names: {
                                nl: 'Leiden',
                                en: 'Leiden',
                                de: 'Leiden',
                                fr: 'Leyde',
                                es: 'Leiden',
                                it: 'Leida'
                            },
                            days: {
                                '10-03': {
                                    name: {
                                        nl: 'Leids Ontzet',
                                        en: 'Relief of Leiden',
                                        de: 'Leidener Entsatz',
                                        fr: "Lev\xe9e de si\xe8ge de Leyde",
                                        es: 'Alivio del asedio de Leiden',
                                        it: 'Assedio revocato di Leida'
                                    },
                                    type: 'observance'
                                }
                            }
                        }
                    }
                }
            }
        },
        NO: {
            names: {
                no: 'Norge',
                en: 'Norway'
            },
            dayoff: 'sunday',
            langs: [
                'no'
            ],
            zones: [
                'Europe/Oslo'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '01-21': {
                    name: {
                        no: 'H.K.H. prinsesse Ingrid Alexandra',
                        en: 'Birthday of Princess Ingrid Alexandra'
                    },
                    type: 'observance'
                },
                '02-06': {
                    name: {
                        no: 'Samefolkets dag',
                        en: 'Day of the Sami people'
                    },
                    type: 'observance'
                },
                '2nd sunday in February': {
                    _name: 'Mothers Day',
                    type: 'observance'
                },
                '02-14': {
                    _name: '02-14',
                    type: 'observance'
                },
                '02-21': {
                    name: {
                        no: 'H.M. kong Harald V',
                        en: 'Birthday of King Harald V'
                    },
                    type: 'observance'
                },
                'easter -49': {
                    name: {
                        no: 'Fastelavn',
                        en: 'Carnival'
                    },
                    type: 'observance'
                },
                'easter -46': {
                    _name: 'easter -46',
                    type: 'observance'
                },
                '03-08': {
                    _name: '03-08',
                    type: 'observance'
                },
                'easter -7': {
                    _name: 'easter -7',
                    type: 'observance'
                },
                'easter -3': {
                    _name: 'easter -3'
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                easter: {
                    _name: 'easter'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '04-01': {
                    _name: '04-01',
                    type: 'observance'
                },
                '05-01': {
                    _name: '05-01'
                },
                '05-08': {
                    _name: 'Liberation Day',
                    type: 'observance'
                },
                '05-17': {
                    _name: 'Constitution Day'
                },
                'easter 39': {
                    _name: 'easter 39'
                },
                'easter 49': {
                    _name: 'easter 49'
                },
                'easter 50': {
                    _name: 'easter 50'
                },
                '06-07': {
                    name: {
                        no: "Unionsoppl\xf8sningen",
                        en: 'Union Dissolution Day'
                    },
                    type: 'observance'
                },
                '06-23': {
                    name: {
                        no: 'Sankthansaften',
                        en: 'Midsummar Eve'
                    },
                    type: 'observance'
                },
                '07-04': {
                    name: {
                        no: 'H.M. dronning Sonja',
                        en: 'Birthday of Queen Sonja'
                    },
                    type: 'observance'
                },
                '07-20': {
                    name: {
                        no: 'H.K.H. kronprins Haakon Magnus',
                        en: 'Birthday of Crown Prince Haakon Magnus'
                    },
                    type: 'observance'
                },
                '07-29': {
                    name: {
                        no: 'Olsok',
                        en: 'Olsok'
                    },
                    type: 'optional'
                },
                '08-19': {
                    name: {
                        no: 'H.K.H. kronprinsesse Mette-Marit',
                        en: 'Birthday of Crown Princess Mette-Marit'
                    },
                    type: 'observance'
                },
                '1st sunday in November': {
                    name: {
                        no: 'Allehelgensaften',
                        en: "All Saints' Day"
                    },
                    type: 'observance'
                },
                '2nd sunday in November': {
                    _name: 'Fathers Day',
                    type: 'observance'
                },
                '4th sunday before 12-25': {
                    name: {
                        no: "F\xf8rste s\xf8ndag i advent",
                        en: 'First Sunday of Advent'
                    },
                    type: 'observance'
                },
                '3rd sunday before 12-25': {
                    name: {
                        no: "Andre s\xf8ndag i advent",
                        en: 'Second Sunday of Advent'
                    },
                    type: 'observance'
                },
                '2nd sunday before 12-25': {
                    name: {
                        no: "Tredje s\xf8ndag i advent",
                        en: 'Third Sunday of Advent'
                    },
                    type: 'observance'
                },
                '1st sunday before 12-25': {
                    name: {
                        no: "Fjerde s\xf8ndag i advent",
                        en: 'Fourth Sunday of Advent'
                    },
                    type: 'observance'
                },
                '12-24': {
                    _name: '12-24',
                    type: 'bank'
                },
                '12-25': {
                    _name: '12-25'
                },
                '12-26': {
                    _name: '12-26'
                },
                '12-31 14:00 if sunday then 00:00': {
                    _name: '12-31',
                    type: 'bank'
                }
            }
        },
        NZ: {
            names: {
                en: 'New Zealand',
                mi: 'Aotearoa'
            },
            dayoff: 'sunday',
            langs: [
                'en',
                'mi'
            ],
            zones: [
                'Pacific/Auckland',
                'Pacific/Chatham'
            ],
            days: {
                '01-01 and if saturday then next monday if sunday then next tuesday': {
                    substitute: true,
                    _name: '01-01'
                },
                '01-02 and if saturday then next monday if sunday then next tuesday': {
                    substitute: true,
                    name: {
                        en: "Day after New Year's Day"
                    }
                },
                '02-06 and if saturday,sunday then next monday': {
                    substitute: true,
                    name: {
                        en: 'Waitangi Day'
                    }
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                easter: {
                    _name: 'easter',
                    type: 'observance'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '04-25 and if saturday,sunday then next monday': {
                    substitute: true,
                    name: {
                        en: 'ANZAC Day'
                    }
                },
                '1st monday in June prior to 2023': {
                    name: {
                        en: "Queen's Birthday"
                    }
                },
                '1st monday in June since 2023': {
                    name: {
                        en: "King's Birthday"
                    }
                },
                '4th monday in October': {
                    _name: '05-01'
                },
                '12-25 and if saturday then next monday if sunday then next tuesday': {
                    substitute: true,
                    _name: '12-25'
                },
                '12-26 and if saturday then next monday if sunday then next tuesday': {
                    substitute: true,
                    _name: '12-26'
                },
                '2022-06-24': {
                    name: {
                        en: 'Matariki'
                    }
                },
                '2023-07-14': {
                    name: {
                        en: 'Matariki'
                    }
                },
                '2024-06-28': {
                    name: {
                        en: 'Matariki'
                    }
                },
                '2025-06-20': {
                    name: {
                        en: 'Matariki'
                    }
                },
                '2026-07-10': {
                    name: {
                        en: 'Matariki'
                    }
                },
                '2027-06-25': {
                    name: {
                        en: 'Matariki'
                    }
                },
                '2028-07-14': {
                    name: {
                        en: 'Matariki'
                    }
                },
                '2029-07-06': {
                    name: {
                        en: 'Matariki'
                    }
                },
                '2030-06-21': {
                    name: {
                        en: 'Matariki'
                    }
                },
                '2031-07-11': {
                    name: {
                        en: 'Matariki'
                    }
                },
                '2032-07-02': {
                    name: {
                        en: 'Matariki'
                    }
                },
                '2033-06-24': {
                    name: {
                        en: 'Matariki'
                    }
                },
                '2034-07-07': {
                    name: {
                        en: 'Matariki'
                    }
                },
                '2035-06-29': {
                    name: {
                        en: 'Matariki'
                    }
                },
                '2036-07-18': {
                    name: {
                        en: 'Matariki'
                    }
                },
                '2037-07-10': {
                    name: {
                        en: 'Matariki'
                    }
                },
                '2038-06-25': {
                    name: {
                        en: 'Matariki'
                    }
                },
                '2039-07-15': {
                    name: {
                        en: 'Matariki'
                    }
                },
                '2040-07-06': {
                    name: {
                        en: 'Matariki'
                    }
                },
                '2041-07-19': {
                    name: {
                        en: 'Matariki'
                    }
                },
                '2042-07-11': {
                    name: {
                        en: 'Matariki'
                    }
                },
                '2043-07-03': {
                    name: {
                        en: 'Matariki'
                    }
                },
                '2044-06-24': {
                    name: {
                        en: 'Matariki'
                    }
                },
                '2045-07-07': {
                    name: {
                        en: 'Matariki'
                    }
                },
                '2046-06-29': {
                    name: {
                        en: 'Matariki'
                    }
                },
                '2047-07-19': {
                    name: {
                        en: 'Matariki'
                    }
                },
                '2048-07-03': {
                    name: {
                        en: 'Matariki'
                    }
                },
                '2049-06-25': {
                    name: {
                        en: 'Matariki'
                    }
                },
                '2050-07-15': {
                    name: {
                        en: 'Matariki'
                    }
                },
                '2051-06-30': {
                    name: {
                        en: 'Matariki'
                    }
                },
                '2052-06-21': {
                    name: {
                        en: 'Matariki'
                    }
                },
                '2022-09-26': {
                    name: {
                        en: 'National Day of Mourning for Queen Elizabeth II'
                    }
                }
            },
            states: {
                AUK: {
                    names: {
                        en: 'Auckland Province',
                        mi: "T\u0101maki-makau-rau"
                    },
                    days: {
                        '01-29 if tuesday,wednesday,thursday then previous monday if friday,saturday,sunday then next monday': {
                            name: {
                                en: 'Provincial anniversary day'
                            }
                        }
                    }
                },
                BOP: {
                    names: {
                        en: 'Bay of Plenty',
                        mi: 'Te Moana-a-Toi'
                    },
                    days: {
                        '01-29 if tuesday,wednesday,thursday then previous monday if friday,saturday,sunday then next monday': {
                            name: {
                                en: 'Provincial anniversary day'
                            }
                        }
                    }
                },
                CAN: {
                    names: {
                        en: 'Canterbury',
                        mi: 'Waitaha'
                    },
                    days: {
                        'friday after 2nd tuesday in November': {
                            name: {
                                en: 'Christchurch Show Day'
                            },
                            note: 'May differ in parts of North Canterbury'
                        }
                    },
                    regions: {
                        Timaru: {
                            name: 'Timaru District',
                            days: {
                                'friday after 2nd tuesday in November': false,
                                '4th monday in September': {
                                    name: {
                                        en: 'Dominion Day'
                                    }
                                }
                            }
                        }
                    }
                },
                CIT: {
                    names: {
                        en: 'Chatham Islands',
                        mi: 'Wharekauri'
                    },
                    days: {
                        '11-30 if tuesday,wednesday,thursday then previous monday if friday,saturday,sunday then next monday': {
                            name: {
                                en: 'Provincial anniversary day'
                            }
                        }
                    }
                },
                GIS: {
                    names: {
                        en: 'Gisborne',
                        mi: "Te Tai R\u0101whiti"
                    },
                    days: {
                        '01-29 if tuesday,wednesday,thursday then previous monday if friday,saturday,sunday then next monday': {
                            name: {
                                en: 'Provincial anniversary day'
                            }
                        }
                    }
                },
                HKB: {
                    names: {
                        en: "Hawke's Bay",
                        mi: "Te Matau-a-M\u0101ui"
                    },
                    days: {
                        'friday before 4th monday in October': {
                            name: {
                                en: 'Provincial anniversary day'
                            }
                        }
                    }
                },
                MBH: {
                    names: {
                        en: 'Marlborough',
                        mi: 'Te Tauihu-o-te-waka'
                    },
                    days: {
                        '5th monday in October': {
                            name: {
                                en: 'Provincial anniversary day'
                            }
                        }
                    }
                },
                MWT: {
                    name: 'Manawatu-Wanganui',
                    days: {
                        '01-22 if tuesday,wednesday,thursday then previous monday if friday,saturday,sunday then next monday': {
                            name: {
                                en: 'Provincial anniversary day'
                            }
                        }
                    }
                },
                NSN: {
                    names: {
                        en: 'Nelson',
                        mi: "Whakat\u016B"
                    },
                    days: {
                        '02-01 if tuesday,wednesday,thursday then previous monday if friday,saturday,sunday then next monday': {
                            name: {
                                en: 'Provincial anniversary day'
                            }
                        }
                    }
                },
                NTL: {
                    names: {
                        en: 'Northland',
                        mi: 'Te Tai Tokerau'
                    },
                    days: {
                        '01-29 if tuesday,wednesday,thursday then previous monday if friday,saturday,sunday then next monday': {
                            name: {
                                en: 'Provincial anniversary day'
                            }
                        }
                    }
                },
                OTA: {
                    names: {
                        en: 'Otago Province',
                        mi: "\u014Ct\u0101kou"
                    },
                    days: {
                        '03-23 if Tuesday,Wednesday,Thursday then previous Monday if Friday,Saturday,Sunday then next Monday if is public holiday then next Monday': {
                            name: {
                                en: 'Provincial anniversary day'
                            }
                        }
                    }
                },
                STL: {
                    names: {
                        en: 'Southland',
                        mi: 'Murihiku'
                    },
                    days: {
                        'easter 2': {
                            name: {
                                en: 'Provincial anniversary day'
                            }
                        }
                    }
                },
                TAS: {
                    names: {
                        en: 'Tasman',
                        mi: 'Te Tai-o-Aorere'
                    },
                    days: {
                        '02-01 if tuesday,wednesday,thursday then previous monday if friday,saturday,sunday then next monday': {
                            name: {
                                en: 'Provincial anniversary day'
                            }
                        }
                    }
                },
                TKI: {
                    name: 'Taranaki',
                    days: {
                        '2nd monday in March': {
                            name: {
                                en: 'Provincial anniversary day'
                            }
                        }
                    }
                },
                WKO: {
                    name: 'Waikato',
                    days: {
                        '01-29 if tuesday,wednesday,thursday then previous monday if friday,saturday,sunday then next monday': {
                            name: {
                                en: 'Provincial anniversary day'
                            }
                        }
                    }
                },
                WGN: {
                    names: {
                        en: 'Wellington Province',
                        mi: 'Te Whanga-nui-a-Tara'
                    },
                    days: {
                        '01-22 if tuesday,wednesday,thursday then previous monday if friday,saturday,sunday then next monday': {
                            name: {
                                en: 'Provincial anniversary day'
                            }
                        }
                    }
                },
                WTC: {
                    names: {
                        en: 'Westland',
                        mi: 'Te Tai Poutini'
                    },
                    days: {
                        '12-01 if tuesday,wednesday,thursday then previous monday if friday,saturday,sunday then next monday': {
                            name: {
                                en: 'Provincial anniversary day'
                            }
                        }
                    },
                    regions: {
                        Buller: {
                            name: 'Buller district',
                            days: {
                                '12-01 if tuesday,wednesday,thursday then previous monday if friday,saturday,sunday then next monday': false,
                                '02-01 if tuesday,wednesday,thursday then previous monday if friday,saturday,sunday then next monday': {
                                    name: {
                                        en: 'Provincial anniversary day'
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        PA: {
            names: {
                es: "Panam\xe1",
                en: 'Panama'
            },
            dayoff: 'sunday',
            langs: [
                'es'
            ],
            zones: [
                'America/Panama'
            ],
            days: {
                '01-01 and if sunday then next monday': {
                    substitute: true,
                    _name: '01-01'
                },
                '01-09 and if sunday then next monday': {
                    substitute: true,
                    name: {
                        en: "Martyrs' Day",
                        es: "D\xeda de los M\xe1rtires Ca\xeddos en la Gesta Patri\xf3tica"
                    }
                },
                'easter -48': {
                    _name: 'easter -48',
                    type: 'observance'
                },
                'easter -47': {
                    _name: 'easter -47'
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                '05-01 and if sunday then next monday': {
                    substitute: true,
                    _name: '05-01'
                },
                '07-01 every 5 years since 2014': {
                    name: {
                        en: 'Presidential Inauguration'
                    }
                },
                '11-03 and if sunday then next monday': {
                    substitute: true,
                    name: {
                        en: 'Separation Day (from Columbia)',
                        es: "D\xeda de la Separaci\xf3n (de Colombia)"
                    }
                },
                '11-10 and if sunday then next monday': {
                    substitute: true,
                    name: {
                        es: 'Primer Grito de Independencia'
                    }
                },
                '11-28 and if sunday then next monday': {
                    substitute: true,
                    _name: 'Independence Day'
                },
                '12-08 and if sunday then next monday': {
                    substitute: true,
                    _name: 'Mothers Day'
                },
                '12-25 and if sunday then next monday': {
                    substitute: true,
                    _name: '12-25'
                }
            }
        },
        PE: {
            names: {
                es: "Per\xfa",
                en: 'Peru'
            },
            dayoff: 'sunday',
            langs: [
                'es',
                'qu'
            ],
            zones: [
                'America/Lima'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                'easter -3': {
                    _name: 'easter -3'
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                easter: {
                    _name: 'easter'
                },
                '05-01': {
                    _name: '05-01'
                },
                '06-29': {
                    _name: '06-29'
                },
                '07-28': {
                    _name: 'Independence Day'
                },
                '07-29': {
                    _name: 'Independence Day'
                },
                '08-30': {
                    name: {
                        en: 'Santa Rosa de Lima',
                        es: "D\xeda de Santa Rosa de Lima"
                    }
                },
                '10-08': {
                    name: {
                        en: 'Battle of Angamos',
                        es: 'Combate de Angamos'
                    }
                },
                '11-01': {
                    _name: '11-01'
                },
                '12-08': {
                    _name: '12-08'
                },
                '12-25': {
                    _name: '12-25'
                }
            },
            regions: {
                CUS: {
                    name: 'Cuzco',
                    days: {
                        '06-24': {
                            name: {
                                en: 'Festival of the Sun',
                                es: 'Fiesta Inca del Sol',
                                qu: 'Inti Raymi'
                            },
                            type: 'observance'
                        }
                    }
                }
            }
        },
        PH: {
            names: {
                en: 'Philippines'
            },
            langs: [
                'en',
                'fil'
            ],
            zones: [
                'Asia/Manila'
            ],
            dayoff: 'sunday',
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '01-23': {
                    type: 'observance',
                    name: {
                        en: 'First Philippine Republic Day',
                        fil: 'Araw ng Unang Republika ng Pilipinas'
                    }
                },
                'chinese 01-0-01': {
                    type: 'optional',
                    name: {
                        en: 'Chinese New Year',
                        fil: 'Bagong Taon ng mga Tsino'
                    }
                },
                '02-02': {
                    type: 'observance',
                    _name: 'Constitution Day'
                },
                'chinese 01-0-15': {
                    type: 'observance',
                    name: {
                        en: 'Lantern Festival',
                        fil: 'Piyesta ng mga Parol Tsino'
                    }
                },
                '02-25': {
                    name: {
                        en: 'EDSA Revolution Anniversary',
                        fil: 'Anibersaryo ng Rebolusyon sa EDSA'
                    },
                    type: 'optional',
                    note: 'Non-working Day'
                },
                'easter -3': {
                    _name: 'easter -3'
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                'easter -1': {
                    _name: 'easter -1',
                    type: 'optional',
                    note: 'Non-working Day'
                },
                easter: {
                    _name: 'easter'
                },
                '04-09': {
                    name: {
                        en: 'Day of Valor',
                        fil: 'Araw ng Kagitingan'
                    }
                },
                '04-27': {
                    type: 'observance',
                    name: {
                        en: 'Lapu-Lapu Day',
                        fil: 'Araw ni Lapu-Lapu'
                    }
                },
                '05-01': {
                    _name: '05-01',
                    name: {
                        en: 'Labour Day',
                        fil: 'Araw ng mga Manggagawa'
                    }
                },
                '06-12': {
                    _name: 'Independence Day'
                },
                '06-19': {
                    type: 'observance',
                    name: {
                        en: "Jos\xe9 Rizal's birthday",
                        fil: "Araw ng Kapanganakan ni Jos\xe9 Rizal"
                    },
                    active: [
                        {
                            from: '1961-01-01T00:00:00.000Z'
                        }
                    ],
                    disable: [
                        '2011-06-19'
                    ]
                },
                '2011-06-19': {
                    name: {
                        en: "Jos\xe9 Rizal's birthday",
                        fil: "Araw ng Kapanganakan ni Jos\xe9 Rizal"
                    }
                },
                '07-27': {
                    type: 'observance',
                    name: {
                        en: 'Iglesia ni Cristo Day',
                        fil: 'Araw ng Iglesia ni Cristo'
                    }
                },
                '08-21': {
                    name: {
                        en: 'Ninoy Aquino Day',
                        fil: 'Araw ng Kabayanihan ni Ninoy Aquino'
                    },
                    type: 'optional',
                    note: 'Non-working Day'
                },
                '1st monday before September': {
                    name: {
                        en: "National Heroes' Day",
                        fil: 'Araw ng mga Bayani'
                    }
                },
                'chinese 08-0-15': {
                    type: 'observance',
                    name: {
                        en: 'Mid-Autumn Festival',
                        fil: "Piyestang Zh\u014Dngqi\u016B Ji\xe9"
                    }
                },
                '11-01': {
                    _name: '11-01',
                    type: 'optional',
                    note: 'Non-working Day'
                },
                '11-02': {
                    _name: '11-02',
                    type: 'optional',
                    note: 'Non-working Day'
                },
                '11-30': {
                    name: {
                        en: 'Bonifacio Day',
                        fil: 'Araw ng Kapanganakan ni Bonifacio'
                    }
                },
                '12-08': {
                    _name: '12-08',
                    name: {
                        en: 'Feast of the Immaculate Conception of the Blessed Virgin Mary',
                        fil: 'Pagdiriwang ng Kalinis-linisang Paglilihi sa Mahal na Birheng Maria'
                    },
                    type: 'optional',
                    note: 'Non-working Day'
                },
                '12-24': {
                    _name: '12-24',
                    type: 'optional',
                    note: 'Non-working Day'
                },
                '12-25': {
                    _name: '12-25'
                },
                '12-30': {
                    name: {
                        en: 'Rizal Day',
                        fil: 'Paggunita sa Kamatayan ni Dr. Jose Rizal'
                    }
                },
                '12-31': {
                    _name: '12-31',
                    type: 'optional',
                    note: 'Non-working Day'
                },
                '1 Muharram': {
                    type: 'observance',
                    _name: '1 Muharram'
                },
                '12 Rabi al-awwal': {
                    type: 'observance',
                    _name: '12 Rabi al-awwal'
                },
                '1 Shawwal': {
                    _name: '1 Shawwal'
                },
                '10 Dhu al-Hijjah': {
                    _name: '10 Dhu al-Hijjah'
                }
            }
        },
        PL: {
            names: {
                pl: 'Polska',
                en: 'Poland'
            },
            dayoff: 'sunday',
            langs: [
                'pl'
            ],
            zones: [
                'Europe/Warsaw'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '01-06 since 2011': {
                    _name: '01-06'
                },
                '01-21': {
                    name: {
                        pl: "Dzie\u0144 Babci",
                        en: "Grandmother's Day"
                    },
                    type: 'observance'
                },
                '01-22': {
                    name: {
                        pl: "Dzie\u0144 Dziadka",
                        en: "Grandfather's Day"
                    },
                    type: 'observance'
                },
                '02-14': {
                    _name: '02-14',
                    type: 'observance'
                },
                '02-19 since 2020': {
                    name: {
                        pl: "Dzie\u0144 Nauki Polskiej",
                        en: 'Polish Science Day'
                    },
                    type: 'observance',
                    note: 'National holiday, although not a public holiday'
                },
                '03-01 since 2011': {
                    name: {
                        pl: "Narodowy Dzie\u0144 Pami\u0119ci \u201E\u017Bo\u0142nierzy Wykl\u0119tych\u201D",
                        en: 'National Cursed Soldiers Remembrance Day'
                    },
                    type: 'observance',
                    note: 'National holiday, although not a public holiday'
                },
                'Thursday before easter -46': {
                    name: {
                        pl: "T\u0142usty Czwartek",
                        en: 'Fat Thursday'
                    },
                    type: 'observance'
                },
                'easter -47': {
                    _name: 'easter -47',
                    type: 'observance'
                },
                'easter -46': {
                    _name: 'easter -46',
                    type: 'observance'
                },
                '03-08': {
                    _name: '03-08',
                    type: 'observance'
                },
                '03-10': {
                    name: {
                        pl: "Dzie\u0144 M\u0119\u017Cczyzny",
                        en: "Men's Day"
                    },
                    type: 'observance'
                },
                '03-21': {
                    name: {
                        pl: "Pierwszy Dzie\u0144 Wiosny / Dzie\u0144 Wagarowicza",
                        en: "First Day of Spring / Truant's Day"
                    },
                    type: 'observance'
                },
                '03-24 since 2018': {
                    name: {
                        pl: "Narodowy Dzie\u0144 Pami\u0119ci Polak\xf3w ratuj\u0105cych \u017Byd\xf3w pod okupacj\u0105 niemieck\u0105",
                        en: 'National Day for the Remembrance of Poles Rescuing Jews under German Occupation'
                    },
                    type: 'observance',
                    note: 'National holiday, although not a public holiday'
                },
                '04-14 since 2019': {
                    name: {
                        pl: "\u015Awi\u0119to Chrztu Polski",
                        en: 'Baptism of Poland Day'
                    },
                    type: 'observance',
                    note: 'National holiday, although not a public holiday'
                },
                'easter -7': {
                    _name: 'easter -7',
                    type: 'observance'
                },
                'easter -3': {
                    _name: 'easter -3',
                    type: 'school',
                    note: 'Religious holiday - a working day, but schools are closed'
                },
                'easter -2': {
                    _name: 'easter -2',
                    type: 'school',
                    note: 'Religious holiday - a working day, but schools are closed'
                },
                'easter -1': {
                    _name: 'easter -1',
                    type: 'observance'
                },
                easter: {
                    _name: 'easter'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '04-19': {
                    name: {
                        pl: "Dzie\u0144 Pami\u0119ci Ofiar Holocaustu i Powstania w Getcie Warszawskim",
                        en: 'Warsaw Ghetto Uprising Remembrance Day'
                    },
                    type: 'observance'
                },
                '04-22': {
                    name: {
                        pl: "Dzie\u0144 Ziemi",
                        en: 'International Mother Earth Day'
                    },
                    type: 'observance'
                },
                '05-01': {
                    _name: '05-01',
                    name: {
                        pl: "\u015Awi\u0119to Pa\u0144stwowe; \u015Awi\u0119to Pracy"
                    }
                },
                '05-02 since 2004': {
                    name: {
                        pl: "Dzie\u0144 Flagi Rzeczypospolitej Polskiej",
                        en: 'Flag Day'
                    },
                    type: 'optional',
                    note: 'Declared by statue'
                },
                '05-03': {
                    name: {
                        pl: "\u015Awi\u0119to Narodowe Trzeciego Maja",
                        en: 'Constitution Day'
                    }
                },
                '05-08 since 2015': {
                    name: {
                        pl: "Narodowy Dzie\u0144 Zwyci\u0119stwa",
                        en: 'National Victory Day'
                    },
                    type: 'observance',
                    note: 'National holiday, although not a public holiday'
                },
                '05-09': {
                    _name: '05-09',
                    type: 'observance'
                },
                '05-26': {
                    _name: 'Mothers Day',
                    type: 'observance'
                },
                '06-01': {
                    name: {
                        pl: "Dzie\u0144 Dziecka",
                        en: "Children's Day"
                    },
                    type: 'observance'
                },
                '06-12 since 2017': {
                    name: {
                        pl: "Dzie\u0144 Walki i M\u0119cze\u0144stwa Wsi Polskiej",
                        en: 'Day of Struggle and Martyrdom of the Polish Villages'
                    },
                    type: 'observance',
                    note: 'National holiday, although not a public holiday'
                },
                '06-23': {
                    _name: 'Fathers Day',
                    type: 'observance'
                },
                'easter 49': {
                    _name: 'easter 49'
                },
                'easter 60': {
                    _name: 'easter 60'
                },
                '08-01 since 2009': {
                    name: {
                        pl: "Narodowy Dzie\u0144 Pami\u0119ci Powstania Warszawskiego",
                        en: 'National Warsaw Uprising Remembrance Day'
                    },
                    type: 'observance',
                    note: 'National holiday, although not a public holiday'
                },
                '08-15': {
                    _name: '08-15'
                },
                '08-31 since 2005': {
                    name: {
                        pl: "Dzie\u0144 Solidarno\u015Bci i Wolno\u015Bci",
                        en: 'Day of Solidarity and Freedom'
                    },
                    type: 'observance',
                    note: 'National holiday, although not a public holiday'
                },
                '09-01': {
                    name: {
                        pl: "Rocznica wybuchu II wojny \u015Bwiatowej",
                        en: 'Anniversary of the outbreak of the Second World War in Poland'
                    },
                    type: 'observance'
                },
                '09-17': {
                    name: {
                        pl: "Rocznica agresji ZSRR na Polsk\u0119",
                        en: 'Anniversary of the Soviet invasion of Poland'
                    },
                    type: 'observance'
                },
                '09-30': {
                    name: {
                        pl: "Dzie\u0144 Ch\u0142opaka",
                        en: "Boy's Day"
                    },
                    type: 'observance'
                },
                '10-19 since 2018': {
                    name: {
                        pl: "Narodowy Dzie\u0144 Pami\u0119ci Duchownych Niez\u0142omnych",
                        en: 'National Day of Remembrance for Steadfast Clergy'
                    },
                    type: 'observance',
                    note: 'National holiday, although not a public holiday'
                },
                '11-01': {
                    _name: '11-01'
                },
                '11-11': {
                    _name: 'Independence Day'
                },
                '12-06': {
                    _name: '12-06',
                    type: 'observance'
                },
                '12-24 since 2025': {
                    _name: '12-24'
                },
                '12-25': {
                    _name: '12-25'
                },
                '12-26': {
                    _name: '12-26'
                },
                '12-27 since 2021': {
                    name: {
                        pl: "Narodowy Dzie\u0144 Pami\u0119ci Zwyci\u0119skiego Powstania Wielkopolskiego",
                        en: 'Greater Poland Uprising Remebrence Day'
                    },
                    type: 'observance',
                    note: 'National holiday, although not a public holiday'
                },
                '12-31': {
                    _name: '12-31',
                    type: 'observance'
                }
            }
        },
        PM: {
            names: {
                en: 'St. Pierre & Miquelon'
            },
            langs: [
                'fr'
            ],
            zones: [
                'America/Miquelon'
            ],
            dayoff: 'sunday',
            days: {},
            _days: 'FR'
        },
        PR: {
            names: {
                en: 'Puerto Rico'
            },
            langs: [
                'es',
                'en'
            ],
            zones: [
                'America/Puerto_Rico'
            ],
            dayoff: 'sunday',
            _days: 'US',
            days: {
                '01-06': {
                    _name: '01-06'
                },
                '2nd Monday in January': {
                    name: {
                        es: "Natalicio de Eugenio Mar\xeda de Hostos",
                        en: "Birthday of Eugenio Mar\xeda de Hostos"
                    }
                },
                '02-18': {
                    name: {
                        es: "Natalicio de Luis Mu\xf1oz Mar\xedn",
                        en: "Birthday of Luis Mu\xf1oz Mar\xedn"
                    }
                },
                '03-02 since 2017': {
                    name: {
                        es: "D\xeda de la Ciudadan\xeda Americana",
                        en: 'American Citizenship Day'
                    }
                },
                '03-17': false,
                '03-22': {
                    name: {
                        es: "D\xeda de la Abolici\xf3n de Esclavitud",
                        en: 'Emancipation Day'
                    }
                },
                '04-16': {
                    name: {
                        es: "Natalicio de Jos\xe9 de Diego",
                        en: "Birthday of Jos\xe9 de Diego"
                    }
                },
                '3rd Monday in July': {
                    name: {
                        es: "Natalicio de Don Luis Mu\xf1oz Rivera",
                        en: "Birthday of Don Luis Mu\xf1oz Rivera"
                    }
                },
                '07-25': {
                    name: {
                        es: "Constituci\xf3n de Puerto Rico",
                        en: 'Puerto Rico Constitution Day'
                    }
                },
                '07-27': {
                    name: {
                        es: "Natalicio de Dr. Jos\xe9 Celso Barbosa",
                        en: "Birthday of Dr. Jos\xe9 Celso Barbosa"
                    }
                },
                '11-19': {
                    name: {
                        es: "D\xeda del Descubrimiento de Puerto Rico",
                        en: 'Discovery of Puerto Rico'
                    }
                }
            }
        },
        PT: {
            names: {
                pt: 'Portugal',
                en: 'Portugal'
            },
            dayoff: 'sunday',
            langs: [
                'pt'
            ],
            zones: [
                'Europe/Lisbon',
                'Atlantic/Madeira',
                'Atlantic/Azores'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                'easter -47': {
                    _name: 'easter -47',
                    type: 'observance'
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                easter: {
                    _name: 'easter'
                },
                '04-25': {
                    name: {
                        pt: 'Dia da Liberdade',
                        en: 'Liberty Day'
                    }
                },
                '05-01': {
                    _name: '05-01'
                },
                '1st sunday in May': {
                    _name: 'Mothers Day',
                    type: 'observance'
                },
                'easter 60': {
                    _name: 'easter 60'
                },
                '06-10': {
                    name: {
                        pt: 'Dia de Portugal',
                        en: 'Portugal Day'
                    }
                },
                '08-15': {
                    _name: '08-15'
                },
                '10-05': {
                    name: {
                        pt: "Implanta\xe7\xe3o da Rep\xfablica"
                    }
                },
                '11-01': {
                    _name: '11-01'
                },
                '12-01': {
                    name: {
                        pt: "Restaura\xe7\xe3o da Independ\xeancia"
                    }
                },
                '12-08': {
                    _name: '12-08'
                },
                '12-24': {
                    _name: '12-24',
                    type: 'observance'
                },
                '12-25': {
                    _name: '12-25'
                },
                '12-31': {
                    _name: '12-31',
                    type: 'observance'
                }
            }
        },
        PY: {
            names: {
                es: 'Paraguay',
                en: 'Paraguay'
            },
            dayoff: 'sunday',
            langs: [
                'es'
            ],
            zones: [
                'America/Asuncion'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '03-01': {
                    disable: [
                        '2017-03-01'
                    ],
                    enable: [
                        '2017-02-27'
                    ],
                    name: {
                        en: "Heroes' Day",
                        es: "Dia de los h\xe9roes"
                    }
                },
                'easter -3': {
                    _name: 'easter -3'
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                '04-30': {
                    name: {
                        en: "Teacher's Day",
                        es: "D\xeda del Maestro"
                    },
                    type: 'optional',
                    note: 'Affects educational institutions'
                },
                '05-01': {
                    _name: '05-01'
                },
                '05-14': {
                    _name: 'Independence Day'
                },
                '05-15': {
                    _name: 'Independence Day'
                },
                '06-12': {
                    name: {
                        en: 'Chaco Armistice',
                        es: "D\xeda de la Paz del Chaco"
                    },
                    disable: [
                        '2020-06-12'
                    ],
                    enable: [
                        '2020-06-15'
                    ]
                },
                '08-15': {
                    _name: '08-15',
                    disable: [
                        '2017-08-15'
                    ],
                    enable: [
                        '2017-08-14'
                    ]
                },
                '09-29': {
                    disable: [
                        '2017-09-29'
                    ],
                    enable: [
                        '2017-10-02'
                    ],
                    name: {
                        en: 'Boqueron Battle Victory Day',
                        es: "Victoria de Boquer\xf3n"
                    }
                },
                '12-08': {
                    _name: '12-08',
                    name: {
                        en: 'Virgin of Caacupe',
                        es: "Virgen de Caacup\xe9"
                    }
                },
                '12-25': {
                    _name: '12-25'
                },
                '12-31': {
                    _name: '12-31',
                    type: 'bank'
                }
            }
        },
        RE: {
            names: {
                fr: "R\xe9union",
                en: "R\xe9union"
            },
            langs: [
                'fr'
            ],
            zones: [
                'Indian/Reunion'
            ],
            dayoff: '',
            _days: 'FR',
            days: {
                '12-20': {
                    _name: 'Abolition of Slavery'
                }
            }
        },
        RO: {
            names: {
                ro: 'Romania',
                en: 'Romania'
            },
            dayoff: 'sunday',
            langs: [
                'ro'
            ],
            zones: [
                'Europe/Bucharest'
            ],
            days: {
                '01-01 P2DT': {
                    name: {
                        ro: 'Anul nou',
                        en: "New Year's Day"
                    }
                },
                '01-06': {
                    name: {
                        ro: "Boboteaz\u0103",
                        en: 'Epiphany'
                    }
                },
                '01-07': {
                    name: {
                        ro: "Sf\xe2ntul Ion",
                        en: 'Saint John the Baptist'
                    }
                },
                '01-24': {
                    name: {
                        ro: "Ziua Unirii Principatelor Rom\xe2ne",
                        en: 'Day of the Unification of the Romanian Principalities'
                    }
                },
                '03-08': {
                    name: {
                        ro: 'Ziua Mamei',
                        en: "Mother's Day"
                    },
                    type: 'observance'
                },
                'orthodox -2': {
                    _name: 'easter -2'
                },
                orthodox: {
                    _name: 'easter'
                },
                'orthodox 1': {
                    _name: 'easter 1'
                },
                '05-01': {
                    _name: '05-01'
                },
                'orthodox 39': {
                    _name: 'easter 39',
                    type: 'observance'
                },
                'orthodox 49': {
                    _name: 'easter 49'
                },
                'orthodox 50': {
                    _name: 'easter 50'
                },
                'Sunday before 06-01': {
                    name: {
                        ro: "Ziua Rom\xe2nilor de Pretutindeni, Ziua Rom\xe2nului de Pretutindeni",
                        en: 'Day of the Romanians Everywhere, Romanian Businessperson Day'
                    },
                    type: 'observance'
                },
                '06-01': {
                    name: {
                        ro: 'Ziua Copilului',
                        en: "Children's Day"
                    }
                },
                '06-26': {
                    name: {
                        ro: 'Ziua drapelului national',
                        en: 'Flag Day'
                    },
                    type: 'observance'
                },
                '07-29': {
                    name: {
                        ro: "Ziua Imnului na\u021Bional",
                        en: 'National Anthem Day'
                    },
                    type: 'observance'
                },
                '08-15': {
                    _name: '08-15'
                },
                '11-30': {
                    name: {
                        ro: "Sf\xe2ntul Andrei",
                        en: "St Andrew's Day"
                    }
                },
                '12-01': {
                    name: {
                        ro: "Ziua na\u021Bional\u0103, Ziua Marii Uniri",
                        en: 'National holiday'
                    }
                },
                '12-08': {
                    _name: 'Constitution Day',
                    type: 'observance'
                },
                '12-25': {
                    _name: '12-25'
                },
                '12-26': {
                    _name: '12-26'
                }
            }
        },
        RS: {
            names: {
                sr: "\u0420\u0435\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0421\u0440\u0431\u0438\u0458\u0430",
                en: 'Serbia'
            },
            langs: [
                'sr'
            ],
            zones: [
                'Europe/Belgrade'
            ],
            dayoff: 'sunday',
            days: {
                '01-01 if sunday then next tuesday': {
                    _name: '01-01'
                },
                '01-02 if sunday then next monday': {
                    _name: '01-01'
                },
                'julian 12-25': {
                    _name: 'julian 12-25'
                },
                '02-15 if sunday then next tuesday': {
                    name: {
                        sr: "\u0414\u0430\u043D \u0434\u0440\u0436\u0430\u0432\u043D\u043E\u0441\u0442\u0438 \u0421\u0440\u0431\u0438\u0458\u0435",
                        en: 'Statehood Day'
                    }
                },
                '02-16 if sunday then next monday': {
                    name: {
                        sr: "\u0414\u0430\u043D \u0434\u0440\u0436\u0430\u0432\u043D\u043E\u0441\u0442\u0438 \u0421\u0440\u0431\u0438\u0458\u0435",
                        en: 'Statehood Day'
                    }
                },
                'orthodox -2': {
                    _name: 'orthodox -2'
                },
                orthodox: {
                    _name: 'orthodox'
                },
                'orthodox 1': {
                    _name: 'orthodox 1'
                },
                '05-01 if sunday then next tuesday': {
                    _name: '05-01'
                },
                '05-02 if sunday then next monday': {
                    _name: '05-01'
                },
                '11-11 if sunday then next monday': {
                    name: {
                        sr: "\u0414\u0430\u043D \u043F\u0440\u0438\u043C\u0438\u0440\u0458\u0430",
                        en: 'Armistice Day'
                    }
                },
                'easter -2': {
                    _name: 'easter -2',
                    type: 'optional',
                    note: 'Catholic believers'
                },
                easter: {
                    _name: 'easter',
                    type: 'optional',
                    note: 'Catholic believers'
                },
                'easter 1': {
                    _name: 'easter 1',
                    type: 'optional',
                    note: 'Catholic believers'
                },
                '12-25': {
                    _name: '12-25',
                    type: 'optional',
                    note: 'Catholic believers'
                },
                '10 Dhu al-Hijjah': {
                    _name: '10 Dhu al-Hijjah',
                    type: 'optional',
                    note: 'Muslim believers'
                },
                '1 Shawwal': {
                    _name: '1 Shawwal',
                    type: 'optional',
                    note: 'Muslim believers'
                },
                '10 Tishrei': {
                    _name: '10 Tishrei',
                    type: 'optional',
                    note: 'Jewish believers'
                },
                'julian 01-14': {
                    name: {
                        sr: "\u0421\u0432\u0435\u0442\u0438 \u0421\u0430\u0432\u0430",
                        en: 'Saint Sava Day'
                    },
                    type: 'observance'
                },
                '04-22': {
                    name: {
                        sr: "\u0414\u0430\u043D \u0441\u0435\u045B\u0430\u045A\u0430 \u043D\u0430 \u0436\u0440\u0442\u0432\u0435 \u0445\u043E\u043B\u043E\u043A\u0430\u0443\u0441\u0442\u0430",
                        en: 'Holocaust Remembrance Day'
                    },
                    type: 'observance'
                },
                '05-09': {
                    name: {
                        sr: "\u0414\u0430\u043D \u043F\u043E\u0431\u0435\u0434\u0435",
                        en: 'Victory Day'
                    },
                    type: 'observance'
                },
                'julian 06-15': {
                    name: {
                        sr: "\u0412\u0438\u0434\u043E\u0432\u0434\u0430\u043D",
                        en: 'Saint Vitus Day'
                    },
                    type: 'observance'
                },
                '10-21': {
                    name: {
                        sr: "\u0414\u0430\u043D \u0441\u0435\u045B\u0430\u045A\u0430 \u043D\u0430 \u0441\u0440\u043F\u0441\u043A\u0435 \u0436\u0440\u0442\u0432\u0435 \u0443 \u0414\u0440\u0443\u0433\u043E\u043C \u0441\u0432\u0435\u0442\u0441\u043A\u043E\u043C \u0440\u0430\u0442\u0443",
                        en: 'World War II Serbian Victims Remembrance Day'
                    },
                    type: 'observance'
                }
            }
        },
        RU: {
            names: {
                ru: "\u0420\u043E\u0441\u0441\u0438\u044F",
                en: 'Russia'
            },
            dayoff: 'sunday',
            langs: [
                'ru'
            ],
            zones: [
                'Europe/Moscow',
                'Europe/Kaliningrad',
                'Europe/Simferopol',
                'Europe/Volgograd',
                'Europe/Samara',
                'Asia/Yekaterinburg',
                'Asia/Omsk',
                'Asia/Novosibirsk',
                'Asia/Novokuznetsk',
                'Asia/Krasnoyarsk',
                'Asia/Irkutsk',
                'Asia/Chita',
                'Asia/Yakutsk',
                'Asia/Khandyga',
                'Asia/Vladivostok',
                'Asia/Sakhalin',
                'Asia/Ust-Nera',
                'Asia/Magadan',
                'Asia/Srednekolymsk',
                'Asia/Kamchatka',
                'Asia/Anadyr'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '01-02 P5D': {
                    name: {
                        ru: "\u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                        en: 'New Year Holiday'
                    }
                },
                'julian 12-25': {
                    _name: '12-25'
                },
                '01-08': {
                    name: {
                        ru: "\u041D\u043E\u0432\u043E\u0433\u043E\u0434\u043D\u0438\u0435 \u043A\u0430\u043D\u0438\u043A\u0443\u043B\u044B",
                        en: 'New Year Holiday'
                    }
                },
                '02-23': {
                    name: {
                        ru: "\u0414\u0435\u043D\u044C \u0437\u0430\u0449\u0438\u0442\u043D\u0438\u043A\u0430 \u041E\u0442\u0435\u0447\u0435\u0441\u0442\u0432\u0430",
                        en: 'Defender of the Fatherland Day'
                    }
                },
                '03-08': {
                    _name: '03-08'
                },
                '05-01': {
                    name: {
                        ru: "\u0414\u0435\u043D\u044C \u0432\u0435\u0441\u043D\u044B \u0438 \u0442\u0440\u0443\u0434\u0430",
                        en: 'Spring and Labour Day'
                    }
                },
                '05-09': {
                    name: {
                        ru: "\u0414\u0435\u043D\u044C \u041F\u043E\u0431\u0435\u0434\u044B",
                        en: 'Victory Day'
                    }
                },
                '06-12': {
                    name: {
                        ru: "\u0414\u0435\u043D\u044C \u0420\u043E\u0441\u0441\u0438\u0438",
                        en: 'Russia Day'
                    }
                },
                '11-04': {
                    name: {
                        ru: "\u0414\u0435\u043D\u044C \u043D\u0430\u0440\u043E\u0434\u043D\u043E\u0433\u043E \u0435\u0434\u0438\u043D\u0441\u0442\u0432\u0430",
                        en: 'Unity Day'
                    }
                }
            }
        },
        RW: {
            names: {
                en: 'Rwanda',
                fr: "R\xe9publique du Rwanda",
                rw: "Repubulika y'u Rwanda"
            },
            dayoff: 'sunday',
            langs: [
                'en',
                'fr',
                'rw'
            ],
            zones: [
                'Africa/Maputo'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '01-02': {
                    _name: 'Public Holiday'
                },
                '02-01': {
                    name: {
                        en: 'Heroes Day'
                    }
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                '04-07': {
                    name: {
                        fr: "Jour de M\xe9morial du G\xe9nocide",
                        en: 'Genocide Memorial Day'
                    }
                },
                '05-01': {
                    _name: '05-01'
                },
                '07-01': {
                    _name: 'Independence Day'
                },
                '07-04': {
                    name: {
                        fr: "Jour de la Lib\xe9ration",
                        en: 'Liberation Day'
                    }
                },
                '08-15': {
                    _name: '08-15'
                },
                '1st friday in August': {
                    name: {
                        rw: 'Umuganura',
                        fr: "Journ\xe9e nationale de r\xe9colte",
                        en: 'National Harvest Day'
                    }
                },
                '12-25': {
                    _name: '12-25'
                },
                '12-26': {
                    _name: '12-26'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '1 Shawwal': {
                    _name: '1 Shawwal'
                },
                '10 Dhu al-Hijjah': {
                    _name: '10 Dhu al-Hijjah'
                }
            }
        },
        SA: {
            names: {
                ar: "\u0627\u0644\u0645\u0645\u0644\u0643\u0629 \u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0627\u0644\u0633\u0639\u0648\u062F\u064A\u0629",
                en: 'Saudi Arabia'
            },
            langs: [
                'ar',
                'en'
            ],
            zones: [
                'Asia/Riyadh'
            ],
            dayoff: 'Saturday',
            days: {
                '02-22 since 2022': {
                    name: {
                        ar: "\u064A\u0648\u0645 \u0627\u0644\u062A\u0623\u0633\u064A\u0633",
                        en: 'Founding Day'
                    }
                },
                '09-23 since 2005': {
                    name: {
                        ar: "\u0627\u0644\u064A\u0648\u0645 \u0627\u0644\u0648\u0637\u0646\u064A",
                        en: 'National Day'
                    }
                },
                '29 Ramadan P4D': {
                    _name: '1 Shawwal'
                },
                '9 Dhu al-Hijjah P4D': {
                    _name: '10 Dhu al-Hijjah'
                }
            }
        },
        SC: {
            names: {
                en: 'Seychelles',
                fr: "R\xe9publique des Seychelles",
                crs: 'Repiblik Sesel'
            },
            langs: [
                'en',
                'fr',
                'crs'
            ],
            zones: [
                'Indian/Mahe'
            ],
            dayoff: 'sunday',
            days: {
                '01-01 P2D': {
                    _name: '01-01'
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                'easter -1': {
                    _name: 'easter -1'
                },
                easter: {
                    _name: 'easter'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                'easter 60': {
                    _name: 'easter 60'
                },
                '05-01': {
                    _name: '05-01'
                },
                '06-18': {
                    _name: 'National Holiday'
                },
                '06-29': {
                    _name: 'Independence Day'
                },
                '08-15': {
                    _name: '08-15'
                },
                '11-01': {
                    _name: '11-01'
                },
                '12-08': {
                    _name: '12-08'
                },
                '12-25': {
                    _name: '12-25'
                }
            }
        },
        SD: {
            names: {
                ar: "\u062C\u0645\u0647\u0648\u0631\u064A\u0629 \u0627\u0644\u0633\u0648\u062F\u0627\u0646",
                en: 'Sudan'
            },
            langs: [],
            zones: [
                'Africa/Khartoum'
            ],
            dayoff: '',
            days: {
                '01-01': {
                    _name: 'Independence Day'
                },
                '12-19': {
                    _name: 'Revolution Day'
                },
                '12-25': {
                    _name: '12-25'
                },
                '1 Muharram': {
                    _name: '1 Muharram'
                },
                '12 Rabi al-awwal': {
                    _name: '12 Rabi al-awwal'
                },
                '1 Shawwal P4D': {
                    _name: '1 Shawwal'
                },
                '10 Dhu al-Hijjah P3D': {
                    _name: '10 Dhu al-Hijjah'
                },
                'julian 12-25': {
                    _name: 'julian 12-25',
                    name: {
                        en: 'Coptic Christmas'
                    }
                },
                orthodox: {
                    _name: 'orthodox',
                    name: {
                        en: 'Coptic Easter'
                    }
                }
            }
        },
        SE: {
            names: {
                sv: 'Sverige',
                en: 'Sweden'
            },
            dayoff: 'sunday',
            langs: [
                'sv'
            ],
            zones: [
                'Europe/Stockholm'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '01-05 12:00': {
                    name: {
                        sv: 'Trettondagsafton',
                        en: 'Twelfth Night'
                    },
                    type: 'optional'
                },
                '01-06': {
                    _name: '01-06'
                },
                '01-13': {
                    name: {
                        sv: 'Tjugondag Knut',
                        en: "Saint Knut's Day"
                    },
                    type: 'observance'
                },
                '1st sunday in March': {
                    name: {
                        sv: 'Vasaloppet'
                    },
                    type: 'observance'
                },
                '03-25': {
                    name: {
                        sv: "Marie Beb\xe5delsedag",
                        en: 'Annunciation Day',
                        lat: "Annuntiatio Mari\xe6"
                    },
                    type: 'observance'
                },
                '04-30 12:00': {
                    name: {
                        sv: "Valborgsm\xe4ssoafton",
                        en: 'Walpurgis Night'
                    },
                    type: 'optional'
                },
                'easter -3': {
                    _name: 'easter -3',
                    type: 'observance'
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                easter: {
                    _name: 'easter',
                    type: 'observance'
                },
                'easter -1': {
                    _name: 'easter -1',
                    type: 'observance'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '05-01': {
                    _name: '05-01'
                },
                'easter 39': {
                    _name: 'easter 39'
                },
                'easter 48': {
                    name: {
                        sv: 'Pingstafton',
                        en: 'Whitsun Eve'
                    },
                    type: 'observance'
                },
                'easter 49': {
                    _name: 'easter 49',
                    type: 'public'
                },
                'easter 50': {
                    _name: 'easter 50',
                    type: 'observance'
                },
                'sunday before 06-01': {
                    _name: 'Mothers Day',
                    type: 'observance'
                },
                '06-06': {
                    name: {
                        sv: 'Sveriges nationaldag',
                        en: 'National Day'
                    }
                },
                'friday after 06-19': {
                    name: {
                        sv: 'Midsommarafton',
                        en: 'Midsummer Eve',
                        fi: 'Juhannusaatto'
                    },
                    type: 'bank'
                },
                'saturday after 06-20': {
                    name: {
                        sv: 'Midsommardagen',
                        en: 'Midsummer Day',
                        fi: "Juhannusp\xe4iv\xe4"
                    }
                },
                'friday after 10-30 12:00': {
                    name: {
                        sv: 'Allhelgonaafton',
                        en: 'Halloween'
                    },
                    type: 'optional'
                },
                'saturday after 10-31': {
                    _name: '11-01'
                },
                '11-06': {
                    name: {
                        sv: 'Gustav-Adolf-dagen',
                        en: 'Gustavus Adolphus Day'
                    },
                    type: 'observance'
                },
                '11-11': {
                    name: {
                        sv: "M\xe5rtensg\xe5s",
                        en: "Saint Martin's Day"
                    },
                    type: 'observance'
                },
                '12-10': {
                    name: {
                        sv: 'Nobeldagen',
                        en: 'Nobel Day'
                    },
                    type: 'observance'
                },
                '12-13': {
                    name: {
                        sv: 'Luciadagen',
                        en: "Saint Lucy's Day"
                    },
                    type: 'observance'
                },
                '12-24': {
                    _name: '12-24',
                    type: 'bank'
                },
                '12-25': {
                    _name: '12-25'
                },
                '12-26': {
                    _name: '12-26'
                },
                '12-31': {
                    _name: '12-31',
                    type: 'bank'
                }
            }
        },
        SG: {
            names: {
                en: 'Singapore'
            },
            langs: [
                'en'
            ],
            zones: [
                'Asia/Singapore'
            ],
            dayoff: 'sunday',
            days: {
                '01-01': {
                    _name: '01-01'
                },
                'substitutes 01-01 if sunday then next monday': {
                    substitute: true,
                    _name: '01-01'
                },
                'chinese 01-0-01': {
                    name: {
                        en: 'Chinese New Year'
                    }
                },
                'chinese 01-0-02': {
                    name: {
                        en: 'Chinese New Year'
                    }
                },
                'substitutes chinese 01-0-01 if sunday then next tuesday': {
                    substitute: true,
                    name: {
                        en: 'Chinese New Year'
                    }
                },
                'substitutes chinese 01-0-02 if sunday then next monday': {
                    substitute: true,
                    name: {
                        en: 'Chinese New Year'
                    }
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                '05-01': {
                    _name: '05-01'
                },
                'substitutes 05-01 if sunday then next monday': {
                    substitute: true,
                    _name: '05-01'
                },
                '08-09': {
                    name: {
                        en: 'National Day'
                    }
                },
                'substitutes 08-09 if sunday then next monday': {
                    substitute: true,
                    name: {
                        en: 'National Day'
                    }
                },
                '12-25': {
                    _name: '12-25'
                },
                'substitutes 12-25 if sunday then next monday': {
                    substitute: true,
                    _name: '12-25'
                },
                '1 Shawwal': {
                    _name: '1 Shawwal',
                    name: {
                        en: 'Hari Raya Puasa'
                    },
                    disable: [
                        '2022-05-02',
                        '2023-04-21',
                        '2024-04-09',
                        '2025-03-30'
                    ],
                    enable: [
                        '2022-05-03',
                        '2023-04-22',
                        '2024-04-10',
                        '2025-03-31'
                    ]
                },
                '10 Dhu al-Hijjah': {
                    _name: '10 Dhu al-Hijjah',
                    name: {
                        en: 'Hari Raya Haji'
                    },
                    disable: [
                        '2022-07-09',
                        '2023-06-28',
                        '2024-06-29',
                        '2025-06-06'
                    ],
                    enable: [
                        '2022-07-10',
                        '2023-06-29',
                        '2024-06-17',
                        '2025-06-07'
                    ]
                },
                '2001-05-07': {
                    _name: 'Vesak'
                },
                '2002-05-27': {
                    _name: 'Vesak'
                },
                '2003-05-15': {
                    _name: 'Vesak'
                },
                '2004-06-02': {
                    _name: 'Vesak'
                },
                '2005-05-23': {
                    _name: 'Vesak'
                },
                '2006-05-12': {
                    _name: 'Vesak'
                },
                '2007-05-31': {
                    _name: 'Vesak'
                },
                '2008-05-19': {
                    _name: 'Vesak'
                },
                '2009-05-09': {
                    _name: 'Vesak'
                },
                '2010-05-28': {
                    _name: 'Vesak'
                },
                '2011-05-17': {
                    _name: 'Vesak'
                },
                '2012-05-05': {
                    _name: 'Vesak'
                },
                '2013-05-24': {
                    _name: 'Vesak'
                },
                '2014-05-13': {
                    _name: 'Vesak'
                },
                '2015-06-01': {
                    _name: 'Vesak'
                },
                '2016-05-21': {
                    _name: 'Vesak'
                },
                '2017-05-10': {
                    _name: 'Vesak'
                },
                '2018-05-29': {
                    _name: 'Vesak'
                },
                '2019-05-19': {
                    _name: 'Vesak'
                },
                '2019-05-20': {
                    substitute: true,
                    _name: 'Vesak'
                },
                '2020-05-07': {
                    _name: 'Vesak'
                },
                '2021-05-26': {
                    _name: 'Vesak'
                },
                '2022-05-15': {
                    _name: 'Vesak'
                },
                '2022-05-16': {
                    substitute: true,
                    _name: 'Vesak'
                },
                '2023-06-02': {
                    _name: 'Vesak'
                },
                '2024-05-22': {
                    _name: 'Vesak'
                },
                '2000-10-26': {
                    _name: 'Deepavali'
                },
                '2001-11-14': {
                    _name: 'Deepavali'
                },
                '2002-11-03': {
                    _name: 'Deepavali'
                },
                '2002-11-04': {
                    substitute: true,
                    _name: 'Deepavali'
                },
                '2003-10-23': {
                    _name: 'Deepavali'
                },
                '2004-11-11': {
                    _name: 'Deepavali'
                },
                '2005-11-01': {
                    _name: 'Deepavali'
                },
                '2006-10-21': {
                    _name: 'Deepavali'
                },
                '2007-11-08': {
                    _name: 'Deepavali'
                },
                '2008-10-27': {
                    _name: 'Deepavali'
                },
                '2009-10-17': {
                    _name: 'Deepavali'
                },
                '2010-11-05': {
                    _name: 'Deepavali'
                },
                '2011-10-26': {
                    _name: 'Deepavali'
                },
                '2012-11-13': {
                    _name: 'Deepavali'
                },
                '2013-11-03': {
                    _name: 'Deepavali'
                },
                '2013-11-04': {
                    substitute: true,
                    _name: 'Deepavali'
                },
                '2014-10-22': {
                    _name: 'Deepavali'
                },
                '2015-11-10': {
                    _name: 'Deepavali'
                },
                '2016-10-29': {
                    _name: 'Deepavali'
                },
                '2017-10-18': {
                    _name: 'Deepavali'
                },
                '2018-11-06': {
                    _name: 'Deepavali'
                },
                '2019-10-27': {
                    _name: 'Deepavali'
                },
                '2019-10-28': {
                    substitute: true,
                    _name: 'Deepavali'
                },
                '2020-11-14': {
                    _name: 'Deepavali'
                },
                '2021-11-04': {
                    _name: 'Deepavali'
                },
                '2022-10-24': {
                    _name: 'Deepavali'
                },
                '2023-11-13': {
                    _name: 'Deepavali'
                },
                '2024-10-31': {
                    _name: 'Deepavali'
                },
                '2025-10-20': {
                    _name: 'Deepavali'
                },
                '2026-11-09': {
                    _name: 'Deepavali'
                },
                '2027-10-28': {
                    _name: 'Deepavali'
                },
                '2028-11-15': {
                    _name: 'Deepavali'
                },
                '2029-11-05': {
                    _name: 'Deepavali'
                },
                '2030-10-25': {
                    _name: 'Deepavali'
                },
                '2023-09-1': {
                    name: {
                        en: 'Presidential Election Day'
                    },
                    type: 'public'
                }
            }
        },
        SH: {
            names: {
                en: 'St. Helena'
            },
            langs: [
                'en'
            ],
            zones: [
                'Africa/Abidjan'
            ],
            dayoff: 'sunday',
            days: {
                '01-01': {
                    _name: '01-01'
                },
                'substitutes 01-01 if sunday then next monday': {
                    substitute: true,
                    _name: '01-01'
                },
                'substitutes 01-01 if saturday then next monday': {
                    substitute: true,
                    _name: '01-01'
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                easter: {
                    _name: 'easter',
                    type: 'observance'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '3rd monday in April': {
                    name: {
                        en: "Queen's Birthday"
                    }
                },
                '05-21': {
                    name: {
                        en: 'Saint Helena Day'
                    }
                },
                'easter 50': {
                    _name: 'easter 50'
                },
                'monday before 09-01': {
                    name: {
                        en: 'August Bank Holiday'
                    }
                },
                '12-25': {
                    _name: '12-25'
                },
                'substitutes 12-25 if saturday then next tuesday': {
                    substitute: true,
                    _name: '12-25'
                },
                'substitutes 12-25 if sunday then next tuesday': {
                    substitute: true,
                    _name: '12-25'
                },
                '12-26': {
                    _name: '12-26'
                },
                'substitutes 12-26 if saturday then next monday': {
                    substitute: true,
                    _name: '12-26'
                },
                'substitutes 12-26 if sunday then next monday': {
                    substitute: true,
                    _name: '12-26'
                }
            },
            states: {
                AC: {
                    name: 'Ascension Island',
                    days: {
                        'easter 39': {
                            _name: 'easter 39'
                        }
                    }
                },
                HL: {
                    name: 'Saint Helena',
                    days: {}
                },
                TA: {
                    name: 'Tristan da Cunha',
                    days: {
                        'easter 39': {
                            _name: 'easter 39'
                        },
                        '2012-04-23': {
                            name: {
                                en: 'Ratting Day'
                            }
                        },
                        '2013-05-03': {
                            name: {
                                en: 'Ratting Day'
                            }
                        },
                        '2014-05-02': {
                            name: {
                                en: 'Ratting Day'
                            }
                        },
                        '2015-05-16': {
                            name: {
                                en: 'Ratting Day'
                            }
                        },
                        '2016-04-30': {
                            name: {
                                en: 'Ratting Day'
                            }
                        },
                        '2017-05-26': {
                            name: {
                                en: 'Ratting Day'
                            }
                        },
                        '2018-06-02': {
                            name: {
                                en: 'Ratting Day'
                            }
                        },
                        '08-14': {
                            name: {
                                en: 'Anniversary Day'
                            }
                        },
                        'monday before 09-01': false
                    }
                }
            }
        },
        SI: {
            names: {
                sl: 'Republika Slovenija',
                en: 'Slovenia'
            },
            langs: [
                'sl'
            ],
            zones: [
                'Europe/Belgrade'
            ],
            dayoff: 'sunday',
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '01-02': {
                    _name: '01-01',
                    active: [
                        {
                            to: 1955
                        },
                        {
                            from: 2017
                        }
                    ]
                },
                '02-08': {
                    name: {
                        en: "Pre\u0161eren Day, the Slovenian Cultural Holiday",
                        sl: "Pre\u0161ernov dan, slovenski kulturni praznik"
                    },
                    active: [
                        {
                            from: 1991
                        }
                    ]
                },
                '03-08': {
                    _name: '03-08',
                    type: 'observance'
                },
                '04-23': {
                    name: {
                        sl: 'Jurjevanje',
                        en: "St. George's Day"
                    },
                    type: 'observance'
                },
                'easter -49': {
                    name: {
                        sl: 'Pust',
                        en: 'Carnival'
                    },
                    type: 'observance'
                },
                easter: {
                    _name: 'easter'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '04-27': {
                    name: {
                        sl: 'Dan upora proti okupatorju',
                        en: 'Day of Uprising Against Occupation'
                    }
                },
                '05-01': {
                    _name: '05-01',
                    name: {
                        en: 'Labour Day'
                    },
                    active: [
                        {
                            from: 1949
                        }
                    ]
                },
                '05-02': {
                    _name: '05-01',
                    name: {
                        en: 'Labour Day'
                    },
                    active: [
                        {
                            from: 1949
                        }
                    ]
                },
                'easter 49': {
                    _name: 'easter 49'
                },
                '06-08': {
                    name: {
                        sl: "Dan Primo\u017Ea Trubarja",
                        en: "Primo\u017E Trubar Day"
                    },
                    type: 'observance',
                    active: [
                        {
                            from: 2010
                        }
                    ]
                },
                '06-25': {
                    name: {
                        sl: "Dan dr\u017Eavnosti",
                        en: 'Statehood Day'
                    },
                    active: [
                        {
                            from: 1991
                        }
                    ]
                },
                '08-15': {
                    _name: '08-15',
                    active: [
                        {
                            from: 1992
                        }
                    ]
                },
                '08-17': {
                    name: {
                        sl: "Zdru\u017Eitev prekmurskih Slovencev z mati\u010Dnim narodom",
                        en: 'Unification of Prekmurje Slovenes with the Mother Nation'
                    },
                    type: 'observance',
                    active: [
                        {
                            from: 2006
                        }
                    ]
                },
                '09-15': {
                    name: {
                        sl: "Vrnitev Primorske k mati\u010Dni domovini",
                        en: 'Return of Primorska to the Motherland'
                    },
                    type: 'observance',
                    active: [
                        {
                            from: 2005
                        }
                    ]
                },
                '09-23': {
                    name: {
                        sl: "Dan slovenskega \u0161porta",
                        en: 'Slovenian Sports Day'
                    },
                    type: 'observance',
                    active: [
                        {
                            from: 2020
                        }
                    ]
                },
                '10-25': {
                    name: {
                        sl: 'Dan suverenosti',
                        en: 'Sovereignty Day'
                    },
                    type: 'observance',
                    active: [
                        {
                            from: 2015
                        }
                    ]
                },
                '10-31': {
                    name: {
                        sl: 'Dan reformacije',
                        en: 'Reformation Day'
                    }
                },
                '11-01': {
                    name: {
                        sl: 'Dan spomina na mrtve',
                        en: 'Day of Remembrance for the Dead'
                    }
                },
                '11-11': {
                    name: {
                        sl: 'Martinovanje',
                        en: "St. Martin's Day"
                    },
                    type: 'observance'
                },
                '11-23': {
                    name: {
                        sl: 'Dan Rudolfa Maistra',
                        en: 'Rudolf Maister Day'
                    },
                    type: 'observance',
                    active: [
                        {
                            from: 2015
                        }
                    ]
                },
                '12-06': {
                    name: {
                        sl: "Miklav\u017E",
                        en: 'Saint Nicholas Day'
                    },
                    type: 'observance'
                },
                '12-25': {
                    _name: '12-25',
                    active: [
                        {
                            to: 1953
                        },
                        {
                            from: 1991
                        }
                    ]
                },
                '12-26': {
                    name: {
                        sl: 'Dan samostojnosti in enotnosti',
                        en: 'Independence and Unity Day'
                    }
                }
            }
        },
        SJ: {
            names: {
                en: 'Svalbard & Jan Mayen'
            },
            langs: [
                'no'
            ],
            zones: [
                'Europe/Oslo'
            ],
            dayoff: 'sunday',
            _days: 'NO'
        },
        SK: {
            names: {
                sk: "Slovensk\xe1 republika",
                en: 'Slovakia'
            },
            langs: [
                'sk'
            ],
            zones: [
                'Europe/Prague'
            ],
            dayoff: 'sunday',
            days: {
                '01-01': {
                    _name: '01-01',
                    name: {
                        sk: "De\u0148 vzniku Slovenskej republiky"
                    }
                },
                '01-06': {
                    _name: '01-06'
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                easter: {
                    _name: 'easter',
                    type: 'observance'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '05-01': {
                    _name: '05-01'
                },
                '05-08': {
                    name: {
                        sk: "De\u0148 v\xed\u0165azstva nad fa\u0161izmom",
                        en: 'Day of victory over fascism'
                    }
                },
                '2nd sunday in May': {
                    _name: 'Mothers Day',
                    type: 'observance'
                },
                '07-05': {
                    name: {
                        sk: "Sviatok sv\xe4t\xe9ho Cyrila a Metoda",
                        en: 'Saints Cyril and Methodius Day'
                    }
                },
                '08-29': {
                    name: {
                        sk: "V\xfdro\u010Die Slovensk\xe9ho n\xe1rodn\xe9ho povstania",
                        en: 'Slovak National Uprising anniversary'
                    }
                },
                '09-01': {
                    _name: 'Constitution Day'
                },
                '09-15': {
                    name: {
                        sk: "Sviatok Panny M\xe1rie Sedembolestnej",
                        en: 'Day of Our Lady of the Seven Sorrows'
                    }
                },
                '11-01': {
                    _name: '11-01'
                },
                '11-17': {
                    name: {
                        sk: "De\u0148 boja za slobodu a demokraciu",
                        en: 'Struggle for Freedom and Democracy Day'
                    }
                },
                '12-24': {
                    _name: '12-24'
                },
                '12-25': {
                    _name: '12-25'
                },
                '12-26': {
                    _name: '12-26'
                }
            }
        },
        SL: {
            names: {
                en: 'Sierra Leone'
            },
            langs: [
                'en'
            ],
            zones: [
                'Africa/Abidjan'
            ],
            dayoff: 'sunday',
            days: {
                '01-01 and if Sunday then next Monday': {
                    substitute: true,
                    _name: '01-01'
                },
                '02-18 and if Sunday then next Monday': {
                    substitute: true,
                    name: {
                        en: 'Armed Forces Day'
                    }
                },
                '03-08 and if Sunday then next Monday': {
                    substitute: true,
                    _name: '03-08'
                },
                '04-27 and if Sunday then next Monday': {
                    substitute: true,
                    _name: 'Independence Day'
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '1 Shawwal and if Sunday then next Monday': {
                    substitute: true,
                    _name: '1 Shawwal',
                    name: {
                        en: "Korit\xe9"
                    }
                },
                '10 Dhu al-Hijjah and if Sunday then next Monday': {
                    substitute: true,
                    _name: '10 Dhu al-Hijjah',
                    name: {
                        en: 'Tabaski'
                    }
                },
                '12 Rabi al-awwal and if Sunday then next Monday': {
                    substitute: true,
                    _name: '12 Rabi al-awwal',
                    name: {
                        en: 'Mawlid'
                    }
                },
                '12-25 and if Sunday then next Tuesday': {
                    substitute: true,
                    _name: '12-25'
                },
                '12-26 and if Sunday then next Monday': {
                    substitute: true,
                    _name: '12-26'
                }
            }
        },
        SM: {
            names: {
                it: 'San Marino',
                en: 'San Marino'
            },
            langs: [
                'it'
            ],
            zones: [
                'Europe/Rome'
            ],
            dayoff: 'sunday',
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '01-06': {
                    _name: '01-06',
                    name: {
                        it: 'Epifania'
                    }
                },
                '02-05': {
                    name: {
                        it: "Festa di Sant\u2019Agata",
                        en: 'Feast of Saint Agatha'
                    }
                },
                easter: {
                    _name: 'easter'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '03-25': {
                    name: {
                        it: "Anniversario dell'Arengo",
                        en: 'Anniversary of the Arengo'
                    }
                },
                '04-01': {
                    name: {
                        it: 'Cerimonia di investitura dei Capitani Reggenti',
                        en: 'Inauguration Ceremony'
                    }
                },
                '05-01': {
                    _name: '05-01'
                },
                '2nd sunday in May': {
                    _name: 'Mothers Day',
                    type: 'observance'
                },
                'easter 60': {
                    _name: 'easter 60'
                },
                '07-28': {
                    name: {
                        it: "Anniversario della caduta del Fascismo e Festa della Libert\xe0",
                        en: 'Liberation from Fascism'
                    }
                },
                '08-15': {
                    _name: '08-15'
                },
                '09-03': {
                    name: {
                        it: 'Festa di San Marino e di Fondazione della Repubblica',
                        en: 'The Feast of San Marino and the Republic'
                    }
                },
                '10-01': {
                    name: {
                        it: 'Cerimonia di investitura dei Capitani Reggenti'
                    }
                },
                '11-01': {
                    _name: '11-01',
                    name: {
                        it: 'Tutti i Santi'
                    }
                },
                '11-02': {
                    name: {
                        it: 'Commemorazione dei defunti',
                        en: 'Commemoration of the deceased'
                    }
                },
                '12-08': {
                    _name: '12-08'
                },
                '12-25': {
                    _name: '12-25'
                },
                '12-26': {
                    _name: '12-26'
                },
                '12-31': {
                    _name: '12-31',
                    type: 'optional'
                }
            }
        },
        SN: {
            names: {
                fr: "R\xe9publique du S\xe9n\xe9gal",
                wo: "R\xe9ewum Senegaal",
                en: 'Senegal'
            },
            langs: [
                'fr',
                'wo'
            ],
            zones: [
                'Africa/Abidjan'
            ],
            dayoff: 'sunday',
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '04-04': {
                    _name: 'National Holiday'
                },
                '05-01': {
                    _name: '05-01'
                },
                '08-15': {
                    _name: '08-15'
                },
                '11-01': {
                    _name: '11-01'
                },
                '12-25': {
                    _name: '12-25'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                'easter 39': {
                    _name: 'easter 39'
                },
                'easter 50': {
                    _name: 'easter 50'
                },
                '12 Rabi al-awwal': {
                    _name: '12 Rabi al-awwal'
                },
                '1 Shawwal and if sunday then next monday': {
                    _name: '1 Shawwal'
                },
                '10 Dhu al-Hijjah and if sunday then next monday': {
                    _name: '10 Dhu al-Hijjah'
                },
                '10 Muharram': {
                    _name: '10 Muharram'
                },
                '18 Safar': {
                    name: 'Magal de Touba'
                }
            }
        },
        SO: {
            names: {
                so: 'Jamhuuriyadda Federaalka Soomaaliya',
                ar: "\u062C\u0645\u0647\u0648\u0631\u064A\u0629 \u0627\u0644\u0635\u0648\u0645\u0627\u0644 \u0627\u0644\u0641\u062F\u0631\u0627\u0644\u064A\u0629",
                en: 'Somalia'
            },
            dayoff: '?',
            langs: [
                'so',
                'ar',
                'en'
            ],
            zones: [
                'Africa/Nairobi'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '05-01': {
                    _name: '05-01'
                },
                '06-26': {
                    name: {
                        ar: "\u0627\u0633\u062A\u0642\u0644\u0627\u0644 \u0627\u0644\u0635\u0648\u0645\u0627\u0644 \u0627\u0644\u0628\u0631\u064A\u0637\u0627\u0646\u064A",
                        en: 'Independence of British Somaliland'
                    }
                },
                '07-01': {
                    _name: 'Independence Day'
                },
                '10 Muharram': {
                    _name: '10 Muharram'
                },
                '12 Rabi al-awwal': {
                    _name: '12 Rabi al-awwal'
                },
                '1 Shawwal': {
                    _name: '1 Shawwal'
                },
                '10 Dhu al-Hijjah': {
                    _name: '10 Dhu al-Hijjah'
                }
            },
            states: {
                AW: {
                    name: 'Awdal',
                    days: {
                        '01-01': false,
                        '05-18 P2D': {
                            name: {
                                en: 'Restoration of Somaliland Sovereignty'
                            }
                        },
                        '07-01': false,
                        '1 Muharram': {
                            _name: '1 Muharram'
                        },
                        '10 Muharram': false,
                        '27 Rajab': {
                            _name: '27 Rajab'
                        }
                    }
                },
                SA: {
                    name: 'Sanaag',
                    _days: [
                        'SO',
                        'states',
                        'AW'
                    ]
                },
                SO: {
                    name: 'Sool',
                    _days: [
                        'SO',
                        'states',
                        'AW'
                    ]
                },
                TO: {
                    name: 'Togdheer',
                    _days: [
                        'SO',
                        'states',
                        'AW'
                    ]
                },
                WO: {
                    name: 'Woqooyi Galbeed',
                    _days: [
                        'SO',
                        'states',
                        'AW'
                    ]
                }
            }
        },
        SR: {
            names: {
                en: 'Suriname'
            },
            langs: [
                'nl',
                'srn'
            ],
            zones: [
                'America/Paramaribo'
            ],
            dayoff: 'sunday',
            days: {
                '01-01': {
                    _name: '01-01'
                },
                'chinese 01-0-01': {
                    name: {
                        nl: 'Chinees Nieuwjaar',
                        en: 'Chinese New Year'
                    }
                },
                '02-25': {
                    name: {
                        nl: 'Dag van Bevrijding en Vernieuwing',
                        en: 'Day of Liberation and Innovation'
                    }
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                easter: {
                    _name: 'easter',
                    type: 'observance'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '05-01': {
                    _name: '05-01'
                },
                '07-01': {
                    name: {
                        nl: 'Dag der Vrijheden (Keti koti)',
                        srn: 'Keti koti',
                        en: 'Emancipation Day'
                    }
                },
                '08-09': {
                    name: {
                        nl: 'Dag der Inheemsen',
                        en: "Indigenous People's Day"
                    }
                },
                '10-10': {
                    name: {
                        nl: 'Dag van de Marrons',
                        en: 'Day of the Maroons'
                    }
                },
                '11-25': {
                    _name: 'Independence Day'
                },
                '12-25': {
                    _name: '12-25'
                },
                '12-26': {
                    _name: '12-26'
                },
                '1 Shawwal': {
                    _name: '1 Shawwal'
                },
                '10 Dhu al-Hijjah': {
                    _name: '10 Dhu al-Hijjah'
                },
                '2015-03-06': {
                    _name: 'Holi'
                },
                '2016-03-23': {
                    _name: 'Holi'
                },
                '2017-03-12': {
                    _name: 'Holi'
                },
                '2018-03-02': {
                    _name: 'Holi'
                },
                '2019-03-21': {
                    _name: 'Holi'
                },
                '2020-03-09': {
                    _name: 'Holi'
                },
                '2021-03-28': {
                    _name: 'Holi'
                },
                '2022-03-18': {
                    _name: 'Holi'
                },
                '2023-03-07': {
                    _name: 'Holi'
                },
                '2024-03-25': {
                    _name: 'Holi'
                },
                '2025-03-14': {
                    _name: 'Holi'
                },
                '2026-03-03': {
                    _name: 'Holi'
                },
                '2027-03-22': {
                    _name: 'Holi'
                },
                '2028-03-11': {
                    _name: 'Holi'
                },
                '2029-03-28': {
                    _name: 'Holi'
                },
                '2030-03-19': {
                    _name: 'Holi'
                },
                '2014-10-23': {
                    _name: 'Deepavali'
                },
                '2015-11-11': {
                    _name: 'Deepavali'
                },
                '2016-10-30': {
                    _name: 'Deepavali'
                },
                '2017-10-19': {
                    _name: 'Deepavali'
                },
                '2018-11-07': {
                    _name: 'Deepavali'
                },
                '2019-10-27': {
                    _name: 'Deepavali'
                },
                '2020-11-14': {
                    _name: 'Deepavali'
                },
                '2021-11-04': {
                    _name: 'Deepavali'
                },
                '2022-10-24': {
                    _name: 'Deepavali'
                },
                '2023-11-12': {
                    _name: 'Deepavali'
                },
                '2024-10-31': {
                    _name: 'Deepavali'
                },
                '2025-10-20': {
                    _name: 'Deepavali'
                },
                '2026-11-08': {
                    _name: 'Deepavali'
                },
                '2027-10-28': {
                    _name: 'Deepavali'
                },
                '2028-10-17': {
                    _name: 'Deepavali'
                },
                '2029-11-05': {
                    _name: 'Deepavali'
                },
                '2030-10-25': {
                    _name: 'Deepavali'
                }
            }
        },
        SS: {
            names: {
                en: 'South Sudan'
            },
            dayoff: 'sunday',
            langs: [
                'en'
            ],
            zones: [
                'Africa/Maputo'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '01-09': {
                    name: {
                        en: 'Peace Agreement Day'
                    }
                },
                '03-08': {
                    _name: '03-08'
                },
                '05-16': {
                    name: {
                        en: 'SPLA Day'
                    }
                },
                '1st monday in July': {
                    _name: 'Mothers Day',
                    type: 'observance'
                },
                '07-09': {
                    _name: 'Independence Day'
                },
                '07-30': {
                    name: {
                        en: 'Martyrs Day'
                    }
                },
                '12-25': {
                    _name: '12-25'
                },
                '12-28': {
                    name: {
                        en: 'Republic Day'
                    }
                },
                '12-31': {
                    _name: '12-31'
                },
                '2 Shawwal': {
                    _name: '1 Shawwal'
                },
                '12 Dhu al-Hijjah': {
                    _name: '10 Dhu al-Hijjah'
                }
            }
        },
        ST: {
            names: {
                pt: "S\xe3o Tom\xe9 & Pr\xedncipe",
                en: "S\xe3o Tom\xe9 & Pr\xedncipe"
            },
            langs: [
                'pt',
                'en'
            ],
            zones: [
                'Africa/Abidjan'
            ],
            dayoff: 'sunday',
            days: {
                '01-01 and if Saturday then previous Friday if Sunday then next Monday': {
                    substitute: true,
                    _name: '01-01'
                },
                '02-03 and if Saturday then previous Friday if Sunday then next Monday': {
                    substitute: true,
                    name: {
                        en: "Martyrs' Day",
                        pt: "Dia dos M\xe1rtires"
                    }
                },
                '05-01 and if Saturday then previous Friday if Sunday then next Monday': {
                    substitute: true,
                    _name: '05-01'
                },
                '07-12 and if Saturday then previous Friday if Sunday then next Monday': {
                    substitute: true,
                    _name: 'Independence Day'
                },
                '09-06 and if Saturday then previous Friday if Sunday then next Monday': {
                    substitute: true,
                    name: {
                        en: 'Armed Forces Day',
                        pt: "Dia das For\xe7as Armadas"
                    }
                },
                '09-30 and if Saturday then previous Friday if Sunday then next Monday': {
                    substitute: true,
                    name: {
                        en: 'Agricultural Reform Day',
                        pt: "Dia da Reforma Agr\xe1ria"
                    }
                },
                '12-21 and if Saturday then previous Friday if Sunday then next Monday': {
                    substitute: true,
                    name: {
                        en: "S\xe3o Tom\xe9 Day",
                        pt: "Dia de S\xe3o Tom\xe9"
                    }
                },
                '12-25 and if Saturday then previous Friday if Sunday then next Monday': {
                    substitute: true,
                    _name: '12-25'
                }
            }
        },
        SV: {
            names: {
                es: 'El Salvador',
                en: 'El Salvador'
            },
            dayoff: 'sunday',
            langs: [
                'es'
            ],
            zones: [
                'America/El_Salvador'
            ],
            days: {
                '01-01': {
                    _name: '01-01',
                    type: 'observance'
                },
                '01-16': {
                    name: {
                        es: 'Firma de los Acuerdos de Paz'
                    },
                    type: 'observance'
                },
                '03-08': {
                    name: {
                        es: "D\xeda de la Mujer"
                    },
                    type: 'observance'
                },
                'easter -3': {
                    _name: 'easter -3'
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                'easter -1': {
                    _name: 'easter -1'
                },
                easter: {
                    _name: 'easter',
                    type: 'observance'
                },
                '05-01': {
                    _name: '05-01'
                },
                '05-07': {
                    name: {
                        en: "Soldier's Day",
                        es: "D\xeda del Soldado"
                    },
                    type: 'observance'
                },
                '05-10': {
                    _name: 'Mothers Day',
                    type: 'optional',
                    note: 'Public Offices only'
                },
                '06-17': {
                    _name: 'Fathers Day',
                    type: 'observance'
                },
                '06-22': {
                    name: {
                        es: "D\xeda del Maestro"
                    },
                    type: 'optional',
                    note: 'Dayoff for teachers only'
                },
                '08-06': {
                    name: {
                        es: "Celebraci\xf3n del Divino Salvador del Mundo"
                    }
                },
                '09-15': {
                    _name: 'Independence Day'
                },
                '11-02': {
                    _name: '11-02'
                },
                '12-25': {
                    _name: '12-25'
                }
            },
            regions: {
                SS: {
                    name: 'San Salvador',
                    days: {
                        '08-03': {
                            name: {
                                es: 'Fiestas Agostinas'
                            }
                        },
                        '08-05': {
                            name: {
                                es: 'Fiestas Agostinas'
                            }
                        }
                    }
                }
            }
        },
        SX: {
            names: {
                en: 'Sint Maarten'
            },
            langs: [
                'nl'
            ],
            zones: [
                'America/Curacao'
            ],
            dayoff: 'sunday',
            days: {
                '01-01': {
                    _name: '01-01'
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                easter: {
                    _name: 'easter'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '04-27': {
                    name: {
                        nl: 'Koningsdag',
                        en: "King's Day"
                    }
                },
                '04-30 if Sunday then next Tuesday prior to 2017': {
                    name: {
                        nl: 'Carnaval',
                        en: 'Carnival'
                    }
                },
                '04-30 if Saturday then previous Friday if Sunday then next Tuesday since 2017': {
                    name: {
                        nl: 'Carnaval',
                        en: 'Carnival'
                    }
                },
                '05-01 if Sunday then next Monday': {
                    _name: '05-01'
                },
                'easter 39': {
                    _name: 'easter 39'
                },
                'easter 49': {
                    _name: 'easter 49'
                },
                '07-01': {
                    name: {
                        nl: 'Emancipatiedag',
                        en: 'Emancipation Day'
                    }
                },
                '10-09': {
                    _name: 'Constitution Day'
                },
                '11-11': {
                    name: {
                        en: 'Sint Maarten Day'
                    }
                },
                '12-25': {
                    _name: '12-25'
                },
                '12-26': {
                    _name: '12-26'
                }
            }
        },
        SZ: {
            names: {
                ss: 'Eswatini',
                en: 'Swaziland'
            },
            langs: [
                'ss',
                'en'
            ],
            zones: [
                'Africa/Johannesburg'
            ],
            dayoff: 'sunday',
            days: {
                '01-01': {
                    _name: '01-01'
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                easter: {
                    _name: 'easter',
                    type: 'observance'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '04-19 and if Saturday, Sunday then next Monday': {
                    substitute: true,
                    name: {
                        en: 'Birthday of King Mswati III'
                    }
                },
                '04-25 and if Saturday, Sunday then next Monday': {
                    substitute: true,
                    name: {
                        en: 'National Flag Day'
                    }
                },
                '05-01 and if Saturday, Sunday then next Monday': {
                    substitute: true,
                    _name: '05-01'
                },
                'easter 39': {
                    _name: 'easter 39'
                },
                '07-22 and if Saturday, Sunday then next Monday': {
                    substitute: true,
                    name: {
                        en: 'Birthday of the late King Sobhuza'
                    }
                },
                '1st Monday in September': {
                    name: {
                        ss: 'Umhlanga Reed Dance',
                        en: 'Umhlanga Reed Dance'
                    }
                },
                '09-06 and if Saturday, Sunday then next Monday': {
                    substitute: true,
                    _name: 'Independence Day',
                    name: {
                        ss: 'Somhlolo Day'
                    }
                },
                '12-25': {
                    _name: '12-25'
                },
                '12-26 and if Sunday then next Monday': {
                    _name: '12-26'
                },
                '12-28 P6D': {
                    name: {
                        ss: 'Incwala',
                        en: 'Incwala Festival'
                    }
                }
            }
        },
        TC: {
            names: {
                en: 'Turks & Caicos Islands'
            },
            langs: [
                'en'
            ],
            zones: [
                'America/Grand_Turk'
            ],
            dayoff: 'sunday',
            days: {
                '01-01 and if Saturday, Sunday then next Monday': {
                    _name: '01-01'
                },
                '2nd Monday in March': {
                    name: {
                        en: 'Commonwealth Day'
                    }
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                easter: {
                    _name: 'easter',
                    type: 'observance'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '1st Monday before 06-01': {
                    name: {
                        en: "National Heroes' Day"
                    }
                },
                '2nd Monday after 06-02': {
                    name: {
                        en: "Queen's Birthday"
                    }
                },
                '1st Monday in August': {
                    name: {
                        en: 'Emancipation Day'
                    }
                },
                '1st Friday before 10-01': {
                    name: {
                        en: 'National Youth Day'
                    }
                },
                '2nd Monday in October': {
                    name: {
                        en: 'National Heritage Day'
                    }
                },
                '4th Friday in November': {
                    name: {
                        en: 'National Day of Thanksgiving'
                    }
                },
                '12-25 and if Saturday then next Monday if Sunday then next Tuesday': {
                    substitute: true,
                    _name: '12-25'
                },
                '12-26 and if Saturday then next Monday if Sunday then next Tuesday': {
                    substitute: true,
                    _name: '12-26'
                }
            }
        },
        TD: {
            names: {
                ar: "\u062C\u0645\u0647\u0648\u0631\u064A\u0629 \u062A\u0634\u0627\u062F",
                fr: "R\xe9publique du Tchad",
                en: 'Chad'
            },
            langs: [
                'ar',
                'fr'
            ],
            zones: [
                'Africa/Ndjamena'
            ],
            dayoff: 'sunday',
            days: {
                '01-01 and if sunday then next monday': {
                    _name: '01-01'
                },
                '05-01 and if sunday then next monday': {
                    _name: '05-01'
                },
                '08-11 and if sunday then next monday': {
                    name: {
                        fr: "F\xeate Nationale (Ind\xe9pendance)",
                        en: 'Independence Day'
                    }
                },
                '12-01 and if sunday then next monday': {
                    name: {
                        fr: "Journ\xe9e de la lib\xe9ration et de la d\xe9mocratie",
                        en: 'Freedom and Democracy Day'
                    }
                },
                '11-01': {
                    _name: '11-01'
                },
                '11-28': {
                    name: {
                        fr: "Anniversaire de la Proclamation de la R\xe9publique",
                        en: 'Proclamation of the Republic'
                    }
                },
                '12-25': {
                    _name: '12-25'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '12 Rabi al-awwal': {
                    _name: '12 Rabi al-awwal'
                },
                '1 Shawwal': {
                    _name: '1 Shawwal'
                },
                '10 Dhu al-Hijjah': {
                    _name: '10 Dhu al-Hijjah'
                }
            }
        },
        TG: {
            names: {
                fr: "R\xe9publique togolaise",
                en: 'Togolese Republic'
            },
            dayoff: 'sunday',
            langs: [
                'fr'
            ],
            zones: [
                'Africa/Abidjan'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '01-13': {
                    name: {
                        fr: "Jour de la lib\xe9ration",
                        en: 'Liberation Day'
                    }
                },
                '04-27': {
                    _name: 'Independence Day'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '05-01': {
                    _name: '05-01'
                },
                'easter 39': {
                    _name: 'easter 39'
                },
                'easter 50': {
                    _name: 'easter 50'
                },
                '06-21': {
                    name: {
                        fr: "Journ\xe9e des Martyrs",
                        en: 'Day of the Martyrs'
                    }
                },
                '08-15': {
                    _name: '08-15'
                },
                '11-01': {
                    _name: '11-01'
                },
                '12-25': {
                    _name: '12-25'
                },
                '13 Rabi al-awwal': {
                    _name: '12 Rabi al-awwal'
                },
                '2 Shawwal': {
                    _name: '1 Shawwal'
                },
                '11 Dhu al-Hijjah': {
                    _name: '10 Dhu al-Hijjah'
                }
            }
        },
        TH: {
            names: {
                en: 'Thailand'
            },
            langs: [
                'en',
                'th'
            ],
            zones: [
                'Asia/Bangkok'
            ],
            dayoff: 'Saturday',
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '04-06': {
                    name: {
                        en: 'Chakri Memorial Day',
                        th: "\u0E27\u0E31\u0E19\u0E08\u0E31\u0E01\u0E23\u0E35"
                    }
                },
                '04-13': {
                    name: {
                        en: 'Songkran Festival',
                        th: "\u0E27\u0E31\u0E19\u0E2A\u0E07\u0E01\u0E23\u0E32\u0E19\u0E15\u0E4C"
                    }
                },
                '04-14': {
                    name: {
                        en: 'Songkran Festival',
                        th: "\u0E27\u0E31\u0E19\u0E2A\u0E07\u0E01\u0E23\u0E32\u0E19\u0E15\u0E4C"
                    }
                },
                '04-15': {
                    name: {
                        en: 'Songkran Festival',
                        th: "\u0E27\u0E31\u0E19\u0E2A\u0E07\u0E01\u0E23\u0E32\u0E19\u0E15\u0E4C"
                    }
                },
                '05-04': {
                    name: {
                        en: 'Coronation Day',
                        th: "\u0E27\u0E31\u0E19\u0E09\u0E31\u0E15\u0E23\u0E21\u0E07\u0E04\u0E25"
                    }
                },
                '06-03': {
                    name: {
                        en: "Queen Suthida's Birthday",
                        th: "\u0E27\u0E31\u0E19\u0E40\u0E09\u0E25\u0E34\u0E21\u0E1E\u0E23\u0E30\u0E0A\u0E19\u0E21\u0E1E\u0E23\u0E23\u0E29\u0E32\u0E2A\u0E21\u0E40\u0E14\u0E47\u0E08\u0E1E\u0E23\u0E30\u0E19\u0E32\u0E07\u0E40\u0E08\u0E49\u0E32\u0E2A\u0E38\u0E17\u0E34\u0E14\u0E32 \u0E1E\u0E31\u0E0A\u0E23\u0E2A\u0E38\u0E18\u0E32\u0E1E\u0E34\u0E21\u0E25\u0E25\u0E31\u0E01\u0E29\u0E13 \u0E1E\u0E23\u0E30\u0E1A\u0E23\u0E21\u0E23\u0E32\u0E0A\u0E34\u0E19\u0E35"
                    }
                },
                '07-28': {
                    name: {
                        en: "King's Birthday",
                        th: "\u0E27\u0E31\u0E19\u0E40\u0E09\u0E25\u0E34\u0E21\u0E1E\u0E23\u0E30\u0E0A\u0E19\u0E21\u0E1E\u0E23\u0E23\u0E29\u0E32\u0E1E\u0E23\u0E30\u0E1A\u0E32\u0E17\u0E2A\u0E21\u0E40\u0E14\u0E47\u0E08\u0E1E\u0E23\u0E30\u0E27\u0E0A\u0E34\u0E23\u0E40\u0E01\u0E25\u0E49\u0E32\u0E40\u0E08\u0E49\u0E32\u0E2D\u0E22\u0E39\u0E48\u0E2B\u0E31\u0E27"
                    }
                },
                '08-12': {
                    name: {
                        en: "The Queen Mother's Birthday",
                        th: "\u0E27\u0E31\u0E19\u0E40\u0E09\u0E25\u0E34\u0E21\u0E1E\u0E23\u0E30\u0E0A\u0E19\u0E21\u0E1E\u0E23\u0E23\u0E29\u0E32\u0E2A\u0E21\u0E40\u0E14\u0E47\u0E08\u0E1E\u0E23\u0E30\u0E19\u0E32\u0E07\u0E40\u0E08\u0E49\u0E32\u0E2A\u0E34\u0E23\u0E34\u0E01\u0E34\u0E15\u0E34\u0E4C \u0E1E\u0E23\u0E30\u0E1A\u0E23\u0E21\u0E23\u0E32\u0E0A\u0E34\u0E19\u0E35\u0E19\u0E32\u0E16 \u0E1E\u0E23\u0E30\u0E1A\u0E23\u0E21\u0E23\u0E32\u0E0A\u0E0A\u0E19\u0E19\u0E35\u0E1E\u0E31\u0E19\u0E1B\u0E35\u0E2B\u0E25\u0E27\u0E07"
                    }
                },
                '10-13': {
                    name: {
                        en: 'King Bhumibol Adulyadej Memorial Day',
                        th: "\u0E27\u0E31\u0E19\u0E04\u0E25\u0E49\u0E32\u0E22\u0E27\u0E31\u0E19\u0E2A\u0E27\u0E23\u0E23\u0E04\u0E15\u0E1E\u0E23\u0E30\u0E1A\u0E32\u0E17\u0E2A\u0E21\u0E40\u0E14\u0E47\u0E08\u0E1E\u0E23\u0E30\u0E1A\u0E23\u0E21\u0E0A\u0E19\u0E01\u0E32\u0E18\u0E34\u0E40\u0E1A\u0E28\u0E23 \u0E21\u0E2B\u0E32\u0E20\u0E39\u0E21\u0E34\u0E1E\u0E25\u0E2D\u0E14\u0E38\u0E25\u0E22\u0E40\u0E14\u0E0A\u0E21\u0E2B\u0E32\u0E23\u0E32\u0E0A \u0E1A\u0E23\u0E21\u0E19\u0E32\u0E16\u0E1A\u0E1E\u0E34\u0E15\u0E23"
                    }
                },
                '10-23': {
                    name: {
                        en: 'King Chulalongkorn Day',
                        th: "\u0E27\u0E31\u0E19\u0E1B\u0E34\u0E22\u0E21\u0E2B\u0E32\u0E23\u0E32\u0E0A"
                    }
                },
                '12-05': {
                    name: {
                        en: "King Bhumibol Adulyadej's Birthday",
                        th: "\u0E27\u0E31\u0E19\u0E04\u0E25\u0E49\u0E32\u0E22\u0E27\u0E31\u0E19\u0E1E\u0E23\u0E30\u0E1A\u0E23\u0E21\u0E23\u0E32\u0E0A\u0E2A\u0E21\u0E20\u0E1E \u0E1E\u0E23\u0E30\u0E1A\u0E32\u0E17\u0E2A\u0E21\u0E40\u0E14\u0E47\u0E08\u0E1E\u0E23\u0E30\u0E1A\u0E23\u0E21\u0E0A\u0E19\u0E01\u0E32\u0E18\u0E34\u0E40\u0E1A\u0E28\u0E23 \u0E21\u0E2B\u0E32\u0E20\u0E39\u0E21\u0E34\u0E1E\u0E25\u0E2D\u0E14\u0E38\u0E25\u0E22\u0E40\u0E14\u0E0A\u0E21\u0E2B\u0E32\u0E23\u0E32\u0E0A \u0E1A\u0E23\u0E21\u0E19\u0E32\u0E16\u0E1A\u0E1E\u0E34\u0E15\u0E23"
                    }
                },
                '12-10': {
                    name: {
                        en: 'Constitution Day',
                        th: "\u0E27\u0E31\u0E19\u0E23\u0E31\u0E10\u0E18\u0E23\u0E23\u0E21\u0E19\u0E39\u0E0D"
                    }
                },
                '12-31': {
                    _name: '12-31'
                },
                '2010-03-01': {
                    _name: 'Makha Bucha'
                },
                '2011-02-18': {
                    _name: 'Makha Bucha'
                },
                '2012-03-07': {
                    _name: 'Makha Bucha'
                },
                '2013-02-25': {
                    _name: 'Makha Bucha'
                },
                '2014-02-14': {
                    _name: 'Makha Bucha'
                },
                '2015-03-04': {
                    _name: 'Makha Bucha'
                },
                '2016-02-22': {
                    _name: 'Makha Bucha'
                },
                '2017-02-11': {
                    _name: 'Makha Bucha'
                },
                '2018-03-01': {
                    _name: 'Makha Bucha'
                },
                '2019-02-19': {
                    _name: 'Makha Bucha'
                },
                '2020-02-08': {
                    _name: 'Makha Bucha'
                },
                '2021-02-26': {
                    _name: 'Makha Bucha'
                },
                '2022-02-16': {
                    _name: 'Makha Bucha'
                },
                '2023-03-06': {
                    _name: 'Makha Bucha'
                },
                '2024-02-24': {
                    _name: 'Makha Bucha'
                },
                '2025-02-13': {
                    _name: 'Makha Bucha'
                },
                '2026-03-03': {
                    _name: 'Makha Bucha'
                },
                '2010-05-28': {
                    _name: 'Vesak'
                },
                '2011-05-17': {
                    _name: 'Vesak'
                },
                '2012-05-06': {
                    _name: 'Vesak'
                },
                '2013-05-25': {
                    _name: 'Vesak'
                },
                '2014-05-15': {
                    _name: 'Vesak'
                },
                '2015-06-02': {
                    _name: 'Vesak'
                },
                '2016-05-22': {
                    _name: 'Vesak'
                },
                '2017-05-10': {
                    _name: 'Vesak'
                },
                '2018-05-29': {
                    _name: 'Vesak'
                },
                '2019-05-19': {
                    _name: 'Vesak'
                },
                '2020-05-07': {
                    _name: 'Vesak'
                },
                '2021-05-26': {
                    _name: 'Vesak'
                },
                '2022-05-15': {
                    _name: 'Vesak'
                },
                '2022-05-16': {
                    substitute: true,
                    _name: 'Vesak'
                },
                '2023-05-04': {
                    _name: 'Vesak'
                },
                '2024-05-22': {
                    _name: 'Vesak'
                },
                '2025-05-12': {
                    _name: 'Vesak'
                },
                '2026-05-31': {
                    _name: 'Vesak'
                },
                '2010-07-25': {
                    _name: 'Asalha Puja'
                },
                '2011-07-15': {
                    _name: 'Asalha Puja'
                },
                '2012-08-02': {
                    _name: 'Asalha Puja'
                },
                '2013-07-22': {
                    _name: 'Asalha Puja'
                },
                '2014-07-11': {
                    _name: 'Asalha Puja'
                },
                '2015-07-30': {
                    _name: 'Asalha Puja'
                },
                '2016-07-19': {
                    _name: 'Asalha Puja'
                },
                '2017-07-08': {
                    _name: 'Asalha Puja'
                },
                '2018-07-27': {
                    _name: 'Asalha Puja'
                },
                '2019-07-16': {
                    _name: 'Asalha Puja'
                },
                '2020-07-04': {
                    _name: 'Asalha Puja'
                },
                '2021-07-24': {
                    _name: 'Asalha Puja'
                },
                '2022-07-13': {
                    _name: 'Asalha Puja'
                },
                '2023-07-31': {
                    _name: 'Asalha Puja'
                },
                '2024-07-19': {
                    _name: 'Asalha Puja'
                },
                '2025-07-10': {
                    _name: 'Asalha Puja'
                },
                '2026-07-29': {
                    _name: 'Asalha Puja'
                },
                '2010-07-26': {
                    _name: 'Buddhist Lent'
                },
                '2011-07-16': {
                    _name: 'Buddhist Lent'
                },
                '2012-08-03': {
                    _name: 'Buddhist Lent'
                },
                '2013-07-23': {
                    _name: 'Buddhist Lent'
                },
                '2014-07-12': {
                    _name: 'Buddhist Lent'
                },
                '2015-07-31': {
                    _name: 'Buddhist Lent'
                },
                '2016-07-20': {
                    _name: 'Buddhist Lent'
                },
                '2017-07-09': {
                    _name: 'Buddhist Lent'
                },
                '2018-07-28': {
                    _name: 'Buddhist Lent'
                },
                '2019-07-17': {
                    _name: 'Buddhist Lent'
                },
                '2020-07-05': {
                    _name: 'Buddhist Lent'
                },
                '2021-07-25': {
                    _name: 'Buddhist Lent'
                },
                '2022-07-14': {
                    _name: 'Buddhist Lent'
                },
                '2023-08-01': {
                    _name: 'Buddhist Lent'
                },
                '2024-07-20': {
                    _name: 'Buddhist Lent'
                },
                '2025-07-11': {
                    _name: 'Buddhist Lent'
                },
                '2026-07-30': {
                    _name: 'Buddhist Lent'
                }
            }
        },
        TN: {
            names: {
                ar: "\u0627\u0644\u062C\u0645\u0647\u0648\u0631\u064A\u0629 \u0627\u0644\u062A\u0648\u0646\u0633\u064A\u0629",
                fr: "R\xe9publique tunisienne",
                en: 'Tunisia'
            },
            langs: [
                'ar',
                'fr'
            ],
            zones: [
                'Africa/Tunis'
            ],
            dayoff: 'sunday',
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '01-14': {
                    name: {
                        fr: "F\xeate de la R\xe9volution et de la Jeunesse",
                        ar: "\u0639\u064A\u062F \u0627\u0644\u062B\u0648\u0631\u0629 \u0648 \u0627\u0644\u0634\u0628\u0627\u0628"
                    }
                },
                '03-20': {
                    name: {
                        fr: "F\xeate de l'ind\xe9pendance",
                        ar: "\u0639\u064A\u062F \u0627\u0644\u0625\u0633\u062A\u0642\u0644\u0627\u0644"
                    }
                },
                '04-09': {
                    name: {
                        fr: "Journ\xe9e des Martyrs",
                        ar: "\u0639\u064A\u062F \u0627\u0644\u0634\u0647\u062F\u0627\u0621"
                    }
                },
                '12 Rabi al-awwal': {
                    _name: '12 Rabi al-awwal'
                },
                '1 Muharram': {
                    _name: '1 Muharram'
                },
                '1 Shawwal': {
                    _name: '1 Shawwal'
                },
                '10 Dhu al-Hijjah': {
                    _name: '10 Dhu al-Hijjah'
                },
                '05-01': {
                    _name: '05-01'
                },
                '07-25': {
                    name: {
                        fr: "F\xeate de la R\xe9publique",
                        ar: "\u0639\u064A\u062F \u0627\u0644\u062C\u0645\u0647\u0648\u0631\u064A\u0629"
                    }
                },
                '08-13': {
                    name: {
                        fr: "F\xeate de la Femme et de la Famille",
                        ar: "\u0639\u064A\u062F \u0627\u0644\u0645\u0631\u0623\u0629"
                    }
                },
                '10-15': {
                    name: {
                        fr: "F\xeate de l'\xc9vacuation",
                        ar: "\u0639\u064A\u062F \u0627\u0644\u062C\u0644\u0627\u0621"
                    }
                }
            }
        },
        TO: {
            names: {
                to: "Pule\u02BBanga Fakatu\u02BBi \u02BBo Tonga",
                en: 'Tonga'
            },
            langs: [
                'to',
                'en'
            ],
            zones: [
                'Pacific/Tongatapu'
            ],
            dayoff: 'sunday',
            days: {
                '01-01': {
                    _name: '01-01'
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '04-25': {
                    name: {
                        en: 'ANZAC Day'
                    }
                },
                '06-04 if thursday,friday,saturday,sunday then next monday and if tuesday then previous monday': {
                    name: {
                        en: 'Emancipation Day'
                    }
                },
                '07-04': {
                    name: {
                        en: 'Official Birthday of His Majesty King Tupou VI'
                    }
                },
                '09-17 if thursday,friday,saturday,sunday then next monday and if tuesday then previous monday': {
                    name: {
                        en: "Birthday of His Royal Highness The Crown Prince Tupoto\u02BBa-\u02BBUlukalala"
                    }
                },
                '11-04 if thursday,friday,saturday,sunday then next monday and if tuesday then previous monday': {
                    _name: 'Constitution Day',
                    name: {
                        en: 'Constitutional Day'
                    }
                },
                '12-04 if thursday,friday,saturday,sunday then next monday and if tuesday then previous monday': {
                    name: {
                        en: 'Tupou I Day'
                    }
                },
                '12-25': {
                    _name: '12-25'
                },
                '12-26': {
                    _name: '12-26'
                }
            }
        },
        TR: {
            names: {
                tr: "T\xfcrkiye",
                en: 'Turkey'
            },
            dayoff: 'saturday',
            langs: [
                'tr'
            ],
            zones: [
                'Europe/Istanbul'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '04-23': {
                    name: {
                        en: "National Sovereignty and Children's Day",
                        tr: "Ulusal Egemenlik ve \xc7ocuk Bayram\u0131"
                    }
                },
                '05-01': {
                    _name: '05-01',
                    name: {
                        en: 'Labour and Solidarity Day',
                        tr: "Emek ve Dayan\u0131\u015Fma G\xfcn\xfc"
                    }
                },
                '05-19': {
                    name: {
                        en: "Commemoration of Atat\xfcrk, Youth and Sports Day",
                        tr: "Atat\xfcrk'\xfc Anma Gen\xe7lik ve Spor Bayram\u0131"
                    }
                },
                '07-15': {
                    name: {
                        en: 'Democracy and National Unity Day',
                        tr: "Demokrasi ve Mill\xee Birlik G\xfcn\xfc"
                    }
                },
                '08-30': {
                    name: {
                        en: 'Victory Day',
                        tr: "Zafer Bayram\u0131"
                    }
                },
                '10-29': {
                    name: {
                        en: 'Republic Day',
                        tr: "Cumhuriyet Bayram\u0131"
                    }
                },
                '1 Shawwal PT90H': {
                    _name: '1 Shawwal'
                },
                '10 Dhu al-Hijjah PT114H': {
                    _name: '10 Dhu al-Hijjah'
                }
            }
        },
        TT: {
            names: {
                en: 'Trinidad & Tobago'
            },
            langs: [
                'en'
            ],
            zones: [
                'America/Port_of_Spain'
            ],
            dayoff: 'sunday',
            days: {
                '01-01 and if Sunday then next Monday': {
                    substitute: true,
                    _name: '01-01'
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                easter: {
                    _name: 'easter'
                },
                'easter 1': {
                    _name: 'easter 1',
                    type: 'observance'
                },
                '03-30 and if Sunday then next Monday': {
                    substitute: true,
                    name: {
                        en: 'Spiritual Baptist Liberation Day'
                    }
                },
                'easter 60': {
                    _name: 'easter 60'
                },
                '05-30 and if Sunday then next Monday': {
                    substitute: true,
                    name: {
                        en: 'Indian Arrival Day'
                    }
                },
                '06-19 and if Sunday then next Monday': {
                    substitute: true,
                    _name: '05-01'
                },
                '08-01 and if Sunday then next Monday': {
                    substitute: true,
                    name: {
                        en: 'Emancipation Day'
                    }
                },
                '08-31 and if Sunday then next Monday': {
                    substitute: true,
                    _name: 'Independence Day'
                },
                '09-24 and if Sunday then next Monday': {
                    substitute: true,
                    name: {
                        en: 'Republic Day'
                    }
                },
                '12-25 and if Sunday then next Tuesday': {
                    substitute: true,
                    _name: '12-25'
                },
                '12-26 and if Sunday then next Monday': {
                    substitute: true,
                    _name: '12-26'
                },
                '1 Shawwal and if Sunday then next Monday': {
                    substitute: true,
                    _name: '1 Shawwal'
                },
                '2012-11-13': {
                    _name: 'Deepavali'
                },
                '2013-11-03': {
                    _name: 'Deepavali'
                },
                '2013-11-04': {
                    substitute: true,
                    _name: 'Deepavali'
                },
                '2014-10-23': {
                    _name: 'Deepavali'
                },
                '2015-11-11': {
                    _name: 'Deepavali'
                },
                '2016-10-29': {
                    _name: 'Deepavali'
                },
                '2017-10-19': {
                    _name: 'Deepavali'
                },
                '2018-11-07': {
                    _name: 'Deepavali'
                },
                '2019-10-27': {
                    _name: 'Deepavali'
                },
                '2019-10-28': {
                    substitute: true,
                    _name: 'Deepavali'
                },
                '2020-11-14': {
                    _name: 'Deepavali'
                },
                '2021-11-04': {
                    _name: 'Deepavali'
                },
                '2022-10-24': {
                    _name: 'Deepavali'
                },
                '2023-11-12': {
                    _name: 'Deepavali'
                },
                '2023-11-13': {
                    substitute: true,
                    _name: 'Deepavali'
                },
                '2024-10-31': {
                    _name: 'Deepavali'
                },
                '2025-10-20': {
                    _name: 'Deepavali'
                },
                '2026-11-08': {
                    _name: 'Deepavali'
                },
                '2026-11-09': {
                    substitute: true,
                    _name: 'Deepavali'
                },
                '2027-10-28': {
                    _name: 'Deepavali'
                },
                '2028-10-17': {
                    _name: 'Deepavali'
                },
                '2029-11-05': {
                    _name: 'Deepavali'
                },
                '2030-10-25': {
                    _name: 'Deepavali'
                }
            }
        },
        TW: {
            names: {
                zh: "\u4E2D\u83EF\u6C11\u570B",
                en: 'Taiwan'
            },
            langs: [
                'zh'
            ],
            zones: [
                'Asia/Taipei'
            ],
            dayoff: '',
            days: {
                '01-01 and if Saturday then previous Friday if Sunday then next Monday': {
                    substitute: true,
                    _name: '01-01',
                    name: {
                        zh: "\u4E2D\u83EF\u6C11\u570B\u958B\u570B\u7D00\u5FF5\u65E5 / \u5143\u65E6",
                        en: 'Founding of the Republic of China'
                    }
                },
                'chinese 01-0-00': {
                    name: {
                        en: "Chinese New Year's Eve",
                        zh: "\u8FB2\u66C6\u9664\u5915"
                    }
                },
                'chinese 01-0-01': {
                    name: {
                        en: 'Chinese New Year',
                        zh: "\u8FB2\u66C6\u5E74\u521D\u4E00"
                    }
                },
                'chinese 01-0-01 if Monday then next Friday if Tuesday then next Saturdayif Wednesday then next Sunday if Thursday then next Monday if Friday then next Tuesday if Saturday then next Wednesday if Sunday then next Thursday': {
                    name: {
                        en: 'Chinese New Year Holiday',
                        zh: "\u519C\u5386\u65B0\u5E74\u5047\u671F"
                    }
                },
                'chinese 01-0-02': {
                    name: {
                        en: 'The second day of the Chinese New Year',
                        zh: "\u8FB2\u66C6\u5E74\u521D\u4E8C"
                    }
                },
                'chinese 01-0-03': {
                    name: {
                        en: 'The third day of the Chinese New Year',
                        zh: "\u8FB2\u66C6\u5E74\u521D\u4E09"
                    }
                },
                'chinese 01-0-04': {
                    name: {
                        en: 'The forth day of the Chinese New Year',
                        zh: "\u8FB2\u66C6\u5E74\u521D\u56DB"
                    }
                },
                '02-28 and if Sunday then next Monday': {
                    substitute: true,
                    name: {
                        en: 'Peace Memorial Day',
                        zh: "228\u548C\u5E73\u7D00\u5FF5\u65E5"
                    }
                },
                '04-04 and if Sunday then next Monday': {
                    substitute: true,
                    name: {
                        en: "Children's Day",
                        zh: "\u5152\u7AE5\u7BC0"
                    }
                },
                'chinese 5-01 solarterm and if Sunday then next Monday': {
                    substitute: true,
                    name: {
                        en: 'Tomb Sweeping Day',
                        zh: "\u6DF8\u660E\u7BC0"
                    }
                },
                'chinese 05-0-05 and if Sunday then next Monday': {
                    substitute: true,
                    name: {
                        en: 'Dragon Boat Festival',
                        zh: "\u7AEF\u5348\u7BC0"
                    }
                },
                'chinese 08-0-15 and if Sunday then next Monday': {
                    substitute: true,
                    name: {
                        en: 'Mid-Autumn Festival',
                        zh: "\u4E2D\u79CB\u7BC0"
                    }
                },
                '10-10 and if Sunday then next Monday': {
                    substitute: true,
                    name: {
                        en: 'National Day / Double Tenth Day',
                        zh: "\u570B\u6176\u65E5 / \u96D9\u5341\u7BC0"
                    }
                },
                '02-04': {
                    name: {
                        en: "Farmer's Day",
                        zh: "\u8FB2\u6C11\u7BC0"
                    },
                    type: 'observance'
                },
                '03-08': {
                    _name: '03-08',
                    type: 'observance'
                },
                '03-12': {
                    name: {
                        en: 'Arbor Day',
                        zh: "\u570B\u7236\u901D\u4E16\u7D00\u5FF5\u65E5"
                    },
                    type: 'observance'
                },
                '03-29': {
                    name: {
                        en: 'Youth Day',
                        zh: "\u9751\u5E74\u7BC0"
                    },
                    type: 'observance'
                },
                '05-01 and if Saturday then previous Friday if Sunday then next Monday': {
                    substitute: true,
                    _name: '05-01',
                    name: {
                        zh: "\u52DE\u52D5\u7BC0"
                    },
                    type: 'observance',
                    note: 'private sector'
                },
                '05-04': {
                    name: {
                        en: 'Literary Day',
                        zh: "\u6587\u85DD\u7BC0"
                    },
                    type: 'observance'
                },
                '2nd Sunday in May': {
                    _name: 'Mothers Day',
                    name: {
                        zh: "\u6BCD\u89AA\u7BC0"
                    },
                    type: 'observance'
                },
                '06-03': {
                    name: {
                        en: 'Opium Suppression Movement Day',
                        zh: "\u7981\u83F8\u7BC0"
                    },
                    type: 'observance'
                },
                '08-08': {
                    _name: 'Fathers Day',
                    name: {
                        zh: "\u7236\u89AA\u7BC0"
                    },
                    type: 'observance'
                },
                '09-01': {
                    name: {
                        en: "Journalist' Day",
                        zh: "\u8A18\u8005\u7BC0"
                    },
                    type: 'observance'
                },
                '09-03': {
                    name: {
                        en: 'Armed Forces Day',
                        zh: "\u8ECD\u4EBA\u7BC0"
                    },
                    type: 'observance'
                },
                '09-28': {
                    name: {
                        en: "Teachers' Day",
                        zh: "\u5B54\u5B50\u8A95\u8FB0\u7D00\u5FF5\u65E5"
                    },
                    type: 'observance'
                },
                '10-21': {
                    name: {
                        en: 'Overseas Chinese Day',
                        zh: "\u83EF\u50D1\u7BC0"
                    },
                    type: 'observance'
                },
                '10-25': {
                    name: {
                        en: 'Taiwan Retrocession Day',
                        zh: "\u81FA\u7063\u5149\u5FA9\u7BC0"
                    },
                    type: 'observance'
                },
                '11-12': {
                    name: {
                        en: "Sun Yat-sen's Birthday",
                        zh: "\u570B\u7236\u8A95\u8FB0\u7D00\u5FF5\u65E5"
                    },
                    note: "Also Doctors' Day and Cultural Renaissance Day",
                    type: 'observance'
                },
                'december solstice': {
                    name: {
                        en: 'Dongzhi Festival',
                        zh: "\u51AC\u81F3"
                    },
                    type: 'observance'
                },
                '12-25': {
                    name: {
                        en: 'Constitution Day',
                        zh: "\u884C\u61B2\u7D00\u5FF5\u65E5"
                    },
                    type: 'observance'
                },
                'chinese 01-0-15': {
                    name: {
                        en: 'Lantern Festival',
                        zh: "\u5143\u5BB5\u7BC0"
                    },
                    type: 'observance'
                },
                'chinese 01-0-15 #1': {
                    name: {
                        en: 'Tourism Day',
                        zh: "\u89C0\u5149\u7BC0"
                    },
                    type: 'observance'
                },
                'chinese 02-0-02': {
                    name: {
                        en: "Earth God's Birthday",
                        zh: "\u571F\u5730\u516C\u8A95\u8FB0"
                    },
                    type: 'observance'
                },
                'chinese 02-0-19': {
                    name: {
                        en: "Kuan Yin's Birthday",
                        zh: "\u89C0\u97F3\u8A95\u8FB0"
                    },
                    type: 'observance'
                },
                'chinese 03-0-15': {
                    name: {
                        en: "God of Medicine's Birthday",
                        zh: "\u4FDD\u751F\u5927\u5E1D\u8A95\u8FB0"
                    },
                    type: 'observance'
                },
                'chinese 03-0-23': {
                    name: {
                        en: "Matsu's Birthday",
                        zh: "\u5ABD\u7956\u8A95\u8FB0"
                    },
                    type: 'observance'
                },
                'chinese 04-0-08': {
                    name: {
                        en: "Buddha's Birthday",
                        zh: "\u4F5B\u8A95\u65E5"
                    },
                    type: 'observance'
                },
                'chinese 05-0-13': {
                    name: {
                        en: "Kuan Kung's Birthday",
                        zh: "\u95DC\u516C\u8A95\u8FB0"
                    },
                    type: 'observance'
                },
                'chinese 05-0-13 #1': {
                    name: {
                        en: "Cheng Huang's Birthday",
                        zh: "\u57CE\u968D\u723A\u8A95\u8FB0"
                    },
                    type: 'observance'
                },
                'chinese 07-0-07': {
                    name: {
                        en: 'Qixi Festival',
                        zh: "\u4E03\u5915"
                    },
                    type: 'observance'
                },
                'chinese 07-0-15': {
                    name: {
                        en: 'Ghost Festival',
                        zh: "\u4E2D\u5143\u7BC0"
                    },
                    type: 'observance'
                },
                'chinese 09-0-09': {
                    name: {
                        en: 'Double Ninth Festival',
                        zh: "\u91CD\u967D\u7BC0"
                    },
                    type: 'observance'
                },
                'chinese 10-0-15': {
                    name: {
                        en: 'Saisiat Festival',
                        zh: "\u8CFD\u590F\u7BC0"
                    },
                    type: 'observance'
                }
            }
        },
        TZ: {
            names: {
                en: 'Tanzania'
            },
            dayoff: 'sunday',
            langs: [
                'en'
            ],
            zones: [
                'Africa/Nairobi'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '01-02': {
                    name: {
                        en: 'Zanzibar Revolution Day'
                    }
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                easter: {
                    _name: 'easter',
                    type: 'observance'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '04-07': {
                    name: {
                        en: 'Karume Day'
                    }
                },
                '04-26': {
                    name: {
                        en: 'Union Day'
                    }
                },
                '05-01': {
                    _name: '05-01'
                },
                '07-07': {
                    name: {
                        en: 'Saba Saba Day'
                    }
                },
                '08-08': {
                    name: {
                        en: 'Nane Nane Day'
                    }
                },
                '10-14': {
                    name: {
                        en: 'Nyerere Day'
                    }
                },
                '12-09': {
                    _name: 'Independence Day'
                },
                '12-25': {
                    _name: '12-25'
                },
                '12-26': {
                    _name: '12-25'
                },
                '1 Shawwal P2D': {
                    _name: '1 Shawwal'
                },
                '10 Dhu al-Hijjah': {
                    _name: '10 Dhu al-Hijjah'
                },
                '12 Rabi al-awwal': {
                    _name: '12 Rabi al-awwal',
                    name: {
                        en: 'Maulid Day'
                    }
                }
            }
        },
        UA: {
            names: {
                uk: "\u0423\u043A\u0440\u0430\u0457\u043D\u0430",
                en: 'Ukraine'
            },
            langs: [
                'uk'
            ],
            zones: [
                'Europe/Kiev',
                'Europe/Uzhgorod',
                'Europe/Zaporozhye'
            ],
            dayoff: 'sunday',
            days: {
                '01-01 and if saturday, sunday then next tuesday': {
                    _name: '01-01',
                    name: {
                        en: 'New Year'
                    },
                    substitute: true
                },
                '01-02 and if saturday, sunday then next monday': {
                    _name: '01-01',
                    name: {
                        en: 'New Year'
                    },
                    substitute: true
                },
                'julian 12-25 and if saturday, sunday then next monday prior to 2023': {
                    _name: 'julian 12-25',
                    substitute: true
                },
                '03-08 and if saturday, sunday then next monday': {
                    _name: '03-08'
                },
                'orthodox and if sunday then next monday': {
                    _name: 'orthodox'
                },
                'orthodox 49 and if sunday then next monday': {
                    _name: 'easter 49'
                },
                '05-01 and if saturday, sunday then next tuesday': {
                    _name: '05-01',
                    substitute: true
                },
                '05-02 and if saturday, sunday then next monday prior to 2018': {
                    _name: '05-01',
                    substitute: true
                },
                '05-09 and if saturday, sunday then next monday': {
                    name: {
                        uk: "\u0414\u0435\u043D\u044C \u043F\u0435\u0440\u0435\u043C\u043E\u0433\u0438 \u043D\u0430\u0434 \u043D\u0430\u0446\u0438\u0437\u043C\u043E\u043C \u0443 \u0414\u0440\u0443\u0433\u0456\u0439 \u0441\u0432\u0456\u0442\u043E\u0432\u0456\u0439 \u0432\u0456\u0439\u043D\u0456",
                        en: 'Victory Day'
                    },
                    substitute: true
                },
                '06-28 and if saturday, sunday then next monday': {
                    _name: 'Constitution Day',
                    substitute: true
                },
                '07-15 and if saturday, sunday then next monday since 2023': {
                    name: {
                        en: 'Statehood Day',
                        uk: "\u0414\u0435\u043D\u044C \u0423\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u043E\u0457 \u0414\u0435\u0440\u0436\u0430\u0432\u043D\u043E\u0441\u0442\u0456"
                    }
                },
                '07-28 and if saturday, sunday then next monday prior to 2023': {
                    name: {
                        en: 'Statehood Day',
                        uk: "\u0414\u0435\u043D\u044C \u0423\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u043E\u0457 \u0414\u0435\u0440\u0436\u0430\u0432\u043D\u043E\u0441\u0442\u0456"
                    }
                },
                '08-24 and if saturday, sunday then next monday': {
                    _name: 'Independence Day',
                    substitute: true
                },
                '10-14 and if saturday, sunday then next monday since 2015 and prior to 2023': {
                    name: {
                        uk: "\u0414\u0435\u043D\u044C \u0437\u0430\u0445\u0438\u0441\u043D\u0438\u043A\u0430 \u0423\u043A\u0440\u0430\u0457\u043D\u0438",
                        en: 'Defenders of Ukraine Day'
                    },
                    substitute: true
                },
                '10-01 and if saturday, sunday then next monday since 2023': {
                    name: {
                        uk: "\u0414\u0435\u043D\u044C \u0437\u0430\u0445\u0438\u0441\u043D\u0438\u043A\u0456\u0432 \u0456 \u0437\u0430\u0445\u0438\u0441\u043D\u0438\u0446\u044C \u0423\u043A\u0440\u0430\u0457\u043D\u0438",
                        en: 'Defenders of Ukraine Day'
                    },
                    substitute: true
                },
                '12-25 and if saturday, sunday then next monday since 2017': {
                    _name: '12-25'
                }
            }
        },
        UG: {
            names: {
                en: 'Uganda'
            },
            dayoff: 'sundays',
            langs: [
                'en',
                'sw'
            ],
            zones: [
                'Africa/Nairobi'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '01-26': {
                    name: {
                        en: 'Liberation Day'
                    }
                },
                '02-16': {
                    name: {
                        en: 'Archbishop Janan Luwum Day'
                    }
                },
                '03-08': {
                    _name: '03-08'
                },
                'easter -46': {
                    _name: 'easter -46',
                    type: 'observance'
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                easter: {
                    _name: 'easter'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '05-01': {
                    _name: '05-01'
                },
                '06-03': {
                    name: {
                        en: "Martyr's Day"
                    }
                },
                '06-09': {
                    name: {
                        en: 'National Heroes Day'
                    }
                },
                '10-09': {
                    _name: 'Independence Day'
                },
                '12-25': {
                    _name: '12-25'
                },
                '12-26': {
                    _name: '12-26'
                },
                '1 Shawwal': {
                    _name: '1 Shawwal'
                },
                '10 Dhu al-Hijjah': {
                    _name: '10 Dhu al-Hijjah'
                }
            }
        },
        US: {
            names: {
                en: 'United States of America'
            },
            dayoff: 'sunday',
            zones: [
                'America/New_York',
                'America/Detroit',
                'America/Kentucky/Louisville',
                'America/Kentucky/Monticello',
                'America/Indiana/Indianapolis',
                'America/Indiana/Vincennes',
                'America/Indiana/Winamac',
                'America/Indiana/Marengo',
                'America/Indiana/Petersburg',
                'America/Indiana/Vevay',
                'America/Chicago',
                'America/Indiana/Tell_City',
                'America/Indiana/Knox',
                'America/Menominee',
                'America/North_Dakota/Center',
                'America/North_Dakota/New_Salem',
                'America/North_Dakota/Beulah',
                'America/Denver',
                'America/Boise',
                'America/Phoenix',
                'America/Los_Angeles',
                'America/Metlakatla',
                'America/Anchorage',
                'America/Juneau',
                'America/Sitka',
                'America/Yakutat',
                'America/Nome',
                'America/Adak',
                'Pacific/Honolulu'
            ],
            langs: [
                'en-us',
                'en'
            ],
            days: {
                '01-01 and if sunday then next monday if saturday then previous friday': {
                    substitute: true,
                    _name: '01-01'
                },
                '3rd monday in January': {
                    name: {
                        en: 'Martin Luther King Jr. Day',
                        es: 'Natalicio de Martin Luther King, Jr.'
                    }
                },
                '3rd monday in February': {
                    name: {
                        en: "Washington's Birthday",
                        es: "D\xeda de los Presidentes"
                    }
                },
                '02-14': {
                    _name: '02-14',
                    type: 'observance'
                },
                '03-17': {
                    name: {
                        en: "St. Patrick's Day"
                    },
                    type: 'observance'
                },
                easter: {
                    _name: 'easter',
                    type: 'observance'
                },
                '04-15 if friday then next monday if saturday,sunday then next tuesday': {
                    name: {
                        en: 'Tax Day'
                    },
                    type: 'observance'
                },
                'wednesday before 04-28': {
                    name: {
                        en: 'Administrative Professionals Day'
                    },
                    type: 'observance'
                },
                '2nd sunday in May': {
                    _name: 'Mothers Day',
                    type: 'observance'
                },
                'monday before 06-01': {
                    name: {
                        en: 'Memorial Day',
                        es: "Recordaci\xf3n de los Muertos de la Guerra"
                    }
                },
                '06-19 and if sunday then next monday if saturday then previous friday since 2021': {
                    substitute: true,
                    name: {
                        en: 'Juneteenth'
                    }
                },
                '3rd sunday in June': {
                    _name: 'Fathers Day',
                    type: 'observance'
                },
                '07-04 and if sunday then next monday if saturday then previous friday': {
                    substitute: true,
                    _name: 'Independence Day'
                },
                '1st monday in September': {
                    _name: '05-01'
                },
                '2nd monday in October': {
                    name: {
                        en: 'Columbus Day',
                        es: "Descubrimiento de Am\xe9rica"
                    }
                },
                '10-31 18:00': {
                    name: {
                        en: 'Halloween'
                    },
                    type: 'observance'
                },
                '11-11': {
                    name: {
                        en: 'Veterans Day',
                        es: "D\xeda del Veterano"
                    }
                },
                'substitutes 11-11 if sunday then next monday if saturday then previous friday': {
                    substitute: true,
                    name: {
                        en: 'Veterans Day',
                        es: "D\xeda del Veterano"
                    },
                    type: 'bank',
                    note: 'Federal Government offices are closed'
                },
                'tuesday after 1st monday in November every 4 years since 1848': {
                    name: {
                        en: 'Election Day'
                    },
                    type: 'observance'
                },
                '4th thursday in November': {
                    name: {
                        en: 'Thanksgiving Day',
                        es: "Acci\xf3n de Gracias"
                    }
                },
                'friday after 4th thursday in November': {
                    name: {
                        en: 'Day after Thanksgiving Day',
                        es: "Dia despues Acci\xf3n de Gracias"
                    },
                    type: 'observance'
                },
                '12-24': {
                    _name: '12-24',
                    type: 'optional'
                },
                '12-25 and if sunday then next monday if saturday then previous friday': {
                    substitute: true,
                    _name: '12-25'
                },
                '12-31': {
                    _name: '12-31',
                    type: 'observance'
                }
            },
            states: {
                AL: {
                    name: 'Alabama',
                    zones: [
                        'America/Chicago'
                    ],
                    days: {
                        '3rd monday in January': {
                            name: {
                                en: 'Robert E. Lee/Martin Luther King Birthday'
                            }
                        },
                        '3rd monday in February': {
                            name: {
                                en: 'George Washington/Thomas Jefferson Birthday'
                            }
                        },
                        '4th monday in April': {
                            name: {
                                en: 'Confederate Memorial Day'
                            }
                        },
                        '1st monday in June': {
                            name: {
                                en: "Jefferson Davis' birthday"
                            }
                        }
                    }
                },
                AK: {
                    name: 'Alaska',
                    zones: [
                        'America/Anchorage',
                        'America/Metlakatla',
                        'America/Juneau',
                        'America/Sitka',
                        'America/Yakutat',
                        'America/Nome'
                    ],
                    days: {
                        '3rd monday in February': {
                            name: {
                                en: "President's Day"
                            }
                        },
                        'monday before April': {
                            name: {
                                en: "Seward's Day"
                            }
                        },
                        '2nd monday in October': {
                            name: {
                                en: 'Columbus Day'
                            },
                            active: [
                                {
                                    to: '2017-01-01'
                                }
                            ]
                        },
                        '2nd monday in October #1': {
                            name: {
                                en: "Indigenous Peoples' Day"
                            },
                            active: [
                                {
                                    from: '2017-01-01'
                                }
                            ]
                        },
                        '10-18': {
                            name: {
                                en: 'Alaska Day'
                            }
                        }
                    }
                },
                AZ: {
                    name: 'Arizona',
                    zones: [
                        'America/Phoenix',
                        'America/Denver'
                    ],
                    days: {
                        '3rd monday in January': {
                            name: {
                                en: 'Dr. Martin Luther King Jr./ Civil Rights Day'
                            }
                        },
                        '3rd monday in February': {
                            name: {
                                en: "Lincoln/Washington Presidents' Day"
                            }
                        }
                    }
                },
                AR: {
                    name: 'Arkansas',
                    zones: [
                        'America/Chicago'
                    ],
                    days: {
                        '3rd monday in January': {
                            name: {
                                en: "Dr. Martin Luther King Jr./Robert E. Lee's Birthdays"
                            }
                        },
                        '3rd monday in February': {
                            name: {
                                en: "George Washington's Birthday/Daisy Gatson Bates Day"
                            }
                        },
                        '12-24': {
                            _name: '12-24'
                        }
                    }
                },
                CA: {
                    name: 'California',
                    zones: [
                        'America/Los_Angeles'
                    ],
                    days: {
                        '3rd monday in February': {
                            name: {
                                en: "Presidents' Day"
                            }
                        },
                        '2nd monday in October': false,
                        '02-15': {
                            type: 'observance',
                            name: {
                                en: 'Susan B. Anthony Day'
                            }
                        },
                        '03-31 and if sunday then next monday': {
                            substitute: true,
                            name: {
                                en: "C\xe9sar Ch\xe1vez Day"
                            }
                        },
                        '05-19': {
                            type: 'observance',
                            name: {
                                en: 'Malcolm X Day'
                            }
                        },
                        '05-23': {
                            type: 'observance',
                            name: {
                                en: 'Harvey Milk Day'
                            }
                        },
                        'friday after 4th thursday in November': {
                            name: {
                                en: 'Day after Thanksgiving Day'
                            },
                            type: 'public'
                        }
                    },
                    regions: {
                        LA: {
                            name: 'Los Angeles',
                            days: {
                                '08-24': {
                                    name: {
                                        en: 'Kobe Bryant Day'
                                    },
                                    type: 'observance',
                                    active: [
                                        {
                                            from: 2016
                                        }
                                    ]
                                }
                            }
                        }
                    }
                },
                CO: {
                    name: 'Colorado',
                    zones: [
                        'America/Denver'
                    ],
                    days: {
                        '3rd monday in February': {
                            name: {
                                en: 'Washington-Lincoln Day'
                            }
                        },
                        '2nd monday in October': {
                            type: 'observance'
                        }
                    }
                },
                CT: {
                    name: 'Connecticut',
                    zones: [
                        'America/New_York'
                    ],
                    days: {
                        '02-12': {
                            name: {
                                en: "Lincoln's Birthday"
                            }
                        },
                        'easter -2': {
                            _name: 'easter -2'
                        }
                    }
                },
                DE: {
                    name: 'Delaware',
                    days: {
                        '2nd monday in October': false,
                        '3rd monday in February': false,
                        'easter -2': {
                            _name: 'easter -2'
                        },
                        'friday after 4th thursday in November': {
                            name: {
                                en: 'Day After Thanksgiving'
                            }
                        },
                        'tuesday after 1st monday in November in even years': {
                            name: {
                                en: 'Election Day'
                            }
                        }
                    }
                },
                DC: {
                    name: 'District of Columbia',
                    days: {
                        '04-16': {
                            name: {
                                en: 'Emancipation Day'
                            }
                        },
                        '2nd monday in October': {
                            name: {
                                en: 'Columbus Day'
                            },
                            active: [
                                {
                                    to: '2019-10-08'
                                }
                            ]
                        },
                        '2nd monday in October #1': {
                            name: {
                                en: "Indigenous Peoples' Day"
                            },
                            active: [
                                {
                                    from: '2019-10-09'
                                }
                            ]
                        }
                    }
                },
                FL: {
                    name: 'Florida',
                    days: {
                        '2nd monday in October': false,
                        '3rd monday in February': false,
                        '02-15': {
                            name: {
                                en: 'Susan B. Anthony Day'
                            }
                        },
                        'friday after 4th thursday in November': {
                            name: {
                                en: 'Day After Thanksgiving'
                            }
                        }
                    }
                },
                GA: {
                    name: 'Georgia',
                    days: {
                        '3rd monday in February': false,
                        'monday before 05-01 #1': {
                            name: {
                                en: 'Confederate Memorial Day'
                            },
                            active: [
                                {
                                    to: '2016-01-01'
                                }
                            ]
                        },
                        'monday before 05-01 #2': {
                            name: {
                                en: 'State Holiday'
                            },
                            note: 'Known as Confederate Memorial Day prior to 2016',
                            active: [
                                {
                                    from: '2016-01-01'
                                }
                            ]
                        },
                        'friday after 4th thursday in November #1': {
                            name: {
                                en: "Robert E. Lee's Birthday"
                            },
                            note: 'General Lee was born on 1807-01-19 but this holiday was traditionally observed the day after Thanksgiving.',
                            active: [
                                {
                                    to: '2016-01-01'
                                }
                            ]
                        },
                        'friday after 4th thursday in November #2': {
                            name: {
                                en: 'State Holiday'
                            },
                            note: "Known as Robert E. Lee's Birtday prior to 2016",
                            active: [
                                {
                                    from: '2016-01-01'
                                }
                            ]
                        },
                        '12-24': {
                            name: {
                                en: "Washington's Birthday"
                            }
                        },
                        'substitutes 12-24 if wednesday then next friday': {
                            substitute: true,
                            name: {
                                en: "Washington's Birthday"
                            }
                        }
                    }
                },
                HI: {
                    name: 'Hawaii',
                    zones: [
                        'Pacific/Honolulu'
                    ],
                    days: {
                        '3rd monday in February': {
                            name: {
                                en: "Presidents' Day"
                            }
                        },
                        '03-26 and if saturday then previous friday if sunday then next monday': {
                            substitute: true,
                            name: {
                                en: 'Prince Jonah Kuhio Kalanianaole Day'
                            }
                        },
                        'easter -2': {
                            _name: 'easter -2'
                        },
                        '06-11 and if saturday then previous friday if sunday then next monday': {
                            substitute: true,
                            name: {
                                en: 'Kamehameha Day'
                            }
                        },
                        '3rd friday in August': {
                            name: {
                                en: 'Statehood Day'
                            }
                        },
                        '2nd monday in October': false,
                        'tuesday after 1st monday in November in even years': {
                            name: {
                                en: 'General Election Day'
                            }
                        }
                    }
                },
                ID: {
                    name: 'Idaho',
                    zones: [
                        'America/Boise',
                        'America/Los_Angeles'
                    ],
                    days: {
                        '3rd monday in January': {
                            name: {
                                en: 'Martin Luther King, Jr./ Idaho Human Rights Day'
                            }
                        },
                        '3rd monday in February': {
                            name: {
                                en: "President's Day"
                            }
                        }
                    }
                },
                IL: {
                    name: 'Illinois',
                    zones: [
                        'America/Chicago'
                    ],
                    days: {
                        '02-12': {
                            name: {
                                en: "Lincoln's Birthday"
                            }
                        },
                        '1st monday in March': {
                            name: {
                                en: 'Casimir Pulaski Day'
                            }
                        },
                        '05-19': {
                            name: {
                                en: 'Malcolm X Day'
                            }
                        },
                        'tuesday after 1st monday in November in even years': {
                            name: {
                                en: 'Election Day'
                            }
                        }
                    }
                },
                IN: {
                    name: 'Indiana',
                    zones: [
                        'America/Indiana/Indianapolis',
                        'America/Indiana/Vincennes',
                        'America/Indiana/Winamac',
                        'America/Indiana/Marengo',
                        'America/Indiana/Petersburg',
                        'America/Indiana/Vevay',
                        'America/Indiana/Tell_City',
                        'America/Indiana/Knox'
                    ],
                    days: {
                        'easter -2': {
                            _name: 'easter -2'
                        },
                        'tuesday after 1st monday in May': {
                            name: {
                                en: 'Primary Election Day'
                            }
                        },
                        'tuesday after 1st monday in November': {
                            name: {
                                en: 'Election Day'
                            }
                        },
                        'friday after 4th thursday in November': {
                            name: {
                                en: "Lincoln's Birthday"
                            }
                        }
                    }
                },
                IA: {
                    name: 'Iowa',
                    zones: [
                        'America/Chicago'
                    ],
                    days: {
                        '02-12': {
                            name: {
                                en: "Lincoln's Birthday"
                            }
                        },
                        '2nd monday in October': {
                            name: {
                                en: 'Columbus Day'
                            },
                            active: [
                                {
                                    to: '2018-10-07'
                                }
                            ]
                        },
                        '2nd monday in October #1': {
                            name: {
                                en: "Indigenous Peoples' Day"
                            },
                            active: [
                                {
                                    from: '2018-10-08'
                                }
                            ]
                        }
                    }
                },
                KS: {
                    name: 'Kansas',
                    zones: [
                        'America/Chicago',
                        'America/Denver'
                    ],
                    days: {
                        '3rd monday in February': false
                    }
                },
                KY: {
                    name: 'Kentucky',
                    zones: [
                        'America/Kentucky/Louisville',
                        'America/Kentucky/Monticello'
                    ],
                    days: {
                        '3rd monday in February': false,
                        'easter -2 14:00': {
                            _name: 'easter -2'
                        },
                        '12-24': {
                            _name: '12-24'
                        },
                        '12-31': {
                            _name: '12-31'
                        }
                    }
                },
                LA: {
                    name: 'Louisiana',
                    zones: [
                        'America/Chicago'
                    ],
                    days: {
                        'easter -2': {
                            _name: 'easter -2'
                        },
                        'tuesday after 1st monday in November in even years': {
                            name: {
                                en: 'Election Day'
                            }
                        }
                    },
                    regions: {
                        NO: {
                            name: 'New Orleans',
                            days: {
                                'easter -47': {
                                    _name: 'easter -47',
                                    name: {
                                        en: 'Mardi Gras'
                                    }
                                }
                            }
                        }
                    }
                },
                ME: {
                    name: 'Maine',
                    zones: [
                        'America/New_York'
                    ],
                    days: {
                        '3rd monday in February': {
                            name: {
                                en: "Washington's Birthday/President's Day"
                            }
                        },
                        '3rd monday in April': {
                            name: {
                                en: "Patriots' Day"
                            }
                        },
                        '2nd monday in October #1': {
                            name: {
                                en: "Indigenous Peoples' Day"
                            },
                            active: [
                                {
                                    from: '2019-04-26'
                                }
                            ]
                        }
                    }
                },
                MD: {
                    name: 'Maryland',
                    zones: [
                        'America/New_York'
                    ],
                    days: {
                        '3rd monday in February': {
                            name: {
                                en: "President's Day"
                            }
                        },
                        'friday before 1st monday before 06-01 since 2009 and prior to 2016': {
                            name: {
                                en: 'Service Reduction Day'
                            }
                        },
                        'friday after 4th thursday in November': {
                            name: {
                                en: 'Native American Heritage Day'
                            }
                        }
                    }
                },
                MA: {
                    name: 'Massachusetts',
                    zones: [
                        'America/New_York'
                    ],
                    days: {
                        '03-17': {
                            name: {
                                en: 'Evacuation Day'
                            }
                        },
                        '3rd monday in April': {
                            name: {
                                en: "Patriots' Day"
                            }
                        },
                        '06-17': {
                            name: {
                                en: 'Bunker Hill Day'
                            }
                        }
                    }
                },
                MI: {
                    name: 'Michigan',
                    zones: [
                        'America/Detroit',
                        'America/Menominee'
                    ],
                    days: {
                        '12-24': {
                            _name: '12-24'
                        },
                        '12-31': {
                            _name: '12-31'
                        }
                    }
                },
                MN: {
                    name: 'Minnesota',
                    zones: [
                        'America/Chicago'
                    ],
                    days: {
                        '3rd monday in February': {
                            name: {
                                en: "Washington's and Lincoln's Birthday"
                            }
                        },
                        '2nd monday in October': {
                            name: {
                                en: 'Columbus Day'
                            },
                            active: [
                                {
                                    to: '2017-01-01'
                                }
                            ]
                        },
                        '2nd monday in October #1': {
                            name: {
                                en: "Indigenous Peoples' Day"
                            },
                            active: [
                                {
                                    from: '2017-01-01'
                                }
                            ]
                        }
                    }
                },
                MS: {
                    name: 'Mississippi',
                    zones: [
                        'America/Chicago'
                    ],
                    days: {
                        '3rd monday in January': {
                            name: {
                                en: "Martin Luther King's and Robert E. Lee's Birthdays"
                            }
                        },
                        'monday before 05-01': {
                            name: {
                                en: 'Confederate Memorial Day'
                            }
                        }
                    }
                },
                MO: {
                    name: 'Missouri',
                    zones: [
                        'America/Chicago'
                    ],
                    days: {
                        '02-12': {
                            name: {
                                en: "Lincoln's Birthday"
                            }
                        },
                        '05-08': {
                            name: {
                                en: 'Truman Day'
                            }
                        }
                    }
                },
                MT: {
                    name: 'Montana',
                    zones: [
                        'America/Denver'
                    ],
                    days: {
                        '3rd monday in February': {
                            name: {
                                en: "Lincoln's and Washington's Birthday"
                            }
                        },
                        'tuesday after 1st monday in November': {
                            name: {
                                en: 'Election Day'
                            }
                        },
                        '12-24': {
                            _name: '12-24'
                        },
                        '12-31': {
                            _name: '12-31'
                        }
                    }
                },
                NE: {
                    name: 'Nebraska',
                    zones: [
                        'America/Chicago',
                        'America/Denver'
                    ],
                    days: {
                        '3rd monday in February': {
                            name: {
                                en: "President's Day"
                            }
                        },
                        'friday before 05-01': {
                            name: {
                                en: 'Arbor Day'
                            }
                        }
                    }
                },
                NV: {
                    name: 'Nevada',
                    zones: [
                        'America/Los_Angeles'
                    ],
                    days: {
                        '3rd monday in February': {
                            name: {
                                en: 'Presidents Day'
                            }
                        },
                        '2nd monday in October': false,
                        '08-09': {
                            name: {
                                en: "Indigenous Peoples' Day"
                            },
                            active: [
                                {
                                    from: '2017-01-01'
                                }
                            ],
                            type: 'observance'
                        },
                        'friday before 11-01': {
                            name: {
                                en: 'Nevada Day'
                            }
                        },
                        '4th friday in November': {
                            name: {
                                en: 'Family Day'
                            }
                        }
                    }
                },
                NH: {
                    name: 'New Hampshire',
                    zones: [
                        'America/New_York'
                    ],
                    days: {
                        '3rd monday in January': {
                            name: {
                                en: 'Martin Luther King, Jr./ Civil Rights Day'
                            }
                        },
                        '3rd monday in February': {
                            name: {
                                en: "President's Day"
                            }
                        },
                        '2nd monday in October': {
                            type: 'observance'
                        },
                        'tuesday after 1st monday in November in even years': {
                            name: {
                                en: 'Election Day'
                            }
                        },
                        'friday after 4th thursday in November': {
                            name: {
                                en: 'Day after Thanksgiving'
                            }
                        }
                    }
                },
                NJ: {
                    name: 'New Jersey',
                    zones: [
                        'America/New_York'
                    ],
                    days: {
                        '02-12': {
                            name: {
                                en: "Lincoln's Birthday"
                            }
                        },
                        '3rd monday in February': {
                            name: {
                                en: 'Presidents Day'
                            }
                        },
                        'easter -2': {
                            _name: 'easter -2'
                        },
                        'tuesday after 1st monday in November': {
                            name: {
                                en: 'Election Day'
                            }
                        }
                    }
                },
                NM: {
                    name: 'New Mexico',
                    zones: [
                        'America/Denver'
                    ],
                    days: {
                        '3rd monday in February': {
                            name: {
                                en: "Presidents' Day"
                            }
                        },
                        '2nd monday in October #1': {
                            name: {
                                en: "Indigenous Peoples' Day"
                            },
                            active: [
                                {
                                    from: '2019-04-01'
                                }
                            ]
                        },
                        'friday after 4th thursday in November': {
                            name: {
                                en: 'Day after Thanksgiving'
                            }
                        }
                    }
                },
                NY: {
                    name: 'New York',
                    zones: [
                        'America/New_York'
                    ],
                    days: {
                        '02-12': {
                            name: {
                                en: "Lincoln's Birthday"
                            }
                        },
                        '02-15': {
                            name: {
                                en: 'Susan B. Anthony Day'
                            }
                        },
                        'tuesday after 1st monday in November': {
                            name: {
                                en: 'Election Day'
                            }
                        }
                    }
                },
                NC: {
                    name: 'North Carolina',
                    zones: [
                        'America/New_York'
                    ],
                    days: {
                        '3rd monday in February': false,
                        '2nd monday in October': false,
                        'easter -2': {
                            _name: 'easter -2'
                        },
                        'friday after 4th thursday in November': {
                            name: {
                                en: 'Day after Thanksgiving'
                            }
                        },
                        '12-24 and if friday then previous thursday if saturday,sunday then previous friday': {
                            substitute: true,
                            _name: '12-24'
                        }
                    }
                },
                ND: {
                    name: 'North Dakota',
                    zones: [
                        'America/North_Dakota/Center',
                        'America/North_Dakota/New_Salem',
                        'America/North_Dakota/Beulah'
                    ],
                    days: {
                        '3rd monday in February': {
                            name: {
                                en: "Presidents' Day"
                            }
                        }
                    }
                },
                OH: {
                    name: 'Ohio',
                    zones: [
                        'America/New_York'
                    ],
                    days: {
                        '3rd monday in February': {
                            name: {
                                en: 'Washington-Lincoln Day'
                            }
                        }
                    }
                },
                OK: {
                    name: 'Oklahoma',
                    zones: [
                        'America/Chicago'
                    ],
                    days: {
                        '3rd monday in February': {
                            name: {
                                en: "Presidents' Day"
                            }
                        },
                        'friday after 4th thursday in November': {
                            name: {
                                en: 'Day after Thanksgiving'
                            }
                        }
                    }
                },
                OR: {
                    name: 'Oregon',
                    zones: [
                        'America/Los_Angeles'
                    ],
                    days: {
                        '3rd monday in February': {
                            name: {
                                en: 'Presidents Day'
                            }
                        }
                    }
                },
                PA: {
                    name: 'Pennsylvania',
                    zones: [
                        'America/New_York'
                    ],
                    days: {
                        '3rd monday in February': {
                            name: {
                                en: "Presidents' Day"
                            }
                        },
                        '06-14': {
                            name: {
                                en: 'Flag Day'
                            }
                        }
                    }
                },
                RI: {
                    name: 'Rhode Island',
                    zones: [
                        'America/New_York'
                    ],
                    days: {
                        '2nd monday in August': {
                            name: {
                                en: 'Victory Day'
                            }
                        }
                    }
                },
                SC: {
                    name: 'South Carolina',
                    zones: [
                        'America/New_York'
                    ],
                    days: {
                        '05-10': {
                            name: {
                                en: 'Confederate Memorial Day'
                            }
                        },
                        '12-26': {
                            _name: '12-26'
                        }
                    }
                },
                SD: {
                    name: 'South Dakota',
                    zones: [
                        'America/Chicago',
                        'America/Denver'
                    ],
                    days: {
                        '3rd monday in February': {
                            name: {
                                en: "Presidents' Day"
                            }
                        },
                        '2nd monday in October': {
                            name: {
                                en: 'Columbus Day'
                            },
                            active: [
                                {
                                    to: '2015-01-01'
                                }
                            ]
                        },
                        '2nd monday in October #1': {
                            name: {
                                en: 'Native American Day'
                            },
                            active: [
                                {
                                    from: '2015-01-01'
                                }
                            ]
                        }
                    }
                },
                TN: {
                    name: 'Tennessee',
                    zones: [
                        'America/Chicago',
                        'America/New_York'
                    ],
                    days: {
                        '3rd monday in February': {
                            name: {
                                en: "President's Day"
                            }
                        },
                        'easter -2': {
                            _name: 'easter -2'
                        },
                        '12-24': {
                            _name: '12-24'
                        }
                    }
                },
                TX: {
                    name: 'Texas',
                    zones: [
                        'America/Chicago',
                        'America/Denver'
                    ],
                    days: {
                        '01-19': {
                            name: {
                                en: 'Confederate Heroes Day'
                            },
                            type: 'observance',
                            note: 'state agencies are partially staffed'
                        },
                        '3rd monday in February': {
                            name: {
                                en: "Presidents' Day"
                            }
                        },
                        '03-02': {
                            name: {
                                en: 'Texas Independence Day'
                            },
                            type: 'observance',
                            note: 'state agencies are partially staffed'
                        },
                        '03-31': {
                            name: {
                                en: 'Cesar Chavez Day'
                            },
                            type: 'observance'
                        },
                        'easter -2': {
                            _name: 'easter -2',
                            type: 'observance'
                        },
                        '04-21': {
                            name: {
                                en: 'San Jacinto Day'
                            },
                            type: 'observance',
                            note: 'state agencies are partially staffed'
                        },
                        '06-19': {
                            name: {
                                en: 'Emancipation Day In Texas'
                            },
                            type: 'observance',
                            note: 'state agencies are partially staffed'
                        },
                        '08-27': {
                            name: {
                                en: 'Lyndon Baines Johnson Day'
                            },
                            type: 'observance',
                            note: 'state agencies are partially staffed'
                        },
                        'friday after 4th thursday in November': {
                            name: {
                                en: 'Day after Thanksgiving'
                            }
                        },
                        '12-24': {
                            _name: '12-24'
                        },
                        '12-26': {
                            _name: '12-26',
                            name: {
                                en: 'Day after Christmas'
                            }
                        }
                    }
                },
                UT: {
                    name: 'Utah',
                    zones: [
                        'America/Denver'
                    ],
                    days: {
                        '3rd monday in February': {
                            name: {
                                en: 'Washington and Lincoln Day'
                            }
                        },
                        '07-24': {
                            name: {
                                en: 'Pioneer Day'
                            }
                        }
                    }
                },
                VT: {
                    name: 'Vermont',
                    zones: [
                        'America/New_York'
                    ],
                    days: {
                        '3rd monday in February': {
                            name: {
                                en: "Presidents' Day"
                            }
                        },
                        '1st tuesday in March': {
                            name: {
                                en: 'Town Meeting Day'
                            }
                        },
                        '3rd monday in August': {
                            name: {
                                en: 'Bennington Battle Day'
                            }
                        },
                        '2nd monday in October': {
                            name: {
                                en: 'Columbus Day'
                            },
                            active: [
                                {
                                    to: '2017-09-01'
                                }
                            ]
                        },
                        '2nd monday in October #1': {
                            name: {
                                en: "Indigenous Peoples' Day"
                            },
                            active: [
                                {
                                    from: '2017-09-01'
                                }
                            ]
                        }
                    }
                },
                VA: {
                    name: 'Virginia',
                    zones: [
                        'America/New_York'
                    ],
                    days: {
                        '3rd monday in February': {
                            name: {
                                en: 'George Washington Day'
                            }
                        },
                        'friday before 3rd monday in January prior to 2021': {
                            name: {
                                en: "Lee\u2013Jackson Day"
                            }
                        },
                        'tuesday after 1st monday in November in even years since 2020': {
                            name: 'Election Day'
                        }
                    }
                },
                WA: {
                    name: 'Washington',
                    zones: [
                        'America/Los_Angeles'
                    ],
                    days: {
                        '3rd monday in February': {
                            name: {
                                en: "Presidents' Day"
                            }
                        }
                    }
                },
                WV: {
                    name: 'West Virginia',
                    zones: [
                        'America/New_York'
                    ],
                    days: {
                        '02-15': {
                            name: {
                                en: 'Susan B. Anthony Day'
                            }
                        },
                        '3rd monday in February': {
                            name: {
                                en: "President's Day"
                            }
                        },
                        '06-20': {
                            name: {
                                en: 'West Virginia Day'
                            }
                        },
                        '4th friday in November': {
                            name: {
                                en: "Lincoln's Day"
                            }
                        }
                    }
                },
                WI: {
                    name: 'Wisconsin',
                    zones: [
                        'America/Chicago'
                    ],
                    days: {
                        '02-15': {
                            name: {
                                en: 'Susan B. Anthony Day'
                            }
                        },
                        '2nd tuesday in September': {
                            name: {
                                en: 'Primary Election Day'
                            }
                        },
                        'tuesday after 1st monday in November': {
                            name: {
                                en: 'Election Day'
                            }
                        }
                    }
                },
                WY: {
                    name: 'Wyoming',
                    zones: [
                        'America/Denver'
                    ],
                    days: {
                        '3rd monday in February': {
                            name: {
                                en: "President's Day"
                            }
                        }
                    }
                }
            }
        },
        UY: {
            names: {
                es: 'Uruguay',
                en: 'Uruguay'
            },
            dayoff: 'sunday',
            langs: [
                'es'
            ],
            zones: [
                'America/Montevideo'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '01-06': {
                    _name: '01-06',
                    type: 'observance'
                },
                'easter -48': {
                    name: {
                        en: 'Carnival',
                        es: 'Carnaval'
                    },
                    type: 'observance'
                },
                'easter -47': {
                    _name: 'easter -47',
                    type: 'observance'
                },
                'easter -6 P5D': {
                    name: {
                        en: 'Tourism Week',
                        es: 'Semana de Turismo'
                    },
                    type: 'observance'
                },
                'easter -3': {
                    _name: 'easter -3'
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                easter: {
                    _name: 'easter',
                    type: 'observance'
                },
                '04-19 if tuesday,wednesday then previous monday if thursday,friday then next monday': {
                    name: {
                        en: 'Landing of the 33 Orientals',
                        es: 'Desembarco de los 33 Orientales'
                    },
                    type: 'observance'
                },
                '05-01': {
                    _name: '05-01'
                },
                '05-18 if tuesday,wednesday then previous monday if thursday,friday then next monday': {
                    name: {
                        en: 'Battle of Las Piedras',
                        es: 'Batalla de las Piedras'
                    },
                    type: 'observance'
                },
                '06-19': {
                    name: {
                        en: "Birthday of Jos\xe9 Gervasio Artigas and Never Again Day",
                        es: "Natalicio de Artigas y D\xeda del Nunca M\xe1s"
                    },
                    type: 'observance'
                },
                '07-18': {
                    _name: 'Constitution Day'
                },
                '08-25': {
                    _name: 'Independence Day'
                },
                '10-12 if tuesday,wednesday then previous monday if thursday,friday then next monday': {
                    name: {
                        en: 'Columbus Day',
                        es: "D\xeda de la Raza"
                    },
                    type: 'observance'
                },
                '11-02': {
                    _name: '11-02',
                    type: 'observance'
                },
                '12-24': {
                    _name: '12-24',
                    type: 'observance'
                },
                '12-25': {
                    _name: '12-25'
                },
                '12-31': {
                    _name: '12-31',
                    type: 'observance'
                }
            }
        },
        VA: {
            names: {
                it: "Stato della Citt\xe0 del Vaticano",
                la: 'Status Civitatis Vaticanae',
                en: 'Vatican City'
            },
            langs: [
                'it'
            ],
            zones: [
                'Europe/Rome'
            ],
            dayoff: 'sunday',
            days: {
                '01-01': {
                    name: {
                        en: 'Solemnity of Mary, Mother of God',
                        it: 'Maria Santissima Madre di Dio'
                    }
                },
                '01-06': {
                    name: {
                        en: 'Epiphany',
                        it: 'Epifania del Signore'
                    }
                },
                '02-11': {
                    name: {
                        en: 'Anniversary of the foundation of Vatican City',
                        it: "Anniversario della istituzione dello Stato della Citt\xe0 del Vaticano"
                    }
                },
                '03-19': {
                    _name: '03-19'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                'easter 39': {
                    _name: 'easter 39',
                    active: [
                        {
                            to: 2009
                        }
                    ]
                },
                'easter 60': {
                    _name: 'easter 60',
                    active: [
                        {
                            to: 2009
                        }
                    ]
                },
                '05-01': {
                    _name: '05-01',
                    name: {
                        en: 'Saint Joseph the Worker',
                        it: 'San Giuseppe lavoratore'
                    }
                },
                '06-29': {
                    _name: '06-29'
                },
                '08-15': {
                    _name: '08-15',
                    name: {
                        it: 'Assunzione di Maria in Cielo'
                    }
                },
                '09-08': {
                    name: {
                        en: 'Nativity of Mary',
                        it: "Festa della nativit\xe0 della madonna"
                    }
                },
                '11-01': {
                    _name: '11-01'
                },
                '12-08': {
                    _name: '12-08'
                },
                '12-25': {
                    _name: '12-25'
                },
                '12-26': {
                    _name: '12-26'
                },
                '10-16': {
                    name: {
                        en: 'Anniversary of the election of Pope John Paul II',
                        it: "Anniversario dell'Elezione del Santo Padre"
                    },
                    active: [
                        {
                            from: 1978,
                            to: 2005
                        }
                    ]
                },
                '11-04': {
                    name: {
                        en: 'Saint Charles Borromeo - Name day of the Holy Father',
                        it: 'San Carlo Borromeo - Onomastico del Santo Padre'
                    },
                    note: "Name day of Pope John Paul II (Karol J\xf3zef Wojty\u0142a)",
                    active: [
                        {
                            from: 1978,
                            to: 2005
                        }
                    ]
                },
                '04-19': {
                    name: {
                        en: 'Anniversary of the election of Pope Benedict XVI',
                        it: "Anniversario dell'Elezione del Santo Padre"
                    },
                    active: [
                        {
                            from: 2005,
                            to: 2013
                        }
                    ]
                },
                '03-19#1': {
                    name: {
                        en: 'Saint Joseph - Name day of the Holy Father',
                        it: 'San Giuseppe - Onomastico del Santo Padre'
                    },
                    note: 'Name day of Pope Benedict XVI (Josef Ratzinger)',
                    active: [
                        {
                            from: 2005,
                            to: 2013
                        }
                    ]
                },
                '03-13': {
                    name: {
                        en: 'Anniversary of the election of Pope Francis',
                        it: "Anniversario dell'Elezione del Santo Padre"
                    },
                    active: [
                        {
                            from: 2013
                        }
                    ]
                },
                '04-23': {
                    name: {
                        en: 'Saint George - Name day of the Holy Father',
                        it: 'San Giorgio - Onomastico del Santo Padre'
                    },
                    note: 'Name day of Pope Francis (Jorge Mario Bergoglio)',
                    active: [
                        {
                            from: 2013
                        }
                    ]
                }
            }
        },
        VC: {
            names: {
                en: 'St. Vincent & Grenadines'
            },
            langs: [
                'en'
            ],
            zones: [
                'America/Port_of_Spain'
            ],
            dayoff: 'sunday',
            days: {
                '01-01 and if Sunday then next Monday': {
                    substitute: true,
                    _name: '01-01'
                },
                '03-14 and if Sunday then next Monday': {
                    substitute: true,
                    name: {
                        en: "National Hero\u2032s Day"
                    }
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                easter: {
                    _name: 'easter',
                    type: 'observance'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '05-01 and if Sunday then next Monday': {
                    substitute: true,
                    _name: '05-01'
                },
                'easter 50': {
                    _name: 'easter 50'
                },
                '1st Monday in July': {
                    name: {
                        en: 'Carnival Monday'
                    },
                    disable: [
                        '2021-06-05'
                    ],
                    enable: [
                        '2021-09-06'
                    ]
                },
                'Tuesday after 1st Monday in July': {
                    name: {
                        en: 'Carnival Tuesday'
                    },
                    disable: [
                        '2021-06-06'
                    ],
                    enable: [
                        '2021-09-07'
                    ]
                },
                '08-01 and if Sunday then next Monday': {
                    substitute: true,
                    name: {
                        en: 'Emancipation Day'
                    }
                },
                '10-27 and if Sunday then next Monday': {
                    substitute: true,
                    _name: 'Independence Day'
                },
                '12-25 and if Sunday then next Tuesday': {
                    substitute: true,
                    _name: '12-25'
                },
                '12-26 and if Sunday then next Monday': {
                    substitute: true,
                    _name: '12-26'
                }
            }
        },
        VE: {
            names: {
                es: 'Venezuela',
                en: 'Venezuela'
            },
            dayoff: 'sundays',
            langs: [
                'es'
            ],
            zones: [
                'America/Caracas'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '01-06': {
                    _name: '01-06',
                    type: 'observance'
                },
                '01-15': {
                    name: {
                        es: "D\xeda del Maestro",
                        en: "Teacher's Day"
                    },
                    type: 'optional',
                    note: 'teachers only'
                },
                '03-19': {
                    _name: '03-19',
                    type: 'observance'
                },
                'easter -48': {
                    name: {
                        en: 'Carnival',
                        es: 'Carnaval'
                    }
                },
                'easter -47': {
                    _name: 'easter -47'
                },
                'easter -6 P7D': {
                    name: {
                        en: 'Holy Week',
                        es: 'Semana Santa'
                    },
                    type: 'observance'
                },
                'easter -3': {
                    _name: 'easter -3'
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                easter: {
                    _name: 'easter'
                },
                '04-19': {
                    name: {
                        en: 'Declaration of Independence',
                        es: "Declaraci\xf3n de la Independencia"
                    }
                },
                '05-01': {
                    _name: '05-01'
                },
                '06-24': {
                    name: {
                        en: 'Battle of Carabobo',
                        es: 'Aniversario de la Batalla de Carabobo'
                    }
                },
                '07-05': {
                    _name: 'Independence Day'
                },
                '07-24': {
                    name: {
                        en: "Birthday of Sim\xf3n Bol\xedvar",
                        es: "Natalicio de Sim\xf3n Bol\xedvar"
                    }
                },
                '08-03': {
                    name: {
                        en: 'Flag Day',
                        es: "D\xeda de la Bandera"
                    },
                    type: 'observance'
                },
                '09-11': {
                    name: {
                        en: 'Our Lady of Coromoto',
                        es: "D\xeda de Nuestra Se\xf1ora de Coromoto"
                    },
                    type: 'observance'
                },
                '10-12': {
                    name: {
                        en: 'Day of Indigenous Resistance',
                        es: "D\xeda de la resistencia ind\xedgena"
                    }
                },
                '11-01': {
                    _name: '11-01',
                    type: 'observance'
                },
                '11-02': {
                    _name: '11-02',
                    type: 'observance'
                },
                '12-08': {
                    _name: '12-08',
                    type: 'observance'
                },
                '12-10': {
                    name: {
                        en: 'Venezuelan Air Force Day',
                        es: "D\xeda de la Aviaci\xf3n Nacional"
                    },
                    type: 'observance'
                },
                '12-24': {
                    _name: '12-24'
                },
                '12-25': {
                    _name: '12-25'
                },
                '12-31': {
                    _name: '12-31'
                }
            },
            states: {
                B: {
                    name: "Anzo\xe1tegui",
                    days: {
                        '11-14': {
                            name: {
                                es: "Natalicio de Jos\xe9 Antonio Anzo\xe1tegui"
                            }
                        }
                    }
                },
                G: {
                    name: 'Carabobo',
                    days: {
                        '11-13': {
                            name: {
                                es: "D\xeda de la Virgen del Socorro"
                            }
                        }
                    }
                },
                K: {
                    name: 'Lara',
                    days: {
                        '01-14': {
                            name: {
                                es: "D\xeda de La Divina Pastora"
                            }
                        },
                        '05-28': {
                            name: {
                                es: 'Natalicio de Jacinto Lara'
                            }
                        }
                    },
                    regions: {
                        BA: {
                            name: 'Barquisimeto',
                            days: {
                                '09-14': {
                                    name: {
                                        es: "D\xeda de Barquisimeto"
                                    }
                                }
                            }
                        }
                    }
                },
                M: {
                    name: 'Miranda',
                    days: {
                        '03-19': {
                            _name: '03-19'
                        }
                    }
                },
                N: {
                    name: 'Monagas',
                    days: {
                        '12-07': {
                            name: {
                                es: "D\xeda de Maturin"
                            }
                        }
                    }
                },
                S: {
                    name: "T\xe1chira",
                    days: {
                        '08-15': {
                            _name: '08-15',
                            name: {
                                es: "D\xeda de la Virgen de Consolaci\xf3n"
                            }
                        }
                    }
                },
                V: {
                    name: 'Zulia',
                    days: {
                        '10-24': {
                            name: {
                                es: 'Natalicio de Rafael Urdaneta'
                            }
                        },
                        '11-18': {
                            name: {
                                es: "D\xeda de la Virgen de la Chinita"
                            }
                        }
                    }
                }
            }
        },
        VG: {
            names: {
                en: 'British Virgin Islands'
            },
            langs: [
                'en'
            ],
            zones: [
                'America/Port_of_Spain'
            ],
            dayoff: 'sunday',
            days: {
                '01-01': {
                    _name: '01-01'
                },
                'Monday before 03-08': {
                    name: {
                        en: 'The Anniversary of the Birth of Hamilton Lavity Stoutt'
                    }
                },
                '2nd Monday in March': {
                    name: {
                        en: 'Commonwealth Day'
                    }
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                easter: {
                    _name: 'easter',
                    type: 'observance'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                'easter 49': {
                    _name: 'easter 49',
                    type: 'observance'
                },
                'easter 50': {
                    _name: 'easter 50'
                },
                '2nd Saturday after 06-02 prior to 2020': {
                    name: {
                        en: "Sovereign\u2019s Birthday"
                    },
                    disable: [
                        '2017-06-10',
                        '2019-06-15'
                    ],
                    enable: [
                        '2017-06-17',
                        '2019-06-07'
                    ]
                },
                '2nd Friday after 06-02 since 2020': {
                    name: {
                        en: "Sovereign\u2019s Birthday"
                    }
                },
                '07-01 if Sunday,Thursday then next Monday if Saturday then previous Friday if Tuesday,Wednesday then previous Monday': {
                    name: {
                        en: 'Virgin Islands Day'
                    }
                },
                '10-21 if Sunday then next Monday if Saturday then previous Friday if Tuesday,Wednesday then previous Monday if Thursday then next Friday': {
                    name: {
                        en: "St. Ursula\u2019s Day"
                    },
                    disable: [
                        '2016-10-23',
                        '2020-10-19',
                        '2021-10-22'
                    ],
                    enable: [
                        '2016-10-19',
                        '2020-10-23'
                    ]
                },
                '1st Monday in August': {
                    name: {
                        en: 'Emancipation Monday'
                    }
                },
                'Tuesday after 1st Monday in August': {
                    name: {
                        en: 'Emancipation Tuesday'
                    }
                },
                'Wednesday after 1st Monday in August': {
                    name: {
                        en: 'Emancipation Wednesday'
                    }
                },
                '2021-10-18': {
                    name: {
                        en: "Heroes\u2019 and Forefathers Day"
                    }
                },
                '2021-11-08': {
                    name: {
                        en: 'Commemoration of the Great March of 1949'
                    }
                },
                '12-25 and if Saturday then next Monday if Sunday then next Tuesday': {
                    substitute: true,
                    _name: '12-25'
                },
                '12-26 and if Saturday then next Monday if Sunday then next Tuesday': {
                    substitute: true,
                    _name: '12-26'
                }
            }
        },
        VI: {
            names: {
                en: 'U.S. Virgin Islands'
            },
            langs: [
                'en'
            ],
            zones: [
                'America/Port_of_Spain'
            ],
            dayoff: 'sunday',
            _days: 'US',
            days: {
                '01-06': {
                    _name: '01-06',
                    name: {
                        en: 'Three Kings Day'
                    }
                },
                '3rd monday in February': {
                    name: {
                        en: "President's Day"
                    }
                },
                '03-17': false,
                '03-31': {
                    name: {
                        en: 'Transfer Day'
                    }
                },
                'easter -3': {
                    _name: 'easter -3'
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '07-03': {
                    name: {
                        en: 'Emancipation Day'
                    }
                },
                '4th Monday in July': {
                    name: {
                        en: 'Hurricane Supplication Day'
                    }
                },
                '2nd monday in October': {
                    name: {
                        en: "Virgin Islands\u2013Puerto Rico Friendship Day"
                    }
                },
                '10-25': {
                    name: {
                        en: 'Hurricane Thanksgiving'
                    },
                    type: 'observance'
                },
                'friday after 4th thursday in November': {
                    name: {
                        en: 'Day after Thanksgiving Day'
                    },
                    type: 'school'
                }
            }
        },
        VN: {
            names: {
                vi: "C\u1ED9ng h\xf2a X\xe3 h\u1ED9i ch\u1EE7 ngh\u0129a Vi\u1EC7t Nam",
                en: 'Vietnam'
            },
            dayoff: '',
            langs: [
                'vi'
            ],
            zones: [
                'Asia/Ho_Chi_Minh',
                'Asia/Bangkok'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                'vietnamese 1-0-1': {
                    name: {
                        en: 'Vietnamese New Year',
                        vi: "T\u1EBFt Nguy\xean \u0110\xe1n"
                    }
                },
                '1 day before vietnamese 1-0-1 P5D': {
                    name: {
                        en: 'Vietnamese New Year Holidays',
                        vi: "Giao th\u1EEBa T\u1EBFt Nguy\xean \u0110\xe1n"
                    }
                },
                'vietnamese 3-0-10': {
                    name: {
                        en: 'Hung Kings Commemorations',
                        vi: "Gi\u1ED7 t\u1ED5 H\xf9ng V\u01B0\u01A1ng"
                    }
                },
                '04-30': {
                    name: {
                        en: 'Day of liberating the South for national reunification',
                        vi: "Ng\xe0y Gi\u1EA3i ph\xf3ng mi\u1EC1n Nam"
                    }
                },
                '05-01': {
                    _name: '05-01'
                },
                '09-02': {
                    name: {
                        en: 'National Day',
                        vi: "Qu\u1ED1c kh\xe1nh"
                    }
                },
                '02-03': {
                    name: {
                        en: 'Communist Party of Viet Nam Foundation Anniversary',
                        vi: "Ng\xe0y th\xe0nh l\u1EADp \u0110\u1EA3ng"
                    },
                    type: 'observance'
                },
                '03-08': {
                    _name: '03-08',
                    type: 'observance'
                },
                '04-21': {
                    name: {
                        en: 'Vietnam Book Day',
                        vi: "Ng\xe0y S\xe1ch Vi\u1EC7t Nam"
                    },
                    type: 'observance'
                },
                '05-07': {
                    name: {
                        en: 'Dien Bien Phu Victory Day',
                        vi: "Ng\xe0y Chi\u1EBFn th\u1EAFng \u0110i\u1EC7n Bi\u1EC7n Ph\u1EE7"
                    },
                    type: 'observance'
                },
                '05-19': {
                    name: {
                        en: "President Ho Chi Minh's Birthday",
                        vi: "Ng\xe0y sinh Ch\u1EE7 t\u1ECBch H\u1ED3 Ch\xed Minh"
                    },
                    type: 'observance'
                },
                '06-01': {
                    name: {
                        en: "International Children's Day",
                        vi: "Ng\xe0y qu\u1ED1c t\u1EBF Thi\u1EBFu nhi"
                    },
                    type: 'observance'
                },
                '06-28': {
                    name: {
                        en: 'Vietnamese Family Day',
                        vi: "Ng\xe0y Gia \u0111\xecnh Vi\u1EC7t Nam"
                    },
                    type: 'observance'
                },
                '07-27': {
                    name: {
                        en: 'Remembrance Day',
                        vi: "Ng\xe0y Th\u01B0\u01A1ng Binh Li\u1EC7t S\u0129"
                    },
                    type: 'observance'
                },
                '08-19': {
                    name: {
                        en: 'August Revolution Commemoration Day',
                        vi: "Ng\xe0y c\xe1ch m\u1EA1ng Th\xe1ng T\xe1m"
                    },
                    type: 'observance'
                },
                '10-10': {
                    name: {
                        en: 'Capital Liberation Day',
                        vi: "Ng\xe0y gi\u1EA3i ph\xf3ng Th\u1EE7 \u0110\xf4"
                    },
                    type: 'observance'
                },
                '10-20': {
                    name: {
                        en: "Vietnamese Women's Day",
                        vi: "Ng\xe0y Ph\u1EE5 n\u1EEF Vi\u1EC7t Nam"
                    },
                    type: 'observance'
                },
                '11-20': {
                    name: {
                        en: "Vietnamese Teacher's Day",
                        vi: "Ng\xe0y Nh\xe0 gi\xe1o Vi\u1EC7t Nam"
                    },
                    type: 'observance'
                },
                '12-22': {
                    name: {
                        en: 'National Defence Day',
                        vi: "Ng\xe0y h\u1ED9i Qu\u1ED1c ph\xf2ng To\xe0n d\xe2n"
                    },
                    type: 'observance'
                },
                'vietnamese 1-0-5': {
                    name: {
                        en: "Victory of Ng\u1ECDc H\u1ED3i-\u0110\u1ED1ng \u0110a",
                        vi: "Chi\u1EBFn th\u1EAFng Ng\u1ECDc H\u1ED3i - \u0110\u1ED1ng \u0110a"
                    },
                    type: 'observance'
                },
                'vietnamese 1-0-15': {
                    name: {
                        en: 'Lantern Festival',
                        vi: "T\u1EBFt Nguy\xean Ti\xeau"
                    },
                    type: 'observance'
                },
                'vietnamese 4-0-15': {
                    name: {
                        en: "Buddha's Birthday",
                        vi: "L\u1EC5 Ph\u1EADt \u0111\u1EA3n"
                    },
                    type: 'observance'
                },
                'vietnamese 5-0-5': {
                    name: {
                        en: 'Mid-year Festival',
                        vi: "T\u1EBFt \u0110oan ng\u1ECD"
                    },
                    type: 'observance'
                },
                'vietnamese 7-0-15': {
                    name: {
                        en: 'Ghost Festival',
                        vi: "R\u1EB1m Th\xe1ng B\u1EA3y, Vu Lan"
                    },
                    type: 'observance'
                },
                'vietnamese 8-0-15': {
                    name: {
                        en: 'Mid-Autumn Festival',
                        vi: "T\u1EBFt Trung thu"
                    },
                    type: 'observance'
                },
                'vietnamese 12-0-23': {
                    name: {
                        en: 'Kitchen guardians',
                        vi: "\xd4ng T\xe1o ch\u1EA7u tr\u1EDDi"
                    },
                    type: 'observance'
                }
            }
        },
        VU: {
            names: {
                en: 'Vanuatu',
                fr: "R\xe9publique de Vanuatu"
            },
            langs: [
                'fr',
                'en',
                'bi'
            ],
            zones: [
                'Pacific/Efate'
            ],
            dayoff: 'sunday',
            days: {
                '01-01': {
                    _name: '01-01'
                },
                '02-21': {
                    name: "M\xe9moire du p\xe8re de l'ind\xe9pendance R\xe9v. Dr. W.H. Lini"
                },
                '02-22': {
                    _name: 'Public Holiday'
                },
                '03-05': {
                    name: "F\xeate des chefs coutumiers"
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '05-01': {
                    _name: '05-01'
                },
                'easter 39': {
                    _name: 'easter 39'
                },
                '07-24': {
                    name: "Journ\xe9e Mondiale des Enfants"
                },
                '07-30': {
                    _name: 'Independence Day'
                },
                '08-15': {
                    _name: '08-15'
                },
                '08-16': {
                    _name: 'Public Holiday'
                },
                '10-05': {
                    _name: 'Constitution Day'
                },
                '10-29': {
                    name: "Jour de l'Unit\xe9"
                },
                '12-25': {
                    _name: '12-25'
                },
                '12-26': {
                    name: "F\xeate de Famille"
                },
                '12-27': {
                    _name: 'Public Holiday'
                }
            }
        },
        XK: {
            names: {
                sq: "Republika e Kosov\xebs",
                sr: "\u0420\u0435\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041A\u043E\u0441\u043E\u0432\u043E",
                en: 'Kosovo'
            },
            langs: [
                'sq',
                'sr'
            ],
            zones: [
                'Europe/Belgrade'
            ],
            dayoff: 'sunday',
            days: {
                '01-01': {
                    _name: '01-01'
                },
                'julian 12-25': {
                    _name: 'julian 12-25'
                },
                '02-17': {
                    _name: 'Independence Day'
                },
                '04-09': {
                    _name: 'Constitution Day'
                },
                easter: {
                    _name: 'easter'
                },
                orthodox: {
                    _name: 'orthodox'
                },
                '05-01': {
                    _name: '05-01'
                },
                '05-09': {
                    _name: '05-09'
                },
                '12-25': {
                    _name: '12-25'
                },
                '1 Shawwal': {
                    _name: '1 Shawwal'
                },
                '10 Dhu al-Hijjah': {
                    _name: '10 Dhu al-Hijjah'
                }
            }
        },
        YT: {
            names: {
                fr: 'Mayotte',
                en: 'Mayotte'
            },
            langs: [
                'fr'
            ],
            zones: [
                'Africa/Nairobi'
            ],
            dayoff: 'sunday',
            _days: 'FR',
            days: {
                '04-27': {
                    _name: 'Abolition of Slavery'
                }
            }
        },
        ZA: {
            names: {
                en: 'South Africa'
            },
            dayoff: 'sunday',
            langs: [
                'en'
            ],
            zones: [
                'Africa/Johannesburg'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                'substitutes 01-01 if sunday then next monday': {
                    name: {
                        en: 'Public Holiday'
                    }
                },
                '03-21': {
                    name: {
                        en: 'Human Rights Day'
                    }
                },
                'substitutes 03-21 if sunday then next monday': {
                    name: {
                        en: 'Public Holiday'
                    }
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                easter: {
                    _name: 'easter',
                    type: 'observance'
                },
                'easter 1': {
                    _name: 'easter 1',
                    name: {
                        en: 'Family Day'
                    }
                },
                '04-27': {
                    name: {
                        en: 'Freedom Day'
                    }
                },
                'substitutes 04-27 if sunday then next monday': {
                    name: {
                        en: 'Public Holiday'
                    }
                },
                '05-01': {
                    _name: '05-01',
                    name: {
                        en: "Workers' Day"
                    }
                },
                'substitutes 05-01 if sunday then next monday': {
                    name: {
                        en: 'Public Holiday'
                    }
                },
                '2nd sunday in May': {
                    _name: 'Mothers Day',
                    type: 'observance'
                },
                '06-16': {
                    name: {
                        en: 'Youth Day'
                    }
                },
                'substitutes 06-16 if sunday then next monday': {
                    name: {
                        en: 'Public Holiday'
                    }
                },
                '3rd sunday in June': {
                    _name: 'Fathers Day',
                    type: 'observance'
                },
                '08-09': {
                    name: {
                        en: "National Women's Day"
                    }
                },
                'substitutes 08-09 if sunday then next monday': {
                    name: {
                        en: 'Public Holiday'
                    }
                },
                '07-18': {
                    name: {
                        en: 'Nelson Mandela Day'
                    },
                    type: 'observance'
                },
                '09-24': {
                    name: {
                        en: 'Heritage Day'
                    }
                },
                'substitutes 09-24 if sunday then next monday': {
                    name: {
                        en: 'Public Holiday'
                    }
                },
                '12-16': {
                    name: {
                        en: 'Day of Reconciliation'
                    }
                },
                'substitutes 12-16 if sunday then next monday': {
                    name: {
                        en: 'Public Holiday'
                    }
                },
                '12-25': {
                    _name: '12-25'
                },
                '12-26': {
                    _name: '12-26',
                    name: {
                        en: 'Day of Goodwill'
                    }
                },
                'substitutes 12-26 if sunday then next monday': {
                    name: {
                        en: 'Public Holiday'
                    }
                },
                '2023-12-15': {
                    name: {
                        en: 'Rugby World Cup Win Public Holiday'
                    }
                },
                '2024-05-29': {
                    name: {
                        en: 'Voting Day'
                    }
                }
            }
        },
        ZM: {
            names: {
                en: 'Zambia'
            },
            dayoff: 'sunday',
            langs: [
                'en'
            ],
            zones: [
                'Africa/Maputo'
            ],
            days: {
                '01-01 and if sunday then next monday': {
                    substitute: true,
                    _name: '01-01'
                },
                '03-09': {
                    name: {
                        en: "Women\u2019s Day"
                    }
                },
                '03-12 and if sunday then next monday': {
                    substitute: true,
                    name: {
                        en: 'Youth Day'
                    }
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '05-01 and if sunday then next monday': {
                    substitute: true,
                    _name: '05-01'
                },
                '05-25 and if sunday then next monday': {
                    substitute: true,
                    name: {
                        en: 'African Freedom Day'
                    }
                },
                '1st monday in July': {
                    name: {
                        en: "Heroes' Day"
                    }
                },
                'tuesday after 1st monday in July': {
                    name: {
                        en: 'Unity Day'
                    }
                },
                '1st monday in August': {
                    name: {
                        en: "Farmers' Day"
                    }
                },
                '2015-10-18': {
                    name: {
                        en: 'National day of Prayers'
                    }
                },
                '10-24 and if sunday then next monday': {
                    substitute: true,
                    _name: 'Independence Day'
                },
                '12-25 and if sunday then next monday': {
                    substitute: true,
                    _name: '12-25'
                }
            }
        },
        ZW: {
            names: {
                sn: 'Nyika yeZimbabwe',
                nd: 'iRiphabhuliki yeZimbabwe',
                xh: 'iRiphubliki eyeZimbabwe',
                kck: 'Nyika yeZimbabwe',
                en: 'Zimbabwe'
            },
            dayoff: 'sunday',
            langs: [
                'en'
            ],
            zones: [
                'Africa/Maputo'
            ],
            days: {
                '01-01': {
                    _name: '01-01'
                },
                'easter -2': {
                    _name: 'easter -2'
                },
                easter: {
                    _name: 'easter',
                    type: 'observance'
                },
                'easter 1': {
                    _name: 'easter 1'
                },
                '04-18': {
                    _name: 'Independence Day'
                },
                '05-01': {
                    _name: '05-01'
                },
                '05-25': {
                    name: {
                        en: 'Africa Day'
                    }
                },
                '2nd sunday in May': {
                    _name: 'Mothers Day',
                    type: 'observance'
                },
                '3rd sunday in June': {
                    _name: 'Fathers Day',
                    type: 'observance'
                },
                '2nd monday in August': {
                    name: {
                        en: "Heroes' Day"
                    }
                },
                '2nd tuesday in August': {
                    name: {
                        en: 'Defence Forces Day'
                    }
                },
                '12-22': {
                    name: {
                        en: 'Unity Day'
                    }
                },
                '12-25': {
                    _name: '12-25'
                },
                '12-26': {
                    _name: '12-26'
                }
            }
        }
    },
    names: {
        '01-01': {
            name: {
                en: "New Year's Day",
                am: "\u12A5\u1295\u1241\u1323\u1323\u123D",
                ar: "\u0639\u064A\u062F \u0631\u0623\u0633 \u0627\u0644\u0633\u0646\u0629",
                az: 'Yeni il',
                be: "\u041D\u043E\u0432\u044B \u0433\u043E\u0434",
                bg: "\u041D\u043E\u0432\u0430 \u0413\u043E\u0434\u0438\u043D\u0430",
                bs: 'Novogodisnji dan',
                ca: 'Any nou',
                cz: "Nov\xfd rok",
                da: "Nyt\xe5r",
                de: 'Neujahr',
                el: "\u03A0\u03C1\u03C9\u03C4\u03BF\u03C7\u03C1\u03BF\u03BD\u03B9\u03AC",
                es: "A\xf1o Nuevo",
                et: 'uusaasta',
                fi: "Uudenvuodenp\xe4iv\xe4",
                fil: 'Araw ng Bagong Taon',
                fo: "N\xfdggj\xe1rsdagur",
                fr: 'Nouvel An',
                ge: "\u10D0\u10EE\u10D0\u10DA\u10D8 \u10EC\u10D4\u10DA\u10D8",
                hr: 'Nova godina',
                hu: "\xdaj\xe9v",
                hy: "\u0531\u0574\u0561\u0576\u0578\u0580",
                id: 'Hari tahun baru',
                it: 'Capodanno',
                is: "N\xfd\xe1rsdagur",
                jp: "\u5143\u65E5",
                kl: 'ukiortaaq',
                ko: "\uC2E0\uC815",
                lb: 'Neijoerschdag',
                lt: 'Naujieji metai',
                lv: 'Jaunais Gads',
                mg: 'Taom-baovao',
                mk: "\u041D\u043E\u0432\u0430 \u0413\u043E\u0434\u0438\u043D\u0430",
                ms: 'Hari Tahun Baru',
                mt: 'L-Ewwel tas-Sena',
                nl: 'Nieuwjaar',
                no: "F\xf8rste nytt\xe5rsdag",
                pap: "A\xf1a Nobo",
                pl: 'Nowy Rok',
                pt: 'Ano Novo',
                ro: 'Anul nou',
                ru: "\u041D\u043E\u0432\u044B\u0439 \u0433\u043E\u0434",
                sl: 'Novo leto',
                sq: 'Viti i Ri',
                sr: "\u041D\u043E\u0432\u0430 \u0433\u043E\u0434\u0438\u043D\u0430",
                sv: "Ny\xe5rsdagen",
                sw: 'Mwaka mpya',
                th: "\u0E27\u0E31\u0E19\u0E02\u0E36\u0E49\u0E19\u0E1B\u0E35\u0E43\u0E2B\u0E21\u0E48",
                ti: "\u1213\u12F2\u123D \u12D3\u1218\u1275",
                tr: "Y\u0131lba\u015F\u0131",
                uk: "\u041D\u043E\u0432\u0438\u0439 \u0420\u0456\u043A",
                vi: "T\u1EBFt D\u01B0\u01A1ng l\u1ECBch",
                zh: "\u5143\u65E6"
            }
        },
        '01-06': {
            name: {
                en: 'Epiphany',
                am: "\u1265\u122D\u1210\u1290 \u1325\u121D\u1240\u1275",
                da: "\xc5benbaring",
                de: "Heilige Drei K\xf6nige",
                'de-ch': "Dreik\xf6nigstag",
                es: "D\xeda de los Reyes Magos",
                et: "kolmekuningap\xe4ev",
                fi: 'Loppiainen',
                fr: "l'\xc9piphanie",
                el: "\u0398\u03B5\u03BF\u03C6\u03AC\u03BD\u03B5\u03B9\u03B1",
                hr: 'Bogojavljenje, Sveta tri kralja',
                hu: "V\xedzkereszt",
                it: 'Befana',
                is: "\xderett\xe1ndinn",
                lb: "Dr\xe4ikinneksdag",
                nl: 'Driekoningen',
                mk: "\u0411\u043E\u0433\u043E\u0458\u0430\u0432\u043B\u0435\u043D\u0438\u0435",
                pl: "\u015Awi\u0119to Trzech Kr\xf3li",
                pt: 'Epifania do Senhor',
                sk: "Zjavenie P\xe1na",
                sv: 'Trettondedag jul',
                ti: "\u1325\u121D\u1240\u1275",
                vi: "L\u1EC5 Hi\u1EC3n Linh"
            }
        },
        '02-02': {
            name: {
                en: 'Candlemas',
                de: 'Lichtmess',
                hu: "Gyertyaszentel\u0151 Boldogasszony",
                lb: "Liichtm\xebssdag",
                nl: 'Lichtmis',
                vi: "L\u1EC5 \u0110\u1EE9c M\u1EB9 d\xe2ng Ch\xfaa Gi\xeasu trong \u0111\u1EC1n th\xe1nh"
            }
        },
        '02-14': {
            name: {
                en: "Valentine's Day",
                de: 'Valentinstag',
                fr: 'Saint-Valentin',
                hu: 'Valentin nap',
                lb: "V\xe4ltesdag",
                nl: 'Valentijnsdag',
                no: 'Valentinsdag',
                pl: 'Walentynki',
                pt: 'Dia dos Namorados',
                vi: "L\u1EC5 t\xecnh nh\xe2n"
            }
        },
        '03-08': {
            name: {
                en: "International Women's Day",
                az: "Qad\u0131nlar g\xfcn\xfc",
                be: "\u041Ci\u0436\u043D\u0430\u0440\u043E\u0434\u043D\u044B \u0436\u0430\u043D\u043E\u0447\u044B \u0434\u0437\u0435\u043D\u044C",
                bg: "\u0414\u0435\u043D \u043D\u0430 \u0436\u0435\u043D\u0430\u0442\u0430",
                de: 'Internationaler Frauentag',
                fr: "Journ\xe9e internationale des femmes",
                ge: "\u10E5\u10D0\u10DA\u10D7\u10D0 \u10E1\u10D0\u10D4\u10E0\u10D7\u10D0\u10E8\u10DD\u10E0\u10D8\u10E1\u10DD \u10D3\u10E6\u10D4",
                hu: "Nemzetk\xf6zi n\u0151nap",
                hy: "\u053F\u0561\u0576\u0561\u0576\u0581 \u057F\u0578\u0576",
                lb: 'Internationale Fraendag',
                nl: 'Internationale Vrouwendag',
                no: 'Kvinnedagen',
                pl: "Dzie\u0144 Kobiet",
                pt: 'Dia Internacional da Mulher',
                ro: 'Ziua Internationala a Femeii',
                ru: "\u041C\u0435\u0436\u0434\u0443\u043D\u0430\u0440\u043E\u0434\u043D\u044B\u0439 \u0436\u0435\u043D\u0441\u043A\u0438\u0439 \u0434\u0435\u043D\u044C",
                sl: "Mednarodni dan \u017Eena",
                uk: "\u041C\u0456\u0436\u043D\u0430\u0440\u043E\u0434\u043D\u0438\u0439 \u0436\u0456\u043D\u043E\u0447\u0438\u0439 \u0434\u0435\u043D\u044C",
                vi: "Qu\u1ED1c t\u1EBF Ph\u1EE5 n\u1EEF",
                zh: "\u56FD\u9645\u5987\u5973\u8282",
                ti: "\u1218\u12D3\u120D\u1272 \u12A3\u1290\u1235\u1272"
            }
        },
        '03-19': {
            name: {
                en: 'Saint Joseph',
                'de-at': 'Josefitag',
                de: 'Josefstag',
                es: "San Jos\xe9",
                it: 'San Giuseppe',
                mt: "San \u0120u\u017Cepp",
                nl: 'Hoogfeest van de Heilige Jozef',
                vi: "K\xednh Th\xe1nh Giuse"
            }
        },
        '04-01': {
            name: {
                en: "April Fools' Day",
                de: '1. April',
                hu: 'Bolondok napja',
                nl: '1 April',
                no: 'Aprilsnarr',
                sq: "Dita e G\xebnjeshtrave",
                vi: "C\xe1 th\xe1ng t\u01B0"
            }
        },
        '05-01': {
            name: {
                en: 'Labour Day',
                'en-us': 'Labor Day',
                ar: "\u064A\u0648\u0645 \u0627\u0644\u0639\u0645\u0627\u0644",
                be: "\u0414\u0437\u0435\u043D\u044C \u043F\u0440\u0430\u0446\u044B",
                bg: "\u0414\u0435\u043D \u043D\u0430 \u0442\u0440\u0443\u0434\u0430",
                bs: 'Radni dan',
                cz: "Sv\xe1tek pr\xe1ce",
                da: '1. maj',
                de: 'Tag der Arbeit',
                el: "\u0395\u03C1\u03B3\u03B1\u03C4\u03B9\u03BA\u03AE \u03A0\u03C1\u03C9\u03C4\u03BF\u03BC\u03B1\u03B3\u03B9\u03AC",
                es: "D\xeda del trabajador",
                et: "kevadp\xfcha",
                fi: 'Vappu',
                fil: 'Araw ng mga Manggagawa',
                fr: "F\xeate du travail",
                hr: 'Praznik rada',
                hu: "A munka \xfcnnepe",
                hy: "\u0531\u0577\u056D\u0561\u057F\u0561\u0576\u0584\u056B \u0585\u0580",
                id: 'Hari Buruh Internasional',
                it: 'Festa del Lavoro',
                is: "H\xe1t\xed\xf0isdagur Verkamanna",
                lb: "\xc9ischte Mee",
                lt: "Tarptautin\u0117 darbo diena",
                lv: "Darba sv\u0113tki",
                nl: 'Dag van de Arbeid',
                no: 'Arbeidernes dag',
                mg: "Fetin'ny asa",
                mk: "\u0414\u0435\u043D \u043D\u0430 \u0442\u0440\u0443\u0434\u043E\u0442",
                ms: 'Hari Pekerja',
                mt: "Jum il-\u0126addiem",
                pap: 'Dia di Obrero',
                pl: "\u015Awi\u0119to Pracy",
                pt: 'Dia do trabalhador',
                ro: 'Ziua muncii',
                sk: "Sviatok pr\xe1ce",
                sl: 'Praznik dela',
                sq: "Dita Nd\xebrkomb\xebtare e Punonj\xebsve",
                sr: "\u041F\u0440\u0430\u0437\u043D\u0438\u043A \u0440\u0430\u0434\u0430",
                sv: "F\xf6rsta Maj",
                ti: "\u12E8\u120B\u1265 \u12A0\u12F0\u122E\u127D \u1240\u1295",
                uk: "\u0414\u0435\u043D\u044C \u043C\u0456\u0436\u043D\u0430\u0440\u043E\u0434\u043D\u043E\u0457 \u0441\u043E\u043B\u0456\u0434\u0430\u0440\u043D\u043E\u0441\u0442\u0456 \u0442\u0440\u0443\u0434\u044F\u0449\u0438\u0445",
                vi: "Qu\u1ED1c t\u1EBF Lao \u0111\u1ED9ng",
                zh: "\u52B3\u52A8\u8282"
            }
        },
        '05-09': {
            name: {
                en: 'Europe Day',
                bg: "\u0414\u0435\u043D\u044F\u0442 \u043D\u0430 \u0415\u0432\u0440\u043E\u043F\u0430",
                cs: 'Den Evropy',
                da: 'Europadagen',
                de: 'Europatag',
                el: "\u0397\u03BC\u03AD\u03C1\u03B1 \u03C4\u03B7\u03C2 \u0395\u03C5\u03C1\u03CE\u03C0\u03B7\u03C2",
                es: "D\xeda de Europa",
                et: "Euroopa p\xe4ev",
                fi: "Eurooppa-p\xe4iv\xe4",
                fr: "Journ\xe9e de l'Europe",
                ga: "L\xe1 na hEorpa",
                hr: 'Dan Europe',
                hu: "Eur\xf3pa-nap",
                it: "Festa dell'Europa",
                lb: 'Europadag',
                ls: 'Dan Evrope',
                lt: 'Europos diena',
                lv: 'Eiropas diena',
                mt: 'Jum l-Ewropa',
                nl: 'Europadag',
                pl: "Dzie\u0144 Europy",
                pt: 'Dia da Europa',
                ro: 'Ziua Europei',
                sk: "De\u0148 Eur\xf3py",
                sq: "Dita e Evrop\xebs",
                sv: 'Europadagen'
            }
        },
        '06-29': {
            name: {
                en: 'Saints Peter and Paul',
                de: 'Peter und Paul',
                es: 'San Pedro y San Pablo',
                fr: 'Saint Pierre et Paul',
                it: 'Santi Pietro e Paolo',
                mt: 'L-Imnarja',
                nl: 'Hoogfeest van Petrus en Paulus',
                vi: "L\u1EC5 k\xednh Th\xe1nh Ph\xear\xf4"
            }
        },
        '08-15': {
            name: {
                en: 'Assumption',
                de: "Mari\xe4 Himmelfahrt",
                es: "Asunci\xf3n",
                fr: 'Assomption',
                el: "\u039A\u03BF\u03AF\u03BC\u03B7\u03C3\u03B7 \u03C4\u03B7\u03C2 \u0398\u03B5\u03BF\u03C4\u03CC\u03BA\u03BF\u03C5",
                hr: 'Velika Gospa',
                it: 'Ferragosto',
                lb: "L\xe9iffraw\xebschdag",
                lt: "\u017Dolin\u0117",
                mg: 'Asompsiona',
                mk: "\u0423\u0441\u043F\u0435\u043D\u0438\u0435 \u043D\u0430 \u041F\u0440\u0435\u0441\u0432\u0435\u0442\u0430 \u0411\u043E\u0433\u043E\u0440\u043E\u0434\u0438\u0446\u0430",
                mt: 'Santa Marija',
                nl: 'O.L.V. Hemelvaart',
                pl: "Wniebowzi\u0119cie Naj\u015Bwi\u0119tszej Maryi Panny",
                pt: "Assun\xe7\xe3o de Maria",
                ro: 'Adormirea Maicii Domnului',
                sl: 'Marijino vnebovzetje',
                sq: "Sh\xebn M\xebria e Gushtit",
                vi: "\u0110\u1EE9c M\u1EB9 L\xean Tr\u1EDDi"
            }
        },
        '11-01': {
            name: {
                en: "All Saints' Day",
                bs: "Dita e t\xeb gjith\xeb Shenjtor\xebve",
                de: 'Allerheiligen',
                es: 'Todos los Santos',
                fi: "Pyh\xe4inp\xe4iv\xe4",
                fil: "Und\xe1s; Todos los Santos; Araw ng mga Santo",
                fr: 'Toussaint',
                hr: 'Svi sveti',
                hu: 'Mindenszentek',
                it: 'Ognissanti',
                lb: 'Allerhellegen',
                lt: "Vis\u0173 \u0161vent\u0173j\u0173 diena",
                mg: "Fetin'ny olo-masina",
                mk: "\u041F\u0440\u0430\u0437\u043D\u0438\u043A\u043E\u0442 \u043D\u0430 \u0441\u0438\u0442\u0435 \u0441\u0432\u0435\u0442\u0446\u0438",
                nl: 'Allerheiligen',
                pl: "Wszystkich \u015Awi\u0119tych",
                pt: 'Todos os santos',
                sk: "Sviatok v\u0161etk\xfdch sv\xe4t\xfdch",
                sq: "T\xeb gjitha Saints",
                sr: "\u0421\u0432\u0438 \u0421\u0432\u0435\u0442\u0438",
                sv: 'Alla Helgons dag',
                vi: "L\u1EC5 C\xe1c Th\xe1nh"
            }
        },
        '11-02': {
            name: {
                en: "All Souls' Day",
                de: 'Allerseelen',
                es: "D\xeda de los Difuntos",
                et: "hingedep\xe4ev",
                fil: 'Araw ng mga Kaluluwa',
                fr: "F\xeate des morts",
                hr: "Du\u0161ni dan",
                hu: 'Halottak napja',
                lb: "Allers\xe9ilen",
                nl: 'Allerzielen',
                pt: 'Dia de Finados',
                vi: "L\u1EC5 C\xe1c \u0110\u1EB3ng",
                lt: "V\u0117lin\u0117s"
            }
        },
        '10-04': {
            name: {
                en: 'World Animal Day',
                de: 'Welttierschutztag',
                es: "D\xeda de los Animales",
                fr: "Journ\xe9e mondiale des Animaux",
                nl: 'Dierendag',
                pt: 'Dia Mundial dos Animais'
            }
        },
        '11-11': {
            name: {
                en: 'Saint Martin',
                de: 'Sankt Martin (Faschingsbeginn)',
                hu: "M\xe1rton nap",
                nl: 'Sint-Maarten',
                vi: "L\u1EC5 th\xe1nh Martin"
            }
        },
        '12-06': {
            name: {
                en: 'Saint Nicholas',
                de: 'Sankt Nikolaus',
                fr: 'Saint-Nicolas',
                hu: "Mikul\xe1s",
                lb: 'Niklosdag',
                nl: 'Sinterklaas',
                pl: "Miko\u0142ajki",
                vi: "Th\xe1nh Saint Nicholas"
            }
        },
        '12-07': {
            name: {
                it: "Sant'Ambrogio",
                en: 'Saint Ambrose',
                de: 'Ambrosius von Mailand',
                nl: 'Ambrosius van Milaan'
            }
        },
        '12-08': {
            name: {
                en: 'Immaculate Conception',
                de: "Mari\xe4 Empf\xe4ngnis",
                es: "La inmaculada concepci\xf3n",
                fr: "Immacul\xe9e Conception",
                it: 'Immacolata Concezione',
                mt: "Il-Kun\u010Bizzjoni",
                nl: 'Onbevlekte Ontvangenis van Maria',
                pt: "Imaculada Concei\xe7\xe3o"
            }
        },
        '12-24': {
            name: {
                en: 'Christmas Eve',
                bg: "\u0411\u044A\u0434\u043D\u0438 \u0432\u0435\u0447\u0435\u0440",
                bs: 'Badnji dan',
                cz: "\u0160t\u011Bdr\xfd den",
                da: 'Juleaften',
                de: 'Heiliger Abend',
                es: 'Nochebuena',
                et: "j\xf5ululaup\xe4ev",
                fo: "J\xf3laaftan",
                fi: 'Jouluaatto',
                fil: 'Bisperas ng Pasko',
                fr: "Veille de No\xebl",
                hr: 'Badnji dan',
                hu: 'Szenteste',
                is: "A\xf0fangadagur",
                kl: 'juulliaraq',
                lb: 'Hellegowend',
                lt: "\u0160v. K\u016B\u010Dios",
                lv: "Ziemassv\u0113tku vakars",
                ms: 'Hari Sebelum Krismas',
                nl: 'Kerstavond',
                no: 'Julaften',
                pl: "Wigilia Bo\u017Cego Narodzenia",
                pt: 'Noite de Natal',
                sk: "\u0160tedr\xfd de\u0148",
                sq: 'Nata e Krishtlindjes',
                sr: "\u0411\u0430\u0434\u045A\u0438 \u0434\u0430\u043D",
                sv: 'Julafton',
                vi: "\u0110\xeam Gi\xe1ng Sinh"
            }
        },
        '12-25': {
            name: {
                en: 'Christmas Day',
                am: "\u120D\u12F0\u1270-\u1208\u12A5\u130D\u12DA\u12A5\u1290/ \u1308\u1293",
                ar: "\u0639\u064A\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F \u0627\u0644\u0645\u062C\u064A\u062F",
                bg: "\u041A\u043E\u043B\u0435\u0434\u0430",
                bn: "\u09AC\u09A1\u09BC\u09A6\u09BF\u09A8",
                bs: "Bo\u017Ei\u0107",
                'de-at': 'Christtag',
                ca: 'Nadal',
                cz: "1. sv\xe1tek v\xe1no\u010Dn\xed",
                da: 'Juledag',
                de: 'Weihnachten',
                'de-ch': 'Weihnachtstag',
                el: "\u03A7\u03C1\u03B9\u03C3\u03C4\u03BF\u03CD\u03B3\u03B5\u03BD\u03BD\u03B1",
                es: 'Navidad',
                et: "esimene j\xf5ulup\xfcha",
                fi: "Joulup\xe4iv\xe4",
                fil: 'Araw ng Pasko',
                fo: "Fyrsti j\xf3ladagur",
                fr: "No\xebl",
                hr: "Bo\u017Ei\u0107",
                hu: "Kar\xe1csony",
                hy: "\u054D\u0578\u0582\u0580\u0562 \u053E\u0576\u0578\u0582\u0576\u0564",
                id: 'Hari Raya Natal',
                it: 'Natale',
                is: "J\xf3ladagur",
                jp: "\u30CE\u30A8\u30EB",
                kl: 'juullerujussuaq',
                ko: "\uAE30\uB3C5\uD0C4\uC2E0\uC77C",
                lb: "Chr\xebschtdag",
                lt: "\u0160v. Kal\u0117dos",
                lv: "Ziemassv\u0113tki",
                mg: 'Krismasy',
                mk: "\u041A\u0430\u0442\u043E\u043B\u0438\u0447\u043A\u0438 \u0411\u043E\u0436\u0438\u045C",
                ms: 'Hari Krismas',
                mt: 'Il-Milied',
                nl: 'Kerstmis',
                no: "F\xf8rste Juledag",
                pap: 'Dia Pasco di Nascimento',
                pl: "Pierwszy dzie\u0144 Bo\u017Cego Narodzenia",
                pt: 'Natal',
                ro: "Cr\u0103ciunul",
                ru: "\u0420\u043E\u0436\u0434\u0435\u0441\u0442\u0432\u043E \u0425\u0440\u0438\u0441\u0442\u043E\u0432\u043E",
                sk: "Prv\xfd sviatok viano\u010Dn\xfd",
                sl: "Bo\u017Ei\u010D",
                sq: 'Krishtlindja',
                sr: "\u041A\u0430\u0442\u043E\u043B\u0438\u0447\u043A\u0438 \u0411\u043E\u0436\u0438\u045B",
                sv: 'Juldagen',
                sw: 'Krismasi',
                ti: "\u120D\u12F0\u1275",
                uk: "\u0420\u0456\u0437\u0434\u0432\u043E \u0425\u0440\u0438\u0441\u0442\u043E\u0432\u0435",
                vi: "L\u1EC5 Gi\xe1ng Sinh",
                zh: "\u8056\u8A95\u7BC0"
            }
        },
        '12-26': {
            name: {
                en: 'Boxing Day',
                bg: "2-\u0440\u0438 \u0434\u0435\u043D \u043D\u0430 \u041A\u043E\u043B\u0435\u0434\u0430",
                cz: "2. sv\xe1tek v\xe1no\u010Dn\xed",
                da: 'Anden Juledag',
                de: '2. Weihnachtstag',
                'de-at': 'Stefanitag',
                'de-ch': 'Stephanstag',
                el: "\u0394\u03B5\u03CD\u03C4\u03B5\u03C1\u03B7 \u03BC\u03AD\u03C1\u03B1 \u03C4\u03C9\u03BD \u03A7\u03C1\u03B9\u03C3\u03C4\u03BF\u03C5\u03B3\u03AD\u03BD\u03BD\u03C9\u03BD",
                es: 'San Esteban',
                et: "teine j\xf5ulup\xfcha",
                fi: "2. joulup\xe4iv\xe4",
                fo: "Fyrsti gerandisdagur eftir j\xf3ladag",
                fr: "Lendemain de No\xebl",
                hr: 'Svetog Stjepana',
                hu: "Kar\xe1csony m\xe1snapja",
                it: 'Santo Stefano',
                is: "Annar \xed j\xf3lum",
                kl: 'juullip aappaa',
                lb: 'Stiefesdag',
                lt: "2. Kal\u0117d\u0173 diena",
                lv: "Otrie Ziemassv\u0113tki",
                nl: 'Tweede kerstdag',
                no: 'Andre juledag',
                pap: 'Di dos Dia Pasco di Nascimento',
                pl: "Drugi dzie\u0144 Bo\u017Cego Narodzenia",
                ro: "A doua zi de Cr\u0103ciun",
                sk: "Druh\xfd sviatok viano\u010Dn\xfd",
                sv: 'Annandag jul',
                vi: "Ng\xe0y t\u1EB7ng qu\xe0"
            }
        },
        '12-31': {
            name: {
                en: "New Year's Eve",
                da: "Nyt\xe5rsaften",
                de: 'Silvester',
                es: "Fin del A\xf1o",
                fi: 'Uudenvuodenaatto',
                fil: 'Bisperas ng Bagong Taon',
                fo: "N\xfdggj\xe1rsaftan",
                fr: 'Saint-Sylvestre',
                hu: 'Szilveszter',
                hy: "\u0546\u0578\u0580 \u057F\u0561\u0580\u057E\u0561 \u0563\u056B\u0577\u0565\u0580",
                is: "Gaml\xe1rsdagur",
                it: "Ultimo dell\u2019anno",
                jp: "\u5927\u6666\u65E5",
                lb: 'Silvester',
                lv: 'Vecgada vakars',
                nl: 'Oudejaarsavond',
                no: "Nytt\xe5rsaften",
                pl: 'Sylwester',
                pt: "V\xe9spera de Ano Novo",
                sv: "Ny\xe5rsafton",
                th: "\u0E27\u0E31\u0E19\u0E2A\u0E34\u0E49\u0E19\u0E1B\u0E35",
                vi: "\u0110\xeam giao th\u1EEBa"
            }
        },
        'easter -48': {
            name: {
                en: 'Shrove Monday',
                de: 'Rosenmontag',
                es: 'Carnaval',
                fr: 'Lundi de Carnaval',
                lb: "Fuesm\xe9indeg",
                nl: 'Carnavalsmaandag',
                pap: 'Dialuna di Carnaval',
                vi: "Ng\xe0y th\u1EE9 hai hoa h\u1ED3ng"
            }
        },
        'easter -47': {
            name: {
                en: 'Shrove Tuesday',
                es: 'Carnaval',
                de: 'Faschingsdienstag',
                hr: 'Pokladni utorak',
                hu: "H\xfashagy\xf3 kedd",
                nl: 'Vastenavond',
                pl: 'Ostatki',
                pt: 'Carnaval',
                vi: "Th\u1EE9 ba m\u1EADp b\xe9o"
            }
        },
        'easter -46': {
            name: {
                en: 'Ash Wednesday',
                de: 'Aschermittwoch',
                es: 'Miercoles de Ceniza',
                fr: 'Mercredi des Cendres',
                hu: "Hamvaz\xf3szerda",
                it: 'Ceneri',
                is: "\xd6skudagur",
                lb: "\xc4scherm\xebttwoch",
                nl: 'Aswoensdag',
                no: 'Askeonsdag',
                pl: "\u015Aroda Popielcowa",
                pt: 'Quarta-feira de Cinzas',
                sw: 'Jumatano ya Majivu',
                vi: "Th\u1EE9 t\u01B0 L\u1EC5 Tro"
            }
        },
        'easter -7': {
            name: {
                en: 'Palm Sunday',
                de: 'Palmsonntag',
                es: 'Domingo de Ramos',
                hu: "Vir\xe1gvas\xe1rnap",
                it: 'Domenica delle Palme',
                is: "P\xe1lmasunnudagur",
                lb: "P\xe4llemsonndeg",
                nl: 'Palmzondag',
                no: "Palmes\xf8ndag",
                pl: 'Niedziela Palmowa',
                vi: "Ch\xfaa nh\u1EADt L\u1EC5 L\xe1"
            }
        },
        'easter -3': {
            name: {
                en: 'Maundy Thursday',
                cz: "Zelen\xfd \u010Dtvrtek",
                da: "Sk\xe6rtorsdag",
                de: "Gr\xfcndonnerstag",
                es: 'Jueves Santo',
                fil: 'Huwebes Santo',
                fo: "Sk\xedrh\xf3sdagur",
                fr: 'Jeudi saint',
                is: "Sk\xedrdagur",
                it: "Gioved\xec santo",
                kl: 'sisamanngortoq illernartoq',
                lb: "Gr\xe9ngen Donneschdeg",
                nl: 'Witte Donderdag',
                no: "Skj\xe6rtorsdag",
                pl: 'Wielki Czwartek',
                sv: "Sk\xe4rtorsdagen",
                vi: "Th\u1EE9 n\u0103m Tu\u1EA7n Th\xe1nh"
            }
        },
        'easter -2': {
            name: {
                en: 'Good Friday',
                am: "\u1235\u1245\u1208\u1275",
                bg: "\u0420\u0430\u0437\u043F\u0435\u0442\u0438 \u043F\u0435\u0442\u044A\u043A",
                bs: 'Dobar petak',
                cz: "Velk\xfd p\xe1tek",
                da: 'Langfredag',
                de: 'Karfreitag',
                es: 'Viernes Santo',
                fi: "Pitk\xe4perjantai",
                fil: 'Biyernes Santo',
                fo: "Langafr\xedggjadagur",
                fr: 'Vendredi saint',
                el: "\u039C\u03B5\u03B3\u03AC\u03BB\u03B7 \u03A0\u03B1\u03C1\u03B1\u03C3\u03BA\u03B5\u03C5\u03AE",
                et: 'suur reede',
                ge: "\u10EC\u10D8\u10D7\u10D4\u10DA\u10D8 \u10DE\u10D0\u10E0\u10D0\u10E1\u10D9\u10D4\u10D5\u10D8",
                hr: 'Veliki petak',
                hu: "Nagyp\xe9ntek",
                id: 'Wafat Yesus Kristus',
                it: "Venerd\xec santo",
                is: "F\xf6studagurinn langi",
                kl: 'tallimanngornersuaq',
                lb: 'Karfreideg',
                lv: "Liel\u0101 Piektdiena",
                ms: 'Jumat Agung',
                mt: "Il-\u0120img\u0127a l-Kbira",
                nl: 'Goede Vrijdag',
                no: 'Langfredag',
                pap: 'Diabierna Santo',
                pl: "Wielki Pi\u0105tek",
                pt: 'Sexta-Feira Santa',
                ro: 'Vinerea Mare',
                sk: "Ve\u013Ekono\u010Dn\xfd piatok",
                sq: 'E Premtja e Madhe',
                sr: "\u041A\u0430\u0442\u043E\u043B\u0438\u0447\u043A\u0438 \u0412\u0435\u043B\u0438\u043A\u0438 \u043F\u0435\u0442\u0430\u043A",
                sv: "L\xe5ngfredagen",
                sw: 'Ijumaa Kuu',
                vi: "Th\u1EE9 s\xe1u Tu\u1EA7n Th\xe1nh",
                zh: "\u8036\u7A4C\u53D7\u96E3\u7BC0"
            }
        },
        'easter -1': {
            name: {
                en: 'Easter Saturday',
                cz: "B\xedl\xe1 sobota",
                de: 'Karsamstag',
                es: 'Sabado Santo',
                fil: 'Sabado de Gloria',
                fr: 'Samedi saint',
                ge: "\u10D3\u10D8\u10D3\u10D8 \u10E8\u10D0\u10D1\u10D0\u10D7\u10D8",
                hu: 'Nagyszombat',
                it: 'Sabado santo',
                lb: 'Karsamschdeg',
                nl: 'Dag voor Pasen',
                no: "P\xe5skeaften",
                pl: 'Wielka Sobota',
                sv: "P\xe5skafton",
                vi: "Th\u1EE9 b\u1EA3y Tu\u1EA7n Th\xe1nh",
                zh: "\u8036\u7A4C\u53D7\u96E3\u7BC0\u7FCC\u65E5"
            }
        },
        easter: {
            name: {
                en: 'Easter Sunday',
                am: "\u134B\u1232\u12AB",
                bg: "\u0412\u0435\u043B\u0438\u043A\u0434\u0435\u043D",
                bs: 'Vaskrs',
                cz: "Velikono\u010Dn\xed ned\u011Ble",
                da: "P\xe5skes\xf8ndag",
                de: 'Ostersonntag',
                el: "\u03A0\u03AC\u03C3\u03C7\u03B1",
                es: 'Pascua',
                et: "lihav\xf5tted",
                fi: "P\xe4\xe4si\xe4isp\xe4iv\xe4",
                fil: 'Pasko ng Pagkabuhay',
                fo: "P\xe1skadagur",
                fr: "P\xe2ques",
                ge: "\u10D0\u10E6\u10D3\u10D2\u10DD\u10DB\u10D0",
                hr: 'Uskrs',
                hu: "H\xfasv\xe9tvas\xe1rnap",
                it: 'Domenica di Pasqua',
                is: "P\xe1skadagur",
                kl: 'poorskip-ullua',
                lb: 'Ouschtersonndeg',
                lt: 'Velykos',
                lv: 'Lieldienas',
                nl: 'Pasen',
                no: "F\xf8rste p\xe5skedag",
                pap: 'Dia Pasco di Resureccion',
                pl: 'Niedziela Wielkanocna',
                pt: "P\xe1scoa",
                ro: "Pa\u0219tele",
                sk: "Ve\u013Ek\xe1 noc",
                sl: "Velika no\u010D",
                sq: "Pashk\xebt Katolike",
                sr: "\u041A\u0430\u0442\u043E\u043B\u0438\u0447\u043A\u0438 \u0412\u0430\u0441\u043A\u0440\u0441",
                sv: "P\xe5skdagen",
                sw: 'Pasaka',
                vi: "L\u1EC5 Ph\u1EE5c Sinh",
                zh: "\u590D\u6D3B\u8282"
            }
        },
        'easter 1': {
            name: {
                en: 'Easter Monday',
                bg: "\u0412\u0435\u043B\u0438\u043A\u0438 \u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A",
                bs: 'Uskrsni ponedjeljak',
                cz: "Velikono\u010Dn\xed pond\u011Bl\xed",
                da: "Anden p\xe5skedag",
                de: 'Ostermontag',
                el: "\u0394\u03B5\u03C5\u03C4\u03AD\u03C1\u03B1 \u03C4\u03BF\u03C5 \u03A0\u03AC\u03C3\u03C7\u03B1",
                es: 'Lunes de Pascua',
                fi: "2. p\xe4\xe4si\xe4isp\xe4iv\xe4",
                fo: "Annar p\xe1skadagur",
                fr: "Lundi de P\xe2ques",
                ge: "\u10D0\u10E6\u10D3\u10D2\u10DD\u10DB\u10D8\u10E1 \u10DD\u10E0\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8",
                hr: "Uskr\u0161nji ponedjeljak",
                hu: "H\xfasv\xe9th\xe9tf\u0151",
                it: "Luned\xec dell\u2019Angelo",
                is: "Annar \xed p\xe1skum",
                kl: 'poorskip-aappaa',
                lb: "Ouschterm\xe9indeg",
                lt: "Velyk\u0173 pirmadienis",
                lv: "Otr\u0101s Lieldienas",
                mg: "Alatsinain'ny Paska",
                mk: "\u0432\u0442\u043E\u0440\u0438\u043E\u0442 \u0434\u0435\u043D \u043D\u0430 \u0412\u0435\u043B\u0438\u0433\u0434\u0435\u043D",
                nl: 'Tweede paasdag',
                no: "Andre p\xe5skedag",
                pap: 'Di dos Dia Pasco di Resureccion',
                pl: "Drugi dzie\u0144 Wielkanocy",
                ro: 'A doua zi de Pasti',
                sk: "Ve\u013Ekono\u010Dn\xfd pondelok",
                sl: "Velikono\u010Dni ponedeljek",
                sr: "\u041A\u0430\u0442\u043E\u043B\u0438\u0447\u043A\u0438 \u0412\u0430\u0441\u043A\u0440\u0441\u043D\u0438 \u043F\u043E\u043D\u0435\u0434\u0435\u0459\u0430\u043A",
                sv: "Annandag p\xe5sk",
                sw: 'Jumatatu ya Pasaka',
                vi: "Th\u1EE9 hai ph\u1EE5c sinh",
                zh: "\u5FA9\u6D3B\u7BC0\u661F\u671F\u4E00"
            }
        },
        'easter 39': {
            name: {
                en: 'Ascension Day',
                da: 'Kristi Himmelfartsdag',
                de: 'Christi Himmelfahrt',
                es: "La Asunci\xf3n",
                fi: 'Helatorstai',
                fo: "Kristi Himmalsfer\xf0ardagur",
                fr: 'Ascension',
                id: 'Kenaikan Yesus Kristus',
                it: 'Ascensione',
                is: 'Uppstigningardagur',
                kl: 'qilaliarfik',
                mg: 'Andro niakarana',
                lb: 'Christi Himmelfaart',
                nl: 'O.L.H. Hemelvaart',
                no: 'Kristi himmelfartsdag',
                pap: 'Dia di Asuncion',
                ro: 'Ziua Eroilor',
                sv: "Kristi himmelf\xe4rds dag",
                vi: "L\u1EC5 Th\u0103ng Thi\xean"
            }
        },
        'easter 49': {
            name: {
                en: 'Pentecost',
                da: 'Pinsedag',
                de: 'Pfingstsonntag',
                el: "\u03A0\u03B5\u03BD\u03C4\u03B7\u03BA\u03BF\u03C3\u03C4\u03AE",
                es: "Pentecost\xe9s",
                et: "nelip\xfchade 1. p\xfcha",
                fi: "Helluntaip\xe4iv\xe4",
                fo: "Hv\xedtusunnudagur",
                fr: "Pentec\xf4te",
                hu: "P\xfcnk\xf6sdvas\xe1rnap",
                it: 'Pentecoste',
                is: "Hv\xedtasunnudagur",
                kl: 'piinsip ullua',
                lb: "P\xe4ischtsonndeg",
                nl: 'Pinksteren',
                no: "F\xf8rste pinsedag",
                mk: "\u0414\u0443\u0445\u043E\u0432\u0434\u0435\u043D",
                pl: "Zielone \u015Awi\u0105tki",
                ro: 'Rusaliile',
                sl: "Binko\u0161ti",
                sv: 'Pingstdagen',
                uk: "\u0422\u0440\u0456\u0439\u0446\u044F",
                vi: "L\u1EC5 Ch\xfaa Th\xe1nh Th\u1EA7n Hi\u1EC7n Xu\u1ED1ng"
            }
        },
        'easter 50': {
            name: {
                en: 'Whit Monday',
                da: 'Anden Pinsedag',
                de: 'Pfingstmontag',
                el: "\u0391\u03B3\u03AF\u03BF\u03C5 \u03A0\u03BD\u03B5\u03CD\u03BC\u03B1\u03C4\u03BF\u03C2",
                es: "Lunes de Pentecost\xe9s",
                fo: "Annar hv\xedtusunnudagur",
                fr: "Lundi de Pentec\xf4te",
                hu: "P\xfcnk\xf6sdh\xe9tf\u0151",
                is: "Annar \xed hv\xedtasunnu",
                it: "Luned\xec di Pentecoste",
                kl: 'piinsip aappaa',
                mg: "Alatsinain'ny Pentekosta",
                lb: "P\xe9ngschtm\xe9indeg",
                nl: 'Tweede pinksterdag',
                no: 'Andre pinsedag',
                ro: 'A doua zi de Rusalii',
                sv: 'Annandag pingst'
            }
        },
        'easter 60': {
            name: {
                en: 'Corpus Christi',
                de: 'Fronleichnam',
                es: 'Corpus Christi',
                fr: "la F\xeate-Dieu",
                it: 'Corpus Domini',
                hr: 'Tijelovo',
                nl: 'Sacramentsdag',
                pl: "Dzie\u0144 Bo\u017Cego Cia\u0142a",
                pt: 'Corpo de Deus',
                vi: "L\u1EC5 M\xecnh v\xe0 M\xe1u Th\xe1nh Ch\xfaa Kit\xf4"
            }
        },
        'julian 01-01': {
            name: {
                en: 'Orthodox New Year',
                bs: "Pravoslavni novogodi\u0161nji dan",
                hr: 'Pravoslavna Nova Godina',
                nl: 'Orthodox Nieuwjaar',
                sq: 'Viti i Ri Ortodoks',
                sr: "\u041F\u0440\u0430\u0432\u043E\u0441\u043B\u0430\u0432\u043D\u0430 \u041D\u043E\u0432\u0430 \u0433\u043E\u0434\u0438\u043D\u0430"
            }
        },
        'julian 12-24': {
            name: {
                en: 'Orthodox Christmas Eve',
                nl: 'Orthodoxe Kerstavond',
                mk: "\u0411\u0430\u0434\u043D\u0438\u043A",
                ti: "\u120D\u12F0\u1275"
            }
        },
        'julian 12-25': {
            name: {
                en: 'Orthodox Christmas',
                bs: "Pravoslavni Bo\u017Ei\u0107",
                hr: "Pravoslavni Bo\u017Ei\u0107",
                mk: "\u041F\u0440\u0432 \u0434\u0435\u043D \u0411\u043E\u0436\u0438\u043A",
                nl: 'Orthodoxe Kerstmis',
                ro: 'Craciun pe Rit Vechi',
                sq: 'Krishtlindjet Ortodokse',
                sr: "\u0411\u043E\u0436\u0438\u045B",
                uk: "\u0420\u0456\u0437\u0434\u0432\u043E"
            }
        },
        'orthodox -2': {
            name: {
                en: 'Orthodox Good Friday',
                mk: "\u0412\u0435\u043B\u0438\u043A\u0438 \u041F\u0435\u0442\u043E\u043A",
                nl: 'Orthodoxe Goede Vrijdag',
                sr: "\u0412\u0435\u043B\u0438\u043A\u0438 \u043F\u0435\u0442\u0430\u043A",
                ti: "\u12D3\u122D\u1262 \u1235\u1245\u1208\u1275"
            }
        },
        orthodox: {
            name: {
                en: 'Orthodox Easter',
                bs: 'Pravoslavni Vaskrs',
                hr: 'Pravoslavni Uskrs',
                mk: "\u041F\u0440\u0432 \u0434\u0435\u043D \u0412\u0435\u043B\u0438\u0433\u0434\u0435\u043D",
                nl: 'Orthodox Pasen',
                sq: "Pashk\xebt Ortodokse",
                sr: "\u0412\u0430\u0441\u043A\u0440\u0441",
                ti: "\u134B\u1232\u12AB",
                uk: "\u0412\u0435\u043B\u0438\u043A\u0434\u0435\u043D\u044C"
            }
        },
        'orthodox 1': {
            name: {
                en: 'Orthodox Easter Monday',
                mk: "\u0412\u0442\u043E\u0440 \u0434\u0435\u043D \u0412\u0435\u043B\u0438\u0433\u0434\u0435\u043D",
                nl: 'Orthodoxe Tweede Paasdag',
                sr: "\u0412\u0430\u0441\u043A\u0440\u0441\u043D\u0438 \u043F\u043E\u043D\u0435\u0434\u0435\u0459\u0430\u043A"
            }
        },
        '1 Muharram': {
            name: {
                en: 'Islamic New Year',
                ar: "\u0631\u0623\u0633 \u0627\u0644\u0633\u0646\u0629 \u0627\u0644\u0647\u062C\u0631\u064A\u0629",
                bs: "Nova hid\u017Eretska godina",
                fil: 'Unang Araw ng Muharram',
                fr: 'Nouvel an islamique',
                hr: "Nova hid\u017Eretska godina",
                id: 'Tahun Baru Islam',
                ms: 'Awal Muharram',
                nl: 'Islamitisch Nieuwjaar',
                sq: 'Viti i Ri hixhri'
            }
        },
        '10 Muharram': {
            name: {
                en: 'Day of Ashura',
                ar: "\u0639\u0627\u0634\u0648\u0631\u0627\u0621",
                bn: "\u0986\u09B6\u09C1\u09B0\u09BE",
                nl: 'De tiende dag (Asjoera)'
            }
        },
        '12 Rabi al-awwal': {
            name: {
                en: 'Birthday of Muhammad (Mawlid)',
                am: "\u1218\u12CD\u120A\u12F5",
                ar: "\u0627\u0644\u0645\u0648\u0644\u062F \u0627\u0644\u0646\u0628\u0648\u064A\u0651",
                bn: "\u0988\u09A6\u09C7 \u09AE\u09BF\u09B2\u09BE\u09A6\u09C1\u09A8\u09CD\u09A8\u09AC\u09C0",
                bs: 'Mevlud',
                fr: 'Mawlid',
                id: 'Maulid Nabi Muhammad',
                ms: 'Hari Keputeraan Nabi Muhammad S.A.W.',
                nl: 'Geboortedag Mohammed (Mawlid an-Nabi)',
                sq: 'Mevludi'
            }
        },
        '27 Rajab': {
            name: {
                en: "Laylat al-Mi'raj",
                ar: "\u0627\u0644\u0625\u0633\u0631\u0627\u0621 \u0648\u0627\u0644\u0645\u0639\u0631\u0627\u062C",
                bs: "Lejletul Mi'rad\u017E",
                id: 'Maulid Nabi Muhammad',
                ms: 'Israk dan Mikraj',
                nl: 'Hemelvaart Mohammed (Lailat-ul-Meraj)',
                sq: 'Nata e Miraxhit',
                tr: "Mira\xe7 Gecesi"
            }
        },
        '15 Shaban': {
            name: {
                en: "Laylat al-Bara'at",
                ar: "\u0644\u064A\u0644\u0629 \u0627\u0644\u0628\u0631\u0627\u0621\u0629",
                bs: 'Lejletul berat',
                nl: 'Nacht van de Lotsbezegeling (Lailat-ul-Baraat)',
                sq: 'Nata e Beratit'
            }
        },
        '1 Ramadan': {
            name: {
                en: 'First day of Ramadan',
                am: "\u1228\u1218\u12F3\u1295",
                ar: "\u0627\u0644\u064A\u0648\u0645 \u0627\u0644\u0623\u0648\u0644 \u0645\u0646 \u0631\u0645\u0636\u0627\u0646",
                bs: 'Prvi dan posta',
                ms: 'Awal Ramadan',
                nl: 'Eerste dag van Ramadan',
                sq: "Dita e par\xeb e agj\xebrimit"
            }
        },
        '17 Ramadan': {
            name: {
                en: 'Day of Nuzul Al-Quran',
                ms: 'Hari Nuzul Al-Quran'
            }
        },
        '23 Ramadan': {
            name: {
                en: 'Lailat al-Qadr'
            }
        },
        '27 Ramadan': {
            name: {
                en: 'Laylat al-Qadr',
                ar: "\u0644\u06CC\u0644\u0629 \u0627\u0644\u0642\u062F\u0631",
                bs: 'Lejletul kadr',
                nl: 'Waardevolle Nacht (Laylat al-Qadr)',
                sq: 'Nata e Kadrit'
            }
        },
        '1 Shawwal': {
            name: {
                en: 'End of Ramadan (Eid al-Fitr)',
                am: "\u12D2\u12F5 \u12A0\u120D \u1348\u1325\u122D",
                ar: "\u0639\u064A\u062F \u0627\u0644\u0641\u0637\u0631",
                az: "Ramazan Bayram\u0131",
                bn: "\u0988\u09A6\u09C1\u09B2 \u09AB\u09BF\u09A4\u09B0",
                bs: 'Ramazanski bajram',
                de: 'Zuckerfest',
                es: 'Fiesta del Eid Fitr',
                fa: "\uFECB\uFBFF\uFEAA \uFEB3\uFECC\uFBFF\uFEAA \uFED3\uFEC4\uFEAE",
                fil: 'Pagwawakas ng Ramadan',
                fr: "F\xeate de fin du Ramadan",
                hr: 'Ramazanski bajram',
                id: 'Hari Raya Idul Fitri',
                nl: 'Suikerfeest (Eid al-Fitr)',
                mk: "\u0420\u0430\u043C\u0430\u0437\u0430\u043D \u0411\u0430\u0458\u0440\u0430\u043C",
                ms: 'Hari Raya Aidil Fitri',
                sq: "Fit\xebr Bajrami",
                tr: "Ramazan Bayram\u0131",
                sr: "\u0420\u0430\u043C\u0430\u0437\u0430\u043D\u0441\u043A\u0438 \u0411\u0430\u0458\u0440\u0430\u043C",
                sw: 'Idd-ul-Fitr'
            }
        },
        '9 Dhu al-Hijjah': {
            name: {
                en: 'Arafat Day',
                ar: "\u064A\u0648\u0645 \u0639\u0631\u0641\u0629",
                es: 'Fiesta del Sacrificio-Eidul Adha',
                ms: 'Hari Arafah',
                nl: 'Dag van Arafat'
            }
        },
        '10 Dhu al-Hijjah': {
            name: {
                en: 'Feast of the Sacrifice (Eid al-Adha)',
                am: "\u12D2\u12F5 \u12A0\u120D \u12A0\u12F5\u1210",
                ar: "\u0639\u064A\u062F \u0627\u0644\u0623\u0636\u062D\u0649",
                az: "Qurban Bayram\u0131",
                bn: "\u0988\u09A6\u09C1\u09B2 \u0986\u09AF\u09B9\u09BE",
                bs: 'Kurbanski bajram',
                de: 'Opferfest',
                es: 'Fiesta del Sacrificio-Aid Al Adha',
                fa: "\uFECB\uFBFF\uFEAA \uFEB3\uFECC\uFBFF\uFEAA \uFED7\uFEAE\uFE91\uFE8E\u0646",
                fil: 'Eidul Adha',
                fr: "F\xeate du mouton",
                hr: 'Kurban-bajram',
                id: 'Hari Raya Idul Adha',
                nl: 'Offerfeest (Eid Al-Adha)',
                mk: "\u041A\u0443\u0440\u0431\u0430\u043D \u0411\u0430\u0458\u0440\u0430\u043C",
                ms: 'Hari Raya Haji',
                sq: 'Kurban Bajrami',
                tr: "Kurban Bayram\u0131",
                sr: "\u041A\u0443\u0440\u0431\u0430\u043D\u0441\u043A\u0438 \u0411\u0430\u0458\u0440\u0430\u043C",
                sw: 'Idd-ul-Azha'
            }
        },
        '15 Nisan': {
            name: {
                en: 'Pesach',
                bs: 'Pesah',
                de: 'Pessach',
                hr: "Pesa\u010D",
                nl: 'Pesach',
                sq: 'Pesach',
                sr: "\u041F\u0435\u0441\u0430\u0445"
            }
        },
        '1 Tishrei': {
            name: {
                en: 'Rosh Hashanah',
                bs: "Ro\u0161 Ha\u0161ana",
                de: 'Rosch Haschana',
                hr: "Ro\u0161 Ha\u0161ane",
                nl: 'Rosj Hasjana',
                sq: 'Rosh Hashanah',
                sr: "\u0420\u043E\u0448 \u0425\u0430\u0448\u0430\u043D\u0430"
            }
        },
        '10 Tishrei': {
            name: {
                en: 'Yom Kippur',
                bs: 'Jom Kipur',
                de: 'Jom Kippur',
                hr: 'Jom Kipur',
                mk: "\u0408\u043E\u043C \u041A\u0438\u043F\u0443\u0440",
                nl: 'Jom Kipoer',
                sq: 'Yom Kippur',
                sr: "\u0408\u043E\u043C \u041A\u0438\u043F\u0443\u0440"
            }
        },
        Deepavali: {
            name: {
                en: 'Deepavali',
                nl: 'Divali'
            }
        },
        Vesak: {
            name: {
                en: 'Vesak Day',
                id: 'Hari Raya Waisak',
                nl: 'Vesakha Puja',
                th: "\u0E27\u0E31\u0E19\u0E27\u0E34\u0E2A\u0E32\u0E02\u0E1A\u0E39\u0E0A\u0E32"
            }
        },
        Holi: {
            name: {
                en: 'Holi Phagwa',
                nl: 'Holifeest'
            }
        },
        Thaipusam: {
            name: {
                en: 'Thaipusam',
                ms: 'Hari Thaipusam'
            }
        },
        'Makha Bucha': {
            name: {
                en: 'Makha Bucha',
                nl: 'Magha Puja',
                th: "\u0E27\u0E31\u0E19\u0E21\u0E32\u0E06\u0E1A\u0E39\u0E0A\u0E32"
            }
        },
        'Asalha Puja': {
            name: {
                en: 'Asalha Puja',
                nl: 'Asalha Puja',
                th: "\u0E27\u0E31\u0E19\u0E2D\u0E32\u0E2A\u0E32\u0E2C\u0E2B\u0E1A\u0E39\u0E0A\u0E32"
            }
        },
        'Buddhist Lent': {
            name: {
                en: 'Buddhist Lent',
                nl: 'Vassa',
                th: "\u0E27\u0E31\u0E19\u0E40\u0E02\u0E49\u0E32\u0E1E\u0E23\u0E23\u0E29\u0E32"
            }
        },
        'Abolition of Slavery': {
            name: {
                en: 'Abolition of Slavery',
                fr: "Abolition de l\u2019esclavage",
                nl: 'Afschaffing van de slavernij',
                vi: "B\xe3i b\u1ECF ch\u1EBF \u0111\u1ED9 N\xf4 l\u1EC7"
            }
        },
        "Bu\xdf- und Bettag": {
            name: {
                de: "Bu\xdf- und Bettag",
                en: 'Day of Prayer and Repentance',
                nl: 'Dag van gebed en bekering'
            }
        },
        'Constitution Day': {
            name: {
                en: 'Constitution Day',
                da: 'Grundlovsdag',
                de: 'Tag der Verfassung',
                ca: "Dia de la Constituci\xf3",
                es: "D\xeda de la Constituci\xf3n",
                fil: 'Araw ng Saligang Batas',
                fo: "Grundl\xf3gardagur",
                hy: "\u054D\u0561\u0570\u0574\u0561\u0576\u0561\u0564\u0580\u0578\u0582\u0569\u0575\u0561\u0576 \u0585\u0580",
                jp: "\u61B2\u6CD5\u8A18\u5FF5\u65E5",
                ko: "\uC81C\uD5CC\uC808",
                nl: 'Dag van de Grondwet',
                no: 'Grunnlovsdagen',
                pt: "Dia da Constitui\xe7\xe3o",
                ro: "Ziua Constitu\u021Biei",
                sk: "De\u0148 \xdastavy",
                sq: "Dita e Kushtetut\xebs",
                uk: "\u0414\u0435\u043D\u044C \u041A\u043E\u043D\u0441\u0442\u0438\u0442\u0443\u0446\u0456\u0457",
                vi: "Ng\xe0y ph\xe1p lu\u1EADt"
            }
        },
        'Fathers Day': {
            name: {
                en: "Father's Day",
                et: "isadep\xe4ev",
                fi: "Is\xe4np\xe4iv\xe4",
                fr: "F\xeate des P\xe8res",
                lt: "T\u0117vo diena",
                nl: 'Vaderdag',
                pl: "Dzie\u0144 Ojca",
                pt: 'Dia dos Pais',
                no: 'Farsdag',
                sv: 'Fars dag',
                vi: "Ng\xe0y c\u1EE7a cha"
            }
        },
        'Independence Day': {
            name: {
                en: 'Independence Day',
                ar: "\u0639\u064A\u062F \u0627\u0644\u0627\u0633\u062A\u0642\u0644\u0627\u0644",
                be: "\u0414\u0437\u0435\u043D\u044C \u041D\u0435\u0437\u0430\u043B\u0435\u0436\u043D\u0430\u0441\u0446i",
                bg: "\u0414\u0435\u043D \u043D\u0430 \u043D\u0435\u0437\u0430\u0432\u0438\u0441\u0438\u043C\u043E\u0441\u0442\u0442\u0430",
                bs: 'Dan nezavisnosti',
                de: "Unabh\xe4ngigkeitstag",
                es: "D\xeda de la Independencia",
                et: "iseseisvusp\xe4ev",
                fi: "Itsen\xe4isyysp\xe4iv\xe4",
                fil: 'Araw ng Kalayaan',
                fr: "Jour de l'Ind\xe9pendance",
                hr: 'Dan neovisnosti',
                hy: "\u0531\u0576\u056F\u0561\u056D\u0578\u0582\u0569\u0575\u0561\u0576 \u0585\u0580",
                id: 'Hari Ulang Tahun Kemerdekaan Republik Indonesia',
                mk: "\u0414\u0435\u043D \u043D\u0430 \u043D\u0435\u0437\u0430\u0432\u0438\u0441\u043D\u043E\u0441\u0442\u0430",
                ms: 'Hari Kebangsaan',
                mt: 'Jum l-Indipendenza',
                nl: 'Onafhankelijkheidsdag',
                pl: "Narodowe \u015Awi\u0119to Niepodleg\u0142o\u015Bci",
                pt: "Dia da Independ\xeancia",
                ro: 'Ziua Independentei',
                sq: "Dita e Pavar\xebsis\xeb",
                sr: "\u0414\u0430\u043D \u043D\u0435\u0437\u0430\u0432\u0438\u0441\u043D\u043E\u0441\u0442\u0438",
                sv: "Sj\xe4lvst\xe4ndighetsdagen",
                sw: 'Siku ya uhuru',
                ti: "\u1218\u12D3\u120D\u1272 \u1293\u133D\u1290\u1275",
                uk: "\u0414\u0435\u043D\u044C \u041D\u0435\u0437\u0430\u043B\u0435\u0436\u043D\u043E\u0441\u0442\u0456",
                vi: "Ng\xe0y \u0110\u1ED9c l\u1EADp"
            }
        },
        'Liberation Day': {
            name: {
                en: 'Liberation Day',
                ar: "\u064A\u0648\u0645 \u0627\u0644\u062A\u062D\u0631\u064A\u0631",
                nl: 'Bevrijdingsdag',
                no: "Frigj\xf8ringsdagen",
                sq: "Dita e \xc7lirimit",
                vi: "Ng\xe0y Th\u1ED1ng nh\u1EA5t"
            }
        },
        'Mothers Day': {
            name: {
                en: "Mother's Day",
                cz: 'Den matek',
                da: 'Mors Dag',
                de: 'Muttertag',
                el: "\u0393\u03B9\u03BF\u03C1\u03C4\u03AE \u03C4\u03B7\u03C2 \u03BC\u03B7\u03C4\u03AD\u03C1\u03B1\u03C2",
                es: "D\xeda de la Madre",
                et: "emadep\xe4ev",
                fi: "\xc4itienp\xe4iv\xe4",
                fr: "F\xeate des M\xe8res",
                hr: "Maj\u010Din dan",
                hu: "Any\xe1k napja",
                hy: "\u0551\u0565\u0572\u0561\u057D\u057A\u0561\u0576\u0578\u0582\u0569\u0575\u0561\u0576 \u0566\u0578\u0570\u0565\u0580\u056B \u0570\u056B\u0577\u0561\u057F\u0561\u056F\u056B \u0585\u0580",
                is: "M\xe6\xf0radagurinn",
                it: 'Festa della mamma',
                lt: 'Motinos diena',
                lv: "M\u0101tes diena",
                nl: 'Moederdag',
                no: 'Morsdag',
                pt: "Dia das M\xe3es",
                pl: "Dzie\u0144 Matki",
                ro: 'Ziua Mamei',
                sq: "Dita e N\xebn\xebs",
                sv: 'Mors dag',
                vi: "Ng\xe0y c\u1EE7a m\u1EB9"
            }
        },
        'National Holiday': {
            name: {
                en: 'National Holiday',
                de: 'Nationalfeiertag',
                es: 'Fiesta Nacional',
                fr: "F\xeate nationale",
                hu: "Nemzeti \xfcnnep",
                el: "\u03B5\u03B8\u03BD\u03B9\u03BA\u03AE \u03B5\u03C0\u03AD\u03C4\u03B5\u03B9\u03BF\u03C2",
                lb: 'Nationalfeierdag',
                nl: 'Nationale feestdag',
                vi: "Qu\u1ED1c L\u1EC5"
            }
        },
        'Public Holiday': {
            name: {
                en: 'Public Holiday',
                fr: "Jour f\xe9ri\xe9 l\xe9gaux",
                nl: 'Wettelijke feestdag',
                pt: "Feriado Obrigat\xf3rio",
                vi: "Ngh\u1EC9 l\u1EC5 To\xe0n Qu\u1ED1c"
            }
        },
        'Reformation Day': {
            name: {
                en: 'Reformation Day',
                de: 'Reformationstag',
                es: "D\xeda Nacional de las Iglesias Evang\xe9licas y Protestantes",
                nl: 'Hervormingsdag',
                vi: "Kh\xe1ng C\xe1ch"
            }
        },
        'Revolution Day': {
            name: {
                en: 'Revolution Day',
                ar: "\u064A\u0648\u0645 \u0627\u0644\u062B\u0648\u0631\u0629",
                es: "D\xeda de la Revoluci\xf3n",
                nl: 'Dag van de Revolutie',
                ti: "\u1263\u1215\u1272 \u1218\u1235\u12A8\u1228\u121D",
                vi: "T\u1ED5ng kh\u1EDFi ngh\u0129a"
            }
        },
        'Bridge Day': {
            name: {
                en: 'Bridge Day',
                es: "Feriado Puente Tur\xedstico"
            }
        },
        substitutes: {
            name: {
                en: 'substitute day',
                az: "\u0259v\u0259z g\xfcn",
                bs: 'zamjena dan',
                de: 'Ersatztag',
                es: "d\xeda sustituto",
                fr: 'jour substitut',
                hr: 'zamjena dan',
                jp: "\u632F\u66FF\u4F11\u65E5",
                lv: "aizst\u0101j\u0113js diena",
                mk: "\u0437\u0430\u043C\u0435\u043D\u0435\u0442 \u0434\u0435\u043D",
                nl: 'substituut',
                sq: "dit\xeb z\xebvend\xebsuese",
                sr: "\u0437\u0430\u043C\u0435\u043D\u0430 \u0434\u0430\u043D",
                uk: "\u0437\u0430\u043C\u0456\u043D\u0438\u0442\u0438 \u0434\u0435\u043D\u044C",
                vi: "ng\xe0y thay th\u1EBF",
                zh: "\u66F4\u6362\u65E5"
            }
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gBKRn":[function(require,module,exports,__globalThis) {
// This file is generated automatically by `scripts/build/indices.ts`. Please, don't change it.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "add", function() {
    return 0, _indexJsDefault.default;
});
parcelHelpers.export(exports, "addBusinessDays", function() {
    return 0, _indexJsDefault1.default;
});
parcelHelpers.export(exports, "addDays", function() {
    return 0, _indexJsDefault2.default;
});
parcelHelpers.export(exports, "addHours", function() {
    return 0, _indexJsDefault3.default;
});
parcelHelpers.export(exports, "addISOWeekYears", function() {
    return 0, _indexJsDefault4.default;
});
parcelHelpers.export(exports, "addMilliseconds", function() {
    return 0, _indexJsDefault5.default;
});
parcelHelpers.export(exports, "addMinutes", function() {
    return 0, _indexJsDefault6.default;
});
parcelHelpers.export(exports, "addMonths", function() {
    return 0, _indexJsDefault7.default;
});
parcelHelpers.export(exports, "addQuarters", function() {
    return 0, _indexJsDefault8.default;
});
parcelHelpers.export(exports, "addSeconds", function() {
    return 0, _indexJsDefault9.default;
});
parcelHelpers.export(exports, "addWeeks", function() {
    return 0, _indexJsDefault10.default;
});
parcelHelpers.export(exports, "addYears", function() {
    return 0, _indexJsDefault11.default;
});
parcelHelpers.export(exports, "areIntervalsOverlapping", function() {
    return 0, _indexJsDefault12.default;
});
parcelHelpers.export(exports, "clamp", function() {
    return 0, _indexJsDefault13.default;
});
parcelHelpers.export(exports, "closestIndexTo", function() {
    return 0, _indexJsDefault14.default;
});
parcelHelpers.export(exports, "closestTo", function() {
    return 0, _indexJsDefault15.default;
});
parcelHelpers.export(exports, "compareAsc", function() {
    return 0, _indexJsDefault16.default;
});
parcelHelpers.export(exports, "compareDesc", function() {
    return 0, _indexJsDefault17.default;
});
parcelHelpers.export(exports, "daysToWeeks", function() {
    return 0, _indexJsDefault18.default;
});
parcelHelpers.export(exports, "differenceInBusinessDays", function() {
    return 0, _indexJsDefault19.default;
});
parcelHelpers.export(exports, "differenceInCalendarDays", function() {
    return 0, _indexJsDefault20.default;
});
parcelHelpers.export(exports, "differenceInCalendarISOWeekYears", function() {
    return 0, _indexJsDefault21.default;
});
parcelHelpers.export(exports, "differenceInCalendarISOWeeks", function() {
    return 0, _indexJsDefault22.default;
});
parcelHelpers.export(exports, "differenceInCalendarMonths", function() {
    return 0, _indexJsDefault23.default;
});
parcelHelpers.export(exports, "differenceInCalendarQuarters", function() {
    return 0, _indexJsDefault24.default;
});
parcelHelpers.export(exports, "differenceInCalendarWeeks", function() {
    return 0, _indexJsDefault25.default;
});
parcelHelpers.export(exports, "differenceInCalendarYears", function() {
    return 0, _indexJsDefault26.default;
});
parcelHelpers.export(exports, "differenceInDays", function() {
    return 0, _indexJsDefault27.default;
});
parcelHelpers.export(exports, "differenceInHours", function() {
    return 0, _indexJsDefault28.default;
});
parcelHelpers.export(exports, "differenceInISOWeekYears", function() {
    return 0, _indexJsDefault29.default;
});
parcelHelpers.export(exports, "differenceInMilliseconds", function() {
    return 0, _indexJsDefault30.default;
});
parcelHelpers.export(exports, "differenceInMinutes", function() {
    return 0, _indexJsDefault31.default;
});
parcelHelpers.export(exports, "differenceInMonths", function() {
    return 0, _indexJsDefault32.default;
});
parcelHelpers.export(exports, "differenceInQuarters", function() {
    return 0, _indexJsDefault33.default;
});
parcelHelpers.export(exports, "differenceInSeconds", function() {
    return 0, _indexJsDefault34.default;
});
parcelHelpers.export(exports, "differenceInWeeks", function() {
    return 0, _indexJsDefault35.default;
});
parcelHelpers.export(exports, "differenceInYears", function() {
    return 0, _indexJsDefault36.default;
});
parcelHelpers.export(exports, "eachDayOfInterval", function() {
    return 0, _indexJsDefault37.default;
});
parcelHelpers.export(exports, "eachHourOfInterval", function() {
    return 0, _indexJsDefault38.default;
});
parcelHelpers.export(exports, "eachMinuteOfInterval", function() {
    return 0, _indexJsDefault39.default;
});
parcelHelpers.export(exports, "eachMonthOfInterval", function() {
    return 0, _indexJsDefault40.default;
});
parcelHelpers.export(exports, "eachQuarterOfInterval", function() {
    return 0, _indexJsDefault41.default;
});
parcelHelpers.export(exports, "eachWeekOfInterval", function() {
    return 0, _indexJsDefault42.default;
});
parcelHelpers.export(exports, "eachWeekendOfInterval", function() {
    return 0, _indexJsDefault43.default;
});
parcelHelpers.export(exports, "eachWeekendOfMonth", function() {
    return 0, _indexJsDefault44.default;
});
parcelHelpers.export(exports, "eachWeekendOfYear", function() {
    return 0, _indexJsDefault45.default;
});
parcelHelpers.export(exports, "eachYearOfInterval", function() {
    return 0, _indexJsDefault46.default;
});
parcelHelpers.export(exports, "endOfDay", function() {
    return 0, _indexJsDefault47.default;
});
parcelHelpers.export(exports, "endOfDecade", function() {
    return 0, _indexJsDefault48.default;
});
parcelHelpers.export(exports, "endOfHour", function() {
    return 0, _indexJsDefault49.default;
});
parcelHelpers.export(exports, "endOfISOWeek", function() {
    return 0, _indexJsDefault50.default;
});
parcelHelpers.export(exports, "endOfISOWeekYear", function() {
    return 0, _indexJsDefault51.default;
});
parcelHelpers.export(exports, "endOfMinute", function() {
    return 0, _indexJsDefault52.default;
});
parcelHelpers.export(exports, "endOfMonth", function() {
    return 0, _indexJsDefault53.default;
});
parcelHelpers.export(exports, "endOfQuarter", function() {
    return 0, _indexJsDefault54.default;
});
parcelHelpers.export(exports, "endOfSecond", function() {
    return 0, _indexJsDefault55.default;
});
parcelHelpers.export(exports, "endOfToday", function() {
    return 0, _indexJsDefault56.default;
});
parcelHelpers.export(exports, "endOfTomorrow", function() {
    return 0, _indexJsDefault57.default;
});
parcelHelpers.export(exports, "endOfWeek", function() {
    return 0, _indexJsDefault58.default;
});
parcelHelpers.export(exports, "endOfYear", function() {
    return 0, _indexJsDefault59.default;
});
parcelHelpers.export(exports, "endOfYesterday", function() {
    return 0, _indexJsDefault60.default;
});
parcelHelpers.export(exports, "format", function() {
    return 0, _indexJsDefault61.default;
});
parcelHelpers.export(exports, "formatDistance", function() {
    return 0, _indexJsDefault62.default;
});
parcelHelpers.export(exports, "formatDistanceStrict", function() {
    return 0, _indexJsDefault63.default;
});
parcelHelpers.export(exports, "formatDistanceToNow", function() {
    return 0, _indexJsDefault64.default;
});
parcelHelpers.export(exports, "formatDistanceToNowStrict", function() {
    return 0, _indexJsDefault65.default;
});
parcelHelpers.export(exports, "formatDuration", function() {
    return 0, _indexJsDefault66.default;
});
parcelHelpers.export(exports, "formatISO", function() {
    return 0, _indexJsDefault67.default;
});
parcelHelpers.export(exports, "formatISO9075", function() {
    return 0, _indexJsDefault68.default;
});
parcelHelpers.export(exports, "formatISODuration", function() {
    return 0, _indexJsDefault69.default;
});
parcelHelpers.export(exports, "formatRFC3339", function() {
    return 0, _indexJsDefault70.default;
});
parcelHelpers.export(exports, "formatRFC7231", function() {
    return 0, _indexJsDefault71.default;
});
parcelHelpers.export(exports, "formatRelative", function() {
    return 0, _indexJsDefault72.default;
});
parcelHelpers.export(exports, "fromUnixTime", function() {
    return 0, _indexJsDefault73.default;
});
parcelHelpers.export(exports, "getDate", function() {
    return 0, _indexJsDefault74.default;
});
parcelHelpers.export(exports, "getDay", function() {
    return 0, _indexJsDefault75.default;
});
parcelHelpers.export(exports, "getDayOfYear", function() {
    return 0, _indexJsDefault76.default;
});
parcelHelpers.export(exports, "getDaysInMonth", function() {
    return 0, _indexJsDefault77.default;
});
parcelHelpers.export(exports, "getDaysInYear", function() {
    return 0, _indexJsDefault78.default;
});
parcelHelpers.export(exports, "getDecade", function() {
    return 0, _indexJsDefault79.default;
});
parcelHelpers.export(exports, "getDefaultOptions", function() {
    return 0, _indexJsDefault80.default;
});
parcelHelpers.export(exports, "getHours", function() {
    return 0, _indexJsDefault81.default;
});
parcelHelpers.export(exports, "getISODay", function() {
    return 0, _indexJsDefault82.default;
});
parcelHelpers.export(exports, "getISOWeek", function() {
    return 0, _indexJsDefault83.default;
});
parcelHelpers.export(exports, "getISOWeekYear", function() {
    return 0, _indexJsDefault84.default;
});
parcelHelpers.export(exports, "getISOWeeksInYear", function() {
    return 0, _indexJsDefault85.default;
});
parcelHelpers.export(exports, "getMilliseconds", function() {
    return 0, _indexJsDefault86.default;
});
parcelHelpers.export(exports, "getMinutes", function() {
    return 0, _indexJsDefault87.default;
});
parcelHelpers.export(exports, "getMonth", function() {
    return 0, _indexJsDefault88.default;
});
parcelHelpers.export(exports, "getOverlappingDaysInIntervals", function() {
    return 0, _indexJsDefault89.default;
});
parcelHelpers.export(exports, "getQuarter", function() {
    return 0, _indexJsDefault90.default;
});
parcelHelpers.export(exports, "getSeconds", function() {
    return 0, _indexJsDefault91.default;
});
parcelHelpers.export(exports, "getTime", function() {
    return 0, _indexJsDefault92.default;
});
parcelHelpers.export(exports, "getUnixTime", function() {
    return 0, _indexJsDefault93.default;
});
parcelHelpers.export(exports, "getWeek", function() {
    return 0, _indexJsDefault94.default;
});
parcelHelpers.export(exports, "getWeekOfMonth", function() {
    return 0, _indexJsDefault95.default;
});
parcelHelpers.export(exports, "getWeekYear", function() {
    return 0, _indexJsDefault96.default;
});
parcelHelpers.export(exports, "getWeeksInMonth", function() {
    return 0, _indexJsDefault97.default;
});
parcelHelpers.export(exports, "getYear", function() {
    return 0, _indexJsDefault98.default;
});
parcelHelpers.export(exports, "hoursToMilliseconds", function() {
    return 0, _indexJsDefault99.default;
});
parcelHelpers.export(exports, "hoursToMinutes", function() {
    return 0, _indexJsDefault100.default;
});
parcelHelpers.export(exports, "hoursToSeconds", function() {
    return 0, _indexJsDefault101.default;
});
parcelHelpers.export(exports, "intervalToDuration", function() {
    return 0, _indexJsDefault102.default;
});
parcelHelpers.export(exports, "intlFormat", function() {
    return 0, _indexJsDefault103.default;
});
parcelHelpers.export(exports, "intlFormatDistance", function() {
    return 0, _indexJsDefault104.default;
});
parcelHelpers.export(exports, "isAfter", function() {
    return 0, _indexJsDefault105.default;
});
parcelHelpers.export(exports, "isBefore", function() {
    return 0, _indexJsDefault106.default;
});
parcelHelpers.export(exports, "isDate", function() {
    return 0, _indexJsDefault107.default;
});
parcelHelpers.export(exports, "isEqual", function() {
    return 0, _indexJsDefault108.default;
});
parcelHelpers.export(exports, "isExists", function() {
    return 0, _indexJsDefault109.default;
});
parcelHelpers.export(exports, "isFirstDayOfMonth", function() {
    return 0, _indexJsDefault110.default;
});
parcelHelpers.export(exports, "isFriday", function() {
    return 0, _indexJsDefault111.default;
});
parcelHelpers.export(exports, "isFuture", function() {
    return 0, _indexJsDefault112.default;
});
parcelHelpers.export(exports, "isLastDayOfMonth", function() {
    return 0, _indexJsDefault113.default;
});
parcelHelpers.export(exports, "isLeapYear", function() {
    return 0, _indexJsDefault114.default;
});
parcelHelpers.export(exports, "isMatch", function() {
    return 0, _indexJsDefault115.default;
});
parcelHelpers.export(exports, "isMonday", function() {
    return 0, _indexJsDefault116.default;
});
parcelHelpers.export(exports, "isPast", function() {
    return 0, _indexJsDefault117.default;
});
parcelHelpers.export(exports, "isSameDay", function() {
    return 0, _indexJsDefault118.default;
});
parcelHelpers.export(exports, "isSameHour", function() {
    return 0, _indexJsDefault119.default;
});
parcelHelpers.export(exports, "isSameISOWeek", function() {
    return 0, _indexJsDefault120.default;
});
parcelHelpers.export(exports, "isSameISOWeekYear", function() {
    return 0, _indexJsDefault121.default;
});
parcelHelpers.export(exports, "isSameMinute", function() {
    return 0, _indexJsDefault122.default;
});
parcelHelpers.export(exports, "isSameMonth", function() {
    return 0, _indexJsDefault123.default;
});
parcelHelpers.export(exports, "isSameQuarter", function() {
    return 0, _indexJsDefault124.default;
});
parcelHelpers.export(exports, "isSameSecond", function() {
    return 0, _indexJsDefault125.default;
});
parcelHelpers.export(exports, "isSameWeek", function() {
    return 0, _indexJsDefault126.default;
});
parcelHelpers.export(exports, "isSameYear", function() {
    return 0, _indexJsDefault127.default;
});
parcelHelpers.export(exports, "isSaturday", function() {
    return 0, _indexJsDefault128.default;
});
parcelHelpers.export(exports, "isSunday", function() {
    return 0, _indexJsDefault129.default;
});
parcelHelpers.export(exports, "isThisHour", function() {
    return 0, _indexJsDefault130.default;
});
parcelHelpers.export(exports, "isThisISOWeek", function() {
    return 0, _indexJsDefault131.default;
});
parcelHelpers.export(exports, "isThisMinute", function() {
    return 0, _indexJsDefault132.default;
});
parcelHelpers.export(exports, "isThisMonth", function() {
    return 0, _indexJsDefault133.default;
});
parcelHelpers.export(exports, "isThisQuarter", function() {
    return 0, _indexJsDefault134.default;
});
parcelHelpers.export(exports, "isThisSecond", function() {
    return 0, _indexJsDefault135.default;
});
parcelHelpers.export(exports, "isThisWeek", function() {
    return 0, _indexJsDefault136.default;
});
parcelHelpers.export(exports, "isThisYear", function() {
    return 0, _indexJsDefault137.default;
});
parcelHelpers.export(exports, "isThursday", function() {
    return 0, _indexJsDefault138.default;
});
parcelHelpers.export(exports, "isToday", function() {
    return 0, _indexJsDefault139.default;
});
parcelHelpers.export(exports, "isTomorrow", function() {
    return 0, _indexJsDefault140.default;
});
parcelHelpers.export(exports, "isTuesday", function() {
    return 0, _indexJsDefault141.default;
});
parcelHelpers.export(exports, "isValid", function() {
    return 0, _indexJsDefault142.default;
});
parcelHelpers.export(exports, "isWednesday", function() {
    return 0, _indexJsDefault143.default;
});
parcelHelpers.export(exports, "isWeekend", function() {
    return 0, _indexJsDefault144.default;
});
parcelHelpers.export(exports, "isWithinInterval", function() {
    return 0, _indexJsDefault145.default;
});
parcelHelpers.export(exports, "isYesterday", function() {
    return 0, _indexJsDefault146.default;
});
parcelHelpers.export(exports, "lastDayOfDecade", function() {
    return 0, _indexJsDefault147.default;
});
parcelHelpers.export(exports, "lastDayOfISOWeek", function() {
    return 0, _indexJsDefault148.default;
});
parcelHelpers.export(exports, "lastDayOfISOWeekYear", function() {
    return 0, _indexJsDefault149.default;
});
parcelHelpers.export(exports, "lastDayOfMonth", function() {
    return 0, _indexJsDefault150.default;
});
parcelHelpers.export(exports, "lastDayOfQuarter", function() {
    return 0, _indexJsDefault151.default;
});
parcelHelpers.export(exports, "lastDayOfWeek", function() {
    return 0, _indexJsDefault152.default;
});
parcelHelpers.export(exports, "lastDayOfYear", function() {
    return 0, _indexJsDefault153.default;
});
parcelHelpers.export(exports, "lightFormat", function() {
    return 0, _indexJsDefault154.default;
});
parcelHelpers.export(exports, "max", function() {
    return 0, _indexJsDefault155.default;
});
parcelHelpers.export(exports, "milliseconds", function() {
    return 0, _indexJsDefault156.default;
});
parcelHelpers.export(exports, "millisecondsToHours", function() {
    return 0, _indexJsDefault157.default;
});
parcelHelpers.export(exports, "millisecondsToMinutes", function() {
    return 0, _indexJsDefault158.default;
});
parcelHelpers.export(exports, "millisecondsToSeconds", function() {
    return 0, _indexJsDefault159.default;
});
parcelHelpers.export(exports, "min", function() {
    return 0, _indexJsDefault160.default;
});
parcelHelpers.export(exports, "minutesToHours", function() {
    return 0, _indexJsDefault161.default;
});
parcelHelpers.export(exports, "minutesToMilliseconds", function() {
    return 0, _indexJsDefault162.default;
});
parcelHelpers.export(exports, "minutesToSeconds", function() {
    return 0, _indexJsDefault163.default;
});
parcelHelpers.export(exports, "monthsToQuarters", function() {
    return 0, _indexJsDefault164.default;
});
parcelHelpers.export(exports, "monthsToYears", function() {
    return 0, _indexJsDefault165.default;
});
parcelHelpers.export(exports, "nextDay", function() {
    return 0, _indexJsDefault166.default;
});
parcelHelpers.export(exports, "nextFriday", function() {
    return 0, _indexJsDefault167.default;
});
parcelHelpers.export(exports, "nextMonday", function() {
    return 0, _indexJsDefault168.default;
});
parcelHelpers.export(exports, "nextSaturday", function() {
    return 0, _indexJsDefault169.default;
});
parcelHelpers.export(exports, "nextSunday", function() {
    return 0, _indexJsDefault170.default;
});
parcelHelpers.export(exports, "nextThursday", function() {
    return 0, _indexJsDefault171.default;
});
parcelHelpers.export(exports, "nextTuesday", function() {
    return 0, _indexJsDefault172.default;
});
parcelHelpers.export(exports, "nextWednesday", function() {
    return 0, _indexJsDefault173.default;
});
parcelHelpers.export(exports, "parse", function() {
    return 0, _indexJsDefault174.default;
});
parcelHelpers.export(exports, "parseISO", function() {
    return 0, _indexJsDefault175.default;
});
parcelHelpers.export(exports, "parseJSON", function() {
    return 0, _indexJsDefault176.default;
});
parcelHelpers.export(exports, "previousDay", function() {
    return 0, _indexJsDefault177.default;
});
parcelHelpers.export(exports, "previousFriday", function() {
    return 0, _indexJsDefault178.default;
});
parcelHelpers.export(exports, "previousMonday", function() {
    return 0, _indexJsDefault179.default;
});
parcelHelpers.export(exports, "previousSaturday", function() {
    return 0, _indexJsDefault180.default;
});
parcelHelpers.export(exports, "previousSunday", function() {
    return 0, _indexJsDefault181.default;
});
parcelHelpers.export(exports, "previousThursday", function() {
    return 0, _indexJsDefault182.default;
});
parcelHelpers.export(exports, "previousTuesday", function() {
    return 0, _indexJsDefault183.default;
});
parcelHelpers.export(exports, "previousWednesday", function() {
    return 0, _indexJsDefault184.default;
});
parcelHelpers.export(exports, "quartersToMonths", function() {
    return 0, _indexJsDefault185.default;
});
parcelHelpers.export(exports, "quartersToYears", function() {
    return 0, _indexJsDefault186.default;
});
parcelHelpers.export(exports, "roundToNearestMinutes", function() {
    return 0, _indexJsDefault187.default;
});
parcelHelpers.export(exports, "secondsToHours", function() {
    return 0, _indexJsDefault188.default;
});
parcelHelpers.export(exports, "secondsToMilliseconds", function() {
    return 0, _indexJsDefault189.default;
});
parcelHelpers.export(exports, "secondsToMinutes", function() {
    return 0, _indexJsDefault190.default;
});
parcelHelpers.export(exports, "set", function() {
    return 0, _indexJsDefault191.default;
});
parcelHelpers.export(exports, "setDate", function() {
    return 0, _indexJsDefault192.default;
});
parcelHelpers.export(exports, "setDay", function() {
    return 0, _indexJsDefault193.default;
});
parcelHelpers.export(exports, "setDayOfYear", function() {
    return 0, _indexJsDefault194.default;
});
parcelHelpers.export(exports, "setDefaultOptions", function() {
    return 0, _indexJsDefault195.default;
});
parcelHelpers.export(exports, "setHours", function() {
    return 0, _indexJsDefault196.default;
});
parcelHelpers.export(exports, "setISODay", function() {
    return 0, _indexJsDefault197.default;
});
parcelHelpers.export(exports, "setISOWeek", function() {
    return 0, _indexJsDefault198.default;
});
parcelHelpers.export(exports, "setISOWeekYear", function() {
    return 0, _indexJsDefault199.default;
});
parcelHelpers.export(exports, "setMilliseconds", function() {
    return 0, _indexJsDefault200.default;
});
parcelHelpers.export(exports, "setMinutes", function() {
    return 0, _indexJsDefault201.default;
});
parcelHelpers.export(exports, "setMonth", function() {
    return 0, _indexJsDefault202.default;
});
parcelHelpers.export(exports, "setQuarter", function() {
    return 0, _indexJsDefault203.default;
});
parcelHelpers.export(exports, "setSeconds", function() {
    return 0, _indexJsDefault204.default;
});
parcelHelpers.export(exports, "setWeek", function() {
    return 0, _indexJsDefault205.default;
});
parcelHelpers.export(exports, "setWeekYear", function() {
    return 0, _indexJsDefault206.default;
});
parcelHelpers.export(exports, "setYear", function() {
    return 0, _indexJsDefault207.default;
});
parcelHelpers.export(exports, "startOfDay", function() {
    return 0, _indexJsDefault208.default;
});
parcelHelpers.export(exports, "startOfDecade", function() {
    return 0, _indexJsDefault209.default;
});
parcelHelpers.export(exports, "startOfHour", function() {
    return 0, _indexJsDefault210.default;
});
parcelHelpers.export(exports, "startOfISOWeek", function() {
    return 0, _indexJsDefault211.default;
});
parcelHelpers.export(exports, "startOfISOWeekYear", function() {
    return 0, _indexJsDefault212.default;
});
parcelHelpers.export(exports, "startOfMinute", function() {
    return 0, _indexJsDefault213.default;
});
parcelHelpers.export(exports, "startOfMonth", function() {
    return 0, _indexJsDefault214.default;
});
parcelHelpers.export(exports, "startOfQuarter", function() {
    return 0, _indexJsDefault215.default;
});
parcelHelpers.export(exports, "startOfSecond", function() {
    return 0, _indexJsDefault216.default;
});
parcelHelpers.export(exports, "startOfToday", function() {
    return 0, _indexJsDefault217.default;
});
parcelHelpers.export(exports, "startOfTomorrow", function() {
    return 0, _indexJsDefault218.default;
});
parcelHelpers.export(exports, "startOfWeek", function() {
    return 0, _indexJsDefault219.default;
});
parcelHelpers.export(exports, "startOfWeekYear", function() {
    return 0, _indexJsDefault220.default;
});
parcelHelpers.export(exports, "startOfYear", function() {
    return 0, _indexJsDefault221.default;
});
parcelHelpers.export(exports, "startOfYesterday", function() {
    return 0, _indexJsDefault222.default;
});
parcelHelpers.export(exports, "sub", function() {
    return 0, _indexJsDefault223.default;
});
parcelHelpers.export(exports, "subBusinessDays", function() {
    return 0, _indexJsDefault224.default;
});
parcelHelpers.export(exports, "subDays", function() {
    return 0, _indexJsDefault225.default;
});
parcelHelpers.export(exports, "subHours", function() {
    return 0, _indexJsDefault226.default;
});
parcelHelpers.export(exports, "subISOWeekYears", function() {
    return 0, _indexJsDefault227.default;
});
parcelHelpers.export(exports, "subMilliseconds", function() {
    return 0, _indexJsDefault228.default;
});
parcelHelpers.export(exports, "subMinutes", function() {
    return 0, _indexJsDefault229.default;
});
parcelHelpers.export(exports, "subMonths", function() {
    return 0, _indexJsDefault230.default;
});
parcelHelpers.export(exports, "subQuarters", function() {
    return 0, _indexJsDefault231.default;
});
parcelHelpers.export(exports, "subSeconds", function() {
    return 0, _indexJsDefault232.default;
});
parcelHelpers.export(exports, "subWeeks", function() {
    return 0, _indexJsDefault233.default;
});
parcelHelpers.export(exports, "subYears", function() {
    return 0, _indexJsDefault234.default;
});
parcelHelpers.export(exports, "toDate", function() {
    return 0, _indexJsDefault235.default;
});
parcelHelpers.export(exports, "weeksToDays", function() {
    return 0, _indexJsDefault236.default;
});
parcelHelpers.export(exports, "yearsToMonths", function() {
    return 0, _indexJsDefault237.default;
});
parcelHelpers.export(exports, "yearsToQuarters", function() {
    return 0, _indexJsDefault238.default;
});
var _indexJs = require("./add/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./addBusinessDays/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./addDays/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./addHours/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./addISOWeekYears/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
var _indexJs5 = require("./addMilliseconds/index.js");
var _indexJsDefault5 = parcelHelpers.interopDefault(_indexJs5);
var _indexJs6 = require("./addMinutes/index.js");
var _indexJsDefault6 = parcelHelpers.interopDefault(_indexJs6);
var _indexJs7 = require("./addMonths/index.js");
var _indexJsDefault7 = parcelHelpers.interopDefault(_indexJs7);
var _indexJs8 = require("./addQuarters/index.js");
var _indexJsDefault8 = parcelHelpers.interopDefault(_indexJs8);
var _indexJs9 = require("./addSeconds/index.js");
var _indexJsDefault9 = parcelHelpers.interopDefault(_indexJs9);
var _indexJs10 = require("./addWeeks/index.js");
var _indexJsDefault10 = parcelHelpers.interopDefault(_indexJs10);
var _indexJs11 = require("./addYears/index.js");
var _indexJsDefault11 = parcelHelpers.interopDefault(_indexJs11);
var _indexJs12 = require("./areIntervalsOverlapping/index.js");
var _indexJsDefault12 = parcelHelpers.interopDefault(_indexJs12);
var _indexJs13 = require("./clamp/index.js");
var _indexJsDefault13 = parcelHelpers.interopDefault(_indexJs13);
var _indexJs14 = require("./closestIndexTo/index.js");
var _indexJsDefault14 = parcelHelpers.interopDefault(_indexJs14);
var _indexJs15 = require("./closestTo/index.js");
var _indexJsDefault15 = parcelHelpers.interopDefault(_indexJs15);
var _indexJs16 = require("./compareAsc/index.js");
var _indexJsDefault16 = parcelHelpers.interopDefault(_indexJs16);
var _indexJs17 = require("./compareDesc/index.js");
var _indexJsDefault17 = parcelHelpers.interopDefault(_indexJs17);
var _indexJs18 = require("./daysToWeeks/index.js");
var _indexJsDefault18 = parcelHelpers.interopDefault(_indexJs18);
var _indexJs19 = require("./differenceInBusinessDays/index.js");
var _indexJsDefault19 = parcelHelpers.interopDefault(_indexJs19);
var _indexJs20 = require("./differenceInCalendarDays/index.js");
var _indexJsDefault20 = parcelHelpers.interopDefault(_indexJs20);
var _indexJs21 = require("./differenceInCalendarISOWeekYears/index.js");
var _indexJsDefault21 = parcelHelpers.interopDefault(_indexJs21);
var _indexJs22 = require("./differenceInCalendarISOWeeks/index.js");
var _indexJsDefault22 = parcelHelpers.interopDefault(_indexJs22);
var _indexJs23 = require("./differenceInCalendarMonths/index.js");
var _indexJsDefault23 = parcelHelpers.interopDefault(_indexJs23);
var _indexJs24 = require("./differenceInCalendarQuarters/index.js");
var _indexJsDefault24 = parcelHelpers.interopDefault(_indexJs24);
var _indexJs25 = require("./differenceInCalendarWeeks/index.js");
var _indexJsDefault25 = parcelHelpers.interopDefault(_indexJs25);
var _indexJs26 = require("./differenceInCalendarYears/index.js");
var _indexJsDefault26 = parcelHelpers.interopDefault(_indexJs26);
var _indexJs27 = require("./differenceInDays/index.js");
var _indexJsDefault27 = parcelHelpers.interopDefault(_indexJs27);
var _indexJs28 = require("./differenceInHours/index.js");
var _indexJsDefault28 = parcelHelpers.interopDefault(_indexJs28);
var _indexJs29 = require("./differenceInISOWeekYears/index.js");
var _indexJsDefault29 = parcelHelpers.interopDefault(_indexJs29);
var _indexJs30 = require("./differenceInMilliseconds/index.js");
var _indexJsDefault30 = parcelHelpers.interopDefault(_indexJs30);
var _indexJs31 = require("./differenceInMinutes/index.js");
var _indexJsDefault31 = parcelHelpers.interopDefault(_indexJs31);
var _indexJs32 = require("./differenceInMonths/index.js");
var _indexJsDefault32 = parcelHelpers.interopDefault(_indexJs32);
var _indexJs33 = require("./differenceInQuarters/index.js");
var _indexJsDefault33 = parcelHelpers.interopDefault(_indexJs33);
var _indexJs34 = require("./differenceInSeconds/index.js");
var _indexJsDefault34 = parcelHelpers.interopDefault(_indexJs34);
var _indexJs35 = require("./differenceInWeeks/index.js");
var _indexJsDefault35 = parcelHelpers.interopDefault(_indexJs35);
var _indexJs36 = require("./differenceInYears/index.js");
var _indexJsDefault36 = parcelHelpers.interopDefault(_indexJs36);
var _indexJs37 = require("./eachDayOfInterval/index.js");
var _indexJsDefault37 = parcelHelpers.interopDefault(_indexJs37);
var _indexJs38 = require("./eachHourOfInterval/index.js");
var _indexJsDefault38 = parcelHelpers.interopDefault(_indexJs38);
var _indexJs39 = require("./eachMinuteOfInterval/index.js");
var _indexJsDefault39 = parcelHelpers.interopDefault(_indexJs39);
var _indexJs40 = require("./eachMonthOfInterval/index.js");
var _indexJsDefault40 = parcelHelpers.interopDefault(_indexJs40);
var _indexJs41 = require("./eachQuarterOfInterval/index.js");
var _indexJsDefault41 = parcelHelpers.interopDefault(_indexJs41);
var _indexJs42 = require("./eachWeekOfInterval/index.js");
var _indexJsDefault42 = parcelHelpers.interopDefault(_indexJs42);
var _indexJs43 = require("./eachWeekendOfInterval/index.js");
var _indexJsDefault43 = parcelHelpers.interopDefault(_indexJs43);
var _indexJs44 = require("./eachWeekendOfMonth/index.js");
var _indexJsDefault44 = parcelHelpers.interopDefault(_indexJs44);
var _indexJs45 = require("./eachWeekendOfYear/index.js");
var _indexJsDefault45 = parcelHelpers.interopDefault(_indexJs45);
var _indexJs46 = require("./eachYearOfInterval/index.js");
var _indexJsDefault46 = parcelHelpers.interopDefault(_indexJs46);
var _indexJs47 = require("./endOfDay/index.js");
var _indexJsDefault47 = parcelHelpers.interopDefault(_indexJs47);
var _indexJs48 = require("./endOfDecade/index.js");
var _indexJsDefault48 = parcelHelpers.interopDefault(_indexJs48);
var _indexJs49 = require("./endOfHour/index.js");
var _indexJsDefault49 = parcelHelpers.interopDefault(_indexJs49);
var _indexJs50 = require("./endOfISOWeek/index.js");
var _indexJsDefault50 = parcelHelpers.interopDefault(_indexJs50);
var _indexJs51 = require("./endOfISOWeekYear/index.js");
var _indexJsDefault51 = parcelHelpers.interopDefault(_indexJs51);
var _indexJs52 = require("./endOfMinute/index.js");
var _indexJsDefault52 = parcelHelpers.interopDefault(_indexJs52);
var _indexJs53 = require("./endOfMonth/index.js");
var _indexJsDefault53 = parcelHelpers.interopDefault(_indexJs53);
var _indexJs54 = require("./endOfQuarter/index.js");
var _indexJsDefault54 = parcelHelpers.interopDefault(_indexJs54);
var _indexJs55 = require("./endOfSecond/index.js");
var _indexJsDefault55 = parcelHelpers.interopDefault(_indexJs55);
var _indexJs56 = require("./endOfToday/index.js");
var _indexJsDefault56 = parcelHelpers.interopDefault(_indexJs56);
var _indexJs57 = require("./endOfTomorrow/index.js");
var _indexJsDefault57 = parcelHelpers.interopDefault(_indexJs57);
var _indexJs58 = require("./endOfWeek/index.js");
var _indexJsDefault58 = parcelHelpers.interopDefault(_indexJs58);
var _indexJs59 = require("./endOfYear/index.js");
var _indexJsDefault59 = parcelHelpers.interopDefault(_indexJs59);
var _indexJs60 = require("./endOfYesterday/index.js");
var _indexJsDefault60 = parcelHelpers.interopDefault(_indexJs60);
var _indexJs61 = require("./format/index.js");
var _indexJsDefault61 = parcelHelpers.interopDefault(_indexJs61);
var _indexJs62 = require("./formatDistance/index.js");
var _indexJsDefault62 = parcelHelpers.interopDefault(_indexJs62);
var _indexJs63 = require("./formatDistanceStrict/index.js");
var _indexJsDefault63 = parcelHelpers.interopDefault(_indexJs63);
var _indexJs64 = require("./formatDistanceToNow/index.js");
var _indexJsDefault64 = parcelHelpers.interopDefault(_indexJs64);
var _indexJs65 = require("./formatDistanceToNowStrict/index.js");
var _indexJsDefault65 = parcelHelpers.interopDefault(_indexJs65);
var _indexJs66 = require("./formatDuration/index.js");
var _indexJsDefault66 = parcelHelpers.interopDefault(_indexJs66);
var _indexJs67 = require("./formatISO/index.js");
var _indexJsDefault67 = parcelHelpers.interopDefault(_indexJs67);
var _indexJs68 = require("./formatISO9075/index.js");
var _indexJsDefault68 = parcelHelpers.interopDefault(_indexJs68);
var _indexJs69 = require("./formatISODuration/index.js");
var _indexJsDefault69 = parcelHelpers.interopDefault(_indexJs69);
var _indexJs70 = require("./formatRFC3339/index.js");
var _indexJsDefault70 = parcelHelpers.interopDefault(_indexJs70);
var _indexJs71 = require("./formatRFC7231/index.js");
var _indexJsDefault71 = parcelHelpers.interopDefault(_indexJs71);
var _indexJs72 = require("./formatRelative/index.js");
var _indexJsDefault72 = parcelHelpers.interopDefault(_indexJs72);
var _indexJs73 = require("./fromUnixTime/index.js");
var _indexJsDefault73 = parcelHelpers.interopDefault(_indexJs73);
var _indexJs74 = require("./getDate/index.js");
var _indexJsDefault74 = parcelHelpers.interopDefault(_indexJs74);
var _indexJs75 = require("./getDay/index.js");
var _indexJsDefault75 = parcelHelpers.interopDefault(_indexJs75);
var _indexJs76 = require("./getDayOfYear/index.js");
var _indexJsDefault76 = parcelHelpers.interopDefault(_indexJs76);
var _indexJs77 = require("./getDaysInMonth/index.js");
var _indexJsDefault77 = parcelHelpers.interopDefault(_indexJs77);
var _indexJs78 = require("./getDaysInYear/index.js");
var _indexJsDefault78 = parcelHelpers.interopDefault(_indexJs78);
var _indexJs79 = require("./getDecade/index.js");
var _indexJsDefault79 = parcelHelpers.interopDefault(_indexJs79);
var _indexJs80 = require("./getDefaultOptions/index.js");
var _indexJsDefault80 = parcelHelpers.interopDefault(_indexJs80);
var _indexJs81 = require("./getHours/index.js");
var _indexJsDefault81 = parcelHelpers.interopDefault(_indexJs81);
var _indexJs82 = require("./getISODay/index.js");
var _indexJsDefault82 = parcelHelpers.interopDefault(_indexJs82);
var _indexJs83 = require("./getISOWeek/index.js");
var _indexJsDefault83 = parcelHelpers.interopDefault(_indexJs83);
var _indexJs84 = require("./getISOWeekYear/index.js");
var _indexJsDefault84 = parcelHelpers.interopDefault(_indexJs84);
var _indexJs85 = require("./getISOWeeksInYear/index.js");
var _indexJsDefault85 = parcelHelpers.interopDefault(_indexJs85);
var _indexJs86 = require("./getMilliseconds/index.js");
var _indexJsDefault86 = parcelHelpers.interopDefault(_indexJs86);
var _indexJs87 = require("./getMinutes/index.js");
var _indexJsDefault87 = parcelHelpers.interopDefault(_indexJs87);
var _indexJs88 = require("./getMonth/index.js");
var _indexJsDefault88 = parcelHelpers.interopDefault(_indexJs88);
var _indexJs89 = require("./getOverlappingDaysInIntervals/index.js");
var _indexJsDefault89 = parcelHelpers.interopDefault(_indexJs89);
var _indexJs90 = require("./getQuarter/index.js");
var _indexJsDefault90 = parcelHelpers.interopDefault(_indexJs90);
var _indexJs91 = require("./getSeconds/index.js");
var _indexJsDefault91 = parcelHelpers.interopDefault(_indexJs91);
var _indexJs92 = require("./getTime/index.js");
var _indexJsDefault92 = parcelHelpers.interopDefault(_indexJs92);
var _indexJs93 = require("./getUnixTime/index.js");
var _indexJsDefault93 = parcelHelpers.interopDefault(_indexJs93);
var _indexJs94 = require("./getWeek/index.js");
var _indexJsDefault94 = parcelHelpers.interopDefault(_indexJs94);
var _indexJs95 = require("./getWeekOfMonth/index.js");
var _indexJsDefault95 = parcelHelpers.interopDefault(_indexJs95);
var _indexJs96 = require("./getWeekYear/index.js");
var _indexJsDefault96 = parcelHelpers.interopDefault(_indexJs96);
var _indexJs97 = require("./getWeeksInMonth/index.js");
var _indexJsDefault97 = parcelHelpers.interopDefault(_indexJs97);
var _indexJs98 = require("./getYear/index.js");
var _indexJsDefault98 = parcelHelpers.interopDefault(_indexJs98);
var _indexJs99 = require("./hoursToMilliseconds/index.js");
var _indexJsDefault99 = parcelHelpers.interopDefault(_indexJs99);
var _indexJs100 = require("./hoursToMinutes/index.js");
var _indexJsDefault100 = parcelHelpers.interopDefault(_indexJs100);
var _indexJs101 = require("./hoursToSeconds/index.js");
var _indexJsDefault101 = parcelHelpers.interopDefault(_indexJs101);
var _indexJs102 = require("./intervalToDuration/index.js");
var _indexJsDefault102 = parcelHelpers.interopDefault(_indexJs102);
var _indexJs103 = require("./intlFormat/index.js");
var _indexJsDefault103 = parcelHelpers.interopDefault(_indexJs103);
var _indexJs104 = require("./intlFormatDistance/index.js");
var _indexJsDefault104 = parcelHelpers.interopDefault(_indexJs104);
var _indexJs105 = require("./isAfter/index.js");
var _indexJsDefault105 = parcelHelpers.interopDefault(_indexJs105);
var _indexJs106 = require("./isBefore/index.js");
var _indexJsDefault106 = parcelHelpers.interopDefault(_indexJs106);
var _indexJs107 = require("./isDate/index.js");
var _indexJsDefault107 = parcelHelpers.interopDefault(_indexJs107);
var _indexJs108 = require("./isEqual/index.js");
var _indexJsDefault108 = parcelHelpers.interopDefault(_indexJs108);
var _indexJs109 = require("./isExists/index.js");
var _indexJsDefault109 = parcelHelpers.interopDefault(_indexJs109);
var _indexJs110 = require("./isFirstDayOfMonth/index.js");
var _indexJsDefault110 = parcelHelpers.interopDefault(_indexJs110);
var _indexJs111 = require("./isFriday/index.js");
var _indexJsDefault111 = parcelHelpers.interopDefault(_indexJs111);
var _indexJs112 = require("./isFuture/index.js");
var _indexJsDefault112 = parcelHelpers.interopDefault(_indexJs112);
var _indexJs113 = require("./isLastDayOfMonth/index.js");
var _indexJsDefault113 = parcelHelpers.interopDefault(_indexJs113);
var _indexJs114 = require("./isLeapYear/index.js");
var _indexJsDefault114 = parcelHelpers.interopDefault(_indexJs114);
var _indexJs115 = require("./isMatch/index.js");
var _indexJsDefault115 = parcelHelpers.interopDefault(_indexJs115);
var _indexJs116 = require("./isMonday/index.js");
var _indexJsDefault116 = parcelHelpers.interopDefault(_indexJs116);
var _indexJs117 = require("./isPast/index.js");
var _indexJsDefault117 = parcelHelpers.interopDefault(_indexJs117);
var _indexJs118 = require("./isSameDay/index.js");
var _indexJsDefault118 = parcelHelpers.interopDefault(_indexJs118);
var _indexJs119 = require("./isSameHour/index.js");
var _indexJsDefault119 = parcelHelpers.interopDefault(_indexJs119);
var _indexJs120 = require("./isSameISOWeek/index.js");
var _indexJsDefault120 = parcelHelpers.interopDefault(_indexJs120);
var _indexJs121 = require("./isSameISOWeekYear/index.js");
var _indexJsDefault121 = parcelHelpers.interopDefault(_indexJs121);
var _indexJs122 = require("./isSameMinute/index.js");
var _indexJsDefault122 = parcelHelpers.interopDefault(_indexJs122);
var _indexJs123 = require("./isSameMonth/index.js");
var _indexJsDefault123 = parcelHelpers.interopDefault(_indexJs123);
var _indexJs124 = require("./isSameQuarter/index.js");
var _indexJsDefault124 = parcelHelpers.interopDefault(_indexJs124);
var _indexJs125 = require("./isSameSecond/index.js");
var _indexJsDefault125 = parcelHelpers.interopDefault(_indexJs125);
var _indexJs126 = require("./isSameWeek/index.js");
var _indexJsDefault126 = parcelHelpers.interopDefault(_indexJs126);
var _indexJs127 = require("./isSameYear/index.js");
var _indexJsDefault127 = parcelHelpers.interopDefault(_indexJs127);
var _indexJs128 = require("./isSaturday/index.js");
var _indexJsDefault128 = parcelHelpers.interopDefault(_indexJs128);
var _indexJs129 = require("./isSunday/index.js");
var _indexJsDefault129 = parcelHelpers.interopDefault(_indexJs129);
var _indexJs130 = require("./isThisHour/index.js");
var _indexJsDefault130 = parcelHelpers.interopDefault(_indexJs130);
var _indexJs131 = require("./isThisISOWeek/index.js");
var _indexJsDefault131 = parcelHelpers.interopDefault(_indexJs131);
var _indexJs132 = require("./isThisMinute/index.js");
var _indexJsDefault132 = parcelHelpers.interopDefault(_indexJs132);
var _indexJs133 = require("./isThisMonth/index.js");
var _indexJsDefault133 = parcelHelpers.interopDefault(_indexJs133);
var _indexJs134 = require("./isThisQuarter/index.js");
var _indexJsDefault134 = parcelHelpers.interopDefault(_indexJs134);
var _indexJs135 = require("./isThisSecond/index.js");
var _indexJsDefault135 = parcelHelpers.interopDefault(_indexJs135);
var _indexJs136 = require("./isThisWeek/index.js");
var _indexJsDefault136 = parcelHelpers.interopDefault(_indexJs136);
var _indexJs137 = require("./isThisYear/index.js");
var _indexJsDefault137 = parcelHelpers.interopDefault(_indexJs137);
var _indexJs138 = require("./isThursday/index.js");
var _indexJsDefault138 = parcelHelpers.interopDefault(_indexJs138);
var _indexJs139 = require("./isToday/index.js");
var _indexJsDefault139 = parcelHelpers.interopDefault(_indexJs139);
var _indexJs140 = require("./isTomorrow/index.js");
var _indexJsDefault140 = parcelHelpers.interopDefault(_indexJs140);
var _indexJs141 = require("./isTuesday/index.js");
var _indexJsDefault141 = parcelHelpers.interopDefault(_indexJs141);
var _indexJs142 = require("./isValid/index.js");
var _indexJsDefault142 = parcelHelpers.interopDefault(_indexJs142);
var _indexJs143 = require("./isWednesday/index.js");
var _indexJsDefault143 = parcelHelpers.interopDefault(_indexJs143);
var _indexJs144 = require("./isWeekend/index.js");
var _indexJsDefault144 = parcelHelpers.interopDefault(_indexJs144);
var _indexJs145 = require("./isWithinInterval/index.js");
var _indexJsDefault145 = parcelHelpers.interopDefault(_indexJs145);
var _indexJs146 = require("./isYesterday/index.js");
var _indexJsDefault146 = parcelHelpers.interopDefault(_indexJs146);
var _indexJs147 = require("./lastDayOfDecade/index.js");
var _indexJsDefault147 = parcelHelpers.interopDefault(_indexJs147);
var _indexJs148 = require("./lastDayOfISOWeek/index.js");
var _indexJsDefault148 = parcelHelpers.interopDefault(_indexJs148);
var _indexJs149 = require("./lastDayOfISOWeekYear/index.js");
var _indexJsDefault149 = parcelHelpers.interopDefault(_indexJs149);
var _indexJs150 = require("./lastDayOfMonth/index.js");
var _indexJsDefault150 = parcelHelpers.interopDefault(_indexJs150);
var _indexJs151 = require("./lastDayOfQuarter/index.js");
var _indexJsDefault151 = parcelHelpers.interopDefault(_indexJs151);
var _indexJs152 = require("./lastDayOfWeek/index.js");
var _indexJsDefault152 = parcelHelpers.interopDefault(_indexJs152);
var _indexJs153 = require("./lastDayOfYear/index.js");
var _indexJsDefault153 = parcelHelpers.interopDefault(_indexJs153);
var _indexJs154 = require("./lightFormat/index.js");
var _indexJsDefault154 = parcelHelpers.interopDefault(_indexJs154);
var _indexJs155 = require("./max/index.js");
var _indexJsDefault155 = parcelHelpers.interopDefault(_indexJs155);
var _indexJs156 = require("./milliseconds/index.js");
var _indexJsDefault156 = parcelHelpers.interopDefault(_indexJs156);
var _indexJs157 = require("./millisecondsToHours/index.js");
var _indexJsDefault157 = parcelHelpers.interopDefault(_indexJs157);
var _indexJs158 = require("./millisecondsToMinutes/index.js");
var _indexJsDefault158 = parcelHelpers.interopDefault(_indexJs158);
var _indexJs159 = require("./millisecondsToSeconds/index.js");
var _indexJsDefault159 = parcelHelpers.interopDefault(_indexJs159);
var _indexJs160 = require("./min/index.js");
var _indexJsDefault160 = parcelHelpers.interopDefault(_indexJs160);
var _indexJs161 = require("./minutesToHours/index.js");
var _indexJsDefault161 = parcelHelpers.interopDefault(_indexJs161);
var _indexJs162 = require("./minutesToMilliseconds/index.js");
var _indexJsDefault162 = parcelHelpers.interopDefault(_indexJs162);
var _indexJs163 = require("./minutesToSeconds/index.js");
var _indexJsDefault163 = parcelHelpers.interopDefault(_indexJs163);
var _indexJs164 = require("./monthsToQuarters/index.js");
var _indexJsDefault164 = parcelHelpers.interopDefault(_indexJs164);
var _indexJs165 = require("./monthsToYears/index.js");
var _indexJsDefault165 = parcelHelpers.interopDefault(_indexJs165);
var _indexJs166 = require("./nextDay/index.js");
var _indexJsDefault166 = parcelHelpers.interopDefault(_indexJs166);
var _indexJs167 = require("./nextFriday/index.js");
var _indexJsDefault167 = parcelHelpers.interopDefault(_indexJs167);
var _indexJs168 = require("./nextMonday/index.js");
var _indexJsDefault168 = parcelHelpers.interopDefault(_indexJs168);
var _indexJs169 = require("./nextSaturday/index.js");
var _indexJsDefault169 = parcelHelpers.interopDefault(_indexJs169);
var _indexJs170 = require("./nextSunday/index.js");
var _indexJsDefault170 = parcelHelpers.interopDefault(_indexJs170);
var _indexJs171 = require("./nextThursday/index.js");
var _indexJsDefault171 = parcelHelpers.interopDefault(_indexJs171);
var _indexJs172 = require("./nextTuesday/index.js");
var _indexJsDefault172 = parcelHelpers.interopDefault(_indexJs172);
var _indexJs173 = require("./nextWednesday/index.js");
var _indexJsDefault173 = parcelHelpers.interopDefault(_indexJs173);
var _indexJs174 = require("./parse/index.js");
var _indexJsDefault174 = parcelHelpers.interopDefault(_indexJs174);
var _indexJs175 = require("./parseISO/index.js");
var _indexJsDefault175 = parcelHelpers.interopDefault(_indexJs175);
var _indexJs176 = require("./parseJSON/index.js");
var _indexJsDefault176 = parcelHelpers.interopDefault(_indexJs176);
var _indexJs177 = require("./previousDay/index.js");
var _indexJsDefault177 = parcelHelpers.interopDefault(_indexJs177);
var _indexJs178 = require("./previousFriday/index.js");
var _indexJsDefault178 = parcelHelpers.interopDefault(_indexJs178);
var _indexJs179 = require("./previousMonday/index.js");
var _indexJsDefault179 = parcelHelpers.interopDefault(_indexJs179);
var _indexJs180 = require("./previousSaturday/index.js");
var _indexJsDefault180 = parcelHelpers.interopDefault(_indexJs180);
var _indexJs181 = require("./previousSunday/index.js");
var _indexJsDefault181 = parcelHelpers.interopDefault(_indexJs181);
var _indexJs182 = require("./previousThursday/index.js");
var _indexJsDefault182 = parcelHelpers.interopDefault(_indexJs182);
var _indexJs183 = require("./previousTuesday/index.js");
var _indexJsDefault183 = parcelHelpers.interopDefault(_indexJs183);
var _indexJs184 = require("./previousWednesday/index.js");
var _indexJsDefault184 = parcelHelpers.interopDefault(_indexJs184);
var _indexJs185 = require("./quartersToMonths/index.js");
var _indexJsDefault185 = parcelHelpers.interopDefault(_indexJs185);
var _indexJs186 = require("./quartersToYears/index.js");
var _indexJsDefault186 = parcelHelpers.interopDefault(_indexJs186);
var _indexJs187 = require("./roundToNearestMinutes/index.js");
var _indexJsDefault187 = parcelHelpers.interopDefault(_indexJs187);
var _indexJs188 = require("./secondsToHours/index.js");
var _indexJsDefault188 = parcelHelpers.interopDefault(_indexJs188);
var _indexJs189 = require("./secondsToMilliseconds/index.js");
var _indexJsDefault189 = parcelHelpers.interopDefault(_indexJs189);
var _indexJs190 = require("./secondsToMinutes/index.js");
var _indexJsDefault190 = parcelHelpers.interopDefault(_indexJs190);
var _indexJs191 = require("./set/index.js");
var _indexJsDefault191 = parcelHelpers.interopDefault(_indexJs191);
var _indexJs192 = require("./setDate/index.js");
var _indexJsDefault192 = parcelHelpers.interopDefault(_indexJs192);
var _indexJs193 = require("./setDay/index.js");
var _indexJsDefault193 = parcelHelpers.interopDefault(_indexJs193);
var _indexJs194 = require("./setDayOfYear/index.js");
var _indexJsDefault194 = parcelHelpers.interopDefault(_indexJs194);
var _indexJs195 = require("./setDefaultOptions/index.js");
var _indexJsDefault195 = parcelHelpers.interopDefault(_indexJs195);
var _indexJs196 = require("./setHours/index.js");
var _indexJsDefault196 = parcelHelpers.interopDefault(_indexJs196);
var _indexJs197 = require("./setISODay/index.js");
var _indexJsDefault197 = parcelHelpers.interopDefault(_indexJs197);
var _indexJs198 = require("./setISOWeek/index.js");
var _indexJsDefault198 = parcelHelpers.interopDefault(_indexJs198);
var _indexJs199 = require("./setISOWeekYear/index.js");
var _indexJsDefault199 = parcelHelpers.interopDefault(_indexJs199);
var _indexJs200 = require("./setMilliseconds/index.js");
var _indexJsDefault200 = parcelHelpers.interopDefault(_indexJs200);
var _indexJs201 = require("./setMinutes/index.js");
var _indexJsDefault201 = parcelHelpers.interopDefault(_indexJs201);
var _indexJs202 = require("./setMonth/index.js");
var _indexJsDefault202 = parcelHelpers.interopDefault(_indexJs202);
var _indexJs203 = require("./setQuarter/index.js");
var _indexJsDefault203 = parcelHelpers.interopDefault(_indexJs203);
var _indexJs204 = require("./setSeconds/index.js");
var _indexJsDefault204 = parcelHelpers.interopDefault(_indexJs204);
var _indexJs205 = require("./setWeek/index.js");
var _indexJsDefault205 = parcelHelpers.interopDefault(_indexJs205);
var _indexJs206 = require("./setWeekYear/index.js");
var _indexJsDefault206 = parcelHelpers.interopDefault(_indexJs206);
var _indexJs207 = require("./setYear/index.js");
var _indexJsDefault207 = parcelHelpers.interopDefault(_indexJs207);
var _indexJs208 = require("./startOfDay/index.js");
var _indexJsDefault208 = parcelHelpers.interopDefault(_indexJs208);
var _indexJs209 = require("./startOfDecade/index.js");
var _indexJsDefault209 = parcelHelpers.interopDefault(_indexJs209);
var _indexJs210 = require("./startOfHour/index.js");
var _indexJsDefault210 = parcelHelpers.interopDefault(_indexJs210);
var _indexJs211 = require("./startOfISOWeek/index.js");
var _indexJsDefault211 = parcelHelpers.interopDefault(_indexJs211);
var _indexJs212 = require("./startOfISOWeekYear/index.js");
var _indexJsDefault212 = parcelHelpers.interopDefault(_indexJs212);
var _indexJs213 = require("./startOfMinute/index.js");
var _indexJsDefault213 = parcelHelpers.interopDefault(_indexJs213);
var _indexJs214 = require("./startOfMonth/index.js");
var _indexJsDefault214 = parcelHelpers.interopDefault(_indexJs214);
var _indexJs215 = require("./startOfQuarter/index.js");
var _indexJsDefault215 = parcelHelpers.interopDefault(_indexJs215);
var _indexJs216 = require("./startOfSecond/index.js");
var _indexJsDefault216 = parcelHelpers.interopDefault(_indexJs216);
var _indexJs217 = require("./startOfToday/index.js");
var _indexJsDefault217 = parcelHelpers.interopDefault(_indexJs217);
var _indexJs218 = require("./startOfTomorrow/index.js");
var _indexJsDefault218 = parcelHelpers.interopDefault(_indexJs218);
var _indexJs219 = require("./startOfWeek/index.js");
var _indexJsDefault219 = parcelHelpers.interopDefault(_indexJs219);
var _indexJs220 = require("./startOfWeekYear/index.js");
var _indexJsDefault220 = parcelHelpers.interopDefault(_indexJs220);
var _indexJs221 = require("./startOfYear/index.js");
var _indexJsDefault221 = parcelHelpers.interopDefault(_indexJs221);
var _indexJs222 = require("./startOfYesterday/index.js");
var _indexJsDefault222 = parcelHelpers.interopDefault(_indexJs222);
var _indexJs223 = require("./sub/index.js");
var _indexJsDefault223 = parcelHelpers.interopDefault(_indexJs223);
var _indexJs224 = require("./subBusinessDays/index.js");
var _indexJsDefault224 = parcelHelpers.interopDefault(_indexJs224);
var _indexJs225 = require("./subDays/index.js");
var _indexJsDefault225 = parcelHelpers.interopDefault(_indexJs225);
var _indexJs226 = require("./subHours/index.js");
var _indexJsDefault226 = parcelHelpers.interopDefault(_indexJs226);
var _indexJs227 = require("./subISOWeekYears/index.js");
var _indexJsDefault227 = parcelHelpers.interopDefault(_indexJs227);
var _indexJs228 = require("./subMilliseconds/index.js");
var _indexJsDefault228 = parcelHelpers.interopDefault(_indexJs228);
var _indexJs229 = require("./subMinutes/index.js");
var _indexJsDefault229 = parcelHelpers.interopDefault(_indexJs229);
var _indexJs230 = require("./subMonths/index.js");
var _indexJsDefault230 = parcelHelpers.interopDefault(_indexJs230);
var _indexJs231 = require("./subQuarters/index.js");
var _indexJsDefault231 = parcelHelpers.interopDefault(_indexJs231);
var _indexJs232 = require("./subSeconds/index.js");
var _indexJsDefault232 = parcelHelpers.interopDefault(_indexJs232);
var _indexJs233 = require("./subWeeks/index.js");
var _indexJsDefault233 = parcelHelpers.interopDefault(_indexJs233);
var _indexJs234 = require("./subYears/index.js");
var _indexJsDefault234 = parcelHelpers.interopDefault(_indexJs234);
var _indexJs235 = require("./toDate/index.js");
var _indexJsDefault235 = parcelHelpers.interopDefault(_indexJs235);
var _indexJs236 = require("./weeksToDays/index.js");
var _indexJsDefault236 = parcelHelpers.interopDefault(_indexJs236);
var _indexJs237 = require("./yearsToMonths/index.js");
var _indexJsDefault237 = parcelHelpers.interopDefault(_indexJs237);
var _indexJs238 = require("./yearsToQuarters/index.js");
var _indexJsDefault238 = parcelHelpers.interopDefault(_indexJs238);
var _indexJs239 = require("./constants/index.js");
parcelHelpers.exportAll(_indexJs239, exports);

},{"./add/index.js":"hbKuq","./addBusinessDays/index.js":"26iKx","./addDays/index.js":"3C7cL","./addHours/index.js":"87L7P","./addISOWeekYears/index.js":"72xLL","./addMilliseconds/index.js":"bkMDO","./addMinutes/index.js":"a9kHu","./addMonths/index.js":"3fsvC","./addQuarters/index.js":"3QFLI","./addSeconds/index.js":"7tH0p","./addWeeks/index.js":"jdo2p","./addYears/index.js":"fLqeW","./areIntervalsOverlapping/index.js":"1fm88","./clamp/index.js":"kLnLh","./closestIndexTo/index.js":"3vUGo","./closestTo/index.js":"5nvWr","./compareAsc/index.js":"jbQZt","./compareDesc/index.js":"1lWbr","./daysToWeeks/index.js":"iatfg","./differenceInBusinessDays/index.js":"bgyXf","./differenceInCalendarDays/index.js":"44jgD","./differenceInCalendarISOWeekYears/index.js":"kUQqi","./differenceInCalendarISOWeeks/index.js":"7WjuL","./differenceInCalendarMonths/index.js":"2NHrG","./differenceInCalendarQuarters/index.js":"6WkeE","./differenceInCalendarWeeks/index.js":"6bPYn","./differenceInCalendarYears/index.js":"dQoj8","./differenceInDays/index.js":"88cpp","./differenceInHours/index.js":"fil0n","./differenceInISOWeekYears/index.js":"4CFRz","./differenceInMilliseconds/index.js":"4H1yL","./differenceInMinutes/index.js":"cEAnJ","./differenceInMonths/index.js":"7dsnu","./differenceInQuarters/index.js":"6UwOj","./differenceInSeconds/index.js":"40bOi","./differenceInWeeks/index.js":"5SadI","./differenceInYears/index.js":"gJB8K","./eachDayOfInterval/index.js":"lO9GP","./eachHourOfInterval/index.js":"2CuLe","./eachMinuteOfInterval/index.js":"kKbgf","./eachMonthOfInterval/index.js":"a3UAO","./eachQuarterOfInterval/index.js":"jiPqr","./eachWeekOfInterval/index.js":"hJ9yE","./eachWeekendOfInterval/index.js":"2L0Yg","./eachWeekendOfMonth/index.js":"8g6dC","./eachWeekendOfYear/index.js":"dGcPn","./eachYearOfInterval/index.js":"hM5VS","./endOfDay/index.js":"9HfEy","./endOfDecade/index.js":"iXWus","./endOfHour/index.js":"8xEyw","./endOfISOWeek/index.js":"l46rw","./endOfISOWeekYear/index.js":"lpCyy","./endOfMinute/index.js":"3PHAt","./endOfMonth/index.js":"fY6SB","./endOfQuarter/index.js":"eF1qJ","./endOfSecond/index.js":"cBffo","./endOfToday/index.js":"jJjn7","./endOfTomorrow/index.js":"6TsRs","./endOfWeek/index.js":"86Bk9","./endOfYear/index.js":"eI4Oq","./endOfYesterday/index.js":"9H1UJ","./format/index.js":"jeCXy","./formatDistance/index.js":"h9eLH","./formatDistanceStrict/index.js":"6Wxdy","./formatDistanceToNow/index.js":"6cP6D","./formatDistanceToNowStrict/index.js":"aRzMn","./formatDuration/index.js":"9cDu4","./formatISO/index.js":"bbu2K","./formatISO9075/index.js":"ikPEG","./formatISODuration/index.js":"g5pMq","./formatRFC3339/index.js":"d7vRW","./formatRFC7231/index.js":"7BU1O","./formatRelative/index.js":"kS7iO","./fromUnixTime/index.js":"hEULc","./getDate/index.js":"9szif","./getDay/index.js":"5wMzR","./getDayOfYear/index.js":"hk4Le","./getDaysInMonth/index.js":"6Eo8o","./getDaysInYear/index.js":"6VLfO","./getDecade/index.js":"5dwea","./getDefaultOptions/index.js":"9pJnk","./getHours/index.js":"4YWMb","./getISODay/index.js":"3jgzA","./getISOWeek/index.js":"hYopA","./getISOWeekYear/index.js":"5i5mG","./getISOWeeksInYear/index.js":"5exDa","./getMilliseconds/index.js":"kLsM5","./getMinutes/index.js":"gYbWF","./getMonth/index.js":"hcsnh","./getOverlappingDaysInIntervals/index.js":"9GAre","./getQuarter/index.js":"ejE5L","./getSeconds/index.js":"4fnKq","./getTime/index.js":"hOaNP","./getUnixTime/index.js":"kkkKH","./getWeek/index.js":"6M8d2","./getWeekOfMonth/index.js":"bWerd","./getWeekYear/index.js":"h8EwW","./getWeeksInMonth/index.js":"8QoMm","./getYear/index.js":"djuEO","./hoursToMilliseconds/index.js":"5d80N","./hoursToMinutes/index.js":"irR0P","./hoursToSeconds/index.js":"7H4oz","./intervalToDuration/index.js":"g409N","./intlFormat/index.js":"iHeqH","./intlFormatDistance/index.js":"dXFeW","./isAfter/index.js":"8h0gP","./isBefore/index.js":"a13ig","./isDate/index.js":"5222M","./isEqual/index.js":"4t23L","./isExists/index.js":"03SJy","./isFirstDayOfMonth/index.js":"fM3Mi","./isFriday/index.js":"2Wcjk","./isFuture/index.js":"7NAjC","./isLastDayOfMonth/index.js":"cqOk0","./isLeapYear/index.js":"8mjUp","./isMatch/index.js":"x4zY1","./isMonday/index.js":"3gapU","./isPast/index.js":"4O947","./isSameDay/index.js":"8u23d","./isSameHour/index.js":"sDgcB","./isSameISOWeek/index.js":"hIfKA","./isSameISOWeekYear/index.js":"2JKTL","./isSameMinute/index.js":"6dy0a","./isSameMonth/index.js":"8yEUT","./isSameQuarter/index.js":"fopzD","./isSameSecond/index.js":"hM0KL","./isSameWeek/index.js":"g3b0I","./isSameYear/index.js":"kX8qq","./isSaturday/index.js":"gj7oN","./isSunday/index.js":"eveXy","./isThisHour/index.js":"12weA","./isThisISOWeek/index.js":"bUbRF","./isThisMinute/index.js":"2MtAx","./isThisMonth/index.js":"1LQgZ","./isThisQuarter/index.js":"2IBI1","./isThisSecond/index.js":"1oae1","./isThisWeek/index.js":"jF4bV","./isThisYear/index.js":"3OrWT","./isThursday/index.js":"5fEDA","./isToday/index.js":"dtqLQ","./isTomorrow/index.js":"9ruSU","./isTuesday/index.js":"fttSw","./isValid/index.js":"fScb4","./isWednesday/index.js":"3HtEA","./isWeekend/index.js":"6gjaR","./isWithinInterval/index.js":"byUym","./isYesterday/index.js":"gIC53","./lastDayOfDecade/index.js":"8DeuD","./lastDayOfISOWeek/index.js":"2XvFr","./lastDayOfISOWeekYear/index.js":"ckpg3","./lastDayOfMonth/index.js":"46Uoq","./lastDayOfQuarter/index.js":"eETX3","./lastDayOfWeek/index.js":"bevXZ","./lastDayOfYear/index.js":"5o12E","./lightFormat/index.js":"fzS5t","./max/index.js":"81MHx","./milliseconds/index.js":"6KTIG","./millisecondsToHours/index.js":"5mrCB","./millisecondsToMinutes/index.js":"almzE","./millisecondsToSeconds/index.js":"5HdxH","./min/index.js":"e4nKp","./minutesToHours/index.js":"91Cwb","./minutesToMilliseconds/index.js":"2UB7Y","./minutesToSeconds/index.js":"hiifw","./monthsToQuarters/index.js":"7YXp6","./monthsToYears/index.js":"1CRgz","./nextDay/index.js":"7Bmyo","./nextFriday/index.js":"6RsRC","./nextMonday/index.js":"jyqbO","./nextSaturday/index.js":"4xCmy","./nextSunday/index.js":"8LcbP","./nextThursday/index.js":"eJEdM","./nextTuesday/index.js":"68dtI","./nextWednesday/index.js":"eDTo1","./parse/index.js":"01uF3","./parseISO/index.js":"dMHtk","./parseJSON/index.js":"3oZ8i","./previousDay/index.js":"h2rcf","./previousFriday/index.js":"braSV","./previousMonday/index.js":"b9PA5","./previousSaturday/index.js":"i0RcM","./previousSunday/index.js":"2kBHa","./previousThursday/index.js":"8fBuK","./previousTuesday/index.js":"jCUbL","./previousWednesday/index.js":"3QFsL","./quartersToMonths/index.js":"i3Toh","./quartersToYears/index.js":"bgNhE","./roundToNearestMinutes/index.js":"ghQL0","./secondsToHours/index.js":"4PRCz","./secondsToMilliseconds/index.js":"d0F6C","./secondsToMinutes/index.js":"6Z2NQ","./set/index.js":"kDXSB","./setDate/index.js":"5Taqz","./setDay/index.js":"8b2jv","./setDayOfYear/index.js":"4ZrgY","./setDefaultOptions/index.js":"4pQYw","./setHours/index.js":"gtryo","./setISODay/index.js":"3zAq8","./setISOWeek/index.js":"9ClkT","./setISOWeekYear/index.js":"lErLA","./setMilliseconds/index.js":"1CEiC","./setMinutes/index.js":"BCNxR","./setMonth/index.js":"17tWf","./setQuarter/index.js":"1IdTY","./setSeconds/index.js":"j2eSg","./setWeek/index.js":"1SPJZ","./setWeekYear/index.js":"kNiLK","./setYear/index.js":"8CMX0","./startOfDay/index.js":"g4xpx","./startOfDecade/index.js":"gjdjj","./startOfHour/index.js":"anlJQ","./startOfISOWeek/index.js":"iB7YK","./startOfISOWeekYear/index.js":"7AEM8","./startOfMinute/index.js":"ioXMa","./startOfMonth/index.js":"4MG0j","./startOfQuarter/index.js":"k4fkG","./startOfSecond/index.js":"f18kx","./startOfToday/index.js":"fYHEU","./startOfTomorrow/index.js":"coRv8","./startOfWeek/index.js":"em4Ab","./startOfWeekYear/index.js":"kJj0U","./startOfYear/index.js":"iKNfx","./startOfYesterday/index.js":"5RwjK","./sub/index.js":"a9Qbj","./subBusinessDays/index.js":"1vTly","./subDays/index.js":"goTWu","./subHours/index.js":"2p6Ci","./subISOWeekYears/index.js":"1VWSB","./subMilliseconds/index.js":"1aYLs","./subMinutes/index.js":"cee50","./subMonths/index.js":"5GQoO","./subQuarters/index.js":"fZikN","./subSeconds/index.js":"68KPU","./subWeeks/index.js":"ZRcZB","./subYears/index.js":"7kVXH","./toDate/index.js":"elr3O","./weeksToDays/index.js":"Pb59y","./yearsToMonths/index.js":"i3C4W","./yearsToQuarters/index.js":"3LrpM","./constants/index.js":"k64Zq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"hbKuq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return add;
});
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _indexJs = require("../addDays/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../addMonths/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../toDate/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../_lib/toInteger/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
function add(dirtyDate, duration) {
    (0, _indexJsDefault3.default)(2, arguments);
    if (!duration || (0, _typeofDefault.default)(duration) !== 'object') return new Date(NaN);
    var years = duration.years ? (0, _indexJsDefault4.default)(duration.years) : 0;
    var months = duration.months ? (0, _indexJsDefault4.default)(duration.months) : 0;
    var weeks = duration.weeks ? (0, _indexJsDefault4.default)(duration.weeks) : 0;
    var days = duration.days ? (0, _indexJsDefault4.default)(duration.days) : 0;
    var hours = duration.hours ? (0, _indexJsDefault4.default)(duration.hours) : 0;
    var minutes = duration.minutes ? (0, _indexJsDefault4.default)(duration.minutes) : 0;
    var seconds = duration.seconds ? (0, _indexJsDefault4.default)(duration.seconds) : 0;
    // Add years and months
    var date = (0, _indexJsDefault2.default)(dirtyDate);
    var dateWithMonths = months || years ? (0, _indexJsDefault1.default)(date, months + years * 12) : date;
    // Add weeks and days
    var dateWithDays = days || weeks ? (0, _indexJsDefault.default)(dateWithMonths, days + weeks * 7) : dateWithMonths;
    // Add days, hours, minutes and seconds
    var minutesToAdd = minutes + hours * 60;
    var secondsToAdd = seconds + minutesToAdd * 60;
    var msToAdd = secondsToAdd * 1000;
    var finalDate = new Date(dateWithDays.getTime() + msToAdd);
    return finalDate;
}

},{"@babel/runtime/helpers/esm/typeof":"8bpl6","../addDays/index.js":"3C7cL","../addMonths/index.js":"3fsvC","../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","../_lib/toInteger/index.js":"dkWbJ","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8bpl6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _typeof;
});
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3C7cL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return addDays;
});
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function addDays(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}

},{"../_lib/toInteger/index.js":"dkWbJ","../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"dkWbJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return toInteger;
});
function toInteger(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"elr3O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return toDate;
});
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _indexJs = require("../_lib/requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function toDate(argument) {
    (0, _indexJsDefault.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, _typeofDefault.default)(argument) === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}

},{"@babel/runtime/helpers/esm/typeof":"8bpl6","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"14prD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return requiredArgs;
});
function requiredArgs(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3fsvC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return addMonths;
});
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function addMonths(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
    var dayOfMonth = date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return date;
    }
}

},{"../_lib/toInteger/index.js":"dkWbJ","../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"26iKx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return addBusinessDays;
});
var _indexJs = require("../isWeekend/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../isSunday/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
var _indexJs5 = require("../isSaturday/index.js");
var _indexJsDefault5 = parcelHelpers.interopDefault(_indexJs5);
function addBusinessDays(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault3.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var startedOnWeekend = (0, _indexJsDefault.default)(date);
    var amount = (0, _indexJsDefault2.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    var hours = date.getHours();
    var sign = amount < 0 ? -1 : 1;
    var fullWeeks = (0, _indexJsDefault2.default)(amount / 5);
    date.setDate(date.getDate() + fullWeeks * 7);
    // Get remaining days not part of a full week
    var restDays = Math.abs(amount % 5);
    // Loops over remaining days
    while(restDays > 0){
        date.setDate(date.getDate() + sign);
        if (!(0, _indexJsDefault.default)(date)) restDays -= 1;
    }
    // If the date is a weekend day and we reduce a dividable of
    // 5 from it, we land on a weekend date.
    // To counter this, we add days accordingly to land on the next business day
    if (startedOnWeekend && (0, _indexJsDefault.default)(date) && amount !== 0) {
        // If we're reducing days, we want to add days until we land on a weekday
        // If we're adding days we want to reduce days until we land on a weekday
        if ((0, _indexJsDefault5.default)(date)) date.setDate(date.getDate() + (sign < 0 ? 2 : -1));
        if ((0, _indexJsDefault4.default)(date)) date.setDate(date.getDate() + (sign < 0 ? 1 : -2));
    }
    // Restore hours to avoid DST lag
    date.setHours(hours);
    return date;
}

},{"../isWeekend/index.js":"6gjaR","../toDate/index.js":"elr3O","../_lib/toInteger/index.js":"dkWbJ","../_lib/requiredArgs/index.js":"14prD","../isSunday/index.js":"eveXy","../isSaturday/index.js":"gj7oN","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6gjaR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isWeekend;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isWeekend(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var day = date.getDay();
    return day === 0 || day === 6;
}

},{"../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"eveXy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isSunday;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isSunday(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    return (0, _indexJsDefault.default)(dirtyDate).getDay() === 0;
}

},{"../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gj7oN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isSaturday;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isSaturday(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    return (0, _indexJsDefault.default)(dirtyDate).getDay() === 6;
}

},{"../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"87L7P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return addHours;
});
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../addMilliseconds/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var MILLISECONDS_IN_HOUR = 3600000;
function addHours(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    return (0, _indexJsDefault1.default)(dirtyDate, amount * MILLISECONDS_IN_HOUR);
}

},{"../_lib/toInteger/index.js":"dkWbJ","../addMilliseconds/index.js":"bkMDO","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"bkMDO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return addMilliseconds;
});
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function addMilliseconds(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var timestamp = (0, _indexJsDefault1.default)(dirtyDate).getTime();
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    return new Date(timestamp + amount);
}

},{"../_lib/toInteger/index.js":"dkWbJ","../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"72xLL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return addISOWeekYears;
});
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../getISOWeekYear/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../setISOWeekYear/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
function addISOWeekYears(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault3.default)(2, arguments);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    return (0, _indexJsDefault2.default)(dirtyDate, (0, _indexJsDefault1.default)(dirtyDate) + amount);
}

},{"../_lib/toInteger/index.js":"dkWbJ","../getISOWeekYear/index.js":"5i5mG","../setISOWeekYear/index.js":"lErLA","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5i5mG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getISOWeekYear;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfISOWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function getISOWeekYear(dirtyDate) {
    (0, _indexJsDefault2.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var year = date.getFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    var startOfNextYear = (0, _indexJsDefault1.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    var startOfThisYear = (0, _indexJsDefault1.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

},{"../toDate/index.js":"elr3O","../startOfISOWeek/index.js":"iB7YK","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"iB7YK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return startOfISOWeek;
});
var _indexJs = require("../startOfWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function startOfISOWeek(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    return (0, _indexJsDefault.default)(dirtyDate, {
        weekStartsOn: 1
    });
}

},{"../startOfWeek/index.js":"em4Ab","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"em4Ab":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return startOfWeek;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/toInteger/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/defaultOptions/index.js");
function startOfWeek(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault2.default)(1, arguments);
    var defaultOptions = (0, _indexJs3.getDefaultOptions)();
    var weekStartsOn = (0, _indexJsDefault1.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setDate(date.getDate() - diff);
    date.setHours(0, 0, 0, 0);
    return date;
}

},{"../toDate/index.js":"elr3O","../_lib/toInteger/index.js":"dkWbJ","../_lib/requiredArgs/index.js":"14prD","../_lib/defaultOptions/index.js":"eo7FR","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"eo7FR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDefaultOptions", function() {
    return getDefaultOptions;
});
parcelHelpers.export(exports, "setDefaultOptions", function() {
    return setDefaultOptions;
});
var defaultOptions = {};
function getDefaultOptions() {
    return defaultOptions;
}
function setDefaultOptions(newOptions) {
    defaultOptions = newOptions;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"lErLA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return setISOWeekYear;
});
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../startOfISOWeekYear/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../differenceInCalendarDays/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
function setISOWeekYear(dirtyDate, dirtyISOWeekYear) {
    (0, _indexJsDefault4.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var isoWeekYear = (0, _indexJsDefault.default)(dirtyISOWeekYear);
    var diff = (0, _indexJsDefault3.default)(date, (0, _indexJsDefault2.default)(date));
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setFullYear(isoWeekYear, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    date = (0, _indexJsDefault2.default)(fourthOfJanuary);
    date.setDate(date.getDate() + diff);
    return date;
}

},{"../_lib/toInteger/index.js":"dkWbJ","../toDate/index.js":"elr3O","../startOfISOWeekYear/index.js":"7AEM8","../differenceInCalendarDays/index.js":"44jgD","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7AEM8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return startOfISOWeekYear;
});
var _indexJs = require("../getISOWeekYear/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfISOWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function startOfISOWeekYear(dirtyDate) {
    (0, _indexJsDefault2.default)(1, arguments);
    var year = (0, _indexJsDefault.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    var date = (0, _indexJsDefault1.default)(fourthOfJanuary);
    return date;
}

},{"../getISOWeekYear/index.js":"5i5mG","../startOfISOWeek/index.js":"iB7YK","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"44jgD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return differenceInCalendarDays;
});
var _indexJs = require("../_lib/getTimezoneOffsetInMilliseconds/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfDay/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var MILLISECONDS_IN_DAY = 86400000;
function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault2.default)(2, arguments);
    var startOfDayLeft = (0, _indexJsDefault1.default)(dirtyDateLeft);
    var startOfDayRight = (0, _indexJsDefault1.default)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, _indexJsDefault.default)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, _indexJsDefault.default)(startOfDayRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
}

},{"../_lib/getTimezoneOffsetInMilliseconds/index.js":"3kvOg","../startOfDay/index.js":"g4xpx","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3kvOg":[function(require,module,exports,__globalThis) {
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getTimezoneOffsetInMilliseconds;
});
function getTimezoneOffsetInMilliseconds(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"g4xpx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return startOfDay;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function startOfDay(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}

},{"../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"a9kHu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return addMinutes;
});
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../addMilliseconds/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var MILLISECONDS_IN_MINUTE = 60000;
function addMinutes(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    return (0, _indexJsDefault1.default)(dirtyDate, amount * MILLISECONDS_IN_MINUTE);
}

},{"../_lib/toInteger/index.js":"dkWbJ","../addMilliseconds/index.js":"bkMDO","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3QFLI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return addQuarters;
});
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../addMonths/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function addQuarters(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    var months = amount * 3;
    return (0, _indexJsDefault1.default)(dirtyDate, months);
}

},{"../_lib/toInteger/index.js":"dkWbJ","../addMonths/index.js":"3fsvC","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7tH0p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return addSeconds;
});
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../addMilliseconds/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function addSeconds(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    return (0, _indexJsDefault1.default)(dirtyDate, amount * 1000);
}

},{"../_lib/toInteger/index.js":"dkWbJ","../addMilliseconds/index.js":"bkMDO","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jdo2p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return addWeeks;
});
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../addDays/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function addWeeks(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    var days = amount * 7;
    return (0, _indexJsDefault1.default)(dirtyDate, days);
}

},{"../_lib/toInteger/index.js":"dkWbJ","../addDays/index.js":"3C7cL","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"fLqeW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return addYears;
});
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../addMonths/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function addYears(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    return (0, _indexJsDefault1.default)(dirtyDate, amount * 12);
}

},{"../_lib/toInteger/index.js":"dkWbJ","../addMonths/index.js":"3fsvC","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1fm88":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return areIntervalsOverlapping;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function areIntervalsOverlapping(intervalLeft, intervalRight, options) {
    (0, _indexJsDefault1.default)(2, arguments);
    var leftStartTime = (0, _indexJsDefault.default)(intervalLeft === null || intervalLeft === void 0 ? void 0 : intervalLeft.start).getTime();
    var leftEndTime = (0, _indexJsDefault.default)(intervalLeft === null || intervalLeft === void 0 ? void 0 : intervalLeft.end).getTime();
    var rightStartTime = (0, _indexJsDefault.default)(intervalRight === null || intervalRight === void 0 ? void 0 : intervalRight.start).getTime();
    var rightEndTime = (0, _indexJsDefault.default)(intervalRight === null || intervalRight === void 0 ? void 0 : intervalRight.end).getTime();
    // Throw an exception if start date is after end date or if any date is `Invalid Date`
    if (!(leftStartTime <= leftEndTime && rightStartTime <= rightEndTime)) throw new RangeError('Invalid interval');
    if (options !== null && options !== void 0 && options.inclusive) return leftStartTime <= rightEndTime && rightStartTime <= leftEndTime;
    return leftStartTime < rightEndTime && rightStartTime < leftEndTime;
}

},{"../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"kLnLh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return clamp;
});
var _indexJs = require("../max/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../min/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function clamp(date, _ref) {
    var start = _ref.start, end = _ref.end;
    (0, _indexJsDefault2.default)(2, arguments);
    return (0, _indexJsDefault1.default)([
        (0, _indexJsDefault.default)([
            date,
            start
        ]),
        end
    ]);
}

},{"../max/index.js":"81MHx","../min/index.js":"e4nKp","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"81MHx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return max;
});
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function max(dirtyDatesArray) {
    (0, _indexJsDefault1.default)(1, arguments);
    var datesArray;
    // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
    if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') datesArray = dirtyDatesArray;
    else if ((0, _typeofDefault.default)(dirtyDatesArray) === 'object' && dirtyDatesArray !== null) datesArray = Array.prototype.slice.call(dirtyDatesArray);
    else // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
    var result;
    datesArray.forEach(function(dirtyDate) {
        var currentDate = (0, _indexJsDefault.default)(dirtyDate);
        if (result === undefined || result < currentDate || isNaN(Number(currentDate))) result = currentDate;
    });
    return result || new Date(NaN);
}

},{"@babel/runtime/helpers/esm/typeof":"8bpl6","../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"e4nKp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return min;
});
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function min(dirtyDatesArray) {
    (0, _indexJsDefault1.default)(1, arguments);
    var datesArray;
    // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
    if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') datesArray = dirtyDatesArray;
    else if ((0, _typeofDefault.default)(dirtyDatesArray) === 'object' && dirtyDatesArray !== null) datesArray = Array.prototype.slice.call(dirtyDatesArray);
    else // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
    var result;
    datesArray.forEach(function(dirtyDate) {
        var currentDate = (0, _indexJsDefault.default)(dirtyDate);
        if (result === undefined || result > currentDate || isNaN(currentDate.getDate())) result = currentDate;
    });
    return result || new Date(NaN);
}

},{"@babel/runtime/helpers/esm/typeof":"8bpl6","../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3vUGo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return closestIndexTo;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function closestIndexTo(dirtyDateToCompare, dirtyDatesArray) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateToCompare = (0, _indexJsDefault.default)(dirtyDateToCompare);
    if (isNaN(Number(dateToCompare))) return NaN;
    var timeToCompare = dateToCompare.getTime();
    var datesArray;
    // `dirtyDatesArray` is undefined or null
    if (dirtyDatesArray == null) datesArray = [];
    else if (typeof dirtyDatesArray.forEach === 'function') datesArray = dirtyDatesArray;
    else datesArray = Array.prototype.slice.call(dirtyDatesArray);
    var result;
    var minDistance;
    datesArray.forEach(function(dirtyDate, index) {
        var currentDate = (0, _indexJsDefault.default)(dirtyDate);
        if (isNaN(Number(currentDate))) {
            result = NaN;
            minDistance = NaN;
            return;
        }
        var distance = Math.abs(timeToCompare - currentDate.getTime());
        if (result == null || distance < Number(minDistance)) {
            result = index;
            minDistance = distance;
        }
    });
    return result;
}

},{"../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5nvWr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return closestTo;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function closestTo(dirtyDateToCompare, dirtyDatesArray) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateToCompare = (0, _indexJsDefault.default)(dirtyDateToCompare);
    if (isNaN(Number(dateToCompare))) return new Date(NaN);
    var timeToCompare = dateToCompare.getTime();
    var datesArray;
    // `dirtyDatesArray` is undefined or null
    if (dirtyDatesArray == null) datesArray = [];
    else if (typeof dirtyDatesArray.forEach === 'function') datesArray = dirtyDatesArray;
    else datesArray = Array.prototype.slice.call(dirtyDatesArray);
    var result;
    var minDistance;
    datesArray.forEach(function(dirtyDate) {
        var currentDate = (0, _indexJsDefault.default)(dirtyDate);
        if (isNaN(Number(currentDate))) {
            result = new Date(NaN);
            minDistance = NaN;
            return;
        }
        var distance = Math.abs(timeToCompare - currentDate.getTime());
        if (result == null || distance < Number(minDistance)) {
            result = currentDate;
            minDistance = distance;
        }
    });
    return result;
}

},{"../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jbQZt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return compareAsc;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function compareAsc(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateLeft = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRight = (0, _indexJsDefault.default)(dirtyDateRight);
    var diff = dateLeft.getTime() - dateRight.getTime();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}

},{"../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1lWbr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return compareDesc;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function compareDesc(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateLeft = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRight = (0, _indexJsDefault.default)(dirtyDateRight);
    var diff = dateLeft.getTime() - dateRight.getTime();
    if (diff > 0) return -1;
    else if (diff < 0) return 1;
    else return diff;
}

},{"../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"iatfg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return daysToWeeks;
});
var _indexJs = require("../_lib/requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../constants/index.js");
function daysToWeeks(days) {
    (0, _indexJsDefault.default)(1, arguments);
    var weeks = days / (0, _indexJs1.daysInWeek);
    return Math.floor(weeks);
}

},{"../_lib/requiredArgs/index.js":"14prD","../constants/index.js":"k64Zq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"k64Zq":[function(require,module,exports,__globalThis) {
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "daysInWeek", function() {
    return daysInWeek;
});
parcelHelpers.export(exports, "daysInYear", function() {
    return daysInYear;
});
parcelHelpers.export(exports, "maxTime", function() {
    return maxTime;
});
parcelHelpers.export(exports, "millisecondsInMinute", function() {
    return millisecondsInMinute;
});
parcelHelpers.export(exports, "millisecondsInHour", function() {
    return millisecondsInHour;
});
parcelHelpers.export(exports, "millisecondsInSecond", function() {
    return millisecondsInSecond;
});
parcelHelpers.export(exports, "minTime", function() {
    return minTime;
});
parcelHelpers.export(exports, "minutesInHour", function() {
    return minutesInHour;
});
parcelHelpers.export(exports, "monthsInQuarter", function() {
    return monthsInQuarter;
});
parcelHelpers.export(exports, "monthsInYear", function() {
    return monthsInYear;
});
parcelHelpers.export(exports, "quartersInYear", function() {
    return quartersInYear;
});
parcelHelpers.export(exports, "secondsInHour", function() {
    return secondsInHour;
});
parcelHelpers.export(exports, "secondsInMinute", function() {
    return secondsInMinute;
});
parcelHelpers.export(exports, "secondsInDay", function() {
    return secondsInDay;
});
parcelHelpers.export(exports, "secondsInWeek", function() {
    return secondsInWeek;
});
parcelHelpers.export(exports, "secondsInYear", function() {
    return secondsInYear;
});
parcelHelpers.export(exports, "secondsInMonth", function() {
    return secondsInMonth;
});
parcelHelpers.export(exports, "secondsInQuarter", function() {
    return secondsInQuarter;
});
var daysInWeek = 7;
var daysInYear = 365.2425;
var maxTime = Math.pow(10, 8) * 86400000;
var millisecondsInMinute = 60000;
var millisecondsInHour = 3600000;
var millisecondsInSecond = 1000;
var minTime = -maxTime;
var minutesInHour = 60;
var monthsInQuarter = 3;
var monthsInYear = 12;
var quartersInYear = 4;
var secondsInHour = 3600;
var secondsInMinute = 60;
var secondsInDay = secondsInHour * 24;
var secondsInWeek = secondsInDay * 7;
var secondsInYear = secondsInDay * daysInYear;
var secondsInMonth = secondsInYear / 12;
var secondsInQuarter = secondsInMonth * 3;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"bgyXf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return differenceInBusinessDays;
});
var _indexJs = require("../addDays/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../differenceInCalendarDays/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../isSameDay/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../isValid/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../isWeekend/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
var _indexJs5 = require("../toDate/index.js");
var _indexJsDefault5 = parcelHelpers.interopDefault(_indexJs5);
var _indexJs6 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault6 = parcelHelpers.interopDefault(_indexJs6);
var _indexJs7 = require("../_lib/toInteger/index.js");
var _indexJsDefault7 = parcelHelpers.interopDefault(_indexJs7);
function differenceInBusinessDays(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault6.default)(2, arguments);
    var dateLeft = (0, _indexJsDefault5.default)(dirtyDateLeft);
    var dateRight = (0, _indexJsDefault5.default)(dirtyDateRight);
    if (!(0, _indexJsDefault3.default)(dateLeft) || !(0, _indexJsDefault3.default)(dateRight)) return NaN;
    var calendarDifference = (0, _indexJsDefault1.default)(dateLeft, dateRight);
    var sign = calendarDifference < 0 ? -1 : 1;
    var weeks = (0, _indexJsDefault7.default)(calendarDifference / 7);
    var result = weeks * 5;
    dateRight = (0, _indexJsDefault.default)(dateRight, weeks * 7);
    // the loop below will run at most 6 times to account for the remaining days that don't makeup a full week
    while(!(0, _indexJsDefault2.default)(dateLeft, dateRight)){
        // sign is used to account for both negative and positive differences
        result += (0, _indexJsDefault4.default)(dateRight) ? 0 : sign;
        dateRight = (0, _indexJsDefault.default)(dateRight, sign);
    }
    return result === 0 ? 0 : result;
}

},{"../addDays/index.js":"3C7cL","../differenceInCalendarDays/index.js":"44jgD","../isSameDay/index.js":"8u23d","../isValid/index.js":"fScb4","../isWeekend/index.js":"6gjaR","../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","../_lib/toInteger/index.js":"dkWbJ","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8u23d":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isSameDay;
});
var _indexJs = require("../startOfDay/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isSameDay(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateLeftStartOfDay = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRightStartOfDay = (0, _indexJsDefault.default)(dirtyDateRight);
    return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

},{"../startOfDay/index.js":"g4xpx","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"fScb4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isValid;
});
var _indexJs = require("../isDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function isValid(dirtyDate) {
    (0, _indexJsDefault2.default)(1, arguments);
    if (!(0, _indexJsDefault.default)(dirtyDate) && typeof dirtyDate !== 'number') return false;
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    return !isNaN(Number(date));
}

},{"../isDate/index.js":"5222M","../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5222M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isDate;
});
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _indexJs = require("../_lib/requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function isDate(value) {
    (0, _indexJsDefault.default)(1, arguments);
    return value instanceof Date || (0, _typeofDefault.default)(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

},{"@babel/runtime/helpers/esm/typeof":"8bpl6","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"kUQqi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return differenceInCalendarISOWeekYears;
});
var _indexJs = require("../getISOWeekYear/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function differenceInCalendarISOWeekYears(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault1.default)(2, arguments);
    return (0, _indexJsDefault.default)(dirtyDateLeft) - (0, _indexJsDefault.default)(dirtyDateRight);
}

},{"../getISOWeekYear/index.js":"5i5mG","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7WjuL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return differenceInCalendarISOWeeks;
});
var _indexJs = require("../_lib/getTimezoneOffsetInMilliseconds/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfISOWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var MILLISECONDS_IN_WEEK = 604800000;
function differenceInCalendarISOWeeks(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault2.default)(2, arguments);
    var startOfISOWeekLeft = (0, _indexJsDefault1.default)(dirtyDateLeft);
    var startOfISOWeekRight = (0, _indexJsDefault1.default)(dirtyDateRight);
    var timestampLeft = startOfISOWeekLeft.getTime() - (0, _indexJsDefault.default)(startOfISOWeekLeft);
    var timestampRight = startOfISOWeekRight.getTime() - (0, _indexJsDefault.default)(startOfISOWeekRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK);
}

},{"../_lib/getTimezoneOffsetInMilliseconds/index.js":"3kvOg","../startOfISOWeek/index.js":"iB7YK","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2NHrG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return differenceInCalendarMonths;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateLeft = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRight = (0, _indexJsDefault.default)(dirtyDateRight);
    var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
    var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}

},{"../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6WkeE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return differenceInCalendarQuarters;
});
var _indexJs = require("../getQuarter/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function differenceInCalendarQuarters(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault2.default)(2, arguments);
    var dateLeft = (0, _indexJsDefault1.default)(dirtyDateLeft);
    var dateRight = (0, _indexJsDefault1.default)(dirtyDateRight);
    var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
    var quarterDiff = (0, _indexJsDefault.default)(dateLeft) - (0, _indexJsDefault.default)(dateRight);
    return yearDiff * 4 + quarterDiff;
}

},{"../getQuarter/index.js":"ejE5L","../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"ejE5L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getQuarter;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getQuarter(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var quarter = Math.floor(date.getMonth() / 3) + 1;
    return quarter;
}

},{"../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6bPYn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return differenceInCalendarWeeks;
});
var _indexJs = require("../startOfWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/getTimezoneOffsetInMilliseconds/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var MILLISECONDS_IN_WEEK = 604800000;
function differenceInCalendarWeeks(dirtyDateLeft, dirtyDateRight, options) {
    (0, _indexJsDefault2.default)(2, arguments);
    var startOfWeekLeft = (0, _indexJsDefault.default)(dirtyDateLeft, options);
    var startOfWeekRight = (0, _indexJsDefault.default)(dirtyDateRight, options);
    var timestampLeft = startOfWeekLeft.getTime() - (0, _indexJsDefault1.default)(startOfWeekLeft);
    var timestampRight = startOfWeekRight.getTime() - (0, _indexJsDefault1.default)(startOfWeekRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK);
}

},{"../startOfWeek/index.js":"em4Ab","../_lib/getTimezoneOffsetInMilliseconds/index.js":"3kvOg","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"dQoj8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return differenceInCalendarYears;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function differenceInCalendarYears(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateLeft = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRight = (0, _indexJsDefault.default)(dirtyDateRight);
    return dateLeft.getFullYear() - dateRight.getFullYear();
}

},{"../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"88cpp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return differenceInDays;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../differenceInCalendarDays/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js"); // Like `compareAsc` but uses local time not UTC, which is needed
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function compareLocalAsc(dateLeft, dateRight) {
    var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}
function differenceInDays(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault2.default)(2, arguments);
    var dateLeft = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRight = (0, _indexJsDefault.default)(dirtyDateRight);
    var sign = compareLocalAsc(dateLeft, dateRight);
    var difference = Math.abs((0, _indexJsDefault1.default)(dateLeft, dateRight));
    dateLeft.setDate(dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastDayNotFull = Number(compareLocalAsc(dateLeft, dateRight) === -sign);
    var result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

},{"../toDate/index.js":"elr3O","../differenceInCalendarDays/index.js":"44jgD","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"fil0n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return differenceInHours;
});
var _indexJs = require("../constants/index.js");
var _indexJs1 = require("../differenceInMilliseconds/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/roundingMethods/index.js");
function differenceInHours(dateLeft, dateRight, options) {
    (0, _indexJsDefault1.default)(2, arguments);
    var diff = (0, _indexJsDefault.default)(dateLeft, dateRight) / (0, _indexJs.millisecondsInHour);
    return (0, _indexJs3.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

},{"../constants/index.js":"k64Zq","../differenceInMilliseconds/index.js":"4H1yL","../_lib/requiredArgs/index.js":"14prD","../_lib/roundingMethods/index.js":"fJBC4","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4H1yL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return differenceInMilliseconds;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function differenceInMilliseconds(dateLeft, dateRight) {
    (0, _indexJsDefault1.default)(2, arguments);
    return (0, _indexJsDefault.default)(dateLeft).getTime() - (0, _indexJsDefault.default)(dateRight).getTime();
}

},{"../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"fJBC4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRoundingMethod", function() {
    return getRoundingMethod;
});
var roundingMap = {
    ceil: Math.ceil,
    round: Math.round,
    floor: Math.floor,
    trunc: function trunc(value) {
        return value < 0 ? Math.ceil(value) : Math.floor(value);
    } // Math.trunc is not supported by IE
};
var defaultRoundingMethod = 'trunc';
function getRoundingMethod(method) {
    return method ? roundingMap[method] : roundingMap[defaultRoundingMethod];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4CFRz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return differenceInISOWeekYears;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../differenceInCalendarISOWeekYears/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../compareAsc/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../subISOWeekYears/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
function differenceInISOWeekYears(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault4.default)(2, arguments);
    var dateLeft = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRight = (0, _indexJsDefault.default)(dirtyDateRight);
    var sign = (0, _indexJsDefault2.default)(dateLeft, dateRight);
    var difference = Math.abs((0, _indexJsDefault1.default)(dateLeft, dateRight));
    dateLeft = (0, _indexJsDefault3.default)(dateLeft, sign * difference);
    // Math.abs(diff in full ISO years - diff in calendar ISO years) === 1
    // if last calendar ISO year is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastISOWeekYearNotFull = Number((0, _indexJsDefault2.default)(dateLeft, dateRight) === -sign);
    var result = sign * (difference - isLastISOWeekYearNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

},{"../toDate/index.js":"elr3O","../differenceInCalendarISOWeekYears/index.js":"kUQqi","../compareAsc/index.js":"jbQZt","../subISOWeekYears/index.js":"1VWSB","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1VWSB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return subISOWeekYears;
});
var _indexJs = require("../addISOWeekYears/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function subISOWeekYears(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault1.default)(2, arguments);
    var amount = (0, _indexJsDefault2.default)(dirtyAmount);
    return (0, _indexJsDefault.default)(dirtyDate, -amount);
}

},{"../addISOWeekYears/index.js":"72xLL","../_lib/requiredArgs/index.js":"14prD","../_lib/toInteger/index.js":"dkWbJ","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"cEAnJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return differenceInMinutes;
});
var _indexJs = require("../constants/index.js");
var _indexJs1 = require("../differenceInMilliseconds/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/roundingMethods/index.js");
function differenceInMinutes(dateLeft, dateRight, options) {
    (0, _indexJsDefault1.default)(2, arguments);
    var diff = (0, _indexJsDefault.default)(dateLeft, dateRight) / (0, _indexJs.millisecondsInMinute);
    return (0, _indexJs3.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

},{"../constants/index.js":"k64Zq","../differenceInMilliseconds/index.js":"4H1yL","../_lib/requiredArgs/index.js":"14prD","../_lib/roundingMethods/index.js":"fJBC4","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7dsnu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return differenceInMonths;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../differenceInCalendarMonths/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../compareAsc/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../isLastDayOfMonth/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
function differenceInMonths(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault3.default)(2, arguments);
    var dateLeft = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRight = (0, _indexJsDefault.default)(dirtyDateRight);
    var sign = (0, _indexJsDefault2.default)(dateLeft, dateRight);
    var difference = Math.abs((0, _indexJsDefault1.default)(dateLeft, dateRight));
    var result;
    // Check for the difference of less than month
    if (difference < 1) result = 0;
    else {
        if (dateLeft.getMonth() === 1 && dateLeft.getDate() > 27) // This will check if the date is end of Feb and assign a higher end of month date
        // to compare it with Jan
        dateLeft.setDate(30);
        dateLeft.setMonth(dateLeft.getMonth() - sign * difference);
        // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
        // If so, result must be decreased by 1 in absolute value
        var isLastMonthNotFull = (0, _indexJsDefault2.default)(dateLeft, dateRight) === -sign;
        // Check for cases of one full calendar month
        if ((0, _indexJsDefault4.default)((0, _indexJsDefault.default)(dirtyDateLeft)) && difference === 1 && (0, _indexJsDefault2.default)(dirtyDateLeft, dateRight) === 1) isLastMonthNotFull = false;
        result = sign * (difference - Number(isLastMonthNotFull));
    }
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

},{"../toDate/index.js":"elr3O","../differenceInCalendarMonths/index.js":"2NHrG","../compareAsc/index.js":"jbQZt","../_lib/requiredArgs/index.js":"14prD","../isLastDayOfMonth/index.js":"cqOk0","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"cqOk0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isLastDayOfMonth;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../endOfDay/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../endOfMonth/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
function isLastDayOfMonth(dirtyDate) {
    (0, _indexJsDefault3.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    return (0, _indexJsDefault1.default)(date).getTime() === (0, _indexJsDefault2.default)(date).getTime();
}

},{"../toDate/index.js":"elr3O","../endOfDay/index.js":"9HfEy","../endOfMonth/index.js":"fY6SB","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"9HfEy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return endOfDay;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function endOfDay(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    date.setHours(23, 59, 59, 999);
    return date;
}

},{"../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"fY6SB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return endOfMonth;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function endOfMonth(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}

},{"../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6UwOj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return differenceInQuarters;
});
var _indexJs = require("../differenceInMonths/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/roundingMethods/index.js");
function differenceInQuarters(dateLeft, dateRight, options) {
    (0, _indexJsDefault1.default)(2, arguments);
    var diff = (0, _indexJsDefault.default)(dateLeft, dateRight) / 3;
    return (0, _indexJs2.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

},{"../differenceInMonths/index.js":"7dsnu","../_lib/requiredArgs/index.js":"14prD","../_lib/roundingMethods/index.js":"fJBC4","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"40bOi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return differenceInSeconds;
});
var _indexJs = require("../differenceInMilliseconds/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/roundingMethods/index.js");
function differenceInSeconds(dateLeft, dateRight, options) {
    (0, _indexJsDefault1.default)(2, arguments);
    var diff = (0, _indexJsDefault.default)(dateLeft, dateRight) / 1000;
    return (0, _indexJs2.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

},{"../differenceInMilliseconds/index.js":"4H1yL","../_lib/requiredArgs/index.js":"14prD","../_lib/roundingMethods/index.js":"fJBC4","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5SadI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return differenceInWeeks;
});
var _indexJs = require("../differenceInDays/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/roundingMethods/index.js");
function differenceInWeeks(dateLeft, dateRight, options) {
    (0, _indexJsDefault1.default)(2, arguments);
    var diff = (0, _indexJsDefault.default)(dateLeft, dateRight) / 7;
    return (0, _indexJs2.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

},{"../differenceInDays/index.js":"88cpp","../_lib/requiredArgs/index.js":"14prD","../_lib/roundingMethods/index.js":"fJBC4","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gJB8K":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return differenceInYears;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../differenceInCalendarYears/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../compareAsc/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
function differenceInYears(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault3.default)(2, arguments);
    var dateLeft = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRight = (0, _indexJsDefault.default)(dirtyDateRight);
    var sign = (0, _indexJsDefault2.default)(dateLeft, dateRight);
    var difference = Math.abs((0, _indexJsDefault1.default)(dateLeft, dateRight));
    // Set both dates to a valid leap year for accurate comparison when dealing
    // with leap days
    dateLeft.setFullYear(1584);
    dateRight.setFullYear(1584);
    // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastYearNotFull = (0, _indexJsDefault2.default)(dateLeft, dateRight) === -sign;
    var result = sign * (difference - Number(isLastYearNotFull));
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

},{"../toDate/index.js":"elr3O","../differenceInCalendarYears/index.js":"dQoj8","../compareAsc/index.js":"jbQZt","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"lO9GP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return eachDayOfInterval;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function eachDayOfInterval(dirtyInterval, options) {
    var _options$step;
    (0, _indexJsDefault1.default)(1, arguments);
    var interval = dirtyInterval || {};
    var startDate = (0, _indexJsDefault.default)(interval.start);
    var endDate = (0, _indexJsDefault.default)(interval.end);
    var endTime = endDate.getTime();
    // Throw an exception if start date is after end date or if any date is `Invalid Date`
    if (!(startDate.getTime() <= endTime)) throw new RangeError('Invalid interval');
    var dates = [];
    var currentDate = startDate;
    currentDate.setHours(0, 0, 0, 0);
    var step = Number((_options$step = options === null || options === void 0 ? void 0 : options.step) !== null && _options$step !== void 0 ? _options$step : 1);
    if (step < 1 || isNaN(step)) throw new RangeError('`options.step` must be a number greater than 1');
    while(currentDate.getTime() <= endTime){
        dates.push((0, _indexJsDefault.default)(currentDate));
        currentDate.setDate(currentDate.getDate() + step);
        currentDate.setHours(0, 0, 0, 0);
    }
    return dates;
}

},{"../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2CuLe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return eachHourOfInterval;
});
var _indexJs = require("../addHours/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function eachHourOfInterval(dirtyInterval, options) {
    var _options$step;
    (0, _indexJsDefault2.default)(1, arguments);
    var interval = dirtyInterval || {};
    var startDate = (0, _indexJsDefault1.default)(interval.start);
    var endDate = (0, _indexJsDefault1.default)(interval.end);
    var startTime = startDate.getTime();
    var endTime = endDate.getTime();
    // Throw an exception if start date is after end date or if any date is `Invalid Date`
    if (!(startTime <= endTime)) throw new RangeError('Invalid interval');
    var dates = [];
    var currentDate = startDate;
    currentDate.setMinutes(0, 0, 0);
    var step = Number((_options$step = options === null || options === void 0 ? void 0 : options.step) !== null && _options$step !== void 0 ? _options$step : 1);
    if (step < 1 || isNaN(step)) throw new RangeError('`options.step` must be a number greater than 1');
    while(currentDate.getTime() <= endTime){
        dates.push((0, _indexJsDefault1.default)(currentDate));
        currentDate = (0, _indexJsDefault.default)(currentDate, step);
    }
    return dates;
}

},{"../addHours/index.js":"87L7P","../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"kKbgf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return eachMinuteOfInterval;
});
var _indexJs = require("../addMinutes/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../startOfMinute/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
function eachMinuteOfInterval(interval, options) {
    var _options$step;
    (0, _indexJsDefault3.default)(1, arguments);
    var startDate = (0, _indexJsDefault2.default)((0, _indexJsDefault1.default)(interval.start));
    var endDate = (0, _indexJsDefault1.default)(interval.end);
    var startTime = startDate.getTime();
    var endTime = endDate.getTime();
    if (startTime >= endTime) throw new RangeError('Invalid interval');
    var dates = [];
    var currentDate = startDate;
    var step = Number((_options$step = options === null || options === void 0 ? void 0 : options.step) !== null && _options$step !== void 0 ? _options$step : 1);
    if (step < 1 || isNaN(step)) throw new RangeError('`options.step` must be a number equal to or greater than 1');
    while(currentDate.getTime() <= endTime){
        dates.push((0, _indexJsDefault1.default)(currentDate));
        currentDate = (0, _indexJsDefault.default)(currentDate, step);
    }
    return dates;
}

},{"../addMinutes/index.js":"a9kHu","../toDate/index.js":"elr3O","../startOfMinute/index.js":"ioXMa","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"ioXMa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return startOfMinute;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function startOfMinute(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    date.setSeconds(0, 0);
    return date;
}

},{"../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"a3UAO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return eachMonthOfInterval;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function eachMonthOfInterval(dirtyInterval) {
    (0, _indexJsDefault1.default)(1, arguments);
    var interval = dirtyInterval || {};
    var startDate = (0, _indexJsDefault.default)(interval.start);
    var endDate = (0, _indexJsDefault.default)(interval.end);
    var endTime = endDate.getTime();
    var dates = [];
    // Throw an exception if start date is after end date or if any date is `Invalid Date`
    if (!(startDate.getTime() <= endTime)) throw new RangeError('Invalid interval');
    var currentDate = startDate;
    currentDate.setHours(0, 0, 0, 0);
    currentDate.setDate(1);
    while(currentDate.getTime() <= endTime){
        dates.push((0, _indexJsDefault.default)(currentDate));
        currentDate.setMonth(currentDate.getMonth() + 1);
    }
    return dates;
}

},{"../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jiPqr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return eachQuarterOfInterval;
});
var _indexJs = require("../addQuarters/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfQuarter/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../toDate/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
function eachQuarterOfInterval(dirtyInterval) {
    (0, _indexJsDefault3.default)(1, arguments);
    var interval = dirtyInterval || {};
    var startDate = (0, _indexJsDefault2.default)(interval.start);
    var endDate = (0, _indexJsDefault2.default)(interval.end);
    var endTime = endDate.getTime();
    // Throw an exception if start date is after end date or if any date is `Invalid Date`
    if (!(startDate.getTime() <= endTime)) throw new RangeError('Invalid interval');
    var startDateQuarter = (0, _indexJsDefault1.default)(startDate);
    var endDateQuarter = (0, _indexJsDefault1.default)(endDate);
    endTime = endDateQuarter.getTime();
    var quarters = [];
    var currentQuarter = startDateQuarter;
    while(currentQuarter.getTime() <= endTime){
        quarters.push((0, _indexJsDefault2.default)(currentQuarter));
        currentQuarter = (0, _indexJsDefault.default)(currentQuarter, 1);
    }
    return quarters;
}

},{"../addQuarters/index.js":"3QFLI","../startOfQuarter/index.js":"k4fkG","../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"k4fkG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return startOfQuarter;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function startOfQuarter(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var currentMonth = date.getMonth();
    var month = currentMonth - currentMonth % 3;
    date.setMonth(month, 1);
    date.setHours(0, 0, 0, 0);
    return date;
}

},{"../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"hJ9yE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return eachWeekOfInterval;
});
var _indexJs = require("../addWeeks/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../toDate/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
function eachWeekOfInterval(dirtyInterval, options) {
    (0, _indexJsDefault3.default)(1, arguments);
    var interval = dirtyInterval || {};
    var startDate = (0, _indexJsDefault2.default)(interval.start);
    var endDate = (0, _indexJsDefault2.default)(interval.end);
    var endTime = endDate.getTime();
    // Throw an exception if start date is after end date or if any date is `Invalid Date`
    if (!(startDate.getTime() <= endTime)) throw new RangeError('Invalid interval');
    var startDateWeek = (0, _indexJsDefault1.default)(startDate, options);
    var endDateWeek = (0, _indexJsDefault1.default)(endDate, options);
    // Some timezones switch DST at midnight, making start of day unreliable in these timezones, 3pm is a safe bet
    startDateWeek.setHours(15);
    endDateWeek.setHours(15);
    endTime = endDateWeek.getTime();
    var weeks = [];
    var currentWeek = startDateWeek;
    while(currentWeek.getTime() <= endTime){
        currentWeek.setHours(0);
        weeks.push((0, _indexJsDefault2.default)(currentWeek));
        currentWeek = (0, _indexJsDefault.default)(currentWeek, 1);
        currentWeek.setHours(15);
    }
    return weeks;
}

},{"../addWeeks/index.js":"jdo2p","../startOfWeek/index.js":"em4Ab","../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2L0Yg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return eachWeekendOfInterval;
});
var _indexJs = require("../eachDayOfInterval/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../isSunday/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../isWeekend/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
function eachWeekendOfInterval(interval) {
    (0, _indexJsDefault3.default)(1, arguments);
    var dateInterval = (0, _indexJsDefault.default)(interval);
    var weekends = [];
    var index = 0;
    while(index < dateInterval.length){
        var date = dateInterval[index++];
        if ((0, _indexJsDefault2.default)(date)) {
            weekends.push(date);
            if ((0, _indexJsDefault1.default)(date)) index = index + 5;
        }
    }
    return weekends;
}

},{"../eachDayOfInterval/index.js":"lO9GP","../isSunday/index.js":"eveXy","../isWeekend/index.js":"6gjaR","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8g6dC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return eachWeekendOfMonth;
});
var _indexJs = require("../eachWeekendOfInterval/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfMonth/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../endOfMonth/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
function eachWeekendOfMonth(dirtyDate) {
    (0, _indexJsDefault3.default)(1, arguments);
    var startDate = (0, _indexJsDefault1.default)(dirtyDate);
    if (isNaN(startDate.getTime())) throw new RangeError('The passed date is invalid');
    var endDate = (0, _indexJsDefault2.default)(dirtyDate);
    return (0, _indexJsDefault.default)({
        start: startDate,
        end: endDate
    });
}

},{"../eachWeekendOfInterval/index.js":"2L0Yg","../startOfMonth/index.js":"4MG0j","../endOfMonth/index.js":"fY6SB","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4MG0j":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return startOfMonth;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function startOfMonth(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
    return date;
}

},{"../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"dGcPn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return eachWeekendOfYear;
});
var _indexJs = require("../eachWeekendOfInterval/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../endOfYear/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../startOfYear/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
function eachWeekendOfYear(dirtyDate) {
    (0, _indexJsDefault3.default)(1, arguments);
    var startDate = (0, _indexJsDefault2.default)(dirtyDate);
    var endDate = (0, _indexJsDefault1.default)(dirtyDate);
    return (0, _indexJsDefault.default)({
        start: startDate,
        end: endDate
    });
}

},{"../eachWeekendOfInterval/index.js":"2L0Yg","../endOfYear/index.js":"eI4Oq","../startOfYear/index.js":"iKNfx","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"eI4Oq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return endOfYear;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function endOfYear(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var year = date.getFullYear();
    date.setFullYear(year + 1, 0, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}

},{"../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"iKNfx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return startOfYear;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function startOfYear(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var cleanDate = (0, _indexJsDefault.default)(dirtyDate);
    var date = new Date(0);
    date.setFullYear(cleanDate.getFullYear(), 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
}

},{"../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"hM5VS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return eachYearOfInterval;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function eachYearOfInterval(dirtyInterval) {
    (0, _indexJsDefault1.default)(1, arguments);
    var interval = dirtyInterval || {};
    var startDate = (0, _indexJsDefault.default)(interval.start);
    var endDate = (0, _indexJsDefault.default)(interval.end);
    var endTime = endDate.getTime();
    // Throw an exception if start date is after end date or if any date is `Invalid Date`
    if (!(startDate.getTime() <= endTime)) throw new RangeError('Invalid interval');
    var dates = [];
    var currentDate = startDate;
    currentDate.setHours(0, 0, 0, 0);
    currentDate.setMonth(0, 1);
    while(currentDate.getTime() <= endTime){
        dates.push((0, _indexJsDefault.default)(currentDate));
        currentDate.setFullYear(currentDate.getFullYear() + 1);
    }
    return dates;
}

},{"../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"iXWus":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return endOfDecade;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function endOfDecade(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var year = date.getFullYear();
    var decade = 9 + Math.floor(year / 10) * 10;
    date.setFullYear(decade, 11, 31);
    date.setHours(23, 59, 59, 999);
    return date;
}

},{"../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8xEyw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return endOfHour;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function endOfHour(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    date.setMinutes(59, 59, 999);
    return date;
}

},{"../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"l46rw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return endOfISOWeek;
});
var _indexJs = require("../endOfWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function endOfISOWeek(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    return (0, _indexJsDefault.default)(dirtyDate, {
        weekStartsOn: 1
    });
}

},{"../endOfWeek/index.js":"86Bk9","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"86Bk9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return endOfWeek;
});
var _indexJs = require("../_lib/defaultOptions/index.js");
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/toInteger/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs3);
function endOfWeek(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault2.default)(1, arguments);
    var defaultOptions = (0, _indexJs.getDefaultOptions)();
    var weekStartsOn = (0, _indexJsDefault1.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    date.setDate(date.getDate() + diff);
    date.setHours(23, 59, 59, 999);
    return date;
}

},{"../_lib/defaultOptions/index.js":"eo7FR","../toDate/index.js":"elr3O","../_lib/toInteger/index.js":"dkWbJ","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"lpCyy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return endOfISOWeekYear;
});
var _indexJs = require("../getISOWeekYear/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfISOWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function endOfISOWeekYear(dirtyDate) {
    (0, _indexJsDefault2.default)(1, arguments);
    var year = (0, _indexJsDefault.default)(dirtyDate);
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    var date = (0, _indexJsDefault1.default)(fourthOfJanuaryOfNextYear);
    date.setMilliseconds(date.getMilliseconds() - 1);
    return date;
}

},{"../getISOWeekYear/index.js":"5i5mG","../startOfISOWeek/index.js":"iB7YK","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3PHAt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return endOfMinute;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function endOfMinute(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    date.setSeconds(59, 999);
    return date;
}

},{"../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"eF1qJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return endOfQuarter;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function endOfQuarter(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var currentMonth = date.getMonth();
    var month = currentMonth - currentMonth % 3 + 3;
    date.setMonth(month, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}

},{"../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"cBffo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return endOfSecond;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function endOfSecond(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    date.setMilliseconds(999);
    return date;
}

},{"../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jJjn7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return endOfToday;
});
var _indexJs = require("../endOfDay/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function endOfToday() {
    return (0, _indexJsDefault.default)(Date.now());
}

},{"../endOfDay/index.js":"9HfEy","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6TsRs":[function(require,module,exports,__globalThis) {
/**
 * @name endOfTomorrow
 * @category Day Helpers
 * @summary Return the end of tomorrow.
 * @pure false
 *
 * @description
 * Return the end of tomorrow.
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `new Date()` internally hence impure and can't be safely curried.
 *
 * @returns {Date} the end of tomorrow
 *
 * @example
 * // If today is 6 October 2014:
 * const result = endOfTomorrow()
 * //=> Tue Oct 7 2014 23:59:59.999
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return endOfTomorrow;
});
function endOfTomorrow() {
    var now = new Date();
    var year = now.getFullYear();
    var month = now.getMonth();
    var day = now.getDate();
    var date = new Date(0);
    date.setFullYear(year, month, day + 1);
    date.setHours(23, 59, 59, 999);
    return date;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"9H1UJ":[function(require,module,exports,__globalThis) {
/**
 * @name endOfYesterday
 * @category Day Helpers
 * @summary Return the end of yesterday.
 * @pure false
 *
 * @description
 * Return the end of yesterday.
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `new Date()` internally hence impure and can't be safely curried.
 *
 * @returns {Date} the end of yesterday
 *
 * @example
 * // If today is 6 October 2014:
 * const result = endOfYesterday()
 * //=> Sun Oct 5 2014 23:59:59.999
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return endOfYesterday;
});
function endOfYesterday() {
    var now = new Date();
    var year = now.getFullYear();
    var month = now.getMonth();
    var day = now.getDate();
    var date = new Date(0);
    date.setFullYear(year, month, day - 1);
    date.setHours(23, 59, 59, 999);
    return date;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jeCXy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return format;
});
var _indexJs = require("../isValid/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../subMilliseconds/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../toDate/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/format/formatters/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../_lib/format/longFormatters/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
var _indexJs5 = require("../_lib/getTimezoneOffsetInMilliseconds/index.js");
var _indexJsDefault5 = parcelHelpers.interopDefault(_indexJs5);
var _indexJs6 = require("../_lib/protectedTokens/index.js");
var _indexJs7 = require("../_lib/toInteger/index.js");
var _indexJsDefault6 = parcelHelpers.interopDefault(_indexJs7);
var _indexJs8 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault7 = parcelHelpers.interopDefault(_indexJs8);
var _indexJs9 = require("../_lib/defaultOptions/index.js");
var _indexJs10 = require("../_lib/defaultLocale/index.js"); // This RegExp consists of three parts separated by `|`:
var _indexJsDefault8 = parcelHelpers.interopDefault(_indexJs10);
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function format(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, _indexJsDefault7.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, _indexJs9.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, _indexJsDefault8.default);
    var firstWeekContainsDate = (0, _indexJsDefault6.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, _indexJsDefault6.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (!locale.localize) throw new RangeError('locale must contain localize property');
    if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
    var originalDate = (0, _indexJsDefault2.default)(dirtyDate);
    if (!(0, _indexJsDefault.default)(originalDate)) throw new RangeError('Invalid time value');
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, _indexJsDefault5.default)(originalDate);
    var utcDate = (0, _indexJsDefault1.default)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match(longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = (0, _indexJsDefault4.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match(formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return cleanEscapedString(substring);
        var formatter = (0, _indexJsDefault3.default)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, _indexJs6.isProtectedWeekYearToken)(substring)) (0, _indexJs6.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, _indexJs6.isProtectedDayOfYearToken)(substring)) (0, _indexJs6.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match(unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        return substring;
    }).join('');
    return result;
}
function cleanEscapedString(input) {
    var matched = input.match(escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace(doubleQuoteRegExp, "'");
}

},{"../isValid/index.js":"fScb4","../subMilliseconds/index.js":"1aYLs","../toDate/index.js":"elr3O","../_lib/format/formatters/index.js":"7dlou","../_lib/format/longFormatters/index.js":"doiWo","../_lib/getTimezoneOffsetInMilliseconds/index.js":"3kvOg","../_lib/protectedTokens/index.js":"l3hRj","../_lib/toInteger/index.js":"dkWbJ","../_lib/requiredArgs/index.js":"14prD","../_lib/defaultOptions/index.js":"eo7FR","../_lib/defaultLocale/index.js":"2BPBN","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1aYLs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return subMilliseconds;
});
var _indexJs = require("../addMilliseconds/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function subMilliseconds(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault1.default)(2, arguments);
    var amount = (0, _indexJsDefault2.default)(dirtyAmount);
    return (0, _indexJsDefault.default)(dirtyDate, -amount);
}

},{"../addMilliseconds/index.js":"bkMDO","../_lib/requiredArgs/index.js":"14prD","../_lib/toInteger/index.js":"dkWbJ","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7dlou":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/getUTCDayOfYear/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/getUTCISOWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../../../_lib/getUTCISOWeekYear/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../../../_lib/getUTCWeek/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../../../_lib/getUTCWeekYear/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
var _indexJs5 = require("../../addLeadingZeros/index.js");
var _indexJsDefault5 = parcelHelpers.interopDefault(_indexJs5);
var _indexJs6 = require("../lightFormatters/index.js");
var _indexJsDefault6 = parcelHelpers.interopDefault(_indexJs6);
var dayPeriodEnum = {
    am: 'am',
    pm: 'pm',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case 'G':
            case 'GG':
            case 'GGG':
                return localize.era(era, {
                    width: 'abbreviated'
                });
            // A, B
            case 'GGGGG':
                return localize.era(era, {
                    width: 'narrow'
                });
            // Anno Domini, Before Christ
            case 'GGGG':
            default:
                return localize.era(era, {
                    width: 'wide'
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === 'yo') {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: 'year'
            });
        }
        return (0, _indexJsDefault6.default).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, _indexJsDefault4.default)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === 'YY') {
            var twoDigitYear = weekYear % 100;
            return (0, _indexJsDefault5.default)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === 'Yo') return localize.ordinalNumber(weekYear, {
            unit: 'year'
        });
        // Padding
        return (0, _indexJsDefault5.default)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, _indexJsDefault2.default)(date);
        // Padding
        return (0, _indexJsDefault5.default)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, _indexJsDefault5.default)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'Q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'QQ':
                return (0, _indexJsDefault5.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'Qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'QQQ':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'QQQQQ':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // 1st quarter, 2nd quarter, ...
            case 'QQQQ':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'qq':
                return (0, _indexJsDefault5.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'qqq':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'qqqqq':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // 1st quarter, 2nd quarter, ...
            case 'qqqq':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case 'M':
            case 'MM':
                return (0, _indexJsDefault6.default).M(date, token);
            // 1st, 2nd, ..., 12th
            case 'Mo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'MMM':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // J, F, ..., D
            case 'MMMMM':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // January, February, ..., December
            case 'MMMM':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case 'L':
                return String(month + 1);
            // 01, 02, ..., 12
            case 'LL':
                return (0, _indexJsDefault5.default)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case 'Lo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'LLL':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // J, F, ..., D
            case 'LLLLL':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // January, February, ..., December
            case 'LLLL':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, _indexJsDefault3.default)(date, options);
        if (token === 'wo') return localize.ordinalNumber(week, {
            unit: 'week'
        });
        return (0, _indexJsDefault5.default)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, _indexJsDefault1.default)(date);
        if (token === 'Io') return localize.ordinalNumber(isoWeek, {
            unit: 'week'
        });
        return (0, _indexJsDefault5.default)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === 'do') return localize.ordinalNumber(date.getUTCDate(), {
            unit: 'date'
        });
        return (0, _indexJsDefault6.default).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, _indexJsDefault.default)(date);
        if (token === 'Do') return localize.ordinalNumber(dayOfYear, {
            unit: 'dayOfYear'
        });
        return (0, _indexJsDefault5.default)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case 'E':
            case 'EE':
            case 'EEE':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'EEEEE':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'EEEEEE':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'EEEE':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case 'e':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'ee':
                return (0, _indexJsDefault5.default)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case 'eo':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'eee':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'eeeee':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'eeeeee':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'eeee':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case 'c':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'cc':
                return (0, _indexJsDefault5.default)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case 'co':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'ccc':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // T
            case 'ccccc':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // Tu
            case 'cccccc':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'standalone'
                });
            // Tuesday
            case 'cccc':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case 'i':
                return String(isoDayOfWeek);
            // 02
            case 'ii':
                return (0, _indexJsDefault5.default)(isoDayOfWeek, token.length);
            // 2nd
            case 'io':
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: 'day'
                });
            // Tue
            case 'iii':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'iiiii':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'iiiiii':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'iiii':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'aaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'aaaaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'aaaa':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'b':
            case 'bb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'bbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'bbbbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'bbbb':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = dayPeriodEnum.morning;
        else dayPeriodEnumValue = dayPeriodEnum.night;
        switch(token){
            case 'B':
            case 'BB':
            case 'BBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'BBBBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'BBBB':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === 'ho') {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
        }
        return (0, _indexJsDefault6.default).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === 'Ho') return localize.ordinalNumber(date.getUTCHours(), {
            unit: 'hour'
        });
        return (0, _indexJsDefault6.default).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === 'Ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, _indexJsDefault5.default)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === 'ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, _indexJsDefault5.default)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === 'mo') return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: 'minute'
        });
        return (0, _indexJsDefault6.default).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === 'so') return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: 'second'
        });
        return (0, _indexJsDefault6.default).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, _indexJsDefault6.default).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                // Hours and minutes without `:` delimiter
                return formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case 'x':
                return formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                // Hours and minutes without `:` delimiter
                return formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'zzzz':
            default:
                return 'GMT' + formatTimezone(timezoneOffset, ':');
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, _indexJsDefault5.default)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, _indexJsDefault5.default)(timestamp, token.length);
    }
};
function formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + (0, _indexJsDefault5.default)(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + (0, _indexJsDefault5.default)(Math.abs(offset) / 60, 2);
    }
    return formatTimezone(offset, dirtyDelimiter);
}
function formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = (0, _indexJsDefault5.default)(Math.floor(absOffset / 60), 2);
    var minutes = (0, _indexJsDefault5.default)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
exports.default = formatters;

},{"../../../_lib/getUTCDayOfYear/index.js":"5YuY9","../../../_lib/getUTCISOWeek/index.js":"wWrG7","../../../_lib/getUTCISOWeekYear/index.js":"1pICj","../../../_lib/getUTCWeek/index.js":"47oK6","../../../_lib/getUTCWeekYear/index.js":"9IqAt","../../addLeadingZeros/index.js":"Lz1wN","../lightFormatters/index.js":"kcHj5","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5YuY9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getUTCDayOfYear;
});
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var MILLISECONDS_IN_DAY = 86400000;
function getUTCDayOfYear(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}

},{"../../toDate/index.js":"elr3O","../requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"wWrG7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getUTCISOWeek;
});
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfUTCISOWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../startOfUTCISOWeekYear/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var MILLISECONDS_IN_WEEK = 604800000;
function getUTCISOWeek(dirtyDate) {
    (0, _indexJsDefault3.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var diff = (0, _indexJsDefault1.default)(date).getTime() - (0, _indexJsDefault2.default)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

},{"../../toDate/index.js":"elr3O","../startOfUTCISOWeek/index.js":"lnjiQ","../startOfUTCISOWeekYear/index.js":"4jQmM","../requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"lnjiQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return startOfUTCISOWeek;
});
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function startOfUTCISOWeek(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

},{"../../toDate/index.js":"elr3O","../requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4jQmM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return startOfUTCISOWeekYear;
});
var _indexJs = require("../getUTCISOWeekYear/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfUTCISOWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function startOfUTCISOWeekYear(dirtyDate) {
    (0, _indexJsDefault2.default)(1, arguments);
    var year = (0, _indexJsDefault.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, _indexJsDefault1.default)(fourthOfJanuary);
    return date;
}

},{"../getUTCISOWeekYear/index.js":"1pICj","../startOfUTCISOWeek/index.js":"lnjiQ","../requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1pICj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getUTCISOWeekYear;
});
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../startOfUTCISOWeek/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function getUTCISOWeekYear(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, _indexJsDefault2.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, _indexJsDefault2.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

},{"../../toDate/index.js":"elr3O","../requiredArgs/index.js":"14prD","../startOfUTCISOWeek/index.js":"lnjiQ","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"47oK6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getUTCWeek;
});
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfUTCWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../startOfUTCWeekYear/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var MILLISECONDS_IN_WEEK = 604800000;
function getUTCWeek(dirtyDate, options) {
    (0, _indexJsDefault3.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var diff = (0, _indexJsDefault1.default)(date, options).getTime() - (0, _indexJsDefault2.default)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

},{"../../toDate/index.js":"elr3O","../startOfUTCWeek/index.js":"cCeyA","../startOfUTCWeekYear/index.js":"i5uQF","../requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"cCeyA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return startOfUTCWeek;
});
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../defaultOptions/index.js");
function startOfUTCWeek(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault1.default)(1, arguments);
    var defaultOptions = (0, _indexJs3.getDefaultOptions)();
    var weekStartsOn = (0, _indexJsDefault2.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

},{"../../toDate/index.js":"elr3O","../requiredArgs/index.js":"14prD","../toInteger/index.js":"dkWbJ","../defaultOptions/index.js":"eo7FR","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"i5uQF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return startOfUTCWeekYear;
});
var _indexJs = require("../getUTCWeekYear/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../startOfUTCWeek/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../toInteger/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../defaultOptions/index.js");
function startOfUTCWeekYear(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault1.default)(1, arguments);
    var defaultOptions = (0, _indexJs4.getDefaultOptions)();
    var firstWeekContainsDate = (0, _indexJsDefault3.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, _indexJsDefault.default)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, _indexJsDefault2.default)(firstWeek, options);
    return date;
}

},{"../getUTCWeekYear/index.js":"9IqAt","../requiredArgs/index.js":"14prD","../startOfUTCWeek/index.js":"cCeyA","../toInteger/index.js":"dkWbJ","../defaultOptions/index.js":"eo7FR","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"9IqAt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getUTCWeekYear;
});
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../startOfUTCWeek/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../toInteger/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../defaultOptions/index.js");
function getUTCWeekYear(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, _indexJs4.getDefaultOptions)();
    var firstWeekContainsDate = (0, _indexJsDefault3.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, _indexJsDefault2.default)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, _indexJsDefault2.default)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

},{"../../toDate/index.js":"elr3O","../requiredArgs/index.js":"14prD","../startOfUTCWeek/index.js":"cCeyA","../toInteger/index.js":"dkWbJ","../defaultOptions/index.js":"eo7FR","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"Lz1wN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return addLeadingZeros;
});
function addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"kcHj5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../addLeadingZeros/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, _indexJsDefault.default)(token === 'yy' ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === 'M' ? String(month + 1) : (0, _indexJsDefault.default)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, _indexJsDefault.default)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return dayPeriodEnumValue.toUpperCase();
            case 'aaa':
                return dayPeriodEnumValue;
            case 'aaaaa':
                return dayPeriodEnumValue[0];
            case 'aaaa':
            default:
                return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, _indexJsDefault.default)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, _indexJsDefault.default)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, _indexJsDefault.default)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, _indexJsDefault.default)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, _indexJsDefault.default)(fractionalSeconds, token.length);
    }
};
exports.default = formatters;

},{"../../addLeadingZeros/index.js":"Lz1wN","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"doiWo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'P':
            return formatLong.date({
                width: 'short'
            });
        case 'PP':
            return formatLong.date({
                width: 'medium'
            });
        case 'PPP':
            return formatLong.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return formatLong.date({
                width: 'full'
            });
    }
};
var timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'p':
            return formatLong.time({
                width: 'short'
            });
        case 'pp':
            return formatLong.time({
                width: 'medium'
            });
        case 'ppp':
            return formatLong.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return formatLong.time({
                width: 'full'
            });
    }
};
var dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case 'P':
            dateTimeFormat = formatLong.dateTime({
                width: 'short'
            });
            break;
        case 'PP':
            dateTimeFormat = formatLong.dateTime({
                width: 'medium'
            });
            break;
        case 'PPP':
            dateTimeFormat = formatLong.dateTime({
                width: 'long'
            });
            break;
        case 'PPPP':
        default:
            dateTimeFormat = formatLong.dateTime({
                width: 'full'
            });
            break;
    }
    return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
};
var longFormatters = {
    p: timeLongFormatter,
    P: dateTimeLongFormatter
};
exports.default = longFormatters;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"l3hRj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isProtectedDayOfYearToken", function() {
    return isProtectedDayOfYearToken;
});
parcelHelpers.export(exports, "isProtectedWeekYearToken", function() {
    return isProtectedWeekYearToken;
});
parcelHelpers.export(exports, "throwProtectedError", function() {
    return throwProtectedError;
});
var protectedDayOfYearTokens = [
    'D',
    'DD'
];
var protectedWeekYearTokens = [
    'YY',
    'YYYY'
];
function isProtectedDayOfYearToken(token) {
    return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
    return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
    if (token === 'YYYY') throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'YY') throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'D') throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'DD') throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2BPBN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../locale/en-US/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
exports.default = (0, _indexJsDefault.default);

},{"../../locale/en-US/index.js":"8LL9Z","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8LL9Z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var locale = {
    code: 'en-US',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"k21rK","./_lib/formatLong/index.js":"egWt2","./_lib/formatRelative/index.js":"5hFuk","./_lib/localize/index.js":"jVOZz","./_lib/match/index.js":"5qFLH","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"k21rK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: '1 hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: '1 day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: '1 month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: '1 year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"egWt2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5U7lS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return buildFormatLongFn;
});
function buildFormatLongFn(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5hFuk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jVOZz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'B',
        'A'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        'Before Christ',
        'Anno Domini'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1st quarter',
        '2nd quarter',
        '3rd quarter',
        '4th quarter'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    wide: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]
};
var dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S'
    ],
    short: [
        'Su',
        'Mo',
        'Tu',
        'We',
        'Th',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    wide: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'st';
        case 2:
            return number + 'nd';
        case 3:
            return number + 'rd';
    }
    return number + 'th';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"lfhT3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return buildLocalizeFn;
});
function buildLocalizeFn(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
        var valuesArray;
        if (context === 'formatting' && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5qFLH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7YCyk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return buildMatchFn;
});
function buildMatchFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2Mexa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return buildMatchPatternFn;
});
function buildMatchPatternFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"h9eLH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return formatDistance;
});
var _indexJs = require("../_lib/defaultOptions/index.js");
var _indexJs1 = require("../compareAsc/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../differenceInMonths/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../differenceInSeconds/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../_lib/defaultLocale/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs4);
var _indexJs5 = require("../toDate/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs5);
var _indexJs6 = require("../_lib/cloneObject/index.js");
var _indexJsDefault5 = parcelHelpers.interopDefault(_indexJs6);
var _indexJs7 = require("../_lib/assign/index.js");
var _indexJsDefault6 = parcelHelpers.interopDefault(_indexJs7);
var _indexJs8 = require("../_lib/getTimezoneOffsetInMilliseconds/index.js");
var _indexJsDefault7 = parcelHelpers.interopDefault(_indexJs8);
var _indexJs9 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault8 = parcelHelpers.interopDefault(_indexJs9);
var MINUTES_IN_DAY = 1440;
var MINUTES_IN_ALMOST_TWO_DAYS = 2520;
var MINUTES_IN_MONTH = 43200;
var MINUTES_IN_TWO_MONTHS = 86400;
function formatDistance(dirtyDate, dirtyBaseDate, options) {
    var _ref, _options$locale;
    (0, _indexJsDefault8.default)(2, arguments);
    var defaultOptions = (0, _indexJs.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, _indexJsDefault3.default);
    if (!locale.formatDistance) throw new RangeError('locale must contain formatDistance property');
    var comparison = (0, _indexJsDefault.default)(dirtyDate, dirtyBaseDate);
    if (isNaN(comparison)) throw new RangeError('Invalid time value');
    var localizeOptions = (0, _indexJsDefault6.default)((0, _indexJsDefault5.default)(options), {
        addSuffix: Boolean(options === null || options === void 0 ? void 0 : options.addSuffix),
        comparison: comparison
    });
    var dateLeft;
    var dateRight;
    if (comparison > 0) {
        dateLeft = (0, _indexJsDefault4.default)(dirtyBaseDate);
        dateRight = (0, _indexJsDefault4.default)(dirtyDate);
    } else {
        dateLeft = (0, _indexJsDefault4.default)(dirtyDate);
        dateRight = (0, _indexJsDefault4.default)(dirtyBaseDate);
    }
    var seconds = (0, _indexJsDefault2.default)(dateRight, dateLeft);
    var offsetInSeconds = ((0, _indexJsDefault7.default)(dateRight) - (0, _indexJsDefault7.default)(dateLeft)) / 1000;
    var minutes = Math.round((seconds - offsetInSeconds) / 60);
    var months;
    // 0 up to 2 mins
    if (minutes < 2) {
        if (options !== null && options !== void 0 && options.includeSeconds) {
            if (seconds < 5) return locale.formatDistance('lessThanXSeconds', 5, localizeOptions);
            else if (seconds < 10) return locale.formatDistance('lessThanXSeconds', 10, localizeOptions);
            else if (seconds < 20) return locale.formatDistance('lessThanXSeconds', 20, localizeOptions);
            else if (seconds < 40) return locale.formatDistance('halfAMinute', 0, localizeOptions);
            else if (seconds < 60) return locale.formatDistance('lessThanXMinutes', 1, localizeOptions);
            else return locale.formatDistance('xMinutes', 1, localizeOptions);
        } else {
            if (minutes === 0) return locale.formatDistance('lessThanXMinutes', 1, localizeOptions);
            else return locale.formatDistance('xMinutes', minutes, localizeOptions);
        }
    } else if (minutes < 45) return locale.formatDistance('xMinutes', minutes, localizeOptions);
    else if (minutes < 90) return locale.formatDistance('aboutXHours', 1, localizeOptions);
    else if (minutes < MINUTES_IN_DAY) {
        var hours = Math.round(minutes / 60);
        return locale.formatDistance('aboutXHours', hours, localizeOptions);
    // 1 day up to 1.75 days
    } else if (minutes < MINUTES_IN_ALMOST_TWO_DAYS) return locale.formatDistance('xDays', 1, localizeOptions);
    else if (minutes < MINUTES_IN_MONTH) {
        var days = Math.round(minutes / MINUTES_IN_DAY);
        return locale.formatDistance('xDays', days, localizeOptions);
    // 1 month up to 2 months
    } else if (minutes < MINUTES_IN_TWO_MONTHS) {
        months = Math.round(minutes / MINUTES_IN_MONTH);
        return locale.formatDistance('aboutXMonths', months, localizeOptions);
    }
    months = (0, _indexJsDefault1.default)(dateRight, dateLeft);
    // 2 months up to 12 months
    if (months < 12) {
        var nearestMonth = Math.round(minutes / MINUTES_IN_MONTH);
        return locale.formatDistance('xMonths', nearestMonth, localizeOptions);
    // 1 year up to max Date
    } else {
        var monthsSinceStartOfYear = months % 12;
        var years = Math.floor(months / 12);
        // N years up to 1 years 3 months
        if (monthsSinceStartOfYear < 3) return locale.formatDistance('aboutXYears', years, localizeOptions);
        else if (monthsSinceStartOfYear < 9) return locale.formatDistance('overXYears', years, localizeOptions);
        else return locale.formatDistance('almostXYears', years + 1, localizeOptions);
    }
}

},{"../_lib/defaultOptions/index.js":"eo7FR","../compareAsc/index.js":"jbQZt","../differenceInMonths/index.js":"7dsnu","../differenceInSeconds/index.js":"40bOi","../_lib/defaultLocale/index.js":"2BPBN","../toDate/index.js":"elr3O","../_lib/cloneObject/index.js":"6HL3w","../_lib/assign/index.js":"lQLgw","../_lib/getTimezoneOffsetInMilliseconds/index.js":"3kvOg","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6HL3w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return cloneObject;
});
var _indexJs = require("../assign/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function cloneObject(object) {
    return (0, _indexJsDefault.default)({}, object);
}

},{"../assign/index.js":"lQLgw","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"lQLgw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return assign;
});
function assign(target, object) {
    if (target == null) throw new TypeError('assign requires that input parameter not be null or undefined');
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6Wxdy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return formatDistanceStrict;
});
var _indexJs = require("../_lib/defaultOptions/index.js");
var _indexJs1 = require("../_lib/getTimezoneOffsetInMilliseconds/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../compareAsc/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../toDate/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../_lib/cloneObject/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs4);
var _indexJs5 = require("../_lib/assign/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs5);
var _indexJs6 = require("../_lib/defaultLocale/index.js");
var _indexJsDefault5 = parcelHelpers.interopDefault(_indexJs6);
var _indexJs7 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault6 = parcelHelpers.interopDefault(_indexJs7);
var MILLISECONDS_IN_MINUTE = 60000;
var MINUTES_IN_DAY = 1440;
var MINUTES_IN_MONTH = MINUTES_IN_DAY * 30;
var MINUTES_IN_YEAR = MINUTES_IN_DAY * 365;
function formatDistanceStrict(dirtyDate, dirtyBaseDate, options) {
    var _ref, _options$locale, _options$roundingMeth;
    (0, _indexJsDefault6.default)(2, arguments);
    var defaultOptions = (0, _indexJs.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, _indexJsDefault5.default);
    if (!locale.formatDistance) throw new RangeError('locale must contain localize.formatDistance property');
    var comparison = (0, _indexJsDefault1.default)(dirtyDate, dirtyBaseDate);
    if (isNaN(comparison)) throw new RangeError('Invalid time value');
    var localizeOptions = (0, _indexJsDefault4.default)((0, _indexJsDefault3.default)(options), {
        addSuffix: Boolean(options === null || options === void 0 ? void 0 : options.addSuffix),
        comparison: comparison
    });
    var dateLeft;
    var dateRight;
    if (comparison > 0) {
        dateLeft = (0, _indexJsDefault2.default)(dirtyBaseDate);
        dateRight = (0, _indexJsDefault2.default)(dirtyDate);
    } else {
        dateLeft = (0, _indexJsDefault2.default)(dirtyDate);
        dateRight = (0, _indexJsDefault2.default)(dirtyBaseDate);
    }
    var roundingMethod = String((_options$roundingMeth = options === null || options === void 0 ? void 0 : options.roundingMethod) !== null && _options$roundingMeth !== void 0 ? _options$roundingMeth : 'round');
    var roundingMethodFn;
    if (roundingMethod === 'floor') roundingMethodFn = Math.floor;
    else if (roundingMethod === 'ceil') roundingMethodFn = Math.ceil;
    else if (roundingMethod === 'round') roundingMethodFn = Math.round;
    else throw new RangeError("roundingMethod must be 'floor', 'ceil' or 'round'");
    var milliseconds = dateRight.getTime() - dateLeft.getTime();
    var minutes = milliseconds / MILLISECONDS_IN_MINUTE;
    var timezoneOffset = (0, _indexJsDefault.default)(dateRight) - (0, _indexJsDefault.default)(dateLeft);
    // Use DST-normalized difference in minutes for years, months and days;
    // use regular difference in minutes for hours, minutes and seconds.
    var dstNormalizedMinutes = (milliseconds - timezoneOffset) / MILLISECONDS_IN_MINUTE;
    var defaultUnit = options === null || options === void 0 ? void 0 : options.unit;
    var unit;
    if (!defaultUnit) {
        if (minutes < 1) unit = 'second';
        else if (minutes < 60) unit = 'minute';
        else if (minutes < MINUTES_IN_DAY) unit = 'hour';
        else if (dstNormalizedMinutes < MINUTES_IN_MONTH) unit = 'day';
        else if (dstNormalizedMinutes < MINUTES_IN_YEAR) unit = 'month';
        else unit = 'year';
    } else unit = String(defaultUnit);
    // 0 up to 60 seconds
    if (unit === 'second') {
        var seconds = roundingMethodFn(milliseconds / 1000);
        return locale.formatDistance('xSeconds', seconds, localizeOptions);
    // 1 up to 60 mins
    } else if (unit === 'minute') {
        var roundedMinutes = roundingMethodFn(minutes);
        return locale.formatDistance('xMinutes', roundedMinutes, localizeOptions);
    // 1 up to 24 hours
    } else if (unit === 'hour') {
        var hours = roundingMethodFn(minutes / 60);
        return locale.formatDistance('xHours', hours, localizeOptions);
    // 1 up to 30 days
    } else if (unit === 'day') {
        var days = roundingMethodFn(dstNormalizedMinutes / MINUTES_IN_DAY);
        return locale.formatDistance('xDays', days, localizeOptions);
    // 1 up to 12 months
    } else if (unit === 'month') {
        var months = roundingMethodFn(dstNormalizedMinutes / MINUTES_IN_MONTH);
        return months === 12 && defaultUnit !== 'month' ? locale.formatDistance('xYears', 1, localizeOptions) : locale.formatDistance('xMonths', months, localizeOptions);
    // 1 year up to max Date
    } else if (unit === 'year') {
        var years = roundingMethodFn(dstNormalizedMinutes / MINUTES_IN_YEAR);
        return locale.formatDistance('xYears', years, localizeOptions);
    }
    throw new RangeError("unit must be 'second', 'minute', 'hour', 'day', 'month' or 'year'");
}

},{"../_lib/defaultOptions/index.js":"eo7FR","../_lib/getTimezoneOffsetInMilliseconds/index.js":"3kvOg","../compareAsc/index.js":"jbQZt","../toDate/index.js":"elr3O","../_lib/cloneObject/index.js":"6HL3w","../_lib/assign/index.js":"lQLgw","../_lib/defaultLocale/index.js":"2BPBN","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6cP6D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return formatDistanceToNow;
});
var _indexJs = require("../formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function formatDistanceToNow(dirtyDate, options) {
    (0, _indexJsDefault1.default)(1, arguments);
    return (0, _indexJsDefault.default)(dirtyDate, Date.now(), options);
}

},{"../formatDistance/index.js":"h9eLH","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"aRzMn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return formatDistanceToNowStrict;
});
var _indexJs = require("../formatDistanceStrict/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function formatDistanceToNowStrict(dirtyDate, options) {
    (0, _indexJsDefault1.default)(1, arguments);
    return (0, _indexJsDefault.default)(dirtyDate, Date.now(), options);
}

},{"../formatDistanceStrict/index.js":"6Wxdy","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"9cDu4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return formatDuration;
});
var _indexJs = require("../_lib/defaultOptions/index.js");
var _indexJs1 = require("../_lib/defaultLocale/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs1);
var defaultFormat = [
    'years',
    'months',
    'weeks',
    'days',
    'hours',
    'minutes',
    'seconds'
];
function formatDuration(duration, options) {
    var _ref, _options$locale, _options$format, _options$zero, _options$delimiter;
    if (arguments.length < 1) throw new TypeError("1 argument required, but only ".concat(arguments.length, " present"));
    var defaultOptions = (0, _indexJs.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, _indexJsDefault.default);
    var format = (_options$format = options === null || options === void 0 ? void 0 : options.format) !== null && _options$format !== void 0 ? _options$format : defaultFormat;
    var zero = (_options$zero = options === null || options === void 0 ? void 0 : options.zero) !== null && _options$zero !== void 0 ? _options$zero : false;
    var delimiter = (_options$delimiter = options === null || options === void 0 ? void 0 : options.delimiter) !== null && _options$delimiter !== void 0 ? _options$delimiter : ' ';
    if (!locale.formatDistance) return '';
    var result = format.reduce(function(acc, unit) {
        var token = "x".concat(unit.replace(/(^.)/, function(m) {
            return m.toUpperCase();
        }));
        var value = duration[unit];
        if (typeof value === 'number' && (zero || duration[unit])) return acc.concat(locale.formatDistance(token, value));
        return acc;
    }, []).join(delimiter);
    return result;
}

},{"../_lib/defaultOptions/index.js":"eo7FR","../_lib/defaultLocale/index.js":"2BPBN","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"bbu2K":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return formatISO;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/addLeadingZeros/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function formatISO(date, options) {
    var _options$format, _options$representati;
    (0, _indexJsDefault2.default)(1, arguments);
    var originalDate = (0, _indexJsDefault.default)(date);
    if (isNaN(originalDate.getTime())) throw new RangeError('Invalid time value');
    var format = String((_options$format = options === null || options === void 0 ? void 0 : options.format) !== null && _options$format !== void 0 ? _options$format : 'extended');
    var representation = String((_options$representati = options === null || options === void 0 ? void 0 : options.representation) !== null && _options$representati !== void 0 ? _options$representati : 'complete');
    if (format !== 'extended' && format !== 'basic') throw new RangeError("format must be 'extended' or 'basic'");
    if (representation !== 'date' && representation !== 'time' && representation !== 'complete') throw new RangeError("representation must be 'date', 'time', or 'complete'");
    var result = '';
    var tzOffset = '';
    var dateDelimiter = format === 'extended' ? '-' : '';
    var timeDelimiter = format === 'extended' ? ':' : '';
    // Representation is either 'date' or 'complete'
    if (representation !== 'time') {
        var day = (0, _indexJsDefault1.default)(originalDate.getDate(), 2);
        var month = (0, _indexJsDefault1.default)(originalDate.getMonth() + 1, 2);
        var year = (0, _indexJsDefault1.default)(originalDate.getFullYear(), 4);
        // yyyyMMdd or yyyy-MM-dd.
        result = "".concat(year).concat(dateDelimiter).concat(month).concat(dateDelimiter).concat(day);
    }
    // Representation is either 'time' or 'complete'
    if (representation !== 'date') {
        // Add the timezone.
        var offset = originalDate.getTimezoneOffset();
        if (offset !== 0) {
            var absoluteOffset = Math.abs(offset);
            var hourOffset = (0, _indexJsDefault1.default)(Math.floor(absoluteOffset / 60), 2);
            var minuteOffset = (0, _indexJsDefault1.default)(absoluteOffset % 60, 2);
            // If less than 0, the sign is +, because it is ahead of time.
            var sign = offset < 0 ? '+' : '-';
            tzOffset = "".concat(sign).concat(hourOffset, ":").concat(minuteOffset);
        } else tzOffset = 'Z';
        var hour = (0, _indexJsDefault1.default)(originalDate.getHours(), 2);
        var minute = (0, _indexJsDefault1.default)(originalDate.getMinutes(), 2);
        var second = (0, _indexJsDefault1.default)(originalDate.getSeconds(), 2);
        // If there's also date, separate it with time with 'T'
        var separator = result === '' ? '' : 'T';
        // Creates a time string consisting of hour, minute, and second, separated by delimiters, if defined.
        var time = [
            hour,
            minute,
            second
        ].join(timeDelimiter);
        // HHmmss or HH:mm:ss.
        result = "".concat(result).concat(separator).concat(time).concat(tzOffset);
    }
    return result;
}

},{"../toDate/index.js":"elr3O","../_lib/addLeadingZeros/index.js":"Lz1wN","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"ikPEG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return formatISO9075;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../isValid/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/addLeadingZeros/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function formatISO9075(dirtyDate, options) {
    var _options$format, _options$representati;
    if (arguments.length < 1) throw new TypeError("1 argument required, but only ".concat(arguments.length, " present"));
    var originalDate = (0, _indexJsDefault.default)(dirtyDate);
    if (!(0, _indexJsDefault1.default)(originalDate)) throw new RangeError('Invalid time value');
    var format = String((_options$format = options === null || options === void 0 ? void 0 : options.format) !== null && _options$format !== void 0 ? _options$format : 'extended');
    var representation = String((_options$representati = options === null || options === void 0 ? void 0 : options.representation) !== null && _options$representati !== void 0 ? _options$representati : 'complete');
    if (format !== 'extended' && format !== 'basic') throw new RangeError("format must be 'extended' or 'basic'");
    if (representation !== 'date' && representation !== 'time' && representation !== 'complete') throw new RangeError("representation must be 'date', 'time', or 'complete'");
    var result = '';
    var dateDelimiter = format === 'extended' ? '-' : '';
    var timeDelimiter = format === 'extended' ? ':' : '';
    // Representation is either 'date' or 'complete'
    if (representation !== 'time') {
        var day = (0, _indexJsDefault2.default)(originalDate.getDate(), 2);
        var month = (0, _indexJsDefault2.default)(originalDate.getMonth() + 1, 2);
        var year = (0, _indexJsDefault2.default)(originalDate.getFullYear(), 4);
        // yyyyMMdd or yyyy-MM-dd.
        result = "".concat(year).concat(dateDelimiter).concat(month).concat(dateDelimiter).concat(day);
    }
    // Representation is either 'time' or 'complete'
    if (representation !== 'date') {
        var hour = (0, _indexJsDefault2.default)(originalDate.getHours(), 2);
        var minute = (0, _indexJsDefault2.default)(originalDate.getMinutes(), 2);
        var second = (0, _indexJsDefault2.default)(originalDate.getSeconds(), 2);
        // If there's also date, separate it with time with a space
        var separator = result === '' ? '' : ' ';
        // HHmmss or HH:mm:ss.
        result = "".concat(result).concat(separator).concat(hour).concat(timeDelimiter).concat(minute).concat(timeDelimiter).concat(second);
    }
    return result;
}

},{"../toDate/index.js":"elr3O","../isValid/index.js":"fScb4","../_lib/addLeadingZeros/index.js":"Lz1wN","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"g5pMq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return formatISODuration;
});
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _indexJs = require("../_lib/requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function formatISODuration(duration) {
    (0, _indexJsDefault.default)(1, arguments);
    if ((0, _typeofDefault.default)(duration) !== 'object') throw new Error('Duration must be an object');
    var _duration$years = duration.years, years = _duration$years === void 0 ? 0 : _duration$years, _duration$months = duration.months, months = _duration$months === void 0 ? 0 : _duration$months, _duration$days = duration.days, days = _duration$days === void 0 ? 0 : _duration$days, _duration$hours = duration.hours, hours = _duration$hours === void 0 ? 0 : _duration$hours, _duration$minutes = duration.minutes, minutes = _duration$minutes === void 0 ? 0 : _duration$minutes, _duration$seconds = duration.seconds, seconds = _duration$seconds === void 0 ? 0 : _duration$seconds;
    return "P".concat(years, "Y").concat(months, "M").concat(days, "DT").concat(hours, "H").concat(minutes, "M").concat(seconds, "S");
}

},{"@babel/runtime/helpers/esm/typeof":"8bpl6","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"d7vRW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return formatRFC3339;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../isValid/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/addLeadingZeros/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/toInteger/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
function formatRFC3339(dirtyDate, options) {
    var _options$fractionDigi;
    if (arguments.length < 1) throw new TypeError("1 arguments required, but only ".concat(arguments.length, " present"));
    var originalDate = (0, _indexJsDefault.default)(dirtyDate);
    if (!(0, _indexJsDefault1.default)(originalDate)) throw new RangeError('Invalid time value');
    var fractionDigits = Number((_options$fractionDigi = options === null || options === void 0 ? void 0 : options.fractionDigits) !== null && _options$fractionDigi !== void 0 ? _options$fractionDigi : 0);
    // Test if fractionDigits is between 0 and 3 _and_ is not NaN
    if (!(fractionDigits >= 0 && fractionDigits <= 3)) throw new RangeError('fractionDigits must be between 0 and 3 inclusively');
    var day = (0, _indexJsDefault2.default)(originalDate.getDate(), 2);
    var month = (0, _indexJsDefault2.default)(originalDate.getMonth() + 1, 2);
    var year = originalDate.getFullYear();
    var hour = (0, _indexJsDefault2.default)(originalDate.getHours(), 2);
    var minute = (0, _indexJsDefault2.default)(originalDate.getMinutes(), 2);
    var second = (0, _indexJsDefault2.default)(originalDate.getSeconds(), 2);
    var fractionalSecond = '';
    if (fractionDigits > 0) {
        var milliseconds = originalDate.getMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, fractionDigits - 3));
        fractionalSecond = '.' + (0, _indexJsDefault2.default)(fractionalSeconds, fractionDigits);
    }
    var offset = '';
    var tzOffset = originalDate.getTimezoneOffset();
    if (tzOffset !== 0) {
        var absoluteOffset = Math.abs(tzOffset);
        var hourOffset = (0, _indexJsDefault2.default)((0, _indexJsDefault3.default)(absoluteOffset / 60), 2);
        var minuteOffset = (0, _indexJsDefault2.default)(absoluteOffset % 60, 2);
        // If less than 0, the sign is +, because it is ahead of time.
        var sign = tzOffset < 0 ? '+' : '-';
        offset = "".concat(sign).concat(hourOffset, ":").concat(minuteOffset);
    } else offset = 'Z';
    return "".concat(year, "-").concat(month, "-").concat(day, "T").concat(hour, ":").concat(minute, ":").concat(second).concat(fractionalSecond).concat(offset);
}

},{"../toDate/index.js":"elr3O","../isValid/index.js":"fScb4","../_lib/addLeadingZeros/index.js":"Lz1wN","../_lib/toInteger/index.js":"dkWbJ","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7BU1O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return formatRFC7231;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../isValid/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/addLeadingZeros/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var days = [
    'Sun',
    'Mon',
    'Tue',
    'Wed',
    'Thu',
    'Fri',
    'Sat'
];
var months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
function formatRFC7231(dirtyDate) {
    if (arguments.length < 1) throw new TypeError("1 arguments required, but only ".concat(arguments.length, " present"));
    var originalDate = (0, _indexJsDefault.default)(dirtyDate);
    if (!(0, _indexJsDefault1.default)(originalDate)) throw new RangeError('Invalid time value');
    var dayName = days[originalDate.getUTCDay()];
    var dayOfMonth = (0, _indexJsDefault2.default)(originalDate.getUTCDate(), 2);
    var monthName = months[originalDate.getUTCMonth()];
    var year = originalDate.getUTCFullYear();
    var hour = (0, _indexJsDefault2.default)(originalDate.getUTCHours(), 2);
    var minute = (0, _indexJsDefault2.default)(originalDate.getUTCMinutes(), 2);
    var second = (0, _indexJsDefault2.default)(originalDate.getUTCSeconds(), 2);
    // Result variables.
    return "".concat(dayName, ", ").concat(dayOfMonth, " ").concat(monthName, " ").concat(year, " ").concat(hour, ":").concat(minute, ":").concat(second, " GMT");
}

},{"../toDate/index.js":"elr3O","../isValid/index.js":"fScb4","../_lib/addLeadingZeros/index.js":"Lz1wN","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"kS7iO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return formatRelative;
});
var _indexJs = require("../_lib/defaultOptions/index.js");
var _indexJs1 = require("../differenceInCalendarDays/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../format/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/defaultLocale/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../subMilliseconds/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs4);
var _indexJs5 = require("../toDate/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs5);
var _indexJs6 = require("../_lib/getTimezoneOffsetInMilliseconds/index.js");
var _indexJsDefault5 = parcelHelpers.interopDefault(_indexJs6);
var _indexJs7 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault6 = parcelHelpers.interopDefault(_indexJs7);
var _indexJs8 = require("../_lib/toInteger/index.js");
var _indexJsDefault7 = parcelHelpers.interopDefault(_indexJs8);
function formatRelative(dirtyDate, dirtyBaseDate, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$weekStartsOn, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault6.default)(2, arguments);
    var date = (0, _indexJsDefault4.default)(dirtyDate);
    var baseDate = (0, _indexJsDefault4.default)(dirtyBaseDate);
    var defaultOptions = (0, _indexJs.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, _indexJsDefault2.default);
    var weekStartsOn = (0, _indexJsDefault7.default)((_ref2 = (_ref3 = (_ref4 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.weekStartsOn) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : 0);
    if (!locale.localize) throw new RangeError('locale must contain localize property');
    if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
    if (!locale.formatRelative) throw new RangeError('locale must contain formatRelative property');
    var diff = (0, _indexJsDefault.default)(date, baseDate);
    if (isNaN(diff)) throw new RangeError('Invalid time value');
    var token;
    if (diff < -6) token = 'other';
    else if (diff < -1) token = 'lastWeek';
    else if (diff < 0) token = 'yesterday';
    else if (diff < 1) token = 'today';
    else if (diff < 2) token = 'tomorrow';
    else if (diff < 7) token = 'nextWeek';
    else token = 'other';
    var utcDate = (0, _indexJsDefault3.default)(date, (0, _indexJsDefault5.default)(date));
    var utcBaseDate = (0, _indexJsDefault3.default)(baseDate, (0, _indexJsDefault5.default)(baseDate));
    var formatStr = locale.formatRelative(token, utcDate, utcBaseDate, {
        locale: locale,
        weekStartsOn: weekStartsOn
    });
    return (0, _indexJsDefault1.default)(date, formatStr, {
        locale: locale,
        weekStartsOn: weekStartsOn
    });
}

},{"../_lib/defaultOptions/index.js":"eo7FR","../differenceInCalendarDays/index.js":"44jgD","../format/index.js":"jeCXy","../_lib/defaultLocale/index.js":"2BPBN","../subMilliseconds/index.js":"1aYLs","../toDate/index.js":"elr3O","../_lib/getTimezoneOffsetInMilliseconds/index.js":"3kvOg","../_lib/requiredArgs/index.js":"14prD","../_lib/toInteger/index.js":"dkWbJ","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"hEULc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return fromUnixTime;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/toInteger/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function fromUnixTime(dirtyUnixTime) {
    (0, _indexJsDefault2.default)(1, arguments);
    var unixTime = (0, _indexJsDefault1.default)(dirtyUnixTime);
    return (0, _indexJsDefault.default)(unixTime * 1000);
}

},{"../toDate/index.js":"elr3O","../_lib/toInteger/index.js":"dkWbJ","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"9szif":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getDate;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getDate(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var dayOfMonth = date.getDate();
    return dayOfMonth;
}

},{"../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5wMzR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getDay;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getDay(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var day = date.getDay();
    return day;
}

},{"../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"hk4Le":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getDayOfYear;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfYear/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../differenceInCalendarDays/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
function getDayOfYear(dirtyDate) {
    (0, _indexJsDefault3.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var diff = (0, _indexJsDefault2.default)(date, (0, _indexJsDefault1.default)(date));
    var dayOfYear = diff + 1;
    return dayOfYear;
}

},{"../toDate/index.js":"elr3O","../startOfYear/index.js":"iKNfx","../differenceInCalendarDays/index.js":"44jgD","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6Eo8o":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getDaysInMonth;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getDaysInMonth(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var year = date.getFullYear();
    var monthIndex = date.getMonth();
    var lastDayOfMonth = new Date(0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}

},{"../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6VLfO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getDaysInYear;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../isLeapYear/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function getDaysInYear(dirtyDate) {
    (0, _indexJsDefault2.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    if (String(new Date(date)) === 'Invalid Date') return NaN;
    return (0, _indexJsDefault1.default)(date) ? 366 : 365;
}

},{"../toDate/index.js":"elr3O","../isLeapYear/index.js":"8mjUp","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8mjUp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isLeapYear;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isLeapYear(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var year = date.getFullYear();
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

},{"../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5dwea":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getDecade;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getDecade(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var year = date.getFullYear();
    var decade = Math.floor(year / 10) * 10;
    return decade;
}

},{"../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"9pJnk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getDefaultOptions;
});
var _indexJs = require("../_lib/defaultOptions/index.js");
var _indexJs1 = require("../_lib/assign/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs1);
function getDefaultOptions() {
    return (0, _indexJsDefault.default)({}, (0, _indexJs.getDefaultOptions)());
}

},{"../_lib/defaultOptions/index.js":"eo7FR","../_lib/assign/index.js":"lQLgw","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4YWMb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getHours;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getHours(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var hours = date.getHours();
    return hours;
}

},{"../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3jgzA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getISODay;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getISODay(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var day = date.getDay();
    if (day === 0) day = 7;
    return day;
}

},{"../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"hYopA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getISOWeek;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfISOWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../startOfISOWeekYear/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var MILLISECONDS_IN_WEEK = 604800000;
function getISOWeek(dirtyDate) {
    (0, _indexJsDefault3.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var diff = (0, _indexJsDefault1.default)(date).getTime() - (0, _indexJsDefault2.default)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

},{"../toDate/index.js":"elr3O","../startOfISOWeek/index.js":"iB7YK","../startOfISOWeekYear/index.js":"7AEM8","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5exDa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getISOWeeksInYear;
});
var _indexJs = require("../startOfISOWeekYear/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../addWeeks/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var MILLISECONDS_IN_WEEK = 604800000;
function getISOWeeksInYear(dirtyDate) {
    (0, _indexJsDefault2.default)(1, arguments);
    var thisYear = (0, _indexJsDefault.default)(dirtyDate);
    var nextYear = (0, _indexJsDefault.default)((0, _indexJsDefault1.default)(thisYear, 60));
    var diff = nextYear.valueOf() - thisYear.valueOf();
    // Round the number of weeks to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / MILLISECONDS_IN_WEEK);
}

},{"../startOfISOWeekYear/index.js":"7AEM8","../addWeeks/index.js":"jdo2p","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"kLsM5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getMilliseconds;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getMilliseconds(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var milliseconds = date.getMilliseconds();
    return milliseconds;
}

},{"../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gYbWF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getMinutes;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getMinutes(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var minutes = date.getMinutes();
    return minutes;
}

},{"../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"hcsnh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getMonth;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getMonth(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var month = date.getMonth();
    return month;
}

},{"../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"9GAre":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getOverlappingDaysInIntervals;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var MILLISECONDS_IN_DAY = 86400000;
function getOverlappingDaysInIntervals(dirtyIntervalLeft, dirtyIntervalRight) {
    (0, _indexJsDefault1.default)(2, arguments);
    var intervalLeft = dirtyIntervalLeft || {};
    var intervalRight = dirtyIntervalRight || {};
    var leftStartTime = (0, _indexJsDefault.default)(intervalLeft.start).getTime();
    var leftEndTime = (0, _indexJsDefault.default)(intervalLeft.end).getTime();
    var rightStartTime = (0, _indexJsDefault.default)(intervalRight.start).getTime();
    var rightEndTime = (0, _indexJsDefault.default)(intervalRight.end).getTime();
    // Throw an exception if start date is after end date or if any date is `Invalid Date`
    if (!(leftStartTime <= leftEndTime && rightStartTime <= rightEndTime)) throw new RangeError('Invalid interval');
    var isOverlapping = leftStartTime < rightEndTime && rightStartTime < leftEndTime;
    if (!isOverlapping) return 0;
    var overlapStartDate = rightStartTime < leftStartTime ? leftStartTime : rightStartTime;
    var overlapEndDate = rightEndTime > leftEndTime ? leftEndTime : rightEndTime;
    var differenceInMs = overlapEndDate - overlapStartDate;
    return Math.ceil(differenceInMs / MILLISECONDS_IN_DAY);
}

},{"../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4fnKq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getSeconds;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getSeconds(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var seconds = date.getSeconds();
    return seconds;
}

},{"../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"hOaNP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getTime;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getTime(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var timestamp = date.getTime();
    return timestamp;
}

},{"../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"kkkKH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getUnixTime;
});
var _indexJs = require("../getTime/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getUnixTime(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    return Math.floor((0, _indexJsDefault.default)(dirtyDate) / 1000);
}

},{"../getTime/index.js":"hOaNP","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6M8d2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getWeek;
});
var _indexJs = require("../startOfWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfWeekYear/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../toDate/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var MILLISECONDS_IN_WEEK = 604800000;
function getWeek(dirtyDate, options) {
    (0, _indexJsDefault3.default)(1, arguments);
    var date = (0, _indexJsDefault2.default)(dirtyDate);
    var diff = (0, _indexJsDefault.default)(date, options).getTime() - (0, _indexJsDefault1.default)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

},{"../startOfWeek/index.js":"em4Ab","../startOfWeekYear/index.js":"kJj0U","../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"kJj0U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return startOfWeekYear;
});
var _indexJs = require("../getWeekYear/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../_lib/defaultOptions/index.js");
function startOfWeekYear(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault3.default)(1, arguments);
    var defaultOptions = (0, _indexJs4.getDefaultOptions)();
    var firstWeekContainsDate = (0, _indexJsDefault2.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, _indexJsDefault.default)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    var date = (0, _indexJsDefault1.default)(firstWeek, options);
    return date;
}

},{"../getWeekYear/index.js":"h8EwW","../startOfWeek/index.js":"em4Ab","../_lib/toInteger/index.js":"dkWbJ","../_lib/requiredArgs/index.js":"14prD","../_lib/defaultOptions/index.js":"eo7FR","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"h8EwW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getWeekYear;
});
var _indexJs = require("../startOfWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../_lib/defaultOptions/index.js");
function getWeekYear(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault3.default)(1, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var year = date.getFullYear();
    var defaultOptions = (0, _indexJs4.getDefaultOptions)();
    var firstWeekContainsDate = (0, _indexJsDefault2.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    var startOfNextYear = (0, _indexJsDefault.default)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    var startOfThisYear = (0, _indexJsDefault.default)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

},{"../startOfWeek/index.js":"em4Ab","../toDate/index.js":"elr3O","../_lib/toInteger/index.js":"dkWbJ","../_lib/requiredArgs/index.js":"14prD","../_lib/defaultOptions/index.js":"eo7FR","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"bWerd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getWeekOfMonth;
});
var _indexJs = require("../_lib/defaultOptions/index.js");
var _indexJs1 = require("../getDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../getDay/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../startOfMonth/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs4);
var _indexJs5 = require("../_lib/toInteger/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs5);
function getWeekOfMonth(date, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault3.default)(1, arguments);
    var defaultOptions = (0, _indexJs.getDefaultOptions)();
    var weekStartsOn = (0, _indexJsDefault4.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var currentDayOfMonth = (0, _indexJsDefault.default)(date);
    if (isNaN(currentDayOfMonth)) return NaN;
    var startWeekDay = (0, _indexJsDefault1.default)((0, _indexJsDefault2.default)(date));
    var lastDayOfFirstWeek = weekStartsOn - startWeekDay;
    if (lastDayOfFirstWeek <= 0) lastDayOfFirstWeek += 7;
    var remainingDaysAfterFirstWeek = currentDayOfMonth - lastDayOfFirstWeek;
    return Math.ceil(remainingDaysAfterFirstWeek / 7) + 1;
}

},{"../_lib/defaultOptions/index.js":"eo7FR","../getDate/index.js":"9szif","../getDay/index.js":"5wMzR","../startOfMonth/index.js":"4MG0j","../_lib/requiredArgs/index.js":"14prD","../_lib/toInteger/index.js":"dkWbJ","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8QoMm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getWeeksInMonth;
});
var _indexJs = require("../differenceInCalendarWeeks/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../lastDayOfMonth/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../startOfMonth/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
function getWeeksInMonth(date, options) {
    (0, _indexJsDefault3.default)(1, arguments);
    return (0, _indexJsDefault.default)((0, _indexJsDefault1.default)(date), (0, _indexJsDefault2.default)(date), options) + 1;
}

},{"../differenceInCalendarWeeks/index.js":"6bPYn","../lastDayOfMonth/index.js":"46Uoq","../startOfMonth/index.js":"4MG0j","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"46Uoq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return lastDayOfMonth;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function lastDayOfMonth(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(0, 0, 0, 0);
    return date;
}

},{"../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"djuEO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getYear;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getYear(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    return (0, _indexJsDefault.default)(dirtyDate).getFullYear();
}

},{"../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5d80N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return hoursToMilliseconds;
});
var _indexJs = require("../_lib/requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../constants/index.js");
function hoursToMilliseconds(hours) {
    (0, _indexJsDefault.default)(1, arguments);
    return Math.floor(hours * (0, _indexJs1.millisecondsInHour));
}

},{"../_lib/requiredArgs/index.js":"14prD","../constants/index.js":"k64Zq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"irR0P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return hoursToMinutes;
});
var _indexJs = require("../_lib/requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../constants/index.js");
function hoursToMinutes(hours) {
    (0, _indexJsDefault.default)(1, arguments);
    return Math.floor(hours * (0, _indexJs1.minutesInHour));
}

},{"../_lib/requiredArgs/index.js":"14prD","../constants/index.js":"k64Zq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7H4oz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return hoursToSeconds;
});
var _indexJs = require("../_lib/requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../constants/index.js");
function hoursToSeconds(hours) {
    (0, _indexJsDefault.default)(1, arguments);
    return Math.floor(hours * (0, _indexJs1.secondsInHour));
}

},{"../_lib/requiredArgs/index.js":"14prD","../constants/index.js":"k64Zq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"g409N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return intervalToDuration;
});
var _indexJs = require("../compareAsc/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../add/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../differenceInDays/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../differenceInHours/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../differenceInMinutes/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
var _indexJs5 = require("../differenceInMonths/index.js");
var _indexJsDefault5 = parcelHelpers.interopDefault(_indexJs5);
var _indexJs6 = require("../differenceInSeconds/index.js");
var _indexJsDefault6 = parcelHelpers.interopDefault(_indexJs6);
var _indexJs7 = require("../differenceInYears/index.js");
var _indexJsDefault7 = parcelHelpers.interopDefault(_indexJs7);
var _indexJs8 = require("../toDate/index.js");
var _indexJsDefault8 = parcelHelpers.interopDefault(_indexJs8);
var _indexJs9 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault9 = parcelHelpers.interopDefault(_indexJs9);
function intervalToDuration(interval) {
    (0, _indexJsDefault9.default)(1, arguments);
    var start = (0, _indexJsDefault8.default)(interval.start);
    var end = (0, _indexJsDefault8.default)(interval.end);
    if (isNaN(start.getTime())) throw new RangeError('Start Date is invalid');
    if (isNaN(end.getTime())) throw new RangeError('End Date is invalid');
    var duration = {};
    duration.years = Math.abs((0, _indexJsDefault7.default)(end, start));
    var sign = (0, _indexJsDefault.default)(end, start);
    var remainingMonths = (0, _indexJsDefault1.default)(start, {
        years: sign * duration.years
    });
    duration.months = Math.abs((0, _indexJsDefault5.default)(end, remainingMonths));
    var remainingDays = (0, _indexJsDefault1.default)(remainingMonths, {
        months: sign * duration.months
    });
    duration.days = Math.abs((0, _indexJsDefault2.default)(end, remainingDays));
    var remainingHours = (0, _indexJsDefault1.default)(remainingDays, {
        days: sign * duration.days
    });
    duration.hours = Math.abs((0, _indexJsDefault3.default)(end, remainingHours));
    var remainingMinutes = (0, _indexJsDefault1.default)(remainingHours, {
        hours: sign * duration.hours
    });
    duration.minutes = Math.abs((0, _indexJsDefault4.default)(end, remainingMinutes));
    var remainingSeconds = (0, _indexJsDefault1.default)(remainingMinutes, {
        minutes: sign * duration.minutes
    });
    duration.seconds = Math.abs((0, _indexJsDefault6.default)(end, remainingSeconds));
    return duration;
}

},{"../compareAsc/index.js":"jbQZt","../add/index.js":"hbKuq","../differenceInDays/index.js":"88cpp","../differenceInHours/index.js":"fil0n","../differenceInMinutes/index.js":"cEAnJ","../differenceInMonths/index.js":"7dsnu","../differenceInSeconds/index.js":"40bOi","../differenceInYears/index.js":"gJB8K","../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"iHeqH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return intlFormat;
});
var _indexJs = require("../_lib/requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function intlFormat(date, formatOrLocale, localeOptions) {
    var _localeOptions;
    (0, _indexJsDefault.default)(1, arguments);
    var formatOptions;
    if (isFormatOptions(formatOrLocale)) formatOptions = formatOrLocale;
    else localeOptions = formatOrLocale;
    return new Intl.DateTimeFormat((_localeOptions = localeOptions) === null || _localeOptions === void 0 ? void 0 : _localeOptions.locale, formatOptions).format(date);
}
function isFormatOptions(opts) {
    return opts !== undefined && !('locale' in opts);
}

},{"../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"dXFeW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return intlFormatDistance;
});
var _indexJs = require("../constants/index.js");
var _indexJs1 = require("../differenceInCalendarDays/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../differenceInCalendarMonths/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../differenceInCalendarQuarters/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../differenceInCalendarWeeks/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs4);
var _indexJs5 = require("../differenceInCalendarYears/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs5);
var _indexJs6 = require("../differenceInHours/index.js");
var _indexJsDefault5 = parcelHelpers.interopDefault(_indexJs6);
var _indexJs7 = require("../differenceInMinutes/index.js");
var _indexJsDefault6 = parcelHelpers.interopDefault(_indexJs7);
var _indexJs8 = require("../differenceInSeconds/index.js");
var _indexJsDefault7 = parcelHelpers.interopDefault(_indexJs8);
var _indexJs9 = require("../toDate/index.js");
var _indexJsDefault8 = parcelHelpers.interopDefault(_indexJs9);
var _indexJs10 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault9 = parcelHelpers.interopDefault(_indexJs10);
function intlFormatDistance(date, baseDate, options) {
    (0, _indexJsDefault9.default)(2, arguments);
    var value = 0;
    var unit;
    var dateLeft = (0, _indexJsDefault8.default)(date);
    var dateRight = (0, _indexJsDefault8.default)(baseDate);
    if (!(options !== null && options !== void 0 && options.unit)) {
        // Get the unit based on diffInSeconds calculations if no unit is specified
        var diffInSeconds = (0, _indexJsDefault7.default)(dateLeft, dateRight); // The smallest unit
        if (Math.abs(diffInSeconds) < (0, _indexJs.secondsInMinute)) {
            value = (0, _indexJsDefault7.default)(dateLeft, dateRight);
            unit = 'second';
        } else if (Math.abs(diffInSeconds) < (0, _indexJs.secondsInHour)) {
            value = (0, _indexJsDefault6.default)(dateLeft, dateRight);
            unit = 'minute';
        } else if (Math.abs(diffInSeconds) < (0, _indexJs.secondsInDay) && Math.abs((0, _indexJsDefault.default)(dateLeft, dateRight)) < 1) {
            value = (0, _indexJsDefault5.default)(dateLeft, dateRight);
            unit = 'hour';
        } else if (Math.abs(diffInSeconds) < (0, _indexJs.secondsInWeek) && (value = (0, _indexJsDefault.default)(dateLeft, dateRight)) && Math.abs(value) < 7) unit = 'day';
        else if (Math.abs(diffInSeconds) < (0, _indexJs.secondsInMonth)) {
            value = (0, _indexJsDefault3.default)(dateLeft, dateRight);
            unit = 'week';
        } else if (Math.abs(diffInSeconds) < (0, _indexJs.secondsInQuarter)) {
            value = (0, _indexJsDefault1.default)(dateLeft, dateRight);
            unit = 'month';
        } else if (Math.abs(diffInSeconds) < (0, _indexJs.secondsInYear)) {
            if ((0, _indexJsDefault2.default)(dateLeft, dateRight) < 4) {
                // To filter out cases that are less than a year but match 4 quarters
                value = (0, _indexJsDefault2.default)(dateLeft, dateRight);
                unit = 'quarter';
            } else {
                value = (0, _indexJsDefault4.default)(dateLeft, dateRight);
                unit = 'year';
            }
        } else {
            value = (0, _indexJsDefault4.default)(dateLeft, dateRight);
            unit = 'year';
        }
    } else {
        // Get the value if unit is specified
        unit = options === null || options === void 0 ? void 0 : options.unit;
        if (unit === 'second') value = (0, _indexJsDefault7.default)(dateLeft, dateRight);
        else if (unit === 'minute') value = (0, _indexJsDefault6.default)(dateLeft, dateRight);
        else if (unit === 'hour') value = (0, _indexJsDefault5.default)(dateLeft, dateRight);
        else if (unit === 'day') value = (0, _indexJsDefault.default)(dateLeft, dateRight);
        else if (unit === 'week') value = (0, _indexJsDefault3.default)(dateLeft, dateRight);
        else if (unit === 'month') value = (0, _indexJsDefault1.default)(dateLeft, dateRight);
        else if (unit === 'quarter') value = (0, _indexJsDefault2.default)(dateLeft, dateRight);
        else if (unit === 'year') value = (0, _indexJsDefault4.default)(dateLeft, dateRight);
    }
    var rtf = new Intl.RelativeTimeFormat(options === null || options === void 0 ? void 0 : options.locale, {
        localeMatcher: options === null || options === void 0 ? void 0 : options.localeMatcher,
        numeric: (options === null || options === void 0 ? void 0 : options.numeric) || 'auto',
        style: options === null || options === void 0 ? void 0 : options.style
    });
    return rtf.format(value, unit);
}

},{"../constants/index.js":"k64Zq","../differenceInCalendarDays/index.js":"44jgD","../differenceInCalendarMonths/index.js":"2NHrG","../differenceInCalendarQuarters/index.js":"6WkeE","../differenceInCalendarWeeks/index.js":"6bPYn","../differenceInCalendarYears/index.js":"dQoj8","../differenceInHours/index.js":"fil0n","../differenceInMinutes/index.js":"cEAnJ","../differenceInSeconds/index.js":"40bOi","../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8h0gP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isAfter;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isAfter(dirtyDate, dirtyDateToCompare) {
    (0, _indexJsDefault1.default)(2, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var dateToCompare = (0, _indexJsDefault.default)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}

},{"../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"a13ig":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isBefore;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isBefore(dirtyDate, dirtyDateToCompare) {
    (0, _indexJsDefault1.default)(2, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var dateToCompare = (0, _indexJsDefault.default)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}

},{"../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4t23L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isEqual;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isEqual(dirtyLeftDate, dirtyRightDate) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateLeft = (0, _indexJsDefault.default)(dirtyLeftDate);
    var dateRight = (0, _indexJsDefault.default)(dirtyRightDate);
    return dateLeft.getTime() === dateRight.getTime();
}

},{"../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"03SJy":[function(require,module,exports,__globalThis) {
/**
 * @name isExists
 * @category Common Helpers
 * @summary Is the given date exists?
 *
 * @description
 * Checks if the given arguments convert to an existing date.
 *
 * @param {Number} year of the date to check
 * @param {Number} month of the date to check
 * @param {Number} day of the date to check
 * @returns {Boolean} the date exists
 * @throws {TypeError} 3 arguments required
 *
 * @example
 * // For the valid date:
 * const result = isExists(2018, 0, 31)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isExists(2018, 1, 31)
 * //=> false
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isExists;
});
function isExists(year, month, day) {
    if (arguments.length < 3) throw new TypeError('3 argument required, but only ' + arguments.length + ' present');
    var date = new Date(year, month, day);
    return date.getFullYear() === year && date.getMonth() === month && date.getDate() === day;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"fM3Mi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isFirstDayOfMonth;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isFirstDayOfMonth(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    return (0, _indexJsDefault.default)(dirtyDate).getDate() === 1;
}

},{"../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2Wcjk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isFriday;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isFriday(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    return (0, _indexJsDefault.default)(dirtyDate).getDay() === 5;
}

},{"../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7NAjC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isFuture;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isFuture(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    return (0, _indexJsDefault.default)(dirtyDate).getTime() > Date.now();
}

},{"../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"x4zY1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isMatch;
});
var _indexJs = require("../parse/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../isValid/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function isMatch(dateString, formatString, options) {
    (0, _indexJsDefault2.default)(2, arguments);
    return (0, _indexJsDefault1.default)((0, _indexJsDefault.default)(dateString, formatString, new Date(), options));
}

},{"../parse/index.js":"01uF3","../isValid/index.js":"fScb4","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"01uF3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return parse;
});
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _createForOfIteratorHelper = require("@babel/runtime/helpers/esm/createForOfIteratorHelper");
var _createForOfIteratorHelperDefault = parcelHelpers.interopDefault(_createForOfIteratorHelper);
var _indexJs = require("../_lib/defaultLocale/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../subMilliseconds/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../toDate/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/assign/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../_lib/format/longFormatters/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
var _indexJs5 = require("../_lib/getTimezoneOffsetInMilliseconds/index.js");
var _indexJsDefault5 = parcelHelpers.interopDefault(_indexJs5);
var _indexJs6 = require("../_lib/protectedTokens/index.js");
var _indexJs7 = require("../_lib/toInteger/index.js");
var _indexJsDefault6 = parcelHelpers.interopDefault(_indexJs7);
var _indexJs8 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault7 = parcelHelpers.interopDefault(_indexJs8);
var _setterJs = require("./_lib/Setter.js");
var _indexJs9 = require("./_lib/parsers/index.js");
var _indexJs10 = require("../_lib/defaultOptions/index.js"); // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var notWhitespaceRegExp = /\S/;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function parse(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, _indexJsDefault7.default)(3, arguments);
    var dateString = String(dirtyDateString);
    var formatString = String(dirtyFormatString);
    var defaultOptions = (0, _indexJs10.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, _indexJsDefault.default);
    if (!locale.match) throw new RangeError('locale must contain match property');
    var firstWeekContainsDate = (0, _indexJsDefault6.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, _indexJsDefault6.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (formatString === '') {
        if (dateString === '') return (0, _indexJsDefault2.default)(dirtyReferenceDate);
        else return new Date(NaN);
    }
    var subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will be set to the system timezone
    var setters = [
        new (0, _setterJs.DateToSystemTimezoneSetter)()
    ];
    var tokens = formatString.match(longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter in (0, _indexJsDefault4.default)) {
            var longFormatter = (0, _indexJsDefault4.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match(formattingTokensRegExp);
    var usedTokens = [];
    var _iterator = (0, _createForOfIteratorHelperDefault.default)(tokens), _step;
    try {
        var _loop = function _loop() {
            var token = _step.value;
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, _indexJs6.isProtectedWeekYearToken)(token)) (0, _indexJs6.throwProtectedError)(token, formatString, dirtyDateString);
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, _indexJs6.isProtectedDayOfYearToken)(token)) (0, _indexJs6.throwProtectedError)(token, formatString, dirtyDateString);
            var firstCharacter = token[0];
            var parser = (0, _indexJs9.parsers)[firstCharacter];
            if (parser) {
                var incompatibleTokens = parser.incompatibleTokens;
                if (Array.isArray(incompatibleTokens)) {
                    var incompatibleToken = usedTokens.find(function(usedToken) {
                        return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
                    });
                    if (incompatibleToken) throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
                } else if (parser.incompatibleTokens === '*' && usedTokens.length > 0) throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
                usedTokens.push({
                    token: firstCharacter,
                    fullToken: token
                });
                var parseResult = parser.run(dateString, token, locale.match, subFnOptions);
                if (!parseResult) return {
                    v: new Date(NaN)
                };
                setters.push(parseResult.setter);
                dateString = parseResult.rest;
            } else {
                if (firstCharacter.match(unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
                // Replace two single quote characters with one single quote character
                if (token === "''") token = "'";
                else if (firstCharacter === "'") token = cleanEscapedString(token);
                // Cut token from string, or, if string doesn't match the token, return Invalid Date
                if (dateString.indexOf(token) === 0) dateString = dateString.slice(token.length);
                else return {
                    v: new Date(NaN)
                };
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _ret = _loop();
            if ((0, _typeofDefault.default)(_ret) === "object") return _ret.v;
        }
    // Check if the remaining input contains something other than whitespace
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) return new Date(NaN);
    var uniquePrioritySetters = setters.map(function(setter) {
        return setter.priority;
    }).sort(function(a, b) {
        return b - a;
    }).filter(function(priority, index, array) {
        return array.indexOf(priority) === index;
    }).map(function(priority) {
        return setters.filter(function(setter) {
            return setter.priority === priority;
        }).sort(function(a, b) {
            return b.subPriority - a.subPriority;
        });
    }).map(function(setterArray) {
        return setterArray[0];
    });
    var date = (0, _indexJsDefault2.default)(dirtyReferenceDate);
    if (isNaN(date.getTime())) return new Date(NaN);
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    var utcDate = (0, _indexJsDefault1.default)(date, (0, _indexJsDefault5.default)(date));
    var flags = {};
    var _iterator2 = (0, _createForOfIteratorHelperDefault.default)(uniquePrioritySetters), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var setter = _step2.value;
            if (!setter.validate(utcDate, subFnOptions)) return new Date(NaN);
            var result = setter.set(utcDate, flags, subFnOptions);
            // Result is tuple (date, flags)
            if (Array.isArray(result)) {
                utcDate = result[0];
                (0, _indexJsDefault3.default)(flags, result[1]);
            // Result is date
            } else utcDate = result;
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    return utcDate;
}
function cleanEscapedString(input) {
    return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}

},{"@babel/runtime/helpers/esm/typeof":"8bpl6","@babel/runtime/helpers/esm/createForOfIteratorHelper":"5XUEk","../_lib/defaultLocale/index.js":"2BPBN","../subMilliseconds/index.js":"1aYLs","../toDate/index.js":"elr3O","../_lib/assign/index.js":"lQLgw","../_lib/format/longFormatters/index.js":"doiWo","../_lib/getTimezoneOffsetInMilliseconds/index.js":"3kvOg","../_lib/protectedTokens/index.js":"l3hRj","../_lib/toInteger/index.js":"dkWbJ","../_lib/requiredArgs/index.js":"14prD","./_lib/Setter.js":"8CuFq","./_lib/parsers/index.js":"kFLbt","../_lib/defaultOptions/index.js":"eo7FR","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5XUEk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _createForOfIteratorHelper;
});
var _unsupportedIterableToArrayJs = require("./unsupportedIterableToArray.js");
var _unsupportedIterableToArrayJsDefault = parcelHelpers.interopDefault(_unsupportedIterableToArrayJs);
function _createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = (0, _unsupportedIterableToArrayJsDefault.default)(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var _$r = t.next();
            return a = _$r.done, _$r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}

},{"./unsupportedIterableToArray.js":"8XNa6","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8XNa6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _unsupportedIterableToArray;
});
var _arrayLikeToArrayJs = require("./arrayLikeToArray.js");
var _arrayLikeToArrayJsDefault = parcelHelpers.interopDefault(_arrayLikeToArrayJs);
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, _arrayLikeToArrayJsDefault.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, _arrayLikeToArrayJsDefault.default)(r, a) : void 0;
    }
}

},{"./arrayLikeToArray.js":"2wXUK","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2wXUK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _arrayLikeToArray;
});
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8CuFq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Setter", function() {
    return Setter;
});
parcelHelpers.export(exports, "ValueSetter", function() {
    return ValueSetter;
});
parcelHelpers.export(exports, "DateToSystemTimezoneSetter", function() {
    return DateToSystemTimezoneSetter;
});
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var TIMEZONE_UNIT_PRIORITY = 10;
var Setter = /*#__PURE__*/ function() {
    function Setter() {
        (0, _classCallCheckDefault.default)(this, Setter);
        (0, _definePropertyDefault.default)(this, "priority", void 0);
        (0, _definePropertyDefault.default)(this, "subPriority", 0);
    }
    (0, _createClassDefault.default)(Setter, [
        {
            key: "validate",
            value: function validate(_utcDate, _options) {
                return true;
            }
        }
    ]);
    return Setter;
}();
var ValueSetter = /*#__PURE__*/ function(_Setter) {
    (0, _inheritsDefault.default)(ValueSetter, _Setter);
    var _super = (0, _createSuperDefault.default)(ValueSetter);
    function ValueSetter(value, validateValue, setValue, priority, subPriority) {
        var _this;
        (0, _classCallCheckDefault.default)(this, ValueSetter);
        _this = _super.call(this);
        _this.value = value;
        _this.validateValue = validateValue;
        _this.setValue = setValue;
        _this.priority = priority;
        if (subPriority) _this.subPriority = subPriority;
        return _this;
    }
    (0, _createClassDefault.default)(ValueSetter, [
        {
            key: "validate",
            value: function validate(utcDate, options) {
                return this.validateValue(utcDate, this.value, options);
            }
        },
        {
            key: "set",
            value: function set(utcDate, flags, options) {
                return this.setValue(utcDate, flags, this.value, options);
            }
        }
    ]);
    return ValueSetter;
}(Setter);
var DateToSystemTimezoneSetter = /*#__PURE__*/ function(_Setter2) {
    (0, _inheritsDefault.default)(DateToSystemTimezoneSetter, _Setter2);
    var _super2 = (0, _createSuperDefault.default)(DateToSystemTimezoneSetter);
    function DateToSystemTimezoneSetter() {
        var _this2;
        (0, _classCallCheckDefault.default)(this, DateToSystemTimezoneSetter);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this2), "priority", TIMEZONE_UNIT_PRIORITY);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this2), "subPriority", -1);
        return _this2;
    }
    (0, _createClassDefault.default)(DateToSystemTimezoneSetter, [
        {
            key: "set",
            value: function set(date, flags) {
                if (flags.timestampIsSet) return date;
                var convertedDate = new Date(0);
                convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
                convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
                return convertedDate;
            }
        }
    ]);
    return DateToSystemTimezoneSetter;
}(Setter);

},{"@babel/runtime/helpers/esm/assertThisInitialized":"KHALr","@babel/runtime/helpers/esm/inherits":"kirHe","@babel/runtime/helpers/esm/createSuper":"10JMl","@babel/runtime/helpers/esm/classCallCheck":"94O91","@babel/runtime/helpers/esm/createClass":"kCxIn","@babel/runtime/helpers/esm/defineProperty":"4z9Hv","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"KHALr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _assertThisInitialized;
});
function _assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"kirHe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _inherits;
});
var _setPrototypeOfJs = require("./setPrototypeOf.js");
var _setPrototypeOfJsDefault = parcelHelpers.interopDefault(_setPrototypeOfJs);
function _inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, _setPrototypeOfJsDefault.default)(t, e);
}

},{"./setPrototypeOf.js":"2hnLS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2hnLS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _setPrototypeOf;
});
function _setPrototypeOf(t, e) {
    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(t, e) {
        return t.__proto__ = e, t;
    }, _setPrototypeOf(t, e);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"10JMl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _createSuper;
});
var _getPrototypeOfJs = require("./getPrototypeOf.js");
var _getPrototypeOfJsDefault = parcelHelpers.interopDefault(_getPrototypeOfJs);
var _isNativeReflectConstructJs = require("./isNativeReflectConstruct.js");
var _isNativeReflectConstructJsDefault = parcelHelpers.interopDefault(_isNativeReflectConstructJs);
var _possibleConstructorReturnJs = require("./possibleConstructorReturn.js");
var _possibleConstructorReturnJsDefault = parcelHelpers.interopDefault(_possibleConstructorReturnJs);
function _createSuper(t) {
    var r = (0, _isNativeReflectConstructJsDefault.default)();
    return function() {
        var e, o = (0, _getPrototypeOfJsDefault.default)(t);
        if (r) {
            var s = (0, _getPrototypeOfJsDefault.default)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, _possibleConstructorReturnJsDefault.default)(this, e);
    };
}

},{"./getPrototypeOf.js":"dZThJ","./isNativeReflectConstruct.js":"1dnPK","./possibleConstructorReturn.js":"6aMAF","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"dZThJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _getPrototypeOf;
});
function _getPrototypeOf(t) {
    return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, _getPrototypeOf(t);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1dnPK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _isNativeReflectConstruct;
});
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6aMAF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _possibleConstructorReturn;
});
var _typeofJs = require("./typeof.js");
var _typeofJsDefault = parcelHelpers.interopDefault(_typeofJs);
var _assertThisInitializedJs = require("./assertThisInitialized.js");
var _assertThisInitializedJsDefault = parcelHelpers.interopDefault(_assertThisInitializedJs);
function _possibleConstructorReturn(t, e) {
    if (e && ("object" == (0, _typeofJsDefault.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, _assertThisInitializedJsDefault.default)(t);
}

},{"./typeof.js":"8bpl6","./assertThisInitialized.js":"KHALr","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"94O91":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _classCallCheck;
});
function _classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"kCxIn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _createClass;
});
var _toPropertyKeyJs = require("./toPropertyKey.js");
var _toPropertyKeyJsDefault = parcelHelpers.interopDefault(_toPropertyKeyJs);
function _defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, _toPropertyKeyJsDefault.default)(o.key), o);
    }
}
function _createClass(e, r, t) {
    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

},{"./toPropertyKey.js":"afUTr","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"afUTr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return toPropertyKey;
});
var _typeofJs = require("./typeof.js");
var _typeofJsDefault = parcelHelpers.interopDefault(_typeofJs);
var _toPrimitiveJs = require("./toPrimitive.js");
var _toPrimitiveJsDefault = parcelHelpers.interopDefault(_toPrimitiveJs);
function toPropertyKey(t) {
    var i = (0, _toPrimitiveJsDefault.default)(t, "string");
    return "symbol" == (0, _typeofJsDefault.default)(i) ? i : i + "";
}

},{"./typeof.js":"8bpl6","./toPrimitive.js":"6NWRd","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6NWRd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return toPrimitive;
});
var _typeofJs = require("./typeof.js");
var _typeofJsDefault = parcelHelpers.interopDefault(_typeofJs);
function toPrimitive(t, r) {
    if ("object" != (0, _typeofJsDefault.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, _typeofJsDefault.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

},{"./typeof.js":"8bpl6","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4z9Hv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _defineProperty;
});
var _toPropertyKeyJs = require("./toPropertyKey.js");
var _toPropertyKeyJsDefault = parcelHelpers.interopDefault(_toPropertyKeyJs);
function _defineProperty(e, r, t) {
    return (r = (0, _toPropertyKeyJsDefault.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

},{"./toPropertyKey.js":"afUTr","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"kFLbt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parsers", function() {
    return parsers;
});
var _eraParserJs = require("./EraParser.js");
var _yearParserJs = require("./YearParser.js");
var _localWeekYearParserJs = require("./LocalWeekYearParser.js");
var _isoweekYearParserJs = require("./ISOWeekYearParser.js");
var _extendedYearParserJs = require("./ExtendedYearParser.js");
var _quarterParserJs = require("./QuarterParser.js");
var _standAloneQuarterParserJs = require("./StandAloneQuarterParser.js");
var _monthParserJs = require("./MonthParser.js");
var _standAloneMonthParserJs = require("./StandAloneMonthParser.js");
var _localWeekParserJs = require("./LocalWeekParser.js");
var _isoweekParserJs = require("./ISOWeekParser.js");
var _dateParserJs = require("./DateParser.js");
var _dayOfYearParserJs = require("./DayOfYearParser.js");
var _dayParserJs = require("./DayParser.js");
var _localDayParserJs = require("./LocalDayParser.js");
var _standAloneLocalDayParserJs = require("./StandAloneLocalDayParser.js");
var _isodayParserJs = require("./ISODayParser.js");
var _ampmparserJs = require("./AMPMParser.js");
var _ampmmidnightParserJs = require("./AMPMMidnightParser.js");
var _dayPeriodParserJs = require("./DayPeriodParser.js");
var _hour1To12ParserJs = require("./Hour1to12Parser.js");
var _hour0To23ParserJs = require("./Hour0to23Parser.js");
var _hour0To11ParserJs = require("./Hour0To11Parser.js");
var _hour1To24ParserJs = require("./Hour1To24Parser.js");
var _minuteParserJs = require("./MinuteParser.js");
var _secondParserJs = require("./SecondParser.js");
var _fractionOfSecondParserJs = require("./FractionOfSecondParser.js");
var _isotimezoneWithZParserJs = require("./ISOTimezoneWithZParser.js");
var _isotimezoneParserJs = require("./ISOTimezoneParser.js");
var _timestampSecondsParserJs = require("./TimestampSecondsParser.js");
var _timestampMillisecondsParserJs = require("./TimestampMillisecondsParser.js");
var parsers = {
    G: new (0, _eraParserJs.EraParser)(),
    y: new (0, _yearParserJs.YearParser)(),
    Y: new (0, _localWeekYearParserJs.LocalWeekYearParser)(),
    R: new (0, _isoweekYearParserJs.ISOWeekYearParser)(),
    u: new (0, _extendedYearParserJs.ExtendedYearParser)(),
    Q: new (0, _quarterParserJs.QuarterParser)(),
    q: new (0, _standAloneQuarterParserJs.StandAloneQuarterParser)(),
    M: new (0, _monthParserJs.MonthParser)(),
    L: new (0, _standAloneMonthParserJs.StandAloneMonthParser)(),
    w: new (0, _localWeekParserJs.LocalWeekParser)(),
    I: new (0, _isoweekParserJs.ISOWeekParser)(),
    d: new (0, _dateParserJs.DateParser)(),
    D: new (0, _dayOfYearParserJs.DayOfYearParser)(),
    E: new (0, _dayParserJs.DayParser)(),
    e: new (0, _localDayParserJs.LocalDayParser)(),
    c: new (0, _standAloneLocalDayParserJs.StandAloneLocalDayParser)(),
    i: new (0, _isodayParserJs.ISODayParser)(),
    a: new (0, _ampmparserJs.AMPMParser)(),
    b: new (0, _ampmmidnightParserJs.AMPMMidnightParser)(),
    B: new (0, _dayPeriodParserJs.DayPeriodParser)(),
    h: new (0, _hour1To12ParserJs.Hour1to12Parser)(),
    H: new (0, _hour0To23ParserJs.Hour0to23Parser)(),
    K: new (0, _hour0To11ParserJs.Hour0To11Parser)(),
    k: new (0, _hour1To24ParserJs.Hour1To24Parser)(),
    m: new (0, _minuteParserJs.MinuteParser)(),
    s: new (0, _secondParserJs.SecondParser)(),
    S: new (0, _fractionOfSecondParserJs.FractionOfSecondParser)(),
    X: new (0, _isotimezoneWithZParserJs.ISOTimezoneWithZParser)(),
    x: new (0, _isotimezoneParserJs.ISOTimezoneParser)(),
    t: new (0, _timestampSecondsParserJs.TimestampSecondsParser)(),
    T: new (0, _timestampMillisecondsParserJs.TimestampMillisecondsParser)()
};

},{"./EraParser.js":"7RRDO","./YearParser.js":"3DYsE","./LocalWeekYearParser.js":"bEgEz","./ISOWeekYearParser.js":"8hQBE","./ExtendedYearParser.js":"7NzgY","./QuarterParser.js":"cXeEn","./StandAloneQuarterParser.js":"Q9TJB","./MonthParser.js":"9nMP6","./StandAloneMonthParser.js":"8Xgdi","./LocalWeekParser.js":"8P1Ck","./ISOWeekParser.js":"6quHF","./DateParser.js":"gXdgI","./DayOfYearParser.js":"lvq4n","./DayParser.js":"lgWWe","./LocalDayParser.js":"43DRU","./StandAloneLocalDayParser.js":"1ztSn","./ISODayParser.js":"d4rRp","./AMPMParser.js":"iJ6KT","./AMPMMidnightParser.js":"9I52l","./DayPeriodParser.js":"gZvbG","./Hour1to12Parser.js":"kFQv3","./Hour0to23Parser.js":"h84n1","./Hour0To11Parser.js":"77H56","./Hour1To24Parser.js":"CW7Uj","./MinuteParser.js":"8gCdK","./SecondParser.js":"1tXC1","./FractionOfSecondParser.js":"1tlNu","./ISOTimezoneWithZParser.js":"dmes1","./ISOTimezoneParser.js":"hKpmZ","./TimestampSecondsParser.js":"ceB0w","./TimestampMillisecondsParser.js":"lcmEb","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7RRDO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EraParser", function() {
    return EraParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var EraParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(EraParser, _Parser);
    var _super = (0, _createSuperDefault.default)(EraParser);
    function EraParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, EraParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 140);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'R',
            'u',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(EraParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // AD, BC
                    case 'G':
                    case 'GG':
                    case 'GGG':
                        return match.era(dateString, {
                            width: 'abbreviated'
                        }) || match.era(dateString, {
                            width: 'narrow'
                        });
                    // A, B
                    case 'GGGGG':
                        return match.era(dateString, {
                            width: 'narrow'
                        });
                    // Anno Domini, Before Christ
                    case 'GGGG':
                    default:
                        return match.era(dateString, {
                            width: 'wide'
                        }) || match.era(dateString, {
                            width: 'abbreviated'
                        }) || match.era(dateString, {
                            width: 'narrow'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                flags.era = value;
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return EraParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"94O91","@babel/runtime/helpers/esm/createClass":"kCxIn","@babel/runtime/helpers/esm/assertThisInitialized":"KHALr","@babel/runtime/helpers/esm/inherits":"kirHe","@babel/runtime/helpers/esm/createSuper":"10JMl","@babel/runtime/helpers/esm/defineProperty":"4z9Hv","../Parser.js":"56qie","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"56qie":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Parser", function() {
    return Parser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _setterJs = require("./Setter.js");
var Parser = /*#__PURE__*/ function() {
    function Parser() {
        (0, _classCallCheckDefault.default)(this, Parser);
        (0, _definePropertyDefault.default)(this, "incompatibleTokens", void 0);
        (0, _definePropertyDefault.default)(this, "priority", void 0);
        (0, _definePropertyDefault.default)(this, "subPriority", void 0);
    }
    (0, _createClassDefault.default)(Parser, [
        {
            key: "run",
            value: function run(dateString, token, match, options) {
                var result = this.parse(dateString, token, match, options);
                if (!result) return null;
                return {
                    setter: new (0, _setterJs.ValueSetter)(result.value, this.validate, this.set, this.priority, this.subPriority),
                    rest: result.rest
                };
            }
        },
        {
            key: "validate",
            value: function validate(_utcDate, _value, _options) {
                return true;
            }
        }
    ]);
    return Parser;
}();

},{"@babel/runtime/helpers/esm/classCallCheck":"94O91","@babel/runtime/helpers/esm/createClass":"kCxIn","@babel/runtime/helpers/esm/defineProperty":"4z9Hv","./Setter.js":"8CuFq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3DYsE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "YearParser", function() {
    return YearParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var YearParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(YearParser, _Parser);
    var _super = (0, _createSuperDefault.default)(YearParser);
    function YearParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, YearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 130);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'u',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(YearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === 'yy'
                    };
                };
                switch(token){
                    case 'y':
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(4, dateString), valueCallback);
                    case 'yo':
                        return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'year'
                        }), valueCallback);
                    default:
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                var currentYear = date.getUTCFullYear();
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, _utilsJs.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
                    date.setUTCHours(0, 0, 0, 0);
                    return date;
                }
                var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return YearParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"94O91","@babel/runtime/helpers/esm/createClass":"kCxIn","@babel/runtime/helpers/esm/assertThisInitialized":"KHALr","@babel/runtime/helpers/esm/inherits":"kirHe","@babel/runtime/helpers/esm/createSuper":"10JMl","@babel/runtime/helpers/esm/defineProperty":"4z9Hv","../Parser.js":"56qie","../utils.js":"78FNA","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"78FNA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapValue", function() {
    return mapValue;
});
parcelHelpers.export(exports, "parseNumericPattern", function() {
    return parseNumericPattern;
});
parcelHelpers.export(exports, "parseTimezonePattern", function() {
    return parseTimezonePattern;
});
parcelHelpers.export(exports, "parseAnyDigitsSigned", function() {
    return parseAnyDigitsSigned;
});
parcelHelpers.export(exports, "parseNDigits", function() {
    return parseNDigits;
});
parcelHelpers.export(exports, "parseNDigitsSigned", function() {
    return parseNDigitsSigned;
});
parcelHelpers.export(exports, "dayPeriodEnumToHours", function() {
    return dayPeriodEnumToHours;
});
parcelHelpers.export(exports, "normalizeTwoDigitYear", function() {
    return normalizeTwoDigitYear;
});
parcelHelpers.export(exports, "isLeapYearIndex", function() {
    return isLeapYearIndex;
});
var _indexJs = require("../../constants/index.js");
var _constantsJs = require("./constants.js");
function mapValue(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function parseNumericPattern(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function parseTimezonePattern(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === 'Z') return {
        value: 0,
        rest: dateString.slice(1)
    };
    var sign = matchResult[1] === '+' ? 1 : -1;
    var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, _indexJs.millisecondsInHour) + minutes * (0, _indexJs.millisecondsInMinute) + seconds * (0, _indexJs.millisecondsInSecond)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function parseAnyDigitsSigned(dateString) {
    return parseNumericPattern((0, _constantsJs.numericPatterns).anyDigitsSigned, dateString);
}
function parseNDigits(n, dateString) {
    switch(n){
        case 1:
            return parseNumericPattern((0, _constantsJs.numericPatterns).singleDigit, dateString);
        case 2:
            return parseNumericPattern((0, _constantsJs.numericPatterns).twoDigits, dateString);
        case 3:
            return parseNumericPattern((0, _constantsJs.numericPatterns).threeDigits, dateString);
        case 4:
            return parseNumericPattern((0, _constantsJs.numericPatterns).fourDigits, dateString);
        default:
            return parseNumericPattern(new RegExp('^\\d{1,' + n + '}'), dateString);
    }
}
function parseNDigitsSigned(n, dateString) {
    switch(n){
        case 1:
            return parseNumericPattern((0, _constantsJs.numericPatterns).singleDigitSigned, dateString);
        case 2:
            return parseNumericPattern((0, _constantsJs.numericPatterns).twoDigitsSigned, dateString);
        case 3:
            return parseNumericPattern((0, _constantsJs.numericPatterns).threeDigitsSigned, dateString);
        case 4:
            return parseNumericPattern((0, _constantsJs.numericPatterns).fourDigitsSigned, dateString);
        default:
            return parseNumericPattern(new RegExp('^-?\\d{1,' + n + '}'), dateString);
    }
}
function dayPeriodEnumToHours(dayPeriod) {
    switch(dayPeriod){
        case 'morning':
            return 4;
        case 'evening':
            return 17;
        case 'pm':
        case 'noon':
        case 'afternoon':
            return 12;
        case 'am':
        case 'midnight':
        case 'night':
        default:
            return 0;
    }
}
function normalizeTwoDigitYear(twoDigitYear, currentYear) {
    var isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    var result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        var rangeEnd = absCurrentYear + 50;
        var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
        var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

},{"../../constants/index.js":"k64Zq","./constants.js":"gBnXO","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gBnXO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "numericPatterns", function() {
    return numericPatterns;
});
parcelHelpers.export(exports, "timezonePatterns", function() {
    return timezonePatterns;
});
var numericPatterns = {
    month: /^(1[0-2]|0?\d)/,
    // 0 to 12
    date: /^(3[0-1]|[0-2]?\d)/,
    // 0 to 31
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    // 0 to 366
    week: /^(5[0-3]|[0-4]?\d)/,
    // 0 to 53
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    // 0 to 23
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    // 0 to 24
    hour11h: /^(1[0-1]|0?\d)/,
    // 0 to 11
    hour12h: /^(1[0-2]|0?\d)/,
    // 0 to 12
    minute: /^[0-5]?\d/,
    // 0 to 59
    second: /^[0-5]?\d/,
    // 0 to 59
    singleDigit: /^\d/,
    // 0 to 9
    twoDigits: /^\d{1,2}/,
    // 0 to 99
    threeDigits: /^\d{1,3}/,
    // 0 to 999
    fourDigits: /^\d{1,4}/,
    // 0 to 9999
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    // 0 to 9, -0 to -9
    twoDigitsSigned: /^-?\d{1,2}/,
    // 0 to 99, -0 to -99
    threeDigitsSigned: /^-?\d{1,3}/,
    // 0 to 999, -0 to -999
    fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};
var timezonePatterns = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"bEgEz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LocalWeekYearParser", function() {
    return LocalWeekYearParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/getUTCWeekYear/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/startOfUTCWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var LocalWeekYearParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(LocalWeekYearParser, _Parser);
    var _super = (0, _createSuperDefault.default)(LocalWeekYearParser);
    function LocalWeekYearParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, LocalWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 130);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(LocalWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === 'YY'
                    };
                };
                switch(token){
                    case 'Y':
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(4, dateString), valueCallback);
                    case 'Yo':
                        return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'year'
                        }), valueCallback);
                    default:
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value, options) {
                var currentYear = (0, _indexJsDefault.default)(date, options);
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, _utilsJs.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
                    date.setUTCHours(0, 0, 0, 0);
                    return (0, _indexJsDefault1.default)(date, options);
                }
                var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
                date.setUTCHours(0, 0, 0, 0);
                return (0, _indexJsDefault1.default)(date, options);
            }
        }
    ]);
    return LocalWeekYearParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"94O91","@babel/runtime/helpers/esm/createClass":"kCxIn","@babel/runtime/helpers/esm/assertThisInitialized":"KHALr","@babel/runtime/helpers/esm/inherits":"kirHe","@babel/runtime/helpers/esm/createSuper":"10JMl","@babel/runtime/helpers/esm/defineProperty":"4z9Hv","../Parser.js":"56qie","../utils.js":"78FNA","../../../_lib/getUTCWeekYear/index.js":"9IqAt","../../../_lib/startOfUTCWeek/index.js":"cCeyA","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8hQBE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ISOWeekYearParser", function() {
    return ISOWeekYearParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/startOfUTCISOWeek/index.js"); // ISO week-numbering year
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var ISOWeekYearParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(ISOWeekYearParser, _Parser);
    var _super = (0, _createSuperDefault.default)(ISOWeekYearParser);
    function ISOWeekYearParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, ISOWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 130);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'G',
            'y',
            'Y',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(ISOWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === 'R') return (0, _utilsJs.parseNDigitsSigned)(4, dateString);
                return (0, _utilsJs.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                var firstWeekOfYear = new Date(0);
                firstWeekOfYear.setUTCFullYear(value, 0, 4);
                firstWeekOfYear.setUTCHours(0, 0, 0, 0);
                return (0, _indexJsDefault.default)(firstWeekOfYear);
            }
        }
    ]);
    return ISOWeekYearParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"94O91","@babel/runtime/helpers/esm/createClass":"kCxIn","@babel/runtime/helpers/esm/assertThisInitialized":"KHALr","@babel/runtime/helpers/esm/inherits":"kirHe","@babel/runtime/helpers/esm/createSuper":"10JMl","@babel/runtime/helpers/esm/defineProperty":"4z9Hv","../Parser.js":"56qie","../utils.js":"78FNA","../../../_lib/startOfUTCISOWeek/index.js":"lnjiQ","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7NzgY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ExtendedYearParser", function() {
    return ExtendedYearParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var ExtendedYearParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(ExtendedYearParser, _Parser);
    var _super = (0, _createSuperDefault.default)(ExtendedYearParser);
    function ExtendedYearParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, ExtendedYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 130);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'G',
            'y',
            'Y',
            'R',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(ExtendedYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === 'u') return (0, _utilsJs.parseNDigitsSigned)(4, dateString);
                return (0, _utilsJs.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ExtendedYearParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"94O91","@babel/runtime/helpers/esm/createClass":"kCxIn","@babel/runtime/helpers/esm/assertThisInitialized":"KHALr","@babel/runtime/helpers/esm/inherits":"kirHe","@babel/runtime/helpers/esm/createSuper":"10JMl","@babel/runtime/helpers/esm/defineProperty":"4z9Hv","../Parser.js":"56qie","../utils.js":"78FNA","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"cXeEn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QuarterParser", function() {
    return QuarterParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var QuarterParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(QuarterParser, _Parser);
    var _super = (0, _createSuperDefault.default)(QuarterParser);
    function QuarterParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, QuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 120);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(QuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case 'Q':
                    case 'QQ':
                        // 01, 02, 03, 04
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case 'Qo':
                        return match.ordinalNumber(dateString, {
                            unit: 'quarter'
                        });
                    // Q1, Q2, Q3, Q4
                    case 'QQQ':
                        return match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case 'QQQQQ':
                        return match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // 1st quarter, 2nd quarter, ...
                    case 'QQQQ':
                    default:
                        return match.quarter(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return QuarterParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"94O91","@babel/runtime/helpers/esm/createClass":"kCxIn","@babel/runtime/helpers/esm/assertThisInitialized":"KHALr","@babel/runtime/helpers/esm/inherits":"kirHe","@babel/runtime/helpers/esm/createSuper":"10JMl","@babel/runtime/helpers/esm/defineProperty":"4z9Hv","../Parser.js":"56qie","../utils.js":"78FNA","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"Q9TJB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StandAloneQuarterParser", function() {
    return StandAloneQuarterParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var StandAloneQuarterParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(StandAloneQuarterParser, _Parser);
    var _super = (0, _createSuperDefault.default)(StandAloneQuarterParser);
    function StandAloneQuarterParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, StandAloneQuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 120);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(StandAloneQuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case 'q':
                    case 'qq':
                        // 01, 02, 03, 04
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case 'qo':
                        return match.ordinalNumber(dateString, {
                            unit: 'quarter'
                        });
                    // Q1, Q2, Q3, Q4
                    case 'qqq':
                        return match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case 'qqqqq':
                        return match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // 1st quarter, 2nd quarter, ...
                    case 'qqqq':
                    default:
                        return match.quarter(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneQuarterParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"94O91","@babel/runtime/helpers/esm/createClass":"kCxIn","@babel/runtime/helpers/esm/assertThisInitialized":"KHALr","@babel/runtime/helpers/esm/inherits":"kirHe","@babel/runtime/helpers/esm/createSuper":"10JMl","@babel/runtime/helpers/esm/defineProperty":"4z9Hv","../Parser.js":"56qie","../utils.js":"78FNA","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"9nMP6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MonthParser", function() {
    return MonthParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _utilsJs = require("../utils.js");
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var MonthParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(MonthParser, _Parser);
    var _super = (0, _createSuperDefault.default)(MonthParser);
    function MonthParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, MonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'L',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 110);
        return _this;
    }
    (0, _createClassDefault.default)(MonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case 'M':
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case 'MM':
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case 'Mo':
                        return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'month'
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case 'MMM':
                        return match.month(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // J, F, ..., D
                    case 'MMMMM':
                        return match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // January, February, ..., December
                    case 'MMMM':
                    default:
                        return match.month(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return MonthParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"94O91","@babel/runtime/helpers/esm/createClass":"kCxIn","@babel/runtime/helpers/esm/assertThisInitialized":"KHALr","@babel/runtime/helpers/esm/inherits":"kirHe","@babel/runtime/helpers/esm/createSuper":"10JMl","@babel/runtime/helpers/esm/defineProperty":"4z9Hv","../utils.js":"78FNA","../Parser.js":"56qie","../constants.js":"gBnXO","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8Xgdi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StandAloneMonthParser", function() {
    return StandAloneMonthParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var StandAloneMonthParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(StandAloneMonthParser, _Parser);
    var _super = (0, _createSuperDefault.default)(StandAloneMonthParser);
    function StandAloneMonthParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, StandAloneMonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 110);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(StandAloneMonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case 'L':
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case 'LL':
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case 'Lo':
                        return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'month'
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case 'LLL':
                        return match.month(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // J, F, ..., D
                    case 'LLLLL':
                        return match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // January, February, ..., December
                    case 'LLLL':
                    default:
                        return match.month(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneMonthParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"94O91","@babel/runtime/helpers/esm/createClass":"kCxIn","@babel/runtime/helpers/esm/assertThisInitialized":"KHALr","@babel/runtime/helpers/esm/inherits":"kirHe","@babel/runtime/helpers/esm/createSuper":"10JMl","@babel/runtime/helpers/esm/defineProperty":"4z9Hv","../Parser.js":"56qie","../constants.js":"gBnXO","../utils.js":"78FNA","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8P1Ck":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LocalWeekParser", function() {
    return LocalWeekParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/setUTCWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/startOfUTCWeek/index.js"); // Local week of year
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var LocalWeekParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(LocalWeekParser, _Parser);
    var _super = (0, _createSuperDefault.default)(LocalWeekParser);
    function LocalWeekParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, LocalWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 100);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(LocalWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'w':
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).week, dateString);
                    case 'wo':
                        return match.ordinalNumber(dateString, {
                            unit: 'week'
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                return (0, _indexJsDefault1.default)((0, _indexJsDefault.default)(date, value, options), options);
            }
        }
    ]);
    return LocalWeekParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"94O91","@babel/runtime/helpers/esm/createClass":"kCxIn","@babel/runtime/helpers/esm/assertThisInitialized":"KHALr","@babel/runtime/helpers/esm/inherits":"kirHe","@babel/runtime/helpers/esm/createSuper":"10JMl","@babel/runtime/helpers/esm/defineProperty":"4z9Hv","../Parser.js":"56qie","../constants.js":"gBnXO","../utils.js":"78FNA","../../../_lib/setUTCWeek/index.js":"lgRX4","../../../_lib/startOfUTCWeek/index.js":"cCeyA","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"lgRX4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return setUTCWeek;
});
var _indexJs = require("../toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../getUTCWeek/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
function setUTCWeek(dirtyDate, dirtyWeek, options) {
    (0, _indexJsDefault3.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var week = (0, _indexJsDefault.default)(dirtyWeek);
    var diff = (0, _indexJsDefault2.default)(date, options) - week;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

},{"../toInteger/index.js":"dkWbJ","../../toDate/index.js":"elr3O","../getUTCWeek/index.js":"47oK6","../requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6quHF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ISOWeekParser", function() {
    return ISOWeekParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/setUTCISOWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/startOfUTCISOWeek/index.js"); // ISO week of year
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var ISOWeekParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(ISOWeekParser, _Parser);
    var _super = (0, _createSuperDefault.default)(ISOWeekParser);
    function ISOWeekParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, ISOWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 100);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(ISOWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'I':
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).week, dateString);
                    case 'Io':
                        return match.ordinalNumber(dateString, {
                            unit: 'week'
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                return (0, _indexJsDefault1.default)((0, _indexJsDefault.default)(date, value));
            }
        }
    ]);
    return ISOWeekParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"94O91","@babel/runtime/helpers/esm/createClass":"kCxIn","@babel/runtime/helpers/esm/assertThisInitialized":"KHALr","@babel/runtime/helpers/esm/inherits":"kirHe","@babel/runtime/helpers/esm/createSuper":"10JMl","@babel/runtime/helpers/esm/defineProperty":"4z9Hv","../Parser.js":"56qie","../constants.js":"gBnXO","../utils.js":"78FNA","../../../_lib/setUTCISOWeek/index.js":"2DY8C","../../../_lib/startOfUTCISOWeek/index.js":"lnjiQ","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2DY8C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return setUTCISOWeek;
});
var _indexJs = require("../toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../getUTCISOWeek/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
    (0, _indexJsDefault3.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var isoWeek = (0, _indexJsDefault.default)(dirtyISOWeek);
    var diff = (0, _indexJsDefault2.default)(date) - isoWeek;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

},{"../toInteger/index.js":"dkWbJ","../../toDate/index.js":"elr3O","../getUTCISOWeek/index.js":"wWrG7","../requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gXdgI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DateParser", function() {
    return DateParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _utilsJs = require("../utils.js");
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var DateParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(DateParser, _Parser);
    var _super = (0, _createSuperDefault.default)(DateParser);
    function DateParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, DateParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 90);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "subPriority", 1);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(DateParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'd':
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).date, dateString);
                    case 'do':
                        return match.ordinalNumber(dateString, {
                            unit: 'date'
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, _utilsJs.isLeapYearIndex)(year);
                var month = date.getUTCMonth();
                if (isLeapYear) return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
                else return value >= 1 && value <= DAYS_IN_MONTH[month];
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCDate(value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DateParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"94O91","@babel/runtime/helpers/esm/createClass":"kCxIn","@babel/runtime/helpers/esm/assertThisInitialized":"KHALr","@babel/runtime/helpers/esm/inherits":"kirHe","@babel/runtime/helpers/esm/createSuper":"10JMl","@babel/runtime/helpers/esm/defineProperty":"4z9Hv","../utils.js":"78FNA","../Parser.js":"56qie","../constants.js":"gBnXO","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"lvq4n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DayOfYearParser", function() {
    return DayOfYearParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var DayOfYearParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(DayOfYearParser, _Parser);
    var _super = (0, _createSuperDefault.default)(DayOfYearParser);
    function DayOfYearParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, DayOfYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 90);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "subpriority", 1);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'E',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(DayOfYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'D':
                    case 'DD':
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).dayOfYear, dateString);
                    case 'Do':
                        return match.ordinalNumber(dateString, {
                            unit: 'date'
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, _utilsJs.isLeapYearIndex)(year);
                if (isLeapYear) return value >= 1 && value <= 366;
                else return value >= 1 && value <= 365;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(0, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayOfYearParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"94O91","@babel/runtime/helpers/esm/createClass":"kCxIn","@babel/runtime/helpers/esm/assertThisInitialized":"KHALr","@babel/runtime/helpers/esm/inherits":"kirHe","@babel/runtime/helpers/esm/createSuper":"10JMl","@babel/runtime/helpers/esm/defineProperty":"4z9Hv","../Parser.js":"56qie","../constants.js":"gBnXO","../utils.js":"78FNA","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"lgWWe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DayParser", function() {
    return DayParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _indexJs = require("../../../_lib/setUTCDay/index.js"); // Day of week
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var DayParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(DayParser, _Parser);
    var _super = (0, _createSuperDefault.default)(DayParser);
    function DayParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, DayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 90);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(DayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // Tue
                    case 'E':
                    case 'EE':
                    case 'EEE':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // T
                    case 'EEEEE':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tu
                    case 'EEEEEE':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tuesday
                    case 'EEEE':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, _indexJsDefault.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"94O91","@babel/runtime/helpers/esm/createClass":"kCxIn","@babel/runtime/helpers/esm/assertThisInitialized":"KHALr","@babel/runtime/helpers/esm/inherits":"kirHe","@babel/runtime/helpers/esm/createSuper":"10JMl","@babel/runtime/helpers/esm/defineProperty":"4z9Hv","../Parser.js":"56qie","../../../_lib/setUTCDay/index.js":"dV5ix","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"dV5ix":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return setUTCDay;
});
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../defaultOptions/index.js");
function setUTCDay(dirtyDate, dirtyDay, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault1.default)(2, arguments);
    var defaultOptions = (0, _indexJs3.getDefaultOptions)();
    var weekStartsOn = (0, _indexJsDefault2.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var day = (0, _indexJsDefault2.default)(dirtyDay);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

},{"../../toDate/index.js":"elr3O","../requiredArgs/index.js":"14prD","../toInteger/index.js":"dkWbJ","../defaultOptions/index.js":"eo7FR","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"43DRU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LocalDayParser", function() {
    return LocalDayParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/setUTCDay/index.js"); // Local day of week
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var LocalDayParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(LocalDayParser, _Parser);
    var _super = (0, _createSuperDefault.default)(LocalDayParser);
    function LocalDayParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, LocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 90);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(LocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case 'e':
                    case 'ee':
                        // 03
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case 'eo':
                        return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'day'
                        }), valueCallback);
                    // Tue
                    case 'eee':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // T
                    case 'eeeee':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tu
                    case 'eeeeee':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tuesday
                    case 'eeee':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, _indexJsDefault.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return LocalDayParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"94O91","@babel/runtime/helpers/esm/createClass":"kCxIn","@babel/runtime/helpers/esm/assertThisInitialized":"KHALr","@babel/runtime/helpers/esm/inherits":"kirHe","@babel/runtime/helpers/esm/createSuper":"10JMl","@babel/runtime/helpers/esm/defineProperty":"4z9Hv","../Parser.js":"56qie","../utils.js":"78FNA","../../../_lib/setUTCDay/index.js":"dV5ix","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1ztSn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StandAloneLocalDayParser", function() {
    return StandAloneLocalDayParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/setUTCDay/index.js"); // Stand-alone local day of week
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var StandAloneLocalDayParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(StandAloneLocalDayParser, _Parser);
    var _super = (0, _createSuperDefault.default)(StandAloneLocalDayParser);
    function StandAloneLocalDayParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, StandAloneLocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 90);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'e',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(StandAloneLocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case 'c':
                    case 'cc':
                        // 03
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case 'co':
                        return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'day'
                        }), valueCallback);
                    // Tue
                    case 'ccc':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // T
                    case 'ccccc':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // Tu
                    case 'cccccc':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // Tuesday
                    case 'cccc':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, _indexJsDefault.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneLocalDayParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"94O91","@babel/runtime/helpers/esm/createClass":"kCxIn","@babel/runtime/helpers/esm/assertThisInitialized":"KHALr","@babel/runtime/helpers/esm/inherits":"kirHe","@babel/runtime/helpers/esm/createSuper":"10JMl","@babel/runtime/helpers/esm/defineProperty":"4z9Hv","../Parser.js":"56qie","../utils.js":"78FNA","../../../_lib/setUTCDay/index.js":"dV5ix","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"d4rRp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ISODayParser", function() {
    return ISODayParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/setUTCISODay/index.js"); // ISO day of week
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var ISODayParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(ISODayParser, _Parser);
    var _super = (0, _createSuperDefault.default)(ISODayParser);
    function ISODayParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, ISODayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 90);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'E',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(ISODayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    if (value === 0) return 7;
                    return value;
                };
                switch(token){
                    // 2
                    case 'i':
                    case 'ii':
                        // 02
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                    // 2nd
                    case 'io':
                        return match.ordinalNumber(dateString, {
                            unit: 'day'
                        });
                    // Tue
                    case 'iii':
                        return (0, _utilsJs.mapValue)(match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // T
                    case 'iiiii':
                        return (0, _utilsJs.mapValue)(match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // Tu
                    case 'iiiiii':
                        return (0, _utilsJs.mapValue)(match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // Tuesday
                    case 'iiii':
                    default:
                        return (0, _utilsJs.mapValue)(match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 7;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date = (0, _indexJsDefault.default)(date, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ISODayParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"94O91","@babel/runtime/helpers/esm/createClass":"kCxIn","@babel/runtime/helpers/esm/assertThisInitialized":"KHALr","@babel/runtime/helpers/esm/inherits":"kirHe","@babel/runtime/helpers/esm/createSuper":"10JMl","@babel/runtime/helpers/esm/defineProperty":"4z9Hv","../Parser.js":"56qie","../utils.js":"78FNA","../../../_lib/setUTCISODay/index.js":"jqLEx","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jqLEx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return setUTCISODay;
});
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function setUTCISODay(dirtyDate, dirtyDay) {
    (0, _indexJsDefault1.default)(2, arguments);
    var day = (0, _indexJsDefault2.default)(dirtyDay);
    if (day % 7 === 0) day = day - 7;
    var weekStartsOn = 1;
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

},{"../../toDate/index.js":"elr3O","../requiredArgs/index.js":"14prD","../toInteger/index.js":"dkWbJ","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"iJ6KT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AMPMParser", function() {
    return AMPMParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var AMPMParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(AMPMParser, _Parser);
    var _super = (0, _createSuperDefault.default)(AMPMParser);
    function AMPMParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, AMPMParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 80);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'b',
            'B',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(AMPMParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'a':
                    case 'aa':
                    case 'aaa':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'aaaaa':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'aaaa':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, _utilsJs.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"94O91","@babel/runtime/helpers/esm/createClass":"kCxIn","@babel/runtime/helpers/esm/assertThisInitialized":"KHALr","@babel/runtime/helpers/esm/inherits":"kirHe","@babel/runtime/helpers/esm/createSuper":"10JMl","@babel/runtime/helpers/esm/defineProperty":"4z9Hv","../Parser.js":"56qie","../utils.js":"78FNA","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"9I52l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AMPMMidnightParser", function() {
    return AMPMMidnightParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var AMPMMidnightParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(AMPMMidnightParser, _Parser);
    var _super = (0, _createSuperDefault.default)(AMPMMidnightParser);
    function AMPMMidnightParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, AMPMMidnightParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 80);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'a',
            'B',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(AMPMMidnightParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'b':
                    case 'bb':
                    case 'bbb':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'bbbbb':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'bbbb':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, _utilsJs.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMMidnightParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"94O91","@babel/runtime/helpers/esm/createClass":"kCxIn","@babel/runtime/helpers/esm/assertThisInitialized":"KHALr","@babel/runtime/helpers/esm/inherits":"kirHe","@babel/runtime/helpers/esm/createSuper":"10JMl","@babel/runtime/helpers/esm/defineProperty":"4z9Hv","../Parser.js":"56qie","../utils.js":"78FNA","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gZvbG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DayPeriodParser", function() {
    return DayPeriodParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js"); // in the morning, in the afternoon, in the evening, at night
var DayPeriodParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(DayPeriodParser, _Parser);
    var _super = (0, _createSuperDefault.default)(DayPeriodParser);
    function DayPeriodParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, DayPeriodParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 80);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(DayPeriodParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'B':
                    case 'BB':
                    case 'BBB':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'BBBBB':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'BBBB':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, _utilsJs.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayPeriodParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"94O91","@babel/runtime/helpers/esm/createClass":"kCxIn","@babel/runtime/helpers/esm/assertThisInitialized":"KHALr","@babel/runtime/helpers/esm/inherits":"kirHe","@babel/runtime/helpers/esm/createSuper":"10JMl","@babel/runtime/helpers/esm/defineProperty":"4z9Hv","../Parser.js":"56qie","../utils.js":"78FNA","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"kFQv3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hour1to12Parser", function() {
    return Hour1to12Parser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var Hour1to12Parser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(Hour1to12Parser, _Parser);
    var _super = (0, _createSuperDefault.default)(Hour1to12Parser);
    function Hour1to12Parser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, Hour1to12Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 70);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'H',
            'K',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(Hour1to12Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'h':
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).hour12h, dateString);
                    case 'ho':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 12;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else if (!isPM && value === 12) date.setUTCHours(0, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1to12Parser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"94O91","@babel/runtime/helpers/esm/createClass":"kCxIn","@babel/runtime/helpers/esm/assertThisInitialized":"KHALr","@babel/runtime/helpers/esm/inherits":"kirHe","@babel/runtime/helpers/esm/createSuper":"10JMl","@babel/runtime/helpers/esm/defineProperty":"4z9Hv","../Parser.js":"56qie","../constants.js":"gBnXO","../utils.js":"78FNA","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"h84n1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hour0to23Parser", function() {
    return Hour0to23Parser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var Hour0to23Parser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(Hour0to23Parser, _Parser);
    var _super = (0, _createSuperDefault.default)(Hour0to23Parser);
    function Hour0to23Parser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, Hour0to23Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 70);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            'h',
            'K',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(Hour0to23Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'H':
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).hour23h, dateString);
                    case 'Ho':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 23;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0to23Parser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"94O91","@babel/runtime/helpers/esm/createClass":"kCxIn","@babel/runtime/helpers/esm/assertThisInitialized":"KHALr","@babel/runtime/helpers/esm/inherits":"kirHe","@babel/runtime/helpers/esm/createSuper":"10JMl","@babel/runtime/helpers/esm/defineProperty":"4z9Hv","../Parser.js":"56qie","../constants.js":"gBnXO","../utils.js":"78FNA","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"77H56":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hour0To11Parser", function() {
    return Hour0To11Parser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var Hour0To11Parser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(Hour0To11Parser, _Parser);
    var _super = (0, _createSuperDefault.default)(Hour0To11Parser);
    function Hour0To11Parser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, Hour0To11Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 70);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'h',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(Hour0To11Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'K':
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).hour11h, dateString);
                    case 'Ko':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0To11Parser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"94O91","@babel/runtime/helpers/esm/createClass":"kCxIn","@babel/runtime/helpers/esm/assertThisInitialized":"KHALr","@babel/runtime/helpers/esm/inherits":"kirHe","@babel/runtime/helpers/esm/createSuper":"10JMl","@babel/runtime/helpers/esm/defineProperty":"4z9Hv","../Parser.js":"56qie","../constants.js":"gBnXO","../utils.js":"78FNA","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"CW7Uj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hour1To24Parser", function() {
    return Hour1To24Parser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var Hour1To24Parser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(Hour1To24Parser, _Parser);
    var _super = (0, _createSuperDefault.default)(Hour1To24Parser);
    function Hour1To24Parser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, Hour1To24Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 70);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            'h',
            'H',
            'K',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(Hour1To24Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'k':
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).hour24h, dateString);
                    case 'ko':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 24;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var hours = value <= 24 ? value % 24 : value;
                date.setUTCHours(hours, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1To24Parser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"94O91","@babel/runtime/helpers/esm/createClass":"kCxIn","@babel/runtime/helpers/esm/assertThisInitialized":"KHALr","@babel/runtime/helpers/esm/inherits":"kirHe","@babel/runtime/helpers/esm/createSuper":"10JMl","@babel/runtime/helpers/esm/defineProperty":"4z9Hv","../Parser.js":"56qie","../constants.js":"gBnXO","../utils.js":"78FNA","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8gCdK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MinuteParser", function() {
    return MinuteParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var MinuteParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(MinuteParser, _Parser);
    var _super = (0, _createSuperDefault.default)(MinuteParser);
    function MinuteParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, MinuteParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 60);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(MinuteParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'm':
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).minute, dateString);
                    case 'mo':
                        return match.ordinalNumber(dateString, {
                            unit: 'minute'
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMinutes(value, 0, 0);
                return date;
            }
        }
    ]);
    return MinuteParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"94O91","@babel/runtime/helpers/esm/createClass":"kCxIn","@babel/runtime/helpers/esm/assertThisInitialized":"KHALr","@babel/runtime/helpers/esm/inherits":"kirHe","@babel/runtime/helpers/esm/createSuper":"10JMl","@babel/runtime/helpers/esm/defineProperty":"4z9Hv","../Parser.js":"56qie","../constants.js":"gBnXO","../utils.js":"78FNA","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1tXC1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SecondParser", function() {
    return SecondParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var SecondParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(SecondParser, _Parser);
    var _super = (0, _createSuperDefault.default)(SecondParser);
    function SecondParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, SecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 50);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(SecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 's':
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).second, dateString);
                    case 'so':
                        return match.ordinalNumber(dateString, {
                            unit: 'second'
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCSeconds(value, 0);
                return date;
            }
        }
    ]);
    return SecondParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"94O91","@babel/runtime/helpers/esm/createClass":"kCxIn","@babel/runtime/helpers/esm/assertThisInitialized":"KHALr","@babel/runtime/helpers/esm/inherits":"kirHe","@babel/runtime/helpers/esm/createSuper":"10JMl","@babel/runtime/helpers/esm/defineProperty":"4z9Hv","../Parser.js":"56qie","../constants.js":"gBnXO","../utils.js":"78FNA","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1tlNu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FractionOfSecondParser", function() {
    return FractionOfSecondParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var FractionOfSecondParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(FractionOfSecondParser, _Parser);
    var _super = (0, _createSuperDefault.default)(FractionOfSecondParser);
    function FractionOfSecondParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, FractionOfSecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 30);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(FractionOfSecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                var valueCallback = function valueCallback(value) {
                    return Math.floor(value * Math.pow(10, -token.length + 3));
                };
                return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(token.length, dateString), valueCallback);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMilliseconds(value);
                return date;
            }
        }
    ]);
    return FractionOfSecondParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"94O91","@babel/runtime/helpers/esm/createClass":"kCxIn","@babel/runtime/helpers/esm/assertThisInitialized":"KHALr","@babel/runtime/helpers/esm/inherits":"kirHe","@babel/runtime/helpers/esm/createSuper":"10JMl","@babel/runtime/helpers/esm/defineProperty":"4z9Hv","../Parser.js":"56qie","../utils.js":"78FNA","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"dmes1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ISOTimezoneWithZParser", function() {
    return ISOTimezoneWithZParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js"); // Timezone (ISO-8601. +00:00 is `'Z'`)
var ISOTimezoneWithZParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(ISOTimezoneWithZParser, _Parser);
    var _super = (0, _createSuperDefault.default)(ISOTimezoneWithZParser);
    function ISOTimezoneWithZParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, ISOTimezoneWithZParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 10);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            't',
            'T',
            'x'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(ISOTimezoneWithZParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case 'X':
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basicOptionalMinutes, dateString);
                    case 'XX':
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basic, dateString);
                    case 'XXXX':
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basicOptionalSeconds, dateString);
                    case 'XXXXX':
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).extendedOptionalSeconds, dateString);
                    case 'XXX':
                    default:
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneWithZParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"94O91","@babel/runtime/helpers/esm/createClass":"kCxIn","@babel/runtime/helpers/esm/assertThisInitialized":"KHALr","@babel/runtime/helpers/esm/inherits":"kirHe","@babel/runtime/helpers/esm/createSuper":"10JMl","@babel/runtime/helpers/esm/defineProperty":"4z9Hv","../Parser.js":"56qie","../constants.js":"gBnXO","../utils.js":"78FNA","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"hKpmZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ISOTimezoneParser", function() {
    return ISOTimezoneParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js"); // Timezone (ISO-8601)
var ISOTimezoneParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(ISOTimezoneParser, _Parser);
    var _super = (0, _createSuperDefault.default)(ISOTimezoneParser);
    function ISOTimezoneParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, ISOTimezoneParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 10);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            't',
            'T',
            'X'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(ISOTimezoneParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case 'x':
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basicOptionalMinutes, dateString);
                    case 'xx':
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basic, dateString);
                    case 'xxxx':
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basicOptionalSeconds, dateString);
                    case 'xxxxx':
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).extendedOptionalSeconds, dateString);
                    case 'xxx':
                    default:
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"94O91","@babel/runtime/helpers/esm/createClass":"kCxIn","@babel/runtime/helpers/esm/assertThisInitialized":"KHALr","@babel/runtime/helpers/esm/inherits":"kirHe","@babel/runtime/helpers/esm/createSuper":"10JMl","@babel/runtime/helpers/esm/defineProperty":"4z9Hv","../Parser.js":"56qie","../constants.js":"gBnXO","../utils.js":"78FNA","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"ceB0w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimestampSecondsParser", function() {
    return TimestampSecondsParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var TimestampSecondsParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(TimestampSecondsParser, _Parser);
    var _super = (0, _createSuperDefault.default)(TimestampSecondsParser);
    function TimestampSecondsParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, TimestampSecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 40);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", '*');
        return _this;
    }
    (0, _createClassDefault.default)(TimestampSecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, _utilsJs.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value * 1000),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampSecondsParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"94O91","@babel/runtime/helpers/esm/createClass":"kCxIn","@babel/runtime/helpers/esm/assertThisInitialized":"KHALr","@babel/runtime/helpers/esm/inherits":"kirHe","@babel/runtime/helpers/esm/createSuper":"10JMl","@babel/runtime/helpers/esm/defineProperty":"4z9Hv","../Parser.js":"56qie","../utils.js":"78FNA","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"lcmEb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimestampMillisecondsParser", function() {
    return TimestampMillisecondsParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var TimestampMillisecondsParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(TimestampMillisecondsParser, _Parser);
    var _super = (0, _createSuperDefault.default)(TimestampMillisecondsParser);
    function TimestampMillisecondsParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, TimestampMillisecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 20);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", '*');
        return _this;
    }
    (0, _createClassDefault.default)(TimestampMillisecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, _utilsJs.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampMillisecondsParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"94O91","@babel/runtime/helpers/esm/createClass":"kCxIn","@babel/runtime/helpers/esm/assertThisInitialized":"KHALr","@babel/runtime/helpers/esm/inherits":"kirHe","@babel/runtime/helpers/esm/createSuper":"10JMl","@babel/runtime/helpers/esm/defineProperty":"4z9Hv","../Parser.js":"56qie","../utils.js":"78FNA","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3gapU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isMonday;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isMonday(date) {
    (0, _indexJsDefault1.default)(1, arguments);
    return (0, _indexJsDefault.default)(date).getDay() === 1;
}

},{"../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4O947":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isPast;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isPast(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    return (0, _indexJsDefault.default)(dirtyDate).getTime() < Date.now();
}

},{"../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"sDgcB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isSameHour;
});
var _indexJs = require("../startOfHour/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isSameHour(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateLeftStartOfHour = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRightStartOfHour = (0, _indexJsDefault.default)(dirtyDateRight);
    return dateLeftStartOfHour.getTime() === dateRightStartOfHour.getTime();
}

},{"../startOfHour/index.js":"anlJQ","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"anlJQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return startOfHour;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function startOfHour(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    date.setMinutes(0, 0, 0);
    return date;
}

},{"../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"hIfKA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isSameISOWeek;
});
var _indexJs = require("../isSameWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isSameISOWeek(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault1.default)(2, arguments);
    return (0, _indexJsDefault.default)(dirtyDateLeft, dirtyDateRight, {
        weekStartsOn: 1
    });
}

},{"../isSameWeek/index.js":"g3b0I","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"g3b0I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isSameWeek;
});
var _indexJs = require("../startOfWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isSameWeek(dirtyDateLeft, dirtyDateRight, options) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateLeftStartOfWeek = (0, _indexJsDefault.default)(dirtyDateLeft, options);
    var dateRightStartOfWeek = (0, _indexJsDefault.default)(dirtyDateRight, options);
    return dateLeftStartOfWeek.getTime() === dateRightStartOfWeek.getTime();
}

},{"../startOfWeek/index.js":"em4Ab","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2JKTL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isSameISOWeekYear;
});
var _indexJs = require("../startOfISOWeekYear/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isSameISOWeekYear(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateLeftStartOfYear = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRightStartOfYear = (0, _indexJsDefault.default)(dirtyDateRight);
    return dateLeftStartOfYear.getTime() === dateRightStartOfYear.getTime();
}

},{"../startOfISOWeekYear/index.js":"7AEM8","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6dy0a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isSameMinute;
});
var _indexJs = require("../startOfMinute/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isSameMinute(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateLeftStartOfMinute = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRightStartOfMinute = (0, _indexJsDefault.default)(dirtyDateRight);
    return dateLeftStartOfMinute.getTime() === dateRightStartOfMinute.getTime();
}

},{"../startOfMinute/index.js":"ioXMa","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8yEUT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isSameMonth;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isSameMonth(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateLeft = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRight = (0, _indexJsDefault.default)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}

},{"../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"fopzD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isSameQuarter;
});
var _indexJs = require("../startOfQuarter/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isSameQuarter(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateLeftStartOfQuarter = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRightStartOfQuarter = (0, _indexJsDefault.default)(dirtyDateRight);
    return dateLeftStartOfQuarter.getTime() === dateRightStartOfQuarter.getTime();
}

},{"../startOfQuarter/index.js":"k4fkG","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"hM0KL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isSameSecond;
});
var _indexJs = require("../startOfSecond/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isSameSecond(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateLeftStartOfSecond = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRightStartOfSecond = (0, _indexJsDefault.default)(dirtyDateRight);
    return dateLeftStartOfSecond.getTime() === dateRightStartOfSecond.getTime();
}

},{"../startOfSecond/index.js":"f18kx","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"f18kx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return startOfSecond;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function startOfSecond(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    date.setMilliseconds(0);
    return date;
}

},{"../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"kX8qq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isSameYear;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isSameYear(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateLeft = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRight = (0, _indexJsDefault.default)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear();
}

},{"../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"12weA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isThisHour;
});
var _indexJs = require("../isSameHour/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isThisHour(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    return (0, _indexJsDefault.default)(Date.now(), dirtyDate);
}

},{"../isSameHour/index.js":"sDgcB","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"bUbRF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isThisISOWeek;
});
var _indexJs = require("../isSameISOWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isThisISOWeek(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    return (0, _indexJsDefault.default)(dirtyDate, Date.now());
}

},{"../isSameISOWeek/index.js":"hIfKA","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2MtAx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isThisMinute;
});
var _indexJs = require("../isSameMinute/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isThisMinute(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    return (0, _indexJsDefault.default)(Date.now(), dirtyDate);
}

},{"../isSameMinute/index.js":"6dy0a","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1LQgZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isThisMonth;
});
var _indexJs = require("../isSameMonth/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isThisMonth(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    return (0, _indexJsDefault.default)(Date.now(), dirtyDate);
}

},{"../isSameMonth/index.js":"8yEUT","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2IBI1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isThisQuarter;
});
var _indexJs = require("../isSameQuarter/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isThisQuarter(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    return (0, _indexJsDefault.default)(Date.now(), dirtyDate);
}

},{"../isSameQuarter/index.js":"fopzD","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1oae1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isThisSecond;
});
var _indexJs = require("../isSameSecond/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isThisSecond(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    return (0, _indexJsDefault.default)(Date.now(), dirtyDate);
}

},{"../isSameSecond/index.js":"hM0KL","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jF4bV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isThisWeek;
});
var _indexJs = require("../isSameWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isThisWeek(dirtyDate, options) {
    (0, _indexJsDefault1.default)(1, arguments);
    return (0, _indexJsDefault.default)(dirtyDate, Date.now(), options);
}

},{"../isSameWeek/index.js":"g3b0I","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3OrWT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isThisYear;
});
var _indexJs = require("../isSameYear/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isThisYear(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    return (0, _indexJsDefault.default)(dirtyDate, Date.now());
}

},{"../isSameYear/index.js":"kX8qq","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5fEDA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isThursday;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isThursday(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    return (0, _indexJsDefault.default)(dirtyDate).getDay() === 4;
}

},{"../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"dtqLQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isToday;
});
var _indexJs = require("../isSameDay/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isToday(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    return (0, _indexJsDefault.default)(dirtyDate, Date.now());
}

},{"../isSameDay/index.js":"8u23d","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"9ruSU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isTomorrow;
});
var _indexJs = require("../addDays/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../isSameDay/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function isTomorrow(dirtyDate) {
    (0, _indexJsDefault2.default)(1, arguments);
    return (0, _indexJsDefault1.default)(dirtyDate, (0, _indexJsDefault.default)(Date.now(), 1));
}

},{"../addDays/index.js":"3C7cL","../isSameDay/index.js":"8u23d","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"fttSw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isTuesday;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isTuesday(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    return (0, _indexJsDefault.default)(dirtyDate).getDay() === 2;
}

},{"../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3HtEA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isWednesday;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isWednesday(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    return (0, _indexJsDefault.default)(dirtyDate).getDay() === 3;
}

},{"../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"byUym":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isWithinInterval;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isWithinInterval(dirtyDate, interval) {
    (0, _indexJsDefault1.default)(2, arguments);
    var time = (0, _indexJsDefault.default)(dirtyDate).getTime();
    var startTime = (0, _indexJsDefault.default)(interval.start).getTime();
    var endTime = (0, _indexJsDefault.default)(interval.end).getTime();
    // Throw an exception if start date is after end date or if any date is `Invalid Date`
    if (!(startTime <= endTime)) throw new RangeError('Invalid interval');
    return time >= startTime && time <= endTime;
}

},{"../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gIC53":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isYesterday;
});
var _indexJs = require("../isSameDay/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../subDays/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function isYesterday(dirtyDate) {
    (0, _indexJsDefault2.default)(1, arguments);
    return (0, _indexJsDefault.default)(dirtyDate, (0, _indexJsDefault1.default)(Date.now(), 1));
}

},{"../isSameDay/index.js":"8u23d","../subDays/index.js":"goTWu","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"goTWu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return subDays;
});
var _indexJs = require("../addDays/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function subDays(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault1.default)(2, arguments);
    var amount = (0, _indexJsDefault2.default)(dirtyAmount);
    return (0, _indexJsDefault.default)(dirtyDate, -amount);
}

},{"../addDays/index.js":"3C7cL","../_lib/requiredArgs/index.js":"14prD","../_lib/toInteger/index.js":"dkWbJ","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8DeuD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return lastDayOfDecade;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function lastDayOfDecade(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var year = date.getFullYear();
    var decade = 9 + Math.floor(year / 10) * 10;
    date.setFullYear(decade + 1, 0, 0);
    date.setHours(0, 0, 0, 0);
    return date;
}

},{"../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2XvFr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return lastDayOfISOWeek;
});
var _indexJs = require("../lastDayOfWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function lastDayOfISOWeek(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    return (0, _indexJsDefault.default)(dirtyDate, {
        weekStartsOn: 1
    });
}

},{"../lastDayOfWeek/index.js":"bevXZ","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"bevXZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return lastDayOfWeek;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/toInteger/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/defaultOptions/index.js");
function lastDayOfWeek(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault2.default)(1, arguments);
    var defaultOptions = (0, _indexJs3.getDefaultOptions)();
    var weekStartsOn = (0, _indexJsDefault1.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6');
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    date.setHours(0, 0, 0, 0);
    date.setDate(date.getDate() + diff);
    return date;
}

},{"../toDate/index.js":"elr3O","../_lib/toInteger/index.js":"dkWbJ","../_lib/requiredArgs/index.js":"14prD","../_lib/defaultOptions/index.js":"eo7FR","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"ckpg3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return lastDayOfISOWeekYear;
});
var _indexJs = require("../getISOWeekYear/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfISOWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function lastDayOfISOWeekYear(dirtyDate) {
    (0, _indexJsDefault2.default)(1, arguments);
    var year = (0, _indexJsDefault.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setFullYear(year + 1, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    var date = (0, _indexJsDefault1.default)(fourthOfJanuary);
    date.setDate(date.getDate() - 1);
    return date;
}

},{"../getISOWeekYear/index.js":"5i5mG","../startOfISOWeek/index.js":"iB7YK","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"eETX3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return lastDayOfQuarter;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function lastDayOfQuarter(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var currentMonth = date.getMonth();
    var month = currentMonth - currentMonth % 3 + 3;
    date.setMonth(month, 0);
    date.setHours(0, 0, 0, 0);
    return date;
}

},{"../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5o12E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return lastDayOfYear;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function lastDayOfYear(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var year = date.getFullYear();
    date.setFullYear(year + 1, 0, 0);
    date.setHours(0, 0, 0, 0);
    return date;
}

},{"../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"fzS5t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return lightFormat;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/format/lightFormatters/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/getTimezoneOffsetInMilliseconds/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../isValid/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../subMilliseconds/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
var _indexJs5 = require("../_lib/requiredArgs/index.js"); // This RegExp consists of three parts separated by `|`:
var _indexJsDefault5 = parcelHelpers.interopDefault(_indexJs5);
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /(\w)\1*|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function lightFormat(dirtyDate, formatStr) {
    (0, _indexJsDefault5.default)(2, arguments);
    var originalDate = (0, _indexJsDefault.default)(dirtyDate);
    if (!(0, _indexJsDefault3.default)(originalDate)) throw new RangeError('Invalid time value');
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, _indexJsDefault2.default)(originalDate);
    var utcDate = (0, _indexJsDefault4.default)(originalDate, timezoneOffset);
    var tokens = formatStr.match(formattingTokensRegExp);
    // The only case when formattingTokensRegExp doesn't match the string is when it's empty
    if (!tokens) return '';
    var result = tokens.map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return cleanEscapedString(substring);
        var formatter = (0, _indexJsDefault1.default)[firstCharacter];
        if (formatter) return formatter(utcDate, substring);
        if (firstCharacter.match(unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        return substring;
    }).join('');
    return result;
}
function cleanEscapedString(input) {
    var matches = input.match(escapedStringRegExp);
    if (!matches) return input;
    return matches[1].replace(doubleQuoteRegExp, "'");
}

},{"../toDate/index.js":"elr3O","../_lib/format/lightFormatters/index.js":"kcHj5","../_lib/getTimezoneOffsetInMilliseconds/index.js":"3kvOg","../isValid/index.js":"fScb4","../subMilliseconds/index.js":"1aYLs","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6KTIG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return milliseconds;
});
var _indexJs = require("../_lib/requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
// Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
// 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
var daysInYear = 365.2425;
function milliseconds(_ref) {
    var years = _ref.years, months = _ref.months, weeks = _ref.weeks, days = _ref.days, hours = _ref.hours, minutes = _ref.minutes, seconds = _ref.seconds;
    (0, _indexJsDefault.default)(1, arguments);
    var totalDays = 0;
    if (years) totalDays += years * daysInYear;
    if (months) totalDays += months * (daysInYear / 12);
    if (weeks) totalDays += weeks * 7;
    if (days) totalDays += days;
    var totalSeconds = totalDays * 86400;
    if (hours) totalSeconds += hours * 3600;
    if (minutes) totalSeconds += minutes * 60;
    if (seconds) totalSeconds += seconds;
    return Math.round(totalSeconds * 1000);
}

},{"../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5mrCB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return millisecondsToHours;
});
var _indexJs = require("../_lib/requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../constants/index.js");
function millisecondsToHours(milliseconds) {
    (0, _indexJsDefault.default)(1, arguments);
    var hours = milliseconds / (0, _indexJs1.millisecondsInHour);
    return Math.floor(hours);
}

},{"../_lib/requiredArgs/index.js":"14prD","../constants/index.js":"k64Zq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"almzE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return millisecondsToMinutes;
});
var _indexJs = require("../_lib/requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../constants/index.js");
function millisecondsToMinutes(milliseconds) {
    (0, _indexJsDefault.default)(1, arguments);
    var minutes = milliseconds / (0, _indexJs1.millisecondsInMinute);
    return Math.floor(minutes);
}

},{"../_lib/requiredArgs/index.js":"14prD","../constants/index.js":"k64Zq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5HdxH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return millisecondsToSeconds;
});
var _indexJs = require("../_lib/requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../constants/index.js");
function millisecondsToSeconds(milliseconds) {
    (0, _indexJsDefault.default)(1, arguments);
    var seconds = milliseconds / (0, _indexJs1.millisecondsInSecond);
    return Math.floor(seconds);
}

},{"../_lib/requiredArgs/index.js":"14prD","../constants/index.js":"k64Zq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"91Cwb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return minutesToHours;
});
var _indexJs = require("../_lib/requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../constants/index.js");
function minutesToHours(minutes) {
    (0, _indexJsDefault.default)(1, arguments);
    var hours = minutes / (0, _indexJs1.minutesInHour);
    return Math.floor(hours);
}

},{"../_lib/requiredArgs/index.js":"14prD","../constants/index.js":"k64Zq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2UB7Y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return minutesToMilliseconds;
});
var _indexJs = require("../_lib/requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../constants/index.js");
function minutesToMilliseconds(minutes) {
    (0, _indexJsDefault.default)(1, arguments);
    return Math.floor(minutes * (0, _indexJs1.millisecondsInMinute));
}

},{"../_lib/requiredArgs/index.js":"14prD","../constants/index.js":"k64Zq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"hiifw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return minutesToSeconds;
});
var _indexJs = require("../_lib/requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../constants/index.js");
function minutesToSeconds(minutes) {
    (0, _indexJsDefault.default)(1, arguments);
    return Math.floor(minutes * (0, _indexJs1.secondsInMinute));
}

},{"../_lib/requiredArgs/index.js":"14prD","../constants/index.js":"k64Zq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7YXp6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return monthsToQuarters;
});
var _indexJs = require("../_lib/requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../constants/index.js");
function monthsToQuarters(months) {
    (0, _indexJsDefault.default)(1, arguments);
    var quarters = months / (0, _indexJs1.monthsInQuarter);
    return Math.floor(quarters);
}

},{"../_lib/requiredArgs/index.js":"14prD","../constants/index.js":"k64Zq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1CRgz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return monthsToYears;
});
var _indexJs = require("../_lib/requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../constants/index.js");
function monthsToYears(months) {
    (0, _indexJsDefault.default)(1, arguments);
    var years = months / (0, _indexJs1.monthsInYear);
    return Math.floor(years);
}

},{"../_lib/requiredArgs/index.js":"14prD","../constants/index.js":"k64Zq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7Bmyo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return nextDay;
});
var _indexJs = require("../addDays/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../getDay/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function nextDay(date, day) {
    (0, _indexJsDefault2.default)(2, arguments);
    var delta = day - (0, _indexJsDefault1.default)(date);
    if (delta <= 0) delta += 7;
    return (0, _indexJsDefault.default)(date, delta);
}

},{"../addDays/index.js":"3C7cL","../getDay/index.js":"5wMzR","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6RsRC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return nextFriday;
});
var _indexJs = require("../nextDay/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function nextFriday(date) {
    (0, _indexJsDefault1.default)(1, arguments);
    return (0, _indexJsDefault.default)(date, 5);
}

},{"../nextDay/index.js":"7Bmyo","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jyqbO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return nextMonday;
});
var _indexJs = require("../nextDay/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function nextMonday(date) {
    (0, _indexJsDefault1.default)(1, arguments);
    return (0, _indexJsDefault.default)(date, 1);
}

},{"../nextDay/index.js":"7Bmyo","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4xCmy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return nextSaturday;
});
var _indexJs = require("../nextDay/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function nextSaturday(date) {
    (0, _indexJsDefault1.default)(1, arguments);
    return (0, _indexJsDefault.default)(date, 6);
}

},{"../nextDay/index.js":"7Bmyo","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8LcbP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return nextSunday;
});
var _indexJs = require("../nextDay/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function nextSunday(date) {
    (0, _indexJsDefault1.default)(1, arguments);
    return (0, _indexJsDefault.default)(date, 0);
}

},{"../nextDay/index.js":"7Bmyo","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"eJEdM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return nextThursday;
});
var _indexJs = require("../nextDay/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function nextThursday(date) {
    (0, _indexJsDefault1.default)(1, arguments);
    return (0, _indexJsDefault.default)(date, 4);
}

},{"../nextDay/index.js":"7Bmyo","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"68dtI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return nextTuesday;
});
var _indexJs = require("../nextDay/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function nextTuesday(date) {
    (0, _indexJsDefault1.default)(1, arguments);
    return (0, _indexJsDefault.default)(date, 2);
}

},{"../nextDay/index.js":"7Bmyo","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"eDTo1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return nextWednesday;
});
var _indexJs = require("../nextDay/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function nextWednesday(date) {
    (0, _indexJsDefault1.default)(1, arguments);
    return (0, _indexJsDefault.default)(date, 3);
}

},{"../nextDay/index.js":"7Bmyo","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"dMHtk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return parseISO;
});
var _indexJs = require("../constants/index.js");
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/toInteger/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs2);
function parseISO(argument, options) {
    var _options$additionalDi;
    (0, _indexJsDefault.default)(1, arguments);
    var additionalDigits = (0, _indexJsDefault1.default)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = parseYear(dateStrings.date, additionalDigits);
        date = parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time);
        // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split(patterns.dateTimeDelimiter);
    var timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function parseYear(dateString, additionalDigits) {
    var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
    var captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ''
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match(dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = parseDateUnit(captures[1]);
    var month = parseDateUnit(captures[2]) - 1;
    var day = parseDateUnit(captures[3]);
    var week = parseDateUnit(captures[4]);
    var dayOfWeek = parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function parseTime(timeString) {
    var captures = timeString.match(timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = parseTimeUnit(captures[1]);
    var minutes = parseTimeUnit(captures[2]);
    var seconds = parseTimeUnit(captures[3]);
    if (!validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, _indexJs.millisecondsInHour) + minutes * (0, _indexJs.millisecondsInMinute) + seconds * 1000;
}
function parseTimeUnit(value) {
    return value && parseFloat(value.replace(',', '.')) || 0;
}
function parseTimezone(timezoneString) {
    if (timezoneString === 'Z') return 0;
    var captures = timezoneString.match(timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === '+' ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, _indexJs.millisecondsInHour) + minutes * (0, _indexJs.millisecondsInMinute));
}
function dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
var daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
}
function validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
}
function validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}

},{"../constants/index.js":"k64Zq","../_lib/requiredArgs/index.js":"14prD","../_lib/toInteger/index.js":"dkWbJ","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3oZ8i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return parseJSON;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function parseJSON(argument) {
    (0, _indexJsDefault1.default)(1, arguments);
    if (typeof argument === 'string') {
        var parts = argument.match(/(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(?:\.(\d{0,7}))?(?:Z|(.)(\d{2}):?(\d{2})?)?/);
        if (parts) // Group 8 matches the sign
        return new Date(Date.UTC(+parts[1], +parts[2] - 1, +parts[3], +parts[4] - (+parts[9] || 0) * (parts[8] == '-' ? -1 : 1), +parts[5] - (+parts[10] || 0) * (parts[8] == '-' ? -1 : 1), +parts[6], +((parts[7] || '0') + '00').substring(0, 3)));
        return new Date(NaN);
    }
    return (0, _indexJsDefault.default)(argument);
}

},{"../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"h2rcf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return previousDay;
});
var _indexJs = require("../_lib/requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../getDay/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../subDays/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function previousDay(date, day) {
    (0, _indexJsDefault.default)(2, arguments);
    var delta = (0, _indexJsDefault1.default)(date) - day;
    if (delta <= 0) delta += 7;
    return (0, _indexJsDefault2.default)(date, delta);
}

},{"../_lib/requiredArgs/index.js":"14prD","../getDay/index.js":"5wMzR","../subDays/index.js":"goTWu","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"braSV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return previousFriday;
});
var _indexJs = require("../_lib/requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../previousDay/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function previousFriday(date) {
    (0, _indexJsDefault.default)(1, arguments);
    return (0, _indexJsDefault1.default)(date, 5);
}

},{"../_lib/requiredArgs/index.js":"14prD","../previousDay/index.js":"h2rcf","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"b9PA5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return previousMonday;
});
var _indexJs = require("../_lib/requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../previousDay/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function previousMonday(date) {
    (0, _indexJsDefault.default)(1, arguments);
    return (0, _indexJsDefault1.default)(date, 1);
}

},{"../_lib/requiredArgs/index.js":"14prD","../previousDay/index.js":"h2rcf","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"i0RcM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return previousSaturday;
});
var _indexJs = require("../_lib/requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../previousDay/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function previousSaturday(date) {
    (0, _indexJsDefault.default)(1, arguments);
    return (0, _indexJsDefault1.default)(date, 6);
}

},{"../_lib/requiredArgs/index.js":"14prD","../previousDay/index.js":"h2rcf","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2kBHa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return previousSunday;
});
var _indexJs = require("../_lib/requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../previousDay/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function previousSunday(date) {
    (0, _indexJsDefault.default)(1, arguments);
    return (0, _indexJsDefault1.default)(date, 0);
}

},{"../_lib/requiredArgs/index.js":"14prD","../previousDay/index.js":"h2rcf","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8fBuK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return previousThursday;
});
var _indexJs = require("../_lib/requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../previousDay/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function previousThursday(date) {
    (0, _indexJsDefault.default)(1, arguments);
    return (0, _indexJsDefault1.default)(date, 4);
}

},{"../_lib/requiredArgs/index.js":"14prD","../previousDay/index.js":"h2rcf","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jCUbL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return previousTuesday;
});
var _indexJs = require("../_lib/requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../previousDay/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function previousTuesday(date) {
    (0, _indexJsDefault.default)(1, arguments);
    return (0, _indexJsDefault1.default)(date, 2);
}

},{"../_lib/requiredArgs/index.js":"14prD","../previousDay/index.js":"h2rcf","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3QFsL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return previousWednesday;
});
var _indexJs = require("../_lib/requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../previousDay/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function previousWednesday(date) {
    (0, _indexJsDefault.default)(1, arguments);
    return (0, _indexJsDefault1.default)(date, 3);
}

},{"../_lib/requiredArgs/index.js":"14prD","../previousDay/index.js":"h2rcf","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"i3Toh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return quartersToMonths;
});
var _indexJs = require("../_lib/requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../constants/index.js");
function quartersToMonths(quarters) {
    (0, _indexJsDefault.default)(1, arguments);
    return Math.floor(quarters * (0, _indexJs1.monthsInQuarter));
}

},{"../_lib/requiredArgs/index.js":"14prD","../constants/index.js":"k64Zq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"bgNhE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return quartersToYears;
});
var _indexJs = require("../_lib/requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../constants/index.js");
function quartersToYears(quarters) {
    (0, _indexJsDefault.default)(1, arguments);
    var years = quarters / (0, _indexJs1.quartersInYear);
    return Math.floor(years);
}

},{"../_lib/requiredArgs/index.js":"14prD","../constants/index.js":"k64Zq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"ghQL0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return roundToNearestMinutes;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/roundingMethods/index.js");
var _indexJs2 = require("../_lib/toInteger/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs2);
function roundToNearestMinutes(dirtyDate, options) {
    var _options$nearestTo;
    if (arguments.length < 1) throw new TypeError('1 argument required, but only none provided present');
    var nearestTo = (0, _indexJsDefault1.default)((_options$nearestTo = options === null || options === void 0 ? void 0 : options.nearestTo) !== null && _options$nearestTo !== void 0 ? _options$nearestTo : 1);
    if (nearestTo < 1 || nearestTo > 30) throw new RangeError('`options.nearestTo` must be between 1 and 30');
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var seconds = date.getSeconds(); // relevant if nearestTo is 1, which is the default case
    var minutes = date.getMinutes() + seconds / 60;
    var roundingMethod = (0, _indexJs1.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod);
    var roundedMinutes = roundingMethod(minutes / nearestTo) * nearestTo;
    var remainderMinutes = minutes % nearestTo;
    var addedMinutes = Math.round(remainderMinutes / nearestTo) * nearestTo;
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), roundedMinutes + addedMinutes);
}

},{"../toDate/index.js":"elr3O","../_lib/roundingMethods/index.js":"fJBC4","../_lib/toInteger/index.js":"dkWbJ","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4PRCz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return secondsToHours;
});
var _indexJs = require("../_lib/requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../constants/index.js");
function secondsToHours(seconds) {
    (0, _indexJsDefault.default)(1, arguments);
    var hours = seconds / (0, _indexJs1.secondsInHour);
    return Math.floor(hours);
}

},{"../_lib/requiredArgs/index.js":"14prD","../constants/index.js":"k64Zq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"d0F6C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return secondsToMilliseconds;
});
var _indexJs = require("../_lib/requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../constants/index.js");
function secondsToMilliseconds(seconds) {
    (0, _indexJsDefault.default)(1, arguments);
    return seconds * (0, _indexJs1.millisecondsInSecond);
}

},{"../_lib/requiredArgs/index.js":"14prD","../constants/index.js":"k64Zq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6Z2NQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return secondsToMinutes;
});
var _indexJs = require("../_lib/requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../constants/index.js");
function secondsToMinutes(seconds) {
    (0, _indexJsDefault.default)(1, arguments);
    var minutes = seconds / (0, _indexJs1.secondsInMinute);
    return Math.floor(minutes);
}

},{"../_lib/requiredArgs/index.js":"14prD","../constants/index.js":"k64Zq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"kDXSB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return set;
});
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../setMonth/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
function set(dirtyDate, values) {
    (0, _indexJsDefault3.default)(2, arguments);
    if ((0, _typeofDefault.default)(values) !== 'object' || values === null) throw new RangeError('values parameter must be an object');
    var date = (0, _indexJsDefault.default)(dirtyDate);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(date.getTime())) return new Date(NaN);
    if (values.year != null) date.setFullYear(values.year);
    if (values.month != null) date = (0, _indexJsDefault1.default)(date, values.month);
    if (values.date != null) date.setDate((0, _indexJsDefault2.default)(values.date));
    if (values.hours != null) date.setHours((0, _indexJsDefault2.default)(values.hours));
    if (values.minutes != null) date.setMinutes((0, _indexJsDefault2.default)(values.minutes));
    if (values.seconds != null) date.setSeconds((0, _indexJsDefault2.default)(values.seconds));
    if (values.milliseconds != null) date.setMilliseconds((0, _indexJsDefault2.default)(values.milliseconds));
    return date;
}

},{"@babel/runtime/helpers/esm/typeof":"8bpl6","../toDate/index.js":"elr3O","../setMonth/index.js":"17tWf","../_lib/toInteger/index.js":"dkWbJ","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"17tWf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return setMonth;
});
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../getDaysInMonth/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
function setMonth(dirtyDate, dirtyMonth) {
    (0, _indexJsDefault3.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var month = (0, _indexJsDefault.default)(dirtyMonth);
    var year = date.getFullYear();
    var day = date.getDate();
    var dateWithDesiredMonth = new Date(0);
    dateWithDesiredMonth.setFullYear(year, month, 15);
    dateWithDesiredMonth.setHours(0, 0, 0, 0);
    var daysInMonth = (0, _indexJsDefault2.default)(dateWithDesiredMonth);
    // Set the last day of the new month
    // if the original date was the last day of the longer month
    date.setMonth(month, Math.min(day, daysInMonth));
    return date;
}

},{"../_lib/toInteger/index.js":"dkWbJ","../toDate/index.js":"elr3O","../getDaysInMonth/index.js":"6Eo8o","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5Taqz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return setDate;
});
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function setDate(dirtyDate, dirtyDayOfMonth) {
    (0, _indexJsDefault2.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var dayOfMonth = (0, _indexJsDefault.default)(dirtyDayOfMonth);
    date.setDate(dayOfMonth);
    return date;
}

},{"../_lib/toInteger/index.js":"dkWbJ","../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8b2jv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return setDay;
});
var _indexJs = require("../addDays/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../_lib/defaultOptions/index.js");
function setDay(dirtyDate, dirtyDay, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault3.default)(2, arguments);
    var defaultOptions = (0, _indexJs4.getDefaultOptions)();
    var weekStartsOn = (0, _indexJsDefault2.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var day = (0, _indexJsDefault2.default)(dirtyDay);
    var currentDay = date.getDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var delta = 7 - weekStartsOn;
    var diff = day < 0 || day > 6 ? day - (currentDay + delta) % 7 : (dayIndex + delta) % 7 - (currentDay + delta) % 7;
    return (0, _indexJsDefault.default)(date, diff);
}

},{"../addDays/index.js":"3C7cL","../toDate/index.js":"elr3O","../_lib/toInteger/index.js":"dkWbJ","../_lib/requiredArgs/index.js":"14prD","../_lib/defaultOptions/index.js":"eo7FR","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4ZrgY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return setDayOfYear;
});
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function setDayOfYear(dirtyDate, dirtyDayOfYear) {
    (0, _indexJsDefault2.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var dayOfYear = (0, _indexJsDefault.default)(dirtyDayOfYear);
    date.setMonth(0);
    date.setDate(dayOfYear);
    return date;
}

},{"../_lib/toInteger/index.js":"dkWbJ","../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4pQYw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return setDefaultOptions;
});
var _indexJs = require("../_lib/defaultOptions/index.js");
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs1);
function setDefaultOptions(newOptions) {
    (0, _indexJsDefault.default)(1, arguments);
    var result = {};
    var defaultOptions = (0, _indexJs.getDefaultOptions)();
    for(var property in defaultOptions)if (Object.prototype.hasOwnProperty.call(defaultOptions, property)) result[property] = defaultOptions[property];
    for(var _property in newOptions)if (Object.prototype.hasOwnProperty.call(newOptions, _property)) {
        if (newOptions[_property] === undefined) delete result[_property];
        else result[_property] = newOptions[_property];
    }
    (0, _indexJs.setDefaultOptions)(result);
}

},{"../_lib/defaultOptions/index.js":"eo7FR","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gtryo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return setHours;
});
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function setHours(dirtyDate, dirtyHours) {
    (0, _indexJsDefault2.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var hours = (0, _indexJsDefault.default)(dirtyHours);
    date.setHours(hours);
    return date;
}

},{"../_lib/toInteger/index.js":"dkWbJ","../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3zAq8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return setISODay;
});
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../addDays/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../getISODay/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
function setISODay(dirtyDate, dirtyDay) {
    (0, _indexJsDefault4.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var day = (0, _indexJsDefault.default)(dirtyDay);
    var currentDay = (0, _indexJsDefault3.default)(date);
    var diff = day - currentDay;
    return (0, _indexJsDefault2.default)(date, diff);
}

},{"../_lib/toInteger/index.js":"dkWbJ","../toDate/index.js":"elr3O","../addDays/index.js":"3C7cL","../getISODay/index.js":"3jgzA","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"9ClkT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return setISOWeek;
});
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../getISOWeek/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
function setISOWeek(dirtyDate, dirtyISOWeek) {
    (0, _indexJsDefault3.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var isoWeek = (0, _indexJsDefault.default)(dirtyISOWeek);
    var diff = (0, _indexJsDefault2.default)(date) - isoWeek;
    date.setDate(date.getDate() - diff * 7);
    return date;
}

},{"../_lib/toInteger/index.js":"dkWbJ","../toDate/index.js":"elr3O","../getISOWeek/index.js":"hYopA","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1CEiC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return setMilliseconds;
});
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function setMilliseconds(dirtyDate, dirtyMilliseconds) {
    (0, _indexJsDefault2.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var milliseconds = (0, _indexJsDefault.default)(dirtyMilliseconds);
    date.setMilliseconds(milliseconds);
    return date;
}

},{"../_lib/toInteger/index.js":"dkWbJ","../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"BCNxR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return setMinutes;
});
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function setMinutes(dirtyDate, dirtyMinutes) {
    (0, _indexJsDefault2.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var minutes = (0, _indexJsDefault.default)(dirtyMinutes);
    date.setMinutes(minutes);
    return date;
}

},{"../_lib/toInteger/index.js":"dkWbJ","../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1IdTY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return setQuarter;
});
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../setMonth/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
function setQuarter(dirtyDate, dirtyQuarter) {
    (0, _indexJsDefault3.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var quarter = (0, _indexJsDefault.default)(dirtyQuarter);
    var oldQuarter = Math.floor(date.getMonth() / 3) + 1;
    var diff = quarter - oldQuarter;
    return (0, _indexJsDefault2.default)(date, date.getMonth() + diff * 3);
}

},{"../_lib/toInteger/index.js":"dkWbJ","../toDate/index.js":"elr3O","../setMonth/index.js":"17tWf","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"j2eSg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return setSeconds;
});
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function setSeconds(dirtyDate, dirtySeconds) {
    (0, _indexJsDefault2.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var seconds = (0, _indexJsDefault.default)(dirtySeconds);
    date.setSeconds(seconds);
    return date;
}

},{"../_lib/toInteger/index.js":"dkWbJ","../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1SPJZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return setWeek;
});
var _indexJs = require("../getWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/toInteger/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
function setWeek(dirtyDate, dirtyWeek, options) {
    (0, _indexJsDefault2.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var week = (0, _indexJsDefault3.default)(dirtyWeek);
    var diff = (0, _indexJsDefault.default)(date, options) - week;
    date.setDate(date.getDate() - diff * 7);
    return date;
}

},{"../getWeek/index.js":"6M8d2","../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","../_lib/toInteger/index.js":"dkWbJ","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"kNiLK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return setWeekYear;
});
var _indexJs = require("../differenceInCalendarDays/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfWeekYear/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../toDate/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/toInteger/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
var _indexJs5 = require("../_lib/defaultOptions/index.js");
function setWeekYear(dirtyDate, dirtyWeekYear, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault4.default)(2, arguments);
    var defaultOptions = (0, _indexJs5.getDefaultOptions)();
    var firstWeekContainsDate = (0, _indexJsDefault3.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var date = (0, _indexJsDefault2.default)(dirtyDate);
    var weekYear = (0, _indexJsDefault3.default)(dirtyWeekYear);
    var diff = (0, _indexJsDefault.default)(date, (0, _indexJsDefault1.default)(date, options));
    var firstWeek = new Date(0);
    firstWeek.setFullYear(weekYear, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    date = (0, _indexJsDefault1.default)(firstWeek, options);
    date.setDate(date.getDate() + diff);
    return date;
}

},{"../differenceInCalendarDays/index.js":"44jgD","../startOfWeekYear/index.js":"kJj0U","../toDate/index.js":"elr3O","../_lib/toInteger/index.js":"dkWbJ","../_lib/requiredArgs/index.js":"14prD","../_lib/defaultOptions/index.js":"eo7FR","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8CMX0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return setYear;
});
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function setYear(dirtyDate, dirtyYear) {
    (0, _indexJsDefault2.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var year = (0, _indexJsDefault.default)(dirtyYear);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(date.getTime())) return new Date(NaN);
    date.setFullYear(year);
    return date;
}

},{"../_lib/toInteger/index.js":"dkWbJ","../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gjdjj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return startOfDecade;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function startOfDecade(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var year = date.getFullYear();
    var decade = Math.floor(year / 10) * 10;
    date.setFullYear(decade, 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
}

},{"../toDate/index.js":"elr3O","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"fYHEU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return startOfToday;
});
var _indexJs = require("../startOfDay/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function startOfToday() {
    return (0, _indexJsDefault.default)(Date.now());
}

},{"../startOfDay/index.js":"g4xpx","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"coRv8":[function(require,module,exports,__globalThis) {
/**
 * @name startOfTomorrow
 * @category Day Helpers
 * @summary Return the start of tomorrow.
 * @pure false
 *
 * @description
 * Return the start of tomorrow.
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `new Date()` internally hence impure and can't be safely curried.
 *
 * @returns {Date} the start of tomorrow
 *
 * @example
 * // If today is 6 October 2014:
 * const result = startOfTomorrow()
 * //=> Tue Oct 7 2014 00:00:00
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return startOfTomorrow;
});
function startOfTomorrow() {
    var now = new Date();
    var year = now.getFullYear();
    var month = now.getMonth();
    var day = now.getDate();
    var date = new Date(0);
    date.setFullYear(year, month, day + 1);
    date.setHours(0, 0, 0, 0);
    return date;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5RwjK":[function(require,module,exports,__globalThis) {
/**
 * @name startOfYesterday
 * @category Day Helpers
 * @summary Return the start of yesterday.
 * @pure false
 *
 * @description
 * Return the start of yesterday.
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `new Date()` internally hence impure and can't be safely curried.
 *
 * @returns {Date} the start of yesterday
 *
 * @example
 * // If today is 6 October 2014:
 * const result = startOfYesterday()
 * //=> Sun Oct 5 2014 00:00:00
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return startOfYesterday;
});
function startOfYesterday() {
    var now = new Date();
    var year = now.getFullYear();
    var month = now.getMonth();
    var day = now.getDate();
    var date = new Date(0);
    date.setFullYear(year, month, day - 1);
    date.setHours(0, 0, 0, 0);
    return date;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"a9Qbj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return sub;
});
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _indexJs = require("../subDays/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../subMonths/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/toInteger/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
function sub(date, duration) {
    (0, _indexJsDefault2.default)(2, arguments);
    if (!duration || (0, _typeofDefault.default)(duration) !== 'object') return new Date(NaN);
    var years = duration.years ? (0, _indexJsDefault3.default)(duration.years) : 0;
    var months = duration.months ? (0, _indexJsDefault3.default)(duration.months) : 0;
    var weeks = duration.weeks ? (0, _indexJsDefault3.default)(duration.weeks) : 0;
    var days = duration.days ? (0, _indexJsDefault3.default)(duration.days) : 0;
    var hours = duration.hours ? (0, _indexJsDefault3.default)(duration.hours) : 0;
    var minutes = duration.minutes ? (0, _indexJsDefault3.default)(duration.minutes) : 0;
    var seconds = duration.seconds ? (0, _indexJsDefault3.default)(duration.seconds) : 0;
    // Subtract years and months
    var dateWithoutMonths = (0, _indexJsDefault1.default)(date, months + years * 12);
    // Subtract weeks and days
    var dateWithoutDays = (0, _indexJsDefault.default)(dateWithoutMonths, days + weeks * 7);
    // Subtract hours, minutes and seconds
    var minutestoSub = minutes + hours * 60;
    var secondstoSub = seconds + minutestoSub * 60;
    var mstoSub = secondstoSub * 1000;
    var finalDate = new Date(dateWithoutDays.getTime() - mstoSub);
    return finalDate;
}

},{"@babel/runtime/helpers/esm/typeof":"8bpl6","../subDays/index.js":"goTWu","../subMonths/index.js":"5GQoO","../_lib/requiredArgs/index.js":"14prD","../_lib/toInteger/index.js":"dkWbJ","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5GQoO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return subMonths;
});
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../addMonths/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function subMonths(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    return (0, _indexJsDefault1.default)(dirtyDate, -amount);
}

},{"../_lib/toInteger/index.js":"dkWbJ","../addMonths/index.js":"3fsvC","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1vTly":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return subBusinessDays;
});
var _indexJs = require("../addBusinessDays/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function subBusinessDays(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault1.default)(2, arguments);
    var amount = (0, _indexJsDefault2.default)(dirtyAmount);
    return (0, _indexJsDefault.default)(dirtyDate, -amount);
}

},{"../addBusinessDays/index.js":"26iKx","../_lib/requiredArgs/index.js":"14prD","../_lib/toInteger/index.js":"dkWbJ","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2p6Ci":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return subHours;
});
var _indexJs = require("../addHours/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function subHours(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault1.default)(2, arguments);
    var amount = (0, _indexJsDefault2.default)(dirtyAmount);
    return (0, _indexJsDefault.default)(dirtyDate, -amount);
}

},{"../addHours/index.js":"87L7P","../_lib/requiredArgs/index.js":"14prD","../_lib/toInteger/index.js":"dkWbJ","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"cee50":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return subMinutes;
});
var _indexJs = require("../addMinutes/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function subMinutes(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault1.default)(2, arguments);
    var amount = (0, _indexJsDefault2.default)(dirtyAmount);
    return (0, _indexJsDefault.default)(dirtyDate, -amount);
}

},{"../addMinutes/index.js":"a9kHu","../_lib/requiredArgs/index.js":"14prD","../_lib/toInteger/index.js":"dkWbJ","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"fZikN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return subQuarters;
});
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../addQuarters/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function subQuarters(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    return (0, _indexJsDefault1.default)(dirtyDate, -amount);
}

},{"../_lib/toInteger/index.js":"dkWbJ","../addQuarters/index.js":"3QFLI","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"68KPU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return subSeconds;
});
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../addSeconds/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function subSeconds(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    return (0, _indexJsDefault1.default)(dirtyDate, -amount);
}

},{"../_lib/toInteger/index.js":"dkWbJ","../addSeconds/index.js":"7tH0p","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"ZRcZB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return subWeeks;
});
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../addWeeks/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function subWeeks(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    return (0, _indexJsDefault1.default)(dirtyDate, -amount);
}

},{"../_lib/toInteger/index.js":"dkWbJ","../addWeeks/index.js":"jdo2p","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7kVXH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return subYears;
});
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../addYears/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function subYears(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    return (0, _indexJsDefault1.default)(dirtyDate, -amount);
}

},{"../_lib/toInteger/index.js":"dkWbJ","../addYears/index.js":"fLqeW","../_lib/requiredArgs/index.js":"14prD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"Pb59y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return weeksToDays;
});
var _indexJs = require("../_lib/requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../constants/index.js");
function weeksToDays(weeks) {
    (0, _indexJsDefault.default)(1, arguments);
    return Math.floor(weeks * (0, _indexJs1.daysInWeek));
}

},{"../_lib/requiredArgs/index.js":"14prD","../constants/index.js":"k64Zq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"i3C4W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return yearsToMonths;
});
var _indexJs = require("../_lib/requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../constants/index.js");
function yearsToMonths(years) {
    (0, _indexJsDefault.default)(1, arguments);
    return Math.floor(years * (0, _indexJs1.monthsInYear));
}

},{"../_lib/requiredArgs/index.js":"14prD","../constants/index.js":"k64Zq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3LrpM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return yearsToQuarters;
});
var _indexJs = require("../_lib/requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../constants/index.js");
function yearsToQuarters(years) {
    (0, _indexJsDefault.default)(1, arguments);
    return Math.floor(years * (0, _indexJs1.quartersInYear));
}

},{"../_lib/requiredArgs/index.js":"14prD","../constants/index.js":"k64Zq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4HYME":[function(require,module,exports,__globalThis) {
// This file is generated automatically by `scripts/build/indices.ts`. Please, don't change it.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "af", function() {
    return 0, _indexJsDefault.default;
});
parcelHelpers.export(exports, "ar", function() {
    return 0, _indexJsDefault1.default;
});
parcelHelpers.export(exports, "arDZ", function() {
    return 0, _indexJsDefault2.default;
});
parcelHelpers.export(exports, "arEG", function() {
    return 0, _indexJsDefault3.default;
});
parcelHelpers.export(exports, "arMA", function() {
    return 0, _indexJsDefault4.default;
});
parcelHelpers.export(exports, "arSA", function() {
    return 0, _indexJsDefault5.default;
});
parcelHelpers.export(exports, "arTN", function() {
    return 0, _indexJsDefault6.default;
});
parcelHelpers.export(exports, "az", function() {
    return 0, _indexJsDefault7.default;
});
parcelHelpers.export(exports, "be", function() {
    return 0, _indexJsDefault8.default;
});
parcelHelpers.export(exports, "beTarask", function() {
    return 0, _indexJsDefault9.default;
});
parcelHelpers.export(exports, "bg", function() {
    return 0, _indexJsDefault10.default;
});
parcelHelpers.export(exports, "bn", function() {
    return 0, _indexJsDefault11.default;
});
parcelHelpers.export(exports, "bs", function() {
    return 0, _indexJsDefault12.default;
});
parcelHelpers.export(exports, "ca", function() {
    return 0, _indexJsDefault13.default;
});
parcelHelpers.export(exports, "cs", function() {
    return 0, _indexJsDefault14.default;
});
parcelHelpers.export(exports, "cy", function() {
    return 0, _indexJsDefault15.default;
});
parcelHelpers.export(exports, "da", function() {
    return 0, _indexJsDefault16.default;
});
parcelHelpers.export(exports, "de", function() {
    return 0, _indexJsDefault17.default;
});
parcelHelpers.export(exports, "deAT", function() {
    return 0, _indexJsDefault18.default;
});
parcelHelpers.export(exports, "el", function() {
    return 0, _indexJsDefault19.default;
});
parcelHelpers.export(exports, "enAU", function() {
    return 0, _indexJsDefault20.default;
});
parcelHelpers.export(exports, "enCA", function() {
    return 0, _indexJsDefault21.default;
});
parcelHelpers.export(exports, "enGB", function() {
    return 0, _indexJsDefault22.default;
});
parcelHelpers.export(exports, "enIE", function() {
    return 0, _indexJsDefault23.default;
});
parcelHelpers.export(exports, "enIN", function() {
    return 0, _indexJsDefault24.default;
});
parcelHelpers.export(exports, "enNZ", function() {
    return 0, _indexJsDefault25.default;
});
parcelHelpers.export(exports, "enUS", function() {
    return 0, _indexJsDefault26.default;
});
parcelHelpers.export(exports, "enZA", function() {
    return 0, _indexJsDefault27.default;
});
parcelHelpers.export(exports, "eo", function() {
    return 0, _indexJsDefault28.default;
});
parcelHelpers.export(exports, "es", function() {
    return 0, _indexJsDefault29.default;
});
parcelHelpers.export(exports, "et", function() {
    return 0, _indexJsDefault30.default;
});
parcelHelpers.export(exports, "eu", function() {
    return 0, _indexJsDefault31.default;
});
parcelHelpers.export(exports, "faIR", function() {
    return 0, _indexJsDefault32.default;
});
parcelHelpers.export(exports, "fi", function() {
    return 0, _indexJsDefault33.default;
});
parcelHelpers.export(exports, "fr", function() {
    return 0, _indexJsDefault34.default;
});
parcelHelpers.export(exports, "frCA", function() {
    return 0, _indexJsDefault35.default;
});
parcelHelpers.export(exports, "frCH", function() {
    return 0, _indexJsDefault36.default;
});
parcelHelpers.export(exports, "fy", function() {
    return 0, _indexJsDefault37.default;
});
parcelHelpers.export(exports, "gd", function() {
    return 0, _indexJsDefault38.default;
});
parcelHelpers.export(exports, "gl", function() {
    return 0, _indexJsDefault39.default;
});
parcelHelpers.export(exports, "gu", function() {
    return 0, _indexJsDefault40.default;
});
parcelHelpers.export(exports, "he", function() {
    return 0, _indexJsDefault41.default;
});
parcelHelpers.export(exports, "hi", function() {
    return 0, _indexJsDefault42.default;
});
parcelHelpers.export(exports, "hr", function() {
    return 0, _indexJsDefault43.default;
});
parcelHelpers.export(exports, "ht", function() {
    return 0, _indexJsDefault44.default;
});
parcelHelpers.export(exports, "hu", function() {
    return 0, _indexJsDefault45.default;
});
parcelHelpers.export(exports, "hy", function() {
    return 0, _indexJsDefault46.default;
});
parcelHelpers.export(exports, "id", function() {
    return 0, _indexJsDefault47.default;
});
parcelHelpers.export(exports, "is", function() {
    return 0, _indexJsDefault48.default;
});
parcelHelpers.export(exports, "it", function() {
    return 0, _indexJsDefault49.default;
});
parcelHelpers.export(exports, "itCH", function() {
    return 0, _indexJsDefault50.default;
});
parcelHelpers.export(exports, "ja", function() {
    return 0, _indexJsDefault51.default;
});
parcelHelpers.export(exports, "jaHira", function() {
    return 0, _indexJsDefault52.default;
});
parcelHelpers.export(exports, "ka", function() {
    return 0, _indexJsDefault53.default;
});
parcelHelpers.export(exports, "kk", function() {
    return 0, _indexJsDefault54.default;
});
parcelHelpers.export(exports, "km", function() {
    return 0, _indexJsDefault55.default;
});
parcelHelpers.export(exports, "kn", function() {
    return 0, _indexJsDefault56.default;
});
parcelHelpers.export(exports, "ko", function() {
    return 0, _indexJsDefault57.default;
});
parcelHelpers.export(exports, "lb", function() {
    return 0, _indexJsDefault58.default;
});
parcelHelpers.export(exports, "lt", function() {
    return 0, _indexJsDefault59.default;
});
parcelHelpers.export(exports, "lv", function() {
    return 0, _indexJsDefault60.default;
});
parcelHelpers.export(exports, "mk", function() {
    return 0, _indexJsDefault61.default;
});
parcelHelpers.export(exports, "mn", function() {
    return 0, _indexJsDefault62.default;
});
parcelHelpers.export(exports, "ms", function() {
    return 0, _indexJsDefault63.default;
});
parcelHelpers.export(exports, "mt", function() {
    return 0, _indexJsDefault64.default;
});
parcelHelpers.export(exports, "nb", function() {
    return 0, _indexJsDefault65.default;
});
parcelHelpers.export(exports, "nl", function() {
    return 0, _indexJsDefault66.default;
});
parcelHelpers.export(exports, "nlBE", function() {
    return 0, _indexJsDefault67.default;
});
parcelHelpers.export(exports, "nn", function() {
    return 0, _indexJsDefault68.default;
});
parcelHelpers.export(exports, "oc", function() {
    return 0, _indexJsDefault69.default;
});
parcelHelpers.export(exports, "pl", function() {
    return 0, _indexJsDefault70.default;
});
parcelHelpers.export(exports, "pt", function() {
    return 0, _indexJsDefault71.default;
});
parcelHelpers.export(exports, "ptBR", function() {
    return 0, _indexJsDefault72.default;
});
parcelHelpers.export(exports, "ro", function() {
    return 0, _indexJsDefault73.default;
});
parcelHelpers.export(exports, "ru", function() {
    return 0, _indexJsDefault74.default;
});
parcelHelpers.export(exports, "sk", function() {
    return 0, _indexJsDefault75.default;
});
parcelHelpers.export(exports, "sl", function() {
    return 0, _indexJsDefault76.default;
});
parcelHelpers.export(exports, "sq", function() {
    return 0, _indexJsDefault77.default;
});
parcelHelpers.export(exports, "sr", function() {
    return 0, _indexJsDefault78.default;
});
parcelHelpers.export(exports, "srLatn", function() {
    return 0, _indexJsDefault79.default;
});
parcelHelpers.export(exports, "sv", function() {
    return 0, _indexJsDefault80.default;
});
parcelHelpers.export(exports, "ta", function() {
    return 0, _indexJsDefault81.default;
});
parcelHelpers.export(exports, "te", function() {
    return 0, _indexJsDefault82.default;
});
parcelHelpers.export(exports, "th", function() {
    return 0, _indexJsDefault83.default;
});
parcelHelpers.export(exports, "tr", function() {
    return 0, _indexJsDefault84.default;
});
parcelHelpers.export(exports, "ug", function() {
    return 0, _indexJsDefault85.default;
});
parcelHelpers.export(exports, "uk", function() {
    return 0, _indexJsDefault86.default;
});
parcelHelpers.export(exports, "uz", function() {
    return 0, _indexJsDefault87.default;
});
parcelHelpers.export(exports, "uzCyrl", function() {
    return 0, _indexJsDefault88.default;
});
parcelHelpers.export(exports, "vi", function() {
    return 0, _indexJsDefault89.default;
});
parcelHelpers.export(exports, "zhCN", function() {
    return 0, _indexJsDefault90.default;
});
parcelHelpers.export(exports, "zhHK", function() {
    return 0, _indexJsDefault91.default;
});
parcelHelpers.export(exports, "zhTW", function() {
    return 0, _indexJsDefault92.default;
});
var _indexJs = require("./af/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./ar/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./ar-DZ/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./ar-EG/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./ar-MA/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
var _indexJs5 = require("./ar-SA/index.js");
var _indexJsDefault5 = parcelHelpers.interopDefault(_indexJs5);
var _indexJs6 = require("./ar-TN/index.js");
var _indexJsDefault6 = parcelHelpers.interopDefault(_indexJs6);
var _indexJs7 = require("./az/index.js");
var _indexJsDefault7 = parcelHelpers.interopDefault(_indexJs7);
var _indexJs8 = require("./be/index.js");
var _indexJsDefault8 = parcelHelpers.interopDefault(_indexJs8);
var _indexJs9 = require("./be-tarask/index.js");
var _indexJsDefault9 = parcelHelpers.interopDefault(_indexJs9);
var _indexJs10 = require("./bg/index.js");
var _indexJsDefault10 = parcelHelpers.interopDefault(_indexJs10);
var _indexJs11 = require("./bn/index.js");
var _indexJsDefault11 = parcelHelpers.interopDefault(_indexJs11);
var _indexJs12 = require("./bs/index.js");
var _indexJsDefault12 = parcelHelpers.interopDefault(_indexJs12);
var _indexJs13 = require("./ca/index.js");
var _indexJsDefault13 = parcelHelpers.interopDefault(_indexJs13);
var _indexJs14 = require("./cs/index.js");
var _indexJsDefault14 = parcelHelpers.interopDefault(_indexJs14);
var _indexJs15 = require("./cy/index.js");
var _indexJsDefault15 = parcelHelpers.interopDefault(_indexJs15);
var _indexJs16 = require("./da/index.js");
var _indexJsDefault16 = parcelHelpers.interopDefault(_indexJs16);
var _indexJs17 = require("./de/index.js");
var _indexJsDefault17 = parcelHelpers.interopDefault(_indexJs17);
var _indexJs18 = require("./de-AT/index.js");
var _indexJsDefault18 = parcelHelpers.interopDefault(_indexJs18);
var _indexJs19 = require("./el/index.js");
var _indexJsDefault19 = parcelHelpers.interopDefault(_indexJs19);
var _indexJs20 = require("./en-AU/index.js");
var _indexJsDefault20 = parcelHelpers.interopDefault(_indexJs20);
var _indexJs21 = require("./en-CA/index.js");
var _indexJsDefault21 = parcelHelpers.interopDefault(_indexJs21);
var _indexJs22 = require("./en-GB/index.js");
var _indexJsDefault22 = parcelHelpers.interopDefault(_indexJs22);
var _indexJs23 = require("./en-IE/index.js");
var _indexJsDefault23 = parcelHelpers.interopDefault(_indexJs23);
var _indexJs24 = require("./en-IN/index.js");
var _indexJsDefault24 = parcelHelpers.interopDefault(_indexJs24);
var _indexJs25 = require("./en-NZ/index.js");
var _indexJsDefault25 = parcelHelpers.interopDefault(_indexJs25);
var _indexJs26 = require("./en-US/index.js");
var _indexJsDefault26 = parcelHelpers.interopDefault(_indexJs26);
var _indexJs27 = require("./en-ZA/index.js");
var _indexJsDefault27 = parcelHelpers.interopDefault(_indexJs27);
var _indexJs28 = require("./eo/index.js");
var _indexJsDefault28 = parcelHelpers.interopDefault(_indexJs28);
var _indexJs29 = require("./es/index.js");
var _indexJsDefault29 = parcelHelpers.interopDefault(_indexJs29);
var _indexJs30 = require("./et/index.js");
var _indexJsDefault30 = parcelHelpers.interopDefault(_indexJs30);
var _indexJs31 = require("./eu/index.js");
var _indexJsDefault31 = parcelHelpers.interopDefault(_indexJs31);
var _indexJs32 = require("./fa-IR/index.js");
var _indexJsDefault32 = parcelHelpers.interopDefault(_indexJs32);
var _indexJs33 = require("./fi/index.js");
var _indexJsDefault33 = parcelHelpers.interopDefault(_indexJs33);
var _indexJs34 = require("./fr/index.js");
var _indexJsDefault34 = parcelHelpers.interopDefault(_indexJs34);
var _indexJs35 = require("./fr-CA/index.js");
var _indexJsDefault35 = parcelHelpers.interopDefault(_indexJs35);
var _indexJs36 = require("./fr-CH/index.js");
var _indexJsDefault36 = parcelHelpers.interopDefault(_indexJs36);
var _indexJs37 = require("./fy/index.js");
var _indexJsDefault37 = parcelHelpers.interopDefault(_indexJs37);
var _indexJs38 = require("./gd/index.js");
var _indexJsDefault38 = parcelHelpers.interopDefault(_indexJs38);
var _indexJs39 = require("./gl/index.js");
var _indexJsDefault39 = parcelHelpers.interopDefault(_indexJs39);
var _indexJs40 = require("./gu/index.js");
var _indexJsDefault40 = parcelHelpers.interopDefault(_indexJs40);
var _indexJs41 = require("./he/index.js");
var _indexJsDefault41 = parcelHelpers.interopDefault(_indexJs41);
var _indexJs42 = require("./hi/index.js");
var _indexJsDefault42 = parcelHelpers.interopDefault(_indexJs42);
var _indexJs43 = require("./hr/index.js");
var _indexJsDefault43 = parcelHelpers.interopDefault(_indexJs43);
var _indexJs44 = require("./ht/index.js");
var _indexJsDefault44 = parcelHelpers.interopDefault(_indexJs44);
var _indexJs45 = require("./hu/index.js");
var _indexJsDefault45 = parcelHelpers.interopDefault(_indexJs45);
var _indexJs46 = require("./hy/index.js");
var _indexJsDefault46 = parcelHelpers.interopDefault(_indexJs46);
var _indexJs47 = require("./id/index.js");
var _indexJsDefault47 = parcelHelpers.interopDefault(_indexJs47);
var _indexJs48 = require("./is/index.js");
var _indexJsDefault48 = parcelHelpers.interopDefault(_indexJs48);
var _indexJs49 = require("./it/index.js");
var _indexJsDefault49 = parcelHelpers.interopDefault(_indexJs49);
var _indexJs50 = require("./it-CH/index.js");
var _indexJsDefault50 = parcelHelpers.interopDefault(_indexJs50);
var _indexJs51 = require("./ja/index.js");
var _indexJsDefault51 = parcelHelpers.interopDefault(_indexJs51);
var _indexJs52 = require("./ja-Hira/index.js");
var _indexJsDefault52 = parcelHelpers.interopDefault(_indexJs52);
var _indexJs53 = require("./ka/index.js");
var _indexJsDefault53 = parcelHelpers.interopDefault(_indexJs53);
var _indexJs54 = require("./kk/index.js");
var _indexJsDefault54 = parcelHelpers.interopDefault(_indexJs54);
var _indexJs55 = require("./km/index.js");
var _indexJsDefault55 = parcelHelpers.interopDefault(_indexJs55);
var _indexJs56 = require("./kn/index.js");
var _indexJsDefault56 = parcelHelpers.interopDefault(_indexJs56);
var _indexJs57 = require("./ko/index.js");
var _indexJsDefault57 = parcelHelpers.interopDefault(_indexJs57);
var _indexJs58 = require("./lb/index.js");
var _indexJsDefault58 = parcelHelpers.interopDefault(_indexJs58);
var _indexJs59 = require("./lt/index.js");
var _indexJsDefault59 = parcelHelpers.interopDefault(_indexJs59);
var _indexJs60 = require("./lv/index.js");
var _indexJsDefault60 = parcelHelpers.interopDefault(_indexJs60);
var _indexJs61 = require("./mk/index.js");
var _indexJsDefault61 = parcelHelpers.interopDefault(_indexJs61);
var _indexJs62 = require("./mn/index.js");
var _indexJsDefault62 = parcelHelpers.interopDefault(_indexJs62);
var _indexJs63 = require("./ms/index.js");
var _indexJsDefault63 = parcelHelpers.interopDefault(_indexJs63);
var _indexJs64 = require("./mt/index.js");
var _indexJsDefault64 = parcelHelpers.interopDefault(_indexJs64);
var _indexJs65 = require("./nb/index.js");
var _indexJsDefault65 = parcelHelpers.interopDefault(_indexJs65);
var _indexJs66 = require("./nl/index.js");
var _indexJsDefault66 = parcelHelpers.interopDefault(_indexJs66);
var _indexJs67 = require("./nl-BE/index.js");
var _indexJsDefault67 = parcelHelpers.interopDefault(_indexJs67);
var _indexJs68 = require("./nn/index.js");
var _indexJsDefault68 = parcelHelpers.interopDefault(_indexJs68);
var _indexJs69 = require("./oc/index.js");
var _indexJsDefault69 = parcelHelpers.interopDefault(_indexJs69);
var _indexJs70 = require("./pl/index.js");
var _indexJsDefault70 = parcelHelpers.interopDefault(_indexJs70);
var _indexJs71 = require("./pt/index.js");
var _indexJsDefault71 = parcelHelpers.interopDefault(_indexJs71);
var _indexJs72 = require("./pt-BR/index.js");
var _indexJsDefault72 = parcelHelpers.interopDefault(_indexJs72);
var _indexJs73 = require("./ro/index.js");
var _indexJsDefault73 = parcelHelpers.interopDefault(_indexJs73);
var _indexJs74 = require("./ru/index.js");
var _indexJsDefault74 = parcelHelpers.interopDefault(_indexJs74);
var _indexJs75 = require("./sk/index.js");
var _indexJsDefault75 = parcelHelpers.interopDefault(_indexJs75);
var _indexJs76 = require("./sl/index.js");
var _indexJsDefault76 = parcelHelpers.interopDefault(_indexJs76);
var _indexJs77 = require("./sq/index.js");
var _indexJsDefault77 = parcelHelpers.interopDefault(_indexJs77);
var _indexJs78 = require("./sr/index.js");
var _indexJsDefault78 = parcelHelpers.interopDefault(_indexJs78);
var _indexJs79 = require("./sr-Latn/index.js");
var _indexJsDefault79 = parcelHelpers.interopDefault(_indexJs79);
var _indexJs80 = require("./sv/index.js");
var _indexJsDefault80 = parcelHelpers.interopDefault(_indexJs80);
var _indexJs81 = require("./ta/index.js");
var _indexJsDefault81 = parcelHelpers.interopDefault(_indexJs81);
var _indexJs82 = require("./te/index.js");
var _indexJsDefault82 = parcelHelpers.interopDefault(_indexJs82);
var _indexJs83 = require("./th/index.js");
var _indexJsDefault83 = parcelHelpers.interopDefault(_indexJs83);
var _indexJs84 = require("./tr/index.js");
var _indexJsDefault84 = parcelHelpers.interopDefault(_indexJs84);
var _indexJs85 = require("./ug/index.js");
var _indexJsDefault85 = parcelHelpers.interopDefault(_indexJs85);
var _indexJs86 = require("./uk/index.js");
var _indexJsDefault86 = parcelHelpers.interopDefault(_indexJs86);
var _indexJs87 = require("./uz/index.js");
var _indexJsDefault87 = parcelHelpers.interopDefault(_indexJs87);
var _indexJs88 = require("./uz-Cyrl/index.js");
var _indexJsDefault88 = parcelHelpers.interopDefault(_indexJs88);
var _indexJs89 = require("./vi/index.js");
var _indexJsDefault89 = parcelHelpers.interopDefault(_indexJs89);
var _indexJs90 = require("./zh-CN/index.js");
var _indexJsDefault90 = parcelHelpers.interopDefault(_indexJs90);
var _indexJs91 = require("./zh-HK/index.js");
var _indexJsDefault91 = parcelHelpers.interopDefault(_indexJs91);
var _indexJs92 = require("./zh-TW/index.js");
var _indexJsDefault92 = parcelHelpers.interopDefault(_indexJs92);

},{"./af/index.js":"jTgdb","./ar/index.js":"3GBrr","./ar-DZ/index.js":"b628y","./ar-EG/index.js":"60cMj","./ar-MA/index.js":"a75sH","./ar-SA/index.js":"kWsMF","./ar-TN/index.js":"6G6CP","./az/index.js":"KKqMC","./be/index.js":"c3Ei3","./be-tarask/index.js":"6uHFq","./bg/index.js":"i2afB","./bn/index.js":"2EJFM","./bs/index.js":"gYIcH","./ca/index.js":"aGMsW","./cs/index.js":"1dSKu","./cy/index.js":"8LyIw","./da/index.js":"1Vh1w","./de/index.js":"4O0vS","./de-AT/index.js":"gMux1","./el/index.js":"fcqRw","./en-AU/index.js":"92Jzk","./en-CA/index.js":"bzLEy","./en-GB/index.js":"8VceF","./en-IE/index.js":"b92JJ","./en-IN/index.js":"6KWuI","./en-NZ/index.js":"6Igdm","./en-US/index.js":"8LL9Z","./en-ZA/index.js":"ec733","./eo/index.js":"ajjSk","./es/index.js":"hhCUu","./et/index.js":"g5EKJ","./eu/index.js":"663nU","./fa-IR/index.js":"ebimY","./fi/index.js":"j3aAH","./fr/index.js":"fNooG","./fr-CA/index.js":"80gFS","./fr-CH/index.js":"853bI","./fy/index.js":"9RrvA","./gd/index.js":"iMY0I","./gl/index.js":"5Zaf9","./gu/index.js":"2VQWP","./he/index.js":"eAQHN","./hi/index.js":"chTCt","./hr/index.js":"lTn2p","./ht/index.js":"be2y5","./hu/index.js":"aYo0x","./hy/index.js":"ieBPG","./id/index.js":"704ij","./is/index.js":"heYJa","./it/index.js":"b9Hvo","./it-CH/index.js":"9vfl3","./ja/index.js":"23QwZ","./ja-Hira/index.js":"2XoVR","./ka/index.js":"lCXTq","./kk/index.js":"dFow7","./km/index.js":"gmuuj","./kn/index.js":"2KUDY","./ko/index.js":"7OdOb","./lb/index.js":"jhM7W","./lt/index.js":"lC6fD","./lv/index.js":"luANn","./mk/index.js":"9EBdt","./mn/index.js":"1JPQ7","./ms/index.js":"3AjWH","./mt/index.js":"i0jzi","./nb/index.js":"jagCx","./nl/index.js":"84xnd","./nl-BE/index.js":"6QUxg","./nn/index.js":"9I8hS","./oc/index.js":"fjHFa","./pl/index.js":"2k3le","./pt/index.js":"4G91w","./pt-BR/index.js":"gSfq8","./ro/index.js":"7oWCw","./ru/index.js":"9f9Hf","./sk/index.js":"9snbz","./sl/index.js":"4eB7k","./sq/index.js":"1nsvW","./sr/index.js":"eRnta","./sr-Latn/index.js":"hbaTt","./sv/index.js":"1LpUy","./ta/index.js":"gZbkW","./te/index.js":"cOMeh","./th/index.js":"lCW3l","./tr/index.js":"5mvpu","./ug/index.js":"d84tX","./uk/index.js":"bW59P","./uz/index.js":"7nwJh","./uz-Cyrl/index.js":"9d28A","./vi/index.js":"bjl72","./zh-CN/index.js":"jdMw9","./zh-HK/index.js":"gpgSt","./zh-TW/index.js":"g7mDQ","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jTgdb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Afrikaans locale.
 * @language Afrikaans
 * @iso-639-2 afr
 * @author Marnus Weststrate [@marnusw]{@link https://github.com/marnusw}
 */ var locale = {
    code: 'af',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"bKWZh","./_lib/formatLong/index.js":"F7M8u","./_lib/formatRelative/index.js":"MVEgq","./_lib/localize/index.js":"4KlEY","./_lib/match/index.js":"jd3av","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"bKWZh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "minder as 'n sekonde",
        other: 'minder as {{count}} sekondes'
    },
    xSeconds: {
        one: '1 sekonde',
        other: '{{count}} sekondes'
    },
    halfAMinute: "'n halwe minuut",
    lessThanXMinutes: {
        one: "minder as 'n minuut",
        other: 'minder as {{count}} minute'
    },
    xMinutes: {
        one: "'n minuut",
        other: '{{count}} minute'
    },
    aboutXHours: {
        one: 'ongeveer 1 uur',
        other: 'ongeveer {{count}} ure'
    },
    xHours: {
        one: '1 uur',
        other: '{{count}} ure'
    },
    xDays: {
        one: '1 dag',
        other: '{{count}} dae'
    },
    aboutXWeeks: {
        one: 'ongeveer 1 week',
        other: 'ongeveer {{count}} weke'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weke'
    },
    aboutXMonths: {
        one: 'ongeveer 1 maand',
        other: 'ongeveer {{count}} maande'
    },
    xMonths: {
        one: '1 maand',
        other: '{{count}} maande'
    },
    aboutXYears: {
        one: 'ongeveer 1 jaar',
        other: 'ongeveer {{count}} jaar'
    },
    xYears: {
        one: '1 jaar',
        other: '{{count}} jaar'
    },
    overXYears: {
        one: 'meer as 1 jaar',
        other: 'meer as {{count}} jaar'
    },
    almostXYears: {
        one: 'byna 1 jaar',
        other: 'byna {{count}} jaar'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'oor ' + result;
        else return result + ' gelede';
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"F7M8u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'yyyy/MM/dd'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'om' {{time}}",
    long: "{{date}} 'om' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"MVEgq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'verlede' eeee 'om' p",
    yesterday: "'gister om' p",
    today: "'vandag om' p",
    tomorrow: "'m\xf4re om' p",
    nextWeek: "eeee 'om' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4KlEY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'vC',
        'nC'
    ],
    abbreviated: [
        'vC',
        'nC'
    ],
    wide: [
        'voor Christus',
        'na Christus'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        '1ste kwartaal',
        '2de kwartaal',
        '3de kwartaal',
        '4de kwartaal'
    ]
};
var monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mrt',
        'Apr',
        'Mei',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Okt',
        'Nov',
        'Des'
    ],
    wide: [
        'Januarie',
        'Februarie',
        'Maart',
        'April',
        'Mei',
        'Junie',
        'Julie',
        'Augustus',
        'September',
        'Oktober',
        'November',
        'Desember'
    ]
};
var dayValues = {
    narrow: [
        'S',
        'M',
        'D',
        'W',
        'D',
        'V',
        'S'
    ],
    short: [
        'So',
        'Ma',
        'Di',
        'Wo',
        'Do',
        'Vr',
        'Sa'
    ],
    abbreviated: [
        'Son',
        'Maa',
        'Din',
        'Woe',
        'Don',
        'Vry',
        'Sat'
    ],
    wide: [
        'Sondag',
        'Maandag',
        'Dinsdag',
        'Woensdag',
        'Donderdag',
        'Vrydag',
        'Saterdag'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'vm',
        pm: 'nm',
        midnight: 'middernag',
        noon: 'middaguur',
        morning: 'oggend',
        afternoon: 'middag',
        evening: 'laat middag',
        night: 'aand'
    },
    abbreviated: {
        am: 'vm',
        pm: 'nm',
        midnight: 'middernag',
        noon: 'middaguur',
        morning: 'oggend',
        afternoon: 'middag',
        evening: 'laat middag',
        night: 'aand'
    },
    wide: {
        am: 'vm',
        pm: 'nm',
        midnight: 'middernag',
        noon: 'middaguur',
        morning: 'oggend',
        afternoon: 'middag',
        evening: 'laat middag',
        night: 'aand'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'vm',
        pm: 'nm',
        midnight: 'middernag',
        noon: 'uur die middag',
        morning: 'uur die oggend',
        afternoon: 'uur die middag',
        evening: 'uur die aand',
        night: 'uur die aand'
    },
    abbreviated: {
        am: 'vm',
        pm: 'nm',
        midnight: 'middernag',
        noon: 'uur die middag',
        morning: 'uur die oggend',
        afternoon: 'uur die middag',
        evening: 'uur die aand',
        night: 'uur die aand'
    },
    wide: {
        am: 'vm',
        pm: 'nm',
        midnight: 'middernag',
        noon: 'uur die middag',
        morning: 'uur die oggend',
        afternoon: 'uur die middag',
        evening: 'uur die aand',
        night: 'uur die aand'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    var rem100 = number % 100;
    if (rem100 < 20) switch(rem100){
        case 1:
        case 8:
            return number + 'ste';
        default:
            return number + 'de';
    }
    return number + 'ste';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jd3av":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(ste|de)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^([vn]\.? ?C\.?)/,
    abbreviated: /^([vn]\. ?C\.?)/,
    wide: /^((voor|na) Christus)/
};
var parseEraPatterns = {
    any: [
        /^v/,
        /^n/
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234](st|d)e kwartaal/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(Jan|Feb|Mrt|Apr|Mei|Jun|Jul|Aug|Sep|Okt|Nov|Dec)\.?/i,
    wide: /^(Januarie|Februarie|Maart|April|Mei|Junie|Julie|Augustus|September|Oktober|November|Desember)/i
};
var parseMonthPatterns = {
    narrow: [
        /^J/i,
        /^F/i,
        /^M/i,
        /^A/i,
        /^M/i,
        /^J/i,
        /^J/i,
        /^A/i,
        /^S/i,
        /^O/i,
        /^N/i,
        /^D/i
    ],
    any: [
        /^Jan/i,
        /^Feb/i,
        /^Mrt/i,
        /^Apr/i,
        /^Mei/i,
        /^Jun/i,
        /^Jul/i,
        /^Aug/i,
        /^Sep/i,
        /^Okt/i,
        /^Nov/i,
        /^Dec/i
    ]
};
var matchDayPatterns = {
    narrow: /^[smdwv]/i,
    short: /^(So|Ma|Di|Wo|Do|Vr|Sa)/i,
    abbreviated: /^(Son|Maa|Din|Woe|Don|Vry|Sat)/i,
    wide: /^(Sondag|Maandag|Dinsdag|Woensdag|Donderdag|Vrydag|Saterdag)/i
};
var parseDayPatterns = {
    narrow: [
        /^S/i,
        /^M/i,
        /^D/i,
        /^W/i,
        /^D/i,
        /^V/i,
        /^S/i
    ],
    any: [
        /^So/i,
        /^Ma/i,
        /^Di/i,
        /^Wo/i,
        /^Do/i,
        /^Vr/i,
        /^Sa/i
    ]
};
var matchDayPeriodPatterns = {
    any: /^(vm|nm|middernag|(?:uur )?die (oggend|middag|aand))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^vm/i,
        pm: /^nm/i,
        midnight: /^middernag/i,
        noon: /^middaguur/i,
        morning: /oggend/i,
        afternoon: /middag/i,
        evening: /laat middag/i,
        night: /aand/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3GBrr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Arabic locale (Modern Standard Arabic - Al-fussha).
 * @language Modern Standard Arabic
 * @iso-639-2 ara
 * @author Abdallah Hassan [@AbdallahAHO]{@link https://github.com/AbdallahAHO}
 * @author Koussay Haj Kacem [@essana3]{@link https://github.com/essana3}
 */ var locale = {
    code: 'ar',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 6 /* Saturday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"2vBwG","./_lib/formatLong/index.js":"ibdUp","./_lib/formatRelative/index.js":"5jbrv","./_lib/localize/index.js":"bdCXe","./_lib/match/index.js":"cXGd2","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2vBwG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062B\u0627\u0646\u064A\u062A\u0627\u0646",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635\u0641 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u0627\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0633\u0627\u0639\u062A\u0627\u0646",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
        two: "\u064A\u0648\u0645\u0627\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639 \u062A\u0642\u0631\u064A\u0628\u0627",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639\u0627 \u062A\u0642\u0631\u064A\u0628\u0627"
    },
    xWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F",
        two: "\u0623\u0633\u0628\u0648\u0639\u0627\u0646",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639\u0627"
    },
    aboutXMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627",
        other: "{{count}} \u0634\u0647\u0631\u0627 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
        two: "\u0634\u0647\u0631\u0627\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631",
        other: "{{count}} \u0634\u0647\u0631\u0627"
    },
    aboutXYears: {
        one: "\u0633\u0646\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0633\u0646\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627",
        threeToTen: "{{count}} \u0633\u0646\u0648\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0633\u0646\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xYears: {
        one: "\u0633\u0646\u0629 \u0648\u0627\u062D\u062F",
        two: "\u0633\u0646\u062A\u0627\u0646",
        threeToTen: "{{count}} \u0633\u0646\u0648\u0627\u062A",
        other: "{{count}} \u0633\u0646\u0629"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0633\u0646\u0629",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0633\u0646\u062A\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0633\u0646\u0648\u0627\u062A",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0633\u0646\u0629"
    },
    almostXYears: {
        one: "\u0645\u0627 \u064A\u0642\u0627\u0631\u0628 \u0633\u0646\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0645\u0627 \u064A\u0642\u0627\u0631\u0628 \u0633\u0646\u062A\u064A\u0646",
        threeToTen: "\u0645\u0627 \u064A\u0642\u0627\u0631\u0628 {{count}} \u0633\u0646\u0648\u0627\u062A",
        other: "\u0645\u0627 \u064A\u0642\u0627\u0631\u0628 {{count}} \u0633\u0646\u0629"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var usageGroup = formatDistanceLocale[token];
    var result;
    if (typeof usageGroup === 'string') result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else if (count === 2) result = usageGroup.two;
    else if (count <= 10) result = usageGroup.threeToTen.replace('{{count}}', String(count));
    else result = usageGroup.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u062E\u0644\u0627\u0644 " + result;
        else return "\u0645\u0646\u0630 " + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"ibdUp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE\u060C do MMMM y",
    long: 'do MMMM y',
    medium: 'd MMM y',
    short: 'dd/MM/yyyy'
};
var timeFormats = {
    full: 'HH:mm:ss',
    long: 'HH:mm:ss',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} '\u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' {{time}}",
    long: "{{date}} '\u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5jbrv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "eeee '\u0627\u0644\u0645\u0627\u0636\u064A \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' p",
    yesterday: "'\u0627\u0644\u0623\u0645\u0633 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' p",
    today: "'\u0627\u0644\u064A\u0648\u0645 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' p",
    tomorrow: "'\u063A\u062F\u0627 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' p",
    nextWeek: "eeee '\u0627\u0644\u0642\u0627\u062F\u0645 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' p",
    other: 'P'
};
var formatRelative = function formatRelative(token) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"bdCXe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
var monthValues = {
    narrow: [
        "\u064A",
        "\u0641",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u064A",
        "\u064A",
        "\u0623",
        "\u0633",
        "\u0623",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u064A\u0646\u0627\u064A\u0631",
        "\u0641\u0628\u0631\u0627\u064A\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u064A\u0648",
        "\u064A\u0648\u0644\u064A\u0648",
        "\u0623\u063A\u0633\u0637\u0633",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ],
    wide: [
        "\u064A\u0646\u0627\u064A\u0631",
        "\u0641\u0628\u0631\u0627\u064A\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u064A\u0648",
        "\u064A\u0648\u0644\u064A\u0648",
        "\u0623\u063A\u0633\u0637\u0633",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ]
};
var dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0627\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
    }
};
var ordinalNumber = function ordinalNumber(num) {
    return String(num);
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"cXGd2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /[قب]/,
    abbreviated: /[قب]\.م\./,
    wide: /(قبل|بعد) الميلاد/
};
var parseEraPatterns = {
    any: [
        /قبل/,
        /بعد/
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /ر[1234]/,
    wide: /الربع (الأول|الثاني|الثالث|الرابع)/
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[أيفمسند]/,
    abbreviated: /^(يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/,
    wide: /^(يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/
};
var parseMonthPatterns = {
    narrow: [
        /^ي/i,
        /^ف/i,
        /^م/i,
        /^أ/i,
        /^م/i,
        /^ي/i,
        /^ي/i,
        /^أ/i,
        /^س/i,
        /^أ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^يناير/i,
        /^فبراير/i,
        /^مارس/i,
        /^أبريل/i,
        /^مايو/i,
        /^يونيو/i,
        /^يوليو/i,
        /^أغسطس/i,
        /^سبتمبر/i,
        /^أكتوبر/i,
        /^نوفمبر/i,
        /^ديسمبر/i
    ]
};
var matchDayPatterns = {
    narrow: /^[حنثرخجس]/i,
    short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    abbreviated: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
var parseDayPatterns = {
    narrow: [
        /^ح/i,
        /^ن/i,
        /^ث/i,
        /^ر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ],
    wide: [
        /^الأحد/i,
        /^الاثنين/i,
        /^الثلاثاء/i,
        /^الأربعاء/i,
        /^الخميس/i,
        /^الجمعة/i,
        /^السبت/i
    ],
    any: [
        /^أح/i,
        /^اث/i,
        /^ث/i,
        /^أر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(ص|م|منتصف الليل|الظهر|بعد الظهر|في الصباح|في المساء|في الليل)/,
    any: /^(ص|م|منتصف الليل|الظهر|بعد الظهر|في الصباح|في المساء|في الليل)/
};
var parseDayPeriodPatterns = {
    any: {
        am: /^ص/,
        pm: /^م/,
        midnight: /منتصف الليل/,
        noon: /الظهر/,
        afternoon: /بعد الظهر/,
        morning: /في الصباح/,
        evening: /في المساء/,
        night: /في الليل/
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault1.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault1.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault1.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault1.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault1.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchPatternFn/index.js":"2Mexa","../../../_lib/buildMatchFn/index.js":"7YCyk","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"b628y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Arabic locale (Algerian Arabic).
 * @language Algerian Arabic
 * @iso-639-2 ara
 * @author Badreddine Boumaza [@badre429]{@link https://github.com/badre429}
 * @author Ahmed ElShahat [@elshahat]{@link https://github.com/elshahat}
 */ var locale = {
    code: 'ar-DZ',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"1uvnx","./_lib/formatLong/index.js":"42Hvp","./_lib/formatRelative/index.js":"3CZos","./_lib/localize/index.js":"kK1un","./_lib/match/index.js":"kUneN","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1uvnx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635\u0641 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
        two: "\u064A\u0648\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639"
    },
    aboutXMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
        two: "\u0634\u0647\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631",
        other: "{{count}} \u0634\u0647\u0631"
    },
    aboutXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F",
        two: "\u0639\u0627\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "{{count}} \u0639\u0627\u0645"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0639\u0627\u0645"
    },
    almostXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    options = options || {};
    var usageGroup = formatDistanceLocale[token];
    var result;
    if (typeof usageGroup === 'string') result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else if (count === 2) result = usageGroup.two;
    else if (count <= 10) result = usageGroup.threeToTen.replace('{{count}}', String(count));
    else result = usageGroup.other.replace('{{count}}', String(count));
    if (options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0641\u064A \u062E\u0644\u0627\u0644 " + result;
        else return "\u0645\u0646\u0630 " + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"42Hvp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var dateTimeFormats = {
    full: "{{date}} '\u0639\u0646\u062F' {{time}}",
    long: "{{date}} '\u0639\u0646\u062F' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3CZos":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'\u0623\u062E\u0631' eeee '\u0639\u0646\u062F' p",
    yesterday: "'\u0623\u0645\u0633 \u0639\u0646\u062F' p",
    today: "'\u0627\u0644\u064A\u0648\u0645 \u0639\u0646\u062F' p",
    tomorrow: "'\u063A\u062F\u0627\u064B \u0639\u0646\u062F' p",
    nextWeek: "eeee '\u0639\u0646\u062F' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"kK1un":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
var monthValues = {
    narrow: [
        "\u062C",
        "\u0641",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u062C",
        "\u062C",
        "\u0623",
        "\u0633",
        "\u0623",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u062C\u0627\u0646\u0640",
        "\u0641\u064A\u0641\u0640",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0641\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0640",
        "\u062C\u0648\u0627\u0646\u0640",
        "\u062C\u0648\u064A\u0640",
        "\u0623\u0648\u062A",
        "\u0633\u0628\u062A\u0640",
        "\u0623\u0643\u062A\u0640",
        "\u0646\u0648\u0641\u0640",
        "\u062F\u064A\u0633\u0640"
    ],
    wide: [
        "\u062C\u0627\u0646\u0641\u064A",
        "\u0641\u064A\u0641\u0631\u064A",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0641\u0631\u064A\u0644",
        "\u0645\u0627\u064A",
        "\u062C\u0648\u0627\u0646",
        "\u062C\u0648\u064A\u0644\u064A\u0629",
        "\u0623\u0648\u062A",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ]
};
var dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u0640",
        "\u062B\u0644\u0627",
        "\u0623\u0631\u0628\u0640",
        "\u062E\u0645\u064A\u0640",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0627\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber) {
    return String(dirtyNumber);
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"kUneN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(ق|ب)/i,
    abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
    wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
};
var parseEraPatterns = {
    any: [
        /^قبل/i,
        /^بعد/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ر[1234]/i,
    wide: /^الربع [1234]/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[جفمأسند]/i,
    abbreviated: /^(جان|فيف|مار|أفر|ماي|جوا|جوي|أوت|سبت|أكت|نوف|ديس)/i,
    wide: /^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/i
};
var parseMonthPatterns = {
    narrow: [
        /^ج/i,
        /^ف/i,
        /^م/i,
        /^أ/i,
        /^م/i,
        /^ج/i,
        /^ج/i,
        /^أ/i,
        /^س/i,
        /^أ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^جان/i,
        /^فيف/i,
        /^مار/i,
        /^أفر/i,
        /^ماي/i,
        /^جوا/i,
        /^جوي/i,
        /^أوت/i,
        /^سبت/i,
        /^أكت/i,
        /^نوف/i,
        /^ديس/i
    ]
};
var matchDayPatterns = {
    narrow: /^[حنثرخجس]/i,
    short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    abbreviated: /^(أحد|اثن|ثلا|أرب|خمي|جمعة|سبت)/i,
    wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
var parseDayPatterns = {
    narrow: [
        /^ح/i,
        /^ن/i,
        /^ث/i,
        /^ر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ],
    wide: [
        /^الأحد/i,
        /^الاثنين/i,
        /^الثلاثاء/i,
        /^الأربعاء/i,
        /^الخميس/i,
        /^الجمعة/i,
        /^السبت/i
    ],
    any: [
        /^أح/i,
        /^اث/i,
        /^ث/i,
        /^أر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault1.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault1.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return Number(index) + 1;
        }
    }),
    month: (0, _indexJsDefault1.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault1.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault1.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchPatternFn/index.js":"2Mexa","../../../_lib/buildMatchFn/index.js":"7YCyk","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"60cMj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Arabic locale (Egypt).
 * @language Arabic
 * @iso-639-2 ara
 * @author AbdAllah AbdElFattah [@AbdAllahAbdElFattah13]{@link https://github.com/AbdAllahAbdElFattah13}
 */ var locale = {
    code: 'ar-EG',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"fQia2","./_lib/formatLong/index.js":"bd7RG","./_lib/formatRelative/index.js":"fV8xc","./_lib/localize/index.js":"bFOYd","./_lib/match/index.js":"jD71W","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"fQia2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629",
        two: "\u062B\u0627\u0646\u064A\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u064A\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u064A\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u062D\u0648\u0627\u0644\u064A \u0633\u0627\u0639\u0629",
        two: "\u062D\u0648\u0627\u0644\u064A \u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0633\u0627\u0639\u0629"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u064A\u0648\u0645",
        two: "\u064A\u0648\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u062D\u0648\u0627\u0644\u064A \u0623\u0633\u0628\u0648\u0639",
        two: "\u062D\u0648\u0627\u0644\u064A \u0623\u0633\u0628\u0648\u0639\u064A\u0646",
        threeToTen: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0623\u0633\u0628\u0648\u0639"
    },
    xWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639"
    },
    aboutXMonths: {
        one: "\u062D\u0648\u0627\u0644\u064A \u0634\u0647\u0631",
        two: "\u062D\u0648\u0627\u0644\u064A \u0634\u0647\u0631\u064A\u0646",
        threeToTen: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0623\u0634\u0647\u0631",
        other: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0634\u0647\u0631"
    },
    xMonths: {
        one: "\u0634\u0647\u0631",
        two: "\u0634\u0647\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631",
        other: "{{count}} \u0634\u0647\u0631"
    },
    aboutXYears: {
        one: "\u062D\u0648\u0627\u0644\u064A \u0633\u0646\u0629",
        two: "\u062D\u0648\u0627\u0644\u064A \u0633\u0646\u062A\u064A\u0646",
        threeToTen: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0633\u0646\u064A\u0646",
        other: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0633\u0646\u0629"
    },
    xYears: {
        one: "\u0639\u0627\u0645",
        two: "\u0639\u0627\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "{{count}} \u0639\u0627\u0645"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0633\u0646\u0629",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0633\u0646\u062A\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0633\u0646\u064A\u0646",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0633\u0646\u0629"
    },
    almostXYears: {
        one: "\u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u064B\u0627",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u064B\u0627",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u064B\u0627",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u064B\u0627"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2) result = tokenValue.two;
    else if (count <= 10) result = tokenValue.threeToTen.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0641\u064A \u062E\u0644\u0627\u0644 ".concat(result);
        else return "\u0645\u0646\u0630 ".concat(result);
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"bd7RG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE\u060C do MMMM y",
    long: 'do MMMM y',
    medium: 'dd/MMM/y',
    short: 'd/MM/y'
};
var timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var dateTimeFormats = {
    full: "{{date}} '\u0627\u0644\u0633\u0627\u0639\u0629' {{time}}",
    long: "{{date}} '\u0627\u0644\u0633\u0627\u0639\u0629' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"fV8xc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "eeee '\u0627\u0644\u0644\u064A \u062C\u0627\u064A \u0627\u0644\u0633\u0627\u0639\u0629' p",
    yesterday: "'\u0625\u0645\u0628\u0627\u0631\u062D \u0627\u0644\u0633\u0627\u0639\u0629' p",
    today: "'\u0627\u0644\u0646\u0647\u0627\u0631\u062F\u0629 \u0627\u0644\u0633\u0627\u0639\u0629' p",
    tomorrow: "'\u0628\u0643\u0631\u0629 \u0627\u0644\u0633\u0627\u0639\u0629' p",
    nextWeek: "eeee '\u0627\u0644\u0633\u0627\u0639\u0629' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"bFOYd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645",
        "\u0628.\u0645"
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
var monthValues = {
    narrow: [
        "\u064A",
        "\u0641",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u064A",
        "\u064A",
        "\u0623",
        "\u0633",
        "\u0623",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u064A\u0646\u0627",
        "\u0641\u0628\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u0640",
        "\u064A\u0648\u0644\u0640",
        "\u0623\u063A\u0633\u0640",
        "\u0633\u0628\u062A\u0640",
        "\u0623\u0643\u062A\u0640",
        "\u0646\u0648\u0641\u0640",
        "\u062F\u064A\u0633\u0640"
    ],
    wide: [
        "\u064A\u0646\u0627\u064A\u0631",
        "\u0641\u0628\u0631\u0627\u064A\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u064A\u0648",
        "\u064A\u0648\u0644\u064A\u0648",
        "\u0623\u063A\u0633\u0637\u0633",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ]
};
var dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0627\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631\u0627\u064B",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631\u0627\u064B",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631\u0627\u064B",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0638\u0647\u0631\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jD71W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)/;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(ق|ب)/g,
    abbreviated: /^(ق.م|ب.م)/g,
    wide: /^(قبل الميلاد|بعد الميلاد)/g
};
var parseEraPatterns = {
    any: [
        /^ق/g,
        /^ب/g
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/,
    abbreviated: /^ر[1234]/,
    wide: /^الربع (الأول|الثاني|الثالث|الرابع)/
};
var parseQuarterPatterns = {
    wide: [
        /الربع الأول/,
        /الربع الثاني/,
        /الربع الثالث/,
        /الربع الرابع/
    ],
    any: [
        /1/,
        /2/,
        /3/,
        /4/
    ]
};
var matchMonthPatterns = {
    narrow: /^(ي|ف|م|أ|س|ن|د)/,
    abbreviated: /^(ينا|فبر|مارس|أبريل|مايو|يونـ|يولـ|أغسـ|سبتـ|أكتـ|نوفـ|ديسـ)/,
    wide: /^(يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/
};
var parseMonthPatterns = {
    narrow: [
        /^ي/,
        /^ف/,
        /^م/,
        /^أ/,
        /^م/,
        /^ي/,
        /^ي/,
        /^أ/,
        /^س/,
        /^أ/,
        /^ن/,
        /^د/
    ],
    any: [
        /^ينا/,
        /^فبر/,
        /^مارس/,
        /^أبريل/,
        /^مايو/,
        /^يون/,
        /^يول/,
        /^أغس/,
        /^سبت/,
        /^أكت/,
        /^نوف/,
        /^ديس/
    ]
};
var matchDayPatterns = {
    narrow: /^(ح|ن|ث|ر|خ|ج|س)/,
    short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/,
    abbreviated: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/,
    wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/
};
var parseDayPatterns = {
    narrow: [
        /^ح/,
        /^ن/,
        /^ث/,
        /^ر/,
        /^خ/,
        /^ج/,
        /^س/
    ],
    any: [
        /أحد/,
        /اثنين/,
        /ثلاثاء/,
        /أربعاء/,
        /خميس/,
        /جمعة/,
        /سبت/
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(ص|م|ن|ظ|في الصباح|بعد الظهر|في المساء|في الليل)/,
    abbreviated: /^(ص|م|نصف الليل|ظهراً|في الصباح|بعد الظهر|في المساء|في الليل)/,
    wide: /^(ص|م|نصف الليل|في الصباح|ظهراً|بعد الظهر|في المساء|في الليل)/,
    any: /^(ص|م|صباح|ظهر|مساء|ليل)/
};
var parseDayPeriodPatterns = {
    any: {
        am: /^ص/,
        pm: /^م/,
        midnight: /^ن/,
        noon: /^ظ/,
        morning: /^ص/,
        afternoon: /^بعد/,
        evening: /^م/,
        night: /^ل/
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"a75sH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Arabic locale (Moroccan Arabic).
 * @language Moroccan Arabic
 * @iso-639-2 ara
 * @author Achraf Rrami [@rramiachraf]{@link https://github.com/rramiachraf}
 */ var locale = {
    code: 'ar-MA',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        // Monday is 1
        weekStartsOn: 1,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"7oAdJ","./_lib/formatLong/index.js":"f84Yl","./_lib/formatRelative/index.js":"92218","./_lib/localize/index.js":"5YGhX","./_lib/match/index.js":"eodPk","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7oAdJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635\u0641 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
        two: "\u064A\u0648\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639"
    },
    aboutXMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
        two: "\u0634\u0647\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631",
        other: "{{count}} \u0634\u0647\u0631"
    },
    aboutXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F",
        two: "\u0639\u0627\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "{{count}} \u0639\u0627\u0645"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0639\u0627\u0645"
    },
    almostXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    options = options || {};
    var usageGroup = formatDistanceLocale[token];
    var result;
    if (typeof usageGroup === 'string') result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else if (count === 2) result = usageGroup.two;
    else if (count <= 10) result = usageGroup.threeToTen.replace('{{count}}', String(count));
    else result = usageGroup.other.replace('{{count}}', String(count));
    if (options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0641\u064A \u062E\u0644\u0627\u0644 " + result;
        else return "\u0645\u0646\u0630 " + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"f84Yl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var dateTimeFormats = {
    full: "{{date}} '\u0639\u0646\u062F' {{time}}",
    long: "{{date}} '\u0639\u0646\u062F' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"92218":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'\u0623\u062E\u0631' eeee '\u0639\u0646\u062F' p",
    yesterday: "'\u0623\u0645\u0633 \u0639\u0646\u062F' p",
    today: "'\u0627\u0644\u064A\u0648\u0645 \u0639\u0646\u062F' p",
    tomorrow: "'\u063A\u062F\u0627\u064B \u0639\u0646\u062F' p",
    nextWeek: "eeee '\u0639\u0646\u062F' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5YGhX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
var monthValues = {
    narrow: [
        "\u064A",
        "\u0641",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u064A",
        "\u064A",
        "\u063A",
        "\u0634",
        "\u0623",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u064A\u0646\u0627",
        "\u0641\u0628\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A",
        "\u064A\u0648\u0646\u0640",
        "\u064A\u0648\u0644\u0640",
        "\u063A\u0634\u062A",
        "\u0634\u062A\u0646\u0640",
        "\u0623\u0643\u062A\u0640",
        "\u0646\u0648\u0646\u0640",
        "\u062F\u062C\u0646\u0640"
    ],
    wide: [
        "\u064A\u0646\u0627\u064A\u0631",
        "\u0641\u0628\u0631\u0627\u064A\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A",
        "\u064A\u0648\u0646\u064A\u0648",
        "\u064A\u0648\u0644\u064A\u0648\u0632",
        "\u063A\u0634\u062A",
        "\u0634\u062A\u0646\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0646\u0628\u0631",
        "\u062F\u062C\u0646\u0628\u0631"
    ]
};
var dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u0640",
        "\u062B\u0644\u0627",
        "\u0623\u0631\u0628\u0640",
        "\u062E\u0645\u064A\u0640",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0625\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber) {
    return String(dirtyNumber);
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"eodPk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(ق|ب)/i,
    abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
    wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
};
var parseEraPatterns = {
    any: [
        /^قبل/i,
        /^بعد/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ر[1234]/i,
    wide: /^الربع [1234]/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[يفمأمسند]/i,
    abbreviated: /^(ين|ف|مار|أب|ماي|يون|يول|غش|شت|أك|ن|د)/i,
    wide: /^(ين|ف|مار|أب|ماي|يون|يول|غش|شت|أك|ن|د)/i
};
var parseMonthPatterns = {
    narrow: [
        /^ي/i,
        /^ف/i,
        /^م/i,
        /^أ/i,
        /^م/i,
        /^ي/i,
        /^ي/i,
        /^غ/i,
        /^ش/i,
        /^أ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^ين/i,
        /^فب/i,
        /^مار/i,
        /^أب/i,
        /^ماي/i,
        /^يون/i,
        /^يول/i,
        /^غشت/i,
        /^ش/i,
        /^أك/i,
        /^ن/i,
        /^د/i
    ]
};
var matchDayPatterns = {
    narrow: /^[حنثرخجس]/i,
    short: /^(أحد|إثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    abbreviated: /^(أحد|إثن|ثلا|أرب|خمي|جمعة|سبت)/i,
    wide: /^(الأحد|الإثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
var parseDayPatterns = {
    narrow: [
        /^ح/i,
        /^ن/i,
        /^ث/i,
        /^ر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ],
    wide: [
        /^الأحد/i,
        /^الإثنين/i,
        /^الثلاثاء/i,
        /^الأربعاء/i,
        /^الخميس/i,
        /^الجمعة/i,
        /^السبت/i
    ],
    any: [
        /^أح/i,
        /^إث/i,
        /^ث/i,
        /^أر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault1.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault1.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return Number(index) + 1;
        }
    }),
    month: (0, _indexJsDefault1.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault1.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault1.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchPatternFn/index.js":"2Mexa","../../../_lib/buildMatchFn/index.js":"7YCyk","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"kWsMF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Arabic locale (Sauid Arabic).
 * @language Arabic
 * @iso-639-2 ara
 * @author Dhaifallah Alwadani [@dalwadani]{@link https://github.com/dalwadani}
 */ var locale = {
    code: 'ar-SA',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"hRaHu","./_lib/formatLong/index.js":"bNlxG","./_lib/formatRelative/index.js":"hg7Xv","./_lib/localize/index.js":"01mqm","./_lib/match/index.js":"W6uJJ","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"hRaHu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635\u0641 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
        two: "\u064A\u0648\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639"
    },
    aboutXMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
        two: "\u0634\u0647\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631",
        other: "{{count}} \u0634\u0647\u0631"
    },
    aboutXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F",
        two: "\u0639\u0627\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "{{count}} \u0639\u0627\u0645"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0639\u0627\u0645"
    },
    almostXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2) result = tokenValue.two;
    else if (count <= 10) result = tokenValue.threeToTen.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0641\u064A \u062E\u0644\u0627\u0644 " + result;
        else return "\u0645\u0646\u0630 " + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"bNlxG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var dateTimeFormats = {
    full: "{{date}} '\u0639\u0646\u062F' {{time}}",
    long: "{{date}} '\u0639\u0646\u062F' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"hg7Xv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'\u0623\u062E\u0631' eeee '\u0639\u0646\u062F' p",
    yesterday: "'\u0623\u0645\u0633 \u0639\u0646\u062F' p",
    today: "'\u0627\u0644\u064A\u0648\u0645 \u0639\u0646\u062F' p",
    tomorrow: "'\u063A\u062F\u0627\u064B \u0639\u0646\u062F' p",
    nextWeek: "eeee '\u0639\u0646\u062F' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"01mqm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
var monthValues = {
    narrow: [
        "\u064A",
        "\u0641",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u064A",
        "\u064A",
        "\u0623",
        "\u0633",
        "\u0623",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u064A\u0646\u0627",
        "\u0641\u0628\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u0640",
        "\u064A\u0648\u0644\u0640",
        "\u0623\u063A\u0633\u0640",
        "\u0633\u0628\u062A\u0640",
        "\u0623\u0643\u062A\u0640",
        "\u0646\u0648\u0641\u0640",
        "\u062F\u064A\u0633\u0640"
    ],
    wide: [
        "\u064A\u0646\u0627\u064A\u0631",
        "\u0641\u0628\u0631\u0627\u064A\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u064A\u0648",
        "\u064A\u0648\u0644\u064A\u0648",
        "\u0623\u063A\u0633\u0637\u0633",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ]
};
var dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u0640",
        "\u062B\u0644\u0627",
        "\u0623\u0631\u0628\u0640",
        "\u062E\u0645\u064A\u0640",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0627\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber) {
    return String(dirtyNumber);
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"W6uJJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(ق|ب)/i,
    abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
    wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
};
var parseEraPatterns = {
    any: [
        /^قبل/i,
        /^بعد/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ر[1234]/i,
    wide: /^الربع [1234]/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[يفمأمسند]/i,
    abbreviated: /^(ين|ف|مار|أب|ماي|يون|يول|أغ|س|أك|ن|د)/i,
    wide: /^(ين|ف|مار|أب|ماي|يون|يول|أغ|س|أك|ن|د)/i
};
var parseMonthPatterns = {
    narrow: [
        /^ي/i,
        /^ف/i,
        /^م/i,
        /^أ/i,
        /^م/i,
        /^ي/i,
        /^ي/i,
        /^أ/i,
        /^س/i,
        /^أ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^ين/i,
        /^ف/i,
        /^مار/i,
        /^أب/i,
        /^ماي/i,
        /^يون/i,
        /^يول/i,
        /^أغ/i,
        /^س/i,
        /^أك/i,
        /^ن/i,
        /^د/i
    ]
};
var matchDayPatterns = {
    narrow: /^[حنثرخجس]/i,
    short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    abbreviated: /^(أحد|اثن|ثلا|أرب|خمي|جمعة|سبت)/i,
    wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
var parseDayPatterns = {
    narrow: [
        /^ح/i,
        /^ن/i,
        /^ث/i,
        /^ر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ],
    wide: [
        /^الأحد/i,
        /^الاثنين/i,
        /^الثلاثاء/i,
        /^الأربعاء/i,
        /^الخميس/i,
        /^الجمعة/i,
        /^السبت/i
    ],
    any: [
        /^أح/i,
        /^اث/i,
        /^ث/i,
        /^أر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6G6CP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Arabic locale (Tunisian Arabic).
 * @language Arabic
 * @iso-639-2 ara
 * @author Koussay Haj Kacem [@essana3]{@link https://github.com/essana3}
 */ var locale = {
    code: 'ar-TN',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"ddldM","./_lib/formatLong/index.js":"eFHFN","./_lib/formatRelative/index.js":"dA8fG","./_lib/localize/index.js":"fn6iz","./_lib/match/index.js":"eAmpu","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"ddldM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u0632\u0648\u0632 \u062B\u0648\u0627\u0646\u064A",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629",
        two: "\u0632\u0648\u0632 \u062B\u0648\u0627\u0646\u064A",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u064A\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u064A\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
        threeToTen: "{{count}} \u0633\u0648\u0627\u064A\u0639 \u062A\u0642\u0631\u064A\u0628",
        other: "{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u0633\u0648\u0627\u064A\u0639",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u0646\u0647\u0627\u0631",
        two: "\u0646\u0647\u0627\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u062C\u0645\u0639\u0629 \u062A\u0642\u0631\u064A\u0628",
        two: "\u062C\u0645\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
        threeToTen: "{{count}} \u062C\u0645\u0627\u0639 \u062A\u0642\u0631\u064A\u0628",
        other: "{{count}} \u062C\u0645\u0639\u0629 \u062A\u0642\u0631\u064A\u0628"
    },
    xWeeks: {
        one: "\u062C\u0645\u0639\u0629",
        two: "\u062C\u0645\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062C\u0645\u0627\u0639",
        other: "{{count}} \u062C\u0645\u0639\u0629"
    },
    aboutXMonths: {
        one: "\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628",
        two: "\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631\u0629 \u062A\u0642\u0631\u064A\u0628",
        other: "{{count}} \u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628"
    },
    xMonths: {
        one: "\u0634\u0647\u0631",
        two: "\u0634\u0647\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631\u0629",
        other: "{{count}} \u0634\u0647\u0631"
    },
    aboutXYears: {
        one: "\u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628"
    },
    xYears: {
        one: "\u0639\u0627\u0645",
        two: "\u0639\u0627\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "{{count}} \u0639\u0627\u0645"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0639\u0627\u0645"
    },
    almostXYears: {
        one: "\u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var usageGroup = formatDistanceLocale[token];
    var result;
    if (typeof usageGroup === 'string') result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else if (count === 2) result = usageGroup.two;
    else if (count <= 10) result = usageGroup.threeToTen.replace('{{count}}', String(count));
    else result = usageGroup.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0641\u064A " + result;
        else return "\u0639\u0646\u062F\u0648 " + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"eFHFN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE\u060C do MMMM y",
    long: 'do MMMM y',
    medium: 'd MMM y',
    short: 'dd/MM/yyyy'
};
var timeFormats = {
    full: 'HH:mm:ss',
    long: 'HH:mm:ss',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} '\u0645\u0639' {{time}}",
    long: "{{date}} '\u0645\u0639' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"dA8fG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "eeee '\u0625\u0644\u064A \u0641\u0627\u062A \u0645\u0639' p",
    yesterday: "'\u0627\u0644\u0628\u0627\u0631\u062D \u0645\u0639' p",
    today: "'\u0627\u0644\u064A\u0648\u0645 \u0645\u0639' p",
    tomorrow: "'\u063A\u062F\u0648\u0629 \u0645\u0639' p",
    nextWeek: "eeee '\u0627\u0644\u062C\u0645\u0639\u0629 \u0627\u0644\u062C\u0627\u064A\u0629 \u0645\u0639' p '\u0646\u0647\u0627\u0631'",
    other: 'P'
};
var formatRelative = function formatRelative(token) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"fn6iz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
var monthValues = {
    narrow: [
        "\u062F",
        "\u0646",
        "\u0623",
        "\u0633",
        "\u0623",
        "\u062C",
        "\u062C",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u0641",
        "\u062C"
    ],
    abbreviated: [
        "\u062C\u0627\u0646\u0641\u064A",
        "\u0641\u064A\u0641\u0631\u064A",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0641\u0631\u064A\u0644",
        "\u0645\u0627\u064A",
        "\u062C\u0648\u0627\u0646",
        "\u062C\u0648\u064A\u0644\u064A\u0629",
        "\u0623\u0648\u062A",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ],
    wide: [
        "\u062C\u0627\u0646\u0641\u064A",
        "\u0641\u064A\u0641\u0631\u064A",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0641\u0631\u064A\u0644",
        "\u0645\u0627\u064A",
        "\u062C\u0648\u0627\u0646",
        "\u062C\u0648\u064A\u0644\u064A\u0629",
        "\u0623\u0648\u062A",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ]
};
var dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0627\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0641\u064A \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0641\u064A \u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0641\u064A \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0641\u064A \u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0641\u064A \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0641\u064A \u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
    }
};
var ordinalNumber = function ordinalNumber(num) {
    return String(num);
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"eAmpu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /[قب]/,
    abbreviated: /[قب]\.م\./,
    wide: /(قبل|بعد) الميلاد/
};
var parseEraPatterns = {
    any: [
        /قبل/,
        /بعد/
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /ر[1234]/,
    wide: /الربع (الأول|الثاني|الثالث|الرابع)/
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[جفمأسند]/,
    abbreviated: /^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/,
    wide: /^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/
};
var parseMonthPatterns = {
    narrow: [
        /^ج/i,
        /^ف/i,
        /^م/i,
        /^أ/i,
        /^م/i,
        /^ج/i,
        /^ج/i,
        /^أ/i,
        /^س/i,
        /^أ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^جانفي/i,
        /^فيفري/i,
        /^مارس/i,
        /^أفريل/i,
        /^ماي/i,
        /^جوان/i,
        /^جويلية/i,
        /^أوت/i,
        /^سبتمبر/i,
        /^أكتوبر/i,
        /^نوفمبر/i,
        /^ديسمبر/i
    ]
};
var matchDayPatterns = {
    narrow: /^[حنثرخجس]/i,
    short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    abbreviated: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
var parseDayPatterns = {
    narrow: [
        /^ح/i,
        /^ن/i,
        /^ث/i,
        /^ر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ],
    wide: [
        /^الأحد/i,
        /^الاثنين/i,
        /^الثلاثاء/i,
        /^الأربعاء/i,
        /^الخميس/i,
        /^الجمعة/i,
        /^السبت/i
    ],
    any: [
        /^أح/i,
        /^اث/i,
        /^ث/i,
        /^أر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(ص|ع|ن ل|ل|(في|مع) (صباح|قايلة|عشية|ليل))/,
    any: /^([صع]|نص الليل|قايلة|(في|مع) (صباح|قايلة|عشية|ليل))/
};
var parseDayPeriodPatterns = {
    any: {
        am: /^ص/,
        pm: /^ع/,
        midnight: /نص الليل/,
        noon: /قايلة/,
        afternoon: /بعد القايلة/,
        morning: /صباح/,
        evening: /عشية/,
        night: /ليل/
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault1.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault1.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault1.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault1.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault1.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchPatternFn/index.js":"2Mexa","../../../_lib/buildMatchFn/index.js":"7YCyk","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"KKqMC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Azerbaijani locale.
 * @language Azerbaijani
 * @iso-639-2 aze
 */ var locale = {
    code: 'az',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"heCM0","./_lib/formatLong/index.js":"hYDaq","./_lib/formatRelative/index.js":"aH3Q8","./_lib/localize/index.js":"9xnQf","./_lib/match/index.js":"a1Hpo","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"heCM0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "bir saniy\u0259d\u0259n az",
        other: "{{count}} bir saniy\u0259d\u0259n az"
    },
    xSeconds: {
        one: "1 saniy\u0259",
        other: "{{count}} saniy\u0259"
    },
    halfAMinute: "yar\u0131m d\u0259qiq\u0259",
    lessThanXMinutes: {
        one: "bir d\u0259qiq\u0259d\u0259n az",
        other: "{{count}} bir d\u0259qiq\u0259d\u0259n az"
    },
    xMinutes: {
        one: "bir d\u0259qiq\u0259",
        other: "{{count}} d\u0259qiq\u0259"
    },
    aboutXHours: {
        one: "t\u0259xmin\u0259n 1 saat",
        other: "t\u0259xmin\u0259n {{count}} saat"
    },
    xHours: {
        one: '1 saat',
        other: '{{count}} saat'
    },
    xDays: {
        one: "1 g\xfcn",
        other: "{{count}} g\xfcn"
    },
    aboutXWeeks: {
        one: "t\u0259xmin\u0259n 1 h\u0259ft\u0259",
        other: "t\u0259xmin\u0259n {{count}} h\u0259ft\u0259"
    },
    xWeeks: {
        one: "1 h\u0259ft\u0259",
        other: "{{count}} h\u0259ft\u0259"
    },
    aboutXMonths: {
        one: "t\u0259xmin\u0259n 1 ay",
        other: "t\u0259xmin\u0259n {{count}} ay"
    },
    xMonths: {
        one: '1 ay',
        other: '{{count}} ay'
    },
    aboutXYears: {
        one: "t\u0259xmin\u0259n 1 il",
        other: "t\u0259xmin\u0259n {{count}} il"
    },
    xYears: {
        one: '1 il',
        other: '{{count}} il'
    },
    overXYears: {
        one: "1 ild\u0259n \xe7ox",
        other: "{{count}} ild\u0259n \xe7ox"
    },
    almostXYears: {
        one: "dem\u0259k olar ki 1 il",
        other: "dem\u0259k olar ki {{count}} il"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + ' sonra';
        else return result + " \u0259vv\u0259l";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"hYDaq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE, do MMMM y 'il'",
    long: "do MMMM y 'il'",
    medium: "d MMM y 'il'",
    short: 'dd.MM.yyyy'
};
var timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var dateTimeFormats = {
    full: "{{date}} {{time}} - 'd\u0259'",
    long: "{{date}} {{time}} - 'd\u0259'",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"aH3Q8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'sonuncu' eeee p -'d\u0259'",
    yesterday: "'d\xfcn\u0259n' p -'d\u0259'",
    today: "'bug\xfcn' p -'d\u0259'",
    tomorrow: "'sabah' p -'d\u0259'",
    nextWeek: "eeee p -'d\u0259'",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"9xnQf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "e.\u0259",
        'b.e'
    ],
    abbreviated: [
        "e.\u0259",
        'b.e'
    ],
    wide: [
        "eram\u0131zdan \u0259vv\u0259l",
        'bizim era'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        '1ci kvartal',
        '2ci kvartal',
        "3c\xfc kvartal",
        "4c\xfc kvartal"
    ]
};
var monthValues = {
    narrow: [
        'Y',
        'F',
        'M',
        'A',
        'M',
        "\u0130",
        "\u0130",
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Yan',
        'Fev',
        'Mar',
        'Apr',
        'May',
        "\u0130yun",
        "\u0130yul",
        'Avq',
        'Sen',
        'Okt',
        'Noy',
        'Dek'
    ],
    wide: [
        'Yanvar',
        'Fevral',
        'Mart',
        'Aprel',
        'May',
        "\u0130yun",
        "\u0130yul",
        'Avqust',
        'Sentyabr',
        'Oktyabr',
        'Noyabr',
        'Dekabr'
    ]
};
var dayValues = {
    narrow: [
        'B.',
        'B.e',
        "\xc7.a",
        "\xc7.",
        'C.a',
        'C.',
        "\u015E."
    ],
    short: [
        'B.',
        'B.e',
        "\xc7.a",
        "\xc7.",
        'C.a',
        'C.',
        "\u015E."
    ],
    abbreviated: [
        'Baz',
        'Baz.e',
        "\xc7\u0259r.a",
        "\xc7\u0259r",
        "C\xfcm.a",
        "C\xfcm",
        "\u015E\u0259"
    ],
    wide: [
        'Bazar',
        "Bazar ert\u0259si",
        "\xc7\u0259r\u015F\u0259nb\u0259 ax\u015Fam\u0131",
        "\xc7\u0259r\u015F\u0259nb\u0259",
        "C\xfcm\u0259 ax\u015Fam\u0131",
        "C\xfcm\u0259",
        "\u015E\u0259nb\u0259"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: "gec\u0259yar\u0131",
        noon: "g\xfcn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xfcnd\xfcz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "gec\u0259yar\u0131",
        noon: "g\xfcn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xfcnd\xfcz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "gec\u0259yar\u0131",
        noon: "g\xfcn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xfcnd\xfcz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: "gec\u0259yar\u0131",
        noon: "g\xfcn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xfcnd\xfcz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "gec\u0259yar\u0131",
        noon: "g\xfcn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xfcnd\xfcz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "gec\u0259yar\u0131",
        noon: "g\xfcn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xfcnd\xfcz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
    }
};
var suffixes = {
    1: '-inci',
    5: '-inci',
    8: '-inci',
    70: '-inci',
    80: '-inci',
    2: '-nci',
    7: '-nci',
    20: '-nci',
    50: '-nci',
    3: "-\xfcnc\xfc",
    4: "-\xfcnc\xfc",
    100: "-\xfcnc\xfc",
    6: "-nc\u0131",
    9: '-uncu',
    10: '-uncu',
    30: '-uncu',
    60: "-\u0131nc\u0131",
    90: "-\u0131nc\u0131"
};
var getSuffix = function getSuffix(number) {
    if (number === 0) // special case for zero
    return number + "-\u0131nc\u0131";
    var a = number % 10;
    var b = number % 100 - a;
    var c = number >= 100 ? 100 : null;
    if (suffixes[a]) return suffixes[a];
    else if (suffixes[b]) return suffixes[b];
    else if (c !== null) return suffixes[c];
    return '';
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    var suffix = getSuffix(number);
    return number + suffix;
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"a1Hpo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(-?(ci|inci|nci|uncu|üncü|ncı))?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(b|a)$/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)$/i,
    wide: /^(bizim eradan əvvəl|bizim era)$/i
};
var parseEraPatterns = {
    any: [
        /^b$/i,
        /^(a|c)$/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]$/i,
    abbreviated: /^K[1234]$/i,
    wide: /^[1234](ci)? kvartal$/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[(?-i)yfmaisond]$/i,
    abbreviated: /^(Yan|Fev|Mar|Apr|May|İyun|İyul|Avq|Sen|Okt|Noy|Dek)$/i,
    wide: /^(Yanvar|Fevral|Mart|Aprel|May|İyun|İyul|Avgust|Sentyabr|Oktyabr|Noyabr|Dekabr)$/i
};
var parseMonthPatterns = {
    narrow: [
        /^[(?-i)y]$/i,
        /^[(?-i)f]$/i,
        /^[(?-i)m]$/i,
        /^[(?-i)a]$/i,
        /^[(?-i)m]$/i,
        /^[(?-i)i]$/i,
        /^[(?-i)i]$/i,
        /^[(?-i)a]$/i,
        /^[(?-i)s]$/i,
        /^[(?-i)o]$/i,
        /^[(?-i)n]$/i,
        /^[(?-i)d]$/i
    ],
    abbreviated: [
        /^Yan$/i,
        /^Fev$/i,
        /^Mar$/i,
        /^Apr$/i,
        /^May$/i,
        /^İyun$/i,
        /^İyul$/i,
        /^Avg$/i,
        /^Sen$/i,
        /^Okt$/i,
        /^Noy$/i,
        /^Dek$/i
    ],
    wide: [
        /^Yanvar$/i,
        /^Fevral$/i,
        /^Mart$/i,
        /^Aprel$/i,
        /^May$/i,
        /^İyun$/i,
        /^İyul$/i,
        /^Avgust$/i,
        /^Sentyabr$/i,
        /^Oktyabr$/i,
        /^Noyabr$/i,
        /^Dekabr$/i
    ]
};
var matchDayPatterns = {
    narrow: /^(B\.|B\.e|Ç\.a|Ç\.|C\.a|C\.|Ş\.)$/i,
    short: /^(B\.|B\.e|Ç\.a|Ç\.|C\.a|C\.|Ş\.)$/i,
    abbreviated: /^(Baz\.e|Çər|Çər\.a|Cüm|Cüm\.a|Şə)$/i,
    wide: /^(Bazar|Bazar ertəsi|Çərşənbə axşamı|Çərşənbə|Cümə axşamı|Cümə|Şənbə)$/i
};
var parseDayPatterns = {
    narrow: [
        /^B\.$/i,
        /^B\.e$/i,
        /^Ç\.a$/i,
        /^Ç\.$/i,
        /^C\.a$/i,
        /^C\.$/i,
        /^Ş\.$/i
    ],
    abbreviated: [
        /^Baz$/i,
        /^Baz\.e$/i,
        /^Çər\.a$/i,
        /^Çər$/i,
        /^Cüm\.a$/i,
        /^Cüm$/i,
        /^Şə$/i
    ],
    wide: [
        /^Bazar$/i,
        /^Bazar ertəsi$/i,
        /^Çərşənbə axşamı$/i,
        /^Çərşənbə$/i,
        /^Cümə axşamı$/i,
        /^Cümə$/i,
        /^Şənbə$/i
    ],
    any: [
        /^B\.$/i,
        /^B\.e$/i,
        /^Ç\.a$/i,
        /^Ç\.$/i,
        /^C\.a$/i,
        /^C\.$/i,
        /^Ş\.$/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|gecəyarı|gün|səhər|gündüz|axşam|gecə)$/i,
    any: /^(am|pm|a\.m\.|p\.m\.|AM|PM|gecəyarı|gün|səhər|gündüz|axşam|gecə)$/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a$/i,
        pm: /^p$/i,
        midnight: /^gecəyarı$/i,
        noon: /^gün$/i,
        morning: /səhər$/i,
        afternoon: /gündüz$/i,
        evening: /axşam$/i,
        night: /gecə$/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'narrow'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"c3Ei3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Belarusian locale.
 * @language Belarusian
 * @iso-639-2 bel
 * @author Kiryl Anokhin [@alyrik]{@link https://github.com/alyrik}
 * @author Martin Wind [@arvigeus]{@link https://github.com/mawi12345}
 */ var locale = {
    code: 'be',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"aLmVG","./_lib/formatLong/index.js":"5aMKf","./_lib/formatRelative/index.js":"cBMVi","./_lib/localize/index.js":"ceTW3","./_lib/match/index.js":"73oUq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"aLmVG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function declension(scheme, count) {
    // scheme for count=1 exists
    if (scheme.one !== undefined && count === 1) return scheme.one;
    var rem10 = count % 10;
    var rem100 = count % 100;
    // 1, 21, 31, ...
    if (rem10 === 1 && rem100 !== 11) return scheme.singularNominative.replace('{{count}}', String(count));
    else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) return scheme.singularGenitive.replace('{{count}}', String(count));
    else return scheme.pluralGenitive.replace('{{count}}', String(count));
}
function buildLocalizeTokenFn(scheme) {
    return function(count, options) {
        if (options && options.addSuffix) {
            if (options.comparison && options.comparison > 0) {
                if (scheme.future) return declension(scheme.future, count);
                else return "\u043F\u0440\u0430\u0437 " + declension(scheme.regular, count);
            } else {
                if (scheme.past) return declension(scheme.past, count);
                else return declension(scheme.regular, count) + " \u0442\u0430\u043C\u0443";
            }
        } else return declension(scheme.regular, count);
    };
}
var halfAMinute = function halfAMinute(_, options) {
    if (options && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u043F\u0440\u0430\u0437 \u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B";
        else return "\u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B \u0442\u0430\u043C\u0443";
    }
    return "\u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B";
};
var formatDistanceLocale = {
    lessThanXSeconds: buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448 \u0437\u0430 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    xSeconds: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        past: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0442\u0430\u043C\u0443"
        },
        future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    halfAMinute: halfAMinute,
    lessThanXMinutes: buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448 \u0437\u0430 \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        }
    }),
    xMinutes: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0430",
            singularGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        },
        past: {
            singularNominative: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D \u0442\u0430\u043C\u0443"
        },
        future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        }
    }),
    aboutXHours: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        }
    }),
    xHours: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0430",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        },
        past: {
            singularNominative: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D \u0442\u0430\u043C\u0443"
        },
        future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        }
    }),
    xDays: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0434\u0437\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0434\u043D\u0456",
            pluralGenitive: "{{count}} \u0434\u0437\u0451\u043D"
        }
    }),
    aboutXWeeks: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            // TODO
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E",
            // TODO
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E" // TODO
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446",
            // TODO
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            // TODO
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E" // TODO
        }
    }),
    xWeeks: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            pluralGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        }
    }),
    aboutXMonths: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        }
    }),
    xMonths: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            pluralGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        }
    }),
    aboutXYears: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u0433\u043E\u0434\u0430",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u043E\u045E",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    }),
    xYears: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u043E\u0434",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    }),
    overXYears: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    }),
    almostXYears: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
            singularNominative: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    })
};
var formatDistance = function formatDistance(token, count, options) {
    options = options || {};
    return formatDistanceLocale[token](count, options);
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5aMKf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE, d MMMM y '\u0433.'",
    long: "d MMMM y '\u0433.'",
    medium: "d MMM y '\u0433.'",
    short: 'dd.MM.y'
};
var timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var dateTimeFormats = {
    any: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'any'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"cBMVi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../../index.js");
var _indexJs1 = require("../../../../_lib/isSameUTCWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs1);
var accusativeWeekdays = [
    "\u043D\u044F\u0434\u0437\u0435\u043B\u044E",
    "\u043F\u0430\u043D\u044F\u0434\u0437\u0435\u043B\u0430\u043A",
    "\u0430\u045E\u0442\u043E\u0440\u0430\u043A",
    "\u0441\u0435\u0440\u0430\u0434\u0443",
    "\u0447\u0430\u0446\u0432\u0435\u0440",
    "\u043F\u044F\u0442\u043D\u0456\u0446\u0443",
    "\u0441\u0443\u0431\u043E\u0442\u0443"
];
function lastWeek(day) {
    var weekday = accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043C\u0456\u043D\u0443\u043B\u0443\u044E " + weekday + " \u0430' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043C\u0456\u043D\u0443\u043B\u044B " + weekday + " \u0430' p";
    }
}
function thisWeek(day) {
    var weekday = accusativeWeekdays[day];
    return "'\u0443 " + weekday + " \u0430' p";
}
function nextWeek(day) {
    var weekday = accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0443\u044E " + weekday + " \u0430' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u044B " + weekday + " \u0430' p";
    }
}
var lastWeekFormat = function lastWeekFormat(dirtyDate, baseDate, options) {
    var date = (0, _indexJs.toDate)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, _indexJsDefault.default)(date, baseDate, options)) return thisWeek(day);
    else return lastWeek(day);
};
var nextWeekFormat = function nextWeekFormat(dirtyDate, baseDate, options) {
    var date = (0, _indexJs.toDate)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, _indexJsDefault.default)(date, baseDate, options)) return thisWeek(day);
    else return nextWeek(day);
};
var formatRelativeLocale = {
    lastWeek: lastWeekFormat,
    yesterday: "'\u0443\u0447\u043E\u0440\u0430 \u0430' p",
    today: "'\u0441\u0451\u043D\u043D\u044F \u0430' p",
    tomorrow: "'\u0437\u0430\u045E\u0442\u0440\u0430 \u0430' p",
    nextWeek: nextWeekFormat,
    other: 'P'
};
var formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
exports.default = formatRelative;

},{"../../../../index.js":"gBKRn","../../../../_lib/isSameUTCWeek/index.js":"g7rCW","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"g7rCW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isSameUTCWeek;
});
var _indexJs = require("../requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfUTCWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isSameUTCWeek(dirtyDateLeft, dirtyDateRight, options) {
    (0, _indexJsDefault.default)(2, arguments);
    var dateLeftStartOfWeek = (0, _indexJsDefault1.default)(dirtyDateLeft, options);
    var dateRightStartOfWeek = (0, _indexJsDefault1.default)(dirtyDateRight, options);
    return dateLeftStartOfWeek.getTime() === dateRightStartOfWeek.getTime();
}

},{"../requiredArgs/index.js":"14prD","../startOfUTCWeek/index.js":"cCeyA","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"ceTW3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u0434\u0430 \u043D.\u044D.",
        "\u043D.\u044D."
    ],
    abbreviated: [
        "\u0434\u0430 \u043D. \u044D.",
        "\u043D. \u044D."
    ],
    wide: [
        "\u0434\u0430 \u043D\u0430\u0448\u0430\u0439 \u044D\u0440\u044B",
        "\u043D\u0430\u0448\u0430\u0439 \u044D\u0440\u044B"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1-\u044B \u043A\u0432.",
        "2-\u0456 \u043A\u0432.",
        "3-\u0456 \u043A\u0432.",
        "4-\u044B \u043A\u0432."
    ],
    wide: [
        "1-\u044B \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2-\u0456 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3-\u0456 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4-\u044B \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
var monthValues = {
    narrow: [
        "\u0421",
        "\u041B",
        "\u0421",
        "\u041A",
        "\u041C",
        "\u0427",
        "\u041B",
        "\u0416",
        "\u0412",
        "\u041A",
        "\u041B",
        "\u0421"
    ],
    abbreviated: [
        "\u0441\u0442\u0443\u0434\u0437.",
        "\u043B\u044E\u0442.",
        "\u0441\u0430\u043A.",
        "\u043A\u0440\u0430\u0441.",
        "\u043C\u0430\u0439",
        "\u0447\u044D\u0440\u0432.",
        "\u043B\u0456\u043F.",
        "\u0436\u043D.",
        "\u0432\u0435\u0440.",
        "\u043A\u0430\u0441\u0442\u0440.",
        "\u043B\u0456\u0441\u0442.",
        "\u0441\u043D\u0435\u0436."
    ],
    wide: [
        "\u0441\u0442\u0443\u0434\u0437\u0435\u043D\u044C",
        "\u043B\u044E\u0442\u044B",
        "\u0441\u0430\u043A\u0430\u0432\u0456\u043A",
        "\u043A\u0440\u0430\u0441\u0430\u0432\u0456\u043A",
        "\u043C\u0430\u0439",
        "\u0447\u044D\u0440\u0432\u0435\u043D\u044C",
        "\u043B\u0456\u043F\u0435\u043D\u044C",
        "\u0436\u043D\u0456\u0432\u0435\u043D\u044C",
        "\u0432\u0435\u0440\u0430\u0441\u0435\u043D\u044C",
        "\u043A\u0430\u0441\u0442\u0440\u044B\u0447\u043D\u0456\u043A",
        "\u043B\u0456\u0441\u0442\u0430\u043F\u0430\u0434",
        "\u0441\u043D\u0435\u0436\u0430\u043D\u044C"
    ]
};
var formattingMonthValues = {
    narrow: [
        "\u0421",
        "\u041B",
        "\u0421",
        "\u041A",
        "\u041C",
        "\u0427",
        "\u041B",
        "\u0416",
        "\u0412",
        "\u041A",
        "\u041B",
        "\u0421"
    ],
    abbreviated: [
        "\u0441\u0442\u0443\u0434\u0437.",
        "\u043B\u044E\u0442.",
        "\u0441\u0430\u043A.",
        "\u043A\u0440\u0430\u0441.",
        "\u043C\u0430\u044F",
        "\u0447\u044D\u0440\u0432.",
        "\u043B\u0456\u043F.",
        "\u0436\u043D.",
        "\u0432\u0435\u0440.",
        "\u043A\u0430\u0441\u0442\u0440.",
        "\u043B\u0456\u0441\u0442.",
        "\u0441\u043D\u0435\u0436."
    ],
    wide: [
        "\u0441\u0442\u0443\u0434\u0437\u0435\u043D\u044F",
        "\u043B\u044E\u0442\u0430\u0433\u0430",
        "\u0441\u0430\u043A\u0430\u0432\u0456\u043A\u0430",
        "\u043A\u0440\u0430\u0441\u0430\u0432\u0456\u043A\u0430",
        "\u043C\u0430\u044F",
        "\u0447\u044D\u0440\u0432\u0435\u043D\u044F",
        "\u043B\u0456\u043F\u0435\u043D\u044F",
        "\u0436\u043D\u0456\u045E\u043D\u044F",
        "\u0432\u0435\u0440\u0430\u0441\u043D\u044F",
        "\u043A\u0430\u0441\u0442\u0440\u044B\u0447\u043D\u0456\u043A\u0430",
        "\u043B\u0456\u0441\u0442\u0430\u043F\u0430\u0434\u0430",
        "\u0441\u043D\u0435\u0436\u043D\u044F"
    ]
};
var dayValues = {
    narrow: [
        "\u041D",
        "\u041F",
        "\u0410",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u043D\u0434",
        "\u043F\u043D",
        "\u0430\u045E",
        "\u0441\u0440",
        "\u0447\u0446",
        "\u043F\u0442",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u043D\u044F\u0434\u0437",
        "\u043F\u0430\u043D",
        "\u0430\u045E\u0442",
        "\u0441\u0435\u0440",
        "\u0447\u0430\u0446",
        "\u043F\u044F\u0442",
        "\u0441\u0443\u0431"
    ],
    wide: [
        "\u043D\u044F\u0434\u0437\u0435\u043B\u044F",
        "\u043F\u0430\u043D\u044F\u0434\u0437\u0435\u043B\u0430\u043A",
        "\u0430\u045E\u0442\u043E\u0440\u0430\u043A",
        "\u0441\u0435\u0440\u0430\u0434\u0430",
        "\u0447\u0430\u0446\u0432\u0435\u0440",
        "\u043F\u044F\u0442\u043D\u0456\u0446\u0430",
        "\u0441\u0443\u0431\u043E\u0442\u0430"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D\u0430\u0447",
        noon: "\u043F\u043E\u045E\u0434\u0437\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u0456\u0446\u0430",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447\u0430\u0440",
        night: "\u043D\u043E\u0447"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044B"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044B"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D\u0430\u0447",
        noon: "\u043F\u043E\u045E\u0434\u0437\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u0456\u0446\u044B",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447\u0430\u0440\u0430",
        night: "\u043D\u043E\u0447\u044B"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var unit = String(options === null || options === void 0 ? void 0 : options.unit);
    var number = Number(dirtyNumber);
    var suffix;
    /** Though it's an incorrect ordinal form of a date we use it here for consistency with other similar locales (ru, uk)
   *  For date-month combinations should be used `d` formatter.
   *  Correct:   `d MMMM` (4 верасня)
   *  Incorrect: `do MMMM` (4-га верасня)
   *
   *  But following the consistency leads to mistakes for literal uses of `do` formatter (ordinal day of month).
   *  So for phrase "5th day of month" (`do дзень месяца`)
   *  library will produce:            `5-га дзень месяца`
   *  but correct spelling should be:  `5-ы дзень месяца`
   *
   *  So I guess there should be a stand-alone and a formatting version of "day of month" formatters
   */ if (unit === 'date') suffix = "-\u0433\u0430";
    else if (unit === 'hour' || unit === 'minute' || unit === 'second') suffix = "-\u044F";
    else suffix = (number % 10 === 2 || number % 10 === 3) && number % 100 !== 12 && number % 100 !== 13 ? "-\u0456" : "-\u044B";
    return number + suffix;
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide',
        formattingValues: formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'any',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"73oUq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(-?(е|я|га|і|ы|ае|ая|яя|шы|гі|ці|ты|мы))?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^((да )?н\.?\s?э\.?)/i,
    abbreviated: /^((да )?н\.?\s?э\.?)/i,
    wide: /^(да нашай эры|нашай эры|наша эра)/i
};
var parseEraPatterns = {
    any: [
        /^д/i,
        /^н/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[ыі]?)? кв.?/i,
    wide: /^[1234](-?[ыі]?)? квартал/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[слкмчжв]/i,
    abbreviated: /^(студз|лют|сак|крас|ма[йя]|чэрв|ліп|жн|вер|кастр|ліст|снеж)\.?/i,
    wide: /^(студзен[ья]|лют(ы|ага)|сакавіка?|красавіка?|ма[йя]|чэрвен[ья]|ліпен[ья]|жні(вень|ўня)|верас(ень|ня)|кастрычніка?|лістапада?|снеж(ань|ня))/i
};
var parseMonthPatterns = {
    narrow: [
        /^с/i,
        /^л/i,
        /^с/i,
        /^к/i,
        /^м/i,
        /^ч/i,
        /^л/i,
        /^ж/i,
        /^в/i,
        /^к/i,
        /^л/i,
        /^с/i
    ],
    any: [
        /^ст/i,
        /^лю/i,
        /^са/i,
        /^кр/i,
        /^ма/i,
        /^ч/i,
        /^ліп/i,
        /^ж/i,
        /^в/i,
        /^ка/i,
        /^ліс/i,
        /^сн/i
    ]
};
var matchDayPatterns = {
    narrow: /^[нпасч]/i,
    short: /^(нд|ня|пн|па|аў|ат|ср|се|чц|ча|пт|пя|сб|су)\.?/i,
    abbreviated: /^(нядз?|ндз|пнд|пан|аўт|срд|сер|чцв|чац|птн|пят|суб).?/i,
    wide: /^(нядзел[яі]|панядзел(ак|ка)|аўтор(ак|ка)|серад[аы]|чацв(ер|ярга)|пятніц[аы]|субот[аы])/i
};
var parseDayPatterns = {
    narrow: [
        /^н/i,
        /^п/i,
        /^а/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^н/i,
        /^п[ан]/i,
        /^а/i,
        /^с[ер]/i,
        /^ч/i,
        /^п[ят]/i,
        /^с[уб]/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
    abbreviated: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
    wide: /^([дп]п|поўнач|поўдзень|раніц[аы]|дзень|дня|вечара?|ночы?)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^дп/i,
        pm: /^пп/i,
        midnight: /^поўн/i,
        noon: /^поўд/i,
        morning: /^р/i,
        afternoon: /^д[зн]/i,
        evening: /^в/i,
        night: /^н/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6uHFq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Belarusian Classic locale.
 * @language Belarusian Classic
 * @iso-639-2 bel
 * @author Ryhor Nopears [@nopears]{@link https://github.com/nopears}
 */ var locale = {
    code: 'be-tarask',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"blb23","./_lib/formatLong/index.js":"biGzD","./_lib/formatRelative/index.js":"jWAEH","./_lib/localize/index.js":"kyMoE","./_lib/match/index.js":"jy5Ro","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"blb23":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function declension(scheme, count) {
    // scheme for count=1 exists
    if (scheme.one !== undefined && count === 1) return scheme.one;
    var rem10 = count % 10;
    var rem100 = count % 100;
    // 1, 21, 31, ...
    if (rem10 === 1 && rem100 !== 11) return scheme.singularNominative.replace('{{count}}', String(count));
    else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) return scheme.singularGenitive.replace('{{count}}', String(count));
    else return scheme.pluralGenitive.replace('{{count}}', String(count));
}
function buildLocalizeTokenFn(scheme) {
    return function(count, options) {
        if (options && options.addSuffix) {
            if (options.comparison && options.comparison > 0) {
                if (scheme.future) return declension(scheme.future, count);
                else return "\u043F\u0440\u0430\u0437 " + declension(scheme.regular, count);
            } else {
                if (scheme.past) return declension(scheme.past, count);
                else return declension(scheme.regular, count) + " \u0442\u0430\u043C\u0443";
            }
        } else return declension(scheme.regular, count);
    };
}
var halfAMinute = function halfAMinute(_, options) {
    if (options && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u043F\u0440\u0430\u0437 \u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B";
        else return "\u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B \u0442\u0430\u043C\u0443";
    }
    return "\u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B";
};
var formatDistanceLocale = {
    lessThanXSeconds: buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448 \u0437\u0430 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    xSeconds: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        past: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0442\u0430\u043C\u0443"
        },
        future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    halfAMinute: halfAMinute,
    lessThanXMinutes: buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448 \u0437\u0430 \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        }
    }),
    xMinutes: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0430",
            singularGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        },
        past: {
            singularNominative: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D \u0442\u0430\u043C\u0443"
        },
        future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        }
    }),
    aboutXHours: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        }
    }),
    xHours: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0430",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        },
        past: {
            singularNominative: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D \u0442\u0430\u043C\u0443"
        },
        future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        }
    }),
    xDays: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0434\u0437\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0434\u043D\u0456",
            pluralGenitive: "{{count}} \u0434\u0437\u0451\u043D"
        }
    }),
    aboutXWeeks: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            // TODO
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E",
            // TODO
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E" // TODO
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446",
            // TODO
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            // TODO
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E" // TODO
        }
    }),
    xWeeks: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            pluralGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        }
    }),
    aboutXMonths: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        }
    }),
    xMonths: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            pluralGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        }
    }),
    aboutXYears: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u0433\u043E\u0434\u0430",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u043E\u045E",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    }),
    xYears: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u043E\u0434",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    }),
    overXYears: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    }),
    almostXYears: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
            singularNominative: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    })
};
var formatDistance = function formatDistance(token, count, options) {
    options = options || {};
    return formatDistanceLocale[token](count, options);
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"biGzD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE, d MMMM y '\u0433.'",
    long: "d MMMM y '\u0433.'",
    medium: "d MMM y '\u0433.'",
    short: 'dd.MM.y'
};
var timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var dateTimeFormats = {
    any: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'any'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jWAEH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../../index.js");
var _indexJs1 = require("../../../../_lib/isSameUTCWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs1);
var accusativeWeekdays = [
    "\u043D\u044F\u0434\u0437\u0435\u043B\u044E",
    "\u043F\u0430\u043D\u044F\u0434\u0437\u0435\u043B\u0430\u043A",
    "\u0430\u045E\u0442\u043E\u0440\u0430\u043A",
    "\u0441\u0435\u0440\u0430\u0434\u0443",
    "\u0447\u0430\u0446\u044C\u0432\u0435\u0440",
    "\u043F\u044F\u0442\u043D\u0456\u0446\u0443",
    "\u0441\u0443\u0431\u043E\u0442\u0443"
];
function lastWeek(day) {
    var weekday = accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043C\u0456\u043D\u0443\u043B\u0443\u044E " + weekday + " \u0430' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043C\u0456\u043D\u0443\u043B\u044B " + weekday + " \u0430' p";
    }
}
function thisWeek(day) {
    var weekday = accusativeWeekdays[day];
    return "'\u0443 " + weekday + " \u0430' p";
}
function nextWeek(day) {
    var weekday = accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0443\u044E " + weekday + " \u0430' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u044B " + weekday + " \u0430' p";
    }
}
var lastWeekFormat = function lastWeekFormat(dirtyDate, baseDate, options) {
    var date = (0, _indexJs.toDate)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, _indexJsDefault.default)(date, baseDate, options)) return thisWeek(day);
    else return lastWeek(day);
};
var nextWeekFormat = function nextWeekFormat(dirtyDate, baseDate, options) {
    var date = (0, _indexJs.toDate)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, _indexJsDefault.default)(date, baseDate, options)) return thisWeek(day);
    else return nextWeek(day);
};
var formatRelativeLocale = {
    lastWeek: lastWeekFormat,
    yesterday: "'\u0443\u0447\u043E\u0440\u0430 \u0430' p",
    today: "'\u0441\u0451\u043D\u044C\u043D\u044F \u0430' p",
    tomorrow: "'\u0437\u0430\u045E\u0442\u0440\u0430 \u0430' p",
    nextWeek: nextWeekFormat,
    other: 'P'
};
var formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
exports.default = formatRelative;

},{"../../../../index.js":"gBKRn","../../../../_lib/isSameUTCWeek/index.js":"g7rCW","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"kyMoE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u0434\u0430 \u043D.\u044D.",
        "\u043D.\u044D."
    ],
    abbreviated: [
        "\u0434\u0430 \u043D. \u044D.",
        "\u043D. \u044D."
    ],
    wide: [
        "\u0434\u0430 \u043D\u0430\u0448\u0430\u0439 \u044D\u0440\u044B",
        "\u043D\u0430\u0448\u0430\u0439 \u044D\u0440\u044B"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1-\u044B \u043A\u0432.",
        "2-\u0456 \u043A\u0432.",
        "3-\u0456 \u043A\u0432.",
        "4-\u044B \u043A\u0432."
    ],
    wide: [
        "1-\u044B \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2-\u0456 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3-\u0456 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4-\u044B \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
var monthValues = {
    narrow: [
        "\u0421",
        "\u041B",
        "\u0421",
        "\u041A",
        "\u0422",
        "\u0427",
        "\u041B",
        "\u0416",
        "\u0412",
        "\u041A",
        "\u041B",
        "\u0421"
    ],
    abbreviated: [
        "\u0441\u0442\u0443\u0434\u0437.",
        "\u043B\u044E\u0442.",
        "\u0441\u0430\u043A.",
        "\u043A\u0440\u0430\u0441.",
        "\u0442\u0440\u0430\u0432.",
        "\u0447\u044D\u0440\u0432.",
        "\u043B\u0456\u043F.",
        "\u0436\u043D.",
        "\u0432\u0435\u0440.",
        "\u043A\u0430\u0441\u0442\u0440.",
        "\u043B\u0456\u0441\u0442.",
        "\u0441\u044C\u043D\u0435\u0436."
    ],
    wide: [
        "\u0441\u0442\u0443\u0434\u0437\u0435\u043D\u044C",
        "\u043B\u044E\u0442\u044B",
        "\u0441\u0430\u043A\u0430\u0432\u0456\u043A",
        "\u043A\u0440\u0430\u0441\u0430\u0432\u0456\u043A",
        "\u0442\u0440\u0430\u0432\u0435\u043D\u044C",
        "\u0447\u044D\u0440\u0432\u0435\u043D\u044C",
        "\u043B\u0456\u043F\u0435\u043D\u044C",
        "\u0436\u043D\u0456\u0432\u0435\u043D\u044C",
        "\u0432\u0435\u0440\u0430\u0441\u0435\u043D\u044C",
        "\u043A\u0430\u0441\u0442\u0440\u044B\u0447\u043D\u0456\u043A",
        "\u043B\u0456\u0441\u0442\u0430\u043F\u0430\u0434",
        "\u0441\u044C\u043D\u0435\u0436\u0430\u043D\u044C"
    ]
};
var formattingMonthValues = {
    narrow: [
        "\u0421",
        "\u041B",
        "\u0421",
        "\u041A",
        "\u0422",
        "\u0427",
        "\u041B",
        "\u0416",
        "\u0412",
        "\u041A",
        "\u041B",
        "\u0421"
    ],
    abbreviated: [
        "\u0441\u0442\u0443\u0434\u0437.",
        "\u043B\u044E\u0442.",
        "\u0441\u0430\u043A.",
        "\u043A\u0440\u0430\u0441.",
        "\u0442\u0440\u0430\u0432.",
        "\u0447\u044D\u0440\u0432.",
        "\u043B\u0456\u043F.",
        "\u0436\u043D.",
        "\u0432\u0435\u0440.",
        "\u043A\u0430\u0441\u0442\u0440.",
        "\u043B\u0456\u0441\u0442.",
        "\u0441\u044C\u043D\u0435\u0436."
    ],
    wide: [
        "\u0441\u0442\u0443\u0434\u0437\u0435\u043D\u044F",
        "\u043B\u044E\u0442\u0430\u0433\u0430",
        "\u0441\u0430\u043A\u0430\u0432\u0456\u043A\u0430",
        "\u043A\u0440\u0430\u0441\u0430\u0432\u0456\u043A\u0430",
        "\u0442\u0440\u0430\u045E\u043D\u044F",
        "\u0447\u044D\u0440\u0432\u0435\u043D\u044F",
        "\u043B\u0456\u043F\u0435\u043D\u044F",
        "\u0436\u043D\u0456\u045E\u043D\u044F",
        "\u0432\u0435\u0440\u0430\u0441\u043D\u044F",
        "\u043A\u0430\u0441\u0442\u0440\u044B\u0447\u043D\u0456\u043A\u0430",
        "\u043B\u0456\u0441\u0442\u0430\u043F\u0430\u0434\u0430",
        "\u0441\u044C\u043D\u0435\u0436\u043D\u044F"
    ]
};
var dayValues = {
    narrow: [
        "\u041D",
        "\u041F",
        "\u0410",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u043D\u0434",
        "\u043F\u043D",
        "\u0430\u045E",
        "\u0441\u0440",
        "\u0447\u0446",
        "\u043F\u0442",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u043D\u044F\u0434\u0437",
        "\u043F\u0430\u043D",
        "\u0430\u045E\u0442",
        "\u0441\u0435\u0440",
        "\u0447\u0430\u0446\u044C",
        "\u043F\u044F\u0442",
        "\u0441\u0443\u0431"
    ],
    wide: [
        "\u043D\u044F\u0434\u0437\u0435\u043B\u044F",
        "\u043F\u0430\u043D\u044F\u0434\u0437\u0435\u043B\u0430\u043A",
        "\u0430\u045E\u0442\u043E\u0440\u0430\u043A",
        "\u0441\u0435\u0440\u0430\u0434\u0430",
        "\u0447\u0430\u0446\u044C\u0432\u0435\u0440",
        "\u043F\u044F\u0442\u043D\u0456\u0446\u0430",
        "\u0441\u0443\u0431\u043E\u0442\u0430"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D\u0430\u0447",
        noon: "\u043F\u043E\u045E\u0434\u0437\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u0456\u0446\u0430",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447\u0430\u0440",
        night: "\u043D\u043E\u0447"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044B"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044B"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D\u0430\u0447",
        noon: "\u043F\u043E\u045E\u0434\u0437\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u0456\u0446\u044B",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447\u0430\u0440\u0430",
        night: "\u043D\u043E\u0447\u044B"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var unit = String(options === null || options === void 0 ? void 0 : options.unit);
    var number = Number(dirtyNumber);
    var suffix;
    /** Though it's an incorrect ordinal form of a date we use it here for consistency with other similar locales (ru, uk)
   *  For date-month combinations should be used `d` formatter.
   *  Correct:   `d MMMM` (4 верасня)
   *  Incorrect: `do MMMM` (4-га верасня)
   *
   *  But following the consistency leads to mistakes for literal uses of `do` formatter (ordinal day of month).
   *  So for phrase "5th day of month" (`do дзень месяца`)
   *  library will produce:            `5-га дзень месяца`
   *  but correct spelling should be:  `5-ы дзень месяца`
   *
   *  So I guess there should be a stand-alone and a formatting version of "day of month" formatters
   */ if (unit === 'date') suffix = "-\u0433\u0430";
    else if (unit === 'hour' || unit === 'minute' || unit === 'second') suffix = "-\u044F";
    else suffix = (number % 10 === 2 || number % 10 === 3) && number % 100 !== 12 && number % 100 !== 13 ? "-\u0456" : "-\u044B";
    return number + suffix;
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide',
        formattingValues: formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'any',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jy5Ro":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(-?(е|я|га|і|ы|ае|ая|яя|шы|гі|ці|ты|мы))?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^((да )?н\.?\s?э\.?)/i,
    abbreviated: /^((да )?н\.?\s?э\.?)/i,
    wide: /^(да нашай эры|нашай эры|наша эра)/i
};
var parseEraPatterns = {
    any: [
        /^д/i,
        /^н/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[ыі]?)? кв.?/i,
    wide: /^[1234](-?[ыі]?)? квартал/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[слкмчжв]/i,
    abbreviated: /^(студз|лют|сак|крас|тр(ав)?|чэрв|ліп|жн|вер|кастр|ліст|сьнеж)\.?/i,
    wide: /^(студзен[ья]|лют(ы|ага)|сакавіка?|красавіка?|тра(вень|ўня)|чэрвен[ья]|ліпен[ья]|жні(вень|ўня)|верас(ень|ня)|кастрычніка?|лістапада?|сьнеж(ань|ня))/i
};
var parseMonthPatterns = {
    narrow: [
        /^с/i,
        /^л/i,
        /^с/i,
        /^к/i,
        /^т/i,
        /^ч/i,
        /^л/i,
        /^ж/i,
        /^в/i,
        /^к/i,
        /^л/i,
        /^с/i
    ],
    any: [
        /^ст/i,
        /^лю/i,
        /^са/i,
        /^кр/i,
        /^тр/i,
        /^ч/i,
        /^ліп/i,
        /^ж/i,
        /^в/i,
        /^ка/i,
        /^ліс/i,
        /^сн/i
    ]
};
var matchDayPatterns = {
    narrow: /^[нпасч]/i,
    short: /^(нд|ня|пн|па|аў|ат|ср|се|чц|ча|пт|пя|сб|су)\.?/i,
    abbreviated: /^(нядз?|ндз|пнд|пан|аўт|срд|сер|чцьв|чаць|птн|пят|суб).?/i,
    wide: /^(нядзел[яі]|панядзел(ак|ка)|аўтор(ак|ка)|серад[аы]|чацьв(ер|ярга)|пятніц[аы]|субот[аы])/i
};
var parseDayPatterns = {
    narrow: [
        /^н/i,
        /^п/i,
        /^а/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^н/i,
        /^п[ан]/i,
        /^а/i,
        /^с[ер]/i,
        /^ч/i,
        /^п[ят]/i,
        /^с[уб]/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
    abbreviated: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
    wide: /^([дп]п|поўнач|поўдзень|раніц[аы]|дзень|дня|вечара?|ночы?)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^дп/i,
        pm: /^пп/i,
        midnight: /^поўн/i,
        noon: /^поўд/i,
        morning: /^р/i,
        afternoon: /^д[зн]/i,
        evening: /^в/i,
        night: /^н/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"i2afB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Bulgarian locale.
 * @language Bulgarian
 * @iso-639-2 bul
 * @author Nikolay Stoynov [@arvigeus]{@link https://github.com/arvigeus}
 * @author Tsvetan Ovedenski [@fintara]{@link https://github.com/fintara}
 */ var locale = {
    code: 'bg',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"decW5","./_lib/formatLong/index.js":"fK1Zt","./_lib/formatRelative/index.js":"gJLhs","./_lib/localize/index.js":"7UC2J","./_lib/match/index.js":"dcq9K","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"decW5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
        other: "\u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
    },
    xSeconds: {
        one: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
        other: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
    },
    halfAMinute: "\u043F\u043E\u043B\u043E\u0432\u0438\u043D \u043C\u0438\u043D\u0443\u0442\u0430",
    lessThanXMinutes: {
        one: "\u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442 \u043C\u0438\u043D\u0443\u0442\u0430",
        other: "\u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442 {{count}} \u043C\u0438\u043D\u0443\u0442\u0438"
    },
    xMinutes: {
        one: "1 \u043C\u0438\u043D\u0443\u0442\u0430",
        other: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0438"
    },
    aboutXHours: {
        one: "\u043E\u043A\u043E\u043B\u043E \u0447\u0430\u0441",
        other: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u0430"
    },
    xHours: {
        one: "1 \u0447\u0430\u0441",
        other: "{{count}} \u0447\u0430\u0441\u0430"
    },
    xDays: {
        one: "1 \u0434\u0435\u043D",
        other: "{{count}} \u0434\u043D\u0438"
    },
    aboutXWeeks: {
        one: "\u043E\u043A\u043E\u043B\u043E \u0441\u0435\u0434\u043C\u0438\u0446\u0430",
        other: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0441\u0435\u0434\u043C\u0438\u0446\u0438"
    },
    xWeeks: {
        one: "1 \u0441\u0435\u0434\u043C\u0438\u0446\u0430",
        other: "{{count}} \u0441\u0435\u0434\u043C\u0438\u0446\u0438"
    },
    aboutXMonths: {
        one: "\u043E\u043A\u043E\u043B\u043E \u043C\u0435\u0441\u0435\u0446",
        other: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u0435\u0446\u0430"
    },
    xMonths: {
        one: "1 \u043C\u0435\u0441\u0435\u0446",
        other: "{{count}} \u043C\u0435\u0441\u0435\u0446\u0430"
    },
    aboutXYears: {
        one: "\u043E\u043A\u043E\u043B\u043E \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    },
    xYears: {
        one: "1 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    },
    overXYears: {
        one: "\u043D\u0430\u0434 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u043D\u0430\u0434 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    },
    almostXYears: {
        one: "\u043F\u043E\u0447\u0442\u0438 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0441\u043B\u0435\u0434 " + result;
        else return "\u043F\u0440\u0435\u0434\u0438 " + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"fK1Zt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, dd MMMM yyyy',
    long: 'dd MMMM yyyy',
    medium: 'dd MMM yyyy',
    short: 'dd/MM/yyyy'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'H:mm'
};
var dateTimeFormats = {
    any: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'any'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gJLhs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../../_lib/isSameUTCWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
// Adapted from the `ru` translation
var weekdays = [
    "\u043D\u0435\u0434\u0435\u043B\u044F",
    "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A",
    "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
    "\u0441\u0440\u044F\u0434\u0430",
    "\u0447\u0435\u0442\u0432\u044A\u0440\u0442\u044A\u043A",
    "\u043F\u0435\u0442\u044A\u043A",
    "\u0441\u044A\u0431\u043E\u0442\u0430"
];
function lastWeek(day) {
    var weekday = weekdays[day];
    switch(day){
        case 0:
        case 3:
        case 6:
            return "'\u043C\u0438\u043D\u0430\u043B\u0430\u0442\u0430 " + weekday + " \u0432' p";
        case 1:
        case 2:
        case 4:
        case 5:
            return "'\u043C\u0438\u043D\u0430\u043B\u0438\u044F " + weekday + " \u0432' p";
    }
}
function thisWeek(day) {
    var weekday = weekdays[day];
    if (day === 2 /* Tue */ ) return "'\u0432\u044A\u0432 " + weekday + " \u0432' p";
    else return "'\u0432 " + weekday + " \u0432' p";
}
function nextWeek(day) {
    var weekday = weekdays[day];
    switch(day){
        case 0:
        case 3:
        case 6:
            return "'\u0441\u043B\u0435\u0434\u0432\u0430\u0449\u0430\u0442\u0430 " + weekday + " \u0432' p";
        case 1:
        case 2:
        case 4:
        case 5:
            return "'\u0441\u043B\u0435\u0434\u0432\u0430\u0449\u0438\u044F " + weekday + " \u0432' p";
    }
}
var lastWeekFormatToken = function lastWeekFormatToken(dirtyDate, baseDate, options) {
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, _indexJsDefault1.default)(date, baseDate, options)) return thisWeek(day);
    else return lastWeek(day);
};
var nextWeekFormatToken = function nextWeekFormatToken(dirtyDate, baseDate, options) {
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, _indexJsDefault1.default)(date, baseDate, options)) return thisWeek(day);
    else return nextWeek(day);
};
var formatRelativeLocale = {
    lastWeek: lastWeekFormatToken,
    yesterday: "'\u0432\u0447\u0435\u0440\u0430 \u0432' p",
    today: "'\u0434\u043D\u0435\u0441 \u0432' p",
    tomorrow: "'\u0443\u0442\u0440\u0435 \u0432' p",
    nextWeek: nextWeekFormatToken,
    other: 'P'
};
var formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
exports.default = formatRelative;

},{"../../../../toDate/index.js":"elr3O","../../../../_lib/isSameUTCWeek/index.js":"g7rCW","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7UC2J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u043F\u0440.\u043D.\u0435.",
        "\u043D.\u0435."
    ],
    abbreviated: [
        "\u043F\u0440\u0435\u0434\u0438 \u043D. \u0435.",
        "\u043D. \u0435."
    ],
    wide: [
        "\u043F\u0440\u0435\u0434\u0438 \u043D\u043E\u0432\u0430\u0442\u0430 \u0435\u0440\u0430",
        "\u043D\u043E\u0432\u0430\u0442\u0430 \u0435\u0440\u0430"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1-\u0432\u043E \u0442\u0440\u0438\u043C\u0435\u0441.",
        "2-\u0440\u043E \u0442\u0440\u0438\u043C\u0435\u0441.",
        "3-\u0442\u043E \u0442\u0440\u0438\u043C\u0435\u0441.",
        "4-\u0442\u043E \u0442\u0440\u0438\u043C\u0435\u0441."
    ],
    wide: [
        "1-\u0432\u043E \u0442\u0440\u0438\u043C\u0435\u0441\u0435\u0447\u0438\u0435",
        "2-\u0440\u043E \u0442\u0440\u0438\u043C\u0435\u0441\u0435\u0447\u0438\u0435",
        "3-\u0442\u043E \u0442\u0440\u0438\u043C\u0435\u0441\u0435\u0447\u0438\u0435",
        "4-\u0442\u043E \u0442\u0440\u0438\u043C\u0435\u0441\u0435\u0447\u0438\u0435"
    ]
};
var monthValues = {
    abbreviated: [
        "\u044F\u043D\u0443",
        "\u0444\u0435\u0432",
        "\u043C\u0430\u0440",
        "\u0430\u043F\u0440",
        "\u043C\u0430\u0439",
        "\u044E\u043D\u0438",
        "\u044E\u043B\u0438",
        "\u0430\u0432\u0433",
        "\u0441\u0435\u043F",
        "\u043E\u043A\u0442",
        "\u043D\u043E\u0435",
        "\u0434\u0435\u043A"
    ],
    wide: [
        "\u044F\u043D\u0443\u0430\u0440\u0438",
        "\u0444\u0435\u0432\u0440\u0443\u0430\u0440\u0438",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0438\u043B",
        "\u043C\u0430\u0439",
        "\u044E\u043D\u0438",
        "\u044E\u043B\u0438",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043F\u0442\u0435\u043C\u0432\u0440\u0438",
        "\u043E\u043A\u0442\u043E\u043C\u0432\u0440\u0438",
        "\u043D\u043E\u0435\u043C\u0432\u0440\u0438",
        "\u0434\u0435\u043A\u0435\u043C\u0432\u0440\u0438"
    ]
};
var dayValues = {
    narrow: [
        "\u041D",
        "\u041F",
        "\u0412",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u043D\u0434",
        "\u043F\u043D",
        "\u0432\u0442",
        "\u0441\u0440",
        "\u0447\u0442",
        "\u043F\u0442",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u043D\u0435\u0434",
        "\u043F\u043E\u043D",
        "\u0432\u0442\u043E",
        "\u0441\u0440\u044F",
        "\u0447\u0435\u0442",
        "\u043F\u0435\u0442",
        "\u0441\u044A\u0431"
    ],
    wide: [
        "\u043D\u0435\u0434\u0435\u043B\u044F",
        "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A",
        "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
        "\u0441\u0440\u044F\u0434\u0430",
        "\u0447\u0435\u0442\u0432\u044A\u0440\u0442\u044A\u043A",
        "\u043F\u0435\u0442\u044A\u043A",
        "\u0441\u044A\u0431\u043E\u0442\u0430"
    ]
};
var dayPeriodValues = {
    wide: {
        am: "\u043F\u0440\u0435\u0434\u0438 \u043E\u0431\u044F\u0434",
        pm: "\u0441\u043B\u0435\u0434 \u043E\u0431\u044F\u0434",
        midnight: "\u0432 \u043F\u043E\u043B\u0443\u043D\u043E\u0449",
        noon: "\u043D\u0430 \u043E\u0431\u044F\u0434",
        morning: "\u0441\u0443\u0442\u0440\u0438\u043D\u0442\u0430",
        afternoon: "\u0441\u043B\u0435\u0434\u043E\u0431\u0435\u0434",
        evening: "\u0432\u0435\u0447\u0435\u0440\u0442\u0430",
        night: "\u043F\u0440\u0435\u0437 \u043D\u043E\u0449\u0442\u0430"
    }
};
function isFeminine(unit) {
    return unit === 'year' || unit === 'week' || unit === 'minute' || unit === 'second';
}
function isNeuter(unit) {
    return unit === 'quarter';
}
function numberWithSuffix(number, unit, masculine, feminine, neuter) {
    var suffix = isNeuter(unit) ? neuter : isFeminine(unit) ? feminine : masculine;
    return number + '-' + suffix;
}
var ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    if (number === 0) return numberWithSuffix(0, unit, "\u0435\u0432", "\u0435\u0432\u0430", "\u0435\u0432\u043E");
    else if (number % 1000 === 0) return numberWithSuffix(number, unit, "\u0435\u043D", "\u043D\u0430", "\u043D\u043E");
    else if (number % 100 === 0) return numberWithSuffix(number, unit, "\u0442\u0435\u043D", "\u0442\u043D\u0430", "\u0442\u043D\u043E");
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return numberWithSuffix(number, unit, "\u0432\u0438", "\u0432\u0430", "\u0432\u043E");
        case 2:
            return numberWithSuffix(number, unit, "\u0440\u0438", "\u0440\u0430", "\u0440\u043E");
        case 7:
        case 8:
            return numberWithSuffix(number, unit, "\u043C\u0438", "\u043C\u0430", "\u043C\u043E");
    }
    return numberWithSuffix(number, unit, "\u0442\u0438", "\u0442\u0430", "\u0442\u043E");
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"dcq9K":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(-?[врмт][аи]|-?т?(ен|на)|-?(ев|ева))?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^((пр)?н\.?\s?е\.?)/i,
    abbreviated: /^((пр)?н\.?\s?е\.?)/i,
    wide: /^(преди новата ера|новата ера|нова ера)/i
};
var parseEraPatterns = {
    any: [
        /^п/i,
        /^н/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[врт]?o?)? тримес.?/i,
    wide: /^[1234](-?[врт]?о?)? тримесечие/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchDayPatterns = {
    narrow: /^[нпвсч]/i,
    short: /^(нд|пн|вт|ср|чт|пт|сб)/i,
    abbreviated: /^(нед|пон|вто|сря|чет|пет|съб)/i,
    wide: /^(неделя|понеделник|вторник|сряда|четвъртък|петък|събота)/i
};
var parseDayPatterns = {
    narrow: [
        /^н/i,
        /^п/i,
        /^в/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^н[ед]/i,
        /^п[он]/i,
        /^вт/i,
        /^ср/i,
        /^ч[ет]/i,
        /^п[ет]/i,
        /^с[ъб]/i
    ]
};
var matchMonthPatterns = {
    abbreviated: /^(яну|фев|мар|апр|май|юни|юли|авг|сеп|окт|ное|дек)/i,
    wide: /^(януари|февруари|март|април|май|юни|юли|август|септември|октомври|ноември|декември)/i
};
var parseMonthPatterns = {
    any: [
        /^я/i,
        /^ф/i,
        /^мар/i,
        /^ап/i,
        /^май/i,
        /^юн/i,
        /^юл/i,
        /^ав/i,
        /^се/i,
        /^окт/i,
        /^но/i,
        /^де/i
    ]
};
var matchDayPeriodPatterns = {
    any: /^(преди о|след о|в по|на о|през|веч|сут|следо)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^преди о/i,
        pm: /^след о/i,
        midnight: /^в пол/i,
        noon: /^на об/i,
        morning: /^сут/i,
        afternoon: /^следо/i,
        evening: /^веч/i,
        night: /^през н/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2EJFM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Bengali locale.
 * @language Bengali
 * @iso-639-2 ben
 * @author Touhidur Rahman [@touhidrahman]{@link https://github.com/touhidrahman}
 * @author Farhad Yasir [@nutboltu]{@link https://github.com/nutboltu}
 */ var locale = {
    code: 'bn',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"chotS","./_lib/formatLong/index.js":"jD1r0","./_lib/formatRelative/index.js":"12lsy","./_lib/localize/index.js":"83mYa","./_lib/match/index.js":"405Hj","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"chotS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../localize/index.js");
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1"
    },
    xSeconds: {
        one: "\u09E7 \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1",
        other: "{{count}} \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1"
    },
    halfAMinute: "\u0986\u09A7 \u09AE\u09BF\u09A8\u09BF\u099F",
    lessThanXMinutes: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09AE\u09BF\u09A8\u09BF\u099F",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09AE\u09BF\u09A8\u09BF\u099F"
    },
    xMinutes: {
        one: "\u09E7 \u09AE\u09BF\u09A8\u09BF\u099F",
        other: "{{count}} \u09AE\u09BF\u09A8\u09BF\u099F"
    },
    aboutXHours: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u0998\u09A8\u09CD\u099F\u09BE",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u0998\u09A8\u09CD\u099F\u09BE"
    },
    xHours: {
        one: "\u09E7 \u0998\u09A8\u09CD\u099F\u09BE",
        other: "{{count}} \u0998\u09A8\u09CD\u099F\u09BE"
    },
    xDays: {
        one: "\u09E7 \u09A6\u09BF\u09A8",
        other: "{{count}} \u09A6\u09BF\u09A8"
    },
    aboutXWeeks: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09B8\u09AA\u09CD\u09A4\u09BE\u09B9",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09B8\u09AA\u09CD\u09A4\u09BE\u09B9"
    },
    xWeeks: {
        one: "\u09E7 \u09B8\u09AA\u09CD\u09A4\u09BE\u09B9",
        other: "{{count}} \u09B8\u09AA\u09CD\u09A4\u09BE\u09B9"
    },
    aboutXMonths: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09AE\u09BE\u09B8",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09AE\u09BE\u09B8"
    },
    xMonths: {
        one: "\u09E7 \u09AE\u09BE\u09B8",
        other: "{{count}} \u09AE\u09BE\u09B8"
    },
    aboutXYears: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09AC\u099B\u09B0",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09AC\u099B\u09B0"
    },
    xYears: {
        one: "\u09E7 \u09AC\u099B\u09B0",
        other: "{{count}} \u09AC\u099B\u09B0"
    },
    overXYears: {
        one: "\u09E7 \u09AC\u099B\u09B0\u09C7\u09B0 \u09AC\u09C7\u09B6\u09BF",
        other: "{{count}} \u09AC\u099B\u09B0\u09C7\u09B0 \u09AC\u09C7\u09B6\u09BF"
    },
    almostXYears: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09AC\u099B\u09B0",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09AC\u099B\u09B0"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', (0, _indexJs.numberToLocale)(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " \u098F\u09B0 \u09AE\u09A7\u09CD\u09AF\u09C7";
        else return result + " \u0986\u0997\u09C7";
    }
    return result;
};
exports.default = formatDistance;

},{"../localize/index.js":"83mYa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"83mYa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// function localeToNumber(locale: string): number {
//   const enNumber = locale.toString().replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
//     return numberValues.number[match as keyof typeof numberValues.number]
//   })
//   return Number(enNumber)
// }
parcelHelpers.export(exports, "numberToLocale", function() {
    return numberToLocale;
});
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var numberValues = {
    locale: {
        '1': "\u09E7",
        '2': "\u09E8",
        '3': "\u09E9",
        '4': "\u09EA",
        '5': "\u09EB",
        '6': "\u09EC",
        '7': "\u09ED",
        '8': "\u09EE",
        '9': "\u09EF",
        '0': "\u09E6"
    },
    number: {
        "\u09E7": '1',
        "\u09E8": '2',
        "\u09E9": '3',
        "\u09EA": '4',
        "\u09EB": '5',
        "\u09EC": '6',
        "\u09ED": '7',
        "\u09EE": '8',
        "\u09EF": '9',
        "\u09E6": '0'
    }
};
var eraValues = {
    narrow: [
        "\u0996\u09CD\u09B0\u09BF\u0983\u09AA\u09C2\u0983",
        "\u0996\u09CD\u09B0\u09BF\u0983"
    ],
    abbreviated: [
        "\u0996\u09CD\u09B0\u09BF\u0983\u09AA\u09C2\u09B0\u09CD\u09AC",
        "\u0996\u09CD\u09B0\u09BF\u0983"
    ],
    wide: [
        "\u0996\u09CD\u09B0\u09BF\u09B8\u09CD\u099F\u09AA\u09C2\u09B0\u09CD\u09AC",
        "\u0996\u09CD\u09B0\u09BF\u09B8\u09CD\u099F\u09BE\u09AC\u09CD\u09A6"
    ]
};
var quarterValues = {
    narrow: [
        "\u09E7",
        "\u09E8",
        "\u09E9",
        "\u09EA"
    ],
    abbreviated: [
        "\u09E7\u09A4\u09CD\u09B0\u09C8",
        "\u09E8\u09A4\u09CD\u09B0\u09C8",
        "\u09E9\u09A4\u09CD\u09B0\u09C8",
        "\u09EA\u09A4\u09CD\u09B0\u09C8"
    ],
    wide: [
        "\u09E7\u09AE \u09A4\u09CD\u09B0\u09C8\u09AE\u09BE\u09B8\u09BF\u0995",
        "\u09E8\u09DF \u09A4\u09CD\u09B0\u09C8\u09AE\u09BE\u09B8\u09BF\u0995",
        "\u09E9\u09DF \u09A4\u09CD\u09B0\u09C8\u09AE\u09BE\u09B8\u09BF\u0995",
        "\u09EA\u09B0\u09CD\u09A5 \u09A4\u09CD\u09B0\u09C8\u09AE\u09BE\u09B8\u09BF\u0995"
    ]
};
var monthValues = {
    narrow: [
        "\u099C\u09BE\u09A8\u09C1",
        "\u09AB\u09C7\u09AC\u09CD\u09B0\u09C1",
        "\u09AE\u09BE\u09B0\u09CD\u099A",
        "\u098F\u09AA\u09CD\u09B0\u09BF\u09B2",
        "\u09AE\u09C7",
        "\u099C\u09C1\u09A8",
        "\u099C\u09C1\u09B2\u09BE\u0987",
        "\u0986\u0997\u09B8\u09CD\u099F",
        "\u09B8\u09C7\u09AA\u09CD\u099F",
        "\u0985\u0995\u09CD\u099F\u09CB",
        "\u09A8\u09AD\u09C7",
        "\u09A1\u09BF\u09B8\u09C7"
    ],
    abbreviated: [
        "\u099C\u09BE\u09A8\u09C1",
        "\u09AB\u09C7\u09AC\u09CD\u09B0\u09C1",
        "\u09AE\u09BE\u09B0\u09CD\u099A",
        "\u098F\u09AA\u09CD\u09B0\u09BF\u09B2",
        "\u09AE\u09C7",
        "\u099C\u09C1\u09A8",
        "\u099C\u09C1\u09B2\u09BE\u0987",
        "\u0986\u0997\u09B8\u09CD\u099F",
        "\u09B8\u09C7\u09AA\u09CD\u099F",
        "\u0985\u0995\u09CD\u099F\u09CB",
        "\u09A8\u09AD\u09C7",
        "\u09A1\u09BF\u09B8\u09C7"
    ],
    wide: [
        "\u099C\u09BE\u09A8\u09C1\u09DF\u09BE\u09B0\u09BF",
        "\u09AB\u09C7\u09AC\u09CD\u09B0\u09C1\u09DF\u09BE\u09B0\u09BF",
        "\u09AE\u09BE\u09B0\u09CD\u099A",
        "\u098F\u09AA\u09CD\u09B0\u09BF\u09B2",
        "\u09AE\u09C7",
        "\u099C\u09C1\u09A8",
        "\u099C\u09C1\u09B2\u09BE\u0987",
        "\u0986\u0997\u09B8\u09CD\u099F",
        "\u09B8\u09C7\u09AA\u09CD\u099F\u09C7\u09AE\u09CD\u09AC\u09B0",
        "\u0985\u0995\u09CD\u099F\u09CB\u09AC\u09B0",
        "\u09A8\u09AD\u09C7\u09AE\u09CD\u09AC\u09B0",
        "\u09A1\u09BF\u09B8\u09C7\u09AE\u09CD\u09AC\u09B0"
    ]
};
var dayValues = {
    narrow: [
        "\u09B0",
        "\u09B8\u09CB",
        "\u09AE",
        "\u09AC\u09C1",
        "\u09AC\u09C3",
        "\u09B6\u09C1",
        "\u09B6"
    ],
    short: [
        "\u09B0\u09AC\u09BF",
        "\u09B8\u09CB\u09AE",
        "\u09AE\u0999\u09CD\u0997\u09B2",
        "\u09AC\u09C1\u09A7",
        "\u09AC\u09C3\u09B9",
        "\u09B6\u09C1\u0995\u09CD\u09B0",
        "\u09B6\u09A8\u09BF"
    ],
    abbreviated: [
        "\u09B0\u09AC\u09BF",
        "\u09B8\u09CB\u09AE",
        "\u09AE\u0999\u09CD\u0997\u09B2",
        "\u09AC\u09C1\u09A7",
        "\u09AC\u09C3\u09B9",
        "\u09B6\u09C1\u0995\u09CD\u09B0",
        "\u09B6\u09A8\u09BF"
    ],
    wide: [
        "\u09B0\u09AC\u09BF\u09AC\u09BE\u09B0",
        "\u09B8\u09CB\u09AE\u09AC\u09BE\u09B0",
        "\u09AE\u0999\u09CD\u0997\u09B2\u09AC\u09BE\u09B0",
        "\u09AC\u09C1\u09A7\u09AC\u09BE\u09B0",
        "\u09AC\u09C3\u09B9\u09B8\u09CD\u09AA\u09A4\u09BF\u09AC\u09BE\u09B0 ",
        "\u09B6\u09C1\u0995\u09CD\u09B0\u09AC\u09BE\u09B0",
        "\u09B6\u09A8\u09BF\u09AC\u09BE\u09B0"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u09AA\u09C2",
        pm: "\u0985\u09AA",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
    },
    abbreviated: {
        am: "\u09AA\u09C2\u09B0\u09CD\u09AC\u09BE\u09B9\u09CD\u09A8",
        pm: "\u0985\u09AA\u09B0\u09BE\u09B9\u09CD\u09A8",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
    },
    wide: {
        am: "\u09AA\u09C2\u09B0\u09CD\u09AC\u09BE\u09B9\u09CD\u09A8",
        pm: "\u0985\u09AA\u09B0\u09BE\u09B9\u09CD\u09A8",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u09AA\u09C2",
        pm: "\u0985\u09AA",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
    },
    abbreviated: {
        am: "\u09AA\u09C2\u09B0\u09CD\u09AC\u09BE\u09B9\u09CD\u09A8",
        pm: "\u0985\u09AA\u09B0\u09BE\u09B9\u09CD\u09A8",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
    },
    wide: {
        am: "\u09AA\u09C2\u09B0\u09CD\u09AC\u09BE\u09B9\u09CD\u09A8",
        pm: "\u0985\u09AA\u09B0\u09BE\u09B9\u09CD\u09A8",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
    }
};
function dateOrdinalNumber(number, localeNumber) {
    if (number > 18 && number <= 31) return localeNumber + "\u09B6\u09C7";
    else switch(number){
        case 1:
            return localeNumber + "\u09B2\u09BE";
        case 2:
        case 3:
            return localeNumber + "\u09B0\u09BE";
        case 4:
            return localeNumber + "\u09A0\u09BE";
        default:
            return localeNumber + "\u0987";
    }
}
var ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var localeNumber = numberToLocale(number);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    if (unit === 'date') return dateOrdinalNumber(number, localeNumber);
    if (number > 10 || number === 0) return localeNumber + "\u09A4\u09AE";
    var rem10 = number % 10;
    switch(rem10){
        case 2:
        case 3:
            return localeNumber + "\u09DF";
        case 4:
            return localeNumber + "\u09B0\u09CD\u09A5";
        case 6:
            return localeNumber + "\u09B7\u09CD\u09A0";
        default:
            return localeNumber + "\u09AE";
    }
};
function numberToLocale(enNumber) {
    return enNumber.toString().replace(/\d/g, function(match) {
        return numberValues.locale[match];
    });
}
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jD1r0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var dateTimeFormats = {
    full: "{{date}} {{time}} '\u09B8\u09AE\u09DF'",
    long: "{{date}} {{time}} '\u09B8\u09AE\u09DF'",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"12lsy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'\u0997\u09A4' eeee '\u09B8\u09AE\u09DF' p",
    yesterday: "'\u0997\u09A4\u0995\u09BE\u09B2' '\u09B8\u09AE\u09DF' p",
    today: "'\u0986\u099C' '\u09B8\u09AE\u09DF' p",
    tomorrow: "'\u0986\u0997\u09BE\u09AE\u09C0\u0995\u09BE\u09B2' '\u09B8\u09AE\u09DF' p",
    nextWeek: "eeee '\u09B8\u09AE\u09DF' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"405Hj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(ম|য়|র্থ|ষ্ঠ|শে|ই|তম)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(খ্রিঃপূঃ|খ্রিঃ)/i,
    abbreviated: /^(খ্রিঃপূর্ব|খ্রিঃ)/i,
    wide: /^(খ্রিস্টপূর্ব|খ্রিস্টাব্দ)/i
};
var parseEraPatterns = {
    narrow: [
        /^খ্রিঃপূঃ/i,
        /^খ্রিঃ/i
    ],
    abbreviated: [
        /^খ্রিঃপূর্ব/i,
        /^খ্রিঃ/i
    ],
    wide: [
        /^খ্রিস্টপূর্ব/i,
        /^খ্রিস্টাব্দ/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[১২৩৪]/i,
    abbreviated: /^[১২৩৪]ত্রৈ/i,
    wide: /^[১২৩৪](ম|য়|র্থ)? ত্রৈমাসিক/i
};
var parseQuarterPatterns = {
    any: [
        /১/i,
        /২/i,
        /৩/i,
        /৪/i
    ]
};
var matchMonthPatterns = {
    narrow: /^(জানু|ফেব্রু|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্ট|অক্টো|নভে|ডিসে)/i,
    abbreviated: /^(জানু|ফেব্রু|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্ট|অক্টো|নভে|ডিসে)/i,
    wide: /^(জানুয়ারি|ফেব্রুয়ারি|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্টেম্বর|অক্টোবর|নভেম্বর|ডিসেম্বর)/i
};
var parseMonthPatterns = {
    any: [
        /^জানু/i,
        /^ফেব্রু/i,
        /^মার্চ/i,
        /^এপ্রিল/i,
        /^মে/i,
        /^জুন/i,
        /^জুলাই/i,
        /^আগস্ট/i,
        /^সেপ্ট/i,
        /^অক্টো/i,
        /^নভে/i,
        /^ডিসে/i
    ]
};
var matchDayPatterns = {
    narrow: /^(র|সো|ম|বু|বৃ|শু|শ)+/i,
    short: /^(রবি|সোম|মঙ্গল|বুধ|বৃহ|শুক্র|শনি)+/i,
    abbreviated: /^(রবি|সোম|মঙ্গল|বুধ|বৃহ|শুক্র|শনি)+/i,
    wide: /^(রবিবার|সোমবার|মঙ্গলবার|বুধবার|বৃহস্পতিবার |শুক্রবার|শনিবার)+/i
};
var parseDayPatterns = {
    narrow: [
        /^র/i,
        /^সো/i,
        /^ম/i,
        /^বু/i,
        /^বৃ/i,
        /^শু/i,
        /^শ/i
    ],
    short: [
        /^রবি/i,
        /^সোম/i,
        /^মঙ্গল/i,
        /^বুধ/i,
        /^বৃহ/i,
        /^শুক্র/i,
        /^শনি/i
    ],
    abbreviated: [
        /^রবি/i,
        /^সোম/i,
        /^মঙ্গল/i,
        /^বুধ/i,
        /^বৃহ/i,
        /^শুক্র/i,
        /^শনি/i
    ],
    wide: [
        /^রবিবার/i,
        /^সোমবার/i,
        /^মঙ্গলবার/i,
        /^বুধবার/i,
        /^বৃহস্পতিবার /i,
        /^শুক্রবার/i,
        /^শনিবার/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(পূ|অপ|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i,
    abbreviated: /^(পূর্বাহ্ন|অপরাহ্ন|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i,
    wide: /^(পূর্বাহ্ন|অপরাহ্ন|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^পূ/i,
        pm: /^অপ/i,
        midnight: /^মধ্যরাত/i,
        noon: /^মধ্যাহ্ন/i,
        morning: /সকাল/i,
        afternoon: /বিকাল/i,
        evening: /সন্ধ্যা/i,
        night: /রাত/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gYIcH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Bosnian locale.
 * @language Bosnian
 * @iso-639-2 bos
 * @author Branislav Lazić [@branislavlazic]{@link https://github.com/branislavlazic}
 */ var locale = {
    code: 'bs',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"75gdm","./_lib/formatLong/index.js":"bLkgt","./_lib/formatRelative/index.js":"7K4Gz","./_lib/localize/index.js":"bRZiB","./_lib/match/index.js":"7Le53","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"75gdm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            standalone: 'manje od 1 sekunde',
            withPrepositionAgo: 'manje od 1 sekunde',
            withPrepositionIn: 'manje od 1 sekundu'
        },
        dual: 'manje od {{count}} sekunde',
        other: 'manje od {{count}} sekundi'
    },
    xSeconds: {
        one: {
            standalone: '1 sekunda',
            withPrepositionAgo: '1 sekunde',
            withPrepositionIn: '1 sekundu'
        },
        dual: '{{count}} sekunde',
        other: '{{count}} sekundi'
    },
    halfAMinute: 'pola minute',
    lessThanXMinutes: {
        one: {
            standalone: 'manje od 1 minute',
            withPrepositionAgo: 'manje od 1 minute',
            withPrepositionIn: 'manje od 1 minutu'
        },
        dual: 'manje od {{count}} minute',
        other: 'manje od {{count}} minuta'
    },
    xMinutes: {
        one: {
            standalone: '1 minuta',
            withPrepositionAgo: '1 minute',
            withPrepositionIn: '1 minutu'
        },
        dual: '{{count}} minute',
        other: '{{count}} minuta'
    },
    aboutXHours: {
        one: {
            standalone: 'oko 1 sat',
            withPrepositionAgo: 'oko 1 sat',
            withPrepositionIn: 'oko 1 sat'
        },
        dual: 'oko {{count}} sata',
        other: 'oko {{count}} sati'
    },
    xHours: {
        one: {
            standalone: '1 sat',
            withPrepositionAgo: '1 sat',
            withPrepositionIn: '1 sat'
        },
        dual: '{{count}} sata',
        other: '{{count}} sati'
    },
    xDays: {
        one: {
            standalone: '1 dan',
            withPrepositionAgo: '1 dan',
            withPrepositionIn: '1 dan'
        },
        dual: '{{count}} dana',
        other: '{{count}} dana'
    },
    aboutXWeeks: {
        one: {
            standalone: 'oko 1 sedmicu',
            withPrepositionAgo: 'oko 1 sedmicu',
            withPrepositionIn: 'oko 1 sedmicu'
        },
        dual: 'oko {{count}} sedmice',
        other: 'oko {{count}} sedmice'
    },
    xWeeks: {
        one: {
            standalone: '1 sedmicu',
            withPrepositionAgo: '1 sedmicu',
            withPrepositionIn: '1 sedmicu'
        },
        dual: '{{count}} sedmice',
        other: '{{count}} sedmice'
    },
    aboutXMonths: {
        one: {
            standalone: 'oko 1 mjesec',
            withPrepositionAgo: 'oko 1 mjesec',
            withPrepositionIn: 'oko 1 mjesec'
        },
        dual: 'oko {{count}} mjeseca',
        other: 'oko {{count}} mjeseci'
    },
    xMonths: {
        one: {
            standalone: '1 mjesec',
            withPrepositionAgo: '1 mjesec',
            withPrepositionIn: '1 mjesec'
        },
        dual: '{{count}} mjeseca',
        other: '{{count}} mjeseci'
    },
    aboutXYears: {
        one: {
            standalone: 'oko 1 godinu',
            withPrepositionAgo: 'oko 1 godinu',
            withPrepositionIn: 'oko 1 godinu'
        },
        dual: 'oko {{count}} godine',
        other: 'oko {{count}} godina'
    },
    xYears: {
        one: {
            standalone: '1 godina',
            withPrepositionAgo: '1 godine',
            withPrepositionIn: '1 godinu'
        },
        dual: '{{count}} godine',
        other: '{{count}} godina'
    },
    overXYears: {
        one: {
            standalone: 'preko 1 godinu',
            withPrepositionAgo: 'preko 1 godinu',
            withPrepositionIn: 'preko 1 godinu'
        },
        dual: 'preko {{count}} godine',
        other: 'preko {{count}} godina'
    },
    almostXYears: {
        one: {
            standalone: 'gotovo 1 godinu',
            withPrepositionAgo: 'gotovo 1 godinu',
            withPrepositionIn: 'gotovo 1 godinu'
        },
        dual: 'gotovo {{count}} godine',
        other: 'gotovo {{count}} godina'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) {
        if (options !== null && options !== void 0 && options.addSuffix) {
            if (options.comparison && options.comparison > 0) result = tokenValue.one.withPrepositionIn;
            else result = tokenValue.one.withPrepositionAgo;
        } else result = tokenValue.one.standalone;
    } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
    String(count).substr(-2, 1) !== '1' // unless the 2nd to last digit is "1"
    ) result = tokenValue.dual.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'za ' + result;
        else return 'prije ' + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"bLkgt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, d. MMMM yyyy.',
    long: 'd. MMMM yyyy.',
    medium: 'd. MMM yy.',
    short: 'dd. MM. yy.'
};
var timeFormats = {
    full: 'HH:mm:ss (zzzz)',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'u' {{time}}",
    long: "{{date}} 'u' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7K4Gz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        switch(date.getUTCDay()){
            case 0:
                return "'pro\u0161le nedjelje u' p";
            case 3:
                return "'pro\u0161le srijede u' p";
            case 6:
                return "'pro\u0161le subote u' p";
            default:
                return "'pro\u0161li' EEEE 'u' p";
        }
    },
    yesterday: "'ju\u010De u' p",
    today: "'danas u' p",
    tomorrow: "'sutra u' p",
    nextWeek: function nextWeek(date) {
        switch(date.getUTCDay()){
            case 0:
                return "'sljede\u0107e nedjelje u' p";
            case 3:
                return "'sljede\u0107u srijedu u' p";
            case 6:
                return "'sljede\u0107u subotu u' p";
            default:
                return "'sljede\u0107i' EEEE 'u' p";
        }
    },
    other: 'P'
};
var formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"bRZiB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'pr.n.e.',
        'AD'
    ],
    abbreviated: [
        'pr. Hr.',
        'po. Hr.'
    ],
    wide: [
        'Prije Hrista',
        'Poslije Hrista'
    ]
};
var quarterValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.'
    ],
    abbreviated: [
        '1. kv.',
        '2. kv.',
        '3. kv.',
        '4. kv.'
    ],
    wide: [
        '1. kvartal',
        '2. kvartal',
        '3. kvartal',
        '4. kvartal'
    ]
};
var monthValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.',
        '5.',
        '6.',
        '7.',
        '8.',
        '9.',
        '10.',
        '11.',
        '12.'
    ],
    abbreviated: [
        'jan',
        'feb',
        'mar',
        'apr',
        'maj',
        'jun',
        'jul',
        'avg',
        'sep',
        'okt',
        'nov',
        'dec'
    ],
    wide: [
        'januar',
        'februar',
        'mart',
        'april',
        'maj',
        'juni',
        'juli',
        'avgust',
        'septembar',
        'oktobar',
        'novembar',
        'decembar'
    ]
};
var formattingMonthValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.',
        '5.',
        '6.',
        '7.',
        '8.',
        '9.',
        '10.',
        '11.',
        '12.'
    ],
    abbreviated: [
        'jan',
        'feb',
        'mar',
        'apr',
        'maj',
        'jun',
        'jul',
        'avg',
        'sep',
        'okt',
        'nov',
        'dec'
    ],
    wide: [
        'januar',
        'februar',
        'mart',
        'april',
        'maj',
        'juni',
        'juli',
        'avgust',
        'septembar',
        'oktobar',
        'novembar',
        'decembar'
    ]
};
var dayValues = {
    narrow: [
        'N',
        'P',
        'U',
        'S',
        "\u010C",
        'P',
        'S'
    ],
    short: [
        'ned',
        'pon',
        'uto',
        'sre',
        "\u010Det",
        'pet',
        'sub'
    ],
    abbreviated: [
        'ned',
        'pon',
        'uto',
        'sre',
        "\u010Det",
        'pet',
        'sub'
    ],
    wide: [
        'nedjelja',
        'ponedjeljak',
        'utorak',
        'srijeda',
        "\u010Detvrtak",
        'petak',
        'subota'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'popodne',
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'popodne',
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'poslije podne',
        evening: "uve\u010De",
        night: "no\u0107u"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'popodne',
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'popodne',
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'poslije podne',
        evening: "uve\u010De",
        night: "no\u0107u"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return String(number) + '.';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide',
        formattingValues: formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7Le53":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)\./i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(pr\.n\.e\.|AD)/i,
    abbreviated: /^(pr\.\s?Hr\.|po\.\s?Hr\.)/i,
    wide: /^(Prije Hrista|prije nove ere|Poslije Hrista|nova era)/i
};
var parseEraPatterns = {
    any: [
        /^pr/i,
        /^(po|nova)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\.\s?kv\.?/i,
    wide: /^[1234]\. kvartal/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^(10|11|12|[123456789])\./i,
    abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|avg|sep|okt|nov|dec)/i,
    wide: /^((januar|januara)|(februar|februara)|(mart|marta)|(april|aprila)|(maj|maja)|(juni|juna)|(juli|jula)|(avgust|avgusta)|(septembar|septembra)|(oktobar|oktobra)|(novembar|novembra)|(decembar|decembra))/i
};
var parseMonthPatterns = {
    narrow: [
        /^1/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^7/i,
        /^8/i,
        /^9/i,
        /^10/i,
        /^11/i,
        /^12/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^avg/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[npusčc]/i,
    short: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
    abbreviated: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
    wide: /^(nedjelja|ponedjeljak|utorak|srijeda|(četvrtak|cetvrtak)|petak|subota)/i
};
var parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var matchDayPeriodPatterns = {
    any: /^(am|pm|ponoc|ponoć|(po)?podne|uvece|uveče|noću|poslije podne|ujutru)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^pono/i,
        noon: /^pod/i,
        morning: /jutro/i,
        afternoon: /(poslije\s|po)+podne/i,
        evening: /(uvece|uveče)/i,
        night: /(nocu|noću)/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"aGMsW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Catalan locale.
 * @language Catalan
 * @iso-639-2 cat
 * @author Guillermo Grau [@guigrpa]{@link https://github.com/guigrpa}
 * @author Alex Vizcaino [@avizcaino]{@link https://github.com/avizcaino}
 */ var locale = {
    code: 'ca',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale; // throw new Error('ca locale is currently unavailable. Please check the progress of converting this locale to v2.0.0 in this issue on Github: TBA')

},{"./_lib/formatDistance/index.js":"fu4WB","./_lib/formatLong/index.js":"lMhYF","./_lib/formatRelative/index.js":"bTD6T","./_lib/localize/index.js":"asYnG","./_lib/match/index.js":"5isY2","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"fu4WB":[function(require,module,exports,__globalThis) {
/**
 * Davant de les xifres que es diuen amb vocal inicial, 1 i 11, s'apostrofen els articles el i la i la preposició de igual que si estiguessin escrits amb lletres.
 *    l'1 de juliol ('l'u')
 *    l'11 de novembre ('l'onze')
 *    l'11a clàusula del contracte ('l'onzena')
 *    la contractació d'11 jugadors ('d'onze')
 *    l'aval d'11.000 socis ('d'onze mil')
 *
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=apostrofaci%25F3+davant+xifres&action=Principal&method=detall_completa&numPagina=1&idHit=11236&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=11236&titol=apostrofaci%F3%20davant%20de%20xifres%20%2F%20apostrofaci%F3%20davant%20de%201%20i%2011&numeroResultat=1&clickLink=detall&tipusCerca=cerca.normes
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "menys d'un segon",
        eleven: "menys d'onze segons",
        other: 'menys de {{count}} segons'
    },
    xSeconds: {
        one: '1 segon',
        other: '{{count}} segons'
    },
    halfAMinute: 'mig minut',
    lessThanXMinutes: {
        one: "menys d'un minut",
        eleven: "menys d'onze minuts",
        other: 'menys de {{count}} minuts'
    },
    xMinutes: {
        one: '1 minut',
        other: '{{count}} minuts'
    },
    aboutXHours: {
        one: 'aproximadament una hora',
        other: 'aproximadament {{count}} hores'
    },
    xHours: {
        one: '1 hora',
        other: '{{count}} hores'
    },
    xDays: {
        one: '1 dia',
        other: '{{count}} dies'
    },
    aboutXWeeks: {
        one: 'aproximadament una setmana',
        other: 'aproximadament {{count}} setmanes'
    },
    xWeeks: {
        one: '1 setmana',
        other: '{{count}} setmanes'
    },
    aboutXMonths: {
        one: 'aproximadament un mes',
        other: 'aproximadament {{count}} mesos'
    },
    xMonths: {
        one: '1 mes',
        other: '{{count}} mesos'
    },
    aboutXYears: {
        one: 'aproximadament un any',
        other: 'aproximadament {{count}} anys'
    },
    xYears: {
        one: '1 any',
        other: '{{count}} anys'
    },
    overXYears: {
        one: "m\xe9s d'un any",
        eleven: "m\xe9s d'onze anys",
        other: "m\xe9s de {{count}} anys"
    },
    almostXYears: {
        one: "gaireb\xe9 un any",
        other: "gaireb\xe9 {{count}} anys"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 11 && tokenValue.eleven) result = tokenValue.eleven;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'en ' + result;
        else return 'fa ' + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"lMhYF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE, d 'de' MMMM y",
    long: "d 'de' MMMM y",
    medium: 'd MMM y',
    short: 'dd/MM/y'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'a les' {{time}}",
    long: "{{date}} 'a les' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"bTD6T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'el' eeee 'passat a la' LT",
    yesterday: "'ahir a la' p",
    today: "'avui a la' p",
    tomorrow: "'dem\xe0 a la' p",
    nextWeek: "eeee 'a la' p",
    other: 'P'
};
var formatRelativeLocalePlural = {
    lastWeek: "'el' eeee 'passat a les' p",
    yesterday: "'ahir a les' p",
    today: "'avui a les' p",
    tomorrow: "'dem\xe0 a les' p",
    nextWeek: "eeee 'a les' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, date, _baseDate, _options) {
    if (date.getUTCHours() !== 1) return formatRelativeLocalePlural[token];
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"asYnG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
/**
 * General information
 * Reference: https://aplicacions.llengua.gencat.cat
 * Reference: https://www.uoc.edu/portal/ca/servei-linguistic/convencions/abreviacions/simbols/simbols-habituals.html
 */ /**
 * Abans de Crist: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=abans+de+crist&action=Principal&method=detall_completa&numPagina=1&idHit=6876&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=6876&titol=abans%20de%20Crist%20(abreviatura)%20/%20abans%20de%20Crist%20(sigla)&numeroResultat=1&clickLink=detall&tipusCerca=cerca.fitxes
 * Desprest de Crist: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=despr%E9s+de+crist&action=Principal&method=detall_completa&numPagina=1&idHit=6879&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=6879&titol=despr%E9s%20de%20Crist%20(sigla)%20/%20despr%E9s%20de%20Crist%20(abreviatura)&numeroResultat=1&clickLink=detall&tipusCerca=cerca.fitxes
 */ var eraValues = {
    narrow: [
        'aC',
        'dC'
    ],
    abbreviated: [
        'a. de C.',
        'd. de C.'
    ],
    wide: [
        'abans de Crist',
        "despr\xe9s de Crist"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    wide: [
        '1r trimestre',
        '2n trimestre',
        '3r trimestre',
        '4t trimestre'
    ]
};
/**
 * Dins d'un text convé fer servir la forma sencera dels mesos, ja que sempre és més clar el mot sencer que l'abreviatura, encara que aquesta sigui força coneguda.
 * Cal reservar, doncs, les abreviatures per a les llistes o classificacions, els gràfics, les taules o quadres estadístics, els textos publicitaris, etc.
 *
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=abreviacions+mesos&action=Principal&method=detall_completa&numPagina=1&idHit=8402&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=8402&titol=abreviatures%20dels%20mesos%20de%20l%27any&numeroResultat=5&clickLink=detall&tipusCerca=cerca.fitxes
 */ var monthValues = {
    narrow: [
        'GN',
        'FB',
        "M\xc7",
        'AB',
        'MG',
        'JN',
        'JL',
        'AG',
        'ST',
        'OC',
        'NV',
        'DS'
    ],
    /**
   * Les abreviatures dels mesos de l'any es formen seguint una de les normes generals de formació d'abreviatures.
   * S'escriu la primera síl·laba i les consonants de la síl·laba següent anteriors a la primera vocal.
   * Els mesos de març, maig i juny no s'abreugen perquè són paraules d'una sola síl·laba.
   */ abbreviated: [
        'gen.',
        'febr.',
        "mar\xe7",
        'abr.',
        'maig',
        'juny',
        'jul.',
        'ag.',
        'set.',
        'oct.',
        'nov.',
        'des.'
    ],
    wide: [
        'gener',
        'febrer',
        "mar\xe7",
        'abril',
        'maig',
        'juny',
        'juliol',
        'agost',
        'setembre',
        'octubre',
        'novembre',
        'desembre'
    ]
};
/**
 * Les abreviatures dels dies de la setmana comencen totes amb la lletra d.
 * Tot seguit porten la consonant següent a la i, excepte en el cas de dimarts, dimecres i diumenge, en què aquesta consonant és la m i, per tant, hi podria haver confusió.
 * Per evitar-ho, s'ha substituït la m per una t (en el cas de dimarts), una c (en el cas de dimecres) i una g (en el cas de diumenge), respectivament.
 *
 * Seguint la norma general d'ús de les abreviatures, les dels dies de la setmana sempre porten punt final.
 * Igualment, van amb la primera lletra en majúscula quan la paraula sencera també hi aniria.
 * En canvi, van amb la primera lletra en minúscula quan la inicial de la paraula sencera també hi aniria.
 *
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=abreviatures+dies&action=Principal&method=detall_completa&numPagina=1&idHit=8387&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=8387&titol=abreviatures%20dels%20dies%20de%20la%20setmana&numeroResultat=1&clickLink=detall&tipusCerca=cerca.tot
 */ var dayValues = {
    narrow: [
        'dg.',
        'dl.',
        'dt.',
        'dm.',
        'dj.',
        'dv.',
        'ds.'
    ],
    short: [
        'dg.',
        'dl.',
        'dt.',
        'dm.',
        'dj.',
        'dv.',
        'ds.'
    ],
    abbreviated: [
        'dg.',
        'dl.',
        'dt.',
        'dm.',
        'dj.',
        'dv.',
        'ds.'
    ],
    wide: [
        'diumenge',
        'dilluns',
        'dimarts',
        'dimecres',
        'dijous',
        'divendres',
        'dissabte'
    ]
};
/**
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?action=Principal&method=detall&input_cercar=parts+del+dia&numPagina=1&database=FITXES_PUB&idFont=12801&idHit=12801&tipusFont=Fitxes+de+l%27Optimot&numeroResultat=1&databases_avansada=&categories_avansada=&clickLink=detall&titol=Nom+de+les+parts+del+dia&tematica=&tipusCerca=cerca.fitxes
 */ var dayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: 'mitjanit',
        noon: 'migdia',
        morning: "mat\xed",
        afternoon: 'tarda',
        evening: 'vespre',
        night: 'nit'
    },
    abbreviated: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'mitjanit',
        noon: 'migdia',
        morning: "mat\xed",
        afternoon: 'tarda',
        evening: 'vespre',
        night: 'nit'
    },
    wide: {
        am: 'ante meridiem',
        pm: 'post meridiem',
        midnight: 'mitjanit',
        noon: 'migdia',
        morning: "mat\xed",
        afternoon: 'tarda',
        evening: 'vespre',
        night: 'nit'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: 'de la mitjanit',
        noon: 'del migdia',
        morning: "del mat\xed",
        afternoon: 'de la tarda',
        evening: 'del vespre',
        night: 'de la nit'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'de la mitjanit',
        noon: 'del migdia',
        morning: "del mat\xed",
        afternoon: 'de la tarda',
        evening: 'del vespre',
        night: 'de la nit'
    },
    wide: {
        am: 'ante meridiem',
        pm: 'post meridiem',
        midnight: 'de la mitjanit',
        noon: 'del migdia',
        morning: "del mat\xed",
        afternoon: 'de la tarda',
        evening: 'del vespre',
        night: 'de la nit'
    }
};
/**
 * Quan van en singular, els nombres ordinals es representen, en forma d’abreviatura, amb la xifra seguida de l’última lletra del mot desplegat.
 * És optatiu posar punt després de la lletra.
 *
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/pdf/abrevia.pdf#page=18
 */ var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'r';
        case 2:
            return number + 'n';
        case 3:
            return number + 'r';
        case 4:
            return number + 't';
    }
    return number + "\xe8";
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5isY2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(è|r|n|r|t)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(aC|dC)/i,
    abbreviated: /^(a. de C.|d. de C.)/i,
    wide: /^(abans de Crist|despr[eé]s de Crist)/i
};
var parseEraPatterns = {
    narrow: [
        /^aC/i,
        /^dC/i
    ],
    abbreviated: [
        /^(a. de C.)/i,
        /^(d. de C.)/i
    ],
    wide: [
        /^(abans de Crist)/i,
        /^(despr[eé]s de Crist)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](è|r|n|r|t)? trimestre/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^(GN|FB|MÇ|AB|MG|JN|JL|AG|ST|OC|NV|DS)/i,
    abbreviated: /^(gen.|febr.|març|abr.|maig|juny|jul.|ag.|set.|oct.|nov.|des.)/i,
    wide: /^(gener|febrer|març|abril|maig|juny|juliol|agost|setembre|octubre|novembre|desembre)/i
};
var parseMonthPatterns = {
    narrow: [
        /^GN/i,
        /^FB/i,
        /^MÇ/i,
        /^AB/i,
        /^MG/i,
        /^JN/i,
        /^JL/i,
        /^AG/i,
        /^ST/i,
        /^OC/i,
        /^NV/i,
        /^DS/i
    ],
    abbreviated: [
        /^gen./i,
        /^febr./i,
        /^març/i,
        /^abr./i,
        /^maig/i,
        /^juny/i,
        /^jul./i,
        /^ag./i,
        /^set./i,
        /^oct./i,
        /^nov./i,
        /^des./i
    ],
    wide: [
        /^gener/i,
        /^febrer/i,
        /^març/i,
        /^abril/i,
        /^maig/i,
        /^juny/i,
        /^juliol/i,
        /^agost/i,
        /^setembre/i,
        /^octubre/i,
        /^novembre/i,
        /^desembre/i
    ]
};
var matchDayPatterns = {
    narrow: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
    short: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
    abbreviated: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
    wide: /^(diumenge|dilluns|dimarts|dimecres|dijous|divendres|dissabte)/i
};
var parseDayPatterns = {
    narrow: [
        /^dg./i,
        /^dl./i,
        /^dt./i,
        /^dm./i,
        /^dj./i,
        /^dv./i,
        /^ds./i
    ],
    abbreviated: [
        /^dg./i,
        /^dl./i,
        /^dt./i,
        /^dm./i,
        /^dj./i,
        /^dv./i,
        /^ds./i
    ],
    wide: [
        /^diumenge/i,
        /^dilluns/i,
        /^dimarts/i,
        /^dimecres/i,
        /^dijous/i,
        /^divendres/i,
        /^disssabte/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|md|(del|de la) (matí|tarda|vespre|nit))/i,
    abbreviated: /^([ap]\.?\s?m\.?|mitjanit|migdia|(del|de la) (matí|tarda|vespre|nit))/i,
    wide: /^(ante meridiem|post meridiem|mitjanit|migdia|(del|de la) (matí|tarda|vespre|nit))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mitjanit/i,
        noon: /^migdia/i,
        morning: /matí/i,
        afternoon: /tarda/i,
        evening: /vespre/i,
        night: /nit/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1dSKu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Czech locale.
 * @language Czech
 * @iso-639-2 ces
 * @author David Rus [@davidrus]{@link https://github.com/davidrus}
 * @author Pavel Hrách [@SilenY]{@link https://github.com/SilenY}
 * @author Jozef Bíroš [@JozefBiros]{@link https://github.com/JozefBiros}
 */ var locale = {
    code: 'cs',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"5hXHa","./_lib/formatLong/index.js":"dKdyT","./_lib/formatRelative/index.js":"eY6VG","./_lib/localize/index.js":"lkagl","./_lib/match/index.js":"9HJjk","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5hXHa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            regular: "m\xe9n\u011B ne\u017E sekunda",
            past: "p\u0159ed m\xe9n\u011B ne\u017E sekundou",
            future: "za m\xe9n\u011B ne\u017E sekundu"
        },
        few: {
            regular: "m\xe9n\u011B ne\u017E {{count}} sekundy",
            past: "p\u0159ed m\xe9n\u011B ne\u017E {{count}} sekundami",
            future: "za m\xe9n\u011B ne\u017E {{count}} sekundy"
        },
        many: {
            regular: "m\xe9n\u011B ne\u017E {{count}} sekund",
            past: "p\u0159ed m\xe9n\u011B ne\u017E {{count}} sekundami",
            future: "za m\xe9n\u011B ne\u017E {{count}} sekund"
        }
    },
    xSeconds: {
        one: {
            regular: 'sekunda',
            past: "p\u0159ed sekundou",
            future: 'za sekundu'
        },
        few: {
            regular: '{{count}} sekundy',
            past: "p\u0159ed {{count}} sekundami",
            future: 'za {{count}} sekundy'
        },
        many: {
            regular: '{{count}} sekund',
            past: "p\u0159ed {{count}} sekundami",
            future: 'za {{count}} sekund'
        }
    },
    halfAMinute: {
        type: 'other',
        other: {
            regular: "p\u016Fl minuty",
            past: "p\u0159ed p\u016Fl minutou",
            future: "za p\u016Fl minuty"
        }
    },
    lessThanXMinutes: {
        one: {
            regular: "m\xe9n\u011B ne\u017E minuta",
            past: "p\u0159ed m\xe9n\u011B ne\u017E minutou",
            future: "za m\xe9n\u011B ne\u017E minutu"
        },
        few: {
            regular: "m\xe9n\u011B ne\u017E {{count}} minuty",
            past: "p\u0159ed m\xe9n\u011B ne\u017E {{count}} minutami",
            future: "za m\xe9n\u011B ne\u017E {{count}} minuty"
        },
        many: {
            regular: "m\xe9n\u011B ne\u017E {{count}} minut",
            past: "p\u0159ed m\xe9n\u011B ne\u017E {{count}} minutami",
            future: "za m\xe9n\u011B ne\u017E {{count}} minut"
        }
    },
    xMinutes: {
        one: {
            regular: 'minuta',
            past: "p\u0159ed minutou",
            future: 'za minutu'
        },
        few: {
            regular: '{{count}} minuty',
            past: "p\u0159ed {{count}} minutami",
            future: 'za {{count}} minuty'
        },
        many: {
            regular: '{{count}} minut',
            past: "p\u0159ed {{count}} minutami",
            future: 'za {{count}} minut'
        }
    },
    aboutXHours: {
        one: {
            regular: "p\u0159ibli\u017En\u011B hodina",
            past: "p\u0159ibli\u017En\u011B p\u0159ed hodinou",
            future: "p\u0159ibli\u017En\u011B za hodinu"
        },
        few: {
            regular: "p\u0159ibli\u017En\u011B {{count}} hodiny",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} hodinami",
            future: "p\u0159ibli\u017En\u011B za {{count}} hodiny"
        },
        many: {
            regular: "p\u0159ibli\u017En\u011B {{count}} hodin",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} hodinami",
            future: "p\u0159ibli\u017En\u011B za {{count}} hodin"
        }
    },
    xHours: {
        one: {
            regular: 'hodina',
            past: "p\u0159ed hodinou",
            future: 'za hodinu'
        },
        few: {
            regular: '{{count}} hodiny',
            past: "p\u0159ed {{count}} hodinami",
            future: 'za {{count}} hodiny'
        },
        many: {
            regular: '{{count}} hodin',
            past: "p\u0159ed {{count}} hodinami",
            future: 'za {{count}} hodin'
        }
    },
    xDays: {
        one: {
            regular: 'den',
            past: "p\u0159ed dnem",
            future: 'za den'
        },
        few: {
            regular: '{{count}} dny',
            past: "p\u0159ed {{count}} dny",
            future: 'za {{count}} dny'
        },
        many: {
            regular: "{{count}} dn\xed",
            past: "p\u0159ed {{count}} dny",
            future: "za {{count}} dn\xed"
        }
    },
    aboutXWeeks: {
        one: {
            regular: "p\u0159ibli\u017En\u011B t\xfdden",
            past: "p\u0159ibli\u017En\u011B p\u0159ed t\xfddnem",
            future: "p\u0159ibli\u017En\u011B za t\xfdden"
        },
        few: {
            regular: "p\u0159ibli\u017En\u011B {{count}} t\xfddny",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} t\xfddny",
            future: "p\u0159ibli\u017En\u011B za {{count}} t\xfddny"
        },
        many: {
            regular: "p\u0159ibli\u017En\u011B {{count}} t\xfddn\u016F",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} t\xfddny",
            future: "p\u0159ibli\u017En\u011B za {{count}} t\xfddn\u016F"
        }
    },
    xWeeks: {
        one: {
            regular: "t\xfdden",
            past: "p\u0159ed t\xfddnem",
            future: "za t\xfdden"
        },
        few: {
            regular: "{{count}} t\xfddny",
            past: "p\u0159ed {{count}} t\xfddny",
            future: "za {{count}} t\xfddny"
        },
        many: {
            regular: "{{count}} t\xfddn\u016F",
            past: "p\u0159ed {{count}} t\xfddny",
            future: "za {{count}} t\xfddn\u016F"
        }
    },
    aboutXMonths: {
        one: {
            regular: "p\u0159ibli\u017En\u011B m\u011Bs\xedc",
            past: "p\u0159ibli\u017En\u011B p\u0159ed m\u011Bs\xedcem",
            future: "p\u0159ibli\u017En\u011B za m\u011Bs\xedc"
        },
        few: {
            regular: "p\u0159ibli\u017En\u011B {{count}} m\u011Bs\xedce",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} m\u011Bs\xedci",
            future: "p\u0159ibli\u017En\u011B za {{count}} m\u011Bs\xedce"
        },
        many: {
            regular: "p\u0159ibli\u017En\u011B {{count}} m\u011Bs\xedc\u016F",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} m\u011Bs\xedci",
            future: "p\u0159ibli\u017En\u011B za {{count}} m\u011Bs\xedc\u016F"
        }
    },
    xMonths: {
        one: {
            regular: "m\u011Bs\xedc",
            past: "p\u0159ed m\u011Bs\xedcem",
            future: "za m\u011Bs\xedc"
        },
        few: {
            regular: "{{count}} m\u011Bs\xedce",
            past: "p\u0159ed {{count}} m\u011Bs\xedci",
            future: "za {{count}} m\u011Bs\xedce"
        },
        many: {
            regular: "{{count}} m\u011Bs\xedc\u016F",
            past: "p\u0159ed {{count}} m\u011Bs\xedci",
            future: "za {{count}} m\u011Bs\xedc\u016F"
        }
    },
    aboutXYears: {
        one: {
            regular: "p\u0159ibli\u017En\u011B rok",
            past: "p\u0159ibli\u017En\u011B p\u0159ed rokem",
            future: "p\u0159ibli\u017En\u011B za rok"
        },
        few: {
            regular: "p\u0159ibli\u017En\u011B {{count}} roky",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} roky",
            future: "p\u0159ibli\u017En\u011B za {{count}} roky"
        },
        many: {
            regular: "p\u0159ibli\u017En\u011B {{count}} rok\u016F",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} roky",
            future: "p\u0159ibli\u017En\u011B za {{count}} rok\u016F"
        }
    },
    xYears: {
        one: {
            regular: 'rok',
            past: "p\u0159ed rokem",
            future: 'za rok'
        },
        few: {
            regular: '{{count}} roky',
            past: "p\u0159ed {{count}} roky",
            future: 'za {{count}} roky'
        },
        many: {
            regular: "{{count}} rok\u016F",
            past: "p\u0159ed {{count}} roky",
            future: "za {{count}} rok\u016F"
        }
    },
    overXYears: {
        one: {
            regular: "v\xedce ne\u017E rok",
            past: "p\u0159ed v\xedce ne\u017E rokem",
            future: "za v\xedce ne\u017E rok"
        },
        few: {
            regular: "v\xedce ne\u017E {{count}} roky",
            past: "p\u0159ed v\xedce ne\u017E {{count}} roky",
            future: "za v\xedce ne\u017E {{count}} roky"
        },
        many: {
            regular: "v\xedce ne\u017E {{count}} rok\u016F",
            past: "p\u0159ed v\xedce ne\u017E {{count}} roky",
            future: "za v\xedce ne\u017E {{count}} rok\u016F"
        }
    },
    almostXYears: {
        one: {
            regular: 'skoro rok',
            past: "skoro p\u0159ed rokem",
            future: 'skoro za rok'
        },
        few: {
            regular: 'skoro {{count}} roky',
            past: "skoro p\u0159ed {{count}} roky",
            future: 'skoro za {{count}} roky'
        },
        many: {
            regular: "skoro {{count}} rok\u016F",
            past: "skoro p\u0159ed {{count}} roky",
            future: "skoro za {{count}} rok\u016F"
        }
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var pluralResult;
    var tokenValue = formatDistanceLocale[token];
    // cs pluralization
    if (tokenValue.type === 'other') pluralResult = tokenValue.other;
    else if (count === 1) pluralResult = tokenValue.one;
    else if (count > 1 && count < 5) pluralResult = tokenValue.few;
    else pluralResult = tokenValue.many;
    // times
    var suffixExist = (options === null || options === void 0 ? void 0 : options.addSuffix) === true;
    var comparison = options === null || options === void 0 ? void 0 : options.comparison;
    var timeResult;
    if (suffixExist && comparison === -1) timeResult = pluralResult.past;
    else if (suffixExist && comparison === 1) timeResult = pluralResult.future;
    else timeResult = pluralResult.regular;
    return timeResult.replace('{{count}}', String(count));
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"dKdyT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, d. MMMM yyyy',
    long: 'd. MMMM yyyy',
    medium: 'd. M. yyyy',
    short: 'dd.MM.yyyy'
};
var timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'v' {{time}}",
    long: "{{date}} 'v' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"eY6VG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var accusativeWeekdays = [
    "ned\u011Bli",
    "pond\u011Bl\xed",
    "\xfater\xfd",
    "st\u0159edu",
    "\u010Dtvrtek",
    "p\xe1tek",
    'sobotu'
];
var formatRelativeLocale = {
    lastWeek: "'posledn\xed' eeee 've' p",
    yesterday: "'v\u010Dera v' p",
    today: "'dnes v' p",
    tomorrow: "'z\xedtra v' p",
    nextWeek: function nextWeek(date) {
        var day = date.getUTCDay();
        return "'v " + accusativeWeekdays[day] + " o' p";
    },
    other: 'P'
};
var formatRelative = function formatRelative(token, date) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"lkagl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "p\u0159. n. l.",
        'n. l.'
    ],
    abbreviated: [
        "p\u0159. n. l.",
        'n. l.'
    ],
    wide: [
        "p\u0159ed na\u0161\xedm letopo\u010Dtem",
        "na\u0161eho letopo\u010Dtu"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1. \u010Dtvrtlet\xed",
        "2. \u010Dtvrtlet\xed",
        "3. \u010Dtvrtlet\xed",
        "4. \u010Dtvrtlet\xed"
    ],
    wide: [
        "1. \u010Dtvrtlet\xed",
        "2. \u010Dtvrtlet\xed",
        "3. \u010Dtvrtlet\xed",
        "4. \u010Dtvrtlet\xed"
    ]
};
var monthValues = {
    narrow: [
        'L',
        "\xda",
        'B',
        'D',
        'K',
        "\u010C",
        "\u010C",
        'S',
        'Z',
        "\u0158",
        'L',
        'P'
    ],
    abbreviated: [
        'led',
        "\xfano",
        "b\u0159e",
        'dub',
        "kv\u011B",
        "\u010Dvn",
        "\u010Dvc",
        'srp',
        "z\xe1\u0159",
        "\u0159\xedj",
        'lis',
        'pro'
    ],
    wide: [
        'leden',
        "\xfanor",
        "b\u0159ezen",
        'duben',
        "kv\u011Bten",
        "\u010Derven",
        "\u010Dervenec",
        'srpen',
        "z\xe1\u0159\xed",
        "\u0159\xedjen",
        'listopad',
        'prosinec'
    ]
};
var formattingMonthValues = {
    narrow: [
        'L',
        "\xda",
        'B',
        'D',
        'K',
        "\u010C",
        "\u010C",
        'S',
        'Z',
        "\u0158",
        'L',
        'P'
    ],
    abbreviated: [
        'led',
        "\xfano",
        "b\u0159e",
        'dub',
        "kv\u011B",
        "\u010Dvn",
        "\u010Dvc",
        'srp',
        "z\xe1\u0159",
        "\u0159\xedj",
        'lis',
        'pro'
    ],
    wide: [
        'ledna',
        "\xfanora",
        "b\u0159ezna",
        'dubna',
        "kv\u011Btna",
        "\u010Dervna",
        "\u010Dervence",
        'srpna',
        "z\xe1\u0159\xed",
        "\u0159\xedjna",
        'listopadu',
        'prosince'
    ]
};
var dayValues = {
    narrow: [
        'ne',
        'po',
        "\xfat",
        'st',
        "\u010Dt",
        "p\xe1",
        'so'
    ],
    short: [
        'ne',
        'po',
        "\xfat",
        'st',
        "\u010Dt",
        "p\xe1",
        'so'
    ],
    abbreviated: [
        'ned',
        'pon',
        "\xfate",
        "st\u0159",
        "\u010Dtv",
        "p\xe1t",
        'sob'
    ],
    wide: [
        "ned\u011Ble",
        "pond\u011Bl\xed",
        "\xfater\xfd",
        "st\u0159eda",
        "\u010Dtvrtek",
        "p\xe1tek",
        'sobota'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'dop.',
        pm: 'odp.',
        midnight: "p\u016Flnoc",
        noon: 'poledne',
        morning: "r\xe1no",
        afternoon: 'odpoledne',
        evening: "ve\u010Der",
        night: 'noc'
    },
    abbreviated: {
        am: 'dop.',
        pm: 'odp.',
        midnight: "p\u016Flnoc",
        noon: 'poledne',
        morning: "r\xe1no",
        afternoon: 'odpoledne',
        evening: "ve\u010Der",
        night: 'noc'
    },
    wide: {
        am: 'dopoledne',
        pm: 'odpoledne',
        midnight: "p\u016Flnoc",
        noon: 'poledne',
        morning: "r\xe1no",
        afternoon: 'odpoledne',
        evening: "ve\u010Der",
        night: 'noc'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'dop.',
        pm: 'odp.',
        midnight: "p\u016Flnoc",
        noon: 'poledne',
        morning: "r\xe1no",
        afternoon: 'odpoledne',
        evening: "ve\u010Der",
        night: 'noc'
    },
    abbreviated: {
        am: 'dop.',
        pm: 'odp.',
        midnight: "p\u016Flnoc",
        noon: 'poledne',
        morning: "r\xe1no",
        afternoon: 'odpoledne',
        evening: "ve\u010Der",
        night: 'noc'
    },
    wide: {
        am: 'dopoledne',
        pm: 'odpoledne',
        midnight: "p\u016Flnoc",
        noon: 'poledne',
        morning: "r\xe1no",
        afternoon: 'odpoledne',
        evening: "ve\u010Der",
        night: 'noc'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide',
        formattingValues: formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"9HJjk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)\.?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(p[řr](\.|ed) Kr\.|p[řr](\.|ed) n\. l\.|po Kr\.|n\. l\.)/i,
    abbreviated: /^(p[řr](\.|ed) Kr\.|p[řr](\.|ed) n\. l\.|po Kr\.|n\. l\.)/i,
    wide: /^(p[řr](\.|ed) Kristem|p[řr](\.|ed) na[šs][íi]m letopo[čc]tem|po Kristu|na[šs]eho letopo[čc]tu)/i
};
var parseEraPatterns = {
    any: [
        /^p[řr]/i,
        /^(po|n)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\. [čc]tvrtlet[íi]/i,
    wide: /^[1234]\. [čc]tvrtlet[íi]/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[lúubdkčcszřrlp]/i,
    abbreviated: /^(led|[úu]no|b[řr]e|dub|kv[ěe]|[čc]vn|[čc]vc|srp|z[áa][řr]|[řr][íi]j|lis|pro)/i,
    wide: /^(leden|ledna|[úu]nora?|b[řr]ezen|b[řr]ezna|duben|dubna|kv[ěe]ten|kv[ěe]tna|[čc]erven(ec|ce)?|[čc]ervna|srpen|srpna|z[áa][řr][íi]|[řr][íi]jen|[řr][íi]jna|listopad(a|u)?|prosinec|prosince)/i
};
var parseMonthPatterns = {
    narrow: [
        /^l/i,
        /^[úu]/i,
        /^b/i,
        /^d/i,
        /^k/i,
        /^[čc]/i,
        /^[čc]/i,
        /^s/i,
        /^z/i,
        /^[řr]/i,
        /^l/i,
        /^p/i
    ],
    any: [
        /^led/i,
        /^[úu]n/i,
        /^b[řr]e/i,
        /^dub/i,
        /^kv[ěe]/i,
        /^[čc]vn|[čc]erven(?!\w)|[čc]ervna/i,
        /^[čc]vc|[čc]erven(ec|ce)/i,
        /^srp/i,
        /^z[áa][řr]/i,
        /^[řr][íi]j/i,
        /^lis/i,
        /^pro/i
    ]
};
var matchDayPatterns = {
    narrow: /^[npuúsčps]/i,
    short: /^(ne|po|[úu]t|st|[čc]t|p[áa]|so)/i,
    abbreviated: /^(ned|pon|[úu]te|st[rř]|[čc]tv|p[áa]t|sob)/i,
    wide: /^(ned[ěe]le|pond[ěe]l[íi]|[úu]ter[ýy]|st[řr]eda|[čc]tvrtek|p[áa]tek|sobota)/i
};
var parseDayPatterns = {
    narrow: [
        /^n/i,
        /^p/i,
        /^[úu]/i,
        /^s/i,
        /^[čc]/i,
        /^p/i,
        /^s/i
    ],
    any: [
        /^ne/i,
        /^po/i,
        /^[úu]t/i,
        /^st/i,
        /^[čc]t/i,
        /^p[áa]/i,
        /^so/i
    ]
};
var matchDayPeriodPatterns = {
    any: /^dopoledne|dop\.?|odpoledne|odp\.?|p[ůu]lnoc|poledne|r[áa]no|odpoledne|ve[čc]er|(v )?noci?/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^dop/i,
        pm: /^odp/i,
        midnight: /^p[ůu]lnoc/i,
        noon: /^poledne/i,
        morning: /r[áa]no/i,
        afternoon: /odpoledne/i,
        evening: /ve[čc]er/i,
        night: /noc/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8LyIw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Welsh locale.
 * @language Welsh
 * @iso-639-2 cym
 * @author Elwyn Malethan [@elmomalmo]{@link https://github.com/elmomalmo}
 */ var locale = {
    code: 'cy',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"geoDG","./_lib/formatLong/index.js":"fDEQy","./_lib/formatRelative/index.js":"d52Ch","./_lib/localize/index.js":"6DvPJ","./_lib/match/index.js":"65FhV","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"geoDG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'llai na eiliad',
        other: 'llai na {{count}} eiliad'
    },
    xSeconds: {
        one: '1 eiliad',
        other: '{{count}} eiliad'
    },
    halfAMinute: 'hanner munud',
    lessThanXMinutes: {
        one: 'llai na munud',
        two: 'llai na 2 funud',
        other: 'llai na {{count}} munud'
    },
    xMinutes: {
        one: '1 munud',
        two: '2 funud',
        other: '{{count}} munud'
    },
    aboutXHours: {
        one: 'tua 1 awr',
        other: 'tua {{count}} awr'
    },
    xHours: {
        one: '1 awr',
        other: '{{count}} awr'
    },
    xDays: {
        one: '1 diwrnod',
        two: '2 ddiwrnod',
        other: '{{count}} diwrnod'
    },
    aboutXWeeks: {
        one: 'tua 1 wythnos',
        two: 'tua pythefnos',
        other: 'tua {{count}} wythnos'
    },
    xWeeks: {
        one: '1 wythnos',
        two: 'pythefnos',
        other: '{{count}} wythnos'
    },
    aboutXMonths: {
        one: 'tua 1 mis',
        two: 'tua 2 fis',
        other: 'tua {{count}} mis'
    },
    xMonths: {
        one: '1 mis',
        two: '2 fis',
        other: '{{count}} mis'
    },
    aboutXYears: {
        one: 'tua 1 flwyddyn',
        two: 'tua 2 flynedd',
        other: 'tua {{count}} mlynedd'
    },
    xYears: {
        one: '1 flwyddyn',
        two: '2 flynedd',
        other: '{{count}} mlynedd'
    },
    overXYears: {
        one: 'dros 1 flwyddyn',
        two: 'dros 2 flynedd',
        other: 'dros {{count}} mlynedd'
    },
    almostXYears: {
        one: 'bron 1 flwyddyn',
        two: 'bron 2 flynedd',
        other: 'bron {{count}} mlynedd'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2 && !!tokenValue.two) result = tokenValue.two;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'mewn ' + result;
        else return result + " yn \xf4l";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"fDEQy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'dd/MM/yyyy'
};
var timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var dateTimeFormats = {
    full: "{{date}} 'am' {{time}}",
    long: "{{date}} 'am' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"d52Ch":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "eeee 'diwethaf am' p",
    yesterday: "'ddoe am' p",
    today: "'heddiw am' p",
    tomorrow: "'yfory am' p",
    nextWeek: "eeee 'am' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6DvPJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'C',
        'O'
    ],
    abbreviated: [
        'CC',
        'OC'
    ],
    wide: [
        'Cyn Crist',
        "Ar \xf4l Crist"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Ch1',
        'Ch2',
        'Ch3',
        'Ch4'
    ],
    wide: [
        'Chwarter 1af',
        '2ail chwarter',
        '3ydd chwarter',
        '4ydd chwarter'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
    narrow: [
        'I',
        'Ch',
        'Ma',
        'E',
        'Mi',
        'Me',
        'G',
        'A',
        'Md',
        'H',
        'T',
        'Rh'
    ],
    abbreviated: [
        'Ion',
        'Chwe',
        'Maw',
        'Ebr',
        'Mai',
        'Meh',
        'Gor',
        'Aws',
        'Med',
        'Hyd',
        'Tach',
        'Rhag'
    ],
    wide: [
        'Ionawr',
        'Chwefror',
        'Mawrth',
        'Ebrill',
        'Mai',
        'Mehefin',
        'Gorffennaf',
        'Awst',
        'Medi',
        'Hydref',
        'Tachwedd',
        'Rhagfyr'
    ]
};
var dayValues = {
    narrow: [
        'S',
        'Ll',
        'M',
        'M',
        'I',
        'G',
        'S'
    ],
    short: [
        'Su',
        'Ll',
        'Ma',
        'Me',
        'Ia',
        'Gw',
        'Sa'
    ],
    abbreviated: [
        'Sul',
        'Llun',
        'Maw',
        'Mer',
        'Iau',
        'Gwe',
        'Sad'
    ],
    wide: [
        'dydd Sul',
        'dydd Llun',
        'dydd Mawrth',
        'dydd Mercher',
        'dydd Iau',
        'dydd Gwener',
        'dydd Sadwrn'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'b',
        pm: 'h',
        midnight: 'hn',
        noon: 'hd',
        morning: 'bore',
        afternoon: 'prynhawn',
        evening: "gyda'r nos",
        night: 'nos'
    },
    abbreviated: {
        am: 'yb',
        pm: 'yh',
        midnight: 'hanner nos',
        noon: 'hanner dydd',
        morning: 'bore',
        afternoon: 'prynhawn',
        evening: "gyda'r nos",
        night: 'nos'
    },
    wide: {
        am: 'y.b.',
        pm: 'y.h.',
        midnight: 'hanner nos',
        noon: 'hanner dydd',
        morning: 'bore',
        afternoon: 'prynhawn',
        evening: "gyda'r nos",
        night: 'nos'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'b',
        pm: 'h',
        midnight: 'hn',
        noon: 'hd',
        morning: 'yn y bore',
        afternoon: 'yn y prynhawn',
        evening: "gyda'r nos",
        night: 'yn y nos'
    },
    abbreviated: {
        am: 'yb',
        pm: 'yh',
        midnight: 'hanner nos',
        noon: 'hanner dydd',
        morning: 'yn y bore',
        afternoon: 'yn y prynhawn',
        evening: "gyda'r nos",
        night: 'yn y nos'
    },
    wide: {
        am: 'y.b.',
        pm: 'y.h.',
        midnight: 'hanner nos',
        noon: 'hanner dydd',
        morning: 'yn y bore',
        afternoon: 'yn y prynhawn',
        evening: "gyda'r nos",
        night: 'yn y nos'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    if (number < 20) switch(number){
        case 0:
            return number + 'fed';
        case 1:
            return number + 'af';
        case 2:
            return number + 'ail';
        case 3:
        case 4:
            return number + 'ydd';
        case 5:
        case 6:
            return number + 'ed';
        case 7:
        case 8:
        case 9:
        case 10:
        case 12:
        case 15:
        case 18:
            return number + 'fed';
        case 11:
        case 13:
        case 14:
        case 16:
        case 17:
        case 19:
            return number + 'eg';
    }
    else if (number >= 50 && number <= 60 || number === 80 || number >= 100) return number + 'fed';
    return number + 'ain';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"65FhV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(af|ail|ydd|ed|fed|eg|ain)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(c|o)/i,
    abbreviated: /^(c\.?\s?c\.?|o\.?\s?c\.?)/i,
    wide: /^(cyn christ|ar ôl crist|ar ol crist)/i
};
var parseEraPatterns = {
    wide: [
        /^c/i,
        /^(ar ôl crist|ar ol crist)/i
    ],
    any: [
        /^c/i,
        /^o/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ch[1234]/i,
    wide: /^(chwarter 1af)|([234](ail|ydd)? chwarter)/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^(i|ch|m|e|g|a|h|t|rh)/i,
    abbreviated: /^(ion|chwe|maw|ebr|mai|meh|gor|aws|med|hyd|tach|rhag)/i,
    wide: /^(ionawr|chwefror|mawrth|ebrill|mai|mehefin|gorffennaf|awst|medi|hydref|tachwedd|rhagfyr)/i
};
var parseMonthPatterns = {
    narrow: [
        /^i/i,
        /^ch/i,
        /^m/i,
        /^e/i,
        /^m/i,
        /^m/i,
        /^g/i,
        /^a/i,
        /^m/i,
        /^h/i,
        /^t/i,
        /^rh/i
    ],
    any: [
        /^io/i,
        /^ch/i,
        /^maw/i,
        /^e/i,
        /^mai/i,
        /^meh/i,
        /^g/i,
        /^a/i,
        /^med/i,
        /^h/i,
        /^t/i,
        /^rh/i
    ]
};
var matchDayPatterns = {
    narrow: /^(s|ll|m|i|g)/i,
    short: /^(su|ll|ma|me|ia|gw|sa)/i,
    abbreviated: /^(sul|llun|maw|mer|iau|gwe|sad)/i,
    wide: /^dydd (sul|llun|mawrth|mercher|iau|gwener|sadwrn)/i
};
var parseDayPatterns = {
    narrow: [
        /^s/i,
        /^ll/i,
        /^m/i,
        /^m/i,
        /^i/i,
        /^g/i,
        /^s/i
    ],
    wide: [
        /^dydd su/i,
        /^dydd ll/i,
        /^dydd ma/i,
        /^dydd me/i,
        /^dydd i/i,
        /^dydd g/i,
        /^dydd sa/i
    ],
    any: [
        /^su/i,
        /^ll/i,
        /^ma/i,
        /^me/i,
        /^i/i,
        /^g/i,
        /^sa/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(b|h|hn|hd|(yn y|y|yr|gyda'r) (bore|prynhawn|nos|hwyr))/i,
    any: /^(y\.?\s?[bh]\.?|hanner nos|hanner dydd|(yn y|y|yr|gyda'r) (bore|prynhawn|nos|hwyr))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^b|(y\.?\s?b\.?)/i,
        pm: /^h|(y\.?\s?h\.?)|(yr hwyr)/i,
        midnight: /^hn|hanner nos/i,
        noon: /^hd|hanner dydd/i,
        morning: /bore/i,
        afternoon: /prynhawn/i,
        evening: /^gyda'r nos$/i,
        night: /blah/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1Vh1w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Danish locale.
 * @language Danish
 * @iso-639-2 dan
 * @author Mathias Wøbbe [@MathiasKandelborg]{@link https://github.com/MathiasKandelborg}
 * @author Anders B. Hansen [@Andersbiha]{@link https://github.com/Andersbiha}
 * @author [@kgram]{@link https://github.com/kgram}
 * @author [@stefanbugge]{@link https://github.com/stefanbugge}
 */ var locale = {
    code: 'da',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"9h1GU","./_lib/formatLong/index.js":"dKzza","./_lib/formatRelative/index.js":"SGoLW","./_lib/localize/index.js":"juXsI","./_lib/match/index.js":"e4v9Z","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"9h1GU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mindre end \xe9t sekund",
        other: 'mindre end {{count}} sekunder'
    },
    xSeconds: {
        one: '1 sekund',
        other: '{{count}} sekunder'
    },
    halfAMinute: "\xe9t halvt minut",
    lessThanXMinutes: {
        one: "mindre end \xe9t minut",
        other: 'mindre end {{count}} minutter'
    },
    xMinutes: {
        one: '1 minut',
        other: '{{count}} minutter'
    },
    aboutXHours: {
        one: 'cirka 1 time',
        other: 'cirka {{count}} timer'
    },
    xHours: {
        one: '1 time',
        other: '{{count}} timer'
    },
    xDays: {
        one: '1 dag',
        other: '{{count}} dage'
    },
    aboutXWeeks: {
        one: 'cirka 1 uge',
        other: 'cirka {{count}} uger'
    },
    xWeeks: {
        one: '1 uge',
        other: '{{count}} uger'
    },
    aboutXMonths: {
        one: "cirka 1 m\xe5ned",
        other: "cirka {{count}} m\xe5neder"
    },
    xMonths: {
        one: "1 m\xe5ned",
        other: "{{count}} m\xe5neder"
    },
    aboutXYears: {
        one: "cirka 1 \xe5r",
        other: "cirka {{count}} \xe5r"
    },
    xYears: {
        one: "1 \xe5r",
        other: "{{count}} \xe5r"
    },
    overXYears: {
        one: "over 1 \xe5r",
        other: "over {{count}} \xe5r"
    },
    almostXYears: {
        one: "n\xe6sten 1 \xe5r",
        other: "n\xe6sten {{count}} \xe5r"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'om ' + result;
        else return result + ' siden';
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"dKzza":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE 'den' d. MMMM y",
    long: 'd. MMMM y',
    medium: 'd. MMM y',
    short: 'dd/MM/y'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'kl'. {{time}}",
    long: "{{date}} 'kl'. {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"SGoLW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'sidste' eeee 'kl.' p",
    yesterday: "'i g\xe5r kl.' p",
    today: "'i dag kl.' p",
    tomorrow: "'i morgen kl.' p",
    nextWeek: "'p\xe5' eeee 'kl.' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"juXsI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'fvt',
        'vt'
    ],
    abbreviated: [
        'f.v.t.',
        'v.t.'
    ],
    wide: [
        "f\xf8r vesterlandsk tidsregning",
        'vesterlandsk tidsregning'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        '1. kvt.',
        '2. kvt.',
        '3. kvt.',
        '4. kvt.'
    ],
    wide: [
        '1. kvartal',
        '2. kvartal',
        '3. kvartal',
        '4. kvartal'
    ]
};
var monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mar.',
        'apr.',
        'maj',
        'jun.',
        'jul.',
        'aug.',
        'sep.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        'januar',
        'februar',
        'marts',
        'april',
        'maj',
        'juni',
        'juli',
        'august',
        'september',
        'oktober',
        'november',
        'december'
    ]
};
// Note that 'Days - abbreviated - Formatting' has periods at the end.
// https://www.unicode.org/cldr/charts/32/summary/da.html#1760
// This makes grammatical sense in danish, as most abbreviations have periods.
var dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'O',
        'T',
        'F',
        'L'
    ],
    short: [
        "s\xf8",
        'ma',
        'ti',
        'on',
        'to',
        'fr',
        "l\xf8"
    ],
    abbreviated: [
        "s\xf8n.",
        'man.',
        'tir.',
        'ons.',
        'tor.',
        'fre.',
        "l\xf8r."
    ],
    wide: [
        "s\xf8ndag",
        'mandag',
        'tirsdag',
        'onsdag',
        'torsdag',
        'fredag',
        "l\xf8rdag"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'midnat',
        noon: 'middag',
        morning: 'morgen',
        afternoon: 'eftermiddag',
        evening: 'aften',
        night: 'nat'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnat',
        noon: 'middag',
        morning: 'morgen',
        afternoon: 'eftermiddag',
        evening: 'aften',
        night: 'nat'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnat',
        noon: 'middag',
        morning: 'morgen',
        afternoon: 'eftermiddag',
        evening: 'aften',
        night: 'nat'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'midnat',
        noon: 'middag',
        morning: 'om morgenen',
        afternoon: 'om eftermiddagen',
        evening: 'om aftenen',
        night: 'om natten'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnat',
        noon: 'middag',
        morning: 'om morgenen',
        afternoon: 'om eftermiddagen',
        evening: 'om aftenen',
        night: 'om natten'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnat',
        noon: 'middag',
        morning: 'om morgenen',
        afternoon: 'om eftermiddagen',
        evening: 'om aftenen',
        night: 'om natten'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"e4v9Z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(fKr|fvt|eKr|vt)/i,
    abbreviated: /^(f\.Kr\.?|f\.v\.t\.?|e\.Kr\.?|v\.t\.)/i,
    wide: /^(f.Kr.|før vesterlandsk tidsregning|e.Kr.|vesterlandsk tidsregning)/i
};
var parseEraPatterns = {
    any: [
        /^f/i,
        /^(v|e)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]. kvt\./i,
    wide: /^[1234]\.? kvartal/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mar.|apr.|maj|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
    wide: /^(januar|februar|marts|april|maj|juni|juli|august|september|oktober|november|december)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[smtofl]/i,
    short: /^(søn.|man.|tir.|ons.|tor.|fre.|lør.)/i,
    abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
    wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
};
var parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^o/i,
        /^t/i,
        /^f/i,
        /^l/i
    ],
    any: [
        /^s/i,
        /^m/i,
        /^ti/i,
        /^o/i,
        /^to/i,
        /^f/i,
        /^l/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i,
    any: /^([ap]\.?\s?m\.?|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /midnat/i,
        noon: /middag/i,
        morning: /morgen/i,
        afternoon: /eftermiddag/i,
        evening: /aften/i,
        night: /nat/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4O0vS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary German locale.
 * @language German
 * @iso-639-2 deu
 * @author Thomas Eilmsteiner [@DeMuu]{@link https://github.com/DeMuu}
 * @author Asia [@asia-t]{@link https://github.com/asia-t}
 * @author Van Vuong Ngo [@vanvuongngo]{@link https://github.com/vanvuongngo}
 * @author RomanErnst [@pex]{@link https://github.com/pex}
 * @author Philipp Keck [@Philipp91]{@link https://github.com/Philipp91}
 */ var locale = {
    code: 'de',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"gI24M","./_lib/formatLong/index.js":"2G0du","./_lib/formatRelative/index.js":"6y0DO","./_lib/localize/index.js":"4GrP2","./_lib/match/index.js":"kYrgz","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gI24M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        standalone: {
            one: 'weniger als 1 Sekunde',
            other: 'weniger als {{count}} Sekunden'
        },
        withPreposition: {
            one: 'weniger als 1 Sekunde',
            other: 'weniger als {{count}} Sekunden'
        }
    },
    xSeconds: {
        standalone: {
            one: '1 Sekunde',
            other: '{{count}} Sekunden'
        },
        withPreposition: {
            one: '1 Sekunde',
            other: '{{count}} Sekunden'
        }
    },
    halfAMinute: {
        standalone: 'halbe Minute',
        withPreposition: 'halben Minute'
    },
    lessThanXMinutes: {
        standalone: {
            one: 'weniger als 1 Minute',
            other: 'weniger als {{count}} Minuten'
        },
        withPreposition: {
            one: 'weniger als 1 Minute',
            other: 'weniger als {{count}} Minuten'
        }
    },
    xMinutes: {
        standalone: {
            one: '1 Minute',
            other: '{{count}} Minuten'
        },
        withPreposition: {
            one: '1 Minute',
            other: '{{count}} Minuten'
        }
    },
    aboutXHours: {
        standalone: {
            one: 'etwa 1 Stunde',
            other: 'etwa {{count}} Stunden'
        },
        withPreposition: {
            one: 'etwa 1 Stunde',
            other: 'etwa {{count}} Stunden'
        }
    },
    xHours: {
        standalone: {
            one: '1 Stunde',
            other: '{{count}} Stunden'
        },
        withPreposition: {
            one: '1 Stunde',
            other: '{{count}} Stunden'
        }
    },
    xDays: {
        standalone: {
            one: '1 Tag',
            other: '{{count}} Tage'
        },
        withPreposition: {
            one: '1 Tag',
            other: '{{count}} Tagen'
        }
    },
    aboutXWeeks: {
        standalone: {
            one: 'etwa 1 Woche',
            other: 'etwa {{count}} Wochen'
        },
        withPreposition: {
            one: 'etwa 1 Woche',
            other: 'etwa {{count}} Wochen'
        }
    },
    xWeeks: {
        standalone: {
            one: '1 Woche',
            other: '{{count}} Wochen'
        },
        withPreposition: {
            one: '1 Woche',
            other: '{{count}} Wochen'
        }
    },
    aboutXMonths: {
        standalone: {
            one: 'etwa 1 Monat',
            other: 'etwa {{count}} Monate'
        },
        withPreposition: {
            one: 'etwa 1 Monat',
            other: 'etwa {{count}} Monaten'
        }
    },
    xMonths: {
        standalone: {
            one: '1 Monat',
            other: '{{count}} Monate'
        },
        withPreposition: {
            one: '1 Monat',
            other: '{{count}} Monaten'
        }
    },
    aboutXYears: {
        standalone: {
            one: 'etwa 1 Jahr',
            other: 'etwa {{count}} Jahre'
        },
        withPreposition: {
            one: 'etwa 1 Jahr',
            other: 'etwa {{count}} Jahren'
        }
    },
    xYears: {
        standalone: {
            one: '1 Jahr',
            other: '{{count}} Jahre'
        },
        withPreposition: {
            one: '1 Jahr',
            other: '{{count}} Jahren'
        }
    },
    overXYears: {
        standalone: {
            one: 'mehr als 1 Jahr',
            other: 'mehr als {{count}} Jahre'
        },
        withPreposition: {
            one: 'mehr als 1 Jahr',
            other: 'mehr als {{count}} Jahren'
        }
    },
    almostXYears: {
        standalone: {
            one: 'fast 1 Jahr',
            other: 'fast {{count}} Jahre'
        },
        withPreposition: {
            one: 'fast 1 Jahr',
            other: 'fast {{count}} Jahren'
        }
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = options !== null && options !== void 0 && options.addSuffix ? formatDistanceLocale[token].withPreposition : formatDistanceLocale[token].standalone;
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return 'vor ' + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2G0du":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
// DIN 5008: https://de.wikipedia.org/wiki/Datumsformat#DIN_5008
var dateFormats = {
    full: 'EEEE, do MMMM y',
    // Montag, 7. Januar 2018
    long: 'do MMMM y',
    // 7. Januar 2018
    medium: 'do MMM y',
    // 7. Jan. 2018
    short: 'dd.MM.y' // 07.01.2018
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'um' {{time}}",
    long: "{{date}} 'um' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6y0DO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'letzten' eeee 'um' p",
    yesterday: "'gestern um' p",
    today: "'heute um' p",
    tomorrow: "'morgen um' p",
    nextWeek: "eeee 'um' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4GrP2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'v.Chr.',
        'n.Chr.'
    ],
    abbreviated: [
        'v.Chr.',
        'n.Chr.'
    ],
    wide: [
        'vor Christus',
        'nach Christus'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1. Quartal',
        '2. Quartal',
        '3. Quartal',
        '4. Quartal'
    ]
};
// Note: in German, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        "M\xe4r",
        'Apr',
        'Mai',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Okt',
        'Nov',
        'Dez'
    ],
    wide: [
        'Januar',
        'Februar',
        "M\xe4rz",
        'April',
        'Mai',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'Dezember'
    ]
};
// https://st.unicode.org/cldr-apps/v#/de/Gregorian/
var formattingMonthValues = {
    narrow: monthValues.narrow,
    abbreviated: [
        'Jan.',
        'Feb.',
        "M\xe4rz",
        'Apr.',
        'Mai',
        'Juni',
        'Juli',
        'Aug.',
        'Sep.',
        'Okt.',
        'Nov.',
        'Dez.'
    ],
    wide: monthValues.wide
};
var dayValues = {
    narrow: [
        'S',
        'M',
        'D',
        'M',
        'D',
        'F',
        'S'
    ],
    short: [
        'So',
        'Mo',
        'Di',
        'Mi',
        'Do',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'So.',
        'Mo.',
        'Di.',
        'Mi.',
        'Do.',
        'Fr.',
        'Sa.'
    ],
    wide: [
        'Sonntag',
        'Montag',
        'Dienstag',
        'Mittwoch',
        'Donnerstag',
        'Freitag',
        'Samstag'
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/de.html#1881
var dayPeriodValues = {
    narrow: {
        am: 'vm.',
        pm: 'nm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'Morgen',
        afternoon: 'Nachm.',
        evening: 'Abend',
        night: 'Nacht'
    },
    abbreviated: {
        am: 'vorm.',
        pm: 'nachm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'Morgen',
        afternoon: 'Nachmittag',
        evening: 'Abend',
        night: 'Nacht'
    },
    wide: {
        am: 'vormittags',
        pm: 'nachmittags',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'Morgen',
        afternoon: 'Nachmittag',
        evening: 'Abend',
        night: 'Nacht'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'vm.',
        pm: 'nm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'morgens',
        afternoon: 'nachm.',
        evening: 'abends',
        night: 'nachts'
    },
    abbreviated: {
        am: 'vorm.',
        pm: 'nachm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'morgens',
        afternoon: 'nachmittags',
        evening: 'abends',
        night: 'nachts'
    },
    wide: {
        am: 'vormittags',
        pm: 'nachmittags',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'morgens',
        afternoon: 'nachmittags',
        evening: 'abends',
        night: 'nachts'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        formattingValues: formattingMonthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"kYrgz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
};
var parseEraPatterns = {
    any: [
        /^v/i,
        /^n/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? Quartal/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
    wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^j[aä]/i,
        /^f/i,
        /^mär/i,
        /^ap/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[smdmf]/i,
    short: /^(so|mo|di|mi|do|fr|sa)/i,
    abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
    wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
};
var parseDayPatterns = {
    any: [
        /^so/i,
        /^mo/i,
        /^di/i,
        /^mi/i,
        /^do/i,
        /^f/i,
        /^sa/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
    abbreviated: /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
    wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^v/i,
        pm: /^n/i,
        midnight: /^Mitte/i,
        noon: /^Mitta/i,
        morning: /morgens/i,
        afternoon: /nachmittags/i,
        // will never be matched. Afternoon is matched by `pm`
        evening: /abends/i,
        night: /nachts/i // will never be matched. Night is matched by `pm`
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gMux1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../de/_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../de/_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../de/_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../de/_lib/match/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
// difference to 'de' locale
var _indexJs4 = require("./_lib/localize/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary German locale (Austria).
 * @language German
 * @iso-639-2 deu
 * @author Christoph Tobias Stenglein [@cstenglein]{@link https://github.com/cstenglein}
 */ var locale = {
    code: 'de-AT',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault4.default),
    match: (0, _indexJsDefault3.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"../de/_lib/formatDistance/index.js":"gI24M","../de/_lib/formatLong/index.js":"2G0du","../de/_lib/formatRelative/index.js":"6y0DO","../de/_lib/match/index.js":"kYrgz","./_lib/localize/index.js":"fq92u","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"fq92u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'v.Chr.',
        'n.Chr.'
    ],
    abbreviated: [
        'v.Chr.',
        'n.Chr.'
    ],
    wide: [
        'vor Christus',
        'nach Christus'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1. Quartal',
        '2. Quartal',
        '3. Quartal',
        '4. Quartal'
    ]
};
// Note: in German, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        "J\xe4n",
        'Feb',
        "M\xe4r",
        'Apr',
        'Mai',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Okt',
        'Nov',
        'Dez'
    ],
    wide: [
        "J\xe4nner",
        'Februar',
        "M\xe4rz",
        'April',
        'Mai',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'Dezember'
    ]
};
// https://st.unicode.org/cldr-apps/v#/de_AT/Gregorian/
var formattingMonthValues = {
    narrow: monthValues.narrow,
    abbreviated: [
        "J\xe4n.",
        'Feb.',
        "M\xe4rz",
        'Apr.',
        'Mai',
        'Juni',
        'Juli',
        'Aug.',
        'Sep.',
        'Okt.',
        'Nov.',
        'Dez.'
    ],
    wide: monthValues.wide
};
var dayValues = {
    narrow: [
        'S',
        'M',
        'D',
        'M',
        'D',
        'F',
        'S'
    ],
    short: [
        'So',
        'Mo',
        'Di',
        'Mi',
        'Do',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'So.',
        'Mo.',
        'Di.',
        'Mi.',
        'Do.',
        'Fr.',
        'Sa.'
    ],
    wide: [
        'Sonntag',
        'Montag',
        'Dienstag',
        'Mittwoch',
        'Donnerstag',
        'Freitag',
        'Samstag'
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/de.html#1881
var dayPeriodValues = {
    narrow: {
        am: 'vm.',
        pm: 'nm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'Morgen',
        afternoon: 'Nachm.',
        evening: 'Abend',
        night: 'Nacht'
    },
    abbreviated: {
        am: 'vorm.',
        pm: 'nachm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'Morgen',
        afternoon: 'Nachmittag',
        evening: 'Abend',
        night: 'Nacht'
    },
    wide: {
        am: 'vormittags',
        pm: 'nachmittags',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'Morgen',
        afternoon: 'Nachmittag',
        evening: 'Abend',
        night: 'Nacht'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'vm.',
        pm: 'nm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'morgens',
        afternoon: 'nachm.',
        evening: 'abends',
        night: 'nachts'
    },
    abbreviated: {
        am: 'vorm.',
        pm: 'nachm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'morgens',
        afternoon: 'nachmittags',
        evening: 'abends',
        night: 'nachts'
    },
    wide: {
        am: 'vormittags',
        pm: 'nachmittags',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'morgens',
        afternoon: 'nachmittags',
        evening: 'abends',
        night: 'nachts'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        formattingValues: formattingMonthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"fcqRw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Greek locale.
 * @language Greek
 * @iso-639-2 ell
 * @author Fanis Katsimpas [@fanixk]{@link https://github.com/fanixk}
 * @author Theodoros Orfanidis [@teoulas]{@link https://github.com/teoulas}
 */ var locale = {
    code: 'el',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"7eNT7","./_lib/formatLong/index.js":"16HLz","./_lib/formatRelative/index.js":"dEi2y","./_lib/localize/index.js":"lkmIj","./_lib/match/index.js":"15bI4","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7eNT7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC \u03AD\u03BD\u03B1 \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03BF",
        other: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC {{count}} \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03B1"
    },
    xSeconds: {
        one: "1 \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03BF",
        other: "{{count}} \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03B1"
    },
    halfAMinute: "\u03BC\u03B9\u03C3\u03CC \u03BB\u03B5\u03C0\u03C4\u03CC",
    lessThanXMinutes: {
        one: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC \u03AD\u03BD\u03B1 \u03BB\u03B5\u03C0\u03C4\u03CC",
        other: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC {{count}} \u03BB\u03B5\u03C0\u03C4\u03AC"
    },
    xMinutes: {
        one: "1 \u03BB\u03B5\u03C0\u03C4\u03CC",
        other: "{{count}} \u03BB\u03B5\u03C0\u03C4\u03AC"
    },
    aboutXHours: {
        one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03CE\u03C1\u03B1",
        other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03CE\u03C1\u03B5\u03C2"
    },
    xHours: {
        one: "1 \u03CE\u03C1\u03B1",
        other: "{{count}} \u03CE\u03C1\u03B5\u03C2"
    },
    xDays: {
        one: "1 \u03B7\u03BC\u03AD\u03C1\u03B1",
        other: "{{count}} \u03B7\u03BC\u03AD\u03C1\u03B5\u03C2"
    },
    aboutXWeeks: {
        one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B1",
        other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B5\u03C2"
    },
    xWeeks: {
        one: "1 \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B1",
        other: "{{count}} \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B5\u03C2"
    },
    aboutXMonths: {
        one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03BC\u03AE\u03BD\u03B1\u03C2",
        other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03BC\u03AE\u03BD\u03B5\u03C2"
    },
    xMonths: {
        one: "1 \u03BC\u03AE\u03BD\u03B1\u03C2",
        other: "{{count}} \u03BC\u03AE\u03BD\u03B5\u03C2"
    },
    aboutXYears: {
        one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03C7\u03C1\u03CC\u03BD\u03BF",
        other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
    },
    xYears: {
        one: "1 \u03C7\u03C1\u03CC\u03BD\u03BF",
        other: "{{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
    },
    overXYears: {
        one: "\u03C0\u03AC\u03BD\u03C9 \u03B1\u03C0\u03CC 1 \u03C7\u03C1\u03CC\u03BD\u03BF",
        other: "\u03C0\u03AC\u03BD\u03C9 \u03B1\u03C0\u03CC {{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
    },
    almostXYears: {
        one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03C7\u03C1\u03CC\u03BD\u03BF",
        other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u03C3\u03B5 " + result;
        else return result + " \u03C0\u03C1\u03B9\u03BD";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"16HLz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'd/M/yy'
};
var timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var dateTimeFormats = {
    full: '{{date}} - {{time}}',
    long: '{{date}} - {{time}}',
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"dEi2y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        switch(date.getUTCDay()){
            case 6:
                //Σάββατο
                return "'\u03C4\u03BF \u03C0\u03C1\u03BF\u03B7\u03B3\u03BF\u03CD\u03BC\u03B5\u03BD\u03BF' eeee '\u03C3\u03C4\u03B9\u03C2' p";
            default:
                return "'\u03C4\u03B7\u03BD \u03C0\u03C1\u03BF\u03B7\u03B3\u03BF\u03CD\u03BC\u03B5\u03BD\u03B7' eeee '\u03C3\u03C4\u03B9\u03C2' p";
        }
    },
    yesterday: "'\u03C7\u03B8\u03B5\u03C2 \u03C3\u03C4\u03B9\u03C2' p",
    today: "'\u03C3\u03AE\u03BC\u03B5\u03C1\u03B1 \u03C3\u03C4\u03B9\u03C2' p",
    tomorrow: "'\u03B1\u03CD\u03C1\u03B9\u03BF \u03C3\u03C4\u03B9\u03C2' p",
    nextWeek: "eeee '\u03C3\u03C4\u03B9\u03C2' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, date) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"lkmIj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u03C0\u03A7",
        "\u03BC\u03A7"
    ],
    abbreviated: [
        "\u03C0.\u03A7.",
        "\u03BC.\u03A7."
    ],
    wide: [
        "\u03C0\u03C1\u03BF \u03A7\u03C1\u03B9\u03C3\u03C4\u03BF\u03CD",
        "\u03BC\u03B5\u03C4\u03AC \u03A7\u03C1\u03B9\u03C3\u03C4\u03CC\u03BD"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u03A41",
        "\u03A42",
        "\u03A43",
        "\u03A44"
    ],
    wide: [
        "1\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF",
        "2\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF",
        "3\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF",
        "4\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF"
    ]
};
var monthValues = {
    narrow: [
        "\u0399",
        "\u03A6",
        "\u039C",
        "\u0391",
        "\u039C",
        "\u0399",
        "\u0399",
        "\u0391",
        "\u03A3",
        "\u039F",
        "\u039D",
        "\u0394"
    ],
    abbreviated: [
        "\u0399\u03B1\u03BD",
        "\u03A6\u03B5\u03B2",
        "\u039C\u03AC\u03C1",
        "\u0391\u03C0\u03C1",
        "\u039C\u03AC\u03B9",
        "\u0399\u03BF\u03CD\u03BD",
        "\u0399\u03BF\u03CD\u03BB",
        "\u0391\u03CD\u03B3",
        "\u03A3\u03B5\u03C0",
        "\u039F\u03BA\u03C4",
        "\u039D\u03BF\u03AD",
        "\u0394\u03B5\u03BA"
    ],
    wide: [
        "\u0399\u03B1\u03BD\u03BF\u03C5\u03AC\u03C1\u03B9\u03BF\u03C2",
        "\u03A6\u03B5\u03B2\u03C1\u03BF\u03C5\u03AC\u03C1\u03B9\u03BF\u03C2",
        "\u039C\u03AC\u03C1\u03C4\u03B9\u03BF\u03C2",
        "\u0391\u03C0\u03C1\u03AF\u03BB\u03B9\u03BF\u03C2",
        "\u039C\u03AC\u03B9\u03BF\u03C2",
        "\u0399\u03BF\u03CD\u03BD\u03B9\u03BF\u03C2",
        "\u0399\u03BF\u03CD\u03BB\u03B9\u03BF\u03C2",
        "\u0391\u03CD\u03B3\u03BF\u03C5\u03C3\u03C4\u03BF\u03C2",
        "\u03A3\u03B5\u03C0\u03C4\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2",
        "\u039F\u03BA\u03C4\u03CE\u03B2\u03C1\u03B9\u03BF\u03C2",
        "\u039D\u03BF\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2",
        "\u0394\u03B5\u03BA\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2"
    ]
};
var formattingMonthValues = {
    narrow: [
        "\u0399",
        "\u03A6",
        "\u039C",
        "\u0391",
        "\u039C",
        "\u0399",
        "\u0399",
        "\u0391",
        "\u03A3",
        "\u039F",
        "\u039D",
        "\u0394"
    ],
    abbreviated: [
        "\u0399\u03B1\u03BD",
        "\u03A6\u03B5\u03B2",
        "\u039C\u03B1\u03C1",
        "\u0391\u03C0\u03C1",
        "\u039C\u03B1\u0390",
        "\u0399\u03BF\u03C5\u03BD",
        "\u0399\u03BF\u03C5\u03BB",
        "\u0391\u03C5\u03B3",
        "\u03A3\u03B5\u03C0",
        "\u039F\u03BA\u03C4",
        "\u039D\u03BF\u03B5",
        "\u0394\u03B5\u03BA"
    ],
    wide: [
        "\u0399\u03B1\u03BD\u03BF\u03C5\u03B1\u03C1\u03AF\u03BF\u03C5",
        "\u03A6\u03B5\u03B2\u03C1\u03BF\u03C5\u03B1\u03C1\u03AF\u03BF\u03C5",
        "\u039C\u03B1\u03C1\u03C4\u03AF\u03BF\u03C5",
        "\u0391\u03C0\u03C1\u03B9\u03BB\u03AF\u03BF\u03C5",
        "\u039C\u03B1\u0390\u03BF\u03C5",
        "\u0399\u03BF\u03C5\u03BD\u03AF\u03BF\u03C5",
        "\u0399\u03BF\u03C5\u03BB\u03AF\u03BF\u03C5",
        "\u0391\u03C5\u03B3\u03BF\u03CD\u03C3\u03C4\u03BF\u03C5",
        "\u03A3\u03B5\u03C0\u03C4\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5",
        "\u039F\u03BA\u03C4\u03C9\u03B2\u03C1\u03AF\u03BF\u03C5",
        "\u039D\u03BF\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5",
        "\u0394\u03B5\u03BA\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5"
    ]
};
var dayValues = {
    narrow: [
        "\u039A",
        "\u0394",
        'T',
        "\u03A4",
        "\u03A0",
        "\u03A0",
        "\u03A3"
    ],
    short: [
        "\u039A\u03C5",
        "\u0394\u03B5",
        "\u03A4\u03C1",
        "\u03A4\u03B5",
        "\u03A0\u03AD",
        "\u03A0\u03B1",
        "\u03A3\u03AC"
    ],
    abbreviated: [
        "\u039A\u03C5\u03C1",
        "\u0394\u03B5\u03C5",
        "\u03A4\u03C1\u03AF",
        "\u03A4\u03B5\u03C4",
        "\u03A0\u03AD\u03BC",
        "\u03A0\u03B1\u03C1",
        "\u03A3\u03AC\u03B2"
    ],
    wide: [
        "\u039A\u03C5\u03C1\u03B9\u03B1\u03BA\u03AE",
        "\u0394\u03B5\u03C5\u03C4\u03AD\u03C1\u03B1",
        "\u03A4\u03C1\u03AF\u03C4\u03B7",
        "\u03A4\u03B5\u03C4\u03AC\u03C1\u03C4\u03B7",
        "\u03A0\u03AD\u03BC\u03C0\u03C4\u03B7",
        "\u03A0\u03B1\u03C1\u03B1\u03C3\u03BA\u03B5\u03C5\u03AE",
        "\u03A3\u03AC\u03B2\u03B2\u03B1\u03C4\u03BF"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u03C0\u03BC",
        pm: "\u03BC\u03BC",
        midnight: "\u03BC\u03B5\u03C3\u03AC\u03BD\u03C5\u03C7\u03C4\u03B1",
        noon: "\u03BC\u03B5\u03C3\u03B7\u03BC\u03AD\u03C1\u03B9",
        morning: "\u03C0\u03C1\u03C9\u03AF",
        afternoon: "\u03B1\u03C0\u03CC\u03B3\u03B5\u03C5\u03BC\u03B1",
        evening: "\u03B2\u03C1\u03AC\u03B4\u03C5",
        night: "\u03BD\u03CD\u03C7\u03C4\u03B1"
    },
    abbreviated: {
        am: "\u03C0.\u03BC.",
        pm: "\u03BC.\u03BC.",
        midnight: "\u03BC\u03B5\u03C3\u03AC\u03BD\u03C5\u03C7\u03C4\u03B1",
        noon: "\u03BC\u03B5\u03C3\u03B7\u03BC\u03AD\u03C1\u03B9",
        morning: "\u03C0\u03C1\u03C9\u03AF",
        afternoon: "\u03B1\u03C0\u03CC\u03B3\u03B5\u03C5\u03BC\u03B1",
        evening: "\u03B2\u03C1\u03AC\u03B4\u03C5",
        night: "\u03BD\u03CD\u03C7\u03C4\u03B1"
    },
    wide: {
        am: "\u03C0.\u03BC.",
        pm: "\u03BC.\u03BC.",
        midnight: "\u03BC\u03B5\u03C3\u03AC\u03BD\u03C5\u03C7\u03C4\u03B1",
        noon: "\u03BC\u03B5\u03C3\u03B7\u03BC\u03AD\u03C1\u03B9",
        morning: "\u03C0\u03C1\u03C9\u03AF",
        afternoon: "\u03B1\u03C0\u03CC\u03B3\u03B5\u03C5\u03BC\u03B1",
        evening: "\u03B2\u03C1\u03AC\u03B4\u03C5",
        night: "\u03BD\u03CD\u03C7\u03C4\u03B1"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    var suffix;
    if (unit === 'year' || unit === 'month') suffix = "\u03BF\u03C2";
    else if (unit === 'week' || unit === 'dayOfYear' || unit === 'day' || unit === 'hour' || unit === 'date') suffix = "\u03B7";
    else suffix = "\u03BF";
    return number + suffix;
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide',
        formattingValues: formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"15bI4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(ος|η|ο)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(πΧ|μΧ)/i,
    abbreviated: /^(π\.?\s?χ\.?|π\.?\s?κ\.?\s?χ\.?|μ\.?\s?χ\.?|κ\.?\s?χ\.?)/i,
    wide: /^(προ Χριστο(ύ|υ)|πριν απ(ό|ο) την Κοιν(ή|η) Χρονολογ(ί|ι)α|μετ(ά|α) Χριστ(ό|ο)ν|Κοιν(ή|η) Χρονολογ(ί|ι)α)/i
};
var parseEraPatterns = {
    any: [
        /^π/i,
        /^(μ|κ)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^τ[1234]/i,
    wide: /^[1234]ο? τρ(ί|ι)μηνο/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[ιφμαμιιασονδ]/i,
    abbreviated: /^(ιαν|φεβ|μ[άα]ρ|απρ|μ[άα][ιΐ]|ιο[ύυ]ν|ιο[ύυ]λ|α[ύυ]γ|σεπ|οκτ|νο[έε]|δεκ)/i,
    wide: /^(μ[άα][ιΐ]|α[ύυ]γο[υύ]στ)(ος|ου)|(ιανου[άα]ρ|φεβρου[άα]ρ|μ[άα]ρτ|απρ[ίι]λ|ιο[ύυ]ν|ιο[ύυ]λ|σεπτ[έε]μβρ|οκτ[ώω]βρ|νο[έε]μβρ|δεκ[έε]μβρ)(ιος|ίου)/i
};
var parseMonthPatterns = {
    narrow: [
        /^ι/i,
        /^φ/i,
        /^μ/i,
        /^α/i,
        /^μ/i,
        /^ι/i,
        /^ι/i,
        /^α/i,
        /^σ/i,
        /^ο/i,
        /^ν/i,
        /^δ/i
    ],
    any: [
        /^ια/i,
        /^φ/i,
        /^μ[άα]ρ/i,
        /^απ/i,
        /^μ[άα][ιΐ]/i,
        /^ιο[ύυ]ν/i,
        /^ιο[ύυ]λ/i,
        /^α[ύυ]/i,
        /^σ/i,
        /^ο/i,
        /^ν/i,
        /^δ/i
    ]
};
var matchDayPatterns = {
    narrow: /^[κδτπσ]/i,
    short: /^(κυ|δε|τρ|τε|π[εέ]|π[αά]|σ[αά])/i,
    abbreviated: /^(κυρ|δευ|τρι|τετ|πεμ|παρ|σαβ)/i,
    wide: /^(κυριακ(ή|η)|δευτ(έ|ε)ρα|τρ(ί|ι)τη|τετ(ά|α)ρτη|π(έ|ε)μπτη|παρασκευ(ή|η)|σ(ά|α)ββατο)/i
};
var parseDayPatterns = {
    narrow: [
        /^κ/i,
        /^δ/i,
        /^τ/i,
        /^τ/i,
        /^π/i,
        /^π/i,
        /^σ/i
    ],
    any: [
        /^κ/i,
        /^δ/i,
        /^τρ/i,
        /^τε/i,
        /^π[εέ]/i,
        /^π[αά]/i,
        /^σ/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(πμ|μμ|μεσ(ά|α)νυχτα|μεσημ(έ|ε)ρι|πρω(ί|ι)|απ(ό|ο)γευμα|βρ(ά|α)δυ|ν(ύ|υ)χτα)/i,
    any: /^([πμ]\.?\s?μ\.?|μεσ(ά|α)νυχτα|μεσημ(έ|ε)ρι|πρω(ί|ι)|απ(ό|ο)γευμα|βρ(ά|α)δυ|ν(ύ|υ)χτα)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^πμ|π\.\s?μ\./i,
        pm: /^μμ|μ\.\s?μ\./i,
        midnight: /^μεσάν/i,
        noon: /^μεσημ(έ|ε)/i,
        morning: /πρω(ί|ι)/i,
        afternoon: /απ(ό|ο)γευμα/i,
        evening: /βρ(ά|α)δυ/i,
        night: /ν(ύ|υ)χτα/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"92Jzk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../en-US/_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../en-US/_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../en-US/_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../en-US/_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (Australia).
 * @language English
 * @iso-639-2 eng
 * @author Julien Malige [@JulienMalige]{@link https://github.com/JulienMalige}
 */ var locale = {
    code: 'en-AU',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"../en-US/_lib/formatDistance/index.js":"k21rK","./_lib/formatLong/index.js":"bpen2","../en-US/_lib/formatRelative/index.js":"5hFuk","../en-US/_lib/localize/index.js":"jVOZz","../en-US/_lib/match/index.js":"5qFLH","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"bpen2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'dd/MM/yyyy'
};
var timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"bzLEy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../en-US/_lib/formatRelative/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../en-US/_lib/localize/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../en-US/_lib/match/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/formatDistance/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/formatLong/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (Canada).
 * @language English
 * @iso-639-2 eng
 * @author Mark Owsiak [@markowsiak]{@link https://github.com/markowsiak}
 * @author Marco Imperatore [@mimperatore]{@link https://github.com/mimperatore}
 */ var locale = {
    code: 'en-CA',
    formatDistance: (0, _indexJsDefault3.default),
    formatLong: (0, _indexJsDefault4.default),
    formatRelative: (0, _indexJsDefault.default),
    localize: (0, _indexJsDefault1.default),
    match: (0, _indexJsDefault2.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"../en-US/_lib/formatRelative/index.js":"5hFuk","../en-US/_lib/localize/index.js":"jVOZz","../en-US/_lib/match/index.js":"5qFLH","./_lib/formatDistance/index.js":"5patp","./_lib/formatLong/index.js":"dJGdZ","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5patp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: 'a second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: 'a minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about an hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: 'an hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: 'a day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about a week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: 'a week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about a month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: 'a month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about a year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: 'a year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over a year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost a year',
        other: 'almost {{count}} years'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"dJGdZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, MMMM do, yyyy',
    long: 'MMMM do, yyyy',
    medium: 'MMM d, yyyy',
    short: 'yyyy-MM-dd'
};
var timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8VceF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../en-US/_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../en-US/_lib/formatRelative/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../en-US/_lib/localize/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../en-US/_lib/match/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/formatLong/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United Kingdom).
 * @language English
 * @iso-639-2 eng
 * @author Alex [@glintik]{@link https://github.com/glintik}
 */ var locale = {
    code: 'en-GB',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault4.default),
    formatRelative: (0, _indexJsDefault1.default),
    localize: (0, _indexJsDefault2.default),
    match: (0, _indexJsDefault3.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"../en-US/_lib/formatDistance/index.js":"k21rK","../en-US/_lib/formatRelative/index.js":"5hFuk","../en-US/_lib/localize/index.js":"jVOZz","../en-US/_lib/match/index.js":"5qFLH","./_lib/formatLong/index.js":"eVBwQ","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"eVBwQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'dd/MM/yyyy'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"b92JJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../en-US/_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../en-US/_lib/formatRelative/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../en-US/_lib/localize/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../en-US/_lib/match/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../en-GB/_lib/formatLong/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (Ireland).
 * @language English
 * @iso-639-2 eng
 * @author Tetiana [@tan75]{@link https://github.com/tan75}
 */ var locale = {
    code: 'en-IE',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault4.default),
    formatRelative: (0, _indexJsDefault1.default),
    localize: (0, _indexJsDefault2.default),
    match: (0, _indexJsDefault3.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"../en-US/_lib/formatDistance/index.js":"k21rK","../en-US/_lib/formatRelative/index.js":"5hFuk","../en-US/_lib/localize/index.js":"jVOZz","../en-US/_lib/match/index.js":"5qFLH","../en-GB/_lib/formatLong/index.js":"eVBwQ","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6KWuI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../en-US/_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../en-US/_lib/formatRelative/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../en-US/_lib/localize/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../en-US/_lib/match/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/formatLong/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (India).
 * @language English
 * @iso-639-2 eng
 * @author Galeel Bhasha Satthar [@gbhasha]{@link https://github.com/gbhasha}
 */ var locale = {
    code: 'en-IN',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault4.default),
    formatRelative: (0, _indexJsDefault1.default),
    localize: (0, _indexJsDefault2.default),
    match: (0, _indexJsDefault3.default),
    options: {
        weekStartsOn: 1,
        // Monday is the first day of the week.
        firstWeekContainsDate: 4 // The week that contains Jan 4th is the first week of the year.
    }
};
exports.default = locale;

},{"../en-US/_lib/formatDistance/index.js":"k21rK","../en-US/_lib/formatRelative/index.js":"5hFuk","../en-US/_lib/localize/index.js":"jVOZz","../en-US/_lib/match/index.js":"5qFLH","./_lib/formatLong/index.js":"70Sue","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"70Sue":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM, yyyy',
    medium: 'd MMM, yyyy',
    short: 'dd/MM/yyyy'
};
var timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6Igdm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../en-US/_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../en-US/_lib/formatRelative/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../en-US/_lib/localize/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../en-US/_lib/match/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/formatLong/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (New Zealand).
 * @language English
 * @iso-639-2 eng
 * @author Murray Lucas [@muntact]{@link https://github.com/muntact}
 */ var locale = {
    code: 'en-NZ',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault4.default),
    formatRelative: (0, _indexJsDefault1.default),
    localize: (0, _indexJsDefault2.default),
    match: (0, _indexJsDefault3.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"../en-US/_lib/formatDistance/index.js":"k21rK","../en-US/_lib/formatRelative/index.js":"5hFuk","../en-US/_lib/localize/index.js":"jVOZz","../en-US/_lib/match/index.js":"5qFLH","./_lib/formatLong/index.js":"96uib","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"96uib":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'dd/MM/yyyy'
};
var timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"ec733":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../en-US/_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../en-US/_lib/formatRelative/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../en-US/_lib/localize/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../en-US/_lib/match/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/formatLong/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (South Africa).
 * @language English
 * @iso-639-2 eng
 * @author Shaila Kavrakova [@shaykav]{@link https://github.com/shaykav}
 */ var locale = {
    code: 'en-ZA',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault4.default),
    formatRelative: (0, _indexJsDefault1.default),
    localize: (0, _indexJsDefault2.default),
    match: (0, _indexJsDefault3.default),
    options: {
        weekStartsOn: 0,
        // Sunday is the first day of the week.
        firstWeekContainsDate: 1 // The week that contains Jan 1st is the first week of the year.
    }
};
exports.default = locale;

},{"../en-US/_lib/formatDistance/index.js":"k21rK","../en-US/_lib/formatRelative/index.js":"5hFuk","../en-US/_lib/localize/index.js":"jVOZz","../en-US/_lib/match/index.js":"5qFLH","./_lib/formatLong/index.js":"dnWbG","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"dnWbG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, dd MMMM yyyy',
    long: 'dd MMMM yyyy',
    medium: 'dd MMM yyyy',
    short: 'yyyy/MM/dd'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"ajjSk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Esperanto locale.
 * @language Esperanto
 * @iso-639-2 epo
 * @author date-fns
 */ var locale = {
    code: 'eo',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"aIo5e","./_lib/formatLong/index.js":"61IDf","./_lib/formatRelative/index.js":"bwAFr","./_lib/localize/index.js":"1u0G2","./_lib/match/index.js":"iuAVr","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"aIo5e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'malpli ol sekundo',
        other: 'malpli ol {{count}} sekundoj'
    },
    xSeconds: {
        one: '1 sekundo',
        other: '{{count}} sekundoj'
    },
    halfAMinute: 'duonminuto',
    lessThanXMinutes: {
        one: 'malpli ol minuto',
        other: 'malpli ol {{count}} minutoj'
    },
    xMinutes: {
        one: '1 minuto',
        other: '{{count}} minutoj'
    },
    aboutXHours: {
        one: 'proksimume 1 horo',
        other: 'proksimume {{count}} horoj'
    },
    xHours: {
        one: '1 horo',
        other: '{{count}} horoj'
    },
    xDays: {
        one: '1 tago',
        other: '{{count}} tagoj'
    },
    aboutXMonths: {
        one: 'proksimume 1 monato',
        other: 'proksimume {{count}} monatoj'
    },
    xWeeks: {
        one: '1 semajno',
        other: '{{count}} semajnoj'
    },
    aboutXWeeks: {
        one: 'proksimume 1 semajno',
        other: 'proksimume {{count}} semajnoj'
    },
    xMonths: {
        one: '1 monato',
        other: '{{count}} monatoj'
    },
    aboutXYears: {
        one: 'proksimume 1 jaro',
        other: 'proksimume {{count}} jaroj'
    },
    xYears: {
        one: '1 jaro',
        other: '{{count}} jaroj'
    },
    overXYears: {
        one: 'pli ol 1 jaro',
        other: 'pli ol {{count}} jaroj'
    },
    almostXYears: {
        one: "preska\u016D 1 jaro",
        other: "preska\u016D {{count}} jaroj"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options !== null && options !== void 0 && options.comparison && options.comparison > 0) return 'post ' + result;
        else return "anta\u016D " + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"61IDf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE, do 'de' MMMM y",
    long: 'y-MMMM-dd',
    medium: 'y-MMM-dd',
    short: 'yyyy-MM-dd'
};
var timeFormats = {
    full: "Ho 'horo kaj' m:ss zzzz",
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    any: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'any'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"bwAFr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'pasinta' eeee 'je' p",
    yesterday: "'hiera\u016D je' p",
    today: "'hodia\u016D je' p",
    tomorrow: "'morga\u016D je' p",
    nextWeek: "eeee 'je' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1u0G2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'aK',
        'pK'
    ],
    abbreviated: [
        'a.K.E.',
        'p.K.E.'
    ],
    wide: [
        "anta\u016D Komuna Erao",
        'Komuna Erao'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        '1-a kvaronjaro',
        '2-a kvaronjaro',
        '3-a kvaronjaro',
        '4-a kvaronjaro'
    ]
};
var monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan',
        'feb',
        'mar',
        'apr',
        'maj',
        'jun',
        'jul',
        "a\u016Dg",
        'sep',
        'okt',
        'nov',
        'dec'
    ],
    wide: [
        'januaro',
        'februaro',
        'marto',
        'aprilo',
        'majo',
        'junio',
        'julio',
        "a\u016Dgusto",
        'septembro',
        'oktobro',
        'novembro',
        'decembro'
    ]
};
var dayValues = {
    narrow: [
        'D',
        'L',
        'M',
        'M',
        "\u0134",
        'V',
        'S'
    ],
    short: [
        'di',
        'lu',
        'ma',
        'me',
        "\u0135a",
        've',
        'sa'
    ],
    abbreviated: [
        'dim',
        'lun',
        'mar',
        'mer',
        "\u0135a\u016D",
        'ven',
        'sab'
    ],
    wide: [
        "diman\u0109o",
        'lundo',
        'mardo',
        'merkredo',
        "\u0135a\u016Ddo",
        'vendredo',
        'sabato'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'noktomezo',
        noon: 'tagmezo',
        morning: 'matene',
        afternoon: 'posttagmeze',
        evening: 'vespere',
        night: 'nokte'
    },
    abbreviated: {
        am: 'a.t.m.',
        pm: 'p.t.m.',
        midnight: 'noktomezo',
        noon: 'tagmezo',
        morning: 'matene',
        afternoon: 'posttagmeze',
        evening: 'vespere',
        night: 'nokte'
    },
    wide: {
        am: "anta\u016Dtagmeze",
        pm: 'posttagmeze',
        midnight: 'noktomezo',
        noon: 'tagmezo',
        morning: 'matene',
        afternoon: 'posttagmeze',
        evening: 'vespere',
        night: 'nokte'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    return number + '-a';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"iuAVr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(-?a)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^([ap]k)/i,
    abbreviated: /^([ap]\.?\s?k\.?\s?e\.?)/i,
    wide: /^((antaǔ |post )?komuna erao)/i
};
var parseEraPatterns = {
    any: [
        /^a/i,
        /^[kp]/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^k[1234]/i,
    wide: /^[1234](-?a)? kvaronjaro/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|a(ŭ|ux|uh|u)g|sep|okt|nov|dec)/i,
    wide: /^(januaro|februaro|marto|aprilo|majo|junio|julio|a(ŭ|ux|uh|u)gusto|septembro|oktobro|novembro|decembro)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^a(u|ŭ)/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[dlmĵjvs]/i,
    short: /^(di|lu|ma|me|(ĵ|jx|jh|j)a|ve|sa)/i,
    abbreviated: /^(dim|lun|mar|mer|(ĵ|jx|jh|j)a(ŭ|ux|uh|u)|ven|sab)/i,
    wide: /^(diman(ĉ|cx|ch|c)o|lundo|mardo|merkredo|(ĵ|jx|jh|j)a(ŭ|ux|uh|u)do|vendredo|sabato)/i
};
var parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^(j|ĵ)/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^l/i,
        /^ma/i,
        /^me/i,
        /^(j|ĵ)/i,
        /^v/i,
        /^s/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^([ap]|(posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo])/i,
    abbreviated: /^([ap][.\s]?t[.\s]?m[.\s]?|(posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo])/i,
    wide: /^(anta(ŭ|ux)tagmez|posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo]/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^noktom/i,
        noon: /^t/i,
        morning: /^m/i,
        afternoon: /^posttagmeze/i,
        evening: /^v/i,
        night: /^n/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault1.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault1.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault1.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault1.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault1.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchPatternFn/index.js":"2Mexa","../../../_lib/buildMatchFn/index.js":"7YCyk","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"hhCUu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Spanish locale.
 * @language Spanish
 * @iso-639-2 spa
 * @author Juan Angosto [@juanangosto]{@link https://github.com/juanangosto}
 * @author Guillermo Grau [@guigrpa]{@link https://github.com/guigrpa}
 * @author Fernando Agüero [@fjaguero]{@link https://github.com/fjaguero}
 * @author Gastón Haro [@harogaston]{@link https://github.com/harogaston}
 * @author Yago Carballo [@YagoCarballo]{@link https://github.com/YagoCarballo}
 */ var locale = {
    code: 'es',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"hz8w6","./_lib/formatLong/index.js":"5mMzA","./_lib/formatRelative/index.js":"2Xc1a","./_lib/localize/index.js":"4RYZc","./_lib/match/index.js":"kTYMi","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"hz8w6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'menos de un segundo',
        other: 'menos de {{count}} segundos'
    },
    xSeconds: {
        one: '1 segundo',
        other: '{{count}} segundos'
    },
    halfAMinute: 'medio minuto',
    lessThanXMinutes: {
        one: 'menos de un minuto',
        other: 'menos de {{count}} minutos'
    },
    xMinutes: {
        one: '1 minuto',
        other: '{{count}} minutos'
    },
    aboutXHours: {
        one: 'alrededor de 1 hora',
        other: 'alrededor de {{count}} horas'
    },
    xHours: {
        one: '1 hora',
        other: '{{count}} horas'
    },
    xDays: {
        one: "1 d\xeda",
        other: "{{count}} d\xedas"
    },
    aboutXWeeks: {
        one: 'alrededor de 1 semana',
        other: 'alrededor de {{count}} semanas'
    },
    xWeeks: {
        one: '1 semana',
        other: '{{count}} semanas'
    },
    aboutXMonths: {
        one: 'alrededor de 1 mes',
        other: 'alrededor de {{count}} meses'
    },
    xMonths: {
        one: '1 mes',
        other: '{{count}} meses'
    },
    aboutXYears: {
        one: "alrededor de 1 a\xf1o",
        other: "alrededor de {{count}} a\xf1os"
    },
    xYears: {
        one: "1 a\xf1o",
        other: "{{count}} a\xf1os"
    },
    overXYears: {
        one: "m\xe1s de 1 a\xf1o",
        other: "m\xe1s de {{count}} a\xf1os"
    },
    almostXYears: {
        one: "casi 1 a\xf1o",
        other: "casi {{count}} a\xf1os"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'en ' + result;
        else return 'hace ' + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5mMzA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: 'd MMM y',
    short: 'dd/MM/y'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'a las' {{time}}",
    long: "{{date}} 'a las' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2Xc1a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'el' eeee 'pasado a la' p",
    yesterday: "'ayer a la' p",
    today: "'hoy a la' p",
    tomorrow: "'ma\xf1ana a la' p",
    nextWeek: "eeee 'a la' p",
    other: 'P'
};
var formatRelativeLocalePlural = {
    lastWeek: "'el' eeee 'pasado a las' p",
    yesterday: "'ayer a las' p",
    today: "'hoy a las' p",
    tomorrow: "'ma\xf1ana a las' p",
    nextWeek: "eeee 'a las' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, date, _baseDate, _options) {
    if (date.getUTCHours() !== 1) return formatRelativeLocalePlural[token];
    else return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4RYZc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'AC',
        'DC'
    ],
    abbreviated: [
        'AC',
        'DC'
    ],
    wide: [
        'antes de cristo',
        "despu\xe9s de cristo"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
var monthValues = {
    narrow: [
        'e',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'ene',
        'feb',
        'mar',
        'abr',
        'may',
        'jun',
        'jul',
        'ago',
        'sep',
        'oct',
        'nov',
        'dic'
    ],
    wide: [
        'enero',
        'febrero',
        'marzo',
        'abril',
        'mayo',
        'junio',
        'julio',
        'agosto',
        'septiembre',
        'octubre',
        'noviembre',
        'diciembre'
    ]
};
var dayValues = {
    narrow: [
        'd',
        'l',
        'm',
        'm',
        'j',
        'v',
        's'
    ],
    short: [
        'do',
        'lu',
        'ma',
        'mi',
        'ju',
        'vi',
        "s\xe1"
    ],
    abbreviated: [
        'dom',
        'lun',
        'mar',
        "mi\xe9",
        'jue',
        'vie',
        "s\xe1b"
    ],
    wide: [
        'domingo',
        'lunes',
        'martes',
        "mi\xe9rcoles",
        'jueves',
        'viernes',
        "s\xe1bado"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: 'md',
        morning: "ma\xf1ana",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noche'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'medianoche',
        noon: 'mediodia',
        morning: "ma\xf1ana",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noche'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'medianoche',
        noon: 'mediodia',
        morning: "ma\xf1ana",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noche'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: 'md',
        morning: "de la ma\xf1ana",
        afternoon: 'de la tarde',
        evening: 'de la tarde',
        night: 'de la noche'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'medianoche',
        noon: 'mediodia',
        morning: "de la ma\xf1ana",
        afternoon: 'de la tarde',
        evening: 'de la tarde',
        night: 'de la noche'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'medianoche',
        noon: 'mediodia',
        morning: "de la ma\xf1ana",
        afternoon: 'de la tarde',
        evening: 'de la tarde',
        night: 'de la noche'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "\xba";
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"kTYMi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(º)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
    wide: /^(antes de cristo|antes de la era com[uú]n|despu[eé]s de cristo|era com[uú]n)/i
};
var parseEraPatterns = {
    any: [
        /^ac/i,
        /^dc/i
    ],
    wide: [
        /^(antes de cristo|antes de la era com[uú]n)/i,
        /^(despu[eé]s de cristo|era com[uú]n)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º)? trimestre/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[efmajsond]/i,
    abbreviated: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)/i,
    wide: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i
};
var parseMonthPatterns = {
    narrow: [
        /^e/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^en/i,
        /^feb/i,
        /^mar/i,
        /^abr/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^ago/i,
        /^sep/i,
        /^oct/i,
        /^nov/i,
        /^dic/i
    ]
};
var matchDayPatterns = {
    narrow: /^[dlmjvs]/i,
    short: /^(do|lu|ma|mi|ju|vi|s[áa])/i,
    abbreviated: /^(dom|lun|mar|mi[ée]|jue|vie|s[áa]b)/i,
    wide: /^(domingo|lunes|martes|mi[ée]rcoles|jueves|viernes|s[áa]bado)/i
};
var parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^do/i,
        /^lu/i,
        /^ma/i,
        /^mi/i,
        /^ju/i,
        /^vi/i,
        /^sa/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|md|(de la|a las) (mañana|tarde|noche))/i,
    any: /^([ap]\.?\s?m\.?|medianoche|mediodia|(de la|a las) (mañana|tarde|noche))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mn/i,
        noon: /^md/i,
        morning: /mañana/i,
        afternoon: /tarde/i,
        evening: /tarde/i,
        night: /noche/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault1.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault1.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault1.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault1.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault1.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchPatternFn/index.js":"2Mexa","../../../_lib/buildMatchFn/index.js":"7YCyk","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"g5EKJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Estonian locale.
 * @language Estonian
 * @iso-639-2 est
 * @author Priit Hansen [@HansenPriit]{@link https://github.com/priithansen}
 */ var locale = {
    code: 'et',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"awcSR","./_lib/formatLong/index.js":"6C4G5","./_lib/formatRelative/index.js":"8WXsy","./_lib/localize/index.js":"aPDkD","./_lib/match/index.js":"46LQJ","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"awcSR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        standalone: {
            one: "v\xe4hem kui \xfcks sekund",
            other: "v\xe4hem kui {{count}} sekundit"
        },
        withPreposition: {
            one: "v\xe4hem kui \xfche sekundi",
            other: "v\xe4hem kui {{count}} sekundi"
        }
    },
    xSeconds: {
        standalone: {
            one: "\xfcks sekund",
            other: '{{count}} sekundit'
        },
        withPreposition: {
            one: "\xfche sekundi",
            other: '{{count}} sekundi'
        }
    },
    halfAMinute: {
        standalone: 'pool minutit',
        withPreposition: 'poole minuti'
    },
    lessThanXMinutes: {
        standalone: {
            one: "v\xe4hem kui \xfcks minut",
            other: "v\xe4hem kui {{count}} minutit"
        },
        withPreposition: {
            one: "v\xe4hem kui \xfche minuti",
            other: "v\xe4hem kui {{count}} minuti"
        }
    },
    xMinutes: {
        standalone: {
            one: "\xfcks minut",
            other: '{{count}} minutit'
        },
        withPreposition: {
            one: "\xfche minuti",
            other: '{{count}} minuti'
        }
    },
    aboutXHours: {
        standalone: {
            one: "umbes \xfcks tund",
            other: 'umbes {{count}} tundi'
        },
        withPreposition: {
            one: "umbes \xfche tunni",
            other: 'umbes {{count}} tunni'
        }
    },
    xHours: {
        standalone: {
            one: "\xfcks tund",
            other: '{{count}} tundi'
        },
        withPreposition: {
            one: "\xfche tunni",
            other: '{{count}} tunni'
        }
    },
    xDays: {
        standalone: {
            one: "\xfcks p\xe4ev",
            other: "{{count}} p\xe4eva"
        },
        withPreposition: {
            one: "\xfche p\xe4eva",
            other: "{{count}} p\xe4eva"
        }
    },
    aboutXWeeks: {
        standalone: {
            one: "umbes \xfcks n\xe4dal",
            other: "umbes {{count}} n\xe4dalat"
        },
        withPreposition: {
            one: "umbes \xfche n\xe4dala",
            other: "umbes {{count}} n\xe4dala"
        }
    },
    xWeeks: {
        standalone: {
            one: "\xfcks n\xe4dal",
            other: "{{count}} n\xe4dalat"
        },
        withPreposition: {
            one: "\xfche n\xe4dala",
            other: "{{count}} n\xe4dala"
        }
    },
    aboutXMonths: {
        standalone: {
            one: "umbes \xfcks kuu",
            other: 'umbes {{count}} kuud'
        },
        withPreposition: {
            one: "umbes \xfche kuu",
            other: 'umbes {{count}} kuu'
        }
    },
    xMonths: {
        standalone: {
            one: "\xfcks kuu",
            other: '{{count}} kuud'
        },
        withPreposition: {
            one: "\xfche kuu",
            other: '{{count}} kuu'
        }
    },
    aboutXYears: {
        standalone: {
            one: "umbes \xfcks aasta",
            other: 'umbes {{count}} aastat'
        },
        withPreposition: {
            one: "umbes \xfche aasta",
            other: 'umbes {{count}} aasta'
        }
    },
    xYears: {
        standalone: {
            one: "\xfcks aasta",
            other: '{{count}} aastat'
        },
        withPreposition: {
            one: "\xfche aasta",
            other: '{{count}} aasta'
        }
    },
    overXYears: {
        standalone: {
            one: "rohkem kui \xfcks aasta",
            other: 'rohkem kui {{count}} aastat'
        },
        withPreposition: {
            one: "rohkem kui \xfche aasta",
            other: 'rohkem kui {{count}} aasta'
        }
    },
    almostXYears: {
        standalone: {
            one: "peaaegu \xfcks aasta",
            other: 'peaaegu {{count}} aastat'
        },
        withPreposition: {
            one: "peaaegu \xfche aasta",
            other: 'peaaegu {{count}} aasta'
        }
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var usageGroup = options !== null && options !== void 0 && options.addSuffix ? formatDistanceLocale[token].withPreposition : formatDistanceLocale[token].standalone;
    var result;
    if (typeof usageGroup === 'string') result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else result = usageGroup.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " p\xe4rast";
        else return result + ' eest';
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6C4G5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, d. MMMM y',
    long: 'd. MMMM y',
    medium: 'd. MMM y',
    short: 'dd.MM.y'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'kell' {{time}}",
    long: "{{date}} 'kell' {{time}}",
    medium: '{{date}}. {{time}}',
    short: '{{date}}. {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8WXsy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'eelmine' eeee 'kell' p",
    yesterday: "'eile kell' p",
    today: "'t\xe4na kell' p",
    tomorrow: "'homme kell' p",
    nextWeek: "'j\xe4rgmine' eeee 'kell' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"aPDkD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'e.m.a',
        'm.a.j'
    ],
    abbreviated: [
        'e.m.a',
        'm.a.j'
    ],
    wide: [
        'enne meie ajaarvamist',
        "meie ajaarvamise j\xe4rgi"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        '1. kvartal',
        '2. kvartal',
        '3. kvartal',
        '4. kvartal'
    ]
};
var monthValues = {
    narrow: [
        'J',
        'V',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jaan',
        'veebr',
        "m\xe4rts",
        'apr',
        'mai',
        'juuni',
        'juuli',
        'aug',
        'sept',
        'okt',
        'nov',
        'dets'
    ],
    wide: [
        'jaanuar',
        'veebruar',
        "m\xe4rts",
        'aprill',
        'mai',
        'juuni',
        'juuli',
        'august',
        'september',
        'oktoober',
        'november',
        'detsember'
    ]
};
var dayValues = {
    narrow: [
        'P',
        'E',
        'T',
        'K',
        'N',
        'R',
        'L'
    ],
    short: [
        'P',
        'E',
        'T',
        'K',
        'N',
        'R',
        'L'
    ],
    abbreviated: [
        "p\xfchap.",
        'esmasp.',
        'teisip.',
        'kolmap.',
        'neljap.',
        'reede.',
        'laup.'
    ],
    wide: [
        "p\xfchap\xe4ev",
        "esmasp\xe4ev",
        "teisip\xe4ev",
        "kolmap\xe4ev",
        "neljap\xe4ev",
        'reede',
        "laup\xe4ev"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "kesk\xf6\xf6",
        noon: "keskp\xe4ev",
        morning: 'hommik',
        afternoon: "p\xe4rastl\xf5una",
        evening: "\xf5htu",
        night: "\xf6\xf6"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "kesk\xf6\xf6",
        noon: "keskp\xe4ev",
        morning: 'hommik',
        afternoon: "p\xe4rastl\xf5una",
        evening: "\xf5htu",
        night: "\xf6\xf6"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "kesk\xf6\xf6",
        noon: "keskp\xe4ev",
        morning: 'hommik',
        afternoon: "p\xe4rastl\xf5una",
        evening: "\xf5htu",
        night: "\xf6\xf6"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "kesk\xf6\xf6l",
        noon: "keskp\xe4eval",
        morning: 'hommikul',
        afternoon: "p\xe4rastl\xf5unal",
        evening: "\xf5htul",
        night: "\xf6\xf6sel"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "kesk\xf6\xf6l",
        noon: "keskp\xe4eval",
        morning: 'hommikul',
        afternoon: "p\xe4rastl\xf5unal",
        evening: "\xf5htul",
        night: "\xf6\xf6sel"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "kesk\xf6\xf6l",
        noon: "keskp\xe4eval",
        morning: 'hommikul',
        afternoon: "p\xe4rastl\xf5unal",
        evening: "\xf5htul",
        night: "\xf6\xf6sel"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide',
        formattingValues: monthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide',
        formattingValues: dayValues,
        defaultFormattingWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"46LQJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^\d+\./i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(e\.m\.a|m\.a\.j|eKr|pKr)/i,
    abbreviated: /^(e\.m\.a|m\.a\.j|eKr|pKr)/i,
    wide: /^(enne meie ajaarvamist|meie ajaarvamise järgi|enne Kristust|pärast Kristust)/i
};
var parseEraPatterns = {
    any: [
        /^e/i,
        /^(m|p)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234](\.)? kvartal/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jvmasond]/i,
    abbreviated: /^(jaan|veebr|märts|apr|mai|juuni|juuli|aug|sept|okt|nov|dets)/i,
    wide: /^(jaanuar|veebruar|märts|aprill|mai|juuni|juuli|august|september|oktoober|november|detsember)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^v/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^v/i,
        /^mär/i,
        /^ap/i,
        /^mai/i,
        /^juun/i,
        /^juul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[petknrl]/i,
    short: /^[petknrl]/i,
    abbreviated: /^(püh?|esm?|tei?|kolm?|nel?|ree?|laup?)\.?/i,
    wide: /^(pühapäev|esmaspäev|teisipäev|kolmapäev|neljapäev|reede|laupäev)/i
};
var parseDayPatterns = {
    any: [
        /^p/i,
        /^e/i,
        /^t/i,
        /^k/i,
        /^n/i,
        /^r/i,
        /^l/i
    ]
};
var matchDayPeriodPatterns = {
    any: /^(am|pm|keskööl?|keskpäev(al)?|hommik(ul)?|pärastlõunal?|õhtul?|öö(sel)?)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^keskö/i,
        noon: /^keskp/i,
        morning: /hommik/i,
        afternoon: /pärastlõuna/i,
        evening: /õhtu/i,
        night: /öö/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"663nU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Basque locale.
 * @language Basque
 * @iso-639-2 eus
 * @author Jacob Söderblom [@JacobSoderblom]{@link https://github.com/JacobSoderblom}
 */ var locale = {
    code: 'eu',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"83mF8","./_lib/formatLong/index.js":"hHQIs","./_lib/formatRelative/index.js":"lvzhl","./_lib/localize/index.js":"3dUuE","./_lib/match/index.js":"lc8jl","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"83mF8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'segundo bat baino gutxiago',
        other: '{{count}} segundo baino gutxiago'
    },
    xSeconds: {
        one: '1 segundo',
        other: '{{count}} segundo'
    },
    halfAMinute: 'minutu erdi',
    lessThanXMinutes: {
        one: 'minutu bat baino gutxiago',
        other: '{{count}} minutu baino gutxiago'
    },
    xMinutes: {
        one: '1 minutu',
        other: '{{count}} minutu'
    },
    aboutXHours: {
        one: '1 ordu gutxi gorabehera',
        other: '{{count}} ordu gutxi gorabehera'
    },
    xHours: {
        one: '1 ordu',
        other: '{{count}} ordu'
    },
    xDays: {
        one: '1 egun',
        other: '{{count}} egun'
    },
    aboutXWeeks: {
        one: 'aste 1 inguru',
        other: '{{count}} aste inguru'
    },
    xWeeks: {
        one: '1 aste',
        other: '{{count}} astean'
    },
    aboutXMonths: {
        one: '1 hilabete gutxi gorabehera',
        other: '{{count}} hilabete gutxi gorabehera'
    },
    xMonths: {
        one: '1 hilabete',
        other: '{{count}} hilabete'
    },
    aboutXYears: {
        one: '1 urte gutxi gorabehera',
        other: '{{count}} urte gutxi gorabehera'
    },
    xYears: {
        one: '1 urte',
        other: '{{count}} urte'
    },
    overXYears: {
        one: '1 urte baino gehiago',
        other: '{{count}} urte baino gehiago'
    },
    almostXYears: {
        one: 'ia 1 urte',
        other: 'ia {{count}} urte'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'en ' + result;
        else return 'duela ' + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"hHQIs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE, y'ko' MMMM'ren' d'a' y'ren'",
    long: "y'ko' MMMM'ren' d'a'",
    medium: 'y MMM d',
    short: 'yy/MM/dd'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'tan' {{time}}",
    long: "{{date}} 'tan' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"lvzhl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'joan den' eeee, LT",
    yesterday: "'atzo,' p",
    today: "'gaur,' p",
    tomorrow: "'bihar,' p",
    nextWeek: 'eeee, p',
    other: 'P'
};
var formatRelativeLocalePlural = {
    lastWeek: "'joan den' eeee, p",
    yesterday: "'atzo,' p",
    today: "'gaur,' p",
    tomorrow: "'bihar,' p",
    nextWeek: 'eeee, p',
    other: 'P'
};
var formatRelative = function formatRelative(token, date) {
    if (date.getUTCHours() !== 1) return formatRelativeLocalePlural[token];
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3dUuE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'k.a.',
        'k.o.'
    ],
    abbreviated: [
        'k.a.',
        'k.o.'
    ],
    wide: [
        'kristo aurretik',
        'kristo ondoren'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        '1H',
        '2H',
        '3H',
        '4H'
    ],
    wide: [
        '1. hiruhilekoa',
        '2. hiruhilekoa',
        '3. hiruhilekoa',
        '4. hiruhilekoa'
    ]
};
var monthValues = {
    narrow: [
        'u',
        'o',
        'm',
        'a',
        'm',
        'e',
        'u',
        'a',
        'i',
        'u',
        'a',
        'a'
    ],
    abbreviated: [
        'urt',
        'ots',
        'mar',
        'api',
        'mai',
        'eka',
        'uzt',
        'abu',
        'ira',
        'urr',
        'aza',
        'abe'
    ],
    wide: [
        'urtarrila',
        'otsaila',
        'martxoa',
        'apirila',
        'maiatza',
        'ekaina',
        'uztaila',
        'abuztua',
        'iraila',
        'urria',
        'azaroa',
        'abendua'
    ]
};
var dayValues = {
    narrow: [
        'i',
        'a',
        'a',
        'a',
        'o',
        'o',
        'l'
    ],
    short: [
        'ig',
        'al',
        'as',
        'az',
        'og',
        'or',
        'lr'
    ],
    abbreviated: [
        'iga',
        'ast',
        'ast',
        'ast',
        'ost',
        'ost',
        'lar'
    ],
    wide: [
        'igandea',
        'astelehena',
        'asteartea',
        'asteazkena',
        'osteguna',
        'ostirala',
        'larunbata'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'ge',
        noon: 'eg',
        morning: 'goiza',
        afternoon: 'arratsaldea',
        evening: 'arratsaldea',
        night: 'gaua'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'gauerdia',
        noon: 'eguerdia',
        morning: 'goiza',
        afternoon: 'arratsaldea',
        evening: 'arratsaldea',
        night: 'gaua'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'gauerdia',
        noon: 'eguerdia',
        morning: 'goiza',
        afternoon: 'arratsaldea',
        evening: 'arratsaldea',
        night: 'gaua'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'ge',
        noon: 'eg',
        morning: 'goizean',
        afternoon: 'arratsaldean',
        evening: 'arratsaldean',
        night: 'gauean'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'gauerdia',
        noon: 'eguerdia',
        morning: 'goizean',
        afternoon: 'arratsaldean',
        evening: 'arratsaldean',
        night: 'gauean'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'gauerdia',
        noon: 'eguerdia',
        morning: 'goizean',
        afternoon: 'arratsaldean',
        evening: 'arratsaldean',
        night: 'gauean'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"lc8jl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(.)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(k.a.|k.o.)/i,
    abbreviated: /^(k.a.|k.o.)/i,
    wide: /^(kristo aurretik|kristo ondoren)/i
};
var parseEraPatterns = {
    narrow: [
        /^k.a./i,
        /^k.o./i
    ],
    abbreviated: [
        /^(k.a.)/i,
        /^(k.o.)/i
    ],
    wide: [
        /^(kristo aurretik)/i,
        /^(kristo ondoren)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]H/i,
    wide: /^[1234](.)? hiruhilekoa/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[uomaei]/i,
    abbreviated: /^(urt|ots|mar|api|mai|eka|uzt|abu|ira|urr|aza|abe)/i,
    wide: /^(urtarrila|otsaila|martxoa|apirila|maiatza|ekaina|uztaila|abuztua|iraila|urria|azaroa|abendua)/i
};
var parseMonthPatterns = {
    narrow: [
        /^u/i,
        /^o/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^e/i,
        /^u/i,
        /^a/i,
        /^i/i,
        /^u/i,
        /^a/i,
        /^a/i
    ],
    any: [
        /^urt/i,
        /^ots/i,
        /^mar/i,
        /^api/i,
        /^mai/i,
        /^eka/i,
        /^uzt/i,
        /^abu/i,
        /^ira/i,
        /^urr/i,
        /^aza/i,
        /^abe/i
    ]
};
var matchDayPatterns = {
    narrow: /^[iaol]/i,
    short: /^(ig|al|as|az|og|or|lr)/i,
    abbreviated: /^(iga|ast|ast|ast|ost|ost|lar)/i,
    wide: /^(igandea|astelehena|asteartea|asteazkena|osteguna|ostirala|larunbata)/i
};
var parseDayPatterns = {
    narrow: [
        /^i/i,
        /^a/i,
        /^a/i,
        /^a/i,
        /^o/i,
        /^o/i,
        /^l/i
    ],
    short: [
        /^ig/i,
        /^al/i,
        /^as/i,
        /^az/i,
        /^og/i,
        /^or/i,
        /^lr/i
    ],
    abbreviated: [
        /^iga/i,
        /^ast/i,
        /^ast/i,
        /^ast/i,
        /^ost/i,
        /^ost/i,
        /^lar/i
    ],
    wide: [
        /^igandea/i,
        /^astelehena/i,
        /^asteartea/i,
        /^asteazkena/i,
        /^osteguna/i,
        /^ostirala/i,
        /^larunbata/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|ge|eg|((goiza|goizean)|arratsaldea|(gaua|gauean)))/i,
    any: /^([ap]\.?\s?m\.?|gauerdia|eguerdia|((goiza|goizean)|arratsaldea|(gaua|gauean)))/i
};
var parseDayPeriodPatterns = {
    narrow: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^ge/i,
        noon: /^eg/i,
        morning: /goiz/i,
        afternoon: /arratsaldea/i,
        evening: /arratsaldea/i,
        night: /gau/i
    },
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^gauerdia/i,
        noon: /^eguerdia/i,
        morning: /goiz/i,
        afternoon: /arratsaldea/i,
        evening: /arratsaldea/i,
        night: /gau/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"ebimY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Persian/Farsi locale (Iran).
 * @language Persian
 * @iso-639-2 ira
 * @author Morteza Ziyae [@mort3za]{@link https://github.com/mort3za}
 */ var locale = {
    code: 'fa-IR',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 6 /* Saturday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"76jwb","./_lib/formatLong/index.js":"16r6c","./_lib/formatRelative/index.js":"j3OdG","./_lib/localize/index.js":"lGUq1","./_lib/match/index.js":"9NjeL","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"76jwb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u06A9\u0645\u062A\u0631 \u0627\u0632 \u06CC\u06A9 \u062B\u0627\u0646\u06CC\u0647",
        other: "\u06A9\u0645\u062A\u0631 \u0627\u0632 {{count}} \u062B\u0627\u0646\u06CC\u0647"
    },
    xSeconds: {
        one: "1 \u062B\u0627\u0646\u06CC\u0647",
        other: "{{count}} \u062B\u0627\u0646\u06CC\u0647"
    },
    halfAMinute: "\u0646\u06CC\u0645 \u062F\u0642\u06CC\u0642\u0647",
    lessThanXMinutes: {
        one: "\u06A9\u0645\u062A\u0631 \u0627\u0632 \u06CC\u06A9 \u062F\u0642\u06CC\u0642\u0647",
        other: "\u06A9\u0645\u062A\u0631 \u0627\u0632 {{count}} \u062F\u0642\u06CC\u0642\u0647"
    },
    xMinutes: {
        one: "1 \u062F\u0642\u06CC\u0642\u0647",
        other: "{{count}} \u062F\u0642\u06CC\u0642\u0647"
    },
    aboutXHours: {
        one: "\u062D\u062F\u0648\u062F 1 \u0633\u0627\u0639\u062A",
        other: "\u062D\u062F\u0648\u062F {{count}} \u0633\u0627\u0639\u062A"
    },
    xHours: {
        one: "1 \u0633\u0627\u0639\u062A",
        other: "{{count}} \u0633\u0627\u0639\u062A"
    },
    xDays: {
        one: "1 \u0631\u0648\u0632",
        other: "{{count}} \u0631\u0648\u0632"
    },
    aboutXWeeks: {
        one: "\u062D\u062F\u0648\u062F 1 \u0647\u0641\u062A\u0647",
        other: "\u062D\u062F\u0648\u062F {{count}} \u0647\u0641\u062A\u0647"
    },
    xWeeks: {
        one: "1 \u0647\u0641\u062A\u0647",
        other: "{{count}} \u0647\u0641\u062A\u0647"
    },
    aboutXMonths: {
        one: "\u062D\u062F\u0648\u062F 1 \u0645\u0627\u0647",
        other: "\u062D\u062F\u0648\u062F {{count}} \u0645\u0627\u0647"
    },
    xMonths: {
        one: "1 \u0645\u0627\u0647",
        other: "{{count}} \u0645\u0627\u0647"
    },
    aboutXYears: {
        one: "\u062D\u062F\u0648\u062F 1 \u0633\u0627\u0644",
        other: "\u062D\u062F\u0648\u062F {{count}} \u0633\u0627\u0644"
    },
    xYears: {
        one: "1 \u0633\u0627\u0644",
        other: "{{count}} \u0633\u0627\u0644"
    },
    overXYears: {
        one: "\u0628\u06CC\u0634\u062A\u0631 \u0627\u0632 1 \u0633\u0627\u0644",
        other: "\u0628\u06CC\u0634\u062A\u0631 \u0627\u0632 {{count}} \u0633\u0627\u0644"
    },
    almostXYears: {
        one: "\u0646\u0632\u062F\u06CC\u06A9 1 \u0633\u0627\u0644",
        other: "\u0646\u0632\u062F\u06CC\u06A9 {{count}} \u0633\u0627\u0644"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u062F\u0631 " + result;
        else return result + " \u0642\u0628\u0644";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"16r6c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE do MMMM y',
    long: 'do MMMM y',
    medium: 'd MMM y',
    short: 'yyyy/MM/dd'
};
var timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var dateTimeFormats = {
    full: "{{date}} '\u062F\u0631' {{time}}",
    long: "{{date}} '\u062F\u0631' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"j3OdG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "eeee '\u06AF\u0630\u0634\u062A\u0647 \u062F\u0631' p",
    yesterday: "'\u062F\u06CC\u0631\u0648\u0632 \u062F\u0631' p",
    today: "'\u0627\u0645\u0631\u0648\u0632 \u062F\u0631' p",
    tomorrow: "'\u0641\u0631\u062F\u0627 \u062F\u0631' p",
    nextWeek: "eeee '\u062F\u0631' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"lGUq1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0632 \u0645\u06CC\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0632 \u0645\u06CC\u0644\u0627\u062F"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u0633\u200C\u06451",
        "\u0633\u200C\u06452",
        "\u0633\u200C\u06453",
        "\u0633\u200C\u06454"
    ],
    wide: [
        "\u0633\u0647\u200C\u0645\u0627\u0647\u0647 1",
        "\u0633\u0647\u200C\u0645\u0627\u0647\u0647 2",
        "\u0633\u0647\u200C\u0645\u0627\u0647\u0647 3",
        "\u0633\u0647\u200C\u0645\u0627\u0647\u0647 4"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
    narrow: [
        "\u0698",
        "\u0641",
        "\u0645",
        "\u0622",
        "\u0645",
        "\u062C",
        "\u062C",
        "\u0622",
        "\u0633",
        "\u0627",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u0698\u0627\u0646\u0640",
        "\u0641\u0648\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0622\u067E\u0631",
        "\u0645\u06CC",
        "\u062C\u0648\u0646",
        "\u062C\u0648\u0644\u0640",
        "\u0622\u06AF\u0648",
        "\u0633\u067E\u062A\u0640",
        "\u0627\u06A9\u062A\u0640",
        "\u0646\u0648\u0627\u0645\u0640",
        "\u062F\u0633\u0627\u0645\u0640"
    ],
    wide: [
        "\u0698\u0627\u0646\u0648\u06CC\u0647",
        "\u0641\u0648\u0631\u06CC\u0647",
        "\u0645\u0627\u0631\u0633",
        "\u0622\u067E\u0631\u06CC\u0644",
        "\u0645\u06CC",
        "\u062C\u0648\u0646",
        "\u062C\u0648\u0644\u0627\u06CC",
        "\u0622\u06AF\u0648\u0633\u062A",
        "\u0633\u067E\u062A\u0627\u0645\u0628\u0631",
        "\u0627\u06A9\u062A\u0628\u0631",
        "\u0646\u0648\u0627\u0645\u0628\u0631",
        "\u062F\u0633\u0627\u0645\u0628\u0631"
    ]
};
var dayValues = {
    narrow: [
        "\u06CC",
        "\u062F",
        "\u0633",
        "\u0686",
        "\u067E",
        "\u062C",
        "\u0634"
    ],
    short: [
        "1\u0634",
        "2\u0634",
        "3\u0634",
        "4\u0634",
        "5\u0634",
        "\u062C",
        "\u0634"
    ],
    abbreviated: [
        "\u06CC\u06A9\u0634\u0646\u0628\u0647",
        "\u062F\u0648\u0634\u0646\u0628\u0647",
        "\u0633\u0647\u200C\u0634\u0646\u0628\u0647",
        "\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647",
        "\u067E\u0646\u062C\u0634\u0646\u0628\u0647",
        "\u062C\u0645\u0639\u0647",
        "\u0634\u0646\u0628\u0647"
    ],
    wide: [
        "\u06CC\u06A9\u0634\u0646\u0628\u0647",
        "\u062F\u0648\u0634\u0646\u0628\u0647",
        "\u0633\u0647\u200C\u0634\u0646\u0628\u0647",
        "\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647",
        "\u067E\u0646\u062C\u0634\u0646\u0628\u0647",
        "\u062C\u0645\u0639\u0647",
        "\u0634\u0646\u0628\u0647"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u0642",
        pm: "\u0628",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635",
        afternoon: "\u0628.\u0638.",
        evening: "\u0639",
        night: "\u0634"
    },
    abbreviated: {
        am: "\u0642.\u0638.",
        pm: "\u0628.\u0638.",
        midnight: "\u0646\u06CC\u0645\u0647\u200C\u0634\u0628",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u062D",
        afternoon: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        evening: "\u0639\u0635\u0631",
        night: "\u0634\u0628"
    },
    wide: {
        am: "\u0642\u0628\u0644\u200C\u0627\u0632\u0638\u0647\u0631",
        pm: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        midnight: "\u0646\u06CC\u0645\u0647\u200C\u0634\u0628",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u062D",
        afternoon: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        evening: "\u0639\u0635\u0631",
        night: "\u0634\u0628"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u0642",
        pm: "\u0628",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635",
        afternoon: "\u0628.\u0638.",
        evening: "\u0639",
        night: "\u0634"
    },
    abbreviated: {
        am: "\u0642.\u0638.",
        pm: "\u0628.\u0638.",
        midnight: "\u0646\u06CC\u0645\u0647\u200C\u0634\u0628",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u062D",
        afternoon: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        evening: "\u0639\u0635\u0631",
        night: "\u0634\u0628"
    },
    wide: {
        am: "\u0642\u0628\u0644\u200C\u0627\u0632\u0638\u0647\u0631",
        pm: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        midnight: "\u0646\u06CC\u0645\u0647\u200C\u0634\u0628",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u062D",
        afternoon: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        evening: "\u0639\u0635\u0631",
        night: "\u0634\u0628"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"9NjeL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(ق|ب)/i,
    abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?د\.?\s?م\.?|م\.?\s?|د\.?\s?م\.?)/i,
    wide: /^(قبل از میلاد|قبل از دوران مشترک|میلادی|دوران مشترک|بعد از میلاد)/i
};
var parseEraPatterns = {
    any: [
        /^قبل/i,
        /^بعد/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^س‌م[1234]/i,
    wide: /^سه‌ماهه [1234]/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[جژفمآاماسند]/i,
    abbreviated: /^(جنو|ژانـ|ژانویه|فوریه|فور|مارس|آوریل|آپر|مه|می|ژوئن|جون|جول|جولـ|ژوئیه|اوت|آگو|سپتمبر|سپتامبر|اکتبر|اکتوبر|نوامبر|نوامـ|دسامبر|دسامـ|دسم)/i,
    wide: /^(ژانویه|جنوری|فبروری|فوریه|مارچ|مارس|آپریل|اپریل|ایپریل|آوریل|مه|می|ژوئن|جون|جولای|ژوئیه|آگست|اگست|آگوست|اوت|سپتمبر|سپتامبر|اکتبر|اکتوبر|نوامبر|نومبر|دسامبر|دسمبر)/i
};
var parseMonthPatterns = {
    narrow: [
        /^(ژ|ج)/i,
        /^ف/i,
        /^م/i,
        /^(آ|ا)/i,
        /^م/i,
        /^(ژ|ج)/i,
        /^(ج|ژ)/i,
        /^(آ|ا)/i,
        /^س/i,
        /^ا/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^ژا/i,
        /^ف/i,
        /^ما/i,
        /^آپ/i,
        /^(می|مه)/i,
        /^(ژوئن|جون)/i,
        /^(ژوئی|جول)/i,
        /^(اوت|آگ)/i,
        /^س/i,
        /^(اوک|اک)/i,
        /^ن/i,
        /^د/i
    ]
};
var matchDayPatterns = {
    narrow: /^[شیدسچپج]/i,
    short: /^(ش|ج|1ش|2ش|3ش|4ش|5ش)/i,
    abbreviated: /^(یکشنبه|دوشنبه|سه‌شنبه|چهارشنبه|پنج‌شنبه|جمعه|شنبه)/i,
    wide: /^(یکشنبه|دوشنبه|سه‌شنبه|چهارشنبه|پنج‌شنبه|جمعه|شنبه)/i
};
var parseDayPatterns = {
    narrow: [
        /^ی/i,
        /^دو/i,
        /^س/i,
        /^چ/i,
        /^پ/i,
        /^ج/i,
        /^ش/i
    ],
    any: [
        /^(ی|1ش|یکشنبه)/i,
        /^(د|2ش|دوشنبه)/i,
        /^(س|3ش|سه‌شنبه)/i,
        /^(چ|4ش|چهارشنبه)/i,
        /^(پ|5ش|پنجشنبه)/i,
        /^(ج|جمعه)/i,
        /^(ش|شنبه)/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(ب|ق|ن|ظ|ص|ب.ظ.|ع|ش)/i,
    abbreviated: /^(ق.ظ.|ب.ظ.|نیمه‌شب|ظهر|صبح|بعدازظهر|عصر|شب)/i,
    wide: /^(قبل‌ازظهر|نیمه‌شب|ظهر|صبح|بعدازظهر|عصر|شب)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^(ق|ق.ظ.|قبل‌ازظهر)/i,
        pm: /^(ب|ب.ظ.|بعدازظهر)/i,
        midnight: /^(‌نیمه‌شب|ن)/i,
        noon: /^(ظ|ظهر)/i,
        morning: /(ص|صبح)/i,
        afternoon: /(ب|ب.ظ.|بعدازظهر)/i,
        evening: /(ع|عصر)/i,
        night: /(ش|شب)/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"j3aAH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Finnish locale.
 * @language Finnish
 * @iso-639-2 fin
 * @author Pyry-Samuli Lahti [@Pyppe]{@link https://github.com/Pyppe}
 * @author Edo Rivai [@mikolajgrzyb]{@link https://github.com/mikolajgrzyb}
 * @author Samu Juvonen [@sjuvonen]{@link https://github.com/sjuvonen}
 */ var locale = {
    code: 'fi',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"f2dB3","./_lib/formatLong/index.js":"5SFmO","./_lib/formatRelative/index.js":"aKNL1","./_lib/localize/index.js":"auVX0","./_lib/match/index.js":"jss2l","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"f2dB3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function futureSeconds(text) {
    return text.replace(/sekuntia?/, 'sekunnin');
}
function futureMinutes(text) {
    return text.replace(/minuuttia?/, 'minuutin');
}
function futureHours(text) {
    return text.replace(/tuntia?/, 'tunnin');
}
function futureDays(text) {
    return text.replace(/päivää?/, "p\xe4iv\xe4n");
}
function futureWeeks(text) {
    return text.replace(/(viikko|viikkoa)/, 'viikon');
}
function futureMonths(text) {
    return text.replace(/(kuukausi|kuukautta)/, 'kuukauden');
}
function futureYears(text) {
    return text.replace(/(vuosi|vuotta)/, 'vuoden');
}
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'alle sekunti',
        other: 'alle {{count}} sekuntia',
        futureTense: futureSeconds
    },
    xSeconds: {
        one: 'sekunti',
        other: '{{count}} sekuntia',
        futureTense: futureSeconds
    },
    halfAMinute: {
        one: 'puoli minuuttia',
        other: 'puoli minuuttia',
        futureTense: function futureTense(_text) {
            return 'puolen minuutin';
        }
    },
    lessThanXMinutes: {
        one: 'alle minuutti',
        other: 'alle {{count}} minuuttia',
        futureTense: futureMinutes
    },
    xMinutes: {
        one: 'minuutti',
        other: '{{count}} minuuttia',
        futureTense: futureMinutes
    },
    aboutXHours: {
        one: 'noin tunti',
        other: 'noin {{count}} tuntia',
        futureTense: futureHours
    },
    xHours: {
        one: 'tunti',
        other: '{{count}} tuntia',
        futureTense: futureHours
    },
    xDays: {
        one: "p\xe4iv\xe4",
        other: "{{count}} p\xe4iv\xe4\xe4",
        futureTense: futureDays
    },
    aboutXWeeks: {
        one: 'noin viikko',
        other: 'noin {{count}} viikkoa',
        futureTense: futureWeeks
    },
    xWeeks: {
        one: 'viikko',
        other: '{{count}} viikkoa',
        futureTense: futureWeeks
    },
    aboutXMonths: {
        one: 'noin kuukausi',
        other: 'noin {{count}} kuukautta',
        futureTense: futureMonths
    },
    xMonths: {
        one: 'kuukausi',
        other: '{{count}} kuukautta',
        futureTense: futureMonths
    },
    aboutXYears: {
        one: 'noin vuosi',
        other: 'noin {{count}} vuotta',
        futureTense: futureYears
    },
    xYears: {
        one: 'vuosi',
        other: '{{count}} vuotta',
        futureTense: futureYears
    },
    overXYears: {
        one: 'yli vuosi',
        other: 'yli {{count}} vuotta',
        futureTense: futureYears
    },
    almostXYears: {
        one: "l\xe4hes vuosi",
        other: "l\xe4hes {{count}} vuotta",
        futureTense: futureYears
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var tokenValue = formatDistanceLocale[token];
    var result = count === 1 ? tokenValue.one : tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return tokenValue.futureTense(result) + ' kuluttua';
        else return result + ' sitten';
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5SFmO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'eeee d. MMMM y',
    long: 'd. MMMM y',
    medium: 'd. MMM y',
    short: 'd.M.y'
};
var timeFormats = {
    full: 'HH.mm.ss zzzz',
    long: 'HH.mm.ss z',
    medium: 'HH.mm.ss',
    short: 'HH.mm'
};
var dateTimeFormats = {
    full: "{{date}} 'klo' {{time}}",
    long: "{{date}} 'klo' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"aKNL1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'viime' eeee 'klo' p",
    yesterday: "'eilen klo' p",
    today: "'t\xe4n\xe4\xe4n klo' p",
    tomorrow: "'huomenna klo' p",
    nextWeek: "'ensi' eeee 'klo' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"auVX0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'eaa.',
        'jaa.'
    ],
    abbreviated: [
        'eaa.',
        'jaa.'
    ],
    wide: [
        'ennen ajanlaskun alkua',
        "j\xe4lkeen ajanlaskun alun"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1. kvartaali',
        '2. kvartaali',
        '3. kvartaali',
        '4. kvartaali'
    ]
};
var monthValues = {
    narrow: [
        'T',
        'H',
        'M',
        'H',
        'T',
        'K',
        'H',
        'E',
        'S',
        'L',
        'M',
        'J'
    ],
    abbreviated: [
        'tammi',
        'helmi',
        'maalis',
        'huhti',
        'touko',
        "kes\xe4",
        "hein\xe4",
        'elo',
        'syys',
        'loka',
        'marras',
        'joulu'
    ],
    wide: [
        'tammikuu',
        'helmikuu',
        'maaliskuu',
        'huhtikuu',
        'toukokuu',
        "kes\xe4kuu",
        "hein\xe4kuu",
        'elokuu',
        'syyskuu',
        'lokakuu',
        'marraskuu',
        'joulukuu'
    ]
};
var formattingMonthValues = {
    narrow: monthValues.narrow,
    abbreviated: monthValues.abbreviated,
    wide: [
        'tammikuuta',
        'helmikuuta',
        'maaliskuuta',
        'huhtikuuta',
        'toukokuuta',
        "kes\xe4kuuta",
        "hein\xe4kuuta",
        'elokuuta',
        'syyskuuta',
        'lokakuuta',
        'marraskuuta',
        'joulukuuta'
    ]
};
var dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'K',
        'T',
        'P',
        'L'
    ],
    short: [
        'su',
        'ma',
        'ti',
        'ke',
        'to',
        'pe',
        'la'
    ],
    abbreviated: [
        'sunn.',
        'maan.',
        'tiis.',
        'kesk.',
        'torst.',
        'perj.',
        'la'
    ],
    wide: [
        'sunnuntai',
        'maanantai',
        'tiistai',
        'keskiviikko',
        'torstai',
        'perjantai',
        'lauantai'
    ]
};
var formattingDayValues = {
    narrow: dayValues.narrow,
    short: dayValues.short,
    abbreviated: dayValues.abbreviated,
    wide: [
        'sunnuntaina',
        'maanantaina',
        'tiistaina',
        'keskiviikkona',
        'torstaina',
        'perjantaina',
        'lauantaina'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'ap',
        pm: 'ip',
        midnight: "keskiy\xf6",
        noon: "keskip\xe4iv\xe4",
        morning: 'ap',
        afternoon: 'ip',
        evening: 'illalla',
        night: "y\xf6ll\xe4"
    },
    abbreviated: {
        am: 'ap',
        pm: 'ip',
        midnight: "keskiy\xf6",
        noon: "keskip\xe4iv\xe4",
        morning: 'ap',
        afternoon: 'ip',
        evening: 'illalla',
        night: "y\xf6ll\xe4"
    },
    wide: {
        am: 'ap',
        pm: 'ip',
        midnight: "keskiy\xf6ll\xe4",
        noon: "keskip\xe4iv\xe4ll\xe4",
        morning: "aamup\xe4iv\xe4ll\xe4",
        afternoon: "iltap\xe4iv\xe4ll\xe4",
        evening: 'illalla',
        night: "y\xf6ll\xe4"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide',
        formattingValues: formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayValues,
        defaultFormattingWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jss2l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(\.)/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(e|j)/i,
    abbreviated: /^(eaa.|jaa.)/i,
    wide: /^(ennen ajanlaskun alkua|jälkeen ajanlaskun alun)/i
};
var parseEraPatterns = {
    any: [
        /^e/i,
        /^j/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234]\.? kvartaali/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[thmkeslj]/i,
    abbreviated: /^(tammi|helmi|maalis|huhti|touko|kesä|heinä|elo|syys|loka|marras|joulu)/i,
    wide: /^(tammikuu|helmikuu|maaliskuu|huhtikuu|toukokuu|kesäkuu|heinäkuu|elokuu|syyskuu|lokakuu|marraskuu|joulukuu)(ta)?/i
};
var parseMonthPatterns = {
    narrow: [
        /^t/i,
        /^h/i,
        /^m/i,
        /^h/i,
        /^t/i,
        /^k/i,
        /^h/i,
        /^e/i,
        /^s/i,
        /^l/i,
        /^m/i,
        /^j/i
    ],
    any: [
        /^ta/i,
        /^hel/i,
        /^maa/i,
        /^hu/i,
        /^to/i,
        /^k/i,
        /^hei/i,
        /^e/i,
        /^s/i,
        /^l/i,
        /^mar/i,
        /^j/i
    ]
};
var matchDayPatterns = {
    narrow: /^[smtkpl]/i,
    short: /^(su|ma|ti|ke|to|pe|la)/i,
    abbreviated: /^(sunn.|maan.|tiis.|kesk.|torst.|perj.|la)/i,
    wide: /^(sunnuntai|maanantai|tiistai|keskiviikko|torstai|perjantai|lauantai)(na)?/i
};
var parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^k/i,
        /^t/i,
        /^p/i,
        /^l/i
    ],
    any: [
        /^s/i,
        /^m/i,
        /^ti/i,
        /^k/i,
        /^to/i,
        /^p/i,
        /^l/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(ap|ip|keskiyö|keskipäivä|aamupäivällä|iltapäivällä|illalla|yöllä)/i,
    any: /^(ap|ip|keskiyöllä|keskipäivällä|aamupäivällä|iltapäivällä|illalla|yöllä)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^ap/i,
        pm: /^ip/i,
        midnight: /^keskiyö/i,
        noon: /^keskipäivä/i,
        morning: /aamupäivällä/i,
        afternoon: /iltapäivällä/i,
        evening: /illalla/i,
        night: /yöllä/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"fNooG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary French locale.
 * @language French
 * @iso-639-2 fra
 * @author Jean Dupouy [@izeau]{@link https://github.com/izeau}
 * @author François B [@fbonzon]{@link https://github.com/fbonzon}
 */ var locale = {
    code: 'fr',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"aceMt","./_lib/formatLong/index.js":"7jOo7","./_lib/formatRelative/index.js":"fOCPr","./_lib/localize/index.js":"dEs0n","./_lib/match/index.js":"ih8pC","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"aceMt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "moins d\u2019une seconde",
        other: 'moins de {{count}} secondes'
    },
    xSeconds: {
        one: '1 seconde',
        other: '{{count}} secondes'
    },
    halfAMinute: '30 secondes',
    lessThanXMinutes: {
        one: "moins d\u2019une minute",
        other: 'moins de {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'environ 1 heure',
        other: 'environ {{count}} heures'
    },
    xHours: {
        one: '1 heure',
        other: '{{count}} heures'
    },
    xDays: {
        one: '1 jour',
        other: '{{count}} jours'
    },
    aboutXWeeks: {
        one: 'environ 1 semaine',
        other: 'environ {{count}} semaines'
    },
    xWeeks: {
        one: '1 semaine',
        other: '{{count}} semaines'
    },
    aboutXMonths: {
        one: 'environ 1 mois',
        other: 'environ {{count}} mois'
    },
    xMonths: {
        one: '1 mois',
        other: '{{count}} mois'
    },
    aboutXYears: {
        one: 'environ 1 an',
        other: 'environ {{count}} ans'
    },
    xYears: {
        one: '1 an',
        other: '{{count}} ans'
    },
    overXYears: {
        one: "plus d\u2019un an",
        other: 'plus de {{count}} ans'
    },
    almostXYears: {
        one: "presqu\u2019un an",
        other: 'presque {{count}} ans'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var form = formatDistanceLocale[token];
    if (typeof form === 'string') result = form;
    else if (count === 1) result = form.one;
    else result = form.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'dans ' + result;
        else return 'il y a ' + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7jOo7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd/MM/y'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} '\xe0' {{time}}",
    long: "{{date}} '\xe0' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"fOCPr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "eeee 'dernier \xe0' p",
    yesterday: "'hier \xe0' p",
    today: "'aujourd\u2019hui \xe0' p",
    tomorrow: "'demain \xe0' p'",
    nextWeek: "eeee 'prochain \xe0' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"dEs0n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'av. J.-C',
        'ap. J.-C'
    ],
    abbreviated: [
        'av. J.-C',
        'ap. J.-C'
    ],
    wide: [
        "avant J\xe9sus-Christ",
        "apr\xe8s J\xe9sus-Christ"
    ]
};
var quarterValues = {
    narrow: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    abbreviated: [
        '1er trim.',
        "2\xe8me trim.",
        "3\xe8me trim.",
        "4\xe8me trim."
    ],
    wide: [
        '1er trimestre',
        "2\xe8me trimestre",
        "3\xe8me trimestre",
        "4\xe8me trimestre"
    ]
};
var monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'janv.',
        "f\xe9vr.",
        'mars',
        'avr.',
        'mai',
        'juin',
        'juil.',
        "ao\xfbt",
        'sept.',
        'oct.',
        'nov.',
        "d\xe9c."
    ],
    wide: [
        'janvier',
        "f\xe9vrier",
        'mars',
        'avril',
        'mai',
        'juin',
        'juillet',
        "ao\xfbt",
        'septembre',
        'octobre',
        'novembre',
        "d\xe9cembre"
    ]
};
var dayValues = {
    narrow: [
        'D',
        'L',
        'M',
        'M',
        'J',
        'V',
        'S'
    ],
    short: [
        'di',
        'lu',
        'ma',
        'me',
        'je',
        've',
        'sa'
    ],
    abbreviated: [
        'dim.',
        'lun.',
        'mar.',
        'mer.',
        'jeu.',
        'ven.',
        'sam.'
    ],
    wide: [
        'dimanche',
        'lundi',
        'mardi',
        'mercredi',
        'jeudi',
        'vendredi',
        'samedi'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'minuit',
        noon: 'midi',
        morning: 'mat.',
        afternoon: 'ap.m.',
        evening: 'soir',
        night: 'mat.'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'minuit',
        noon: 'midi',
        morning: 'matin',
        afternoon: "apr\xe8s-midi",
        evening: 'soir',
        night: 'matin'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'minuit',
        noon: 'midi',
        morning: 'du matin',
        afternoon: "de l\u2019apr\xe8s-midi",
        evening: 'du soir',
        night: 'du matin'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    if (number === 0) return '0';
    var feminineUnits = [
        'year',
        'week',
        'hour',
        'minute',
        'second'
    ];
    var suffix;
    if (number === 1) suffix = unit && feminineUnits.includes(unit) ? "\xe8re" : 'er';
    else suffix = "\xe8me";
    return number + suffix;
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"ih8pC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(ième|ère|ème|er|e)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
    abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
    wide: /^(avant Jésus-Christ|après Jésus-Christ)/i
};
var parseEraPatterns = {
    any: [
        /^av/i,
        /^ap/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^T?[1234]/i,
    abbreviated: /^[1234](er|ème|e)? trim\.?/i,
    wide: /^[1234](er|ème|e)? trimestre/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
    wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^av/i,
        /^ma/i,
        /^juin/i,
        /^juil/i,
        /^ao/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[lmjvsd]/i,
    short: /^(di|lu|ma|me|je|ve|sa)/i,
    abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
    wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
};
var parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^di/i,
        /^lu/i,
        /^ma/i,
        /^me/i,
        /^je/i,
        /^ve/i,
        /^sa/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
    any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^min/i,
        noon: /^mid/i,
        morning: /mat/i,
        afternoon: /ap/i,
        evening: /soir/i,
        night: /nuit/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"80gFS":[function(require,module,exports,__globalThis) {
// Same as fr
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../fr/_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../fr/_lib/formatRelative/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../fr/_lib/localize/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../fr/_lib/match/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
// Unique for fr-CA
var _indexJs4 = require("./_lib/formatLong/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary French locale (Canada).
 * @language French
 * @iso-639-2 fra
 * @author Jean Dupouy [@izeau]{@link https://github.com/izeau}
 * @author François B [@fbonzon]{@link https://github.com/fbonzon}
 * @author Gabriele Petrioli [@gpetrioli]{@link https://github.com/gpetrioli}
 */ var locale = {
    code: 'fr-CA',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault4.default),
    formatRelative: (0, _indexJsDefault1.default),
    localize: (0, _indexJsDefault2.default),
    match: (0, _indexJsDefault3.default),
    // Unique for fr-CA
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"../fr/_lib/formatDistance/index.js":"aceMt","../fr/_lib/formatRelative/index.js":"fOCPr","../fr/_lib/localize/index.js":"dEs0n","../fr/_lib/match/index.js":"ih8pC","./_lib/formatLong/index.js":"ycQl2","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"ycQl2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'yy-MM-dd'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} '\xe0' {{time}}",
    long: "{{date}} '\xe0' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"853bI":[function(require,module,exports,__globalThis) {
// Same as fr
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../fr/_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../fr/_lib/localize/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../fr/_lib/match/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
// Unique for fr-CH
var _indexJs3 = require("./_lib/formatLong/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/formatRelative/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary French locale (Switzerland).
 * @language French
 * @iso-639-2 fra
 * @author Jean Dupouy [@izeau]{@link https://github.com/izeau}
 * @author François B [@fbonzon]{@link https://github.com/fbonzon}
 * @author Van Vuong Ngo [@vanvuongngo]{@link https://github.com/vanvuongngo}
 * @author Alex Hoeing [@dcbn]{@link https://github.com/dcbn}
 */ var locale = {
    code: 'fr-CH',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault3.default),
    formatRelative: (0, _indexJsDefault4.default),
    localize: (0, _indexJsDefault1.default),
    match: (0, _indexJsDefault2.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"../fr/_lib/formatDistance/index.js":"aceMt","../fr/_lib/localize/index.js":"dEs0n","../fr/_lib/match/index.js":"ih8pC","./_lib/formatLong/index.js":"6gI4i","./_lib/formatRelative/index.js":"9zaRM","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6gI4i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd.MM.y'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} '\xe0' {{time}}",
    long: "{{date}} '\xe0' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"9zaRM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "eeee 'la semaine derni\xe8re \xe0' p",
    yesterday: "'hier \xe0' p",
    today: "'aujourd\u2019hui \xe0' p",
    tomorrow: "'demain \xe0' p'",
    nextWeek: "eeee 'la semaine prochaine \xe0' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"9RrvA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Western Frisian locale (Netherlands).
 * @language West Frisian
 * @iso-639-2 fry
 * @author Damon Asberg [@damon02]{@link https://github.com/damon02}
 */ var locale = {
    code: 'fy',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"hHEF9","./_lib/formatLong/index.js":"gI55p","./_lib/formatRelative/index.js":"8pO77","./_lib/localize/index.js":"dqjDN","./_lib/match/index.js":"c46DY","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"hHEF9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'minder as 1 sekonde',
        other: 'minder as {{count}} sekonden'
    },
    xSeconds: {
        one: '1 sekonde',
        other: '{{count}} sekonden'
    },
    halfAMinute: "oardel min\xfat",
    lessThanXMinutes: {
        one: "minder as 1 min\xfat",
        other: 'minder as {{count}} minuten'
    },
    xMinutes: {
        one: "1 min\xfat",
        other: '{{count}} minuten'
    },
    aboutXHours: {
        one: 'sawat 1 oere',
        other: 'sawat {{count}} oere'
    },
    xHours: {
        one: '1 oere',
        other: '{{count}} oere'
    },
    xDays: {
        one: '1 dei',
        other: '{{count}} dagen'
    },
    aboutXWeeks: {
        one: 'sawat 1 wike',
        other: 'sawat {{count}} wiken'
    },
    xWeeks: {
        one: '1 wike',
        other: '{{count}} wiken'
    },
    aboutXMonths: {
        one: 'sawat 1 moanne',
        other: 'sawat {{count}} moannen'
    },
    xMonths: {
        one: '1 moanne',
        other: '{{count}} moannen'
    },
    aboutXYears: {
        one: 'sawat 1 jier',
        other: 'sawat {{count}} jier'
    },
    xYears: {
        one: '1 jier',
        other: '{{count}} jier'
    },
    overXYears: {
        one: 'mear as 1 jier',
        other: 'mear as {{count}}s jier'
    },
    almostXYears: {
        one: 'hast 1 jier',
        other: 'hast {{count}} jier'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'oer ' + result;
        else return result + ' lyn';
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gI55p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd-MM-y'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'om' {{time}}",
    long: "{{date}} 'om' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8pO77":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'\xf4fr\xfbne' eeee 'om' p",
    yesterday: "'juster om' p",
    today: "'hjoed om' p",
    tomorrow: "'moarn om' p",
    nextWeek: "eeee 'om' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"dqjDN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'f.K.',
        'n.K.'
    ],
    abbreviated: [
        'f.Kr.',
        'n.Kr.'
    ],
    wide: [
        'foar Kristus',
        'nei Kristus'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        '1e fearnsjier',
        '2e fearnsjier',
        '3e fearnsjier',
        '4e fearnsjier'
    ]
};
var monthValues = {
    narrow: [
        'j',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mrt.',
        'apr.',
        'mai.',
        'jun.',
        'jul.',
        'aug.',
        'sep.',
        'okt.',
        'nov.',
        'des.'
    ],
    wide: [
        'jannewaris',
        'febrewaris',
        'maart',
        'april',
        'maaie',
        'juny',
        'july',
        'augustus',
        'septimber',
        'oktober',
        'novimber',
        'desimber'
    ]
};
var dayValues = {
    narrow: [
        's',
        'm',
        't',
        'w',
        't',
        'f',
        's'
    ],
    short: [
        'si',
        'mo',
        'ti',
        'wo',
        'to',
        'fr',
        'so'
    ],
    abbreviated: [
        'snein',
        'moa',
        'tii',
        'woa',
        'ton',
        'fre',
        'sneon'
    ],
    wide: [
        'snein',
        'moandei',
        'tiisdei',
        'woansdei',
        'tongersdei',
        'freed',
        'sneon'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'middei',
        morning: 'moarns',
        afternoon: 'middeis',
        evening: "j\xfbns",
        night: 'nachts'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'middei',
        morning: 'moarns',
        afternoon: 'middeis',
        evening: "j\xfbns",
        night: 'nachts'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'middei',
        morning: 'moarns',
        afternoon: 'middeis',
        evening: "j\xfbns",
        night: 'nachts'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + 'e';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"c46DY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)e?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^([fn]\.? ?K\.?)/,
    abbreviated: /^([fn]\. ?Kr\.?)/,
    wide: /^((foar|nei) Kristus)/
};
var parseEraPatterns = {
    any: [
        /^f/,
        /^n/
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234]e fearnsjier/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mrt.|apr.|mai.|jun.|jul.|aug.|sep.|okt.|nov.|des.)/i,
    wide: /^(jannewaris|febrewaris|maart|april|maaie|juny|july|augustus|septimber|oktober|novimber|desimber)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^jan/i,
        /^feb/i,
        /^m(r|a)/i,
        /^apr/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^sep/i,
        /^okt/i,
        /^nov/i,
        /^des/i
    ]
};
var matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(si|mo|ti|wo|to|fr|so)/i,
    abbreviated: /^(snein|moa|tii|woa|ton|fre|sneon)/i,
    wide: /^(snein|moandei|tiisdei|woansdei|tongersdei|freed|sneon)/i
};
var parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^sn/i,
        /^mo/i,
        /^ti/i,
        /^wo/i,
        /^to/i,
        /^fr/i,
        /^sn/i
    ]
};
var matchDayPeriodPatterns = {
    any: /^(am|pm|middernacht|middeis|moarns|middei|jûns|nachts)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /^middernacht/i,
        noon: /^middei/i,
        morning: /moarns/i,
        afternoon: /^middeis/i,
        evening: /jûns/i,
        night: /nachts/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"iMY0I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Scottish Gaelic.
 * @language Scottish Gaelic
 * @iso-639-2 gla
 * @author Lee Driscoll [@leedriscoll]{@link https://github.com/leedriscoll}
 */ var locale = {
    code: 'gd',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"k62XF","./_lib/formatLong/index.js":"97eRM","./_lib/formatRelative/index.js":"di5aZ","./_lib/localize/index.js":"jFJYr","./_lib/match/index.js":"8prwj","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"k62XF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'nas lugha na diog',
        other: 'nas lugha na {{count}} diogan'
    },
    xSeconds: {
        one: '1 diog',
        two: '2 dhiog',
        twenty: '20 diog',
        other: '{{count}} diogan'
    },
    halfAMinute: 'leth mhionaid',
    lessThanXMinutes: {
        one: 'nas lugha na mionaid',
        other: 'nas lugha na {{count}} mionaidean'
    },
    xMinutes: {
        one: '1 mionaid',
        two: '2 mhionaid',
        twenty: '20 mionaid',
        other: '{{count}} mionaidean'
    },
    aboutXHours: {
        one: "mu uair de th\xecde",
        other: "mu {{count}} uairean de th\xecde"
    },
    xHours: {
        one: "1 uair de th\xecde",
        two: "2 uair de th\xecde",
        twenty: "20 uair de th\xecde",
        other: "{{count}} uairean de th\xecde"
    },
    xDays: {
        one: "1 l\xe0",
        other: "{{count}} l\xe0"
    },
    aboutXWeeks: {
        one: 'mu 1 seachdain',
        other: 'mu {{count}} seachdainean'
    },
    xWeeks: {
        one: '1 seachdain',
        other: '{{count}} seachdainean'
    },
    aboutXMonths: {
        one: "mu mh\xecos",
        other: "mu {{count}} m\xecosan"
    },
    xMonths: {
        one: "1 m\xecos",
        other: "{{count}} m\xecosan"
    },
    aboutXYears: {
        one: 'mu bhliadhna',
        other: 'mu {{count}} bliadhnaichean'
    },
    xYears: {
        one: '1 bhliadhna',
        other: '{{count}} bliadhna'
    },
    overXYears: {
        one: "c\xf2rr is bliadhna",
        other: "c\xf2rr is {{count}} bliadhnaichean"
    },
    almostXYears: {
        one: "cha mh\xf2r bliadhna",
        other: "cha mh\xf2r {{count}} bliadhnaichean"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2 && !!tokenValue.two) result = tokenValue.two;
    else if (count === 20 && !!tokenValue.twenty) result = tokenValue.twenty;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'ann an ' + result;
        else return 'o chionn ' + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"97eRM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var dateTimeFormats = {
    full: "{{date}} 'aig' {{time}}",
    long: "{{date}} 'aig' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"di5aZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'mu dheireadh' eeee 'aig' p",
    //FIX
    yesterday: "'an-d\xe8 aig' p",
    today: "'an-diugh aig' p",
    tomorrow: "'a-m\xe0ireach aig' p",
    nextWeek: "eeee 'aig' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jFJYr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'R',
        'A'
    ],
    abbreviated: [
        'RC',
        'AD'
    ],
    wide: [
        "ro Chr\xecosta",
        'anno domini'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'C1',
        'C2',
        'C3',
        'C4'
    ],
    wide: [
        "a' chiad chairteal",
        "an d\xe0rna cairteal",
        'an treas cairteal',
        'an ceathramh cairteal'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
    narrow: [
        'F',
        'G',
        'M',
        'G',
        'C',
        "\xd2",
        'I',
        'L',
        'S',
        'D',
        'S',
        'D'
    ],
    abbreviated: [
        'Faoi',
        'Gear',
        "M\xe0rt",
        'Gibl',
        "C\xe8it",
        "\xd2gmh",
        'Iuch',
        "L\xf9n",
        'Sult',
        "D\xe0mh",
        'Samh',
        "D\xf9bh"
    ],
    wide: [
        'Am Faoilleach',
        'An Gearran',
        "Am M\xe0rt",
        'An Giblean',
        "An C\xe8itean",
        "An t-\xd2gmhios",
        'An t-Iuchar',
        "An L\xf9nastal",
        'An t-Sultain',
        "An D\xe0mhair",
        'An t-Samhain',
        "An D\xf9bhlachd"
    ]
};
var dayValues = {
    narrow: [
        'D',
        'L',
        'M',
        'C',
        'A',
        'H',
        'S'
    ],
    short: [
        "D\xf2",
        'Lu',
        "M\xe0",
        'Ci',
        'Ar',
        'Ha',
        'Sa'
    ],
    abbreviated: [
        'Did',
        'Dil',
        'Dim',
        'Dic',
        'Dia',
        'Dih',
        'Dis'
    ],
    wide: [
        "Did\xf2mhnaich",
        'Diluain',
        "Dim\xe0irt",
        'Diciadain',
        'Diardaoin',
        'Dihaoine',
        'Disathairne'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'm',
        pm: 'f',
        midnight: 'm.o.',
        noon: 'm.l.',
        morning: 'madainn',
        afternoon: 'feasgar',
        evening: 'feasgar',
        night: 'oidhche'
    },
    abbreviated: {
        am: 'M.',
        pm: 'F.',
        midnight: 'meadhan oidhche',
        noon: "meadhan l\xe0",
        morning: 'madainn',
        afternoon: 'feasgar',
        evening: 'feasgar',
        night: 'oidhche'
    },
    wide: {
        am: 'm.',
        pm: 'f.',
        midnight: 'meadhan oidhche',
        noon: "meadhan l\xe0",
        morning: 'madainn',
        afternoon: 'feasgar',
        evening: 'feasgar',
        night: 'oidhche'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'm',
        pm: 'f',
        midnight: 'm.o.',
        noon: 'm.l.',
        morning: 'sa mhadainn',
        afternoon: 'feasgar',
        evening: 'feasgar',
        night: 'air an oidhche'
    },
    abbreviated: {
        am: 'M.',
        pm: 'F.',
        midnight: 'meadhan oidhche',
        noon: "meadhan l\xe0",
        morning: 'sa mhadainn',
        afternoon: 'feasgar',
        evening: 'feasgar',
        night: 'air an oidhche'
    },
    wide: {
        am: 'm.',
        pm: 'f.',
        midnight: 'meadhan oidhche',
        noon: "meadhan l\xe0",
        morning: 'sa mhadainn',
        afternoon: 'feasgar',
        evening: 'feasgar',
        night: 'air an oidhche'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'd';
        case 2:
            return number + 'na';
    }
    if (rem100 === 12) return number + 'na';
    return number + 'mh';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8prwj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(d|na|tr|mh)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(r|a)/i,
    abbreviated: /^(r\.?\s?c\.?|r\.?\s?a\.?\s?c\.?|a\.?\s?d\.?|a\.?\s?c\.?)/i,
    wide: /^(ro Chrìosta|ron aois choitchinn|anno domini|aois choitcheann)/i
};
var parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^c[1234]/i,
    wide: /^[1234](cd|na|tr|mh)? cairteal/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[fgmcòilsd]/i,
    abbreviated: /^(faoi|gear|màrt|gibl|cèit|ògmh|iuch|lùn|sult|dàmh|samh|dùbh)/i,
    wide: /^(am faoilleach|an gearran|am màrt|an giblean|an cèitean|an t-Ògmhios|an t-Iuchar|an lùnastal|an t-Sultain|an dàmhair|an t-Samhain|an dùbhlachd)/i
};
var parseMonthPatterns = {
    narrow: [
        /^f/i,
        /^g/i,
        /^m/i,
        /^g/i,
        /^c/i,
        /^ò/i,
        /^i/i,
        /^l/i,
        /^s/i,
        /^d/i,
        /^s/i,
        /^d/i
    ],
    any: [
        /^fa/i,
        /^ge/i,
        /^mà/i,
        /^gi/i,
        /^c/i,
        /^ò/i,
        /^i/i,
        /^l/i,
        /^su/i,
        /^d/i,
        /^sa/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[dlmcahs]/i,
    short: /^(dò|lu|mà|ci|ar|ha|sa)/i,
    abbreviated: /^(did|dil|dim|dic|dia|dih|dis)/i,
    wide: /^(didòmhnaich|diluain|dimàirt|diciadain|diardaoin|dihaoine|disathairne)/i
};
var parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^c/i,
        /^a/i,
        /^h/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^c/i,
        /^a/i,
        /^h/i,
        /^s/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(san|aig) (madainn|feasgar|feasgar|oidhche))/i,
    any: /^([ap]\.?\s?m\.?|meadhan oidhche|meadhan là|(san|aig) (madainn|feasgar|feasgar|oidhche))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^m/i,
        pm: /^f/i,
        midnight: /^meadhan oidhche/i,
        noon: /^meadhan là/i,
        morning: /sa mhadainn/i,
        afternoon: /feasgar/i,
        evening: /feasgar/i,
        night: /air an oidhche/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5Zaf9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Galician locale.
 * @language Galician
 * @iso-639-2 glg
 * @author Alberto Doval - Cocodin Technology[@cocodinTech]{@link https://github.com/cocodinTech}
 * @author Fidel Pita [@fidelpita]{@link https://github.com/fidelpita}
 */ var locale = {
    code: 'gl',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"i8MUr","./_lib/formatLong/index.js":"2o91r","./_lib/formatRelative/index.js":"1OXhg","./_lib/localize/index.js":"kzp8P","./_lib/match/index.js":"8iE5Z","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"i8MUr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'menos dun segundo',
        other: 'menos de {{count}} segundos'
    },
    xSeconds: {
        one: '1 segundo',
        other: '{{count}} segundos'
    },
    halfAMinute: 'medio minuto',
    lessThanXMinutes: {
        one: 'menos dun minuto',
        other: 'menos de {{count}} minutos'
    },
    xMinutes: {
        one: '1 minuto',
        other: '{{count}} minutos'
    },
    aboutXHours: {
        one: 'arredor dunha hora',
        other: 'arredor de {{count}} horas'
    },
    xHours: {
        one: '1 hora',
        other: '{{count}} horas'
    },
    xDays: {
        one: "1 d\xeda",
        other: "{{count}} d\xedas"
    },
    aboutXWeeks: {
        one: 'arredor dunha semana',
        other: 'arredor de {{count}} semanas'
    },
    xWeeks: {
        one: '1 semana',
        other: '{{count}} semanas'
    },
    aboutXMonths: {
        one: 'arredor de 1 mes',
        other: 'arredor de {{count}} meses'
    },
    xMonths: {
        one: '1 mes',
        other: '{{count}} meses'
    },
    aboutXYears: {
        one: 'arredor dun ano',
        other: 'arredor de {{count}} anos'
    },
    xYears: {
        one: '1 ano',
        other: '{{count}} anos'
    },
    overXYears: {
        one: "m\xe1is dun ano",
        other: "m\xe1is de {{count}} anos"
    },
    almostXYears: {
        one: 'case un ano',
        other: 'case {{count}} anos'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'en ' + result;
        else return 'hai ' + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2o91r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE, d 'de' MMMM y",
    long: "d 'de' MMMM y",
    medium: 'd MMM y',
    short: 'dd/MM/y'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} '\xe1s' {{time}}",
    long: "{{date}} '\xe1s' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1OXhg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'o' eeee 'pasado \xe1' LT",
    yesterday: "'onte \xe1' p",
    today: "'hoxe \xe1' p",
    tomorrow: "'ma\xf1\xe1 \xe1' p",
    nextWeek: "eeee '\xe1' p",
    other: 'P'
};
var formatRelativeLocalePlural = {
    lastWeek: "'o' eeee 'pasado \xe1s' p",
    yesterday: "'onte \xe1s' p",
    today: "'hoxe \xe1s' p",
    tomorrow: "'ma\xf1\xe1 \xe1s' p",
    nextWeek: "eeee '\xe1s' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, date, _baseDate, _options) {
    if (date.getUTCHours() !== 1) return formatRelativeLocalePlural[token];
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"kzp8P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'AC',
        'DC'
    ],
    abbreviated: [
        'AC',
        'DC'
    ],
    wide: [
        'antes de cristo',
        'despois de cristo'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
var monthValues = {
    narrow: [
        'e',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'xan',
        'feb',
        'mar',
        'abr',
        'mai',
        'xun',
        'xul',
        'ago',
        'set',
        'out',
        'nov',
        'dec'
    ],
    wide: [
        'xaneiro',
        'febreiro',
        'marzo',
        'abril',
        'maio',
        "xu\xf1o",
        'xullo',
        'agosto',
        'setembro',
        'outubro',
        'novembro',
        'decembro'
    ]
};
var dayValues = {
    narrow: [
        'd',
        'l',
        'm',
        'm',
        'j',
        'v',
        's'
    ],
    short: [
        'do',
        'lu',
        'ma',
        'me',
        'xo',
        've',
        'sa'
    ],
    abbreviated: [
        'dom',
        'lun',
        'mar',
        'mer',
        'xov',
        'ven',
        'sab'
    ],
    wide: [
        'domingo',
        'luns',
        'martes',
        "m\xe9rcores",
        'xoves',
        'venres',
        "s\xe1bado"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: 'md',
        morning: "ma\xf1\xe1",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noite'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'medianoite',
        noon: "mediod\xeda",
        morning: "ma\xf1\xe1",
        afternoon: 'tarde',
        evening: "tardi\xf1a",
        night: 'noite'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'medianoite',
        noon: "mediod\xeda",
        morning: "ma\xf1\xe1",
        afternoon: 'tarde',
        evening: "tardi\xf1a",
        night: 'noite'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: 'md',
        morning: "da ma\xf1\xe1",
        afternoon: 'da tarde',
        evening: "da tardi\xf1a",
        night: 'da noite'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'medianoite',
        noon: "mediod\xeda",
        morning: "da ma\xf1\xe1",
        afternoon: 'da tarde',
        evening: "da tardi\xf1a",
        night: 'da noite'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'medianoite',
        noon: "mediod\xeda",
        morning: "da ma\xf1\xe1",
        afternoon: 'da tarde',
        evening: "da tardi\xf1a",
        night: 'da noite'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "\xba";
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8iE5Z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(º)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
    wide: /^(antes de cristo|antes da era com[uú]n|despois de cristo|era com[uú]n)/i
};
var parseEraPatterns = {
    any: [
        /^ac/i,
        /^dc/i
    ],
    wide: [
        /^(antes de cristo|antes da era com[uú]n)/i,
        /^(despois de cristo|era com[uú]n)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º)? trimestre/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[xfmasond]/i,
    abbreviated: /^(xan|feb|mar|abr|mai|xun|xul|ago|set|out|nov|dec)/i,
    wide: /^(xaneiro|febreiro|marzo|abril|maio|xuño|xullo|agosto|setembro|outubro|novembro|decembro)/i
};
var parseMonthPatterns = {
    narrow: [
        /^x/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^x/i,
        /^x/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^xan/i,
        /^feb/i,
        /^mar/i,
        /^abr/i,
        /^mai/i,
        /^xun/i,
        /^xul/i,
        /^ago/i,
        /^set/i,
        /^out/i,
        /^nov/i,
        /^dec/i
    ]
};
var matchDayPatterns = {
    narrow: /^[dlmxvs]/i,
    short: /^(do|lu|ma|me|xo|ve|sa)/i,
    abbreviated: /^(dom|lun|mar|mer|xov|ven|sab)/i,
    wide: /^(domingo|luns|martes|m[eé]rcores|xoves|venres|s[áa]bado)/i
};
var parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^x/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^do/i,
        /^lu/i,
        /^ma/i,
        /^me/i,
        /^xo/i,
        /^ve/i,
        /^sa/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|md|(da|[aá]s) (mañ[aá]|tarde|noite))/i,
    any: /^([ap]\.?\s?m\.?|medianoite|mediod[ií]a|(da|[aá]s) (mañ[aá]|tarde|noite))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mn/i,
        noon: /^md/i,
        morning: /mañ[aá]/i,
        afternoon: /tarde/i,
        evening: /tardiña/i,
        night: /noite/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2VQWP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Gujarati locale (India).
 * @language Gujarati
 * @iso-639-2 guj
 * @author Manaday Mavani [@ManadayM]{@link https://github.com/manadaym}
 */ var locale = {
    code: 'gu',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"d5V8b","./_lib/formatLong/index.js":"5GQMY","./_lib/formatRelative/index.js":"ja2tj","./_lib/localize/index.js":"b9KR1","./_lib/match/index.js":"6f9x5","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"d5V8b":[function(require,module,exports,__globalThis) {
// Source: https://www.unicode.org/cldr/charts/32/summary/gu.html
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0AB9\u0AAE\u0AA3\u0ABE\u0A82",
        // CLDR #1461
        other: "\u200B\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0AB8\u0AC7\u0A95\u0A82\u0AA1"
    },
    xSeconds: {
        one: "1 \u0AB8\u0AC7\u0A95\u0A82\u0AA1",
        other: "{{count}} \u0AB8\u0AC7\u0A95\u0A82\u0AA1"
    },
    halfAMinute: "\u0A85\u0AA1\u0AA7\u0AC0 \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F",
    lessThanXMinutes: {
        one: "\u0A86 \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F",
        // CLDR #1448
        other: "\u200B\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F"
    },
    xMinutes: {
        one: "1 \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F",
        other: "{{count}} \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F"
    },
    aboutXHours: {
        one: "\u200B\u0A86\u0AB6\u0AB0\u0AC7 1 \u0A95\u0AB2\u0ABE\u0A95",
        other: "\u200B\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0A95\u0AB2\u0ABE\u0A95"
    },
    xHours: {
        one: "1 \u0A95\u0AB2\u0ABE\u0A95",
        other: "{{count}} \u0A95\u0AB2\u0ABE\u0A95"
    },
    xDays: {
        one: "1 \u0AA6\u0ABF\u0AB5\u0AB8",
        other: "{{count}} \u0AA6\u0ABF\u0AB5\u0AB8"
    },
    aboutXWeeks: {
        one: "\u0A86\u0AB6\u0AB0\u0AC7 1 \u0A85\u0AA0\u0AB5\u0ABE\u0AA1\u0ABF\u0AAF\u0AC1\u0A82",
        other: "\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0A85\u0AA0\u0AB5\u0ABE\u0AA1\u0ABF\u0AAF\u0ABE"
    },
    xWeeks: {
        one: "1 \u0A85\u0AA0\u0AB5\u0ABE\u0AA1\u0ABF\u0AAF\u0AC1\u0A82",
        other: "{{count}} \u0A85\u0AA0\u0AB5\u0ABE\u0AA1\u0ABF\u0AAF\u0ABE"
    },
    aboutXMonths: {
        one: "\u0A86\u0AB6\u0AB0\u0AC7 1 \u0AAE\u0AB9\u0ABF\u0AA8\u0ACB",
        other: "\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0AAE\u0AB9\u0ABF\u0AA8\u0ABE"
    },
    xMonths: {
        one: "1 \u0AAE\u0AB9\u0ABF\u0AA8\u0ACB",
        other: "{{count}} \u0AAE\u0AB9\u0ABF\u0AA8\u0ABE"
    },
    aboutXYears: {
        one: "\u0A86\u0AB6\u0AB0\u0AC7 1 \u0AB5\u0AB0\u0ACD\u0AB7",
        other: "\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0AB5\u0AB0\u0ACD\u0AB7"
    },
    xYears: {
        one: "1 \u0AB5\u0AB0\u0ACD\u0AB7",
        other: "{{count}} \u0AB5\u0AB0\u0ACD\u0AB7"
    },
    overXYears: {
        one: "1 \u0AB5\u0AB0\u0ACD\u0AB7\u0AA5\u0AC0 \u0AB5\u0AA7\u0AC1",
        other: "{{count}} \u0AB5\u0AB0\u0ACD\u0AB7\u0AA5\u0AC0 \u0AB5\u0AA7\u0AC1"
    },
    almostXYears: {
        one: "\u0AB2\u0A97\u0AAD\u0A97 1 \u0AB5\u0AB0\u0ACD\u0AB7",
        other: "\u0AB2\u0A97\u0AAD\u0A97 {{count}} \u0AB5\u0AB0\u0ACD\u0AB7"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u0AAE\u0ABE\u0A82";
        else return result + " \u0AAA\u0AB9\u0AC7\u0AB2\u0ABE\u0A82";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5GQMY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js"); //Source: https://www.unicode.org/cldr/charts/32/summary/gu.html
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, d MMMM, y',
    // CLDR #1825
    long: 'd MMMM, y',
    // CLDR #1826
    medium: 'd MMM, y',
    // CLDR #1827
    short: 'd/M/yy' // CLDR #1828
};
var timeFormats = {
    full: 'hh:mm:ss a zzzz',
    // CLDR #1829
    long: 'hh:mm:ss a z',
    // CLDR #1830
    medium: 'hh:mm:ss a',
    // CLDR #1831
    short: 'hh:mm a' // CLDR #1832
};
var dateTimeFormats = {
    full: '{{date}} {{time}}',
    // CLDR #1833
    long: '{{date}} {{time}}',
    // CLDR #1834
    medium: '{{date}} {{time}}',
    // CLDR #1835
    short: '{{date}} {{time}}' // CLDR #1836
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"ja2tj":[function(require,module,exports,__globalThis) {
// Source: https://www.unicode.org/cldr/charts/32/summary/gu.html
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'\u0AAA\u0ABE\u0A9B\u0AB2\u0ABE' eeee p",
    // CLDR #1384
    yesterday: "'\u0A97\u0A88\u0A95\u0ABE\u0AB2\u0AC7' p",
    // CLDR #1409
    today: "'\u0A86\u0A9C\u0AC7' p",
    // CLDR #1410
    tomorrow: "'\u0A86\u0AB5\u0AA4\u0AC0\u0A95\u0ABE\u0AB2\u0AC7' p",
    // CLDR #1411
    nextWeek: 'eeee p',
    // CLDR #1386
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"b9KR1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js"); // https://www.unicode.org/cldr/charts/32/summary/gu.html
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
// #1621 - #1630
var eraValues = {
    narrow: [
        "\u0A88\u0AB8\u0AAA\u0AC2",
        "\u0A88\u0AB8"
    ],
    abbreviated: [
        "\u0A88.\u0AB8.\u0AAA\u0AC2\u0AB0\u0ACD\u0AB5\u0AC7",
        "\u0A88.\u0AB8."
    ],
    wide: [
        "\u0A88\u0AB8\u0AB5\u0AC0\u0AB8\u0AA8 \u0AAA\u0AC2\u0AB0\u0ACD\u0AB5\u0AC7",
        "\u0A88\u0AB8\u0AB5\u0AC0\u0AB8\u0AA8"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/gu.html
// #1631 - #1654
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "1\u0AB2\u0ACB \u0AA4\u0ACD\u0AB0\u0ABF\u0AAE\u0ABE\u0AB8",
        "2\u0A9C\u0ACB \u0AA4\u0ACD\u0AB0\u0ABF\u0AAE\u0ABE\u0AB8",
        "3\u0A9C\u0ACB \u0AA4\u0ACD\u0AB0\u0ABF\u0AAE\u0ABE\u0AB8",
        "4\u0AA5\u0ACB \u0AA4\u0ACD\u0AB0\u0ABF\u0AAE\u0ABE\u0AB8"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
// https://www.unicode.org/cldr/charts/32/summary/gu.html
// #1655 - #1726
var monthValues = {
    narrow: [
        "\u0A9C\u0ABE",
        "\u0AAB\u0AC7",
        "\u0AAE\u0ABE",
        "\u0A8F",
        "\u0AAE\u0AC7",
        "\u0A9C\u0AC2",
        "\u0A9C\u0AC1",
        "\u0A93",
        "\u0AB8",
        "\u0A93",
        "\u0AA8",
        "\u0AA1\u0ABF"
    ],
    abbreviated: [
        "\u0A9C\u0ABE\u0AA8\u0ACD\u0AAF\u0AC1",
        "\u0AAB\u0AC7\u0AAC\u0ACD\u0AB0\u0AC1",
        "\u0AAE\u0ABE\u0AB0\u0ACD\u0A9A",
        "\u0A8F\u0AAA\u0ACD\u0AB0\u0ABF\u0AB2",
        "\u0AAE\u0AC7",
        "\u0A9C\u0AC2\u0AA8",
        "\u0A9C\u0AC1\u0AB2\u0ABE\u0A88",
        "\u0A91\u0A97\u0AB8\u0ACD\u0A9F",
        "\u0AB8\u0AAA\u0ACD\u0A9F\u0AC7",
        "\u0A93\u0A95\u0ACD\u0A9F\u0ACB",
        "\u0AA8\u0AB5\u0AC7",
        "\u0AA1\u0ABF\u0AB8\u0AC7"
    ],
    wide: [
        "\u0A9C\u0ABE\u0AA8\u0ACD\u0AAF\u0AC1\u0A86\u0AB0\u0AC0",
        "\u0AAB\u0AC7\u0AAC\u0ACD\u0AB0\u0AC1\u0A86\u0AB0\u0AC0",
        "\u0AAE\u0ABE\u0AB0\u0ACD\u0A9A",
        "\u0A8F\u0AAA\u0ACD\u0AB0\u0ABF\u0AB2",
        "\u0AAE\u0AC7",
        "\u0A9C\u0AC2\u0AA8",
        "\u0A9C\u0AC1\u0AB2\u0ABE\u0A87",
        "\u0A93\u0A97\u0AB8\u0ACD\u0A9F",
        "\u0AB8\u0AAA\u0ACD\u0A9F\u0AC7\u0AAE\u0ACD\u0AAC\u0AB0",
        "\u0A93\u0A95\u0ACD\u0A9F\u0ACB\u0AAC\u0AB0",
        "\u0AA8\u0AB5\u0AC7\u0AAE\u0ACD\u0AAC\u0AB0",
        "\u0AA1\u0ABF\u0AB8\u0AC7\u0AAE\u0ACD\u0AAC\u0AB0"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/gu.html
// #1727 - #1768
var dayValues = {
    narrow: [
        "\u0AB0",
        "\u0AB8\u0ACB",
        "\u0AAE\u0A82",
        "\u0AAC\u0AC1",
        "\u0A97\u0AC1",
        "\u0AB6\u0AC1",
        "\u0AB6"
    ],
    short: [
        "\u0AB0",
        "\u0AB8\u0ACB",
        "\u0AAE\u0A82",
        "\u0AAC\u0AC1",
        "\u0A97\u0AC1",
        "\u0AB6\u0AC1",
        "\u0AB6"
    ],
    abbreviated: [
        "\u0AB0\u0AB5\u0ABF",
        "\u0AB8\u0ACB\u0AAE",
        "\u0AAE\u0A82\u0A97\u0AB3",
        "\u0AAC\u0AC1\u0AA7",
        "\u0A97\u0AC1\u0AB0\u0AC1",
        "\u0AB6\u0AC1\u0A95\u0ACD\u0AB0",
        "\u0AB6\u0AA8\u0ABF"
    ],
    wide: [
        "\u0AB0\u0AB5\u0ABF\u0AB5\u0ABE\u0AB0" /* Sunday */ ,
        "\u0AB8\u0ACB\u0AAE\u0AB5\u0ABE\u0AB0" /* Monday */ ,
        "\u0AAE\u0A82\u0A97\u0AB3\u0AB5\u0ABE\u0AB0" /* Tuesday */ ,
        "\u0AAC\u0AC1\u0AA7\u0AB5\u0ABE\u0AB0" /* Wednesday */ ,
        "\u0A97\u0AC1\u0AB0\u0AC1\u0AB5\u0ABE\u0AB0" /* Thursday */ ,
        "\u0AB6\u0AC1\u0A95\u0ACD\u0AB0\u0AB5\u0ABE\u0AB0" /* Friday */ ,
        "\u0AB6\u0AA8\u0ABF\u0AB5\u0ABE\u0AB0" /* Saturday */ 
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/gu.html
// #1783 - #1824
var dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u0AAE.\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC.",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u200B\u0AAE\u0AA7\u0ACD\u0AAF\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u200B\u0AAE\u0AA7\u0ACD\u0AAF\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u0AAE.\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u0AAE\u0AA7\u0ACD\u0AAF\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u200B\u0AAE\u0AA7\u0ACD\u0AAF\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6f9x5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(લ|જ|થ|ઠ્ઠ|મ)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(ઈસપૂ|ઈસ)/i,
    abbreviated: /^(ઈ\.સ\.પૂર્વે|ઈ\.સ\.)/i,
    wide: /^(ઈસવીસન\sપૂર્વે|ઈસવીસન)/i
};
var parseEraPatterns = {
    any: [
        /^ઈસપૂ/i,
        /^ઈસ/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](લો|જો|થો)? ત્રિમાસ/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    // eslint-disable-next-line no-misleading-character-class
    narrow: /^[જાફેમાએમેજૂજુઓસઓનડિ]/i,
    abbreviated: /^(જાન્યુ|ફેબ્રુ|માર્ચ|એપ્રિલ|મે|જૂન|જુલાઈ|ઑગસ્ટ|સપ્ટે|ઓક્ટો|નવે|ડિસે)/i,
    wide: /^(જાન્યુઆરી|ફેબ્રુઆરી|માર્ચ|એપ્રિલ|મે|જૂન|જુલાઇ|ઓગસ્ટ|સપ્ટેમ્બર|ઓક્ટોબર|નવેમ્બર|ડિસેમ્બર)/i
};
var parseMonthPatterns = {
    narrow: [
        /^જા/i,
        /^ફે/i,
        /^મા/i,
        /^એ/i,
        /^મે/i,
        /^જૂ/i,
        /^જુ/i,
        /^ઑગ/i,
        /^સ/i,
        /^ઓક્ટો/i,
        /^ન/i,
        /^ડિ/i
    ],
    any: [
        /^જા/i,
        /^ફે/i,
        /^મા/i,
        /^એ/i,
        /^મે/i,
        /^જૂ/i,
        /^જુ/i,
        /^ઑગ/i,
        /^સ/i,
        /^ઓક્ટો/i,
        /^ન/i,
        /^ડિ/i
    ]
};
var matchDayPatterns = {
    narrow: /^(ર|સો|મં|બુ|ગુ|શુ|શ)/i,
    short: /^(ર|સો|મં|બુ|ગુ|શુ|શ)/i,
    abbreviated: /^(રવિ|સોમ|મંગળ|બુધ|ગુરુ|શુક્ર|શનિ)/i,
    wide: /^(રવિવાર|સોમવાર|મંગળવાર|બુધવાર|ગુરુવાર|શુક્રવાર|શનિવાર)/i
};
var parseDayPatterns = {
    narrow: [
        /^ર/i,
        /^સો/i,
        /^મં/i,
        /^બુ/i,
        /^ગુ/i,
        /^શુ/i,
        /^શ/i
    ],
    any: [
        /^ર/i,
        /^સો/i,
        /^મં/i,
        /^બુ/i,
        /^ગુ/i,
        /^શુ/i,
        /^શ/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|મ\.?|સ|બ|સાં|રા)/i,
    any: /^(a|p|મ\.?|સ|બ|સાં|રા)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^મ\.?/i,
        noon: /^બ/i,
        morning: /સ/i,
        afternoon: /બ/i,
        evening: /સાં/i,
        night: /રા/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"eAQHN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Hebrew locale.
 * @language Hebrew
 * @iso-639-2 heb
 * @author Nir Lahad [@nirlah]{@link https://github.com/nirlah}
 */ var locale = {
    code: 'he',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"6DFby","./_lib/formatLong/index.js":"8dA3b","./_lib/formatRelative/index.js":"1C6Xp","./_lib/localize/index.js":"8ieqn","./_lib/match/index.js":"53jlc","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6DFby":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05E9\u05E0\u05D9\u05D9\u05D4",
        two: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05E9\u05EA\u05D9 \u05E9\u05E0\u05D9\u05D5\u05EA",
        other: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05BE{{count}} \u05E9\u05E0\u05D9\u05D5\u05EA"
    },
    xSeconds: {
        one: "\u05E9\u05E0\u05D9\u05D9\u05D4",
        two: "\u05E9\u05EA\u05D9 \u05E9\u05E0\u05D9\u05D5\u05EA",
        other: "{{count}} \u05E9\u05E0\u05D9\u05D5\u05EA"
    },
    halfAMinute: "\u05D7\u05E6\u05D9 \u05D3\u05E7\u05D4",
    lessThanXMinutes: {
        one: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05D3\u05E7\u05D4",
        two: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05E9\u05EA\u05D9 \u05D3\u05E7\u05D5\u05EA",
        other: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05BE{{count}} \u05D3\u05E7\u05D5\u05EA"
    },
    xMinutes: {
        one: "\u05D3\u05E7\u05D4",
        two: "\u05E9\u05EA\u05D9 \u05D3\u05E7\u05D5\u05EA",
        other: "{{count}} \u05D3\u05E7\u05D5\u05EA"
    },
    aboutXHours: {
        one: "\u05DB\u05E9\u05E2\u05D4",
        two: "\u05DB\u05E9\u05E2\u05EA\u05D9\u05D9\u05DD",
        other: "\u05DB\u05BE{{count}} \u05E9\u05E2\u05D5\u05EA"
    },
    xHours: {
        one: "\u05E9\u05E2\u05D4",
        two: "\u05E9\u05E2\u05EA\u05D9\u05D9\u05DD",
        other: "{{count}} \u05E9\u05E2\u05D5\u05EA"
    },
    xDays: {
        one: "\u05D9\u05D5\u05DD",
        two: "\u05D9\u05D5\u05DE\u05D9\u05D9\u05DD",
        other: "{{count}} \u05D9\u05DE\u05D9\u05DD"
    },
    aboutXWeeks: {
        one: "\u05DB\u05E9\u05D1\u05D5\u05E2",
        two: "\u05DB\u05E9\u05D1\u05D5\u05E2\u05D9\u05D9\u05DD",
        other: "\u05DB\u05BE{{count}} \u05E9\u05D1\u05D5\u05E2\u05D5\u05EA"
    },
    xWeeks: {
        one: "\u05E9\u05D1\u05D5\u05E2",
        two: "\u05E9\u05D1\u05D5\u05E2\u05D9\u05D9\u05DD",
        other: "{{count}} \u05E9\u05D1\u05D5\u05E2\u05D5\u05EA"
    },
    aboutXMonths: {
        one: "\u05DB\u05D7\u05D5\u05D3\u05E9",
        two: "\u05DB\u05D7\u05D5\u05D3\u05E9\u05D9\u05D9\u05DD",
        other: "\u05DB\u05BE{{count}} \u05D7\u05D5\u05D3\u05E9\u05D9\u05DD"
    },
    xMonths: {
        one: "\u05D7\u05D5\u05D3\u05E9",
        two: "\u05D7\u05D5\u05D3\u05E9\u05D9\u05D9\u05DD",
        other: "{{count}} \u05D7\u05D5\u05D3\u05E9\u05D9\u05DD"
    },
    aboutXYears: {
        one: "\u05DB\u05E9\u05E0\u05D4",
        two: "\u05DB\u05E9\u05E0\u05EA\u05D9\u05D9\u05DD",
        other: "\u05DB\u05BE{{count}} \u05E9\u05E0\u05D9\u05DD"
    },
    xYears: {
        one: "\u05E9\u05E0\u05D4",
        two: "\u05E9\u05E0\u05EA\u05D9\u05D9\u05DD",
        other: "{{count}} \u05E9\u05E0\u05D9\u05DD"
    },
    overXYears: {
        one: "\u05D9\u05D5\u05EA\u05E8 \u05DE\u05E9\u05E0\u05D4",
        two: "\u05D9\u05D5\u05EA\u05E8 \u05DE\u05E9\u05E0\u05EA\u05D9\u05D9\u05DD",
        other: "\u05D9\u05D5\u05EA\u05E8 \u05DE\u05BE{{count}} \u05E9\u05E0\u05D9\u05DD"
    },
    almostXYears: {
        one: "\u05DB\u05DE\u05E2\u05D8 \u05E9\u05E0\u05D4",
        two: "\u05DB\u05DE\u05E2\u05D8 \u05E9\u05E0\u05EA\u05D9\u05D9\u05DD",
        other: "\u05DB\u05DE\u05E2\u05D8 {{count}} \u05E9\u05E0\u05D9\u05DD"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    // Return word instead of `in one day` or `one day ago`
    if (token === 'xDays' && options !== null && options !== void 0 && options.addSuffix && count <= 2) {
        if (options.comparison && options.comparison > 0) return count === 1 ? "\u05DE\u05D7\u05E8" : "\u05DE\u05D7\u05E8\u05EA\u05D9\u05D9\u05DD";
        return count === 1 ? "\u05D0\u05EA\u05DE\u05D5\u05DC" : "\u05E9\u05DC\u05E9\u05D5\u05DD";
    }
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2) result = tokenValue.two;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u05D1\u05E2\u05D5\u05D3 " + result;
        else return "\u05DC\u05E4\u05E0\u05D9 " + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8dA3b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE, d \u05D1MMMM y",
    long: "d \u05D1MMMM y",
    medium: "d \u05D1MMM y",
    short: 'd.M.y'
};
var timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var dateTimeFormats = {
    full: "{{date}} '\u05D1\u05E9\u05E2\u05D4' {{time}}",
    long: "{{date}} '\u05D1\u05E9\u05E2\u05D4' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1C6Xp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "eeee '\u05E9\u05E2\u05D1\u05E8 \u05D1\u05E9\u05E2\u05D4' p",
    yesterday: "'\u05D0\u05EA\u05DE\u05D5\u05DC \u05D1\u05E9\u05E2\u05D4' p",
    today: "'\u05D4\u05D9\u05D5\u05DD \u05D1\u05E9\u05E2\u05D4' p",
    tomorrow: "'\u05DE\u05D7\u05E8 \u05D1\u05E9\u05E2\u05D4' p",
    nextWeek: "eeee '\u05D1\u05E9\u05E2\u05D4' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8ieqn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E1",
        "\u05DC\u05E1\u05E4\u05D9\u05E8\u05D4"
    ],
    abbreviated: [
        "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E1",
        "\u05DC\u05E1\u05E4\u05D9\u05E8\u05D4"
    ],
    wide: [
        "\u05DC\u05E4\u05E0\u05D9 \u05D4\u05E1\u05E4\u05D9\u05E8\u05D4",
        "\u05DC\u05E1\u05E4\u05D9\u05E8\u05D4"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "\u05E8\u05D1\u05E2\u05D5\u05DF 1",
        "\u05E8\u05D1\u05E2\u05D5\u05DF 2",
        "\u05E8\u05D1\u05E2\u05D5\u05DF 3",
        "\u05E8\u05D1\u05E2\u05D5\u05DF 4"
    ]
};
var monthValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10',
        '11',
        '12'
    ],
    abbreviated: [
        "\u05D9\u05E0\u05D5\u05F3",
        "\u05E4\u05D1\u05E8\u05F3",
        "\u05DE\u05E8\u05E5",
        "\u05D0\u05E4\u05E8\u05F3",
        "\u05DE\u05D0\u05D9",
        "\u05D9\u05D5\u05E0\u05D9",
        "\u05D9\u05D5\u05DC\u05D9",
        "\u05D0\u05D5\u05D2\u05F3",
        "\u05E1\u05E4\u05D8\u05F3",
        "\u05D0\u05D5\u05E7\u05F3",
        "\u05E0\u05D5\u05D1\u05F3",
        "\u05D3\u05E6\u05DE\u05F3"
    ],
    wide: [
        "\u05D9\u05E0\u05D5\u05D0\u05E8",
        "\u05E4\u05D1\u05E8\u05D5\u05D0\u05E8",
        "\u05DE\u05E8\u05E5",
        "\u05D0\u05E4\u05E8\u05D9\u05DC",
        "\u05DE\u05D0\u05D9",
        "\u05D9\u05D5\u05E0\u05D9",
        "\u05D9\u05D5\u05DC\u05D9",
        "\u05D0\u05D5\u05D2\u05D5\u05E1\u05D8",
        "\u05E1\u05E4\u05D8\u05DE\u05D1\u05E8",
        "\u05D0\u05D5\u05E7\u05D8\u05D5\u05D1\u05E8",
        "\u05E0\u05D5\u05D1\u05DE\u05D1\u05E8",
        "\u05D3\u05E6\u05DE\u05D1\u05E8"
    ]
};
var dayValues = {
    narrow: [
        "\u05D0\u05F3",
        "\u05D1\u05F3",
        "\u05D2\u05F3",
        "\u05D3\u05F3",
        "\u05D4\u05F3",
        "\u05D5\u05F3",
        "\u05E9\u05F3"
    ],
    short: [
        "\u05D0\u05F3",
        "\u05D1\u05F3",
        "\u05D2\u05F3",
        "\u05D3\u05F3",
        "\u05D4\u05F3",
        "\u05D5\u05F3",
        "\u05E9\u05F3"
    ],
    abbreviated: [
        "\u05D9\u05D5\u05DD \u05D0\u05F3",
        "\u05D9\u05D5\u05DD \u05D1\u05F3",
        "\u05D9\u05D5\u05DD \u05D2\u05F3",
        "\u05D9\u05D5\u05DD \u05D3\u05F3",
        "\u05D9\u05D5\u05DD \u05D4\u05F3",
        "\u05D9\u05D5\u05DD \u05D5\u05F3",
        "\u05E9\u05D1\u05EA"
    ],
    wide: [
        "\u05D9\u05D5\u05DD \u05E8\u05D0\u05E9\u05D5\u05DF",
        "\u05D9\u05D5\u05DD \u05E9\u05E0\u05D9",
        "\u05D9\u05D5\u05DD \u05E9\u05DC\u05D9\u05E9\u05D9",
        "\u05D9\u05D5\u05DD \u05E8\u05D1\u05D9\u05E2\u05D9",
        "\u05D9\u05D5\u05DD \u05D7\u05DE\u05D9\u05E9\u05D9",
        "\u05D9\u05D5\u05DD \u05E9\u05D9\u05E9\u05D9",
        "\u05D9\u05D5\u05DD \u05E9\u05D1\u05EA"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05E2\u05E8\u05D1",
        night: "\u05DC\u05D9\u05DC\u05D4"
    },
    abbreviated: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05E2\u05E8\u05D1",
        night: "\u05DC\u05D9\u05DC\u05D4"
    },
    wide: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05E2\u05E8\u05D1",
        night: "\u05DC\u05D9\u05DC\u05D4"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D1\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05D1\u05E2\u05E8\u05D1",
        night: "\u05D1\u05DC\u05D9\u05DC\u05D4"
    },
    abbreviated: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05D1\u05E2\u05E8\u05D1",
        night: "\u05D1\u05DC\u05D9\u05DC\u05D4"
    },
    wide: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05D1\u05E2\u05E8\u05D1",
        night: "\u05D1\u05DC\u05D9\u05DC\u05D4"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    // We only show words till 10
    if (number <= 0 || number > 10) return String(number);
    var unit = String(options === null || options === void 0 ? void 0 : options.unit);
    var isFemale = [
        'year',
        'hour',
        'minute',
        'second'
    ].indexOf(unit) >= 0;
    var male = [
        "\u05E8\u05D0\u05E9\u05D5\u05DF",
        "\u05E9\u05E0\u05D9",
        "\u05E9\u05DC\u05D9\u05E9\u05D9",
        "\u05E8\u05D1\u05D9\u05E2\u05D9",
        "\u05D7\u05DE\u05D9\u05E9\u05D9",
        "\u05E9\u05D9\u05E9\u05D9",
        "\u05E9\u05D1\u05D9\u05E2\u05D9",
        "\u05E9\u05DE\u05D9\u05E0\u05D9",
        "\u05EA\u05E9\u05D9\u05E2\u05D9",
        "\u05E2\u05E9\u05D9\u05E8\u05D9"
    ];
    var female = [
        "\u05E8\u05D0\u05E9\u05D5\u05E0\u05D4",
        "\u05E9\u05E0\u05D9\u05D9\u05D4",
        "\u05E9\u05DC\u05D9\u05E9\u05D9\u05EA",
        "\u05E8\u05D1\u05D9\u05E2\u05D9\u05EA",
        "\u05D7\u05DE\u05D9\u05E9\u05D9\u05EA",
        "\u05E9\u05D9\u05E9\u05D9\u05EA",
        "\u05E9\u05D1\u05D9\u05E2\u05D9\u05EA",
        "\u05E9\u05DE\u05D9\u05E0\u05D9\u05EA",
        "\u05EA\u05E9\u05D9\u05E2\u05D9\u05EA",
        "\u05E2\u05E9\u05D9\u05E8\u05D9\u05EA"
    ];
    var index = number - 1;
    return isFemale ? female[index] : male[index];
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"53jlc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+|(ראשון|שני|שלישי|רביעי|חמישי|שישי|שביעי|שמיני|תשיעי|עשירי|ראשונה|שנייה|שלישית|רביעית|חמישית|שישית|שביעית|שמינית|תשיעית|עשירית))/i;
var parseOrdinalNumberPattern = /^(\d+|רא|שנ|של|רב|ח|שי|שב|שמ|ת|ע)/i;
var matchEraPatterns = {
    narrow: /^ל(ספירה|פנה״ס)/i,
    abbreviated: /^ל(ספירה|פנה״ס)/i,
    wide: /^ל(פני ה)?ספירה/i
};
var parseEraPatterns = {
    any: [
        /^לפ/i,
        /^לס/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^רבעון [1234]/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^\d+/i,
    abbreviated: /^(ינו|פבר|מרץ|אפר|מאי|יוני|יולי|אוג|ספט|אוק|נוב|דצמ)׳?/i,
    wide: /^(ינואר|פברואר|מרץ|אפריל|מאי|יוני|יולי|אוגוסט|ספטמבר|אוקטובר|נובמבר|דצמבר)/i
};
var parseMonthPatterns = {
    narrow: [
        /^1$/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^7/i,
        /^8/i,
        /^9/i,
        /^10/i,
        /^11/i,
        /^12/i
    ],
    any: [
        /^ינ/i,
        /^פ/i,
        /^מר/i,
        /^אפ/i,
        /^מא/i,
        /^יונ/i,
        /^יול/i,
        /^אוג/i,
        /^ס/i,
        /^אוק/i,
        /^נ/i,
        /^ד/i
    ]
};
var matchDayPatterns = {
    narrow: /^[אבגדהוש]׳/i,
    short: /^[אבגדהוש]׳/i,
    abbreviated: /^(שבת|יום (א|ב|ג|ד|ה|ו)׳)/i,
    wide: /^יום (ראשון|שני|שלישי|רביעי|חמישי|שישי|שבת)/i
};
var parseDayPatterns = {
    abbreviated: [
        /א׳$/i,
        /ב׳$/i,
        /ג׳$/i,
        /ד׳$/i,
        /ה׳$/i,
        /ו׳$/i,
        /^ש/i
    ],
    wide: [
        /ן$/i,
        /ני$/i,
        /לישי$/i,
        /עי$/i,
        /מישי$/i,
        /שישי$/i,
        /ת$/i
    ],
    any: [
        /^א/i,
        /^ב/i,
        /^ג/i,
        /^ד/i,
        /^ה/i,
        /^ו/i,
        /^ש/i
    ]
};
var matchDayPeriodPatterns = {
    any: /^(אחר ה|ב)?(חצות|צהריים|בוקר|ערב|לילה|אחה״צ|לפנה״צ)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^לפ/i,
        pm: /^אחה/i,
        midnight: /^ח/i,
        noon: /^צ/i,
        morning: /בוקר/i,
        afternoon: /בצ|אחר/i,
        evening: /ערב/i,
        night: /לילה/i
    }
};
var ordinalName = [
    "\u05E8\u05D0",
    "\u05E9\u05E0",
    "\u05E9\u05DC",
    "\u05E8\u05D1",
    "\u05D7",
    "\u05E9\u05D9",
    "\u05E9\u05D1",
    "\u05E9\u05DE",
    "\u05EA",
    "\u05E2"
];
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            var number = parseInt(value, 10);
            return isNaN(number) ? ordinalName.indexOf(value) + 1 : number;
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"chTCt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Hindi locale (India).
 * @language Hindi
 * @iso-639-2 hin
 * @author Mukesh Mandiwal [@mukeshmandiwal]{@link https://github.com/mukeshmandiwal}
 */ var locale = {
    code: 'hi',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 0 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"dCv1b","./_lib/formatLong/index.js":"arb8U","./_lib/formatRelative/index.js":"1gViw","./_lib/localize/index.js":"alsjF","./_lib/match/index.js":"euJO7","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"dCv1b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../localize/index.js"); // Source: https://www.unicode.org/cldr/charts/32/summary/hi.html
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0967 \u0938\u0947\u0915\u0902\u0921 \u0938\u0947 \u0915\u092E",
        // CLDR #1310
        other: "{{count}} \u0938\u0947\u0915\u0902\u0921 \u0938\u0947 \u0915\u092E"
    },
    xSeconds: {
        one: "\u0967 \u0938\u0947\u0915\u0902\u0921",
        other: "{{count}} \u0938\u0947\u0915\u0902\u0921"
    },
    halfAMinute: "\u0906\u0927\u093E \u092E\u093F\u0928\u091F",
    lessThanXMinutes: {
        one: "\u0967 \u092E\u093F\u0928\u091F \u0938\u0947 \u0915\u092E",
        other: "{{count}} \u092E\u093F\u0928\u091F \u0938\u0947 \u0915\u092E"
    },
    xMinutes: {
        one: "\u0967 \u092E\u093F\u0928\u091F",
        // CLDR #1307
        other: "{{count}} \u092E\u093F\u0928\u091F"
    },
    aboutXHours: {
        one: "\u0932\u0917\u092D\u0917 \u0967 \u0918\u0902\u091F\u093E",
        other: "\u0932\u0917\u092D\u0917 {{count}} \u0918\u0902\u091F\u0947"
    },
    xHours: {
        one: "\u0967 \u0918\u0902\u091F\u093E",
        // CLDR #1304
        other: "{{count}} \u0918\u0902\u091F\u0947" // CLDR #4467
    },
    xDays: {
        one: "\u0967 \u0926\u093F\u0928",
        // CLDR #1286
        other: "{{count}} \u0926\u093F\u0928"
    },
    aboutXWeeks: {
        one: "\u0932\u0917\u092D\u0917 \u0967 \u0938\u092A\u094D\u0924\u093E\u0939",
        other: "\u0932\u0917\u092D\u0917 {{count}} \u0938\u092A\u094D\u0924\u093E\u0939"
    },
    xWeeks: {
        one: "\u0967 \u0938\u092A\u094D\u0924\u093E\u0939",
        other: "{{count}} \u0938\u092A\u094D\u0924\u093E\u0939"
    },
    aboutXMonths: {
        one: "\u0932\u0917\u092D\u0917 \u0967 \u092E\u0939\u0940\u0928\u093E",
        other: "\u0932\u0917\u092D\u0917 {{count}} \u092E\u0939\u0940\u0928\u0947"
    },
    xMonths: {
        one: "\u0967 \u092E\u0939\u0940\u0928\u093E",
        other: "{{count}} \u092E\u0939\u0940\u0928\u0947"
    },
    aboutXYears: {
        one: "\u0932\u0917\u092D\u0917 \u0967 \u0935\u0930\u094D\u0937",
        other: "\u0932\u0917\u092D\u0917 {{count}} \u0935\u0930\u094D\u0937" // CLDR #4823
    },
    xYears: {
        one: "\u0967 \u0935\u0930\u094D\u0937",
        other: "{{count}} \u0935\u0930\u094D\u0937"
    },
    overXYears: {
        one: "\u0967 \u0935\u0930\u094D\u0937 \u0938\u0947 \u0905\u0927\u093F\u0915",
        other: "{{count}} \u0935\u0930\u094D\u0937 \u0938\u0947 \u0905\u0927\u093F\u0915"
    },
    almostXYears: {
        one: "\u0932\u0917\u092D\u0917 \u0967 \u0935\u0930\u094D\u0937",
        other: "\u0932\u0917\u092D\u0917 {{count}} \u0935\u0930\u094D\u0937"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', (0, _indexJs.numberToLocale)(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u092E\u0947 ";
        else return result + " \u092A\u0939\u0932\u0947";
    }
    return result;
};
exports.default = formatDistance;

},{"../localize/index.js":"alsjF","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"alsjF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "localeToNumber", function() {
    return localeToNumber;
});
parcelHelpers.export(exports, "numberToLocale", function() {
    return numberToLocale;
});
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var numberValues = {
    locale: {
        '1': "\u0967",
        '2': "\u0968",
        '3': "\u0969",
        '4': "\u096A",
        '5': "\u096B",
        '6': "\u096C",
        '7': "\u096D",
        '8': "\u096E",
        '9': "\u096F",
        '0': "\u0966"
    },
    number: {
        "\u0967": '1',
        "\u0968": '2',
        "\u0969": '3',
        "\u096A": '4',
        "\u096B": '5',
        "\u096C": '6',
        "\u096D": '7',
        "\u096E": '8',
        "\u096F": '9',
        "\u0966": '0'
    }
};
// CLDR #1585 - #1592
var eraValues = {
    narrow: [
        "\u0908\u0938\u093E-\u092A\u0942\u0930\u094D\u0935",
        "\u0908\u0938\u094D\u0935\u0940"
    ],
    abbreviated: [
        "\u0908\u0938\u093E-\u092A\u0942\u0930\u094D\u0935",
        "\u0908\u0938\u094D\u0935\u0940"
    ],
    wide: [
        "\u0908\u0938\u093E-\u092A\u0942\u0930\u094D\u0935",
        "\u0908\u0938\u0935\u0940 \u0938\u0928"
    ]
};
// CLDR #1593 - #1616
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u0924\u093F1",
        "\u0924\u093F2",
        "\u0924\u093F3",
        "\u0924\u093F4"
    ],
    wide: [
        "\u092A\u0939\u0932\u0940 \u0924\u093F\u092E\u093E\u0939\u0940",
        "\u0926\u0942\u0938\u0930\u0940 \u0924\u093F\u092E\u093E\u0939\u0940",
        "\u0924\u0940\u0938\u0930\u0940 \u0924\u093F\u092E\u093E\u0939\u0940",
        "\u091A\u094C\u0925\u0940 \u0924\u093F\u092E\u093E\u0939\u0940"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
// https://www.unicode.org/cldr/charts/32/summary/hi.html
// CLDR #1617 - #1688
var monthValues = {
    narrow: [
        "\u091C",
        "\u092B\u093C",
        "\u092E\u093E",
        "\u0905",
        "\u092E\u0908",
        "\u091C\u0942",
        "\u091C\u0941",
        "\u0905\u0917",
        "\u0938\u093F",
        "\u0905\u0915\u094D\u091F\u0942",
        "\u0928",
        "\u0926\u093F"
    ],
    abbreviated: [
        "\u091C\u0928",
        "\u092B\u093C\u0930",
        "\u092E\u093E\u0930\u094D\u091A",
        "\u0905\u092A\u094D\u0930\u0948\u0932",
        "\u092E\u0908",
        "\u091C\u0942\u0928",
        "\u091C\u0941\u0932",
        "\u0905\u0917",
        "\u0938\u093F\u0924",
        "\u0905\u0915\u094D\u091F\u0942",
        "\u0928\u0935",
        "\u0926\u093F\u0938"
    ],
    wide: [
        "\u091C\u0928\u0935\u0930\u0940",
        "\u092B\u093C\u0930\u0935\u0930\u0940",
        "\u092E\u093E\u0930\u094D\u091A",
        "\u0905\u092A\u094D\u0930\u0948\u0932",
        "\u092E\u0908",
        "\u091C\u0942\u0928",
        "\u091C\u0941\u0932\u093E\u0908",
        "\u0905\u0917\u0938\u094D\u0924",
        "\u0938\u093F\u0924\u0902\u092C\u0930",
        "\u0905\u0915\u094D\u091F\u0942\u092C\u0930",
        "\u0928\u0935\u0902\u092C\u0930",
        "\u0926\u093F\u0938\u0902\u092C\u0930"
    ]
};
// CLDR #1689 - #1744
var dayValues = {
    narrow: [
        "\u0930",
        "\u0938\u094B",
        "\u092E\u0902",
        "\u092C\u0941",
        "\u0917\u0941",
        "\u0936\u0941",
        "\u0936"
    ],
    short: [
        "\u0930",
        "\u0938\u094B",
        "\u092E\u0902",
        "\u092C\u0941",
        "\u0917\u0941",
        "\u0936\u0941",
        "\u0936"
    ],
    abbreviated: [
        "\u0930\u0935\u093F",
        "\u0938\u094B\u092E",
        "\u092E\u0902\u0917\u0932",
        "\u092C\u0941\u0927",
        "\u0917\u0941\u0930\u0941",
        "\u0936\u0941\u0915\u094D\u0930",
        "\u0936\u0928\u093F"
    ],
    wide: [
        "\u0930\u0935\u093F\u0935\u093E\u0930",
        "\u0938\u094B\u092E\u0935\u093E\u0930",
        "\u092E\u0902\u0917\u0932\u0935\u093E\u0930",
        "\u092C\u0941\u0927\u0935\u093E\u0930",
        "\u0917\u0941\u0930\u0941\u0935\u093E\u0930",
        "\u0936\u0941\u0915\u094D\u0930\u0935\u093E\u0930",
        "\u0936\u0928\u093F\u0935\u093E\u0930"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
    },
    abbreviated: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
    },
    wide: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
    },
    abbreviated: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
    },
    wide: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return numberToLocale(number);
};
function localeToNumber(locale) {
    var enNumber = locale.toString().replace(/[१२३४५६७८९०]/g, function(match) {
        return numberValues.number[match];
    });
    return Number(enNumber);
}
function numberToLocale(enNumber) {
    return enNumber.toString().replace(/\d/g, function(match) {
        return numberValues.locale[match];
    });
}
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"arb8U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, do MMMM, y',
    // CLDR #1787
    long: 'do MMMM, y',
    // CLDR #1788
    medium: 'd MMM, y',
    // CLDR #1789
    short: 'dd/MM/yyyy' // CLDR #1790
};
var timeFormats = {
    full: 'h:mm:ss a zzzz',
    // CLDR #1791
    long: 'h:mm:ss a z',
    // CLDR #1792
    medium: 'h:mm:ss a',
    // CLDR #1793
    short: 'h:mm a' // CLDR #1794
};
var dateTimeFormats = {
    full: "{{date}} '\u0915\u094B' {{time}}",
    // CLDR #1795
    long: "{{date}} '\u0915\u094B' {{time}}",
    // CLDR #1796
    medium: '{{date}}, {{time}}',
    // CLDR #1797
    short: '{{date}}, {{time}}' // CLDR #1798
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1gViw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'\u092A\u093F\u091B\u0932\u0947' eeee p",
    yesterday: "'\u0915\u0932' p",
    today: "'\u0906\u091C' p",
    tomorrow: "'\u0915\u0932' p",
    nextWeek: "eeee '\u0915\u094B' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"euJO7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../localize/index.js");
var matchOrdinalNumberPattern = /^[०१२३४५६७८९]+/i;
var parseOrdinalNumberPattern = /^[०१२३४५६७८९]+/i;
var matchEraPatterns = {
    narrow: /^(ईसा-पूर्व|ईस्वी)/i,
    abbreviated: /^(ईसा\.?\s?पूर्व\.?|ईसा\.?)/i,
    wide: /^(ईसा-पूर्व|ईसवी पूर्व|ईसवी सन|ईसवी)/i
};
var parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ति[1234]/i,
    wide: /^[1234](पहली|दूसरी|तीसरी|चौथी)? तिमाही/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    // eslint-disable-next-line no-misleading-character-class
    narrow: /^[जफ़माअप्मईजूनजुअगसिअक्तनदि]/i,
    abbreviated: /^(जन|फ़र|मार्च|अप्|मई|जून|जुल|अग|सित|अक्तू|नव|दिस)/i,
    wide: /^(जनवरी|फ़रवरी|मार्च|अप्रैल|मई|जून|जुलाई|अगस्त|सितंबर|अक्तूबर|नवंबर|दिसंबर)/i
};
var parseMonthPatterns = {
    narrow: [
        /^ज/i,
        /^फ़/i,
        /^मा/i,
        /^अप्/i,
        /^मई/i,
        /^जू/i,
        /^जु/i,
        /^अग/i,
        /^सि/i,
        /^अक्तू/i,
        /^न/i,
        /^दि/i
    ],
    any: [
        /^जन/i,
        /^फ़/i,
        /^मा/i,
        /^अप्/i,
        /^मई/i,
        /^जू/i,
        /^जु/i,
        /^अग/i,
        /^सि/i,
        /^अक्तू/i,
        /^नव/i,
        /^दिस/i
    ]
};
var matchDayPatterns = {
    // eslint-disable-next-line no-misleading-character-class
    narrow: /^[रविसोममंगलबुधगुरुशुक्रशनि]/i,
    short: /^(रवि|सोम|मंगल|बुध|गुरु|शुक्र|शनि)/i,
    abbreviated: /^(रवि|सोम|मंगल|बुध|गुरु|शुक्र|शनि)/i,
    wide: /^(रविवार|सोमवार|मंगलवार|बुधवार|गुरुवार|शुक्रवार|शनिवार)/i
};
var parseDayPatterns = {
    narrow: [
        /^रवि/i,
        /^सोम/i,
        /^मंगल/i,
        /^बुध/i,
        /^गुरु/i,
        /^शुक्र/i,
        /^शनि/i
    ],
    any: [
        /^रवि/i,
        /^सोम/i,
        /^मंगल/i,
        /^बुध/i,
        /^गुरु/i,
        /^शुक्र/i,
        /^शनि/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(पू|अ|म|द.\?|सु|दो|शा|रा)/i,
    any: /^(पूर्वाह्न|अपराह्न|म|द.\?|सु|दो|शा|रा)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^पूर्वाह्न/i,
        pm: /^अपराह्न/i,
        midnight: /^मध्य/i,
        noon: /^दो/i,
        morning: /सु/i,
        afternoon: /दो/i,
        evening: /शा/i,
        night: /रा/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: (0, _indexJs2.localeToNumber)
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","../localize/index.js":"alsjF","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"lTn2p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Croatian locale.
 * @language Croatian
 * @iso-639-2 hrv
 * @author Matija Marohnić [@silvenon]{@link https://github.com/silvenon}
 * @author Manico [@manico]{@link https://github.com/manico}
 * @author Ivan Jeržabek [@jerzabek]{@link https://github.com/jerzabek}
 */ var locale = {
    code: 'hr',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"7qXCt","./_lib/formatLong/index.js":"k5wR3","./_lib/formatRelative/index.js":"hf5yC","./_lib/localize/index.js":"2Ynez","./_lib/match/index.js":"bWFJw","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7qXCt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            standalone: 'manje od 1 sekunde',
            withPrepositionAgo: 'manje od 1 sekunde',
            withPrepositionIn: 'manje od 1 sekundu'
        },
        dual: 'manje od {{count}} sekunde',
        other: 'manje od {{count}} sekundi'
    },
    xSeconds: {
        one: {
            standalone: '1 sekunda',
            withPrepositionAgo: '1 sekunde',
            withPrepositionIn: '1 sekundu'
        },
        dual: '{{count}} sekunde',
        other: '{{count}} sekundi'
    },
    halfAMinute: 'pola minute',
    lessThanXMinutes: {
        one: {
            standalone: 'manje od 1 minute',
            withPrepositionAgo: 'manje od 1 minute',
            withPrepositionIn: 'manje od 1 minutu'
        },
        dual: 'manje od {{count}} minute',
        other: 'manje od {{count}} minuta'
    },
    xMinutes: {
        one: {
            standalone: '1 minuta',
            withPrepositionAgo: '1 minute',
            withPrepositionIn: '1 minutu'
        },
        dual: '{{count}} minute',
        other: '{{count}} minuta'
    },
    aboutXHours: {
        one: {
            standalone: 'oko 1 sat',
            withPrepositionAgo: 'oko 1 sat',
            withPrepositionIn: 'oko 1 sat'
        },
        dual: 'oko {{count}} sata',
        other: 'oko {{count}} sati'
    },
    xHours: {
        one: {
            standalone: '1 sat',
            withPrepositionAgo: '1 sat',
            withPrepositionIn: '1 sat'
        },
        dual: '{{count}} sata',
        other: '{{count}} sati'
    },
    xDays: {
        one: {
            standalone: '1 dan',
            withPrepositionAgo: '1 dan',
            withPrepositionIn: '1 dan'
        },
        dual: '{{count}} dana',
        other: '{{count}} dana'
    },
    aboutXWeeks: {
        one: {
            standalone: 'oko 1 tjedan',
            withPrepositionAgo: 'oko 1 tjedan',
            withPrepositionIn: 'oko 1 tjedan'
        },
        dual: 'oko {{count}} tjedna',
        other: 'oko {{count}} tjedana'
    },
    xWeeks: {
        one: {
            standalone: '1 tjedan',
            withPrepositionAgo: '1 tjedan',
            withPrepositionIn: '1 tjedan'
        },
        dual: '{{count}} tjedna',
        other: '{{count}} tjedana'
    },
    aboutXMonths: {
        one: {
            standalone: 'oko 1 mjesec',
            withPrepositionAgo: 'oko 1 mjesec',
            withPrepositionIn: 'oko 1 mjesec'
        },
        dual: 'oko {{count}} mjeseca',
        other: 'oko {{count}} mjeseci'
    },
    xMonths: {
        one: {
            standalone: '1 mjesec',
            withPrepositionAgo: '1 mjesec',
            withPrepositionIn: '1 mjesec'
        },
        dual: '{{count}} mjeseca',
        other: '{{count}} mjeseci'
    },
    aboutXYears: {
        one: {
            standalone: 'oko 1 godinu',
            withPrepositionAgo: 'oko 1 godinu',
            withPrepositionIn: 'oko 1 godinu'
        },
        dual: 'oko {{count}} godine',
        other: 'oko {{count}} godina'
    },
    xYears: {
        one: {
            standalone: '1 godina',
            withPrepositionAgo: '1 godine',
            withPrepositionIn: '1 godinu'
        },
        dual: '{{count}} godine',
        other: '{{count}} godina'
    },
    overXYears: {
        one: {
            standalone: 'preko 1 godinu',
            withPrepositionAgo: 'preko 1 godinu',
            withPrepositionIn: 'preko 1 godinu'
        },
        dual: 'preko {{count}} godine',
        other: 'preko {{count}} godina'
    },
    almostXYears: {
        one: {
            standalone: 'gotovo 1 godinu',
            withPrepositionAgo: 'gotovo 1 godinu',
            withPrepositionIn: 'gotovo 1 godinu'
        },
        dual: 'gotovo {{count}} godine',
        other: 'gotovo {{count}} godina'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) {
        if (options !== null && options !== void 0 && options.addSuffix) {
            if (options.comparison && options.comparison > 0) result = tokenValue.one.withPrepositionIn;
            else result = tokenValue.one.withPrepositionAgo;
        } else result = tokenValue.one.standalone;
    } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
    String(count).substr(-2, 1) !== '1' // unless the 2nd to last digit is "1"
    ) result = tokenValue.dual.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'za ' + result;
        else return 'prije ' + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"k5wR3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, d. MMMM y.',
    long: 'd. MMMM y.',
    medium: 'd. MMM y.',
    short: 'dd. MM. y.'
};
var timeFormats = {
    full: 'HH:mm:ss (zzzz)',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'u' {{time}}",
    long: "{{date}} 'u' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"hf5yC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        switch(date.getUTCDay()){
            case 0:
                return "'pro\u0161lu nedjelju u' p";
            case 3:
                return "'pro\u0161lu srijedu u' p";
            case 6:
                return "'pro\u0161lu subotu u' p";
            default:
                return "'pro\u0161li' EEEE 'u' p";
        }
    },
    yesterday: "'ju\u010Der u' p",
    today: "'danas u' p",
    tomorrow: "'sutra u' p",
    nextWeek: function nextWeek(date) {
        switch(date.getUTCDay()){
            case 0:
                return "'idu\u0107u nedjelju u' p";
            case 3:
                return "'idu\u0107u srijedu u' p";
            case 6:
                return "'idu\u0107u subotu u' p";
            default:
                return "'pro\u0161li' EEEE 'u' p";
        }
    },
    other: 'P'
};
var formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2Ynez":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'pr.n.e.',
        'AD'
    ],
    abbreviated: [
        'pr. Kr.',
        'po. Kr.'
    ],
    wide: [
        'Prije Krista',
        'Poslije Krista'
    ]
};
var quarterValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.'
    ],
    abbreviated: [
        '1. kv.',
        '2. kv.',
        '3. kv.',
        '4. kv.'
    ],
    wide: [
        '1. kvartal',
        '2. kvartal',
        '3. kvartal',
        '4. kvartal'
    ]
};
var monthValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.',
        '5.',
        '6.',
        '7.',
        '8.',
        '9.',
        '10.',
        '11.',
        '12.'
    ],
    abbreviated: [
        'sij',
        'velj',
        "o\u017Eu",
        'tra',
        'svi',
        'lip',
        'srp',
        'kol',
        'ruj',
        'lis',
        'stu',
        'pro'
    ],
    wide: [
        "sije\u010Danj",
        "velja\u010Da",
        "o\u017Eujak",
        'travanj',
        'svibanj',
        'lipanj',
        'srpanj',
        'kolovoz',
        'rujan',
        'listopad',
        'studeni',
        'prosinac'
    ]
};
var formattingMonthValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.',
        '5.',
        '6.',
        '7.',
        '8.',
        '9.',
        '10.',
        '11.',
        '12.'
    ],
    abbreviated: [
        'sij',
        'velj',
        "o\u017Eu",
        'tra',
        'svi',
        'lip',
        'srp',
        'kol',
        'ruj',
        'lis',
        'stu',
        'pro'
    ],
    wide: [
        "sije\u010Dnja",
        "velja\u010De",
        "o\u017Eujka",
        'travnja',
        'svibnja',
        'lipnja',
        'srpnja',
        'kolovoza',
        'rujna',
        'listopada',
        'studenog',
        'prosinca'
    ]
};
var dayValues = {
    narrow: [
        'N',
        'P',
        'U',
        'S',
        "\u010C",
        'P',
        'S'
    ],
    short: [
        'ned',
        'pon',
        'uto',
        'sri',
        "\u010Det",
        'pet',
        'sub'
    ],
    abbreviated: [
        'ned',
        'pon',
        'uto',
        'sri',
        "\u010Det",
        'pet',
        'sub'
    ],
    wide: [
        'nedjelja',
        'ponedjeljak',
        'utorak',
        'srijeda',
        "\u010Detvrtak",
        'petak',
        'subota'
    ]
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutro',
        afternoon: 'popodne',
        evening: "nave\u010Der",
        night: "no\u0107u"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutro',
        afternoon: 'popodne',
        evening: "nave\u010Der",
        night: "no\u0107u"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutro',
        afternoon: 'poslije podne',
        evening: "nave\u010Der",
        night: "no\u0107u"
    }
};
var dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutro',
        afternoon: 'popodne',
        evening: "nave\u010Der",
        night: "no\u0107u"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutro',
        afternoon: 'popodne',
        evening: "nave\u010Der",
        night: "no\u0107u"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutro',
        afternoon: 'poslije podne',
        evening: "nave\u010Der",
        night: "no\u0107u"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide',
        formattingValues: formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"bWFJw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)\./i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(pr\.n\.e\.|AD)/i,
    abbreviated: /^(pr\.\s?Kr\.|po\.\s?Kr\.)/i,
    wide: /^(Prije Krista|prije nove ere|Poslije Krista|nova era)/i
};
var parseEraPatterns = {
    any: [
        /^pr/i,
        /^(po|nova)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\.\s?kv\.?/i,
    wide: /^[1234]\. kvartal/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^(10|11|12|[123456789])\./i,
    abbreviated: /^(sij|velj|(ožu|ozu)|tra|svi|lip|srp|kol|ruj|lis|stu|pro)/i,
    wide: /^((siječanj|siječnja|sijecanj|sijecnja)|(veljača|veljače|veljaca|veljace)|(ožujak|ožujka|ozujak|ozujka)|(travanj|travnja)|(svibanj|svibnja)|(lipanj|lipnja)|(srpanj|srpnja)|(kolovoz|kolovoza)|(rujan|rujna)|(listopad|listopada)|(studeni|studenog)|(prosinac|prosinca))/i
};
var parseMonthPatterns = {
    narrow: [
        /1/i,
        /2/i,
        /3/i,
        /4/i,
        /5/i,
        /6/i,
        /7/i,
        /8/i,
        /9/i,
        /10/i,
        /11/i,
        /12/i
    ],
    abbreviated: [
        /^sij/i,
        /^velj/i,
        /^(ožu|ozu)/i,
        /^tra/i,
        /^svi/i,
        /^lip/i,
        /^srp/i,
        /^kol/i,
        /^ruj/i,
        /^lis/i,
        /^stu/i,
        /^pro/i
    ],
    wide: [
        /^sij/i,
        /^velj/i,
        /^(ožu|ozu)/i,
        /^tra/i,
        /^svi/i,
        /^lip/i,
        /^srp/i,
        /^kol/i,
        /^ruj/i,
        /^lis/i,
        /^stu/i,
        /^pro/i
    ]
};
var matchDayPatterns = {
    narrow: /^[npusčc]/i,
    short: /^(ned|pon|uto|sri|(čet|cet)|pet|sub)/i,
    abbreviated: /^(ned|pon|uto|sri|(čet|cet)|pet|sub)/i,
    wide: /^(nedjelja|ponedjeljak|utorak|srijeda|(četvrtak|cetvrtak)|petak|subota)/i
};
var parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var matchDayPeriodPatterns = {
    any: /^(am|pm|ponoc|ponoć|(po)?podne|navecer|navečer|noću|poslije podne|ujutro)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^pono/i,
        noon: /^pod/i,
        morning: /jutro/i,
        afternoon: /(poslije\s|po)+podne/i,
        evening: /(navece|naveče)/i,
        night: /(nocu|noću)/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"be2y5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Haitian Creole locale.
 * @language Haitian Creole
 * @iso-639-2 hat
 * @author Rubens Mariuzzo [@rmariuzzo]{@link https://github.com/rmariuzzo}
 * @author Watson Marcelain [@watsongm24]{@link https://github.com/watsongm24}
 */ var locale = {
    code: 'ht',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"8eYtq","./_lib/formatLong/index.js":"jwMC4","./_lib/formatRelative/index.js":"8puFr","./_lib/localize/index.js":"c6mPM","./_lib/match/index.js":"32LiY","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8eYtq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'mwens pase yon segond',
        other: 'mwens pase {{count}} segond'
    },
    xSeconds: {
        one: '1 segond',
        other: '{{count}} segond'
    },
    halfAMinute: '30 segond',
    lessThanXMinutes: {
        one: 'mwens pase yon minit',
        other: 'mwens pase {{count}} minit'
    },
    xMinutes: {
        one: '1 minit',
        other: '{{count}} minit'
    },
    aboutXHours: {
        one: "anviwon in\xe8",
        other: "anviwon {{count}} \xe8"
    },
    xHours: {
        one: "1 l\xe8",
        other: "{{count}} l\xe8"
    },
    xDays: {
        one: '1 jou',
        other: '{{count}} jou'
    },
    aboutXWeeks: {
        one: "anviwon 1 sem\xe8n",
        other: "anviwon {{count}} sem\xe8n"
    },
    xWeeks: {
        one: "1 sem\xe8n",
        other: "{{count}} sem\xe8n"
    },
    aboutXMonths: {
        one: 'anviwon 1 mwa',
        other: 'anviwon {{count}} mwa'
    },
    xMonths: {
        one: '1 mwa',
        other: '{{count}} mwa'
    },
    aboutXYears: {
        one: 'anviwon 1 an',
        other: 'anviwon {{count}} an'
    },
    xYears: {
        one: '1 an',
        other: '{{count}} an'
    },
    overXYears: {
        one: 'plis pase 1 an',
        other: 'plis pase {{count}} an'
    },
    almostXYears: {
        one: "pr\xe8ske 1 an",
        other: "pr\xe8ske {{count}} an"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'nan ' + result;
        else return "sa f\xe8 " + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jwMC4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd/MM/y'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'nan l\xe8' {{time}}",
    long: "{{date}} 'nan l\xe8' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8puFr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "eeee 'pase nan l\xe8' p",
    yesterday: "'y\xe8 nan l\xe8' p",
    today: "'jodi a' p",
    tomorrow: "'demen nan l\xe8' p'",
    nextWeek: "eeee 'pwochen nan l\xe8' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"c6mPM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'av. J.-K',
        'ap. J.-K'
    ],
    abbreviated: [
        'av. J.-K',
        'ap. J.-K'
    ],
    wide: [
        'anvan Jezi Kris',
        'apre Jezi Kris'
    ]
};
var quarterValues = {
    narrow: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    abbreviated: [
        '1ye trim.',
        "2y\xe8m trim.",
        "3y\xe8m trim.",
        "4y\xe8m trim."
    ],
    wide: [
        "1ye trim\xe8s",
        "2y\xe8m trim\xe8s",
        "3y\xe8m trim\xe8s",
        "4y\xe8m trim\xe8s"
    ]
};
var monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'O',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'janv.',
        'fevr.',
        'mas',
        'avr.',
        'me',
        'jen',
        "jiy\xe8",
        'out',
        'sept.',
        'okt.',
        'nov.',
        'des.'
    ],
    wide: [
        'janvye',
        'fevrye',
        'mas',
        'avril',
        'me',
        'jen',
        "jiy\xe8",
        'out',
        'septanm',
        "okt\xf2b",
        'novanm',
        'desanm'
    ]
};
var dayValues = {
    narrow: [
        'D',
        'L',
        'M',
        'M',
        'J',
        'V',
        'S'
    ],
    short: [
        'di',
        'le',
        'ma',
        "m\xe8",
        'je',
        'va',
        'sa'
    ],
    abbreviated: [
        'dim.',
        'len.',
        'mad.',
        "m\xe8k.",
        'jed.',
        'van.',
        'sam.'
    ],
    wide: [
        'dimanch',
        'lendi',
        'madi',
        "m\xe8kredi",
        'jedi',
        'vandredi',
        'samdi'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'minwit',
        noon: 'midi',
        morning: 'mat.',
        afternoon: 'ap.m.',
        evening: 'swa',
        night: 'mat.'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'minwit',
        noon: 'midi',
        morning: 'maten',
        afternoon: "apr\xe8midi",
        evening: 'swa',
        night: 'maten'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'minwit',
        noon: 'midi',
        morning: 'nan maten',
        afternoon: "nan apr\xe8midi",
        evening: "nan asw\xe8",
        night: 'nan maten'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    if (number === 0) return String(number);
    var suffix = number === 1 ? 'ye' : "y\xe8m";
    return number + suffix;
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"32LiY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(ye|yèm)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(av\.J\.K|ap\.J\.K|ap\.J\.-K)/i,
    abbreviated: /^(av\.J\.-K|av\.J-K|apr\.J\.-K|apr\.J-K|ap\.J-K)/i,
    wide: /^(avan Jezi Kris|apre Jezi Kris)/i
};
var parseEraPatterns = {
    any: [
        /^av/i,
        /^ap/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^t[1234]/i,
    wide: /^[1234](ye|yèm)? trimès/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(janv|fevr|mas|avr|me|jen|jiyè|out|sept|okt|nov|des)\.?/i,
    wide: /^(janvye|fevrye|mas|avril|me|jen|jiyè|out|septanm|oktòb|novanm|desanm)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^o/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^ma/i,
        /^av/i,
        /^me/i,
        /^je/i,
        /^ji/i,
        /^ou/i,
        /^s/i,
        /^ok/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[lmjvsd]/i,
    short: /^(di|le|ma|me|je|va|sa)/i,
    abbreviated: /^(dim|len|mad|mèk|jed|van|sam)\.?/i,
    wide: /^(dimanch|lendi|madi|mèkredi|jedi|vandredi|samdi)/i
};
var parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^di/i,
        /^le/i,
        /^ma/i,
        /^mè/i,
        /^je/i,
        /^va/i,
        /^sa/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|minwit|midi|mat\.?|ap\.?m\.?|swa)/i,
    any: /^([ap]\.?\s?m\.?|nan maten|nan aprèmidi|nan aswè)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^min/i,
        noon: /^mid/i,
        morning: /mat/i,
        afternoon: /ap/i,
        evening: /sw/i,
        night: /nwit/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"aYo0x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Hungarian locale.
 * @language Hungarian
 * @iso-639-2 hun
 * @author Pavlo Shpak [@pshpak]{@link https://github.com/pshpak}
 * @author Eduardo Pardo [@eduardopsll]{@link https://github.com/eduardopsll}
 * @author Zoltan Szepesi [@twodcube]{@link https://github.com/twodcube}
 */ var locale = {
    code: 'hu',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"iTUl9","./_lib/formatLong/index.js":"lpn0U","./_lib/formatRelative/index.js":"lXRri","./_lib/localize/index.js":"2nzp3","./_lib/match/index.js":"goxJI","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"iTUl9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var translations = {
    about: "k\xf6r\xfclbel\xfcl",
    over: "t\xf6bb mint",
    almost: 'majdnem',
    lessthan: 'kevesebb mint'
};
var withoutSuffixes = {
    xseconds: " m\xe1sodperc",
    halfaminute: "f\xe9l perc",
    xminutes: ' perc',
    xhours: " \xf3ra",
    xdays: ' nap',
    xweeks: " h\xe9t",
    xmonths: " h\xf3nap",
    xyears: " \xe9v"
};
var withSuffixes = {
    xseconds: {
        '-1': " m\xe1sodperccel ezel\u0151tt",
        '1': " m\xe1sodperc m\xfalva",
        '0': " m\xe1sodperce"
    },
    halfaminute: {
        '-1': "f\xe9l perccel ezel\u0151tt",
        '1': "f\xe9l perc m\xfalva",
        '0': "f\xe9l perce"
    },
    xminutes: {
        '-1': " perccel ezel\u0151tt",
        '1': " perc m\xfalva",
        '0': ' perce'
    },
    xhours: {
        '-1': " \xf3r\xe1val ezel\u0151tt",
        '1': " \xf3ra m\xfalva",
        '0': " \xf3r\xe1ja"
    },
    xdays: {
        '-1': " nappal ezel\u0151tt",
        '1': " nap m\xfalva",
        '0': ' napja'
    },
    xweeks: {
        '-1': " h\xe9ttel ezel\u0151tt",
        '1': " h\xe9t m\xfalva",
        '0': ' hete'
    },
    xmonths: {
        '-1': " h\xf3nappal ezel\u0151tt",
        '1': " h\xf3nap m\xfalva",
        '0': " h\xf3napja"
    },
    xyears: {
        '-1': " \xe9vvel ezel\u0151tt",
        '1': " \xe9v m\xfalva",
        '0': " \xe9ve"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var adverb = token.match(/about|over|almost|lessthan/i);
    var unit = adverb ? token.replace(adverb[0], '') : token;
    var addSuffix = (options === null || options === void 0 ? void 0 : options.addSuffix) === true;
    var key = unit.toLowerCase();
    var comparison = (options === null || options === void 0 ? void 0 : options.comparison) || 0;
    var translated = addSuffix ? withSuffixes[key][comparison] : withoutSuffixes[key];
    var result = key === 'halfaminute' ? translated : count + translated;
    if (adverb) {
        var adv = adverb[0].toLowerCase();
        result = translations[adv] + ' ' + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"lpn0U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'y. MMMM d., EEEE',
    long: 'y. MMMM d.',
    medium: 'y. MMM d.',
    short: 'y. MM. dd.'
};
var timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"lXRri":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var accusativeWeekdays = [
    "vas\xe1rnap",
    "h\xe9tf\u0151n",
    'kedden',
    "szerd\xe1n",
    "cs\xfct\xf6rt\xf6k\xf6n",
    "p\xe9nteken",
    'szombaton'
];
function week(isFuture) {
    return function(date) {
        var weekday = accusativeWeekdays[date.getUTCDay()];
        var prefix = isFuture ? '' : "'m\xfalt' ";
        return "".concat(prefix, "'").concat(weekday, "' p'-kor'");
    };
}
var formatRelativeLocale = {
    lastWeek: week(false),
    yesterday: "'tegnap' p'-kor'",
    today: "'ma' p'-kor'",
    tomorrow: "'holnap' p'-kor'",
    nextWeek: week(true),
    other: 'P'
};
var formatRelative = function formatRelative(token, date) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2nzp3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'ie.',
        'isz.'
    ],
    abbreviated: [
        'i. e.',
        'i. sz.'
    ],
    wide: [
        "Krisztus el\u0151tt",
        "id\u0151sz\xe1m\xedt\xe1sunk szerint"
    ]
};
var quarterValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.'
    ],
    abbreviated: [
        "1. n.\xe9v",
        "2. n.\xe9v",
        "3. n.\xe9v",
        "4. n.\xe9v"
    ],
    wide: [
        "1. negyed\xe9v",
        "2. negyed\xe9v",
        "3. negyed\xe9v",
        "4. negyed\xe9v"
    ]
};
var formattingQuarterValues = {
    narrow: [
        'I.',
        'II.',
        'III.',
        'IV.'
    ],
    abbreviated: [
        "I. n.\xe9v",
        "II. n.\xe9v",
        "III. n.\xe9v",
        "IV. n.\xe9v"
    ],
    wide: [
        "I. negyed\xe9v",
        "II. negyed\xe9v",
        "III. negyed\xe9v",
        "IV. negyed\xe9v"
    ]
};
var monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        "\xc1",
        'M',
        'J',
        'J',
        'A',
        'Sz',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'febr.',
        "m\xe1rc.",
        "\xe1pr.",
        "m\xe1j.",
        "j\xfan.",
        "j\xfal.",
        'aug.',
        'szept.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        "janu\xe1r",
        "febru\xe1r",
        "m\xe1rcius",
        "\xe1prilis",
        "m\xe1jus",
        "j\xfanius",
        "j\xfalius",
        'augusztus',
        'szeptember',
        "okt\xf3ber",
        'november',
        'december'
    ]
};
var dayValues = {
    narrow: [
        'V',
        'H',
        'K',
        'Sz',
        'Cs',
        'P',
        'Sz'
    ],
    short: [
        'V',
        'H',
        'K',
        'Sze',
        'Cs',
        'P',
        'Szo'
    ],
    abbreviated: [
        'V',
        'H',
        'K',
        'Sze',
        'Cs',
        'P',
        'Szo'
    ],
    wide: [
        "vas\xe1rnap",
        "h\xe9tf\u0151",
        'kedd',
        'szerda',
        "cs\xfct\xf6rt\xf6k",
        "p\xe9ntek",
        'szombat'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'de.',
        pm: 'du.',
        midnight: "\xe9jf\xe9l",
        noon: "d\xe9l",
        morning: 'reggel',
        afternoon: 'du.',
        evening: 'este',
        night: "\xe9jjel"
    },
    abbreviated: {
        am: 'de.',
        pm: 'du.',
        midnight: "\xe9jf\xe9l",
        noon: "d\xe9l",
        morning: 'reggel',
        afternoon: 'du.',
        evening: 'este',
        night: "\xe9jjel"
    },
    wide: {
        am: 'de.',
        pm: 'du.',
        midnight: "\xe9jf\xe9l",
        noon: "d\xe9l",
        morning: 'reggel',
        afternoon: "d\xe9lut\xe1n",
        evening: 'este',
        night: "\xe9jjel"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        },
        formattingValues: formattingQuarterValues,
        defaultFormattingWidth: 'wide'
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"goxJI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)\.?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(ie\.|isz\.)/i,
    abbreviated: /^(i\.\s?e\.?|b?\s?c\s?e|i\.\s?sz\.?)/i,
    wide: /^(Krisztus előtt|időszámításunk előtt|időszámításunk szerint|i\. sz\.)/i
};
var parseEraPatterns = {
    narrow: [
        /ie/i,
        /isz/i
    ],
    abbreviated: [
        /^(i\.?\s?e\.?|b\s?ce)/i,
        /^(i\.?\s?sz\.?|c\s?e)/i
    ],
    any: [
        /előtt/i,
        /(szerint|i. sz.)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]\.?/i,
    abbreviated: /^[1234]?\.?\s?n\.év/i,
    wide: /^([1234]|I|II|III|IV)?\.?\s?negyedév/i
};
var parseQuarterPatterns = {
    any: [
        /1|I$/i,
        /2|II$/i,
        /3|III/i,
        /4|IV/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmaásond]|sz/i,
    abbreviated: /^(jan\.?|febr\.?|márc\.?|ápr\.?|máj\.?|jún\.?|júl\.?|aug\.?|szept\.?|okt\.?|nov\.?|dec\.?)/i,
    wide: /^(január|február|március|április|május|június|július|augusztus|szeptember|október|november|december)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a|á/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s|sz/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^már/i,
        /^áp/i,
        /^máj/i,
        /^jún/i,
        /^júl/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^([vhkpc]|sz|cs|sz)/i,
    short: /^([vhkp]|sze|cs|szo)/i,
    abbreviated: /^([vhkp]|sze|cs|szo)/i,
    wide: /^(vasárnap|hétfő|kedd|szerda|csütörtök|péntek|szombat)/i
};
var parseDayPatterns = {
    narrow: [
        /^v/i,
        /^h/i,
        /^k/i,
        /^sz/i,
        /^c/i,
        /^p/i,
        /^sz/i
    ],
    any: [
        /^v/i,
        /^h/i,
        /^k/i,
        /^sze/i,
        /^c/i,
        /^p/i,
        /^szo/i
    ]
};
var matchDayPeriodPatterns = {
    any: /^((de|du)\.?|éjfél|délután|dél|reggel|este|éjjel)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^de\.?/i,
        pm: /^du\.?/i,
        midnight: /^éjf/i,
        noon: /^dé/i,
        morning: /reg/i,
        afternoon: /^délu\.?/i,
        evening: /es/i,
        night: /éjj/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"ieBPG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Armenian locale
 * @language Armenian
 * @iso-639-2 arm
 * @author Alex Igityan [@alexigityan]{@link https://github.com/alexigityan}
 */ var locale = {
    code: 'hy',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"791yb","./_lib/formatLong/index.js":"dz3UT","./_lib/formatRelative/index.js":"kVdQd","./_lib/localize/index.js":"6ElEt","./_lib/match/index.js":"2jLg8","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"791yb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0561\u057E\u0565\u056C\u056B \u0584\u056B\u0579 \u0584\u0561\u0576 1 \u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576",
        other: "\u0561\u057E\u0565\u056C\u056B \u0584\u056B\u0579 \u0584\u0561\u0576 {{count}} \u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576"
    },
    xSeconds: {
        one: "1 \u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576",
        other: "{{count}} \u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576"
    },
    halfAMinute: "\u056F\u0565\u057D \u0580\u0578\u057A\u0565",
    lessThanXMinutes: {
        one: "\u0561\u057E\u0565\u056C\u056B \u0584\u056B\u0579 \u0584\u0561\u0576 1 \u0580\u0578\u057A\u0565",
        other: "\u0561\u057E\u0565\u056C\u056B \u0584\u056B\u0579 \u0584\u0561\u0576 {{count}} \u0580\u0578\u057A\u0565"
    },
    xMinutes: {
        one: "1 \u0580\u0578\u057A\u0565",
        other: "{{count}} \u0580\u0578\u057A\u0565"
    },
    aboutXHours: {
        one: "\u0574\u0578\u057F 1 \u056A\u0561\u0574",
        other: "\u0574\u0578\u057F {{count}} \u056A\u0561\u0574"
    },
    xHours: {
        one: "1 \u056A\u0561\u0574",
        other: "{{count}} \u056A\u0561\u0574"
    },
    xDays: {
        one: "1 \u0585\u0580",
        other: "{{count}} \u0585\u0580"
    },
    aboutXWeeks: {
        one: "\u0574\u0578\u057F 1 \u0577\u0561\u0562\u0561\u0569",
        other: "\u0574\u0578\u057F {{count}} \u0577\u0561\u0562\u0561\u0569"
    },
    xWeeks: {
        one: "1 \u0577\u0561\u0562\u0561\u0569",
        other: "{{count}} \u0577\u0561\u0562\u0561\u0569"
    },
    aboutXMonths: {
        one: "\u0574\u0578\u057F 1 \u0561\u0574\u056B\u057D",
        other: "\u0574\u0578\u057F {{count}} \u0561\u0574\u056B\u057D"
    },
    xMonths: {
        one: "1 \u0561\u0574\u056B\u057D",
        other: "{{count}} \u0561\u0574\u056B\u057D"
    },
    aboutXYears: {
        one: "\u0574\u0578\u057F 1 \u057F\u0561\u0580\u056B",
        other: "\u0574\u0578\u057F {{count}} \u057F\u0561\u0580\u056B"
    },
    xYears: {
        one: "1 \u057F\u0561\u0580\u056B",
        other: "{{count}} \u057F\u0561\u0580\u056B"
    },
    overXYears: {
        one: "\u0561\u057E\u0565\u056C\u056B \u0584\u0561\u0576 1 \u057F\u0561\u0580\u056B",
        other: "\u0561\u057E\u0565\u056C\u056B \u0584\u0561\u0576 {{count}} \u057F\u0561\u0580\u056B"
    },
    almostXYears: {
        one: "\u0570\u0561\u0574\u0561\u0580\u0575\u0561 1 \u057F\u0561\u0580\u056B",
        other: "\u0570\u0561\u0574\u0561\u0580\u0575\u0561 {{count}} \u057F\u0561\u0580\u056B"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " \u0570\u0565\u057F\u0578";
        else return result + " \u0561\u057C\u0561\u057B";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"dz3UT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'd MMMM, y, EEEE',
    long: 'd MMMM, y',
    medium: 'd MMM, y',
    short: 'dd.MM.yyyy'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} '\u056A\u2024'{{time}}",
    long: "{{date}} '\u056A\u2024'{{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"kVdQd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'\u0576\u0561\u056D\u0578\u0580\u0564' eeee p'\u058A\u056B\u0576'",
    yesterday: "'\u0565\u0580\u0565\u056F' p'\u058A\u056B\u0576'",
    today: "'\u0561\u0575\u057D\u0585\u0580' p'\u058A\u056B\u0576'",
    tomorrow: "'\u057E\u0561\u0572\u0568' p'\u058A\u056B\u0576'",
    nextWeek: "'\u0570\u0561\u057B\u0578\u0580\u0564' eeee p'\u058A\u056B\u0576'",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6ElEt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u0554",
        "\u0544"
    ],
    abbreviated: [
        "\u0554\u0531",
        "\u0544\u0539"
    ],
    wide: [
        "\u0554\u0580\u056B\u057D\u057F\u0578\u057D\u056B\u0581 \u0561\u057C\u0561\u057B",
        "\u0544\u0565\u0580 \u0569\u057E\u0561\u0580\u056F\u0578\u0582\u0569\u0575\u0561\u0576"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u05541",
        "\u05542",
        "\u05543",
        "\u05544"
    ],
    wide: [
        "1\u058A\u056B\u0576 \u0584\u0561\u057C\u0578\u0580\u0564",
        "2\u058A\u0580\u0564 \u0584\u0561\u057C\u0578\u0580\u0564",
        "3\u058A\u0580\u0564 \u0584\u0561\u057C\u0578\u0580\u0564",
        "4\u058A\u0580\u0564 \u0584\u0561\u057C\u0578\u0580\u0564"
    ]
};
var monthValues = {
    narrow: [
        "\u0540",
        "\u0553",
        "\u0544",
        "\u0531",
        "\u0544",
        "\u0540",
        "\u0540",
        "\u0555",
        "\u054D",
        "\u0540",
        "\u0546",
        "\u0534"
    ],
    abbreviated: [
        "\u0570\u0578\u0582\u0576",
        "\u0583\u0565\u057F",
        "\u0574\u0561\u0580",
        "\u0561\u057A\u0580",
        "\u0574\u0561\u0575",
        "\u0570\u0578\u0582\u0576",
        "\u0570\u0578\u0582\u056C",
        "\u0585\u0563\u057D",
        "\u057D\u0565\u057A",
        "\u0570\u0578\u056F",
        "\u0576\u0578\u0575",
        "\u0564\u0565\u056F"
    ],
    wide: [
        "\u0570\u0578\u0582\u0576\u057E\u0561\u0580",
        "\u0583\u0565\u057F\u0580\u057E\u0561\u0580",
        "\u0574\u0561\u0580\u057F",
        "\u0561\u057A\u0580\u056B\u056C",
        "\u0574\u0561\u0575\u056B\u057D",
        "\u0570\u0578\u0582\u0576\u056B\u057D",
        "\u0570\u0578\u0582\u056C\u056B\u057D",
        "\u0585\u0563\u0578\u057D\u057F\u0578\u057D",
        "\u057D\u0565\u057A\u057F\u0565\u0574\u0562\u0565\u0580",
        "\u0570\u0578\u056F\u057F\u0565\u0574\u0562\u0565\u0580",
        "\u0576\u0578\u0575\u0565\u0574\u0562\u0565\u0580",
        "\u0564\u0565\u056F\u057F\u0565\u0574\u0562\u0565\u0580"
    ]
};
var dayValues = {
    narrow: [
        "\u053F",
        "\u0535",
        "\u0535",
        "\u0549",
        "\u0540",
        "\u0548",
        "\u0547"
    ],
    short: [
        "\u056F\u0580",
        "\u0565\u0580",
        "\u0565\u0584",
        "\u0579\u0584",
        "\u0570\u0563",
        "\u0578\u0582\u0580",
        "\u0577\u0562"
    ],
    abbreviated: [
        "\u056F\u056B\u0580",
        "\u0565\u0580\u056F",
        "\u0565\u0580\u0584",
        "\u0579\u0578\u0580",
        "\u0570\u0576\u0563",
        "\u0578\u0582\u0580\u0562",
        "\u0577\u0561\u0562"
    ],
    wide: [
        "\u056F\u056B\u0580\u0561\u056F\u056B",
        "\u0565\u0580\u056F\u0578\u0582\u0577\u0561\u0562\u0569\u056B",
        "\u0565\u0580\u0565\u0584\u0577\u0561\u0562\u0569\u056B",
        "\u0579\u0578\u0580\u0565\u0584\u0577\u0561\u0562\u0569\u056B",
        "\u0570\u056B\u0576\u0563\u0577\u0561\u0562\u0569\u056B",
        "\u0578\u0582\u0580\u0562\u0561\u0569",
        "\u0577\u0561\u0562\u0561\u0569"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: "\u056F\u0565\u057D\u0563\u0577",
        noon: "\u056F\u0565\u057D\u0585\u0580",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F",
        afternoon: "\u0581\u0565\u0580\u0565\u056F",
        evening: "\u0565\u0580\u0565\u056F\u0578",
        night: "\u0563\u056B\u0577\u0565\u0580"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u056F\u0565\u057D\u0563\u056B\u0577\u0565\u0580",
        noon: "\u056F\u0565\u057D\u0585\u0580",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F",
        afternoon: "\u0581\u0565\u0580\u0565\u056F",
        evening: "\u0565\u0580\u0565\u056F\u0578",
        night: "\u0563\u056B\u0577\u0565\u0580"
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "\u056F\u0565\u057D\u0563\u056B\u0577\u0565\u0580",
        noon: "\u056F\u0565\u057D\u0585\u0580",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F",
        afternoon: "\u0581\u0565\u0580\u0565\u056F",
        evening: "\u0565\u0580\u0565\u056F\u0578",
        night: "\u0563\u056B\u0577\u0565\u0580"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: "\u056F\u0565\u057D\u0563\u0577",
        noon: "\u056F\u0565\u057D\u0585\u0580",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F\u0568",
        afternoon: "\u0581\u0565\u0580\u0565\u056F\u0568",
        evening: "\u0565\u0580\u0565\u056F\u0578\u0575\u0561\u0576",
        night: "\u0563\u056B\u0577\u0565\u0580\u0568"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u056F\u0565\u057D\u0563\u056B\u0577\u0565\u0580\u056B\u0576",
        noon: "\u056F\u0565\u057D\u0585\u0580\u056B\u0576",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F\u0568",
        afternoon: "\u0581\u0565\u0580\u0565\u056F\u0568",
        evening: "\u0565\u0580\u0565\u056F\u0578\u0575\u0561\u0576",
        night: "\u0563\u056B\u0577\u0565\u0580\u0568"
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "\u056F\u0565\u057D\u0563\u056B\u0577\u0565\u0580\u056B\u0576",
        noon: "\u056F\u0565\u057D\u0585\u0580\u056B\u0576",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F\u0568",
        afternoon: "\u0581\u0565\u0580\u0565\u056F\u0568",
        evening: "\u0565\u0580\u0565\u056F\u0578\u0575\u0561\u0576",
        night: "\u0563\u056B\u0577\u0565\u0580\u0568"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 < 10) {
        if (rem100 % 10 === 1) return number + "\u058A\u056B\u0576";
    }
    return number + "\u058A\u0580\u0564";
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2jLg8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)((-|֊)?(ին|րդ))?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(Ք|Մ)/i,
    abbreviated: /^(Ք\.?\s?Ա\.?|Մ\.?\s?Թ\.?\s?Ա\.?|Մ\.?\s?Թ\.?|Ք\.?\s?Հ\.?)/i,
    wide: /^(քրիստոսից առաջ|մեր թվարկությունից առաջ|մեր թվարկության|քրիստոսից հետո)/i
};
var parseEraPatterns = {
    any: [
        /^ք/i,
        /^մ/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ք[1234]/i,
    wide: /^[1234]((-|֊)?(ին|րդ)) քառորդ/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[հփմաօսնդ]/i,
    abbreviated: /^(հուն|փետ|մար|ապր|մայ|հուն|հուլ|օգս|սեպ|հոկ|նոյ|դեկ)/i,
    wide: /^(հունվար|փետրվար|մարտ|ապրիլ|մայիս|հունիս|հուլիս|օգոստոս|սեպտեմբեր|հոկտեմբեր|նոյեմբեր|դեկտեմբեր)/i
};
var parseMonthPatterns = {
    narrow: [
        /^հ/i,
        /^փ/i,
        /^մ/i,
        /^ա/i,
        /^մ/i,
        /^հ/i,
        /^հ/i,
        /^օ/i,
        /^ս/i,
        /^հ/i,
        /^ն/i,
        /^դ/i
    ],
    any: [
        /^հու/i,
        /^փ/i,
        /^մար/i,
        /^ա/i,
        /^մայ/i,
        /^հուն/i,
        /^հուլ/i,
        /^օ/i,
        /^ս/i,
        /^հոկ/i,
        /^ն/i,
        /^դ/i
    ]
};
var matchDayPatterns = {
    narrow: /^[եչհոշկ]/i,
    short: /^(կր|եր|եք|չք|հգ|ուր|շբ)/i,
    abbreviated: /^(կիր|երկ|երք|չոր|հնգ|ուրբ|շաբ)/i,
    wide: /^(կիրակի|երկուշաբթի|երեքշաբթի|չորեքշաբթի|հինգշաբթի|ուրբաթ|շաբաթ)/i
};
var parseDayPatterns = {
    narrow: [
        /^կ/i,
        /^ե/i,
        /^ե/i,
        /^չ/i,
        /^հ/i,
        /^(ո|Ո)/,
        /^շ/i
    ],
    short: [
        /^կ/i,
        /^եր/i,
        /^եք/i,
        /^չ/i,
        /^հ/i,
        /^(ո|Ո)/,
        /^շ/i
    ],
    abbreviated: [
        /^կ/i,
        /^երկ/i,
        /^երք/i,
        /^չ/i,
        /^հ/i,
        /^(ո|Ո)/,
        /^շ/i
    ],
    wide: [
        /^կ/i,
        /^երկ/i,
        /^երե/i,
        /^չ/i,
        /^հ/i,
        /^(ո|Ո)/,
        /^շ/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^([ap]|կեսգշ|կեսօր|(առավոտը?|ցերեկը?|երեկո(յան)?|գիշերը?))/i,
    any: /^([ap]\.?\s?m\.?|կեսգիշեր(ին)?|կեսօր(ին)?|(առավոտը?|ցերեկը?|երեկո(յան)?|գիշերը?))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /կեսգիշեր/i,
        noon: /կեսօր/i,
        morning: /առավոտ/i,
        afternoon: /ցերեկ/i,
        evening: /երեկո/i,
        night: /գիշեր/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"704ij":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Indonesian locale.
 * @language Indonesian
 * @iso-639-2 ind
 * @author Rahmat Budiharso [@rbudiharso]{@link https://github.com/rbudiharso}
 * @author Benget Nata [@bentinata]{@link https://github.com/bentinata}
 * @author Budi Irawan [@deerawan]{@link https://github.com/deerawan}
 * @author Try Ajitiono [@imballinst]{@link https://github.com/imballinst}
 */ var locale = {
    code: 'id',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"iZvmM","./_lib/formatLong/index.js":"3lfu3","./_lib/formatRelative/index.js":"7pvG0","./_lib/localize/index.js":"9W2LW","./_lib/match/index.js":"2ZdNK","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"iZvmM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'kurang dari 1 detik',
        other: 'kurang dari {{count}} detik'
    },
    xSeconds: {
        one: '1 detik',
        other: '{{count}} detik'
    },
    halfAMinute: 'setengah menit',
    lessThanXMinutes: {
        one: 'kurang dari 1 menit',
        other: 'kurang dari {{count}} menit'
    },
    xMinutes: {
        one: '1 menit',
        other: '{{count}} menit'
    },
    aboutXHours: {
        one: 'sekitar 1 jam',
        other: 'sekitar {{count}} jam'
    },
    xHours: {
        one: '1 jam',
        other: '{{count}} jam'
    },
    xDays: {
        one: '1 hari',
        other: '{{count}} hari'
    },
    aboutXWeeks: {
        one: 'sekitar 1 minggu',
        other: 'sekitar {{count}} minggu'
    },
    xWeeks: {
        one: '1 minggu',
        other: '{{count}} minggu'
    },
    aboutXMonths: {
        one: 'sekitar 1 bulan',
        other: 'sekitar {{count}} bulan'
    },
    xMonths: {
        one: '1 bulan',
        other: '{{count}} bulan'
    },
    aboutXYears: {
        one: 'sekitar 1 tahun',
        other: 'sekitar {{count}} tahun'
    },
    xYears: {
        one: '1 tahun',
        other: '{{count}} tahun'
    },
    overXYears: {
        one: 'lebih dari 1 tahun',
        other: 'lebih dari {{count}} tahun'
    },
    almostXYears: {
        one: 'hampir 1 tahun',
        other: 'hampir {{count}} tahun'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'dalam waktu ' + result;
        else return result + ' yang lalu';
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3lfu3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'd/M/yyyy'
};
var timeFormats = {
    full: 'HH.mm.ss',
    long: 'HH.mm.ss',
    medium: 'HH.mm',
    short: 'HH.mm'
};
var dateTimeFormats = {
    full: "{{date}} 'pukul' {{time}}",
    long: "{{date}} 'pukul' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7pvG0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "eeee 'lalu pukul' p",
    yesterday: "'Kemarin pukul' p",
    today: "'Hari ini pukul' p",
    tomorrow: "'Besok pukul' p",
    nextWeek: "eeee 'pukul' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"9W2LW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js"); // All data for localization are taken from this page
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
// https://www.unicode.org/cldr/charts/32/summary/id.html
var eraValues = {
    narrow: [
        'SM',
        'M'
    ],
    abbreviated: [
        'SM',
        'M'
    ],
    wide: [
        'Sebelum Masehi',
        'Masehi'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        'Kuartal ke-1',
        'Kuartal ke-2',
        'Kuartal ke-3',
        'Kuartal ke-4'
    ]
};
// Note: in Indonesian, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'Mei',
        'Jun',
        'Jul',
        'Agt',
        'Sep',
        'Okt',
        'Nov',
        'Des'
    ],
    wide: [
        'Januari',
        'Februari',
        'Maret',
        'April',
        'Mei',
        'Juni',
        'Juli',
        'Agustus',
        'September',
        'Oktober',
        'November',
        'Desember'
    ]
};
var dayValues = {
    narrow: [
        'M',
        'S',
        'S',
        'R',
        'K',
        'J',
        'S'
    ],
    short: [
        'Min',
        'Sen',
        'Sel',
        'Rab',
        'Kam',
        'Jum',
        'Sab'
    ],
    abbreviated: [
        'Min',
        'Sen',
        'Sel',
        'Rab',
        'Kam',
        'Jum',
        'Sab'
    ],
    wide: [
        'Minggu',
        'Senin',
        'Selasa',
        'Rabu',
        'Kamis',
        'Jumat',
        'Sabtu'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'siang',
        evening: 'sore',
        night: 'malam'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'siang',
        evening: 'sore',
        night: 'malam'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'siang',
        evening: 'sore',
        night: 'malam'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'siang',
        evening: 'sore',
        night: 'malam'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'siang',
        evening: 'sore',
        night: 'malam'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'siang',
        evening: 'sore',
        night: 'malam'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // Can't use "pertama", "kedua" because can't be parsed
    return 'ke-' + number;
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2ZdNK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^ke-(\d+)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(sm|m)/i,
    abbreviated: /^(s\.?\s?m\.?|s\.?\s?e\.?\s?u\.?|m\.?|e\.?\s?u\.?)/i,
    wide: /^(sebelum masehi|sebelum era umum|masehi|era umum)/i
};
var parseEraPatterns = {
    any: [
        /^s/i,
        /^(m|e)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K-?\s[1234]/i,
    wide: /^Kuartal ke-?\s?[1234]/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|mei|jun|jul|agt|sep|okt|nov|des)/i,
    wide: /^(januari|februari|maret|april|mei|juni|juli|agustus|september|oktober|november|desember)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^ma/i,
        /^ap/i,
        /^me/i,
        /^jun/i,
        /^jul/i,
        /^ag/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[srkjm]/i,
    short: /^(min|sen|sel|rab|kam|jum|sab)/i,
    abbreviated: /^(min|sen|sel|rab|kam|jum|sab)/i,
    wide: /^(minggu|senin|selasa|rabu|kamis|jumat|sabtu)/i
};
var parseDayPatterns = {
    narrow: [
        /^m/i,
        /^s/i,
        /^s/i,
        /^r/i,
        /^k/i,
        /^j/i,
        /^s/i
    ],
    any: [
        /^m/i,
        /^sen/i,
        /^sel/i,
        /^r/i,
        /^k/i,
        /^j/i,
        /^sa/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|tengah m|tengah h|(di(\swaktu)?) (pagi|siang|sore|malam))/i,
    any: /^([ap]\.?\s?m\.?|tengah malam|tengah hari|(di(\swaktu)?) (pagi|siang|sore|malam))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^pm/i,
        midnight: /^tengah m/i,
        noon: /^tengah h/i,
        morning: /pagi/i,
        afternoon: /siang/i,
        evening: /sore/i,
        night: /malam/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"heYJa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Icelandic locale.
 * @language Icelandic
 * @iso-639-2 isl
 * @author Derek Blank [@derekblank]{@link https://github.com/derekblank}
 * @author Arnór Ýmir [@lamayg]{@link https://github.com/lamayg}
 */ var locale = {
    code: 'is',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"buHob","./_lib/formatLong/index.js":"6NzqB","./_lib/formatRelative/index.js":"786yG","./_lib/localize/index.js":"9RDib","./_lib/match/index.js":"bHaDf","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"buHob":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "minna en 1 sek\xfanda",
        other: "minna en {{count}} sek\xfandur"
    },
    xSeconds: {
        one: "1 sek\xfanda",
        other: "{{count}} sek\xfandur"
    },
    halfAMinute: "h\xe1lf m\xedn\xfata",
    lessThanXMinutes: {
        one: "minna en 1 m\xedn\xfata",
        other: "minna en {{count}} m\xedn\xfatur"
    },
    xMinutes: {
        one: "1 m\xedn\xfata",
        other: "{{count}} m\xedn\xfatur"
    },
    aboutXHours: {
        one: "u.\xfe.b. 1 klukkustund",
        other: "u.\xfe.b. {{count}} klukkustundir"
    },
    xHours: {
        one: '1 klukkustund',
        other: '{{count}} klukkustundir'
    },
    xDays: {
        one: '1 dagur',
        other: '{{count}} dagar'
    },
    aboutXWeeks: {
        one: 'um viku',
        other: 'um {{count}} vikur'
    },
    xWeeks: {
        one: '1 viku',
        other: '{{count}} vikur'
    },
    aboutXMonths: {
        one: "u.\xfe.b. 1 m\xe1nu\xf0ur",
        other: "u.\xfe.b. {{count}} m\xe1nu\xf0ir"
    },
    xMonths: {
        one: "1 m\xe1nu\xf0ur",
        other: "{{count}} m\xe1nu\xf0ir"
    },
    aboutXYears: {
        one: "u.\xfe.b. 1 \xe1r",
        other: "u.\xfe.b. {{count}} \xe1r"
    },
    xYears: {
        one: "1 \xe1r",
        other: "{{count}} \xe1r"
    },
    overXYears: {
        one: "meira en 1 \xe1r",
        other: "meira en {{count}} \xe1r"
    },
    almostXYears: {
        one: "n\xe6stum 1 \xe1r",
        other: "n\xe6stum {{count}} \xe1r"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\xed " + result;
        else return result + " s\xed\xf0an";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6NzqB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, do MMMM y',
    long: 'do MMMM y',
    medium: 'do MMM y',
    short: 'd.MM.y'
};
var timeFormats = {
    full: "'kl'. HH:mm:ss zzzz",
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"786yG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'s\xed\xf0asta' dddd 'kl.' p",
    yesterday: "'\xed g\xe6r kl.' p",
    today: "'\xed dag kl.' p",
    tomorrow: "'\xe1 morgun kl.' p",
    nextWeek: "dddd 'kl.' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"9RDib":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'f.Kr.',
        'e.Kr.'
    ],
    abbreviated: [
        'f.Kr.',
        'e.Kr.'
    ],
    wide: [
        'fyrir Krist',
        'eftir Krist'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        '1F',
        '2F',
        '3F',
        '4F'
    ],
    wide: [
        "1. fj\xf3r\xf0ungur",
        "2. fj\xf3r\xf0ungur",
        "3. fj\xf3r\xf0ungur",
        "4. fj\xf3r\xf0ungur"
    ]
};
var monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        "\xc1",
        'S',
        "\xd3",
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mars',
        "apr\xedl",
        "ma\xed",
        "j\xfan\xed",
        "j\xfal\xed",
        "\xe1g\xfast",
        'sept.',
        'okt.',
        "n\xf3v.",
        'des.'
    ],
    wide: [
        "jan\xfaar",
        "febr\xfaar",
        'mars',
        "apr\xedl",
        "ma\xed",
        "j\xfan\xed",
        "j\xfal\xed",
        "\xe1g\xfast",
        'september',
        "okt\xf3ber",
        "n\xf3vember",
        'desember'
    ]
};
var dayValues = {
    narrow: [
        'S',
        'M',
        "\xde",
        'M',
        'F',
        'F',
        'L'
    ],
    short: [
        'Su',
        "M\xe1",
        "\xder",
        'Mi',
        'Fi',
        "F\xf6",
        'La'
    ],
    abbreviated: [
        'sun.',
        "m\xe1n.",
        "\xferi.",
        "mi\xf0.",
        'fim.',
        "f\xf6s.",
        'lau.'
    ],
    wide: [
        'sunnudagur',
        "m\xe1nudagur",
        "\xferi\xf0judagur",
        "mi\xf0vikudagur",
        'fimmtudagur',
        "f\xf6studagur",
        'laugardagur'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'f',
        pm: 'e',
        midnight: "mi\xf0n\xe6tti",
        noon: "h\xe1degi",
        morning: 'morgunn',
        afternoon: "s\xed\xf0degi",
        evening: "kv\xf6ld",
        night: "n\xf3tt"
    },
    abbreviated: {
        am: 'f.h.',
        pm: 'e.h.',
        midnight: "mi\xf0n\xe6tti",
        noon: "h\xe1degi",
        morning: 'morgunn',
        afternoon: "s\xed\xf0degi",
        evening: "kv\xf6ld",
        night: "n\xf3tt"
    },
    wide: {
        am: "fyrir h\xe1degi",
        pm: "eftir h\xe1degi",
        midnight: "mi\xf0n\xe6tti",
        noon: "h\xe1degi",
        morning: 'morgunn',
        afternoon: "s\xed\xf0degi",
        evening: "kv\xf6ld",
        night: "n\xf3tt"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'f',
        pm: 'e',
        midnight: "\xe1 mi\xf0n\xe6tti",
        noon: "\xe1 h\xe1degi",
        morning: "a\xf0 morgni",
        afternoon: "s\xed\xf0degis",
        evening: "um kv\xf6ld",
        night: "um n\xf3tt"
    },
    abbreviated: {
        am: 'f.h.',
        pm: 'e.h.',
        midnight: "\xe1 mi\xf0n\xe6tti",
        noon: "\xe1 h\xe1degi",
        morning: "a\xf0 morgni",
        afternoon: "s\xed\xf0degis",
        evening: "um kv\xf6ld",
        night: "um n\xf3tt"
    },
    wide: {
        am: "fyrir h\xe1degi",
        pm: "eftir h\xe1degi",
        midnight: "\xe1 mi\xf0n\xe6tti",
        noon: "\xe1 h\xe1degi",
        morning: "a\xf0 morgni",
        afternoon: "s\xed\xf0degis",
        evening: "um kv\xf6ld",
        night: "um n\xf3tt"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"bHaDf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
var parseOrdinalNumberPattern = /\d+(\.)?/i;
var matchEraPatterns = {
    narrow: /^(f\.Kr\.|e\.Kr\.)/i,
    abbreviated: /^(f\.Kr\.|e\.Kr\.)/i,
    wide: /^(fyrir Krist|eftir Krist)/i
};
var parseEraPatterns = {
    any: [
        /^(f\.Kr\.)/i,
        /^(e\.Kr\.)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]\.?/i,
    abbreviated: /^q[1234]\.?/i,
    wide: /^[1234]\.? fjórðungur/i
};
var parseQuarterPatterns = {
    any: [
        /1\.?/i,
        /2\.?/i,
        /3\.?/i,
        /4\.?/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmásónd]/i,
    abbreviated: /^(jan\.|feb\.|mars\.|apríl\.|maí|júní|júlí|águst|sep\.|oct\.|nov\.|dec\.)/i,
    wide: /^(januar|febrúar|mars|apríl|maí|júní|júlí|águst|september|október|nóvember|desember)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^á/i,
        /^s/i,
        /^ó/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maí/i,
        /^jún/i,
        /^júl/i,
        /^áu/i,
        /^s/i,
        /^ó/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|má|þr|mi|fi|fö|la)/i,
    abbreviated: /^(sun|mán|þri|mið|fim|fös|lau)\.?/i,
    wide: /^(sunnudagur|mánudagur|þriðjudagur|miðvikudagur|fimmtudagur|föstudagur|laugardagur)/i
};
var parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^þ/i,
        /^m/i,
        /^f/i,
        /^f/i,
        /^l/i
    ],
    any: [
        /^su/i,
        /^má/i,
        /^þr/i,
        /^mi/i,
        /^fi/i,
        /^fö/i,
        /^la/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(f|e|síðdegis|(á|að|um) (morgni|kvöld|nótt|miðnætti))/i,
    any: /^(fyrir hádegi|eftir hádegi|[ef]\.?h\.?|síðdegis|morgunn|(á|að|um) (morgni|kvöld|nótt|miðnætti))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^f/i,
        pm: /^e/i,
        midnight: /^mi/i,
        noon: /^há/i,
        morning: /morgunn/i,
        afternoon: /síðdegi/i,
        evening: /kvöld/i,
        night: /nótt/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"b9Hvo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Italian locale.
 * @language Italian
 * @iso-639-2 ita
 * @author Alberto Restifo [@albertorestifo]{@link https://github.com/albertorestifo}
 * @author Giovanni Polimeni [@giofilo]{@link https://github.com/giofilo}
 * @author Vincenzo Carrese [@vin-car]{@link https://github.com/vin-car}
 */ var locale = {
    code: 'it',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"ehMPH","./_lib/formatLong/index.js":"3EKzK","./_lib/formatRelative/index.js":"2t0d8","./_lib/localize/index.js":"cS0EO","./_lib/match/index.js":"3VoDy","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"ehMPH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'meno di un secondo',
        other: 'meno di {{count}} secondi'
    },
    xSeconds: {
        one: 'un secondo',
        other: '{{count}} secondi'
    },
    halfAMinute: 'alcuni secondi',
    lessThanXMinutes: {
        one: 'meno di un minuto',
        other: 'meno di {{count}} minuti'
    },
    xMinutes: {
        one: 'un minuto',
        other: '{{count}} minuti'
    },
    aboutXHours: {
        one: "circa un'ora",
        other: 'circa {{count}} ore'
    },
    xHours: {
        one: "un'ora",
        other: '{{count}} ore'
    },
    xDays: {
        one: 'un giorno',
        other: '{{count}} giorni'
    },
    aboutXWeeks: {
        one: 'circa una settimana',
        other: 'circa {{count}} settimane'
    },
    xWeeks: {
        one: 'una settimana',
        other: '{{count}} settimane'
    },
    aboutXMonths: {
        one: 'circa un mese',
        other: 'circa {{count}} mesi'
    },
    xMonths: {
        one: 'un mese',
        other: '{{count}} mesi'
    },
    aboutXYears: {
        one: 'circa un anno',
        other: 'circa {{count}} anni'
    },
    xYears: {
        one: 'un anno',
        other: '{{count}} anni'
    },
    overXYears: {
        one: "pi\xf9 di un anno",
        other: "pi\xf9 di {{count}} anni"
    },
    almostXYears: {
        one: 'quasi un anno',
        other: 'quasi {{count}} anni'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'tra ' + result;
        else return result + ' fa';
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3EKzK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd/MM/y'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2t0d8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../../_lib/isSameUTCWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var weekdays = [
    'domenica',
    "luned\xec",
    "marted\xec",
    "mercoled\xec",
    "gioved\xec",
    "venerd\xec",
    'sabato'
];
function _lastWeek(day) {
    switch(day){
        case 0:
            return "'domenica scorsa alle' p";
        default:
            return "'" + weekdays[day] + " scorso alle' p";
    }
}
function thisWeek(day) {
    return "'" + weekdays[day] + " alle' p";
}
function _nextWeek(day) {
    switch(day){
        case 0:
            return "'domenica prossima alle' p";
        default:
            return "'" + weekdays[day] + " prossimo alle' p";
    }
}
var formatRelativeLocale = {
    lastWeek: function lastWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, _indexJsDefault.default)(date, baseDate, options)) return thisWeek(day);
        else return _lastWeek(day);
    },
    yesterday: "'ieri alle' p",
    today: "'oggi alle' p",
    tomorrow: "'domani alle' p",
    nextWeek: function nextWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, _indexJsDefault.default)(date, baseDate, options)) return thisWeek(day);
        else return _nextWeek(day);
    },
    other: 'P'
};
var formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
exports.default = formatRelative;

},{"../../../../_lib/isSameUTCWeek/index.js":"g7rCW","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"cS0EO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'aC',
        'dC'
    ],
    abbreviated: [
        'a.C.',
        'd.C.'
    ],
    wide: [
        'avanti Cristo',
        'dopo Cristo'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
var monthValues = {
    narrow: [
        'G',
        'F',
        'M',
        'A',
        'M',
        'G',
        'L',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'gen',
        'feb',
        'mar',
        'apr',
        'mag',
        'giu',
        'lug',
        'ago',
        'set',
        'ott',
        'nov',
        'dic'
    ],
    wide: [
        'gennaio',
        'febbraio',
        'marzo',
        'aprile',
        'maggio',
        'giugno',
        'luglio',
        'agosto',
        'settembre',
        'ottobre',
        'novembre',
        'dicembre'
    ]
};
var dayValues = {
    narrow: [
        'D',
        'L',
        'M',
        'M',
        'G',
        'V',
        'S'
    ],
    short: [
        'dom',
        'lun',
        'mar',
        'mer',
        'gio',
        'ven',
        'sab'
    ],
    abbreviated: [
        'dom',
        'lun',
        'mar',
        'mer',
        'gio',
        'ven',
        'sab'
    ],
    wide: [
        'domenica',
        "luned\xec",
        "marted\xec",
        "mercoled\xec",
        "gioved\xec",
        "venerd\xec",
        'sabato'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'm.',
        pm: 'p.',
        midnight: 'mezzanotte',
        noon: 'mezzogiorno',
        morning: 'mattina',
        afternoon: 'pomeriggio',
        evening: 'sera',
        night: 'notte'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'mezzanotte',
        noon: 'mezzogiorno',
        morning: 'mattina',
        afternoon: 'pomeriggio',
        evening: 'sera',
        night: 'notte'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'mezzanotte',
        noon: 'mezzogiorno',
        morning: 'mattina',
        afternoon: 'pomeriggio',
        evening: 'sera',
        night: 'notte'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'm.',
        pm: 'p.',
        midnight: 'mezzanotte',
        noon: 'mezzogiorno',
        morning: 'di mattina',
        afternoon: 'del pomeriggio',
        evening: 'di sera',
        night: 'di notte'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'mezzanotte',
        noon: 'mezzogiorno',
        morning: 'di mattina',
        afternoon: 'del pomeriggio',
        evening: 'di sera',
        night: 'di notte'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'mezzanotte',
        noon: 'mezzogiorno',
        morning: 'di mattina',
        afternoon: 'del pomeriggio',
        evening: 'di sera',
        night: 'di notte'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return String(number);
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3VoDy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(º)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(aC|dC)/i,
    abbreviated: /^(a\.?\s?C\.?|a\.?\s?e\.?\s?v\.?|d\.?\s?C\.?|e\.?\s?v\.?)/i,
    wide: /^(avanti Cristo|avanti Era Volgare|dopo Cristo|Era Volgare)/i
};
var parseEraPatterns = {
    any: [
        /^a/i,
        /^(d|e)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^t[1234]/i,
    wide: /^[1234](º)? trimestre/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[gfmalsond]/i,
    abbreviated: /^(gen|feb|mar|apr|mag|giu|lug|ago|set|ott|nov|dic)/i,
    wide: /^(gennaio|febbraio|marzo|aprile|maggio|giugno|luglio|agosto|settembre|ottobre|novembre|dicembre)/i
};
var parseMonthPatterns = {
    narrow: [
        /^g/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^g/i,
        /^l/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ge/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mag/i,
        /^gi/i,
        /^l/i,
        /^ag/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[dlmgvs]/i,
    short: /^(do|lu|ma|me|gi|ve|sa)/i,
    abbreviated: /^(dom|lun|mar|mer|gio|ven|sab)/i,
    wide: /^(domenica|luned[i|ì]|marted[i|ì]|mercoled[i|ì]|gioved[i|ì]|venerd[i|ì]|sabato)/i
};
var parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^g/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^l/i,
        /^ma/i,
        /^me/i,
        /^g/i,
        /^v/i,
        /^s/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|m\.|p|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i,
    any: /^([ap]\.?\s?m\.?|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mezza/i,
        noon: /^mezzo/i,
        morning: /mattina/i,
        afternoon: /pomeriggio/i,
        evening: /sera/i,
        night: /notte/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"9vfl3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../it/_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../it/_lib/formatRelative/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../it/_lib/localize/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../it/_lib/match/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/formatLong/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Italian locale (Switzerland).
 * @language Italian
 * @iso-639-2 ita
 * @author Mike Peyer [@maic66]{@link https://github.com/maic66}
 */ var locale = {
    code: 'it-CH',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault4.default),
    formatRelative: (0, _indexJsDefault1.default),
    localize: (0, _indexJsDefault2.default),
    match: (0, _indexJsDefault3.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"../it/_lib/formatDistance/index.js":"ehMPH","../it/_lib/formatRelative/index.js":"2t0d8","../it/_lib/localize/index.js":"cS0EO","../it/_lib/match/index.js":"3VoDy","./_lib/formatLong/index.js":"2sFbu","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2sFbu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd.MM.y'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"23QwZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Japanese locale.
 * @language Japanese
 * @iso-639-2 jpn
 * @author Thomas Eilmsteiner [@DeMuu]{@link https://github.com/DeMuu}
 * @author Yamagishi Kazutoshi [@ykzts]{@link https://github.com/ykzts}
 * @author Luca Ban [@mesqueeb]{@link https://github.com/mesqueeb}
 * @author Terrence Lam [@skyuplam]{@link https://github.com/skyuplam}
 * @author Taiki IKeda [@so99ynoodles]{@link https://github.com/so99ynoodles}
 */ var locale = {
    code: 'ja',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"9BfDs","./_lib/formatLong/index.js":"gTPCF","./_lib/formatRelative/index.js":"l7ybc","./_lib/localize/index.js":"aGONB","./_lib/match/index.js":"jBH9U","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"9BfDs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "1\u79D2\u672A\u6E80",
        other: "{{count}}\u79D2\u672A\u6E80",
        oneWithSuffix: "\u7D041\u79D2",
        otherWithSuffix: "\u7D04{{count}}\u79D2"
    },
    xSeconds: {
        one: "1\u79D2",
        other: "{{count}}\u79D2"
    },
    halfAMinute: "30\u79D2",
    lessThanXMinutes: {
        one: "1\u5206\u672A\u6E80",
        other: "{{count}}\u5206\u672A\u6E80",
        oneWithSuffix: "\u7D041\u5206",
        otherWithSuffix: "\u7D04{{count}}\u5206"
    },
    xMinutes: {
        one: "1\u5206",
        other: "{{count}}\u5206"
    },
    aboutXHours: {
        one: "\u7D041\u6642\u9593",
        other: "\u7D04{{count}}\u6642\u9593"
    },
    xHours: {
        one: "1\u6642\u9593",
        other: "{{count}}\u6642\u9593"
    },
    xDays: {
        one: "1\u65E5",
        other: "{{count}}\u65E5"
    },
    aboutXWeeks: {
        one: "\u7D041\u9031\u9593",
        other: "\u7D04{{count}}\u9031\u9593"
    },
    xWeeks: {
        one: "1\u9031\u9593",
        other: "{{count}}\u9031\u9593"
    },
    aboutXMonths: {
        one: "\u7D041\u304B\u6708",
        other: "\u7D04{{count}}\u304B\u6708"
    },
    xMonths: {
        one: "1\u304B\u6708",
        other: "{{count}}\u304B\u6708"
    },
    aboutXYears: {
        one: "\u7D041\u5E74",
        other: "\u7D04{{count}}\u5E74"
    },
    xYears: {
        one: "1\u5E74",
        other: "{{count}}\u5E74"
    },
    overXYears: {
        one: "1\u5E74\u4EE5\u4E0A",
        other: "{{count}}\u5E74\u4EE5\u4E0A"
    },
    almostXYears: {
        one: "1\u5E74\u8FD1\u304F",
        other: "{{count}}\u5E74\u8FD1\u304F"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    options = options || {};
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) {
        if (options.addSuffix && tokenValue.oneWithSuffix) result = tokenValue.oneWithSuffix;
        else result = tokenValue.one;
    } else if (options.addSuffix && tokenValue.otherWithSuffix) result = tokenValue.otherWithSuffix.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u5F8C";
        else return result + "\u524D";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gTPCF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "y\u5E74M\u6708d\u65E5EEEE",
    long: "y\u5E74M\u6708d\u65E5",
    medium: 'y/MM/dd',
    short: 'y/MM/dd'
};
var timeFormats = {
    full: "H\u6642mm\u5206ss\u79D2 zzzz",
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"l7ybc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "\u5148\u9031\u306Eeeee\u306Ep",
    yesterday: "\u6628\u65E5\u306Ep",
    today: "\u4ECA\u65E5\u306Ep",
    tomorrow: "\u660E\u65E5\u306Ep",
    nextWeek: "\u7FCC\u9031\u306Eeeee\u306Ep",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"aGONB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'BC',
        'AC'
    ],
    abbreviated: [
        "\u7D00\u5143\u524D",
        "\u897F\u66A6"
    ],
    wide: [
        "\u7D00\u5143\u524D",
        "\u897F\u66A6"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "\u7B2C1\u56DB\u534A\u671F",
        "\u7B2C2\u56DB\u534A\u671F",
        "\u7B2C3\u56DB\u534A\u671F",
        "\u7B2C4\u56DB\u534A\u671F"
    ]
};
var monthValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10',
        '11',
        '12'
    ],
    abbreviated: [
        "1\u6708",
        "2\u6708",
        "3\u6708",
        "4\u6708",
        "5\u6708",
        "6\u6708",
        "7\u6708",
        "8\u6708",
        "9\u6708",
        "10\u6708",
        "11\u6708",
        "12\u6708"
    ],
    wide: [
        "1\u6708",
        "2\u6708",
        "3\u6708",
        "4\u6708",
        "5\u6708",
        "6\u6708",
        "7\u6708",
        "8\u6708",
        "9\u6708",
        "10\u6708",
        "11\u6708",
        "12\u6708"
    ]
};
var dayValues = {
    narrow: [
        "\u65E5",
        "\u6708",
        "\u706B",
        "\u6C34",
        "\u6728",
        "\u91D1",
        "\u571F"
    ],
    short: [
        "\u65E5",
        "\u6708",
        "\u706B",
        "\u6C34",
        "\u6728",
        "\u91D1",
        "\u571F"
    ],
    abbreviated: [
        "\u65E5",
        "\u6708",
        "\u706B",
        "\u6C34",
        "\u6728",
        "\u91D1",
        "\u571F"
    ],
    wide: [
        "\u65E5\u66DC\u65E5",
        "\u6708\u66DC\u65E5",
        "\u706B\u66DC\u65E5",
        "\u6C34\u66DC\u65E5",
        "\u6728\u66DC\u65E5",
        "\u91D1\u66DC\u65E5",
        "\u571F\u66DC\u65E5"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    },
    abbreviated: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    },
    wide: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    },
    abbreviated: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    },
    wide: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = String(options === null || options === void 0 ? void 0 : options.unit);
    switch(unit){
        case 'year':
            return "".concat(number, "\u5E74");
        case 'quarter':
            return "\u7B2C".concat(number, "\u56DB\u534A\u671F");
        case 'month':
            return "".concat(number, "\u6708");
        case 'week':
            return "\u7B2C".concat(number, "\u9031");
        case 'date':
            return "".concat(number, "\u65E5");
        case 'hour':
            return "".concat(number, "\u6642");
        case 'minute':
            return "".concat(number, "\u5206");
        case 'second':
            return "".concat(number, "\u79D2");
        default:
            return "".concat(number);
    }
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jBH9U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^第?\d+(年|四半期|月|週|日|時|分|秒)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(B\.?C\.?|A\.?D\.?)/i,
    abbreviated: /^(紀元[前後]|西暦)/i,
    wide: /^(紀元[前後]|西暦)/i
};
var parseEraPatterns = {
    narrow: [
        /^B/i,
        /^A/i
    ],
    any: [
        /^(紀元前)/i,
        /^(西暦|紀元後)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^Q[1234]/i,
    wide: /^第[1234一二三四１２３４]四半期/i
};
var parseQuarterPatterns = {
    any: [
        /(1|一|１)/i,
        /(2|二|２)/i,
        /(3|三|３)/i,
        /(4|四|４)/i
    ]
};
var matchMonthPatterns = {
    narrow: /^([123456789]|1[012])/,
    abbreviated: /^([123456789]|1[012])月/i,
    wide: /^([123456789]|1[012])月/i
};
var parseMonthPatterns = {
    any: [
        /^1\D/,
        /^2/,
        /^3/,
        /^4/,
        /^5/,
        /^6/,
        /^7/,
        /^8/,
        /^9/,
        /^10/,
        /^11/,
        /^12/
    ]
};
var matchDayPatterns = {
    narrow: /^[日月火水木金土]/,
    short: /^[日月火水木金土]/,
    abbreviated: /^[日月火水木金土]/,
    wide: /^[日月火水木金土]曜日/
};
var parseDayPatterns = {
    any: [
        /^日/,
        /^月/,
        /^火/,
        /^水/,
        /^木/,
        /^金/,
        /^土/
    ]
};
var matchDayPeriodPatterns = {
    any: /^(AM|PM|午前|午後|正午|深夜|真夜中|夜|朝)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^(A|午前)/i,
        pm: /^(P|午後)/i,
        midnight: /^深夜|真夜中/i,
        noon: /^正午/i,
        morning: /^朝/i,
        afternoon: /^午後/i,
        evening: /^夜/i,
        night: /^深夜/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault1.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault1.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault1.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault1.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault1.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchPatternFn/index.js":"2Mexa","../../../_lib/buildMatchFn/index.js":"7YCyk","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2XoVR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Japanese (Hiragana) locale.
 * @language Japanese (Hiragana)
 * @iso-639-2 jpn
 * @author Eri Hiramatsu [@Eritutteo]{@link https://github.com/Eritutteo}
 */ var locale = {
    code: 'ja-Hira',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"c8vFN","./_lib/formatLong/index.js":"hoLPQ","./_lib/formatRelative/index.js":"bVjTG","./_lib/localize/index.js":"i3czA","./_lib/match/index.js":"29Quw","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"c8vFN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "1\u3073\u3087\u3046\u307F\u307E\u3093",
        other: "{{count}}\u3073\u3087\u3046\u307F\u307E\u3093",
        oneWithSuffix: "\u3084\u304F1\u3073\u3087\u3046",
        otherWithSuffix: "\u3084\u304F{{count}}\u3073\u3087\u3046"
    },
    xSeconds: {
        one: "1\u3073\u3087\u3046",
        other: "{{count}}\u3073\u3087\u3046"
    },
    halfAMinute: "30\u3073\u3087\u3046",
    lessThanXMinutes: {
        one: "1\u3077\u3093\u307F\u307E\u3093",
        other: "{{count}}\u3075\u3093\u307F\u307E\u3093",
        oneWithSuffix: "\u3084\u304F1\u3077\u3093",
        otherWithSuffix: "\u3084\u304F{{count}}\u3075\u3093"
    },
    xMinutes: {
        one: "1\u3077\u3093",
        other: "{{count}}\u3075\u3093"
    },
    aboutXHours: {
        one: "\u3084\u304F1\u3058\u304B\u3093",
        other: "\u3084\u304F{{count}}\u3058\u304B\u3093"
    },
    xHours: {
        one: "1\u3058\u304B\u3093",
        other: "{{count}}\u3058\u304B\u3093"
    },
    xDays: {
        one: "1\u306B\u3061",
        other: "{{count}}\u306B\u3061"
    },
    aboutXWeeks: {
        one: "\u3084\u304F1\u3057\u3085\u3046\u304B\u3093",
        other: "\u3084\u304F{{count}}\u3057\u3085\u3046\u304B\u3093"
    },
    xWeeks: {
        one: "1\u3057\u3085\u3046\u304B\u3093",
        other: "{{count}}\u3057\u3085\u3046\u304B\u3093"
    },
    aboutXMonths: {
        one: "\u3084\u304F1\u304B\u3052\u3064",
        other: "\u3084\u304F{{count}}\u304B\u3052\u3064"
    },
    xMonths: {
        one: "1\u304B\u3052\u3064",
        other: "{{count}}\u304B\u3052\u3064"
    },
    aboutXYears: {
        one: "\u3084\u304F1\u306D\u3093",
        other: "\u3084\u304F{{count}}\u306D\u3093"
    },
    xYears: {
        one: "1\u306D\u3093",
        other: "{{count}}\u306D\u3093"
    },
    overXYears: {
        one: "1\u306D\u3093\u3044\u3058\u3087\u3046",
        other: "{{count}}\u306D\u3093\u3044\u3058\u3087\u3046"
    },
    almostXYears: {
        one: "1\u306D\u3093\u3061\u304B\u304F",
        other: "{{count}}\u306D\u3093\u3061\u304B\u304F"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    options = options || {};
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) {
        if (options.addSuffix && tokenValue.oneWithSuffix) result = tokenValue.oneWithSuffix;
        else result = tokenValue.one;
    } else if (options.addSuffix && tokenValue.otherWithSuffix) result = tokenValue.otherWithSuffix.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u3042\u3068";
        else return result + "\u307E\u3048";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"hoLPQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "y\u306D\u3093M\u304C\u3064d\u306B\u3061EEEE",
    long: "y\u306D\u3093M\u304C\u3064d\u306B\u3061",
    medium: 'y/MM/dd',
    short: 'y/MM/dd'
};
var timeFormats = {
    full: "H\u3058mm\u3075\u3093ss\u3073\u3087\u3046 zzzz",
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"bVjTG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "\u305B\u3093\u3057\u3085\u3046\u306Eeeee\u306Ep",
    yesterday: "\u304D\u306E\u3046\u306Ep",
    today: "\u304D\u3087\u3046\u306Ep",
    tomorrow: "\u3042\u3057\u305F\u306Ep",
    nextWeek: "\u3088\u304F\u3057\u3085\u3046\u306Eeeee\u306Ep",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"i3czA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'BC',
        'AC'
    ],
    abbreviated: [
        "\u304D\u3052\u3093\u305C\u3093",
        "\u305B\u3044\u308C\u304D"
    ],
    wide: [
        "\u304D\u3052\u3093\u305C\u3093",
        "\u305B\u3044\u308C\u304D"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "\u3060\u30441\u3057\u306F\u3093\u304D",
        "\u3060\u30442\u3057\u306F\u3093\u304D",
        "\u3060\u30443\u3057\u306F\u3093\u304D",
        "\u3060\u30444\u3057\u306F\u3093\u304D"
    ]
};
var monthValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10',
        '11',
        '12'
    ],
    abbreviated: [
        "1\u304C\u3064",
        "2\u304C\u3064",
        "3\u304C\u3064",
        "4\u304C\u3064",
        "5\u304C\u3064",
        "6\u304C\u3064",
        "7\u304C\u3064",
        "8\u304C\u3064",
        "9\u304C\u3064",
        "10\u304C\u3064",
        "11\u304C\u3064",
        "12\u304C\u3064"
    ],
    wide: [
        "1\u304C\u3064",
        "2\u304C\u3064",
        "3\u304C\u3064",
        "4\u304C\u3064",
        "5\u304C\u3064",
        "6\u304C\u3064",
        "7\u304C\u3064",
        "8\u304C\u3064",
        "9\u304C\u3064",
        "10\u304C\u3064",
        "11\u304C\u3064",
        "12\u304C\u3064"
    ]
};
var dayValues = {
    narrow: [
        "\u306B\u3061",
        "\u3052\u3064",
        "\u304B",
        "\u3059\u3044",
        "\u3082\u304F",
        "\u304D\u3093",
        "\u3069"
    ],
    short: [
        "\u306B\u3061",
        "\u3052\u3064",
        "\u304B",
        "\u3059\u3044",
        "\u3082\u304F",
        "\u304D\u3093",
        "\u3069"
    ],
    abbreviated: [
        "\u306B\u3061",
        "\u3052\u3064",
        "\u304B",
        "\u3059\u3044",
        "\u3082\u304F",
        "\u304D\u3093",
        "\u3069"
    ],
    wide: [
        "\u306B\u3061\u3088\u3046\u3073",
        "\u3052\u3064\u3088\u3046\u3073",
        "\u304B\u3088\u3046\u3073",
        "\u3059\u3044\u3088\u3046\u3073",
        "\u3082\u304F\u3088\u3046\u3073",
        "\u304D\u3093\u3088\u3046\u3073",
        "\u3069\u3088\u3046\u3073"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
    },
    abbreviated: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
    },
    wide: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
    },
    abbreviated: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
    },
    wide: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = String(options === null || options === void 0 ? void 0 : options.unit);
    switch(unit){
        case 'year':
            return "".concat(number, "\u306D\u3093");
        case 'quarter':
            return "\u3060\u3044".concat(number, "\u3057\u306F\u3093\u304D");
        case 'month':
            return "".concat(number, "\u304C\u3064");
        case 'week':
            return "\u3060\u3044".concat(number, "\u3057\u3085\u3046");
        case 'date':
            return "".concat(number, "\u306B\u3061");
        case 'hour':
            return "".concat(number, "\u3058");
        case 'minute':
            return "".concat(number, "\u3075\u3093");
        case 'second':
            return "".concat(number, "\u3073\u3087\u3046");
        default:
            return "".concat(number);
    }
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"29Quw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^だ?い?\d+(ねん|しはんき|がつ|しゅう|にち|じ|ふん|びょう)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(B\.?C\.?|A\.?D\.?)/i,
    abbreviated: /^(きげん[前後]|せいれき)/i,
    wide: /^(きげん[前後]|せいれき)/i
};
var parseEraPatterns = {
    narrow: [
        /^B/i,
        /^A/i
    ],
    any: [
        /^(きげんぜん)/i,
        /^(せいれき|きげんご)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^Q[1234]/i,
    wide: /^だい[1234一二三四１２３４]しはんき/i
};
var parseQuarterPatterns = {
    any: [
        /(1|一|１)/i,
        /(2|二|２)/i,
        /(3|三|３)/i,
        /(4|四|４)/i
    ]
};
var matchMonthPatterns = {
    narrow: /^([123456789]|1[012])/,
    abbreviated: /^([123456789]|1[012])がつ/i,
    wide: /^([123456789]|1[012])がつ/i
};
var parseMonthPatterns = {
    any: [
        /^1\D/,
        /^2/,
        /^3/,
        /^4/,
        /^5/,
        /^6/,
        /^7/,
        /^8/,
        /^9/,
        /^10/,
        /^11/,
        /^12/
    ]
};
var matchDayPatterns = {
    narrow: /^(にち|げつ|か|すい|もく|きん|ど)/,
    short: /^(にち|げつ|か|すい|もく|きん|ど)/,
    abbreviated: /^(にち|げつ|か|すい|もく|きん|ど)/,
    wide: /^(にち|げつ|か|すい|もく|きん|ど)ようび/
};
var parseDayPatterns = {
    any: [
        /^にち/,
        /^げつ/,
        /^か/,
        /^すい/,
        /^もく/,
        /^きん/,
        /^ど/
    ]
};
var matchDayPeriodPatterns = {
    any: /^(AM|PM|ごぜん|ごご|しょうご|しんや|まよなか|よる|あさ)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^(A|ごぜん)/i,
        pm: /^(P|ごご)/i,
        midnight: /^しんや|まよなか/i,
        noon: /^しょうご/i,
        morning: /^あさ/i,
        afternoon: /^ごご/i,
        evening: /^よる/i,
        night: /^しんや/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"lCXTq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Georgian locale.
 * @language Georgian
 * @iso-639-2 geo
 * @author Lado Lomidze [@Landish]{@link https://github.com/Landish}
 * @author Nick Shvelidze [@shvelo]{@link https://github.com/shvelo}
 */ var locale = {
    code: 'ka',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"gO5ny","./_lib/formatLong/index.js":"atNeA","./_lib/formatRelative/index.js":"chg5c","./_lib/localize/index.js":"5BEv8","./_lib/match/index.js":"heg0f","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gO5ny":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        past: "{{count}} \u10EC\u10D0\u10DB\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10D8 \u10EE\u10DC\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10D0\u10DB\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10D8",
        future: "{{count}} \u10EC\u10D0\u10DB\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10E8\u10D8"
    },
    xSeconds: {
        past: "{{count}} \u10EC\u10D0\u10DB\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10D0\u10DB\u10D8",
        future: "{{count}} \u10EC\u10D0\u10DB\u10E8\u10D8"
    },
    halfAMinute: {
        past: "\u10DC\u10D0\u10EE\u10D4\u10D5\u10D0\u10E0\u10D8 \u10EC\u10E3\u10D7\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10DC\u10D0\u10EE\u10D4\u10D5\u10D0\u10E0\u10D8 \u10EC\u10E3\u10D7\u10D8",
        future: "\u10DC\u10D0\u10EE\u10D4\u10D5\u10D0\u10E0\u10D8 \u10EC\u10E3\u10D7\u10E8\u10D8"
    },
    lessThanXMinutes: {
        past: "{{count}} \u10EC\u10E3\u10D7\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10D8 \u10EE\u10DC\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10E3\u10D7\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10D8",
        future: "{{count}} \u10EC\u10E3\u10D7\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10E8\u10D8"
    },
    xMinutes: {
        past: "{{count}} \u10EC\u10E3\u10D7\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10E3\u10D7\u10D8",
        future: "{{count}} \u10EC\u10E3\u10D7\u10E8\u10D8"
    },
    aboutXHours: {
        past: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10E1\u10D0\u10D0\u10D7\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10E1\u10D0\u10D0\u10D7\u10D8",
        future: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10E1\u10D0\u10D0\u10D7\u10E8\u10D8"
    },
    xHours: {
        past: "{{count}} \u10E1\u10D0\u10D0\u10D7\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10E1\u10D0\u10D0\u10D7\u10D8",
        future: "{{count}} \u10E1\u10D0\u10D0\u10D7\u10E8\u10D8"
    },
    xDays: {
        past: "{{count}} \u10D3\u10E6\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10D3\u10E6\u10D4",
        future: "{{count}} \u10D3\u10E6\u10D4\u10E8\u10D8"
    },
    aboutXWeeks: {
        past: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D9\u10D5\u10D8\u10E0\u10D0\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D9\u10D5\u10D8\u10E0\u10D0",
        future: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D9\u10D5\u10D8\u10E0\u10D0\u10E8\u10D8"
    },
    xWeeks: {
        past: "{{count}} \u10D9\u10D5\u10D8\u10E0\u10D0\u10E1 \u10D9\u10D5\u10D8\u10E0\u10D0",
        present: "{{count}} \u10D9\u10D5\u10D8\u10E0\u10D0",
        future: "{{count}} \u10D9\u10D5\u10D8\u10E0\u10D0\u10E8\u10D8"
    },
    aboutXMonths: {
        past: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D7\u10D5\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D7\u10D5\u10D4",
        future: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D7\u10D5\u10D4\u10E8\u10D8"
    },
    xMonths: {
        past: "{{count}} \u10D7\u10D5\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10D7\u10D5\u10D4",
        future: "{{count}} \u10D7\u10D5\u10D4\u10E8\u10D8"
    },
    aboutXYears: {
        past: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10EC\u10DA\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10EC\u10D4\u10DA\u10D8",
        future: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10EC\u10D4\u10DA\u10E8\u10D8"
    },
    xYears: {
        past: "{{count}} \u10EC\u10DA\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10D4\u10DA\u10D8",
        future: "{{count}} \u10EC\u10D4\u10DA\u10E8\u10D8"
    },
    overXYears: {
        past: "{{count}} \u10EC\u10D4\u10DA\u10D6\u10D4 \u10DB\u10D4\u10E2\u10D8 \u10EE\u10DC\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10D4\u10DA\u10D6\u10D4 \u10DB\u10D4\u10E2\u10D8",
        future: "{{count}} \u10EC\u10D4\u10DA\u10D6\u10D4 \u10DB\u10D4\u10E2\u10D8 \u10EE\u10DC\u10D8\u10E1 \u10E8\u10D4\u10DB\u10D3\u10D4\u10D2"
    },
    almostXYears: {
        past: "\u10D7\u10D8\u10D7\u10E5\u10DB\u10D8\u10E1 {{count}} \u10EC\u10DA\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10D7\u10D8\u10D7\u10E5\u10DB\u10D8\u10E1 {{count}} \u10EC\u10D4\u10DA\u10D8",
        future: "\u10D7\u10D8\u10D7\u10E5\u10DB\u10D8\u10E1 {{count}} \u10EC\u10D4\u10DA\u10E8\u10D8"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (options !== null && options !== void 0 && options.addSuffix && options.comparison && options.comparison > 0) result = tokenValue.future.replace('{{count}}', String(count));
    else if (options !== null && options !== void 0 && options.addSuffix) result = tokenValue.past.replace('{{count}}', String(count));
    else result = tokenValue.present.replace('{{count}}', String(count));
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"atNeA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, do MMMM, y',
    long: 'do, MMMM, y',
    medium: 'd, MMM, y',
    short: 'dd/MM/yyyy'
};
var timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var dateTimeFormats = {
    full: "{{date}} {{time}}'-\u10D6\u10D4'",
    long: "{{date}} {{time}}'-\u10D6\u10D4'",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"chg5c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'\u10EC\u10D8\u10DC\u10D0' eeee p'-\u10D6\u10D4'",
    yesterday: "'\u10D2\u10E3\u10E8\u10D8\u10DC' p'-\u10D6\u10D4'",
    today: "'\u10D3\u10E6\u10D4\u10E1' p'-\u10D6\u10D4'",
    tomorrow: "'\u10EE\u10D5\u10D0\u10DA' p'-\u10D6\u10D4'",
    nextWeek: "'\u10E8\u10D4\u10DB\u10D3\u10D4\u10D2\u10D8' eeee p'-\u10D6\u10D4'",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5BEv8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u10E9.\u10EC-\u10DB\u10D3\u10D4",
        "\u10E9.\u10EC"
    ],
    abbreviated: [
        "\u10E9\u10D5.\u10EC-\u10DB\u10D3\u10D4",
        "\u10E9\u10D5.\u10EC"
    ],
    wide: [
        "\u10E9\u10D5\u10D4\u10DC\u10E1 \u10EC\u10D4\u10DA\u10D7\u10D0\u10E6\u10E0\u10D8\u10EA\u10EE\u10D5\u10D0\u10DB\u10D3\u10D4",
        "\u10E9\u10D5\u10D4\u10DC\u10D8 \u10EC\u10D4\u10DA\u10D7\u10D0\u10E6\u10E0\u10D8\u10EA\u10EE\u10D5\u10D8\u10D7"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1-\u10DA\u10D8 \u10D9\u10D5",
        "2-\u10D4 \u10D9\u10D5",
        "3-\u10D4 \u10D9\u10D5",
        "4-\u10D4 \u10D9\u10D5"
    ],
    wide: [
        "1-\u10DA\u10D8 \u10D9\u10D5\u10D0\u10E0\u10E2\u10D0\u10DA\u10D8",
        "2-\u10D4 \u10D9\u10D5\u10D0\u10E0\u10E2\u10D0\u10DA\u10D8",
        "3-\u10D4 \u10D9\u10D5\u10D0\u10E0\u10E2\u10D0\u10DA\u10D8",
        "4-\u10D4 \u10D9\u10D5\u10D0\u10E0\u10E2\u10D0\u10DA\u10D8"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
    narrow: [
        "\u10D8\u10D0",
        "\u10D7\u10D4",
        "\u10DB\u10D0",
        "\u10D0\u10DE",
        "\u10DB\u10E1",
        "\u10D5\u10DC",
        "\u10D5\u10DA",
        "\u10D0\u10D2",
        "\u10E1\u10D4",
        "\u10DD\u10E5",
        "\u10DC\u10DD",
        "\u10D3\u10D4"
    ],
    abbreviated: [
        "\u10D8\u10D0\u10DC",
        "\u10D7\u10D4\u10D1",
        "\u10DB\u10D0\u10E0",
        "\u10D0\u10DE\u10E0",
        "\u10DB\u10D0\u10D8",
        "\u10D8\u10D5\u10DC",
        "\u10D8\u10D5\u10DA",
        "\u10D0\u10D2\u10D5",
        "\u10E1\u10D4\u10E5",
        "\u10DD\u10E5\u10E2",
        "\u10DC\u10DD\u10D4",
        "\u10D3\u10D4\u10D9"
    ],
    wide: [
        "\u10D8\u10D0\u10DC\u10D5\u10D0\u10E0\u10D8",
        "\u10D7\u10D4\u10D1\u10D4\u10E0\u10D5\u10D0\u10DA\u10D8",
        "\u10DB\u10D0\u10E0\u10E2\u10D8",
        "\u10D0\u10DE\u10E0\u10D8\u10DA\u10D8",
        "\u10DB\u10D0\u10D8\u10E1\u10D8",
        "\u10D8\u10D5\u10DC\u10D8\u10E1\u10D8",
        "\u10D8\u10D5\u10DA\u10D8\u10E1\u10D8",
        "\u10D0\u10D2\u10D5\u10D8\u10E1\u10E2\u10DD",
        "\u10E1\u10D4\u10E5\u10E2\u10D4\u10DB\u10D1\u10D4\u10E0\u10D8",
        "\u10DD\u10E5\u10E2\u10DD\u10DB\u10D1\u10D4\u10E0\u10D8",
        "\u10DC\u10DD\u10D4\u10DB\u10D1\u10D4\u10E0\u10D8",
        "\u10D3\u10D4\u10D9\u10D4\u10DB\u10D1\u10D4\u10E0\u10D8"
    ]
};
var dayValues = {
    narrow: [
        "\u10D9\u10D5",
        "\u10DD\u10E0",
        "\u10E1\u10D0",
        "\u10DD\u10D7",
        "\u10EE\u10E3",
        "\u10DE\u10D0",
        "\u10E8\u10D0"
    ],
    short: [
        "\u10D9\u10D5\u10D8",
        "\u10DD\u10E0\u10E8",
        "\u10E1\u10D0\u10DB",
        "\u10DD\u10D7\u10EE",
        "\u10EE\u10E3\u10D7",
        "\u10DE\u10D0\u10E0",
        "\u10E8\u10D0\u10D1"
    ],
    abbreviated: [
        "\u10D9\u10D5\u10D8",
        "\u10DD\u10E0\u10E8",
        "\u10E1\u10D0\u10DB",
        "\u10DD\u10D7\u10EE",
        "\u10EE\u10E3\u10D7",
        "\u10DE\u10D0\u10E0",
        "\u10E8\u10D0\u10D1"
    ],
    wide: [
        "\u10D9\u10D5\u10D8\u10E0\u10D0",
        "\u10DD\u10E0\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8",
        "\u10E1\u10D0\u10DB\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8",
        "\u10DD\u10D7\u10EE\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8",
        "\u10EE\u10E3\u10D7\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8",
        "\u10DE\u10D0\u10E0\u10D0\u10E1\u10D9\u10D4\u10D5\u10D8",
        "\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D4",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4",
        morning: "\u10D3\u10D8\u10DA\u10D0",
        afternoon: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        night: "\u10E6\u10D0\u10DB\u10D4"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D4",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4",
        morning: "\u10D3\u10D8\u10DA\u10D0",
        afternoon: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        night: "\u10E6\u10D0\u10DB\u10D4"
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D4",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4",
        morning: "\u10D3\u10D8\u10DA\u10D0",
        afternoon: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        night: "\u10E6\u10D0\u10DB\u10D4"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D8\u10D7",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D8\u10E1\u10D0\u10E1",
        morning: "\u10D3\u10D8\u10DA\u10D8\u10D7",
        afternoon: "\u10DC\u10D0\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4\u10D5\u10E1",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD\u10E1",
        night: "\u10E6\u10D0\u10DB\u10D8\u10D7"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D8\u10D7",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D8\u10E1\u10D0\u10E1",
        morning: "\u10D3\u10D8\u10DA\u10D8\u10D7",
        afternoon: "\u10DC\u10D0\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4\u10D5\u10E1",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD\u10E1",
        night: "\u10E6\u10D0\u10DB\u10D8\u10D7"
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D8\u10D7",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D8\u10E1\u10D0\u10E1",
        morning: "\u10D3\u10D8\u10DA\u10D8\u10D7",
        afternoon: "\u10DC\u10D0\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4\u10D5\u10E1",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD\u10E1",
        night: "\u10E6\u10D0\u10DB\u10D8\u10D7"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    if (number === 1) return number + "-\u10DA\u10D8";
    return number + "-\u10D4";
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"heg0f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(-ლი|-ე)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(ჩვ?\.წ)/i,
    abbreviated: /^(ჩვ?\.წ)/i,
    wide: /^(ჩვენს წელთაღრიცხვამდე|ქრისტეშობამდე|ჩვენი წელთაღრიცხვით|ქრისტეშობიდან)/i
};
var parseEraPatterns = {
    any: [
        /^(ჩვენს წელთაღრიცხვამდე|ქრისტეშობამდე)/i,
        /^(ჩვენი წელთაღრიცხვით|ქრისტეშობიდან)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]-(ლი|ე)? კვ/i,
    wide: /^[1234]-(ლი|ე)? კვარტალი/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    any: /^(ია|თე|მა|აპ|მს|ვნ|ვლ|აგ|სე|ოქ|ნო|დე)/i
};
var parseMonthPatterns = {
    any: [
        /^ია/i,
        /^თ/i,
        /^მარ/i,
        /^აპ/i,
        /^მაი/i,
        /^ი?ვნ/i,
        /^ი?ვლ/i,
        /^აგ/i,
        /^ს/i,
        /^ო/i,
        /^ნ/i,
        /^დ/i
    ]
};
var matchDayPatterns = {
    narrow: /^(კვ|ორ|სა|ოთ|ხუ|პა|შა)/i,
    short: /^(კვი|ორშ|სამ|ოთხ|ხუთ|პარ|შაბ)/i,
    wide: /^(კვირა|ორშაბათი|სამშაბათი|ოთხშაბათი|ხუთშაბათი|პარასკევი|შაბათი)/i
};
var parseDayPatterns = {
    any: [
        /^კვ/i,
        /^ორ/i,
        /^სა/i,
        /^ოთ/i,
        /^ხუ/i,
        /^პა/i,
        /^შა/i
    ]
};
var matchDayPeriodPatterns = {
    any: /^([ap]\.?\s?m\.?|შუაღ|დილ)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^შუაღ/i,
        noon: /^შუადღ/i,
        morning: /^დილ/i,
        afternoon: /ნაშუადღევს/i,
        evening: /საღამო/i,
        night: /ღამ/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"dFow7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Kazakh locale.
 * @language Kazakh
 * @iso-639-2 kaz
 * @author Nikita Bayev [@drugoi]{@link https://github.com/drugoi}
 */ var locale = {
    code: 'kk',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"lHo4N","./_lib/formatLong/index.js":"j5P2d","./_lib/formatRelative/index.js":"5eNoh","./_lib/localize/index.js":"7ZtIE","./_lib/match/index.js":"fD08i","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"lHo4N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        regular: {
            one: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u0430\u0437",
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u0430\u0437",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u0430\u0437",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u0430\u0437"
        },
        future: {
            one: "\u0431\u0456\u0440 \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    xSeconds: {
        regular: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        past: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0431\u04B1\u0440\u044B\u043D",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0431\u04B1\u0440\u044B\u043D",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0431\u04B1\u0440\u044B\u043D"
        },
        future: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    halfAMinute: function halfAMinute(options) {
        if (options !== null && options !== void 0 && options.addSuffix) {
            if (options.comparison && options.comparison > 0) return "\u0436\u0430\u0440\u0442\u044B \u043C\u0438\u043D\u0443\u0442 \u0456\u0448\u0456\u043D\u0434\u0435";
            else return "\u0436\u0430\u0440\u0442\u044B \u043C\u0438\u043D\u0443\u0442 \u0431\u04B1\u0440\u044B\u043D";
        }
        return "\u0436\u0430\u0440\u0442\u044B \u043C\u0438\u043D\u0443\u0442";
    },
    lessThanXMinutes: {
        regular: {
            one: "1 \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u0430\u0437",
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u0430\u0437",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u0430\u0437",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u0430\u0437"
        },
        future: {
            one: "\u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u043C ",
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u043C",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u043C",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u043C"
        }
    },
    xMinutes: {
        regular: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442"
        },
        past: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u0431\u04B1\u0440\u044B\u043D",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u0431\u04B1\u0440\u044B\u043D",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u0431\u04B1\u0440\u044B\u043D"
        },
        future: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    aboutXHours: {
        regular: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442"
        },
        future: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    xHours: {
        regular: {
            singularNominative: "{{count}} \u0441\u0430\u0493\u0430\u0442",
            singularGenitive: "{{count}} \u0441\u0430\u0493\u0430\u0442",
            pluralGenitive: "{{count}} \u0441\u0430\u0493\u0430\u0442"
        }
    },
    xDays: {
        regular: {
            singularNominative: "{{count}} \u043A\u04AF\u043D",
            singularGenitive: "{{count}} \u043A\u04AF\u043D",
            pluralGenitive: "{{count}} \u043A\u04AF\u043D"
        },
        future: {
            singularNominative: "{{count}} \u043A\u04AF\u043D\u043D\u0435\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u043A\u04AF\u043D\u043D\u0435\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u043A\u04AF\u043D\u043D\u0435\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    aboutXWeeks: {
        type: 'weeks',
        one: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D 1 \u0430\u043F\u0442\u0430",
        other: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u043F\u0442\u0430"
    },
    xWeeks: {
        type: 'weeks',
        one: "1 \u0430\u043F\u0442\u0430",
        other: "{{count}} \u0430\u043F\u0442\u0430"
    },
    aboutXMonths: {
        regular: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439"
        },
        future: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    xMonths: {
        regular: {
            singularNominative: "{{count}} \u0430\u0439",
            singularGenitive: "{{count}} \u0430\u0439",
            pluralGenitive: "{{count}} \u0430\u0439"
        }
    },
    aboutXYears: {
        regular: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B"
        },
        future: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    xYears: {
        regular: {
            singularNominative: "{{count}} \u0436\u044B\u043B",
            singularGenitive: "{{count}} \u0436\u044B\u043B",
            pluralGenitive: "{{count}} \u0436\u044B\u043B"
        },
        future: {
            singularNominative: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    overXYears: {
        regular: {
            singularNominative: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C",
            singularGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C",
            pluralGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C"
        },
        future: {
            singularNominative: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C",
            singularGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C",
            pluralGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C"
        }
    },
    almostXYears: {
        regular: {
            singularNominative: "{{count}} \u0436\u044B\u043B\u0493\u0430 \u0436\u0430\u049B\u044B\u043D",
            singularGenitive: "{{count}} \u0436\u044B\u043B\u0493\u0430 \u0436\u0430\u049B\u044B\u043D",
            pluralGenitive: "{{count}} \u0436\u044B\u043B\u0493\u0430 \u0436\u0430\u049B\u044B\u043D"
        },
        future: {
            singularNominative: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    }
};
function declension(scheme, count) {
    // scheme for count=1 exists
    if (scheme.one && count === 1) return scheme.one;
    var rem10 = count % 10;
    var rem100 = count % 100;
    // 1, 21, 31, ...
    if (rem10 === 1 && rem100 !== 11) return scheme.singularNominative.replace('{{count}}', String(count));
    else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) return scheme.singularGenitive.replace('{{count}}', String(count));
    else return scheme.pluralGenitive.replace('{{count}}', String(count));
}
var formatDistance = function formatDistance(token, count, options) {
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'function') return tokenValue(options);
    if (tokenValue.type === 'weeks') return count === 1 ? tokenValue.one : tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
            if (tokenValue.future) return declension(tokenValue.future, count);
            else return declension(tokenValue.regular, count) + " \u043A\u0435\u0439\u0456\u043D";
        } else {
            if (tokenValue.past) return declension(tokenValue.past, count);
            else return declension(tokenValue.regular, count) + " \u0431\u04B1\u0440\u044B\u043D";
        }
    } else return declension(tokenValue.regular, count);
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"j5P2d":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE, do MMMM y '\u0436.'",
    long: "do MMMM y '\u0436.'",
    medium: "d MMM y '\u0436.'",
    short: 'dd.MM.yyyy'
};
var timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var dateTimeFormats = {
    any: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'any'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5eNoh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../../_lib/isSameUTCWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var accusativeWeekdays = [
    "\u0436\u0435\u043A\u0441\u0435\u043D\u0431\u0456\u0434\u0435",
    "\u0434\u04AF\u0439\u0441\u0435\u043D\u0431\u0456\u0434\u0435",
    "\u0441\u0435\u0439\u0441\u0435\u043D\u0431\u0456\u0434\u0435",
    "\u0441\u04D9\u0440\u0441\u0435\u043D\u0431\u0456\u0434\u0435",
    "\u0431\u0435\u0439\u0441\u0435\u043D\u0431\u0456\u0434\u0435",
    "\u0436\u04B1\u043C\u0430\u0434\u0430",
    "\u0441\u0435\u043D\u0431\u0456\u0434\u0435"
];
function _lastWeek(day) {
    var weekday = accusativeWeekdays[day];
    return "'\u04E9\u0442\u043A\u0435\u043D " + weekday + " \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'";
}
function thisWeek(day) {
    var weekday = accusativeWeekdays[day];
    return "'" + weekday + " \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'";
}
function _nextWeek(day) {
    var weekday = accusativeWeekdays[day];
    return "'\u043A\u0435\u043B\u0435\u0441\u0456 " + weekday + " \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'";
}
var formatRelativeLocale = {
    lastWeek: function lastWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, _indexJsDefault.default)(date, baseDate, options)) return thisWeek(day);
        else return _lastWeek(day);
    },
    yesterday: "'\u043A\u0435\u0448\u0435 \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'",
    today: "'\u0431\u04AF\u0433\u0456\u043D \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'",
    tomorrow: "'\u0435\u0440\u0442\u0435\u04A3 \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'",
    nextWeek: function nextWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, _indexJsDefault.default)(date, baseDate, options)) return thisWeek(day);
        else return _nextWeek(day);
    },
    other: 'P'
};
var formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
exports.default = formatRelative;

},{"../../../../_lib/isSameUTCWeek/index.js":"g7rCW","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7ZtIE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u0431.\u0437.\u0434.",
        "\u0431.\u0437."
    ],
    abbreviated: [
        "\u0431.\u0437.\u0434.",
        "\u0431.\u0437."
    ],
    wide: [
        "\u0431\u0456\u0437\u0434\u0456\u04A3 \u0437\u0430\u043C\u0430\u043D\u044B\u043C\u044B\u0437\u0493\u0430 \u0434\u0435\u0439\u0456\u043D",
        "\u0431\u0456\u0437\u0434\u0456\u04A3 \u0437\u0430\u043C\u0430\u043D\u044B\u043C\u044B\u0437"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1-\u0448\u0456 \u0442\u043E\u049B.",
        "2-\u0448\u0456 \u0442\u043E\u049B.",
        "3-\u0448\u0456 \u0442\u043E\u049B.",
        "4-\u0448\u0456 \u0442\u043E\u049B."
    ],
    wide: [
        "1-\u0448\u0456 \u0442\u043E\u049B\u0441\u0430\u043D",
        "2-\u0448\u0456 \u0442\u043E\u049B\u0441\u0430\u043D",
        "3-\u0448\u0456 \u0442\u043E\u049B\u0441\u0430\u043D",
        "4-\u0448\u0456 \u0442\u043E\u049B\u0441\u0430\u043D"
    ]
};
var monthValues = {
    narrow: [
        "\u049A",
        "\u0410",
        "\u041D",
        "\u0421",
        "\u041C",
        "\u041C",
        "\u0428",
        "\u0422",
        "\u049A",
        "\u049A",
        "\u049A",
        "\u0416"
    ],
    abbreviated: [
        "\u049B\u0430\u04A3",
        "\u0430\u049B\u043F",
        "\u043D\u0430\u0443",
        "\u0441\u04D9\u0443",
        "\u043C\u0430\u043C",
        "\u043C\u0430\u0443",
        "\u0448\u0456\u043B",
        "\u0442\u0430\u043C",
        "\u049B\u044B\u0440",
        "\u049B\u0430\u0437",
        "\u049B\u0430\u0440",
        "\u0436\u0435\u043B"
    ],
    wide: [
        "\u049B\u0430\u04A3\u0442\u0430\u0440",
        "\u0430\u049B\u043F\u0430\u043D",
        "\u043D\u0430\u0443\u0440\u044B\u0437",
        "\u0441\u04D9\u0443\u0456\u0440",
        "\u043C\u0430\u043C\u044B\u0440",
        "\u043C\u0430\u0443\u0441\u044B\u043C",
        "\u0448\u0456\u043B\u0434\u0435",
        "\u0442\u0430\u043C\u044B\u0437",
        "\u049B\u044B\u0440\u043A\u04AF\u0439\u0435\u043A",
        "\u049B\u0430\u0437\u0430\u043D",
        "\u049B\u0430\u0440\u0430\u0448\u0430",
        "\u0436\u0435\u043B\u0442\u043E\u049B\u0441\u0430\u043D"
    ]
};
var formattingMonthValues = {
    narrow: [
        "\u049A",
        "\u0410",
        "\u041D",
        "\u0421",
        "\u041C",
        "\u041C",
        "\u0428",
        "\u0422",
        "\u049A",
        "\u049A",
        "\u049A",
        "\u0416"
    ],
    abbreviated: [
        "\u049B\u0430\u04A3",
        "\u0430\u049B\u043F",
        "\u043D\u0430\u0443",
        "\u0441\u04D9\u0443",
        "\u043C\u0430\u043C",
        "\u043C\u0430\u0443",
        "\u0448\u0456\u043B",
        "\u0442\u0430\u043C",
        "\u049B\u044B\u0440",
        "\u049B\u0430\u0437",
        "\u049B\u0430\u0440",
        "\u0436\u0435\u043B"
    ],
    wide: [
        "\u049B\u0430\u04A3\u0442\u0430\u0440",
        "\u0430\u049B\u043F\u0430\u043D",
        "\u043D\u0430\u0443\u0440\u044B\u0437",
        "\u0441\u04D9\u0443\u0456\u0440",
        "\u043C\u0430\u043C\u044B\u0440",
        "\u043C\u0430\u0443\u0441\u044B\u043C",
        "\u0448\u0456\u043B\u0434\u0435",
        "\u0442\u0430\u043C\u044B\u0437",
        "\u049B\u044B\u0440\u043A\u04AF\u0439\u0435\u043A",
        "\u049B\u0430\u0437\u0430\u043D",
        "\u049B\u0430\u0440\u0430\u0448\u0430",
        "\u0436\u0435\u043B\u0442\u043E\u049B\u0441\u0430\u043D"
    ]
};
var dayValues = {
    narrow: [
        "\u0416",
        "\u0414",
        "\u0421",
        "\u0421",
        "\u0411",
        "\u0416",
        "\u0421"
    ],
    short: [
        "\u0436\u0441",
        "\u0434\u0441",
        "\u0441\u0441",
        "\u0441\u0440",
        "\u0431\u0441",
        "\u0436\u043C",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u0436\u0441",
        "\u0434\u0441",
        "\u0441\u0441",
        "\u0441\u0440",
        "\u0431\u0441",
        "\u0436\u043C",
        "\u0441\u0431"
    ],
    wide: [
        "\u0436\u0435\u043A\u0441\u0435\u043D\u0431\u0456",
        "\u0434\u04AF\u0439\u0441\u0435\u043D\u0431\u0456",
        "\u0441\u0435\u0439\u0441\u0435\u043D\u0431\u0456",
        "\u0441\u04D9\u0440\u0441\u0435\u043D\u0431\u0456",
        "\u0431\u0435\u0439\u0441\u0435\u043D\u0431\u0456",
        "\u0436\u04B1\u043C\u0430",
        "\u0441\u0435\u043D\u0431\u0456"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u0422\u0414",
        pm: "\u0422\u041A",
        midnight: "\u0442\u04AF\u043D \u043E\u0440\u0442\u0430\u0441\u044B",
        noon: "\u0442\u04AF\u0441",
        morning: "\u0442\u0430\u04A3",
        afternoon: "\u043A\u04AF\u043D\u0434\u0456\u0437",
        evening: "\u043A\u0435\u0448",
        night: "\u0442\u04AF\u043D"
    },
    wide: {
        am: "\u0422\u0414",
        pm: "\u0422\u041A",
        midnight: "\u0442\u04AF\u043D \u043E\u0440\u0442\u0430\u0441\u044B",
        noon: "\u0442\u04AF\u0441",
        morning: "\u0442\u0430\u04A3",
        afternoon: "\u043A\u04AF\u043D\u0434\u0456\u0437",
        evening: "\u043A\u0435\u0448",
        night: "\u0442\u04AF\u043D"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u0422\u0414",
        pm: "\u0422\u041A",
        midnight: "\u0442\u04AF\u043D \u043E\u0440\u0442\u0430\u0441\u044B\u043D\u0434\u0430",
        noon: "\u0442\u04AF\u0441",
        morning: "\u0442\u0430\u04A3",
        afternoon: "\u043A\u04AF\u043D",
        evening: "\u043A\u0435\u0448",
        night: "\u0442\u04AF\u043D"
    },
    wide: {
        am: "\u0422\u0414",
        pm: "\u0422\u041A",
        midnight: "\u0442\u04AF\u043D \u043E\u0440\u0442\u0430\u0441\u044B\u043D\u0434\u0430",
        noon: "\u0442\u04AF\u0441\u0442\u0435",
        morning: "\u0442\u0430\u04A3\u0435\u0440\u0442\u0435\u04A3",
        afternoon: "\u043A\u04AF\u043D\u0434\u0456\u0437",
        evening: "\u043A\u0435\u0448\u0442\u0435",
        night: "\u0442\u04AF\u043D\u0434\u0435"
    }
};
var suffixes = {
    0: "-\u0448\u0456",
    1: "-\u0448\u0456",
    2: "-\u0448\u0456",
    3: "-\u0448\u0456",
    4: "-\u0448\u0456",
    5: "-\u0448\u0456",
    6: "-\u0448\u044B",
    7: "-\u0448\u0456",
    8: "-\u0448\u0456",
    9: "-\u0448\u044B",
    10: "-\u0448\u044B",
    20: "-\u0448\u044B",
    30: "-\u0448\u044B",
    40: "-\u0448\u044B",
    50: "-\u0448\u0456",
    60: "-\u0448\u044B",
    70: "-\u0448\u0456",
    80: "-\u0448\u0456",
    90: "-\u0448\u044B",
    100: "-\u0448\u0456"
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    var mod10 = number % 10;
    var b = number >= 100 ? 100 : null;
    var suffix = suffixes[number] || suffixes[mod10] || b && suffixes[b] || '';
    return number + suffix;
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide',
        formattingValues: formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'any',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"fD08i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(-?(ші|шы))?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^((б )?з\.?\s?д\.?)/i,
    abbreviated: /^((б )?з\.?\s?д\.?)/i,
    wide: /^(біздің заманымызға дейін|біздің заманымыз|біздің заманымыздан)/i
};
var parseEraPatterns = {
    any: [
        /^б/i,
        /^з/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?ші)? тоқ.?/i,
    wide: /^[1234](-?ші)? тоқсан/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^(қ|а|н|с|м|мау|ш|т|қыр|қаз|қар|ж)/i,
    abbreviated: /^(қаң|ақп|нау|сәу|мам|мау|шіл|там|қыр|қаз|қар|жел)/i,
    wide: /^(қаңтар|ақпан|наурыз|сәуір|мамыр|маусым|шілде|тамыз|қыркүйек|қазан|қараша|желтоқсан)/i
};
var parseMonthPatterns = {
    narrow: [
        /^қ/i,
        /^а/i,
        /^н/i,
        /^с/i,
        /^м/i,
        /^м/i,
        /^ш/i,
        /^т/i,
        /^қ/i,
        /^қ/i,
        /^қ/i,
        /^ж/i
    ],
    abbreviated: [
        /^қаң/i,
        /^ақп/i,
        /^нау/i,
        /^сәу/i,
        /^мам/i,
        /^мау/i,
        /^шіл/i,
        /^там/i,
        /^қыр/i,
        /^қаз/i,
        /^қар/i,
        /^жел/i
    ],
    any: [
        /^қ/i,
        /^а/i,
        /^н/i,
        /^с/i,
        /^м/i,
        /^м/i,
        /^ш/i,
        /^т/i,
        /^қ/i,
        /^қ/i,
        /^қ/i,
        /^ж/i
    ]
};
var matchDayPatterns = {
    narrow: /^(ж|д|с|с|б|ж|с)/i,
    short: /^(жс|дс|сс|ср|бс|жм|сб)/i,
    wide: /^(жексенбі|дүйсенбі|сейсенбі|сәрсенбі|бейсенбі|жұма|сенбі)/i
};
var parseDayPatterns = {
    narrow: [
        /^ж/i,
        /^д/i,
        /^с/i,
        /^с/i,
        /^б/i,
        /^ж/i,
        /^с/i
    ],
    short: [
        /^жс/i,
        /^дс/i,
        /^сс/i,
        /^ср/i,
        /^бс/i,
        /^жм/i,
        /^сб/i
    ],
    any: [
        /^ж[ек]/i,
        /^д[үй]/i,
        /^сe[й]/i,
        /^сә[р]/i,
        /^б[ей]/i,
        /^ж[ұм]/i,
        /^се[н]/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i,
    wide: /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i,
    any: /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^ТД/i,
        pm: /^ТК/i,
        midnight: /^түн орта/i,
        noon: /^күндіз/i,
        morning: /таң/i,
        afternoon: /түс/i,
        evening: /кеш/i,
        night: /түн/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gmuuj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Khmer locale (Cambodian).
 * @language Khmer
 * @iso-639-2 khm
 * @author Seanghay Yath [@seanghay]{@link https://github.com/seanghay}
 */ var locale = {
    code: 'km',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"c0dRA","./_lib/formatLong/index.js":"job2L","./_lib/formatRelative/index.js":"62xbC","./_lib/localize/index.js":"UJNq0","./_lib/match/index.js":"eavlK","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"c0dRA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: "\u178F\u17B7\u1785\u1787\u17B6\u1784 {{count}} \u179C\u17B7\u1793\u17B6\u1791\u17B8",
    xSeconds: "{{count}} \u179C\u17B7\u1793\u17B6\u1791\u17B8",
    halfAMinute: "\u1780\u1793\u17D2\u179B\u17C7\u1793\u17B6\u1791\u17B8",
    lessThanXMinutes: "\u178F\u17B7\u1785\u1787\u17B6\u1784 {{count}} \u1793\u17B6\u1791\u17B8",
    xMinutes: "{{count}} \u1793\u17B6\u1791\u17B8",
    aboutXHours: "\u1794\u17D2\u179A\u17A0\u17C2\u179B {{count}} \u1798\u17C9\u17C4\u1784",
    xHours: "{{count}} \u1798\u17C9\u17C4\u1784",
    xDays: "{{count}} \u1790\u17D2\u1784\u17C3",
    aboutXWeeks: "\u1794\u17D2\u179A\u17A0\u17C2\u179B {{count}} \u179F\u1794\u17D2\u178F\u17B6\u17A0\u17CD",
    xWeeks: "{{count}} \u179F\u1794\u17D2\u178F\u17B6\u17A0\u17CD",
    aboutXMonths: "\u1794\u17D2\u179A\u17A0\u17C2\u179B {{count}} \u1781\u17C2",
    xMonths: "{{count}} \u1781\u17C2",
    aboutXYears: "\u1794\u17D2\u179A\u17A0\u17C2\u179B {{count}} \u1786\u17D2\u1793\u17B6\u17C6",
    xYears: "{{count}} \u1786\u17D2\u1793\u17B6\u17C6",
    overXYears: "\u1787\u17B6\u1784 {{count}} \u1786\u17D2\u1793\u17B6\u17C6",
    almostXYears: "\u1787\u17B7\u178F {{count}} \u1786\u17D2\u1793\u17B6\u17C6"
};
var formatDistance = function formatDistance(token, count, options) {
    var tokenValue = formatDistanceLocale[token];
    var result = tokenValue;
    if (typeof count === 'number') result = result.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u1780\u17D2\u1793\u17BB\u1784\u179A\u1799\u17C8\u1796\u17C1\u179B " + result;
        else return result + "\u1798\u17BB\u1793";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"job2L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE do MMMM y',
    long: 'do MMMM y',
    medium: 'd MMM y',
    short: 'dd/MM/yyyy'
};
var timeFormats = {
    full: 'h:mm:ss a',
    long: 'h:mm:ss a',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var dateTimeFormats = {
    full: "{{date}} '\u1798\u17C9\u17C4\u1784' {{time}}",
    long: "{{date}} '\u1798\u17C9\u17C4\u1784' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"62xbC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'\u1790\u17D2\u1784\u17C3'eeee'\u179F\u200B\u1794\u17D2\u178F\u17B6\u200B\u17A0\u17CD\u200B\u1798\u17BB\u1793\u1798\u17C9\u17C4\u1784' p",
    yesterday: "'\u1798\u17D2\u179F\u17B7\u179B\u1798\u17B7\u1789\u1793\u17C5\u1798\u17C9\u17C4\u1784' p",
    today: "'\u1790\u17D2\u1784\u17C3\u1793\u17C1\u17C7\u1798\u17C9\u17C4\u1784' p",
    tomorrow: "'\u1790\u17D2\u1784\u17C3\u179F\u17D2\u17A2\u17C2\u1780\u1798\u17C9\u17C4\u1784' p",
    nextWeek: "'\u1790\u17D2\u1784\u17C3'eeee'\u179F\u200B\u1794\u17D2\u178F\u17B6\u200B\u17A0\u17CD\u200B\u1780\u17D2\u179A\u17C4\u1799\u1798\u17C9\u17C4\u1784' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"UJNq0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u1798.\u1782\u179F",
        "\u1782\u179F"
    ],
    abbreviated: [
        "\u1798\u17BB\u1793\u1782.\u179F",
        "\u1782.\u179F"
    ],
    wide: [
        "\u1798\u17BB\u1793\u1782\u17D2\u179A\u17B7\u179F\u17D2\u178F\u179F\u1780\u179A\u17B6\u1787",
        "\u1793\u17C3\u1782\u17D2\u179A\u17B7\u179F\u17D2\u178F\u179F\u1780\u179A\u17B6\u1787"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "\u178F\u17D2\u179A\u17B8\u1798\u17B6\u179F\u1791\u17B8 1",
        "\u178F\u17D2\u179A\u17B8\u1798\u17B6\u179F\u1791\u17B8 2",
        "\u178F\u17D2\u179A\u17B8\u1798\u17B6\u179F\u1791\u17B8 3",
        "\u178F\u17D2\u179A\u17B8\u1798\u17B6\u179F\u1791\u17B8 4"
    ]
};
var monthValues = {
    narrow: [
        "\u1798.\u1780",
        "\u1780.\u1798",
        "\u1798\u17B7",
        "\u1798.\u179F",
        "\u17A7.\u179F",
        "\u1798.\u1790",
        "\u1780.\u178A",
        "\u179F\u17B8",
        "\u1780\u1789",
        "\u178F\u17BB",
        "\u179C\u17B7",
        "\u1792"
    ],
    abbreviated: [
        "\u1798\u1780\u179A\u17B6",
        "\u1780\u17BB\u1798\u17D2\u1797\u17C8",
        "\u1798\u17B8\u1793\u17B6",
        "\u1798\u17C1\u179F\u17B6",
        "\u17A7\u179F\u1797\u17B6",
        "\u1798\u17B7\u1790\u17BB\u1793\u17B6",
        "\u1780\u1780\u17D2\u1780\u178A\u17B6",
        "\u179F\u17B8\u17A0\u17B6",
        "\u1780\u1789\u17D2\u1789\u17B6",
        "\u178F\u17BB\u179B\u17B6",
        "\u179C\u17B7\u1785\u17D2\u1786\u17B7\u1780\u17B6",
        "\u1792\u17D2\u1793\u17BC"
    ],
    wide: [
        "\u1798\u1780\u179A\u17B6",
        "\u1780\u17BB\u1798\u17D2\u1797\u17C8",
        "\u1798\u17B8\u1793\u17B6",
        "\u1798\u17C1\u179F\u17B6",
        "\u17A7\u179F\u1797\u17B6",
        "\u1798\u17B7\u1790\u17BB\u1793\u17B6",
        "\u1780\u1780\u17D2\u1780\u178A\u17B6",
        "\u179F\u17B8\u17A0\u17B6",
        "\u1780\u1789\u17D2\u1789\u17B6",
        "\u178F\u17BB\u179B\u17B6",
        "\u179C\u17B7\u1785\u17D2\u1786\u17B7\u1780\u17B6",
        "\u1792\u17D2\u1793\u17BC"
    ]
};
var dayValues = {
    narrow: [
        "\u17A2\u17B6",
        "\u1785",
        "\u17A2",
        "\u1796",
        "\u1796\u17D2\u179A",
        "\u179F\u17BB",
        "\u179F"
    ],
    short: [
        "\u17A2\u17B6",
        "\u1785",
        "\u17A2",
        "\u1796",
        "\u1796\u17D2\u179A",
        "\u179F\u17BB",
        "\u179F"
    ],
    abbreviated: [
        "\u17A2\u17B6",
        "\u1785",
        "\u17A2",
        "\u1796",
        "\u1796\u17D2\u179A",
        "\u179F\u17BB",
        "\u179F"
    ],
    wide: [
        "\u17A2\u17B6\u1791\u17B7\u178F\u17D2\u1799",
        "\u1785\u1793\u17D2\u1791",
        "\u17A2\u1784\u17D2\u1782\u17B6\u179A",
        "\u1796\u17BB\u1792",
        "\u1796\u17D2\u179A\u17A0\u179F\u17D2\u1794\u178F\u17B7\u17CD",
        "\u179F\u17BB\u1780\u17D2\u179A",
        "\u179F\u17C5\u179A\u17CD"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
    },
    abbreviated: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
    },
    wide: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
    },
    abbreviated: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
    },
    wide: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _) {
    var number = Number(dirtyNumber);
    return number.toString();
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"eavlK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(ម\.)?គស/i,
    abbreviated: /^(មុន)?គ\.ស/i,
    wide: /^(មុន|នៃ)គ្រិស្តសករាជ/i
};
var parseEraPatterns = {
    any: [
        /^(ម|មុន)គ\.?ស/i,
        /^(នៃ)?គ\.?ស/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^(ត្រីមាស)(ទី)?\s?[1234]/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^(ម\.ក|ក\.ម|មិ|ម\.ស|ឧ\.ស|ម\.ថ|ក\.ដ|សី|កញ|តុ|វិ|ធ)/i,
    abbreviated: /^(មករា|កុម្ភៈ|មីនា|មេសា|ឧសភា|មិថុនា|កក្កដា|សីហា|កញ្ញា|តុលា|វិច្ឆិកា|ធ្នូ)/i,
    wide: /^(មករា|កុម្ភៈ|មីនា|មេសា|ឧសភា|មិថុនា|កក្កដា|សីហា|កញ្ញា|តុលា|វិច្ឆិកា|ធ្នូ)/i
};
var parseMonthPatterns = {
    narrow: [
        /^ម\.ក/i,
        /^ក\.ម/i,
        /^មិ/i,
        /^ម\.ស/i,
        /^ឧ\.ស/i,
        /^ម\.ថ/i,
        /^ក\.ដ/i,
        /^សី/i,
        /^កញ/i,
        /^តុ/i,
        /^វិ/i,
        /^ធ/i
    ],
    any: [
        /^មក/i,
        /^កុ/i,
        /^មីន/i,
        /^មេ/i,
        /^ឧស/i,
        /^មិថ/i,
        /^កក/i,
        /^សី/i,
        /^កញ/i,
        /^តុ/i,
        /^វិច/i,
        /^ធ/i
    ]
};
var matchDayPatterns = {
    narrow: /^(អា|ច|អ|ព|ព្រ|សុ|ស)/i,
    short: /^(អា|ច|អ|ព|ព្រ|សុ|ស)/i,
    abbreviated: /^(អា|ច|អ|ព|ព្រ|សុ|ស)/i,
    wide: /^(អាទិត្យ|ចន្ទ|អង្គារ|ពុធ|ព្រហស្បតិ៍|សុក្រ|សៅរ៍)/i
};
var parseDayPatterns = {
    narrow: [
        /^អា/i,
        /^ច/i,
        /^អ/i,
        /^ព/i,
        /^ព្រ/i,
        /^សុ/i,
        /^ស/i
    ],
    any: [
        /^អា/i,
        /^ច/i,
        /^អ/i,
        /^ព/i,
        /^ព្រ/i,
        /^សុ/i,
        /^សៅ/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(ព្រឹក|ល្ងាច|ពេលព្រឹក|ពេលថ្ងៃត្រង់|ពេលល្ងាច|ពេលរសៀល|ពេលយប់|ពេលកណ្ដាលអធ្រាត្រ)/i,
    any: /^(ព្រឹក|ល្ងាច|ពេលព្រឹក|ពេលថ្ងៃត្រង់|ពេលល្ងាច|ពេលរសៀល|ពេលយប់|ពេលកណ្ដាលអធ្រាត្រ)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^ព្រឹក/i,
        pm: /^ល្ងាច/i,
        midnight: /^ពេលកណ្ដាលអធ្រាត្រ/i,
        noon: /^ពេលថ្ងៃត្រង់/i,
        morning: /ពេលព្រឹក/i,
        afternoon: /ពេលរសៀល/i,
        evening: /ពេលល្ងាច/i,
        night: /ពេលយប់/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2KUDY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Kannada locale (India).
 * @language Kannada
 * @iso-639-2 kan
 * @author Manjunatha Gouli [@developergouli]{@link https://github.com/developergouli}
 */ var locale = {
    code: 'kn',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"5TEF5","./_lib/formatLong/index.js":"Yxjke","./_lib/formatRelative/index.js":"8YI0O","./_lib/localize/index.js":"lTysc","./_lib/match/index.js":"4n2AG","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5TEF5":[function(require,module,exports,__globalThis) {
// note: no implementation for weeks
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            default: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            future: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            past: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6"
        },
        other: {
            default: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            future: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            past: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6"
        }
    },
    xSeconds: {
        one: {
            default: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD",
            future: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0CA8\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CC1\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    halfAMinute: {
        other: {
            default: "\u0C85\u0CB0\u0CCD\u0CA7 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7",
            future: "\u0C85\u0CB0\u0CCD\u0CA7 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0C85\u0CB0\u0CCD\u0CA7 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    lessThanXMinutes: {
        one: {
            default: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            future: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            past: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6"
        },
        other: {
            default: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            future: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            past: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6"
        }
    },
    xMinutes: {
        one: {
            default: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7",
            future: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    aboutXHours: {
        one: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0C97\u0C82\u0C9F\u0CC6",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0C97\u0C82\u0C9F\u0CC6\u0CAF\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0C97\u0C82\u0C9F\u0CC6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3\u0CC1",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    xHours: {
        one: {
            default: "1 \u0C97\u0C82\u0C9F\u0CC6",
            future: "1 \u0C97\u0C82\u0C9F\u0CC6\u0CAF\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0C97\u0C82\u0C9F\u0CC6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "{{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    xDays: {
        one: {
            default: "1 \u0CA6\u0CBF\u0CA8",
            future: "1 \u0CA6\u0CBF\u0CA8\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0CA6\u0CBF\u0CA8\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "{{count}} \u0CA6\u0CBF\u0CA8\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0CA6\u0CBF\u0CA8\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0CA6\u0CBF\u0CA8\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    // TODO
    // aboutXWeeks: {},
    // TODO
    // xWeeks: {},
    aboutXMonths: {
        one: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    xMonths: {
        one: {
            default: "1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1",
            future: "1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "{{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    aboutXYears: {
        one: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CB5\u0CB0\u0CCD\u0CB7",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CC1",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    xYears: {
        one: {
            default: "1 \u0CB5\u0CB0\u0CCD\u0CB7",
            future: "1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    overXYears: {
        one: {
            default: "1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CAE\u0CC7\u0CB2\u0CC6",
            future: "1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CAE\u0CC7\u0CB2\u0CC6",
            past: "1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CAE\u0CC7\u0CB2\u0CC6"
        },
        other: {
            default: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CAE\u0CC7\u0CB2\u0CC6",
            future: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CAE\u0CC7\u0CB2\u0CC6",
            past: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CAE\u0CC7\u0CB2\u0CC6"
        }
    },
    almostXYears: {
        one: {
            default: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            future: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF"
        },
        other: {
            default: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            future: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF"
        }
    }
};
function getResultByTense(parentToken, options) {
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return parentToken.future;
        else return parentToken.past;
    }
    return parentToken.default;
}
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (tokenValue.one && count === 1) result = getResultByTense(tokenValue.one, options);
    else result = getResultByTense(tokenValue.other, options);
    return result.replace('{{count}}', String(count));
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"Yxjke":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js"); // Reference: https://www.unicode.org/cldr/charts/32/summary/kn.html
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, MMMM d, y',
    // CLDR 1816
    long: 'MMMM d, y',
    // CLDR 1817
    medium: 'MMM d, y',
    // CLDR 1818
    short: 'd/M/yy' // CLDR 1819
};
var timeFormats = {
    full: 'hh:mm:ss a zzzz',
    // CLDR 1820
    long: 'hh:mm:ss a z',
    // CLDR 1821
    medium: 'hh:mm:ss a',
    // CLDR 1822
    short: 'hh:mm a' // CLDR 1823
};
var dateTimeFormats = {
    full: '{{date}} {{time}}',
    // CLDR 1824
    long: '{{date}} {{time}}',
    // CLDR 1825
    medium: '{{date}} {{time}}',
    // CLDR 1826
    short: '{{date}} {{time}}' // CLDR 1827
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8YI0O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'\u0C95\u0CB3\u0CC6\u0CA6' eeee p '\u0C95\u0CCD\u0C95\u0CC6'",
    yesterday: "'\u0CA8\u0CBF\u0CA8\u0CCD\u0CA8\u0CC6' p '\u0C95\u0CCD\u0C95\u0CC6'",
    today: "'\u0C87\u0C82\u0CA6\u0CC1' p '\u0C95\u0CCD\u0C95\u0CC6'",
    tomorrow: "'\u0CA8\u0CBE\u0CB3\u0CC6' p '\u0C95\u0CCD\u0C95\u0CC6'",
    nextWeek: "eeee p '\u0C95\u0CCD\u0C95\u0CC6'",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"lTysc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js"); // Reference: https://www.unicode.org/cldr/charts/32/summary/kn.html
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u0C95\u0CCD\u0CB0\u0CBF.\u0CAA\u0CC2",
        "\u0C95\u0CCD\u0CB0\u0CBF.\u0CB6"
    ],
    abbreviated: [
        "\u0C95\u0CCD\u0CB0\u0CBF.\u0CAA\u0CC2",
        "\u0C95\u0CCD\u0CB0\u0CBF.\u0CB6"
    ],
    // CLDR #1618, #1620
    wide: [
        "\u0C95\u0CCD\u0CB0\u0CBF\u0CB8\u0CCD\u0CA4 \u0CAA\u0CC2\u0CB0\u0CCD\u0CB5",
        "\u0C95\u0CCD\u0CB0\u0CBF\u0CB8\u0CCD\u0CA4 \u0CB6\u0C95"
    ] // CLDR #1614, #1616
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u0CA4\u0CCD\u0CB0\u0CC8 1",
        "\u0CA4\u0CCD\u0CB0\u0CC8 2",
        "\u0CA4\u0CCD\u0CB0\u0CC8 3",
        "\u0CA4\u0CCD\u0CB0\u0CC8 4"
    ],
    // CLDR #1630 - #1638
    wide: [
        "1\u0CA8\u0CC7 \u0CA4\u0CCD\u0CB0\u0CC8\u0CAE\u0CBE\u0CB8\u0CBF\u0C95",
        "2\u0CA8\u0CC7 \u0CA4\u0CCD\u0CB0\u0CC8\u0CAE\u0CBE\u0CB8\u0CBF\u0C95",
        "3\u0CA8\u0CC7 \u0CA4\u0CCD\u0CB0\u0CC8\u0CAE\u0CBE\u0CB8\u0CBF\u0C95",
        "4\u0CA8\u0CC7 \u0CA4\u0CCD\u0CB0\u0CC8\u0CAE\u0CBE\u0CB8\u0CBF\u0C95"
    ] // CLDR #1622 - #1629
};
// CLDR #1646 - #1717
var monthValues = {
    narrow: [
        "\u0C9C",
        "\u0CAB\u0CC6",
        "\u0CAE\u0CBE",
        "\u0C8F",
        "\u0CAE\u0CC7",
        "\u0C9C\u0CC2",
        "\u0C9C\u0CC1",
        "\u0C86",
        "\u0CB8\u0CC6",
        "\u0C85",
        "\u0CA8",
        "\u0CA1\u0CBF"
    ],
    abbreviated: [
        "\u0C9C\u0CA8",
        "\u0CAB\u0CC6\u0CAC\u0CCD\u0CB0",
        "\u0CAE\u0CBE\u0CB0\u0CCD\u0C9A\u0CCD",
        "\u0C8F\u0CAA\u0CCD\u0CB0\u0CBF",
        "\u0CAE\u0CC7",
        "\u0C9C\u0CC2\u0CA8\u0CCD",
        "\u0C9C\u0CC1\u0CB2\u0CC8",
        "\u0C86\u0C97",
        "\u0CB8\u0CC6\u0CAA\u0CCD\u0C9F\u0CC6\u0C82",
        "\u0C85\u0C95\u0CCD\u0C9F\u0CCB",
        "\u0CA8\u0CB5\u0CC6\u0C82",
        "\u0CA1\u0CBF\u0CB8\u0CC6\u0C82"
    ],
    wide: [
        "\u0C9C\u0CA8\u0CB5\u0CB0\u0CBF",
        "\u0CAB\u0CC6\u0CAC\u0CCD\u0CB0\u0CB5\u0CB0\u0CBF",
        "\u0CAE\u0CBE\u0CB0\u0CCD\u0C9A\u0CCD",
        "\u0C8F\u0CAA\u0CCD\u0CB0\u0CBF\u0CB2\u0CCD",
        "\u0CAE\u0CC7",
        "\u0C9C\u0CC2\u0CA8\u0CCD",
        "\u0C9C\u0CC1\u0CB2\u0CC8",
        "\u0C86\u0C97\u0CB8\u0CCD\u0C9F\u0CCD",
        "\u0CB8\u0CC6\u0CAA\u0CCD\u0C9F\u0CC6\u0C82\u0CAC\u0CB0\u0CCD",
        "\u0C85\u0C95\u0CCD\u0C9F\u0CCB\u0CAC\u0CB0\u0CCD",
        "\u0CA8\u0CB5\u0CC6\u0C82\u0CAC\u0CB0\u0CCD",
        "\u0CA1\u0CBF\u0CB8\u0CC6\u0C82\u0CAC\u0CB0\u0CCD"
    ]
};
// CLDR #1718 - #1773
var dayValues = {
    narrow: [
        "\u0CAD\u0CBE",
        "\u0CB8\u0CCB",
        "\u0CAE\u0C82",
        "\u0CAC\u0CC1",
        "\u0C97\u0CC1",
        "\u0CB6\u0CC1",
        "\u0CB6"
    ],
    short: [
        "\u0CAD\u0CBE\u0CA8\u0CC1",
        "\u0CB8\u0CCB\u0CAE",
        "\u0CAE\u0C82\u0C97\u0CB3",
        "\u0CAC\u0CC1\u0CA7",
        "\u0C97\u0CC1\u0CB0\u0CC1",
        "\u0CB6\u0CC1\u0C95\u0CCD\u0CB0",
        "\u0CB6\u0CA8\u0CBF"
    ],
    abbreviated: [
        "\u0CAD\u0CBE\u0CA8\u0CC1",
        "\u0CB8\u0CCB\u0CAE",
        "\u0CAE\u0C82\u0C97\u0CB3",
        "\u0CAC\u0CC1\u0CA7",
        "\u0C97\u0CC1\u0CB0\u0CC1",
        "\u0CB6\u0CC1\u0C95\u0CCD\u0CB0",
        "\u0CB6\u0CA8\u0CBF"
    ],
    wide: [
        "\u0CAD\u0CBE\u0CA8\u0CC1\u0CB5\u0CBE\u0CB0",
        "\u0CB8\u0CCB\u0CAE\u0CB5\u0CBE\u0CB0",
        "\u0CAE\u0C82\u0C97\u0CB3\u0CB5\u0CBE\u0CB0",
        "\u0CAC\u0CC1\u0CA7\u0CB5\u0CBE\u0CB0",
        "\u0C97\u0CC1\u0CB0\u0CC1\u0CB5\u0CBE\u0CB0",
        "\u0CB6\u0CC1\u0C95\u0CCD\u0CB0\u0CB5\u0CBE\u0CB0",
        "\u0CB6\u0CA8\u0CBF\u0CB5\u0CBE\u0CB0"
    ]
};
// CLDR #1774 - #1815
var dayPeriodValues = {
    narrow: {
        am: "\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
        pm: "\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CB9\u0CCD\u0CA8",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CB9\u0CCD\u0CA8",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
    },
    abbreviated: {
        am: "\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
        pm: "\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
    },
    wide: {
        am: "\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
        pm: "\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u0CAA\u0CC2",
        pm: "\u0C85",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
    },
    abbreviated: {
        am: "\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
        pm: "\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF \u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
    },
    wide: {
        am: "\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
        pm: "\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF \u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "\u0CA8\u0CC7";
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4n2AG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(ನೇ|ನೆ)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(ಕ್ರಿ.ಪೂ|ಕ್ರಿ.ಶ)/i,
    abbreviated: /^(ಕ್ರಿ\.?\s?ಪೂ\.?|ಕ್ರಿ\.?\s?ಶ\.?|ಪ್ರ\.?\s?ಶ\.?)/i,
    wide: /^(ಕ್ರಿಸ್ತ ಪೂರ್ವ|ಕ್ರಿಸ್ತ ಶಕ|ಪ್ರಸಕ್ತ ಶಕ)/i
};
var parseEraPatterns = {
    any: [
        /^ಪೂ/i,
        /^(ಶ|ಪ್ರ)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ತ್ರೈ[1234]|ತ್ರೈ [1234]| [1234]ತ್ರೈ/i,
    wide: /^[1234](ನೇ)? ತ್ರೈಮಾಸಿಕ/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^(ಜೂ|ಜು|ಜ|ಫೆ|ಮಾ|ಏ|ಮೇ|ಆ|ಸೆ|ಅ|ನ|ಡಿ)/i,
    abbreviated: /^(ಜನ|ಫೆಬ್ರ|ಮಾರ್ಚ್|ಏಪ್ರಿ|ಮೇ|ಜೂನ್|ಜುಲೈ|ಆಗ|ಸೆಪ್ಟೆಂ|ಅಕ್ಟೋ|ನವೆಂ|ಡಿಸೆಂ)/i,
    wide: /^(ಜನವರಿ|ಫೆಬ್ರವರಿ|ಮಾರ್ಚ್|ಏಪ್ರಿಲ್|ಮೇ|ಜೂನ್|ಜುಲೈ|ಆಗಸ್ಟ್|ಸೆಪ್ಟೆಂಬರ್|ಅಕ್ಟೋಬರ್|ನವೆಂಬರ್|ಡಿಸೆಂಬರ್)/i
};
var parseMonthPatterns = {
    narrow: [
        /^ಜ$/i,
        /^ಫೆ/i,
        /^ಮಾ/i,
        /^ಏ/i,
        /^ಮೇ/i,
        /^ಜೂ/i,
        /^ಜು$/i,
        /^ಆ/i,
        /^ಸೆ/i,
        /^ಅ/i,
        /^ನ/i,
        /^ಡಿ/i
    ],
    any: [
        /^ಜನ/i,
        /^ಫೆ/i,
        /^ಮಾ/i,
        /^ಏ/i,
        /^ಮೇ/i,
        /^ಜೂನ್/i,
        /^ಜುಲೈ/i,
        /^ಆ/i,
        /^ಸೆ/i,
        /^ಅ/i,
        /^ನ/i,
        /^ಡಿ/i
    ]
};
var matchDayPatterns = {
    narrow: /^(ಭಾ|ಸೋ|ಮ|ಬು|ಗು|ಶು|ಶ)/i,
    short: /^(ಭಾನು|ಸೋಮ|ಮಂಗಳ|ಬುಧ|ಗುರು|ಶುಕ್ರ|ಶನಿ)/i,
    abbreviated: /^(ಭಾನು|ಸೋಮ|ಮಂಗಳ|ಬುಧ|ಗುರು|ಶುಕ್ರ|ಶನಿ)/i,
    wide: /^(ಭಾನುವಾರ|ಸೋಮವಾರ|ಮಂಗಳವಾರ|ಬುಧವಾರ|ಗುರುವಾರ|ಶುಕ್ರವಾರ|ಶನಿವಾರ)/i
};
var parseDayPatterns = {
    narrow: [
        /^ಭಾ/i,
        /^ಸೋ/i,
        /^ಮ/i,
        /^ಬು/i,
        /^ಗು/i,
        /^ಶು/i,
        /^ಶ/i
    ],
    any: [
        /^ಭಾ/i,
        /^ಸೋ/i,
        /^ಮ/i,
        /^ಬು/i,
        /^ಗು/i,
        /^ಶು/i,
        /^ಶ/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(ಪೂ|ಅ|ಮಧ್ಯರಾತ್ರಿ|ಮಧ್ಯಾನ್ಹ|ಬೆಳಗ್ಗೆ|ಸಂಜೆ|ರಾತ್ರಿ)/i,
    any: /^(ಪೂರ್ವಾಹ್ನ|ಅಪರಾಹ್ನ|ಮಧ್ಯರಾತ್ರಿ|ಮಧ್ಯಾನ್ಹ|ಬೆಳಗ್ಗೆ|ಸಂಜೆ|ರಾತ್ರಿ)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^ಪೂ/i,
        pm: /^ಅ/i,
        midnight: /ಮಧ್ಯರಾತ್ರಿ/i,
        noon: /ಮಧ್ಯಾನ್ಹ/i,
        morning: /ಬೆಳಗ್ಗೆ/i,
        afternoon: /ಮಧ್ಯಾನ್ಹ/i,
        evening: /ಸಂಜೆ/i,
        night: /ರಾತ್ರಿ/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7OdOb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Korean locale.
 * @language Korean
 * @iso-639-2 kor
 * @author Hong Chulju [@angdev]{@link https://github.com/angdev}
 * @author Lee Seoyoen [@iamssen]{@link https://github.com/iamssen}
 * @author Taiki IKeda [@so99ynoodles]{@link https://github.com/so99ynoodles}
 */ var locale = {
    code: 'ko',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"z9X4A","./_lib/formatLong/index.js":"1LjyJ","./_lib/formatRelative/index.js":"bDVME","./_lib/localize/index.js":"9h0Ml","./_lib/match/index.js":"jpjj5","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"z9X4A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "1\uCD08 \uBBF8\uB9CC",
        other: "{{count}}\uCD08 \uBBF8\uB9CC"
    },
    xSeconds: {
        one: "1\uCD08",
        other: "{{count}}\uCD08"
    },
    halfAMinute: "30\uCD08",
    lessThanXMinutes: {
        one: "1\uBD84 \uBBF8\uB9CC",
        other: "{{count}}\uBD84 \uBBF8\uB9CC"
    },
    xMinutes: {
        one: "1\uBD84",
        other: "{{count}}\uBD84"
    },
    aboutXHours: {
        one: "\uC57D 1\uC2DC\uAC04",
        other: "\uC57D {{count}}\uC2DC\uAC04"
    },
    xHours: {
        one: "1\uC2DC\uAC04",
        other: "{{count}}\uC2DC\uAC04"
    },
    xDays: {
        one: "1\uC77C",
        other: "{{count}}\uC77C"
    },
    aboutXWeeks: {
        one: "\uC57D 1\uC8FC",
        other: "\uC57D {{count}}\uC8FC"
    },
    xWeeks: {
        one: "1\uC8FC",
        other: "{{count}}\uC8FC"
    },
    aboutXMonths: {
        one: "\uC57D 1\uAC1C\uC6D4",
        other: "\uC57D {{count}}\uAC1C\uC6D4"
    },
    xMonths: {
        one: "1\uAC1C\uC6D4",
        other: "{{count}}\uAC1C\uC6D4"
    },
    aboutXYears: {
        one: "\uC57D 1\uB144",
        other: "\uC57D {{count}}\uB144"
    },
    xYears: {
        one: "1\uB144",
        other: "{{count}}\uB144"
    },
    overXYears: {
        one: "1\uB144 \uC774\uC0C1",
        other: "{{count}}\uB144 \uC774\uC0C1"
    },
    almostXYears: {
        one: "\uAC70\uC758 1\uB144",
        other: "\uAC70\uC758 {{count}}\uB144"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " \uD6C4";
        else return result + " \uC804";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1LjyJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "y\uB144 M\uC6D4 d\uC77C EEEE",
    long: "y\uB144 M\uC6D4 d\uC77C",
    medium: 'y.MM.dd',
    short: 'y.MM.dd'
};
var timeFormats = {
    full: "a H\uC2DC mm\uBD84 ss\uCD08 zzzz",
    long: 'a H:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"bDVME":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'\uC9C0\uB09C' eeee p",
    yesterday: "'\uC5B4\uC81C' p",
    today: "'\uC624\uB298' p",
    tomorrow: "'\uB0B4\uC77C' p",
    nextWeek: "'\uB2E4\uC74C' eeee p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"9h0Ml":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'BC',
        'AD'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        "\uAE30\uC6D0\uC804",
        "\uC11C\uAE30"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "1\uBD84\uAE30",
        "2\uBD84\uAE30",
        "3\uBD84\uAE30",
        "4\uBD84\uAE30"
    ]
};
var monthValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10',
        '11',
        '12'
    ],
    abbreviated: [
        "1\uC6D4",
        "2\uC6D4",
        "3\uC6D4",
        "4\uC6D4",
        "5\uC6D4",
        "6\uC6D4",
        "7\uC6D4",
        "8\uC6D4",
        "9\uC6D4",
        "10\uC6D4",
        "11\uC6D4",
        "12\uC6D4"
    ],
    wide: [
        "1\uC6D4",
        "2\uC6D4",
        "3\uC6D4",
        "4\uC6D4",
        "5\uC6D4",
        "6\uC6D4",
        "7\uC6D4",
        "8\uC6D4",
        "9\uC6D4",
        "10\uC6D4",
        "11\uC6D4",
        "12\uC6D4"
    ]
};
var dayValues = {
    narrow: [
        "\uC77C",
        "\uC6D4",
        "\uD654",
        "\uC218",
        "\uBAA9",
        "\uAE08",
        "\uD1A0"
    ],
    short: [
        "\uC77C",
        "\uC6D4",
        "\uD654",
        "\uC218",
        "\uBAA9",
        "\uAE08",
        "\uD1A0"
    ],
    abbreviated: [
        "\uC77C",
        "\uC6D4",
        "\uD654",
        "\uC218",
        "\uBAA9",
        "\uAE08",
        "\uD1A0"
    ],
    wide: [
        "\uC77C\uC694\uC77C",
        "\uC6D4\uC694\uC77C",
        "\uD654\uC694\uC77C",
        "\uC218\uC694\uC77C",
        "\uBAA9\uC694\uC77C",
        "\uAE08\uC694\uC77C",
        "\uD1A0\uC694\uC77C"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    },
    abbreviated: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    },
    wide: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    },
    abbreviated: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    },
    wide: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = String(options === null || options === void 0 ? void 0 : options.unit);
    switch(unit){
        case 'minute':
        case 'second':
            return String(number);
        case 'date':
            return number + "\uC77C";
        default:
            return number + "\uBC88\uC9F8";
    }
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jpjj5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(일|번째)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(기원전|서기)/i
};
var parseEraPatterns = {
    any: [
        /^(bc|기원전)/i,
        /^(ad|서기)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234]사?분기/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^(1[012]|[123456789])/,
    abbreviated: /^(1[012]|[123456789])월/i,
    wide: /^(1[012]|[123456789])월/i
};
var parseMonthPatterns = {
    any: [
        /^1월?$/,
        /^2/,
        /^3/,
        /^4/,
        /^5/,
        /^6/,
        /^7/,
        /^8/,
        /^9/,
        /^10/,
        /^11/,
        /^12/
    ]
};
var matchDayPatterns = {
    narrow: /^[일월화수목금토]/,
    short: /^[일월화수목금토]/,
    abbreviated: /^[일월화수목금토]/,
    wide: /^[일월화수목금토]요일/
};
var parseDayPatterns = {
    any: [
        /^일/,
        /^월/,
        /^화/,
        /^수/,
        /^목/,
        /^금/,
        /^토/
    ]
};
var matchDayPeriodPatterns = {
    any: /^(am|pm|오전|오후|자정|정오|아침|저녁|밤)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^(am|오전)/i,
        pm: /^(pm|오후)/i,
        midnight: /^자정/i,
        noon: /^정오/i,
        morning: /^아침/i,
        afternoon: /^오후/i,
        evening: /^저녁/i,
        night: /^밤/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jhM7W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Luxembourgish locale.
 * @language Luxembourgish
 * @iso-639-2 ltz
 * @author Daniel Waxweiler [@dwaxweiler]{@link https://github.com/dwaxweiler}
 */ var locale = {
    code: 'lb',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"aCxvt","./_lib/formatLong/index.js":"kJlxR","./_lib/formatRelative/index.js":"dCsrU","./_lib/localize/index.js":"efgMd","./_lib/match/index.js":"9TmJw","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"aCxvt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        standalone: {
            one: "manner w\xe9i eng Sekonn",
            other: "manner w\xe9i {{count}} Sekonnen"
        },
        withPreposition: {
            one: "manner w\xe9i enger Sekonn",
            other: "manner w\xe9i {{count}} Sekonnen"
        }
    },
    xSeconds: {
        standalone: {
            one: 'eng Sekonn',
            other: '{{count}} Sekonnen'
        },
        withPreposition: {
            one: 'enger Sekonn',
            other: '{{count}} Sekonnen'
        }
    },
    halfAMinute: {
        standalone: 'eng hallef Minutt',
        withPreposition: 'enger hallwer Minutt'
    },
    lessThanXMinutes: {
        standalone: {
            one: "manner w\xe9i eng Minutt",
            other: "manner w\xe9i {{count}} Minutten"
        },
        withPreposition: {
            one: "manner w\xe9i enger Minutt",
            other: "manner w\xe9i {{count}} Minutten"
        }
    },
    xMinutes: {
        standalone: {
            one: 'eng Minutt',
            other: '{{count}} Minutten'
        },
        withPreposition: {
            one: 'enger Minutt',
            other: '{{count}} Minutten'
        }
    },
    aboutXHours: {
        standalone: {
            one: "ongef\xe9ier eng Stonn",
            other: "ongef\xe9ier {{count}} Stonnen"
        },
        withPreposition: {
            one: "ongef\xe9ier enger Stonn",
            other: "ongef\xe9ier {{count}} Stonnen"
        }
    },
    xHours: {
        standalone: {
            one: 'eng Stonn',
            other: '{{count}} Stonnen'
        },
        withPreposition: {
            one: 'enger Stonn',
            other: '{{count}} Stonnen'
        }
    },
    xDays: {
        standalone: {
            one: 'een Dag',
            other: '{{count}} Deeg'
        },
        withPreposition: {
            one: 'engem Dag',
            other: '{{count}} Deeg'
        }
    },
    aboutXWeeks: {
        standalone: {
            one: "ongef\xe9ier eng Woch",
            other: "ongef\xe9ier {{count}} Wochen"
        },
        withPreposition: {
            one: "ongef\xe9ier enger Woche",
            other: "ongef\xe9ier {{count}} Wochen"
        }
    },
    xWeeks: {
        standalone: {
            one: 'eng Woch',
            other: '{{count}} Wochen'
        },
        withPreposition: {
            one: 'enger Woch',
            other: '{{count}} Wochen'
        }
    },
    aboutXMonths: {
        standalone: {
            one: "ongef\xe9ier ee Mount",
            other: "ongef\xe9ier {{count}} M\xe9int"
        },
        withPreposition: {
            one: "ongef\xe9ier engem Mount",
            other: "ongef\xe9ier {{count}} M\xe9int"
        }
    },
    xMonths: {
        standalone: {
            one: 'ee Mount',
            other: "{{count}} M\xe9int"
        },
        withPreposition: {
            one: 'engem Mount',
            other: "{{count}} M\xe9int"
        }
    },
    aboutXYears: {
        standalone: {
            one: "ongef\xe9ier ee Joer",
            other: "ongef\xe9ier {{count}} Joer"
        },
        withPreposition: {
            one: "ongef\xe9ier engem Joer",
            other: "ongef\xe9ier {{count}} Joer"
        }
    },
    xYears: {
        standalone: {
            one: 'ee Joer',
            other: '{{count}} Joer'
        },
        withPreposition: {
            one: 'engem Joer',
            other: '{{count}} Joer'
        }
    },
    overXYears: {
        standalone: {
            one: "m\xe9i w\xe9i ee Joer",
            other: "m\xe9i w\xe9i {{count}} Joer"
        },
        withPreposition: {
            one: "m\xe9i w\xe9i engem Joer",
            other: "m\xe9i w\xe9i {{count}} Joer"
        }
    },
    almostXYears: {
        standalone: {
            one: 'bal ee Joer',
            other: 'bal {{count}} Joer'
        },
        withPreposition: {
            one: 'bal engem Joer',
            other: 'bal {{count}} Joer'
        }
    }
};
var EXCEPTION_CONSONANTS = [
    'd',
    'h',
    'n',
    't',
    'z'
];
var VOWELS = [
    'a,',
    'e',
    'i',
    'o',
    'u'
];
var DIGITS_SPOKEN_N_NEEDED = [
    0,
    1,
    2,
    3,
    8,
    9
];
var FIRST_TWO_DIGITS_SPOKEN_NO_N_NEEDED = [
    40,
    50,
    60,
    70
];
// Eifeler Regel
function isFinalNNeeded(nextWords) {
    var firstLetter = nextWords.charAt(0).toLowerCase();
    if (VOWELS.indexOf(firstLetter) != -1 || EXCEPTION_CONSONANTS.indexOf(firstLetter) != -1) return true;
    // Numbers would need to converted into words for checking.
    // Therefore, I have listed the digits that require a preceeding n with a few exceptions.
    var firstWord = nextWords.split(' ')[0];
    var number = parseInt(firstWord);
    if (!isNaN(number) && DIGITS_SPOKEN_N_NEEDED.indexOf(number % 10) != -1 && FIRST_TWO_DIGITS_SPOKEN_NO_N_NEEDED.indexOf(parseInt(firstWord.substring(0, 2))) == -1) return true;
    // Omit other checks as they are not expected here.
    return false;
}
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    var usageGroup = options !== null && options !== void 0 && options.addSuffix ? tokenValue.withPreposition : tokenValue.standalone;
    if (typeof usageGroup === 'string') result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else result = usageGroup.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'a' + (isFinalNNeeded(result) ? 'n' : '') + ' ' + result;
        else return 'viru' + (isFinalNNeeded(result) ? 'n' : '') + ' ' + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"kJlxR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js"); // DIN 5008: https://de.wikipedia.org/wiki/Datumsformat#DIN_5008
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, do MMMM y',
    // Méindeg, 7. Januar 2018
    long: 'do MMMM y',
    // 7. Januar 2018
    medium: 'do MMM y',
    // 7. Jan 2018
    short: 'dd.MM.yy' // 07.01.18
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'um' {{time}}",
    long: "{{date}} 'um' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"dCsrU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        var day = date.getUTCDay();
        var result = "'l\xe4schte";
        if (day === 2 || day === 4) // Eifeler Regel: Add an n before the consonant d; Here "Dënschdeg" "and Donneschde".
        result += 'n';
        result += "' eeee 'um' p";
        return result;
    },
    yesterday: "'g\xebschter um' p",
    today: "'haut um' p",
    tomorrow: "'moien um' p",
    nextWeek: "eeee 'um' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"efgMd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'v.Chr.',
        'n.Chr.'
    ],
    abbreviated: [
        'v.Chr.',
        'n.Chr.'
    ],
    wide: [
        'viru Christus',
        'no Christus'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1. Quartal',
        '2. Quartal',
        '3. Quartal',
        '4. Quartal'
    ]
};
var monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        "M\xe4e",
        'Abr',
        'Mee',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Okt',
        'Nov',
        'Dez'
    ],
    wide: [
        'Januar',
        'Februar',
        "M\xe4erz",
        "Abr\xebll",
        'Mee',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'Dezember'
    ]
};
var dayValues = {
    narrow: [
        'S',
        'M',
        'D',
        'M',
        'D',
        'F',
        'S'
    ],
    short: [
        'So',
        "M\xe9",
        "D\xeb",
        "M\xeb",
        'Do',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'So.',
        "M\xe9.",
        "D\xeb.",
        "M\xeb.",
        'Do.',
        'Fr.',
        'Sa.'
    ],
    wide: [
        'Sonndeg',
        "M\xe9indeg",
        "D\xebnschdeg",
        "M\xebttwoch",
        'Donneschdeg',
        'Freideg',
        'Samschdeg'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'mo.',
        pm: "nom\xeb.",
        midnight: "M\xebtternuecht",
        noon: "M\xebtteg",
        morning: 'Moien',
        afternoon: "Nom\xebtteg",
        evening: 'Owend',
        night: 'Nuecht'
    },
    abbreviated: {
        am: 'moies',
        pm: "nom\xebttes",
        midnight: "M\xebtternuecht",
        noon: "M\xebtteg",
        morning: 'Moien',
        afternoon: "Nom\xebtteg",
        evening: 'Owend',
        night: 'Nuecht'
    },
    wide: {
        am: 'moies',
        pm: "nom\xebttes",
        midnight: "M\xebtternuecht",
        noon: "M\xebtteg",
        morning: 'Moien',
        afternoon: "Nom\xebtteg",
        evening: 'Owend',
        night: 'Nuecht'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'mo.',
        pm: 'nom.',
        midnight: "M\xebtternuecht",
        noon: "m\xebttes",
        morning: 'moies',
        afternoon: "nom\xebttes",
        evening: 'owes',
        night: 'nuets'
    },
    abbreviated: {
        am: 'moies',
        pm: "nom\xebttes",
        midnight: "M\xebtternuecht",
        noon: "m\xebttes",
        morning: 'moies',
        afternoon: "nom\xebttes",
        evening: 'owes',
        night: 'nuets'
    },
    wide: {
        am: 'moies',
        pm: "nom\xebttes",
        midnight: "M\xebtternuecht",
        noon: "m\xebttes",
        morning: 'moies',
        afternoon: "nom\xebttes",
        evening: 'owes',
        night: 'nuets'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"9TmJw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    wide: /^(viru Christus|virun eiser Zäitrechnung|no Christus|eiser Zäitrechnung)/i
};
var parseEraPatterns = {
    any: [
        /^v/i,
        /^n/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? Quartal/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mäe|abr|mee|jun|jul|aug|sep|okt|nov|dez)/i,
    wide: /^(januar|februar|mäerz|abrëll|mee|juni|juli|august|september|oktober|november|dezember)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mä/i,
        /^ab/i,
        /^me/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[smdf]/i,
    short: /^(so|mé|dë|më|do|fr|sa)/i,
    abbreviated: /^(son?|méi?|dën?|mët?|don?|fre?|sam?)\.?/i,
    wide: /^(sonndeg|méindeg|dënschdeg|mëttwoch|donneschdeg|freideg|samschdeg)/i
};
var parseDayPatterns = {
    any: [
        /^so/i,
        /^mé/i,
        /^dë/i,
        /^më/i,
        /^do/i,
        /^f/i,
        /^sa/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(mo\.?|nomë\.?|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i,
    abbreviated: /^(moi\.?|nomët\.?|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i,
    wide: /^(moies|nomëttes|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^m/i,
        pm: /^n/i,
        midnight: /^Mëtter/i,
        noon: /^mëttes/i,
        morning: /moies/i,
        afternoon: /nomëttes/i,
        // will never be matched. Afternoon is matched by `pm`
        evening: /owes/i,
        night: /nuets/i // will never be matched. Night is matched by `pm`
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"lC6fD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Lithuanian locale.
 * @language Lithuanian
 * @iso-639-2 lit
 * @author Pavlo Shpak [@pshpak]{@link https://github.com/pshpak}
 * @author Eduardo Pardo [@eduardopsll]{@link https://github.com/eduardopsll}
 */ var locale = {
    code: 'lt',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"27UOX","./_lib/formatLong/index.js":"2EKCh","./_lib/formatRelative/index.js":"kkR5J","./_lib/localize/index.js":"27zuw","./_lib/match/index.js":"fggdQ","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"27UOX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var translations = {
    xseconds_other: "sekund\u0117_sekund\u017Ei\u0173_sekundes",
    xminutes_one: "minut\u0117_minut\u0117s_minut\u0119",
    xminutes_other: "minut\u0117s_minu\u010Di\u0173_minutes",
    xhours_one: "valanda_valandos_valand\u0105",
    xhours_other: "valandos_valand\u0173_valandas",
    xdays_one: "diena_dienos_dien\u0105",
    xdays_other: "dienos_dien\u0173_dienas",
    xweeks_one: "savait\u0117_savait\u0117s_savait\u0119",
    xweeks_other: "savait\u0117s_savai\u010Di\u0173_savaites",
    xmonths_one: "m\u0117nuo_m\u0117nesio_m\u0117nes\u012F",
    xmonths_other: "m\u0117nesiai_m\u0117nesi\u0173_m\u0117nesius",
    xyears_one: "metai_met\u0173_metus",
    xyears_other: "metai_met\u0173_metus",
    about: 'apie',
    over: 'daugiau nei',
    almost: 'beveik',
    lessthan: "ma\u017Eiau nei"
};
var translateSeconds = function translateSeconds(_number, addSuffix, _key, isFuture) {
    if (!addSuffix) return "kelios sekund\u0117s";
    else return isFuture ? "keli\u0173 sekund\u017Ei\u0173" : 'kelias sekundes';
};
var translateSingular = function translateSingular(_number, addSuffix, key, isFuture) {
    return !addSuffix ? forms(key)[0] : isFuture ? forms(key)[1] : forms(key)[2];
};
var translate = function translate(number, addSuffix, key, isFuture) {
    var result = number + ' ';
    if (number === 1) return result + translateSingular(number, addSuffix, key, isFuture);
    else if (!addSuffix) return result + (special(number) ? forms(key)[1] : forms(key)[0]);
    else {
        if (isFuture) return result + forms(key)[1];
        else return result + (special(number) ? forms(key)[1] : forms(key)[2]);
    }
};
function special(number) {
    return number % 10 === 0 || number > 10 && number < 20;
}
function forms(key) {
    return translations[key].split('_');
}
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: translateSeconds,
        other: translate
    },
    xSeconds: {
        one: translateSeconds,
        other: translate
    },
    halfAMinute: "pus\u0117 minut\u0117s",
    lessThanXMinutes: {
        one: translateSingular,
        other: translate
    },
    xMinutes: {
        one: translateSingular,
        other: translate
    },
    aboutXHours: {
        one: translateSingular,
        other: translate
    },
    xHours: {
        one: translateSingular,
        other: translate
    },
    xDays: {
        one: translateSingular,
        other: translate
    },
    aboutXWeeks: {
        one: translateSingular,
        other: translate
    },
    xWeeks: {
        one: translateSingular,
        other: translate
    },
    aboutXMonths: {
        one: translateSingular,
        other: translate
    },
    xMonths: {
        one: translateSingular,
        other: translate
    },
    aboutXYears: {
        one: translateSingular,
        other: translate
    },
    xYears: {
        one: translateSingular,
        other: translate
    },
    overXYears: {
        one: translateSingular,
        other: translate
    },
    almostXYears: {
        one: translateSingular,
        other: translate
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var adverb = token.match(/about|over|almost|lessthan/i);
    var unit = adverb ? token.replace(adverb[0], '') : token;
    var isFuture = (options === null || options === void 0 ? void 0 : options.comparison) !== undefined && options.comparison > 0;
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one(count, (options === null || options === void 0 ? void 0 : options.addSuffix) === true, unit.toLowerCase() + '_one', isFuture);
    else result = tokenValue.other(count, (options === null || options === void 0 ? void 0 : options.addSuffix) === true, unit.toLowerCase() + '_other', isFuture);
    if (adverb) {
        var _key2 = adverb[0].toLowerCase();
        result = translations[_key2] + ' ' + result;
    }
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'po ' + result;
        else return "prie\u0161 " + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2EKCh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "y 'm'. MMMM d 'd'., EEEE",
    long: "y 'm'. MMMM d 'd'.",
    medium: 'y-MM-dd',
    short: 'y-MM-dd'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"kkR5J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'Pra\u0117jus\u012F' eeee p",
    yesterday: "'Vakar' p",
    today: "'\u0160iandien' p",
    tomorrow: "'Rytoj' p",
    nextWeek: 'eeee p',
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"27zuw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'pr. Kr.',
        'po Kr.'
    ],
    abbreviated: [
        'pr. Kr.',
        'po Kr.'
    ],
    wide: [
        "prie\u0161 Krist\u0173",
        'po Kristaus'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'I ketv.',
        'II ketv.',
        'III ketv.',
        'IV ketv.'
    ],
    wide: [
        'I ketvirtis',
        'II ketvirtis',
        'III ketvirtis',
        'IV ketvirtis'
    ]
};
var formattingQuarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'I k.',
        'II k.',
        'III k.',
        'IV k.'
    ],
    wide: [
        'I ketvirtis',
        'II ketvirtis',
        'III ketvirtis',
        'IV ketvirtis'
    ]
};
var monthValues = {
    narrow: [
        'S',
        'V',
        'K',
        'B',
        'G',
        'B',
        'L',
        'R',
        'R',
        'S',
        'L',
        'G'
    ],
    abbreviated: [
        'saus.',
        'vas.',
        'kov.',
        'bal.',
        'geg.',
        "bir\u017E.",
        'liep.',
        'rugp.',
        'rugs.',
        'spal.',
        'lapkr.',
        'gruod.'
    ],
    wide: [
        'sausis',
        'vasaris',
        'kovas',
        'balandis',
        "gegu\u017E\u0117",
        "bir\u017Eelis",
        'liepa',
        "rugpj\u016Btis",
        "rugs\u0117jis",
        'spalis',
        'lapkritis',
        'gruodis'
    ]
};
var formattingMonthValues = {
    narrow: [
        'S',
        'V',
        'K',
        'B',
        'G',
        'B',
        'L',
        'R',
        'R',
        'S',
        'L',
        'G'
    ],
    abbreviated: [
        'saus.',
        'vas.',
        'kov.',
        'bal.',
        'geg.',
        "bir\u017E.",
        'liep.',
        'rugp.',
        'rugs.',
        'spal.',
        'lapkr.',
        'gruod.'
    ],
    wide: [
        'sausio',
        'vasario',
        'kovo',
        "baland\u017Eio",
        "gegu\u017E\u0117s",
        "bir\u017Eelio",
        'liepos',
        "rugpj\u016B\u010Dio",
        "rugs\u0117jo",
        'spalio',
        "lapkri\u010Dio",
        "gruod\u017Eio"
    ]
};
var dayValues = {
    narrow: [
        'S',
        'P',
        'A',
        'T',
        'K',
        'P',
        "\u0160"
    ],
    short: [
        'Sk',
        'Pr',
        'An',
        'Tr',
        'Kt',
        'Pn',
        "\u0160t"
    ],
    abbreviated: [
        'sk',
        'pr',
        'an',
        'tr',
        'kt',
        'pn',
        "\u0161t"
    ],
    wide: [
        'sekmadienis',
        'pirmadienis',
        'antradienis',
        "tre\u010Diadienis",
        'ketvirtadienis',
        'penktadienis',
        "\u0161e\u0161tadienis"
    ]
};
var formattingDayValues = {
    narrow: [
        'S',
        'P',
        'A',
        'T',
        'K',
        'P',
        "\u0160"
    ],
    short: [
        'Sk',
        'Pr',
        'An',
        'Tr',
        'Kt',
        'Pn',
        "\u0160t"
    ],
    abbreviated: [
        'sk',
        'pr',
        'an',
        'tr',
        'kt',
        'pn',
        "\u0161t"
    ],
    wide: [
        "sekmadien\u012F",
        "pirmadien\u012F",
        "antradien\u012F",
        "tre\u010Diadien\u012F",
        "ketvirtadien\u012F",
        "penktadien\u012F",
        "\u0161e\u0161tadien\u012F"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'pr. p.',
        pm: 'pop.',
        midnight: 'vidurnaktis',
        noon: 'vidurdienis',
        morning: 'rytas',
        afternoon: 'diena',
        evening: 'vakaras',
        night: 'naktis'
    },
    abbreviated: {
        am: "prie\u0161piet",
        pm: 'popiet',
        midnight: 'vidurnaktis',
        noon: 'vidurdienis',
        morning: 'rytas',
        afternoon: 'diena',
        evening: 'vakaras',
        night: 'naktis'
    },
    wide: {
        am: "prie\u0161piet",
        pm: 'popiet',
        midnight: 'vidurnaktis',
        noon: 'vidurdienis',
        morning: 'rytas',
        afternoon: 'diena',
        evening: 'vakaras',
        night: 'naktis'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'pr. p.',
        pm: 'pop.',
        midnight: 'vidurnaktis',
        noon: 'perpiet',
        morning: 'rytas',
        afternoon: "popiet\u0117",
        evening: 'vakaras',
        night: 'naktis'
    },
    abbreviated: {
        am: "prie\u0161piet",
        pm: 'popiet',
        midnight: 'vidurnaktis',
        noon: 'perpiet',
        morning: 'rytas',
        afternoon: "popiet\u0117",
        evening: 'vakaras',
        night: 'naktis'
    },
    wide: {
        am: "prie\u0161piet",
        pm: 'popiet',
        midnight: 'vidurnaktis',
        noon: 'perpiet',
        morning: 'rytas',
        afternoon: "popiet\u0117",
        evening: 'vakaras',
        night: 'naktis'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '-oji';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        formattingValues: formattingQuarterValues,
        defaultFormattingWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide',
        formattingValues: formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayValues,
        defaultFormattingWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"fggdQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(-oji)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^p(r|o)\.?\s?(kr\.?|me)/i,
    abbreviated: /^(pr\.\s?(kr\.|m\.\s?e\.)|po\s?kr\.|mūsų eroje)/i,
    wide: /^(prieš Kristų|prieš mūsų erą|po Kristaus|mūsų eroje)/i
};
var parseEraPatterns = {
    wide: [
        /prieš/i,
        /(po|mūsų)/i
    ],
    any: [
        /^pr/i,
        /^(po|m)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^([1234])/i,
    abbreviated: /^(I|II|III|IV)\s?ketv?\.?/i,
    wide: /^(I|II|III|IV)\s?ketvirtis/i
};
var parseQuarterPatterns = {
    narrow: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ],
    any: [
        /I$/i,
        /II$/i,
        /III/i,
        /IV/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[svkbglr]/i,
    abbreviated: /^(saus\.|vas\.|kov\.|bal\.|geg\.|birž\.|liep\.|rugp\.|rugs\.|spal\.|lapkr\.|gruod\.)/i,
    wide: /^(sausi(s|o)|vasari(s|o)|kov(a|o)s|balandž?i(s|o)|gegužės?|birželi(s|o)|liep(a|os)|rugpjū(t|č)i(s|o)|rugsėj(is|o)|spali(s|o)|lapkri(t|č)i(s|o)|gruodž?i(s|o))/i
};
var parseMonthPatterns = {
    narrow: [
        /^s/i,
        /^v/i,
        /^k/i,
        /^b/i,
        /^g/i,
        /^b/i,
        /^l/i,
        /^r/i,
        /^r/i,
        /^s/i,
        /^l/i,
        /^g/i
    ],
    any: [
        /^saus/i,
        /^vas/i,
        /^kov/i,
        /^bal/i,
        /^geg/i,
        /^birž/i,
        /^liep/i,
        /^rugp/i,
        /^rugs/i,
        /^spal/i,
        /^lapkr/i,
        /^gruod/i
    ]
};
var matchDayPatterns = {
    narrow: /^[spatkš]/i,
    short: /^(sk|pr|an|tr|kt|pn|št)/i,
    abbreviated: /^(sk|pr|an|tr|kt|pn|št)/i,
    wide: /^(sekmadien(is|į)|pirmadien(is|į)|antradien(is|į)|trečiadien(is|į)|ketvirtadien(is|į)|penktadien(is|į)|šeštadien(is|į))/i
};
var parseDayPatterns = {
    narrow: [
        /^s/i,
        /^p/i,
        /^a/i,
        /^t/i,
        /^k/i,
        /^p/i,
        /^š/i
    ],
    wide: [
        /^se/i,
        /^pi/i,
        /^an/i,
        /^tr/i,
        /^ke/i,
        /^pe/i,
        /^še/i
    ],
    any: [
        /^sk/i,
        /^pr/i,
        /^an/i,
        /^tr/i,
        /^kt/i,
        /^pn/i,
        /^št/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(pr.\s?p.|pop.|vidurnaktis|(vidurdienis|perpiet)|rytas|(diena|popietė)|vakaras|naktis)/i,
    any: /^(priešpiet|popiet$|vidurnaktis|(vidurdienis|perpiet)|rytas|(diena|popietė)|vakaras|naktis)/i
};
var parseDayPeriodPatterns = {
    narrow: {
        am: /^pr/i,
        pm: /^pop./i,
        midnight: /^vidurnaktis/i,
        noon: /^(vidurdienis|perp)/i,
        morning: /rytas/i,
        afternoon: /(die|popietė)/i,
        evening: /vakaras/i,
        night: /naktis/i
    },
    any: {
        am: /^pr/i,
        pm: /^popiet$/i,
        midnight: /^vidurnaktis/i,
        noon: /^(vidurdienis|perp)/i,
        morning: /rytas/i,
        afternoon: /(die|popietė)/i,
        evening: /vakaras/i,
        night: /naktis/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"luANn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Latvian locale (Latvia).
 * @language Latvian
 * @iso-639-2 lav
 * @author Rūdolfs Puķītis [@prudolfs]{@link https://github.com/prudolfs}
 */ var locale = {
    code: 'lv',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"36mXP","./_lib/formatLong/index.js":"dCL70","./_lib/formatRelative/index.js":"6wCjK","./_lib/localize/index.js":"4ViyN","./_lib/match/index.js":"jhLGX","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"36mXP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function buildLocalizeTokenFn(schema) {
    return function(count, options) {
        if (count === 1) {
            if (options !== null && options !== void 0 && options.addSuffix) return schema.one[0].replace('{{time}}', schema.one[2]);
            else return schema.one[0].replace('{{time}}', schema.one[1]);
        } else {
            var rem = count % 10 === 1 && count % 100 !== 11;
            if (options !== null && options !== void 0 && options.addSuffix) return schema.other[0].replace('{{time}}', rem ? schema.other[3] : schema.other[4]).replace('{{count}}', String(count));
            else return schema.other[0].replace('{{time}}', rem ? schema.other[1] : schema.other[2]).replace('{{count}}', String(count));
        }
    };
}
var formatDistanceLocale = {
    lessThanXSeconds: buildLocalizeTokenFn({
        one: [
            "maz\u0101k par {{time}}",
            'sekundi',
            'sekundi'
        ],
        other: [
            "maz\u0101k nek\u0101 {{count}} {{time}}",
            'sekunde',
            'sekundes',
            'sekundes',
            "sekund\u0113m"
        ]
    }),
    xSeconds: buildLocalizeTokenFn({
        one: [
            '1 {{time}}',
            'sekunde',
            'sekundes'
        ],
        other: [
            '{{count}} {{time}}',
            'sekunde',
            'sekundes',
            'sekundes',
            "sekund\u0113m"
        ]
    }),
    halfAMinute: function halfAMinute(_count, options) {
        if (options !== null && options !== void 0 && options.addSuffix) return "pusmin\u016Btes";
        else return "pusmin\u016Bte";
    },
    lessThanXMinutes: buildLocalizeTokenFn({
        one: [
            "maz\u0101k par {{time}}",
            "min\u016Bti",
            "min\u016Bti"
        ],
        other: [
            "maz\u0101k nek\u0101 {{count}} {{time}}",
            "min\u016Bte",
            "min\u016Btes",
            "min\u016Btes",
            "min\u016Bt\u0113m"
        ]
    }),
    xMinutes: buildLocalizeTokenFn({
        one: [
            '1 {{time}}',
            "min\u016Bte",
            "min\u016Btes"
        ],
        other: [
            '{{count}} {{time}}',
            "min\u016Bte",
            "min\u016Btes",
            "min\u016Btes",
            "min\u016Bt\u0113m"
        ]
    }),
    aboutXHours: buildLocalizeTokenFn({
        one: [
            "apm\u0113ram 1 {{time}}",
            'stunda',
            'stundas'
        ],
        other: [
            "apm\u0113ram {{count}} {{time}}",
            'stunda',
            'stundas',
            'stundas',
            "stund\u0101m"
        ]
    }),
    xHours: buildLocalizeTokenFn({
        one: [
            '1 {{time}}',
            'stunda',
            'stundas'
        ],
        other: [
            '{{count}} {{time}}',
            'stunda',
            'stundas',
            'stundas',
            "stund\u0101m"
        ]
    }),
    xDays: buildLocalizeTokenFn({
        one: [
            '1 {{time}}',
            'diena',
            'dienas'
        ],
        other: [
            '{{count}} {{time}}',
            'diena',
            'dienas',
            'dienas',
            "dien\u0101m"
        ]
    }),
    aboutXWeeks: buildLocalizeTokenFn({
        one: [
            "apm\u0113ram 1 {{time}}",
            "ned\u0113\u013Ca",
            "ned\u0113\u013Cas"
        ],
        other: [
            "apm\u0113ram {{count}} {{time}}",
            "ned\u0113\u013Ca",
            "ned\u0113\u013Cu",
            "ned\u0113\u013Cas",
            "ned\u0113\u013C\u0101m"
        ]
    }),
    xWeeks: buildLocalizeTokenFn({
        one: [
            '1 {{time}}',
            "ned\u0113\u013Ca",
            "ned\u0113\u013Cas"
        ],
        other: [
            '{{count}} {{time}}',
            // TODO
            "ned\u0113\u013Ca",
            "ned\u0113\u013Cu",
            "ned\u0113\u013Cas",
            "ned\u0113\u013C\u0101m"
        ]
    }),
    aboutXMonths: buildLocalizeTokenFn({
        one: [
            "apm\u0113ram 1 {{time}}",
            "m\u0113nesis",
            "m\u0113ne\u0161a"
        ],
        other: [
            "apm\u0113ram {{count}} {{time}}",
            "m\u0113nesis",
            "m\u0113ne\u0161i",
            "m\u0113ne\u0161a",
            "m\u0113ne\u0161iem"
        ]
    }),
    xMonths: buildLocalizeTokenFn({
        one: [
            '1 {{time}}',
            "m\u0113nesis",
            "m\u0113ne\u0161a"
        ],
        other: [
            '{{count}} {{time}}',
            "m\u0113nesis",
            "m\u0113ne\u0161i",
            "m\u0113ne\u0161a",
            "m\u0113ne\u0161iem"
        ]
    }),
    aboutXYears: buildLocalizeTokenFn({
        one: [
            "apm\u0113ram 1 {{time}}",
            'gads',
            'gada'
        ],
        other: [
            "apm\u0113ram {{count}} {{time}}",
            'gads',
            'gadi',
            'gada',
            'gadiem'
        ]
    }),
    xYears: buildLocalizeTokenFn({
        one: [
            '1 {{time}}',
            'gads',
            'gada'
        ],
        other: [
            '{{count}} {{time}}',
            'gads',
            'gadi',
            'gada',
            'gadiem'
        ]
    }),
    overXYears: buildLocalizeTokenFn({
        one: [
            "ilg\u0101k par 1 {{time}}",
            'gadu',
            'gadu'
        ],
        other: [
            "vair\u0101k nek\u0101 {{count}} {{time}}",
            'gads',
            'gadi',
            'gada',
            'gadiem'
        ]
    }),
    almostXYears: buildLocalizeTokenFn({
        one: [
            "gandr\u012Bz 1 {{time}}",
            'gads',
            'gada'
        ],
        other: [
            "vair\u0101k nek\u0101 {{count}} {{time}}",
            'gads',
            'gadi',
            'gada',
            'gadiem'
        ]
    })
};
var formatDistance = function formatDistance(token, count, options) {
    var result = formatDistanceLocale[token](count, options);
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "p\u0113c " + result;
        else return 'pirms ' + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"dCL70":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE, y. 'gada' d. MMMM",
    long: "y. 'gada' d. MMMM",
    medium: 'dd.MM.y.',
    short: 'dd.MM.y.'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'plkst.' {{time}}",
    long: "{{date}} 'plkst.' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6wCjK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../../_lib/isSameUTCWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var weekdays = [
    "sv\u0113tdien\u0101",
    "pirmdien\u0101",
    "otrdien\u0101",
    "tre\u0161dien\u0101",
    "ceturtdien\u0101",
    "piektdien\u0101",
    "sestdien\u0101"
];
var formatRelativeLocale = {
    lastWeek: function lastWeek(date, baseDate, options) {
        if ((0, _indexJsDefault.default)(date, baseDate, options)) return "eeee 'plkst.' p";
        var weekday = weekdays[date.getUTCDay()];
        return "'Pag\u0101ju\u0161\u0101 " + weekday + " plkst.' p";
    },
    yesterday: "'Vakar plkst.' p",
    today: "'\u0160odien plkst.' p",
    tomorrow: "'R\u012Bt plkst.' p",
    nextWeek: function nextWeek(date, baseDate, options) {
        if ((0, _indexJsDefault.default)(date, baseDate, options)) return "eeee 'plkst.' p";
        var weekday = weekdays[date.getUTCDay()];
        return "'N\u0101kamaj\u0101 " + weekday + " plkst.' p";
    },
    other: 'P'
};
var formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
exports.default = formatRelative;

},{"../../../../_lib/isSameUTCWeek/index.js":"g7rCW","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4ViyN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "p.m.\u0113",
        "m.\u0113"
    ],
    abbreviated: [
        "p. m. \u0113.",
        "m. \u0113."
    ],
    wide: [
        "pirms m\u016Bsu \u0113ras",
        "m\u016Bsu \u0113r\u0101"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        '1. cet.',
        '2. cet.',
        '3. cet.',
        '4. cet.'
    ],
    wide: [
        'pirmais ceturksnis',
        'otrais ceturksnis',
        "tre\u0161ais ceturksnis",
        'ceturtais ceturksnis'
    ]
};
var formattingQuarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        '1. cet.',
        '2. cet.',
        '3. cet.',
        '4. cet.'
    ],
    wide: [
        "pirmaj\u0101 ceturksn\u012B",
        "otraj\u0101 ceturksn\u012B",
        "tre\u0161aj\u0101 ceturksn\u012B",
        "ceturtaj\u0101 ceturksn\u012B"
    ]
};
var monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'janv.',
        'febr.',
        'marts',
        'apr.',
        'maijs',
        "j\u016Bn.",
        "j\u016Bl.",
        'aug.',
        'sept.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        "janv\u0101ris",
        "febru\u0101ris",
        'marts',
        "apr\u012Blis",
        'maijs',
        "j\u016Bnijs",
        "j\u016Blijs",
        'augusts',
        'septembris',
        'oktobris',
        'novembris',
        'decembris'
    ]
};
var formattingMonthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'janv.',
        'febr.',
        "mart\u0101",
        'apr.',
        'maijs',
        "j\u016Bn.",
        "j\u016Bl.",
        'aug.',
        'sept.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        "janv\u0101r\u012B",
        "febru\u0101r\u012B",
        "mart\u0101",
        "apr\u012Bl\u012B",
        "maij\u0101",
        "j\u016Bnij\u0101",
        "j\u016Blij\u0101",
        "august\u0101",
        "septembr\u012B",
        "oktobr\u012B",
        "novembr\u012B",
        "decembr\u012B"
    ]
};
var dayValues = {
    narrow: [
        'S',
        'P',
        'O',
        'T',
        'C',
        'P',
        'S'
    ],
    short: [
        'Sv',
        'P',
        'O',
        'T',
        'C',
        'Pk',
        'S'
    ],
    abbreviated: [
        "sv\u0113td.",
        'pirmd.',
        'otrd.',
        "tre\u0161d.",
        'ceturtd.',
        'piektd.',
        'sestd.'
    ],
    wide: [
        "sv\u0113tdiena",
        'pirmdiena',
        'otrdiena',
        "tre\u0161diena",
        'ceturtdiena',
        'piektdiena',
        'sestdiena'
    ]
};
var formattingDayValues = {
    narrow: [
        'S',
        'P',
        'O',
        'T',
        'C',
        'P',
        'S'
    ],
    short: [
        'Sv',
        'P',
        'O',
        'T',
        'C',
        'Pk',
        'S'
    ],
    abbreviated: [
        "sv\u0113td.",
        'pirmd.',
        'otrd.',
        "tre\u0161d.",
        'ceturtd.',
        'piektd.',
        'sestd.'
    ],
    wide: [
        "sv\u0113tdien\u0101",
        "pirmdien\u0101",
        "otrdien\u0101",
        "tre\u0161dien\u0101",
        "ceturtdien\u0101",
        "piektdien\u0101",
        "sestdien\u0101"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: 'pusn.',
        noon: 'pusd.',
        morning: "r\u012Bts",
        afternoon: 'diena',
        evening: 'vakars',
        night: 'nakts'
    },
    abbreviated: {
        am: 'am',
        pm: 'pm',
        midnight: 'pusn.',
        noon: 'pusd.',
        morning: "r\u012Bts",
        afternoon: "p\u0113cpusd.",
        evening: 'vakars',
        night: 'nakts'
    },
    wide: {
        am: 'am',
        pm: 'pm',
        midnight: 'pusnakts',
        noon: 'pusdienlaiks',
        morning: "r\u012Bts",
        afternoon: "p\u0113cpusdiena",
        evening: 'vakars',
        night: 'nakts'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: 'pusn.',
        noon: 'pusd.',
        morning: "r\u012Bt\u0101",
        afternoon: "dien\u0101",
        evening: "vakar\u0101",
        night: "nakt\u012B"
    },
    abbreviated: {
        am: 'am',
        pm: 'pm',
        midnight: 'pusn.',
        noon: 'pusd.',
        morning: "r\u012Bt\u0101",
        afternoon: "p\u0113cpusd.",
        evening: "vakar\u0101",
        night: "nakt\u012B"
    },
    wide: {
        am: 'am',
        pm: 'pm',
        midnight: "pusnakt\u012B",
        noon: "pusdienlaik\u0101",
        morning: "r\u012Bt\u0101",
        afternoon: "p\u0113cpusdien\u0101",
        evening: "vakar\u0101",
        night: "nakt\u012B"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        formattingValues: formattingQuarterValues,
        defaultFormattingWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide',
        formattingValues: formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayValues,
        defaultFormattingWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jhLGX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)\./i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(p\.m\.ē|m\.ē)/i,
    abbreviated: /^(p\. m\. ē\.|m\. ē\.)/i,
    wide: /^(pirms mūsu ēras|mūsu ērā)/i
};
var parseEraPatterns = {
    any: [
        /^p/i,
        /^m/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](\. cet\.)/i,
    wide: /^(pirma(is|jā)|otra(is|jā)|treša(is|jā)|ceturta(is|jā)) ceturksn(is|ī)/i
};
var parseQuarterPatterns = {
    narrow: [
        /^1/i,
        /^2/i,
        /^3/i,
        /^4/i
    ],
    abbreviated: [
        /^1/i,
        /^2/i,
        /^3/i,
        /^4/i
    ],
    wide: [
        /^p/i,
        /^o/i,
        /^t/i,
        /^c/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(janv\.|febr\.|marts|apr\.|maijs|jūn\.|jūl\.|aug\.|sept\.|okt\.|nov\.|dec\.)/i,
    wide: /^(janvār(is|ī)|februār(is|ī)|mart[sā]|aprīl(is|ī)|maij[sā]|jūnij[sā]|jūlij[sā]|august[sā]|septembr(is|ī)|oktobr(is|ī)|novembr(is|ī)|decembr(is|ī))/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mai/i,
        /^jūn/i,
        /^jūl/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[spotc]/i,
    short: /^(sv|pi|o|t|c|pk|s)/i,
    abbreviated: /^(svētd\.|pirmd\.|otrd.\|trešd\.|ceturtd\.|piektd\.|sestd\.)/i,
    wide: /^(svētdien(a|ā)|pirmdien(a|ā)|otrdien(a|ā)|trešdien(a|ā)|ceturtdien(a|ā)|piektdien(a|ā)|sestdien(a|ā))/i
};
var parseDayPatterns = {
    narrow: [
        /^s/i,
        /^p/i,
        /^o/i,
        /^t/i,
        /^c/i,
        /^p/i,
        /^s/i
    ],
    any: [
        /^sv/i,
        /^pi/i,
        /^o/i,
        /^t/i,
        /^c/i,
        /^p/i,
        /^se/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(am|pm|pusn\.|pusd\.|rīt(s|ā)|dien(a|ā)|vakar(s|ā)|nakt(s|ī))/,
    abbreviated: /^(am|pm|pusn\.|pusd\.|rīt(s|ā)|pēcpusd\.|vakar(s|ā)|nakt(s|ī))/,
    wide: /^(am|pm|pusnakt(s|ī)|pusdienlaik(s|ā)|rīt(s|ā)|pēcpusdien(a|ā)|vakar(s|ā)|nakt(s|ī))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /^pusn/i,
        noon: /^pusd/i,
        morning: /^r/i,
        afternoon: /^(d|pēc)/i,
        evening: /^v/i,
        night: /^n/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'wide',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"9EBdt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Macedonian locale.
 * @language Macedonian
 * @iso-639-2 mkd
 * @author Petar Vlahu [@vlahupetar]{@link https://github.com/vlahupetar}
 * @author Altrim Beqiri [@altrim]{@link https://github.com/altrim}
 */ var locale = {
    code: 'mk',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"aGLot","./_lib/formatLong/index.js":"lPE1j","./_lib/formatRelative/index.js":"77bKC","./_lib/localize/index.js":"gs6pl","./_lib/match/index.js":"6H0nJ","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"aGLot":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u043F\u043E\u043C\u0430\u043B\u043A\u0443 \u043E\u0434 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
        other: "\u043F\u043E\u043C\u0430\u043B\u043A\u0443 \u043E\u0434 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
    },
    xSeconds: {
        one: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
        other: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
    },
    halfAMinute: "\u043F\u043E\u043B\u043E\u0432\u0438\u043D\u0430 \u043C\u0438\u043D\u0443\u0442\u0430",
    lessThanXMinutes: {
        one: "\u043F\u043E\u043C\u0430\u043B\u043A\u0443 \u043E\u0434 \u043C\u0438\u043D\u0443\u0442\u0430",
        other: "\u043F\u043E\u043C\u0430\u043B\u043A\u0443 \u043E\u0434 {{count}} \u043C\u0438\u043D\u0443\u0442\u0438"
    },
    xMinutes: {
        one: "1 \u043C\u0438\u043D\u0443\u0442\u0430",
        other: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0438"
    },
    aboutXHours: {
        one: "\u043E\u043A\u043E\u043B\u0443 1 \u0447\u0430\u0441",
        other: "\u043E\u043A\u043E\u043B\u0443 {{count}} \u0447\u0430\u0441\u0430"
    },
    xHours: {
        one: "1 \u0447\u0430\u0441",
        other: "{{count}} \u0447\u0430\u0441\u0430"
    },
    xDays: {
        one: "1 \u0434\u0435\u043D",
        other: "{{count}} \u0434\u0435\u043D\u0430"
    },
    aboutXWeeks: {
        one: "\u043E\u043A\u043E\u043B\u0443 1 \u043D\u0435\u0434\u0435\u043B\u0430",
        other: "\u043E\u043A\u043E\u043B\u0443 {{count}} \u043C\u0435\u0441\u0435\u0446\u0438"
    },
    xWeeks: {
        one: "1 \u043D\u0435\u0434\u0435\u043B\u0430",
        other: "{{count}} \u043D\u0435\u0434\u0435\u043B\u0438"
    },
    aboutXMonths: {
        one: "\u043E\u043A\u043E\u043B\u0443 1 \u043C\u0435\u0441\u0435\u0446",
        other: "\u043E\u043A\u043E\u043B\u0443 {{count}} \u043D\u0435\u0434\u0435\u043B\u0438"
    },
    xMonths: {
        one: "1 \u043C\u0435\u0441\u0435\u0446",
        other: "{{count}} \u043C\u0435\u0441\u0435\u0446\u0438"
    },
    aboutXYears: {
        one: "\u043E\u043A\u043E\u043B\u0443 1 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u043E\u043A\u043E\u043B\u0443 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    },
    xYears: {
        one: "1 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    },
    overXYears: {
        one: "\u043F\u043E\u0432\u0435\u045C\u0435 \u043E\u0434 1 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u043F\u043E\u0432\u0435\u045C\u0435 \u043E\u0434 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    },
    almostXYears: {
        one: "\u0431\u0435\u0437\u043C\u0430\u043B\u043A\u0443 1 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u0431\u0435\u0437\u043C\u0430\u043B\u043A\u0443 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0437\u0430 " + result;
        else return "\u043F\u0440\u0435\u0434 " + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"lPE1j":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, dd MMMM yyyy',
    long: 'dd MMMM yyyy',
    medium: 'dd MMM yyyy',
    short: 'dd/MM/yyyy'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'H:mm'
};
var dateTimeFormats = {
    any: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'any'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"77bKC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../../_lib/isSameUTCWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var weekdays = [
    "\u043D\u0435\u0434\u0435\u043B\u0430",
    "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A",
    "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
    "\u0441\u0440\u0435\u0434\u0430",
    "\u0447\u0435\u0442\u0432\u0440\u0442\u043E\u043A",
    "\u043F\u0435\u0442\u043E\u043A",
    "\u0441\u0430\u0431\u043E\u0442\u0430"
];
function _lastWeek(day) {
    var weekday = weekdays[day];
    switch(day){
        case 0:
        case 3:
        case 6:
            return "'\u043C\u0438\u043D\u0430\u0442\u0430\u0442\u0430 " + weekday + " \u0432\u043E' p";
        case 1:
        case 2:
        case 4:
        case 5:
            return "'\u043C\u0438\u043D\u0430\u0442\u0438\u043E\u0442 " + weekday + " \u0432\u043E' p";
    }
}
function thisWeek(day) {
    var weekday = weekdays[day];
    switch(day){
        case 0:
        case 3:
        case 6:
            return "'\u043E\u0432\u0430 " + weekday + " \u0432o' p";
        case 1:
        case 2:
        case 4:
        case 5:
            return "'\u043E\u0432\u043E\u0458 " + weekday + " \u0432o' p";
    }
}
function _nextWeek(day) {
    var weekday = weekdays[day];
    switch(day){
        case 0:
        case 3:
        case 6:
            return "'\u0441\u043B\u0435\u0434\u043D\u0430\u0442\u0430 " + weekday + " \u0432o' p";
        case 1:
        case 2:
        case 4:
        case 5:
            return "'\u0441\u043B\u0435\u0434\u043D\u0438\u043E\u0442 " + weekday + " \u0432o' p";
    }
}
var formatRelativeLocale = {
    lastWeek: function lastWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, _indexJsDefault.default)(date, baseDate, options)) return thisWeek(day);
        else return _lastWeek(day);
    },
    yesterday: "'\u0432\u0447\u0435\u0440\u0430 \u0432\u043E' p",
    today: "'\u0434\u0435\u043D\u0435\u0441 \u0432\u043E' p",
    tomorrow: "'\u0443\u0442\u0440\u0435 \u0432\u043E' p",
    nextWeek: function nextWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, _indexJsDefault.default)(date, baseDate, options)) return thisWeek(day);
        else return _nextWeek(day);
    },
    other: 'P'
};
var formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
exports.default = formatRelative;

},{"../../../../_lib/isSameUTCWeek/index.js":"g7rCW","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gs6pl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u043F\u0440.\u043D.\u0435.",
        "\u043D.\u0435."
    ],
    abbreviated: [
        "\u043F\u0440\u0435\u0434 \u043D. \u0435.",
        "\u043D. \u0435."
    ],
    wide: [
        "\u043F\u0440\u0435\u0434 \u043D\u0430\u0448\u0430\u0442\u0430 \u0435\u0440\u0430",
        "\u043D\u0430\u0448\u0430\u0442\u0430 \u0435\u0440\u0430"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1-\u0432\u0438 \u043A\u0432.",
        "2-\u0440\u0438 \u043A\u0432.",
        "3-\u0442\u0438 \u043A\u0432.",
        "4-\u0442\u0438 \u043A\u0432."
    ],
    wide: [
        "1-\u0432\u0438 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2-\u0440\u0438 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3-\u0442\u0438 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4-\u0442\u0438 \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
var monthValues = {
    abbreviated: [
        "\u0458\u0430\u043D",
        "\u0444\u0435\u0432",
        "\u043C\u0430\u0440",
        "\u0430\u043F\u0440",
        "\u043C\u0430\u0458",
        "\u0458\u0443\u043D",
        "\u0458\u0443\u043B",
        "\u0430\u0432\u0433",
        "\u0441\u0435\u043F\u0442",
        "\u043E\u043A\u0442",
        "\u043D\u043E\u0435\u043C",
        "\u0434\u0435\u043A"
    ],
    wide: [
        "\u0458\u0430\u043D\u0443\u0430\u0440\u0438",
        "\u0444\u0435\u0432\u0440\u0443\u0430\u0440\u0438",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0438\u043B",
        "\u043C\u0430\u0458",
        "\u0458\u0443\u043D\u0438",
        "\u0458\u0443\u043B\u0438",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043F\u0442\u0435\u043C\u0432\u0440\u0438",
        "\u043E\u043A\u0442\u043E\u043C\u0432\u0440\u0438",
        "\u043D\u043E\u0435\u043C\u0432\u0440\u0438",
        "\u0434\u0435\u043A\u0435\u043C\u0432\u0440\u0438"
    ]
};
var dayValues = {
    narrow: [
        "\u041D",
        "\u041F",
        "\u0412",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u043D\u0435",
        "\u043F\u043E",
        "\u0432\u0442",
        "\u0441\u0440",
        "\u0447\u0435",
        "\u043F\u0435",
        "\u0441\u0430"
    ],
    abbreviated: [
        "\u043D\u0435\u0434",
        "\u043F\u043E\u043D",
        "\u0432\u0442\u043E",
        "\u0441\u0440\u0435",
        "\u0447\u0435\u0442",
        "\u043F\u0435\u0442",
        "\u0441\u0430\u0431"
    ],
    wide: [
        "\u043D\u0435\u0434\u0435\u043B\u0430",
        "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A",
        "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
        "\u0441\u0440\u0435\u0434\u0430",
        "\u0447\u0435\u0442\u0432\u0440\u0442\u043E\u043A",
        "\u043F\u0435\u0442\u043E\u043A",
        "\u0441\u0430\u0431\u043E\u0442\u0430"
    ]
};
var dayPeriodValues = {
    wide: {
        am: "\u043F\u0440\u0435\u0442\u043F\u043B\u0430\u0434\u043D\u0435",
        pm: "\u043F\u043E\u043F\u043B\u0430\u0434\u043D\u0435",
        midnight: "\u043F\u043E\u043B\u043D\u043E\u045C",
        noon: "\u043D\u0430\u043F\u043B\u0430\u0434\u043D\u0435",
        morning: "\u043D\u0430\u0443\u0442\u0440\u043E",
        afternoon: "\u043F\u043E\u043F\u043B\u0430\u0434\u043D\u0435",
        evening: "\u043D\u0430\u0432\u0435\u0447\u0435\u0440",
        night: "\u043D\u043E\u045C\u0435"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "-\u0432\u0438";
        case 2:
            return number + "-\u0440\u0438";
        case 7:
        case 8:
            return number + "-\u043C\u0438";
    }
    return number + "-\u0442\u0438";
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6H0nJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(-?[врмт][и])?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^((пр)?н\.?\s?е\.?)/i,
    abbreviated: /^((пр)?н\.?\s?е\.?)/i,
    wide: /^(пред нашата ера|нашата ера)/i
};
var parseEraPatterns = {
    any: [
        /^п/i,
        /^н/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[врт]?и?)? кв.?/i,
    wide: /^[1234](-?[врт]?и?)? квартал/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchDayPatterns = {
    narrow: /^[нпвсч]/i,
    short: /^(не|по|вт|ср|че|пе|са)/i,
    abbreviated: /^(нед|пон|вто|сре|чет|пет|саб)/i,
    wide: /^(недела|понеделник|вторник|среда|четврток|петок|сабота)/i
};
var parseDayPatterns = {
    narrow: [
        /^н/i,
        /^п/i,
        /^в/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^н[ед]/i,
        /^п[он]/i,
        /^вт/i,
        /^ср/i,
        /^ч[ет]/i,
        /^п[ет]/i,
        /^с[аб]/i
    ]
};
var matchMonthPatterns = {
    abbreviated: /^(јан|фев|мар|апр|мај|јун|јул|авг|сеп|окт|ноем|дек)/i,
    wide: /^(јануари|февруари|март|април|мај|јуни|јули|август|септември|октомври|ноември|декември)/i
};
var parseMonthPatterns = {
    any: [
        /^ја/i,
        /^Ф/i,
        /^мар/i,
        /^ап/i,
        /^мај/i,
        /^јун/i,
        /^јул/i,
        /^ав/i,
        /^се/i,
        /^окт/i,
        /^но/i,
        /^де/i
    ]
};
var matchDayPeriodPatterns = {
    any: /^(претп|попл|полноќ|утро|пладне|вечер|ноќ)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /претпладне/i,
        pm: /попладне/i,
        midnight: /полноќ/i,
        noon: /напладне/i,
        morning: /наутро/i,
        afternoon: /попладне/i,
        evening: /навечер/i,
        night: /ноќе/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1JPQ7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Mongolian locale.
 * @language Mongolian
 * @iso-639-2 mon
 * @author Bilguun Ochirbat [@bilguun0203]{@link https://github.com/bilguun0203}
 */ var locale = {
    code: 'mn',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"16zmb","./_lib/formatLong/index.js":"7ECpT","./_lib/formatRelative/index.js":"coziV","./_lib/localize/index.js":"aGgog","./_lib/match/index.js":"1FuJR","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"16zmb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0441\u0435\u043A\u0443\u043D\u0434 \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439",
        other: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439"
    },
    xSeconds: {
        one: "1 \u0441\u0435\u043A\u0443\u043D\u0434",
        other: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
    },
    halfAMinute: "\u0445\u0430\u0433\u0430\u0441 \u043C\u0438\u043D\u0443\u0442",
    lessThanXMinutes: {
        one: "\u043C\u0438\u043D\u0443\u0442 \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439",
        other: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439"
    },
    xMinutes: {
        one: "1 \u043C\u0438\u043D\u0443\u0442",
        other: "{{count}} \u043C\u0438\u043D\u0443\u0442"
    },
    aboutXHours: {
        one: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 1 \u0446\u0430\u0433",
        other: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 {{count}} \u0446\u0430\u0433"
    },
    xHours: {
        one: "1 \u0446\u0430\u0433",
        other: "{{count}} \u0446\u0430\u0433"
    },
    xDays: {
        one: "1 \u04E9\u0434\u04E9\u0440",
        other: "{{count}} \u04E9\u0434\u04E9\u0440"
    },
    aboutXWeeks: {
        one: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 1 \u0434\u043E\u043B\u043E\u043E \u0445\u043E\u043D\u043E\u0433",
        other: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 {{count}} \u0434\u043E\u043B\u043E\u043E \u0445\u043E\u043D\u043E\u0433"
    },
    xWeeks: {
        one: "1 \u0434\u043E\u043B\u043E\u043E \u0445\u043E\u043D\u043E\u0433",
        other: "{{count}} \u0434\u043E\u043B\u043E\u043E \u0445\u043E\u043D\u043E\u0433"
    },
    aboutXMonths: {
        one: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 1 \u0441\u0430\u0440",
        other: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 {{count}} \u0441\u0430\u0440"
    },
    xMonths: {
        one: "1 \u0441\u0430\u0440",
        other: "{{count}} \u0441\u0430\u0440"
    },
    aboutXYears: {
        one: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 1 \u0436\u0438\u043B",
        other: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 {{count}} \u0436\u0438\u043B"
    },
    xYears: {
        one: "1 \u0436\u0438\u043B",
        other: "{{count}} \u0436\u0438\u043B"
    },
    overXYears: {
        one: "1 \u0436\u0438\u043B \u0433\u0430\u0440\u0430\u043D",
        other: "{{count}} \u0436\u0438\u043B \u0433\u0430\u0440\u0430\u043D"
    },
    almostXYears: {
        one: "\u0431\u0430\u0440\u0430\u0433 1 \u0436\u0438\u043B",
        other: "\u0431\u0430\u0440\u0430\u0433 {{count}} \u0436\u0438\u043B"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        /**
     * Append genitive case
     */ var words = result.split(' ');
        var lastword = words.pop();
        result = words.join(' ');
        switch(lastword){
            case "\u0441\u0435\u043A\u0443\u043D\u0434":
                result += " \u0441\u0435\u043A\u0443\u043D\u0434\u0438\u0439\u043D";
                break;
            case "\u043C\u0438\u043D\u0443\u0442":
                result += " \u043C\u0438\u043D\u0443\u0442\u044B\u043D";
                break;
            case "\u0446\u0430\u0433":
                result += " \u0446\u0430\u0433\u0438\u0439\u043D";
                break;
            case "\u04E9\u0434\u04E9\u0440":
                result += " \u04E9\u0434\u0440\u0438\u0439\u043D";
                break;
            case "\u0441\u0430\u0440":
                result += " \u0441\u0430\u0440\u044B\u043D";
                break;
            case "\u0436\u0438\u043B":
                result += " \u0436\u0438\u043B\u0438\u0439\u043D";
                break;
            case "\u0445\u043E\u043D\u043E\u0433":
                result += " \u0445\u043E\u043D\u043E\u0433\u0438\u0439\u043D";
                break;
            case "\u0433\u0430\u0440\u0430\u043D":
                result += " \u0433\u0430\u0440\u0430\u043D\u044B";
                break;
            case "\u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439":
                result += " \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439 \u0445\u0443\u0433\u0430\u0446\u0430\u0430\u043D\u044B";
                break;
            default:
                result += lastword + "-\u043D";
        }
        if (options.comparison && options.comparison > 0) return result + " \u0434\u0430\u0440\u0430\u0430";
        else return result + " \u04E9\u043C\u043D\u04E9";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7ECpT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "y '\u043E\u043D\u044B' MMMM'\u044B\u043D' d, EEEE '\u0433\u0430\u0440\u0430\u0433'",
    long: "y '\u043E\u043D\u044B' MMMM'\u044B\u043D' d",
    medium: "y '\u043E\u043D\u044B' MMM'\u044B\u043D' d",
    short: 'y.MM.dd'
};
var timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"coziV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'\u04E9\u043D\u0433\u04E9\u0440\u0441\u04E9\u043D' eeee '\u0433\u0430\u0440\u0430\u0433\u0438\u0439\u043D' p '\u0446\u0430\u0433\u0442'",
    yesterday: "'\u04E9\u0447\u0438\u0433\u0434\u04E9\u0440' p '\u0446\u0430\u0433\u0442'",
    today: "'\u04E9\u043D\u04E9\u04E9\u0434\u04E9\u0440' p '\u0446\u0430\u0433\u0442'",
    tomorrow: "'\u043C\u0430\u0440\u0433\u0430\u0430\u0448' p '\u0446\u0430\u0433\u0442'",
    nextWeek: "'\u0438\u0440\u044D\u0445' eeee '\u0433\u0430\u0440\u0430\u0433\u0438\u0439\u043D' p '\u0446\u0430\u0433\u0442'",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"aGgog":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u041D\u0422\u04E8",
        "\u041D\u0422"
    ],
    abbreviated: [
        "\u041D\u0422\u04E8",
        "\u041D\u0422"
    ],
    wide: [
        "\u043D\u0438\u0439\u0442\u0438\u0439\u043D \u0442\u043E\u043E\u043B\u043B\u044B\u043D \u04E9\u043C\u043D\u04E9\u0445",
        "\u043D\u0438\u0439\u0442\u0438\u0439\u043D \u0442\u043E\u043E\u043B\u043B\u044B\u043D"
    ]
};
var quarterValues = {
    narrow: [
        'I',
        'II',
        'III',
        'IV'
    ],
    abbreviated: [
        "I \u0443\u043B\u0438\u0440\u0430\u043B",
        "II \u0443\u043B\u0438\u0440\u0430\u043B",
        "III \u0443\u043B\u0438\u0440\u0430\u043B",
        "IV \u0443\u043B\u0438\u0440\u0430\u043B"
    ],
    wide: [
        "1-\u0440 \u0443\u043B\u0438\u0440\u0430\u043B",
        "2-\u0440 \u0443\u043B\u0438\u0440\u0430\u043B",
        "3-\u0440 \u0443\u043B\u0438\u0440\u0430\u043B",
        "4-\u0440 \u0443\u043B\u0438\u0440\u0430\u043B"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
    narrow: [
        'I',
        'II',
        'III',
        'IV',
        'V',
        'VI',
        'VII',
        'VIII',
        'IX',
        'X',
        'XI',
        'XII'
    ],
    abbreviated: [
        "1-\u0440 \u0441\u0430\u0440",
        "2-\u0440 \u0441\u0430\u0440",
        "3-\u0440 \u0441\u0430\u0440",
        "4-\u0440 \u0441\u0430\u0440",
        "5-\u0440 \u0441\u0430\u0440",
        "6-\u0440 \u0441\u0430\u0440",
        "7-\u0440 \u0441\u0430\u0440",
        "8-\u0440 \u0441\u0430\u0440",
        "9-\u0440 \u0441\u0430\u0440",
        "10-\u0440 \u0441\u0430\u0440",
        "11-\u0440 \u0441\u0430\u0440",
        "12-\u0440 \u0441\u0430\u0440"
    ],
    wide: [
        "\u041D\u044D\u0433\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0425\u043E\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0413\u0443\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0414\u04E9\u0440\u04E9\u0432\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0422\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0417\u0443\u0440\u0433\u0430\u0430\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0414\u043E\u043B\u043E\u043E\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u041D\u0430\u0439\u043C\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0415\u0441\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0410\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0410\u0440\u0432\u0430\u043D\u043D\u044D\u0433\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0410\u0440\u0432\u0430\u043D \u0445\u043E\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440"
    ]
};
var formattingMonthValues = {
    narrow: [
        'I',
        'II',
        'III',
        'IV',
        'V',
        'VI',
        'VII',
        'VIII',
        'IX',
        'X',
        'XI',
        'XII'
    ],
    abbreviated: [
        "1-\u0440 \u0441\u0430\u0440",
        "2-\u0440 \u0441\u0430\u0440",
        "3-\u0440 \u0441\u0430\u0440",
        "4-\u0440 \u0441\u0430\u0440",
        "5-\u0440 \u0441\u0430\u0440",
        "6-\u0440 \u0441\u0430\u0440",
        "7-\u0440 \u0441\u0430\u0440",
        "8-\u0440 \u0441\u0430\u0440",
        "9-\u0440 \u0441\u0430\u0440",
        "10-\u0440 \u0441\u0430\u0440",
        "11-\u0440 \u0441\u0430\u0440",
        "12-\u0440 \u0441\u0430\u0440"
    ],
    wide: [
        "\u043D\u044D\u0433\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0445\u043E\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0433\u0443\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0434\u04E9\u0440\u04E9\u0432\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0442\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0437\u0443\u0440\u0433\u0430\u0430\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0434\u043E\u043B\u043E\u043E\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u043D\u0430\u0439\u043C\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0435\u0441\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0430\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0430\u0440\u0432\u0430\u043D\u043D\u044D\u0433\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0430\u0440\u0432\u0430\u043D \u0445\u043E\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440"
    ]
};
var dayValues = {
    narrow: [
        "\u041D",
        "\u0414",
        "\u041C",
        "\u041B",
        "\u041F",
        "\u0411",
        "\u0411"
    ],
    short: [
        "\u041D\u044F",
        "\u0414\u0430",
        "\u041C\u044F",
        "\u041B\u0445",
        "\u041F\u04AF",
        "\u0411\u0430",
        "\u0411\u044F"
    ],
    abbreviated: [
        "\u041D\u044F\u043C",
        "\u0414\u0430\u0432",
        "\u041C\u044F\u0433",
        "\u041B\u0445\u0430",
        "\u041F\u04AF\u0440",
        "\u0411\u0430\u0430",
        "\u0411\u044F\u043C"
    ],
    wide: [
        "\u041D\u044F\u043C",
        "\u0414\u0430\u0432\u0430\u0430",
        "\u041C\u044F\u0433\u043C\u0430\u0440",
        "\u041B\u0445\u0430\u0433\u0432\u0430",
        "\u041F\u04AF\u0440\u044D\u0432",
        "\u0411\u0430\u0430\u0441\u0430\u043D",
        "\u0411\u044F\u043C\u0431\u0430"
    ]
};
var formattingDayValues = {
    narrow: [
        "\u041D",
        "\u0414",
        "\u041C",
        "\u041B",
        "\u041F",
        "\u0411",
        "\u0411"
    ],
    short: [
        "\u041D\u044F",
        "\u0414\u0430",
        "\u041C\u044F",
        "\u041B\u0445",
        "\u041F\u04AF",
        "\u0411\u0430",
        "\u0411\u044F"
    ],
    abbreviated: [
        "\u041D\u044F\u043C",
        "\u0414\u0430\u0432",
        "\u041C\u044F\u0433",
        "\u041B\u0445\u0430",
        "\u041F\u04AF\u0440",
        "\u0411\u0430\u0430",
        "\u0411\u044F\u043C"
    ],
    wide: [
        "\u043D\u044F\u043C",
        "\u0434\u0430\u0432\u0430\u0430",
        "\u043C\u044F\u0433\u043C\u0430\u0440",
        "\u043B\u0445\u0430\u0433\u0432\u0430",
        "\u043F\u04AF\u0440\u044D\u0432",
        "\u0431\u0430\u0430\u0441\u0430\u043D",
        "\u0431\u044F\u043C\u0431\u0430"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u04AF.\u04E9.",
        pm: "\u04AF.\u0445.",
        midnight: "\u0448\u04E9\u043D\u04E9 \u0434\u0443\u043D\u0434",
        noon: "\u04AF\u0434 \u0434\u0443\u043D\u0434",
        morning: "\u04E9\u0433\u043B\u04E9\u04E9",
        afternoon: "\u04E9\u0434\u04E9\u0440",
        evening: "\u043E\u0440\u043E\u0439",
        night: "\u0448\u04E9\u043D\u04E9"
    },
    abbreviated: {
        am: "\u04AF.\u04E9.",
        pm: "\u04AF.\u0445.",
        midnight: "\u0448\u04E9\u043D\u04E9 \u0434\u0443\u043D\u0434",
        noon: "\u04AF\u0434 \u0434\u0443\u043D\u0434",
        morning: "\u04E9\u0433\u043B\u04E9\u04E9",
        afternoon: "\u04E9\u0434\u04E9\u0440",
        evening: "\u043E\u0440\u043E\u0439",
        night: "\u0448\u04E9\u043D\u04E9"
    },
    wide: {
        am: "\u04AF.\u04E9.",
        pm: "\u04AF.\u0445.",
        midnight: "\u0448\u04E9\u043D\u04E9 \u0434\u0443\u043D\u0434",
        noon: "\u04AF\u0434 \u0434\u0443\u043D\u0434",
        morning: "\u04E9\u0433\u043B\u04E9\u04E9",
        afternoon: "\u04E9\u0434\u04E9\u0440",
        evening: "\u043E\u0440\u043E\u0439",
        night: "\u0448\u04E9\u043D\u04E9"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide',
        formattingValues: formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayValues,
        defaultFormattingWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1FuJR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /\d+/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(нтө|нт)/i,
    abbreviated: /^(нтө|нт)/i,
    wide: /^(нийтийн тооллын өмнө|нийтийн тооллын)/i
};
var parseEraPatterns = {
    any: [
        /^(нтө|нийтийн тооллын өмнө)/i,
        /^(нт|нийтийн тооллын)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^(iv|iii|ii|i)/i,
    abbreviated: /^(iv|iii|ii|i) улирал/i,
    wide: /^[1-4]-р улирал/i
};
var parseQuarterPatterns = {
    any: [
        /^(i(\s|$)|1)/i,
        /^(ii(\s|$)|2)/i,
        /^(iii(\s|$)|3)/i,
        /^(iv(\s|$)|4)/i
    ]
};
var matchMonthPatterns = {
    narrow: /^(xii|xi|x|ix|viii|vii|vi|v|iv|iii|ii|i)/i,
    abbreviated: /^(1-р сар|2-р сар|3-р сар|4-р сар|5-р сар|6-р сар|7-р сар|8-р сар|9-р сар|10-р сар|11-р сар|12-р сар)/i,
    wide: /^(нэгдүгээр сар|хоёрдугаар сар|гуравдугаар сар|дөрөвдүгээр сар|тавдугаар сар|зургаадугаар сар|долоодугаар сар|наймдугаар сар|есдүгээр сар|аравдугаар сар|арван нэгдүгээр сар|арван хоёрдугаар сар)/i
};
var parseMonthPatterns = {
    narrow: [
        /^i$/i,
        /^ii$/i,
        /^iii$/i,
        /^iv$/i,
        /^v$/i,
        /^vi$/i,
        /^vii$/i,
        /^viii$/i,
        /^ix$/i,
        /^x$/i,
        /^xi$/i,
        /^xii$/i
    ],
    any: [
        /^(1|нэгдүгээр)/i,
        /^(2|хоёрдугаар)/i,
        /^(3|гуравдугаар)/i,
        /^(4|дөрөвдүгээр)/i,
        /^(5|тавдугаар)/i,
        /^(6|зургаадугаар)/i,
        /^(7|долоодугаар)/i,
        /^(8|наймдугаар)/i,
        /^(9|есдүгээр)/i,
        /^(10|аравдугаар)/i,
        /^(11|арван нэгдүгээр)/i,
        /^(12|арван хоёрдугаар)/i
    ]
};
var matchDayPatterns = {
    narrow: /^[ндмлпбб]/i,
    short: /^(ня|да|мя|лх|пү|ба|бя)/i,
    abbreviated: /^(ням|дав|мяг|лха|пүр|баа|бям)/i,
    wide: /^(ням|даваа|мягмар|лхагва|пүрэв|баасан|бямба)/i
};
var parseDayPatterns = {
    narrow: [
        /^н/i,
        /^д/i,
        /^м/i,
        /^л/i,
        /^п/i,
        /^б/i,
        /^б/i
    ],
    any: [
        /^ня/i,
        /^да/i,
        /^мя/i,
        /^лх/i,
        /^пү/i,
        /^ба/i,
        /^бя/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(ү\.ө\.|ү\.х\.|шөнө дунд|үд дунд|өглөө|өдөр|орой|шөнө)/i,
    any: /^(ү\.ө\.|ү\.х\.|шөнө дунд|үд дунд|өглөө|өдөр|орой|шөнө)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^ү\.ө\./i,
        pm: /^ү\.х\./i,
        midnight: /^шөнө дунд/i,
        noon: /^үд дунд/i,
        morning: /өглөө/i,
        afternoon: /өдөр/i,
        evening: /орой/i,
        night: /шөнө/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3AjWH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Malay locale.
 * @language Malay
 * @iso-639-2 msa
 * @author Ruban Selvarajah [@Zyten]{@link https://github.com/Zyten}
 */ var locale = {
    code: 'ms',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"13qFi","./_lib/formatLong/index.js":"2IHAS","./_lib/formatRelative/index.js":"fViNp","./_lib/localize/index.js":"iyNAI","./_lib/match/index.js":"5Qnl3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"13qFi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'kurang dari 1 saat',
        other: 'kurang dari {{count}} saat'
    },
    xSeconds: {
        one: '1 saat',
        other: '{{count}} saat'
    },
    halfAMinute: 'setengah minit',
    lessThanXMinutes: {
        one: 'kurang dari 1 minit',
        other: 'kurang dari {{count}} minit'
    },
    xMinutes: {
        one: '1 minit',
        other: '{{count}} minit'
    },
    aboutXHours: {
        one: 'sekitar 1 jam',
        other: 'sekitar {{count}} jam'
    },
    xHours: {
        one: '1 jam',
        other: '{{count}} jam'
    },
    xDays: {
        one: '1 hari',
        other: '{{count}} hari'
    },
    aboutXWeeks: {
        one: 'sekitar 1 minggu',
        other: 'sekitar {{count}} minggu'
    },
    xWeeks: {
        one: '1 minggu',
        other: '{{count}} minggu'
    },
    aboutXMonths: {
        one: 'sekitar 1 bulan',
        other: 'sekitar {{count}} bulan'
    },
    xMonths: {
        one: '1 bulan',
        other: '{{count}} bulan'
    },
    aboutXYears: {
        one: 'sekitar 1 tahun',
        other: 'sekitar {{count}} tahun'
    },
    xYears: {
        one: '1 tahun',
        other: '{{count}} tahun'
    },
    overXYears: {
        one: 'lebih dari 1 tahun',
        other: 'lebih dari {{count}} tahun'
    },
    almostXYears: {
        one: 'hampir 1 tahun',
        other: 'hampir {{count}} tahun'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'dalam masa ' + result;
        else return result + ' yang lalu';
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2IHAS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'd/M/yyyy'
};
var timeFormats = {
    full: 'HH.mm.ss',
    long: 'HH.mm.ss',
    medium: 'HH.mm',
    short: 'HH.mm'
};
var dateTimeFormats = {
    full: "{{date}} 'pukul' {{time}}",
    long: "{{date}} 'pukul' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"fViNp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "eeee 'lepas pada jam' p",
    yesterday: "'Semalam pada jam' p",
    today: "'Hari ini pada jam' p",
    tomorrow: "'Esok pada jam' p",
    nextWeek: "eeee 'pada jam' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"iyNAI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js"); // Most data for localization are taken from this page
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
// https://www.unicode.org/cldr/charts/32/summary/ms.html
var eraValues = {
    narrow: [
        'SM',
        'M'
    ],
    abbreviated: [
        'SM',
        'M'
    ],
    wide: [
        'Sebelum Masihi',
        'Masihi'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'S1',
        'S2',
        'S3',
        'S4'
    ],
    wide: [
        'Suku pertama',
        'Suku kedua',
        'Suku ketiga',
        'Suku keempat'
    ]
};
// Note: in Malay, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'O',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mac',
        'Apr',
        'Mei',
        'Jun',
        'Jul',
        'Ogo',
        'Sep',
        'Okt',
        'Nov',
        'Dis'
    ],
    wide: [
        'Januari',
        'Februari',
        'Mac',
        'April',
        'Mei',
        'Jun',
        'Julai',
        'Ogos',
        'September',
        'Oktober',
        'November',
        'Disember'
    ]
};
var dayValues = {
    narrow: [
        'A',
        'I',
        'S',
        'R',
        'K',
        'J',
        'S'
    ],
    short: [
        'Ahd',
        'Isn',
        'Sel',
        'Rab',
        'Kha',
        'Jum',
        'Sab'
    ],
    abbreviated: [
        'Ahd',
        'Isn',
        'Sel',
        'Rab',
        'Kha',
        'Jum',
        'Sab'
    ],
    wide: [
        'Ahad',
        'Isnin',
        'Selasa',
        'Rabu',
        'Khamis',
        'Jumaat',
        'Sabtu'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: 'tgh malam',
        noon: 'tgh hari',
        morning: 'pagi',
        afternoon: 'tengah hari',
        evening: 'petang',
        night: 'malam'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'tengah hari',
        evening: 'petang',
        night: 'malam'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'tengah hari',
        evening: 'petang',
        night: 'malam'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'tengah hari',
        evening: 'petang',
        night: 'malam'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'tengah hari',
        evening: 'petang',
        night: 'malam'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'tengah malam',
        noon: 'tengah hari',
        morning: 'pagi',
        afternoon: 'tengah hari',
        evening: 'petang',
        night: 'malam'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    // Can't use "pertama", "kedua" because can't be parsed
    return 'ke-' + Number(dirtyNumber);
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5Qnl3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^ke-(\d+)?/i;
var parseOrdinalNumberPattern = /petama|\d+/i;
var matchEraPatterns = {
    narrow: /^(sm|m)/i,
    abbreviated: /^(s\.?\s?m\.?|m\.?)/i,
    wide: /^(sebelum masihi|masihi)/i
};
var parseEraPatterns = {
    any: [
        /^s/i,
        /^(m)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^S[1234]/i,
    wide: /Suku (pertama|kedua|ketiga|keempat)/i
};
var parseQuarterPatterns = {
    any: [
        /pertama|1/i,
        /kedua|2/i,
        /ketiga|3/i,
        /keempat|4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mac|apr|mei|jun|jul|ogo|sep|okt|nov|dis)/i,
    wide: /^(januari|februari|mac|april|mei|jun|julai|ogos|september|oktober|november|disember)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^o/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^ma/i,
        /^ap/i,
        /^me/i,
        /^jun/i,
        /^jul/i,
        /^og/i,
        /^s/i,
        /^ok/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[aisrkj]/i,
    short: /^(ahd|isn|sel|rab|kha|jum|sab)/i,
    abbreviated: /^(ahd|isn|sel|rab|kha|jum|sab)/i,
    wide: /^(ahad|isnin|selasa|rabu|khamis|jumaat|sabtu)/i
};
var parseDayPatterns = {
    narrow: [
        /^a/i,
        /^i/i,
        /^s/i,
        /^r/i,
        /^k/i,
        /^j/i,
        /^s/i
    ],
    any: [
        /^a/i,
        /^i/i,
        /^se/i,
        /^r/i,
        /^k/i,
        /^j/i,
        /^sa/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(am|pm|tengah malam|tengah hari|pagi|petang|malam)/i,
    any: /^([ap]\.?\s?m\.?|tengah malam|tengah hari|pagi|petang|malam)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^pm/i,
        midnight: /^tengah m/i,
        noon: /^tengah h/i,
        morning: /pa/i,
        afternoon: /tengah h/i,
        evening: /pe/i,
        night: /m/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"i0jzi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Maltese locale.
 * @language Maltese
 * @iso-639-2 mlt
 * @author Andras Matzon [@amatzon](@link https://github.com/amatzon)
 * @author Bryan Borg [@bryanMt](@link https://github.com/bryanMt)
 */ var locale = {
    code: 'mt',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"6dV2c","./_lib/formatLong/index.js":"3Rs61","./_lib/formatRelative/index.js":"4zKjj","./_lib/localize/index.js":"2TfO9","./_lib/match/index.js":"1p9gz","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6dV2c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'inqas minn sekonda',
        other: 'inqas minn {{count}} sekondi'
    },
    xSeconds: {
        one: 'sekonda',
        other: '{{count}} sekondi'
    },
    halfAMinute: 'nofs minuta',
    lessThanXMinutes: {
        one: 'inqas minn minuta',
        other: 'inqas minn {{count}} minuti'
    },
    xMinutes: {
        one: 'minuta',
        other: '{{count}} minuti'
    },
    aboutXHours: {
        one: "madwar sieg\u0127a",
        other: "madwar {{count}} sieg\u0127at"
    },
    xHours: {
        one: "sieg\u0127a",
        other: "{{count}} sieg\u0127at"
    },
    xDays: {
        one: "\u0121urnata",
        other: "{{count}} \u0121ranet"
    },
    aboutXWeeks: {
        one: "madwar \u0121img\u0127a",
        other: "madwar {{count}} \u0121img\u0127at"
    },
    xWeeks: {
        one: "\u0121img\u0127a",
        other: "{{count}} \u0121img\u0127at"
    },
    aboutXMonths: {
        one: 'madwar xahar',
        other: 'madwar {{count}} xhur'
    },
    xMonths: {
        one: 'xahar',
        other: '{{count}} xhur'
    },
    aboutXYears: {
        one: 'madwar sena',
        two: 'madwar sentejn',
        other: 'madwar {{count}} snin'
    },
    xYears: {
        one: 'sena',
        two: 'sentejn',
        other: '{{count}} snin'
    },
    overXYears: {
        one: 'aktar minn sena',
        two: 'aktar minn sentejn',
        other: 'aktar minn {{count}} snin'
    },
    almostXYears: {
        one: "kwa\u017Ci sena",
        two: "kwa\u017Ci sentejn",
        other: "kwa\u017Ci {{count}} snin"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2 && tokenValue.two) result = tokenValue.two;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "f'" + result;
        else return result + ' ilu';
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3Rs61":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'dd/MM/yyyy'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4zKjj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "eeee 'li g\u0127adda' 'fil-'p",
    yesterday: "'Il-biera\u0127 fil-'p",
    today: "'Illum fil-'p",
    tomorrow: "'G\u0127ada fil-'p",
    nextWeek: "eeee 'fil-'p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2TfO9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'Q',
        'W'
    ],
    abbreviated: [
        'QK',
        'WK'
    ],
    wide: [
        'qabel Kristu',
        'wara Kristu'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        '1. kwart',
        '2. kwart',
        '3. kwart',
        '4. kwart'
    ]
};
var monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        "\u0120",
        'L',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Fra',
        'Mar',
        'Apr',
        'Mej',
        "\u0120un",
        'Lul',
        'Aww',
        'Set',
        'Ott',
        'Nov',
        "Di\u010B"
    ],
    wide: [
        'Jannar',
        'Frar',
        'Marzu',
        'April',
        'Mejju',
        "\u0120unju",
        'Lulju',
        'Awwissu',
        'Settembru',
        'Ottubru',
        'Novembru',
        "Di\u010Bembru"
    ]
};
var dayValues = {
    narrow: [
        "\u0126",
        'T',
        'T',
        'E',
        "\u0126",
        "\u0120",
        'S'
    ],
    short: [
        "\u0126a",
        'Tn',
        'Tl',
        'Er',
        "\u0126a",
        "\u0120i",
        'Si'
    ],
    abbreviated: [
        "\u0126ad",
        'Tne',
        'Tli',
        'Erb',
        "\u0126am",
        "\u0120im",
        'Sib'
    ],
    wide: [
        "Il-\u0126add",
        'It-Tnejn',
        'It-Tlieta',
        "L-Erbg\u0127a",
        "Il-\u0126amis",
        "Il-\u0120img\u0127a",
        'Is-Sibt'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'nofsillejl',
        noon: 'nofsinhar',
        morning: "g\u0127odwa",
        afternoon: 'wara nofsinhar',
        evening: "filg\u0127axija",
        night: 'lejl'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'nofsillejl',
        noon: 'nofsinhar',
        morning: "g\u0127odwa",
        afternoon: 'wara nofsinhar',
        evening: "filg\u0127axija",
        night: 'lejl'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'nofsillejl',
        noon: 'nofsinhar',
        morning: "g\u0127odwa",
        afternoon: 'wara nofsinhar',
        evening: "filg\u0127axija",
        night: 'lejl'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: "f'nofsillejl",
        noon: "f'nofsinhar",
        morning: "filg\u0127odu",
        afternoon: 'wara nofsinhar',
        evening: "filg\u0127axija",
        night: 'billejl'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "f'nofsillejl",
        noon: "f'nofsinhar",
        morning: "filg\u0127odu",
        afternoon: 'wara nofsinhar',
        evening: "filg\u0127axija",
        night: 'billejl'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "f'nofsillejl",
        noon: "f'nofsinhar",
        morning: "filg\u0127odu",
        afternoon: 'wara nofsinhar',
        evening: "filg\u0127axija",
        night: 'billejl'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "\xba";
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1p9gz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(º)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(q|w)/i,
    abbreviated: /^(q\.?\s?k\.?|b\.?\s?c\.?\s?e\.?|w\.?\s?k\.?)/i,
    wide: /^(qabel kristu|before common era|wara kristu|common era)/i
};
var parseEraPatterns = {
    any: [
        /^(q|b)/i,
        /^(w|c)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^k[1234]/i,
    wide: /^[1234](\.)? kwart/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmaglsond]/i,
    abbreviated: /^(jan|fra|mar|apr|mej|ġun|lul|aww|set|ott|nov|diċ)/i,
    wide: /^(jannar|frar|marzu|april|mejju|ġunju|lulju|awwissu|settembru|ottubru|novembru|diċembru)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^ġ/i,
        /^l/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mej/i,
        /^ġ/i,
        /^l/i,
        /^aw/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[ħteġs]/i,
    short: /^(ħa|tn|tl|er|ħa|ġi|si)/i,
    abbreviated: /^(ħad|tne|tli|erb|ħam|ġim|sib)/i,
    wide: /^(il-ħadd|it-tnejn|it-tlieta|l-erbgħa|il-ħamis|il-ġimgħa|is-sibt)/i
};
var parseDayPatterns = {
    narrow: [
        /^ħ/i,
        /^t/i,
        /^t/i,
        /^e/i,
        /^ħ/i,
        /^ġ/i,
        /^s/i
    ],
    any: [
        /^(il-)?ħad/i,
        /^(it-)?tn/i,
        /^(it-)?tl/i,
        /^(l-)?er/i,
        /^(il-)?ham/i,
        /^(il-)?ġi/i,
        /^(is-)?si/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|f'nofsillejl|f'nofsinhar|(ta') (għodwa|wara nofsinhar|filgħaxija|lejl))/i,
    any: /^([ap]\.?\s?m\.?|f'nofsillejl|f'nofsinhar|(ta') (għodwa|wara nofsinhar|filgħaxija|lejl))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^f'nofsillejl/i,
        noon: /^f'nofsinhar/i,
        morning: /għodwa/i,
        afternoon: /wara(\s.*)nofsinhar/i,
        evening: /filgħaxija/i,
        night: /lejl/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jagCx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Norwegian Bokmål locale.
 * @language Norwegian Bokmål
 * @iso-639-2 nob
 * @author Hans-Kristian Koren [@Hanse]{@link https://github.com/Hanse}
 * @author Mikolaj Grzyb [@mikolajgrzyb]{@link https://github.com/mikolajgrzyb}
 * @author Dag Stuan [@dagstuan]{@link https://github.com/dagstuan}
 */ var locale = {
    code: 'nb',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"7cTZh","./_lib/formatLong/index.js":"4YUVl","./_lib/formatRelative/index.js":"3h32l","./_lib/localize/index.js":"ll6qn","./_lib/match/index.js":"9Cc3O","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7cTZh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'mindre enn ett sekund',
        other: 'mindre enn {{count}} sekunder'
    },
    xSeconds: {
        one: 'ett sekund',
        other: '{{count}} sekunder'
    },
    halfAMinute: 'et halvt minutt',
    lessThanXMinutes: {
        one: 'mindre enn ett minutt',
        other: 'mindre enn {{count}} minutter'
    },
    xMinutes: {
        one: 'ett minutt',
        other: '{{count}} minutter'
    },
    aboutXHours: {
        one: 'omtrent en time',
        other: 'omtrent {{count}} timer'
    },
    xHours: {
        one: 'en time',
        other: '{{count}} timer'
    },
    xDays: {
        one: 'en dag',
        other: '{{count}} dager'
    },
    aboutXWeeks: {
        one: 'omtrent en uke',
        other: 'omtrent {{count}} uker'
    },
    xWeeks: {
        one: 'en uke',
        other: '{{count}} uker'
    },
    aboutXMonths: {
        one: "omtrent en m\xe5ned",
        other: "omtrent {{count}} m\xe5neder"
    },
    xMonths: {
        one: "en m\xe5ned",
        other: "{{count}} m\xe5neder"
    },
    aboutXYears: {
        one: "omtrent ett \xe5r",
        other: "omtrent {{count}} \xe5r"
    },
    xYears: {
        one: "ett \xe5r",
        other: "{{count}} \xe5r"
    },
    overXYears: {
        one: "over ett \xe5r",
        other: "over {{count}} \xe5r"
    },
    almostXYears: {
        one: "nesten ett \xe5r",
        other: "nesten {{count}} \xe5r"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'om ' + result;
        else return result + ' siden';
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4YUVl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE d. MMMM y',
    long: 'd. MMMM y',
    medium: 'd. MMM y',
    short: 'dd.MM.y'
};
var timeFormats = {
    full: "'kl'. HH:mm:ss zzzz",
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3h32l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'forrige' eeee 'kl.' p",
    yesterday: "'i g\xe5r kl.' p",
    today: "'i dag kl.' p",
    tomorrow: "'i morgen kl.' p",
    nextWeek: "EEEE 'kl.' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"ll6qn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'f.Kr.',
        'e.Kr.'
    ],
    abbreviated: [
        'f.Kr.',
        'e.Kr.'
    ],
    wide: [
        "f\xf8r Kristus",
        'etter Kristus'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1. kvartal',
        '2. kvartal',
        '3. kvartal',
        '4. kvartal'
    ]
};
var monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mars',
        'apr.',
        'mai',
        'juni',
        'juli',
        'aug.',
        'sep.',
        'okt.',
        'nov.',
        'des.'
    ],
    wide: [
        'januar',
        'februar',
        'mars',
        'april',
        'mai',
        'juni',
        'juli',
        'august',
        'september',
        'oktober',
        'november',
        'desember'
    ]
};
var dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'O',
        'T',
        'F',
        'L'
    ],
    short: [
        "s\xf8",
        'ma',
        'ti',
        'on',
        'to',
        'fr',
        "l\xf8"
    ],
    abbreviated: [
        "s\xf8n",
        'man',
        'tir',
        'ons',
        'tor',
        'fre',
        "l\xf8r"
    ],
    wide: [
        "s\xf8ndag",
        'mandag',
        'tirsdag',
        'onsdag',
        'torsdag',
        'fredag',
        "l\xf8rdag"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 etterm.",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natten"
    },
    abbreviated: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 etterm.",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natten"
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morgenen",
        afternoon: "p\xe5 ettermiddagen",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natten"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"9Cc3O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)\.?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
    abbreviated: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
    wide: /^(før Kristus|før vår tid|etter Kristus|vår tid)/i
};
var parseEraPatterns = {
    any: [
        /^f/i,
        /^e/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? kvartal/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mars?|apr|mai|juni?|juli?|aug|sep|okt|nov|des)\.?/i,
    wide: /^(januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[smtofl]/i,
    short: /^(sø|ma|ti|on|to|fr|lø)/i,
    abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
    wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
};
var parseDayPatterns = {
    any: [
        /^s/i,
        /^m/i,
        /^ti/i,
        /^o/i,
        /^to/i,
        /^f/i,
        /^l/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten)|[ap])/i,
    any: /^([ap]\.?\s?m\.?|midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a(\.?\s?m\.?)?$/i,
        pm: /^p(\.?\s?m\.?)?$/i,
        midnight: /^midn/i,
        noon: /^midd/i,
        morning: /morgen/i,
        afternoon: /ettermiddag/i,
        evening: /kveld/i,
        night: /natt/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"84xnd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Dutch locale.
 * @language Dutch
 * @iso-639-2 nld
 * @author Jorik Tangelder [@jtangelder]{@link https://github.com/jtangelder}
 * @author Ruben Stolk [@rubenstolk]{@link https://github.com/rubenstolk}
 * @author Lode Vanhove [@bitcrumb]{@link https://github.com/bitcrumb}
 * @author Edo Rivai [@edorivai]{@link https://github.com/edorivai}
 * @author Niels Keurentjes [@curry684]{@link https://github.com/curry684}
 * @author Stefan Vermaas [@stefanvermaas]{@link https://github.com/stefanvermaas}
 */ var locale = {
    code: 'nl',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"ef9ds","./_lib/formatLong/index.js":"fCMjf","./_lib/formatRelative/index.js":"4IVAW","./_lib/localize/index.js":"c6BBz","./_lib/match/index.js":"fy6Sd","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"ef9ds":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'minder dan een seconde',
        other: 'minder dan {{count}} seconden'
    },
    xSeconds: {
        one: '1 seconde',
        other: '{{count}} seconden'
    },
    halfAMinute: 'een halve minuut',
    lessThanXMinutes: {
        one: 'minder dan een minuut',
        other: 'minder dan {{count}} minuten'
    },
    xMinutes: {
        one: 'een minuut',
        other: '{{count}} minuten'
    },
    aboutXHours: {
        one: 'ongeveer 1 uur',
        other: 'ongeveer {{count}} uur'
    },
    xHours: {
        one: '1 uur',
        other: '{{count}} uur'
    },
    xDays: {
        one: '1 dag',
        other: '{{count}} dagen'
    },
    aboutXWeeks: {
        one: 'ongeveer 1 week',
        other: 'ongeveer {{count}} weken'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weken'
    },
    aboutXMonths: {
        one: 'ongeveer 1 maand',
        other: 'ongeveer {{count}} maanden'
    },
    xMonths: {
        one: '1 maand',
        other: '{{count}} maanden'
    },
    aboutXYears: {
        one: 'ongeveer 1 jaar',
        other: 'ongeveer {{count}} jaar'
    },
    xYears: {
        one: '1 jaar',
        other: '{{count}} jaar'
    },
    overXYears: {
        one: 'meer dan 1 jaar',
        other: 'meer dan {{count}} jaar'
    },
    almostXYears: {
        one: 'bijna 1 jaar',
        other: 'bijna {{count}} jaar'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'over ' + result;
        else return result + ' geleden';
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"fCMjf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd-MM-y'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'om' {{time}}",
    long: "{{date}} 'om' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4IVAW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'afgelopen' eeee 'om' p",
    yesterday: "'gisteren om' p",
    today: "'vandaag om' p",
    tomorrow: "'morgen om' p",
    nextWeek: "eeee 'om' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"c6BBz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'v.C.',
        'n.C.'
    ],
    abbreviated: [
        'v.Chr.',
        'n.Chr.'
    ],
    wide: [
        'voor Christus',
        'na Christus'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        '1e kwartaal',
        '2e kwartaal',
        '3e kwartaal',
        '4e kwartaal'
    ]
};
var monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mrt.',
        'apr.',
        'mei',
        'jun.',
        'jul.',
        'aug.',
        'sep.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        'januari',
        'februari',
        'maart',
        'april',
        'mei',
        'juni',
        'juli',
        'augustus',
        'september',
        'oktober',
        'november',
        'december'
    ]
};
var dayValues = {
    narrow: [
        'Z',
        'M',
        'D',
        'W',
        'D',
        'V',
        'Z'
    ],
    short: [
        'zo',
        'ma',
        'di',
        'wo',
        'do',
        'vr',
        'za'
    ],
    abbreviated: [
        'zon',
        'maa',
        'din',
        'woe',
        'don',
        'vri',
        'zat'
    ],
    wide: [
        'zondag',
        'maandag',
        'dinsdag',
        'woensdag',
        'donderdag',
        'vrijdag',
        'zaterdag'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'het middaguur',
        morning: "'s ochtends",
        afternoon: "'s middags",
        evening: "'s avonds",
        night: "'s nachts"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'het middaguur',
        morning: "'s ochtends",
        afternoon: "'s middags",
        evening: "'s avonds",
        night: "'s nachts"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'het middaguur',
        morning: "'s ochtends",
        afternoon: "'s middags",
        evening: "'s avonds",
        night: "'s nachts"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + 'e';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"fy6Sd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)e?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^([vn]\.? ?C\.?)/,
    abbreviated: /^([vn]\. ?Chr\.?)/,
    wide: /^((voor|na) Christus)/
};
var parseEraPatterns = {
    any: [
        /^v/,
        /^n/
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234]e kwartaal/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
    wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^jan/i,
        /^feb/i,
        /^m(r|a)/i,
        /^apr/i,
        /^mei/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^sep/i,
        /^okt/i,
        /^nov/i,
        /^dec/i
    ]
};
var matchDayPatterns = {
    narrow: /^[zmdwv]/i,
    short: /^(zo|ma|di|wo|do|vr|za)/i,
    abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
    wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
};
var parseDayPatterns = {
    narrow: [
        /^z/i,
        /^m/i,
        /^d/i,
        /^w/i,
        /^d/i,
        /^v/i,
        /^z/i
    ],
    any: [
        /^zo/i,
        /^ma/i,
        /^di/i,
        /^wo/i,
        /^do/i,
        /^vr/i,
        /^za/i
    ]
};
var matchDayPeriodPatterns = {
    any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /^middernacht/i,
        noon: /^het middaguur/i,
        morning: /ochtend/i,
        afternoon: /middag/i,
        evening: /avond/i,
        night: /nacht/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6QUxg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Dutch locale.
 * @language Dutch
 * @iso-639-2 nld
 * @author Jorik Tangelder [@jtangelder]{@link https://github.com/jtangelder}
 * @author Ruben Stolk [@rubenstolk]{@link https://github.com/rubenstolk}
 * @author Lode Vanhove [@bitcrumb]{@link https://github.com/bitcrumb}
 * @author Alex Hoeing [@dcbn]{@link https://github.com/dcbn}
 */ var locale = {
    code: 'nl-BE',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"4Tq1T","./_lib/formatLong/index.js":"jWJbW","./_lib/formatRelative/index.js":"1ZHI8","./_lib/localize/index.js":"aAOT2","./_lib/match/index.js":"6Dz5M","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4Tq1T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'minder dan een seconde',
        other: 'minder dan {{count}} seconden'
    },
    xSeconds: {
        one: '1 seconde',
        other: '{{count}} seconden'
    },
    halfAMinute: 'een halve minuut',
    lessThanXMinutes: {
        one: 'minder dan een minuut',
        other: 'minder dan {{count}} minuten'
    },
    xMinutes: {
        one: 'een minuut',
        other: '{{count}} minuten'
    },
    aboutXHours: {
        one: 'ongeveer 1 uur',
        other: 'ongeveer {{count}} uur'
    },
    xHours: {
        one: '1 uur',
        other: '{{count}} uur'
    },
    xDays: {
        one: '1 dag',
        other: '{{count}} dagen'
    },
    aboutXWeeks: {
        one: 'ongeveer 1 week',
        other: 'ongeveer {{count}} weken'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weken'
    },
    aboutXMonths: {
        one: 'ongeveer 1 maand',
        other: 'ongeveer {{count}} maanden'
    },
    xMonths: {
        one: '1 maand',
        other: '{{count}} maanden'
    },
    aboutXYears: {
        one: 'ongeveer 1 jaar',
        other: 'ongeveer {{count}} jaar'
    },
    xYears: {
        one: '1 jaar',
        other: '{{count}} jaar'
    },
    overXYears: {
        one: 'meer dan 1 jaar',
        other: 'meer dan {{count}} jaar'
    },
    almostXYears: {
        one: 'bijna 1 jaar',
        other: 'bijna {{count}} jaar'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'over ' + result;
        else return result + ' geleden';
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jWJbW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd.MM.y'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'om' {{time}}",
    long: "{{date}} 'om' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1ZHI8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'vorige' eeee 'om' p",
    yesterday: "'gisteren om' p",
    today: "'vandaag om' p",
    tomorrow: "'morgen om' p",
    nextWeek: "eeee 'om' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"aAOT2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'v.C.',
        'n.C.'
    ],
    abbreviated: [
        'v.Chr.',
        'n.Chr.'
    ],
    wide: [
        'voor Christus',
        'na Christus'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        '1e kwartaal',
        '2e kwartaal',
        '3e kwartaal',
        '4e kwartaal'
    ]
};
var monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mrt.',
        'apr.',
        'mei',
        'jun.',
        'jul.',
        'aug.',
        'sep.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        'januari',
        'februari',
        'maart',
        'april',
        'mei',
        'juni',
        'juli',
        'augustus',
        'september',
        'oktober',
        'november',
        'december'
    ]
};
var dayValues = {
    narrow: [
        'Z',
        'M',
        'D',
        'W',
        'D',
        'V',
        'Z'
    ],
    short: [
        'zo',
        'ma',
        'di',
        'wo',
        'do',
        'vr',
        'za'
    ],
    abbreviated: [
        'zon',
        'maa',
        'din',
        'woe',
        'don',
        'vri',
        'zat'
    ],
    wide: [
        'zondag',
        'maandag',
        'dinsdag',
        'woensdag',
        'donderdag',
        'vrijdag',
        'zaterdag'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'het middag',
        morning: "'s ochtends",
        afternoon: "'s namiddags",
        evening: "'s avonds",
        night: "'s nachts"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'het middag',
        morning: "'s ochtends",
        afternoon: "'s namiddags",
        evening: "'s avonds",
        night: "'s nachts"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'het middag',
        morning: "'s ochtends",
        afternoon: "'s namiddags",
        evening: "'s avonds",
        night: "'s nachts"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + 'e';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6Dz5M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)e?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^([vn]\.? ?C\.?)/,
    abbreviated: /^([vn]\. ?Chr\.?)/,
    wide: /^((voor|na) Christus)/
};
var parseEraPatterns = {
    any: [
        /^v/,
        /^n/
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234]e kwartaal/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
    wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^jan/i,
        /^feb/i,
        /^m(r|a)/i,
        /^apr/i,
        /^mei/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^sep/i,
        /^okt/i,
        /^nov/i,
        /^dec/i
    ]
};
var matchDayPatterns = {
    narrow: /^[zmdwv]/i,
    short: /^(zo|ma|di|wo|do|vr|za)/i,
    abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
    wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
};
var parseDayPatterns = {
    narrow: [
        /^z/i,
        /^m/i,
        /^d/i,
        /^w/i,
        /^d/i,
        /^v/i,
        /^z/i
    ],
    any: [
        /^zo/i,
        /^ma/i,
        /^di/i,
        /^wo/i,
        /^do/i,
        /^vr/i,
        /^za/i
    ]
};
var matchDayPeriodPatterns = {
    any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /^middernacht/i,
        noon: /^het middaguur/i,
        morning: /ochtend/i,
        afternoon: /middag/i,
        evening: /avond/i,
        night: /nacht/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"9I8hS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Norwegian Nynorsk locale.
 * @language Norwegian Nynorsk
 * @iso-639-2 nno
 * @author Mats Byrkjeland [@draperunner]{@link https://github.com/draperunner}
 */ var locale = {
    code: 'nn',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"eUekS","./_lib/formatLong/index.js":"9gUj6","./_lib/formatRelative/index.js":"2TkjL","./_lib/localize/index.js":"6TWXk","./_lib/match/index.js":"3XZ9g","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"eUekS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'mindre enn eitt sekund',
        other: 'mindre enn {{count}} sekund'
    },
    xSeconds: {
        one: 'eitt sekund',
        other: '{{count}} sekund'
    },
    halfAMinute: 'eit halvt minutt',
    lessThanXMinutes: {
        one: 'mindre enn eitt minutt',
        other: 'mindre enn {{count}} minutt'
    },
    xMinutes: {
        one: 'eitt minutt',
        other: '{{count}} minutt'
    },
    aboutXHours: {
        one: 'omtrent ein time',
        other: 'omtrent {{count}} timar'
    },
    xHours: {
        one: 'ein time',
        other: '{{count}} timar'
    },
    xDays: {
        one: 'ein dag',
        other: '{{count}} dagar'
    },
    aboutXWeeks: {
        one: 'omtrent ei veke',
        other: 'omtrent {{count}} veker'
    },
    xWeeks: {
        one: 'ei veke',
        other: '{{count}} veker'
    },
    aboutXMonths: {
        one: "omtrent ein m\xe5nad",
        other: "omtrent {{count}} m\xe5nader"
    },
    xMonths: {
        one: "ein m\xe5nad",
        other: "{{count}} m\xe5nader"
    },
    aboutXYears: {
        one: "omtrent eitt \xe5r",
        other: "omtrent {{count}} \xe5r"
    },
    xYears: {
        one: "eitt \xe5r",
        other: "{{count}} \xe5r"
    },
    overXYears: {
        one: "over eitt \xe5r",
        other: "over {{count}} \xe5r"
    },
    almostXYears: {
        one: "nesten eitt \xe5r",
        other: "nesten {{count}} \xe5r"
    }
};
var wordMapping = [
    'null',
    'ein',
    'to',
    'tre',
    'fire',
    'fem',
    'seks',
    'sju',
    "\xe5tte",
    'ni',
    'ti',
    'elleve',
    'tolv'
];
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (options && options.onlyNumeric) result = tokenValue.other.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', count < 13 ? wordMapping[count] : String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'om ' + result;
        else return result + ' sidan';
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"9gUj6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE d. MMMM y',
    long: 'd. MMMM y',
    medium: 'd. MMM y',
    short: 'dd.MM.y'
};
var timeFormats = {
    full: "'kl'. HH:mm:ss zzzz",
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2TkjL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'f\xf8rre' eeee 'kl.' p",
    yesterday: "'i g\xe5r kl.' p",
    today: "'i dag kl.' p",
    tomorrow: "'i morgon kl.' p",
    nextWeek: "EEEE 'kl.' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6TWXk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'f.Kr.',
        'e.Kr.'
    ],
    abbreviated: [
        'f.Kr.',
        'e.Kr.'
    ],
    wide: [
        "f\xf8r Kristus",
        'etter Kristus'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1. kvartal',
        '2. kvartal',
        '3. kvartal',
        '4. kvartal'
    ]
};
var monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mars',
        'apr.',
        'mai',
        'juni',
        'juli',
        'aug.',
        'sep.',
        'okt.',
        'nov.',
        'des.'
    ],
    wide: [
        'januar',
        'februar',
        'mars',
        'april',
        'mai',
        'juni',
        'juli',
        'august',
        'september',
        'oktober',
        'november',
        'desember'
    ]
};
var dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'O',
        'T',
        'F',
        'L'
    ],
    short: [
        'su',
        "m\xe5",
        'ty',
        'on',
        'to',
        'fr',
        'lau'
    ],
    abbreviated: [
        'sun',
        "m\xe5n",
        'tys',
        'ons',
        'tor',
        'fre',
        'laur'
    ],
    wide: [
        'sundag',
        "m\xe5ndag",
        'tysdag',
        'onsdag',
        'torsdag',
        'fredag',
        'laurdag'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 etterm.",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natta"
    },
    abbreviated: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 etterm.",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natta"
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morgonen",
        afternoon: "p\xe5 ettermiddagen",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natta"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3XZ9g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)\.?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
    abbreviated: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
    wide: /^(før Kristus|før vår tid|etter Kristus|vår tid)/i
};
var parseEraPatterns = {
    any: [
        /^f/i,
        /^e/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? kvartal/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mars?|apr|mai|juni?|juli?|aug|sep|okt|nov|des)\.?/i,
    wide: /^(januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[smtofl]/i,
    short: /^(su|må|ty|on|to|fr|la)/i,
    abbreviated: /^(sun|mån|tys|ons|tor|fre|laur)/i,
    wide: /^(sundag|måndag|tysdag|onsdag|torsdag|fredag|laurdag)/i
};
var parseDayPatterns = {
    any: [
        /^s/i,
        /^m/i,
        /^ty/i,
        /^o/i,
        /^to/i,
        /^f/i,
        /^l/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(midnatt|middag|(på) (morgonen|ettermiddagen|kvelden|natta)|[ap])/i,
    any: /^([ap]\.?\s?m\.?|midnatt|middag|(på) (morgonen|ettermiddagen|kvelden|natta))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a(\.?\s?m\.?)?$/i,
        pm: /^p(\.?\s?m\.?)?$/i,
        midnight: /^midn/i,
        noon: /^midd/i,
        morning: /morgon/i,
        afternoon: /ettermiddag/i,
        evening: /kveld/i,
        night: /natt/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"fjHFa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Occitan locale.
 * @language Occitan
 * @iso-639-2 oci
 * @author Quentin PAGÈS
 */ var locale = {
    code: 'oc',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"iPkDM","./_lib/formatLong/index.js":"h74yk","./_lib/formatRelative/index.js":"cU78x","./_lib/localize/index.js":"k3wwV","./_lib/match/index.js":"23Elb","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"iPkDM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mens d\u2019una segonda",
        other: 'mens de {{count}} segondas'
    },
    xSeconds: {
        one: '1 segonda',
        other: '{{count}} segondas'
    },
    halfAMinute: '30 segondas',
    lessThanXMinutes: {
        one: "mens d\u2019una minuta",
        other: 'mens de {{count}} minutas'
    },
    xMinutes: {
        one: '1 minuta',
        other: '{{count}} minutas'
    },
    aboutXHours: {
        one: 'environ 1 ora',
        other: 'environ {{count}} oras'
    },
    xHours: {
        one: '1 ora',
        other: '{{count}} oras'
    },
    xDays: {
        one: '1 jorn',
        other: '{{count}} jorns'
    },
    aboutXWeeks: {
        one: 'environ 1 setmana',
        other: 'environ {{count}} setmanas'
    },
    xWeeks: {
        one: '1 setmana',
        other: '{{count}} setmanas'
    },
    aboutXMonths: {
        one: 'environ 1 mes',
        other: 'environ {{count}} meses'
    },
    xMonths: {
        one: '1 mes',
        other: '{{count}} meses'
    },
    aboutXYears: {
        one: 'environ 1 an',
        other: 'environ {{count}} ans'
    },
    xYears: {
        one: '1 an',
        other: '{{count}} ans'
    },
    overXYears: {
        one: "mai d\u2019un an",
        other: 'mai de {{count}} ans'
    },
    almostXYears: {
        one: 'gaireben un an',
        other: 'gaireben {{count}} ans'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "d\u2019aqu\xed " + result;
        else return 'fa ' + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"h74yk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE d 'de' MMMM y",
    long: "d 'de' MMMM y",
    medium: 'd MMM y',
    short: 'dd/MM/y'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'a' {{time}}",
    long: "{{date}} 'a' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"cU78x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "eeee 'passat a' p",
    yesterday: "'i\xe8r a' p",
    today: "'u\xe8i a' p",
    tomorrow: "'deman a' p",
    nextWeek: "eeee 'a' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"k3wwV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'ab. J.C.',
        'apr. J.C.'
    ],
    abbreviated: [
        'ab. J.C.',
        'apr. J.C.'
    ],
    wide: [
        "abans J\xe8sus-Crist",
        "apr\xe8s J\xe8sus-Crist"
    ]
};
var quarterValues = {
    narrow: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    abbreviated: [
        "1\xe8r trim.",
        '2nd trim.',
        '3en trim.',
        '4en trim.'
    ],
    wide: [
        "1\xe8r trim\xe8stre",
        "2nd trim\xe8stre",
        "3en trim\xe8stre",
        "4en trim\xe8stre"
    ]
};
var monthValues = {
    narrow: [
        'GN',
        'FB',
        "M\xc7",
        'AB',
        'MA',
        'JN',
        'JL',
        'AG',
        'ST',
        'OC',
        'NV',
        'DC'
    ],
    abbreviated: [
        'gen.',
        'febr.',
        "mar\xe7",
        'abr.',
        'mai',
        'junh',
        'jul.',
        'ag.',
        'set.',
        'oct.',
        'nov.',
        'dec.'
    ],
    wide: [
        "geni\xe8r",
        "febri\xe8r",
        "mar\xe7",
        'abril',
        'mai',
        'junh',
        'julhet',
        'agost',
        'setembre',
        "oct\xf2bre",
        'novembre',
        'decembre'
    ]
};
var dayValues = {
    narrow: [
        'dg.',
        'dl.',
        'dm.',
        'dc.',
        'dj.',
        'dv.',
        'ds.'
    ],
    short: [
        'dg.',
        'dl.',
        'dm.',
        'dc.',
        'dj.',
        'dv.',
        'ds.'
    ],
    abbreviated: [
        'dg.',
        'dl.',
        'dm.',
        'dc.',
        'dj.',
        'dv.',
        'ds.'
    ],
    wide: [
        'dimenge',
        'diluns',
        'dimars',
        "dim\xe8cres",
        "dij\xf2us",
        'divendres',
        'dissabte'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: 'matin',
        afternoon: "apr\xe8p-mi\xe8gjorn",
        evening: "v\xe8spre",
        night: "nu\xe8ch"
    },
    abbreviated: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: 'matin',
        afternoon: "apr\xe8p-mi\xe8gjorn",
        evening: "v\xe8spre",
        night: "nu\xe8ch"
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: 'matin',
        afternoon: "apr\xe8p-mi\xe8gjorn",
        evening: "v\xe8spre",
        night: "nu\xe8ch"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: 'del matin',
        afternoon: "de l\u2019apr\xe8p-mi\xe8gjorn",
        evening: 'del ser',
        night: "de la nu\xe8ch"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: 'del matin',
        afternoon: "de l\u2019apr\xe8p-mi\xe8gjorn",
        evening: 'del ser',
        night: "de la nu\xe8ch"
    },
    wide: {
        am: 'ante meridiem',
        pm: 'post meridiem',
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: 'del matin',
        afternoon: "de l\u2019apr\xe8p-mi\xe8gjorn",
        evening: 'del ser',
        night: "de la nu\xe8ch"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    var ordinal;
    switch(number){
        case 1:
            ordinal = "\xe8r";
            break;
        case 2:
            ordinal = 'nd';
            break;
        default:
            ordinal = 'en';
    }
    // feminine for year, week, hour, minute, second
    if (unit === 'year' || unit === 'week' || unit === 'hour' || unit === 'minute' || unit === 'second') ordinal += 'a';
    return number + ordinal;
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"23Elb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(èr|nd|en)?[a]?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(ab\.J\.C|apr\.J\.C|apr\.J\.-C)/i,
    abbreviated: /^(ab\.J\.-C|ab\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
    wide: /^(abans Jèsus-Crist|après Jèsus-Crist)/i
};
var parseEraPatterns = {
    any: [
        /^ab/i,
        /^ap/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^T[1234]/i,
    abbreviated: /^[1234](èr|nd|en)? trim\.?/i,
    wide: /^[1234](èr|nd|en)? trimèstre/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^(GN|FB|MÇ|AB|MA|JN|JL|AG|ST|OC|NV|DC)/i,
    abbreviated: /^(gen|febr|març|abr|mai|junh|jul|ag|set|oct|nov|dec)\.?/i,
    wide: /^(genièr|febrièr|març|abril|mai|junh|julhet|agost|setembre|octòbre|novembre|decembre)/i
};
var parseMonthPatterns = {
    any: [
        /^g/i,
        /^f/i,
        /^ma[r?]|MÇ/i,
        /^ab/i,
        /^ma[i?]/i,
        /^ju[n?]|JN/i,
        /^ju[l?]|JL/i,
        /^ag/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^d[glmcjvs]\.?/i,
    short: /^d[glmcjvs]\.?/i,
    abbreviated: /^d[glmcjvs]\.?/i,
    wide: /^(dimenge|diluns|dimars|dimècres|dijòus|divendres|dissabte)/i
};
var parseDayPatterns = {
    narrow: [
        /^dg/i,
        /^dl/i,
        /^dm/i,
        /^dc/i,
        /^dj/i,
        /^dv/i,
        /^ds/i
    ],
    short: [
        /^dg/i,
        /^dl/i,
        /^dm/i,
        /^dc/i,
        /^dj/i,
        /^dv/i,
        /^ds/i
    ],
    abbreviated: [
        /^dg/i,
        /^dl/i,
        /^dm/i,
        /^dc/i,
        /^dj/i,
        /^dv/i,
        /^ds/i
    ],
    any: [
        /^dg|dime/i,
        /^dl|dil/i,
        /^dm|dima/i,
        /^dc|dimè/i,
        /^dj|dij/i,
        /^dv|div/i,
        /^ds|dis/i
    ]
};
var matchDayPeriodPatterns = {
    any: /(^(a\.?m|p\.?m))|(ante meridiem|post meridiem)|((del |de la |de l’)(matin|aprèp-miègjorn|vèspre|ser|nuèch))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /(^a)|ante meridiem/i,
        pm: /(^p)|post meridiem/i,
        midnight: /^mièj/i,
        noon: /^mièg/i,
        morning: /matin/i,
        afternoon: /aprèp-miègjorn/i,
        evening: /vèspre|ser/i,
        night: /nuèch/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2k3le":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Polish locale.
 * @language Polish
 * @iso-639-2 pol
 * @author Mateusz Derks [@ertrzyiks]{@link https://github.com/ertrzyiks}
 * @author Just RAG [@justrag]{@link https://github.com/justrag}
 * @author Mikolaj Grzyb [@mikolajgrzyb]{@link https://github.com/mikolajgrzyb}
 * @author Mateusz Tokarski [@mutisz]{@link https://github.com/mutisz}
 */ var locale = {
    code: 'pl',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"kXFpa","./_lib/formatLong/index.js":"ak1b3","./_lib/formatRelative/index.js":"lDW73","./_lib/localize/index.js":"i6a6g","./_lib/match/index.js":"52pmu","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"kXFpa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            regular: "mniej ni\u017C sekunda",
            past: "mniej ni\u017C sekund\u0119",
            future: "mniej ni\u017C sekund\u0119"
        },
        twoFour: "mniej ni\u017C {{count}} sekundy",
        other: "mniej ni\u017C {{count}} sekund"
    },
    xSeconds: {
        one: {
            regular: 'sekunda',
            past: "sekund\u0119",
            future: "sekund\u0119"
        },
        twoFour: '{{count}} sekundy',
        other: '{{count}} sekund'
    },
    halfAMinute: {
        one: "p\xf3\u0142 minuty",
        twoFour: "p\xf3\u0142 minuty",
        other: "p\xf3\u0142 minuty"
    },
    lessThanXMinutes: {
        one: {
            regular: "mniej ni\u017C minuta",
            past: "mniej ni\u017C minut\u0119",
            future: "mniej ni\u017C minut\u0119"
        },
        twoFour: "mniej ni\u017C {{count}} minuty",
        other: "mniej ni\u017C {{count}} minut"
    },
    xMinutes: {
        one: {
            regular: 'minuta',
            past: "minut\u0119",
            future: "minut\u0119"
        },
        twoFour: '{{count}} minuty',
        other: '{{count}} minut'
    },
    aboutXHours: {
        one: {
            regular: "oko\u0142o godziny",
            past: "oko\u0142o godziny",
            future: "oko\u0142o godzin\u0119"
        },
        twoFour: "oko\u0142o {{count}} godziny",
        other: "oko\u0142o {{count}} godzin"
    },
    xHours: {
        one: {
            regular: 'godzina',
            past: "godzin\u0119",
            future: "godzin\u0119"
        },
        twoFour: '{{count}} godziny',
        other: '{{count}} godzin'
    },
    xDays: {
        one: {
            regular: "dzie\u0144",
            past: "dzie\u0144",
            future: "1 dzie\u0144"
        },
        twoFour: '{{count}} dni',
        other: '{{count}} dni'
    },
    aboutXWeeks: {
        one: "oko\u0142o tygodnia",
        twoFour: "oko\u0142o {{count}} tygodni",
        other: "oko\u0142o {{count}} tygodni"
    },
    xWeeks: {
        one: "tydzie\u0144",
        twoFour: '{{count}} tygodnie',
        other: '{{count}} tygodni'
    },
    aboutXMonths: {
        one: "oko\u0142o miesi\u0105c",
        twoFour: "oko\u0142o {{count}} miesi\u0105ce",
        other: "oko\u0142o {{count}} miesi\u0119cy"
    },
    xMonths: {
        one: "miesi\u0105c",
        twoFour: "{{count}} miesi\u0105ce",
        other: "{{count}} miesi\u0119cy"
    },
    aboutXYears: {
        one: "oko\u0142o rok",
        twoFour: "oko\u0142o {{count}} lata",
        other: "oko\u0142o {{count}} lat"
    },
    xYears: {
        one: 'rok',
        twoFour: '{{count}} lata',
        other: '{{count}} lat'
    },
    overXYears: {
        one: 'ponad rok',
        twoFour: 'ponad {{count}} lata',
        other: 'ponad {{count}} lat'
    },
    almostXYears: {
        one: 'prawie rok',
        twoFour: 'prawie {{count}} lata',
        other: 'prawie {{count}} lat'
    }
};
function declensionGroup(scheme, count) {
    if (count === 1) return scheme.one;
    var rem100 = count % 100;
    // ends with 11-20
    if (rem100 <= 20 && rem100 > 10) return scheme.other;
    var rem10 = rem100 % 10;
    // ends with 2, 3, 4
    if (rem10 >= 2 && rem10 <= 4) return scheme.twoFour;
    return scheme.other;
}
function declension(scheme, count, time) {
    var group = declensionGroup(scheme, count);
    var finalText = typeof group === 'string' ? group : group[time];
    return finalText.replace('{{count}}', String(count));
}
var formatDistance = function formatDistance(token, count, options) {
    var scheme = formatDistanceLocale[token];
    if (!(options !== null && options !== void 0 && options.addSuffix)) return declension(scheme, count, 'regular');
    if (options.comparison && options.comparison > 0) return 'za ' + declension(scheme, count, 'future');
    else return declension(scheme, count, 'past') + ' temu';
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"ak1b3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, do MMMM y',
    long: 'do MMMM y',
    medium: 'do MMM y',
    short: 'dd.MM.y'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"lDW73":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../../_lib/isSameUTCWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var adjectivesLastWeek = {
    masculine: 'ostatni',
    feminine: 'ostatnia'
};
var adjectivesThisWeek = {
    masculine: 'ten',
    feminine: 'ta'
};
var adjectivesNextWeek = {
    masculine: "nast\u0119pny",
    feminine: "nast\u0119pna"
};
var dayGrammaticalGender = {
    0: 'feminine',
    1: 'masculine',
    2: 'masculine',
    3: 'feminine',
    4: 'masculine',
    5: 'masculine',
    6: 'feminine'
};
function dayAndTimeWithAdjective(token, date, baseDate, options) {
    var adjectives;
    if ((0, _indexJsDefault.default)(date, baseDate, options)) adjectives = adjectivesThisWeek;
    else if (token === 'lastWeek') adjectives = adjectivesLastWeek;
    else if (token === 'nextWeek') adjectives = adjectivesNextWeek;
    else throw new Error("Cannot determine adjectives for token ".concat(token));
    var day = date.getUTCDay();
    var grammaticalGender = dayGrammaticalGender[day];
    var adjective = adjectives[grammaticalGender];
    return "'".concat(adjective, "' eeee 'o' p");
}
var formatRelativeLocale = {
    lastWeek: dayAndTimeWithAdjective,
    yesterday: "'wczoraj o' p",
    today: "'dzisiaj o' p",
    tomorrow: "'jutro o' p",
    nextWeek: dayAndTimeWithAdjective,
    other: 'P'
};
var formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(token, date, baseDate, options);
    return format;
};
exports.default = formatRelative;

},{"../../../../_lib/isSameUTCWeek/index.js":"g7rCW","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"i6a6g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'p.n.e.',
        'n.e.'
    ],
    abbreviated: [
        'p.n.e.',
        'n.e.'
    ],
    wide: [
        "przed nasz\u0105 er\u0105",
        'naszej ery'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'I kw.',
        'II kw.',
        'III kw.',
        'IV kw.'
    ],
    wide: [
        "I kwarta\u0142",
        "II kwarta\u0142",
        "III kwarta\u0142",
        "IV kwarta\u0142"
    ]
};
var monthValues = {
    narrow: [
        'S',
        'L',
        'M',
        'K',
        'M',
        'C',
        'L',
        'S',
        'W',
        'P',
        'L',
        'G'
    ],
    abbreviated: [
        'sty',
        'lut',
        'mar',
        'kwi',
        'maj',
        'cze',
        'lip',
        'sie',
        'wrz',
        "pa\u017A",
        'lis',
        'gru'
    ],
    wide: [
        "stycze\u0144",
        'luty',
        'marzec',
        "kwiecie\u0144",
        'maj',
        'czerwiec',
        'lipiec',
        "sierpie\u0144",
        "wrzesie\u0144",
        "pa\u017Adziernik",
        'listopad',
        "grudzie\u0144"
    ]
};
var monthFormattingValues = {
    narrow: [
        's',
        'l',
        'm',
        'k',
        'm',
        'c',
        'l',
        's',
        'w',
        'p',
        'l',
        'g'
    ],
    abbreviated: [
        'sty',
        'lut',
        'mar',
        'kwi',
        'maj',
        'cze',
        'lip',
        'sie',
        'wrz',
        "pa\u017A",
        'lis',
        'gru'
    ],
    wide: [
        'stycznia',
        'lutego',
        'marca',
        'kwietnia',
        'maja',
        'czerwca',
        'lipca',
        'sierpnia',
        "wrze\u015Bnia",
        "pa\u017Adziernika",
        'listopada',
        'grudnia'
    ]
};
var dayValues = {
    narrow: [
        'N',
        'P',
        'W',
        "\u015A",
        'C',
        'P',
        'S'
    ],
    short: [
        'nie',
        'pon',
        'wto',
        "\u015Bro",
        'czw',
        "pi\u0105",
        'sob'
    ],
    abbreviated: [
        'niedz.',
        'pon.',
        'wt.',
        "\u015Br.",
        'czw.',
        'pt.',
        'sob.'
    ],
    wide: [
        'niedziela',
        "poniedzia\u0142ek",
        'wtorek',
        "\u015Broda",
        'czwartek',
        "pi\u0105tek",
        'sobota'
    ]
};
var dayFormattingValues = {
    narrow: [
        'n',
        'p',
        'w',
        "\u015B",
        'c',
        'p',
        's'
    ],
    short: [
        'nie',
        'pon',
        'wto',
        "\u015Bro",
        'czw',
        "pi\u0105",
        'sob'
    ],
    abbreviated: [
        'niedz.',
        'pon.',
        'wt.',
        "\u015Br.",
        'czw.',
        'pt.',
        'sob.'
    ],
    wide: [
        'niedziela',
        "poniedzia\u0142ek",
        'wtorek',
        "\u015Broda",
        'czwartek',
        "pi\u0105tek",
        'sobota'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: "p\xf3\u0142n.",
        noon: "po\u0142",
        morning: 'rano',
        afternoon: "popo\u0142.",
        evening: 'wiecz.',
        night: 'noc'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "p\xf3\u0142noc",
        noon: "po\u0142udnie",
        morning: 'rano',
        afternoon: "popo\u0142udnie",
        evening: "wiecz\xf3r",
        night: 'noc'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "p\xf3\u0142noc",
        noon: "po\u0142udnie",
        morning: 'rano',
        afternoon: "popo\u0142udnie",
        evening: "wiecz\xf3r",
        night: 'noc'
    }
};
var dayPeriodFormattingValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: "o p\xf3\u0142n.",
        noon: "w po\u0142.",
        morning: 'rano',
        afternoon: "po po\u0142.",
        evening: 'wiecz.',
        night: 'w nocy'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "o p\xf3\u0142nocy",
        noon: "w po\u0142udnie",
        morning: 'rano',
        afternoon: "po po\u0142udniu",
        evening: 'wieczorem',
        night: 'w nocy'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "o p\xf3\u0142nocy",
        noon: "w po\u0142udnie",
        morning: 'rano',
        afternoon: "po po\u0142udniu",
        evening: 'wieczorem',
        night: 'w nocy'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide',
        formattingValues: monthFormattingValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide',
        formattingValues: dayFormattingValues,
        defaultFormattingWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: dayPeriodFormattingValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"52pmu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(p\.?\s*n\.?\s*e\.?\s*|n\.?\s*e\.?\s*)/i,
    abbreviated: /^(p\.?\s*n\.?\s*e\.?\s*|n\.?\s*e\.?\s*)/i,
    wide: /^(przed\s*nasz(ą|a)\s*er(ą|a)|naszej\s*ery)/i
};
var parseEraPatterns = {
    any: [
        /^p/i,
        /^n/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^(I|II|III|IV)\s*kw\.?/i,
    wide: /^(I|II|III|IV)\s*kwarta(ł|l)/i
};
var parseQuarterPatterns = {
    narrow: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ],
    any: [
        /^I kw/i,
        /^II kw/i,
        /^III kw/i,
        /^IV kw/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[slmkcwpg]/i,
    abbreviated: /^(sty|lut|mar|kwi|maj|cze|lip|sie|wrz|pa(ź|z)|lis|gru)/i,
    wide: /^(stycznia|stycze(ń|n)|lutego|luty|marca|marzec|kwietnia|kwiecie(ń|n)|maja|maj|czerwca|czerwiec|lipca|lipiec|sierpnia|sierpie(ń|n)|wrze(ś|s)nia|wrzesie(ń|n)|pa(ź|z)dziernika|pa(ź|z)dziernik|listopada|listopad|grudnia|grudzie(ń|n))/i
};
var parseMonthPatterns = {
    narrow: [
        /^s/i,
        /^l/i,
        /^m/i,
        /^k/i,
        /^m/i,
        /^c/i,
        /^l/i,
        /^s/i,
        /^w/i,
        /^p/i,
        /^l/i,
        /^g/i
    ],
    any: [
        /^st/i,
        /^lu/i,
        /^mar/i,
        /^k/i,
        /^maj/i,
        /^c/i,
        /^lip/i,
        /^si/i,
        /^w/i,
        /^p/i,
        /^lis/i,
        /^g/i
    ]
};
var matchDayPatterns = {
    narrow: /^[npwścs]/i,
    short: /^(nie|pon|wto|(ś|s)ro|czw|pi(ą|a)|sob)/i,
    abbreviated: /^(niedz|pon|wt|(ś|s)r|czw|pt|sob)\.?/i,
    wide: /^(niedziela|poniedzia(ł|l)ek|wtorek|(ś|s)roda|czwartek|pi(ą|a)tek|sobota)/i
};
var parseDayPatterns = {
    narrow: [
        /^n/i,
        /^p/i,
        /^w/i,
        /^ś/i,
        /^c/i,
        /^p/i,
        /^s/i
    ],
    abbreviated: [
        /^n/i,
        /^po/i,
        /^w/i,
        /^(ś|s)r/i,
        /^c/i,
        /^pt/i,
        /^so/i
    ],
    any: [
        /^n/i,
        /^po/i,
        /^w/i,
        /^(ś|s)r/i,
        /^c/i,
        /^pi/i,
        /^so/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(^a$|^p$|pó(ł|l)n\.?|o\s*pó(ł|l)n\.?|po(ł|l)\.?|w\s*po(ł|l)\.?|po\s*po(ł|l)\.?|rano|wiecz\.?|noc|w\s*nocy)/i,
    any: /^(am|pm|pó(ł|l)noc|o\s*pó(ł|l)nocy|po(ł|l)udnie|w\s*po(ł|l)udnie|popo(ł|l)udnie|po\s*po(ł|l)udniu|rano|wieczór|wieczorem|noc|w\s*nocy)/i
};
var parseDayPeriodPatterns = {
    narrow: {
        am: /^a$/i,
        pm: /^p$/i,
        midnight: /pó(ł|l)n/i,
        noon: /po(ł|l)/i,
        morning: /rano/i,
        afternoon: /po\s*po(ł|l)/i,
        evening: /wiecz/i,
        night: /noc/i
    },
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /pó(ł|l)n/i,
        noon: /po(ł|l)/i,
        morning: /rano/i,
        afternoon: /po\s*po(ł|l)/i,
        evening: /wiecz/i,
        night: /noc/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4G91w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Portuguese locale.
 * @language Portuguese
 * @iso-639-2 por
 * @author Dário Freire [@dfreire]{@link https://github.com/dfreire}
 * @author Adrián de la Rosa [@adrm]{@link https://github.com/adrm}
 */ var locale = {
    code: 'pt',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"jLIJJ","./_lib/formatLong/index.js":"aas0q","./_lib/formatRelative/index.js":"jUQpU","./_lib/localize/index.js":"6SS5b","./_lib/match/index.js":"7tpyy","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jLIJJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'menos de um segundo',
        other: 'menos de {{count}} segundos'
    },
    xSeconds: {
        one: '1 segundo',
        other: '{{count}} segundos'
    },
    halfAMinute: 'meio minuto',
    lessThanXMinutes: {
        one: 'menos de um minuto',
        other: 'menos de {{count}} minutos'
    },
    xMinutes: {
        one: '1 minuto',
        other: '{{count}} minutos'
    },
    aboutXHours: {
        one: 'aproximadamente 1 hora',
        other: 'aproximadamente {{count}} horas'
    },
    xHours: {
        one: '1 hora',
        other: '{{count}} horas'
    },
    xDays: {
        one: '1 dia',
        other: '{{count}} dias'
    },
    aboutXWeeks: {
        one: 'aproximadamente 1 semana',
        other: 'aproximadamente {{count}} semanas'
    },
    xWeeks: {
        one: '1 semana',
        other: '{{count}} semanas'
    },
    aboutXMonths: {
        one: "aproximadamente 1 m\xeas",
        other: 'aproximadamente {{count}} meses'
    },
    xMonths: {
        one: "1 m\xeas",
        other: '{{count}} meses'
    },
    aboutXYears: {
        one: 'aproximadamente 1 ano',
        other: 'aproximadamente {{count}} anos'
    },
    xYears: {
        one: '1 ano',
        other: '{{count}} anos'
    },
    overXYears: {
        one: 'mais de 1 ano',
        other: 'mais de {{count}} anos'
    },
    almostXYears: {
        one: 'quase 1 ano',
        other: 'quase {{count}} anos'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'daqui a ' + result;
        else return "h\xe1 " + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"aas0q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: "d 'de' MMM 'de' y",
    short: 'dd/MM/y'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} '\xe0s' {{time}}",
    long: "{{date}} '\xe0s' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jUQpU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        var weekday = date.getUTCDay();
        var last = weekday === 0 || weekday === 6 ? "\xfaltimo" : "\xfaltima";
        return "'" + last + "' eeee '\xe0s' p";
    },
    yesterday: "'ontem \xe0s' p",
    today: "'hoje \xe0s' p",
    tomorrow: "'amanh\xe3 \xe0s' p",
    nextWeek: "eeee '\xe0s' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6SS5b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'aC',
        'dC'
    ],
    abbreviated: [
        'a.C.',
        'd.C.'
    ],
    wide: [
        'antes de Cristo',
        'depois de Cristo'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
var monthValues = {
    narrow: [
        'j',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'jan',
        'fev',
        'mar',
        'abr',
        'mai',
        'jun',
        'jul',
        'ago',
        'set',
        'out',
        'nov',
        'dez'
    ],
    wide: [
        'janeiro',
        'fevereiro',
        "mar\xe7o",
        'abril',
        'maio',
        'junho',
        'julho',
        'agosto',
        'setembro',
        'outubro',
        'novembro',
        'dezembro'
    ]
};
var dayValues = {
    narrow: [
        'd',
        's',
        't',
        'q',
        'q',
        's',
        's'
    ],
    short: [
        'dom',
        'seg',
        'ter',
        'qua',
        'qui',
        'sex',
        "s\xe1b"
    ],
    abbreviated: [
        'dom',
        'seg',
        'ter',
        'qua',
        'qui',
        'sex',
        "s\xe1b"
    ],
    wide: [
        'domingo',
        'segunda-feira',
        "ter\xe7a-feira",
        'quarta-feira',
        'quinta-feira',
        'sexta-feira',
        "s\xe1bado"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "manh\xe3",
        afternoon: 'tarde',
        evening: 'noite',
        night: 'madrugada'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "manh\xe3",
        afternoon: 'tarde',
        evening: 'noite',
        night: 'madrugada'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "manh\xe3",
        afternoon: 'tarde',
        evening: 'noite',
        night: 'madrugada'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "da manh\xe3",
        afternoon: 'da tarde',
        evening: 'da noite',
        night: 'da madrugada'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "da manh\xe3",
        afternoon: 'da tarde',
        evening: 'da noite',
        night: 'da madrugada'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "da manh\xe3",
        afternoon: 'da tarde',
        evening: 'da noite',
        night: 'da madrugada'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "\xba";
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7tpyy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(º|ª)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
    wide: /^(antes de cristo|antes da era comum|depois de cristo|era comum)/i
};
var parseEraPatterns = {
    any: [
        /^ac/i,
        /^dc/i
    ],
    wide: [
        /^(antes de cristo|antes da era comum)/i,
        /^(depois de cristo|era comum)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º|ª)? trimestre/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
    wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ab/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^ag/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[dstq]/i,
    short: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
    abbreviated: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
    wide: /^(domingo|segunda-?\s?feira|terça-?\s?feira|quarta-?\s?feira|quinta-?\s?feira|sexta-?\s?feira|s[áa]bado)/i
};
var parseDayPatterns = {
    narrow: [
        /^d/i,
        /^s/i,
        /^t/i,
        /^q/i,
        /^q/i,
        /^s/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^seg/i,
        /^t/i,
        /^qua/i,
        /^qui/i,
        /^sex/i,
        /^s[áa]/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i,
    any: /^([ap]\.?\s?m\.?|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^meia/i,
        noon: /^meio/i,
        morning: /manh[ãa]/i,
        afternoon: /tarde/i,
        evening: /noite/i,
        night: /madrugada/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gSfq8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Portuguese locale (Brazil).
 * @language Portuguese
 * @iso-639-2 por
 * @author Lucas Duailibe [@duailibe]{@link https://github.com/duailibe}
 * @author Yago Carballo [@yagocarballo]{@link https://github.com/YagoCarballo}
 */ var locale = {
    code: 'pt-BR',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"iPIpQ","./_lib/formatLong/index.js":"6S6cu","./_lib/formatRelative/index.js":"cxkmB","./_lib/localize/index.js":"dS2TO","./_lib/match/index.js":"k5pk6","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"iPIpQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'menos de um segundo',
        other: 'menos de {{count}} segundos'
    },
    xSeconds: {
        one: '1 segundo',
        other: '{{count}} segundos'
    },
    halfAMinute: 'meio minuto',
    lessThanXMinutes: {
        one: 'menos de um minuto',
        other: 'menos de {{count}} minutos'
    },
    xMinutes: {
        one: '1 minuto',
        other: '{{count}} minutos'
    },
    aboutXHours: {
        one: 'cerca de 1 hora',
        other: 'cerca de {{count}} horas'
    },
    xHours: {
        one: '1 hora',
        other: '{{count}} horas'
    },
    xDays: {
        one: '1 dia',
        other: '{{count}} dias'
    },
    aboutXWeeks: {
        one: 'cerca de 1 semana',
        other: 'cerca de {{count}} semanas'
    },
    xWeeks: {
        one: '1 semana',
        other: '{{count}} semanas'
    },
    aboutXMonths: {
        one: "cerca de 1 m\xeas",
        other: 'cerca de {{count}} meses'
    },
    xMonths: {
        one: "1 m\xeas",
        other: '{{count}} meses'
    },
    aboutXYears: {
        one: 'cerca de 1 ano',
        other: 'cerca de {{count}} anos'
    },
    xYears: {
        one: '1 ano',
        other: '{{count}} anos'
    },
    overXYears: {
        one: 'mais de 1 ano',
        other: 'mais de {{count}} anos'
    },
    almostXYears: {
        one: 'quase 1 ano',
        other: 'quase {{count}} anos'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'em ' + result;
        else return "h\xe1 " + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6S6cu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: 'd MMM y',
    short: 'dd/MM/yyyy'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} '\xe0s' {{time}}",
    long: "{{date}} '\xe0s' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"cxkmB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        var weekday = date.getUTCDay();
        var last = weekday === 0 || weekday === 6 ? "\xfaltimo" : "\xfaltima";
        return "'" + last + "' eeee '\xe0s' p";
    },
    yesterday: "'ontem \xe0s' p",
    today: "'hoje \xe0s' p",
    tomorrow: "'amanh\xe3 \xe0s' p",
    nextWeek: "eeee '\xe0s' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"dS2TO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'AC',
        'DC'
    ],
    abbreviated: [
        'AC',
        'DC'
    ],
    wide: [
        'antes de cristo',
        'depois de cristo'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
var monthValues = {
    narrow: [
        'j',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'jan',
        'fev',
        'mar',
        'abr',
        'mai',
        'jun',
        'jul',
        'ago',
        'set',
        'out',
        'nov',
        'dez'
    ],
    wide: [
        'janeiro',
        'fevereiro',
        "mar\xe7o",
        'abril',
        'maio',
        'junho',
        'julho',
        'agosto',
        'setembro',
        'outubro',
        'novembro',
        'dezembro'
    ]
};
var dayValues = {
    narrow: [
        'D',
        'S',
        'T',
        'Q',
        'Q',
        'S',
        'S'
    ],
    short: [
        'dom',
        'seg',
        'ter',
        'qua',
        'qui',
        'sex',
        'sab'
    ],
    abbreviated: [
        'domingo',
        'segunda',
        "ter\xe7a",
        'quarta',
        'quinta',
        'sexta',
        "s\xe1bado"
    ],
    wide: [
        'domingo',
        'segunda-feira',
        "ter\xe7a-feira",
        'quarta-feira',
        'quinta-feira',
        'sexta-feira',
        "s\xe1bado"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: 'md',
        morning: "manh\xe3",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noite'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "manh\xe3",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noite'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "manh\xe3",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noite'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: 'md',
        morning: "da manh\xe3",
        afternoon: 'da tarde',
        evening: 'da tarde',
        night: 'da noite'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "da manh\xe3",
        afternoon: 'da tarde',
        evening: 'da tarde',
        night: 'da noite'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "da manh\xe3",
        afternoon: 'da tarde',
        evening: 'da tarde',
        night: 'da noite'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    if ((options === null || options === void 0 ? void 0 : options.unit) === 'week') return number + "\xaa";
    return number + "\xba";
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"k5pk6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)[ºªo]?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|d\.?\s?c\.?)/i,
    wide: /^(antes de cristo|depois de cristo)/i
};
var parseEraPatterns = {
    any: [
        /^ac/i,
        /^dc/i
    ],
    wide: [
        /^antes de cristo/i,
        /^depois de cristo/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º)? trimestre/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmajsond]/i,
    abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
    wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^fev/i,
        /^mar/i,
        /^abr/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^ago/i,
        /^set/i,
        /^out/i,
        /^nov/i,
        /^dez/i
    ]
};
var matchDayPatterns = {
    narrow: /^(dom|[23456]ª?|s[aá]b)/i,
    short: /^(dom|[23456]ª?|s[aá]b)/i,
    abbreviated: /^(dom|seg|ter|qua|qui|sex|s[aá]b)/i,
    wide: /^(domingo|(segunda|ter[cç]a|quarta|quinta|sexta)([- ]feira)?|s[aá]bado)/i
};
var parseDayPatterns = {
    short: [
        /^d/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^s[aá]/i
    ],
    narrow: [
        /^d/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^s[aá]/i
    ],
    any: [
        /^d/i,
        /^seg/i,
        /^t/i,
        /^qua/i,
        /^qui/i,
        /^sex/i,
        /^s[aá]b/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|md|(da) (manhã|tarde|noite))/i,
    any: /^([ap]\.?\s?m\.?|meia[-\s]noite|meio[-\s]dia|(da) (manhã|tarde|noite))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mn|^meia[-\s]noite/i,
        noon: /^md|^meio[-\s]dia/i,
        morning: /manhã/i,
        afternoon: /tarde/i,
        evening: /tarde/i,
        night: /noite/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7oWCw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Romanian locale.
 * @language Romanian
 * @iso-639-2 ron
 * @author Sergiu Munteanu [@jsergiu]{@link https://github.com/jsergiu}
 * @author Adrian Ocneanu [@aocneanu]{@link https://github.com/aocneanu}
 * @author Mihai Ocneanu [@gandesc]{@link https://github.com/gandesc}
 */ var locale = {
    code: 'ro',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"l3lBK","./_lib/formatLong/index.js":"3mTQz","./_lib/formatRelative/index.js":"kDWBP","./_lib/localize/index.js":"8TT3K","./_lib/match/index.js":"khLS6","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"l3lBK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mai pu\u021Bin de o secund\u0103",
        other: "mai pu\u021Bin de {{count}} secunde"
    },
    xSeconds: {
        one: "1 secund\u0103",
        other: '{{count}} secunde'
    },
    halfAMinute: "jum\u0103tate de minut",
    lessThanXMinutes: {
        one: "mai pu\u021Bin de un minut",
        other: "mai pu\u021Bin de {{count}} minute"
    },
    xMinutes: {
        one: '1 minut',
        other: '{{count}} minute'
    },
    aboutXHours: {
        one: "circa 1 or\u0103",
        other: 'circa {{count}} ore'
    },
    xHours: {
        one: "1 or\u0103",
        other: '{{count}} ore'
    },
    xDays: {
        one: '1 zi',
        other: '{{count}} zile'
    },
    aboutXWeeks: {
        one: "circa o s\u0103pt\u0103m\xe2n\u0103",
        other: "circa {{count}} s\u0103pt\u0103m\xe2ni"
    },
    xWeeks: {
        one: "1 s\u0103pt\u0103m\xe2n\u0103",
        other: "{{count}} s\u0103pt\u0103m\xe2ni"
    },
    aboutXMonths: {
        one: "circa 1 lun\u0103",
        other: 'circa {{count}} luni'
    },
    xMonths: {
        one: "1 lun\u0103",
        other: '{{count}} luni'
    },
    aboutXYears: {
        one: 'circa 1 an',
        other: 'circa {{count}} ani'
    },
    xYears: {
        one: '1 an',
        other: '{{count}} ani'
    },
    overXYears: {
        one: 'peste 1 an',
        other: 'peste {{count}} ani'
    },
    almostXYears: {
        one: 'aproape 1 an',
        other: 'aproape {{count}} ani'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\xeen " + result;
        else return result + " \xeen urm\u0103";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3mTQz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'dd.MM.yyyy'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'la' {{time}}",
    long: "{{date}} 'la' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"kDWBP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "eeee 'trecut\u0103 la' p",
    yesterday: "'ieri la' p",
    today: "'ast\u0103zi la' p",
    tomorrow: "'m\xe2ine la' p",
    nextWeek: "eeee 'viitoare la' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8TT3K":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\xce",
        'D'
    ],
    abbreviated: [
        "\xce.d.C.",
        'D.C.'
    ],
    wide: [
        "\xcenainte de Cristos",
        "Dup\u0103 Cristos"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    wide: [
        'primul trimestru',
        'al doilea trimestru',
        'al treilea trimestru',
        'al patrulea trimestru'
    ]
};
var monthValues = {
    narrow: [
        'I',
        'F',
        'M',
        'A',
        'M',
        'I',
        'I',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'ian',
        'feb',
        'mar',
        'apr',
        'mai',
        'iun',
        'iul',
        'aug',
        'sep',
        'oct',
        'noi',
        'dec'
    ],
    wide: [
        'ianuarie',
        'februarie',
        'martie',
        'aprilie',
        'mai',
        'iunie',
        'iulie',
        'august',
        'septembrie',
        'octombrie',
        'noiembrie',
        'decembrie'
    ]
};
var dayValues = {
    narrow: [
        'd',
        'l',
        'm',
        'm',
        'j',
        'v',
        's'
    ],
    short: [
        'du',
        'lu',
        'ma',
        'mi',
        'jo',
        'vi',
        "s\xe2"
    ],
    abbreviated: [
        'dum',
        'lun',
        'mar',
        'mie',
        'joi',
        'vin',
        "s\xe2m"
    ],
    wide: [
        "duminic\u0103",
        'luni',
        "mar\u021Bi",
        'miercuri',
        'joi',
        'vineri',
        "s\xe2mb\u0103t\u0103"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: 'ami',
        morning: 'dim',
        afternoon: 'da',
        evening: 's',
        night: 'n'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "miezul nop\u021Bii",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: 'noapte'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "miezul nop\u021Bii",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: 'noapte'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: 'noapte'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "miezul nop\u021Bii",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: 'noapte'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: "miezul nop\u021Bii",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: 'noapte'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"khLS6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(Î|D)/i,
    abbreviated: /^(Î\.?\s?d\.?\s?C\.?|Î\.?\s?e\.?\s?n\.?|D\.?\s?C\.?|e\.?\s?n\.?)/i,
    wide: /^(Înainte de Cristos|Înaintea erei noastre|După Cristos|Era noastră)/i
};
var parseEraPatterns = {
    any: [
        /^ÎC/i,
        /^DC/i
    ],
    wide: [
        /^(Înainte de Cristos|Înaintea erei noastre)/i,
        /^(După Cristos|Era noastră)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^trimestrul [1234]/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[ifmaasond]/i,
    abbreviated: /^(ian|feb|mar|apr|mai|iun|iul|aug|sep|oct|noi|dec)/i,
    wide: /^(ianuarie|februarie|martie|aprilie|mai|iunie|iulie|august|septembrie|octombrie|noiembrie|decembrie)/i
};
var parseMonthPatterns = {
    narrow: [
        /^i/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^i/i,
        /^i/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ia/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mai/i,
        /^iun/i,
        /^iul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[dlmjvs]/i,
    short: /^(d|l|ma|mi|j|v|s)/i,
    abbreviated: /^(dum|lun|mar|mie|jo|vi|sâ)/i,
    wide: /^(duminica|luni|marţi|miercuri|joi|vineri|sâmbătă)/i
};
var parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^l/i,
        /^ma/i,
        /^mi/i,
        /^j/i,
        /^v/i,
        /^s/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|a|(dimineaţa|după-amiaza|seara|noaptea))/i,
    any: /^([ap]\.?\s?m\.?|miezul nopții|amiaza|(dimineaţa|după-amiaza|seara|noaptea))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mn/i,
        noon: /amiaza/i,
        morning: /dimineaţa/i,
        afternoon: /după-amiaza/i,
        evening: /seara/i,
        night: /noaptea/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"9f9Hf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Russian locale.
 * @language Russian
 * @iso-639-2 rus
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var locale = {
    code: 'ru',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"5RUDY","./_lib/formatLong/index.js":"kBMVT","./_lib/formatRelative/index.js":"9VipW","./_lib/localize/index.js":"DWOAb","./_lib/match/index.js":"9LgHz","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5RUDY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function declension(scheme, count) {
    // scheme for count=1 exists
    if (scheme.one !== undefined && count === 1) return scheme.one;
    var rem10 = count % 10;
    var rem100 = count % 100;
    // 1, 21, 31, ...
    if (rem10 === 1 && rem100 !== 11) return scheme.singularNominative.replace('{{count}}', String(count));
    else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) return scheme.singularGenitive.replace('{{count}}', String(count));
    else return scheme.pluralGenitive.replace('{{count}}', String(count));
}
function buildLocalizeTokenFn(scheme) {
    return function(count, options) {
        if (options !== null && options !== void 0 && options.addSuffix) {
            if (options.comparison && options.comparison > 0) {
                if (scheme.future) return declension(scheme.future, count);
                else return "\u0447\u0435\u0440\u0435\u0437 " + declension(scheme.regular, count);
            } else {
                if (scheme.past) return declension(scheme.past, count);
                else return declension(scheme.regular, count) + " \u043D\u0430\u0437\u0430\u0434";
            }
        } else return declension(scheme.regular, count);
    };
}
var formatDistanceLocale = {
    lessThanXSeconds: buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u044C\u0448\u0435 \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434",
            pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        future: {
            one: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    xSeconds: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        past: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443 \u043D\u0430\u0437\u0430\u0434",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B \u043D\u0430\u0437\u0430\u0434",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u043D\u0430\u0437\u0430\u0434"
        },
        future: {
            singularNominative: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    halfAMinute: function halfAMinute(_count, options) {
        if (options !== null && options !== void 0 && options.addSuffix) {
            if (options.comparison && options.comparison > 0) return "\u0447\u0435\u0440\u0435\u0437 \u043F\u043E\u043B\u043C\u0438\u043D\u0443\u0442\u044B";
            else return "\u043F\u043E\u043B\u043C\u0438\u043D\u0443\u0442\u044B \u043D\u0430\u0437\u0430\u0434";
        }
        return "\u043F\u043E\u043B\u043C\u0438\u043D\u0443\u0442\u044B";
    },
    lessThanXMinutes: buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u044C\u0448\u0435 \u043C\u0438\u043D\u0443\u0442\u044B",
            singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
            singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u043C\u0438\u043D\u0443\u0442",
            pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u043C\u0438\u043D\u0443\u0442"
        },
        future: {
            one: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 \u043C\u0438\u043D\u0443\u0442\u0443",
            singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u0443",
            singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442"
        }
    }),
    xMinutes: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0430",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442"
        },
        past: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0443 \u043D\u0430\u0437\u0430\u0434",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u044B \u043D\u0430\u0437\u0430\u0434",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u043D\u0430\u0437\u0430\u0434"
        },
        future: {
            singularNominative: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u0443",
            singularGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
            pluralGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442"
        }
    }),
    aboutXHours: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u0430",
            singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u043E\u0432",
            pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u043E\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0447\u0430\u0441",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0447\u0430\u0441\u0430",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0447\u0430\u0441\u043E\u0432"
        }
    }),
    xHours: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0447\u0430\u0441",
            singularGenitive: "{{count}} \u0447\u0430\u0441\u0430",
            pluralGenitive: "{{count}} \u0447\u0430\u0441\u043E\u0432"
        }
    }),
    xDays: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0434\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0434\u043D\u044F",
            pluralGenitive: "{{count}} \u0434\u043D\u0435\u0439"
        }
    }),
    aboutXWeeks: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043D\u0435\u0434\u0435\u043B\u0438",
            singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043D\u0435\u0434\u0435\u043B\u044C",
            pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043D\u0435\u0434\u0435\u043B\u044C"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043D\u0435\u0434\u0435\u043B\u044E",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043D\u0435\u0434\u0435\u043B\u0438",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043D\u0435\u0434\u0435\u043B\u044C"
        }
    }),
    xWeeks: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043D\u0435\u0434\u0435\u043B\u044F",
            singularGenitive: "{{count}} \u043D\u0435\u0434\u0435\u043B\u0438",
            pluralGenitive: "{{count}} \u043D\u0435\u0434\u0435\u043B\u044C"
        }
    }),
    aboutXMonths: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432",
            pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432"
        }
    }),
    xMonths: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            pluralGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432"
        }
    }),
    aboutXYears: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0433\u043E\u0434\u0430",
            singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043B\u0435\u0442",
            pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043B\u0435\u0442"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043B\u0435\u0442"
        }
    }),
    xYears: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u043E\u0434",
            singularGenitive: "{{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "{{count}} \u043B\u0435\u0442"
        }
    }),
    overXYears: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448\u0435 {{count}} \u0433\u043E\u0434\u0430",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435 {{count}} \u043B\u0435\u0442",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435 {{count}} \u043B\u0435\u0442"
        },
        future: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043B\u0435\u0442"
        }
    }),
    almostXYears: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u043B\u0435\u0442"
        },
        future: {
            singularNominative: "\u043F\u043E\u0447\u0442\u0438 \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u043E\u0447\u0442\u0438 \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "\u043F\u043E\u0447\u0442\u0438 \u0447\u0435\u0440\u0435\u0437 {{count}} \u043B\u0435\u0442"
        }
    })
};
var formatDistance = function formatDistance(token, count, options) {
    return formatDistanceLocale[token](count, options);
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"kBMVT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE, d MMMM y '\u0433.'",
    long: "d MMMM y '\u0433.'",
    medium: "d MMM y '\u0433.'",
    short: 'dd.MM.y'
};
var timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var dateTimeFormats = {
    any: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'any'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"9VipW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../../_lib/isSameUTCWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var accusativeWeekdays = [
    "\u0432\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435",
    "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A",
    "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
    "\u0441\u0440\u0435\u0434\u0443",
    "\u0447\u0435\u0442\u0432\u0435\u0440\u0433",
    "\u043F\u044F\u0442\u043D\u0438\u0446\u0443",
    "\u0441\u0443\u0431\u0431\u043E\u0442\u0443"
];
function _lastWeek(day) {
    var weekday = accusativeWeekdays[day];
    switch(day){
        case 0:
            return "'\u0432 \u043F\u0440\u043E\u0448\u043B\u043E\u0435 " + weekday + " \u0432' p";
        case 1:
        case 2:
        case 4:
            return "'\u0432 \u043F\u0440\u043E\u0448\u043B\u044B\u0439 " + weekday + " \u0432' p";
        case 3:
        case 5:
        case 6:
            return "'\u0432 \u043F\u0440\u043E\u0448\u043B\u0443\u044E " + weekday + " \u0432' p";
    }
}
function thisWeek(day) {
    var weekday = accusativeWeekdays[day];
    if (day === 2 /* Tue */ ) return "'\u0432\u043E " + weekday + " \u0432' p";
    else return "'\u0432 " + weekday + " \u0432' p";
}
function _nextWeek(day) {
    var weekday = accusativeWeekdays[day];
    switch(day){
        case 0:
            return "'\u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u0435 " + weekday + " \u0432' p";
        case 1:
        case 2:
        case 4:
            return "'\u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439 " + weekday + " \u0432' p";
        case 3:
        case 5:
        case 6:
            return "'\u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0443\u044E " + weekday + " \u0432' p";
    }
}
var formatRelativeLocale = {
    lastWeek: function lastWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, _indexJsDefault.default)(date, baseDate, options)) return thisWeek(day);
        else return _lastWeek(day);
    },
    yesterday: "'\u0432\u0447\u0435\u0440\u0430 \u0432' p",
    today: "'\u0441\u0435\u0433\u043E\u0434\u043D\u044F \u0432' p",
    tomorrow: "'\u0437\u0430\u0432\u0442\u0440\u0430 \u0432' p",
    nextWeek: function nextWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, _indexJsDefault.default)(date, baseDate, options)) return thisWeek(day);
        else return _nextWeek(day);
    },
    other: 'P'
};
var formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
exports.default = formatRelative;

},{"../../../../_lib/isSameUTCWeek/index.js":"g7rCW","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"DWOAb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u0434\u043E \u043D.\u044D.",
        "\u043D.\u044D."
    ],
    abbreviated: [
        "\u0434\u043E \u043D. \u044D.",
        "\u043D. \u044D."
    ],
    wide: [
        "\u0434\u043E \u043D\u0430\u0448\u0435\u0439 \u044D\u0440\u044B",
        "\u043D\u0430\u0448\u0435\u0439 \u044D\u0440\u044B"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1-\u0439 \u043A\u0432.",
        "2-\u0439 \u043A\u0432.",
        "3-\u0439 \u043A\u0432.",
        "4-\u0439 \u043A\u0432."
    ],
    wide: [
        "1-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
var monthValues = {
    narrow: [
        "\u042F",
        "\u0424",
        "\u041C",
        "\u0410",
        "\u041C",
        "\u0418",
        "\u0418",
        "\u0410",
        "\u0421",
        "\u041E",
        "\u041D",
        "\u0414"
    ],
    abbreviated: [
        "\u044F\u043D\u0432.",
        "\u0444\u0435\u0432.",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440.",
        "\u043C\u0430\u0439",
        "\u0438\u044E\u043D\u044C",
        "\u0438\u044E\u043B\u044C",
        "\u0430\u0432\u0433.",
        "\u0441\u0435\u043D\u0442.",
        "\u043E\u043A\u0442.",
        "\u043D\u043E\u044F\u0431.",
        "\u0434\u0435\u043A."
    ],
    wide: [
        "\u044F\u043D\u0432\u0430\u0440\u044C",
        "\u0444\u0435\u0432\u0440\u0430\u043B\u044C",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0435\u043B\u044C",
        "\u043C\u0430\u0439",
        "\u0438\u044E\u043D\u044C",
        "\u0438\u044E\u043B\u044C",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044C",
        "\u043E\u043A\u0442\u044F\u0431\u0440\u044C",
        "\u043D\u043E\u044F\u0431\u0440\u044C",
        "\u0434\u0435\u043A\u0430\u0431\u0440\u044C"
    ]
};
var formattingMonthValues = {
    narrow: [
        "\u042F",
        "\u0424",
        "\u041C",
        "\u0410",
        "\u041C",
        "\u0418",
        "\u0418",
        "\u0410",
        "\u0421",
        "\u041E",
        "\u041D",
        "\u0414"
    ],
    abbreviated: [
        "\u044F\u043D\u0432.",
        "\u0444\u0435\u0432.",
        "\u043C\u0430\u0440.",
        "\u0430\u043F\u0440.",
        "\u043C\u0430\u044F",
        "\u0438\u044E\u043D.",
        "\u0438\u044E\u043B.",
        "\u0430\u0432\u0433.",
        "\u0441\u0435\u043D\u0442.",
        "\u043E\u043A\u0442.",
        "\u043D\u043E\u044F\u0431.",
        "\u0434\u0435\u043A."
    ],
    wide: [
        "\u044F\u043D\u0432\u0430\u0440\u044F",
        "\u0444\u0435\u0432\u0440\u0430\u043B\u044F",
        "\u043C\u0430\u0440\u0442\u0430",
        "\u0430\u043F\u0440\u0435\u043B\u044F",
        "\u043C\u0430\u044F",
        "\u0438\u044E\u043D\u044F",
        "\u0438\u044E\u043B\u044F",
        "\u0430\u0432\u0433\u0443\u0441\u0442\u0430",
        "\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044F",
        "\u043E\u043A\u0442\u044F\u0431\u0440\u044F",
        "\u043D\u043E\u044F\u0431\u0440\u044F",
        "\u0434\u0435\u043A\u0430\u0431\u0440\u044F"
    ]
};
var dayValues = {
    narrow: [
        "\u0412",
        "\u041F",
        "\u0412",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u0432\u0441",
        "\u043F\u043D",
        "\u0432\u0442",
        "\u0441\u0440",
        "\u0447\u0442",
        "\u043F\u0442",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u0432\u0441\u043A",
        "\u043F\u043D\u0434",
        "\u0432\u0442\u0440",
        "\u0441\u0440\u0434",
        "\u0447\u0442\u0432",
        "\u043F\u0442\u043D",
        "\u0441\u0443\u0431"
    ],
    wide: [
        "\u0432\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435",
        "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A",
        "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
        "\u0441\u0440\u0435\u0434\u0430",
        "\u0447\u0435\u0442\u0432\u0435\u0440\u0433",
        "\u043F\u044F\u0442\u043D\u0438\u0446\u0430",
        "\u0441\u0443\u0431\u0431\u043E\u0442\u0430"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D.",
        noon: "\u043F\u043E\u043B\u0434.",
        morning: "\u0443\u0442\u0440\u043E",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044C"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D.",
        noon: "\u043F\u043E\u043B\u0434.",
        morning: "\u0443\u0442\u0440\u043E",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044C"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D\u043E\u0447\u044C",
        noon: "\u043F\u043E\u043B\u0434\u0435\u043D\u044C",
        morning: "\u0443\u0442\u0440\u043E",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447\u0435\u0440",
        night: "\u043D\u043E\u0447\u044C"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D.",
        noon: "\u043F\u043E\u043B\u0434.",
        morning: "\u0443\u0442\u0440\u0430",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0438"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D.",
        noon: "\u043F\u043E\u043B\u0434.",
        morning: "\u0443\u0442\u0440\u0430",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0438"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D\u043E\u0447\u044C",
        noon: "\u043F\u043E\u043B\u0434\u0435\u043D\u044C",
        morning: "\u0443\u0442\u0440\u0430",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447\u0435\u0440\u0430",
        night: "\u043D\u043E\u0447\u0438"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    var suffix;
    if (unit === 'date') suffix = "-\u0435";
    else if (unit === 'week' || unit === 'minute' || unit === 'second') suffix = "-\u044F";
    else suffix = "-\u0439";
    return number + suffix;
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide',
        formattingValues: formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'any',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"9LgHz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(-?(е|я|й|ое|ье|ая|ья|ый|ой|ий|ый))?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^((до )?н\.?\s?э\.?)/i,
    abbreviated: /^((до )?н\.?\s?э\.?)/i,
    wide: /^(до нашей эры|нашей эры|наша эра)/i
};
var parseEraPatterns = {
    any: [
        /^д/i,
        /^н/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[ыои]?й?)? кв.?/i,
    wide: /^[1234](-?[ыои]?й?)? квартал/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[яфмаисонд]/i,
    abbreviated: /^(янв|фев|март?|апр|ма[йя]|июн[ья]?|июл[ья]?|авг|сент?|окт|нояб?|дек)\.?/i,
    wide: /^(январ[ья]|феврал[ья]|марта?|апрел[ья]|ма[йя]|июн[ья]|июл[ья]|августа?|сентябр[ья]|октябр[ья]|октябр[ья]|ноябр[ья]|декабр[ья])/i
};
var parseMonthPatterns = {
    narrow: [
        /^я/i,
        /^ф/i,
        /^м/i,
        /^а/i,
        /^м/i,
        /^и/i,
        /^и/i,
        /^а/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^я/i
    ],
    any: [
        /^я/i,
        /^ф/i,
        /^мар/i,
        /^ап/i,
        /^ма[йя]/i,
        /^июн/i,
        /^июл/i,
        /^ав/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^д/i
    ]
};
var matchDayPatterns = {
    narrow: /^[впсч]/i,
    short: /^(вс|во|пн|по|вт|ср|чт|че|пт|пя|сб|су)\.?/i,
    abbreviated: /^(вск|вос|пнд|пон|втр|вто|срд|сре|чтв|чет|птн|пят|суб).?/i,
    wide: /^(воскресень[ея]|понедельника?|вторника?|сред[аы]|четверга?|пятниц[аы]|суббот[аы])/i
};
var parseDayPatterns = {
    narrow: [
        /^в/i,
        /^п/i,
        /^в/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^в[ос]/i,
        /^п[он]/i,
        /^в/i,
        /^ср/i,
        /^ч/i,
        /^п[ят]/i,
        /^с[уб]/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
    abbreviated: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
    wide: /^([дп]п|полночь|полдень|утр[оа]|день|дня|вечера?|ноч[ьи])/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^дп/i,
        pm: /^пп/i,
        midnight: /^полн/i,
        noon: /^полд/i,
        morning: /^у/i,
        afternoon: /^д[ен]/i,
        evening: /^в/i,
        night: /^н/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"9snbz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Slovak locale.
 * @language Slovak
 * @iso-639-2 slk
 * @author Marek Suscak [@mareksuscak]{@link https://github.com/mareksuscak}
 */ var locale = {
    code: 'sk',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"hV9bl","./_lib/formatLong/index.js":"eScMG","./_lib/formatRelative/index.js":"gaA5X","./_lib/localize/index.js":"cS2jH","./_lib/match/index.js":"8KX2G","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"hV9bl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function declensionGroup(scheme, count) {
    if (count === 1 && scheme.one) return scheme.one;
    if (count >= 2 && count <= 4 && scheme.twoFour) return scheme.twoFour;
    // if count === null || count === 0 || count >= 5
    return scheme.other;
}
function declension(scheme, count, time) {
    var group = declensionGroup(scheme, count);
    var finalText = group[time];
    return finalText.replace('{{count}}', String(count));
}
function extractPreposition(token) {
    var result = [
        'lessThan',
        'about',
        'over',
        'almost'
    ].filter(function(preposition) {
        return !!token.match(new RegExp('^' + preposition));
    });
    return result[0];
}
function prefixPreposition(preposition) {
    var translation = '';
    if (preposition === 'almost') translation = 'takmer';
    if (preposition === 'about') translation = "pribli\u017Ene";
    return translation.length > 0 ? translation + ' ' : '';
}
function suffixPreposition(preposition) {
    var translation = '';
    if (preposition === 'lessThan') translation = "menej ne\u017E";
    if (preposition === 'over') translation = "viac ne\u017E";
    return translation.length > 0 ? translation + ' ' : '';
}
function lowercaseFirstLetter(string) {
    return string.charAt(0).toLowerCase() + string.slice(1);
}
var formatDistanceLocale = {
    xSeconds: {
        one: {
            present: 'sekunda',
            past: 'sekundou',
            future: 'sekundu'
        },
        twoFour: {
            present: '{{count}} sekundy',
            past: '{{count}} sekundami',
            future: '{{count}} sekundy'
        },
        other: {
            present: "{{count}} sek\xfand",
            past: '{{count}} sekundami',
            future: "{{count}} sek\xfand"
        }
    },
    halfAMinute: {
        other: {
            present: "pol min\xfaty",
            past: "pol min\xfatou",
            future: "pol min\xfaty"
        }
    },
    xMinutes: {
        one: {
            present: "min\xfata",
            past: "min\xfatou",
            future: "min\xfatu"
        },
        twoFour: {
            present: "{{count}} min\xfaty",
            past: "{{count}} min\xfatami",
            future: "{{count}} min\xfaty"
        },
        other: {
            present: "{{count}} min\xfat",
            past: "{{count}} min\xfatami",
            future: "{{count}} min\xfat"
        }
    },
    xHours: {
        one: {
            present: 'hodina',
            past: 'hodinou',
            future: 'hodinu'
        },
        twoFour: {
            present: '{{count}} hodiny',
            past: '{{count}} hodinami',
            future: '{{count}} hodiny'
        },
        other: {
            present: "{{count}} hod\xedn",
            past: '{{count}} hodinami',
            future: "{{count}} hod\xedn"
        }
    },
    xDays: {
        one: {
            present: "de\u0148",
            past: "d\u0148om",
            future: "de\u0148"
        },
        twoFour: {
            present: '{{count}} dni',
            past: "{{count}} d\u0148ami",
            future: '{{count}} dni'
        },
        other: {
            present: "{{count}} dn\xed",
            past: "{{count}} d\u0148ami",
            future: "{{count}} dn\xed"
        }
    },
    xWeeks: {
        one: {
            present: "t\xfd\u017Ede\u0148",
            past: "t\xfd\u017Ed\u0148om",
            future: "t\xfd\u017Ede\u0148"
        },
        twoFour: {
            present: "{{count}} t\xfd\u017Edne",
            past: "{{count}} t\xfd\u017Ed\u0148ami",
            future: "{{count}} t\xfd\u017Edne"
        },
        other: {
            present: "{{count}} t\xfd\u017Ed\u0148ov",
            past: "{{count}} t\xfd\u017Ed\u0148ami",
            future: "{{count}} t\xfd\u017Ed\u0148ov"
        }
    },
    xMonths: {
        one: {
            present: 'mesiac',
            past: 'mesiacom',
            future: 'mesiac'
        },
        twoFour: {
            present: '{{count}} mesiace',
            past: '{{count}} mesiacmi',
            future: '{{count}} mesiace'
        },
        other: {
            present: '{{count}} mesiacov',
            past: '{{count}} mesiacmi',
            future: '{{count}} mesiacov'
        }
    },
    xYears: {
        one: {
            present: 'rok',
            past: 'rokom',
            future: 'rok'
        },
        twoFour: {
            present: '{{count}} roky',
            past: '{{count}} rokmi',
            future: '{{count}} roky'
        },
        other: {
            present: '{{count}} rokov',
            past: '{{count}} rokmi',
            future: '{{count}} rokov'
        }
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var preposition = extractPreposition(token) || '';
    var key = lowercaseFirstLetter(token.substring(preposition.length));
    var scheme = formatDistanceLocale[key];
    if (!(options !== null && options !== void 0 && options.addSuffix)) return prefixPreposition(preposition) + suffixPreposition(preposition) + declension(scheme, count, 'present');
    if (options.comparison && options.comparison > 0) return prefixPreposition(preposition) + 'o ' + suffixPreposition(preposition) + declension(scheme, count, 'future');
    else return prefixPreposition(preposition) + 'pred ' + suffixPreposition(preposition) + declension(scheme, count, 'past');
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"eScMG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js"); // https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#1986
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE d. MMMM y',
    long: 'd. MMMM y',
    medium: 'd. M. y',
    short: 'd. M. y'
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#2149
var timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#1994
var dateTimeFormats = {
    full: '{{date}}, {{time}}',
    long: '{{date}}, {{time}}',
    medium: '{{date}}, {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gaA5X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../../_lib/isSameUTCWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
// https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#1308
var accusativeWeekdays = [
    "nede\u013Eu",
    'pondelok',
    'utorok',
    'stredu',
    "\u0161tvrtok",
    'piatok',
    'sobotu'
];
function _lastWeek(day) {
    var weekday = accusativeWeekdays[day];
    switch(day){
        case 0:
        /* Sun */ case 3:
        /* Wed */ case 6 /* Sat */ :
            return "'minul\xfa " + weekday + " o' p";
        default:
            return "'minul\xfd' eeee 'o' p";
    }
}
function thisWeek(day) {
    var weekday = accusativeWeekdays[day];
    if (day === 4 /* Thu */ ) return "'vo' eeee 'o' p";
    else return "'v " + weekday + " o' p";
}
function _nextWeek(day) {
    var weekday = accusativeWeekdays[day];
    switch(day){
        case 0:
        /* Sun */ case 4:
        /* Wed */ case 6 /* Sat */ :
            return "'bud\xfacu " + weekday + " o' p";
        default:
            return "'bud\xfaci' eeee 'o' p";
    }
}
var formatRelativeLocale = {
    lastWeek: function lastWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, _indexJsDefault.default)(date, baseDate, options)) return thisWeek(day);
        else return _lastWeek(day);
    },
    yesterday: "'v\u010Dera o' p",
    today: "'dnes o' p",
    tomorrow: "'zajtra o' p",
    nextWeek: function nextWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, _indexJsDefault.default)(date, baseDate, options)) return thisWeek(day);
        else return _nextWeek(day);
    },
    other: 'P'
};
var formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
exports.default = formatRelative;

},{"../../../../_lib/isSameUTCWeek/index.js":"g7rCW","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"cS2jH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js"); // https://www.unicode.org/cldr/charts/32/summary/sk.html#1772
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'pred Kr.',
        'po Kr.'
    ],
    abbreviated: [
        'pred Kr.',
        'po Kr.'
    ],
    wide: [
        'pred Kristom',
        'po Kristovi'
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html#1780
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "1. \u0161tvr\u0165rok",
        "2. \u0161tvr\u0165rok",
        "3. \u0161tvr\u0165rok",
        "4. \u0161tvr\u0165rok"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html#1804
var monthValues = {
    narrow: [
        'j',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'jan',
        'feb',
        'mar',
        'apr',
        "m\xe1j",
        "j\xfan",
        "j\xfal",
        'aug',
        'sep',
        'okt',
        'nov',
        'dec'
    ],
    wide: [
        "janu\xe1r",
        "febru\xe1r",
        'marec',
        "apr\xedl",
        "m\xe1j",
        "j\xfan",
        "j\xfal",
        'august',
        'september',
        "okt\xf3ber",
        'november',
        'december'
    ]
};
var formattingMonthValues = {
    narrow: [
        'j',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'jan',
        'feb',
        'mar',
        'apr',
        "m\xe1j",
        "j\xfan",
        "j\xfal",
        'aug',
        'sep',
        'okt',
        'nov',
        'dec'
    ],
    wide: [
        "janu\xe1ra",
        "febru\xe1ra",
        'marca',
        "apr\xedla",
        "m\xe1ja",
        "j\xfana",
        "j\xfala",
        'augusta',
        'septembra',
        "okt\xf3bra",
        'novembra',
        'decembra'
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html#1876
var dayValues = {
    narrow: [
        'n',
        'p',
        'u',
        's',
        "\u0161",
        'p',
        's'
    ],
    short: [
        'ne',
        'po',
        'ut',
        'st',
        "\u0161t",
        'pi',
        'so'
    ],
    abbreviated: [
        'ne',
        'po',
        'ut',
        'st',
        "\u0161t",
        'pi',
        'so'
    ],
    wide: [
        "nede\u013Ea",
        'pondelok',
        'utorok',
        'streda',
        "\u0161tvrtok",
        'piatok',
        'sobota'
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html#1932
var dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'poln.',
        noon: 'pol.',
        morning: "r\xe1no",
        afternoon: 'pop.',
        evening: "ve\u010D.",
        night: 'noc'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'poln.',
        noon: 'pol.',
        morning: "r\xe1no",
        afternoon: 'popol.',
        evening: "ve\u010Der",
        night: 'noc'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'polnoc',
        noon: 'poludnie',
        morning: "r\xe1no",
        afternoon: 'popoludnie',
        evening: "ve\u010Der",
        night: 'noc'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'o poln.',
        noon: 'nap.',
        morning: "r\xe1no",
        afternoon: 'pop.',
        evening: "ve\u010D.",
        night: 'v n.'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'o poln.',
        noon: 'napol.',
        morning: "r\xe1no",
        afternoon: 'popol.',
        evening: "ve\u010Der",
        night: 'v noci'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'o polnoci',
        noon: 'napoludnie',
        morning: "r\xe1no",
        afternoon: "popoludn\xed",
        evening: "ve\u010Der",
        night: 'v noci'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide',
        formattingValues: formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8KX2G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)\.?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
    abbreviated: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
    wide: /^(pred Kristom|pred na[šs][íi]m letopo[čc]tom|po Kristovi|n[áa][šs]ho letopo[čc]tu)/i
};
var parseEraPatterns = {
    any: [
        /^pr/i,
        /^(po|n)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234]\. [šs]tvr[ťt]rok/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|m[áa]j|j[úu]n|j[úu]l|aug|sep|okt|nov|dec)/i,
    wide: /^(janu[áa]ra?|febru[áa]ra?|(marec|marca)|apr[íi]la?|m[áa]ja?|j[úu]na?|j[úu]la?|augusta?|(september|septembra)|(okt[óo]ber|okt[óo]bra)|(november|novembra)|(december|decembra))/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^m[áa]j/i,
        /^j[úu]n/i,
        /^j[úu]l/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[npusšp]/i,
    short: /^(ne|po|ut|st|št|pi|so)/i,
    abbreviated: /^(ne|po|ut|st|št|pi|so)/i,
    wide: /^(nede[ľl]a|pondelok|utorok|streda|[šs]tvrtok|piatok|sobota])/i
};
var parseDayPatterns = {
    narrow: [
        /^n/i,
        /^p/i,
        /^u/i,
        /^s/i,
        /^š/i,
        /^p/i,
        /^s/i
    ],
    any: [
        /^n/i,
        /^po/i,
        /^u/i,
        /^st/i,
        /^(št|stv)/i,
        /^pi/i,
        /^so/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(am|pm|(o )?poln\.?|(nap\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]\.?|(v n\.?|noc))/i,
    abbreviated: /^(am|pm|(o )?poln\.?|(napol\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]er|(v )?noci?)/i,
    any: /^(am|pm|(o )?polnoci?|(na)?poludnie|r[áa]no|popoludn(ie|í|i)|ve[čc]er|(v )?noci?)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /poln/i,
        noon: /^(nap|(na)?pol(\.|u))/i,
        morning: /^r[áa]no/i,
        afternoon: /^pop/i,
        evening: /^ve[čc]/i,
        night: /^(noc|v n\.)/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4eB7k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Slovenian locale.
 * @language Slovenian
 * @iso-639-2 slv
 * @author Adam Stradovnik [@Neoglyph]{@link https://github.com/Neoglyph}
 * @author Mato Žgajner [@mzgajner]{@link https://github.com/mzgajner}
 */ var locale = {
    code: 'sl',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"3fiHf","./_lib/formatLong/index.js":"gaDm2","./_lib/formatRelative/index.js":"gI2sg","./_lib/localize/index.js":"Q2Yjo","./_lib/match/index.js":"eh7wt","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3fiHf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function isPluralType(val) {
    return val.one !== undefined;
}
var formatDistanceLocale = {
    lessThanXSeconds: {
        present: {
            one: 'manj kot {{count}} sekunda',
            two: 'manj kot {{count}} sekundi',
            few: 'manj kot {{count}} sekunde',
            other: 'manj kot {{count}} sekund'
        },
        past: {
            one: 'manj kot {{count}} sekundo',
            two: 'manj kot {{count}} sekundama',
            few: 'manj kot {{count}} sekundami',
            other: 'manj kot {{count}} sekundami'
        },
        future: {
            one: 'manj kot {{count}} sekundo',
            two: 'manj kot {{count}} sekundi',
            few: 'manj kot {{count}} sekunde',
            other: 'manj kot {{count}} sekund'
        }
    },
    xSeconds: {
        present: {
            one: '{{count}} sekunda',
            two: '{{count}} sekundi',
            few: '{{count}} sekunde',
            other: '{{count}} sekund'
        },
        past: {
            one: '{{count}} sekundo',
            two: '{{count}} sekundama',
            few: '{{count}} sekundami',
            other: '{{count}} sekundami'
        },
        future: {
            one: '{{count}} sekundo',
            two: '{{count}} sekundi',
            few: '{{count}} sekunde',
            other: '{{count}} sekund'
        }
    },
    halfAMinute: 'pol minute',
    lessThanXMinutes: {
        present: {
            one: 'manj kot {{count}} minuta',
            two: 'manj kot {{count}} minuti',
            few: 'manj kot {{count}} minute',
            other: 'manj kot {{count}} minut'
        },
        past: {
            one: 'manj kot {{count}} minuto',
            two: 'manj kot {{count}} minutama',
            few: 'manj kot {{count}} minutami',
            other: 'manj kot {{count}} minutami'
        },
        future: {
            one: 'manj kot {{count}} minuto',
            two: 'manj kot {{count}} minuti',
            few: 'manj kot {{count}} minute',
            other: 'manj kot {{count}} minut'
        }
    },
    xMinutes: {
        present: {
            one: '{{count}} minuta',
            two: '{{count}} minuti',
            few: '{{count}} minute',
            other: '{{count}} minut'
        },
        past: {
            one: '{{count}} minuto',
            two: '{{count}} minutama',
            few: '{{count}} minutami',
            other: '{{count}} minutami'
        },
        future: {
            one: '{{count}} minuto',
            two: '{{count}} minuti',
            few: '{{count}} minute',
            other: '{{count}} minut'
        }
    },
    aboutXHours: {
        present: {
            one: "pribli\u017Eno {{count}} ura",
            two: "pribli\u017Eno {{count}} uri",
            few: "pribli\u017Eno {{count}} ure",
            other: "pribli\u017Eno {{count}} ur"
        },
        past: {
            one: "pribli\u017Eno {{count}} uro",
            two: "pribli\u017Eno {{count}} urama",
            few: "pribli\u017Eno {{count}} urami",
            other: "pribli\u017Eno {{count}} urami"
        },
        future: {
            one: "pribli\u017Eno {{count}} uro",
            two: "pribli\u017Eno {{count}} uri",
            few: "pribli\u017Eno {{count}} ure",
            other: "pribli\u017Eno {{count}} ur"
        }
    },
    xHours: {
        present: {
            one: '{{count}} ura',
            two: '{{count}} uri',
            few: '{{count}} ure',
            other: '{{count}} ur'
        },
        past: {
            one: '{{count}} uro',
            two: '{{count}} urama',
            few: '{{count}} urami',
            other: '{{count}} urami'
        },
        future: {
            one: '{{count}} uro',
            two: '{{count}} uri',
            few: '{{count}} ure',
            other: '{{count}} ur'
        }
    },
    xDays: {
        present: {
            one: '{{count}} dan',
            two: '{{count}} dni',
            few: '{{count}} dni',
            other: '{{count}} dni'
        },
        past: {
            one: '{{count}} dnem',
            two: '{{count}} dnevoma',
            few: '{{count}} dnevi',
            other: '{{count}} dnevi'
        },
        future: {
            one: '{{count}} dan',
            two: '{{count}} dni',
            few: '{{count}} dni',
            other: '{{count}} dni'
        }
    },
    // no tenses for weeks?
    aboutXWeeks: {
        one: "pribli\u017Eno {{count}} teden",
        two: "pribli\u017Eno {{count}} tedna",
        few: "pribli\u017Eno {{count}} tedne",
        other: "pribli\u017Eno {{count}} tednov"
    },
    // no tenses for weeks?
    xWeeks: {
        one: '{{count}} teden',
        two: '{{count}} tedna',
        few: '{{count}} tedne',
        other: '{{count}} tednov'
    },
    aboutXMonths: {
        present: {
            one: "pribli\u017Eno {{count}} mesec",
            two: "pribli\u017Eno {{count}} meseca",
            few: "pribli\u017Eno {{count}} mesece",
            other: "pribli\u017Eno {{count}} mesecev"
        },
        past: {
            one: "pribli\u017Eno {{count}} mesecem",
            two: "pribli\u017Eno {{count}} mesecema",
            few: "pribli\u017Eno {{count}} meseci",
            other: "pribli\u017Eno {{count}} meseci"
        },
        future: {
            one: "pribli\u017Eno {{count}} mesec",
            two: "pribli\u017Eno {{count}} meseca",
            few: "pribli\u017Eno {{count}} mesece",
            other: "pribli\u017Eno {{count}} mesecev"
        }
    },
    xMonths: {
        present: {
            one: '{{count}} mesec',
            two: '{{count}} meseca',
            few: '{{count}} meseci',
            other: '{{count}} mesecev'
        },
        past: {
            one: '{{count}} mesecem',
            two: '{{count}} mesecema',
            few: '{{count}} meseci',
            other: '{{count}} meseci'
        },
        future: {
            one: '{{count}} mesec',
            two: '{{count}} meseca',
            few: '{{count}} mesece',
            other: '{{count}} mesecev'
        }
    },
    aboutXYears: {
        present: {
            one: "pribli\u017Eno {{count}} leto",
            two: "pribli\u017Eno {{count}} leti",
            few: "pribli\u017Eno {{count}} leta",
            other: "pribli\u017Eno {{count}} let"
        },
        past: {
            one: "pribli\u017Eno {{count}} letom",
            two: "pribli\u017Eno {{count}} letoma",
            few: "pribli\u017Eno {{count}} leti",
            other: "pribli\u017Eno {{count}} leti"
        },
        future: {
            one: "pribli\u017Eno {{count}} leto",
            two: "pribli\u017Eno {{count}} leti",
            few: "pribli\u017Eno {{count}} leta",
            other: "pribli\u017Eno {{count}} let"
        }
    },
    xYears: {
        present: {
            one: '{{count}} leto',
            two: '{{count}} leti',
            few: '{{count}} leta',
            other: '{{count}} let'
        },
        past: {
            one: '{{count}} letom',
            two: '{{count}} letoma',
            few: '{{count}} leti',
            other: '{{count}} leti'
        },
        future: {
            one: '{{count}} leto',
            two: '{{count}} leti',
            few: '{{count}} leta',
            other: '{{count}} let'
        }
    },
    overXYears: {
        present: {
            one: "ve\u010D kot {{count}} leto",
            two: "ve\u010D kot {{count}} leti",
            few: "ve\u010D kot {{count}} leta",
            other: "ve\u010D kot {{count}} let"
        },
        past: {
            one: "ve\u010D kot {{count}} letom",
            two: "ve\u010D kot {{count}} letoma",
            few: "ve\u010D kot {{count}} leti",
            other: "ve\u010D kot {{count}} leti"
        },
        future: {
            one: "ve\u010D kot {{count}} leto",
            two: "ve\u010D kot {{count}} leti",
            few: "ve\u010D kot {{count}} leta",
            other: "ve\u010D kot {{count}} let"
        }
    },
    almostXYears: {
        present: {
            one: 'skoraj {{count}} leto',
            two: 'skoraj {{count}} leti',
            few: 'skoraj {{count}} leta',
            other: 'skoraj {{count}} let'
        },
        past: {
            one: 'skoraj {{count}} letom',
            two: 'skoraj {{count}} letoma',
            few: 'skoraj {{count}} leti',
            other: 'skoraj {{count}} leti'
        },
        future: {
            one: 'skoraj {{count}} leto',
            two: 'skoraj {{count}} leti',
            few: 'skoraj {{count}} leta',
            other: 'skoraj {{count}} let'
        }
    }
};
function getFormFromCount(count) {
    switch(count % 100){
        case 1:
            return 'one';
        case 2:
            return 'two';
        case 3:
        case 4:
            return 'few';
        default:
            return 'other';
    }
}
var formatDistance = function formatDistance(token, count, options) {
    var result = '';
    var tense = 'present';
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
            tense = 'future';
            result = "\u010Dez ";
        } else {
            tense = 'past';
            result = 'pred ';
        }
    }
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result += tokenValue;
    else {
        var form = getFormFromCount(count);
        if (isPluralType(tokenValue)) result += tokenValue[form].replace('{{count}}', String(count));
        else result += tokenValue[tense][form].replace('{{count}}', String(count));
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gaDm2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, dd. MMMM y',
    long: 'dd. MMMM y',
    medium: 'd. MMM y',
    short: 'd. MM. yy'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gI2sg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        var day = date.getUTCDay();
        switch(day){
            case 0:
                return "'prej\u0161njo nedeljo ob' p";
            case 3:
                return "'prej\u0161njo sredo ob' p";
            case 6:
                return "'prej\u0161njo soboto ob' p";
            default:
                return "'prej\u0161nji' EEEE 'ob' p";
        }
    },
    yesterday: "'v\u010Deraj ob' p",
    today: "'danes ob' p",
    tomorrow: "'jutri ob' p",
    nextWeek: function nextWeek(date) {
        var day = date.getUTCDay();
        switch(day){
            case 0:
                return "'naslednjo nedeljo ob' p";
            case 3:
                return "'naslednjo sredo ob' p";
            case 6:
                return "'naslednjo soboto ob' p";
            default:
                return "'naslednji' EEEE 'ob' p";
        }
    },
    other: 'P'
};
var formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"Q2Yjo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "pr. n. \u0161t.",
        "po n. \u0161t."
    ],
    abbreviated: [
        "pr. n. \u0161t.",
        "po n. \u0161t."
    ],
    wide: [
        "pred na\u0161im \u0161tetjem",
        "po na\u0161em \u0161tetju"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1. \u010Det.",
        "2. \u010Det.",
        "3. \u010Det.",
        "4. \u010Det."
    ],
    wide: [
        "1. \u010Detrtletje",
        "2. \u010Detrtletje",
        "3. \u010Detrtletje",
        "4. \u010Detrtletje"
    ]
};
var monthValues = {
    narrow: [
        'j',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mar.',
        'apr.',
        'maj',
        'jun.',
        'jul.',
        'avg.',
        'sep.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        'januar',
        'februar',
        'marec',
        'april',
        'maj',
        'junij',
        'julij',
        'avgust',
        'september',
        'oktober',
        'november',
        'december'
    ]
};
var dayValues = {
    narrow: [
        'n',
        'p',
        't',
        's',
        "\u010D",
        'p',
        's'
    ],
    short: [
        'ned.',
        'pon.',
        'tor.',
        'sre.',
        "\u010Det.",
        'pet.',
        'sob.'
    ],
    abbreviated: [
        'ned.',
        'pon.',
        'tor.',
        'sre.',
        "\u010Det.",
        'pet.',
        'sob.'
    ],
    wide: [
        'nedelja',
        'ponedeljek',
        'torek',
        'sreda',
        "\u010Detrtek",
        'petek',
        'sobota'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'd',
        pm: 'p',
        midnight: '24.00',
        noon: '12.00',
        morning: 'j',
        afternoon: 'p',
        evening: 'v',
        night: 'n'
    },
    abbreviated: {
        am: 'dop.',
        pm: 'pop.',
        midnight: 'poln.',
        noon: 'pold.',
        morning: 'jut.',
        afternoon: 'pop.',
        evening: "ve\u010D.",
        night: "no\u010D"
    },
    wide: {
        am: 'dop.',
        pm: 'pop.',
        midnight: "polno\u010D",
        noon: 'poldne',
        morning: 'jutro',
        afternoon: 'popoldne',
        evening: "ve\u010Der",
        night: "no\u010D"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'd',
        pm: 'p',
        midnight: '24.00',
        noon: '12.00',
        morning: 'zj',
        afternoon: 'p',
        evening: 'zv',
        night: 'po'
    },
    abbreviated: {
        am: 'dop.',
        pm: 'pop.',
        midnight: 'opoln.',
        noon: 'opold.',
        morning: 'zjut.',
        afternoon: 'pop.',
        evening: "zve\u010D.",
        night: "pono\u010Di"
    },
    wide: {
        am: 'dop.',
        pm: 'pop.',
        midnight: "opolno\u010Di",
        noon: 'opoldne',
        morning: 'zjutraj',
        afternoon: 'popoldan',
        evening: "zve\u010Der",
        night: "pono\u010Di"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"eh7wt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)\./i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    abbreviated: /^(pr\. n\. št\.|po n\. št\.)/i,
    wide: /^(pred Kristusom|pred na[sš]im [sš]tetjem|po Kristusu|po na[sš]em [sš]tetju|na[sš]ega [sš]tetja)/i
};
var parseEraPatterns = {
    any: [
        /^pr/i,
        /^(po|na[sš]em)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\.\s?[čc]et\.?/i,
    wide: /^[1234]\. [čc]etrtletje/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan\.|feb\.|mar\.|apr\.|maj|jun\.|jul\.|avg\.|sep\.|okt\.|nov\.|dec\.)/i,
    wide: /^(januar|februar|marec|april|maj|junij|julij|avgust|september|oktober|november|december)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    abbreviated: [
        /^ja/i,
        /^fe/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^av/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    wide: [
        /^ja/i,
        /^fe/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^av/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[nptsčc]/i,
    short: /^(ned\.|pon\.|tor\.|sre\.|[cč]et\.|pet\.|sob\.)/i,
    abbreviated: /^(ned\.|pon\.|tor\.|sre\.|[cč]et\.|pet\.|sob\.)/i,
    wide: /^(nedelja|ponedeljek|torek|sreda|[cč]etrtek|petek|sobota)/i
};
var parseDayPatterns = {
    narrow: [
        /^n/i,
        /^p/i,
        /^t/i,
        /^s/i,
        /^[cč]/i,
        /^p/i,
        /^s/i
    ],
    any: [
        /^n/i,
        /^po/i,
        /^t/i,
        /^sr/i,
        /^[cč]/i,
        /^pe/i,
        /^so/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(d|po?|z?v|n|z?j|24\.00|12\.00)/i,
    any: /^(dop\.|pop\.|o?poln(\.|o[cč]i?)|o?pold(\.|ne)|z?ve[cč](\.|er)|(po)?no[cč]i?|popold(ne|an)|jut(\.|ro)|zjut(\.|raj))/i
};
var parseDayPeriodPatterns = {
    narrow: {
        am: /^d/i,
        pm: /^p/i,
        midnight: /^24/i,
        noon: /^12/i,
        morning: /^(z?j)/i,
        afternoon: /^p/i,
        evening: /^(z?v)/i,
        night: /^(n|po)/i
    },
    any: {
        am: /^dop\./i,
        pm: /^pop\./i,
        midnight: /^o?poln/i,
        noon: /^o?pold/i,
        morning: /j/i,
        afternoon: /^pop\./i,
        evening: /^z?ve/i,
        night: /(po)?no/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1nsvW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Albanian locale.
 * @language Shqip
 * @iso-639-2 sqi
 * @author Ardit Dine [@arditdine]{@link https://github.com/arditdine}
 */ var locale = {
    code: 'sq',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"5GhPy","./_lib/formatLong/index.js":"99O8c","./_lib/formatRelative/index.js":"3haol","./_lib/localize/index.js":"1vvzg","./_lib/match/index.js":"fbjqv","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5GhPy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "m\xeb pak se nj\xeb sekond\xeb",
        other: "m\xeb pak se {{count}} sekonda"
    },
    xSeconds: {
        one: "1 sekond\xeb",
        other: '{{count}} sekonda'
    },
    halfAMinute: "gjys\xebm minuti",
    lessThanXMinutes: {
        one: "m\xeb pak se nj\xeb minute",
        other: "m\xeb pak se {{count}} minuta"
    },
    xMinutes: {
        one: "1 minut\xeb",
        other: '{{count}} minuta'
    },
    aboutXHours: {
        one: "rreth 1 or\xeb",
        other: "rreth {{count}} or\xeb"
    },
    xHours: {
        one: "1 or\xeb",
        other: "{{count}} or\xeb"
    },
    xDays: {
        one: "1 dit\xeb",
        other: "{{count}} dit\xeb"
    },
    aboutXWeeks: {
        one: "rreth 1 jav\xeb",
        other: "rreth {{count}} jav\xeb"
    },
    xWeeks: {
        one: "1 jav\xeb",
        other: "{{count}} jav\xeb"
    },
    aboutXMonths: {
        one: 'rreth 1 muaj',
        other: 'rreth {{count}} muaj'
    },
    xMonths: {
        one: '1 muaj',
        other: '{{count}} muaj'
    },
    aboutXYears: {
        one: 'rreth 1 vit',
        other: 'rreth {{count}} vite'
    },
    xYears: {
        one: '1 vit',
        other: '{{count}} vite'
    },
    overXYears: {
        one: 'mbi 1 vit',
        other: 'mbi {{count}} vite'
    },
    almostXYears: {
        one: 'pothuajse 1 vit',
        other: 'pothuajse {{count}} vite'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "n\xeb " + result;
        else return result + " m\xeb par\xeb";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"99O8c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var dateTimeFormats = {
    full: "{{date}} 'n\xeb' {{time}}",
    long: "{{date}} 'n\xeb' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3haol":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'t\xeb' eeee 'e shkuar n\xeb' p",
    yesterday: "'dje n\xeb' p",
    today: "'sot n\xeb' p",
    tomorrow: "'nes\xebr n\xeb' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1vvzg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'P',
        'M'
    ],
    abbreviated: [
        'PK',
        'MK'
    ],
    wide: [
        'Para Krishtit',
        'Mbas Krishtit'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '4-mujori I',
        '4-mujori II',
        '4-mujori III',
        '4-mujori IV'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
    narrow: [
        'J',
        'S',
        'M',
        'P',
        'M',
        'Q',
        'K',
        'G',
        'S',
        'T',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Shk',
        'Mar',
        'Pri',
        'Maj',
        'Qer',
        'Kor',
        'Gus',
        'Sht',
        'Tet',
        "N\xebn",
        'Dhj'
    ],
    wide: [
        'Janar',
        'Shkurt',
        'Mars',
        'Prill',
        'Maj',
        'Qershor',
        'Korrik',
        'Gusht',
        'Shtator',
        'Tetor',
        "N\xebntor",
        'Dhjetor'
    ]
};
var dayValues = {
    narrow: [
        'D',
        'H',
        'M',
        'M',
        'E',
        'P',
        'S'
    ],
    short: [
        'Di',
        "H\xeb",
        'Ma',
        "M\xeb",
        'En',
        'Pr',
        'Sh'
    ],
    abbreviated: [
        'Die',
        "H\xebn",
        'Mar',
        "M\xebr",
        'Enj',
        'Pre',
        'Sht'
    ],
    wide: [
        "Diel\xeb",
        "H\xebn\xeb",
        "Mart\xeb",
        "M\xebrkur\xeb",
        'Enjte',
        'Premte',
        "Shtun\xeb"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'p',
        pm: 'm',
        midnight: 'm',
        noon: 'd',
        morning: "m\xebngjes",
        afternoon: 'dite',
        evening: "mbr\xebmje",
        night: "nat\xeb"
    },
    abbreviated: {
        am: 'PD',
        pm: 'MD',
        midnight: "mesn\xebt\xeb",
        noon: 'drek',
        morning: "m\xebngjes",
        afternoon: 'mbasdite',
        evening: "mbr\xebmje",
        night: "nat\xeb"
    },
    wide: {
        am: 'p.d.',
        pm: 'm.d.',
        midnight: "mesn\xebt\xeb",
        noon: 'drek',
        morning: "m\xebngjes",
        afternoon: 'mbasdite',
        evening: "mbr\xebmje",
        night: "nat\xeb"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'p',
        pm: 'm',
        midnight: 'm',
        noon: 'd',
        morning: "n\xeb m\xebngjes",
        afternoon: "n\xeb mbasdite",
        evening: "n\xeb mbr\xebmje",
        night: "n\xeb mesnat\xeb"
    },
    abbreviated: {
        am: 'PD',
        pm: 'MD',
        midnight: "mesnat\xeb",
        noon: 'drek',
        morning: "n\xeb m\xebngjes",
        afternoon: "n\xeb mbasdite",
        evening: "n\xeb mbr\xebmje",
        night: "n\xeb mesnat\xeb"
    },
    wide: {
        am: 'p.d.',
        pm: 'm.d.',
        midnight: "mesnat\xeb",
        noon: 'drek',
        morning: "n\xeb m\xebngjes",
        afternoon: "n\xeb mbasdite",
        evening: "n\xeb mbr\xebmje",
        night: "n\xeb mesnat\xeb"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    if ((options === null || options === void 0 ? void 0 : options.unit) === 'hour') return String(number);
    if (number === 1) return number + "-r\xeb";
    if (number === 4) return number + 't';
    return number + "-t\xeb";
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"fbjqv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(-rë|-të|t|)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(p|m)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(para krishtit|mbas krishtit)/i
};
var parseEraPatterns = {
    any: [
        /^b/i,
        /^(p|m)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234]-mujori (i{1,3}|iv)/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jsmpqkftnd]/i,
    abbreviated: /^(jan|shk|mar|pri|maj|qer|kor|gus|sht|tet|nën|dhj)/i,
    wide: /^(janar|shkurt|mars|prill|maj|qershor|korrik|gusht|shtator|tetor|nëntor|dhjetor)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^s/i,
        /^m/i,
        /^p/i,
        /^m/i,
        /^q/i,
        /^k/i,
        /^g/i,
        /^s/i,
        /^t/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^shk/i,
        /^mar/i,
        /^pri/i,
        /^maj/i,
        /^qer/i,
        /^kor/i,
        /^gu/i,
        /^sht/i,
        /^tet/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[dhmeps]/i,
    short: /^(di|hë|ma|më|en|pr|sh)/i,
    abbreviated: /^(die|hën|mar|mër|enj|pre|sht)/i,
    wide: /^(dielë|hënë|martë|mërkurë|enjte|premte|shtunë)/i
};
var parseDayPatterns = {
    narrow: [
        /^d/i,
        /^h/i,
        /^m/i,
        /^m/i,
        /^e/i,
        /^p/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^h/i,
        /^ma/i,
        /^më/i,
        /^e/i,
        /^p/i,
        /^s/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(p|m|me|në (mëngjes|mbasdite|mbrëmje|mesnatë))/i,
    any: /^([pm]\.?\s?d\.?|drek|në (mëngjes|mbasdite|mbrëmje|mesnatë))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^p/i,
        pm: /^m/i,
        midnight: /^me/i,
        noon: /^dr/i,
        morning: /mëngjes/i,
        afternoon: /mbasdite/i,
        evening: /mbrëmje/i,
        night: /natë/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"eRnta":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Serbian cyrillic locale.
 * @language Serbian
 * @iso-639-2 srp
 * @author Igor Radivojević [@rogyvoje]{@link https://github.com/rogyvoje}
 */ var locale = {
    code: 'sr',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"fBYwG","./_lib/formatLong/index.js":"fADwS","./_lib/formatRelative/index.js":"3GhVG","./_lib/localize/index.js":"81HLl","./_lib/match/index.js":"khwl2","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"fBYwG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            standalone: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
            withPrepositionAgo: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
            withPrepositionIn: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u0441\u0435\u043A\u0443\u043D\u0434\u0443"
        },
        dual: "\u043C\u0430\u045A\u0435 \u043E\u0434 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
        other: "\u043C\u0430\u045A\u0435 \u043E\u0434 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
    },
    xSeconds: {
        one: {
            standalone: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            withPrepositionAgo: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
            withPrepositionIn: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0443"
        },
        dual: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
        other: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
    },
    halfAMinute: "\u043F\u043E\u043B\u0430 \u043C\u0438\u043D\u0443\u0442\u0435",
    lessThanXMinutes: {
        one: {
            standalone: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u043C\u0438\u043D\u0443\u0442\u0435",
            withPrepositionAgo: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u043C\u0438\u043D\u0443\u0442\u0435",
            withPrepositionIn: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u043C\u0438\u043D\u0443\u0442\u0443"
        },
        dual: "\u043C\u0430\u045A\u0435 \u043E\u0434 {{count}} \u043C\u0438\u043D\u0443\u0442\u0435",
        other: "\u043C\u0430\u045A\u0435 \u043E\u0434 {{count}} \u043C\u0438\u043D\u0443\u0442\u0430"
    },
    xMinutes: {
        one: {
            standalone: "1 \u043C\u0438\u043D\u0443\u0442\u0430",
            withPrepositionAgo: "1 \u043C\u0438\u043D\u0443\u0442\u0435",
            withPrepositionIn: "1 \u043C\u0438\u043D\u0443\u0442\u0443"
        },
        dual: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0435",
        other: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0430"
    },
    aboutXHours: {
        one: {
            standalone: "\u043E\u043A\u043E 1 \u0441\u0430\u0442",
            withPrepositionAgo: "\u043E\u043A\u043E 1 \u0441\u0430\u0442",
            withPrepositionIn: "\u043E\u043A\u043E 1 \u0441\u0430\u0442"
        },
        dual: "\u043E\u043A\u043E {{count}} \u0441\u0430\u0442\u0430",
        other: "\u043E\u043A\u043E {{count}} \u0441\u0430\u0442\u0438"
    },
    xHours: {
        one: {
            standalone: "1 \u0441\u0430\u0442",
            withPrepositionAgo: "1 \u0441\u0430\u0442",
            withPrepositionIn: "1 \u0441\u0430\u0442"
        },
        dual: "{{count}} \u0441\u0430\u0442\u0430",
        other: "{{count}} \u0441\u0430\u0442\u0438"
    },
    xDays: {
        one: {
            standalone: "1 \u0434\u0430\u043D",
            withPrepositionAgo: "1 \u0434\u0430\u043D",
            withPrepositionIn: "1 \u0434\u0430\u043D"
        },
        dual: "{{count}} \u0434\u0430\u043D\u0430",
        other: "{{count}} \u0434\u0430\u043D\u0430"
    },
    aboutXWeeks: {
        one: {
            standalone: "\u043E\u043A\u043E 1 \u043D\u0435\u0434\u0435\u0459\u0443",
            withPrepositionAgo: "\u043E\u043A\u043E 1 \u043D\u0435\u0434\u0435\u0459\u0443",
            withPrepositionIn: "\u043E\u043A\u043E 1 \u043D\u0435\u0434\u0435\u0459\u0443"
        },
        dual: "\u043E\u043A\u043E {{count}} \u043D\u0435\u0434\u0435\u0459\u0435",
        other: "\u043E\u043A\u043E {{count}} \u043D\u0435\u0434\u0435\u0459\u0435"
    },
    xWeeks: {
        one: {
            standalone: "1 \u043D\u0435\u0434\u0435\u0459\u0443",
            withPrepositionAgo: "1 \u043D\u0435\u0434\u0435\u0459\u0443",
            withPrepositionIn: "1 \u043D\u0435\u0434\u0435\u0459\u0443"
        },
        dual: "{{count}} \u043D\u0435\u0434\u0435\u0459\u0435",
        other: "{{count}} \u043D\u0435\u0434\u0435\u0459\u0435"
    },
    aboutXMonths: {
        one: {
            standalone: "\u043E\u043A\u043E 1 \u043C\u0435\u0441\u0435\u0446",
            withPrepositionAgo: "\u043E\u043A\u043E 1 \u043C\u0435\u0441\u0435\u0446",
            withPrepositionIn: "\u043E\u043A\u043E 1 \u043C\u0435\u0441\u0435\u0446"
        },
        dual: "\u043E\u043A\u043E {{count}} \u043C\u0435\u0441\u0435\u0446\u0430",
        other: "\u043E\u043A\u043E {{count}} \u043C\u0435\u0441\u0435\u0446\u0438"
    },
    xMonths: {
        one: {
            standalone: "1 \u043C\u0435\u0441\u0435\u0446",
            withPrepositionAgo: "1 \u043C\u0435\u0441\u0435\u0446",
            withPrepositionIn: "1 \u043C\u0435\u0441\u0435\u0446"
        },
        dual: "{{count}} \u043C\u0435\u0441\u0435\u0446\u0430",
        other: "{{count}} \u043C\u0435\u0441\u0435\u0446\u0438"
    },
    aboutXYears: {
        one: {
            standalone: "\u043E\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionAgo: "\u043E\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionIn: "\u043E\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443"
        },
        dual: "\u043E\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0435",
        other: "\u043E\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0430"
    },
    xYears: {
        one: {
            standalone: "1 \u0433\u043E\u0434\u0438\u043D\u0430",
            withPrepositionAgo: "1 \u0433\u043E\u0434\u0438\u043D\u0435",
            withPrepositionIn: "1 \u0433\u043E\u0434\u0438\u043D\u0443"
        },
        dual: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0435",
        other: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0430"
    },
    overXYears: {
        one: {
            standalone: "\u043F\u0440\u0435\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionAgo: "\u043F\u0440\u0435\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionIn: "\u043F\u0440\u0435\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443"
        },
        dual: "\u043F\u0440\u0435\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0435",
        other: "\u043F\u0440\u0435\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0430"
    },
    almostXYears: {
        one: {
            standalone: "\u0433\u043E\u0442\u043E\u0432\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionAgo: "\u0433\u043E\u0442\u043E\u0432\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionIn: "\u0433\u043E\u0442\u043E\u0432\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443"
        },
        dual: "\u0433\u043E\u0442\u043E\u0432\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0435",
        other: "\u0433\u043E\u0442\u043E\u0432\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0430"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) {
        if (options !== null && options !== void 0 && options.addSuffix) {
            if (options.comparison && options.comparison > 0) result = tokenValue.one.withPrepositionIn;
            else result = tokenValue.one.withPrepositionAgo;
        } else result = tokenValue.one.standalone;
    } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
    String(count).substr(-2, 1) !== '1' // unless the 2nd to last digit is "1"
    ) result = tokenValue.dual.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0437\u0430 " + result;
        else return "\u043F\u0440\u0435 " + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"fADwS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, d. MMMM yyyy.',
    long: 'd. MMMM yyyy.',
    medium: 'd. MMM yy.',
    short: 'dd. MM. yy.'
};
var timeFormats = {
    full: 'HH:mm:ss (zzzz)',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} '\u0443' {{time}}",
    long: "{{date}} '\u0443' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3GhVG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        var day = date.getUTCDay();
        switch(day){
            case 0:
                return "'\u043F\u0440\u043E\u0448\u043B\u0435 \u043D\u0435\u0434\u0435\u0459\u0435 \u0443' p";
            case 3:
                return "'\u043F\u0440\u043E\u0448\u043B\u0435 \u0441\u0440\u0435\u0434\u0435 \u0443' p";
            case 6:
                return "'\u043F\u0440\u043E\u0448\u043B\u0435 \u0441\u0443\u0431\u043E\u0442\u0435 \u0443' p";
            default:
                return "'\u043F\u0440\u043E\u0448\u043B\u0438' EEEE '\u0443' p";
        }
    },
    yesterday: "'\u0458\u0443\u0447\u0435 \u0443' p",
    today: "'\u0434\u0430\u043D\u0430\u0441 \u0443' p",
    tomorrow: "'\u0441\u0443\u0442\u0440\u0430 \u0443' p",
    nextWeek: function nextWeek(date) {
        var day = date.getUTCDay();
        switch(day){
            case 0:
                return "'\u0441\u043B\u0435\u0434\u0435\u045B\u0435 \u043D\u0435\u0434\u0435\u0459\u0435 \u0443' p";
            case 3:
                return "'\u0441\u043B\u0435\u0434\u0435\u045B\u0443 \u0441\u0440\u0435\u0434\u0443 \u0443' p";
            case 6:
                return "'\u0441\u043B\u0435\u0434\u0435\u045B\u0443 \u0441\u0443\u0431\u043E\u0442\u0443 \u0443' p";
            default:
                return "'\u0441\u043B\u0435\u0434\u0435\u045B\u0438' EEEE '\u0443' p";
        }
    },
    other: 'P'
};
var formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"81HLl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u043F\u0440.\u043D.\u0435.",
        "\u0410\u0414"
    ],
    abbreviated: [
        "\u043F\u0440. \u0425\u0440.",
        "\u043F\u043E. \u0425\u0440."
    ],
    wide: [
        "\u041F\u0440\u0435 \u0425\u0440\u0438\u0441\u0442\u0430",
        "\u041F\u043E\u0441\u043B\u0435 \u0425\u0440\u0438\u0441\u0442\u0430"
    ]
};
var quarterValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.'
    ],
    abbreviated: [
        "1. \u043A\u0432.",
        "2. \u043A\u0432.",
        "3. \u043A\u0432.",
        "4. \u043A\u0432."
    ],
    wide: [
        "1. \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2. \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3. \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4. \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
var monthValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.',
        '5.',
        '6.',
        '7.',
        '8.',
        '9.',
        '10.',
        '11.',
        '12.'
    ],
    abbreviated: [
        "\u0458\u0430\u043D",
        "\u0444\u0435\u0431",
        "\u043C\u0430\u0440",
        "\u0430\u043F\u0440",
        "\u043C\u0430\u0458",
        "\u0458\u0443\u043D",
        "\u0458\u0443\u043B",
        "\u0430\u0432\u0433",
        "\u0441\u0435\u043F",
        "\u043E\u043A\u0442",
        "\u043D\u043E\u0432",
        "\u0434\u0435\u0446"
    ],
    wide: [
        "\u0458\u0430\u043D\u0443\u0430\u0440",
        "\u0444\u0435\u0431\u0440\u0443\u0430\u0440",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0438\u043B",
        "\u043C\u0430\u0458",
        "\u0458\u0443\u043D",
        "\u0458\u0443\u043B",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043F\u0442\u0435\u043C\u0431\u0430\u0440",
        "\u043E\u043A\u0442\u043E\u0431\u0430\u0440",
        "\u043D\u043E\u0432\u0435\u043C\u0431\u0430\u0440",
        "\u0434\u0435\u0446\u0435\u043C\u0431\u0430\u0440"
    ]
};
var formattingMonthValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.',
        '5.',
        '6.',
        '7.',
        '8.',
        '9.',
        '10.',
        '11.',
        '12.'
    ],
    abbreviated: [
        "\u0458\u0430\u043D",
        "\u0444\u0435\u0431",
        "\u043C\u0430\u0440",
        "\u0430\u043F\u0440",
        "\u043C\u0430\u0458",
        "\u0458\u0443\u043D",
        "\u0458\u0443\u043B",
        "\u0430\u0432\u0433",
        "\u0441\u0435\u043F",
        "\u043E\u043A\u0442",
        "\u043D\u043E\u0432",
        "\u0434\u0435\u0446"
    ],
    wide: [
        "\u0458\u0430\u043D\u0443\u0430\u0440",
        "\u0444\u0435\u0431\u0440\u0443\u0430\u0440",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0438\u043B",
        "\u043C\u0430\u0458",
        "\u0458\u0443\u043D",
        "\u0458\u0443\u043B",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043F\u0442\u0435\u043C\u0431\u0430\u0440",
        "\u043E\u043A\u0442\u043E\u0431\u0430\u0440",
        "\u043D\u043E\u0432\u0435\u043C\u0431\u0430\u0440",
        "\u0434\u0435\u0446\u0435\u043C\u0431\u0430\u0440"
    ]
};
var dayValues = {
    narrow: [
        "\u041D",
        "\u041F",
        "\u0423",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u043D\u0435\u0434",
        "\u043F\u043E\u043D",
        "\u0443\u0442\u043E",
        "\u0441\u0440\u0435",
        "\u0447\u0435\u0442",
        "\u043F\u0435\u0442",
        "\u0441\u0443\u0431"
    ],
    abbreviated: [
        "\u043D\u0435\u0434",
        "\u043F\u043E\u043D",
        "\u0443\u0442\u043E",
        "\u0441\u0440\u0435",
        "\u0447\u0435\u0442",
        "\u043F\u0435\u0442",
        "\u0441\u0443\u0431"
    ],
    wide: [
        "\u043D\u0435\u0434\u0435\u0459\u0430",
        "\u043F\u043E\u043D\u0435\u0434\u0435\u0459\u0430\u043A",
        "\u0443\u0442\u043E\u0440\u0430\u043A",
        "\u0441\u0440\u0435\u0434\u0430",
        "\u0447\u0435\u0442\u0432\u0440\u0442\u0430\u043A",
        "\u043F\u0435\u0442\u0430\u043A",
        "\u0441\u0443\u0431\u043E\u0442\u0430"
    ]
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u0410\u041C",
        pm: "\u041F\u041C",
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
    },
    abbreviated: {
        am: "\u0410\u041C",
        pm: "\u041F\u041C",
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u0441\u043B\u0435 \u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
    }
};
var dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u0441\u043B\u0435 \u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide',
        formattingValues: formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"khwl2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)\./i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(пр\.н\.е\.|АД)/i,
    abbreviated: /^(пр\.\s?Хр\.|по\.\s?Хр\.)/i,
    wide: /^(Пре Христа|пре нове ере|После Христа|нова ера)/i
};
var parseEraPatterns = {
    any: [
        /^пр/i,
        /^(по|нова)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\.\s?кв\.?/i,
    wide: /^[1234]\. квартал/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^(10|11|12|[123456789])\./i,
    abbreviated: /^(јан|феб|мар|апр|мај|јун|јул|авг|сеп|окт|нов|дец)/i,
    wide: /^((јануар|јануара)|(фебруар|фебруара)|(март|марта)|(април|априла)|(мја|маја)|(јун|јуна)|(јул|јула)|(август|августа)|(септембар|септембра)|(октобар|октобра)|(новембар|новембра)|(децембар|децембра))/i
};
var parseMonthPatterns = {
    narrow: [
        /^1/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^7/i,
        /^8/i,
        /^9/i,
        /^10/i,
        /^11/i,
        /^12/i
    ],
    any: [
        /^ја/i,
        /^ф/i,
        /^мар/i,
        /^ап/i,
        /^мај/i,
        /^јун/i,
        /^јул/i,
        /^авг/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^д/i
    ]
};
var matchDayPatterns = {
    narrow: /^[пусчн]/i,
    short: /^(нед|пон|уто|сре|чет|пет|суб)/i,
    abbreviated: /^(нед|пон|уто|сре|чет|пет|суб)/i,
    wide: /^(недеља|понедељак|уторак|среда|четвртак|петак|субота)/i
};
var parseDayPatterns = {
    narrow: [
        /^п/i,
        /^у/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i,
        /^н/i
    ],
    any: [
        /^нед/i,
        /^пон/i,
        /^уто/i,
        /^сре/i,
        /^чет/i,
        /^пет/i,
        /^суб/i
    ]
};
var matchDayPeriodPatterns = {
    any: /^(ам|пм|поноћ|(по)?подне|увече|ноћу|после подне|ујутру)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^поно/i,
        noon: /^под/i,
        morning: /ујутру/i,
        afternoon: /(после\s|по)+подне/i,
        evening: /(увече)/i,
        night: /(ноћу)/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"hbaTt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Serbian latin locale.
 * @language Serbian
 * @iso-639-2 srp
 * @author Igor Radivojević [@rogyvoje]{@link https://github.com/rogyvoje}
 */ var locale = {
    code: 'sr-Latn',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"2WolR","./_lib/formatLong/index.js":"ahIey","./_lib/formatRelative/index.js":"6jErV","./_lib/localize/index.js":"lRCFx","./_lib/match/index.js":"jUavF","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2WolR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            standalone: 'manje od 1 sekunde',
            withPrepositionAgo: 'manje od 1 sekunde',
            withPrepositionIn: 'manje od 1 sekundu'
        },
        dual: 'manje od {{count}} sekunde',
        other: 'manje od {{count}} sekundi'
    },
    xSeconds: {
        one: {
            standalone: '1 sekunda',
            withPrepositionAgo: '1 sekunde',
            withPrepositionIn: '1 sekundu'
        },
        dual: '{{count}} sekunde',
        other: '{{count}} sekundi'
    },
    halfAMinute: 'pola minute',
    lessThanXMinutes: {
        one: {
            standalone: 'manje od 1 minute',
            withPrepositionAgo: 'manje od 1 minute',
            withPrepositionIn: 'manje od 1 minutu'
        },
        dual: 'manje od {{count}} minute',
        other: 'manje od {{count}} minuta'
    },
    xMinutes: {
        one: {
            standalone: '1 minuta',
            withPrepositionAgo: '1 minute',
            withPrepositionIn: '1 minutu'
        },
        dual: '{{count}} minute',
        other: '{{count}} minuta'
    },
    aboutXHours: {
        one: {
            standalone: 'oko 1 sat',
            withPrepositionAgo: 'oko 1 sat',
            withPrepositionIn: 'oko 1 sat'
        },
        dual: 'oko {{count}} sata',
        other: 'oko {{count}} sati'
    },
    xHours: {
        one: {
            standalone: '1 sat',
            withPrepositionAgo: '1 sat',
            withPrepositionIn: '1 sat'
        },
        dual: '{{count}} sata',
        other: '{{count}} sati'
    },
    xDays: {
        one: {
            standalone: '1 dan',
            withPrepositionAgo: '1 dan',
            withPrepositionIn: '1 dan'
        },
        dual: '{{count}} dana',
        other: '{{count}} dana'
    },
    aboutXWeeks: {
        one: {
            standalone: 'oko 1 nedelju',
            withPrepositionAgo: 'oko 1 nedelju',
            withPrepositionIn: 'oko 1 nedelju'
        },
        dual: 'oko {{count}} nedelje',
        other: 'oko {{count}} nedelje'
    },
    xWeeks: {
        one: {
            standalone: '1 nedelju',
            withPrepositionAgo: '1 nedelju',
            withPrepositionIn: '1 nedelju'
        },
        dual: '{{count}} nedelje',
        other: '{{count}} nedelje'
    },
    aboutXMonths: {
        one: {
            standalone: 'oko 1 mesec',
            withPrepositionAgo: 'oko 1 mesec',
            withPrepositionIn: 'oko 1 mesec'
        },
        dual: 'oko {{count}} meseca',
        other: 'oko {{count}} meseci'
    },
    xMonths: {
        one: {
            standalone: '1 mesec',
            withPrepositionAgo: '1 mesec',
            withPrepositionIn: '1 mesec'
        },
        dual: '{{count}} meseca',
        other: '{{count}} meseci'
    },
    aboutXYears: {
        one: {
            standalone: 'oko 1 godinu',
            withPrepositionAgo: 'oko 1 godinu',
            withPrepositionIn: 'oko 1 godinu'
        },
        dual: 'oko {{count}} godine',
        other: 'oko {{count}} godina'
    },
    xYears: {
        one: {
            standalone: '1 godina',
            withPrepositionAgo: '1 godine',
            withPrepositionIn: '1 godinu'
        },
        dual: '{{count}} godine',
        other: '{{count}} godina'
    },
    overXYears: {
        one: {
            standalone: 'preko 1 godinu',
            withPrepositionAgo: 'preko 1 godinu',
            withPrepositionIn: 'preko 1 godinu'
        },
        dual: 'preko {{count}} godine',
        other: 'preko {{count}} godina'
    },
    almostXYears: {
        one: {
            standalone: 'gotovo 1 godinu',
            withPrepositionAgo: 'gotovo 1 godinu',
            withPrepositionIn: 'gotovo 1 godinu'
        },
        dual: 'gotovo {{count}} godine',
        other: 'gotovo {{count}} godina'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) {
        if (options !== null && options !== void 0 && options.addSuffix) {
            if (options.comparison && options.comparison > 0) result = tokenValue.one.withPrepositionIn;
            else result = tokenValue.one.withPrepositionAgo;
        } else result = tokenValue.one.standalone;
    } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
    String(count).substr(-2, 1) !== '1' // unless the 2nd to last digit is "1"
    ) result = tokenValue.dual.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'za ' + result;
        else return 'pre ' + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"ahIey":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, d. MMMM yyyy.',
    long: 'd. MMMM yyyy.',
    medium: 'd. MMM yy.',
    short: 'dd. MM. yy.'
};
var timeFormats = {
    full: 'HH:mm:ss (zzzz)',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'u' {{time}}",
    long: "{{date}} 'u' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6jErV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        switch(date.getUTCDay()){
            case 0:
                return "'pro\u0161le nedelje u' p";
            case 3:
                return "'pro\u0161le srede u' p";
            case 6:
                return "'pro\u0161le subote u' p";
            default:
                return "'pro\u0161li' EEEE 'u' p";
        }
    },
    yesterday: "'ju\u010De u' p",
    today: "'danas u' p",
    tomorrow: "'sutra u' p",
    nextWeek: function nextWeek(date) {
        switch(date.getUTCDay()){
            case 0:
                return "'slede\u0107e nedelje u' p";
            case 3:
                return "'slede\u0107u sredu u' p";
            case 6:
                return "'slede\u0107u subotu u' p";
            default:
                return "'slede\u0107i' EEEE 'u' p";
        }
    },
    other: 'P'
};
var formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"lRCFx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'pr.n.e.',
        'AD'
    ],
    abbreviated: [
        'pr. Hr.',
        'po. Hr.'
    ],
    wide: [
        'Pre Hrista',
        'Posle Hrista'
    ]
};
var quarterValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.'
    ],
    abbreviated: [
        '1. kv.',
        '2. kv.',
        '3. kv.',
        '4. kv.'
    ],
    wide: [
        '1. kvartal',
        '2. kvartal',
        '3. kvartal',
        '4. kvartal'
    ]
};
var monthValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.',
        '5.',
        '6.',
        '7.',
        '8.',
        '9.',
        '10.',
        '11.',
        '12.'
    ],
    abbreviated: [
        'jan',
        'feb',
        'mar',
        'apr',
        'maj',
        'jun',
        'jul',
        'avg',
        'sep',
        'okt',
        'nov',
        'dec'
    ],
    wide: [
        'januar',
        'februar',
        'mart',
        'april',
        'maj',
        'jun',
        'jul',
        'avgust',
        'septembar',
        'oktobar',
        'novembar',
        'decembar'
    ]
};
var formattingMonthValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.',
        '5.',
        '6.',
        '7.',
        '8.',
        '9.',
        '10.',
        '11.',
        '12.'
    ],
    abbreviated: [
        'jan',
        'feb',
        'mar',
        'apr',
        'maj',
        'jun',
        'jul',
        'avg',
        'sep',
        'okt',
        'nov',
        'dec'
    ],
    wide: [
        'januar',
        'februar',
        'mart',
        'april',
        'maj',
        'jun',
        'jul',
        'avgust',
        'septembar',
        'oktobar',
        'novembar',
        'decembar'
    ]
};
var dayValues = {
    narrow: [
        'N',
        'P',
        'U',
        'S',
        "\u010C",
        'P',
        'S'
    ],
    short: [
        'ned',
        'pon',
        'uto',
        'sre',
        "\u010Det",
        'pet',
        'sub'
    ],
    abbreviated: [
        'ned',
        'pon',
        'uto',
        'sre',
        "\u010Det",
        'pet',
        'sub'
    ],
    wide: [
        'nedelja',
        'ponedeljak',
        'utorak',
        'sreda',
        "\u010Detvrtak",
        'petak',
        'subota'
    ]
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'popodne',
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'popodne',
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'posle podne',
        evening: "uve\u010De",
        night: "no\u0107u"
    }
};
var dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'popodne',
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'popodne',
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "pono\u0107",
        noon: 'podne',
        morning: 'ujutru',
        afternoon: 'posle podne',
        evening: "uve\u010De",
        night: "no\u0107u"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide',
        formattingValues: formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jUavF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)\./i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(pr\.n\.e\.|AD)/i,
    abbreviated: /^(pr\.\s?Hr\.|po\.\s?Hr\.)/i,
    wide: /^(Pre Hrista|pre nove ere|Posle Hrista|nova era)/i
};
var parseEraPatterns = {
    any: [
        /^pr/i,
        /^(po|nova)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\.\s?kv\.?/i,
    wide: /^[1234]\. kvartal/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^(10|11|12|[123456789])\./i,
    abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|avg|sep|okt|nov|dec)/i,
    wide: /^((januar|januara)|(februar|februara)|(mart|marta)|(april|aprila)|(maj|maja)|(jun|juna)|(jul|jula)|(avgust|avgusta)|(septembar|septembra)|(oktobar|oktobra)|(novembar|novembra)|(decembar|decembra))/i
};
var parseMonthPatterns = {
    narrow: [
        /^1/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^7/i,
        /^8/i,
        /^9/i,
        /^10/i,
        /^11/i,
        /^12/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^avg/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[npusčc]/i,
    short: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
    abbreviated: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
    wide: /^(nedelja|ponedeljak|utorak|sreda|(četvrtak|cetvrtak)|petak|subota)/i
};
var parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var matchDayPeriodPatterns = {
    any: /^(am|pm|ponoc|ponoć|(po)?podne|uvece|uveče|noću|posle podne|ujutru)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^pono/i,
        noon: /^pod/i,
        morning: /jutro/i,
        afternoon: /(posle\s|po)+podne/i,
        evening: /(uvece|uveče)/i,
        night: /(nocu|noću)/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1LpUy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Swedish locale.
 * @language Swedish
 * @iso-639-2 swe
 * @author Johannes Ulén [@ejulen]{@link https://github.com/ejulen}
 * @author Alexander Nanberg [@alexandernanberg]{@link https://github.com/alexandernanberg}
 * @author Henrik Andersson [@limelights]{@link https://github.com/limelights}
 */ var locale = {
    code: 'sv',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"gbg7L","./_lib/formatLong/index.js":"b3OmL","./_lib/formatRelative/index.js":"1xA2l","./_lib/localize/index.js":"gwXuW","./_lib/match/index.js":"5oGir","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gbg7L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mindre \xe4n en sekund",
        other: "mindre \xe4n {{count}} sekunder"
    },
    xSeconds: {
        one: 'en sekund',
        other: '{{count}} sekunder'
    },
    halfAMinute: 'en halv minut',
    lessThanXMinutes: {
        one: "mindre \xe4n en minut",
        other: "mindre \xe4n {{count}} minuter"
    },
    xMinutes: {
        one: 'en minut',
        other: '{{count}} minuter'
    },
    aboutXHours: {
        one: "ungef\xe4r en timme",
        other: "ungef\xe4r {{count}} timmar"
    },
    xHours: {
        one: 'en timme',
        other: '{{count}} timmar'
    },
    xDays: {
        one: 'en dag',
        other: '{{count}} dagar'
    },
    aboutXWeeks: {
        one: "ungef\xe4r en vecka",
        other: "ungef\xe4r {{count}} vecka"
    },
    xWeeks: {
        one: 'en vecka',
        other: '{{count}} vecka'
    },
    aboutXMonths: {
        one: "ungef\xe4r en m\xe5nad",
        other: "ungef\xe4r {{count}} m\xe5nader"
    },
    xMonths: {
        one: "en m\xe5nad",
        other: "{{count}} m\xe5nader"
    },
    aboutXYears: {
        one: "ungef\xe4r ett \xe5r",
        other: "ungef\xe4r {{count}} \xe5r"
    },
    xYears: {
        one: "ett \xe5r",
        other: "{{count}} \xe5r"
    },
    overXYears: {
        one: "\xf6ver ett \xe5r",
        other: "\xf6ver {{count}} \xe5r"
    },
    almostXYears: {
        one: "n\xe4stan ett \xe5r",
        other: "n\xe4stan {{count}} \xe5r"
    }
};
var wordMapping = [
    'noll',
    'en',
    "tv\xe5",
    'tre',
    'fyra',
    'fem',
    'sex',
    'sju',
    "\xe5tta",
    'nio',
    'tio',
    'elva',
    'tolv'
];
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (options && options.onlyNumeric) result = tokenValue.other.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', count < 13 ? wordMapping[count] : String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'om ' + result;
        else return result + ' sedan';
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"b3OmL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'y-MM-dd'
};
var timeFormats = {
    full: "'kl'. HH:mm:ss zzzz",
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1xA2l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'i' EEEE's kl.' p",
    yesterday: "'ig\xe5r kl.' p",
    today: "'idag kl.' p",
    tomorrow: "'imorgon kl.' p",
    nextWeek: "EEEE 'kl.' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gwXuW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'f.Kr.',
        'e.Kr.'
    ],
    abbreviated: [
        'f.Kr.',
        'e.Kr.'
    ],
    wide: [
        "f\xf6re Kristus",
        'efter Kristus'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1:a kvartalet',
        '2:a kvartalet',
        '3:e kvartalet',
        '4:e kvartalet'
    ]
};
var monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mars',
        'apr.',
        'maj',
        'juni',
        'juli',
        'aug.',
        'sep.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        'januari',
        'februari',
        'mars',
        'april',
        'maj',
        'juni',
        'juli',
        'augusti',
        'september',
        'oktober',
        'november',
        'december'
    ]
};
var dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'O',
        'T',
        'F',
        'L'
    ],
    short: [
        "s\xf6",
        "m\xe5",
        'ti',
        'on',
        'to',
        'fr',
        "l\xf6"
    ],
    abbreviated: [
        "s\xf6n",
        "m\xe5n",
        'tis',
        'ons',
        'tors',
        'fre',
        "l\xf6r"
    ],
    wide: [
        "s\xf6ndag",
        "m\xe5ndag",
        'tisdag',
        'onsdag',
        'torsdag',
        'fredag',
        "l\xf6rdag"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sv.html#1888
var dayPeriodValues = {
    narrow: {
        am: 'fm',
        pm: 'em',
        midnight: 'midnatt',
        noon: 'middag',
        morning: 'morg.',
        afternoon: 'efterm.',
        evening: "kv\xe4ll",
        night: 'natt'
    },
    abbreviated: {
        am: 'f.m.',
        pm: 'e.m.',
        midnight: 'midnatt',
        noon: 'middag',
        morning: 'morgon',
        afternoon: 'efterm.',
        evening: "kv\xe4ll",
        night: 'natt'
    },
    wide: {
        am: "f\xf6rmiddag",
        pm: 'eftermiddag',
        midnight: 'midnatt',
        noon: 'middag',
        morning: 'morgon',
        afternoon: 'eftermiddag',
        evening: "kv\xe4ll",
        night: 'natt'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'fm',
        pm: 'em',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 efterm.",
        evening: "p\xe5 kv\xe4llen",
        night: "p\xe5 natten"
    },
    abbreviated: {
        am: 'fm',
        pm: 'em',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 efterm.",
        evening: "p\xe5 kv\xe4llen",
        night: "p\xe5 natten"
    },
    wide: {
        am: 'fm',
        pm: 'em',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morgonen",
        afternoon: "p\xe5 eftermiddagen",
        evening: "p\xe5 kv\xe4llen",
        night: "p\xe5 natten"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
        case 2:
            return number + ':a';
    }
    return number + ':e';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5oGir":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(:a|:e)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
    abbreviated: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
    wide: /^(före Kristus|före vår tid|efter Kristus|vår tid)/i
};
var parseEraPatterns = {
    any: [
        /^f/i,
        /^[ev]/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](:a|:e)? kvartalet/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar[s]?|apr|maj|jun[i]?|jul[i]?|aug|sep|okt|nov|dec)\.?/i,
    wide: /^(januari|februari|mars|april|maj|juni|juli|augusti|september|oktober|november|december)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[smtofl]/i,
    short: /^(sö|må|ti|on|to|fr|lö)/i,
    abbreviated: /^(sön|mån|tis|ons|tors|fre|lör)/i,
    wide: /^(söndag|måndag|tisdag|onsdag|torsdag|fredag|lördag)/i
};
var parseDayPatterns = {
    any: [
        /^s/i,
        /^m/i,
        /^ti/i,
        /^o/i,
        /^to/i,
        /^f/i,
        /^l/i
    ]
};
var matchDayPeriodPatterns = {
    any: /^([fe]\.?\s?m\.?|midn(att)?|midd(ag)?|(på) (morgonen|eftermiddagen|kvällen|natten))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^f/i,
        pm: /^e/i,
        midnight: /^midn/i,
        noon: /^midd/i,
        morning: /morgon/i,
        afternoon: /eftermiddag/i,
        evening: /kväll/i,
        night: /natt/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gZbkW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Tamil locale (India).
 * @language Tamil
 * @iso-639-2 tam
 * @author Sibiraj [@sibiraj-s]{@link https://github.com/sibiraj-s}
 */ var locale = {
    code: 'ta',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"8czgP","./_lib/formatLong/index.js":"a90vf","./_lib/formatRelative/index.js":"kuPeo","./_lib/localize/index.js":"5E8PZ","./_lib/match/index.js":"11tkU","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8czgP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function isPluralType(val) {
    return val.one !== undefined;
}
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            default: "\u0B92\u0BB0\u0BC1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BCD\u0B95\u0BC1 \u0B95\u0BC1\u0BB1\u0BC8\u0BB5\u0BBE\u0B95",
            in: "\u0B92\u0BB0\u0BC1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BCD\u0B95\u0BC1\u0BB3\u0BCD",
            ago: "\u0B92\u0BB0\u0BC1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0B95\u0BC1\u0BB1\u0BC8\u0BB5\u0BBE\u0B95",
            in: "{{count}} \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1\u0BB3\u0BCD",
            ago: "{{count}} \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    xSeconds: {
        one: {
            default: "1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF",
            in: "1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0BAF\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BB5\u0BBF\u0BA8\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BB5\u0BBF\u0BA8\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    halfAMinute: {
        default: "\u0B85\u0BB0\u0BC8 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BAE\u0BCD",
        in: "\u0B85\u0BB0\u0BC8 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
        ago: "\u0B85\u0BB0\u0BC8 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
    },
    lessThanXMinutes: {
        one: {
            default: "\u0B92\u0BB0\u0BC1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1\u0BAE\u0BCD \u0B95\u0BC1\u0BB1\u0BC8\u0BB5\u0BBE\u0B95",
            in: "\u0B92\u0BB0\u0BC1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1\u0BB3\u0BCD",
            ago: "\u0B92\u0BB0\u0BC1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1\u0BAE\u0BCD \u0B95\u0BC1\u0BB1\u0BC8\u0BB5\u0BBE\u0B95",
            in: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1\u0BB3\u0BCD",
            ago: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    xMinutes: {
        one: {
            default: "1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BAE\u0BCD",
            in: "1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    aboutXHours: {
        one: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD"
        }
    },
    xHours: {
        one: {
            default: "1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
            in: "1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
            in: "{{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    xDays: {
        one: {
            default: "1 \u0BA8\u0BBE\u0BB3\u0BCD",
            in: "1 \u0BA8\u0BBE\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BA8\u0BBE\u0BB3\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BA8\u0BBE\u0B9F\u0BCD\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0BA8\u0BBE\u0B9F\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BA8\u0BBE\u0B9F\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    aboutXWeeks: {
        one: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BBE\u0BB0\u0BAE\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BBE\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BBE\u0BB0\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    xWeeks: {
        one: {
            default: "1 \u0BB5\u0BBE\u0BB0\u0BAE\u0BCD",
            in: "1 \u0BB5\u0BBE\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BB5\u0BBE\u0BB0\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    aboutXMonths: {
        one: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BBE\u0BA4\u0BAE\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BBE\u0BA4\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BBE\u0BA4\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    xMonths: {
        one: {
            default: "1 \u0BAE\u0BBE\u0BA4\u0BAE\u0BCD",
            in: "1 \u0BAE\u0BBE\u0BA4\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BAE\u0BBE\u0BA4\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    aboutXYears: {
        one: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0B86\u0BA3\u0BCD\u0B9F\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    xYears: {
        one: {
            default: "1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD",
            in: "1 \u0B86\u0BA3\u0BCD\u0B9F\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    overXYears: {
        one: {
            default: "1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC7\u0BB2\u0BCD",
            in: "1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1\u0BAE\u0BCD \u0BAE\u0BC7\u0BB2\u0BBE\u0B95",
            ago: "1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1\u0BAE\u0BCD \u0BAE\u0BC7\u0BB2\u0BBE\u0B95",
            in: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    almostXYears: {
        one: {
            default: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F 1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD",
            in: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F 1 \u0B86\u0BA3\u0BCD\u0B9F\u0BBF\u0BB2\u0BCD",
            ago: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F 1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BCD",
            in: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var tense = options !== null && options !== void 0 && options.addSuffix ? options.comparison && options.comparison > 0 ? 'in' : 'ago' : 'default';
    var tokenValue = formatDistanceLocale[token];
    if (!isPluralType(tokenValue)) return tokenValue[tense];
    if (count === 1) return tokenValue.one[tense];
    else return tokenValue.other[tense].replace('{{count}}', String(count));
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"a90vf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js"); // Ref: https://www.unicode.org/cldr/charts/32/summary/ta.html
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
// CLDR #1846 - #1849
var dateFormats = {
    full: 'EEEE, d MMMM, y',
    long: 'd MMMM, y',
    medium: 'd MMM, y',
    short: 'd/M/yy'
};
// CLDR #1850 - #1853
var timeFormats = {
    full: 'a h:mm:ss zzzz',
    long: 'a h:mm:ss z',
    medium: 'a h:mm:ss',
    short: 'a h:mm'
};
var dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"kuPeo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'\u0B95\u0B9F\u0BA8\u0BCD\u0BA4' eeee p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
    yesterday: "'\u0BA8\u0BC7\u0BB1\u0BCD\u0BB1\u0BC1 ' p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
    today: "'\u0B87\u0BA9\u0BCD\u0BB1\u0BC1 ' p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
    tomorrow: "'\u0BA8\u0BBE\u0BB3\u0BC8 ' p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
    nextWeek: "eeee p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5E8PZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js"); // Ref: https://www.unicode.org/cldr/charts/32/summary/ta.html
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u0B95\u0BBF.\u0BAE\u0BC1.",
        "\u0B95\u0BBF.\u0BAA\u0BBF."
    ],
    abbreviated: [
        "\u0B95\u0BBF.\u0BAE\u0BC1.",
        "\u0B95\u0BBF.\u0BAA\u0BBF."
    ],
    // CLDR #1624, #1626
    wide: [
        "\u0B95\u0BBF\u0BB1\u0BBF\u0BB8\u0BCD\u0BA4\u0BC1\u0BB5\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD",
        "\u0B85\u0BA9\u0BCD\u0BA9\u0BCB \u0B9F\u0BCB\u0BAE\u0BBF\u0BA9\u0BBF"
    ] // CLDR #1620, #1622
};
var quarterValues = {
    // CLDR #1644 - #1647
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    // CLDR #1636 - #1639
    abbreviated: [
        "\u0B95\u0BBE\u0BB2\u0BBE.1",
        "\u0B95\u0BBE\u0BB2\u0BBE.2",
        "\u0B95\u0BBE\u0BB2\u0BBE.3",
        "\u0B95\u0BBE\u0BB2\u0BBE.4"
    ],
    // CLDR #1628 - #1631
    wide: [
        "\u0B92\u0BA9\u0BCD\u0BB1\u0BBE\u0BAE\u0BCD \u0B95\u0BBE\u0BB2\u0BBE\u0BA3\u0BCD\u0B9F\u0BC1",
        "\u0B87\u0BB0\u0BA3\u0BCD\u0B9F\u0BBE\u0BAE\u0BCD \u0B95\u0BBE\u0BB2\u0BBE\u0BA3\u0BCD\u0B9F\u0BC1",
        "\u0BAE\u0BC2\u0BA9\u0BCD\u0BB1\u0BBE\u0BAE\u0BCD \u0B95\u0BBE\u0BB2\u0BBE\u0BA3\u0BCD\u0B9F\u0BC1",
        "\u0BA8\u0BBE\u0BA9\u0BCD\u0B95\u0BBE\u0BAE\u0BCD \u0B95\u0BBE\u0BB2\u0BBE\u0BA3\u0BCD\u0B9F\u0BC1"
    ]
};
var monthValues = {
    // CLDR #700 - #711
    narrow: [
        "\u0B9C",
        "\u0BAA\u0BBF",
        "\u0BAE\u0BBE",
        "\u0B8F",
        "\u0BAE\u0BC7",
        "\u0B9C\u0BC2",
        "\u0B9C\u0BC2",
        "\u0B86",
        "\u0B9A\u0BC6",
        "\u0B85",
        "\u0BA8",
        "\u0B9F\u0BBF"
    ],
    // CLDR #1676 - #1687
    abbreviated: [
        "\u0B9C\u0BA9.",
        "\u0BAA\u0BBF\u0BAA\u0BCD.",
        "\u0BAE\u0BBE\u0BB0\u0BCD.",
        "\u0B8F\u0BAA\u0BCD.",
        "\u0BAE\u0BC7",
        "\u0B9C\u0BC2\u0BA9\u0BCD",
        "\u0B9C\u0BC2\u0BB2\u0BC8",
        "\u0B86\u0B95.",
        "\u0B9A\u0BC6\u0BAA\u0BCD.",
        "\u0B85\u0B95\u0BCD.",
        "\u0BA8\u0BB5.",
        "\u0B9F\u0BBF\u0B9A."
    ],
    // CLDR #1652 - #1663
    wide: [
        "\u0B9C\u0BA9\u0BB5\u0BB0\u0BBF",
        // January
        "\u0BAA\u0BBF\u0BAA\u0BCD\u0BB0\u0BB5\u0BB0\u0BBF",
        // February
        "\u0BAE\u0BBE\u0BB0\u0BCD\u0B9A\u0BCD",
        // March
        "\u0B8F\u0BAA\u0BCD\u0BB0\u0BB2\u0BCD",
        // April
        "\u0BAE\u0BC7",
        // May
        "\u0B9C\u0BC2\u0BA9\u0BCD",
        // June
        "\u0B9C\u0BC2\u0BB2\u0BC8",
        // July
        "\u0B86\u0B95\u0BB8\u0BCD\u0B9F\u0BCD",
        // August
        "\u0B9A\u0BC6\u0BAA\u0BCD\u0B9F\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD",
        // September
        "\u0B85\u0B95\u0BCD\u0B9F\u0BCB\u0BAA\u0BB0\u0BCD",
        // October
        "\u0BA8\u0BB5\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD",
        // November
        "\u0B9F\u0BBF\u0B9A\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD" // December
    ]
};
var dayValues = {
    // CLDR #1766 - #1772
    narrow: [
        "\u0B9E\u0BBE",
        "\u0BA4\u0BBF",
        "\u0B9A\u0BC6",
        "\u0BAA\u0BC1",
        "\u0BB5\u0BBF",
        "\u0BB5\u0BC6",
        "\u0B9A"
    ],
    // CLDR #1752 - #1758
    short: [
        "\u0B9E\u0BBE",
        "\u0BA4\u0BBF",
        "\u0B9A\u0BC6",
        "\u0BAA\u0BC1",
        "\u0BB5\u0BBF",
        "\u0BB5\u0BC6",
        "\u0B9A"
    ],
    // CLDR #1738 - #1744
    abbreviated: [
        "\u0B9E\u0BBE\u0BAF\u0BBF.",
        "\u0BA4\u0BBF\u0B99\u0BCD.",
        "\u0B9A\u0BC6\u0BB5\u0BCD.",
        "\u0BAA\u0BC1\u0BA4.",
        "\u0BB5\u0BBF\u0BAF\u0BBE.",
        "\u0BB5\u0BC6\u0BB3\u0BCD.",
        "\u0B9A\u0BA9\u0BBF"
    ],
    // CLDR #1724 - #1730
    wide: [
        "\u0B9E\u0BBE\u0BAF\u0BBF\u0BB1\u0BC1",
        // Sunday
        "\u0BA4\u0BBF\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
        // Monday
        "\u0B9A\u0BC6\u0BB5\u0BCD\u0BB5\u0BBE\u0BAF\u0BCD",
        // Tuesday
        "\u0BAA\u0BC1\u0BA4\u0BA9\u0BCD",
        // Wednesday
        "\u0BB5\u0BBF\u0BAF\u0BBE\u0BB4\u0BA9\u0BCD",
        // Thursday
        "\u0BB5\u0BC6\u0BB3\u0BCD\u0BB3\u0BBF",
        // Friday
        "\u0B9A\u0BA9\u0BBF" // Saturday
    ]
};
// CLDR #1780 - #1845
var dayPeriodValues = {
    narrow: {
        am: "\u0BAE\u0BC1.\u0BAA",
        pm: "\u0BAA\u0BBF.\u0BAA",
        midnight: "\u0BA8\u0BB3\u0BCD.",
        noon: "\u0BA8\u0BA3\u0BCD.",
        morning: "\u0B95\u0BBE.",
        afternoon: "\u0BAE\u0BA4\u0BBF.",
        evening: "\u0BAE\u0BBE.",
        night: "\u0B87\u0BB0."
    },
    abbreviated: {
        am: "\u0BAE\u0BC1\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        pm: "\u0BAA\u0BBF\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        midnight: "\u0BA8\u0BB3\u0BCD\u0BB3\u0BBF\u0BB0\u0BB5\u0BC1",
        noon: "\u0BA8\u0BA3\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        morning: "\u0B95\u0BBE\u0BB2\u0BC8",
        afternoon: "\u0BAE\u0BA4\u0BBF\u0BAF\u0BAE\u0BCD",
        evening: "\u0BAE\u0BBE\u0BB2\u0BC8",
        night: "\u0B87\u0BB0\u0BB5\u0BC1"
    },
    wide: {
        am: "\u0BAE\u0BC1\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        pm: "\u0BAA\u0BBF\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        midnight: "\u0BA8\u0BB3\u0BCD\u0BB3\u0BBF\u0BB0\u0BB5\u0BC1",
        noon: "\u0BA8\u0BA3\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        morning: "\u0B95\u0BBE\u0BB2\u0BC8",
        afternoon: "\u0BAE\u0BA4\u0BBF\u0BAF\u0BAE\u0BCD",
        evening: "\u0BAE\u0BBE\u0BB2\u0BC8",
        night: "\u0B87\u0BB0\u0BB5\u0BC1"
    }
};
// CLDR #1780 - #1845
var formattingDayPeriodValues = {
    narrow: {
        am: "\u0BAE\u0BC1.\u0BAA",
        pm: "\u0BAA\u0BBF.\u0BAA",
        midnight: "\u0BA8\u0BB3\u0BCD.",
        noon: "\u0BA8\u0BA3\u0BCD.",
        morning: "\u0B95\u0BBE.",
        afternoon: "\u0BAE\u0BA4\u0BBF.",
        evening: "\u0BAE\u0BBE.",
        night: "\u0B87\u0BB0."
    },
    abbreviated: {
        am: "\u0BAE\u0BC1\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        pm: "\u0BAA\u0BBF\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        midnight: "\u0BA8\u0BB3\u0BCD\u0BB3\u0BBF\u0BB0\u0BB5\u0BC1",
        noon: "\u0BA8\u0BA3\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        morning: "\u0B95\u0BBE\u0BB2\u0BC8",
        afternoon: "\u0BAE\u0BA4\u0BBF\u0BAF\u0BAE\u0BCD",
        evening: "\u0BAE\u0BBE\u0BB2\u0BC8",
        night: "\u0B87\u0BB0\u0BB5\u0BC1"
    },
    wide: {
        am: "\u0BAE\u0BC1\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        pm: "\u0BAA\u0BBF\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        midnight: "\u0BA8\u0BB3\u0BCD\u0BB3\u0BBF\u0BB0\u0BB5\u0BC1",
        noon: "\u0BA8\u0BA3\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        morning: "\u0B95\u0BBE\u0BB2\u0BC8",
        afternoon: "\u0BAE\u0BA4\u0BBF\u0BAF\u0BAE\u0BCD",
        evening: "\u0BAE\u0BBE\u0BB2\u0BC8",
        night: "\u0B87\u0BB0\u0BB5\u0BC1"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"11tkU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(வது)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(கி.மு.|கி.பி.)/i,
    abbreviated: /^(கி\.?\s?மு\.?|கி\.?\s?பி\.?)/,
    wide: /^(கிறிஸ்துவுக்கு\sமுன்|அன்னோ\sடோமினி)/i
};
var parseEraPatterns = {
    any: [
        /கி\.?\s?மு\.?/,
        /கி\.?\s?பி\.?/
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^காலா.[1234]/i,
    wide: /^(ஒன்றாம்|இரண்டாம்|மூன்றாம்|நான்காம்) காலாண்டு/i
};
var parseQuarterPatterns = {
    narrow: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ],
    any: [
        /(1|காலா.1|ஒன்றாம்)/i,
        /(2|காலா.2|இரண்டாம்)/i,
        /(3|காலா.3|மூன்றாம்)/i,
        /(4|காலா.4|நான்காம்)/i
    ]
};
var matchMonthPatterns = {
    narrow: /^(ஜ|பி|மா|ஏ|மே|ஜூ|ஆ|செ|அ|ந|டி)$/i,
    abbreviated: /^(ஜன.|பிப்.|மார்.|ஏப்.|மே|ஜூன்|ஜூலை|ஆக.|செப்.|அக்.|நவ.|டிச.)/i,
    wide: /^(ஜனவரி|பிப்ரவரி|மார்ச்|ஏப்ரல்|மே|ஜூன்|ஜூலை|ஆகஸ்ட்|செப்டம்பர்|அக்டோபர்|நவம்பர்|டிசம்பர்)/i
};
var parseMonthPatterns = {
    narrow: [
        /^ஜ$/i,
        /^பி/i,
        /^மா/i,
        /^ஏ/i,
        /^மே/i,
        /^ஜூ/i,
        /^ஜூ/i,
        /^ஆ/i,
        /^செ/i,
        /^அ/i,
        /^ந/i,
        /^டி/i
    ],
    any: [
        /^ஜன/i,
        /^பி/i,
        /^மா/i,
        /^ஏ/i,
        /^மே/i,
        /^ஜூன்/i,
        /^ஜூலை/i,
        /^ஆ/i,
        /^செ/i,
        /^அ/i,
        /^ந/i,
        /^டி/i
    ]
};
var matchDayPatterns = {
    narrow: /^(ஞா|தி|செ|பு|வி|வெ|ச)/i,
    short: /^(ஞா|தி|செ|பு|வி|வெ|ச)/i,
    abbreviated: /^(ஞாயி.|திங்.|செவ்.|புத.|வியா.|வெள்.|சனி)/i,
    wide: /^(ஞாயிறு|திங்கள்|செவ்வாய்|புதன்|வியாழன்|வெள்ளி|சனி)/i
};
var parseDayPatterns = {
    narrow: [
        /^ஞா/i,
        /^தி/i,
        /^செ/i,
        /^பு/i,
        /^வி/i,
        /^வெ/i,
        /^ச/i
    ],
    any: [
        /^ஞா/i,
        /^தி/i,
        /^செ/i,
        /^பு/i,
        /^வி/i,
        /^வெ/i,
        /^ச/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(மு.ப|பி.ப|நள்|நண்|காலை|மதியம்|மாலை|இரவு)/i,
    any: /^(மு.ப|பி.ப|முற்பகல்|பிற்பகல்|நள்ளிரவு|நண்பகல்|காலை|மதியம்|மாலை|இரவு)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^மு/i,
        pm: /^பி/i,
        midnight: /^நள்/i,
        noon: /^நண்/i,
        morning: /காலை/i,
        afternoon: /மதியம்/i,
        evening: /மாலை/i,
        night: /இரவு/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"cOMeh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Telugu locale
 * @language Telugu
 * @iso-639-2 tel
 * @author Kranthi Lakum [@kranthilakum]{@link https://github.com/kranthilakum}
 */ var locale = {
    code: 'te',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"dePiI","./_lib/formatLong/index.js":"kZzXd","./_lib/formatRelative/index.js":"8GEgO","./_lib/localize/index.js":"cAKQD","./_lib/match/index.js":"2zeEj","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"dePiI":[function(require,module,exports,__globalThis) {
// Source: https://www.unicode.org/cldr/charts/32/summary/te.html
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        standalone: {
            one: "\u0C38\u0C46\u0C15\u0C28\u0C41 \u0C15\u0C28\u0C4D\u0C28\u0C3E \u0C24\u0C15\u0C4D\u0C15\u0C41\u0C35",
            other: "{{count}} \u0C38\u0C46\u0C15\u0C28\u0C4D\u0C32 \u0C15\u0C28\u0C4D\u0C28\u0C3E \u0C24\u0C15\u0C4D\u0C15\u0C41\u0C35"
        },
        withPreposition: {
            one: "\u0C38\u0C46\u0C15\u0C28\u0C41",
            other: "{{count}} \u0C38\u0C46\u0C15\u0C28\u0C4D\u0C32"
        }
    },
    xSeconds: {
        standalone: {
            one: "\u0C12\u0C15 \u0C38\u0C46\u0C15\u0C28\u0C41",
            // CLDR #1314
            other: "{{count}} \u0C38\u0C46\u0C15\u0C28\u0C4D\u0C32"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C38\u0C46\u0C15\u0C28\u0C41",
            other: "{{count}} \u0C38\u0C46\u0C15\u0C28\u0C4D\u0C32"
        }
    },
    halfAMinute: {
        standalone: "\u0C05\u0C30 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02",
        withPreposition: "\u0C05\u0C30 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02"
    },
    lessThanXMinutes: {
        standalone: {
            one: "\u0C12\u0C15 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02 \u0C15\u0C28\u0C4D\u0C28\u0C3E \u0C24\u0C15\u0C4D\u0C15\u0C41\u0C35",
            other: "{{count}} \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C3E\u0C32 \u0C15\u0C28\u0C4D\u0C28\u0C3E \u0C24\u0C15\u0C4D\u0C15\u0C41\u0C35"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02",
            other: "{{count}} \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C3E\u0C32"
        }
    },
    xMinutes: {
        standalone: {
            one: "\u0C12\u0C15 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02",
            // CLDR #1311
            other: "{{count}} \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02",
            // CLDR #1311
            other: "{{count}} \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C3E\u0C32"
        }
    },
    aboutXHours: {
        standalone: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C17\u0C02\u0C1F",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C17\u0C02\u0C1F\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C17\u0C02\u0C1F",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C17\u0C02\u0C1F\u0C32"
        }
    },
    xHours: {
        standalone: {
            one: "\u0C12\u0C15 \u0C17\u0C02\u0C1F",
            // CLDR #1308
            other: "{{count}} \u0C17\u0C02\u0C1F\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C17\u0C02\u0C1F",
            other: "{{count}} \u0C17\u0C02\u0C1F\u0C32"
        }
    },
    xDays: {
        standalone: {
            one: "\u0C12\u0C15 \u0C30\u0C4B\u0C1C\u0C41",
            // CLDR #1292
            other: "{{count}} \u0C30\u0C4B\u0C1C\u0C41\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C30\u0C4B\u0C1C\u0C41",
            other: "{{count}} \u0C30\u0C4B\u0C1C\u0C41\u0C32"
        }
    },
    aboutXWeeks: {
        standalone: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C35\u0C3E\u0C30\u0C02",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C35\u0C3E\u0C30\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C35\u0C3E\u0C30\u0C02",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C35\u0C3E\u0C30\u0C3E\u0C32\u0C32"
        }
    },
    xWeeks: {
        standalone: {
            one: "\u0C12\u0C15 \u0C35\u0C3E\u0C30\u0C02",
            other: "{{count}} \u0C35\u0C3E\u0C30\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C35\u0C3E\u0C30\u0C02",
            other: "{{count}} \u0C35\u0C3E\u0C30\u0C3E\u0C32\u0C32"
        }
    },
    aboutXMonths: {
        standalone: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C28\u0C46\u0C32",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C28\u0C46\u0C32\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C28\u0C46\u0C32",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C28\u0C46\u0C32\u0C32"
        }
    },
    xMonths: {
        standalone: {
            one: "\u0C12\u0C15 \u0C28\u0C46\u0C32",
            // CLDR #1281
            other: "{{count}} \u0C28\u0C46\u0C32\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C28\u0C46\u0C32",
            other: "{{count}} \u0C28\u0C46\u0C32\u0C32"
        }
    },
    aboutXYears: {
        standalone: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32"
        }
    },
    xYears: {
        standalone: {
            one: "\u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            // CLDR #1275
            other: "{{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "{{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32"
        }
    },
    overXYears: {
        standalone: {
            one: "\u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02 \u0C2A\u0C48\u0C17\u0C3E",
            other: "{{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32\u0C15\u0C41 \u0C2A\u0C48\u0C17\u0C3E"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "{{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32"
        }
    },
    almostXYears: {
        standalone: {
            one: "\u0C26\u0C3E\u0C26\u0C3E\u0C2A\u0C41 \u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "\u0C26\u0C3E\u0C26\u0C3E\u0C2A\u0C41 {{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C26\u0C3E\u0C26\u0C3E\u0C2A\u0C41 \u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "\u0C26\u0C3E\u0C26\u0C3E\u0C2A\u0C41 {{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32"
        }
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = options !== null && options !== void 0 && options.addSuffix ? formatDistanceLocale[token].withPreposition : formatDistanceLocale[token].standalone;
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u0C32\u0C4B";
        else return result + " \u0C15\u0C4D\u0C30\u0C3F\u0C24\u0C02";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"kZzXd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js"); // Source: https://www.unicode.org/cldr/charts/32/summary/te.html
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
// CLDR #1807 - #1811
var dateFormats = {
    full: 'd, MMMM y, EEEE',
    long: 'd MMMM, y',
    medium: 'd MMM, y',
    short: 'dd-MM-yy'
};
// CLDR #1807 - #1811
var timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
// CLDR #1815 - #1818
var dateTimeFormats = {
    full: "{{date}} {{time}}'\u0C15\u0C3F'",
    long: "{{date}} {{time}}'\u0C15\u0C3F'",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8GEgO":[function(require,module,exports,__globalThis) {
// Source: https://www.unicode.org/cldr/charts/32/summary/te.html
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'\u0C17\u0C24' eeee p",
    // CLDR #1384
    yesterday: "'\u0C28\u0C3F\u0C28\u0C4D\u0C28' p",
    // CLDR #1393
    today: "'\u0C08 \u0C30\u0C4B\u0C1C\u0C41' p",
    // CLDR #1394
    tomorrow: "'\u0C30\u0C47\u0C2A\u0C41' p",
    // CLDR #1395
    nextWeek: "'\u0C24\u0C26\u0C41\u0C2A\u0C30\u0C3F' eeee p",
    // CLDR #1386
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"cAKQD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js"); // Source: https://www.unicode.org/cldr/charts/32/summary/te.html
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
// Source: https://dsal.uchicago.edu/dictionaries/brown/
// CLDR #1605 - #1608
var eraValues = {
    narrow: [
        "\u0C15\u0C4D\u0C30\u0C40.\u0C2A\u0C42.",
        "\u0C15\u0C4D\u0C30\u0C40.\u0C36."
    ],
    abbreviated: [
        "\u0C15\u0C4D\u0C30\u0C40.\u0C2A\u0C42.",
        "\u0C15\u0C4D\u0C30\u0C40.\u0C36."
    ],
    wide: [
        "\u0C15\u0C4D\u0C30\u0C40\u0C38\u0C4D\u0C24\u0C41 \u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C02",
        "\u0C15\u0C4D\u0C30\u0C40\u0C38\u0C4D\u0C24\u0C41\u0C36\u0C15\u0C02"
    ]
};
// CLDR #1613 - #1628
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u0C24\u0C4D\u0C30\u0C481",
        "\u0C24\u0C4D\u0C30\u0C482",
        "\u0C24\u0C4D\u0C30\u0C483",
        "\u0C24\u0C4D\u0C30\u0C484"
    ],
    wide: [
        "1\u0C35 \u0C24\u0C4D\u0C30\u0C48\u0C2E\u0C3E\u0C38\u0C3F\u0C15\u0C02",
        "2\u0C35 \u0C24\u0C4D\u0C30\u0C48\u0C2E\u0C3E\u0C38\u0C3F\u0C15\u0C02",
        "3\u0C35 \u0C24\u0C4D\u0C30\u0C48\u0C2E\u0C3E\u0C38\u0C3F\u0C15\u0C02",
        "4\u0C35 \u0C24\u0C4D\u0C30\u0C48\u0C2E\u0C3E\u0C38\u0C3F\u0C15\u0C02"
    ]
};
// CLDR #1637 - #1708
var monthValues = {
    narrow: [
        "\u0C1C",
        "\u0C2B\u0C3F",
        "\u0C2E\u0C3E",
        "\u0C0F",
        "\u0C2E\u0C47",
        "\u0C1C\u0C42",
        "\u0C1C\u0C41",
        "\u0C06",
        "\u0C38\u0C46",
        "\u0C05",
        "\u0C28",
        "\u0C21\u0C3F"
    ],
    abbreviated: [
        "\u0C1C\u0C28",
        "\u0C2B\u0C3F\u0C2C\u0C4D\u0C30",
        "\u0C2E\u0C3E\u0C30\u0C4D\u0C1A\u0C3F",
        "\u0C0F\u0C2A\u0C4D\u0C30\u0C3F",
        "\u0C2E\u0C47",
        "\u0C1C\u0C42\u0C28\u0C4D",
        "\u0C1C\u0C41\u0C32\u0C48",
        "\u0C06\u0C17",
        "\u0C38\u0C46\u0C2A\u0C4D\u0C1F\u0C46\u0C02",
        "\u0C05\u0C15\u0C4D\u0C1F\u0C4B",
        "\u0C28\u0C35\u0C02",
        "\u0C21\u0C3F\u0C38\u0C46\u0C02"
    ],
    wide: [
        "\u0C1C\u0C28\u0C35\u0C30\u0C3F",
        "\u0C2B\u0C3F\u0C2C\u0C4D\u0C30\u0C35\u0C30\u0C3F",
        "\u0C2E\u0C3E\u0C30\u0C4D\u0C1A\u0C3F",
        "\u0C0F\u0C2A\u0C4D\u0C30\u0C3F\u0C32\u0C4D",
        "\u0C2E\u0C47",
        "\u0C1C\u0C42\u0C28\u0C4D",
        "\u0C1C\u0C41\u0C32\u0C48",
        "\u0C06\u0C17\u0C38\u0C4D\u0C1F\u0C41",
        "\u0C38\u0C46\u0C2A\u0C4D\u0C1F\u0C46\u0C02\u0C2C\u0C30\u0C4D",
        "\u0C05\u0C15\u0C4D\u0C1F\u0C4B\u0C2C\u0C30\u0C4D",
        "\u0C28\u0C35\u0C02\u0C2C\u0C30\u0C4D",
        "\u0C21\u0C3F\u0C38\u0C46\u0C02\u0C2C\u0C30\u0C4D"
    ]
};
// CLDR #1709 - #1764
var dayValues = {
    narrow: [
        "\u0C06",
        "\u0C38\u0C4B",
        "\u0C2E",
        "\u0C2C\u0C41",
        "\u0C17\u0C41",
        "\u0C36\u0C41",
        "\u0C36"
    ],
    short: [
        "\u0C06\u0C26\u0C3F",
        "\u0C38\u0C4B\u0C2E",
        "\u0C2E\u0C02\u0C17\u0C33",
        "\u0C2C\u0C41\u0C27",
        "\u0C17\u0C41\u0C30\u0C41",
        "\u0C36\u0C41\u0C15\u0C4D\u0C30",
        "\u0C36\u0C28\u0C3F"
    ],
    abbreviated: [
        "\u0C06\u0C26\u0C3F",
        "\u0C38\u0C4B\u0C2E",
        "\u0C2E\u0C02\u0C17\u0C33",
        "\u0C2C\u0C41\u0C27",
        "\u0C17\u0C41\u0C30\u0C41",
        "\u0C36\u0C41\u0C15\u0C4D\u0C30",
        "\u0C36\u0C28\u0C3F"
    ],
    wide: [
        "\u0C06\u0C26\u0C3F\u0C35\u0C3E\u0C30\u0C02",
        "\u0C38\u0C4B\u0C2E\u0C35\u0C3E\u0C30\u0C02",
        "\u0C2E\u0C02\u0C17\u0C33\u0C35\u0C3E\u0C30\u0C02",
        "\u0C2C\u0C41\u0C27\u0C35\u0C3E\u0C30\u0C02",
        "\u0C17\u0C41\u0C30\u0C41\u0C35\u0C3E\u0C30\u0C02",
        "\u0C36\u0C41\u0C15\u0C4D\u0C30\u0C35\u0C3E\u0C30\u0C02",
        "\u0C36\u0C28\u0C3F\u0C35\u0C3E\u0C30\u0C02"
    ]
};
// CLDR #1767 - #1806
var dayPeriodValues = {
    narrow: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
    },
    abbreviated: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
    },
    wide: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
    },
    abbreviated: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
    },
    wide: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "\u0C35";
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2zeEj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(వ)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(క్రీ\.పూ\.|క్రీ\.శ\.)/i,
    abbreviated: /^(క్రీ\.?\s?పూ\.?|ప్ర\.?\s?శ\.?\s?పూ\.?|క్రీ\.?\s?శ\.?|సా\.?\s?శ\.?)/i,
    wide: /^(క్రీస్తు పూర్వం|ప్రస్తుత శకానికి పూర్వం|క్రీస్తు శకం|ప్రస్తుత శకం)/i
};
var parseEraPatterns = {
    any: [
        /^(పూ|శ)/i,
        /^సా/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^త్రై[1234]/i,
    wide: /^[1234](వ)? త్రైమాసికం/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^(జూ|జు|జ|ఫి|మా|ఏ|మే|ఆ|సె|అ|న|డి)/i,
    abbreviated: /^(జన|ఫిబ్ర|మార్చి|ఏప్రి|మే|జూన్|జులై|ఆగ|సెప్|అక్టో|నవ|డిసె)/i,
    wide: /^(జనవరి|ఫిబ్రవరి|మార్చి|ఏప్రిల్|మే|జూన్|జులై|ఆగస్టు|సెప్టెంబర్|అక్టోబర్|నవంబర్|డిసెంబర్)/i
};
var parseMonthPatterns = {
    narrow: [
        /^జ/i,
        /^ఫి/i,
        /^మా/i,
        /^ఏ/i,
        /^మే/i,
        /^జూ/i,
        /^జు/i,
        /^ఆ/i,
        /^సె/i,
        /^అ/i,
        /^న/i,
        /^డి/i
    ],
    any: [
        /^జన/i,
        /^ఫి/i,
        /^మా/i,
        /^ఏ/i,
        /^మే/i,
        /^జూన్/i,
        /^జులై/i,
        /^ఆగ/i,
        /^సె/i,
        /^అ/i,
        /^న/i,
        /^డి/i
    ]
};
var matchDayPatterns = {
    narrow: /^(ఆ|సో|మ|బు|గు|శు|శ)/i,
    short: /^(ఆది|సోమ|మం|బుధ|గురు|శుక్ర|శని)/i,
    abbreviated: /^(ఆది|సోమ|మం|బుధ|గురు|శుక్ర|శని)/i,
    wide: /^(ఆదివారం|సోమవారం|మంగళవారం|బుధవారం|గురువారం|శుక్రవారం|శనివారం)/i
};
var parseDayPatterns = {
    narrow: [
        /^ఆ/i,
        /^సో/i,
        /^మ/i,
        /^బు/i,
        /^గు/i,
        /^శు/i,
        /^శ/i
    ],
    any: [
        /^ఆది/i,
        /^సోమ/i,
        /^మం/i,
        /^బుధ/i,
        /^గురు/i,
        /^శుక్ర/i,
        /^శని/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(పూర్వాహ్నం|అపరాహ్నం|అర్ధరాత్రి|మిట్టమధ్యాహ్నం|ఉదయం|మధ్యాహ్నం|సాయంత్రం|రాత్రి)/i,
    any: /^(పూర్వాహ్నం|అపరాహ్నం|అర్ధరాత్రి|మిట్టమధ్యాహ్నం|ఉదయం|మధ్యాహ్నం|సాయంత్రం|రాత్రి)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^పూర్వాహ్నం/i,
        pm: /^అపరాహ్నం/i,
        midnight: /^అర్ధ/i,
        noon: /^మిట్ట/i,
        morning: /ఉదయం/i,
        afternoon: /మధ్యాహ్నం/i,
        evening: /సాయంత్రం/i,
        night: /రాత్రి/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"lCW3l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Thai locale.
 * @language Thai
 * @iso-639-2 tha
 * @author Athiwat Hirunworawongkun [@athivvat]{@link https://github.com/athivvat}
 * @author [@hawkup]{@link https://github.com/hawkup}
 * @author  Jirawat I. [@nodtem66]{@link https://github.com/nodtem66}
 */ var locale = {
    code: 'th',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"1luhF","./_lib/formatLong/index.js":"NvgYk","./_lib/formatRelative/index.js":"6Sfg1","./_lib/localize/index.js":"eCNY3","./_lib/match/index.js":"8ncdk","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1luhF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32 1 \u0E27\u0E34\u0E19\u0E32\u0E17\u0E35",
        other: "\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32 {{count}} \u0E27\u0E34\u0E19\u0E32\u0E17\u0E35"
    },
    xSeconds: {
        one: "1 \u0E27\u0E34\u0E19\u0E32\u0E17\u0E35",
        other: "{{count}} \u0E27\u0E34\u0E19\u0E32\u0E17\u0E35"
    },
    halfAMinute: "\u0E04\u0E23\u0E36\u0E48\u0E07\u0E19\u0E32\u0E17\u0E35",
    lessThanXMinutes: {
        one: "\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32 1 \u0E19\u0E32\u0E17\u0E35",
        other: "\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32 {{count}} \u0E19\u0E32\u0E17\u0E35"
    },
    xMinutes: {
        one: "1 \u0E19\u0E32\u0E17\u0E35",
        other: "{{count}} \u0E19\u0E32\u0E17\u0E35"
    },
    aboutXHours: {
        one: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 1 \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07",
        other: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 {{count}} \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07"
    },
    xHours: {
        one: "1 \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07",
        other: "{{count}} \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07"
    },
    xDays: {
        one: "1 \u0E27\u0E31\u0E19",
        other: "{{count}} \u0E27\u0E31\u0E19"
    },
    aboutXWeeks: {
        one: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 1 \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C",
        other: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 {{count}} \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C"
    },
    xWeeks: {
        one: "1 \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C",
        other: "{{count}} \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C"
    },
    aboutXMonths: {
        one: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 1 \u0E40\u0E14\u0E37\u0E2D\u0E19",
        other: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 {{count}} \u0E40\u0E14\u0E37\u0E2D\u0E19"
    },
    xMonths: {
        one: "1 \u0E40\u0E14\u0E37\u0E2D\u0E19",
        other: "{{count}} \u0E40\u0E14\u0E37\u0E2D\u0E19"
    },
    aboutXYears: {
        one: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 1 \u0E1B\u0E35",
        other: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 {{count}} \u0E1B\u0E35"
    },
    xYears: {
        one: "1 \u0E1B\u0E35",
        other: "{{count}} \u0E1B\u0E35"
    },
    overXYears: {
        one: "\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32 1 \u0E1B\u0E35",
        other: "\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32 {{count}} \u0E1B\u0E35"
    },
    almostXYears: {
        one: "\u0E40\u0E01\u0E37\u0E2D\u0E1A 1 \u0E1B\u0E35",
        other: "\u0E40\u0E01\u0E37\u0E2D\u0E1A {{count}} \u0E1B\u0E35"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
            if (token === 'halfAMinute') return "\u0E43\u0E19" + result;
            else return "\u0E43\u0E19 " + result;
        } else return result + "\u0E17\u0E35\u0E48\u0E1C\u0E48\u0E32\u0E19\u0E21\u0E32";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"NvgYk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "\u0E27\u0E31\u0E19EEEE\u0E17\u0E35\u0E48 do MMMM y",
    long: 'do MMMM y',
    medium: 'd MMM y',
    short: 'dd/MM/yyyy'
};
var timeFormats = {
    full: "H:mm:ss \u0E19. zzzz",
    long: "H:mm:ss \u0E19. z",
    medium: "H:mm:ss \u0E19.",
    short: "H:mm \u0E19."
};
var dateTimeFormats = {
    full: "{{date}} '\u0E40\u0E27\u0E25\u0E32' {{time}}",
    long: "{{date}} '\u0E40\u0E27\u0E25\u0E32' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'medium'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6Sfg1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "eeee'\u0E17\u0E35\u0E48\u0E41\u0E25\u0E49\u0E27\u0E40\u0E27\u0E25\u0E32' p",
    yesterday: "'\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E27\u0E32\u0E19\u0E19\u0E35\u0E49\u0E40\u0E27\u0E25\u0E32' p",
    today: "'\u0E27\u0E31\u0E19\u0E19\u0E35\u0E49\u0E40\u0E27\u0E25\u0E32' p",
    tomorrow: "'\u0E1E\u0E23\u0E38\u0E48\u0E07\u0E19\u0E35\u0E49\u0E40\u0E27\u0E25\u0E32' p",
    nextWeek: "eeee '\u0E40\u0E27\u0E25\u0E32' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"eCNY3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'B',
        "\u0E04\u0E28"
    ],
    abbreviated: [
        'BC',
        "\u0E04.\u0E28."
    ],
    wide: [
        "\u0E1B\u0E35\u0E01\u0E48\u0E2D\u0E19\u0E04\u0E23\u0E34\u0E2A\u0E15\u0E01\u0E32\u0E25",
        "\u0E04\u0E23\u0E34\u0E2A\u0E15\u0E4C\u0E28\u0E31\u0E01\u0E23\u0E32\u0E0A"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "\u0E44\u0E15\u0E23\u0E21\u0E32\u0E2A\u0E41\u0E23\u0E01",
        "\u0E44\u0E15\u0E23\u0E21\u0E32\u0E2A\u0E17\u0E35\u0E48\u0E2A\u0E2D\u0E07",
        "\u0E44\u0E15\u0E23\u0E21\u0E32\u0E2A\u0E17\u0E35\u0E48\u0E2A\u0E32\u0E21",
        "\u0E44\u0E15\u0E23\u0E21\u0E32\u0E2A\u0E17\u0E35\u0E48\u0E2A\u0E35\u0E48"
    ]
};
var dayValues = {
    narrow: [
        "\u0E2D\u0E32.",
        "\u0E08.",
        "\u0E2D.",
        "\u0E1E.",
        "\u0E1E\u0E24.",
        "\u0E28.",
        "\u0E2A."
    ],
    short: [
        "\u0E2D\u0E32.",
        "\u0E08.",
        "\u0E2D.",
        "\u0E1E.",
        "\u0E1E\u0E24.",
        "\u0E28.",
        "\u0E2A."
    ],
    abbreviated: [
        "\u0E2D\u0E32.",
        "\u0E08.",
        "\u0E2D.",
        "\u0E1E.",
        "\u0E1E\u0E24.",
        "\u0E28.",
        "\u0E2A."
    ],
    wide: [
        "\u0E2D\u0E32\u0E17\u0E34\u0E15\u0E22\u0E4C",
        "\u0E08\u0E31\u0E19\u0E17\u0E23\u0E4C",
        "\u0E2D\u0E31\u0E07\u0E04\u0E32\u0E23",
        "\u0E1E\u0E38\u0E18",
        "\u0E1E\u0E24\u0E2B\u0E31\u0E2A\u0E1A\u0E14\u0E35",
        "\u0E28\u0E38\u0E01\u0E23\u0E4C",
        "\u0E40\u0E2A\u0E32\u0E23\u0E4C"
    ]
};
var monthValues = {
    narrow: [
        "\u0E21.\u0E04.",
        "\u0E01.\u0E1E.",
        "\u0E21\u0E35.\u0E04.",
        "\u0E40\u0E21.\u0E22.",
        "\u0E1E.\u0E04.",
        "\u0E21\u0E34.\u0E22.",
        "\u0E01.\u0E04.",
        "\u0E2A.\u0E04.",
        "\u0E01.\u0E22.",
        "\u0E15.\u0E04.",
        "\u0E1E.\u0E22.",
        "\u0E18.\u0E04."
    ],
    abbreviated: [
        "\u0E21.\u0E04.",
        "\u0E01.\u0E1E.",
        "\u0E21\u0E35.\u0E04.",
        "\u0E40\u0E21.\u0E22.",
        "\u0E1E.\u0E04.",
        "\u0E21\u0E34.\u0E22.",
        "\u0E01.\u0E04.",
        "\u0E2A.\u0E04.",
        "\u0E01.\u0E22.",
        "\u0E15.\u0E04.",
        "\u0E1E.\u0E22.",
        "\u0E18.\u0E04."
    ],
    wide: [
        "\u0E21\u0E01\u0E23\u0E32\u0E04\u0E21",
        "\u0E01\u0E38\u0E21\u0E20\u0E32\u0E1E\u0E31\u0E19\u0E18\u0E4C",
        "\u0E21\u0E35\u0E19\u0E32\u0E04\u0E21",
        "\u0E40\u0E21\u0E29\u0E32\u0E22\u0E19",
        "\u0E1E\u0E24\u0E29\u0E20\u0E32\u0E04\u0E21",
        "\u0E21\u0E34\u0E16\u0E38\u0E19\u0E32\u0E22\u0E19",
        "\u0E01\u0E23\u0E01\u0E0E\u0E32\u0E04\u0E21",
        "\u0E2A\u0E34\u0E07\u0E2B\u0E32\u0E04\u0E21",
        "\u0E01\u0E31\u0E19\u0E22\u0E32\u0E22\u0E19",
        "\u0E15\u0E38\u0E25\u0E32\u0E04\u0E21",
        "\u0E1E\u0E24\u0E28\u0E08\u0E34\u0E01\u0E32\u0E22\u0E19",
        "\u0E18\u0E31\u0E19\u0E27\u0E32\u0E04\u0E21"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E1A\u0E48\u0E32\u0E22",
        evening: "\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
    },
    abbreviated: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E1A\u0E48\u0E32\u0E22",
        evening: "\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
    },
    wide: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E1A\u0E48\u0E32\u0E22",
        evening: "\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E15\u0E2D\u0E19\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E27\u0E31\u0E19",
        evening: "\u0E15\u0E2D\u0E19\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
    },
    abbreviated: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E15\u0E2D\u0E19\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E27\u0E31\u0E19",
        evening: "\u0E15\u0E2D\u0E19\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
    },
    wide: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E15\u0E2D\u0E19\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E27\u0E31\u0E19",
        evening: "\u0E15\u0E2D\u0E19\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8ncdk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^\d+/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^([bB]|[aA]|คศ)/i,
    abbreviated: /^([bB]\.?\s?[cC]\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?|ค\.?ศ\.?)/i,
    wide: /^(ก่อนคริสตกาล|คริสต์ศักราช|คริสตกาล)/i
};
var parseEraPatterns = {
    any: [
        /^[bB]/i,
        /^(^[aA]|ค\.?ศ\.?|คริสตกาล|คริสต์ศักราช|)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^ไตรมาส(ที่)? ?[1234]/i
};
var parseQuarterPatterns = {
    any: [
        /(1|แรก|หนึ่ง)/i,
        /(2|สอง)/i,
        /(3|สาม)/i,
        /(4|สี่)/i
    ]
};
var matchMonthPatterns = {
    narrow: /^(ม\.?ค\.?|ก\.?พ\.?|มี\.?ค\.?|เม\.?ย\.?|พ\.?ค\.?|มิ\.?ย\.?|ก\.?ค\.?|ส\.?ค\.?|ก\.?ย\.?|ต\.?ค\.?|พ\.?ย\.?|ธ\.?ค\.?)/i,
    abbreviated: /^(ม\.?ค\.?|ก\.?พ\.?|มี\.?ค\.?|เม\.?ย\.?|พ\.?ค\.?|มิ\.?ย\.?|ก\.?ค\.?|ส\.?ค\.?|ก\.?ย\.?|ต\.?ค\.?|พ\.?ย\.?|ธ\.?ค\.?')/i,
    wide: /^(มกราคม|กุมภาพันธ์|มีนาคม|เมษายน|พฤษภาคม|มิถุนายน|กรกฎาคม|สิงหาคม|กันยายน|ตุลาคม|พฤศจิกายน|ธันวาคม)/i
};
var parseMonthPatterns = {
    wide: [
        /^มก/i,
        /^กุม/i,
        /^มี/i,
        /^เม/i,
        /^พฤษ/i,
        /^มิ/i,
        /^กรก/i,
        /^ส/i,
        /^กัน/i,
        /^ต/i,
        /^พฤศ/i,
        /^ธ/i
    ],
    any: [
        /^ม\.?ค\.?/i,
        /^ก\.?พ\.?/i,
        /^มี\.?ค\.?/i,
        /^เม\.?ย\.?/i,
        /^พ\.?ค\.?/i,
        /^มิ\.?ย\.?/i,
        /^ก\.?ค\.?/i,
        /^ส\.?ค\.?/i,
        /^ก\.?ย\.?/i,
        /^ต\.?ค\.?/i,
        /^พ\.?ย\.?/i,
        /^ธ\.?ค\.?/i
    ]
};
var matchDayPatterns = {
    narrow: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
    short: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
    abbreviated: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
    wide: /^(อาทิตย์|จันทร์|อังคาร|พุธ|พฤหัสบดี|ศุกร์|เสาร์)/i
};
var parseDayPatterns = {
    wide: [
        /^อา/i,
        /^จั/i,
        /^อั/i,
        /^พุธ/i,
        /^พฤ/i,
        /^ศ/i,
        /^เส/i
    ],
    any: [
        /^อา/i,
        /^จ/i,
        /^อ/i,
        /^พ(?!ฤ)/i,
        /^พฤ/i,
        /^ศ/i,
        /^ส/i
    ]
};
var matchDayPeriodPatterns = {
    any: /^(ก่อนเที่ยง|หลังเที่ยง|เที่ยงคืน|เที่ยง|(ตอน.*?)?.*(เที่ยง|เช้า|บ่าย|เย็น|กลางคืน))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^ก่อนเที่ยง/i,
        pm: /^หลังเที่ยง/i,
        midnight: /^เที่ยงคืน/i,
        noon: /^เที่ยง/i,
        morning: /เช้า/i,
        afternoon: /บ่าย/i,
        evening: /เย็น/i,
        night: /กลางคืน/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5mvpu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Turkish locale.
 * @language Turkish
 * @iso-639-2 tur
 * @author Alpcan Aydın [@alpcanaydin]{@link https://github.com/alpcanaydin}
 * @author Berkay Sargın [@berkaey]{@link https://github.com/berkaey}
 * @author Fatih Bulut [@bulutfatih]{@link https://github.com/bulutfatih}
 * @author Ismail Demirbilek [@dbtek]{@link https://github.com/dbtek}
 * @author İsmail Kayar [@ikayar]{@link https://github.com/ikayar}
 *
 *
 */ var locale = {
    code: 'tr',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"5ypgC","./_lib/formatLong/index.js":"k6bYW","./_lib/formatRelative/index.js":"53kh9","./_lib/localize/index.js":"5xrKv","./_lib/match/index.js":"6ILBX","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5ypgC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'bir saniyeden az',
        other: '{{count}} saniyeden az'
    },
    xSeconds: {
        one: '1 saniye',
        other: '{{count}} saniye'
    },
    halfAMinute: "yar\u0131m dakika",
    lessThanXMinutes: {
        one: 'bir dakikadan az',
        other: '{{count}} dakikadan az'
    },
    xMinutes: {
        one: '1 dakika',
        other: '{{count}} dakika'
    },
    aboutXHours: {
        one: "yakla\u015F\u0131k 1 saat",
        other: "yakla\u015F\u0131k {{count}} saat"
    },
    xHours: {
        one: '1 saat',
        other: '{{count}} saat'
    },
    xDays: {
        one: "1 g\xfcn",
        other: "{{count}} g\xfcn"
    },
    aboutXWeeks: {
        one: "yakla\u015F\u0131k 1 hafta",
        other: "yakla\u015F\u0131k {{count}} hafta"
    },
    xWeeks: {
        one: '1 hafta',
        other: '{{count}} hafta'
    },
    aboutXMonths: {
        one: "yakla\u015F\u0131k 1 ay",
        other: "yakla\u015F\u0131k {{count}} ay"
    },
    xMonths: {
        one: '1 ay',
        other: '{{count}} ay'
    },
    aboutXYears: {
        one: "yakla\u015F\u0131k 1 y\u0131l",
        other: "yakla\u015F\u0131k {{count}} y\u0131l"
    },
    xYears: {
        one: "1 y\u0131l",
        other: "{{count}} y\u0131l"
    },
    overXYears: {
        one: "1 y\u0131ldan fazla",
        other: "{{count}} y\u0131ldan fazla"
    },
    almostXYears: {
        one: "neredeyse 1 y\u0131l",
        other: "neredeyse {{count}} y\u0131l"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + ' sonra';
        else return result + " \xf6nce";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"k6bYW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'd MMMM y EEEE',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd.MM.yyyy'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} 'saat' {{time}}",
    long: "{{date}} 'saat' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"53kh9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'ge\xe7en hafta' eeee 'saat' p",
    yesterday: "'d\xfcn saat' p",
    today: "'bug\xfcn saat' p",
    tomorrow: "'yar\u0131n saat' p",
    nextWeek: "eeee 'saat' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5xrKv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "M\xd6",
        'MS'
    ],
    abbreviated: [
        "M\xd6",
        'MS'
    ],
    wide: [
        "Milattan \xd6nce",
        'Milattan Sonra'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1\xc7",
        "2\xc7",
        "3\xc7",
        "4\xc7"
    ],
    wide: [
        "\u0130lk \xe7eyrek",
        "\u0130kinci \xc7eyrek",
        "\xdc\xe7\xfcnc\xfc \xe7eyrek",
        "Son \xe7eyrek"
    ]
};
var monthValues = {
    narrow: [
        'O',
        "\u015E",
        'M',
        'N',
        'M',
        'H',
        'T',
        'A',
        'E',
        'E',
        'K',
        'A'
    ],
    abbreviated: [
        'Oca',
        "\u015Eub",
        'Mar',
        'Nis',
        'May',
        'Haz',
        'Tem',
        "A\u011Fu",
        'Eyl',
        'Eki',
        'Kas',
        'Ara'
    ],
    wide: [
        'Ocak',
        "\u015Eubat",
        'Mart',
        'Nisan',
        "May\u0131s",
        'Haziran',
        'Temmuz',
        "A\u011Fustos",
        "Eyl\xfcl",
        'Ekim',
        "Kas\u0131m",
        "Aral\u0131k"
    ]
};
var dayValues = {
    narrow: [
        'P',
        'P',
        'S',
        "\xc7",
        'P',
        'C',
        'C'
    ],
    short: [
        'Pz',
        'Pt',
        'Sa',
        "\xc7a",
        'Pe',
        'Cu',
        'Ct'
    ],
    abbreviated: [
        'Paz',
        'Pzt',
        'Sal',
        "\xc7ar",
        'Per',
        'Cum',
        'Cts'
    ],
    wide: [
        'Pazar',
        'Pazartesi',
        "Sal\u0131",
        "\xc7ar\u015Famba",
        "Per\u015Fembe",
        'Cuma',
        'Cumartesi'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\xf6\xf6",
        pm: "\xf6s",
        midnight: 'gy',
        noon: "\xf6",
        morning: 'sa',
        afternoon: "\xf6s",
        evening: 'ak',
        night: 'ge'
    },
    abbreviated: {
        am: "\xd6\xd6",
        pm: "\xd6S",
        midnight: "gece yar\u0131s\u0131",
        noon: "\xf6\u011Fle",
        morning: 'sabah',
        afternoon: "\xf6\u011Fleden sonra",
        evening: "ak\u015Fam",
        night: 'gece'
    },
    wide: {
        am: "\xd6.\xd6.",
        pm: "\xd6.S.",
        midnight: "gece yar\u0131s\u0131",
        noon: "\xf6\u011Fle",
        morning: 'sabah',
        afternoon: "\xf6\u011Fleden sonra",
        evening: "ak\u015Fam",
        night: 'gece'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\xf6\xf6",
        pm: "\xf6s",
        midnight: 'gy',
        noon: "\xf6",
        morning: 'sa',
        afternoon: "\xf6s",
        evening: 'ak',
        night: 'ge'
    },
    abbreviated: {
        am: "\xd6\xd6",
        pm: "\xd6S",
        midnight: "gece yar\u0131s\u0131",
        noon: "\xf6\u011Flen",
        morning: 'sabahleyin',
        afternoon: "\xf6\u011Fleden sonra",
        evening: "ak\u015Famleyin",
        night: 'geceleyin'
    },
    wide: {
        am: "\xf6.\xf6.",
        pm: "\xf6.s.",
        midnight: "gece yar\u0131s\u0131",
        noon: "\xf6\u011Flen",
        morning: 'sabahleyin',
        afternoon: "\xf6\u011Fleden sonra",
        evening: "ak\u015Famleyin",
        night: 'geceleyin'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6ILBX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(mö|ms)/i,
    abbreviated: /^(mö|ms)/i,
    wide: /^(milattan önce|milattan sonra)/i
};
var parseEraPatterns = {
    any: [
        /(^mö|^milattan önce)/i,
        /(^ms|^milattan sonra)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]ç/i,
    wide: /^((i|İ)lk|(i|İ)kinci|üçüncü|son) çeyrek/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ],
    abbreviated: [
        /1ç/i,
        /2ç/i,
        /3ç/i,
        /4ç/i
    ],
    wide: [
        /^(i|İ)lk çeyrek/i,
        /(i|İ)kinci çeyrek/i,
        /üçüncü çeyrek/i,
        /son çeyrek/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[oşmnhtaek]/i,
    abbreviated: /^(oca|şub|mar|nis|may|haz|tem|ağu|eyl|eki|kas|ara)/i,
    wide: /^(ocak|şubat|mart|nisan|mayıs|haziran|temmuz|ağustos|eylül|ekim|kasım|aralık)/i
};
var parseMonthPatterns = {
    narrow: [
        /^o/i,
        /^ş/i,
        /^m/i,
        /^n/i,
        /^m/i,
        /^h/i,
        /^t/i,
        /^a/i,
        /^e/i,
        /^e/i,
        /^k/i,
        /^a/i
    ],
    any: [
        /^o/i,
        /^ş/i,
        /^mar/i,
        /^n/i,
        /^may/i,
        /^h/i,
        /^t/i,
        /^ağ/i,
        /^ey/i,
        /^ek/i,
        /^k/i,
        /^ar/i
    ]
};
var matchDayPatterns = {
    narrow: /^[psçc]/i,
    short: /^(pz|pt|sa|ça|pe|cu|ct)/i,
    abbreviated: /^(paz|pzt|sal|çar|per|cum|cts)/i,
    wide: /^(pazar(?!tesi)|pazartesi|salı|çarşamba|perşembe|cuma(?!rtesi)|cumartesi)/i
};
var parseDayPatterns = {
    narrow: [
        /^p/i,
        /^p/i,
        /^s/i,
        /^ç/i,
        /^p/i,
        /^c/i,
        /^c/i
    ],
    any: [
        /^pz/i,
        /^pt/i,
        /^sa/i,
        /^ça/i,
        /^pe/i,
        /^cu/i,
        /^ct/i
    ],
    wide: [
        /^pazar(?!tesi)/i,
        /^pazartesi/i,
        /^salı/i,
        /^çarşamba/i,
        /^perşembe/i,
        /^cuma(?!rtesi)/i,
        /^cumartesi/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(öö|ös|gy|ö|sa|ös|ak|ge)/i,
    any: /^(ö\.?\s?[ös]\.?|öğleden sonra|gece yarısı|öğle|(sabah|öğ|akşam|gece)(leyin))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^ö\.?ö\.?/i,
        pm: /^ö\.?s\.?/i,
        midnight: /^(gy|gece yarısı)/i,
        noon: /^öğ/i,
        morning: /^sa/i,
        afternoon: /^öğleden sonra/i,
        evening: /^ak/i,
        night: /^ge/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"d84tX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Uighur locale
 * @language Uighur
 * @iso-639-2 uig
 * @author Abduwaly M. [@abduwaly]{@link https://github.com/abduwaly}
 */ var locale = {
    code: 'ug',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"dCo1i","./_lib/formatLong/index.js":"ish6K","./_lib/formatRelative/index.js":"blZqE","./_lib/localize/index.js":"5dDNi","./_lib/match/index.js":"lLaIE","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"dCo1i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0628\u0649\u0631 \u0633\u0649\u0643\u06C7\u0646\u062A \u0626\u0649\u0686\u0649\u062F\u06D5",
        other: "\u0633\u0649\u0643\u06C7\u0646\u062A \u0626\u0649\u0686\u0649\u062F\u06D5 {{count}}"
    },
    xSeconds: {
        one: "\u0628\u0649\u0631 \u0633\u0649\u0643\u06C7\u0646\u062A",
        other: "\u0633\u0649\u0643\u06C7\u0646\u062A {{count}}"
    },
    halfAMinute: "\u064A\u0649\u0631\u0649\u0645 \u0645\u0649\u0646\u06C7\u062A",
    lessThanXMinutes: {
        one: "\u0628\u0649\u0631 \u0645\u0649\u0646\u06C7\u062A \u0626\u0649\u0686\u0649\u062F\u06D5",
        other: "\u0645\u0649\u0646\u06C7\u062A \u0626\u0649\u0686\u0649\u062F\u06D5 {{count}}"
    },
    xMinutes: {
        one: "\u0628\u0649\u0631 \u0645\u0649\u0646\u06C7\u062A",
        other: "\u0645\u0649\u0646\u06C7\u062A {{count}}"
    },
    aboutXHours: {
        one: "\u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646 \u0628\u0649\u0631 \u0633\u0627\u0626\u06D5\u062A",
        other: "\u0633\u0627\u0626\u06D5\u062A {{count}} \u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646"
    },
    xHours: {
        one: "\u0628\u0649\u0631 \u0633\u0627\u0626\u06D5\u062A",
        other: "\u0633\u0627\u0626\u06D5\u062A {{count}}"
    },
    xDays: {
        one: "\u0628\u0649\u0631 \u0643\u06C8\u0646",
        other: "\u0643\u06C8\u0646 {{count}}"
    },
    aboutXWeeks: {
        one: "\u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646 \u0628\u0649\u0631\u06BE\u06D5\u067E\u062A\u06D5",
        other: "\u06BE\u06D5\u067E\u062A\u06D5 {{count}} \u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646"
    },
    xWeeks: {
        one: "\u0628\u0649\u0631\u06BE\u06D5\u067E\u062A\u06D5",
        other: "\u06BE\u06D5\u067E\u062A\u06D5 {{count}}"
    },
    aboutXMonths: {
        one: "\u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646 \u0628\u0649\u0631 \u0626\u0627\u064A",
        other: "\u0626\u0627\u064A {{count}} \u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646"
    },
    xMonths: {
        one: "\u0628\u0649\u0631 \u0626\u0627\u064A",
        other: "\u0626\u0627\u064A {{count}}"
    },
    aboutXYears: {
        one: "\u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646 \u0628\u0649\u0631 \u064A\u0649\u0644",
        other: "\u064A\u0649\u0644 {{count}} \u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646"
    },
    xYears: {
        one: "\u0628\u0649\u0631 \u064A\u0649\u0644",
        other: "\u064A\u0649\u0644 {{count}}"
    },
    overXYears: {
        one: "\u0628\u0649\u0631 \u064A\u0649\u0644\u062F\u0649\u0646 \u0626\u0627\u0631\u062A\u06C7\u0642",
        other: "\u064A\u0649\u0644\u062F\u0649\u0646 \u0626\u0627\u0631\u062A\u06C7\u0642 {{count}}"
    },
    almostXYears: {
        one: "\u0626\u0627\u0633\u0627\u0633\u06D5\u0646 \u0628\u0649\u0631 \u064A\u0649\u0644",
        other: "\u064A\u0649\u0644 {{count}} \u0626\u0627\u0633\u0627\u0633\u06D5\u0646"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result;
        else return result + " \u0628\u0648\u0644\u062F\u0649";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"ish6K":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var dateTimeFormats = {
    full: "{{date}} '\u062F\u06D5' {{time}}",
    long: "{{date}} '\u062F\u06D5' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"blZqE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'\u0626\u200D\u06C6\u062A\u0643\u06D5\u0646' eeee '\u062F\u06D5' p",
    yesterday: "'\u062A\u06C8\u0646\u06C8\u06AF\u06C8\u0646 \u062F\u06D5' p",
    today: "'\u0628\u06C8\u06AF\u06C8\u0646 \u062F\u06D5' p",
    tomorrow: "'\u0626\u06D5\u062A\u06D5 \u062F\u06D5' p",
    nextWeek: "eeee '\u062F\u06D5' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5dDNi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u0628",
        "\u0643"
    ],
    abbreviated: [
        "\u0628",
        "\u0643"
    ],
    wide: [
        "\u0645\u0649\u064A\u0644\u0627\u062F\u0649\u062F\u0649\u0646 \u0628\u06C7\u0631\u06C7\u0646",
        "\u0645\u0649\u064A\u0644\u0627\u062F\u0649\u062F\u0649\u0646 \u0643\u0649\u064A\u0649\u0646"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        '1',
        '2',
        '3',
        '4'
    ],
    wide: [
        "\u0628\u0649\u0631\u0649\u0646\u062C\u0649 \u0686\u0627\u0631\u06D5\u0643",
        "\u0626\u0649\u0643\u0643\u0649\u0646\u062C\u0649 \u0686\u0627\u0631\u06D5\u0643",
        "\u0626\u06C8\u0686\u0649\u0646\u062C\u0649 \u0686\u0627\u0631\u06D5\u0643",
        "\u062A\u06C6\u062A\u0649\u0646\u062C\u0649 \u0686\u0627\u0631\u06D5\u0643"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
    narrow: [
        "\u064A",
        "\u0641",
        "\u0645",
        "\u0627",
        "\u0645",
        "\u0649",
        "\u0649",
        "\u0627",
        "\u0633",
        "\u06C6",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u064A\u0627\u0646\u06CB\u0627\u0631",
        "\u0641\u06D0\u06CB\u0649\u0631\u0627\u0644",
        "\u0645\u0627\u0631\u062A",
        "\u0626\u0627\u067E\u0631\u0649\u0644",
        "\u0645\u0627\u064A",
        "\u0626\u0649\u064A\u06C7\u0646",
        "\u0626\u0649\u064A\u0648\u0644",
        "\u0626\u0627\u06CB\u063A\u06C7\u0633\u062A",
        "\u0633\u0649\u0646\u062A\u06D5\u0628\u0649\u0631",
        "\u0626\u06C6\u0643\u062A\u06D5\u0628\u0649\u0631",
        "\u0646\u0648\u064A\u0627\u0628\u0649\u0631",
        "\u062F\u0649\u0643\u0627\u0628\u0649\u0631"
    ],
    wide: [
        "\u064A\u0627\u0646\u06CB\u0627\u0631",
        "\u0641\u06D0\u06CB\u0649\u0631\u0627\u0644",
        "\u0645\u0627\u0631\u062A",
        "\u0626\u0627\u067E\u0631\u0649\u0644",
        "\u0645\u0627\u064A",
        "\u0626\u0649\u064A\u06C7\u0646",
        "\u0626\u0649\u064A\u0648\u0644",
        "\u0626\u0627\u06CB\u063A\u06C7\u0633\u062A",
        "\u0633\u0649\u0646\u062A\u06D5\u0628\u0649\u0631",
        "\u0626\u06C6\u0643\u062A\u06D5\u0628\u0649\u0631",
        "\u0646\u0648\u064A\u0627\u0628\u0649\u0631",
        "\u062F\u0649\u0643\u0627\u0628\u0649\u0631"
    ]
};
var dayValues = {
    narrow: [
        "\u064A",
        "\u062F",
        "\u0633",
        "\u0686",
        "\u067E",
        "\u062C",
        "\u0634"
    ],
    short: [
        "\u064A",
        "\u062F",
        "\u0633",
        "\u0686",
        "\u067E",
        "\u062C",
        "\u0634"
    ],
    abbreviated: [
        "\u064A\u06D5\u0643\u0634\u06D5\u0646\u0628\u06D5",
        "\u062F\u06C8\u0634\u06D5\u0646\u0628\u06D5",
        "\u0633\u06D5\u064A\u0634\u06D5\u0646\u0628\u06D5",
        "\u0686\u0627\u0631\u0634\u06D5\u0646\u0628\u06D5",
        "\u067E\u06D5\u064A\u0634\u06D5\u0646\u0628\u06D5",
        "\u062C\u06C8\u0645\u06D5",
        "\u0634\u06D5\u0646\u0628\u06D5"
    ],
    wide: [
        "\u064A\u06D5\u0643\u0634\u06D5\u0646\u0628\u06D5",
        "\u062F\u06C8\u0634\u06D5\u0646\u0628\u06D5",
        "\u0633\u06D5\u064A\u0634\u06D5\u0646\u0628\u06D5",
        "\u0686\u0627\u0631\u0634\u06D5\u0646\u0628\u06D5",
        "\u067E\u06D5\u064A\u0634\u06D5\u0646\u0628\u06D5",
        "\u062C\u06C8\u0645\u06D5",
        "\u0634\u06D5\u0646\u0628\u06D5"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0649\u0645",
        night: "\u0643\u0649\u0686\u06D5"
    },
    abbreviated: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0649\u0645",
        night: "\u0643\u0649\u0686\u06D5"
    },
    wide: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0649\u0645",
        night: "\u0643\u0649\u0686\u06D5"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646\u062F\u06D5",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0627\u0645\u062F\u0627",
        night: "\u0643\u0649\u0686\u0649\u062F\u06D5"
    },
    abbreviated: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646\u062F\u06D5",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0627\u0645\u062F\u0627",
        night: "\u0643\u0649\u0686\u0649\u062F\u06D5"
    },
    wide: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646\u062F\u06D5",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0627\u0645\u062F\u0627",
        night: "\u0643\u0649\u0686\u0649\u062F\u06D5"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"lLaIE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(ب|ك)/i,
    wide: /^(مىيلادىدىن بۇرۇن|مىيلادىدىن كىيىن)/i
};
var parseEraPatterns = {
    any: [
        /^بۇرۇن/i,
        /^كىيىن/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^چ[1234]/i,
    wide: /^چارەك [1234]/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    // eslint-disable-next-line no-misleading-character-class
    narrow: /^[يفمئامئ‍ئاسۆند]/i,
    abbreviated: /^(يانۋار|فېۋىرال|مارت|ئاپرىل|ماي|ئىيۇن|ئىيول|ئاۋغۇست|سىنتەبىر|ئۆكتەبىر|نويابىر|دىكابىر)/i,
    wide: /^(يانۋار|فېۋىرال|مارت|ئاپرىل|ماي|ئىيۇن|ئىيول|ئاۋغۇست|سىنتەبىر|ئۆكتەبىر|نويابىر|دىكابىر)/i
};
var parseMonthPatterns = {
    narrow: [
        /^ي/i,
        /^ف/i,
        /^م/i,
        /^ا/i,
        /^م/i,
        /^ى‍/i,
        /^ى‍/i,
        /^ا‍/i,
        /^س/i,
        /^ۆ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^يان/i,
        /^فېۋ/i,
        /^مار/i,
        /^ئاپ/i,
        /^ماي/i,
        /^ئىيۇن/i,
        /^ئىيول/i,
        /^ئاۋ/i,
        /^سىن/i,
        /^ئۆك/i,
        /^نوي/i,
        /^دىك/i
    ]
};
var matchDayPatterns = {
    narrow: /^[دسچپجشي]/i,
    short: /^(يە|دۈ|سە|چا|پە|جۈ|شە)/i,
    abbreviated: /^(يە|دۈ|سە|چا|پە|جۈ|شە)/i,
    wide: /^(يەكشەنبە|دۈشەنبە|سەيشەنبە|چارشەنبە|پەيشەنبە|جۈمە|شەنبە)/i
};
var parseDayPatterns = {
    narrow: [
        /^ي/i,
        /^د/i,
        /^س/i,
        /^چ/i,
        /^پ/i,
        /^ج/i,
        /^ش/i
    ],
    any: [
        /^ي/i,
        /^د/i,
        /^س/i,
        /^چ/i,
        /^پ/i,
        /^ج/i,
        /^ش/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(ئە|چ|ك|چ|(دە|ئەتىگەن) ( ئە‍|چۈشتىن كىيىن|ئاخشىم|كىچە))/i,
    any: /^(ئە|چ|ك|چ|(دە|ئەتىگەن) ( ئە‍|چۈشتىن كىيىن|ئاخشىم|كىچە))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^ئە/i,
        pm: /^چ/i,
        midnight: /^ك/i,
        noon: /^چ/i,
        morning: /ئەتىگەن/i,
        afternoon: /چۈشتىن كىيىن/i,
        evening: /ئاخشىم/i,
        night: /كىچە/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"bW59P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Ukrainian locale.
 * @language Ukrainian
 * @iso-639-2 ukr
 * @author Andrii Korzh [@korzhyk]{@link https://github.com/korzhyk}
 * @author Andriy Shcherbyak [@shcherbyakdev]{@link https://github.com/shcherbyakdev}
 */ var locale = {
    code: 'uk',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"dy7Es","./_lib/formatLong/index.js":"3Mxdy","./_lib/formatRelative/index.js":"f36Vx","./_lib/localize/index.js":"KstfP","./_lib/match/index.js":"dV4uo","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"dy7Es":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function declension(scheme, count) {
    // scheme for count=1 exists
    if (scheme.one !== undefined && count === 1) return scheme.one;
    var rem10 = count % 10;
    var rem100 = count % 100;
    // 1, 21, 31, ...
    if (rem10 === 1 && rem100 !== 11) return scheme.singularNominative.replace('{{count}}', String(count));
    else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) return scheme.singularGenitive.replace('{{count}}', String(count));
    else return scheme.pluralGenitive.replace('{{count}}', String(count));
}
function buildLocalizeTokenFn(scheme) {
    return function(count, options) {
        if (options && options.addSuffix) {
            if (options.comparison && options.comparison > 0) {
                if (scheme.future) return declension(scheme.future, count);
                else return "\u0437\u0430 " + declension(scheme.regular, count);
            } else {
                if (scheme.past) return declension(scheme.past, count);
                else return declension(scheme.regular, count) + " \u0442\u043E\u043C\u0443";
            }
        } else return declension(scheme.regular, count);
    };
}
var halfAtMinute = function halfAtMinute(_, options) {
    if (options && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0437\u0430 \u043F\u0456\u0432\u0445\u0432\u0438\u043B\u0438\u043D\u0438";
        else return "\u043F\u0456\u0432\u0445\u0432\u0438\u043B\u0438\u043D\u0438 \u0442\u043E\u043C\u0443";
    }
    return "\u043F\u0456\u0432\u0445\u0432\u0438\u043B\u0438\u043D\u0438";
};
var formatDistanceLocale = {
    lessThanXSeconds: buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448\u0435 \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            singularNominative: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            singularGenitive: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434",
            pluralGenitive: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            pluralGenitive: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    xSeconds: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        past: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443 \u0442\u043E\u043C\u0443",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438 \u0442\u043E\u043C\u0443",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0442\u043E\u043C\u0443"
        },
        future: {
            singularNominative: "\u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            pluralGenitive: "\u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    halfAMinute: halfAtMinute,
    lessThanXMinutes: buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448\u0435 \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            singularNominative: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            singularGenitive: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D",
            pluralGenitive: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 \u0445\u0432\u0438\u043B\u0438\u043D\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            pluralGenitive: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D"
        }
    }),
    xMinutes: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0430",
            singularGenitive: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            pluralGenitive: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D"
        },
        past: {
            singularNominative: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0443 \u0442\u043E\u043C\u0443",
            singularGenitive: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438 \u0442\u043E\u043C\u0443",
            pluralGenitive: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D \u0442\u043E\u043C\u0443"
        },
        future: {
            singularNominative: "\u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0443",
            singularGenitive: "\u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            pluralGenitive: "\u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D"
        }
    }),
    aboutXHours: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0438",
            singularGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D",
            pluralGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0433\u043E\u0434\u0438\u043D\u0443",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0433\u043E\u0434\u0438\u043D"
        }
    }),
    xHours: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0443",
            singularGenitive: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0438",
            pluralGenitive: "{{count}} \u0433\u043E\u0434\u0438\u043D"
        }
    }),
    xDays: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0434\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0434\u043Di",
            pluralGenitive: "{{count}} \u0434\u043D\u0456\u0432"
        }
    }),
    aboutXWeeks: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0442\u0438\u0436\u043D\u044F",
            singularGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0442\u0438\u0436\u043D\u0456\u0432",
            pluralGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0442\u0438\u0436\u043D\u0456\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0442\u0438\u0436\u0434\u0435\u043D\u044C",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0442\u0438\u0436\u043D\u0456",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0442\u0438\u0436\u043D\u0456\u0432"
        }
    }),
    xWeeks: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0442\u0438\u0436\u0434\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0442\u0438\u0436\u043D\u0456",
            pluralGenitive: "{{count}} \u0442\u0438\u0436\u043D\u0456\u0432"
        }
    }),
    aboutXMonths: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u043C\u0456\u0441\u044F\u0446\u044F",
            singularGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u043C\u0456\u0441\u044F\u0446\u0456\u0432",
            pluralGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u043C\u0456\u0441\u044F\u0446\u0456\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u043C\u0456\u0441\u044F\u0446\u044C",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u043C\u0456\u0441\u044F\u0446\u0456",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u043C\u0456\u0441\u044F\u0446\u0456\u0432"
        }
    }),
    xMonths: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0456\u0441\u044F\u0446\u044C",
            singularGenitive: "{{count}} \u043C\u0456\u0441\u044F\u0446\u0456",
            pluralGenitive: "{{count}} \u043C\u0456\u0441\u044F\u0446\u0456\u0432"
        }
    }),
    aboutXYears: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0440\u043E\u043A\u0443",
            singularGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0440\u043E\u043A\u0456\u0432",
            pluralGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0440\u043E\u043A\u0456\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0440\u0456\u043A",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0440\u043E\u043A\u0456\u0432"
        }
    }),
    xYears: buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0440\u0456\u043A",
            singularGenitive: "{{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "{{count}} \u0440\u043E\u043A\u0456\u0432"
        }
    }),
    overXYears: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u0456\u043B\u044C\u0448\u0435 {{count}} \u0440\u043E\u043A\u0443",
            singularGenitive: "\u0431\u0456\u043B\u044C\u0448\u0435 {{count}} \u0440\u043E\u043A\u0456\u0432",
            pluralGenitive: "\u0431\u0456\u043B\u044C\u0448\u0435 {{count}} \u0440\u043E\u043A\u0456\u0432"
        },
        future: {
            singularNominative: "\u0431\u0456\u043B\u044C\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0440\u0456\u043A",
            singularGenitive: "\u0431\u0456\u043B\u044C\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "\u0431\u0456\u043B\u044C\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0440\u043E\u043A\u0456\u0432"
        }
    }),
    almostXYears: buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043C\u0430\u0439\u0436\u0435 {{count}} \u0440\u0456\u043A",
            singularGenitive: "\u043C\u0430\u0439\u0436\u0435 {{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "\u043C\u0430\u0439\u0436\u0435 {{count}} \u0440\u043E\u043A\u0456\u0432"
        },
        future: {
            singularNominative: "\u043C\u0430\u0439\u0436\u0435 \u0437\u0430 {{count}} \u0440\u0456\u043A",
            singularGenitive: "\u043C\u0430\u0439\u0436\u0435 \u0437\u0430 {{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "\u043C\u0430\u0439\u0436\u0435 \u0437\u0430 {{count}} \u0440\u043E\u043A\u0456\u0432"
        }
    })
};
var formatDistance = function formatDistance(token, count, options) {
    options = options || {};
    return formatDistanceLocale[token](count, options);
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3Mxdy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "EEEE, do MMMM y '\u0440.'",
    long: "do MMMM y '\u0440.'",
    medium: "d MMM y '\u0440.'",
    short: 'dd.MM.y'
};
var timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var dateTimeFormats = {
    full: "{{date}} '\u043E' {{time}}",
    long: "{{date}} '\u043E' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"f36Vx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../../index.js");
var _indexJs1 = require("../../../../_lib/isSameUTCWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs1);
var accusativeWeekdays = [
    "\u043D\u0435\u0434\u0456\u043B\u044E",
    "\u043F\u043E\u043D\u0435\u0434\u0456\u043B\u043E\u043A",
    "\u0432\u0456\u0432\u0442\u043E\u0440\u043E\u043A",
    "\u0441\u0435\u0440\u0435\u0434\u0443",
    "\u0447\u0435\u0442\u0432\u0435\u0440",
    "\u043F\u2019\u044F\u0442\u043D\u0438\u0446\u044E",
    "\u0441\u0443\u0431\u043E\u0442\u0443"
];
function lastWeek(day) {
    var weekday = accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043C\u0438\u043D\u0443\u043B\u0443 " + weekday + " \u043E' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043C\u0438\u043D\u0443\u043B\u0438\u0439 " + weekday + " \u043E' p";
    }
}
function thisWeek(day) {
    var weekday = accusativeWeekdays[day];
    return "'\u0443 " + weekday + " \u043E' p";
}
function nextWeek(day) {
    var weekday = accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0443 " + weekday + " \u043E' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0438\u0439 " + weekday + " \u043E' p";
    }
}
var lastWeekFormat = function lastWeekFormat(dirtyDate, baseDate, options) {
    var date = (0, _indexJs.toDate)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, _indexJsDefault.default)(date, baseDate, options)) return thisWeek(day);
    else return lastWeek(day);
};
var nextWeekFormat = function nextWeekFormat(dirtyDate, baseDate, options) {
    var date = (0, _indexJs.toDate)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, _indexJsDefault.default)(date, baseDate, options)) return thisWeek(day);
    else return nextWeek(day);
};
var formatRelativeLocale = {
    lastWeek: lastWeekFormat,
    yesterday: "'\u0432\u0447\u043E\u0440\u0430 \u043E' p",
    today: "'\u0441\u044C\u043E\u0433\u043E\u0434\u043D\u0456 \u043E' p",
    tomorrow: "'\u0437\u0430\u0432\u0442\u0440\u0430 \u043E' p",
    nextWeek: nextWeekFormat,
    other: 'P'
};
var formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
exports.default = formatRelative;

},{"../../../../index.js":"gBKRn","../../../../_lib/isSameUTCWeek/index.js":"g7rCW","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"KstfP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u0434\u043E \u043D.\u0435.",
        "\u043D.\u0435."
    ],
    abbreviated: [
        "\u0434\u043E \u043D. \u0435.",
        "\u043D. \u0435."
    ],
    wide: [
        "\u0434\u043E \u043D\u0430\u0448\u043E\u0457 \u0435\u0440\u0438",
        "\u043D\u0430\u0448\u043E\u0457 \u0435\u0440\u0438"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1-\u0439 \u043A\u0432.",
        "2-\u0439 \u043A\u0432.",
        "3-\u0439 \u043A\u0432.",
        "4-\u0439 \u043A\u0432."
    ],
    wide: [
        "1-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
var monthValues = {
    // ДСТУ 3582:2013
    narrow: [
        "\u0421",
        "\u041B",
        "\u0411",
        "\u041A",
        "\u0422",
        "\u0427",
        "\u041B",
        "\u0421",
        "\u0412",
        "\u0416",
        "\u041B",
        "\u0413"
    ],
    abbreviated: [
        "\u0441\u0456\u0447.",
        "\u043B\u044E\u0442.",
        "\u0431\u0435\u0440\u0435\u0437.",
        "\u043A\u0432\u0456\u0442.",
        "\u0442\u0440\u0430\u0432.",
        "\u0447\u0435\u0440\u0432.",
        "\u043B\u0438\u043F.",
        "\u0441\u0435\u0440\u043F.",
        "\u0432\u0435\u0440\u0435\u0441.",
        "\u0436\u043E\u0432\u0442.",
        "\u043B\u0438\u0441\u0442\u043E\u043F.",
        "\u0433\u0440\u0443\u0434."
    ],
    wide: [
        "\u0441\u0456\u0447\u0435\u043D\u044C",
        "\u043B\u044E\u0442\u0438\u0439",
        "\u0431\u0435\u0440\u0435\u0437\u0435\u043D\u044C",
        "\u043A\u0432\u0456\u0442\u0435\u043D\u044C",
        "\u0442\u0440\u0430\u0432\u0435\u043D\u044C",
        "\u0447\u0435\u0440\u0432\u0435\u043D\u044C",
        "\u043B\u0438\u043F\u0435\u043D\u044C",
        "\u0441\u0435\u0440\u043F\u0435\u043D\u044C",
        "\u0432\u0435\u0440\u0435\u0441\u0435\u043D\u044C",
        "\u0436\u043E\u0432\u0442\u0435\u043D\u044C",
        "\u043B\u0438\u0441\u0442\u043E\u043F\u0430\u0434",
        "\u0433\u0440\u0443\u0434\u0435\u043D\u044C"
    ]
};
var formattingMonthValues = {
    narrow: [
        "\u0421",
        "\u041B",
        "\u0411",
        "\u041A",
        "\u0422",
        "\u0427",
        "\u041B",
        "\u0421",
        "\u0412",
        "\u0416",
        "\u041B",
        "\u0413"
    ],
    abbreviated: [
        "\u0441\u0456\u0447.",
        "\u043B\u044E\u0442.",
        "\u0431\u0435\u0440\u0435\u0437.",
        "\u043A\u0432\u0456\u0442.",
        "\u0442\u0440\u0430\u0432.",
        "\u0447\u0435\u0440\u0432.",
        "\u043B\u0438\u043F.",
        "\u0441\u0435\u0440\u043F.",
        "\u0432\u0435\u0440\u0435\u0441.",
        "\u0436\u043E\u0432\u0442.",
        "\u043B\u0438\u0441\u0442\u043E\u043F.",
        "\u0433\u0440\u0443\u0434."
    ],
    wide: [
        "\u0441\u0456\u0447\u043D\u044F",
        "\u043B\u044E\u0442\u043E\u0433\u043E",
        "\u0431\u0435\u0440\u0435\u0437\u043D\u044F",
        "\u043A\u0432\u0456\u0442\u043D\u044F",
        "\u0442\u0440\u0430\u0432\u043D\u044F",
        "\u0447\u0435\u0440\u0432\u043D\u044F",
        "\u043B\u0438\u043F\u043D\u044F",
        "\u0441\u0435\u0440\u043F\u043D\u044F",
        "\u0432\u0435\u0440\u0435\u0441\u043D\u044F",
        "\u0436\u043E\u0432\u0442\u043D\u044F",
        "\u043B\u0438\u0441\u0442\u043E\u043F\u0430\u0434\u0430",
        "\u0433\u0440\u0443\u0434\u043D\u044F"
    ]
};
var dayValues = {
    narrow: [
        "\u041D",
        "\u041F",
        "\u0412",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u043D\u0434",
        "\u043F\u043D",
        "\u0432\u0442",
        "\u0441\u0440",
        "\u0447\u0442",
        "\u043F\u0442",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u043D\u0435\u0434",
        "\u043F\u043E\u043D",
        "\u0432\u0456\u0432",
        "\u0441\u0435\u0440",
        "\u0447\u0442\u0432",
        "\u043F\u0442\u043D",
        "\u0441\u0443\u0431"
    ],
    wide: [
        "\u043D\u0435\u0434\u0456\u043B\u044F",
        "\u043F\u043E\u043D\u0435\u0434\u0456\u043B\u043E\u043A",
        "\u0432\u0456\u0432\u0442\u043E\u0440\u043E\u043A",
        "\u0441\u0435\u0440\u0435\u0434\u0430",
        "\u0447\u0435\u0442\u0432\u0435\u0440",
        "\u043F\u2019\u044F\u0442\u043D\u0438\u0446\u044F",
        "\u0441\u0443\u0431\u043E\u0442\u0430"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D.",
        noon: "\u043F\u043E\u043B.",
        morning: "\u0440\u0430\u043D\u043E\u043A",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u0456\u0447"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D.",
        noon: "\u043F\u043E\u043B.",
        morning: "\u0440\u0430\u043D\u043E\u043A",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u0456\u0447"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D\u0456\u0447",
        noon: "\u043F\u043E\u043B\u0443\u0434\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u043E\u043A",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447\u0456\u0440",
        night: "\u043D\u0456\u0447"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D.",
        noon: "\u043F\u043E\u043B.",
        morning: "\u0440\u0430\u043D\u043A\u0443",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0456"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D.",
        noon: "\u043F\u043E\u043B.",
        morning: "\u0440\u0430\u043D\u043A\u0443",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0456"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D\u0456\u0447",
        noon: "\u043F\u043E\u043B\u0443\u0434\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u043A\u0443",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0456"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var unit = String(options === null || options === void 0 ? void 0 : options.unit);
    var number = Number(dirtyNumber);
    var suffix;
    if (unit === 'date') {
        if (number === 3 || number === 23) suffix = "-\u0454";
        else suffix = "-\u0435";
    } else if (unit === 'minute' || unit === 'second' || unit === 'hour') suffix = "-\u0430";
    else suffix = "-\u0439";
    return number + suffix;
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide',
        formattingValues: formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'any',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"dV4uo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(-?(е|й|є|а|я))?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^((до )?н\.?\s?е\.?)/i,
    abbreviated: /^((до )?н\.?\s?е\.?)/i,
    wide: /^(до нашої ери|нашої ери|наша ера)/i
};
var parseEraPatterns = {
    any: [
        /^д/i,
        /^н/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[иі]?й?)? кв.?/i,
    wide: /^[1234](-?[иі]?й?)? квартал/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[слбктчвжг]/i,
    abbreviated: /^(січ|лют|бер(ез)?|квіт|трав|черв|лип|серп|вер(ес)?|жовт|лис(топ)?|груд)\.?/i,
    wide: /^(січень|січня|лютий|лютого|березень|березня|квітень|квітня|травень|травня|червня|червень|липень|липня|серпень|серпня|вересень|вересня|жовтень|жовтня|листопад[а]?|грудень|грудня)/i
};
var parseMonthPatterns = {
    narrow: [
        /^с/i,
        /^л/i,
        /^б/i,
        /^к/i,
        /^т/i,
        /^ч/i,
        /^л/i,
        /^с/i,
        /^в/i,
        /^ж/i,
        /^л/i,
        /^г/i
    ],
    any: [
        /^сі/i,
        /^лю/i,
        /^б/i,
        /^к/i,
        /^т/i,
        /^ч/i,
        /^лип/i,
        /^се/i,
        /^в/i,
        /^ж/i,
        /^лис/i,
        /^г/i
    ]
};
var matchDayPatterns = {
    narrow: /^[нпвсч]/i,
    short: /^(нд|пн|вт|ср|чт|пт|сб)\.?/i,
    abbreviated: /^(нед|пон|вів|сер|че?тв|птн?|суб)\.?/i,
    wide: /^(неділ[яі]|понеділ[ок][ка]|вівтор[ок][ка]|серед[аи]|четвер(га)?|п\W*?ятниц[яі]|субот[аи])/i
};
var parseDayPatterns = {
    narrow: [
        /^н/i,
        /^п/i,
        /^в/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^н/i,
        /^п[он]/i,
        /^в/i,
        /^с[ер]/i,
        /^ч/i,
        /^п\W*?[ят]/i,
        /^с[уб]/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^([дп]п|півн\.?|пол\.?|ранок|ранку|день|дня|веч\.?|ніч|ночі)/i,
    abbreviated: /^([дп]п|півн\.?|пол\.?|ранок|ранку|день|дня|веч\.?|ніч|ночі)/i,
    wide: /^([дп]п|північ|полудень|ранок|ранку|день|дня|вечір|вечора|ніч|ночі)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^дп/i,
        pm: /^пп/i,
        midnight: /^півн/i,
        noon: /^пол/i,
        morning: /^р/i,
        afternoon: /^д[ен]/i,
        evening: /^в/i,
        night: /^н/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7nwJh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Uzbek locale.
 * @language Uzbek
 * @iso-639-2 uzb
 * @author Mukhammadali [@mukhammadali]{@link https://github.com/Mukhammadali}
 */ var locale = {
    code: 'uz',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"fKiWC","./_lib/formatLong/index.js":"iaw9q","./_lib/formatRelative/index.js":"2bhwC","./_lib/localize/index.js":"gHnyA","./_lib/match/index.js":"8QmiY","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"fKiWC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'sekunddan kam',
        other: '{{count}} sekunddan kam'
    },
    xSeconds: {
        one: '1 sekund',
        other: '{{count}} sekund'
    },
    halfAMinute: 'yarim minut',
    lessThanXMinutes: {
        one: 'bir minutdan kam',
        other: '{{count}} minutdan kam'
    },
    xMinutes: {
        one: '1 minut',
        other: '{{count}} minut'
    },
    aboutXHours: {
        one: 'tahminan 1 soat',
        other: 'tahminan {{count}} soat'
    },
    xHours: {
        one: '1 soat',
        other: '{{count}} soat'
    },
    xDays: {
        one: '1 kun',
        other: '{{count}} kun'
    },
    aboutXWeeks: {
        one: 'tahminan 1 hafta',
        other: 'tahminan {{count}} hafta'
    },
    xWeeks: {
        one: '1 hafta',
        other: '{{count}} hafta'
    },
    aboutXMonths: {
        one: 'tahminan 1 oy',
        other: 'tahminan {{count}} oy'
    },
    xMonths: {
        one: '1 oy',
        other: '{{count}} oy'
    },
    aboutXYears: {
        one: 'tahminan 1 yil',
        other: 'tahminan {{count}} yil'
    },
    xYears: {
        one: '1 yil',
        other: '{{count}} yil'
    },
    overXYears: {
        one: "1 yildan ko'p",
        other: "{{count}} yildan ko'p"
    },
    almostXYears: {
        one: 'deyarli 1 yil',
        other: 'deyarli {{count}} yil'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + ' dan keyin';
        else return result + ' oldin';
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"iaw9q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, do MMMM, y',
    long: 'do MMMM, y',
    medium: 'd MMM, y',
    short: 'dd/MM/yyyy'
};
var timeFormats = {
    full: 'h:mm:ss zzzz',
    long: 'h:mm:ss z',
    medium: 'h:mm:ss',
    short: 'h:mm'
};
var dateTimeFormats = {
    any: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'any'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2bhwC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'oldingi' eeee p 'da'",
    yesterday: "'kecha' p 'da'",
    today: "'bugun' p 'da'",
    tomorrow: "'ertaga' p 'da'",
    nextWeek: "eeee p 'da'",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gHnyA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'M.A',
        'M.'
    ],
    abbreviated: [
        'M.A',
        'M.'
    ],
    wide: [
        'Miloddan Avvalgi',
        'Milodiy'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'CH.1',
        'CH.2',
        'CH.3',
        'CH.4'
    ],
    wide: [
        '1-chi chorak',
        '2-chi chorak',
        '3-chi chorak',
        '4-chi chorak'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
    narrow: [
        'Y',
        'F',
        'M',
        'A',
        'M',
        'I',
        'I',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Yan',
        'Fev',
        'Mar',
        'Apr',
        'May',
        'Iyun',
        'Iyul',
        'Avg',
        'Sen',
        'Okt',
        'Noy',
        'Dek'
    ],
    wide: [
        'Yanvar',
        'Fevral',
        'Mart',
        'Aprel',
        'May',
        'Iyun',
        'Iyul',
        'Avgust',
        'Sentabr',
        'Oktabr',
        'Noyabr',
        'Dekabr'
    ]
};
var dayValues = {
    narrow: [
        'Y',
        'D',
        'S',
        'CH',
        'P',
        'J',
        'SH'
    ],
    short: [
        'Ya',
        'Du',
        'Se',
        'Cho',
        'Pa',
        'Ju',
        'Sha'
    ],
    abbreviated: [
        'Yak',
        'Dush',
        'Sesh',
        'Chor',
        'Pay',
        'Jum',
        'Shan'
    ],
    wide: [
        'Yakshanba',
        'Dushanba',
        'Seshanba',
        'Chorshanba',
        'Payshanba',
        'Juma',
        'Shanba'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'y.t',
        noon: 'p.',
        morning: 'ertalab',
        afternoon: 'tushdan keyin',
        evening: 'kechqurun',
        night: 'tun'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'yarim tun',
        noon: 'peshin',
        morning: 'ertalab',
        afternoon: 'tushdan keyin',
        evening: 'kechqurun',
        night: 'tun'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'yarim tun',
        noon: 'peshin',
        morning: 'ertalab',
        afternoon: 'tushdan keyin',
        evening: 'kechqurun',
        night: 'tun'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'y.t',
        noon: 'p.',
        morning: 'ertalab',
        afternoon: 'tushdan keyin',
        evening: 'kechqurun',
        night: 'tun'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'yarim tun',
        noon: 'peshin',
        morning: 'ertalab',
        afternoon: 'tushdan keyin',
        evening: 'kechqurun',
        night: 'tun'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'yarim tun',
        noon: 'peshin',
        morning: 'ertalab',
        afternoon: 'tushdan keyin',
        evening: 'kechqurun',
        night: 'tun'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8QmiY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(chi)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(m\.a|m\.)/i,
    abbreviated: /^(m\.a\.?\s?m\.?)/i,
    wide: /^(miloddan avval|miloddan keyin)/i
};
var parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](chi)? chorak/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[yfmasond]/i,
    abbreviated: /^(yan|fev|mar|apr|may|iyun|iyul|avg|sen|okt|noy|dek)/i,
    wide: /^(yanvar|fevral|mart|aprel|may|iyun|iyul|avgust|sentabr|oktabr|noyabr|dekabr)/i
};
var parseMonthPatterns = {
    narrow: [
        /^y/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^i/i,
        /^i/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ya/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^iyun/i,
        /^iyul/i,
        /^av/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[ydschj]/i,
    short: /^(ya|du|se|cho|pa|ju|sha)/i,
    abbreviated: /^(yak|dush|sesh|chor|pay|jum|shan)/i,
    wide: /^(yakshanba|dushanba|seshanba|chorshanba|payshanba|juma|shanba)/i
};
var parseDayPatterns = {
    narrow: [
        /^y/i,
        /^d/i,
        /^s/i,
        /^ch/i,
        /^p/i,
        /^j/i,
        /^sh/i
    ],
    any: [
        /^ya/i,
        /^d/i,
        /^se/i,
        /^ch/i,
        /^p/i,
        /^j/i,
        /^sh/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|y\.t|p| (ertalab|tushdan keyin|kechqurun|tun))/i,
    any: /^([ap]\.?\s?m\.?|yarim tun|peshin| (ertalab|tushdan keyin|kechqurun|tun))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^y\.t/i,
        noon: /^pe/i,
        morning: /ertalab/i,
        afternoon: /tushdan keyin/i,
        evening: /kechqurun/i,
        night: /tun/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"9d28A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Uzbek Cyrillic locale.
 * @language Uzbek
 * @iso-639-2 uzb
 * @author Kamronbek Shodmonov [@kamronbek28]{@link https://github.com/kamronbek28}
 */ var locale = {
    code: 'uz-Cyrl',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"zWDDU","./_lib/formatLong/index.js":"9PEtE","./_lib/formatRelative/index.js":"4hOJr","./_lib/localize/index.js":"7htAs","./_lib/match/index.js":"lTom5","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"zWDDU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "1 \u0441\u043E\u043D\u0438\u044F\u0434\u0430\u043D \u043A\u0430\u043C",
        other: "{{count}} \u0441\u043E\u043D\u0438\u044F\u0434\u0430\u043D \u043A\u0430\u043C"
    },
    xSeconds: {
        one: "1 \u0441\u043E\u043D\u0438\u044F",
        other: "{{count}} \u0441\u043E\u043D\u0438\u044F"
    },
    halfAMinute: "\u044F\u0440\u0438\u043C \u0434\u0430\u049B\u0438\u049B\u0430",
    lessThanXMinutes: {
        one: "1 \u0434\u0430\u049B\u0438\u049B\u0430\u0434\u0430\u043D \u043A\u0430\u043C",
        other: "{{count}} \u0434\u0430\u049B\u0438\u049B\u0430\u0434\u0430\u043D \u043A\u0430\u043C"
    },
    xMinutes: {
        one: "1 \u0434\u0430\u049B\u0438\u049B\u0430",
        other: "{{count}} \u0434\u0430\u049B\u0438\u049B\u0430"
    },
    aboutXHours: {
        one: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D 1 \u0441\u043E\u0430\u0442",
        other: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D {{count}} \u0441\u043E\u0430\u0442"
    },
    xHours: {
        one: "1 \u0441\u043E\u0430\u0442",
        other: "{{count}} \u0441\u043E\u0430\u0442"
    },
    xDays: {
        one: "1 \u043A\u0443\u043D",
        other: "{{count}} \u043A\u0443\u043D"
    },
    aboutXWeeks: {
        one: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D 1 \u0445\u0430\u0444\u0442\u0430",
        other: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D {{count}} \u0445\u0430\u0444\u0442\u0430"
    },
    xWeeks: {
        one: "1 \u0445\u0430\u0444\u0442\u0430",
        other: "{{count}} \u0445\u0430\u0444\u0442\u0430"
    },
    aboutXMonths: {
        one: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D 1 \u043E\u0439",
        other: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D {{count}} \u043E\u0439"
    },
    xMonths: {
        one: "1 \u043E\u0439",
        other: "{{count}} \u043E\u0439"
    },
    aboutXYears: {
        one: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D 1 \u0439\u0438\u043B",
        other: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D {{count}} \u0439\u0438\u043B"
    },
    xYears: {
        one: "1 \u0439\u0438\u043B",
        other: "{{count}} \u0439\u0438\u043B"
    },
    overXYears: {
        one: "1 \u0439\u0438\u043B\u0434\u0430\u043D \u043A\u045E\u043F",
        other: "{{count}} \u0439\u0438\u043B\u0434\u0430\u043D \u043A\u045E\u043F"
    },
    almostXYears: {
        one: "\u0434\u0435\u044F\u0440\u043B\u0438 1 \u0439\u0438\u043B",
        other: "\u0434\u0435\u044F\u0440\u043B\u0438 {{count}} \u0439\u0438\u043B"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u0434\u0430\u043D \u043A\u0435\u0439\u0438\u043D";
        else return result + " \u043E\u043B\u0434\u0438\u043D";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"9PEtE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, do MMMM, y',
    long: 'do MMMM, y',
    medium: 'd MMM, y',
    short: 'dd/MM/yyyy'
};
var timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var dateTimeFormats = {
    any: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'any'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4hOJr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'\u045E\u0442\u0433\u0430\u043D' eeee p '\u0434\u0430'",
    yesterday: "'\u043A\u0435\u0447\u0430' p '\u0434\u0430'",
    today: "'\u0431\u0443\u0433\u0443\u043D' p '\u0434\u0430'",
    tomorrow: "'\u044D\u0440\u0442\u0430\u0433\u0430' p '\u0434\u0430'",
    nextWeek: "eeee p '\u0434\u0430'",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7htAs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u041C.\u0410",
        "\u041C"
    ],
    abbreviated: [
        "\u041C.\u0410",
        "\u041C"
    ],
    wide: [
        "\u041C\u0438\u043B\u043E\u0434\u0434\u0430\u043D \u0410\u0432\u0432\u0430\u043B\u0433\u0438",
        "\u041C\u0438\u043B\u043E\u0434\u0438\u0439"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1-\u0447\u043E\u0440.",
        "2-\u0447\u043E\u0440.",
        "3-\u0447\u043E\u0440.",
        "4-\u0447\u043E\u0440."
    ],
    wide: [
        "1-\u0447\u043E\u0440\u0430\u043A",
        "2-\u0447\u043E\u0440\u0430\u043A",
        "3-\u0447\u043E\u0440\u0430\u043A",
        "4-\u0447\u043E\u0440\u0430\u043A"
    ]
};
var monthValues = {
    narrow: [
        "\u042F",
        "\u0424",
        "\u041C",
        "\u0410",
        "\u041C",
        "\u0418",
        "\u0418",
        "\u0410",
        "\u0421",
        "\u041E",
        "\u041D",
        "\u0414"
    ],
    abbreviated: [
        "\u044F\u043D\u0432",
        "\u0444\u0435\u0432",
        "\u043C\u0430\u0440",
        "\u0430\u043F\u0440",
        "\u043C\u0430\u0439",
        "\u0438\u044E\u043D",
        "\u0438\u044E\u043B",
        "\u0430\u0432\u0433",
        "\u0441\u0435\u043D",
        "\u043E\u043A\u0442",
        "\u043D\u043E\u044F",
        "\u0434\u0435\u043A"
    ],
    wide: [
        "\u044F\u043D\u0432\u0430\u0440",
        "\u0444\u0435\u0432\u0440\u0430\u043B",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0435\u043B",
        "\u043C\u0430\u0439",
        "\u0438\u044E\u043D",
        "\u0438\u044E\u043B",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043D\u0442\u0430\u0431\u0440",
        "\u043E\u043A\u0442\u0430\u0431\u0440",
        "\u043D\u043E\u044F\u0431\u0440",
        "\u0434\u0435\u043A\u0430\u0431\u0440"
    ]
};
var dayValues = {
    narrow: [
        "\u042F",
        "\u0414",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0416",
        "\u0428"
    ],
    short: [
        "\u044F\u043A",
        "\u0434\u0443",
        "\u0441\u0435",
        "\u0447\u043E",
        "\u043F\u0430",
        "\u0436\u0443",
        "\u0448\u0430"
    ],
    abbreviated: [
        "\u044F\u043A\u0448",
        "\u0434\u0443\u0448",
        "\u0441\u0435\u0448",
        "\u0447\u043E\u0440",
        "\u043F\u0430\u0439",
        "\u0436\u0443\u043C",
        "\u0448\u0430\u043D"
    ],
    wide: [
        "\u044F\u043A\u0448\u0430\u043D\u0431\u0430",
        "\u0434\u0443\u0448\u0430\u043D\u0431\u0430",
        "\u0441\u0435\u0448\u0430\u043D\u0431\u0430",
        "\u0447\u043E\u0440\u0448\u0430\u043D\u0431\u0430",
        "\u043F\u0430\u0439\u0448\u0430\u043D\u0431\u0430",
        "\u0436\u0443\u043C\u0430",
        "\u0448\u0430\u043D\u0431\u0430"
    ]
};
var dayPeriodValues = {
    any: {
        am: "\u041F.\u041E.",
        pm: "\u041F.\u041A.",
        midnight: "\u044F\u0440\u0438\u043C \u0442\u0443\u043D",
        noon: "\u043F\u0435\u0448\u0438\u043D",
        morning: "\u044D\u0440\u0442\u0430\u043B\u0430\u0431",
        afternoon: "\u043F\u0435\u0448\u0438\u043D\u0434\u0430\u043D \u043A\u0435\u0439\u0438\u043D",
        evening: "\u043A\u0435\u0447\u0430\u0441\u0438",
        night: "\u0442\u0443\u043D"
    }
};
var formattingDayPeriodValues = {
    any: {
        am: "\u041F.\u041E.",
        pm: "\u041F.\u041A.",
        midnight: "\u044F\u0440\u0438\u043C \u0442\u0443\u043D",
        noon: "\u043F\u0435\u0448\u0438\u043D",
        morning: "\u044D\u0440\u0442\u0430\u043B\u0430\u0431",
        afternoon: "\u043F\u0435\u0448\u0438\u043D\u0434\u0430\u043D \u043A\u0435\u0439\u0438\u043D",
        evening: "\u043A\u0435\u0447\u0430\u0441\u0438",
        night: "\u0442\u0443\u043D"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'any',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'any'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"lTom5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(чи)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(м\.а|м\.)/i,
    abbreviated: /^(м\.а|м\.)/i,
    wide: /^(милоддан аввал|милоддан кейин)/i
};
var parseEraPatterns = {
    any: [
        /^м/i,
        /^а/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]-чор./i,
    wide: /^[1234]-чорак/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[яфмамииасонд]/i,
    abbreviated: /^(янв|фев|мар|апр|май|июн|июл|авг|сен|окт|ноя|дек)/i,
    wide: /^(январ|феврал|март|апрел|май|июн|июл|август|сентабр|октабр|ноябр|декабр)/i
};
var parseMonthPatterns = {
    narrow: [
        /^я/i,
        /^ф/i,
        /^м/i,
        /^а/i,
        /^м/i,
        /^и/i,
        /^и/i,
        /^а/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^д/i
    ],
    any: [
        /^я/i,
        /^ф/i,
        /^мар/i,
        /^ап/i,
        /^май/i,
        /^июн/i,
        /^июл/i,
        /^ав/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^д/i
    ]
};
var matchDayPatterns = {
    narrow: /^[ядсчпжш]/i,
    short: /^(як|ду|се|чо|па|жу|ша)/i,
    abbreviated: /^(якш|душ|сеш|чор|пай|жум|шан)/i,
    wide: /^(якшанба|душанба|сешанба|чоршанба|пайшанба|жума|шанба)/i
};
var parseDayPatterns = {
    narrow: [
        /^я/i,
        /^д/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^ж/i,
        /^ш/i
    ],
    any: [
        /^як/i,
        /^ду/i,
        /^се/i,
        /^чор/i,
        /^пай/i,
        /^жу/i,
        /^шан/i
    ]
};
var matchDayPeriodPatterns = {
    any: /^(п\.о\.|п\.к\.|ярим тун|пешиндан кейин|(эрталаб|пешиндан кейин|кечаси|тун))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^п\.о\./i,
        pm: /^п\.к\./i,
        midnight: /^ярим тун/i,
        noon: /^пешиндан кейин/i,
        morning: /эрталаб/i,
        afternoon: /пешиндан кейин/i,
        evening: /кечаси/i,
        night: /тун/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"bjl72":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Vietnamese locale (Vietnam).
 * @language Vietnamese
 * @iso-639-2 vie
 * @author Thanh Tran [@trongthanh]{@link https://github.com/trongthanh}
 * @author Leroy Hopson [@lihop]{@link https://github.com/lihop}
 */ var locale = {
    code: 'vi',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1 /* First week of new year contains Jan 1st  */ 
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"3qdrn","./_lib/formatLong/index.js":"fAVdx","./_lib/formatRelative/index.js":"iNxhT","./_lib/localize/index.js":"aabu5","./_lib/match/index.js":"5XI5L","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3qdrn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "d\u01B0\u1EDBi 1 gi\xe2y",
        other: "d\u01B0\u1EDBi {{count}} gi\xe2y"
    },
    xSeconds: {
        one: "1 gi\xe2y",
        other: "{{count}} gi\xe2y"
    },
    halfAMinute: "n\u1EEDa ph\xfat",
    lessThanXMinutes: {
        one: "d\u01B0\u1EDBi 1 ph\xfat",
        other: "d\u01B0\u1EDBi {{count}} ph\xfat"
    },
    xMinutes: {
        one: "1 ph\xfat",
        other: "{{count}} ph\xfat"
    },
    aboutXHours: {
        one: "kho\u1EA3ng 1 gi\u1EDD",
        other: "kho\u1EA3ng {{count}} gi\u1EDD"
    },
    xHours: {
        one: "1 gi\u1EDD",
        other: "{{count}} gi\u1EDD"
    },
    xDays: {
        one: "1 ng\xe0y",
        other: "{{count}} ng\xe0y"
    },
    aboutXWeeks: {
        one: "kho\u1EA3ng 1 tu\u1EA7n",
        other: "kho\u1EA3ng {{count}} tu\u1EA7n"
    },
    xWeeks: {
        one: "1 tu\u1EA7n",
        other: "{{count}} tu\u1EA7n"
    },
    aboutXMonths: {
        one: "kho\u1EA3ng 1 th\xe1ng",
        other: "kho\u1EA3ng {{count}} th\xe1ng"
    },
    xMonths: {
        one: "1 th\xe1ng",
        other: "{{count}} th\xe1ng"
    },
    aboutXYears: {
        one: "kho\u1EA3ng 1 n\u0103m",
        other: "kho\u1EA3ng {{count}} n\u0103m"
    },
    xYears: {
        one: "1 n\u0103m",
        other: "{{count}} n\u0103m"
    },
    overXYears: {
        one: "h\u01A1n 1 n\u0103m",
        other: "h\u01A1n {{count}} n\u0103m"
    },
    almostXYears: {
        one: "g\u1EA7n 1 n\u0103m",
        other: "g\u1EA7n {{count}} n\u0103m"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " n\u1EEFa";
        else return result + " tr\u01B0\u1EDBc";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"fAVdx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    // thứ Sáu, ngày 25 tháng 08 năm 2017
    full: "EEEE, 'ng\xe0y' d MMMM 'n\u0103m' y",
    // ngày 25 tháng 08 năm 2017
    long: "'ng\xe0y' d MMMM 'n\u0103m' y",
    // 25 thg 08 năm 2017
    medium: "d MMM 'n\u0103m' y",
    // 25/08/2017
    short: 'dd/MM/y'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    // thứ Sáu, ngày 25 tháng 08 năm 2017 23:25:59
    full: '{{date}} {{time}}',
    // ngày 25 tháng 08 năm 2017 23:25
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"iNxhT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "eeee 'tu\u1EA7n tr\u01B0\u1EDBc v\xe0o l\xfac' p",
    yesterday: "'h\xf4m qua v\xe0o l\xfac' p",
    today: "'h\xf4m nay v\xe0o l\xfac' p",
    tomorrow: "'ng\xe0y mai v\xe0o l\xfac' p",
    nextWeek: "eeee 't\u1EDBi v\xe0o l\xfac' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"aabu5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js"); // Vietnamese locale reference: http://www.localeplanet.com/icu/vi-VN/index.html
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
// Capitalization reference: http://hcmup.edu.vn/index.php?option=com_content&view=article&id=4106%3Avit-hoa-trong-vn-bn-hanh-chinh&catid=2345%3Atham-kho&Itemid=4103&lang=vi&site=134
var eraValues = {
    narrow: [
        'TCN',
        'SCN'
    ],
    abbreviated: [
        "tr\u01B0\u1EDBc CN",
        'sau CN'
    ],
    wide: [
        "tr\u01B0\u1EDBc C\xf4ng Nguy\xean",
        "sau C\xf4ng Nguy\xean"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "Qu\xfd 1",
        "Qu\xfd 2",
        "Qu\xfd 3",
        "Qu\xfd 4"
    ]
};
var formattingQuarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    // I notice many news outlet use this "quý II/2018"
    wide: [
        "qu\xfd I",
        "qu\xfd II",
        "qu\xfd III",
        "qu\xfd IV"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10',
        '11',
        '12'
    ],
    abbreviated: [
        'Thg 1',
        'Thg 2',
        'Thg 3',
        'Thg 4',
        'Thg 5',
        'Thg 6',
        'Thg 7',
        'Thg 8',
        'Thg 9',
        'Thg 10',
        'Thg 11',
        'Thg 12'
    ],
    wide: [
        "Th\xe1ng M\u1ED9t",
        "Th\xe1ng Hai",
        "Th\xe1ng Ba",
        "Th\xe1ng T\u01B0",
        "Th\xe1ng N\u0103m",
        "Th\xe1ng S\xe1u",
        "Th\xe1ng B\u1EA3y",
        "Th\xe1ng T\xe1m",
        "Th\xe1ng Ch\xedn",
        "Th\xe1ng M\u01B0\u1EDDi",
        "Th\xe1ng M\u01B0\u1EDDi M\u1ED9t",
        "Th\xe1ng M\u01B0\u1EDDi Hai"
    ]
};
// In Vietnamese date formatting, month number less than 10 expected to have leading zero
var formattingMonthValues = {
    narrow: [
        '01',
        '02',
        '03',
        '04',
        '05',
        '06',
        '07',
        '08',
        '09',
        '10',
        '11',
        '12'
    ],
    abbreviated: [
        'thg 1',
        'thg 2',
        'thg 3',
        'thg 4',
        'thg 5',
        'thg 6',
        'thg 7',
        'thg 8',
        'thg 9',
        'thg 10',
        'thg 11',
        'thg 12'
    ],
    wide: [
        "th\xe1ng 01",
        "th\xe1ng 02",
        "th\xe1ng 03",
        "th\xe1ng 04",
        "th\xe1ng 05",
        "th\xe1ng 06",
        "th\xe1ng 07",
        "th\xe1ng 08",
        "th\xe1ng 09",
        "th\xe1ng 10",
        "th\xe1ng 11",
        "th\xe1ng 12"
    ]
};
var dayValues = {
    narrow: [
        'CN',
        'T2',
        'T3',
        'T4',
        'T5',
        'T6',
        'T7'
    ],
    short: [
        'CN',
        'Th 2',
        'Th 3',
        'Th 4',
        'Th 5',
        'Th 6',
        'Th 7'
    ],
    abbreviated: [
        'CN',
        "Th\u1EE9 2",
        "Th\u1EE9 3",
        "Th\u1EE9 4",
        "Th\u1EE9 5",
        "Th\u1EE9 6",
        "Th\u1EE9 7"
    ],
    wide: [
        "Ch\u1EE7 Nh\u1EADt",
        "Th\u1EE9 Hai",
        "Th\u1EE9 Ba",
        "Th\u1EE9 T\u01B0",
        "Th\u1EE9 N\u0103m",
        "Th\u1EE9 S\xe1u",
        "Th\u1EE9 B\u1EA3y"
    ]
};
// Vietnamese are used to AM/PM borrowing from English, hence `narrow` and
// `abbreviated` are just like English but I'm leaving the `wide`
// format being localized with abbreviations found in some systems (SÁng / CHiều);
// however, personally, I don't think `Chiều` sounds appropriate for `PM`
var dayPeriodValues = {
    // narrow date period is extremely rare in Vietnamese
    // I used abbreviated form for noon, morning and afternoon
    // which are regconizable by Vietnamese, others cannot be any shorter
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: "n\u1EEDa \u0111\xeam",
        noon: 'tr',
        morning: 'sg',
        afternoon: 'ch',
        evening: "t\u1ED1i",
        night: "\u0111\xeam"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "n\u1EEDa \u0111\xeam",
        noon: "tr\u01B0a",
        morning: "s\xe1ng",
        afternoon: "chi\u1EC1u",
        evening: "t\u1ED1i",
        night: "\u0111\xeam"
    },
    wide: {
        am: 'SA',
        pm: 'CH',
        midnight: "n\u1EEDa \u0111\xeam",
        noon: "tr\u01B0a",
        morning: "s\xe1ng",
        afternoon: "chi\u1EC1u",
        evening: "t\u1ED1i",
        night: "\u0111\xeam"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: "n\u1EEDa \u0111\xeam",
        noon: 'tr',
        morning: 'sg',
        afternoon: 'ch',
        evening: "t\u1ED1i",
        night: "\u0111\xeam"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "n\u1EEDa \u0111\xeam",
        noon: "tr\u01B0a",
        morning: "s\xe1ng",
        afternoon: "chi\u1EC1u",
        evening: "t\u1ED1i",
        night: "\u0111\xeam"
    },
    wide: {
        am: 'SA',
        pm: 'CH',
        midnight: "n\u1EEDa \u0111\xeam",
        noon: "gi\u1EEFa tr\u01B0a",
        morning: "v\xe0o bu\u1ED5i s\xe1ng",
        afternoon: "v\xe0o bu\u1ED5i chi\u1EC1u",
        evening: "v\xe0o bu\u1ED5i t\u1ED1i",
        night: "v\xe0o ban \u0111\xeam"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    if (unit === 'quarter') // many news outlets use "quý I"...
    switch(number){
        case 1:
            return 'I';
        case 2:
            return 'II';
        case 3:
            return 'III';
        case 4:
            return 'IV';
    }
    else if (unit === 'day') // day of week in Vietnamese has ordinal number meaning,
    // so we should use them, else it'll sound weird
    switch(number){
        case 1:
            return "th\u1EE9 2";
        // meaning 2nd day but it's the first day of the week :D
        case 2:
            return "th\u1EE9 3";
        // meaning 3rd day
        case 3:
            return "th\u1EE9 4";
        // meaning 4th day and so on
        case 4:
            return "th\u1EE9 5";
        case 5:
            return "th\u1EE9 6";
        case 6:
            return "th\u1EE9 7";
        case 7:
            return "ch\u1EE7 nh\u1EADt";
    }
    else if (unit === 'week') {
        if (number === 1) return "th\u1EE9 nh\u1EA5t";
        else return "th\u1EE9 " + number;
    } else if (unit === 'dayOfYear') {
        if (number === 1) return "\u0111\u1EA7u ti\xean";
        else return "th\u1EE9 " + number;
    }
    // there are no different forms of ordinal numbers in Vietnamese
    return String(number);
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        formattingValues: formattingQuarterValues,
        defaultFormattingWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide',
        formattingValues: formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5XI5L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(tcn|scn)/i,
    abbreviated: /^(trước CN|sau CN)/i,
    wide: /^(trước Công Nguyên|sau Công Nguyên)/i
};
var parseEraPatterns = {
    any: [
        /^t/i,
        /^s/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^([1234]|i{1,3}v?)/i,
    abbreviated: /^q([1234]|i{1,3}v?)/i,
    wide: /^quý ([1234]|i{1,3}v?)/i
};
var parseQuarterPatterns = {
    any: [
        /(1|i)$/i,
        /(2|ii)$/i,
        /(3|iii)$/i,
        /(4|iv)$/i
    ]
};
var matchMonthPatterns = {
    // month number may contain leading 0, 'thg' prefix may have space, underscore or empty before number
    // note the order of '1' since it is a sub-string of '10', so must be lower priority
    narrow: /^(0?[2-9]|10|11|12|0?1)/i,
    // note the order of 'thg 1' since it is sub-string of 'thg 10', so must be lower priority
    abbreviated: /^thg[ _]?(0?[1-9](?!\d)|10|11|12)/i,
    // note the order of 'Mười' since it is sub-string of Mười Một, so must be lower priority
    wide: /^tháng ?(Một|Hai|Ba|Tư|Năm|Sáu|Bảy|Tám|Chín|Mười|Mười ?Một|Mười ?Hai|0?[1-9](?!\d)|10|11|12)/i
};
var parseMonthPatterns = {
    narrow: [
        /0?1$/i,
        /0?2/i,
        /3/,
        /4/,
        /5/,
        /6/,
        /7/,
        /8/,
        /9/,
        /10/,
        /11/,
        /12/
    ],
    abbreviated: [
        /^thg[ _]?0?1(?!\d)/i,
        /^thg[ _]?0?2/i,
        /^thg[ _]?0?3/i,
        /^thg[ _]?0?4/i,
        /^thg[ _]?0?5/i,
        /^thg[ _]?0?6/i,
        /^thg[ _]?0?7/i,
        /^thg[ _]?0?8/i,
        /^thg[ _]?0?9/i,
        /^thg[ _]?10/i,
        /^thg[ _]?11/i,
        /^thg[ _]?12/i
    ],
    wide: [
        /^tháng ?(Một|0?1(?!\d))/i,
        /^tháng ?(Hai|0?2)/i,
        /^tháng ?(Ba|0?3)/i,
        /^tháng ?(Tư|0?4)/i,
        /^tháng ?(Năm|0?5)/i,
        /^tháng ?(Sáu|0?6)/i,
        /^tháng ?(Bảy|0?7)/i,
        /^tháng ?(Tám|0?8)/i,
        /^tháng ?(Chín|0?9)/i,
        /^tháng ?(Mười|10)/i,
        /^tháng ?(Mười ?Một|11)/i,
        /^tháng ?(Mười ?Hai|12)/i
    ]
};
var matchDayPatterns = {
    narrow: /^(CN|T2|T3|T4|T5|T6|T7)/i,
    short: /^(CN|Th ?2|Th ?3|Th ?4|Th ?5|Th ?6|Th ?7)/i,
    abbreviated: /^(CN|Th ?2|Th ?3|Th ?4|Th ?5|Th ?6|Th ?7)/i,
    wide: /^(Chủ ?Nhật|Chúa ?Nhật|thứ ?Hai|thứ ?Ba|thứ ?Tư|thứ ?Năm|thứ ?Sáu|thứ ?Bảy)/i
};
var parseDayPatterns = {
    narrow: [
        /CN/i,
        /2/i,
        /3/i,
        /4/i,
        /5/i,
        /6/i,
        /7/i
    ],
    short: [
        /CN/i,
        /2/i,
        /3/i,
        /4/i,
        /5/i,
        /6/i,
        /7/i
    ],
    abbreviated: [
        /CN/i,
        /2/i,
        /3/i,
        /4/i,
        /5/i,
        /6/i,
        /7/i
    ],
    wide: [
        /(Chủ|Chúa) ?Nhật/i,
        /Hai/i,
        /Ba/i,
        /Tư/i,
        /Năm/i,
        /Sáu/i,
        /Bảy/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i,
    abbreviated: /^(am|pm|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i,
    wide: /^(ch[^i]*|sa|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^(a|sa)/i,
        pm: /^(p|ch[^i]*)/i,
        midnight: /nửa đêm/i,
        noon: /trưa/i,
        morning: /sáng/i,
        afternoon: /chiều/i,
        evening: /tối/i,
        night: /^đêm/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jdMw9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Chinese Simplified locale.
 * @language Chinese Simplified
 * @iso-639-2 zho
 * @author Changyu Geng [@KingMario]{@link https://github.com/KingMario}
 * @author Song Shuoyun [@fnlctrl]{@link https://github.com/fnlctrl}
 * @author sabrinaM [@sabrinamiao]{@link https://github.com/sabrinamiao}
 * @author Carney Wu [@cubicwork]{@link https://github.com/cubicwork}
 * @author Terrence Lam [@skyuplam]{@link https://github.com/skyuplam}
 */ var locale = {
    code: 'zh-CN',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"3jnnw","./_lib/formatLong/index.js":"gXYry","./_lib/formatRelative/index.js":"E35CH","./_lib/localize/index.js":"5CFMg","./_lib/match/index.js":"dkeHA","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3jnnw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u4E0D\u5230 1 \u79D2",
        other: "\u4E0D\u5230 {{count}} \u79D2"
    },
    xSeconds: {
        one: "1 \u79D2",
        other: "{{count}} \u79D2"
    },
    halfAMinute: "\u534A\u5206\u949F",
    lessThanXMinutes: {
        one: "\u4E0D\u5230 1 \u5206\u949F",
        other: "\u4E0D\u5230 {{count}} \u5206\u949F"
    },
    xMinutes: {
        one: "1 \u5206\u949F",
        other: "{{count}} \u5206\u949F"
    },
    xHours: {
        one: "1 \u5C0F\u65F6",
        other: "{{count}} \u5C0F\u65F6"
    },
    aboutXHours: {
        one: "\u5927\u7EA6 1 \u5C0F\u65F6",
        other: "\u5927\u7EA6 {{count}} \u5C0F\u65F6"
    },
    xDays: {
        one: "1 \u5929",
        other: "{{count}} \u5929"
    },
    aboutXWeeks: {
        one: "\u5927\u7EA6 1 \u4E2A\u661F\u671F",
        other: "\u5927\u7EA6 {{count}} \u4E2A\u661F\u671F"
    },
    xWeeks: {
        one: "1 \u4E2A\u661F\u671F",
        other: "{{count}} \u4E2A\u661F\u671F"
    },
    aboutXMonths: {
        one: "\u5927\u7EA6 1 \u4E2A\u6708",
        other: "\u5927\u7EA6 {{count}} \u4E2A\u6708"
    },
    xMonths: {
        one: "1 \u4E2A\u6708",
        other: "{{count}} \u4E2A\u6708"
    },
    aboutXYears: {
        one: "\u5927\u7EA6 1 \u5E74",
        other: "\u5927\u7EA6 {{count}} \u5E74"
    },
    xYears: {
        one: "1 \u5E74",
        other: "{{count}} \u5E74"
    },
    overXYears: {
        one: "\u8D85\u8FC7 1 \u5E74",
        other: "\u8D85\u8FC7 {{count}} \u5E74"
    },
    almostXYears: {
        one: "\u5C06\u8FD1 1 \u5E74",
        other: "\u5C06\u8FD1 {{count}} \u5E74"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u5185";
        else return result + "\u524D";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gXYry":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "y'\u5E74'M'\u6708'd'\u65E5' EEEE",
    long: "y'\u5E74'M'\u6708'd'\u65E5'",
    medium: 'yyyy-MM-dd',
    short: 'yy-MM-dd'
};
var timeFormats = {
    full: 'zzzz a h:mm:ss',
    long: 'z a h:mm:ss',
    medium: 'a h:mm:ss',
    short: 'a h:mm'
};
var dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"E35CH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../../_lib/isSameUTCWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function checkWeek(date, baseDate, options) {
    var baseFormat = 'eeee p';
    if ((0, _indexJsDefault.default)(date, baseDate, options)) return baseFormat; // in same week
    else if (date.getTime() > baseDate.getTime()) return "'\u4E0B\u4E2A'" + baseFormat; // in next week
    return "'\u4E0A\u4E2A'" + baseFormat; // in last week
}
var formatRelativeLocale = {
    lastWeek: checkWeek,
    // days before yesterday, maybe in this week or last week
    yesterday: "'\u6628\u5929' p",
    today: "'\u4ECA\u5929' p",
    tomorrow: "'\u660E\u5929' p",
    nextWeek: checkWeek,
    // days after tomorrow, maybe in this week or next week
    other: 'PP p'
};
var formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
exports.default = formatRelative;

},{"../../../../_lib/isSameUTCWeek/index.js":"g7rCW","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5CFMg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u524D",
        "\u516C\u5143"
    ],
    abbreviated: [
        "\u524D",
        "\u516C\u5143"
    ],
    wide: [
        "\u516C\u5143\u524D",
        "\u516C\u5143"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u7B2C\u4E00\u5B63",
        "\u7B2C\u4E8C\u5B63",
        "\u7B2C\u4E09\u5B63",
        "\u7B2C\u56DB\u5B63"
    ],
    wide: [
        "\u7B2C\u4E00\u5B63\u5EA6",
        "\u7B2C\u4E8C\u5B63\u5EA6",
        "\u7B2C\u4E09\u5B63\u5EA6",
        "\u7B2C\u56DB\u5B63\u5EA6"
    ]
};
var monthValues = {
    narrow: [
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D",
        "\u4E03",
        "\u516B",
        "\u4E5D",
        "\u5341",
        "\u5341\u4E00",
        "\u5341\u4E8C"
    ],
    abbreviated: [
        "1\u6708",
        "2\u6708",
        "3\u6708",
        "4\u6708",
        "5\u6708",
        "6\u6708",
        "7\u6708",
        "8\u6708",
        "9\u6708",
        "10\u6708",
        "11\u6708",
        "12\u6708"
    ],
    wide: [
        "\u4E00\u6708",
        "\u4E8C\u6708",
        "\u4E09\u6708",
        "\u56DB\u6708",
        "\u4E94\u6708",
        "\u516D\u6708",
        "\u4E03\u6708",
        "\u516B\u6708",
        "\u4E5D\u6708",
        "\u5341\u6708",
        "\u5341\u4E00\u6708",
        "\u5341\u4E8C\u6708"
    ]
};
var dayValues = {
    narrow: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    short: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    abbreviated: [
        "\u5468\u65E5",
        "\u5468\u4E00",
        "\u5468\u4E8C",
        "\u5468\u4E09",
        "\u5468\u56DB",
        "\u5468\u4E94",
        "\u5468\u516D"
    ],
    wide: [
        "\u661F\u671F\u65E5",
        "\u661F\u671F\u4E00",
        "\u661F\u671F\u4E8C",
        "\u661F\u671F\u4E09",
        "\u661F\u671F\u56DB",
        "\u661F\u671F\u4E94",
        "\u661F\u671F\u516D"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u51CC\u6668",
        noon: "\u5348",
        morning: "\u65E9",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u95F4"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u95F4"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u51CC\u6668",
        noon: "\u5348",
        morning: "\u65E9",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u95F4"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u95F4"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    switch(options === null || options === void 0 ? void 0 : options.unit){
        case 'date':
            return number.toString() + "\u65E5";
        case 'hour':
            return number.toString() + "\u65F6";
        case 'minute':
            return number.toString() + "\u5206";
        case 'second':
            return number.toString() + "\u79D2";
        default:
            return "\u7B2C " + number.toString();
    }
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"dkeHA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(第\s*)?\d+(日|时|分|秒)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(前)/i,
    abbreviated: /^(前)/i,
    wide: /^(公元前|公元)/i
};
var parseEraPatterns = {
    any: [
        /^(前)/i,
        /^(公元)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^第[一二三四]刻/i,
    wide: /^第[一二三四]刻钟/i
};
var parseQuarterPatterns = {
    any: [
        /(1|一)/i,
        /(2|二)/i,
        /(3|三)/i,
        /(4|四)/i
    ]
};
var matchMonthPatterns = {
    narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
    abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
    wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
};
var parseMonthPatterns = {
    narrow: [
        /^一/i,
        /^二/i,
        /^三/i,
        /^四/i,
        /^五/i,
        /^六/i,
        /^七/i,
        /^八/i,
        /^九/i,
        /^十(?!(一|二))/i,
        /^十一/i,
        /^十二/i
    ],
    any: [
        /^一|1/i,
        /^二|2/i,
        /^三|3/i,
        /^四|4/i,
        /^五|5/i,
        /^六|6/i,
        /^七|7/i,
        /^八|8/i,
        /^九|9/i,
        /^十(?!(一|二))|10/i,
        /^十一|11/i,
        /^十二|12/i
    ]
};
var matchDayPatterns = {
    narrow: /^[一二三四五六日]/i,
    short: /^[一二三四五六日]/i,
    abbreviated: /^周[一二三四五六日]/i,
    wide: /^星期[一二三四五六日]/i
};
var parseDayPatterns = {
    any: [
        /日/i,
        /一/i,
        /二/i,
        /三/i,
        /四/i,
        /五/i,
        /六/i
    ]
};
var matchDayPeriodPatterns = {
    any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨|)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^上午?/i,
        pm: /^下午?/i,
        midnight: /^午夜/i,
        noon: /^[中正]午/i,
        morning: /^早上/i,
        afternoon: /^下午/i,
        evening: /^晚上?/i,
        night: /^凌晨/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gpgSt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Chinese Traditional locale.
 * @language Chinese Traditional
 * @iso-639-2 zho
 * @author Gary Ip [@gaplo]{@link https://github.com/gaplo}
 */ var locale = {
    code: 'zh-HK',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"jmTk1","./_lib/formatLong/index.js":"1QsZN","./_lib/formatRelative/index.js":"fDgjM","./_lib/localize/index.js":"hkJtw","./_lib/match/index.js":"7TM6S","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jmTk1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u5C11\u65BC 1 \u79D2",
        other: "\u5C11\u65BC {{count}} \u79D2"
    },
    xSeconds: {
        one: "1 \u79D2",
        other: "{{count}} \u79D2"
    },
    halfAMinute: "\u534A\u5206\u9418",
    lessThanXMinutes: {
        one: "\u5C11\u65BC 1 \u5206\u9418",
        other: "\u5C11\u65BC {{count}} \u5206\u9418"
    },
    xMinutes: {
        one: "1 \u5206\u9418",
        other: "{{count}} \u5206\u9418"
    },
    xHours: {
        one: "1 \u5C0F\u6642",
        other: "{{count}} \u5C0F\u6642"
    },
    aboutXHours: {
        one: "\u5927\u7D04 1 \u5C0F\u6642",
        other: "\u5927\u7D04 {{count}} \u5C0F\u6642"
    },
    xDays: {
        one: "1 \u5929",
        other: "{{count}} \u5929"
    },
    aboutXWeeks: {
        one: "\u5927\u7D04 1 \u500B\u661F\u671F",
        other: "\u5927\u7D04 {{count}} \u500B\u661F\u671F"
    },
    xWeeks: {
        one: "1 \u500B\u661F\u671F",
        other: "{{count}} \u500B\u661F\u671F"
    },
    aboutXMonths: {
        one: "\u5927\u7D04 1 \u500B\u6708",
        other: "\u5927\u7D04 {{count}} \u500B\u6708"
    },
    xMonths: {
        one: "1 \u500B\u6708",
        other: "{{count}} \u500B\u6708"
    },
    aboutXYears: {
        one: "\u5927\u7D04 1 \u5E74",
        other: "\u5927\u7D04 {{count}} \u5E74"
    },
    xYears: {
        one: "1 \u5E74",
        other: "{{count}} \u5E74"
    },
    overXYears: {
        one: "\u8D85\u904E 1 \u5E74",
        other: "\u8D85\u904E {{count}} \u5E74"
    },
    almostXYears: {
        one: "\u5C07\u8FD1 1 \u5E74",
        other: "\u5C07\u8FD1 {{count}} \u5E74"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u5167";
        else return result + "\u524D";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1QsZN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "y'\u5E74'M'\u6708'd'\u65E5' EEEE",
    long: "y'\u5E74'M'\u6708'd'\u65E5'",
    medium: 'yyyy-MM-dd',
    short: 'yy-MM-dd'
};
var timeFormats = {
    full: 'zzzz a h:mm:ss',
    long: 'z a h:mm:ss',
    medium: 'a h:mm:ss',
    short: 'a h:mm'
};
var dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"fDgjM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'\u4E0A\u500B'eeee p",
    yesterday: "'\u6628\u5929' p",
    today: "'\u4ECA\u5929' p",
    tomorrow: "'\u660E\u5929' p",
    nextWeek: "'\u4E0B\u500B'eeee p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"hkJtw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u524D",
        "\u516C\u5143"
    ],
    abbreviated: [
        "\u524D",
        "\u516C\u5143"
    ],
    wide: [
        "\u516C\u5143\u524D",
        "\u516C\u5143"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u7B2C\u4E00\u5B63",
        "\u7B2C\u4E8C\u5B63",
        "\u7B2C\u4E09\u5B63",
        "\u7B2C\u56DB\u5B63"
    ],
    wide: [
        "\u7B2C\u4E00\u5B63\u5EA6",
        "\u7B2C\u4E8C\u5B63\u5EA6",
        "\u7B2C\u4E09\u5B63\u5EA6",
        "\u7B2C\u56DB\u5B63\u5EA6"
    ]
};
var monthValues = {
    narrow: [
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D",
        "\u4E03",
        "\u516B",
        "\u4E5D",
        "\u5341",
        "\u5341\u4E00",
        "\u5341\u4E8C"
    ],
    abbreviated: [
        "1\u6708",
        "2\u6708",
        "3\u6708",
        "4\u6708",
        "5\u6708",
        "6\u6708",
        "7\u6708",
        "8\u6708",
        "9\u6708",
        "10\u6708",
        "11\u6708",
        "12\u6708"
    ],
    wide: [
        "\u4E00\u6708",
        "\u4E8C\u6708",
        "\u4E09\u6708",
        "\u56DB\u6708",
        "\u4E94\u6708",
        "\u516D\u6708",
        "\u4E03\u6708",
        "\u516B\u6708",
        "\u4E5D\u6708",
        "\u5341\u6708",
        "\u5341\u4E00\u6708",
        "\u5341\u4E8C\u6708"
    ]
};
var dayValues = {
    narrow: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    short: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    abbreviated: [
        "\u9031\u65E5",
        "\u9031\u4E00",
        "\u9031\u4E8C",
        "\u9031\u4E09",
        "\u9031\u56DB",
        "\u9031\u4E94",
        "\u9031\u516D"
    ],
    wide: [
        "\u661F\u671F\u65E5",
        "\u661F\u671F\u4E00",
        "\u661F\u671F\u4E8C",
        "\u661F\u671F\u4E09",
        "\u661F\u671F\u56DB",
        "\u661F\u671F\u4E94",
        "\u661F\u671F\u516D"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u5348\u591C",
        noon: "\u664C",
        morning: "\u65E9",
        afternoon: "\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u5348\u591C",
        noon: "\u4E2D\u5348",
        morning: "\u4E0A\u5348",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u665A"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u5348\u591C",
        noon: "\u4E2D\u5348",
        morning: "\u4E0A\u5348",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u665A"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u5348\u591C",
        noon: "\u664C",
        morning: "\u65E9",
        afternoon: "\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u5348\u591C",
        noon: "\u4E2D\u5348",
        morning: "\u4E0A\u5348",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u665A"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u5348\u591C",
        noon: "\u4E2D\u5348",
        morning: "\u4E0A\u5348",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u665A"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    switch(options === null || options === void 0 ? void 0 : options.unit){
        case 'date':
            return number + "\u65E5";
        case 'hour':
            return number + "\u6642";
        case 'minute':
            return number + "\u5206";
        case 'second':
            return number + "\u79D2";
        default:
            return "\u7B2C " + number;
    }
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7TM6S":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(第\s*)?\d+(日|時|分|秒)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(前)/i,
    abbreviated: /^(前)/i,
    wide: /^(公元前|公元)/i
};
var parseEraPatterns = {
    any: [
        /^(前)/i,
        /^(公元)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^第[一二三四]季/i,
    wide: /^第[一二三四]季度/i
};
var parseQuarterPatterns = {
    any: [
        /(1|一)/i,
        /(2|二)/i,
        /(3|三)/i,
        /(4|四)/i
    ]
};
var matchMonthPatterns = {
    narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
    abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
    wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
};
var parseMonthPatterns = {
    narrow: [
        /^一/i,
        /^二/i,
        /^三/i,
        /^四/i,
        /^五/i,
        /^六/i,
        /^七/i,
        /^八/i,
        /^九/i,
        /^十(?!(一|二))/i,
        /^十一/i,
        /^十二/i
    ],
    any: [
        /^一|1/i,
        /^二|2/i,
        /^三|3/i,
        /^四|4/i,
        /^五|5/i,
        /^六|6/i,
        /^七|7/i,
        /^八|8/i,
        /^九|9/i,
        /^十(?!(一|二))|10/i,
        /^十一|11/i,
        /^十二|12/i
    ]
};
var matchDayPatterns = {
    narrow: /^[一二三四五六日]/i,
    short: /^[一二三四五六日]/i,
    abbreviated: /^週[一二三四五六日]/i,
    wide: /^星期[一二三四五六日]/i
};
var parseDayPatterns = {
    any: [
        /日/i,
        /一/i,
        /二/i,
        /三/i,
        /四/i,
        /五/i,
        /六/i
    ]
};
var matchDayPeriodPatterns = {
    any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^上午?/i,
        pm: /^下午?/i,
        midnight: /^午夜/i,
        noon: /^[中正]午/i,
        morning: /^早上/i,
        afternoon: /^下午/i,
        evening: /^晚上?/i,
        night: /^凌晨/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"g7mDQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary Chinese Traditional locale.
 * @language Chinese Traditional
 * @iso-639-2 zho
 * @author tonypai [@tpai]{@link https://github.com/tpai}
 * @author Jack Hsu [@jackhsu978]{@link https://github.com/jackhsu978}
 * @author Terrence Lam [@skyuplam]{@link https://github.com/skyuplam}
 */ var locale = {
    code: 'zh-TW',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"iGDRQ","./_lib/formatLong/index.js":"cCFYV","./_lib/formatRelative/index.js":"hLBP3","./_lib/localize/index.js":"k57Yu","./_lib/match/index.js":"kmtN4","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"iGDRQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u5C11\u65BC 1 \u79D2",
        other: "\u5C11\u65BC {{count}} \u79D2"
    },
    xSeconds: {
        one: "1 \u79D2",
        other: "{{count}} \u79D2"
    },
    halfAMinute: "\u534A\u5206\u9418",
    lessThanXMinutes: {
        one: "\u5C11\u65BC 1 \u5206\u9418",
        other: "\u5C11\u65BC {{count}} \u5206\u9418"
    },
    xMinutes: {
        one: "1 \u5206\u9418",
        other: "{{count}} \u5206\u9418"
    },
    xHours: {
        one: "1 \u5C0F\u6642",
        other: "{{count}} \u5C0F\u6642"
    },
    aboutXHours: {
        one: "\u5927\u7D04 1 \u5C0F\u6642",
        other: "\u5927\u7D04 {{count}} \u5C0F\u6642"
    },
    xDays: {
        one: "1 \u5929",
        other: "{{count}} \u5929"
    },
    aboutXWeeks: {
        one: "\u5927\u7D04 1 \u500B\u661F\u671F",
        other: "\u5927\u7D04 {{count}} \u500B\u661F\u671F"
    },
    xWeeks: {
        one: "1 \u500B\u661F\u671F",
        other: "{{count}} \u500B\u661F\u671F"
    },
    aboutXMonths: {
        one: "\u5927\u7D04 1 \u500B\u6708",
        other: "\u5927\u7D04 {{count}} \u500B\u6708"
    },
    xMonths: {
        one: "1 \u500B\u6708",
        other: "{{count}} \u500B\u6708"
    },
    aboutXYears: {
        one: "\u5927\u7D04 1 \u5E74",
        other: "\u5927\u7D04 {{count}} \u5E74"
    },
    xYears: {
        one: "1 \u5E74",
        other: "{{count}} \u5E74"
    },
    overXYears: {
        one: "\u8D85\u904E 1 \u5E74",
        other: "\u8D85\u904E {{count}} \u5E74"
    },
    almostXYears: {
        one: "\u5C07\u8FD1 1 \u5E74",
        other: "\u5C07\u8FD1 {{count}} \u5E74"
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u5167";
        else return result + "\u524D";
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"cCFYV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: "y'\u5E74'M'\u6708'd'\u65E5' EEEE",
    long: "y'\u5E74'M'\u6708'd'\u65E5'",
    medium: 'yyyy-MM-dd',
    short: 'yy-MM-dd'
};
var timeFormats = {
    full: 'zzzz a h:mm:ss',
    long: 'z a h:mm:ss',
    medium: 'a h:mm:ss',
    short: 'a h:mm'
};
var dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"5U7lS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"hLBP3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'\u4E0A\u500B'eeee p",
    yesterday: "'\u6628\u5929' p",
    today: "'\u4ECA\u5929' p",
    tomorrow: "'\u660E\u5929' p",
    nextWeek: "'\u4E0B\u500B'eeee p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"k57Yu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        "\u524D",
        "\u516C\u5143"
    ],
    abbreviated: [
        "\u524D",
        "\u516C\u5143"
    ],
    wide: [
        "\u516C\u5143\u524D",
        "\u516C\u5143"
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u7B2C\u4E00\u523B",
        "\u7B2C\u4E8C\u523B",
        "\u7B2C\u4E09\u523B",
        "\u7B2C\u56DB\u523B"
    ],
    wide: [
        "\u7B2C\u4E00\u523B\u9418",
        "\u7B2C\u4E8C\u523B\u9418",
        "\u7B2C\u4E09\u523B\u9418",
        "\u7B2C\u56DB\u523B\u9418"
    ]
};
var monthValues = {
    narrow: [
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D",
        "\u4E03",
        "\u516B",
        "\u4E5D",
        "\u5341",
        "\u5341\u4E00",
        "\u5341\u4E8C"
    ],
    abbreviated: [
        "1\u6708",
        "2\u6708",
        "3\u6708",
        "4\u6708",
        "5\u6708",
        "6\u6708",
        "7\u6708",
        "8\u6708",
        "9\u6708",
        "10\u6708",
        "11\u6708",
        "12\u6708"
    ],
    wide: [
        "\u4E00\u6708",
        "\u4E8C\u6708",
        "\u4E09\u6708",
        "\u56DB\u6708",
        "\u4E94\u6708",
        "\u516D\u6708",
        "\u4E03\u6708",
        "\u516B\u6708",
        "\u4E5D\u6708",
        "\u5341\u6708",
        "\u5341\u4E00\u6708",
        "\u5341\u4E8C\u6708"
    ]
};
var dayValues = {
    narrow: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    short: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    abbreviated: [
        "\u9031\u65E5",
        "\u9031\u4E00",
        "\u9031\u4E8C",
        "\u9031\u4E09",
        "\u9031\u56DB",
        "\u9031\u4E94",
        "\u9031\u516D"
    ],
    wide: [
        "\u661F\u671F\u65E5",
        "\u661F\u671F\u4E00",
        "\u661F\u671F\u4E8C",
        "\u661F\u671F\u4E09",
        "\u661F\u671F\u56DB",
        "\u661F\u671F\u4E94",
        "\u661F\u671F\u516D"
    ]
};
var dayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u51CC\u6668",
        noon: "\u5348",
        morning: "\u65E9",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u9593"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u9593"
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u51CC\u6668",
        noon: "\u5348",
        morning: "\u65E9",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u9593"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u9593"
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    switch(options === null || options === void 0 ? void 0 : options.unit){
        case 'date':
            return number + "\u65E5";
        case 'hour':
            return number + "\u6642";
        case 'minute':
            return number + "\u5206";
        case 'second':
            return number + "\u79D2";
        default:
            return "\u7B2C " + number;
    }
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"lfhT3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"kmtN4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(第\s*)?\d+(日|時|分|秒)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(前)/i,
    abbreviated: /^(前)/i,
    wide: /^(公元前|公元)/i
};
var parseEraPatterns = {
    any: [
        /^(前)/i,
        /^(公元)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^第[一二三四]刻/i,
    wide: /^第[一二三四]刻鐘/i
};
var parseQuarterPatterns = {
    any: [
        /(1|一)/i,
        /(2|二)/i,
        /(3|三)/i,
        /(4|四)/i
    ]
};
var matchMonthPatterns = {
    narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
    abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
    wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
};
var parseMonthPatterns = {
    narrow: [
        /^一/i,
        /^二/i,
        /^三/i,
        /^四/i,
        /^五/i,
        /^六/i,
        /^七/i,
        /^八/i,
        /^九/i,
        /^十(?!(一|二))/i,
        /^十一/i,
        /^十二/i
    ],
    any: [
        /^一|1/i,
        /^二|2/i,
        /^三|3/i,
        /^四|4/i,
        /^五|5/i,
        /^六|6/i,
        /^七|7/i,
        /^八|8/i,
        /^九|9/i,
        /^十(?!(一|二))|10/i,
        /^十一|11/i,
        /^十二|12/i
    ]
};
var matchDayPatterns = {
    narrow: /^[一二三四五六日]/i,
    short: /^[一二三四五六日]/i,
    abbreviated: /^週[一二三四五六日]/i,
    wide: /^星期[一二三四五六日]/i
};
var parseDayPatterns = {
    any: [
        /日/i,
        /一/i,
        /二/i,
        /三/i,
        /四/i,
        /五/i,
        /六/i
    ]
};
var matchDayPeriodPatterns = {
    any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^上午?/i,
        pm: /^下午?/i,
        midnight: /^午夜/i,
        noon: /^[中正]午/i,
        morning: /^早上/i,
        afternoon: /^下午/i,
        evening: /^晚上?/i,
        night: /^凌晨/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"7YCyk","../../../_lib/buildMatchPatternFn/index.js":"2Mexa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"c1e6y":[function(require,module,exports,__globalThis) {
// This file is generated automatically by `scripts/build/indices.js`. Please, don't change it.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "format", function() {
    return 0, _indexJsDefault.default;
});
parcelHelpers.export(exports, "formatInTimeZone", function() {
    return 0, _indexJsDefault1.default;
});
parcelHelpers.export(exports, "getTimezoneOffset", function() {
    return 0, _indexJsDefault2.default;
});
parcelHelpers.export(exports, "toDate", function() {
    return 0, _indexJsDefault3.default;
});
parcelHelpers.export(exports, "utcToZonedTime", function() {
    return 0, _indexJsDefault4.default;
});
parcelHelpers.export(exports, "zonedTimeToUtc", function() {
    return 0, _indexJsDefault5.default;
});
var _indexJs = require("./format/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./formatInTimeZone/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./getTimezoneOffset/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./toDate/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./utcToZonedTime/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
var _indexJs5 = require("./zonedTimeToUtc/index.js");
var _indexJsDefault5 = parcelHelpers.interopDefault(_indexJs5);

},{"./format/index.js":"3pIQ8","./formatInTimeZone/index.js":"4gMyy","./getTimezoneOffset/index.js":"4bIo8","./toDate/index.js":"kyrsm","./utcToZonedTime/index.js":"jvA4D","./zonedTimeToUtc/index.js":"ccSgm","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3pIQ8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return format;
});
var _indexJs = require("date-fns/format/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./formatters/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../toDate/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function format(dirtyDate, dirtyFormatStr, dirtyOptions) {
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var matches = formatStr.match(tzFormattingTokensRegExp);
    if (matches) {
        var date = (0, _indexJsDefault2.default)(options.originalDate || dirtyDate, options);
        // Work through each match and replace the tz token in the format string with the quoted
        // formatted time zone so the remaining tokens can be filled in by date-fns#format.
        formatStr = matches.reduce(function(result, token) {
            if (token[0] === "'") return result // This is a quoted portion, matched only to ensure we don't match inside it
            ;
            var pos = result.indexOf(token);
            var precededByQuotedSection = result[pos - 1] === "'";
            var replaced = result.replace(token, "'" + (0, _indexJsDefault1.default)[token[0]](date, token, null, options) + "'");
            // If the replacement results in two adjoining quoted strings, the back to back quotes
            // are removed, so it doesn't look like an escaped quote.
            return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
        }, formatStr);
    }
    return (0, _indexJsDefault.default)(dirtyDate, formatStr, options);
}

},{"date-fns/format/index.js":"6xHDW","./formatters/index.js":"if4WT","../toDate/index.js":"kyrsm","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6xHDW":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("2d5c5ab83a9a7f9d").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = format;
var _index = _interopRequireDefault(require("301a965f05908c93"));
var _index2 = _interopRequireDefault(require("280650fac6565050"));
var _index3 = _interopRequireDefault(require("c5685c1181d7a467"));
var _index4 = _interopRequireDefault(require("718d55ed818e4074"));
var _index5 = _interopRequireDefault(require("963f82a2f837f8e1"));
var _index6 = _interopRequireDefault(require("1e318add5ac154f9"));
var _index7 = require("bdffe4c6b1fdab42");
var _index8 = _interopRequireDefault(require("5136fd9d1f406b42"));
var _index9 = _interopRequireDefault(require("75fb3b1b1a6186cc"));
var _index10 = require("651b38f827eb4283");
var _index11 = _interopRequireDefault(require("43922e50441f4928"));
// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */ function format(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, _index9.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, _index10.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : _index11.default;
    var firstWeekContainsDate = (0, _index8.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, _index8.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (!locale.localize) throw new RangeError('locale must contain localize property');
    if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
    var originalDate = (0, _index3.default)(dirtyDate);
    if (!(0, _index.default)(originalDate)) throw new RangeError('Invalid time value');
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, _index6.default)(originalDate);
    var utcDate = (0, _index2.default)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match(longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = _index5.default[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match(formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return cleanEscapedString(substring);
        var formatter = _index4.default[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, _index7.isProtectedWeekYearToken)(substring)) (0, _index7.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, _index7.isProtectedDayOfYearToken)(substring)) (0, _index7.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match(unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        return substring;
    }).join('');
    return result;
}
function cleanEscapedString(input) {
    var matched = input.match(escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace(doubleQuoteRegExp, "'");
}
module.exports = exports.default;

},{"2d5c5ab83a9a7f9d":"iZ6pp","301a965f05908c93":"2JLPc","280650fac6565050":"7hmfY","c5685c1181d7a467":"2gk4p","718d55ed818e4074":"hhdC4","963f82a2f837f8e1":"gWhBO","1e318add5ac154f9":"hrqxc","bdffe4c6b1fdab42":"35xKr","5136fd9d1f406b42":"6aYrL","75fb3b1b1a6186cc":"frnfg","651b38f827eb4283":"e16ZD","43922e50441f4928":"iSFDG"}],"iZ6pp":[function(require,module,exports,__globalThis) {
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"2JLPc":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("bda26f6f86dd45f5").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = isValid;
var _index = _interopRequireDefault(require("8466d9d57bcb1951"));
var _index2 = _interopRequireDefault(require("42fc81a307ed7e61"));
var _index3 = _interopRequireDefault(require("c2ec2410ab978a61"));
/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */ function isValid(dirtyDate) {
    (0, _index3.default)(1, arguments);
    if (!(0, _index.default)(dirtyDate) && typeof dirtyDate !== 'number') return false;
    var date = (0, _index2.default)(dirtyDate);
    return !isNaN(Number(date));
}
module.exports = exports.default;

},{"bda26f6f86dd45f5":"iZ6pp","8466d9d57bcb1951":"9eyB8","42fc81a307ed7e61":"2gk4p","c2ec2410ab978a61":"frnfg"}],"9eyB8":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("14b68aa003875388").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = isDate;
var _typeof2 = _interopRequireDefault(require("f1bac99237ced52a"));
var _index = _interopRequireDefault(require("692a9a1832cd7cae"));
/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */ function isDate(value) {
    (0, _index.default)(1, arguments);
    return value instanceof Date || (0, _typeof2.default)(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}
module.exports = exports.default;

},{"14b68aa003875388":"iZ6pp","f1bac99237ced52a":"iyzqt","692a9a1832cd7cae":"frnfg"}],"iyzqt":[function(require,module,exports,__globalThis) {
function _typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

},{}],"frnfg":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = requiredArgs;
function requiredArgs(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}
module.exports = exports.default;

},{}],"2gk4p":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("7e71702002f2227c").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = toDate;
var _typeof2 = _interopRequireDefault(require("26972b07fee09bce"));
var _index = _interopRequireDefault(require("c77555ddf0f34a8a"));
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */ function toDate(argument) {
    (0, _index.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, _typeof2.default)(argument) === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}
module.exports = exports.default;

},{"7e71702002f2227c":"iZ6pp","26972b07fee09bce":"iyzqt","c77555ddf0f34a8a":"frnfg"}],"7hmfY":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("856e2d21609bd2db").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = subMilliseconds;
var _index = _interopRequireDefault(require("76d85b1a9216fdc1"));
var _index2 = _interopRequireDefault(require("fdf2663cb0b7d75e"));
var _index3 = _interopRequireDefault(require("29368509f6d949f1"));
/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */ function subMilliseconds(dirtyDate, dirtyAmount) {
    (0, _index2.default)(2, arguments);
    var amount = (0, _index3.default)(dirtyAmount);
    return (0, _index.default)(dirtyDate, -amount);
}
module.exports = exports.default;

},{"856e2d21609bd2db":"iZ6pp","76d85b1a9216fdc1":"7ofed","fdf2663cb0b7d75e":"frnfg","29368509f6d949f1":"6aYrL"}],"7ofed":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("af8a8533799244fa").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = addMilliseconds;
var _index = _interopRequireDefault(require("24afbb04b203903c"));
var _index2 = _interopRequireDefault(require("4f5028fbb626ba7d"));
var _index3 = _interopRequireDefault(require("546d68cf80e1bc5d"));
/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */ function addMilliseconds(dirtyDate, dirtyAmount) {
    (0, _index3.default)(2, arguments);
    var timestamp = (0, _index2.default)(dirtyDate).getTime();
    var amount = (0, _index.default)(dirtyAmount);
    return new Date(timestamp + amount);
}
module.exports = exports.default;

},{"af8a8533799244fa":"iZ6pp","24afbb04b203903c":"6aYrL","4f5028fbb626ba7d":"2gk4p","546d68cf80e1bc5d":"frnfg"}],"6aYrL":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = toInteger;
function toInteger(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}
module.exports = exports.default;

},{}],"hhdC4":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("2adba11879467d94").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("7828aad1fbfdc8ee"));
var _index2 = _interopRequireDefault(require("91183fa214b0ccf4"));
var _index3 = _interopRequireDefault(require("e7936eaf92a044ac"));
var _index4 = _interopRequireDefault(require("8e136e09e2666c91"));
var _index5 = _interopRequireDefault(require("44a81a549f9f4b67"));
var _index6 = _interopRequireDefault(require("cac5e7f5ce4526a"));
var _index7 = _interopRequireDefault(require("72716cbd3e476997"));
var dayPeriodEnum = {
    am: 'am',
    pm: 'pm',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case 'G':
            case 'GG':
            case 'GGG':
                return localize.era(era, {
                    width: 'abbreviated'
                });
            // A, B
            case 'GGGGG':
                return localize.era(era, {
                    width: 'narrow'
                });
            // Anno Domini, Before Christ
            case 'GGGG':
            default:
                return localize.era(era, {
                    width: 'wide'
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === 'yo') {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: 'year'
            });
        }
        return _index7.default.y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, _index5.default)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === 'YY') {
            var twoDigitYear = weekYear % 100;
            return (0, _index6.default)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === 'Yo') return localize.ordinalNumber(weekYear, {
            unit: 'year'
        });
        // Padding
        return (0, _index6.default)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, _index3.default)(date);
        // Padding
        return (0, _index6.default)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, _index6.default)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'Q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'QQ':
                return (0, _index6.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'Qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'QQQ':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'QQQQQ':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // 1st quarter, 2nd quarter, ...
            case 'QQQQ':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'qq':
                return (0, _index6.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'qqq':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'qqqqq':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // 1st quarter, 2nd quarter, ...
            case 'qqqq':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case 'M':
            case 'MM':
                return _index7.default.M(date, token);
            // 1st, 2nd, ..., 12th
            case 'Mo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'MMM':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // J, F, ..., D
            case 'MMMMM':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // January, February, ..., December
            case 'MMMM':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case 'L':
                return String(month + 1);
            // 01, 02, ..., 12
            case 'LL':
                return (0, _index6.default)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case 'Lo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'LLL':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // J, F, ..., D
            case 'LLLLL':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // January, February, ..., December
            case 'LLLL':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, _index4.default)(date, options);
        if (token === 'wo') return localize.ordinalNumber(week, {
            unit: 'week'
        });
        return (0, _index6.default)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, _index2.default)(date);
        if (token === 'Io') return localize.ordinalNumber(isoWeek, {
            unit: 'week'
        });
        return (0, _index6.default)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === 'do') return localize.ordinalNumber(date.getUTCDate(), {
            unit: 'date'
        });
        return _index7.default.d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, _index.default)(date);
        if (token === 'Do') return localize.ordinalNumber(dayOfYear, {
            unit: 'dayOfYear'
        });
        return (0, _index6.default)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case 'E':
            case 'EE':
            case 'EEE':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'EEEEE':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'EEEEEE':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'EEEE':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case 'e':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'ee':
                return (0, _index6.default)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case 'eo':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'eee':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'eeeee':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'eeeeee':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'eeee':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case 'c':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'cc':
                return (0, _index6.default)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case 'co':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'ccc':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // T
            case 'ccccc':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // Tu
            case 'cccccc':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'standalone'
                });
            // Tuesday
            case 'cccc':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case 'i':
                return String(isoDayOfWeek);
            // 02
            case 'ii':
                return (0, _index6.default)(isoDayOfWeek, token.length);
            // 2nd
            case 'io':
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: 'day'
                });
            // Tue
            case 'iii':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'iiiii':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'iiiiii':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'iiii':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'aaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'aaaaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'aaaa':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'b':
            case 'bb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'bbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'bbbbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'bbbb':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = dayPeriodEnum.morning;
        else dayPeriodEnumValue = dayPeriodEnum.night;
        switch(token){
            case 'B':
            case 'BB':
            case 'BBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'BBBBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'BBBB':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === 'ho') {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
        }
        return _index7.default.h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === 'Ho') return localize.ordinalNumber(date.getUTCHours(), {
            unit: 'hour'
        });
        return _index7.default.H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === 'Ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, _index6.default)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === 'ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, _index6.default)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === 'mo') return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: 'minute'
        });
        return _index7.default.m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === 'so') return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: 'second'
        });
        return _index7.default.s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return _index7.default.S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                // Hours and minutes without `:` delimiter
                return formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case 'x':
                return formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                // Hours and minutes without `:` delimiter
                return formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'zzzz':
            default:
                return 'GMT' + formatTimezone(timezoneOffset, ':');
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, _index6.default)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, _index6.default)(timestamp, token.length);
    }
};
function formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + (0, _index6.default)(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + (0, _index6.default)(Math.abs(offset) / 60, 2);
    }
    return formatTimezone(offset, dirtyDelimiter);
}
function formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = (0, _index6.default)(Math.floor(absOffset / 60), 2);
    var minutes = (0, _index6.default)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var _default = formatters;
exports.default = _default;
module.exports = exports.default;

},{"2adba11879467d94":"iZ6pp","7828aad1fbfdc8ee":"jFzTv","91183fa214b0ccf4":"kvWGW","e7936eaf92a044ac":"3ugqh","8e136e09e2666c91":"gkxx5","44a81a549f9f4b67":"inJKd","cac5e7f5ce4526a":"djEZF","72716cbd3e476997":"91o5B"}],"jFzTv":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("e7be542631ae7e3a").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getUTCDayOfYear;
var _index = _interopRequireDefault(require("9024dd291ac3c79a"));
var _index2 = _interopRequireDefault(require("623facb5670f7e50"));
var MILLISECONDS_IN_DAY = 86400000;
function getUTCDayOfYear(dirtyDate) {
    (0, _index2.default)(1, arguments);
    var date = (0, _index.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}
module.exports = exports.default;

},{"e7be542631ae7e3a":"iZ6pp","9024dd291ac3c79a":"2gk4p","623facb5670f7e50":"frnfg"}],"kvWGW":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("d7fe6e212e87ece").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getUTCISOWeek;
var _index = _interopRequireDefault(require("a46b6419a9428580"));
var _index2 = _interopRequireDefault(require("d06ec2899e604adb"));
var _index3 = _interopRequireDefault(require("58367736a4083f2b"));
var _index4 = _interopRequireDefault(require("584fc6d065e4f226"));
var MILLISECONDS_IN_WEEK = 604800000;
function getUTCISOWeek(dirtyDate) {
    (0, _index4.default)(1, arguments);
    var date = (0, _index.default)(dirtyDate);
    var diff = (0, _index2.default)(date).getTime() - (0, _index3.default)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}
module.exports = exports.default;

},{"d7fe6e212e87ece":"iZ6pp","a46b6419a9428580":"2gk4p","d06ec2899e604adb":"fSYAK","58367736a4083f2b":"fgSkC","584fc6d065e4f226":"frnfg"}],"fSYAK":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("989ff457b2fd13eb").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = startOfUTCISOWeek;
var _index = _interopRequireDefault(require("c2eaebece57cfd86"));
var _index2 = _interopRequireDefault(require("df37419933fa87be"));
function startOfUTCISOWeek(dirtyDate) {
    (0, _index2.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, _index.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}
module.exports = exports.default;

},{"989ff457b2fd13eb":"iZ6pp","c2eaebece57cfd86":"2gk4p","df37419933fa87be":"frnfg"}],"fgSkC":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("a3ba8ab6c83f68d4").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = startOfUTCISOWeekYear;
var _index = _interopRequireDefault(require("ca390965d0d7c03b"));
var _index2 = _interopRequireDefault(require("ef06fcda4618d10d"));
var _index3 = _interopRequireDefault(require("fb5f84e2a5c7d906"));
function startOfUTCISOWeekYear(dirtyDate) {
    (0, _index3.default)(1, arguments);
    var year = (0, _index.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, _index2.default)(fourthOfJanuary);
    return date;
}
module.exports = exports.default;

},{"a3ba8ab6c83f68d4":"iZ6pp","ca390965d0d7c03b":"3ugqh","ef06fcda4618d10d":"fSYAK","fb5f84e2a5c7d906":"frnfg"}],"3ugqh":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("64914c1d69646792").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getUTCISOWeekYear;
var _index = _interopRequireDefault(require("c64d27d2d4aec4cb"));
var _index2 = _interopRequireDefault(require("a7ba4c5480f0356"));
var _index3 = _interopRequireDefault(require("da1a95ff434ae277"));
function getUTCISOWeekYear(dirtyDate) {
    (0, _index2.default)(1, arguments);
    var date = (0, _index.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, _index3.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, _index3.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
module.exports = exports.default;

},{"64914c1d69646792":"iZ6pp","c64d27d2d4aec4cb":"2gk4p","a7ba4c5480f0356":"frnfg","da1a95ff434ae277":"fSYAK"}],"gkxx5":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("f734c977881715e7").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getUTCWeek;
var _index = _interopRequireDefault(require("e9578781b2d44524"));
var _index2 = _interopRequireDefault(require("97be29c2829ba144"));
var _index3 = _interopRequireDefault(require("87782ee6abc77a6f"));
var _index4 = _interopRequireDefault(require("17026d664b9320ad"));
var MILLISECONDS_IN_WEEK = 604800000;
function getUTCWeek(dirtyDate, options) {
    (0, _index4.default)(1, arguments);
    var date = (0, _index.default)(dirtyDate);
    var diff = (0, _index2.default)(date, options).getTime() - (0, _index3.default)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}
module.exports = exports.default;

},{"f734c977881715e7":"iZ6pp","e9578781b2d44524":"2gk4p","97be29c2829ba144":"7zTyn","87782ee6abc77a6f":"4h6Ny","17026d664b9320ad":"frnfg"}],"7zTyn":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("996fc008a2a4b421").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = startOfUTCWeek;
var _index = _interopRequireDefault(require("aa230ad1b037e224"));
var _index2 = _interopRequireDefault(require("9c3c46f04947cb10"));
var _index3 = _interopRequireDefault(require("f61735a29ba3435d"));
var _index4 = require("52a109d014ead322");
function startOfUTCWeek(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _index2.default)(1, arguments);
    var defaultOptions = (0, _index4.getDefaultOptions)();
    var weekStartsOn = (0, _index3.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, _index.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}
module.exports = exports.default;

},{"996fc008a2a4b421":"iZ6pp","aa230ad1b037e224":"2gk4p","9c3c46f04947cb10":"frnfg","f61735a29ba3435d":"6aYrL","52a109d014ead322":"e16ZD"}],"e16ZD":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getDefaultOptions = getDefaultOptions;
exports.setDefaultOptions = setDefaultOptions;
var defaultOptions = {};
function getDefaultOptions() {
    return defaultOptions;
}
function setDefaultOptions(newOptions) {
    defaultOptions = newOptions;
}

},{}],"4h6Ny":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("ba119a1a797c4c74").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = startOfUTCWeekYear;
var _index = _interopRequireDefault(require("ae62e2de97c04c63"));
var _index2 = _interopRequireDefault(require("e272f63c92408b60"));
var _index3 = _interopRequireDefault(require("428a4ab06300388d"));
var _index4 = _interopRequireDefault(require("152c631053c91106"));
var _index5 = require("bc2c3f45224ac55d");
function startOfUTCWeekYear(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _index2.default)(1, arguments);
    var defaultOptions = (0, _index5.getDefaultOptions)();
    var firstWeekContainsDate = (0, _index4.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, _index.default)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, _index3.default)(firstWeek, options);
    return date;
}
module.exports = exports.default;

},{"ba119a1a797c4c74":"iZ6pp","ae62e2de97c04c63":"inJKd","e272f63c92408b60":"frnfg","428a4ab06300388d":"7zTyn","152c631053c91106":"6aYrL","bc2c3f45224ac55d":"e16ZD"}],"inJKd":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("cdb5d8c998729a40").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getUTCWeekYear;
var _index = _interopRequireDefault(require("8c716bd41363adf5"));
var _index2 = _interopRequireDefault(require("6dc40a147c9482c9"));
var _index3 = _interopRequireDefault(require("fd8d2a47f68594b2"));
var _index4 = _interopRequireDefault(require("2693828d049b0bea"));
var _index5 = require("cea4432aca02de6");
function getUTCWeekYear(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _index2.default)(1, arguments);
    var date = (0, _index.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, _index5.getDefaultOptions)();
    var firstWeekContainsDate = (0, _index4.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, _index3.default)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, _index3.default)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
module.exports = exports.default;

},{"cdb5d8c998729a40":"iZ6pp","8c716bd41363adf5":"2gk4p","6dc40a147c9482c9":"frnfg","fd8d2a47f68594b2":"7zTyn","2693828d049b0bea":"6aYrL","cea4432aca02de6":"e16ZD"}],"djEZF":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = addLeadingZeros;
function addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
module.exports = exports.default;

},{}],"91o5B":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("3ebfed447a058cec").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("605d97605b44eacf"));
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, _index.default)(token === 'yy' ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === 'M' ? String(month + 1) : (0, _index.default)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, _index.default)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return dayPeriodEnumValue.toUpperCase();
            case 'aaa':
                return dayPeriodEnumValue;
            case 'aaaaa':
                return dayPeriodEnumValue[0];
            case 'aaaa':
            default:
                return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, _index.default)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, _index.default)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, _index.default)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, _index.default)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, _index.default)(fractionalSeconds, token.length);
    }
};
var _default = formatters;
exports.default = _default;
module.exports = exports.default;

},{"3ebfed447a058cec":"iZ6pp","605d97605b44eacf":"djEZF"}],"gWhBO":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'P':
            return formatLong.date({
                width: 'short'
            });
        case 'PP':
            return formatLong.date({
                width: 'medium'
            });
        case 'PPP':
            return formatLong.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return formatLong.date({
                width: 'full'
            });
    }
};
var timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'p':
            return formatLong.time({
                width: 'short'
            });
        case 'pp':
            return formatLong.time({
                width: 'medium'
            });
        case 'ppp':
            return formatLong.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return formatLong.time({
                width: 'full'
            });
    }
};
var dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case 'P':
            dateTimeFormat = formatLong.dateTime({
                width: 'short'
            });
            break;
        case 'PP':
            dateTimeFormat = formatLong.dateTime({
                width: 'medium'
            });
            break;
        case 'PPP':
            dateTimeFormat = formatLong.dateTime({
                width: 'long'
            });
            break;
        case 'PPPP':
        default:
            dateTimeFormat = formatLong.dateTime({
                width: 'full'
            });
            break;
    }
    return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
};
var longFormatters = {
    p: timeLongFormatter,
    P: dateTimeLongFormatter
};
var _default = longFormatters;
exports.default = _default;
module.exports = exports.default;

},{}],"hrqxc":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getTimezoneOffsetInMilliseconds;
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function getTimezoneOffsetInMilliseconds(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}
module.exports = exports.default;

},{}],"35xKr":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isProtectedDayOfYearToken = isProtectedDayOfYearToken;
exports.isProtectedWeekYearToken = isProtectedWeekYearToken;
exports.throwProtectedError = throwProtectedError;
var protectedDayOfYearTokens = [
    'D',
    'DD'
];
var protectedWeekYearTokens = [
    'YY',
    'YYYY'
];
function isProtectedDayOfYearToken(token) {
    return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
    return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
    if (token === 'YYYY') throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'YY') throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'D') throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'DD') throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}

},{}],"iSFDG":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("84038d993ac13242").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("b38d0d63a6c40aa2"));
var _default = _index.default;
exports.default = _default;
module.exports = exports.default;

},{"84038d993ac13242":"iZ6pp","b38d0d63a6c40aa2":"hlvQQ"}],"hlvQQ":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("c31e4c597ee23635").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("7af9001c63ed0ada"));
var _index2 = _interopRequireDefault(require("33d5687e3bc175b7"));
var _index3 = _interopRequireDefault(require("1c761b8f578f03ea"));
var _index4 = _interopRequireDefault(require("ff7f50edeb1c6a3a"));
var _index5 = _interopRequireDefault(require("a6b3c20ed5415c53"));
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var locale = {
    code: 'en-US',
    formatDistance: _index.default,
    formatLong: _index2.default,
    formatRelative: _index3.default,
    localize: _index4.default,
    match: _index5.default,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var _default = locale;
exports.default = _default;
module.exports = exports.default;

},{"c31e4c597ee23635":"iZ6pp","7af9001c63ed0ada":"7NDNX","33d5687e3bc175b7":"sh6mO","1c761b8f578f03ea":"h0jKB","ff7f50edeb1c6a3a":"czWM2","a6b3c20ed5415c53":"8iB84"}],"7NDNX":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: '1 hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: '1 day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: '1 month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: '1 year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
};
var _default = formatDistance;
exports.default = _default;
module.exports = exports.default;

},{}],"sh6mO":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("1bb3dba2212f3904").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("e168c516dcf4331b"));
var dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _index.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _index.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _index.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
var _default = formatLong;
exports.default = _default;
module.exports = exports.default;

},{"1bb3dba2212f3904":"iZ6pp","e168c516dcf4331b":"amweR"}],"amweR":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = buildFormatLongFn;
function buildFormatLongFn(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}
module.exports = exports.default;

},{}],"h0jKB":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
var _default = formatRelative;
exports.default = _default;
module.exports = exports.default;

},{}],"czWM2":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("173314d5b8f36c5").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("acef9b8d3c117763"));
var eraValues = {
    narrow: [
        'B',
        'A'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        'Before Christ',
        'Anno Domini'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1st quarter',
        '2nd quarter',
        '3rd quarter',
        '4th quarter'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    wide: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]
};
var dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S'
    ],
    short: [
        'Su',
        'Mo',
        'Tu',
        'We',
        'Th',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    wide: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'st';
        case 2:
            return number + 'nd';
        case 3:
            return number + 'rd';
    }
    return number + 'th';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _index.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _index.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _index.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _index.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _index.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var _default = localize;
exports.default = _default;
module.exports = exports.default;

},{"173314d5b8f36c5":"iZ6pp","acef9b8d3c117763":"gGtZt"}],"gGtZt":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = buildLocalizeFn;
function buildLocalizeFn(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
        var valuesArray;
        if (context === 'formatting' && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}
module.exports = exports.default;

},{}],"8iB84":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("927ad6a14895259a").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("a58d16898aff0c63"));
var _index2 = _interopRequireDefault(require("eb878fef7d3dea23"));
var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var match = {
    ordinalNumber: (0, _index2.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _index.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _index.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _index.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _index.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _index.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var _default = match;
exports.default = _default;
module.exports = exports.default;

},{"927ad6a14895259a":"iZ6pp","a58d16898aff0c63":"6jj9V","eb878fef7d3dea23":"6aH0A"}],"6jj9V":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = buildMatchFn;
function buildMatchFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}
module.exports = exports.default;

},{}],"6aH0A":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = buildMatchPatternFn;
function buildMatchPatternFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
module.exports = exports.default;

},{}],"if4WT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../_lib/tzIntlTimeZoneName/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../_lib/tzParseTimezone/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var MILLISECONDS_IN_MINUTE = 60000;
var formatters = {
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, localize, options) {
        var timezoneOffset = getTimeZoneOffset(options.timeZone, date);
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                return formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, localize, options) {
        var timezoneOffset = getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Hours and optional minutes
            case 'x':
                return formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                return formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function O(date, token, localize, options) {
        var timezoneOffset = getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, localize, options) {
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return (0, _indexJsDefault.default)('short', date, options);
            // Long
            case 'zzzz':
            default:
                return (0, _indexJsDefault.default)('long', date, options);
        }
    }
};
function getTimeZoneOffset(timeZone, originalDate) {
    var timeZoneOffset = timeZone ? (0, _indexJsDefault1.default)(timeZone, originalDate, true) / MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();
    if (Number.isNaN(timeZoneOffset)) throw new RangeError('Invalid time zone specified: ' + timeZone);
    return timeZoneOffset;
}
function addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
function formatTimezone(offset, dirtyDelimeter) {
    var delimeter = dirtyDelimeter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
    var minutes = addLeadingZeros(Math.floor(absOffset % 60), 2);
    return sign + hours + delimeter + minutes;
}
function formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
    }
    return formatTimezone(offset, dirtyDelimeter);
}
function formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}
exports.default = formatters;

},{"../../_lib/tzIntlTimeZoneName/index.js":"ajdP9","../../_lib/tzParseTimezone/index.js":"1aZe8","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"ajdP9":[function(require,module,exports,__globalThis) {
/**
 * Returns the formatted time zone name of the provided `timeZone` or the current
 * system time zone if omitted, accounting for DST according to the UTC value of
 * the date.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return tzIntlTimeZoneName;
});
function tzIntlTimeZoneName(length, date, options) {
    var dtf = getDTF(length, options.timeZone, options.locale);
    return dtf.formatToParts ? partsTimeZone(dtf, date) : hackyTimeZone(dtf, date);
}
function partsTimeZone(dtf, date) {
    var formatted = dtf.formatToParts(date);
    for(var i = formatted.length - 1; i >= 0; --i){
        if (formatted[i].type === 'timeZoneName') return formatted[i].value;
    }
}
function hackyTimeZone(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, '');
    var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
    return tzNameMatch ? tzNameMatch[0].substr(1) : '';
}
// If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.
function getDTF(length, timeZone, locale) {
    if (locale && !locale.code) throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
    return new Intl.DateTimeFormat(locale ? [
        locale.code,
        'en-US'
    ] : undefined, {
        timeZone: timeZone,
        timeZoneName: length
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1aZe8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return tzParseTimezone;
});
var _indexJs = require("../tzTokenizeDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../newDateUTC/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var MILLISECONDS_IN_HOUR = 3600000;
var MILLISECONDS_IN_MINUTE = 60000;
var patterns = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function tzParseTimezone(timezoneString, date, isUtcDate) {
    var token;
    var absoluteOffset;
    // Empty string
    if (!timezoneString) return 0;
    // Z
    token = patterns.timezoneZ.exec(timezoneString);
    if (token) return 0;
    var hours;
    // ±hh
    token = patterns.timezoneHH.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        if (!validateTimezone(hours)) return NaN;
        return -(hours * MILLISECONDS_IN_HOUR);
    }
    // ±hh:mm or ±hhmm
    token = patterns.timezoneHHMM.exec(timezoneString);
    if (token) {
        hours = parseInt(token[2], 10);
        var minutes = parseInt(token[3], 10);
        if (!validateTimezone(hours, minutes)) return NaN;
        absoluteOffset = Math.abs(hours) * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE;
        return token[1] === '+' ? -absoluteOffset : absoluteOffset;
    }
    // IANA time zone
    if (isValidTimezoneIANAString(timezoneString)) {
        date = new Date(date || Date.now());
        var utcDate = isUtcDate ? date : toUtcDate(date);
        var offset = calcOffset(utcDate, timezoneString);
        var fixedOffset = isUtcDate ? offset : fixOffset(date, offset, timezoneString);
        return -fixedOffset;
    }
    return NaN;
}
function toUtcDate(date) {
    return (0, _indexJsDefault1.default)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function calcOffset(date, timezoneString) {
    var tokens = (0, _indexJsDefault.default)(date, timezoneString);
    // ms dropped because it's not provided by tzTokenizeDate
    var asUTC = (0, _indexJsDefault1.default)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
    var asTS = date.getTime();
    var over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return asUTC - asTS;
}
function fixOffset(date, offset, timezoneString) {
    var localTS = date.getTime();
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - offset;
    // Test whether the zone matches the offset for this ts
    var o2 = calcOffset(new Date(utcGuess), timezoneString);
    // If so, offset didn't change, and we're done
    if (offset === o2) return offset;
    // If not, change the ts by the difference in the offset
    utcGuess -= o2 - offset;
    // If that gives us the local time we want, we're done
    var o3 = calcOffset(new Date(utcGuess), timezoneString);
    if (o2 === o3) return o2;
    // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
    return Math.max(o2, o3);
}
function validateTimezone(hours, minutes) {
    return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
var validIANATimezoneCache = {};
function isValidTimezoneIANAString(timeZoneString) {
    if (validIANATimezoneCache[timeZoneString]) return true;
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZoneString
        });
        validIANATimezoneCache[timeZoneString] = true;
        return true;
    } catch (error) {
        return false;
    }
}

},{"../tzTokenizeDate/index.js":"1EIzj","../newDateUTC/index.js":"kaQJK","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1EIzj":[function(require,module,exports,__globalThis) {
/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return tzTokenizeDate;
});
function tzTokenizeDate(date, timeZone) {
    var dtf = getDateTimeFormat(timeZone);
    return dtf.formatToParts ? partsOffset(dtf, date) : hackyOffset(dtf, date);
}
var typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function partsOffset(dtf, date) {
    try {
        var formatted = dtf.formatToParts(date);
        var filled = [];
        for(var i = 0; i < formatted.length; i++){
            var pos = typeToPos[formatted[i].type];
            if (pos >= 0) filled[pos] = parseInt(formatted[i].value, 10);
        }
        return filled;
    } catch (error) {
        if (error instanceof RangeError) return [
            NaN
        ];
        throw error;
    }
}
function hackyOffset(dtf, date) {
    var formatted = dtf.format(date);
    var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
    // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
    // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
    return [
        parsed[3],
        parsed[1],
        parsed[2],
        parsed[4],
        parsed[5],
        parsed[6]
    ];
}
// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
var dtfCache = {};
function getDateTimeFormat(timeZone) {
    if (!dtfCache[timeZone]) {
        // New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
        var testDateFormatted = new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: 'America/New_York',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }).format(new Date('2014-06-25T04:00:00.123Z'));
        var hourCycleSupported = testDateFormatted === '06/25/2014, 00:00:00' || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
        dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }) : new Intl.DateTimeFormat('en-US', {
            hour12: false,
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    }
    return dtfCache[timeZone];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"kaQJK":[function(require,module,exports,__globalThis) {
/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return newDateUTC;
});
function newDateUTC(fullYear, month, day, hour, minute, second, millisecond) {
    var utcDate = new Date(0);
    utcDate.setUTCFullYear(fullYear, month, day);
    utcDate.setUTCHours(hour, minute, second, millisecond);
    return utcDate;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"kyrsm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return toDate;
});
var _indexJs = require("date-fns/_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("date-fns/_lib/getTimezoneOffsetInMilliseconds/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/tzParseTimezone/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/tzPattern/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var MILLISECONDS_IN_HOUR = 3600000;
var MILLISECONDS_IN_MINUTE = 60000;
var DEFAULT_ADDITIONAL_DIGITS = 2;
var patterns = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    // year tokens
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    // date tokens
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    // time zone tokens (to identify the presence of a tz)
    timeZone: (0, _indexJsDefault3.default)
};
function toDate(argument, dirtyOptions) {
    if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    if (argument === null) return new Date(NaN);
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits == null ? DEFAULT_ADDITIONAL_DIGITS : (0, _indexJsDefault.default)(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') return new Date(argument);
    else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = splitDateString(argument);
    var parseYearResult = parseYear(dateStrings.date, additionalDigits);
    var year = parseYearResult.year;
    var restDateString = parseYearResult.restDateString;
    var date = parseDate(restDateString, year);
    if (isNaN(date)) return new Date(NaN);
    if (date) {
        var timestamp = date.getTime();
        var time = 0;
        var offset;
        if (dateStrings.time) {
            time = parseTime(dateStrings.time);
            if (isNaN(time)) return new Date(NaN);
        }
        if (dateStrings.timeZone || options.timeZone) {
            offset = (0, _indexJsDefault2.default)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
            if (isNaN(offset)) return new Date(NaN);
        } else {
            // get offset accurate to hour in time zones that change offset
            offset = (0, _indexJsDefault1.default)(new Date(timestamp + time));
            offset = (0, _indexJsDefault1.default)(new Date(timestamp + time + offset));
        }
        return new Date(timestamp + time + offset);
    } else return new Date(NaN);
}
function splitDateString(dateString) {
    var dateStrings = {};
    var parts = patterns.dateTimePattern.exec(dateString);
    var timeString;
    if (!parts) {
        parts = patterns.datePattern.exec(dateString);
        if (parts) {
            dateStrings.date = parts[1];
            timeString = parts[2];
        } else {
            dateStrings.date = null;
            timeString = dateString;
        }
    } else {
        dateStrings.date = parts[1];
        timeString = parts[3];
    }
    if (timeString) {
        var token = patterns.timeZone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timeZone = token[1].trim();
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function parseYear(dateString, additionalDigits) {
    var patternYYY = patterns.YYY[additionalDigits];
    var patternYYYYY = patterns.YYYYY[additionalDigits];
    var token;
    // YYYY or ±YYYYY
    token = patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
    if (token) {
        var yearString = token[1];
        return {
            year: parseInt(yearString, 10),
            restDateString: dateString.slice(yearString.length)
        };
    }
    // YY or ±YYY
    token = patterns.YY.exec(dateString) || patternYYY.exec(dateString);
    if (token) {
        var centuryString = token[1];
        return {
            year: parseInt(centuryString, 10) * 100,
            restDateString: dateString.slice(centuryString.length)
        };
    }
    // Invalid ISO-formatted year
    return {
        year: null
    };
}
function parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    var token;
    var date;
    var month;
    var week;
    // YYYY
    if (dateString.length === 0) {
        date = new Date(0);
        date.setUTCFullYear(year);
        return date;
    }
    // YYYY-MM
    token = patterns.MM.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        if (!validateDate(year, month)) return new Date(NaN);
        date.setUTCFullYear(year, month);
        return date;
    }
    // YYYY-DDD or YYYYDDD
    token = patterns.DDD.exec(dateString);
    if (token) {
        date = new Date(0);
        var dayOfYear = parseInt(token[1], 10);
        if (!validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
    }
    // yyyy-MM-dd or YYYYMMDD
    token = patterns.MMDD.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        var day = parseInt(token[2], 10);
        if (!validateDate(year, month, day)) return new Date(NaN);
        date.setUTCFullYear(year, month, day);
        return date;
    }
    // YYYY-Www or YYYYWww
    token = patterns.Www.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        if (!validateWeekDate(year, week)) return new Date(NaN);
        return dayOfISOWeekYear(year, week);
    }
    // YYYY-Www-D or YYYYWwwD
    token = patterns.WwwD.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        var dayOfWeek = parseInt(token[2], 10) - 1;
        if (!validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return dayOfISOWeekYear(year, week, dayOfWeek);
    }
    // Invalid ISO-formatted date
    return null;
}
function parseTime(timeString) {
    var token;
    var hours;
    var minutes;
    // hh
    token = patterns.HH.exec(timeString);
    if (token) {
        hours = parseFloat(token[1].replace(',', '.'));
        if (!validateTime(hours)) return NaN;
        return hours % 24 * MILLISECONDS_IN_HOUR;
    }
    // hh:mm or hhmm
    token = patterns.HHMM.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(',', '.'));
        if (!validateTime(hours, minutes)) return NaN;
        return hours % 24 * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE;
    }
    // hh:mm:ss or hhmmss
    token = patterns.HHMMSS.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        var seconds = parseFloat(token[3].replace(',', '.'));
        if (!validateTime(hours, minutes, seconds)) return NaN;
        return hours % 24 * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE + seconds * 1000;
    }
    // Invalid ISO-formatted time
    return null;
}
function dayOfISOWeekYear(isoWeekYear, week, day) {
    week = week || 0;
    day = day || 0;
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
var DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function validateDate(year, month, date) {
    if (month < 0 || month > 11) return false;
    if (date != null) {
        if (date < 1) return false;
        var isLeapYear = isLeapYearIndex(year);
        if (isLeapYear && date > DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
        if (!isLeapYear && date > DAYS_IN_MONTH[month]) return false;
    }
    return true;
}
function validateDayOfYearDate(year, dayOfYear) {
    if (dayOfYear < 1) return false;
    var isLeapYear = isLeapYearIndex(year);
    if (isLeapYear && dayOfYear > 366) return false;
    if (!isLeapYear && dayOfYear > 365) return false;
    return true;
}
function validateWeekDate(year, week, day) {
    if (week < 0 || week > 52) return false;
    if (day != null && (day < 0 || day > 6)) return false;
    return true;
}
function validateTime(hours, minutes, seconds) {
    if (hours != null && (hours < 0 || hours >= 25)) return false;
    if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
    if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
    return true;
}

},{"date-fns/_lib/toInteger/index.js":"6aYrL","date-fns/_lib/getTimezoneOffsetInMilliseconds/index.js":"hrqxc","../_lib/tzParseTimezone/index.js":"1aZe8","../_lib/tzPattern/index.js":"je5EQ","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"je5EQ":[function(require,module,exports,__globalThis) {
/** Regex to identify the presence of a time zone specifier in a date string */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
exports.default = tzPattern;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4gMyy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return formatInTimeZone;
});
var _indexJs = require("date-fns/_lib/cloneObject/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../format/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../utcToZonedTime/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function formatInTimeZone(date, timeZone, formatStr, options) {
    var extendedOptions = (0, _indexJsDefault.default)(options);
    extendedOptions.timeZone = timeZone;
    extendedOptions.originalDate = date;
    return (0, _indexJsDefault1.default)((0, _indexJsDefault2.default)(date, timeZone), formatStr, extendedOptions);
}

},{"date-fns/_lib/cloneObject/index.js":"lWBm1","../format/index.js":"3pIQ8","../utcToZonedTime/index.js":"jvA4D","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"lWBm1":[function(require,module,exports,__globalThis) {
"use strict";
var _interopRequireDefault = require("5e3b3a63c9853a03").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = cloneObject;
var _index = _interopRequireDefault(require("2860cdd56cd43392"));
function cloneObject(object) {
    return (0, _index.default)({}, object);
}
module.exports = exports.default;

},{"5e3b3a63c9853a03":"iZ6pp","2860cdd56cd43392":"6HFhG"}],"6HFhG":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = assign;
function assign(target, object) {
    if (target == null) throw new TypeError('assign requires that input parameter not be null or undefined');
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}
module.exports = exports.default;

},{}],"jvA4D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return utcToZonedTime;
});
var _indexJs = require("../_lib/tzParseTimezone/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function utcToZonedTime(dirtyDate, timeZone, options) {
    var date = (0, _indexJsDefault1.default)(dirtyDate, options);
    var offsetMilliseconds = (0, _indexJsDefault.default)(timeZone, date, true);
    var d = new Date(date.getTime() - offsetMilliseconds);
    var resultDate = new Date(0);
    resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
    return resultDate;
}

},{"../_lib/tzParseTimezone/index.js":"1aZe8","../toDate/index.js":"kyrsm","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4bIo8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getTimezoneOffset;
});
var _indexJs = require("../_lib/tzParseTimezone/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function getTimezoneOffset(timeZone, date) {
    return -(0, _indexJsDefault.default)(timeZone, date);
}

},{"../_lib/tzParseTimezone/index.js":"1aZe8","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"ccSgm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return zonedTimeToUtc;
});
var _indexJs = require("date-fns/_lib/cloneObject/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/tzPattern/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/tzParseTimezone/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../_lib/newDateUTC/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
function zonedTimeToUtc(date, timeZone, options) {
    if (typeof date === 'string' && !date.match((0, _indexJsDefault2.default))) {
        var extendedOptions = (0, _indexJsDefault.default)(options);
        extendedOptions.timeZone = timeZone;
        return (0, _indexJsDefault1.default)(date, extendedOptions);
    }
    var d = (0, _indexJsDefault1.default)(date, options);
    var utc = (0, _indexJsDefault4.default)(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds(), d.getMilliseconds()).getTime();
    var offsetMilliseconds = (0, _indexJsDefault3.default)(timeZone, new Date(utc));
    return new Date(utc + offsetMilliseconds);
}

},{"date-fns/_lib/cloneObject/index.js":"lWBm1","../toDate/index.js":"kyrsm","../_lib/tzPattern/index.js":"je5EQ","../_lib/tzParseTimezone/index.js":"1aZe8","../_lib/newDateUTC/index.js":"kaQJK","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"g4MAO":[function(require,module,exports,__globalThis) {
var _defineProperty = require("@swc/helpers/_/_define_property");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DogBreeds = exports.dogBreedsMapping = exports.dogBreedToName = exports.dogBreedFromName = void 0;
var unwrap_1 = require("d67ac185aa60fd24");
function dogBreedFromName(name) {
    var key = Object.keys(exports.DogBreeds).map(function(key) {
        return Number(key);
    }).find(function(key) {
        return exports.DogBreeds[key].toLowerCase() === name.toLowerCase();
    });
    return (0, unwrap_1.unwrap)(key);
}
exports.dogBreedFromName = dogBreedFromName;
function dogBreedToName(breed) {
    return exports.DogBreeds[breed];
}
exports.dogBreedToName = dogBreedToName;
function dogBreedsMapping() {
    var mapping = {};
    Object.keys(exports.DogBreeds).forEach(function(key) {
        var id = Number(key);
        var name = exports.DogBreeds[id];
        mapping[name] = id;
    });
    return mapping;
}
exports.dogBreedsMapping = dogBreedsMapping;
var _obj;
exports.DogBreeds = (_obj = {}, (0, _defineProperty._)(_obj, 1, "Affenpinscher"), (0, _defineProperty._)(_obj, 2, "Airedale Terrier"), (0, _defineProperty._)(_obj, 3, "Akita Am\xe9ricain"), (0, _defineProperty._)(_obj, 4, "Akita Inu"), (0, _defineProperty._)(_obj, 5, "Altdeutscher sch\xe4ferhund"), (0, _defineProperty._)(_obj, 6, "American Bully"), (0, _defineProperty._)(_obj, 7, "American Hairless Terrier"), (0, _defineProperty._)(_obj, 8, "American Pit Bull Terrier"), (0, _defineProperty._)(_obj, 9, "American Stafford Terrier"), (0, _defineProperty._)(_obj, 10, "Ancien chien d'arr\xeat danois"), (0, _defineProperty._)(_obj, 11, "Anglo-fran\xe7ais de petite v\xe9nerie"), (0, _defineProperty._)(_obj, 12, "Ari\xe9geois"), (0, _defineProperty._)(_obj, 13, "Australian Kelpie"), (0, _defineProperty._)(_obj, 14, "Azawakh"), (0, _defineProperty._)(_obj, 15, "Bangkaew de Tha\xeflande"), (0, _defineProperty._)(_obj, 16, "Barbet"), (0, _defineProperty._)(_obj, 17, "Barbu Tch\xe8que"), (0, _defineProperty._)(_obj, 18, "Barzo\xef"), (0, _defineProperty._)(_obj, 19, "Basenji"), (0, _defineProperty._)(_obj, 20, "Basset Art\xe9sien Normand"), (0, _defineProperty._)(_obj, 21, "Basset bleu de Gascogne"), (0, _defineProperty._)(_obj, 22, "Basset de Westphalie"), (0, _defineProperty._)(_obj, 23, "Basset des Alpes"), (0, _defineProperty._)(_obj, 24, "Basset fauve de Bretagne"), (0, _defineProperty._)(_obj, 25, "Basset Hound"), (0, _defineProperty._)(_obj, 26, "Basset Su\xe9dois"), (0, _defineProperty._)(_obj, 27, "Beagle"), (0, _defineProperty._)(_obj, 28, "Beagle Harrier"), (0, _defineProperty._)(_obj, 29, "Beagle terrier"), (0, _defineProperty._)(_obj, 30, "Bearded Collie"), (0, _defineProperty._)(_obj, 31, "Beauceron"), (0, _defineProperty._)(_obj, 32, "Bedlington Terrier"), (0, _defineProperty._)(_obj, 33, "Berger Allemand"), (0, _defineProperty._)(_obj, 34, "Berger Am\xe9ricain miniature"), (0, _defineProperty._)(_obj, 35, "Berger Australien"), (0, _defineProperty._)(_obj, 36, "Berger Belge"), (0, _defineProperty._)(_obj, 37, "Berger Belge Groenendael"), (0, _defineProperty._)(_obj, 38, "Berger belge malinois"), (0, _defineProperty._)(_obj, 39, "Berger Belge Tervueren"), (0, _defineProperty._)(_obj, 40, "Berger Blanc Suisse"), (0, _defineProperty._)(_obj, 41, "Berger catalan"), (0, _defineProperty._)(_obj, 42, "Berger Cr\xe9ole"), (0, _defineProperty._)(_obj, 43, "Berger d'Anatolie"), (0, _defineProperty._)(_obj, 44, "Berger d'Asie Centrale"), (0, _defineProperty._)(_obj, 45, "Berger d'Auvergne"), (0, _defineProperty._)(_obj, 46, "Berger de Beauce"), (0, _defineProperty._)(_obj, 47, "Berger de Bergame"), (0, _defineProperty._)(_obj, 48, "Berger de Boh\xeame"), (0, _defineProperty._)(_obj, 49, "Berger de Bosnie-Herz\xe9govine et de Croatie"), (0, _defineProperty._)(_obj, 50, "Berger de Brie"), (0, _defineProperty._)(_obj, 51, "Berger de l'Atlas"), (0, _defineProperty._)(_obj, 52, "Berger de la serra de aires"), (0, _defineProperty._)(_obj, 53, "Berger de la Serra des Aires"), (0, _defineProperty._)(_obj, 54, "Berger de Maremme et Abruzzes"), (0, _defineProperty._)(_obj, 55, "Berger de Russie m\xe9ridionale"), (0, _defineProperty._)(_obj, 56, "Berger des Pyr\xe9n\xe9es"), (0, _defineProperty._)(_obj, 57, "Berger des shetland"), (0, _defineProperty._)(_obj, 58, "Berger du Caucase"), (0, _defineProperty._)(_obj, 59, "Berger du Karst"), (0, _defineProperty._)(_obj, 60, "Berger Finnois de Laponie"), (0, _defineProperty._)(_obj, 61, "Berger Hollandais"), (0, _defineProperty._)(_obj, 62, "Berger Islandais"), (0, _defineProperty._)(_obj, 63, "Berger Kangal"), (0, _defineProperty._)(_obj, 64, "Berger Picard"), (0, _defineProperty._)(_obj, 65, "Berger Polonais de plaine"), (0, _defineProperty._)(_obj, 66, "Berger Roumain des Carpathes"), (0, _defineProperty._)(_obj, 67, "Berger Yougoslave"), (0, _defineProperty._)(_obj, 68, "Berger Yougoslave de Charplanina"), (0, _defineProperty._)(_obj, 69, "Bichon boulonais"), (0, _defineProperty._)(_obj, 70, "Bichon Fris\xe9"), (0, _defineProperty._)(_obj, 71, "Bichon Havanais"), (0, _defineProperty._)(_obj, 72, "Bichon Maltais"), (0, _defineProperty._)(_obj, 73, "Biewer Yorkshire"), (0, _defineProperty._)(_obj, 74, "Billy"), (0, _defineProperty._)(_obj, 75, "Bobtail"), (0, _defineProperty._)(_obj, 76, "Boerbull"), (0, _defineProperty._)(_obj, 77, "Border Collie"), (0, _defineProperty._)(_obj, 78, "Border Terrier"), (0, _defineProperty._)(_obj, 79, "Boston terrier"), (0, _defineProperty._)(_obj, 80, "Bouledogue"), (0, _defineProperty._)(_obj, 81, "Bouledogue am\xe9ricain"), (0, _defineProperty._)(_obj, 82, "Bouledogue Anglais"), (0, _defineProperty._)(_obj, 83, "Bouledogue Fran\xe7ais"), (0, _defineProperty._)(_obj, 84, "Bouvier Australien"), (0, _defineProperty._)(_obj, 85, "Bouvier Bernois"), (0, _defineProperty._)(_obj, 86, "Bouvier de l'Appenzell"), (0, _defineProperty._)(_obj, 87, "Bouvier de l'Entlebuch"), (0, _defineProperty._)(_obj, 88, "Bouvier des Ardennes"), (0, _defineProperty._)(_obj, 89, "Bouvier des Flandres"), (0, _defineProperty._)(_obj, 90, "Boxer"), (0, _defineProperty._)(_obj, 91, "Brachet Allemand"), (0, _defineProperty._)(_obj, 92, "Brachet de styrue \xe0 poil dur"), (0, _defineProperty._)(_obj, 93, "Brachet noir et feu"), (0, _defineProperty._)(_obj, 94, "Brachet Polonais"), (0, _defineProperty._)(_obj, 95, "Brachet tyrolien"), (0, _defineProperty._)(_obj, 96, "Braque Allemand \xe0 poil court"), (0, _defineProperty._)(_obj, 97, "Braque allemand \xe0 poil dur"), (0, _defineProperty._)(_obj, 98, "Braque d'Auvergne"), (0, _defineProperty._)(_obj, 99, "Braque de bourbonnais"), (0, _defineProperty._)(_obj, 100, "Braque de burgos"), (0, _defineProperty._)(_obj, 101, "Braque de l'Ari\xe8ge"), (0, _defineProperty._)(_obj, 102, "Braque de saint germain"), (0, _defineProperty._)(_obj, 103, "Braque de Weimar"), (0, _defineProperty._)(_obj, 104, "Braque Fran\xe7ais"), (0, _defineProperty._)(_obj, 105, "Braque Hongrois \xe0 poil court"), (0, _defineProperty._)(_obj, 106, "Braque Hongrois \xe0 poil dur"), (0, _defineProperty._)(_obj, 107, "Braque Italien"), (0, _defineProperty._)(_obj, 108, "Briquet Griffon Vend\xe9en"), (0, _defineProperty._)(_obj, 109, "Broholmer"), (0, _defineProperty._)(_obj, 110, "Bruno du Jura"), (0, _defineProperty._)(_obj, 111, "Buhund Norv\xe9gien"), (0, _defineProperty._)(_obj, 112, "Bull Terrier"), (0, _defineProperty._)(_obj, 113, "Bull terrier miniature"), (0, _defineProperty._)(_obj, 114, "Bulldog anglais"), (0, _defineProperty._)(_obj, 115, "Bullmastiff"), (0, _defineProperty._)(_obj, 116, "Cairn Terrier"), (0, _defineProperty._)(_obj, 117, "Cane Corso"), (0, _defineProperty._)(_obj, 118, "Caniche"), (0, _defineProperty._)(_obj, 119, "Caniche Moyen"), (0, _defineProperty._)(_obj, 120, "Caniche Nain"), (0, _defineProperty._)(_obj, 121, "Caniche Royal"), (0, _defineProperty._)(_obj, 122, "Caniche Toy"), (0, _defineProperty._)(_obj, 123, "Cao de castro laboreiro"), (0, _defineProperty._)(_obj, 124, "Carlin"), (0, _defineProperty._)(_obj, 125, "Cavalier King Charles"), (0, _defineProperty._)(_obj, 126, "Cavalier King Charles Spaniel"), (0, _defineProperty._)(_obj, 127, "Chien Chanteur de Nouvelle Guin\xe9e"), (0, _defineProperty._)(_obj, 128, "Chien Chinois \xe0 cr\xeate"), (0, _defineProperty._)(_obj, 129, "Chien Courant"), (0, _defineProperty._)(_obj, 130, "Chien courant finnois"), (0, _defineProperty._)(_obj, 131, "Chien d'Arr\xeat"), (0, _defineProperty._)(_obj, 132, "Chien d'arr\xeat allemand \xe0 poil dur"), (0, _defineProperty._)(_obj, 133, "Chien d'arr\xeat Portugais"), (0, _defineProperty._)(_obj, 134, "Chien d'Artois"), (0, _defineProperty._)(_obj, 135, "Chien d'eau am\xe9ricain"), (0, _defineProperty._)(_obj, 136, "Chien d'eau irlandais"), (0, _defineProperty._)(_obj, 137, "Chien d'Eau portugais"), (0, _defineProperty._)(_obj, 138, "Chien d'eau Romagnol"), (0, _defineProperty._)(_obj, 139, "Chien d'Elan Norv\xe9gien"), (0, _defineProperty._)(_obj, 140, "Chien d'\xe9lan norv\xe9gien gris"), (0, _defineProperty._)(_obj, 141, "Chien de berger yougoslave de Charplanina"), (0, _defineProperty._)(_obj, 142, "Chien de canaan"), (0, _defineProperty._)(_obj, 143, "Chien de montagne des pyrenees"), (0, _defineProperty._)(_obj, 144, "Chien de montagne portugais"), (0, _defineProperty._)(_obj, 145, "Chien de recherche au sang de la montagne bavaroise"), (0, _defineProperty._)(_obj, 146, "Chien de Saint Hubert"), (0, _defineProperty._)(_obj, 147, "Chien du pharaon"), (0, _defineProperty._)(_obj, 148, "Chien Finnois de Laponie"), (0, _defineProperty._)(_obj, 149, "Chien loup de saaloos"), (0, _defineProperty._)(_obj, 150, "Chien loup tchecoslovaque"), (0, _defineProperty._)(_obj, 151, "Chien noir et feu pour la chasse au raton laveur"), (0, _defineProperty._)(_obj, 152, "Chien Tha\xeflandais \xe0 cr\xeate dorsale"), (0, _defineProperty._)(_obj, 153, "Chien-loup de Saarloos"), (0, _defineProperty._)(_obj, 154, "Chien-Loup Tch\xe9coslovaque"), (0, _defineProperty._)(_obj, 155, "Chihuahua"), (0, _defineProperty._)(_obj, 156, "Chow-Chow"), (0, _defineProperty._)(_obj, 157, "Clumber Spaniel"), (0, _defineProperty._)(_obj, 158, "Cocker"), (0, _defineProperty._)(_obj, 159, "Cocker Am\xe9ricain"), (0, _defineProperty._)(_obj, 160, "Cocker Spaniel Anglais"), (0, _defineProperty._)(_obj, 161, "Colley \xe0 poils long"), (0, _defineProperty._)(_obj, 162, "Colley \xe0 poils longs"), (0, _defineProperty._)(_obj, 163, "Continental Bulldog"), (0, _defineProperty._)(_obj, 164, "Coton de Tul\xe9ar"), (0, _defineProperty._)(_obj, 165, "Curly coated retriever"), (0, _defineProperty._)(_obj, 166, "Cursinu"), (0, _defineProperty._)(_obj, 167, "Dalmatien"), (0, _defineProperty._)(_obj, 168, "Dandie Dinmont Terrier"), (0, _defineProperty._)(_obj, 169, "Deerhound"), (0, _defineProperty._)(_obj, 170, "Dingo"), (0, _defineProperty._)(_obj, 171, "Dobermann"), (0, _defineProperty._)(_obj, 172, "Dogo canario"), (0, _defineProperty._)(_obj, 173, "Dogue Allemand"), (0, _defineProperty._)(_obj, 174, "Dogue Argentin"), (0, _defineProperty._)(_obj, 175, "Dogue de Bordeaux"), (0, _defineProperty._)(_obj, 176, "Dogue de Majorque"), (0, _defineProperty._)(_obj, 177, "Dogue des Canaries"), (0, _defineProperty._)(_obj, 178, "Dogue du Tibet"), (0, _defineProperty._)(_obj, 179, "Drahthaar"), (0, _defineProperty._)(_obj, 180, "Drever"), (0, _defineProperty._)(_obj, 181, "Dunker"), (0, _defineProperty._)(_obj, 182, "English toy terrier"), (0, _defineProperty._)(_obj, 183, "Epagneul"), (0, _defineProperty._)(_obj, 184, "Epagneul Bleu de Picardie"), (0, _defineProperty._)(_obj, 185, "Epagneul Breton"), (0, _defineProperty._)(_obj, 186, "Epagneul d'eau Irlandais"), (0, _defineProperty._)(_obj, 187, "Epagneul de M\xfcnster"), (0, _defineProperty._)(_obj, 188, "Epagneul de pont audemer"), (0, _defineProperty._)(_obj, 189, "\xc9pagneul fran\xe7ais"), (0, _defineProperty._)(_obj, 190, "Epagneul Japonais"), (0, _defineProperty._)(_obj, 191, "Epagneul Nain Continental Papillon"), (0, _defineProperty._)(_obj, 192, "Epagneul Picard"), (0, _defineProperty._)(_obj, 193, "Epagneul Tib\xe9tain"), (0, _defineProperty._)(_obj, 194, "Eurasier"), (0, _defineProperty._)(_obj, 195, "Field spaniel"), (0, _defineProperty._)(_obj, 196, "Fila brasileiro"), (0, _defineProperty._)(_obj, 197, "Fila de Sao Miguel"), (0, _defineProperty._)(_obj, 198, "Flat coat retriever"), (0, _defineProperty._)(_obj, 199, "Fox Terrier \xe0 poil dur"), (0, _defineProperty._)(_obj, 200, "Fox terrier \xe0 poil lisse"), (0, _defineProperty._)(_obj, 201, "Foxhound anglais"), (0, _defineProperty._)(_obj, 202, "Golden Retriever"), (0, _defineProperty._)(_obj, 203, "Gos d'Atura Catal\xe0"), (0, _defineProperty._)(_obj, 204, "Grand basset griffon vend\xe9en"), (0, _defineProperty._)(_obj, 205, "Grand Bleu de Gascogne"), (0, _defineProperty._)(_obj, 206, "Grand Bouvier Suisse"), (0, _defineProperty._)(_obj, 207, "Greyhound"), (0, _defineProperty._)(_obj, 208, "Griffon"), (0, _defineProperty._)(_obj, 209, "Griffon Bruxellois"), (0, _defineProperty._)(_obj, 210, "Griffon d'arr\xeat \xe0 poil dur Korthals"), (0, _defineProperty._)(_obj, 211, "Griffon Korthal"), (0, _defineProperty._)(_obj, 212, "Griffon Nivernais"), (0, _defineProperty._)(_obj, 213, "Hamiltonst\xf6vare"), (0, _defineProperty._)(_obj, 214, "Harrier"), (0, _defineProperty._)(_obj, 215, "Hokkaido Ken"), (0, _defineProperty._)(_obj, 216, "Hovawart"), (0, _defineProperty._)(_obj, 217, "Husky de Sib\xe9rie"), (0, _defineProperty._)(_obj, 218, "Irish Terrier"), (0, _defineProperty._)(_obj, 219, "Irish Wolfhound"), (0, _defineProperty._)(_obj, 220, "Jack Russel Parson"), (0, _defineProperty._)(_obj, 221, "Jack Russell Terrier"), (0, _defineProperty._)(_obj, 222, "Jindo Cor\xe9en"), (0, _defineProperty._)(_obj, 223, "Kai"), (0, _defineProperty._)(_obj, 224, "Kerry Blue Terrier"), (0, _defineProperty._)(_obj, 225, "King charles spaniel"), (0, _defineProperty._)(_obj, 226, "Kishu"), (0, _defineProperty._)(_obj, 227, "Komondor"), (0, _defineProperty._)(_obj, 228, "Labrador Retriever"), (0, _defineProperty._)(_obj, 229, "Labrit"), (0, _defineProperty._)(_obj, 230, "La\xefka"), (0, _defineProperty._)(_obj, 231, "Lakeland Terrier"), (0, _defineProperty._)(_obj, 232, "Landseer"), (0, _defineProperty._)(_obj, 233, "Leonberg"), (0, _defineProperty._)(_obj, 234, "L\xe9vrier"), (0, _defineProperty._)(_obj, 235, "L\xe9vrier Afghan"), (0, _defineProperty._)(_obj, 236, "L\xe9vrier Espagnol"), (0, _defineProperty._)(_obj, 237, "L\xe9vrier Greyhound"), (0, _defineProperty._)(_obj, 238, "L\xe9vrier Hongrois"), (0, _defineProperty._)(_obj, 239, "L\xe9vrier persan"), (0, _defineProperty._)(_obj, 240, "L\xe9vrier Polonais"), (0, _defineProperty._)(_obj, 241, "Levrier Whippet"), (0, _defineProperty._)(_obj, 242, "Lhassa Apso"), (0, _defineProperty._)(_obj, 243, "Loulou de Pom\xe9ranie"), (0, _defineProperty._)(_obj, 244, "Malamute de l'Alaska"), (0, _defineProperty._)(_obj, 245, "Malinois"), (0, _defineProperty._)(_obj, 246, "Manchester Terrier"), (0, _defineProperty._)(_obj, 247, "Mastiff"), (0, _defineProperty._)(_obj, 248, "Matin de Naples"), (0, _defineProperty._)(_obj, 249, "M\xe2tin espagnol"), (0, _defineProperty._)(_obj, 250, "M\xe2tin napolitain"), (0, _defineProperty._)(_obj, 251, "Montagne des Pyr\xe9n\xe9es"), (0, _defineProperty._)(_obj, 252, "Mudi"), (0, _defineProperty._)(_obj, 253, "Munchkin"), (0, _defineProperty._)(_obj, 254, "new english bulldog"), (0, _defineProperty._)(_obj, 255, "Norfolk Terrier"), (0, _defineProperty._)(_obj, 256, "Norwich Terrier"), (0, _defineProperty._)(_obj, 257, "Nu du P\xe9rou"), (0, _defineProperty._)(_obj, 258, "Old English Bulldog"), (0, _defineProperty._)(_obj, 259, "Otterhound"), (0, _defineProperty._)(_obj, 260, "Parson Russel Terrier"), (0, _defineProperty._)(_obj, 261, "Parson Russell Terrier"), (0, _defineProperty._)(_obj, 262, "P\xe9kinois"), (0, _defineProperty._)(_obj, 263, "Petit Braban\xe7on"), (0, _defineProperty._)(_obj, 264, "Petit Chiens Lions"), (0, _defineProperty._)(_obj, 265, "Petit L\xe9vrier Italien"), (0, _defineProperty._)(_obj, 266, "Phu Qu\xf4c Ridgeback"), (0, _defineProperty._)(_obj, 267, "Pinscher"), (0, _defineProperty._)(_obj, 268, "Pinscher nain"), (0, _defineProperty._)(_obj, 269, "Pinsher Allemand"), (0, _defineProperty._)(_obj, 270, "Pitbull"), (0, _defineProperty._)(_obj, 271, "Podenco"), (0, _defineProperty._)(_obj, 272, "Pointer anglais"), (0, _defineProperty._)(_obj, 273, "Puli"), (0, _defineProperty._)(_obj, 274, "Pumi"), (0, _defineProperty._)(_obj, 275, "Ratier de Prague"), (0, _defineProperty._)(_obj, 276, "Retriever \xe0 poil boucl\xe9"), (0, _defineProperty._)(_obj, 277, "Retriever \xe0 poil plat"), (0, _defineProperty._)(_obj, 278, "Retriever de la baie de Chesapeake"), (0, _defineProperty._)(_obj, 279, "Retriever de la Nouvelle-\xc9cosse"), (0, _defineProperty._)(_obj, 280, "Rhodesian Ridgeback"), (0, _defineProperty._)(_obj, 281, "Rottweiler"), (0, _defineProperty._)(_obj, 282, "Rouge du Hanovre"), (0, _defineProperty._)(_obj, 283, "Royal Bourbon"), (0, _defineProperty._)(_obj, 284, "Saint-Bernard"), (0, _defineProperty._)(_obj, 285, "Samoy\xe8de"), (0, _defineProperty._)(_obj, 286, "Schipperke"), (0, _defineProperty._)(_obj, 287, "Schipperke"), (0, _defineProperty._)(_obj, 288, "Schnauzer"), (0, _defineProperty._)(_obj, 289, "Schnauzer G\xe9ant"), (0, _defineProperty._)(_obj, 290, "Schnauzer miniature"), (0, _defineProperty._)(_obj, 291, "Schnauzer Moyen"), (0, _defineProperty._)(_obj, 292, "Sealyham Terrier"), (0, _defineProperty._)(_obj, 293, "Setter anglais"), (0, _defineProperty._)(_obj, 294, "Setter Gordon"), (0, _defineProperty._)(_obj, 295, "Setter Irlandais Irlandais"), (0, _defineProperty._)(_obj, 296, "Setter irlandais rouge"), (0, _defineProperty._)(_obj, 297, "Setter Llewellin"), (0, _defineProperty._)(_obj, 298, "Shar Pei"), (0, _defineProperty._)(_obj, 299, "Shetland"), (0, _defineProperty._)(_obj, 300, "Shiba"), (0, _defineProperty._)(_obj, 301, "Shiba inu"), (0, _defineProperty._)(_obj, 302, "Shih Tzu"), (0, _defineProperty._)(_obj, 303, "Shikoku"), (0, _defineProperty._)(_obj, 304, "Skye Terrier"), (0, _defineProperty._)(_obj, 305, "Spinone"), (0, _defineProperty._)(_obj, 306, "Spitz Allemand"), (0, _defineProperty._)(_obj, 307, "Spitz des Wisigoths"), (0, _defineProperty._)(_obj, 308, "Spitz Finlandais"), (0, _defineProperty._)(_obj, 309, "Spitz Japonais"), (0, _defineProperty._)(_obj, 310, "Spitz loup"), (0, _defineProperty._)(_obj, 311, "Springer Anglais"), (0, _defineProperty._)(_obj, 312, "Staffordshire Bull Terrier"), (0, _defineProperty._)(_obj, 313, "Sussex Spaniel"), (0, _defineProperty._)(_obj, 314, "Teckel"), (0, _defineProperty._)(_obj, 315, "Teckel Nain"), (0, _defineProperty._)(_obj, 316, "Terre-Neuve"), (0, _defineProperty._)(_obj, 317, "Terrier Australien"), (0, _defineProperty._)(_obj, 318, "Terrier br\xe9silien"), (0, _defineProperty._)(_obj, 319, "Terrier de Boston"), (0, _defineProperty._)(_obj, 320, "Terrier de chasse allemand"), (0, _defineProperty._)(_obj, 321, "Terrier de Norwich"), (0, _defineProperty._)(_obj, 322, "Terrier Ecossais"), (0, _defineProperty._)(_obj, 323, "Terrier Irlandais"), (0, _defineProperty._)(_obj, 324, "Terrier Japonais"), (0, _defineProperty._)(_obj, 325, "Terrier Noir Russe"), (0, _defineProperty._)(_obj, 326, "Terrier Tch\xe8que"), (0, _defineProperty._)(_obj, 327, "Terrier Tib\xe9tain"), (0, _defineProperty._)(_obj, 328, "Tosa"), (0, _defineProperty._)(_obj, 329, "Volpino italien"), (0, _defineProperty._)(_obj, 330, "Welsh Corgi Cardigan"), (0, _defineProperty._)(_obj, 331, "Welsh Corgi Pembroke"), (0, _defineProperty._)(_obj, 332, "Welsh Springer Spaniel"), (0, _defineProperty._)(_obj, 333, "Welsh terrier"), (0, _defineProperty._)(_obj, 334, "West Highland White Terrier"), (0, _defineProperty._)(_obj, 335, "Whippet"), (0, _defineProperty._)(_obj, 336, "Yorkshire Terrier"), _obj);

},{"@swc/helpers/_/_define_property":"54Zvk","d67ac185aa60fd24":"iXNqV"}],"l6DuW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rootReducer", function() {
    return rootReducer;
});
var _redux = require("redux");
var _views = require("./state/views");
var _data = require("./state/data");
var _sections = require("../../../../sections");
var _components = require("../../../../snippets/components");
var rootReducer = (0, _redux.combineReducers)({
    data: (0, _data.dataReducer),
    views: (0, _views.viewsReducer),
    sections: (0, _sections.sectionsReducer),
    components: (0, _components.componentsReducer)
});

},{"redux":"lKoa8","./state/views":"35REj","./state/data":"lHdM3","../../../../sections":"8H2M7","../../../../snippets/components":"1f8Ky","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"35REj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "viewsReducer", function() {
    return viewsReducer;
});
var _redux = require("redux");
var _intakeCalculator = require("./intakeCalculator");
var _account = require("./account");
var viewsReducer = (0, _redux.combineReducers)({
    intakeCalculator: (0, _intakeCalculator.intakeCalculatorViewReducer),
    account: (0, _account.accountViewReducer)
});

},{"redux":"lKoa8","./intakeCalculator":"eDiK8","./account":"48PeC","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"eDiK8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IntakeCalculationStatus", function() {
    return IntakeCalculationStatus;
});
parcelHelpers.export(exports, "intakeCalculatorViewReducer", function() {
    return intakeCalculatorViewReducer;
});
parcelHelpers.export(exports, "intakeCalculatorViewSelector", function() {
    return intakeCalculatorViewSelector;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _intakeCalculator = require("../../../events/IntakeCalculator");
var _addProductToCart = require("../../../../../../snippets/components/cart/useCases/addProductToCart");
var IntakeCalculationStatus = /*#__PURE__*/ function(IntakeCalculationStatus) {
    IntakeCalculationStatus["WAITING_FOR_INPUTS"] = "WAITING_FOR_INPUTS";
    IntakeCalculationStatus["CALCULATING"] = "CALCULATING";
    IntakeCalculationStatus["CALCULATED"] = "CALCULATED";
    return IntakeCalculationStatus;
}({});
var initialState = {
    productId: null,
    opened: false,
    animalWeight: null,
    animalActivityLevel: null,
    status: "WAITING_FOR_INPUTS",
    dailyIntake: null,
    errors: [],
    recommendation: null
};
function intakeCalculatorViewReducer() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, event = arguments.length > 1 ? arguments[1] : void 0;
    switch(event.type){
        case 0, _intakeCalculator.OpenIntakeCalculatorKey:
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, initialState), {
                productId: event.payload.productId,
                opened: true
            });
        case 0, _intakeCalculator.CloseIntakeCalculatorKey:
        case 0, _addProductToCart.AddProductToCartKey:
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                opened: false
            });
        case 0, _intakeCalculator.SetIntakeCalculatorAnimalWeightKey:
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                animalWeight: event.payload.animalWeight
            });
        case 0, _intakeCalculator.SetIntakeCalculatorAnimalActivityLevelKey:
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                animalActivityLevel: event.payload.animalActivityLevel
            });
        case 0, _intakeCalculator.StartDailyIntakeCalculationKey:
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                status: "CALCULATING"
            });
        case 0, _intakeCalculator.ModifyIntakeCalulatorInputsKey:
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                status: "WAITING_FOR_INPUTS",
                errors: [],
                dailyIntake: null
            });
        case 0, _intakeCalculator.DailyIntakeCalculatedKey:
            var _event_payload = event.payload, dailyIntake = _event_payload.dailyIntake, recommendation = _event_payload.recommendation;
            var status = dailyIntake ? "CALCULATED" : "WAITING_FOR_INPUTS";
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                status: status,
                recommendation: recommendation
            });
        default:
            return state;
    }
}
function intakeCalculatorViewSelector(state) {
    return state.views.intakeCalculator;
}

},{"@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_object_spread_props":"fLCYP","../../../events/IntakeCalculator":"8FDos","../../../../../../snippets/components/cart/useCases/addProductToCart":"bC9NF","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8FDos":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OpenIntakeCalculatorKey", function() {
    return OpenIntakeCalculatorKey;
});
parcelHelpers.export(exports, "OpenIntakeCalculator", function() {
    return OpenIntakeCalculator;
});
parcelHelpers.export(exports, "CloseIntakeCalculatorKey", function() {
    return CloseIntakeCalculatorKey;
});
parcelHelpers.export(exports, "CloseIntakeCalculator", function() {
    return CloseIntakeCalculator;
});
parcelHelpers.export(exports, "IntakeCalculatorDataLoadedKey", function() {
    return IntakeCalculatorDataLoadedKey;
});
parcelHelpers.export(exports, "IntakeCalculatorDataLoaded", function() {
    return IntakeCalculatorDataLoaded;
});
parcelHelpers.export(exports, "SetIntakeCalculatorAnimalWeightKey", function() {
    return SetIntakeCalculatorAnimalWeightKey;
});
parcelHelpers.export(exports, "SetIntakeCalculatorAnimalWeight", function() {
    return SetIntakeCalculatorAnimalWeight;
});
parcelHelpers.export(exports, "SetIntakeCalculatorAnimalActivityLevelKey", function() {
    return SetIntakeCalculatorAnimalActivityLevelKey;
});
parcelHelpers.export(exports, "SetIntakeCalculatorAnimalActivityLevel", function() {
    return SetIntakeCalculatorAnimalActivityLevel;
});
parcelHelpers.export(exports, "CalculateDailyIntakeKey", function() {
    return CalculateDailyIntakeKey;
});
parcelHelpers.export(exports, "CalculateDailyIntake", function() {
    return CalculateDailyIntake;
});
parcelHelpers.export(exports, "StartDailyIntakeCalculationKey", function() {
    return StartDailyIntakeCalculationKey;
});
parcelHelpers.export(exports, "StartDailyIntakeCalculation", function() {
    return StartDailyIntakeCalculation;
});
parcelHelpers.export(exports, "DailyIntakeCalculatedKey", function() {
    return DailyIntakeCalculatedKey;
});
parcelHelpers.export(exports, "DailyIntakeCalculated", function() {
    return DailyIntakeCalculated;
});
parcelHelpers.export(exports, "ModifyIntakeCalulatorInputsKey", function() {
    return ModifyIntakeCalulatorInputsKey;
});
parcelHelpers.export(exports, "ModifyIntakeCalulatorInputs", function() {
    return ModifyIntakeCalulatorInputs;
});
var _eventFactory = require("../../std/eventFactory");
var OpenIntakeCalculatorKey = 'OpenIntakeCalculator';
var OpenIntakeCalculator = (0, _eventFactory.eventFactory)('OpenIntakeCalculator')();
var CloseIntakeCalculatorKey = 'CloseIntakeCalculator';
var CloseIntakeCalculator = (0, _eventFactory.eventFactory)('CloseIntakeCalculator')();
var IntakeCalculatorDataLoadedKey = 'IntakeCalculatorDataLoaded';
var IntakeCalculatorDataLoaded = (0, _eventFactory.eventFactory)('IntakeCalculatorDataLoaded')();
var SetIntakeCalculatorAnimalWeightKey = 'SetIntakeCalculatorAnimalWeight';
var SetIntakeCalculatorAnimalWeight = (0, _eventFactory.eventFactory)('SetIntakeCalculatorAnimalWeight')();
var SetIntakeCalculatorAnimalActivityLevelKey = 'SetIntakeCalculatorAnimalActivityLevel';
var SetIntakeCalculatorAnimalActivityLevel = (0, _eventFactory.eventFactory)('SetIntakeCalculatorAnimalActivityLevel')();
var CalculateDailyIntakeKey = 'CalculateDailyIntake';
var CalculateDailyIntake = (0, _eventFactory.eventFactory)('CalculateDailyIntake')();
var StartDailyIntakeCalculationKey = 'StartDailyIntakeCalculation';
var StartDailyIntakeCalculation = (0, _eventFactory.eventFactory)('StartDailyIntakeCalculation')();
var DailyIntakeCalculatedKey = 'DailyIntakeCalculated';
var DailyIntakeCalculated = (0, _eventFactory.eventFactory)('DailyIntakeCalculated')();
var ModifyIntakeCalulatorInputsKey = 'ModifyIntakeCalulatorInputs';
var ModifyIntakeCalulatorInputs = (0, _eventFactory.eventFactory)('ModifyIntakeCalulatorInputs')();

},{"../../std/eventFactory":"f2PpV","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"f2PpV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "eventFactory", function() {
    return eventFactory;
});
function eventFactory(type) {
    return function() {
        return function() {
            for(var _len = arguments.length, payload = new Array(_len), _key = 0; _key < _len; _key++){
                payload[_key] = arguments[_key];
            }
            return {
                type: type,
                payload: payload[0]
            };
        };
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"bC9NF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AddProductToCartKey", function() {
    return AddProductToCartKey;
});
parcelHelpers.export(exports, "AddProductToCart", function() {
    return AddProductToCart;
});
parcelHelpers.export(exports, "addProductToCart", function() {
    return addProductToCart;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _state = require("../state");
var _std = require("@reglo/std");
var _variants = require("../../../../script/src/app/store/state/data/variants");
var _updateCart = require("./updateCart");
var AddProductToCartKey = 'AddProductToCart';
var AddProductToCart = (0, _std.eventFactory)(AddProductToCartKey)();
function addProductToCart(deps) {
    return /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(event) {
            var update, items;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            track(event)
                        ];
                    case 1:
                        _state.sent();
                        update = prepareUpdate(event);
                        return [
                            4,
                            deps.cart.updateCartItems(update)
                        ];
                    case 2:
                        items = _state.sent();
                        return [
                            4,
                            deps.publishEvent((0, _updateCart.CartUpdated)({
                                items: items
                            }))
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }();
    function track(event) {
        return _track.apply(this, arguments);
    }
    function _track() {
        _track = (0, _asyncToGenerator._)(function(event) {
            var variant;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        variant = (0, _std.unwrap)(deps.getState((0, _variants.variantSelector)(event.payload.variantId)));
                        return [
                            4,
                            deps.track('AddToCart', {
                                sku: variant.sku,
                                quantity: event.payload.quantity,
                                subscription: !!event.payload.subscriptionPlanId,
                                source: event.payload.source
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return _track.apply(this, arguments);
    }
    function prepareUpdate(event) {
        if (hasItemAlready(event)) return updateQuantity(event);
        return addItem(event);
    }
    function hasItemAlready(event) {
        return !!selectExistingItem(event);
    }
    function selectExistingItem(event) {
        var _event_payload = event.payload, variantId = _event_payload.variantId, subscriptionPlanId = _event_payload.subscriptionPlanId;
        var _deps_getState_find;
        return (_deps_getState_find = deps.getState((0, _state.activeCartItemsSelector)).find(function(item) {
            return item.variantId === variantId && item.subscriptionPlanId === subscriptionPlanId;
        })) !== null && _deps_getState_find !== void 0 ? _deps_getState_find : null;
    }
    function addItem(event) {
        return (0, _objectSpread._)({
            type: 'Add'
        }, event.payload);
    }
    function updateQuantity(event) {
        var quantity = event.payload.quantity;
        var item = (0, _std.unwrap)(selectExistingItem(event));
        return (0, _objectSpreadProps._)((0, _objectSpread._)({
            type: 'UpdateQuantity'
        }, item), {
            quantity: item.quantity + quantity
        });
    }
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_object_spread_props":"fLCYP","@swc/helpers/_/_ts_generator":"f2hGH","../state":"1HyQc","@reglo/std":"1USo0","../../../../script/src/app/store/state/data/variants":"11hc8","./updateCart":"3nzo7","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1HyQc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cartReducer", function() {
    return cartReducer;
});
parcelHelpers.export(exports, "cartSelector", function() {
    return cartSelector;
});
parcelHelpers.export(exports, "cartItemsSelector", function() {
    return cartItemsSelector;
});
parcelHelpers.export(exports, "cartItemSelector", function() {
    return cartItemSelector;
});
parcelHelpers.export(exports, "activeCartItemsSelector", function() {
    return activeCartItemsSelector;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _openCartWithContent = require("../useCases/openCartWithContent");
var _loadCart = require("../useCases/loadCart");
var _addProductToCart = require("../useCases/addProductToCart");
var _changeItemSubscriptionPlanInCart = require("../useCases/changeItemSubscriptionPlanInCart");
var _std = require("@reglo/std");
var _updateCart = require("../useCases/updateCart");
var _openCart = require("../useCases/openCart");
var _changeCartItemQuantity = require("../useCases/changeCartItemQuantity");
var _removeCartItem = require("../useCases/removeCartItem");
var _closeCart = require("../useCases/closeCart");
var _changeAllCartSubscriptionFrequency = require("../useCases/changeAllCartSubscriptionFrequency");
var initialState = {
    opened: false,
    updating: false,
    loading: true,
    items: [],
    initialContent: null
};
function cartReducer() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, event = arguments.length > 1 ? arguments[1] : void 0;
    switch(event.type){
        case 0, _loadCart.CartLoadedKey:
            return (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                loading: false
            }), event.payload);
        case 0, _updateCart.CartUpdatedKey:
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                updating: false,
                items: event.payload.items,
                initialContent: state.initialContent !== null ? state.initialContent : event.payload.items
            });
        case 0, _openCartWithContent.OpenCartWithContentKey:
            {
                var items = event.payload.map(function(item, index) {
                    return (0, _objectSpread._)({
                        key: `temp_${index}`,
                        removed: false,
                        subscriptionSelected: !!item.subscriptionPlanId
                    }, item);
                });
                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                    loading: false,
                    opened: true,
                    updating: false,
                    items: items,
                    initialContent: state.initialContent !== null ? state.initialContent : items
                });
            }
        case 0, _openCart.OpenCartKey:
            {
                var items1 = state.items.filter(function(item) {
                    return !item.removed;
                });
                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                    opened: true,
                    items: items1,
                    initialContent: items1
                });
            }
        case 0, _addProductToCart.AddProductToCartKey:
        case 0, _changeCartItemQuantity.ChangeCartItemQuantityKey:
        case 0, _removeCartItem.RemoveCartItemKey:
        case 0, _changeItemSubscriptionPlanInCart.ChangeItemSubscriptionPlanInCartKey:
        case 0, _changeAllCartSubscriptionFrequency.ChangeAllCartSubscriptionFrequencyKey:
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                opened: true,
                updating: true
            });
        case 0, _closeCart.CloseCartKey:
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                opened: false,
                initialContent: null
            });
        default:
            return state;
    }
}
function cartSelector(state) {
    return state.components.cart;
}
function cartItemsSelector(state) {
    return state.components.cart.items;
}
function cartItemSelector(itemKey) {
    return function(state) {
        return (0, _std.unwrap)(cartItemsSelector(state).find(function(item) {
            return item.key === itemKey;
        }));
    };
}
function activeCartItemsSelector(state) {
    return state.components.cart.items.filter(function(item) {
        return !item.removed;
    });
}

},{"@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_object_spread_props":"fLCYP","../useCases/openCartWithContent":"eaTox","../useCases/loadCart":"3fYue","../useCases/addProductToCart":"bC9NF","../useCases/changeItemSubscriptionPlanInCart":"d0Ejd","@reglo/std":"1USo0","../useCases/updateCart":"3nzo7","../useCases/openCart":"cSUzZ","../useCases/changeCartItemQuantity":"b69iv","../useCases/removeCartItem":"32Oeg","../useCases/closeCart":"nTTZT","../useCases/changeAllCartSubscriptionFrequency":"gJIad","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"eaTox":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OpenCartWithContentKey", function() {
    return OpenCartWithContentKey;
});
parcelHelpers.export(exports, "OpenCartWithContent", function() {
    return OpenCartWithContent;
});
parcelHelpers.export(exports, "openCartWithContent", function() {
    return openCartWithContent;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _std = require("@reglo/std");
var _updateCart = require("./updateCart");
var OpenCartWithContentKey = 'OpenCartWithContent';
var OpenCartWithContent = (0, _std.eventFactory)(OpenCartWithContentKey)();
function openCartWithContent(deps) {
    return /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(event) {
            var _deps_cart, updates, items;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        updates = prepareUpdate(event);
                        return [
                            4,
                            (_deps_cart = deps.cart).updateCartItems.apply(_deps_cart, (0, _toConsumableArray._)(updates))
                        ];
                    case 1:
                        items = _state.sent();
                        return [
                            2,
                            (0, _updateCart.CartUpdated)({
                                items: items
                            })
                        ];
                }
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }();
    function prepareUpdate(event) {
        return [
            {
                type: 'Empty'
            }
        ].concat((0, _toConsumableArray._)(event.payload.map(function(item) {
            return (0, _objectSpread._)({
                type: 'Add'
            }, item);
        })));
    }
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_to_consumable_array":"eqNDD","@swc/helpers/_/_ts_generator":"f2hGH","@reglo/std":"1USo0","./updateCart":"3nzo7","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3nzo7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CartUpdatedKey", function() {
    return CartUpdatedKey;
});
parcelHelpers.export(exports, "CartUpdated", function() {
    return CartUpdated;
});
var _eventFactory = require("../../../../script/src/std/eventFactory");
var CartUpdatedKey = 'CartUpdated';
var CartUpdated = (0, _eventFactory.eventFactory)(CartUpdatedKey)();

},{"../../../../script/src/std/eventFactory":"f2PpV","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3fYue":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LoadCartKey", function() {
    return LoadCartKey;
});
parcelHelpers.export(exports, "LoadCart", function() {
    return LoadCart;
});
parcelHelpers.export(exports, "CartLoadedKey", function() {
    return CartLoadedKey;
});
parcelHelpers.export(exports, "CartLoaded", function() {
    return CartLoaded;
});
parcelHelpers.export(exports, "loadCart", function() {
    return loadCart;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _eventFactory = require("../../../../script/src/std/eventFactory");
var LoadCartKey = 'LoadCart';
var LoadCart = (0, _eventFactory.eventFactory)(LoadCartKey)();
var CartLoadedKey = 'CartLoaded';
var CartLoaded = (0, _eventFactory.eventFactory)(CartLoadedKey)();
function loadCart(deps) {
    return /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(event) {
            var items;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            deps.cart.retrieveCartItems()
                        ];
                    case 1:
                        items = _state.sent();
                        return [
                            2,
                            CartLoaded({
                                items: items
                            })
                        ];
                }
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }();
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_ts_generator":"f2hGH","../../../../script/src/std/eventFactory":"f2PpV","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"d0Ejd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChangeItemSubscriptionPlanInCartKey", function() {
    return ChangeItemSubscriptionPlanInCartKey;
});
parcelHelpers.export(exports, "ChangeItemSubscriptionPlanInCart", function() {
    return ChangeItemSubscriptionPlanInCart;
});
parcelHelpers.export(exports, "changeSubscriptionPlanInCart", function() {
    return changeSubscriptionPlanInCart;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _std = require("@reglo/std");
var _variants = require("../../../../script/src/app/store/state/data/variants");
var _state = require("../state");
var _updateCart = require("./updateCart");
var ChangeItemSubscriptionPlanInCartKey = 'ChangeItemSubscriptionPlanInCart';
var ChangeItemSubscriptionPlanInCart = (0, _std.eventFactory)(ChangeItemSubscriptionPlanInCartKey)();
function changeSubscriptionPlanInCart(deps) {
    return /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(event) {
            var update, items;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            track(event)
                        ];
                    case 1:
                        _state.sent();
                        update = prepareUpdate(event);
                        return [
                            4,
                            deps.cart.updateCartItems(update)
                        ];
                    case 2:
                        items = _state.sent();
                        return [
                            4,
                            deps.publishEvent((0, _updateCart.CartUpdated)({
                                items: items
                            }))
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }();
    function prepareUpdate(event) {
        return (0, _objectSpread._)({
            type: 'UpdateSubscription'
        }, event.payload);
    }
    function track(event) {
        return _track.apply(this, arguments);
    }
    function _track() {
        _track = (0, _asyncToGenerator._)(function(event) {
            var sku, eventName;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        sku = selectSku(event);
                        eventName = event.payload.subscriptionPlanId === null ? 'RemoveSubscriptionInCart' : 'AddSubscriptionInCart';
                        return [
                            4,
                            deps.track(eventName, {
                                sku: sku
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return _track.apply(this, arguments);
    }
    function selectSku(event) {
        var cartItem = deps.getState((0, _state.cartItemSelector)(event.payload.key));
        return (0, _std.unwrap)(deps.getState((0, _variants.variantSelector)(cartItem.variantId))).sku;
    }
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_ts_generator":"f2hGH","@reglo/std":"1USo0","../../../../script/src/app/store/state/data/variants":"11hc8","../state":"1HyQc","./updateCart":"3nzo7","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"11hc8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "variantsReducer", function() {
    return variantsReducer;
});
parcelHelpers.export(exports, "variantsSelector", function() {
    return variantsSelector;
});
parcelHelpers.export(exports, "variantSelector", function() {
    return variantSelector;
});
parcelHelpers.export(exports, "subscriptionIdSelector", function() {
    return subscriptionIdSelector;
});
parcelHelpers.export(exports, "selectVariantInState", function() {
    return selectVariantInState;
});
parcelHelpers.export(exports, "selectVariantInStateBySku", function() {
    return selectVariantInStateBySku;
});
var _productDataLoaded = require("../../../events/ProductDataLoaded");
var _std = require("@reglo/std");
var initialState = {
    loading: true,
    entities: []
};
function variantsReducer() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, event = arguments.length > 1 ? arguments[1] : void 0;
    switch(event.type){
        case 0, _productDataLoaded.ProductDataLoadedKey:
            return {
                loading: false,
                entities: event.payload.variants
            };
        default:
            return state;
    }
}
function variantsSelector(state) {
    return state.data.variants;
}
function variantSelector(variantId) {
    return function(state) {
        var variants = variantsSelector(state).entities;
        if (variants.length === 0) return null;
        return (0, _std.unwrap)(variants.find(function(variant) {
            return variant.variantId === variantId;
        }));
    };
}
function subscriptionIdSelector(variantId, frequencyInWeeks) {
    return function(state) {
        var variant = variantSelector(variantId)(state);
        if (!variant) return null;
        var subscriptionPlan = variant.subscriptionPlans.find(function(plan) {
            return plan.weekFrequency === frequencyInWeeks;
        });
        var _subscriptionPlan_subscriptionPlanId;
        return (_subscriptionPlan_subscriptionPlanId = subscriptionPlan === null || subscriptionPlan === void 0 ? void 0 : subscriptionPlan.subscriptionPlanId) !== null && _subscriptionPlan_subscriptionPlanId !== void 0 ? _subscriptionPlan_subscriptionPlanId : null;
    };
}
function selectVariantInState(state, variantId) {
    var _state_entities_find;
    return (_state_entities_find = state.entities.find(function(variant) {
        return variant.variantId === variantId;
    })) !== null && _state_entities_find !== void 0 ? _state_entities_find : null;
}
function selectVariantInStateBySku(state, sku) {
    var _state_entities_find;
    return (_state_entities_find = state.entities.find(function(variant) {
        return variant.sku === sku;
    })) !== null && _state_entities_find !== void 0 ? _state_entities_find : null;
}

},{"../../../events/ProductDataLoaded":"k7cce","@reglo/std":"1USo0","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"k7cce":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProductDataLoadedKey", function() {
    return ProductDataLoadedKey;
});
parcelHelpers.export(exports, "ProductDataLoaded", function() {
    return ProductDataLoaded;
});
var _eventFactory = require("../../std/eventFactory");
var ProductDataLoadedKey = 'ProductDataLoaded';
var ProductDataLoaded = (0, _eventFactory.eventFactory)(ProductDataLoadedKey)();

},{"../../std/eventFactory":"f2PpV","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"cSUzZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OpenCartKey", function() {
    return OpenCartKey;
});
parcelHelpers.export(exports, "OpenCart", function() {
    return OpenCart;
});
var _eventFactory = require("../../../../script/src/std/eventFactory");
var OpenCartKey = 'CART.OpenCartKey';
var OpenCart = (0, _eventFactory.eventFactory)(OpenCartKey)();

},{"../../../../script/src/std/eventFactory":"f2PpV","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"b69iv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChangeCartItemQuantityKey", function() {
    return ChangeCartItemQuantityKey;
});
parcelHelpers.export(exports, "ChangeCartItemQuantity", function() {
    return ChangeCartItemQuantity;
});
parcelHelpers.export(exports, "changeCartItemQuantity", function() {
    return changeCartItemQuantity;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _state = require("../state");
var _std = require("@reglo/std");
var _updateCart = require("./updateCart");
var _eventFactory = require("../../../../script/src/std/eventFactory");
var ChangeCartItemQuantityKey = 'CART.ChangeCartItemQuantityKey';
var ChangeCartItemQuantity = (0, _eventFactory.eventFactory)(ChangeCartItemQuantityKey)();
function changeCartItemQuantity(deps) {
    return /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(event) {
            var update, items;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        update = prepareUpdate(event);
                        return [
                            4,
                            deps.cart.updateCartItems(update)
                        ];
                    case 1:
                        items = _state.sent();
                        return [
                            2,
                            (0, _updateCart.CartUpdated)({
                                items: items
                            })
                        ];
                }
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }();
    function prepareUpdate(event) {
        var quantity = event.payload.quantity;
        var item = selectItem(event);
        if (quantity > 0) return (0, _objectSpreadProps._)((0, _objectSpread._)({
            type: 'UpdateQuantity'
        }, item), {
            quantity: quantity
        });
        return (0, _objectSpread._)({
            type: 'Remove'
        }, item);
    }
    function selectItem(event) {
        var key = event.payload.key;
        var item = deps.getState((0, _state.cartItemsSelector)).find(function(item) {
            return item.key === key;
        });
        return (0, _std.unwrap)(item);
    }
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_object_spread_props":"fLCYP","@swc/helpers/_/_ts_generator":"f2hGH","../state":"1HyQc","@reglo/std":"1USo0","./updateCart":"3nzo7","../../../../script/src/std/eventFactory":"f2PpV","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"32Oeg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RemoveCartItemKey", function() {
    return RemoveCartItemKey;
});
parcelHelpers.export(exports, "RemoveCartItem", function() {
    return RemoveCartItem;
});
parcelHelpers.export(exports, "removeCartItem", function() {
    return removeCartItem;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _updateCart = require("./updateCart");
var _eventFactory = require("../../../../script/src/std/eventFactory");
var RemoveCartItemKey = 'CART.RemoveCartItemKey';
var RemoveCartItem = (0, _eventFactory.eventFactory)(RemoveCartItemKey)();
function removeCartItem(deps) {
    return /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(event) {
            var update, items;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        update = prepareUpdate(event);
                        return [
                            4,
                            deps.cart.updateCartItems(update)
                        ];
                    case 1:
                        items = _state.sent();
                        return [
                            2,
                            (0, _updateCart.CartUpdated)({
                                items: items
                            })
                        ];
                }
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }();
    function prepareUpdate(event) {
        return (0, _objectSpread._)({
            type: 'Remove'
        }, event.payload);
    }
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_ts_generator":"f2hGH","./updateCart":"3nzo7","../../../../script/src/std/eventFactory":"f2PpV","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"nTTZT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CloseCartKey", function() {
    return CloseCartKey;
});
parcelHelpers.export(exports, "CloseCart", function() {
    return CloseCart;
});
var _eventFactory = require("../../../../script/src/std/eventFactory");
var CloseCartKey = 'Cart.CloseCartKey';
var CloseCart = (0, _eventFactory.eventFactory)(CloseCartKey)();

},{"../../../../script/src/std/eventFactory":"f2PpV","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gJIad":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChangeAllCartSubscriptionFrequencyKey", function() {
    return ChangeAllCartSubscriptionFrequencyKey;
});
parcelHelpers.export(exports, "ChangeAllCartSubscriptionFrequency", function() {
    return ChangeAllCartSubscriptionFrequency;
});
parcelHelpers.export(exports, "changeAllItemsSubscriptionFrequencyInCart", function() {
    return changeAllItemsSubscriptionFrequencyInCart;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _std = require("@reglo/std");
var _updateCart = require("./updateCart");
var _state = require("../state");
var _variants = require("../../../../script/src/app/store/state/data/variants");
var ChangeAllCartSubscriptionFrequencyKey = 'ChangeAllCartSubscriptionFrequency';
var ChangeAllCartSubscriptionFrequency = (0, _std.eventFactory)(ChangeAllCartSubscriptionFrequencyKey)();
function changeAllItemsSubscriptionFrequencyInCart(deps) {
    return /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(event) {
            var _deps_cart, updates, items;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        updates = prepareUpdates(event);
                        return [
                            4,
                            (_deps_cart = deps.cart).updateCartItems.apply(_deps_cart, (0, _toConsumableArray._)(updates))
                        ];
                    case 1:
                        items = _state.sent();
                        return [
                            4,
                            deps.publishEvent((0, _updateCart.CartUpdated)({
                                items: items
                            }))
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            track(event)
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }();
    function prepareUpdates(event) {
        var cartState = deps.getState((0, _state.cartSelector));
        return cartState.items.filter(function(item) {
            return item.subscriptionSelected;
        }).map(function(item) {
            var subscriptionPlanId = (0, _std.unwrap)(deps.getState((0, _variants.subscriptionIdSelector)(item.variantId, event.payload.frequencyInWeeks)));
            return {
                type: 'UpdateSubscription',
                key: item.key,
                subscriptionPlanId: subscriptionPlanId
            };
        });
    }
    function track(event) {
        return _track.apply(this, arguments);
    }
    function _track() {
        _track = (0, _asyncToGenerator._)(function(event) {
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            deps.track('ChangeAllCartSubscriptionFrequency', {
                                frequencyInWeeks: event.payload.frequencyInWeeks
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return _track.apply(this, arguments);
    }
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_to_consumable_array":"eqNDD","@swc/helpers/_/_ts_generator":"f2hGH","@reglo/std":"1USo0","./updateCart":"3nzo7","../state":"1HyQc","../../../../script/src/app/store/state/data/variants":"11hc8","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"48PeC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "accountViewReducer", function() {
    return accountViewReducer;
});
parcelHelpers.export(exports, "accountIsLoaded", function() {
    return accountIsLoaded;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _loadCustomerSubscriptions = require("../../../useCases/loadCustomerSubscriptions");
var _loadCustomerData = require("../../../useCases/loadCustomerData");
var _loadOrdersData = require("../../../useCases/loadOrdersData");
var initialState = {
    areCustomerSubscriptionsLoaded: false,
    isCustomerLoaded: false,
    areCustomerOrdersLoaded: false
};
function accountViewReducer() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, event = arguments.length > 1 ? arguments[1] : void 0;
    switch(event.type){
        case 0, _loadCustomerSubscriptions.CustomerSubscriptionsLoadedKey:
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                areCustomerSubscriptionsLoaded: true
            });
        case 0, _loadCustomerData.CustomerDataLoadedKey:
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                isCustomerLoaded: true
            });
        case 0, _loadOrdersData.OrdersDataLoadedKey:
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                areCustomerOrdersLoaded: true
            });
        default:
            return state;
    }
}
function accountIsLoaded(state) {
    var _state_views_account = state.views.account, isCustomerLoaded = _state_views_account.isCustomerLoaded, areCustomerOrdersLoaded = _state_views_account.areCustomerOrdersLoaded, areCustomerSubscriptionsLoaded = _state_views_account.areCustomerSubscriptionsLoaded;
    return isCustomerLoaded && areCustomerOrdersLoaded && areCustomerSubscriptionsLoaded;
}

},{"@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_object_spread_props":"fLCYP","../../../useCases/loadCustomerSubscriptions":"efjCG","../../../useCases/loadCustomerData":"lIaYI","../../../useCases/loadOrdersData":"4CTLE","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"efjCG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LoadCustomerSubscriptionsKey", function() {
    return LoadCustomerSubscriptionsKey;
});
parcelHelpers.export(exports, "LoadCustomerSubscriptions", function() {
    return LoadCustomerSubscriptions;
});
parcelHelpers.export(exports, "CustomerSubscriptionsLoadedKey", function() {
    return CustomerSubscriptionsLoadedKey;
});
parcelHelpers.export(exports, "CustomerSubscriptionsLoaded", function() {
    return CustomerSubscriptionsLoaded;
});
parcelHelpers.export(exports, "loadCustomerSubscriptions", function() {
    return loadCustomerSubscriptions;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _std = require("@reglo/std");
var LoadCustomerSubscriptionsKey = 'LoadCustomerSubscriptions';
var LoadCustomerSubscriptions = (0, _std.eventFactory)(LoadCustomerSubscriptionsKey)();
var CustomerSubscriptionsLoadedKey = 'CustomerSubscriptionsLoaded';
var CustomerSubscriptionsLoaded = (0, _std.eventFactory)(CustomerSubscriptionsLoadedKey)();
function loadCustomerSubscriptions(deps) {
    return /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(event) {
            var data;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            deps.retrieveCustomerSubscriptions()
                        ];
                    case 1:
                        data = _state.sent();
                        return [
                            4,
                            deps.publishEvent(CustomerSubscriptionsLoaded(data))
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }();
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_ts_generator":"f2hGH","@reglo/std":"1USo0","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"lIaYI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LoadCustomerDataKey", function() {
    return LoadCustomerDataKey;
});
parcelHelpers.export(exports, "LoadCustomerData", function() {
    return LoadCustomerData;
});
parcelHelpers.export(exports, "CustomerDataLoadedKey", function() {
    return CustomerDataLoadedKey;
});
parcelHelpers.export(exports, "CustomerDataLoaded", function() {
    return CustomerDataLoaded;
});
parcelHelpers.export(exports, "loadCustomerData", function() {
    return loadCustomerData;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _std = require("@reglo/std");
var _eventFactory = require("../../std/eventFactory");
var LoadCustomerDataKey = 'LoadCustomerData';
var LoadCustomerData = (0, _eventFactory.eventFactory)(LoadCustomerDataKey)();
var CustomerDataLoadedKey = 'CustomerDataLoaded';
var CustomerDataLoaded = (0, _eventFactory.eventFactory)(CustomerDataLoadedKey)();
function loadCustomerData(deps) {
    return /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(event) {
            var customer;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            deps.retrieveCustomer().then((0, _std.unwrap))
                        ];
                    case 1:
                        customer = _state.sent();
                        return [
                            4,
                            deps.publishEvent(CustomerDataLoaded({
                                customer: customer
                            }))
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }();
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_ts_generator":"f2hGH","@reglo/std":"1USo0","../../std/eventFactory":"f2PpV","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4CTLE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LoadOrdersDataKey", function() {
    return LoadOrdersDataKey;
});
parcelHelpers.export(exports, "LoadOrdersData", function() {
    return LoadOrdersData;
});
parcelHelpers.export(exports, "OrdersDataLoadedKey", function() {
    return OrdersDataLoadedKey;
});
parcelHelpers.export(exports, "OrdersDataLoaded", function() {
    return OrdersDataLoaded;
});
parcelHelpers.export(exports, "loadOrdersData", function() {
    return loadOrdersData;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _eventFactory = require("../../std/eventFactory");
var LoadOrdersDataKey = 'LoadOrdersData';
var LoadOrdersData = (0, _eventFactory.eventFactory)(LoadOrdersDataKey)();
var OrdersDataLoadedKey = 'OrdersDataLoaded';
var OrdersDataLoaded = (0, _eventFactory.eventFactory)(OrdersDataLoadedKey)();
function loadOrdersData(deps) {
    return /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(event) {
            var orders;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            deps.retrieveCustomerOrders()
                        ];
                    case 1:
                        orders = _state.sent();
                        return [
                            4,
                            deps.publishEvent(OrdersDataLoaded({
                                orders: orders
                            }))
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }();
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_ts_generator":"f2hGH","../../std/eventFactory":"f2PpV","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"lHdM3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dataReducer", function() {
    return dataReducer;
});
var _redux = require("redux");
var _variants = require("./variants");
var _customer = require("./customer");
var _orders = require("./orders");
var _customerSubscription = require("./customerSubscription");
var _intakeCalculatorData = require("./intakeCalculatorData");
var _products = require("./products");
var _shippingRates = require("./shippingRates");
var dataReducer = (0, _redux.combineReducers)({
    variants: (0, _variants.variantsReducer),
    products: (0, _products.productsReducer),
    customer: (0, _customer.customerReducer),
    customerSubscription: (0, _customerSubscription.customerSubscriptionReducer),
    orders: (0, _orders.ordersReducer),
    intakeCalculatorData: (0, _intakeCalculatorData.intakeCalculatorDataReducer),
    shippingRates: (0, _shippingRates.shippingRatesReducer)
});

},{"redux":"lKoa8","./variants":"11hc8","./customer":"hDp3A","./orders":"4hVLS","./customerSubscription":"3ipiV","./intakeCalculatorData":"ctRLt","./products":"17rrh","./shippingRates":"9lFur","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"hDp3A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "customerReducer", function() {
    return customerReducer;
});
parcelHelpers.export(exports, "customerSelector", function() {
    return customerSelector;
});
parcelHelpers.export(exports, "shippingAddressSelector", function() {
    return shippingAddressSelector;
});
parcelHelpers.export(exports, "customerIdSelector", function() {
    return customerIdSelector;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _loadCustomerData = require("../../../useCases/loadCustomerData");
var _std = require("@reglo/std");
var _updateShippingAddress = require("../../../useCases/updateShippingAddress");
var initialState = {
    entity: null
};
function customerReducer() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, event = arguments.length > 1 ? arguments[1] : void 0;
    switch(event.type){
        case 0, _loadCustomerData.CustomerDataLoadedKey:
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                entity: event.payload.customer
            });
        case 0, _updateShippingAddress.ShippingAddressUpdatedKey:
            return updateShippingAddress(state, event);
        default:
            return state;
    }
    function updateShippingAddress(state, event) {
        var shippingAddress = (0, _objectSpread._)({}, (0, _std.unwrap)(state.entity).shippingAddress, event.payload.shippingAddress);
        var entity = (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _std.unwrap)(state.entity)), {
            shippingAddress: shippingAddress
        });
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
            entity: entity
        });
    }
}
function customerSelector(state) {
    return state.data.customer;
}
function shippingAddressSelector(state) {
    var _customerSelector_entity;
    return (0, _std.unwrap)((_customerSelector_entity = customerSelector(state).entity) === null || _customerSelector_entity === void 0 ? void 0 : _customerSelector_entity.shippingAddress);
}
function customerIdSelector(state) {
    var _customerSelector_entity;
    return (0, _std.unwrap)((_customerSelector_entity = customerSelector(state).entity) === null || _customerSelector_entity === void 0 ? void 0 : _customerSelector_entity.customerId);
}

},{"@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_object_spread_props":"fLCYP","../../../useCases/loadCustomerData":"lIaYI","@reglo/std":"1USo0","../../../useCases/updateShippingAddress":"bzbXd","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"bzbXd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UpdateShippingAddressKey", function() {
    return UpdateShippingAddressKey;
});
parcelHelpers.export(exports, "UpdateShippingAddress", function() {
    return UpdateShippingAddress;
});
parcelHelpers.export(exports, "ShippingAddressUpdatedKey", function() {
    return ShippingAddressUpdatedKey;
});
parcelHelpers.export(exports, "ShippingAddressUpdated", function() {
    return ShippingAddressUpdated;
});
parcelHelpers.export(exports, "formatShippingAddress", function() {
    return formatShippingAddress;
});
parcelHelpers.export(exports, "updateShippingAddress", function() {
    return updateShippingAddress;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _std = require("@reglo/std");
var _eventFactory = require("../../std/eventFactory");
var _customer = require("../store/state/data/customer");
var UpdateShippingAddressKey = 'UpdateShippingAddress';
var UpdateShippingAddress = (0, _eventFactory.eventFactory)(UpdateShippingAddressKey)();
var ShippingAddressUpdatedKey = 'ShippingAddressUpdated';
var ShippingAddressUpdated = (0, _eventFactory.eventFactory)(ShippingAddressUpdatedKey)();
function formatShippingAddress(shippingAddress) {
    var firstName = shippingAddress.firstName, lastName = shippingAddress.lastName, address1 = shippingAddress.address1, address2 = shippingAddress.address2, zipCode = shippingAddress.zipCode, city = shippingAddress.city, countryCode = shippingAddress.countryCode, phone = shippingAddress.phone;
    return {
        firstName: firstName,
        lastName: lastName,
        address1: address1,
        address2: address2,
        zipCode: zipCode,
        city: city,
        countryCode: countryCode,
        phone: phone
    };
}
function updateShippingAddress(deps) {
    return /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(event) {
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            track(event)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            update(event)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            publishSuccessEvent(event)
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }();
    function update(event) {
        return _update.apply(this, arguments);
    }
    function _update() {
        _update = (0, _asyncToGenerator._)(function(event) {
            var execution;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        execution = deps.updateShippingAddress(event.payload.shippingAddress);
                        return [
                            4,
                            deps.waitAtLeast(execution, 1000)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return _update.apply(this, arguments);
    }
    function publishSuccessEvent(event) {
        return _publishSuccessEvent.apply(this, arguments);
    }
    function _publishSuccessEvent() {
        _publishSuccessEvent = (0, _asyncToGenerator._)(function(event) {
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            deps.publishEvent(ShippingAddressUpdated(event.payload))
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return _publishSuccessEvent.apply(this, arguments);
    }
    function track(event) {
        return _track.apply(this, arguments);
    }
    function _track() {
        _track = (0, _asyncToGenerator._)(function(event) {
            var from, to;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        from = selectInitialAddress();
                        to = selectNewAddress(event);
                        return [
                            4,
                            deps.track('UpdateShippingAddress', {
                                from: from,
                                to: to
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return _track.apply(this, arguments);
    }
    function selectInitialAddress() {
        return formatShippingAddress((0, _std.unwrap)(deps.getState((0, _customer.customerSelector)).entity).shippingAddress);
    }
    function selectNewAddress(event) {
        return event.payload.shippingAddress;
    }
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_ts_generator":"f2hGH","@reglo/std":"1USo0","../../std/eventFactory":"f2PpV","../store/state/data/customer":"hDp3A","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4hVLS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ordersReducer", function() {
    return ordersReducer;
});
parcelHelpers.export(exports, "ordersSelector", function() {
    return ordersSelector;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _loadOrdersData = require("../../../useCases/loadOrdersData");
var initialState = {
    isLoading: true,
    entities: null
};
function ordersReducer() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, event = arguments.length > 1 ? arguments[1] : void 0;
    switch(event.type){
        case 0, _loadOrdersData.OrdersDataLoadedKey:
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                entities: event.payload.orders,
                isLoading: false
            });
        default:
            return state;
    }
}
function ordersSelector(state) {
    return state.data.orders;
}

},{"@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_object_spread_props":"fLCYP","../../../useCases/loadOrdersData":"4CTLE","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3ipiV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "customerSubscriptionReducer", function() {
    return customerSubscriptionReducer;
});
parcelHelpers.export(exports, "customerSubscriptionSelector", function() {
    return customerSubscriptionSelector;
});
parcelHelpers.export(exports, "activeSubscriptionsSelector", function() {
    return activeSubscriptionsSelector;
});
parcelHelpers.export(exports, "subscriptionSelector", function() {
    return subscriptionSelector;
});
parcelHelpers.export(exports, "subscriptionProductSelector", function() {
    return subscriptionProductSelector;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _loadCustomerSubscriptions = require("../../../useCases/loadCustomerSubscriptions");
var _refreshCustomerSubscriptions = require("../../../useCases/refreshCustomerSubscriptions");
var _std = require("@reglo/std");
var _variants = require("./variants");
var _updateSubscriptionQuantity = require("../../../useCases/updateSubscriptionQuantity");
var _addProductToSubscription = require("../../../useCases/addProductToSubscription");
var _removeProductFromSubscription = require("../../../useCases/removeProductFromSubscription");
var _swapProductOfSubscription = require("../../../useCases/swapProductOfSubscription");
var _updateFrequency = require("../../../useCases/updateFrequency");
var initialState = {
    isLoading: true,
    isRefreshing: false,
    isAddingSubscription: false,
    addressId: null,
    nextOrder: null,
    paymentMethod: null,
    subscriptions: []
};
function customerSubscriptionReducer() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, event = arguments.length > 1 ? arguments[1] : void 0;
    switch(event.type){
        case 0, _loadCustomerSubscriptions.LoadCustomerSubscriptionsKey:
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                isLoading: true
            });
        case 0, _addProductToSubscription.AddProductToSubscriptionKey:
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                isAddingSubscription: true
            });
        case 0, _updateSubscriptionQuantity.UpdateSubscriptionQuantityKey:
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                isRefreshing: true,
                subscriptions: updateSubscriptionQuantity(state, event)
            });
        case 0, _swapProductOfSubscription.SwapProductOfSubscriptionKey:
        case 0, _removeProductFromSubscription.RemoveProductFromSubscriptionKey:
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                isRefreshing: true,
                subscriptions: updateSubscription(state, event)
            });
        case 0, _loadCustomerSubscriptions.CustomerSubscriptionsLoadedKey:
        case 0, _refreshCustomerSubscriptions.CustomerSubscriptionsRefreshedKey:
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state, event.payload), {
                isLoading: false,
                isRefreshing: false,
                isAddingSubscription: false,
                subscriptions: loadSubscriptions(state, event)
            });
        case 0, _updateFrequency.FrequencyUpdatedKey:
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                nextOrder: (0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _std.unwrap)(state.nextOrder)), {
                    frequency: {
                        value: event.payload.frequencyInWeek,
                        unit: 'week'
                    }
                })
            });
        default:
            return state;
    }
}
function loadSubscriptions(state, event) {
    switch(event.type){
        case 0, _loadCustomerSubscriptions.CustomerSubscriptionsLoadedKey:
        case 0, _refreshCustomerSubscriptions.CustomerSubscriptionsRefreshedKey:
            return event.payload.subscriptions.map(function(subscription) {
                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, subscription), {
                    isLoading: false,
                    isUpdating: false,
                    isAdding: false,
                    quantityIsLoading: false
                });
            });
        default:
            return state.subscriptions;
    }
}
function updateSubscription(state, event) {
    return state.subscriptions.map(function(subscription) {
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, subscription), {
            isUpdating: subscription.id === event.payload.subscriptionId
        });
    });
}
function updateSubscriptionQuantity(state, event) {
    return state.subscriptions.map(function(subscription) {
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, subscription), {
            quantityIsLoading: subscription.id === event.payload.subscriptionId
        });
    });
}
function customerSubscriptionSelector(state) {
    return state.data.customerSubscription;
}
function activeSubscriptionsSelector(state) {
    return state.data.customerSubscription.subscriptions.filter(function(subscription) {
        return subscription.status === 'ACTIVE';
    });
}
function subscriptionSelector(subscriptionId) {
    return function(state) {
        return (0, _std.unwrap)(customerSubscriptionSelector(state).subscriptions.find(function(subscription) {
            return subscription.id === subscriptionId;
        }));
    };
}
function subscriptionProductSelector(subscriptionId) {
    return function(state) {
        var subscription = subscriptionSelector(subscriptionId)(state);
        return (0, _std.unwrap)((0, _variants.variantSelector)(subscription.variantId)(state));
    };
}

},{"@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_object_spread_props":"fLCYP","../../../useCases/loadCustomerSubscriptions":"efjCG","../../../useCases/refreshCustomerSubscriptions":"f4vE2","@reglo/std":"1USo0","./variants":"11hc8","../../../useCases/updateSubscriptionQuantity":"2ruvf","../../../useCases/addProductToSubscription":"76m1k","../../../useCases/removeProductFromSubscription":"eGpss","../../../useCases/swapProductOfSubscription":"5sLIq","../../../useCases/updateFrequency":"eXHAW","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"f4vE2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RefreshCustomerSubscriptionsKey", function() {
    return RefreshCustomerSubscriptionsKey;
});
parcelHelpers.export(exports, "RefreshCustomerSubscriptions", function() {
    return RefreshCustomerSubscriptions;
});
parcelHelpers.export(exports, "CustomerSubscriptionsRefreshedKey", function() {
    return CustomerSubscriptionsRefreshedKey;
});
parcelHelpers.export(exports, "CustomerSubscriptionsRefreshed", function() {
    return CustomerSubscriptionsRefreshed;
});
parcelHelpers.export(exports, "refreshCustomerSubscriptions", function() {
    return refreshCustomerSubscriptions;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _std = require("@reglo/std");
var RefreshCustomerSubscriptionsKey = 'RefreshCustomerSubscriptions';
var RefreshCustomerSubscriptions = (0, _std.eventFactory)(RefreshCustomerSubscriptionsKey)();
var CustomerSubscriptionsRefreshedKey = 'CustomerSubscriptionsRefreshed';
var CustomerSubscriptionsRefreshed = (0, _std.eventFactory)(CustomerSubscriptionsRefreshedKey)();
function refreshCustomerSubscriptions(deps) {
    return /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(event) {
            var data;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            deps.retrieveCustomerSubscriptions()
                        ];
                    case 1:
                        data = _state.sent();
                        return [
                            4,
                            deps.publishEvent(CustomerSubscriptionsRefreshed(data))
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }();
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_ts_generator":"f2hGH","@reglo/std":"1USo0","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2ruvf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UpdateSubscriptionQuantityKey", function() {
    return UpdateSubscriptionQuantityKey;
});
parcelHelpers.export(exports, "UpdateSubscriptionQuantity", function() {
    return UpdateSubscriptionQuantity;
});
parcelHelpers.export(exports, "SubscriptionQuantityUpdatedKey", function() {
    return SubscriptionQuantityUpdatedKey;
});
parcelHelpers.export(exports, "SubscriptionQuantityUpdated", function() {
    return SubscriptionQuantityUpdated;
});
parcelHelpers.export(exports, "updateSubscriptionQuantity", function() {
    return updateSubscriptionQuantity;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _eventFactory = require("../../std/eventFactory");
var _customerSubscription = require("../store/state/data/customerSubscription");
var UpdateSubscriptionQuantityKey = 'UpdateSubscriptionQuantity';
var UpdateSubscriptionQuantity = (0, _eventFactory.eventFactory)(UpdateSubscriptionQuantityKey)();
var SubscriptionQuantityUpdatedKey = 'SubscriptionQuantityUpdated';
var SubscriptionQuantityUpdated = (0, _eventFactory.eventFactory)(SubscriptionQuantityUpdatedKey)();
function updateSubscriptionQuantity(deps) {
    return /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(event) {
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            track(event)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            update(event)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            publishSuccessEvent(event)
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }();
    function update(event) {
        return _update.apply(this, arguments);
    }
    function _update() {
        _update = (0, _asyncToGenerator._)(function(event) {
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            deps.updateSubscriptionQuantity(event.payload)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return _update.apply(this, arguments);
    }
    function publishSuccessEvent(event) {
        return _publishSuccessEvent.apply(this, arguments);
    }
    function _publishSuccessEvent() {
        _publishSuccessEvent = (0, _asyncToGenerator._)(function(event) {
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            deps.publishEvent(SubscriptionQuantityUpdated(event.payload))
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return _publishSuccessEvent.apply(this, arguments);
    }
    function track(event) {
        return _track.apply(this, arguments);
    }
    function _track() {
        _track = (0, _asyncToGenerator._)(function(event) {
            var from, to, sku;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        from = selectInitialQuantity(event);
                        to = event.payload.quantity;
                        sku = selectSku(event);
                        return [
                            4,
                            deps.track('UpdateSubscriptionQuantity', {
                                sku: sku,
                                from: from,
                                to: to
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return _track.apply(this, arguments);
    }
    function selectSku(event) {
        return deps.getState((0, _customerSubscription.subscriptionProductSelector)(event.payload.subscriptionId)).sku;
    }
    function selectInitialQuantity(event) {
        return deps.getState((0, _customerSubscription.subscriptionSelector)(event.payload.subscriptionId)).quantity;
    }
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_ts_generator":"f2hGH","../../std/eventFactory":"f2PpV","../store/state/data/customerSubscription":"3ipiV","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"76m1k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AddProductToSubscriptionKey", function() {
    return AddProductToSubscriptionKey;
});
parcelHelpers.export(exports, "AddProductToSubscription", function() {
    return AddProductToSubscription;
});
parcelHelpers.export(exports, "ProductAddedToSubscriptionKey", function() {
    return ProductAddedToSubscriptionKey;
});
parcelHelpers.export(exports, "ProductAddedToSubscription", function() {
    return ProductAddedToSubscription;
});
parcelHelpers.export(exports, "addProductToSubscription", function() {
    return addProductToSubscription;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _eventFactory = require("../../std/eventFactory");
var _std = require("@reglo/std");
var _variants = require("../store/state/data/variants");
var AddProductToSubscriptionKey = 'AddProductToSubscription';
var AddProductToSubscription = (0, _eventFactory.eventFactory)(AddProductToSubscriptionKey)();
var ProductAddedToSubscriptionKey = 'ProductAddedToSubscription';
var ProductAddedToSubscription = (0, _eventFactory.eventFactory)(ProductAddedToSubscriptionKey)();
function addProductToSubscription(deps) {
    return /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(event) {
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            track(event)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            update(event)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            publishSuccessEvent(event)
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }();
    function update(event) {
        return _update.apply(this, arguments);
    }
    function _update() {
        _update = (0, _asyncToGenerator._)(function(event) {
            return (0, _tsGenerator._)(this, function(_state) {
                return [
                    2,
                    deps.addProductToSubscription(event.payload.variantId)
                ];
            });
        });
        return _update.apply(this, arguments);
    }
    function publishSuccessEvent(event) {
        return _publishSuccessEvent.apply(this, arguments);
    }
    function _publishSuccessEvent() {
        _publishSuccessEvent = (0, _asyncToGenerator._)(function(event) {
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            deps.publishEvent(ProductAddedToSubscription(event.payload))
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return _publishSuccessEvent.apply(this, arguments);
    }
    function track(event) {
        return _track.apply(this, arguments);
    }
    function _track() {
        _track = (0, _asyncToGenerator._)(function(event) {
            var sku;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        sku = selectSku(event);
                        return [
                            4,
                            deps.track('AddProductToSubscription', {
                                sku: sku
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return _track.apply(this, arguments);
    }
    function selectSku(event) {
        return (0, _std.unwrap)(deps.getState((0, _variants.variantSelector)(event.payload.variantId))).sku;
    }
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_ts_generator":"f2hGH","../../std/eventFactory":"f2PpV","@reglo/std":"1USo0","../store/state/data/variants":"11hc8","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"eGpss":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RemoveProductFromSubscriptionKey", function() {
    return RemoveProductFromSubscriptionKey;
});
parcelHelpers.export(exports, "RemoveProductFromSubscription", function() {
    return RemoveProductFromSubscription;
});
parcelHelpers.export(exports, "ProductRemovedFromSubscriptionKey", function() {
    return ProductRemovedFromSubscriptionKey;
});
parcelHelpers.export(exports, "ProductRemovedFromSubscription", function() {
    return ProductRemovedFromSubscription;
});
parcelHelpers.export(exports, "removeProductFromSubscription", function() {
    return removeProductFromSubscription;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _eventFactory = require("../../std/eventFactory");
var _customerSubscription = require("../store/state/data/customerSubscription");
var RemoveProductFromSubscriptionKey = 'RemoveProductFromSubscription';
var RemoveProductFromSubscription = (0, _eventFactory.eventFactory)(RemoveProductFromSubscriptionKey)();
var ProductRemovedFromSubscriptionKey = 'ProductRemovedFromSubscription';
var ProductRemovedFromSubscription = (0, _eventFactory.eventFactory)(ProductRemovedFromSubscriptionKey)();
function removeProductFromSubscription(deps) {
    return /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(event) {
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            track(event)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            deps.disableSubscriptions([
                                event.payload.subscriptionId
                            ])
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            deps.publishEvent(ProductRemovedFromSubscription())
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }();
    function track(event) {
        return _track.apply(this, arguments);
    }
    function _track() {
        _track = (0, _asyncToGenerator._)(function(event) {
            var sku;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        sku = selectSku(event);
                        return [
                            4,
                            deps.track('ProductRemovedFromSubscription', {
                                sku: sku
                            })
                        ];
                    case 1:
                        _state.sent();
                        if (!event.payload.feedback) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            deps.track('CancelSubscription', event.payload.feedback)
                        ];
                    case 2:
                        _state.sent();
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return _track.apply(this, arguments);
    }
    function selectSku(event) {
        return deps.getState((0, _customerSubscription.subscriptionProductSelector)(event.payload.subscriptionId)).sku;
    }
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_ts_generator":"f2hGH","../../std/eventFactory":"f2PpV","../store/state/data/customerSubscription":"3ipiV","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5sLIq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SwapProductOfSubscriptionKey", function() {
    return SwapProductOfSubscriptionKey;
});
parcelHelpers.export(exports, "SwapProductOfSubscription", function() {
    return SwapProductOfSubscription;
});
parcelHelpers.export(exports, "ProductOfSubscriptionSwappedKey", function() {
    return ProductOfSubscriptionSwappedKey;
});
parcelHelpers.export(exports, "ProductOfSubscriptionSwapped", function() {
    return ProductOfSubscriptionSwapped;
});
parcelHelpers.export(exports, "swapProductOfSubscription", function() {
    return swapProductOfSubscription;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _eventFactory = require("../../std/eventFactory");
var _std = require("@reglo/std");
var _variants = require("../store/state/data/variants");
var _customerSubscription = require("../store/state/data/customerSubscription");
var SwapProductOfSubscriptionKey = 'SwapProductOfSubscription';
var SwapProductOfSubscription = (0, _eventFactory.eventFactory)(SwapProductOfSubscriptionKey)();
var ProductOfSubscriptionSwappedKey = 'ProductOfSubscriptionSwapped';
var ProductOfSubscriptionSwapped = (0, _eventFactory.eventFactory)(ProductOfSubscriptionSwappedKey)();
function swapProductOfSubscription(deps) {
    return /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(event) {
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            track(event)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            update(event)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            publishSuccessEvent(event)
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }();
    function update(event) {
        return _update.apply(this, arguments);
    }
    function _update() {
        _update = (0, _asyncToGenerator._)(function(event) {
            return (0, _tsGenerator._)(this, function(_state) {
                return [
                    2,
                    deps.swapProductToSubscription(event.payload)
                ];
            });
        });
        return _update.apply(this, arguments);
    }
    function publishSuccessEvent(event) {
        return _publishSuccessEvent.apply(this, arguments);
    }
    function _publishSuccessEvent() {
        _publishSuccessEvent = (0, _asyncToGenerator._)(function(event) {
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            deps.publishEvent(ProductOfSubscriptionSwapped(event.payload))
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return _publishSuccessEvent.apply(this, arguments);
    }
    function track(event) {
        return _track.apply(this, arguments);
    }
    function _track() {
        _track = (0, _asyncToGenerator._)(function(event) {
            var from, to;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        from = selectInitialSku(event);
                        to = selectNewSku(event);
                        return [
                            4,
                            deps.track('SwapProductToSubscription', {
                                from: from,
                                to: to
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return _track.apply(this, arguments);
    }
    function selectInitialSku(event) {
        return deps.getState((0, _customerSubscription.subscriptionProductSelector)(event.payload.subscriptionId)).sku;
    }
    function selectNewSku(event) {
        return (0, _std.unwrap)(deps.getState((0, _variants.variantSelector)(event.payload.variantId))).sku;
    }
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_ts_generator":"f2hGH","../../std/eventFactory":"f2PpV","@reglo/std":"1USo0","../store/state/data/variants":"11hc8","../store/state/data/customerSubscription":"3ipiV","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"eXHAW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UpdateFrequencyKey", function() {
    return UpdateFrequencyKey;
});
parcelHelpers.export(exports, "UpdateFrequency", function() {
    return UpdateFrequency;
});
parcelHelpers.export(exports, "FrequencyUpdatedKey", function() {
    return FrequencyUpdatedKey;
});
parcelHelpers.export(exports, "FrequencyUpdated", function() {
    return FrequencyUpdated;
});
parcelHelpers.export(exports, "updateFrequency", function() {
    return updateFrequency;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _eventFactory = require("../../std/eventFactory");
var _std = require("@reglo/std");
var _customerSubscription = require("../store/state/data/customerSubscription");
var UpdateFrequencyKey = 'UpdateFrequency';
var UpdateFrequency = (0, _eventFactory.eventFactory)(UpdateFrequencyKey)();
var FrequencyUpdatedKey = 'FrequencyUpdated';
var FrequencyUpdated = (0, _eventFactory.eventFactory)(FrequencyUpdatedKey)();
function updateFrequency(deps) {
    return /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(event) {
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            track(event)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            update(event)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            publishSuccessEvent(event)
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }();
    function update(event) {
        return _update.apply(this, arguments);
    }
    function _update() {
        _update = (0, _asyncToGenerator._)(function(event) {
            var execution;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        execution = deps.updateSubscriptionFrequency(event.payload.frequencyInWeek);
                        return [
                            4,
                            deps.waitAtLeast(execution, 1000)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return _update.apply(this, arguments);
    }
    function publishSuccessEvent(event) {
        return _publishSuccessEvent.apply(this, arguments);
    }
    function _publishSuccessEvent() {
        _publishSuccessEvent = (0, _asyncToGenerator._)(function(event) {
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            deps.publishEvent(FrequencyUpdated(event.payload))
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return _publishSuccessEvent.apply(this, arguments);
    }
    function track(event) {
        return _track.apply(this, arguments);
    }
    function _track() {
        _track = (0, _asyncToGenerator._)(function(event) {
            var from, to;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        from = selectInitialFrequency();
                        to = selectNewFrequency(event);
                        return [
                            4,
                            deps.track('UpdateFrequency', {
                                from: from,
                                to: to
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return _track.apply(this, arguments);
    }
    function selectInitialFrequency() {
        var _deps_getState_nextOrder;
        return (0, _std.unwrap)((_deps_getState_nextOrder = deps.getState((0, _customerSubscription.customerSubscriptionSelector)).nextOrder) === null || _deps_getState_nextOrder === void 0 ? void 0 : _deps_getState_nextOrder.frequency);
    }
    function selectNewFrequency(event) {
        return {
            value: event.payload.frequencyInWeek,
            unit: 'week'
        };
    }
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_ts_generator":"f2hGH","../../std/eventFactory":"f2PpV","@reglo/std":"1USo0","../store/state/data/customerSubscription":"3ipiV","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"ctRLt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "intakeCalculatorDataReducer", function() {
    return intakeCalculatorDataReducer;
});
parcelHelpers.export(exports, "intakeCalculatorDataSelector", function() {
    return intakeCalculatorDataSelector;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _intakeCalculator = require("../../../events/IntakeCalculator");
var initialState = {
    entity: null
};
function intakeCalculatorDataReducer() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, event = arguments.length > 1 ? arguments[1] : void 0;
    switch(event.type){
        case 0, _intakeCalculator.OpenIntakeCalculatorKey:
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                entity: null
            });
        case 0, _intakeCalculator.IntakeCalculatorDataLoadedKey:
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                entity: event.payload.intakeCalculatorData
            });
        default:
            return state;
    }
}
function intakeCalculatorDataSelector(state) {
    return state.data.intakeCalculatorData;
}

},{"@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_object_spread_props":"fLCYP","../../../events/IntakeCalculator":"8FDos","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"17rrh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "productsReducer", function() {
    return productsReducer;
});
parcelHelpers.export(exports, "productsSelector", function() {
    return productsSelector;
});
parcelHelpers.export(exports, "productByTypeSelector", function() {
    return productByTypeSelector;
});
var _productDataLoaded = require("../../../events/ProductDataLoaded");
var initialState = {
    loading: true,
    entities: []
};
function productsReducer() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, event = arguments.length > 1 ? arguments[1] : void 0;
    switch(event.type){
        case 0, _productDataLoaded.ProductDataLoadedKey:
            return {
                loading: false,
                entities: event.payload.products
            };
        default:
            return state;
    }
}
function productsSelector(state) {
    return state.data.products;
}
function productByTypeSelector(type) {
    return function(state) {
        var _state_data_products_entities_find;
        return (_state_data_products_entities_find = state.data.products.entities.find(function(product) {
            return product.type === type;
        })) !== null && _state_data_products_entities_find !== void 0 ? _state_data_products_entities_find : null;
    };
}

},{"../../../events/ProductDataLoaded":"k7cce","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"9lFur":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "shippingRatesReducer", function() {
    return shippingRatesReducer;
});
parcelHelpers.export(exports, "shippingRatesSelector", function() {
    return shippingRatesSelector;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _loadShippingRates = require("../../../useCases/loadShippingRates");
var initialState = {
    entities: null
};
function shippingRatesReducer() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, event = arguments.length > 1 ? arguments[1] : void 0;
    switch(event.type){
        case 0, _loadShippingRates.ShippingRatesLoadedKey:
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                entities: event.payload.shippingRates
            });
        default:
            return state;
    }
}
function shippingRatesSelector(state) {
    return state.data.shippingRates;
}

},{"@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_object_spread_props":"fLCYP","../../../useCases/loadShippingRates":"hpNjt","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"hpNjt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LoadShippingRatesKey", function() {
    return LoadShippingRatesKey;
});
parcelHelpers.export(exports, "LoadShippingRates", function() {
    return LoadShippingRates;
});
parcelHelpers.export(exports, "ShippingRatesLoadedKey", function() {
    return ShippingRatesLoadedKey;
});
parcelHelpers.export(exports, "ShippingRatesLoaded", function() {
    return ShippingRatesLoaded;
});
parcelHelpers.export(exports, "loadShippingRates", function() {
    return loadShippingRates;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _eventFactory = require("../../std/eventFactory");
var LoadShippingRatesKey = 'LoadShippingRates';
var LoadShippingRates = (0, _eventFactory.eventFactory)(LoadShippingRatesKey)();
var ShippingRatesLoadedKey = 'ShippingRatesLoaded';
var ShippingRatesLoaded = (0, _eventFactory.eventFactory)(ShippingRatesLoadedKey)();
function loadShippingRates(deps) {
    return /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(event) {
            var shippingRates;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            deps.retrieveShippingRates()
                        ];
                    case 1:
                        shippingRates = _state.sent();
                        return [
                            4,
                            deps.publishEvent(ShippingRatesLoaded({
                                shippingRates: shippingRates
                            }))
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }();
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_ts_generator":"f2hGH","../../std/eventFactory":"f2PpV","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8H2M7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sectionsHandlers", function() {
    return sectionsHandlers;
});
parcelHelpers.export(exports, "sectionsDeps", function() {
    return sectionsDeps;
});
parcelHelpers.export(exports, "sectionsReducer", function() {
    return sectionsReducer;
});
parcelHelpers.export(exports, "Sections", function() {
    return Sections;
});
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _handlers = require("./reviewsPreview/handlers");
var _redux = require("redux");
var _state = require("./reviewsPreview/state");
var _medias = require("./medias");
var _liquid = require("./productHero/liquid");
var _liquid1 = require("./reviewsPreview/liquid");
var _faq = require("./faq");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _deps = require("./reviewsPreview/deps");
var _dom = require("./productsWithFilter/js/dom");
var _liquid2 = require("./choiceHelper/liquid");
var _deps1 = require("./choiceHelper/deps");
var _state1 = require("./choiceHelper/state");
var _handlers1 = require("./choiceHelper/handlers");
var _liquid3 = require("./testimonials/liquid");
var _offers = require("./offers");
var _dom1 = require("./lpDestinationQuiz/dom");
function sectionsHandlers(params) {
    (0, _handlers.reviewsPreviewHandlers)(params);
    (0, _handlers1.choiceHelperHandlers)(params);
}
function sectionsDeps(ref) {
    return {
        reviewsPreview: function() {
            return (0, _deps.reviewsPreviewDeps)(ref.deps);
        },
        choiceHelper: function() {
            return (0, _deps1.choiceHelperDeps)(ref.deps);
        }
    };
}
var sectionsReducer = (0, _redux.combineReducers)({
    reviewsPreview: (0, _state.reviewsPreviewReducer),
    choiceHelper: (0, _state1.choiceHelperReducer)
});
function Sections() {
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _jsxDevRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _medias.Medias), {}, void 0, false, {
                fileName: "src/sections/index.tsx",
                lineNumber: 63,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _liquid.ProductHero), {}, void 0, false, {
                fileName: "src/sections/index.tsx",
                lineNumber: 64,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _liquid1.ReviewsPreview), {}, void 0, false, {
                fileName: "src/sections/index.tsx",
                lineNumber: 65,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _dom.ProductsWithFilter), {}, void 0, false, {
                fileName: "src/sections/index.tsx",
                lineNumber: 66,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _faq.Faq), {}, void 0, false, {
                fileName: "src/sections/index.tsx",
                lineNumber: 67,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _liquid2.ChoiceHelper), {}, void 0, false, {
                fileName: "src/sections/index.tsx",
                lineNumber: 68,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _liquid3.Testimonials), {}, void 0, false, {
                fileName: "src/sections/index.tsx",
                lineNumber: 69,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _offers.Offers), {}, void 0, false, {
                fileName: "src/sections/index.tsx",
                lineNumber: 70,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _dom1.LpDestinationQuiz), {}, void 0, false, {
                fileName: "src/sections/index.tsx",
                lineNumber: 71,
                columnNumber: 13
            }, this)
        ]
    }, void 0, true);
}

},{"react/jsx-dev-runtime":"jXZ8I","./reviewsPreview/handlers":"bldky","redux":"lKoa8","./reviewsPreview/state":"kx1bN","./medias":"c0qiU","./productHero/liquid":"e1D7H","./reviewsPreview/liquid":"31IQY","./faq":"dfGqs","react":"c8CN1","./reviewsPreview/deps":"ccm9w","./productsWithFilter/js/dom":"cILyh","./choiceHelper/liquid":"246fu","./choiceHelper/deps":"8HnTs","./choiceHelper/state":"jTUgf","./choiceHelper/handlers":"FC17t","./testimonials/liquid":"9ReXb","./offers":"ehF57","./lpDestinationQuiz/dom":"407d8","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jXZ8I":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("ee51401569654d91");

},{"ee51401569654d91":"21UNC"}],"21UNC":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-jsx-dev-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
(function() {
    'use strict';
    var React = require("58362d9d82be395f");
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types.
    var REACT_ELEMENT_TYPE = Symbol.for('react.element');
    var REACT_PORTAL_TYPE = Symbol.for('react.portal');
    var REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
    var REACT_STRICT_MODE_TYPE = Symbol.for('react.strict_mode');
    var REACT_PROFILER_TYPE = Symbol.for('react.profiler');
    var REACT_PROVIDER_TYPE = Symbol.for('react.provider');
    var REACT_CONTEXT_TYPE = Symbol.for('react.context');
    var REACT_FORWARD_REF_TYPE = Symbol.for('react.forward_ref');
    var REACT_SUSPENSE_TYPE = Symbol.for('react.suspense');
    var REACT_SUSPENSE_LIST_TYPE = Symbol.for('react.suspense_list');
    var REACT_MEMO_TYPE = Symbol.for('react.memo');
    var REACT_LAZY_TYPE = Symbol.for('react.lazy');
    var REACT_OFFSCREEN_TYPE = Symbol.for('react.offscreen');
    var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = '@@iterator';
    function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== 'object') return null;
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === 'function') return maybeIterator;
        return null;
    }
    var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function error(format) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        printWarning('error', format, args);
    }
    function printWarning(level, format, args) {
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        var stack = ReactDebugCurrentFrame.getStackAddendum();
        if (stack !== '') {
            format += '%s';
            args = args.concat([
                stack
            ]);
        } // eslint-disable-next-line react-internal/safe-string-coercion
        var argsWithFormat = args.map(function(item) {
            return String(item);
        }); // Careful: RN currently depends on this prefix
        argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
        // breaks IE9: https://github.com/facebook/react/issues/13610
        // eslint-disable-next-line react-internal/no-production-logging
        Function.prototype.apply.call(console[level], console, argsWithFormat);
    }
    // -----------------------------------------------------------------------------
    var enableScopeAPI = false; // Experimental Create Event Handle API.
    var enableCacheElement = false;
    var enableTransitionTracing = false; // No known bugs, but needs performance testing
    var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
    // stuff. Intended to enable React core members to more easily debug scheduling
    // issues in DEV builds.
    var enableDebugTracing = false; // Track which Fiber(s) schedule render work.
    var REACT_MODULE_REFERENCE;
    REACT_MODULE_REFERENCE = Symbol.for('react.module.reference');
    function isValidElementType(type) {
        if (typeof type === 'string' || typeof type === 'function') return true;
         // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).
        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) return true;
        if (typeof type === 'object' && type !== null) {
            if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
            // types supported by any Flight configuration anywhere since
            // we don't know which Flight build this will end up being used
            // with.
            type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) return true;
        }
        return false;
    }
    function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;
        if (displayName) return displayName;
        var functionName = innerType.displayName || innerType.name || '';
        return functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName;
    } // Keep in sync with react-reconciler/getComponentNameFromFiber
    function getContextName(type) {
        return type.displayName || 'Context';
    } // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.
    function getComponentNameFromType(type) {
        if (type == null) // Host root, text node or just invalid type.
        return null;
        if (typeof type.tag === 'number') error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
        if (typeof type === 'function') return type.displayName || type.name || null;
        if (typeof type === 'string') return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return 'Fragment';
            case REACT_PORTAL_TYPE:
                return 'Portal';
            case REACT_PROFILER_TYPE:
                return 'Profiler';
            case REACT_STRICT_MODE_TYPE:
                return 'StrictMode';
            case REACT_SUSPENSE_TYPE:
                return 'Suspense';
            case REACT_SUSPENSE_LIST_TYPE:
                return 'SuspenseList';
        }
        if (typeof type === 'object') switch(type.$$typeof){
            case REACT_CONTEXT_TYPE:
                var context = type;
                return getContextName(context) + '.Consumer';
            case REACT_PROVIDER_TYPE:
                var provider = type;
                return getContextName(provider._context) + '.Provider';
            case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, 'ForwardRef');
            case REACT_MEMO_TYPE:
                var outerName = type.displayName || null;
                if (outerName !== null) return outerName;
                return getComponentNameFromType(type.type) || 'Memo';
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    return getComponentNameFromType(init(payload));
                } catch (x) {
                    return null;
                }
        }
        return null;
    }
    var assign = Object.assign;
    // Helpers to patch console.logs to avoid logging during side-effect free
    // replaying on render function. This currently only patches the object
    // lazily which won't cover if the log function was extracted eagerly.
    // We could also eagerly patch the method.
    var disabledDepth = 0;
    var prevLog;
    var prevInfo;
    var prevWarn;
    var prevError;
    var prevGroup;
    var prevGroupCollapsed;
    var prevGroupEnd;
    function disabledLog() {}
    disabledLog.__reactDisabledLog = true;
    function disableLogs() {
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099
            var props = {
                configurable: true,
                enumerable: true,
                value: disabledLog,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
            });
        /* eslint-enable react-internal/no-production-logging */ }
        disabledDepth++;
    }
    function reenableLogs() {
        disabledDepth--;
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ var props = {
                configurable: true,
                enumerable: true,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                log: assign({}, props, {
                    value: prevLog
                }),
                info: assign({}, props, {
                    value: prevInfo
                }),
                warn: assign({}, props, {
                    value: prevWarn
                }),
                error: assign({}, props, {
                    value: prevError
                }),
                group: assign({}, props, {
                    value: prevGroup
                }),
                groupCollapsed: assign({}, props, {
                    value: prevGroupCollapsed
                }),
                groupEnd: assign({}, props, {
                    value: prevGroupEnd
                })
            });
        /* eslint-enable react-internal/no-production-logging */ }
        if (disabledDepth < 0) error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
    }
    var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
    var prefix;
    function describeBuiltInComponentFrame(name, source, ownerFn) {
        if (prefix === undefined) // Extract the VM specific prefix used by each line.
        try {
            throw Error();
        } catch (x) {
            var match = x.stack.trim().match(/\n( *(at )?)/);
            prefix = match && match[1] || '';
        }
         // We use the prefix to ensure our stacks line up with native stack frames.
        return '\n' + prefix + name;
    }
    var reentry = false;
    var componentFrameCache;
    var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
    componentFrameCache = new PossiblyWeakMap();
    function describeNativeComponentFrame(fn, construct) {
        // If something asked for a stack inside a fake render, it should get ignored.
        if (!fn || reentry) return '';
        var frame = componentFrameCache.get(fn);
        if (frame !== undefined) return frame;
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.
        Error.prepareStackTrace = undefined;
        var previousDispatcher;
        previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
        // for warnings.
        ReactCurrentDispatcher.current = null;
        disableLogs();
        try {
            // This should throw.
            if (construct) {
                // Something should be setting the props in the constructor.
                var Fake = function Fake() {
                    throw Error();
                }; // $FlowFixMe
                Object.defineProperty(Fake.prototype, 'props', {
                    set: function set() {
                        // We use a throwing setter instead of frozen or non-writable props
                        // because that won't throw in a non-strict mode function.
                        throw Error();
                    }
                });
                if (typeof Reflect === 'object' && Reflect.construct) {
                    // We construct a different control for this case to include any extra
                    // frames added by the construct call.
                    try {
                        Reflect.construct(Fake, []);
                    } catch (x) {
                        control = x;
                    }
                    Reflect.construct(fn, [], Fake);
                } else {
                    try {
                        Fake.call();
                    } catch (x) {
                        control = x;
                    }
                    fn.call(Fake.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (x) {
                    control = x;
                }
                fn();
            }
        } catch (sample) {
            // This is inlined manually because closure doesn't do it for us.
            if (sample && control && typeof sample.stack === 'string') {
                // This extracts the first frame from the sample that isn't also in the control.
                // Skipping one frame that we assume is the frame that calls the two.
                var sampleLines = sample.stack.split('\n');
                var controlLines = control.stack.split('\n');
                var s = sampleLines.length - 1;
                var c = controlLines.length - 1;
                while(s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c])// We expect at least one stack frame to be shared.
                // Typically this will be the root most one. However, stack frames may be
                // cut off due to maximum stack limits. In this case, one maybe cut off
                // earlier than the other. We assume that the sample is longer or the same
                // and there for cut off earlier. So we should find the root most frame in
                // the sample somewhere in the control.
                c--;
                for(; s >= 1 && c >= 0; s--, c--)// Next we find the first one that isn't the same which should be the
                // frame that called our sample function and the control.
                if (sampleLines[s] !== controlLines[c]) {
                    // In V8, the first line is describing the message but other VMs don't.
                    // If we're about to return the first line, and the control is also on the same
                    // line, that's a pretty good indicator that our sample threw at same line as
                    // the control. I.e. before we entered the sample frame. So we ignore this result.
                    // This can happen if you passed a class to function component, or non-function.
                    if (s !== 1 || c !== 1) do {
                        s--;
                        c--; // We may still have similar intermediate frames from the construct call.
                        // The next one that isn't the same should be our match though.
                        if (c < 0 || sampleLines[s] !== controlLines[c]) {
                            // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                            var _frame = '\n' + sampleLines[s].replace(' at new ', ' at '); // If our component frame is labeled "<anonymous>"
                            // but we have a user-provided "displayName"
                            // splice it in to make the stack more readable.
                            if (fn.displayName && _frame.includes('<anonymous>')) _frame = _frame.replace('<anonymous>', fn.displayName);
                            if (typeof fn === 'function') componentFrameCache.set(fn, _frame);
                            return _frame;
                        }
                    }while (s >= 1 && c >= 0);
                    break;
                }
            }
        } finally{
            reentry = false;
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
            Error.prepareStackTrace = previousPrepareStackTrace;
        } // Fallback to just using the name if we couldn't make it throw.
        var name = fn ? fn.displayName || fn.name : '';
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : '';
        if (typeof fn === 'function') componentFrameCache.set(fn, syntheticFrame);
        return syntheticFrame;
    }
    function describeFunctionComponentFrame(fn, source, ownerFn) {
        return describeNativeComponentFrame(fn, false);
    }
    function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) return '';
        if (typeof type === 'function') return describeNativeComponentFrame(type, shouldConstruct(type));
        if (typeof type === 'string') return describeBuiltInComponentFrame(type);
        switch(type){
            case REACT_SUSPENSE_TYPE:
                return describeBuiltInComponentFrame('Suspense');
            case REACT_SUSPENSE_LIST_TYPE:
                return describeBuiltInComponentFrame('SuspenseList');
        }
        if (typeof type === 'object') switch(type.$$typeof){
            case REACT_FORWARD_REF_TYPE:
                return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
                // Memo may contain any component type so we recursively resolve it.
                return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    // Lazy may contain any component type so we recursively resolve it.
                    return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
        }
        return '';
    }
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var loggedTypeFailures = {};
    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame.setExtraStackFrame(null);
    }
    function checkPropTypes(typeSpecs, values, location, componentName, element) {
        // $FlowFixMe This is okay but Flow doesn't know it.
        var has = Function.call.bind(hasOwnProperty);
        for(var typeSpecName in typeSpecs)if (has(typeSpecs, typeSpecName)) {
            var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.
            try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                if (typeof typeSpecs[typeSpecName] !== 'function') {
                    // eslint-disable-next-line react-internal/prod-error-codes
                    var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
                    err.name = 'Invariant Violation';
                    throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
            } catch (ex) {
                error$1 = ex;
            }
            if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || 'React class', location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
            }
            if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error('Failed %s type: %s', location, error$1.message);
                setCurrentlyValidatingElement(null);
            }
        }
    }
    var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare
    function isArray(a) {
        return isArrayImpl(a);
    }
    /*
 * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
 * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
 *
 * The functions in this module will throw an easier-to-understand,
 * easier-to-debug exception with a clear errors message message explaining the
 * problem. (Instead of a confusing exception thrown inside the implementation
 * of the `value` object).
 */ // $FlowFixMe only called in DEV, so void return is not possible.
    function typeName(value) {
        // toStringTag is needed for namespaced types like Temporal.Instant
        var hasToStringTag = typeof Symbol === 'function' && Symbol.toStringTag;
        var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || 'Object';
        return type;
    } // $FlowFixMe only called in DEV, so void return is not possible.
    function willCoercionThrow(value) {
        try {
            testStringCoercion(value);
            return false;
        } catch (e) {
            return true;
        }
    }
    function testStringCoercion(value) {
        // If you ended up here by following an exception call stack, here's what's
        // happened: you supplied an object or symbol value to React (as a prop, key,
        // DOM attribute, CSS property, string ref, etc.) and when React tried to
        // coerce it to a string using `'' + value`, an exception was thrown.
        //
        // The most common types that will cause this exception are `Symbol` instances
        // and Temporal objects like `Temporal.Instant`. But any object that has a
        // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
        // exception. (Library authors do this to prevent users from using built-in
        // numeric operators like `+` or comparison operators like `>=` because custom
        // methods are needed to perform accurate arithmetic or comparison.)
        //
        // To fix the problem, coerce this object or symbol value to a string before
        // passing it to React. The most reliable way is usually `String(value)`.
        //
        // To find which value is throwing, check the browser or debugger console.
        // Before this exception was thrown, there should be `console.error` output
        // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
        // problem and how that type was used: key, atrribute, input value prop, etc.
        // In most cases, this console output also shows the component and its
        // ancestor components where the exception happened.
        //
        // eslint-disable-next-line react-internal/safe-string-coercion
        return '' + value;
    }
    function checkKeyStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
    var RESERVED_PROPS = {
        key: true,
        ref: true,
        __self: true,
        __source: true
    };
    var specialPropKeyWarningShown;
    var specialPropRefWarningShown;
    var didWarnAboutStringRefs;
    didWarnAboutStringRefs = {};
    function hasValidRef(config) {
        if (hasOwnProperty.call(config, 'ref')) {
            var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.ref !== undefined;
    }
    function hasValidKey(config) {
        if (hasOwnProperty.call(config, 'key')) {
            var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.key !== undefined;
    }
    function warnIfStringRefCannotBeAutoConverted(config, self) {
        if (typeof config.ref === 'string' && ReactCurrentOwner.current && self && ReactCurrentOwner.current.stateNode !== self) {
            var componentName = getComponentNameFromType(ReactCurrentOwner.current.type);
            if (!didWarnAboutStringRefs[componentName]) {
                error('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', getComponentNameFromType(ReactCurrentOwner.current.type), config.ref);
                didWarnAboutStringRefs[componentName] = true;
            }
        }
    }
    function defineKeyPropWarningGetter(props, displayName) {
        var warnAboutAccessingKey = function warnAboutAccessingKey() {
            if (!specialPropKeyWarningShown) {
                specialPropKeyWarningShown = true;
                error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingKey.isReactWarning = true;
        Object.defineProperty(props, 'key', {
            get: warnAboutAccessingKey,
            configurable: true
        });
    }
    function defineRefPropWarningGetter(props, displayName) {
        var warnAboutAccessingRef = function warnAboutAccessingRef() {
            if (!specialPropRefWarningShown) {
                specialPropRefWarningShown = true;
                error("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingRef.isReactWarning = true;
        Object.defineProperty(props, 'ref', {
            get: warnAboutAccessingRef,
            configurable: true
        });
    }
    /**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, instanceof check
 * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} props
 * @param {*} key
 * @param {string|object} ref
 * @param {*} owner
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @internal
 */ var ReactElement = function ReactElement(type, key, ref, self, source, owner, props) {
        var element = {
            // This tag allows us to uniquely identify this as a React Element
            $$typeof: REACT_ELEMENT_TYPE,
            // Built-in properties that belong on the element
            type: type,
            key: key,
            ref: ref,
            props: props,
            // Record the component responsible for creating this element.
            _owner: owner
        };
        // The validation flag is currently mutative. We put it on
        // an external backing store so that we can freeze the whole object.
        // This can be replaced with a WeakMap once they are implemented in
        // commonly used development environments.
        element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
        // the validation flag non-enumerable (where possible, which should
        // include every environment we run tests in), so the test framework
        // ignores it.
        Object.defineProperty(element._store, 'validated', {
            configurable: false,
            enumerable: false,
            writable: true,
            value: false
        }); // self and source are DEV only properties.
        Object.defineProperty(element, '_self', {
            configurable: false,
            enumerable: false,
            writable: false,
            value: self
        }); // Two elements created in two different places should be considered
        // equal for testing purposes and therefore we hide it from enumeration.
        Object.defineProperty(element, '_source', {
            configurable: false,
            enumerable: false,
            writable: false,
            value: source
        });
        if (Object.freeze) {
            Object.freeze(element.props);
            Object.freeze(element);
        }
        return element;
    };
    /**
 * https://github.com/reactjs/rfcs/pull/107
 * @param {*} type
 * @param {object} props
 * @param {string} key
 */ function jsxDEV(type, config, maybeKey, source, self) {
        var propName; // Reserved names are extracted
        var props = {};
        var key = null;
        var ref = null; // Currently, key can be spread in as a prop. This causes a potential
        // issue if key is also explicitly declared (ie. <div {...props} key="Hi" />
        // or <div key="Hi" {...props} /> ). We want to deprecate key spread,
        // but as an intermediary step, we will use jsxDEV for everything except
        // <div {...props} key="Hi" />, because we aren't currently able to tell if
        // key is explicitly declared to be undefined or not.
        if (maybeKey !== undefined) {
            checkKeyStringCoercion(maybeKey);
            key = '' + maybeKey;
        }
        if (hasValidKey(config)) {
            checkKeyStringCoercion(config.key);
            key = '' + config.key;
        }
        if (hasValidRef(config)) {
            ref = config.ref;
            warnIfStringRefCannotBeAutoConverted(config, self);
        } // Remaining properties are added to a new props object
        for(propName in config)if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) props[propName] = config[propName];
         // Resolve default props
        if (type && type.defaultProps) {
            var defaultProps = type.defaultProps;
            for(propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
        }
        if (key || ref) {
            var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
            if (key) defineKeyPropWarningGetter(props, displayName);
            if (ref) defineRefPropWarningGetter(props, displayName);
        }
        return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
    }
    var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
    var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement$1(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
    var propTypesMisspellWarningShown;
    propTypesMisspellWarningShown = false;
    /**
 * Verifies the object is a ReactElement.
 * See https://reactjs.org/docs/react-api.html#isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a ReactElement.
 * @final
 */ function isValidElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function getDeclarationErrorAddendum() {
        if (ReactCurrentOwner$1.current) {
            var name = getComponentNameFromType(ReactCurrentOwner$1.current.type);
            if (name) return '\n\nCheck the render method of `' + name + '`.';
        }
        return '';
    }
    function getSourceInfoErrorAddendum(source) {
        if (source !== undefined) {
            var fileName = source.fileName.replace(/^.*[\\\/]/, '');
            var lineNumber = source.lineNumber;
            return '\n\nCheck your code at ' + fileName + ':' + lineNumber + '.';
        }
        return '';
    }
    /**
 * Warn if there's no key explicitly set on dynamic arrays of children or
 * object keys are not valid. This allows us to keep track of children between
 * updates.
 */ var ownerHasKeyUseWarning = {};
    function getCurrentComponentErrorInfo(parentType) {
        var info = getDeclarationErrorAddendum();
        if (!info) {
            var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;
            if (parentName) info = "\n\nCheck the top-level render call using <" + parentName + ">.";
        }
        return info;
    }
    /**
 * Warn if the element doesn't have an explicit key assigned to it.
 * This element is in an array. The array could grow and shrink or be
 * reordered. All children that haven't already been validated are required to
 * have a "key" property assigned to it. Error statuses are cached so a warning
 * will only be shown once.
 *
 * @internal
 * @param {ReactElement} element Element that requires a key.
 * @param {*} parentType element's parent's type.
 */ function validateExplicitKey(element, parentType) {
        if (!element._store || element._store.validated || element.key != null) return;
        element._store.validated = true;
        var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
        if (ownerHasKeyUseWarning[currentComponentErrorInfo]) return;
        ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
        // property, it may be the creator of the child that's responsible for
        // assigning it a key.
        var childOwner = '';
        if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) // Give the component that originally created this child.
        childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
        setCurrentlyValidatingElement$1(element);
        error('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
        setCurrentlyValidatingElement$1(null);
    }
    /**
 * Ensure that every element either is passed in a static location, in an
 * array with an explicit keys property defined, or in an object literal
 * with valid key property.
 *
 * @internal
 * @param {ReactNode} node Statically passed child of any type.
 * @param {*} parentType node's parent's type.
 */ function validateChildKeys(node, parentType) {
        if (typeof node !== 'object') return;
        if (isArray(node)) for(var i = 0; i < node.length; i++){
            var child = node[i];
            if (isValidElement(child)) validateExplicitKey(child, parentType);
        }
        else if (isValidElement(node)) // This element was passed in a valid location.
        {
            if (node._store) node._store.validated = true;
        } else if (node) {
            var iteratorFn = getIteratorFn(node);
            if (typeof iteratorFn === 'function') // Entry iterators used to provide implicit keys,
            // but now we print a separate warning for them later.
            {
                if (iteratorFn !== node.entries) {
                    var iterator = iteratorFn.call(node);
                    var step;
                    while(!(step = iterator.next()).done)if (isValidElement(step.value)) validateExplicitKey(step.value, parentType);
                }
            }
        }
    }
    /**
 * Given an element, validate that its props follow the propTypes definition,
 * provided by the type.
 *
 * @param {ReactElement} element
 */ function validatePropTypes(element) {
        var type = element.type;
        if (type === null || type === undefined || typeof type === 'string') return;
        var propTypes;
        if (typeof type === 'function') propTypes = type.propTypes;
        else if (typeof type === 'object' && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        type.$$typeof === REACT_MEMO_TYPE)) propTypes = type.propTypes;
        else return;
        if (propTypes) {
            // Intentionally inside to avoid triggering lazy initializers:
            var name = getComponentNameFromType(type);
            checkPropTypes(propTypes, element.props, 'prop', name, element);
        } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
            propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:
            var _name = getComponentNameFromType(type);
            error('Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?', _name || 'Unknown');
        }
        if (typeof type.getDefaultProps === 'function' && !type.getDefaultProps.isReactClassApproved) error("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
    }
    /**
 * Given a fragment, validate that it can only be provided with fragment props
 * @param {ReactElement} fragment
 */ function validateFragmentProps(fragment) {
        var keys = Object.keys(fragment.props);
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            if (key !== 'children' && key !== 'key') {
                setCurrentlyValidatingElement$1(fragment);
                error("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", key);
                setCurrentlyValidatingElement$1(null);
                break;
            }
        }
        if (fragment.ref !== null) {
            setCurrentlyValidatingElement$1(fragment);
            error('Invalid attribute `ref` supplied to `React.Fragment`.');
            setCurrentlyValidatingElement$1(null);
        }
    }
    var didWarnAboutKeySpread = {};
    function jsxWithValidation(type, props, key, isStaticChildren, source, self) {
        var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
        // succeed and there will likely be errors in render.
        if (!validType) {
            var info = '';
            if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
            var sourceInfo = getSourceInfoErrorAddendum(source);
            if (sourceInfo) info += sourceInfo;
            else info += getDeclarationErrorAddendum();
            var typeString;
            if (type === null) typeString = 'null';
            else if (isArray(type)) typeString = 'array';
            else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
                typeString = "<" + (getComponentNameFromType(type.type) || 'Unknown') + " />";
                info = ' Did you accidentally export a JSX literal instead of a component?';
            } else typeString = typeof type;
            error("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", typeString, info);
        }
        var element = jsxDEV(type, props, key, source, self); // The result can be nullish if a mock or a custom function is used.
        // TODO: Drop this when these are no longer allowed as the type argument.
        if (element == null) return element;
         // Skip key warning if the type isn't valid since our key validation logic
        // doesn't expect a non-string/function type and can throw confusing errors.
        // We don't want exception behavior to differ between dev and prod.
        // (Rendering will throw with a helpful message and as soon as the type is
        // fixed, the key warnings will appear.)
        if (validType) {
            var children = props.children;
            if (children !== undefined) {
                if (isStaticChildren) {
                    if (isArray(children)) {
                        for(var i = 0; i < children.length; i++)validateChildKeys(children[i], type);
                        if (Object.freeze) Object.freeze(children);
                    } else error("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
                } else validateChildKeys(children, type);
            }
        }
        if (hasOwnProperty.call(props, 'key')) {
            var componentName = getComponentNameFromType(type);
            var keys = Object.keys(props).filter(function(k) {
                return k !== 'key';
            });
            var beforeExample = keys.length > 0 ? '{key: someKey, ' + keys.join(': ..., ') + ': ...}' : '{key: someKey}';
            if (!didWarnAboutKeySpread[componentName + beforeExample]) {
                var afterExample = keys.length > 0 ? '{' + keys.join(': ..., ') + ': ...}' : '{}';
                error('A props object containing a "key" prop is being spread into JSX:\n  let props = %s;\n  <%s {...props} />\nReact keys must be passed directly to JSX without using spread:\n  let props = %s;\n  <%s key={someKey} {...props} />', beforeExample, componentName, afterExample, componentName);
                didWarnAboutKeySpread[componentName + beforeExample] = true;
            }
        }
        if (type === REACT_FRAGMENT_TYPE) validateFragmentProps(element);
        else validatePropTypes(element);
        return element;
    } // These two functions exist to still get child warnings in dev
    var jsxDEV$1 = jsxWithValidation;
    exports.Fragment = REACT_FRAGMENT_TYPE;
    exports.jsxDEV = jsxDEV$1;
})();

},{"58362d9d82be395f":"c8CN1"}],"c8CN1":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("a569817e6ea559f6");

},{"a569817e6ea559f6":"2rYyj"}],"2rYyj":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
(function() {
    'use strict';
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === 'function') __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var ReactVersion = '18.3.1';
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types.
    var REACT_ELEMENT_TYPE = Symbol.for('react.element');
    var REACT_PORTAL_TYPE = Symbol.for('react.portal');
    var REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
    var REACT_STRICT_MODE_TYPE = Symbol.for('react.strict_mode');
    var REACT_PROFILER_TYPE = Symbol.for('react.profiler');
    var REACT_PROVIDER_TYPE = Symbol.for('react.provider');
    var REACT_CONTEXT_TYPE = Symbol.for('react.context');
    var REACT_FORWARD_REF_TYPE = Symbol.for('react.forward_ref');
    var REACT_SUSPENSE_TYPE = Symbol.for('react.suspense');
    var REACT_SUSPENSE_LIST_TYPE = Symbol.for('react.suspense_list');
    var REACT_MEMO_TYPE = Symbol.for('react.memo');
    var REACT_LAZY_TYPE = Symbol.for('react.lazy');
    var REACT_OFFSCREEN_TYPE = Symbol.for('react.offscreen');
    var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = '@@iterator';
    function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== 'object') return null;
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === 'function') return maybeIterator;
        return null;
    }
    /**
 * Keeps track of the current dispatcher.
 */ var ReactCurrentDispatcher = {
        /**
   * @internal
   * @type {ReactComponent}
   */ current: null
    };
    /**
 * Keeps track of the current batch's configuration such as how long an update
 * should suspend for if it needs to.
 */ var ReactCurrentBatchConfig = {
        transition: null
    };
    var ReactCurrentActQueue = {
        current: null,
        // Used to reproduce behavior of `batchedUpdates` in legacy mode.
        isBatchingLegacy: false,
        didScheduleLegacyUpdate: false
    };
    /**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */ var ReactCurrentOwner = {
        /**
   * @internal
   * @type {ReactComponent}
   */ current: null
    };
    var ReactDebugCurrentFrame = {};
    var currentExtraStackFrame = null;
    function setExtraStackFrame(stack) {
        currentExtraStackFrame = stack;
    }
    ReactDebugCurrentFrame.setExtraStackFrame = function(stack) {
        currentExtraStackFrame = stack;
    }; // Stack implementation injected by the current renderer.
    ReactDebugCurrentFrame.getCurrentStack = null;
    ReactDebugCurrentFrame.getStackAddendum = function() {
        var stack = ''; // Add an extra top frame while an element is being validated
        if (currentExtraStackFrame) stack += currentExtraStackFrame;
         // Delegate to the injected renderer-specific implementation
        var impl = ReactDebugCurrentFrame.getCurrentStack;
        if (impl) stack += impl() || '';
        return stack;
    };
    // -----------------------------------------------------------------------------
    var enableScopeAPI = false; // Experimental Create Event Handle API.
    var enableCacheElement = false;
    var enableTransitionTracing = false; // No known bugs, but needs performance testing
    var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
    // stuff. Intended to enable React core members to more easily debug scheduling
    // issues in DEV builds.
    var enableDebugTracing = false; // Track which Fiber(s) schedule render work.
    var ReactSharedInternals = {
        ReactCurrentDispatcher: ReactCurrentDispatcher,
        ReactCurrentBatchConfig: ReactCurrentBatchConfig,
        ReactCurrentOwner: ReactCurrentOwner
    };
    ReactSharedInternals.ReactDebugCurrentFrame = ReactDebugCurrentFrame;
    ReactSharedInternals.ReactCurrentActQueue = ReactCurrentActQueue;
    // by calls to these methods by a Babel plugin.
    //
    // In PROD (or in packages without access to React internals),
    // they are left as they are instead.
    function warn(format) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        printWarning('warn', format, args);
    }
    function error(format) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        printWarning('error', format, args);
    }
    function printWarning(level, format, args) {
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        var stack = ReactDebugCurrentFrame.getStackAddendum();
        if (stack !== '') {
            format += '%s';
            args = args.concat([
                stack
            ]);
        } // eslint-disable-next-line react-internal/safe-string-coercion
        var argsWithFormat = args.map(function(item) {
            return String(item);
        }); // Careful: RN currently depends on this prefix
        argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
        // breaks IE9: https://github.com/facebook/react/issues/13610
        // eslint-disable-next-line react-internal/no-production-logging
        Function.prototype.apply.call(console[level], console, argsWithFormat);
    }
    var didWarnStateUpdateForUnmountedComponent = {};
    function warnNoop(publicInstance, callerName) {
        var _constructor = publicInstance.constructor;
        var componentName = _constructor && (_constructor.displayName || _constructor.name) || 'ReactClass';
        var warningKey = componentName + "." + callerName;
        if (didWarnStateUpdateForUnmountedComponent[warningKey]) return;
        error("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.", callerName, componentName);
        didWarnStateUpdateForUnmountedComponent[warningKey] = true;
    }
    /**
 * This is the abstract API for an update queue.
 */ var ReactNoopUpdateQueue = {
        /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */ isMounted: function isMounted(publicInstance) {
            return false;
        },
        /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {?function} callback Called after component is updated.
   * @param {?string} callerName name of the calling function in the public API.
   * @internal
   */ enqueueForceUpdate: function enqueueForceUpdate(publicInstance, callback, callerName) {
            warnNoop(publicInstance, 'forceUpdate');
        },
        /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @param {?function} callback Called after component is updated.
   * @param {?string} callerName name of the calling function in the public API.
   * @internal
   */ enqueueReplaceState: function enqueueReplaceState(publicInstance, completeState, callback, callerName) {
            warnNoop(publicInstance, 'replaceState');
        },
        /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @param {?function} callback Called after component is updated.
   * @param {?string} Name of the calling function in the public API.
   * @internal
   */ enqueueSetState: function enqueueSetState(publicInstance, partialState, callback, callerName) {
            warnNoop(publicInstance, 'setState');
        }
    };
    var assign = Object.assign;
    var emptyObject = {};
    Object.freeze(emptyObject);
    /**
 * Base class helpers for the updating state of a component.
 */ function Component(props, context, updater) {
        this.props = props;
        this.context = context; // If a component has string refs, we will assign a different object later.
        this.refs = emptyObject; // We initialize the default updater but the real one gets injected by the
        // renderer.
        this.updater = updater || ReactNoopUpdateQueue;
    }
    Component.prototype.isReactComponent = {};
    /**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */ Component.prototype.setState = function(partialState, callback) {
        if (typeof partialState !== 'object' && typeof partialState !== 'function' && partialState != null) throw new Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
        this.updater.enqueueSetState(this, partialState, callback, 'setState');
    };
    /**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */ Component.prototype.forceUpdate = function(callback) {
        this.updater.enqueueForceUpdate(this, callback, 'forceUpdate');
    };
    var deprecatedAPIs = {
        isMounted: [
            'isMounted',
            "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."
        ],
        replaceState: [
            'replaceState',
            "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."
        ]
    };
    var defineDeprecationWarning = function defineDeprecationWarning(methodName, info) {
        Object.defineProperty(Component.prototype, methodName, {
            get: function get() {
                warn('%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
                return undefined;
            }
        });
    };
    for(var fnName in deprecatedAPIs)if (deprecatedAPIs.hasOwnProperty(fnName)) defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    function ComponentDummy() {}
    ComponentDummy.prototype = Component.prototype;
    /**
 * Convenience component with default shallow equality check for sCU.
 */ function PureComponent(props, context, updater) {
        this.props = props;
        this.context = context; // If a component has string refs, we will assign a different object later.
        this.refs = emptyObject;
        this.updater = updater || ReactNoopUpdateQueue;
    }
    var pureComponentPrototype = PureComponent.prototype = new ComponentDummy();
    pureComponentPrototype.constructor = PureComponent; // Avoid an extra prototype jump for these methods.
    assign(pureComponentPrototype, Component.prototype);
    pureComponentPrototype.isPureReactComponent = true;
    // an immutable object with a single mutable value
    function createRef() {
        var refObject = {
            current: null
        };
        Object.seal(refObject);
        return refObject;
    }
    var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare
    function isArray(a) {
        return isArrayImpl(a);
    }
    /*
 * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
 * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
 *
 * The functions in this module will throw an easier-to-understand,
 * easier-to-debug exception with a clear errors message message explaining the
 * problem. (Instead of a confusing exception thrown inside the implementation
 * of the `value` object).
 */ // $FlowFixMe only called in DEV, so void return is not possible.
    function typeName(value) {
        // toStringTag is needed for namespaced types like Temporal.Instant
        var hasToStringTag = typeof Symbol === 'function' && Symbol.toStringTag;
        var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || 'Object';
        return type;
    } // $FlowFixMe only called in DEV, so void return is not possible.
    function willCoercionThrow(value) {
        try {
            testStringCoercion(value);
            return false;
        } catch (e) {
            return true;
        }
    }
    function testStringCoercion(value) {
        // If you ended up here by following an exception call stack, here's what's
        // happened: you supplied an object or symbol value to React (as a prop, key,
        // DOM attribute, CSS property, string ref, etc.) and when React tried to
        // coerce it to a string using `'' + value`, an exception was thrown.
        //
        // The most common types that will cause this exception are `Symbol` instances
        // and Temporal objects like `Temporal.Instant`. But any object that has a
        // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
        // exception. (Library authors do this to prevent users from using built-in
        // numeric operators like `+` or comparison operators like `>=` because custom
        // methods are needed to perform accurate arithmetic or comparison.)
        //
        // To fix the problem, coerce this object or symbol value to a string before
        // passing it to React. The most reliable way is usually `String(value)`.
        //
        // To find which value is throwing, check the browser or debugger console.
        // Before this exception was thrown, there should be `console.error` output
        // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
        // problem and how that type was used: key, atrribute, input value prop, etc.
        // In most cases, this console output also shows the component and its
        // ancestor components where the exception happened.
        //
        // eslint-disable-next-line react-internal/safe-string-coercion
        return '' + value;
    }
    function checkKeyStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;
        if (displayName) return displayName;
        var functionName = innerType.displayName || innerType.name || '';
        return functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName;
    } // Keep in sync with react-reconciler/getComponentNameFromFiber
    function getContextName(type) {
        return type.displayName || 'Context';
    } // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.
    function getComponentNameFromType(type) {
        if (type == null) // Host root, text node or just invalid type.
        return null;
        if (typeof type.tag === 'number') error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
        if (typeof type === 'function') return type.displayName || type.name || null;
        if (typeof type === 'string') return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return 'Fragment';
            case REACT_PORTAL_TYPE:
                return 'Portal';
            case REACT_PROFILER_TYPE:
                return 'Profiler';
            case REACT_STRICT_MODE_TYPE:
                return 'StrictMode';
            case REACT_SUSPENSE_TYPE:
                return 'Suspense';
            case REACT_SUSPENSE_LIST_TYPE:
                return 'SuspenseList';
        }
        if (typeof type === 'object') switch(type.$$typeof){
            case REACT_CONTEXT_TYPE:
                var context = type;
                return getContextName(context) + '.Consumer';
            case REACT_PROVIDER_TYPE:
                var provider = type;
                return getContextName(provider._context) + '.Provider';
            case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, 'ForwardRef');
            case REACT_MEMO_TYPE:
                var outerName = type.displayName || null;
                if (outerName !== null) return outerName;
                return getComponentNameFromType(type.type) || 'Memo';
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    return getComponentNameFromType(init(payload));
                } catch (x) {
                    return null;
                }
        }
        return null;
    }
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var RESERVED_PROPS = {
        key: true,
        ref: true,
        __self: true,
        __source: true
    };
    var specialPropKeyWarningShown, specialPropRefWarningShown, didWarnAboutStringRefs;
    didWarnAboutStringRefs = {};
    function hasValidRef(config) {
        if (hasOwnProperty.call(config, 'ref')) {
            var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.ref !== undefined;
    }
    function hasValidKey(config) {
        if (hasOwnProperty.call(config, 'key')) {
            var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.key !== undefined;
    }
    function defineKeyPropWarningGetter(props, displayName) {
        var warnAboutAccessingKey = function warnAboutAccessingKey() {
            if (!specialPropKeyWarningShown) {
                specialPropKeyWarningShown = true;
                error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingKey.isReactWarning = true;
        Object.defineProperty(props, 'key', {
            get: warnAboutAccessingKey,
            configurable: true
        });
    }
    function defineRefPropWarningGetter(props, displayName) {
        var warnAboutAccessingRef = function warnAboutAccessingRef() {
            if (!specialPropRefWarningShown) {
                specialPropRefWarningShown = true;
                error("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingRef.isReactWarning = true;
        Object.defineProperty(props, 'ref', {
            get: warnAboutAccessingRef,
            configurable: true
        });
    }
    function warnIfStringRefCannotBeAutoConverted(config) {
        if (typeof config.ref === 'string' && ReactCurrentOwner.current && config.__self && ReactCurrentOwner.current.stateNode !== config.__self) {
            var componentName = getComponentNameFromType(ReactCurrentOwner.current.type);
            if (!didWarnAboutStringRefs[componentName]) {
                error('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', componentName, config.ref);
                didWarnAboutStringRefs[componentName] = true;
            }
        }
    }
    /**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, instanceof check
 * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} props
 * @param {*} key
 * @param {string|object} ref
 * @param {*} owner
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @internal
 */ var ReactElement = function ReactElement(type, key, ref, self, source, owner, props) {
        var element = {
            // This tag allows us to uniquely identify this as a React Element
            $$typeof: REACT_ELEMENT_TYPE,
            // Built-in properties that belong on the element
            type: type,
            key: key,
            ref: ref,
            props: props,
            // Record the component responsible for creating this element.
            _owner: owner
        };
        // The validation flag is currently mutative. We put it on
        // an external backing store so that we can freeze the whole object.
        // This can be replaced with a WeakMap once they are implemented in
        // commonly used development environments.
        element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
        // the validation flag non-enumerable (where possible, which should
        // include every environment we run tests in), so the test framework
        // ignores it.
        Object.defineProperty(element._store, 'validated', {
            configurable: false,
            enumerable: false,
            writable: true,
            value: false
        }); // self and source are DEV only properties.
        Object.defineProperty(element, '_self', {
            configurable: false,
            enumerable: false,
            writable: false,
            value: self
        }); // Two elements created in two different places should be considered
        // equal for testing purposes and therefore we hide it from enumeration.
        Object.defineProperty(element, '_source', {
            configurable: false,
            enumerable: false,
            writable: false,
            value: source
        });
        if (Object.freeze) {
            Object.freeze(element.props);
            Object.freeze(element);
        }
        return element;
    };
    /**
 * Create and return a new ReactElement of the given type.
 * See https://reactjs.org/docs/react-api.html#createelement
 */ function createElement(type, config, children) {
        var propName; // Reserved names are extracted
        var props = {};
        var key = null;
        var ref = null;
        var self = null;
        var source = null;
        if (config != null) {
            if (hasValidRef(config)) {
                ref = config.ref;
                warnIfStringRefCannotBeAutoConverted(config);
            }
            if (hasValidKey(config)) {
                checkKeyStringCoercion(config.key);
                key = '' + config.key;
            }
            self = config.__self === undefined ? null : config.__self;
            source = config.__source === undefined ? null : config.__source; // Remaining properties are added to a new props object
            for(propName in config)if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) props[propName] = config[propName];
        } // Children can be more than one argument, and those are transferred onto
        // the newly allocated props object.
        var childrenLength = arguments.length - 2;
        if (childrenLength === 1) props.children = children;
        else if (childrenLength > 1) {
            var childArray = Array(childrenLength);
            for(var i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
            if (Object.freeze) Object.freeze(childArray);
            props.children = childArray;
        } // Resolve default props
        if (type && type.defaultProps) {
            var defaultProps = type.defaultProps;
            for(propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
        }
        if (key || ref) {
            var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
            if (key) defineKeyPropWarningGetter(props, displayName);
            if (ref) defineRefPropWarningGetter(props, displayName);
        }
        return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
    }
    function cloneAndReplaceKey(oldElement, newKey) {
        var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
        return newElement;
    }
    /**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://reactjs.org/docs/react-api.html#cloneelement
 */ function cloneElement(element, config, children) {
        if (element === null || element === undefined) throw new Error("React.cloneElement(...): The argument must be a React element, but you passed " + element + ".");
        var propName; // Original props are copied
        var props = assign({}, element.props); // Reserved names are extracted
        var key = element.key;
        var ref = element.ref; // Self is preserved since the owner is preserved.
        var self = element._self; // Source is preserved since cloneElement is unlikely to be targeted by a
        // transpiler, and the original source is probably a better indicator of the
        // true owner.
        var source = element._source; // Owner will be preserved, unless ref is overridden
        var owner = element._owner;
        if (config != null) {
            if (hasValidRef(config)) {
                // Silently steal the ref from the parent.
                ref = config.ref;
                owner = ReactCurrentOwner.current;
            }
            if (hasValidKey(config)) {
                checkKeyStringCoercion(config.key);
                key = '' + config.key;
            } // Remaining properties override existing props
            var defaultProps;
            if (element.type && element.type.defaultProps) defaultProps = element.type.defaultProps;
            for(propName in config)if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
                if (config[propName] === undefined && defaultProps !== undefined) // Resolve default props
                props[propName] = defaultProps[propName];
                else props[propName] = config[propName];
            }
        } // Children can be more than one argument, and those are transferred onto
        // the newly allocated props object.
        var childrenLength = arguments.length - 2;
        if (childrenLength === 1) props.children = children;
        else if (childrenLength > 1) {
            var childArray = Array(childrenLength);
            for(var i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
            props.children = childArray;
        }
        return ReactElement(element.type, key, ref, self, source, owner, props);
    }
    /**
 * Verifies the object is a ReactElement.
 * See https://reactjs.org/docs/react-api.html#isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a ReactElement.
 * @final
 */ function isValidElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    var SEPARATOR = '.';
    var SUBSEPARATOR = ':';
    /**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */ function escape(key) {
        var escapeRegex = /[=:]/g;
        var escaperLookup = {
            '=': '=0',
            ':': '=2'
        };
        var escapedString = key.replace(escapeRegex, function(match) {
            return escaperLookup[match];
        });
        return '$' + escapedString;
    }
    /**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */ var didWarnAboutMaps = false;
    var userProvidedKeyEscapeRegex = /\/+/g;
    function escapeUserProvidedKey(text) {
        return text.replace(userProvidedKeyEscapeRegex, '$&/');
    }
    /**
 * Generate a key string that identifies a element within a set.
 *
 * @param {*} element A element that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */ function getElementKey(element, index) {
        // Do some typechecking here since we call this blindly. We want to ensure
        // that we don't block potential future ES APIs.
        if (typeof element === 'object' && element !== null && element.key != null) {
            checkKeyStringCoercion(element.key);
            return escape('' + element.key);
        } // Implicit key determined by the index in the set
        return index.toString(36);
    }
    function mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
        var type = typeof children;
        if (type === 'undefined' || type === 'boolean') // All of the above are perceived as null.
        children = null;
        var invokeCallback = false;
        if (children === null) invokeCallback = true;
        else switch(type){
            case 'string':
            case 'number':
                invokeCallback = true;
                break;
            case 'object':
                switch(children.$$typeof){
                    case REACT_ELEMENT_TYPE:
                    case REACT_PORTAL_TYPE:
                        invokeCallback = true;
                }
        }
        if (invokeCallback) {
            var _child = children;
            var mappedChild = callback(_child); // If it's the only child, treat the name as if it was wrapped in an array
            // so that it's consistent if the number of children grows:
            var childKey = nameSoFar === '' ? SEPARATOR + getElementKey(_child, 0) : nameSoFar;
            if (isArray(mappedChild)) {
                var escapedChildKey = '';
                if (childKey != null) escapedChildKey = escapeUserProvidedKey(childKey) + '/';
                mapIntoArray(mappedChild, array, escapedChildKey, '', function(c) {
                    return c;
                });
            } else if (mappedChild != null) {
                if (isValidElement(mappedChild)) {
                    // The `if` statement here prevents auto-disabling of the safe
                    // coercion ESLint rule, so we must manually disable it below.
                    // $FlowFixMe Flow incorrectly thinks React.Portal doesn't have a key
                    if (mappedChild.key && (!_child || _child.key !== mappedChild.key)) checkKeyStringCoercion(mappedChild.key);
                    mappedChild = cloneAndReplaceKey(mappedChild, // traverseAllChildren used to do for objects as children
                    escapedPrefix + (mappedChild.key && (!_child || _child.key !== mappedChild.key) ? // eslint-disable-next-line react-internal/safe-string-coercion
                    escapeUserProvidedKey('' + mappedChild.key) + '/' : '') + childKey);
                }
                array.push(mappedChild);
            }
            return 1;
        }
        var child;
        var nextName;
        var subtreeCount = 0; // Count of children found in the current subtree.
        var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
        if (isArray(children)) for(var i = 0; i < children.length; i++){
            child = children[i];
            nextName = nextNamePrefix + getElementKey(child, i);
            subtreeCount += mapIntoArray(child, array, escapedPrefix, nextName, callback);
        }
        else {
            var iteratorFn = getIteratorFn(children);
            if (typeof iteratorFn === 'function') {
                var iterableChildren = children;
                // Warn about using Maps as children
                if (iteratorFn === iterableChildren.entries) {
                    if (!didWarnAboutMaps) warn("Using Maps as children is not supported. Use an array of keyed ReactElements instead.");
                    didWarnAboutMaps = true;
                }
                var iterator = iteratorFn.call(iterableChildren);
                var step;
                var ii = 0;
                while(!(step = iterator.next()).done){
                    child = step.value;
                    nextName = nextNamePrefix + getElementKey(child, ii++);
                    subtreeCount += mapIntoArray(child, array, escapedPrefix, nextName, callback);
                }
            } else if (type === 'object') {
                // eslint-disable-next-line react-internal/safe-string-coercion
                var childrenString = String(children);
                throw new Error("Objects are not valid as a React child (found: " + (childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString) + "). " + 'If you meant to render a collection of children, use an array ' + 'instead.');
            }
        }
        return subtreeCount;
    }
    /**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenmap
 *
 * The provided mapFunction(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */ function mapChildren(children, func, context) {
        if (children == null) return children;
        var result = [];
        var count = 0;
        mapIntoArray(children, result, '', '', function(child) {
            return func.call(context, child, count++);
        });
        return result;
    }
    /**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrencount
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */ function countChildren(children) {
        var n = 0;
        mapChildren(children, function() {
            n++; // Don't return anything
        });
        return n;
    }
    /**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenforeach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */ function forEachChildren(children, forEachFunc, forEachContext) {
        mapChildren(children, function() {
            forEachFunc.apply(this, arguments); // Don't return anything.
        }, forEachContext);
    }
    /**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrentoarray
 */ function toArray(children) {
        return mapChildren(children, function(child) {
            return child;
        }) || [];
    }
    /**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenonly
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */ function onlyChild(children) {
        if (!isValidElement(children)) throw new Error('React.Children.only expected to receive a single React element child.');
        return children;
    }
    function createContext(defaultValue) {
        // TODO: Second argument used to be an optional `calculateChangedBits`
        // function. Warn to reserve for future use?
        var context = {
            $$typeof: REACT_CONTEXT_TYPE,
            // As a workaround to support multiple concurrent renderers, we categorize
            // some renderers as primary and others as secondary. We only expect
            // there to be two concurrent renderers at most: React Native (primary) and
            // Fabric (secondary); React DOM (primary) and React ART (secondary).
            // Secondary renderers store their context values on separate fields.
            _currentValue: defaultValue,
            _currentValue2: defaultValue,
            // Used to track how many concurrent renderers this context currently
            // supports within in a single renderer. Such as parallel server rendering.
            _threadCount: 0,
            // These are circular
            Provider: null,
            Consumer: null,
            // Add these to use same hidden class in VM as ServerContext
            _defaultValue: null,
            _globalName: null
        };
        context.Provider = {
            $$typeof: REACT_PROVIDER_TYPE,
            _context: context
        };
        var hasWarnedAboutUsingNestedContextConsumers = false;
        var hasWarnedAboutUsingConsumerProvider = false;
        var hasWarnedAboutDisplayNameOnConsumer = false;
        // A separate object, but proxies back to the original context object for
        // backwards compatibility. It has a different $$typeof, so we can properly
        // warn for the incorrect usage of Context as a Consumer.
        var Consumer = {
            $$typeof: REACT_CONTEXT_TYPE,
            _context: context
        }; // $FlowFixMe: Flow complains about not setting a value, which is intentional here
        Object.defineProperties(Consumer, {
            Provider: {
                get: function get() {
                    if (!hasWarnedAboutUsingConsumerProvider) {
                        hasWarnedAboutUsingConsumerProvider = true;
                        error("Rendering <Context.Consumer.Provider> is not supported and will be removed in a future major release. Did you mean to render <Context.Provider> instead?");
                    }
                    return context.Provider;
                },
                set: function set(_Provider) {
                    context.Provider = _Provider;
                }
            },
            _currentValue: {
                get: function get() {
                    return context._currentValue;
                },
                set: function set(_currentValue) {
                    context._currentValue = _currentValue;
                }
            },
            _currentValue2: {
                get: function get() {
                    return context._currentValue2;
                },
                set: function set(_currentValue2) {
                    context._currentValue2 = _currentValue2;
                }
            },
            _threadCount: {
                get: function get() {
                    return context._threadCount;
                },
                set: function set(_threadCount) {
                    context._threadCount = _threadCount;
                }
            },
            Consumer: {
                get: function get() {
                    if (!hasWarnedAboutUsingNestedContextConsumers) {
                        hasWarnedAboutUsingNestedContextConsumers = true;
                        error("Rendering <Context.Consumer.Consumer> is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?");
                    }
                    return context.Consumer;
                }
            },
            displayName: {
                get: function get() {
                    return context.displayName;
                },
                set: function set(displayName) {
                    if (!hasWarnedAboutDisplayNameOnConsumer) {
                        warn("Setting `displayName` on Context.Consumer has no effect. You should set it directly on the context with Context.displayName = '%s'.", displayName);
                        hasWarnedAboutDisplayNameOnConsumer = true;
                    }
                }
            }
        }); // $FlowFixMe: Flow complains about missing properties because it doesn't understand defineProperty
        context.Consumer = Consumer;
        context._currentRenderer = null;
        context._currentRenderer2 = null;
        return context;
    }
    var Uninitialized = -1;
    var Pending = 0;
    var Resolved = 1;
    var Rejected = 2;
    function lazyInitializer(payload) {
        if (payload._status === Uninitialized) {
            var ctor = payload._result;
            var thenable = ctor(); // Transition to the next state.
            // This might throw either because it's missing or throws. If so, we treat it
            // as still uninitialized and try again next time. Which is the same as what
            // happens if the ctor or any wrappers processing the ctor throws. This might
            // end up fixing it if the resolution was a concurrency bug.
            thenable.then(function(moduleObject) {
                if (payload._status === Pending || payload._status === Uninitialized) {
                    // Transition to the next state.
                    var resolved = payload;
                    resolved._status = Resolved;
                    resolved._result = moduleObject;
                }
            }, function(error) {
                if (payload._status === Pending || payload._status === Uninitialized) {
                    // Transition to the next state.
                    var rejected = payload;
                    rejected._status = Rejected;
                    rejected._result = error;
                }
            });
            if (payload._status === Uninitialized) {
                // In case, we're still uninitialized, then we're waiting for the thenable
                // to resolve. Set it as pending in the meantime.
                var pending = payload;
                pending._status = Pending;
                pending._result = thenable;
            }
        }
        if (payload._status === Resolved) {
            var moduleObject = payload._result;
            if (moduleObject === undefined) error("lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))\n\nDid you accidentally put curly braces around the import?", moduleObject);
            if (!('default' in moduleObject)) error("lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))", moduleObject);
            return moduleObject.default;
        } else throw payload._result;
    }
    function lazy(ctor) {
        var payload = {
            // We use these fields to store the result.
            _status: Uninitialized,
            _result: ctor
        };
        var lazyType = {
            $$typeof: REACT_LAZY_TYPE,
            _payload: payload,
            _init: lazyInitializer
        };
        // In production, this would just set it on the object.
        var defaultProps;
        var propTypes; // $FlowFixMe
        Object.defineProperties(lazyType, {
            defaultProps: {
                configurable: true,
                get: function get() {
                    return defaultProps;
                },
                set: function set(newDefaultProps) {
                    error("React.lazy(...): It is not supported to assign `defaultProps` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it.");
                    defaultProps = newDefaultProps; // Match production behavior more closely:
                    // $FlowFixMe
                    Object.defineProperty(lazyType, 'defaultProps', {
                        enumerable: true
                    });
                }
            },
            propTypes: {
                configurable: true,
                get: function get() {
                    return propTypes;
                },
                set: function set(newPropTypes) {
                    error("React.lazy(...): It is not supported to assign `propTypes` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it.");
                    propTypes = newPropTypes; // Match production behavior more closely:
                    // $FlowFixMe
                    Object.defineProperty(lazyType, 'propTypes', {
                        enumerable: true
                    });
                }
            }
        });
        return lazyType;
    }
    function forwardRef(render) {
        if (render != null && render.$$typeof === REACT_MEMO_TYPE) error("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).");
        else if (typeof render !== 'function') error('forwardRef requires a render function but was given %s.', render === null ? 'null' : typeof render);
        else if (render.length !== 0 && render.length !== 2) error('forwardRef render functions accept exactly two parameters: props and ref. %s', render.length === 1 ? 'Did you forget to use the ref parameter?' : 'Any additional parameter will be undefined.');
        if (render != null) {
            if (render.defaultProps != null || render.propTypes != null) error("forwardRef render functions do not support propTypes or defaultProps. Did you accidentally pass a React component?");
        }
        var elementType = {
            $$typeof: REACT_FORWARD_REF_TYPE,
            render: render
        };
        var ownName;
        Object.defineProperty(elementType, 'displayName', {
            enumerable: false,
            configurable: true,
            get: function get() {
                return ownName;
            },
            set: function set(name) {
                ownName = name; // The inner component shouldn't inherit this display name in most cases,
                // because the component may be used elsewhere.
                // But it's nice for anonymous functions to inherit the name,
                // so that our component-stack generation logic will display their frames.
                // An anonymous function generally suggests a pattern like:
                //   React.forwardRef((props, ref) => {...});
                // This kind of inner function is not used elsewhere so the side effect is okay.
                if (!render.name && !render.displayName) render.displayName = name;
            }
        });
        return elementType;
    }
    var REACT_MODULE_REFERENCE;
    REACT_MODULE_REFERENCE = Symbol.for('react.module.reference');
    function isValidElementType(type) {
        if (typeof type === 'string' || typeof type === 'function') return true;
         // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).
        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) return true;
        if (typeof type === 'object' && type !== null) {
            if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
            // types supported by any Flight configuration anywhere since
            // we don't know which Flight build this will end up being used
            // with.
            type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) return true;
        }
        return false;
    }
    function memo(type, compare) {
        if (!isValidElementType(type)) error("memo: The first argument must be a component. Instead received: %s", type === null ? 'null' : typeof type);
        var elementType = {
            $$typeof: REACT_MEMO_TYPE,
            type: type,
            compare: compare === undefined ? null : compare
        };
        var ownName;
        Object.defineProperty(elementType, 'displayName', {
            enumerable: false,
            configurable: true,
            get: function get() {
                return ownName;
            },
            set: function set(name) {
                ownName = name; // The inner component shouldn't inherit this display name in most cases,
                // because the component may be used elsewhere.
                // But it's nice for anonymous functions to inherit the name,
                // so that our component-stack generation logic will display their frames.
                // An anonymous function generally suggests a pattern like:
                //   React.memo((props) => {...});
                // This kind of inner function is not used elsewhere so the side effect is okay.
                if (!type.name && !type.displayName) type.displayName = name;
            }
        });
        return elementType;
    }
    function resolveDispatcher() {
        var dispatcher = ReactCurrentDispatcher.current;
        if (dispatcher === null) error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.");
        // intentionally don't throw our own error because this is in a hot path.
        // Also helps ensure this is inlined.
        return dispatcher;
    }
    function useContext(Context) {
        var dispatcher = resolveDispatcher();
        // TODO: add a more generic warning for invalid values.
        if (Context._context !== undefined) {
            var realContext = Context._context; // Don't deduplicate because this legitimately causes bugs
            // and nobody should be using this in existing code.
            if (realContext.Consumer === Context) error("Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be removed in a future major release. Did you mean to call useContext(Context) instead?");
            else if (realContext.Provider === Context) error("Calling useContext(Context.Provider) is not supported. Did you mean to call useContext(Context) instead?");
        }
        return dispatcher.useContext(Context);
    }
    function useState(initialState) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useState(initialState);
    }
    function useReducer(reducer, initialArg, init) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useReducer(reducer, initialArg, init);
    }
    function useRef(initialValue) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useRef(initialValue);
    }
    function useEffect(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useEffect(create, deps);
    }
    function useInsertionEffect(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useInsertionEffect(create, deps);
    }
    function useLayoutEffect(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useLayoutEffect(create, deps);
    }
    function useCallback(callback, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useCallback(callback, deps);
    }
    function useMemo(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useMemo(create, deps);
    }
    function useImperativeHandle(ref, create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useImperativeHandle(ref, create, deps);
    }
    function useDebugValue(value, formatterFn) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useDebugValue(value, formatterFn);
    }
    function useTransition() {
        var dispatcher = resolveDispatcher();
        return dispatcher.useTransition();
    }
    function useDeferredValue(value) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useDeferredValue(value);
    }
    function useId() {
        var dispatcher = resolveDispatcher();
        return dispatcher.useId();
    }
    function useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    }
    // Helpers to patch console.logs to avoid logging during side-effect free
    // replaying on render function. This currently only patches the object
    // lazily which won't cover if the log function was extracted eagerly.
    // We could also eagerly patch the method.
    var disabledDepth = 0;
    var prevLog;
    var prevInfo;
    var prevWarn;
    var prevError;
    var prevGroup;
    var prevGroupCollapsed;
    var prevGroupEnd;
    function disabledLog() {}
    disabledLog.__reactDisabledLog = true;
    function disableLogs() {
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099
            var props = {
                configurable: true,
                enumerable: true,
                value: disabledLog,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
            });
        /* eslint-enable react-internal/no-production-logging */ }
        disabledDepth++;
    }
    function reenableLogs() {
        disabledDepth--;
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ var props = {
                configurable: true,
                enumerable: true,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                log: assign({}, props, {
                    value: prevLog
                }),
                info: assign({}, props, {
                    value: prevInfo
                }),
                warn: assign({}, props, {
                    value: prevWarn
                }),
                error: assign({}, props, {
                    value: prevError
                }),
                group: assign({}, props, {
                    value: prevGroup
                }),
                groupCollapsed: assign({}, props, {
                    value: prevGroupCollapsed
                }),
                groupEnd: assign({}, props, {
                    value: prevGroupEnd
                })
            });
        /* eslint-enable react-internal/no-production-logging */ }
        if (disabledDepth < 0) error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
    }
    var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher;
    var prefix;
    function describeBuiltInComponentFrame(name, source, ownerFn) {
        if (prefix === undefined) // Extract the VM specific prefix used by each line.
        try {
            throw Error();
        } catch (x) {
            var match = x.stack.trim().match(/\n( *(at )?)/);
            prefix = match && match[1] || '';
        }
         // We use the prefix to ensure our stacks line up with native stack frames.
        return '\n' + prefix + name;
    }
    var reentry = false;
    var componentFrameCache;
    var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
    componentFrameCache = new PossiblyWeakMap();
    function describeNativeComponentFrame(fn, construct) {
        // If something asked for a stack inside a fake render, it should get ignored.
        if (!fn || reentry) return '';
        var frame = componentFrameCache.get(fn);
        if (frame !== undefined) return frame;
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.
        Error.prepareStackTrace = undefined;
        var previousDispatcher;
        previousDispatcher = ReactCurrentDispatcher$1.current; // Set the dispatcher in DEV because this might be call in the render function
        // for warnings.
        ReactCurrentDispatcher$1.current = null;
        disableLogs();
        try {
            // This should throw.
            if (construct) {
                // Something should be setting the props in the constructor.
                var Fake = function Fake() {
                    throw Error();
                }; // $FlowFixMe
                Object.defineProperty(Fake.prototype, 'props', {
                    set: function set() {
                        // We use a throwing setter instead of frozen or non-writable props
                        // because that won't throw in a non-strict mode function.
                        throw Error();
                    }
                });
                if (typeof Reflect === 'object' && Reflect.construct) {
                    // We construct a different control for this case to include any extra
                    // frames added by the construct call.
                    try {
                        Reflect.construct(Fake, []);
                    } catch (x) {
                        control = x;
                    }
                    Reflect.construct(fn, [], Fake);
                } else {
                    try {
                        Fake.call();
                    } catch (x) {
                        control = x;
                    }
                    fn.call(Fake.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (x) {
                    control = x;
                }
                fn();
            }
        } catch (sample) {
            // This is inlined manually because closure doesn't do it for us.
            if (sample && control && typeof sample.stack === 'string') {
                // This extracts the first frame from the sample that isn't also in the control.
                // Skipping one frame that we assume is the frame that calls the two.
                var sampleLines = sample.stack.split('\n');
                var controlLines = control.stack.split('\n');
                var s = sampleLines.length - 1;
                var c = controlLines.length - 1;
                while(s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c])// We expect at least one stack frame to be shared.
                // Typically this will be the root most one. However, stack frames may be
                // cut off due to maximum stack limits. In this case, one maybe cut off
                // earlier than the other. We assume that the sample is longer or the same
                // and there for cut off earlier. So we should find the root most frame in
                // the sample somewhere in the control.
                c--;
                for(; s >= 1 && c >= 0; s--, c--)// Next we find the first one that isn't the same which should be the
                // frame that called our sample function and the control.
                if (sampleLines[s] !== controlLines[c]) {
                    // In V8, the first line is describing the message but other VMs don't.
                    // If we're about to return the first line, and the control is also on the same
                    // line, that's a pretty good indicator that our sample threw at same line as
                    // the control. I.e. before we entered the sample frame. So we ignore this result.
                    // This can happen if you passed a class to function component, or non-function.
                    if (s !== 1 || c !== 1) do {
                        s--;
                        c--; // We may still have similar intermediate frames from the construct call.
                        // The next one that isn't the same should be our match though.
                        if (c < 0 || sampleLines[s] !== controlLines[c]) {
                            // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                            var _frame = '\n' + sampleLines[s].replace(' at new ', ' at '); // If our component frame is labeled "<anonymous>"
                            // but we have a user-provided "displayName"
                            // splice it in to make the stack more readable.
                            if (fn.displayName && _frame.includes('<anonymous>')) _frame = _frame.replace('<anonymous>', fn.displayName);
                            if (typeof fn === 'function') componentFrameCache.set(fn, _frame);
                            return _frame;
                        }
                    }while (s >= 1 && c >= 0);
                    break;
                }
            }
        } finally{
            reentry = false;
            ReactCurrentDispatcher$1.current = previousDispatcher;
            reenableLogs();
            Error.prepareStackTrace = previousPrepareStackTrace;
        } // Fallback to just using the name if we couldn't make it throw.
        var name = fn ? fn.displayName || fn.name : '';
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : '';
        if (typeof fn === 'function') componentFrameCache.set(fn, syntheticFrame);
        return syntheticFrame;
    }
    function describeFunctionComponentFrame(fn, source, ownerFn) {
        return describeNativeComponentFrame(fn, false);
    }
    function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) return '';
        if (typeof type === 'function') return describeNativeComponentFrame(type, shouldConstruct(type));
        if (typeof type === 'string') return describeBuiltInComponentFrame(type);
        switch(type){
            case REACT_SUSPENSE_TYPE:
                return describeBuiltInComponentFrame('Suspense');
            case REACT_SUSPENSE_LIST_TYPE:
                return describeBuiltInComponentFrame('SuspenseList');
        }
        if (typeof type === 'object') switch(type.$$typeof){
            case REACT_FORWARD_REF_TYPE:
                return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
                // Memo may contain any component type so we recursively resolve it.
                return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    // Lazy may contain any component type so we recursively resolve it.
                    return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
        }
        return '';
    }
    var loggedTypeFailures = {};
    var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
    function checkPropTypes(typeSpecs, values, location, componentName, element) {
        // $FlowFixMe This is okay but Flow doesn't know it.
        var has = Function.call.bind(hasOwnProperty);
        for(var typeSpecName in typeSpecs)if (has(typeSpecs, typeSpecName)) {
            var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.
            try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                if (typeof typeSpecs[typeSpecName] !== 'function') {
                    // eslint-disable-next-line react-internal/prod-error-codes
                    var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
                    err.name = 'Invariant Violation';
                    throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
            } catch (ex) {
                error$1 = ex;
            }
            if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || 'React class', location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
            }
            if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error('Failed %s type: %s', location, error$1.message);
                setCurrentlyValidatingElement(null);
            }
        }
    }
    function setCurrentlyValidatingElement$1(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            setExtraStackFrame(stack);
        } else setExtraStackFrame(null);
    }
    var propTypesMisspellWarningShown;
    propTypesMisspellWarningShown = false;
    function getDeclarationErrorAddendum() {
        if (ReactCurrentOwner.current) {
            var name = getComponentNameFromType(ReactCurrentOwner.current.type);
            if (name) return '\n\nCheck the render method of `' + name + '`.';
        }
        return '';
    }
    function getSourceInfoErrorAddendum(source) {
        if (source !== undefined) {
            var fileName = source.fileName.replace(/^.*[\\\/]/, '');
            var lineNumber = source.lineNumber;
            return '\n\nCheck your code at ' + fileName + ':' + lineNumber + '.';
        }
        return '';
    }
    function getSourceInfoErrorAddendumForProps(elementProps) {
        if (elementProps !== null && elementProps !== undefined) return getSourceInfoErrorAddendum(elementProps.__source);
        return '';
    }
    /**
 * Warn if there's no key explicitly set on dynamic arrays of children or
 * object keys are not valid. This allows us to keep track of children between
 * updates.
 */ var ownerHasKeyUseWarning = {};
    function getCurrentComponentErrorInfo(parentType) {
        var info = getDeclarationErrorAddendum();
        if (!info) {
            var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;
            if (parentName) info = "\n\nCheck the top-level render call using <" + parentName + ">.";
        }
        return info;
    }
    /**
 * Warn if the element doesn't have an explicit key assigned to it.
 * This element is in an array. The array could grow and shrink or be
 * reordered. All children that haven't already been validated are required to
 * have a "key" property assigned to it. Error statuses are cached so a warning
 * will only be shown once.
 *
 * @internal
 * @param {ReactElement} element Element that requires a key.
 * @param {*} parentType element's parent's type.
 */ function validateExplicitKey(element, parentType) {
        if (!element._store || element._store.validated || element.key != null) return;
        element._store.validated = true;
        var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
        if (ownerHasKeyUseWarning[currentComponentErrorInfo]) return;
        ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
        // property, it may be the creator of the child that's responsible for
        // assigning it a key.
        var childOwner = '';
        if (element && element._owner && element._owner !== ReactCurrentOwner.current) // Give the component that originally created this child.
        childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
        setCurrentlyValidatingElement$1(element);
        error('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
        setCurrentlyValidatingElement$1(null);
    }
    /**
 * Ensure that every element either is passed in a static location, in an
 * array with an explicit keys property defined, or in an object literal
 * with valid key property.
 *
 * @internal
 * @param {ReactNode} node Statically passed child of any type.
 * @param {*} parentType node's parent's type.
 */ function validateChildKeys(node, parentType) {
        if (typeof node !== 'object') return;
        if (isArray(node)) for(var i = 0; i < node.length; i++){
            var child = node[i];
            if (isValidElement(child)) validateExplicitKey(child, parentType);
        }
        else if (isValidElement(node)) // This element was passed in a valid location.
        {
            if (node._store) node._store.validated = true;
        } else if (node) {
            var iteratorFn = getIteratorFn(node);
            if (typeof iteratorFn === 'function') // Entry iterators used to provide implicit keys,
            // but now we print a separate warning for them later.
            {
                if (iteratorFn !== node.entries) {
                    var iterator = iteratorFn.call(node);
                    var step;
                    while(!(step = iterator.next()).done)if (isValidElement(step.value)) validateExplicitKey(step.value, parentType);
                }
            }
        }
    }
    /**
 * Given an element, validate that its props follow the propTypes definition,
 * provided by the type.
 *
 * @param {ReactElement} element
 */ function validatePropTypes(element) {
        var type = element.type;
        if (type === null || type === undefined || typeof type === 'string') return;
        var propTypes;
        if (typeof type === 'function') propTypes = type.propTypes;
        else if (typeof type === 'object' && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        type.$$typeof === REACT_MEMO_TYPE)) propTypes = type.propTypes;
        else return;
        if (propTypes) {
            // Intentionally inside to avoid triggering lazy initializers:
            var name = getComponentNameFromType(type);
            checkPropTypes(propTypes, element.props, 'prop', name, element);
        } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
            propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:
            var _name = getComponentNameFromType(type);
            error('Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?', _name || 'Unknown');
        }
        if (typeof type.getDefaultProps === 'function' && !type.getDefaultProps.isReactClassApproved) error("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
    }
    /**
 * Given a fragment, validate that it can only be provided with fragment props
 * @param {ReactElement} fragment
 */ function validateFragmentProps(fragment) {
        var keys = Object.keys(fragment.props);
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            if (key !== 'children' && key !== 'key') {
                setCurrentlyValidatingElement$1(fragment);
                error("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", key);
                setCurrentlyValidatingElement$1(null);
                break;
            }
        }
        if (fragment.ref !== null) {
            setCurrentlyValidatingElement$1(fragment);
            error('Invalid attribute `ref` supplied to `React.Fragment`.');
            setCurrentlyValidatingElement$1(null);
        }
    }
    function createElementWithValidation(type, props, children) {
        var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
        // succeed and there will likely be errors in render.
        if (!validType) {
            var info = '';
            if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
            var sourceInfo = getSourceInfoErrorAddendumForProps(props);
            if (sourceInfo) info += sourceInfo;
            else info += getDeclarationErrorAddendum();
            var typeString;
            if (type === null) typeString = 'null';
            else if (isArray(type)) typeString = 'array';
            else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
                typeString = "<" + (getComponentNameFromType(type.type) || 'Unknown') + " />";
                info = ' Did you accidentally export a JSX literal instead of a component?';
            } else typeString = typeof type;
            error("React.createElement: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", typeString, info);
        }
        var element = createElement.apply(this, arguments); // The result can be nullish if a mock or a custom function is used.
        // TODO: Drop this when these are no longer allowed as the type argument.
        if (element == null) return element;
         // Skip key warning if the type isn't valid since our key validation logic
        // doesn't expect a non-string/function type and can throw confusing errors.
        // We don't want exception behavior to differ between dev and prod.
        // (Rendering will throw with a helpful message and as soon as the type is
        // fixed, the key warnings will appear.)
        if (validType) for(var i = 2; i < arguments.length; i++)validateChildKeys(arguments[i], type);
        if (type === REACT_FRAGMENT_TYPE) validateFragmentProps(element);
        else validatePropTypes(element);
        return element;
    }
    var didWarnAboutDeprecatedCreateFactory = false;
    function createFactoryWithValidation(type) {
        var validatedFactory = createElementWithValidation.bind(null, type);
        validatedFactory.type = type;
        if (!didWarnAboutDeprecatedCreateFactory) {
            didWarnAboutDeprecatedCreateFactory = true;
            warn("React.createFactory() is deprecated and will be removed in a future major release. Consider using JSX or use React.createElement() directly instead.");
        } // Legacy hook: remove it
        Object.defineProperty(validatedFactory, 'type', {
            enumerable: false,
            get: function get() {
                warn("Factory.type is deprecated. Access the class directly before passing it to createFactory.");
                Object.defineProperty(this, 'type', {
                    value: type
                });
                return type;
            }
        });
        return validatedFactory;
    }
    function cloneElementWithValidation(element, props, children) {
        var newElement = cloneElement.apply(this, arguments);
        for(var i = 2; i < arguments.length; i++)validateChildKeys(arguments[i], newElement.type);
        validatePropTypes(newElement);
        return newElement;
    }
    function startTransition(scope, options) {
        var prevTransition = ReactCurrentBatchConfig.transition;
        ReactCurrentBatchConfig.transition = {};
        var currentTransition = ReactCurrentBatchConfig.transition;
        ReactCurrentBatchConfig.transition._updatedFibers = new Set();
        try {
            scope();
        } finally{
            ReactCurrentBatchConfig.transition = prevTransition;
            if (prevTransition === null && currentTransition._updatedFibers) {
                var updatedFibersCount = currentTransition._updatedFibers.size;
                if (updatedFibersCount > 10) warn("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table.");
                currentTransition._updatedFibers.clear();
            }
        }
    }
    var didWarnAboutMessageChannel = false;
    var enqueueTaskImpl = null;
    function enqueueTask(task) {
        if (enqueueTaskImpl === null) try {
            // read require off the module object to get around the bundlers.
            // we don't want them to detect a require and bundle a Node polyfill.
            var requireString = ('require' + Math.random()).slice(0, 7);
            var nodeRequire = module && module[requireString]; // assuming we're in node, let's try to get node's
            // version of setImmediate, bypassing fake timers if any.
            enqueueTaskImpl = nodeRequire.call(module, 'timers').setImmediate;
        } catch (_err) {
            // we're in a browser
            // we can't use regular timers because they may still be faked
            // so we try MessageChannel+postMessage instead
            enqueueTaskImpl = function enqueueTaskImpl(callback) {
                if (didWarnAboutMessageChannel === false) {
                    didWarnAboutMessageChannel = true;
                    if (typeof MessageChannel === 'undefined') error("This browser does not have a MessageChannel implementation, so enqueuing tasks via await act(async () => ...) will fail. Please file an issue at https://github.com/facebook/react/issues if you encounter this warning.");
                }
                var channel = new MessageChannel();
                channel.port1.onmessage = callback;
                channel.port2.postMessage(undefined);
            };
        }
        return enqueueTaskImpl(task);
    }
    var actScopeDepth = 0;
    var didWarnNoAwaitAct = false;
    function act(callback) {
        // `act` calls can be nested, so we track the depth. This represents the
        // number of `act` scopes on the stack.
        var prevActScopeDepth = actScopeDepth;
        actScopeDepth++;
        if (ReactCurrentActQueue.current === null) // This is the outermost `act` scope. Initialize the queue. The reconciler
        // will detect the queue and use it instead of Scheduler.
        ReactCurrentActQueue.current = [];
        var prevIsBatchingLegacy = ReactCurrentActQueue.isBatchingLegacy;
        var result;
        try {
            // Used to reproduce behavior of `batchedUpdates` in legacy mode. Only
            // set to `true` while the given callback is executed, not for updates
            // triggered during an async event, because this is how the legacy
            // implementation of `act` behaved.
            ReactCurrentActQueue.isBatchingLegacy = true;
            result = callback(); // Replicate behavior of original `act` implementation in legacy mode,
            // which flushed updates immediately after the scope function exits, even
            // if it's an async function.
            if (!prevIsBatchingLegacy && ReactCurrentActQueue.didScheduleLegacyUpdate) {
                var queue = ReactCurrentActQueue.current;
                if (queue !== null) {
                    ReactCurrentActQueue.didScheduleLegacyUpdate = false;
                    flushActQueue(queue);
                }
            }
        } catch (error) {
            popActScope(prevActScopeDepth);
            throw error;
        } finally{
            ReactCurrentActQueue.isBatchingLegacy = prevIsBatchingLegacy;
        }
        if (result !== null && typeof result === 'object' && typeof result.then === 'function') {
            var thenableResult = result; // The callback is an async function (i.e. returned a promise). Wait
            // for it to resolve before exiting the current scope.
            var wasAwaited = false;
            var thenable = {
                then: function then(resolve, reject) {
                    wasAwaited = true;
                    thenableResult.then(function(returnValue) {
                        popActScope(prevActScopeDepth);
                        if (actScopeDepth === 0) // We've exited the outermost act scope. Recursively flush the
                        // queue until there's no remaining work.
                        recursivelyFlushAsyncActWork(returnValue, resolve, reject);
                        else resolve(returnValue);
                    }, function(error) {
                        // The callback threw an error.
                        popActScope(prevActScopeDepth);
                        reject(error);
                    });
                }
            };
            if (!didWarnNoAwaitAct && typeof Promise !== 'undefined') // eslint-disable-next-line no-undef
            Promise.resolve().then(function() {}).then(function() {
                if (!wasAwaited) {
                    didWarnNoAwaitAct = true;
                    error("You called act(async () => ...) without await. This could lead to unexpected testing behaviour, interleaving multiple act calls and mixing their scopes. You should - await act(async () => ...);");
                }
            });
            return thenable;
        } else {
            var returnValue = result; // The callback is not an async function. Exit the current scope
            // immediately, without awaiting.
            popActScope(prevActScopeDepth);
            if (actScopeDepth === 0) {
                // Exiting the outermost act scope. Flush the queue.
                var _queue = ReactCurrentActQueue.current;
                if (_queue !== null) {
                    flushActQueue(_queue);
                    ReactCurrentActQueue.current = null;
                } // Return a thenable. If the user awaits it, we'll flush again in
                // case additional work was scheduled by a microtask.
                var _thenable = {
                    then: function then(resolve, reject) {
                        // Confirm we haven't re-entered another `act` scope, in case
                        // the user does something weird like await the thenable
                        // multiple times.
                        if (ReactCurrentActQueue.current === null) {
                            // Recursively flush the queue until there's no remaining work.
                            ReactCurrentActQueue.current = [];
                            recursivelyFlushAsyncActWork(returnValue, resolve, reject);
                        } else resolve(returnValue);
                    }
                };
                return _thenable;
            } else {
                // Since we're inside a nested `act` scope, the returned thenable
                // immediately resolves. The outer scope will flush the queue.
                var _thenable2 = {
                    then: function then(resolve, reject) {
                        resolve(returnValue);
                    }
                };
                return _thenable2;
            }
        }
    }
    function popActScope(prevActScopeDepth) {
        if (prevActScopeDepth !== actScopeDepth - 1) error("You seem to have overlapping act() calls, this is not supported. Be sure to await previous act() calls before making a new one. ");
        actScopeDepth = prevActScopeDepth;
    }
    function recursivelyFlushAsyncActWork(returnValue, resolve, reject) {
        var queue = ReactCurrentActQueue.current;
        if (queue !== null) try {
            flushActQueue(queue);
            enqueueTask(function() {
                if (queue.length === 0) {
                    // No additional work was scheduled. Finish.
                    ReactCurrentActQueue.current = null;
                    resolve(returnValue);
                } else // Keep flushing work until there's none left.
                recursivelyFlushAsyncActWork(returnValue, resolve, reject);
            });
        } catch (error) {
            reject(error);
        }
        else resolve(returnValue);
    }
    var isFlushing = false;
    function flushActQueue(queue) {
        if (!isFlushing) {
            // Prevent re-entrance.
            isFlushing = true;
            var i = 0;
            try {
                for(; i < queue.length; i++){
                    var callback = queue[i];
                    do callback = callback(true);
                    while (callback !== null);
                }
                queue.length = 0;
            } catch (error) {
                // If something throws, leave the remaining callbacks on the queue.
                queue = queue.slice(i + 1);
                throw error;
            } finally{
                isFlushing = false;
            }
        }
    }
    var createElement$1 = createElementWithValidation;
    var cloneElement$1 = cloneElementWithValidation;
    var createFactory = createFactoryWithValidation;
    var Children = {
        map: mapChildren,
        forEach: forEachChildren,
        count: countChildren,
        toArray: toArray,
        only: onlyChild
    };
    exports.Children = Children;
    exports.Component = Component;
    exports.Fragment = REACT_FRAGMENT_TYPE;
    exports.Profiler = REACT_PROFILER_TYPE;
    exports.PureComponent = PureComponent;
    exports.StrictMode = REACT_STRICT_MODE_TYPE;
    exports.Suspense = REACT_SUSPENSE_TYPE;
    exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ReactSharedInternals;
    exports.act = act;
    exports.cloneElement = cloneElement$1;
    exports.createContext = createContext;
    exports.createElement = createElement$1;
    exports.createFactory = createFactory;
    exports.createRef = createRef;
    exports.forwardRef = forwardRef;
    exports.isValidElement = isValidElement;
    exports.lazy = lazy;
    exports.memo = memo;
    exports.startTransition = startTransition;
    exports.unstable_act = act;
    exports.useCallback = useCallback;
    exports.useContext = useContext;
    exports.useDebugValue = useDebugValue;
    exports.useDeferredValue = useDeferredValue;
    exports.useEffect = useEffect;
    exports.useId = useId;
    exports.useImperativeHandle = useImperativeHandle;
    exports.useInsertionEffect = useInsertionEffect;
    exports.useLayoutEffect = useLayoutEffect;
    exports.useMemo = useMemo;
    exports.useReducer = useReducer;
    exports.useRef = useRef;
    exports.useState = useState;
    exports.useSyncExternalStore = useSyncExternalStore;
    exports.useTransition = useTransition;
    exports.version = ReactVersion;
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === 'function') __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
})();

},{}],"bldky":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "reviewsPreviewHandlers", function() {
    return reviewsPreviewHandlers;
});
var _loadReviews = require("./useCases/loadReviews");
var _loadReviewsSaga = require("./sagas/loadReviewsSaga");
var _selectReviewTag = require("./useCases/selectReviewTag");
var _goToReviewsPage = require("./useCases/goToReviewsPage");
var _selectBreed = require("./useCases/selectBreed");
var _clearBreed = require("./useCases/clearBreed");
function reviewsPreviewHandlers(param) {
    var eventBus = param.eventBus, deps = param.deps;
    eventBus.subscribeToAll((0, _loadReviewsSaga.loadReviewsSaga)(deps));
    eventBus.subscribeTo((0, _loadReviews.LoadReviewsKey), (0, _loadReviews.loadReviews)(deps));
    eventBus.subscribeTo((0, _selectReviewTag.SelectReviewTagKey), (0, _selectReviewTag.selectReviewTag)(deps));
    eventBus.subscribeTo((0, _selectBreed.SelectBreedKey), (0, _selectBreed.selectBreed)(deps));
    eventBus.subscribeTo((0, _clearBreed.ClearBreedKey), (0, _clearBreed.clearBreed)(deps));
    eventBus.subscribeTo((0, _goToReviewsPage.GoToReviewsPageKey), (0, _goToReviewsPage.goToReviewsPage)(deps));
}

},{"./useCases/loadReviews":"fKFqv","./sagas/loadReviewsSaga":"2gdEM","./useCases/selectReviewTag":"korzW","./useCases/goToReviewsPage":"9IBl6","./useCases/selectBreed":"7xLoF","./useCases/clearBreed":"8rZwx","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"fKFqv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LoadReviewsKey", function() {
    return LoadReviewsKey;
});
parcelHelpers.export(exports, "LoadReviews", function() {
    return LoadReviews;
});
parcelHelpers.export(exports, "ReviewsLoadedKey", function() {
    return ReviewsLoadedKey;
});
parcelHelpers.export(exports, "ReviewsLoaded", function() {
    return ReviewsLoaded;
});
parcelHelpers.export(exports, "loadReviews", function() {
    return loadReviews;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _eventFactory = require("../../../script/src/std/eventFactory");
var _state = require("../state");
var LoadReviewsKey = 'ReviewsPreview.LoadReviews';
var LoadReviews = (0, _eventFactory.eventFactory)(LoadReviewsKey)();
var ReviewsLoadedKey = 'ReviewsPreview.ReviewsLoaded';
var ReviewsLoaded = (0, _eventFactory.eventFactory)(ReviewsLoadedKey)();
function loadReviews(deps) {
    return /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(event) {
            var state, data;
            return (0, _tsGenerator._)(this, function(_state1) {
                switch(_state1.label){
                    case 0:
                        state = deps.getState((0, _state.reviewsPreviewSelector));
                        return [
                            4,
                            deps.reviewsPreview.loadReviews({
                                page: state.page,
                                collection: state.collection,
                                tag: state.tag,
                                breedId: state.breedId
                            })
                        ];
                    case 1:
                        data = _state1.sent();
                        return [
                            4,
                            deps.publishEvent(ReviewsLoaded(data))
                        ];
                    case 2:
                        _state1.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }();
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_ts_generator":"f2hGH","../../../script/src/std/eventFactory":"f2PpV","../state":"kx1bN","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"kx1bN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "reviewsPreviewReducer", function() {
    return reviewsPreviewReducer;
});
parcelHelpers.export(exports, "reviewsPreviewSelector", function() {
    return reviewsPreviewSelector;
});
parcelHelpers.export(exports, "breedIdSelector", function() {
    return breedIdSelector;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _goToReviewsPage = require("./useCases/goToReviewsPage");
var _init = require("./useCases/init");
var _selectReviewTag = require("./useCases/selectReviewTag");
var _selectBreed = require("./useCases/selectBreed");
var _clearBreed = require("./useCases/clearBreed");
var initialState = {
    page: 1,
    collection: 'all',
    tag: 'all',
    breedId: null
};
function reviewsPreviewReducer() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, event = arguments.length > 1 ? arguments[1] : void 0;
    switch(event.type){
        case 0, _init.InitKey:
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                collection: event.payload.collection
            });
        case 0, _goToReviewsPage.GoToReviewsPageKey:
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                page: event.payload.page
            });
        case 0, _selectReviewTag.SelectReviewTagKey:
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                tag: event.payload.tag,
                page: 1
            });
        case 0, _selectBreed.SelectBreedKey:
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                breedId: event.payload.breedId,
                page: 1
            });
        case 0, _clearBreed.ClearBreedKey:
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                breedId: null,
                page: 1
            });
        default:
            return state;
    }
}
function reviewsPreviewSelector(state) {
    return state.sections.reviewsPreview;
}
function breedIdSelector(state) {
    return reviewsPreviewSelector(state).breedId;
}

},{"@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_object_spread_props":"fLCYP","./useCases/goToReviewsPage":"9IBl6","./useCases/init":"8guS5","./useCases/selectReviewTag":"korzW","./useCases/selectBreed":"7xLoF","./useCases/clearBreed":"8rZwx","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"9IBl6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GoToReviewsPageKey", function() {
    return GoToReviewsPageKey;
});
parcelHelpers.export(exports, "GoToReviewsPage", function() {
    return GoToReviewsPage;
});
parcelHelpers.export(exports, "goToReviewsPage", function() {
    return goToReviewsPage;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _eventFactory = require("../../../script/src/std/eventFactory");
var _state = require("../state");
var GoToReviewsPageKey = 'ReviewsPreview.GoToReviewsPage';
var GoToReviewsPage = (0, _eventFactory.eventFactory)(GoToReviewsPageKey)();
function goToReviewsPage(deps) {
    return /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(event) {
            var tag;
            return (0, _tsGenerator._)(this, function(_state1) {
                switch(_state1.label){
                    case 0:
                        tag = deps.getState((0, _state.reviewsPreviewSelector)).tag;
                        return [
                            4,
                            deps.track('GoToReviewsPage', {
                                page: event.payload.page,
                                tag: tag
                            })
                        ];
                    case 1:
                        _state1.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }();
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_ts_generator":"f2hGH","../../../script/src/std/eventFactory":"f2PpV","../state":"kx1bN","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8guS5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InitKey", function() {
    return InitKey;
});
parcelHelpers.export(exports, "Init", function() {
    return Init;
});
var _eventFactory = require("../../../script/src/std/eventFactory");
var InitKey = 'ReviewsPreview.Init';
var Init = (0, _eventFactory.eventFactory)(InitKey)();

},{"../../../script/src/std/eventFactory":"f2PpV","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"korzW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SelectReviewTagKey", function() {
    return SelectReviewTagKey;
});
parcelHelpers.export(exports, "SelectReviewTag", function() {
    return SelectReviewTag;
});
parcelHelpers.export(exports, "selectReviewTag", function() {
    return selectReviewTag;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _eventFactory = require("../../../script/src/std/eventFactory");
var SelectReviewTagKey = 'ReviewsPreview.SelectReviewTag';
var SelectReviewTag = (0, _eventFactory.eventFactory)(SelectReviewTagKey)();
function selectReviewTag(deps) {
    return /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(event) {
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            deps.track('SelectReviewTag', {
                                tag: event.payload.tag
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }();
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_ts_generator":"f2hGH","../../../script/src/std/eventFactory":"f2PpV","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7xLoF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SelectBreedKey", function() {
    return SelectBreedKey;
});
parcelHelpers.export(exports, "SelectBreed", function() {
    return SelectBreed;
});
parcelHelpers.export(exports, "selectBreed", function() {
    return selectBreed;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _eventFactory = require("../../../script/src/std/eventFactory");
var SelectBreedKey = 'ReviewsPreview.SelectBreed';
var SelectBreed = (0, _eventFactory.eventFactory)(SelectBreedKey)();
function selectBreed(deps) {
    return /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(event) {
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            deps.track('SelectReviewBreed', {
                                breed: event.payload.breedId
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }();
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_ts_generator":"f2hGH","../../../script/src/std/eventFactory":"f2PpV","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8rZwx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ClearBreedKey", function() {
    return ClearBreedKey;
});
parcelHelpers.export(exports, "ClearBreed", function() {
    return ClearBreed;
});
parcelHelpers.export(exports, "clearBreed", function() {
    return clearBreed;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _eventFactory = require("../../../script/src/std/eventFactory");
var ClearBreedKey = 'ReviewsPreview.ClearBreed';
var ClearBreed = (0, _eventFactory.eventFactory)(ClearBreedKey)();
function clearBreed(deps) {
    return /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(event) {
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            deps.track('ClearReviewBreed')
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }();
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_ts_generator":"f2hGH","../../../script/src/std/eventFactory":"f2PpV","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2gdEM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loadReviewsSaga", function() {
    return loadReviewsSaga;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _loadReviews = require("../useCases/loadReviews");
var _goToReviewsPage = require("../useCases/goToReviewsPage");
var _selectReviewTag = require("../useCases/selectReviewTag");
var _selectBreed = require("../useCases/selectBreed");
var _clearBreed = require("../useCases/clearBreed");
function loadReviewsSaga(deps) {
    return /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(event) {
            return (0, _tsGenerator._)(this, function(_state) {
                switch(event.type){
                    case 0, _goToReviewsPage.GoToReviewsPageKey:
                    case 0, _selectReviewTag.SelectReviewTagKey:
                    case 0, _selectBreed.SelectBreedKey:
                    case 0, _clearBreed.ClearBreedKey:
                        return [
                            2,
                            deps.publishEvent((0, _loadReviews.LoadReviews)())
                        ];
                }
                return [
                    2
                ];
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }();
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_ts_generator":"f2hGH","../useCases/loadReviews":"fKFqv","../useCases/goToReviewsPage":"9IBl6","../useCases/selectReviewTag":"korzW","../useCases/selectBreed":"7xLoF","../useCases/clearBreed":"8rZwx","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"c0qiU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Medias", function() {
    return Medias;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _domSection = require("../../script/src/dom/library/DomSection");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _domElement = require("../../script/src/dom/library/DomElement");
var _domArray = require("../../script/src/dom/library/DomArray");
var _domComponent = require("../../script/src/dom/library/DomComponent");
function Medias() {
    var _this = this;
    return (0, _domSection.DomSection)('sectionMedias', function() {
        return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(Section, {}, void 0, false, {
            fileName: "src/sections/medias/index.tsx",
            lineNumber: 8,
            columnNumber: 46
        }, _this);
    });
}
function Section() {
    var defaultSelected = (0, _domElement.useNullableAttributeValue)('data-selected', '&__container');
    var isWithQuotes = (0, _domElement.doesElementHasClass)('display-withQuotes', '&__container');
    var _useState = (0, _slicedToArray._)((0, _react.useState)(defaultSelected), 2), selected = _useState[0], setSelected = _useState[1];
    if (!isWithQuotes) return null;
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _jsxDevRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domArray.DomArray), {
                selector: "[data-id=logo]",
                discriminator: "data-key",
                child: function(param) {
                    var selector = param.selector, key = param.key;
                    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
                        selector: selector,
                        onClick: function() {
                            return setSelected(key);
                        },
                        data: {
                            selected: key === selected
                        }
                    }, key, false, {
                        fileName: "src/sections/medias/index.tsx",
                        lineNumber: 23,
                        columnNumber: 17
                    }, void 0);
                }
            }, void 0, false, {
                fileName: "src/sections/medias/index.tsx",
                lineNumber: 22,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domArray.DomArray), {
                selector: "[data-id=quote]",
                discriminator: "data-key",
                child: function(param) {
                    var selector = param.selector, key = param.key;
                    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
                        selector: selector,
                        data: {
                            hidden: key !== selected
                        }
                    }, key, false, {
                        fileName: "src/sections/medias/index.tsx",
                        lineNumber: 28,
                        columnNumber: 17
                    }, void 0);
                }
            }, void 0, false, {
                fileName: "src/sections/medias/index.tsx",
                lineNumber: 27,
                columnNumber: 13
            }, this)
        ]
    }, void 0, true);
}

},{"@swc/helpers/_/_sliced_to_array":"ha6sq","react/jsx-dev-runtime":"jXZ8I","../../script/src/dom/library/DomSection":"gcFCP","react":"c8CN1","../../script/src/dom/library/DomElement":"15N7Q","../../script/src/dom/library/DomArray":"ZEl1X","../../script/src/dom/library/DomComponent":"8H9za","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gcFCP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DomSection", function() {
    return DomSection;
});
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _domComponent = require("./DomComponent");
var _domArray = require("./DomArray");
function DomSection(sectionName, children) {
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domArray.DomArray), {
        selector: `.${sectionName}`,
        child: function(param) {
            var key = param.key, selector = param.selector;
            return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
                selector: selector,
                children: children()
            }, key, false, {
                fileName: "src/script/src/dom/library/DomSection.tsx",
                lineNumber: 8,
                columnNumber: 13
            }, void 0);
        }
    }, void 0, false, {
        fileName: "src/script/src/dom/library/DomSection.tsx",
        lineNumber: 7,
        columnNumber: 9
    }, this);
}

},{"react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","./DomComponent":"8H9za","./DomArray":"ZEl1X","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8H9za":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DomComponent", function() {
    return DomComponent;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _domElement = require("./DomElement");
function DomComponent(props) {
    var _useDomElement = (0, _domElement.useDomElement)(props.selector), elementSelector = _useDomElement.elementSelector, className = _useDomElement.className, element = _useDomElement.element;
    var _useState = (0, _slicedToArray._)((0, _react.useState)({}), 2), classes = _useState[0], setClasses = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)({}), 2), data = _useState1[0], setData = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)(), 2), innerHtml = _useState2[0], setInnerHtml = _useState2[1];
    if (!element) {
        if (!props.optional) setTimeout(function() {
            throw new Error(`element not found: ${elementSelector}`);
        }, 1);
        return null;
    }
    apply(element, props.classes, applyClasses(classes, setClasses));
    apply(element, props.data, applyData(data, setData));
    apply(element, props.onClick, applyOnClick);
    apply(element, props.onChange, applyOnChange);
    apply(element, props.selectedValue, applySelectedValue);
    apply(element, props.text, applyText);
    apply(element, props.innerHtml, applyInnerHtml);
    apply(element, props.href, applyHref);
    apply(element, props.checked, applyChecked);
    apply(element, props.style, applyStyle);
    if (!props.children) return null;
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domElement.DomElementContext).Provider, {
        value: elementSelector,
        children: props.children
    }, innerHtml, false, {
        fileName: "src/script/src/dom/library/DomComponent.tsx",
        lineNumber: 53,
        columnNumber: 9
    }, this);
    function apply(element, prop, callback) {
        (0, _react.useEffect)(function() {
            if (prop === undefined) return;
            return callback(element, prop);
        }, [
            element,
            prop
        ]);
    }
    function applyClasses(classes, setClasses) {
        return function(element, newClasses) {
            var hasChanged = false;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Object.keys(newClasses)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var key = _step.value;
                    if (newClasses[key] !== classes[key]) {
                        var classNameToManage = key.replace(/&/g, className);
                        newClasses[key] ? element.classList.add(classNameToManage) : element.classList.remove(classNameToManage);
                        hasChanged = true;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            if (hasChanged) setClasses(newClasses);
        };
    }
    function applyData(data, setData) {
        return function(element, newData) {
            var hasChanged = false;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Object.keys(newData)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var key = _step.value;
                    if (newData[key] !== data[key]) {
                        var attribute = `data-${key}`;
                        var newValue = newData[key];
                        newValue ? element.setAttribute(attribute, newValue === true ? '' : newValue) : element.removeAttribute(attribute);
                        hasChanged = true;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            if (hasChanged) setData(newData);
        };
    }
    function applyOnClick(element, onClick) {
        var isModifiedEvent = function(event) {
            return event.metaKey || event.altKey || event.ctrlKey || event.shiftKey;
        };
        var listener = function(event) {
            if (element.tagName === 'A' && event.button === 0 && // ignore everything but left clicks
            (element.target === "_blank" || // let browser handle "target=_blank" etc.
            isModifiedEvent(event) // ignore clicks with modifier keys
            )) return;
            onClick(event, element);
        };
        element.addEventListener('click', listener);
        return function() {
            return element.removeEventListener('click', listener);
        };
    }
    function applyOnChange(element, onChange) {
        var listener = function(event) {
            var _event_target;
            onChange((_event_target = event.target) === null || _event_target === void 0 ? void 0 : _event_target.value);
        };
        element.addEventListener('change', listener);
        return function() {
            return element.removeEventListener('change', listener);
        };
    }
    function applySelectedValue(element, value) {
        if (value) element.value = value.toString();
    }
    function applyText(element, text) {
        element.textContent = text.toString();
    }
    function applyInnerHtml(element, innerHtml) {
        element.innerHTML = innerHtml;
        setInnerHtml(innerHtml);
    }
    function applyHref(element, href) {
        if (href === null) {
            element.removeAttribute('href');
            return;
        }
        element.href = href;
    }
    function applyChecked(element, checked) {
        element.checked = checked;
    }
    function applyStyle(element, style) {
        element.setAttribute('style', style);
    }
}

},{"@swc/helpers/_/_sliced_to_array":"ha6sq","react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","./DomElement":"15N7Q","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"15N7Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DomElementContext", function() {
    return DomElementContext;
});
parcelHelpers.export(exports, "useDomElement", function() {
    return useDomElement;
});
parcelHelpers.export(exports, "useAttributeValue", function() {
    return useAttributeValue;
});
parcelHelpers.export(exports, "useNullableAttributeValue", function() {
    return useNullableAttributeValue;
});
parcelHelpers.export(exports, "useNumberAttributeValue", function() {
    return useNumberAttributeValue;
});
parcelHelpers.export(exports, "useJsonAttributeValue", function() {
    return useJsonAttributeValue;
});
parcelHelpers.export(exports, "useNullableNumberAttributeValue", function() {
    return useNullableNumberAttributeValue;
});
parcelHelpers.export(exports, "useBooleanAttributeValue", function() {
    return useBooleanAttributeValue;
});
parcelHelpers.export(exports, "useDomElementText", function() {
    return useDomElementText;
});
parcelHelpers.export(exports, "useSectionId", function() {
    return useSectionId;
});
parcelHelpers.export(exports, "doesElementHasClass", function() {
    return doesElementHasClass;
});
var _react = require("react");
var _std = require("@reglo/std");
var DomElementContext = /*#__PURE__*/ (0, _react.createContext)(null);
function useDomElement() {
    var selector = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : '', multiple = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var elementSelector = prepareSelector(selector);
    var className = extractClassName(elementSelector);
    if (!elementSelector) return {
        elementSelector: elementSelector,
        className: className,
        element: null
    };
    var elements = document.querySelectorAll(elementSelector);
    if (elements.length > 1 && !multiple) setTimeout(function() {
        throw new Error(`${elements.length} elements found for: ${elementSelector}`);
    }, 1);
    var _elements_;
    return {
        elementSelector: elementSelector,
        className: className,
        element: (_elements_ = elements[0]) !== null && _elements_ !== void 0 ? _elements_ : null
    };
}
function extractClassName(selector) {
    var _selector_match;
    var _selector_match_;
    return (_selector_match_ = (_selector_match = selector.match(/\.(\w+)(?!.*\.)/)) === null || _selector_match === void 0 ? void 0 : _selector_match[1]) !== null && _selector_match_ !== void 0 ? _selector_match_ : '';
}
function useAttributeValue(attributeName, selector) {
    var element = useDomElement(selector).element;
    return (0, _std.unwrap)(element === null || element === void 0 ? void 0 : element.getAttribute(attributeName));
}
function useNullableAttributeValue(attributeName, selector) {
    var element = useDomElement(selector).element;
    var _element_getAttribute;
    return (_element_getAttribute = element === null || element === void 0 ? void 0 : element.getAttribute(attributeName)) !== null && _element_getAttribute !== void 0 ? _element_getAttribute : null;
}
function useNumberAttributeValue(attributeName, selector) {
    var element = useDomElement(selector).element;
    var value = (0, _std.unwrap)(element === null || element === void 0 ? void 0 : element.getAttribute(attributeName));
    var number = Number(value);
    if (Number.isNaN(number)) throw new Error(`'${value} is not a number'`);
    return number;
}
function useJsonAttributeValue(attributeName, selector) {
    var element = useDomElement(selector).element;
    var value = (0, _std.unwrap)(element === null || element === void 0 ? void 0 : element.getAttribute(attributeName));
    return JSON.parse(value);
}
function useNullableNumberAttributeValue(attributeName, selector) {
    var element = useDomElement(selector).element;
    var value = (0, _std.unwrap)(element === null || element === void 0 ? void 0 : element.getAttribute(attributeName));
    var number = Number(value);
    if (Number.isNaN(number)) return null;
    return number;
}
function useBooleanAttributeValue(attributeName, selector) {
    var element = useDomElement(selector).element;
    var value = (0, _std.unwrap)(element).getAttribute(attributeName);
    return value === '' || value === 'true';
}
function useDomElementText(selector) {
    var element = (0, _std.unwrap)(useDomElement(selector).element);
    return element.innerText;
}
function useSectionId(selector) {
    var element = (0, _std.unwrap)(useDomElement(selector).element);
    var section = element.closest('[data-section_id]');
    var _section_getAttribute;
    return (_section_getAttribute = section === null || section === void 0 ? void 0 : section.getAttribute('data-section_id')) !== null && _section_getAttribute !== void 0 ? _section_getAttribute : null;
}
function doesElementHasClass(name, selector) {
    var element = useDomElement(selector).element;
    if (!element) return false;
    return element.className.split(' ').includes(name);
}
function prepareSelector(selector) {
    var _parentSelector_match;
    var parentSelector = (0, _react.useContext)(DomElementContext);
    if (parentSelector === null) return selector;
    var parentClass = (_parentSelector_match = parentSelector.match(/(\.\w+)(?!.*\.)/)) === null || _parentSelector_match === void 0 ? void 0 : _parentSelector_match[1];
    var preparedSelector = parentClass ? selector.replace(/&/g, parentClass) : selector;
    if (preparedSelector.match(/^#/)) return preparedSelector;
    return `${parentSelector} ${preparedSelector}`;
}

},{"react":"c8CN1","@reglo/std":"1USo0","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"ZEl1X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DomArray", function() {
    return DomArray;
});
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _std = require("@reglo/std");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _domElement = require("./DomElement");
function DomArray(props) {
    var elementSelector = (0, _domElement.useDomElement)(props.selector, true).elementSelector;
    var _props_discriminator;
    var discriminator = (_props_discriminator = props.discriminator) !== null && _props_discriminator !== void 0 ? _props_discriminator : 'data-array-id';
    function retrieveElementKeys() {
        var childrenElementList = document.querySelectorAll(`${elementSelector}`);
        return Array.from(childrenElementList).map(retrieveChildKey);
    }
    function retrieveChildKey(childElement) {
        if (!hasKey(childElement)) {
            var key = (0, _std.uuid)();
            childElement.setAttribute(discriminator, key);
            return key;
        }
        return childElement.getAttribute(discriminator);
    }
    function hasKey(childElement) {
        return !!childElement.getAttribute(discriminator);
    }
    function renderChild(key) {
        return props.child({
            key: key,
            selector: `${props.selector}[${discriminator}="${key}"]`
        });
    }
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _jsxDevRuntime.Fragment), {
        children: retrieveElementKeys().map(renderChild)
    }, void 0, false);
}

},{"react/jsx-dev-runtime":"jXZ8I","@reglo/std":"1USo0","react":"c8CN1","./DomElement":"15N7Q","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"e1D7H":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProductHero", function() {
    return ProductHero;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _domSection = require("../../../script/src/dom/library/DomSection");
var _domComponent = require("../../../script/src/dom/library/DomComponent");
var _domElement = require("../../../script/src/dom/library/DomElement");
var _domArray = require("../../../script/src/dom/library/DomArray");
var _std = require("@reglo/std");
var _pictures = require("./snippets/pictures");
function ProductHero() {
    var _this = this;
    return (0, _domSection.DomSection)('sectionProductHero', function() {
        return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(Section, {}, void 0, false, {
            fileName: "src/sections/productHero/liquid/index.tsx",
            lineNumber: 10,
            columnNumber: 51
        }, _this);
    });
}
function Section() {
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _jsxDevRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _pictures.Pictures), {}, void 0, false, {
                fileName: "src/sections/productHero/liquid/index.tsx",
                lineNumber: 16,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(Accordions, {}, void 0, false, {
                fileName: "src/sections/productHero/liquid/index.tsx",
                lineNumber: 17,
                columnNumber: 13
            }, this)
        ]
    }, void 0, true);
}
function Accordions() {
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domArray.DomArray), {
        selector: ".accordion",
        child: function(param) {
            var key = param.key, selector = param.selector;
            return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(Accordion, {
                selector: selector
            }, key, false, {
                fileName: "src/sections/productHero/liquid/index.tsx",
                lineNumber: 24,
                columnNumber: 71
            }, void 0);
        }
    }, void 0, false, {
        fileName: "src/sections/productHero/liquid/index.tsx",
        lineNumber: 24,
        columnNumber: 9
    }, this);
}
function Accordion(props) {
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), opened = _useState[0], setOpened = _useState[1];
    function toggle() {
        setOpened(!opened);
    }
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
        selector: props.selector,
        classes: {
            opened: opened
        },
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
                selector: ".title-container",
                onClick: toggle
            }, void 0, false, {
                fileName: "src/sections/productHero/liquid/index.tsx",
                lineNumber: 39,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
                selector: ".content-container",
                children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(AccordionContent, {
                    opened: opened
                }, void 0, false, {
                    fileName: "src/sections/productHero/liquid/index.tsx",
                    lineNumber: 41,
                    columnNumber: 17
                }, this)
            }, void 0, false, {
                fileName: "src/sections/productHero/liquid/index.tsx",
                lineNumber: 40,
                columnNumber: 13
            }, this)
        ]
    }, void 0, true, {
        fileName: "src/sections/productHero/liquid/index.tsx",
        lineNumber: 38,
        columnNumber: 9
    }, this);
}
function AccordionContent(props) {
    var element = (0, _std.unwrap)((0, _domElement.useDomElement)().element);
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), previouslyOpened = _useState[0], setPreviouslyOpened = _useState[1];
    (0, _react.useEffect)(function() {
        return props.opened ? openAccordion() : closeAccordion();
    }, [
        props.opened
    ]);
    return null;
    function closeAccordion() {
        if (previouslyOpened) element.style.height = `${element.scrollHeight}px`;
        setTimeout(function() {
            element.style.height = '0px';
        }, 1);
    }
    function openAccordion() {
        element.style.height = `${element.scrollHeight}px`;
        if (!previouslyOpened) setPreviouslyOpened(true);
        setTimeout(function() {
            element.style.height = '';
        }, 500);
    }
}

},{"@swc/helpers/_/_sliced_to_array":"ha6sq","react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","../../../script/src/dom/library/DomSection":"gcFCP","../../../script/src/dom/library/DomComponent":"8H9za","../../../script/src/dom/library/DomElement":"15N7Q","../../../script/src/dom/library/DomArray":"ZEl1X","@reglo/std":"1USo0","./snippets/pictures":"gBaPQ","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gBaPQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Pictures", function() {
    return Pictures;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _std = require("@reglo/std");
var _domElement = require("../../../../script/src/dom/library/DomElement");
var _useTrack = require("../../../../script/src/dom/hooks/useTrack");
var _react = require("react");
var _swiper = require("swiper");
var _swiperDefault = parcelHelpers.interopDefault(_swiper);
var _modules = require("swiper/modules");
function Pictures() {
    var picturesContainer = (0, _std.unwrap)((0, _domElement.useDomElement)('[data-id=pictures__container]').element);
    var thumbnailsContainer = (0, _std.unwrap)((0, _domElement.useDomElement)('[data-id=thumbnails__container]').element);
    var thumbnailsWrapper = (0, _std.unwrap)((0, _domElement.useDomElement)('[data-id=thumbnails__wrapper]').element);
    var track = (0, _useTrack.useTrack)();
    var picturesSlider = (0, _react.useMemo)(createPicturesSlider, []);
    var thumbnailSlider = (0, _react.useMemo)(createThumbnailSlider, []);
    var _useState = (0, _slicedToArray._)((0, _react.useState)(0), 2), selectedSlide = _useState[0], setSelectedSlide = _useState[1];
    (0, _react.useEffect)(initSlidders, []);
    (0, _react.useEffect)(function() {
        updateSelectedThumbnail();
        trackSlideView();
        startVideo();
    }, [
        selectedSlide
    ]);
    function createPicturesSlider() {
        return new (0, _swiperDefault.default)(picturesContainer, {
            modules: [
                (0, _modules.Navigation)
            ],
            loop: true,
            navigation: {
                prevEl: '[data-id=pictures__leftControl]',
                nextEl: '[data-id=pictures__rightControl]'
            }
        });
    }
    function createThumbnailSlider() {
        return new (0, _swiperDefault.default)(thumbnailsContainer, {
            slidesPerView: 'auto',
            spaceBetween: 10,
            loop: false
        });
    }
    function startVideo() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = Object.entries(picturesSlider.slides)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, _slicedToArray._)(_step.value, 2), index = _step_value[0], slide = _step_value[1];
                var video = slide.querySelector('video');
                if (Number(index) === selectedSlide) video === null || video === void 0 ? void 0 : video.play();
                else video === null || video === void 0 ? void 0 : video.pause();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    function initSlidders() {
        var lastClick = 0;
        thumbnailsContainer.setAttribute('data-isInitialized', '');
        picturesSlider.on('slideChangeTransitionEnd', function() {
            if (new Date().getTime() - lastClick < 1000) return;
            setSelectedSlide(picturesSlider.realIndex);
        });
        thumbnailSlider.on('click', function() {
            lastClick = new Date().getTime();
            var index = thumbnailSlider.clickedIndex;
            picturesSlider.slideToLoop(index);
            setSelectedSlide(index);
        });
    }
    function updateSelectedThumbnail() {
        thumbnailSlider.slideTo(selectedSlide === 0 ? 0 : selectedSlide - 1);
        for(var i = 0; i < thumbnailSlides().length; i++){
            thumbnailSlides()[i].removeAttribute('data-active');
            if (i === selectedSlide) thumbnailSlides()[i].setAttribute('data-active', '');
        }
    }
    function thumbnailSlides() {
        return (0, _toConsumableArray._)(thumbnailsWrapper.children).map(function(slide) {
            return slide;
        });
    }
    function trackSlideView() {
        track('SlideToProductPicture', {
            number: selectedSlide + 1
        });
    }
    return null;
}

},{"@swc/helpers/_/_sliced_to_array":"ha6sq","@swc/helpers/_/_to_consumable_array":"eqNDD","@reglo/std":"1USo0","../../../../script/src/dom/library/DomElement":"15N7Q","../../../../script/src/dom/hooks/useTrack":"iL2dq","react":"c8CN1","swiper":"8wPRQ","swiper/modules":"4UOSx","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"iL2dq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useTrack", function() {
    return useTrack;
});
var _react = require("react");
var _startDom = require("../../../startDom");
var _dontWaitFor = require("../../std/dontWaitFor");
function useTrack() {
    var deps = (0, _react.useContext)((0, _startDom.DomParamsContext)).deps;
    return function(name, properties) {
        (0, _dontWaitFor.dontWaitFor)(deps.track(name, properties));
    };
}

},{"react":"c8CN1","../../../startDom":"iwlTF","../../std/dontWaitFor":"hMCO5","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"iwlTF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "startDom", function() {
    return startDom;
});
parcelHelpers.export(exports, "DomParamsContext", function() {
    return DomParamsContext;
});
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _app = require("./src/app/App");
var _client = require("react-dom/client");
var _hooks = require("./src/std/hooks");
function startDom(params) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = (0, _app.apps)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var app = _step.value;
            initApp(params, app);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
var DomParamsContext = /*#__PURE__*/ (0, _reactDefault.default).createContext(undefined);
function initApp(params, app) {
    var Component = app.Component;
    var container = selectContainer(app);
    if (!container) return;
    var root = /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _reactDefault.default).StrictMode, {
        children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _reactRedux.Provider), {
            store: params.store,
            children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(DomParamsContext.Provider, {
                value: params,
                children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _hooks.MobileWindowPropertiesProvider), {
                    children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(Component, {}, void 0, false, {
                        fileName: "src/script/startDom.tsx",
                        lineNumber: 35,
                        columnNumber: 25
                    }, this)
                }, void 0, false, {
                    fileName: "src/script/startDom.tsx",
                    lineNumber: 34,
                    columnNumber: 21
                }, this)
            }, void 0, false, {
                fileName: "src/script/startDom.tsx",
                lineNumber: 33,
                columnNumber: 17
            }, this)
        }, void 0, false, {
            fileName: "src/script/startDom.tsx",
            lineNumber: 32,
            columnNumber: 13
        }, this)
    }, void 0, false, {
        fileName: "src/script/startDom.tsx",
        lineNumber: 31,
        columnNumber: 9
    }, this);
    (0, _client.createRoot)(container).render(root);
}
function selectContainer(app) {
    if (app.id) {
        var selector = `#${app.id}`;
        return document.querySelector(selector);
    }
    var container = document.createElement('div');
    document.body.appendChild(container);
    return container;
}

},{"react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","react-redux":"ghMZu","./src/app/App":"kmFyA","react-dom/client":"3HY3R","./src/std/hooks":"j9RPQ","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"ghMZu":[function(require,module,exports,__globalThis) {
// The primary entry point assumes we're working with standard ReactDOM/RN, but
// older versions that do not include `useSyncExternalStore` (React 16.9 - 17.x).
// Because of that, the useSyncExternalStore compat shim is needed.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "batch", function() {
    return 0, _reactBatchedUpdates.unstable_batchedUpdates;
});
var _shim = require("use-sync-external-store/shim");
var _withSelector = require("use-sync-external-store/shim/with-selector");
var _reactBatchedUpdates = require("./utils/reactBatchedUpdates");
var _batch = require("./utils/batch");
var _useSelector = require("./hooks/useSelector");
var _connect = require("./components/connect");
var _exports = require("./exports");
parcelHelpers.exportAll(_exports, exports);
(0, _useSelector.initializeUseSelector)((0, _withSelector.useSyncExternalStoreWithSelector));
(0, _connect.initializeConnect)((0, _shim.useSyncExternalStore)); // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)
(0, _batch.setBatch)((0, _reactBatchedUpdates.unstable_batchedUpdates));

},{"use-sync-external-store/shim":"4936x","use-sync-external-store/shim/with-selector":"eqxOY","./utils/reactBatchedUpdates":"jqxRX","./utils/batch":"jJell","./hooks/useSelector":"hKcoU","./components/connect":"61bh2","./exports":"40eKr","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4936x":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("5ab7799a565bbe74");

},{"5ab7799a565bbe74":"hr62a"}],"hr62a":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
(function() {
    function is(x, y) {
        return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
    }
    function useSyncExternalStore$2(subscribe, getSnapshot) {
        didWarnOld18Alpha || void 0 === React.startTransition || (didWarnOld18Alpha = !0, console.error("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
        var value = getSnapshot();
        if (!didWarnUncachedGetSnapshot) {
            var cachedValue = getSnapshot();
            objectIs(value, cachedValue) || (console.error("The result of getSnapshot should be cached to avoid an infinite loop"), didWarnUncachedGetSnapshot = !0);
        }
        cachedValue = useState({
            inst: {
                value: value,
                getSnapshot: getSnapshot
            }
        });
        var inst = cachedValue[0].inst, forceUpdate = cachedValue[1];
        useLayoutEffect(function() {
            inst.value = value;
            inst.getSnapshot = getSnapshot;
            checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        }, [
            subscribe,
            value,
            getSnapshot
        ]);
        useEffect(function() {
            checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
            return subscribe(function() {
                checkIfSnapshotChanged(inst) && forceUpdate({
                    inst: inst
                });
            });
        }, [
            subscribe
        ]);
        useDebugValue(value);
        return value;
    }
    function checkIfSnapshotChanged(inst) {
        var latestGetSnapshot = inst.getSnapshot;
        inst = inst.value;
        try {
            var nextValue = latestGetSnapshot();
            return !objectIs(inst, nextValue);
        } catch (error) {
            return !0;
        }
    }
    function useSyncExternalStore$1(subscribe, getSnapshot) {
        return getSnapshot();
    }
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var React = require("d49206e28a986e9f"), objectIs = "function" === typeof Object.is ? Object.is : is, useState = React.useState, useEffect = React.useEffect, useLayoutEffect = React.useLayoutEffect, useDebugValue = React.useDebugValue, didWarnOld18Alpha = !1, didWarnUncachedGetSnapshot = !1, shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? useSyncExternalStore$1 : useSyncExternalStore$2;
    exports.useSyncExternalStore = void 0 !== React.useSyncExternalStore ? React.useSyncExternalStore : shim;
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
})();

},{"d49206e28a986e9f":"c8CN1"}],"eqxOY":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("825b2585cf61f03e");

},{"825b2585cf61f03e":"dKc1a"}],"dKc1a":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
(function() {
    function is(x, y) {
        return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
    }
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var React = require("2f25dc3829c8e76e"), shim = require("c4afd16660885105"), objectIs = "function" === typeof Object.is ? Object.is : is, useSyncExternalStore = shim.useSyncExternalStore, useRef = React.useRef, useEffect = React.useEffect, useMemo = React.useMemo, useDebugValue = React.useDebugValue;
    exports.useSyncExternalStoreWithSelector = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
        var instRef = useRef(null);
        if (null === instRef.current) {
            var inst = {
                hasValue: !1,
                value: null
            };
            instRef.current = inst;
        } else inst = instRef.current;
        instRef = useMemo(function() {
            function memoizedSelector(nextSnapshot) {
                if (!hasMemo) {
                    hasMemo = !0;
                    memoizedSnapshot = nextSnapshot;
                    nextSnapshot = selector(nextSnapshot);
                    if (void 0 !== isEqual && inst.hasValue) {
                        var currentSelection = inst.value;
                        if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                    }
                    return memoizedSelection = nextSnapshot;
                }
                currentSelection = memoizedSelection;
                if (objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
                var nextSelection = selector(nextSnapshot);
                if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
                memoizedSnapshot = nextSnapshot;
                return memoizedSelection = nextSelection;
            }
            var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
            return [
                function() {
                    return memoizedSelector(getSnapshot());
                },
                null === maybeGetServerSnapshot ? void 0 : function() {
                    return memoizedSelector(maybeGetServerSnapshot());
                }
            ];
        }, [
            getSnapshot,
            getServerSnapshot,
            selector,
            isEqual
        ]);
        var value = useSyncExternalStore(subscribe, instRef[0], instRef[1]);
        useEffect(function() {
            inst.hasValue = !0;
            inst.value = value;
        }, [
            value
        ]);
        useDebugValue(value);
        return value;
    };
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
})();

},{"2f25dc3829c8e76e":"c8CN1","c4afd16660885105":"4936x"}],"jqxRX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unstable_batchedUpdates", function() {
    return 0, _reactDom.unstable_batchedUpdates;
});
var _reactDom = require("react-dom");

},{"react-dom":"kFYAC","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"kFYAC":[function(require,module,exports,__globalThis) {
'use strict';
function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    var err;
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
}
module.exports = require("b0f0e6b9e8349dac");

},{"b0f0e6b9e8349dac":"iBRwD"}],"iBRwD":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-dom.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
(function() {
    'use strict';
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === 'function') __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var React = require("6f0162e9ab224cd4");
    var Scheduler = require("8ad4ca65319d28a7");
    var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    var suppressWarning = false;
    function setSuppressWarning(newSuppressWarning) {
        suppressWarning = newSuppressWarning;
    } // In DEV, calls to console.warn and console.error get replaced
    // by calls to these methods by a Babel plugin.
    //
    // In PROD (or in packages without access to React internals),
    // they are left as they are instead.
    function warn(format) {
        if (!suppressWarning) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            printWarning('warn', format, args);
        }
    }
    function error(format) {
        if (!suppressWarning) {
            for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
            printWarning('error', format, args);
        }
    }
    function printWarning(level, format, args) {
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        var stack = ReactDebugCurrentFrame.getStackAddendum();
        if (stack !== '') {
            format += '%s';
            args = args.concat([
                stack
            ]);
        } // eslint-disable-next-line react-internal/safe-string-coercion
        var argsWithFormat = args.map(function(item) {
            return String(item);
        }); // Careful: RN currently depends on this prefix
        argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
        // breaks IE9: https://github.com/facebook/react/issues/13610
        // eslint-disable-next-line react-internal/no-production-logging
        Function.prototype.apply.call(console[level], console, argsWithFormat);
    }
    var FunctionComponent = 0;
    var ClassComponent = 1;
    var IndeterminateComponent = 2; // Before we know whether it is function or class
    var HostRoot = 3; // Root of a host tree. Could be nested inside another node.
    var HostPortal = 4; // A subtree. Could be an entry point to a different renderer.
    var HostComponent = 5;
    var HostText = 6;
    var Fragment = 7;
    var Mode = 8;
    var ContextConsumer = 9;
    var ContextProvider = 10;
    var ForwardRef = 11;
    var Profiler = 12;
    var SuspenseComponent = 13;
    var MemoComponent = 14;
    var SimpleMemoComponent = 15;
    var LazyComponent = 16;
    var IncompleteClassComponent = 17;
    var DehydratedFragment = 18;
    var SuspenseListComponent = 19;
    var ScopeComponent = 21;
    var OffscreenComponent = 22;
    var LegacyHiddenComponent = 23;
    var CacheComponent = 24;
    var TracingMarkerComponent = 25;
    // -----------------------------------------------------------------------------
    var enableClientRenderFallbackOnTextMismatch = true; // TODO: Need to review this code one more time before landing
    // the react-reconciler package.
    var enableNewReconciler = false; // Support legacy Primer support on internal FB www
    var enableLazyContextPropagation = false; // FB-only usage. The new API has different semantics.
    var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
    var enableSuspenseAvoidThisFallback = false; // Enables unstable_avoidThisFallback feature in Fizz
    // React DOM Chopping Block
    //
    // Similar to main Chopping Block but only flags related to React DOM. These are
    // grouped because we will likely batch all of them into a single major release.
    // -----------------------------------------------------------------------------
    // Disable support for comment nodes as React DOM containers. Already disabled
    // in open source, but www codebase still relies on it. Need to remove.
    var disableCommentsAsDOMContainers = true; // Disable javascript: URL strings in href for XSS protection.
    // and client rendering, mostly to allow JSX attributes to apply to the custom
    // element's object properties instead of only HTML attributes.
    // https://github.com/facebook/react/issues/11347
    var enableCustomElementPropertySupport = false; // Disables children for <textarea> elements
    var warnAboutStringRefs = true; // -----------------------------------------------------------------------------
    // Debugging and DevTools
    // -----------------------------------------------------------------------------
    // Adds user timing marks for e.g. state updates, suspense, and work loop stuff,
    // for an experimental timeline tool.
    var enableSchedulingProfiler = true; // Helps identify side effects in render-phase lifecycle hooks and setState
    var enableProfilerTimer = true; // Record durations for commit and passive effects phases.
    var enableProfilerCommitHooks = true; // Phase param passed to onRender callback differentiates between an "update" and a "cascading-update".
    var allNativeEvents = new Set();
    /**
 * Mapping from registration name to event name
 */ var registrationNameDependencies = {};
    /**
 * Mapping from lowercase registration names to the properly cased version,
 * used to warn in the case of missing event handlers. Available
 * only in true.
 * @type {Object}
 */ var possibleRegistrationNames = {}; // Trust the developer to only use possibleRegistrationNames in true
    function registerTwoPhaseEvent(registrationName, dependencies) {
        registerDirectEvent(registrationName, dependencies);
        registerDirectEvent(registrationName + 'Capture', dependencies);
    }
    function registerDirectEvent(registrationName, dependencies) {
        if (registrationNameDependencies[registrationName]) error("EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.", registrationName);
        registrationNameDependencies[registrationName] = dependencies;
        var lowerCasedName = registrationName.toLowerCase();
        possibleRegistrationNames[lowerCasedName] = registrationName;
        if (registrationName === 'onDoubleClick') possibleRegistrationNames.ondblclick = registrationName;
        for(var i = 0; i < dependencies.length; i++)allNativeEvents.add(dependencies[i]);
    }
    var canUseDOM = !!(typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined');
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    /*
 * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
 * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
 *
 * The functions in this module will throw an easier-to-understand,
 * easier-to-debug exception with a clear errors message message explaining the
 * problem. (Instead of a confusing exception thrown inside the implementation
 * of the `value` object).
 */ // $FlowFixMe only called in DEV, so void return is not possible.
    function typeName(value) {
        // toStringTag is needed for namespaced types like Temporal.Instant
        var hasToStringTag = typeof Symbol === 'function' && Symbol.toStringTag;
        var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || 'Object';
        return type;
    } // $FlowFixMe only called in DEV, so void return is not possible.
    function willCoercionThrow(value) {
        try {
            testStringCoercion(value);
            return false;
        } catch (e) {
            return true;
        }
    }
    function testStringCoercion(value) {
        // If you ended up here by following an exception call stack, here's what's
        // happened: you supplied an object or symbol value to React (as a prop, key,
        // DOM attribute, CSS property, string ref, etc.) and when React tried to
        // coerce it to a string using `'' + value`, an exception was thrown.
        //
        // The most common types that will cause this exception are `Symbol` instances
        // and Temporal objects like `Temporal.Instant`. But any object that has a
        // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
        // exception. (Library authors do this to prevent users from using built-in
        // numeric operators like `+` or comparison operators like `>=` because custom
        // methods are needed to perform accurate arithmetic or comparison.)
        //
        // To fix the problem, coerce this object or symbol value to a string before
        // passing it to React. The most reliable way is usually `String(value)`.
        //
        // To find which value is throwing, check the browser or debugger console.
        // Before this exception was thrown, there should be `console.error` output
        // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
        // problem and how that type was used: key, atrribute, input value prop, etc.
        // In most cases, this console output also shows the component and its
        // ancestor components where the exception happened.
        //
        // eslint-disable-next-line react-internal/safe-string-coercion
        return '' + value;
    }
    function checkAttributeStringCoercion(value, attributeName) {
        if (willCoercionThrow(value)) {
            error("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", attributeName, typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkKeyStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkPropStringCoercion(value, propName) {
        if (willCoercionThrow(value)) {
            error("The provided `%s` prop is an unsupported type %s. This value must be coerced to a string before before using it here.", propName, typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkCSSPropertyStringCoercion(value, propName) {
        if (willCoercionThrow(value)) {
            error("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", propName, typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkHtmlStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkFormFieldValueStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    // A reserved attribute.
    // It is handled by React separately and shouldn't be written to the DOM.
    var RESERVED = 0; // A simple string attribute.
    // Attributes that aren't in the filter are presumed to have this type.
    var STRING = 1; // A string attribute that accepts booleans in React. In HTML, these are called
    // "enumerated" attributes with "true" and "false" as possible values.
    // When true, it should be set to a "true" string.
    // When false, it should be set to a "false" string.
    var BOOLEANISH_STRING = 2; // A real boolean attribute.
    // When true, it should be present (set either to an empty string or its name).
    // When false, it should be omitted.
    var BOOLEAN = 3; // An attribute that can be used as a flag as well as with a value.
    // When true, it should be present (set either to an empty string or its name).
    // When false, it should be omitted.
    // For any other value, should be present with that value.
    var OVERLOADED_BOOLEAN = 4; // An attribute that must be numeric or parse as a numeric.
    // When falsy, it should be removed.
    var NUMERIC = 5; // An attribute that must be positive numeric or parse as a positive numeric.
    // When falsy, it should be removed.
    var POSITIVE_NUMERIC = 6;
    /* eslint-disable max-len */ var ATTRIBUTE_NAME_START_CHAR = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
    /* eslint-enable max-len */ var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
    var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + ATTRIBUTE_NAME_START_CHAR + '][' + ATTRIBUTE_NAME_CHAR + ']*$');
    var illegalAttributeNameCache = {};
    var validatedAttributeNameCache = {};
    function isAttributeNameSafe(attributeName) {
        if (hasOwnProperty.call(validatedAttributeNameCache, attributeName)) return true;
        if (hasOwnProperty.call(illegalAttributeNameCache, attributeName)) return false;
        if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
            validatedAttributeNameCache[attributeName] = true;
            return true;
        }
        illegalAttributeNameCache[attributeName] = true;
        error('Invalid attribute name: `%s`', attributeName);
        return false;
    }
    function shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag) {
        if (propertyInfo !== null) return propertyInfo.type === RESERVED;
        if (isCustomComponentTag) return false;
        if (name.length > 2 && (name[0] === 'o' || name[0] === 'O') && (name[1] === 'n' || name[1] === 'N')) return true;
        return false;
    }
    function shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag) {
        if (propertyInfo !== null && propertyInfo.type === RESERVED) return false;
        switch(typeof value){
            case 'function':
            case 'symbol':
                // eslint-disable-line
                return true;
            case 'boolean':
                if (isCustomComponentTag) return false;
                if (propertyInfo !== null) return !propertyInfo.acceptsBooleans;
                else {
                    var prefix = name.toLowerCase().slice(0, 5);
                    return prefix !== 'data-' && prefix !== 'aria-';
                }
            default:
                return false;
        }
    }
    function shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag) {
        if (value === null || typeof value === 'undefined') return true;
        if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag)) return true;
        if (isCustomComponentTag) return false;
        if (propertyInfo !== null) switch(propertyInfo.type){
            case BOOLEAN:
                return !value;
            case OVERLOADED_BOOLEAN:
                return value === false;
            case NUMERIC:
                return isNaN(value);
            case POSITIVE_NUMERIC:
                return isNaN(value) || value < 1;
        }
        return false;
    }
    function getPropertyInfo(name) {
        return properties.hasOwnProperty(name) ? properties[name] : null;
    }
    function PropertyInfoRecord(name, type, mustUseProperty, attributeName, attributeNamespace, sanitizeURL, removeEmptyString) {
        this.acceptsBooleans = type === BOOLEANISH_STRING || type === BOOLEAN || type === OVERLOADED_BOOLEAN;
        this.attributeName = attributeName;
        this.attributeNamespace = attributeNamespace;
        this.mustUseProperty = mustUseProperty;
        this.propertyName = name;
        this.type = type;
        this.sanitizeURL = sanitizeURL;
        this.removeEmptyString = removeEmptyString;
    } // When adding attributes to this list, be sure to also add them to
    // the `possibleStandardNames` module to ensure casing and incorrect
    // name warnings.
    var properties = {}; // These props are reserved by React. They shouldn't be written to the DOM.
    var reservedProps = [
        'children',
        'dangerouslySetInnerHTML',
        // elements (not just inputs). Now that ReactDOMInput assigns to the
        // defaultValue property -- do we need this?
        'defaultValue',
        'defaultChecked',
        'innerHTML',
        'suppressContentEditableWarning',
        'suppressHydrationWarning',
        'style'
    ];
    reservedProps.forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, RESERVED, false, name, null, false, false);
    }); // A few React string attributes have a different name.
    // This is a mapping from React prop names to the attribute names.
    [
        [
            'acceptCharset',
            'accept-charset'
        ],
        [
            'className',
            'class'
        ],
        [
            'htmlFor',
            'for'
        ],
        [
            'httpEquiv',
            'http-equiv'
        ]
    ].forEach(function(_ref) {
        var name = _ref[0], attributeName = _ref[1];
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, null, false, false);
    }); // These are "enumerated" HTML attributes that accept "true" and "false".
    // In React, we let users pass `true` and `false` even though technically
    // these aren't boolean attributes (they are coerced to strings).
    [
        'contentEditable',
        'draggable',
        'spellCheck',
        'value'
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, name.toLowerCase(), null, false, false);
    }); // These are "enumerated" SVG attributes that accept "true" and "false".
    // In React, we let users pass `true` and `false` even though technically
    // these aren't boolean attributes (they are coerced to strings).
    // Since these are SVG attributes, their attribute names are case-sensitive.
    [
        'autoReverse',
        'externalResourcesRequired',
        'focusable',
        'preserveAlpha'
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, name, null, false, false);
    }); // These are HTML boolean attributes.
    [
        'allowFullScreen',
        'async',
        // on the client side because the browsers are inconsistent. Instead we call focus().
        'autoFocus',
        'autoPlay',
        'controls',
        'default',
        'defer',
        'disabled',
        'disablePictureInPicture',
        'disableRemotePlayback',
        'formNoValidate',
        'hidden',
        'loop',
        'noModule',
        'noValidate',
        'open',
        'playsInline',
        'readOnly',
        'required',
        'reversed',
        'scoped',
        'seamless',
        'itemScope'
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEAN, false, name.toLowerCase(), null, false, false);
    }); // These are the few React props that we set as DOM properties
    // rather than attributes. These are all booleans.
    [
        'checked',
        // disabled with `removeAttribute`. We have special logic for handling this.
        'multiple',
        'muted',
        'selected' // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEAN, true, name, null, false, false);
    }); // These are HTML attributes that are "overloaded booleans": they behave like
    // booleans, but can also accept a string value.
    [
        'capture',
        'download' // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, OVERLOADED_BOOLEAN, false, name, null, false, false);
    }); // These are HTML attributes that must be positive numbers.
    [
        'cols',
        'rows',
        'size',
        'span' // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, POSITIVE_NUMERIC, false, name, null, false, false);
    }); // These are HTML attributes that must be numbers.
    [
        'rowSpan',
        'start'
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, NUMERIC, false, name.toLowerCase(), null, false, false);
    });
    var CAMELIZE = /[\-\:]([a-z])/g;
    var capitalize = function capitalize(token) {
        return token[1].toUpperCase();
    }; // This is a list of all SVG attributes that need special casing, namespacing,
    // or boolean value assignment. Regular attributes that just accept strings
    // and have the same names are omitted, just like in the HTML attribute filter.
    // Some of these attributes can be hard to find. This list was created by
    // scraping the MDN documentation.
    [
        'accent-height',
        'alignment-baseline',
        'arabic-form',
        'baseline-shift',
        'cap-height',
        'clip-path',
        'clip-rule',
        'color-interpolation',
        'color-interpolation-filters',
        'color-profile',
        'color-rendering',
        'dominant-baseline',
        'enable-background',
        'fill-opacity',
        'fill-rule',
        'flood-color',
        'flood-opacity',
        'font-family',
        'font-size',
        'font-size-adjust',
        'font-stretch',
        'font-style',
        'font-variant',
        'font-weight',
        'glyph-name',
        'glyph-orientation-horizontal',
        'glyph-orientation-vertical',
        'horiz-adv-x',
        'horiz-origin-x',
        'image-rendering',
        'letter-spacing',
        'lighting-color',
        'marker-end',
        'marker-mid',
        'marker-start',
        'overline-position',
        'overline-thickness',
        'paint-order',
        'panose-1',
        'pointer-events',
        'rendering-intent',
        'shape-rendering',
        'stop-color',
        'stop-opacity',
        'strikethrough-position',
        'strikethrough-thickness',
        'stroke-dasharray',
        'stroke-dashoffset',
        'stroke-linecap',
        'stroke-linejoin',
        'stroke-miterlimit',
        'stroke-opacity',
        'stroke-width',
        'text-anchor',
        'text-decoration',
        'text-rendering',
        'underline-position',
        'underline-thickness',
        'unicode-bidi',
        'unicode-range',
        'units-per-em',
        'v-alphabetic',
        'v-hanging',
        'v-ideographic',
        'v-mathematical',
        'vector-effect',
        'vert-adv-y',
        'vert-origin-x',
        'vert-origin-y',
        'word-spacing',
        'writing-mode',
        'xmlns:xlink',
        'x-height' // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, null, false, false);
    }); // String SVG attributes with the xlink namespace.
    [
        'xlink:actuate',
        'xlink:arcrole',
        'xlink:role',
        'xlink:show',
        'xlink:title',
        'xlink:type' // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, 'http://www.w3.org/1999/xlink', false, false);
    }); // String SVG attributes with the xml namespace.
    [
        'xml:base',
        'xml:lang',
        'xml:space' // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, 'http://www.w3.org/XML/1998/namespace', false, false);
    }); // These attribute exists both in HTML and SVG.
    // The attribute name is case-sensitive in SVG so we can't just use
    // the React name like we do for attributes that exist only in HTML.
    [
        'tabIndex',
        'crossOrigin'
    ].forEach(function(attributeName) {
        properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, attributeName.toLowerCase(), null, false, false);
    }); // These attributes accept URLs. These must not allow javascript: URLS.
    // These will also need to accept Trusted Types object in the future.
    var xlinkHref = 'xlinkHref';
    properties[xlinkHref] = new PropertyInfoRecord('xlinkHref', STRING, false, 'xlink:href', 'http://www.w3.org/1999/xlink', true, false);
    [
        'src',
        'href',
        'action',
        'formAction'
    ].forEach(function(attributeName) {
        properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, attributeName.toLowerCase(), null, true, true);
    });
    // and any newline or tab are filtered out as if they're not part of the URL.
    // https://url.spec.whatwg.org/#url-parsing
    // Tab or newline are defined as \r\n\t:
    // https://infra.spec.whatwg.org/#ascii-tab-or-newline
    // A C0 control is a code point in the range \u0000 NULL to \u001F
    // INFORMATION SEPARATOR ONE, inclusive:
    // https://infra.spec.whatwg.org/#c0-control-or-space
    /* eslint-disable max-len */ var isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i;
    var didWarn = false;
    function sanitizeURL(url) {
        if (!didWarn && isJavaScriptProtocol.test(url)) {
            didWarn = true;
            error("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(url));
        }
    }
    /**
 * Get the value for a property on a node. Only used in DEV for SSR validation.
 * The "expected" argument is used as a hint of what the expected value is.
 * Some properties have multiple equivalent values.
 */ function getValueForProperty(node, name, expected, propertyInfo) {
        if (propertyInfo.mustUseProperty) {
            var propertyName = propertyInfo.propertyName;
            return node[propertyName];
        } else {
            checkAttributeStringCoercion(expected, name);
            if (propertyInfo.sanitizeURL) // If we haven't fully disabled javascript: URLs, and if
            // the hydration is successful of a javascript: URL, we
            // still want to warn on the client.
            // eslint-disable-next-line react-internal/safe-string-coercion
            sanitizeURL('' + expected);
            var attributeName = propertyInfo.attributeName;
            var stringValue = null;
            if (propertyInfo.type === OVERLOADED_BOOLEAN) {
                if (node.hasAttribute(attributeName)) {
                    var value = node.getAttribute(attributeName);
                    if (value === '') return true;
                    if (shouldRemoveAttribute(name, expected, propertyInfo, false)) return value;
                     // eslint-disable-next-line react-internal/safe-string-coercion
                    if (value === '' + expected) return expected;
                    return value;
                }
            } else if (node.hasAttribute(attributeName)) {
                if (shouldRemoveAttribute(name, expected, propertyInfo, false)) // We had an attribute but shouldn't have had one, so read it
                // for the error message.
                return node.getAttribute(attributeName);
                if (propertyInfo.type === BOOLEAN) // If this was a boolean, it doesn't matter what the value is
                // the fact that we have it is the same as the expected.
                return expected;
                 // Even if this property uses a namespace we use getAttribute
                // because we assume its namespaced name is the same as our config.
                // To use getAttributeNS we need the local name which we don't have
                // in our config atm.
                stringValue = node.getAttribute(attributeName);
            }
            if (shouldRemoveAttribute(name, expected, propertyInfo, false)) return stringValue === null ? expected : stringValue; // eslint-disable-next-line react-internal/safe-string-coercion
            else if (stringValue === '' + expected) return expected;
            else return stringValue;
        }
    }
    /**
 * Get the value for a attribute on a node. Only used in DEV for SSR validation.
 * The third argument is used as a hint of what the expected value is. Some
 * attributes have multiple equivalent values.
 */ function getValueForAttribute(node, name, expected, isCustomComponentTag) {
        if (!isAttributeNameSafe(name)) return;
        if (!node.hasAttribute(name)) return expected === undefined ? undefined : null;
        var value = node.getAttribute(name);
        checkAttributeStringCoercion(expected, name);
        if (value === '' + expected) return expected;
        return value;
    }
    /**
 * Sets the value for a property on a node.
 *
 * @param {DOMElement} node
 * @param {string} name
 * @param {*} value
 */ function setValueForProperty(node, name, value, isCustomComponentTag) {
        var propertyInfo = getPropertyInfo(name);
        if (shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag)) return;
        if (shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag)) value = null;
        if (isCustomComponentTag || propertyInfo === null) {
            if (isAttributeNameSafe(name)) {
                var _attributeName = name;
                if (value === null) node.removeAttribute(_attributeName);
                else {
                    checkAttributeStringCoercion(value, name);
                    node.setAttribute(_attributeName, '' + value);
                }
            }
            return;
        }
        var mustUseProperty = propertyInfo.mustUseProperty;
        if (mustUseProperty) {
            var propertyName = propertyInfo.propertyName;
            if (value === null) {
                var type = propertyInfo.type;
                node[propertyName] = type === BOOLEAN ? false : '';
            } else // Contrary to `setAttribute`, object properties are properly
            // `toString`ed by IE8/9.
            node[propertyName] = value;
            return;
        } // The rest are treated as attributes with special cases.
        var attributeName = propertyInfo.attributeName, attributeNamespace = propertyInfo.attributeNamespace;
        if (value === null) node.removeAttribute(attributeName);
        else {
            var _type = propertyInfo.type;
            var attributeValue;
            if (_type === BOOLEAN || _type === OVERLOADED_BOOLEAN && value === true) // If attribute type is boolean, we know for sure it won't be an execution sink
            // and we won't require Trusted Type here.
            attributeValue = '';
            else {
                checkAttributeStringCoercion(value, attributeName);
                attributeValue = '' + value;
                if (propertyInfo.sanitizeURL) sanitizeURL(attributeValue.toString());
            }
            if (attributeNamespace) node.setAttributeNS(attributeNamespace, attributeName, attributeValue);
            else node.setAttribute(attributeName, attributeValue);
        }
    }
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types.
    var REACT_ELEMENT_TYPE = Symbol.for('react.element');
    var REACT_PORTAL_TYPE = Symbol.for('react.portal');
    var REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
    var REACT_STRICT_MODE_TYPE = Symbol.for('react.strict_mode');
    var REACT_PROFILER_TYPE = Symbol.for('react.profiler');
    var REACT_PROVIDER_TYPE = Symbol.for('react.provider');
    var REACT_CONTEXT_TYPE = Symbol.for('react.context');
    var REACT_FORWARD_REF_TYPE = Symbol.for('react.forward_ref');
    var REACT_SUSPENSE_TYPE = Symbol.for('react.suspense');
    var REACT_SUSPENSE_LIST_TYPE = Symbol.for('react.suspense_list');
    var REACT_MEMO_TYPE = Symbol.for('react.memo');
    var REACT_LAZY_TYPE = Symbol.for('react.lazy');
    var REACT_SCOPE_TYPE = Symbol.for('react.scope');
    var REACT_DEBUG_TRACING_MODE_TYPE = Symbol.for('react.debug_trace_mode');
    var REACT_OFFSCREEN_TYPE = Symbol.for('react.offscreen');
    var REACT_LEGACY_HIDDEN_TYPE = Symbol.for('react.legacy_hidden');
    var REACT_CACHE_TYPE = Symbol.for('react.cache');
    var REACT_TRACING_MARKER_TYPE = Symbol.for('react.tracing_marker');
    var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = '@@iterator';
    function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== 'object') return null;
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === 'function') return maybeIterator;
        return null;
    }
    var assign = Object.assign;
    // Helpers to patch console.logs to avoid logging during side-effect free
    // replaying on render function. This currently only patches the object
    // lazily which won't cover if the log function was extracted eagerly.
    // We could also eagerly patch the method.
    var disabledDepth = 0;
    var prevLog;
    var prevInfo;
    var prevWarn;
    var prevError;
    var prevGroup;
    var prevGroupCollapsed;
    var prevGroupEnd;
    function disabledLog() {}
    disabledLog.__reactDisabledLog = true;
    function disableLogs() {
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099
            var props = {
                configurable: true,
                enumerable: true,
                value: disabledLog,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
            });
        /* eslint-enable react-internal/no-production-logging */ }
        disabledDepth++;
    }
    function reenableLogs() {
        disabledDepth--;
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ var props = {
                configurable: true,
                enumerable: true,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                log: assign({}, props, {
                    value: prevLog
                }),
                info: assign({}, props, {
                    value: prevInfo
                }),
                warn: assign({}, props, {
                    value: prevWarn
                }),
                error: assign({}, props, {
                    value: prevError
                }),
                group: assign({}, props, {
                    value: prevGroup
                }),
                groupCollapsed: assign({}, props, {
                    value: prevGroupCollapsed
                }),
                groupEnd: assign({}, props, {
                    value: prevGroupEnd
                })
            });
        /* eslint-enable react-internal/no-production-logging */ }
        if (disabledDepth < 0) error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
    }
    var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
    var prefix;
    function describeBuiltInComponentFrame(name, source, ownerFn) {
        if (prefix === undefined) // Extract the VM specific prefix used by each line.
        try {
            throw Error();
        } catch (x) {
            var match = x.stack.trim().match(/\n( *(at )?)/);
            prefix = match && match[1] || '';
        }
         // We use the prefix to ensure our stacks line up with native stack frames.
        return '\n' + prefix + name;
    }
    var reentry = false;
    var componentFrameCache;
    var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
    componentFrameCache = new PossiblyWeakMap();
    function describeNativeComponentFrame(fn, construct) {
        // If something asked for a stack inside a fake render, it should get ignored.
        if (!fn || reentry) return '';
        var frame = componentFrameCache.get(fn);
        if (frame !== undefined) return frame;
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.
        Error.prepareStackTrace = undefined;
        var previousDispatcher;
        previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
        // for warnings.
        ReactCurrentDispatcher.current = null;
        disableLogs();
        try {
            // This should throw.
            if (construct) {
                // Something should be setting the props in the constructor.
                var Fake = function Fake() {
                    throw Error();
                }; // $FlowFixMe
                Object.defineProperty(Fake.prototype, 'props', {
                    set: function set() {
                        // We use a throwing setter instead of frozen or non-writable props
                        // because that won't throw in a non-strict mode function.
                        throw Error();
                    }
                });
                if (typeof Reflect === 'object' && Reflect.construct) {
                    // We construct a different control for this case to include any extra
                    // frames added by the construct call.
                    try {
                        Reflect.construct(Fake, []);
                    } catch (x) {
                        control = x;
                    }
                    Reflect.construct(fn, [], Fake);
                } else {
                    try {
                        Fake.call();
                    } catch (x) {
                        control = x;
                    }
                    fn.call(Fake.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (x) {
                    control = x;
                }
                fn();
            }
        } catch (sample) {
            // This is inlined manually because closure doesn't do it for us.
            if (sample && control && typeof sample.stack === 'string') {
                // This extracts the first frame from the sample that isn't also in the control.
                // Skipping one frame that we assume is the frame that calls the two.
                var sampleLines = sample.stack.split('\n');
                var controlLines = control.stack.split('\n');
                var s = sampleLines.length - 1;
                var c = controlLines.length - 1;
                while(s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c])// We expect at least one stack frame to be shared.
                // Typically this will be the root most one. However, stack frames may be
                // cut off due to maximum stack limits. In this case, one maybe cut off
                // earlier than the other. We assume that the sample is longer or the same
                // and there for cut off earlier. So we should find the root most frame in
                // the sample somewhere in the control.
                c--;
                for(; s >= 1 && c >= 0; s--, c--)// Next we find the first one that isn't the same which should be the
                // frame that called our sample function and the control.
                if (sampleLines[s] !== controlLines[c]) {
                    // In V8, the first line is describing the message but other VMs don't.
                    // If we're about to return the first line, and the control is also on the same
                    // line, that's a pretty good indicator that our sample threw at same line as
                    // the control. I.e. before we entered the sample frame. So we ignore this result.
                    // This can happen if you passed a class to function component, or non-function.
                    if (s !== 1 || c !== 1) do {
                        s--;
                        c--; // We may still have similar intermediate frames from the construct call.
                        // The next one that isn't the same should be our match though.
                        if (c < 0 || sampleLines[s] !== controlLines[c]) {
                            // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                            var _frame = '\n' + sampleLines[s].replace(' at new ', ' at '); // If our component frame is labeled "<anonymous>"
                            // but we have a user-provided "displayName"
                            // splice it in to make the stack more readable.
                            if (fn.displayName && _frame.includes('<anonymous>')) _frame = _frame.replace('<anonymous>', fn.displayName);
                            if (typeof fn === 'function') componentFrameCache.set(fn, _frame);
                            return _frame;
                        }
                    }while (s >= 1 && c >= 0);
                    break;
                }
            }
        } finally{
            reentry = false;
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
            Error.prepareStackTrace = previousPrepareStackTrace;
        } // Fallback to just using the name if we couldn't make it throw.
        var name = fn ? fn.displayName || fn.name : '';
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : '';
        if (typeof fn === 'function') componentFrameCache.set(fn, syntheticFrame);
        return syntheticFrame;
    }
    function describeClassComponentFrame(ctor, source, ownerFn) {
        return describeNativeComponentFrame(ctor, true);
    }
    function describeFunctionComponentFrame(fn, source, ownerFn) {
        return describeNativeComponentFrame(fn, false);
    }
    function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) return '';
        if (typeof type === 'function') return describeNativeComponentFrame(type, shouldConstruct(type));
        if (typeof type === 'string') return describeBuiltInComponentFrame(type);
        switch(type){
            case REACT_SUSPENSE_TYPE:
                return describeBuiltInComponentFrame('Suspense');
            case REACT_SUSPENSE_LIST_TYPE:
                return describeBuiltInComponentFrame('SuspenseList');
        }
        if (typeof type === 'object') switch(type.$$typeof){
            case REACT_FORWARD_REF_TYPE:
                return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
                // Memo may contain any component type so we recursively resolve it.
                return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    // Lazy may contain any component type so we recursively resolve it.
                    return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
        }
        return '';
    }
    function describeFiber(fiber) {
        var owner = fiber._debugOwner ? fiber._debugOwner.type : null;
        var source = fiber._debugSource;
        switch(fiber.tag){
            case HostComponent:
                return describeBuiltInComponentFrame(fiber.type);
            case LazyComponent:
                return describeBuiltInComponentFrame('Lazy');
            case SuspenseComponent:
                return describeBuiltInComponentFrame('Suspense');
            case SuspenseListComponent:
                return describeBuiltInComponentFrame('SuspenseList');
            case FunctionComponent:
            case IndeterminateComponent:
            case SimpleMemoComponent:
                return describeFunctionComponentFrame(fiber.type);
            case ForwardRef:
                return describeFunctionComponentFrame(fiber.type.render);
            case ClassComponent:
                return describeClassComponentFrame(fiber.type);
            default:
                return '';
        }
    }
    function getStackByFiberInDevAndProd(workInProgress) {
        try {
            var info = '';
            var node = workInProgress;
            do {
                info += describeFiber(node);
                node = node.return;
            }while (node);
            return info;
        } catch (x) {
            return '\nError generating stack: ' + x.message + '\n' + x.stack;
        }
    }
    function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;
        if (displayName) return displayName;
        var functionName = innerType.displayName || innerType.name || '';
        return functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName;
    } // Keep in sync with react-reconciler/getComponentNameFromFiber
    function getContextName(type) {
        return type.displayName || 'Context';
    } // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.
    function getComponentNameFromType(type) {
        if (type == null) // Host root, text node or just invalid type.
        return null;
        if (typeof type.tag === 'number') error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
        if (typeof type === 'function') return type.displayName || type.name || null;
        if (typeof type === 'string') return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return 'Fragment';
            case REACT_PORTAL_TYPE:
                return 'Portal';
            case REACT_PROFILER_TYPE:
                return 'Profiler';
            case REACT_STRICT_MODE_TYPE:
                return 'StrictMode';
            case REACT_SUSPENSE_TYPE:
                return 'Suspense';
            case REACT_SUSPENSE_LIST_TYPE:
                return 'SuspenseList';
        }
        if (typeof type === 'object') switch(type.$$typeof){
            case REACT_CONTEXT_TYPE:
                var context = type;
                return getContextName(context) + '.Consumer';
            case REACT_PROVIDER_TYPE:
                var provider = type;
                return getContextName(provider._context) + '.Provider';
            case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, 'ForwardRef');
            case REACT_MEMO_TYPE:
                var outerName = type.displayName || null;
                if (outerName !== null) return outerName;
                return getComponentNameFromType(type.type) || 'Memo';
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    return getComponentNameFromType(init(payload));
                } catch (x) {
                    return null;
                }
        }
        return null;
    }
    function getWrappedName$1(outerType, innerType, wrapperName) {
        var functionName = innerType.displayName || innerType.name || '';
        return outerType.displayName || (functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName);
    } // Keep in sync with shared/getComponentNameFromType
    function getContextName$1(type) {
        return type.displayName || 'Context';
    }
    function getComponentNameFromFiber(fiber) {
        var tag = fiber.tag, type = fiber.type;
        switch(tag){
            case CacheComponent:
                return 'Cache';
            case ContextConsumer:
                var context = type;
                return getContextName$1(context) + '.Consumer';
            case ContextProvider:
                var provider = type;
                return getContextName$1(provider._context) + '.Provider';
            case DehydratedFragment:
                return 'DehydratedFragment';
            case ForwardRef:
                return getWrappedName$1(type, type.render, 'ForwardRef');
            case Fragment:
                return 'Fragment';
            case HostComponent:
                // Host component type is the display name (e.g. "div", "View")
                return type;
            case HostPortal:
                return 'Portal';
            case HostRoot:
                return 'Root';
            case HostText:
                return 'Text';
            case LazyComponent:
                // Name comes from the type in this case; we don't have a tag.
                return getComponentNameFromType(type);
            case Mode:
                if (type === REACT_STRICT_MODE_TYPE) // Don't be less specific than shared/getComponentNameFromType
                return 'StrictMode';
                return 'Mode';
            case OffscreenComponent:
                return 'Offscreen';
            case Profiler:
                return 'Profiler';
            case ScopeComponent:
                return 'Scope';
            case SuspenseComponent:
                return 'Suspense';
            case SuspenseListComponent:
                return 'SuspenseList';
            case TracingMarkerComponent:
                return 'TracingMarker';
            // The display name for this tags come from the user-provided type:
            case ClassComponent:
            case FunctionComponent:
            case IncompleteClassComponent:
            case IndeterminateComponent:
            case MemoComponent:
            case SimpleMemoComponent:
                if (typeof type === 'function') return type.displayName || type.name || null;
                if (typeof type === 'string') return type;
                break;
        }
        return null;
    }
    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
    var current = null;
    var isRendering = false;
    function getCurrentFiberOwnerNameInDevOrNull() {
        if (current === null) return null;
        var owner = current._debugOwner;
        if (owner !== null && typeof owner !== 'undefined') return getComponentNameFromFiber(owner);
        return null;
    }
    function getCurrentFiberStackInDev() {
        if (current === null) return '';
         // Safe because if current fiber exists, we are reconciling,
        // and it is guaranteed to be the work-in-progress version.
        return getStackByFiberInDevAndProd(current);
    }
    function resetCurrentFiber() {
        ReactDebugCurrentFrame.getCurrentStack = null;
        current = null;
        isRendering = false;
    }
    function setCurrentFiber(fiber) {
        ReactDebugCurrentFrame.getCurrentStack = fiber === null ? null : getCurrentFiberStackInDev;
        current = fiber;
        isRendering = false;
    }
    function getCurrentFiber() {
        return current;
    }
    function setIsRendering(rendering) {
        isRendering = rendering;
    }
    // Flow does not allow string concatenation of most non-string types. To work
    // around this limitation, we use an opaque type that can only be obtained by
    // passing the value through getToStringValue first.
    function toString(value) {
        // The coercion safety check is performed in getToStringValue().
        // eslint-disable-next-line react-internal/safe-string-coercion
        return '' + value;
    }
    function getToStringValue(value) {
        switch(typeof value){
            case 'boolean':
            case 'number':
            case 'string':
            case 'undefined':
                return value;
            case 'object':
                checkFormFieldValueStringCoercion(value);
                return value;
            default:
                // function, symbol are assigned as empty strings
                return '';
        }
    }
    var hasReadOnlyValue = {
        button: true,
        checkbox: true,
        image: true,
        hidden: true,
        radio: true,
        reset: true,
        submit: true
    };
    function checkControlledValueProps(tagName, props) {
        if (!(hasReadOnlyValue[props.type] || props.onChange || props.onInput || props.readOnly || props.disabled || props.value == null)) error("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`.");
        if (!(props.onChange || props.readOnly || props.disabled || props.checked == null)) error("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function isCheckable(elem) {
        var type = elem.type;
        var nodeName = elem.nodeName;
        return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
    }
    function getTracker(node) {
        return node._valueTracker;
    }
    function detachTracker(node) {
        node._valueTracker = null;
    }
    function getValueFromNode(node) {
        var value = '';
        if (!node) return value;
        if (isCheckable(node)) value = node.checked ? 'true' : 'false';
        else value = node.value;
        return value;
    }
    function trackValueOnNode(node) {
        var valueField = isCheckable(node) ? 'checked' : 'value';
        var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
        checkFormFieldValueStringCoercion(node[valueField]);
        var currentValue = '' + node[valueField]; // if someone has already defined a value or Safari, then bail
        // and don't track value will cause over reporting of changes,
        // but it's better then a hard failure
        // (needed for certain tests that spyOn input values and Safari)
        if (node.hasOwnProperty(valueField) || typeof descriptor === 'undefined' || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') return;
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: true,
            get: function get1() {
                return get.call(this);
            },
            set: function set1(value) {
                checkFormFieldValueStringCoercion(value);
                currentValue = '' + value;
                set.call(this, value);
            }
        }); // We could've passed this the first time
        // but it triggers a bug in IE11 and Edge 14/15.
        // Calling defineProperty() again should be equivalent.
        // https://github.com/facebook/react/issues/11768
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        var tracker = {
            getValue: function getValue() {
                return currentValue;
            },
            setValue: function setValue(value) {
                checkFormFieldValueStringCoercion(value);
                currentValue = '' + value;
            },
            stopTracking: function stopTracking() {
                detachTracker(node);
                delete node[valueField];
            }
        };
        return tracker;
    }
    function track(node) {
        if (getTracker(node)) return;
         // TODO: Once it's just Fiber we can move this to node._wrapperState
        node._valueTracker = trackValueOnNode(node);
    }
    function updateValueIfChanged(node) {
        if (!node) return false;
        var tracker = getTracker(node); // if there is no tracker at this point it's unlikely
        // that trying again will succeed
        if (!tracker) return true;
        var lastValue = tracker.getValue();
        var nextValue = getValueFromNode(node);
        if (nextValue !== lastValue) {
            tracker.setValue(nextValue);
            return true;
        }
        return false;
    }
    function getActiveElement(doc) {
        doc = doc || (typeof document !== 'undefined' ? document : undefined);
        if (typeof doc === 'undefined') return null;
        try {
            return doc.activeElement || doc.body;
        } catch (e) {
            return doc.body;
        }
    }
    var didWarnValueDefaultValue = false;
    var didWarnCheckedDefaultChecked = false;
    var didWarnControlledToUncontrolled = false;
    var didWarnUncontrolledToControlled = false;
    function isControlled(props) {
        var usesChecked = props.type === 'checkbox' || props.type === 'radio';
        return usesChecked ? props.checked != null : props.value != null;
    }
    /**
 * Implements an <input> host component that allows setting these optional
 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
 *
 * If `checked` or `value` are not supplied (or null/undefined), user actions
 * that affect the checked state or value will trigger updates to the element.
 *
 * If they are supplied (and not null/undefined), the rendered element will not
 * trigger updates to the element. Instead, the props must change in order for
 * the rendered element to be updated.
 *
 * The rendered element will be initialized as unchecked (or `defaultChecked`)
 * with an empty value (or `defaultValue`).
 *
 * See http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
 */ function getHostProps(element, props) {
        var node = element;
        var checked = props.checked;
        var hostProps = assign({}, props, {
            defaultChecked: undefined,
            defaultValue: undefined,
            value: undefined,
            checked: checked != null ? checked : node._wrapperState.initialChecked
        });
        return hostProps;
    }
    function initWrapperState(element, props) {
        checkControlledValueProps('input', props);
        if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
            error("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || 'A component', props.type);
            didWarnCheckedDefaultChecked = true;
        }
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
            error("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || 'A component', props.type);
            didWarnValueDefaultValue = true;
        }
        var node = element;
        var defaultValue = props.defaultValue == null ? '' : props.defaultValue;
        node._wrapperState = {
            initialChecked: props.checked != null ? props.checked : props.defaultChecked,
            initialValue: getToStringValue(props.value != null ? props.value : defaultValue),
            controlled: isControlled(props)
        };
    }
    function updateChecked(element, props) {
        var node = element;
        var checked = props.checked;
        if (checked != null) setValueForProperty(node, 'checked', checked, false);
    }
    function updateWrapper(element, props) {
        var node = element;
        var controlled = isControlled(props);
        if (!node._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
            error("A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components");
            didWarnUncontrolledToControlled = true;
        }
        if (node._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
            error("A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components");
            didWarnControlledToUncontrolled = true;
        }
        updateChecked(element, props);
        var value = getToStringValue(props.value);
        var type = props.type;
        if (value != null) {
            if (type === 'number') {
                if (value === 0 && node.value === '' || // We explicitly want to coerce to number here if possible.
                // eslint-disable-next-line
                node.value != value) node.value = toString(value);
            } else if (node.value !== toString(value)) node.value = toString(value);
        } else if (type === 'submit' || type === 'reset') {
            // Submit/reset inputs need the attribute removed completely to avoid
            // blank-text buttons.
            node.removeAttribute('value');
            return;
        }
        // When syncing the value attribute, the value comes from a cascade of
        // properties:
        //  1. The value React property
        //  2. The defaultValue React property
        //  3. Otherwise there should be no change
        if (props.hasOwnProperty('value')) setDefaultValue(node, props.type, value);
        else if (props.hasOwnProperty('defaultValue')) setDefaultValue(node, props.type, getToStringValue(props.defaultValue));
        // When syncing the checked attribute, it only changes when it needs
        // to be removed, such as transitioning from a checkbox into a text input
        if (props.checked == null && props.defaultChecked != null) node.defaultChecked = !!props.defaultChecked;
    }
    function postMountWrapper(element, props, isHydrating) {
        var node = element; // Do not assign value if it is already set. This prevents user text input
        // from being lost during SSR hydration.
        if (props.hasOwnProperty('value') || props.hasOwnProperty('defaultValue')) {
            var type = props.type;
            var isButton = type === 'submit' || type === 'reset'; // Avoid setting value attribute on submit/reset inputs as it overrides the
            // default value provided by the browser. See: #12872
            if (isButton && (props.value === undefined || props.value === null)) return;
            var initialValue = toString(node._wrapperState.initialValue); // Do not assign value if it is already set. This prevents user text input
            // from being lost during SSR hydration.
            if (!isHydrating) // When syncing the value attribute, the value property should use
            // the wrapperState._initialValue property. This uses:
            //
            //   1. The value React property when present
            //   2. The defaultValue React property when present
            //   3. An empty string
            {
                if (initialValue !== node.value) node.value = initialValue;
            }
            // Otherwise, the value attribute is synchronized to the property,
            // so we assign defaultValue to the same thing as the value property
            // assignment step above.
            node.defaultValue = initialValue;
        } // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
        // this is needed to work around a chrome bug where setting defaultChecked
        // will sometimes influence the value of checked (even after detachment).
        // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
        // We need to temporarily unset name to avoid disrupting radio button groups.
        var name = node.name;
        if (name !== '') node.name = '';
        // When syncing the checked attribute, both the checked property and
        // attribute are assigned at the same time using defaultChecked. This uses:
        //
        //   1. The checked React property when present
        //   2. The defaultChecked React property when present
        //   3. Otherwise, false
        node.defaultChecked = !node.defaultChecked;
        node.defaultChecked = !!node._wrapperState.initialChecked;
        if (name !== '') node.name = name;
    }
    function restoreControlledState(element, props) {
        var node = element;
        updateWrapper(node, props);
        updateNamedCousins(node, props);
    }
    function updateNamedCousins(rootNode, props) {
        var name = props.name;
        if (props.type === 'radio' && name != null) {
            var queryRoot = rootNode;
            while(queryRoot.parentNode)queryRoot = queryRoot.parentNode;
             // If `rootNode.form` was non-null, then we could try `form.elements`,
            checkAttributeStringCoercion(name, 'name');
            var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
            for(var i = 0; i < group.length; i++){
                var otherNode = group[i];
                if (otherNode === rootNode || otherNode.form !== rootNode.form) continue;
                 // This will throw if radio buttons rendered by different copies of React
                // and the same name are rendered into the same form (same as #1939).
                // That's probably okay; we don't support it just as we don't support
                // mixing React radio buttons with non-React ones.
                var otherProps = getFiberCurrentPropsFromNode(otherNode);
                if (!otherProps) throw new Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");
                 // We need update the tracked value on the named cousin since the value
                // was changed but the input saw no event or value set
                updateValueIfChanged(otherNode); // If this is a controlled radio button group, forcing the input that
                // was previously checked to update will cause it to be come re-checked
                // as appropriate.
                updateWrapper(otherNode, otherProps);
            }
        }
    } // In Chrome, assigning defaultValue to certain input types triggers input validation.
    // For number inputs, the display value loses trailing decimal points. For email inputs,
    // Chrome raises "The specified value <x> is not a valid email address".
    //
    // Here we check to see if the defaultValue has actually changed, avoiding these problems
    // when the user is inputting text
    //
    // https://github.com/facebook/react/issues/7253
    function setDefaultValue(node, type, value) {
        if (type !== 'number' || getActiveElement(node.ownerDocument) !== node) {
            if (value == null) node.defaultValue = toString(node._wrapperState.initialValue);
            else if (node.defaultValue !== toString(value)) node.defaultValue = toString(value);
        }
    }
    var didWarnSelectedSetOnOption = false;
    var didWarnInvalidChild = false;
    var didWarnInvalidInnerHTML = false;
    /**
 * Implements an <option> host component that warns when `selected` is set.
 */ function validateProps(element, props) {
        // If a value is not provided, then the children must be simple.
        if (props.value == null) {
            if (typeof props.children === 'object' && props.children !== null) React.Children.forEach(props.children, function(child) {
                if (child == null) return;
                if (typeof child === 'string' || typeof child === 'number') return;
                if (!didWarnInvalidChild) {
                    didWarnInvalidChild = true;
                    error("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.");
                }
            });
            else if (props.dangerouslySetInnerHTML != null) {
                if (!didWarnInvalidInnerHTML) {
                    didWarnInvalidInnerHTML = true;
                    error("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected.");
                }
            }
        } // TODO: Remove support for `selected` in <option>.
        if (props.selected != null && !didWarnSelectedSetOnOption) {
            error("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>.");
            didWarnSelectedSetOnOption = true;
        }
    }
    function postMountWrapper$1(element, props) {
        // value="" should make a value attribute (#6219)
        if (props.value != null) element.setAttribute('value', toString(getToStringValue(props.value)));
    }
    var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare
    function isArray(a) {
        return isArrayImpl(a);
    }
    var didWarnValueDefaultValue$1;
    didWarnValueDefaultValue$1 = false;
    function getDeclarationErrorAddendum() {
        var ownerName = getCurrentFiberOwnerNameInDevOrNull();
        if (ownerName) return '\n\nCheck the render method of `' + ownerName + '`.';
        return '';
    }
    var valuePropNames = [
        'value',
        'defaultValue'
    ];
    /**
 * Validation function for `value` and `defaultValue`.
 */ function checkSelectPropTypes(props) {
        checkControlledValueProps('select', props);
        for(var i = 0; i < valuePropNames.length; i++){
            var propName = valuePropNames[i];
            if (props[propName] == null) continue;
            var propNameIsArray = isArray(props[propName]);
            if (props.multiple && !propNameIsArray) error("The `%s` prop supplied to <select> must be an array if `multiple` is true.%s", propName, getDeclarationErrorAddendum());
            else if (!props.multiple && propNameIsArray) error("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s", propName, getDeclarationErrorAddendum());
        }
    }
    function updateOptions(node, multiple, propValue, setDefaultSelected) {
        var options = node.options;
        if (multiple) {
            var selectedValues = propValue;
            var selectedValue = {};
            for(var i = 0; i < selectedValues.length; i++)// Prefix to avoid chaos with special keys.
            selectedValue['$' + selectedValues[i]] = true;
            for(var _i = 0; _i < options.length; _i++){
                var selected = selectedValue.hasOwnProperty('$' + options[_i].value);
                if (options[_i].selected !== selected) options[_i].selected = selected;
                if (selected && setDefaultSelected) options[_i].defaultSelected = true;
            }
        } else {
            // Do not set `select.value` as exact behavior isn't consistent across all
            // browsers for all cases.
            var _selectedValue = toString(getToStringValue(propValue));
            var defaultSelected = null;
            for(var _i2 = 0; _i2 < options.length; _i2++){
                if (options[_i2].value === _selectedValue) {
                    options[_i2].selected = true;
                    if (setDefaultSelected) options[_i2].defaultSelected = true;
                    return;
                }
                if (defaultSelected === null && !options[_i2].disabled) defaultSelected = options[_i2];
            }
            if (defaultSelected !== null) defaultSelected.selected = true;
        }
    }
    /**
 * Implements a <select> host component that allows optionally setting the
 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
 * stringable. If `multiple` is true, the prop must be an array of stringables.
 *
 * If `value` is not supplied (or null/undefined), user actions that change the
 * selected option will trigger updates to the rendered options.
 *
 * If it is supplied (and not null/undefined), the rendered options will not
 * update in response to user actions. Instead, the `value` prop must change in
 * order for the rendered options to update.
 *
 * If `defaultValue` is provided, any options with the supplied values will be
 * selected.
 */ function getHostProps$1(element, props) {
        return assign({}, props, {
            value: undefined
        });
    }
    function initWrapperState$1(element, props) {
        var node = element;
        checkSelectPropTypes(props);
        node._wrapperState = {
            wasMultiple: !!props.multiple
        };
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue$1) {
            error("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components");
            didWarnValueDefaultValue$1 = true;
        }
    }
    function postMountWrapper$2(element, props) {
        var node = element;
        node.multiple = !!props.multiple;
        var value = props.value;
        if (value != null) updateOptions(node, !!props.multiple, value, false);
        else if (props.defaultValue != null) updateOptions(node, !!props.multiple, props.defaultValue, true);
    }
    function postUpdateWrapper(element, props) {
        var node = element;
        var wasMultiple = node._wrapperState.wasMultiple;
        node._wrapperState.wasMultiple = !!props.multiple;
        var value = props.value;
        if (value != null) updateOptions(node, !!props.multiple, value, false);
        else if (wasMultiple !== !!props.multiple) {
            // For simplicity, reapply `defaultValue` if `multiple` is toggled.
            if (props.defaultValue != null) updateOptions(node, !!props.multiple, props.defaultValue, true);
            else // Revert the select back to its default unselected state.
            updateOptions(node, !!props.multiple, props.multiple ? [] : '', false);
        }
    }
    function restoreControlledState$1(element, props) {
        var node = element;
        var value = props.value;
        if (value != null) updateOptions(node, !!props.multiple, value, false);
    }
    var didWarnValDefaultVal = false;
    /**
 * Implements a <textarea> host component that allows setting `value`, and
 * `defaultValue`. This differs from the traditional DOM API because value is
 * usually set as PCDATA children.
 *
 * If `value` is not supplied (or null/undefined), user actions that affect the
 * value will trigger updates to the element.
 *
 * If `value` is supplied (and not null/undefined), the rendered element will
 * not trigger updates to the element. Instead, the `value` prop must change in
 * order for the rendered element to be updated.
 *
 * The rendered element will be initialized with an empty value, the prop
 * `defaultValue` if specified, or the children content (deprecated).
 */ function getHostProps$2(element, props) {
        var node = element;
        if (props.dangerouslySetInnerHTML != null) throw new Error('`dangerouslySetInnerHTML` does not make sense on <textarea>.');
         // Always set children to the same thing. In IE9, the selection range will
        // get reset if `textContent` is mutated.  We could add a check in setTextContent
        // to only set the value if/when the value differs from the node value (which would
        // completely solve this IE9 bug), but Sebastian+Sophie seemed to like this
        // solution. The value can be a boolean or object so that's why it's forced
        // to be a string.
        var hostProps = assign({}, props, {
            value: undefined,
            defaultValue: undefined,
            children: toString(node._wrapperState.initialValue)
        });
        return hostProps;
    }
    function initWrapperState$2(element, props) {
        var node = element;
        checkControlledValueProps('textarea', props);
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
            error("%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || 'A component');
            didWarnValDefaultVal = true;
        }
        var initialValue = props.value; // Only bother fetching default value if we're going to use it
        if (initialValue == null) {
            var children = props.children, defaultValue = props.defaultValue;
            if (children != null) {
                error("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
                if (defaultValue != null) throw new Error('If you supply `defaultValue` on a <textarea>, do not pass children.');
                if (isArray(children)) {
                    if (children.length > 1) throw new Error('<textarea> can only have at most one child.');
                    children = children[0];
                }
                defaultValue = children;
            }
            if (defaultValue == null) defaultValue = '';
            initialValue = defaultValue;
        }
        node._wrapperState = {
            initialValue: getToStringValue(initialValue)
        };
    }
    function updateWrapper$1(element, props) {
        var node = element;
        var value = getToStringValue(props.value);
        var defaultValue = getToStringValue(props.defaultValue);
        if (value != null) {
            // Cast `value` to a string to ensure the value is set correctly. While
            // browsers typically do this as necessary, jsdom doesn't.
            var newValue = toString(value); // To avoid side effects (such as losing text selection), only set value if changed
            if (newValue !== node.value) node.value = newValue;
            if (props.defaultValue == null && node.defaultValue !== newValue) node.defaultValue = newValue;
        }
        if (defaultValue != null) node.defaultValue = toString(defaultValue);
    }
    function postMountWrapper$3(element, props) {
        var node = element; // This is in postMount because we need access to the DOM node, which is not
        // available until after the component has mounted.
        var textContent = node.textContent; // Only set node.value if textContent is equal to the expected
        // initial value. In IE10/IE11 there is a bug where the placeholder attribute
        // will populate textContent as well.
        // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
        if (textContent === node._wrapperState.initialValue) {
            if (textContent !== '' && textContent !== null) node.value = textContent;
        }
    }
    function restoreControlledState$2(element, props) {
        // DOM component is still mounted; update
        updateWrapper$1(element, props);
    }
    var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
    var MATH_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
    var SVG_NAMESPACE = 'http://www.w3.org/2000/svg'; // Assumes there is no parent namespace.
    function getIntrinsicNamespace(type) {
        switch(type){
            case 'svg':
                return SVG_NAMESPACE;
            case 'math':
                return MATH_NAMESPACE;
            default:
                return HTML_NAMESPACE;
        }
    }
    function getChildNamespace(parentNamespace, type) {
        if (parentNamespace == null || parentNamespace === HTML_NAMESPACE) // No (or default) parent namespace: potential entry point.
        return getIntrinsicNamespace(type);
        if (parentNamespace === SVG_NAMESPACE && type === 'foreignObject') // We're leaving SVG.
        return HTML_NAMESPACE;
         // By default, pass namespace below.
        return parentNamespace;
    }
    /* globals MSApp */ /**
 * Create a function which has 'unsafe' privileges (required by windows8 apps)
 */ var createMicrosoftUnsafeLocalFunction = function createMicrosoftUnsafeLocalFunction(func) {
        if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) return function(arg0, arg1, arg2, arg3) {
            MSApp.execUnsafeLocalFunction(function() {
                return func(arg0, arg1, arg2, arg3);
            });
        };
        else return func;
    };
    var reusableSVGContainer;
    /**
 * Set the innerHTML property of a node
 *
 * @param {DOMElement} node
 * @param {string} html
 * @internal
 */ var setInnerHTML = createMicrosoftUnsafeLocalFunction(function(node, html) {
        if (node.namespaceURI === SVG_NAMESPACE) {
            if (!('innerHTML' in node)) {
                // IE does not have innerHTML for SVG nodes, so instead we inject the
                // new markup in a temp node and then move the child nodes across into
                // the target node
                reusableSVGContainer = reusableSVGContainer || document.createElement('div');
                reusableSVGContainer.innerHTML = '<svg>' + html.valueOf().toString() + '</svg>';
                var svgNode = reusableSVGContainer.firstChild;
                while(node.firstChild)node.removeChild(node.firstChild);
                while(svgNode.firstChild)node.appendChild(svgNode.firstChild);
                return;
            }
        }
        node.innerHTML = html;
    });
    /**
 * HTML nodeType values that represent the type of the node
 */ var ELEMENT_NODE = 1;
    var TEXT_NODE = 3;
    var COMMENT_NODE = 8;
    var DOCUMENT_NODE = 9;
    var DOCUMENT_FRAGMENT_NODE = 11;
    /**
 * Set the textContent property of a node. For text updates, it's faster
 * to set the `nodeValue` of the Text node directly instead of using
 * `.textContent` which will remove the existing node and create a new one.
 *
 * @param {DOMElement} node
 * @param {string} text
 * @internal
 */ var setTextContent = function setTextContent(node, text) {
        if (text) {
            var firstChild = node.firstChild;
            if (firstChild && firstChild === node.lastChild && firstChild.nodeType === TEXT_NODE) {
                firstChild.nodeValue = text;
                return;
            }
        }
        node.textContent = text;
    };
    // List derived from Gecko source code:
    // https://github.com/mozilla/gecko-dev/blob/4e638efc71/layout/style/test/property_database.js
    var shorthandToLonghand = {
        animation: [
            'animationDelay',
            'animationDirection',
            'animationDuration',
            'animationFillMode',
            'animationIterationCount',
            'animationName',
            'animationPlayState',
            'animationTimingFunction'
        ],
        background: [
            'backgroundAttachment',
            'backgroundClip',
            'backgroundColor',
            'backgroundImage',
            'backgroundOrigin',
            'backgroundPositionX',
            'backgroundPositionY',
            'backgroundRepeat',
            'backgroundSize'
        ],
        backgroundPosition: [
            'backgroundPositionX',
            'backgroundPositionY'
        ],
        border: [
            'borderBottomColor',
            'borderBottomStyle',
            'borderBottomWidth',
            'borderImageOutset',
            'borderImageRepeat',
            'borderImageSlice',
            'borderImageSource',
            'borderImageWidth',
            'borderLeftColor',
            'borderLeftStyle',
            'borderLeftWidth',
            'borderRightColor',
            'borderRightStyle',
            'borderRightWidth',
            'borderTopColor',
            'borderTopStyle',
            'borderTopWidth'
        ],
        borderBlockEnd: [
            'borderBlockEndColor',
            'borderBlockEndStyle',
            'borderBlockEndWidth'
        ],
        borderBlockStart: [
            'borderBlockStartColor',
            'borderBlockStartStyle',
            'borderBlockStartWidth'
        ],
        borderBottom: [
            'borderBottomColor',
            'borderBottomStyle',
            'borderBottomWidth'
        ],
        borderColor: [
            'borderBottomColor',
            'borderLeftColor',
            'borderRightColor',
            'borderTopColor'
        ],
        borderImage: [
            'borderImageOutset',
            'borderImageRepeat',
            'borderImageSlice',
            'borderImageSource',
            'borderImageWidth'
        ],
        borderInlineEnd: [
            'borderInlineEndColor',
            'borderInlineEndStyle',
            'borderInlineEndWidth'
        ],
        borderInlineStart: [
            'borderInlineStartColor',
            'borderInlineStartStyle',
            'borderInlineStartWidth'
        ],
        borderLeft: [
            'borderLeftColor',
            'borderLeftStyle',
            'borderLeftWidth'
        ],
        borderRadius: [
            'borderBottomLeftRadius',
            'borderBottomRightRadius',
            'borderTopLeftRadius',
            'borderTopRightRadius'
        ],
        borderRight: [
            'borderRightColor',
            'borderRightStyle',
            'borderRightWidth'
        ],
        borderStyle: [
            'borderBottomStyle',
            'borderLeftStyle',
            'borderRightStyle',
            'borderTopStyle'
        ],
        borderTop: [
            'borderTopColor',
            'borderTopStyle',
            'borderTopWidth'
        ],
        borderWidth: [
            'borderBottomWidth',
            'borderLeftWidth',
            'borderRightWidth',
            'borderTopWidth'
        ],
        columnRule: [
            'columnRuleColor',
            'columnRuleStyle',
            'columnRuleWidth'
        ],
        columns: [
            'columnCount',
            'columnWidth'
        ],
        flex: [
            'flexBasis',
            'flexGrow',
            'flexShrink'
        ],
        flexFlow: [
            'flexDirection',
            'flexWrap'
        ],
        font: [
            'fontFamily',
            'fontFeatureSettings',
            'fontKerning',
            'fontLanguageOverride',
            'fontSize',
            'fontSizeAdjust',
            'fontStretch',
            'fontStyle',
            'fontVariant',
            'fontVariantAlternates',
            'fontVariantCaps',
            'fontVariantEastAsian',
            'fontVariantLigatures',
            'fontVariantNumeric',
            'fontVariantPosition',
            'fontWeight',
            'lineHeight'
        ],
        fontVariant: [
            'fontVariantAlternates',
            'fontVariantCaps',
            'fontVariantEastAsian',
            'fontVariantLigatures',
            'fontVariantNumeric',
            'fontVariantPosition'
        ],
        gap: [
            'columnGap',
            'rowGap'
        ],
        grid: [
            'gridAutoColumns',
            'gridAutoFlow',
            'gridAutoRows',
            'gridTemplateAreas',
            'gridTemplateColumns',
            'gridTemplateRows'
        ],
        gridArea: [
            'gridColumnEnd',
            'gridColumnStart',
            'gridRowEnd',
            'gridRowStart'
        ],
        gridColumn: [
            'gridColumnEnd',
            'gridColumnStart'
        ],
        gridColumnGap: [
            'columnGap'
        ],
        gridGap: [
            'columnGap',
            'rowGap'
        ],
        gridRow: [
            'gridRowEnd',
            'gridRowStart'
        ],
        gridRowGap: [
            'rowGap'
        ],
        gridTemplate: [
            'gridTemplateAreas',
            'gridTemplateColumns',
            'gridTemplateRows'
        ],
        listStyle: [
            'listStyleImage',
            'listStylePosition',
            'listStyleType'
        ],
        margin: [
            'marginBottom',
            'marginLeft',
            'marginRight',
            'marginTop'
        ],
        marker: [
            'markerEnd',
            'markerMid',
            'markerStart'
        ],
        mask: [
            'maskClip',
            'maskComposite',
            'maskImage',
            'maskMode',
            'maskOrigin',
            'maskPositionX',
            'maskPositionY',
            'maskRepeat',
            'maskSize'
        ],
        maskPosition: [
            'maskPositionX',
            'maskPositionY'
        ],
        outline: [
            'outlineColor',
            'outlineStyle',
            'outlineWidth'
        ],
        overflow: [
            'overflowX',
            'overflowY'
        ],
        padding: [
            'paddingBottom',
            'paddingLeft',
            'paddingRight',
            'paddingTop'
        ],
        placeContent: [
            'alignContent',
            'justifyContent'
        ],
        placeItems: [
            'alignItems',
            'justifyItems'
        ],
        placeSelf: [
            'alignSelf',
            'justifySelf'
        ],
        textDecoration: [
            'textDecorationColor',
            'textDecorationLine',
            'textDecorationStyle'
        ],
        textEmphasis: [
            'textEmphasisColor',
            'textEmphasisStyle'
        ],
        transition: [
            'transitionDelay',
            'transitionDuration',
            'transitionProperty',
            'transitionTimingFunction'
        ],
        wordWrap: [
            'overflowWrap'
        ]
    };
    /**
 * CSS properties which accept numbers but are not in units of "px".
 */ var isUnitlessNumber = {
        animationIterationCount: true,
        aspectRatio: true,
        borderImageOutset: true,
        borderImageSlice: true,
        borderImageWidth: true,
        boxFlex: true,
        boxFlexGroup: true,
        boxOrdinalGroup: true,
        columnCount: true,
        columns: true,
        flex: true,
        flexGrow: true,
        flexPositive: true,
        flexShrink: true,
        flexNegative: true,
        flexOrder: true,
        gridArea: true,
        gridRow: true,
        gridRowEnd: true,
        gridRowSpan: true,
        gridRowStart: true,
        gridColumn: true,
        gridColumnEnd: true,
        gridColumnSpan: true,
        gridColumnStart: true,
        fontWeight: true,
        lineClamp: true,
        lineHeight: true,
        opacity: true,
        order: true,
        orphans: true,
        tabSize: true,
        widows: true,
        zIndex: true,
        zoom: true,
        // SVG-related properties
        fillOpacity: true,
        floodOpacity: true,
        stopOpacity: true,
        strokeDasharray: true,
        strokeDashoffset: true,
        strokeMiterlimit: true,
        strokeOpacity: true,
        strokeWidth: true
    };
    /**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */ function prefixKey(prefix, key) {
        return prefix + key.charAt(0).toUpperCase() + key.substring(1);
    }
    /**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */ var prefixes = [
        'Webkit',
        'ms',
        'Moz',
        'O'
    ]; // Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
    // infinite loop, because it iterates over the newly added props too.
    Object.keys(isUnitlessNumber).forEach(function(prop) {
        prefixes.forEach(function(prefix) {
            isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
        });
    });
    /**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @return {string} Normalized style value with dimensions applied.
 */ function dangerousStyleValue(name, value, isCustomProperty) {
        // Note that we've removed escapeTextForBrowser() calls here since the
        // whole string will be escaped when the attribute is injected into
        // the markup. If you provide unsafe user data here they can inject
        // arbitrary CSS which may be problematic (I couldn't repro this):
        // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
        // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
        // This is not an XSS hole but instead a potential CSS injection issue
        // which has lead to a greater discussion about how we're going to
        // trust URLs moving forward. See #2115901
        var isEmpty = value == null || typeof value === 'boolean' || value === '';
        if (isEmpty) return '';
        if (!isCustomProperty && typeof value === 'number' && value !== 0 && !(isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name])) return value + 'px'; // Presumes implicit 'px' suffix for unitless numbers
        checkCSSPropertyStringCoercion(value, name);
        return ('' + value).trim();
    }
    var uppercasePattern = /([A-Z])/g;
    var msPattern = /^ms-/;
    /**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 */ function hyphenateStyleName(name) {
        return name.replace(uppercasePattern, '-$1').toLowerCase().replace(msPattern, '-ms-');
    }
    var warnValidStyle = function warnValidStyle() {};
    // 'msTransform' is correct, but the other prefixes should be capitalized
    var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
    var msPattern$1 = /^-ms-/;
    var hyphenPattern = /-(.)/g; // style values shouldn't contain a semicolon
    var badStyleValueWithSemicolonPattern = /;\s*$/;
    var warnedStyleNames = {};
    var warnedStyleValues = {};
    var warnedForNaNValue = false;
    var warnedForInfinityValue = false;
    var camelize = function camelize(string) {
        return string.replace(hyphenPattern, function(_, character) {
            return character.toUpperCase();
        });
    };
    var warnHyphenatedStyleName = function warnHyphenatedStyleName(name) {
        if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) return;
        warnedStyleNames[name] = true;
        error('Unsupported style property %s. Did you mean %s?', name, // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
        // is converted to lowercase `ms`.
        camelize(name.replace(msPattern$1, 'ms-')));
    };
    var warnBadVendoredStyleName = function warnBadVendoredStyleName(name) {
        if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) return;
        warnedStyleNames[name] = true;
        error('Unsupported vendor-prefixed style property %s. Did you mean %s?', name, name.charAt(0).toUpperCase() + name.slice(1));
    };
    var warnStyleValueWithSemicolon = function warnStyleValueWithSemicolon(name, value) {
        if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) return;
        warnedStyleValues[value] = true;
        error('Style property values shouldn\'t contain a semicolon. Try "%s: %s" instead.', name, value.replace(badStyleValueWithSemicolonPattern, ''));
    };
    var warnStyleValueIsNaN = function warnStyleValueIsNaN(name, value) {
        if (warnedForNaNValue) return;
        warnedForNaNValue = true;
        error('`NaN` is an invalid value for the `%s` css style property.', name);
    };
    var warnStyleValueIsInfinity = function warnStyleValueIsInfinity(name, value) {
        if (warnedForInfinityValue) return;
        warnedForInfinityValue = true;
        error('`Infinity` is an invalid value for the `%s` css style property.', name);
    };
    warnValidStyle = function warnValidStyle(name, value) {
        if (name.indexOf('-') > -1) warnHyphenatedStyleName(name);
        else if (badVendoredStyleNamePattern.test(name)) warnBadVendoredStyleName(name);
        else if (badStyleValueWithSemicolonPattern.test(value)) warnStyleValueWithSemicolon(name, value);
        if (typeof value === 'number') {
            if (isNaN(value)) warnStyleValueIsNaN(name, value);
            else if (!isFinite(value)) warnStyleValueIsInfinity(name, value);
        }
    };
    var warnValidStyle$1 = warnValidStyle;
    /**
 * Operations for dealing with CSS properties.
 */ /**
 * This creates a string that is expected to be equivalent to the style
 * attribute generated by server-side rendering. It by-passes warnings and
 * security checks so it's not safe to use this value for anything other than
 * comparison. It is only used in DEV for SSR validation.
 */ function createDangerousStringForStyles(styles) {
        var serialized = '';
        var delimiter = '';
        for(var styleName in styles){
            if (!styles.hasOwnProperty(styleName)) continue;
            var styleValue = styles[styleName];
            if (styleValue != null) {
                var isCustomProperty = styleName.indexOf('--') === 0;
                serialized += delimiter + (isCustomProperty ? styleName : hyphenateStyleName(styleName)) + ':';
                serialized += dangerousStyleValue(styleName, styleValue, isCustomProperty);
                delimiter = ';';
            }
        }
        return serialized || null;
    }
    /**
 * Sets the value for multiple styles on a node.  If a value is specified as
 * '' (empty string), the corresponding style property will be unset.
 *
 * @param {DOMElement} node
 * @param {object} styles
 */ function setValueForStyles(node, styles) {
        var style = node.style;
        for(var styleName in styles){
            if (!styles.hasOwnProperty(styleName)) continue;
            var isCustomProperty = styleName.indexOf('--') === 0;
            if (!isCustomProperty) warnValidStyle$1(styleName, styles[styleName]);
            var styleValue = dangerousStyleValue(styleName, styles[styleName], isCustomProperty);
            if (styleName === 'float') styleName = 'cssFloat';
            if (isCustomProperty) style.setProperty(styleName, styleValue);
            else style[styleName] = styleValue;
        }
    }
    function isValueEmpty(value) {
        return value == null || typeof value === 'boolean' || value === '';
    }
    /**
 * Given {color: 'red', overflow: 'hidden'} returns {
 *   color: 'color',
 *   overflowX: 'overflow',
 *   overflowY: 'overflow',
 * }. This can be read as "the overflowY property was set by the overflow
 * shorthand". That is, the values are the property that each was derived from.
 */ function expandShorthandMap(styles) {
        var expanded = {};
        for(var key in styles){
            var longhands = shorthandToLonghand[key] || [
                key
            ];
            for(var i = 0; i < longhands.length; i++)expanded[longhands[i]] = key;
        }
        return expanded;
    }
    /**
 * When mixing shorthand and longhand property names, we warn during updates if
 * we expect an incorrect result to occur. In particular, we warn for:
 *
 * Updating a shorthand property (longhand gets overwritten):
 *   {font: 'foo', fontVariant: 'bar'} -> {font: 'baz', fontVariant: 'bar'}
 *   becomes .style.font = 'baz'
 * Removing a shorthand property (longhand gets lost too):
 *   {font: 'foo', fontVariant: 'bar'} -> {fontVariant: 'bar'}
 *   becomes .style.font = ''
 * Removing a longhand property (should revert to shorthand; doesn't):
 *   {font: 'foo', fontVariant: 'bar'} -> {font: 'foo'}
 *   becomes .style.fontVariant = ''
 */ function validateShorthandPropertyCollisionInDev(styleUpdates, nextStyles) {
        if (!nextStyles) return;
        var expandedUpdates = expandShorthandMap(styleUpdates);
        var expandedStyles = expandShorthandMap(nextStyles);
        var warnedAbout = {};
        for(var key in expandedUpdates){
            var originalKey = expandedUpdates[key];
            var correctOriginalKey = expandedStyles[key];
            if (correctOriginalKey && originalKey !== correctOriginalKey) {
                var warningKey = originalKey + ',' + correctOriginalKey;
                if (warnedAbout[warningKey]) continue;
                warnedAbout[warningKey] = true;
                error("%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.", isValueEmpty(styleUpdates[originalKey]) ? 'Removing' : 'Updating', originalKey, correctOriginalKey);
            }
        }
    }
    // For HTML, certain tags should omit their close tag. We keep a list for
    // those special-case tags.
    var omittedCloseTags = {
        area: true,
        base: true,
        br: true,
        col: true,
        embed: true,
        hr: true,
        img: true,
        input: true,
        keygen: true,
        link: true,
        meta: true,
        param: true,
        source: true,
        track: true,
        wbr: true // NOTE: menuitem's close tag should be omitted, but that causes problems.
    };
    // `omittedCloseTags` except that `menuitem` should still have its closing tag.
    var voidElementTags = assign({
        menuitem: true
    }, omittedCloseTags);
    var HTML = '__html';
    function assertValidProps(tag, props) {
        if (!props) return;
         // Note the use of `==` which checks for null or undefined.
        if (voidElementTags[tag]) {
            if (props.children != null || props.dangerouslySetInnerHTML != null) throw new Error(tag + " is a void element tag and must neither have `children` nor " + 'use `dangerouslySetInnerHTML`.');
        }
        if (props.dangerouslySetInnerHTML != null) {
            if (props.children != null) throw new Error('Can only set one of `children` or `props.dangerouslySetInnerHTML`.');
            if (typeof props.dangerouslySetInnerHTML !== 'object' || !(HTML in props.dangerouslySetInnerHTML)) throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        }
        if (!props.suppressContentEditableWarning && props.contentEditable && props.children != null) error("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional.");
        if (props.style != null && typeof props.style !== 'object') throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
    }
    function isCustomComponent(tagName, props) {
        if (tagName.indexOf('-') === -1) return typeof props.is === 'string';
        switch(tagName){
            // These are reserved SVG and MathML elements.
            // We don't mind this list too much because we expect it to never grow.
            // The alternative is to track the namespace in a few places which is convoluted.
            // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
            case 'annotation-xml':
            case 'color-profile':
            case 'font-face':
            case 'font-face-src':
            case 'font-face-uri':
            case 'font-face-format':
            case 'font-face-name':
            case 'missing-glyph':
                return false;
            default:
                return true;
        }
    }
    // When adding attributes to the HTML or SVG allowed attribute list, be sure to
    // also add them to this module to ensure casing and incorrect name
    // warnings.
    var possibleStandardNames = {
        // HTML
        accept: 'accept',
        acceptcharset: 'acceptCharset',
        'accept-charset': 'acceptCharset',
        accesskey: 'accessKey',
        action: 'action',
        allowfullscreen: 'allowFullScreen',
        alt: 'alt',
        as: 'as',
        async: 'async',
        autocapitalize: 'autoCapitalize',
        autocomplete: 'autoComplete',
        autocorrect: 'autoCorrect',
        autofocus: 'autoFocus',
        autoplay: 'autoPlay',
        autosave: 'autoSave',
        capture: 'capture',
        cellpadding: 'cellPadding',
        cellspacing: 'cellSpacing',
        challenge: 'challenge',
        charset: 'charSet',
        checked: 'checked',
        children: 'children',
        cite: 'cite',
        class: 'className',
        classid: 'classID',
        classname: 'className',
        cols: 'cols',
        colspan: 'colSpan',
        content: 'content',
        contenteditable: 'contentEditable',
        contextmenu: 'contextMenu',
        controls: 'controls',
        controlslist: 'controlsList',
        coords: 'coords',
        crossorigin: 'crossOrigin',
        dangerouslysetinnerhtml: 'dangerouslySetInnerHTML',
        data: 'data',
        datetime: 'dateTime',
        default: 'default',
        defaultchecked: 'defaultChecked',
        defaultvalue: 'defaultValue',
        defer: 'defer',
        dir: 'dir',
        disabled: 'disabled',
        disablepictureinpicture: 'disablePictureInPicture',
        disableremoteplayback: 'disableRemotePlayback',
        download: 'download',
        draggable: 'draggable',
        enctype: 'encType',
        enterkeyhint: 'enterKeyHint',
        for: 'htmlFor',
        form: 'form',
        formmethod: 'formMethod',
        formaction: 'formAction',
        formenctype: 'formEncType',
        formnovalidate: 'formNoValidate',
        formtarget: 'formTarget',
        frameborder: 'frameBorder',
        headers: 'headers',
        height: 'height',
        hidden: 'hidden',
        high: 'high',
        href: 'href',
        hreflang: 'hrefLang',
        htmlfor: 'htmlFor',
        httpequiv: 'httpEquiv',
        'http-equiv': 'httpEquiv',
        icon: 'icon',
        id: 'id',
        imagesizes: 'imageSizes',
        imagesrcset: 'imageSrcSet',
        innerhtml: 'innerHTML',
        inputmode: 'inputMode',
        integrity: 'integrity',
        is: 'is',
        itemid: 'itemID',
        itemprop: 'itemProp',
        itemref: 'itemRef',
        itemscope: 'itemScope',
        itemtype: 'itemType',
        keyparams: 'keyParams',
        keytype: 'keyType',
        kind: 'kind',
        label: 'label',
        lang: 'lang',
        list: 'list',
        loop: 'loop',
        low: 'low',
        manifest: 'manifest',
        marginwidth: 'marginWidth',
        marginheight: 'marginHeight',
        max: 'max',
        maxlength: 'maxLength',
        media: 'media',
        mediagroup: 'mediaGroup',
        method: 'method',
        min: 'min',
        minlength: 'minLength',
        multiple: 'multiple',
        muted: 'muted',
        name: 'name',
        nomodule: 'noModule',
        nonce: 'nonce',
        novalidate: 'noValidate',
        open: 'open',
        optimum: 'optimum',
        pattern: 'pattern',
        placeholder: 'placeholder',
        playsinline: 'playsInline',
        poster: 'poster',
        preload: 'preload',
        profile: 'profile',
        radiogroup: 'radioGroup',
        readonly: 'readOnly',
        referrerpolicy: 'referrerPolicy',
        rel: 'rel',
        required: 'required',
        reversed: 'reversed',
        role: 'role',
        rows: 'rows',
        rowspan: 'rowSpan',
        sandbox: 'sandbox',
        scope: 'scope',
        scoped: 'scoped',
        scrolling: 'scrolling',
        seamless: 'seamless',
        selected: 'selected',
        shape: 'shape',
        size: 'size',
        sizes: 'sizes',
        span: 'span',
        spellcheck: 'spellCheck',
        src: 'src',
        srcdoc: 'srcDoc',
        srclang: 'srcLang',
        srcset: 'srcSet',
        start: 'start',
        step: 'step',
        style: 'style',
        summary: 'summary',
        tabindex: 'tabIndex',
        target: 'target',
        title: 'title',
        type: 'type',
        usemap: 'useMap',
        value: 'value',
        width: 'width',
        wmode: 'wmode',
        wrap: 'wrap',
        // SVG
        about: 'about',
        accentheight: 'accentHeight',
        'accent-height': 'accentHeight',
        accumulate: 'accumulate',
        additive: 'additive',
        alignmentbaseline: 'alignmentBaseline',
        'alignment-baseline': 'alignmentBaseline',
        allowreorder: 'allowReorder',
        alphabetic: 'alphabetic',
        amplitude: 'amplitude',
        arabicform: 'arabicForm',
        'arabic-form': 'arabicForm',
        ascent: 'ascent',
        attributename: 'attributeName',
        attributetype: 'attributeType',
        autoreverse: 'autoReverse',
        azimuth: 'azimuth',
        basefrequency: 'baseFrequency',
        baselineshift: 'baselineShift',
        'baseline-shift': 'baselineShift',
        baseprofile: 'baseProfile',
        bbox: 'bbox',
        begin: 'begin',
        bias: 'bias',
        by: 'by',
        calcmode: 'calcMode',
        capheight: 'capHeight',
        'cap-height': 'capHeight',
        clip: 'clip',
        clippath: 'clipPath',
        'clip-path': 'clipPath',
        clippathunits: 'clipPathUnits',
        cliprule: 'clipRule',
        'clip-rule': 'clipRule',
        color: 'color',
        colorinterpolation: 'colorInterpolation',
        'color-interpolation': 'colorInterpolation',
        colorinterpolationfilters: 'colorInterpolationFilters',
        'color-interpolation-filters': 'colorInterpolationFilters',
        colorprofile: 'colorProfile',
        'color-profile': 'colorProfile',
        colorrendering: 'colorRendering',
        'color-rendering': 'colorRendering',
        contentscripttype: 'contentScriptType',
        contentstyletype: 'contentStyleType',
        cursor: 'cursor',
        cx: 'cx',
        cy: 'cy',
        d: 'd',
        datatype: 'datatype',
        decelerate: 'decelerate',
        descent: 'descent',
        diffuseconstant: 'diffuseConstant',
        direction: 'direction',
        display: 'display',
        divisor: 'divisor',
        dominantbaseline: 'dominantBaseline',
        'dominant-baseline': 'dominantBaseline',
        dur: 'dur',
        dx: 'dx',
        dy: 'dy',
        edgemode: 'edgeMode',
        elevation: 'elevation',
        enablebackground: 'enableBackground',
        'enable-background': 'enableBackground',
        end: 'end',
        exponent: 'exponent',
        externalresourcesrequired: 'externalResourcesRequired',
        fill: 'fill',
        fillopacity: 'fillOpacity',
        'fill-opacity': 'fillOpacity',
        fillrule: 'fillRule',
        'fill-rule': 'fillRule',
        filter: 'filter',
        filterres: 'filterRes',
        filterunits: 'filterUnits',
        floodopacity: 'floodOpacity',
        'flood-opacity': 'floodOpacity',
        floodcolor: 'floodColor',
        'flood-color': 'floodColor',
        focusable: 'focusable',
        fontfamily: 'fontFamily',
        'font-family': 'fontFamily',
        fontsize: 'fontSize',
        'font-size': 'fontSize',
        fontsizeadjust: 'fontSizeAdjust',
        'font-size-adjust': 'fontSizeAdjust',
        fontstretch: 'fontStretch',
        'font-stretch': 'fontStretch',
        fontstyle: 'fontStyle',
        'font-style': 'fontStyle',
        fontvariant: 'fontVariant',
        'font-variant': 'fontVariant',
        fontweight: 'fontWeight',
        'font-weight': 'fontWeight',
        format: 'format',
        from: 'from',
        fx: 'fx',
        fy: 'fy',
        g1: 'g1',
        g2: 'g2',
        glyphname: 'glyphName',
        'glyph-name': 'glyphName',
        glyphorientationhorizontal: 'glyphOrientationHorizontal',
        'glyph-orientation-horizontal': 'glyphOrientationHorizontal',
        glyphorientationvertical: 'glyphOrientationVertical',
        'glyph-orientation-vertical': 'glyphOrientationVertical',
        glyphref: 'glyphRef',
        gradienttransform: 'gradientTransform',
        gradientunits: 'gradientUnits',
        hanging: 'hanging',
        horizadvx: 'horizAdvX',
        'horiz-adv-x': 'horizAdvX',
        horizoriginx: 'horizOriginX',
        'horiz-origin-x': 'horizOriginX',
        ideographic: 'ideographic',
        imagerendering: 'imageRendering',
        'image-rendering': 'imageRendering',
        in2: 'in2',
        in: 'in',
        inlist: 'inlist',
        intercept: 'intercept',
        k1: 'k1',
        k2: 'k2',
        k3: 'k3',
        k4: 'k4',
        k: 'k',
        kernelmatrix: 'kernelMatrix',
        kernelunitlength: 'kernelUnitLength',
        kerning: 'kerning',
        keypoints: 'keyPoints',
        keysplines: 'keySplines',
        keytimes: 'keyTimes',
        lengthadjust: 'lengthAdjust',
        letterspacing: 'letterSpacing',
        'letter-spacing': 'letterSpacing',
        lightingcolor: 'lightingColor',
        'lighting-color': 'lightingColor',
        limitingconeangle: 'limitingConeAngle',
        local: 'local',
        markerend: 'markerEnd',
        'marker-end': 'markerEnd',
        markerheight: 'markerHeight',
        markermid: 'markerMid',
        'marker-mid': 'markerMid',
        markerstart: 'markerStart',
        'marker-start': 'markerStart',
        markerunits: 'markerUnits',
        markerwidth: 'markerWidth',
        mask: 'mask',
        maskcontentunits: 'maskContentUnits',
        maskunits: 'maskUnits',
        mathematical: 'mathematical',
        mode: 'mode',
        numoctaves: 'numOctaves',
        offset: 'offset',
        opacity: 'opacity',
        operator: 'operator',
        order: 'order',
        orient: 'orient',
        orientation: 'orientation',
        origin: 'origin',
        overflow: 'overflow',
        overlineposition: 'overlinePosition',
        'overline-position': 'overlinePosition',
        overlinethickness: 'overlineThickness',
        'overline-thickness': 'overlineThickness',
        paintorder: 'paintOrder',
        'paint-order': 'paintOrder',
        panose1: 'panose1',
        'panose-1': 'panose1',
        pathlength: 'pathLength',
        patterncontentunits: 'patternContentUnits',
        patterntransform: 'patternTransform',
        patternunits: 'patternUnits',
        pointerevents: 'pointerEvents',
        'pointer-events': 'pointerEvents',
        points: 'points',
        pointsatx: 'pointsAtX',
        pointsaty: 'pointsAtY',
        pointsatz: 'pointsAtZ',
        prefix: 'prefix',
        preservealpha: 'preserveAlpha',
        preserveaspectratio: 'preserveAspectRatio',
        primitiveunits: 'primitiveUnits',
        property: 'property',
        r: 'r',
        radius: 'radius',
        refx: 'refX',
        refy: 'refY',
        renderingintent: 'renderingIntent',
        'rendering-intent': 'renderingIntent',
        repeatcount: 'repeatCount',
        repeatdur: 'repeatDur',
        requiredextensions: 'requiredExtensions',
        requiredfeatures: 'requiredFeatures',
        resource: 'resource',
        restart: 'restart',
        result: 'result',
        results: 'results',
        rotate: 'rotate',
        rx: 'rx',
        ry: 'ry',
        scale: 'scale',
        security: 'security',
        seed: 'seed',
        shaperendering: 'shapeRendering',
        'shape-rendering': 'shapeRendering',
        slope: 'slope',
        spacing: 'spacing',
        specularconstant: 'specularConstant',
        specularexponent: 'specularExponent',
        speed: 'speed',
        spreadmethod: 'spreadMethod',
        startoffset: 'startOffset',
        stddeviation: 'stdDeviation',
        stemh: 'stemh',
        stemv: 'stemv',
        stitchtiles: 'stitchTiles',
        stopcolor: 'stopColor',
        'stop-color': 'stopColor',
        stopopacity: 'stopOpacity',
        'stop-opacity': 'stopOpacity',
        strikethroughposition: 'strikethroughPosition',
        'strikethrough-position': 'strikethroughPosition',
        strikethroughthickness: 'strikethroughThickness',
        'strikethrough-thickness': 'strikethroughThickness',
        string: 'string',
        stroke: 'stroke',
        strokedasharray: 'strokeDasharray',
        'stroke-dasharray': 'strokeDasharray',
        strokedashoffset: 'strokeDashoffset',
        'stroke-dashoffset': 'strokeDashoffset',
        strokelinecap: 'strokeLinecap',
        'stroke-linecap': 'strokeLinecap',
        strokelinejoin: 'strokeLinejoin',
        'stroke-linejoin': 'strokeLinejoin',
        strokemiterlimit: 'strokeMiterlimit',
        'stroke-miterlimit': 'strokeMiterlimit',
        strokewidth: 'strokeWidth',
        'stroke-width': 'strokeWidth',
        strokeopacity: 'strokeOpacity',
        'stroke-opacity': 'strokeOpacity',
        suppresscontenteditablewarning: 'suppressContentEditableWarning',
        suppresshydrationwarning: 'suppressHydrationWarning',
        surfacescale: 'surfaceScale',
        systemlanguage: 'systemLanguage',
        tablevalues: 'tableValues',
        targetx: 'targetX',
        targety: 'targetY',
        textanchor: 'textAnchor',
        'text-anchor': 'textAnchor',
        textdecoration: 'textDecoration',
        'text-decoration': 'textDecoration',
        textlength: 'textLength',
        textrendering: 'textRendering',
        'text-rendering': 'textRendering',
        to: 'to',
        transform: 'transform',
        typeof: 'typeof',
        u1: 'u1',
        u2: 'u2',
        underlineposition: 'underlinePosition',
        'underline-position': 'underlinePosition',
        underlinethickness: 'underlineThickness',
        'underline-thickness': 'underlineThickness',
        unicode: 'unicode',
        unicodebidi: 'unicodeBidi',
        'unicode-bidi': 'unicodeBidi',
        unicoderange: 'unicodeRange',
        'unicode-range': 'unicodeRange',
        unitsperem: 'unitsPerEm',
        'units-per-em': 'unitsPerEm',
        unselectable: 'unselectable',
        valphabetic: 'vAlphabetic',
        'v-alphabetic': 'vAlphabetic',
        values: 'values',
        vectoreffect: 'vectorEffect',
        'vector-effect': 'vectorEffect',
        version: 'version',
        vertadvy: 'vertAdvY',
        'vert-adv-y': 'vertAdvY',
        vertoriginx: 'vertOriginX',
        'vert-origin-x': 'vertOriginX',
        vertoriginy: 'vertOriginY',
        'vert-origin-y': 'vertOriginY',
        vhanging: 'vHanging',
        'v-hanging': 'vHanging',
        videographic: 'vIdeographic',
        'v-ideographic': 'vIdeographic',
        viewbox: 'viewBox',
        viewtarget: 'viewTarget',
        visibility: 'visibility',
        vmathematical: 'vMathematical',
        'v-mathematical': 'vMathematical',
        vocab: 'vocab',
        widths: 'widths',
        wordspacing: 'wordSpacing',
        'word-spacing': 'wordSpacing',
        writingmode: 'writingMode',
        'writing-mode': 'writingMode',
        x1: 'x1',
        x2: 'x2',
        x: 'x',
        xchannelselector: 'xChannelSelector',
        xheight: 'xHeight',
        'x-height': 'xHeight',
        xlinkactuate: 'xlinkActuate',
        'xlink:actuate': 'xlinkActuate',
        xlinkarcrole: 'xlinkArcrole',
        'xlink:arcrole': 'xlinkArcrole',
        xlinkhref: 'xlinkHref',
        'xlink:href': 'xlinkHref',
        xlinkrole: 'xlinkRole',
        'xlink:role': 'xlinkRole',
        xlinkshow: 'xlinkShow',
        'xlink:show': 'xlinkShow',
        xlinktitle: 'xlinkTitle',
        'xlink:title': 'xlinkTitle',
        xlinktype: 'xlinkType',
        'xlink:type': 'xlinkType',
        xmlbase: 'xmlBase',
        'xml:base': 'xmlBase',
        xmllang: 'xmlLang',
        'xml:lang': 'xmlLang',
        xmlns: 'xmlns',
        'xml:space': 'xmlSpace',
        xmlnsxlink: 'xmlnsXlink',
        'xmlns:xlink': 'xmlnsXlink',
        xmlspace: 'xmlSpace',
        y1: 'y1',
        y2: 'y2',
        y: 'y',
        ychannelselector: 'yChannelSelector',
        z: 'z',
        zoomandpan: 'zoomAndPan'
    };
    var ariaProperties = {
        'aria-current': 0,
        // state
        'aria-description': 0,
        'aria-details': 0,
        'aria-disabled': 0,
        // state
        'aria-hidden': 0,
        // state
        'aria-invalid': 0,
        // state
        'aria-keyshortcuts': 0,
        'aria-label': 0,
        'aria-roledescription': 0,
        // Widget Attributes
        'aria-autocomplete': 0,
        'aria-checked': 0,
        'aria-expanded': 0,
        'aria-haspopup': 0,
        'aria-level': 0,
        'aria-modal': 0,
        'aria-multiline': 0,
        'aria-multiselectable': 0,
        'aria-orientation': 0,
        'aria-placeholder': 0,
        'aria-pressed': 0,
        'aria-readonly': 0,
        'aria-required': 0,
        'aria-selected': 0,
        'aria-sort': 0,
        'aria-valuemax': 0,
        'aria-valuemin': 0,
        'aria-valuenow': 0,
        'aria-valuetext': 0,
        // Live Region Attributes
        'aria-atomic': 0,
        'aria-busy': 0,
        'aria-live': 0,
        'aria-relevant': 0,
        // Drag-and-Drop Attributes
        'aria-dropeffect': 0,
        'aria-grabbed': 0,
        // Relationship Attributes
        'aria-activedescendant': 0,
        'aria-colcount': 0,
        'aria-colindex': 0,
        'aria-colspan': 0,
        'aria-controls': 0,
        'aria-describedby': 0,
        'aria-errormessage': 0,
        'aria-flowto': 0,
        'aria-labelledby': 0,
        'aria-owns': 0,
        'aria-posinset': 0,
        'aria-rowcount': 0,
        'aria-rowindex': 0,
        'aria-rowspan': 0,
        'aria-setsize': 0
    };
    var warnedProperties = {};
    var rARIA = new RegExp('^(aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$');
    var rARIACamel = new RegExp('^(aria)[A-Z][' + ATTRIBUTE_NAME_CHAR + ']*$');
    function validateProperty(tagName, name) {
        if (hasOwnProperty.call(warnedProperties, name) && warnedProperties[name]) return true;
        if (rARIACamel.test(name)) {
            var ariaName = 'aria-' + name.slice(4).toLowerCase();
            var correctName = ariaProperties.hasOwnProperty(ariaName) ? ariaName : null; // If this is an aria-* attribute, but is not listed in the known DOM
            // DOM properties, then it is an invalid aria-* attribute.
            if (correctName == null) {
                error('Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.', name);
                warnedProperties[name] = true;
                return true;
            } // aria-* attributes should be lowercase; suggest the lowercase version.
            if (name !== correctName) {
                error('Invalid ARIA attribute `%s`. Did you mean `%s`?', name, correctName);
                warnedProperties[name] = true;
                return true;
            }
        }
        if (rARIA.test(name)) {
            var lowerCasedName = name.toLowerCase();
            var standardName = ariaProperties.hasOwnProperty(lowerCasedName) ? lowerCasedName : null; // If this is an aria-* attribute, but is not listed in the known DOM
            // DOM properties, then it is an invalid aria-* attribute.
            if (standardName == null) {
                warnedProperties[name] = true;
                return false;
            } // aria-* attributes should be lowercase; suggest the lowercase version.
            if (name !== standardName) {
                error('Unknown ARIA attribute `%s`. Did you mean `%s`?', name, standardName);
                warnedProperties[name] = true;
                return true;
            }
        }
        return true;
    }
    function warnInvalidARIAProps(type, props) {
        var invalidProps = [];
        for(var key in props){
            var isValid = validateProperty(type, key);
            if (!isValid) invalidProps.push(key);
        }
        var unknownPropString = invalidProps.map(function(prop) {
            return '`' + prop + '`';
        }).join(', ');
        if (invalidProps.length === 1) error("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", unknownPropString, type);
        else if (invalidProps.length > 1) error("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", unknownPropString, type);
    }
    function validateProperties(type, props) {
        if (isCustomComponent(type, props)) return;
        warnInvalidARIAProps(type, props);
    }
    var didWarnValueNull = false;
    function validateProperties$1(type, props) {
        if (type !== 'input' && type !== 'textarea' && type !== 'select') return;
        if (props != null && props.value === null && !didWarnValueNull) {
            didWarnValueNull = true;
            if (type === 'select' && props.multiple) error("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", type);
            else error("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", type);
        }
    }
    var validateProperty$1 = function validateProperty$1() {};
    var warnedProperties$1 = {};
    var EVENT_NAME_REGEX = /^on./;
    var INVALID_EVENT_NAME_REGEX = /^on[^A-Z]/;
    var rARIA$1 = new RegExp('^(aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$');
    var rARIACamel$1 = new RegExp('^(aria)[A-Z][' + ATTRIBUTE_NAME_CHAR + ']*$');
    validateProperty$1 = function validateProperty$1(tagName, name, value, eventRegistry) {
        if (hasOwnProperty.call(warnedProperties$1, name) && warnedProperties$1[name]) return true;
        var lowerCasedName = name.toLowerCase();
        if (lowerCasedName === 'onfocusin' || lowerCasedName === 'onfocusout') {
            error("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React.");
            warnedProperties$1[name] = true;
            return true;
        } // We can't rely on the event system being injected on the server.
        if (eventRegistry != null) {
            var registrationNameDependencies = eventRegistry.registrationNameDependencies, possibleRegistrationNames = eventRegistry.possibleRegistrationNames;
            if (registrationNameDependencies.hasOwnProperty(name)) return true;
            var registrationName = possibleRegistrationNames.hasOwnProperty(lowerCasedName) ? possibleRegistrationNames[lowerCasedName] : null;
            if (registrationName != null) {
                error('Invalid event handler property `%s`. Did you mean `%s`?', name, registrationName);
                warnedProperties$1[name] = true;
                return true;
            }
            if (EVENT_NAME_REGEX.test(name)) {
                error('Unknown event handler property `%s`. It will be ignored.', name);
                warnedProperties$1[name] = true;
                return true;
            }
        } else if (EVENT_NAME_REGEX.test(name)) {
            // If no event plugins have been injected, we are in a server environment.
            // So we can't tell if the event name is correct for sure, but we can filter
            // out known bad ones like `onclick`. We can't suggest a specific replacement though.
            if (INVALID_EVENT_NAME_REGEX.test(name)) error("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", name);
            warnedProperties$1[name] = true;
            return true;
        } // Let the ARIA attribute hook validate ARIA attributes
        if (rARIA$1.test(name) || rARIACamel$1.test(name)) return true;
        if (lowerCasedName === 'innerhtml') {
            error("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`.");
            warnedProperties$1[name] = true;
            return true;
        }
        if (lowerCasedName === 'aria') {
            error("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead.");
            warnedProperties$1[name] = true;
            return true;
        }
        if (lowerCasedName === 'is' && value !== null && value !== undefined && typeof value !== 'string') {
            error("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof value);
            warnedProperties$1[name] = true;
            return true;
        }
        if (typeof value === 'number' && isNaN(value)) {
            error("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", name);
            warnedProperties$1[name] = true;
            return true;
        }
        var propertyInfo = getPropertyInfo(name);
        var isReserved = propertyInfo !== null && propertyInfo.type === RESERVED; // Known attributes should match the casing specified in the property config.
        if (possibleStandardNames.hasOwnProperty(lowerCasedName)) {
            var standardName = possibleStandardNames[lowerCasedName];
            if (standardName !== name) {
                error('Invalid DOM property `%s`. Did you mean `%s`?', name, standardName);
                warnedProperties$1[name] = true;
                return true;
            }
        } else if (!isReserved && name !== lowerCasedName) {
            // Unknown attributes should have lowercase casing since that's how they
            // will be cased anyway with server rendering.
            error("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", name, lowerCasedName);
            warnedProperties$1[name] = true;
            return true;
        }
        if (typeof value === 'boolean' && shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
            if (value) error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', value, name, name, value, name);
            else error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', value, name, name, value, name, name, name);
            warnedProperties$1[name] = true;
            return true;
        } // Now that we've validated casing, do not validate
        // data types for reserved props
        if (isReserved) return true;
         // Warn when a known attribute is a bad type
        if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
            warnedProperties$1[name] = true;
            return false;
        } // Warn when passing the strings 'false' or 'true' into a boolean prop
        if ((value === 'false' || value === 'true') && propertyInfo !== null && propertyInfo.type === BOOLEAN) {
            error("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", value, name, value === 'false' ? 'The browser will interpret it as a truthy value.' : 'Although this works, it will not work as expected if you pass the string "false".', name, value);
            warnedProperties$1[name] = true;
            return true;
        }
        return true;
    };
    var warnUnknownProperties = function warnUnknownProperties(type, props, eventRegistry) {
        var unknownProps = [];
        for(var key in props){
            var isValid = validateProperty$1(type, key, props[key], eventRegistry);
            if (!isValid) unknownProps.push(key);
        }
        var unknownPropString = unknownProps.map(function(prop) {
            return '`' + prop + '`';
        }).join(', ');
        if (unknownProps.length === 1) error("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", unknownPropString, type);
        else if (unknownProps.length > 1) error("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", unknownPropString, type);
    };
    function validateProperties$2(type, props, eventRegistry) {
        if (isCustomComponent(type, props)) return;
        warnUnknownProperties(type, props, eventRegistry);
    }
    var IS_EVENT_HANDLE_NON_MANAGED_NODE = 1;
    var IS_NON_DELEGATED = 2;
    var IS_CAPTURE_PHASE = 4;
    // set to LEGACY_FB_SUPPORT. LEGACY_FB_SUPPORT only gets set when
    // we call willDeferLaterForLegacyFBSupport, thus not bailing out
    // will result in endless cycles like an infinite loop.
    // We also don't want to defer during event replaying.
    var SHOULD_NOT_PROCESS_POLYFILL_EVENT_PLUGINS = IS_EVENT_HANDLE_NON_MANAGED_NODE | IS_NON_DELEGATED | IS_CAPTURE_PHASE;
    // This exists to avoid circular dependency between ReactDOMEventReplaying
    // and DOMPluginEventSystem.
    var currentReplayingEvent = null;
    function setReplayingEvent(event) {
        if (currentReplayingEvent !== null) error("Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue.");
        currentReplayingEvent = event;
    }
    function resetReplayingEvent() {
        if (currentReplayingEvent === null) error("Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue.");
        currentReplayingEvent = null;
    }
    function isReplayingEvent(event) {
        return event === currentReplayingEvent;
    }
    /**
 * Gets the target node from a native browser event by accounting for
 * inconsistencies in browser DOM APIs.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {DOMEventTarget} Target node.
 */ function getEventTarget(nativeEvent) {
        // Fallback to nativeEvent.srcElement for IE9
        // https://github.com/facebook/react/issues/12506
        var target = nativeEvent.target || nativeEvent.srcElement || window; // Normalize SVG <use> element events #4963
        if (target.correspondingUseElement) target = target.correspondingUseElement;
         // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
        // @see http://www.quirksmode.org/js/events_properties.html
        return target.nodeType === TEXT_NODE ? target.parentNode : target;
    }
    var restoreImpl = null;
    var restoreTarget = null;
    var restoreQueue = null;
    function restoreStateOfTarget(target) {
        // We perform this translation at the end of the event loop so that we
        // always receive the correct fiber here
        var internalInstance = getInstanceFromNode(target);
        if (!internalInstance) // Unmounted
        return;
        if (typeof restoreImpl !== 'function') throw new Error("setRestoreImplementation() needs to be called to handle a target for controlled events. This error is likely caused by a bug in React. Please file an issue.");
        var stateNode = internalInstance.stateNode; // Guard against Fiber being unmounted.
        if (stateNode) {
            var _props = getFiberCurrentPropsFromNode(stateNode);
            restoreImpl(internalInstance.stateNode, internalInstance.type, _props);
        }
    }
    function setRestoreImplementation(impl) {
        restoreImpl = impl;
    }
    function enqueueStateRestore(target) {
        if (restoreTarget) {
            if (restoreQueue) restoreQueue.push(target);
            else restoreQueue = [
                target
            ];
        } else restoreTarget = target;
    }
    function needsStateRestore() {
        return restoreTarget !== null || restoreQueue !== null;
    }
    function restoreStateIfNeeded() {
        if (!restoreTarget) return;
        var target = restoreTarget;
        var queuedTargets = restoreQueue;
        restoreTarget = null;
        restoreQueue = null;
        restoreStateOfTarget(target);
        if (queuedTargets) for(var i = 0; i < queuedTargets.length; i++)restoreStateOfTarget(queuedTargets[i]);
    }
    // the renderer. Such as when we're dispatching events or if third party
    // libraries need to call batchedUpdates. Eventually, this API will go away when
    // everything is batched by default. We'll then have a similar API to opt-out of
    // scheduled work and instead do synchronous work.
    // Defaults
    var batchedUpdatesImpl = function batchedUpdatesImpl(fn, bookkeeping) {
        return fn(bookkeeping);
    };
    var flushSyncImpl = function flushSyncImpl() {};
    var isInsideEventHandler = false;
    function finishEventHandler() {
        // Here we wait until all updates have propagated, which is important
        // when using controlled components within layers:
        // https://github.com/facebook/react/issues/1698
        // Then we restore state of any controlled component.
        var controlledComponentsHavePendingUpdates = needsStateRestore();
        if (controlledComponentsHavePendingUpdates) {
            // If a controlled event was fired, we may need to restore the state of
            // the DOM node back to the controlled value. This is necessary when React
            // bails out of the update without touching the DOM.
            // TODO: Restore state in the microtask, after the discrete updates flush,
            // instead of early flushing them here.
            flushSyncImpl();
            restoreStateIfNeeded();
        }
    }
    function batchedUpdates(fn, a, b) {
        if (isInsideEventHandler) // If we are currently inside another batch, we need to wait until it
        // fully completes before restoring state.
        return fn(a, b);
        isInsideEventHandler = true;
        try {
            return batchedUpdatesImpl(fn, a, b);
        } finally{
            isInsideEventHandler = false;
            finishEventHandler();
        }
    } // TODO: Replace with flushSync
    function setBatchingImplementation(_batchedUpdatesImpl, _discreteUpdatesImpl, _flushSyncImpl) {
        batchedUpdatesImpl = _batchedUpdatesImpl;
        flushSyncImpl = _flushSyncImpl;
    }
    function isInteractive(tag) {
        return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
    }
    function shouldPreventMouseEvent(name, type, props) {
        switch(name){
            case 'onClick':
            case 'onClickCapture':
            case 'onDoubleClick':
            case 'onDoubleClickCapture':
            case 'onMouseDown':
            case 'onMouseDownCapture':
            case 'onMouseMove':
            case 'onMouseMoveCapture':
            case 'onMouseUp':
            case 'onMouseUpCapture':
            case 'onMouseEnter':
                return !!(props.disabled && isInteractive(type));
            default:
                return false;
        }
    }
    /**
 * @param {object} inst The instance, which is the source of events.
 * @param {string} registrationName Name of listener (e.g. `onClick`).
 * @return {?function} The stored callback.
 */ function getListener(inst, registrationName) {
        var stateNode = inst.stateNode;
        if (stateNode === null) // Work in progress (ex: onload events in incremental mode).
        return null;
        var props = getFiberCurrentPropsFromNode(stateNode);
        if (props === null) // Work in progress.
        return null;
        var listener = props[registrationName];
        if (shouldPreventMouseEvent(registrationName, inst.type, props)) return null;
        if (listener && typeof listener !== 'function') throw new Error("Expected `" + registrationName + "` listener to be a function, instead got a value of `" + typeof listener + "` type.");
        return listener;
    }
    var passiveBrowserEventsSupported = false; // Check if browser support events with passive listeners
    // https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
    if (canUseDOM) try {
        var options = {}; // $FlowFixMe: Ignore Flow complaining about needing a value
        Object.defineProperty(options, 'passive', {
            get: function get() {
                passiveBrowserEventsSupported = true;
            }
        });
        window.addEventListener('test', options, options);
        window.removeEventListener('test', options, options);
    } catch (e) {
        passiveBrowserEventsSupported = false;
    }
    function invokeGuardedCallbackProd(name, func, context, a, b, c, d, e, f) {
        var funcArgs = Array.prototype.slice.call(arguments, 3);
        try {
            func.apply(context, funcArgs);
        } catch (error) {
            this.onError(error);
        }
    }
    var invokeGuardedCallbackImpl = invokeGuardedCallbackProd;
    // In DEV mode, we swap out invokeGuardedCallback for a special version
    // that plays more nicely with the browser's DevTools. The idea is to preserve
    // "Pause on exceptions" behavior. Because React wraps all user-provided
    // functions in invokeGuardedCallback, and the production version of
    // invokeGuardedCallback uses a try-catch, all user exceptions are treated
    // like caught exceptions, and the DevTools won't pause unless the developer
    // takes the extra step of enabling pause on caught exceptions. This is
    // unintuitive, though, because even though React has caught the error, from
    // the developer's perspective, the error is uncaught.
    //
    // To preserve the expected "Pause on exceptions" behavior, we don't use a
    // try-catch in DEV. Instead, we synchronously dispatch a fake event to a fake
    // DOM node, and call the user-provided callback from inside an event handler
    // for that fake event. If the callback throws, the error is "captured" using
    // a global event handler. But because the error happens in a different
    // event loop context, it does not interrupt the normal program flow.
    // Effectively, this gives us try-catch behavior without actually using
    // try-catch. Neat!
    // Check that the browser supports the APIs we need to implement our special
    // DEV version of invokeGuardedCallback
    if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
        var fakeNode = document.createElement('react');
        invokeGuardedCallbackImpl = function invokeGuardedCallbackDev(name, func, context, a, b, c, d, e, f) {
            // If document doesn't exist we know for sure we will crash in this method
            // when we call document.createEvent(). However this can cause confusing
            // errors: https://github.com/facebook/create-react-app/issues/3482
            // So we preemptively throw with a better message instead.
            if (typeof document === 'undefined' || document === null) throw new Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
            var evt = document.createEvent('Event');
            var didCall = false; // Keeps track of whether the user-provided callback threw an error. We
            // set this to true at the beginning, then set it to false right after
            // calling the function. If the function errors, `didError` will never be
            // set to false. This strategy works even if the browser is flaky and
            // fails to call our global error handler, because it doesn't rely on
            // the error event at all.
            var didError = true; // Keeps track of the value of window.event so that we can reset it
            // during the callback to let user code access window.event in the
            // browsers that support it.
            var windowEvent = window.event; // Keeps track of the descriptor of window.event to restore it after event
            // dispatching: https://github.com/facebook/react/issues/13688
            var windowEventDescriptor = Object.getOwnPropertyDescriptor(window, 'event');
            function restoreAfterDispatch() {
                // We immediately remove the callback from event listeners so that
                // nested `invokeGuardedCallback` calls do not clash. Otherwise, a
                // nested call would trigger the fake event handlers of any call higher
                // in the stack.
                fakeNode.removeEventListener(evtType, callCallback, false); // We check for window.hasOwnProperty('event') to prevent the
                // window.event assignment in both IE <= 10 as they throw an error
                // "Member not found" in strict mode, and in Firefox which does not
                // support window.event.
                if (typeof window.event !== 'undefined' && window.hasOwnProperty('event')) window.event = windowEvent;
            } // Create an event handler for our fake event. We will synchronously
            // dispatch our fake event using `dispatchEvent`. Inside the handler, we
            // call the user-provided callback.
            var funcArgs = Array.prototype.slice.call(arguments, 3);
            function callCallback() {
                didCall = true;
                restoreAfterDispatch();
                func.apply(context, funcArgs);
                didError = false;
            } // Create a global error event handler. We use this to capture the value
            // that was thrown. It's possible that this error handler will fire more
            // than once; for example, if non-React code also calls `dispatchEvent`
            // and a handler for that event throws. We should be resilient to most of
            // those cases. Even if our error event handler fires more than once, the
            // last error event is always used. If the callback actually does error,
            // we know that the last error event is the correct one, because it's not
            // possible for anything else to have happened in between our callback
            // erroring and the code that follows the `dispatchEvent` call below. If
            // the callback doesn't error, but the error event was fired, we know to
            // ignore it because `didError` will be false, as described above.
            var _$error; // Use this to track whether the error event is ever called.
            var didSetError = false;
            var isCrossOriginError = false;
            function handleWindowError(event) {
                _$error = event.error;
                didSetError = true;
                if (_$error === null && event.colno === 0 && event.lineno === 0) isCrossOriginError = true;
                if (event.defaultPrevented) {
                    // Some other error handler has prevented default.
                    // Browsers silence the error report if this happens.
                    // We'll remember this to later decide whether to log it or not.
                    if (_$error != null && typeof _$error === 'object') try {
                        _$error._suppressLogging = true;
                    } catch (inner) {}
                }
            } // Create a fake event type.
            var evtType = "react-" + (name ? name : 'invokeguardedcallback'); // Attach our event handlers
            window.addEventListener('error', handleWindowError);
            fakeNode.addEventListener(evtType, callCallback, false); // Synchronously dispatch our fake event. If the user-provided function
            // errors, it will trigger our global error handler.
            evt.initEvent(evtType, false, false);
            fakeNode.dispatchEvent(evt);
            if (windowEventDescriptor) Object.defineProperty(window, 'event', windowEventDescriptor);
            if (didCall && didError) {
                if (!didSetError) // The callback errored, but the error event never fired.
                // eslint-disable-next-line react-internal/prod-error-codes
                _$error = new Error("An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the \"Pause on exceptions\" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue.");
                else if (isCrossOriginError) // eslint-disable-next-line react-internal/prod-error-codes
                _$error = new Error("A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://reactjs.org/link/crossorigin-error for more information.");
                this.onError(_$error);
            } // Remove our event listeners
            window.removeEventListener('error', handleWindowError);
            if (!didCall) {
                // Something went really wrong, and our event was not dispatched.
                // https://github.com/facebook/react/issues/16734
                // https://github.com/facebook/react/issues/16585
                // Fall back to the production implementation.
                restoreAfterDispatch();
                return invokeGuardedCallbackProd.apply(this, arguments);
            }
        };
    }
    var invokeGuardedCallbackImpl$1 = invokeGuardedCallbackImpl;
    var hasError = false;
    var caughtError = null; // Used by event system to capture/rethrow the first error.
    var hasRethrowError = false;
    var rethrowError = null;
    var reporter = {
        onError: function onError(error) {
            hasError = true;
            caughtError = error;
        }
    };
    /**
 * Call a function while guarding against errors that happens within it.
 * Returns an error if it throws, otherwise null.
 *
 * In production, this is implemented using a try-catch. The reason we don't
 * use a try-catch directly is so that we can swap out a different
 * implementation in DEV mode.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} context The context to use when calling the function
 * @param {...*} args Arguments for function
 */ function invokeGuardedCallback(name, func, context, a, b, c, d, e, f) {
        hasError = false;
        caughtError = null;
        invokeGuardedCallbackImpl$1.apply(reporter, arguments);
    }
    /**
 * Same as invokeGuardedCallback, but instead of returning an error, it stores
 * it in a global so it can be rethrown by `rethrowCaughtError` later.
 * TODO: See if caughtError and rethrowError can be unified.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} context The context to use when calling the function
 * @param {...*} args Arguments for function
 */ function invokeGuardedCallbackAndCatchFirstError(name, func, context, a, b, c, d, e, f) {
        invokeGuardedCallback.apply(this, arguments);
        if (hasError) {
            var _$error = clearCaughtError();
            if (!hasRethrowError) {
                hasRethrowError = true;
                rethrowError = _$error;
            }
        }
    }
    /**
 * During execution of guarded functions we will capture the first error which
 * we will rethrow to be handled by the top level error handler.
 */ function rethrowCaughtError() {
        if (hasRethrowError) {
            var _$error = rethrowError;
            hasRethrowError = false;
            rethrowError = null;
            throw _$error;
        }
    }
    function hasCaughtError() {
        return hasError;
    }
    function clearCaughtError() {
        if (hasError) {
            var _$error = caughtError;
            hasError = false;
            caughtError = null;
            return _$error;
        } else throw new Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
    }
    /**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 *
 * Note that this module is currently shared and assumed to be stateless.
 * If this becomes an actual Map, that will break.
 */ function get(key) {
        return key._reactInternals;
    }
    function has(key) {
        return key._reactInternals !== undefined;
    }
    function set(key, value) {
        key._reactInternals = value;
    }
    // Don't change these two values. They're used by React Dev Tools.
    var NoFlags = /*                      */ 0;
    var PerformedWork = /*                */ 1; // You can change the rest (and add more).
    var Placement = /*                    */ 2;
    var Update = /*                       */ 4;
    var ChildDeletion = /*                */ 16;
    var ContentReset = /*                 */ 32;
    var Callback = /*                     */ 64;
    var DidCapture = /*                   */ 128;
    var ForceClientRender = /*            */ 256;
    var Ref = /*                          */ 512;
    var Snapshot = /*                     */ 1024;
    var Passive = /*                      */ 2048;
    var Hydrating = /*                    */ 4096;
    var Visibility = /*                   */ 8192;
    var StoreConsistency = /*             */ 16384;
    var LifecycleEffectMask = Passive | Update | Callback | Ref | Snapshot | StoreConsistency; // Union of all commit flags (flags with the lifetime of a particular commit)
    var HostEffectMask = /*               */ 32767; // These are not really side effects, but we still reuse this field.
    var Incomplete = /*                   */ 32768;
    var ShouldCapture = /*                */ 65536;
    var ForceUpdateForLegacySuspense = /* */ 131072;
    var Forked = /*                       */ 1048576; // Static tags describe aspects of a fiber that are not specific to a render,
    // e.g. a fiber uses a passive effect (even if there are no updates on this particular render).
    // This enables us to defer more work in the unmount case,
    // since we can defer traversing the tree during layout to look for Passive effects,
    // and instead rely on the static flag as a signal that there may be cleanup work.
    var RefStatic = /*                    */ 2097152;
    var LayoutStatic = /*                 */ 4194304;
    var PassiveStatic = /*                */ 8388608; // These flags allow us to traverse to fibers that have effects on mount
    // without traversing the entire tree after every commit for
    // double invoking
    var MountLayoutDev = /*               */ 16777216;
    var MountPassiveDev = /*              */ 33554432; // Groups of flags that are used in the commit phase to skip over trees that
    // don't contain effects, by checking subtreeFlags.
    var BeforeMutationMask = // flag logic (see #20043)
    Update | Snapshot | 0;
    var MutationMask = Placement | Update | ChildDeletion | ContentReset | Ref | Hydrating | Visibility;
    var LayoutMask = Update | Callback | Ref | Visibility; // TODO: Split into PassiveMountMask and PassiveUnmountMask
    var PassiveMask = Passive | ChildDeletion; // Union of tags that don't get reset on clones.
    // This allows certain concepts to persist without recalculating them,
    // e.g. whether a subtree contains passive effects or portals.
    var StaticMask = LayoutStatic | PassiveStatic | RefStatic;
    var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
    function getNearestMountedFiber(fiber) {
        var node = fiber;
        var nearestMounted = fiber;
        if (!fiber.alternate) {
            // If there is no alternate, this might be a new tree that isn't inserted
            // yet. If it is, then it will have a pending insertion effect on it.
            var nextNode = node;
            do {
                node = nextNode;
                if ((node.flags & (Placement | Hydrating)) !== NoFlags) // This is an insertion or in-progress hydration. The nearest possible
                // mounted fiber is the parent but we need to continue to figure out
                // if that one is still mounted.
                nearestMounted = node.return;
                nextNode = node.return;
            }while (nextNode);
        } else while(node.return)node = node.return;
        if (node.tag === HostRoot) // TODO: Check if this was a nested HostRoot when used with
        // renderContainerIntoSubtree.
        return nearestMounted;
         // If we didn't hit the root, that means that we're in an disconnected tree
        // that has been unmounted.
        return null;
    }
    function getSuspenseInstanceFromFiber(fiber) {
        if (fiber.tag === SuspenseComponent) {
            var suspenseState = fiber.memoizedState;
            if (suspenseState === null) {
                var current = fiber.alternate;
                if (current !== null) suspenseState = current.memoizedState;
            }
            if (suspenseState !== null) return suspenseState.dehydrated;
        }
        return null;
    }
    function getContainerFromFiber(fiber) {
        return fiber.tag === HostRoot ? fiber.stateNode.containerInfo : null;
    }
    function isFiberMounted(fiber) {
        return getNearestMountedFiber(fiber) === fiber;
    }
    function isMounted(component) {
        var owner = ReactCurrentOwner.current;
        if (owner !== null && owner.tag === ClassComponent) {
            var ownerFiber = owner;
            var instance = ownerFiber.stateNode;
            if (!instance._warnedAboutRefsInRender) error("%s is accessing isMounted inside its render() function. render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", getComponentNameFromFiber(ownerFiber) || 'A component');
            instance._warnedAboutRefsInRender = true;
        }
        var fiber = get(component);
        if (!fiber) return false;
        return getNearestMountedFiber(fiber) === fiber;
    }
    function assertIsMounted(fiber) {
        if (getNearestMountedFiber(fiber) !== fiber) throw new Error('Unable to find node on an unmounted component.');
    }
    function findCurrentFiberUsingSlowPath(fiber) {
        var alternate = fiber.alternate;
        if (!alternate) {
            // If there is no alternate, then we only need to check if it is mounted.
            var nearestMounted = getNearestMountedFiber(fiber);
            if (nearestMounted === null) throw new Error('Unable to find node on an unmounted component.');
            if (nearestMounted !== fiber) return null;
            return fiber;
        } // If we have two possible branches, we'll walk backwards up to the root
        // to see what path the root points to. On the way we may hit one of the
        // special cases and we'll deal with them.
        var a = fiber;
        var b = alternate;
        while(true){
            var parentA = a.return;
            if (parentA === null) break;
            var parentB = parentA.alternate;
            if (parentB === null) {
                // There is no alternate. This is an unusual case. Currently, it only
                // happens when a Suspense component is hidden. An extra fragment fiber
                // is inserted in between the Suspense fiber and its children. Skip
                // over this extra fragment fiber and proceed to the next parent.
                var nextParent = parentA.return;
                if (nextParent !== null) {
                    a = b = nextParent;
                    continue;
                } // If there's no parent, we're at the root.
                break;
            } // If both copies of the parent fiber point to the same child, we can
            // assume that the child is current. This happens when we bailout on low
            // priority: the bailed out fiber's child reuses the current child.
            if (parentA.child === parentB.child) {
                var child = parentA.child;
                while(child){
                    if (child === a) {
                        // We've determined that A is the current branch.
                        assertIsMounted(parentA);
                        return fiber;
                    }
                    if (child === b) {
                        // We've determined that B is the current branch.
                        assertIsMounted(parentA);
                        return alternate;
                    }
                    child = child.sibling;
                } // We should never have an alternate for any mounting node. So the only
                // way this could possibly happen is if this was unmounted, if at all.
                throw new Error('Unable to find node on an unmounted component.');
            }
            if (a.return !== b.return) {
                // The return pointer of A and the return pointer of B point to different
                // fibers. We assume that return pointers never criss-cross, so A must
                // belong to the child set of A.return, and B must belong to the child
                // set of B.return.
                a = parentA;
                b = parentB;
            } else {
                // The return pointers point to the same fiber. We'll have to use the
                // default, slow path: scan the child sets of each parent alternate to see
                // which child belongs to which set.
                //
                // Search parent A's child set
                var didFindChild = false;
                var _child = parentA.child;
                while(_child){
                    if (_child === a) {
                        didFindChild = true;
                        a = parentA;
                        b = parentB;
                        break;
                    }
                    if (_child === b) {
                        didFindChild = true;
                        b = parentA;
                        a = parentB;
                        break;
                    }
                    _child = _child.sibling;
                }
                if (!didFindChild) {
                    // Search parent B's child set
                    _child = parentB.child;
                    while(_child){
                        if (_child === a) {
                            didFindChild = true;
                            a = parentB;
                            b = parentA;
                            break;
                        }
                        if (_child === b) {
                            didFindChild = true;
                            b = parentB;
                            a = parentA;
                            break;
                        }
                        _child = _child.sibling;
                    }
                    if (!didFindChild) throw new Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
                }
            }
            if (a.alternate !== b) throw new Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
        } // If the root is not a host container, we're in a disconnected tree. I.e.
        // unmounted.
        if (a.tag !== HostRoot) throw new Error('Unable to find node on an unmounted component.');
        if (a.stateNode.current === a) // We've determined that A is the current branch.
        return fiber;
         // Otherwise B has to be current branch.
        return alternate;
    }
    function findCurrentHostFiber(parent) {
        var currentParent = findCurrentFiberUsingSlowPath(parent);
        return currentParent !== null ? findCurrentHostFiberImpl(currentParent) : null;
    }
    function findCurrentHostFiberImpl(node) {
        // Next we'll drill down this component to find the first HostComponent/Text.
        if (node.tag === HostComponent || node.tag === HostText) return node;
        var child = node.child;
        while(child !== null){
            var match = findCurrentHostFiberImpl(child);
            if (match !== null) return match;
            child = child.sibling;
        }
        return null;
    }
    function findCurrentHostFiberWithNoPortals(parent) {
        var currentParent = findCurrentFiberUsingSlowPath(parent);
        return currentParent !== null ? findCurrentHostFiberWithNoPortalsImpl(currentParent) : null;
    }
    function findCurrentHostFiberWithNoPortalsImpl(node) {
        // Next we'll drill down this component to find the first HostComponent/Text.
        if (node.tag === HostComponent || node.tag === HostText) return node;
        var child = node.child;
        while(child !== null){
            if (child.tag !== HostPortal) {
                var match = findCurrentHostFiberWithNoPortalsImpl(child);
                if (match !== null) return match;
            }
            child = child.sibling;
        }
        return null;
    }
    // This module only exists as an ESM wrapper around the external CommonJS
    var scheduleCallback = Scheduler.unstable_scheduleCallback;
    var cancelCallback = Scheduler.unstable_cancelCallback;
    var shouldYield = Scheduler.unstable_shouldYield;
    var requestPaint = Scheduler.unstable_requestPaint;
    var now = Scheduler.unstable_now;
    var getCurrentPriorityLevel = Scheduler.unstable_getCurrentPriorityLevel;
    var ImmediatePriority = Scheduler.unstable_ImmediatePriority;
    var UserBlockingPriority = Scheduler.unstable_UserBlockingPriority;
    var NormalPriority = Scheduler.unstable_NormalPriority;
    var LowPriority = Scheduler.unstable_LowPriority;
    var IdlePriority = Scheduler.unstable_IdlePriority;
    // this doesn't actually exist on the scheduler, but it *does*
    // on scheduler/unstable_mock, which we'll need for internal testing
    var unstable_yieldValue = Scheduler.unstable_yieldValue;
    var unstable_setDisableYieldValue = Scheduler.unstable_setDisableYieldValue;
    var rendererID = null;
    var injectedHook = null;
    var injectedProfilingHooks = null;
    var hasLoggedError = false;
    var isDevToolsPresent = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined';
    function injectInternals(internals) {
        if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') // No DevTools
        return false;
        var hook = __REACT_DEVTOOLS_GLOBAL_HOOK__;
        if (hook.isDisabled) // This isn't a real property on the hook, but it can be set to opt out
        // of DevTools integration and associated warnings and logs.
        // https://github.com/facebook/react/issues/3877
        return true;
        if (!hook.supportsFiber) {
            error("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://reactjs.org/link/react-devtools");
            return true;
        }
        try {
            if (enableSchedulingProfiler) // Conditionally inject these hooks only if Timeline profiler is supported by this build.
            // This gives DevTools a way to feature detect that isn't tied to version number
            // (since profiling and timeline are controlled by different feature flags).
            internals = assign({}, internals, {
                getLaneLabelMap: getLaneLabelMap,
                injectProfilingHooks: injectProfilingHooks
            });
            rendererID = hook.inject(internals); // We have successfully injected, so now it is safe to set up hooks.
            injectedHook = hook;
        } catch (err) {
            error('React instrumentation encountered an error: %s.', err);
        }
        if (hook.checkDCE) // This is the real DevTools.
        return true;
        else // This is likely a hook installed by Fast Refresh runtime.
        return false;
    }
    function onScheduleRoot(root, children) {
        if (injectedHook && typeof injectedHook.onScheduleFiberRoot === 'function') try {
            injectedHook.onScheduleFiberRoot(rendererID, root, children);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error('React instrumentation encountered an error: %s', err);
            }
        }
    }
    function onCommitRoot(root, eventPriority) {
        if (injectedHook && typeof injectedHook.onCommitFiberRoot === 'function') try {
            var didError = (root.current.flags & DidCapture) === DidCapture;
            if (enableProfilerTimer) {
                var schedulerPriority;
                switch(eventPriority){
                    case DiscreteEventPriority:
                        schedulerPriority = ImmediatePriority;
                        break;
                    case ContinuousEventPriority:
                        schedulerPriority = UserBlockingPriority;
                        break;
                    case DefaultEventPriority:
                        schedulerPriority = NormalPriority;
                        break;
                    case IdleEventPriority:
                        schedulerPriority = IdlePriority;
                        break;
                    default:
                        schedulerPriority = NormalPriority;
                        break;
                }
                injectedHook.onCommitFiberRoot(rendererID, root, schedulerPriority, didError);
            } else injectedHook.onCommitFiberRoot(rendererID, root, undefined, didError);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error('React instrumentation encountered an error: %s', err);
            }
        }
    }
    function onPostCommitRoot(root) {
        if (injectedHook && typeof injectedHook.onPostCommitFiberRoot === 'function') try {
            injectedHook.onPostCommitFiberRoot(rendererID, root);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error('React instrumentation encountered an error: %s', err);
            }
        }
    }
    function onCommitUnmount(fiber) {
        if (injectedHook && typeof injectedHook.onCommitFiberUnmount === 'function') try {
            injectedHook.onCommitFiberUnmount(rendererID, fiber);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error('React instrumentation encountered an error: %s', err);
            }
        }
    }
    function setIsStrictModeForDevtools(newIsStrictMode) {
        if (typeof unstable_yieldValue === 'function') {
            // We're in a test because Scheduler.unstable_yieldValue only exists
            // in SchedulerMock. To reduce the noise in strict mode tests,
            // suppress warnings and disable scheduler yielding during the double render
            unstable_setDisableYieldValue(newIsStrictMode);
            setSuppressWarning(newIsStrictMode);
        }
        if (injectedHook && typeof injectedHook.setStrictMode === 'function') try {
            injectedHook.setStrictMode(rendererID, newIsStrictMode);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error('React instrumentation encountered an error: %s', err);
            }
        }
    } // Profiler API hooks
    function injectProfilingHooks(profilingHooks) {
        injectedProfilingHooks = profilingHooks;
    }
    function getLaneLabelMap() {
        var map = new Map();
        var lane = 1;
        for(var index = 0; index < TotalLanes; index++){
            var label = getLabelForLane(lane);
            map.set(lane, label);
            lane *= 2;
        }
        return map;
    }
    function markCommitStarted(lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markCommitStarted === 'function') injectedProfilingHooks.markCommitStarted(lanes);
    }
    function markCommitStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markCommitStopped === 'function') injectedProfilingHooks.markCommitStopped();
    }
    function markComponentRenderStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentRenderStarted === 'function') injectedProfilingHooks.markComponentRenderStarted(fiber);
    }
    function markComponentRenderStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentRenderStopped === 'function') injectedProfilingHooks.markComponentRenderStopped();
    }
    function markComponentPassiveEffectMountStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectMountStarted === 'function') injectedProfilingHooks.markComponentPassiveEffectMountStarted(fiber);
    }
    function markComponentPassiveEffectMountStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectMountStopped === 'function') injectedProfilingHooks.markComponentPassiveEffectMountStopped();
    }
    function markComponentPassiveEffectUnmountStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectUnmountStarted === 'function') injectedProfilingHooks.markComponentPassiveEffectUnmountStarted(fiber);
    }
    function markComponentPassiveEffectUnmountStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectUnmountStopped === 'function') injectedProfilingHooks.markComponentPassiveEffectUnmountStopped();
    }
    function markComponentLayoutEffectMountStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectMountStarted === 'function') injectedProfilingHooks.markComponentLayoutEffectMountStarted(fiber);
    }
    function markComponentLayoutEffectMountStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectMountStopped === 'function') injectedProfilingHooks.markComponentLayoutEffectMountStopped();
    }
    function markComponentLayoutEffectUnmountStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectUnmountStarted === 'function') injectedProfilingHooks.markComponentLayoutEffectUnmountStarted(fiber);
    }
    function markComponentLayoutEffectUnmountStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectUnmountStopped === 'function') injectedProfilingHooks.markComponentLayoutEffectUnmountStopped();
    }
    function markComponentErrored(fiber, thrownValue, lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentErrored === 'function') injectedProfilingHooks.markComponentErrored(fiber, thrownValue, lanes);
    }
    function markComponentSuspended(fiber, wakeable, lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentSuspended === 'function') injectedProfilingHooks.markComponentSuspended(fiber, wakeable, lanes);
    }
    function markLayoutEffectsStarted(lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markLayoutEffectsStarted === 'function') injectedProfilingHooks.markLayoutEffectsStarted(lanes);
    }
    function markLayoutEffectsStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markLayoutEffectsStopped === 'function') injectedProfilingHooks.markLayoutEffectsStopped();
    }
    function markPassiveEffectsStarted(lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markPassiveEffectsStarted === 'function') injectedProfilingHooks.markPassiveEffectsStarted(lanes);
    }
    function markPassiveEffectsStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markPassiveEffectsStopped === 'function') injectedProfilingHooks.markPassiveEffectsStopped();
    }
    function markRenderStarted(lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderStarted === 'function') injectedProfilingHooks.markRenderStarted(lanes);
    }
    function markRenderYielded() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderYielded === 'function') injectedProfilingHooks.markRenderYielded();
    }
    function markRenderStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderStopped === 'function') injectedProfilingHooks.markRenderStopped();
    }
    function markRenderScheduled(lane) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderScheduled === 'function') injectedProfilingHooks.markRenderScheduled(lane);
    }
    function markForceUpdateScheduled(fiber, lane) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markForceUpdateScheduled === 'function') injectedProfilingHooks.markForceUpdateScheduled(fiber, lane);
    }
    function markStateUpdateScheduled(fiber, lane) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markStateUpdateScheduled === 'function') injectedProfilingHooks.markStateUpdateScheduled(fiber, lane);
    }
    var NoMode = /*                         */ 0; // TODO: Remove ConcurrentMode by reading from the root tag instead
    var ConcurrentMode = /*                 */ 1;
    var ProfileMode = /*                    */ 2;
    var StrictLegacyMode = /*               */ 8;
    var StrictEffectsMode = /*              */ 16;
    // TODO: This is pretty well supported by browsers. Maybe we can drop it.
    var clz32 = Math.clz32 ? Math.clz32 : clz32Fallback; // Count leading zeros.
    // Based on:
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/clz32
    var log = Math.log;
    var LN2 = Math.LN2;
    function clz32Fallback(x) {
        var asUint = x >>> 0;
        if (asUint === 0) return 32;
        return 31 - (log(asUint) / LN2 | 0) | 0;
    }
    // If those values are changed that package should be rebuilt and redeployed.
    var TotalLanes = 31;
    var NoLanes = /*                        */ 0;
    var NoLane = /*                          */ 0;
    var SyncLane = /*                        */ 1;
    var InputContinuousHydrationLane = /*    */ 2;
    var InputContinuousLane = /*             */ 4;
    var DefaultHydrationLane = /*            */ 8;
    var DefaultLane = /*                     */ 16;
    var TransitionHydrationLane = /*                */ 32;
    var TransitionLanes = /*                       */ 4194240;
    var TransitionLane1 = /*                        */ 64;
    var TransitionLane2 = /*                        */ 128;
    var TransitionLane3 = /*                        */ 256;
    var TransitionLane4 = /*                        */ 512;
    var TransitionLane5 = /*                        */ 1024;
    var TransitionLane6 = /*                        */ 2048;
    var TransitionLane7 = /*                        */ 4096;
    var TransitionLane8 = /*                        */ 8192;
    var TransitionLane9 = /*                        */ 16384;
    var TransitionLane10 = /*                       */ 32768;
    var TransitionLane11 = /*                       */ 65536;
    var TransitionLane12 = /*                       */ 131072;
    var TransitionLane13 = /*                       */ 262144;
    var TransitionLane14 = /*                       */ 524288;
    var TransitionLane15 = /*                       */ 1048576;
    var TransitionLane16 = /*                       */ 2097152;
    var RetryLanes = /*                            */ 130023424;
    var RetryLane1 = /*                             */ 4194304;
    var RetryLane2 = /*                             */ 8388608;
    var RetryLane3 = /*                             */ 16777216;
    var RetryLane4 = /*                             */ 33554432;
    var RetryLane5 = /*                             */ 67108864;
    var SomeRetryLane = RetryLane1;
    var SelectiveHydrationLane = /*          */ 134217728;
    var NonIdleLanes = /*                          */ 268435455;
    var IdleHydrationLane = /*               */ 268435456;
    var IdleLane = /*                        */ 536870912;
    var OffscreenLane = /*                   */ 1073741824; // This function is used for the experimental timeline (react-devtools-timeline)
    // It should be kept in sync with the Lanes values above.
    function getLabelForLane(lane) {
        if (lane & SyncLane) return 'Sync';
        if (lane & InputContinuousHydrationLane) return 'InputContinuousHydration';
        if (lane & InputContinuousLane) return 'InputContinuous';
        if (lane & DefaultHydrationLane) return 'DefaultHydration';
        if (lane & DefaultLane) return 'Default';
        if (lane & TransitionHydrationLane) return 'TransitionHydration';
        if (lane & TransitionLanes) return 'Transition';
        if (lane & RetryLanes) return 'Retry';
        if (lane & SelectiveHydrationLane) return 'SelectiveHydration';
        if (lane & IdleHydrationLane) return 'IdleHydration';
        if (lane & IdleLane) return 'Idle';
        if (lane & OffscreenLane) return 'Offscreen';
    }
    var NoTimestamp = -1;
    var nextTransitionLane = TransitionLane1;
    var nextRetryLane = RetryLane1;
    function getHighestPriorityLanes(lanes) {
        switch(getHighestPriorityLane(lanes)){
            case SyncLane:
                return SyncLane;
            case InputContinuousHydrationLane:
                return InputContinuousHydrationLane;
            case InputContinuousLane:
                return InputContinuousLane;
            case DefaultHydrationLane:
                return DefaultHydrationLane;
            case DefaultLane:
                return DefaultLane;
            case TransitionHydrationLane:
                return TransitionHydrationLane;
            case TransitionLane1:
            case TransitionLane2:
            case TransitionLane3:
            case TransitionLane4:
            case TransitionLane5:
            case TransitionLane6:
            case TransitionLane7:
            case TransitionLane8:
            case TransitionLane9:
            case TransitionLane10:
            case TransitionLane11:
            case TransitionLane12:
            case TransitionLane13:
            case TransitionLane14:
            case TransitionLane15:
            case TransitionLane16:
                return lanes & TransitionLanes;
            case RetryLane1:
            case RetryLane2:
            case RetryLane3:
            case RetryLane4:
            case RetryLane5:
                return lanes & RetryLanes;
            case SelectiveHydrationLane:
                return SelectiveHydrationLane;
            case IdleHydrationLane:
                return IdleHydrationLane;
            case IdleLane:
                return IdleLane;
            case OffscreenLane:
                return OffscreenLane;
            default:
                error('Should have found matching lanes. This is a bug in React.');
                return lanes;
        }
    }
    function getNextLanes(root, wipLanes) {
        // Early bailout if there's no pending work left.
        var pendingLanes = root.pendingLanes;
        if (pendingLanes === NoLanes) return NoLanes;
        var nextLanes = NoLanes;
        var suspendedLanes = root.suspendedLanes;
        var pingedLanes = root.pingedLanes; // Do not work on any idle work until all the non-idle work has finished,
        // even if the work is suspended.
        var nonIdlePendingLanes = pendingLanes & NonIdleLanes;
        if (nonIdlePendingLanes !== NoLanes) {
            var nonIdleUnblockedLanes = nonIdlePendingLanes & ~suspendedLanes;
            if (nonIdleUnblockedLanes !== NoLanes) nextLanes = getHighestPriorityLanes(nonIdleUnblockedLanes);
            else {
                var nonIdlePingedLanes = nonIdlePendingLanes & pingedLanes;
                if (nonIdlePingedLanes !== NoLanes) nextLanes = getHighestPriorityLanes(nonIdlePingedLanes);
            }
        } else {
            // The only remaining work is Idle.
            var unblockedLanes = pendingLanes & ~suspendedLanes;
            if (unblockedLanes !== NoLanes) nextLanes = getHighestPriorityLanes(unblockedLanes);
            else if (pingedLanes !== NoLanes) nextLanes = getHighestPriorityLanes(pingedLanes);
        }
        if (nextLanes === NoLanes) // This should only be reachable if we're suspended
        // TODO: Consider warning in this path if a fallback timer is not scheduled.
        return NoLanes;
         // If we're already in the middle of a render, switching lanes will interrupt
        // it and we'll lose our progress. We should only do this if the new lanes are
        // higher priority.
        if (wipLanes !== NoLanes && wipLanes !== nextLanes && // If we already suspended with a delay, then interrupting is fine. Don't
        // bother waiting until the root is complete.
        (wipLanes & suspendedLanes) === NoLanes) {
            var nextLane = getHighestPriorityLane(nextLanes);
            var wipLane = getHighestPriorityLane(wipLanes);
            if (// one. This works because the bits decrease in priority as you go left.
            nextLane >= wipLane || // Default priority updates should not interrupt transition updates. The
            // only difference between default updates and transition updates is that
            // default updates do not support refresh transitions.
            nextLane === DefaultLane && (wipLane & TransitionLanes) !== NoLanes) // Keep working on the existing in-progress tree. Do not interrupt.
            return wipLanes;
        }
        if ((nextLanes & InputContinuousLane) !== NoLanes) // When updates are sync by default, we entangle continuous priority updates
        // and default updates, so they render in the same batch. The only reason
        // they use separate lanes is because continuous updates should interrupt
        // transitions, but default updates should not.
        nextLanes |= pendingLanes & DefaultLane;
         // Check for entangled lanes and add them to the batch.
        //
        // A lane is said to be entangled with another when it's not allowed to render
        // in a batch that does not also include the other lane. Typically we do this
        // when multiple updates have the same source, and we only want to respond to
        // the most recent event from that source.
        //
        // Note that we apply entanglements *after* checking for partial work above.
        // This means that if a lane is entangled during an interleaved event while
        // it's already rendering, we won't interrupt it. This is intentional, since
        // entanglement is usually "best effort": we'll try our best to render the
        // lanes in the same batch, but it's not worth throwing out partially
        // completed work in order to do it.
        // TODO: Reconsider this. The counter-argument is that the partial work
        // represents an intermediate state, which we don't want to show to the user.
        // And by spending extra time finishing it, we're increasing the amount of
        // time it takes to show the final state, which is what they are actually
        // waiting for.
        //
        // For those exceptions where entanglement is semantically important, like
        // useMutableSource, we should ensure that there is no partial work at the
        // time we apply the entanglement.
        var entangledLanes = root.entangledLanes;
        if (entangledLanes !== NoLanes) {
            var entanglements = root.entanglements;
            var lanes = nextLanes & entangledLanes;
            while(lanes > 0){
                var index = pickArbitraryLaneIndex(lanes);
                var lane = 1 << index;
                nextLanes |= entanglements[index];
                lanes &= ~lane;
            }
        }
        return nextLanes;
    }
    function getMostRecentEventTime(root, lanes) {
        var eventTimes = root.eventTimes;
        var mostRecentEventTime = NoTimestamp;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            var eventTime = eventTimes[index];
            if (eventTime > mostRecentEventTime) mostRecentEventTime = eventTime;
            lanes &= ~lane;
        }
        return mostRecentEventTime;
    }
    function computeExpirationTime(lane, currentTime) {
        switch(lane){
            case SyncLane:
            case InputContinuousHydrationLane:
            case InputContinuousLane:
                // User interactions should expire slightly more quickly.
                //
                // NOTE: This is set to the corresponding constant as in Scheduler.js.
                // When we made it larger, a product metric in www regressed, suggesting
                // there's a user interaction that's being starved by a series of
                // synchronous updates. If that theory is correct, the proper solution is
                // to fix the starvation. However, this scenario supports the idea that
                // expiration times are an important safeguard when starvation
                // does happen.
                return currentTime + 250;
            case DefaultHydrationLane:
            case DefaultLane:
            case TransitionHydrationLane:
            case TransitionLane1:
            case TransitionLane2:
            case TransitionLane3:
            case TransitionLane4:
            case TransitionLane5:
            case TransitionLane6:
            case TransitionLane7:
            case TransitionLane8:
            case TransitionLane9:
            case TransitionLane10:
            case TransitionLane11:
            case TransitionLane12:
            case TransitionLane13:
            case TransitionLane14:
            case TransitionLane15:
            case TransitionLane16:
                return currentTime + 5000;
            case RetryLane1:
            case RetryLane2:
            case RetryLane3:
            case RetryLane4:
            case RetryLane5:
                // TODO: Retries should be allowed to expire if they are CPU bound for
                // too long, but when I made this change it caused a spike in browser
                // crashes. There must be some other underlying bug; not super urgent but
                // ideally should figure out why and fix it. Unfortunately we don't have
                // a repro for the crashes, only detected via production metrics.
                return NoTimestamp;
            case SelectiveHydrationLane:
            case IdleHydrationLane:
            case IdleLane:
            case OffscreenLane:
                // Anything idle priority or lower should never expire.
                return NoTimestamp;
            default:
                error('Should have found matching lanes. This is a bug in React.');
                return NoTimestamp;
        }
    }
    function markStarvedLanesAsExpired(root, currentTime) {
        // TODO: This gets called every time we yield. We can optimize by storing
        // the earliest expiration time on the root. Then use that to quickly bail out
        // of this function.
        var pendingLanes = root.pendingLanes;
        var suspendedLanes = root.suspendedLanes;
        var pingedLanes = root.pingedLanes;
        var expirationTimes = root.expirationTimes; // Iterate through the pending lanes and check if we've reached their
        // expiration time. If so, we'll assume the update is being starved and mark
        // it as expired to force it to finish.
        var lanes = pendingLanes;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            var expirationTime = expirationTimes[index];
            if (expirationTime === NoTimestamp) // Found a pending lane with no expiration time. If it's not suspended, or
            // if it's pinged, assume it's CPU-bound. Compute a new expiration time
            // using the current time.
            {
                if ((lane & suspendedLanes) === NoLanes || (lane & pingedLanes) !== NoLanes) // Assumes timestamps are monotonically increasing.
                expirationTimes[index] = computeExpirationTime(lane, currentTime);
            } else if (expirationTime <= currentTime) // This lane expired
            root.expiredLanes |= lane;
            lanes &= ~lane;
        }
    } // This returns the highest priority pending lanes regardless of whether they
    // are suspended.
    function getHighestPriorityPendingLanes(root) {
        return getHighestPriorityLanes(root.pendingLanes);
    }
    function getLanesToRetrySynchronouslyOnError(root) {
        var everythingButOffscreen = root.pendingLanes & ~OffscreenLane;
        if (everythingButOffscreen !== NoLanes) return everythingButOffscreen;
        if (everythingButOffscreen & OffscreenLane) return OffscreenLane;
        return NoLanes;
    }
    function includesSyncLane(lanes) {
        return (lanes & SyncLane) !== NoLanes;
    }
    function includesNonIdleWork(lanes) {
        return (lanes & NonIdleLanes) !== NoLanes;
    }
    function includesOnlyRetries(lanes) {
        return (lanes & RetryLanes) === lanes;
    }
    function includesOnlyNonUrgentLanes(lanes) {
        var UrgentLanes = SyncLane | InputContinuousLane | DefaultLane;
        return (lanes & UrgentLanes) === NoLanes;
    }
    function includesOnlyTransitions(lanes) {
        return (lanes & TransitionLanes) === lanes;
    }
    function includesBlockingLane(root, lanes) {
        var SyncDefaultLanes = InputContinuousHydrationLane | InputContinuousLane | DefaultHydrationLane | DefaultLane;
        return (lanes & SyncDefaultLanes) !== NoLanes;
    }
    function includesExpiredLane(root, lanes) {
        // This is a separate check from includesBlockingLane because a lane can
        // expire after a render has already started.
        return (lanes & root.expiredLanes) !== NoLanes;
    }
    function isTransitionLane(lane) {
        return (lane & TransitionLanes) !== NoLanes;
    }
    function claimNextTransitionLane() {
        // Cycle through the lanes, assigning each new transition to the next lane.
        // In most cases, this means every transition gets its own lane, until we
        // run out of lanes and cycle back to the beginning.
        var lane = nextTransitionLane;
        nextTransitionLane <<= 1;
        if ((nextTransitionLane & TransitionLanes) === NoLanes) nextTransitionLane = TransitionLane1;
        return lane;
    }
    function claimNextRetryLane() {
        var lane = nextRetryLane;
        nextRetryLane <<= 1;
        if ((nextRetryLane & RetryLanes) === NoLanes) nextRetryLane = RetryLane1;
        return lane;
    }
    function getHighestPriorityLane(lanes) {
        return lanes & -lanes;
    }
    function pickArbitraryLane(lanes) {
        // This wrapper function gets inlined. Only exists so to communicate that it
        // doesn't matter which bit is selected; you can pick any bit without
        // affecting the algorithms where its used. Here I'm using
        // getHighestPriorityLane because it requires the fewest operations.
        return getHighestPriorityLane(lanes);
    }
    function pickArbitraryLaneIndex(lanes) {
        return 31 - clz32(lanes);
    }
    function laneToIndex(lane) {
        return pickArbitraryLaneIndex(lane);
    }
    function includesSomeLane(a, b) {
        return (a & b) !== NoLanes;
    }
    function isSubsetOfLanes(set, subset) {
        return (set & subset) === subset;
    }
    function mergeLanes(a, b) {
        return a | b;
    }
    function removeLanes(set, subset) {
        return set & ~subset;
    }
    function intersectLanes(a, b) {
        return a & b;
    } // Seems redundant, but it changes the type from a single lane (used for
    // updates) to a group of lanes (used for flushing work).
    function laneToLanes(lane) {
        return lane;
    }
    function higherPriorityLane(a, b) {
        // This works because the bit ranges decrease in priority as you go left.
        return a !== NoLane && a < b ? a : b;
    }
    function createLaneMap(initial) {
        // Intentionally pushing one by one.
        // https://v8.dev/blog/elements-kinds#avoid-creating-holes
        var laneMap = [];
        for(var i = 0; i < TotalLanes; i++)laneMap.push(initial);
        return laneMap;
    }
    function markRootUpdated(root, updateLane, eventTime) {
        root.pendingLanes |= updateLane; // If there are any suspended transitions, it's possible this new update
        // could unblock them. Clear the suspended lanes so that we can try rendering
        // them again.
        //
        // TODO: We really only need to unsuspend only lanes that are in the
        // `subtreeLanes` of the updated fiber, or the update lanes of the return
        // path. This would exclude suspended updates in an unrelated sibling tree,
        // since there's no way for this update to unblock it.
        //
        // We don't do this if the incoming update is idle, because we never process
        // idle updates until after all the regular updates have finished; there's no
        // way it could unblock a transition.
        if (updateLane !== IdleLane) {
            root.suspendedLanes = NoLanes;
            root.pingedLanes = NoLanes;
        }
        var eventTimes = root.eventTimes;
        var index = laneToIndex(updateLane); // We can always overwrite an existing timestamp because we prefer the most
        // recent event, and we assume time is monotonically increasing.
        eventTimes[index] = eventTime;
    }
    function markRootSuspended(root, suspendedLanes) {
        root.suspendedLanes |= suspendedLanes;
        root.pingedLanes &= ~suspendedLanes; // The suspended lanes are no longer CPU-bound. Clear their expiration times.
        var expirationTimes = root.expirationTimes;
        var lanes = suspendedLanes;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            expirationTimes[index] = NoTimestamp;
            lanes &= ~lane;
        }
    }
    function markRootPinged(root, pingedLanes, eventTime) {
        root.pingedLanes |= root.suspendedLanes & pingedLanes;
    }
    function markRootFinished(root, remainingLanes) {
        var noLongerPendingLanes = root.pendingLanes & ~remainingLanes;
        root.pendingLanes = remainingLanes; // Let's try everything again
        root.suspendedLanes = NoLanes;
        root.pingedLanes = NoLanes;
        root.expiredLanes &= remainingLanes;
        root.mutableReadLanes &= remainingLanes;
        root.entangledLanes &= remainingLanes;
        var entanglements = root.entanglements;
        var eventTimes = root.eventTimes;
        var expirationTimes = root.expirationTimes; // Clear the lanes that no longer have pending work
        var lanes = noLongerPendingLanes;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            entanglements[index] = NoLanes;
            eventTimes[index] = NoTimestamp;
            expirationTimes[index] = NoTimestamp;
            lanes &= ~lane;
        }
    }
    function markRootEntangled(root, entangledLanes) {
        // In addition to entangling each of the given lanes with each other, we also
        // have to consider _transitive_ entanglements. For each lane that is already
        // entangled with *any* of the given lanes, that lane is now transitively
        // entangled with *all* the given lanes.
        //
        // Translated: If C is entangled with A, then entangling A with B also
        // entangles C with B.
        //
        // If this is hard to grasp, it might help to intentionally break this
        // function and look at the tests that fail in ReactTransition-test.js. Try
        // commenting out one of the conditions below.
        var rootEntangledLanes = root.entangledLanes |= entangledLanes;
        var entanglements = root.entanglements;
        var lanes = rootEntangledLanes;
        while(lanes){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            if (lane & entangledLanes | // Is this lane transitively entangled with the newly entangled lanes?
            entanglements[index] & entangledLanes) entanglements[index] |= entangledLanes;
            lanes &= ~lane;
        }
    }
    function getBumpedLaneForHydration(root, renderLanes) {
        var renderLane = getHighestPriorityLane(renderLanes);
        var lane;
        switch(renderLane){
            case InputContinuousLane:
                lane = InputContinuousHydrationLane;
                break;
            case DefaultLane:
                lane = DefaultHydrationLane;
                break;
            case TransitionLane1:
            case TransitionLane2:
            case TransitionLane3:
            case TransitionLane4:
            case TransitionLane5:
            case TransitionLane6:
            case TransitionLane7:
            case TransitionLane8:
            case TransitionLane9:
            case TransitionLane10:
            case TransitionLane11:
            case TransitionLane12:
            case TransitionLane13:
            case TransitionLane14:
            case TransitionLane15:
            case TransitionLane16:
            case RetryLane1:
            case RetryLane2:
            case RetryLane3:
            case RetryLane4:
            case RetryLane5:
                lane = TransitionHydrationLane;
                break;
            case IdleLane:
                lane = IdleHydrationLane;
                break;
            default:
                // Everything else is already either a hydration lane, or shouldn't
                // be retried at a hydration lane.
                lane = NoLane;
                break;
        } // Check if the lane we chose is suspended. If so, that indicates that we
        // already attempted and failed to hydrate at that level. Also check if we're
        // already rendering that lane, which is rare but could happen.
        if ((lane & (root.suspendedLanes | renderLanes)) !== NoLane) // Give up trying to hydrate and fall back to client render.
        return NoLane;
        return lane;
    }
    function addFiberToLanesMap(root, fiber, lanes) {
        if (!isDevToolsPresent) return;
        var pendingUpdatersLaneMap = root.pendingUpdatersLaneMap;
        while(lanes > 0){
            var index = laneToIndex(lanes);
            var lane = 1 << index;
            var updaters = pendingUpdatersLaneMap[index];
            updaters.add(fiber);
            lanes &= ~lane;
        }
    }
    function movePendingFibersToMemoized(root, lanes) {
        if (!isDevToolsPresent) return;
        var pendingUpdatersLaneMap = root.pendingUpdatersLaneMap;
        var memoizedUpdaters = root.memoizedUpdaters;
        while(lanes > 0){
            var index = laneToIndex(lanes);
            var lane = 1 << index;
            var updaters = pendingUpdatersLaneMap[index];
            if (updaters.size > 0) {
                updaters.forEach(function(fiber) {
                    var alternate = fiber.alternate;
                    if (alternate === null || !memoizedUpdaters.has(alternate)) memoizedUpdaters.add(fiber);
                });
                updaters.clear();
            }
            lanes &= ~lane;
        }
    }
    function getTransitionsForLanes(root, lanes) {
        return null;
    }
    var DiscreteEventPriority = SyncLane;
    var ContinuousEventPriority = InputContinuousLane;
    var DefaultEventPriority = DefaultLane;
    var IdleEventPriority = IdleLane;
    var currentUpdatePriority = NoLane;
    function getCurrentUpdatePriority() {
        return currentUpdatePriority;
    }
    function setCurrentUpdatePriority(newPriority) {
        currentUpdatePriority = newPriority;
    }
    function runWithPriority(priority, fn) {
        var previousPriority = currentUpdatePriority;
        try {
            currentUpdatePriority = priority;
            return fn();
        } finally{
            currentUpdatePriority = previousPriority;
        }
    }
    function higherEventPriority(a, b) {
        return a !== 0 && a < b ? a : b;
    }
    function lowerEventPriority(a, b) {
        return a === 0 || a > b ? a : b;
    }
    function isHigherEventPriority(a, b) {
        return a !== 0 && a < b;
    }
    function lanesToEventPriority(lanes) {
        var lane = getHighestPriorityLane(lanes);
        if (!isHigherEventPriority(DiscreteEventPriority, lane)) return DiscreteEventPriority;
        if (!isHigherEventPriority(ContinuousEventPriority, lane)) return ContinuousEventPriority;
        if (includesNonIdleWork(lane)) return DefaultEventPriority;
        return IdleEventPriority;
    }
    // This is imported by the event replaying implementation in React DOM. It's
    // in a separate file to break a circular dependency between the renderer and
    // the reconciler.
    function isRootDehydrated(root) {
        var currentState = root.current.memoizedState;
        return currentState.isDehydrated;
    }
    var _attemptSynchronousHydration;
    function setAttemptSynchronousHydration(fn) {
        _attemptSynchronousHydration = fn;
    }
    function attemptSynchronousHydration(fiber) {
        _attemptSynchronousHydration(fiber);
    }
    var attemptContinuousHydration;
    function setAttemptContinuousHydration(fn) {
        attemptContinuousHydration = fn;
    }
    var attemptHydrationAtCurrentPriority;
    function setAttemptHydrationAtCurrentPriority(fn) {
        attemptHydrationAtCurrentPriority = fn;
    }
    var getCurrentUpdatePriority$1;
    function setGetCurrentUpdatePriority(fn) {
        getCurrentUpdatePriority$1 = fn;
    }
    var attemptHydrationAtPriority;
    function setAttemptHydrationAtPriority(fn) {
        attemptHydrationAtPriority = fn;
    } // TODO: Upgrade this definition once we're on a newer version of Flow that
    // has this definition built-in.
    var hasScheduledReplayAttempt = false; // The queue of discrete events to be replayed.
    var queuedDiscreteEvents = []; // Indicates if any continuous event targets are non-null for early bailout.
    // if the last target was dehydrated.
    var queuedFocus = null;
    var queuedDrag = null;
    var queuedMouse = null; // For pointer events there can be one latest event per pointerId.
    var queuedPointers = new Map();
    var queuedPointerCaptures = new Map(); // We could consider replaying selectionchange and touchmoves too.
    var queuedExplicitHydrationTargets = [];
    var discreteReplayableEvents = [
        'mousedown',
        'mouseup',
        'touchcancel',
        'touchend',
        'touchstart',
        'auxclick',
        'dblclick',
        'pointercancel',
        'pointerdown',
        'pointerup',
        'dragend',
        'dragstart',
        'drop',
        'compositionend',
        'compositionstart',
        'keydown',
        'keypress',
        'keyup',
        'input',
        'textInput',
        'copy',
        'cut',
        'paste',
        'click',
        'change',
        'contextmenu',
        'reset',
        'submit'
    ];
    function isDiscreteEventThatRequiresHydration(eventType) {
        return discreteReplayableEvents.indexOf(eventType) > -1;
    }
    function createQueuedReplayableEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        return {
            blockedOn: blockedOn,
            domEventName: domEventName,
            eventSystemFlags: eventSystemFlags,
            nativeEvent: nativeEvent,
            targetContainers: [
                targetContainer
            ]
        };
    }
    function clearIfContinuousEvent(domEventName, nativeEvent) {
        switch(domEventName){
            case 'focusin':
            case 'focusout':
                queuedFocus = null;
                break;
            case 'dragenter':
            case 'dragleave':
                queuedDrag = null;
                break;
            case 'mouseover':
            case 'mouseout':
                queuedMouse = null;
                break;
            case 'pointerover':
            case 'pointerout':
                var pointerId = nativeEvent.pointerId;
                queuedPointers.delete(pointerId);
                break;
            case 'gotpointercapture':
            case 'lostpointercapture':
                var _pointerId = nativeEvent.pointerId;
                queuedPointerCaptures.delete(_pointerId);
                break;
        }
    }
    function accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        if (existingQueuedEvent === null || existingQueuedEvent.nativeEvent !== nativeEvent) {
            var queuedEvent = createQueuedReplayableEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent);
            if (blockedOn !== null) {
                var _fiber2 = getInstanceFromNode(blockedOn);
                if (_fiber2 !== null) // Attempt to increase the priority of this target.
                attemptContinuousHydration(_fiber2);
            }
            return queuedEvent;
        } // If we have already queued this exact event, then it's because
        // the different event systems have different DOM event listeners.
        // We can accumulate the flags, and the targetContainers, and
        // store a single event to be replayed.
        existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
        var targetContainers = existingQueuedEvent.targetContainers;
        if (targetContainer !== null && targetContainers.indexOf(targetContainer) === -1) targetContainers.push(targetContainer);
        return existingQueuedEvent;
    }
    function queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        // These set relatedTarget to null because the replayed event will be treated as if we
        // moved from outside the window (no target) onto the target once it hydrates.
        // Instead of mutating we could clone the event.
        switch(domEventName){
            case 'focusin':
                var focusEvent = nativeEvent;
                queuedFocus = accumulateOrCreateContinuousQueuedReplayableEvent(queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, focusEvent);
                return true;
            case 'dragenter':
                var dragEvent = nativeEvent;
                queuedDrag = accumulateOrCreateContinuousQueuedReplayableEvent(queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, dragEvent);
                return true;
            case 'mouseover':
                var mouseEvent = nativeEvent;
                queuedMouse = accumulateOrCreateContinuousQueuedReplayableEvent(queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, mouseEvent);
                return true;
            case 'pointerover':
                var pointerEvent = nativeEvent;
                var pointerId = pointerEvent.pointerId;
                queuedPointers.set(pointerId, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, pointerEvent));
                return true;
            case 'gotpointercapture':
                var _pointerEvent = nativeEvent;
                var _pointerId2 = _pointerEvent.pointerId;
                queuedPointerCaptures.set(_pointerId2, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointerCaptures.get(_pointerId2) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, _pointerEvent));
                return true;
        }
        return false;
    } // Check if this target is unblocked. Returns true if it's unblocked.
    function attemptExplicitHydrationTarget(queuedTarget) {
        // TODO: This function shares a lot of logic with findInstanceBlockingEvent.
        // Try to unify them. It's a bit tricky since it would require two return
        // values.
        var targetInst = getClosestInstanceFromNode(queuedTarget.target);
        if (targetInst !== null) {
            var nearestMounted = getNearestMountedFiber(targetInst);
            if (nearestMounted !== null) {
                var tag = nearestMounted.tag;
                if (tag === SuspenseComponent) {
                    var instance = getSuspenseInstanceFromFiber(nearestMounted);
                    if (instance !== null) {
                        // We're blocked on hydrating this boundary.
                        // Increase its priority.
                        queuedTarget.blockedOn = instance;
                        attemptHydrationAtPriority(queuedTarget.priority, function() {
                            attemptHydrationAtCurrentPriority(nearestMounted);
                        });
                        return;
                    }
                } else if (tag === HostRoot) {
                    var root = nearestMounted.stateNode;
                    if (isRootDehydrated(root)) {
                        queuedTarget.blockedOn = getContainerFromFiber(nearestMounted); // We don't currently have a way to increase the priority of
                        // a root other than sync.
                        return;
                    }
                }
            }
        }
        queuedTarget.blockedOn = null;
    }
    function queueExplicitHydrationTarget(target) {
        // TODO: This will read the priority if it's dispatched by the React
        // event system but not native events. Should read window.event.type, like
        // we do for updates (getCurrentEventPriority).
        var updatePriority = getCurrentUpdatePriority$1();
        var queuedTarget = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        var i = 0;
        for(; i < queuedExplicitHydrationTargets.length; i++){
            // Stop once we hit the first target with lower priority than
            if (!isHigherEventPriority(updatePriority, queuedExplicitHydrationTargets[i].priority)) break;
        }
        queuedExplicitHydrationTargets.splice(i, 0, queuedTarget);
        if (i === 0) attemptExplicitHydrationTarget(queuedTarget);
    }
    function attemptReplayContinuousQueuedEvent(queuedEvent) {
        if (queuedEvent.blockedOn !== null) return false;
        var targetContainers = queuedEvent.targetContainers;
        while(targetContainers.length > 0){
            var targetContainer = targetContainers[0];
            var nextBlockedOn = findInstanceBlockingEvent(queuedEvent.domEventName, queuedEvent.eventSystemFlags, targetContainer, queuedEvent.nativeEvent);
            if (nextBlockedOn === null) {
                var nativeEvent = queuedEvent.nativeEvent;
                var nativeEventClone = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                setReplayingEvent(nativeEventClone);
                nativeEvent.target.dispatchEvent(nativeEventClone);
                resetReplayingEvent();
            } else {
                // We're still blocked. Try again later.
                var _fiber3 = getInstanceFromNode(nextBlockedOn);
                if (_fiber3 !== null) attemptContinuousHydration(_fiber3);
                queuedEvent.blockedOn = nextBlockedOn;
                return false;
            } // This target container was successfully dispatched. Try the next.
            targetContainers.shift();
        }
        return true;
    }
    function attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
        if (attemptReplayContinuousQueuedEvent(queuedEvent)) map.delete(key);
    }
    function replayUnblockedEvents() {
        hasScheduledReplayAttempt = false;
        if (queuedFocus !== null && attemptReplayContinuousQueuedEvent(queuedFocus)) queuedFocus = null;
        if (queuedDrag !== null && attemptReplayContinuousQueuedEvent(queuedDrag)) queuedDrag = null;
        if (queuedMouse !== null && attemptReplayContinuousQueuedEvent(queuedMouse)) queuedMouse = null;
        queuedPointers.forEach(attemptReplayContinuousQueuedEventInMap);
        queuedPointerCaptures.forEach(attemptReplayContinuousQueuedEventInMap);
    }
    function scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
        if (queuedEvent.blockedOn === unblocked) {
            queuedEvent.blockedOn = null;
            if (!hasScheduledReplayAttempt) {
                hasScheduledReplayAttempt = true; // Schedule a callback to attempt replaying as many events as are
                // now unblocked. This first might not actually be unblocked yet.
                // We could check it early to avoid scheduling an unnecessary callback.
                Scheduler.unstable_scheduleCallback(Scheduler.unstable_NormalPriority, replayUnblockedEvents);
            }
        }
    }
    function retryIfBlockedOn(unblocked) {
        // Mark anything that was blocked on this as no longer blocked
        // and eligible for a replay.
        if (queuedDiscreteEvents.length > 0) {
            scheduleCallbackIfUnblocked(queuedDiscreteEvents[0], unblocked); // This is a exponential search for each boundary that commits. I think it's
            // worth it because we expect very few discrete events to queue up and once
            // we are actually fully unblocked it will be fast to replay them.
            for(var i = 1; i < queuedDiscreteEvents.length; i++){
                var queuedEvent = queuedDiscreteEvents[i];
                if (queuedEvent.blockedOn === unblocked) queuedEvent.blockedOn = null;
            }
        }
        if (queuedFocus !== null) scheduleCallbackIfUnblocked(queuedFocus, unblocked);
        if (queuedDrag !== null) scheduleCallbackIfUnblocked(queuedDrag, unblocked);
        if (queuedMouse !== null) scheduleCallbackIfUnblocked(queuedMouse, unblocked);
        var unblock = function unblock(queuedEvent) {
            return scheduleCallbackIfUnblocked(queuedEvent, unblocked);
        };
        queuedPointers.forEach(unblock);
        queuedPointerCaptures.forEach(unblock);
        for(var _i = 0; _i < queuedExplicitHydrationTargets.length; _i++){
            var queuedTarget = queuedExplicitHydrationTargets[_i];
            if (queuedTarget.blockedOn === unblocked) queuedTarget.blockedOn = null;
        }
        while(queuedExplicitHydrationTargets.length > 0){
            var nextExplicitTarget = queuedExplicitHydrationTargets[0];
            if (nextExplicitTarget.blockedOn !== null) break;
            else {
                attemptExplicitHydrationTarget(nextExplicitTarget);
                if (nextExplicitTarget.blockedOn === null) // We're unblocked.
                queuedExplicitHydrationTargets.shift();
            }
        }
    }
    var ReactCurrentBatchConfig = ReactSharedInternals.ReactCurrentBatchConfig; // TODO: can we stop exporting these?
    var _enabled = true; // This is exported in FB builds for use by legacy FB layer infra.
    // We'd like to remove this but it's not clear if this is safe.
    function setEnabled(enabled) {
        _enabled = !!enabled;
    }
    function isEnabled() {
        return _enabled;
    }
    function createEventListenerWrapperWithPriority(targetContainer, domEventName, eventSystemFlags) {
        var eventPriority = getEventPriority(domEventName);
        var listenerWrapper;
        switch(eventPriority){
            case DiscreteEventPriority:
                listenerWrapper = dispatchDiscreteEvent;
                break;
            case ContinuousEventPriority:
                listenerWrapper = dispatchContinuousEvent;
                break;
            case DefaultEventPriority:
            default:
                listenerWrapper = dispatchEvent;
                break;
        }
        return listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    }
    function dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
        var previousPriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig.transition;
        ReactCurrentBatchConfig.transition = null;
        try {
            setCurrentUpdatePriority(DiscreteEventPriority);
            dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig.transition = prevTransition;
        }
    }
    function dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
        var previousPriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig.transition;
        ReactCurrentBatchConfig.transition = null;
        try {
            setCurrentUpdatePriority(ContinuousEventPriority);
            dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig.transition = prevTransition;
        }
    }
    function dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        if (!_enabled) return;
        dispatchEventWithEnableCapturePhaseSelectiveHydrationWithoutDiscreteEventReplay(domEventName, eventSystemFlags, targetContainer, nativeEvent);
    }
    function dispatchEventWithEnableCapturePhaseSelectiveHydrationWithoutDiscreteEventReplay(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        var blockedOn = findInstanceBlockingEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent);
        if (blockedOn === null) {
            dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, return_targetInst, targetContainer);
            clearIfContinuousEvent(domEventName, nativeEvent);
            return;
        }
        if (queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) {
            nativeEvent.stopPropagation();
            return;
        } // We need to clear only if we didn't queue because
        // queueing is accumulative.
        clearIfContinuousEvent(domEventName, nativeEvent);
        if (eventSystemFlags & IS_CAPTURE_PHASE && isDiscreteEventThatRequiresHydration(domEventName)) {
            while(blockedOn !== null){
                var fiber = getInstanceFromNode(blockedOn);
                if (fiber !== null) attemptSynchronousHydration(fiber);
                var nextBlockedOn = findInstanceBlockingEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent);
                if (nextBlockedOn === null) dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, return_targetInst, targetContainer);
                if (nextBlockedOn === blockedOn) break;
                blockedOn = nextBlockedOn;
            }
            if (blockedOn !== null) nativeEvent.stopPropagation();
            return;
        } // This is not replayable so we'll invoke it but without a target,
        // in case the event system needs to trace it.
        dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
    var return_targetInst = null; // Returns a SuspenseInstance or Container if it's blocked.
    // The return_targetInst field above is conceptually part of the return value.
    function findInstanceBlockingEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        // TODO: Warn if _enabled is false.
        return_targetInst = null;
        var nativeEventTarget = getEventTarget(nativeEvent);
        var targetInst = getClosestInstanceFromNode(nativeEventTarget);
        if (targetInst !== null) {
            var nearestMounted = getNearestMountedFiber(targetInst);
            if (nearestMounted === null) // This tree has been unmounted already. Dispatch without a target.
            targetInst = null;
            else {
                var tag = nearestMounted.tag;
                if (tag === SuspenseComponent) {
                    var instance = getSuspenseInstanceFromFiber(nearestMounted);
                    if (instance !== null) // Queue the event to be replayed later. Abort dispatching since we
                    // don't want this event dispatched twice through the event system.
                    // TODO: If this is the first discrete event in the queue. Schedule an increased
                    // priority for this boundary.
                    return instance;
                     // This shouldn't happen, something went wrong but to avoid blocking
                    // the whole system, dispatch the event without a target.
                    // TODO: Warn.
                    targetInst = null;
                } else if (tag === HostRoot) {
                    var root = nearestMounted.stateNode;
                    if (isRootDehydrated(root)) // If this happens during a replay something went wrong and it might block
                    // the whole system.
                    return getContainerFromFiber(nearestMounted);
                    targetInst = null;
                } else if (nearestMounted !== targetInst) // If we get an event (ex: img onload) before committing that
                // component's mount, ignore it for now (that is, treat it as if it was an
                // event on a non-React tree). We might also consider queueing events and
                // dispatching them after the mount.
                targetInst = null;
            }
        }
        return_targetInst = targetInst; // We're not blocked on anything.
        return null;
    }
    function getEventPriority(domEventName) {
        switch(domEventName){
            // Used by SimpleEventPlugin:
            case 'cancel':
            case 'click':
            case 'close':
            case 'contextmenu':
            case 'copy':
            case 'cut':
            case 'auxclick':
            case 'dblclick':
            case 'dragend':
            case 'dragstart':
            case 'drop':
            case 'focusin':
            case 'focusout':
            case 'input':
            case 'invalid':
            case 'keydown':
            case 'keypress':
            case 'keyup':
            case 'mousedown':
            case 'mouseup':
            case 'paste':
            case 'pause':
            case 'play':
            case 'pointercancel':
            case 'pointerdown':
            case 'pointerup':
            case 'ratechange':
            case 'reset':
            case 'resize':
            case 'seeked':
            case 'submit':
            case 'touchcancel':
            case 'touchend':
            case 'touchstart':
            case 'volumechange':
            // eslint-disable-next-line no-fallthrough
            case 'change':
            case 'selectionchange':
            case 'textInput':
            case 'compositionstart':
            case 'compositionend':
            case 'compositionupdate':
            // eslint-disable-next-line no-fallthrough
            case 'beforeblur':
            case 'afterblur':
            // eslint-disable-next-line no-fallthrough
            case 'beforeinput':
            case 'blur':
            case 'fullscreenchange':
            case 'focus':
            case 'hashchange':
            case 'popstate':
            case 'select':
            case 'selectstart':
                return DiscreteEventPriority;
            case 'drag':
            case 'dragenter':
            case 'dragexit':
            case 'dragleave':
            case 'dragover':
            case 'mousemove':
            case 'mouseout':
            case 'mouseover':
            case 'pointermove':
            case 'pointerout':
            case 'pointerover':
            case 'scroll':
            case 'toggle':
            case 'touchmove':
            case 'wheel':
            // eslint-disable-next-line no-fallthrough
            case 'mouseenter':
            case 'mouseleave':
            case 'pointerenter':
            case 'pointerleave':
                return ContinuousEventPriority;
            case 'message':
                // We might be in the Scheduler callback.
                // Eventually this mechanism will be replaced by a check
                // of the current priority on the native scheduler.
                var schedulerPriority = getCurrentPriorityLevel();
                switch(schedulerPriority){
                    case ImmediatePriority:
                        return DiscreteEventPriority;
                    case UserBlockingPriority:
                        return ContinuousEventPriority;
                    case NormalPriority:
                    case LowPriority:
                        // TODO: Handle LowSchedulerPriority, somehow. Maybe the same lane as hydration.
                        return DefaultEventPriority;
                    case IdlePriority:
                        return IdleEventPriority;
                    default:
                        return DefaultEventPriority;
                }
            default:
                return DefaultEventPriority;
        }
    }
    function addEventBubbleListener(target, eventType, listener) {
        target.addEventListener(eventType, listener, false);
        return listener;
    }
    function addEventCaptureListener(target, eventType, listener) {
        target.addEventListener(eventType, listener, true);
        return listener;
    }
    function addEventCaptureListenerWithPassiveFlag(target, eventType, listener, passive) {
        target.addEventListener(eventType, listener, {
            capture: true,
            passive: passive
        });
        return listener;
    }
    function addEventBubbleListenerWithPassiveFlag(target, eventType, listener, passive) {
        target.addEventListener(eventType, listener, {
            passive: passive
        });
        return listener;
    }
    /**
 * These variables store information about text content of a target node,
 * allowing comparison of content before and after a given event.
 *
 * Identify the node where selection currently begins, then observe
 * both its text content and its current position in the DOM. Since the
 * browser may natively replace the target node during composition, we can
 * use its position to find its replacement.
 *
 *
 */ var root = null;
    var startText = null;
    var fallbackText = null;
    function initialize(nativeEventTarget) {
        root = nativeEventTarget;
        startText = getText();
        return true;
    }
    function reset() {
        root = null;
        startText = null;
        fallbackText = null;
    }
    function getData() {
        if (fallbackText) return fallbackText;
        var start;
        var startValue = startText;
        var startLength = startValue.length;
        var end;
        var endValue = getText();
        var endLength = endValue.length;
        for(start = 0; start < startLength; start++){
            if (startValue[start] !== endValue[start]) break;
        }
        var minEnd = startLength - start;
        for(end = 1; end <= minEnd; end++){
            if (startValue[startLength - end] !== endValue[endLength - end]) break;
        }
        var sliceTail = end > 1 ? 1 - end : undefined;
        fallbackText = endValue.slice(start, sliceTail);
        return fallbackText;
    }
    function getText() {
        if ('value' in root) return root.value;
        return root.textContent;
    }
    /**
 * `charCode` represents the actual "character code" and is safe to use with
 * `String.fromCharCode`. As such, only keys that correspond to printable
 * characters produce a valid `charCode`, the only exception to this is Enter.
 * The Tab-key is considered non-printable and does not have a `charCode`,
 * presumably because it does not produce a tab-character in browsers.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {number} Normalized `charCode` property.
 */ function getEventCharCode(nativeEvent) {
        var charCode;
        var keyCode = nativeEvent.keyCode;
        if ('charCode' in nativeEvent) {
            charCode = nativeEvent.charCode; // FF does not set `charCode` for the Enter-key, check against `keyCode`.
            if (charCode === 0 && keyCode === 13) charCode = 13;
        } else // IE8 does not implement `charCode`, but `keyCode` has the correct value.
        charCode = keyCode;
         // IE and Edge (on Windows) and Chrome / Safari (on Windows and Linux)
        // report Enter as charCode 10 when ctrl is pressed.
        if (charCode === 10) charCode = 13;
         // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
        // Must not discard the (non-)printable Enter-key.
        if (charCode >= 32 || charCode === 13) return charCode;
        return 0;
    }
    function functionThatReturnsTrue() {
        return true;
    }
    function functionThatReturnsFalse() {
        return false;
    } // This is intentionally a factory so that we have different returned constructors.
    // If we had a single constructor, it would be megamorphic and engines would deopt.
    function createSyntheticEvent(Interface) {
        /**
   * Synthetic events are dispatched by event plugins, typically in response to a
   * top-level event delegation handler.
   *
   * These systems should generally use pooling to reduce the frequency of garbage
   * collection. The system should check `isPersistent` to determine whether the
   * event should be released into the pool after being dispatched. Users that
   * need a persisted event should invoke `persist`.
   *
   * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
   * normalizing browser quirks. Subclasses do not necessarily have to implement a
   * DOM interface; custom application-specific events can also subclass this.
   */ function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
            this._reactName = reactName;
            this._targetInst = targetInst;
            this.type = reactEventType;
            this.nativeEvent = nativeEvent;
            this.target = nativeEventTarget;
            this.currentTarget = null;
            for(var _propName in Interface){
                if (!Interface.hasOwnProperty(_propName)) continue;
                var normalize = Interface[_propName];
                if (normalize) this[_propName] = normalize(nativeEvent);
                else this[_propName] = nativeEvent[_propName];
            }
            var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
            if (defaultPrevented) this.isDefaultPrevented = functionThatReturnsTrue;
            else this.isDefaultPrevented = functionThatReturnsFalse;
            this.isPropagationStopped = functionThatReturnsFalse;
            return this;
        }
        assign(SyntheticBaseEvent.prototype, {
            preventDefault: function preventDefault() {
                this.defaultPrevented = true;
                var event = this.nativeEvent;
                if (!event) return;
                if (event.preventDefault) event.preventDefault(); // $FlowFixMe - flow is not aware of `unknown` in IE
                else if (typeof event.returnValue !== 'unknown') event.returnValue = false;
                this.isDefaultPrevented = functionThatReturnsTrue;
            },
            stopPropagation: function stopPropagation() {
                var event = this.nativeEvent;
                if (!event) return;
                if (event.stopPropagation) event.stopPropagation(); // $FlowFixMe - flow is not aware of `unknown` in IE
                else if (typeof event.cancelBubble !== 'unknown') // The ChangeEventPlugin registers a "propertychange" event for
                // IE. This event does not support bubbling or cancelling, and
                // any references to cancelBubble throw "Member not found".  A
                // typeof check of "unknown" circumvents this issue (and is also
                // IE specific).
                event.cancelBubble = true;
                this.isPropagationStopped = functionThatReturnsTrue;
            },
            /**
     * We release all dispatched `SyntheticEvent`s after each event loop, adding
     * them back into the pool. This allows a way to hold onto a reference that
     * won't be added back into the pool.
     */ persist: function persist() {},
            /**
     * Checks if this event should be released back into the pool.
     *
     * @return {boolean} True if this should not be released, false otherwise.
     */ isPersistent: functionThatReturnsTrue
        });
        return SyntheticBaseEvent;
    }
    /**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var EventInterface = {
        eventPhase: 0,
        bubbles: 0,
        cancelable: 0,
        timeStamp: function timeStamp(event) {
            return event.timeStamp || Date.now();
        },
        defaultPrevented: 0,
        isTrusted: 0
    };
    var SyntheticEvent = createSyntheticEvent(EventInterface);
    var UIEventInterface = assign({}, EventInterface, {
        view: 0,
        detail: 0
    });
    var SyntheticUIEvent = createSyntheticEvent(UIEventInterface);
    var lastMovementX;
    var lastMovementY;
    var lastMouseEvent;
    function updateMouseMovementPolyfillState(event) {
        if (event !== lastMouseEvent) {
            if (lastMouseEvent && event.type === 'mousemove') {
                lastMovementX = event.screenX - lastMouseEvent.screenX;
                lastMovementY = event.screenY - lastMouseEvent.screenY;
            } else {
                lastMovementX = 0;
                lastMovementY = 0;
            }
            lastMouseEvent = event;
        }
    }
    /**
 * @interface MouseEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var MouseEventInterface = assign({}, UIEventInterface, {
        screenX: 0,
        screenY: 0,
        clientX: 0,
        clientY: 0,
        pageX: 0,
        pageY: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        getModifierState: getEventModifierState,
        button: 0,
        buttons: 0,
        relatedTarget: function relatedTarget(event) {
            if (event.relatedTarget === undefined) return event.fromElement === event.srcElement ? event.toElement : event.fromElement;
            return event.relatedTarget;
        },
        movementX: function movementX(event) {
            if ('movementX' in event) return event.movementX;
            updateMouseMovementPolyfillState(event);
            return lastMovementX;
        },
        movementY: function movementY(event) {
            if ('movementY' in event) return event.movementY;
             // Don't need to call updateMouseMovementPolyfillState() here
            // because it's guaranteed to have already run when movementX
            // was copied.
            return lastMovementY;
        }
    });
    var SyntheticMouseEvent = createSyntheticEvent(MouseEventInterface);
    /**
 * @interface DragEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var DragEventInterface = assign({}, MouseEventInterface, {
        dataTransfer: 0
    });
    var SyntheticDragEvent = createSyntheticEvent(DragEventInterface);
    /**
 * @interface FocusEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var FocusEventInterface = assign({}, UIEventInterface, {
        relatedTarget: 0
    });
    var SyntheticFocusEvent = createSyntheticEvent(FocusEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
 */ var AnimationEventInterface = assign({}, EventInterface, {
        animationName: 0,
        elapsedTime: 0,
        pseudoElement: 0
    });
    var SyntheticAnimationEvent = createSyntheticEvent(AnimationEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/clipboard-apis/
 */ var ClipboardEventInterface = assign({}, EventInterface, {
        clipboardData: function clipboardData(event) {
            return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
        }
    });
    var SyntheticClipboardEvent = createSyntheticEvent(ClipboardEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
 */ var CompositionEventInterface = assign({}, EventInterface, {
        data: 0
    });
    var SyntheticCompositionEvent = createSyntheticEvent(CompositionEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
 *      /#events-inputevents
 */ // Happens to share the same list for now.
    var SyntheticInputEvent = SyntheticCompositionEvent;
    /**
 * Normalization of deprecated HTML5 `key` values
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */ var normalizeKey = {
        Esc: 'Escape',
        Spacebar: ' ',
        Left: 'ArrowLeft',
        Up: 'ArrowUp',
        Right: 'ArrowRight',
        Down: 'ArrowDown',
        Del: 'Delete',
        Win: 'OS',
        Menu: 'ContextMenu',
        Apps: 'ContextMenu',
        Scroll: 'ScrollLock',
        MozPrintableKey: 'Unidentified'
    };
    /**
 * Translation from legacy `keyCode` to HTML5 `key`
 * Only special keys supported, all others depend on keyboard layout or browser
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */ var translateToKey = {
        '8': 'Backspace',
        '9': 'Tab',
        '12': 'Clear',
        '13': 'Enter',
        '16': 'Shift',
        '17': 'Control',
        '18': 'Alt',
        '19': 'Pause',
        '20': 'CapsLock',
        '27': 'Escape',
        '32': ' ',
        '33': 'PageUp',
        '34': 'PageDown',
        '35': 'End',
        '36': 'Home',
        '37': 'ArrowLeft',
        '38': 'ArrowUp',
        '39': 'ArrowRight',
        '40': 'ArrowDown',
        '45': 'Insert',
        '46': 'Delete',
        '112': 'F1',
        '113': 'F2',
        '114': 'F3',
        '115': 'F4',
        '116': 'F5',
        '117': 'F6',
        '118': 'F7',
        '119': 'F8',
        '120': 'F9',
        '121': 'F10',
        '122': 'F11',
        '123': 'F12',
        '144': 'NumLock',
        '145': 'ScrollLock',
        '224': 'Meta'
    };
    /**
 * @param {object} nativeEvent Native browser event.
 * @return {string} Normalized `key` property.
 */ function getEventKey(nativeEvent) {
        if (nativeEvent.key) {
            // Normalize inconsistent values reported by browsers due to
            // implementations of a working draft specification.
            // FireFox implements `key` but returns `MozPrintableKey` for all
            // printable characters (normalized to `Unidentified`), ignore it.
            var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
            if (key !== 'Unidentified') return key;
        } // Browser does not implement `key`, polyfill as much of it as we can.
        if (nativeEvent.type === 'keypress') {
            var charCode = getEventCharCode(nativeEvent); // The enter-key is technically both printable and non-printable and can
            // thus be captured by `keypress`, no other non-printable key should.
            return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
        }
        if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') // While user keyboard layout determines the actual meaning of each
        // `keyCode` value, almost all function keys have a universal value.
        return translateToKey[nativeEvent.keyCode] || 'Unidentified';
        return '';
    }
    /**
 * Translation from modifier key to the associated property in the event.
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
 */ var modifierKeyToProp = {
        Alt: 'altKey',
        Control: 'ctrlKey',
        Meta: 'metaKey',
        Shift: 'shiftKey'
    }; // Older browsers (Safari <= 10, iOS Safari <= 10.2) do not support
    // getModifierState. If getModifierState is not supported, we map it to a set of
    // modifier keys exposed by the event. In this case, Lock-keys are not supported.
    function modifierStateGetter(keyArg) {
        var syntheticEvent = this;
        var nativeEvent = syntheticEvent.nativeEvent;
        if (nativeEvent.getModifierState) return nativeEvent.getModifierState(keyArg);
        var keyProp = modifierKeyToProp[keyArg];
        return keyProp ? !!nativeEvent[keyProp] : false;
    }
    function getEventModifierState(nativeEvent) {
        return modifierStateGetter;
    }
    /**
 * @interface KeyboardEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var KeyboardEventInterface = assign({}, UIEventInterface, {
        key: getEventKey,
        code: 0,
        location: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        repeat: 0,
        locale: 0,
        getModifierState: getEventModifierState,
        // Legacy Interface
        charCode: function charCode(event) {
            // `charCode` is the result of a KeyPress event and represents the value of
            // the actual printable character.
            // KeyPress is deprecated, but its replacement is not yet final and not
            // implemented in any major browser. Only KeyPress has charCode.
            if (event.type === 'keypress') return getEventCharCode(event);
            return 0;
        },
        keyCode: function keyCode(event) {
            // `keyCode` is the result of a KeyDown/Up event and represents the value of
            // physical keyboard key.
            // The actual meaning of the value depends on the users' keyboard layout
            // which cannot be detected. Assuming that it is a US keyboard layout
            // provides a surprisingly accurate mapping for US and European users.
            // Due to this, it is left to the user to implement at this time.
            if (event.type === 'keydown' || event.type === 'keyup') return event.keyCode;
            return 0;
        },
        which: function which(event) {
            // `which` is an alias for either `keyCode` or `charCode` depending on the
            // type of the event.
            if (event.type === 'keypress') return getEventCharCode(event);
            if (event.type === 'keydown' || event.type === 'keyup') return event.keyCode;
            return 0;
        }
    });
    var SyntheticKeyboardEvent = createSyntheticEvent(KeyboardEventInterface);
    /**
 * @interface PointerEvent
 * @see http://www.w3.org/TR/pointerevents/
 */ var PointerEventInterface = assign({}, MouseEventInterface, {
        pointerId: 0,
        width: 0,
        height: 0,
        pressure: 0,
        tangentialPressure: 0,
        tiltX: 0,
        tiltY: 0,
        twist: 0,
        pointerType: 0,
        isPrimary: 0
    });
    var SyntheticPointerEvent = createSyntheticEvent(PointerEventInterface);
    /**
 * @interface TouchEvent
 * @see http://www.w3.org/TR/touch-events/
 */ var TouchEventInterface = assign({}, UIEventInterface, {
        touches: 0,
        targetTouches: 0,
        changedTouches: 0,
        altKey: 0,
        metaKey: 0,
        ctrlKey: 0,
        shiftKey: 0,
        getModifierState: getEventModifierState
    });
    var SyntheticTouchEvent = createSyntheticEvent(TouchEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
 */ var TransitionEventInterface = assign({}, EventInterface, {
        propertyName: 0,
        elapsedTime: 0,
        pseudoElement: 0
    });
    var SyntheticTransitionEvent = createSyntheticEvent(TransitionEventInterface);
    /**
 * @interface WheelEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var WheelEventInterface = assign({}, MouseEventInterface, {
        deltaX: function deltaX(event) {
            return 'deltaX' in event ? event.deltaX : 'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
        },
        deltaY: function deltaY(event) {
            return 'deltaY' in event ? event.deltaY : 'wheelDeltaY' in event ? -event.wheelDeltaY : 'wheelDelta' in event ? -event.wheelDelta : 0;
        },
        deltaZ: 0,
        // Browsers without "deltaMode" is reporting in raw wheel delta where one
        // notch on the scroll is always +/- 120, roughly equivalent to pixels.
        // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
        // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
        deltaMode: 0
    });
    var SyntheticWheelEvent = createSyntheticEvent(WheelEventInterface);
    var END_KEYCODES = [
        9,
        13,
        27,
        32
    ]; // Tab, Return, Esc, Space
    var START_KEYCODE = 229;
    var canUseCompositionEvent = canUseDOM && 'CompositionEvent' in window;
    var documentMode = null;
    if (canUseDOM && 'documentMode' in document) documentMode = document.documentMode;
     // Webkit offers a very useful `textInput` event that can be used to
    // directly represent `beforeInput`. The IE `textinput` event is not as
    // useful, so we don't use it.
    var canUseTextInputEvent = canUseDOM && 'TextEvent' in window && !documentMode; // In IE9+, we have access to composition events, but the data supplied
    // by the native compositionend event may be incorrect. Japanese ideographic
    // spaces, for instance (\u3000) are not recorded correctly.
    var useFallbackCompositionData = canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
    var SPACEBAR_CODE = 32;
    var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
    function registerEvents() {
        registerTwoPhaseEvent('onBeforeInput', [
            'compositionend',
            'keypress',
            'textInput',
            'paste'
        ]);
        registerTwoPhaseEvent('onCompositionEnd', [
            'compositionend',
            'focusout',
            'keydown',
            'keypress',
            'keyup',
            'mousedown'
        ]);
        registerTwoPhaseEvent('onCompositionStart', [
            'compositionstart',
            'focusout',
            'keydown',
            'keypress',
            'keyup',
            'mousedown'
        ]);
        registerTwoPhaseEvent('onCompositionUpdate', [
            'compositionupdate',
            'focusout',
            'keydown',
            'keypress',
            'keyup',
            'mousedown'
        ]);
    } // Track whether we've ever handled a keypress on the space key.
    var hasSpaceKeypress = false;
    /**
 * Return whether a native keypress event is assumed to be a command.
 * This is required because Firefox fires `keypress` events for key commands
 * (cut, copy, select-all, etc.) even though no character is inserted.
 */ function isKeypressCommand(nativeEvent) {
        return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) && // ctrlKey && altKey is equivalent to AltGr, and is not a command.
        !(nativeEvent.ctrlKey && nativeEvent.altKey);
    }
    /**
 * Translate native top level events into event types.
 */ function getCompositionEventType(domEventName) {
        switch(domEventName){
            case 'compositionstart':
                return 'onCompositionStart';
            case 'compositionend':
                return 'onCompositionEnd';
            case 'compositionupdate':
                return 'onCompositionUpdate';
        }
    }
    /**
 * Does our fallback best-guess model think this event signifies that
 * composition has begun?
 */ function isFallbackCompositionStart(domEventName, nativeEvent) {
        return domEventName === 'keydown' && nativeEvent.keyCode === START_KEYCODE;
    }
    /**
 * Does our fallback mode think that this event is the end of composition?
 */ function isFallbackCompositionEnd(domEventName, nativeEvent) {
        switch(domEventName){
            case 'keyup':
                // Command keys insert or clear IME input.
                return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
            case 'keydown':
                // Expect IME keyCode on each keydown. If we get any other
                // code we must have exited earlier.
                return nativeEvent.keyCode !== START_KEYCODE;
            case 'keypress':
            case 'mousedown':
            case 'focusout':
                // Events are not possible without cancelling IME.
                return true;
            default:
                return false;
        }
    }
    /**
 * Google Input Tools provides composition data via a CustomEvent,
 * with the `data` property populated in the `detail` object. If this
 * is available on the event object, use it. If not, this is a plain
 * composition event and we have nothing special to extract.
 *
 * @param {object} nativeEvent
 * @return {?string}
 */ function getDataFromCustomEvent(nativeEvent) {
        var detail = nativeEvent.detail;
        if (typeof detail === 'object' && 'data' in detail) return detail.data;
        return null;
    }
    /**
 * Check if a composition event was triggered by Korean IME.
 * Our fallback mode does not work well with IE's Korean IME,
 * so just use native composition events when Korean IME is used.
 * Although CompositionEvent.locale property is deprecated,
 * it is available in IE, where our fallback mode is enabled.
 *
 * @param {object} nativeEvent
 * @return {boolean}
 */ function isUsingKoreanIME(nativeEvent) {
        return nativeEvent.locale === 'ko';
    } // Track the current IME composition status, if any.
    var isComposing = false;
    /**
 * @return {?object} A SyntheticCompositionEvent.
 */ function extractCompositionEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget) {
        var eventType;
        var fallbackData;
        if (canUseCompositionEvent) eventType = getCompositionEventType(domEventName);
        else if (!isComposing) {
            if (isFallbackCompositionStart(domEventName, nativeEvent)) eventType = 'onCompositionStart';
        } else if (isFallbackCompositionEnd(domEventName, nativeEvent)) eventType = 'onCompositionEnd';
        if (!eventType) return null;
        if (useFallbackCompositionData && !isUsingKoreanIME(nativeEvent)) {
            // The current composition is stored statically and must not be
            // overwritten while composition continues.
            if (!isComposing && eventType === 'onCompositionStart') isComposing = initialize(nativeEventTarget);
            else if (eventType === 'onCompositionEnd') {
                if (isComposing) fallbackData = getData();
            }
        }
        var listeners = accumulateTwoPhaseListeners(targetInst, eventType);
        if (listeners.length > 0) {
            var event = new SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget);
            dispatchQueue.push({
                event: event,
                listeners: listeners
            });
            if (fallbackData) // Inject data generated from fallback path into the synthetic event.
            // This matches the property of native CompositionEventInterface.
            event.data = fallbackData;
            else {
                var customData = getDataFromCustomEvent(nativeEvent);
                if (customData !== null) event.data = customData;
            }
        }
    }
    function getNativeBeforeInputChars(domEventName, nativeEvent) {
        switch(domEventName){
            case 'compositionend':
                return getDataFromCustomEvent(nativeEvent);
            case 'keypress':
                /**
       * If native `textInput` events are available, our goal is to make
       * use of them. However, there is a special case: the spacebar key.
       * In Webkit, preventing default on a spacebar `textInput` event
       * cancels character insertion, but it *also* causes the browser
       * to fall back to its default spacebar behavior of scrolling the
       * page.
       *
       * Tracking at:
       * https://code.google.com/p/chromium/issues/detail?id=355103
       *
       * To avoid this issue, use the keypress event as if no `textInput`
       * event is available.
       */ var which = nativeEvent.which;
                if (which !== SPACEBAR_CODE) return null;
                hasSpaceKeypress = true;
                return SPACEBAR_CHAR;
            case 'textInput':
                // Record the characters to be added to the DOM.
                var chars = nativeEvent.data; // If it's a spacebar character, assume that we have already handled
                // it at the keypress level and bail immediately. Android Chrome
                // doesn't give us keycodes, so we need to ignore it.
                if (chars === SPACEBAR_CHAR && hasSpaceKeypress) return null;
                return chars;
            default:
                // For other native event types, do nothing.
                return null;
        }
    }
    /**
 * For browsers that do not provide the `textInput` event, extract the
 * appropriate string to use for SyntheticInputEvent.
 */ function getFallbackBeforeInputChars(domEventName, nativeEvent) {
        // If we are currently composing (IME) and using a fallback to do so,
        // try to extract the composed characters from the fallback object.
        // If composition event is available, we extract a string only at
        // compositionevent, otherwise extract it at fallback events.
        if (isComposing) {
            if (domEventName === 'compositionend' || !canUseCompositionEvent && isFallbackCompositionEnd(domEventName, nativeEvent)) {
                var chars = getData();
                reset();
                isComposing = false;
                return chars;
            }
            return null;
        }
        switch(domEventName){
            case 'paste':
                // If a paste event occurs after a keypress, throw out the input
                // chars. Paste events should not lead to BeforeInput events.
                return null;
            case 'keypress':
                /**
       * As of v27, Firefox may fire keypress events even when no character
       * will be inserted. A few possibilities:
       *
       * - `which` is `0`. Arrow keys, Esc key, etc.
       *
       * - `which` is the pressed key code, but no char is available.
       *   Ex: 'AltGr + d` in Polish. There is no modified character for
       *   this key combination and no character is inserted into the
       *   document, but FF fires the keypress for char code `100` anyway.
       *   No `input` event will occur.
       *
       * - `which` is the pressed key code, but a command combination is
       *   being used. Ex: `Cmd+C`. No character is inserted, and no
       *   `input` event will occur.
       */ if (!isKeypressCommand(nativeEvent)) {
                    // IE fires the `keypress` event when a user types an emoji via
                    // Touch keyboard of Windows.  In such a case, the `char` property
                    // holds an emoji character like `\uD83D\uDE0A`.  Because its length
                    // is 2, the property `which` does not represent an emoji correctly.
                    // In such a case, we directly return the `char` property instead of
                    // using `which`.
                    if (nativeEvent.char && nativeEvent.char.length > 1) return nativeEvent.char;
                    else if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
                }
                return null;
            case 'compositionend':
                return useFallbackCompositionData && !isUsingKoreanIME(nativeEvent) ? null : nativeEvent.data;
            default:
                return null;
        }
    }
    /**
 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
 * `textInput` or fallback behavior.
 *
 * @return {?object} A SyntheticInputEvent.
 */ function extractBeforeInputEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget) {
        var chars;
        if (canUseTextInputEvent) chars = getNativeBeforeInputChars(domEventName, nativeEvent);
        else chars = getFallbackBeforeInputChars(domEventName, nativeEvent);
         // If no characters are being inserted, no BeforeInput event should
        // be fired.
        if (!chars) return null;
        var listeners = accumulateTwoPhaseListeners(targetInst, 'onBeforeInput');
        if (listeners.length > 0) {
            var event = new SyntheticInputEvent('onBeforeInput', 'beforeinput', null, nativeEvent, nativeEventTarget);
            dispatchQueue.push({
                event: event,
                listeners: listeners
            });
            event.data = chars;
        }
    }
    /**
 * Create an `onBeforeInput` event to match
 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
 *
 * This event plugin is based on the native `textInput` event
 * available in Chrome, Safari, Opera, and IE. This event fires after
 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
 *
 * `beforeInput` is spec'd but not implemented in any browsers, and
 * the `input` event does not provide any useful information about what has
 * actually been added, contrary to the spec. Thus, `textInput` is the best
 * available event to identify the characters that have actually been inserted
 * into the target node.
 *
 * This plugin is also responsible for emitting `composition` events, thus
 * allowing us to share composition fallback code for both `beforeInput` and
 * `composition` event types.
 */ function extractEvents(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        extractCompositionEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        extractBeforeInputEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
    }
    /**
 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
 */ var supportedInputTypes = {
        color: true,
        date: true,
        datetime: true,
        'datetime-local': true,
        email: true,
        month: true,
        number: true,
        password: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true
    };
    function isTextInputElement(elem) {
        var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
        if (nodeName === 'input') return !!supportedInputTypes[elem.type];
        if (nodeName === 'textarea') return true;
        return false;
    }
    /**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */ function isEventSupported(eventNameSuffix) {
        if (!canUseDOM) return false;
        var eventName = 'on' + eventNameSuffix;
        var isSupported = eventName in document;
        if (!isSupported) {
            var element = document.createElement('div');
            element.setAttribute(eventName, 'return;');
            isSupported = typeof element[eventName] === 'function';
        }
        return isSupported;
    }
    function registerEvents$1() {
        registerTwoPhaseEvent('onChange', [
            'change',
            'click',
            'focusin',
            'focusout',
            'input',
            'keydown',
            'keyup',
            'selectionchange'
        ]);
    }
    function createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
        // Flag this event loop as needing state restore.
        enqueueStateRestore(target);
        var listeners = accumulateTwoPhaseListeners(inst, 'onChange');
        if (listeners.length > 0) {
            var event = new SyntheticEvent('onChange', 'change', null, nativeEvent, target);
            dispatchQueue.push({
                event: event,
                listeners: listeners
            });
        }
    }
    /**
 * For IE shims
 */ var activeElement = null;
    var activeElementInst = null;
    /**
 * SECTION: handle `change` event
 */ function shouldUseChangeEvent(elem) {
        var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
        return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
    }
    function manualDispatchChangeEvent(nativeEvent) {
        var dispatchQueue = [];
        createAndAccumulateChangeEvent(dispatchQueue, activeElementInst, nativeEvent, getEventTarget(nativeEvent)); // If change and propertychange bubbled, we'd just bind to it like all the
        // other events and have it go through ReactBrowserEventEmitter. Since it
        // doesn't, we manually listen for the events and so we have to enqueue and
        // process the abstract event manually.
        //
        // Batching is necessary here in order to ensure that all event handlers run
        // before the next rerender (including event handlers attached to ancestor
        // elements instead of directly on the input). Without this, controlled
        // components don't work properly in conjunction with event bubbling because
        // the component is rerendered and the value reverted before all the event
        // handlers can run. See https://github.com/facebook/react/issues/708.
        batchedUpdates(runEventInBatch, dispatchQueue);
    }
    function runEventInBatch(dispatchQueue) {
        processDispatchQueue(dispatchQueue, 0);
    }
    function getInstIfValueChanged(targetInst) {
        var targetNode = getNodeFromInstance(targetInst);
        if (updateValueIfChanged(targetNode)) return targetInst;
    }
    function getTargetInstForChangeEvent(domEventName, targetInst) {
        if (domEventName === 'change') return targetInst;
    }
    /**
 * SECTION: handle `input` event
 */ var isInputEventSupported = false;
    if (canUseDOM) // IE9 claims to support the input event but fails to trigger it when
    // deleting text, so we ignore its input events.
    isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
    /**
 * (For IE <=9) Starts tracking propertychange events on the passed-in element
 * and override the value property so that we can distinguish user events from
 * value changes in JS.
 */ function startWatchingForValueChange(target, targetInst) {
        activeElement = target;
        activeElementInst = targetInst;
        activeElement.attachEvent('onpropertychange', handlePropertyChange);
    }
    /**
 * (For IE <=9) Removes the event listeners from the currently-tracked element,
 * if any exists.
 */ function stopWatchingForValueChange() {
        if (!activeElement) return;
        activeElement.detachEvent('onpropertychange', handlePropertyChange);
        activeElement = null;
        activeElementInst = null;
    }
    /**
 * (For IE <=9) Handles a propertychange event, sending a `change` event if
 * the value of the active element has changed.
 */ function handlePropertyChange(nativeEvent) {
        if (nativeEvent.propertyName !== 'value') return;
        if (getInstIfValueChanged(activeElementInst)) manualDispatchChangeEvent(nativeEvent);
    }
    function handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
        if (domEventName === 'focusin') {
            // In IE9, propertychange fires for most input events but is buggy and
            // doesn't fire when text is deleted, but conveniently, selectionchange
            // appears to fire in all of the remaining cases so we catch those and
            // forward the event if the value has changed
            // In either case, we don't want to call the event handler if the value
            // is changed from JS so we redefine a setter for `.value` that updates
            // our activeElementValue variable, allowing us to ignore those changes
            //
            // stopWatching() should be a noop here but we call it just in case we
            // missed a blur event somehow.
            stopWatchingForValueChange();
            startWatchingForValueChange(target, targetInst);
        } else if (domEventName === 'focusout') stopWatchingForValueChange();
    } // For IE8 and IE9.
    function getTargetInstForInputEventPolyfill(domEventName, targetInst) {
        if (domEventName === 'selectionchange' || domEventName === 'keyup' || domEventName === 'keydown') // On the selectionchange event, the target is just document which isn't
        // helpful for us so just check activeElement instead.
        //
        // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
        // propertychange on the first input event after setting `value` from a
        // script and fires only keydown, keypress, keyup. Catching keyup usually
        // gets it and catching keydown lets us fire an event for the first
        // keystroke if user does a key repeat (it'll be a little delayed: right
        // before the second keystroke). Other input methods (e.g., paste) seem to
        // fire selectionchange normally.
        return getInstIfValueChanged(activeElementInst);
    }
    /**
 * SECTION: handle `click` event
 */ function shouldUseClickEvent(elem) {
        // Use the `click` event to detect changes to checkbox and radio inputs.
        // This approach works across all browsers, whereas `change` does not fire
        // until `blur` in IE8.
        var nodeName = elem.nodeName;
        return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
    }
    function getTargetInstForClickEvent(domEventName, targetInst) {
        if (domEventName === 'click') return getInstIfValueChanged(targetInst);
    }
    function getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
        if (domEventName === 'input' || domEventName === 'change') return getInstIfValueChanged(targetInst);
    }
    function handleControlledInputBlur(node) {
        var state = node._wrapperState;
        if (!state || !state.controlled || node.type !== 'number') return;
        // If controlled, assign the value attribute to the current value on blur
        setDefaultValue(node, 'number', node.value);
    }
    /**
 * This plugin creates an `onChange` event that normalizes change events
 * across form elements. This event fires at a time when it's possible to
 * change the element's value without seeing a flicker.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - select
 */ function extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var targetNode = targetInst ? getNodeFromInstance(targetInst) : window;
        var getTargetInstFunc, handleEventFunc;
        if (shouldUseChangeEvent(targetNode)) getTargetInstFunc = getTargetInstForChangeEvent;
        else if (isTextInputElement(targetNode)) {
            if (isInputEventSupported) getTargetInstFunc = getTargetInstForInputOrChangeEvent;
            else {
                getTargetInstFunc = getTargetInstForInputEventPolyfill;
                handleEventFunc = handleEventsForInputEventPolyfill;
            }
        } else if (shouldUseClickEvent(targetNode)) getTargetInstFunc = getTargetInstForClickEvent;
        if (getTargetInstFunc) {
            var inst = getTargetInstFunc(domEventName, targetInst);
            if (inst) {
                createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, nativeEventTarget);
                return;
            }
        }
        if (handleEventFunc) handleEventFunc(domEventName, targetNode, targetInst);
         // When blurring, set the value attribute for number inputs
        if (domEventName === 'focusout') handleControlledInputBlur(targetNode);
    }
    function registerEvents$2() {
        registerDirectEvent('onMouseEnter', [
            'mouseout',
            'mouseover'
        ]);
        registerDirectEvent('onMouseLeave', [
            'mouseout',
            'mouseover'
        ]);
        registerDirectEvent('onPointerEnter', [
            'pointerout',
            'pointerover'
        ]);
        registerDirectEvent('onPointerLeave', [
            'pointerout',
            'pointerover'
        ]);
    }
    /**
 * For almost every interaction we care about, there will be both a top-level
 * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
 * we do not extract duplicate events. However, moving the mouse into the
 * browser from outside will not fire a `mouseout` event. In this case, we use
 * the `mouseover` top-level event.
 */ function extractEvents$2(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var isOverEvent = domEventName === 'mouseover' || domEventName === 'pointerover';
        var isOutEvent = domEventName === 'mouseout' || domEventName === 'pointerout';
        if (isOverEvent && !isReplayingEvent(nativeEvent)) {
            // If this is an over event with a target, we might have already dispatched
            // the event in the out event of the other target. If this is replayed,
            // then it's because we couldn't dispatch against this target previously
            // so we have to do it now instead.
            var related = nativeEvent.relatedTarget || nativeEvent.fromElement;
            if (related) {
                // If the related node is managed by React, we can assume that we have
                // already dispatched the corresponding events during its mouseout.
                if (getClosestInstanceFromNode(related) || isContainerMarkedAsRoot(related)) return;
            }
        }
        if (!isOutEvent && !isOverEvent) // Must not be a mouse or pointer in or out - ignoring.
        return;
        var win; // TODO: why is this nullable in the types but we read from it?
        if (nativeEventTarget.window === nativeEventTarget) // `nativeEventTarget` is probably a window object.
        win = nativeEventTarget;
        else {
            // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
            var doc = nativeEventTarget.ownerDocument;
            if (doc) win = doc.defaultView || doc.parentWindow;
            else win = window;
        }
        var from;
        var to;
        if (isOutEvent) {
            var _related = nativeEvent.relatedTarget || nativeEvent.toElement;
            from = targetInst;
            to = _related ? getClosestInstanceFromNode(_related) : null;
            if (to !== null) {
                var nearestMounted = getNearestMountedFiber(to);
                if (to !== nearestMounted || to.tag !== HostComponent && to.tag !== HostText) to = null;
            }
        } else {
            // Moving to a node from outside the window.
            from = null;
            to = targetInst;
        }
        if (from === to) // Nothing pertains to our managed components.
        return;
        var SyntheticEventCtor = SyntheticMouseEvent;
        var leaveEventType = 'onMouseLeave';
        var enterEventType = 'onMouseEnter';
        var eventTypePrefix = 'mouse';
        if (domEventName === 'pointerout' || domEventName === 'pointerover') {
            SyntheticEventCtor = SyntheticPointerEvent;
            leaveEventType = 'onPointerLeave';
            enterEventType = 'onPointerEnter';
            eventTypePrefix = 'pointer';
        }
        var fromNode = from == null ? win : getNodeFromInstance(from);
        var toNode = to == null ? win : getNodeFromInstance(to);
        var leave = new SyntheticEventCtor(leaveEventType, eventTypePrefix + 'leave', from, nativeEvent, nativeEventTarget);
        leave.target = fromNode;
        leave.relatedTarget = toNode;
        var enter = null; // We should only process this nativeEvent if we are processing
        // the first ancestor. Next time, we will ignore the event.
        var nativeTargetInst = getClosestInstanceFromNode(nativeEventTarget);
        if (nativeTargetInst === targetInst) {
            var enterEvent = new SyntheticEventCtor(enterEventType, eventTypePrefix + 'enter', to, nativeEvent, nativeEventTarget);
            enterEvent.target = toNode;
            enterEvent.relatedTarget = fromNode;
            enter = enterEvent;
        }
        accumulateEnterLeaveTwoPhaseListeners(dispatchQueue, leave, enter, from, to);
    }
    /**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */ function is(x, y) {
        return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
        ;
    }
    var objectIs = typeof Object.is === 'function' ? Object.is : is;
    /**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */ function shallowEqual(objA, objB) {
        if (objectIs(objA, objB)) return true;
        if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
        var keysA = Object.keys(objA);
        var keysB = Object.keys(objB);
        if (keysA.length !== keysB.length) return false;
         // Test for A's keys different from B.
        for(var i = 0; i < keysA.length; i++){
            var currentKey = keysA[i];
            if (!hasOwnProperty.call(objB, currentKey) || !objectIs(objA[currentKey], objB[currentKey])) return false;
        }
        return true;
    }
    /**
 * Given any node return the first leaf node without children.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {DOMElement|DOMTextNode}
 */ function getLeafNode(node) {
        while(node && node.firstChild)node = node.firstChild;
        return node;
    }
    /**
 * Get the next sibling within a container. This will walk up the
 * DOM if a node's siblings have been exhausted.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {?DOMElement|DOMTextNode}
 */ function getSiblingNode(node) {
        while(node){
            if (node.nextSibling) return node.nextSibling;
            node = node.parentNode;
        }
    }
    /**
 * Get object describing the nodes which contain characters at offset.
 *
 * @param {DOMElement|DOMTextNode} root
 * @param {number} offset
 * @return {?object}
 */ function getNodeForCharacterOffset(root, offset) {
        var node = getLeafNode(root);
        var nodeStart = 0;
        var nodeEnd = 0;
        while(node){
            if (node.nodeType === TEXT_NODE) {
                nodeEnd = nodeStart + node.textContent.length;
                if (nodeStart <= offset && nodeEnd >= offset) return {
                    node: node,
                    offset: offset - nodeStart
                };
                nodeStart = nodeEnd;
            }
            node = getLeafNode(getSiblingNode(node));
        }
    }
    /**
 * @param {DOMElement} outerNode
 * @return {?object}
 */ function getOffsets(outerNode) {
        var ownerDocument = outerNode.ownerDocument;
        var win = ownerDocument && ownerDocument.defaultView || window;
        var selection = win.getSelection && win.getSelection();
        if (!selection || selection.rangeCount === 0) return null;
        var anchorNode = selection.anchorNode, anchorOffset = selection.anchorOffset, focusNode = selection.focusNode, focusOffset = selection.focusOffset; // In Firefox, anchorNode and focusNode can be "anonymous divs", e.g. the
        // up/down buttons on an <input type="number">. Anonymous divs do not seem to
        // expose properties, triggering a "Permission denied error" if any of its
        // properties are accessed. The only seemingly possible way to avoid erroring
        // is to access a property that typically works for non-anonymous divs and
        // catch any error that may otherwise arise. See
        // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
        try {
            /* eslint-disable no-unused-expressions */ anchorNode.nodeType;
            focusNode.nodeType;
        /* eslint-enable no-unused-expressions */ } catch (e) {
            return null;
        }
        return getModernOffsetsFromPoints(outerNode, anchorNode, anchorOffset, focusNode, focusOffset);
    }
    /**
 * Returns {start, end} where `start` is the character/codepoint index of
 * (anchorNode, anchorOffset) within the textContent of `outerNode`, and
 * `end` is the index of (focusNode, focusOffset).
 *
 * Returns null if you pass in garbage input but we should probably just crash.
 *
 * Exported only for testing.
 */ function getModernOffsetsFromPoints(outerNode, anchorNode, anchorOffset, focusNode, focusOffset) {
        var length = 0;
        var start = -1;
        var end = -1;
        var indexWithinAnchor = 0;
        var indexWithinFocus = 0;
        var node = outerNode;
        var parentNode = null;
        outer: while(true){
            var next = null;
            while(true){
                if (node === anchorNode && (anchorOffset === 0 || node.nodeType === TEXT_NODE)) start = length + anchorOffset;
                if (node === focusNode && (focusOffset === 0 || node.nodeType === TEXT_NODE)) end = length + focusOffset;
                if (node.nodeType === TEXT_NODE) length += node.nodeValue.length;
                if ((next = node.firstChild) === null) break;
                 // Moving from `node` to its first child `next`.
                parentNode = node;
                node = next;
            }
            while(true){
                if (node === outerNode) break outer;
                if (parentNode === anchorNode && ++indexWithinAnchor === anchorOffset) start = length;
                if (parentNode === focusNode && ++indexWithinFocus === focusOffset) end = length;
                if ((next = node.nextSibling) !== null) break;
                node = parentNode;
                parentNode = node.parentNode;
            } // Moving from `node` to its next sibling `next`.
            node = next;
        }
        if (start === -1 || end === -1) // This should never happen. (Would happen if the anchor/focus nodes aren't
        // actually inside the passed-in node.)
        return null;
        return {
            start: start,
            end: end
        };
    }
    /**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programmatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 *
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */ function setOffsets(node, offsets) {
        var doc = node.ownerDocument || document;
        var win = doc && doc.defaultView || window; // Edge fails with "Object expected" in some scenarios.
        // (For instance: TinyMCE editor used in a list component that supports pasting to add more,
        // fails when pasting 100+ items)
        if (!win.getSelection) return;
        var selection = win.getSelection();
        var length = node.textContent.length;
        var start = Math.min(offsets.start, length);
        var end = offsets.end === undefined ? start : Math.min(offsets.end, length); // IE 11 uses modern selection, but doesn't support the extend method.
        // Flip backward selections, so we can set with a single range.
        if (!selection.extend && start > end) {
            var temp = end;
            end = start;
            start = temp;
        }
        var startMarker = getNodeForCharacterOffset(node, start);
        var endMarker = getNodeForCharacterOffset(node, end);
        if (startMarker && endMarker) {
            if (selection.rangeCount === 1 && selection.anchorNode === startMarker.node && selection.anchorOffset === startMarker.offset && selection.focusNode === endMarker.node && selection.focusOffset === endMarker.offset) return;
            var range = doc.createRange();
            range.setStart(startMarker.node, startMarker.offset);
            selection.removeAllRanges();
            if (start > end) {
                selection.addRange(range);
                selection.extend(endMarker.node, endMarker.offset);
            } else {
                range.setEnd(endMarker.node, endMarker.offset);
                selection.addRange(range);
            }
        }
    }
    function isTextNode(node) {
        return node && node.nodeType === TEXT_NODE;
    }
    function containsNode(outerNode, innerNode) {
        if (!outerNode || !innerNode) return false;
        else if (outerNode === innerNode) return true;
        else if (isTextNode(outerNode)) return false;
        else if (isTextNode(innerNode)) return containsNode(outerNode, innerNode.parentNode);
        else if ('contains' in outerNode) return outerNode.contains(innerNode);
        else if (outerNode.compareDocumentPosition) return !!(outerNode.compareDocumentPosition(innerNode) & 16);
        else return false;
    }
    function isInDocument(node) {
        return node && node.ownerDocument && containsNode(node.ownerDocument.documentElement, node);
    }
    function isSameOriginFrame(iframe) {
        try {
            // Accessing the contentDocument of a HTMLIframeElement can cause the browser
            // to throw, e.g. if it has a cross-origin src attribute.
            // Safari will show an error in the console when the access results in "Blocked a frame with origin". e.g:
            // iframe.contentDocument.defaultView;
            // A safety way is to access one of the cross origin properties: Window or Location
            // Which might result in "SecurityError" DOM Exception and it is compatible to Safari.
            // https://html.spec.whatwg.org/multipage/browsers.html#integration-with-idl
            return typeof iframe.contentWindow.location.href === 'string';
        } catch (err) {
            return false;
        }
    }
    function getActiveElementDeep() {
        var win = window;
        var element = getActiveElement();
        while(element instanceof win.HTMLIFrameElement){
            if (isSameOriginFrame(element)) win = element.contentWindow;
            else return element;
            element = getActiveElement(win.document);
        }
        return element;
    }
    /**
 * @ReactInputSelection: React input selection module. Based on Selection.js,
 * but modified to be suitable for react and has a couple of bug fixes (doesn't
 * assume buttons have range selections allowed).
 * Input selection module for React.
 */ /**
 * @hasSelectionCapabilities: we get the element types that support selection
 * from https://html.spec.whatwg.org/#do-not-apply, looking at `selectionStart`
 * and `selectionEnd` rows.
 */ function hasSelectionCapabilities(elem) {
        var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
        return nodeName && (nodeName === 'input' && (elem.type === 'text' || elem.type === 'search' || elem.type === 'tel' || elem.type === 'url' || elem.type === 'password') || nodeName === 'textarea' || elem.contentEditable === 'true');
    }
    function getSelectionInformation() {
        var focusedElem = getActiveElementDeep();
        return {
            focusedElem: focusedElem,
            selectionRange: hasSelectionCapabilities(focusedElem) ? getSelection(focusedElem) : null
        };
    }
    /**
 * @restoreSelection: If any selection information was potentially lost,
 * restore it. This is useful when performing operations that could remove dom
 * nodes and place them back in, resulting in focus being lost.
 */ function restoreSelection(priorSelectionInformation) {
        var curFocusedElem = getActiveElementDeep();
        var priorFocusedElem = priorSelectionInformation.focusedElem;
        var priorSelectionRange = priorSelectionInformation.selectionRange;
        if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
            if (priorSelectionRange !== null && hasSelectionCapabilities(priorFocusedElem)) setSelection(priorFocusedElem, priorSelectionRange);
             // Focusing a node can change the scroll position, which is undesirable
            var ancestors = [];
            var ancestor = priorFocusedElem;
            while(ancestor = ancestor.parentNode)if (ancestor.nodeType === ELEMENT_NODE) ancestors.push({
                element: ancestor,
                left: ancestor.scrollLeft,
                top: ancestor.scrollTop
            });
            if (typeof priorFocusedElem.focus === 'function') priorFocusedElem.focus();
            for(var i = 0; i < ancestors.length; i++){
                var info = ancestors[i];
                info.element.scrollLeft = info.left;
                info.element.scrollTop = info.top;
            }
        }
    }
    /**
 * @getSelection: Gets the selection bounds of a focused textarea, input or
 * contentEditable node.
 * -@input: Look up selection bounds of this input
 * -@return {start: selectionStart, end: selectionEnd}
 */ function getSelection(input) {
        var selection;
        if ('selectionStart' in input) // Modern browser with input or textarea.
        selection = {
            start: input.selectionStart,
            end: input.selectionEnd
        };
        else // Content editable or old IE textarea.
        selection = getOffsets(input);
        return selection || {
            start: 0,
            end: 0
        };
    }
    /**
 * @setSelection: Sets the selection bounds of a textarea or input and focuses
 * the input.
 * -@input     Set selection bounds of this input or textarea
 * -@offsets   Object of same form that is returned from get*
 */ function setSelection(input, offsets) {
        var start = offsets.start;
        var end = offsets.end;
        if (end === undefined) end = start;
        if ('selectionStart' in input) {
            input.selectionStart = start;
            input.selectionEnd = Math.min(end, input.value.length);
        } else setOffsets(input, offsets);
    }
    var skipSelectionChangeEvent = canUseDOM && 'documentMode' in document && document.documentMode <= 11;
    function registerEvents$3() {
        registerTwoPhaseEvent('onSelect', [
            'focusout',
            'contextmenu',
            'dragend',
            'focusin',
            'keydown',
            'keyup',
            'mousedown',
            'mouseup',
            'selectionchange'
        ]);
    }
    var activeElement$1 = null;
    var activeElementInst$1 = null;
    var lastSelection = null;
    var mouseDown = false;
    /**
 * Get an object which is a unique representation of the current selection.
 *
 * The return value will not be consistent across nodes or browsers, but
 * two identical selections on the same node will return identical objects.
 */ function getSelection$1(node) {
        if ('selectionStart' in node && hasSelectionCapabilities(node)) return {
            start: node.selectionStart,
            end: node.selectionEnd
        };
        else {
            var win = node.ownerDocument && node.ownerDocument.defaultView || window;
            var selection = win.getSelection();
            return {
                anchorNode: selection.anchorNode,
                anchorOffset: selection.anchorOffset,
                focusNode: selection.focusNode,
                focusOffset: selection.focusOffset
            };
        }
    }
    /**
 * Get document associated with the event target.
 */ function getEventTargetDocument(eventTarget) {
        return eventTarget.window === eventTarget ? eventTarget.document : eventTarget.nodeType === DOCUMENT_NODE ? eventTarget : eventTarget.ownerDocument;
    }
    /**
 * Poll selection to see whether it's changed.
 *
 * @param {object} nativeEvent
 * @param {object} nativeEventTarget
 * @return {?SyntheticEvent}
 */ function constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
        // Ensure we have the right element, and that the user is not dragging a
        // selection (this matches native `select` event behavior). In HTML5, select
        // fires only on input and textarea thus if there's no focused element we
        // won't dispatch.
        var doc = getEventTargetDocument(nativeEventTarget);
        if (mouseDown || activeElement$1 == null || activeElement$1 !== getActiveElement(doc)) return;
         // Only fire when selection has actually changed.
        var currentSelection = getSelection$1(activeElement$1);
        if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
            lastSelection = currentSelection;
            var listeners = accumulateTwoPhaseListeners(activeElementInst$1, 'onSelect');
            if (listeners.length > 0) {
                var event = new SyntheticEvent('onSelect', 'select', null, nativeEvent, nativeEventTarget);
                dispatchQueue.push({
                    event: event,
                    listeners: listeners
                });
                event.target = activeElement$1;
            }
        }
    }
    /**
 * This plugin creates an `onSelect` event that normalizes select events
 * across form elements.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - contentEditable
 *
 * This differs from native browser implementations in the following ways:
 * - Fires on contentEditable fields as well as inputs.
 * - Fires for collapsed selection.
 * - Fires after user input.
 */ function extractEvents$3(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var targetNode = targetInst ? getNodeFromInstance(targetInst) : window;
        switch(domEventName){
            // Track the input node that has focus.
            case 'focusin':
                if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
                    activeElement$1 = targetNode;
                    activeElementInst$1 = targetInst;
                    lastSelection = null;
                }
                break;
            case 'focusout':
                activeElement$1 = null;
                activeElementInst$1 = null;
                lastSelection = null;
                break;
            // Don't fire the event while the user is dragging. This matches the
            // semantics of the native select event.
            case 'mousedown':
                mouseDown = true;
                break;
            case 'contextmenu':
            case 'mouseup':
            case 'dragend':
                mouseDown = false;
                constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                break;
            // Chrome and IE fire non-standard event when selection is changed (and
            // sometimes when it hasn't). IE's event fires out of order with respect
            // to key and input events on deletion, so we discard it.
            //
            // Firefox doesn't support selectionchange, so check selection status
            // after each key entry. The selection changes after keydown and before
            // keyup, but we check on keydown as well in the case of holding down a
            // key, when multiple keydown events are fired but only one keyup is.
            // This is also our approach for IE handling, for the reason above.
            case 'selectionchange':
                if (skipSelectionChangeEvent) break;
            // falls through
            case 'keydown':
            case 'keyup':
                constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
        }
    }
    /**
 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
 *
 * @param {string} styleProp
 * @param {string} eventName
 * @returns {object}
 */ function makePrefixMap(styleProp, eventName) {
        var prefixes = {};
        prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
        prefixes['Webkit' + styleProp] = 'webkit' + eventName;
        prefixes['Moz' + styleProp] = 'moz' + eventName;
        return prefixes;
    }
    /**
 * A list of event names to a configurable list of vendor prefixes.
 */ var vendorPrefixes = {
        animationend: makePrefixMap('Animation', 'AnimationEnd'),
        animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
        animationstart: makePrefixMap('Animation', 'AnimationStart'),
        transitionend: makePrefixMap('Transition', 'TransitionEnd')
    };
    /**
 * Event names that have already been detected and prefixed (if applicable).
 */ var prefixedEventNames = {};
    /**
 * Element to check for prefixes on.
 */ var style = {};
    /**
 * Bootstrap if a DOM exists.
 */ if (canUseDOM) {
        style = document.createElement('div').style; // On some platforms, in particular some releases of Android 4.x,
        // the un-prefixed "animation" and "transition" properties are defined on the
        // style object but the events that fire will still be prefixed, so we need
        // to check if the un-prefixed events are usable, and if not remove them from the map.
        if (!('AnimationEvent' in window)) {
            delete vendorPrefixes.animationend.animation;
            delete vendorPrefixes.animationiteration.animation;
            delete vendorPrefixes.animationstart.animation;
        } // Same as above
        if (!('TransitionEvent' in window)) delete vendorPrefixes.transitionend.transition;
    }
    /**
 * Attempts to determine the correct vendor prefixed event name.
 *
 * @param {string} eventName
 * @returns {string}
 */ function getVendorPrefixedEventName(eventName) {
        if (prefixedEventNames[eventName]) return prefixedEventNames[eventName];
        else if (!vendorPrefixes[eventName]) return eventName;
        var prefixMap = vendorPrefixes[eventName];
        for(var styleProp in prefixMap){
            if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) return prefixedEventNames[eventName] = prefixMap[styleProp];
        }
        return eventName;
    }
    var ANIMATION_END = getVendorPrefixedEventName('animationend');
    var ANIMATION_ITERATION = getVendorPrefixedEventName('animationiteration');
    var ANIMATION_START = getVendorPrefixedEventName('animationstart');
    var TRANSITION_END = getVendorPrefixedEventName('transitionend');
    var topLevelEventsToReactNames = new Map(); // NOTE: Capitalization is important in this list!
    //
    // E.g. it needs "pointerDown", not "pointerdown".
    // This is because we derive both React name ("onPointerDown")
    // and DOM name ("pointerdown") from the same list.
    //
    // Exceptions that don't match this convention are listed separately.
    //
    // prettier-ignore
    var simpleEventPluginEvents = [
        'abort',
        'auxClick',
        'cancel',
        'canPlay',
        'canPlayThrough',
        'click',
        'close',
        'contextMenu',
        'copy',
        'cut',
        'drag',
        'dragEnd',
        'dragEnter',
        'dragExit',
        'dragLeave',
        'dragOver',
        'dragStart',
        'drop',
        'durationChange',
        'emptied',
        'encrypted',
        'ended',
        'error',
        'gotPointerCapture',
        'input',
        'invalid',
        'keyDown',
        'keyPress',
        'keyUp',
        'load',
        'loadedData',
        'loadedMetadata',
        'loadStart',
        'lostPointerCapture',
        'mouseDown',
        'mouseMove',
        'mouseOut',
        'mouseOver',
        'mouseUp',
        'paste',
        'pause',
        'play',
        'playing',
        'pointerCancel',
        'pointerDown',
        'pointerMove',
        'pointerOut',
        'pointerOver',
        'pointerUp',
        'progress',
        'rateChange',
        'reset',
        'resize',
        'seeked',
        'seeking',
        'stalled',
        'submit',
        'suspend',
        'timeUpdate',
        'touchCancel',
        'touchEnd',
        'touchStart',
        'volumeChange',
        'scroll',
        'toggle',
        'touchMove',
        'waiting',
        'wheel'
    ];
    function registerSimpleEvent(domEventName, reactName) {
        topLevelEventsToReactNames.set(domEventName, reactName);
        registerTwoPhaseEvent(reactName, [
            domEventName
        ]);
    }
    function registerSimpleEvents() {
        for(var i = 0; i < simpleEventPluginEvents.length; i++){
            var eventName = simpleEventPluginEvents[i];
            var domEventName = eventName.toLowerCase();
            var capitalizedEvent = eventName[0].toUpperCase() + eventName.slice(1);
            registerSimpleEvent(domEventName, 'on' + capitalizedEvent);
        } // Special cases where event names don't match.
        registerSimpleEvent(ANIMATION_END, 'onAnimationEnd');
        registerSimpleEvent(ANIMATION_ITERATION, 'onAnimationIteration');
        registerSimpleEvent(ANIMATION_START, 'onAnimationStart');
        registerSimpleEvent('dblclick', 'onDoubleClick');
        registerSimpleEvent('focusin', 'onFocus');
        registerSimpleEvent('focusout', 'onBlur');
        registerSimpleEvent(TRANSITION_END, 'onTransitionEnd');
    }
    function extractEvents$4(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var reactName = topLevelEventsToReactNames.get(domEventName);
        if (reactName === undefined) return;
        var SyntheticEventCtor = SyntheticEvent;
        var reactEventType = domEventName;
        switch(domEventName){
            case 'keypress':
                // Firefox creates a keypress event for function keys too. This removes
                // the unwanted keypress events. Enter is however both printable and
                // non-printable. One would expect Tab to be as well (but it isn't).
                if (getEventCharCode(nativeEvent) === 0) return;
            /* falls through */ case 'keydown':
            case 'keyup':
                SyntheticEventCtor = SyntheticKeyboardEvent;
                break;
            case 'focusin':
                reactEventType = 'focus';
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
            case 'focusout':
                reactEventType = 'blur';
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
            case 'beforeblur':
            case 'afterblur':
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
            case 'click':
                // Firefox creates a click event on right mouse clicks. This removes the
                // unwanted click events.
                if (nativeEvent.button === 2) return;
            /* falls through */ case 'auxclick':
            case 'dblclick':
            case 'mousedown':
            case 'mousemove':
            case 'mouseup':
            /* falls through */ case 'mouseout':
            case 'mouseover':
            case 'contextmenu':
                SyntheticEventCtor = SyntheticMouseEvent;
                break;
            case 'drag':
            case 'dragend':
            case 'dragenter':
            case 'dragexit':
            case 'dragleave':
            case 'dragover':
            case 'dragstart':
            case 'drop':
                SyntheticEventCtor = SyntheticDragEvent;
                break;
            case 'touchcancel':
            case 'touchend':
            case 'touchmove':
            case 'touchstart':
                SyntheticEventCtor = SyntheticTouchEvent;
                break;
            case ANIMATION_END:
            case ANIMATION_ITERATION:
            case ANIMATION_START:
                SyntheticEventCtor = SyntheticAnimationEvent;
                break;
            case TRANSITION_END:
                SyntheticEventCtor = SyntheticTransitionEvent;
                break;
            case 'scroll':
                SyntheticEventCtor = SyntheticUIEvent;
                break;
            case 'wheel':
                SyntheticEventCtor = SyntheticWheelEvent;
                break;
            case 'copy':
            case 'cut':
            case 'paste':
                SyntheticEventCtor = SyntheticClipboardEvent;
                break;
            case 'gotpointercapture':
            case 'lostpointercapture':
            case 'pointercancel':
            case 'pointerdown':
            case 'pointermove':
            case 'pointerout':
            case 'pointerover':
            case 'pointerup':
                SyntheticEventCtor = SyntheticPointerEvent;
                break;
        }
        var inCapturePhase = (eventSystemFlags & IS_CAPTURE_PHASE) !== 0;
        // Some events don't bubble in the browser.
        // In the past, React has always bubbled them, but this can be surprising.
        // We're going to try aligning closer to the browser behavior by not bubbling
        // them in React either. We'll start by not bubbling onScroll, and then expand.
        var accumulateTargetOnly = !inCapturePhase && // TODO: ideally, we'd eventually add all events from
        // nonDelegatedEvents list in DOMPluginEventSystem.
        // Then we can remove this special list.
        // This is a breaking change that can wait until React 18.
        domEventName === 'scroll';
        var _listeners = accumulateSinglePhaseListeners(targetInst, reactName, nativeEvent.type, inCapturePhase, accumulateTargetOnly);
        if (_listeners.length > 0) {
            // Intentionally create event lazily.
            var _event = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget);
            dispatchQueue.push({
                event: _event,
                listeners: _listeners
            });
        }
    }
    // TODO: remove top-level side effect.
    registerSimpleEvents();
    registerEvents$2();
    registerEvents$1();
    registerEvents$3();
    registerEvents();
    function extractEvents$5(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        // TODO: we should remove the concept of a "SimpleEventPlugin".
        // This is the basic functionality of the event system. All
        // the other plugins are essentially polyfills. So the plugin
        // should probably be inlined somewhere and have its logic
        // be core the to event system. This would potentially allow
        // us to ship builds of React without the polyfilled plugins below.
        extractEvents$4(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
        var shouldProcessPolyfillPlugins = (eventSystemFlags & SHOULD_NOT_PROCESS_POLYFILL_EVENT_PLUGINS) === 0; // We don't process these events unless we are in the
        // event's native "bubble" phase, which means that we're
        // not in the capture phase. That's because we emulate
        // the capture phase here still. This is a trade-off,
        // because in an ideal world we would not emulate and use
        // the phases properly, like we do with the SimpleEvent
        // plugin. However, the plugins below either expect
        // emulation (EnterLeave) or use state localized to that
        // plugin (BeforeInput, Change, Select). The state in
        // these modules complicates things, as you'll essentially
        // get the case where the capture phase event might change
        // state, only for the following bubble event to come in
        // later and not trigger anything as the state now
        // invalidates the heuristics of the event plugin. We
        // could alter all these plugins to work in such ways, but
        // that might cause other unknown side-effects that we
        // can't foresee right now.
        if (shouldProcessPolyfillPlugins) {
            extractEvents$2(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
            extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
            extractEvents$3(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
            extractEvents(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
    } // List of events that need to be individually attached to media elements.
    var mediaEventTypes = [
        'abort',
        'canplay',
        'canplaythrough',
        'durationchange',
        'emptied',
        'encrypted',
        'ended',
        'error',
        'loadeddata',
        'loadedmetadata',
        'loadstart',
        'pause',
        'play',
        'playing',
        'progress',
        'ratechange',
        'resize',
        'seeked',
        'seeking',
        'stalled',
        'suspend',
        'timeupdate',
        'volumechange',
        'waiting'
    ]; // We should not delegate these events to the container, but rather
    // set them on the actual target element itself. This is primarily
    // because these events do not consistently bubble in the DOM.
    var nonDelegatedEvents = new Set([
        'cancel',
        'close',
        'invalid',
        'load',
        'scroll',
        'toggle'
    ].concat(mediaEventTypes));
    function executeDispatch(event, listener, currentTarget) {
        var type = event.type || 'unknown-event';
        event.currentTarget = currentTarget;
        invokeGuardedCallbackAndCatchFirstError(type, listener, undefined, event);
        event.currentTarget = null;
    }
    function processDispatchQueueItemsInOrder(event, dispatchListeners, inCapturePhase) {
        var previousInstance;
        if (inCapturePhase) for(var i = dispatchListeners.length - 1; i >= 0; i--){
            var _dispatchListeners$i = dispatchListeners[i], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget, listener = _dispatchListeners$i.listener;
            if (instance !== previousInstance && event.isPropagationStopped()) return;
            executeDispatch(event, listener, currentTarget);
            previousInstance = instance;
        }
        else for(var _i = 0; _i < dispatchListeners.length; _i++){
            var _dispatchListeners$_i = dispatchListeners[_i], _instance = _dispatchListeners$_i.instance, _currentTarget = _dispatchListeners$_i.currentTarget, _listener = _dispatchListeners$_i.listener;
            if (_instance !== previousInstance && event.isPropagationStopped()) return;
            executeDispatch(event, _listener, _currentTarget);
            previousInstance = _instance;
        }
    }
    function processDispatchQueue(dispatchQueue, eventSystemFlags) {
        var inCapturePhase = (eventSystemFlags & IS_CAPTURE_PHASE) !== 0;
        for(var i = 0; i < dispatchQueue.length; i++){
            var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event, listeners = _dispatchQueue$i.listeners;
            processDispatchQueueItemsInOrder(event, listeners, inCapturePhase); //  event system doesn't use pooling.
        } // This would be a good time to rethrow if any of the event handlers threw.
        rethrowCaughtError();
    }
    function dispatchEventsForPlugins(domEventName, eventSystemFlags, nativeEvent, targetInst, targetContainer) {
        var nativeEventTarget = getEventTarget(nativeEvent);
        var dispatchQueue = [];
        extractEvents$5(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
        processDispatchQueue(dispatchQueue, eventSystemFlags);
    }
    function listenToNonDelegatedEvent(domEventName, targetElement) {
        if (!nonDelegatedEvents.has(domEventName)) error('Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.', domEventName);
        var isCapturePhaseListener = false;
        var listenerSet = getEventListenerSet(targetElement);
        var listenerSetKey = getListenerSetKey(domEventName, isCapturePhaseListener);
        if (!listenerSet.has(listenerSetKey)) {
            addTrappedEventListener(targetElement, domEventName, IS_NON_DELEGATED, isCapturePhaseListener);
            listenerSet.add(listenerSetKey);
        }
    }
    function listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
        if (nonDelegatedEvents.has(domEventName) && !isCapturePhaseListener) error('Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.', domEventName);
        var eventSystemFlags = 0;
        if (isCapturePhaseListener) eventSystemFlags |= IS_CAPTURE_PHASE;
        addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
    } // This is only used by createEventHandle when the
    var listeningMarker = '_reactListening' + Math.random().toString(36).slice(2);
    function listenToAllSupportedEvents(rootContainerElement) {
        if (!rootContainerElement[listeningMarker]) {
            rootContainerElement[listeningMarker] = true;
            allNativeEvents.forEach(function(domEventName) {
                // We handle selectionchange separately because it
                // doesn't bubble and needs to be on the document.
                if (domEventName !== 'selectionchange') {
                    if (!nonDelegatedEvents.has(domEventName)) listenToNativeEvent(domEventName, false, rootContainerElement);
                    listenToNativeEvent(domEventName, true, rootContainerElement);
                }
            });
            var ownerDocument = rootContainerElement.nodeType === DOCUMENT_NODE ? rootContainerElement : rootContainerElement.ownerDocument;
            if (ownerDocument !== null) // The selectionchange event also needs deduplication
            // but it is attached to the document.
            {
                if (!ownerDocument[listeningMarker]) {
                    ownerDocument[listeningMarker] = true;
                    listenToNativeEvent('selectionchange', false, ownerDocument);
                }
            }
        }
    }
    function addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener, isDeferredListenerForLegacyFBSupport) {
        var listener = createEventListenerWrapperWithPriority(targetContainer, domEventName, eventSystemFlags); // If passive option is not supported, then the event will be
        // active and not passive.
        var isPassiveListener = undefined;
        if (passiveBrowserEventsSupported) // Browsers introduced an intervention, making these events
        // passive by default on document. React doesn't bind them
        // to document anymore, but changing this now would undo
        // the performance wins from the change. So we emulate
        // the existing behavior manually on the roots now.
        // https://github.com/facebook/react/issues/19651
        {
            if (domEventName === 'touchstart' || domEventName === 'touchmove' || domEventName === 'wheel') isPassiveListener = true;
        }
        targetContainer;
        var unsubscribeListener; // When legacyFBSupport is enabled, it's for when we
        if (isCapturePhaseListener) {
            if (isPassiveListener !== undefined) unsubscribeListener = addEventCaptureListenerWithPassiveFlag(targetContainer, domEventName, listener, isPassiveListener);
            else unsubscribeListener = addEventCaptureListener(targetContainer, domEventName, listener);
        } else if (isPassiveListener !== undefined) unsubscribeListener = addEventBubbleListenerWithPassiveFlag(targetContainer, domEventName, listener, isPassiveListener);
        else unsubscribeListener = addEventBubbleListener(targetContainer, domEventName, listener);
    }
    function isMatchingRootContainer(grandContainer, targetContainer) {
        return grandContainer === targetContainer || grandContainer.nodeType === COMMENT_NODE && grandContainer.parentNode === targetContainer;
    }
    function dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst, targetContainer) {
        var ancestorInst = targetInst;
        if ((eventSystemFlags & IS_EVENT_HANDLE_NON_MANAGED_NODE) === 0 && (eventSystemFlags & IS_NON_DELEGATED) === 0) {
            var targetContainerNode = targetContainer; // If we are using the legacy FB support flag, we
            if (targetInst !== null) {
                // The below logic attempts to work out if we need to change
                // the target fiber to a different ancestor. We had similar logic
                // in the legacy event system, except the big difference between
                // systems is that the modern event system now has an event listener
                // attached to each React Root and React Portal Root. Together,
                // the DOM nodes representing these roots are the "rootContainer".
                // To figure out which ancestor instance we should use, we traverse
                // up the fiber tree from the target instance and attempt to find
                // root boundaries that match that of our current "rootContainer".
                // If we find that "rootContainer", we find the parent fiber
                // sub-tree for that root and make that our ancestor instance.
                var node = targetInst;
                mainLoop: while(true){
                    if (node === null) return;
                    var nodeTag = node.tag;
                    if (nodeTag === HostRoot || nodeTag === HostPortal) {
                        var container = node.stateNode.containerInfo;
                        if (isMatchingRootContainer(container, targetContainerNode)) break;
                        if (nodeTag === HostPortal) {
                            // The target is a portal, but it's not the rootContainer we're looking for.
                            // Normally portals handle their own events all the way down to the root.
                            // So we should be able to stop now. However, we don't know if this portal
                            // was part of *our* root.
                            var grandNode = node.return;
                            while(grandNode !== null){
                                var grandTag = grandNode.tag;
                                if (grandTag === HostRoot || grandTag === HostPortal) {
                                    var grandContainer = grandNode.stateNode.containerInfo;
                                    if (isMatchingRootContainer(grandContainer, targetContainerNode)) // This is the rootContainer we're looking for and we found it as
                                    // a parent of the Portal. That means we can ignore it because the
                                    // Portal will bubble through to us.
                                    return;
                                }
                                grandNode = grandNode.return;
                            }
                        } // Now we need to find it's corresponding host fiber in the other
                        // tree. To do this we can use getClosestInstanceFromNode, but we
                        // need to validate that the fiber is a host instance, otherwise
                        // we need to traverse up through the DOM till we find the correct
                        // node that is from the other tree.
                        while(container !== null){
                            var parentNode = getClosestInstanceFromNode(container);
                            if (parentNode === null) return;
                            var parentTag = parentNode.tag;
                            if (parentTag === HostComponent || parentTag === HostText) {
                                node = ancestorInst = parentNode;
                                continue mainLoop;
                            }
                            container = container.parentNode;
                        }
                    }
                    node = node.return;
                }
            }
        }
        batchedUpdates(function() {
            return dispatchEventsForPlugins(domEventName, eventSystemFlags, nativeEvent, ancestorInst);
        });
    }
    function createDispatchListener(instance, listener, currentTarget) {
        return {
            instance: instance,
            listener: listener,
            currentTarget: currentTarget
        };
    }
    function accumulateSinglePhaseListeners(targetFiber, reactName, nativeEventType, inCapturePhase, accumulateTargetOnly, nativeEvent) {
        var captureName = reactName !== null ? reactName + 'Capture' : null;
        var reactEventName = inCapturePhase ? captureName : reactName;
        var listeners = [];
        var instance = targetFiber;
        var lastHostComponent = null; // Accumulate all instances and listeners via the target -> root path.
        while(instance !== null){
            var _instance2 = instance, stateNode = _instance2.stateNode, tag = _instance2.tag; // Handle listeners that are on HostComponents (i.e. <div>)
            if (tag === HostComponent && stateNode !== null) {
                lastHostComponent = stateNode; // createEventHandle listeners
                if (reactEventName !== null) {
                    var listener = getListener(instance, reactEventName);
                    if (listener != null) listeners.push(createDispatchListener(instance, listener, lastHostComponent));
                }
            } // If we are only accumulating events for the target, then we don't
            // continue to propagate through the React fiber tree to find other
            // listeners.
            if (accumulateTargetOnly) break;
             // If we are processing the onBeforeBlur event, then we need to take
            instance = instance.return;
        }
        return listeners;
    } // We should only use this function for:
    // - BeforeInputEventPlugin
    // - ChangeEventPlugin
    // - SelectEventPlugin
    // This is because we only process these plugins
    // in the bubble phase, so we need to accumulate two
    // phase event listeners (via emulation).
    function accumulateTwoPhaseListeners(targetFiber, reactName) {
        var captureName = reactName + 'Capture';
        var listeners = [];
        var instance = targetFiber; // Accumulate all instances and listeners via the target -> root path.
        while(instance !== null){
            var _instance3 = instance, stateNode = _instance3.stateNode, tag = _instance3.tag; // Handle listeners that are on HostComponents (i.e. <div>)
            if (tag === HostComponent && stateNode !== null) {
                var currentTarget = stateNode;
                var captureListener = getListener(instance, captureName);
                if (captureListener != null) listeners.unshift(createDispatchListener(instance, captureListener, currentTarget));
                var bubbleListener = getListener(instance, reactName);
                if (bubbleListener != null) listeners.push(createDispatchListener(instance, bubbleListener, currentTarget));
            }
            instance = instance.return;
        }
        return listeners;
    }
    function getParent(inst) {
        if (inst === null) return null;
        do inst = inst.return; // TODO: If this is a HostRoot we might want to bail out.
        while (inst && inst.tag !== HostComponent);
        if (inst) return inst;
        return null;
    }
    /**
 * Return the lowest common ancestor of A and B, or null if they are in
 * different trees.
 */ function getLowestCommonAncestor(instA, instB) {
        var nodeA = instA;
        var nodeB = instB;
        var depthA = 0;
        for(var tempA = nodeA; tempA; tempA = getParent(tempA))depthA++;
        var depthB = 0;
        for(var tempB = nodeB; tempB; tempB = getParent(tempB))depthB++;
         // If A is deeper, crawl up.
        while(depthA - depthB > 0){
            nodeA = getParent(nodeA);
            depthA--;
        } // If B is deeper, crawl up.
        while(depthB - depthA > 0){
            nodeB = getParent(nodeB);
            depthB--;
        } // Walk in lockstep until we find a match.
        var depth = depthA;
        while(depth--){
            if (nodeA === nodeB || nodeB !== null && nodeA === nodeB.alternate) return nodeA;
            nodeA = getParent(nodeA);
            nodeB = getParent(nodeB);
        }
        return null;
    }
    function accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
        var registrationName = event._reactName;
        var listeners = [];
        var instance = target;
        while(instance !== null){
            if (instance === common) break;
            var _instance4 = instance, alternate = _instance4.alternate, stateNode = _instance4.stateNode, tag = _instance4.tag;
            if (alternate !== null && alternate === common) break;
            if (tag === HostComponent && stateNode !== null) {
                var currentTarget = stateNode;
                if (inCapturePhase) {
                    var captureListener = getListener(instance, registrationName);
                    if (captureListener != null) listeners.unshift(createDispatchListener(instance, captureListener, currentTarget));
                } else if (!inCapturePhase) {
                    var bubbleListener = getListener(instance, registrationName);
                    if (bubbleListener != null) listeners.push(createDispatchListener(instance, bubbleListener, currentTarget));
                }
            }
            instance = instance.return;
        }
        if (listeners.length !== 0) dispatchQueue.push({
            event: event,
            listeners: listeners
        });
    } // We should only use this function for:
    // - EnterLeaveEventPlugin
    // This is because we only process this plugin
    // in the bubble phase, so we need to accumulate two
    // phase event listeners.
    function accumulateEnterLeaveTwoPhaseListeners(dispatchQueue, leaveEvent, enterEvent, from, to) {
        var common = from && to ? getLowestCommonAncestor(from, to) : null;
        if (from !== null) accumulateEnterLeaveListenersForEvent(dispatchQueue, leaveEvent, from, common, false);
        if (to !== null && enterEvent !== null) accumulateEnterLeaveListenersForEvent(dispatchQueue, enterEvent, to, common, true);
    }
    function getListenerSetKey(domEventName, capture) {
        return domEventName + "__" + (capture ? 'capture' : 'bubble');
    }
    var didWarnInvalidHydration = false;
    var DANGEROUSLY_SET_INNER_HTML = 'dangerouslySetInnerHTML';
    var SUPPRESS_CONTENT_EDITABLE_WARNING = 'suppressContentEditableWarning';
    var SUPPRESS_HYDRATION_WARNING = 'suppressHydrationWarning';
    var AUTOFOCUS = 'autoFocus';
    var CHILDREN = 'children';
    var STYLE = 'style';
    var HTML$1 = '__html';
    var warnedUnknownTags;
    var validatePropertiesInDevelopment;
    var warnForPropDifference;
    var warnForExtraAttributes;
    var warnForInvalidEventListener;
    var canDiffStyleForHydrationWarning;
    var normalizeHTML;
    warnedUnknownTags = {
        // There are working polyfills for <dialog>. Let people use it.
        dialog: true,
        // Electron ships a custom <webview> tag to display external web content in
        // an isolated frame and process.
        // This tag is not present in non Electron environments such as JSDom which
        // is often used for testing purposes.
        // @see https://electronjs.org/docs/api/webview-tag
        webview: true
    };
    validatePropertiesInDevelopment = function validatePropertiesInDevelopment(type, props) {
        validateProperties(type, props);
        validateProperties$1(type, props);
        validateProperties$2(type, props, {
            registrationNameDependencies: registrationNameDependencies,
            possibleRegistrationNames: possibleRegistrationNames
        });
    }; // IE 11 parses & normalizes the style attribute as opposed to other
    // browsers. It adds spaces and sorts the properties in some
    // non-alphabetical order. Handling that would require sorting CSS
    // properties in the client & server versions or applying
    // `expectedStyle` to a temporary DOM node to read its `style` attribute
    // normalized. Since it only affects IE, we're skipping style warnings
    // in that browser completely in favor of doing all that work.
    // See https://github.com/facebook/react/issues/11807
    canDiffStyleForHydrationWarning = canUseDOM && !document.documentMode;
    warnForPropDifference = function warnForPropDifference(propName, serverValue, clientValue) {
        if (didWarnInvalidHydration) return;
        var normalizedClientValue = normalizeMarkupForTextOrAttribute(clientValue);
        var normalizedServerValue = normalizeMarkupForTextOrAttribute(serverValue);
        if (normalizedServerValue === normalizedClientValue) return;
        didWarnInvalidHydration = true;
        error('Prop `%s` did not match. Server: %s Client: %s', propName, JSON.stringify(normalizedServerValue), JSON.stringify(normalizedClientValue));
    };
    warnForExtraAttributes = function warnForExtraAttributes(attributeNames) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        var names = [];
        attributeNames.forEach(function(name) {
            names.push(name);
        });
        error('Extra attributes from the server: %s', names);
    };
    warnForInvalidEventListener = function warnForInvalidEventListener(registrationName, listener) {
        if (listener === false) error("Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.", registrationName, registrationName, registrationName);
        else error('Expected `%s` listener to be a function, instead got a value of `%s` type.', registrationName, typeof listener);
    }; // Parse the HTML and read it back to normalize the HTML string so that it
    // can be used for comparison.
    normalizeHTML = function normalizeHTML(parent, html) {
        // We could have created a separate document here to avoid
        // re-initializing custom elements if they exist. But this breaks
        // how <noscript> is being handled. So we use the same document.
        // See the discussion in https://github.com/facebook/react/pull/11157.
        var testElement = parent.namespaceURI === HTML_NAMESPACE ? parent.ownerDocument.createElement(parent.tagName) : parent.ownerDocument.createElementNS(parent.namespaceURI, parent.tagName);
        testElement.innerHTML = html;
        return testElement.innerHTML;
    };
    // It also can turn \u0000 into \uFFFD inside attributes.
    // https://www.w3.org/TR/html5/single-page.html#preprocessing-the-input-stream
    // If we have a mismatch, it might be caused by that.
    // We will still patch up in this case but not fire the warning.
    var NORMALIZE_NEWLINES_REGEX = /\r\n?/g;
    var NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
    function normalizeMarkupForTextOrAttribute(markup) {
        checkHtmlStringCoercion(markup);
        var markupString = typeof markup === 'string' ? markup : '' + markup;
        return markupString.replace(NORMALIZE_NEWLINES_REGEX, '\n').replace(NORMALIZE_NULL_AND_REPLACEMENT_REGEX, '');
    }
    function checkForUnmatchedText(serverText, clientText, isConcurrentMode, shouldWarnDev) {
        var normalizedClientText = normalizeMarkupForTextOrAttribute(clientText);
        var normalizedServerText = normalizeMarkupForTextOrAttribute(serverText);
        if (normalizedServerText === normalizedClientText) return;
        if (shouldWarnDev) {
            if (!didWarnInvalidHydration) {
                didWarnInvalidHydration = true;
                error('Text content did not match. Server: "%s" Client: "%s"', normalizedServerText, normalizedClientText);
            }
        }
        if (isConcurrentMode && enableClientRenderFallbackOnTextMismatch) // In concurrent roots, we throw when there's a text mismatch and revert to
        // client rendering, up to the nearest Suspense boundary.
        throw new Error('Text content does not match server-rendered HTML.');
    }
    function getOwnerDocumentFromRootContainer(rootContainerElement) {
        return rootContainerElement.nodeType === DOCUMENT_NODE ? rootContainerElement : rootContainerElement.ownerDocument;
    }
    function noop() {}
    function trapClickOnNonInteractiveElement(node) {
        // Mobile Safari does not fire properly bubble click events on
        // non-interactive elements, which means delegated click listeners do not
        // fire. The workaround for this bug involves attaching an empty click
        // listener on the target node.
        // https://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
        // Just set it using the onclick property so that we don't have to manage any
        // bookkeeping for it. Not sure if we need to clear it when the listener is
        // removed.
        // TODO: Only do this for the relevant Safaris maybe?
        node.onclick = noop;
    }
    function setInitialDOMProperties(tag, domElement, rootContainerElement, nextProps, isCustomComponentTag) {
        for(var propKey in nextProps){
            if (!nextProps.hasOwnProperty(propKey)) continue;
            var nextProp = nextProps[propKey];
            if (propKey === STYLE) {
                if (nextProp) // Freeze the next style object so that we can assume it won't be
                // mutated. We have already warned for this in the past.
                Object.freeze(nextProp);
                setValueForStyles(domElement, nextProp);
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
                if (nextHtml != null) setInnerHTML(domElement, nextHtml);
            } else if (propKey === CHILDREN) {
                if (typeof nextProp === 'string') {
                    // Avoid setting initial textContent when the text is empty. In IE11 setting
                    // textContent on a <textarea> will cause the placeholder to not
                    // show within the <textarea> until it has been focused and blurred again.
                    // https://github.com/facebook/react/issues/6731#issuecomment-254874553
                    var canSetTextContent = tag !== 'textarea' || nextProp !== '';
                    if (canSetTextContent) setTextContent(domElement, nextProp);
                } else if (typeof nextProp === 'number') setTextContent(domElement, '' + nextProp);
            } else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;
            else if (propKey === AUTOFOCUS) ;
            else if (registrationNameDependencies.hasOwnProperty(propKey)) {
                if (nextProp != null) {
                    if (typeof nextProp !== 'function') warnForInvalidEventListener(propKey, nextProp);
                    if (propKey === 'onScroll') listenToNonDelegatedEvent('scroll', domElement);
                }
            } else if (nextProp != null) setValueForProperty(domElement, propKey, nextProp, isCustomComponentTag);
        }
    }
    function updateDOMProperties(domElement, updatePayload, wasCustomComponentTag, isCustomComponentTag) {
        // TODO: Handle wasCustomComponentTag
        for(var i = 0; i < updatePayload.length; i += 2){
            var propKey = updatePayload[i];
            var propValue = updatePayload[i + 1];
            if (propKey === STYLE) setValueForStyles(domElement, propValue);
            else if (propKey === DANGEROUSLY_SET_INNER_HTML) setInnerHTML(domElement, propValue);
            else if (propKey === CHILDREN) setTextContent(domElement, propValue);
            else setValueForProperty(domElement, propKey, propValue, isCustomComponentTag);
        }
    }
    function createElement(type, props, rootContainerElement, parentNamespace) {
        var isCustomComponentTag; // We create tags in the namespace of their parent container, except HTML
        // tags get no namespace.
        var ownerDocument = getOwnerDocumentFromRootContainer(rootContainerElement);
        var domElement;
        var namespaceURI = parentNamespace;
        if (namespaceURI === HTML_NAMESPACE) namespaceURI = getIntrinsicNamespace(type);
        if (namespaceURI === HTML_NAMESPACE) {
            isCustomComponentTag = isCustomComponent(type, props); // Should this check be gated by parent namespace? Not sure we want to
            // allow <SVG> or <mATH>.
            if (!isCustomComponentTag && type !== type.toLowerCase()) error("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", type);
            if (type === 'script') {
                // Create the script via .innerHTML so its "parser-inserted" flag is
                // set to true and it does not execute
                var div = ownerDocument.createElement('div');
                div.innerHTML = "<script></script>"; // eslint-disable-line
                // This is guaranteed to yield a script element.
                var firstChild = div.firstChild;
                domElement = div.removeChild(firstChild);
            } else if (typeof props.is === 'string') // $FlowIssue `createElement` should be updated for Web Components
            domElement = ownerDocument.createElement(type, {
                is: props.is
            });
            else {
                // Separate else branch instead of using `props.is || undefined` above because of a Firefox bug.
                // See discussion in https://github.com/facebook/react/pull/6896
                // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
                domElement = ownerDocument.createElement(type); // Normally attributes are assigned in `setInitialDOMProperties`, however the `multiple` and `size`
                // attributes on `select`s needs to be added before `option`s are inserted.
                // This prevents:
                // - a bug where the `select` does not scroll to the correct option because singular
                //  `select` elements automatically pick the first item #13222
                // - a bug where the `select` set the first item as selected despite the `size` attribute #14239
                // See https://github.com/facebook/react/issues/13222
                // and https://github.com/facebook/react/issues/14239
                if (type === 'select') {
                    var node = domElement;
                    if (props.multiple) node.multiple = true;
                    else if (props.size) // Setting a size greater than 1 causes a select to behave like `multiple=true`, where
                    // it is possible that no option is selected.
                    //
                    // This is only necessary when a select in "single selection mode".
                    node.size = props.size;
                }
            }
        } else domElement = ownerDocument.createElementNS(namespaceURI, type);
        if (namespaceURI === HTML_NAMESPACE) {
            if (!isCustomComponentTag && Object.prototype.toString.call(domElement) === '[object HTMLUnknownElement]' && !hasOwnProperty.call(warnedUnknownTags, type)) {
                warnedUnknownTags[type] = true;
                error("The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.", type);
            }
        }
        return domElement;
    }
    function createTextNode(text, rootContainerElement) {
        return getOwnerDocumentFromRootContainer(rootContainerElement).createTextNode(text);
    }
    function setInitialProperties(domElement, tag, rawProps, rootContainerElement) {
        var isCustomComponentTag = isCustomComponent(tag, rawProps);
        validatePropertiesInDevelopment(tag, rawProps);
        var props;
        switch(tag){
            case 'dialog':
                listenToNonDelegatedEvent('cancel', domElement);
                listenToNonDelegatedEvent('close', domElement);
                props = rawProps;
                break;
            case 'iframe':
            case 'object':
            case 'embed':
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the load event.
                listenToNonDelegatedEvent('load', domElement);
                props = rawProps;
                break;
            case 'video':
            case 'audio':
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for all the media events.
                for(var i = 0; i < mediaEventTypes.length; i++)listenToNonDelegatedEvent(mediaEventTypes[i], domElement);
                props = rawProps;
                break;
            case 'source':
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the error event.
                listenToNonDelegatedEvent('error', domElement);
                props = rawProps;
                break;
            case 'img':
            case 'image':
            case 'link':
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for error and load events.
                listenToNonDelegatedEvent('error', domElement);
                listenToNonDelegatedEvent('load', domElement);
                props = rawProps;
                break;
            case 'details':
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the toggle event.
                listenToNonDelegatedEvent('toggle', domElement);
                props = rawProps;
                break;
            case 'input':
                initWrapperState(domElement, rawProps);
                props = getHostProps(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent('invalid', domElement);
                break;
            case 'option':
                validateProps(domElement, rawProps);
                props = rawProps;
                break;
            case 'select':
                initWrapperState$1(domElement, rawProps);
                props = getHostProps$1(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent('invalid', domElement);
                break;
            case 'textarea':
                initWrapperState$2(domElement, rawProps);
                props = getHostProps$2(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent('invalid', domElement);
                break;
            default:
                props = rawProps;
        }
        assertValidProps(tag, props);
        setInitialDOMProperties(tag, domElement, rootContainerElement, props, isCustomComponentTag);
        switch(tag){
            case 'input':
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper(domElement, rawProps, false);
                break;
            case 'textarea':
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper$3(domElement);
                break;
            case 'option':
                postMountWrapper$1(domElement, rawProps);
                break;
            case 'select':
                postMountWrapper$2(domElement, rawProps);
                break;
            default:
                if (typeof props.onClick === 'function') // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
                break;
        }
    } // Calculate the diff between the two objects.
    function diffProperties(domElement, tag, lastRawProps, nextRawProps, rootContainerElement) {
        validatePropertiesInDevelopment(tag, nextRawProps);
        var updatePayload = null;
        var lastProps;
        var nextProps;
        switch(tag){
            case 'input':
                lastProps = getHostProps(domElement, lastRawProps);
                nextProps = getHostProps(domElement, nextRawProps);
                updatePayload = [];
                break;
            case 'select':
                lastProps = getHostProps$1(domElement, lastRawProps);
                nextProps = getHostProps$1(domElement, nextRawProps);
                updatePayload = [];
                break;
            case 'textarea':
                lastProps = getHostProps$2(domElement, lastRawProps);
                nextProps = getHostProps$2(domElement, nextRawProps);
                updatePayload = [];
                break;
            default:
                lastProps = lastRawProps;
                nextProps = nextRawProps;
                if (typeof lastProps.onClick !== 'function' && typeof nextProps.onClick === 'function') // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
                break;
        }
        assertValidProps(tag, nextProps);
        var propKey;
        var styleName;
        var styleUpdates = null;
        for(propKey in lastProps){
            if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) continue;
            if (propKey === STYLE) {
                var lastStyle = lastProps[propKey];
                for(styleName in lastStyle)if (lastStyle.hasOwnProperty(styleName)) {
                    if (!styleUpdates) styleUpdates = {};
                    styleUpdates[styleName] = '';
                }
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML || propKey === CHILDREN) ;
            else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;
            else if (propKey === AUTOFOCUS) ;
            else if (registrationNameDependencies.hasOwnProperty(propKey)) // This is a special case. If any listener updates we need to ensure
            // that the "current" fiber pointer gets updated so we need a commit
            // to update this element.
            {
                if (!updatePayload) updatePayload = [];
            } else // For all other deleted properties we add it to the queue. We use
            // the allowed property list in the commit phase instead.
            (updatePayload = updatePayload || []).push(propKey, null);
        }
        for(propKey in nextProps){
            var nextProp = nextProps[propKey];
            var lastProp = lastProps != null ? lastProps[propKey] : undefined;
            if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) continue;
            if (propKey === STYLE) {
                if (nextProp) // Freeze the next style object so that we can assume it won't be
                // mutated. We have already warned for this in the past.
                Object.freeze(nextProp);
                if (lastProp) {
                    // Unset styles on `lastProp` but not on `nextProp`.
                    for(styleName in lastProp)if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
                        if (!styleUpdates) styleUpdates = {};
                        styleUpdates[styleName] = '';
                    }
                     // Update styles that changed since `lastProp`.
                    for(styleName in nextProp)if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
                        if (!styleUpdates) styleUpdates = {};
                        styleUpdates[styleName] = nextProp[styleName];
                    }
                } else {
                    // Relies on `updateStylesByID` not mutating `styleUpdates`.
                    if (!styleUpdates) {
                        if (!updatePayload) updatePayload = [];
                        updatePayload.push(propKey, styleUpdates);
                    }
                    styleUpdates = nextProp;
                }
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
                var lastHtml = lastProp ? lastProp[HTML$1] : undefined;
                if (nextHtml != null) {
                    if (lastHtml !== nextHtml) (updatePayload = updatePayload || []).push(propKey, nextHtml);
                }
            } else if (propKey === CHILDREN) {
                if (typeof nextProp === 'string' || typeof nextProp === 'number') (updatePayload = updatePayload || []).push(propKey, '' + nextProp);
            } else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;
            else if (registrationNameDependencies.hasOwnProperty(propKey)) {
                if (nextProp != null) {
                    // We eagerly listen to this even though we haven't committed yet.
                    if (typeof nextProp !== 'function') warnForInvalidEventListener(propKey, nextProp);
                    if (propKey === 'onScroll') listenToNonDelegatedEvent('scroll', domElement);
                }
                if (!updatePayload && lastProp !== nextProp) // This is a special case. If any listener updates we need to ensure
                // that the "current" props pointer gets updated so we need a commit
                // to update this element.
                updatePayload = [];
            } else // For any other property we always add it to the queue and then we
            // filter it out using the allowed property list during the commit.
            (updatePayload = updatePayload || []).push(propKey, nextProp);
        }
        if (styleUpdates) {
            validateShorthandPropertyCollisionInDev(styleUpdates, nextProps[STYLE]);
            (updatePayload = updatePayload || []).push(STYLE, styleUpdates);
        }
        return updatePayload;
    } // Apply the diff.
    function updateProperties(domElement, updatePayload, tag, lastRawProps, nextRawProps) {
        // Update checked *before* name.
        // In the middle of an update, it is possible to have multiple checked.
        // When a checked radio tries to change name, browser makes another radio's checked false.
        if (tag === 'input' && nextRawProps.type === 'radio' && nextRawProps.name != null) updateChecked(domElement, nextRawProps);
        var wasCustomComponentTag = isCustomComponent(tag, lastRawProps);
        var isCustomComponentTag = isCustomComponent(tag, nextRawProps); // Apply the diff.
        updateDOMProperties(domElement, updatePayload, wasCustomComponentTag, isCustomComponentTag); // TODO: Ensure that an update gets scheduled if any of the special props
        // changed.
        switch(tag){
            case 'input':
                // Update the wrapper around inputs *after* updating props. This has to
                // happen after `updateDOMProperties`. Otherwise HTML5 input validations
                // raise warnings and prevent the new value from being assigned.
                updateWrapper(domElement, nextRawProps);
                break;
            case 'textarea':
                updateWrapper$1(domElement, nextRawProps);
                break;
            case 'select':
                // <select> value update needs to occur after <option> children
                // reconciliation
                postUpdateWrapper(domElement, nextRawProps);
                break;
        }
    }
    function getPossibleStandardName(propName) {
        var lowerCasedName = propName.toLowerCase();
        if (!possibleStandardNames.hasOwnProperty(lowerCasedName)) return null;
        return possibleStandardNames[lowerCasedName] || null;
    }
    function diffHydratedProperties(domElement, tag, rawProps, parentNamespace, rootContainerElement, isConcurrentMode, shouldWarnDev) {
        var isCustomComponentTag;
        var extraAttributeNames;
        isCustomComponentTag = isCustomComponent(tag, rawProps);
        validatePropertiesInDevelopment(tag, rawProps);
        switch(tag){
            case 'dialog':
                listenToNonDelegatedEvent('cancel', domElement);
                listenToNonDelegatedEvent('close', domElement);
                break;
            case 'iframe':
            case 'object':
            case 'embed':
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the load event.
                listenToNonDelegatedEvent('load', domElement);
                break;
            case 'video':
            case 'audio':
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for all the media events.
                for(var i = 0; i < mediaEventTypes.length; i++)listenToNonDelegatedEvent(mediaEventTypes[i], domElement);
                break;
            case 'source':
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the error event.
                listenToNonDelegatedEvent('error', domElement);
                break;
            case 'img':
            case 'image':
            case 'link':
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for error and load events.
                listenToNonDelegatedEvent('error', domElement);
                listenToNonDelegatedEvent('load', domElement);
                break;
            case 'details':
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the toggle event.
                listenToNonDelegatedEvent('toggle', domElement);
                break;
            case 'input':
                initWrapperState(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent('invalid', domElement);
                break;
            case 'option':
                validateProps(domElement, rawProps);
                break;
            case 'select':
                initWrapperState$1(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent('invalid', domElement);
                break;
            case 'textarea':
                initWrapperState$2(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent('invalid', domElement);
                break;
        }
        assertValidProps(tag, rawProps);
        extraAttributeNames = new Set();
        var attributes = domElement.attributes;
        for(var _i = 0; _i < attributes.length; _i++){
            var name = attributes[_i].name.toLowerCase();
            switch(name){
                // Controlled attributes are not validated
                // TODO: Only ignore them on controlled tags.
                case 'value':
                    break;
                case 'checked':
                    break;
                case 'selected':
                    break;
                default:
                    // Intentionally use the original name.
                    // See discussion in https://github.com/facebook/react/pull/10676.
                    extraAttributeNames.add(attributes[_i].name);
            }
        }
        var updatePayload = null;
        for(var propKey in rawProps){
            if (!rawProps.hasOwnProperty(propKey)) continue;
            var nextProp = rawProps[propKey];
            if (propKey === CHILDREN) {
                // For text content children we compare against textContent. This
                // might match additional HTML that is hidden when we read it using
                // textContent. E.g. "foo" will match "f<span>oo</span>" but that still
                // satisfies our requirement. Our requirement is not to produce perfect
                // HTML and attributes. Ideally we should preserve structure but it's
                // ok not to if the visible content is still enough to indicate what
                // even listeners these nodes might be wired up to.
                // TODO: Warn if there is more than a single textNode as a child.
                // TODO: Should we use domElement.firstChild.nodeValue to compare?
                if (typeof nextProp === 'string') {
                    if (domElement.textContent !== nextProp) {
                        if (rawProps[SUPPRESS_HYDRATION_WARNING] !== true) checkForUnmatchedText(domElement.textContent, nextProp, isConcurrentMode, shouldWarnDev);
                        updatePayload = [
                            CHILDREN,
                            nextProp
                        ];
                    }
                } else if (typeof nextProp === 'number') {
                    if (domElement.textContent !== '' + nextProp) {
                        if (rawProps[SUPPRESS_HYDRATION_WARNING] !== true) checkForUnmatchedText(domElement.textContent, nextProp, isConcurrentMode, shouldWarnDev);
                        updatePayload = [
                            CHILDREN,
                            '' + nextProp
                        ];
                    }
                }
            } else if (registrationNameDependencies.hasOwnProperty(propKey)) {
                if (nextProp != null) {
                    if (typeof nextProp !== 'function') warnForInvalidEventListener(propKey, nextProp);
                    if (propKey === 'onScroll') listenToNonDelegatedEvent('scroll', domElement);
                }
            } else if (shouldWarnDev && true && // Convince Flow we've calculated it (it's DEV-only in this method.)
            typeof isCustomComponentTag === 'boolean') {
                // Validate that the properties correspond to their expected values.
                var serverValue = void 0;
                var propertyInfo = isCustomComponentTag && enableCustomElementPropertySupport ? null : getPropertyInfo(propKey);
                if (rawProps[SUPPRESS_HYDRATION_WARNING] === true) ;
                else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING || // Controlled attributes are not validated
                // TODO: Only ignore them on controlled tags.
                propKey === 'value' || propKey === 'checked' || propKey === 'selected') ;
                else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                    var serverHTML = domElement.innerHTML;
                    var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
                    if (nextHtml != null) {
                        var expectedHTML = normalizeHTML(domElement, nextHtml);
                        if (expectedHTML !== serverHTML) warnForPropDifference(propKey, serverHTML, expectedHTML);
                    }
                } else if (propKey === STYLE) {
                    // $FlowFixMe - Should be inferred as not undefined.
                    extraAttributeNames.delete(propKey);
                    if (canDiffStyleForHydrationWarning) {
                        var expectedStyle = createDangerousStringForStyles(nextProp);
                        serverValue = domElement.getAttribute('style');
                        if (expectedStyle !== serverValue) warnForPropDifference(propKey, serverValue, expectedStyle);
                    }
                } else if (isCustomComponentTag && !enableCustomElementPropertySupport) {
                    // $FlowFixMe - Should be inferred as not undefined.
                    extraAttributeNames.delete(propKey.toLowerCase());
                    serverValue = getValueForAttribute(domElement, propKey, nextProp);
                    if (nextProp !== serverValue) warnForPropDifference(propKey, serverValue, nextProp);
                } else if (!shouldIgnoreAttribute(propKey, propertyInfo, isCustomComponentTag) && !shouldRemoveAttribute(propKey, nextProp, propertyInfo, isCustomComponentTag)) {
                    var isMismatchDueToBadCasing = false;
                    if (propertyInfo !== null) {
                        // $FlowFixMe - Should be inferred as not undefined.
                        extraAttributeNames.delete(propertyInfo.attributeName);
                        serverValue = getValueForProperty(domElement, propKey, nextProp, propertyInfo);
                    } else {
                        var ownNamespace = parentNamespace;
                        if (ownNamespace === HTML_NAMESPACE) ownNamespace = getIntrinsicNamespace(tag);
                        if (ownNamespace === HTML_NAMESPACE) // $FlowFixMe - Should be inferred as not undefined.
                        extraAttributeNames.delete(propKey.toLowerCase());
                        else {
                            var standardName = getPossibleStandardName(propKey);
                            if (standardName !== null && standardName !== propKey) {
                                // If an SVG prop is supplied with bad casing, it will
                                // be successfully parsed from HTML, but will produce a mismatch
                                // (and would be incorrectly rendered on the client).
                                // However, we already warn about bad casing elsewhere.
                                // So we'll skip the misleading extra mismatch warning in this case.
                                isMismatchDueToBadCasing = true; // $FlowFixMe - Should be inferred as not undefined.
                                extraAttributeNames.delete(standardName);
                            } // $FlowFixMe - Should be inferred as not undefined.
                            extraAttributeNames.delete(propKey);
                        }
                        serverValue = getValueForAttribute(domElement, propKey, nextProp);
                    }
                    var dontWarnCustomElement = enableCustomElementPropertySupport;
                    if (!dontWarnCustomElement && nextProp !== serverValue && !isMismatchDueToBadCasing) warnForPropDifference(propKey, serverValue, nextProp);
                }
            }
        }
        if (shouldWarnDev) {
            if (extraAttributeNames.size > 0 && rawProps[SUPPRESS_HYDRATION_WARNING] !== true) // $FlowFixMe - Should be inferred as not undefined.
            warnForExtraAttributes(extraAttributeNames);
        }
        switch(tag){
            case 'input':
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper(domElement, rawProps, true);
                break;
            case 'textarea':
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper$3(domElement);
                break;
            case 'select':
            case 'option':
                break;
            default:
                if (typeof rawProps.onClick === 'function') // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
                break;
        }
        return updatePayload;
    }
    function diffHydratedText(textNode, text, isConcurrentMode) {
        var isDifferent = textNode.nodeValue !== text;
        return isDifferent;
    }
    function warnForDeletedHydratableElement(parentNode, child) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error('Did not expect server HTML to contain a <%s> in <%s>.', child.nodeName.toLowerCase(), parentNode.nodeName.toLowerCase());
    }
    function warnForDeletedHydratableText(parentNode, child) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error('Did not expect server HTML to contain the text node "%s" in <%s>.', child.nodeValue, parentNode.nodeName.toLowerCase());
    }
    function warnForInsertedHydratedElement(parentNode, tag, props) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error('Expected server HTML to contain a matching <%s> in <%s>.', tag, parentNode.nodeName.toLowerCase());
    }
    function warnForInsertedHydratedText(parentNode, text) {
        if (text === '') // We expect to insert empty text nodes since they're not represented in
        // the HTML.
        // TODO: Remove this special case if we can just avoid inserting empty
        // text nodes.
        return;
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error('Expected server HTML to contain a matching text node for "%s" in <%s>.', text, parentNode.nodeName.toLowerCase());
    }
    function restoreControlledState$3(domElement, tag, props) {
        switch(tag){
            case 'input':
                restoreControlledState(domElement, props);
                return;
            case 'textarea':
                restoreControlledState$2(domElement, props);
                return;
            case 'select':
                restoreControlledState$1(domElement, props);
                return;
        }
    }
    var validateDOMNesting = function validateDOMNesting() {};
    var updatedAncestorInfo = function updatedAncestorInfo() {};
    // This validation code was written based on the HTML5 parsing spec:
    // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
    //
    // Note: this does not catch all invalid nesting, nor does it try to (as it's
    // not clear what practical benefit doing so provides); instead, we warn only
    // for cases where the parser will give a parse tree differing from what React
    // intended. For example, <b><div></div></b> is invalid but we don't warn
    // because it still parses correctly; we do warn for other cases like nested
    // <p> tags where the beginning of the second element implicitly closes the
    // first, causing a confusing mess.
    // https://html.spec.whatwg.org/multipage/syntax.html#special
    var specialTags = [
        'address',
        'applet',
        'area',
        'article',
        'aside',
        'base',
        'basefont',
        'bgsound',
        'blockquote',
        'body',
        'br',
        'button',
        'caption',
        'center',
        'col',
        'colgroup',
        'dd',
        'details',
        'dir',
        'div',
        'dl',
        'dt',
        'embed',
        'fieldset',
        'figcaption',
        'figure',
        'footer',
        'form',
        'frame',
        'frameset',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'head',
        'header',
        'hgroup',
        'hr',
        'html',
        'iframe',
        'img',
        'input',
        'isindex',
        'li',
        'link',
        'listing',
        'main',
        'marquee',
        'menu',
        'menuitem',
        'meta',
        'nav',
        'noembed',
        'noframes',
        'noscript',
        'object',
        'ol',
        'p',
        'param',
        'plaintext',
        'pre',
        'script',
        'section',
        'select',
        'source',
        'style',
        'summary',
        'table',
        'tbody',
        'td',
        'template',
        'textarea',
        'tfoot',
        'th',
        'thead',
        'title',
        'tr',
        'track',
        'ul',
        'wbr',
        'xmp'
    ]; // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
    var inScopeTags = [
        'applet',
        'caption',
        'html',
        'table',
        'td',
        'th',
        'marquee',
        'object',
        'template',
        // TODO: Distinguish by namespace here -- for <title>, including it here
        // errs on the side of fewer warnings
        'foreignObject',
        'desc',
        'title'
    ]; // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
    var buttonScopeTags = inScopeTags.concat([
        'button'
    ]); // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
    var impliedEndTags = [
        'dd',
        'dt',
        'li',
        'option',
        'optgroup',
        'p',
        'rp',
        'rt'
    ];
    var emptyAncestorInfo = {
        current: null,
        formTag: null,
        aTagInScope: null,
        buttonTagInScope: null,
        nobrTagInScope: null,
        pTagInButtonScope: null,
        listItemTagAutoclosing: null,
        dlItemTagAutoclosing: null
    };
    updatedAncestorInfo = function updatedAncestorInfo(oldInfo, tag) {
        var ancestorInfo = assign({}, oldInfo || emptyAncestorInfo);
        var info = {
            tag: tag
        };
        if (inScopeTags.indexOf(tag) !== -1) {
            ancestorInfo.aTagInScope = null;
            ancestorInfo.buttonTagInScope = null;
            ancestorInfo.nobrTagInScope = null;
        }
        if (buttonScopeTags.indexOf(tag) !== -1) ancestorInfo.pTagInButtonScope = null;
         // See rules for 'li', 'dd', 'dt' start tags in
        // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
        if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
            ancestorInfo.listItemTagAutoclosing = null;
            ancestorInfo.dlItemTagAutoclosing = null;
        }
        ancestorInfo.current = info;
        if (tag === 'form') ancestorInfo.formTag = info;
        if (tag === 'a') ancestorInfo.aTagInScope = info;
        if (tag === 'button') ancestorInfo.buttonTagInScope = info;
        if (tag === 'nobr') ancestorInfo.nobrTagInScope = info;
        if (tag === 'p') ancestorInfo.pTagInButtonScope = info;
        if (tag === 'li') ancestorInfo.listItemTagAutoclosing = info;
        if (tag === 'dd' || tag === 'dt') ancestorInfo.dlItemTagAutoclosing = info;
        return ancestorInfo;
    };
    /**
   * Returns whether
   */ var isTagValidWithParent = function isTagValidWithParent(tag, parentTag) {
        // First, let's check if we're in an unusual parsing mode...
        switch(parentTag){
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
            case 'select':
                return tag === 'option' || tag === 'optgroup' || tag === '#text';
            case 'optgroup':
                return tag === 'option' || tag === '#text';
            // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
            // but
            case 'option':
                return tag === '#text';
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
            // No special behavior since these rules fall back to "in body" mode for
            // all except special table nodes which cause bad parsing behavior anyway.
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
            case 'tr':
                return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
            case 'tbody':
            case 'thead':
            case 'tfoot':
                return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
            case 'colgroup':
                return tag === 'col' || tag === 'template';
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
            case 'table':
                return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
            case 'head':
                return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
            // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
            case 'html':
                return tag === 'head' || tag === 'body' || tag === 'frameset';
            case 'frameset':
                return tag === 'frame';
            case '#document':
                return tag === 'html';
        } // Probably in the "in body" parsing mode, so we outlaw only tag combos
        // where the parsing rules cause implicit opens or closes to be added.
        // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
        switch(tag){
            case 'h1':
            case 'h2':
            case 'h3':
            case 'h4':
            case 'h5':
            case 'h6':
                return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
            case 'rp':
            case 'rt':
                return impliedEndTags.indexOf(parentTag) === -1;
            case 'body':
            case 'caption':
            case 'col':
            case 'colgroup':
            case 'frameset':
            case 'frame':
            case 'head':
            case 'html':
            case 'tbody':
            case 'td':
            case 'tfoot':
            case 'th':
            case 'thead':
            case 'tr':
                // These tags are only valid with a few parents that have special child
                // parsing rules -- if we're down here, then none of those matched and
                // so we allow it only if we don't know what the parent is, as all other
                // cases are invalid.
                return parentTag == null;
        }
        return true;
    };
    /**
   * Returns whether
   */ var findInvalidAncestorForTag = function findInvalidAncestorForTag(tag, ancestorInfo) {
        switch(tag){
            case 'address':
            case 'article':
            case 'aside':
            case 'blockquote':
            case 'center':
            case 'details':
            case 'dialog':
            case 'dir':
            case 'div':
            case 'dl':
            case 'fieldset':
            case 'figcaption':
            case 'figure':
            case 'footer':
            case 'header':
            case 'hgroup':
            case 'main':
            case 'menu':
            case 'nav':
            case 'ol':
            case 'p':
            case 'section':
            case 'summary':
            case 'ul':
            case 'pre':
            case 'listing':
            case 'table':
            case 'hr':
            case 'xmp':
            case 'h1':
            case 'h2':
            case 'h3':
            case 'h4':
            case 'h5':
            case 'h6':
                return ancestorInfo.pTagInButtonScope;
            case 'form':
                return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
            case 'li':
                return ancestorInfo.listItemTagAutoclosing;
            case 'dd':
            case 'dt':
                return ancestorInfo.dlItemTagAutoclosing;
            case 'button':
                return ancestorInfo.buttonTagInScope;
            case 'a':
                // Spec says something about storing a list of markers, but it sounds
                // equivalent to this check.
                return ancestorInfo.aTagInScope;
            case 'nobr':
                return ancestorInfo.nobrTagInScope;
        }
        return null;
    };
    var didWarn$1 = {};
    validateDOMNesting = function validateDOMNesting(childTag, childText, ancestorInfo) {
        ancestorInfo = ancestorInfo || emptyAncestorInfo;
        var parentInfo = ancestorInfo.current;
        var parentTag = parentInfo && parentInfo.tag;
        if (childText != null) {
            if (childTag != null) error('validateDOMNesting: when childText is passed, childTag should be null');
            childTag = '#text';
        }
        var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
        var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
        var invalidParentOrAncestor = invalidParent || invalidAncestor;
        if (!invalidParentOrAncestor) return;
        var ancestorTag = invalidParentOrAncestor.tag;
        var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag;
        if (didWarn$1[warnKey]) return;
        didWarn$1[warnKey] = true;
        var tagDisplayName = childTag;
        var whitespaceInfo = '';
        if (childTag === '#text') {
            if (/\S/.test(childText)) tagDisplayName = 'Text nodes';
            else {
                tagDisplayName = 'Whitespace text nodes';
                whitespaceInfo = " Make sure you don't have any extra whitespace between tags on each line of your source code.";
            }
        } else tagDisplayName = '<' + childTag + '>';
        if (invalidParent) {
            var info = '';
            if (ancestorTag === 'table' && childTag === 'tr') info += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser.";
            error('validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s', tagDisplayName, ancestorTag, whitespaceInfo, info);
        } else error("validateDOMNesting(...): %s cannot appear as a descendant of <%s>.", tagDisplayName, ancestorTag);
    };
    var SUPPRESS_HYDRATION_WARNING$1 = 'suppressHydrationWarning';
    var SUSPENSE_START_DATA = '$';
    var SUSPENSE_END_DATA = '/$';
    var SUSPENSE_PENDING_START_DATA = '$?';
    var SUSPENSE_FALLBACK_START_DATA = '$!';
    var STYLE$1 = 'style';
    var eventsEnabled = null;
    var selectionInformation = null;
    function getRootHostContext(rootContainerInstance) {
        var type;
        var namespace;
        var nodeType = rootContainerInstance.nodeType;
        switch(nodeType){
            case DOCUMENT_NODE:
            case DOCUMENT_FRAGMENT_NODE:
                type = nodeType === DOCUMENT_NODE ? '#document' : '#fragment';
                var root = rootContainerInstance.documentElement;
                namespace = root ? root.namespaceURI : getChildNamespace(null, '');
                break;
            default:
                var container = nodeType === COMMENT_NODE ? rootContainerInstance.parentNode : rootContainerInstance;
                var ownNamespace = container.namespaceURI || null;
                type = container.tagName;
                namespace = getChildNamespace(ownNamespace, type);
                break;
        }
        var validatedTag = type.toLowerCase();
        var ancestorInfo = updatedAncestorInfo(null, validatedTag);
        return {
            namespace: namespace,
            ancestorInfo: ancestorInfo
        };
    }
    function getChildHostContext(parentHostContext, type, rootContainerInstance) {
        var parentHostContextDev = parentHostContext;
        var namespace = getChildNamespace(parentHostContextDev.namespace, type);
        var ancestorInfo = updatedAncestorInfo(parentHostContextDev.ancestorInfo, type);
        return {
            namespace: namespace,
            ancestorInfo: ancestorInfo
        };
    }
    function getPublicInstance(instance) {
        return instance;
    }
    function prepareForCommit(containerInfo) {
        eventsEnabled = isEnabled();
        selectionInformation = getSelectionInformation();
        var activeInstance = null;
        setEnabled(false);
        return activeInstance;
    }
    function resetAfterCommit(containerInfo) {
        restoreSelection(selectionInformation);
        setEnabled(eventsEnabled);
        eventsEnabled = null;
        selectionInformation = null;
    }
    function createInstance(type, props, rootContainerInstance, hostContext, internalInstanceHandle) {
        var parentNamespace;
        // TODO: take namespace into account when validating.
        var hostContextDev = hostContext;
        validateDOMNesting(type, null, hostContextDev.ancestorInfo);
        if (typeof props.children === 'string' || typeof props.children === 'number') {
            var string = '' + props.children;
            var ownAncestorInfo = updatedAncestorInfo(hostContextDev.ancestorInfo, type);
            validateDOMNesting(null, string, ownAncestorInfo);
        }
        parentNamespace = hostContextDev.namespace;
        var domElement = createElement(type, props, rootContainerInstance, parentNamespace);
        precacheFiberNode(internalInstanceHandle, domElement);
        updateFiberProps(domElement, props);
        return domElement;
    }
    function appendInitialChild(parentInstance, child) {
        parentInstance.appendChild(child);
    }
    function finalizeInitialChildren(domElement, type, props, rootContainerInstance, hostContext) {
        setInitialProperties(domElement, type, props, rootContainerInstance);
        switch(type){
            case 'button':
            case 'input':
            case 'select':
            case 'textarea':
                return !!props.autoFocus;
            case 'img':
                return true;
            default:
                return false;
        }
    }
    function prepareUpdate(domElement, type, oldProps, newProps, rootContainerInstance, hostContext) {
        var hostContextDev = hostContext;
        if (typeof newProps.children !== typeof oldProps.children && (typeof newProps.children === 'string' || typeof newProps.children === 'number')) {
            var string = '' + newProps.children;
            var ownAncestorInfo = updatedAncestorInfo(hostContextDev.ancestorInfo, type);
            validateDOMNesting(null, string, ownAncestorInfo);
        }
        return diffProperties(domElement, type, oldProps, newProps);
    }
    function shouldSetTextContent(type, props) {
        return type === 'textarea' || type === 'noscript' || typeof props.children === 'string' || typeof props.children === 'number' || typeof props.dangerouslySetInnerHTML === 'object' && props.dangerouslySetInnerHTML !== null && props.dangerouslySetInnerHTML.__html != null;
    }
    function createTextInstance(text, rootContainerInstance, hostContext, internalInstanceHandle) {
        var hostContextDev = hostContext;
        validateDOMNesting(null, text, hostContextDev.ancestorInfo);
        var textNode = createTextNode(text, rootContainerInstance);
        precacheFiberNode(internalInstanceHandle, textNode);
        return textNode;
    }
    function getCurrentEventPriority() {
        var currentEvent = window.event;
        if (currentEvent === undefined) return DefaultEventPriority;
        return getEventPriority(currentEvent.type);
    }
    // if a component just imports ReactDOM (e.g. for findDOMNode).
    // Some environments might not have setTimeout or clearTimeout.
    var scheduleTimeout = typeof setTimeout === 'function' ? setTimeout : undefined;
    var cancelTimeout = typeof clearTimeout === 'function' ? clearTimeout : undefined;
    var noTimeout = -1;
    var localPromise = typeof Promise === 'function' ? Promise : undefined; // -------------------
    var scheduleMicrotask = typeof queueMicrotask === 'function' ? queueMicrotask : typeof localPromise !== 'undefined' ? function scheduleMicrotask(callback) {
        return localPromise.resolve(null).then(callback).catch(handleErrorInNextTick);
    } : scheduleTimeout; // TODO: Determine the best fallback here.
    function handleErrorInNextTick(error) {
        setTimeout(function() {
            throw error;
        });
    } // -------------------
    function commitMount(domElement, type, newProps, internalInstanceHandle) {
        // Despite the naming that might imply otherwise, this method only
        // fires if there is an `Update` effect scheduled during mounting.
        // This happens if `finalizeInitialChildren` returns `true` (which it
        // does to implement the `autoFocus` attribute on the client). But
        // there are also other cases when this might happen (such as patching
        // up text content during hydration mismatch). So we'll check this again.
        switch(type){
            case 'button':
            case 'input':
            case 'select':
            case 'textarea':
                if (newProps.autoFocus) domElement.focus();
                return;
            case 'img':
                if (newProps.src) domElement.src = newProps.src;
                return;
        }
    }
    function commitUpdate(domElement, updatePayload, type, oldProps, newProps, internalInstanceHandle) {
        // Apply the diff to the DOM node.
        updateProperties(domElement, updatePayload, type, oldProps, newProps); // Update the props handle so that we know which props are the ones with
        // with current event handlers.
        updateFiberProps(domElement, newProps);
    }
    function resetTextContent(domElement) {
        setTextContent(domElement, '');
    }
    function commitTextUpdate(textInstance, oldText, newText) {
        textInstance.nodeValue = newText;
    }
    function appendChild(parentInstance, child) {
        parentInstance.appendChild(child);
    }
    function appendChildToContainer(container, child) {
        var parentNode;
        if (container.nodeType === COMMENT_NODE) {
            parentNode = container.parentNode;
            parentNode.insertBefore(child, container);
        } else {
            parentNode = container;
            parentNode.appendChild(child);
        } // This container might be used for a portal.
        // If something inside a portal is clicked, that click should bubble
        // through the React tree. However, on Mobile Safari the click would
        // never bubble through the *DOM* tree unless an ancestor with onclick
        // event exists. So we wouldn't see it and dispatch it.
        // This is why we ensure that non React root containers have inline onclick
        // defined.
        // https://github.com/facebook/react/issues/11918
        var reactRootContainer = container._reactRootContainer;
        if ((reactRootContainer === null || reactRootContainer === undefined) && parentNode.onclick === null) // TODO: This cast may not be sound for SVG, MathML or custom elements.
        trapClickOnNonInteractiveElement(parentNode);
    }
    function insertBefore(parentInstance, child, beforeChild) {
        parentInstance.insertBefore(child, beforeChild);
    }
    function insertInContainerBefore(container, child, beforeChild) {
        if (container.nodeType === COMMENT_NODE) container.parentNode.insertBefore(child, beforeChild);
        else container.insertBefore(child, beforeChild);
    }
    function removeChild(parentInstance, child) {
        parentInstance.removeChild(child);
    }
    function removeChildFromContainer(container, child) {
        if (container.nodeType === COMMENT_NODE) container.parentNode.removeChild(child);
        else container.removeChild(child);
    }
    function clearSuspenseBoundary(parentInstance, suspenseInstance) {
        var node = suspenseInstance; // Delete all nodes within this suspense boundary.
        // There might be nested nodes so we need to keep track of how
        // deep we are and only break out when we're back on top.
        var depth = 0;
        do {
            var nextNode = node.nextSibling;
            parentInstance.removeChild(node);
            if (nextNode && nextNode.nodeType === COMMENT_NODE) {
                var data = nextNode.data;
                if (data === SUSPENSE_END_DATA) {
                    if (depth === 0) {
                        parentInstance.removeChild(nextNode); // Retry if any event replaying was blocked on this.
                        retryIfBlockedOn(suspenseInstance);
                        return;
                    } else depth--;
                } else if (data === SUSPENSE_START_DATA || data === SUSPENSE_PENDING_START_DATA || data === SUSPENSE_FALLBACK_START_DATA) depth++;
            }
            node = nextNode;
        }while (node); // TODO: Warn, we didn't find the end comment boundary.
        // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(suspenseInstance);
    }
    function clearSuspenseBoundaryFromContainer(container, suspenseInstance) {
        if (container.nodeType === COMMENT_NODE) clearSuspenseBoundary(container.parentNode, suspenseInstance);
        else if (container.nodeType === ELEMENT_NODE) clearSuspenseBoundary(container, suspenseInstance);
         // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(container);
    }
    function hideInstance(instance) {
        // TODO: Does this work for all element types? What about MathML? Should we
        // pass host context to this method?
        instance;
        var style = instance.style;
        if (typeof style.setProperty === 'function') style.setProperty('display', 'none', 'important');
        else style.display = 'none';
    }
    function hideTextInstance(textInstance) {
        textInstance.nodeValue = '';
    }
    function unhideInstance(instance, props) {
        instance;
        var styleProp = props[STYLE$1];
        var display = styleProp !== undefined && styleProp !== null && styleProp.hasOwnProperty('display') ? styleProp.display : null;
        instance.style.display = dangerousStyleValue('display', display);
    }
    function unhideTextInstance(textInstance, text) {
        textInstance.nodeValue = text;
    }
    function clearContainer(container) {
        if (container.nodeType === ELEMENT_NODE) container.textContent = '';
        else if (container.nodeType === DOCUMENT_NODE) {
            if (container.documentElement) container.removeChild(container.documentElement);
        }
    } // -------------------
    function canHydrateInstance(instance, type, props) {
        if (instance.nodeType !== ELEMENT_NODE || type.toLowerCase() !== instance.nodeName.toLowerCase()) return null;
         // This has now been refined to an element node.
        return instance;
    }
    function canHydrateTextInstance(instance, text) {
        if (text === '' || instance.nodeType !== TEXT_NODE) // Empty strings are not parsed by HTML so there won't be a correct match here.
        return null;
         // This has now been refined to a text node.
        return instance;
    }
    function canHydrateSuspenseInstance(instance) {
        if (instance.nodeType !== COMMENT_NODE) // Empty strings are not parsed by HTML so there won't be a correct match here.
        return null;
         // This has now been refined to a suspense node.
        return instance;
    }
    function isSuspenseInstancePending(instance) {
        return instance.data === SUSPENSE_PENDING_START_DATA;
    }
    function isSuspenseInstanceFallback(instance) {
        return instance.data === SUSPENSE_FALLBACK_START_DATA;
    }
    function getSuspenseInstanceFallbackErrorDetails(instance) {
        var dataset = instance.nextSibling && instance.nextSibling.dataset;
        var digest, message, stack;
        if (dataset) {
            digest = dataset.dgst;
            message = dataset.msg;
            stack = dataset.stck;
        }
        return {
            message: message,
            digest: digest,
            stack: stack
        };
    // const nextSibling = instance.nextSibling;
    // if (nextSibling) {
    //   const dataset = ((nextSibling: any): HTMLTemplateElement).dataset;
    //   value.message = dataset.msg;
    //   value.hash = dataset.hash;
    //   if (true) {
    //     value.stack = dataset.stack;
    //   }
    // }
    // return value;
    }
    function registerSuspenseInstanceRetry(instance, callback) {
        instance._reactRetry = callback;
    }
    function getNextHydratable(node) {
        // Skip non-hydratable nodes.
        for(; node != null; node = node.nextSibling){
            var nodeType = node.nodeType;
            if (nodeType === ELEMENT_NODE || nodeType === TEXT_NODE) break;
            if (nodeType === COMMENT_NODE) {
                var nodeData = node.data;
                if (nodeData === SUSPENSE_START_DATA || nodeData === SUSPENSE_FALLBACK_START_DATA || nodeData === SUSPENSE_PENDING_START_DATA) break;
                if (nodeData === SUSPENSE_END_DATA) return null;
            }
        }
        return node;
    }
    function getNextHydratableSibling(instance) {
        return getNextHydratable(instance.nextSibling);
    }
    function getFirstHydratableChild(parentInstance) {
        return getNextHydratable(parentInstance.firstChild);
    }
    function getFirstHydratableChildWithinContainer(parentContainer) {
        return getNextHydratable(parentContainer.firstChild);
    }
    function getFirstHydratableChildWithinSuspenseInstance(parentInstance) {
        return getNextHydratable(parentInstance.nextSibling);
    }
    function hydrateInstance(instance, type, props, rootContainerInstance, hostContext, internalInstanceHandle, shouldWarnDev) {
        precacheFiberNode(internalInstanceHandle, instance); // TODO: Possibly defer this until the commit phase where all the events
        // get attached.
        updateFiberProps(instance, props);
        var parentNamespace;
        var hostContextDev = hostContext;
        parentNamespace = hostContextDev.namespace;
        // when the legacy root API is removed.
        var isConcurrentMode = (internalInstanceHandle.mode & ConcurrentMode) !== NoMode;
        return diffHydratedProperties(instance, type, props, parentNamespace, rootContainerInstance, isConcurrentMode, shouldWarnDev);
    }
    function hydrateTextInstance(textInstance, text, internalInstanceHandle, shouldWarnDev) {
        precacheFiberNode(internalInstanceHandle, textInstance); // TODO: Temporary hack to check if we're in a concurrent root. We can delete
        // when the legacy root API is removed.
        var isConcurrentMode = (internalInstanceHandle.mode & ConcurrentMode) !== NoMode;
        return diffHydratedText(textInstance, text);
    }
    function hydrateSuspenseInstance(suspenseInstance, internalInstanceHandle) {
        precacheFiberNode(internalInstanceHandle, suspenseInstance);
    }
    function getNextHydratableInstanceAfterSuspenseInstance(suspenseInstance) {
        var node = suspenseInstance.nextSibling; // Skip past all nodes within this suspense boundary.
        // There might be nested nodes so we need to keep track of how
        // deep we are and only break out when we're back on top.
        var depth = 0;
        while(node){
            if (node.nodeType === COMMENT_NODE) {
                var data = node.data;
                if (data === SUSPENSE_END_DATA) {
                    if (depth === 0) return getNextHydratableSibling(node);
                    else depth--;
                } else if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA) depth++;
            }
            node = node.nextSibling;
        } // TODO: Warn, we didn't find the end comment boundary.
        return null;
    } // Returns the SuspenseInstance if this node is a direct child of a
    // SuspenseInstance. I.e. if its previous sibling is a Comment with
    // SUSPENSE_x_START_DATA. Otherwise, null.
    function getParentSuspenseInstance(targetInstance) {
        var node = targetInstance.previousSibling; // Skip past all nodes within this suspense boundary.
        // There might be nested nodes so we need to keep track of how
        // deep we are and only break out when we're back on top.
        var depth = 0;
        while(node){
            if (node.nodeType === COMMENT_NODE) {
                var data = node.data;
                if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA) {
                    if (depth === 0) return node;
                    else depth--;
                } else if (data === SUSPENSE_END_DATA) depth++;
            }
            node = node.previousSibling;
        }
        return null;
    }
    function commitHydratedContainer(container) {
        // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(container);
    }
    function commitHydratedSuspenseInstance(suspenseInstance) {
        // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(suspenseInstance);
    }
    function shouldDeleteUnhydratedTailInstances(parentType) {
        return parentType !== 'head' && parentType !== 'body';
    }
    function didNotMatchHydratedContainerTextInstance(parentContainer, textInstance, text, isConcurrentMode) {
        var shouldWarnDev = true;
        checkForUnmatchedText(textInstance.nodeValue, text, isConcurrentMode, shouldWarnDev);
    }
    function didNotMatchHydratedTextInstance(parentType, parentProps, parentInstance, textInstance, text, isConcurrentMode) {
        if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
            var shouldWarnDev = true;
            checkForUnmatchedText(textInstance.nodeValue, text, isConcurrentMode, shouldWarnDev);
        }
    }
    function didNotHydrateInstanceWithinContainer(parentContainer, instance) {
        if (instance.nodeType === ELEMENT_NODE) warnForDeletedHydratableElement(parentContainer, instance);
        else if (instance.nodeType === COMMENT_NODE) ;
        else warnForDeletedHydratableText(parentContainer, instance);
    }
    function didNotHydrateInstanceWithinSuspenseInstance(parentInstance, instance) {
        // $FlowFixMe: Only Element or Document can be parent nodes.
        var parentNode = parentInstance.parentNode;
        if (parentNode !== null) {
            if (instance.nodeType === ELEMENT_NODE) warnForDeletedHydratableElement(parentNode, instance);
            else if (instance.nodeType === COMMENT_NODE) ;
            else warnForDeletedHydratableText(parentNode, instance);
        }
    }
    function didNotHydrateInstance(parentType, parentProps, parentInstance, instance, isConcurrentMode) {
        if (isConcurrentMode || parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
            if (instance.nodeType === ELEMENT_NODE) warnForDeletedHydratableElement(parentInstance, instance);
            else if (instance.nodeType === COMMENT_NODE) ;
            else warnForDeletedHydratableText(parentInstance, instance);
        }
    }
    function didNotFindHydratableInstanceWithinContainer(parentContainer, type, props) {
        warnForInsertedHydratedElement(parentContainer, type);
    }
    function didNotFindHydratableTextInstanceWithinContainer(parentContainer, text) {
        warnForInsertedHydratedText(parentContainer, text);
    }
    function didNotFindHydratableInstanceWithinSuspenseInstance(parentInstance, type, props) {
        // $FlowFixMe: Only Element or Document can be parent nodes.
        var parentNode = parentInstance.parentNode;
        if (parentNode !== null) warnForInsertedHydratedElement(parentNode, type);
    }
    function didNotFindHydratableTextInstanceWithinSuspenseInstance(parentInstance, text) {
        // $FlowFixMe: Only Element or Document can be parent nodes.
        var parentNode = parentInstance.parentNode;
        if (parentNode !== null) warnForInsertedHydratedText(parentNode, text);
    }
    function didNotFindHydratableInstance(parentType, parentProps, parentInstance, type, props, isConcurrentMode) {
        if (isConcurrentMode || parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) warnForInsertedHydratedElement(parentInstance, type);
    }
    function didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, text, isConcurrentMode) {
        if (isConcurrentMode || parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) warnForInsertedHydratedText(parentInstance, text);
    }
    function errorHydratingContainer(parentContainer) {
        // TODO: This gets logged by onRecoverableError, too, so we should be
        // able to remove it.
        error('An error occurred during hydration. The server HTML was replaced with client content in <%s>.', parentContainer.nodeName.toLowerCase());
    }
    function preparePortalMount(portalInstance) {
        listenToAllSupportedEvents(portalInstance);
    }
    var randomKey = Math.random().toString(36).slice(2);
    var internalInstanceKey = '__reactFiber$' + randomKey;
    var internalPropsKey = '__reactProps$' + randomKey;
    var internalContainerInstanceKey = '__reactContainer$' + randomKey;
    var internalEventHandlersKey = '__reactEvents$' + randomKey;
    var internalEventHandlerListenersKey = '__reactListeners$' + randomKey;
    var internalEventHandlesSetKey = '__reactHandles$' + randomKey;
    function detachDeletedInstance(node) {
        // TODO: This function is only called on host components. I don't think all of
        // these fields are relevant.
        delete node[internalInstanceKey];
        delete node[internalPropsKey];
        delete node[internalEventHandlersKey];
        delete node[internalEventHandlerListenersKey];
        delete node[internalEventHandlesSetKey];
    }
    function precacheFiberNode(hostInst, node) {
        node[internalInstanceKey] = hostInst;
    }
    function markContainerAsRoot(hostRoot, node) {
        node[internalContainerInstanceKey] = hostRoot;
    }
    function unmarkContainerAsRoot(node) {
        node[internalContainerInstanceKey] = null;
    }
    function isContainerMarkedAsRoot(node) {
        return !!node[internalContainerInstanceKey];
    } // Given a DOM node, return the closest HostComponent or HostText fiber ancestor.
    // If the target node is part of a hydrated or not yet rendered subtree, then
    // this may also return a SuspenseComponent or HostRoot to indicate that.
    // Conceptually the HostRoot fiber is a child of the Container node. So if you
    // pass the Container node as the targetNode, you will not actually get the
    // HostRoot back. To get to the HostRoot, you need to pass a child of it.
    // The same thing applies to Suspense boundaries.
    function getClosestInstanceFromNode(targetNode) {
        var targetInst = targetNode[internalInstanceKey];
        if (targetInst) // Don't return HostRoot or SuspenseComponent here.
        return targetInst;
         // If the direct event target isn't a React owned DOM node, we need to look
        // to see if one of its parents is a React owned DOM node.
        var parentNode = targetNode.parentNode;
        while(parentNode){
            // We'll check if this is a container root that could include
            // React nodes in the future. We need to check this first because
            // if we're a child of a dehydrated container, we need to first
            // find that inner container before moving on to finding the parent
            // instance. Note that we don't check this field on  the targetNode
            // itself because the fibers are conceptually between the container
            // node and the first child. It isn't surrounding the container node.
            // If it's not a container, we check if it's an instance.
            targetInst = parentNode[internalContainerInstanceKey] || parentNode[internalInstanceKey];
            if (targetInst) {
                // Since this wasn't the direct target of the event, we might have
                // stepped past dehydrated DOM nodes to get here. However they could
                // also have been non-React nodes. We need to answer which one.
                // If we the instance doesn't have any children, then there can't be
                // a nested suspense boundary within it. So we can use this as a fast
                // bailout. Most of the time, when people add non-React children to
                // the tree, it is using a ref to a child-less DOM node.
                // Normally we'd only need to check one of the fibers because if it
                // has ever gone from having children to deleting them or vice versa
                // it would have deleted the dehydrated boundary nested inside already.
                // However, since the HostRoot starts out with an alternate it might
                // have one on the alternate so we need to check in case this was a
                // root.
                var alternate = targetInst.alternate;
                if (targetInst.child !== null || alternate !== null && alternate.child !== null) {
                    // Next we need to figure out if the node that skipped past is
                    // nested within a dehydrated boundary and if so, which one.
                    var suspenseInstance = getParentSuspenseInstance(targetNode);
                    while(suspenseInstance !== null){
                        // We found a suspense instance. That means that we haven't
                        // hydrated it yet. Even though we leave the comments in the
                        // DOM after hydrating, and there are boundaries in the DOM
                        // that could already be hydrated, we wouldn't have found them
                        // through this pass since if the target is hydrated it would
                        // have had an internalInstanceKey on it.
                        // Let's get the fiber associated with the SuspenseComponent
                        // as the deepest instance.
                        var targetSuspenseInst = suspenseInstance[internalInstanceKey];
                        if (targetSuspenseInst) return targetSuspenseInst;
                         // If we don't find a Fiber on the comment, it might be because
                        // we haven't gotten to hydrate it yet. There might still be a
                        // parent boundary that hasn't above this one so we need to find
                        // the outer most that is known.
                        suspenseInstance = getParentSuspenseInstance(suspenseInstance); // If we don't find one, then that should mean that the parent
                    // host component also hasn't hydrated yet. We can return it
                    // below since it will bail out on the isMounted check later.
                    }
                }
                return targetInst;
            }
            targetNode = parentNode;
            parentNode = targetNode.parentNode;
        }
        return null;
    }
    /**
 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
 * instance, or null if the node was not rendered by this React.
 */ function getInstanceFromNode(node) {
        var inst = node[internalInstanceKey] || node[internalContainerInstanceKey];
        if (inst) {
            if (inst.tag === HostComponent || inst.tag === HostText || inst.tag === SuspenseComponent || inst.tag === HostRoot) return inst;
            else return null;
        }
        return null;
    }
    /**
 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
 * DOM node.
 */ function getNodeFromInstance(inst) {
        if (inst.tag === HostComponent || inst.tag === HostText) // In Fiber this, is just the state node right now. We assume it will be
        // a host component or host text.
        return inst.stateNode;
         // Without this first invariant, passing a non-DOM-component triggers the next
        // invariant for a missing parent, which is super confusing.
        throw new Error('getNodeFromInstance: Invalid argument.');
    }
    function getFiberCurrentPropsFromNode(node) {
        return node[internalPropsKey] || null;
    }
    function updateFiberProps(node, props) {
        node[internalPropsKey] = props;
    }
    function getEventListenerSet(node) {
        var elementListenerSet = node[internalEventHandlersKey];
        if (elementListenerSet === undefined) elementListenerSet = node[internalEventHandlersKey] = new Set();
        return elementListenerSet;
    }
    var loggedTypeFailures = {};
    var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
    function checkPropTypes(typeSpecs, values, location, componentName, element) {
        // $FlowFixMe This is okay but Flow doesn't know it.
        var has = Function.call.bind(hasOwnProperty);
        for(var typeSpecName in typeSpecs)if (has(typeSpecs, typeSpecName)) {
            var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.
            try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                if (typeof typeSpecs[typeSpecName] !== 'function') {
                    // eslint-disable-next-line react-internal/prod-error-codes
                    var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
                    err.name = 'Invariant Violation';
                    throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
            } catch (ex) {
                error$1 = ex;
            }
            if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || 'React class', location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
            }
            if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error('Failed %s type: %s', location, error$1.message);
                setCurrentlyValidatingElement(null);
            }
        }
    }
    var valueStack = [];
    var fiberStack;
    fiberStack = [];
    var index = -1;
    function createCursor(defaultValue) {
        return {
            current: defaultValue
        };
    }
    function pop(cursor, fiber) {
        if (index < 0) {
            error('Unexpected pop.');
            return;
        }
        if (fiber !== fiberStack[index]) error('Unexpected Fiber popped.');
        cursor.current = valueStack[index];
        valueStack[index] = null;
        fiberStack[index] = null;
        index--;
    }
    function push(cursor, value, fiber) {
        index++;
        valueStack[index] = cursor.current;
        fiberStack[index] = fiber;
        cursor.current = value;
    }
    var warnedAboutMissingGetChildContext;
    warnedAboutMissingGetChildContext = {};
    var emptyContextObject = {};
    Object.freeze(emptyContextObject);
    var contextStackCursor = createCursor(emptyContextObject); // A cursor to a boolean indicating whether the context has changed.
    var didPerformWorkStackCursor = createCursor(false); // Keep track of the previous context object that was on the stack.
    // We use this to get access to the parent context after we have already
    // pushed the next context provider, and now need to merge their contexts.
    var previousContext = emptyContextObject;
    function getUnmaskedContext(workInProgress, Component, didPushOwnContextIfProvider) {
        if (didPushOwnContextIfProvider && isContextProvider(Component)) // If the fiber is a context provider itself, when we read its context
        // we may have already pushed its own child context on the stack. A context
        // provider should not "see" its own child context. Therefore we read the
        // previous (parent) context instead for a context provider.
        return previousContext;
        return contextStackCursor.current;
    }
    function cacheContext(workInProgress, unmaskedContext, maskedContext) {
        var instance = workInProgress.stateNode;
        instance.__reactInternalMemoizedUnmaskedChildContext = unmaskedContext;
        instance.__reactInternalMemoizedMaskedChildContext = maskedContext;
    }
    function getMaskedContext(workInProgress, unmaskedContext) {
        var type = workInProgress.type;
        var contextTypes = type.contextTypes;
        if (!contextTypes) return emptyContextObject;
         // Avoid recreating masked context unless unmasked context has changed.
        // Failing to do this will result in unnecessary calls to componentWillReceiveProps.
        // This may trigger infinite loops if componentWillReceiveProps calls setState.
        var instance = workInProgress.stateNode;
        if (instance && instance.__reactInternalMemoizedUnmaskedChildContext === unmaskedContext) return instance.__reactInternalMemoizedMaskedChildContext;
        var context = {};
        for(var key in contextTypes)context[key] = unmaskedContext[key];
        var name = getComponentNameFromFiber(workInProgress) || 'Unknown';
        checkPropTypes(contextTypes, context, 'context', name);
        // Context is created before the class component is instantiated so check for instance.
        if (instance) cacheContext(workInProgress, unmaskedContext, context);
        return context;
    }
    function hasContextChanged() {
        return didPerformWorkStackCursor.current;
    }
    function isContextProvider(type) {
        var childContextTypes = type.childContextTypes;
        return childContextTypes !== null && childContextTypes !== undefined;
    }
    function popContext(fiber) {
        pop(didPerformWorkStackCursor, fiber);
        pop(contextStackCursor, fiber);
    }
    function popTopLevelContextObject(fiber) {
        pop(didPerformWorkStackCursor, fiber);
        pop(contextStackCursor, fiber);
    }
    function pushTopLevelContextObject(fiber, context, didChange) {
        if (contextStackCursor.current !== emptyContextObject) throw new Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");
        push(contextStackCursor, context, fiber);
        push(didPerformWorkStackCursor, didChange, fiber);
    }
    function processChildContext(fiber, type, parentContext) {
        var instance = fiber.stateNode;
        var childContextTypes = type.childContextTypes; // TODO (bvaughn) Replace this behavior with an invariant() in the future.
        // It has only been added in Fiber to match the (unintentional) behavior in Stack.
        if (typeof instance.getChildContext !== 'function') {
            var componentName = getComponentNameFromFiber(fiber) || 'Unknown';
            if (!warnedAboutMissingGetChildContext[componentName]) {
                warnedAboutMissingGetChildContext[componentName] = true;
                error("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", componentName, componentName);
            }
            return parentContext;
        }
        var childContext = instance.getChildContext();
        for(var contextKey in childContext){
            if (!(contextKey in childContextTypes)) throw new Error((getComponentNameFromFiber(fiber) || 'Unknown') + ".getChildContext(): key \"" + contextKey + "\" is not defined in childContextTypes.");
        }
        var name = getComponentNameFromFiber(fiber) || 'Unknown';
        checkPropTypes(childContextTypes, childContext, 'child context', name);
        return assign({}, parentContext, childContext);
    }
    function pushContextProvider(workInProgress) {
        var instance = workInProgress.stateNode; // We push the context as early as possible to ensure stack integrity.
        // If the instance does not exist yet, we will push null at first,
        // and replace it on the stack later when invalidating the context.
        var memoizedMergedChildContext = instance && instance.__reactInternalMemoizedMergedChildContext || emptyContextObject; // Remember the parent context so we can merge with it later.
        // Inherit the parent's did-perform-work value to avoid inadvertently blocking updates.
        previousContext = contextStackCursor.current;
        push(contextStackCursor, memoizedMergedChildContext, workInProgress);
        push(didPerformWorkStackCursor, didPerformWorkStackCursor.current, workInProgress);
        return true;
    }
    function invalidateContextProvider(workInProgress, type, didChange) {
        var instance = workInProgress.stateNode;
        if (!instance) throw new Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");
        if (didChange) {
            // Merge parent and own context.
            // Skip this if we're not updating due to sCU.
            // This avoids unnecessarily recomputing memoized values.
            var mergedContext = processChildContext(workInProgress, type, previousContext);
            instance.__reactInternalMemoizedMergedChildContext = mergedContext; // Replace the old (or empty) context with the new one.
            // It is important to unwind the context in the reverse order.
            pop(didPerformWorkStackCursor, workInProgress);
            pop(contextStackCursor, workInProgress); // Now push the new context and mark that it has changed.
            push(contextStackCursor, mergedContext, workInProgress);
            push(didPerformWorkStackCursor, didChange, workInProgress);
        } else {
            pop(didPerformWorkStackCursor, workInProgress);
            push(didPerformWorkStackCursor, didChange, workInProgress);
        }
    }
    function findCurrentUnmaskedContext(fiber) {
        // Currently this is only used with renderSubtreeIntoContainer; not sure if it
        // makes sense elsewhere
        if (!isFiberMounted(fiber) || fiber.tag !== ClassComponent) throw new Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");
        var node = fiber;
        do {
            switch(node.tag){
                case HostRoot:
                    return node.stateNode.context;
                case ClassComponent:
                    var Component = node.type;
                    if (isContextProvider(Component)) return node.stateNode.__reactInternalMemoizedMergedChildContext;
                    break;
            }
            node = node.return;
        }while (node !== null);
        throw new Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    var LegacyRoot = 0;
    var ConcurrentRoot = 1;
    var syncQueue = null;
    var includesLegacySyncCallbacks = false;
    var isFlushingSyncQueue = false;
    function scheduleSyncCallback(callback) {
        // Push this callback into an internal queue. We'll flush these either in
        // the next tick, or earlier if something calls `flushSyncCallbackQueue`.
        if (syncQueue === null) syncQueue = [
            callback
        ];
        else // Push onto existing queue. Don't need to schedule a callback because
        // we already scheduled one when we created the queue.
        syncQueue.push(callback);
    }
    function scheduleLegacySyncCallback(callback) {
        includesLegacySyncCallbacks = true;
        scheduleSyncCallback(callback);
    }
    function flushSyncCallbacksOnlyInLegacyMode() {
        // Only flushes the queue if there's a legacy sync callback scheduled.
        // TODO: There's only a single type of callback: performSyncOnWorkOnRoot. So
        // it might make more sense for the queue to be a list of roots instead of a
        // list of generic callbacks. Then we can have two: one for legacy roots, one
        // for concurrent roots. And this method would only flush the legacy ones.
        if (includesLegacySyncCallbacks) flushSyncCallbacks();
    }
    function flushSyncCallbacks() {
        if (!isFlushingSyncQueue && syncQueue !== null) {
            // Prevent re-entrance.
            isFlushingSyncQueue = true;
            var i = 0;
            var previousUpdatePriority = getCurrentUpdatePriority();
            try {
                var isSync = true;
                var queue = syncQueue; // TODO: Is this necessary anymore? The only user code that runs in this
                // queue is in the render or commit phases.
                setCurrentUpdatePriority(DiscreteEventPriority);
                for(; i < queue.length; i++){
                    var callback = queue[i];
                    do callback = callback(isSync);
                    while (callback !== null);
                }
                syncQueue = null;
                includesLegacySyncCallbacks = false;
            } catch (error) {
                // If something throws, leave the remaining callbacks on the queue.
                if (syncQueue !== null) syncQueue = syncQueue.slice(i + 1);
                 // Resume flushing in the next tick
                scheduleCallback(ImmediatePriority, flushSyncCallbacks);
                throw error;
            } finally{
                setCurrentUpdatePriority(previousUpdatePriority);
                isFlushingSyncQueue = false;
            }
        }
        return null;
    }
    // TODO: Use the unified fiber stack module instead of this local one?
    // Intentionally not using it yet to derisk the initial implementation, because
    // the way we push/pop these values is a bit unusual. If there's a mistake, I'd
    // rather the ids be wrong than crash the whole reconciler.
    var forkStack = [];
    var forkStackIndex = 0;
    var treeForkProvider = null;
    var treeForkCount = 0;
    var idStack = [];
    var idStackIndex = 0;
    var treeContextProvider = null;
    var treeContextId = 1;
    var treeContextOverflow = '';
    function isForkedChild(workInProgress) {
        warnIfNotHydrating();
        return (workInProgress.flags & Forked) !== NoFlags;
    }
    function getForksAtLevel(workInProgress) {
        warnIfNotHydrating();
        return treeForkCount;
    }
    function getTreeId() {
        var overflow = treeContextOverflow;
        var idWithLeadingBit = treeContextId;
        var id = idWithLeadingBit & ~getLeadingBit(idWithLeadingBit);
        return id.toString(32) + overflow;
    }
    function pushTreeFork(workInProgress, totalChildren) {
        // This is called right after we reconcile an array (or iterator) of child
        // fibers, because that's the only place where we know how many children in
        // the whole set without doing extra work later, or storing addtional
        // information on the fiber.
        //
        // That's why this function is separate from pushTreeId — it's called during
        // the render phase of the fork parent, not the child, which is where we push
        // the other context values.
        //
        // In the Fizz implementation this is much simpler because the child is
        // rendered in the same callstack as the parent.
        //
        // It might be better to just add a `forks` field to the Fiber type. It would
        // make this module simpler.
        warnIfNotHydrating();
        forkStack[forkStackIndex++] = treeForkCount;
        forkStack[forkStackIndex++] = treeForkProvider;
        treeForkProvider = workInProgress;
        treeForkCount = totalChildren;
    }
    function pushTreeId(workInProgress, totalChildren, index) {
        warnIfNotHydrating();
        idStack[idStackIndex++] = treeContextId;
        idStack[idStackIndex++] = treeContextOverflow;
        idStack[idStackIndex++] = treeContextProvider;
        treeContextProvider = workInProgress;
        var baseIdWithLeadingBit = treeContextId;
        var baseOverflow = treeContextOverflow; // The leftmost 1 marks the end of the sequence, non-inclusive. It's not part
        // of the id; we use it to account for leading 0s.
        var baseLength = getBitLength(baseIdWithLeadingBit) - 1;
        var baseId = baseIdWithLeadingBit & ~(1 << baseLength);
        var slot = index + 1;
        var length = getBitLength(totalChildren) + baseLength; // 30 is the max length we can store without overflowing, taking into
        // consideration the leading 1 we use to mark the end of the sequence.
        if (length > 30) {
            // We overflowed the bitwise-safe range. Fall back to slower algorithm.
            // This branch assumes the length of the base id is greater than 5; it won't
            // work for smaller ids, because you need 5 bits per character.
            //
            // We encode the id in multiple steps: first the base id, then the
            // remaining digits.
            //
            // Each 5 bit sequence corresponds to a single base 32 character. So for
            // example, if the current id is 23 bits long, we can convert 20 of those
            // bits into a string of 4 characters, with 3 bits left over.
            //
            // First calculate how many bits in the base id represent a complete
            // sequence of characters.
            var numberOfOverflowBits = baseLength - baseLength % 5; // Then create a bitmask that selects only those bits.
            var newOverflowBits = (1 << numberOfOverflowBits) - 1; // Select the bits, and convert them to a base 32 string.
            var newOverflow = (baseId & newOverflowBits).toString(32); // Now we can remove those bits from the base id.
            var restOfBaseId = baseId >> numberOfOverflowBits;
            var restOfBaseLength = baseLength - numberOfOverflowBits; // Finally, encode the rest of the bits using the normal algorithm. Because
            // we made more room, this time it won't overflow.
            var restOfLength = getBitLength(totalChildren) + restOfBaseLength;
            var restOfNewBits = slot << restOfBaseLength;
            var id = restOfNewBits | restOfBaseId;
            var overflow = newOverflow + baseOverflow;
            treeContextId = 1 << restOfLength | id;
            treeContextOverflow = overflow;
        } else {
            // Normal path
            var newBits = slot << baseLength;
            var _id = newBits | baseId;
            var _overflow = baseOverflow;
            treeContextId = 1 << length | _id;
            treeContextOverflow = _overflow;
        }
    }
    function pushMaterializedTreeId(workInProgress) {
        warnIfNotHydrating(); // This component materialized an id. This will affect any ids that appear
        // in its children.
        var returnFiber = workInProgress.return;
        if (returnFiber !== null) {
            var numberOfForks = 1;
            var slotIndex = 0;
            pushTreeFork(workInProgress, numberOfForks);
            pushTreeId(workInProgress, numberOfForks, slotIndex);
        }
    }
    function getBitLength(number) {
        return 32 - clz32(number);
    }
    function getLeadingBit(id) {
        return 1 << getBitLength(id) - 1;
    }
    function popTreeContext(workInProgress) {
        // Restore the previous values.
        // This is a bit more complicated than other context-like modules in Fiber
        // because the same Fiber may appear on the stack multiple times and for
        // different reasons. We have to keep popping until the work-in-progress is
        // no longer at the top of the stack.
        while(workInProgress === treeForkProvider){
            treeForkProvider = forkStack[--forkStackIndex];
            forkStack[forkStackIndex] = null;
            treeForkCount = forkStack[--forkStackIndex];
            forkStack[forkStackIndex] = null;
        }
        while(workInProgress === treeContextProvider){
            treeContextProvider = idStack[--idStackIndex];
            idStack[idStackIndex] = null;
            treeContextOverflow = idStack[--idStackIndex];
            idStack[idStackIndex] = null;
            treeContextId = idStack[--idStackIndex];
            idStack[idStackIndex] = null;
        }
    }
    function getSuspendedTreeContext() {
        warnIfNotHydrating();
        if (treeContextProvider !== null) return {
            id: treeContextId,
            overflow: treeContextOverflow
        };
        else return null;
    }
    function restoreSuspendedTreeContext(workInProgress, suspendedContext) {
        warnIfNotHydrating();
        idStack[idStackIndex++] = treeContextId;
        idStack[idStackIndex++] = treeContextOverflow;
        idStack[idStackIndex++] = treeContextProvider;
        treeContextId = suspendedContext.id;
        treeContextOverflow = suspendedContext.overflow;
        treeContextProvider = workInProgress;
    }
    function warnIfNotHydrating() {
        if (!getIsHydrating()) error("Expected to be hydrating. This is a bug in React. Please file an issue.");
    }
    // This may have been an insertion or a hydration.
    var hydrationParentFiber = null;
    var nextHydratableInstance = null;
    var isHydrating = false; // This flag allows for warning supression when we expect there to be mismatches
    // due to earlier mismatches or a suspended fiber.
    var didSuspendOrErrorDEV = false; // Hydration errors that were thrown inside this boundary
    var hydrationErrors = null;
    function warnIfHydrating() {
        if (isHydrating) error('We should not be hydrating here. This is a bug in React. Please file a bug.');
    }
    function markDidThrowWhileHydratingDEV() {
        didSuspendOrErrorDEV = true;
    }
    function didSuspendOrErrorWhileHydratingDEV() {
        return didSuspendOrErrorDEV;
    }
    function enterHydrationState(fiber) {
        var parentInstance = fiber.stateNode.containerInfo;
        nextHydratableInstance = getFirstHydratableChildWithinContainer(parentInstance);
        hydrationParentFiber = fiber;
        isHydrating = true;
        hydrationErrors = null;
        didSuspendOrErrorDEV = false;
        return true;
    }
    function reenterHydrationStateFromDehydratedSuspenseInstance(fiber, suspenseInstance, treeContext) {
        nextHydratableInstance = getFirstHydratableChildWithinSuspenseInstance(suspenseInstance);
        hydrationParentFiber = fiber;
        isHydrating = true;
        hydrationErrors = null;
        didSuspendOrErrorDEV = false;
        if (treeContext !== null) restoreSuspendedTreeContext(fiber, treeContext);
        return true;
    }
    function warnUnhydratedInstance(returnFiber, instance) {
        switch(returnFiber.tag){
            case HostRoot:
                didNotHydrateInstanceWithinContainer(returnFiber.stateNode.containerInfo, instance);
                break;
            case HostComponent:
                var isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;
                didNotHydrateInstance(returnFiber.type, returnFiber.memoizedProps, returnFiber.stateNode, instance, isConcurrentMode);
                break;
            case SuspenseComponent:
                var suspenseState = returnFiber.memoizedState;
                if (suspenseState.dehydrated !== null) didNotHydrateInstanceWithinSuspenseInstance(suspenseState.dehydrated, instance);
                break;
        }
    }
    function deleteHydratableInstance(returnFiber, instance) {
        warnUnhydratedInstance(returnFiber, instance);
        var childToDelete = createFiberFromHostInstanceForDeletion();
        childToDelete.stateNode = instance;
        childToDelete.return = returnFiber;
        var deletions = returnFiber.deletions;
        if (deletions === null) {
            returnFiber.deletions = [
                childToDelete
            ];
            returnFiber.flags |= ChildDeletion;
        } else deletions.push(childToDelete);
    }
    function warnNonhydratedInstance(returnFiber, fiber) {
        if (didSuspendOrErrorDEV) // Inside a boundary that already suspended. We're currently rendering the
        // siblings of a suspended node. The mismatch may be due to the missing
        // data, so it's probably a false positive.
        return;
        switch(returnFiber.tag){
            case HostRoot:
                var parentContainer = returnFiber.stateNode.containerInfo;
                switch(fiber.tag){
                    case HostComponent:
                        var type = fiber.type;
                        var props = fiber.pendingProps;
                        didNotFindHydratableInstanceWithinContainer(parentContainer, type);
                        break;
                    case HostText:
                        var text = fiber.pendingProps;
                        didNotFindHydratableTextInstanceWithinContainer(parentContainer, text);
                        break;
                }
                break;
            case HostComponent:
                var parentType = returnFiber.type;
                var parentProps = returnFiber.memoizedProps;
                var parentInstance = returnFiber.stateNode;
                switch(fiber.tag){
                    case HostComponent:
                        var _type = fiber.type;
                        var _props = fiber.pendingProps;
                        var isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;
                        didNotFindHydratableInstance(parentType, parentProps, parentInstance, _type, _props, isConcurrentMode);
                        break;
                    case HostText:
                        var _text = fiber.pendingProps;
                        var _isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;
                        didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, _text, _isConcurrentMode);
                        break;
                }
                break;
            case SuspenseComponent:
                var suspenseState = returnFiber.memoizedState;
                var _parentInstance = suspenseState.dehydrated;
                if (_parentInstance !== null) switch(fiber.tag){
                    case HostComponent:
                        var _type2 = fiber.type;
                        var _props2 = fiber.pendingProps;
                        didNotFindHydratableInstanceWithinSuspenseInstance(_parentInstance, _type2);
                        break;
                    case HostText:
                        var _text2 = fiber.pendingProps;
                        didNotFindHydratableTextInstanceWithinSuspenseInstance(_parentInstance, _text2);
                        break;
                }
                break;
            default:
                return;
        }
    }
    function insertNonHydratedInstance(returnFiber, fiber) {
        fiber.flags = fiber.flags & ~Hydrating | Placement;
        warnNonhydratedInstance(returnFiber, fiber);
    }
    function tryHydrate(fiber, nextInstance) {
        switch(fiber.tag){
            case HostComponent:
                var type = fiber.type;
                var props = fiber.pendingProps;
                var instance = canHydrateInstance(nextInstance, type);
                if (instance !== null) {
                    fiber.stateNode = instance;
                    hydrationParentFiber = fiber;
                    nextHydratableInstance = getFirstHydratableChild(instance);
                    return true;
                }
                return false;
            case HostText:
                var text = fiber.pendingProps;
                var textInstance = canHydrateTextInstance(nextInstance, text);
                if (textInstance !== null) {
                    fiber.stateNode = textInstance;
                    hydrationParentFiber = fiber; // Text Instances don't have children so there's nothing to hydrate.
                    nextHydratableInstance = null;
                    return true;
                }
                return false;
            case SuspenseComponent:
                var suspenseInstance = canHydrateSuspenseInstance(nextInstance);
                if (suspenseInstance !== null) {
                    var suspenseState = {
                        dehydrated: suspenseInstance,
                        treeContext: getSuspendedTreeContext(),
                        retryLane: OffscreenLane
                    };
                    fiber.memoizedState = suspenseState; // Store the dehydrated fragment as a child fiber.
                    // This simplifies the code for getHostSibling and deleting nodes,
                    // since it doesn't have to consider all Suspense boundaries and
                    // check if they're dehydrated ones or not.
                    var dehydratedFragment = createFiberFromDehydratedFragment(suspenseInstance);
                    dehydratedFragment.return = fiber;
                    fiber.child = dehydratedFragment;
                    hydrationParentFiber = fiber; // While a Suspense Instance does have children, we won't step into
                    // it during the first pass. Instead, we'll reenter it later.
                    nextHydratableInstance = null;
                    return true;
                }
                return false;
            default:
                return false;
        }
    }
    function shouldClientRenderOnMismatch(fiber) {
        return (fiber.mode & ConcurrentMode) !== NoMode && (fiber.flags & DidCapture) === NoFlags;
    }
    function throwOnHydrationMismatch(fiber) {
        throw new Error("Hydration failed because the initial UI does not match what was rendered on the server.");
    }
    function tryToClaimNextHydratableInstance(fiber) {
        if (!isHydrating) return;
        var nextInstance = nextHydratableInstance;
        if (!nextInstance) {
            if (shouldClientRenderOnMismatch(fiber)) {
                warnNonhydratedInstance(hydrationParentFiber, fiber);
                throwOnHydrationMismatch();
            } // Nothing to hydrate. Make it an insertion.
            insertNonHydratedInstance(hydrationParentFiber, fiber);
            isHydrating = false;
            hydrationParentFiber = fiber;
            return;
        }
        var firstAttemptedInstance = nextInstance;
        if (!tryHydrate(fiber, nextInstance)) {
            if (shouldClientRenderOnMismatch(fiber)) {
                warnNonhydratedInstance(hydrationParentFiber, fiber);
                throwOnHydrationMismatch();
            } // If we can't hydrate this instance let's try the next one.
            // We use this as a heuristic. It's based on intuition and not data so it
            // might be flawed or unnecessary.
            nextInstance = getNextHydratableSibling(firstAttemptedInstance);
            var prevHydrationParentFiber = hydrationParentFiber;
            if (!nextInstance || !tryHydrate(fiber, nextInstance)) {
                // Nothing to hydrate. Make it an insertion.
                insertNonHydratedInstance(hydrationParentFiber, fiber);
                isHydrating = false;
                hydrationParentFiber = fiber;
                return;
            } // We matched the next one, we'll now assume that the first one was
            // superfluous and we'll delete it. Since we can't eagerly delete it
            // we'll have to schedule a deletion. To do that, this node needs a dummy
            // fiber associated with it.
            deleteHydratableInstance(prevHydrationParentFiber, firstAttemptedInstance);
        }
    }
    function prepareToHydrateHostInstance(fiber, rootContainerInstance, hostContext) {
        var instance = fiber.stateNode;
        var shouldWarnIfMismatchDev = !didSuspendOrErrorDEV;
        var updatePayload = hydrateInstance(instance, fiber.type, fiber.memoizedProps, rootContainerInstance, hostContext, fiber, shouldWarnIfMismatchDev); // TODO: Type this specific to this type of component.
        fiber.updateQueue = updatePayload; // If the update payload indicates that there is a change or if there
        // is a new ref we mark this as an update.
        if (updatePayload !== null) return true;
        return false;
    }
    function prepareToHydrateHostTextInstance(fiber) {
        var textInstance = fiber.stateNode;
        var textContent = fiber.memoizedProps;
        var shouldUpdate = hydrateTextInstance(textInstance, textContent, fiber);
        if (shouldUpdate) {
            // We assume that prepareToHydrateHostTextInstance is called in a context where the
            // hydration parent is the parent host component of this host text.
            var returnFiber = hydrationParentFiber;
            if (returnFiber !== null) switch(returnFiber.tag){
                case HostRoot:
                    var parentContainer = returnFiber.stateNode.containerInfo;
                    var isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;
                    didNotMatchHydratedContainerTextInstance(parentContainer, textInstance, textContent, isConcurrentMode);
                    break;
                case HostComponent:
                    var parentType = returnFiber.type;
                    var parentProps = returnFiber.memoizedProps;
                    var parentInstance = returnFiber.stateNode;
                    var _isConcurrentMode2 = (returnFiber.mode & ConcurrentMode) !== NoMode;
                    didNotMatchHydratedTextInstance(parentType, parentProps, parentInstance, textInstance, textContent, _isConcurrentMode2);
                    break;
            }
        }
        return shouldUpdate;
    }
    function prepareToHydrateHostSuspenseInstance(fiber) {
        var suspenseState = fiber.memoizedState;
        var suspenseInstance = suspenseState !== null ? suspenseState.dehydrated : null;
        if (!suspenseInstance) throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
        hydrateSuspenseInstance(suspenseInstance, fiber);
    }
    function skipPastDehydratedSuspenseInstance(fiber) {
        var suspenseState = fiber.memoizedState;
        var suspenseInstance = suspenseState !== null ? suspenseState.dehydrated : null;
        if (!suspenseInstance) throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
        return getNextHydratableInstanceAfterSuspenseInstance(suspenseInstance);
    }
    function popToNextHostParent(fiber) {
        var parent = fiber.return;
        while(parent !== null && parent.tag !== HostComponent && parent.tag !== HostRoot && parent.tag !== SuspenseComponent)parent = parent.return;
        hydrationParentFiber = parent;
    }
    function popHydrationState(fiber) {
        if (fiber !== hydrationParentFiber) // We're deeper than the current hydration context, inside an inserted
        // tree.
        return false;
        if (!isHydrating) {
            // If we're not currently hydrating but we're in a hydration context, then
            // we were an insertion and now need to pop up reenter hydration of our
            // siblings.
            popToNextHostParent(fiber);
            isHydrating = true;
            return false;
        } // If we have any remaining hydratable nodes, we need to delete them now.
        // We only do this deeper than head and body since they tend to have random
        // other nodes in them. We also ignore components with pure text content in
        // side of them. We also don't delete anything inside the root container.
        if (fiber.tag !== HostRoot && (fiber.tag !== HostComponent || shouldDeleteUnhydratedTailInstances(fiber.type) && !shouldSetTextContent(fiber.type, fiber.memoizedProps))) {
            var nextInstance = nextHydratableInstance;
            if (nextInstance) {
                if (shouldClientRenderOnMismatch(fiber)) {
                    warnIfUnhydratedTailNodes(fiber);
                    throwOnHydrationMismatch();
                } else while(nextInstance){
                    deleteHydratableInstance(fiber, nextInstance);
                    nextInstance = getNextHydratableSibling(nextInstance);
                }
            }
        }
        popToNextHostParent(fiber);
        if (fiber.tag === SuspenseComponent) nextHydratableInstance = skipPastDehydratedSuspenseInstance(fiber);
        else nextHydratableInstance = hydrationParentFiber ? getNextHydratableSibling(fiber.stateNode) : null;
        return true;
    }
    function hasUnhydratedTailNodes() {
        return isHydrating && nextHydratableInstance !== null;
    }
    function warnIfUnhydratedTailNodes(fiber) {
        var nextInstance = nextHydratableInstance;
        while(nextInstance){
            warnUnhydratedInstance(fiber, nextInstance);
            nextInstance = getNextHydratableSibling(nextInstance);
        }
    }
    function resetHydrationState() {
        hydrationParentFiber = null;
        nextHydratableInstance = null;
        isHydrating = false;
        didSuspendOrErrorDEV = false;
    }
    function upgradeHydrationErrorsToRecoverable() {
        if (hydrationErrors !== null) {
            // Successfully completed a forced client render. The errors that occurred
            // during the hydration attempt are now recovered. We will log them in
            // commit phase, once the entire tree has finished.
            queueRecoverableErrors(hydrationErrors);
            hydrationErrors = null;
        }
    }
    function getIsHydrating() {
        return isHydrating;
    }
    function queueHydrationError(error) {
        if (hydrationErrors === null) hydrationErrors = [
            error
        ];
        else hydrationErrors.push(error);
    }
    var ReactCurrentBatchConfig$1 = ReactSharedInternals.ReactCurrentBatchConfig;
    var NoTransition = null;
    function requestCurrentTransition() {
        return ReactCurrentBatchConfig$1.transition;
    }
    var ReactStrictModeWarnings = {
        recordUnsafeLifecycleWarnings: function recordUnsafeLifecycleWarnings(fiber, instance) {},
        flushPendingUnsafeLifecycleWarnings: function flushPendingUnsafeLifecycleWarnings() {},
        recordLegacyContextWarning: function recordLegacyContextWarning(fiber, instance) {},
        flushLegacyContextWarning: function flushLegacyContextWarning() {},
        discardPendingWarnings: function discardPendingWarnings() {}
    };
    var findStrictRoot = function findStrictRoot(fiber) {
        var maybeStrictRoot = null;
        var node = fiber;
        while(node !== null){
            if (node.mode & StrictLegacyMode) maybeStrictRoot = node;
            node = node.return;
        }
        return maybeStrictRoot;
    };
    var setToSortedString = function setToSortedString(set) {
        var array = [];
        set.forEach(function(value) {
            array.push(value);
        });
        return array.sort().join(', ');
    };
    var pendingComponentWillMountWarnings = [];
    var pendingUNSAFE_ComponentWillMountWarnings = [];
    var pendingComponentWillReceivePropsWarnings = [];
    var pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
    var pendingComponentWillUpdateWarnings = [];
    var pendingUNSAFE_ComponentWillUpdateWarnings = []; // Tracks components we have already warned about.
    var didWarnAboutUnsafeLifecycles = new Set();
    ReactStrictModeWarnings.recordUnsafeLifecycleWarnings = function(fiber, instance) {
        // Dedupe strategy: Warn once per component.
        if (didWarnAboutUnsafeLifecycles.has(fiber.type)) return;
        if (typeof instance.componentWillMount === 'function' && // Don't warn about react-lifecycles-compat polyfilled components.
        instance.componentWillMount.__suppressDeprecationWarning !== true) pendingComponentWillMountWarnings.push(fiber);
        if (fiber.mode & StrictLegacyMode && typeof instance.UNSAFE_componentWillMount === 'function') pendingUNSAFE_ComponentWillMountWarnings.push(fiber);
        if (typeof instance.componentWillReceiveProps === 'function' && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) pendingComponentWillReceivePropsWarnings.push(fiber);
        if (fiber.mode & StrictLegacyMode && typeof instance.UNSAFE_componentWillReceiveProps === 'function') pendingUNSAFE_ComponentWillReceivePropsWarnings.push(fiber);
        if (typeof instance.componentWillUpdate === 'function' && instance.componentWillUpdate.__suppressDeprecationWarning !== true) pendingComponentWillUpdateWarnings.push(fiber);
        if (fiber.mode & StrictLegacyMode && typeof instance.UNSAFE_componentWillUpdate === 'function') pendingUNSAFE_ComponentWillUpdateWarnings.push(fiber);
    };
    ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings = function() {
        // We do an initial pass to gather component names
        var componentWillMountUniqueNames = new Set();
        if (pendingComponentWillMountWarnings.length > 0) {
            pendingComponentWillMountWarnings.forEach(function(fiber) {
                componentWillMountUniqueNames.add(getComponentNameFromFiber(fiber) || 'Component');
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillMountWarnings = [];
        }
        var UNSAFE_componentWillMountUniqueNames = new Set();
        if (pendingUNSAFE_ComponentWillMountWarnings.length > 0) {
            pendingUNSAFE_ComponentWillMountWarnings.forEach(function(fiber) {
                UNSAFE_componentWillMountUniqueNames.add(getComponentNameFromFiber(fiber) || 'Component');
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillMountWarnings = [];
        }
        var componentWillReceivePropsUniqueNames = new Set();
        if (pendingComponentWillReceivePropsWarnings.length > 0) {
            pendingComponentWillReceivePropsWarnings.forEach(function(fiber) {
                componentWillReceivePropsUniqueNames.add(getComponentNameFromFiber(fiber) || 'Component');
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillReceivePropsWarnings = [];
        }
        var UNSAFE_componentWillReceivePropsUniqueNames = new Set();
        if (pendingUNSAFE_ComponentWillReceivePropsWarnings.length > 0) {
            pendingUNSAFE_ComponentWillReceivePropsWarnings.forEach(function(fiber) {
                UNSAFE_componentWillReceivePropsUniqueNames.add(getComponentNameFromFiber(fiber) || 'Component');
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
        }
        var componentWillUpdateUniqueNames = new Set();
        if (pendingComponentWillUpdateWarnings.length > 0) {
            pendingComponentWillUpdateWarnings.forEach(function(fiber) {
                componentWillUpdateUniqueNames.add(getComponentNameFromFiber(fiber) || 'Component');
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillUpdateWarnings = [];
        }
        var UNSAFE_componentWillUpdateUniqueNames = new Set();
        if (pendingUNSAFE_ComponentWillUpdateWarnings.length > 0) {
            pendingUNSAFE_ComponentWillUpdateWarnings.forEach(function(fiber) {
                UNSAFE_componentWillUpdateUniqueNames.add(getComponentNameFromFiber(fiber) || 'Component');
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillUpdateWarnings = [];
        } // Finally, we flush all the warnings
        // UNSAFE_ ones before the deprecated ones, since they'll be 'louder'
        if (UNSAFE_componentWillMountUniqueNames.size > 0) {
            var sortedNames = setToSortedString(UNSAFE_componentWillMountUniqueNames);
            error("Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n\nPlease update the following components: %s", sortedNames);
        }
        if (UNSAFE_componentWillReceivePropsUniqueNames.size > 0) {
            var _sortedNames = setToSortedString(UNSAFE_componentWillReceivePropsUniqueNames);
            error("Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state\n\nPlease update the following components: %s", _sortedNames);
        }
        if (UNSAFE_componentWillUpdateUniqueNames.size > 0) {
            var _sortedNames2 = setToSortedString(UNSAFE_componentWillUpdateUniqueNames);
            error("Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n\nPlease update the following components: %s", _sortedNames2);
        }
        if (componentWillMountUniqueNames.size > 0) {
            var _sortedNames3 = setToSortedString(componentWillMountUniqueNames);
            warn("componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames3);
        }
        if (componentWillReceivePropsUniqueNames.size > 0) {
            var _sortedNames4 = setToSortedString(componentWillReceivePropsUniqueNames);
            warn("componentWillReceiveProps has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state\n* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames4);
        }
        if (componentWillUpdateUniqueNames.size > 0) {
            var _sortedNames5 = setToSortedString(componentWillUpdateUniqueNames);
            warn("componentWillUpdate has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames5);
        }
    };
    var pendingLegacyContextWarning = new Map(); // Tracks components we have already warned about.
    var didWarnAboutLegacyContext = new Set();
    ReactStrictModeWarnings.recordLegacyContextWarning = function(fiber, instance) {
        var strictRoot = findStrictRoot(fiber);
        if (strictRoot === null) {
            error("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.");
            return;
        } // Dedup strategy: Warn once per component.
        if (didWarnAboutLegacyContext.has(fiber.type)) return;
        var warningsForRoot = pendingLegacyContextWarning.get(strictRoot);
        if (fiber.type.contextTypes != null || fiber.type.childContextTypes != null || instance !== null && typeof instance.getChildContext === 'function') {
            if (warningsForRoot === undefined) {
                warningsForRoot = [];
                pendingLegacyContextWarning.set(strictRoot, warningsForRoot);
            }
            warningsForRoot.push(fiber);
        }
    };
    ReactStrictModeWarnings.flushLegacyContextWarning = function() {
        pendingLegacyContextWarning.forEach(function(fiberArray, strictRoot) {
            if (fiberArray.length === 0) return;
            var firstFiber = fiberArray[0];
            var uniqueNames = new Set();
            fiberArray.forEach(function(fiber) {
                uniqueNames.add(getComponentNameFromFiber(fiber) || 'Component');
                didWarnAboutLegacyContext.add(fiber.type);
            });
            var sortedNames = setToSortedString(uniqueNames);
            try {
                setCurrentFiber(firstFiber);
                error("Legacy context API has been detected within a strict-mode tree.\n\nThe old API will be supported in all 16.x releases, but applications using it should migrate to the new version.\n\nPlease update the following components: %s\n\nLearn more about this warning here: https://reactjs.org/link/legacy-context", sortedNames);
            } finally{
                resetCurrentFiber();
            }
        });
    };
    ReactStrictModeWarnings.discardPendingWarnings = function() {
        pendingComponentWillMountWarnings = [];
        pendingUNSAFE_ComponentWillMountWarnings = [];
        pendingComponentWillReceivePropsWarnings = [];
        pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
        pendingComponentWillUpdateWarnings = [];
        pendingUNSAFE_ComponentWillUpdateWarnings = [];
        pendingLegacyContextWarning = new Map();
    };
    var didWarnAboutMaps;
    var didWarnAboutGenerators;
    var didWarnAboutStringRefs;
    var ownerHasKeyUseWarning;
    var ownerHasFunctionTypeWarning;
    var warnForMissingKey = function warnForMissingKey(child, returnFiber) {};
    didWarnAboutMaps = false;
    didWarnAboutGenerators = false;
    didWarnAboutStringRefs = {};
    /**
   * Warn if there's no key explicitly set on dynamic arrays of children or
   * object keys are not valid. This allows us to keep track of children between
   * updates.
   */ ownerHasKeyUseWarning = {};
    ownerHasFunctionTypeWarning = {};
    warnForMissingKey = function warnForMissingKey(child, returnFiber) {
        if (child === null || typeof child !== 'object') return;
        if (!child._store || child._store.validated || child.key != null) return;
        if (typeof child._store !== 'object') throw new Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
        child._store.validated = true;
        var componentName = getComponentNameFromFiber(returnFiber) || 'Component';
        if (ownerHasKeyUseWarning[componentName]) return;
        ownerHasKeyUseWarning[componentName] = true;
        error('Each child in a list should have a unique "key" prop. See https://reactjs.org/link/warning-keys for more information.');
    };
    function isReactClass(type) {
        return type.prototype && type.prototype.isReactComponent;
    }
    function coerceRef(returnFiber, current, element) {
        var mixedRef = element.ref;
        if (mixedRef !== null && typeof mixedRef !== 'function' && typeof mixedRef !== 'object') {
            // TODO: Clean this up once we turn on the string ref warning for
            // everyone, because the strict mode case will no longer be relevant
            if ((returnFiber.mode & StrictLegacyMode || warnAboutStringRefs) && // We warn in ReactElement.js if owner and self are equal for string refs
            // because these cannot be automatically converted to an arrow function
            // using a codemod. Therefore, we don't have to warn about string refs again.
            !(element._owner && element._self && element._owner.stateNode !== element._self) && // Will already throw with "Function components cannot have string refs"
            !(element._owner && element._owner.tag !== ClassComponent) && // Will already warn with "Function components cannot be given refs"
            !(typeof element.type === 'function' && !isReactClass(element.type)) && // Will already throw with "Element ref was specified as a string (someStringRef) but no owner was set"
            element._owner) {
                var componentName = getComponentNameFromFiber(returnFiber) || 'Component';
                if (!didWarnAboutStringRefs[componentName]) {
                    error('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. We recommend using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', componentName, mixedRef);
                    didWarnAboutStringRefs[componentName] = true;
                }
            }
            if (element._owner) {
                var owner = element._owner;
                var inst;
                if (owner) {
                    var ownerFiber = owner;
                    if (ownerFiber.tag !== ClassComponent) throw new Error("Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref");
                    inst = ownerFiber.stateNode;
                }
                if (!inst) throw new Error("Missing owner for string ref " + mixedRef + ". This error is likely caused by a " + 'bug in React. Please file an issue.');
                 // Assigning this to a const so Flow knows it won't change in the closure
                var resolvedInst = inst;
                checkPropStringCoercion(mixedRef, 'ref');
                var stringRef = '' + mixedRef; // Check if previous string ref matches new string ref
                if (current !== null && current.ref !== null && typeof current.ref === 'function' && current.ref._stringRef === stringRef) return current.ref;
                var ref = function ref(value) {
                    var refs = resolvedInst.refs;
                    if (value === null) delete refs[stringRef];
                    else refs[stringRef] = value;
                };
                ref._stringRef = stringRef;
                return ref;
            } else {
                if (typeof mixedRef !== 'string') throw new Error('Expected ref to be a function, a string, an object returned by React.createRef(), or null.');
                if (!element._owner) throw new Error("Element ref was specified as a string (" + mixedRef + ") but no owner was set. This could happen for one of" + ' the following reasons:\n' + '1. You may be adding a ref to a function component\n' + "2. You may be adding a ref to a component that was not created inside a component's render method\n" + '3. You have multiple copies of React loaded\n' + 'See https://reactjs.org/link/refs-must-have-owner for more information.');
            }
        }
        return mixedRef;
    }
    function throwOnInvalidObjectType(returnFiber, newChild) {
        var childString = Object.prototype.toString.call(newChild);
        throw new Error("Objects are not valid as a React child (found: " + (childString === '[object Object]' ? 'object with keys {' + Object.keys(newChild).join(', ') + '}' : childString) + "). " + 'If you meant to render a collection of children, use an array ' + 'instead.');
    }
    function warnOnFunctionType(returnFiber) {
        var componentName = getComponentNameFromFiber(returnFiber) || 'Component';
        if (ownerHasFunctionTypeWarning[componentName]) return;
        ownerHasFunctionTypeWarning[componentName] = true;
        error("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
    }
    function resolveLazy(lazyType) {
        var payload = lazyType._payload;
        var init = lazyType._init;
        return init(payload);
    } // This wrapper function exists because I expect to clone the code in each path
    // to be able to optimize each path individually by branching early. This needs
    // a compiler or we can do it manually. Helpers that don't need this branching
    // live outside of this function.
    function ChildReconciler(shouldTrackSideEffects) {
        function deleteChild(returnFiber, childToDelete) {
            if (!shouldTrackSideEffects) // Noop.
            return;
            var deletions = returnFiber.deletions;
            if (deletions === null) {
                returnFiber.deletions = [
                    childToDelete
                ];
                returnFiber.flags |= ChildDeletion;
            } else deletions.push(childToDelete);
        }
        function deleteRemainingChildren(returnFiber, currentFirstChild) {
            if (!shouldTrackSideEffects) // Noop.
            return null;
             // TODO: For the shouldClone case, this could be micro-optimized a bit by
            // assuming that after the first child we've already added everything.
            var childToDelete = currentFirstChild;
            while(childToDelete !== null){
                deleteChild(returnFiber, childToDelete);
                childToDelete = childToDelete.sibling;
            }
            return null;
        }
        function mapRemainingChildren(returnFiber, currentFirstChild) {
            // Add the remaining children to a temporary map so that we can find them by
            // keys quickly. Implicit (null) keys get added to this set with their index
            // instead.
            var existingChildren = new Map();
            var existingChild = currentFirstChild;
            while(existingChild !== null){
                if (existingChild.key !== null) existingChildren.set(existingChild.key, existingChild);
                else existingChildren.set(existingChild.index, existingChild);
                existingChild = existingChild.sibling;
            }
            return existingChildren;
        }
        function useFiber(fiber, pendingProps) {
            // We currently set sibling to null and index to 0 here because it is easy
            // to forget to do before returning it. E.g. for the single child case.
            var clone = createWorkInProgress(fiber, pendingProps);
            clone.index = 0;
            clone.sibling = null;
            return clone;
        }
        function placeChild(newFiber, lastPlacedIndex, newIndex) {
            newFiber.index = newIndex;
            if (!shouldTrackSideEffects) {
                // During hydration, the useId algorithm needs to know which fibers are
                // part of a list of children (arrays, iterators).
                newFiber.flags |= Forked;
                return lastPlacedIndex;
            }
            var current = newFiber.alternate;
            if (current !== null) {
                var oldIndex = current.index;
                if (oldIndex < lastPlacedIndex) {
                    // This is a move.
                    newFiber.flags |= Placement;
                    return lastPlacedIndex;
                } else // This item can stay in place.
                return oldIndex;
            } else {
                // This is an insertion.
                newFiber.flags |= Placement;
                return lastPlacedIndex;
            }
        }
        function placeSingleChild(newFiber) {
            // This is simpler for the single child case. We only need to do a
            // placement for inserting new children.
            if (shouldTrackSideEffects && newFiber.alternate === null) newFiber.flags |= Placement;
            return newFiber;
        }
        function updateTextNode(returnFiber, current, textContent, lanes) {
            if (current === null || current.tag !== HostText) {
                // Insert
                var created = createFiberFromText(textContent, returnFiber.mode, lanes);
                created.return = returnFiber;
                return created;
            } else {
                // Update
                var existing = useFiber(current, textContent);
                existing.return = returnFiber;
                return existing;
            }
        }
        function updateElement(returnFiber, current, element, lanes) {
            var elementType = element.type;
            if (elementType === REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
            if (current !== null) {
                if (current.elementType === elementType || isCompatibleFamilyForHotReloading(current, element) || // Lazy types should reconcile their resolved type.
                // We need to do this after the Hot Reloading check above,
                // because hot reloading has different semantics than prod because
                // it doesn't resuspend. So we can't let the call below suspend.
                typeof elementType === 'object' && elementType !== null && elementType.$$typeof === REACT_LAZY_TYPE && resolveLazy(elementType) === current.type) {
                    // Move based on index
                    var existing = useFiber(current, element.props);
                    existing.ref = coerceRef(returnFiber, current, element);
                    existing.return = returnFiber;
                    existing._debugSource = element._source;
                    existing._debugOwner = element._owner;
                    return existing;
                }
            } // Insert
            var created = createFiberFromElement(element, returnFiber.mode, lanes);
            created.ref = coerceRef(returnFiber, current, element);
            created.return = returnFiber;
            return created;
        }
        function updatePortal(returnFiber, current, portal, lanes) {
            if (current === null || current.tag !== HostPortal || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) {
                // Insert
                var created = createFiberFromPortal(portal, returnFiber.mode, lanes);
                created.return = returnFiber;
                return created;
            } else {
                // Update
                var existing = useFiber(current, portal.children || []);
                existing.return = returnFiber;
                return existing;
            }
        }
        function updateFragment(returnFiber, current, fragment, lanes, key) {
            if (current === null || current.tag !== Fragment) {
                // Insert
                var created = createFiberFromFragment(fragment, returnFiber.mode, lanes, key);
                created.return = returnFiber;
                return created;
            } else {
                // Update
                var existing = useFiber(current, fragment);
                existing.return = returnFiber;
                return existing;
            }
        }
        function createChild(returnFiber, newChild, lanes) {
            if (typeof newChild === 'string' && newChild !== '' || typeof newChild === 'number') {
                // Text nodes don't have keys. If the previous node is implicitly keyed
                // we can continue to replace it without aborting even if it is not a text
                // node.
                var created = createFiberFromText('' + newChild, returnFiber.mode, lanes);
                created.return = returnFiber;
                return created;
            }
            if (typeof newChild === 'object' && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        var _created = createFiberFromElement(newChild, returnFiber.mode, lanes);
                        _created.ref = coerceRef(returnFiber, null, newChild);
                        _created.return = returnFiber;
                        return _created;
                    case REACT_PORTAL_TYPE:
                        var _created2 = createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        _created2.return = returnFiber;
                        return _created2;
                    case REACT_LAZY_TYPE:
                        var payload = newChild._payload;
                        var init = newChild._init;
                        return createChild(returnFiber, init(payload), lanes);
                }
                if (isArray(newChild) || getIteratorFn(newChild)) {
                    var _created3 = createFiberFromFragment(newChild, returnFiber.mode, lanes, null);
                    _created3.return = returnFiber;
                    return _created3;
                }
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === 'function') warnOnFunctionType(returnFiber);
            return null;
        }
        function updateSlot(returnFiber, oldFiber, newChild, lanes) {
            // Update the fiber if the keys match, otherwise return null.
            var key = oldFiber !== null ? oldFiber.key : null;
            if (typeof newChild === 'string' && newChild !== '' || typeof newChild === 'number') {
                // Text nodes don't have keys. If the previous node is implicitly keyed
                // we can continue to replace it without aborting even if it is not a text
                // node.
                if (key !== null) return null;
                return updateTextNode(returnFiber, oldFiber, '' + newChild, lanes);
            }
            if (typeof newChild === 'object' && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        if (newChild.key === key) return updateElement(returnFiber, oldFiber, newChild, lanes);
                        else return null;
                    case REACT_PORTAL_TYPE:
                        if (newChild.key === key) return updatePortal(returnFiber, oldFiber, newChild, lanes);
                        else return null;
                    case REACT_LAZY_TYPE:
                        var payload = newChild._payload;
                        var init = newChild._init;
                        return updateSlot(returnFiber, oldFiber, init(payload), lanes);
                }
                if (isArray(newChild) || getIteratorFn(newChild)) {
                    if (key !== null) return null;
                    return updateFragment(returnFiber, oldFiber, newChild, lanes, null);
                }
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === 'function') warnOnFunctionType(returnFiber);
            return null;
        }
        function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
            if (typeof newChild === 'string' && newChild !== '' || typeof newChild === 'number') {
                // Text nodes don't have keys, so we neither have to check the old nor
                // new node for the key. If both are text nodes, they match.
                var matchedFiber = existingChildren.get(newIdx) || null;
                return updateTextNode(returnFiber, matchedFiber, '' + newChild, lanes);
            }
            if (typeof newChild === 'object' && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        var _matchedFiber = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;
                        return updateElement(returnFiber, _matchedFiber, newChild, lanes);
                    case REACT_PORTAL_TYPE:
                        var _matchedFiber2 = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;
                        return updatePortal(returnFiber, _matchedFiber2, newChild, lanes);
                    case REACT_LAZY_TYPE:
                        var payload = newChild._payload;
                        var init = newChild._init;
                        return updateFromMap(existingChildren, returnFiber, newIdx, init(payload), lanes);
                }
                if (isArray(newChild) || getIteratorFn(newChild)) {
                    var _matchedFiber3 = existingChildren.get(newIdx) || null;
                    return updateFragment(returnFiber, _matchedFiber3, newChild, lanes, null);
                }
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === 'function') warnOnFunctionType(returnFiber);
            return null;
        }
        /**
   * Warns if there is a duplicate or missing key
   */ function warnOnInvalidKey(child, knownKeys, returnFiber) {
            if (typeof child !== 'object' || child === null) return knownKeys;
            switch(child.$$typeof){
                case REACT_ELEMENT_TYPE:
                case REACT_PORTAL_TYPE:
                    warnForMissingKey(child, returnFiber);
                    var key = child.key;
                    if (typeof key !== 'string') break;
                    if (knownKeys === null) {
                        knownKeys = new Set();
                        knownKeys.add(key);
                        break;
                    }
                    if (!knownKeys.has(key)) {
                        knownKeys.add(key);
                        break;
                    }
                    error("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted \u2014 the behavior is unsupported and could change in a future version.", key);
                    break;
                case REACT_LAZY_TYPE:
                    var payload = child._payload;
                    var init = child._init;
                    warnOnInvalidKey(init(payload), knownKeys, returnFiber);
                    break;
            }
            return knownKeys;
        }
        function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
            // First, validate keys.
            var knownKeys = null;
            for(var i = 0; i < newChildren.length; i++){
                var child = newChildren[i];
                knownKeys = warnOnInvalidKey(child, knownKeys, returnFiber);
            }
            var resultingFirstChild = null;
            var previousNewFiber = null;
            var oldFiber = currentFirstChild;
            var lastPlacedIndex = 0;
            var newIdx = 0;
            var nextOldFiber = null;
            for(; oldFiber !== null && newIdx < newChildren.length; newIdx++){
                if (oldFiber.index > newIdx) {
                    nextOldFiber = oldFiber;
                    oldFiber = null;
                } else nextOldFiber = oldFiber.sibling;
                var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
                if (newFiber === null) {
                    // TODO: This breaks on empty slots like null children. That's
                    // unfortunate because it triggers the slow path all the time. We need
                    // a better way to communicate whether this was a miss or null,
                    // boolean, undefined, etc.
                    if (oldFiber === null) oldFiber = nextOldFiber;
                    break;
                }
                if (shouldTrackSideEffects) {
                    if (oldFiber && newFiber.alternate === null) // We matched the slot, but we didn't reuse the existing fiber, so we
                    // need to delete the existing child.
                    deleteChild(returnFiber, oldFiber);
                }
                lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);
                if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                resultingFirstChild = newFiber;
                else // TODO: Defer siblings if we're not at the right index for this slot.
                // I.e. if we had null values before, then we want to defer this
                // for each null value. However, we also don't want to call updateSlot
                // with the previous one.
                previousNewFiber.sibling = newFiber;
                previousNewFiber = newFiber;
                oldFiber = nextOldFiber;
            }
            if (newIdx === newChildren.length) {
                // We've reached the end of the new children. We can delete the rest.
                deleteRemainingChildren(returnFiber, oldFiber);
                if (getIsHydrating()) {
                    var numberOfForks = newIdx;
                    pushTreeFork(returnFiber, numberOfForks);
                }
                return resultingFirstChild;
            }
            if (oldFiber === null) {
                // If we don't have any more existing children we can choose a fast path
                // since the rest will all be insertions.
                for(; newIdx < newChildren.length; newIdx++){
                    var _newFiber = createChild(returnFiber, newChildren[newIdx], lanes);
                    if (_newFiber === null) continue;
                    lastPlacedIndex = placeChild(_newFiber, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                    resultingFirstChild = _newFiber;
                    else previousNewFiber.sibling = _newFiber;
                    previousNewFiber = _newFiber;
                }
                if (getIsHydrating()) {
                    var _numberOfForks = newIdx;
                    pushTreeFork(returnFiber, _numberOfForks);
                }
                return resultingFirstChild;
            } // Add all children to a key map for quick lookups.
            var existingChildren = mapRemainingChildren(returnFiber, oldFiber); // Keep scanning and use the map to restore deleted items as moves.
            for(; newIdx < newChildren.length; newIdx++){
                var _newFiber2 = updateFromMap(existingChildren, returnFiber, newIdx, newChildren[newIdx], lanes);
                if (_newFiber2 !== null) {
                    if (shouldTrackSideEffects) {
                        if (_newFiber2.alternate !== null) // The new fiber is a work in progress, but if there exists a
                        // current, that means that we reused the fiber. We need to delete
                        // it from the child list so that we don't add it to the deletion
                        // list.
                        existingChildren.delete(_newFiber2.key === null ? newIdx : _newFiber2.key);
                    }
                    lastPlacedIndex = placeChild(_newFiber2, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) resultingFirstChild = _newFiber2;
                    else previousNewFiber.sibling = _newFiber2;
                    previousNewFiber = _newFiber2;
                }
            }
            if (shouldTrackSideEffects) // Any existing children that weren't consumed above were deleted. We need
            // to add them to the deletion list.
            existingChildren.forEach(function(child) {
                return deleteChild(returnFiber, child);
            });
            if (getIsHydrating()) {
                var _numberOfForks2 = newIdx;
                pushTreeFork(returnFiber, _numberOfForks2);
            }
            return resultingFirstChild;
        }
        function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildrenIterable, lanes) {
            // This is the same implementation as reconcileChildrenArray(),
            // but using the iterator instead.
            var iteratorFn = getIteratorFn(newChildrenIterable);
            if (typeof iteratorFn !== 'function') throw new Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
            // We don't support rendering Generators because it's a mutation.
            // See https://github.com/facebook/react/issues/12995
            if (typeof Symbol === 'function' && // $FlowFixMe Flow doesn't know about toStringTag
            newChildrenIterable[Symbol.toStringTag] === 'Generator') {
                if (!didWarnAboutGenerators) error("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers.");
                didWarnAboutGenerators = true;
            } // Warn about using Maps as children
            if (newChildrenIterable.entries === iteratorFn) {
                if (!didWarnAboutMaps) error("Using Maps as children is not supported. Use an array of keyed ReactElements instead.");
                didWarnAboutMaps = true;
            } // First, validate keys.
            // We'll get a different iterator later for the main pass.
            var _newChildren = iteratorFn.call(newChildrenIterable);
            if (_newChildren) {
                var knownKeys = null;
                var _step = _newChildren.next();
                for(; !_step.done; _step = _newChildren.next()){
                    var child = _step.value;
                    knownKeys = warnOnInvalidKey(child, knownKeys, returnFiber);
                }
            }
            var newChildren = iteratorFn.call(newChildrenIterable);
            if (newChildren == null) throw new Error('An iterable object provided no iterator.');
            var resultingFirstChild = null;
            var previousNewFiber = null;
            var oldFiber = currentFirstChild;
            var lastPlacedIndex = 0;
            var newIdx = 0;
            var nextOldFiber = null;
            var step = newChildren.next();
            for(; oldFiber !== null && !step.done; newIdx++, step = newChildren.next()){
                if (oldFiber.index > newIdx) {
                    nextOldFiber = oldFiber;
                    oldFiber = null;
                } else nextOldFiber = oldFiber.sibling;
                var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
                if (newFiber === null) {
                    // TODO: This breaks on empty slots like null children. That's
                    // unfortunate because it triggers the slow path all the time. We need
                    // a better way to communicate whether this was a miss or null,
                    // boolean, undefined, etc.
                    if (oldFiber === null) oldFiber = nextOldFiber;
                    break;
                }
                if (shouldTrackSideEffects) {
                    if (oldFiber && newFiber.alternate === null) // We matched the slot, but we didn't reuse the existing fiber, so we
                    // need to delete the existing child.
                    deleteChild(returnFiber, oldFiber);
                }
                lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);
                if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                resultingFirstChild = newFiber;
                else // TODO: Defer siblings if we're not at the right index for this slot.
                // I.e. if we had null values before, then we want to defer this
                // for each null value. However, we also don't want to call updateSlot
                // with the previous one.
                previousNewFiber.sibling = newFiber;
                previousNewFiber = newFiber;
                oldFiber = nextOldFiber;
            }
            if (step.done) {
                // We've reached the end of the new children. We can delete the rest.
                deleteRemainingChildren(returnFiber, oldFiber);
                if (getIsHydrating()) {
                    var numberOfForks = newIdx;
                    pushTreeFork(returnFiber, numberOfForks);
                }
                return resultingFirstChild;
            }
            if (oldFiber === null) {
                // If we don't have any more existing children we can choose a fast path
                // since the rest will all be insertions.
                for(; !step.done; newIdx++, step = newChildren.next()){
                    var _newFiber3 = createChild(returnFiber, step.value, lanes);
                    if (_newFiber3 === null) continue;
                    lastPlacedIndex = placeChild(_newFiber3, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                    resultingFirstChild = _newFiber3;
                    else previousNewFiber.sibling = _newFiber3;
                    previousNewFiber = _newFiber3;
                }
                if (getIsHydrating()) {
                    var _numberOfForks3 = newIdx;
                    pushTreeFork(returnFiber, _numberOfForks3);
                }
                return resultingFirstChild;
            } // Add all children to a key map for quick lookups.
            var existingChildren = mapRemainingChildren(returnFiber, oldFiber); // Keep scanning and use the map to restore deleted items as moves.
            for(; !step.done; newIdx++, step = newChildren.next()){
                var _newFiber4 = updateFromMap(existingChildren, returnFiber, newIdx, step.value, lanes);
                if (_newFiber4 !== null) {
                    if (shouldTrackSideEffects) {
                        if (_newFiber4.alternate !== null) // The new fiber is a work in progress, but if there exists a
                        // current, that means that we reused the fiber. We need to delete
                        // it from the child list so that we don't add it to the deletion
                        // list.
                        existingChildren.delete(_newFiber4.key === null ? newIdx : _newFiber4.key);
                    }
                    lastPlacedIndex = placeChild(_newFiber4, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) resultingFirstChild = _newFiber4;
                    else previousNewFiber.sibling = _newFiber4;
                    previousNewFiber = _newFiber4;
                }
            }
            if (shouldTrackSideEffects) // Any existing children that weren't consumed above were deleted. We need
            // to add them to the deletion list.
            existingChildren.forEach(function(child) {
                return deleteChild(returnFiber, child);
            });
            if (getIsHydrating()) {
                var _numberOfForks4 = newIdx;
                pushTreeFork(returnFiber, _numberOfForks4);
            }
            return resultingFirstChild;
        }
        function reconcileSingleTextNode(returnFiber, currentFirstChild, textContent, lanes) {
            // There's no need to check for keys on text nodes since we don't have a
            // way to define them.
            if (currentFirstChild !== null && currentFirstChild.tag === HostText) {
                // We already have an existing node so let's just update it and delete
                // the rest.
                deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                var existing = useFiber(currentFirstChild, textContent);
                existing.return = returnFiber;
                return existing;
            } // The existing first child is not a text node so we need to create one
            // and delete the existing ones.
            deleteRemainingChildren(returnFiber, currentFirstChild);
            var created = createFiberFromText(textContent, returnFiber.mode, lanes);
            created.return = returnFiber;
            return created;
        }
        function reconcileSingleElement(returnFiber, currentFirstChild, element, lanes) {
            var key = element.key;
            var child = currentFirstChild;
            while(child !== null){
                // TODO: If key === null and child.key === null, then this only applies to
                // the first item in the list.
                if (child.key === key) {
                    var elementType = element.type;
                    if (elementType === REACT_FRAGMENT_TYPE) {
                        if (child.tag === Fragment) {
                            deleteRemainingChildren(returnFiber, child.sibling);
                            var existing = useFiber(child, element.props.children);
                            existing.return = returnFiber;
                            existing._debugSource = element._source;
                            existing._debugOwner = element._owner;
                            return existing;
                        }
                    } else if (child.elementType === elementType || isCompatibleFamilyForHotReloading(child, element) || // Lazy types should reconcile their resolved type.
                    // We need to do this after the Hot Reloading check above,
                    // because hot reloading has different semantics than prod because
                    // it doesn't resuspend. So we can't let the call below suspend.
                    typeof elementType === 'object' && elementType !== null && elementType.$$typeof === REACT_LAZY_TYPE && resolveLazy(elementType) === child.type) {
                        deleteRemainingChildren(returnFiber, child.sibling);
                        var _existing = useFiber(child, element.props);
                        _existing.ref = coerceRef(returnFiber, child, element);
                        _existing.return = returnFiber;
                        _existing._debugSource = element._source;
                        _existing._debugOwner = element._owner;
                        return _existing;
                    }
                     // Didn't match.
                    deleteRemainingChildren(returnFiber, child);
                    break;
                } else deleteChild(returnFiber, child);
                child = child.sibling;
            }
            if (element.type === REACT_FRAGMENT_TYPE) {
                var created = createFiberFromFragment(element.props.children, returnFiber.mode, lanes, element.key);
                created.return = returnFiber;
                return created;
            } else {
                var _created4 = createFiberFromElement(element, returnFiber.mode, lanes);
                _created4.ref = coerceRef(returnFiber, currentFirstChild, element);
                _created4.return = returnFiber;
                return _created4;
            }
        }
        function reconcileSinglePortal(returnFiber, currentFirstChild, portal, lanes) {
            var key = portal.key;
            var child = currentFirstChild;
            while(child !== null){
                // TODO: If key === null and child.key === null, then this only applies to
                // the first item in the list.
                if (child.key === key) {
                    if (child.tag === HostPortal && child.stateNode.containerInfo === portal.containerInfo && child.stateNode.implementation === portal.implementation) {
                        deleteRemainingChildren(returnFiber, child.sibling);
                        var existing = useFiber(child, portal.children || []);
                        existing.return = returnFiber;
                        return existing;
                    } else {
                        deleteRemainingChildren(returnFiber, child);
                        break;
                    }
                } else deleteChild(returnFiber, child);
                child = child.sibling;
            }
            var created = createFiberFromPortal(portal, returnFiber.mode, lanes);
            created.return = returnFiber;
            return created;
        } // This API will tag the children with the side-effect of the reconciliation
        // itself. They will be added to the side-effect list as we pass through the
        // children and the parent.
        function reconcileChildFibers(returnFiber, currentFirstChild, newChild, lanes) {
            // This function is not recursive.
            // If the top level item is an array, we treat it as a set of children,
            // not as a fragment. Nested arrays on the other hand will be treated as
            // fragment nodes. Recursion happens at the normal flow.
            // Handle top level unkeyed fragments as if they were arrays.
            // This leads to an ambiguity between <>{[...]}</> and <>...</>.
            // We treat the ambiguous cases above the same.
            var isUnkeyedTopLevelFragment = typeof newChild === 'object' && newChild !== null && newChild.type === REACT_FRAGMENT_TYPE && newChild.key === null;
            if (isUnkeyedTopLevelFragment) newChild = newChild.props.children;
             // Handle object types
            if (typeof newChild === 'object' && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        return placeSingleChild(reconcileSingleElement(returnFiber, currentFirstChild, newChild, lanes));
                    case REACT_PORTAL_TYPE:
                        return placeSingleChild(reconcileSinglePortal(returnFiber, currentFirstChild, newChild, lanes));
                    case REACT_LAZY_TYPE:
                        var payload = newChild._payload;
                        var init = newChild._init; // TODO: This function is supposed to be non-recursive.
                        return reconcileChildFibers(returnFiber, currentFirstChild, init(payload), lanes);
                }
                if (isArray(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
                if (getIteratorFn(newChild)) return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === 'string' && newChild !== '' || typeof newChild === 'number') return placeSingleChild(reconcileSingleTextNode(returnFiber, currentFirstChild, '' + newChild, lanes));
            if (typeof newChild === 'function') warnOnFunctionType(returnFiber);
            return deleteRemainingChildren(returnFiber, currentFirstChild);
        }
        return reconcileChildFibers;
    }
    var reconcileChildFibers = ChildReconciler(true);
    var mountChildFibers = ChildReconciler(false);
    function cloneChildFibers(current, workInProgress) {
        if (current !== null && workInProgress.child !== current.child) throw new Error('Resuming work not yet implemented.');
        if (workInProgress.child === null) return;
        var currentChild = workInProgress.child;
        var newChild = createWorkInProgress(currentChild, currentChild.pendingProps);
        workInProgress.child = newChild;
        newChild.return = workInProgress;
        while(currentChild.sibling !== null){
            currentChild = currentChild.sibling;
            newChild = newChild.sibling = createWorkInProgress(currentChild, currentChild.pendingProps);
            newChild.return = workInProgress;
        }
        newChild.sibling = null;
    } // Reset a workInProgress child set to prepare it for a second pass.
    function resetChildFibers(workInProgress, lanes) {
        var child = workInProgress.child;
        while(child !== null){
            resetWorkInProgress(child, lanes);
            child = child.sibling;
        }
    }
    var valueCursor = createCursor(null);
    var rendererSigil;
    // Use this to detect multiple renderers using the same context
    rendererSigil = {};
    var currentlyRenderingFiber = null;
    var lastContextDependency = null;
    var lastFullyObservedContext = null;
    var isDisallowedContextReadInDEV = false;
    function resetContextDependencies() {
        // This is called right before React yields execution, to ensure `readContext`
        // cannot be called outside the render phase.
        currentlyRenderingFiber = null;
        lastContextDependency = null;
        lastFullyObservedContext = null;
        isDisallowedContextReadInDEV = false;
    }
    function enterDisallowedContextReadInDEV() {
        isDisallowedContextReadInDEV = true;
    }
    function exitDisallowedContextReadInDEV() {
        isDisallowedContextReadInDEV = false;
    }
    function pushProvider(providerFiber, context, nextValue) {
        push(valueCursor, context._currentValue, providerFiber);
        context._currentValue = nextValue;
        if (context._currentRenderer !== undefined && context._currentRenderer !== null && context._currentRenderer !== rendererSigil) error("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported.");
        context._currentRenderer = rendererSigil;
    }
    function popProvider(context, providerFiber) {
        var currentValue = valueCursor.current;
        pop(valueCursor, providerFiber);
        context._currentValue = currentValue;
    }
    function scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
        // Update the child lanes of all the ancestors, including the alternates.
        var node = parent;
        while(node !== null){
            var alternate = node.alternate;
            if (!isSubsetOfLanes(node.childLanes, renderLanes)) {
                node.childLanes = mergeLanes(node.childLanes, renderLanes);
                if (alternate !== null) alternate.childLanes = mergeLanes(alternate.childLanes, renderLanes);
            } else if (alternate !== null && !isSubsetOfLanes(alternate.childLanes, renderLanes)) alternate.childLanes = mergeLanes(alternate.childLanes, renderLanes);
            if (node === propagationRoot) break;
            node = node.return;
        }
        if (node !== propagationRoot) error("Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue.");
    }
    function propagateContextChange(workInProgress, context, renderLanes) {
        propagateContextChange_eager(workInProgress, context, renderLanes);
    }
    function propagateContextChange_eager(workInProgress, context, renderLanes) {
        var fiber = workInProgress.child;
        if (fiber !== null) // Set the return pointer of the child to the work-in-progress fiber.
        fiber.return = workInProgress;
        while(fiber !== null){
            var nextFiber = void 0; // Visit this fiber.
            var list = fiber.dependencies;
            if (list !== null) {
                nextFiber = fiber.child;
                var dependency = list.firstContext;
                while(dependency !== null){
                    // Check if the context matches.
                    if (dependency.context === context) {
                        // Match! Schedule an update on this fiber.
                        if (fiber.tag === ClassComponent) {
                            // Schedule a force update on the work-in-progress.
                            var lane = pickArbitraryLane(renderLanes);
                            var update = createUpdate(NoTimestamp, lane);
                            update.tag = ForceUpdate; // TODO: Because we don't have a work-in-progress, this will add the
                            // update to the current fiber, too, which means it will persist even if
                            // this render is thrown away. Since it's a race condition, not sure it's
                            // worth fixing.
                            // Inlined `enqueueUpdate` to remove interleaved update check
                            var updateQueue = fiber.updateQueue;
                            if (updateQueue === null) ;
                            else {
                                var sharedQueue = updateQueue.shared;
                                var pending = sharedQueue.pending;
                                if (pending === null) // This is the first update. Create a circular list.
                                update.next = update;
                                else {
                                    update.next = pending.next;
                                    pending.next = update;
                                }
                                sharedQueue.pending = update;
                            }
                        }
                        fiber.lanes = mergeLanes(fiber.lanes, renderLanes);
                        var alternate = fiber.alternate;
                        if (alternate !== null) alternate.lanes = mergeLanes(alternate.lanes, renderLanes);
                        scheduleContextWorkOnParentPath(fiber.return, renderLanes, workInProgress); // Mark the updated lanes on the list, too.
                        list.lanes = mergeLanes(list.lanes, renderLanes); // Since we already found a match, we can stop traversing the
                        break;
                    }
                    dependency = dependency.next;
                }
            } else if (fiber.tag === ContextProvider) // Don't scan deeper if this is a matching provider
            nextFiber = fiber.type === workInProgress.type ? null : fiber.child;
            else if (fiber.tag === DehydratedFragment) {
                // If a dehydrated suspense boundary is in this subtree, we don't know
                // if it will have any context consumers in it. The best we can do is
                // mark it as having updates.
                var parentSuspense = fiber.return;
                if (parentSuspense === null) throw new Error('We just came from a parent so we must have had a parent. This is a bug in React.');
                parentSuspense.lanes = mergeLanes(parentSuspense.lanes, renderLanes);
                var _alternate = parentSuspense.alternate;
                if (_alternate !== null) _alternate.lanes = mergeLanes(_alternate.lanes, renderLanes);
                 // This is intentionally passing this fiber as the parent
                // because we want to schedule this fiber as having work
                // on its children. We'll use the childLanes on
                // this fiber to indicate that a context has changed.
                scheduleContextWorkOnParentPath(parentSuspense, renderLanes, workInProgress);
                nextFiber = fiber.sibling;
            } else // Traverse down.
            nextFiber = fiber.child;
            if (nextFiber !== null) // Set the return pointer of the child to the work-in-progress fiber.
            nextFiber.return = fiber;
            else {
                // No child. Traverse to next sibling.
                nextFiber = fiber;
                while(nextFiber !== null){
                    if (nextFiber === workInProgress) {
                        // We're back to the root of this subtree. Exit.
                        nextFiber = null;
                        break;
                    }
                    var sibling = nextFiber.sibling;
                    if (sibling !== null) {
                        // Set the return pointer of the sibling to the work-in-progress fiber.
                        sibling.return = nextFiber.return;
                        nextFiber = sibling;
                        break;
                    } // No more siblings. Traverse up.
                    nextFiber = nextFiber.return;
                }
            }
            fiber = nextFiber;
        }
    }
    function prepareToReadContext(workInProgress, renderLanes) {
        currentlyRenderingFiber = workInProgress;
        lastContextDependency = null;
        lastFullyObservedContext = null;
        var dependencies = workInProgress.dependencies;
        if (dependencies !== null) {
            var firstContext = dependencies.firstContext;
            if (firstContext !== null) {
                if (includesSomeLane(dependencies.lanes, renderLanes)) // Context list has a pending update. Mark that this fiber performed work.
                markWorkInProgressReceivedUpdate();
                 // Reset the work-in-progress list
                dependencies.firstContext = null;
            }
        }
    }
    function readContext(context) {
        // This warning would fire if you read context inside a Hook like useMemo.
        // Unlike the class check below, it's not enforced in production for perf.
        if (isDisallowedContextReadInDEV) error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
        var value = context._currentValue;
        if (lastFullyObservedContext === context) ;
        else {
            var contextItem = {
                context: context,
                memoizedValue: value,
                next: null
            };
            if (lastContextDependency === null) {
                if (currentlyRenderingFiber === null) throw new Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
                 // This is the first dependency for this component. Create a new list.
                lastContextDependency = contextItem;
                currentlyRenderingFiber.dependencies = {
                    lanes: NoLanes,
                    firstContext: contextItem
                };
            } else // Append a new context item.
            lastContextDependency = lastContextDependency.next = contextItem;
        }
        return value;
    }
    // render. When this render exits, either because it finishes or because it is
    // interrupted, the interleaved updates will be transferred onto the main part
    // of the queue.
    var concurrentQueues = null;
    function pushConcurrentUpdateQueue(queue) {
        if (concurrentQueues === null) concurrentQueues = [
            queue
        ];
        else concurrentQueues.push(queue);
    }
    function finishQueueingConcurrentUpdates() {
        // Transfer the interleaved updates onto the main queue. Each queue has a
        // `pending` field and an `interleaved` field. When they are not null, they
        // point to the last node in a circular linked list. We need to append the
        // interleaved list to the end of the pending list by joining them into a
        // single, circular list.
        if (concurrentQueues !== null) {
            for(var i = 0; i < concurrentQueues.length; i++){
                var queue = concurrentQueues[i];
                var lastInterleavedUpdate = queue.interleaved;
                if (lastInterleavedUpdate !== null) {
                    queue.interleaved = null;
                    var firstInterleavedUpdate = lastInterleavedUpdate.next;
                    var lastPendingUpdate = queue.pending;
                    if (lastPendingUpdate !== null) {
                        var firstPendingUpdate = lastPendingUpdate.next;
                        lastPendingUpdate.next = firstInterleavedUpdate;
                        lastInterleavedUpdate.next = firstPendingUpdate;
                    }
                    queue.pending = lastInterleavedUpdate;
                }
            }
            concurrentQueues = null;
        }
    }
    function enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
        var interleaved = queue.interleaved;
        if (interleaved === null) {
            // This is the first update. Create a circular list.
            update.next = update; // At the end of the current render, this queue's interleaved updates will
            // be transferred to the pending queue.
            pushConcurrentUpdateQueue(queue);
        } else {
            update.next = interleaved.next;
            interleaved.next = update;
        }
        queue.interleaved = update;
        return markUpdateLaneFromFiberToRoot(fiber, lane);
    }
    function enqueueConcurrentHookUpdateAndEagerlyBailout(fiber, queue, update, lane) {
        var interleaved = queue.interleaved;
        if (interleaved === null) {
            // This is the first update. Create a circular list.
            update.next = update; // At the end of the current render, this queue's interleaved updates will
            // be transferred to the pending queue.
            pushConcurrentUpdateQueue(queue);
        } else {
            update.next = interleaved.next;
            interleaved.next = update;
        }
        queue.interleaved = update;
    }
    function enqueueConcurrentClassUpdate(fiber, queue, update, lane) {
        var interleaved = queue.interleaved;
        if (interleaved === null) {
            // This is the first update. Create a circular list.
            update.next = update; // At the end of the current render, this queue's interleaved updates will
            // be transferred to the pending queue.
            pushConcurrentUpdateQueue(queue);
        } else {
            update.next = interleaved.next;
            interleaved.next = update;
        }
        queue.interleaved = update;
        return markUpdateLaneFromFiberToRoot(fiber, lane);
    }
    function enqueueConcurrentRenderForLane(fiber, lane) {
        return markUpdateLaneFromFiberToRoot(fiber, lane);
    } // Calling this function outside this module should only be done for backwards
    // compatibility and should always be accompanied by a warning.
    var unsafe_markUpdateLaneFromFiberToRoot = markUpdateLaneFromFiberToRoot;
    function markUpdateLaneFromFiberToRoot(sourceFiber, lane) {
        // Update the source fiber's lanes
        sourceFiber.lanes = mergeLanes(sourceFiber.lanes, lane);
        var alternate = sourceFiber.alternate;
        if (alternate !== null) alternate.lanes = mergeLanes(alternate.lanes, lane);
        if (alternate === null && (sourceFiber.flags & (Placement | Hydrating)) !== NoFlags) warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber);
        var node = sourceFiber;
        var parent = sourceFiber.return;
        while(parent !== null){
            parent.childLanes = mergeLanes(parent.childLanes, lane);
            alternate = parent.alternate;
            if (alternate !== null) alternate.childLanes = mergeLanes(alternate.childLanes, lane);
            else if ((parent.flags & (Placement | Hydrating)) !== NoFlags) warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber);
            node = parent;
            parent = parent.return;
        }
        if (node.tag === HostRoot) {
            var root = node.stateNode;
            return root;
        } else return null;
    }
    var UpdateState = 0;
    var ReplaceState = 1;
    var ForceUpdate = 2;
    var CaptureUpdate = 3; // Global state that is reset at the beginning of calling `processUpdateQueue`.
    // It should only be read right after calling `processUpdateQueue`, via
    // `checkHasForceUpdateAfterProcessing`.
    var hasForceUpdate = false;
    var didWarnUpdateInsideUpdate;
    var currentlyProcessingQueue;
    didWarnUpdateInsideUpdate = false;
    currentlyProcessingQueue = null;
    function initializeUpdateQueue(fiber) {
        var queue = {
            baseState: fiber.memoizedState,
            firstBaseUpdate: null,
            lastBaseUpdate: null,
            shared: {
                pending: null,
                interleaved: null,
                lanes: NoLanes
            },
            effects: null
        };
        fiber.updateQueue = queue;
    }
    function cloneUpdateQueue(current, workInProgress) {
        // Clone the update queue from current. Unless it's already a clone.
        var queue = workInProgress.updateQueue;
        var currentQueue = current.updateQueue;
        if (queue === currentQueue) {
            var clone = {
                baseState: currentQueue.baseState,
                firstBaseUpdate: currentQueue.firstBaseUpdate,
                lastBaseUpdate: currentQueue.lastBaseUpdate,
                shared: currentQueue.shared,
                effects: currentQueue.effects
            };
            workInProgress.updateQueue = clone;
        }
    }
    function createUpdate(eventTime, lane) {
        var update = {
            eventTime: eventTime,
            lane: lane,
            tag: UpdateState,
            payload: null,
            callback: null,
            next: null
        };
        return update;
    }
    function enqueueUpdate(fiber, update, lane) {
        var updateQueue = fiber.updateQueue;
        if (updateQueue === null) // Only occurs if the fiber has been unmounted.
        return null;
        var sharedQueue = updateQueue.shared;
        if (currentlyProcessingQueue === sharedQueue && !didWarnUpdateInsideUpdate) {
            error("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback.");
            didWarnUpdateInsideUpdate = true;
        }
        if (isUnsafeClassRenderPhaseUpdate()) {
            // This is an unsafe render phase update. Add directly to the update
            // queue so we can process it immediately during the current render.
            var pending = sharedQueue.pending;
            if (pending === null) // This is the first update. Create a circular list.
            update.next = update;
            else {
                update.next = pending.next;
                pending.next = update;
            }
            sharedQueue.pending = update; // Update the childLanes even though we're most likely already rendering
            // this fiber. This is for backwards compatibility in the case where you
            // update a different component during render phase than the one that is
            // currently renderings (a pattern that is accompanied by a warning).
            return unsafe_markUpdateLaneFromFiberToRoot(fiber, lane);
        } else return enqueueConcurrentClassUpdate(fiber, sharedQueue, update, lane);
    }
    function entangleTransitions(root, fiber, lane) {
        var updateQueue = fiber.updateQueue;
        if (updateQueue === null) // Only occurs if the fiber has been unmounted.
        return;
        var sharedQueue = updateQueue.shared;
        if (isTransitionLane(lane)) {
            var queueLanes = sharedQueue.lanes; // If any entangled lanes are no longer pending on the root, then they must
            // have finished. We can remove them from the shared queue, which represents
            // a superset of the actually pending lanes. In some cases we may entangle
            // more than we need to, but that's OK. In fact it's worse if we *don't*
            // entangle when we should.
            queueLanes = intersectLanes(queueLanes, root.pendingLanes); // Entangle the new transition lane with the other transition lanes.
            var newQueueLanes = mergeLanes(queueLanes, lane);
            sharedQueue.lanes = newQueueLanes; // Even if queue.lanes already include lane, we don't know for certain if
            // the lane finished since the last time we entangled it. So we need to
            // entangle it again, just to be sure.
            markRootEntangled(root, newQueueLanes);
        }
    }
    function enqueueCapturedUpdate(workInProgress, capturedUpdate) {
        // Captured updates are updates that are thrown by a child during the render
        // phase. They should be discarded if the render is aborted. Therefore,
        // we should only put them on the work-in-progress queue, not the current one.
        var queue = workInProgress.updateQueue; // Check if the work-in-progress queue is a clone.
        var current = workInProgress.alternate;
        if (current !== null) {
            var currentQueue = current.updateQueue;
            if (queue === currentQueue) {
                // The work-in-progress queue is the same as current. This happens when
                // we bail out on a parent fiber that then captures an error thrown by
                // a child. Since we want to append the update only to the work-in
                // -progress queue, we need to clone the updates. We usually clone during
                // processUpdateQueue, but that didn't happen in this case because we
                // skipped over the parent when we bailed out.
                var newFirst = null;
                var newLast = null;
                var firstBaseUpdate = queue.firstBaseUpdate;
                if (firstBaseUpdate !== null) {
                    // Loop through the updates and clone them.
                    var update = firstBaseUpdate;
                    do {
                        var clone = {
                            eventTime: update.eventTime,
                            lane: update.lane,
                            tag: update.tag,
                            payload: update.payload,
                            callback: update.callback,
                            next: null
                        };
                        if (newLast === null) newFirst = newLast = clone;
                        else {
                            newLast.next = clone;
                            newLast = clone;
                        }
                        update = update.next;
                    }while (update !== null); // Append the captured update the end of the cloned list.
                    if (newLast === null) newFirst = newLast = capturedUpdate;
                    else {
                        newLast.next = capturedUpdate;
                        newLast = capturedUpdate;
                    }
                } else // There are no base updates.
                newFirst = newLast = capturedUpdate;
                queue = {
                    baseState: currentQueue.baseState,
                    firstBaseUpdate: newFirst,
                    lastBaseUpdate: newLast,
                    shared: currentQueue.shared,
                    effects: currentQueue.effects
                };
                workInProgress.updateQueue = queue;
                return;
            }
        } // Append the update to the end of the list.
        var lastBaseUpdate = queue.lastBaseUpdate;
        if (lastBaseUpdate === null) queue.firstBaseUpdate = capturedUpdate;
        else lastBaseUpdate.next = capturedUpdate;
        queue.lastBaseUpdate = capturedUpdate;
    }
    function getStateFromUpdate(workInProgress, queue, update, prevState, nextProps, instance) {
        switch(update.tag){
            case ReplaceState:
                var payload = update.payload;
                if (typeof payload === 'function') {
                    enterDisallowedContextReadInDEV();
                    var nextState = payload.call(instance, prevState, nextProps);
                    if (workInProgress.mode & StrictLegacyMode) {
                        setIsStrictModeForDevtools(true);
                        try {
                            payload.call(instance, prevState, nextProps);
                        } finally{
                            setIsStrictModeForDevtools(false);
                        }
                    }
                    exitDisallowedContextReadInDEV();
                    return nextState;
                } // State object
                return payload;
            case CaptureUpdate:
                workInProgress.flags = workInProgress.flags & ~ShouldCapture | DidCapture;
            // Intentional fallthrough
            case UpdateState:
                var _payload = update.payload;
                var partialState;
                if (typeof _payload === 'function') {
                    enterDisallowedContextReadInDEV();
                    partialState = _payload.call(instance, prevState, nextProps);
                    if (workInProgress.mode & StrictLegacyMode) {
                        setIsStrictModeForDevtools(true);
                        try {
                            _payload.call(instance, prevState, nextProps);
                        } finally{
                            setIsStrictModeForDevtools(false);
                        }
                    }
                    exitDisallowedContextReadInDEV();
                } else // Partial state object
                partialState = _payload;
                if (partialState === null || partialState === undefined) // Null and undefined are treated as no-ops.
                return prevState;
                 // Merge the partial state and the previous state.
                return assign({}, prevState, partialState);
            case ForceUpdate:
                hasForceUpdate = true;
                return prevState;
        }
        return prevState;
    }
    function processUpdateQueue(workInProgress, props, instance, renderLanes) {
        // This is always non-null on a ClassComponent or HostRoot
        var queue = workInProgress.updateQueue;
        hasForceUpdate = false;
        currentlyProcessingQueue = queue.shared;
        var firstBaseUpdate = queue.firstBaseUpdate;
        var lastBaseUpdate = queue.lastBaseUpdate; // Check if there are pending updates. If so, transfer them to the base queue.
        var pendingQueue = queue.shared.pending;
        if (pendingQueue !== null) {
            queue.shared.pending = null; // The pending queue is circular. Disconnect the pointer between first
            // and last so that it's non-circular.
            var lastPendingUpdate = pendingQueue;
            var firstPendingUpdate = lastPendingUpdate.next;
            lastPendingUpdate.next = null; // Append pending updates to base queue
            if (lastBaseUpdate === null) firstBaseUpdate = firstPendingUpdate;
            else lastBaseUpdate.next = firstPendingUpdate;
            lastBaseUpdate = lastPendingUpdate; // If there's a current queue, and it's different from the base queue, then
            // we need to transfer the updates to that queue, too. Because the base
            // queue is a singly-linked list with no cycles, we can append to both
            // lists and take advantage of structural sharing.
            // TODO: Pass `current` as argument
            var current = workInProgress.alternate;
            if (current !== null) {
                // This is always non-null on a ClassComponent or HostRoot
                var currentQueue = current.updateQueue;
                var currentLastBaseUpdate = currentQueue.lastBaseUpdate;
                if (currentLastBaseUpdate !== lastBaseUpdate) {
                    if (currentLastBaseUpdate === null) currentQueue.firstBaseUpdate = firstPendingUpdate;
                    else currentLastBaseUpdate.next = firstPendingUpdate;
                    currentQueue.lastBaseUpdate = lastPendingUpdate;
                }
            }
        } // These values may change as we process the queue.
        if (firstBaseUpdate !== null) {
            // Iterate through the list of updates to compute the result.
            var newState = queue.baseState; // TODO: Don't need to accumulate this. Instead, we can remove renderLanes
            // from the original lanes.
            var newLanes = NoLanes;
            var newBaseState = null;
            var newFirstBaseUpdate = null;
            var newLastBaseUpdate = null;
            var update = firstBaseUpdate;
            do {
                var updateLane = update.lane;
                var updateEventTime = update.eventTime;
                if (!isSubsetOfLanes(renderLanes, updateLane)) {
                    // Priority is insufficient. Skip this update. If this is the first
                    // skipped update, the previous update/state is the new base
                    // update/state.
                    var clone = {
                        eventTime: updateEventTime,
                        lane: updateLane,
                        tag: update.tag,
                        payload: update.payload,
                        callback: update.callback,
                        next: null
                    };
                    if (newLastBaseUpdate === null) {
                        newFirstBaseUpdate = newLastBaseUpdate = clone;
                        newBaseState = newState;
                    } else newLastBaseUpdate = newLastBaseUpdate.next = clone;
                     // Update the remaining priority in the queue.
                    newLanes = mergeLanes(newLanes, updateLane);
                } else {
                    // This update does have sufficient priority.
                    if (newLastBaseUpdate !== null) {
                        var _clone = {
                            eventTime: updateEventTime,
                            // This update is going to be committed so we never want uncommit
                            // it. Using NoLane works because 0 is a subset of all bitmasks, so
                            // this will never be skipped by the check above.
                            lane: NoLane,
                            tag: update.tag,
                            payload: update.payload,
                            callback: update.callback,
                            next: null
                        };
                        newLastBaseUpdate = newLastBaseUpdate.next = _clone;
                    } // Process this update.
                    newState = getStateFromUpdate(workInProgress, queue, update, newState, props, instance);
                    var callback = update.callback;
                    if (callback !== null && // If the update was already committed, we should not queue its
                    // callback again.
                    update.lane !== NoLane) {
                        workInProgress.flags |= Callback;
                        var effects = queue.effects;
                        if (effects === null) queue.effects = [
                            update
                        ];
                        else effects.push(update);
                    }
                }
                update = update.next;
                if (update === null) {
                    pendingQueue = queue.shared.pending;
                    if (pendingQueue === null) break;
                    else {
                        // An update was scheduled from inside a reducer. Add the new
                        // pending updates to the end of the list and keep processing.
                        var _lastPendingUpdate = pendingQueue; // Intentionally unsound. Pending updates form a circular list, but we
                        // unravel them when transferring them to the base queue.
                        var _firstPendingUpdate = _lastPendingUpdate.next;
                        _lastPendingUpdate.next = null;
                        update = _firstPendingUpdate;
                        queue.lastBaseUpdate = _lastPendingUpdate;
                        queue.shared.pending = null;
                    }
                }
            }while (true);
            if (newLastBaseUpdate === null) newBaseState = newState;
            queue.baseState = newBaseState;
            queue.firstBaseUpdate = newFirstBaseUpdate;
            queue.lastBaseUpdate = newLastBaseUpdate; // Interleaved updates are stored on a separate queue. We aren't going to
            // process them during this render, but we do need to track which lanes
            // are remaining.
            var lastInterleaved = queue.shared.interleaved;
            if (lastInterleaved !== null) {
                var interleaved = lastInterleaved;
                do {
                    newLanes = mergeLanes(newLanes, interleaved.lane);
                    interleaved = interleaved.next;
                }while (interleaved !== lastInterleaved);
            } else if (firstBaseUpdate === null) // `queue.lanes` is used for entangling transitions. We can set it back to
            // zero once the queue is empty.
            queue.shared.lanes = NoLanes;
             // Set the remaining expiration time to be whatever is remaining in the queue.
            // This should be fine because the only two other things that contribute to
            // expiration time are props and context. We're already in the middle of the
            // begin phase by the time we start processing the queue, so we've already
            // dealt with the props. Context in components that specify
            // shouldComponentUpdate is tricky; but we'll have to account for
            // that regardless.
            markSkippedUpdateLanes(newLanes);
            workInProgress.lanes = newLanes;
            workInProgress.memoizedState = newState;
        }
        currentlyProcessingQueue = null;
    }
    function callCallback(callback, context) {
        if (typeof callback !== 'function') throw new Error('Invalid argument passed as callback. Expected a function. Instead ' + ("received: " + callback));
        callback.call(context);
    }
    function resetHasForceUpdateBeforeProcessing() {
        hasForceUpdate = false;
    }
    function checkHasForceUpdateAfterProcessing() {
        return hasForceUpdate;
    }
    function commitUpdateQueue(finishedWork, finishedQueue, instance) {
        // Commit the effects
        var effects = finishedQueue.effects;
        finishedQueue.effects = null;
        if (effects !== null) for(var i = 0; i < effects.length; i++){
            var effect = effects[i];
            var callback = effect.callback;
            if (callback !== null) {
                effect.callback = null;
                callCallback(callback, instance);
            }
        }
    }
    var NO_CONTEXT = {};
    var contextStackCursor$1 = createCursor(NO_CONTEXT);
    var contextFiberStackCursor = createCursor(NO_CONTEXT);
    var rootInstanceStackCursor = createCursor(NO_CONTEXT);
    function requiredContext(c) {
        if (c === NO_CONTEXT) throw new Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
        return c;
    }
    function getRootHostContainer() {
        var rootInstance = requiredContext(rootInstanceStackCursor.current);
        return rootInstance;
    }
    function pushHostContainer(fiber, nextRootInstance) {
        // Push current root instance onto the stack;
        // This allows us to reset root when portals are popped.
        push(rootInstanceStackCursor, nextRootInstance, fiber); // Track the context and the Fiber that provided it.
        // This enables us to pop only Fibers that provide unique contexts.
        push(contextFiberStackCursor, fiber, fiber); // Finally, we need to push the host context to the stack.
        // However, we can't just call getRootHostContext() and push it because
        // we'd have a different number of entries on the stack depending on
        // whether getRootHostContext() throws somewhere in renderer code or not.
        // So we push an empty value first. This lets us safely unwind on errors.
        push(contextStackCursor$1, NO_CONTEXT, fiber);
        var nextRootContext = getRootHostContext(nextRootInstance); // Now that we know this function doesn't throw, replace it.
        pop(contextStackCursor$1, fiber);
        push(contextStackCursor$1, nextRootContext, fiber);
    }
    function popHostContainer(fiber) {
        pop(contextStackCursor$1, fiber);
        pop(contextFiberStackCursor, fiber);
        pop(rootInstanceStackCursor, fiber);
    }
    function getHostContext() {
        var context = requiredContext(contextStackCursor$1.current);
        return context;
    }
    function pushHostContext(fiber) {
        var rootInstance = requiredContext(rootInstanceStackCursor.current);
        var context = requiredContext(contextStackCursor$1.current);
        var nextContext = getChildHostContext(context, fiber.type); // Don't push this Fiber's context unless it's unique.
        if (context === nextContext) return;
         // Track the context and the Fiber that provided it.
        // This enables us to pop only Fibers that provide unique contexts.
        push(contextFiberStackCursor, fiber, fiber);
        push(contextStackCursor$1, nextContext, fiber);
    }
    function popHostContext(fiber) {
        // Do not pop unless this Fiber provided the current context.
        // pushHostContext() only pushes Fibers that provide unique contexts.
        if (contextFiberStackCursor.current !== fiber) return;
        pop(contextStackCursor$1, fiber);
        pop(contextFiberStackCursor, fiber);
    }
    var DefaultSuspenseContext = 0; // The Suspense Context is split into two parts. The lower bits is
    // inherited deeply down the subtree. The upper bits only affect
    // this immediate suspense boundary and gets reset each new
    // boundary or suspense list.
    var SubtreeSuspenseContextMask = 1; // Subtree Flags:
    // InvisibleParentSuspenseContext indicates that one of our parent Suspense
    // boundaries is not currently showing visible main content.
    // Either because it is already showing a fallback or is not mounted at all.
    // We can use this to determine if it is desirable to trigger a fallback at
    // the parent. If not, then we might need to trigger undesirable boundaries
    // and/or suspend the commit to avoid hiding the parent content.
    var InvisibleParentSuspenseContext = 1; // Shallow Flags:
    // ForceSuspenseFallback can be used by SuspenseList to force newly added
    // items into their fallback state during one of the render passes.
    var ForceSuspenseFallback = 2;
    var suspenseStackCursor = createCursor(DefaultSuspenseContext);
    function hasSuspenseContext(parentContext, flag) {
        return (parentContext & flag) !== 0;
    }
    function setDefaultShallowSuspenseContext(parentContext) {
        return parentContext & SubtreeSuspenseContextMask;
    }
    function setShallowSuspenseContext(parentContext, shallowContext) {
        return parentContext & SubtreeSuspenseContextMask | shallowContext;
    }
    function addSubtreeSuspenseContext(parentContext, subtreeContext) {
        return parentContext | subtreeContext;
    }
    function pushSuspenseContext(fiber, newContext) {
        push(suspenseStackCursor, newContext, fiber);
    }
    function popSuspenseContext(fiber) {
        pop(suspenseStackCursor, fiber);
    }
    function shouldCaptureSuspense(workInProgress, hasInvisibleParent) {
        // If it was the primary children that just suspended, capture and render the
        // fallback. Otherwise, don't capture and bubble to the next boundary.
        var nextState = workInProgress.memoizedState;
        if (nextState !== null) {
            if (nextState.dehydrated !== null) // A dehydrated boundary always captures.
            return true;
            return false;
        }
        var props = workInProgress.memoizedProps; // Regular boundaries always capture.
        return true;
    }
    function findFirstSuspended(row) {
        var node = row;
        while(node !== null){
            if (node.tag === SuspenseComponent) {
                var state = node.memoizedState;
                if (state !== null) {
                    var dehydrated = state.dehydrated;
                    if (dehydrated === null || isSuspenseInstancePending(dehydrated) || isSuspenseInstanceFallback(dehydrated)) return node;
                }
            } else if (node.tag === SuspenseListComponent && // revealOrder undefined can't be trusted because it don't
            // keep track of whether it suspended or not.
            node.memoizedProps.revealOrder !== undefined) {
                var didSuspend = (node.flags & DidCapture) !== NoFlags;
                if (didSuspend) return node;
            } else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === row) return null;
            while(node.sibling === null){
                if (node.return === null || node.return === row) return null;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
        return null;
    }
    var NoFlags$1 = /*   */ 0; // Represents whether effect should fire.
    var HasEffect = /* */ 1; // Represents the phase in which the effect (not the clean-up) fires.
    var Insertion = /*  */ 2;
    var Layout = /*    */ 4;
    var Passive$1 = /*   */ 8;
    // and should be reset before starting a new render.
    // This tracks which mutable sources need to be reset after a render.
    var workInProgressSources = [];
    function resetWorkInProgressVersions() {
        for(var i = 0; i < workInProgressSources.length; i++){
            var mutableSource = workInProgressSources[i];
            mutableSource._workInProgressVersionPrimary = null;
        }
        workInProgressSources.length = 0;
    }
    // This ensures that the version used for server rendering matches the one
    // that is eventually read during hydration.
    // If they don't match there's a potential tear and a full deopt render is required.
    function registerMutableSourceForHydration(root, mutableSource) {
        var getVersion = mutableSource._getVersion;
        var version = getVersion(mutableSource._source); // TODO Clear this data once all pending hydration work is finished.
        // Retaining it forever may interfere with GC.
        if (root.mutableSourceEagerHydrationData == null) root.mutableSourceEagerHydrationData = [
            mutableSource,
            version
        ];
        else root.mutableSourceEagerHydrationData.push(mutableSource, version);
    }
    var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher, ReactCurrentBatchConfig$2 = ReactSharedInternals.ReactCurrentBatchConfig;
    var didWarnAboutMismatchedHooksForComponent;
    var didWarnUncachedGetSnapshot;
    didWarnAboutMismatchedHooksForComponent = new Set();
    // These are set right before calling the component.
    var renderLanes = NoLanes; // The work-in-progress fiber. I've named it differently to distinguish it from
    // the work-in-progress hook.
    var currentlyRenderingFiber$1 = null; // Hooks are stored as a linked list on the fiber's memoizedState field. The
    // current hook list is the list that belongs to the current fiber. The
    // work-in-progress hook list is a new list that will be added to the
    // work-in-progress fiber.
    var currentHook = null;
    var workInProgressHook = null; // Whether an update was scheduled at any point during the render phase. This
    // does not get reset if we do another render pass; only when we're completely
    // finished evaluating this component. This is an optimization so we know
    // whether we need to clear render phase updates after a throw.
    var didScheduleRenderPhaseUpdate = false; // Where an update was scheduled only during the current render pass. This
    // gets reset after each attempt.
    // TODO: Maybe there's some way to consolidate this with
    // `didScheduleRenderPhaseUpdate`. Or with `numberOfReRenders`.
    var didScheduleRenderPhaseUpdateDuringThisPass = false; // Counts the number of useId hooks in this component.
    var localIdCounter = 0; // Used for ids that are generated completely client-side (i.e. not during
    // hydration). This counter is global, so client ids are not stable across
    // render attempts.
    var globalClientIdCounter = 0;
    var RE_RENDER_LIMIT = 25; // In DEV, this is the name of the currently executing primitive hook
    var currentHookNameInDev = null; // In DEV, this list ensures that hooks are called in the same order between renders.
    // The list stores the order of hooks used during the initial render (mount).
    // Subsequent renders (updates) reference this list.
    var hookTypesDev = null;
    var hookTypesUpdateIndexDev = -1; // In DEV, this tracks whether currently rendering component needs to ignore
    // the dependencies for Hooks that need them (e.g. useEffect or useMemo).
    // When true, such Hooks will always be "remounted". Only used during hot reload.
    var ignorePreviousDependencies = false;
    function mountHookTypesDev() {
        var hookName = currentHookNameInDev;
        if (hookTypesDev === null) hookTypesDev = [
            hookName
        ];
        else hookTypesDev.push(hookName);
    }
    function updateHookTypesDev() {
        var hookName = currentHookNameInDev;
        if (hookTypesDev !== null) {
            hookTypesUpdateIndexDev++;
            if (hookTypesDev[hookTypesUpdateIndexDev] !== hookName) warnOnHookMismatchInDev(hookName);
        }
    }
    function checkDepsAreArrayDev(deps) {
        if (deps !== undefined && deps !== null && !isArray(deps)) // Verify deps, but only on mount to avoid extra checks.
        // It's unlikely their type would change as usually you define them inline.
        error("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", currentHookNameInDev, typeof deps);
    }
    function warnOnHookMismatchInDev(currentHookName) {
        var componentName = getComponentNameFromFiber(currentlyRenderingFiber$1);
        if (!didWarnAboutMismatchedHooksForComponent.has(componentName)) {
            didWarnAboutMismatchedHooksForComponent.add(componentName);
            if (hookTypesDev !== null) {
                var table = '';
                var secondColumnStart = 30;
                for(var i = 0; i <= hookTypesUpdateIndexDev; i++){
                    var oldHookName = hookTypesDev[i];
                    var newHookName = i === hookTypesUpdateIndexDev ? currentHookName : oldHookName;
                    var row = i + 1 + ". " + oldHookName; // Extra space so second column lines up
                    // lol @ IE not supporting String#repeat
                    while(row.length < secondColumnStart)row += ' ';
                    row += newHookName + '\n';
                    table += row;
                }
                error("React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks\n\n   Previous render            Next render\n   ------------------------------------------------------\n%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^\n", componentName, table);
            }
        }
    }
    function throwInvalidHookError() {
        throw new Error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.");
    }
    function areHookInputsEqual(nextDeps, prevDeps) {
        if (ignorePreviousDependencies) // Only true when this component is being hot reloaded.
        return false;
        if (prevDeps === null) {
            error("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", currentHookNameInDev);
            return false;
        }
        // Don't bother comparing lengths in prod because these arrays should be
        // passed inline.
        if (nextDeps.length !== prevDeps.length) error("The final argument passed to %s changed size between renders. The order and size of this array must remain constant.\n\nPrevious: %s\nIncoming: %s", currentHookNameInDev, "[" + prevDeps.join(', ') + "]", "[" + nextDeps.join(', ') + "]");
        for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++){
            if (objectIs(nextDeps[i], prevDeps[i])) continue;
            return false;
        }
        return true;
    }
    function renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
        renderLanes = nextRenderLanes;
        currentlyRenderingFiber$1 = workInProgress;
        hookTypesDev = current !== null ? current._debugHookTypes : null;
        hookTypesUpdateIndexDev = -1; // Used for hot reloading:
        ignorePreviousDependencies = current !== null && current.type !== workInProgress.type;
        workInProgress.memoizedState = null;
        workInProgress.updateQueue = null;
        workInProgress.lanes = NoLanes; // The following should have already been reset
        if (current !== null && current.memoizedState !== null) ReactCurrentDispatcher$1.current = HooksDispatcherOnUpdateInDEV;
        else if (hookTypesDev !== null) // This dispatcher handles an edge case where a component is updating,
        // but no stateful hooks have been used.
        // We want to match the production code behavior (which will use HooksDispatcherOnMount),
        // but with the extra DEV validation to ensure hooks ordering hasn't changed.
        // This dispatcher does that.
        ReactCurrentDispatcher$1.current = HooksDispatcherOnMountWithHookTypesInDEV;
        else ReactCurrentDispatcher$1.current = HooksDispatcherOnMountInDEV;
        var children = Component(props, secondArg); // Check if there was a render phase update
        if (didScheduleRenderPhaseUpdateDuringThisPass) {
            // Keep rendering in a loop for as long as render phase updates continue to
            // be scheduled. Use a counter to prevent infinite loops.
            var numberOfReRenders = 0;
            do {
                didScheduleRenderPhaseUpdateDuringThisPass = false;
                localIdCounter = 0;
                if (numberOfReRenders >= RE_RENDER_LIMIT) throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
                numberOfReRenders += 1;
                // Even when hot reloading, allow dependencies to stabilize
                // after first render to prevent infinite render phase updates.
                ignorePreviousDependencies = false;
                currentHook = null;
                workInProgressHook = null;
                workInProgress.updateQueue = null;
                // Also validate hook order for cascading updates.
                hookTypesUpdateIndexDev = -1;
                ReactCurrentDispatcher$1.current = HooksDispatcherOnRerenderInDEV;
                children = Component(props, secondArg);
            }while (didScheduleRenderPhaseUpdateDuringThisPass);
        } // We can assume the previous dispatcher is always this one, since we set it
        // at the beginning of the render phase and there's no re-entrance.
        ReactCurrentDispatcher$1.current = ContextOnlyDispatcher;
        workInProgress._debugHookTypes = hookTypesDev;
        // hookTypesDev could catch more cases (e.g. context) but only in DEV bundles.
        var didRenderTooFewHooks = currentHook !== null && currentHook.next !== null;
        renderLanes = NoLanes;
        currentlyRenderingFiber$1 = null;
        currentHook = null;
        workInProgressHook = null;
        currentHookNameInDev = null;
        hookTypesDev = null;
        hookTypesUpdateIndexDev = -1; // Confirm that a static flag was not added or removed since the last
        // render. If this fires, it suggests that we incorrectly reset the static
        // flags in some other part of the codebase. This has happened before, for
        // example, in the SuspenseList implementation.
        if (current !== null && (current.flags & StaticMask) !== (workInProgress.flags & StaticMask) && // Disable this warning in legacy mode, because legacy Suspense is weird
        // and creates false positives. To make this work in legacy mode, we'd
        // need to mark fibers that commit in an incomplete state, somehow. For
        // now I'll disable the warning that most of the bugs that would trigger
        // it are either exclusive to concurrent mode or exist in both.
        (current.mode & ConcurrentMode) !== NoMode) error("Internal React error: Expected static flag was missing. Please notify the React team.");
        didScheduleRenderPhaseUpdate = false; // This is reset by checkDidRenderIdHook
        // localIdCounter = 0;
        if (didRenderTooFewHooks) throw new Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
        return children;
    }
    function checkDidRenderIdHook() {
        // This should be called immediately after every renderWithHooks call.
        // Conceptually, it's part of the return value of renderWithHooks; it's only a
        // separate function to avoid using an array tuple.
        var didRenderIdHook = localIdCounter !== 0;
        localIdCounter = 0;
        return didRenderIdHook;
    }
    function bailoutHooks(current, workInProgress, lanes) {
        workInProgress.updateQueue = current.updateQueue; // TODO: Don't need to reset the flags here, because they're reset in the
        // complete phase (bubbleProperties).
        if ((workInProgress.mode & StrictEffectsMode) !== NoMode) workInProgress.flags &= ~(MountPassiveDev | MountLayoutDev | Passive | Update);
        else workInProgress.flags &= ~(Passive | Update);
        current.lanes = removeLanes(current.lanes, lanes);
    }
    function resetHooksAfterThrow() {
        // We can assume the previous dispatcher is always this one, since we set it
        // at the beginning of the render phase and there's no re-entrance.
        ReactCurrentDispatcher$1.current = ContextOnlyDispatcher;
        if (didScheduleRenderPhaseUpdate) {
            // There were render phase updates. These are only valid for this render
            // phase, which we are now aborting. Remove the updates from the queues so
            // they do not persist to the next render. Do not remove updates from hooks
            // that weren't processed.
            //
            // Only reset the updates from the queue if it has a clone. If it does
            // not have a clone, that means it wasn't processed, and the updates were
            // scheduled before we entered the render phase.
            var hook = currentlyRenderingFiber$1.memoizedState;
            while(hook !== null){
                var queue = hook.queue;
                if (queue !== null) queue.pending = null;
                hook = hook.next;
            }
            didScheduleRenderPhaseUpdate = false;
        }
        renderLanes = NoLanes;
        currentlyRenderingFiber$1 = null;
        currentHook = null;
        workInProgressHook = null;
        hookTypesDev = null;
        hookTypesUpdateIndexDev = -1;
        currentHookNameInDev = null;
        isUpdatingOpaqueValueInRenderPhase = false;
        didScheduleRenderPhaseUpdateDuringThisPass = false;
        localIdCounter = 0;
    }
    function mountWorkInProgressHook() {
        var hook = {
            memoizedState: null,
            baseState: null,
            baseQueue: null,
            queue: null,
            next: null
        };
        if (workInProgressHook === null) // This is the first hook in the list
        currentlyRenderingFiber$1.memoizedState = workInProgressHook = hook;
        else // Append to the end of the list
        workInProgressHook = workInProgressHook.next = hook;
        return workInProgressHook;
    }
    function updateWorkInProgressHook() {
        // This function is used both for updates and for re-renders triggered by a
        // render phase update. It assumes there is either a current hook we can
        // clone, or a work-in-progress hook from a previous render pass that we can
        // use as a base. When we reach the end of the base list, we must switch to
        // the dispatcher used for mounts.
        var nextCurrentHook;
        if (currentHook === null) {
            var current = currentlyRenderingFiber$1.alternate;
            if (current !== null) nextCurrentHook = current.memoizedState;
            else nextCurrentHook = null;
        } else nextCurrentHook = currentHook.next;
        var nextWorkInProgressHook;
        if (workInProgressHook === null) nextWorkInProgressHook = currentlyRenderingFiber$1.memoizedState;
        else nextWorkInProgressHook = workInProgressHook.next;
        if (nextWorkInProgressHook !== null) {
            // There's already a work-in-progress. Reuse it.
            workInProgressHook = nextWorkInProgressHook;
            nextWorkInProgressHook = workInProgressHook.next;
            currentHook = nextCurrentHook;
        } else {
            // Clone from the current hook.
            if (nextCurrentHook === null) throw new Error('Rendered more hooks than during the previous render.');
            currentHook = nextCurrentHook;
            var newHook = {
                memoizedState: currentHook.memoizedState,
                baseState: currentHook.baseState,
                baseQueue: currentHook.baseQueue,
                queue: currentHook.queue,
                next: null
            };
            if (workInProgressHook === null) // This is the first hook in the list.
            currentlyRenderingFiber$1.memoizedState = workInProgressHook = newHook;
            else // Append to the end of the list.
            workInProgressHook = workInProgressHook.next = newHook;
        }
        return workInProgressHook;
    }
    function createFunctionComponentUpdateQueue() {
        return {
            lastEffect: null,
            stores: null
        };
    }
    function basicStateReducer(state, action) {
        // $FlowFixMe: Flow doesn't like mixed types
        return typeof action === 'function' ? action(state) : action;
    }
    function mountReducer(reducer, initialArg, init) {
        var hook = mountWorkInProgressHook();
        var initialState;
        if (init !== undefined) initialState = init(initialArg);
        else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        var queue = {
            pending: null,
            interleaved: null,
            lanes: NoLanes,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = queue;
        var dispatch = queue.dispatch = dispatchReducerAction.bind(null, currentlyRenderingFiber$1, queue);
        return [
            hook.memoizedState,
            dispatch
        ];
    }
    function updateReducer(reducer, initialArg, init) {
        var hook = updateWorkInProgressHook();
        var queue = hook.queue;
        if (queue === null) throw new Error('Should have a queue. This is likely a bug in React. Please file an issue.');
        queue.lastRenderedReducer = reducer;
        var current = currentHook; // The last rebase update that is NOT part of the base state.
        var baseQueue = current.baseQueue; // The last pending update that hasn't been processed yet.
        var pendingQueue = queue.pending;
        if (pendingQueue !== null) {
            // We have new updates that haven't been processed yet.
            // We'll add them to the base queue.
            if (baseQueue !== null) {
                // Merge the pending queue and the base queue.
                var baseFirst = baseQueue.next;
                var pendingFirst = pendingQueue.next;
                baseQueue.next = pendingFirst;
                pendingQueue.next = baseFirst;
            }
            if (current.baseQueue !== baseQueue) // Internal invariant that should never happen, but feasibly could in
            // the future if we implement resuming, or some form of that.
            error("Internal error: Expected work-in-progress queue to be a clone. This is a bug in React.");
            current.baseQueue = baseQueue = pendingQueue;
            queue.pending = null;
        }
        if (baseQueue !== null) {
            // We have a queue to process.
            var first = baseQueue.next;
            var newState = current.baseState;
            var newBaseState = null;
            var newBaseQueueFirst = null;
            var newBaseQueueLast = null;
            var update = first;
            do {
                var updateLane = update.lane;
                if (!isSubsetOfLanes(renderLanes, updateLane)) {
                    // Priority is insufficient. Skip this update. If this is the first
                    // skipped update, the previous update/state is the new base
                    // update/state.
                    var clone = {
                        lane: updateLane,
                        action: update.action,
                        hasEagerState: update.hasEagerState,
                        eagerState: update.eagerState,
                        next: null
                    };
                    if (newBaseQueueLast === null) {
                        newBaseQueueFirst = newBaseQueueLast = clone;
                        newBaseState = newState;
                    } else newBaseQueueLast = newBaseQueueLast.next = clone;
                     // Update the remaining priority in the queue.
                    // TODO: Don't need to accumulate this. Instead, we can remove
                    // renderLanes from the original lanes.
                    currentlyRenderingFiber$1.lanes = mergeLanes(currentlyRenderingFiber$1.lanes, updateLane);
                    markSkippedUpdateLanes(updateLane);
                } else {
                    // This update does have sufficient priority.
                    if (newBaseQueueLast !== null) {
                        var _clone = {
                            // This update is going to be committed so we never want uncommit
                            // it. Using NoLane works because 0 is a subset of all bitmasks, so
                            // this will never be skipped by the check above.
                            lane: NoLane,
                            action: update.action,
                            hasEagerState: update.hasEagerState,
                            eagerState: update.eagerState,
                            next: null
                        };
                        newBaseQueueLast = newBaseQueueLast.next = _clone;
                    } // Process this update.
                    if (update.hasEagerState) // If this update is a state update (not a reducer) and was processed eagerly,
                    // we can use the eagerly computed state
                    newState = update.eagerState;
                    else {
                        var action = update.action;
                        newState = reducer(newState, action);
                    }
                }
                update = update.next;
            }while (update !== null && update !== first);
            if (newBaseQueueLast === null) newBaseState = newState;
            else newBaseQueueLast.next = newBaseQueueFirst;
             // Mark that the fiber performed work, but only if the new state is
            // different from the current state.
            if (!objectIs(newState, hook.memoizedState)) markWorkInProgressReceivedUpdate();
            hook.memoizedState = newState;
            hook.baseState = newBaseState;
            hook.baseQueue = newBaseQueueLast;
            queue.lastRenderedState = newState;
        } // Interleaved updates are stored on a separate queue. We aren't going to
        // process them during this render, but we do need to track which lanes
        // are remaining.
        var lastInterleaved = queue.interleaved;
        if (lastInterleaved !== null) {
            var interleaved = lastInterleaved;
            do {
                var interleavedLane = interleaved.lane;
                currentlyRenderingFiber$1.lanes = mergeLanes(currentlyRenderingFiber$1.lanes, interleavedLane);
                markSkippedUpdateLanes(interleavedLane);
                interleaved = interleaved.next;
            }while (interleaved !== lastInterleaved);
        } else if (baseQueue === null) // `queue.lanes` is used for entangling transitions. We can set it back to
        // zero once the queue is empty.
        queue.lanes = NoLanes;
        var dispatch = queue.dispatch;
        return [
            hook.memoizedState,
            dispatch
        ];
    }
    function rerenderReducer(reducer, initialArg, init) {
        var hook = updateWorkInProgressHook();
        var queue = hook.queue;
        if (queue === null) throw new Error('Should have a queue. This is likely a bug in React. Please file an issue.');
        queue.lastRenderedReducer = reducer; // This is a re-render. Apply the new render phase updates to the previous
        // work-in-progress hook.
        var dispatch = queue.dispatch;
        var lastRenderPhaseUpdate = queue.pending;
        var newState = hook.memoizedState;
        if (lastRenderPhaseUpdate !== null) {
            // The queue doesn't persist past this render pass.
            queue.pending = null;
            var firstRenderPhaseUpdate = lastRenderPhaseUpdate.next;
            var update = firstRenderPhaseUpdate;
            do {
                // Process this render phase update. We don't have to check the
                // priority because it will always be the same as the current
                // render's.
                var action = update.action;
                newState = reducer(newState, action);
                update = update.next;
            }while (update !== firstRenderPhaseUpdate); // Mark that the fiber performed work, but only if the new state is
            // different from the current state.
            if (!objectIs(newState, hook.memoizedState)) markWorkInProgressReceivedUpdate();
            hook.memoizedState = newState; // Don't persist the state accumulated from the render phase updates to
            // the base state unless the queue is empty.
            // TODO: Not sure if this is the desired semantics, but it's what we
            // do for gDSFP. I can't remember why.
            if (hook.baseQueue === null) hook.baseState = newState;
            queue.lastRenderedState = newState;
        }
        return [
            newState,
            dispatch
        ];
    }
    function mountMutableSource(source, getSnapshot, subscribe) {
        return undefined;
    }
    function updateMutableSource(source, getSnapshot, subscribe) {
        return undefined;
    }
    function mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = currentlyRenderingFiber$1;
        var hook = mountWorkInProgressHook();
        var nextSnapshot;
        var isHydrating = getIsHydrating();
        if (isHydrating) {
            if (getServerSnapshot === undefined) throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
            nextSnapshot = getServerSnapshot();
            if (!didWarnUncachedGetSnapshot) {
                if (nextSnapshot !== getServerSnapshot()) {
                    error('The result of getServerSnapshot should be cached to avoid an infinite loop');
                    didWarnUncachedGetSnapshot = true;
                }
            }
        } else {
            nextSnapshot = getSnapshot();
            if (!didWarnUncachedGetSnapshot) {
                var cachedSnapshot = getSnapshot();
                if (!objectIs(nextSnapshot, cachedSnapshot)) {
                    error('The result of getSnapshot should be cached to avoid an infinite loop');
                    didWarnUncachedGetSnapshot = true;
                }
            }
            // Right before committing, we will walk the tree and check if any of the
            // stores were mutated.
            //
            // We won't do this if we're hydrating server-rendered content, because if
            // the content is stale, it's already visible anyway. Instead we'll patch
            // it up in a passive effect.
            var root = getWorkInProgressRoot();
            if (root === null) throw new Error('Expected a work-in-progress root. This is a bug in React. Please file an issue.');
            if (!includesBlockingLane(root, renderLanes)) pushStoreConsistencyCheck(fiber, getSnapshot, nextSnapshot);
        } // Read the current snapshot from the store on every render. This breaks the
        // normal rules of React, and only works because store updates are
        // always synchronous.
        hook.memoizedState = nextSnapshot;
        var inst = {
            value: nextSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst; // Schedule an effect to subscribe to the store.
        mountEffect(subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]); // Schedule an effect to update the mutable instance fields. We will update
        // this whenever subscribe, getSnapshot, or value changes. Because there's no
        // clean-up function, and we track the deps correctly, we can call pushEffect
        // directly, without storing any additional state. For the same reason, we
        // don't need to set a static flag, either.
        // TODO: We can move this to the passive phase once we add a pre-commit
        // consistency check. See the next comment.
        fiber.flags |= Passive;
        pushEffect(HasEffect | Passive$1, updateStoreInstance.bind(null, fiber, inst, nextSnapshot, getSnapshot), undefined, null);
        return nextSnapshot;
    }
    function updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = currentlyRenderingFiber$1;
        var hook = updateWorkInProgressHook(); // Read the current snapshot from the store on every render. This breaks the
        // normal rules of React, and only works because store updates are
        // always synchronous.
        var nextSnapshot = getSnapshot();
        if (!didWarnUncachedGetSnapshot) {
            var cachedSnapshot = getSnapshot();
            if (!objectIs(nextSnapshot, cachedSnapshot)) {
                error('The result of getSnapshot should be cached to avoid an infinite loop');
                didWarnUncachedGetSnapshot = true;
            }
        }
        var prevSnapshot = hook.memoizedState;
        var snapshotChanged = !objectIs(prevSnapshot, nextSnapshot);
        if (snapshotChanged) {
            hook.memoizedState = nextSnapshot;
            markWorkInProgressReceivedUpdate();
        }
        var inst = hook.queue;
        updateEffect(subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]); // Whenever getSnapshot or subscribe changes, we need to check in the
        // commit phase if there was an interleaved mutation. In concurrent mode
        // this can happen all the time, but even in synchronous mode, an earlier
        // effect may have mutated the store.
        if (inst.getSnapshot !== getSnapshot || snapshotChanged || // Check if the susbcribe function changed. We can save some memory by
        // checking whether we scheduled a subscription effect above.
        workInProgressHook !== null && workInProgressHook.memoizedState.tag & HasEffect) {
            fiber.flags |= Passive;
            pushEffect(HasEffect | Passive$1, updateStoreInstance.bind(null, fiber, inst, nextSnapshot, getSnapshot), undefined, null); // Unless we're rendering a blocking lane, schedule a consistency check.
            // Right before committing, we will walk the tree and check if any of the
            // stores were mutated.
            var root = getWorkInProgressRoot();
            if (root === null) throw new Error('Expected a work-in-progress root. This is a bug in React. Please file an issue.');
            if (!includesBlockingLane(root, renderLanes)) pushStoreConsistencyCheck(fiber, getSnapshot, nextSnapshot);
        }
        return nextSnapshot;
    }
    function pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
        fiber.flags |= StoreConsistency;
        var check = {
            getSnapshot: getSnapshot,
            value: renderedSnapshot
        };
        var componentUpdateQueue = currentlyRenderingFiber$1.updateQueue;
        if (componentUpdateQueue === null) {
            componentUpdateQueue = createFunctionComponentUpdateQueue();
            currentlyRenderingFiber$1.updateQueue = componentUpdateQueue;
            componentUpdateQueue.stores = [
                check
            ];
        } else {
            var stores = componentUpdateQueue.stores;
            if (stores === null) componentUpdateQueue.stores = [
                check
            ];
            else stores.push(check);
        }
    }
    function updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
        // These are updated in the passive phase
        inst.value = nextSnapshot;
        inst.getSnapshot = getSnapshot; // Something may have been mutated in between render and commit. This could
        // have been in an event that fired before the passive effects, or it could
        // have been in a layout effect. In that case, we would have used the old
        // snapsho and getSnapshot values to bail out. We need to check one more time.
        if (checkIfSnapshotChanged(inst)) // Force a re-render.
        forceStoreRerender(fiber);
    }
    function subscribeToStore(fiber, inst, subscribe) {
        var handleStoreChange = function handleStoreChange() {
            // The store changed. Check if the snapshot changed since the last time we
            // read from the store.
            if (checkIfSnapshotChanged(inst)) // Force a re-render.
            forceStoreRerender(fiber);
        }; // Subscribe to the store and return a clean-up function.
        return subscribe(handleStoreChange);
    }
    function checkIfSnapshotChanged(inst) {
        var latestGetSnapshot = inst.getSnapshot;
        var prevValue = inst.value;
        try {
            var nextValue = latestGetSnapshot();
            return !objectIs(prevValue, nextValue);
        } catch (error) {
            return true;
        }
    }
    function forceStoreRerender(fiber) {
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    }
    function mountState(initialState) {
        var hook = mountWorkInProgressHook();
        if (typeof initialState === 'function') // $FlowFixMe: Flow doesn't like mixed types
        initialState = initialState();
        hook.memoizedState = hook.baseState = initialState;
        var queue = {
            pending: null,
            interleaved: null,
            lanes: NoLanes,
            dispatch: null,
            lastRenderedReducer: basicStateReducer,
            lastRenderedState: initialState
        };
        hook.queue = queue;
        var dispatch = queue.dispatch = dispatchSetState.bind(null, currentlyRenderingFiber$1, queue);
        return [
            hook.memoizedState,
            dispatch
        ];
    }
    function updateState(initialState) {
        return updateReducer(basicStateReducer);
    }
    function rerenderState(initialState) {
        return rerenderReducer(basicStateReducer);
    }
    function pushEffect(tag, create, destroy, deps) {
        var effect = {
            tag: tag,
            create: create,
            destroy: destroy,
            deps: deps,
            // Circular
            next: null
        };
        var componentUpdateQueue = currentlyRenderingFiber$1.updateQueue;
        if (componentUpdateQueue === null) {
            componentUpdateQueue = createFunctionComponentUpdateQueue();
            currentlyRenderingFiber$1.updateQueue = componentUpdateQueue;
            componentUpdateQueue.lastEffect = effect.next = effect;
        } else {
            var lastEffect = componentUpdateQueue.lastEffect;
            if (lastEffect === null) componentUpdateQueue.lastEffect = effect.next = effect;
            else {
                var firstEffect = lastEffect.next;
                lastEffect.next = effect;
                effect.next = firstEffect;
                componentUpdateQueue.lastEffect = effect;
            }
        }
        return effect;
    }
    function mountRef(initialValue) {
        var hook = mountWorkInProgressHook();
        var _ref2 = {
            current: initialValue
        };
        hook.memoizedState = _ref2;
        return _ref2;
    }
    function updateRef(initialValue) {
        var hook = updateWorkInProgressHook();
        return hook.memoizedState;
    }
    function mountEffectImpl(fiberFlags, hookFlags, create, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        currentlyRenderingFiber$1.flags |= fiberFlags;
        hook.memoizedState = pushEffect(HasEffect | hookFlags, create, undefined, nextDeps);
    }
    function updateEffectImpl(fiberFlags, hookFlags, create, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var destroy = undefined;
        if (currentHook !== null) {
            var prevEffect = currentHook.memoizedState;
            destroy = prevEffect.destroy;
            if (nextDeps !== null) {
                var prevDeps = prevEffect.deps;
                if (areHookInputsEqual(nextDeps, prevDeps)) {
                    hook.memoizedState = pushEffect(hookFlags, create, destroy, nextDeps);
                    return;
                }
            }
        }
        currentlyRenderingFiber$1.flags |= fiberFlags;
        hook.memoizedState = pushEffect(HasEffect | hookFlags, create, destroy, nextDeps);
    }
    function mountEffect(create, deps) {
        if ((currentlyRenderingFiber$1.mode & StrictEffectsMode) !== NoMode) return mountEffectImpl(MountPassiveDev | Passive | PassiveStatic, Passive$1, create, deps);
        else return mountEffectImpl(Passive | PassiveStatic, Passive$1, create, deps);
    }
    function updateEffect(create, deps) {
        return updateEffectImpl(Passive, Passive$1, create, deps);
    }
    function mountInsertionEffect(create, deps) {
        return mountEffectImpl(Update, Insertion, create, deps);
    }
    function updateInsertionEffect(create, deps) {
        return updateEffectImpl(Update, Insertion, create, deps);
    }
    function mountLayoutEffect(create, deps) {
        var fiberFlags = Update;
        fiberFlags |= LayoutStatic;
        if ((currentlyRenderingFiber$1.mode & StrictEffectsMode) !== NoMode) fiberFlags |= MountLayoutDev;
        return mountEffectImpl(fiberFlags, Layout, create, deps);
    }
    function updateLayoutEffect(create, deps) {
        return updateEffectImpl(Update, Layout, create, deps);
    }
    function imperativeHandleEffect(create, ref) {
        if (typeof ref === 'function') {
            var refCallback = ref;
            var _inst = create();
            refCallback(_inst);
            return function() {
                refCallback(null);
            };
        } else if (ref !== null && ref !== undefined) {
            var refObject = ref;
            if (!refObject.hasOwnProperty('current')) error("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", 'an object with keys {' + Object.keys(refObject).join(', ') + '}');
            var _inst2 = create();
            refObject.current = _inst2;
            return function() {
                refObject.current = null;
            };
        }
    }
    function mountImperativeHandle(ref, create, deps) {
        if (typeof create !== 'function') error("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", create !== null ? typeof create : 'null');
        var effectDeps = deps !== null && deps !== undefined ? deps.concat([
            ref
        ]) : null;
        var fiberFlags = Update;
        fiberFlags |= LayoutStatic;
        if ((currentlyRenderingFiber$1.mode & StrictEffectsMode) !== NoMode) fiberFlags |= MountLayoutDev;
        return mountEffectImpl(fiberFlags, Layout, imperativeHandleEffect.bind(null, create, ref), effectDeps);
    }
    function updateImperativeHandle(ref, create, deps) {
        if (typeof create !== 'function') error("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", create !== null ? typeof create : 'null');
        var effectDeps = deps !== null && deps !== undefined ? deps.concat([
            ref
        ]) : null;
        return updateEffectImpl(Update, Layout, imperativeHandleEffect.bind(null, create, ref), effectDeps);
    }
    function mountDebugValue(value, formatterFn) {
    // The react-debug-hooks package injects its own implementation
    // so that e.g. DevTools can display custom hook values.
    }
    var updateDebugValue = mountDebugValue;
    function mountCallback(callback, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        hook.memoizedState = [
            callback,
            nextDeps
        ];
        return callback;
    }
    function updateCallback(callback, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var prevState = hook.memoizedState;
        if (prevState !== null) {
            if (nextDeps !== null) {
                var prevDeps = prevState[1];
                if (areHookInputsEqual(nextDeps, prevDeps)) return prevState[0];
            }
        }
        hook.memoizedState = [
            callback,
            nextDeps
        ];
        return callback;
    }
    function mountMemo(nextCreate, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var nextValue = nextCreate();
        hook.memoizedState = [
            nextValue,
            nextDeps
        ];
        return nextValue;
    }
    function updateMemo(nextCreate, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var prevState = hook.memoizedState;
        if (prevState !== null) // Assume these are defined. If they're not, areHookInputsEqual will warn.
        {
            if (nextDeps !== null) {
                var prevDeps = prevState[1];
                if (areHookInputsEqual(nextDeps, prevDeps)) return prevState[0];
            }
        }
        var nextValue = nextCreate();
        hook.memoizedState = [
            nextValue,
            nextDeps
        ];
        return nextValue;
    }
    function mountDeferredValue(value) {
        var hook = mountWorkInProgressHook();
        hook.memoizedState = value;
        return value;
    }
    function updateDeferredValue(value) {
        var hook = updateWorkInProgressHook();
        var resolvedCurrentHook = currentHook;
        var prevValue = resolvedCurrentHook.memoizedState;
        return updateDeferredValueImpl(hook, prevValue, value);
    }
    function rerenderDeferredValue(value) {
        var hook = updateWorkInProgressHook();
        if (currentHook === null) {
            // This is a rerender during a mount.
            hook.memoizedState = value;
            return value;
        } else {
            // This is a rerender during an update.
            var prevValue = currentHook.memoizedState;
            return updateDeferredValueImpl(hook, prevValue, value);
        }
    }
    function updateDeferredValueImpl(hook, prevValue, value) {
        var shouldDeferValue = !includesOnlyNonUrgentLanes(renderLanes);
        if (shouldDeferValue) {
            // This is an urgent update. If the value has changed, keep using the
            // previous value and spawn a deferred render to update it later.
            if (!objectIs(value, prevValue)) {
                // Schedule a deferred render
                var deferredLane = claimNextTransitionLane();
                currentlyRenderingFiber$1.lanes = mergeLanes(currentlyRenderingFiber$1.lanes, deferredLane);
                markSkippedUpdateLanes(deferredLane); // Set this to true to indicate that the rendered value is inconsistent
                // from the latest value. The name "baseState" doesn't really match how we
                // use it because we're reusing a state hook field instead of creating a
                // new one.
                hook.baseState = true;
            } // Reuse the previous value
            return prevValue;
        } else {
            // This is not an urgent update, so we can use the latest value regardless
            // of what it is. No need to defer it.
            // However, if we're currently inside a spawned render, then we need to mark
            // this as an update to prevent the fiber from bailing out.
            //
            // `baseState` is true when the current value is different from the rendered
            // value. The name doesn't really match how we use it because we're reusing
            // a state hook field instead of creating a new one.
            if (hook.baseState) {
                // Flip this back to false.
                hook.baseState = false;
                markWorkInProgressReceivedUpdate();
            }
            hook.memoizedState = value;
            return value;
        }
    }
    function startTransition(setPending, callback, options) {
        var previousPriority = getCurrentUpdatePriority();
        setCurrentUpdatePriority(higherEventPriority(previousPriority, ContinuousEventPriority));
        setPending(true);
        var prevTransition = ReactCurrentBatchConfig$2.transition;
        ReactCurrentBatchConfig$2.transition = {};
        var currentTransition = ReactCurrentBatchConfig$2.transition;
        ReactCurrentBatchConfig$2.transition._updatedFibers = new Set();
        try {
            setPending(false);
            callback();
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig$2.transition = prevTransition;
            if (prevTransition === null && currentTransition._updatedFibers) {
                var updatedFibersCount = currentTransition._updatedFibers.size;
                if (updatedFibersCount > 10) warn("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table.");
                currentTransition._updatedFibers.clear();
            }
        }
    }
    function mountTransition() {
        var _mountState = mountState(false), isPending = _mountState[0], setPending = _mountState[1]; // The `start` method never changes.
        var start = startTransition.bind(null, setPending);
        var hook = mountWorkInProgressHook();
        hook.memoizedState = start;
        return [
            isPending,
            start
        ];
    }
    function updateTransition() {
        var _updateState = updateState(), isPending = _updateState[0];
        var hook = updateWorkInProgressHook();
        var start = hook.memoizedState;
        return [
            isPending,
            start
        ];
    }
    function rerenderTransition() {
        var _rerenderState = rerenderState(), isPending = _rerenderState[0];
        var hook = updateWorkInProgressHook();
        var start = hook.memoizedState;
        return [
            isPending,
            start
        ];
    }
    var isUpdatingOpaqueValueInRenderPhase = false;
    function getIsUpdatingOpaqueValueInRenderPhaseInDEV() {
        return isUpdatingOpaqueValueInRenderPhase;
    }
    function mountId() {
        var hook = mountWorkInProgressHook();
        var root = getWorkInProgressRoot(); // TODO: In Fizz, id generation is specific to each server config. Maybe we
        // should do this in Fiber, too? Deferring this decision for now because
        // there's no other place to store the prefix except for an internal field on
        // the public createRoot object, which the fiber tree does not currently have
        // a reference to.
        var identifierPrefix = root.identifierPrefix;
        var id;
        if (getIsHydrating()) {
            var treeId = getTreeId(); // Use a captial R prefix for server-generated ids.
            id = ':' + identifierPrefix + 'R' + treeId; // Unless this is the first id at this level, append a number at the end
            // that represents the position of this useId hook among all the useId
            // hooks for this fiber.
            var localId = localIdCounter++;
            if (localId > 0) id += 'H' + localId.toString(32);
            id += ':';
        } else {
            // Use a lowercase r prefix for client-generated ids.
            var globalClientId = globalClientIdCounter++;
            id = ':' + identifierPrefix + 'r' + globalClientId.toString(32) + ':';
        }
        hook.memoizedState = id;
        return id;
    }
    function updateId() {
        var hook = updateWorkInProgressHook();
        var id = hook.memoizedState;
        return id;
    }
    function dispatchReducerAction(fiber, queue, action) {
        if (typeof arguments[3] === 'function') error("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
        var lane = requestUpdateLane(fiber);
        var update = {
            lane: lane,
            action: action,
            hasEagerState: false,
            eagerState: null,
            next: null
        };
        if (isRenderPhaseUpdate(fiber)) enqueueRenderPhaseUpdate(queue, update);
        else {
            var root = enqueueConcurrentHookUpdate(fiber, queue, update, lane);
            if (root !== null) {
                var eventTime = requestEventTime();
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitionUpdate(root, queue, lane);
            }
        }
        markUpdateInDevTools(fiber, lane);
    }
    function dispatchSetState(fiber, queue, action) {
        if (typeof arguments[3] === 'function') error("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
        var lane = requestUpdateLane(fiber);
        var update = {
            lane: lane,
            action: action,
            hasEagerState: false,
            eagerState: null,
            next: null
        };
        if (isRenderPhaseUpdate(fiber)) enqueueRenderPhaseUpdate(queue, update);
        else {
            var alternate = fiber.alternate;
            if (fiber.lanes === NoLanes && (alternate === null || alternate.lanes === NoLanes)) {
                // The queue is currently empty, which means we can eagerly compute the
                // next state before entering the render phase. If the new state is the
                // same as the current state, we may be able to bail out entirely.
                var lastRenderedReducer = queue.lastRenderedReducer;
                if (lastRenderedReducer !== null) {
                    var prevDispatcher;
                    prevDispatcher = ReactCurrentDispatcher$1.current;
                    ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
                    try {
                        var currentState = queue.lastRenderedState;
                        var eagerState = lastRenderedReducer(currentState, action); // Stash the eagerly computed state, and the reducer used to compute
                        // it, on the update object. If the reducer hasn't changed by the
                        // time we enter the render phase, then the eager state can be used
                        // without calling the reducer again.
                        update.hasEagerState = true;
                        update.eagerState = eagerState;
                        if (objectIs(eagerState, currentState)) {
                            // Fast path. We can bail out without scheduling React to re-render.
                            // It's still possible that we'll need to rebase this update later,
                            // if the component re-renders for a different reason and by that
                            // time the reducer has changed.
                            // TODO: Do we still need to entangle transitions in this case?
                            enqueueConcurrentHookUpdateAndEagerlyBailout(fiber, queue, update, lane);
                            return;
                        }
                    } catch (error) {} finally{
                        ReactCurrentDispatcher$1.current = prevDispatcher;
                    }
                }
            }
            var root = enqueueConcurrentHookUpdate(fiber, queue, update, lane);
            if (root !== null) {
                var eventTime = requestEventTime();
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitionUpdate(root, queue, lane);
            }
        }
        markUpdateInDevTools(fiber, lane);
    }
    function isRenderPhaseUpdate(fiber) {
        var alternate = fiber.alternate;
        return fiber === currentlyRenderingFiber$1 || alternate !== null && alternate === currentlyRenderingFiber$1;
    }
    function enqueueRenderPhaseUpdate(queue, update) {
        // This is a render phase update. Stash it in a lazily-created map of
        // queue -> linked list of updates. After this render pass, we'll restart
        // and apply the stashed updates on top of the work-in-progress hook.
        didScheduleRenderPhaseUpdateDuringThisPass = didScheduleRenderPhaseUpdate = true;
        var pending = queue.pending;
        if (pending === null) // This is the first update. Create a circular list.
        update.next = update;
        else {
            update.next = pending.next;
            pending.next = update;
        }
        queue.pending = update;
    } // TODO: Move to ReactFiberConcurrentUpdates?
    function entangleTransitionUpdate(root, queue, lane) {
        if (isTransitionLane(lane)) {
            var queueLanes = queue.lanes; // If any entangled lanes are no longer pending on the root, then they
            // must have finished. We can remove them from the shared queue, which
            // represents a superset of the actually pending lanes. In some cases we
            // may entangle more than we need to, but that's OK. In fact it's worse if
            // we *don't* entangle when we should.
            queueLanes = intersectLanes(queueLanes, root.pendingLanes); // Entangle the new transition lane with the other transition lanes.
            var newQueueLanes = mergeLanes(queueLanes, lane);
            queue.lanes = newQueueLanes; // Even if queue.lanes already include lane, we don't know for certain if
            // the lane finished since the last time we entangled it. So we need to
            // entangle it again, just to be sure.
            markRootEntangled(root, newQueueLanes);
        }
    }
    function markUpdateInDevTools(fiber, lane, action) {
        markStateUpdateScheduled(fiber, lane);
    }
    var ContextOnlyDispatcher = {
        readContext: readContext,
        useCallback: throwInvalidHookError,
        useContext: throwInvalidHookError,
        useEffect: throwInvalidHookError,
        useImperativeHandle: throwInvalidHookError,
        useInsertionEffect: throwInvalidHookError,
        useLayoutEffect: throwInvalidHookError,
        useMemo: throwInvalidHookError,
        useReducer: throwInvalidHookError,
        useRef: throwInvalidHookError,
        useState: throwInvalidHookError,
        useDebugValue: throwInvalidHookError,
        useDeferredValue: throwInvalidHookError,
        useTransition: throwInvalidHookError,
        useMutableSource: throwInvalidHookError,
        useSyncExternalStore: throwInvalidHookError,
        useId: throwInvalidHookError,
        unstable_isNewReconciler: enableNewReconciler
    };
    var HooksDispatcherOnMountInDEV = null;
    var HooksDispatcherOnMountWithHookTypesInDEV = null;
    var HooksDispatcherOnUpdateInDEV = null;
    var HooksDispatcherOnRerenderInDEV = null;
    var InvalidNestedHooksDispatcherOnMountInDEV = null;
    var InvalidNestedHooksDispatcherOnUpdateInDEV = null;
    var InvalidNestedHooksDispatcherOnRerenderInDEV = null;
    var warnInvalidContextAccess = function warnInvalidContextAccess() {
        error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
    };
    var warnInvalidHookAccess = function warnInvalidHookAccess() {
        error("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks");
    };
    HooksDispatcherOnMountInDEV = {
        readContext: function readContext1(context) {
            return readContext(context);
        },
        useCallback: function useCallback(callback, deps) {
            currentHookNameInDev = 'useCallback';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountCallback(callback, deps);
        },
        useContext: function useContext(context) {
            currentHookNameInDev = 'useContext';
            mountHookTypesDev();
            return readContext(context);
        },
        useEffect: function useEffect(create, deps) {
            currentHookNameInDev = 'useEffect';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountEffect(create, deps);
        },
        useImperativeHandle: function useImperativeHandle(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function useInsertionEffect(create, deps) {
            currentHookNameInDev = 'useInsertionEffect';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountInsertionEffect(create, deps);
        },
        useLayoutEffect: function useLayoutEffect(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountLayoutEffect(create, deps);
        },
        useMemo: function useMemo(create, deps) {
            currentHookNameInDev = 'useMemo';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function useReducer(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function useRef(initialValue) {
            currentHookNameInDev = 'useRef';
            mountHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function useState(initialState) {
            currentHookNameInDev = 'useState';
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function useDebugValue(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            mountHookTypesDev();
            return mountDebugValue();
        },
        useDeferredValue: function useDeferredValue(value) {
            currentHookNameInDev = 'useDeferredValue';
            mountHookTypesDev();
            return mountDeferredValue(value);
        },
        useTransition: function useTransition() {
            currentHookNameInDev = 'useTransition';
            mountHookTypesDev();
            return mountTransition();
        },
        useMutableSource: function useMutableSource(source, getSnapshot, subscribe) {
            currentHookNameInDev = 'useMutableSource';
            mountHookTypesDev();
            return mountMutableSource();
        },
        useSyncExternalStore: function useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = 'useSyncExternalStore';
            mountHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function useId() {
            currentHookNameInDev = 'useId';
            mountHookTypesDev();
            return mountId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    HooksDispatcherOnMountWithHookTypesInDEV = {
        readContext: function readContext1(context) {
            return readContext(context);
        },
        useCallback: function useCallback(callback, deps) {
            currentHookNameInDev = 'useCallback';
            updateHookTypesDev();
            return mountCallback(callback, deps);
        },
        useContext: function useContext(context) {
            currentHookNameInDev = 'useContext';
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function useEffect(create, deps) {
            currentHookNameInDev = 'useEffect';
            updateHookTypesDev();
            return mountEffect(create, deps);
        },
        useImperativeHandle: function useImperativeHandle(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            updateHookTypesDev();
            return mountImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function useInsertionEffect(create, deps) {
            currentHookNameInDev = 'useInsertionEffect';
            updateHookTypesDev();
            return mountInsertionEffect(create, deps);
        },
        useLayoutEffect: function useLayoutEffect(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            updateHookTypesDev();
            return mountLayoutEffect(create, deps);
        },
        useMemo: function useMemo(create, deps) {
            currentHookNameInDev = 'useMemo';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function useReducer(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function useRef(initialValue) {
            currentHookNameInDev = 'useRef';
            updateHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function useState(initialState) {
            currentHookNameInDev = 'useState';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function useDebugValue(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            updateHookTypesDev();
            return mountDebugValue();
        },
        useDeferredValue: function useDeferredValue(value) {
            currentHookNameInDev = 'useDeferredValue';
            updateHookTypesDev();
            return mountDeferredValue(value);
        },
        useTransition: function useTransition() {
            currentHookNameInDev = 'useTransition';
            updateHookTypesDev();
            return mountTransition();
        },
        useMutableSource: function useMutableSource(source, getSnapshot, subscribe) {
            currentHookNameInDev = 'useMutableSource';
            updateHookTypesDev();
            return mountMutableSource();
        },
        useSyncExternalStore: function useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = 'useSyncExternalStore';
            updateHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function useId() {
            currentHookNameInDev = 'useId';
            updateHookTypesDev();
            return mountId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    HooksDispatcherOnUpdateInDEV = {
        readContext: function readContext1(context) {
            return readContext(context);
        },
        useCallback: function useCallback(callback, deps) {
            currentHookNameInDev = 'useCallback';
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function useContext(context) {
            currentHookNameInDev = 'useContext';
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function useEffect(create, deps) {
            currentHookNameInDev = 'useEffect';
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function useImperativeHandle(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function useInsertionEffect(create, deps) {
            currentHookNameInDev = 'useInsertionEffect';
            updateHookTypesDev();
            return updateInsertionEffect(create, deps);
        },
        useLayoutEffect: function useLayoutEffect(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function useMemo(create, deps) {
            currentHookNameInDev = 'useMemo';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function useReducer(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function useRef(initialValue) {
            currentHookNameInDev = 'useRef';
            updateHookTypesDev();
            return updateRef();
        },
        useState: function useState(initialState) {
            currentHookNameInDev = 'useState';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function useDebugValue(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function useDeferredValue(value) {
            currentHookNameInDev = 'useDeferredValue';
            updateHookTypesDev();
            return updateDeferredValue(value);
        },
        useTransition: function useTransition() {
            currentHookNameInDev = 'useTransition';
            updateHookTypesDev();
            return updateTransition();
        },
        useMutableSource: function useMutableSource(source, getSnapshot, subscribe) {
            currentHookNameInDev = 'useMutableSource';
            updateHookTypesDev();
            return updateMutableSource();
        },
        useSyncExternalStore: function useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = 'useSyncExternalStore';
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
        },
        useId: function useId() {
            currentHookNameInDev = 'useId';
            updateHookTypesDev();
            return updateId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    HooksDispatcherOnRerenderInDEV = {
        readContext: function readContext1(context) {
            return readContext(context);
        },
        useCallback: function useCallback(callback, deps) {
            currentHookNameInDev = 'useCallback';
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function useContext(context) {
            currentHookNameInDev = 'useContext';
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function useEffect(create, deps) {
            currentHookNameInDev = 'useEffect';
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function useImperativeHandle(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function useInsertionEffect(create, deps) {
            currentHookNameInDev = 'useInsertionEffect';
            updateHookTypesDev();
            return updateInsertionEffect(create, deps);
        },
        useLayoutEffect: function useLayoutEffect(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function useMemo(create, deps) {
            currentHookNameInDev = 'useMemo';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function useReducer(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return rerenderReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function useRef(initialValue) {
            currentHookNameInDev = 'useRef';
            updateHookTypesDev();
            return updateRef();
        },
        useState: function useState(initialState) {
            currentHookNameInDev = 'useState';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return rerenderState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function useDebugValue(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function useDeferredValue(value) {
            currentHookNameInDev = 'useDeferredValue';
            updateHookTypesDev();
            return rerenderDeferredValue(value);
        },
        useTransition: function useTransition() {
            currentHookNameInDev = 'useTransition';
            updateHookTypesDev();
            return rerenderTransition();
        },
        useMutableSource: function useMutableSource(source, getSnapshot, subscribe) {
            currentHookNameInDev = 'useMutableSource';
            updateHookTypesDev();
            return updateMutableSource();
        },
        useSyncExternalStore: function useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = 'useSyncExternalStore';
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
        },
        useId: function useId() {
            currentHookNameInDev = 'useId';
            updateHookTypesDev();
            return updateId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    InvalidNestedHooksDispatcherOnMountInDEV = {
        readContext: function readContext1(context) {
            warnInvalidContextAccess();
            return readContext(context);
        },
        useCallback: function useCallback(callback, deps) {
            currentHookNameInDev = 'useCallback';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountCallback(callback, deps);
        },
        useContext: function useContext(context) {
            currentHookNameInDev = 'useContext';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return readContext(context);
        },
        useEffect: function useEffect(create, deps) {
            currentHookNameInDev = 'useEffect';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountEffect(create, deps);
        },
        useImperativeHandle: function useImperativeHandle(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function useInsertionEffect(create, deps) {
            currentHookNameInDev = 'useInsertionEffect';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountInsertionEffect(create, deps);
        },
        useLayoutEffect: function useLayoutEffect(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountLayoutEffect(create, deps);
        },
        useMemo: function useMemo(create, deps) {
            currentHookNameInDev = 'useMemo';
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function useReducer(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function useRef(initialValue) {
            currentHookNameInDev = 'useRef';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function useState(initialState) {
            currentHookNameInDev = 'useState';
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function useDebugValue(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountDebugValue();
        },
        useDeferredValue: function useDeferredValue(value) {
            currentHookNameInDev = 'useDeferredValue';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountDeferredValue(value);
        },
        useTransition: function useTransition() {
            currentHookNameInDev = 'useTransition';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountTransition();
        },
        useMutableSource: function useMutableSource(source, getSnapshot, subscribe) {
            currentHookNameInDev = 'useMutableSource';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountMutableSource();
        },
        useSyncExternalStore: function useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = 'useSyncExternalStore';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function useId() {
            currentHookNameInDev = 'useId';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    InvalidNestedHooksDispatcherOnUpdateInDEV = {
        readContext: function readContext1(context) {
            warnInvalidContextAccess();
            return readContext(context);
        },
        useCallback: function useCallback(callback, deps) {
            currentHookNameInDev = 'useCallback';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function useContext(context) {
            currentHookNameInDev = 'useContext';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function useEffect(create, deps) {
            currentHookNameInDev = 'useEffect';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function useImperativeHandle(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function useInsertionEffect(create, deps) {
            currentHookNameInDev = 'useInsertionEffect';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateInsertionEffect(create, deps);
        },
        useLayoutEffect: function useLayoutEffect(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function useMemo(create, deps) {
            currentHookNameInDev = 'useMemo';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function useReducer(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function useRef(initialValue) {
            currentHookNameInDev = 'useRef';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateRef();
        },
        useState: function useState(initialState) {
            currentHookNameInDev = 'useState';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function useDebugValue(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function useDeferredValue(value) {
            currentHookNameInDev = 'useDeferredValue';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDeferredValue(value);
        },
        useTransition: function useTransition() {
            currentHookNameInDev = 'useTransition';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateTransition();
        },
        useMutableSource: function useMutableSource(source, getSnapshot, subscribe) {
            currentHookNameInDev = 'useMutableSource';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateMutableSource();
        },
        useSyncExternalStore: function useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = 'useSyncExternalStore';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
        },
        useId: function useId() {
            currentHookNameInDev = 'useId';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    InvalidNestedHooksDispatcherOnRerenderInDEV = {
        readContext: function readContext1(context) {
            warnInvalidContextAccess();
            return readContext(context);
        },
        useCallback: function useCallback(callback, deps) {
            currentHookNameInDev = 'useCallback';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function useContext(context) {
            currentHookNameInDev = 'useContext';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function useEffect(create, deps) {
            currentHookNameInDev = 'useEffect';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function useImperativeHandle(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function useInsertionEffect(create, deps) {
            currentHookNameInDev = 'useInsertionEffect';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateInsertionEffect(create, deps);
        },
        useLayoutEffect: function useLayoutEffect(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function useMemo(create, deps) {
            currentHookNameInDev = 'useMemo';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function useReducer(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return rerenderReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function useRef(initialValue) {
            currentHookNameInDev = 'useRef';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateRef();
        },
        useState: function useState(initialState) {
            currentHookNameInDev = 'useState';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return rerenderState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function useDebugValue(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function useDeferredValue(value) {
            currentHookNameInDev = 'useDeferredValue';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderDeferredValue(value);
        },
        useTransition: function useTransition() {
            currentHookNameInDev = 'useTransition';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderTransition();
        },
        useMutableSource: function useMutableSource(source, getSnapshot, subscribe) {
            currentHookNameInDev = 'useMutableSource';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateMutableSource();
        },
        useSyncExternalStore: function useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = 'useSyncExternalStore';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
        },
        useId: function useId() {
            currentHookNameInDev = 'useId';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    var now$1 = Scheduler.unstable_now;
    var commitTime = 0;
    var layoutEffectStartTime = -1;
    var profilerStartTime = -1;
    var passiveEffectStartTime = -1;
    /**
 * Tracks whether the current update was a nested/cascading update (scheduled from a layout effect).
 *
 * The overall sequence is:
 *   1. render
 *   2. commit (and call `onRender`, `onCommit`)
 *   3. check for nested updates
 *   4. flush passive effects (and call `onPostCommit`)
 *
 * Nested updates are identified in step 3 above,
 * but step 4 still applies to the work that was just committed.
 * We use two flags to track nested updates then:
 * one tracks whether the upcoming update is a nested update,
 * and the other tracks whether the current update was a nested update.
 * The first value gets synced to the second at the start of the render phase.
 */ var currentUpdateIsNested = false;
    var nestedUpdateScheduled = false;
    function isCurrentUpdateNested() {
        return currentUpdateIsNested;
    }
    function markNestedUpdateScheduled() {
        nestedUpdateScheduled = true;
    }
    function resetNestedUpdateFlag() {
        currentUpdateIsNested = false;
        nestedUpdateScheduled = false;
    }
    function syncNestedUpdateFlag() {
        currentUpdateIsNested = nestedUpdateScheduled;
        nestedUpdateScheduled = false;
    }
    function getCommitTime() {
        return commitTime;
    }
    function recordCommitTime() {
        commitTime = now$1();
    }
    function startProfilerTimer(fiber) {
        profilerStartTime = now$1();
        if (fiber.actualStartTime < 0) fiber.actualStartTime = now$1();
    }
    function stopProfilerTimerIfRunning(fiber) {
        profilerStartTime = -1;
    }
    function stopProfilerTimerIfRunningAndRecordDelta(fiber, overrideBaseTime) {
        if (profilerStartTime >= 0) {
            var elapsedTime = now$1() - profilerStartTime;
            fiber.actualDuration += elapsedTime;
            if (overrideBaseTime) fiber.selfBaseDuration = elapsedTime;
            profilerStartTime = -1;
        }
    }
    function recordLayoutEffectDuration(fiber) {
        if (layoutEffectStartTime >= 0) {
            var elapsedTime = now$1() - layoutEffectStartTime;
            layoutEffectStartTime = -1; // Store duration on the next nearest Profiler ancestor
            // Or the root (for the DevTools Profiler to read)
            var parentFiber = fiber.return;
            while(parentFiber !== null){
                switch(parentFiber.tag){
                    case HostRoot:
                        var root = parentFiber.stateNode;
                        root.effectDuration += elapsedTime;
                        return;
                    case Profiler:
                        var parentStateNode = parentFiber.stateNode;
                        parentStateNode.effectDuration += elapsedTime;
                        return;
                }
                parentFiber = parentFiber.return;
            }
        }
    }
    function recordPassiveEffectDuration(fiber) {
        if (passiveEffectStartTime >= 0) {
            var elapsedTime = now$1() - passiveEffectStartTime;
            passiveEffectStartTime = -1; // Store duration on the next nearest Profiler ancestor
            // Or the root (for the DevTools Profiler to read)
            var parentFiber = fiber.return;
            while(parentFiber !== null){
                switch(parentFiber.tag){
                    case HostRoot:
                        var root = parentFiber.stateNode;
                        if (root !== null) root.passiveEffectDuration += elapsedTime;
                        return;
                    case Profiler:
                        var parentStateNode = parentFiber.stateNode;
                        if (parentStateNode !== null) // Detached fibers have their state node cleared out.
                        // In this case, the return pointer is also cleared out,
                        // so we won't be able to report the time spent in this Profiler's subtree.
                        parentStateNode.passiveEffectDuration += elapsedTime;
                        return;
                }
                parentFiber = parentFiber.return;
            }
        }
    }
    function startLayoutEffectTimer() {
        layoutEffectStartTime = now$1();
    }
    function startPassiveEffectTimer() {
        passiveEffectStartTime = now$1();
    }
    function transferActualDuration(fiber) {
        // Transfer time spent rendering these children so we don't lose it
        // after we rerender. This is used as a helper in special cases
        // where we should count the work of multiple passes.
        var child = fiber.child;
        while(child){
            fiber.actualDuration += child.actualDuration;
            child = child.sibling;
        }
    }
    function resolveDefaultProps(Component, baseProps) {
        if (Component && Component.defaultProps) {
            // Resolve default props. Taken from ReactElement
            var props = assign({}, baseProps);
            var defaultProps = Component.defaultProps;
            for(var propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
            return props;
        }
        return baseProps;
    }
    var fakeInternalInstance = {};
    var didWarnAboutStateAssignmentForComponent;
    var didWarnAboutUninitializedState;
    var didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate;
    var didWarnAboutLegacyLifecyclesAndDerivedState;
    var didWarnAboutUndefinedDerivedState;
    var warnOnUndefinedDerivedState;
    var warnOnInvalidCallback;
    var didWarnAboutDirectlyAssigningPropsToState;
    var didWarnAboutContextTypeAndContextTypes;
    var didWarnAboutInvalidateContextType;
    var didWarnAboutLegacyContext$1;
    didWarnAboutStateAssignmentForComponent = new Set();
    didWarnAboutUninitializedState = new Set();
    didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate = new Set();
    didWarnAboutLegacyLifecyclesAndDerivedState = new Set();
    didWarnAboutDirectlyAssigningPropsToState = new Set();
    didWarnAboutUndefinedDerivedState = new Set();
    didWarnAboutContextTypeAndContextTypes = new Set();
    didWarnAboutInvalidateContextType = new Set();
    didWarnAboutLegacyContext$1 = new Set();
    var didWarnOnInvalidCallback = new Set();
    warnOnInvalidCallback = function warnOnInvalidCallback(callback, callerName) {
        if (callback === null || typeof callback === 'function') return;
        var key = callerName + '_' + callback;
        if (!didWarnOnInvalidCallback.has(key)) {
            didWarnOnInvalidCallback.add(key);
            error("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callerName, callback);
        }
    };
    warnOnUndefinedDerivedState = function warnOnUndefinedDerivedState(type, partialState) {
        if (partialState === undefined) {
            var componentName = getComponentNameFromType(type) || 'Component';
            if (!didWarnAboutUndefinedDerivedState.has(componentName)) {
                didWarnAboutUndefinedDerivedState.add(componentName);
                error("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", componentName);
            }
        }
    }; // This is so gross but it's at least non-critical and can be removed if
    // it causes problems. This is meant to give a nicer error message for
    // ReactDOM15.unstable_renderSubtreeIntoContainer(reactDOM16Component,
    // ...)) which otherwise throws a "_processChildContext is not a function"
    // exception.
    Object.defineProperty(fakeInternalInstance, '_processChildContext', {
        enumerable: false,
        value: function value() {
            throw new Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).");
        }
    });
    Object.freeze(fakeInternalInstance);
    function applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
        var prevState = workInProgress.memoizedState;
        var partialState = getDerivedStateFromProps(nextProps, prevState);
        if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);
            try {
                // Invoke the function an extra time to help detect side-effects.
                partialState = getDerivedStateFromProps(nextProps, prevState);
            } finally{
                setIsStrictModeForDevtools(false);
            }
        }
        warnOnUndefinedDerivedState(ctor, partialState);
        var memoizedState = partialState === null || partialState === undefined ? prevState : assign({}, prevState, partialState);
        workInProgress.memoizedState = memoizedState; // Once the update queue is empty, persist the derived state onto the
        // base state.
        if (workInProgress.lanes === NoLanes) {
            // Queue is always non-null for classes
            var updateQueue = workInProgress.updateQueue;
            updateQueue.baseState = memoizedState;
        }
    }
    var classComponentUpdater = {
        isMounted: isMounted,
        enqueueSetState: function enqueueSetState(inst, payload, callback) {
            var fiber = get(inst);
            var eventTime = requestEventTime();
            var lane = requestUpdateLane(fiber);
            var update = createUpdate(eventTime, lane);
            update.payload = payload;
            if (callback !== undefined && callback !== null) {
                warnOnInvalidCallback(callback, 'setState');
                update.callback = callback;
            }
            var root = enqueueUpdate(fiber, update, lane);
            if (root !== null) {
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitions(root, fiber, lane);
            }
            markStateUpdateScheduled(fiber, lane);
        },
        enqueueReplaceState: function enqueueReplaceState(inst, payload, callback) {
            var fiber = get(inst);
            var eventTime = requestEventTime();
            var lane = requestUpdateLane(fiber);
            var update = createUpdate(eventTime, lane);
            update.tag = ReplaceState;
            update.payload = payload;
            if (callback !== undefined && callback !== null) {
                warnOnInvalidCallback(callback, 'replaceState');
                update.callback = callback;
            }
            var root = enqueueUpdate(fiber, update, lane);
            if (root !== null) {
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitions(root, fiber, lane);
            }
            markStateUpdateScheduled(fiber, lane);
        },
        enqueueForceUpdate: function enqueueForceUpdate(inst, callback) {
            var fiber = get(inst);
            var eventTime = requestEventTime();
            var lane = requestUpdateLane(fiber);
            var update = createUpdate(eventTime, lane);
            update.tag = ForceUpdate;
            if (callback !== undefined && callback !== null) {
                warnOnInvalidCallback(callback, 'forceUpdate');
                update.callback = callback;
            }
            var root = enqueueUpdate(fiber, update, lane);
            if (root !== null) {
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitions(root, fiber, lane);
            }
            markForceUpdateScheduled(fiber, lane);
        }
    };
    function checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
        var instance = workInProgress.stateNode;
        if (typeof instance.shouldComponentUpdate === 'function') {
            var shouldUpdate = instance.shouldComponentUpdate(newProps, newState, nextContext);
            if (workInProgress.mode & StrictLegacyMode) {
                setIsStrictModeForDevtools(true);
                try {
                    // Invoke the function an extra time to help detect side-effects.
                    shouldUpdate = instance.shouldComponentUpdate(newProps, newState, nextContext);
                } finally{
                    setIsStrictModeForDevtools(false);
                }
            }
            if (shouldUpdate === undefined) error("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", getComponentNameFromType(ctor) || 'Component');
            return shouldUpdate;
        }
        if (ctor.prototype && ctor.prototype.isPureReactComponent) return !shallowEqual(oldProps, newProps) || !shallowEqual(oldState, newState);
        return true;
    }
    function checkClassInstance(workInProgress, ctor, newProps) {
        var instance = workInProgress.stateNode;
        var name = getComponentNameFromType(ctor) || 'Component';
        var renderPresent = instance.render;
        if (!renderPresent) {
            if (ctor.prototype && typeof ctor.prototype.render === 'function') error("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", name);
            else error("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", name);
        }
        if (instance.getInitialState && !instance.getInitialState.isReactClassApproved && !instance.state) error("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", name);
        if (instance.getDefaultProps && !instance.getDefaultProps.isReactClassApproved) error("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", name);
        if (instance.propTypes) error("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", name);
        if (instance.contextType) error("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", name);
        if (ctor.childContextTypes && !didWarnAboutLegacyContext$1.has(ctor) && // Strict Mode has its own warning for legacy context, so we can skip
        // this one.
        (workInProgress.mode & StrictLegacyMode) === NoMode) {
            didWarnAboutLegacyContext$1.add(ctor);
            error("%s uses the legacy childContextTypes API which is no longer supported and will be removed in the next major release. Use React.createContext() instead\n\n.Learn more about this warning here: https://reactjs.org/link/legacy-context", name);
        }
        if (ctor.contextTypes && !didWarnAboutLegacyContext$1.has(ctor) && // Strict Mode has its own warning for legacy context, so we can skip
        // this one.
        (workInProgress.mode & StrictLegacyMode) === NoMode) {
            didWarnAboutLegacyContext$1.add(ctor);
            error("%s uses the legacy contextTypes API which is no longer supported and will be removed in the next major release. Use React.createContext() with static contextType instead.\n\nLearn more about this warning here: https://reactjs.org/link/legacy-context", name);
        }
        if (instance.contextTypes) error("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", name);
        if (ctor.contextType && ctor.contextTypes && !didWarnAboutContextTypeAndContextTypes.has(ctor)) {
            didWarnAboutContextTypeAndContextTypes.add(ctor);
            error("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", name);
        }
        if (typeof instance.componentShouldUpdate === 'function') error("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", name);
        if (ctor.prototype && ctor.prototype.isPureReactComponent && typeof instance.shouldComponentUpdate !== 'undefined') error("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", getComponentNameFromType(ctor) || 'A pure component');
        if (typeof instance.componentDidUnmount === 'function') error("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", name);
        if (typeof instance.componentDidReceiveProps === 'function') error("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", name);
        if (typeof instance.componentWillRecieveProps === 'function') error("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", name);
        if (typeof instance.UNSAFE_componentWillRecieveProps === 'function') error("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", name);
        var hasMutatedProps = instance.props !== newProps;
        if (instance.props !== undefined && hasMutatedProps) error("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", name, name);
        if (instance.defaultProps) error("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", name, name);
        if (typeof instance.getSnapshotBeforeUpdate === 'function' && typeof instance.componentDidUpdate !== 'function' && !didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.has(ctor)) {
            didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.add(ctor);
            error("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", getComponentNameFromType(ctor));
        }
        if (typeof instance.getDerivedStateFromProps === 'function') error("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", name);
        if (typeof instance.getDerivedStateFromError === 'function') error("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", name);
        if (typeof ctor.getSnapshotBeforeUpdate === 'function') error("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", name);
        var _state = instance.state;
        if (_state && (typeof _state !== 'object' || isArray(_state))) error('%s.state: must be set to an object or null', name);
        if (typeof instance.getChildContext === 'function' && typeof ctor.childContextTypes !== 'object') error("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", name);
    }
    function adoptClassInstance(workInProgress, instance) {
        instance.updater = classComponentUpdater;
        workInProgress.stateNode = instance; // The instance needs access to the fiber so that it can schedule updates
        set(instance, workInProgress);
        instance._reactInternalInstance = fakeInternalInstance;
    }
    function constructClassInstance(workInProgress, ctor, props) {
        var isLegacyContextConsumer = false;
        var unmaskedContext = emptyContextObject;
        var context = emptyContextObject;
        var contextType = ctor.contextType;
        if ('contextType' in ctor) {
            var isValid = contextType === null || contextType !== undefined && contextType.$$typeof === REACT_CONTEXT_TYPE && contextType._context === undefined; // Not a <Context.Consumer>
            if (!isValid && !didWarnAboutInvalidateContextType.has(ctor)) {
                didWarnAboutInvalidateContextType.add(ctor);
                var addendum = '';
                if (contextType === undefined) addendum = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file.";
                else if (typeof contextType !== 'object') addendum = ' However, it is set to a ' + typeof contextType + '.';
                else if (contextType.$$typeof === REACT_PROVIDER_TYPE) addendum = ' Did you accidentally pass the Context.Provider instead?';
                else if (contextType._context !== undefined) // <Context.Consumer>
                addendum = ' Did you accidentally pass the Context.Consumer instead?';
                else addendum = ' However, it is set to an object with keys {' + Object.keys(contextType).join(', ') + '}.';
                error("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", getComponentNameFromType(ctor) || 'Component', addendum);
            }
        }
        if (typeof contextType === 'object' && contextType !== null) context = readContext(contextType);
        else {
            unmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            var contextTypes = ctor.contextTypes;
            isLegacyContextConsumer = contextTypes !== null && contextTypes !== undefined;
            context = isLegacyContextConsumer ? getMaskedContext(workInProgress, unmaskedContext) : emptyContextObject;
        }
        var instance = new ctor(props, context); // Instantiate twice to help detect side-effects.
        if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);
            try {
                instance = new ctor(props, context); // eslint-disable-line no-new
            } finally{
                setIsStrictModeForDevtools(false);
            }
        }
        var state = workInProgress.memoizedState = instance.state !== null && instance.state !== undefined ? instance.state : null;
        adoptClassInstance(workInProgress, instance);
        if (typeof ctor.getDerivedStateFromProps === 'function' && state === null) {
            var componentName = getComponentNameFromType(ctor) || 'Component';
            if (!didWarnAboutUninitializedState.has(componentName)) {
                didWarnAboutUninitializedState.add(componentName);
                error("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", componentName, instance.state === null ? 'null' : 'undefined', componentName);
            }
        } // If new component APIs are defined, "unsafe" lifecycles won't be called.
        // Warn about these lifecycles if they are present.
        // Don't warn about react-lifecycles-compat polyfilled methods though.
        if (typeof ctor.getDerivedStateFromProps === 'function' || typeof instance.getSnapshotBeforeUpdate === 'function') {
            var foundWillMountName = null;
            var foundWillReceivePropsName = null;
            var foundWillUpdateName = null;
            if (typeof instance.componentWillMount === 'function' && instance.componentWillMount.__suppressDeprecationWarning !== true) foundWillMountName = 'componentWillMount';
            else if (typeof instance.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
            if (typeof instance.componentWillReceiveProps === 'function' && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) foundWillReceivePropsName = 'componentWillReceiveProps';
            else if (typeof instance.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
            if (typeof instance.componentWillUpdate === 'function' && instance.componentWillUpdate.__suppressDeprecationWarning !== true) foundWillUpdateName = 'componentWillUpdate';
            else if (typeof instance.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
            if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
                var _componentName = getComponentNameFromType(ctor) || 'Component';
                var newApiName = typeof ctor.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
                if (!didWarnAboutLegacyLifecyclesAndDerivedState.has(_componentName)) {
                    didWarnAboutLegacyLifecyclesAndDerivedState.add(_componentName);
                    error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n%s uses %s but also contains the following legacy lifecycles:%s%s%s\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://reactjs.org/link/unsafe-component-lifecycles", _componentName, newApiName, foundWillMountName !== null ? "\n  " + foundWillMountName : '', foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : '', foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : '');
                }
            }
        }
        // ReactFiberContext usually updates this cache but can't for newly-created instances.
        if (isLegacyContextConsumer) cacheContext(workInProgress, unmaskedContext, context);
        return instance;
    }
    function callComponentWillMount(workInProgress, instance) {
        var oldState = instance.state;
        if (typeof instance.componentWillMount === 'function') instance.componentWillMount();
        if (typeof instance.UNSAFE_componentWillMount === 'function') instance.UNSAFE_componentWillMount();
        if (oldState !== instance.state) {
            error("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", getComponentNameFromFiber(workInProgress) || 'Component');
            classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
        }
    }
    function callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
        var oldState = instance.state;
        if (typeof instance.componentWillReceiveProps === 'function') instance.componentWillReceiveProps(newProps, nextContext);
        if (typeof instance.UNSAFE_componentWillReceiveProps === 'function') instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
        if (instance.state !== oldState) {
            var componentName = getComponentNameFromFiber(workInProgress) || 'Component';
            if (!didWarnAboutStateAssignmentForComponent.has(componentName)) {
                didWarnAboutStateAssignmentForComponent.add(componentName);
                error("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", componentName);
            }
            classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
        }
    } // Invokes the mount life-cycles on a previously never rendered instance.
    function mountClassInstance(workInProgress, ctor, newProps, renderLanes) {
        checkClassInstance(workInProgress, ctor, newProps);
        var instance = workInProgress.stateNode;
        instance.props = newProps;
        instance.state = workInProgress.memoizedState;
        instance.refs = {};
        initializeUpdateQueue(workInProgress);
        var contextType = ctor.contextType;
        if (typeof contextType === 'object' && contextType !== null) instance.context = readContext(contextType);
        else {
            var unmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            instance.context = getMaskedContext(workInProgress, unmaskedContext);
        }
        if (instance.state === newProps) {
            var componentName = getComponentNameFromType(ctor) || 'Component';
            if (!didWarnAboutDirectlyAssigningPropsToState.has(componentName)) {
                didWarnAboutDirectlyAssigningPropsToState.add(componentName);
                error("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", componentName);
            }
        }
        if (workInProgress.mode & StrictLegacyMode) ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, instance);
        ReactStrictModeWarnings.recordUnsafeLifecycleWarnings(workInProgress, instance);
        instance.state = workInProgress.memoizedState;
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        if (typeof getDerivedStateFromProps === 'function') {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            instance.state = workInProgress.memoizedState;
        } // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.
        if (typeof ctor.getDerivedStateFromProps !== 'function' && typeof instance.getSnapshotBeforeUpdate !== 'function' && (typeof instance.UNSAFE_componentWillMount === 'function' || typeof instance.componentWillMount === 'function')) {
            callComponentWillMount(workInProgress, instance); // If we had additional state updates during this life-cycle, let's
            // process them now.
            processUpdateQueue(workInProgress, newProps, instance, renderLanes);
            instance.state = workInProgress.memoizedState;
        }
        if (typeof instance.componentDidMount === 'function') {
            var fiberFlags = Update;
            fiberFlags |= LayoutStatic;
            if ((workInProgress.mode & StrictEffectsMode) !== NoMode) fiberFlags |= MountLayoutDev;
            workInProgress.flags |= fiberFlags;
        }
    }
    function resumeMountClassInstance(workInProgress, ctor, newProps, renderLanes) {
        var instance = workInProgress.stateNode;
        var oldProps = workInProgress.memoizedProps;
        instance.props = oldProps;
        var oldContext = instance.context;
        var contextType = ctor.contextType;
        var nextContext = emptyContextObject;
        if (typeof contextType === 'object' && contextType !== null) nextContext = readContext(contextType);
        else {
            var nextLegacyUnmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            nextContext = getMaskedContext(workInProgress, nextLegacyUnmaskedContext);
        }
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        var hasNewLifecycles = typeof getDerivedStateFromProps === 'function' || typeof instance.getSnapshotBeforeUpdate === 'function'; // Note: During these life-cycles, instance.props/instance.state are what
        // ever the previously attempted to render - not the "current". However,
        // during componentDidUpdate we pass the "current" props.
        // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.
        if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === 'function' || typeof instance.componentWillReceiveProps === 'function')) {
            if (oldProps !== newProps || oldContext !== nextContext) callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext);
        }
        resetHasForceUpdateBeforeProcessing();
        var oldState = workInProgress.memoizedState;
        var newState = instance.state = oldState;
        processUpdateQueue(workInProgress, newProps, instance, renderLanes);
        newState = workInProgress.memoizedState;
        if (oldProps === newProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing()) {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidMount === 'function') {
                var fiberFlags = Update;
                fiberFlags |= LayoutStatic;
                if ((workInProgress.mode & StrictEffectsMode) !== NoMode) fiberFlags |= MountLayoutDev;
                workInProgress.flags |= fiberFlags;
            }
            return false;
        }
        if (typeof getDerivedStateFromProps === 'function') {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            newState = workInProgress.memoizedState;
        }
        var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext);
        if (shouldUpdate) {
            // In order to support react-lifecycles-compat polyfilled components,
            // Unsafe lifecycles should not be invoked for components using the new APIs.
            if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillMount === 'function' || typeof instance.componentWillMount === 'function')) {
                if (typeof instance.componentWillMount === 'function') instance.componentWillMount();
                if (typeof instance.UNSAFE_componentWillMount === 'function') instance.UNSAFE_componentWillMount();
            }
            if (typeof instance.componentDidMount === 'function') {
                var _fiberFlags = Update;
                _fiberFlags |= LayoutStatic;
                if ((workInProgress.mode & StrictEffectsMode) !== NoMode) _fiberFlags |= MountLayoutDev;
                workInProgress.flags |= _fiberFlags;
            }
        } else {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidMount === 'function') {
                var _fiberFlags2 = Update;
                _fiberFlags2 |= LayoutStatic;
                if ((workInProgress.mode & StrictEffectsMode) !== NoMode) _fiberFlags2 |= MountLayoutDev;
                workInProgress.flags |= _fiberFlags2;
            } // If shouldComponentUpdate returned false, we should still update the
            // memoized state to indicate that this work can be reused.
            workInProgress.memoizedProps = newProps;
            workInProgress.memoizedState = newState;
        } // Update the existing instance's state, props, and context pointers even
        // if shouldComponentUpdate returns false.
        instance.props = newProps;
        instance.state = newState;
        instance.context = nextContext;
        return shouldUpdate;
    } // Invokes the update life-cycles and returns false if it shouldn't rerender.
    function updateClassInstance(current, workInProgress, ctor, newProps, renderLanes) {
        var instance = workInProgress.stateNode;
        cloneUpdateQueue(current, workInProgress);
        var unresolvedOldProps = workInProgress.memoizedProps;
        var oldProps = workInProgress.type === workInProgress.elementType ? unresolvedOldProps : resolveDefaultProps(workInProgress.type, unresolvedOldProps);
        instance.props = oldProps;
        var unresolvedNewProps = workInProgress.pendingProps;
        var oldContext = instance.context;
        var contextType = ctor.contextType;
        var nextContext = emptyContextObject;
        if (typeof contextType === 'object' && contextType !== null) nextContext = readContext(contextType);
        else {
            var nextUnmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            nextContext = getMaskedContext(workInProgress, nextUnmaskedContext);
        }
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        var hasNewLifecycles = typeof getDerivedStateFromProps === 'function' || typeof instance.getSnapshotBeforeUpdate === 'function'; // Note: During these life-cycles, instance.props/instance.state are what
        // ever the previously attempted to render - not the "current". However,
        // during componentDidUpdate we pass the "current" props.
        // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.
        if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === 'function' || typeof instance.componentWillReceiveProps === 'function')) {
            if (unresolvedOldProps !== unresolvedNewProps || oldContext !== nextContext) callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext);
        }
        resetHasForceUpdateBeforeProcessing();
        var oldState = workInProgress.memoizedState;
        var newState = instance.state = oldState;
        processUpdateQueue(workInProgress, newProps, instance, renderLanes);
        newState = workInProgress.memoizedState;
        if (unresolvedOldProps === unresolvedNewProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing() && !enableLazyContextPropagation) {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidUpdate === 'function') {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Update;
            }
            if (typeof instance.getSnapshotBeforeUpdate === 'function') {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Snapshot;
            }
            return false;
        }
        if (typeof getDerivedStateFromProps === 'function') {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            newState = workInProgress.memoizedState;
        }
        var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) || // TODO: In some cases, we'll end up checking if context has changed twice,
        // both before and after `shouldComponentUpdate` has been called. Not ideal,
        // but I'm loath to refactor this function. This only happens for memoized
        // components so it's not that common.
        enableLazyContextPropagation;
        if (shouldUpdate) {
            // In order to support react-lifecycles-compat polyfilled components,
            // Unsafe lifecycles should not be invoked for components using the new APIs.
            if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillUpdate === 'function' || typeof instance.componentWillUpdate === 'function')) {
                if (typeof instance.componentWillUpdate === 'function') instance.componentWillUpdate(newProps, newState, nextContext);
                if (typeof instance.UNSAFE_componentWillUpdate === 'function') instance.UNSAFE_componentWillUpdate(newProps, newState, nextContext);
            }
            if (typeof instance.componentDidUpdate === 'function') workInProgress.flags |= Update;
            if (typeof instance.getSnapshotBeforeUpdate === 'function') workInProgress.flags |= Snapshot;
        } else {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidUpdate === 'function') {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Update;
            }
            if (typeof instance.getSnapshotBeforeUpdate === 'function') {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Snapshot;
            } // If shouldComponentUpdate returned false, we should still update the
            // memoized props/state to indicate that this work can be reused.
            workInProgress.memoizedProps = newProps;
            workInProgress.memoizedState = newState;
        } // Update the existing instance's state, props, and context pointers even
        // if shouldComponentUpdate returns false.
        instance.props = newProps;
        instance.state = newState;
        instance.context = nextContext;
        return shouldUpdate;
    }
    function createCapturedValueAtFiber(value, source) {
        // If the value is an error, call this function immediately after it is thrown
        // so the stack is accurate.
        return {
            value: value,
            source: source,
            stack: getStackByFiberInDevAndProd(source),
            digest: null
        };
    }
    function createCapturedValue(value, digest, stack) {
        return {
            value: value,
            source: null,
            stack: stack != null ? stack : null,
            digest: digest != null ? digest : null
        };
    }
    // This module is forked in different environments.
    // By default, return `true` to log errors to the console.
    // Forks can return `false` if this isn't desirable.
    function showErrorDialog(boundary, errorInfo) {
        return true;
    }
    function logCapturedError(boundary, errorInfo) {
        try {
            var logError = showErrorDialog(boundary, errorInfo); // Allow injected showErrorDialog() to prevent default console.error logging.
            // This enables renderers like ReactNative to better manage redbox behavior.
            if (logError === false) return;
            var _$error = errorInfo.value;
            var source = errorInfo.source;
            var stack = errorInfo.stack;
            var componentStack = stack !== null ? stack : ''; // Browsers support silencing uncaught errors by calling
            // `preventDefault()` in window `error` handler.
            // We record this information as an expando on the error.
            if (_$error != null && _$error._suppressLogging) {
                if (boundary.tag === ClassComponent) // The error is recoverable and was silenced.
                // Ignore it and don't print the stack addendum.
                // This is handy for testing error boundaries without noise.
                return;
                 // The error is fatal. Since the silencing might have
                // been accidental, we'll surface it anyway.
                // However, the browser would have silenced the original error
                // so we'll print it first, and then print the stack addendum.
                console['error'](_$error); // Don't transform to our wrapper
            // For a more detailed description of this block, see:
            // https://github.com/facebook/react/pull/13384
            }
            var componentName = source ? getComponentNameFromFiber(source) : null;
            var componentNameMessage = componentName ? "The above error occurred in the <" + componentName + "> component:" : 'The above error occurred in one of your React components:';
            var errorBoundaryMessage;
            if (boundary.tag === HostRoot) errorBoundaryMessage = "Consider adding an error boundary to your tree to customize error handling behavior.\nVisit https://reactjs.org/link/error-boundaries to learn more about error boundaries.";
            else {
                var errorBoundaryName = getComponentNameFromFiber(boundary) || 'Anonymous';
                errorBoundaryMessage = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + errorBoundaryName + ".");
            }
            var combinedMessage = componentNameMessage + "\n" + componentStack + "\n\n" + ("" + errorBoundaryMessage); // In development, we provide our own message with just the component stack.
            // We don't include the original error message and JS stack because the browser
            // has already printed it. Even if the application swallows the error, it is still
            // displayed by the browser thanks to the DEV-only fake event trick in ReactErrorUtils.
            console['error'](combinedMessage); // Don't transform to our wrapper
        } catch (e) {
            // This method must not throw, or React internal state will get messed up.
            // If console.error is overridden, or logCapturedError() shows a dialog that throws,
            // we want to report this error outside of the normal stack as a last resort.
            // https://github.com/facebook/react/issues/13188
            setTimeout(function() {
                throw e;
            });
        }
    }
    var PossiblyWeakMap$1 = typeof WeakMap === 'function' ? WeakMap : Map;
    function createRootErrorUpdate(fiber, errorInfo, lane) {
        var update = createUpdate(NoTimestamp, lane); // Unmount the root by rendering null.
        update.tag = CaptureUpdate; // Caution: React DevTools currently depends on this property
        // being called "element".
        update.payload = {
            element: null
        };
        var _$error = errorInfo.value;
        update.callback = function() {
            onUncaughtError(_$error);
            logCapturedError(fiber, errorInfo);
        };
        return update;
    }
    function createClassErrorUpdate(fiber, errorInfo, lane) {
        var update = createUpdate(NoTimestamp, lane);
        update.tag = CaptureUpdate;
        var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
        if (typeof getDerivedStateFromError === 'function') {
            var error$1 = errorInfo.value;
            update.payload = function() {
                return getDerivedStateFromError(error$1);
            };
            update.callback = function() {
                markFailedErrorBoundaryForHotReloading(fiber);
                logCapturedError(fiber, errorInfo);
            };
        }
        var inst = fiber.stateNode;
        if (inst !== null && typeof inst.componentDidCatch === 'function') update.callback = function callback() {
            markFailedErrorBoundaryForHotReloading(fiber);
            logCapturedError(fiber, errorInfo);
            if (typeof getDerivedStateFromError !== 'function') // To preserve the preexisting retry behavior of error boundaries,
            // we keep track of which ones already failed during this batch.
            // This gets reset before we yield back to the browser.
            // TODO: Warn in strict mode if getDerivedStateFromError is
            // not defined.
            markLegacyErrorBoundaryAsFailed(this);
            var error$1 = errorInfo.value;
            var stack = errorInfo.stack;
            this.componentDidCatch(error$1, {
                componentStack: stack !== null ? stack : ''
            });
            if (typeof getDerivedStateFromError !== 'function') // If componentDidCatch is the only error boundary method defined,
            // then it needs to call setState to recover from errors.
            // If no state update is scheduled then the boundary will swallow the error.
            {
                if (!includesSomeLane(fiber.lanes, SyncLane)) error("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", getComponentNameFromFiber(fiber) || 'Unknown');
            }
        };
        return update;
    }
    function attachPingListener(root, wakeable, lanes) {
        // Attach a ping listener
        //
        // The data might resolve before we have a chance to commit the fallback. Or,
        // in the case of a refresh, we'll never commit a fallback. So we need to
        // attach a listener now. When it resolves ("pings"), we can decide whether to
        // try rendering the tree again.
        //
        // Only attach a listener if one does not already exist for the lanes
        // we're currently rendering (which acts like a "thread ID" here).
        //
        // We only need to do this in concurrent mode. Legacy Suspense always
        // commits fallbacks synchronously, so there are no pings.
        var pingCache = root.pingCache;
        var threadIDs;
        if (pingCache === null) {
            pingCache = root.pingCache = new PossiblyWeakMap$1();
            threadIDs = new Set();
            pingCache.set(wakeable, threadIDs);
        } else {
            threadIDs = pingCache.get(wakeable);
            if (threadIDs === undefined) {
                threadIDs = new Set();
                pingCache.set(wakeable, threadIDs);
            }
        }
        if (!threadIDs.has(lanes)) {
            // Memoize using the thread ID to prevent redundant listeners.
            threadIDs.add(lanes);
            var ping = pingSuspendedRoot.bind(null, root, wakeable, lanes);
            if (isDevToolsPresent) // If we have pending work still, restore the original updaters
            restorePendingUpdaters(root, lanes);
            wakeable.then(ping, ping);
        }
    }
    function attachRetryListener(suspenseBoundary, root, wakeable, lanes) {
        // Retry listener
        //
        // If the fallback does commit, we need to attach a different type of
        // listener. This one schedules an update on the Suspense boundary to turn
        // the fallback state off.
        //
        // Stash the wakeable on the boundary fiber so we can access it in the
        // commit phase.
        //
        // When the wakeable resolves, we'll attempt to render the boundary
        // again ("retry").
        var wakeables = suspenseBoundary.updateQueue;
        if (wakeables === null) {
            var updateQueue = new Set();
            updateQueue.add(wakeable);
            suspenseBoundary.updateQueue = updateQueue;
        } else wakeables.add(wakeable);
    }
    function resetSuspendedComponent(sourceFiber, rootRenderLanes) {
        // A legacy mode Suspense quirk, only relevant to hook components.
        var tag = sourceFiber.tag;
        if ((sourceFiber.mode & ConcurrentMode) === NoMode && (tag === FunctionComponent || tag === ForwardRef || tag === SimpleMemoComponent)) {
            var currentSource = sourceFiber.alternate;
            if (currentSource) {
                sourceFiber.updateQueue = currentSource.updateQueue;
                sourceFiber.memoizedState = currentSource.memoizedState;
                sourceFiber.lanes = currentSource.lanes;
            } else {
                sourceFiber.updateQueue = null;
                sourceFiber.memoizedState = null;
            }
        }
    }
    function getNearestSuspenseBoundaryToCapture(returnFiber) {
        var node = returnFiber;
        do {
            if (node.tag === SuspenseComponent && shouldCaptureSuspense(node)) return node;
             // This boundary already captured during this render. Continue to the next
            // boundary.
            node = node.return;
        }while (node !== null);
        return null;
    }
    function markSuspenseBoundaryShouldCapture(suspenseBoundary, returnFiber, sourceFiber, root, rootRenderLanes) {
        // This marks a Suspense boundary so that when we're unwinding the stack,
        // it captures the suspended "exception" and does a second (fallback) pass.
        if ((suspenseBoundary.mode & ConcurrentMode) === NoMode) {
            // Legacy Mode Suspense
            //
            // If the boundary is in legacy mode, we should *not*
            // suspend the commit. Pretend as if the suspended component rendered
            // null and keep rendering. When the Suspense boundary completes,
            // we'll do a second pass to render the fallback.
            if (suspenseBoundary === returnFiber) // Special case where we suspended while reconciling the children of
            // a Suspense boundary's inner Offscreen wrapper fiber. This happens
            // when a React.lazy component is a direct child of a
            // Suspense boundary.
            //
            // Suspense boundaries are implemented as multiple fibers, but they
            // are a single conceptual unit. The legacy mode behavior where we
            // pretend the suspended fiber committed as `null` won't work,
            // because in this case the "suspended" fiber is the inner
            // Offscreen wrapper.
            //
            // Because the contents of the boundary haven't started rendering
            // yet (i.e. nothing in the tree has partially rendered) we can
            // switch to the regular, concurrent mode behavior: mark the
            // boundary with ShouldCapture and enter the unwind phase.
            suspenseBoundary.flags |= ShouldCapture;
            else {
                suspenseBoundary.flags |= DidCapture;
                sourceFiber.flags |= ForceUpdateForLegacySuspense; // We're going to commit this fiber even though it didn't complete.
                // But we shouldn't call any lifecycle methods or callbacks. Remove
                // all lifecycle effect tags.
                sourceFiber.flags &= ~(LifecycleEffectMask | Incomplete);
                if (sourceFiber.tag === ClassComponent) {
                    var currentSourceFiber = sourceFiber.alternate;
                    if (currentSourceFiber === null) // This is a new mount. Change the tag so it's not mistaken for a
                    // completed class component. For example, we should not call
                    // componentWillUnmount if it is deleted.
                    sourceFiber.tag = IncompleteClassComponent;
                    else {
                        // When we try rendering again, we should not reuse the current fiber,
                        // since it's known to be in an inconsistent state. Use a force update to
                        // prevent a bail out.
                        var update = createUpdate(NoTimestamp, SyncLane);
                        update.tag = ForceUpdate;
                        enqueueUpdate(sourceFiber, update, SyncLane);
                    }
                } // The source fiber did not complete. Mark it with Sync priority to
                // indicate that it still has pending work.
                sourceFiber.lanes = mergeLanes(sourceFiber.lanes, SyncLane);
            }
            return suspenseBoundary;
        } // Confirmed that the boundary is in a concurrent mode tree. Continue
        // with the normal suspend path.
        //
        // After this we'll use a set of heuristics to determine whether this
        // render pass will run to completion or restart or "suspend" the commit.
        // The actual logic for this is spread out in different places.
        //
        // This first principle is that if we're going to suspend when we complete
        // a root, then we should also restart if we get an update or ping that
        // might unsuspend it, and vice versa. The only reason to suspend is
        // because you think you might want to restart before committing. However,
        // it doesn't make sense to restart only while in the period we're suspended.
        //
        // Restarting too aggressively is also not good because it starves out any
        // intermediate loading state. So we use heuristics to determine when.
        // Suspense Heuristics
        //
        // If nothing threw a Promise or all the same fallbacks are already showing,
        // then don't suspend/restart.
        //
        // If this is an initial render of a new tree of Suspense boundaries and
        // those trigger a fallback, then don't suspend/restart. We want to ensure
        // that we can show the initial loading state as quickly as possible.
        //
        // If we hit a "Delayed" case, such as when we'd switch from content back into
        // a fallback, then we should always suspend/restart. Transitions apply
        // to this case. If none is defined, JND is used instead.
        //
        // If we're already showing a fallback and it gets "retried", allowing us to show
        // another level, but there's still an inner boundary that would show a fallback,
        // then we suspend/restart for 500ms since the last time we showed a fallback
        // anywhere in the tree. This effectively throttles progressive loading into a
        // consistent train of commits. This also gives us an opportunity to restart to
        // get to the completed state slightly earlier.
        //
        // If there's ambiguity due to batching it's resolved in preference of:
        // 1) "delayed", 2) "initial render", 3) "retry".
        //
        // We want to ensure that a "busy" state doesn't get force committed. We want to
        // ensure that new initial loading states can commit as soon as possible.
        suspenseBoundary.flags |= ShouldCapture; // TODO: I think we can remove this, since we now use `DidCapture` in
        // the begin phase to prevent an early bailout.
        suspenseBoundary.lanes = rootRenderLanes;
        return suspenseBoundary;
    }
    function throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
        // The source fiber did not complete.
        sourceFiber.flags |= Incomplete;
        if (isDevToolsPresent) // If we have pending work still, restore the original updaters
        restorePendingUpdaters(root, rootRenderLanes);
        if (value !== null && typeof value === 'object' && typeof value.then === 'function') {
            // This is a wakeable. The component suspended.
            var wakeable = value;
            resetSuspendedComponent(sourceFiber);
            if (getIsHydrating() && sourceFiber.mode & ConcurrentMode) markDidThrowWhileHydratingDEV();
            var suspenseBoundary = getNearestSuspenseBoundaryToCapture(returnFiber);
            if (suspenseBoundary !== null) {
                suspenseBoundary.flags &= ~ForceClientRender;
                markSuspenseBoundaryShouldCapture(suspenseBoundary, returnFiber, sourceFiber, root, rootRenderLanes); // We only attach ping listeners in concurrent mode. Legacy Suspense always
                // commits fallbacks synchronously, so there are no pings.
                if (suspenseBoundary.mode & ConcurrentMode) attachPingListener(root, wakeable, rootRenderLanes);
                attachRetryListener(suspenseBoundary, root, wakeable);
                return;
            } else {
                // No boundary was found. Unless this is a sync update, this is OK.
                // We can suspend and wait for more data to arrive.
                if (!includesSyncLane(rootRenderLanes)) {
                    // This is not a sync update. Suspend. Since we're not activating a
                    // Suspense boundary, this will unwind all the way to the root without
                    // performing a second pass to render a fallback. (This is arguably how
                    // refresh transitions should work, too, since we're not going to commit
                    // the fallbacks anyway.)
                    //
                    // This case also applies to initial hydration.
                    attachPingListener(root, wakeable, rootRenderLanes);
                    renderDidSuspendDelayIfPossible();
                    return;
                } // This is a sync/discrete update. We treat this case like an error
                // because discrete renders are expected to produce a complete tree
                // synchronously to maintain consistency with external state.
                var uncaughtSuspenseError = new Error("A component suspended while responding to synchronous input. This will cause the UI to be replaced with a loading indicator. To fix, updates that suspend should be wrapped with startTransition."); // If we're outside a transition, fall through to the regular error path.
                // The error will be caught by the nearest suspense boundary.
                value = uncaughtSuspenseError;
            }
        } else // This is a regular error, not a Suspense wakeable.
        if (getIsHydrating() && sourceFiber.mode & ConcurrentMode) {
            markDidThrowWhileHydratingDEV();
            var _suspenseBoundary = getNearestSuspenseBoundaryToCapture(returnFiber); // If the error was thrown during hydration, we may be able to recover by
            // discarding the dehydrated content and switching to a client render.
            // Instead of surfacing the error, find the nearest Suspense boundary
            // and render it again without hydration.
            if (_suspenseBoundary !== null) {
                if ((_suspenseBoundary.flags & ShouldCapture) === NoFlags) // Set a flag to indicate that we should try rendering the normal
                // children again, not the fallback.
                _suspenseBoundary.flags |= ForceClientRender;
                markSuspenseBoundaryShouldCapture(_suspenseBoundary, returnFiber, sourceFiber, root, rootRenderLanes); // Even though the user may not be affected by this error, we should
                // still log it so it can be fixed.
                queueHydrationError(createCapturedValueAtFiber(value, sourceFiber));
                return;
            }
        }
        value = createCapturedValueAtFiber(value, sourceFiber);
        renderDidError(value); // We didn't find a boundary that could handle this type of exception. Start
        // over and traverse parent path again, this time treating the exception
        // as an error.
        var workInProgress = returnFiber;
        do {
            switch(workInProgress.tag){
                case HostRoot:
                    var _errorInfo = value;
                    workInProgress.flags |= ShouldCapture;
                    var lane = pickArbitraryLane(rootRenderLanes);
                    workInProgress.lanes = mergeLanes(workInProgress.lanes, lane);
                    var update = createRootErrorUpdate(workInProgress, _errorInfo, lane);
                    enqueueCapturedUpdate(workInProgress, update);
                    return;
                case ClassComponent:
                    // Capture and retry
                    var errorInfo = value;
                    var ctor = workInProgress.type;
                    var instance = workInProgress.stateNode;
                    if ((workInProgress.flags & DidCapture) === NoFlags && (typeof ctor.getDerivedStateFromError === 'function' || instance !== null && typeof instance.componentDidCatch === 'function' && !isAlreadyFailedLegacyErrorBoundary(instance))) {
                        workInProgress.flags |= ShouldCapture;
                        var _lane = pickArbitraryLane(rootRenderLanes);
                        workInProgress.lanes = mergeLanes(workInProgress.lanes, _lane); // Schedule the error boundary to re-render using updated state
                        var _update = createClassErrorUpdate(workInProgress, errorInfo, _lane);
                        enqueueCapturedUpdate(workInProgress, _update);
                        return;
                    }
                    break;
            }
            workInProgress = workInProgress.return;
        }while (workInProgress !== null);
    }
    function getSuspendedCache() {
        return null;
    }
    var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
    var didReceiveUpdate = false;
    var didWarnAboutBadClass;
    var didWarnAboutModulePatternComponent;
    var didWarnAboutContextTypeOnFunctionComponent;
    var didWarnAboutGetDerivedStateOnFunctionComponent;
    var didWarnAboutFunctionRefs;
    var didWarnAboutReassigningProps;
    var didWarnAboutRevealOrder;
    var didWarnAboutTailOptions;
    var didWarnAboutDefaultPropsOnFunctionComponent;
    didWarnAboutBadClass = {};
    didWarnAboutModulePatternComponent = {};
    didWarnAboutContextTypeOnFunctionComponent = {};
    didWarnAboutGetDerivedStateOnFunctionComponent = {};
    didWarnAboutFunctionRefs = {};
    didWarnAboutReassigningProps = false;
    didWarnAboutRevealOrder = {};
    didWarnAboutTailOptions = {};
    didWarnAboutDefaultPropsOnFunctionComponent = {};
    function reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
        if (current === null) // If this is a fresh new component that hasn't been rendered yet, we
        // won't update its child set by applying minimal side-effects. Instead,
        // we will add them all to the child before it gets rendered. That means
        // we can optimize this reconciliation pass by not tracking side-effects.
        workInProgress.child = mountChildFibers(workInProgress, null, nextChildren, renderLanes);
        else // If the current child is the same as the work in progress, it means that
        // we haven't yet started any work on these children. Therefore, we use
        // the clone algorithm to create a copy of all the current children.
        // If we had any progressed work already, that is invalid at this point so
        // let's throw it out.
        workInProgress.child = reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
    }
    function forceUnmountCurrentAndReconcile(current, workInProgress, nextChildren, renderLanes) {
        // This function is fork of reconcileChildren. It's used in cases where we
        // want to reconcile without matching against the existing set. This has the
        // effect of all current children being unmounted; even if the type and key
        // are the same, the old child is unmounted and a new child is created.
        //
        // To do this, we're going to go through the reconcile algorithm twice. In
        // the first pass, we schedule a deletion for all the current children by
        // passing null.
        workInProgress.child = reconcileChildFibers(workInProgress, current.child, null, renderLanes); // In the second pass, we mount the new children. The trick here is that we
        // pass null in place of where we usually pass the current child set. This has
        // the effect of remounting all children regardless of whether their
        // identities match.
        workInProgress.child = reconcileChildFibers(workInProgress, null, nextChildren, renderLanes);
    }
    function updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) checkPropTypes(innerPropTypes, nextProps, 'prop', getComponentNameFromType(Component));
        }
        var _$render = Component.render;
        var ref = workInProgress.ref; // The rest is a fork of updateFunctionComponent
        var nextChildren;
        var hasId;
        prepareToReadContext(workInProgress, renderLanes);
        markComponentRenderStarted(workInProgress);
        ReactCurrentOwner$1.current = workInProgress;
        setIsRendering(true);
        nextChildren = renderWithHooks(current, workInProgress, _$render, nextProps, ref, renderLanes);
        hasId = checkDidRenderIdHook();
        if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);
            try {
                nextChildren = renderWithHooks(current, workInProgress, _$render, nextProps, ref, renderLanes);
                hasId = checkDidRenderIdHook();
            } finally{
                setIsStrictModeForDevtools(false);
            }
        }
        setIsRendering(false);
        markComponentRenderStopped();
        if (current !== null && !didReceiveUpdate) {
            bailoutHooks(current, workInProgress, renderLanes);
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
        if (getIsHydrating() && hasId) pushMaterializedTreeId(workInProgress);
         // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (current === null) {
            var type = Component.type;
            if (isSimpleFunctionComponent(type) && Component.compare === null && // SimpleMemoComponent codepath doesn't resolve outer props either.
            Component.defaultProps === undefined) {
                var resolvedType = type;
                resolvedType = resolveFunctionForHotReloading(type);
                // and with only the default shallow comparison, we upgrade it
                // to a SimpleMemoComponent to allow fast path updates.
                workInProgress.tag = SimpleMemoComponent;
                workInProgress.type = resolvedType;
                validateFunctionComponentInDev(workInProgress, type);
                return updateSimpleMemoComponent(current, workInProgress, resolvedType, nextProps, renderLanes);
            }
            var innerPropTypes = type.propTypes;
            if (innerPropTypes) // Inner memo component props aren't currently validated in createElement.
            // We could move it there, but we'd still need this for lazy code path.
            checkPropTypes(innerPropTypes, nextProps, 'prop', getComponentNameFromType(type));
            if (Component.defaultProps !== undefined) {
                var componentName = getComponentNameFromType(type) || 'Unknown';
                if (!didWarnAboutDefaultPropsOnFunctionComponent[componentName]) {
                    error("%s: Support for defaultProps will be removed from memo components in a future major release. Use JavaScript default parameters instead.", componentName);
                    didWarnAboutDefaultPropsOnFunctionComponent[componentName] = true;
                }
            }
            var child = createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
            child.ref = workInProgress.ref;
            child.return = workInProgress;
            workInProgress.child = child;
            return child;
        }
        var _type = Component.type;
        var _innerPropTypes = _type.propTypes;
        if (_innerPropTypes) // Inner memo component props aren't currently validated in createElement.
        // We could move it there, but we'd still need this for lazy code path.
        checkPropTypes(_innerPropTypes, nextProps, 'prop', getComponentNameFromType(_type));
        var currentChild = current.child; // This is always exactly one child
        var hasScheduledUpdateOrContext = checkScheduledUpdateOrContext(current, renderLanes);
        if (!hasScheduledUpdateOrContext) {
            // This will be the props with resolved defaultProps,
            // unlike current.memoizedProps which will be the unresolved ones.
            var prevProps = currentChild.memoizedProps; // Default to shallow comparison
            var compare = Component.compare;
            compare = compare !== null ? compare : shallowEqual;
            if (compare(prevProps, nextProps) && current.ref === workInProgress.ref) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        } // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        var newChild = createWorkInProgress(currentChild, nextProps);
        newChild.ref = workInProgress.ref;
        newChild.return = workInProgress;
        workInProgress.child = newChild;
        return newChild;
    }
    function updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var outerMemoType = workInProgress.elementType;
            if (outerMemoType.$$typeof === REACT_LAZY_TYPE) {
                // We warn when you define propTypes on lazy()
                // so let's just skip over it to find memo() outer wrapper.
                // Inner props for memo are validated later.
                var lazyComponent = outerMemoType;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    outerMemoType = init(payload);
                } catch (x) {
                    outerMemoType = null;
                } // Inner propTypes will be validated in the function component path.
                var outerPropTypes = outerMemoType && outerMemoType.propTypes;
                if (outerPropTypes) checkPropTypes(outerPropTypes, nextProps, 'prop', getComponentNameFromType(outerMemoType));
            }
        }
        if (current !== null) {
            var prevProps = current.memoizedProps;
            if (shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref && workInProgress.type === current.type) {
                didReceiveUpdate = false; // The props are shallowly equal. Reuse the previous props object, like we
                // would during a normal fiber bailout.
                //
                // We don't have strong guarantees that the props object is referentially
                // equal during updates where we can't bail out anyway — like if the props
                // are shallowly equal, but there's a local state or context update in the
                // same batch.
                //
                // However, as a principle, we should aim to make the behavior consistent
                // across different ways of memoizing a component. For example, React.memo
                // has a different internal Fiber layout if you pass a normal function
                // component (SimpleMemoComponent) versus if you pass a different type
                // like forwardRef (MemoComponent). But this is an implementation detail.
                // Wrapping a component in forwardRef (or React.lazy, etc) shouldn't
                // affect whether the props object is reused during a bailout.
                workInProgress.pendingProps = nextProps = prevProps;
                if (!checkScheduledUpdateOrContext(current, renderLanes)) {
                    // The pending lanes were cleared at the beginning of beginWork. We're
                    // about to bail out, but there might be other lanes that weren't
                    // included in the current render. Usually, the priority level of the
                    // remaining updates is accumulated during the evaluation of the
                    // component (i.e. when processing the update queue). But since since
                    // we're bailing out early *without* evaluating the component, we need
                    // to account for it here, too. Reset to the value of the current fiber.
                    // NOTE: This only applies to SimpleMemoComponent, not MemoComponent,
                    // because a MemoComponent fiber does not have hooks or an update queue;
                    // rather, it wraps around an inner component, which may or may not
                    // contains hooks.
                    // TODO: Move the reset at in beginWork out of the common path so that
                    // this is no longer necessary.
                    workInProgress.lanes = current.lanes;
                    return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                } else if ((current.flags & ForceUpdateForLegacySuspense) !== NoFlags) // This is a special case that only exists for legacy mode.
                // See https://github.com/facebook/react/pull/19216.
                didReceiveUpdate = true;
            }
        }
        return updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
    }
    function updateOffscreenComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps;
        var nextChildren = nextProps.children;
        var prevState = current !== null ? current.memoizedState : null;
        if (nextProps.mode === 'hidden' || enableLegacyHidden) {
            // Rendering a hidden tree.
            if ((workInProgress.mode & ConcurrentMode) === NoMode) {
                // In legacy sync mode, don't defer the subtree. Render it now.
                // TODO: Consider how Offscreen should work with transitions in the future
                var nextState = {
                    baseLanes: NoLanes,
                    cachePool: null,
                    transitions: null
                };
                workInProgress.memoizedState = nextState;
                pushRenderLanes(workInProgress, renderLanes);
            } else if (!includesSomeLane(renderLanes, OffscreenLane)) {
                var spawnedCachePool = null; // We're hidden, and we're not rendering at Offscreen. We will bail out
                // and resume this tree later.
                var nextBaseLanes;
                if (prevState !== null) {
                    var prevBaseLanes = prevState.baseLanes;
                    nextBaseLanes = mergeLanes(prevBaseLanes, renderLanes);
                } else nextBaseLanes = renderLanes;
                 // Schedule this fiber to re-render at offscreen priority. Then bailout.
                workInProgress.lanes = workInProgress.childLanes = laneToLanes(OffscreenLane);
                var _nextState = {
                    baseLanes: nextBaseLanes,
                    cachePool: spawnedCachePool,
                    transitions: null
                };
                workInProgress.memoizedState = _nextState;
                workInProgress.updateQueue = null;
                // to avoid a push/pop misalignment.
                pushRenderLanes(workInProgress, nextBaseLanes);
                return null;
            } else {
                // This is the second render. The surrounding visible content has already
                // committed. Now we resume rendering the hidden tree.
                // Rendering at offscreen, so we can clear the base lanes.
                var _nextState2 = {
                    baseLanes: NoLanes,
                    cachePool: null,
                    transitions: null
                };
                workInProgress.memoizedState = _nextState2; // Push the lanes that were skipped when we bailed out.
                var subtreeRenderLanes = prevState !== null ? prevState.baseLanes : renderLanes;
                pushRenderLanes(workInProgress, subtreeRenderLanes);
            }
        } else {
            // Rendering a visible tree.
            var _subtreeRenderLanes;
            if (prevState !== null) {
                // We're going from hidden -> visible.
                _subtreeRenderLanes = mergeLanes(prevState.baseLanes, renderLanes);
                workInProgress.memoizedState = null;
            } else // We weren't previously hidden, and we still aren't, so there's nothing
            // special to do. Need to push to the stack regardless, though, to avoid
            // a push/pop misalignment.
            _subtreeRenderLanes = renderLanes;
            pushRenderLanes(workInProgress, _subtreeRenderLanes);
        }
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    } // Note: These happen to have identical begin phases, for now. We shouldn't hold
    function updateFragment(current, workInProgress, renderLanes) {
        var nextChildren = workInProgress.pendingProps;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateMode(current, workInProgress, renderLanes) {
        var nextChildren = workInProgress.pendingProps.children;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateProfiler(current, workInProgress, renderLanes) {
        workInProgress.flags |= Update;
        // Reset effect durations for the next eventual effect phase.
        // These are reset during render to allow the DevTools commit hook a chance to read them,
        var stateNode = workInProgress.stateNode;
        stateNode.effectDuration = 0;
        stateNode.passiveEffectDuration = 0;
        var nextProps = workInProgress.pendingProps;
        var nextChildren = nextProps.children;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function markRef(current, workInProgress) {
        var ref = workInProgress.ref;
        if (current === null && ref !== null || current !== null && current.ref !== ref) {
            // Schedule a Ref effect
            workInProgress.flags |= Ref;
            workInProgress.flags |= RefStatic;
        }
    }
    function updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) checkPropTypes(innerPropTypes, nextProps, 'prop', getComponentNameFromType(Component));
        }
        var context;
        var unmaskedContext = getUnmaskedContext(workInProgress, Component, true);
        context = getMaskedContext(workInProgress, unmaskedContext);
        var nextChildren;
        var hasId;
        prepareToReadContext(workInProgress, renderLanes);
        markComponentRenderStarted(workInProgress);
        ReactCurrentOwner$1.current = workInProgress;
        setIsRendering(true);
        nextChildren = renderWithHooks(current, workInProgress, Component, nextProps, context, renderLanes);
        hasId = checkDidRenderIdHook();
        if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);
            try {
                nextChildren = renderWithHooks(current, workInProgress, Component, nextProps, context, renderLanes);
                hasId = checkDidRenderIdHook();
            } finally{
                setIsStrictModeForDevtools(false);
            }
        }
        setIsRendering(false);
        markComponentRenderStopped();
        if (current !== null && !didReceiveUpdate) {
            bailoutHooks(current, workInProgress, renderLanes);
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
        if (getIsHydrating() && hasId) pushMaterializedTreeId(workInProgress);
         // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
        // This is used by DevTools to force a boundary to error.
        switch(shouldError(workInProgress)){
            case false:
                var _instance = workInProgress.stateNode;
                var ctor = workInProgress.type; // TODO This way of resetting the error boundary state is a hack.
                // Is there a better way to do this?
                var tempInstance = new ctor(workInProgress.memoizedProps, _instance.context);
                var state = tempInstance.state;
                _instance.updater.enqueueSetState(_instance, state, null);
                break;
            case true:
                workInProgress.flags |= DidCapture;
                workInProgress.flags |= ShouldCapture; // eslint-disable-next-line react-internal/prod-error-codes
                var error$1 = new Error('Simulated error coming from DevTools');
                var lane = pickArbitraryLane(renderLanes);
                workInProgress.lanes = mergeLanes(workInProgress.lanes, lane); // Schedule the error boundary to re-render using updated state
                var update = createClassErrorUpdate(workInProgress, createCapturedValueAtFiber(error$1, workInProgress), lane);
                enqueueCapturedUpdate(workInProgress, update);
                break;
        }
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) checkPropTypes(innerPropTypes, nextProps, 'prop', getComponentNameFromType(Component));
        }
        // During mounting we don't know the child context yet as the instance doesn't exist.
        // We will invalidate the child context in finishClassComponent() right after rendering.
        var hasContext;
        if (isContextProvider(Component)) {
            hasContext = true;
            pushContextProvider(workInProgress);
        } else hasContext = false;
        prepareToReadContext(workInProgress, renderLanes);
        var instance = workInProgress.stateNode;
        var shouldUpdate;
        if (instance === null) {
            resetSuspendedCurrentOnMountInLegacyMode(current, workInProgress); // In the initial pass we might need to construct the instance.
            constructClassInstance(workInProgress, Component, nextProps);
            mountClassInstance(workInProgress, Component, nextProps, renderLanes);
            shouldUpdate = true;
        } else if (current === null) // In a resume, we'll already have an instance we can reuse.
        shouldUpdate = resumeMountClassInstance(workInProgress, Component, nextProps, renderLanes);
        else shouldUpdate = updateClassInstance(current, workInProgress, Component, nextProps, renderLanes);
        var nextUnitOfWork = finishClassComponent(current, workInProgress, Component, shouldUpdate, hasContext, renderLanes);
        var inst = workInProgress.stateNode;
        if (shouldUpdate && inst.props !== nextProps) {
            if (!didWarnAboutReassigningProps) error("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", getComponentNameFromFiber(workInProgress) || 'a component');
            didWarnAboutReassigningProps = true;
        }
        return nextUnitOfWork;
    }
    function finishClassComponent(current, workInProgress, Component, shouldUpdate, hasContext, renderLanes) {
        // Refs should update even if shouldComponentUpdate returns false
        markRef(current, workInProgress);
        var didCaptureError = (workInProgress.flags & DidCapture) !== NoFlags;
        if (!shouldUpdate && !didCaptureError) {
            // Context providers should defer to sCU for rendering
            if (hasContext) invalidateContextProvider(workInProgress, Component, false);
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
        var instance = workInProgress.stateNode; // Rerender
        ReactCurrentOwner$1.current = workInProgress;
        var nextChildren;
        if (didCaptureError && typeof Component.getDerivedStateFromError !== 'function') {
            // If we captured an error, but getDerivedStateFromError is not defined,
            // unmount all the children. componentDidCatch will schedule an update to
            // re-render a fallback. This is temporary until we migrate everyone to
            // the new API.
            // TODO: Warn in a future release.
            nextChildren = null;
            stopProfilerTimerIfRunning();
        } else {
            markComponentRenderStarted(workInProgress);
            setIsRendering(true);
            nextChildren = instance.render();
            if (workInProgress.mode & StrictLegacyMode) {
                setIsStrictModeForDevtools(true);
                try {
                    instance.render();
                } finally{
                    setIsStrictModeForDevtools(false);
                }
            }
            setIsRendering(false);
            markComponentRenderStopped();
        } // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        if (current !== null && didCaptureError) // If we're recovering from an error, reconcile without reusing any of
        // the existing children. Conceptually, the normal children and the children
        // that are shown on error are two different sets, so we shouldn't reuse
        // normal children even if their identities match.
        forceUnmountCurrentAndReconcile(current, workInProgress, nextChildren, renderLanes);
        else reconcileChildren(current, workInProgress, nextChildren, renderLanes);
         // Memoize state using the values we just used to render.
        // TODO: Restructure so we never read values from the instance.
        workInProgress.memoizedState = instance.state; // The context might have changed so we need to recalculate it.
        if (hasContext) invalidateContextProvider(workInProgress, Component, true);
        return workInProgress.child;
    }
    function pushHostRootContext(workInProgress) {
        var root = workInProgress.stateNode;
        if (root.pendingContext) pushTopLevelContextObject(workInProgress, root.pendingContext, root.pendingContext !== root.context);
        else if (root.context) // Should always be set
        pushTopLevelContextObject(workInProgress, root.context, false);
        pushHostContainer(workInProgress, root.containerInfo);
    }
    function updateHostRoot(current, workInProgress, renderLanes) {
        pushHostRootContext(workInProgress);
        if (current === null) throw new Error('Should have a current fiber. This is a bug in React.');
        var nextProps = workInProgress.pendingProps;
        var prevState = workInProgress.memoizedState;
        var prevChildren = prevState.element;
        cloneUpdateQueue(current, workInProgress);
        processUpdateQueue(workInProgress, nextProps, null, renderLanes);
        var nextState = workInProgress.memoizedState;
        var root = workInProgress.stateNode;
        // being called "element".
        var nextChildren = nextState.element;
        if (prevState.isDehydrated) {
            // This is a hydration root whose shell has not yet hydrated. We should
            // attempt to hydrate.
            // Flip isDehydrated to false to indicate that when this render
            // finishes, the root will no longer be dehydrated.
            var overrideState = {
                element: nextChildren,
                isDehydrated: false,
                cache: nextState.cache,
                pendingSuspenseBoundaries: nextState.pendingSuspenseBoundaries,
                transitions: nextState.transitions
            };
            var updateQueue = workInProgress.updateQueue; // `baseState` can always be the last state because the root doesn't
            // have reducer functions so it doesn't need rebasing.
            updateQueue.baseState = overrideState;
            workInProgress.memoizedState = overrideState;
            if (workInProgress.flags & ForceClientRender) {
                // Something errored during a previous attempt to hydrate the shell, so we
                // forced a client render.
                var recoverableError = createCapturedValueAtFiber(new Error("There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering."), workInProgress);
                return mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes, recoverableError);
            } else if (nextChildren !== prevChildren) {
                var _recoverableError = createCapturedValueAtFiber(new Error("This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."), workInProgress);
                return mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes, _recoverableError);
            } else {
                // The outermost shell has not hydrated yet. Start hydrating.
                enterHydrationState(workInProgress);
                var child = mountChildFibers(workInProgress, null, nextChildren, renderLanes);
                workInProgress.child = child;
                var node = child;
                while(node){
                    // Mark each child as hydrating. This is a fast path to know whether this
                    // tree is part of a hydrating tree. This is used to determine if a child
                    // node has fully mounted yet, and for scheduling event replaying.
                    // Conceptually this is similar to Placement in that a new subtree is
                    // inserted into the React tree here. It just happens to not need DOM
                    // mutations because it already exists.
                    node.flags = node.flags & ~Placement | Hydrating;
                    node = node.sibling;
                }
            }
        } else {
            // Root is not dehydrated. Either this is a client-only root, or it
            // already hydrated.
            resetHydrationState();
            if (nextChildren === prevChildren) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
            reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        }
        return workInProgress.child;
    }
    function mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes, recoverableError) {
        // Revert to client rendering.
        resetHydrationState();
        queueHydrationError(recoverableError);
        workInProgress.flags |= ForceClientRender;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateHostComponent(current, workInProgress, renderLanes) {
        pushHostContext(workInProgress);
        if (current === null) tryToClaimNextHydratableInstance(workInProgress);
        var type = workInProgress.type;
        var nextProps = workInProgress.pendingProps;
        var prevProps = current !== null ? current.memoizedProps : null;
        var nextChildren = nextProps.children;
        var isDirectTextChild = shouldSetTextContent(type, nextProps);
        if (isDirectTextChild) // We special case a direct text child of a host node. This is a common
        // case. We won't handle it as a reified child. We will instead handle
        // this in the host environment that also has access to this prop. That
        // avoids allocating another HostText fiber and traversing it.
        nextChildren = null;
        else if (prevProps !== null && shouldSetTextContent(type, prevProps)) // If we're switching from a direct text child to a normal child, or to
        // empty, we need to schedule the text content to be reset.
        workInProgress.flags |= ContentReset;
        markRef(current, workInProgress);
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateHostText(current, workInProgress) {
        if (current === null) tryToClaimNextHydratableInstance(workInProgress);
         // Nothing to do here. This is terminal. We'll do the completion step
        // immediately after.
        return null;
    }
    function mountLazyComponent(_current, workInProgress, elementType, renderLanes) {
        resetSuspendedCurrentOnMountInLegacyMode(_current, workInProgress);
        var props = workInProgress.pendingProps;
        var lazyComponent = elementType;
        var payload = lazyComponent._payload;
        var init = lazyComponent._init;
        var Component = init(payload); // Store the unwrapped component in the type.
        workInProgress.type = Component;
        var resolvedTag = workInProgress.tag = resolveLazyComponentTag(Component);
        var resolvedProps = resolveDefaultProps(Component, props);
        var child;
        switch(resolvedTag){
            case FunctionComponent:
                validateFunctionComponentInDev(workInProgress, Component);
                workInProgress.type = Component = resolveFunctionForHotReloading(Component);
                child = updateFunctionComponent(null, workInProgress, Component, resolvedProps, renderLanes);
                return child;
            case ClassComponent:
                workInProgress.type = Component = resolveClassForHotReloading(Component);
                child = updateClassComponent(null, workInProgress, Component, resolvedProps, renderLanes);
                return child;
            case ForwardRef:
                workInProgress.type = Component = resolveForwardRefForHotReloading(Component);
                child = updateForwardRef(null, workInProgress, Component, resolvedProps, renderLanes);
                return child;
            case MemoComponent:
                if (workInProgress.type !== workInProgress.elementType) {
                    var outerPropTypes = Component.propTypes;
                    if (outerPropTypes) checkPropTypes(outerPropTypes, resolvedProps, 'prop', getComponentNameFromType(Component));
                }
                child = updateMemoComponent(null, workInProgress, Component, resolveDefaultProps(Component.type, resolvedProps), renderLanes);
                return child;
        }
        var hint = '';
        if (Component !== null && typeof Component === 'object' && Component.$$typeof === REACT_LAZY_TYPE) hint = ' Did you wrap a component in React.lazy() more than once?';
        // because the fact that it's a separate type of work is an
        // implementation detail.
        throw new Error("Element type is invalid. Received a promise that resolves to: " + Component + ". " + ("Lazy element type must resolve to a class or function." + hint));
    }
    function mountIncompleteClassComponent(_current, workInProgress, Component, nextProps, renderLanes) {
        resetSuspendedCurrentOnMountInLegacyMode(_current, workInProgress); // Promote the fiber to a class and try rendering again.
        workInProgress.tag = ClassComponent; // The rest of this function is a fork of `updateClassComponent`
        // Push context providers early to prevent context stack mismatches.
        // During mounting we don't know the child context yet as the instance doesn't exist.
        // We will invalidate the child context in finishClassComponent() right after rendering.
        var hasContext;
        if (isContextProvider(Component)) {
            hasContext = true;
            pushContextProvider(workInProgress);
        } else hasContext = false;
        prepareToReadContext(workInProgress, renderLanes);
        constructClassInstance(workInProgress, Component, nextProps);
        mountClassInstance(workInProgress, Component, nextProps, renderLanes);
        return finishClassComponent(null, workInProgress, Component, true, hasContext, renderLanes);
    }
    function mountIndeterminateComponent(_current, workInProgress, Component, renderLanes) {
        resetSuspendedCurrentOnMountInLegacyMode(_current, workInProgress);
        var props = workInProgress.pendingProps;
        var context;
        var unmaskedContext = getUnmaskedContext(workInProgress, Component, false);
        context = getMaskedContext(workInProgress, unmaskedContext);
        prepareToReadContext(workInProgress, renderLanes);
        var value;
        var hasId;
        markComponentRenderStarted(workInProgress);
        if (Component.prototype && typeof Component.prototype.render === 'function') {
            var componentName = getComponentNameFromType(Component) || 'Unknown';
            if (!didWarnAboutBadClass[componentName]) {
                error("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", componentName, componentName);
                didWarnAboutBadClass[componentName] = true;
            }
        }
        if (workInProgress.mode & StrictLegacyMode) ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, null);
        setIsRendering(true);
        ReactCurrentOwner$1.current = workInProgress;
        value = renderWithHooks(null, workInProgress, Component, props, context, renderLanes);
        hasId = checkDidRenderIdHook();
        setIsRendering(false);
        markComponentRenderStopped();
        workInProgress.flags |= PerformedWork;
        // Support for module components is deprecated and is removed behind a flag.
        // Whether or not it would crash later, we want to show a good message in DEV first.
        if (typeof value === 'object' && value !== null && typeof value.render === 'function' && value.$$typeof === undefined) {
            var _componentName = getComponentNameFromType(Component) || 'Unknown';
            if (!didWarnAboutModulePatternComponent[_componentName]) {
                error("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", _componentName, _componentName, _componentName);
                didWarnAboutModulePatternComponent[_componentName] = true;
            }
        }
        if (// Eventually we'll delete this branch altogether.
        typeof value === 'object' && value !== null && typeof value.render === 'function' && value.$$typeof === undefined) {
            var _componentName2 = getComponentNameFromType(Component) || 'Unknown';
            if (!didWarnAboutModulePatternComponent[_componentName2]) {
                error("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", _componentName2, _componentName2, _componentName2);
                didWarnAboutModulePatternComponent[_componentName2] = true;
            }
            workInProgress.tag = ClassComponent; // Throw out any hooks that were used.
            workInProgress.memoizedState = null;
            workInProgress.updateQueue = null; // Push context providers early to prevent context stack mismatches.
            // During mounting we don't know the child context yet as the instance doesn't exist.
            // We will invalidate the child context in finishClassComponent() right after rendering.
            var hasContext = false;
            if (isContextProvider(Component)) {
                hasContext = true;
                pushContextProvider(workInProgress);
            } else hasContext = false;
            workInProgress.memoizedState = value.state !== null && value.state !== undefined ? value.state : null;
            initializeUpdateQueue(workInProgress);
            adoptClassInstance(workInProgress, value);
            mountClassInstance(workInProgress, Component, props, renderLanes);
            return finishClassComponent(null, workInProgress, Component, true, hasContext, renderLanes);
        } else {
            // Proceed under the assumption that this is a function component
            workInProgress.tag = FunctionComponent;
            if (workInProgress.mode & StrictLegacyMode) {
                setIsStrictModeForDevtools(true);
                try {
                    value = renderWithHooks(null, workInProgress, Component, props, context, renderLanes);
                    hasId = checkDidRenderIdHook();
                } finally{
                    setIsStrictModeForDevtools(false);
                }
            }
            if (getIsHydrating() && hasId) pushMaterializedTreeId(workInProgress);
            reconcileChildren(null, workInProgress, value, renderLanes);
            validateFunctionComponentInDev(workInProgress, Component);
            return workInProgress.child;
        }
    }
    function validateFunctionComponentInDev(workInProgress, Component) {
        if (Component) {
            if (Component.childContextTypes) error('%s(...): childContextTypes cannot be defined on a function component.', Component.displayName || Component.name || 'Component');
        }
        if (workInProgress.ref !== null) {
            var info = '';
            var ownerName = getCurrentFiberOwnerNameInDevOrNull();
            if (ownerName) info += '\n\nCheck the render method of `' + ownerName + '`.';
            var warningKey = ownerName || '';
            var debugSource = workInProgress._debugSource;
            if (debugSource) warningKey = debugSource.fileName + ':' + debugSource.lineNumber;
            if (!didWarnAboutFunctionRefs[warningKey]) {
                didWarnAboutFunctionRefs[warningKey] = true;
                error("Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?%s", info);
            }
        }
        if (Component.defaultProps !== undefined) {
            var componentName = getComponentNameFromType(Component) || 'Unknown';
            if (!didWarnAboutDefaultPropsOnFunctionComponent[componentName]) {
                error("%s: Support for defaultProps will be removed from function components in a future major release. Use JavaScript default parameters instead.", componentName);
                didWarnAboutDefaultPropsOnFunctionComponent[componentName] = true;
            }
        }
        if (typeof Component.getDerivedStateFromProps === 'function') {
            var _componentName3 = getComponentNameFromType(Component) || 'Unknown';
            if (!didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3]) {
                error('%s: Function components do not support getDerivedStateFromProps.', _componentName3);
                didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3] = true;
            }
        }
        if (typeof Component.contextType === 'object' && Component.contextType !== null) {
            var _componentName4 = getComponentNameFromType(Component) || 'Unknown';
            if (!didWarnAboutContextTypeOnFunctionComponent[_componentName4]) {
                error('%s: Function components do not support contextType.', _componentName4);
                didWarnAboutContextTypeOnFunctionComponent[_componentName4] = true;
            }
        }
    }
    var SUSPENDED_MARKER = {
        dehydrated: null,
        treeContext: null,
        retryLane: NoLane
    };
    function mountSuspenseOffscreenState(renderLanes) {
        return {
            baseLanes: renderLanes,
            cachePool: getSuspendedCache(),
            transitions: null
        };
    }
    function updateSuspenseOffscreenState(prevOffscreenState, renderLanes) {
        var cachePool = null;
        return {
            baseLanes: mergeLanes(prevOffscreenState.baseLanes, renderLanes),
            cachePool: cachePool,
            transitions: prevOffscreenState.transitions
        };
    } // TODO: Probably should inline this back
    function shouldRemainOnFallback(suspenseContext, current, workInProgress, renderLanes) {
        // If we're already showing a fallback, there are cases where we need to
        // remain on that fallback regardless of whether the content has resolved.
        // For example, SuspenseList coordinates when nested content appears.
        if (current !== null) {
            var suspenseState = current.memoizedState;
            if (suspenseState === null) // Currently showing content. Don't hide it, even if ForceSuspenseFallback
            // is true. More precise name might be "ForceRemainSuspenseFallback".
            // Note: This is a factoring smell. Can't remain on a fallback if there's
            // no fallback to remain on.
            return false;
        } // Not currently showing content. Consult the Suspense context.
        return hasSuspenseContext(suspenseContext, ForceSuspenseFallback);
    }
    function getRemainingWorkInPrimaryTree(current, renderLanes) {
        // TODO: Should not remove render lanes that were pinged during this render
        return removeLanes(current.childLanes, renderLanes);
    }
    function updateSuspenseComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps; // This is used by DevTools to force a boundary to suspend.
        if (shouldSuspend(workInProgress)) workInProgress.flags |= DidCapture;
        var suspenseContext = suspenseStackCursor.current;
        var showFallback = false;
        var didSuspend = (workInProgress.flags & DidCapture) !== NoFlags;
        if (didSuspend || shouldRemainOnFallback(suspenseContext, current)) {
            // Something in this boundary's subtree already suspended. Switch to
            // rendering the fallback children.
            showFallback = true;
            workInProgress.flags &= ~DidCapture;
        } else // Attempting the main content
        if (current === null || current.memoizedState !== null) suspenseContext = addSubtreeSuspenseContext(suspenseContext, InvisibleParentSuspenseContext);
        suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
        pushSuspenseContext(workInProgress, suspenseContext); // OK, the next part is confusing. We're about to reconcile the Suspense
        // boundary's children. This involves some custom reconciliation logic. Two
        // main reasons this is so complicated.
        //
        // First, Legacy Mode has different semantics for backwards compatibility. The
        // primary tree will commit in an inconsistent state, so when we do the
        // second pass to render the fallback, we do some exceedingly, uh, clever
        // hacks to make that not totally break. Like transferring effects and
        // deletions from hidden tree. In Concurrent Mode, it's much simpler,
        // because we bailout on the primary tree completely and leave it in its old
        // state, no effects. Same as what we do for Offscreen (except that
        // Offscreen doesn't have the first render pass).
        //
        // Second is hydration. During hydration, the Suspense fiber has a slightly
        // different layout, where the child points to a dehydrated fragment, which
        // contains the DOM rendered by the server.
        //
        // Third, even if you set all that aside, Suspense is like error boundaries in
        // that we first we try to render one tree, and if that fails, we render again
        // and switch to a different tree. Like a try/catch block. So we have to track
        // which branch we're currently rendering. Ideally we would model this using
        // a stack.
        if (current === null) {
            // Initial mount
            // Special path for hydration
            // If we're currently hydrating, try to hydrate this boundary.
            tryToClaimNextHydratableInstance(workInProgress); // This could've been a dehydrated suspense component.
            var suspenseState = workInProgress.memoizedState;
            if (suspenseState !== null) {
                var dehydrated = suspenseState.dehydrated;
                if (dehydrated !== null) return mountDehydratedSuspenseComponent(workInProgress, dehydrated);
            }
            var nextPrimaryChildren = nextProps.children;
            var nextFallbackChildren = nextProps.fallback;
            if (showFallback) {
                var fallbackFragment = mountSuspenseFallbackChildren(workInProgress, nextPrimaryChildren, nextFallbackChildren, renderLanes);
                var primaryChildFragment = workInProgress.child;
                primaryChildFragment.memoizedState = mountSuspenseOffscreenState(renderLanes);
                workInProgress.memoizedState = SUSPENDED_MARKER;
                return fallbackFragment;
            } else return mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
        } else {
            // This is an update.
            // Special path for hydration
            var prevState = current.memoizedState;
            if (prevState !== null) {
                var _dehydrated = prevState.dehydrated;
                if (_dehydrated !== null) return updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, nextProps, _dehydrated, prevState, renderLanes);
            }
            if (showFallback) {
                var _nextFallbackChildren = nextProps.fallback;
                var _nextPrimaryChildren = nextProps.children;
                var fallbackChildFragment = updateSuspenseFallbackChildren(current, workInProgress, _nextPrimaryChildren, _nextFallbackChildren, renderLanes);
                var _primaryChildFragment2 = workInProgress.child;
                var prevOffscreenState = current.child.memoizedState;
                _primaryChildFragment2.memoizedState = prevOffscreenState === null ? mountSuspenseOffscreenState(renderLanes) : updateSuspenseOffscreenState(prevOffscreenState, renderLanes);
                _primaryChildFragment2.childLanes = getRemainingWorkInPrimaryTree(current, renderLanes);
                workInProgress.memoizedState = SUSPENDED_MARKER;
                return fallbackChildFragment;
            } else {
                var _nextPrimaryChildren2 = nextProps.children;
                var _primaryChildFragment3 = updateSuspensePrimaryChildren(current, workInProgress, _nextPrimaryChildren2, renderLanes);
                workInProgress.memoizedState = null;
                return _primaryChildFragment3;
            }
        }
    }
    function mountSuspensePrimaryChildren(workInProgress, primaryChildren, renderLanes) {
        var mode = workInProgress.mode;
        var primaryChildProps = {
            mode: 'visible',
            children: primaryChildren
        };
        var primaryChildFragment = mountWorkInProgressOffscreenFiber(primaryChildProps, mode);
        primaryChildFragment.return = workInProgress;
        workInProgress.child = primaryChildFragment;
        return primaryChildFragment;
    }
    function mountSuspenseFallbackChildren(workInProgress, primaryChildren, fallbackChildren, renderLanes) {
        var mode = workInProgress.mode;
        var progressedPrimaryFragment = workInProgress.child;
        var primaryChildProps = {
            mode: 'hidden',
            children: primaryChildren
        };
        var primaryChildFragment;
        var fallbackChildFragment;
        if ((mode & ConcurrentMode) === NoMode && progressedPrimaryFragment !== null) {
            // In legacy mode, we commit the primary tree as if it successfully
            // completed, even though it's in an inconsistent state.
            primaryChildFragment = progressedPrimaryFragment;
            primaryChildFragment.childLanes = NoLanes;
            primaryChildFragment.pendingProps = primaryChildProps;
            if (workInProgress.mode & ProfileMode) {
                // Reset the durations from the first pass so they aren't included in the
                // final amounts. This seems counterintuitive, since we're intentionally
                // not measuring part of the render phase, but this makes it match what we
                // do in Concurrent Mode.
                primaryChildFragment.actualDuration = 0;
                primaryChildFragment.actualStartTime = -1;
                primaryChildFragment.selfBaseDuration = 0;
                primaryChildFragment.treeBaseDuration = 0;
            }
            fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null);
        } else {
            primaryChildFragment = mountWorkInProgressOffscreenFiber(primaryChildProps, mode);
            fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null);
        }
        primaryChildFragment.return = workInProgress;
        fallbackChildFragment.return = workInProgress;
        primaryChildFragment.sibling = fallbackChildFragment;
        workInProgress.child = primaryChildFragment;
        return fallbackChildFragment;
    }
    function mountWorkInProgressOffscreenFiber(offscreenProps, mode, renderLanes) {
        // The props argument to `createFiberFromOffscreen` is `any` typed, so we use
        // this wrapper function to constrain it.
        return createFiberFromOffscreen(offscreenProps, mode, NoLanes, null);
    }
    function updateWorkInProgressOffscreenFiber(current, offscreenProps) {
        // The props argument to `createWorkInProgress` is `any` typed, so we use this
        // wrapper function to constrain it.
        return createWorkInProgress(current, offscreenProps);
    }
    function updateSuspensePrimaryChildren(current, workInProgress, primaryChildren, renderLanes) {
        var currentPrimaryChildFragment = current.child;
        var currentFallbackChildFragment = currentPrimaryChildFragment.sibling;
        var primaryChildFragment = updateWorkInProgressOffscreenFiber(currentPrimaryChildFragment, {
            mode: 'visible',
            children: primaryChildren
        });
        if ((workInProgress.mode & ConcurrentMode) === NoMode) primaryChildFragment.lanes = renderLanes;
        primaryChildFragment.return = workInProgress;
        primaryChildFragment.sibling = null;
        if (currentFallbackChildFragment !== null) {
            // Delete the fallback child fragment
            var deletions = workInProgress.deletions;
            if (deletions === null) {
                workInProgress.deletions = [
                    currentFallbackChildFragment
                ];
                workInProgress.flags |= ChildDeletion;
            } else deletions.push(currentFallbackChildFragment);
        }
        workInProgress.child = primaryChildFragment;
        return primaryChildFragment;
    }
    function updateSuspenseFallbackChildren(current, workInProgress, primaryChildren, fallbackChildren, renderLanes) {
        var mode = workInProgress.mode;
        var currentPrimaryChildFragment = current.child;
        var currentFallbackChildFragment = currentPrimaryChildFragment.sibling;
        var primaryChildProps = {
            mode: 'hidden',
            children: primaryChildren
        };
        var primaryChildFragment;
        if (// completed, even though it's in an inconsistent state.
        (mode & ConcurrentMode) === NoMode && // Make sure we're on the second pass, i.e. the primary child fragment was
        // already cloned. In legacy mode, the only case where this isn't true is
        // when DevTools forces us to display a fallback; we skip the first render
        // pass entirely and go straight to rendering the fallback. (In Concurrent
        // Mode, SuspenseList can also trigger this scenario, but this is a legacy-
        // only codepath.)
        workInProgress.child !== currentPrimaryChildFragment) {
            var progressedPrimaryFragment = workInProgress.child;
            primaryChildFragment = progressedPrimaryFragment;
            primaryChildFragment.childLanes = NoLanes;
            primaryChildFragment.pendingProps = primaryChildProps;
            if (workInProgress.mode & ProfileMode) {
                // Reset the durations from the first pass so they aren't included in the
                // final amounts. This seems counterintuitive, since we're intentionally
                // not measuring part of the render phase, but this makes it match what we
                // do in Concurrent Mode.
                primaryChildFragment.actualDuration = 0;
                primaryChildFragment.actualStartTime = -1;
                primaryChildFragment.selfBaseDuration = currentPrimaryChildFragment.selfBaseDuration;
                primaryChildFragment.treeBaseDuration = currentPrimaryChildFragment.treeBaseDuration;
            } // The fallback fiber was added as a deletion during the first pass.
            // However, since we're going to remain on the fallback, we no longer want
            // to delete it.
            workInProgress.deletions = null;
        } else {
            primaryChildFragment = updateWorkInProgressOffscreenFiber(currentPrimaryChildFragment, primaryChildProps); // Since we're reusing a current tree, we need to reuse the flags, too.
            // (We don't do this in legacy mode, because in legacy mode we don't re-use
            // the current tree; see previous branch.)
            primaryChildFragment.subtreeFlags = currentPrimaryChildFragment.subtreeFlags & StaticMask;
        }
        var fallbackChildFragment;
        if (currentFallbackChildFragment !== null) fallbackChildFragment = createWorkInProgress(currentFallbackChildFragment, fallbackChildren);
        else {
            fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null); // Needs a placement effect because the parent (the Suspense boundary) already
            // mounted but this is a new fiber.
            fallbackChildFragment.flags |= Placement;
        }
        fallbackChildFragment.return = workInProgress;
        primaryChildFragment.return = workInProgress;
        primaryChildFragment.sibling = fallbackChildFragment;
        workInProgress.child = primaryChildFragment;
        return fallbackChildFragment;
    }
    function retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, recoverableError) {
        // Falling back to client rendering. Because this has performance
        // implications, it's considered a recoverable error, even though the user
        // likely won't observe anything wrong with the UI.
        //
        // The error is passed in as an argument to enforce that every caller provide
        // a custom message, or explicitly opt out (currently the only path that opts
        // out is legacy mode; every concurrent path provides an error).
        if (recoverableError !== null) queueHydrationError(recoverableError);
         // This will add the old fiber to the deletion list
        reconcileChildFibers(workInProgress, current.child, null, renderLanes); // We're now not suspended nor dehydrated.
        var nextProps = workInProgress.pendingProps;
        var primaryChildren = nextProps.children;
        var primaryChildFragment = mountSuspensePrimaryChildren(workInProgress, primaryChildren); // Needs a placement effect because the parent (the Suspense boundary) already
        // mounted but this is a new fiber.
        primaryChildFragment.flags |= Placement;
        workInProgress.memoizedState = null;
        return primaryChildFragment;
    }
    function mountSuspenseFallbackAfterRetryWithoutHydrating(current, workInProgress, primaryChildren, fallbackChildren, renderLanes) {
        var fiberMode = workInProgress.mode;
        var primaryChildProps = {
            mode: 'visible',
            children: primaryChildren
        };
        var primaryChildFragment = mountWorkInProgressOffscreenFiber(primaryChildProps, fiberMode);
        var fallbackChildFragment = createFiberFromFragment(fallbackChildren, fiberMode, renderLanes, null); // Needs a placement effect because the parent (the Suspense
        // boundary) already mounted but this is a new fiber.
        fallbackChildFragment.flags |= Placement;
        primaryChildFragment.return = workInProgress;
        fallbackChildFragment.return = workInProgress;
        primaryChildFragment.sibling = fallbackChildFragment;
        workInProgress.child = primaryChildFragment;
        if ((workInProgress.mode & ConcurrentMode) !== NoMode) // We will have dropped the effect list which contains the
        // deletion. We need to reconcile to delete the current child.
        reconcileChildFibers(workInProgress, current.child, null, renderLanes);
        return fallbackChildFragment;
    }
    function mountDehydratedSuspenseComponent(workInProgress, suspenseInstance, renderLanes) {
        // During the first pass, we'll bail out and not drill into the children.
        // Instead, we'll leave the content in place and try to hydrate it later.
        if ((workInProgress.mode & ConcurrentMode) === NoMode) {
            error("Cannot hydrate Suspense in legacy mode. Switch from ReactDOM.hydrate(element, container) to ReactDOMClient.hydrateRoot(container, <App />).render(element) or remove the Suspense components from the server rendered components.");
            workInProgress.lanes = laneToLanes(SyncLane);
        } else if (isSuspenseInstanceFallback(suspenseInstance)) // This is a client-only boundary. Since we won't get any content from the server
        // for this, we need to schedule that at a higher priority based on when it would
        // have timed out. In theory we could render it in this pass but it would have the
        // wrong priority associated with it and will prevent hydration of parent path.
        // Instead, we'll leave work left on it to render it in a separate commit.
        // TODO This time should be the time at which the server rendered response that is
        // a parent to this boundary was displayed. However, since we currently don't have
        // a protocol to transfer that time, we'll just estimate it by using the current
        // time. This will mean that Suspense timeouts are slightly shifted to later than
        // they should be.
        // Schedule a normal pri update to render this content.
        workInProgress.lanes = laneToLanes(DefaultHydrationLane);
        else // We'll continue hydrating the rest at offscreen priority since we'll already
        // be showing the right content coming from the server, it is no rush.
        workInProgress.lanes = laneToLanes(OffscreenLane);
        return null;
    }
    function updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, nextProps, suspenseInstance, suspenseState, renderLanes) {
        if (!didSuspend) {
            // This is the first render pass. Attempt to hydrate.
            // We should never be hydrating at this point because it is the first pass,
            // but after we've already committed once.
            warnIfHydrating();
            if ((workInProgress.mode & ConcurrentMode) === NoMode) return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, // required — every concurrent mode path that causes hydration to
            // de-opt to client rendering should have an error message.
            null);
            if (isSuspenseInstanceFallback(suspenseInstance)) {
                // This boundary is in a permanent fallback state. In this case, we'll never
                // get an update and we'll never be able to hydrate the final content. Let's just try the
                // client side render instead.
                var digest, message, stack;
                var _getSuspenseInstanceF = getSuspenseInstanceFallbackErrorDetails(suspenseInstance);
                digest = _getSuspenseInstanceF.digest;
                message = _getSuspenseInstanceF.message;
                stack = _getSuspenseInstanceF.stack;
                var _$error;
                if (message) // eslint-disable-next-line react-internal/prod-error-codes
                _$error = new Error(message);
                else _$error = new Error("The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.");
                var capturedValue = createCapturedValue(_$error, digest, stack);
                return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, capturedValue);
            }
            // any context has changed, we need to treat is as if the input might have changed.
            var hasContextChanged = includesSomeLane(renderLanes, current.childLanes);
            if (didReceiveUpdate || hasContextChanged) {
                // This boundary has changed since the first render. This means that we are now unable to
                // hydrate it. We might still be able to hydrate it using a higher priority lane.
                var root = getWorkInProgressRoot();
                if (root !== null) {
                    var attemptHydrationAtLane = getBumpedLaneForHydration(root, renderLanes);
                    if (attemptHydrationAtLane !== NoLane && attemptHydrationAtLane !== suspenseState.retryLane) {
                        // Intentionally mutating since this render will get interrupted. This
                        // is one of the very rare times where we mutate the current tree
                        // during the render phase.
                        suspenseState.retryLane = attemptHydrationAtLane; // TODO: Ideally this would inherit the event time of the current render
                        var eventTime = NoTimestamp;
                        enqueueConcurrentRenderForLane(current, attemptHydrationAtLane);
                        scheduleUpdateOnFiber(root, current, attemptHydrationAtLane, eventTime);
                    }
                } // If we have scheduled higher pri work above, this will probably just abort the render
                // since we now have higher priority work, but in case it doesn't, we need to prepare to
                // render something, if we time out. Even if that requires us to delete everything and
                // skip hydration.
                // Delay having to do this as long as the suspense timeout allows us.
                renderDidSuspendDelayIfPossible();
                var _capturedValue = createCapturedValue(new Error("This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition."));
                return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, _capturedValue);
            } else if (isSuspenseInstancePending(suspenseInstance)) {
                // This component is still pending more data from the server, so we can't hydrate its
                // content. We treat it as if this component suspended itself. It might seem as if
                // we could just try to render it client-side instead. However, this will perform a
                // lot of unnecessary work and is unlikely to complete since it often will suspend
                // on missing data anyway. Additionally, the server might be able to render more
                // than we can on the client yet. In that case we'd end up with more fallback states
                // on the client than if we just leave it alone. If the server times out or errors
                // these should update this boundary to the permanent Fallback state instead.
                // Mark it as having captured (i.e. suspended).
                workInProgress.flags |= DidCapture; // Leave the child in place. I.e. the dehydrated fragment.
                workInProgress.child = current.child; // Register a callback to retry this boundary once the server has sent the result.
                var retry = retryDehydratedSuspenseBoundary.bind(null, current);
                registerSuspenseInstanceRetry(suspenseInstance, retry);
                return null;
            } else {
                // This is the first attempt.
                reenterHydrationStateFromDehydratedSuspenseInstance(workInProgress, suspenseInstance, suspenseState.treeContext);
                var primaryChildren = nextProps.children;
                var primaryChildFragment = mountSuspensePrimaryChildren(workInProgress, primaryChildren); // Mark the children as hydrating. This is a fast path to know whether this
                // tree is part of a hydrating tree. This is used to determine if a child
                // node has fully mounted yet, and for scheduling event replaying.
                // Conceptually this is similar to Placement in that a new subtree is
                // inserted into the React tree here. It just happens to not need DOM
                // mutations because it already exists.
                primaryChildFragment.flags |= Hydrating;
                return primaryChildFragment;
            }
        } else {
            // This is the second render pass. We already attempted to hydrated, but
            // something either suspended or errored.
            if (workInProgress.flags & ForceClientRender) {
                // Something errored during hydration. Try again without hydrating.
                workInProgress.flags &= ~ForceClientRender;
                var _capturedValue2 = createCapturedValue(new Error("There was an error while hydrating this Suspense boundary. Switched to client rendering."));
                return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, _capturedValue2);
            } else if (workInProgress.memoizedState !== null) {
                // Something suspended and we should still be in dehydrated mode.
                // Leave the existing child in place.
                workInProgress.child = current.child; // The dehydrated completion pass expects this flag to be there
                // but the normal suspense pass doesn't.
                workInProgress.flags |= DidCapture;
                return null;
            } else {
                // Suspended but we should no longer be in dehydrated mode.
                // Therefore we now have to render the fallback.
                var nextPrimaryChildren = nextProps.children;
                var nextFallbackChildren = nextProps.fallback;
                var fallbackChildFragment = mountSuspenseFallbackAfterRetryWithoutHydrating(current, workInProgress, nextPrimaryChildren, nextFallbackChildren, renderLanes);
                var _primaryChildFragment4 = workInProgress.child;
                _primaryChildFragment4.memoizedState = mountSuspenseOffscreenState(renderLanes);
                workInProgress.memoizedState = SUSPENDED_MARKER;
                return fallbackChildFragment;
            }
        }
    }
    function scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
        fiber.lanes = mergeLanes(fiber.lanes, renderLanes);
        var alternate = fiber.alternate;
        if (alternate !== null) alternate.lanes = mergeLanes(alternate.lanes, renderLanes);
        scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
    }
    function propagateSuspenseContextChange(workInProgress, firstChild, renderLanes) {
        // Mark any Suspense boundaries with fallbacks as having work to do.
        // If they were previously forced into fallbacks, they may now be able
        // to unblock.
        var node = firstChild;
        while(node !== null){
            if (node.tag === SuspenseComponent) {
                var state = node.memoizedState;
                if (state !== null) scheduleSuspenseWorkOnFiber(node, renderLanes, workInProgress);
            } else if (node.tag === SuspenseListComponent) // If the tail is hidden there might not be an Suspense boundaries
            // to schedule work on. In this case we have to schedule it on the
            // list itself.
            // We don't have to traverse to the children of the list since
            // the list will propagate the change when it rerenders.
            scheduleSuspenseWorkOnFiber(node, renderLanes, workInProgress);
            else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === workInProgress) return;
            while(node.sibling === null){
                if (node.return === null || node.return === workInProgress) return;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    function findLastContentRow(firstChild) {
        // This is going to find the last row among these children that is already
        // showing content on the screen, as opposed to being in fallback state or
        // new. If a row has multiple Suspense boundaries, any of them being in the
        // fallback state, counts as the whole row being in a fallback state.
        // Note that the "rows" will be workInProgress, but any nested children
        // will still be current since we haven't rendered them yet. The mounted
        // order may not be the same as the new order. We use the new order.
        var row = firstChild;
        var lastContentRow = null;
        while(row !== null){
            var currentRow = row.alternate; // New rows can't be content rows.
            if (currentRow !== null && findFirstSuspended(currentRow) === null) lastContentRow = row;
            row = row.sibling;
        }
        return lastContentRow;
    }
    function validateRevealOrder(revealOrder) {
        if (revealOrder !== undefined && revealOrder !== 'forwards' && revealOrder !== 'backwards' && revealOrder !== 'together' && !didWarnAboutRevealOrder[revealOrder]) {
            didWarnAboutRevealOrder[revealOrder] = true;
            if (typeof revealOrder === 'string') switch(revealOrder.toLowerCase()){
                case 'together':
                case 'forwards':
                case 'backwards':
                    error('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                case 'forward':
                case 'backward':
                    error('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                default:
                    error('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', revealOrder);
                    break;
            }
            else error('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', revealOrder);
        }
    }
    function validateTailOptions(tailMode, revealOrder) {
        if (tailMode !== undefined && !didWarnAboutTailOptions[tailMode]) {
            if (tailMode !== 'collapsed' && tailMode !== 'hidden') {
                didWarnAboutTailOptions[tailMode] = true;
                error('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?', tailMode);
            } else if (revealOrder !== 'forwards' && revealOrder !== 'backwards') {
                didWarnAboutTailOptions[tailMode] = true;
                error('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?', tailMode);
            }
        }
    }
    function validateSuspenseListNestedChild(childSlot, index) {
        var isAnArray = isArray(childSlot);
        var isIterable = !isAnArray && typeof getIteratorFn(childSlot) === 'function';
        if (isAnArray || isIterable) {
            var type = isAnArray ? 'array' : 'iterable';
            error("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", type, index, type);
            return false;
        }
        return true;
    }
    function validateSuspenseListChildren(children, revealOrder) {
        if ((revealOrder === 'forwards' || revealOrder === 'backwards') && children !== undefined && children !== null && children !== false) {
            if (isArray(children)) for(var i = 0; i < children.length; i++){
                if (!validateSuspenseListNestedChild(children[i], i)) return;
            }
            else {
                var iteratorFn = getIteratorFn(children);
                if (typeof iteratorFn === 'function') {
                    var childrenIterator = iteratorFn.call(children);
                    if (childrenIterator) {
                        var step = childrenIterator.next();
                        var _i = 0;
                        for(; !step.done; step = childrenIterator.next()){
                            if (!validateSuspenseListNestedChild(step.value, _i)) return;
                            _i++;
                        }
                    }
                } else error('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', revealOrder);
            }
        }
    }
    function initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode) {
        var renderState = workInProgress.memoizedState;
        if (renderState === null) workInProgress.memoizedState = {
            isBackwards: isBackwards,
            rendering: null,
            renderingStartTime: 0,
            last: lastContentRow,
            tail: tail,
            tailMode: tailMode
        };
        else {
            // We can reuse the existing object from previous renders.
            renderState.isBackwards = isBackwards;
            renderState.rendering = null;
            renderState.renderingStartTime = 0;
            renderState.last = lastContentRow;
            renderState.tail = tail;
            renderState.tailMode = tailMode;
        }
    } // This can end up rendering this component multiple passes.
    // The first pass splits the children fibers into two sets. A head and tail.
    // We first render the head. If anything is in fallback state, we do another
    // pass through beginWork to rerender all children (including the tail) with
    // the force suspend context. If the first render didn't have anything in
    // in fallback state. Then we render each row in the tail one-by-one.
    // That happens in the completeWork phase without going back to beginWork.
    function updateSuspenseListComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps;
        var revealOrder = nextProps.revealOrder;
        var tailMode = nextProps.tail;
        var newChildren = nextProps.children;
        validateRevealOrder(revealOrder);
        validateTailOptions(tailMode, revealOrder);
        validateSuspenseListChildren(newChildren, revealOrder);
        reconcileChildren(current, workInProgress, newChildren, renderLanes);
        var suspenseContext = suspenseStackCursor.current;
        var shouldForceFallback = hasSuspenseContext(suspenseContext, ForceSuspenseFallback);
        if (shouldForceFallback) {
            suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
            workInProgress.flags |= DidCapture;
        } else {
            var didSuspendBefore = current !== null && (current.flags & DidCapture) !== NoFlags;
            if (didSuspendBefore) // If we previously forced a fallback, we need to schedule work
            // on any nested boundaries to let them know to try to render
            // again. This is the same as context updating.
            propagateSuspenseContextChange(workInProgress, workInProgress.child, renderLanes);
            suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
        }
        pushSuspenseContext(workInProgress, suspenseContext);
        if ((workInProgress.mode & ConcurrentMode) === NoMode) // In legacy mode, SuspenseList doesn't work so we just
        // use make it a noop by treating it as the default revealOrder.
        workInProgress.memoizedState = null;
        else switch(revealOrder){
            case 'forwards':
                var lastContentRow = findLastContentRow(workInProgress.child);
                var tail;
                if (lastContentRow === null) {
                    // The whole list is part of the tail.
                    // TODO: We could fast path by just rendering the tail now.
                    tail = workInProgress.child;
                    workInProgress.child = null;
                } else {
                    // Disconnect the tail rows after the content row.
                    // We're going to render them separately later.
                    tail = lastContentRow.sibling;
                    lastContentRow.sibling = null;
                }
                initSuspenseListRenderState(workInProgress, false, tail, lastContentRow, tailMode);
                break;
            case 'backwards':
                // We're going to find the first row that has existing content.
                // At the same time we're going to reverse the list of everything
                // we pass in the meantime. That's going to be our tail in reverse
                // order.
                var _tail = null;
                var row = workInProgress.child;
                workInProgress.child = null;
                while(row !== null){
                    var currentRow = row.alternate; // New rows can't be content rows.
                    if (currentRow !== null && findFirstSuspended(currentRow) === null) {
                        // This is the beginning of the main content.
                        workInProgress.child = row;
                        break;
                    }
                    var nextRow = row.sibling;
                    row.sibling = _tail;
                    _tail = row;
                    row = nextRow;
                } // TODO: If workInProgress.child is null, we can continue on the tail immediately.
                initSuspenseListRenderState(workInProgress, true, _tail, null, tailMode);
                break;
            case 'together':
                initSuspenseListRenderState(workInProgress, false, null, null, undefined);
                break;
            default:
                // The default reveal order is the same as not having
                // a boundary.
                workInProgress.memoizedState = null;
        }
        return workInProgress.child;
    }
    function updatePortalComponent(current, workInProgress, renderLanes) {
        pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
        var nextChildren = workInProgress.pendingProps;
        if (current === null) // Portals are special because we don't append the children during mount
        // but at commit. Therefore we need to track insertions which the normal
        // flow doesn't do during mount. This doesn't happen at the root because
        // the root always starts with a "current" with a null child.
        // TODO: Consider unifying this with how the root works.
        workInProgress.child = reconcileChildFibers(workInProgress, null, nextChildren, renderLanes);
        else reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    var hasWarnedAboutUsingNoValuePropOnContextProvider = false;
    function updateContextProvider(current, workInProgress, renderLanes) {
        var providerType = workInProgress.type;
        var context = providerType._context;
        var newProps = workInProgress.pendingProps;
        var oldProps = workInProgress.memoizedProps;
        var newValue = newProps.value;
        if (!('value' in newProps)) {
            if (!hasWarnedAboutUsingNoValuePropOnContextProvider) {
                hasWarnedAboutUsingNoValuePropOnContextProvider = true;
                error('The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?');
            }
        }
        var providerPropTypes = workInProgress.type.propTypes;
        if (providerPropTypes) checkPropTypes(providerPropTypes, newProps, 'prop', 'Context.Provider');
        pushProvider(workInProgress, context, newValue);
        if (oldProps !== null) {
            var oldValue = oldProps.value;
            if (objectIs(oldValue, newValue)) {
                // No change. Bailout early if children are the same.
                if (oldProps.children === newProps.children && !hasContextChanged()) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
            } else // The context value changed. Search for matching consumers and schedule
            // them to update.
            propagateContextChange(workInProgress, context, renderLanes);
        }
        var newChildren = newProps.children;
        reconcileChildren(current, workInProgress, newChildren, renderLanes);
        return workInProgress.child;
    }
    var hasWarnedAboutUsingContextAsConsumer = false;
    function updateContextConsumer(current, workInProgress, renderLanes) {
        var context = workInProgress.type; // The logic below for Context differs depending on PROD or DEV mode. In
        if (context._context === undefined) {
            // This may be because it's a Context (rather than a Consumer).
            // Or it may be because it's older React where they're the same thing.
            // We only want to warn if we're sure it's a new React.
            if (context !== context.Consumer) {
                if (!hasWarnedAboutUsingContextAsConsumer) {
                    hasWarnedAboutUsingContextAsConsumer = true;
                    error("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?");
                }
            }
        } else context = context._context;
        var newProps = workInProgress.pendingProps;
        var _$render = newProps.children;
        if (typeof _$render !== 'function') error("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it.");
        prepareToReadContext(workInProgress, renderLanes);
        var newValue = readContext(context);
        markComponentRenderStarted(workInProgress);
        var newChildren;
        ReactCurrentOwner$1.current = workInProgress;
        setIsRendering(true);
        newChildren = _$render(newValue);
        setIsRendering(false);
        markComponentRenderStopped();
        workInProgress.flags |= PerformedWork;
        reconcileChildren(current, workInProgress, newChildren, renderLanes);
        return workInProgress.child;
    }
    function markWorkInProgressReceivedUpdate() {
        didReceiveUpdate = true;
    }
    function resetSuspendedCurrentOnMountInLegacyMode(current, workInProgress) {
        if ((workInProgress.mode & ConcurrentMode) === NoMode) {
            if (current !== null) {
                // A lazy component only mounts if it suspended inside a non-
                // concurrent tree, in an inconsistent state. We want to treat it like
                // a new mount, even though an empty version of it already committed.
                // Disconnect the alternate pointers.
                current.alternate = null;
                workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect
                workInProgress.flags |= Placement;
            }
        }
    }
    function bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
        if (current !== null) // Reuse previous dependencies
        workInProgress.dependencies = current.dependencies;
        // Don't update "base" render times for bailouts.
        stopProfilerTimerIfRunning();
        markSkippedUpdateLanes(workInProgress.lanes); // Check if the children have any pending work.
        if (!includesSomeLane(renderLanes, workInProgress.childLanes)) return null;
         // This fiber doesn't have work, but its subtree does. Clone the child
        // fibers and continue.
        cloneChildFibers(current, workInProgress);
        return workInProgress.child;
    }
    function remountFiber(current, oldWorkInProgress, newWorkInProgress) {
        var returnFiber = oldWorkInProgress.return;
        if (returnFiber === null) // eslint-disable-next-line react-internal/prod-error-codes
        throw new Error('Cannot swap the root fiber.');
         // Disconnect from the old current.
        // It will get deleted.
        current.alternate = null;
        oldWorkInProgress.alternate = null; // Connect to the new tree.
        newWorkInProgress.index = oldWorkInProgress.index;
        newWorkInProgress.sibling = oldWorkInProgress.sibling;
        newWorkInProgress.return = oldWorkInProgress.return;
        newWorkInProgress.ref = oldWorkInProgress.ref; // Replace the child/sibling pointers above it.
        if (oldWorkInProgress === returnFiber.child) returnFiber.child = newWorkInProgress;
        else {
            var prevSibling = returnFiber.child;
            if (prevSibling === null) // eslint-disable-next-line react-internal/prod-error-codes
            throw new Error('Expected parent to have a child.');
            while(prevSibling.sibling !== oldWorkInProgress){
                prevSibling = prevSibling.sibling;
                if (prevSibling === null) // eslint-disable-next-line react-internal/prod-error-codes
                throw new Error('Expected to find the previous sibling.');
            }
            prevSibling.sibling = newWorkInProgress;
        } // Delete the old fiber and place the new one.
        // Since the old fiber is disconnected, we have to schedule it manually.
        var deletions = returnFiber.deletions;
        if (deletions === null) {
            returnFiber.deletions = [
                current
            ];
            returnFiber.flags |= ChildDeletion;
        } else deletions.push(current);
        newWorkInProgress.flags |= Placement; // Restart work from the new fiber.
        return newWorkInProgress;
    }
    function checkScheduledUpdateOrContext(current, renderLanes) {
        // Before performing an early bailout, we must check if there are pending
        // updates or context.
        var updateLanes = current.lanes;
        if (includesSomeLane(updateLanes, renderLanes)) return true;
         // No pending update, but because context is propagated lazily, we need
        return false;
    }
    function attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
        // This fiber does not have any pending work. Bailout without entering
        // the begin phase. There's still some bookkeeping we that needs to be done
        // in this optimized path, mostly pushing stuff onto the stack.
        switch(workInProgress.tag){
            case HostRoot:
                pushHostRootContext(workInProgress);
                var root = workInProgress.stateNode;
                resetHydrationState();
                break;
            case HostComponent:
                pushHostContext(workInProgress);
                break;
            case ClassComponent:
                var Component = workInProgress.type;
                if (isContextProvider(Component)) pushContextProvider(workInProgress);
                break;
            case HostPortal:
                pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                break;
            case ContextProvider:
                var newValue = workInProgress.memoizedProps.value;
                var context = workInProgress.type._context;
                pushProvider(workInProgress, context, newValue);
                break;
            case Profiler:
                // Profiler should only call onRender when one of its descendants actually rendered.
                var hasChildWork = includesSomeLane(renderLanes, workInProgress.childLanes);
                if (hasChildWork) workInProgress.flags |= Update;
                // Reset effect durations for the next eventual effect phase.
                // These are reset during render to allow the DevTools commit hook a chance to read them,
                var stateNode = workInProgress.stateNode;
                stateNode.effectDuration = 0;
                stateNode.passiveEffectDuration = 0;
                break;
            case SuspenseComponent:
                var state = workInProgress.memoizedState;
                if (state !== null) {
                    if (state.dehydrated !== null) {
                        pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current)); // We know that this component will suspend again because if it has
                        // been unsuspended it has committed as a resolved Suspense component.
                        // If it needs to be retried, it should have work scheduled on it.
                        workInProgress.flags |= DidCapture; // We should never render the children of a dehydrated boundary until we
                        // upgrade it. We return null instead of bailoutOnAlreadyFinishedWork.
                        return null;
                    } // If this boundary is currently timed out, we need to decide
                    // whether to retry the primary children, or to skip over it and
                    // go straight to the fallback. Check the priority of the primary
                    // child fragment.
                    var primaryChildFragment = workInProgress.child;
                    var primaryChildLanes = primaryChildFragment.childLanes;
                    if (includesSomeLane(renderLanes, primaryChildLanes)) // The primary children have pending work. Use the normal path
                    // to attempt to render the primary children again.
                    return updateSuspenseComponent(current, workInProgress, renderLanes);
                    else {
                        // The primary child fragment does not have pending work marked
                        // on it
                        pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current)); // The primary children do not have pending work with sufficient
                        // priority. Bailout.
                        var child = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        if (child !== null) // The fallback children have pending work. Skip over the
                        // primary children and work on the fallback.
                        return child.sibling;
                        else // Note: We can return `null` here because we already checked
                        // whether there were nested context consumers, via the call to
                        // `bailoutOnAlreadyFinishedWork` above.
                        return null;
                    }
                } else pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current));
                break;
            case SuspenseListComponent:
                var didSuspendBefore = (current.flags & DidCapture) !== NoFlags;
                var _hasChildWork = includesSomeLane(renderLanes, workInProgress.childLanes);
                if (didSuspendBefore) {
                    if (_hasChildWork) // If something was in fallback state last time, and we have all the
                    // same children then we're still in progressive loading state.
                    // Something might get unblocked by state updates or retries in the
                    // tree which will affect the tail. So we need to use the normal
                    // path to compute the correct tail.
                    return updateSuspenseListComponent(current, workInProgress, renderLanes);
                     // If none of the children had any work, that means that none of
                    // them got retried so they'll still be blocked in the same way
                    // as before. We can fast bail out.
                    workInProgress.flags |= DidCapture;
                } // If nothing suspended before and we're rendering the same children,
                // then the tail doesn't matter. Anything new that suspends will work
                // in the "together" mode, so we can continue from the state we had.
                var renderState = workInProgress.memoizedState;
                if (renderState !== null) {
                    // Reset to the "together" mode in case we've started a different
                    // update in the past but didn't complete it.
                    renderState.rendering = null;
                    renderState.tail = null;
                    renderState.lastEffect = null;
                }
                pushSuspenseContext(workInProgress, suspenseStackCursor.current);
                if (_hasChildWork) break;
                else // If none of the children had any work, that means that none of
                // them got retried so they'll still be blocked in the same way
                // as before. We can fast bail out.
                return null;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                // Need to check if the tree still needs to be deferred. This is
                // almost identical to the logic used in the normal update path,
                // so we'll just enter that. The only difference is we'll bail out
                // at the next level instead of this one, because the child props
                // have not changed. Which is fine.
                // TODO: Probably should refactor `beginWork` to split the bailout
                // path from the normal path. I'm tempted to do a labeled break here
                // but I won't :)
                workInProgress.lanes = NoLanes;
                return updateOffscreenComponent(current, workInProgress, renderLanes);
        }
        return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    function beginWork(current, workInProgress, renderLanes) {
        if (workInProgress._debugNeedsRemount && current !== null) // This will restart the begin phase with a new fiber.
        return remountFiber(current, workInProgress, createFiberFromTypeAndProps(workInProgress.type, workInProgress.key, workInProgress.pendingProps, workInProgress._debugOwner || null, workInProgress.mode, workInProgress.lanes));
        if (current !== null) {
            var oldProps = current.memoizedProps;
            var newProps = workInProgress.pendingProps;
            if (oldProps !== newProps || hasContextChanged() || workInProgress.type !== current.type) // If props or context changed, mark the fiber as having performed work.
            // This may be unset if the props are determined to be equal later (memo).
            didReceiveUpdate = true;
            else {
                // Neither props nor legacy context changes. Check if there's a pending
                // update or context change.
                var hasScheduledUpdateOrContext = checkScheduledUpdateOrContext(current, renderLanes);
                if (!hasScheduledUpdateOrContext && // If this is the second pass of an error or suspense boundary, there
                // may not be work scheduled on `current`, so we check for this flag.
                (workInProgress.flags & DidCapture) === NoFlags) {
                    // No pending updates or context. Bail out now.
                    didReceiveUpdate = false;
                    return attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
                }
                if ((current.flags & ForceUpdateForLegacySuspense) !== NoFlags) // This is a special case that only exists for legacy mode.
                // See https://github.com/facebook/react/pull/19216.
                didReceiveUpdate = true;
                else // An update was scheduled on this fiber, but there are no new props
                // nor legacy context. Set this to false. If an update queue or context
                // consumer produces a changed value, it will set this to true. Otherwise,
                // the component will assume the children have not changed and bail out.
                didReceiveUpdate = false;
            }
        } else {
            didReceiveUpdate = false;
            if (getIsHydrating() && isForkedChild(workInProgress)) {
                // Check if this child belongs to a list of muliple children in
                // its parent.
                //
                // In a true multi-threaded implementation, we would render children on
                // parallel threads. This would represent the beginning of a new render
                // thread for this subtree.
                //
                // We only use this for id generation during hydration, which is why the
                // logic is located in this special branch.
                var slotIndex = workInProgress.index;
                var numberOfForks = getForksAtLevel();
                pushTreeId(workInProgress, numberOfForks, slotIndex);
            }
        } // Before entering the begin phase, clear pending update priority.
        // TODO: This assumes that we're about to evaluate the component and process
        // the update queue. However, there's an exception: SimpleMemoComponent
        // sometimes bails out later in the begin phase. This indicates that we should
        // move this assignment out of the common path and into each branch.
        workInProgress.lanes = NoLanes;
        switch(workInProgress.tag){
            case IndeterminateComponent:
                return mountIndeterminateComponent(current, workInProgress, workInProgress.type, renderLanes);
            case LazyComponent:
                var elementType = workInProgress.elementType;
                return mountLazyComponent(current, workInProgress, elementType, renderLanes);
            case FunctionComponent:
                var Component = workInProgress.type;
                var unresolvedProps = workInProgress.pendingProps;
                var resolvedProps = workInProgress.elementType === Component ? unresolvedProps : resolveDefaultProps(Component, unresolvedProps);
                return updateFunctionComponent(current, workInProgress, Component, resolvedProps, renderLanes);
            case ClassComponent:
                var _Component = workInProgress.type;
                var _unresolvedProps = workInProgress.pendingProps;
                var _resolvedProps = workInProgress.elementType === _Component ? _unresolvedProps : resolveDefaultProps(_Component, _unresolvedProps);
                return updateClassComponent(current, workInProgress, _Component, _resolvedProps, renderLanes);
            case HostRoot:
                return updateHostRoot(current, workInProgress, renderLanes);
            case HostComponent:
                return updateHostComponent(current, workInProgress, renderLanes);
            case HostText:
                return updateHostText(current, workInProgress);
            case SuspenseComponent:
                return updateSuspenseComponent(current, workInProgress, renderLanes);
            case HostPortal:
                return updatePortalComponent(current, workInProgress, renderLanes);
            case ForwardRef:
                var type = workInProgress.type;
                var _unresolvedProps2 = workInProgress.pendingProps;
                var _resolvedProps2 = workInProgress.elementType === type ? _unresolvedProps2 : resolveDefaultProps(type, _unresolvedProps2);
                return updateForwardRef(current, workInProgress, type, _resolvedProps2, renderLanes);
            case Fragment:
                return updateFragment(current, workInProgress, renderLanes);
            case Mode:
                return updateMode(current, workInProgress, renderLanes);
            case Profiler:
                return updateProfiler(current, workInProgress, renderLanes);
            case ContextProvider:
                return updateContextProvider(current, workInProgress, renderLanes);
            case ContextConsumer:
                return updateContextConsumer(current, workInProgress, renderLanes);
            case MemoComponent:
                var _type2 = workInProgress.type;
                var _unresolvedProps3 = workInProgress.pendingProps; // Resolve outer props first, then resolve inner props.
                var _resolvedProps3 = resolveDefaultProps(_type2, _unresolvedProps3);
                if (workInProgress.type !== workInProgress.elementType) {
                    var outerPropTypes = _type2.propTypes;
                    if (outerPropTypes) checkPropTypes(outerPropTypes, _resolvedProps3, 'prop', getComponentNameFromType(_type2));
                }
                _resolvedProps3 = resolveDefaultProps(_type2.type, _resolvedProps3);
                return updateMemoComponent(current, workInProgress, _type2, _resolvedProps3, renderLanes);
            case SimpleMemoComponent:
                return updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
            case IncompleteClassComponent:
                var _Component2 = workInProgress.type;
                var _unresolvedProps4 = workInProgress.pendingProps;
                var _resolvedProps4 = workInProgress.elementType === _Component2 ? _unresolvedProps4 : resolveDefaultProps(_Component2, _unresolvedProps4);
                return mountIncompleteClassComponent(current, workInProgress, _Component2, _resolvedProps4, renderLanes);
            case SuspenseListComponent:
                return updateSuspenseListComponent(current, workInProgress, renderLanes);
            case ScopeComponent:
                break;
            case OffscreenComponent:
                return updateOffscreenComponent(current, workInProgress, renderLanes);
        }
        throw new Error("Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in " + 'React. Please file an issue.');
    }
    function markUpdate(workInProgress) {
        // Tag the fiber with an update effect. This turns a Placement into
        // a PlacementAndUpdate.
        workInProgress.flags |= Update;
    }
    function markRef$1(workInProgress) {
        workInProgress.flags |= Ref;
        workInProgress.flags |= RefStatic;
    }
    var appendAllChildren;
    var updateHostContainer;
    var updateHostComponent$1;
    var updateHostText$1;
    // Mutation mode
    appendAllChildren = function appendAllChildren(parent, workInProgress, needsVisibilityToggle, isHidden) {
        // We only have the top Fiber that was created but we need recurse down its
        // children to find all the terminal nodes.
        var node = workInProgress.child;
        while(node !== null){
            if (node.tag === HostComponent || node.tag === HostText) appendInitialChild(parent, node.stateNode);
            else if (node.tag === HostPortal) ;
            else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === workInProgress) return;
            while(node.sibling === null){
                if (node.return === null || node.return === workInProgress) return;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    };
    updateHostContainer = function updateHostContainer(current, workInProgress) {};
    updateHostComponent$1 = function updateHostComponent$1(current, workInProgress, type, newProps, rootContainerInstance) {
        // If we have an alternate, that means this is an update and we need to
        // schedule a side-effect to do the updates.
        var oldProps = current.memoizedProps;
        if (oldProps === newProps) // In mutation mode, this is sufficient for a bailout because
        // we won't touch this node even if children changed.
        return;
         // If we get updated because one of our children updated, we don't
        // have newProps so we'll have to reuse them.
        // TODO: Split the update API as separate for the props vs. children.
        // Even better would be if children weren't special cased at all tho.
        var instance = workInProgress.stateNode;
        var currentHostContext = getHostContext(); // TODO: Experiencing an error where oldProps is null. Suggests a host
        // component is hitting the resume path. Figure out why. Possibly
        // related to `hidden`.
        var updatePayload = prepareUpdate(instance, type, oldProps, newProps, rootContainerInstance, currentHostContext); // TODO: Type this specific to this type of component.
        workInProgress.updateQueue = updatePayload; // If the update payload indicates that there is a change or if there
        // is a new ref we mark this as an update. All the work is done in commitWork.
        if (updatePayload) markUpdate(workInProgress);
    };
    updateHostText$1 = function updateHostText$1(current, workInProgress, oldText, newText) {
        // If the text differs, mark it as an update. All the work in done in commitWork.
        if (oldText !== newText) markUpdate(workInProgress);
    };
    function cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
        if (getIsHydrating()) // If we're hydrating, we should consume as many items as we can
        // so we don't leave any behind.
        return;
        switch(renderState.tailMode){
            case 'hidden':
                // Any insertions at the end of the tail list after this point
                // should be invisible. If there are already mounted boundaries
                // anything before them are not considered for collapsing.
                // Therefore we need to go through the whole tail to find if
                // there are any.
                var tailNode = renderState.tail;
                var lastTailNode = null;
                while(tailNode !== null){
                    if (tailNode.alternate !== null) lastTailNode = tailNode;
                    tailNode = tailNode.sibling;
                } // Next we're simply going to delete all insertions after the
                // last rendered item.
                if (lastTailNode === null) // All remaining items in the tail are insertions.
                renderState.tail = null;
                else // Detach the insertion after the last node that was already
                // inserted.
                lastTailNode.sibling = null;
                break;
            case 'collapsed':
                // Any insertions at the end of the tail list after this point
                // should be invisible. If there are already mounted boundaries
                // anything before them are not considered for collapsing.
                // Therefore we need to go through the whole tail to find if
                // there are any.
                var _tailNode = renderState.tail;
                var _lastTailNode = null;
                while(_tailNode !== null){
                    if (_tailNode.alternate !== null) _lastTailNode = _tailNode;
                    _tailNode = _tailNode.sibling;
                } // Next we're simply going to delete all insertions after the
                // last rendered item.
                if (_lastTailNode === null) {
                    // All remaining items in the tail are insertions.
                    if (!hasRenderedATailFallback && renderState.tail !== null) // We suspended during the head. We want to show at least one
                    // row at the tail. So we'll keep on and cut off the rest.
                    renderState.tail.sibling = null;
                    else renderState.tail = null;
                } else // Detach the insertion after the last node that was already
                // inserted.
                _lastTailNode.sibling = null;
                break;
        }
    }
    function bubbleProperties(completedWork) {
        var didBailout = completedWork.alternate !== null && completedWork.alternate.child === completedWork.child;
        var newChildLanes = NoLanes;
        var subtreeFlags = NoFlags;
        if (!didBailout) {
            // Bubble up the earliest expiration time.
            if ((completedWork.mode & ProfileMode) !== NoMode) {
                // In profiling mode, resetChildExpirationTime is also used to reset
                // profiler durations.
                var actualDuration = completedWork.actualDuration;
                var treeBaseDuration = completedWork.selfBaseDuration;
                var child = completedWork.child;
                while(child !== null){
                    newChildLanes = mergeLanes(newChildLanes, mergeLanes(child.lanes, child.childLanes));
                    subtreeFlags |= child.subtreeFlags;
                    subtreeFlags |= child.flags; // When a fiber is cloned, its actualDuration is reset to 0. This value will
                    // only be updated if work is done on the fiber (i.e. it doesn't bailout).
                    // When work is done, it should bubble to the parent's actualDuration. If
                    // the fiber has not been cloned though, (meaning no work was done), then
                    // this value will reflect the amount of time spent working on a previous
                    // render. In that case it should not bubble. We determine whether it was
                    // cloned by comparing the child pointer.
                    actualDuration += child.actualDuration;
                    treeBaseDuration += child.treeBaseDuration;
                    child = child.sibling;
                }
                completedWork.actualDuration = actualDuration;
                completedWork.treeBaseDuration = treeBaseDuration;
            } else {
                var _child = completedWork.child;
                while(_child !== null){
                    newChildLanes = mergeLanes(newChildLanes, mergeLanes(_child.lanes, _child.childLanes));
                    subtreeFlags |= _child.subtreeFlags;
                    subtreeFlags |= _child.flags; // Update the return pointer so the tree is consistent. This is a code
                    // smell because it assumes the commit phase is never concurrent with
                    // the render phase. Will address during refactor to alternate model.
                    _child.return = completedWork;
                    _child = _child.sibling;
                }
            }
            completedWork.subtreeFlags |= subtreeFlags;
        } else {
            // Bubble up the earliest expiration time.
            if ((completedWork.mode & ProfileMode) !== NoMode) {
                // In profiling mode, resetChildExpirationTime is also used to reset
                // profiler durations.
                var _treeBaseDuration = completedWork.selfBaseDuration;
                var _child2 = completedWork.child;
                while(_child2 !== null){
                    newChildLanes = mergeLanes(newChildLanes, mergeLanes(_child2.lanes, _child2.childLanes)); // "Static" flags share the lifetime of the fiber/hook they belong to,
                    // so we should bubble those up even during a bailout. All the other
                    // flags have a lifetime only of a single render + commit, so we should
                    // ignore them.
                    subtreeFlags |= _child2.subtreeFlags & StaticMask;
                    subtreeFlags |= _child2.flags & StaticMask;
                    _treeBaseDuration += _child2.treeBaseDuration;
                    _child2 = _child2.sibling;
                }
                completedWork.treeBaseDuration = _treeBaseDuration;
            } else {
                var _child3 = completedWork.child;
                while(_child3 !== null){
                    newChildLanes = mergeLanes(newChildLanes, mergeLanes(_child3.lanes, _child3.childLanes)); // "Static" flags share the lifetime of the fiber/hook they belong to,
                    // so we should bubble those up even during a bailout. All the other
                    // flags have a lifetime only of a single render + commit, so we should
                    // ignore them.
                    subtreeFlags |= _child3.subtreeFlags & StaticMask;
                    subtreeFlags |= _child3.flags & StaticMask; // Update the return pointer so the tree is consistent. This is a code
                    // smell because it assumes the commit phase is never concurrent with
                    // the render phase. Will address during refactor to alternate model.
                    _child3.return = completedWork;
                    _child3 = _child3.sibling;
                }
            }
            completedWork.subtreeFlags |= subtreeFlags;
        }
        completedWork.childLanes = newChildLanes;
        return didBailout;
    }
    function completeDehydratedSuspenseBoundary(current, workInProgress, nextState) {
        if (hasUnhydratedTailNodes() && (workInProgress.mode & ConcurrentMode) !== NoMode && (workInProgress.flags & DidCapture) === NoFlags) {
            warnIfUnhydratedTailNodes(workInProgress);
            resetHydrationState();
            workInProgress.flags |= ForceClientRender | Incomplete | ShouldCapture;
            return false;
        }
        var wasHydrated = popHydrationState(workInProgress);
        if (nextState !== null && nextState.dehydrated !== null) {
            // We might be inside a hydration state the first time we're picking up this
            // Suspense boundary, and also after we've reentered it for further hydration.
            if (current === null) {
                if (!wasHydrated) throw new Error("A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.");
                prepareToHydrateHostSuspenseInstance(workInProgress);
                bubbleProperties(workInProgress);
                if ((workInProgress.mode & ProfileMode) !== NoMode) {
                    var isTimedOutSuspense = nextState !== null;
                    if (isTimedOutSuspense) {
                        // Don't count time spent in a timed out Suspense subtree as part of the base duration.
                        var primaryChildFragment = workInProgress.child;
                        if (primaryChildFragment !== null) // $FlowFixMe Flow doesn't support type casting in combination with the -= operator
                        workInProgress.treeBaseDuration -= primaryChildFragment.treeBaseDuration;
                    }
                }
                return false;
            } else {
                // We might have reentered this boundary to hydrate it. If so, we need to reset the hydration
                // state since we're now exiting out of it. popHydrationState doesn't do that for us.
                resetHydrationState();
                if ((workInProgress.flags & DidCapture) === NoFlags) // This boundary did not suspend so it's now hydrated and unsuspended.
                workInProgress.memoizedState = null;
                 // If nothing suspended, we need to schedule an effect to mark this boundary
                // as having hydrated so events know that they're free to be invoked.
                // It's also a signal to replay events and the suspense callback.
                // If something suspended, schedule an effect to attach retry listeners.
                // So we might as well always mark this.
                workInProgress.flags |= Update;
                bubbleProperties(workInProgress);
                if ((workInProgress.mode & ProfileMode) !== NoMode) {
                    var _isTimedOutSuspense = nextState !== null;
                    if (_isTimedOutSuspense) {
                        // Don't count time spent in a timed out Suspense subtree as part of the base duration.
                        var _primaryChildFragment = workInProgress.child;
                        if (_primaryChildFragment !== null) // $FlowFixMe Flow doesn't support type casting in combination with the -= operator
                        workInProgress.treeBaseDuration -= _primaryChildFragment.treeBaseDuration;
                    }
                }
                return false;
            }
        } else {
            // Successfully completed this tree. If this was a forced client render,
            // there may have been recoverable errors during first hydration
            // attempt. If so, add them to a queue so we can log them in the
            // commit phase.
            upgradeHydrationErrorsToRecoverable(); // Fall through to normal Suspense path
            return true;
        }
    }
    function completeWork(current, workInProgress, renderLanes) {
        var newProps = workInProgress.pendingProps; // Note: This intentionally doesn't check if we're hydrating because comparing
        // to the current tree provider fiber is just as fast and less error-prone.
        // Ideally we would have a special version of the work loop only
        // for hydration.
        popTreeContext(workInProgress);
        switch(workInProgress.tag){
            case IndeterminateComponent:
            case LazyComponent:
            case SimpleMemoComponent:
            case FunctionComponent:
            case ForwardRef:
            case Fragment:
            case Mode:
            case Profiler:
            case ContextConsumer:
            case MemoComponent:
                bubbleProperties(workInProgress);
                return null;
            case ClassComponent:
                var Component = workInProgress.type;
                if (isContextProvider(Component)) popContext(workInProgress);
                bubbleProperties(workInProgress);
                return null;
            case HostRoot:
                var fiberRoot = workInProgress.stateNode;
                popHostContainer(workInProgress);
                popTopLevelContextObject(workInProgress);
                resetWorkInProgressVersions();
                if (fiberRoot.pendingContext) {
                    fiberRoot.context = fiberRoot.pendingContext;
                    fiberRoot.pendingContext = null;
                }
                if (current === null || current.child === null) {
                    // If we hydrated, pop so that we can delete any remaining children
                    // that weren't hydrated.
                    var wasHydrated = popHydrationState(workInProgress);
                    if (wasHydrated) // If we hydrated, then we'll need to schedule an update for
                    // the commit side-effects on the root.
                    markUpdate(workInProgress);
                    else if (current !== null) {
                        var prevState = current.memoizedState;
                        if (!prevState.isDehydrated || // Check if we reverted to client rendering (e.g. due to an error)
                        (workInProgress.flags & ForceClientRender) !== NoFlags) {
                            // Schedule an effect to clear this container at the start of the
                            // next commit. This handles the case of React rendering into a
                            // container with previous children. It's also safe to do for
                            // updates too, because current.child would only be null if the
                            // previous render was null (so the container would already
                            // be empty).
                            workInProgress.flags |= Snapshot; // If this was a forced client render, there may have been
                            // recoverable errors during first hydration attempt. If so, add
                            // them to a queue so we can log them in the commit phase.
                            upgradeHydrationErrorsToRecoverable();
                        }
                    }
                }
                updateHostContainer(current, workInProgress);
                bubbleProperties(workInProgress);
                return null;
            case HostComponent:
                popHostContext(workInProgress);
                var rootContainerInstance = getRootHostContainer();
                var type = workInProgress.type;
                if (current !== null && workInProgress.stateNode != null) {
                    updateHostComponent$1(current, workInProgress, type, newProps, rootContainerInstance);
                    if (current.ref !== workInProgress.ref) markRef$1(workInProgress);
                } else {
                    if (!newProps) {
                        if (workInProgress.stateNode === null) throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                         // This can happen when we abort work.
                        bubbleProperties(workInProgress);
                        return null;
                    }
                    var currentHostContext = getHostContext(); // TODO: Move createInstance to beginWork and keep it on a context
                    // "stack" as the parent. Then append children as we go in beginWork
                    // or completeWork depending on whether we want to add them top->down or
                    // bottom->up. Top->down is faster in IE11.
                    var _wasHydrated = popHydrationState(workInProgress);
                    if (_wasHydrated) // TODO: Move this and createInstance step into the beginPhase
                    // to consolidate.
                    {
                        if (prepareToHydrateHostInstance(workInProgress, rootContainerInstance, currentHostContext)) // If changes to the hydrated node need to be applied at the
                        // commit-phase we mark this as such.
                        markUpdate(workInProgress);
                    } else {
                        var instance = createInstance(type, newProps, rootContainerInstance, currentHostContext, workInProgress);
                        appendAllChildren(instance, workInProgress, false, false);
                        workInProgress.stateNode = instance; // Certain renderers require commit-time effects for initial mount.
                        // (eg DOM renderer supports auto-focus for certain elements).
                        // Make sure such renderers get scheduled for later work.
                        if (finalizeInitialChildren(instance, type, newProps, rootContainerInstance)) markUpdate(workInProgress);
                    }
                    if (workInProgress.ref !== null) // If there is a ref on a host node we need to schedule a callback
                    markRef$1(workInProgress);
                }
                bubbleProperties(workInProgress);
                return null;
            case HostText:
                var newText = newProps;
                if (current && workInProgress.stateNode != null) {
                    var oldText = current.memoizedProps; // If we have an alternate, that means this is an update and we need
                    // to schedule a side-effect to do the updates.
                    updateHostText$1(current, workInProgress, oldText, newText);
                } else {
                    if (typeof newText !== 'string') {
                        if (workInProgress.stateNode === null) throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                         // This can happen when we abort work.
                    }
                    var _rootContainerInstance = getRootHostContainer();
                    var _currentHostContext = getHostContext();
                    var _wasHydrated2 = popHydrationState(workInProgress);
                    if (_wasHydrated2) {
                        if (prepareToHydrateHostTextInstance(workInProgress)) markUpdate(workInProgress);
                    } else workInProgress.stateNode = createTextInstance(newText, _rootContainerInstance, _currentHostContext, workInProgress);
                }
                bubbleProperties(workInProgress);
                return null;
            case SuspenseComponent:
                popSuspenseContext(workInProgress);
                var nextState = workInProgress.memoizedState; // Special path for dehydrated boundaries. We may eventually move this
                // to its own fiber type so that we can add other kinds of hydration
                // boundaries that aren't associated with a Suspense tree. In anticipation
                // of such a refactor, all the hydration logic is contained in
                // this branch.
                if (current === null || current.memoizedState !== null && current.memoizedState.dehydrated !== null) {
                    var fallthroughToNormalSuspensePath = completeDehydratedSuspenseBoundary(current, workInProgress, nextState);
                    if (!fallthroughToNormalSuspensePath) {
                        if (workInProgress.flags & ShouldCapture) // Special case. There were remaining unhydrated nodes. We treat
                        // this as a mismatch. Revert to client rendering.
                        return workInProgress;
                        else // Did not finish hydrating, either because this is the initial
                        // render or because something suspended.
                        return null;
                    } // Continue with the normal Suspense path.
                }
                if ((workInProgress.flags & DidCapture) !== NoFlags) {
                    // Something suspended. Re-render with the fallback children.
                    workInProgress.lanes = renderLanes; // Do not reset the effect list.
                    if ((workInProgress.mode & ProfileMode) !== NoMode) transferActualDuration(workInProgress);
                     // Don't bubble properties in this case.
                    return workInProgress;
                }
                var nextDidTimeout = nextState !== null;
                var prevDidTimeout = current !== null && current.memoizedState !== null;
                // a passive effect, which is when we process the transitions
                if (nextDidTimeout !== prevDidTimeout) // an effect to toggle the subtree's visibility. When we switch from
                // fallback -> primary, the inner Offscreen fiber schedules this effect
                // as part of its normal complete phase. But when we switch from
                // primary -> fallback, the inner Offscreen fiber does not have a complete
                // phase. So we need to schedule its effect here.
                //
                // We also use this flag to connect/disconnect the effects, but the same
                // logic applies: when re-connecting, the Offscreen fiber's complete
                // phase will handle scheduling the effect. It's only when the fallback
                // is active that we have to do anything special.
                {
                    if (nextDidTimeout) {
                        var _offscreenFiber2 = workInProgress.child;
                        _offscreenFiber2.flags |= Visibility; // TODO: This will still suspend a synchronous tree if anything
                        // in the concurrent tree already suspended during this render.
                        // This is a known bug.
                        if ((workInProgress.mode & ConcurrentMode) !== NoMode) {
                            // TODO: Move this back to throwException because this is too late
                            // if this is a large tree which is common for initial loads. We
                            // don't know if we should restart a render or not until we get
                            // this marker, and this is too late.
                            // If this render already had a ping or lower pri updates,
                            // and this is the first time we know we're going to suspend we
                            // should be able to immediately restart from within throwException.
                            var hasInvisibleChildContext = current === null && (workInProgress.memoizedProps.unstable_avoidThisFallback !== true || !enableSuspenseAvoidThisFallback);
                            if (hasInvisibleChildContext || hasSuspenseContext(suspenseStackCursor.current, InvisibleParentSuspenseContext)) // If this was in an invisible tree or a new render, then showing
                            // this boundary is ok.
                            renderDidSuspend();
                            else // Otherwise, we're going to have to hide content so we should
                            // suspend for longer if possible.
                            renderDidSuspendDelayIfPossible();
                        }
                    }
                }
                var wakeables = workInProgress.updateQueue;
                if (wakeables !== null) // Schedule an effect to attach a retry listener to the promise.
                // TODO: Move to passive phase
                workInProgress.flags |= Update;
                bubbleProperties(workInProgress);
                if ((workInProgress.mode & ProfileMode) !== NoMode) {
                    if (nextDidTimeout) {
                        // Don't count time spent in a timed out Suspense subtree as part of the base duration.
                        var primaryChildFragment = workInProgress.child;
                        if (primaryChildFragment !== null) // $FlowFixMe Flow doesn't support type casting in combination with the -= operator
                        workInProgress.treeBaseDuration -= primaryChildFragment.treeBaseDuration;
                    }
                }
                return null;
            case HostPortal:
                popHostContainer(workInProgress);
                updateHostContainer(current, workInProgress);
                if (current === null) preparePortalMount(workInProgress.stateNode.containerInfo);
                bubbleProperties(workInProgress);
                return null;
            case ContextProvider:
                // Pop provider fiber
                var context = workInProgress.type._context;
                popProvider(context, workInProgress);
                bubbleProperties(workInProgress);
                return null;
            case IncompleteClassComponent:
                // Same as class component case. I put it down here so that the tags are
                // sequential to ensure this switch is compiled to a jump table.
                var _Component = workInProgress.type;
                if (isContextProvider(_Component)) popContext(workInProgress);
                bubbleProperties(workInProgress);
                return null;
            case SuspenseListComponent:
                popSuspenseContext(workInProgress);
                var renderState = workInProgress.memoizedState;
                if (renderState === null) {
                    // We're running in the default, "independent" mode.
                    // We don't do anything in this mode.
                    bubbleProperties(workInProgress);
                    return null;
                }
                var didSuspendAlready = (workInProgress.flags & DidCapture) !== NoFlags;
                var renderedTail = renderState.rendering;
                if (renderedTail === null) {
                    // We just rendered the head.
                    if (!didSuspendAlready) {
                        // This is the first pass. We need to figure out if anything is still
                        // suspended in the rendered set.
                        // If new content unsuspended, but there's still some content that
                        // didn't. Then we need to do a second pass that forces everything
                        // to keep showing their fallbacks.
                        // We might be suspended if something in this render pass suspended, or
                        // something in the previous committed pass suspended. Otherwise,
                        // there's no chance so we can skip the expensive call to
                        // findFirstSuspended.
                        var cannotBeSuspended = renderHasNotSuspendedYet() && (current === null || (current.flags & DidCapture) === NoFlags);
                        if (!cannotBeSuspended) {
                            var row = workInProgress.child;
                            while(row !== null){
                                var suspended = findFirstSuspended(row);
                                if (suspended !== null) {
                                    didSuspendAlready = true;
                                    workInProgress.flags |= DidCapture;
                                    cutOffTailIfNeeded(renderState, false); // If this is a newly suspended tree, it might not get committed as
                                    // part of the second pass. In that case nothing will subscribe to
                                    // its thenables. Instead, we'll transfer its thenables to the
                                    // SuspenseList so that it can retry if they resolve.
                                    // There might be multiple of these in the list but since we're
                                    // going to wait for all of them anyway, it doesn't really matter
                                    // which ones gets to ping. In theory we could get clever and keep
                                    // track of how many dependencies remain but it gets tricky because
                                    // in the meantime, we can add/remove/change items and dependencies.
                                    // We might bail out of the loop before finding any but that
                                    // doesn't matter since that means that the other boundaries that
                                    // we did find already has their listeners attached.
                                    var newThenables = suspended.updateQueue;
                                    if (newThenables !== null) {
                                        workInProgress.updateQueue = newThenables;
                                        workInProgress.flags |= Update;
                                    } // Rerender the whole list, but this time, we'll force fallbacks
                                    // to stay in place.
                                    // Reset the effect flags before doing the second pass since that's now invalid.
                                    // Reset the child fibers to their original state.
                                    workInProgress.subtreeFlags = NoFlags;
                                    resetChildFibers(workInProgress, renderLanes); // Set up the Suspense Context to force suspense and immediately
                                    // rerender the children.
                                    pushSuspenseContext(workInProgress, setShallowSuspenseContext(suspenseStackCursor.current, ForceSuspenseFallback)); // Don't bubble properties in this case.
                                    return workInProgress.child;
                                }
                                row = row.sibling;
                            }
                        }
                        if (renderState.tail !== null && now() > getRenderTargetTime()) {
                            // We have already passed our CPU deadline but we still have rows
                            // left in the tail. We'll just give up further attempts to render
                            // the main content and only render fallbacks.
                            workInProgress.flags |= DidCapture;
                            didSuspendAlready = true;
                            cutOffTailIfNeeded(renderState, false); // Since nothing actually suspended, there will nothing to ping this
                            // to get it started back up to attempt the next item. While in terms
                            // of priority this work has the same priority as this current render,
                            // it's not part of the same transition once the transition has
                            // committed. If it's sync, we still want to yield so that it can be
                            // painted. Conceptually, this is really the same as pinging.
                            // We can use any RetryLane even if it's the one currently rendering
                            // since we're leaving it behind on this node.
                            workInProgress.lanes = SomeRetryLane;
                        }
                    } else cutOffTailIfNeeded(renderState, false);
                     // Next we're going to render the tail.
                } else {
                    // Append the rendered row to the child list.
                    if (!didSuspendAlready) {
                        var _suspended = findFirstSuspended(renderedTail);
                        if (_suspended !== null) {
                            workInProgress.flags |= DidCapture;
                            didSuspendAlready = true; // Ensure we transfer the update queue to the parent so that it doesn't
                            // get lost if this row ends up dropped during a second pass.
                            var _newThenables = _suspended.updateQueue;
                            if (_newThenables !== null) {
                                workInProgress.updateQueue = _newThenables;
                                workInProgress.flags |= Update;
                            }
                            cutOffTailIfNeeded(renderState, true); // This might have been modified.
                            if (renderState.tail === null && renderState.tailMode === 'hidden' && !renderedTail.alternate && !getIsHydrating() // We don't cut it if we're hydrating.
                            ) {
                                // We're done.
                                bubbleProperties(workInProgress);
                                return null;
                            }
                        } else if (// time we have to render. So rendering one more row would likely
                        // exceed it.
                        now() * 2 - renderState.renderingStartTime > getRenderTargetTime() && renderLanes !== OffscreenLane) {
                            // We have now passed our CPU deadline and we'll just give up further
                            // attempts to render the main content and only render fallbacks.
                            // The assumption is that this is usually faster.
                            workInProgress.flags |= DidCapture;
                            didSuspendAlready = true;
                            cutOffTailIfNeeded(renderState, false); // Since nothing actually suspended, there will nothing to ping this
                            // to get it started back up to attempt the next item. While in terms
                            // of priority this work has the same priority as this current render,
                            // it's not part of the same transition once the transition has
                            // committed. If it's sync, we still want to yield so that it can be
                            // painted. Conceptually, this is really the same as pinging.
                            // We can use any RetryLane even if it's the one currently rendering
                            // since we're leaving it behind on this node.
                            workInProgress.lanes = SomeRetryLane;
                        }
                    }
                    if (renderState.isBackwards) {
                        // The effect list of the backwards tail will have been added
                        // to the end. This breaks the guarantee that life-cycles fire in
                        // sibling order but that isn't a strong guarantee promised by React.
                        // Especially since these might also just pop in during future commits.
                        // Append to the beginning of the list.
                        renderedTail.sibling = workInProgress.child;
                        workInProgress.child = renderedTail;
                    } else {
                        var previousSibling = renderState.last;
                        if (previousSibling !== null) previousSibling.sibling = renderedTail;
                        else workInProgress.child = renderedTail;
                        renderState.last = renderedTail;
                    }
                }
                if (renderState.tail !== null) {
                    // We still have tail rows to render.
                    // Pop a row.
                    var next = renderState.tail;
                    renderState.rendering = next;
                    renderState.tail = next.sibling;
                    renderState.renderingStartTime = now();
                    next.sibling = null; // Restore the context.
                    // TODO: We can probably just avoid popping it instead and only
                    // setting it the first time we go from not suspended to suspended.
                    var suspenseContext = suspenseStackCursor.current;
                    if (didSuspendAlready) suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
                    else suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
                    pushSuspenseContext(workInProgress, suspenseContext); // Do a pass over the next row.
                    // Don't bubble properties in this case.
                    return next;
                }
                bubbleProperties(workInProgress);
                return null;
            case ScopeComponent:
                break;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                popRenderLanes(workInProgress);
                var _nextState = workInProgress.memoizedState;
                var nextIsHidden = _nextState !== null;
                if (current !== null) {
                    var _prevState = current.memoizedState;
                    var prevIsHidden = _prevState !== null;
                    if (prevIsHidden !== nextIsHidden && !enableLegacyHidden) workInProgress.flags |= Visibility;
                }
                if (!nextIsHidden || (workInProgress.mode & ConcurrentMode) === NoMode) bubbleProperties(workInProgress);
                else // Don't bubble properties for hidden children unless we're rendering
                // at offscreen priority.
                if (includesSomeLane(subtreeRenderLanes, OffscreenLane)) {
                    bubbleProperties(workInProgress);
                    // Check if there was an insertion or update in the hidden subtree.
                    // If so, we need to hide those nodes in the commit phase, so
                    // schedule a visibility effect.
                    if (workInProgress.subtreeFlags & (Placement | Update)) workInProgress.flags |= Visibility;
                }
                return null;
            case CacheComponent:
                return null;
            case TracingMarkerComponent:
                return null;
        }
        throw new Error("Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in " + 'React. Please file an issue.');
    }
    function unwindWork(current, workInProgress, renderLanes) {
        // Note: This intentionally doesn't check if we're hydrating because comparing
        // to the current tree provider fiber is just as fast and less error-prone.
        // Ideally we would have a special version of the work loop only
        // for hydration.
        popTreeContext(workInProgress);
        switch(workInProgress.tag){
            case ClassComponent:
                var Component = workInProgress.type;
                if (isContextProvider(Component)) popContext(workInProgress);
                var flags = workInProgress.flags;
                if (flags & ShouldCapture) {
                    workInProgress.flags = flags & ~ShouldCapture | DidCapture;
                    if ((workInProgress.mode & ProfileMode) !== NoMode) transferActualDuration(workInProgress);
                    return workInProgress;
                }
                return null;
            case HostRoot:
                var root = workInProgress.stateNode;
                popHostContainer(workInProgress);
                popTopLevelContextObject(workInProgress);
                resetWorkInProgressVersions();
                var _flags = workInProgress.flags;
                if ((_flags & ShouldCapture) !== NoFlags && (_flags & DidCapture) === NoFlags) {
                    // There was an error during render that wasn't captured by a suspense
                    // boundary. Do a second pass on the root to unmount the children.
                    workInProgress.flags = _flags & ~ShouldCapture | DidCapture;
                    return workInProgress;
                } // We unwound to the root without completing it. Exit.
                return null;
            case HostComponent:
                // TODO: popHydrationState
                popHostContext(workInProgress);
                return null;
            case SuspenseComponent:
                popSuspenseContext(workInProgress);
                var suspenseState = workInProgress.memoizedState;
                if (suspenseState !== null && suspenseState.dehydrated !== null) {
                    if (workInProgress.alternate === null) throw new Error("Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.");
                    resetHydrationState();
                }
                var _flags2 = workInProgress.flags;
                if (_flags2 & ShouldCapture) {
                    workInProgress.flags = _flags2 & ~ShouldCapture | DidCapture; // Captured a suspense effect. Re-render the boundary.
                    if ((workInProgress.mode & ProfileMode) !== NoMode) transferActualDuration(workInProgress);
                    return workInProgress;
                }
                return null;
            case SuspenseListComponent:
                popSuspenseContext(workInProgress); // SuspenseList doesn't actually catch anything. It should've been
                // caught by a nested boundary. If not, it should bubble through.
                return null;
            case HostPortal:
                popHostContainer(workInProgress);
                return null;
            case ContextProvider:
                var context = workInProgress.type._context;
                popProvider(context, workInProgress);
                return null;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                popRenderLanes(workInProgress);
                return null;
            case CacheComponent:
                return null;
            default:
                return null;
        }
    }
    function unwindInterruptedWork(current, interruptedWork, renderLanes) {
        // Note: This intentionally doesn't check if we're hydrating because comparing
        // to the current tree provider fiber is just as fast and less error-prone.
        // Ideally we would have a special version of the work loop only
        // for hydration.
        popTreeContext(interruptedWork);
        switch(interruptedWork.tag){
            case ClassComponent:
                var childContextTypes = interruptedWork.type.childContextTypes;
                if (childContextTypes !== null && childContextTypes !== undefined) popContext(interruptedWork);
                break;
            case HostRoot:
                var root = interruptedWork.stateNode;
                popHostContainer(interruptedWork);
                popTopLevelContextObject(interruptedWork);
                resetWorkInProgressVersions();
                break;
            case HostComponent:
                popHostContext(interruptedWork);
                break;
            case HostPortal:
                popHostContainer(interruptedWork);
                break;
            case SuspenseComponent:
                popSuspenseContext(interruptedWork);
                break;
            case SuspenseListComponent:
                popSuspenseContext(interruptedWork);
                break;
            case ContextProvider:
                var context = interruptedWork.type._context;
                popProvider(context, interruptedWork);
                break;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                popRenderLanes(interruptedWork);
                break;
        }
    }
    var didWarnAboutUndefinedSnapshotBeforeUpdate = null;
    didWarnAboutUndefinedSnapshotBeforeUpdate = new Set();
    // Allows us to avoid traversing the return path to find the nearest Offscreen ancestor.
    // Only used when enableSuspenseLayoutEffectSemantics is enabled.
    var offscreenSubtreeIsHidden = false;
    var offscreenSubtreeWasHidden = false;
    var PossiblyWeakSet = typeof WeakSet === 'function' ? WeakSet : Set;
    var nextEffect = null; // Used for Profiling builds to track updaters.
    var inProgressLanes = null;
    var inProgressRoot = null;
    function reportUncaughtErrorInDEV(error) {
        invokeGuardedCallback(null, function() {
            throw error;
        });
        clearCaughtError();
    }
    var callComponentWillUnmountWithTimer = function callComponentWillUnmountWithTimer(current, instance) {
        instance.props = current.memoizedProps;
        instance.state = current.memoizedState;
        if (current.mode & ProfileMode) try {
            startLayoutEffectTimer();
            instance.componentWillUnmount();
        } finally{
            recordLayoutEffectDuration(current);
        }
        else instance.componentWillUnmount();
    }; // Capture errors so they don't interrupt mounting.
    function safelyCallCommitHookLayoutEffectListMount(current, nearestMountedAncestor) {
        try {
            commitHookEffectListMount(Layout, current);
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    } // Capture errors so they don't interrupt unmounting.
    function safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
        try {
            callComponentWillUnmountWithTimer(current, instance);
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    } // Capture errors so they don't interrupt mounting.
    function safelyCallComponentDidMount(current, nearestMountedAncestor, instance) {
        try {
            instance.componentDidMount();
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    } // Capture errors so they don't interrupt mounting.
    function safelyAttachRef(current, nearestMountedAncestor) {
        try {
            commitAttachRef(current);
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    }
    function safelyDetachRef(current, nearestMountedAncestor) {
        var ref = current.ref;
        if (ref !== null) {
            if (typeof ref === 'function') {
                var retVal;
                try {
                    if (enableProfilerTimer && enableProfilerCommitHooks && current.mode & ProfileMode) try {
                        startLayoutEffectTimer();
                        retVal = ref(null);
                    } finally{
                        recordLayoutEffectDuration(current);
                    }
                    else retVal = ref(null);
                } catch (error) {
                    captureCommitPhaseError(current, nearestMountedAncestor, error);
                }
                if (typeof retVal === 'function') error("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", getComponentNameFromFiber(current));
            } else ref.current = null;
        }
    }
    function safelyCallDestroy(current, nearestMountedAncestor, destroy) {
        try {
            destroy();
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    }
    var focusedInstanceHandle = null;
    var shouldFireAfterActiveInstanceBlur = false;
    function commitBeforeMutationEffects(root, firstChild) {
        focusedInstanceHandle = prepareForCommit(root.containerInfo);
        nextEffect = firstChild;
        commitBeforeMutationEffects_begin(); // We no longer need to track the active instance fiber
        var shouldFire = shouldFireAfterActiveInstanceBlur;
        shouldFireAfterActiveInstanceBlur = false;
        focusedInstanceHandle = null;
        return shouldFire;
    }
    function commitBeforeMutationEffects_begin() {
        while(nextEffect !== null){
            var fiber = nextEffect; // This phase is only used for beforeActiveInstanceBlur.
            var child = fiber.child;
            if ((fiber.subtreeFlags & BeforeMutationMask) !== NoFlags && child !== null) {
                child.return = fiber;
                nextEffect = child;
            } else commitBeforeMutationEffects_complete();
        }
    }
    function commitBeforeMutationEffects_complete() {
        while(nextEffect !== null){
            var fiber = nextEffect;
            setCurrentFiber(fiber);
            try {
                commitBeforeMutationEffectsOnFiber(fiber);
            } catch (error) {
                captureCommitPhaseError(fiber, fiber.return, error);
            }
            resetCurrentFiber();
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function commitBeforeMutationEffectsOnFiber(finishedWork) {
        var current = finishedWork.alternate;
        var flags = finishedWork.flags;
        if ((flags & Snapshot) !== NoFlags) {
            setCurrentFiber(finishedWork);
            switch(finishedWork.tag){
                case FunctionComponent:
                case ForwardRef:
                case SimpleMemoComponent:
                    break;
                case ClassComponent:
                    if (current !== null) {
                        var prevProps = current.memoizedProps;
                        var prevState = current.memoizedState;
                        var instance = finishedWork.stateNode; // We could update instance props and state here,
                        if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                            if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || 'instance');
                            if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || 'instance');
                        }
                        var snapshot = instance.getSnapshotBeforeUpdate(finishedWork.elementType === finishedWork.type ? prevProps : resolveDefaultProps(finishedWork.type, prevProps), prevState);
                        var didWarnSet = didWarnAboutUndefinedSnapshotBeforeUpdate;
                        if (snapshot === undefined && !didWarnSet.has(finishedWork.type)) {
                            didWarnSet.add(finishedWork.type);
                            error("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", getComponentNameFromFiber(finishedWork));
                        }
                        instance.__reactInternalSnapshotBeforeUpdate = snapshot;
                    }
                    break;
                case HostRoot:
                    var root = finishedWork.stateNode;
                    clearContainer(root.containerInfo);
                    break;
                case HostComponent:
                case HostText:
                case HostPortal:
                case IncompleteClassComponent:
                    break;
                default:
                    throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
            }
            resetCurrentFiber();
        }
    }
    function commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor) {
        var updateQueue = finishedWork.updateQueue;
        var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;
        if (lastEffect !== null) {
            var firstEffect = lastEffect.next;
            var effect = firstEffect;
            do {
                if ((effect.tag & flags) === flags) {
                    // Unmount
                    var destroy = effect.destroy;
                    effect.destroy = undefined;
                    if (destroy !== undefined) {
                        if ((flags & Passive$1) !== NoFlags$1) markComponentPassiveEffectUnmountStarted(finishedWork);
                        else if ((flags & Layout) !== NoFlags$1) markComponentLayoutEffectUnmountStarted(finishedWork);
                        if ((flags & Insertion) !== NoFlags$1) setIsRunningInsertionEffect(true);
                        safelyCallDestroy(finishedWork, nearestMountedAncestor, destroy);
                        if ((flags & Insertion) !== NoFlags$1) setIsRunningInsertionEffect(false);
                        if ((flags & Passive$1) !== NoFlags$1) markComponentPassiveEffectUnmountStopped();
                        else if ((flags & Layout) !== NoFlags$1) markComponentLayoutEffectUnmountStopped();
                    }
                }
                effect = effect.next;
            }while (effect !== firstEffect);
        }
    }
    function commitHookEffectListMount(flags, finishedWork) {
        var updateQueue = finishedWork.updateQueue;
        var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;
        if (lastEffect !== null) {
            var firstEffect = lastEffect.next;
            var effect = firstEffect;
            do {
                if ((effect.tag & flags) === flags) {
                    if ((flags & Passive$1) !== NoFlags$1) markComponentPassiveEffectMountStarted(finishedWork);
                    else if ((flags & Layout) !== NoFlags$1) markComponentLayoutEffectMountStarted(finishedWork);
                    var create = effect.create;
                    if ((flags & Insertion) !== NoFlags$1) setIsRunningInsertionEffect(true);
                    effect.destroy = create();
                    if ((flags & Insertion) !== NoFlags$1) setIsRunningInsertionEffect(false);
                    if ((flags & Passive$1) !== NoFlags$1) markComponentPassiveEffectMountStopped();
                    else if ((flags & Layout) !== NoFlags$1) markComponentLayoutEffectMountStopped();
                    var destroy = effect.destroy;
                    if (destroy !== undefined && typeof destroy !== 'function') {
                        var hookName = void 0;
                        if ((effect.tag & Layout) !== NoFlags) hookName = 'useLayoutEffect';
                        else if ((effect.tag & Insertion) !== NoFlags) hookName = 'useInsertionEffect';
                        else hookName = 'useEffect';
                        var addendum = void 0;
                        if (destroy === null) addendum = " You returned null. If your effect does not require clean up, return undefined (or nothing).";
                        else if (typeof destroy.then === 'function') addendum = '\n\nIt looks like you wrote ' + hookName + '(async () => ...) or returned a Promise. ' + 'Instead, write the async function inside your effect ' + 'and call it immediately:\n\n' + hookName + '(() => {\n' + '  async function fetchData() {\n' + '    // You can await here\n' + '    const response = await MyAPI.getData(someId);\n' + '    // ...\n' + '  }\n' + '  fetchData();\n' + "}, [someId]); // Or [] if effect doesn't need props or state\n\n" + 'Learn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching';
                        else addendum = ' You returned: ' + destroy;
                        error("%s must not return anything besides a function, which is used for clean-up.%s", hookName, addendum);
                    }
                }
                effect = effect.next;
            }while (effect !== firstEffect);
        }
    }
    function commitPassiveEffectDurations(finishedRoot, finishedWork) {
        // Only Profilers with work in their subtree will have an Update effect scheduled.
        if ((finishedWork.flags & Update) !== NoFlags) switch(finishedWork.tag){
            case Profiler:
                var passiveEffectDuration = finishedWork.stateNode.passiveEffectDuration;
                var _finishedWork$memoize = finishedWork.memoizedProps, id = _finishedWork$memoize.id, onPostCommit = _finishedWork$memoize.onPostCommit; // This value will still reflect the previous commit phase.
                // It does not get reset until the start of the next commit phase.
                var commitTime = getCommitTime();
                var phase = finishedWork.alternate === null ? 'mount' : 'update';
                if (isCurrentUpdateNested()) phase = 'nested-update';
                if (typeof onPostCommit === 'function') onPostCommit(id, phase, passiveEffectDuration, commitTime);
                 // Bubble times to the next nearest ancestor Profiler.
                // After we process that Profiler, we'll bubble further up.
                var parentFiber = finishedWork.return;
                outer: while(parentFiber !== null){
                    switch(parentFiber.tag){
                        case HostRoot:
                            var root = parentFiber.stateNode;
                            root.passiveEffectDuration += passiveEffectDuration;
                            break outer;
                        case Profiler:
                            var parentStateNode = parentFiber.stateNode;
                            parentStateNode.passiveEffectDuration += passiveEffectDuration;
                            break outer;
                    }
                    parentFiber = parentFiber.return;
                }
                break;
        }
    }
    function commitLayoutEffectOnFiber(finishedRoot, current, finishedWork, committedLanes) {
        if ((finishedWork.flags & LayoutMask) !== NoFlags) switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (!offscreenSubtreeWasHidden) {
                    // At this point layout effects have already been destroyed (during mutation phase).
                    // This is done to prevent sibling component effects from interfering with each other,
                    // e.g. a destroy function in one component should never override a ref set
                    // by a create function in another component during the same commit.
                    if (finishedWork.mode & ProfileMode) try {
                        startLayoutEffectTimer();
                        commitHookEffectListMount(Layout | HasEffect, finishedWork);
                    } finally{
                        recordLayoutEffectDuration(finishedWork);
                    }
                    else commitHookEffectListMount(Layout | HasEffect, finishedWork);
                }
                break;
            case ClassComponent:
                var instance = finishedWork.stateNode;
                if (finishedWork.flags & Update) {
                    if (!offscreenSubtreeWasHidden) {
                        if (current === null) {
                            if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                                if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || 'instance');
                                if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || 'instance');
                            }
                            if (finishedWork.mode & ProfileMode) try {
                                startLayoutEffectTimer();
                                instance.componentDidMount();
                            } finally{
                                recordLayoutEffectDuration(finishedWork);
                            }
                            else instance.componentDidMount();
                        } else {
                            var prevProps = finishedWork.elementType === finishedWork.type ? current.memoizedProps : resolveDefaultProps(finishedWork.type, current.memoizedProps);
                            var prevState = current.memoizedState; // We could update instance props and state here,
                            if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                                if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || 'instance');
                                if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || 'instance');
                            }
                            if (finishedWork.mode & ProfileMode) try {
                                startLayoutEffectTimer();
                                instance.componentDidUpdate(prevProps, prevState, instance.__reactInternalSnapshotBeforeUpdate);
                            } finally{
                                recordLayoutEffectDuration(finishedWork);
                            }
                            else instance.componentDidUpdate(prevProps, prevState, instance.__reactInternalSnapshotBeforeUpdate);
                        }
                    }
                } // TODO: I think this is now always non-null by the time it reaches the
                // commit phase. Consider removing the type check.
                var updateQueue = finishedWork.updateQueue;
                if (updateQueue !== null) {
                    if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                        if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || 'instance');
                        if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || 'instance');
                    }
                    // but instead we rely on them being set during last render.
                    // TODO: revisit this when we implement resuming.
                    commitUpdateQueue(finishedWork, updateQueue, instance);
                }
                break;
            case HostRoot:
                // TODO: I think this is now always non-null by the time it reaches the
                // commit phase. Consider removing the type check.
                var _updateQueue = finishedWork.updateQueue;
                if (_updateQueue !== null) {
                    var _instance = null;
                    if (finishedWork.child !== null) switch(finishedWork.child.tag){
                        case HostComponent:
                            _instance = getPublicInstance(finishedWork.child.stateNode);
                            break;
                        case ClassComponent:
                            _instance = finishedWork.child.stateNode;
                            break;
                    }
                    commitUpdateQueue(finishedWork, _updateQueue, _instance);
                }
                break;
            case HostComponent:
                var _instance2 = finishedWork.stateNode; // Renderers may schedule work to be done after host components are mounted
                // (eg DOM renderer may schedule auto-focus for inputs and form controls).
                // These effects should only be committed when components are first mounted,
                // aka when there is no current/alternate.
                if (current === null && finishedWork.flags & Update) {
                    var type = finishedWork.type;
                    var props = finishedWork.memoizedProps;
                    commitMount(_instance2, type, props);
                }
                break;
            case HostText:
                break;
            case HostPortal:
                break;
            case Profiler:
                var _finishedWork$memoize2 = finishedWork.memoizedProps, onCommit = _finishedWork$memoize2.onCommit, onRender = _finishedWork$memoize2.onRender;
                var effectDuration = finishedWork.stateNode.effectDuration;
                var commitTime = getCommitTime();
                var phase = current === null ? 'mount' : 'update';
                if (isCurrentUpdateNested()) phase = 'nested-update';
                if (typeof onRender === 'function') onRender(finishedWork.memoizedProps.id, phase, finishedWork.actualDuration, finishedWork.treeBaseDuration, finishedWork.actualStartTime, commitTime);
                if (typeof onCommit === 'function') onCommit(finishedWork.memoizedProps.id, phase, effectDuration, commitTime);
                 // Schedule a passive effect for this Profiler to call onPostCommit hooks.
                // This effect should be scheduled even if there is no onPostCommit callback for this Profiler,
                // because the effect is also where times bubble to parent Profilers.
                enqueuePendingPassiveProfilerEffect(finishedWork); // Propagate layout effect durations to the next nearest Profiler ancestor.
                // Do not reset these values until the next render so DevTools has a chance to read them first.
                var parentFiber = finishedWork.return;
                outer: while(parentFiber !== null){
                    switch(parentFiber.tag){
                        case HostRoot:
                            var root = parentFiber.stateNode;
                            root.effectDuration += effectDuration;
                            break outer;
                        case Profiler:
                            var parentStateNode = parentFiber.stateNode;
                            parentStateNode.effectDuration += effectDuration;
                            break outer;
                    }
                    parentFiber = parentFiber.return;
                }
                break;
            case SuspenseComponent:
                commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case SuspenseListComponent:
            case IncompleteClassComponent:
            case ScopeComponent:
            case OffscreenComponent:
            case LegacyHiddenComponent:
            case TracingMarkerComponent:
                break;
            default:
                throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
        if (!offscreenSubtreeWasHidden) {
            if (finishedWork.flags & Ref) commitAttachRef(finishedWork);
        }
    }
    function reappearLayoutEffectsOnFiber(node) {
        // Turn on layout effects in a tree that previously disappeared.
        // TODO (Offscreen) Check: flags & LayoutStatic
        switch(node.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (node.mode & ProfileMode) try {
                    startLayoutEffectTimer();
                    safelyCallCommitHookLayoutEffectListMount(node, node.return);
                } finally{
                    recordLayoutEffectDuration(node);
                }
                else safelyCallCommitHookLayoutEffectListMount(node, node.return);
                break;
            case ClassComponent:
                var instance = node.stateNode;
                if (typeof instance.componentDidMount === 'function') safelyCallComponentDidMount(node, node.return, instance);
                safelyAttachRef(node, node.return);
                break;
            case HostComponent:
                safelyAttachRef(node, node.return);
                break;
        }
    }
    function hideOrUnhideAllChildren(finishedWork, isHidden) {
        // Only hide or unhide the top-most host nodes.
        var hostSubtreeRoot = null;
        // We only have the top Fiber that was inserted but we need to recurse down its
        // children to find all the terminal nodes.
        var node = finishedWork;
        while(true){
            if (node.tag === HostComponent) {
                if (hostSubtreeRoot === null) {
                    hostSubtreeRoot = node;
                    try {
                        var instance = node.stateNode;
                        if (isHidden) hideInstance(instance);
                        else unhideInstance(node.stateNode, node.memoizedProps);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
            } else if (node.tag === HostText) {
                if (hostSubtreeRoot === null) try {
                    var _instance3 = node.stateNode;
                    if (isHidden) hideTextInstance(_instance3);
                    else unhideTextInstance(_instance3, node.memoizedProps);
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else if ((node.tag === OffscreenComponent || node.tag === LegacyHiddenComponent) && node.memoizedState !== null && node !== finishedWork) ;
            else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === finishedWork) return;
            while(node.sibling === null){
                if (node.return === null || node.return === finishedWork) return;
                if (hostSubtreeRoot === node) hostSubtreeRoot = null;
                node = node.return;
            }
            if (hostSubtreeRoot === node) hostSubtreeRoot = null;
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    function commitAttachRef(finishedWork) {
        var ref = finishedWork.ref;
        if (ref !== null) {
            var instance = finishedWork.stateNode;
            var instanceToUse;
            switch(finishedWork.tag){
                case HostComponent:
                    instanceToUse = getPublicInstance(instance);
                    break;
                default:
                    instanceToUse = instance;
            } // Moved outside to ensure DCE works with this flag
            if (typeof ref === 'function') {
                var retVal;
                if (finishedWork.mode & ProfileMode) try {
                    startLayoutEffectTimer();
                    retVal = ref(instanceToUse);
                } finally{
                    recordLayoutEffectDuration(finishedWork);
                }
                else retVal = ref(instanceToUse);
                if (typeof retVal === 'function') error("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", getComponentNameFromFiber(finishedWork));
            } else {
                if (!ref.hasOwnProperty('current')) error("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().", getComponentNameFromFiber(finishedWork));
                ref.current = instanceToUse;
            }
        }
    }
    function detachFiberMutation(fiber) {
        // Cut off the return pointer to disconnect it from the tree.
        // This enables us to detect and warn against state updates on an unmounted component.
        // It also prevents events from bubbling from within disconnected components.
        //
        // Ideally, we should also clear the child pointer of the parent alternate to let this
        // get GC:ed but we don't know which for sure which parent is the current
        // one so we'll settle for GC:ing the subtree of this child.
        // This child itself will be GC:ed when the parent updates the next time.
        //
        // Note that we can't clear child or sibling pointers yet.
        // They're needed for passive effects and for findDOMNode.
        // We defer those fields, and all other cleanup, to the passive phase (see detachFiberAfterEffects).
        //
        // Don't reset the alternate yet, either. We need that so we can detach the
        // alternate's fields in the passive phase. Clearing the return pointer is
        // sufficient for findDOMNode semantics.
        var alternate = fiber.alternate;
        if (alternate !== null) alternate.return = null;
        fiber.return = null;
    }
    function detachFiberAfterEffects(fiber) {
        var alternate = fiber.alternate;
        if (alternate !== null) {
            fiber.alternate = null;
            detachFiberAfterEffects(alternate);
        } // Note: Defensively using negation instead of < in case
        // Clear cyclical Fiber fields. This level alone is designed to roughly
        // approximate the planned Fiber refactor. In that world, `setState` will be
        // bound to a special "instance" object instead of a Fiber. The Instance
        // object will not have any of these fields. It will only be connected to
        // the fiber tree via a single link at the root. So if this level alone is
        // sufficient to fix memory issues, that bodes well for our plans.
        fiber.child = null;
        fiber.deletions = null;
        fiber.sibling = null; // The `stateNode` is cyclical because on host nodes it points to the host
        // tree, which has its own pointers to children, parents, and siblings.
        // The other host nodes also point back to fibers, so we should detach that
        // one, too.
        if (fiber.tag === HostComponent) {
            var hostInstance = fiber.stateNode;
            if (hostInstance !== null) detachDeletedInstance(hostInstance);
        }
        fiber.stateNode = null; // I'm intentionally not clearing the `return` field in this level. We
        fiber._debugOwner = null;
        // Theoretically, nothing in here should be necessary, because we already
        // disconnected the fiber from the tree. So even if something leaks this
        // particular fiber, it won't leak anything else
        //
        // The purpose of this branch is to be super aggressive so we can measure
        // if there's any difference in memory impact. If there is, that could
        // indicate a React leak we don't know about.
        fiber.return = null;
        fiber.dependencies = null;
        fiber.memoizedProps = null;
        fiber.memoizedState = null;
        fiber.pendingProps = null;
        fiber.stateNode = null; // TODO: Move to `commitPassiveUnmountInsideDeletedTreeOnFiber` instead.
        fiber.updateQueue = null;
    }
    function getHostParentFiber(fiber) {
        var parent = fiber.return;
        while(parent !== null){
            if (isHostParent(parent)) return parent;
            parent = parent.return;
        }
        throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    function isHostParent(fiber) {
        return fiber.tag === HostComponent || fiber.tag === HostRoot || fiber.tag === HostPortal;
    }
    function getHostSibling(fiber) {
        // We're going to search forward into the tree until we find a sibling host
        // node. Unfortunately, if multiple insertions are done in a row we have to
        // search past them. This leads to exponential search for the next sibling.
        // TODO: Find a more efficient way to do this.
        var node = fiber;
        siblings: while(true){
            // If we didn't find anything, let's try the next sibling.
            while(node.sibling === null){
                if (node.return === null || isHostParent(node.return)) // If we pop out of the root or hit the parent the fiber we are the
                // last sibling.
                return null;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
            while(node.tag !== HostComponent && node.tag !== HostText && node.tag !== DehydratedFragment){
                // If it is not host node and, we might have a host node inside it.
                // Try to search down until we find one.
                if (node.flags & Placement) continue siblings;
                 // If we don't have a child, try the siblings instead.
                // We also skip portals because they are not part of this host tree.
                if (node.child === null || node.tag === HostPortal) continue siblings;
                else {
                    node.child.return = node;
                    node = node.child;
                }
            } // Check if this host node is stable or about to be placed.
            if (!(node.flags & Placement)) // Found it!
            return node.stateNode;
        }
    }
    function commitPlacement(finishedWork) {
        var parentFiber = getHostParentFiber(finishedWork); // Note: these two variables *must* always be updated together.
        switch(parentFiber.tag){
            case HostComponent:
                var parent = parentFiber.stateNode;
                if (parentFiber.flags & ContentReset) {
                    // Reset the text content of the parent before doing any insertions
                    resetTextContent(parent); // Clear ContentReset from the effect tag
                    parentFiber.flags &= ~ContentReset;
                }
                var before = getHostSibling(finishedWork); // We only have the top Fiber that was inserted but we need to recurse down its
                // children to find all the terminal nodes.
                insertOrAppendPlacementNode(finishedWork, before, parent);
                break;
            case HostRoot:
            case HostPortal:
                var _parent = parentFiber.stateNode.containerInfo;
                var _before = getHostSibling(finishedWork);
                insertOrAppendPlacementNodeIntoContainer(finishedWork, _before, _parent);
                break;
            // eslint-disable-next-line-no-fallthrough
            default:
                throw new Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
        }
    }
    function insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
        var tag = node.tag;
        var isHost = tag === HostComponent || tag === HostText;
        if (isHost) {
            var stateNode = node.stateNode;
            if (before) insertInContainerBefore(parent, stateNode, before);
            else appendChildToContainer(parent, stateNode);
        } else if (tag === HostPortal) ;
        else {
            var child = node.child;
            if (child !== null) {
                insertOrAppendPlacementNodeIntoContainer(child, before, parent);
                var sibling = child.sibling;
                while(sibling !== null){
                    insertOrAppendPlacementNodeIntoContainer(sibling, before, parent);
                    sibling = sibling.sibling;
                }
            }
        }
    }
    function insertOrAppendPlacementNode(node, before, parent) {
        var tag = node.tag;
        var isHost = tag === HostComponent || tag === HostText;
        if (isHost) {
            var stateNode = node.stateNode;
            if (before) insertBefore(parent, stateNode, before);
            else appendChild(parent, stateNode);
        } else if (tag === HostPortal) ;
        else {
            var child = node.child;
            if (child !== null) {
                insertOrAppendPlacementNode(child, before, parent);
                var sibling = child.sibling;
                while(sibling !== null){
                    insertOrAppendPlacementNode(sibling, before, parent);
                    sibling = sibling.sibling;
                }
            }
        }
    } // These are tracked on the stack as we recursively traverse a
    // deleted subtree.
    // TODO: Update these during the whole mutation phase, not just during
    // a deletion.
    var hostParent = null;
    var hostParentIsContainer = false;
    function commitDeletionEffects(root, returnFiber, deletedFiber) {
        // We only have the top Fiber that was deleted but we need to recurse down its
        // children to find all the terminal nodes.
        // Recursively delete all host nodes from the parent, detach refs, clean
        // up mounted layout effects, and call componentWillUnmount.
        // We only need to remove the topmost host child in each branch. But then we
        // still need to keep traversing to unmount effects, refs, and cWU. TODO: We
        // could split this into two separate traversals functions, where the second
        // one doesn't include any removeChild logic. This is maybe the same
        // function as "disappearLayoutEffects" (or whatever that turns into after
        // the layout phase is refactored to use recursion).
        // Before starting, find the nearest host parent on the stack so we know
        // which instance/container to remove the children from.
        // TODO: Instead of searching up the fiber return path on every deletion, we
        // can track the nearest host component on the JS stack as we traverse the
        // tree during the commit phase. This would make insertions faster, too.
        var parent = returnFiber;
        findParent: while(parent !== null){
            switch(parent.tag){
                case HostComponent:
                    hostParent = parent.stateNode;
                    hostParentIsContainer = false;
                    break findParent;
                case HostRoot:
                    hostParent = parent.stateNode.containerInfo;
                    hostParentIsContainer = true;
                    break findParent;
                case HostPortal:
                    hostParent = parent.stateNode.containerInfo;
                    hostParentIsContainer = true;
                    break findParent;
            }
            parent = parent.return;
        }
        if (hostParent === null) throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
        commitDeletionEffectsOnFiber(root, returnFiber, deletedFiber);
        hostParent = null;
        hostParentIsContainer = false;
        detachFiberMutation(deletedFiber);
    }
    function recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
        // TODO: Use a static flag to skip trees that don't have unmount effects
        var child = parent.child;
        while(child !== null){
            commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, child);
            child = child.sibling;
        }
    }
    function commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
        onCommitUnmount(deletedFiber); // The cases in this outer switch modify the stack before they traverse
        // into their subtree. There are simpler cases in the inner switch
        // that don't modify the stack.
        switch(deletedFiber.tag){
            case HostComponent:
                if (!offscreenSubtreeWasHidden) safelyDetachRef(deletedFiber, nearestMountedAncestor);
                 // Intentional fallthrough to next branch
            // eslint-disable-next-line-no-fallthrough
            case HostText:
                var prevHostParent = hostParent;
                var prevHostParentIsContainer = hostParentIsContainer;
                hostParent = null;
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                hostParent = prevHostParent;
                hostParentIsContainer = prevHostParentIsContainer;
                if (hostParent !== null) {
                    // Now that all the child effects have unmounted, we can remove the
                    // node from the tree.
                    if (hostParentIsContainer) removeChildFromContainer(hostParent, deletedFiber.stateNode);
                    else removeChild(hostParent, deletedFiber.stateNode);
                }
                return;
            case DehydratedFragment:
                if (hostParent !== null) {
                    if (hostParentIsContainer) clearSuspenseBoundaryFromContainer(hostParent, deletedFiber.stateNode);
                    else clearSuspenseBoundary(hostParent, deletedFiber.stateNode);
                }
                return;
            case HostPortal:
                // When we go into a portal, it becomes the parent to remove from.
                var _prevHostParent = hostParent;
                var _prevHostParentIsContainer = hostParentIsContainer;
                hostParent = deletedFiber.stateNode.containerInfo;
                hostParentIsContainer = true;
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                hostParent = _prevHostParent;
                hostParentIsContainer = _prevHostParentIsContainer;
                return;
            case FunctionComponent:
            case ForwardRef:
            case MemoComponent:
            case SimpleMemoComponent:
                if (!offscreenSubtreeWasHidden) {
                    var updateQueue = deletedFiber.updateQueue;
                    if (updateQueue !== null) {
                        var lastEffect = updateQueue.lastEffect;
                        if (lastEffect !== null) {
                            var firstEffect = lastEffect.next;
                            var effect = firstEffect;
                            do {
                                var _effect = effect, destroy = _effect.destroy, tag = _effect.tag;
                                if (destroy !== undefined) {
                                    if ((tag & Insertion) !== NoFlags$1) safelyCallDestroy(deletedFiber, nearestMountedAncestor, destroy);
                                    else if ((tag & Layout) !== NoFlags$1) {
                                        markComponentLayoutEffectUnmountStarted(deletedFiber);
                                        if (deletedFiber.mode & ProfileMode) {
                                            startLayoutEffectTimer();
                                            safelyCallDestroy(deletedFiber, nearestMountedAncestor, destroy);
                                            recordLayoutEffectDuration(deletedFiber);
                                        } else safelyCallDestroy(deletedFiber, nearestMountedAncestor, destroy);
                                        markComponentLayoutEffectUnmountStopped();
                                    }
                                }
                                effect = effect.next;
                            }while (effect !== firstEffect);
                        }
                    }
                }
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                return;
            case ClassComponent:
                if (!offscreenSubtreeWasHidden) {
                    safelyDetachRef(deletedFiber, nearestMountedAncestor);
                    var instance = deletedFiber.stateNode;
                    if (typeof instance.componentWillUnmount === 'function') safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, instance);
                }
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                return;
            case ScopeComponent:
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                return;
            case OffscreenComponent:
                if (deletedFiber.mode & ConcurrentMode) {
                    // If this offscreen component is hidden, we already unmounted it. Before
                    // deleting the children, track that it's already unmounted so that we
                    // don't attempt to unmount the effects again.
                    // TODO: If the tree is hidden, in most cases we should be able to skip
                    // over the nested children entirely. An exception is we haven't yet found
                    // the topmost host node to delete, which we already track on the stack.
                    // But the other case is portals, which need to be detached no matter how
                    // deeply they are nested. We should use a subtree flag to track whether a
                    // subtree includes a nested portal.
                    var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || deletedFiber.memoizedState !== null;
                    recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
                } else recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                break;
            default:
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                return;
        }
    }
    function commitSuspenseCallback(finishedWork) {
        // TODO: Move this to passive phase
        var newState = finishedWork.memoizedState;
    }
    function commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
        var newState = finishedWork.memoizedState;
        if (newState === null) {
            var current = finishedWork.alternate;
            if (current !== null) {
                var prevState = current.memoizedState;
                if (prevState !== null) {
                    var suspenseInstance = prevState.dehydrated;
                    if (suspenseInstance !== null) commitHydratedSuspenseInstance(suspenseInstance);
                }
            }
        }
    }
    function attachSuspenseRetryListeners(finishedWork) {
        // If this boundary just timed out, then it will have a set of wakeables.
        // For each wakeable, attach a listener so that when it resolves, React
        // attempts to re-render the boundary in the primary (pre-timeout) state.
        var wakeables = finishedWork.updateQueue;
        if (wakeables !== null) {
            finishedWork.updateQueue = null;
            var retryCache = finishedWork.stateNode;
            if (retryCache === null) retryCache = finishedWork.stateNode = new PossiblyWeakSet();
            wakeables.forEach(function(wakeable) {
                // Memoize using the boundary fiber to prevent redundant listeners.
                var retry = resolveRetryWakeable.bind(null, finishedWork, wakeable);
                if (!retryCache.has(wakeable)) {
                    retryCache.add(wakeable);
                    if (isDevToolsPresent) {
                        if (inProgressLanes !== null && inProgressRoot !== null) // If we have pending work still, associate the original updaters with it.
                        restorePendingUpdaters(inProgressRoot, inProgressLanes);
                        else throw Error('Expected finished root and lanes to be set. This is a bug in React.');
                    }
                    wakeable.then(retry, retry);
                }
            });
        }
    } // This function detects when a Suspense boundary goes from visible to hidden.
    function commitMutationEffects(root, finishedWork, committedLanes) {
        inProgressLanes = committedLanes;
        inProgressRoot = root;
        setCurrentFiber(finishedWork);
        commitMutationEffectsOnFiber(finishedWork, root);
        setCurrentFiber(finishedWork);
        inProgressLanes = null;
        inProgressRoot = null;
    }
    function recursivelyTraverseMutationEffects(root, parentFiber, lanes) {
        // Deletions effects can be scheduled on any fiber type. They need to happen
        // before the children effects hae fired.
        var deletions = parentFiber.deletions;
        if (deletions !== null) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            try {
                commitDeletionEffects(root, parentFiber, childToDelete);
            } catch (error) {
                captureCommitPhaseError(childToDelete, parentFiber, error);
            }
        }
        var prevDebugFiber = getCurrentFiber();
        if (parentFiber.subtreeFlags & MutationMask) {
            var child = parentFiber.child;
            while(child !== null){
                setCurrentFiber(child);
                commitMutationEffectsOnFiber(child, root);
                child = child.sibling;
            }
        }
        setCurrentFiber(prevDebugFiber);
    }
    function commitMutationEffectsOnFiber(finishedWork, root, lanes) {
        var current = finishedWork.alternate;
        var flags = finishedWork.flags; // The effect flag should be checked *after* we refine the type of fiber,
        // because the fiber tag is more specific. An exception is any flag related
        // to reconcilation, because those can be set on all fiber types.
        switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case MemoComponent:
            case SimpleMemoComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Update) {
                    try {
                        commitHookEffectListUnmount(Insertion | HasEffect, finishedWork, finishedWork.return);
                        commitHookEffectListMount(Insertion | HasEffect, finishedWork);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    } // Layout effects are destroyed during the mutation phase so that all
                    // destroy functions for all fibers are called before any create functions.
                    // This prevents sibling component effects from interfering with each other,
                    // e.g. a destroy function in one component should never override a ref set
                    // by a create function in another component during the same commit.
                    if (finishedWork.mode & ProfileMode) {
                        try {
                            startLayoutEffectTimer();
                            commitHookEffectListUnmount(Layout | HasEffect, finishedWork, finishedWork.return);
                        } catch (error) {
                            captureCommitPhaseError(finishedWork, finishedWork.return, error);
                        }
                        recordLayoutEffectDuration(finishedWork);
                    } else try {
                        commitHookEffectListUnmount(Layout | HasEffect, finishedWork, finishedWork.return);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                return;
            case ClassComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Ref) {
                    if (current !== null) safelyDetachRef(current, current.return);
                }
                return;
            case HostComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Ref) {
                    if (current !== null) safelyDetachRef(current, current.return);
                }
                // TODO: ContentReset gets cleared by the children during the commit
                // phase. This is a refactor hazard because it means we must read
                // flags the flags after `commitReconciliationEffects` has already run;
                // the order matters. We should refactor so that ContentReset does not
                // rely on mutating the flag during commit. Like by setting a flag
                // during the render phase instead.
                if (finishedWork.flags & ContentReset) {
                    var instance = finishedWork.stateNode;
                    try {
                        resetTextContent(instance);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                if (flags & Update) {
                    var _instance4 = finishedWork.stateNode;
                    if (_instance4 != null) {
                        // Commit the work prepared earlier.
                        var newProps = finishedWork.memoizedProps; // For hydration we reuse the update path but we treat the oldProps
                        // as the newProps. The updatePayload will contain the real change in
                        // this case.
                        var oldProps = current !== null ? current.memoizedProps : newProps;
                        var type = finishedWork.type; // TODO: Type the updateQueue to be specific to host components.
                        var updatePayload = finishedWork.updateQueue;
                        finishedWork.updateQueue = null;
                        if (updatePayload !== null) try {
                            commitUpdate(_instance4, updatePayload, type, oldProps, newProps, finishedWork);
                        } catch (error) {
                            captureCommitPhaseError(finishedWork, finishedWork.return, error);
                        }
                    }
                }
                return;
            case HostText:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Update) {
                    if (finishedWork.stateNode === null) throw new Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
                    var textInstance = finishedWork.stateNode;
                    var newText = finishedWork.memoizedProps; // For hydration we reuse the update path but we treat the oldProps
                    // as the newProps. The updatePayload will contain the real change in
                    // this case.
                    var oldText = current !== null ? current.memoizedProps : newText;
                    try {
                        commitTextUpdate(textInstance, oldText, newText);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                return;
            case HostRoot:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Update) {
                    if (current !== null) {
                        var prevRootState = current.memoizedState;
                        if (prevRootState.isDehydrated) try {
                            commitHydratedContainer(root.containerInfo);
                        } catch (error) {
                            captureCommitPhaseError(finishedWork, finishedWork.return, error);
                        }
                    }
                }
                return;
            case HostPortal:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                return;
            case SuspenseComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                var offscreenFiber = finishedWork.child;
                if (offscreenFiber.flags & Visibility) {
                    var offscreenInstance = offscreenFiber.stateNode;
                    var newState = offscreenFiber.memoizedState;
                    var isHidden = newState !== null; // Track the current state on the Offscreen instance so we can
                    // read it during an event
                    offscreenInstance.isHidden = isHidden;
                    if (isHidden) {
                        var wasHidden = offscreenFiber.alternate !== null && offscreenFiber.alternate.memoizedState !== null;
                        if (!wasHidden) // TODO: Move to passive phase
                        markCommitTimeOfFallback();
                    }
                }
                if (flags & Update) {
                    try {
                        commitSuspenseCallback(finishedWork);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                    attachSuspenseRetryListeners(finishedWork);
                }
                return;
            case OffscreenComponent:
                var _wasHidden = current !== null && current.memoizedState !== null;
                if (finishedWork.mode & ConcurrentMode) {
                    // Before committing the children, track on the stack whether this
                    // offscreen subtree was already hidden, so that we don't unmount the
                    // effects again.
                    var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || _wasHidden;
                    recursivelyTraverseMutationEffects(root, finishedWork);
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
                } else recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Visibility) {
                    var _offscreenInstance = finishedWork.stateNode;
                    var _newState = finishedWork.memoizedState;
                    var _isHidden = _newState !== null;
                    var offscreenBoundary = finishedWork; // Track the current state on the Offscreen instance so we can
                    // read it during an event
                    _offscreenInstance.isHidden = _isHidden;
                    if (_isHidden) {
                        if (!_wasHidden) {
                            if ((offscreenBoundary.mode & ConcurrentMode) !== NoMode) {
                                nextEffect = offscreenBoundary;
                                var offscreenChild = offscreenBoundary.child;
                                while(offscreenChild !== null){
                                    nextEffect = offscreenChild;
                                    disappearLayoutEffects_begin(offscreenChild);
                                    offscreenChild = offscreenChild.sibling;
                                }
                            }
                        }
                    }
                    // TODO: This needs to run whenever there's an insertion or update
                    // inside a hidden Offscreen tree.
                    hideOrUnhideAllChildren(offscreenBoundary, _isHidden);
                }
                return;
            case SuspenseListComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Update) attachSuspenseRetryListeners(finishedWork);
                return;
            case ScopeComponent:
                return;
            default:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                return;
        }
    }
    function commitReconciliationEffects(finishedWork) {
        // Placement effects (insertions, reorders) can be scheduled on any fiber
        // type. They needs to happen after the children effects have fired, but
        // before the effects on this fiber have fired.
        var flags = finishedWork.flags;
        if (flags & Placement) {
            try {
                commitPlacement(finishedWork);
            } catch (error) {
                captureCommitPhaseError(finishedWork, finishedWork.return, error);
            } // Clear the "placement" from effect tag so that we know that this is
            // inserted, before any life-cycles like componentDidMount gets called.
            // TODO: findDOMNode doesn't rely on this any more but isMounted does
            // and isMounted is deprecated anyway so we should be able to kill this.
            finishedWork.flags &= ~Placement;
        }
        if (flags & Hydrating) finishedWork.flags &= ~Hydrating;
    }
    function commitLayoutEffects(finishedWork, root, committedLanes) {
        inProgressLanes = committedLanes;
        inProgressRoot = root;
        nextEffect = finishedWork;
        commitLayoutEffects_begin(finishedWork, root, committedLanes);
        inProgressLanes = null;
        inProgressRoot = null;
    }
    function commitLayoutEffects_begin(subtreeRoot, root, committedLanes) {
        // Suspense layout effects semantics don't change for legacy roots.
        var isModernRoot = (subtreeRoot.mode & ConcurrentMode) !== NoMode;
        while(nextEffect !== null){
            var fiber = nextEffect;
            var firstChild = fiber.child;
            if (fiber.tag === OffscreenComponent && isModernRoot) {
                // Keep track of the current Offscreen stack's state.
                var isHidden = fiber.memoizedState !== null;
                var newOffscreenSubtreeIsHidden = isHidden || offscreenSubtreeIsHidden;
                if (newOffscreenSubtreeIsHidden) {
                    // The Offscreen tree is hidden. Skip over its layout effects.
                    commitLayoutMountEffects_complete(subtreeRoot, root, committedLanes);
                    continue;
                } else {
                    // TODO (Offscreen) Also check: subtreeFlags & LayoutMask
                    var current = fiber.alternate;
                    var wasHidden = current !== null && current.memoizedState !== null;
                    var newOffscreenSubtreeWasHidden = wasHidden || offscreenSubtreeWasHidden;
                    var prevOffscreenSubtreeIsHidden = offscreenSubtreeIsHidden;
                    var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden; // Traverse the Offscreen subtree with the current Offscreen as the root.
                    offscreenSubtreeIsHidden = newOffscreenSubtreeIsHidden;
                    offscreenSubtreeWasHidden = newOffscreenSubtreeWasHidden;
                    if (offscreenSubtreeWasHidden && !prevOffscreenSubtreeWasHidden) {
                        // This is the root of a reappearing boundary. Turn its layout effects
                        // back on.
                        nextEffect = fiber;
                        reappearLayoutEffects_begin(fiber);
                    }
                    var child = firstChild;
                    while(child !== null){
                        nextEffect = child;
                        commitLayoutEffects_begin(child, root, committedLanes);
                        child = child.sibling;
                    } // Restore Offscreen state and resume in our-progress traversal.
                    nextEffect = fiber;
                    offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
                    commitLayoutMountEffects_complete(subtreeRoot, root, committedLanes);
                    continue;
                }
            }
            if ((fiber.subtreeFlags & LayoutMask) !== NoFlags && firstChild !== null) {
                firstChild.return = fiber;
                nextEffect = firstChild;
            } else commitLayoutMountEffects_complete(subtreeRoot, root, committedLanes);
        }
    }
    function commitLayoutMountEffects_complete(subtreeRoot, root, committedLanes) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            if ((fiber.flags & LayoutMask) !== NoFlags) {
                var current = fiber.alternate;
                setCurrentFiber(fiber);
                try {
                    commitLayoutEffectOnFiber(root, current, fiber, committedLanes);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                resetCurrentFiber();
            }
            if (fiber === subtreeRoot) {
                nextEffect = null;
                return;
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function disappearLayoutEffects_begin(subtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var firstChild = fiber.child; // TODO (Offscreen) Check: flags & (RefStatic | LayoutStatic)
            switch(fiber.tag){
                case FunctionComponent:
                case ForwardRef:
                case MemoComponent:
                case SimpleMemoComponent:
                    if (fiber.mode & ProfileMode) try {
                        startLayoutEffectTimer();
                        commitHookEffectListUnmount(Layout, fiber, fiber.return);
                    } finally{
                        recordLayoutEffectDuration(fiber);
                    }
                    else commitHookEffectListUnmount(Layout, fiber, fiber.return);
                    break;
                case ClassComponent:
                    // TODO (Offscreen) Check: flags & RefStatic
                    safelyDetachRef(fiber, fiber.return);
                    var instance = fiber.stateNode;
                    if (typeof instance.componentWillUnmount === 'function') safelyCallComponentWillUnmount(fiber, fiber.return, instance);
                    break;
                case HostComponent:
                    safelyDetachRef(fiber, fiber.return);
                    break;
                case OffscreenComponent:
                    // Check if this is a
                    var isHidden = fiber.memoizedState !== null;
                    if (isHidden) {
                        // Nested Offscreen tree is already hidden. Don't disappear
                        // its effects.
                        disappearLayoutEffects_complete(subtreeRoot);
                        continue;
                    }
                    break;
            } // TODO (Offscreen) Check: subtreeFlags & LayoutStatic
            if (firstChild !== null) {
                firstChild.return = fiber;
                nextEffect = firstChild;
            } else disappearLayoutEffects_complete(subtreeRoot);
        }
    }
    function disappearLayoutEffects_complete(subtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            if (fiber === subtreeRoot) {
                nextEffect = null;
                return;
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function reappearLayoutEffects_begin(subtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var firstChild = fiber.child;
            if (fiber.tag === OffscreenComponent) {
                var isHidden = fiber.memoizedState !== null;
                if (isHidden) {
                    // Nested Offscreen tree is still hidden. Don't re-appear its effects.
                    reappearLayoutEffects_complete(subtreeRoot);
                    continue;
                }
            } // TODO (Offscreen) Check: subtreeFlags & LayoutStatic
            if (firstChild !== null) {
                // This node may have been reused from a previous render, so we can't
                // assume its return pointer is correct.
                firstChild.return = fiber;
                nextEffect = firstChild;
            } else reappearLayoutEffects_complete(subtreeRoot);
        }
    }
    function reappearLayoutEffects_complete(subtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect; // TODO (Offscreen) Check: flags & LayoutStatic
            setCurrentFiber(fiber);
            try {
                reappearLayoutEffectsOnFiber(fiber);
            } catch (error) {
                captureCommitPhaseError(fiber, fiber.return, error);
            }
            resetCurrentFiber();
            if (fiber === subtreeRoot) {
                nextEffect = null;
                return;
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                // This node may have been reused from a previous render, so we can't
                // assume its return pointer is correct.
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function commitPassiveMountEffects(root, finishedWork, committedLanes, committedTransitions) {
        nextEffect = finishedWork;
        commitPassiveMountEffects_begin(finishedWork, root, committedLanes, committedTransitions);
    }
    function commitPassiveMountEffects_begin(subtreeRoot, root, committedLanes, committedTransitions) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var firstChild = fiber.child;
            if ((fiber.subtreeFlags & PassiveMask) !== NoFlags && firstChild !== null) {
                firstChild.return = fiber;
                nextEffect = firstChild;
            } else commitPassiveMountEffects_complete(subtreeRoot, root, committedLanes, committedTransitions);
        }
    }
    function commitPassiveMountEffects_complete(subtreeRoot, root, committedLanes, committedTransitions) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            if ((fiber.flags & Passive) !== NoFlags) {
                setCurrentFiber(fiber);
                try {
                    commitPassiveMountOnFiber(root, fiber, committedLanes, committedTransitions);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                resetCurrentFiber();
            }
            if (fiber === subtreeRoot) {
                nextEffect = null;
                return;
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
        switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (finishedWork.mode & ProfileMode) {
                    startPassiveEffectTimer();
                    try {
                        commitHookEffectListMount(Passive$1 | HasEffect, finishedWork);
                    } finally{
                        recordPassiveEffectDuration(finishedWork);
                    }
                } else commitHookEffectListMount(Passive$1 | HasEffect, finishedWork);
                break;
        }
    }
    function commitPassiveUnmountEffects(firstChild) {
        nextEffect = firstChild;
        commitPassiveUnmountEffects_begin();
    }
    function commitPassiveUnmountEffects_begin() {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var child = fiber.child;
            if ((nextEffect.flags & ChildDeletion) !== NoFlags) {
                var deletions = fiber.deletions;
                if (deletions !== null) {
                    for(var i = 0; i < deletions.length; i++){
                        var fiberToDelete = deletions[i];
                        nextEffect = fiberToDelete;
                        commitPassiveUnmountEffectsInsideOfDeletedTree_begin(fiberToDelete, fiber);
                    }
                    // A fiber was deleted from this parent fiber, but it's still part of
                    // the previous (alternate) parent fiber's list of children. Because
                    // children are a linked list, an earlier sibling that's still alive
                    // will be connected to the deleted fiber via its `alternate`:
                    //
                    //   live fiber
                    //   --alternate--> previous live fiber
                    //   --sibling--> deleted fiber
                    //
                    // We can't disconnect `alternate` on nodes that haven't been deleted
                    // yet, but we can disconnect the `sibling` and `child` pointers.
                    var previousFiber = fiber.alternate;
                    if (previousFiber !== null) {
                        var detachedChild = previousFiber.child;
                        if (detachedChild !== null) {
                            previousFiber.child = null;
                            do {
                                var detachedSibling = detachedChild.sibling;
                                detachedChild.sibling = null;
                                detachedChild = detachedSibling;
                            }while (detachedChild !== null);
                        }
                    }
                    nextEffect = fiber;
                }
            }
            if ((fiber.subtreeFlags & PassiveMask) !== NoFlags && child !== null) {
                child.return = fiber;
                nextEffect = child;
            } else commitPassiveUnmountEffects_complete();
        }
    }
    function commitPassiveUnmountEffects_complete() {
        while(nextEffect !== null){
            var fiber = nextEffect;
            if ((fiber.flags & Passive) !== NoFlags) {
                setCurrentFiber(fiber);
                commitPassiveUnmountOnFiber(fiber);
                resetCurrentFiber();
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function commitPassiveUnmountOnFiber(finishedWork) {
        switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (finishedWork.mode & ProfileMode) {
                    startPassiveEffectTimer();
                    commitHookEffectListUnmount(Passive$1 | HasEffect, finishedWork, finishedWork.return);
                    recordPassiveEffectDuration(finishedWork);
                } else commitHookEffectListUnmount(Passive$1 | HasEffect, finishedWork, finishedWork.return);
                break;
        }
    }
    function commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
        while(nextEffect !== null){
            var fiber = nextEffect; // Deletion effects fire in parent -> child order
            // TODO: Check if fiber has a PassiveStatic flag
            setCurrentFiber(fiber);
            commitPassiveUnmountInsideDeletedTreeOnFiber(fiber, nearestMountedAncestor);
            resetCurrentFiber();
            var child = fiber.child; // TODO: Only traverse subtree if it has a PassiveStatic flag. (But, if we
            // do this, still need to handle `deletedTreeCleanUpLevel` correctly.)
            if (child !== null) {
                child.return = fiber;
                nextEffect = child;
            } else commitPassiveUnmountEffectsInsideOfDeletedTree_complete(deletedSubtreeRoot);
        }
    }
    function commitPassiveUnmountEffectsInsideOfDeletedTree_complete(deletedSubtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var sibling = fiber.sibling;
            var returnFiber = fiber.return;
            // Recursively traverse the entire deleted tree and clean up fiber fields.
            // This is more aggressive than ideal, and the long term goal is to only
            // have to detach the deleted tree at the root.
            detachFiberAfterEffects(fiber);
            if (fiber === deletedSubtreeRoot) {
                nextEffect = null;
                return;
            }
            if (sibling !== null) {
                sibling.return = returnFiber;
                nextEffect = sibling;
                return;
            }
            nextEffect = returnFiber;
        }
    }
    function commitPassiveUnmountInsideDeletedTreeOnFiber(current, nearestMountedAncestor) {
        switch(current.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (current.mode & ProfileMode) {
                    startPassiveEffectTimer();
                    commitHookEffectListUnmount(Passive$1, current, nearestMountedAncestor);
                    recordPassiveEffectDuration(current);
                } else commitHookEffectListUnmount(Passive$1, current, nearestMountedAncestor);
                break;
        }
    } // TODO: Reuse reappearLayoutEffects traversal here?
    function invokeLayoutEffectMountInDEV(fiber) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                try {
                    commitHookEffectListMount(Layout | HasEffect, fiber);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                break;
            case ClassComponent:
                var instance = fiber.stateNode;
                try {
                    instance.componentDidMount();
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                break;
        }
    }
    function invokePassiveEffectMountInDEV(fiber) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                try {
                    commitHookEffectListMount(Passive$1 | HasEffect, fiber);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                break;
        }
    }
    function invokeLayoutEffectUnmountInDEV(fiber) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                try {
                    commitHookEffectListUnmount(Layout | HasEffect, fiber, fiber.return);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                break;
            case ClassComponent:
                var instance = fiber.stateNode;
                if (typeof instance.componentWillUnmount === 'function') safelyCallComponentWillUnmount(fiber, fiber.return, instance);
                break;
        }
    }
    function invokePassiveEffectUnmountInDEV(fiber) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                try {
                    commitHookEffectListUnmount(Passive$1 | HasEffect, fiber, fiber.return);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
        }
    }
    var COMPONENT_TYPE = 0;
    var HAS_PSEUDO_CLASS_TYPE = 1;
    var ROLE_TYPE = 2;
    var TEST_NAME_TYPE = 3;
    var TEXT_TYPE = 4;
    if (typeof Symbol === 'function' && Symbol.for) {
        var symbolFor = Symbol.for;
        COMPONENT_TYPE = symbolFor('selector.component');
        HAS_PSEUDO_CLASS_TYPE = symbolFor('selector.has_pseudo_class');
        ROLE_TYPE = symbolFor('selector.role');
        TEST_NAME_TYPE = symbolFor('selector.test_id');
        TEXT_TYPE = symbolFor('selector.text');
    }
    var commitHooks = [];
    function onCommitRoot$1() {
        commitHooks.forEach(function(commitHook) {
            return commitHook();
        });
    }
    var ReactCurrentActQueue = ReactSharedInternals.ReactCurrentActQueue;
    function isLegacyActEnvironment(fiber) {
        // Legacy mode. We preserve the behavior of React 17's act. It assumes an
        // act environment whenever `jest` is defined, but you can still turn off
        // spurious warnings by setting IS_REACT_ACT_ENVIRONMENT explicitly
        // to false.
        var isReactActEnvironmentGlobal = typeof IS_REACT_ACT_ENVIRONMENT !== 'undefined' ? IS_REACT_ACT_ENVIRONMENT : undefined; // $FlowExpectedError - Flow doesn't know about jest
        var jestIsDefined = typeof jest !== 'undefined';
        return jestIsDefined && isReactActEnvironmentGlobal !== false;
    }
    function isConcurrentActEnvironment() {
        var isReactActEnvironmentGlobal = typeof IS_REACT_ACT_ENVIRONMENT !== 'undefined' ? IS_REACT_ACT_ENVIRONMENT : undefined;
        if (!isReactActEnvironmentGlobal && ReactCurrentActQueue.current !== null) // TODO: Include link to relevant documentation page.
        error("The current testing environment is not configured to support act(...)");
        return isReactActEnvironmentGlobal;
    }
    var ceil = Math.ceil;
    var ReactCurrentDispatcher$2 = ReactSharedInternals.ReactCurrentDispatcher, ReactCurrentOwner$2 = ReactSharedInternals.ReactCurrentOwner, ReactCurrentBatchConfig$3 = ReactSharedInternals.ReactCurrentBatchConfig, ReactCurrentActQueue$1 = ReactSharedInternals.ReactCurrentActQueue;
    var NoContext = /*             */ 0;
    var BatchedContext = /*               */ 1;
    var RenderContext = /*                */ 2;
    var CommitContext = /*                */ 4;
    var RootInProgress = 0;
    var RootFatalErrored = 1;
    var RootErrored = 2;
    var RootSuspended = 3;
    var RootSuspendedWithDelay = 4;
    var RootCompleted = 5;
    var RootDidNotComplete = 6; // Describes where we are in the React execution stack
    var executionContext = NoContext; // The root we're working on
    var workInProgressRoot = null; // The fiber we're working on
    var workInProgress = null; // The lanes we're rendering
    var workInProgressRootRenderLanes = NoLanes; // Stack that allows components to change the render lanes for its subtree
    // This is a superset of the lanes we started working on at the root. The only
    // case where it's different from `workInProgressRootRenderLanes` is when we
    // enter a subtree that is hidden and needs to be unhidden: Suspense and
    // Offscreen component.
    //
    // Most things in the work loop should deal with workInProgressRootRenderLanes.
    // Most things in begin/complete phases should deal with subtreeRenderLanes.
    var subtreeRenderLanes = NoLanes;
    var subtreeRenderLanesCursor = createCursor(NoLanes); // Whether to root completed, errored, suspended, etc.
    var workInProgressRootExitStatus = RootInProgress; // A fatal error, if one is thrown
    var workInProgressRootFatalError = null; // "Included" lanes refer to lanes that were worked on during this render. It's
    // slightly different than `renderLanes` because `renderLanes` can change as you
    // enter and exit an Offscreen tree. This value is the combination of all render
    // lanes for the entire render phase.
    var workInProgressRootIncludedLanes = NoLanes; // The work left over by components that were visited during this render. Only
    // includes unprocessed updates, not work in bailed out children.
    var workInProgressRootSkippedLanes = NoLanes; // Lanes that were updated (in an interleaved event) during this render.
    var workInProgressRootInterleavedUpdatedLanes = NoLanes; // Lanes that were updated during the render phase (*not* an interleaved event).
    var workInProgressRootPingedLanes = NoLanes; // Errors that are thrown during the render phase.
    var workInProgressRootConcurrentErrors = null; // These are errors that we recovered from without surfacing them to the UI.
    // We will log them once the tree commits.
    var workInProgressRootRecoverableErrors = null; // The most recent time we committed a fallback. This lets us ensure a train
    // model where we don't commit new loading states in too quick succession.
    var globalMostRecentFallbackTime = 0;
    var FALLBACK_THROTTLE_MS = 500; // The absolute time for when we should start giving up on rendering
    // more and prefer CPU suspense heuristics instead.
    var workInProgressRootRenderTargetTime = Infinity; // How long a render is supposed to take before we start following CPU
    // suspense heuristics and opt out of rendering more content.
    var RENDER_TIMEOUT_MS = 500;
    var workInProgressTransitions = null;
    function resetRenderTimer() {
        workInProgressRootRenderTargetTime = now() + RENDER_TIMEOUT_MS;
    }
    function getRenderTargetTime() {
        return workInProgressRootRenderTargetTime;
    }
    var hasUncaughtError = false;
    var firstUncaughtError = null;
    var legacyErrorBoundariesThatAlreadyFailed = null; // Only used when enableProfilerNestedUpdateScheduledHook is true;
    var rootDoesHavePassiveEffects = false;
    var rootWithPendingPassiveEffects = null;
    var pendingPassiveEffectsLanes = NoLanes;
    var pendingPassiveProfilerEffects = [];
    var pendingPassiveTransitions = null; // Use these to prevent an infinite loop of nested updates
    var NESTED_UPDATE_LIMIT = 50;
    var nestedUpdateCount = 0;
    var rootWithNestedUpdates = null;
    var isFlushingPassiveEffects = false;
    var didScheduleUpdateDuringPassiveEffects = false;
    var NESTED_PASSIVE_UPDATE_LIMIT = 50;
    var nestedPassiveUpdateCount = 0;
    var rootWithPassiveNestedUpdates = null; // If two updates are scheduled within the same event, we should treat their
    // event times as simultaneous, even if the actual clock time has advanced
    // between the first and second call.
    var currentEventTime = NoTimestamp;
    var currentEventTransitionLane = NoLanes;
    var isRunningInsertionEffect = false;
    function getWorkInProgressRoot() {
        return workInProgressRoot;
    }
    function requestEventTime() {
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) // We're inside React, so it's fine to read the actual time.
        return now();
         // We're not inside React, so we may be in the middle of a browser event.
        if (currentEventTime !== NoTimestamp) // Use the same start time for all updates until we enter React again.
        return currentEventTime;
         // This is the first update since React yielded. Compute a new start time.
        currentEventTime = now();
        return currentEventTime;
    }
    function requestUpdateLane(fiber) {
        // Special cases
        var mode = fiber.mode;
        if ((mode & ConcurrentMode) === NoMode) return SyncLane;
        else if ((executionContext & RenderContext) !== NoContext && workInProgressRootRenderLanes !== NoLanes) // This is a render phase update. These are not officially supported. The
        // old behavior is to give this the same "thread" (lanes) as
        // whatever is currently rendering. So if you call `setState` on a component
        // that happens later in the same render, it will flush. Ideally, we want to
        // remove the special case and treat them as if they came from an
        // interleaved event. Regardless, this pattern is not officially supported.
        // This behavior is only a fallback. The flag only exists until we can roll
        // out the setState warning, since existing code might accidentally rely on
        // the current behavior.
        return pickArbitraryLane(workInProgressRootRenderLanes);
        var isTransition = requestCurrentTransition() !== NoTransition;
        if (isTransition) {
            if (ReactCurrentBatchConfig$3.transition !== null) {
                var transition = ReactCurrentBatchConfig$3.transition;
                if (!transition._updatedFibers) transition._updatedFibers = new Set();
                transition._updatedFibers.add(fiber);
            } // The algorithm for assigning an update to a lane should be stable for all
            // updates at the same priority within the same event. To do this, the
            // inputs to the algorithm must be the same.
            //
            // The trick we use is to cache the first of each of these inputs within an
            // event. Then reset the cached values once we can be sure the event is
            // over. Our heuristic for that is whenever we enter a concurrent work loop.
            if (currentEventTransitionLane === NoLane) // All transitions within the same event are assigned the same lane.
            currentEventTransitionLane = claimNextTransitionLane();
            return currentEventTransitionLane;
        } // Updates originating inside certain React methods, like flushSync, have
        // their priority set by tracking it with a context variable.
        //
        // The opaque type returned by the host config is internally a lane, so we can
        // use that directly.
        // TODO: Move this type conversion to the event priority module.
        var updateLane = getCurrentUpdatePriority();
        if (updateLane !== NoLane) return updateLane;
         // This update originated outside React. Ask the host environment for an
        // appropriate priority, based on the type of event.
        //
        // The opaque type returned by the host config is internally a lane, so we can
        // use that directly.
        // TODO: Move this type conversion to the event priority module.
        var eventLane = getCurrentEventPriority();
        return eventLane;
    }
    function requestRetryLane(fiber) {
        // This is a fork of `requestUpdateLane` designed specifically for Suspense
        // "retries" — a special update that attempts to flip a Suspense boundary
        // from its placeholder state to its primary/resolved state.
        // Special cases
        var mode = fiber.mode;
        if ((mode & ConcurrentMode) === NoMode) return SyncLane;
        return claimNextRetryLane();
    }
    function scheduleUpdateOnFiber(root, fiber, lane, eventTime) {
        checkForNestedUpdates();
        if (isRunningInsertionEffect) error('useInsertionEffect must not schedule updates.');
        if (isFlushingPassiveEffects) didScheduleUpdateDuringPassiveEffects = true;
        markRootUpdated(root, lane, eventTime);
        if ((executionContext & RenderContext) !== NoLanes && root === workInProgressRoot) // This update was dispatched during the render phase. This is a mistake
        // if the update originates from user space (with the exception of local
        // hook updates, which are handled differently and don't reach this
        // function), but there are some internal React features that use this as
        // an implementation detail, like selective hydration.
        warnAboutRenderPhaseUpdatesInDEV(fiber); // Track lanes that were updated during the render phase
        else {
            if (isDevToolsPresent) addFiberToLanesMap(root, fiber, lane);
            warnIfUpdatesNotWrappedWithActDEV(fiber);
            if (root === workInProgressRoot) {
                // Received an update to a tree that's in the middle of rendering. Mark
                // that there was an interleaved update work on this root. Unless the
                // `deferRenderPhaseUpdateToNextBatch` flag is off and this is a render
                // phase update. In that case, we don't treat render phase updates as if
                // they were interleaved, for backwards compat reasons.
                if ((executionContext & RenderContext) === NoContext) workInProgressRootInterleavedUpdatedLanes = mergeLanes(workInProgressRootInterleavedUpdatedLanes, lane);
                if (workInProgressRootExitStatus === RootSuspendedWithDelay) // The root already suspended with a delay, which means this render
                // definitely won't finish. Since we have a new update, let's mark it as
                // suspended now, right before marking the incoming update. This has the
                // effect of interrupting the current render and switching to the update.
                // TODO: Make sure this doesn't override pings that happen while we've
                // already started rendering.
                markRootSuspended$1(root, workInProgressRootRenderLanes);
            }
            ensureRootIsScheduled(root, eventTime);
            if (lane === SyncLane && executionContext === NoContext && (fiber.mode & ConcurrentMode) === NoMode && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
            !ReactCurrentActQueue$1.isBatchingLegacy) {
                // Flush the synchronous work now, unless we're already working or inside
                // a batch. This is intentionally inside scheduleUpdateOnFiber instead of
                // scheduleCallbackForFiber to preserve the ability to schedule a callback
                // without immediately flushing it. We only do this for user-initiated
                // updates, to preserve historical behavior of legacy mode.
                resetRenderTimer();
                flushSyncCallbacksOnlyInLegacyMode();
            }
        }
    }
    function scheduleInitialHydrationOnRoot(root, lane, eventTime) {
        // This is a special fork of scheduleUpdateOnFiber that is only used to
        // schedule the initial hydration of a root that has just been created. Most
        // of the stuff in scheduleUpdateOnFiber can be skipped.
        //
        // The main reason for this separate path, though, is to distinguish the
        // initial children from subsequent updates. In fully client-rendered roots
        // (createRoot instead of hydrateRoot), all top-level renders are modeled as
        // updates, but hydration roots are special because the initial render must
        // match what was rendered on the server.
        var current = root.current;
        current.lanes = lane;
        markRootUpdated(root, lane, eventTime);
        ensureRootIsScheduled(root, eventTime);
    }
    function isUnsafeClassRenderPhaseUpdate(fiber) {
        // Check if this is a render phase update. Only called by class components,
        // which special (deprecated) behavior for UNSAFE_componentWillReceive props.
        return(// decided not to enable it.
        (executionContext & RenderContext) !== NoContext);
    } // Use this function to schedule a task for a root. There's only one task per
    // root; if a task was already scheduled, we'll check to make sure the priority
    // of the existing task is the same as the priority of the next level that the
    // root has work on. This function is called on every update, and right before
    // exiting a task.
    function ensureRootIsScheduled(root, currentTime) {
        var existingCallbackNode = root.callbackNode; // Check if any lanes are being starved by other work. If so, mark them as
        // expired so we know to work on those next.
        markStarvedLanesAsExpired(root, currentTime); // Determine the next lanes to work on, and their priority.
        var nextLanes = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes : NoLanes);
        if (nextLanes === NoLanes) {
            // Special case: There's nothing to work on.
            if (existingCallbackNode !== null) cancelCallback$1(existingCallbackNode);
            root.callbackNode = null;
            root.callbackPriority = NoLane;
            return;
        } // We use the highest priority lane to represent the priority of the callback.
        var newCallbackPriority = getHighestPriorityLane(nextLanes); // Check if there's an existing task. We may be able to reuse it.
        var existingCallbackPriority = root.callbackPriority;
        if (existingCallbackPriority === newCallbackPriority && // Special case related to `act`. If the currently scheduled task is a
        // Scheduler task, rather than an `act` task, cancel it and re-scheduled
        // on the `act` queue.
        !(ReactCurrentActQueue$1.current !== null && existingCallbackNode !== fakeActCallbackNode)) {
            // If we're going to re-use an existing task, it needs to exist.
            // Assume that discrete update microtasks are non-cancellable and null.
            // TODO: Temporary until we confirm this warning is not fired.
            if (existingCallbackNode == null && existingCallbackPriority !== SyncLane) error('Expected scheduled callback to exist. This error is likely caused by a bug in React. Please file an issue.');
            return;
        }
        if (existingCallbackNode != null) // Cancel the existing callback. We'll schedule a new one below.
        cancelCallback$1(existingCallbackNode);
         // Schedule a new callback.
        var newCallbackNode;
        if (newCallbackPriority === SyncLane) {
            // Special case: Sync React callbacks are scheduled on a special
            // internal queue
            if (root.tag === LegacyRoot) {
                if (ReactCurrentActQueue$1.isBatchingLegacy !== null) ReactCurrentActQueue$1.didScheduleLegacyUpdate = true;
                scheduleLegacySyncCallback(performSyncWorkOnRoot.bind(null, root));
            } else scheduleSyncCallback(performSyncWorkOnRoot.bind(null, root));
            // Flush the queue in a microtask.
            if (ReactCurrentActQueue$1.current !== null) // Inside `act`, use our internal `act` queue so that these get flushed
            // at the end of the current scope even when using the sync version
            // of `act`.
            ReactCurrentActQueue$1.current.push(flushSyncCallbacks);
            else scheduleMicrotask(function() {
                // In Safari, appending an iframe forces microtasks to run.
                // https://github.com/facebook/react/issues/22459
                // We don't support running callbacks in the middle of render
                // or commit so we need to check against that.
                if ((executionContext & (RenderContext | CommitContext)) === NoContext) // Note that this would still prematurely flush the callbacks
                // if this happens outside render or commit phase (e.g. in an event).
                flushSyncCallbacks();
            });
            newCallbackNode = null;
        } else {
            var schedulerPriorityLevel;
            switch(lanesToEventPriority(nextLanes)){
                case DiscreteEventPriority:
                    schedulerPriorityLevel = ImmediatePriority;
                    break;
                case ContinuousEventPriority:
                    schedulerPriorityLevel = UserBlockingPriority;
                    break;
                case DefaultEventPriority:
                    schedulerPriorityLevel = NormalPriority;
                    break;
                case IdleEventPriority:
                    schedulerPriorityLevel = IdlePriority;
                    break;
                default:
                    schedulerPriorityLevel = NormalPriority;
                    break;
            }
            newCallbackNode = scheduleCallback$1(schedulerPriorityLevel, performConcurrentWorkOnRoot.bind(null, root));
        }
        root.callbackPriority = newCallbackPriority;
        root.callbackNode = newCallbackNode;
    } // This is the entry point for every concurrent task, i.e. anything that
    // goes through Scheduler.
    function performConcurrentWorkOnRoot(root, didTimeout) {
        resetNestedUpdateFlag();
        // event time. The next update will compute a new event time.
        currentEventTime = NoTimestamp;
        currentEventTransitionLane = NoLanes;
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw new Error('Should not already be working.');
         // Flush any pending passive effects before deciding which lanes to work on,
        // in case they schedule additional work.
        var originalCallbackNode = root.callbackNode;
        var didFlushPassiveEffects = flushPassiveEffects();
        if (didFlushPassiveEffects) {
            // Something in the passive effect phase may have canceled the current task.
            // Check if the task node for this root was changed.
            if (root.callbackNode !== originalCallbackNode) // The current task was canceled. Exit. We don't need to call
            // `ensureRootIsScheduled` because the check above implies either that
            // there's a new task, or that there's no remaining work on this root.
            return null;
        } // Determine the next lanes to work on, using the fields stored
        // on the root.
        var lanes = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes : NoLanes);
        if (lanes === NoLanes) // Defensive coding. This is never expected to happen.
        return null;
         // We disable time-slicing in some cases: if the work has been CPU-bound
        // for too long ("expired" work, to prevent starvation), or we're in
        // sync-updates-by-default mode.
        // TODO: We only check `didTimeout` defensively, to account for a Scheduler
        // bug we're still investigating. Once the bug in Scheduler is fixed,
        // we can remove this, since we track expiration ourselves.
        var shouldTimeSlice = !includesBlockingLane(root, lanes) && !includesExpiredLane(root, lanes) && !didTimeout;
        var exitStatus = shouldTimeSlice ? renderRootConcurrent(root, lanes) : renderRootSync(root, lanes);
        if (exitStatus !== RootInProgress) {
            if (exitStatus === RootErrored) {
                // If something threw an error, try rendering one more time. We'll
                // render synchronously to block concurrent data mutations, and we'll
                // includes all pending updates are included. If it still fails after
                // the second attempt, we'll give up and commit the resulting tree.
                var errorRetryLanes = getLanesToRetrySynchronouslyOnError(root);
                if (errorRetryLanes !== NoLanes) {
                    lanes = errorRetryLanes;
                    exitStatus = recoverFromConcurrentError(root, errorRetryLanes);
                }
            }
            if (exitStatus === RootFatalErrored) {
                var fatalError = workInProgressRootFatalError;
                prepareFreshStack(root, NoLanes);
                markRootSuspended$1(root, lanes);
                ensureRootIsScheduled(root, now());
                throw fatalError;
            }
            if (exitStatus === RootDidNotComplete) // The render unwound without completing the tree. This happens in special
            // cases where need to exit the current render without producing a
            // consistent tree or committing.
            //
            // This should only happen during a concurrent render, not a discrete or
            // synchronous update. We should have already checked for this when we
            // unwound the stack.
            markRootSuspended$1(root, lanes);
            else {
                // The render completed.
                // Check if this render may have yielded to a concurrent event, and if so,
                // confirm that any newly rendered stores are consistent.
                // TODO: It's possible that even a concurrent render may never have yielded
                // to the main thread, if it was fast enough, or if it expired. We could
                // skip the consistency check in that case, too.
                var renderWasConcurrent = !includesBlockingLane(root, lanes);
                var finishedWork = root.current.alternate;
                if (renderWasConcurrent && !isRenderConsistentWithExternalStores(finishedWork)) {
                    // A store was mutated in an interleaved event. Render again,
                    // synchronously, to block further mutations.
                    exitStatus = renderRootSync(root, lanes); // We need to check again if something threw
                    if (exitStatus === RootErrored) {
                        var _errorRetryLanes = getLanesToRetrySynchronouslyOnError(root);
                        if (_errorRetryLanes !== NoLanes) {
                            lanes = _errorRetryLanes;
                            exitStatus = recoverFromConcurrentError(root, _errorRetryLanes); // We assume the tree is now consistent because we didn't yield to any
                        // concurrent events.
                        }
                    }
                    if (exitStatus === RootFatalErrored) {
                        var _fatalError = workInProgressRootFatalError;
                        prepareFreshStack(root, NoLanes);
                        markRootSuspended$1(root, lanes);
                        ensureRootIsScheduled(root, now());
                        throw _fatalError;
                    }
                } // We now have a consistent tree. The next step is either to commit it,
                // or, if something suspended, wait to commit it after a timeout.
                root.finishedWork = finishedWork;
                root.finishedLanes = lanes;
                finishConcurrentRender(root, exitStatus, lanes);
            }
        }
        ensureRootIsScheduled(root, now());
        if (root.callbackNode === originalCallbackNode) // The task node scheduled for this root is the same one that's
        // currently executed. Need to return a continuation.
        return performConcurrentWorkOnRoot.bind(null, root);
        return null;
    }
    function recoverFromConcurrentError(root, errorRetryLanes) {
        // If an error occurred during hydration, discard server response and fall
        // back to client side render.
        // Before rendering again, save the errors from the previous attempt.
        var errorsFromFirstAttempt = workInProgressRootConcurrentErrors;
        if (isRootDehydrated(root)) {
            // The shell failed to hydrate. Set a flag to force a client rendering
            // during the next attempt. To do this, we call prepareFreshStack now
            // to create the root work-in-progress fiber. This is a bit weird in terms
            // of factoring, because it relies on renderRootSync not calling
            // prepareFreshStack again in the call below, which happens because the
            // root and lanes haven't changed.
            //
            // TODO: I think what we should do is set ForceClientRender inside
            // throwException, like we do for nested Suspense boundaries. The reason
            // it's here instead is so we can switch to the synchronous work loop, too.
            // Something to consider for a future refactor.
            var rootWorkInProgress = prepareFreshStack(root, errorRetryLanes);
            rootWorkInProgress.flags |= ForceClientRender;
            errorHydratingContainer(root.containerInfo);
        }
        var exitStatus = renderRootSync(root, errorRetryLanes);
        if (exitStatus !== RootErrored) {
            // Successfully finished rendering on retry
            // The errors from the failed first attempt have been recovered. Add
            // them to the collection of recoverable errors. We'll log them in the
            // commit phase.
            var errorsFromSecondAttempt = workInProgressRootRecoverableErrors;
            workInProgressRootRecoverableErrors = errorsFromFirstAttempt; // The errors from the second attempt should be queued after the errors
            // from the first attempt, to preserve the causal sequence.
            if (errorsFromSecondAttempt !== null) queueRecoverableErrors(errorsFromSecondAttempt);
        }
        return exitStatus;
    }
    function queueRecoverableErrors(errors) {
        if (workInProgressRootRecoverableErrors === null) workInProgressRootRecoverableErrors = errors;
        else workInProgressRootRecoverableErrors.push.apply(workInProgressRootRecoverableErrors, errors);
    }
    function finishConcurrentRender(root, exitStatus, lanes) {
        switch(exitStatus){
            case RootInProgress:
            case RootFatalErrored:
                throw new Error('Root did not complete. This is a bug in React.');
            // Flow knows about invariant, so it complains if I add a break
            // statement, but eslint doesn't know about invariant, so it complains
            // if I do. eslint-disable-next-line no-fallthrough
            case RootErrored:
                // We should have already attempted to retry this tree. If we reached
                // this point, it errored again. Commit it.
                commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
                break;
            case RootSuspended:
                markRootSuspended$1(root, lanes); // We have an acceptable loading state. We need to figure out if we
                // should immediately commit it or wait a bit.
                if (includesOnlyRetries(lanes) && // do not delay if we're inside an act() scope
                !shouldForceFlushFallbacksInDEV()) {
                    // This render only included retries, no updates. Throttle committing
                    // retries so that we don't show too many loading states too quickly.
                    var msUntilTimeout = globalMostRecentFallbackTime + FALLBACK_THROTTLE_MS - now(); // Don't bother with a very short suspense time.
                    if (msUntilTimeout > 10) {
                        var nextLanes = getNextLanes(root, NoLanes);
                        if (nextLanes !== NoLanes) break;
                        var suspendedLanes = root.suspendedLanes;
                        if (!isSubsetOfLanes(suspendedLanes, lanes)) {
                            // We should prefer to render the fallback of at the last
                            // suspended level. Ping the last suspended level to try
                            // rendering it again.
                            // FIXME: What if the suspended lanes are Idle? Should not restart.
                            var eventTime = requestEventTime();
                            markRootPinged(root, suspendedLanes);
                            break;
                        } // The render is suspended, it hasn't timed out, and there's no
                        // lower priority work to do. Instead of committing the fallback
                        // immediately, wait for more data to arrive.
                        root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root, workInProgressRootRecoverableErrors, workInProgressTransitions), msUntilTimeout);
                        break;
                    }
                } // The work expired. Commit immediately.
                commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
                break;
            case RootSuspendedWithDelay:
                markRootSuspended$1(root, lanes);
                if (includesOnlyTransitions(lanes)) break;
                if (!shouldForceFlushFallbacksInDEV()) {
                    // This is not a transition, but we did trigger an avoided state.
                    // Schedule a placeholder to display after a short delay, using the Just
                    // Noticeable Difference.
                    // TODO: Is the JND optimization worth the added complexity? If this is
                    // the only reason we track the event time, then probably not.
                    // Consider removing.
                    var mostRecentEventTime = getMostRecentEventTime(root, lanes);
                    var eventTimeMs = mostRecentEventTime;
                    var timeElapsedMs = now() - eventTimeMs;
                    var _msUntilTimeout = jnd(timeElapsedMs) - timeElapsedMs; // Don't bother with a very short suspense time.
                    if (_msUntilTimeout > 10) {
                        // Instead of committing the fallback immediately, wait for more data
                        // to arrive.
                        root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root, workInProgressRootRecoverableErrors, workInProgressTransitions), _msUntilTimeout);
                        break;
                    }
                } // Commit the placeholder.
                commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
                break;
            case RootCompleted:
                // The work completed. Ready to commit.
                commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
                break;
            default:
                throw new Error('Unknown root exit status.');
        }
    }
    function isRenderConsistentWithExternalStores(finishedWork) {
        // Search the rendered tree for external store reads, and check whether the
        // stores were mutated in a concurrent event. Intentionally using an iterative
        // loop instead of recursion so we can exit early.
        var node = finishedWork;
        while(true){
            if (node.flags & StoreConsistency) {
                var updateQueue = node.updateQueue;
                if (updateQueue !== null) {
                    var checks = updateQueue.stores;
                    if (checks !== null) for(var i = 0; i < checks.length; i++){
                        var check = checks[i];
                        var getSnapshot = check.getSnapshot;
                        var renderedValue = check.value;
                        try {
                            if (!objectIs(getSnapshot(), renderedValue)) // Found an inconsistent store.
                            return false;
                        } catch (error) {
                            // If `getSnapshot` throws, return `false`. This will schedule
                            // a re-render, and the error will be rethrown during render.
                            return false;
                        }
                    }
                }
            }
            var child = node.child;
            if (node.subtreeFlags & StoreConsistency && child !== null) {
                child.return = node;
                node = child;
                continue;
            }
            if (node === finishedWork) return true;
            while(node.sibling === null){
                if (node.return === null || node.return === finishedWork) return true;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        } // Flow doesn't know this is unreachable, but eslint does
        // eslint-disable-next-line no-unreachable
        return true;
    }
    function markRootSuspended$1(root, suspendedLanes) {
        // When suspending, we should always exclude lanes that were pinged or (more
        // rarely, since we try to avoid it) updated during the render phase.
        // TODO: Lol maybe there's a better way to factor this besides this
        // obnoxiously named function :)
        suspendedLanes = removeLanes(suspendedLanes, workInProgressRootPingedLanes);
        suspendedLanes = removeLanes(suspendedLanes, workInProgressRootInterleavedUpdatedLanes);
        markRootSuspended(root, suspendedLanes);
    } // This is the entry point for synchronous tasks that don't go
    // through Scheduler
    function performSyncWorkOnRoot(root) {
        syncNestedUpdateFlag();
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw new Error('Should not already be working.');
        flushPassiveEffects();
        var lanes = getNextLanes(root, NoLanes);
        if (!includesSomeLane(lanes, SyncLane)) {
            // There's no remaining sync work left.
            ensureRootIsScheduled(root, now());
            return null;
        }
        var exitStatus = renderRootSync(root, lanes);
        if (root.tag !== LegacyRoot && exitStatus === RootErrored) {
            // If something threw an error, try rendering one more time. We'll render
            // synchronously to block concurrent data mutations, and we'll includes
            // all pending updates are included. If it still fails after the second
            // attempt, we'll give up and commit the resulting tree.
            var errorRetryLanes = getLanesToRetrySynchronouslyOnError(root);
            if (errorRetryLanes !== NoLanes) {
                lanes = errorRetryLanes;
                exitStatus = recoverFromConcurrentError(root, errorRetryLanes);
            }
        }
        if (exitStatus === RootFatalErrored) {
            var fatalError = workInProgressRootFatalError;
            prepareFreshStack(root, NoLanes);
            markRootSuspended$1(root, lanes);
            ensureRootIsScheduled(root, now());
            throw fatalError;
        }
        if (exitStatus === RootDidNotComplete) throw new Error('Root did not complete. This is a bug in React.');
         // We now have a consistent tree. Because this is a sync render, we
        // will commit it even if something suspended.
        var finishedWork = root.current.alternate;
        root.finishedWork = finishedWork;
        root.finishedLanes = lanes;
        commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions); // Before exiting, make sure there's a callback scheduled for the next
        // pending level.
        ensureRootIsScheduled(root, now());
        return null;
    }
    function flushRoot(root, lanes) {
        if (lanes !== NoLanes) {
            markRootEntangled(root, mergeLanes(lanes, SyncLane));
            ensureRootIsScheduled(root, now());
            if ((executionContext & (RenderContext | CommitContext)) === NoContext) {
                resetRenderTimer();
                flushSyncCallbacks();
            }
        }
    }
    function batchedUpdates$1(fn, a) {
        var prevExecutionContext = executionContext;
        executionContext |= BatchedContext;
        try {
            return fn(a);
        } finally{
            executionContext = prevExecutionContext; // If there were legacy sync updates, flush them at the end of the outer
            // most batchedUpdates-like method.
            if (executionContext === NoContext && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
            !ReactCurrentActQueue$1.isBatchingLegacy) {
                resetRenderTimer();
                flushSyncCallbacksOnlyInLegacyMode();
            }
        }
    }
    function discreteUpdates(fn, a, b, c, d) {
        var previousPriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig$3.transition;
        try {
            ReactCurrentBatchConfig$3.transition = null;
            setCurrentUpdatePriority(DiscreteEventPriority);
            return fn(a, b, c, d);
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig$3.transition = prevTransition;
            if (executionContext === NoContext) resetRenderTimer();
        }
    } // Overload the definition to the two valid signatures.
    // Warning, this opts-out of checking the function body.
    // eslint-disable-next-line no-redeclare
    function flushSync(fn) {
        // In legacy mode, we flush pending passive effects at the beginning of the
        // next event, not at the end of the previous one.
        if (rootWithPendingPassiveEffects !== null && rootWithPendingPassiveEffects.tag === LegacyRoot && (executionContext & (RenderContext | CommitContext)) === NoContext) flushPassiveEffects();
        var prevExecutionContext = executionContext;
        executionContext |= BatchedContext;
        var prevTransition = ReactCurrentBatchConfig$3.transition;
        var previousPriority = getCurrentUpdatePriority();
        try {
            ReactCurrentBatchConfig$3.transition = null;
            setCurrentUpdatePriority(DiscreteEventPriority);
            if (fn) return fn();
            else return undefined;
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig$3.transition = prevTransition;
            executionContext = prevExecutionContext; // Flush the immediate callbacks that were scheduled during this batch.
            // Note that this will happen even if batchedUpdates is higher up
            // the stack.
            if ((executionContext & (RenderContext | CommitContext)) === NoContext) flushSyncCallbacks();
        }
    }
    function isAlreadyRendering() {
        // Used by the renderer to print a warning if certain APIs are called from
        // the wrong context.
        return (executionContext & (RenderContext | CommitContext)) !== NoContext;
    }
    function pushRenderLanes(fiber, lanes) {
        push(subtreeRenderLanesCursor, subtreeRenderLanes, fiber);
        subtreeRenderLanes = mergeLanes(subtreeRenderLanes, lanes);
        workInProgressRootIncludedLanes = mergeLanes(workInProgressRootIncludedLanes, lanes);
    }
    function popRenderLanes(fiber) {
        subtreeRenderLanes = subtreeRenderLanesCursor.current;
        pop(subtreeRenderLanesCursor, fiber);
    }
    function prepareFreshStack(root, lanes) {
        root.finishedWork = null;
        root.finishedLanes = NoLanes;
        var timeoutHandle = root.timeoutHandle;
        if (timeoutHandle !== noTimeout) {
            // The root previous suspended and scheduled a timeout to commit a fallback
            // state. Now that we have additional work, cancel the timeout.
            root.timeoutHandle = noTimeout; // $FlowFixMe Complains noTimeout is not a TimeoutID, despite the check above
            cancelTimeout(timeoutHandle);
        }
        if (workInProgress !== null) {
            var interruptedWork = workInProgress.return;
            while(interruptedWork !== null){
                var current = interruptedWork.alternate;
                unwindInterruptedWork(current, interruptedWork);
                interruptedWork = interruptedWork.return;
            }
        }
        workInProgressRoot = root;
        var rootWorkInProgress = createWorkInProgress(root.current, null);
        workInProgress = rootWorkInProgress;
        workInProgressRootRenderLanes = subtreeRenderLanes = workInProgressRootIncludedLanes = lanes;
        workInProgressRootExitStatus = RootInProgress;
        workInProgressRootFatalError = null;
        workInProgressRootSkippedLanes = NoLanes;
        workInProgressRootInterleavedUpdatedLanes = NoLanes;
        workInProgressRootPingedLanes = NoLanes;
        workInProgressRootConcurrentErrors = null;
        workInProgressRootRecoverableErrors = null;
        finishQueueingConcurrentUpdates();
        ReactStrictModeWarnings.discardPendingWarnings();
        return rootWorkInProgress;
    }
    function handleError(root, thrownValue) {
        do {
            var erroredWork = workInProgress;
            try {
                // Reset module-level state that was set during the render phase.
                resetContextDependencies();
                resetHooksAfterThrow();
                resetCurrentFiber(); // TODO: I found and added this missing line while investigating a
                // separate issue. Write a regression test using string refs.
                ReactCurrentOwner$2.current = null;
                if (erroredWork === null || erroredWork.return === null) {
                    // Expected to be working on a non-root fiber. This is a fatal error
                    // because there's no ancestor that can handle it; the root is
                    // supposed to capture all errors that weren't caught by an error
                    // boundary.
                    workInProgressRootExitStatus = RootFatalErrored;
                    workInProgressRootFatalError = thrownValue; // Set `workInProgress` to null. This represents advancing to the next
                    // sibling, or the parent if there are no siblings. But since the root
                    // has no siblings nor a parent, we set it to null. Usually this is
                    // handled by `completeUnitOfWork` or `unwindWork`, but since we're
                    // intentionally not calling those, we need set it here.
                    // TODO: Consider calling `unwindWork` to pop the contexts.
                    workInProgress = null;
                    return;
                }
                if (enableProfilerTimer && erroredWork.mode & ProfileMode) // Record the time spent rendering before an error was thrown. This
                // avoids inaccurate Profiler durations in the case of a
                // suspended render.
                stopProfilerTimerIfRunningAndRecordDelta(erroredWork, true);
                if (enableSchedulingProfiler) {
                    markComponentRenderStopped();
                    if (thrownValue !== null && typeof thrownValue === 'object' && typeof thrownValue.then === 'function') {
                        var wakeable = thrownValue;
                        markComponentSuspended(erroredWork, wakeable, workInProgressRootRenderLanes);
                    } else markComponentErrored(erroredWork, thrownValue, workInProgressRootRenderLanes);
                }
                throwException(root, erroredWork.return, erroredWork, thrownValue, workInProgressRootRenderLanes);
                completeUnitOfWork(erroredWork);
            } catch (yetAnotherThrownValue) {
                // Something in the return path also threw.
                thrownValue = yetAnotherThrownValue;
                if (workInProgress === erroredWork && erroredWork !== null) {
                    // If this boundary has already errored, then we had trouble processing
                    // the error. Bubble it to the next boundary.
                    erroredWork = erroredWork.return;
                    workInProgress = erroredWork;
                } else erroredWork = workInProgress;
                continue;
            } // Return to the normal work loop.
            return;
        }while (true);
    }
    function pushDispatcher() {
        var prevDispatcher = ReactCurrentDispatcher$2.current;
        ReactCurrentDispatcher$2.current = ContextOnlyDispatcher;
        if (prevDispatcher === null) // The React isomorphic package does not include a default dispatcher.
        // Instead the first renderer will lazily attach one, in order to give
        // nicer error messages.
        return ContextOnlyDispatcher;
        else return prevDispatcher;
    }
    function popDispatcher(prevDispatcher) {
        ReactCurrentDispatcher$2.current = prevDispatcher;
    }
    function markCommitTimeOfFallback() {
        globalMostRecentFallbackTime = now();
    }
    function markSkippedUpdateLanes(lane) {
        workInProgressRootSkippedLanes = mergeLanes(lane, workInProgressRootSkippedLanes);
    }
    function renderDidSuspend() {
        if (workInProgressRootExitStatus === RootInProgress) workInProgressRootExitStatus = RootSuspended;
    }
    function renderDidSuspendDelayIfPossible() {
        if (workInProgressRootExitStatus === RootInProgress || workInProgressRootExitStatus === RootSuspended || workInProgressRootExitStatus === RootErrored) workInProgressRootExitStatus = RootSuspendedWithDelay;
         // Check if there are updates that we skipped tree that might have unblocked
        // this render.
        if (workInProgressRoot !== null && (includesNonIdleWork(workInProgressRootSkippedLanes) || includesNonIdleWork(workInProgressRootInterleavedUpdatedLanes))) // Mark the current render as suspended so that we switch to working on
        // the updates that were skipped. Usually we only suspend at the end of
        // the render phase.
        // TODO: We should probably always mark the root as suspended immediately
        // (inside this function), since by suspending at the end of the render
        // phase introduces a potential mistake where we suspend lanes that were
        // pinged or updated while we were rendering.
        markRootSuspended$1(workInProgressRoot, workInProgressRootRenderLanes);
    }
    function renderDidError(error) {
        if (workInProgressRootExitStatus !== RootSuspendedWithDelay) workInProgressRootExitStatus = RootErrored;
        if (workInProgressRootConcurrentErrors === null) workInProgressRootConcurrentErrors = [
            error
        ];
        else workInProgressRootConcurrentErrors.push(error);
    } // Called during render to determine if anything has suspended.
    // Returns false if we're not sure.
    function renderHasNotSuspendedYet() {
        // If something errored or completed, we can't really be sure,
        // so those are false.
        return workInProgressRootExitStatus === RootInProgress;
    }
    function renderRootSync(root, lanes) {
        var prevExecutionContext = executionContext;
        executionContext |= RenderContext;
        var prevDispatcher = pushDispatcher(); // If the root or lanes have changed, throw out the existing stack
        // and prepare a fresh one. Otherwise we'll continue where we left off.
        if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) {
            if (isDevToolsPresent) {
                var memoizedUpdaters = root.memoizedUpdaters;
                if (memoizedUpdaters.size > 0) {
                    restorePendingUpdaters(root, workInProgressRootRenderLanes);
                    memoizedUpdaters.clear();
                } // At this point, move Fibers that scheduled the upcoming work from the Map to the Set.
                // If we bailout on this work, we'll move them back (like above).
                // It's important to move them now in case the work spawns more work at the same priority with different updaters.
                // That way we can keep the current update and future updates separate.
                movePendingFibersToMemoized(root, lanes);
            }
            workInProgressTransitions = getTransitionsForLanes();
            prepareFreshStack(root, lanes);
        }
        markRenderStarted(lanes);
        for(;;)try {
            workLoopSync();
            break;
        } catch (thrownValue) {
            handleError(root, thrownValue);
        }
        resetContextDependencies();
        executionContext = prevExecutionContext;
        popDispatcher(prevDispatcher);
        if (workInProgress !== null) // This is a sync render, so we should have finished the whole tree.
        throw new Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");
        markRenderStopped();
        workInProgressRoot = null;
        workInProgressRootRenderLanes = NoLanes;
        return workInProgressRootExitStatus;
    } // The work loop is an extremely hot path. Tell Closure not to inline it.
    /** @noinline */ function workLoopSync() {
        // Already timed out, so perform work without checking if we need to yield.
        while(workInProgress !== null)performUnitOfWork(workInProgress);
    }
    function renderRootConcurrent(root, lanes) {
        var prevExecutionContext = executionContext;
        executionContext |= RenderContext;
        var prevDispatcher = pushDispatcher(); // If the root or lanes have changed, throw out the existing stack
        // and prepare a fresh one. Otherwise we'll continue where we left off.
        if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) {
            if (isDevToolsPresent) {
                var memoizedUpdaters = root.memoizedUpdaters;
                if (memoizedUpdaters.size > 0) {
                    restorePendingUpdaters(root, workInProgressRootRenderLanes);
                    memoizedUpdaters.clear();
                } // At this point, move Fibers that scheduled the upcoming work from the Map to the Set.
                // If we bailout on this work, we'll move them back (like above).
                // It's important to move them now in case the work spawns more work at the same priority with different updaters.
                // That way we can keep the current update and future updates separate.
                movePendingFibersToMemoized(root, lanes);
            }
            workInProgressTransitions = getTransitionsForLanes();
            resetRenderTimer();
            prepareFreshStack(root, lanes);
        }
        markRenderStarted(lanes);
        for(;;)try {
            workLoopConcurrent();
            break;
        } catch (thrownValue) {
            handleError(root, thrownValue);
        }
        resetContextDependencies();
        popDispatcher(prevDispatcher);
        executionContext = prevExecutionContext;
        if (workInProgress !== null) {
            markRenderYielded();
            return RootInProgress;
        } else {
            markRenderStopped();
            workInProgressRoot = null;
            workInProgressRootRenderLanes = NoLanes; // Return the final exit status.
            return workInProgressRootExitStatus;
        }
    }
    /** @noinline */ function workLoopConcurrent() {
        // Perform work until Scheduler asks us to yield
        while(workInProgress !== null && !shouldYield())performUnitOfWork(workInProgress);
    }
    function performUnitOfWork(unitOfWork) {
        // The current, flushed, state of this fiber is the alternate. Ideally
        // nothing should rely on this, but relying on it here means that we don't
        // need an additional field on the work in progress.
        var current = unitOfWork.alternate;
        setCurrentFiber(unitOfWork);
        var next;
        if ((unitOfWork.mode & ProfileMode) !== NoMode) {
            startProfilerTimer(unitOfWork);
            next = beginWork$1(current, unitOfWork, subtreeRenderLanes);
            stopProfilerTimerIfRunningAndRecordDelta(unitOfWork, true);
        } else next = beginWork$1(current, unitOfWork, subtreeRenderLanes);
        resetCurrentFiber();
        unitOfWork.memoizedProps = unitOfWork.pendingProps;
        if (next === null) // If this doesn't spawn new work, complete the current work.
        completeUnitOfWork(unitOfWork);
        else workInProgress = next;
        ReactCurrentOwner$2.current = null;
    }
    function completeUnitOfWork(unitOfWork) {
        // Attempt to complete the current unit of work, then move to the next
        // sibling. If there are no more siblings, return to the parent fiber.
        var completedWork = unitOfWork;
        do {
            // The current, flushed, state of this fiber is the alternate. Ideally
            // nothing should rely on this, but relying on it here means that we don't
            // need an additional field on the work in progress.
            var current = completedWork.alternate;
            var returnFiber = completedWork.return; // Check if the work completed or if something threw.
            if ((completedWork.flags & Incomplete) === NoFlags) {
                setCurrentFiber(completedWork);
                var next = void 0;
                if ((completedWork.mode & ProfileMode) === NoMode) next = completeWork(current, completedWork, subtreeRenderLanes);
                else {
                    startProfilerTimer(completedWork);
                    next = completeWork(current, completedWork, subtreeRenderLanes); // Update render duration assuming we didn't error.
                    stopProfilerTimerIfRunningAndRecordDelta(completedWork, false);
                }
                resetCurrentFiber();
                if (next !== null) {
                    // Completing this fiber spawned new work. Work on that next.
                    workInProgress = next;
                    return;
                }
            } else {
                // This fiber did not complete because something threw. Pop values off
                // the stack without entering the complete phase. If this is a boundary,
                // capture values if possible.
                var _next = unwindWork(current, completedWork); // Because this fiber did not complete, don't reset its lanes.
                if (_next !== null) {
                    // If completing this work spawned new work, do that next. We'll come
                    // back here again.
                    // Since we're restarting, remove anything that is not a host effect
                    // from the effect tag.
                    _next.flags &= HostEffectMask;
                    workInProgress = _next;
                    return;
                }
                if ((completedWork.mode & ProfileMode) !== NoMode) {
                    // Record the render duration for the fiber that errored.
                    stopProfilerTimerIfRunningAndRecordDelta(completedWork, false); // Include the time spent working on failed children before continuing.
                    var actualDuration = completedWork.actualDuration;
                    var child = completedWork.child;
                    while(child !== null){
                        actualDuration += child.actualDuration;
                        child = child.sibling;
                    }
                    completedWork.actualDuration = actualDuration;
                }
                if (returnFiber !== null) {
                    // Mark the parent fiber as incomplete and clear its subtree flags.
                    returnFiber.flags |= Incomplete;
                    returnFiber.subtreeFlags = NoFlags;
                    returnFiber.deletions = null;
                } else {
                    // We've unwound all the way to the root.
                    workInProgressRootExitStatus = RootDidNotComplete;
                    workInProgress = null;
                    return;
                }
            }
            var siblingFiber = completedWork.sibling;
            if (siblingFiber !== null) {
                // If there is more work to do in this returnFiber, do that next.
                workInProgress = siblingFiber;
                return;
            } // Otherwise, return to the parent
            completedWork = returnFiber; // Update the next thing we're working on in case something throws.
            workInProgress = completedWork;
        }while (completedWork !== null); // We've reached the root.
        if (workInProgressRootExitStatus === RootInProgress) workInProgressRootExitStatus = RootCompleted;
    }
    function commitRoot(root, recoverableErrors, transitions) {
        // TODO: This no longer makes any sense. We already wrap the mutation and
        // layout phases. Should be able to remove.
        var previousUpdateLanePriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig$3.transition;
        try {
            ReactCurrentBatchConfig$3.transition = null;
            setCurrentUpdatePriority(DiscreteEventPriority);
            commitRootImpl(root, recoverableErrors, transitions, previousUpdateLanePriority);
        } finally{
            ReactCurrentBatchConfig$3.transition = prevTransition;
            setCurrentUpdatePriority(previousUpdateLanePriority);
        }
        return null;
    }
    function commitRootImpl(root, recoverableErrors, transitions, renderPriorityLevel) {
        do // `flushPassiveEffects` will call `flushSyncUpdateQueue` at the end, which
        // means `flushPassiveEffects` will sometimes result in additional
        // passive effects. So we need to keep flushing in a loop until there are
        // no more pending effects.
        // TODO: Might be better if `flushPassiveEffects` did not automatically
        // flush synchronous work at the end, to avoid factoring hazards like this.
        flushPassiveEffects();
        while (rootWithPendingPassiveEffects !== null);
        flushRenderPhaseStrictModeWarningsInDEV();
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw new Error('Should not already be working.');
        var finishedWork = root.finishedWork;
        var lanes = root.finishedLanes;
        markCommitStarted(lanes);
        if (finishedWork === null) {
            markCommitStopped();
            return null;
        } else if (lanes === NoLanes) error("root.finishedLanes should not be empty during a commit. This is a bug in React.");
        root.finishedWork = null;
        root.finishedLanes = NoLanes;
        if (finishedWork === root.current) throw new Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
         // commitRoot never returns a continuation; it always finishes synchronously.
        // So we can clear these now to allow a new callback to be scheduled.
        root.callbackNode = null;
        root.callbackPriority = NoLane; // Update the first and last pending times on this root. The new first
        // pending time is whatever is left on the root fiber.
        var remainingLanes = mergeLanes(finishedWork.lanes, finishedWork.childLanes);
        markRootFinished(root, remainingLanes);
        if (root === workInProgressRoot) {
            // We can reset these now that they are finished.
            workInProgressRoot = null;
            workInProgress = null;
            workInProgressRootRenderLanes = NoLanes;
        } // If there are pending passive effects, schedule a callback to process them.
        // Do this as early as possible, so it is queued before anything else that
        // might get scheduled in the commit phase. (See #16714.)
        // TODO: Delete all other places that schedule the passive effect callback
        // They're redundant.
        if ((finishedWork.subtreeFlags & PassiveMask) !== NoFlags || (finishedWork.flags & PassiveMask) !== NoFlags) {
            if (!rootDoesHavePassiveEffects) {
                rootDoesHavePassiveEffects = true;
                // to store it in pendingPassiveTransitions until they get processed
                // We need to pass this through as an argument to commitRoot
                // because workInProgressTransitions might have changed between
                // the previous render and commit if we throttle the commit
                // with setTimeout
                pendingPassiveTransitions = transitions;
                scheduleCallback$1(NormalPriority, function() {
                    flushPassiveEffects(); // This render triggered passive effects: release the root cache pool
                    // *after* passive effects fire to avoid freeing a cache pool that may
                    // be referenced by a node in the tree (HostRoot, Cache boundary etc)
                    return null;
                });
            }
        } // Check if there are any effects in the whole tree.
        // TODO: This is left over from the effect list implementation, where we had
        // to check for the existence of `firstEffect` to satisfy Flow. I think the
        // only other reason this optimization exists is because it affects profiling.
        // Reconsider whether this is necessary.
        var subtreeHasEffects = (finishedWork.subtreeFlags & (BeforeMutationMask | MutationMask | LayoutMask | PassiveMask)) !== NoFlags;
        var rootHasEffect = (finishedWork.flags & (BeforeMutationMask | MutationMask | LayoutMask | PassiveMask)) !== NoFlags;
        if (subtreeHasEffects || rootHasEffect) {
            var prevTransition = ReactCurrentBatchConfig$3.transition;
            ReactCurrentBatchConfig$3.transition = null;
            var previousPriority = getCurrentUpdatePriority();
            setCurrentUpdatePriority(DiscreteEventPriority);
            var prevExecutionContext = executionContext;
            executionContext |= CommitContext; // Reset this to null before calling lifecycles
            ReactCurrentOwner$2.current = null; // The commit phase is broken into several sub-phases. We do a separate pass
            // of the effect list for each phase: all mutation effects come before all
            // layout effects, and so on.
            // The first phase a "before mutation" phase. We use this phase to read the
            // state of the host tree right before we mutate it. This is where
            // getSnapshotBeforeUpdate is called.
            var shouldFireAfterActiveInstanceBlur = commitBeforeMutationEffects(root, finishedWork);
            // Mark the current commit time to be shared by all Profilers in this
            // batch. This enables them to be grouped later.
            recordCommitTime();
            commitMutationEffects(root, finishedWork, lanes);
            resetAfterCommit(root.containerInfo); // The work-in-progress tree is now the current tree. This must come after
            // the mutation phase, so that the previous tree is still current during
            // componentWillUnmount, but before the layout phase, so that the finished
            // work is current during componentDidMount/Update.
            root.current = finishedWork; // The next phase is the layout phase, where we call effects that read
            markLayoutEffectsStarted(lanes);
            commitLayoutEffects(finishedWork, root, lanes);
            markLayoutEffectsStopped();
            // opportunity to paint.
            requestPaint();
            executionContext = prevExecutionContext; // Reset the priority to the previous non-sync value.
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig$3.transition = prevTransition;
        } else {
            // No effects.
            root.current = finishedWork; // Measure these anyway so the flamegraph explicitly shows that there were
            recordCommitTime();
        }
        var rootDidHavePassiveEffects = rootDoesHavePassiveEffects;
        if (rootDoesHavePassiveEffects) {
            // This commit has passive effects. Stash a reference to them. But don't
            // schedule a callback until after flushing layout work.
            rootDoesHavePassiveEffects = false;
            rootWithPendingPassiveEffects = root;
            pendingPassiveEffectsLanes = lanes;
        } else {
            nestedPassiveUpdateCount = 0;
            rootWithPassiveNestedUpdates = null;
        } // Read this again, since an effect might have updated it
        remainingLanes = root.pendingLanes; // Check if there's remaining work on this root
        // TODO: This is part of the `componentDidCatch` implementation. Its purpose
        // is to detect whether something might have called setState inside
        // `componentDidCatch`. The mechanism is known to be flawed because `setState`
        // inside `componentDidCatch` is itself flawed — that's why we recommend
        // `getDerivedStateFromError` instead. However, it could be improved by
        // checking if remainingLanes includes Sync work, instead of whether there's
        // any work remaining at all (which would also include stuff like Suspense
        // retries or transitions). It's been like this for a while, though, so fixing
        // it probably isn't that urgent.
        if (remainingLanes === NoLanes) // If there's no remaining work, we can clear the set of already failed
        // error boundaries.
        legacyErrorBoundariesThatAlreadyFailed = null;
        if (!rootDidHavePassiveEffects) commitDoubleInvokeEffectsInDEV(root.current, false);
        onCommitRoot(finishedWork.stateNode, renderPriorityLevel);
        if (isDevToolsPresent) root.memoizedUpdaters.clear();
        onCommitRoot$1();
        // additional work on this root is scheduled.
        ensureRootIsScheduled(root, now());
        if (recoverableErrors !== null) {
            // There were errors during this render, but recovered from them without
            // needing to surface it to the UI. We log them here.
            var onRecoverableError = root.onRecoverableError;
            for(var i = 0; i < recoverableErrors.length; i++){
                var recoverableError = recoverableErrors[i];
                var componentStack = recoverableError.stack;
                var digest = recoverableError.digest;
                onRecoverableError(recoverableError.value, {
                    componentStack: componentStack,
                    digest: digest
                });
            }
        }
        if (hasUncaughtError) {
            hasUncaughtError = false;
            var error$1 = firstUncaughtError;
            firstUncaughtError = null;
            throw error$1;
        } // If the passive effects are the result of a discrete render, flush them
        // synchronously at the end of the current task so that the result is
        // immediately observable. Otherwise, we assume that they are not
        // order-dependent and do not need to be observed by external systems, so we
        // can wait until after paint.
        // TODO: We can optimize this by not scheduling the callback earlier. Since we
        // currently schedule the callback in multiple places, will wait until those
        // are consolidated.
        if (includesSomeLane(pendingPassiveEffectsLanes, SyncLane) && root.tag !== LegacyRoot) flushPassiveEffects();
         // Read this again, since a passive effect might have updated it
        remainingLanes = root.pendingLanes;
        if (includesSomeLane(remainingLanes, SyncLane)) {
            markNestedUpdateScheduled();
            // finishing. If there are too many, it indicates an infinite update loop.
            if (root === rootWithNestedUpdates) nestedUpdateCount++;
            else {
                nestedUpdateCount = 0;
                rootWithNestedUpdates = root;
            }
        } else nestedUpdateCount = 0;
         // If layout work was scheduled, flush it now.
        flushSyncCallbacks();
        markCommitStopped();
        return null;
    }
    function flushPassiveEffects() {
        // Returns whether passive effects were flushed.
        // TODO: Combine this check with the one in flushPassiveEFfectsImpl. We should
        // probably just combine the two functions. I believe they were only separate
        // in the first place because we used to wrap it with
        // `Scheduler.runWithPriority`, which accepts a function. But now we track the
        // priority within React itself, so we can mutate the variable directly.
        if (rootWithPendingPassiveEffects !== null) {
            var renderPriority = lanesToEventPriority(pendingPassiveEffectsLanes);
            var priority = lowerEventPriority(DefaultEventPriority, renderPriority);
            var prevTransition = ReactCurrentBatchConfig$3.transition;
            var previousPriority = getCurrentUpdatePriority();
            try {
                ReactCurrentBatchConfig$3.transition = null;
                setCurrentUpdatePriority(priority);
                return flushPassiveEffectsImpl();
            } finally{
                setCurrentUpdatePriority(previousPriority);
                ReactCurrentBatchConfig$3.transition = prevTransition; // Once passive effects have run for the tree - giving components a
            }
        }
        return false;
    }
    function enqueuePendingPassiveProfilerEffect(fiber) {
        pendingPassiveProfilerEffects.push(fiber);
        if (!rootDoesHavePassiveEffects) {
            rootDoesHavePassiveEffects = true;
            scheduleCallback$1(NormalPriority, function() {
                flushPassiveEffects();
                return null;
            });
        }
    }
    function flushPassiveEffectsImpl() {
        if (rootWithPendingPassiveEffects === null) return false;
         // Cache and clear the transitions flag
        var transitions = pendingPassiveTransitions;
        pendingPassiveTransitions = null;
        var root = rootWithPendingPassiveEffects;
        var lanes = pendingPassiveEffectsLanes;
        rootWithPendingPassiveEffects = null; // TODO: This is sometimes out of sync with rootWithPendingPassiveEffects.
        // Figure out why and fix it. It's not causing any known issues (probably
        // because it's only used for profiling), but it's a refactor hazard.
        pendingPassiveEffectsLanes = NoLanes;
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw new Error('Cannot flush passive effects while already rendering.');
        isFlushingPassiveEffects = true;
        didScheduleUpdateDuringPassiveEffects = false;
        markPassiveEffectsStarted(lanes);
        var prevExecutionContext = executionContext;
        executionContext |= CommitContext;
        commitPassiveUnmountEffects(root.current);
        commitPassiveMountEffects(root, root.current, lanes, transitions); // TODO: Move to commitPassiveMountEffects
        var profilerEffects = pendingPassiveProfilerEffects;
        pendingPassiveProfilerEffects = [];
        for(var i = 0; i < profilerEffects.length; i++){
            var _fiber = profilerEffects[i];
            commitPassiveEffectDurations(root, _fiber);
        }
        markPassiveEffectsStopped();
        commitDoubleInvokeEffectsInDEV(root.current, true);
        executionContext = prevExecutionContext;
        flushSyncCallbacks();
        // If additional passive effects were scheduled, increment a counter. If this
        // exceeds the limit, we'll fire a warning.
        if (didScheduleUpdateDuringPassiveEffects) {
            if (root === rootWithPassiveNestedUpdates) nestedPassiveUpdateCount++;
            else {
                nestedPassiveUpdateCount = 0;
                rootWithPassiveNestedUpdates = root;
            }
        } else nestedPassiveUpdateCount = 0;
        isFlushingPassiveEffects = false;
        didScheduleUpdateDuringPassiveEffects = false;
        onPostCommitRoot(root);
        var stateNode = root.current.stateNode;
        stateNode.effectDuration = 0;
        stateNode.passiveEffectDuration = 0;
        return true;
    }
    function isAlreadyFailedLegacyErrorBoundary(instance) {
        return legacyErrorBoundariesThatAlreadyFailed !== null && legacyErrorBoundariesThatAlreadyFailed.has(instance);
    }
    function markLegacyErrorBoundaryAsFailed(instance) {
        if (legacyErrorBoundariesThatAlreadyFailed === null) legacyErrorBoundariesThatAlreadyFailed = new Set([
            instance
        ]);
        else legacyErrorBoundariesThatAlreadyFailed.add(instance);
    }
    function prepareToThrowUncaughtError(error) {
        if (!hasUncaughtError) {
            hasUncaughtError = true;
            firstUncaughtError = error;
        }
    }
    var onUncaughtError = prepareToThrowUncaughtError;
    function captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
        var errorInfo = createCapturedValueAtFiber(error, sourceFiber);
        var update = createRootErrorUpdate(rootFiber, errorInfo, SyncLane);
        var root = enqueueUpdate(rootFiber, update, SyncLane);
        var eventTime = requestEventTime();
        if (root !== null) {
            markRootUpdated(root, SyncLane, eventTime);
            ensureRootIsScheduled(root, eventTime);
        }
    }
    function captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error$1) {
        reportUncaughtErrorInDEV(error$1);
        setIsRunningInsertionEffect(false);
        if (sourceFiber.tag === HostRoot) {
            // Error was thrown at the root. There is no parent, so the root
            // itself should capture it.
            captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error$1);
            return;
        }
        var fiber = null;
        fiber = nearestMountedAncestor;
        while(fiber !== null){
            if (fiber.tag === HostRoot) {
                captureCommitPhaseErrorOnRoot(fiber, sourceFiber, error$1);
                return;
            } else if (fiber.tag === ClassComponent) {
                var ctor = fiber.type;
                var instance = fiber.stateNode;
                if (typeof ctor.getDerivedStateFromError === 'function' || typeof instance.componentDidCatch === 'function' && !isAlreadyFailedLegacyErrorBoundary(instance)) {
                    var errorInfo = createCapturedValueAtFiber(error$1, sourceFiber);
                    var update = createClassErrorUpdate(fiber, errorInfo, SyncLane);
                    var root = enqueueUpdate(fiber, update, SyncLane);
                    var eventTime = requestEventTime();
                    if (root !== null) {
                        markRootUpdated(root, SyncLane, eventTime);
                        ensureRootIsScheduled(root, eventTime);
                    }
                    return;
                }
            }
            fiber = fiber.return;
        }
        // TODO: Until we re-land skipUnmountedBoundaries (see #20147), this warning
        // will fire for errors that are thrown by destroy functions inside deleted
        // trees. What it should instead do is propagate the error to the parent of
        // the deleted tree. In the meantime, do not add this warning to the
        // allowlist; this is only for our internal use.
        error("Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Likely causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.\n\nError message:\n\n%s", error$1);
    }
    function pingSuspendedRoot(root, wakeable, pingedLanes) {
        var pingCache = root.pingCache;
        if (pingCache !== null) // The wakeable resolved, so we no longer need to memoize, because it will
        // never be thrown again.
        pingCache.delete(wakeable);
        var eventTime = requestEventTime();
        markRootPinged(root, pingedLanes);
        warnIfSuspenseResolutionNotWrappedWithActDEV(root);
        if (workInProgressRoot === root && isSubsetOfLanes(workInProgressRootRenderLanes, pingedLanes)) {
            // Received a ping at the same priority level at which we're currently
            // rendering. We might want to restart this render. This should mirror
            // the logic of whether or not a root suspends once it completes.
            // TODO: If we're rendering sync either due to Sync, Batched or expired,
            // we should probably never restart.
            // If we're suspended with delay, or if it's a retry, we'll always suspend
            // so we can always restart.
            if (workInProgressRootExitStatus === RootSuspendedWithDelay || workInProgressRootExitStatus === RootSuspended && includesOnlyRetries(workInProgressRootRenderLanes) && now() - globalMostRecentFallbackTime < FALLBACK_THROTTLE_MS) // Restart from the root.
            prepareFreshStack(root, NoLanes);
            else // Even though we can't restart right now, we might get an
            // opportunity later. So we mark this render as having a ping.
            workInProgressRootPingedLanes = mergeLanes(workInProgressRootPingedLanes, pingedLanes);
        }
        ensureRootIsScheduled(root, eventTime);
    }
    function retryTimedOutBoundary(boundaryFiber, retryLane) {
        // The boundary fiber (a Suspense component or SuspenseList component)
        // previously was rendered in its fallback state. One of the promises that
        // suspended it has resolved, which means at least part of the tree was
        // likely unblocked. Try rendering again, at a new lanes.
        if (retryLane === NoLane) // TODO: Assign this to `suspenseState.retryLane`? to avoid
        // unnecessary entanglement?
        retryLane = requestRetryLane(boundaryFiber);
         // TODO: Special case idle priority?
        var eventTime = requestEventTime();
        var root = enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
        if (root !== null) {
            markRootUpdated(root, retryLane, eventTime);
            ensureRootIsScheduled(root, eventTime);
        }
    }
    function retryDehydratedSuspenseBoundary(boundaryFiber) {
        var suspenseState = boundaryFiber.memoizedState;
        var retryLane = NoLane;
        if (suspenseState !== null) retryLane = suspenseState.retryLane;
        retryTimedOutBoundary(boundaryFiber, retryLane);
    }
    function resolveRetryWakeable(boundaryFiber, wakeable) {
        var retryLane = NoLane; // Default
        var retryCache;
        switch(boundaryFiber.tag){
            case SuspenseComponent:
                retryCache = boundaryFiber.stateNode;
                var suspenseState = boundaryFiber.memoizedState;
                if (suspenseState !== null) retryLane = suspenseState.retryLane;
                break;
            case SuspenseListComponent:
                retryCache = boundaryFiber.stateNode;
                break;
            default:
                throw new Error("Pinged unknown suspense boundary type. This is probably a bug in React.");
        }
        if (retryCache !== null) // The wakeable resolved, so we no longer need to memoize, because it will
        // never be thrown again.
        retryCache.delete(wakeable);
        retryTimedOutBoundary(boundaryFiber, retryLane);
    } // Computes the next Just Noticeable Difference (JND) boundary.
    // The theory is that a person can't tell the difference between small differences in time.
    // Therefore, if we wait a bit longer than necessary that won't translate to a noticeable
    // difference in the experience. However, waiting for longer might mean that we can avoid
    // showing an intermediate loading state. The longer we have already waited, the harder it
    // is to tell small differences in time. Therefore, the longer we've already waited,
    // the longer we can wait additionally. At some point we have to give up though.
    // We pick a train model where the next boundary commits at a consistent schedule.
    // These particular numbers are vague estimates. We expect to adjust them based on research.
    function jnd(timeElapsed) {
        return timeElapsed < 120 ? 120 : timeElapsed < 480 ? 480 : timeElapsed < 1080 ? 1080 : timeElapsed < 1920 ? 1920 : timeElapsed < 3000 ? 3000 : timeElapsed < 4320 ? 4320 : ceil(timeElapsed / 1960) * 1960;
    }
    function checkForNestedUpdates() {
        if (nestedUpdateCount > NESTED_UPDATE_LIMIT) {
            nestedUpdateCount = 0;
            rootWithNestedUpdates = null;
            throw new Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
        }
        if (nestedPassiveUpdateCount > NESTED_PASSIVE_UPDATE_LIMIT) {
            nestedPassiveUpdateCount = 0;
            rootWithPassiveNestedUpdates = null;
            error("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render.");
        }
    }
    function flushRenderPhaseStrictModeWarningsInDEV() {
        ReactStrictModeWarnings.flushLegacyContextWarning();
        ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings();
    }
    function commitDoubleInvokeEffectsInDEV(fiber, hasPassiveEffects) {
        // TODO (StrictEffects) Should we set a marker on the root if it contains strict effects
        // so we don't traverse unnecessarily? similar to subtreeFlags but just at the root level.
        // Maybe not a big deal since this is DEV only behavior.
        setCurrentFiber(fiber);
        invokeEffectsInDev(fiber, MountLayoutDev, invokeLayoutEffectUnmountInDEV);
        if (hasPassiveEffects) invokeEffectsInDev(fiber, MountPassiveDev, invokePassiveEffectUnmountInDEV);
        invokeEffectsInDev(fiber, MountLayoutDev, invokeLayoutEffectMountInDEV);
        if (hasPassiveEffects) invokeEffectsInDev(fiber, MountPassiveDev, invokePassiveEffectMountInDEV);
        resetCurrentFiber();
    }
    function invokeEffectsInDev(firstChild, fiberFlags, invokeEffectFn) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        var current = firstChild;
        var subtreeRoot = null;
        while(current !== null){
            var primarySubtreeFlag = current.subtreeFlags & fiberFlags;
            if (current !== subtreeRoot && current.child !== null && primarySubtreeFlag !== NoFlags) current = current.child;
            else {
                if ((current.flags & fiberFlags) !== NoFlags) invokeEffectFn(current);
                if (current.sibling !== null) current = current.sibling;
                else current = subtreeRoot = current.return;
            }
        }
    }
    var didWarnStateUpdateForNotYetMountedComponent = null;
    function warnAboutUpdateOnNotYetMountedFiberInDEV(fiber) {
        if ((executionContext & RenderContext) !== NoContext) // We let the other warning about render phase updates deal with this one.
        return;
        if (!(fiber.mode & ConcurrentMode)) return;
        var tag = fiber.tag;
        if (tag !== IndeterminateComponent && tag !== HostRoot && tag !== ClassComponent && tag !== FunctionComponent && tag !== ForwardRef && tag !== MemoComponent && tag !== SimpleMemoComponent) // Only warn for user-defined components, not internal ones like Suspense.
        return;
         // We show the whole stack but dedupe on the top component's name because
        // the problematic code almost always lies inside that component.
        var componentName = getComponentNameFromFiber(fiber) || 'ReactComponent';
        if (didWarnStateUpdateForNotYetMountedComponent !== null) {
            if (didWarnStateUpdateForNotYetMountedComponent.has(componentName)) return;
            didWarnStateUpdateForNotYetMountedComponent.add(componentName);
        } else didWarnStateUpdateForNotYetMountedComponent = new Set([
            componentName
        ]);
        var previousFiber = current;
        try {
            setCurrentFiber(fiber);
            error("Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead.");
        } finally{
            if (previousFiber) setCurrentFiber(fiber);
            else resetCurrentFiber();
        }
    }
    var beginWork$1;
    var dummyFiber = null;
    beginWork$1 = function beginWork$1(current, unitOfWork, lanes) {
        // If a component throws an error, we replay it again in a synchronously
        // dispatched event, so that the debugger will treat it as an uncaught
        // error See ReactErrorUtils for more information.
        // Before entering the begin phase, copy the work-in-progress onto a dummy
        // fiber. If beginWork throws, we'll use this to reset the state.
        var originalWorkInProgressCopy = assignFiberPropertiesInDEV(dummyFiber, unitOfWork);
        try {
            return beginWork(current, unitOfWork, lanes);
        } catch (originalError) {
            if (didSuspendOrErrorWhileHydratingDEV() || originalError !== null && typeof originalError === 'object' && typeof originalError.then === 'function') // Don't replay promises.
            // Don't replay errors if we are hydrating and have already suspended or handled an error
            throw originalError;
             // Keep this code in sync with handleError; any changes here must have
            // corresponding changes there.
            resetContextDependencies();
            resetHooksAfterThrow(); // Don't reset current debug fiber, since we're about to work on the
            // same fiber again.
            // Unwind the failed stack frame
            unwindInterruptedWork(current, unitOfWork); // Restore the original properties of the fiber.
            assignFiberPropertiesInDEV(unitOfWork, originalWorkInProgressCopy);
            if (unitOfWork.mode & ProfileMode) // Reset the profiler timer.
            startProfilerTimer(unitOfWork);
             // Run beginWork again.
            invokeGuardedCallback(null, beginWork, null, current, unitOfWork, lanes);
            if (hasCaughtError()) {
                var replayError = clearCaughtError();
                if (typeof replayError === 'object' && replayError !== null && replayError._suppressLogging && typeof originalError === 'object' && originalError !== null && !originalError._suppressLogging) // If suppressed, let the flag carry over to the original error which is the one we'll rethrow.
                originalError._suppressLogging = true;
            } // We always throw the original error in case the second render pass is not idempotent.
            // This can happen if a memoized function or CommonJS module doesn't throw after first invocation.
            throw originalError;
        }
    };
    var didWarnAboutUpdateInRender = false;
    var didWarnAboutUpdateInRenderForAnotherComponent;
    didWarnAboutUpdateInRenderForAnotherComponent = new Set();
    function warnAboutRenderPhaseUpdatesInDEV(fiber) {
        if (isRendering && !getIsUpdatingOpaqueValueInRenderPhaseInDEV()) switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                var renderingComponentName = workInProgress && getComponentNameFromFiber(workInProgress) || 'Unknown'; // Dedupe by the rendering component because it's the one that needs to be fixed.
                var dedupeKey = renderingComponentName;
                if (!didWarnAboutUpdateInRenderForAnotherComponent.has(dedupeKey)) {
                    didWarnAboutUpdateInRenderForAnotherComponent.add(dedupeKey);
                    var setStateComponentName = getComponentNameFromFiber(fiber) || 'Unknown';
                    error("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://reactjs.org/link/setstate-in-render", setStateComponentName, renderingComponentName, renderingComponentName);
                }
                break;
            case ClassComponent:
                if (!didWarnAboutUpdateInRender) {
                    error("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state.");
                    didWarnAboutUpdateInRender = true;
                }
                break;
        }
    }
    function restorePendingUpdaters(root, lanes) {
        if (isDevToolsPresent) {
            var memoizedUpdaters = root.memoizedUpdaters;
            memoizedUpdaters.forEach(function(schedulingFiber) {
                addFiberToLanesMap(root, schedulingFiber, lanes);
            }); // This function intentionally does not clear memoized updaters.
        // Those may still be relevant to the current commit
        // and a future one (e.g. Suspense).
        }
    }
    var fakeActCallbackNode = {};
    function scheduleCallback$1(priorityLevel, callback) {
        // If we're currently inside an `act` scope, bypass Scheduler and push to
        // the `act` queue instead.
        var actQueue = ReactCurrentActQueue$1.current;
        if (actQueue !== null) {
            actQueue.push(callback);
            return fakeActCallbackNode;
        } else return scheduleCallback(priorityLevel, callback);
    }
    function cancelCallback$1(callbackNode) {
        if (callbackNode === fakeActCallbackNode) return;
         // In production, always call Scheduler. This function will be stripped out.
        return cancelCallback(callbackNode);
    }
    function shouldForceFlushFallbacksInDEV() {
        // Never force flush in production. This function should get stripped out.
        return ReactCurrentActQueue$1.current !== null;
    }
    function warnIfUpdatesNotWrappedWithActDEV(fiber) {
        if (fiber.mode & ConcurrentMode) {
            if (!isConcurrentActEnvironment()) // Not in an act environment. No need to warn.
            return;
        } else {
            // Legacy mode has additional cases where we suppress a warning.
            if (!isLegacyActEnvironment()) // Not in an act environment. No need to warn.
            return;
            if (executionContext !== NoContext) // Legacy mode doesn't warn if the update is batched, i.e.
            // batchedUpdates or flushSync.
            return;
            if (fiber.tag !== FunctionComponent && fiber.tag !== ForwardRef && fiber.tag !== SimpleMemoComponent) // For backwards compatibility with pre-hooks code, legacy mode only
            // warns for updates that originate from a hook.
            return;
        }
        if (ReactCurrentActQueue$1.current === null) {
            var previousFiber = current;
            try {
                setCurrentFiber(fiber);
                error("An update to %s inside a test was not wrapped in act(...).\n\nWhen testing, code that causes React state updates should be wrapped into act(...):\n\nact(() => {\n  /* fire events that update state */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act", getComponentNameFromFiber(fiber));
            } finally{
                if (previousFiber) setCurrentFiber(fiber);
                else resetCurrentFiber();
            }
        }
    }
    function warnIfSuspenseResolutionNotWrappedWithActDEV(root) {
        if (root.tag !== LegacyRoot && isConcurrentActEnvironment() && ReactCurrentActQueue$1.current === null) error("A suspended resource finished loading inside a test, but the event was not wrapped in act(...).\n\nWhen testing, code that resolves suspended data should be wrapped into act(...):\n\nact(() => {\n  /* finish loading suspended data */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act");
    }
    function setIsRunningInsertionEffect(isRunning) {
        isRunningInsertionEffect = isRunning;
    }
    /* eslint-disable react-internal/prod-error-codes */ var resolveFamily = null; // $FlowFixMe Flow gets confused by a WeakSet feature check below.
    var failedBoundaries = null;
    var setRefreshHandler = function setRefreshHandler(handler) {
        resolveFamily = handler;
    };
    function resolveFunctionForHotReloading(type) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return type;
        var family = resolveFamily(type);
        if (family === undefined) return type;
         // Use the latest known implementation.
        return family.current;
    }
    function resolveClassForHotReloading(type) {
        // No implementation differences.
        return resolveFunctionForHotReloading(type);
    }
    function resolveForwardRefForHotReloading(type) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return type;
        var family = resolveFamily(type);
        if (family === undefined) {
            // Check if we're dealing with a real forwardRef. Don't want to crash early.
            if (type !== null && type !== undefined && typeof type.render === 'function') {
                // ForwardRef is special because its resolved .type is an object,
                // but it's possible that we only have its inner render function in the map.
                // If that inner render function is different, we'll build a new forwardRef type.
                var currentRender = resolveFunctionForHotReloading(type.render);
                if (type.render !== currentRender) {
                    var syntheticType = {
                        $$typeof: REACT_FORWARD_REF_TYPE,
                        render: currentRender
                    };
                    if (type.displayName !== undefined) syntheticType.displayName = type.displayName;
                    return syntheticType;
                }
            }
            return type;
        } // Use the latest known implementation.
        return family.current;
    }
    function isCompatibleFamilyForHotReloading(fiber, element) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return false;
        var prevType = fiber.elementType;
        var nextType = element.type; // If we got here, we know types aren't === equal.
        var needsCompareFamilies = false;
        var $$typeofNextType = typeof nextType === 'object' && nextType !== null ? nextType.$$typeof : null;
        switch(fiber.tag){
            case ClassComponent:
                if (typeof nextType === 'function') needsCompareFamilies = true;
                break;
            case FunctionComponent:
                if (typeof nextType === 'function') needsCompareFamilies = true;
                else if ($$typeofNextType === REACT_LAZY_TYPE) // We don't know the inner type yet.
                // We're going to assume that the lazy inner type is stable,
                // and so it is sufficient to avoid reconciling it away.
                // We're not going to unwrap or actually use the new lazy type.
                needsCompareFamilies = true;
                break;
            case ForwardRef:
                if ($$typeofNextType === REACT_FORWARD_REF_TYPE) needsCompareFamilies = true;
                else if ($$typeofNextType === REACT_LAZY_TYPE) needsCompareFamilies = true;
                break;
            case MemoComponent:
            case SimpleMemoComponent:
                if ($$typeofNextType === REACT_MEMO_TYPE) // TODO: if it was but can no longer be simple,
                // we shouldn't set this.
                needsCompareFamilies = true;
                else if ($$typeofNextType === REACT_LAZY_TYPE) needsCompareFamilies = true;
                break;
            default:
                return false;
        } // Check if both types have a family and it's the same one.
        if (needsCompareFamilies) {
            // Note: memo() and forwardRef() we'll compare outer rather than inner type.
            // This means both of them need to be registered to preserve state.
            // If we unwrapped and compared the inner types for wrappers instead,
            // then we would risk falsely saying two separate memo(Foo)
            // calls are equivalent because they wrap the same Foo function.
            var prevFamily = resolveFamily(prevType);
            if (prevFamily !== undefined && prevFamily === resolveFamily(nextType)) return true;
        }
        return false;
    }
    function markFailedErrorBoundaryForHotReloading(fiber) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return;
        if (typeof WeakSet !== 'function') return;
        if (failedBoundaries === null) failedBoundaries = new WeakSet();
        failedBoundaries.add(fiber);
    }
    var scheduleRefresh = function scheduleRefresh(root, update) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return;
        var staleFamilies = update.staleFamilies, updatedFamilies = update.updatedFamilies;
        flushPassiveEffects();
        flushSync(function() {
            scheduleFibersWithFamiliesRecursively(root.current, updatedFamilies, staleFamilies);
        });
    };
    var scheduleRoot = function scheduleRoot(root, element) {
        if (root.context !== emptyContextObject) // Super edge case: root has a legacy _renderSubtree context
        // but we don't know the parentComponent so we can't pass it.
        // Just ignore. We'll delete this with _renderSubtree code path later.
        return;
        flushPassiveEffects();
        flushSync(function() {
            updateContainer(element, root, null, null);
        });
    };
    function scheduleFibersWithFamiliesRecursively(fiber, updatedFamilies, staleFamilies) {
        var alternate = fiber.alternate, child = fiber.child, sibling = fiber.sibling, tag = fiber.tag, type = fiber.type;
        var candidateType = null;
        switch(tag){
            case FunctionComponent:
            case SimpleMemoComponent:
            case ClassComponent:
                candidateType = type;
                break;
            case ForwardRef:
                candidateType = type.render;
                break;
        }
        if (resolveFamily === null) throw new Error('Expected resolveFamily to be set during hot reload.');
        var needsRender = false;
        var needsRemount = false;
        if (candidateType !== null) {
            var family = resolveFamily(candidateType);
            if (family !== undefined) {
                if (staleFamilies.has(family)) needsRemount = true;
                else if (updatedFamilies.has(family)) {
                    if (tag === ClassComponent) needsRemount = true;
                    else needsRender = true;
                }
            }
        }
        if (failedBoundaries !== null) {
            if (failedBoundaries.has(fiber) || alternate !== null && failedBoundaries.has(alternate)) needsRemount = true;
        }
        if (needsRemount) fiber._debugNeedsRemount = true;
        if (needsRemount || needsRender) {
            var _root = enqueueConcurrentRenderForLane(fiber, SyncLane);
            if (_root !== null) scheduleUpdateOnFiber(_root, fiber, SyncLane, NoTimestamp);
        }
        if (child !== null && !needsRemount) scheduleFibersWithFamiliesRecursively(child, updatedFamilies, staleFamilies);
        if (sibling !== null) scheduleFibersWithFamiliesRecursively(sibling, updatedFamilies, staleFamilies);
    }
    var findHostInstancesForRefresh = function findHostInstancesForRefresh(root, families) {
        var hostInstances = new Set();
        var types = new Set(families.map(function(family) {
            return family.current;
        }));
        findHostInstancesForMatchingFibersRecursively(root.current, types, hostInstances);
        return hostInstances;
    };
    function findHostInstancesForMatchingFibersRecursively(fiber, types, hostInstances) {
        var child = fiber.child, sibling = fiber.sibling, tag = fiber.tag, type = fiber.type;
        var candidateType = null;
        switch(tag){
            case FunctionComponent:
            case SimpleMemoComponent:
            case ClassComponent:
                candidateType = type;
                break;
            case ForwardRef:
                candidateType = type.render;
                break;
        }
        var didMatch = false;
        if (candidateType !== null) {
            if (types.has(candidateType)) didMatch = true;
        }
        if (didMatch) // We have a match. This only drills down to the closest host components.
        // There's no need to search deeper because for the purpose of giving
        // visual feedback, "flashing" outermost parent rectangles is sufficient.
        findHostInstancesForFiberShallowly(fiber, hostInstances);
        else // If there's no match, maybe there will be one further down in the child tree.
        if (child !== null) findHostInstancesForMatchingFibersRecursively(child, types, hostInstances);
        if (sibling !== null) findHostInstancesForMatchingFibersRecursively(sibling, types, hostInstances);
    }
    function findHostInstancesForFiberShallowly(fiber, hostInstances) {
        var foundHostInstances = findChildHostInstancesForFiberShallowly(fiber, hostInstances);
        if (foundHostInstances) return;
         // If we didn't find any host children, fallback to closest host parent.
        var node = fiber;
        while(true){
            switch(node.tag){
                case HostComponent:
                    hostInstances.add(node.stateNode);
                    return;
                case HostPortal:
                    hostInstances.add(node.stateNode.containerInfo);
                    return;
                case HostRoot:
                    hostInstances.add(node.stateNode.containerInfo);
                    return;
            }
            if (node.return === null) throw new Error('Expected to reach root first.');
            node = node.return;
        }
    }
    function findChildHostInstancesForFiberShallowly(fiber, hostInstances) {
        var node = fiber;
        var foundHostInstances = false;
        while(true){
            if (node.tag === HostComponent) {
                // We got a match.
                foundHostInstances = true;
                hostInstances.add(node.stateNode); // There may still be more, so keep searching.
            } else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === fiber) return foundHostInstances;
            while(node.sibling === null){
                if (node.return === null || node.return === fiber) return foundHostInstances;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
        return false;
    }
    var hasBadMapPolyfill;
    hasBadMapPolyfill = false;
    try {
        var nonExtensibleObject = Object.preventExtensions({});
        /* eslint-disable no-new */ new Map([
            [
                nonExtensibleObject,
                null
            ]
        ]);
        new Set([
            nonExtensibleObject
        ]);
    /* eslint-enable no-new */ } catch (e) {
        // TODO: Consider warning about bad polyfills
        hasBadMapPolyfill = true;
    }
    function FiberNode(tag, pendingProps, key, mode) {
        // Instance
        this.tag = tag;
        this.key = key;
        this.elementType = null;
        this.type = null;
        this.stateNode = null; // Fiber
        this.return = null;
        this.child = null;
        this.sibling = null;
        this.index = 0;
        this.ref = null;
        this.pendingProps = pendingProps;
        this.memoizedProps = null;
        this.updateQueue = null;
        this.memoizedState = null;
        this.dependencies = null;
        this.mode = mode; // Effects
        this.flags = NoFlags;
        this.subtreeFlags = NoFlags;
        this.deletions = null;
        this.lanes = NoLanes;
        this.childLanes = NoLanes;
        this.alternate = null;
        // Note: The following is done to avoid a v8 performance cliff.
        //
        // Initializing the fields below to smis and later updating them with
        // double values will cause Fibers to end up having separate shapes.
        // This behavior/bug has something to do with Object.preventExtension().
        // Fortunately this only impacts DEV builds.
        // Unfortunately it makes React unusably slow for some applications.
        // To work around this, initialize the fields below with doubles.
        //
        // Learn more about this here:
        // https://github.com/facebook/react/issues/14365
        // https://bugs.chromium.org/p/v8/issues/detail?id=8538
        this.actualDuration = Number.NaN;
        this.actualStartTime = Number.NaN;
        this.selfBaseDuration = Number.NaN;
        this.treeBaseDuration = Number.NaN; // It's okay to replace the initial doubles with smis after initialization.
        // This won't trigger the performance cliff mentioned above,
        // and it simplifies other profiler code (including DevTools).
        this.actualDuration = 0;
        this.actualStartTime = -1;
        this.selfBaseDuration = 0;
        this.treeBaseDuration = 0;
        // This isn't directly used but is handy for debugging internals:
        this._debugSource = null;
        this._debugOwner = null;
        this._debugNeedsRemount = false;
        this._debugHookTypes = null;
        if (!hasBadMapPolyfill && typeof Object.preventExtensions === 'function') Object.preventExtensions(this);
    } // This is a constructor function, rather than a POJO constructor, still
    // please ensure we do the following:
    // 1) Nobody should add any instance methods on this. Instance methods can be
    //    more difficult to predict when they get optimized and they are almost
    //    never inlined properly in static compilers.
    // 2) Nobody should rely on `instanceof Fiber` for type testing. We should
    //    always know when it is a fiber.
    // 3) We might want to experiment with using numeric keys since they are easier
    //    to optimize in a non-JIT environment.
    // 4) We can easily go from a constructor to a createFiber object literal if that
    //    is faster.
    // 5) It should be easy to port this to a C struct and keep a C implementation
    //    compatible.
    var createFiber = function createFiber(tag, pendingProps, key, mode) {
        // $FlowFixMe: the shapes are exact here but Flow doesn't like constructors
        return new FiberNode(tag, pendingProps, key, mode);
    };
    function shouldConstruct$1(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function isSimpleFunctionComponent(type) {
        return typeof type === 'function' && !shouldConstruct$1(type) && type.defaultProps === undefined;
    }
    function resolveLazyComponentTag(Component) {
        if (typeof Component === 'function') return shouldConstruct$1(Component) ? ClassComponent : FunctionComponent;
        else if (Component !== undefined && Component !== null) {
            var $$typeof = Component.$$typeof;
            if ($$typeof === REACT_FORWARD_REF_TYPE) return ForwardRef;
            if ($$typeof === REACT_MEMO_TYPE) return MemoComponent;
        }
        return IndeterminateComponent;
    } // This is used to create an alternate fiber to do work on.
    function createWorkInProgress(current, pendingProps) {
        var workInProgress = current.alternate;
        if (workInProgress === null) {
            // We use a double buffering pooling technique because we know that we'll
            // only ever need at most two versions of a tree. We pool the "other" unused
            // node that we're free to reuse. This is lazily created to avoid allocating
            // extra objects for things that are never updated. It also allow us to
            // reclaim the extra memory if needed.
            workInProgress = createFiber(current.tag, pendingProps, current.key, current.mode);
            workInProgress.elementType = current.elementType;
            workInProgress.type = current.type;
            workInProgress.stateNode = current.stateNode;
            // DEV-only fields
            workInProgress._debugSource = current._debugSource;
            workInProgress._debugOwner = current._debugOwner;
            workInProgress._debugHookTypes = current._debugHookTypes;
            workInProgress.alternate = current;
            current.alternate = workInProgress;
        } else {
            workInProgress.pendingProps = pendingProps; // Needed because Blocks store data on type.
            workInProgress.type = current.type; // We already have an alternate.
            // Reset the effect tag.
            workInProgress.flags = NoFlags; // The effects are no longer valid.
            workInProgress.subtreeFlags = NoFlags;
            workInProgress.deletions = null;
            // We intentionally reset, rather than copy, actualDuration & actualStartTime.
            // This prevents time from endlessly accumulating in new commits.
            // This has the downside of resetting values for different priority renders,
            // But works for yielding (the common case) and should support resuming.
            workInProgress.actualDuration = 0;
            workInProgress.actualStartTime = -1;
        } // Reset all effects except static ones.
        // Static effects are not specific to a render.
        workInProgress.flags = current.flags & StaticMask;
        workInProgress.childLanes = current.childLanes;
        workInProgress.lanes = current.lanes;
        workInProgress.child = current.child;
        workInProgress.memoizedProps = current.memoizedProps;
        workInProgress.memoizedState = current.memoizedState;
        workInProgress.updateQueue = current.updateQueue; // Clone the dependencies object. This is mutated during the render phase, so
        // it cannot be shared with the current fiber.
        var currentDependencies = current.dependencies;
        workInProgress.dependencies = currentDependencies === null ? null : {
            lanes: currentDependencies.lanes,
            firstContext: currentDependencies.firstContext
        }; // These will be overridden during the parent's reconciliation
        workInProgress.sibling = current.sibling;
        workInProgress.index = current.index;
        workInProgress.ref = current.ref;
        workInProgress.selfBaseDuration = current.selfBaseDuration;
        workInProgress.treeBaseDuration = current.treeBaseDuration;
        workInProgress._debugNeedsRemount = current._debugNeedsRemount;
        switch(workInProgress.tag){
            case IndeterminateComponent:
            case FunctionComponent:
            case SimpleMemoComponent:
                workInProgress.type = resolveFunctionForHotReloading(current.type);
                break;
            case ClassComponent:
                workInProgress.type = resolveClassForHotReloading(current.type);
                break;
            case ForwardRef:
                workInProgress.type = resolveForwardRefForHotReloading(current.type);
                break;
        }
        return workInProgress;
    } // Used to reuse a Fiber for a second pass.
    function resetWorkInProgress(workInProgress, renderLanes) {
        // This resets the Fiber to what createFiber or createWorkInProgress would
        // have set the values to before during the first pass. Ideally this wouldn't
        // be necessary but unfortunately many code paths reads from the workInProgress
        // when they should be reading from current and writing to workInProgress.
        // We assume pendingProps, index, key, ref, return are still untouched to
        // avoid doing another reconciliation.
        // Reset the effect flags but keep any Placement tags, since that's something
        // that child fiber is setting, not the reconciliation.
        workInProgress.flags &= StaticMask | Placement; // The effects are no longer valid.
        var current = workInProgress.alternate;
        if (current === null) {
            // Reset to createFiber's initial values.
            workInProgress.childLanes = NoLanes;
            workInProgress.lanes = renderLanes;
            workInProgress.child = null;
            workInProgress.subtreeFlags = NoFlags;
            workInProgress.memoizedProps = null;
            workInProgress.memoizedState = null;
            workInProgress.updateQueue = null;
            workInProgress.dependencies = null;
            workInProgress.stateNode = null;
            // Note: We don't reset the actualTime counts. It's useful to accumulate
            // actual time across multiple render passes.
            workInProgress.selfBaseDuration = 0;
            workInProgress.treeBaseDuration = 0;
        } else {
            // Reset to the cloned values that createWorkInProgress would've.
            workInProgress.childLanes = current.childLanes;
            workInProgress.lanes = current.lanes;
            workInProgress.child = current.child;
            workInProgress.subtreeFlags = NoFlags;
            workInProgress.deletions = null;
            workInProgress.memoizedProps = current.memoizedProps;
            workInProgress.memoizedState = current.memoizedState;
            workInProgress.updateQueue = current.updateQueue; // Needed because Blocks store data on type.
            workInProgress.type = current.type; // Clone the dependencies object. This is mutated during the render phase, so
            // it cannot be shared with the current fiber.
            var currentDependencies = current.dependencies;
            workInProgress.dependencies = currentDependencies === null ? null : {
                lanes: currentDependencies.lanes,
                firstContext: currentDependencies.firstContext
            };
            // Note: We don't reset the actualTime counts. It's useful to accumulate
            // actual time across multiple render passes.
            workInProgress.selfBaseDuration = current.selfBaseDuration;
            workInProgress.treeBaseDuration = current.treeBaseDuration;
        }
        return workInProgress;
    }
    function createHostRootFiber(tag, isStrictMode, concurrentUpdatesByDefaultOverride) {
        var mode;
        if (tag === ConcurrentRoot) {
            mode = ConcurrentMode;
            if (isStrictMode === true) {
                mode |= StrictLegacyMode;
                mode |= StrictEffectsMode;
            }
        } else mode = NoMode;
        if (isDevToolsPresent) // Always collect profile timings when DevTools are present.
        // This enables DevTools to start capturing timing at any point–
        // Without some nodes in the tree having empty base times.
        mode |= ProfileMode;
        return createFiber(HostRoot, null, null, mode);
    }
    function createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
        var fiberTag = IndeterminateComponent; // The resolved type is set if we know what the final type will be. I.e. it's not lazy.
        var resolvedType = type;
        if (typeof type === 'function') {
            if (shouldConstruct$1(type)) {
                fiberTag = ClassComponent;
                resolvedType = resolveClassForHotReloading(resolvedType);
            } else resolvedType = resolveFunctionForHotReloading(resolvedType);
        } else if (typeof type === 'string') fiberTag = HostComponent;
        else getTag: switch(type){
            case REACT_FRAGMENT_TYPE:
                return createFiberFromFragment(pendingProps.children, mode, lanes, key);
            case REACT_STRICT_MODE_TYPE:
                fiberTag = Mode;
                mode |= StrictLegacyMode;
                if ((mode & ConcurrentMode) !== NoMode) // Strict effects should never run on legacy roots
                mode |= StrictEffectsMode;
                break;
            case REACT_PROFILER_TYPE:
                return createFiberFromProfiler(pendingProps, mode, lanes, key);
            case REACT_SUSPENSE_TYPE:
                return createFiberFromSuspense(pendingProps, mode, lanes, key);
            case REACT_SUSPENSE_LIST_TYPE:
                return createFiberFromSuspenseList(pendingProps, mode, lanes, key);
            case REACT_OFFSCREEN_TYPE:
                return createFiberFromOffscreen(pendingProps, mode, lanes, key);
            case REACT_LEGACY_HIDDEN_TYPE:
            // eslint-disable-next-line no-fallthrough
            case REACT_SCOPE_TYPE:
            // eslint-disable-next-line no-fallthrough
            case REACT_CACHE_TYPE:
            // eslint-disable-next-line no-fallthrough
            case REACT_TRACING_MARKER_TYPE:
            // eslint-disable-next-line no-fallthrough
            case REACT_DEBUG_TRACING_MODE_TYPE:
            // eslint-disable-next-line no-fallthrough
            default:
                if (typeof type === 'object' && type !== null) switch(type.$$typeof){
                    case REACT_PROVIDER_TYPE:
                        fiberTag = ContextProvider;
                        break getTag;
                    case REACT_CONTEXT_TYPE:
                        // This is a consumer
                        fiberTag = ContextConsumer;
                        break getTag;
                    case REACT_FORWARD_REF_TYPE:
                        fiberTag = ForwardRef;
                        resolvedType = resolveForwardRefForHotReloading(resolvedType);
                        break getTag;
                    case REACT_MEMO_TYPE:
                        fiberTag = MemoComponent;
                        break getTag;
                    case REACT_LAZY_TYPE:
                        fiberTag = LazyComponent;
                        resolvedType = null;
                        break getTag;
                }
                var info = '';
                if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
                var ownerName = owner ? getComponentNameFromFiber(owner) : null;
                if (ownerName) info += '\n\nCheck the render method of `' + ownerName + '`.';
                throw new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (type == null ? type : typeof type) + "." + info));
        }
        var fiber = createFiber(fiberTag, pendingProps, key, mode);
        fiber.elementType = type;
        fiber.type = resolvedType;
        fiber.lanes = lanes;
        fiber._debugOwner = owner;
        return fiber;
    }
    function createFiberFromElement(element, mode, lanes) {
        var owner = null;
        owner = element._owner;
        var type = element.type;
        var key = element.key;
        var pendingProps = element.props;
        var fiber = createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes);
        fiber._debugSource = element._source;
        fiber._debugOwner = element._owner;
        return fiber;
    }
    function createFiberFromFragment(elements, mode, lanes, key) {
        var fiber = createFiber(Fragment, elements, key, mode);
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromProfiler(pendingProps, mode, lanes, key) {
        if (typeof pendingProps.id !== 'string') error('Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.', typeof pendingProps.id);
        var fiber = createFiber(Profiler, pendingProps, key, mode | ProfileMode);
        fiber.elementType = REACT_PROFILER_TYPE;
        fiber.lanes = lanes;
        fiber.stateNode = {
            effectDuration: 0,
            passiveEffectDuration: 0
        };
        return fiber;
    }
    function createFiberFromSuspense(pendingProps, mode, lanes, key) {
        var fiber = createFiber(SuspenseComponent, pendingProps, key, mode);
        fiber.elementType = REACT_SUSPENSE_TYPE;
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromSuspenseList(pendingProps, mode, lanes, key) {
        var fiber = createFiber(SuspenseListComponent, pendingProps, key, mode);
        fiber.elementType = REACT_SUSPENSE_LIST_TYPE;
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromOffscreen(pendingProps, mode, lanes, key) {
        var fiber = createFiber(OffscreenComponent, pendingProps, key, mode);
        fiber.elementType = REACT_OFFSCREEN_TYPE;
        fiber.lanes = lanes;
        var primaryChildInstance = {
            isHidden: false
        };
        fiber.stateNode = primaryChildInstance;
        return fiber;
    }
    function createFiberFromText(content, mode, lanes) {
        var fiber = createFiber(HostText, content, null, mode);
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromHostInstanceForDeletion() {
        var fiber = createFiber(HostComponent, null, null, NoMode);
        fiber.elementType = 'DELETED';
        return fiber;
    }
    function createFiberFromDehydratedFragment(dehydratedNode) {
        var fiber = createFiber(DehydratedFragment, null, null, NoMode);
        fiber.stateNode = dehydratedNode;
        return fiber;
    }
    function createFiberFromPortal(portal, mode, lanes) {
        var pendingProps = portal.children !== null ? portal.children : [];
        var fiber = createFiber(HostPortal, pendingProps, portal.key, mode);
        fiber.lanes = lanes;
        fiber.stateNode = {
            containerInfo: portal.containerInfo,
            pendingChildren: null,
            // Used by persistent updates
            implementation: portal.implementation
        };
        return fiber;
    } // Used for stashing WIP properties to replay failed work in DEV.
    function assignFiberPropertiesInDEV(target, source) {
        if (target === null) // This Fiber's initial properties will always be overwritten.
        // We only use a Fiber to ensure the same hidden class so DEV isn't slow.
        target = createFiber(IndeterminateComponent, null, null, NoMode);
         // This is intentionally written as a list of all properties.
        // We tried to use Object.assign() instead but this is called in
        // the hottest path, and Object.assign() was too slow:
        // https://github.com/facebook/react/issues/12502
        // This code is DEV-only so size is not a concern.
        target.tag = source.tag;
        target.key = source.key;
        target.elementType = source.elementType;
        target.type = source.type;
        target.stateNode = source.stateNode;
        target.return = source.return;
        target.child = source.child;
        target.sibling = source.sibling;
        target.index = source.index;
        target.ref = source.ref;
        target.pendingProps = source.pendingProps;
        target.memoizedProps = source.memoizedProps;
        target.updateQueue = source.updateQueue;
        target.memoizedState = source.memoizedState;
        target.dependencies = source.dependencies;
        target.mode = source.mode;
        target.flags = source.flags;
        target.subtreeFlags = source.subtreeFlags;
        target.deletions = source.deletions;
        target.lanes = source.lanes;
        target.childLanes = source.childLanes;
        target.alternate = source.alternate;
        target.actualDuration = source.actualDuration;
        target.actualStartTime = source.actualStartTime;
        target.selfBaseDuration = source.selfBaseDuration;
        target.treeBaseDuration = source.treeBaseDuration;
        target._debugSource = source._debugSource;
        target._debugOwner = source._debugOwner;
        target._debugNeedsRemount = source._debugNeedsRemount;
        target._debugHookTypes = source._debugHookTypes;
        return target;
    }
    function FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onRecoverableError) {
        this.tag = tag;
        this.containerInfo = containerInfo;
        this.pendingChildren = null;
        this.current = null;
        this.pingCache = null;
        this.finishedWork = null;
        this.timeoutHandle = noTimeout;
        this.context = null;
        this.pendingContext = null;
        this.callbackNode = null;
        this.callbackPriority = NoLane;
        this.eventTimes = createLaneMap(NoLanes);
        this.expirationTimes = createLaneMap(NoTimestamp);
        this.pendingLanes = NoLanes;
        this.suspendedLanes = NoLanes;
        this.pingedLanes = NoLanes;
        this.expiredLanes = NoLanes;
        this.mutableReadLanes = NoLanes;
        this.finishedLanes = NoLanes;
        this.entangledLanes = NoLanes;
        this.entanglements = createLaneMap(NoLanes);
        this.identifierPrefix = identifierPrefix;
        this.onRecoverableError = onRecoverableError;
        this.mutableSourceEagerHydrationData = null;
        this.effectDuration = 0;
        this.passiveEffectDuration = 0;
        this.memoizedUpdaters = new Set();
        var pendingUpdatersLaneMap = this.pendingUpdatersLaneMap = [];
        for(var _i = 0; _i < TotalLanes; _i++)pendingUpdatersLaneMap.push(new Set());
        switch(tag){
            case ConcurrentRoot:
                this._debugRootType = hydrate ? 'hydrateRoot()' : 'createRoot()';
                break;
            case LegacyRoot:
                this._debugRootType = hydrate ? 'hydrate()' : 'render()';
                break;
        }
    }
    function createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, // host config, but because they are passed in at runtime, we have to thread
    // them through the root constructor. Perhaps we should put them all into a
    // single type, like a DynamicHostConfig that is defined by the renderer.
    identifierPrefix, onRecoverableError, transitionCallbacks) {
        var root = new FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onRecoverableError);
        // stateNode is any.
        var uninitializedFiber = createHostRootFiber(tag, isStrictMode);
        root.current = uninitializedFiber;
        uninitializedFiber.stateNode = root;
        var _initialState = {
            element: initialChildren,
            isDehydrated: hydrate,
            cache: null,
            // not enabled yet
            transitions: null,
            pendingSuspenseBoundaries: null
        };
        uninitializedFiber.memoizedState = _initialState;
        initializeUpdateQueue(uninitializedFiber);
        return root;
    }
    var ReactVersion = '18.3.1';
    function createPortal(children, containerInfo, implementation) {
        var key = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
        checkKeyStringCoercion(key);
        return {
            // This tag allow us to uniquely identify this as a React Portal
            $$typeof: REACT_PORTAL_TYPE,
            key: key == null ? null : '' + key,
            children: children,
            containerInfo: containerInfo,
            implementation: implementation
        };
    }
    var didWarnAboutNestedUpdates;
    var didWarnAboutFindNodeInStrictMode;
    didWarnAboutNestedUpdates = false;
    didWarnAboutFindNodeInStrictMode = {};
    function getContextForSubtree(parentComponent) {
        if (!parentComponent) return emptyContextObject;
        var fiber = get(parentComponent);
        var parentContext = findCurrentUnmaskedContext(fiber);
        if (fiber.tag === ClassComponent) {
            var Component = fiber.type;
            if (isContextProvider(Component)) return processChildContext(fiber, Component, parentContext);
        }
        return parentContext;
    }
    function findHostInstanceWithWarning(component, methodName) {
        var fiber = get(component);
        if (fiber === undefined) {
            if (typeof component.render === 'function') throw new Error('Unable to find node on an unmounted component.');
            else {
                var keys = Object.keys(component).join(',');
                throw new Error("Argument appears to not be a ReactComponent. Keys: " + keys);
            }
        }
        var hostFiber = findCurrentHostFiber(fiber);
        if (hostFiber === null) return null;
        if (hostFiber.mode & StrictLegacyMode) {
            var componentName = getComponentNameFromFiber(fiber) || 'Component';
            if (!didWarnAboutFindNodeInStrictMode[componentName]) {
                didWarnAboutFindNodeInStrictMode[componentName] = true;
                var previousFiber = current;
                try {
                    setCurrentFiber(hostFiber);
                    if (fiber.mode & StrictLegacyMode) error("%s is deprecated in StrictMode. %s was passed an instance of %s which is inside StrictMode. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", methodName, methodName, componentName);
                    else error("%s is deprecated in StrictMode. %s was passed an instance of %s which renders StrictMode children. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", methodName, methodName, componentName);
                } finally{
                    // Ideally this should reset to previous but this shouldn't be called in
                    // render and there's another warning for that anyway.
                    if (previousFiber) setCurrentFiber(previousFiber);
                    else resetCurrentFiber();
                }
            }
        }
        return hostFiber.stateNode;
    }
    function createContainer(containerInfo, tag, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError, transitionCallbacks) {
        var _$hydrate = false;
        var initialChildren = null;
        return createFiberRoot(containerInfo, tag, _$hydrate, initialChildren, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError);
    }
    function createHydrationContainer(initialChildren, callback, containerInfo, tag, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError, transitionCallbacks) {
        var _$hydrate = true;
        var root = createFiberRoot(containerInfo, tag, _$hydrate, initialChildren, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError); // TODO: Move this to FiberRoot constructor
        root.context = getContextForSubtree(null); // Schedule the initial render. In a hydration root, this is different from
        // a regular update because the initial render must match was was rendered
        // on the server.
        // NOTE: This update intentionally doesn't have a payload. We're only using
        // the update to schedule work on the root fiber (and, for legacy roots, to
        // enqueue the callback if one is provided).
        var current = root.current;
        var eventTime = requestEventTime();
        var lane = requestUpdateLane(current);
        var update = createUpdate(eventTime, lane);
        update.callback = callback !== undefined && callback !== null ? callback : null;
        enqueueUpdate(current, update, lane);
        scheduleInitialHydrationOnRoot(root, lane, eventTime);
        return root;
    }
    function updateContainer(element, container, parentComponent, callback) {
        onScheduleRoot(container, element);
        var current$1 = container.current;
        var eventTime = requestEventTime();
        var lane = requestUpdateLane(current$1);
        markRenderScheduled(lane);
        var context = getContextForSubtree(parentComponent);
        if (container.context === null) container.context = context;
        else container.pendingContext = context;
        if (isRendering && current !== null && !didWarnAboutNestedUpdates) {
            didWarnAboutNestedUpdates = true;
            error("Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.\n\nCheck the render method of %s.", getComponentNameFromFiber(current) || 'Unknown');
        }
        var update = createUpdate(eventTime, lane); // Caution: React DevTools currently depends on this property
        // being called "element".
        update.payload = {
            element: element
        };
        callback = callback === undefined ? null : callback;
        if (callback !== null) {
            if (typeof callback !== 'function') error("render(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callback);
            update.callback = callback;
        }
        var root = enqueueUpdate(current$1, update, lane);
        if (root !== null) {
            scheduleUpdateOnFiber(root, current$1, lane, eventTime);
            entangleTransitions(root, current$1, lane);
        }
        return lane;
    }
    function getPublicRootInstance(container) {
        var containerFiber = container.current;
        if (!containerFiber.child) return null;
        switch(containerFiber.child.tag){
            case HostComponent:
                return getPublicInstance(containerFiber.child.stateNode);
            default:
                return containerFiber.child.stateNode;
        }
    }
    function attemptSynchronousHydration$1(fiber) {
        switch(fiber.tag){
            case HostRoot:
                var root = fiber.stateNode;
                if (isRootDehydrated(root)) {
                    // Flush the first scheduled "update".
                    var lanes = getHighestPriorityPendingLanes(root);
                    flushRoot(root, lanes);
                }
                break;
            case SuspenseComponent:
                flushSync(function() {
                    var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
                    if (root !== null) {
                        var eventTime = requestEventTime();
                        scheduleUpdateOnFiber(root, fiber, SyncLane, eventTime);
                    }
                }); // If we're still blocked after this, we need to increase
                // the priority of any promises resolving within this
                // boundary so that they next attempt also has higher pri.
                var retryLane = SyncLane;
                markRetryLaneIfNotHydrated(fiber, retryLane);
                break;
        }
    }
    function markRetryLaneImpl(fiber, retryLane) {
        var suspenseState = fiber.memoizedState;
        if (suspenseState !== null && suspenseState.dehydrated !== null) suspenseState.retryLane = higherPriorityLane(suspenseState.retryLane, retryLane);
    } // Increases the priority of thenables when they resolve within this boundary.
    function markRetryLaneIfNotHydrated(fiber, retryLane) {
        markRetryLaneImpl(fiber, retryLane);
        var alternate = fiber.alternate;
        if (alternate) markRetryLaneImpl(alternate, retryLane);
    }
    function attemptContinuousHydration$1(fiber) {
        if (fiber.tag !== SuspenseComponent) // We ignore HostRoots here because we can't increase
        // their priority and they should not suspend on I/O,
        // since you have to wrap anything that might suspend in
        // Suspense.
        return;
        var lane = SelectiveHydrationLane;
        var root = enqueueConcurrentRenderForLane(fiber, lane);
        if (root !== null) {
            var eventTime = requestEventTime();
            scheduleUpdateOnFiber(root, fiber, lane, eventTime);
        }
        markRetryLaneIfNotHydrated(fiber, lane);
    }
    function attemptHydrationAtCurrentPriority$1(fiber) {
        if (fiber.tag !== SuspenseComponent) // We ignore HostRoots here because we can't increase
        // their priority other than synchronously flush it.
        return;
        var lane = requestUpdateLane(fiber);
        var root = enqueueConcurrentRenderForLane(fiber, lane);
        if (root !== null) {
            var eventTime = requestEventTime();
            scheduleUpdateOnFiber(root, fiber, lane, eventTime);
        }
        markRetryLaneIfNotHydrated(fiber, lane);
    }
    function findHostInstanceWithNoPortals(fiber) {
        var hostFiber = findCurrentHostFiberWithNoPortals(fiber);
        if (hostFiber === null) return null;
        return hostFiber.stateNode;
    }
    var shouldErrorImpl = function shouldErrorImpl(fiber) {
        return null;
    };
    function shouldError(fiber) {
        return shouldErrorImpl(fiber);
    }
    var shouldSuspendImpl = function shouldSuspendImpl(fiber) {
        return false;
    };
    function shouldSuspend(fiber) {
        return shouldSuspendImpl(fiber);
    }
    var overrideHookState = null;
    var overrideHookStateDeletePath = null;
    var overrideHookStateRenamePath = null;
    var overrideProps = null;
    var overridePropsDeletePath = null;
    var overridePropsRenamePath = null;
    var scheduleUpdate = null;
    var setErrorHandler = null;
    var setSuspenseHandler = null;
    var copyWithDeleteImpl = function copyWithDeleteImpl1(obj, path, index) {
        var key = path[index];
        var updated = isArray(obj) ? obj.slice() : assign({}, obj);
        if (index + 1 === path.length) {
            if (isArray(updated)) updated.splice(key, 1);
            else delete updated[key];
            return updated;
        } // $FlowFixMe number or string is fine here
        updated[key] = copyWithDeleteImpl(obj[key], path, index + 1);
        return updated;
    };
    var copyWithDelete = function copyWithDelete(obj, path) {
        return copyWithDeleteImpl(obj, path, 0);
    };
    var copyWithRenameImpl = function copyWithRenameImpl1(obj, oldPath, newPath, index) {
        var oldKey = oldPath[index];
        var updated = isArray(obj) ? obj.slice() : assign({}, obj);
        if (index + 1 === oldPath.length) {
            var newKey = newPath[index]; // $FlowFixMe number or string is fine here
            updated[newKey] = updated[oldKey];
            if (isArray(updated)) updated.splice(oldKey, 1);
            else delete updated[oldKey];
        } else // $FlowFixMe number or string is fine here
        updated[oldKey] = copyWithRenameImpl(obj[oldKey], oldPath, newPath, index + 1);
        return updated;
    };
    var copyWithRename = function copyWithRename(obj, oldPath, newPath) {
        if (oldPath.length !== newPath.length) {
            warn('copyWithRename() expects paths of the same length');
            return;
        } else {
            for(var i = 0; i < newPath.length - 1; i++)if (oldPath[i] !== newPath[i]) {
                warn('copyWithRename() expects paths to be the same except for the deepest key');
                return;
            }
        }
        return copyWithRenameImpl(obj, oldPath, newPath, 0);
    };
    var copyWithSetImpl = function copyWithSetImpl1(obj, path, index, value) {
        if (index >= path.length) return value;
        var key = path[index];
        var updated = isArray(obj) ? obj.slice() : assign({}, obj); // $FlowFixMe number or string is fine here
        updated[key] = copyWithSetImpl(obj[key], path, index + 1, value);
        return updated;
    };
    var copyWithSet = function copyWithSet(obj, path, value) {
        return copyWithSetImpl(obj, path, 0, value);
    };
    var findHook = function findHook(fiber, id) {
        // For now, the "id" of stateful hooks is just the stateful hook index.
        // This may change in the future with e.g. nested hooks.
        var currentHook = fiber.memoizedState;
        while(currentHook !== null && id > 0){
            currentHook = currentHook.next;
            id--;
        }
        return currentHook;
    }; // Support DevTools editable values for useState and useReducer.
    overrideHookState = function overrideHookState(fiber, id, path, value) {
        var hook = findHook(fiber, id);
        if (hook !== null) {
            var newState = copyWithSet(hook.memoizedState, path, value);
            hook.memoizedState = newState;
            hook.baseState = newState; // We aren't actually adding an update to the queue,
            // because there is no update we can add for useReducer hooks that won't trigger an error.
            // (There's no appropriate action type for DevTools overrides.)
            // As a result though, React will see the scheduled update as a noop and bailout.
            // Shallow cloning props works as a workaround for now to bypass the bailout check.
            fiber.memoizedProps = assign({}, fiber.memoizedProps);
            var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
            if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
        }
    };
    overrideHookStateDeletePath = function overrideHookStateDeletePath(fiber, id, path) {
        var hook = findHook(fiber, id);
        if (hook !== null) {
            var newState = copyWithDelete(hook.memoizedState, path);
            hook.memoizedState = newState;
            hook.baseState = newState; // We aren't actually adding an update to the queue,
            // because there is no update we can add for useReducer hooks that won't trigger an error.
            // (There's no appropriate action type for DevTools overrides.)
            // As a result though, React will see the scheduled update as a noop and bailout.
            // Shallow cloning props works as a workaround for now to bypass the bailout check.
            fiber.memoizedProps = assign({}, fiber.memoizedProps);
            var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
            if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
        }
    };
    overrideHookStateRenamePath = function overrideHookStateRenamePath(fiber, id, oldPath, newPath) {
        var hook = findHook(fiber, id);
        if (hook !== null) {
            var newState = copyWithRename(hook.memoizedState, oldPath, newPath);
            hook.memoizedState = newState;
            hook.baseState = newState; // We aren't actually adding an update to the queue,
            // because there is no update we can add for useReducer hooks that won't trigger an error.
            // (There's no appropriate action type for DevTools overrides.)
            // As a result though, React will see the scheduled update as a noop and bailout.
            // Shallow cloning props works as a workaround for now to bypass the bailout check.
            fiber.memoizedProps = assign({}, fiber.memoizedProps);
            var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
            if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
        }
    }; // Support DevTools props for function components, forwardRef, memo, host components, etc.
    overrideProps = function overrideProps(fiber, path, value) {
        fiber.pendingProps = copyWithSet(fiber.memoizedProps, path, value);
        if (fiber.alternate) fiber.alternate.pendingProps = fiber.pendingProps;
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    };
    overridePropsDeletePath = function overridePropsDeletePath(fiber, path) {
        fiber.pendingProps = copyWithDelete(fiber.memoizedProps, path);
        if (fiber.alternate) fiber.alternate.pendingProps = fiber.pendingProps;
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    };
    overridePropsRenamePath = function overridePropsRenamePath(fiber, oldPath, newPath) {
        fiber.pendingProps = copyWithRename(fiber.memoizedProps, oldPath, newPath);
        if (fiber.alternate) fiber.alternate.pendingProps = fiber.pendingProps;
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    };
    scheduleUpdate = function scheduleUpdate(fiber) {
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    };
    setErrorHandler = function setErrorHandler(newShouldErrorImpl) {
        shouldErrorImpl = newShouldErrorImpl;
    };
    setSuspenseHandler = function setSuspenseHandler(newShouldSuspendImpl) {
        shouldSuspendImpl = newShouldSuspendImpl;
    };
    function findHostInstanceByFiber(fiber) {
        var hostFiber = findCurrentHostFiber(fiber);
        if (hostFiber === null) return null;
        return hostFiber.stateNode;
    }
    function emptyFindFiberByHostInstance(instance) {
        return null;
    }
    function getCurrentFiberForDevTools() {
        return current;
    }
    function injectIntoDevTools(devToolsConfig) {
        var findFiberByHostInstance = devToolsConfig.findFiberByHostInstance;
        var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
        return injectInternals({
            bundleType: devToolsConfig.bundleType,
            version: devToolsConfig.version,
            rendererPackageName: devToolsConfig.rendererPackageName,
            rendererConfig: devToolsConfig.rendererConfig,
            overrideHookState: overrideHookState,
            overrideHookStateDeletePath: overrideHookStateDeletePath,
            overrideHookStateRenamePath: overrideHookStateRenamePath,
            overrideProps: overrideProps,
            overridePropsDeletePath: overridePropsDeletePath,
            overridePropsRenamePath: overridePropsRenamePath,
            setErrorHandler: setErrorHandler,
            setSuspenseHandler: setSuspenseHandler,
            scheduleUpdate: scheduleUpdate,
            currentDispatcherRef: ReactCurrentDispatcher,
            findHostInstanceByFiber: findHostInstanceByFiber,
            findFiberByHostInstance: findFiberByHostInstance || emptyFindFiberByHostInstance,
            // React Refresh
            findHostInstancesForRefresh: findHostInstancesForRefresh,
            scheduleRefresh: scheduleRefresh,
            scheduleRoot: scheduleRoot,
            setRefreshHandler: setRefreshHandler,
            // Enables DevTools to append owner stacks to error messages in DEV mode.
            getCurrentFiber: getCurrentFiberForDevTools,
            // Enables DevTools to detect reconciler version rather than renderer version
            // which may not match for third party renderers.
            reconcilerVersion: ReactVersion
        });
    }
    /* global reportError */ var defaultOnRecoverableError = typeof reportError === 'function' ? // emulating an uncaught JavaScript error.
    reportError : function defaultOnRecoverableError(error) {
        // In older browsers and test environments, fallback to console.error.
        // eslint-disable-next-line react-internal/no-production-logging
        console['error'](error);
    };
    function ReactDOMRoot(internalRoot) {
        this._internalRoot = internalRoot;
    }
    ReactDOMHydrationRoot.prototype.render = ReactDOMRoot.prototype.render = function(children) {
        var root = this._internalRoot;
        if (root === null) throw new Error('Cannot update an unmounted root.');
        if (typeof arguments[1] === 'function') error("render(...): does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
        else if (isValidContainer(arguments[1])) error("You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root.");
        else if (typeof arguments[1] !== 'undefined') error("You passed a second argument to root.render(...) but it only accepts one argument.");
        var container = root.containerInfo;
        if (container.nodeType !== COMMENT_NODE) {
            var hostInstance = findHostInstanceWithNoPortals(root.current);
            if (hostInstance) {
                if (hostInstance.parentNode !== container) error("render(...): It looks like the React-rendered content of the root container was removed without using React. This is not supported and will cause errors. Instead, call root.unmount() to empty a root's container.");
            }
        }
        updateContainer(children, root, null, null);
    };
    ReactDOMHydrationRoot.prototype.unmount = ReactDOMRoot.prototype.unmount = function() {
        if (typeof arguments[0] === 'function') error("unmount(...): does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
        var root = this._internalRoot;
        if (root !== null) {
            this._internalRoot = null;
            var container = root.containerInfo;
            if (isAlreadyRendering()) error("Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition.");
            flushSync(function() {
                updateContainer(null, root, null, null);
            });
            unmarkContainerAsRoot(container);
        }
    };
    function createRoot(container, options) {
        if (!isValidContainer(container)) throw new Error('createRoot(...): Target container is not a DOM element.');
        warnIfReactDOMContainerInDEV(container);
        var isStrictMode = false;
        var concurrentUpdatesByDefaultOverride = false;
        var identifierPrefix = '';
        var onRecoverableError = defaultOnRecoverableError;
        var transitionCallbacks = null;
        if (options !== null && options !== undefined) {
            if (options.hydrate) warn('hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead.');
            else if (typeof options === 'object' && options !== null && options.$$typeof === REACT_ELEMENT_TYPE) error("You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:\n\n  let root = createRoot(domContainer);\n  root.render(<App />);");
            if (options.unstable_strictMode === true) isStrictMode = true;
            if (options.identifierPrefix !== undefined) identifierPrefix = options.identifierPrefix;
            if (options.onRecoverableError !== undefined) onRecoverableError = options.onRecoverableError;
            if (options.transitionCallbacks !== undefined) transitionCallbacks = options.transitionCallbacks;
        }
        var root = createContainer(container, ConcurrentRoot, null, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError);
        markContainerAsRoot(root.current, container);
        var rootContainerElement = container.nodeType === COMMENT_NODE ? container.parentNode : container;
        listenToAllSupportedEvents(rootContainerElement);
        return new ReactDOMRoot(root);
    }
    function ReactDOMHydrationRoot(internalRoot) {
        this._internalRoot = internalRoot;
    }
    function scheduleHydration(target) {
        if (target) queueExplicitHydrationTarget(target);
    }
    ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = scheduleHydration;
    function hydrateRoot(container, initialChildren, options) {
        if (!isValidContainer(container)) throw new Error('hydrateRoot(...): Target container is not a DOM element.');
        warnIfReactDOMContainerInDEV(container);
        if (initialChildren === undefined) error("Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)");
        // the hydration callbacks.
        var hydrationCallbacks = options != null ? options : null; // TODO: Delete this option
        var mutableSources = options != null && options.hydratedSources || null;
        var isStrictMode = false;
        var concurrentUpdatesByDefaultOverride = false;
        var identifierPrefix = '';
        var onRecoverableError = defaultOnRecoverableError;
        if (options !== null && options !== undefined) {
            if (options.unstable_strictMode === true) isStrictMode = true;
            if (options.identifierPrefix !== undefined) identifierPrefix = options.identifierPrefix;
            if (options.onRecoverableError !== undefined) onRecoverableError = options.onRecoverableError;
        }
        var root = createHydrationContainer(initialChildren, null, container, ConcurrentRoot, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError);
        markContainerAsRoot(root.current, container); // This can't be a comment node since hydration doesn't work on comment nodes anyway.
        listenToAllSupportedEvents(container);
        if (mutableSources) for(var i = 0; i < mutableSources.length; i++){
            var mutableSource = mutableSources[i];
            registerMutableSourceForHydration(root, mutableSource);
        }
        return new ReactDOMHydrationRoot(root);
    }
    function isValidContainer(node) {
        return !!(node && (node.nodeType === ELEMENT_NODE || node.nodeType === DOCUMENT_NODE || node.nodeType === DOCUMENT_FRAGMENT_NODE || !disableCommentsAsDOMContainers));
    } // TODO: Remove this function which also includes comment nodes.
    // We only use it in places that are currently more relaxed.
    function isValidContainerLegacy(node) {
        return !!(node && (node.nodeType === ELEMENT_NODE || node.nodeType === DOCUMENT_NODE || node.nodeType === DOCUMENT_FRAGMENT_NODE || node.nodeType === COMMENT_NODE && node.nodeValue === ' react-mount-point-unstable '));
    }
    function warnIfReactDOMContainerInDEV(container) {
        if (container.nodeType === ELEMENT_NODE && container.tagName && container.tagName.toUpperCase() === 'BODY') error("createRoot(): Creating roots directly with document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try using a container element created for your app.");
        if (isContainerMarkedAsRoot(container)) {
            if (container._reactRootContainer) error("You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported.");
            else error("You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it.");
        }
    }
    var ReactCurrentOwner$3 = ReactSharedInternals.ReactCurrentOwner;
    var topLevelUpdateWarnings;
    topLevelUpdateWarnings = function topLevelUpdateWarnings(container) {
        if (container._reactRootContainer && container.nodeType !== COMMENT_NODE) {
            var hostInstance = findHostInstanceWithNoPortals(container._reactRootContainer.current);
            if (hostInstance) {
                if (hostInstance.parentNode !== container) error("render(...): It looks like the React-rendered content of this container was removed without using React. This is not supported and will cause errors. Instead, call ReactDOM.unmountComponentAtNode to empty a container.");
            }
        }
        var isRootRenderedBySomeReact = !!container._reactRootContainer;
        var rootEl = getReactRootElementInContainer(container);
        var hasNonRootReactChild = !!(rootEl && getInstanceFromNode(rootEl));
        if (hasNonRootReactChild && !isRootRenderedBySomeReact) error("render(...): Replacing React-rendered children with a new root component. If you intended to update the children of this node, you should instead have the existing children update their state and render the new components instead of calling ReactDOM.render.");
        if (container.nodeType === ELEMENT_NODE && container.tagName && container.tagName.toUpperCase() === 'BODY') error("render(): Rendering components directly into document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try rendering into a container element created for your app.");
    };
    function getReactRootElementInContainer(container) {
        if (!container) return null;
        if (container.nodeType === DOCUMENT_NODE) return container.documentElement;
        else return container.firstChild;
    }
    function noopOnRecoverableError() {
    // legacy API.
    }
    function legacyCreateRootFromDOMContainer(container, initialChildren, parentComponent, callback, isHydrationContainer) {
        if (isHydrationContainer) {
            if (typeof callback === 'function') {
                var originalCallback = callback;
                callback = function callback() {
                    var instance = getPublicRootInstance(root);
                    originalCallback.call(instance);
                };
            }
            var root = createHydrationContainer(initialChildren, callback, container, LegacyRoot, null, false, false, '', noopOnRecoverableError);
            container._reactRootContainer = root;
            markContainerAsRoot(root.current, container);
            var rootContainerElement = container.nodeType === COMMENT_NODE ? container.parentNode : container;
            listenToAllSupportedEvents(rootContainerElement);
            flushSync();
            return root;
        } else {
            // First clear any existing content.
            var rootSibling;
            while(rootSibling = container.lastChild)container.removeChild(rootSibling);
            if (typeof callback === 'function') {
                var _originalCallback = callback;
                callback = function callback() {
                    var instance = getPublicRootInstance(_root);
                    _originalCallback.call(instance);
                };
            }
            var _root = createContainer(container, LegacyRoot, null, false, false, '', noopOnRecoverableError);
            container._reactRootContainer = _root;
            markContainerAsRoot(_root.current, container);
            var _rootContainerElement = container.nodeType === COMMENT_NODE ? container.parentNode : container;
            listenToAllSupportedEvents(_rootContainerElement); // Initial mount should not be batched.
            flushSync(function() {
                updateContainer(initialChildren, _root, parentComponent, callback);
            });
            return _root;
        }
    }
    function warnOnInvalidCallback$1(callback, callerName) {
        if (callback !== null && typeof callback !== 'function') error("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callerName, callback);
    }
    function legacyRenderSubtreeIntoContainer(parentComponent, children, container, forceHydrate, callback) {
        topLevelUpdateWarnings(container);
        warnOnInvalidCallback$1(callback === undefined ? null : callback, 'render');
        var maybeRoot = container._reactRootContainer;
        var root;
        if (!maybeRoot) // Initial mount
        root = legacyCreateRootFromDOMContainer(container, children, parentComponent, callback, forceHydrate);
        else {
            root = maybeRoot;
            if (typeof callback === 'function') {
                var originalCallback = callback;
                callback = function callback() {
                    var instance = getPublicRootInstance(root);
                    originalCallback.call(instance);
                };
            } // Update
            updateContainer(children, root, parentComponent, callback);
        }
        return getPublicRootInstance(root);
    }
    var didWarnAboutFindDOMNode = false;
    function findDOMNode(componentOrElement) {
        if (!didWarnAboutFindDOMNode) {
            didWarnAboutFindDOMNode = true;
            error("findDOMNode is deprecated and will be removed in the next major release. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node");
        }
        var owner = ReactCurrentOwner$3.current;
        if (owner !== null && owner.stateNode !== null) {
            var warnedAboutRefsInRender = owner.stateNode._warnedAboutRefsInRender;
            if (!warnedAboutRefsInRender) error("%s is accessing findDOMNode inside its render(). render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", getComponentNameFromType(owner.type) || 'A component');
            owner.stateNode._warnedAboutRefsInRender = true;
        }
        if (componentOrElement == null) return null;
        if (componentOrElement.nodeType === ELEMENT_NODE) return componentOrElement;
        return findHostInstanceWithWarning(componentOrElement, 'findDOMNode');
    }
    function hydrate(element, container, callback) {
        error("ReactDOM.hydrate is no longer supported in React 18. Use hydrateRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot");
        if (!isValidContainerLegacy(container)) throw new Error('Target container is not a DOM element.');
        var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
        if (isModernRoot) error("You are calling ReactDOM.hydrate() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call hydrateRoot(container, element)?");
        return legacyRenderSubtreeIntoContainer(null, element, container, true, callback);
    }
    function render(element, container, callback) {
        error("ReactDOM.render is no longer supported in React 18. Use createRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot");
        if (!isValidContainerLegacy(container)) throw new Error('Target container is not a DOM element.');
        var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
        if (isModernRoot) error("You are calling ReactDOM.render() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.render(element)?");
        return legacyRenderSubtreeIntoContainer(null, element, container, false, callback);
    }
    function unstable_renderSubtreeIntoContainer(parentComponent, element, containerNode, callback) {
        error("ReactDOM.unstable_renderSubtreeIntoContainer() is no longer supported in React 18. Consider using a portal instead. Until you switch to the createRoot API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot");
        if (!isValidContainerLegacy(containerNode)) throw new Error('Target container is not a DOM element.');
        if (parentComponent == null || !has(parentComponent)) throw new Error('parentComponent must be a valid React Component');
        return legacyRenderSubtreeIntoContainer(parentComponent, element, containerNode, false, callback);
    }
    var didWarnAboutUnmountComponentAtNode = false;
    function unmountComponentAtNode(container) {
        if (!didWarnAboutUnmountComponentAtNode) {
            didWarnAboutUnmountComponentAtNode = true;
            error("unmountComponentAtNode is deprecated and will be removed in the next major release. Switch to the createRoot API. Learn more: https://reactjs.org/link/switch-to-createroot");
        }
        if (!isValidContainerLegacy(container)) throw new Error('unmountComponentAtNode(...): Target container is not a DOM element.');
        var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
        if (isModernRoot) error("You are calling ReactDOM.unmountComponentAtNode() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.unmount()?");
        if (container._reactRootContainer) {
            var rootEl = getReactRootElementInContainer(container);
            var renderedByDifferentReact = rootEl && !getInstanceFromNode(rootEl);
            if (renderedByDifferentReact) error("unmountComponentAtNode(): The node you're attempting to unmount was rendered by another copy of React.");
            flushSync(function() {
                legacyRenderSubtreeIntoContainer(null, null, container, false, function() {
                    // $FlowFixMe This should probably use `delete container._reactRootContainer`
                    container._reactRootContainer = null;
                    unmarkContainerAsRoot(container);
                });
            }); // If you call unmountComponentAtNode twice in quick succession, you'll
            // get `true` twice. That's probably fine?
            return true;
        } else {
            var _rootEl = getReactRootElementInContainer(container);
            var hasNonRootReactChild = !!(_rootEl && getInstanceFromNode(_rootEl)); // Check if the container itself is a React root node.
            var isContainerReactRoot = container.nodeType === ELEMENT_NODE && isValidContainerLegacy(container.parentNode) && !!container.parentNode._reactRootContainer;
            if (hasNonRootReactChild) error("unmountComponentAtNode(): The node you're attempting to unmount was rendered by React and is not a top-level container. %s", isContainerReactRoot ? "You may have accidentally passed in a React root node instead of its container." : "Instead, have the parent component update its state and rerender in order to remove this component.");
            return false;
        }
    }
    setAttemptSynchronousHydration(attemptSynchronousHydration$1);
    setAttemptContinuousHydration(attemptContinuousHydration$1);
    setAttemptHydrationAtCurrentPriority(attemptHydrationAtCurrentPriority$1);
    setGetCurrentUpdatePriority(getCurrentUpdatePriority);
    setAttemptHydrationAtPriority(runWithPriority);
    if (typeof Map !== 'function' || // $FlowIssue Flow incorrectly thinks Map has no prototype
    Map.prototype == null || typeof Map.prototype.forEach !== 'function' || typeof Set !== 'function' || // $FlowIssue Flow incorrectly thinks Set has no prototype
    Set.prototype == null || typeof Set.prototype.clear !== 'function' || typeof Set.prototype.forEach !== 'function') error("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    setRestoreImplementation(restoreControlledState$3);
    setBatchingImplementation(batchedUpdates$1, discreteUpdates, flushSync);
    function createPortal$1(children, container) {
        var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        if (!isValidContainer(container)) throw new Error('Target container is not a DOM element.');
         // TODO: pass ReactDOM portal implementation as third argument
        // $FlowFixMe The Flow type is opaque but there's no way to actually create it.
        return createPortal(children, container, null, key);
    }
    function renderSubtreeIntoContainer(parentComponent, element, containerNode, callback) {
        return unstable_renderSubtreeIntoContainer(parentComponent, element, containerNode, callback);
    }
    var Internals = {
        usingClientEntryPoint: false,
        // Keep in sync with ReactTestUtils.js.
        // This is an array for better minification.
        Events: [
            getInstanceFromNode,
            getNodeFromInstance,
            getFiberCurrentPropsFromNode,
            enqueueStateRestore,
            restoreStateIfNeeded,
            batchedUpdates$1
        ]
    };
    function createRoot$1(container, options) {
        if (!Internals.usingClientEntryPoint && true) error('You are importing createRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".');
        return createRoot(container, options);
    }
    function hydrateRoot$1(container, initialChildren, options) {
        if (!Internals.usingClientEntryPoint && true) error('You are importing hydrateRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".');
        return hydrateRoot(container, initialChildren, options);
    } // Overload the definition to the two valid signatures.
    // Warning, this opts-out of checking the function body.
    // eslint-disable-next-line no-redeclare
    function flushSync$1(fn) {
        if (isAlreadyRendering()) error("flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task.");
        return flushSync(fn);
    }
    var foundDevTools = injectIntoDevTools({
        findFiberByHostInstance: getClosestInstanceFromNode,
        bundleType: 1,
        version: ReactVersion,
        rendererPackageName: 'react-dom'
    });
    if (!foundDevTools && canUseDOM && window.top === window.self) // If we're in Chrome or Firefox, provide a download link if not installed.
    {
        if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
            var protocol = window.location.protocol; // Don't warn in exotic cases like chrome-extension://.
            if (/^(https?|file):$/.test(protocol)) // eslint-disable-next-line react-internal/no-production-logging
            console.info("%cDownload the React DevTools for a better development experience: https://reactjs.org/link/react-devtools" + (protocol === 'file:' ? "\nYou might need to use a local HTTP server (instead of file://): https://reactjs.org/link/react-devtools-faq" : ''), 'font-weight:bold');
        }
    }
    exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Internals;
    exports.createPortal = createPortal$1;
    exports.createRoot = createRoot$1;
    exports.findDOMNode = findDOMNode;
    exports.flushSync = flushSync$1;
    exports.hydrate = hydrate;
    exports.hydrateRoot = hydrateRoot$1;
    exports.render = render;
    exports.unmountComponentAtNode = unmountComponentAtNode;
    exports.unstable_batchedUpdates = batchedUpdates$1;
    exports.unstable_renderSubtreeIntoContainer = renderSubtreeIntoContainer;
    exports.version = ReactVersion;
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === 'function') __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
})();

},{"6f0162e9ab224cd4":"c8CN1","8ad4ca65319d28a7":"OILcw"}],"OILcw":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("ef03b89c8fe2794e");

},{"ef03b89c8fe2794e":"1EGCK"}],"1EGCK":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * scheduler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
(function() {
    'use strict';
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === 'function') __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var enableSchedulerDebugging = false;
    var enableProfiling = false;
    var frameYieldMs = 5;
    function push(heap, node) {
        var index = heap.length;
        heap.push(node);
        siftUp(heap, node, index);
    }
    function peek(heap) {
        return heap.length === 0 ? null : heap[0];
    }
    function pop(heap) {
        if (heap.length === 0) return null;
        var first = heap[0];
        var last = heap.pop();
        if (last !== first) {
            heap[0] = last;
            siftDown(heap, last, 0);
        }
        return first;
    }
    function siftUp(heap, node, i) {
        var index = i;
        while(index > 0){
            var parentIndex = index - 1 >>> 1;
            var parent = heap[parentIndex];
            if (compare(parent, node) > 0) {
                // The parent is larger. Swap positions.
                heap[parentIndex] = node;
                heap[index] = parent;
                index = parentIndex;
            } else // The parent is smaller. Exit.
            return;
        }
    }
    function siftDown(heap, node, i) {
        var index = i;
        var length = heap.length;
        var halfLength = length >>> 1;
        while(index < halfLength){
            var leftIndex = (index + 1) * 2 - 1;
            var left = heap[leftIndex];
            var rightIndex = leftIndex + 1;
            var right = heap[rightIndex]; // If the left or right node is smaller, swap with the smaller of those.
            if (compare(left, node) < 0) {
                if (rightIndex < length && compare(right, left) < 0) {
                    heap[index] = right;
                    heap[rightIndex] = node;
                    index = rightIndex;
                } else {
                    heap[index] = left;
                    heap[leftIndex] = node;
                    index = leftIndex;
                }
            } else if (rightIndex < length && compare(right, node) < 0) {
                heap[index] = right;
                heap[rightIndex] = node;
                index = rightIndex;
            } else // Neither child is smaller. Exit.
            return;
        }
    }
    function compare(a, b) {
        // Compare sort index first, then task id.
        var diff = a.sortIndex - b.sortIndex;
        return diff !== 0 ? diff : a.id - b.id;
    }
    // TODO: Use symbols?
    var ImmediatePriority = 1;
    var UserBlockingPriority = 2;
    var NormalPriority = 3;
    var LowPriority = 4;
    var IdlePriority = 5;
    function markTaskErrored(task, ms) {}
    /* eslint-disable no-var */ var hasPerformanceNow = typeof performance === 'object' && typeof performance.now === 'function';
    if (hasPerformanceNow) {
        var localPerformance = performance;
        exports.unstable_now = function() {
            return localPerformance.now();
        };
    } else {
        var localDate = Date;
        var initialTime = localDate.now();
        exports.unstable_now = function() {
            return localDate.now() - initialTime;
        };
    } // Max 31 bit integer. The max integer size in V8 for 32-bit systems.
    // Math.pow(2, 30) - 1
    // 0b111111111111111111111111111111
    var maxSigned31BitInt = 1073741823; // Times out immediately
    var IMMEDIATE_PRIORITY_TIMEOUT = -1; // Eventually times out
    var USER_BLOCKING_PRIORITY_TIMEOUT = 250;
    var NORMAL_PRIORITY_TIMEOUT = 5000;
    var LOW_PRIORITY_TIMEOUT = 10000; // Never times out
    var IDLE_PRIORITY_TIMEOUT = maxSigned31BitInt; // Tasks are stored on a min heap
    var taskQueue = [];
    var timerQueue = []; // Incrementing id counter. Used to maintain insertion order.
    var taskIdCounter = 1; // Pausing the scheduler is useful for debugging.
    var currentTask = null;
    var currentPriorityLevel = NormalPriority; // This is set while performing work, to prevent re-entrance.
    var isPerformingWork = false;
    var isHostCallbackScheduled = false;
    var isHostTimeoutScheduled = false; // Capture local references to native APIs, in case a polyfill overrides them.
    var localSetTimeout = typeof setTimeout === 'function' ? setTimeout : null;
    var localClearTimeout = typeof clearTimeout === 'function' ? clearTimeout : null;
    var localSetImmediate = typeof setImmediate !== 'undefined' ? setImmediate : null; // IE and Node.js + jsdom
    var isInputPending = typeof navigator !== 'undefined' && navigator.scheduling !== undefined && navigator.scheduling.isInputPending !== undefined ? navigator.scheduling.isInputPending.bind(navigator.scheduling) : null;
    function advanceTimers(currentTime) {
        // Check for tasks that are no longer delayed and add them to the queue.
        var timer = peek(timerQueue);
        while(timer !== null){
            if (timer.callback === null) // Timer was cancelled.
            pop(timerQueue);
            else if (timer.startTime <= currentTime) {
                // Timer fired. Transfer to the task queue.
                pop(timerQueue);
                timer.sortIndex = timer.expirationTime;
                push(taskQueue, timer);
            } else // Remaining timers are pending.
            return;
            timer = peek(timerQueue);
        }
    }
    function handleTimeout(currentTime) {
        isHostTimeoutScheduled = false;
        advanceTimers(currentTime);
        if (!isHostCallbackScheduled) {
            if (peek(taskQueue) !== null) {
                isHostCallbackScheduled = true;
                requestHostCallback(flushWork);
            } else {
                var firstTimer = peek(timerQueue);
                if (firstTimer !== null) requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
            }
        }
    }
    function flushWork(hasTimeRemaining, initialTime) {
        isHostCallbackScheduled = false;
        if (isHostTimeoutScheduled) {
            // We scheduled a timeout but it's no longer needed. Cancel it.
            isHostTimeoutScheduled = false;
            cancelHostTimeout();
        }
        isPerformingWork = true;
        var previousPriorityLevel = currentPriorityLevel;
        try {
            if (enableProfiling) try {
                return workLoop(hasTimeRemaining, initialTime);
            } catch (error) {
                if (currentTask !== null) {
                    var currentTime = exports.unstable_now();
                    markTaskErrored(currentTask, currentTime);
                    currentTask.isQueued = false;
                }
                throw error;
            }
            else // No catch in prod code path.
            return workLoop(hasTimeRemaining, initialTime);
        } finally{
            currentTask = null;
            currentPriorityLevel = previousPriorityLevel;
            isPerformingWork = false;
        }
    }
    function workLoop(hasTimeRemaining, initialTime) {
        var currentTime = initialTime;
        advanceTimers(currentTime);
        currentTask = peek(taskQueue);
        while(currentTask !== null && !enableSchedulerDebugging){
            if (currentTask.expirationTime > currentTime && (!hasTimeRemaining || shouldYieldToHost())) break;
            var callback = currentTask.callback;
            if (typeof callback === 'function') {
                currentTask.callback = null;
                currentPriorityLevel = currentTask.priorityLevel;
                var didUserCallbackTimeout = currentTask.expirationTime <= currentTime;
                var continuationCallback = callback(didUserCallbackTimeout);
                currentTime = exports.unstable_now();
                if (typeof continuationCallback === 'function') currentTask.callback = continuationCallback;
                else if (currentTask === peek(taskQueue)) pop(taskQueue);
                advanceTimers(currentTime);
            } else pop(taskQueue);
            currentTask = peek(taskQueue);
        } // Return whether there's additional work
        if (currentTask !== null) return true;
        else {
            var firstTimer = peek(timerQueue);
            if (firstTimer !== null) requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
            return false;
        }
    }
    function unstable_runWithPriority(priorityLevel, eventHandler) {
        switch(priorityLevel){
            case ImmediatePriority:
            case UserBlockingPriority:
            case NormalPriority:
            case LowPriority:
            case IdlePriority:
                break;
            default:
                priorityLevel = NormalPriority;
        }
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;
        try {
            return eventHandler();
        } finally{
            currentPriorityLevel = previousPriorityLevel;
        }
    }
    function unstable_next(eventHandler) {
        var priorityLevel;
        switch(currentPriorityLevel){
            case ImmediatePriority:
            case UserBlockingPriority:
            case NormalPriority:
                // Shift down to normal priority
                priorityLevel = NormalPriority;
                break;
            default:
                // Anything lower than normal priority should remain at the current level.
                priorityLevel = currentPriorityLevel;
                break;
        }
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;
        try {
            return eventHandler();
        } finally{
            currentPriorityLevel = previousPriorityLevel;
        }
    }
    function unstable_wrapCallback(callback) {
        var parentPriorityLevel = currentPriorityLevel;
        return function() {
            // This is a fork of runWithPriority, inlined for performance.
            var previousPriorityLevel = currentPriorityLevel;
            currentPriorityLevel = parentPriorityLevel;
            try {
                return callback.apply(this, arguments);
            } finally{
                currentPriorityLevel = previousPriorityLevel;
            }
        };
    }
    function unstable_scheduleCallback(priorityLevel, callback, options) {
        var currentTime = exports.unstable_now();
        var startTime;
        if (typeof options === 'object' && options !== null) {
            var delay = options.delay;
            if (typeof delay === 'number' && delay > 0) startTime = currentTime + delay;
            else startTime = currentTime;
        } else startTime = currentTime;
        var timeout;
        switch(priorityLevel){
            case ImmediatePriority:
                timeout = IMMEDIATE_PRIORITY_TIMEOUT;
                break;
            case UserBlockingPriority:
                timeout = USER_BLOCKING_PRIORITY_TIMEOUT;
                break;
            case IdlePriority:
                timeout = IDLE_PRIORITY_TIMEOUT;
                break;
            case LowPriority:
                timeout = LOW_PRIORITY_TIMEOUT;
                break;
            case NormalPriority:
            default:
                timeout = NORMAL_PRIORITY_TIMEOUT;
                break;
        }
        var expirationTime = startTime + timeout;
        var newTask = {
            id: taskIdCounter++,
            callback: callback,
            priorityLevel: priorityLevel,
            startTime: startTime,
            expirationTime: expirationTime,
            sortIndex: -1
        };
        if (startTime > currentTime) {
            // This is a delayed task.
            newTask.sortIndex = startTime;
            push(timerQueue, newTask);
            if (peek(taskQueue) === null && newTask === peek(timerQueue)) {
                // All tasks are delayed, and this is the task with the earliest delay.
                if (isHostTimeoutScheduled) // Cancel an existing timeout.
                cancelHostTimeout();
                else isHostTimeoutScheduled = true;
                 // Schedule a timeout.
                requestHostTimeout(handleTimeout, startTime - currentTime);
            }
        } else {
            newTask.sortIndex = expirationTime;
            push(taskQueue, newTask);
            // wait until the next time we yield.
            if (!isHostCallbackScheduled && !isPerformingWork) {
                isHostCallbackScheduled = true;
                requestHostCallback(flushWork);
            }
        }
        return newTask;
    }
    function unstable_pauseExecution() {}
    function unstable_continueExecution() {
        if (!isHostCallbackScheduled && !isPerformingWork) {
            isHostCallbackScheduled = true;
            requestHostCallback(flushWork);
        }
    }
    function unstable_getFirstCallbackNode() {
        return peek(taskQueue);
    }
    function unstable_cancelCallback(task) {
        // remove from the queue because you can't remove arbitrary nodes from an
        // array based heap, only the first one.)
        task.callback = null;
    }
    function unstable_getCurrentPriorityLevel() {
        return currentPriorityLevel;
    }
    var isMessageLoopRunning = false;
    var scheduledHostCallback = null;
    var taskTimeoutID = -1; // Scheduler periodically yields in case there is other work on the main
    // thread, like user events. By default, it yields multiple times per frame.
    // It does not attempt to align with frame boundaries, since most tasks don't
    // need to be frame aligned; for those that do, use requestAnimationFrame.
    var frameInterval = frameYieldMs;
    var startTime = -1;
    function shouldYieldToHost() {
        var timeElapsed = exports.unstable_now() - startTime;
        if (timeElapsed < frameInterval) // The main thread has only been blocked for a really short amount of time;
        // smaller than a single frame. Don't yield yet.
        return false;
         // The main thread has been blocked for a non-negligible amount of time. We
        return true;
    }
    function requestPaint() {}
    function forceFrameRate(fps) {
        if (fps < 0 || fps > 125) {
            // Using console['error'] to evade Babel and ESLint
            console['error']("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported");
            return;
        }
        if (fps > 0) frameInterval = Math.floor(1000 / fps);
        else // reset the framerate
        frameInterval = frameYieldMs;
    }
    var performWorkUntilDeadline = function performWorkUntilDeadline() {
        if (scheduledHostCallback !== null) {
            var currentTime = exports.unstable_now(); // Keep track of the start time so we can measure how long the main thread
            // has been blocked.
            startTime = currentTime;
            var hasTimeRemaining = true; // If a scheduler task throws, exit the current browser task so the
            // error can be observed.
            //
            // Intentionally not using a try-catch, since that makes some debugging
            // techniques harder. Instead, if `scheduledHostCallback` errors, then
            // `hasMoreWork` will remain true, and we'll continue the work loop.
            var hasMoreWork = true;
            try {
                hasMoreWork = scheduledHostCallback(hasTimeRemaining, currentTime);
            } finally{
                if (hasMoreWork) // If there's more work, schedule the next message event at the end
                // of the preceding one.
                schedulePerformWorkUntilDeadline();
                else {
                    isMessageLoopRunning = false;
                    scheduledHostCallback = null;
                }
            }
        } else isMessageLoopRunning = false;
         // Yielding to the browser will give it a chance to paint, so we can
    };
    var schedulePerformWorkUntilDeadline;
    if (typeof localSetImmediate === 'function') // Node.js and old IE.
    // There's a few reasons for why we prefer setImmediate.
    //
    // Unlike MessageChannel, it doesn't prevent a Node.js process from exiting.
    // (Even though this is a DOM fork of the Scheduler, you could get here
    // with a mix of Node.js 15+, which has a MessageChannel, and jsdom.)
    // https://github.com/facebook/react/issues/20756
    //
    // But also, it runs earlier which is the semantic we want.
    // If other browsers ever implement it, it's better to use it.
    // Although both of these would be inferior to native scheduling.
    schedulePerformWorkUntilDeadline = function schedulePerformWorkUntilDeadline() {
        localSetImmediate(performWorkUntilDeadline);
    };
    else if (typeof MessageChannel !== 'undefined') {
        // DOM and Worker environments.
        // We prefer MessageChannel because of the 4ms setTimeout clamping.
        var channel = new MessageChannel();
        var port = channel.port2;
        channel.port1.onmessage = performWorkUntilDeadline;
        schedulePerformWorkUntilDeadline = function schedulePerformWorkUntilDeadline() {
            port.postMessage(null);
        };
    } else // We should only fallback here in non-browser environments.
    schedulePerformWorkUntilDeadline = function schedulePerformWorkUntilDeadline() {
        localSetTimeout(performWorkUntilDeadline, 0);
    };
    function requestHostCallback(callback) {
        scheduledHostCallback = callback;
        if (!isMessageLoopRunning) {
            isMessageLoopRunning = true;
            schedulePerformWorkUntilDeadline();
        }
    }
    function requestHostTimeout(callback, ms) {
        taskTimeoutID = localSetTimeout(function() {
            callback(exports.unstable_now());
        }, ms);
    }
    function cancelHostTimeout() {
        localClearTimeout(taskTimeoutID);
        taskTimeoutID = -1;
    }
    var unstable_requestPaint = requestPaint;
    var unstable_Profiling = null;
    exports.unstable_IdlePriority = IdlePriority;
    exports.unstable_ImmediatePriority = ImmediatePriority;
    exports.unstable_LowPriority = LowPriority;
    exports.unstable_NormalPriority = NormalPriority;
    exports.unstable_Profiling = unstable_Profiling;
    exports.unstable_UserBlockingPriority = UserBlockingPriority;
    exports.unstable_cancelCallback = unstable_cancelCallback;
    exports.unstable_continueExecution = unstable_continueExecution;
    exports.unstable_forceFrameRate = forceFrameRate;
    exports.unstable_getCurrentPriorityLevel = unstable_getCurrentPriorityLevel;
    exports.unstable_getFirstCallbackNode = unstable_getFirstCallbackNode;
    exports.unstable_next = unstable_next;
    exports.unstable_pauseExecution = unstable_pauseExecution;
    exports.unstable_requestPaint = unstable_requestPaint;
    exports.unstable_runWithPriority = unstable_runWithPriority;
    exports.unstable_scheduleCallback = unstable_scheduleCallback;
    exports.unstable_shouldYield = shouldYieldToHost;
    exports.unstable_wrapCallback = unstable_wrapCallback;
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === 'function') __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
})();

},{}],"jJell":[function(require,module,exports,__globalThis) {
// Default to a dummy "batch" implementation that just runs the callback
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setBatch", function() {
    return setBatch;
});
parcelHelpers.export(exports, "getBatch", function() {
    return getBatch;
});
function defaultNoopBatch(callback) {
    callback();
}
var batch = defaultNoopBatch; // Allow injecting another batching function later
var setBatch = function(newBatch) {
    return batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings
var getBatch = function() {
    return batch;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"hKcoU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initializeUseSelector", function() {
    return initializeUseSelector;
});
/**
 * Hook factory, which creates a `useSelector` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useSelector` hook bound to the specified context.
 */ parcelHelpers.export(exports, "createSelectorHook", function() {
    return createSelectorHook;
});
parcelHelpers.export(exports, "useSelector", function() {
    return useSelector;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _react = require("react");
var _useReduxContext = require("./useReduxContext");
var _context = require("../components/Context");
var _useSyncExternalStore = require("../utils/useSyncExternalStore");
var useSyncExternalStoreWithSelector = (0, _useSyncExternalStore.notInitialized);
var initializeUseSelector = function(fn) {
    useSyncExternalStoreWithSelector = fn;
};
var refEquality = function(a, b) {
    return a === b;
};
function createSelectorHook() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, _context.ReactReduxContext);
    var useReduxContext = context === (0, _context.ReactReduxContext) ? (0, _useReduxContext.useReduxContext) : (0, _useReduxContext.createReduxContextHook)(context);
    return function useSelector(selector) {
        var equalityFnOrOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var _ref = typeof equalityFnOrOptions === 'function' ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions, _ref_equalityFn = _ref.equalityFn, equalityFn = _ref_equalityFn === void 0 ? refEquality : _ref_equalityFn, stabilityCheck = _ref.stabilityCheck, noopCheck = _ref.noopCheck;
        if (!selector) throw new Error(`You must pass a selector to useSelector`);
        if (typeof selector !== 'function') throw new Error(`You must pass a function as a selector to useSelector`);
        if (typeof equalityFn !== 'function') throw new Error(`You must pass a function as an equality function to useSelector`);
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store, subscription = _useReduxContext.subscription, getServerState = _useReduxContext.getServerState, globalStabilityCheck = _useReduxContext.stabilityCheck, globalNoopCheck = _useReduxContext.noopCheck;
        var firstRun = (0, _react.useRef)(true);
        var wrappedSelector = (0, _react.useCallback)((0, _defineProperty._)({}, selector.name, function(state) {
            var selected = selector(state);
            {
                var finalStabilityCheck = typeof stabilityCheck === 'undefined' ? globalStabilityCheck : stabilityCheck;
                if (finalStabilityCheck === 'always' || finalStabilityCheck === 'once' && firstRun.current) {
                    var toCompare = selector(state);
                    if (!equalityFn(selected, toCompare)) {
                        var stack = undefined;
                        try {
                            throw new Error();
                        } catch (e) {
                            stack = e.stack;
                        }
                        console.warn('Selector ' + (selector.name || 'unknown') + ' returned a different result when called with the same parameters. This can lead to unnecessary rerenders.' + '\nSelectors that return a new reference (such as an object or an array) should be memoized: https://redux.js.org/usage/deriving-data-selectors#optimizing-selectors-with-memoization', {
                            state: state,
                            selected: selected,
                            selected2: toCompare,
                            stack: stack
                        });
                    }
                }
                var finalNoopCheck = typeof noopCheck === 'undefined' ? globalNoopCheck : noopCheck;
                if (finalNoopCheck === 'always' || finalNoopCheck === 'once' && firstRun.current) // @ts-ignore
                {
                    if (selected === state) {
                        var stack1 = undefined;
                        try {
                            throw new Error();
                        } catch (e) {
                            stack1 = e.stack;
                        }
                        console.warn('Selector ' + (selector.name || 'unknown') + ' returned the root state when called. This can lead to unnecessary rerenders.' + '\nSelectors that return the entire state are almost certainly a mistake, as they will cause a rerender whenever *anything* in state changes.', {
                            stack: stack1
                        });
                    }
                }
                if (firstRun.current) firstRun.current = false;
            }
            return selected;
        })[selector.name], [
            selector,
            globalStabilityCheck,
            stabilityCheck
        ]);
        var selectedState = useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        (0, _react.useDebugValue)(selectedState);
        return selectedState;
    };
}
var useSelector = /*#__PURE__*/ createSelectorHook();

},{"@swc/helpers/_/_define_property":"54Zvk","react":"c8CN1","./useReduxContext":"hzx1D","../components/Context":"4I62F","../utils/useSyncExternalStore":"2kIGR","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"hzx1D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Hook factory, which creates a `useReduxContext` hook bound to a given context. This is a low-level
 * hook that you should usually not need to call directly.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useReduxContext` hook bound to the specified context.
 */ parcelHelpers.export(exports, "createReduxContextHook", function() {
    return createReduxContextHook;
});
parcelHelpers.export(exports, "useReduxContext", function() {
    return useReduxContext;
});
var _react = require("react");
var _context = require("../components/Context");
function createReduxContextHook() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, _context.ReactReduxContext);
    return function useReduxContext() {
        var contextValue = (0, _react.useContext)(context);
        if (!contextValue) throw new Error('could not find react-redux context value; please ensure the component is wrapped in a <Provider>');
        return contextValue;
    };
}
var useReduxContext = /*#__PURE__*/ createReduxContextHook();

},{"react":"c8CN1","../components/Context":"4I62F","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4I62F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactReduxContext", function() {
    return ReactReduxContext;
});
var _react = require("react");
var ContextKey = Symbol.for(`react-redux-context`);
var gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function getContext() {
    var _gT$ContextKey;
    if (!_react.createContext) return {};
    var contextMap = (_gT$ContextKey = gT[ContextKey]) != null ? _gT$ContextKey : gT[ContextKey] = new Map();
    var realContext = contextMap.get(_react.createContext);
    if (!realContext) {
        realContext = _react.createContext(null);
        realContext.displayName = 'ReactRedux';
        contextMap.set(_react.createContext, realContext);
    }
    return realContext;
}
var ReactReduxContext = /*#__PURE__*/ getContext();
exports.default = ReactReduxContext;

},{"react":"c8CN1","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2kIGR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "notInitialized", function() {
    return notInitialized;
});
var notInitialized = function() {
    throw new Error('uSES not initialized!');
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"61bh2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initializeConnect", function() {
    return initializeConnect;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
/* eslint-disable valid-jsdoc, @typescript-eslint/no-unused-vars */ var _hoistNonReactStatics = require("hoist-non-react-statics");
var _hoistNonReactStaticsDefault = parcelHelpers.interopDefault(_hoistNonReactStatics);
var _react = require("react");
var _reactIs = require("react-is");
var _selectorFactory = require("../connect/selectorFactory");
var _selectorFactoryDefault = parcelHelpers.interopDefault(_selectorFactory);
var _mapDispatchToProps = require("../connect/mapDispatchToProps");
var _mapStateToProps = require("../connect/mapStateToProps");
var _mergeProps = require("../connect/mergeProps");
var _subscription = require("../utils/Subscription");
var _useIsomorphicLayoutEffect = require("../utils/useIsomorphicLayoutEffect");
var _shallowEqual = require("../utils/shallowEqual");
var _shallowEqualDefault = parcelHelpers.interopDefault(_shallowEqual);
var _warning = require("../utils/warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
var _context = require("./Context");
var _useSyncExternalStore = require("../utils/useSyncExternalStore");
var _excluded = [
    "reactReduxForwardedRef"
];
var useSyncExternalStore = (0, _useSyncExternalStore.notInitialized);
var initializeConnect = function(fn) {
    useSyncExternalStore = fn;
}; // Define some constant arrays just to avoid re-creating these
var EMPTY_ARRAY = [
    null,
    0
];
var NO_SUBSCRIPTION_ARRAY = [
    null,
    null
]; // Attempts to stringify whatever not-really-a-component value we were given
// for logging in an error message
var stringifyComponent = function(Comp) {
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
// This is "just" a `useLayoutEffect`, but with two modifications:
// - we need to fall back to `useEffect` in SSR to avoid annoying warnings
// - we extract this to a separate function to avoid closing over values
//   and causing memory leaks
function useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function() {
        return effectFunc.apply(void 0, (0, _toConsumableArray._)(effectArgs));
    }, dependencies);
} // Effect callback, extracted: assign the latest props values to refs for later usage
function captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
} // Effect callback, extracted: subscribe to the Redux store or nearest connected ancestor,
// check for updates after dispatched actions, and trigger re-renders.
function subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return function() {}; // Capture values for checking if and when this component unmounts
    var didUnsubscribe = false;
    var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    var checkForUpdates = function() {
        if (didUnsubscribe || !isMounted.current) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
         // TODO We're currently calling getState ourselves here, rather than letting `uSES` do it
        var latestStoreState = store.getState();
        var newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // TODO This is hacky and not how `uSES` is meant to be used
            // Trigger the React `useSyncExternalStore` subscriber
            additionalSubscribeListener();
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    var unsubscribeWrapper = function() {
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
} // Reducer initial state creation for our update reducer
var initStateUpdates = function() {
    return EMPTY_ARRAY;
};
function strictEqual(a, b) {
    return a === b;
}
/**
 * Infers the type of props that a connector will inject into a component.
 */ var hasWarnedAboutDeprecatedPureOption = false;
/**
 * Connects a React component to a Redux store.
 *
 * - Without arguments, just wraps the component, without changing the behavior / props
 *
 * - If 2 params are passed (3rd param, mergeProps, is skipped), default behavior
 * is to override ownProps (as stated in the docs), so what remains is everything that's
 * not a state or dispatch prop
 *
 * - When 3rd param is passed, we don't know if ownProps propagate and whether they
 * should be valid component props, because it depends on mergeProps implementation.
 * As such, it is the user's responsibility to extend ownProps interface from state or
 * dispatch props or both when applicable
 *
 * @param mapStateToProps A function that extracts values from state
 * @param mapDispatchToProps Setup for dispatching actions
 * @param mergeProps Optional callback to merge state and dispatch props together
 * @param options Options for configuring the connection
 *
 */ function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
    // @ts-ignore
    pure = _ref.pure, _ref_areStatesEqual = _ref.areStatesEqual, areStatesEqual = _ref_areStatesEqual === void 0 ? strictEqual : _ref_areStatesEqual, _ref_areOwnPropsEqual = _ref.areOwnPropsEqual, areOwnPropsEqual = _ref_areOwnPropsEqual === void 0 ? (0, _shallowEqualDefault.default) : _ref_areOwnPropsEqual, _ref_areStatePropsEqual = _ref.areStatePropsEqual, areStatePropsEqual = _ref_areStatePropsEqual === void 0 ? (0, _shallowEqualDefault.default) : _ref_areStatePropsEqual, _ref_areMergedPropsEqual = _ref.areMergedPropsEqual, areMergedPropsEqual = _ref_areMergedPropsEqual === void 0 ? (0, _shallowEqualDefault.default) : _ref_areMergedPropsEqual, _ref_forwardRef = _ref.// use React's forwardRef to expose a ref of the wrapped component
    forwardRef, forwardRef = _ref_forwardRef === void 0 ? false : _ref_forwardRef, _ref_context = _ref.// the context consumer to use
    context, context = _ref_context === void 0 ? (0, _context.ReactReduxContext) : _ref_context;
    if (pure !== undefined && !hasWarnedAboutDeprecatedPureOption) {
        hasWarnedAboutDeprecatedPureOption = true;
        (0, _warningDefault.default)('The `pure` option has been removed. `connect` is now always a "pure/memoized" component');
    }
    var Context = context;
    var initMapStateToProps = (0, _mapStateToProps.mapStateToPropsFactory)(mapStateToProps);
    var initMapDispatchToProps = (0, _mapDispatchToProps.mapDispatchToPropsFactory)(mapDispatchToProps);
    var initMergeProps = (0, _mergeProps.mergePropsFactory)(mergeProps);
    var shouldHandleStateChanges = Boolean(mapStateToProps);
    var wrapWithConnect = function(WrappedComponent) {
        if (!(0, _reactIs.isValidElementType)(WrappedComponent)) throw new Error(`You must pass a component to the function returned by connect. Instead received ${stringifyComponent(WrappedComponent)}`);
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
        var displayName = `Connect(${wrappedComponentName})`;
        var selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            // @ts-ignore
            initMapStateToProps: initMapStateToProps,
            // @ts-ignore
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            var _React_useMemo = (0, _slicedToArray._)(_react.useMemo(function() {
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                var reactReduxForwardedRef = props.reactReduxForwardedRef, wrapperProps = (0, _objectWithoutPropertiesLooseDefault.default)(props, _excluded);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]), 3), propsContext = _React_useMemo[0], reactReduxForwardedRef = _React_useMemo[1], wrapperProps = _React_useMemo[2];
            var ContextToUse = _react.useMemo(function() {
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && // @ts-ignore
                (0, _reactIs.isContextConsumer)(/*#__PURE__*/ _react.createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            var contextValue = _react.useContext(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            if (!didStoreComeFromProps && !didStoreComeFromContext) throw new Error(`Could not find "store" in the context of ` + `"${displayName}". Either wrap the root component in a <Provider>, ` + `or pass a custom React context provider to <Provider> and the corresponding ` + `React context consumer to ${displayName} in connect options.`);
             // Based on the previous check, one of these must be true
            var store = didStoreComeFromProps ? props.store : contextValue.store;
            var getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            var childPropsSelector = _react.useMemo(function() {
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return (0, _selectorFactoryDefault.default)(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            var _React_useMemo1 = (0, _slicedToArray._)(_react.useMemo(function() {
                if (!shouldHandleStateChanges) return NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                var subscription = (0, _subscription.createSubscription)(store, didStoreComeFromProps ? undefined : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]), 2), subscription = _React_useMemo1[0], notifyNestedSubs = _React_useMemo1[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            var overriddenContextValue = _react.useMemo(function() {
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, _extendsDefault.default)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // Set up refs to coordinate values between the subscription effect and the render logic
            var lastChildProps = _react.useRef();
            var lastWrapperProps = _react.useRef(wrapperProps);
            var childPropsFromStoreUpdate = _react.useRef();
            var renderIsScheduled = _react.useRef(false);
            var isProcessingDispatch = _react.useRef(false);
            var isMounted = _react.useRef(false);
            var latestSubscriptionCallbackError = _react.useRef();
            (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function() {
                isMounted.current = true;
                return function() {
                    isMounted.current = false;
                };
            }, []);
            var actualChildPropsSelector = _react.useMemo(function() {
                var selector = function() {
                    // Tricky logic here:
                    // - This render may have been triggered by a Redux store update that produced new child props
                    // - However, we may have gotten new wrapper props after that
                    // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                    // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                    // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                     // TODO We're reading the store directly in render() here. Bad idea?
                    // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                    // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                    // to determine what the child props should be.
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            var subscribeForReact = _react.useMemo(function() {
                var subscribe = function(reactListener) {
                    if (!subscription) return function() {};
                    return subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            useIsomorphicLayoutEffectWithArgs(captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            var actualChildProps;
            try {
                actualChildProps = useSyncExternalStore(subscribeForReact, // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? function() {
                    return childPropsSelector(getServerState(), wrapperProps);
                } : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `\nThe error may be correlated with this previous error:\n${latestSubscriptionCallbackError.current.stack}\n\n`;
                throw err;
            }
            (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function() {
                latestSubscriptionCallbackError.current = undefined;
                childPropsFromStoreUpdate.current = undefined;
                lastChildProps.current = actualChildProps;
            }); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            var renderedWrappedComponent = _react.useMemo(function() {
                return(/*#__PURE__*/ // @ts-ignore
                _react.createElement(WrappedComponent, (0, _extendsDefault.default)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            var renderedChild = _react.useMemo(function() {
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ _react.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        var _Connect = _react.memo(ConnectFunction);
        // Add a hacky cast to get the right output type
        var Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            var _forwarded = _react.forwardRef(function forwardConnectRef(props, ref) {
                // @ts-ignore
                return /*#__PURE__*/ _react.createElement(Connect, (0, _extendsDefault.default)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            var forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, _hoistNonReactStaticsDefault.default)(forwarded, WrappedComponent);
        }
        return (0, _hoistNonReactStaticsDefault.default)(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
exports.default = connect;

},{"@swc/helpers/_/_sliced_to_array":"ha6sq","@swc/helpers/_/_to_consumable_array":"eqNDD","@babel/runtime/helpers/esm/extends":"jSPXj","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dAnBs","hoist-non-react-statics":"9oeVj","react":"c8CN1","react-is":"4RhZJ","../connect/selectorFactory":"eJpfZ","../connect/mapDispatchToProps":"8VGVx","../connect/mapStateToProps":"i563l","../connect/mergeProps":"8bNlc","../utils/Subscription":"ixFzf","../utils/useIsomorphicLayoutEffect":"5PH4o","../utils/shallowEqual":"a2LtI","../utils/warning":"2ZkiK","./Context":"4I62F","../utils/useSyncExternalStore":"2kIGR","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jSPXj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _extends;
});
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function _extends(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"dAnBs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _objectWithoutPropertiesLoose;
});
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"9oeVj":[function(require,module,exports,__globalThis) {
'use strict';
var reactIs = require("c03b486d83967636");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
function getStatics(component) {
    // React v16.11 and below
    if (reactIs.isMemo(component)) return MEMO_STATICS;
     // React v16.12 and above
    return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}
var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = getOwnPropertyNames(sourceComponent);
        if (getOwnPropertySymbols) keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        var targetStatics = getStatics(targetComponent);
        var sourceStatics = getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = hoistNonReactStatics;

},{"c03b486d83967636":"MjK33"}],"MjK33":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("2255125a8e8b1051");

},{"2255125a8e8b1051":"h7Yze"}],"h7Yze":[function(require,module,exports,__globalThis) {
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
(function() {
    'use strict';
    // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
    // nor polyfill, then a plain number is used for performance.
    var hasSymbol = typeof Symbol === 'function' && Symbol.for;
    var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
    var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
    var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
    var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
    var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
    var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
    var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
    // (unstable) APIs that have been removed. Can we remove the symbols?
    var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
    var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
    var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
    var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
    var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
    var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
    var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
    var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
    var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
    var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
    var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;
    function isValidElementType(type) {
        return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
    }
    function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
            var $$typeof = object.$$typeof;
            switch($$typeof){
                case REACT_ELEMENT_TYPE:
                    var type = object.type;
                    switch(type){
                        case REACT_ASYNC_MODE_TYPE:
                        case REACT_CONCURRENT_MODE_TYPE:
                        case REACT_FRAGMENT_TYPE:
                        case REACT_PROFILER_TYPE:
                        case REACT_STRICT_MODE_TYPE:
                        case REACT_SUSPENSE_TYPE:
                            return type;
                        default:
                            var $$typeofType = type && type.$$typeof;
                            switch($$typeofType){
                                case REACT_CONTEXT_TYPE:
                                case REACT_FORWARD_REF_TYPE:
                                case REACT_LAZY_TYPE:
                                case REACT_MEMO_TYPE:
                                case REACT_PROVIDER_TYPE:
                                    return $$typeofType;
                                default:
                                    return $$typeof;
                            }
                    }
                case REACT_PORTAL_TYPE:
                    return $$typeof;
            }
        }
        return undefined;
    } // AsyncMode is deprecated along with isAsyncMode
    var AsyncMode = REACT_ASYNC_MODE_TYPE;
    var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
    var ContextConsumer = REACT_CONTEXT_TYPE;
    var ContextProvider = REACT_PROVIDER_TYPE;
    var Element = REACT_ELEMENT_TYPE;
    var ForwardRef = REACT_FORWARD_REF_TYPE;
    var Fragment = REACT_FRAGMENT_TYPE;
    var Lazy = REACT_LAZY_TYPE;
    var Memo = REACT_MEMO_TYPE;
    var Portal = REACT_PORTAL_TYPE;
    var Profiler = REACT_PROFILER_TYPE;
    var StrictMode = REACT_STRICT_MODE_TYPE;
    var Suspense = REACT_SUSPENSE_TYPE;
    var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated
    function isAsyncMode(object) {
        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint
            console['warn']("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
    }
    function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
    }
    function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
    }
    function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
    }
    function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
    }
    function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
    }
    function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
    }
    function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
    }
    function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
    }
    function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
    }
    function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
    }
    function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
    }
    exports.AsyncMode = AsyncMode;
    exports.ConcurrentMode = ConcurrentMode;
    exports.ContextConsumer = ContextConsumer;
    exports.ContextProvider = ContextProvider;
    exports.Element = Element;
    exports.ForwardRef = ForwardRef;
    exports.Fragment = Fragment;
    exports.Lazy = Lazy;
    exports.Memo = Memo;
    exports.Portal = Portal;
    exports.Profiler = Profiler;
    exports.StrictMode = StrictMode;
    exports.Suspense = Suspense;
    exports.isAsyncMode = isAsyncMode;
    exports.isConcurrentMode = isConcurrentMode;
    exports.isContextConsumer = isContextConsumer;
    exports.isContextProvider = isContextProvider;
    exports.isElement = isElement;
    exports.isForwardRef = isForwardRef;
    exports.isFragment = isFragment;
    exports.isLazy = isLazy;
    exports.isMemo = isMemo;
    exports.isPortal = isPortal;
    exports.isProfiler = isProfiler;
    exports.isStrictMode = isStrictMode;
    exports.isSuspense = isSuspense;
    exports.isValidElementType = isValidElementType;
    exports.typeOf = typeOf;
})();

},{}],"4RhZJ":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("d31d03ee5728daed");

},{"d31d03ee5728daed":"emrR6"}],"emrR6":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
(function() {
    'use strict';
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types.
    var REACT_ELEMENT_TYPE = Symbol.for('react.element');
    var REACT_PORTAL_TYPE = Symbol.for('react.portal');
    var REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
    var REACT_STRICT_MODE_TYPE = Symbol.for('react.strict_mode');
    var REACT_PROFILER_TYPE = Symbol.for('react.profiler');
    var REACT_PROVIDER_TYPE = Symbol.for('react.provider');
    var REACT_CONTEXT_TYPE = Symbol.for('react.context');
    var REACT_SERVER_CONTEXT_TYPE = Symbol.for('react.server_context');
    var REACT_FORWARD_REF_TYPE = Symbol.for('react.forward_ref');
    var REACT_SUSPENSE_TYPE = Symbol.for('react.suspense');
    var REACT_SUSPENSE_LIST_TYPE = Symbol.for('react.suspense_list');
    var REACT_MEMO_TYPE = Symbol.for('react.memo');
    var REACT_LAZY_TYPE = Symbol.for('react.lazy');
    var REACT_OFFSCREEN_TYPE = Symbol.for('react.offscreen');
    // -----------------------------------------------------------------------------
    var enableScopeAPI = false; // Experimental Create Event Handle API.
    var enableCacheElement = false;
    var enableTransitionTracing = false; // No known bugs, but needs performance testing
    var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
    // stuff. Intended to enable React core members to more easily debug scheduling
    // issues in DEV builds.
    var enableDebugTracing = false; // Track which Fiber(s) schedule render work.
    var REACT_MODULE_REFERENCE;
    REACT_MODULE_REFERENCE = Symbol.for('react.module.reference');
    function isValidElementType(type) {
        if (typeof type === 'string' || typeof type === 'function') return true;
         // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).
        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) return true;
        if (typeof type === 'object' && type !== null) {
            if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
            // types supported by any Flight configuration anywhere since
            // we don't know which Flight build this will end up being used
            // with.
            type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) return true;
        }
        return false;
    }
    function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
            var $$typeof = object.$$typeof;
            switch($$typeof){
                case REACT_ELEMENT_TYPE:
                    var type = object.type;
                    switch(type){
                        case REACT_FRAGMENT_TYPE:
                        case REACT_PROFILER_TYPE:
                        case REACT_STRICT_MODE_TYPE:
                        case REACT_SUSPENSE_TYPE:
                        case REACT_SUSPENSE_LIST_TYPE:
                            return type;
                        default:
                            var $$typeofType = type && type.$$typeof;
                            switch($$typeofType){
                                case REACT_SERVER_CONTEXT_TYPE:
                                case REACT_CONTEXT_TYPE:
                                case REACT_FORWARD_REF_TYPE:
                                case REACT_LAZY_TYPE:
                                case REACT_MEMO_TYPE:
                                case REACT_PROVIDER_TYPE:
                                    return $$typeofType;
                                default:
                                    return $$typeof;
                            }
                    }
                case REACT_PORTAL_TYPE:
                    return $$typeof;
            }
        }
        return undefined;
    }
    var ContextConsumer = REACT_CONTEXT_TYPE;
    var ContextProvider = REACT_PROVIDER_TYPE;
    var Element = REACT_ELEMENT_TYPE;
    var ForwardRef = REACT_FORWARD_REF_TYPE;
    var Fragment = REACT_FRAGMENT_TYPE;
    var Lazy = REACT_LAZY_TYPE;
    var Memo = REACT_MEMO_TYPE;
    var Portal = REACT_PORTAL_TYPE;
    var Profiler = REACT_PROFILER_TYPE;
    var StrictMode = REACT_STRICT_MODE_TYPE;
    var Suspense = REACT_SUSPENSE_TYPE;
    var SuspenseList = REACT_SUSPENSE_LIST_TYPE;
    var hasWarnedAboutDeprecatedIsAsyncMode = false;
    var hasWarnedAboutDeprecatedIsConcurrentMode = false; // AsyncMode should be deprecated
    function isAsyncMode(object) {
        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint
            console['warn']("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.");
        }
        return false;
    }
    function isConcurrentMode(object) {
        if (!hasWarnedAboutDeprecatedIsConcurrentMode) {
            hasWarnedAboutDeprecatedIsConcurrentMode = true; // Using console['warn'] to evade Babel and ESLint
            console['warn']("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.");
        }
        return false;
    }
    function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
    }
    function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
    }
    function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
    }
    function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
    }
    function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
    }
    function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
    }
    function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
    }
    function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
    }
    function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
    }
    function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
    }
    function isSuspenseList(object) {
        return typeOf(object) === REACT_SUSPENSE_LIST_TYPE;
    }
    exports.ContextConsumer = ContextConsumer;
    exports.ContextProvider = ContextProvider;
    exports.Element = Element;
    exports.ForwardRef = ForwardRef;
    exports.Fragment = Fragment;
    exports.Lazy = Lazy;
    exports.Memo = Memo;
    exports.Portal = Portal;
    exports.Profiler = Profiler;
    exports.StrictMode = StrictMode;
    exports.Suspense = Suspense;
    exports.SuspenseList = SuspenseList;
    exports.isAsyncMode = isAsyncMode;
    exports.isConcurrentMode = isConcurrentMode;
    exports.isContextConsumer = isContextConsumer;
    exports.isContextProvider = isContextProvider;
    exports.isElement = isElement;
    exports.isForwardRef = isForwardRef;
    exports.isFragment = isFragment;
    exports.isLazy = isLazy;
    exports.isMemo = isMemo;
    exports.isPortal = isPortal;
    exports.isProfiler = isProfiler;
    exports.isStrictMode = isStrictMode;
    exports.isSuspense = isSuspense;
    exports.isSuspenseList = isSuspenseList;
    exports.isValidElementType = isValidElementType;
    exports.typeOf = typeOf;
})();

},{}],"eJpfZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pureFinalPropsSelectorFactory", function() {
    return pureFinalPropsSelectorFactory;
});
parcelHelpers.export(exports, "default", function() {
    return finalPropsSelectorFactory;
});
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _verifySubselectors = require("./verifySubselectors");
var _verifySubselectorsDefault = parcelHelpers.interopDefault(_verifySubselectors);
var _excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, param) {
    var areStatesEqual = param.areStatesEqual, areOwnPropsEqual = param.areOwnPropsEqual, areStatePropsEqual = param.areStatePropsEqual;
    var hasRunAtLeastOnce = false;
    var state;
    var ownProps;
    var stateProps;
    var dispatchProps;
    var mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        var nextStateProps = mapStateToProps(state, ownProps);
        var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        var stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function finalPropsSelectorFactory(dispatch, _ref) {
    var initMapStateToProps = _ref.initMapStateToProps, initMapDispatchToProps = _ref.initMapDispatchToProps, initMergeProps = _ref.initMergeProps, options = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, _excluded);
    var mapStateToProps = initMapStateToProps(dispatch, options);
    var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    var mergeProps = initMergeProps(dispatch, options);
    (0, _verifySubselectorsDefault.default)(mapStateToProps, mapDispatchToProps, mergeProps);
    return pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dAnBs","./verifySubselectors":"9dSc6","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"9dSc6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return verifySubselectors;
});
var _warning = require("../utils/warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
function verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
        if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) (0, _warningDefault.default)(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    verify(mapStateToProps, 'mapStateToProps');
    verify(mapDispatchToProps, 'mapDispatchToProps');
    verify(mergeProps, 'mergeProps');
}

},{"../utils/warning":"2ZkiK","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2ZkiK":[function(require,module,exports,__globalThis) {
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return warning;
});
function warning(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8VGVx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapDispatchToPropsFactory", function() {
    return mapDispatchToPropsFactory;
});
var _bindActionCreators = require("../utils/bindActionCreators");
var _bindActionCreatorsDefault = parcelHelpers.interopDefault(_bindActionCreators);
var _wrapMapToProps = require("./wrapMapToProps");
var _invalidArgFactory = require("./invalidArgFactory");
function mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function(dispatch) {
        return (0, _bindActionCreatorsDefault.default)(mapDispatchToProps, dispatch);
    }) : !mapDispatchToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function(dispatch) {
        return {
            dispatch: dispatch
        };
    }) : typeof mapDispatchToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : (0, _invalidArgFactory.createInvalidArgFactory)(mapDispatchToProps, 'mapDispatchToProps');
}

},{"../utils/bindActionCreators":"l1hwJ","./wrapMapToProps":"gadfj","./invalidArgFactory":"8UnS6","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"l1hwJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return bindActionCreators;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
function bindActionCreators(actionCreators, dispatch) {
    var _loop = function(key) {
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return dispatch(actionCreator.apply(void 0, (0, _toConsumableArray._)(args)));
        };
    };
    var boundActionCreators = {};
    for(var key in actionCreators)_loop(key);
    return boundActionCreators;
}

},{"@swc/helpers/_/_to_consumable_array":"eqNDD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gadfj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "wrapMapToPropsConstant", function() {
    return wrapMapToPropsConstant;
}) // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
;
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
//
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
// TODO Can this get pulled out so that we can subscribe directly to the store if we don't need ownProps?
parcelHelpers.export(exports, "getDependsOnOwnProps", function() {
    return getDependsOnOwnProps;
}) // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
;
// this function wraps mapToProps in a proxy function which does several things:
//
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//
parcelHelpers.export(exports, "wrapMapToPropsFunc", function() {
    return wrapMapToPropsFunc;
});
var _verifyPlainObject = require("../utils/verifyPlainObject");
var _verifyPlainObjectDefault = parcelHelpers.interopDefault(_verifyPlainObject);
function wrapMapToPropsConstant(//  It seems that the dispatch argument
//  could be a dispatch function in some cases (ex: whenMapDispatchToPropsIsMissing)
//  and a state object in some others (ex: whenMapStateToPropsIsMissing)
// eslint-disable-next-line no-unused-vars
getConstant) {
    return function initConstantSelector(dispatch) {
        var constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, param) {
        var displayName = param.displayName;
        var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, undefined);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
            var props = proxy(stateOrDispatch, ownProps);
            if (typeof props === 'function') {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            (0, _verifyPlainObjectDefault.default)(props, displayName, methodName);
            return props;
        };
        return proxy;
    };
}

},{"../utils/verifyPlainObject":"go4mz","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"go4mz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return verifyPlainObject;
});
var _isPlainObject = require("./isPlainObject");
var _isPlainObjectDefault = parcelHelpers.interopDefault(_isPlainObject);
var _warning = require("./warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
function verifyPlainObject(value, displayName, methodName) {
    if (!(0, _isPlainObjectDefault.default)(value)) (0, _warningDefault.default)(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}

},{"./isPlainObject":"9VNtY","./warning":"2ZkiK","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"9VNtY":[function(require,module,exports,__globalThis) {
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isPlainObject;
});
function isPlainObject(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8UnS6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createInvalidArgFactory", function() {
    return createInvalidArgFactory;
});
function createInvalidArgFactory(arg, name) {
    return function(dispatch, options) {
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"i563l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapStateToPropsFactory", function() {
    return mapStateToPropsFactory;
});
var _wrapMapToProps = require("./wrapMapToProps");
var _invalidArgFactory = require("./invalidArgFactory");
function mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function() {
        return {};
    }) : typeof mapStateToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : (0, _invalidArgFactory.createInvalidArgFactory)(mapStateToProps, 'mapStateToProps');
}

},{"./wrapMapToProps":"gadfj","./invalidArgFactory":"8UnS6","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8bNlc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultMergeProps", function() {
    return defaultMergeProps;
});
parcelHelpers.export(exports, "wrapMergePropsFunc", function() {
    return wrapMergePropsFunc;
});
parcelHelpers.export(exports, "mergePropsFactory", function() {
    return mergePropsFactory;
});
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _verifyPlainObject = require("../utils/verifyPlainObject");
var _verifyPlainObjectDefault = parcelHelpers.interopDefault(_verifyPlainObject);
var _invalidArgFactory = require("./invalidArgFactory");
function defaultMergeProps(stateProps, dispatchProps, ownProps) {
    // @ts-ignore
    return (0, _extendsDefault.default)({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, param) {
        var displayName = param.displayName, areMergedPropsEqual = param.areMergedPropsEqual;
        var hasRunOnce = false;
        var mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
                (0, _verifyPlainObjectDefault.default)(mergedProps, displayName, 'mergeProps');
            }
            return mergedProps;
        };
    };
}
function mergePropsFactory(mergeProps) {
    return !mergeProps ? function() {
        return defaultMergeProps;
    } : typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : (0, _invalidArgFactory.createInvalidArgFactory)(mergeProps, 'mergeProps');
}

},{"@babel/runtime/helpers/esm/extends":"jSPXj","../utils/verifyPlainObject":"go4mz","./invalidArgFactory":"8UnS6","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"ixFzf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createSubscription", function() {
    return createSubscription;
});
var _batch = require("./batch"); // encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function createListenerCollection() {
    var batch = (0, _batch.getBatch)();
    var first = null;
    var last = null;
    return {
        clear: function() {
            first = null;
            last = null;
        },
        notify: function() {
            batch(function() {
                var listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get: function() {
            var listeners = [];
            var listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe: function(callback) {
            var isSubscribed = true;
            var listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var nullListeners = {
    notify: function() {},
    get: function() {
        return [];
    }
};
function createSubscription(store, parentSub) {
    var unsubscribe;
    var listeners = nullListeners; // Reasons to keep the subscription active
    var subscriptionsAmount = 0; // Is this specific subscription subscribed (or only nested ones?)
    var selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        var cleanupListener = listeners.subscribe(listener); // cleanup nested sub
        var removed = false;
        return function() {
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    var subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: function() {
            return listeners;
        }
    };
    return subscription;
}

},{"./batch":"jJell","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5PH4o":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "canUseDOM", function() {
    return canUseDOM;
});
parcelHelpers.export(exports, "useIsomorphicLayoutEffect", function() {
    return useIsomorphicLayoutEffect;
});
var _react = require("react"); // React currently throws a warning when using useLayoutEffect on the server.
var canUseDOM = !!(typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined');
var useIsomorphicLayoutEffect = canUseDOM ? _react.useLayoutEffect : _react.useEffect;

},{"react":"c8CN1","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"a2LtI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return shallowEqual;
});
function is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function shallowEqual(objA, objB) {
    if (is(objA, objB)) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"40eKr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Provider", function() {
    return 0, _providerDefault.default;
});
parcelHelpers.export(exports, "ReactReduxContext", function() {
    return 0, _context.ReactReduxContext;
});
parcelHelpers.export(exports, "connect", function() {
    return 0, _connectDefault.default;
});
parcelHelpers.export(exports, "useDispatch", function() {
    return 0, _useDispatch.useDispatch;
});
parcelHelpers.export(exports, "createDispatchHook", function() {
    return 0, _useDispatch.createDispatchHook;
});
parcelHelpers.export(exports, "useSelector", function() {
    return 0, _useSelector.useSelector;
});
parcelHelpers.export(exports, "createSelectorHook", function() {
    return 0, _useSelector.createSelectorHook;
});
parcelHelpers.export(exports, "useStore", function() {
    return 0, _useStore.useStore;
});
parcelHelpers.export(exports, "createStoreHook", function() {
    return 0, _useStore.createStoreHook;
});
parcelHelpers.export(exports, "shallowEqual", function() {
    return 0, _shallowEqualDefault.default;
});
var _provider = require("./components/Provider");
var _providerDefault = parcelHelpers.interopDefault(_provider);
var _connect = require("./components/connect");
var _connectDefault = parcelHelpers.interopDefault(_connect);
var _context = require("./components/Context");
var _useDispatch = require("./hooks/useDispatch");
var _useSelector = require("./hooks/useSelector");
var _useStore = require("./hooks/useStore");
var _shallowEqual = require("./utils/shallowEqual");
var _shallowEqualDefault = parcelHelpers.interopDefault(_shallowEqual);
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);

},{"./components/Provider":"3eoEH","./components/connect":"61bh2","./components/Context":"4I62F","./hooks/useDispatch":"kXa6p","./hooks/useSelector":"hKcoU","./hooks/useStore":"1eyjA","./utils/shallowEqual":"a2LtI","./types":"8SI8Y","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3eoEH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _context = require("./Context");
var _subscription = require("../utils/Subscription");
var _useIsomorphicLayoutEffect = require("../utils/useIsomorphicLayoutEffect");
function Provider(param) {
    var store = param.store, context = param.context, children = param.children, serverState = param.serverState, _param_stabilityCheck = param.stabilityCheck, stabilityCheck = _param_stabilityCheck === void 0 ? 'once' : _param_stabilityCheck, _param_noopCheck = param.noopCheck, noopCheck = _param_noopCheck === void 0 ? 'once' : _param_noopCheck;
    var contextValue = _react.useMemo(function() {
        var subscription = (0, _subscription.createSubscription)(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? function() {
                return serverState;
            } : undefined,
            stabilityCheck: stabilityCheck,
            noopCheck: noopCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        noopCheck
    ]);
    var previousState = _react.useMemo(function() {
        return store.getState();
    }, [
        store
    ]);
    (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function() {
        var subscription = contextValue.subscription;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return function() {
            subscription.tryUnsubscribe();
            subscription.onStateChange = undefined;
        };
    }, [
        contextValue,
        previousState
    ]);
    var Context = context || (0, _context.ReactReduxContext); // @ts-ignore 'AnyAction' is assignable to the constraint of type 'A', but 'A' could be instantiated with a different subtype
    return /*#__PURE__*/ _react.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
exports.default = Provider;

},{"react":"c8CN1","./Context":"4I62F","../utils/Subscription":"ixFzf","../utils/useIsomorphicLayoutEffect":"5PH4o","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"kXa6p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Hook factory, which creates a `useDispatch` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useDispatch` hook bound to the specified context.
 */ parcelHelpers.export(exports, "createDispatchHook", function() {
    return createDispatchHook;
});
parcelHelpers.export(exports, "useDispatch", function() {
    return useDispatch;
});
var _context = require("../components/Context");
var _useStore = require("./useStore");
function createDispatchHook() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, _context.ReactReduxContext);
    var useStore = context === (0, _context.ReactReduxContext) ? (0, _useStore.useStore) : (0, _useStore.createStoreHook)(context);
    return function useDispatch() {
        var store = useStore(); // @ts-ignore
        return store.dispatch;
    };
}
var useDispatch = /*#__PURE__*/ createDispatchHook();

},{"../components/Context":"4I62F","./useStore":"1eyjA","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1eyjA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Hook factory, which creates a `useStore` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useStore` hook bound to the specified context.
 */ parcelHelpers.export(exports, "createStoreHook", function() {
    return createStoreHook;
});
parcelHelpers.export(exports, "useStore", function() {
    return useStore;
});
var _context = require("../components/Context");
var _useReduxContext = require("./useReduxContext");
function createStoreHook() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, _context.ReactReduxContext);
    var useReduxContext = context === (0, _context.ReactReduxContext) ? (0, _useReduxContext.useReduxContext) : (0, _useReduxContext.createReduxContextHook)(context);
    return function useStore() {
        var store = useReduxContext().store; // @ts-ignore
        return store;
    };
}
var useStore = /*#__PURE__*/ createStoreHook();

},{"../components/Context":"4I62F","./useReduxContext":"hzx1D","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8SI8Y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"kmFyA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "apps", function() {
    return apps;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _account = require("../dom/views/Common/Account");
var _app = require("../dom/views/App");
var apps = [
    {
        Component: (0, _app.DomApp),
        id: null
    },
    {
        Component: (0, _account.Account),
        id: 'page_account'
    }
];

},{"react":"c8CN1","../dom/views/Common/Account":"bwA10","../dom/views/App":"jp6rK","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"bwA10":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Account", function() {
    return Account;
});
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _hooks = require("../../../std/hooks");
var _orderHistoryList = require("../Account/views/OrderHistoryList/OrderHistoryList");
var _orderHistoryDetails = require("../Account/views/OrderHistoryList/OrderHistoryDetails");
var _reactRouterDom = require("react-router-dom");
var _subscription = require("../Account/views/Subscription/Subscription");
var _paymentMethod = require("../Account/views/PaymentMethod/PaymentMethod");
var _login = require("../Account/views/Login/Login");
var _register = require("../Account/views/Login/Register");
var _loadAccountSaga = require("../../../app/sagas/loadAccountSaga");
var _lastOrderDetails = require("../Account/views/LastOrderDetails/LastOrderDetails");
function Account() {
    (0, _hooks.useOnEvent)((0, _loadAccountSaga.CustomerIsNotLoggedInKey), function() {
        window.location.href = '/account/login';
    });
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _reactRouterDom.BrowserRouter), {
        children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _reactRouterDom.Routes), {
            children: [
                /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _reactRouterDom.Route), {
                    path: "/account/login",
                    element: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _login.Login), {}, void 0, false, {
                        fileName: "src/script/src/dom/views/Common/Account.tsx",
                        lineNumber: 21,
                        columnNumber: 55
                    }, void 0)
                }, void 0, false, {
                    fileName: "src/script/src/dom/views/Common/Account.tsx",
                    lineNumber: 21,
                    columnNumber: 17
                }, this),
                /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _reactRouterDom.Route), {
                    path: "/account/register",
                    element: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _register.Register), {}, void 0, false, {
                        fileName: "src/script/src/dom/views/Common/Account.tsx",
                        lineNumber: 22,
                        columnNumber: 58
                    }, void 0)
                }, void 0, false, {
                    fileName: "src/script/src/dom/views/Common/Account.tsx",
                    lineNumber: 22,
                    columnNumber: 17
                }, this),
                /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _reactRouterDom.Route), {
                    path: "/account",
                    element: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _subscription.Subscription), {}, void 0, false, {
                        fileName: "src/script/src/dom/views/Common/Account.tsx",
                        lineNumber: 23,
                        columnNumber: 49
                    }, void 0)
                }, void 0, false, {
                    fileName: "src/script/src/dom/views/Common/Account.tsx",
                    lineNumber: 23,
                    columnNumber: 17
                }, this),
                /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _reactRouterDom.Route), {
                    path: "/pages/mon-compte",
                    element: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _subscription.Subscription), {}, void 0, false, {
                        fileName: "src/script/src/dom/views/Common/Account.tsx",
                        lineNumber: 24,
                        columnNumber: 58
                    }, void 0)
                }, void 0, false, {
                    fileName: "src/script/src/dom/views/Common/Account.tsx",
                    lineNumber: 24,
                    columnNumber: 17
                }, this),
                /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _reactRouterDom.Route), {
                    path: "/pages/abonnement",
                    element: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _subscription.Subscription), {}, void 0, false, {
                        fileName: "src/script/src/dom/views/Common/Account.tsx",
                        lineNumber: 25,
                        columnNumber: 58
                    }, void 0)
                }, void 0, false, {
                    fileName: "src/script/src/dom/views/Common/Account.tsx",
                    lineNumber: 25,
                    columnNumber: 17
                }, this),
                /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _reactRouterDom.Route), {
                    path: "/pages/commandes",
                    element: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _orderHistoryList.OrderHistoryList), {}, void 0, false, {
                        fileName: "src/script/src/dom/views/Common/Account.tsx",
                        lineNumber: 26,
                        columnNumber: 57
                    }, void 0)
                }, void 0, false, {
                    fileName: "src/script/src/dom/views/Common/Account.tsx",
                    lineNumber: 26,
                    columnNumber: 17
                }, this),
                /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _reactRouterDom.Route), {
                    path: "/pages/commandes/:orderId",
                    element: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _orderHistoryDetails.OrderHistoryDetails), {}, void 0, false, {
                        fileName: "src/script/src/dom/views/Common/Account.tsx",
                        lineNumber: 27,
                        columnNumber: 66
                    }, void 0)
                }, void 0, false, {
                    fileName: "src/script/src/dom/views/Common/Account.tsx",
                    lineNumber: 27,
                    columnNumber: 17
                }, this),
                /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _reactRouterDom.Route), {
                    path: "/pages/commandes/derniere",
                    element: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _lastOrderDetails.LastOrderDetails), {}, void 0, false, {
                        fileName: "src/script/src/dom/views/Common/Account.tsx",
                        lineNumber: 28,
                        columnNumber: 66
                    }, void 0)
                }, void 0, false, {
                    fileName: "src/script/src/dom/views/Common/Account.tsx",
                    lineNumber: 28,
                    columnNumber: 17
                }, this),
                /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _reactRouterDom.Route), {
                    path: "/pages/moyen-de-paiement",
                    element: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _paymentMethod.PaymentMethod), {}, void 0, false, {
                        fileName: "src/script/src/dom/views/Common/Account.tsx",
                        lineNumber: 29,
                        columnNumber: 65
                    }, void 0)
                }, void 0, false, {
                    fileName: "src/script/src/dom/views/Common/Account.tsx",
                    lineNumber: 29,
                    columnNumber: 17
                }, this)
            ]
        }, void 0, true, {
            fileName: "src/script/src/dom/views/Common/Account.tsx",
            lineNumber: 20,
            columnNumber: 13
        }, this)
    }, void 0, false, {
        fileName: "src/script/src/dom/views/Common/Account.tsx",
        lineNumber: 19,
        columnNumber: 9
    }, this);
}

},{"react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","../../../std/hooks":"j9RPQ","../Account/views/OrderHistoryList/OrderHistoryList":"4MKOz","../Account/views/OrderHistoryList/OrderHistoryDetails":"ePjGe","react-router-dom":"9VDGr","../Account/views/Subscription/Subscription":"lUAoT","../Account/views/PaymentMethod/PaymentMethod":"fJSro","../Account/views/Login/Login":"caL9L","../Account/views/Login/Register":"crChd","../../../app/sagas/loadAccountSaga":"fo1BR","../Account/views/LastOrderDetails/LastOrderDetails":"hiaZZ","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"j9RPQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDispatch", function() {
    return useDispatch;
});
parcelHelpers.export(exports, "useSelector", function() {
    return useSelector;
});
parcelHelpers.export(exports, "useTrigger", function() {
    return useTrigger;
});
parcelHelpers.export(exports, "useOnEvent", function() {
    return useOnEvent;
});
parcelHelpers.export(exports, "useScrollTo", function() {
    return useScrollTo;
});
parcelHelpers.export(exports, "getHeaderHeight", function() {
    return getHeaderHeight;
});
parcelHelpers.export(exports, "useLocalStorage", function() {
    return useLocalStorage;
});
parcelHelpers.export(exports, "usePreventBackgroundScroll", function() {
    return usePreventBackgroundScroll;
});
parcelHelpers.export(exports, "useOnElementAboveScreen", function() {
    return useOnElementAboveScreen;
});
parcelHelpers.export(exports, "MobileWindowPropertiesProvider", function() {
    return MobileWindowPropertiesProvider;
});
parcelHelpers.export(exports, "useMobileWindowProperties", function() {
    return useMobileWindowProperties;
});
parcelHelpers.export(exports, "useIsMobileTaskBarHidden", function() {
    return useIsMobileTaskBarHidden;
});
parcelHelpers.export(exports, "useSectionIsVisible", function() {
    return useSectionIsVisible;
});
parcelHelpers.export(exports, "useOnElementFirstAppearanceInScreen", function() {
    return useOnElementFirstAppearanceInScreen;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _reactRedux = require("react-redux");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _domElement = require("../dom/library/DomElement");
var _std = require("@reglo/std");
var _startDom = require("../../startDom");
var _uaParserJs = require("ua-parser-js");
var _uaParserJsDefault = parcelHelpers.interopDefault(_uaParserJs);
function useDispatch() {
    var nativeDispatch = (0, _reactRedux.useDispatch)();
    return function(event) {
        if (!event) return;
        nativeDispatch(event);
    };
}
function useSelector(selector) {
    return (0, _reactRedux.useSelector)(selector);
}
function useTrigger() {
    var ref = (0, _react.useRef)();
    var onFired = function(callback) {
        return ref.current = callback;
    };
    var trigger = function() {
        return (0, _std.unwrap)(ref.current)();
    };
    return [
        onFired,
        trigger
    ];
}
function useOnEvent(key, callback) {
    var eventBus = (0, _react.useContext)((0, _startDom.DomParamsContext)).eventBus;
    (0, _react.useEffect)(function() {
        eventBus.subscribeTo(key, callback);
        return function() {
            return eventBus.unsubscribeTo(key, callback);
        };
    });
}
function getBodyContainer() {
    var _document_querySelector;
    return document.body.scrollHeight > 0 ? document.documentElement : (_document_querySelector = document.querySelector('[data-body_container]')) !== null && _document_querySelector !== void 0 ? _document_querySelector : document.documentElement;
}
function useScrollTo(params) {
    var selector = params.selector;
    var _params_scrollDown;
    var scrollDown = (_params_scrollDown = params.scrollDown) !== null && _params_scrollDown !== void 0 ? _params_scrollDown : true;
    var element = (0, _domElement.useDomElement)(selector).element;
    var _params_position;
    var position = (_params_position = params.position) !== null && _params_position !== void 0 ? _params_position : 'top';
    var bodyContainer = getBodyContainer();
    return function() {
        if (!element) return;
        var currentPosition = bodyContainer.scrollTop;
        var elementRelativePosition = element.getBoundingClientRect()[position];
        var target = currentPosition + elementRelativePosition - getHeaderHeight();
        if (!scrollDown && currentPosition < target) return;
        bodyContainer.scrollTo({
            top: target,
            behavior: 'smooth'
        });
    };
}
function getHeaderHeight() {
    var _document_querySelector;
    var _document_querySelector_getBoundingClientRect_height;
    return (_document_querySelector_getBoundingClientRect_height = (_document_querySelector = document.querySelector('#header[data-sticky=true]')) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.getBoundingClientRect().height) !== null && _document_querySelector_getBoundingClientRect_height !== void 0 ? _document_querySelector_getBoundingClientRect_height : 0;
}
function useLocalStorage(key, defaultValue) {
    var _useState = (0, _slicedToArray._)((0, _react.useState)(loadState()), 2), state = _useState[0], setState = _useState[1];
    function loadState() {
        if (typeof window === 'undefined') return defaultValue;
        var serializedState = localStorage.getItem(key);
        return serializedState ? JSON.parse(serializedState) : defaultValue;
    }
    function update(state) {
        localStorage.setItem(key, JSON.stringify(state));
        setState(state);
    }
    return [
        state,
        update
    ];
}
function usePreventBackgroundScroll(isActive) {
    var scrollY = (0, _react.useRef)(0);
    function enableScroll() {
        document.body.style.position = '';
        document.body.style.top = '';
        window.scrollTo(0, scrollY.current);
    }
    function preventScroll() {
        var currentScrollY = window.scrollY;
        scrollY.current = currentScrollY;
        document.body.style.position = 'fixed';
        document.body.style.top = `-${currentScrollY}px`;
        document.body.style.width = `100vw`;
    }
    (0, _react.useEffect)(function() {
        isActive ? preventScroll() : enableScroll();
    }, [
        isActive
    ]);
    (0, _react.useEffect)(function() {
        return function() {
            enableScroll();
        };
    }, []);
}
function useOnElementAboveScreen(selector, callback) {
    var element = (0, _domElement.useDomElement)(selector).element;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), isAbove = _useState[0], setIsAbove = _useState[1];
    function scrollListener() {
        var position = (0, _std.unwrap)(element).getBoundingClientRect().bottom - getHeaderHeight();
        setIsAbove(position <= 0);
    }
    (0, _react.useEffect)(function() {
        window.addEventListener('scroll', scrollListener);
        return function() {
            return window.removeEventListener('scroll', scrollListener);
        };
    }, []);
    (0, _react.useEffect)(function() {
        callback(isAbove);
    }, [
        isAbove
    ]);
}
var MobileWindowPropertiesContext = /*#__PURE__*/ (0, _react.createContext)(null);
function MobileWindowPropertiesProvider(props) {
    var _useState = (0, _slicedToArray._)((0, _react.useState)(initialValue()), 2), value = _useState[0], setValue = _useState[1];
    function scrollListener() {
        setValue(updatedValue());
    }
    (0, _react.useEffect)(function() {
        window.addEventListener('scroll', scrollListener);
        return function() {
            return window.removeEventListener('scroll', scrollListener);
        };
    }, [
        value
    ]);
    function initialValue() {
        return {
            initialHeight: window.innerHeight,
            currentHeight: window.innerHeight,
            orientation: orientation()
        };
    }
    function orientation() {
        return window.innerHeight > window.innerWidth ? 'portrait' : 'landscape';
    }
    function updatedValue() {
        return {
            initialHeight: value.orientation === orientation() ? value.initialHeight : window.innerHeight,
            currentHeight: window.innerHeight,
            orientation: orientation()
        };
    }
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(MobileWindowPropertiesContext.Provider, {
        value: value,
        children: props.children
    }, void 0, false, {
        fileName: "src/script/src/std/hooks.tsx",
        lineNumber: 185,
        columnNumber: 9
    }, this);
}
function useMobileWindowProperties() {
    return (0, _std.unwrap)((0, _react.useContext)(MobileWindowPropertiesContext));
}
function useIsMobileTaskBarHidden() {
    var mobileWindowProperties = useMobileWindowProperties();
    if (!isMobile()) return false;
    if (!isPortrait()) return false;
    return isHigherThanInitial();
    function isHigherThanInitial() {
        return mobileWindowProperties.currentHeight > mobileWindowProperties.initialHeight;
    }
    function isPortrait() {
        return mobileWindowProperties.orientation === 'portrait';
    }
    function isMobile() {
        var uaParser = new (0, _uaParserJsDefault.default)();
        return uaParser.getOS().name === 'iOS' && uaParser.getDevice().type === 'mobile';
    }
}
function useSectionIsVisible(selector, callback) {
    var element = (0, _domElement.useDomElement)(selector).element;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(computeIsVisible()), 2), isVisible = _useState[0], setIsVisible = _useState[1];
    var bodyContainer = getBodyContainer();
    function scrollListener() {
        setIsVisible(computeIsVisible());
    }
    function computeIsVisible() {
        var rect = (0, _std.unwrap)(element).getBoundingClientRect();
        var headerHeight = getHeaderHeight();
        var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
        var limit = headerHeight + (viewHeight - headerHeight) * 0.6;
        return rect.top <= limit && rect.bottom > limit;
    }
    (0, _react.useEffect)(function() {
        bodyContainer.addEventListener('scroll', scrollListener);
        return function() {
            return bodyContainer.removeEventListener('scroll', scrollListener);
        };
    }, []);
    (0, _react.useEffect)(function() {
        callback(isVisible);
    }, [
        isVisible
    ]);
}
function useOnElementFirstAppearanceInScreen(callback, params) {
    var element = (0, _domElement.useDomElement)(params === null || params === void 0 ? void 0 : params.selector).element;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), alreadyTriggered = _useState[0], setAlreadyTriggered = _useState[1];
    (0, _react.useEffect)(initScrollListener);
    (0, _react.useEffect)(triggerOnLoad, []);
    function initScrollListener() {
        if (alreadyTriggered) return;
        window.addEventListener('scroll', scrollListener);
        return function() {
            return window.removeEventListener('scroll', scrollListener);
        };
    }
    function triggerOnLoad() {
        var _params_delayOnPageLoad;
        var delay = (_params_delayOnPageLoad = params === null || params === void 0 ? void 0 : params.delayOnPageLoad) !== null && _params_delayOnPageLoad !== void 0 ? _params_delayOnPageLoad : 0;
        setTimeout(triggerCallbackIfNeeded, delay);
    }
    function scrollListener() {
        triggerCallbackIfNeeded();
    }
    function triggerCallbackIfNeeded() {
        if (alreadyTriggered) return;
        if (isInScreen()) {
            callback();
            setAlreadyTriggered(true);
        }
    }
    function isInScreen() {
        var rect = (0, _std.unwrap)(element).getBoundingClientRect();
        var windowHeight = window.innerHeight || document.documentElement.clientHeight;
        return rect.top < windowHeight && rect.bottom > 0;
    }
}

},{"@swc/helpers/_/_sliced_to_array":"ha6sq","react/jsx-dev-runtime":"jXZ8I","react-redux":"ghMZu","react":"c8CN1","../dom/library/DomElement":"15N7Q","@reglo/std":"1USo0","../../startDom":"iwlTF","ua-parser-js":"82B9p","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"82B9p":[function(require,module,exports,__globalThis) {
/////////////////////////////////////////////////////////////////////////////////
/* UAParser.js v1.0.40
   Copyright © 2012-2024 Faisal Salman <f@faisalman.com>
   MIT License */ /*
   Detect Browser, Engine, OS, CPU, and Device type/model from User-Agent data.
   Supports browser & node.js environment. 
   Demo   : https://faisalman.github.io/ua-parser-js
   Source : https://github.com/faisalman/ua-parser-js */ /////////////////////////////////////////////////////////////////////////////////
(function(window1, undefined) {
    'use strict';
    //////////////
    // Constants
    /////////////
    var LIBVERSION = '1.0.40', EMPTY = '', UNKNOWN = '?', FUNC_TYPE = 'function', UNDEF_TYPE = 'undefined', OBJ_TYPE = 'object', STR_TYPE = 'string', MAJOR = 'major', MODEL = 'model', NAME = 'name', TYPE = 'type', VENDOR = 'vendor', VERSION = 'version', ARCHITECTURE = 'architecture', CONSOLE = 'console', MOBILE = 'mobile', TABLET = 'tablet', SMARTTV = 'smarttv', WEARABLE = 'wearable', EMBEDDED = 'embedded', UA_MAX_LENGTH = 500;
    var AMAZON = 'Amazon', APPLE = 'Apple', ASUS = 'ASUS', BLACKBERRY = 'BlackBerry', BROWSER = 'Browser', CHROME = 'Chrome', EDGE = 'Edge', FIREFOX = 'Firefox', GOOGLE = 'Google', HUAWEI = 'Huawei', LG = 'LG', MICROSOFT = 'Microsoft', MOTOROLA = 'Motorola', OPERA = 'Opera', SAMSUNG = 'Samsung', SHARP = 'Sharp', SONY = 'Sony', XIAOMI = 'Xiaomi', ZEBRA = 'Zebra', FACEBOOK = 'Facebook', CHROMIUM_OS = 'Chromium OS', MAC_OS = 'Mac OS', SUFFIX_BROWSER = ' Browser';
    ///////////
    // Helper
    //////////
    var extend = function extend(regexes, extensions) {
        var mergedRegexes = {};
        for(var i in regexes)if (extensions[i] && extensions[i].length % 2 === 0) mergedRegexes[i] = extensions[i].concat(regexes[i]);
        else mergedRegexes[i] = regexes[i];
        return mergedRegexes;
    }, enumerize = function enumerize(arr) {
        var enums = {};
        for(var i = 0; i < arr.length; i++)enums[arr[i].toUpperCase()] = arr[i];
        return enums;
    }, has = function has(str1, str2) {
        return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
    }, lowerize = function lowerize(str) {
        return str.toLowerCase();
    }, majorize = function majorize(version) {
        return typeof version === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split('.')[0] : undefined;
    }, trim = function trim(str, len) {
        if (typeof str === STR_TYPE) {
            str = str.replace(/^\s\s*/, EMPTY);
            return typeof len === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
        }
    };
    ///////////////
    // Map helper
    //////////////
    var rgxMapper = function rgxMapper(ua, arrays) {
        var i = 0, j, k, p, q, matches, match;
        // loop through all regexes maps
        while(i < arrays.length && !matches){
            var regex = arrays[i], props = arrays[i + 1]; // odd sequence (1,3,5,..)
            j = k = 0;
            // try matching uastring with regexes
            while(j < regex.length && !matches){
                if (!regex[j]) break;
                matches = regex[j++].exec(ua);
                if (!!matches) for(p = 0; p < props.length; p++){
                    match = matches[++k];
                    q = props[p];
                    // check if given property is actually array
                    if (typeof q === OBJ_TYPE && q.length > 0) {
                        if (q.length === 2) {
                            if (typeof q[1] == FUNC_TYPE) // assign modified match
                            this[q[0]] = q[1].call(this, match);
                            else // assign given value, ignore regex match
                            this[q[0]] = q[1];
                        } else if (q.length === 3) {
                            // check whether function or regex
                            if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) // call function (usually string mapper)
                            this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                            else // sanitize match using given regex
                            this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                        } else if (q.length === 4) this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                    } else this[q] = match ? match : undefined;
                }
            }
            i += 2;
        }
    }, strMapper = function strMapper(str, map) {
        for(var i in map){
            // check if current value is array
            if (typeof map[i] === OBJ_TYPE && map[i].length > 0) for(var j = 0; j < map[i].length; j++){
                if (has(map[i][j], str)) return i === UNKNOWN ? undefined : i;
            }
            else if (has(map[i], str)) return i === UNKNOWN ? undefined : i;
        }
        return map.hasOwnProperty('*') ? map['*'] : str;
    };
    ///////////////
    // String map
    //////////////
    // Safari < 3.0
    var oldSafariMap = {
        '1.0': '/8',
        '1.2': '/1',
        '1.3': '/3',
        '2.0': '/412',
        '2.0.2': '/416',
        '2.0.3': '/417',
        '2.0.4': '/419',
        '?': '/'
    }, windowsVersionMap = {
        'ME': '4.90',
        'NT 3.11': 'NT3.51',
        'NT 4.0': 'NT4.0',
        '2000': 'NT 5.0',
        'XP': [
            'NT 5.1',
            'NT 5.2'
        ],
        'Vista': 'NT 6.0',
        '7': 'NT 6.1',
        '8': 'NT 6.2',
        '8.1': 'NT 6.3',
        '10': [
            'NT 6.4',
            'NT 10.0'
        ],
        'RT': 'ARM'
    };
    //////////////
    // Regex map
    /////////////
    var regexes = {
        browser: [
            [
                /\b(?:crmo|crios)\/([\w\.]+)/i // Chrome for Android/iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    'Chrome'
                ]
            ],
            [
                /edg(?:e|ios|a)?\/([\w\.]+)/i // Microsoft Edge
            ],
            [
                VERSION,
                [
                    NAME,
                    'Edge'
                ]
            ],
            [
                // Presto based
                /(opera mini)\/([-\w\.]+)/i,
                /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
                /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i // Opera
            ],
            [
                NAME,
                VERSION
            ],
            [
                /opios[\/ ]+([\w\.]+)/i // Opera mini on iphone >= 8.0
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + ' Mini'
                ]
            ],
            [
                /\bop(?:rg)?x\/([\w\.]+)/i // Opera GX
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + ' GX'
                ]
            ],
            [
                /\bopr\/([\w\.]+)/i // Opera Webkit
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA
                ]
            ],
            [
                // Mixed
                /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i // Baidu
            ],
            [
                VERSION,
                [
                    NAME,
                    'Baidu'
                ]
            ],
            [
                /\b(?:mxbrowser|mxios|myie2)\/?([-\w\.]*)\b/i // Maxthon
            ],
            [
                VERSION,
                [
                    NAME,
                    'Maxthon'
                ]
            ],
            [
                /(kindle)\/([\w\.]+)/i,
                /(lunascape|maxthon|netfront|jasmine|blazer|sleipnir)[\/ ]?([\w\.]*)/i,
                // Lunascape/Maxthon/Netfront/Jasmine/Blazer/Sleipnir
                // Trident based
                /(avant|iemobile|slim(?:browser|boat|jet))[\/ ]?([\d\.]*)/i,
                /(?:ms|\()(ie) ([\w\.]+)/i,
                // Blink/Webkit/KHTML based                                         // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
                /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|duckduckgo|klar|helio|(?=comodo_)?dragon)\/([-\w\.]+)/i,
                // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ//Vivaldi/DuckDuckGo/Klar/Helio/Dragon
                /(heytap|ovi|115)browser\/([\d\.]+)/i,
                /(weibo)__([\d\.]+)/i // Weibo
            ],
            [
                NAME,
                VERSION
            ],
            [
                /quark(?:pc)?\/([-\w\.]+)/i // Quark
            ],
            [
                VERSION,
                [
                    NAME,
                    'Quark'
                ]
            ],
            [
                /\bddg\/([\w\.]+)/i // DuckDuckGo
            ],
            [
                VERSION,
                [
                    NAME,
                    'DuckDuckGo'
                ]
            ],
            [
                /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i // UCBrowser
            ],
            [
                VERSION,
                [
                    NAME,
                    'UC' + BROWSER
                ]
            ],
            [
                /microm.+\bqbcore\/([\w\.]+)/i,
                /\bqbcore\/([\w\.]+).+microm/i,
                /micromessenger\/([\w\.]+)/i // WeChat
            ],
            [
                VERSION,
                [
                    NAME,
                    'WeChat'
                ]
            ],
            [
                /konqueror\/([\w\.]+)/i // Konqueror
            ],
            [
                VERSION,
                [
                    NAME,
                    'Konqueror'
                ]
            ],
            [
                /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i // IE11
            ],
            [
                VERSION,
                [
                    NAME,
                    'IE'
                ]
            ],
            [
                /ya(?:search)?browser\/([\w\.]+)/i // Yandex
            ],
            [
                VERSION,
                [
                    NAME,
                    'Yandex'
                ]
            ],
            [
                /slbrowser\/([\w\.]+)/i // Smart Lenovo Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    'Smart Lenovo ' + BROWSER
                ]
            ],
            [
                /(avast|avg)\/([\w\.]+)/i // Avast/AVG Secure Browser
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    '$1 Secure ' + BROWSER
                ],
                VERSION
            ],
            [
                /\bfocus\/([\w\.]+)/i // Firefox Focus
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + ' Focus'
                ]
            ],
            [
                /\bopt\/([\w\.]+)/i // Opera Touch
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + ' Touch'
                ]
            ],
            [
                /coc_coc\w+\/([\w\.]+)/i // Coc Coc Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    'Coc Coc'
                ]
            ],
            [
                /dolfin\/([\w\.]+)/i // Dolphin
            ],
            [
                VERSION,
                [
                    NAME,
                    'Dolphin'
                ]
            ],
            [
                /coast\/([\w\.]+)/i // Opera Coast
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + ' Coast'
                ]
            ],
            [
                /miuibrowser\/([\w\.]+)/i // MIUI Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    'MIUI' + SUFFIX_BROWSER
                ]
            ],
            [
                /fxios\/([\w\.-]+)/i // Firefox for iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX
                ]
            ],
            [
                /\bqihoobrowser\/?([\w\.]*)/i // 360
            ],
            [
                VERSION,
                [
                    NAME,
                    '360'
                ]
            ],
            [
                /\b(qq)\/([\w\.]+)/i // QQ
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    '$1Browser'
                ],
                VERSION
            ],
            [
                /(oculus|sailfish|huawei|vivo|pico)browser\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    '$1' + SUFFIX_BROWSER
                ],
                VERSION
            ],
            [
                /samsungbrowser\/([\w\.]+)/i // Samsung Internet
            ],
            [
                VERSION,
                [
                    NAME,
                    SAMSUNG + ' Internet'
                ]
            ],
            [
                /metasr[\/ ]?([\d\.]+)/i // Sogou Explorer
            ],
            [
                VERSION,
                [
                    NAME,
                    'Sogou Explorer'
                ]
            ],
            [
                /(sogou)mo\w+\/([\d\.]+)/i // Sogou Mobile
            ],
            [
                [
                    NAME,
                    'Sogou Mobile'
                ],
                VERSION
            ],
            [
                /(electron)\/([\w\.]+) safari/i,
                /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
                /m?(qqbrowser|2345(?=browser|chrome|explorer))\w*[\/ ]?v?([\w\.]+)/i // QQ/2345
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(lbbrowser|rekonq)/i,
                /\[(linkedin)app\]/i // LinkedIn App for iOS & Android
            ],
            [
                NAME
            ],
            [
                /ome\/([\w\.]+) \w* ?(iron) saf/i,
                /ome\/([\w\.]+).+qihu (360)[es]e/i // 360
            ],
            [
                VERSION,
                NAME
            ],
            [
                // WebView
                /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i // Facebook App for iOS & Android
            ],
            [
                [
                    NAME,
                    FACEBOOK
                ],
                VERSION
            ],
            [
                /(Klarna)\/([\w\.]+)/i,
                /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
                /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
                /safari (line)\/([\w\.]+)/i,
                /\b(line)\/([\w\.]+)\/iab/i,
                /(alipay)client\/([\w\.]+)/i,
                /(twitter)(?:and| f.+e\/([\w\.]+))/i,
                /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i // Chromium/Instagram/Snapchat
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\bgsa\/([\w\.]+) .*safari\//i // Google Search Appliance on iOS
            ],
            [
                VERSION,
                [
                    NAME,
                    'GSA'
                ]
            ],
            [
                /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i // TikTok
            ],
            [
                VERSION,
                [
                    NAME,
                    'TikTok'
                ]
            ],
            [
                /headlesschrome(?:\/([\w\.]+)| )/i // Chrome Headless
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + ' Headless'
                ]
            ],
            [
                / wv\).+(chrome)\/([\w\.]+)/i // Chrome WebView
            ],
            [
                [
                    NAME,
                    CHROME + ' WebView'
                ],
                VERSION
            ],
            [
                /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i // Android Browser
            ],
            [
                VERSION,
                [
                    NAME,
                    'Android ' + BROWSER
                ]
            ],
            [
                /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i // Chrome/OmniWeb/Arora/Tizen/Nokia
            ],
            [
                NAME,
                VERSION
            ],
            [
                /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i // Mobile Safari
            ],
            [
                VERSION,
                [
                    NAME,
                    'Mobile Safari'
                ]
            ],
            [
                /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i // Safari & Safari Mobile
            ],
            [
                VERSION,
                NAME
            ],
            [
                /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i // Safari < 3.0
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    oldSafariMap
                ]
            ],
            [
                /(webkit|khtml)\/([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                // Gecko based
                /(navigator|netscape\d?)\/([-\w\.]+)/i // Netscape
            ],
            [
                [
                    NAME,
                    'Netscape'
                ],
                VERSION
            ],
            [
                /(wolvic|librewolf)\/([\w\.]+)/i // Wolvic/LibreWolf
            ],
            [
                NAME,
                VERSION
            ],
            [
                /mobile vr; rv:([\w\.]+)\).+firefox/i // Firefox Reality
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + ' Reality'
                ]
            ],
            [
                /ekiohf.+(flow)\/([\w\.]+)/i,
                /(swiftfox)/i,
                /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror)[\/ ]?([\w\.\+]+)/i,
                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
                /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
                /(firefox)\/([\w\.]+)/i,
                /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
                // Other
                /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Obigo/Mosaic/Go/ICE/UP.Browser
                /(links) \(([\w\.]+)/i // Links
            ],
            [
                NAME,
                [
                    VERSION,
                    /_/g,
                    '.'
                ]
            ],
            [
                /(cobalt)\/([\w\.]+)/i // Cobalt
            ],
            [
                NAME,
                [
                    VERSION,
                    /master.|lts./,
                    ""
                ]
            ]
        ],
        cpu: [
            [
                /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i // AMD64 (x64)
            ],
            [
                [
                    ARCHITECTURE,
                    'amd64'
                ]
            ],
            [
                /(ia32(?=;))/i // IA32 (quicktime)
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ],
            [
                /((?:i[346]|x)86)[;\)]/i // IA32 (x86)
            ],
            [
                [
                    ARCHITECTURE,
                    'ia32'
                ]
            ],
            [
                /\b(aarch64|arm(v?8e?l?|_?64))\b/i // ARM64
            ],
            [
                [
                    ARCHITECTURE,
                    'arm64'
                ]
            ],
            [
                /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i // ARMHF
            ],
            [
                [
                    ARCHITECTURE,
                    'armhf'
                ]
            ],
            [
                // PocketPC mistakenly identified as PowerPC
                /windows (ce|mobile); ppc;/i
            ],
            [
                [
                    ARCHITECTURE,
                    'arm'
                ]
            ],
            [
                /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i // PowerPC
            ],
            [
                [
                    ARCHITECTURE,
                    /ower/,
                    EMPTY,
                    lowerize
                ]
            ],
            [
                /(sun4\w)[;\)]/i // SPARC
            ],
            [
                [
                    ARCHITECTURE,
                    'sparc'
                ]
            ],
            [
                /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ]
        ],
        device: [
            [
                //////////////////////////
                // MOBILES & TABLETS
                /////////////////////////
                // Samsung
                /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:s[cgp]h|gt|sm)-(?![lr])\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
                /samsung[- ]((?!sm-[lr])[-\w]+)/i,
                /sec-(sgh\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Apple
                /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i // iPod/iPhone
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\((ipad);[-\w\),; ]+apple/i,
                /applecoremedia\/[\w\.]+ \((ipad)/i,
                /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(macintosh);/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ]
            ],
            [
                // Sharp
                /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Honor
                /(?:honor)([-\w ]+)[;\)]/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Honor'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Huawei
                /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:huawei)([-\w ]+)[;\)]/i,
                /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Xiaomi
                /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
                /\b; (\w+) build\/hm\1/i,
                /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
                /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
                /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
                /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite|pro)?)(?: bui|\))/i // Xiaomi Mi
            ],
            [
                [
                    MODEL,
                    /_/g,
                    ' '
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i,
                /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i // Mi Pad tablets
            ],
            [
                [
                    MODEL,
                    /_/g,
                    ' '
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // OPPO
                /; (\w+) bui.+ oppo/i,
                /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'OPPO'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(opd2\d{3}a?) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'OPPO'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // Vivo
                /vivo (\w+)(?: bui|\))/i,
                /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Vivo'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Realme
                /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Realme'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Motorola
                /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
                /\bmot(?:orola)?[- ](\w*)/i,
                /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(mz60\d|xoom[2 ]{0,2}) build\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // LG
                /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
                /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
                /\blg-?([\d\w]+) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Lenovo
                /(ideatab[-\w ]+)/i,
                /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Lenovo'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // Nokia
                /(?:maemo|nokia).*(n900|lumia \d+)/i,
                /nokia[-_ ]?([-\w\.]*)/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    ' '
                ],
                [
                    VENDOR,
                    'Nokia'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Google
                /(pixel c)\b/i // Google Pixel C
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i // Google Pixel
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Sony
                /droid.+; (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /sony tablet [ps]/i,
                /\b(?:sony)?sgp\w+(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    'Xperia Tablet'
                ],
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // OnePlus
                / (kb2005|in20[12]5|be20[12][59])\b/i,
                /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'OnePlus'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Amazon
                /(alexa)webm/i,
                /(kf[a-z]{2}wi|aeo(?!bc)\w\w)( bui|\))/i,
                /(kf[a-z]+)( bui|\)).+silk\//i // Kindle Fire HD
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i // Fire Phone
            ],
            [
                [
                    MODEL,
                    /(.+)/g,
                    'Fire Phone $1'
                ],
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // BlackBerry
                /(playbook);[-\w\),; ]+(rim)/i // BlackBerry PlayBook
            ],
            [
                MODEL,
                VENDOR,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:bb[a-f]|st[hv])100-\d)/i,
                /\(bb10; (\w+)/i // BlackBerry 10
            ],
            [
                MODEL,
                [
                    VENDOR,
                    BLACKBERRY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Asus
                /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // HTC
                /(nexus 9)/i // HTC Nexus 9
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'HTC'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
                // ZTE
                /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
                /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
            ],
            [
                VENDOR,
                [
                    MODEL,
                    /_/g,
                    ' '
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // TCL
                /droid [\w\.]+; ((?:8[14]9[16]|9(?:0(?:48|60|8[01])|1(?:3[27]|66)|2(?:6[69]|9[56])|466))[gqswx])\w*(\)| bui)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'TCL'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // itel
                /(itel) ((\w+))/i
            ],
            [
                [
                    VENDOR,
                    lowerize
                ],
                MODEL,
                [
                    TYPE,
                    strMapper,
                    {
                        'tablet': [
                            'p10001l',
                            'w7001'
                        ],
                        '*': 'mobile'
                    }
                ]
            ],
            [
                // Acer
                /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Acer'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                // Meizu
                /droid.+; (m[1-5] note) bui/i,
                /\bmz-([-\w]{2,})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Meizu'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Ulefone
                /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Ulefone'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Energizer
                /; (energy ?\w+)(?: bui|\))/i,
                /; energizer ([\w ]+)(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Energizer'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Cat
                /; cat (b35);/i,
                /; (b15q?|s22 flip|s48c|s62 pro)(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Cat'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Smartfren
                /((?:new )?andromax[\w- ]+)(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Smartfren'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // Nothing
                /droid.+; (a(?:015|06[35]|142p?))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Nothing'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                // MIXED
                /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno|micromax|advan)[-_ ]?([-\w]*)/i,
                // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron/Infinix/Tecno/Micromax/Advan
                /; (imo) ((?!tab)[\w ]+?)(?: bui|\))/i,
                /(hp) ([\w ]+\w)/i,
                /(asus)-?(\w+)/i,
                /(microsoft); (lumia[\w ]+)/i,
                /(lenovo)[-_ ]?([-\w]+)/i,
                /(jolla)/i,
                /(oppo) ?([\w ]+) bui/i // OPPO
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(imo) (tab \w+)/i,
                /(kobo)\s(ereader|touch)/i,
                /(archos) (gamepad2?)/i,
                /(hp).+(touchpad(?!.+tablet)|tablet)/i,
                /(kindle)\/([\w\.]+)/i,
                /(nook)[\w ]+build\/(\w+)/i,
                /(dell) (strea[kpr\d ]*[\dko])/i,
                /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
                /(trinity)[- ]*(t\d{3}) bui/i,
                /(gigaset)[- ]+(q\w{1,9}) bui/i,
                /(vodafone) ([\w ]+)(?:\)| bui)/i // Vodafone
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(surface duo)/i // Surface Duo
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid [\d\.]+; (fp\du?)(?: b|\))/i // Fairphone
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Fairphone'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(u304aa)/i // AT&T
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'AT&T'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\bsie-(\w*)/i // Siemens
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Siemens'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rct\w+) b/i // RCA Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'RCA'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(venue[\d ]{2,7}) b/i // Dell Venue Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Dell'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(q(?:mv|ta)\w+) b/i // Verizon Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Verizon'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i // Barnes & Noble Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Barnes & Noble'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(tm\d{3}\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'NuVision'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(k88) b/i // ZTE K Series Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'ZTE'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(nx\d{3}j) b/i // ZTE Nubia
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'ZTE'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(gen\d{3}) b.+49h/i // Swiss GEN Mobile
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Swiss'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(zur\d{3}) b/i // Swiss ZUR Tablet
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Swiss'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((zeki)?tb.*\b) b/i // Zeki Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Zeki'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b([yr]\d{2}) b/i,
                /\b(dragon[- ]+touch |dt)(\w{5}) b/i // Dragon Touch Tablet
            ],
            [
                [
                    VENDOR,
                    'Dragon Touch'
                ],
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(ns-?\w{0,9}) b/i // Insignia Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Insignia'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((nxa|next)-?\w{0,9}) b/i // NextBook Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'NextBook'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i // Voice Xtreme Phones
            ],
            [
                [
                    VENDOR,
                    'Voice'
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(lvtel\-)?(v1[12]) b/i // LvTel Phones
            ],
            [
                [
                    VENDOR,
                    'LvTel'
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(ph-1) /i // Essential PH-1
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Essential'
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(v(100md|700na|7011|917g).*\b) b/i // Envizen Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Envizen'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(trio[-\w\. ]+) b/i // MachSpeed Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'MachSpeed'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\btu_(1491) b/i // Rotor Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Rotor'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(shield[\w ]+) b/i // Nvidia Shield Tablets
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Nvidia'
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(sprint) (\w+)/i // Sprint Phones
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kin\.[onetw]{3})/i // Microsoft Kin
            ],
            [
                [
                    MODEL,
                    /\./g,
                    ' '
                ],
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i // Zebra
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                ///////////////////
                // SMARTTVS
                ///////////////////
                /smart-tv.+(samsung)/i // Samsung
            ],
            [
                VENDOR,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /hbbtv.+maple;(\d+)/i
            ],
            [
                [
                    MODEL,
                    /^/,
                    'SmartTV'
                ],
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i // LG SmartTV
            ],
            [
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(apple) ?tv/i // Apple TV
            ],
            [
                VENDOR,
                [
                    MODEL,
                    APPLE + ' TV'
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /crkey/i // Google Chromecast
            ],
            [
                [
                    MODEL,
                    CHROME + 'cast'
                ],
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /droid.+aft(\w+)( bui|\))/i // Fire TV
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\(dtv[\);].+(aquos)/i,
                /(aquos-tv[\w ]+)\)/i // Sharp
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(bravia[\w ]+)( bui|\))/i // Sony
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(mitv-\w{5}) bui/i // Xiaomi
            ],
            [
                MODEL,
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /Hbbtv.*(technisat) (.*);/i // TechniSAT
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
                /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i // HbbTV devices
            ],
            [
                [
                    VENDOR,
                    trim
                ],
                [
                    MODEL,
                    trim
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i // SmartTV from Unidentified Vendors
            ],
            [
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                ///////////////////
                // CONSOLES
                ///////////////////
                /(ouya)/i,
                /(nintendo) ([wids3utch]+)/i // Nintendo
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /droid.+; (shield) bui/i // Nvidia
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Nvidia'
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /(playstation [345portablevi]+)/i // Playstation
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /\b(xbox(?: one)?(?!; xbox))[\); ]/i // Microsoft Xbox
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                ///////////////////
                // WEARABLES
                ///////////////////
                /\b(sm-[lr]\d\d[05][fnuw]?s?)\b/i // Samsung Galaxy Watch
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /((pebble))app/i // Pebble
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i // Apple Watch
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (glass) \d/i // Google Glass
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (wt63?0{2,3})\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                ///////////////////
                // XR
                ///////////////////
                /droid.+; (glass) \d/i // Google Glass
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(pico) (4|neo3(?: link|pro)?)/i // Pico
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /; (quest( \d| pro)?)/i // Oculus Quest
            ],
            [
                MODEL,
                [
                    VENDOR,
                    FACEBOOK
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                ///////////////////
                // EMBEDDED
                ///////////////////
                /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i // Tesla
            ],
            [
                VENDOR,
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /(aeobc)\b/i // Echo Dot
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                ////////////////////
                // MIXED (GENERIC)
                ///////////////////
                /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i // Android Phones from Unidentified Vendors
            ],
            [
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i // Android Tablets from Unidentified Vendors
            ],
            [
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i // Unidentifiable Tablet
            ],
            [
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i // Unidentifiable Mobile
            ],
            [
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(android[-\w\. ]{0,9});.+buil/i // Generic Android Device
            ],
            [
                MODEL,
                [
                    VENDOR,
                    'Generic'
                ]
            ]
        ],
        engine: [
            [
                /windows.+ edge\/([\w\.]+)/i // EdgeHTML
            ],
            [
                VERSION,
                [
                    NAME,
                    EDGE + 'HTML'
                ]
            ],
            [
                /(arkweb)\/([\w\.]+)/i // ArkWeb
            ],
            [
                NAME,
                VERSION
            ],
            [
                /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i // Blink
            ],
            [
                VERSION,
                [
                    NAME,
                    'Blink'
                ]
            ],
            [
                /(presto)\/([\w\.]+)/i,
                /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna|servo)\/([\w\.]+)/i,
                /ekioh(flow)\/([\w\.]+)/i,
                /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
                /(icab)[\/ ]([23]\.[\d\.]+)/i,
                /\b(libweb)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /rv\:([\w\.]{1,9})\b.+(gecko)/i // Gecko
            ],
            [
                VERSION,
                NAME
            ]
        ],
        os: [
            [
                // Windows
                /microsoft (windows) (vista|xp)/i // Windows (iTunes)
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i // Windows Phone
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ]
            ],
            [
                /windows nt 6\.2; (arm)/i,
                /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i,
                /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
            ],
            [
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ],
                [
                    NAME,
                    'Windows'
                ]
            ],
            [
                // iOS/macOS
                /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
                /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
                /cfnetwork\/.+darwin/i
            ],
            [
                [
                    VERSION,
                    /_/g,
                    '.'
                ],
                [
                    NAME,
                    'iOS'
                ]
            ],
            [
                /(mac os x) ?([\w\. ]*)/i,
                /(macintosh|mac_powerpc\b)(?!.+haiku)/i // Mac OS
            ],
            [
                [
                    NAME,
                    MAC_OS
                ],
                [
                    VERSION,
                    /_/g,
                    '.'
                ]
            ],
            [
                // Mobile OSes
                /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i // Android-x86/HarmonyOS
            ],
            [
                VERSION,
                NAME
            ],
            [
                /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish|openharmony)[-\/ ]?([\w\.]*)/i,
                /(blackberry)\w*\/([\w\.]*)/i,
                /(tizen|kaios)[\/ ]([\w\.]+)/i,
                /\((series40);/i // Series 40
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\(bb(10);/i // BlackBerry 10
            ],
            [
                VERSION,
                [
                    NAME,
                    BLACKBERRY
                ]
            ],
            [
                /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i // Symbian
            ],
            [
                VERSION,
                [
                    NAME,
                    'Symbian'
                ]
            ],
            [
                /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i // Firefox OS
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + ' OS'
                ]
            ],
            [
                /web0s;.+rt(tv)/i,
                /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i // WebOS
            ],
            [
                VERSION,
                [
                    NAME,
                    'webOS'
                ]
            ],
            [
                /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i // watchOS
            ],
            [
                VERSION,
                [
                    NAME,
                    'watchOS'
                ]
            ],
            [
                // Google Chromecast
                /crkey\/([\d\.]+)/i // Google Chromecast
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + 'cast'
                ]
            ],
            [
                /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i // Chromium OS
            ],
            [
                [
                    NAME,
                    CHROMIUM_OS
                ],
                VERSION
            ],
            [
                // Smart TVs
                /panasonic;(viera)/i,
                /(netrange)mmh/i,
                /(nettv)\/(\d+\.[\w\.]+)/i,
                // Console
                /(nintendo|playstation) ([wids345portablevuch]+)/i,
                /(xbox); +xbox ([^\);]+)/i,
                // Other
                /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
                /(mint)[\/\(\) ]?(\w*)/i,
                /(mageia|vectorlinux)[; ]/i,
                /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
                /(hurd|linux) ?([\w\.]*)/i,
                /(gnu) ?([\w\.]*)/i,
                /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
                /(haiku) (\w+)/i // Haiku
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(sunos) ?([\w\.\d]*)/i // Solaris
            ],
            [
                [
                    NAME,
                    'Solaris'
                ],
                VERSION
            ],
            [
                /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
                /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
                /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
                /(unix) ?([\w\.]*)/i // UNIX
            ],
            [
                NAME,
                VERSION
            ]
        ]
    };
    /////////////////
    // Constructor
    ////////////////
    var UAParser = function UAParser1(ua, extensions) {
        if (typeof ua === OBJ_TYPE) {
            extensions = ua;
            ua = undefined;
        }
        if (!(this instanceof UAParser)) return new UAParser(ua, extensions).getResult();
        var _navigator = typeof window1 !== UNDEF_TYPE && window1.navigator ? window1.navigator : undefined;
        var _ua = ua || (_navigator && _navigator.userAgent ? _navigator.userAgent : EMPTY);
        var _uach = _navigator && _navigator.userAgentData ? _navigator.userAgentData : undefined;
        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
        var _isSelfNav = _navigator && _navigator.userAgent == _ua;
        this.getBrowser = function() {
            var _browser = {};
            _browser[NAME] = undefined;
            _browser[VERSION] = undefined;
            rgxMapper.call(_browser, _ua, _rgxmap.browser);
            _browser[MAJOR] = majorize(_browser[VERSION]);
            // Brave-specific detection
            if (_isSelfNav && _navigator && _navigator.brave && typeof _navigator.brave.isBrave == FUNC_TYPE) _browser[NAME] = 'Brave';
            return _browser;
        };
        this.getCPU = function() {
            var _cpu = {};
            _cpu[ARCHITECTURE] = undefined;
            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
            return _cpu;
        };
        this.getDevice = function() {
            var _device = {};
            _device[VENDOR] = undefined;
            _device[MODEL] = undefined;
            _device[TYPE] = undefined;
            rgxMapper.call(_device, _ua, _rgxmap.device);
            if (_isSelfNav && !_device[TYPE] && _uach && _uach.mobile) _device[TYPE] = MOBILE;
            // iPadOS-specific detection: identified as Mac, but has some iOS-only properties
            if (_isSelfNav && _device[MODEL] == 'Macintosh' && _navigator && typeof _navigator.standalone !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
                _device[MODEL] = 'iPad';
                _device[TYPE] = TABLET;
            }
            return _device;
        };
        this.getEngine = function() {
            var _engine = {};
            _engine[NAME] = undefined;
            _engine[VERSION] = undefined;
            rgxMapper.call(_engine, _ua, _rgxmap.engine);
            return _engine;
        };
        this.getOS = function() {
            var _os = {};
            _os[NAME] = undefined;
            _os[VERSION] = undefined;
            rgxMapper.call(_os, _ua, _rgxmap.os);
            if (_isSelfNav && !_os[NAME] && _uach && _uach.platform && _uach.platform != 'Unknown') _os[NAME] = _uach.platform.replace(/chrome os/i, CHROMIUM_OS).replace(/macos/i, MAC_OS); // backward compatibility
            return _os;
        };
        this.getResult = function() {
            return {
                ua: this.getUA(),
                browser: this.getBrowser(),
                engine: this.getEngine(),
                os: this.getOS(),
                device: this.getDevice(),
                cpu: this.getCPU()
            };
        };
        this.getUA = function() {
            return _ua;
        };
        this.setUA = function(ua) {
            _ua = typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH ? trim(ua, UA_MAX_LENGTH) : ua;
            return this;
        };
        this.setUA(_ua);
        return this;
    };
    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = enumerize([
        NAME,
        VERSION,
        MAJOR
    ]);
    UAParser.CPU = enumerize([
        ARCHITECTURE
    ]);
    UAParser.DEVICE = enumerize([
        MODEL,
        VENDOR,
        TYPE,
        CONSOLE,
        MOBILE,
        SMARTTV,
        TABLET,
        WEARABLE,
        EMBEDDED
    ]);
    UAParser.ENGINE = UAParser.OS = enumerize([
        NAME,
        VERSION
    ]);
    ///////////
    // Export
    //////////
    // check js environment
    if (typeof exports !== UNDEF_TYPE) {
        // nodejs env
        if ("object" !== UNDEF_TYPE && module.exports) exports = module.exports = UAParser;
        exports.UAParser = UAParser;
    } else {
        // requirejs env (optional)
        if (typeof define === FUNC_TYPE && define.amd) define(function() {
            return UAParser;
        });
        else if (typeof window1 !== UNDEF_TYPE) // browser env
        window1.UAParser = UAParser;
    }
    // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.
    var $ = typeof window1 !== UNDEF_TYPE && (window1.jQuery || window1.Zepto);
    if ($ && !$.ua) {
        var parser = new UAParser();
        $.ua = parser.getResult();
        $.ua.get = function() {
            return parser.getUA();
        };
        $.ua.set = function(ua) {
            parser.setUA(ua);
            var result = parser.getResult();
            for(var prop in result)$.ua[prop] = result[prop];
        };
    }
})(typeof window === 'object' ? window : this);

},{}],"4MKOz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OrderHistoryList", function() {
    return OrderHistoryList;
});
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _fp = require("date-fns/fp");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _ordersHistoryListView = require("../../../../../app/views/ordersHistoryListView");
var _reactRedux = require("react-redux");
var _price = require("../../../../../std/price");
var _statusLabel = require("../../functions/statusLabel");
var _reactRouterDom = require("react-router-dom");
var _layout = require("../Layout");
var _hooks = require("../../../../../std/hooks");
var _loadAccountSaga = require("../../../../../app/sagas/loadAccountSaga");
function OrderHistoryList() {
    var _this = this;
    var view = (0, _reactRedux.useSelector)((0, _ordersHistoryListView.orderHistoryListView));
    var dispatch = (0, _hooks.useDispatch)();
    var isLoading = !view;
    (0, _react.useEffect)(function() {
        dispatch((0, _loadAccountSaga.LoadAccount)());
    }, []);
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _layout.Layout), {
        page: (0, _layout.Page).OrderHistoryList,
        isLoading: isLoading,
        children: view && /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
            className: "history",
            children: [
                /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("h3", {
                    className: "history_title",
                    children: "Historique de commandes"
                }, void 0, false, {
                    fileName: "src/script/src/dom/views/Account/views/OrderHistoryList/OrderHistoryList.tsx",
                    lineNumber: 22,
                    columnNumber: 17
                }, this),
                /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                    className: "history_tableContainer",
                    children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                        className: "history_table",
                        children: view.items.map(function(order) {
                            return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(Order, {
                                view: order
                            }, order.orderId, false, {
                                fileName: "src/script/src/dom/views/Account/views/OrderHistoryList/OrderHistoryList.tsx",
                                lineNumber: 25,
                                columnNumber: 51
                            }, _this);
                        })
                    }, void 0, false, {
                        fileName: "src/script/src/dom/views/Account/views/OrderHistoryList/OrderHistoryList.tsx",
                        lineNumber: 24,
                        columnNumber: 21
                    }, this)
                }, void 0, false, {
                    fileName: "src/script/src/dom/views/Account/views/OrderHistoryList/OrderHistoryList.tsx",
                    lineNumber: 23,
                    columnNumber: 17
                }, this)
            ]
        }, void 0, true, {
            fileName: "src/script/src/dom/views/Account/views/OrderHistoryList/OrderHistoryList.tsx",
            lineNumber: 21,
            columnNumber: 22
        }, this)
    }, void 0, false, {
        fileName: "src/script/src/dom/views/Account/views/OrderHistoryList/OrderHistoryList.tsx",
        lineNumber: 20,
        columnNumber: 9
    }, this);
}
function Order(props) {
    var view = props.view;
    var orderId = view.orderId;
    function renderProduct(product) {
        return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
            children: product
        }, product, false, {
            fileName: "src/script/src/dom/views/Account/views/OrderHistoryList/OrderHistoryList.tsx",
            lineNumber: 40,
            columnNumber: 16
        }, this);
    }
    function renderStatusOrTrackingLinks() {
        if (view.trackingLinks.length === 0) return (0, _statusLabel.statusLabel)(view.status);
        return view.trackingLinks.map(renderTrackingLink);
    }
    function renderTrackingLink(link, index) {
        var title = view.trackingLinks.length > 1 ? `Suivre le colis ${index + 1}` : `Suivre mon colis`;
        return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("a", {
            href: link,
            className: "link",
            target: "_blank",
            children: title
        }, link, false, {
            fileName: "src/script/src/dom/views/Account/views/OrderHistoryList/OrderHistoryList.tsx",
            lineNumber: 52,
            columnNumber: 16
        }, this);
    }
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _jsxDevRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                children: [
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("span", {
                        children: view.number
                    }, void 0, false, {
                        fileName: "src/script/src/dom/views/Account/views/OrderHistoryList/OrderHistoryList.tsx",
                        lineNumber: 58,
                        columnNumber: 17
                    }, this),
                    " ",
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("span", {
                        children: [
                            "le ",
                            (0, _fp.format)('dd/MM/yyyy')(view.date)
                        ]
                    }, void 0, true, {
                        fileName: "src/script/src/dom/views/Account/views/OrderHistoryList/OrderHistoryList.tsx",
                        lineNumber: 58,
                        columnNumber: 44
                    }, this)
                ]
            }, void 0, true, {
                fileName: "src/script/src/dom/views/Account/views/OrderHistoryList/OrderHistoryList.tsx",
                lineNumber: 57,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                children: [
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                        children: "Produits :"
                    }, void 0, false, {
                        fileName: "src/script/src/dom/views/Account/views/OrderHistoryList/OrderHistoryList.tsx",
                        lineNumber: 61,
                        columnNumber: 17
                    }, this),
                    view.products.map(renderProduct)
                ]
            }, void 0, true, {
                fileName: "src/script/src/dom/views/Account/views/OrderHistoryList/OrderHistoryList.tsx",
                lineNumber: 60,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                children: [
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("span", {
                        children: "Montant :"
                    }, void 0, false, {
                        fileName: "src/script/src/dom/views/Account/views/OrderHistoryList/OrderHistoryList.tsx",
                        lineNumber: 65,
                        columnNumber: 17
                    }, this),
                    (0, _price.formatPrice)(view.amount)
                ]
            }, void 0, true, {
                fileName: "src/script/src/dom/views/Account/views/OrderHistoryList/OrderHistoryList.tsx",
                lineNumber: 64,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                children: [
                    renderStatusOrTrackingLinks(),
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _reactRouterDom.Link), {
                        to: `/pages/commandes/${orderId}`,
                        className: "link",
                        children: "D\xe9tails"
                    }, void 0, false, {
                        fileName: "src/script/src/dom/views/Account/views/OrderHistoryList/OrderHistoryList.tsx",
                        lineNumber: 69,
                        columnNumber: 17
                    }, this)
                ]
            }, void 0, true, {
                fileName: "src/script/src/dom/views/Account/views/OrderHistoryList/OrderHistoryList.tsx",
                lineNumber: 67,
                columnNumber: 13
            }, this)
        ]
    }, void 0, true);
}

},{"react/jsx-dev-runtime":"jXZ8I","date-fns/fp":"lVPZP","react":"c8CN1","../../../../../app/views/ordersHistoryListView":"gzdgZ","react-redux":"ghMZu","../../../../../std/price":"bpfMV","../../functions/statusLabel":"dlTaP","react-router-dom":"9VDGr","../Layout":"gnkXt","../../../../../std/hooks":"j9RPQ","../../../../../app/sagas/loadAccountSaga":"fo1BR","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"lVPZP":[function(require,module,exports,__globalThis) {
// This file is generated automatically by `scripts/build/indices.ts`. Please, don't change it.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "add", function() {
    return 0, _indexJsDefault.default;
});
parcelHelpers.export(exports, "addBusinessDays", function() {
    return 0, _indexJsDefault1.default;
});
parcelHelpers.export(exports, "addDays", function() {
    return 0, _indexJsDefault2.default;
});
parcelHelpers.export(exports, "addHours", function() {
    return 0, _indexJsDefault3.default;
});
parcelHelpers.export(exports, "addISOWeekYears", function() {
    return 0, _indexJsDefault4.default;
});
parcelHelpers.export(exports, "addMilliseconds", function() {
    return 0, _indexJsDefault5.default;
});
parcelHelpers.export(exports, "addMinutes", function() {
    return 0, _indexJsDefault6.default;
});
parcelHelpers.export(exports, "addMonths", function() {
    return 0, _indexJsDefault7.default;
});
parcelHelpers.export(exports, "addQuarters", function() {
    return 0, _indexJsDefault8.default;
});
parcelHelpers.export(exports, "addSeconds", function() {
    return 0, _indexJsDefault9.default;
});
parcelHelpers.export(exports, "addWeeks", function() {
    return 0, _indexJsDefault10.default;
});
parcelHelpers.export(exports, "addYears", function() {
    return 0, _indexJsDefault11.default;
});
parcelHelpers.export(exports, "areIntervalsOverlapping", function() {
    return 0, _indexJsDefault12.default;
});
parcelHelpers.export(exports, "areIntervalsOverlappingWithOptions", function() {
    return 0, _indexJsDefault13.default;
});
parcelHelpers.export(exports, "clamp", function() {
    return 0, _indexJsDefault14.default;
});
parcelHelpers.export(exports, "closestIndexTo", function() {
    return 0, _indexJsDefault15.default;
});
parcelHelpers.export(exports, "closestTo", function() {
    return 0, _indexJsDefault16.default;
});
parcelHelpers.export(exports, "compareAsc", function() {
    return 0, _indexJsDefault17.default;
});
parcelHelpers.export(exports, "compareDesc", function() {
    return 0, _indexJsDefault18.default;
});
parcelHelpers.export(exports, "daysToWeeks", function() {
    return 0, _indexJsDefault19.default;
});
parcelHelpers.export(exports, "differenceInBusinessDays", function() {
    return 0, _indexJsDefault20.default;
});
parcelHelpers.export(exports, "differenceInCalendarDays", function() {
    return 0, _indexJsDefault21.default;
});
parcelHelpers.export(exports, "differenceInCalendarISOWeekYears", function() {
    return 0, _indexJsDefault22.default;
});
parcelHelpers.export(exports, "differenceInCalendarISOWeeks", function() {
    return 0, _indexJsDefault23.default;
});
parcelHelpers.export(exports, "differenceInCalendarMonths", function() {
    return 0, _indexJsDefault24.default;
});
parcelHelpers.export(exports, "differenceInCalendarQuarters", function() {
    return 0, _indexJsDefault25.default;
});
parcelHelpers.export(exports, "differenceInCalendarWeeks", function() {
    return 0, _indexJsDefault26.default;
});
parcelHelpers.export(exports, "differenceInCalendarWeeksWithOptions", function() {
    return 0, _indexJsDefault27.default;
});
parcelHelpers.export(exports, "differenceInCalendarYears", function() {
    return 0, _indexJsDefault28.default;
});
parcelHelpers.export(exports, "differenceInDays", function() {
    return 0, _indexJsDefault29.default;
});
parcelHelpers.export(exports, "differenceInHours", function() {
    return 0, _indexJsDefault30.default;
});
parcelHelpers.export(exports, "differenceInHoursWithOptions", function() {
    return 0, _indexJsDefault31.default;
});
parcelHelpers.export(exports, "differenceInISOWeekYears", function() {
    return 0, _indexJsDefault32.default;
});
parcelHelpers.export(exports, "differenceInMilliseconds", function() {
    return 0, _indexJsDefault33.default;
});
parcelHelpers.export(exports, "differenceInMinutes", function() {
    return 0, _indexJsDefault34.default;
});
parcelHelpers.export(exports, "differenceInMinutesWithOptions", function() {
    return 0, _indexJsDefault35.default;
});
parcelHelpers.export(exports, "differenceInMonths", function() {
    return 0, _indexJsDefault36.default;
});
parcelHelpers.export(exports, "differenceInQuarters", function() {
    return 0, _indexJsDefault37.default;
});
parcelHelpers.export(exports, "differenceInQuartersWithOptions", function() {
    return 0, _indexJsDefault38.default;
});
parcelHelpers.export(exports, "differenceInSeconds", function() {
    return 0, _indexJsDefault39.default;
});
parcelHelpers.export(exports, "differenceInSecondsWithOptions", function() {
    return 0, _indexJsDefault40.default;
});
parcelHelpers.export(exports, "differenceInWeeks", function() {
    return 0, _indexJsDefault41.default;
});
parcelHelpers.export(exports, "differenceInWeeksWithOptions", function() {
    return 0, _indexJsDefault42.default;
});
parcelHelpers.export(exports, "differenceInYears", function() {
    return 0, _indexJsDefault43.default;
});
parcelHelpers.export(exports, "eachDayOfInterval", function() {
    return 0, _indexJsDefault44.default;
});
parcelHelpers.export(exports, "eachDayOfIntervalWithOptions", function() {
    return 0, _indexJsDefault45.default;
});
parcelHelpers.export(exports, "eachHourOfInterval", function() {
    return 0, _indexJsDefault46.default;
});
parcelHelpers.export(exports, "eachHourOfIntervalWithOptions", function() {
    return 0, _indexJsDefault47.default;
});
parcelHelpers.export(exports, "eachMinuteOfInterval", function() {
    return 0, _indexJsDefault48.default;
});
parcelHelpers.export(exports, "eachMinuteOfIntervalWithOptions", function() {
    return 0, _indexJsDefault49.default;
});
parcelHelpers.export(exports, "eachMonthOfInterval", function() {
    return 0, _indexJsDefault50.default;
});
parcelHelpers.export(exports, "eachQuarterOfInterval", function() {
    return 0, _indexJsDefault51.default;
});
parcelHelpers.export(exports, "eachWeekOfInterval", function() {
    return 0, _indexJsDefault52.default;
});
parcelHelpers.export(exports, "eachWeekOfIntervalWithOptions", function() {
    return 0, _indexJsDefault53.default;
});
parcelHelpers.export(exports, "eachWeekendOfInterval", function() {
    return 0, _indexJsDefault54.default;
});
parcelHelpers.export(exports, "eachWeekendOfMonth", function() {
    return 0, _indexJsDefault55.default;
});
parcelHelpers.export(exports, "eachWeekendOfYear", function() {
    return 0, _indexJsDefault56.default;
});
parcelHelpers.export(exports, "eachYearOfInterval", function() {
    return 0, _indexJsDefault57.default;
});
parcelHelpers.export(exports, "endOfDay", function() {
    return 0, _indexJsDefault58.default;
});
parcelHelpers.export(exports, "endOfDecade", function() {
    return 0, _indexJsDefault59.default;
});
parcelHelpers.export(exports, "endOfDecadeWithOptions", function() {
    return 0, _indexJsDefault60.default;
});
parcelHelpers.export(exports, "endOfHour", function() {
    return 0, _indexJsDefault61.default;
});
parcelHelpers.export(exports, "endOfISOWeek", function() {
    return 0, _indexJsDefault62.default;
});
parcelHelpers.export(exports, "endOfISOWeekYear", function() {
    return 0, _indexJsDefault63.default;
});
parcelHelpers.export(exports, "endOfMinute", function() {
    return 0, _indexJsDefault64.default;
});
parcelHelpers.export(exports, "endOfMonth", function() {
    return 0, _indexJsDefault65.default;
});
parcelHelpers.export(exports, "endOfQuarter", function() {
    return 0, _indexJsDefault66.default;
});
parcelHelpers.export(exports, "endOfSecond", function() {
    return 0, _indexJsDefault67.default;
});
parcelHelpers.export(exports, "endOfWeek", function() {
    return 0, _indexJsDefault68.default;
});
parcelHelpers.export(exports, "endOfWeekWithOptions", function() {
    return 0, _indexJsDefault69.default;
});
parcelHelpers.export(exports, "endOfYear", function() {
    return 0, _indexJsDefault70.default;
});
parcelHelpers.export(exports, "format", function() {
    return 0, _indexJsDefault71.default;
});
parcelHelpers.export(exports, "formatDistance", function() {
    return 0, _indexJsDefault72.default;
});
parcelHelpers.export(exports, "formatDistanceStrict", function() {
    return 0, _indexJsDefault73.default;
});
parcelHelpers.export(exports, "formatDistanceStrictWithOptions", function() {
    return 0, _indexJsDefault74.default;
});
parcelHelpers.export(exports, "formatDistanceWithOptions", function() {
    return 0, _indexJsDefault75.default;
});
parcelHelpers.export(exports, "formatDuration", function() {
    return 0, _indexJsDefault76.default;
});
parcelHelpers.export(exports, "formatDurationWithOptions", function() {
    return 0, _indexJsDefault77.default;
});
parcelHelpers.export(exports, "formatISO", function() {
    return 0, _indexJsDefault78.default;
});
parcelHelpers.export(exports, "formatISO9075", function() {
    return 0, _indexJsDefault79.default;
});
parcelHelpers.export(exports, "formatISO9075WithOptions", function() {
    return 0, _indexJsDefault80.default;
});
parcelHelpers.export(exports, "formatISODuration", function() {
    return 0, _indexJsDefault81.default;
});
parcelHelpers.export(exports, "formatISOWithOptions", function() {
    return 0, _indexJsDefault82.default;
});
parcelHelpers.export(exports, "formatRFC3339", function() {
    return 0, _indexJsDefault83.default;
});
parcelHelpers.export(exports, "formatRFC3339WithOptions", function() {
    return 0, _indexJsDefault84.default;
});
parcelHelpers.export(exports, "formatRFC7231", function() {
    return 0, _indexJsDefault85.default;
});
parcelHelpers.export(exports, "formatRelative", function() {
    return 0, _indexJsDefault86.default;
});
parcelHelpers.export(exports, "formatRelativeWithOptions", function() {
    return 0, _indexJsDefault87.default;
});
parcelHelpers.export(exports, "formatWithOptions", function() {
    return 0, _indexJsDefault88.default;
});
parcelHelpers.export(exports, "fromUnixTime", function() {
    return 0, _indexJsDefault89.default;
});
parcelHelpers.export(exports, "getDate", function() {
    return 0, _indexJsDefault90.default;
});
parcelHelpers.export(exports, "getDay", function() {
    return 0, _indexJsDefault91.default;
});
parcelHelpers.export(exports, "getDayOfYear", function() {
    return 0, _indexJsDefault92.default;
});
parcelHelpers.export(exports, "getDaysInMonth", function() {
    return 0, _indexJsDefault93.default;
});
parcelHelpers.export(exports, "getDaysInYear", function() {
    return 0, _indexJsDefault94.default;
});
parcelHelpers.export(exports, "getDecade", function() {
    return 0, _indexJsDefault95.default;
});
parcelHelpers.export(exports, "getHours", function() {
    return 0, _indexJsDefault96.default;
});
parcelHelpers.export(exports, "getISODay", function() {
    return 0, _indexJsDefault97.default;
});
parcelHelpers.export(exports, "getISOWeek", function() {
    return 0, _indexJsDefault98.default;
});
parcelHelpers.export(exports, "getISOWeekYear", function() {
    return 0, _indexJsDefault99.default;
});
parcelHelpers.export(exports, "getISOWeeksInYear", function() {
    return 0, _indexJsDefault100.default;
});
parcelHelpers.export(exports, "getMilliseconds", function() {
    return 0, _indexJsDefault101.default;
});
parcelHelpers.export(exports, "getMinutes", function() {
    return 0, _indexJsDefault102.default;
});
parcelHelpers.export(exports, "getMonth", function() {
    return 0, _indexJsDefault103.default;
});
parcelHelpers.export(exports, "getOverlappingDaysInIntervals", function() {
    return 0, _indexJsDefault104.default;
});
parcelHelpers.export(exports, "getQuarter", function() {
    return 0, _indexJsDefault105.default;
});
parcelHelpers.export(exports, "getSeconds", function() {
    return 0, _indexJsDefault106.default;
});
parcelHelpers.export(exports, "getTime", function() {
    return 0, _indexJsDefault107.default;
});
parcelHelpers.export(exports, "getUnixTime", function() {
    return 0, _indexJsDefault108.default;
});
parcelHelpers.export(exports, "getWeek", function() {
    return 0, _indexJsDefault109.default;
});
parcelHelpers.export(exports, "getWeekOfMonth", function() {
    return 0, _indexJsDefault110.default;
});
parcelHelpers.export(exports, "getWeekOfMonthWithOptions", function() {
    return 0, _indexJsDefault111.default;
});
parcelHelpers.export(exports, "getWeekWithOptions", function() {
    return 0, _indexJsDefault112.default;
});
parcelHelpers.export(exports, "getWeekYear", function() {
    return 0, _indexJsDefault113.default;
});
parcelHelpers.export(exports, "getWeekYearWithOptions", function() {
    return 0, _indexJsDefault114.default;
});
parcelHelpers.export(exports, "getWeeksInMonth", function() {
    return 0, _indexJsDefault115.default;
});
parcelHelpers.export(exports, "getWeeksInMonthWithOptions", function() {
    return 0, _indexJsDefault116.default;
});
parcelHelpers.export(exports, "getYear", function() {
    return 0, _indexJsDefault117.default;
});
parcelHelpers.export(exports, "hoursToMilliseconds", function() {
    return 0, _indexJsDefault118.default;
});
parcelHelpers.export(exports, "hoursToMinutes", function() {
    return 0, _indexJsDefault119.default;
});
parcelHelpers.export(exports, "hoursToSeconds", function() {
    return 0, _indexJsDefault120.default;
});
parcelHelpers.export(exports, "intervalToDuration", function() {
    return 0, _indexJsDefault121.default;
});
parcelHelpers.export(exports, "intlFormat", function() {
    return 0, _indexJsDefault122.default;
});
parcelHelpers.export(exports, "intlFormatDistance", function() {
    return 0, _indexJsDefault123.default;
});
parcelHelpers.export(exports, "intlFormatDistanceWithOptions", function() {
    return 0, _indexJsDefault124.default;
});
parcelHelpers.export(exports, "isAfter", function() {
    return 0, _indexJsDefault125.default;
});
parcelHelpers.export(exports, "isBefore", function() {
    return 0, _indexJsDefault126.default;
});
parcelHelpers.export(exports, "isDate", function() {
    return 0, _indexJsDefault127.default;
});
parcelHelpers.export(exports, "isEqual", function() {
    return 0, _indexJsDefault128.default;
});
parcelHelpers.export(exports, "isExists", function() {
    return 0, _indexJsDefault129.default;
});
parcelHelpers.export(exports, "isFirstDayOfMonth", function() {
    return 0, _indexJsDefault130.default;
});
parcelHelpers.export(exports, "isFriday", function() {
    return 0, _indexJsDefault131.default;
});
parcelHelpers.export(exports, "isLastDayOfMonth", function() {
    return 0, _indexJsDefault132.default;
});
parcelHelpers.export(exports, "isLeapYear", function() {
    return 0, _indexJsDefault133.default;
});
parcelHelpers.export(exports, "isMatch", function() {
    return 0, _indexJsDefault134.default;
});
parcelHelpers.export(exports, "isMatchWithOptions", function() {
    return 0, _indexJsDefault135.default;
});
parcelHelpers.export(exports, "isMonday", function() {
    return 0, _indexJsDefault136.default;
});
parcelHelpers.export(exports, "isSameDay", function() {
    return 0, _indexJsDefault137.default;
});
parcelHelpers.export(exports, "isSameHour", function() {
    return 0, _indexJsDefault138.default;
});
parcelHelpers.export(exports, "isSameISOWeek", function() {
    return 0, _indexJsDefault139.default;
});
parcelHelpers.export(exports, "isSameISOWeekYear", function() {
    return 0, _indexJsDefault140.default;
});
parcelHelpers.export(exports, "isSameMinute", function() {
    return 0, _indexJsDefault141.default;
});
parcelHelpers.export(exports, "isSameMonth", function() {
    return 0, _indexJsDefault142.default;
});
parcelHelpers.export(exports, "isSameQuarter", function() {
    return 0, _indexJsDefault143.default;
});
parcelHelpers.export(exports, "isSameSecond", function() {
    return 0, _indexJsDefault144.default;
});
parcelHelpers.export(exports, "isSameWeek", function() {
    return 0, _indexJsDefault145.default;
});
parcelHelpers.export(exports, "isSameWeekWithOptions", function() {
    return 0, _indexJsDefault146.default;
});
parcelHelpers.export(exports, "isSameYear", function() {
    return 0, _indexJsDefault147.default;
});
parcelHelpers.export(exports, "isSaturday", function() {
    return 0, _indexJsDefault148.default;
});
parcelHelpers.export(exports, "isSunday", function() {
    return 0, _indexJsDefault149.default;
});
parcelHelpers.export(exports, "isThursday", function() {
    return 0, _indexJsDefault150.default;
});
parcelHelpers.export(exports, "isTuesday", function() {
    return 0, _indexJsDefault151.default;
});
parcelHelpers.export(exports, "isValid", function() {
    return 0, _indexJsDefault152.default;
});
parcelHelpers.export(exports, "isWednesday", function() {
    return 0, _indexJsDefault153.default;
});
parcelHelpers.export(exports, "isWeekend", function() {
    return 0, _indexJsDefault154.default;
});
parcelHelpers.export(exports, "isWithinInterval", function() {
    return 0, _indexJsDefault155.default;
});
parcelHelpers.export(exports, "lastDayOfDecade", function() {
    return 0, _indexJsDefault156.default;
});
parcelHelpers.export(exports, "lastDayOfISOWeek", function() {
    return 0, _indexJsDefault157.default;
});
parcelHelpers.export(exports, "lastDayOfISOWeekYear", function() {
    return 0, _indexJsDefault158.default;
});
parcelHelpers.export(exports, "lastDayOfMonth", function() {
    return 0, _indexJsDefault159.default;
});
parcelHelpers.export(exports, "lastDayOfQuarter", function() {
    return 0, _indexJsDefault160.default;
});
parcelHelpers.export(exports, "lastDayOfQuarterWithOptions", function() {
    return 0, _indexJsDefault161.default;
});
parcelHelpers.export(exports, "lastDayOfWeek", function() {
    return 0, _indexJsDefault162.default;
});
parcelHelpers.export(exports, "lastDayOfWeekWithOptions", function() {
    return 0, _indexJsDefault163.default;
});
parcelHelpers.export(exports, "lastDayOfYear", function() {
    return 0, _indexJsDefault164.default;
});
parcelHelpers.export(exports, "lightFormat", function() {
    return 0, _indexJsDefault165.default;
});
parcelHelpers.export(exports, "max", function() {
    return 0, _indexJsDefault166.default;
});
parcelHelpers.export(exports, "milliseconds", function() {
    return 0, _indexJsDefault167.default;
});
parcelHelpers.export(exports, "millisecondsToHours", function() {
    return 0, _indexJsDefault168.default;
});
parcelHelpers.export(exports, "millisecondsToMinutes", function() {
    return 0, _indexJsDefault169.default;
});
parcelHelpers.export(exports, "millisecondsToSeconds", function() {
    return 0, _indexJsDefault170.default;
});
parcelHelpers.export(exports, "min", function() {
    return 0, _indexJsDefault171.default;
});
parcelHelpers.export(exports, "minutesToHours", function() {
    return 0, _indexJsDefault172.default;
});
parcelHelpers.export(exports, "minutesToMilliseconds", function() {
    return 0, _indexJsDefault173.default;
});
parcelHelpers.export(exports, "minutesToSeconds", function() {
    return 0, _indexJsDefault174.default;
});
parcelHelpers.export(exports, "monthsToQuarters", function() {
    return 0, _indexJsDefault175.default;
});
parcelHelpers.export(exports, "monthsToYears", function() {
    return 0, _indexJsDefault176.default;
});
parcelHelpers.export(exports, "nextDay", function() {
    return 0, _indexJsDefault177.default;
});
parcelHelpers.export(exports, "nextFriday", function() {
    return 0, _indexJsDefault178.default;
});
parcelHelpers.export(exports, "nextMonday", function() {
    return 0, _indexJsDefault179.default;
});
parcelHelpers.export(exports, "nextSaturday", function() {
    return 0, _indexJsDefault180.default;
});
parcelHelpers.export(exports, "nextSunday", function() {
    return 0, _indexJsDefault181.default;
});
parcelHelpers.export(exports, "nextThursday", function() {
    return 0, _indexJsDefault182.default;
});
parcelHelpers.export(exports, "nextTuesday", function() {
    return 0, _indexJsDefault183.default;
});
parcelHelpers.export(exports, "nextWednesday", function() {
    return 0, _indexJsDefault184.default;
});
parcelHelpers.export(exports, "parse", function() {
    return 0, _indexJsDefault185.default;
});
parcelHelpers.export(exports, "parseISO", function() {
    return 0, _indexJsDefault186.default;
});
parcelHelpers.export(exports, "parseISOWithOptions", function() {
    return 0, _indexJsDefault187.default;
});
parcelHelpers.export(exports, "parseJSON", function() {
    return 0, _indexJsDefault188.default;
});
parcelHelpers.export(exports, "parseWithOptions", function() {
    return 0, _indexJsDefault189.default;
});
parcelHelpers.export(exports, "previousDay", function() {
    return 0, _indexJsDefault190.default;
});
parcelHelpers.export(exports, "previousFriday", function() {
    return 0, _indexJsDefault191.default;
});
parcelHelpers.export(exports, "previousMonday", function() {
    return 0, _indexJsDefault192.default;
});
parcelHelpers.export(exports, "previousSaturday", function() {
    return 0, _indexJsDefault193.default;
});
parcelHelpers.export(exports, "previousSunday", function() {
    return 0, _indexJsDefault194.default;
});
parcelHelpers.export(exports, "previousThursday", function() {
    return 0, _indexJsDefault195.default;
});
parcelHelpers.export(exports, "previousTuesday", function() {
    return 0, _indexJsDefault196.default;
});
parcelHelpers.export(exports, "previousWednesday", function() {
    return 0, _indexJsDefault197.default;
});
parcelHelpers.export(exports, "quartersToMonths", function() {
    return 0, _indexJsDefault198.default;
});
parcelHelpers.export(exports, "quartersToYears", function() {
    return 0, _indexJsDefault199.default;
});
parcelHelpers.export(exports, "roundToNearestMinutes", function() {
    return 0, _indexJsDefault200.default;
});
parcelHelpers.export(exports, "roundToNearestMinutesWithOptions", function() {
    return 0, _indexJsDefault201.default;
});
parcelHelpers.export(exports, "secondsToHours", function() {
    return 0, _indexJsDefault202.default;
});
parcelHelpers.export(exports, "secondsToMilliseconds", function() {
    return 0, _indexJsDefault203.default;
});
parcelHelpers.export(exports, "secondsToMinutes", function() {
    return 0, _indexJsDefault204.default;
});
parcelHelpers.export(exports, "set", function() {
    return 0, _indexJsDefault205.default;
});
parcelHelpers.export(exports, "setDate", function() {
    return 0, _indexJsDefault206.default;
});
parcelHelpers.export(exports, "setDay", function() {
    return 0, _indexJsDefault207.default;
});
parcelHelpers.export(exports, "setDayOfYear", function() {
    return 0, _indexJsDefault208.default;
});
parcelHelpers.export(exports, "setDayWithOptions", function() {
    return 0, _indexJsDefault209.default;
});
parcelHelpers.export(exports, "setHours", function() {
    return 0, _indexJsDefault210.default;
});
parcelHelpers.export(exports, "setISODay", function() {
    return 0, _indexJsDefault211.default;
});
parcelHelpers.export(exports, "setISOWeek", function() {
    return 0, _indexJsDefault212.default;
});
parcelHelpers.export(exports, "setISOWeekYear", function() {
    return 0, _indexJsDefault213.default;
});
parcelHelpers.export(exports, "setMilliseconds", function() {
    return 0, _indexJsDefault214.default;
});
parcelHelpers.export(exports, "setMinutes", function() {
    return 0, _indexJsDefault215.default;
});
parcelHelpers.export(exports, "setMonth", function() {
    return 0, _indexJsDefault216.default;
});
parcelHelpers.export(exports, "setQuarter", function() {
    return 0, _indexJsDefault217.default;
});
parcelHelpers.export(exports, "setSeconds", function() {
    return 0, _indexJsDefault218.default;
});
parcelHelpers.export(exports, "setWeek", function() {
    return 0, _indexJsDefault219.default;
});
parcelHelpers.export(exports, "setWeekWithOptions", function() {
    return 0, _indexJsDefault220.default;
});
parcelHelpers.export(exports, "setWeekYear", function() {
    return 0, _indexJsDefault221.default;
});
parcelHelpers.export(exports, "setWeekYearWithOptions", function() {
    return 0, _indexJsDefault222.default;
});
parcelHelpers.export(exports, "setYear", function() {
    return 0, _indexJsDefault223.default;
});
parcelHelpers.export(exports, "startOfDay", function() {
    return 0, _indexJsDefault224.default;
});
parcelHelpers.export(exports, "startOfDecade", function() {
    return 0, _indexJsDefault225.default;
});
parcelHelpers.export(exports, "startOfHour", function() {
    return 0, _indexJsDefault226.default;
});
parcelHelpers.export(exports, "startOfISOWeek", function() {
    return 0, _indexJsDefault227.default;
});
parcelHelpers.export(exports, "startOfISOWeekYear", function() {
    return 0, _indexJsDefault228.default;
});
parcelHelpers.export(exports, "startOfMinute", function() {
    return 0, _indexJsDefault229.default;
});
parcelHelpers.export(exports, "startOfMonth", function() {
    return 0, _indexJsDefault230.default;
});
parcelHelpers.export(exports, "startOfQuarter", function() {
    return 0, _indexJsDefault231.default;
});
parcelHelpers.export(exports, "startOfSecond", function() {
    return 0, _indexJsDefault232.default;
});
parcelHelpers.export(exports, "startOfWeek", function() {
    return 0, _indexJsDefault233.default;
});
parcelHelpers.export(exports, "startOfWeekWithOptions", function() {
    return 0, _indexJsDefault234.default;
});
parcelHelpers.export(exports, "startOfWeekYear", function() {
    return 0, _indexJsDefault235.default;
});
parcelHelpers.export(exports, "startOfWeekYearWithOptions", function() {
    return 0, _indexJsDefault236.default;
});
parcelHelpers.export(exports, "startOfYear", function() {
    return 0, _indexJsDefault237.default;
});
parcelHelpers.export(exports, "sub", function() {
    return 0, _indexJsDefault238.default;
});
parcelHelpers.export(exports, "subBusinessDays", function() {
    return 0, _indexJsDefault239.default;
});
parcelHelpers.export(exports, "subDays", function() {
    return 0, _indexJsDefault240.default;
});
parcelHelpers.export(exports, "subHours", function() {
    return 0, _indexJsDefault241.default;
});
parcelHelpers.export(exports, "subISOWeekYears", function() {
    return 0, _indexJsDefault242.default;
});
parcelHelpers.export(exports, "subMilliseconds", function() {
    return 0, _indexJsDefault243.default;
});
parcelHelpers.export(exports, "subMinutes", function() {
    return 0, _indexJsDefault244.default;
});
parcelHelpers.export(exports, "subMonths", function() {
    return 0, _indexJsDefault245.default;
});
parcelHelpers.export(exports, "subQuarters", function() {
    return 0, _indexJsDefault246.default;
});
parcelHelpers.export(exports, "subSeconds", function() {
    return 0, _indexJsDefault247.default;
});
parcelHelpers.export(exports, "subWeeks", function() {
    return 0, _indexJsDefault248.default;
});
parcelHelpers.export(exports, "subYears", function() {
    return 0, _indexJsDefault249.default;
});
parcelHelpers.export(exports, "toDate", function() {
    return 0, _indexJsDefault250.default;
});
parcelHelpers.export(exports, "weeksToDays", function() {
    return 0, _indexJsDefault251.default;
});
parcelHelpers.export(exports, "yearsToMonths", function() {
    return 0, _indexJsDefault252.default;
});
parcelHelpers.export(exports, "yearsToQuarters", function() {
    return 0, _indexJsDefault253.default;
});
var _indexJs = require("./add/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./addBusinessDays/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./addDays/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./addHours/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./addISOWeekYears/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
var _indexJs5 = require("./addMilliseconds/index.js");
var _indexJsDefault5 = parcelHelpers.interopDefault(_indexJs5);
var _indexJs6 = require("./addMinutes/index.js");
var _indexJsDefault6 = parcelHelpers.interopDefault(_indexJs6);
var _indexJs7 = require("./addMonths/index.js");
var _indexJsDefault7 = parcelHelpers.interopDefault(_indexJs7);
var _indexJs8 = require("./addQuarters/index.js");
var _indexJsDefault8 = parcelHelpers.interopDefault(_indexJs8);
var _indexJs9 = require("./addSeconds/index.js");
var _indexJsDefault9 = parcelHelpers.interopDefault(_indexJs9);
var _indexJs10 = require("./addWeeks/index.js");
var _indexJsDefault10 = parcelHelpers.interopDefault(_indexJs10);
var _indexJs11 = require("./addYears/index.js");
var _indexJsDefault11 = parcelHelpers.interopDefault(_indexJs11);
var _indexJs12 = require("./areIntervalsOverlapping/index.js");
var _indexJsDefault12 = parcelHelpers.interopDefault(_indexJs12);
var _indexJs13 = require("./areIntervalsOverlappingWithOptions/index.js");
var _indexJsDefault13 = parcelHelpers.interopDefault(_indexJs13);
var _indexJs14 = require("./clamp/index.js");
var _indexJsDefault14 = parcelHelpers.interopDefault(_indexJs14);
var _indexJs15 = require("./closestIndexTo/index.js");
var _indexJsDefault15 = parcelHelpers.interopDefault(_indexJs15);
var _indexJs16 = require("./closestTo/index.js");
var _indexJsDefault16 = parcelHelpers.interopDefault(_indexJs16);
var _indexJs17 = require("./compareAsc/index.js");
var _indexJsDefault17 = parcelHelpers.interopDefault(_indexJs17);
var _indexJs18 = require("./compareDesc/index.js");
var _indexJsDefault18 = parcelHelpers.interopDefault(_indexJs18);
var _indexJs19 = require("./daysToWeeks/index.js");
var _indexJsDefault19 = parcelHelpers.interopDefault(_indexJs19);
var _indexJs20 = require("./differenceInBusinessDays/index.js");
var _indexJsDefault20 = parcelHelpers.interopDefault(_indexJs20);
var _indexJs21 = require("./differenceInCalendarDays/index.js");
var _indexJsDefault21 = parcelHelpers.interopDefault(_indexJs21);
var _indexJs22 = require("./differenceInCalendarISOWeekYears/index.js");
var _indexJsDefault22 = parcelHelpers.interopDefault(_indexJs22);
var _indexJs23 = require("./differenceInCalendarISOWeeks/index.js");
var _indexJsDefault23 = parcelHelpers.interopDefault(_indexJs23);
var _indexJs24 = require("./differenceInCalendarMonths/index.js");
var _indexJsDefault24 = parcelHelpers.interopDefault(_indexJs24);
var _indexJs25 = require("./differenceInCalendarQuarters/index.js");
var _indexJsDefault25 = parcelHelpers.interopDefault(_indexJs25);
var _indexJs26 = require("./differenceInCalendarWeeks/index.js");
var _indexJsDefault26 = parcelHelpers.interopDefault(_indexJs26);
var _indexJs27 = require("./differenceInCalendarWeeksWithOptions/index.js");
var _indexJsDefault27 = parcelHelpers.interopDefault(_indexJs27);
var _indexJs28 = require("./differenceInCalendarYears/index.js");
var _indexJsDefault28 = parcelHelpers.interopDefault(_indexJs28);
var _indexJs29 = require("./differenceInDays/index.js");
var _indexJsDefault29 = parcelHelpers.interopDefault(_indexJs29);
var _indexJs30 = require("./differenceInHours/index.js");
var _indexJsDefault30 = parcelHelpers.interopDefault(_indexJs30);
var _indexJs31 = require("./differenceInHoursWithOptions/index.js");
var _indexJsDefault31 = parcelHelpers.interopDefault(_indexJs31);
var _indexJs32 = require("./differenceInISOWeekYears/index.js");
var _indexJsDefault32 = parcelHelpers.interopDefault(_indexJs32);
var _indexJs33 = require("./differenceInMilliseconds/index.js");
var _indexJsDefault33 = parcelHelpers.interopDefault(_indexJs33);
var _indexJs34 = require("./differenceInMinutes/index.js");
var _indexJsDefault34 = parcelHelpers.interopDefault(_indexJs34);
var _indexJs35 = require("./differenceInMinutesWithOptions/index.js");
var _indexJsDefault35 = parcelHelpers.interopDefault(_indexJs35);
var _indexJs36 = require("./differenceInMonths/index.js");
var _indexJsDefault36 = parcelHelpers.interopDefault(_indexJs36);
var _indexJs37 = require("./differenceInQuarters/index.js");
var _indexJsDefault37 = parcelHelpers.interopDefault(_indexJs37);
var _indexJs38 = require("./differenceInQuartersWithOptions/index.js");
var _indexJsDefault38 = parcelHelpers.interopDefault(_indexJs38);
var _indexJs39 = require("./differenceInSeconds/index.js");
var _indexJsDefault39 = parcelHelpers.interopDefault(_indexJs39);
var _indexJs40 = require("./differenceInSecondsWithOptions/index.js");
var _indexJsDefault40 = parcelHelpers.interopDefault(_indexJs40);
var _indexJs41 = require("./differenceInWeeks/index.js");
var _indexJsDefault41 = parcelHelpers.interopDefault(_indexJs41);
var _indexJs42 = require("./differenceInWeeksWithOptions/index.js");
var _indexJsDefault42 = parcelHelpers.interopDefault(_indexJs42);
var _indexJs43 = require("./differenceInYears/index.js");
var _indexJsDefault43 = parcelHelpers.interopDefault(_indexJs43);
var _indexJs44 = require("./eachDayOfInterval/index.js");
var _indexJsDefault44 = parcelHelpers.interopDefault(_indexJs44);
var _indexJs45 = require("./eachDayOfIntervalWithOptions/index.js");
var _indexJsDefault45 = parcelHelpers.interopDefault(_indexJs45);
var _indexJs46 = require("./eachHourOfInterval/index.js");
var _indexJsDefault46 = parcelHelpers.interopDefault(_indexJs46);
var _indexJs47 = require("./eachHourOfIntervalWithOptions/index.js");
var _indexJsDefault47 = parcelHelpers.interopDefault(_indexJs47);
var _indexJs48 = require("./eachMinuteOfInterval/index.js");
var _indexJsDefault48 = parcelHelpers.interopDefault(_indexJs48);
var _indexJs49 = require("./eachMinuteOfIntervalWithOptions/index.js");
var _indexJsDefault49 = parcelHelpers.interopDefault(_indexJs49);
var _indexJs50 = require("./eachMonthOfInterval/index.js");
var _indexJsDefault50 = parcelHelpers.interopDefault(_indexJs50);
var _indexJs51 = require("./eachQuarterOfInterval/index.js");
var _indexJsDefault51 = parcelHelpers.interopDefault(_indexJs51);
var _indexJs52 = require("./eachWeekOfInterval/index.js");
var _indexJsDefault52 = parcelHelpers.interopDefault(_indexJs52);
var _indexJs53 = require("./eachWeekOfIntervalWithOptions/index.js");
var _indexJsDefault53 = parcelHelpers.interopDefault(_indexJs53);
var _indexJs54 = require("./eachWeekendOfInterval/index.js");
var _indexJsDefault54 = parcelHelpers.interopDefault(_indexJs54);
var _indexJs55 = require("./eachWeekendOfMonth/index.js");
var _indexJsDefault55 = parcelHelpers.interopDefault(_indexJs55);
var _indexJs56 = require("./eachWeekendOfYear/index.js");
var _indexJsDefault56 = parcelHelpers.interopDefault(_indexJs56);
var _indexJs57 = require("./eachYearOfInterval/index.js");
var _indexJsDefault57 = parcelHelpers.interopDefault(_indexJs57);
var _indexJs58 = require("./endOfDay/index.js");
var _indexJsDefault58 = parcelHelpers.interopDefault(_indexJs58);
var _indexJs59 = require("./endOfDecade/index.js");
var _indexJsDefault59 = parcelHelpers.interopDefault(_indexJs59);
var _indexJs60 = require("./endOfDecadeWithOptions/index.js");
var _indexJsDefault60 = parcelHelpers.interopDefault(_indexJs60);
var _indexJs61 = require("./endOfHour/index.js");
var _indexJsDefault61 = parcelHelpers.interopDefault(_indexJs61);
var _indexJs62 = require("./endOfISOWeek/index.js");
var _indexJsDefault62 = parcelHelpers.interopDefault(_indexJs62);
var _indexJs63 = require("./endOfISOWeekYear/index.js");
var _indexJsDefault63 = parcelHelpers.interopDefault(_indexJs63);
var _indexJs64 = require("./endOfMinute/index.js");
var _indexJsDefault64 = parcelHelpers.interopDefault(_indexJs64);
var _indexJs65 = require("./endOfMonth/index.js");
var _indexJsDefault65 = parcelHelpers.interopDefault(_indexJs65);
var _indexJs66 = require("./endOfQuarter/index.js");
var _indexJsDefault66 = parcelHelpers.interopDefault(_indexJs66);
var _indexJs67 = require("./endOfSecond/index.js");
var _indexJsDefault67 = parcelHelpers.interopDefault(_indexJs67);
var _indexJs68 = require("./endOfWeek/index.js");
var _indexJsDefault68 = parcelHelpers.interopDefault(_indexJs68);
var _indexJs69 = require("./endOfWeekWithOptions/index.js");
var _indexJsDefault69 = parcelHelpers.interopDefault(_indexJs69);
var _indexJs70 = require("./endOfYear/index.js");
var _indexJsDefault70 = parcelHelpers.interopDefault(_indexJs70);
var _indexJs71 = require("./format/index.js");
var _indexJsDefault71 = parcelHelpers.interopDefault(_indexJs71);
var _indexJs72 = require("./formatDistance/index.js");
var _indexJsDefault72 = parcelHelpers.interopDefault(_indexJs72);
var _indexJs73 = require("./formatDistanceStrict/index.js");
var _indexJsDefault73 = parcelHelpers.interopDefault(_indexJs73);
var _indexJs74 = require("./formatDistanceStrictWithOptions/index.js");
var _indexJsDefault74 = parcelHelpers.interopDefault(_indexJs74);
var _indexJs75 = require("./formatDistanceWithOptions/index.js");
var _indexJsDefault75 = parcelHelpers.interopDefault(_indexJs75);
var _indexJs76 = require("./formatDuration/index.js");
var _indexJsDefault76 = parcelHelpers.interopDefault(_indexJs76);
var _indexJs77 = require("./formatDurationWithOptions/index.js");
var _indexJsDefault77 = parcelHelpers.interopDefault(_indexJs77);
var _indexJs78 = require("./formatISO/index.js");
var _indexJsDefault78 = parcelHelpers.interopDefault(_indexJs78);
var _indexJs79 = require("./formatISO9075/index.js");
var _indexJsDefault79 = parcelHelpers.interopDefault(_indexJs79);
var _indexJs80 = require("./formatISO9075WithOptions/index.js");
var _indexJsDefault80 = parcelHelpers.interopDefault(_indexJs80);
var _indexJs81 = require("./formatISODuration/index.js");
var _indexJsDefault81 = parcelHelpers.interopDefault(_indexJs81);
var _indexJs82 = require("./formatISOWithOptions/index.js");
var _indexJsDefault82 = parcelHelpers.interopDefault(_indexJs82);
var _indexJs83 = require("./formatRFC3339/index.js");
var _indexJsDefault83 = parcelHelpers.interopDefault(_indexJs83);
var _indexJs84 = require("./formatRFC3339WithOptions/index.js");
var _indexJsDefault84 = parcelHelpers.interopDefault(_indexJs84);
var _indexJs85 = require("./formatRFC7231/index.js");
var _indexJsDefault85 = parcelHelpers.interopDefault(_indexJs85);
var _indexJs86 = require("./formatRelative/index.js");
var _indexJsDefault86 = parcelHelpers.interopDefault(_indexJs86);
var _indexJs87 = require("./formatRelativeWithOptions/index.js");
var _indexJsDefault87 = parcelHelpers.interopDefault(_indexJs87);
var _indexJs88 = require("./formatWithOptions/index.js");
var _indexJsDefault88 = parcelHelpers.interopDefault(_indexJs88);
var _indexJs89 = require("./fromUnixTime/index.js");
var _indexJsDefault89 = parcelHelpers.interopDefault(_indexJs89);
var _indexJs90 = require("./getDate/index.js");
var _indexJsDefault90 = parcelHelpers.interopDefault(_indexJs90);
var _indexJs91 = require("./getDay/index.js");
var _indexJsDefault91 = parcelHelpers.interopDefault(_indexJs91);
var _indexJs92 = require("./getDayOfYear/index.js");
var _indexJsDefault92 = parcelHelpers.interopDefault(_indexJs92);
var _indexJs93 = require("./getDaysInMonth/index.js");
var _indexJsDefault93 = parcelHelpers.interopDefault(_indexJs93);
var _indexJs94 = require("./getDaysInYear/index.js");
var _indexJsDefault94 = parcelHelpers.interopDefault(_indexJs94);
var _indexJs95 = require("./getDecade/index.js");
var _indexJsDefault95 = parcelHelpers.interopDefault(_indexJs95);
var _indexJs96 = require("./getHours/index.js");
var _indexJsDefault96 = parcelHelpers.interopDefault(_indexJs96);
var _indexJs97 = require("./getISODay/index.js");
var _indexJsDefault97 = parcelHelpers.interopDefault(_indexJs97);
var _indexJs98 = require("./getISOWeek/index.js");
var _indexJsDefault98 = parcelHelpers.interopDefault(_indexJs98);
var _indexJs99 = require("./getISOWeekYear/index.js");
var _indexJsDefault99 = parcelHelpers.interopDefault(_indexJs99);
var _indexJs100 = require("./getISOWeeksInYear/index.js");
var _indexJsDefault100 = parcelHelpers.interopDefault(_indexJs100);
var _indexJs101 = require("./getMilliseconds/index.js");
var _indexJsDefault101 = parcelHelpers.interopDefault(_indexJs101);
var _indexJs102 = require("./getMinutes/index.js");
var _indexJsDefault102 = parcelHelpers.interopDefault(_indexJs102);
var _indexJs103 = require("./getMonth/index.js");
var _indexJsDefault103 = parcelHelpers.interopDefault(_indexJs103);
var _indexJs104 = require("./getOverlappingDaysInIntervals/index.js");
var _indexJsDefault104 = parcelHelpers.interopDefault(_indexJs104);
var _indexJs105 = require("./getQuarter/index.js");
var _indexJsDefault105 = parcelHelpers.interopDefault(_indexJs105);
var _indexJs106 = require("./getSeconds/index.js");
var _indexJsDefault106 = parcelHelpers.interopDefault(_indexJs106);
var _indexJs107 = require("./getTime/index.js");
var _indexJsDefault107 = parcelHelpers.interopDefault(_indexJs107);
var _indexJs108 = require("./getUnixTime/index.js");
var _indexJsDefault108 = parcelHelpers.interopDefault(_indexJs108);
var _indexJs109 = require("./getWeek/index.js");
var _indexJsDefault109 = parcelHelpers.interopDefault(_indexJs109);
var _indexJs110 = require("./getWeekOfMonth/index.js");
var _indexJsDefault110 = parcelHelpers.interopDefault(_indexJs110);
var _indexJs111 = require("./getWeekOfMonthWithOptions/index.js");
var _indexJsDefault111 = parcelHelpers.interopDefault(_indexJs111);
var _indexJs112 = require("./getWeekWithOptions/index.js");
var _indexJsDefault112 = parcelHelpers.interopDefault(_indexJs112);
var _indexJs113 = require("./getWeekYear/index.js");
var _indexJsDefault113 = parcelHelpers.interopDefault(_indexJs113);
var _indexJs114 = require("./getWeekYearWithOptions/index.js");
var _indexJsDefault114 = parcelHelpers.interopDefault(_indexJs114);
var _indexJs115 = require("./getWeeksInMonth/index.js");
var _indexJsDefault115 = parcelHelpers.interopDefault(_indexJs115);
var _indexJs116 = require("./getWeeksInMonthWithOptions/index.js");
var _indexJsDefault116 = parcelHelpers.interopDefault(_indexJs116);
var _indexJs117 = require("./getYear/index.js");
var _indexJsDefault117 = parcelHelpers.interopDefault(_indexJs117);
var _indexJs118 = require("./hoursToMilliseconds/index.js");
var _indexJsDefault118 = parcelHelpers.interopDefault(_indexJs118);
var _indexJs119 = require("./hoursToMinutes/index.js");
var _indexJsDefault119 = parcelHelpers.interopDefault(_indexJs119);
var _indexJs120 = require("./hoursToSeconds/index.js");
var _indexJsDefault120 = parcelHelpers.interopDefault(_indexJs120);
var _indexJs121 = require("./intervalToDuration/index.js");
var _indexJsDefault121 = parcelHelpers.interopDefault(_indexJs121);
var _indexJs122 = require("./intlFormat/index.js");
var _indexJsDefault122 = parcelHelpers.interopDefault(_indexJs122);
var _indexJs123 = require("./intlFormatDistance/index.js");
var _indexJsDefault123 = parcelHelpers.interopDefault(_indexJs123);
var _indexJs124 = require("./intlFormatDistanceWithOptions/index.js");
var _indexJsDefault124 = parcelHelpers.interopDefault(_indexJs124);
var _indexJs125 = require("./isAfter/index.js");
var _indexJsDefault125 = parcelHelpers.interopDefault(_indexJs125);
var _indexJs126 = require("./isBefore/index.js");
var _indexJsDefault126 = parcelHelpers.interopDefault(_indexJs126);
var _indexJs127 = require("./isDate/index.js");
var _indexJsDefault127 = parcelHelpers.interopDefault(_indexJs127);
var _indexJs128 = require("./isEqual/index.js");
var _indexJsDefault128 = parcelHelpers.interopDefault(_indexJs128);
var _indexJs129 = require("./isExists/index.js");
var _indexJsDefault129 = parcelHelpers.interopDefault(_indexJs129);
var _indexJs130 = require("./isFirstDayOfMonth/index.js");
var _indexJsDefault130 = parcelHelpers.interopDefault(_indexJs130);
var _indexJs131 = require("./isFriday/index.js");
var _indexJsDefault131 = parcelHelpers.interopDefault(_indexJs131);
var _indexJs132 = require("./isLastDayOfMonth/index.js");
var _indexJsDefault132 = parcelHelpers.interopDefault(_indexJs132);
var _indexJs133 = require("./isLeapYear/index.js");
var _indexJsDefault133 = parcelHelpers.interopDefault(_indexJs133);
var _indexJs134 = require("./isMatch/index.js");
var _indexJsDefault134 = parcelHelpers.interopDefault(_indexJs134);
var _indexJs135 = require("./isMatchWithOptions/index.js");
var _indexJsDefault135 = parcelHelpers.interopDefault(_indexJs135);
var _indexJs136 = require("./isMonday/index.js");
var _indexJsDefault136 = parcelHelpers.interopDefault(_indexJs136);
var _indexJs137 = require("./isSameDay/index.js");
var _indexJsDefault137 = parcelHelpers.interopDefault(_indexJs137);
var _indexJs138 = require("./isSameHour/index.js");
var _indexJsDefault138 = parcelHelpers.interopDefault(_indexJs138);
var _indexJs139 = require("./isSameISOWeek/index.js");
var _indexJsDefault139 = parcelHelpers.interopDefault(_indexJs139);
var _indexJs140 = require("./isSameISOWeekYear/index.js");
var _indexJsDefault140 = parcelHelpers.interopDefault(_indexJs140);
var _indexJs141 = require("./isSameMinute/index.js");
var _indexJsDefault141 = parcelHelpers.interopDefault(_indexJs141);
var _indexJs142 = require("./isSameMonth/index.js");
var _indexJsDefault142 = parcelHelpers.interopDefault(_indexJs142);
var _indexJs143 = require("./isSameQuarter/index.js");
var _indexJsDefault143 = parcelHelpers.interopDefault(_indexJs143);
var _indexJs144 = require("./isSameSecond/index.js");
var _indexJsDefault144 = parcelHelpers.interopDefault(_indexJs144);
var _indexJs145 = require("./isSameWeek/index.js");
var _indexJsDefault145 = parcelHelpers.interopDefault(_indexJs145);
var _indexJs146 = require("./isSameWeekWithOptions/index.js");
var _indexJsDefault146 = parcelHelpers.interopDefault(_indexJs146);
var _indexJs147 = require("./isSameYear/index.js");
var _indexJsDefault147 = parcelHelpers.interopDefault(_indexJs147);
var _indexJs148 = require("./isSaturday/index.js");
var _indexJsDefault148 = parcelHelpers.interopDefault(_indexJs148);
var _indexJs149 = require("./isSunday/index.js");
var _indexJsDefault149 = parcelHelpers.interopDefault(_indexJs149);
var _indexJs150 = require("./isThursday/index.js");
var _indexJsDefault150 = parcelHelpers.interopDefault(_indexJs150);
var _indexJs151 = require("./isTuesday/index.js");
var _indexJsDefault151 = parcelHelpers.interopDefault(_indexJs151);
var _indexJs152 = require("./isValid/index.js");
var _indexJsDefault152 = parcelHelpers.interopDefault(_indexJs152);
var _indexJs153 = require("./isWednesday/index.js");
var _indexJsDefault153 = parcelHelpers.interopDefault(_indexJs153);
var _indexJs154 = require("./isWeekend/index.js");
var _indexJsDefault154 = parcelHelpers.interopDefault(_indexJs154);
var _indexJs155 = require("./isWithinInterval/index.js");
var _indexJsDefault155 = parcelHelpers.interopDefault(_indexJs155);
var _indexJs156 = require("./lastDayOfDecade/index.js");
var _indexJsDefault156 = parcelHelpers.interopDefault(_indexJs156);
var _indexJs157 = require("./lastDayOfISOWeek/index.js");
var _indexJsDefault157 = parcelHelpers.interopDefault(_indexJs157);
var _indexJs158 = require("./lastDayOfISOWeekYear/index.js");
var _indexJsDefault158 = parcelHelpers.interopDefault(_indexJs158);
var _indexJs159 = require("./lastDayOfMonth/index.js");
var _indexJsDefault159 = parcelHelpers.interopDefault(_indexJs159);
var _indexJs160 = require("./lastDayOfQuarter/index.js");
var _indexJsDefault160 = parcelHelpers.interopDefault(_indexJs160);
var _indexJs161 = require("./lastDayOfQuarterWithOptions/index.js");
var _indexJsDefault161 = parcelHelpers.interopDefault(_indexJs161);
var _indexJs162 = require("./lastDayOfWeek/index.js");
var _indexJsDefault162 = parcelHelpers.interopDefault(_indexJs162);
var _indexJs163 = require("./lastDayOfWeekWithOptions/index.js");
var _indexJsDefault163 = parcelHelpers.interopDefault(_indexJs163);
var _indexJs164 = require("./lastDayOfYear/index.js");
var _indexJsDefault164 = parcelHelpers.interopDefault(_indexJs164);
var _indexJs165 = require("./lightFormat/index.js");
var _indexJsDefault165 = parcelHelpers.interopDefault(_indexJs165);
var _indexJs166 = require("./max/index.js");
var _indexJsDefault166 = parcelHelpers.interopDefault(_indexJs166);
var _indexJs167 = require("./milliseconds/index.js");
var _indexJsDefault167 = parcelHelpers.interopDefault(_indexJs167);
var _indexJs168 = require("./millisecondsToHours/index.js");
var _indexJsDefault168 = parcelHelpers.interopDefault(_indexJs168);
var _indexJs169 = require("./millisecondsToMinutes/index.js");
var _indexJsDefault169 = parcelHelpers.interopDefault(_indexJs169);
var _indexJs170 = require("./millisecondsToSeconds/index.js");
var _indexJsDefault170 = parcelHelpers.interopDefault(_indexJs170);
var _indexJs171 = require("./min/index.js");
var _indexJsDefault171 = parcelHelpers.interopDefault(_indexJs171);
var _indexJs172 = require("./minutesToHours/index.js");
var _indexJsDefault172 = parcelHelpers.interopDefault(_indexJs172);
var _indexJs173 = require("./minutesToMilliseconds/index.js");
var _indexJsDefault173 = parcelHelpers.interopDefault(_indexJs173);
var _indexJs174 = require("./minutesToSeconds/index.js");
var _indexJsDefault174 = parcelHelpers.interopDefault(_indexJs174);
var _indexJs175 = require("./monthsToQuarters/index.js");
var _indexJsDefault175 = parcelHelpers.interopDefault(_indexJs175);
var _indexJs176 = require("./monthsToYears/index.js");
var _indexJsDefault176 = parcelHelpers.interopDefault(_indexJs176);
var _indexJs177 = require("./nextDay/index.js");
var _indexJsDefault177 = parcelHelpers.interopDefault(_indexJs177);
var _indexJs178 = require("./nextFriday/index.js");
var _indexJsDefault178 = parcelHelpers.interopDefault(_indexJs178);
var _indexJs179 = require("./nextMonday/index.js");
var _indexJsDefault179 = parcelHelpers.interopDefault(_indexJs179);
var _indexJs180 = require("./nextSaturday/index.js");
var _indexJsDefault180 = parcelHelpers.interopDefault(_indexJs180);
var _indexJs181 = require("./nextSunday/index.js");
var _indexJsDefault181 = parcelHelpers.interopDefault(_indexJs181);
var _indexJs182 = require("./nextThursday/index.js");
var _indexJsDefault182 = parcelHelpers.interopDefault(_indexJs182);
var _indexJs183 = require("./nextTuesday/index.js");
var _indexJsDefault183 = parcelHelpers.interopDefault(_indexJs183);
var _indexJs184 = require("./nextWednesday/index.js");
var _indexJsDefault184 = parcelHelpers.interopDefault(_indexJs184);
var _indexJs185 = require("./parse/index.js");
var _indexJsDefault185 = parcelHelpers.interopDefault(_indexJs185);
var _indexJs186 = require("./parseISO/index.js");
var _indexJsDefault186 = parcelHelpers.interopDefault(_indexJs186);
var _indexJs187 = require("./parseISOWithOptions/index.js");
var _indexJsDefault187 = parcelHelpers.interopDefault(_indexJs187);
var _indexJs188 = require("./parseJSON/index.js");
var _indexJsDefault188 = parcelHelpers.interopDefault(_indexJs188);
var _indexJs189 = require("./parseWithOptions/index.js");
var _indexJsDefault189 = parcelHelpers.interopDefault(_indexJs189);
var _indexJs190 = require("./previousDay/index.js");
var _indexJsDefault190 = parcelHelpers.interopDefault(_indexJs190);
var _indexJs191 = require("./previousFriday/index.js");
var _indexJsDefault191 = parcelHelpers.interopDefault(_indexJs191);
var _indexJs192 = require("./previousMonday/index.js");
var _indexJsDefault192 = parcelHelpers.interopDefault(_indexJs192);
var _indexJs193 = require("./previousSaturday/index.js");
var _indexJsDefault193 = parcelHelpers.interopDefault(_indexJs193);
var _indexJs194 = require("./previousSunday/index.js");
var _indexJsDefault194 = parcelHelpers.interopDefault(_indexJs194);
var _indexJs195 = require("./previousThursday/index.js");
var _indexJsDefault195 = parcelHelpers.interopDefault(_indexJs195);
var _indexJs196 = require("./previousTuesday/index.js");
var _indexJsDefault196 = parcelHelpers.interopDefault(_indexJs196);
var _indexJs197 = require("./previousWednesday/index.js");
var _indexJsDefault197 = parcelHelpers.interopDefault(_indexJs197);
var _indexJs198 = require("./quartersToMonths/index.js");
var _indexJsDefault198 = parcelHelpers.interopDefault(_indexJs198);
var _indexJs199 = require("./quartersToYears/index.js");
var _indexJsDefault199 = parcelHelpers.interopDefault(_indexJs199);
var _indexJs200 = require("./roundToNearestMinutes/index.js");
var _indexJsDefault200 = parcelHelpers.interopDefault(_indexJs200);
var _indexJs201 = require("./roundToNearestMinutesWithOptions/index.js");
var _indexJsDefault201 = parcelHelpers.interopDefault(_indexJs201);
var _indexJs202 = require("./secondsToHours/index.js");
var _indexJsDefault202 = parcelHelpers.interopDefault(_indexJs202);
var _indexJs203 = require("./secondsToMilliseconds/index.js");
var _indexJsDefault203 = parcelHelpers.interopDefault(_indexJs203);
var _indexJs204 = require("./secondsToMinutes/index.js");
var _indexJsDefault204 = parcelHelpers.interopDefault(_indexJs204);
var _indexJs205 = require("./set/index.js");
var _indexJsDefault205 = parcelHelpers.interopDefault(_indexJs205);
var _indexJs206 = require("./setDate/index.js");
var _indexJsDefault206 = parcelHelpers.interopDefault(_indexJs206);
var _indexJs207 = require("./setDay/index.js");
var _indexJsDefault207 = parcelHelpers.interopDefault(_indexJs207);
var _indexJs208 = require("./setDayOfYear/index.js");
var _indexJsDefault208 = parcelHelpers.interopDefault(_indexJs208);
var _indexJs209 = require("./setDayWithOptions/index.js");
var _indexJsDefault209 = parcelHelpers.interopDefault(_indexJs209);
var _indexJs210 = require("./setHours/index.js");
var _indexJsDefault210 = parcelHelpers.interopDefault(_indexJs210);
var _indexJs211 = require("./setISODay/index.js");
var _indexJsDefault211 = parcelHelpers.interopDefault(_indexJs211);
var _indexJs212 = require("./setISOWeek/index.js");
var _indexJsDefault212 = parcelHelpers.interopDefault(_indexJs212);
var _indexJs213 = require("./setISOWeekYear/index.js");
var _indexJsDefault213 = parcelHelpers.interopDefault(_indexJs213);
var _indexJs214 = require("./setMilliseconds/index.js");
var _indexJsDefault214 = parcelHelpers.interopDefault(_indexJs214);
var _indexJs215 = require("./setMinutes/index.js");
var _indexJsDefault215 = parcelHelpers.interopDefault(_indexJs215);
var _indexJs216 = require("./setMonth/index.js");
var _indexJsDefault216 = parcelHelpers.interopDefault(_indexJs216);
var _indexJs217 = require("./setQuarter/index.js");
var _indexJsDefault217 = parcelHelpers.interopDefault(_indexJs217);
var _indexJs218 = require("./setSeconds/index.js");
var _indexJsDefault218 = parcelHelpers.interopDefault(_indexJs218);
var _indexJs219 = require("./setWeek/index.js");
var _indexJsDefault219 = parcelHelpers.interopDefault(_indexJs219);
var _indexJs220 = require("./setWeekWithOptions/index.js");
var _indexJsDefault220 = parcelHelpers.interopDefault(_indexJs220);
var _indexJs221 = require("./setWeekYear/index.js");
var _indexJsDefault221 = parcelHelpers.interopDefault(_indexJs221);
var _indexJs222 = require("./setWeekYearWithOptions/index.js");
var _indexJsDefault222 = parcelHelpers.interopDefault(_indexJs222);
var _indexJs223 = require("./setYear/index.js");
var _indexJsDefault223 = parcelHelpers.interopDefault(_indexJs223);
var _indexJs224 = require("./startOfDay/index.js");
var _indexJsDefault224 = parcelHelpers.interopDefault(_indexJs224);
var _indexJs225 = require("./startOfDecade/index.js");
var _indexJsDefault225 = parcelHelpers.interopDefault(_indexJs225);
var _indexJs226 = require("./startOfHour/index.js");
var _indexJsDefault226 = parcelHelpers.interopDefault(_indexJs226);
var _indexJs227 = require("./startOfISOWeek/index.js");
var _indexJsDefault227 = parcelHelpers.interopDefault(_indexJs227);
var _indexJs228 = require("./startOfISOWeekYear/index.js");
var _indexJsDefault228 = parcelHelpers.interopDefault(_indexJs228);
var _indexJs229 = require("./startOfMinute/index.js");
var _indexJsDefault229 = parcelHelpers.interopDefault(_indexJs229);
var _indexJs230 = require("./startOfMonth/index.js");
var _indexJsDefault230 = parcelHelpers.interopDefault(_indexJs230);
var _indexJs231 = require("./startOfQuarter/index.js");
var _indexJsDefault231 = parcelHelpers.interopDefault(_indexJs231);
var _indexJs232 = require("./startOfSecond/index.js");
var _indexJsDefault232 = parcelHelpers.interopDefault(_indexJs232);
var _indexJs233 = require("./startOfWeek/index.js");
var _indexJsDefault233 = parcelHelpers.interopDefault(_indexJs233);
var _indexJs234 = require("./startOfWeekWithOptions/index.js");
var _indexJsDefault234 = parcelHelpers.interopDefault(_indexJs234);
var _indexJs235 = require("./startOfWeekYear/index.js");
var _indexJsDefault235 = parcelHelpers.interopDefault(_indexJs235);
var _indexJs236 = require("./startOfWeekYearWithOptions/index.js");
var _indexJsDefault236 = parcelHelpers.interopDefault(_indexJs236);
var _indexJs237 = require("./startOfYear/index.js");
var _indexJsDefault237 = parcelHelpers.interopDefault(_indexJs237);
var _indexJs238 = require("./sub/index.js");
var _indexJsDefault238 = parcelHelpers.interopDefault(_indexJs238);
var _indexJs239 = require("./subBusinessDays/index.js");
var _indexJsDefault239 = parcelHelpers.interopDefault(_indexJs239);
var _indexJs240 = require("./subDays/index.js");
var _indexJsDefault240 = parcelHelpers.interopDefault(_indexJs240);
var _indexJs241 = require("./subHours/index.js");
var _indexJsDefault241 = parcelHelpers.interopDefault(_indexJs241);
var _indexJs242 = require("./subISOWeekYears/index.js");
var _indexJsDefault242 = parcelHelpers.interopDefault(_indexJs242);
var _indexJs243 = require("./subMilliseconds/index.js");
var _indexJsDefault243 = parcelHelpers.interopDefault(_indexJs243);
var _indexJs244 = require("./subMinutes/index.js");
var _indexJsDefault244 = parcelHelpers.interopDefault(_indexJs244);
var _indexJs245 = require("./subMonths/index.js");
var _indexJsDefault245 = parcelHelpers.interopDefault(_indexJs245);
var _indexJs246 = require("./subQuarters/index.js");
var _indexJsDefault246 = parcelHelpers.interopDefault(_indexJs246);
var _indexJs247 = require("./subSeconds/index.js");
var _indexJsDefault247 = parcelHelpers.interopDefault(_indexJs247);
var _indexJs248 = require("./subWeeks/index.js");
var _indexJsDefault248 = parcelHelpers.interopDefault(_indexJs248);
var _indexJs249 = require("./subYears/index.js");
var _indexJsDefault249 = parcelHelpers.interopDefault(_indexJs249);
var _indexJs250 = require("./toDate/index.js");
var _indexJsDefault250 = parcelHelpers.interopDefault(_indexJs250);
var _indexJs251 = require("./weeksToDays/index.js");
var _indexJsDefault251 = parcelHelpers.interopDefault(_indexJs251);
var _indexJs252 = require("./yearsToMonths/index.js");
var _indexJsDefault252 = parcelHelpers.interopDefault(_indexJs252);
var _indexJs253 = require("./yearsToQuarters/index.js");
var _indexJsDefault253 = parcelHelpers.interopDefault(_indexJs253);
var _indexJs254 = require("../constants/index.js");
parcelHelpers.exportAll(_indexJs254, exports);

},{"./add/index.js":false,"./addBusinessDays/index.js":false,"./addDays/index.js":false,"./addHours/index.js":false,"./addISOWeekYears/index.js":false,"./addMilliseconds/index.js":false,"./addMinutes/index.js":false,"./addMonths/index.js":false,"./addQuarters/index.js":false,"./addSeconds/index.js":false,"./addWeeks/index.js":false,"./addYears/index.js":false,"./areIntervalsOverlapping/index.js":false,"./areIntervalsOverlappingWithOptions/index.js":false,"./clamp/index.js":false,"./closestIndexTo/index.js":false,"./closestTo/index.js":false,"./compareAsc/index.js":false,"./compareDesc/index.js":false,"./daysToWeeks/index.js":false,"./differenceInBusinessDays/index.js":false,"./differenceInCalendarDays/index.js":false,"./differenceInCalendarISOWeekYears/index.js":false,"./differenceInCalendarISOWeeks/index.js":false,"./differenceInCalendarMonths/index.js":false,"./differenceInCalendarQuarters/index.js":false,"./differenceInCalendarWeeks/index.js":false,"./differenceInCalendarWeeksWithOptions/index.js":false,"./differenceInCalendarYears/index.js":false,"./differenceInDays/index.js":false,"./differenceInHours/index.js":false,"./differenceInHoursWithOptions/index.js":false,"./differenceInISOWeekYears/index.js":false,"./differenceInMilliseconds/index.js":false,"./differenceInMinutes/index.js":false,"./differenceInMinutesWithOptions/index.js":false,"./differenceInMonths/index.js":false,"./differenceInQuarters/index.js":false,"./differenceInQuartersWithOptions/index.js":false,"./differenceInSeconds/index.js":false,"./differenceInSecondsWithOptions/index.js":false,"./differenceInWeeks/index.js":false,"./differenceInWeeksWithOptions/index.js":false,"./differenceInYears/index.js":false,"./eachDayOfInterval/index.js":false,"./eachDayOfIntervalWithOptions/index.js":false,"./eachHourOfInterval/index.js":false,"./eachHourOfIntervalWithOptions/index.js":false,"./eachMinuteOfInterval/index.js":false,"./eachMinuteOfIntervalWithOptions/index.js":false,"./eachMonthOfInterval/index.js":false,"./eachQuarterOfInterval/index.js":false,"./eachWeekOfInterval/index.js":false,"./eachWeekOfIntervalWithOptions/index.js":false,"./eachWeekendOfInterval/index.js":false,"./eachWeekendOfMonth/index.js":false,"./eachWeekendOfYear/index.js":false,"./eachYearOfInterval/index.js":false,"./endOfDay/index.js":false,"./endOfDecade/index.js":false,"./endOfDecadeWithOptions/index.js":false,"./endOfHour/index.js":false,"./endOfISOWeek/index.js":false,"./endOfISOWeekYear/index.js":false,"./endOfMinute/index.js":false,"./endOfMonth/index.js":false,"./endOfQuarter/index.js":false,"./endOfSecond/index.js":false,"./endOfWeek/index.js":false,"./endOfWeekWithOptions/index.js":false,"./endOfYear/index.js":false,"./format/index.js":"dPNmv","./formatDistance/index.js":false,"./formatDistanceStrict/index.js":false,"./formatDistanceStrictWithOptions/index.js":false,"./formatDistanceWithOptions/index.js":false,"./formatDuration/index.js":false,"./formatDurationWithOptions/index.js":false,"./formatISO/index.js":false,"./formatISO9075/index.js":false,"./formatISO9075WithOptions/index.js":false,"./formatISODuration/index.js":false,"./formatISOWithOptions/index.js":false,"./formatRFC3339/index.js":false,"./formatRFC3339WithOptions/index.js":false,"./formatRFC7231/index.js":false,"./formatRelative/index.js":false,"./formatRelativeWithOptions/index.js":false,"./formatWithOptions/index.js":false,"./fromUnixTime/index.js":false,"./getDate/index.js":false,"./getDay/index.js":false,"./getDayOfYear/index.js":false,"./getDaysInMonth/index.js":false,"./getDaysInYear/index.js":false,"./getDecade/index.js":false,"./getHours/index.js":false,"./getISODay/index.js":false,"./getISOWeek/index.js":false,"./getISOWeekYear/index.js":false,"./getISOWeeksInYear/index.js":false,"./getMilliseconds/index.js":false,"./getMinutes/index.js":false,"./getMonth/index.js":false,"./getOverlappingDaysInIntervals/index.js":false,"./getQuarter/index.js":false,"./getSeconds/index.js":false,"./getTime/index.js":false,"./getUnixTime/index.js":false,"./getWeek/index.js":false,"./getWeekOfMonth/index.js":false,"./getWeekOfMonthWithOptions/index.js":false,"./getWeekWithOptions/index.js":false,"./getWeekYear/index.js":false,"./getWeekYearWithOptions/index.js":false,"./getWeeksInMonth/index.js":false,"./getWeeksInMonthWithOptions/index.js":false,"./getYear/index.js":false,"./hoursToMilliseconds/index.js":false,"./hoursToMinutes/index.js":false,"./hoursToSeconds/index.js":false,"./intervalToDuration/index.js":false,"./intlFormat/index.js":false,"./intlFormatDistance/index.js":false,"./intlFormatDistanceWithOptions/index.js":false,"./isAfter/index.js":false,"./isBefore/index.js":false,"./isDate/index.js":false,"./isEqual/index.js":false,"./isExists/index.js":false,"./isFirstDayOfMonth/index.js":false,"./isFriday/index.js":false,"./isLastDayOfMonth/index.js":false,"./isLeapYear/index.js":false,"./isMatch/index.js":false,"./isMatchWithOptions/index.js":false,"./isMonday/index.js":false,"./isSameDay/index.js":false,"./isSameHour/index.js":false,"./isSameISOWeek/index.js":false,"./isSameISOWeekYear/index.js":false,"./isSameMinute/index.js":false,"./isSameMonth/index.js":false,"./isSameQuarter/index.js":false,"./isSameSecond/index.js":false,"./isSameWeek/index.js":false,"./isSameWeekWithOptions/index.js":false,"./isSameYear/index.js":false,"./isSaturday/index.js":false,"./isSunday/index.js":false,"./isThursday/index.js":false,"./isTuesday/index.js":false,"./isValid/index.js":false,"./isWednesday/index.js":false,"./isWeekend/index.js":false,"./isWithinInterval/index.js":false,"./lastDayOfDecade/index.js":false,"./lastDayOfISOWeek/index.js":false,"./lastDayOfISOWeekYear/index.js":false,"./lastDayOfMonth/index.js":false,"./lastDayOfQuarter/index.js":false,"./lastDayOfQuarterWithOptions/index.js":false,"./lastDayOfWeek/index.js":false,"./lastDayOfWeekWithOptions/index.js":false,"./lastDayOfYear/index.js":false,"./lightFormat/index.js":false,"./max/index.js":false,"./milliseconds/index.js":false,"./millisecondsToHours/index.js":false,"./millisecondsToMinutes/index.js":false,"./millisecondsToSeconds/index.js":false,"./min/index.js":false,"./minutesToHours/index.js":false,"./minutesToMilliseconds/index.js":false,"./minutesToSeconds/index.js":false,"./monthsToQuarters/index.js":false,"./monthsToYears/index.js":false,"./nextDay/index.js":false,"./nextFriday/index.js":false,"./nextMonday/index.js":false,"./nextSaturday/index.js":false,"./nextSunday/index.js":false,"./nextThursday/index.js":false,"./nextTuesday/index.js":false,"./nextWednesday/index.js":false,"./parse/index.js":false,"./parseISO/index.js":false,"./parseISOWithOptions/index.js":false,"./parseJSON/index.js":false,"./parseWithOptions/index.js":false,"./previousDay/index.js":false,"./previousFriday/index.js":false,"./previousMonday/index.js":false,"./previousSaturday/index.js":false,"./previousSunday/index.js":false,"./previousThursday/index.js":false,"./previousTuesday/index.js":false,"./previousWednesday/index.js":false,"./quartersToMonths/index.js":false,"./quartersToYears/index.js":false,"./roundToNearestMinutes/index.js":false,"./roundToNearestMinutesWithOptions/index.js":false,"./secondsToHours/index.js":false,"./secondsToMilliseconds/index.js":false,"./secondsToMinutes/index.js":false,"./set/index.js":false,"./setDate/index.js":false,"./setDay/index.js":false,"./setDayOfYear/index.js":false,"./setDayWithOptions/index.js":false,"./setHours/index.js":false,"./setISODay/index.js":false,"./setISOWeek/index.js":false,"./setISOWeekYear/index.js":false,"./setMilliseconds/index.js":false,"./setMinutes/index.js":false,"./setMonth/index.js":false,"./setQuarter/index.js":false,"./setSeconds/index.js":false,"./setWeek/index.js":false,"./setWeekWithOptions/index.js":false,"./setWeekYear/index.js":false,"./setWeekYearWithOptions/index.js":false,"./setYear/index.js":false,"./startOfDay/index.js":false,"./startOfDecade/index.js":false,"./startOfHour/index.js":false,"./startOfISOWeek/index.js":false,"./startOfISOWeekYear/index.js":false,"./startOfMinute/index.js":false,"./startOfMonth/index.js":false,"./startOfQuarter/index.js":false,"./startOfSecond/index.js":false,"./startOfWeek/index.js":false,"./startOfWeekWithOptions/index.js":false,"./startOfWeekYear/index.js":false,"./startOfWeekYearWithOptions/index.js":false,"./startOfYear/index.js":false,"./sub/index.js":false,"./subBusinessDays/index.js":false,"./subDays/index.js":false,"./subHours/index.js":false,"./subISOWeekYears/index.js":false,"./subMilliseconds/index.js":false,"./subMinutes/index.js":false,"./subMonths/index.js":false,"./subQuarters/index.js":false,"./subSeconds/index.js":false,"./subWeeks/index.js":false,"./subYears/index.js":false,"./toDate/index.js":false,"./weeksToDays/index.js":false,"./yearsToMonths/index.js":false,"./yearsToQuarters/index.js":false,"../constants/index.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"dPNmv":[function(require,module,exports,__globalThis) {
// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../format/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/convertToFP/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
exports.default = (0, _indexJsDefault1.default)((0, _indexJsDefault.default), 2);

},{"../../format/index.js":"jiVQj","../_lib/convertToFP/index.js":"h72g3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jiVQj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return format;
});
var _indexJs = require("../isValid/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../subMilliseconds/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../toDate/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/format/formatters/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../_lib/format/longFormatters/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
var _indexJs5 = require("../_lib/getTimezoneOffsetInMilliseconds/index.js");
var _indexJsDefault5 = parcelHelpers.interopDefault(_indexJs5);
var _indexJs6 = require("../_lib/protectedTokens/index.js");
var _indexJs7 = require("../_lib/toInteger/index.js");
var _indexJsDefault6 = parcelHelpers.interopDefault(_indexJs7);
var _indexJs8 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault7 = parcelHelpers.interopDefault(_indexJs8);
var _indexJs9 = require("../_lib/defaultOptions/index.js");
var _indexJs10 = require("../_lib/defaultLocale/index.js"); // This RegExp consists of three parts separated by `|`:
var _indexJsDefault8 = parcelHelpers.interopDefault(_indexJs10);
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function format(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, _indexJsDefault7.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, _indexJs9.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, _indexJsDefault8.default);
    var firstWeekContainsDate = (0, _indexJsDefault6.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, _indexJsDefault6.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (!locale.localize) throw new RangeError('locale must contain localize property');
    if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
    var originalDate = (0, _indexJsDefault2.default)(dirtyDate);
    if (!(0, _indexJsDefault.default)(originalDate)) throw new RangeError('Invalid time value');
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, _indexJsDefault5.default)(originalDate);
    var utcDate = (0, _indexJsDefault1.default)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match(longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = (0, _indexJsDefault4.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match(formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return cleanEscapedString(substring);
        var formatter = (0, _indexJsDefault3.default)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, _indexJs6.isProtectedWeekYearToken)(substring)) (0, _indexJs6.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, _indexJs6.isProtectedDayOfYearToken)(substring)) (0, _indexJs6.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match(unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        return substring;
    }).join('');
    return result;
}
function cleanEscapedString(input) {
    var matched = input.match(escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace(doubleQuoteRegExp, "'");
}

},{"../isValid/index.js":"3ObFu","../subMilliseconds/index.js":"5b6Uh","../toDate/index.js":"j2pWU","../_lib/format/formatters/index.js":"7QF8t","../_lib/format/longFormatters/index.js":"6kxpi","../_lib/getTimezoneOffsetInMilliseconds/index.js":"i5oJ5","../_lib/protectedTokens/index.js":"lJQbo","../_lib/toInteger/index.js":"l2SJM","../_lib/requiredArgs/index.js":"a3mwq","../_lib/defaultOptions/index.js":"f8LK0","../_lib/defaultLocale/index.js":"1ggW0","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3ObFu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isValid;
});
var _indexJs = require("../isDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function isValid(dirtyDate) {
    (0, _indexJsDefault2.default)(1, arguments);
    if (!(0, _indexJsDefault.default)(dirtyDate) && typeof dirtyDate !== 'number') return false;
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    return !isNaN(Number(date));
}

},{"../isDate/index.js":"kf7MH","../toDate/index.js":"j2pWU","../_lib/requiredArgs/index.js":"a3mwq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"kf7MH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isDate;
});
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _indexJs = require("../_lib/requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function isDate(value) {
    (0, _indexJsDefault.default)(1, arguments);
    return value instanceof Date || (0, _typeofDefault.default)(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

},{"@babel/runtime/helpers/esm/typeof":"iu2gT","../_lib/requiredArgs/index.js":"a3mwq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"a3mwq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return requiredArgs;
});
function requiredArgs(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"j2pWU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return toDate;
});
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _indexJs = require("../_lib/requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
function toDate(argument) {
    (0, _indexJsDefault.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, _typeofDefault.default)(argument) === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}

},{"@babel/runtime/helpers/esm/typeof":"iu2gT","../_lib/requiredArgs/index.js":"a3mwq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5b6Uh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return subMilliseconds;
});
var _indexJs = require("../addMilliseconds/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function subMilliseconds(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault1.default)(2, arguments);
    var amount = (0, _indexJsDefault2.default)(dirtyAmount);
    return (0, _indexJsDefault.default)(dirtyDate, -amount);
}

},{"../addMilliseconds/index.js":"5O0Rn","../_lib/requiredArgs/index.js":"a3mwq","../_lib/toInteger/index.js":"l2SJM","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5O0Rn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return addMilliseconds;
});
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function addMilliseconds(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var timestamp = (0, _indexJsDefault1.default)(dirtyDate).getTime();
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    return new Date(timestamp + amount);
}

},{"../_lib/toInteger/index.js":"l2SJM","../toDate/index.js":"j2pWU","../_lib/requiredArgs/index.js":"a3mwq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"l2SJM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return toInteger;
});
function toInteger(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7QF8t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/getUTCDayOfYear/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/getUTCISOWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../../../_lib/getUTCISOWeekYear/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../../../_lib/getUTCWeek/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../../../_lib/getUTCWeekYear/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
var _indexJs5 = require("../../addLeadingZeros/index.js");
var _indexJsDefault5 = parcelHelpers.interopDefault(_indexJs5);
var _indexJs6 = require("../lightFormatters/index.js");
var _indexJsDefault6 = parcelHelpers.interopDefault(_indexJs6);
var dayPeriodEnum = {
    am: 'am',
    pm: 'pm',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case 'G':
            case 'GG':
            case 'GGG':
                return localize.era(era, {
                    width: 'abbreviated'
                });
            // A, B
            case 'GGGGG':
                return localize.era(era, {
                    width: 'narrow'
                });
            // Anno Domini, Before Christ
            case 'GGGG':
            default:
                return localize.era(era, {
                    width: 'wide'
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === 'yo') {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: 'year'
            });
        }
        return (0, _indexJsDefault6.default).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, _indexJsDefault4.default)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === 'YY') {
            var twoDigitYear = weekYear % 100;
            return (0, _indexJsDefault5.default)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === 'Yo') return localize.ordinalNumber(weekYear, {
            unit: 'year'
        });
        // Padding
        return (0, _indexJsDefault5.default)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, _indexJsDefault2.default)(date);
        // Padding
        return (0, _indexJsDefault5.default)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, _indexJsDefault5.default)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'Q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'QQ':
                return (0, _indexJsDefault5.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'Qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'QQQ':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'QQQQQ':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // 1st quarter, 2nd quarter, ...
            case 'QQQQ':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'qq':
                return (0, _indexJsDefault5.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'qqq':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'qqqqq':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // 1st quarter, 2nd quarter, ...
            case 'qqqq':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case 'M':
            case 'MM':
                return (0, _indexJsDefault6.default).M(date, token);
            // 1st, 2nd, ..., 12th
            case 'Mo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'MMM':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // J, F, ..., D
            case 'MMMMM':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // January, February, ..., December
            case 'MMMM':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case 'L':
                return String(month + 1);
            // 01, 02, ..., 12
            case 'LL':
                return (0, _indexJsDefault5.default)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case 'Lo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'LLL':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // J, F, ..., D
            case 'LLLLL':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // January, February, ..., December
            case 'LLLL':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, _indexJsDefault3.default)(date, options);
        if (token === 'wo') return localize.ordinalNumber(week, {
            unit: 'week'
        });
        return (0, _indexJsDefault5.default)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, _indexJsDefault1.default)(date);
        if (token === 'Io') return localize.ordinalNumber(isoWeek, {
            unit: 'week'
        });
        return (0, _indexJsDefault5.default)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === 'do') return localize.ordinalNumber(date.getUTCDate(), {
            unit: 'date'
        });
        return (0, _indexJsDefault6.default).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, _indexJsDefault.default)(date);
        if (token === 'Do') return localize.ordinalNumber(dayOfYear, {
            unit: 'dayOfYear'
        });
        return (0, _indexJsDefault5.default)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case 'E':
            case 'EE':
            case 'EEE':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'EEEEE':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'EEEEEE':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'EEEE':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case 'e':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'ee':
                return (0, _indexJsDefault5.default)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case 'eo':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'eee':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'eeeee':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'eeeeee':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'eeee':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case 'c':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'cc':
                return (0, _indexJsDefault5.default)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case 'co':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'ccc':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // T
            case 'ccccc':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // Tu
            case 'cccccc':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'standalone'
                });
            // Tuesday
            case 'cccc':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case 'i':
                return String(isoDayOfWeek);
            // 02
            case 'ii':
                return (0, _indexJsDefault5.default)(isoDayOfWeek, token.length);
            // 2nd
            case 'io':
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: 'day'
                });
            // Tue
            case 'iii':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'iiiii':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'iiiiii':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'iiii':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'aaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'aaaaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'aaaa':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'b':
            case 'bb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'bbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'bbbbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'bbbb':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = dayPeriodEnum.morning;
        else dayPeriodEnumValue = dayPeriodEnum.night;
        switch(token){
            case 'B':
            case 'BB':
            case 'BBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'BBBBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'BBBB':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === 'ho') {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
        }
        return (0, _indexJsDefault6.default).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === 'Ho') return localize.ordinalNumber(date.getUTCHours(), {
            unit: 'hour'
        });
        return (0, _indexJsDefault6.default).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === 'Ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, _indexJsDefault5.default)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === 'ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, _indexJsDefault5.default)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === 'mo') return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: 'minute'
        });
        return (0, _indexJsDefault6.default).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === 'so') return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: 'second'
        });
        return (0, _indexJsDefault6.default).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, _indexJsDefault6.default).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                // Hours and minutes without `:` delimiter
                return formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case 'x':
                return formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                // Hours and minutes without `:` delimiter
                return formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'zzzz':
            default:
                return 'GMT' + formatTimezone(timezoneOffset, ':');
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, _indexJsDefault5.default)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, _indexJsDefault5.default)(timestamp, token.length);
    }
};
function formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + (0, _indexJsDefault5.default)(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + (0, _indexJsDefault5.default)(Math.abs(offset) / 60, 2);
    }
    return formatTimezone(offset, dirtyDelimiter);
}
function formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = (0, _indexJsDefault5.default)(Math.floor(absOffset / 60), 2);
    var minutes = (0, _indexJsDefault5.default)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
exports.default = formatters;

},{"../../../_lib/getUTCDayOfYear/index.js":"2guqe","../../../_lib/getUTCISOWeek/index.js":"gE4Bi","../../../_lib/getUTCISOWeekYear/index.js":"bhOUL","../../../_lib/getUTCWeek/index.js":"iNdq4","../../../_lib/getUTCWeekYear/index.js":"aGFqe","../../addLeadingZeros/index.js":"yel3Y","../lightFormatters/index.js":"eelzN","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2guqe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getUTCDayOfYear;
});
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var MILLISECONDS_IN_DAY = 86400000;
function getUTCDayOfYear(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}

},{"../../toDate/index.js":"j2pWU","../requiredArgs/index.js":"a3mwq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gE4Bi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getUTCISOWeek;
});
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfUTCISOWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../startOfUTCISOWeekYear/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var MILLISECONDS_IN_WEEK = 604800000;
function getUTCISOWeek(dirtyDate) {
    (0, _indexJsDefault3.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var diff = (0, _indexJsDefault1.default)(date).getTime() - (0, _indexJsDefault2.default)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

},{"../../toDate/index.js":"j2pWU","../startOfUTCISOWeek/index.js":"bber1","../startOfUTCISOWeekYear/index.js":"jHzPM","../requiredArgs/index.js":"a3mwq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"bber1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return startOfUTCISOWeek;
});
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function startOfUTCISOWeek(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

},{"../../toDate/index.js":"j2pWU","../requiredArgs/index.js":"a3mwq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jHzPM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return startOfUTCISOWeekYear;
});
var _indexJs = require("../getUTCISOWeekYear/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfUTCISOWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function startOfUTCISOWeekYear(dirtyDate) {
    (0, _indexJsDefault2.default)(1, arguments);
    var year = (0, _indexJsDefault.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, _indexJsDefault1.default)(fourthOfJanuary);
    return date;
}

},{"../getUTCISOWeekYear/index.js":"bhOUL","../startOfUTCISOWeek/index.js":"bber1","../requiredArgs/index.js":"a3mwq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"bhOUL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getUTCISOWeekYear;
});
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../startOfUTCISOWeek/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function getUTCISOWeekYear(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, _indexJsDefault2.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, _indexJsDefault2.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

},{"../../toDate/index.js":"j2pWU","../requiredArgs/index.js":"a3mwq","../startOfUTCISOWeek/index.js":"bber1","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"iNdq4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getUTCWeek;
});
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfUTCWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../startOfUTCWeekYear/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var MILLISECONDS_IN_WEEK = 604800000;
function getUTCWeek(dirtyDate, options) {
    (0, _indexJsDefault3.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var diff = (0, _indexJsDefault1.default)(date, options).getTime() - (0, _indexJsDefault2.default)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

},{"../../toDate/index.js":"j2pWU","../startOfUTCWeek/index.js":"lFep6","../startOfUTCWeekYear/index.js":"89Bgl","../requiredArgs/index.js":"a3mwq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"lFep6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return startOfUTCWeek;
});
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../defaultOptions/index.js");
function startOfUTCWeek(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault1.default)(1, arguments);
    var defaultOptions = (0, _indexJs3.getDefaultOptions)();
    var weekStartsOn = (0, _indexJsDefault2.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

},{"../../toDate/index.js":"j2pWU","../requiredArgs/index.js":"a3mwq","../toInteger/index.js":"l2SJM","../defaultOptions/index.js":"f8LK0","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"f8LK0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDefaultOptions", function() {
    return getDefaultOptions;
});
parcelHelpers.export(exports, "setDefaultOptions", function() {
    return setDefaultOptions;
});
var defaultOptions = {};
function getDefaultOptions() {
    return defaultOptions;
}
function setDefaultOptions(newOptions) {
    defaultOptions = newOptions;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"89Bgl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return startOfUTCWeekYear;
});
var _indexJs = require("../getUTCWeekYear/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../startOfUTCWeek/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../toInteger/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../defaultOptions/index.js");
function startOfUTCWeekYear(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault1.default)(1, arguments);
    var defaultOptions = (0, _indexJs4.getDefaultOptions)();
    var firstWeekContainsDate = (0, _indexJsDefault3.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, _indexJsDefault.default)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, _indexJsDefault2.default)(firstWeek, options);
    return date;
}

},{"../getUTCWeekYear/index.js":"aGFqe","../requiredArgs/index.js":"a3mwq","../startOfUTCWeek/index.js":"lFep6","../toInteger/index.js":"l2SJM","../defaultOptions/index.js":"f8LK0","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"aGFqe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getUTCWeekYear;
});
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../startOfUTCWeek/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../toInteger/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../defaultOptions/index.js");
function getUTCWeekYear(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, _indexJs4.getDefaultOptions)();
    var firstWeekContainsDate = (0, _indexJsDefault3.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, _indexJsDefault2.default)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, _indexJsDefault2.default)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

},{"../../toDate/index.js":"j2pWU","../requiredArgs/index.js":"a3mwq","../startOfUTCWeek/index.js":"lFep6","../toInteger/index.js":"l2SJM","../defaultOptions/index.js":"f8LK0","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"yel3Y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return addLeadingZeros;
});
function addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"eelzN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../addLeadingZeros/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, _indexJsDefault.default)(token === 'yy' ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === 'M' ? String(month + 1) : (0, _indexJsDefault.default)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, _indexJsDefault.default)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return dayPeriodEnumValue.toUpperCase();
            case 'aaa':
                return dayPeriodEnumValue;
            case 'aaaaa':
                return dayPeriodEnumValue[0];
            case 'aaaa':
            default:
                return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, _indexJsDefault.default)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, _indexJsDefault.default)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, _indexJsDefault.default)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, _indexJsDefault.default)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, _indexJsDefault.default)(fractionalSeconds, token.length);
    }
};
exports.default = formatters;

},{"../../addLeadingZeros/index.js":"yel3Y","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6kxpi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'P':
            return formatLong.date({
                width: 'short'
            });
        case 'PP':
            return formatLong.date({
                width: 'medium'
            });
        case 'PPP':
            return formatLong.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return formatLong.date({
                width: 'full'
            });
    }
};
var timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'p':
            return formatLong.time({
                width: 'short'
            });
        case 'pp':
            return formatLong.time({
                width: 'medium'
            });
        case 'ppp':
            return formatLong.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return formatLong.time({
                width: 'full'
            });
    }
};
var dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case 'P':
            dateTimeFormat = formatLong.dateTime({
                width: 'short'
            });
            break;
        case 'PP':
            dateTimeFormat = formatLong.dateTime({
                width: 'medium'
            });
            break;
        case 'PPP':
            dateTimeFormat = formatLong.dateTime({
                width: 'long'
            });
            break;
        case 'PPPP':
        default:
            dateTimeFormat = formatLong.dateTime({
                width: 'full'
            });
            break;
    }
    return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
};
var longFormatters = {
    p: timeLongFormatter,
    P: dateTimeLongFormatter
};
exports.default = longFormatters;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"i5oJ5":[function(require,module,exports,__globalThis) {
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getTimezoneOffsetInMilliseconds;
});
function getTimezoneOffsetInMilliseconds(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"lJQbo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isProtectedDayOfYearToken", function() {
    return isProtectedDayOfYearToken;
});
parcelHelpers.export(exports, "isProtectedWeekYearToken", function() {
    return isProtectedWeekYearToken;
});
parcelHelpers.export(exports, "throwProtectedError", function() {
    return throwProtectedError;
});
var protectedDayOfYearTokens = [
    'D',
    'DD'
];
var protectedWeekYearTokens = [
    'YY',
    'YYYY'
];
function isProtectedDayOfYearToken(token) {
    return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
    return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
    if (token === 'YYYY') throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'YY') throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'D') throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'DD') throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1ggW0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../locale/en-US/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
exports.default = (0, _indexJsDefault.default);

},{"../../locale/en-US/index.js":"aeGc8","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"aeGc8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var locale = {
    code: 'en-US',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"1WWJs","./_lib/formatLong/index.js":"iZ19Z","./_lib/formatRelative/index.js":"1W4iA","./_lib/localize/index.js":"fwo8l","./_lib/match/index.js":"i8Zq1","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1WWJs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: '1 hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: '1 day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: '1 month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: '1 year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"iZ19Z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"xh7vF","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"xh7vF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return buildFormatLongFn;
});
function buildFormatLongFn(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1W4iA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"fwo8l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'B',
        'A'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        'Before Christ',
        'Anno Domini'
    ]
};
var quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1st quarter',
        '2nd quarter',
        '3rd quarter',
        '4th quarter'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    wide: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]
};
var dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S'
    ],
    short: [
        'Su',
        'Mo',
        'Tu',
        'We',
        'Th',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    wide: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    }
};
var formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'st';
        case 2:
            return number + 'nd';
        case 3:
            return number + 'rd';
    }
    return number + 'th';
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"5bKyZ","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5bKyZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return buildLocalizeFn;
});
function buildLocalizeFn(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
        var valuesArray;
        if (context === 'formatting' && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"i8Zq1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"iGdRV","../../../_lib/buildMatchPatternFn/index.js":"6eYoV","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"iGdRV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return buildMatchFn;
});
function buildMatchFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6eYoV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return buildMatchPatternFn;
});
function buildMatchPatternFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"h72g3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return convertToFP;
});
function convertToFP(fn, arity) {
    var a = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    if (a.length >= arity) return fn.apply(null, a.slice(0, arity).reverse());
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return convertToFP(fn, arity, a.concat(args));
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"ieaI6":[function(require,module,exports,__globalThis) {
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "daysInWeek", function() {
    return daysInWeek;
});
parcelHelpers.export(exports, "daysInYear", function() {
    return daysInYear;
});
parcelHelpers.export(exports, "maxTime", function() {
    return maxTime;
});
parcelHelpers.export(exports, "millisecondsInMinute", function() {
    return millisecondsInMinute;
});
parcelHelpers.export(exports, "millisecondsInHour", function() {
    return millisecondsInHour;
});
parcelHelpers.export(exports, "millisecondsInSecond", function() {
    return millisecondsInSecond;
});
parcelHelpers.export(exports, "minTime", function() {
    return minTime;
});
parcelHelpers.export(exports, "minutesInHour", function() {
    return minutesInHour;
});
parcelHelpers.export(exports, "monthsInQuarter", function() {
    return monthsInQuarter;
});
parcelHelpers.export(exports, "monthsInYear", function() {
    return monthsInYear;
});
parcelHelpers.export(exports, "quartersInYear", function() {
    return quartersInYear;
});
parcelHelpers.export(exports, "secondsInHour", function() {
    return secondsInHour;
});
parcelHelpers.export(exports, "secondsInMinute", function() {
    return secondsInMinute;
});
parcelHelpers.export(exports, "secondsInDay", function() {
    return secondsInDay;
});
parcelHelpers.export(exports, "secondsInWeek", function() {
    return secondsInWeek;
});
parcelHelpers.export(exports, "secondsInYear", function() {
    return secondsInYear;
});
parcelHelpers.export(exports, "secondsInMonth", function() {
    return secondsInMonth;
});
parcelHelpers.export(exports, "secondsInQuarter", function() {
    return secondsInQuarter;
});
var daysInWeek = 7;
var daysInYear = 365.2425;
var maxTime = Math.pow(10, 8) * 86400000;
var millisecondsInMinute = 60000;
var millisecondsInHour = 3600000;
var millisecondsInSecond = 1000;
var minTime = -maxTime;
var minutesInHour = 60;
var monthsInQuarter = 3;
var monthsInYear = 12;
var quartersInYear = 4;
var secondsInHour = 3600;
var secondsInMinute = 60;
var secondsInDay = secondsInHour * 24;
var secondsInWeek = secondsInDay * 7;
var secondsInYear = secondsInDay * daysInYear;
var secondsInMonth = secondsInYear / 12;
var secondsInQuarter = secondsInMonth * 3;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gzdgZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "orderHistoryListView", function() {
    return orderHistoryListView;
});
var _reselect = require("reselect");
var _orders = require("../store/state/data/orders");
var _variants = require("../store/state/data/variants");
var _std = require("@reglo/std");
var orderHistoryListView = (0, _reselect.createSelector)((0, _orders.ordersSelector), (0, _variants.variantsSelector), prepareView);
function prepareView(ordersState, variantsState) {
    if (!ordersState.entities) return null;
    return {
        items: prepareItems()
    };
    function prepareItems() {
        var orders = (0, _std.unwrap)(ordersState.entities);
        return orders.map(prepareItem);
    }
    function prepareItem(item) {
        return {
            orderId: item.id,
            number: item.number,
            amount: item.orderPrice - item.refundPrice,
            date: item.date,
            products: prepareProductLines(item.itemsLines),
            status: item.status,
            trackingLinks: prepareTrackingLinks(item.shippingTrackings)
        };
    }
    function prepareProductLines(lines) {
        return lines.map(prepareProductLine);
    }
    function prepareProductLine(line) {
        var title = prepareLineTitle(line);
        return `${line.quantity} x ${title}`;
    }
    function prepareLineTitle(line) {
        var variant = selectVariant(line.variantId);
        if (variant) return `${variant.productTitle} - ${variant.variantTitle}`;
        return line.title;
    }
    function prepareTrackingLinks(trackings) {
        if (!trackings) return [];
        return trackings.map(function(tracking) {
            return tracking.url;
        });
    }
    function selectVariant(variantId) {
        var _variantsState_entities_find;
        return (_variantsState_entities_find = variantsState.entities.find(function(variant) {
            return variant.variantId === variantId;
        })) !== null && _variantsState_entities_find !== void 0 ? _variantsState_entities_find : null;
    }
}

},{"reselect":"fb6q1","../store/state/data/orders":"4hVLS","../store/state/data/variants":"11hc8","@reglo/std":"1USo0","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"fb6q1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultMemoize", function() {
    return 0, _defaultMemoize.defaultMemoize;
});
parcelHelpers.export(exports, "defaultEqualityCheck", function() {
    return 0, _defaultMemoize.defaultEqualityCheck;
});
parcelHelpers.export(exports, "createSelectorCreator", function() {
    return createSelectorCreator;
});
parcelHelpers.export(exports, "createSelector", function() {
    return createSelector;
});
parcelHelpers.export(exports, "createStructuredSelector", function() {
    return createStructuredSelector;
});
var _defaultMemoize = require("./defaultMemoize");
function getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === 'function';
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep === 'function' ? "function " + (dep.name || 'unnamed') + "()" : typeof dep;
        }).join(', ');
        throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
    }
    return dependencies;
}
function createSelectorCreator(memoize) {
    for(var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptionsFromArgs[_key - 1] = arguments[_key];
    var createSelector = function createSelector() {
        for(var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var _recomputations = 0;
        var _lastResult; // Due to the intricacies of rest params, we can't do an optional arg after `...funcs`.
        // So, start by declaring the default value here.
        // (And yes, the words 'memoize' and 'options' appear too many times in this next sequence.)
        var directlyPassedOptions = {
            memoizeOptions: undefined
        }; // Normally, the result func or "output selector" is the last arg
        var resultFunc = funcs.pop(); // If the result func is actually an _object_, assume it's our options object
        if (typeof resultFunc === 'object') {
            directlyPassedOptions = resultFunc; // and pop the real result func off
            resultFunc = funcs.pop();
        }
        if (typeof resultFunc !== 'function') throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
         // Determine which set of options we're using. Prefer options passed directly,
        // but fall back to options given to createSelectorCreator.
        var _directlyPassedOption = directlyPassedOptions, _directlyPassedOption2 = _directlyPassedOption.memoizeOptions, memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2; // Simplifying assumption: it's unlikely that the first options arg of the provided memoizer
        // is an array. In most libs I've looked at, it's an equality function or options object.
        // Based on that, if `memoizeOptions` _is_ an array, we assume it's a full
        // user-provided array of options. Otherwise, it must be just the _first_ arg, and so
        // we wrap it in an array so we can apply it.
        var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [
            memoizeOptions
        ];
        var dependencies = getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(void 0, [
            function recomputationWrapper() {
                _recomputations++; // apply arguments instead of spreading for performance.
                return resultFunc.apply(null, arguments);
            }
        ].concat(finalMemoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
        var selector = memoize(function dependenciesChecker() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)// apply arguments instead of spreading and mutate a local list of params for performance.
            // @ts-ignore
            params.push(dependencies[i].apply(null, arguments));
             // apply arguments instead of spreading for performance.
            _lastResult = memoizedResultFunc.apply(null, params);
            return _lastResult;
        });
        Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            lastResult: function lastResult() {
                return _lastResult;
            },
            recomputations: function recomputations() {
                return _recomputations;
            },
            resetRecomputations: function resetRecomputations() {
                return _recomputations = 0;
            }
        });
        return selector;
    }; // @ts-ignore
    return createSelector;
}
var createSelector = /* #__PURE__ */ createSelectorCreator((0, _defaultMemoize.defaultMemoize));
var createStructuredSelector = function createStructuredSelector(selectors, selectorCreator) {
    if (selectorCreator === void 0) selectorCreator = createSelector;
    if (typeof selectors !== 'object') throw new Error('createStructuredSelector expects first argument to be an object ' + ("where each property is a selector, instead received a " + typeof selectors));
    var objectKeys = Object.keys(selectors);
    var resultSelector = selectorCreator(objectKeys.map(function(key) {
        return selectors[key];
    }), function() {
        for(var _len3 = arguments.length, values = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)values[_key3] = arguments[_key3];
        return values.reduce(function(composition, value, index) {
            composition[objectKeys[index]] = value;
            return composition;
        }, {});
    });
    return resultSelector;
};

},{"./defaultMemoize":"QEyKi","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"QEyKi":[function(require,module,exports,__globalThis) {
// Cache implementation based on Erik Rasmussen's `lru-memoize`:
// https://github.com/erikras/lru-memoize
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultEqualityCheck", function() {
    return defaultEqualityCheck;
});
parcelHelpers.export(exports, "createCacheKeyComparator", function() {
    return createCacheKeyComparator;
});
// defaultMemoize now supports a configurable cache size with LRU behavior,
// and optional comparison of the result value with existing values
parcelHelpers.export(exports, "defaultMemoize", function() {
    return defaultMemoize;
});
var NOT_FOUND = 'NOT_FOUND';
function createSingletonCache(equals) {
    var entry;
    return {
        get: function get(key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return NOT_FOUND;
        },
        put: function put(key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries: function getEntries() {
            return entry ? [
                entry
            ] : [];
        },
        clear: function clear() {
            entry = undefined;
        }
    };
}
function createLruCache(maxSize, equals) {
    var entries = [];
    function get(key) {
        var cacheIndex = entries.findIndex(function(entry) {
            return equals(key, entry.key);
        }); // We found a cached entry
        if (cacheIndex > -1) {
            var entry = entries[cacheIndex]; // Cached entry not at top of cache, move it to the top
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        } // No entry found in cache, return sentinel
        return NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === NOT_FOUND) {
            // TODO Is unshift slow?
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var defaultEqualityCheck = function defaultEqualityCheck(a, b) {
    return a === b;
};
function createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
         // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
        var length = prev.length;
        for(var i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function defaultMemoize(func, equalityCheckOrOptions) {
    var providedOptions = typeof equalityCheckOrOptions === 'object' ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    var _providedOptions$equa = providedOptions.equalityCheck, equalityCheck = _providedOptions$equa === void 0 ? defaultEqualityCheck : _providedOptions$equa, _providedOptions$maxS = providedOptions.maxSize, maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS, resultEqualityCheck = providedOptions.resultEqualityCheck;
    var comparator = createCacheKeyComparator(equalityCheck);
    var cache = maxSize === 1 ? createSingletonCache(comparator) : createLruCache(maxSize, comparator); // we reference arguments instead of spreading them for performance reasons
    function memoized() {
        var value = cache.get(arguments);
        if (value === NOT_FOUND) {
            // @ts-ignore
            value = func.apply(null, arguments);
            if (resultEqualityCheck) {
                var entries = cache.getEntries();
                var matchingEntry = entries.find(function(entry) {
                    return resultEqualityCheck(entry.value, value);
                });
                if (matchingEntry) value = matchingEntry.value;
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = function() {
        return cache.clear();
    };
    return memoized;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"bpfMV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "splitPriceIntegerAndCents", function() {
    return splitPriceIntegerAndCents;
});
parcelHelpers.export(exports, "formatPrice", function() {
    return formatPrice;
});
parcelHelpers.export(exports, "toCents", function() {
    return toCents;
});
function splitPriceIntegerAndCents(price) {
    return function() {
        var integer = Math.floor(price / 100);
        var cents = price % 100;
        var centsText = formatCents(cents);
        return {
            integer: integer,
            cents: cents,
            centsText: centsText
        };
    }();
    function formatCents(cents) {
        if (cents < 10) return `0${cents}`;
        return cents.toString();
    }
}
function formatPrice(price) {
    var _splitPriceIntegerAndCents = splitPriceIntegerAndCents(Math.abs(price)), integer = _splitPriceIntegerAndCents.integer, cents = _splitPriceIntegerAndCents.cents, centsText = _splitPriceIntegerAndCents.centsText;
    if (price < 0) return `-${integer},${cents} \u{20AC}`;
    return `${integer},${centsText} \u{20AC}`;
}
function toCents(price) {
    return Math.round(Number(price) * 100);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"dlTaP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "statusLabel", function() {
    return statusLabel;
});
var _order = require("../../../../app/entities/Order");
function statusLabel(status) {
    switch(status){
        case (0, _order.OrderStatus).Pending:
            return "En cours de pr\xe9paration";
        case (0, _order.OrderStatus).Cancelled:
            return "Annul\xe9e";
        case (0, _order.OrderStatus).Fulfilled:
            return "Exp\xe9di\xe9e";
    }
}

},{"../../../../app/entities/Order":"9elEf","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"9elEf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OrderStatus", function() {
    return OrderStatus;
});
var OrderStatus = /*#__PURE__*/ function(OrderStatus) {
    OrderStatus["Pending"] = "pending";
    OrderStatus["Cancelled"] = "cancelled";
    OrderStatus["Fulfilled"] = "fulfilled";
    return OrderStatus;
}({});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"9VDGr":[function(require,module,exports,__globalThis) {
/**
 * React Router DOM v6.30.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbortedDeferredError", function() {
    return 0, _reactRouter.AbortedDeferredError;
});
parcelHelpers.export(exports, "Await", function() {
    return 0, _reactRouter.Await;
});
parcelHelpers.export(exports, "MemoryRouter", function() {
    return 0, _reactRouter.MemoryRouter;
});
parcelHelpers.export(exports, "Navigate", function() {
    return 0, _reactRouter.Navigate;
});
parcelHelpers.export(exports, "NavigationType", function() {
    return 0, _reactRouter.NavigationType;
});
parcelHelpers.export(exports, "Outlet", function() {
    return 0, _reactRouter.Outlet;
});
parcelHelpers.export(exports, "Route", function() {
    return 0, _reactRouter.Route;
});
parcelHelpers.export(exports, "Router", function() {
    return 0, _reactRouter.Router;
});
parcelHelpers.export(exports, "Routes", function() {
    return 0, _reactRouter.Routes;
});
parcelHelpers.export(exports, "UNSAFE_DataRouterContext", function() {
    return 0, _reactRouter.UNSAFE_DataRouterContext;
});
parcelHelpers.export(exports, "UNSAFE_DataRouterStateContext", function() {
    return 0, _reactRouter.UNSAFE_DataRouterStateContext;
});
parcelHelpers.export(exports, "UNSAFE_LocationContext", function() {
    return 0, _reactRouter.UNSAFE_LocationContext;
});
parcelHelpers.export(exports, "UNSAFE_NavigationContext", function() {
    return 0, _reactRouter.UNSAFE_NavigationContext;
});
parcelHelpers.export(exports, "UNSAFE_RouteContext", function() {
    return 0, _reactRouter.UNSAFE_RouteContext;
});
parcelHelpers.export(exports, "UNSAFE_useRouteId", function() {
    return 0, _reactRouter.UNSAFE_useRouteId;
});
parcelHelpers.export(exports, "createMemoryRouter", function() {
    return 0, _reactRouter.createMemoryRouter;
});
parcelHelpers.export(exports, "createPath", function() {
    return 0, _reactRouter.createPath;
});
parcelHelpers.export(exports, "createRoutesFromChildren", function() {
    return 0, _reactRouter.createRoutesFromChildren;
});
parcelHelpers.export(exports, "createRoutesFromElements", function() {
    return 0, _reactRouter.createRoutesFromElements;
});
parcelHelpers.export(exports, "defer", function() {
    return 0, _reactRouter.defer;
});
parcelHelpers.export(exports, "generatePath", function() {
    return 0, _reactRouter.generatePath;
});
parcelHelpers.export(exports, "isRouteErrorResponse", function() {
    return 0, _reactRouter.isRouteErrorResponse;
});
parcelHelpers.export(exports, "json", function() {
    return 0, _reactRouter.json;
});
parcelHelpers.export(exports, "matchPath", function() {
    return 0, _reactRouter.matchPath;
});
parcelHelpers.export(exports, "matchRoutes", function() {
    return 0, _reactRouter.matchRoutes;
});
parcelHelpers.export(exports, "parsePath", function() {
    return 0, _reactRouter.parsePath;
});
parcelHelpers.export(exports, "redirect", function() {
    return 0, _reactRouter.redirect;
});
parcelHelpers.export(exports, "redirectDocument", function() {
    return 0, _reactRouter.redirectDocument;
});
parcelHelpers.export(exports, "renderMatches", function() {
    return 0, _reactRouter.renderMatches;
});
parcelHelpers.export(exports, "replace", function() {
    return 0, _reactRouter.replace;
});
parcelHelpers.export(exports, "resolvePath", function() {
    return 0, _reactRouter.resolvePath;
});
parcelHelpers.export(exports, "useActionData", function() {
    return 0, _reactRouter.useActionData;
});
parcelHelpers.export(exports, "useAsyncError", function() {
    return 0, _reactRouter.useAsyncError;
});
parcelHelpers.export(exports, "useAsyncValue", function() {
    return 0, _reactRouter.useAsyncValue;
});
parcelHelpers.export(exports, "useBlocker", function() {
    return 0, _reactRouter.useBlocker;
});
parcelHelpers.export(exports, "useHref", function() {
    return 0, _reactRouter.useHref;
});
parcelHelpers.export(exports, "useInRouterContext", function() {
    return 0, _reactRouter.useInRouterContext;
});
parcelHelpers.export(exports, "useLoaderData", function() {
    return 0, _reactRouter.useLoaderData;
});
parcelHelpers.export(exports, "useLocation", function() {
    return 0, _reactRouter.useLocation;
});
parcelHelpers.export(exports, "useMatch", function() {
    return 0, _reactRouter.useMatch;
});
parcelHelpers.export(exports, "useMatches", function() {
    return 0, _reactRouter.useMatches;
});
parcelHelpers.export(exports, "useNavigate", function() {
    return 0, _reactRouter.useNavigate;
});
parcelHelpers.export(exports, "useNavigation", function() {
    return 0, _reactRouter.useNavigation;
});
parcelHelpers.export(exports, "useNavigationType", function() {
    return 0, _reactRouter.useNavigationType;
});
parcelHelpers.export(exports, "useOutlet", function() {
    return 0, _reactRouter.useOutlet;
});
parcelHelpers.export(exports, "useOutletContext", function() {
    return 0, _reactRouter.useOutletContext;
});
parcelHelpers.export(exports, "useParams", function() {
    return 0, _reactRouter.useParams;
});
parcelHelpers.export(exports, "useResolvedPath", function() {
    return 0, _reactRouter.useResolvedPath;
});
parcelHelpers.export(exports, "useRevalidator", function() {
    return 0, _reactRouter.useRevalidator;
});
parcelHelpers.export(exports, "useRouteError", function() {
    return 0, _reactRouter.useRouteError;
});
parcelHelpers.export(exports, "useRouteLoaderData", function() {
    return 0, _reactRouter.useRouteLoaderData;
});
parcelHelpers.export(exports, "useRoutes", function() {
    return 0, _reactRouter.useRoutes;
});
parcelHelpers.export(exports, "UNSAFE_ErrorResponseImpl", function() {
    return 0, _router.UNSAFE_ErrorResponseImpl;
});
//#endregion
parcelHelpers.export(exports, "BrowserRouter", function() {
    return BrowserRouter;
});
parcelHelpers.export(exports, "Form", function() {
    return Form;
});
parcelHelpers.export(exports, "HashRouter", function() {
    return HashRouter;
});
parcelHelpers.export(exports, "Link", function() {
    return Link;
});
parcelHelpers.export(exports, "NavLink", function() {
    return NavLink;
});
parcelHelpers.export(exports, "RouterProvider", function() {
    return RouterProvider;
});
parcelHelpers.export(exports, "ScrollRestoration", function() {
    return ScrollRestoration;
});
parcelHelpers.export(exports, "UNSAFE_FetchersContext", function() {
    return FetchersContext;
});
parcelHelpers.export(exports, "UNSAFE_ViewTransitionContext", function() {
    return ViewTransitionContext;
});
parcelHelpers.export(exports, "UNSAFE_useScrollRestoration", function() {
    return useScrollRestoration;
});
parcelHelpers.export(exports, "createBrowserRouter", function() {
    return createBrowserRouter;
});
parcelHelpers.export(exports, "createHashRouter", function() {
    return createHashRouter;
});
parcelHelpers.export(exports, "createSearchParams", function() {
    return createSearchParams;
});
parcelHelpers.export(exports, "unstable_HistoryRouter", function() {
    return HistoryRouter;
});
parcelHelpers.export(exports, "unstable_usePrompt", function() {
    return usePrompt;
});
parcelHelpers.export(exports, "useBeforeUnload", function() {
    return useBeforeUnload;
});
parcelHelpers.export(exports, "useFetcher", function() {
    return useFetcher;
});
parcelHelpers.export(exports, "useFetchers", function() {
    return useFetchers;
});
parcelHelpers.export(exports, "useFormAction", function() {
    return useFormAction;
});
parcelHelpers.export(exports, "useLinkClickHandler", function() {
    return useLinkClickHandler;
});
parcelHelpers.export(exports, "useSearchParams", function() {
    return useSearchParams;
});
parcelHelpers.export(exports, "useSubmit", function() {
    return useSubmit;
});
parcelHelpers.export(exports, "useViewTransitionState", function() {
    return useViewTransitionState;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _react = require("react");
var _reactDom = require("react-dom");
var _reactRouter = require("react-router");
var _router = require("@remix-run/router");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var defaultMethod = "get";
var defaultEncType = "application/x-www-form-urlencoded";
function isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function isButtonElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function isFormElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function isInputElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function createSearchParams(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce(function(memo, key) {
        var value = init[key];
        return memo.concat(Array.isArray(value) ? value.map(function(v) {
            return [
                key,
                v
            ];
        }) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    var searchParams = createSearchParams(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach(function(_, key) {
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach(function(value) {
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
var _formDataSupportsSubmitter = null;
function isFormDataSubmitterSupported() {
    if (_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        _formDataSupportsSubmitter = false;
    } catch (e) {
        _formDataSupportsSubmitter = true;
    }
    return _formDataSupportsSubmitter;
}
var supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function getFormEncType(encType) {
    if (encType != null && !supportedFormEncTypes.has(encType)) {
        (0, _router.UNSAFE_warning)(false, "\"" + encType + "\" is not a valid `encType` for `<Form>`/`<fetcher.Form>` " + ("and will default to \"" + defaultEncType + "\""));
        return null;
    }
    return encType;
}
function getFormSubmissionInfo(target, basename) {
    var method;
    var action;
    var encType;
    var formData;
    var body;
    if (isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        var attr = target.getAttribute("action");
        action = attr ? (0, _router.stripBasename)(attr, basename) : null;
        method = target.getAttribute("method") || defaultMethod;
        encType = getFormEncType(target.getAttribute("enctype")) || defaultEncType;
        formData = new FormData(target);
    } else if (isButtonElement(target) || isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        var form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        var attr1 = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr1 ? (0, _router.stripBasename)(attr1, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || defaultMethod;
        encType = getFormEncType(target.getAttribute("formenctype")) || getFormEncType(form.getAttribute("enctype")) || defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!isFormDataSubmitterSupported()) {
            var name = target.name, type = target.type, value = target.value;
            if (type === "image") {
                var prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if (isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = defaultMethod;
        action = null;
        encType = defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
var _excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], _excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], _excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
var REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function createBrowserRouter(routes, opts) {
    return (0, _router.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: _extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, _router.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, _reactRouter.UNSAFE_mapRouteProperties),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function createHashRouter(routes, opts) {
    return (0, _router.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: _extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, _router.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, _reactRouter.UNSAFE_mapRouteProperties),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function parseHydrationData() {
    var _window;
    var state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = _extends({}, state, {
        errors: deserializeErrors(state.errors)
    });
    return state;
}
function deserializeErrors(errors) {
    if (!errors) return null;
    var entries = Object.entries(errors);
    var serialized = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, _slicedToArray._)(_step.value, 2), key = _step_value[0], val = _step_value[1];
            // Hey you!  If you change this, please change the corresponding logic in
            // serializeErrors in react-router-dom/server.tsx :)
            if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, _router.UNSAFE_ErrorResponseImpl)(val.status, val.statusText, val.data, val.internal === true);
            else if (val && val.__type === "Error") {
                // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
                if (val.__subType) {
                    var ErrorConstructor = window[val.__subType];
                    if (typeof ErrorConstructor === "function") try {
                        // @ts-expect-error
                        var error = new ErrorConstructor(val.message);
                        // Wipe away the client-side stack trace.  Nothing to fill it in with
                        // because we don't serialize SSR stack traces for security reasons
                        error.stack = "";
                        serialized[key] = error;
                    } catch (e) {
                    // no-op - fall through and create a normal Error
                    }
                }
                if (serialized[key] == null) {
                    var error1 = new Error(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error1.stack = "";
                    serialized[key] = error1;
                }
            } else serialized[key] = val;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return serialized;
}
var ViewTransitionContext = /*#__PURE__*/ _react.createContext({
    isTransitioning: false
});
ViewTransitionContext.displayName = "ViewTransition";
var FetchersContext = /*#__PURE__*/ _react.createContext(new Map());
FetchersContext.displayName = "Fetchers";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ var START_TRANSITION = "startTransition";
var startTransitionImpl = _react[START_TRANSITION];
var FLUSH_SYNC = "flushSync";
var flushSyncImpl = _reactDom[FLUSH_SYNC];
var USE_ID = "useId";
var useIdImpl = _react[USE_ID];
function startTransitionSafe(cb) {
    if (startTransitionImpl) startTransitionImpl(cb);
    else cb();
}
function flushSyncSafe(cb) {
    if (flushSyncImpl) flushSyncImpl(cb);
    else cb();
}
var Deferred = function Deferred() {
    "use strict";
    var _this = this;
    (0, _classCallCheck._)(this, Deferred);
    this.status = "pending";
    this.promise = new Promise(function(resolve, reject) {
        _this.resolve = function(value) {
            if (_this.status === "pending") {
                _this.status = "resolved";
                resolve(value);
            }
        };
        _this.reject = function(reason) {
            if (_this.status === "pending") {
                _this.status = "rejected";
                reject(reason);
            }
        };
    });
};
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function RouterProvider(_ref) {
    var fallbackElement = _ref.fallbackElement, router = _ref.router, future = _ref.future;
    var _React_useState = (0, _slicedToArray._)(_react.useState(router.state), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var _React_useState1 = (0, _slicedToArray._)(_react.useState(), 2), pendingState = _React_useState1[0], setPendingState = _React_useState1[1];
    var _React_useState2 = (0, _slicedToArray._)(_react.useState({
        isTransitioning: false
    }), 2), vtContext = _React_useState2[0], setVtContext = _React_useState2[1];
    var _React_useState3 = (0, _slicedToArray._)(_react.useState(), 2), renderDfd = _React_useState3[0], setRenderDfd = _React_useState3[1];
    var _React_useState4 = (0, _slicedToArray._)(_react.useState(), 2), transition = _React_useState4[0], setTransition = _React_useState4[1];
    var _React_useState5 = (0, _slicedToArray._)(_react.useState(), 2), interruption = _React_useState5[0], setInterruption = _React_useState5[1];
    var fetcherData = _react.useRef(new Map());
    var v7_startTransition = (future || {}).v7_startTransition;
    var optInStartTransition = _react.useCallback(function(cb) {
        if (v7_startTransition) startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    var setState = _react.useCallback(function(newState, _ref2) {
        var deletedFetchers = _ref2.deletedFetchers, flushSync = _ref2.flushSync, viewTransitionOpts = _ref2.viewTransitionOpts;
        newState.fetchers.forEach(function(fetcher, key) {
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach(function(key) {
            return fetcherData.current.delete(key);
        });
        var isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) flushSyncSafe(function() {
                return setStateImpl(newState);
            });
            else optInStartTransition(function() {
                return setStateImpl(newState);
            });
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            flushSyncSafe(function() {
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            var t = router.window.document.startViewTransition(function() {
                flushSyncSafe(function() {
                    return setStateImpl(newState);
                });
            });
            // Clean up after the animation completes
            t.finished.finally(function() {
                flushSyncSafe(function() {
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            flushSyncSafe(function() {
                return setTransition(t);
            });
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    _react.useLayoutEffect(function() {
        return router.subscribe(setState);
    }, [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    _react.useEffect(function() {
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    _react.useEffect(function() {
        if (renderDfd && pendingState && router.window) {
            var newState = pendingState;
            var renderPromise = renderDfd.promise;
            var transition = router.window.document.startViewTransition(/*#__PURE__*/ (0, _asyncToGenerator._)(function() {
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            optInStartTransition(function() {
                                return setStateImpl(newState);
                            });
                            return [
                                4,
                                renderPromise
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            }));
            transition.finished.finally(function() {
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    _react.useEffect(function() {
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    _react.useEffect(function() {
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    _react.useEffect(function() {
        (0, _router.UNSAFE_warning)(fallbackElement == null || !router.future.v7_partialHydration, "`<RouterProvider fallbackElement>` is deprecated when using `v7_partialHydration`, use a `HydrateFallback` component instead");
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var navigator = _react.useMemo(function() {
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: function(n) {
                return router.navigate(n);
            },
            push: function(to, state, opts) {
                return router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            },
            replace: function(to, state, opts) {
                return router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            }
        };
    }, [
        router
    ]);
    var basename = router.basename || "/";
    var dataRouterContext = _react.useMemo(function() {
        return {
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        };
    }, [
        router,
        navigator,
        basename
    ]);
    var routerFuture = _react.useMemo(function() {
        return {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        };
    }, [
        router.future.v7_relativeSplatPath
    ]);
    _react.useEffect(function() {
        return (0, _reactRouter.UNSAFE_logV6DeprecationWarnings)(future, router.future);
    }, [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement((0, _reactRouter.UNSAFE_DataRouterContext).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ _react.createElement((0, _reactRouter.UNSAFE_DataRouterStateContext).Provider, {
        value: state
    }, /*#__PURE__*/ _react.createElement(FetchersContext.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ _react.createElement(ViewTransitionContext.Provider, {
        value: vtContext
    }, /*#__PURE__*/ _react.createElement((0, _reactRouter.Router), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ _react.createElement(MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
var MemoizedDataRoutes = /*#__PURE__*/ _react.memo(DataRoutes);
function DataRoutes(_ref3) {
    var routes = _ref3.routes, future = _ref3.future, state = _ref3.state;
    return (0, _reactRouter.UNSAFE_useRoutesImpl)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function BrowserRouter(_ref4) {
    var basename = _ref4.basename, children = _ref4.children, future = _ref4.future, _$window = _ref4.window;
    var historyRef = _react.useRef();
    if (historyRef.current == null) historyRef.current = (0, _router.createBrowserHistory)({
        window: _$window,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, _slicedToArray._)(_react.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = _react.useCallback(function(newState) {
        v7_startTransition && startTransitionImpl ? startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    _react.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    _react.useEffect(function() {
        return (0, _reactRouter.UNSAFE_logV6DeprecationWarnings)(future);
    }, [
        future
    ]);
    return /*#__PURE__*/ _react.createElement((0, _reactRouter.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function HashRouter(_ref5) {
    var basename = _ref5.basename, children = _ref5.children, future = _ref5.future, _$window = _ref5.window;
    var historyRef = _react.useRef();
    if (historyRef.current == null) historyRef.current = (0, _router.createHashHistory)({
        window: _$window,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, _slicedToArray._)(_react.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = _react.useCallback(function(newState) {
        v7_startTransition && startTransitionImpl ? startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    _react.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    _react.useEffect(function() {
        return (0, _reactRouter.UNSAFE_logV6DeprecationWarnings)(future);
    }, [
        future
    ]);
    return /*#__PURE__*/ _react.createElement((0, _reactRouter.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function HistoryRouter(_ref6) {
    var basename = _ref6.basename, children = _ref6.children, future = _ref6.future, history = _ref6.history;
    var _React_useState = (0, _slicedToArray._)(_react.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = _react.useCallback(function(newState) {
        v7_startTransition && startTransitionImpl ? startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    _react.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    _react.useEffect(function() {
        return (0, _reactRouter.UNSAFE_logV6DeprecationWarnings)(future);
    }, [
        future
    ]);
    return /*#__PURE__*/ _react.createElement((0, _reactRouter.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
HistoryRouter.displayName = "unstable_HistoryRouter";
var isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
var ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ var Link = /*#__PURE__*/ _react.forwardRef(function LinkWithRef(_ref7, ref) {
    var onClick = _ref7.onClick, relative = _ref7.relative, reloadDocument = _ref7.reloadDocument, replace = _ref7.replace, state = _ref7.state, target = _ref7.target, to = _ref7.to, preventScrollReset = _ref7.preventScrollReset, viewTransition = _ref7.viewTransition, rest = _objectWithoutPropertiesLoose(_ref7, _excluded);
    var basename = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext)).basename;
    // Rendered into <a href> for absolute URLs
    var absoluteHref;
    var isExternal = false;
    if (typeof to === "string" && ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if (isBrowser) try {
            var currentUrl = new URL(window.location.href);
            var targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            var path = (0, _router.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {
            // We can't do external URL detection without a valid URL
            (0, _router.UNSAFE_warning)(false, "<Link to=\"" + to + "\"> contains an invalid URL which will probably break " + "when clicked - please update to a valid URL path.");
        }
    }
    // Rendered into <a href> for relative URLs
    var href = (0, _reactRouter.useHref)(to, {
        relative: relative
    });
    var internalOnClick = useLinkClickHandler(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    _react.createElement("a", _extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
Link.displayName = "Link";
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ var NavLink = /*#__PURE__*/ _react.forwardRef(function NavLinkWithRef(_ref8, ref) {
    var tmp = _ref8["aria-current"], ariaCurrentProp = tmp === void 0 ? "page" : tmp, _ref8_caseSensitive = _ref8.caseSensitive, caseSensitive = _ref8_caseSensitive === void 0 ? false : _ref8_caseSensitive, tmp1 = _ref8.className, classNameProp = tmp1 === void 0 ? "" : tmp1, _ref8_end = _ref8.end, end = _ref8_end === void 0 ? false : _ref8_end, styleProp = _ref8.style, to = _ref8.to, viewTransition = _ref8.viewTransition, children = _ref8.children, rest = _objectWithoutPropertiesLoose(_ref8, _excluded2);
    var path = (0, _reactRouter.useResolvedPath)(to, {
        relative: rest.relative
    });
    var location = (0, _reactRouter.useLocation)();
    var routerState = _react.useContext((0, _reactRouter.UNSAFE_DataRouterStateContext));
    var _React_useContext = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext)), navigator = _React_useContext.navigator, basename = _React_useContext.basename;
    var isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useViewTransitionState(path) && viewTransition === true;
    var toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    var locationPathname = location.pathname;
    var nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, _router.stripBasename)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    var endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    var isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    var isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    var renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    var ariaCurrent = isActive ? ariaCurrentProp : undefined;
    var className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    var style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ _react.createElement(Link, _extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
NavLink.displayName = "NavLink";
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ var Form = /*#__PURE__*/ _react.forwardRef(function(_ref9, forwardedRef) {
    var fetcherKey = _ref9.fetcherKey, navigate = _ref9.navigate, reloadDocument = _ref9.reloadDocument, replace = _ref9.replace, state = _ref9.state, _ref9_method = _ref9.method, method = _ref9_method === void 0 ? defaultMethod : _ref9_method, action = _ref9.action, onSubmit = _ref9.onSubmit, relative = _ref9.relative, preventScrollReset = _ref9.preventScrollReset, viewTransition = _ref9.viewTransition, props = _objectWithoutPropertiesLoose(_ref9, _excluded3);
    var submit = useSubmit();
    var formAction = useFormAction(action, {
        relative: relative
    });
    var formMethod = method.toLowerCase() === "get" ? "get" : "post";
    var submitHandler = function(event) {
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        var submitter = event.nativeEvent.submitter;
        var submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ _react.createElement("form", _extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
Form.displayName = "Form";
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function ScrollRestoration(_ref10) {
    var getKey = _ref10.getKey, storageKey = _ref10.storageKey;
    useScrollRestoration({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
ScrollRestoration.displayName = "ScrollRestoration";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})(DataRouterHook || (DataRouterHook = {}));
var DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})(DataRouterStateHook || (DataRouterStateHook = {}));
// Internal hooks
function getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function useDataRouterContext(hookName) {
    var ctx = _react.useContext((0, _reactRouter.UNSAFE_DataRouterContext));
    !ctx && (0, _router.UNSAFE_invariant)(false, getDataRouterConsoleError(hookName));
    return ctx;
}
function useDataRouterState(hookName) {
    var state = _react.useContext((0, _reactRouter.UNSAFE_DataRouterStateContext));
    !state && (0, _router.UNSAFE_invariant)(false, getDataRouterConsoleError(hookName));
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function useLinkClickHandler(to, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, target = _ref.target, replaceProp = _ref.replace, state = _ref.state, preventScrollReset = _ref.preventScrollReset, relative = _ref.relative, viewTransition = _ref.viewTransition;
    var navigate = (0, _reactRouter.useNavigate)();
    var location = (0, _reactRouter.useLocation)();
    var path = (0, _reactRouter.useResolvedPath)(to, {
        relative: relative
    });
    return _react.useCallback(function(event) {
        if (shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            var replace = replaceProp !== undefined ? replaceProp : (0, _reactRouter.createPath)(location) === (0, _reactRouter.createPath)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function useSearchParams(defaultInit) {
    (0, _router.UNSAFE_warning)(typeof URLSearchParams !== "undefined", "You cannot use the `useSearchParams` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.");
    var defaultSearchParamsRef = _react.useRef(createSearchParams(defaultInit));
    var hasSetSearchParamsRef = _react.useRef(false);
    var location = (0, _reactRouter.useLocation)();
    var searchParams = _react.useMemo(function() {
        return(// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current));
    }, [
        location.search
    ]);
    var navigate = (0, _reactRouter.useNavigate)();
    var setSearchParams = _react.useCallback(function(nextInit, navigateOptions) {
        var newSearchParams = createSearchParams(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
var fetcherId = 0;
var getUniqueFetcherId = function() {
    return "__" + String(++fetcherId) + "__";
};
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function useSubmit() {
    var router = useDataRouterContext(DataRouterHook.UseSubmit).router;
    var basename = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext)).basename;
    var currentRouteId = (0, _reactRouter.UNSAFE_useRouteId)();
    return _react.useCallback(function(target, options) {
        if (options === void 0) options = {};
        validateClientSideSubmission();
        var _getFormSubmissionInfo = getFormSubmissionInfo(target, basename), action = _getFormSubmissionInfo.action, method = _getFormSubmissionInfo.method, encType = _getFormSubmissionInfo.encType, formData = _getFormSubmissionInfo.formData, body = _getFormSubmissionInfo.body;
        if (options.navigate === false) {
            var key = options.fetcherKey || getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function useFormAction(action, _temp2) {
    var relative = (_temp2 === void 0 ? {} : _temp2).relative;
    var basename = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext)).basename;
    var routeContext = _react.useContext((0, _reactRouter.UNSAFE_RouteContext));
    !routeContext && (0, _router.UNSAFE_invariant)(false, "useFormAction must be used inside a RouteContext");
    var _routeContext_matches_slice = (0, _slicedToArray._)(routeContext.matches.slice(-1), 1), match = _routeContext_matches_slice[0];
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    var path = _extends({}, (0, _reactRouter.useResolvedPath)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    var location = (0, _reactRouter.useLocation)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        var params = new URLSearchParams(path.search);
        var indexValues = params.getAll("index");
        var hasNakedIndexParam = indexValues.some(function(v) {
            return v === "";
        });
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter(function(v) {
                return v;
            }).forEach(function(v) {
                return params.append("index", v);
            });
            var qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, _router.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, _reactRouter.createPath)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function useFetcher(_temp3) {
    var _route$matches;
    var key = (_temp3 === void 0 ? {} : _temp3).key;
    var router = useDataRouterContext(DataRouterHook.UseFetcher).router;
    var state = useDataRouterState(DataRouterStateHook.UseFetcher);
    var fetcherData = _react.useContext(FetchersContext);
    var route = _react.useContext((0, _reactRouter.UNSAFE_RouteContext));
    var routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, _router.UNSAFE_invariant)(false, "useFetcher must be used inside a FetchersContext");
    !route && (0, _router.UNSAFE_invariant)(false, "useFetcher must be used inside a RouteContext");
    !(routeId != null) && (0, _router.UNSAFE_invariant)(false, "useFetcher can only be used on routes that contain a unique \"id\"");
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var defaultKey = useIdImpl ? useIdImpl() : "";
    var _React_useState = (0, _slicedToArray._)(_react.useState(key || defaultKey), 2), fetcherKey = _React_useState[0], setFetcherKey = _React_useState[1];
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey(getUniqueFetcherId());
    // Registration/cleanup
    _react.useEffect(function() {
        router.getFetcher(fetcherKey);
        return function() {
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    var load = _react.useCallback(function(href, opts) {
        !routeId && (0, _router.UNSAFE_invariant)(false, "No routeId available for fetcher.load()");
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    var submitImpl = useSubmit();
    var submit = _react.useCallback(function(target, opts) {
        submitImpl(target, _extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    var FetcherForm = _react.useMemo(function() {
        var FetcherForm = /*#__PURE__*/ _react.forwardRef(function(props, ref) {
            return /*#__PURE__*/ _react.createElement(Form, _extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        FetcherForm.displayName = "fetcher.Form";
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    var fetcher = state.fetchers.get(fetcherKey) || (0, _router.IDLE_FETCHER);
    var data = fetcherData.get(fetcherKey);
    var fetcherWithComponents = _react.useMemo(function() {
        return _extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        });
    }, [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function useFetchers() {
    var state = useDataRouterState(DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map(function(_ref11) {
        var _$_ref11 = (0, _slicedToArray._)(_ref11, 2), key = _$_ref11[0], fetcher = _$_ref11[1];
        return _extends({}, fetcher, {
            key: key
        });
    });
}
var SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function useScrollRestoration(_temp4) {
    var _ref = _temp4 === void 0 ? {} : _temp4, getKey = _ref.getKey, storageKey = _ref.storageKey;
    var router = useDataRouterContext(DataRouterHook.UseScrollRestoration).router;
    var _useDataRouterState = useDataRouterState(DataRouterStateHook.UseScrollRestoration), restoreScrollPosition = _useDataRouterState.restoreScrollPosition, preventScrollReset = _useDataRouterState.preventScrollReset;
    var basename = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext)).basename;
    var location = (0, _reactRouter.useLocation)();
    var matches = (0, _reactRouter.useMatches)();
    var navigation = (0, _reactRouter.useNavigation)();
    // Trigger manual scroll restoration while we're active
    _react.useEffect(function() {
        window.history.scrollRestoration = "manual";
        return function() {
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    usePageHide(_react.useCallback(function() {
        if (navigation.state === "idle") {
            var key = (getKey ? getKey(location, matches) : null) || location.key;
            savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify(savedScrollPositions));
        } catch (error) {
            (0, _router.UNSAFE_warning)(false, "Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (" + error + ").");
        }
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        _react.useLayoutEffect(function() {
            try {
                var sessionPositions = sessionStorage.getItem(storageKey || SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        _react.useLayoutEffect(function() {
            var getKeyWithoutBasename = getKey && basename !== "/" ? function(location, matches) {
                return getKey(_extends({}, location, {
                    pathname: (0, _router.stripBasename)(location.pathname, basename) || location.pathname
                }), matches);
            } : getKey;
            var disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration(savedScrollPositions, function() {
                return window.scrollY;
            }, getKeyWithoutBasename);
            return function() {
                return disableScrollRestoration && disableScrollRestoration();
            };
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        _react.useLayoutEffect(function() {
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                var el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function useBeforeUnload(callback, options) {
    var capture = (options || {}).capture;
    _react.useEffect(function() {
        var opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return function() {
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function usePageHide(callback, options) {
    var capture = (options || {}).capture;
    _react.useEffect(function() {
        var opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return function() {
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function usePrompt(_ref12) {
    var when = _ref12.when, message = _ref12.message;
    var blocker = (0, _reactRouter.useBlocker)(when);
    _react.useEffect(function() {
        if (blocker.state === "blocked") {
            var proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    _react.useEffect(function() {
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function useViewTransitionState(to, opts) {
    if (opts === void 0) opts = {};
    var vtContext = _react.useContext(ViewTransitionContext);
    !(vtContext != null) && (0, _router.UNSAFE_invariant)(false, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    var basename = useDataRouterContext(DataRouterHook.useViewTransitionState).basename;
    var path = (0, _reactRouter.useResolvedPath)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    var currentPath = (0, _router.stripBasename)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    var nextPath = (0, _router.stripBasename)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, _router.matchPath)(path.pathname, nextPath) != null || (0, _router.matchPath)(path.pathname, currentPath) != null;
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_sliced_to_array":"ha6sq","@swc/helpers/_/_ts_generator":"f2hGH","react":"c8CN1","react-dom":"kFYAC","react-router":"cuhma","@remix-run/router":"2coNK","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"cuhma":[function(require,module,exports,__globalThis) {
/**
 * React Router v6.30.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbortedDeferredError", function() {
    return 0, _router.AbortedDeferredError;
});
parcelHelpers.export(exports, "NavigationType", function() {
    return 0, _router.Action;
});
parcelHelpers.export(exports, "createPath", function() {
    return 0, _router.createPath;
});
parcelHelpers.export(exports, "defer", function() {
    return 0, _router.defer;
});
parcelHelpers.export(exports, "generatePath", function() {
    return 0, _router.generatePath;
});
parcelHelpers.export(exports, "isRouteErrorResponse", function() {
    return 0, _router.isRouteErrorResponse;
});
parcelHelpers.export(exports, "json", function() {
    return 0, _router.json;
});
parcelHelpers.export(exports, "matchPath", function() {
    return 0, _router.matchPath;
});
parcelHelpers.export(exports, "matchRoutes", function() {
    return 0, _router.matchRoutes;
});
parcelHelpers.export(exports, "parsePath", function() {
    return 0, _router.parsePath;
});
parcelHelpers.export(exports, "redirect", function() {
    return 0, _router.redirect;
});
parcelHelpers.export(exports, "redirectDocument", function() {
    return 0, _router.redirectDocument;
});
parcelHelpers.export(exports, "replace", function() {
    return 0, _router.replace;
});
parcelHelpers.export(exports, "resolvePath", function() {
    return 0, _router.resolvePath;
});
parcelHelpers.export(exports, "Await", function() {
    return Await;
});
parcelHelpers.export(exports, "MemoryRouter", function() {
    return MemoryRouter;
});
parcelHelpers.export(exports, "Navigate", function() {
    return Navigate;
});
parcelHelpers.export(exports, "Outlet", function() {
    return Outlet;
});
parcelHelpers.export(exports, "Route", function() {
    return Route;
});
parcelHelpers.export(exports, "Router", function() {
    return Router;
});
parcelHelpers.export(exports, "RouterProvider", function() {
    return RouterProvider;
});
parcelHelpers.export(exports, "Routes", function() {
    return Routes;
});
parcelHelpers.export(exports, "UNSAFE_DataRouterContext", function() {
    return DataRouterContext;
});
parcelHelpers.export(exports, "UNSAFE_DataRouterStateContext", function() {
    return DataRouterStateContext;
});
parcelHelpers.export(exports, "UNSAFE_LocationContext", function() {
    return LocationContext;
});
parcelHelpers.export(exports, "UNSAFE_NavigationContext", function() {
    return NavigationContext;
});
parcelHelpers.export(exports, "UNSAFE_RouteContext", function() {
    return RouteContext;
});
parcelHelpers.export(exports, "UNSAFE_logV6DeprecationWarnings", function() {
    return logV6DeprecationWarnings;
});
parcelHelpers.export(exports, "UNSAFE_mapRouteProperties", function() {
    return mapRouteProperties;
});
parcelHelpers.export(exports, "UNSAFE_useRouteId", function() {
    return useRouteId;
});
parcelHelpers.export(exports, "UNSAFE_useRoutesImpl", function() {
    return useRoutesImpl;
});
parcelHelpers.export(exports, "createMemoryRouter", function() {
    return createMemoryRouter;
});
parcelHelpers.export(exports, "createRoutesFromChildren", function() {
    return createRoutesFromChildren;
});
parcelHelpers.export(exports, "createRoutesFromElements", function() {
    return createRoutesFromChildren;
});
parcelHelpers.export(exports, "renderMatches", function() {
    return renderMatches;
});
parcelHelpers.export(exports, "useActionData", function() {
    return useActionData;
});
parcelHelpers.export(exports, "useAsyncError", function() {
    return useAsyncError;
});
parcelHelpers.export(exports, "useAsyncValue", function() {
    return useAsyncValue;
});
parcelHelpers.export(exports, "useBlocker", function() {
    return useBlocker;
});
parcelHelpers.export(exports, "useHref", function() {
    return useHref;
});
parcelHelpers.export(exports, "useInRouterContext", function() {
    return useInRouterContext;
});
parcelHelpers.export(exports, "useLoaderData", function() {
    return useLoaderData;
});
parcelHelpers.export(exports, "useLocation", function() {
    return useLocation;
});
parcelHelpers.export(exports, "useMatch", function() {
    return useMatch;
});
parcelHelpers.export(exports, "useMatches", function() {
    return useMatches;
});
parcelHelpers.export(exports, "useNavigate", function() {
    return useNavigate;
});
parcelHelpers.export(exports, "useNavigation", function() {
    return useNavigation;
});
parcelHelpers.export(exports, "useNavigationType", function() {
    return useNavigationType;
});
parcelHelpers.export(exports, "useOutlet", function() {
    return useOutlet;
});
parcelHelpers.export(exports, "useOutletContext", function() {
    return useOutletContext;
});
parcelHelpers.export(exports, "useParams", function() {
    return useParams;
});
parcelHelpers.export(exports, "useResolvedPath", function() {
    return useResolvedPath;
});
parcelHelpers.export(exports, "useRevalidator", function() {
    return useRevalidator;
});
parcelHelpers.export(exports, "useRouteError", function() {
    return useRouteError;
});
parcelHelpers.export(exports, "useRouteLoaderData", function() {
    return useRouteLoaderData;
});
parcelHelpers.export(exports, "useRoutes", function() {
    return useRoutes;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _react = require("react");
var _router = require("@remix-run/router");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
var DataRouterContext = /*#__PURE__*/ _react.createContext(null);
DataRouterContext.displayName = "DataRouter";
var DataRouterStateContext = /*#__PURE__*/ _react.createContext(null);
DataRouterStateContext.displayName = "DataRouterState";
var AwaitContext = /*#__PURE__*/ _react.createContext(null);
AwaitContext.displayName = "Await";
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ var NavigationContext = /*#__PURE__*/ _react.createContext(null);
NavigationContext.displayName = "Navigation";
var LocationContext = /*#__PURE__*/ _react.createContext(null);
LocationContext.displayName = "Location";
var RouteContext = /*#__PURE__*/ _react.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
RouteContext.displayName = "Route";
var RouteErrorContext = /*#__PURE__*/ _react.createContext(null);
RouteErrorContext.displayName = "RouteError";
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function useHref(to, _temp) {
    var relative = (_temp === void 0 ? {} : _temp).relative;
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false, // router loaded. We can help them understand how to avoid that.
    "useHref() may be used only in the context of a <Router> component.");
    var _React_useContext = _react.useContext(NavigationContext), basename = _React_useContext.basename, navigator = _React_useContext.navigator;
    var _useResolvedPath = useResolvedPath(to, {
        relative: relative
    }), hash = _useResolvedPath.hash, pathname = _useResolvedPath.pathname, search = _useResolvedPath.search;
    var joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, _router.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function useInRouterContext() {
    return _react.useContext(LocationContext) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function useLocation() {
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false, // router loaded. We can help them understand how to avoid that.
    "useLocation() may be used only in the context of a <Router> component.");
    return _react.useContext(LocationContext).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function useNavigationType() {
    return _react.useContext(LocationContext).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function useMatch(pattern) {
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false, // router loaded. We can help them understand how to avoid that.
    "useMatch() may be used only in the context of a <Router> component.");
    var pathname = useLocation().pathname;
    return _react.useMemo(function() {
        return (0, _router.matchPath)(pattern, (0, _router.UNSAFE_decodePath)(pathname));
    }, [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ var navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function useIsomorphicLayoutEffect(cb) {
    var isStatic = _react.useContext(NavigationContext).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    _react.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function useNavigate() {
    var isDataRoute = _react.useContext(RouteContext).isDataRoute;
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? useNavigateStable() : useNavigateUnstable();
}
function useNavigateUnstable() {
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false, // router loaded. We can help them understand how to avoid that.
    "useNavigate() may be used only in the context of a <Router> component.");
    var dataRouterContext = _react.useContext(DataRouterContext);
    var _React_useContext = _react.useContext(NavigationContext), basename = _React_useContext.basename, future = _React_useContext.future, navigator = _React_useContext.navigator;
    var matches = _react.useContext(RouteContext).matches;
    var _useLocation = useLocation(), locationPathname = _useLocation.pathname;
    var routePathnamesJson = JSON.stringify((0, _router.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    var activeRef = _react.useRef(false);
    useIsomorphicLayoutEffect(function() {
        activeRef.current = true;
    });
    var navigate = _react.useCallback(function(to, options) {
        if (options === void 0) options = {};
        (0, _router.UNSAFE_warning)(activeRef.current, navigateEffectWarning);
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        var path = (0, _router.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, _router.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var OutletContext = /*#__PURE__*/ _react.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function useOutletContext() {
    return _react.useContext(OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function useOutlet(context) {
    var outlet = _react.useContext(RouteContext).outlet;
    if (outlet) return /*#__PURE__*/ _react.createElement(OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function useParams() {
    var matches = _react.useContext(RouteContext).matches;
    var routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function useResolvedPath(to, _temp2) {
    var relative = (_temp2 === void 0 ? {} : _temp2).relative;
    var future = _react.useContext(NavigationContext).future;
    var matches = _react.useContext(RouteContext).matches;
    var _useLocation = useLocation(), locationPathname = _useLocation.pathname;
    var routePathnamesJson = JSON.stringify((0, _router.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    return _react.useMemo(function() {
        return (0, _router.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path");
    }, [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function useRoutes(routes, locationArg) {
    return useRoutesImpl(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function useRoutesImpl(routes, locationArg, dataRouterState, future) {
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false, // router loaded. We can help them understand how to avoid that.
    "useRoutes() may be used only in the context of a <Router> component.");
    var _React_useContext = _react.useContext(NavigationContext), navigator = _React_useContext.navigator, isStatic = _React_useContext.static;
    var _React_useContext1 = _react.useContext(RouteContext), parentMatches = _React_useContext1.matches;
    var routeMatch = parentMatches[parentMatches.length - 1];
    var parentParams = routeMatch ? routeMatch.params : {};
    var parentPathname = routeMatch ? routeMatch.pathname : "/";
    var parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    var parentRoute = routeMatch && routeMatch.route;
    {
        // You won't get a warning about 2 different <Routes> under a <Route>
        // without a trailing *, but this is a best-effort warning anyway since we
        // cannot even give the warning unless they land at the parent route.
        //
        // Example:
        //
        // <Routes>
        //   {/* This route path MUST end with /* because otherwise
        //       it will never match /blog/post/123 */}
        //   <Route path="blog" element={<Blog />} />
        //   <Route path="blog/feed" element={<BlogFeed />} />
        // </Routes>
        //
        // function Blog() {
        //   return (
        //     <Routes>
        //       <Route path="post/:id" element={<Post />} />
        //     </Routes>
        //   );
        // }
        var parentPath = parentRoute && parentRoute.path || "";
        warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*"), "You rendered descendant <Routes> (or called `useRoutes()`) at " + ("\"" + parentPathname + "\" (under <Route path=\"" + parentPath + "\">) but the ") + "parent route path has no trailing \"*\". This means if you navigate " + "deeper, the parent won't match anymore and therefore the child " + "routes will never render.\n\n" + ("Please change the parent <Route path=\"" + parentPath + "\"> to <Route ") + ("path=\"" + (parentPath === "/" ? "*" : parentPath + "/*") + "\">."));
    }
    var locationFromContext = useLocation();
    var location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        var parsedLocationArg = typeof locationArg === "string" ? (0, _router.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, _router.UNSAFE_invariant)(false, "When overriding the location using `<Routes location>` or `useRoutes(routes, location)`, the location pathname must begin with the portion of the URL pathname that was " + ("matched by all parent routes. The current pathname base is \"" + parentPathnameBase + "\" ") + ("but pathname \"" + parsedLocationArg.pathname + "\" was given in the `location` prop."));
        location = parsedLocationArg;
    } else location = locationFromContext;
    var pathname = location.pathname || "/";
    var remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        var parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        var segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    var matches = !isStatic && dataRouterState && dataRouterState.matches && dataRouterState.matches.length > 0 ? dataRouterState.matches : (0, _router.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    (0, _router.UNSAFE_warning)(parentRoute || matches != null, "No routes matched location \"" + location.pathname + location.search + location.hash + "\" ");
    (0, _router.UNSAFE_warning)(matches == null || matches[matches.length - 1].route.element !== undefined || matches[matches.length - 1].route.Component !== undefined || matches[matches.length - 1].route.lazy !== undefined, "Matched leaf route at location \"" + location.pathname + location.search + location.hash + "\" " + "does not have an element or Component. This means it will render an <Outlet /> with a " + "null value by default resulting in an \"empty\" page.");
    var renderedMatches = _renderMatches(matches && matches.map(function(match) {
        return Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, _router.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, _router.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        });
    }), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ _react.createElement(LocationContext.Provider, {
        value: {
            location: _extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, _router.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function DefaultErrorComponent() {
    var error = useRouteError();
    var message = (0, _router.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    var stack = error instanceof Error ? error.stack : null;
    var lightgrey = "rgba(200,200,200, 0.5)";
    var preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    var codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    var devInfo = null;
    console.error("Error handled by React Router default ErrorBoundary:", error);
    devInfo = /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /*#__PURE__*/ _react.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /*#__PURE__*/ _react.createElement("code", {
        style: codeStyles
    }, "ErrorBoundary"), " or", " ", /*#__PURE__*/ _react.createElement("code", {
        style: codeStyles
    }, "errorElement"), " prop on your route."));
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ _react.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ _react.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var defaultErrorElement = /*#__PURE__*/ _react.createElement(DefaultErrorComponent, null);
var RenderErrorBoundary = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, _inherits._)(RenderErrorBoundary, _React_Component);
    function RenderErrorBoundary(props) {
        (0, _classCallCheck._)(this, RenderErrorBoundary);
        var _this;
        _this = (0, _callSuper._)(this, RenderErrorBoundary, [
            props
        ]);
        _this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
        return _this;
    }
    (0, _createClass._)(RenderErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                console.error("React Router caught the following error during render", error, errorInfo);
            }
        },
        {
            key: "render",
            value: function render() {
                return this.state.error !== undefined ? /*#__PURE__*/ _react.createElement(RouteContext.Provider, {
                    value: this.props.routeContext
                }, /*#__PURE__*/ _react.createElement(RouteErrorContext.Provider, {
                    value: this.state.error,
                    children: this.props.component
                })) : this.props.children;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                // When we get into an error state, the user will likely click "back" to the
                // previous page that didn't have an error. Because this wraps the entire
                // application, that will have no effect--the error page continues to display.
                // This gives us a mechanism to recover from the error when the location changes.
                //
                // Whether we're in an error state or not, we update the location in state
                // so that when we are in an error state, it gets reset when a new location
                // comes in and the user recovers from the error.
                if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
                    error: props.error,
                    location: props.location,
                    revalidation: props.revalidation
                };
                // If we're not changing locations, preserve the location but still surface
                // any new errors that may come through. We retain the existing error, we do
                // this because the error provided from the app state may be cleared without
                // the location changing.
                return {
                    error: props.error !== undefined ? props.error : state.error,
                    location: state.location,
                    revalidation: props.revalidation || state.revalidation
                };
            }
        }
    ]);
    return RenderErrorBoundary;
}(_react.Component);
function RenderedRoute(_ref) {
    var routeContext = _ref.routeContext, match = _ref.match, children = _ref.children;
    var dataRouterContext = _react.useContext(DataRouterContext);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ _react.createElement(RouteContext.Provider, {
        value: routeContext
    }, children);
}
function _renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    var renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    var errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        var errorIndex = renderedMatches.findIndex(function(m) {
            return m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined;
        });
        !(errorIndex >= 0) && (0, _router.UNSAFE_invariant)(false, "Could not find a matching route for errors on route IDs: " + Object.keys(errors).join(","));
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    var renderFallback = false;
    var fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(var i = 0; i < renderedMatches.length; i++){
        var match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            var loaderData = dataRouterState.loaderData, errors1 = dataRouterState.errors;
            var needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors1 || errors1[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight(function(outlet, match, index) {
        // Only data routers handle errors/fallbacks
        var error;
        var shouldRenderHydrateFallback = false;
        var errorElement = null;
        var hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        var _$matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        var getChildren = function() {
            var children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ _react.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ _react.createElement(RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: _$matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ _react.createElement(RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: _$matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}(DataRouterHook || {});
var DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}(DataRouterStateHook || {});
function getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function useDataRouterContext(hookName) {
    var ctx = _react.useContext(DataRouterContext);
    !ctx && (0, _router.UNSAFE_invariant)(false, getDataRouterConsoleError(hookName));
    return ctx;
}
function useDataRouterState(hookName) {
    var state = _react.useContext(DataRouterStateContext);
    !state && (0, _router.UNSAFE_invariant)(false, getDataRouterConsoleError(hookName));
    return state;
}
function useRouteContext(hookName) {
    var route = _react.useContext(RouteContext);
    !route && (0, _router.UNSAFE_invariant)(false, getDataRouterConsoleError(hookName));
    return route;
}
// Internal version with hookName-aware debugging
function useCurrentRouteId(hookName) {
    var route = useRouteContext(hookName);
    var thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, _router.UNSAFE_invariant)(false, hookName + " can only be used on routes that contain a unique \"id\"");
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function useRouteId() {
    return useCurrentRouteId(DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function useNavigation() {
    var state = useDataRouterState(DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function useRevalidator() {
    var dataRouterContext = useDataRouterContext(DataRouterHook.UseRevalidator);
    var state = useDataRouterState(DataRouterStateHook.UseRevalidator);
    return _react.useMemo(function() {
        return {
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        };
    }, [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function useMatches() {
    var _useDataRouterState = useDataRouterState(DataRouterStateHook.UseMatches), matches = _useDataRouterState.matches, loaderData = _useDataRouterState.loaderData;
    return _react.useMemo(function() {
        return matches.map(function(m) {
            return (0, _router.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData);
        });
    }, [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function useLoaderData() {
    var state = useDataRouterState(DataRouterStateHook.UseLoaderData);
    var routeId = useCurrentRouteId(DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function useRouteLoaderData(routeId) {
    var state = useDataRouterState(DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function useActionData() {
    var state = useDataRouterState(DataRouterStateHook.UseActionData);
    var routeId = useCurrentRouteId(DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function useRouteError() {
    var _state$errors;
    var error = _react.useContext(RouteErrorContext);
    var state = useDataRouterState(DataRouterStateHook.UseRouteError);
    var routeId = useCurrentRouteId(DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function useAsyncValue() {
    var value = _react.useContext(AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function useAsyncError() {
    var value = _react.useContext(AwaitContext);
    return value == null ? void 0 : value._error;
}
var blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function useBlocker(shouldBlock) {
    var _useDataRouterContext = useDataRouterContext(DataRouterHook.UseBlocker), router = _useDataRouterContext.router, basename = _useDataRouterContext.basename;
    var state = useDataRouterState(DataRouterStateHook.UseBlocker);
    var _React_useState = (0, _slicedToArray._)(_react.useState(""), 2), blockerKey = _React_useState[0], setBlockerKey = _React_useState[1];
    var blockerFunction = _react.useCallback(function(arg) {
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        var currentLocation = arg.currentLocation, nextLocation = arg.nextLocation, historyAction = arg.historyAction;
        return shouldBlock({
            currentLocation: _extends({}, currentLocation, {
                pathname: (0, _router.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: _extends({}, nextLocation, {
                pathname: (0, _router.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    _react.useEffect(function() {
        var key = String(++blockerId);
        setBlockerKey(key);
        return function() {
            return router.deleteBlocker(key);
        };
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    _react.useEffect(function() {
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, _router.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function useNavigateStable() {
    var router = useDataRouterContext(DataRouterHook.UseNavigateStable).router;
    var id = useCurrentRouteId(DataRouterStateHook.UseNavigateStable);
    var activeRef = _react.useRef(false);
    useIsomorphicLayoutEffect(function() {
        activeRef.current = true;
    });
    var navigate = _react.useCallback(function(to, options) {
        if (options === void 0) options = {};
        (0, _router.UNSAFE_warning)(activeRef.current, navigateEffectWarning);
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, _extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
var alreadyWarned$1 = {};
function warningOnce(key, cond, message) {
    if (!cond && !alreadyWarned$1[key]) {
        alreadyWarned$1[key] = true;
        (0, _router.UNSAFE_warning)(false, message);
    }
}
var alreadyWarned = {};
function warnOnce(key, message) {
    if (!alreadyWarned[message]) {
        alreadyWarned[message] = true;
        console.warn(message);
    }
}
var logDeprecation = function(flag, msg, link) {
    return warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
};
function logV6DeprecationWarnings(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || !routerFuture.v7_relativeSplatPath)) logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ var START_TRANSITION = "startTransition";
var startTransitionImpl = _react[START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function RouterProvider(_ref) {
    var fallbackElement = _ref.fallbackElement, router = _ref.router, future = _ref.future;
    var _React_useState = (0, _slicedToArray._)(_react.useState(router.state), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = _react.useCallback(function(newState) {
        if (v7_startTransition && startTransitionImpl) startTransitionImpl(function() {
            return setStateImpl(newState);
        });
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    _react.useLayoutEffect(function() {
        return router.subscribe(setState);
    }, [
        router,
        setState
    ]);
    _react.useEffect(function() {
        (0, _router.UNSAFE_warning)(fallbackElement == null || !router.future.v7_partialHydration, "`<RouterProvider fallbackElement>` is deprecated when using `v7_partialHydration`, use a `HydrateFallback` component instead");
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var navigator = _react.useMemo(function() {
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: function(n) {
                return router.navigate(n);
            },
            push: function(to, state, opts) {
                return router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            },
            replace: function(to, state, opts) {
                return router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            }
        };
    }, [
        router
    ]);
    var basename = router.basename || "/";
    var dataRouterContext = _react.useMemo(function() {
        return {
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        };
    }, [
        router,
        navigator,
        basename
    ]);
    _react.useEffect(function() {
        return logV6DeprecationWarnings(future, router.future);
    }, [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement(DataRouterContext.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ _react.createElement(DataRouterStateContext.Provider, {
        value: state
    }, /*#__PURE__*/ _react.createElement(Router, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ _react.createElement(DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function DataRoutes(_ref2) {
    var routes = _ref2.routes, future = _ref2.future, state = _ref2.state;
    return useRoutesImpl(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function MemoryRouter(_ref3) {
    var basename = _ref3.basename, children = _ref3.children, initialEntries = _ref3.initialEntries, initialIndex = _ref3.initialIndex, future = _ref3.future;
    var historyRef = _react.useRef();
    if (historyRef.current == null) historyRef.current = (0, _router.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, _slicedToArray._)(_react.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = _react.useCallback(function(newState) {
        v7_startTransition && startTransitionImpl ? startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    _react.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    _react.useEffect(function() {
        return logV6DeprecationWarnings(future);
    }, [
        future
    ]);
    return /*#__PURE__*/ _react.createElement(Router, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function Navigate(_ref4) {
    var to = _ref4.to, replace = _ref4.replace, state = _ref4.state, relative = _ref4.relative;
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false, // the router loaded. We can help them understand how to avoid that.
    "<Navigate> may be used only in the context of a <Router> component.");
    var _React_useContext = _react.useContext(NavigationContext), future = _React_useContext.future, isStatic = _React_useContext.static;
    (0, _router.UNSAFE_warning)(!isStatic, "<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.");
    var matches = _react.useContext(RouteContext).matches;
    var _useLocation = useLocation(), locationPathname = _useLocation.pathname;
    var navigate = useNavigate();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    var path = (0, _router.resolveTo)(to, (0, _router.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    var jsonPath = JSON.stringify(path);
    _react.useEffect(function() {
        return navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function Outlet(props) {
    return useOutlet(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function Route(_props) {
    (0, _router.UNSAFE_invariant)(false, "A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.");
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function Router(_ref5) {
    var tmp = _ref5.basename, basenameProp = tmp === void 0 ? "/" : tmp, _ref5_children = _ref5.children, children = _ref5_children === void 0 ? null : _ref5_children, locationProp = _ref5.location, _ref5_navigationType = _ref5.navigationType, navigationType = _ref5_navigationType === void 0 ? (0, _router.Action).Pop : _ref5_navigationType, navigator = _ref5.navigator, tmp1 = _ref5.static, staticProp = tmp1 === void 0 ? false : tmp1, future = _ref5.future;
    !!useInRouterContext() && (0, _router.UNSAFE_invariant)(false, "You cannot render a <Router> inside another <Router>. You should never have more than one in your app.");
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    var basename = basenameProp.replace(/^\/*/, "/");
    var navigationContext = _react.useMemo(function() {
        return {
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: _extends({
                v7_relativeSplatPath: false
            }, future)
        };
    }, [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, _router.parsePath)(locationProp);
    var _locationProp_pathname = locationProp.pathname, pathname = _locationProp_pathname === void 0 ? "/" : _locationProp_pathname, _locationProp_search = locationProp.search, search = _locationProp_search === void 0 ? "" : _locationProp_search, _locationProp_hash = locationProp.hash, hash = _locationProp_hash === void 0 ? "" : _locationProp_hash, _locationProp_state = locationProp.state, state = _locationProp_state === void 0 ? null : _locationProp_state, _locationProp_key = locationProp.key, key = _locationProp_key === void 0 ? "default" : _locationProp_key;
    var locationContext = _react.useMemo(function() {
        var trailingPathname = (0, _router.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    (0, _router.UNSAFE_warning)(locationContext != null, "<Router basename=\"" + basename + "\"> is not able to match the URL " + ("\"" + pathname + search + hash + "\" because it does not start with the ") + "basename, so the <Router> won't render anything.");
    if (locationContext == null) return null;
    return /*#__PURE__*/ _react.createElement(NavigationContext.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ _react.createElement(LocationContext.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function Routes(_ref6) {
    var children = _ref6.children, location = _ref6.location;
    return useRoutes(createRoutesFromChildren(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function Await(_ref7) {
    var children = _ref7.children, errorElement = _ref7.errorElement, resolve = _ref7.resolve;
    return /*#__PURE__*/ _react.createElement(AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ _react.createElement(ResolveAwait, null, children));
}
var AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}(AwaitRenderStatus || {});
var neverSettledPromise = new Promise(function() {});
var AwaitErrorBoundary = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, _inherits._)(AwaitErrorBoundary, _React_Component);
    function AwaitErrorBoundary(props) {
        (0, _classCallCheck._)(this, AwaitErrorBoundary);
        var _this;
        _this = (0, _callSuper._)(this, AwaitErrorBoundary, [
            props
        ]);
        _this.state = {
            error: null
        };
        return _this;
    }
    (0, _createClass._)(AwaitErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                console.error("<Await> caught the following error during render", error, errorInfo);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, children = _this_props.children, errorElement = _this_props.errorElement, resolve = _this_props.resolve;
                var promise = null;
                var status = AwaitRenderStatus.pending;
                if (!(resolve instanceof Promise)) {
                    // Didn't get a promise - provide as a resolved promise
                    status = AwaitRenderStatus.success;
                    promise = Promise.resolve();
                    Object.defineProperty(promise, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    Object.defineProperty(promise, "_data", {
                        get: function() {
                            return resolve;
                        }
                    });
                } else if (this.state.error) {
                    // Caught a render error, provide it as a rejected promise
                    status = AwaitRenderStatus.error;
                    var renderError = this.state.error;
                    promise = Promise.reject().catch(function() {}); // Avoid unhandled rejection warnings
                    Object.defineProperty(promise, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return renderError;
                        }
                    });
                } else if (resolve._tracked) {
                    // Already tracked promise - check contents
                    promise = resolve;
                    status = "_error" in promise ? AwaitRenderStatus.error : "_data" in promise ? AwaitRenderStatus.success : AwaitRenderStatus.pending;
                } else {
                    // Raw (untracked) promise - track it
                    status = AwaitRenderStatus.pending;
                    Object.defineProperty(resolve, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    promise = resolve.then(function(data) {
                        return Object.defineProperty(resolve, "_data", {
                            get: function() {
                                return data;
                            }
                        });
                    }, function(error) {
                        return Object.defineProperty(resolve, "_error", {
                            get: function() {
                                return error;
                            }
                        });
                    });
                }
                if (status === AwaitRenderStatus.error && promise._error instanceof (0, _router.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
                throw neverSettledPromise;
                if (status === AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
                throw promise._error;
                if (status === AwaitRenderStatus.error) // Render via our errorElement
                return /*#__PURE__*/ _react.createElement(AwaitContext.Provider, {
                    value: promise,
                    children: errorElement
                });
                if (status === AwaitRenderStatus.success) // Render children with resolved value
                return /*#__PURE__*/ _react.createElement(AwaitContext.Provider, {
                    value: promise,
                    children: children
                });
                // Throw to the suspense boundary
                throw promise;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        }
    ]);
    return AwaitErrorBoundary;
}(_react.Component);
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function ResolveAwait(_ref8) {
    var children = _ref8.children;
    var data = useAsyncValue();
    var toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function createRoutesFromChildren(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    var routes = [];
    _react.Children.forEach(children, function(element, index) {
        if (!/*#__PURE__*/ _react.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        var treePath = (0, _toConsumableArray._)(parentPath).concat([
            index
        ]);
        if (element.type === _react.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, createRoutesFromChildren(element.props.children, treePath));
            return;
        }
        !(element.type === Route) && (0, _router.UNSAFE_invariant)(false, "[" + (typeof element.type === "string" ? element.type : element.type.name) + "] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>");
        !(!element.props.index || !element.props.children) && (0, _router.UNSAFE_invariant)(false, "An index route cannot have child routes.");
        var route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = createRoutesFromChildren(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function renderMatches(matches) {
    return _renderMatches(matches);
}
function mapRouteProperties(route) {
    var updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if (route.element) (0, _router.UNSAFE_warning)(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        Object.assign(updates, {
            element: /*#__PURE__*/ _react.createElement(route.Component),
            Component: undefined
        });
    }
    if (route.HydrateFallback) {
        if (route.hydrateFallbackElement) (0, _router.UNSAFE_warning)(false, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used.");
        Object.assign(updates, {
            hydrateFallbackElement: /*#__PURE__*/ _react.createElement(route.HydrateFallback),
            HydrateFallback: undefined
        });
    }
    if (route.ErrorBoundary) {
        if (route.errorElement) (0, _router.UNSAFE_warning)(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        Object.assign(updates, {
            errorElement: /*#__PURE__*/ _react.createElement(route.ErrorBoundary),
            ErrorBoundary: undefined
        });
    }
    return updates;
}
function createMemoryRouter(routes, opts) {
    return (0, _router.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: _extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, _router.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: mapRouteProperties,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}

},{"@swc/helpers/_/_call_super":"5oPMc","@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","@swc/helpers/_/_inherits":"j8HRi","@swc/helpers/_/_sliced_to_array":"ha6sq","@swc/helpers/_/_to_consumable_array":"eqNDD","react":"c8CN1","@remix-run/router":"2coNK","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2coNK":[function(require,module,exports,__globalThis) {
/**
 * @remix-run/router v1.23.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
//#endregion
parcelHelpers.export(exports, "AbortedDeferredError", function() {
    return AbortedDeferredError;
});
parcelHelpers.export(exports, "Action", function() {
    return Action;
});
parcelHelpers.export(exports, "IDLE_BLOCKER", function() {
    return IDLE_BLOCKER;
});
parcelHelpers.export(exports, "IDLE_FETCHER", function() {
    return IDLE_FETCHER;
});
parcelHelpers.export(exports, "IDLE_NAVIGATION", function() {
    return IDLE_NAVIGATION;
});
parcelHelpers.export(exports, "UNSAFE_DEFERRED_SYMBOL", function() {
    return UNSAFE_DEFERRED_SYMBOL;
});
parcelHelpers.export(exports, "UNSAFE_DeferredData", function() {
    return DeferredData;
});
parcelHelpers.export(exports, "UNSAFE_ErrorResponseImpl", function() {
    return ErrorResponseImpl;
});
parcelHelpers.export(exports, "UNSAFE_convertRouteMatchToUiMatch", function() {
    return convertRouteMatchToUiMatch;
});
parcelHelpers.export(exports, "UNSAFE_convertRoutesToDataRoutes", function() {
    return convertRoutesToDataRoutes;
});
parcelHelpers.export(exports, "UNSAFE_decodePath", function() {
    return decodePath;
});
parcelHelpers.export(exports, "UNSAFE_getResolveToMatches", function() {
    return getResolveToMatches;
});
parcelHelpers.export(exports, "UNSAFE_invariant", function() {
    return invariant;
});
parcelHelpers.export(exports, "UNSAFE_warning", function() {
    return warning;
});
parcelHelpers.export(exports, "createBrowserHistory", function() {
    return createBrowserHistory;
});
parcelHelpers.export(exports, "createHashHistory", function() {
    return createHashHistory;
});
parcelHelpers.export(exports, "createMemoryHistory", function() {
    return createMemoryHistory;
});
parcelHelpers.export(exports, "createPath", function() {
    return createPath;
});
parcelHelpers.export(exports, "createRouter", function() {
    return createRouter;
});
parcelHelpers.export(exports, "createStaticHandler", function() {
    return createStaticHandler;
});
parcelHelpers.export(exports, "data", function() {
    return data;
});
parcelHelpers.export(exports, "defer", function() {
    return defer;
});
parcelHelpers.export(exports, "generatePath", function() {
    return generatePath;
});
parcelHelpers.export(exports, "getStaticContextFromError", function() {
    return getStaticContextFromError;
});
parcelHelpers.export(exports, "getToPathname", function() {
    return getToPathname;
});
parcelHelpers.export(exports, "isDataWithResponseInit", function() {
    return isDataWithResponseInit;
});
parcelHelpers.export(exports, "isDeferredData", function() {
    return isDeferredData;
});
parcelHelpers.export(exports, "isRouteErrorResponse", function() {
    return isRouteErrorResponse;
});
parcelHelpers.export(exports, "joinPaths", function() {
    return joinPaths;
});
parcelHelpers.export(exports, "json", function() {
    return json;
});
parcelHelpers.export(exports, "matchPath", function() {
    return matchPath;
});
parcelHelpers.export(exports, "matchRoutes", function() {
    return matchRoutes;
});
parcelHelpers.export(exports, "normalizePathname", function() {
    return normalizePathname;
});
parcelHelpers.export(exports, "parsePath", function() {
    return parsePath;
});
parcelHelpers.export(exports, "redirect", function() {
    return redirect;
});
parcelHelpers.export(exports, "redirectDocument", function() {
    return redirectDocument;
});
parcelHelpers.export(exports, "replace", function() {
    return replace;
});
parcelHelpers.export(exports, "resolvePath", function() {
    return resolvePath;
});
parcelHelpers.export(exports, "resolveTo", function() {
    return resolveTo;
});
parcelHelpers.export(exports, "stripBasename", function() {
    return stripBasename;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _inherits = require("@swc/helpers/_/_inherits");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toArray = require("@swc/helpers/_/_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _typeOf = require("@swc/helpers/_/_type_of");
var _wrapNativeSuper = require("@swc/helpers/_/_wrap_native_super");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _tsValues = require("@swc/helpers/_/_ts_values");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var Action;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})(Action || (Action = {}));
var PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function createMemoryHistory(options) {
    if (options === void 0) options = {};
    var _options_initialEntries = options.initialEntries, initialEntries = _options_initialEntries === void 0 ? [
        "/"
    ] : _options_initialEntries, initialIndex = options.initialIndex, _options_v5Compat = options.v5Compat, v5Compat = _options_v5Compat === void 0 ? false : _options_v5Compat;
    var entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map(function(entry, index) {
        return createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined);
    });
    var index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    var action = Action.Pop;
    var listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        var location = createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        warning(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : createPath(to);
    }
    var history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL: function(to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation: function(to) {
            var path = typeof to === "string" ? parsePath(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push: function(to, state) {
            action = Action.Push;
            var nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace: function(to, state) {
            action = Action.Replace;
            var nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go: function(delta) {
            action = Action.Pop;
            var nextIndex = clampIndex(index + delta);
            var nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen: function(fn) {
            listener = fn;
            return function() {
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function createBrowserHistory(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        var _window_location = window1.location, pathname = _window_location.pathname, search = _window_location.search, hash = _window_location.hash;
        return createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : createPath(to);
    }
    return getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function createHashHistory(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        var _parsePath = parsePath(window1.location.hash.substr(1)), _parsePath_pathname = _parsePath.pathname, pathname = _parsePath_pathname === void 0 ? "/" : _parsePath_pathname, _parsePath_search = _parsePath.search, search = _parsePath_search === void 0 ? "" : _parsePath_search, _parsePath_hash = _parsePath.hash, hash = _parsePath_hash === void 0 ? "" : _parsePath_hash;
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        var base = window1.document.querySelector("base");
        var href = "";
        if (base && base.getAttribute("href")) {
            var url = window1.location.href;
            var hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : createPath(to));
    }
    function validateHashLocation(location, to) {
        warning(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function invariant(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function warning(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    var location = _extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? parsePath(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function createPath(_ref) {
    var _ref_pathname = _ref.pathname, pathname = _ref_pathname === void 0 ? "/" : _ref_pathname, _ref_search = _ref.search, search = _ref_search === void 0 ? "" : _ref_search, _ref_hash = _ref.hash, hash = _ref_hash === void 0 ? "" : _ref_hash;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function parsePath(path) {
    var parsedPath = {};
    if (path) {
        var hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        var searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    var _options_window = options.window, window1 = _options_window === void 0 ? document.defaultView : _options_window, _options_v5Compat = options.v5Compat, v5Compat = _options_v5Compat === void 0 ? false : _options_v5Compat;
    var globalHistory = window1.history;
    var action = Action.Pop;
    var listener = null;
    var index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState(_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        var state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = Action.Pop;
        var nextIndex = getIndex();
        var delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = Action.Push;
        var location = createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        var historyState = getHistoryState(location, index);
        var url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = Action.Replace;
        var location = createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        var historyState = getHistoryState(location, index);
        var url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        var base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        var href = typeof to === "string" ? to : createPath(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        invariant(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen: function(fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener(PopStateEventType, handlePop);
            listener = fn;
            return function() {
                window1.removeEventListener(PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref: function(to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation: function(to) {
            // Encode a Location the same way window.location would
            var url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go: function(n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})(ResultType || (ResultType = {}));
var immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function convertRoutesToDataRoutes(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map(function(route, index) {
        var treePath = (0, _toConsumableArray._)(parentPath).concat([
            String(index)
        ]);
        var id = typeof route.id === "string" ? route.id : treePath.join("-");
        invariant(route.index !== true || !route.children, "Cannot specify children on an index route");
        invariant(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if (isIndexRoute(route)) {
            var indexRoute = _extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            var pathOrLayoutRoute = _extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = convertRoutesToDataRoutes(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function matchRoutes(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return matchRoutesImpl(routes, locationArg, basename, false);
}
function matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    var location = typeof locationArg === "string" ? parsePath(locationArg) : locationArg;
    var pathname = stripBasename(location.pathname || "/", basename);
    if (pathname == null) return null;
    var branches = flattenRoutes(routes);
    rankRouteBranches(branches);
    var matches = null;
    for(var i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        var decoded = decodePath(pathname);
        matches = matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function convertRouteMatchToUiMatch(match, loaderData) {
    var route = match.route, pathname = match.pathname, params = match.params;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    var flattenRoute = function(route, index, relativePath) {
        var meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            invariant(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        var path = joinPaths([
            parentPath,
            meta.relativePath
        ]);
        var routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            invariant(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach(function(route, index) {
        var _route$path;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else try {
            for(var _iterator = explodeOptionalSegments(route.path)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var exploded = _step.value;
                flattenRoute(route, index, exploded);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function explodeOptionalSegments(path) {
    var // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    _result, _result1;
    var segments = path.split("/");
    if (segments.length === 0) return [];
    var _segments = (0, _toArray._)(segments), first = _segments[0], rest = _segments.slice(1);
    // Optional path segments are denoted by a trailing `?`
    var isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    var required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    var restExploded = explodeOptionalSegments(rest.join("/"));
    var result = [];
    (_result = result).push.apply(_result, (0, _toConsumableArray._)(restExploded.map(function(subpath) {
        return subpath === "" ? required : [
            required,
            subpath
        ].join("/");
    })));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) (_result1 = result).push.apply(_result1, (0, _toConsumableArray._)(restExploded));
    // for absolute paths, ensure `/` instead of empty segment
    return result.map(function(exploded) {
        return path.startsWith("/") && exploded === "" ? "/" : exploded;
    });
}
function rankRouteBranches(branches) {
    branches.sort(function(a, b) {
        return a.score !== b.score ? b.score - a.score // Higher score first
         : compareIndexes(a.routesMeta.map(function(meta) {
            return meta.childrenIndex;
        }), b.routesMeta.map(function(meta) {
            return meta.childrenIndex;
        }));
    });
}
var paramRe = /^:[\w-]+$/;
var dynamicSegmentValue = 3;
var indexRouteValue = 2;
var emptySegmentValue = 1;
var staticSegmentValue = 10;
var splatPenalty = -2;
var isSplat = function(s) {
    return s === "*";
};
function computeScore(path, index) {
    var segments = path.split("/");
    var initialScore = segments.length;
    if (segments.some(isSplat)) initialScore += splatPenalty;
    if (index) initialScore += indexRouteValue;
    return segments.filter(function(s) {
        return !isSplat(s);
    }).reduce(function(score, segment) {
        return score + (paramRe.test(segment) ? dynamicSegmentValue : segment === "" ? emptySegmentValue : staticSegmentValue);
    }, initialScore);
}
function compareIndexes(a, b) {
    var siblings = a.length === b.length && a.slice(0, -1).every(function(n, i) {
        return n === b[i];
    });
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    var routesMeta = branch.routesMeta;
    var matchedParams = {};
    var matchedPathname = "/";
    var matches = [];
    for(var i = 0; i < routesMeta.length; ++i){
        var meta = routesMeta[i];
        var end = i === routesMeta.length - 1;
        var remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        var match = matchPath({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        var route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = matchPath({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: normalizePathname(joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function generatePath(originalPath, params) {
    if (params === void 0) params = {};
    var path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        warning(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    var prefix = path.startsWith("/") ? "/" : "";
    var stringify = function(p) {
        return p == null ? "" : typeof p === "string" ? p : String(p);
    };
    var segments = path.split(/\/+/).map(function(segment, index, array) {
        var isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            var star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        var keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            var _keyMatch = (0, _slicedToArray._)(keyMatch, 3), key = _keyMatch[1], optional = _keyMatch[2];
            var param = params[key];
            invariant(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter(function(segment) {
        return !!segment;
    });
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function matchPath(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    var _compilePath = (0, _slicedToArray._)(compilePath(pattern.path, pattern.caseSensitive, pattern.end), 2), matcher = _compilePath[0], compiledParams = _compilePath[1];
    var match = pathname.match(matcher);
    if (!match) return null;
    var matchedPathname = match[0];
    var pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    var captureGroups = match.slice(1);
    var params = compiledParams.reduce(function(memo, _ref, index) {
        var paramName = _ref.paramName, isOptional = _ref.isOptional;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            var splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        var value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    var params = [];
    var regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, function(_, paramName, isOptional) {
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    var matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function decodePath(value) {
    try {
        return value.split("/").map(function(v) {
            return decodeURIComponent(v).replace(/\//g, "%2F");
        }).join("/");
    } catch (error) {
        warning(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function stripBasename(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    var startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    var nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function resolvePath(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    var _ref = typeof to === "string" ? parsePath(to) : to, toPathname = _ref.pathname, _ref_search = _ref.search, search = _ref_search === void 0 ? "" : _ref_search, _ref_hash = _ref.hash, hash = _ref_hash === void 0 ? "" : _ref_hash;
    var pathname = toPathname ? toPathname.startsWith("/") ? toPathname : resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: normalizeSearch(search),
        hash: normalizeHash(hash)
    };
}
function resolvePathname(relativePath, fromPathname) {
    var segments = fromPathname.replace(/\/+$/, "").split("/");
    var relativeSegments = relativePath.split("/");
    relativeSegments.forEach(function(segment) {
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function getPathContributingMatches(matches) {
    return matches.filter(function(match, index) {
        return index === 0 || match.route.path && match.route.path.length > 0;
    });
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function getResolveToMatches(matches, v7_relativeSplatPath) {
    var pathMatches = getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map(function(match, idx) {
        return idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase;
    });
    return pathMatches.map(function(match) {
        return match.pathnameBase;
    });
}
/**
 * @private
 */ function resolveTo(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    var to;
    if (typeof toArg === "string") to = parsePath(toArg);
    else {
        to = _extends({}, toArg);
        invariant(!to.pathname || !to.pathname.includes("?"), getInvalidPathError("?", "pathname", "search", to));
        invariant(!to.pathname || !to.pathname.includes("#"), getInvalidPathError("#", "pathname", "hash", to));
        invariant(!to.search || !to.search.includes("#"), getInvalidPathError("#", "search", "hash", to));
    }
    var isEmptyPath = toArg === "" || to.pathname === "";
    var toPathname = isEmptyPath ? "/" : to.pathname;
    var from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        var routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            var toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    var path = resolvePath(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    var hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    var hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function getToPathname(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? parsePath(to).pathname : to.pathname;
}
/**
 * @private
 */ var joinPaths = function(paths) {
    return paths.join("/").replace(/\/\/+/g, "/");
};
/**
 * @private
 */ var normalizePathname = function(pathname) {
    return pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
};
/**
 * @private
 */ var normalizeSearch = function(search) {
    return !search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
};
/**
 * @private
 */ var normalizeHash = function(hash) {
    return !hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
};
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ var json = function json(data, init) {
    if (init === void 0) init = {};
    var responseInit = typeof init === "number" ? {
        status: init
    } : init;
    var headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), _extends({}, responseInit, {
        headers: headers
    }));
};
var DataWithResponseInit = function DataWithResponseInit(data, init) {
    "use strict";
    (0, _classCallCheck._)(this, DataWithResponseInit);
    this.type = "DataWithResponseInit";
    this.data = data;
    this.init = init || null;
};
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function data(data, init) {
    return new DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
var AbortedDeferredError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, _inherits._)(AbortedDeferredError, Error1);
    function AbortedDeferredError() {
        (0, _classCallCheck._)(this, AbortedDeferredError);
        return (0, _callSuper._)(this, AbortedDeferredError, arguments);
    }
    return AbortedDeferredError;
}((0, _wrapNativeSuper._)(Error));
var DeferredData = /*#__PURE__*/ function() {
    "use strict";
    function DeferredData(data, responseInit) {
        var _this = this;
        (0, _classCallCheck._)(this, DeferredData);
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        invariant(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        var reject;
        this.abortPromise = new Promise(function(_, r) {
            return reject = r;
        });
        this.controller = new AbortController();
        var onAbort = function() {
            return reject(new AbortedDeferredError("Deferred data aborted"));
        };
        this.unlistenAbortSignal = function() {
            return _this.controller.signal.removeEventListener("abort", onAbort);
        };
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce(function(acc, _ref2) {
            var _$_ref2 = (0, _slicedToArray._)(_ref2, 2), key = _$_ref2[0], value = _$_ref2[1];
            return Object.assign(acc, (0, _defineProperty._)({}, key, _this.trackPromise(key, value)));
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    (0, _createClass._)(DeferredData, [
        {
            key: "trackPromise",
            value: function trackPromise(key, value) {
                var _this = this;
                if (!(value instanceof Promise)) return value;
                this.deferredKeys.push(key);
                this.pendingKeysSet.add(key);
                // We store a little wrapper promise that will be extended with
                // _data/_error props upon resolve/reject
                var promise = Promise.race([
                    value,
                    this.abortPromise
                ]).then(function(data) {
                    return _this.onSettle(promise, key, undefined, data);
                }, function(error) {
                    return _this.onSettle(promise, key, error);
                });
                // Register rejection listeners to avoid uncaught promise rejections on
                // errors or aborted deferred values
                promise.catch(function() {});
                Object.defineProperty(promise, "_tracked", {
                    get: function() {
                        return true;
                    }
                });
                return promise;
            }
        },
        {
            key: "onSettle",
            value: function onSettle(promise, key, error, data) {
                if (this.controller.signal.aborted && error instanceof AbortedDeferredError) {
                    this.unlistenAbortSignal();
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return error;
                        }
                    });
                    return Promise.reject(error);
                }
                this.pendingKeysSet.delete(key);
                if (this.done) // Nothing left to abort!
                this.unlistenAbortSignal();
                // If the promise was resolved/rejected with undefined, we'll throw an error as you
                // should always resolve with a value or null
                if (error === undefined && data === undefined) {
                    var undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return undefinedError;
                        }
                    });
                    this.emit(false, key);
                    return Promise.reject(undefinedError);
                }
                if (data === undefined) {
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return error;
                        }
                    });
                    this.emit(false, key);
                    return Promise.reject(error);
                }
                Object.defineProperty(promise, "_data", {
                    get: function() {
                        return data;
                    }
                });
                this.emit(false, key);
                return data;
            }
        },
        {
            key: "emit",
            value: function emit(aborted, settledKey) {
                this.subscribers.forEach(function(subscriber) {
                    return subscriber(aborted, settledKey);
                });
            }
        },
        {
            key: "subscribe",
            value: function subscribe(fn) {
                var _this = this;
                this.subscribers.add(fn);
                return function() {
                    return _this.subscribers.delete(fn);
                };
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                var _this = this;
                this.controller.abort();
                this.pendingKeysSet.forEach(function(v, k) {
                    return _this.pendingKeysSet.delete(k);
                });
                this.emit(true);
            }
        },
        {
            key: "resolveData",
            value: function resolveData(signal) {
                var _this = this;
                return (0, _asyncToGenerator._)(function() {
                    var aborted, onAbort;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                aborted = false;
                                if (!!_this.done) return [
                                    3,
                                    2
                                ];
                                onAbort = function() {
                                    return _this.cancel();
                                };
                                signal.addEventListener("abort", onAbort);
                                return [
                                    4,
                                    new Promise(function(resolve) {
                                        _this.subscribe(function(aborted) {
                                            signal.removeEventListener("abort", onAbort);
                                            if (aborted || _this.done) resolve(aborted);
                                        });
                                    })
                                ];
                            case 1:
                                aborted = _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2,
                                    aborted
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "done",
            get: function get() {
                return this.pendingKeysSet.size === 0;
            }
        },
        {
            key: "unwrappedData",
            get: function get() {
                invariant(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
                return Object.entries(this.data).reduce(function(acc, _ref3) {
                    var _$_ref3 = (0, _slicedToArray._)(_ref3, 2), key = _$_ref3[0], value = _$_ref3[1];
                    return Object.assign(acc, (0, _defineProperty._)({}, key, unwrapTrackedPromise(value)));
                }, {});
            }
        },
        {
            key: "pendingKeys",
            get: function get() {
                return Array.from(this.pendingKeysSet);
            }
        }
    ]);
    return DeferredData;
}();
function isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function unwrapTrackedPromise(value) {
    if (!isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ var defer = function defer(data, init) {
    if (init === void 0) init = {};
    var responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new DeferredData(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ var redirect = function redirect(url, init) {
    if (init === void 0) init = 302;
    var responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    var headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, _extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ var redirectDocument = function(url, init) {
    var response = redirect(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ var replace = function(url, init) {
    var response = redirect(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ var ErrorResponseImpl = function ErrorResponseImpl(status, statusText, data, internal) {
    "use strict";
    (0, _classCallCheck._)(this, ErrorResponseImpl);
    if (internal === void 0) internal = false;
    this.status = status;
    this.statusText = statusText || "";
    this.internal = internal;
    if (data instanceof Error) {
        this.data = data.toString();
        this.error = data;
    } else this.data = data;
};
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function isRouteErrorResponse(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
var validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
var validMutationMethods = new Set(validMutationMethodsArr);
var validRequestMethodsArr = [
    "get"
].concat((0, _toConsumableArray._)(validMutationMethodsArr));
var validRequestMethods = new Set(validRequestMethodsArr);
var redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
var redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
var IDLE_NAVIGATION = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
var IDLE_FETCHER = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
var IDLE_BLOCKER = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
var ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var defaultMapRouteProperties = function(route) {
    return {
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    };
};
var TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function createRouter(init) {
    var routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    var isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    var isServer = !isBrowser;
    invariant(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    var mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        var detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = function(route) {
            return {
                hasErrorBoundary: detectErrorBoundary(route)
            };
        };
    } else mapRouteProperties = defaultMapRouteProperties;
    // Routes keyed by ID
    var manifest = {};
    // Routes in tree format for matching
    var dataRoutes = convertRoutesToDataRoutes(init.routes, mapRouteProperties, undefined, manifest);
    var inFlightDataRoutes;
    var basename = init.basename || "/";
    var dataStrategyImpl = init.dataStrategy || defaultDataStrategy;
    var patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    var future = _extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    var unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    var subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    var savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    var getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    var getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    var initialScrollRestored = init.hydrationData != null;
    var initialMatches = matchRoutes(dataRoutes, init.history.location, basename);
    var initialMatchesIsFOW = false;
    var initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        var error = getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        var _getShortCircuitMatches = getShortCircuitMatches(dataRoutes), matches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
        initialMatches = matches;
        initialErrors = (0, _defineProperty._)({}, route.id, error);
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        var fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    var initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            var fogOfWar1 = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar1.active && fogOfWar1.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar1.matches;
            }
        }
    } else if (initialMatches.some(function(m) {
        return m.route.lazy;
    })) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some(function(m) {
        return m.route.loader;
    })) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        var loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        var errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            var idx = initialMatches.findIndex(function(m) {
                return errors[m.route.id] !== undefined;
            });
            initialized = initialMatches.slice(0, idx + 1).every(function(m) {
                return !shouldLoadRouteOnHydration(m.route, loaderData, errors);
            });
        } else initialized = initialMatches.every(function(m) {
            return !shouldLoadRouteOnHydration(m.route, loaderData, errors);
        });
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    var router;
    var state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: IDLE_NAVIGATION,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    var pendingAction = Action.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    var pendingPreventScrollReset = false;
    // AbortController for the active navigation
    var pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    var pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    var appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    var removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    var isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    var isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    var cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    var cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    var fetchControllers = new Map();
    // Track loads based on the order in which they started
    var incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    var pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    var fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    var fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    var fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    var activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    var deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    var activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    var blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    var unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen(function(_ref) {
            var historyAction = _ref.action, location = _ref.location, delta = _ref.delta;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            var blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                var nextHistoryUpdatePromise = new Promise(function(resolve) {
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed: function() {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(function() {
                            return init.history.go(delta);
                        });
                    },
                    reset: function() {
                        var blockers = new Map(state.blockers);
                        blockers.set(blockerKey, IDLE_BLOCKER);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            var _saveAppliedTransitions = function() {
                return persistAppliedTransitions(routerWindow, appliedViewTransitions);
            };
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = function() {
                return routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
            };
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation(Action.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach(function(_, key) {
            return deleteFetcher(key);
        });
        state.blockers.forEach(function(_, key) {
            return deleteBlocker(key);
        });
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return function() {
            return subscribers.delete(fn);
        };
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = _extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        var completedFetchers = [];
        var deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach(function(fetcher, key) {
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach(function(key) {
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        (0, _toConsumableArray._)(subscribers).forEach(function(subscriber) {
            return subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            });
        });
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach(function(key) {
                return state.fetchers.delete(key);
            });
            deletedFetchersKeys.forEach(function(key) {
                return deleteFetcher(key);
            });
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach(function(key) {
            return deletedFetchers.delete(key);
        });
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        var flushSync = (_temp === void 0 ? {} : _temp).flushSync;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        var isActionReload = state.actionData != null && state.navigation.formMethod != null && isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        var actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        var loaderData = newState.loaderData ? mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        var blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach(function(_, k) {
                return blockers.set(k, IDLE_BLOCKER);
            });
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        var preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === Action.Pop) ;
        else if (pendingAction === Action.Push) init.history.push(location, location.state);
        else if (pendingAction === Action.Replace) init.history.replace(location, location.state);
        var viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === Action.Pop) {
            // Forward takes precedence so they behave like the original navigation
            var priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            var toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState(_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: IDLE_NAVIGATION,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = Action.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    function navigate(to, opts) {
        return _navigate.apply(this, arguments);
    }
    function _navigate() {
        _navigate = // Trigger a navigation event, which can either be a numerical POP or a PUSH
        // replace with an optional submission
        (0, _asyncToGenerator._)(function(to, opts) {
            var normalizedPath, _normalizeNavigateOptions, path, submission, error, currentLocation, nextLocation, userReplace, historyAction, preventScrollReset, flushSync, blockerKey;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (typeof to === "number") {
                            init.history.go(to);
                            return [
                                2
                            ];
                        }
                        normalizedPath = normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
                        _normalizeNavigateOptions = normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts), path = _normalizeNavigateOptions.path, submission = _normalizeNavigateOptions.submission, error = _normalizeNavigateOptions.error;
                        currentLocation = state.location;
                        nextLocation = createLocation(state.location, path, opts && opts.state);
                        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
                        // URL from window.location, so we need to encode it here so the behavior
                        // remains the same as POP and non-data-router usages.  new URL() does all
                        // the same encoding we'd get from a history.pushState/window.location read
                        // without having to touch history
                        nextLocation = _extends({}, nextLocation, init.history.encodeLocation(nextLocation));
                        userReplace = opts && opts.replace != null ? opts.replace : undefined;
                        historyAction = Action.Push;
                        if (userReplace === true) historyAction = Action.Replace;
                        else if (userReplace === false) ;
                        else if (submission != null && isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
                        // users don't have to double-click the back button to get to the prior
                        // location.  If the user redirects to a different location from the
                        // action/loader this will be ignored and the redirect will be a PUSH
                        historyAction = Action.Replace;
                        preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
                        flushSync = (opts && opts.flushSync) === true;
                        blockerKey = shouldBlockNavigation({
                            currentLocation: currentLocation,
                            nextLocation: nextLocation,
                            historyAction: historyAction
                        });
                        if (blockerKey) {
                            // Put the blocker into a blocked state
                            updateBlocker(blockerKey, {
                                state: "blocked",
                                location: nextLocation,
                                proceed: function() {
                                    updateBlocker(blockerKey, {
                                        state: "proceeding",
                                        proceed: undefined,
                                        reset: undefined,
                                        location: nextLocation
                                    });
                                    // Send the same navigation through
                                    navigate(to, opts);
                                },
                                reset: function() {
                                    var blockers = new Map(state.blockers);
                                    blockers.set(blockerKey, IDLE_BLOCKER);
                                    updateState({
                                        blockers: blockers
                                    });
                                }
                            });
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            startNavigation(historyAction, nextLocation, {
                                submission: submission,
                                // Send through the formData serialization error if we have one so we can
                                // render at the right error boundary after we match routes
                                pendingError: error,
                                preventScrollReset: preventScrollReset,
                                replace: opts && opts.replace,
                                enableViewTransition: opts && opts.viewTransition,
                                flushSync: flushSync
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return _navigate.apply(this, arguments);
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    function startNavigation(historyAction, location, opts) {
        return _startNavigation.apply(this, arguments);
    }
    function _startNavigation() {
        _startNavigation = // Start a navigation to the given action/location.  Can optionally provide a
        // overrideNavigation which will override the normalLoad in the case of a redirect
        // navigation
        (0, _asyncToGenerator._)(function(historyAction, location, opts) {
            var routesToUse, loadingNavigation, matches, flushSync, fogOfWar, _handleNavigational404, error, notFoundMatches, route, request, pendingActionResult, actionResult, _actionResult_pendingActionResult, routeId, result, _ref, shortCircuited, updatedMatches, loaderData, errors;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // Abort any in-progress navigations and start a new one. Unset any ongoing
                        // uninterrupted revalidations unless told otherwise, since we want this
                        // new navigation to update history normally
                        pendingNavigationController && pendingNavigationController.abort();
                        pendingNavigationController = null;
                        pendingAction = historyAction;
                        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
                        // Save the current scroll position every time we start a new navigation,
                        // and track whether we should reset scroll on completion
                        saveScrollPosition(state.location, state.matches);
                        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
                        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        loadingNavigation = opts && opts.overrideNavigation;
                        matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
                        state.matches : matchRoutes(routesToUse, location, basename);
                        flushSync = (opts && opts.flushSync) === true;
                        // Short circuit if it's only a hash change and not a revalidation or
                        // mutation submission.
                        //
                        // Ignore on initial page loads because since the initial hydration will always
                        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
                        // which will default to a navigation to /page
                        if (matches && state.initialized && !isRevalidationRequired && isHashChangeOnly(state.location, location) && !(opts && opts.submission && isMutationMethod(opts.submission.formMethod))) {
                            completeNavigation(location, {
                                matches: matches
                            }, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
                        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
                        // Short circuit with a 404 on the root error boundary if we match nothing
                        if (!matches) {
                            _handleNavigational404 = handleNavigational404(location.pathname), error = _handleNavigational404.error, notFoundMatches = _handleNavigational404.notFoundMatches, route = _handleNavigational404.route;
                            completeNavigation(location, {
                                matches: notFoundMatches,
                                loaderData: {},
                                errors: (0, _defineProperty._)({}, route.id, error)
                            }, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        // Create a controller/Request for this navigation
                        pendingNavigationController = new AbortController();
                        request = createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
                        if (!(opts && opts.pendingError)) return [
                            3,
                            1
                        ];
                        // If we have a pendingError, it means the user attempted a GET submission
                        // with binary FormData so assign here and skip to handleLoaders.  That
                        // way we handle calling loaders above the boundary etc.  It's not really
                        // different from an actionError in that sense.
                        pendingActionResult = [
                            findNearestBoundary(matches).route.id,
                            {
                                type: ResultType.error,
                                error: opts.pendingError
                            }
                        ];
                        return [
                            3,
                            3
                        ];
                    case 1:
                        if (!(opts && opts.submission && isMutationMethod(opts.submission.formMethod))) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                                replace: opts.replace,
                                flushSync: flushSync
                            })
                        ];
                    case 2:
                        actionResult = _state.sent();
                        if (actionResult.shortCircuited) return [
                            2
                        ];
                        // If we received a 404 from handleAction, it's because we couldn't lazily
                        // discover the destination route so we don't want to call loaders
                        if (actionResult.pendingActionResult) {
                            _actionResult_pendingActionResult = (0, _slicedToArray._)(actionResult.pendingActionResult, 2), routeId = _actionResult_pendingActionResult[0], result = _actionResult_pendingActionResult[1];
                            if (isErrorResult(result) && isRouteErrorResponse(result.error) && result.error.status === 404) {
                                pendingNavigationController = null;
                                completeNavigation(location, {
                                    matches: actionResult.matches,
                                    loaderData: {},
                                    errors: (0, _defineProperty._)({}, routeId, result.error)
                                });
                                return [
                                    2
                                ];
                            }
                        }
                        matches = actionResult.matches || matches;
                        pendingActionResult = actionResult.pendingActionResult;
                        loadingNavigation = getLoadingNavigation(location, opts.submission);
                        flushSync = false;
                        // No need to do fog of war matching again on loader execution
                        fogOfWar.active = false;
                        // Create a GET request for the loaders
                        request = createClientSideRequest(init.history, request.url, request.signal);
                        _state.label = 3;
                    case 3:
                        return [
                            4,
                            handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult)
                        ];
                    case 4:
                        _ref = _state.sent(), shortCircuited = _ref.shortCircuited, updatedMatches = _ref.matches, loaderData = _ref.loaderData, errors = _ref.errors;
                        if (shortCircuited) return [
                            2
                        ];
                        // Clean up now that the action/loaders have completed.  Don't clean up if
                        // we short circuited because pendingNavigationController will have already
                        // been assigned to a new controller for the next navigation
                        pendingNavigationController = null;
                        completeNavigation(location, _extends({
                            matches: updatedMatches || matches
                        }, getActionDataForCommit(pendingActionResult), {
                            loaderData: loaderData,
                            errors: errors
                        }));
                        return [
                            2
                        ];
                }
            });
        });
        return _startNavigation.apply(this, arguments);
    }
    function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        return _handleAction.apply(this, arguments);
    }
    function _handleAction() {
        _handleAction = // Call the action matched by the leaf route for this navigation and handle
        // redirects/errors
        (0, _asyncToGenerator._)(function(request, location, submission, matches, isFogOfWar, opts) {
            var navigation, discoverResult, boundaryId, _handleNavigational404, notFoundMatches, error, route, result, actionMatch, results, replace, _$location, boundaryMatch;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (opts === void 0) opts = {};
                        interruptActiveLoads();
                        // Put us in a submitting state
                        navigation = getSubmittingNavigation(location, submission);
                        updateState({
                            navigation: navigation
                        }, {
                            flushSync: opts.flushSync === true
                        });
                        if (!isFogOfWar) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            discoverRoutes(matches, location.pathname, request.signal)
                        ];
                    case 1:
                        discoverResult = _state.sent();
                        if (discoverResult.type === "aborted") return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        else if (discoverResult.type === "error") {
                            boundaryId = findNearestBoundary(discoverResult.partialMatches).route.id;
                            return [
                                2,
                                {
                                    matches: discoverResult.partialMatches,
                                    pendingActionResult: [
                                        boundaryId,
                                        {
                                            type: ResultType.error,
                                            error: discoverResult.error
                                        }
                                    ]
                                }
                            ];
                        } else if (!discoverResult.matches) {
                            _handleNavigational404 = handleNavigational404(location.pathname), notFoundMatches = _handleNavigational404.notFoundMatches, error = _handleNavigational404.error, route = _handleNavigational404.route;
                            return [
                                2,
                                {
                                    matches: notFoundMatches,
                                    pendingActionResult: [
                                        route.id,
                                        {
                                            type: ResultType.error,
                                            error: error
                                        }
                                    ]
                                }
                            ];
                        } else matches = discoverResult.matches;
                        _state.label = 2;
                    case 2:
                        actionMatch = getTargetMatch(matches, location);
                        if (!(!actionMatch.route.action && !actionMatch.route.lazy)) return [
                            3,
                            3
                        ];
                        result = {
                            type: ResultType.error,
                            error: getInternalRouterError(405, {
                                method: request.method,
                                pathname: location.pathname,
                                routeId: actionMatch.route.id
                            })
                        };
                        return [
                            3,
                            5
                        ];
                    case 3:
                        return [
                            4,
                            callDataStrategy("action", state, request, [
                                actionMatch
                            ], matches, null)
                        ];
                    case 4:
                        results = _state.sent();
                        result = results[actionMatch.route.id];
                        if (request.signal.aborted) return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        _state.label = 5;
                    case 5:
                        if (!isRedirectResult(result)) return [
                            3,
                            7
                        ];
                        if (opts && opts.replace != null) replace = opts.replace;
                        else {
                            // If the user didn't explicity indicate replace behavior, replace if
                            // we redirected to the exact same location we're currently at to avoid
                            // double back-buttons
                            _$location = normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                            replace = _$location === state.location.pathname + state.location.search;
                        }
                        return [
                            4,
                            startRedirectNavigation(request, result, true, {
                                submission: submission,
                                replace: replace
                            })
                        ];
                    case 6:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 7:
                        if (isDeferredResult(result)) throw getInternalRouterError(400, {
                            type: "defer-action"
                        });
                        if (isErrorResult(result)) {
                            // Store off the pending error - we use it to determine which loaders
                            // to call and will commit it when we complete the navigation
                            boundaryMatch = findNearestBoundary(matches, actionMatch.route.id);
                            // By default, all submissions to the current location are REPLACE
                            // navigations, but if the action threw an error that'll be rendered in
                            // an errorElement, we fall back to PUSH so that the user can use the
                            // back button to get back to the pre-submission form location to try
                            // again
                            if ((opts && opts.replace) !== true) pendingAction = Action.Push;
                            return [
                                2,
                                {
                                    matches: matches,
                                    pendingActionResult: [
                                        boundaryMatch.route.id,
                                        result
                                    ]
                                }
                            ];
                        }
                        return [
                            2,
                            {
                                matches: matches,
                                pendingActionResult: [
                                    actionMatch.route.id,
                                    result
                                ]
                            }
                        ];
                }
            });
        });
        return _handleAction.apply(this, arguments);
    }
    function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        return _handleLoaders.apply(this, arguments);
    }
    function _handleLoaders() {
        _handleLoaders = // Call all applicable loaders for the given matches, handling redirects,
        // errors, etc.
        (0, _asyncToGenerator._)(function(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
            var loadingNavigation, activeSubmission, shouldUpdateNavigationState, actionData, discoverResult, boundaryId, _handleNavigational404, error, notFoundMatches, route, routesToUse, _getMatchesToLoad, matchesToLoad, revalidatingFetchers, updatedFetchers, updates, actionData1, abortPendingFetchRevalidations, _ref, loaderResults, fetcherResults, redirect, _processLoaderData, loaderData, errors, updatedFetchers1, didAbortFetchLoads, shouldUpdateFetchers;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // Figure out the right navigation we want to use for data loading
                        loadingNavigation = overrideNavigation || getLoadingNavigation(location, submission);
                        // If this was a redirect from an action we don't have a "submission" but
                        // we have it on the loading navigation so use that if available
                        activeSubmission = submission || fetcherSubmission || getSubmissionFromNavigation(loadingNavigation);
                        // If this is an uninterrupted revalidation, we remain in our current idle
                        // state.  If not, we need to switch to our loading state and load data,
                        // preserving any new action data or existing action data (in the case of
                        // a revalidation interrupting an actionReload)
                        // If we have partialHydration enabled, then don't update the state for the
                        // initial data load since it's not a "navigation"
                        shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
                        if (!isFogOfWar) return [
                            3,
                            2
                        ];
                        if (shouldUpdateNavigationState) {
                            actionData = getUpdatedActionData(pendingActionResult);
                            updateState(_extends({
                                navigation: loadingNavigation
                            }, actionData !== undefined ? {
                                actionData: actionData
                            } : {}), {
                                flushSync: flushSync
                            });
                        }
                        return [
                            4,
                            discoverRoutes(matches, location.pathname, request.signal)
                        ];
                    case 1:
                        discoverResult = _state.sent();
                        if (discoverResult.type === "aborted") return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        else if (discoverResult.type === "error") {
                            boundaryId = findNearestBoundary(discoverResult.partialMatches).route.id;
                            return [
                                2,
                                {
                                    matches: discoverResult.partialMatches,
                                    loaderData: {},
                                    errors: (0, _defineProperty._)({}, boundaryId, discoverResult.error)
                                }
                            ];
                        } else if (!discoverResult.matches) {
                            _handleNavigational404 = handleNavigational404(location.pathname), error = _handleNavigational404.error, notFoundMatches = _handleNavigational404.notFoundMatches, route = _handleNavigational404.route;
                            return [
                                2,
                                {
                                    matches: notFoundMatches,
                                    loaderData: {},
                                    errors: (0, _defineProperty._)({}, route.id, error)
                                }
                            ];
                        } else matches = discoverResult.matches;
                        _state.label = 2;
                    case 2:
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        _getMatchesToLoad = (0, _slicedToArray._)(getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult), 2), matchesToLoad = _getMatchesToLoad[0], revalidatingFetchers = _getMatchesToLoad[1];
                        // Cancel pending deferreds for no-longer-matched routes or routes we're
                        // about to reload.  Note that if this is an action reload we would have
                        // already cancelled all pending deferreds so this would be a no-op
                        cancelActiveDeferreds(function(routeId) {
                            return !(matches && matches.some(function(m) {
                                return m.route.id === routeId;
                            })) || matchesToLoad && matchesToLoad.some(function(m) {
                                return m.route.id === routeId;
                            });
                        });
                        pendingNavigationLoadId = ++incrementingLoadId;
                        // Short circuit if we have no loaders to run
                        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
                            updatedFetchers = markFetchRedirectsDone();
                            completeNavigation(location, _extends({
                                matches: matches,
                                loaderData: {},
                                // Commit pending error if we're short circuiting
                                errors: pendingActionResult && isErrorResult(pendingActionResult[1]) ? (0, _defineProperty._)({}, pendingActionResult[0], pendingActionResult[1].error) : null
                            }, getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                                fetchers: new Map(state.fetchers)
                            } : {}), {
                                flushSync: flushSync
                            });
                            return [
                                2,
                                {
                                    shortCircuited: true
                                }
                            ];
                        }
                        if (shouldUpdateNavigationState) {
                            updates = {};
                            if (!isFogOfWar) {
                                // Only update navigation/actionNData if we didn't already do it above
                                updates.navigation = loadingNavigation;
                                actionData1 = getUpdatedActionData(pendingActionResult);
                                if (actionData1 !== undefined) updates.actionData = actionData1;
                            }
                            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
                            updateState(updates, {
                                flushSync: flushSync
                            });
                        }
                        revalidatingFetchers.forEach(function(rf) {
                            abortFetcher(rf.key);
                            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
                            // (via deleteFetcher) does not abort the triggering navigation that
                            // triggered the revalidation
                            fetchControllers.set(rf.key, rf.controller);
                        });
                        // Proxy navigation abort through to revalidation fetchers
                        abortPendingFetchRevalidations = function() {
                            return revalidatingFetchers.forEach(function(f) {
                                return abortFetcher(f.key);
                            });
                        };
                        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
                        return [
                            4,
                            callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request)
                        ];
                    case 3:
                        _ref = _state.sent(), loaderResults = _ref.loaderResults, fetcherResults = _ref.fetcherResults;
                        if (request.signal.aborted) return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        // Clean up _after_ loaders have completed.  Don't clean up if we short
                        // circuited because fetchControllers would have been aborted and
                        // reassigned to new controllers for the next navigation
                        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
                        revalidatingFetchers.forEach(function(rf) {
                            return fetchControllers.delete(rf.key);
                        });
                        // If any loaders returned a redirect Response, start a new REPLACE navigation
                        redirect = findRedirect(loaderResults);
                        if (!redirect) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            startRedirectNavigation(request, redirect.result, true, {
                                replace: replace
                            })
                        ];
                    case 4:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 5:
                        redirect = findRedirect(fetcherResults);
                        if (!redirect) return [
                            3,
                            7
                        ];
                        // If this redirect came from a fetcher make sure we mark it in
                        // fetchRedirectIds so it doesn't get revalidated on the next set of
                        // loader executions
                        fetchRedirectIds.add(redirect.key);
                        return [
                            4,
                            startRedirectNavigation(request, redirect.result, true, {
                                replace: replace
                            })
                        ];
                    case 6:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 7:
                        // Process and commit output from loaders
                        _processLoaderData = processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds), loaderData = _processLoaderData.loaderData, errors = _processLoaderData.errors;
                        // Wire up subscribers to update loaderData as promises settle
                        activeDeferreds.forEach(function(deferredData, routeId) {
                            deferredData.subscribe(function(aborted) {
                                // Note: No need to updateState here since the TrackedPromise on
                                // loaderData is stable across resolve/reject
                                // Remove this instance if we were aborted or if promises have settled
                                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
                            });
                        });
                        // Preserve SSR errors during partial hydration
                        if (future.v7_partialHydration && initialHydration && state.errors) errors = _extends({}, state.errors, errors);
                        updatedFetchers1 = markFetchRedirectsDone();
                        didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
                        shouldUpdateFetchers = updatedFetchers1 || didAbortFetchLoads || revalidatingFetchers.length > 0;
                        return [
                            2,
                            _extends({
                                matches: matches,
                                loaderData: loaderData,
                                errors: errors
                            }, shouldUpdateFetchers ? {
                                fetchers: new Map(state.fetchers)
                            } : {})
                        ];
                }
            });
        });
        return _handleLoaders.apply(this, arguments);
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return (0, _defineProperty._)({}, pendingActionResult[0], pendingActionResult[1].data);
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach(function(rf) {
            var fetcher = state.fetchers.get(rf.key);
            var revalidatingFetcher = getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        var flushSync = (opts && opts.flushSync) === true;
        var routesToUse = inFlightDataRoutes || dataRoutes;
        var normalizedPath = normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        var matches = matchRoutes(routesToUse, normalizedPath, basename);
        var fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        var _normalizeNavigateOptions = normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts), path = _normalizeNavigateOptions.path, submission = _normalizeNavigateOptions.submission, error = _normalizeNavigateOptions.error;
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        var match = getTargetMatch(matches, path);
        var preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        return _handleFetcherAction.apply(this, arguments);
    }
    function _handleFetcherAction() {
        _handleFetcherAction = // Call the action for the matched fetcher.submit(), and then handle redirects,
        // errors, and revalidation
        (0, _asyncToGenerator._)(function(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
            var existingFetcher, abortController, fetchRequest, discoverResult, originatingLoadId, actionResults, actionResult, nextLocation, revalidationRequest, routesToUse, matches, loadId, loadFetcher, _getMatchesToLoad, matchesToLoad, revalidatingFetchers, abortPendingFetchRevalidations, _ref, loaderResults, fetcherResults, redirect, _processLoaderData, loaderData, errors, doneFetcher;
            function detectAndHandle405Error(m) {
                if (!m.route.action && !m.route.lazy) {
                    var error = getInternalRouterError(405, {
                        method: submission.formMethod,
                        pathname: path,
                        routeId: routeId
                    });
                    setFetcherError(key, routeId, error, {
                        flushSync: flushSync
                    });
                    return true;
                }
                return false;
            }
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        interruptActiveLoads();
                        fetchLoadMatches.delete(key);
                        if (!isFogOfWar && detectAndHandle405Error(match)) return [
                            2
                        ];
                        // Put this fetcher into it's submitting state
                        existingFetcher = state.fetchers.get(key);
                        updateFetcherState(key, getSubmittingFetcher(submission, existingFetcher), {
                            flushSync: flushSync
                        });
                        abortController = new AbortController();
                        fetchRequest = createClientSideRequest(init.history, path, abortController.signal, submission);
                        if (!isFogOfWar) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key)
                        ];
                    case 1:
                        discoverResult = _state.sent();
                        if (discoverResult.type === "aborted") return [
                            2
                        ];
                        else if (discoverResult.type === "error") {
                            setFetcherError(key, routeId, discoverResult.error, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        } else if (!discoverResult.matches) {
                            setFetcherError(key, routeId, getInternalRouterError(404, {
                                pathname: path
                            }), {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        } else {
                            requestMatches = discoverResult.matches;
                            match = getTargetMatch(requestMatches, path);
                            if (detectAndHandle405Error(match)) return [
                                2
                            ];
                        }
                        _state.label = 2;
                    case 2:
                        // Call the action for the fetcher
                        fetchControllers.set(key, abortController);
                        originatingLoadId = incrementingLoadId;
                        return [
                            4,
                            callDataStrategy("action", state, fetchRequest, [
                                match
                            ], requestMatches, key)
                        ];
                    case 3:
                        actionResults = _state.sent();
                        actionResult = actionResults[match.route.id];
                        if (fetchRequest.signal.aborted) {
                            // We can delete this so long as we weren't aborted by our own fetcher
                            // re-submit which would have put _new_ controller is in fetchControllers
                            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
                            return [
                                2
                            ];
                        }
                        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
                        // or redirects processed for unmounted fetchers so we just revert them to
                        // idle
                        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
                            if (isRedirectResult(actionResult) || isErrorResult(actionResult)) {
                                updateFetcherState(key, getDoneFetcher(undefined));
                                return [
                                    2
                                ];
                            }
                        } else {
                            if (isRedirectResult(actionResult)) {
                                fetchControllers.delete(key);
                                if (pendingNavigationLoadId > originatingLoadId) {
                                    // A new navigation was kicked off after our action started, so that
                                    // should take precedence over this redirect navigation.  We already
                                    // set isRevalidationRequired so all loaders for the new route should
                                    // fire unless opted out via shouldRevalidate
                                    updateFetcherState(key, getDoneFetcher(undefined));
                                    return [
                                        2
                                    ];
                                } else {
                                    fetchRedirectIds.add(key);
                                    updateFetcherState(key, getLoadingFetcher(submission));
                                    return [
                                        2,
                                        startRedirectNavigation(fetchRequest, actionResult, false, {
                                            fetcherSubmission: submission,
                                            preventScrollReset: preventScrollReset
                                        })
                                    ];
                                }
                            }
                            // Process any non-redirect errors thrown
                            if (isErrorResult(actionResult)) {
                                setFetcherError(key, routeId, actionResult.error);
                                return [
                                    2
                                ];
                            }
                        }
                        if (isDeferredResult(actionResult)) throw getInternalRouterError(400, {
                            type: "defer-action"
                        });
                        // Start the data load for current matches, or the next location if we're
                        // in the middle of a navigation
                        nextLocation = state.navigation.location || state.location;
                        revalidationRequest = createClientSideRequest(init.history, nextLocation, abortController.signal);
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        matches = state.navigation.state !== "idle" ? matchRoutes(routesToUse, state.navigation.location, basename) : state.matches;
                        invariant(matches, "Didn't find any matches after fetcher action");
                        loadId = ++incrementingLoadId;
                        fetchReloadIds.set(key, loadId);
                        loadFetcher = getLoadingFetcher(submission, actionResult.data);
                        state.fetchers.set(key, loadFetcher);
                        _getMatchesToLoad = (0, _slicedToArray._)(getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
                            match.route.id,
                            actionResult
                        ]), 2), matchesToLoad = _getMatchesToLoad[0], revalidatingFetchers = _getMatchesToLoad[1];
                        // Put all revalidating fetchers into the loading state, except for the
                        // current fetcher which we want to keep in it's current loading state which
                        // contains it's action submission info + action data
                        revalidatingFetchers.filter(function(rf) {
                            return rf.key !== key;
                        }).forEach(function(rf) {
                            var staleKey = rf.key;
                            var existingFetcher = state.fetchers.get(staleKey);
                            var revalidatingFetcher = getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
                            state.fetchers.set(staleKey, revalidatingFetcher);
                            abortFetcher(staleKey);
                            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
                        });
                        updateState({
                            fetchers: new Map(state.fetchers)
                        });
                        abortPendingFetchRevalidations = function() {
                            return revalidatingFetchers.forEach(function(rf) {
                                return abortFetcher(rf.key);
                            });
                        };
                        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
                        return [
                            4,
                            callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest)
                        ];
                    case 4:
                        _ref = _state.sent(), loaderResults = _ref.loaderResults, fetcherResults = _ref.fetcherResults;
                        if (abortController.signal.aborted) return [
                            2
                        ];
                        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
                        fetchReloadIds.delete(key);
                        fetchControllers.delete(key);
                        revalidatingFetchers.forEach(function(r) {
                            return fetchControllers.delete(r.key);
                        });
                        redirect = findRedirect(loaderResults);
                        if (redirect) return [
                            2,
                            startRedirectNavigation(revalidationRequest, redirect.result, false, {
                                preventScrollReset: preventScrollReset
                            })
                        ];
                        redirect = findRedirect(fetcherResults);
                        if (redirect) {
                            // If this redirect came from a fetcher make sure we mark it in
                            // fetchRedirectIds so it doesn't get revalidated on the next set of
                            // loader executions
                            fetchRedirectIds.add(redirect.key);
                            return [
                                2,
                                startRedirectNavigation(revalidationRequest, redirect.result, false, {
                                    preventScrollReset: preventScrollReset
                                })
                            ];
                        }
                        // Process and commit output from loaders
                        _processLoaderData = processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds), loaderData = _processLoaderData.loaderData, errors = _processLoaderData.errors;
                        // Since we let revalidations complete even if the submitting fetcher was
                        // deleted, only put it back to idle if it hasn't been deleted
                        if (state.fetchers.has(key)) {
                            doneFetcher = getDoneFetcher(actionResult.data);
                            state.fetchers.set(key, doneFetcher);
                        }
                        abortStaleFetchLoads(loadId);
                        // If we are currently in a navigation loading state and this fetcher is
                        // more recent than the navigation, we want the newer data so abort the
                        // navigation and complete it with the fetcher data
                        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
                            invariant(pendingAction, "Expected pending action");
                            pendingNavigationController && pendingNavigationController.abort();
                            completeNavigation(state.navigation.location, {
                                matches: matches,
                                loaderData: loaderData,
                                errors: errors,
                                fetchers: new Map(state.fetchers)
                            });
                        } else {
                            // otherwise just update with the fetcher data, preserving any existing
                            // loaderData for loaders that did not need to reload.  We have to
                            // manually merge here since we aren't going through completeNavigation
                            updateState({
                                errors: errors,
                                loaderData: mergeLoaderData(state.loaderData, loaderData, matches, errors),
                                fetchers: new Map(state.fetchers)
                            });
                            isRevalidationRequired = false;
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return _handleFetcherAction.apply(this, arguments);
    }
    function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        return _handleFetcherLoader.apply(this, arguments);
    }
    function _handleFetcherLoader() {
        _handleFetcherLoader = // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
        (0, _asyncToGenerator._)(function(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
            var existingFetcher, abortController, fetchRequest, discoverResult, originatingLoadId, results, result;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        existingFetcher = state.fetchers.get(key);
                        updateFetcherState(key, getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
                            flushSync: flushSync
                        });
                        abortController = new AbortController();
                        fetchRequest = createClientSideRequest(init.history, path, abortController.signal);
                        if (!isFogOfWar) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key)
                        ];
                    case 1:
                        discoverResult = _state.sent();
                        if (discoverResult.type === "aborted") return [
                            2
                        ];
                        else if (discoverResult.type === "error") {
                            setFetcherError(key, routeId, discoverResult.error, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        } else if (!discoverResult.matches) {
                            setFetcherError(key, routeId, getInternalRouterError(404, {
                                pathname: path
                            }), {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        } else {
                            matches = discoverResult.matches;
                            match = getTargetMatch(matches, path);
                        }
                        _state.label = 2;
                    case 2:
                        // Call the loader for this fetcher route match
                        fetchControllers.set(key, abortController);
                        originatingLoadId = incrementingLoadId;
                        return [
                            4,
                            callDataStrategy("loader", state, fetchRequest, [
                                match
                            ], matches, key)
                        ];
                    case 3:
                        results = _state.sent();
                        result = results[match.route.id];
                        if (!isDeferredResult(result)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            resolveDeferredData(result, fetchRequest.signal, true)
                        ];
                    case 4:
                        result = _state.sent() || result;
                        _state.label = 5;
                    case 5:
                        // We can delete this so long as we weren't aborted by our our own fetcher
                        // re-load which would have put _new_ controller is in fetchControllers
                        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
                        if (fetchRequest.signal.aborted) return [
                            2
                        ];
                        // We don't want errors bubbling up or redirects followed for unmounted
                        // fetchers, so short circuit here if it was removed from the UI
                        if (deletedFetchers.has(key)) {
                            updateFetcherState(key, getDoneFetcher(undefined));
                            return [
                                2
                            ];
                        }
                        if (!isRedirectResult(result)) return [
                            3,
                            8
                        ];
                        if (!(pendingNavigationLoadId > originatingLoadId)) return [
                            3,
                            6
                        ];
                        // A new navigation was kicked off after our loader started, so that
                        // should take precedence over this redirect navigation
                        updateFetcherState(key, getDoneFetcher(undefined));
                        return [
                            2
                        ];
                    case 6:
                        fetchRedirectIds.add(key);
                        return [
                            4,
                            startRedirectNavigation(fetchRequest, result, false, {
                                preventScrollReset: preventScrollReset
                            })
                        ];
                    case 7:
                        _state.sent();
                        return [
                            2
                        ];
                    case 8:
                        // Process any non-redirect errors thrown
                        if (isErrorResult(result)) {
                            setFetcherError(key, routeId, result.error);
                            return [
                                2
                            ];
                        }
                        invariant(!isDeferredResult(result), "Unhandled fetcher deferred data");
                        // Put the fetcher back into an idle state
                        updateFetcherState(key, getDoneFetcher(result.data));
                        return [
                            2
                        ];
                }
            });
        });
        return _handleFetcherLoader.apply(this, arguments);
    }
    function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        return _startRedirectNavigation.apply(this, arguments);
    }
    function _startRedirectNavigation() {
        _startRedirectNavigation = /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ (0, _asyncToGenerator._)(function(request, redirect, isNavigation, _temp2) {
            var _ref, submission, fetcherSubmission, preventScrollReset, replace, location, redirectLocation, isDocumentReload, url, redirectHistoryAction, _state_navigation, formMethod, formAction, formEncType, activeSubmission, overrideNavigation;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _temp2 === void 0 ? {} : _temp2, submission = _ref.submission, fetcherSubmission = _ref.fetcherSubmission, preventScrollReset = _ref.preventScrollReset, replace = _ref.replace;
                        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
                        location = redirect.response.headers.get("Location");
                        invariant(location, "Expected a Location header on the redirect Response");
                        location = normalizeRedirectLocation(location, new URL(request.url), basename);
                        redirectLocation = createLocation(state.location, location, {
                            _isRedirect: true
                        });
                        if (isBrowser) {
                            isDocumentReload = false;
                            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
                            isDocumentReload = true;
                            else if (ABSOLUTE_URL_REGEX.test(location)) {
                                url = init.history.createURL(location);
                                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                                stripBasename(url.pathname, basename) == null;
                            }
                            if (isDocumentReload) {
                                if (replace) routerWindow.location.replace(location);
                                else routerWindow.location.assign(location);
                                return [
                                    2
                                ];
                            }
                        }
                        // There's no need to abort on redirects, since we don't detect the
                        // redirect until the action/loaders have settled
                        pendingNavigationController = null;
                        redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? Action.Replace : Action.Push;
                        // Use the incoming submission if provided, fallback on the active one in
                        // state.navigation
                        _state_navigation = state.navigation, formMethod = _state_navigation.formMethod, formAction = _state_navigation.formAction, formEncType = _state_navigation.formEncType;
                        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = getSubmissionFromNavigation(state.navigation);
                        // If this was a 307/308 submission we want to preserve the HTTP method and
                        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
                        // redirected location
                        activeSubmission = submission || fetcherSubmission;
                        if (!(redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && isMutationMethod(activeSubmission.formMethod))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            startNavigation(redirectHistoryAction, redirectLocation, {
                                submission: _extends({}, activeSubmission, {
                                    formAction: location
                                }),
                                // Preserve these flags across redirects
                                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        // If we have a navigation submission, we will preserve it through the
                        // redirect navigation
                        overrideNavigation = getLoadingNavigation(redirectLocation, submission);
                        return [
                            4,
                            startNavigation(redirectHistoryAction, redirectLocation, {
                                overrideNavigation: overrideNavigation,
                                // Send fetcher submissions through for shouldRevalidate
                                fetcherSubmission: fetcherSubmission,
                                // Preserve these flags across redirects
                                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
                            })
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return _startRedirectNavigation.apply(this, arguments);
    }
    function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        return _callDataStrategy.apply(this, arguments);
    }
    function _callDataStrategy() {
        _callDataStrategy = // Utility wrapper for calling dataStrategy client-side without having to
        // pass around the manifest, mapRouteProperties, etc.
        (0, _asyncToGenerator._)(function(type, state, request, matchesToLoad, matches, fetcherKey) {
            var results, dataResults, e, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step_value, routeId, result, response, err;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        dataResults = {};
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties)
                        ];
                    case 2:
                        results = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        // If the outer dataStrategy method throws, just return the error for all
                        // matches - and it'll naturally bubble to the root
                        matchesToLoad.forEach(function(m) {
                            dataResults[m.route.id] = {
                                type: ResultType.error,
                                error: e
                            };
                        });
                        return [
                            2,
                            dataResults
                        ];
                    case 4:
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _state.label = 5;
                    case 5:
                        _state.trys.push([
                            5,
                            11,
                            12,
                            13
                        ]);
                        _iterator = Object.entries(results)[Symbol.iterator]();
                        _state.label = 6;
                    case 6:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            10
                        ];
                        _step_value = (0, _slicedToArray._)(_step.value, 2), routeId = _step_value[0], result = _step_value[1];
                        if (!isRedirectDataStrategyResultResult(result)) return [
                            3,
                            7
                        ];
                        response = result.result;
                        dataResults[routeId] = {
                            type: ResultType.redirect,
                            response: normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
                        };
                        return [
                            3,
                            9
                        ];
                    case 7:
                        return [
                            4,
                            convertDataStrategyResultToDataResult(result)
                        ];
                    case 8:
                        dataResults[routeId] = _state.sent();
                        _state.label = 9;
                    case 9:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            6
                        ];
                    case 10:
                        return [
                            3,
                            13
                        ];
                    case 11:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            13
                        ];
                    case 12:
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2,
                            dataResults
                        ];
                }
            });
        });
        return _callDataStrategy.apply(this, arguments);
    }
    function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        return _callLoadersAndMaybeResolveData.apply(this, arguments);
    }
    function _callLoadersAndMaybeResolveData() {
        _callLoadersAndMaybeResolveData = (0, _asyncToGenerator._)(function(state, matches, matchesToLoad, fetchersToLoad, request) {
            var currentMatches, loaderResultsPromise, fetcherResultsPromise, loaderResults, fetcherResults;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        currentMatches = state.matches;
                        // Kick off loaders and fetchers in parallel
                        loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
                        fetcherResultsPromise = Promise.all(fetchersToLoad.map(/*#__PURE__*/ function() {
                            var _ref = (0, _asyncToGenerator._)(function(f) {
                                var results, result;
                                return (0, _tsGenerator._)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            if (!(f.matches && f.match && f.controller)) return [
                                                3,
                                                2
                                            ];
                                            return [
                                                4,
                                                callDataStrategy("loader", state, createClientSideRequest(init.history, f.path, f.controller.signal), [
                                                    f.match
                                                ], f.matches, f.key)
                                            ];
                                        case 1:
                                            results = _state.sent();
                                            result = results[f.match.route.id];
                                            // Fetcher results are keyed by fetcher key from here on out, not routeId
                                            return [
                                                2,
                                                (0, _defineProperty._)({}, f.key, result)
                                            ];
                                        case 2:
                                            return [
                                                2,
                                                Promise.resolve((0, _defineProperty._)({}, f.key, {
                                                    type: ResultType.error,
                                                    error: getInternalRouterError(404, {
                                                        pathname: f.path
                                                    })
                                                }))
                                            ];
                                        case 3:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function(f) {
                                return _ref.apply(this, arguments);
                            };
                        }()));
                        return [
                            4,
                            loaderResultsPromise
                        ];
                    case 1:
                        loaderResults = _state.sent();
                        return [
                            4,
                            fetcherResultsPromise
                        ];
                    case 2:
                        fetcherResults = _state.sent().reduce(function(acc, r) {
                            return Object.assign(acc, r);
                        }, {});
                        return [
                            4,
                            Promise.all([
                                resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
                                resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
                            ])
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2,
                            {
                                loaderResults: loaderResults,
                                fetcherResults: fetcherResults
                            }
                        ];
                }
            });
        });
        return _callLoadersAndMaybeResolveData.apply(this, arguments);
    }
    function interruptActiveLoads() {
        var // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        _cancelledDeferredRoutes;
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        (_cancelledDeferredRoutes = cancelledDeferredRoutes).push.apply(_cancelledDeferredRoutes, (0, _toConsumableArray._)(cancelActiveDeferreds()));
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach(function(_, key) {
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        var boundaryMatch = findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: (0, _defineProperty._)({}, boundaryMatch.route.id, error),
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || IDLE_FETCHER;
    }
    function deleteFetcher(key) {
        var fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        var count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        var controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var fetcher = getFetcher(key);
                var doneFetcher = getDoneFetcher(fetcher.data);
                state.fetchers.set(key, doneFetcher);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    function markFetchRedirectsDone() {
        var doneKeys = [];
        var updatedFetchers = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = fetchRedirectIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var fetcher = state.fetchers.get(key);
                invariant(fetcher, "Expected fetcher: " + key);
                if (fetcher.state === "loading") {
                    fetchRedirectIds.delete(key);
                    doneKeys.push(key);
                    updatedFetchers = true;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        var yeetedKeys = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = fetchReloadIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, _slicedToArray._)(_step.value, 2), key = _step_value[0], id = _step_value[1];
                if (id < landedId) {
                    var fetcher = state.fetchers.get(key);
                    invariant(fetcher, "Expected fetcher: " + key);
                    if (fetcher.state === "loading") {
                        abortFetcher(key);
                        fetchReloadIds.delete(key);
                        yeetedKeys.push(key);
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        var blocker = state.blockers.get(key) || IDLE_BLOCKER;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        var blocker = state.blockers.get(key) || IDLE_BLOCKER;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        invariant(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        var blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        var currentLocation = _ref2.currentLocation, nextLocation = _ref2.nextLocation, historyAction = _ref2.historyAction;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) warning(false, "A router only supports one blocker at a time");
        var entries = Array.from(blockerFunctions.entries());
        var _entries_ = (0, _slicedToArray._)(entries[entries.length - 1], 2), blockerKey = _entries_[0], blockerFunction = _entries_[1];
        var blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        var error = getInternalRouterError(404, {
            pathname: pathname
        });
        var routesToUse = inFlightDataRoutes || dataRoutes;
        var _getShortCircuitMatches = getShortCircuitMatches(routesToUse), matches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        var cancelledRouteIds = [];
        activeDeferreds.forEach(function(dfd, routeId) {
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === IDLE_NAVIGATION) {
            initialScrollRestored = true;
            var y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return function() {
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            var key = getScrollRestorationKey(location, matches.map(function(m) {
                return convertRouteMatchToUiMatch(m, state.loaderData);
            }));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            var key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            var key = getScrollKey(location, matches);
            var y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                var fogMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                var partialMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    function discoverRoutes(matches, pathname, signal, fetcherKey) {
        return _discoverRoutes.apply(this, arguments);
    }
    function _discoverRoutes() {
        _discoverRoutes = (0, _asyncToGenerator._)(function(matches, pathname, signal, fetcherKey) {
            var _loop, partialMatches, _ret;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _loop = function() {
                            var isNonHMR, routesToUse, localManifest, e, newMatches, newPartialMatches;
                            return (0, _tsGenerator._)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        isNonHMR = inFlightDataRoutes == null;
                                        routesToUse = inFlightDataRoutes || dataRoutes;
                                        localManifest = manifest;
                                        _state.label = 1;
                                    case 1:
                                        _state.trys.push([
                                            1,
                                            3,
                                            4,
                                            5
                                        ]);
                                        return [
                                            4,
                                            patchRoutesOnNavigationImpl({
                                                signal: signal,
                                                path: pathname,
                                                matches: partialMatches,
                                                fetcherKey: fetcherKey,
                                                patch: function(routeId, children) {
                                                    if (signal.aborted) return;
                                                    patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                                                }
                                            })
                                        ];
                                    case 2:
                                        _state.sent();
                                        return [
                                            3,
                                            5
                                        ];
                                    case 3:
                                        e = _state.sent();
                                        return [
                                            2,
                                            {
                                                v: {
                                                    type: "error",
                                                    error: e,
                                                    partialMatches: partialMatches
                                                }
                                            }
                                        ];
                                    case 4:
                                        // If we are not in the middle of an HMR revalidation and we changed the
                                        // routes, provide a new identity so when we `updateState` at the end of
                                        // this navigation/fetch `router.routes` will be a new identity and
                                        // trigger a re-run of memoized `router.routes` dependencies.
                                        // HMR will already update the identity and reflow when it lands
                                        // `inFlightDataRoutes` in `completeNavigation`
                                        if (isNonHMR && !signal.aborted) dataRoutes = (0, _toConsumableArray._)(dataRoutes);
                                        return [
                                            7
                                        ];
                                    case 5:
                                        if (signal.aborted) return [
                                            2,
                                            {
                                                v: {
                                                    type: "aborted"
                                                }
                                            }
                                        ];
                                        newMatches = matchRoutes(routesToUse, pathname, basename);
                                        if (newMatches) return [
                                            2,
                                            {
                                                v: {
                                                    type: "success",
                                                    matches: newMatches
                                                }
                                            }
                                        ];
                                        newPartialMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
                                        // Avoid loops if the second pass results in the same partial matches
                                        if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every(function(m, i) {
                                            return m.route.id === newPartialMatches[i].route.id;
                                        })) return [
                                            2,
                                            {
                                                v: {
                                                    type: "success",
                                                    matches: null
                                                }
                                            }
                                        ];
                                        partialMatches = newPartialMatches;
                                        return [
                                            2
                                        ];
                                }
                            });
                        };
                        if (!patchRoutesOnNavigationImpl) return [
                            2,
                            {
                                type: "success",
                                matches: matches
                            }
                        ];
                        partialMatches = matches;
                        _state.label = 1;
                    case 1:
                        if (!true) return [
                            3,
                            3
                        ];
                        return [
                            5,
                            (0, _tsValues._)(_loop())
                        ];
                    case 2:
                        _ret = _state.sent();
                        if ((0, _typeOf._)(_ret) === "object") return [
                            2,
                            _ret.v
                        ];
                        return [
                            3,
                            1
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return _discoverRoutes.apply(this, arguments);
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = convertRoutesToDataRoutes(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        var isNonHMR = inFlightDataRoutes == null;
        var routesToUse = inFlightDataRoutes || dataRoutes;
        patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = (0, _toConsumableArray._)(dataRoutes);
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: function(to) {
            return init.history.createHref(to);
        },
        encodeLocation: function(to) {
            return init.history.encodeLocation(to);
        },
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes: _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
var UNSAFE_DEFERRED_SYMBOL = Symbol("deferred");
function createStaticHandler(routes, opts) {
    invariant(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    var manifest = {};
    var basename = (opts ? opts.basename : null) || "/";
    var mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        var detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = function(route) {
            return {
                hasErrorBoundary: detectErrorBoundary(route)
            };
        };
    } else mapRouteProperties = defaultMapRouteProperties;
    // Config driven behavior flags
    var future = _extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    var dataRoutes = convertRoutesToDataRoutes(routes, mapRouteProperties, undefined, manifest);
    function query(request, _temp3) {
        return _query.apply(this, arguments);
    }
    function _query() {
        _query = /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ (0, _asyncToGenerator._)(function(request, _temp3) {
            var _ref, requestContext, skipLoaderErrorBubbling, dataStrategy, url, method, location, matches, error, _getShortCircuitMatches, methodNotAllowedMatches, route, error1, _getShortCircuitMatches1, notFoundMatches, route1, result;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _temp3 === void 0 ? {} : _temp3, requestContext = _ref.requestContext, skipLoaderErrorBubbling = _ref.skipLoaderErrorBubbling, dataStrategy = _ref.dataStrategy;
                        url = new URL(request.url);
                        method = request.method;
                        location = createLocation("", createPath(url), null, "default");
                        matches = matchRoutes(dataRoutes, location, basename);
                        // SSR supports HEAD requests while SPA doesn't
                        if (!isValidMethod(method) && method !== "HEAD") {
                            error = getInternalRouterError(405, {
                                method: method
                            });
                            _getShortCircuitMatches = getShortCircuitMatches(dataRoutes), methodNotAllowedMatches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
                            return [
                                2,
                                {
                                    basename: basename,
                                    location: location,
                                    matches: methodNotAllowedMatches,
                                    loaderData: {},
                                    actionData: null,
                                    errors: (0, _defineProperty._)({}, route.id, error),
                                    statusCode: error.status,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        } else if (!matches) {
                            error1 = getInternalRouterError(404, {
                                pathname: location.pathname
                            });
                            _getShortCircuitMatches1 = getShortCircuitMatches(dataRoutes), notFoundMatches = _getShortCircuitMatches1.matches, route1 = _getShortCircuitMatches1.route;
                            return [
                                2,
                                {
                                    basename: basename,
                                    location: location,
                                    matches: notFoundMatches,
                                    loaderData: {},
                                    actionData: null,
                                    errors: (0, _defineProperty._)({}, route1.id, error1),
                                    statusCode: error1.status,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        }
                        return [
                            4,
                            queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null)
                        ];
                    case 1:
                        result = _state.sent();
                        if (isResponse(result)) return [
                            2,
                            result
                        ];
                        // When returning StaticHandlerContext, we patch back in the location here
                        // since we need it for React Context.  But this helps keep our submit and
                        // loadRouteData operating on a Request instead of a Location
                        return [
                            2,
                            _extends({
                                location: location,
                                basename: basename
                            }, result)
                        ];
                }
            });
        });
        return _query.apply(this, arguments);
    }
    function queryRoute(request, _temp4) {
        return _queryRoute.apply(this, arguments);
    }
    function _queryRoute() {
        _queryRoute = /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ (0, _asyncToGenerator._)(function(request, _temp4) {
            var _ref, routeId, requestContext, dataStrategy, url, method, location, matches, match, result, error, _result$activeDeferre, data;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _temp4 === void 0 ? {} : _temp4, routeId = _ref.routeId, requestContext = _ref.requestContext, dataStrategy = _ref.dataStrategy;
                        url = new URL(request.url);
                        method = request.method;
                        location = createLocation("", createPath(url), null, "default");
                        matches = matchRoutes(dataRoutes, location, basename);
                        // SSR supports HEAD requests while SPA doesn't
                        if (!isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw getInternalRouterError(405, {
                            method: method
                        });
                        else if (!matches) throw getInternalRouterError(404, {
                            pathname: location.pathname
                        });
                        match = routeId ? matches.find(function(m) {
                            return m.route.id === routeId;
                        }) : getTargetMatch(matches, location);
                        if (routeId && !match) throw getInternalRouterError(403, {
                            pathname: location.pathname,
                            routeId: routeId
                        });
                        else if (!match) // This should never hit I don't think?
                        throw getInternalRouterError(404, {
                            pathname: location.pathname
                        });
                        return [
                            4,
                            queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match)
                        ];
                    case 1:
                        result = _state.sent();
                        if (isResponse(result)) return [
                            2,
                            result
                        ];
                        error = result.errors ? Object.values(result.errors)[0] : undefined;
                        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
                        // _something_ that wasn't a Response, but it's not guaranteed/required
                        // to be an `instanceof Error` either, so we have to use throw here to
                        // preserve the "error" state outside of queryImpl.
                        throw error;
                        // Pick off the right state value to return
                        if (result.actionData) return [
                            2,
                            Object.values(result.actionData)[0]
                        ];
                        if (result.loaderData) {
                            ;
                            data = Object.values(result.loaderData)[0];
                            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[UNSAFE_DEFERRED_SYMBOL] = result.activeDeferreds[match.route.id];
                            return [
                                2,
                                data
                            ];
                        }
                        return [
                            2,
                            undefined
                        ];
                }
            });
        });
        return _queryRoute.apply(this, arguments);
    }
    function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        return _queryImpl.apply(this, arguments);
    }
    function _queryImpl() {
        _queryImpl = (0, _asyncToGenerator._)(function(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
            var result, result1, e;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        invariant(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        if (!isMutationMethod(request.method.toLowerCase())) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            submit(request, matches, routeMatch || getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null)
                        ];
                    case 2:
                        result = _state.sent();
                        return [
                            2,
                            result
                        ];
                    case 3:
                        return [
                            4,
                            loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch)
                        ];
                    case 4:
                        result1 = _state.sent();
                        return [
                            2,
                            isResponse(result1) ? result1 : _extends({}, result1, {
                                actionData: null,
                                actionHeaders: {}
                            })
                        ];
                    case 5:
                        e = _state.sent();
                        // If the user threw/returned a Response in callLoaderOrAction for a
                        // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
                        // and then return or throw the raw Response here accordingly
                        if (isDataStrategyResult(e) && isResponse(e.result)) {
                            if (e.type === ResultType.error) throw e.result;
                            return [
                                2,
                                e.result
                            ];
                        }
                        // Redirects are always returned since they don't propagate to catch
                        // boundaries
                        if (isRedirectResponse(e)) return [
                            2,
                            e
                        ];
                        throw e;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return _queryImpl.apply(this, arguments);
    }
    function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        return _submit.apply(this, arguments);
    }
    function _submit() {
        _submit = (0, _asyncToGenerator._)(function(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
            var result, error, results, error1, loaderRequest, boundaryMatch, context, context1;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(!actionMatch.route.action && !actionMatch.route.lazy)) return [
                            3,
                            1
                        ];
                        error = getInternalRouterError(405, {
                            method: request.method,
                            pathname: new URL(request.url).pathname,
                            routeId: actionMatch.route.id
                        });
                        if (isRouteRequest) throw error;
                        result = {
                            type: ResultType.error,
                            error: error
                        };
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            callDataStrategy("action", request, [
                                actionMatch
                            ], matches, isRouteRequest, requestContext, dataStrategy)
                        ];
                    case 2:
                        results = _state.sent();
                        result = results[actionMatch.route.id];
                        if (request.signal.aborted) throwStaticHandlerAbortedError(request, isRouteRequest, future);
                        _state.label = 3;
                    case 3:
                        if (isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
                        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
                        // can get back on the "throw all redirect responses" train here should
                        // this ever happen :/
                        throw new Response(null, {
                            status: result.response.status,
                            headers: {
                                Location: result.response.headers.get("Location")
                            }
                        });
                        if (isDeferredResult(result)) {
                            error1 = getInternalRouterError(400, {
                                type: "defer-action"
                            });
                            if (isRouteRequest) throw error1;
                            result = {
                                type: ResultType.error,
                                error: error1
                            };
                        }
                        if (isRouteRequest) {
                            // Note: This should only be non-Response values if we get here, since
                            // isRouteRequest should throw any Response received in callLoaderOrAction
                            if (isErrorResult(result)) throw result.error;
                            return [
                                2,
                                {
                                    matches: [
                                        actionMatch
                                    ],
                                    loaderData: {},
                                    actionData: (0, _defineProperty._)({}, actionMatch.route.id, result.data),
                                    errors: null,
                                    // Note: statusCode + headers are unused here since queryRoute will
                                    // return the raw Response or value
                                    statusCode: 200,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        }
                        // Create a GET request for the loaders
                        loaderRequest = new Request(request.url, {
                            headers: request.headers,
                            redirect: request.redirect,
                            signal: request.signal
                        });
                        if (!isErrorResult(result)) return [
                            3,
                            5
                        ];
                        // Store off the pending error - we use it to determine which loaders
                        // to call and will commit it when we complete the navigation
                        boundaryMatch = skipLoaderErrorBubbling ? actionMatch : findNearestBoundary(matches, actionMatch.route.id);
                        return [
                            4,
                            loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                                boundaryMatch.route.id,
                                result
                            ])
                        ];
                    case 4:
                        context = _state.sent();
                        // action status codes take precedence over loader status codes
                        return [
                            2,
                            _extends({}, context, {
                                statusCode: isRouteErrorResponse(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                                actionData: null,
                                actionHeaders: _extends({}, result.headers ? (0, _defineProperty._)({}, actionMatch.route.id, result.headers) : {})
                            })
                        ];
                    case 5:
                        return [
                            4,
                            loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null)
                        ];
                    case 6:
                        context1 = _state.sent();
                        return [
                            2,
                            _extends({}, context1, {
                                actionData: (0, _defineProperty._)({}, actionMatch.route.id, result.data)
                            }, result.statusCode ? {
                                statusCode: result.statusCode
                            } : {}, {
                                actionHeaders: result.headers ? (0, _defineProperty._)({}, actionMatch.route.id, result.headers) : {}
                            })
                        ];
                }
            });
        });
        return _submit.apply(this, arguments);
    }
    function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        return _loadRouteData.apply(this, arguments);
    }
    function _loadRouteData() {
        _loadRouteData = (0, _asyncToGenerator._)(function(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
            var isRouteRequest, requestMatches, matchesToLoad, results, activeDeferreds, context, executedLoaders;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isRouteRequest = routeMatch != null;
                        // Short circuit if we have no loaders to run (queryRoute())
                        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw getInternalRouterError(400, {
                            method: request.method,
                            pathname: new URL(request.url).pathname,
                            routeId: routeMatch == null ? void 0 : routeMatch.route.id
                        });
                        requestMatches = routeMatch ? [
                            routeMatch
                        ] : pendingActionResult && isErrorResult(pendingActionResult[1]) ? getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
                        matchesToLoad = requestMatches.filter(function(m) {
                            return m.route.loader || m.route.lazy;
                        });
                        // Short circuit if we have no loaders to run (query())
                        if (matchesToLoad.length === 0) return [
                            2,
                            {
                                matches: matches,
                                // Add a null for all matched routes for proper revalidation on the client
                                loaderData: matches.reduce(function(acc, m) {
                                    return Object.assign(acc, (0, _defineProperty._)({}, m.route.id, null));
                                }, {}),
                                errors: pendingActionResult && isErrorResult(pendingActionResult[1]) ? (0, _defineProperty._)({}, pendingActionResult[0], pendingActionResult[1].error) : null,
                                statusCode: 200,
                                loaderHeaders: {},
                                activeDeferreds: null
                            }
                        ];
                        return [
                            4,
                            callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy)
                        ];
                    case 1:
                        results = _state.sent();
                        if (request.signal.aborted) throwStaticHandlerAbortedError(request, isRouteRequest, future);
                        // Process and commit output from loaders
                        activeDeferreds = new Map();
                        context = processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
                        // Add a null for any non-loader matches for proper revalidation on the client
                        executedLoaders = new Set(matchesToLoad.map(function(match) {
                            return match.route.id;
                        }));
                        matches.forEach(function(match) {
                            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
                        });
                        return [
                            2,
                            _extends({}, context, {
                                matches: matches,
                                activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
                            })
                        ];
                }
            });
        });
        return _loadRouteData.apply(this, arguments);
    }
    function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        return _callDataStrategy.apply(this, arguments);
    }
    function _callDataStrategy() {
        _callDataStrategy = // Utility wrapper for calling dataStrategy server-side without having to
        // pass around the manifest, mapRouteProperties, etc.
        (0, _asyncToGenerator._)(function(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
            var results, dataResults;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            callDataStrategyImpl(dataStrategy || defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext)
                        ];
                    case 1:
                        results = _state.sent();
                        dataResults = {};
                        return [
                            4,
                            Promise.all(matches.map(/*#__PURE__*/ function() {
                                var _ref = (0, _asyncToGenerator._)(function(match) {
                                    var result, response, _;
                                    return (0, _tsGenerator._)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                if (!(match.route.id in results)) return [
                                                    2
                                                ];
                                                result = results[match.route.id];
                                                if (isRedirectDataStrategyResultResult(result)) {
                                                    response = result.result;
                                                    // Throw redirects and let the server handle them with an HTTP redirect
                                                    throw normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
                                                }
                                                if (isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
                                                // directly without unwrapping
                                                throw result;
                                                _ = match.route.id;
                                                return [
                                                    4,
                                                    convertDataStrategyResultToDataResult(result)
                                                ];
                                            case 1:
                                                dataResults[_] = _state.sent();
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function(match) {
                                    return _ref.apply(this, arguments);
                                };
                            }()))
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2,
                            dataResults
                        ];
                }
            });
        });
        return _callDataStrategy.apply(this, arguments);
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function getStaticContextFromError(routes, context, error) {
    var newContext = _extends({}, context, {
        statusCode: isRouteErrorResponse(error) ? error.status : 500,
        errors: (0, _defineProperty._)({}, context._deepestRenderedBoundaryId || routes[0].id, error)
    });
    return newContext;
}
function throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    var method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    var contextualMatches;
    var activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var match = _step.value;
                contextualMatches.push(match);
                if (match.route.id === fromRouteId) {
                    activeRouteMatch = match;
                    break;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    var path = resolveTo(to ? to : ".", getResolveToMatches(contextualMatches, v7_relativeSplatPath), stripBasename(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        var nakedIndex = hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            var params = new URLSearchParams(path.search);
            var indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter(function(v) {
                return v;
            }).forEach(function(v) {
                return params.append("index", v);
            });
            var qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : joinPaths([
        basename,
        path.pathname
    ]);
    return createPath(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !isValidMethod(opts.formMethod)) return {
        path: path,
        error: getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    var getInvalidBodyError = function() {
        return {
            path: path,
            error: getInternalRouterError(400, {
                type: "invalid-body"
            })
        };
    };
    // Create a Submission on non-GET navigations
    var rawFormMethod = opts.formMethod || "get";
    var formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    var formAction = stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!isMutationMethod(formMethod)) return getInvalidBodyError();
            var text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce(function(acc, _ref3) {
                var _$_ref3 = (0, _slicedToArray._)(_ref3, 2), name = _$_ref3[0], value = _$_ref3[1];
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                var json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    invariant(typeof FormData === "function", "FormData is not available in this environment");
    var searchParams;
    var formData;
    if (opts.formData) {
        searchParams = convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    var submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if (isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    var parsedPath = parsePath(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: createPath(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    var index = matches.findIndex(function(m) {
        return m.route.id === boundaryId;
    });
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    var actionResult = pendingActionResult ? isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    var currentUrl = history.createURL(state.location);
    var nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    var boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    var actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    var shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    var navigationMatches = boundaryMatches.filter(function(match, index) {
        var route = match.route;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if (isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some(function(id) {
            return id === match.route.id;
        })) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        var currentRouteMatch = state.matches[index];
        var nextRouteMatch = match;
        return shouldRevalidateLoader(match, _extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    var revalidatingFetchers = [];
    fetchLoadMatches.forEach(function(f, key) {
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some(function(m) {
            return m.route.id === f.routeId;
        }) || deletedFetchers.has(key)) return;
        var fetcherMatches = matchRoutes(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        var fetcher = state.fetchers.get(key);
        var fetcherMatch = getTargetMatch(fetcherMatches, f.path);
        var shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = shouldRevalidateLoader(fetcherMatch, _extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    var hasData = loaderData != null && loaderData[route.id] !== undefined;
    var hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function isNewLoader(currentLoaderData, currentMatch, match) {
    var isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    var isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function isNewRouteInstance(currentMatch, match) {
    var currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        var routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    var _childrenToPatch1;
    var childrenToPatch;
    if (routeId) {
        var route = manifest[routeId];
        invariant(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    var uniqueChildren = children.filter(function(newRoute) {
        return !childrenToPatch.some(function(existingRoute) {
            return isSameRoute(newRoute, existingRoute);
        });
    });
    var newRoutes = convertRoutesToDataRoutes(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch1 = childrenToPatch) == null ? void 0 : _childrenToPatch1.length) || "0")
    ], manifest);
    (_childrenToPatch = childrenToPatch).push.apply(_childrenToPatch, (0, _toConsumableArray._)(newRoutes));
}
function isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every(function(aChild, i) {
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some(function(bChild) {
            return isSameRoute(aChild, bChild);
        });
    });
}
function loadLazyRouteModule(route, mapRouteProperties, manifest) {
    return _loadLazyRouteModule.apply(this, arguments);
}
function _loadLazyRouteModule() {
    _loadLazyRouteModule = /**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ (0, _asyncToGenerator._)(function(route, mapRouteProperties, manifest) {
        var lazyRoute, routeToUpdate, routeUpdates, lazyRouteProperty, staticRouteValue, isPropertyStaticallyDefined;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!route.lazy) return [
                        2
                    ];
                    return [
                        4,
                        route.lazy()
                    ];
                case 1:
                    lazyRoute = _state.sent();
                    // If the lazy route function was executed and removed by another parallel
                    // call then we can return - first lazy() to finish wins because the return
                    // value of lazy is expected to be static
                    if (!route.lazy) return [
                        2
                    ];
                    routeToUpdate = manifest[route.id];
                    invariant(routeToUpdate, "No route found in manifest");
                    // Update the route in place.  This should be safe because there's no way
                    // we could yet be sitting on this route as we can't get there without
                    // resolving lazy() first.
                    //
                    // This is different than the HMR "update" use-case where we may actively be
                    // on the route being updated.  The main concern boils down to "does this
                    // mutation affect any ongoing navigations or any current state.matches
                    // values?".  If not, it should be safe to update in place.
                    routeUpdates = {};
                    for(var lazyRouteProperty in lazyRoute){
                        staticRouteValue = routeToUpdate[lazyRouteProperty];
                        isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
                        // on the route updates
                        lazyRouteProperty !== "hasErrorBoundary";
                        warning(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
                        if (!isPropertyStaticallyDefined && !immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
                    }
                    // Mutate the route with the provided updates.  Do this first so we pass
                    // the updated version to mapRouteProperties
                    Object.assign(routeToUpdate, routeUpdates);
                    // Mutate the `hasErrorBoundary` property on the route based on the route
                    // updates and remove the `lazy` function so we don't resolve the lazy
                    // route again.
                    Object.assign(routeToUpdate, _extends({}, mapRouteProperties(routeToUpdate), {
                        lazy: undefined
                    }));
                    return [
                        2
                    ];
            }
        });
    });
    return _loadLazyRouteModule.apply(this, arguments);
}
function defaultDataStrategy(_ref4) {
    return _defaultDataStrategy.apply(this, arguments);
}
function _defaultDataStrategy() {
    _defaultDataStrategy = // Default implementation of `dataStrategy` which fetches all loaders in parallel
    (0, _asyncToGenerator._)(function(_ref4) {
        var matches, matchesToLoad, results;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    matches = _ref4.matches;
                    matchesToLoad = matches.filter(function(m) {
                        return m.shouldLoad;
                    });
                    return [
                        4,
                        Promise.all(matchesToLoad.map(function(m) {
                            return m.resolve();
                        }))
                    ];
                case 1:
                    results = _state.sent();
                    return [
                        2,
                        results.reduce(function(acc, result, i) {
                            return Object.assign(acc, (0, _defineProperty._)({}, matchesToLoad[i].route.id, result));
                        }, {})
                    ];
            }
        });
    });
    return _defaultDataStrategy.apply(this, arguments);
}
function callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    return _callDataStrategyImpl.apply(this, arguments);
}
function _callDataStrategyImpl() {
    _callDataStrategyImpl = (0, _asyncToGenerator._)(function(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
        var loadRouteDefinitionsPromises, dsMatches, results, e;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    loadRouteDefinitionsPromises = matches.map(function(m) {
                        return m.route.lazy ? loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined;
                    });
                    dsMatches = matches.map(function(match, i) {
                        var loadRoutePromise = loadRouteDefinitionsPromises[i];
                        var shouldLoad = matchesToLoad.some(function(m) {
                            return m.route.id === match.route.id;
                        });
                        // `resolve` encapsulates route.lazy(), executing the loader/action,
                        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
                        // can pass a callback to take fine-grained control over the execution
                        // of the loader/action
                        var resolve = /*#__PURE__*/ function() {
                            var _ref = (0, _asyncToGenerator._)(function(handlerOverride) {
                                return (0, _tsGenerator._)(this, function(_state) {
                                    if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
                                    return [
                                        2,
                                        shouldLoad ? callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                                            type: ResultType.data,
                                            result: undefined
                                        })
                                    ];
                                });
                            });
                            return function resolve(handlerOverride) {
                                return _ref.apply(this, arguments);
                            };
                        }();
                        return _extends({}, match, {
                            shouldLoad: shouldLoad,
                            resolve: resolve
                        });
                    });
                    return [
                        4,
                        dataStrategyImpl({
                            matches: dsMatches,
                            request: request,
                            params: matches[0].params,
                            fetcherKey: fetcherKey,
                            context: requestContext
                        })
                    ];
                case 1:
                    results = _state.sent();
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        Promise.all(loadRouteDefinitionsPromises)
                    ];
                case 3:
                    _state.sent();
                    return [
                        3,
                        5
                    ];
                case 4:
                    e = _state.sent();
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        2,
                        results
                    ];
            }
        });
    });
    return _callDataStrategyImpl.apply(this, arguments);
}
function callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    return _callLoaderOrAction.apply(this, arguments);
}
function _callLoaderOrAction() {
    _callLoaderOrAction = // Default logic for calling a loader/action is the user has no specified a dataStrategy
    (0, _asyncToGenerator._)(function(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
        var result, onReject, runHandler, handler, handlerError, _ref, value, url, pathname, url1, pathname1, e;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    runHandler = function(handler) {
                        // Setup a promise we can race against so that abort signals short circuit
                        var reject;
                        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
                        // satisfy the function return value
                        var abortPromise = new Promise(function(_, r) {
                            return reject = r;
                        });
                        onReject = function() {
                            return reject();
                        };
                        request.signal.addEventListener("abort", onReject);
                        var actualHandler = function(ctx) {
                            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
                            return handler.apply(void 0, [
                                {
                                    request: request,
                                    params: match.params,
                                    context: staticContext
                                }
                            ].concat((0, _toConsumableArray._)(ctx !== undefined ? [
                                ctx
                            ] : [])));
                        };
                        var handlerPromise = (0, _asyncToGenerator._)(function() {
                            var val, e;
                            return (0, _tsGenerator._)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _state.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4,
                                            handlerOverride ? handlerOverride(function(ctx) {
                                                return actualHandler(ctx);
                                            }) : actualHandler()
                                        ];
                                    case 1:
                                        val = _state.sent();
                                        return [
                                            2,
                                            {
                                                type: "data",
                                                result: val
                                            }
                                        ];
                                    case 2:
                                        e = _state.sent();
                                        return [
                                            2,
                                            {
                                                type: "error",
                                                result: e
                                            }
                                        ];
                                    case 3:
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                        return Promise.race([
                            handlerPromise,
                            abortPromise
                        ]);
                    };
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        12,
                        13,
                        14
                    ]);
                    handler = match.route[type];
                    if (!loadRoutePromise) return [
                        3,
                        8
                    ];
                    if (!handler) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        Promise.all([
                            // If the handler throws, don't let it immediately bubble out,
                            // since we need to let the lazy() execution finish so we know if this
                            // route has a boundary that can handle the error
                            runHandler(handler).catch(function(e) {
                                handlerError = e;
                            }),
                            loadRoutePromise
                        ])
                    ];
                case 2:
                    _ref = (0, _slicedToArray._).apply(void 0, [
                        _state.sent(),
                        1
                    ]), value = _ref[0];
                    if (handlerError !== undefined) throw handlerError;
                    result = value;
                    return [
                        3,
                        7
                    ];
                case 3:
                    // Load lazy route module, then run any returned handler
                    return [
                        4,
                        loadRoutePromise
                    ];
                case 4:
                    _state.sent();
                    handler = match.route[type];
                    if (!handler) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        runHandler(handler)
                    ];
                case 5:
                    // Handler still runs even if we got interrupted to maintain consistency
                    // with un-abortable behavior of handler execution on non-lazy or
                    // previously-lazy-loaded routes
                    result = _state.sent();
                    return [
                        3,
                        7
                    ];
                case 6:
                    if (type === "action") {
                        url = new URL(request.url);
                        pathname = url.pathname + url.search;
                        throw getInternalRouterError(405, {
                            method: request.method,
                            pathname: pathname,
                            routeId: match.route.id
                        });
                    } else // lazy() route has no loader to run.  Short circuit here so we don't
                    // hit the invariant below that errors on returning undefined.
                    return [
                        2,
                        {
                            type: ResultType.data,
                            result: undefined
                        }
                    ];
                    _state.label = 7;
                case 7:
                    return [
                        3,
                        11
                    ];
                case 8:
                    if (!!handler) return [
                        3,
                        9
                    ];
                    url1 = new URL(request.url);
                    pathname1 = url1.pathname + url1.search;
                    throw getInternalRouterError(404, {
                        pathname: pathname1
                    });
                case 9:
                    return [
                        4,
                        runHandler(handler)
                    ];
                case 10:
                    result = _state.sent();
                    _state.label = 11;
                case 11:
                    invariant(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
                    return [
                        3,
                        14
                    ];
                case 12:
                    e = _state.sent();
                    // We should already be catching and converting normal handler executions to
                    // DataStrategyResults and returning them, so anything that throws here is an
                    // unexpected error we still need to wrap
                    return [
                        2,
                        {
                            type: ResultType.error,
                            result: e
                        }
                    ];
                case 13:
                    if (onReject) request.signal.removeEventListener("abort", onReject);
                    return [
                        7
                    ];
                case 14:
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return _callLoaderOrAction.apply(this, arguments);
}
function convertDataStrategyResultToDataResult(dataStrategyResult) {
    return _convertDataStrategyResultToDataResult.apply(this, arguments);
}
function _convertDataStrategyResultToDataResult() {
    _convertDataStrategyResultToDataResult = (0, _asyncToGenerator._)(function(dataStrategyResult) {
        var result, type, data, contentType, e, _result$init3, _result$init4, _result$init, _result$init2, _result$init5, _result$init6, _result$init7, _result$init8;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    result = dataStrategyResult.result, type = dataStrategyResult.type;
                    if (!isResponse(result)) return [
                        3,
                        10
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        8,
                        ,
                        9
                    ]);
                    contentType = result.headers.get("Content-Type");
                    if (!(contentType && /\bapplication\/json\b/.test(contentType))) return [
                        3,
                        5
                    ];
                    if (!(result.body == null)) return [
                        3,
                        2
                    ];
                    data = null;
                    return [
                        3,
                        4
                    ];
                case 2:
                    return [
                        4,
                        result.json()
                    ];
                case 3:
                    data = _state.sent();
                    _state.label = 4;
                case 4:
                    return [
                        3,
                        7
                    ];
                case 5:
                    return [
                        4,
                        result.text()
                    ];
                case 6:
                    data = _state.sent();
                    _state.label = 7;
                case 7:
                    return [
                        3,
                        9
                    ];
                case 8:
                    e = _state.sent();
                    return [
                        2,
                        {
                            type: ResultType.error,
                            error: e
                        }
                    ];
                case 9:
                    if (type === ResultType.error) return [
                        2,
                        {
                            type: ResultType.error,
                            error: new ErrorResponseImpl(result.status, result.statusText, data),
                            statusCode: result.status,
                            headers: result.headers
                        }
                    ];
                    return [
                        2,
                        {
                            type: ResultType.data,
                            data: data,
                            statusCode: result.status,
                            headers: result.headers
                        }
                    ];
                case 10:
                    if (type === ResultType.error) {
                        if (isDataWithResponseInit(result)) {
                            ;
                            if (result.data instanceof Error) {
                                ;
                                return [
                                    2,
                                    {
                                        type: ResultType.error,
                                        error: result.data,
                                        statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                                        headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                                    }
                                ];
                            }
                            // Convert thrown data() to ErrorResponse instances
                            return [
                                2,
                                {
                                    type: ResultType.error,
                                    error: new ErrorResponseImpl(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                                    statusCode: isRouteErrorResponse(result) ? result.status : undefined,
                                    headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
                                }
                            ];
                        }
                        return [
                            2,
                            {
                                type: ResultType.error,
                                error: result,
                                statusCode: isRouteErrorResponse(result) ? result.status : undefined
                            }
                        ];
                    }
                    if (isDeferredData(result)) {
                        ;
                        return [
                            2,
                            {
                                type: ResultType.deferred,
                                deferredData: result,
                                statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
                                headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
                            }
                        ];
                    }
                    if (isDataWithResponseInit(result)) {
                        ;
                        return [
                            2,
                            {
                                type: ResultType.data,
                                data: result.data,
                                statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
                                headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            type: ResultType.data,
                            data: result
                        }
                    ];
            }
        });
    });
    return _convertDataStrategyResultToDataResult.apply(this, arguments);
}
// Support relative routing in internal redirects
function normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    var location = response.headers.get("Location");
    invariant(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!ABSOLUTE_URL_REGEX.test(location)) {
        var trimmedMatches = matches.slice(0, matches.findIndex(function(m) {
            return m.route.id === routeId;
        }) + 1);
        location = normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function normalizeRedirectLocation(location, currentUrl, basename) {
    if (ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        var normalizedLocation = location;
        var url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        var isSameBasename = stripBasename(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function createClientSideRequest(history, location, signal, submission) {
    var url = history.createURL(stripHashFromPath(location)).toString();
    var init = {
        signal: signal
    };
    if (submission && isMutationMethod(submission.formMethod)) {
        var formMethod = submission.formMethod, formEncType = submission.formEncType;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function convertFormDataToSearchParams(formData) {
    var searchParams = new URLSearchParams();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = formData.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, _slicedToArray._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
            searchParams.append(key, typeof value === "string" ? value : value.name);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return searchParams;
}
function convertSearchParamsToFormData(searchParams) {
    var formData = new FormData();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = searchParams.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, _slicedToArray._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            formData.append(key, value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return formData;
}
function processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    var loaderData = {};
    var errors = null;
    var statusCode;
    var foundError = false;
    var loaderHeaders = {};
    var pendingError = pendingActionResult && isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach(function(match) {
        if (!(match.route.id in results)) return;
        var id = match.route.id;
        var result = results[id];
        invariant(!isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if (isErrorResult(result)) {
            var error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                var boundaryMatch = findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = isRouteErrorResponse(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if (isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = (0, _defineProperty._)({}, pendingActionResult[0], pendingError);
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    var _processRouteLoaderData = processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    ), loaderData = _processRouteLoaderData.loaderData, errors = _processRouteLoaderData.errors;
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach(function(rf) {
        var key = rf.key, match = rf.match, controller = rf.controller;
        var result = fetcherResults[key];
        invariant(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if (isErrorResult(result)) {
            var boundaryMatch = findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = _extends({}, errors, (0, _defineProperty._)({}, boundaryMatch.route.id, result.error));
            state.fetchers.delete(key);
        } else if (isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        invariant(false, "Unhandled fetcher revalidation redirect");
        else if (isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        invariant(false, "Unhandled fetcher deferred data");
        else {
            var doneFetcher = getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    var mergedLoaderData = _extends({}, newLoaderData);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var match = _step.value;
            var id = match.route.id;
            if (newLoaderData.hasOwnProperty(id)) {
                if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
            } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
            // wasn't removed by HMR
            mergedLoaderData[id] = loaderData[id];
            if (errors && errors.hasOwnProperty(id)) break;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return mergedLoaderData;
}
function getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: (0, _defineProperty._)({}, pendingActionResult[0], pendingActionResult[1].data)
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function findNearestBoundary(matches, routeId) {
    var eligibleMatches = routeId ? matches.slice(0, matches.findIndex(function(m) {
        return m.route.id === routeId;
    }) + 1) : (0, _toConsumableArray._)(matches);
    return eligibleMatches.reverse().find(function(m) {
        return m.route.hasErrorBoundary === true;
    }) || matches[0];
}
function getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    var route = routes.length === 1 ? routes[0] : routes.find(function(r) {
        return r.index || !r.path || r.path === "/";
    }) || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function getInternalRouterError(status, _temp5) {
    var _ref = _temp5 === void 0 ? {} : _temp5, pathname = _ref.pathname, routeId = _ref.routeId, method = _ref.method, type = _ref.type, message = _ref.message;
    var statusText = "Unknown Server Error";
    var errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new ErrorResponseImpl(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function findRedirect(results) {
    var entries = Object.entries(results);
    for(var i = entries.length - 1; i >= 0; i--){
        var _entries_i = (0, _slicedToArray._)(entries[i], 2), key = _entries_i[0], result = _entries_i[1];
        if (isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function stripHashFromPath(path) {
    var parsedPath = typeof path === "string" ? parsePath(path) : path;
    return createPath(_extends({}, parsedPath, {
        hash: ""
    }));
}
function isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === ResultType.data || result.type === ResultType.error);
}
function isRedirectDataStrategyResultResult(result) {
    return isResponse(result.result) && redirectStatusCodes.has(result.result.status);
}
function isDeferredResult(result) {
    return result.type === ResultType.deferred;
}
function isErrorResult(result) {
    return result.type === ResultType.error;
}
function isRedirectResult(result) {
    return (result && result.type) === ResultType.redirect;
}
function isDataWithResponseInit(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function isDeferredData(value) {
    var deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function isRedirectResponse(result) {
    if (!isResponse(result)) return false;
    var status = result.status;
    var location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function isValidMethod(method) {
    return validRequestMethods.has(method.toLowerCase());
}
function isMutationMethod(method) {
    return validMutationMethods.has(method.toLowerCase());
}
function resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    return _resolveNavigationDeferredResults.apply(this, arguments);
}
function _resolveNavigationDeferredResults() {
    _resolveNavigationDeferredResults = (0, _asyncToGenerator._)(function(matches, results, signal, currentMatches, currentLoaderData) {
        var _loop, entries, index;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _loop = function(index) {
                        var _entries_index, routeId, result, match, currentMatch, isRevalidatingLoader;
                        return (0, _tsGenerator._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _entries_index = (0, _slicedToArray._)(entries[index], 2), routeId = _entries_index[0], result = _entries_index[1];
                                    match = matches.find(function(m) {
                                        return (m == null ? void 0 : m.route.id) === routeId;
                                    });
                                    // If we don't have a match, then we can have a deferred result to do
                                    // anything with.  This is for revalidating fetchers where the route was
                                    // removed during HMR
                                    if (!match) return [
                                        2,
                                        "continue"
                                    ];
                                    currentMatch = currentMatches.find(function(m) {
                                        return m.route.id === match.route.id;
                                    });
                                    isRevalidatingLoader = currentMatch != null && !isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
                                    if (!(isDeferredResult(result) && isRevalidatingLoader)) return [
                                        3,
                                        2
                                    ];
                                    // Note: we do not have to touch activeDeferreds here since we race them
                                    // against the signal in resolveDeferredData and they'll get aborted
                                    // there if needed
                                    return [
                                        4,
                                        resolveDeferredData(result, signal, false).then(function(result) {
                                            if (result) results[routeId] = result;
                                        })
                                    ];
                                case 1:
                                    _state.sent();
                                    _state.label = 2;
                                case 2:
                                    return [
                                        2
                                    ];
                            }
                        });
                    };
                    entries = Object.entries(results);
                    index = 0;
                    _state.label = 1;
                case 1:
                    if (!(index < entries.length)) return [
                        3,
                        4
                    ];
                    return [
                        5,
                        (0, _tsValues._)(_loop(index))
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    index++;
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _resolveNavigationDeferredResults.apply(this, arguments);
}
function resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    return _resolveFetcherDeferredResults.apply(this, arguments);
}
function _resolveFetcherDeferredResults() {
    _resolveFetcherDeferredResults = (0, _asyncToGenerator._)(function(matches, results, revalidatingFetchers) {
        var _loop, index;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _loop = function(index) {
                        var _revalidatingFetchers_index, key, routeId, controller, result, match;
                        return (0, _tsGenerator._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _revalidatingFetchers_index = revalidatingFetchers[index], key = _revalidatingFetchers_index.key, routeId = _revalidatingFetchers_index.routeId, controller = _revalidatingFetchers_index.controller;
                                    result = results[key];
                                    match = matches.find(function(m) {
                                        return (m == null ? void 0 : m.route.id) === routeId;
                                    });
                                    // If we don't have a match, then we can have a deferred result to do
                                    // anything with.  This is for revalidating fetchers where the route was
                                    // removed during HMR
                                    if (!match) return [
                                        2,
                                        "continue"
                                    ];
                                    if (!isDeferredResult(result)) return [
                                        3,
                                        2
                                    ];
                                    // Note: we do not have to touch activeDeferreds here since we race them
                                    // against the signal in resolveDeferredData and they'll get aborted
                                    // there if needed
                                    invariant(controller, "Expected an AbortController for revalidating fetcher deferred result");
                                    return [
                                        4,
                                        resolveDeferredData(result, controller.signal, true).then(function(result) {
                                            if (result) results[key] = result;
                                        })
                                    ];
                                case 1:
                                    _state.sent();
                                    _state.label = 2;
                                case 2:
                                    return [
                                        2
                                    ];
                            }
                        });
                    };
                    index = 0;
                    _state.label = 1;
                case 1:
                    if (!(index < revalidatingFetchers.length)) return [
                        3,
                        4
                    ];
                    return [
                        5,
                        (0, _tsValues._)(_loop(index))
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    index++;
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _resolveFetcherDeferredResults.apply(this, arguments);
}
function resolveDeferredData(result, signal, unwrap) {
    return _resolveDeferredData.apply(this, arguments);
}
function _resolveDeferredData() {
    _resolveDeferredData = (0, _asyncToGenerator._)(function(result, signal, unwrap) {
        var aborted;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (unwrap === void 0) unwrap = false;
                    return [
                        4,
                        result.deferredData.resolveData(signal)
                    ];
                case 1:
                    aborted = _state.sent();
                    if (aborted) return [
                        2
                    ];
                    if (unwrap) try {
                        return [
                            2,
                            {
                                type: ResultType.data,
                                data: result.deferredData.unwrappedData
                            }
                        ];
                    } catch (e) {
                        // Handle any TrackedPromise._error values encountered while unwrapping
                        return [
                            2,
                            {
                                type: ResultType.error,
                                error: e
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            type: ResultType.data,
                            data: result.deferredData.data
                        }
                    ];
            }
        });
    });
    return _resolveDeferredData.apply(this, arguments);
}
function hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some(function(v) {
        return v === "";
    });
}
function getTargetMatch(matches, location) {
    var search = typeof location === "string" ? parsePath(location).search : location.search;
    if (matches[matches.length - 1].route.index && hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    var pathMatches = getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function getSubmissionFromNavigation(navigation) {
    var formMethod = navigation.formMethod, formAction = navigation.formAction, formEncType = navigation.formEncType, text = navigation.text, formData = navigation.formData, json = navigation.json;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function getLoadingNavigation(location, submission) {
    if (submission) {
        var navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        var navigation1 = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation1;
    }
}
function getSubmittingNavigation(location, submission) {
    var navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function getLoadingFetcher(submission, data) {
    if (submission) {
        var fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        var fetcher1 = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher1;
    }
}
function getSubmittingFetcher(submission, existingFetcher) {
    var fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function getDoneFetcher(data) {
    var fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function restoreAppliedTransitions(_window, transitions) {
    try {
        var sessionPositions = _window.sessionStorage.getItem(TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            var json = JSON.parse(sessionPositions);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Object.entries(json || {})[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = (0, _slicedToArray._)(_step.value, 2), k = _step_value[0], v = _step_value[1];
                    if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        var json = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = transitions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, _slicedToArray._)(_step.value, 2), k = _step_value[0], v = _step_value[1];
                json[k] = (0, _toConsumableArray._)(v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        try {
            _window.sessionStorage.setItem(TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            warning(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_call_super":"5oPMc","@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","@swc/helpers/_/_define_property":"54Zvk","@swc/helpers/_/_inherits":"j8HRi","@swc/helpers/_/_sliced_to_array":"ha6sq","@swc/helpers/_/_to_array":"wdLug","@swc/helpers/_/_to_consumable_array":"eqNDD","@swc/helpers/_/_type_of":"c3ItR","@swc/helpers/_/_wrap_native_super":"gNmVc","@swc/helpers/_/_ts_generator":"f2hGH","@swc/helpers/_/_ts_values":"1KvqK","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"wdLug":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _to_array;
});
var _arrayWithHolesJs = require("./_array_with_holes.js");
var _iterableToArrayJs = require("./_iterable_to_array.js");
var _nonIterableRestJs = require("./_non_iterable_rest.js");
var _unsupportedIterableToArrayJs = require("./_unsupported_iterable_to_array.js");
function _to_array(arr) {
    return (0, _arrayWithHolesJs._)(arr) || (0, _iterableToArrayJs._)(arr) || (0, _unsupportedIterableToArrayJs._)(arr) || (0, _nonIterableRestJs._)();
}

},{"./_array_with_holes.js":"5YhNB","./_iterable_to_array.js":"aWBXo","./_non_iterable_rest.js":"9PKKT","./_unsupported_iterable_to_array.js":"fAMhu","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gNmVc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _wrap_native_super;
});
var _constructJs = require("./_construct.js");
var _getPrototypeOfJs = require("./_get_prototype_of.js");
var _isNativeFunctionJs = require("./_is_native_function.js");
var _setPrototypeOfJs = require("./_set_prototype_of.js");
function _wrap_native_super(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrap_native_super = function(Class) {
        if (Class === null || !(0, _isNativeFunctionJs._)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, _constructJs._)(Class, arguments, (0, _getPrototypeOfJs._)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, _setPrototypeOfJs._)(Wrapper, Class);
    };
    return _wrap_native_super(Class);
}

},{"./_construct.js":"kAKhX","./_get_prototype_of.js":"fF8vn","./_is_native_function.js":"8KaPJ","./_set_prototype_of.js":"gh9Xk","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"kAKhX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _construct;
});
var _isNativeReflectConstructJs = require("./_is_native_reflect_construct.js");
var _setPrototypeOfJs = require("./_set_prototype_of.js");
function _construct(Parent, args, Class) {
    if ((0, _isNativeReflectConstructJs._)()) _construct = Reflect.construct;
    else _construct = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, _setPrototypeOfJs._)(instance, Class.prototype);
        return instance;
    };
    return _construct.apply(null, arguments);
}

},{"./_is_native_reflect_construct.js":"3Bx8P","./_set_prototype_of.js":"gh9Xk","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8KaPJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _is_native_function;
});
function _is_native_function(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1KvqK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return 0, _tslib.__values;
});
var _tslib = require("tslib");

},{"tslib":"C7UIb","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gnkXt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Page", function() {
    return Page;
});
parcelHelpers.export(exports, "Layout", function() {
    return Layout;
});
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _accountView = require("../../../../app/views/accountView");
var _useShopifyAsset = require("../../../hooks/useShopifyAsset");
var _reactRouterDom = require("react-router-dom");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _reactRedux = require("react-redux");
var _circleLoader = require("../../../../../../snippets/components/circleLoader");
var Page = /*#__PURE__*/ function(Page) {
    Page[Page["Subscription"] = 0] = "Subscription";
    Page[Page["PaymentMethod"] = 1] = "PaymentMethod";
    Page[Page["OrderHistoryList"] = 2] = "OrderHistoryList";
    Page[Page["OrderHistoryDetails"] = 3] = "OrderHistoryDetails";
    Page[Page["LastOrderDetails"] = 4] = "LastOrderDetails";
    return Page;
}({});
function Layout(props) {
    var view = (0, _reactRedux.useSelector)((0, _accountView.accountView));
    var isLoading = function() {
        if (!view) return true;
        if (props.isLoading) return true;
        return false;
    };
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
        className: "sectionContainer",
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(Title, {}, void 0, false, {
                fileName: "src/script/src/dom/views/Account/views/Layout.tsx",
                lineNumber: 36,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                className: "layout_main",
                children: [
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(Menu, {
                        page: props.page
                    }, void 0, false, {
                        fileName: "src/script/src/dom/views/Account/views/Layout.tsx",
                        lineNumber: 38,
                        columnNumber: 17
                    }, this),
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                        className: "layout_content",
                        children: props.children
                    }, void 0, false, {
                        fileName: "src/script/src/dom/views/Account/views/Layout.tsx",
                        lineNumber: 39,
                        columnNumber: 17
                    }, this)
                ]
            }, void 0, true, {
                fileName: "src/script/src/dom/views/Account/views/Layout.tsx",
                lineNumber: 37,
                columnNumber: 13
            }, this),
            isLoading() && /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                className: "layout_loader",
                children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _circleLoader.CircleLoader), {}, void 0, false, {
                    fileName: "src/script/src/dom/views/Account/views/Layout.tsx",
                    lineNumber: 44,
                    columnNumber: 17
                }, this)
            }, void 0, false, {
                fileName: "src/script/src/dom/views/Account/views/Layout.tsx",
                lineNumber: 43,
                columnNumber: 29
            }, this)
        ]
    }, void 0, true, {
        fileName: "src/script/src/dom/views/Account/views/Layout.tsx",
        lineNumber: 35,
        columnNumber: 9
    }, this);
}
function Title() {
    var view = (0, _reactRedux.useSelector)((0, _accountView.accountView));
    function render() {
        if (!(view === null || view === void 0 ? void 0 : view.firstName)) return 'Bonjour !';
        return `Bonjour ${view.firstName} !`;
    }
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("h2", {
        className: "layout_title",
        children: render()
    }, void 0, false, {
        fileName: "src/script/src/dom/views/Account/views/Layout.tsx",
        lineNumber: 60,
        columnNumber: 12
    }, this);
}
function Menu(props) {
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _jsxDevRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("h3", {
                className: "layout_menuTitle",
                children: "Mon espace"
            }, void 0, false, {
                fileName: "src/script/src/dom/views/Account/views/Layout.tsx",
                lineNumber: 68,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                className: "layout_menu",
                children: [
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(MenuOption, {
                        label: "Mon abonnement",
                        currentPage: props.page,
                        pages: [
                            0,
                            4
                        ],
                        to: "/pages/abonnement",
                        picto: "image_icon_account_history.svg"
                    }, void 0, false, {
                        fileName: "src/script/src/dom/views/Account/views/Layout.tsx",
                        lineNumber: 70,
                        columnNumber: 17
                    }, this),
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(MenuOption, {
                        label: "Historique de commandes",
                        currentPage: props.page,
                        pages: [
                            2,
                            3
                        ],
                        to: "/pages/commandes",
                        picto: "image_icon_account_subscription.svg"
                    }, void 0, false, {
                        fileName: "src/script/src/dom/views/Account/views/Layout.tsx",
                        lineNumber: 77,
                        columnNumber: 17
                    }, this),
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(MenuOption, {
                        label: "Moyen de paiement",
                        currentPage: props.page,
                        pages: [
                            1
                        ],
                        to: "/pages/moyen-de-paiement",
                        picto: "image_icon_account_payment_method.svg"
                    }, void 0, false, {
                        fileName: "src/script/src/dom/views/Account/views/Layout.tsx",
                        lineNumber: 84,
                        columnNumber: 17
                    }, this),
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("a", {
                        className: "logout",
                        href: "/account/logout",
                        children: "D\xe9connexion"
                    }, void 0, false, {
                        fileName: "src/script/src/dom/views/Account/views/Layout.tsx",
                        lineNumber: 91,
                        columnNumber: 17
                    }, this)
                ]
            }, void 0, true, {
                fileName: "src/script/src/dom/views/Account/views/Layout.tsx",
                lineNumber: 69,
                columnNumber: 13
            }, this)
        ]
    }, void 0, true);
}
function MenuOption(props) {
    var shopifyAsset = (0, _useShopifyAsset.useShopifyAsset)();
    var navigate = (0, _reactRouterDom.useNavigate)();
    var classNames = (0, _classnamesDefault.default)({
        menuOption: true,
        selected: isCurrent()
    });
    function isCurrent() {
        return props.pages.indexOf(props.currentPage) >= 0;
    }
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
        className: classNames,
        onClick: function() {
            return navigate(props.to);
        },
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                className: "imgContainer",
                children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("img", {
                    src: shopifyAsset(props.picto)
                }, void 0, false, {
                    fileName: "src/script/src/dom/views/Account/views/Layout.tsx",
                    lineNumber: 119,
                    columnNumber: 17
                }, this)
            }, void 0, false, {
                fileName: "src/script/src/dom/views/Account/views/Layout.tsx",
                lineNumber: 118,
                columnNumber: 13
            }, this),
            props.label
        ]
    }, void 0, true, {
        fileName: "src/script/src/dom/views/Account/views/Layout.tsx",
        lineNumber: 117,
        columnNumber: 9
    }, this);
}

},{"react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","../../../../app/views/accountView":"edpwn","../../../hooks/useShopifyAsset":"aJ4wV","react-router-dom":"9VDGr","classnames":"4SuBi","react-redux":"ghMZu","../../../../../../snippets/components/circleLoader":"6ifIi","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"edpwn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "accountView", function() {
    return accountView;
});
var _reselect = require("reselect");
var _customer = require("../store/state/data/customer");
var accountView = (0, _reselect.createSelector)((0, _customer.customerSelector), prepareView);
function prepareView(customerState) {
    if (!customerState.entity) return null;
    return {
        firstName: customerState.entity.firstName
    };
}

},{"reselect":"fb6q1","../store/state/data/customer":"hDp3A","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"aJ4wV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useShopifyAsset", function() {
    return useShopifyAsset;
});
function useShopifyAsset() {
    return function(key) {
        var preparedKey = key.replace(/\//g, '__');
        // @ts-ignore
        return assets[preparedKey];
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4SuBi":[function(require,module,exports,__globalThis) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

},{}],"6ifIi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CircleLoader", function() {
    return CircleLoader;
});
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
function CircleLoader(props) {
    if (!isLoading()) return null;
    function isLoading() {
        var _props_loading;
        return (_props_loading = props.loading) !== null && _props_loading !== void 0 ? _props_loading : true;
    }
    function hasOpacityLayer() {
        var _props_opacityLayer;
        return (_props_opacityLayer = props.opacityLayer) !== null && _props_opacityLayer !== void 0 ? _props_opacityLayer : false;
    }
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
        className: (0, _classnamesDefault.default)({
            componentCircleLoader: true,
            'componentCircleLoader--hasOpacityLayer': hasOpacityLayer()
        }),
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                className: "componentCircleLoader__spinner",
                children: [
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {}, void 0, false, {
                        fileName: "src/snippets/components/circleLoader/index.tsx",
                        lineNumber: 27,
                        columnNumber: 17
                    }, this),
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {}, void 0, false, {
                        fileName: "src/snippets/components/circleLoader/index.tsx",
                        lineNumber: 28,
                        columnNumber: 17
                    }, this),
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {}, void 0, false, {
                        fileName: "src/snippets/components/circleLoader/index.tsx",
                        lineNumber: 29,
                        columnNumber: 17
                    }, this),
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {}, void 0, false, {
                        fileName: "src/snippets/components/circleLoader/index.tsx",
                        lineNumber: 30,
                        columnNumber: 17
                    }, this)
                ]
            }, void 0, true, {
                fileName: "src/snippets/components/circleLoader/index.tsx",
                lineNumber: 26,
                columnNumber: 13
            }, this),
            props.message && /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                children: props.message
            }, void 0, false, {
                fileName: "src/snippets/components/circleLoader/index.tsx",
                lineNumber: 32,
                columnNumber: 32
            }, this)
        ]
    }, void 0, true, {
        fileName: "src/snippets/components/circleLoader/index.tsx",
        lineNumber: 22,
        columnNumber: 9
    }, this);
}

},{"react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","classnames":"4SuBi","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"fo1BR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LoadAccountKey", function() {
    return LoadAccountKey;
});
parcelHelpers.export(exports, "LoadAccount", function() {
    return LoadAccount;
});
parcelHelpers.export(exports, "CustomerIsNotLoggedInKey", function() {
    return CustomerIsNotLoggedInKey;
});
parcelHelpers.export(exports, "CustomerIsNotLoggedIn", function() {
    return CustomerIsNotLoggedIn;
});
parcelHelpers.export(exports, "loadAccountSaga", function() {
    return loadAccountSaga;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _std = require("@reglo/std");
var _eventFactory = require("../../std/eventFactory");
var _loadCustomerData = require("../useCases/loadCustomerData");
var _loadOrdersData = require("../useCases/loadOrdersData");
var _loadCustomerSubscriptions = require("../useCases/loadCustomerSubscriptions");
var _loadShippingRates = require("../useCases/loadShippingRates");
var _account = require("../store/state/views/account");
var _analyticsBrowser = require("@amplitude/analytics-browser");
var LoadAccountKey = 'LoadAccount';
var LoadAccount = (0, _eventFactory.eventFactory)(LoadAccountKey)();
var CustomerIsNotLoggedInKey = 'CustomerIsNotLoggedIn';
var CustomerIsNotLoggedIn = (0, _eventFactory.eventFactory)(CustomerIsNotLoggedInKey)();
function loadAccountSaga(deps) {
    return /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(event) {
            var _;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ = event.type;
                        switch(_){
                            case LoadAccountKey:
                                return [
                                    3,
                                    1
                                ];
                            case 0, _loadCustomerData.CustomerDataLoadedKey:
                                return [
                                    3,
                                    3
                                ];
                        }
                        return [
                            3,
                            4
                        ];
                    case 1:
                        if (deps.getState((0, _account.accountIsLoaded))) return [
                            2
                        ];
                        return [
                            4,
                            deps.isLoggedIn()
                        ];
                    case 2:
                        if (!_state.sent()) return [
                            2,
                            deps.publishEvent(CustomerIsNotLoggedIn())
                        ];
                        return [
                            2,
                            (0, _std.waitForAll)([
                                deps.publishEvent((0, _loadCustomerData.LoadCustomerData)()),
                                deps.publishEvent((0, _loadOrdersData.LoadOrdersData)()),
                                deps.publishEvent((0, _loadCustomerSubscriptions.LoadCustomerSubscriptions)()),
                                deps.publishEvent((0, _loadShippingRates.LoadShippingRates)())
                            ])
                        ];
                    case 3:
                        return [
                            2,
                            identifyCustomerInTracking(event)
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }();
    function identifyCustomerInTracking(event) {
        _analyticsBrowser.setUserId(event.payload.customer.customerId.toString());
    }
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_ts_generator":"f2hGH","@reglo/std":"1USo0","../../std/eventFactory":"f2PpV","../useCases/loadCustomerData":"lIaYI","../useCases/loadOrdersData":"4CTLE","../useCases/loadCustomerSubscriptions":"efjCG","../useCases/loadShippingRates":"hpNjt","../store/state/views/account":"48PeC","@amplitude/analytics-browser":"3318X","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3318X":[function(require,module,exports,__globalThis) {
/* eslint-disable @typescript-eslint/unbound-method */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createInstance", function() {
    return 0, _browserClientFactory.createInstance;
});
parcelHelpers.export(exports, "runQueuedFunctions", function() {
    return 0, _snippetHelper.runQueuedFunctions;
});
parcelHelpers.export(exports, "Revenue", function() {
    return 0, _analyticsCore.Revenue;
});
parcelHelpers.export(exports, "Identify", function() {
    return 0, _analyticsCore.Identify;
});
parcelHelpers.export(exports, "add", function() {
    return add;
});
parcelHelpers.export(exports, "extendSession", function() {
    return extendSession;
});
parcelHelpers.export(exports, "flush", function() {
    return flush;
});
parcelHelpers.export(exports, "getDeviceId", function() {
    return getDeviceId;
});
parcelHelpers.export(exports, "getSessionId", function() {
    return getSessionId;
});
parcelHelpers.export(exports, "getUserId", function() {
    return getUserId;
});
parcelHelpers.export(exports, "groupIdentify", function() {
    return groupIdentify;
});
parcelHelpers.export(exports, "identify", function() {
    return identify;
});
parcelHelpers.export(exports, "init", function() {
    return init;
});
parcelHelpers.export(exports, "logEvent", function() {
    return logEvent;
});
parcelHelpers.export(exports, "remove", function() {
    return remove;
});
parcelHelpers.export(exports, "reset", function() {
    return reset;
});
parcelHelpers.export(exports, "revenue", function() {
    return revenue;
});
parcelHelpers.export(exports, "setDeviceId", function() {
    return setDeviceId;
});
parcelHelpers.export(exports, "setGroup", function() {
    return setGroup;
});
parcelHelpers.export(exports, "setOptOut", function() {
    return setOptOut;
});
parcelHelpers.export(exports, "setSessionId", function() {
    return setSessionId;
});
parcelHelpers.export(exports, "setTransport", function() {
    return setTransport;
});
parcelHelpers.export(exports, "setUserId", function() {
    return setUserId;
});
parcelHelpers.export(exports, "track", function() {
    return track;
});
parcelHelpers.export(exports, "Types", function() {
    return Types;
});
var _browserClientFactory = require("./browser-client-factory");
var _browserClientFactoryDefault = parcelHelpers.interopDefault(_browserClientFactory);
var _snippetHelper = require("./utils/snippet-helper");
var _analyticsCore = require("@amplitude/analytics-core");
var add = (0, _browserClientFactoryDefault.default).add, extendSession = (0, _browserClientFactoryDefault.default).extendSession, flush = (0, _browserClientFactoryDefault.default).flush, getDeviceId = (0, _browserClientFactoryDefault.default).getDeviceId, getSessionId = (0, _browserClientFactoryDefault.default).getSessionId, getUserId = (0, _browserClientFactoryDefault.default).getUserId, groupIdentify = (0, _browserClientFactoryDefault.default).groupIdentify, identify = (0, _browserClientFactoryDefault.default).identify, init = (0, _browserClientFactoryDefault.default).init, logEvent = (0, _browserClientFactoryDefault.default).logEvent, remove = (0, _browserClientFactoryDefault.default).remove, reset = (0, _browserClientFactoryDefault.default).reset, revenue = (0, _browserClientFactoryDefault.default).revenue, setDeviceId = (0, _browserClientFactoryDefault.default).setDeviceId, setGroup = (0, _browserClientFactoryDefault.default).setGroup, setOptOut = (0, _browserClientFactoryDefault.default).setOptOut, setSessionId = (0, _browserClientFactoryDefault.default).setSessionId, setTransport = (0, _browserClientFactoryDefault.default).setTransport, setUserId = (0, _browserClientFactoryDefault.default).setUserId, track = (0, _browserClientFactoryDefault.default).track;
var Types;
(function(Types) {
    Types.IdentifyOperation = (0, _analyticsCore.IdentifyOperation);
    Types.SpecialEventType = (0, _analyticsCore.SpecialEventType);
    Types.RevenueProperty = (0, _analyticsCore.RevenueProperty);
    Types.LogLevel = (0, _analyticsCore.LogLevel);
    Types.ServerZone = (0, _analyticsCore.ServerZone);
    Types.OfflineDisabled = (0, _analyticsCore.OfflineDisabled);
    Types.DEFAULT_CSS_SELECTOR_ALLOWLIST = (0, _analyticsCore.DEFAULT_CSS_SELECTOR_ALLOWLIST);
    Types.DEFAULT_DATA_ATTRIBUTE_PREFIX = (0, _analyticsCore.DEFAULT_DATA_ATTRIBUTE_PREFIX);
    Types.DEFAULT_ACTION_CLICK_ALLOWLIST = (0, _analyticsCore.DEFAULT_ACTION_CLICK_ALLOWLIST);
})(Types || (Types = {}));

},{"./browser-client-factory":"gT2rk","./utils/snippet-helper":"ajPs6","@amplitude/analytics-core":"4c2pj","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gT2rk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createInstance", function() {
    return createInstance;
});
var _analyticsCore = require("@amplitude/analytics-core");
var _browserClient = require("./browser-client");
var createInstance = function createInstance() {
    var client = new (0, _browserClient.AmplitudeBrowser)();
    return {
        init: (0, _analyticsCore.debugWrapper)(client.init.bind(client), 'init', (0, _analyticsCore.getClientLogConfig)(client), (0, _analyticsCore.getClientStates)(client, [
            'config'
        ])),
        add: (0, _analyticsCore.debugWrapper)(client.add.bind(client), 'add', (0, _analyticsCore.getClientLogConfig)(client), (0, _analyticsCore.getClientStates)(client, [
            'config.apiKey',
            'timeline.plugins'
        ])),
        remove: (0, _analyticsCore.debugWrapper)(client.remove.bind(client), 'remove', (0, _analyticsCore.getClientLogConfig)(client), (0, _analyticsCore.getClientStates)(client, [
            'config.apiKey',
            'timeline.plugins'
        ])),
        track: (0, _analyticsCore.debugWrapper)(client.track.bind(client), 'track', (0, _analyticsCore.getClientLogConfig)(client), (0, _analyticsCore.getClientStates)(client, [
            'config.apiKey',
            'timeline.queue.length'
        ])),
        logEvent: (0, _analyticsCore.debugWrapper)(client.logEvent.bind(client), 'logEvent', (0, _analyticsCore.getClientLogConfig)(client), (0, _analyticsCore.getClientStates)(client, [
            'config.apiKey',
            'timeline.queue.length'
        ])),
        identify: (0, _analyticsCore.debugWrapper)(client.identify.bind(client), 'identify', (0, _analyticsCore.getClientLogConfig)(client), (0, _analyticsCore.getClientStates)(client, [
            'config.apiKey',
            'timeline.queue.length'
        ])),
        groupIdentify: (0, _analyticsCore.debugWrapper)(client.groupIdentify.bind(client), 'groupIdentify', (0, _analyticsCore.getClientLogConfig)(client), (0, _analyticsCore.getClientStates)(client, [
            'config.apiKey',
            'timeline.queue.length'
        ])),
        setGroup: (0, _analyticsCore.debugWrapper)(client.setGroup.bind(client), 'setGroup', (0, _analyticsCore.getClientLogConfig)(client), (0, _analyticsCore.getClientStates)(client, [
            'config.apiKey',
            'timeline.queue.length'
        ])),
        revenue: (0, _analyticsCore.debugWrapper)(client.revenue.bind(client), 'revenue', (0, _analyticsCore.getClientLogConfig)(client), (0, _analyticsCore.getClientStates)(client, [
            'config.apiKey',
            'timeline.queue.length'
        ])),
        flush: (0, _analyticsCore.debugWrapper)(client.flush.bind(client), 'flush', (0, _analyticsCore.getClientLogConfig)(client), (0, _analyticsCore.getClientStates)(client, [
            'config.apiKey',
            'timeline.queue.length'
        ])),
        getUserId: (0, _analyticsCore.debugWrapper)(client.getUserId.bind(client), 'getUserId', (0, _analyticsCore.getClientLogConfig)(client), (0, _analyticsCore.getClientStates)(client, [
            'config',
            'config.userId'
        ])),
        setUserId: (0, _analyticsCore.debugWrapper)(client.setUserId.bind(client), 'setUserId', (0, _analyticsCore.getClientLogConfig)(client), (0, _analyticsCore.getClientStates)(client, [
            'config',
            'config.userId'
        ])),
        getDeviceId: (0, _analyticsCore.debugWrapper)(client.getDeviceId.bind(client), 'getDeviceId', (0, _analyticsCore.getClientLogConfig)(client), (0, _analyticsCore.getClientStates)(client, [
            'config',
            'config.deviceId'
        ])),
        setDeviceId: (0, _analyticsCore.debugWrapper)(client.setDeviceId.bind(client), 'setDeviceId', (0, _analyticsCore.getClientLogConfig)(client), (0, _analyticsCore.getClientStates)(client, [
            'config',
            'config.deviceId'
        ])),
        reset: (0, _analyticsCore.debugWrapper)(client.reset.bind(client), 'reset', (0, _analyticsCore.getClientLogConfig)(client), (0, _analyticsCore.getClientStates)(client, [
            'config',
            'config.userId',
            'config.deviceId'
        ])),
        getSessionId: (0, _analyticsCore.debugWrapper)(client.getSessionId.bind(client), 'getSessionId', (0, _analyticsCore.getClientLogConfig)(client), (0, _analyticsCore.getClientStates)(client, [
            'config'
        ])),
        setSessionId: (0, _analyticsCore.debugWrapper)(client.setSessionId.bind(client), 'setSessionId', (0, _analyticsCore.getClientLogConfig)(client), (0, _analyticsCore.getClientStates)(client, [
            'config'
        ])),
        extendSession: (0, _analyticsCore.debugWrapper)(client.extendSession.bind(client), 'extendSession', (0, _analyticsCore.getClientLogConfig)(client), (0, _analyticsCore.getClientStates)(client, [
            'config'
        ])),
        setOptOut: (0, _analyticsCore.debugWrapper)(client.setOptOut.bind(client), 'setOptOut', (0, _analyticsCore.getClientLogConfig)(client), (0, _analyticsCore.getClientStates)(client, [
            'config'
        ])),
        setTransport: (0, _analyticsCore.debugWrapper)(client.setTransport.bind(client), 'setTransport', (0, _analyticsCore.getClientLogConfig)(client), (0, _analyticsCore.getClientStates)(client, [
            'config'
        ]))
    };
};
exports.default = createInstance();

},{"@amplitude/analytics-core":"4c2pj","./browser-client":"21Z6v","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4c2pj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AmplitudeCore", function() {
    return 0, _coreClient.AmplitudeCore;
});
parcelHelpers.export(exports, "Identify", function() {
    return 0, _identify.Identify;
});
parcelHelpers.export(exports, "Revenue", function() {
    return 0, _revenue.Revenue;
});
parcelHelpers.export(exports, "RevenueProperty", function() {
    return 0, _revenue.RevenueProperty;
});
parcelHelpers.export(exports, "Destination", function() {
    return 0, _destination.Destination;
});
parcelHelpers.export(exports, "IdentityEventSender", function() {
    return 0, _identity.IdentityEventSender;
});
parcelHelpers.export(exports, "Config", function() {
    return 0, _config.Config;
});
parcelHelpers.export(exports, "RequestMetadata", function() {
    return 0, _config.RequestMetadata;
});
parcelHelpers.export(exports, "Logger", function() {
    return 0, _logger.Logger;
});
parcelHelpers.export(exports, "getGlobalScope", function() {
    return 0, _globalScope.getGlobalScope;
});
parcelHelpers.export(exports, "getAnalyticsConnector", function() {
    return 0, _analyticsConnector.getAnalyticsConnector;
});
parcelHelpers.export(exports, "setConnectorDeviceId", function() {
    return 0, _analyticsConnector.setConnectorDeviceId;
});
parcelHelpers.export(exports, "setConnectorUserId", function() {
    return 0, _analyticsConnector.setConnectorUserId;
});
parcelHelpers.export(exports, "isNewSession", function() {
    return 0, _session.isNewSession;
});
parcelHelpers.export(exports, "getCookieName", function() {
    return 0, _cookieName.getCookieName;
});
parcelHelpers.export(exports, "getOldCookieName", function() {
    return 0, _cookieName.getOldCookieName;
});
parcelHelpers.export(exports, "getLanguage", function() {
    return 0, _language.getLanguage;
});
parcelHelpers.export(exports, "getQueryParams", function() {
    return 0, _queryParams.getQueryParams;
});
parcelHelpers.export(exports, "returnWrapper", function() {
    return 0, _returnWrapper.returnWrapper;
});
parcelHelpers.export(exports, "debugWrapper", function() {
    return 0, _debug.debugWrapper;
});
parcelHelpers.export(exports, "getClientLogConfig", function() {
    return 0, _debug.getClientLogConfig;
});
parcelHelpers.export(exports, "getClientStates", function() {
    return 0, _debug.getClientStates;
});
parcelHelpers.export(exports, "UUID", function() {
    return 0, _uuid.UUID;
});
parcelHelpers.export(exports, "createIdentifyEvent", function() {
    return 0, _eventBuilder.createIdentifyEvent;
});
parcelHelpers.export(exports, "MemoryStorage", function() {
    return 0, _memory.MemoryStorage;
});
parcelHelpers.export(exports, "CookieStorage", function() {
    return 0, _cookie.CookieStorage;
});
parcelHelpers.export(exports, "getStorageKey", function() {
    return 0, _helpers.getStorageKey;
});
parcelHelpers.export(exports, "BaseTransport", function() {
    return 0, _base.BaseTransport;
});
parcelHelpers.export(exports, "FetchTransport", function() {
    return 0, _fetch.FetchTransport;
});
parcelHelpers.export(exports, "LogLevel", function() {
    return 0, _loglevel.LogLevel;
});
parcelHelpers.export(exports, "AMPLITUDE_PREFIX", function() {
    return 0, _constants.AMPLITUDE_PREFIX;
});
parcelHelpers.export(exports, "STORAGE_PREFIX", function() {
    return 0, _constants.STORAGE_PREFIX;
});
parcelHelpers.export(exports, "IdentifyOperation", function() {
    return 0, _event.IdentifyOperation;
});
parcelHelpers.export(exports, "SpecialEventType", function() {
    return 0, _event.SpecialEventType;
});
parcelHelpers.export(exports, "ServerZone", function() {
    return 0, _serverZone.ServerZone;
});
parcelHelpers.export(exports, "OfflineDisabled", function() {
    return 0, _offline.OfflineDisabled;
});
parcelHelpers.export(exports, "DEFAULT_CSS_SELECTOR_ALLOWLIST", function() {
    return 0, _elementInteractions.DEFAULT_CSS_SELECTOR_ALLOWLIST;
});
parcelHelpers.export(exports, "DEFAULT_DATA_ATTRIBUTE_PREFIX", function() {
    return 0, _elementInteractions.DEFAULT_DATA_ATTRIBUTE_PREFIX;
});
parcelHelpers.export(exports, "DEFAULT_ACTION_CLICK_ALLOWLIST", function() {
    return 0, _elementInteractions.DEFAULT_ACTION_CLICK_ALLOWLIST;
});
parcelHelpers.export(exports, "Status", function() {
    return 0, _status.Status;
});
var _coreClient = require("./core-client");
var _identify = require("./identify");
var _revenue = require("./revenue");
var _destination = require("./plugins/destination");
var _identity = require("./plugins/identity");
var _config = require("./config");
var _logger = require("./logger");
var _globalScope = require("./global-scope");
var _analyticsConnector = require("./analytics-connector");
var _session = require("./session");
var _cookieName = require("./cookie-name");
var _language = require("./language");
var _queryParams = require("./query-params");
var _returnWrapper = require("./utils/return-wrapper");
var _debug = require("./utils/debug");
var _uuid = require("./utils/uuid");
var _eventBuilder = require("./utils/event-builder");
var _memory = require("./storage/memory");
var _cookie = require("./storage/cookie");
var _helpers = require("./storage/helpers");
var _base = require("./transports/base");
var _fetch = require("./transports/fetch");
var _loglevel = require("./types/loglevel");
var _constants = require("./types/constants");
var _event = require("./types/event/event");
var _serverZone = require("./types/server-zone");
var _offline = require("./types/offline");
var _elementInteractions = require("./types/element-interactions");
var _status = require("./types/status");

},{"./core-client":"4Bola","./identify":"jaNNQ","./revenue":"42BO0","./plugins/destination":"j86sF","./plugins/identity":"kvWSM","./config":"e682o","./logger":"1aV1H","./global-scope":"4bWZr","./analytics-connector":"2Lk9V","./session":"dxnNU","./cookie-name":"bYrlE","./language":"8sq0e","./query-params":"80C04","./utils/return-wrapper":"5R4na","./utils/debug":"6BQsR","./utils/uuid":"edfiW","./utils/event-builder":"jibvN","./storage/memory":"cUIMK","./storage/cookie":"22BRC","./storage/helpers":"eCmYy","./transports/base":"daeJA","./transports/fetch":"c9NGk","./types/loglevel":"4Ddkh","./types/constants":false,"./types/event/event":"kiCzI","./types/server-zone":"fBWmt","./types/offline":"gHzIR","./types/element-interactions":"cWEvn","./types/status":false,"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4Bola":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AmplitudeCore", function() {
    return AmplitudeCore;
});
var _tslib = require("tslib");
var _messages = require("./types/messages");
var _timeline = require("./timeline");
var _eventBuilder = require("./utils/event-builder");
var _resultBuilder = require("./utils/result-builder");
var _returnWrapper = require("./utils/return-wrapper");
var AmplitudeCore = /** @class */ function() {
    function AmplitudeCore(name) {
        if (name === void 0) name = '$default';
        this.initializing = false;
        this.isReady = false;
        this.q = [];
        this.dispatchQ = [];
        this.logEvent = this.track.bind(this);
        this.timeline = new (0, _timeline.Timeline)(this);
        this.name = name;
    }
    AmplitudeCore.prototype._init = function(config) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.config = config;
                        this.timeline.reset(this);
                        return [
                            4 /*yield*/ ,
                            this.runQueuedFunctions('q')
                        ];
                    case 1:
                        _a.sent();
                        this.isReady = true;
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AmplitudeCore.prototype.runQueuedFunctions = function(queueName) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var queuedFunctions, queuedFunctions_1, queuedFunctions_1_1, queuedFunction, val, e_1_1;
            var e_1, _a;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        queuedFunctions = this[queueName];
                        this[queueName] = [];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            8,
                            9,
                            10
                        ]);
                        queuedFunctions_1 = (0, _tslib.__values)(queuedFunctions), queuedFunctions_1_1 = queuedFunctions_1.next();
                        _b.label = 2;
                    case 2:
                        if (!!queuedFunctions_1_1.done) return [
                            3 /*break*/ ,
                            7
                        ];
                        queuedFunction = queuedFunctions_1_1.value;
                        val = queuedFunction();
                        if (!(val && 'promise' in val)) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            val.promise
                        ];
                    case 3:
                        _b.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 4:
                        return [
                            4 /*yield*/ ,
                            val
                        ];
                    case 5:
                        _b.sent();
                        _b.label = 6;
                    case 6:
                        queuedFunctions_1_1 = queuedFunctions_1.next();
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 7:
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 8:
                        e_1_1 = _b.sent();
                        e_1 = {
                            error: e_1_1
                        };
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 9:
                        try {
                            if (queuedFunctions_1_1 && !queuedFunctions_1_1.done && (_a = queuedFunctions_1.return)) _a.call(queuedFunctions_1);
                        } finally{
                            if (e_1) throw e_1.error;
                        }
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 10:
                        if (!this[queueName].length) return [
                            3 /*break*/ ,
                            12
                        ];
                        return [
                            4 /*yield*/ ,
                            this.runQueuedFunctions(queueName)
                        ];
                    case 11:
                        _b.sent();
                        _b.label = 12;
                    case 12:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AmplitudeCore.prototype.track = function(eventInput, eventProperties, eventOptions) {
        var event = (0, _eventBuilder.createTrackEvent)(eventInput, eventProperties, eventOptions);
        return (0, _returnWrapper.returnWrapper)(this.dispatch(event));
    };
    AmplitudeCore.prototype.identify = function(identify, eventOptions) {
        var event = (0, _eventBuilder.createIdentifyEvent)(identify, eventOptions);
        return (0, _returnWrapper.returnWrapper)(this.dispatch(event));
    };
    AmplitudeCore.prototype.groupIdentify = function(groupType, groupName, identify, eventOptions) {
        var event = (0, _eventBuilder.createGroupIdentifyEvent)(groupType, groupName, identify, eventOptions);
        return (0, _returnWrapper.returnWrapper)(this.dispatch(event));
    };
    AmplitudeCore.prototype.setGroup = function(groupType, groupName, eventOptions) {
        var event = (0, _eventBuilder.createGroupEvent)(groupType, groupName, eventOptions);
        return (0, _returnWrapper.returnWrapper)(this.dispatch(event));
    };
    AmplitudeCore.prototype.revenue = function(revenue, eventOptions) {
        var event = (0, _eventBuilder.createRevenueEvent)(revenue, eventOptions);
        return (0, _returnWrapper.returnWrapper)(this.dispatch(event));
    };
    AmplitudeCore.prototype.add = function(plugin) {
        if (!this.isReady) {
            this.q.push(this._addPlugin.bind(this, plugin));
            return (0, _returnWrapper.returnWrapper)();
        }
        return this._addPlugin(plugin);
    };
    AmplitudeCore.prototype._addPlugin = function(plugin) {
        return (0, _returnWrapper.returnWrapper)(this.timeline.register(plugin, this.config));
    };
    AmplitudeCore.prototype.remove = function(pluginName) {
        if (!this.isReady) {
            this.q.push(this._removePlugin.bind(this, pluginName));
            return (0, _returnWrapper.returnWrapper)();
        }
        return this._removePlugin(pluginName);
    };
    AmplitudeCore.prototype._removePlugin = function(pluginName) {
        return (0, _returnWrapper.returnWrapper)(this.timeline.deregister(pluginName, this.config));
    };
    AmplitudeCore.prototype.dispatchWithCallback = function(event, callback) {
        if (!this.isReady) return callback((0, _resultBuilder.buildResult)(event, 0, (0, _messages.CLIENT_NOT_INITIALIZED)));
        this.process(event).then(callback);
    };
    AmplitudeCore.prototype.dispatch = function(event) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                if (!this.isReady) return [
                    2 /*return*/ ,
                    new Promise(function(resolve) {
                        _this.dispatchQ.push(_this.dispatchWithCallback.bind(_this, event, resolve));
                    })
                ];
                return [
                    2 /*return*/ ,
                    this.process(event)
                ];
            });
        });
    };
    AmplitudeCore.prototype.process = function(event) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var result, e_2, message, result;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        // skip event processing if opt out
                        if (this.config.optOut) return [
                            2 /*return*/ ,
                            (0, _resultBuilder.buildResult)(event, 0, (0, _messages.OPT_OUT_MESSAGE))
                        ];
                        return [
                            4 /*yield*/ ,
                            this.timeline.push(event)
                        ];
                    case 1:
                        result = _a.sent();
                        result.code === 200 ? this.config.loggerProvider.log(result.message) : result.code === 100 ? this.config.loggerProvider.warn(result.message) : this.config.loggerProvider.error(result.message);
                        return [
                            2 /*return*/ ,
                            result
                        ];
                    case 2:
                        e_2 = _a.sent();
                        message = String(e_2);
                        this.config.loggerProvider.error(message);
                        result = (0, _resultBuilder.buildResult)(event, 0, message);
                        return [
                            2 /*return*/ ,
                            result
                        ];
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AmplitudeCore.prototype.setOptOut = function(optOut) {
        if (!this.isReady) {
            this.q.push(this._setOptOut.bind(this, Boolean(optOut)));
            return;
        }
        this._setOptOut(optOut);
    };
    AmplitudeCore.prototype._setOptOut = function(optOut) {
        this.config.optOut = Boolean(optOut);
    };
    AmplitudeCore.prototype.flush = function() {
        return (0, _returnWrapper.returnWrapper)(this.timeline.flush());
    };
    return AmplitudeCore;
}();

},{"tslib":"C7UIb","./types/messages":"67nWr","./timeline":"lDhkc","./utils/event-builder":"jibvN","./utils/result-builder":"4rE2c","./utils/return-wrapper":"5R4na","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"67nWr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SUCCESS_MESSAGE", function() {
    return SUCCESS_MESSAGE;
});
parcelHelpers.export(exports, "UNEXPECTED_ERROR_MESSAGE", function() {
    return UNEXPECTED_ERROR_MESSAGE;
});
parcelHelpers.export(exports, "MAX_RETRIES_EXCEEDED_MESSAGE", function() {
    return MAX_RETRIES_EXCEEDED_MESSAGE;
});
parcelHelpers.export(exports, "OPT_OUT_MESSAGE", function() {
    return OPT_OUT_MESSAGE;
});
parcelHelpers.export(exports, "MISSING_API_KEY_MESSAGE", function() {
    return MISSING_API_KEY_MESSAGE;
});
parcelHelpers.export(exports, "INVALID_API_KEY", function() {
    return INVALID_API_KEY;
});
parcelHelpers.export(exports, "CLIENT_NOT_INITIALIZED", function() {
    return CLIENT_NOT_INITIALIZED;
});
var SUCCESS_MESSAGE = 'Event tracked successfully';
var UNEXPECTED_ERROR_MESSAGE = 'Unexpected error occurred';
var MAX_RETRIES_EXCEEDED_MESSAGE = 'Event rejected due to exceeded retry count';
var OPT_OUT_MESSAGE = 'Event skipped due to optOut config';
var MISSING_API_KEY_MESSAGE = 'Event rejected due to missing API key';
var INVALID_API_KEY = 'Invalid API key';
var CLIENT_NOT_INITIALIZED = 'Client not initialized';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"lDhkc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Timeline", function() {
    return Timeline;
});
var _tslib = require("tslib");
var _resultBuilder = require("./utils/result-builder");
var _uuid = require("./utils/uuid");
var Timeline = /** @class */ function() {
    function Timeline(client) {
        this.client = client;
        this.queue = [];
        // Flag to guarantee one schedule apply is running
        this.applying = false;
        // Flag indicates whether timeline is ready to process event
        // Events collected before timeline is ready will stay in the queue to be processed later
        this.plugins = [];
    }
    Timeline.prototype.register = function(plugin, config) {
        var _a, _b;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        if (this.plugins.some(function(existingPlugin) {
                            return existingPlugin.name === plugin.name;
                        })) {
                            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                            config.loggerProvider.warn("Plugin with name ".concat(plugin.name, " already exists, skipping registration"));
                            return [
                                2 /*return*/ 
                            ];
                        }
                        if (plugin.name === undefined) {
                            plugin.name = (0, _uuid.UUID)();
                            config.loggerProvider.warn("Plugin name is undefined. \n      Generating a random UUID for plugin name: ".concat(plugin.name, ". \n      Set a name for the plugin to prevent it from being added multiple times."));
                        }
                        plugin.type = (_a = plugin.type) !== null && _a !== void 0 ? _a : 'enrichment';
                        return [
                            4 /*yield*/ ,
                            (_b = plugin.setup) === null || _b === void 0 ? void 0 : _b.call(plugin, config, this.client)
                        ];
                    case 1:
                        _c.sent();
                        this.plugins.push(plugin);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    Timeline.prototype.deregister = function(pluginName, config) {
        var _a;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var index, plugin;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        index = this.plugins.findIndex(function(plugin) {
                            return plugin.name === pluginName;
                        });
                        if (index === -1) {
                            config.loggerProvider.warn("Plugin with name ".concat(pluginName, " does not exist, skipping deregistration"));
                            return [
                                2 /*return*/ 
                            ];
                        }
                        plugin = this.plugins[index];
                        this.plugins.splice(index, 1);
                        return [
                            4 /*yield*/ ,
                            (_a = plugin.teardown) === null || _a === void 0 ? void 0 : _a.call(plugin)
                        ];
                    case 1:
                        _b.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    Timeline.prototype.reset = function(client) {
        this.applying = false;
        var plugins = this.plugins;
        plugins.map(function(plugin) {
            var _a;
            return (_a = plugin.teardown) === null || _a === void 0 ? void 0 : _a.call(plugin);
        });
        this.plugins = [];
        this.client = client;
    };
    Timeline.prototype.push = function(event) {
        var _this = this;
        return new Promise(function(resolve) {
            _this.queue.push([
                event,
                resolve
            ]);
            _this.scheduleApply(0);
        });
    };
    Timeline.prototype.scheduleApply = function(timeout) {
        var _this = this;
        if (this.applying) return;
        this.applying = true;
        setTimeout(function() {
            _this.apply(_this.queue.shift()).then(function() {
                _this.applying = false;
                if (_this.queue.length > 0) _this.scheduleApply(0);
            });
        }, timeout);
    };
    Timeline.prototype.apply = function(item) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _a, event, _b, resolve, before, before_1, before_1_1, plugin, e, e_1_1, enrichment, enrichment_1, enrichment_1_1, plugin, e, e_2_1, destination, executeDestinations;
            var e_1, _c, e_2, _d;
            return (0, _tslib.__generator)(this, function(_e) {
                switch(_e.label){
                    case 0:
                        if (!item) return [
                            2 /*return*/ 
                        ];
                        _a = (0, _tslib.__read)(item, 1), event = _a[0];
                        _b = (0, _tslib.__read)(item, 2), resolve = _b[1];
                        before = this.plugins.filter(function(plugin) {
                            return plugin.type === 'before';
                        });
                        _e.label = 1;
                    case 1:
                        _e.trys.push([
                            1,
                            6,
                            7,
                            8
                        ]);
                        before_1 = (0, _tslib.__values)(before), before_1_1 = before_1.next();
                        _e.label = 2;
                    case 2:
                        if (!!before_1_1.done) return [
                            3 /*break*/ ,
                            5
                        ];
                        plugin = before_1_1.value;
                        /* istanbul ignore if */ if (!plugin.execute) // do nothing
                        return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            plugin.execute((0, _tslib.__assign)({}, event))
                        ];
                    case 3:
                        e = _e.sent();
                        if (e === null) {
                            resolve({
                                event: event,
                                code: 0,
                                message: ''
                            });
                            return [
                                2 /*return*/ 
                            ];
                        } else event = e;
                        _e.label = 4;
                    case 4:
                        before_1_1 = before_1.next();
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 5:
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 6:
                        e_1_1 = _e.sent();
                        e_1 = {
                            error: e_1_1
                        };
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 7:
                        try {
                            if (before_1_1 && !before_1_1.done && (_c = before_1.return)) _c.call(before_1);
                        } finally{
                            if (e_1) throw e_1.error;
                        }
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 8:
                        enrichment = this.plugins.filter(function(plugin) {
                            return plugin.type === 'enrichment' || plugin.type === undefined;
                        });
                        _e.label = 9;
                    case 9:
                        _e.trys.push([
                            9,
                            14,
                            15,
                            16
                        ]);
                        enrichment_1 = (0, _tslib.__values)(enrichment), enrichment_1_1 = enrichment_1.next();
                        _e.label = 10;
                    case 10:
                        if (!!enrichment_1_1.done) return [
                            3 /*break*/ ,
                            13
                        ];
                        plugin = enrichment_1_1.value;
                        /* istanbul ignore if */ if (!plugin.execute) // do nothing
                        return [
                            3 /*break*/ ,
                            12
                        ];
                        return [
                            4 /*yield*/ ,
                            plugin.execute((0, _tslib.__assign)({}, event))
                        ];
                    case 11:
                        e = _e.sent();
                        if (e === null) {
                            resolve({
                                event: event,
                                code: 0,
                                message: ''
                            });
                            return [
                                2 /*return*/ 
                            ];
                        } else event = e;
                        _e.label = 12;
                    case 12:
                        enrichment_1_1 = enrichment_1.next();
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 13:
                        return [
                            3 /*break*/ ,
                            16
                        ];
                    case 14:
                        e_2_1 = _e.sent();
                        e_2 = {
                            error: e_2_1
                        };
                        return [
                            3 /*break*/ ,
                            16
                        ];
                    case 15:
                        try {
                            if (enrichment_1_1 && !enrichment_1_1.done && (_d = enrichment_1.return)) _d.call(enrichment_1);
                        } finally{
                            if (e_2) throw e_2.error;
                        }
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 16:
                        destination = this.plugins.filter(function(plugin) {
                            return plugin.type === 'destination';
                        });
                        executeDestinations = destination.map(function(plugin) {
                            var eventClone = (0, _tslib.__assign)({}, event);
                            return plugin.execute(eventClone).catch(function(e) {
                                return (0, _resultBuilder.buildResult)(eventClone, 0, String(e));
                            });
                        });
                        Promise.all(executeDestinations).then(function(_a) {
                            var _b = (0, _tslib.__read)(_a, 1), result = _b[0];
                            var resolveResult = result || (0, _resultBuilder.buildResult)(event, 100, 'Event not tracked, no destination plugins on the instance');
                            resolve(resolveResult);
                        });
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    Timeline.prototype.flush = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var queue, destination, executeDestinations;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        queue = this.queue;
                        this.queue = [];
                        return [
                            4 /*yield*/ ,
                            Promise.all(queue.map(function(item) {
                                return _this.apply(item);
                            }))
                        ];
                    case 1:
                        _a.sent();
                        destination = this.plugins.filter(function(plugin) {
                            return plugin.type === 'destination';
                        });
                        executeDestinations = destination.map(function(plugin) {
                            return plugin.flush && plugin.flush();
                        });
                        return [
                            4 /*yield*/ ,
                            Promise.all(executeDestinations)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return Timeline;
}();

},{"tslib":"C7UIb","./utils/result-builder":"4rE2c","./utils/uuid":"edfiW","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4rE2c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildResult", function() {
    return buildResult;
});
var _status = require("../types/status");
var buildResult = function buildResult(event, code, message) {
    if (code === void 0) code = 0;
    if (message === void 0) message = (0, _status.Status).Unknown;
    return {
        event: event,
        code: code,
        message: message
    };
};

},{"../types/status":"l9ub9","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"l9ub9":[function(require,module,exports,__globalThis) {
/** The status of an event. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Status", function() {
    return Status;
});
var Status;
(function(Status) {
    /** The status could not be determined. */ Status["Unknown"] = "unknown";
    /** The event was skipped due to configuration or callbacks. */ Status["Skipped"] = "skipped";
    /** The event was sent successfully. */ Status["Success"] = "success";
    /** A user or device in the payload is currently rate limited and should try again later. */ Status["RateLimit"] = "rate_limit";
    /** The sent payload was too large to be processed. */ Status["PayloadTooLarge"] = "payload_too_large";
    /** The event could not be processed. */ Status["Invalid"] = "invalid";
    /** A server-side error ocurred during submission. */ Status["Failed"] = "failed";
    /** a server or client side error occuring when a request takes too long and is cancelled */ Status["Timeout"] = "Timeout";
    /** NodeJS runtime environment error.. E.g. disconnected from network */ Status["SystemError"] = "SystemError";
})(Status || (Status = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"edfiW":[function(require,module,exports,__globalThis) {
/**
 * Source: [jed's gist's comment]{@link https://gist.github.com/jed/982883?permalink_comment_id=3223002#gistcomment-3223002}.
 * Returns a random v4 UUID of the form xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx,
 * where each x is replaced with a random hexadecimal digit from 0 to f, and
 * y is replaced with a random hexadecimal digit from 8 to b.
 * Used to generate UUIDs for deviceIds.
 * @private
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UUID", function() {
    return UUID;
});
var _tslib = require("tslib");
var _globalScope = require("../global-scope");
var legacyUUID = function legacyUUID(a) {
    return a // if the placeholder was passed, return
     ? (a ^ // unless b is 8,
    Math.random() * // in which case
    16 >> // a random number from
    a / 4 // 8 to 11
    ).toString(16) // in hexadecimal
     : (String(1e7) + // 10000000 +
    String(-1000) + // -1000 +
    String(-4000) + // -4000 +
    String(-8000) + // -80000000 +
    String(-100000000000) // -100000000000,
    ).replace(// replacing
    /[018]/g, UUID);
};
var hex = (0, _tslib.__spreadArray)([], (0, _tslib.__read)(Array(256).keys()), false).map(function(index) {
    return index.toString(16).padStart(2, '0');
});
var UUID = function UUID(a) {
    var _a;
    var globalScope = (0, _globalScope.getGlobalScope)();
    /* istanbul ignore next */ if (!((_a = globalScope === null || globalScope === void 0 ? void 0 : globalScope.crypto) === null || _a === void 0 ? void 0 : _a.getRandomValues)) // Fallback to legacy UUID generation if crypto is not available
    return legacyUUID(a);
    var r = globalScope.crypto.getRandomValues(new Uint8Array(16));
    r[6] = r[6] & 0x0f | 0x40;
    r[8] = r[8] & 0x3f | 0x80;
    return (0, _tslib.__spreadArray)([], (0, _tslib.__read)(r.entries()), false).map(function(_a) {
        var _b = (0, _tslib.__read)(_a, 2), index = _b[0], int = _b[1];
        return [
            4,
            6,
            8,
            10
        ].includes(index) ? "-".concat(hex[int]) : hex[int];
    }).join('');
};

},{"tslib":"C7UIb","../global-scope":"4bWZr","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4bWZr":[function(require,module,exports,__globalThis) {
/* eslint-disable no-restricted-globals */ /* Only file allowed to access to globalThis, window, self */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getGlobalScope", function() {
    return getGlobalScope;
});
var global = arguments[3];
var getGlobalScope = function getGlobalScope() {
    // This should only be used for integrations with Amplitude that are not running in a browser environment
    //   We need to specify the name of the global variable as a string to prevent it from being minified
    var ampIntegrationContextName = 'ampIntegrationContext';
    if (typeof globalThis !== 'undefined' && typeof globalThis[ampIntegrationContextName] !== 'undefined') return globalThis[ampIntegrationContextName];
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof window !== 'undefined') return window;
    if (typeof self !== 'undefined') return self;
    if (typeof global !== 'undefined') return global;
    return undefined;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jibvN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createTrackEvent", function() {
    return createTrackEvent;
});
parcelHelpers.export(exports, "createIdentifyEvent", function() {
    return createIdentifyEvent;
});
parcelHelpers.export(exports, "createGroupIdentifyEvent", function() {
    return createGroupIdentifyEvent;
});
parcelHelpers.export(exports, "createGroupEvent", function() {
    return createGroupEvent;
});
parcelHelpers.export(exports, "createRevenueEvent", function() {
    return createRevenueEvent;
});
var _tslib = require("tslib");
var _identify = require("../identify");
var _event = require("../types/event/event");
var createTrackEvent = function createTrackEvent(eventInput, eventProperties, eventOptions) {
    var baseEvent = typeof eventInput === 'string' ? {
        event_type: eventInput
    } : eventInput;
    return (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, baseEvent), eventOptions), eventProperties && {
        event_properties: eventProperties
    });
};
var createIdentifyEvent = function createIdentifyEvent(identify, eventOptions) {
    var identifyEvent = (0, _tslib.__assign)((0, _tslib.__assign)({}, eventOptions), {
        event_type: (0, _event.SpecialEventType).IDENTIFY,
        user_properties: identify.getUserProperties()
    });
    return identifyEvent;
};
var createGroupIdentifyEvent = function createGroupIdentifyEvent(groupType, groupName, identify, eventOptions) {
    var _a;
    var groupIdentify = (0, _tslib.__assign)((0, _tslib.__assign)({}, eventOptions), {
        event_type: (0, _event.SpecialEventType).GROUP_IDENTIFY,
        group_properties: identify.getUserProperties(),
        groups: (_a = {}, _a[groupType] = groupName, _a)
    });
    return groupIdentify;
};
var createGroupEvent = function createGroupEvent(groupType, groupName, eventOptions) {
    var _a;
    var identify = new (0, _identify.Identify)();
    identify.set(groupType, groupName);
    var groupEvent = (0, _tslib.__assign)((0, _tslib.__assign)({}, eventOptions), {
        event_type: (0, _event.SpecialEventType).IDENTIFY,
        user_properties: identify.getUserProperties(),
        groups: (_a = {}, _a[groupType] = groupName, _a)
    });
    return groupEvent;
};
var createRevenueEvent = function createRevenueEvent(revenue, eventOptions) {
    return (0, _tslib.__assign)((0, _tslib.__assign)({}, eventOptions), {
        event_type: (0, _event.SpecialEventType).REVENUE,
        event_properties: revenue.getEventProperties()
    });
};

},{"tslib":"C7UIb","../identify":"jaNNQ","../types/event/event":"kiCzI","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jaNNQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Identify", function() {
    return Identify;
});
parcelHelpers.export(exports, "IdentifyOperation", function() {
    return IdentifyOperation;
});
var _tslib = require("tslib");
var _constants = require("./types/constants");
var _validProperties = require("./utils/valid-properties");
var Identify = /** @class */ function() {
    function Identify() {
        this._propertySet = new Set();
        this._properties = {};
    }
    Identify.prototype.getUserProperties = function() {
        return (0, _tslib.__assign)({}, this._properties);
    };
    Identify.prototype.set = function(property, value) {
        this._safeSet(IdentifyOperation.SET, property, value);
        return this;
    };
    Identify.prototype.setOnce = function(property, value) {
        this._safeSet(IdentifyOperation.SET_ONCE, property, value);
        return this;
    };
    Identify.prototype.append = function(property, value) {
        this._safeSet(IdentifyOperation.APPEND, property, value);
        return this;
    };
    Identify.prototype.prepend = function(property, value) {
        this._safeSet(IdentifyOperation.PREPEND, property, value);
        return this;
    };
    Identify.prototype.postInsert = function(property, value) {
        this._safeSet(IdentifyOperation.POSTINSERT, property, value);
        return this;
    };
    Identify.prototype.preInsert = function(property, value) {
        this._safeSet(IdentifyOperation.PREINSERT, property, value);
        return this;
    };
    Identify.prototype.remove = function(property, value) {
        this._safeSet(IdentifyOperation.REMOVE, property, value);
        return this;
    };
    Identify.prototype.add = function(property, value) {
        this._safeSet(IdentifyOperation.ADD, property, value);
        return this;
    };
    Identify.prototype.unset = function(property) {
        this._safeSet(IdentifyOperation.UNSET, property, (0, _constants.UNSET_VALUE));
        return this;
    };
    Identify.prototype.clearAll = function() {
        // When clear all happens, all properties are unset. Reset the entire object.
        this._properties = {};
        this._properties[IdentifyOperation.CLEAR_ALL] = (0, _constants.UNSET_VALUE);
        return this;
    };
    // Returns whether or not this set actually worked.
    Identify.prototype._safeSet = function(operation, property, value) {
        if (this._validate(operation, property, value)) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            var userPropertyMap = this._properties[operation];
            if (userPropertyMap === undefined) {
                userPropertyMap = {};
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                this._properties[operation] = userPropertyMap;
            }
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            userPropertyMap[property] = value;
            this._propertySet.add(property);
            return true;
        }
        return false;
    };
    Identify.prototype._validate = function(operation, property, value) {
        if (this._properties[IdentifyOperation.CLEAR_ALL] !== undefined) // clear all already set. Skipping operation;
        return false;
        if (this._propertySet.has(property)) // Property already used. Skipping operation
        return false;
        if (operation === IdentifyOperation.ADD) return typeof value === 'number';
        if (operation !== IdentifyOperation.UNSET && operation !== IdentifyOperation.REMOVE) return (0, _validProperties.isValidProperties)(property, value);
        return true;
    };
    return Identify;
}();
var IdentifyOperation;
(function(IdentifyOperation) {
    // Base Operations to set values
    IdentifyOperation["SET"] = "$set";
    IdentifyOperation["SET_ONCE"] = "$setOnce";
    // Operations around modifying existing values
    IdentifyOperation["ADD"] = "$add";
    IdentifyOperation["APPEND"] = "$append";
    IdentifyOperation["PREPEND"] = "$prepend";
    IdentifyOperation["REMOVE"] = "$remove";
    // Operations around appending values *if* they aren't present
    IdentifyOperation["PREINSERT"] = "$preInsert";
    IdentifyOperation["POSTINSERT"] = "$postInsert";
    // Operations around removing properties/values
    IdentifyOperation["UNSET"] = "$unset";
    IdentifyOperation["CLEAR_ALL"] = "$clearAll";
})(IdentifyOperation || (IdentifyOperation = {}));

},{"tslib":"C7UIb","./types/constants":"a5ZK7","./utils/valid-properties":"jr3Bh","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"a5ZK7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UNSET_VALUE", function() {
    return UNSET_VALUE;
});
parcelHelpers.export(exports, "AMPLITUDE_PREFIX", function() {
    return AMPLITUDE_PREFIX;
});
parcelHelpers.export(exports, "STORAGE_PREFIX", function() {
    return STORAGE_PREFIX;
});
parcelHelpers.export(exports, "AMPLITUDE_SERVER_URL", function() {
    return AMPLITUDE_SERVER_URL;
});
parcelHelpers.export(exports, "EU_AMPLITUDE_SERVER_URL", function() {
    return EU_AMPLITUDE_SERVER_URL;
});
parcelHelpers.export(exports, "AMPLITUDE_BATCH_SERVER_URL", function() {
    return AMPLITUDE_BATCH_SERVER_URL;
});
parcelHelpers.export(exports, "EU_AMPLITUDE_BATCH_SERVER_URL", function() {
    return EU_AMPLITUDE_BATCH_SERVER_URL;
});
var UNSET_VALUE = '-';
var AMPLITUDE_PREFIX = 'AMP';
var STORAGE_PREFIX = "".concat(AMPLITUDE_PREFIX, "_unsent");
var AMPLITUDE_SERVER_URL = 'https://api2.amplitude.com/2/httpapi';
var EU_AMPLITUDE_SERVER_URL = 'https://api.eu.amplitude.com/2/httpapi';
var AMPLITUDE_BATCH_SERVER_URL = 'https://api2.amplitude.com/batch';
var EU_AMPLITUDE_BATCH_SERVER_URL = 'https://api.eu.amplitude.com/batch';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jr3Bh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isValidObject", function() {
    return isValidObject;
});
parcelHelpers.export(exports, "isValidProperties", function() {
    return isValidProperties;
});
var _tslib = require("tslib");
var MAX_PROPERTY_KEYS = 1000;
var isValidObject = function isValidObject(properties) {
    if (Object.keys(properties).length > MAX_PROPERTY_KEYS) return false;
    for(var key in properties){
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        var value = properties[key];
        if (!isValidProperties(key, value)) return false;
    }
    return true;
};
var isValidProperties = function isValidProperties(property, value) {
    var e_1, _a;
    if (typeof property !== 'string') return false;
    if (Array.isArray(value)) {
        var isValid = true;
        try {
            for(var value_1 = (0, _tslib.__values)(value), value_1_1 = value_1.next(); !value_1_1.done; value_1_1 = value_1.next()){
                var valueElement = value_1_1.value;
                if (Array.isArray(valueElement)) return false;
                else if (typeof valueElement === 'object') isValid = isValid && isValidObject(valueElement);
                else if (![
                    'number',
                    'string'
                ].includes(typeof valueElement)) return false;
                if (!isValid) return false;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (value_1_1 && !value_1_1.done && (_a = value_1.return)) _a.call(value_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    } else if (value === null || value === undefined) return false;
    else if (typeof value === 'object') // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    return isValidObject(value);
    else if (![
        'number',
        'string',
        'boolean'
    ].includes(typeof value)) return false;
    return true;
};

},{"tslib":"C7UIb","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"kiCzI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IdentifyOperation", function() {
    return IdentifyOperation;
});
parcelHelpers.export(exports, "SpecialEventType", function() {
    return SpecialEventType;
});
var IdentifyOperation;
(function(IdentifyOperation) {
    // Base Operations to set values
    IdentifyOperation["SET"] = "$set";
    IdentifyOperation["SET_ONCE"] = "$setOnce";
    // Operations around modifying existing values
    IdentifyOperation["ADD"] = "$add";
    IdentifyOperation["APPEND"] = "$append";
    IdentifyOperation["PREPEND"] = "$prepend";
    IdentifyOperation["REMOVE"] = "$remove";
    // Operations around appending values *if* they aren't present
    IdentifyOperation["PREINSERT"] = "$preInsert";
    IdentifyOperation["POSTINSERT"] = "$postInsert";
    // Operations around removing properties/values
    IdentifyOperation["UNSET"] = "$unset";
    IdentifyOperation["CLEAR_ALL"] = "$clearAll";
})(IdentifyOperation || (IdentifyOperation = {}));
var SpecialEventType;
(function(SpecialEventType) {
    SpecialEventType["IDENTIFY"] = "$identify";
    SpecialEventType["GROUP_IDENTIFY"] = "$groupidentify";
    SpecialEventType["REVENUE"] = "revenue_amount";
})(SpecialEventType || (SpecialEventType = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5R4na":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "returnWrapper", function() {
    return returnWrapper;
});
var returnWrapper = function returnWrapper(awaitable) {
    return {
        promise: awaitable || Promise.resolve()
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"42BO0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Revenue", function() {
    return Revenue;
});
parcelHelpers.export(exports, "RevenueProperty", function() {
    return RevenueProperty;
});
var _tslib = require("tslib");
var _validProperties = require("./utils/valid-properties");
var Revenue = /** @class */ function() {
    function Revenue() {
        this.productId = '';
        this.quantity = 1;
        this.price = 0.0;
    }
    Revenue.prototype.setProductId = function(productId) {
        this.productId = productId;
        return this;
    };
    Revenue.prototype.setQuantity = function(quantity) {
        if (quantity > 0) this.quantity = quantity;
        return this;
    };
    Revenue.prototype.setPrice = function(price) {
        this.price = price;
        return this;
    };
    Revenue.prototype.setRevenueType = function(revenueType) {
        this.revenueType = revenueType;
        return this;
    };
    Revenue.prototype.setCurrency = function(currency) {
        this.currency = currency;
        return this;
    };
    Revenue.prototype.setRevenue = function(revenue) {
        this.revenue = revenue;
        return this;
    };
    Revenue.prototype.setReceipt = function(receipt) {
        this.receipt = receipt;
        return this;
    };
    Revenue.prototype.setReceiptSig = function(receiptSig) {
        this.receiptSig = receiptSig;
        return this;
    };
    Revenue.prototype.setEventProperties = function(properties) {
        if ((0, _validProperties.isValidObject)(properties)) this.properties = properties;
        return this;
    };
    Revenue.prototype.getEventProperties = function() {
        var eventProperties = this.properties ? (0, _tslib.__assign)({}, this.properties) : {};
        eventProperties[RevenueProperty.REVENUE_PRODUCT_ID] = this.productId;
        eventProperties[RevenueProperty.REVENUE_QUANTITY] = this.quantity;
        eventProperties[RevenueProperty.REVENUE_PRICE] = this.price;
        eventProperties[RevenueProperty.REVENUE_TYPE] = this.revenueType;
        eventProperties[RevenueProperty.REVENUE_CURRENCY] = this.currency;
        eventProperties[RevenueProperty.REVENUE] = this.revenue;
        eventProperties[RevenueProperty.RECEIPT] = this.receipt;
        eventProperties[RevenueProperty.RECEIPT_SIG] = this.receiptSig;
        return eventProperties;
    };
    return Revenue;
}();
var RevenueProperty;
(function(RevenueProperty) {
    RevenueProperty["REVENUE_PRODUCT_ID"] = "$productId";
    RevenueProperty["REVENUE_QUANTITY"] = "$quantity";
    RevenueProperty["REVENUE_PRICE"] = "$price";
    RevenueProperty["REVENUE_TYPE"] = "$revenueType";
    RevenueProperty["REVENUE_CURRENCY"] = "$currency";
    RevenueProperty["REVENUE"] = "$revenue";
    RevenueProperty["RECEIPT"] = "$receipt";
    RevenueProperty["RECEIPT_SIG"] = "$receiptSig";
})(RevenueProperty || (RevenueProperty = {}));

},{"tslib":"C7UIb","./utils/valid-properties":"jr3Bh","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"j86sF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getResponseBodyString", function() {
    return getResponseBodyString;
});
parcelHelpers.export(exports, "Destination", function() {
    return Destination;
});
var _tslib = require("tslib");
var _status = require("../types/status");
var _messages = require("../types/messages");
var _constants = require("../types/constants");
var _chunk = require("../utils/chunk");
var _resultBuilder = require("../utils/result-builder");
var _config = require("../config");
var _uuid = require("../utils/uuid");
function getErrorMessage(error) {
    if (error instanceof Error) return error.message;
    return String(error);
}
function getResponseBodyString(res) {
    var responseBodyString = '';
    try {
        if ('body' in res) responseBodyString = JSON.stringify(res.body, null, 2);
    } catch (_a) {
    // to avoid crash, but don't care about the error, add comment to avoid empty block lint error
    }
    return responseBodyString;
}
var Destination = /** @class */ function() {
    function Destination() {
        this.name = 'amplitude';
        this.type = 'destination';
        this.retryTimeout = 1000;
        this.throttleTimeout = 30000;
        this.storageKey = '';
        // Indicator of whether events that are scheduled (but not flushed yet).
        // When flush:
        //   1. assign `scheduleId` to `flushId`
        //   2. set `scheduleId` to null
        this.scheduleId = null;
        // Timeout in milliseconds of current schedule
        this.scheduledTimeout = 0;
        // Indicator of whether current flush resolves.
        // When flush resolves, set `flushId` to null
        this.flushId = null;
        this.queue = [];
    }
    Destination.prototype.setup = function(config) {
        var _a;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var unsent;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        this.config = config;
                        this.storageKey = "".concat((0, _constants.STORAGE_PREFIX), "_").concat(this.config.apiKey.substring(0, 10));
                        return [
                            4 /*yield*/ ,
                            (_a = this.config.storageProvider) === null || _a === void 0 ? void 0 : _a.get(this.storageKey)
                        ];
                    case 1:
                        unsent = _b.sent();
                        if (unsent && unsent.length > 0) Promise.all(unsent.map(function(event) {
                            return _this.execute(event);
                        })).catch();
                        return [
                            2 /*return*/ ,
                            Promise.resolve(undefined)
                        ];
                }
            });
        });
    };
    Destination.prototype.execute = function(event) {
        var _this = this;
        // Assign insert_id for dropping invalid event later
        if (!event.insert_id) event.insert_id = (0, _uuid.UUID)();
        return new Promise(function(resolve) {
            var context = {
                event: event,
                attempts: 0,
                callback: function callback(result) {
                    return resolve(result);
                },
                timeout: 0
            };
            _this.queue.push(context);
            _this.schedule(_this.config.flushIntervalMillis);
            _this.saveEvents();
        });
    };
    Destination.prototype.removeEventsExceedFlushMaxRetries = function(list) {
        var _this = this;
        return list.filter(function(context) {
            context.attempts += 1;
            if (context.attempts < _this.config.flushMaxRetries) return true;
            _this.fulfillRequest([
                context
            ], 500, (0, _messages.MAX_RETRIES_EXCEEDED_MESSAGE));
            return false;
        });
    };
    Destination.prototype.scheduleEvents = function(list) {
        var _this = this;
        list.forEach(function(context) {
            _this.schedule(context.timeout === 0 ? _this.config.flushIntervalMillis : context.timeout);
        });
    };
    // Schedule a flush in timeout when
    // 1. No schedule
    // 2. Timeout greater than existing timeout.
    // This makes sure that when throttled, no flush when throttle timeout expires.
    Destination.prototype.schedule = function(timeout) {
        var _this = this;
        if (this.config.offline) return;
        if (this.scheduleId === null || this.scheduleId && timeout > this.scheduledTimeout) {
            if (this.scheduleId) clearTimeout(this.scheduleId);
            this.scheduledTimeout = timeout;
            this.scheduleId = setTimeout(function() {
                _this.queue = _this.queue.map(function(context) {
                    context.timeout = 0;
                    return context;
                });
                _this.flush(true);
            }, timeout);
            return;
        }
    };
    // Mark current schedule is flushed.
    Destination.prototype.resetSchedule = function() {
        this.scheduleId = null;
        this.scheduledTimeout = 0;
    };
    // Flush all events regardless of their timeout
    Destination.prototype.flush = function(useRetry) {
        if (useRetry === void 0) useRetry = false;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var list, later, batches;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        // Skip flush if offline
                        if (this.config.offline) {
                            this.resetSchedule();
                            this.config.loggerProvider.debug('Skipping flush while offline.');
                            return [
                                2 /*return*/ 
                            ];
                        }
                        if (this.flushId) {
                            this.resetSchedule();
                            this.config.loggerProvider.debug('Skipping flush because previous flush has not resolved.');
                            return [
                                2 /*return*/ 
                            ];
                        }
                        this.flushId = this.scheduleId;
                        this.resetSchedule();
                        list = [];
                        later = [];
                        this.queue.forEach(function(context) {
                            return context.timeout === 0 ? list.push(context) : later.push(context);
                        });
                        batches = (0, _chunk.chunk)(list, this.config.flushQueueSize);
                        // Promise.all() doesn't guarantee resolve order.
                        // Sequentially resolve to make sure backend receives events in order
                        return [
                            4 /*yield*/ ,
                            batches.reduce(function(promise, batch) {
                                return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                                    return (0, _tslib.__generator)(this, function(_a) {
                                        switch(_a.label){
                                            case 0:
                                                return [
                                                    4 /*yield*/ ,
                                                    promise
                                                ];
                                            case 1:
                                                _a.sent();
                                                return [
                                                    4 /*yield*/ ,
                                                    this.send(batch, useRetry)
                                                ];
                                            case 2:
                                                return [
                                                    2 /*return*/ ,
                                                    _a.sent()
                                                ];
                                        }
                                    });
                                });
                            }, Promise.resolve())
                        ];
                    case 1:
                        // Promise.all() doesn't guarantee resolve order.
                        // Sequentially resolve to make sure backend receives events in order
                        _a.sent();
                        // Mark current flush is done
                        this.flushId = null;
                        this.scheduleEvents(this.queue);
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    Destination.prototype.send = function(list, useRetry) {
        if (useRetry === void 0) useRetry = true;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var payload, serverUrl, res, e_1, errorMessage;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.config.apiKey) return [
                            2 /*return*/ ,
                            this.fulfillRequest(list, 400, (0, _messages.MISSING_API_KEY_MESSAGE))
                        ];
                        payload = {
                            api_key: this.config.apiKey,
                            events: list.map(function(context) {
                                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                var _$_a = context.event, extra = _$_a.extra, eventWithoutExtra = (0, _tslib.__rest)(_$_a, [
                                    "extra"
                                ]);
                                return eventWithoutExtra;
                            }),
                            options: {
                                min_id_length: this.config.minIdLength
                            },
                            client_upload_time: new Date().toISOString(),
                            request_metadata: this.config.requestMetadata
                        };
                        this.config.requestMetadata = new (0, _config.RequestMetadata)();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        serverUrl = (0, _config.createServerConfig)(this.config.serverUrl, this.config.serverZone, this.config.useBatch).serverUrl;
                        return [
                            4 /*yield*/ ,
                            this.config.transportProvider.send(serverUrl, payload)
                        ];
                    case 2:
                        res = _a.sent();
                        if (res === null) {
                            this.fulfillRequest(list, 0, (0, _messages.UNEXPECTED_ERROR_MESSAGE));
                            return [
                                2 /*return*/ 
                            ];
                        }
                        if (!useRetry) {
                            if ('body' in res) this.fulfillRequest(list, res.statusCode, "".concat(res.status, ": ").concat(getResponseBodyString(res)));
                            else this.fulfillRequest(list, res.statusCode, res.status);
                            return [
                                2 /*return*/ 
                            ];
                        }
                        this.handleResponse(res, list);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_1 = _a.sent();
                        errorMessage = getErrorMessage(e_1);
                        this.config.loggerProvider.error(errorMessage);
                        this.handleResponse({
                            status: (0, _status.Status).Failed,
                            statusCode: 0
                        }, list);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    Destination.prototype.handleResponse = function(res, list) {
        var status = res.status;
        switch(status){
            case (0, _status.Status).Success:
                this.handleSuccessResponse(res, list);
                break;
            case (0, _status.Status).Invalid:
                this.handleInvalidResponse(res, list);
                break;
            case (0, _status.Status).PayloadTooLarge:
                this.handlePayloadTooLargeResponse(res, list);
                break;
            case (0, _status.Status).RateLimit:
                this.handleRateLimitResponse(res, list);
                break;
            default:
                // log intermediate event status before retry
                this.config.loggerProvider.warn("{code: 0, error: \"Status '".concat(status, "' provided for ").concat(list.length, " events\"}"));
                this.handleOtherResponse(list);
                break;
        }
    };
    Destination.prototype.handleSuccessResponse = function(res, list) {
        this.fulfillRequest(list, res.statusCode, (0, _messages.SUCCESS_MESSAGE));
    };
    Destination.prototype.handleInvalidResponse = function(res, list) {
        var _this = this;
        if (res.body.missingField || res.body.error.startsWith((0, _messages.INVALID_API_KEY))) {
            this.fulfillRequest(list, res.statusCode, res.body.error);
            return;
        }
        var dropIndex = (0, _tslib.__spreadArray)((0, _tslib.__spreadArray)((0, _tslib.__spreadArray)((0, _tslib.__spreadArray)([], (0, _tslib.__read)(Object.values(res.body.eventsWithInvalidFields)), false), (0, _tslib.__read)(Object.values(res.body.eventsWithMissingFields)), false), (0, _tslib.__read)(Object.values(res.body.eventsWithInvalidIdLengths)), false), (0, _tslib.__read)(res.body.silencedEvents), false).flat();
        var dropIndexSet = new Set(dropIndex);
        var retry = list.filter(function(context, index) {
            if (dropIndexSet.has(index)) {
                _this.fulfillRequest([
                    context
                ], res.statusCode, res.body.error);
                return;
            }
            return true;
        });
        if (retry.length > 0) // log intermediate event status before retry
        this.config.loggerProvider.warn(getResponseBodyString(res));
        var tryable = this.removeEventsExceedFlushMaxRetries(retry);
        this.scheduleEvents(tryable);
    };
    Destination.prototype.handlePayloadTooLargeResponse = function(res, list) {
        if (list.length === 1) {
            this.fulfillRequest(list, res.statusCode, res.body.error);
            return;
        }
        // log intermediate event status before retry
        this.config.loggerProvider.warn(getResponseBodyString(res));
        this.config.flushQueueSize /= 2;
        var tryable = this.removeEventsExceedFlushMaxRetries(list);
        this.scheduleEvents(tryable);
    };
    Destination.prototype.handleRateLimitResponse = function(res, list) {
        var _this = this;
        var dropUserIds = Object.keys(res.body.exceededDailyQuotaUsers);
        var dropDeviceIds = Object.keys(res.body.exceededDailyQuotaDevices);
        var throttledIndex = res.body.throttledEvents;
        var dropUserIdsSet = new Set(dropUserIds);
        var dropDeviceIdsSet = new Set(dropDeviceIds);
        var throttledIndexSet = new Set(throttledIndex);
        var retry = list.filter(function(context, index) {
            if (context.event.user_id && dropUserIdsSet.has(context.event.user_id) || context.event.device_id && dropDeviceIdsSet.has(context.event.device_id)) {
                _this.fulfillRequest([
                    context
                ], res.statusCode, res.body.error);
                return;
            }
            if (throttledIndexSet.has(index)) context.timeout = _this.throttleTimeout;
            return true;
        });
        if (retry.length > 0) // log intermediate event status before retry
        this.config.loggerProvider.warn(getResponseBodyString(res));
        var tryable = this.removeEventsExceedFlushMaxRetries(retry);
        this.scheduleEvents(tryable);
    };
    Destination.prototype.handleOtherResponse = function(list) {
        var _this = this;
        var later = list.map(function(context) {
            context.timeout = context.attempts * _this.retryTimeout;
            return context;
        });
        var tryable = this.removeEventsExceedFlushMaxRetries(later);
        this.scheduleEvents(tryable);
    };
    Destination.prototype.fulfillRequest = function(list, code, message) {
        this.removeEvents(list);
        list.forEach(function(context) {
            return context.callback((0, _resultBuilder.buildResult)(context.event, code, message));
        });
    };
    /**
     * This is called on
     * 1) new events are added to queue; or
     * 2) response comes back for a request
     *
     * Update the event storage based on the queue
     */ Destination.prototype.saveEvents = function() {
        if (!this.config.storageProvider) return;
        var updatedEvents = this.queue.map(function(context) {
            return context.event;
        });
        this.config.storageProvider.set(this.storageKey, updatedEvents);
    };
    /**
     * This is called on response comes back for a request
     */ Destination.prototype.removeEvents = function(eventsToRemove) {
        this.queue = this.queue.filter(function(queuedContext) {
            return !eventsToRemove.some(function(context) {
                return context.event.insert_id === queuedContext.event.insert_id;
            });
        });
        this.saveEvents();
    };
    return Destination;
}();

},{"tslib":"C7UIb","../types/status":"l9ub9","../types/messages":"67nWr","../types/constants":"a5ZK7","../utils/chunk":"gHwA5","../utils/result-builder":"4rE2c","../config":"e682o","../utils/uuid":"edfiW","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gHwA5":[function(require,module,exports,__globalThis) {
// Creates an array of elements split into groups the length of size.
// If array can't be split evenly, the final chunk will be the remaining elements.
// Works similary as https://lodash.com/docs/4.17.15#chunk
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "chunk", function() {
    return chunk;
});
var chunk = function chunk(arr, size) {
    var chunkSize = Math.max(size, 1);
    return arr.reduce(function(chunks, element, index) {
        var chunkIndex = Math.floor(index / chunkSize);
        if (!chunks[chunkIndex]) chunks[chunkIndex] = [];
        chunks[chunkIndex].push(element);
        return chunks;
    }, []);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"e682o":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDefaultConfig", function() {
    return getDefaultConfig;
});
parcelHelpers.export(exports, "Config", function() {
    return Config;
});
parcelHelpers.export(exports, "getServerUrl", function() {
    return getServerUrl;
});
parcelHelpers.export(exports, "createServerConfig", function() {
    return createServerConfig;
});
parcelHelpers.export(exports, "RequestMetadata", function() {
    return RequestMetadata;
});
var _constants = require("./types/constants");
var _logger = require("./logger");
var _loglevel = require("./types/loglevel");
var getDefaultConfig = function getDefaultConfig() {
    return {
        flushMaxRetries: 12,
        flushQueueSize: 200,
        flushIntervalMillis: 10000,
        instanceName: '$default_instance',
        logLevel: (0, _loglevel.LogLevel).Warn,
        loggerProvider: new (0, _logger.Logger)(),
        offline: false,
        optOut: false,
        serverUrl: (0, _constants.AMPLITUDE_SERVER_URL),
        serverZone: 'US',
        useBatch: false
    };
};
var Config = /** @class */ function() {
    function Config(options) {
        var _a, _b, _c, _d;
        this._optOut = false;
        var defaultConfig = getDefaultConfig();
        this.apiKey = options.apiKey;
        this.flushIntervalMillis = (_a = options.flushIntervalMillis) !== null && _a !== void 0 ? _a : defaultConfig.flushIntervalMillis;
        this.flushMaxRetries = options.flushMaxRetries || defaultConfig.flushMaxRetries;
        this.flushQueueSize = options.flushQueueSize || defaultConfig.flushQueueSize;
        this.instanceName = options.instanceName || defaultConfig.instanceName;
        this.loggerProvider = options.loggerProvider || defaultConfig.loggerProvider;
        this.logLevel = (_b = options.logLevel) !== null && _b !== void 0 ? _b : defaultConfig.logLevel;
        this.minIdLength = options.minIdLength;
        this.plan = options.plan;
        this.ingestionMetadata = options.ingestionMetadata;
        this.offline = options.offline !== undefined ? options.offline : defaultConfig.offline;
        this.optOut = (_c = options.optOut) !== null && _c !== void 0 ? _c : defaultConfig.optOut;
        this.serverUrl = options.serverUrl;
        this.serverZone = options.serverZone || defaultConfig.serverZone;
        this.storageProvider = options.storageProvider;
        this.transportProvider = options.transportProvider;
        this.useBatch = (_d = options.useBatch) !== null && _d !== void 0 ? _d : defaultConfig.useBatch;
        this.loggerProvider.enable(this.logLevel);
        var serverConfig = createServerConfig(options.serverUrl, options.serverZone, options.useBatch);
        this.serverZone = serverConfig.serverZone;
        this.serverUrl = serverConfig.serverUrl;
    }
    Object.defineProperty(Config.prototype, "optOut", {
        get: function get() {
            return this._optOut;
        },
        set: function set(optOut) {
            this._optOut = optOut;
        },
        enumerable: false,
        configurable: true
    });
    return Config;
}();
var getServerUrl = function getServerUrl(serverZone, useBatch) {
    if (serverZone === 'EU') return useBatch ? (0, _constants.EU_AMPLITUDE_BATCH_SERVER_URL) : (0, _constants.EU_AMPLITUDE_SERVER_URL);
    return useBatch ? (0, _constants.AMPLITUDE_BATCH_SERVER_URL) : (0, _constants.AMPLITUDE_SERVER_URL);
};
var createServerConfig = function createServerConfig(serverUrl, serverZone, useBatch) {
    if (serverUrl === void 0) serverUrl = '';
    if (serverZone === void 0) serverZone = getDefaultConfig().serverZone;
    if (useBatch === void 0) useBatch = getDefaultConfig().useBatch;
    if (serverUrl) return {
        serverUrl: serverUrl,
        serverZone: undefined
    };
    var _serverZone = [
        'US',
        'EU'
    ].includes(serverZone) ? serverZone : getDefaultConfig().serverZone;
    return {
        serverZone: _serverZone,
        serverUrl: getServerUrl(_serverZone, useBatch)
    };
};
var RequestMetadata = /** @class */ function() {
    function RequestMetadata() {
        this.sdk = {
            metrics: {
                histogram: {}
            }
        };
    }
    RequestMetadata.prototype.recordHistogram = function(key, value) {
        this.sdk.metrics.histogram[key] = value;
    };
    return RequestMetadata;
}();
var HistogramOptions = /** @class */ function() {
    function HistogramOptions() {}
    return HistogramOptions;
}();

},{"./types/constants":"a5ZK7","./logger":"1aV1H","./types/loglevel":"4Ddkh","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1aV1H":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Logger", function() {
    return Logger;
});
var _loglevel = require("./types/loglevel");
var PREFIX = 'Amplitude Logger ';
var Logger = /** @class */ function() {
    function Logger() {
        this.logLevel = (0, _loglevel.LogLevel).None;
    }
    Logger.prototype.disable = function() {
        this.logLevel = (0, _loglevel.LogLevel).None;
    };
    Logger.prototype.enable = function(logLevel) {
        if (logLevel === void 0) logLevel = (0, _loglevel.LogLevel).Warn;
        this.logLevel = logLevel;
    };
    Logger.prototype.log = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (this.logLevel < (0, _loglevel.LogLevel).Verbose) return;
        console.log("".concat(PREFIX, "[Log]: ").concat(args.join(' ')));
    };
    Logger.prototype.warn = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (this.logLevel < (0, _loglevel.LogLevel).Warn) return;
        console.warn("".concat(PREFIX, "[Warn]: ").concat(args.join(' ')));
    };
    Logger.prototype.error = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (this.logLevel < (0, _loglevel.LogLevel).Error) return;
        console.error("".concat(PREFIX, "[Error]: ").concat(args.join(' ')));
    };
    Logger.prototype.debug = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (this.logLevel < (0, _loglevel.LogLevel).Debug) return;
        // console.debug output is hidden by default in chrome
        console.log("".concat(PREFIX, "[Debug]: ").concat(args.join(' ')));
    };
    return Logger;
}();

},{"./types/loglevel":"4Ddkh","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4Ddkh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LogLevel", function() {
    return LogLevel;
});
var LogLevel;
(function(LogLevel) {
    LogLevel[LogLevel["None"] = 0] = "None";
    LogLevel[LogLevel["Error"] = 1] = "Error";
    LogLevel[LogLevel["Warn"] = 2] = "Warn";
    LogLevel[LogLevel["Verbose"] = 3] = "Verbose";
    LogLevel[LogLevel["Debug"] = 4] = "Debug";
})(LogLevel || (LogLevel = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"kvWSM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IdentityEventSender", function() {
    return IdentityEventSender;
});
var _tslib = require("tslib");
var _analyticsConnector = require("../analytics-connector");
var IdentityEventSender = /** @class */ function() {
    function IdentityEventSender() {
        this.name = 'identity';
        this.type = 'before';
        this.identityStore = (0, _analyticsConnector.getAnalyticsConnector)().identityStore;
    }
    IdentityEventSender.prototype.execute = function(context) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var userProperties;
            return (0, _tslib.__generator)(this, function(_a) {
                userProperties = context.user_properties;
                if (userProperties) this.identityStore.editIdentity().updateUserProperties(userProperties).commit();
                return [
                    2 /*return*/ ,
                    context
                ];
            });
        });
    };
    IdentityEventSender.prototype.setup = function(config) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                if (config.instanceName) this.identityStore = (0, _analyticsConnector.getAnalyticsConnector)(config.instanceName).identityStore;
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return IdentityEventSender;
}();

},{"tslib":"C7UIb","../analytics-connector":"2Lk9V","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2Lk9V":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAnalyticsConnector", function() {
    return getAnalyticsConnector;
});
parcelHelpers.export(exports, "setConnectorUserId", function() {
    return setConnectorUserId;
});
parcelHelpers.export(exports, "setConnectorDeviceId", function() {
    return setConnectorDeviceId;
});
var _analyticsConnector = require("@amplitude/analytics-connector");
var getAnalyticsConnector = function getAnalyticsConnector(instanceName) {
    if (instanceName === void 0) instanceName = '$default_instance';
    return (0, _analyticsConnector.AnalyticsConnector).getInstance(instanceName);
};
var setConnectorUserId = function setConnectorUserId(userId, instanceName) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    getAnalyticsConnector(instanceName).identityStore.editIdentity().setUserId(userId).commit();
};
var setConnectorDeviceId = function setConnectorDeviceId(deviceId, instanceName) {
    getAnalyticsConnector(instanceName).identityStore.editIdentity().setDeviceId(deviceId).commit();
};

},{"@amplitude/analytics-connector":"6AinM","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6AinM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AnalyticsConnector", function() {
    return AnalyticsConnector;
});
var global = arguments[3];
var ApplicationContextProviderImpl = /** @class */ function() {
    function ApplicationContextProviderImpl() {}
    ApplicationContextProviderImpl.prototype.getApplicationContext = function() {
        return {
            versionName: this.versionName,
            language: getLanguage(),
            platform: 'Web',
            os: undefined,
            deviceModel: undefined
        };
    };
    return ApplicationContextProviderImpl;
}();
var getLanguage = function getLanguage() {
    return typeof navigator !== 'undefined' && (navigator.languages && navigator.languages[0] || navigator.language) || '';
};
var EventBridgeImpl = /** @class */ function() {
    function EventBridgeImpl() {
        this.queue = [];
    }
    EventBridgeImpl.prototype.logEvent = function(event) {
        if (!this.receiver) {
            if (this.queue.length < 512) this.queue.push(event);
        } else this.receiver(event);
    };
    EventBridgeImpl.prototype.setEventReceiver = function(receiver) {
        this.receiver = receiver;
        if (this.queue.length > 0) {
            this.queue.forEach(function(event) {
                receiver(event);
            });
            this.queue = [];
        }
    };
    return EventBridgeImpl;
}();
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var __assign = function __assign1() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
typeof SuppressedError === "function" && SuppressedError;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var isEqual = function isEqual1(obj1, obj2) {
    var e_1, _a;
    var primitive = [
        'string',
        'number',
        'boolean',
        'undefined'
    ];
    var typeA = typeof obj1;
    var typeB = typeof obj2;
    if (typeA !== typeB) return false;
    try {
        for(var primitive_1 = __values(primitive), primitive_1_1 = primitive_1.next(); !primitive_1_1.done; primitive_1_1 = primitive_1.next()){
            var p = primitive_1_1.value;
            if (p === typeA) return obj1 === obj2;
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (primitive_1_1 && !primitive_1_1.done && (_a = primitive_1.return)) _a.call(primitive_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    // check null
    if (obj1 == null && obj2 == null) return true;
    else if (obj1 == null || obj2 == null) return false;
    // if got here - objects
    if (obj1.length !== obj2.length) return false;
    //check if arrays
    var isArrayA = Array.isArray(obj1);
    var isArrayB = Array.isArray(obj2);
    if (isArrayA !== isArrayB) return false;
    if (isArrayA && isArrayB) //arrays
    for(var i = 0; i < obj1.length; i++){
        if (!isEqual(obj1[i], obj2[i])) return false;
    }
    else {
        //objects
        var sorted1 = Object.keys(obj1).sort();
        var sorted2 = Object.keys(obj2).sort();
        if (!isEqual(sorted1, sorted2)) return false;
        //compare object values
        var result_1 = true;
        Object.keys(obj1).forEach(function(key) {
            if (!isEqual(obj1[key], obj2[key])) result_1 = false;
        });
        return result_1;
    }
    return true;
};
var ID_OP_SET = '$set';
var ID_OP_UNSET = '$unset';
var ID_OP_CLEAR_ALL = '$clearAll';
// Polyfill for Object.entries
if (!Object.entries) Object.entries = function(obj) {
    var ownProps = Object.keys(obj);
    var i = ownProps.length;
    var resArray = new Array(i);
    while(i--)resArray[i] = [
        ownProps[i],
        obj[ownProps[i]]
    ];
    return resArray;
};
var IdentityStoreImpl = /** @class */ function() {
    function IdentityStoreImpl() {
        this.identity = {
            userProperties: {}
        };
        this.listeners = new Set();
    }
    IdentityStoreImpl.prototype.editIdentity = function() {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var _$self = this;
        var actingUserProperties = __assign({}, this.identity.userProperties);
        var actingIdentity = __assign(__assign({}, this.identity), {
            userProperties: actingUserProperties
        });
        return {
            setUserId: function setUserId(userId) {
                actingIdentity.userId = userId;
                return this;
            },
            setDeviceId: function setDeviceId(deviceId) {
                actingIdentity.deviceId = deviceId;
                return this;
            },
            setUserProperties: function setUserProperties(userProperties) {
                actingIdentity.userProperties = userProperties;
                return this;
            },
            setOptOut: function setOptOut(optOut) {
                actingIdentity.optOut = optOut;
                return this;
            },
            updateUserProperties: function updateUserProperties(actions) {
                var e_1, _a, e_2, _b, e_3, _c;
                var actingProperties = actingIdentity.userProperties || {};
                try {
                    for(var _d = __values(Object.entries(actions)), _e = _d.next(); !_e.done; _e = _d.next()){
                        var _f = __read(_e.value, 2), action = _f[0], properties = _f[1];
                        switch(action){
                            case ID_OP_SET:
                                try {
                                    for(var _g = (e_2 = void 0, __values(Object.entries(properties))), _h = _g.next(); !_h.done; _h = _g.next()){
                                        var _j = __read(_h.value, 2), key = _j[0], value = _j[1];
                                        actingProperties[key] = value;
                                    }
                                } catch (e_2_1) {
                                    e_2 = {
                                        error: e_2_1
                                    };
                                } finally{
                                    try {
                                        if (_h && !_h.done && (_b = _g.return)) _b.call(_g);
                                    } finally{
                                        if (e_2) throw e_2.error;
                                    }
                                }
                                break;
                            case ID_OP_UNSET:
                                try {
                                    for(var _k = (e_3 = void 0, __values(Object.keys(properties))), _l = _k.next(); !_l.done; _l = _k.next()){
                                        var key = _l.value;
                                        delete actingProperties[key];
                                    }
                                } catch (e_3_1) {
                                    e_3 = {
                                        error: e_3_1
                                    };
                                } finally{
                                    try {
                                        if (_l && !_l.done && (_c = _k.return)) _c.call(_k);
                                    } finally{
                                        if (e_3) throw e_3.error;
                                    }
                                }
                                break;
                            case ID_OP_CLEAR_ALL:
                                actingProperties = {};
                                break;
                        }
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
                actingIdentity.userProperties = actingProperties;
                return this;
            },
            commit: function commit() {
                _$self.setIdentity(actingIdentity);
                return this;
            }
        };
    };
    IdentityStoreImpl.prototype.getIdentity = function() {
        return __assign({}, this.identity);
    };
    IdentityStoreImpl.prototype.setIdentity = function(identity) {
        var originalIdentity = __assign({}, this.identity);
        this.identity = __assign({}, identity);
        if (!isEqual(originalIdentity, this.identity)) this.listeners.forEach(function(listener) {
            listener(identity);
        });
    };
    IdentityStoreImpl.prototype.addIdentityListener = function(listener) {
        this.listeners.add(listener);
    };
    IdentityStoreImpl.prototype.removeIdentityListener = function(listener) {
        this.listeners.delete(listener);
    };
    return IdentityStoreImpl;
}();
var safeGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof global !== 'undefined' ? global : self;
var AnalyticsConnector = /** @class */ function() {
    function AnalyticsConnector() {
        this.identityStore = new IdentityStoreImpl();
        this.eventBridge = new EventBridgeImpl();
        this.applicationContextProvider = new ApplicationContextProviderImpl();
    }
    AnalyticsConnector.getInstance = function(instanceName) {
        if (!safeGlobal['analyticsConnectorInstances']) safeGlobal['analyticsConnectorInstances'] = {};
        if (!safeGlobal['analyticsConnectorInstances'][instanceName]) safeGlobal['analyticsConnectorInstances'][instanceName] = new AnalyticsConnector();
        return safeGlobal['analyticsConnectorInstances'][instanceName];
    };
    return AnalyticsConnector;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"dxnNU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isNewSession", function() {
    return isNewSession;
});
var isNewSession = function isNewSession(sessionTimeout, lastEventTime) {
    if (lastEventTime === void 0) lastEventTime = Date.now();
    var currentTime = Date.now();
    var timeSinceLastEvent = currentTime - lastEventTime;
    return timeSinceLastEvent > sessionTimeout;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"bYrlE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCookieName", function() {
    return getCookieName;
});
parcelHelpers.export(exports, "getOldCookieName", function() {
    return getOldCookieName;
});
var _constants = require("./types/constants");
var getCookieName = function getCookieName(apiKey, postKey, limit) {
    if (postKey === void 0) postKey = '';
    if (limit === void 0) limit = 10;
    return [
        (0, _constants.AMPLITUDE_PREFIX),
        postKey,
        apiKey.substring(0, limit)
    ].filter(Boolean).join('_');
};
var getOldCookieName = function getOldCookieName(apiKey) {
    return "".concat((0, _constants.AMPLITUDE_PREFIX).toLowerCase(), "_").concat(apiKey.substring(0, 6));
};

},{"./types/constants":"a5ZK7","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8sq0e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getLanguage", function() {
    return getLanguage;
});
var getLanguage = function getLanguage() {
    var _a, _b, _c, _d;
    if (typeof navigator === 'undefined') return '';
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    var userLanguage = navigator.userLanguage;
    return (_d = (_c = (_b = (_a = navigator.languages) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : navigator.language) !== null && _c !== void 0 ? _c : userLanguage) !== null && _d !== void 0 ? _d : '';
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"80C04":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getQueryParams", function() {
    return getQueryParams;
});
parcelHelpers.export(exports, "tryDecodeURIComponent", function() {
    return tryDecodeURIComponent;
});
var _globalScope = require("./global-scope");
var getQueryParams = function getQueryParams() {
    var _a;
    var globalScope = (0, _globalScope.getGlobalScope)();
    /* istanbul ignore if */ if (!((_a = globalScope === null || globalScope === void 0 ? void 0 : globalScope.location) === null || _a === void 0 ? void 0 : _a.search)) return {};
    var pairs = globalScope.location.search.substring(1).split('&').filter(Boolean);
    var params = pairs.reduce(function(acc, curr) {
        var query = curr.split('=', 2);
        var key = tryDecodeURIComponent(query[0]);
        var value = tryDecodeURIComponent(query[1]);
        if (!value) return acc;
        acc[key] = value;
        return acc;
    }, {});
    return params;
};
var tryDecodeURIComponent = function tryDecodeURIComponent(value) {
    if (value === void 0) value = '';
    try {
        return decodeURIComponent(value);
    } catch (_a) {
        return '';
    }
};

},{"./global-scope":"4bWZr","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6BQsR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getStacktrace", function() {
    return getStacktrace;
});
parcelHelpers.export(exports, "getClientLogConfig", function() {
    return getClientLogConfig;
});
parcelHelpers.export(exports, "getValueByStringPath", function() {
    return getValueByStringPath;
});
parcelHelpers.export(exports, "getClientStates", function() {
    return getClientStates;
});
parcelHelpers.export(exports, "debugWrapper", function() {
    return debugWrapper;
});
var _tslib = require("tslib");
var _loglevel = require("../types/loglevel");
var getStacktrace = function getStacktrace(ignoreDepth) {
    if (ignoreDepth === void 0) ignoreDepth = 0;
    var trace = new Error().stack || '';
    return trace.split('\n').slice(2 + ignoreDepth).map(function(text) {
        return text.trim();
    });
};
var getClientLogConfig = function getClientLogConfig(client) {
    return function() {
        var _a = (0, _tslib.__assign)({}, client.config), logger = _a.loggerProvider, logLevel = _a.logLevel;
        return {
            logger: logger,
            logLevel: logLevel
        };
    };
};
var getValueByStringPath = function getValueByStringPath(obj, path) {
    var e_1, _a;
    path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
    path = path.replace(/^\./, ''); // strip a leading dot
    try {
        for(var _b = (0, _tslib.__values)(path.split('.')), _c = _b.next(); !_c.done; _c = _b.next()){
            var attr = _c.value;
            if (attr in obj) obj = obj[attr];
            else return;
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return obj;
};
var getClientStates = function getClientStates(client, paths) {
    return function() {
        var e_2, _a;
        var res = {};
        try {
            for(var paths_1 = (0, _tslib.__values)(paths), paths_1_1 = paths_1.next(); !paths_1_1.done; paths_1_1 = paths_1.next()){
                var path = paths_1_1.value;
                res[path] = getValueByStringPath(client, path);
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (paths_1_1 && !paths_1_1.done && (_a = paths_1.return)) _a.call(paths_1);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        return res;
    };
};
var debugWrapper = function debugWrapper(fn, fnName, getLogConfig, getStates, fnContext) {
    if (fnContext === void 0) fnContext = null;
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _a = getLogConfig(), logger = _a.logger, logLevel = _a.logLevel;
        // return early if possible to reduce overhead
        if (logLevel && logLevel < (0, _loglevel.LogLevel).Debug || !logLevel || !logger) return fn.apply(fnContext, args);
        var debugContext = {
            type: 'invoke public method',
            name: fnName,
            args: args,
            stacktrace: getStacktrace(1),
            time: {
                start: new Date().toISOString()
            },
            states: {}
        };
        if (getStates && debugContext.states) debugContext.states.before = getStates();
        var result = fn.apply(fnContext, args);
        if (result && result.promise) // if result is a promise, add the callback
        result.promise.then(function() {
            if (getStates && debugContext.states) debugContext.states.after = getStates();
            if (debugContext.time) debugContext.time.end = new Date().toISOString();
            logger.debug(JSON.stringify(debugContext, null, 2));
        });
        else {
            if (getStates && debugContext.states) debugContext.states.after = getStates();
            if (debugContext.time) debugContext.time.end = new Date().toISOString();
            logger.debug(JSON.stringify(debugContext, null, 2));
        }
        return result;
    };
};

},{"tslib":"C7UIb","../types/loglevel":"4Ddkh","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"cUIMK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MemoryStorage", function() {
    return MemoryStorage;
});
var _tslib = require("tslib");
var MemoryStorage = /** @class */ function() {
    function MemoryStorage() {
        this.memoryStorage = new Map();
    }
    MemoryStorage.prototype.isEnabled = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    true
                ];
            });
        });
    };
    MemoryStorage.prototype.get = function(key) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.memoryStorage.get(key)
                ];
            });
        });
    };
    MemoryStorage.prototype.getRaw = function(key) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var value;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.get(key)
                        ];
                    case 1:
                        value = _a.sent();
                        return [
                            2 /*return*/ ,
                            value ? JSON.stringify(value) : undefined
                        ];
                }
            });
        });
    };
    MemoryStorage.prototype.set = function(key, value) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                this.memoryStorage.set(key, value);
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    MemoryStorage.prototype.remove = function(key) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                this.memoryStorage.delete(key);
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    MemoryStorage.prototype.reset = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                this.memoryStorage.clear();
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return MemoryStorage;
}();

},{"tslib":"C7UIb","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"22BRC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CookieStorage", function() {
    return CookieStorage;
});
var _tslib = require("tslib");
var _globalScope = require("../global-scope");
var CookieStorage = /** @class */ function() {
    function CookieStorage(options) {
        this.options = (0, _tslib.__assign)({}, options);
    }
    CookieStorage.prototype.isEnabled = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var testStrorage, testKey, value, _a;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        /* istanbul ignore if */ if (!(0, _globalScope.getGlobalScope)()) return [
                            2 /*return*/ ,
                            false
                        ];
                        CookieStorage.testValue = String(Date.now());
                        testStrorage = new CookieStorage(this.options);
                        testKey = 'AMP_TEST';
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            4,
                            5,
                            7
                        ]);
                        return [
                            4 /*yield*/ ,
                            testStrorage.set(testKey, CookieStorage.testValue)
                        ];
                    case 2:
                        _b.sent();
                        return [
                            4 /*yield*/ ,
                            testStrorage.get(testKey)
                        ];
                    case 3:
                        value = _b.sent();
                        return [
                            2 /*return*/ ,
                            value === CookieStorage.testValue
                        ];
                    case 4:
                        _a = _b.sent();
                        /* istanbul ignore next */ return [
                            2 /*return*/ ,
                            false
                        ];
                    case 5:
                        return [
                            4 /*yield*/ ,
                            testStrorage.remove(testKey)
                        ];
                    case 6:
                        _b.sent();
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 7:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    CookieStorage.prototype.get = function(key) {
        var _a;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var value, decodedValue;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.getRaw(key)
                        ];
                    case 1:
                        value = _b.sent();
                        if (!value) return [
                            2 /*return*/ ,
                            undefined
                        ];
                        try {
                            decodedValue = (_a = decodeCookiesAsDefault(value)) !== null && _a !== void 0 ? _a : decodeCookiesWithDoubleUrlEncoding(value);
                            if (decodedValue === undefined) {
                                console.error("Amplitude Logger [Error]: Failed to decode cookie value for key: ".concat(key, ", value: ").concat(value));
                                return [
                                    2 /*return*/ ,
                                    undefined
                                ];
                            }
                            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
                            return [
                                2 /*return*/ ,
                                JSON.parse(decodedValue)
                            ];
                        } catch (_c) {
                            console.error("Amplitude Logger [Error]: Failed to parse cookie value for key: ".concat(key, ", value: ").concat(value));
                            return [
                                2 /*return*/ ,
                                undefined
                            ];
                        }
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    CookieStorage.prototype.getRaw = function(key) {
        var _a, _b;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var globalScope, cookie, match;
            return (0, _tslib.__generator)(this, function(_c) {
                globalScope = (0, _globalScope.getGlobalScope)();
                cookie = (_b = (_a = globalScope === null || globalScope === void 0 ? void 0 : globalScope.document) === null || _a === void 0 ? void 0 : _a.cookie.split('; ')) !== null && _b !== void 0 ? _b : [];
                match = cookie.find(function(c) {
                    return c.indexOf(key + '=') === 0;
                });
                if (!match) return [
                    2 /*return*/ ,
                    undefined
                ];
                return [
                    2 /*return*/ ,
                    match.substring(key.length + 1)
                ];
            });
        });
    };
    CookieStorage.prototype.set = function(key, value) {
        var _a;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var expirationDays, expires, expireDate, date, str, globalScope, errorMessage;
            return (0, _tslib.__generator)(this, function(_b) {
                try {
                    expirationDays = (_a = this.options.expirationDays) !== null && _a !== void 0 ? _a : 0;
                    expires = value !== null ? expirationDays : -1;
                    expireDate = undefined;
                    if (expires) {
                        date = new Date();
                        date.setTime(date.getTime() + expires * 86400000);
                        expireDate = date;
                    }
                    str = "".concat(key, "=").concat(btoa(encodeURIComponent(JSON.stringify(value))));
                    if (expireDate) str += "; expires=".concat(expireDate.toUTCString());
                    str += '; path=/';
                    if (this.options.domain) str += "; domain=".concat(this.options.domain);
                    if (this.options.secure) str += '; Secure';
                    if (this.options.sameSite) str += "; SameSite=".concat(this.options.sameSite);
                    globalScope = (0, _globalScope.getGlobalScope)();
                    if (globalScope) globalScope.document.cookie = str;
                } catch (error) {
                    errorMessage = error instanceof Error ? error.message : String(error);
                    console.error("Amplitude Logger [Error]: Failed to set cookie for key: ".concat(key, ". Error: ").concat(errorMessage));
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    CookieStorage.prototype.remove = function(key) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.set(key, null)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    CookieStorage.prototype.reset = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return CookieStorage;
}();
var decodeCookiesAsDefault = function decodeCookiesAsDefault(value) {
    try {
        return decodeURIComponent(atob(value));
    } catch (_a) {
        return undefined;
    }
};
var decodeCookiesWithDoubleUrlEncoding = function decodeCookiesWithDoubleUrlEncoding(value) {
    // Modern Ruby (v7+) automatically encodes cookies with URL encoding by
    // https://api.rubyonrails.org/classes/ActionDispatch/Cookies.html
    try {
        return decodeURIComponent(atob(decodeURIComponent(value)));
    } catch (_a) {
        return undefined;
    }
};

},{"tslib":"C7UIb","../global-scope":"4bWZr","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"eCmYy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getStorageKey", function() {
    return getStorageKey;
});
var _constants = require("../types/constants");
var getStorageKey = function getStorageKey(apiKey, postKey, limit) {
    if (postKey === void 0) postKey = '';
    if (limit === void 0) limit = 10;
    return [
        (0, _constants.AMPLITUDE_PREFIX),
        postKey,
        apiKey.substring(0, limit)
    ].filter(Boolean).join('_');
};

},{"../types/constants":"a5ZK7","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"daeJA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BaseTransport", function() {
    return BaseTransport;
});
var _status = require("../types/status");
var BaseTransport = /** @class */ function() {
    function BaseTransport() {}
    BaseTransport.prototype.send = function(_serverUrl, _payload) {
        return Promise.resolve(null);
    };
    BaseTransport.prototype.buildResponse = function(responseJSON) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
        if (typeof responseJSON !== 'object') return null;
        var statusCode = responseJSON.code || 0;
        var status = this.buildStatus(statusCode);
        switch(status){
            case (0, _status.Status).Success:
                return {
                    status: status,
                    statusCode: statusCode,
                    body: {
                        eventsIngested: (_a = responseJSON.events_ingested) !== null && _a !== void 0 ? _a : 0,
                        payloadSizeBytes: (_b = responseJSON.payload_size_bytes) !== null && _b !== void 0 ? _b : 0,
                        serverUploadTime: (_c = responseJSON.server_upload_time) !== null && _c !== void 0 ? _c : 0
                    }
                };
            case (0, _status.Status).Invalid:
                return {
                    status: status,
                    statusCode: statusCode,
                    body: {
                        error: (_d = responseJSON.error) !== null && _d !== void 0 ? _d : '',
                        missingField: (_e = responseJSON.missing_field) !== null && _e !== void 0 ? _e : '',
                        eventsWithInvalidFields: (_f = responseJSON.events_with_invalid_fields) !== null && _f !== void 0 ? _f : {},
                        eventsWithMissingFields: (_g = responseJSON.events_with_missing_fields) !== null && _g !== void 0 ? _g : {},
                        eventsWithInvalidIdLengths: (_h = responseJSON.events_with_invalid_id_lengths) !== null && _h !== void 0 ? _h : {},
                        epsThreshold: (_j = responseJSON.eps_threshold) !== null && _j !== void 0 ? _j : 0,
                        exceededDailyQuotaDevices: (_k = responseJSON.exceeded_daily_quota_devices) !== null && _k !== void 0 ? _k : {},
                        silencedDevices: (_l = responseJSON.silenced_devices) !== null && _l !== void 0 ? _l : [],
                        silencedEvents: (_m = responseJSON.silenced_events) !== null && _m !== void 0 ? _m : [],
                        throttledDevices: (_o = responseJSON.throttled_devices) !== null && _o !== void 0 ? _o : {},
                        throttledEvents: (_p = responseJSON.throttled_events) !== null && _p !== void 0 ? _p : []
                    }
                };
            case (0, _status.Status).PayloadTooLarge:
                return {
                    status: status,
                    statusCode: statusCode,
                    body: {
                        error: (_q = responseJSON.error) !== null && _q !== void 0 ? _q : ''
                    }
                };
            case (0, _status.Status).RateLimit:
                return {
                    status: status,
                    statusCode: statusCode,
                    body: {
                        error: (_r = responseJSON.error) !== null && _r !== void 0 ? _r : '',
                        epsThreshold: (_s = responseJSON.eps_threshold) !== null && _s !== void 0 ? _s : 0,
                        throttledDevices: (_t = responseJSON.throttled_devices) !== null && _t !== void 0 ? _t : {},
                        throttledUsers: (_u = responseJSON.throttled_users) !== null && _u !== void 0 ? _u : {},
                        exceededDailyQuotaDevices: (_v = responseJSON.exceeded_daily_quota_devices) !== null && _v !== void 0 ? _v : {},
                        exceededDailyQuotaUsers: (_w = responseJSON.exceeded_daily_quota_users) !== null && _w !== void 0 ? _w : {},
                        throttledEvents: (_x = responseJSON.throttled_events) !== null && _x !== void 0 ? _x : []
                    }
                };
            case (0, _status.Status).Timeout:
            default:
                return {
                    status: status,
                    statusCode: statusCode
                };
        }
    };
    BaseTransport.prototype.buildStatus = function(code) {
        if (code >= 200 && code < 300) return (0, _status.Status).Success;
        if (code === 429) return (0, _status.Status).RateLimit;
        if (code === 413) return (0, _status.Status).PayloadTooLarge;
        if (code === 408) return (0, _status.Status).Timeout;
        if (code >= 400 && code < 500) return (0, _status.Status).Invalid;
        if (code >= 500) return (0, _status.Status).Failed;
        return (0, _status.Status).Unknown;
    };
    return BaseTransport;
}();

},{"../types/status":"l9ub9","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"c9NGk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FetchTransport", function() {
    return FetchTransport;
});
var _tslib = require("tslib");
var _base = require("./base");
var FetchTransport = /** @class */ function(_super) {
    (0, _tslib.__extends)(FetchTransport, _super);
    function FetchTransport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FetchTransport.prototype.send = function(serverUrl, payload) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var options, response, responseText;
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        /* istanbul ignore if */ if (typeof fetch === 'undefined') throw new Error('FetchTransport is not supported');
                        options = {
                            headers: {
                                'Content-Type': 'application/json',
                                Accept: '*/*'
                            },
                            body: JSON.stringify(payload),
                            method: 'POST'
                        };
                        return [
                            4 /*yield*/ ,
                            fetch(serverUrl, options)
                        ];
                    case 1:
                        response = _a.sent();
                        return [
                            4 /*yield*/ ,
                            response.text()
                        ];
                    case 2:
                        responseText = _a.sent();
                        try {
                            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                            return [
                                2 /*return*/ ,
                                this.buildResponse(JSON.parse(responseText))
                            ];
                        } catch (_b) {
                            return [
                                2 /*return*/ ,
                                this.buildResponse({
                                    code: response.status
                                })
                            ];
                        }
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return FetchTransport;
}((0, _base.BaseTransport));

},{"tslib":"C7UIb","./base":"daeJA","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"fBWmt":[function(require,module,exports,__globalThis) {
/**
 * @deprecated use ServerZoneType instead
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ServerZone", function() {
    return ServerZone;
});
var ServerZone;
(function(ServerZone) {
    ServerZone["US"] = "US";
    ServerZone["EU"] = "EU";
    /**
     * Add for session-replay-browser migration from analytics-type v1.x.
     */ ServerZone["STAGING"] = "STAGING";
})(ServerZone || (ServerZone = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gHzIR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OfflineDisabled", function() {
    return OfflineDisabled;
});
var OfflineDisabled = null;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"cWEvn":[function(require,module,exports,__globalThis) {
/**
 * Default CSS selectors to define which elements on the page to track.
 * Extend this list to include additional elements to track. For example:
 * ```
 * autocapturePlugin({
 *    cssSelectorAllowlist: [...DEFAULT_CSS_SELECTOR_ALLOWLIST, ".my-class"],
 * })
 * ```
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_CSS_SELECTOR_ALLOWLIST", function() {
    return DEFAULT_CSS_SELECTOR_ALLOWLIST;
});
parcelHelpers.export(exports, "DEFAULT_DATA_ATTRIBUTE_PREFIX", function() {
    return DEFAULT_DATA_ATTRIBUTE_PREFIX;
});
parcelHelpers.export(exports, "DEFAULT_ACTION_CLICK_ALLOWLIST", function() {
    return DEFAULT_ACTION_CLICK_ALLOWLIST;
});
var DEFAULT_CSS_SELECTOR_ALLOWLIST = [
    'a',
    'button',
    'input',
    'select',
    'textarea',
    'label',
    'video',
    'audio',
    '[contenteditable="true" i]',
    '[data-amp-default-track]',
    '.amp-default-track'
];
var DEFAULT_DATA_ATTRIBUTE_PREFIX = 'data-amp-track-';
var DEFAULT_ACTION_CLICK_ALLOWLIST = [
    'div',
    'span',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6'
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"21Z6v":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AmplitudeBrowser", function() {
    return AmplitudeBrowser;
});
var _tslib = require("tslib");
var _analyticsCore = require("@amplitude/analytics-core");
var _defaultTracking = require("./default-tracking");
var _snippetHelper = require("./utils/snippet-helper");
var _context = require("./plugins/context");
var _config = require("./config");
var _pluginPageViewTrackingBrowser = require("@amplitude/plugin-page-view-tracking-browser");
var _formInteractionTracking = require("./plugins/form-interaction-tracking");
var _fileDownloadTracking = require("./plugins/file-download-tracking");
var _constants = require("./constants");
var _detNotification = require("./det-notification");
var _networkConnectivityChecker = require("./plugins/network-connectivity-checker");
var _joinedConfig = require("./config/joined-config");
var _pluginAutocaptureBrowser = require("@amplitude/plugin-autocapture-browser");
var _webAttribution = require("./attribution/web-attribution");
var AmplitudeBrowser = /** @class */ function(_super) {
    (0, _tslib.__extends)(AmplitudeBrowser, _super);
    function AmplitudeBrowser() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AmplitudeBrowser.prototype.plugin = function(name) {
        var plugin = this.timeline.plugins.find(function(plugin) {
            return plugin.name === name;
        });
        if (plugin === undefined) {
            this.config.loggerProvider.debug("Cannot find plugin with name ".concat(name));
            return undefined;
        }
        return plugin;
    };
    AmplitudeBrowser.prototype.init = function(apiKey, userIdOrOptions, maybeOptions) {
        if (apiKey === void 0) apiKey = '';
        var userId;
        var options;
        if (arguments.length > 2) {
            userId = userIdOrOptions;
            options = maybeOptions;
        } else if (typeof userIdOrOptions === 'string') {
            userId = userIdOrOptions;
            options = undefined;
        } else {
            userId = userIdOrOptions === null || userIdOrOptions === void 0 ? void 0 : userIdOrOptions.userId;
            options = userIdOrOptions;
        }
        return (0, _analyticsCore.returnWrapper)(this._init((0, _tslib.__assign)((0, _tslib.__assign)({}, options), {
            userId: userId,
            apiKey: apiKey
        })));
    };
    AmplitudeBrowser.prototype._init = function(options) {
        var _a, _b, _c;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var browserOptions, joinedConfigGenerator, attributionTrackingOptions, queryParams, querySessionId, connector;
            var _this = this;
            return (0, _tslib.__generator)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        // Step 1: Block concurrent initialization
                        if (this.initializing) return [
                            2 /*return*/ 
                        ];
                        this.initializing = true;
                        return [
                            4 /*yield*/ ,
                            (0, _config.useBrowserConfig)(options.apiKey, options, this)
                        ];
                    case 1:
                        browserOptions = _d.sent();
                        if (!options.fetchRemoteConfig) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, _joinedConfig.createBrowserJoinedConfigGenerator)(browserOptions)
                        ];
                    case 2:
                        joinedConfigGenerator = _d.sent();
                        return [
                            4 /*yield*/ ,
                            joinedConfigGenerator.generateJoinedConfig()
                        ];
                    case 3:
                        browserOptions = _d.sent();
                        _d.label = 4;
                    case 4:
                        return [
                            4 /*yield*/ ,
                            _super.prototype._init.call(this, browserOptions)
                        ];
                    case 5:
                        _d.sent();
                        this.logBrowserOptions(browserOptions);
                        if (!(0, _defaultTracking.isAttributionTrackingEnabled)(this.config.defaultTracking)) return [
                            3 /*break*/ ,
                            7
                        ];
                        attributionTrackingOptions = (0, _defaultTracking.getAttributionTrackingConfig)(this.config);
                        this.webAttribution = new (0, _webAttribution.WebAttribution)(attributionTrackingOptions, this.config);
                        // Fetch the current campaign, check if need to track web attribution later
                        return [
                            4 /*yield*/ ,
                            this.webAttribution.init()
                        ];
                    case 6:
                        // Fetch the current campaign, check if need to track web attribution later
                        _d.sent();
                        _d.label = 7;
                    case 7:
                        queryParams = (0, _analyticsCore.getQueryParams)();
                        querySessionId = Number.isNaN(Number(queryParams.ampSessionId)) ? undefined : Number(queryParams.ampSessionId);
                        this.setSessionId((_c = (_b = (_a = options.sessionId) !== null && _a !== void 0 ? _a : querySessionId) !== null && _b !== void 0 ? _b : this.config.sessionId) !== null && _c !== void 0 ? _c : Date.now());
                        connector = (0, _analyticsCore.getAnalyticsConnector)(options.instanceName);
                        connector.identityStore.setIdentity({
                            userId: this.config.userId,
                            deviceId: this.config.deviceId
                        });
                        if (!(this.config.offline !== (0, _analyticsCore.OfflineDisabled))) return [
                            3 /*break*/ ,
                            9
                        ];
                        return [
                            4 /*yield*/ ,
                            this.add((0, _networkConnectivityChecker.networkConnectivityCheckerPlugin)()).promise
                        ];
                    case 8:
                        _d.sent();
                        _d.label = 9;
                    case 9:
                        return [
                            4 /*yield*/ ,
                            this.add(new (0, _analyticsCore.Destination)()).promise
                        ];
                    case 10:
                        _d.sent();
                        return [
                            4 /*yield*/ ,
                            this.add(new (0, _context.Context)()).promise
                        ];
                    case 11:
                        _d.sent();
                        return [
                            4 /*yield*/ ,
                            this.add(new (0, _analyticsCore.IdentityEventSender)()).promise
                        ];
                    case 12:
                        _d.sent();
                        // Notify if DET is enabled
                        (0, _detNotification.detNotify)(this.config);
                        if (!(0, _defaultTracking.isFileDownloadTrackingEnabled)(this.config.defaultTracking)) return [
                            3 /*break*/ ,
                            14
                        ];
                        this.config.loggerProvider.debug('Adding file download tracking plugin');
                        return [
                            4 /*yield*/ ,
                            this.add((0, _fileDownloadTracking.fileDownloadTracking)()).promise
                        ];
                    case 13:
                        _d.sent();
                        _d.label = 14;
                    case 14:
                        if (!(0, _defaultTracking.isFormInteractionTrackingEnabled)(this.config.defaultTracking)) return [
                            3 /*break*/ ,
                            16
                        ];
                        this.config.loggerProvider.debug('Adding form interaction plugin');
                        return [
                            4 /*yield*/ ,
                            this.add((0, _formInteractionTracking.formInteractionTracking)()).promise
                        ];
                    case 15:
                        _d.sent();
                        _d.label = 16;
                    case 16:
                        if (!(0, _defaultTracking.isPageViewTrackingEnabled)(this.config.defaultTracking)) return [
                            3 /*break*/ ,
                            18
                        ];
                        this.config.loggerProvider.debug('Adding page view tracking plugin');
                        return [
                            4 /*yield*/ ,
                            this.add((0, _pluginPageViewTrackingBrowser.pageViewTrackingPlugin)((0, _defaultTracking.getPageViewTrackingConfig)(this.config))).promise
                        ];
                    case 17:
                        _d.sent();
                        _d.label = 18;
                    case 18:
                        if (!(0, _defaultTracking.isElementInteractionsEnabled)(this.config.autocapture)) return [
                            3 /*break*/ ,
                            20
                        ];
                        this.config.loggerProvider.debug('Adding user interactions plugin (autocapture plugin)');
                        return [
                            4 /*yield*/ ,
                            this.add((0, _pluginAutocaptureBrowser.autocapturePlugin)((0, _defaultTracking.getElementInteractionsConfig)(this.config))).promise
                        ];
                    case 19:
                        _d.sent();
                        _d.label = 20;
                    case 20:
                        this.initializing = false;
                        // Step 6: Run queued dispatch functions
                        return [
                            4 /*yield*/ ,
                            this.runQueuedFunctions('dispatchQ')
                        ];
                    case 21:
                        // Step 6: Run queued dispatch functions
                        _d.sent();
                        // Step 7: Add the event receiver after running remaining queued functions.
                        connector.eventBridge.setEventReceiver(function(event) {
                            _this.track(event.eventType, event.eventProperties);
                        });
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    AmplitudeBrowser.prototype.getUserId = function() {
        var _a;
        return (_a = this.config) === null || _a === void 0 ? void 0 : _a.userId;
    };
    AmplitudeBrowser.prototype.setUserId = function(userId) {
        if (!this.config) {
            this.q.push(this.setUserId.bind(this, userId));
            return;
        }
        this.config.loggerProvider.debug('function setUserId: ', userId);
        if (userId !== this.config.userId || userId === undefined) {
            this.config.userId = userId;
            (0, _analyticsCore.setConnectorUserId)(userId, this.config.instanceName);
        }
    };
    AmplitudeBrowser.prototype.getDeviceId = function() {
        var _a;
        return (_a = this.config) === null || _a === void 0 ? void 0 : _a.deviceId;
    };
    AmplitudeBrowser.prototype.setDeviceId = function(deviceId) {
        if (!this.config) {
            this.q.push(this.setDeviceId.bind(this, deviceId));
            return;
        }
        this.config.loggerProvider.debug('function setDeviceId: ', deviceId);
        this.config.deviceId = deviceId;
        (0, _analyticsCore.setConnectorDeviceId)(deviceId, this.config.instanceName);
    };
    AmplitudeBrowser.prototype.reset = function() {
        this.setDeviceId((0, _analyticsCore.UUID)());
        this.setUserId(undefined);
    };
    AmplitudeBrowser.prototype.getSessionId = function() {
        var _a;
        return (_a = this.config) === null || _a === void 0 ? void 0 : _a.sessionId;
    };
    AmplitudeBrowser.prototype.setSessionId = function(sessionId) {
        var _a;
        var promises = [];
        if (!this.config) {
            this.q.push(this.setSessionId.bind(this, sessionId));
            return (0, _analyticsCore.returnWrapper)(Promise.resolve());
        }
        // Prevents starting a new session with the same session ID
        if (sessionId === this.config.sessionId) return (0, _analyticsCore.returnWrapper)(Promise.resolve());
        this.config.loggerProvider.debug('function setSessionId: ', sessionId);
        var previousSessionId = this.getSessionId();
        var lastEventTime = this.config.lastEventTime;
        var lastEventId = (_a = this.config.lastEventId) !== null && _a !== void 0 ? _a : -1;
        this.config.sessionId = sessionId;
        this.config.lastEventTime = undefined;
        this.config.pageCounter = 0;
        if ((0, _defaultTracking.isSessionTrackingEnabled)(this.config.defaultTracking)) {
            if (previousSessionId && lastEventTime) promises.push(this.track((0, _constants.DEFAULT_SESSION_END_EVENT), undefined, {
                device_id: this.previousSessionDeviceId,
                event_id: ++lastEventId,
                session_id: previousSessionId,
                time: lastEventTime + 1,
                user_id: this.previousSessionUserId
            }).promise);
            this.config.lastEventTime = this.config.sessionId;
        }
        // Fire web attribution event when enable webAttribution tracking
        // 1. has new campaign (call setSessionId from init function)
        // 2. or shouldTrackNewCampaign (call setSessionId from async process(event) when there has new campaign and resetSessionOnNewCampaign = true )
        var isCampaignEventTracked = this.trackCampaignEventIfNeeded(++lastEventId, promises);
        if ((0, _defaultTracking.isSessionTrackingEnabled)(this.config.defaultTracking)) promises.push(this.track((0, _constants.DEFAULT_SESSION_START_EVENT), undefined, {
            event_id: isCampaignEventTracked ? ++lastEventId : lastEventId,
            session_id: this.config.sessionId,
            time: this.config.lastEventTime
        }).promise);
        this.previousSessionDeviceId = this.config.deviceId;
        this.previousSessionUserId = this.config.userId;
        return (0, _analyticsCore.returnWrapper)(Promise.all(promises));
    };
    AmplitudeBrowser.prototype.extendSession = function() {
        if (!this.config) {
            this.q.push(this.extendSession.bind(this));
            return;
        }
        this.config.lastEventTime = Date.now();
    };
    AmplitudeBrowser.prototype.setTransport = function(transport) {
        if (!this.config) {
            this.q.push(this.setTransport.bind(this, transport));
            return;
        }
        this.config.transportProvider = (0, _config.createTransport)(transport);
    };
    AmplitudeBrowser.prototype.identify = function(identify, eventOptions) {
        if ((0, _snippetHelper.isInstanceProxy)(identify)) {
            var queue = identify._q;
            identify._q = [];
            identify = (0, _snippetHelper.convertProxyObjectToRealObject)(new (0, _analyticsCore.Identify)(), queue);
        }
        if (eventOptions === null || eventOptions === void 0 ? void 0 : eventOptions.user_id) this.setUserId(eventOptions.user_id);
        if (eventOptions === null || eventOptions === void 0 ? void 0 : eventOptions.device_id) this.setDeviceId(eventOptions.device_id);
        return _super.prototype.identify.call(this, identify, eventOptions);
    };
    AmplitudeBrowser.prototype.groupIdentify = function(groupType, groupName, identify, eventOptions) {
        if ((0, _snippetHelper.isInstanceProxy)(identify)) {
            var queue = identify._q;
            identify._q = [];
            identify = (0, _snippetHelper.convertProxyObjectToRealObject)(new (0, _analyticsCore.Identify)(), queue);
        }
        return _super.prototype.groupIdentify.call(this, groupType, groupName, identify, eventOptions);
    };
    AmplitudeBrowser.prototype.revenue = function(revenue, eventOptions) {
        if ((0, _snippetHelper.isInstanceProxy)(revenue)) {
            var queue = revenue._q;
            revenue._q = [];
            revenue = (0, _snippetHelper.convertProxyObjectToRealObject)(new (0, _analyticsCore.Revenue)(), queue);
        }
        return _super.prototype.revenue.call(this, revenue, eventOptions);
    };
    AmplitudeBrowser.prototype.trackCampaignEventIfNeeded = function(lastEventId, promises) {
        if (!this.webAttribution || !this.webAttribution.shouldTrackNewCampaign) return false;
        var campaignEvent = this.webAttribution.generateCampaignEvent(lastEventId);
        if (promises) promises.push(this.track(campaignEvent).promise);
        else this.track(campaignEvent);
        this.config.loggerProvider.log('Tracking attribution.');
        return true;
    };
    AmplitudeBrowser.prototype.process = function(event) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var currentTime, isEventInNewSession, shouldSetSessionIdOnNewCampaign;
            return (0, _tslib.__generator)(this, function(_a) {
                currentTime = Date.now();
                isEventInNewSession = (0, _analyticsCore.isNewSession)(this.config.sessionTimeout, this.config.lastEventTime);
                shouldSetSessionIdOnNewCampaign = this.webAttribution && this.webAttribution.shouldSetSessionIdOnNewCampaign();
                if (event.event_type !== (0, _constants.DEFAULT_SESSION_START_EVENT) && event.event_type !== (0, _constants.DEFAULT_SESSION_END_EVENT) && (!event.session_id || event.session_id === this.getSessionId())) {
                    if (isEventInNewSession || shouldSetSessionIdOnNewCampaign) {
                        this.setSessionId(currentTime);
                        if (shouldSetSessionIdOnNewCampaign) this.config.loggerProvider.log('Created a new session for new campaign.');
                    } else if (!isEventInNewSession) // Web attribution should be tracked during the middle of a session
                    // if there has been a chance in the campaign information.
                    this.trackCampaignEventIfNeeded();
                }
                return [
                    2 /*return*/ ,
                    _super.prototype.process.call(this, event)
                ];
            });
        });
    };
    AmplitudeBrowser.prototype.logBrowserOptions = function(browserConfig) {
        try {
            var browserConfigCopy = (0, _tslib.__assign)((0, _tslib.__assign)({}, browserConfig), {
                apiKey: browserConfig.apiKey.substring(0, 10) + '********'
            });
            this.config.loggerProvider.debug('Initialized Amplitude with BrowserConfig:', JSON.stringify(browserConfigCopy));
        } catch (e) {
            /* istanbul ignore next */ this.config.loggerProvider.error('Error logging browser config', e);
        }
    };
    return AmplitudeBrowser;
}((0, _analyticsCore.AmplitudeCore));

},{"tslib":"C7UIb","@amplitude/analytics-core":"4c2pj","./default-tracking":"3E1f6","./utils/snippet-helper":"ajPs6","./plugins/context":"8wtZX","./config":"5yfQ0","@amplitude/plugin-page-view-tracking-browser":"8wWFA","./plugins/form-interaction-tracking":"36Fvd","./plugins/file-download-tracking":"2zrYN","./constants":"la8xP","./det-notification":"2yhjP","./plugins/network-connectivity-checker":"b6BGo","./config/joined-config":"cwo2J","@amplitude/plugin-autocapture-browser":"kHUNZ","./attribution/web-attribution":"5GcQ4","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3E1f6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isAttributionTrackingEnabled", function() {
    return isAttributionTrackingEnabled;
});
parcelHelpers.export(exports, "isFileDownloadTrackingEnabled", function() {
    return isFileDownloadTrackingEnabled;
});
parcelHelpers.export(exports, "isFormInteractionTrackingEnabled", function() {
    return isFormInteractionTrackingEnabled;
});
parcelHelpers.export(exports, "isPageViewTrackingEnabled", function() {
    return isPageViewTrackingEnabled;
});
parcelHelpers.export(exports, "isSessionTrackingEnabled", function() {
    return isSessionTrackingEnabled;
});
parcelHelpers.export(exports, "isElementInteractionsEnabled", function() {
    return isElementInteractionsEnabled;
});
parcelHelpers.export(exports, "getElementInteractionsConfig", function() {
    return getElementInteractionsConfig;
});
parcelHelpers.export(exports, "getPageViewTrackingConfig", function() {
    return getPageViewTrackingConfig;
});
parcelHelpers.export(exports, "getAttributionTrackingConfig", function() {
    return getAttributionTrackingConfig;
});
var _tslib = require("tslib");
/**
 * Returns false if autocapture === false or if autocapture[event],
 * otherwise returns true
 */ var isTrackingEnabled = function isTrackingEnabled(autocapture, event) {
    if (typeof autocapture === 'boolean') return autocapture;
    if ((autocapture === null || autocapture === void 0 ? void 0 : autocapture[event]) === false) return false;
    return true;
};
var isAttributionTrackingEnabled = function isAttributionTrackingEnabled(autocapture) {
    return isTrackingEnabled(autocapture, 'attribution');
};
var isFileDownloadTrackingEnabled = function isFileDownloadTrackingEnabled(autocapture) {
    return isTrackingEnabled(autocapture, 'fileDownloads');
};
var isFormInteractionTrackingEnabled = function isFormInteractionTrackingEnabled(autocapture) {
    return isTrackingEnabled(autocapture, 'formInteractions');
};
var isPageViewTrackingEnabled = function isPageViewTrackingEnabled(autocapture) {
    return isTrackingEnabled(autocapture, 'pageViews');
};
var isSessionTrackingEnabled = function isSessionTrackingEnabled(autocapture) {
    return isTrackingEnabled(autocapture, 'sessions');
};
var isElementInteractionsEnabled = function isElementInteractionsEnabled(autocapture) {
    if (typeof autocapture === 'boolean') return autocapture;
    if (typeof autocapture === 'object' && (autocapture.elementInteractions === true || typeof autocapture.elementInteractions === 'object')) return true;
    return false;
};
var getElementInteractionsConfig = function getElementInteractionsConfig(config) {
    if (isElementInteractionsEnabled(config.autocapture) && typeof config.autocapture === 'object' && typeof config.autocapture.elementInteractions === 'object') return config.autocapture.elementInteractions;
    return undefined;
};
var getPageViewTrackingConfig = function getPageViewTrackingConfig(config) {
    var trackOn = function trackOn() {
        return false;
    };
    var trackHistoryChanges = undefined;
    var eventType;
    var pageCounter = config.pageCounter;
    var isDefaultPageViewTrackingEnabled = isPageViewTrackingEnabled(config.defaultTracking);
    if (isDefaultPageViewTrackingEnabled) {
        trackOn = undefined;
        eventType = undefined;
        if (config.defaultTracking && typeof config.defaultTracking === 'object' && config.defaultTracking.pageViews && typeof config.defaultTracking.pageViews === 'object') {
            if ('trackOn' in config.defaultTracking.pageViews) trackOn = config.defaultTracking.pageViews.trackOn;
            if ('trackHistoryChanges' in config.defaultTracking.pageViews) trackHistoryChanges = config.defaultTracking.pageViews.trackHistoryChanges;
            if ('eventType' in config.defaultTracking.pageViews && config.defaultTracking.pageViews.eventType) eventType = config.defaultTracking.pageViews.eventType;
        }
    }
    return {
        trackOn: trackOn,
        trackHistoryChanges: trackHistoryChanges,
        eventType: eventType,
        pageCounter: pageCounter
    };
};
var getAttributionTrackingConfig = function getAttributionTrackingConfig(config) {
    if (isAttributionTrackingEnabled(config.defaultTracking) && config.defaultTracking && typeof config.defaultTracking === 'object' && config.defaultTracking.attribution && typeof config.defaultTracking.attribution === 'object') return (0, _tslib.__assign)({}, config.defaultTracking.attribution);
    return {};
};

},{"tslib":"C7UIb","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"ajPs6":[function(require,module,exports,__globalThis) {
/**
 * Applies the proxied functions on the proxied amplitude snippet to an instance of the real object.
 * @ignore
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "runQueuedFunctions", function() {
    return runQueuedFunctions;
});
parcelHelpers.export(exports, "convertProxyObjectToRealObject", function() {
    return convertProxyObjectToRealObject;
});
parcelHelpers.export(exports, "isInstanceProxy", function() {
    return isInstanceProxy;
});
var runQueuedFunctions = function runQueuedFunctions(instance, queue) {
    convertProxyObjectToRealObject(instance, queue);
};
var convertProxyObjectToRealObject = function convertProxyObjectToRealObject(instance, queue) {
    for(var i = 0; i < queue.length; i++){
        var _a = queue[i], name_1 = _a.name, args = _a.args, resolve = _a.resolve;
        var fn = instance && instance[name_1];
        if (typeof fn === 'function') {
            var result = fn.apply(instance, args);
            if (typeof resolve === 'function') resolve(result === null || result === void 0 ? void 0 : result.promise);
        }
    }
    return instance;
};
var isInstanceProxy = function isInstanceProxy(instance) {
    var instanceProxy = instance;
    return instanceProxy && instanceProxy._q !== undefined;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8wtZX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Context", function() {
    return Context;
});
var _tslib = require("tslib");
var _analyticsCore = require("@amplitude/analytics-core");
var _version = require("../version");
var _libPrefix = require("../lib-prefix");
var BROWSER_PLATFORM = 'Web';
var IP_ADDRESS = '$remote';
var Context = /** @class */ function() {
    function Context() {
        this.name = '@amplitude/plugin-context-browser';
        this.type = 'before';
        this.library = "".concat((0, _libPrefix.LIBPREFIX), "/").concat((0, _version.VERSION));
        /* istanbul ignore else */ if (typeof navigator !== 'undefined') this.userAgent = navigator.userAgent;
    }
    Context.prototype.setup = function(config) {
        this.config = config;
        return Promise.resolve(undefined);
    };
    Context.prototype.execute = function(context) {
        var _a, _b;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var time, lastEventId, nextEventId, event;
            return (0, _tslib.__generator)(this, function(_c) {
                time = new Date().getTime();
                lastEventId = (_a = this.config.lastEventId) !== null && _a !== void 0 ? _a : -1;
                nextEventId = (_b = context.event_id) !== null && _b !== void 0 ? _b : lastEventId + 1;
                this.config.lastEventId = nextEventId;
                if (!context.time) this.config.lastEventTime = time;
                event = (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({
                    user_id: this.config.userId,
                    device_id: this.config.deviceId,
                    session_id: this.config.sessionId,
                    time: time
                }, this.config.appVersion && {
                    app_version: this.config.appVersion
                }), this.config.trackingOptions.platform && {
                    platform: BROWSER_PLATFORM
                }), this.config.trackingOptions.language && {
                    language: (0, _analyticsCore.getLanguage)()
                }), this.config.trackingOptions.ipAddress && {
                    ip: IP_ADDRESS
                }), {
                    insert_id: (0, _analyticsCore.UUID)(),
                    partner_id: this.config.partnerId,
                    plan: this.config.plan
                }), this.config.ingestionMetadata && {
                    ingestion_metadata: {
                        source_name: this.config.ingestionMetadata.sourceName,
                        source_version: this.config.ingestionMetadata.sourceVersion
                    }
                }), context), {
                    event_id: nextEventId,
                    library: this.library,
                    user_agent: this.userAgent
                });
                return [
                    2 /*return*/ ,
                    event
                ];
            });
        });
    };
    return Context;
}();

},{"tslib":"C7UIb","@amplitude/analytics-core":"4c2pj","../version":"i5rpJ","../lib-prefix":"kdkJa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"i5rpJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VERSION", function() {
    return VERSION;
});
var VERSION = '2.14.0';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"kdkJa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LIBPREFIX", function() {
    return LIBPREFIX;
});
var LIBPREFIX = 'amplitude-ts';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5yfQ0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BrowserConfig", function() {
    return BrowserConfig;
});
parcelHelpers.export(exports, "useBrowserConfig", function() {
    return useBrowserConfig;
});
parcelHelpers.export(exports, "createCookieStorage", function() {
    return createCookieStorage;
});
parcelHelpers.export(exports, "createTransport", function() {
    return createTransport;
});
parcelHelpers.export(exports, "getTopLevelDomain", function() {
    return getTopLevelDomain;
});
var _tslib = require("tslib");
var _analyticsCore = require("@amplitude/analytics-core");
var _localStorage = require("./storage/local-storage");
var _sessionStorage = require("./storage/session-storage");
var _xhr = require("./transports/xhr");
var _sendBeacon = require("./transports/send-beacon");
var _cookieMigration = require("./cookie-migration");
var _constants = require("./constants");
var _version = require("./version");
// Exported for testing purposes only. Do not expose to public interface.
var BrowserConfig = /** @class */ function(_super) {
    (0, _tslib.__extends)(BrowserConfig, _super);
    function BrowserConfig(apiKey, appVersion, cookieStorage, cookieOptions, defaultTracking, autocapture, deviceId, flushIntervalMillis, flushMaxRetries, flushQueueSize, identityStorage, ingestionMetadata, instanceName, lastEventId, lastEventTime, loggerProvider, logLevel, minIdLength, offline, optOut, partnerId, plan, serverUrl, serverZone, sessionId, sessionTimeout, storageProvider, trackingOptions, transport, useBatch, fetchRemoteConfig, userId, pageCounter, debugLogsEnabled) {
        if (cookieStorage === void 0) cookieStorage = new (0, _analyticsCore.MemoryStorage)();
        if (cookieOptions === void 0) cookieOptions = {
            domain: '',
            expiration: 365,
            sameSite: 'Lax',
            secure: false,
            upgrade: true
        };
        if (flushIntervalMillis === void 0) flushIntervalMillis = 1000;
        if (flushMaxRetries === void 0) flushMaxRetries = 5;
        if (flushQueueSize === void 0) flushQueueSize = 30;
        if (identityStorage === void 0) identityStorage = (0, _constants.DEFAULT_IDENTITY_STORAGE);
        if (loggerProvider === void 0) loggerProvider = new (0, _analyticsCore.Logger)();
        if (logLevel === void 0) logLevel = (0, _analyticsCore.LogLevel).Warn;
        if (offline === void 0) offline = false;
        if (optOut === void 0) optOut = false;
        if (serverUrl === void 0) serverUrl = '';
        if (serverZone === void 0) serverZone = (0, _constants.DEFAULT_SERVER_ZONE);
        if (sessionTimeout === void 0) sessionTimeout = 1800000;
        if (storageProvider === void 0) storageProvider = new (0, _localStorage.LocalStorage)({
            loggerProvider: loggerProvider
        });
        if (trackingOptions === void 0) trackingOptions = {
            ipAddress: true,
            language: true,
            platform: true
        };
        if (transport === void 0) transport = 'fetch';
        if (useBatch === void 0) useBatch = false;
        if (fetchRemoteConfig === void 0) fetchRemoteConfig = true;
        var _this = _super.call(this, {
            apiKey: apiKey,
            storageProvider: storageProvider,
            transportProvider: createTransport(transport)
        }) || this;
        _this.apiKey = apiKey;
        _this.appVersion = appVersion;
        _this.cookieOptions = cookieOptions;
        _this.defaultTracking = defaultTracking;
        _this.autocapture = autocapture;
        _this.flushIntervalMillis = flushIntervalMillis;
        _this.flushMaxRetries = flushMaxRetries;
        _this.flushQueueSize = flushQueueSize;
        _this.identityStorage = identityStorage;
        _this.ingestionMetadata = ingestionMetadata;
        _this.instanceName = instanceName;
        _this.loggerProvider = loggerProvider;
        _this.logLevel = logLevel;
        _this.minIdLength = minIdLength;
        _this.offline = offline;
        _this.partnerId = partnerId;
        _this.plan = plan;
        _this.serverUrl = serverUrl;
        _this.serverZone = serverZone;
        _this.sessionTimeout = sessionTimeout;
        _this.storageProvider = storageProvider;
        _this.trackingOptions = trackingOptions;
        _this.transport = transport;
        _this.useBatch = useBatch;
        _this.fetchRemoteConfig = fetchRemoteConfig;
        _this.version = (0, _version.VERSION);
        _this._optOut = false;
        _this._cookieStorage = cookieStorage;
        _this.deviceId = deviceId;
        _this.lastEventId = lastEventId;
        _this.lastEventTime = lastEventTime;
        _this.optOut = optOut;
        _this.sessionId = sessionId;
        _this.pageCounter = pageCounter;
        _this.userId = userId;
        _this.debugLogsEnabled = debugLogsEnabled;
        _this.loggerProvider.enable(debugLogsEnabled ? (0, _analyticsCore.LogLevel).Debug : _this.logLevel);
        return _this;
    }
    Object.defineProperty(BrowserConfig.prototype, "cookieStorage", {
        get: function get() {
            return this._cookieStorage;
        },
        set: function set(cookieStorage) {
            if (this._cookieStorage !== cookieStorage) {
                this._cookieStorage = cookieStorage;
                this.updateStorage();
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrowserConfig.prototype, "deviceId", {
        get: function get() {
            return this._deviceId;
        },
        set: function set(deviceId) {
            if (this._deviceId !== deviceId) {
                this._deviceId = deviceId;
                this.updateStorage();
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrowserConfig.prototype, "userId", {
        get: function get() {
            return this._userId;
        },
        set: function set(userId) {
            if (this._userId !== userId) {
                this._userId = userId;
                this.updateStorage();
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrowserConfig.prototype, "sessionId", {
        get: function get() {
            return this._sessionId;
        },
        set: function set(sessionId) {
            if (this._sessionId !== sessionId) {
                this._sessionId = sessionId;
                this.updateStorage();
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrowserConfig.prototype, "optOut", {
        get: function get() {
            return this._optOut;
        },
        set: function set(optOut) {
            if (this._optOut !== optOut) {
                this._optOut = optOut;
                this.updateStorage();
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrowserConfig.prototype, "lastEventTime", {
        get: function get() {
            return this._lastEventTime;
        },
        set: function set(lastEventTime) {
            if (this._lastEventTime !== lastEventTime) {
                this._lastEventTime = lastEventTime;
                this.updateStorage();
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrowserConfig.prototype, "lastEventId", {
        get: function get() {
            return this._lastEventId;
        },
        set: function set(lastEventId) {
            if (this._lastEventId !== lastEventId) {
                this._lastEventId = lastEventId;
                this.updateStorage();
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrowserConfig.prototype, "pageCounter", {
        get: function get() {
            return this._pageCounter;
        },
        set: function set(pageCounter) {
            if (this._pageCounter !== pageCounter) {
                this._pageCounter = pageCounter;
                this.updateStorage();
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrowserConfig.prototype, "debugLogsEnabled", {
        set: function set(debugLogsEnabled) {
            if (this._debugLogsEnabled !== debugLogsEnabled) {
                this._debugLogsEnabled = debugLogsEnabled;
                this.updateStorage();
            }
        },
        enumerable: false,
        configurable: true
    });
    BrowserConfig.prototype.updateStorage = function() {
        var cache = {
            deviceId: this._deviceId,
            userId: this._userId,
            sessionId: this._sessionId,
            optOut: this._optOut,
            lastEventTime: this._lastEventTime,
            lastEventId: this._lastEventId,
            pageCounter: this._pageCounter,
            debugLogsEnabled: this._debugLogsEnabled
        };
        this.cookieStorage.set((0, _analyticsCore.getCookieName)(this.apiKey), cache);
    };
    return BrowserConfig;
}((0, _analyticsCore.Config));
var useBrowserConfig = function useBrowserConfig(apiKey, options, amplitudeInstance) {
    if (options === void 0) options = {};
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var identityStorage, cookieOptions, _a, _b, cookieStorage, legacyCookies, previousCookies, queryParams, deviceId, lastEventId, lastEventTime, optOut, sessionId, userId, trackingOptions, pageCounter, debugLogsEnabled, browserConfig;
        var _c;
        var _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2;
        return (0, _tslib.__generator)(this, function(_3) {
            switch(_3.label){
                case 0:
                    identityStorage = options.identityStorage || (0, _constants.DEFAULT_IDENTITY_STORAGE);
                    _c = {};
                    if (!(identityStorage !== (0, _constants.DEFAULT_IDENTITY_STORAGE))) return [
                        3 /*break*/ ,
                        1
                    ];
                    _a = '';
                    return [
                        3 /*break*/ ,
                        5
                    ];
                case 1:
                    if (!((_e = (_d = options.cookieOptions) === null || _d === void 0 ? void 0 : _d.domain) !== null && _e !== void 0)) return [
                        3 /*break*/ ,
                        2
                    ];
                    _b = _e;
                    return [
                        3 /*break*/ ,
                        4
                    ];
                case 2:
                    return [
                        4 /*yield*/ ,
                        getTopLevelDomain()
                    ];
                case 3:
                    _b = _3.sent();
                    _3.label = 4;
                case 4:
                    _a = _b;
                    _3.label = 5;
                case 5:
                    cookieOptions = (0, _tslib.__assign).apply(void 0, [
                        (_c.domain = _a, _c.expiration = 365, _c.sameSite = 'Lax', _c.secure = false, _c.upgrade = true, _c),
                        options.cookieOptions
                    ]);
                    cookieStorage = createCookieStorage(options.identityStorage, cookieOptions);
                    return [
                        4 /*yield*/ ,
                        (0, _cookieMigration.parseLegacyCookies)(apiKey, cookieStorage, (_g = (_f = options.cookieOptions) === null || _f === void 0 ? void 0 : _f.upgrade) !== null && _g !== void 0 ? _g : true)
                    ];
                case 6:
                    legacyCookies = _3.sent();
                    return [
                        4 /*yield*/ ,
                        cookieStorage.get((0, _analyticsCore.getCookieName)(apiKey))
                    ];
                case 7:
                    previousCookies = _3.sent();
                    queryParams = (0, _analyticsCore.getQueryParams)();
                    deviceId = (_m = (_l = (_k = (_j = (_h = options.deviceId) !== null && _h !== void 0 ? _h : queryParams.ampDeviceId) !== null && _j !== void 0 ? _j : queryParams.deviceId) !== null && _k !== void 0 ? _k : previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.deviceId) !== null && _l !== void 0 ? _l : legacyCookies.deviceId) !== null && _m !== void 0 ? _m : (0, _analyticsCore.UUID)();
                    lastEventId = (_o = previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.lastEventId) !== null && _o !== void 0 ? _o : legacyCookies.lastEventId;
                    lastEventTime = (_p = previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.lastEventTime) !== null && _p !== void 0 ? _p : legacyCookies.lastEventTime;
                    optOut = (_r = (_q = options.optOut) !== null && _q !== void 0 ? _q : previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.optOut) !== null && _r !== void 0 ? _r : legacyCookies.optOut;
                    sessionId = (_s = previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.sessionId) !== null && _s !== void 0 ? _s : legacyCookies.sessionId;
                    userId = (_u = (_t = options.userId) !== null && _t !== void 0 ? _t : previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.userId) !== null && _u !== void 0 ? _u : legacyCookies.userId;
                    amplitudeInstance.previousSessionDeviceId = (_v = previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.deviceId) !== null && _v !== void 0 ? _v : legacyCookies.deviceId;
                    amplitudeInstance.previousSessionUserId = (_w = previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.userId) !== null && _w !== void 0 ? _w : legacyCookies.userId;
                    trackingOptions = {
                        ipAddress: (_y = (_x = options.trackingOptions) === null || _x === void 0 ? void 0 : _x.ipAddress) !== null && _y !== void 0 ? _y : true,
                        language: (_0 = (_z = options.trackingOptions) === null || _z === void 0 ? void 0 : _z.language) !== null && _0 !== void 0 ? _0 : true,
                        platform: (_2 = (_1 = options.trackingOptions) === null || _1 === void 0 ? void 0 : _1.platform) !== null && _2 !== void 0 ? _2 : true
                    };
                    pageCounter = previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.pageCounter;
                    debugLogsEnabled = previousCookies === null || previousCookies === void 0 ? void 0 : previousCookies.debugLogsEnabled;
                    // Override default tracking options if autocapture is set
                    if (options.autocapture !== undefined) options.defaultTracking = options.autocapture;
                    browserConfig = new BrowserConfig(apiKey, options.appVersion, cookieStorage, cookieOptions, options.defaultTracking, options.autocapture, deviceId, options.flushIntervalMillis, options.flushMaxRetries, options.flushQueueSize, identityStorage, options.ingestionMetadata, options.instanceName, lastEventId, lastEventTime, options.loggerProvider, options.logLevel, options.minIdLength, options.offline, optOut, options.partnerId, options.plan, options.serverUrl, options.serverZone, sessionId, options.sessionTimeout, options.storageProvider, trackingOptions, options.transport, options.useBatch, options.fetchRemoteConfig, userId, pageCounter, debugLogsEnabled);
                    return [
                        4 /*yield*/ ,
                        browserConfig.storageProvider.isEnabled()
                    ];
                case 8:
                    if (!_3.sent()) {
                        browserConfig.loggerProvider.warn("Storage provider ".concat(browserConfig.storageProvider.constructor.name, " is not enabled. Falling back to MemoryStorage."));
                        browserConfig.storageProvider = new (0, _analyticsCore.MemoryStorage)();
                    }
                    return [
                        2 /*return*/ ,
                        browserConfig
                    ];
            }
        });
    });
};
var createCookieStorage = function createCookieStorage(identityStorage, cookieOptions) {
    if (identityStorage === void 0) identityStorage = (0, _constants.DEFAULT_IDENTITY_STORAGE);
    if (cookieOptions === void 0) cookieOptions = {};
    switch(identityStorage){
        case 'localStorage':
            return new (0, _localStorage.LocalStorage)();
        case 'sessionStorage':
            return new (0, _sessionStorage.SessionStorage)();
        case 'none':
            return new (0, _analyticsCore.MemoryStorage)();
        case 'cookie':
        default:
            return new (0, _analyticsCore.CookieStorage)((0, _tslib.__assign)((0, _tslib.__assign)({}, cookieOptions), {
                expirationDays: cookieOptions.expiration
            }));
    }
};
var createTransport = function createTransport(transport) {
    if (transport === 'xhr') return new (0, _xhr.XHRTransport)();
    if (transport === 'beacon') return new (0, _sendBeacon.SendBeaconTransport)();
    return new (0, _analyticsCore.FetchTransport)();
};
var getTopLevelDomain = function getTopLevelDomain(url) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var host, parts, levels, storageKey, i, i, domain, options, storage, value;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        new (0, _analyticsCore.CookieStorage)().isEnabled()
                    ];
                case 1:
                    if (!_a.sent() || !url && (typeof location === 'undefined' || !location.hostname)) return [
                        2 /*return*/ ,
                        ''
                    ];
                    host = url !== null && url !== void 0 ? url : location.hostname;
                    parts = host.split('.');
                    levels = [];
                    storageKey = 'AMP_TLDTEST';
                    for(i = parts.length - 2; i >= 0; --i)levels.push(parts.slice(i).join('.'));
                    i = 0;
                    _a.label = 2;
                case 2:
                    if (!(i < levels.length)) return [
                        3 /*break*/ ,
                        7
                    ];
                    domain = levels[i];
                    options = {
                        domain: '.' + domain
                    };
                    storage = new (0, _analyticsCore.CookieStorage)(options);
                    return [
                        4 /*yield*/ ,
                        storage.set(storageKey, 1)
                    ];
                case 3:
                    _a.sent();
                    return [
                        4 /*yield*/ ,
                        storage.get(storageKey)
                    ];
                case 4:
                    value = _a.sent();
                    if (!value) return [
                        3 /*break*/ ,
                        6
                    ];
                    return [
                        4 /*yield*/ ,
                        storage.remove(storageKey)
                    ];
                case 5:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        '.' + domain
                    ];
                case 6:
                    i++;
                    return [
                        3 /*break*/ ,
                        2
                    ];
                case 7:
                    return [
                        2 /*return*/ ,
                        ''
                    ];
            }
        });
    });
};

},{"tslib":"C7UIb","@amplitude/analytics-core":"4c2pj","./storage/local-storage":"dEw5m","./storage/session-storage":"aeD2B","./transports/xhr":"MgeA8","./transports/send-beacon":"3K1Oq","./cookie-migration":"m20GK","./constants":"la8xP","./version":"i5rpJ","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"dEw5m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LocalStorage", function() {
    return LocalStorage;
});
var _tslib = require("tslib");
var _analyticsCore = require("@amplitude/analytics-core");
var _browserStorage = require("./browser-storage");
var MAX_ARRAY_LENGTH = 1000;
var LocalStorage = /** @class */ function(_super) {
    (0, _tslib.__extends)(LocalStorage, _super);
    function LocalStorage(config) {
        var _this = this;
        var _a, _b;
        var localStorage;
        try {
            localStorage = (_a = (0, _analyticsCore.getGlobalScope)()) === null || _a === void 0 ? void 0 : _a.localStorage;
        } catch (e) {
            (_b = config === null || config === void 0 ? void 0 : config.loggerProvider) === null || _b === void 0 || _b.debug("Failed to access localStorage. error=".concat(JSON.stringify(e)));
            localStorage = undefined;
        }
        _this = _super.call(this, localStorage) || this;
        _this.loggerProvider = config === null || config === void 0 ? void 0 : config.loggerProvider;
        return _this;
    }
    LocalStorage.prototype.set = function(key, value) {
        var _a;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var droppedEventsCount;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (!(Array.isArray(value) && value.length > MAX_ARRAY_LENGTH)) return [
                            3 /*break*/ ,
                            2
                        ];
                        droppedEventsCount = value.length - MAX_ARRAY_LENGTH;
                        return [
                            4 /*yield*/ ,
                            _super.prototype.set.call(this, key, value.slice(0, MAX_ARRAY_LENGTH))
                        ];
                    case 1:
                        _b.sent();
                        (_a = this.loggerProvider) === null || _a === void 0 || _a.error("Failed to save ".concat(droppedEventsCount, " events because the queue length exceeded ").concat(MAX_ARRAY_LENGTH, "."));
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 2:
                        return [
                            4 /*yield*/ ,
                            _super.prototype.set.call(this, key, value)
                        ];
                    case 3:
                        _b.sent();
                        _b.label = 4;
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return LocalStorage;
}((0, _browserStorage.BrowserStorage));

},{"tslib":"C7UIb","@amplitude/analytics-core":"4c2pj","./browser-storage":"7mGXh","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7mGXh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BrowserStorage", function() {
    return BrowserStorage;
});
var _tslib = require("tslib");
var BrowserStorage = /** @class */ function() {
    function BrowserStorage(storage) {
        this.storage = storage;
    }
    BrowserStorage.prototype.isEnabled = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var random, testStorage, testKey, value, _a;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        /* istanbul ignore if */ if (!this.storage) return [
                            2 /*return*/ ,
                            false
                        ];
                        random = String(Date.now());
                        testStorage = new BrowserStorage(this.storage);
                        testKey = 'AMP_TEST';
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            4,
                            5,
                            7
                        ]);
                        return [
                            4 /*yield*/ ,
                            testStorage.set(testKey, random)
                        ];
                    case 2:
                        _b.sent();
                        return [
                            4 /*yield*/ ,
                            testStorage.get(testKey)
                        ];
                    case 3:
                        value = _b.sent();
                        return [
                            2 /*return*/ ,
                            value === random
                        ];
                    case 4:
                        _a = _b.sent();
                        /* istanbul ignore next */ return [
                            2 /*return*/ ,
                            false
                        ];
                    case 5:
                        return [
                            4 /*yield*/ ,
                            testStorage.remove(testKey)
                        ];
                    case 6:
                        _b.sent();
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 7:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    BrowserStorage.prototype.get = function(key) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var value, _a;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _b.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.getRaw(key)
                        ];
                    case 1:
                        value = _b.sent();
                        if (!value) return [
                            2 /*return*/ ,
                            undefined
                        ];
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
                        return [
                            2 /*return*/ ,
                            JSON.parse(value)
                        ];
                    case 2:
                        _a = _b.sent();
                        console.error("[Amplitude] Error: Could not get value from storage");
                        return [
                            2 /*return*/ ,
                            undefined
                        ];
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    BrowserStorage.prototype.getRaw = function(key) {
        var _a;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_b) {
                return [
                    2 /*return*/ ,
                    ((_a = this.storage) === null || _a === void 0 ? void 0 : _a.getItem(key)) || undefined
                ];
            });
        });
    };
    BrowserStorage.prototype.set = function(key, value) {
        var _a;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_b) {
                try {
                    (_a = this.storage) === null || _a === void 0 || _a.setItem(key, JSON.stringify(value));
                } catch (_c) {
                //
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    BrowserStorage.prototype.remove = function(key) {
        var _a;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_b) {
                try {
                    (_a = this.storage) === null || _a === void 0 || _a.removeItem(key);
                } catch (_c) {
                //
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    BrowserStorage.prototype.reset = function() {
        var _a;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_b) {
                try {
                    (_a = this.storage) === null || _a === void 0 || _a.clear();
                } catch (_c) {
                //
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return BrowserStorage;
}();

},{"tslib":"C7UIb","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"aeD2B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SessionStorage", function() {
    return SessionStorage;
});
var _tslib = require("tslib");
var _analyticsCore = require("@amplitude/analytics-core");
var _browserStorage = require("./browser-storage");
var SessionStorage = /** @class */ function(_super) {
    (0, _tslib.__extends)(SessionStorage, _super);
    function SessionStorage() {
        var _a;
        return _super.call(this, (_a = (0, _analyticsCore.getGlobalScope)()) === null || _a === void 0 ? void 0 : _a.sessionStorage) || this;
    }
    return SessionStorage;
}((0, _browserStorage.BrowserStorage));

},{"tslib":"C7UIb","@amplitude/analytics-core":"4c2pj","./browser-storage":"7mGXh","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"MgeA8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "XHRTransport", function() {
    return XHRTransport;
});
var _tslib = require("tslib");
var _analyticsCore = require("@amplitude/analytics-core");
var XHRTransport = /** @class */ function(_super) {
    (0, _tslib.__extends)(XHRTransport, _super);
    function XHRTransport() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            done: 4
        };
        return _this;
    }
    XHRTransport.prototype.send = function(serverUrl, payload) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    new Promise(function(resolve, reject) {
                        /* istanbul ignore if */ if (typeof XMLHttpRequest === 'undefined') reject(new Error('XHRTransport is not supported.'));
                        var xhr = new XMLHttpRequest();
                        xhr.open('POST', serverUrl, true);
                        xhr.onreadystatechange = function() {
                            if (xhr.readyState === _this.state.done) {
                                var responseText = xhr.responseText;
                                try {
                                    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                                    resolve(_this.buildResponse(JSON.parse(responseText)));
                                } catch (_a) {
                                    resolve(_this.buildResponse({
                                        code: xhr.status
                                    }));
                                }
                            }
                        };
                        xhr.setRequestHeader('Content-Type', 'application/json');
                        xhr.setRequestHeader('Accept', '*/*');
                        xhr.send(JSON.stringify(payload));
                    })
                ];
            });
        });
    };
    return XHRTransport;
}((0, _analyticsCore.BaseTransport));

},{"tslib":"C7UIb","@amplitude/analytics-core":"4c2pj","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3K1Oq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SendBeaconTransport", function() {
    return SendBeaconTransport;
});
var _tslib = require("tslib");
var _analyticsCore = require("@amplitude/analytics-core");
var SendBeaconTransport = /** @class */ function(_super) {
    (0, _tslib.__extends)(SendBeaconTransport, _super);
    function SendBeaconTransport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SendBeaconTransport.prototype.send = function(serverUrl, payload) {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _this = this;
            return (0, _tslib.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    new Promise(function(resolve, reject) {
                        var globalScope = (0, _analyticsCore.getGlobalScope)();
                        /* istanbul ignore if */ if (!(globalScope === null || globalScope === void 0 ? void 0 : globalScope.navigator.sendBeacon)) throw new Error('SendBeaconTransport is not supported');
                        try {
                            var data = JSON.stringify(payload);
                            var success = globalScope.navigator.sendBeacon(serverUrl, JSON.stringify(payload));
                            if (success) return resolve(_this.buildResponse({
                                code: 200,
                                events_ingested: payload.events.length,
                                payload_size_bytes: data.length,
                                server_upload_time: Date.now()
                            }));
                            return resolve(_this.buildResponse({
                                code: 500
                            }));
                        } catch (e) {
                            reject(e);
                        }
                    })
                ];
            });
        });
    };
    return SendBeaconTransport;
}((0, _analyticsCore.BaseTransport));

},{"tslib":"C7UIb","@amplitude/analytics-core":"4c2pj","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"m20GK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseLegacyCookies", function() {
    return parseLegacyCookies;
});
parcelHelpers.export(exports, "parseTime", function() {
    return parseTime;
});
parcelHelpers.export(exports, "decode", function() {
    return decode;
});
var _tslib = require("tslib");
var _analyticsCore = require("@amplitude/analytics-core");
var parseLegacyCookies = function parseLegacyCookies(apiKey, cookieStorage, deleteLegacyCookies) {
    if (deleteLegacyCookies === void 0) deleteLegacyCookies = true;
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var cookieName, cookies, _a, deviceId, userId, optOut, sessionId, lastEventTime, lastEventId;
        return (0, _tslib.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    cookieName = (0, _analyticsCore.getOldCookieName)(apiKey);
                    return [
                        4 /*yield*/ ,
                        cookieStorage.getRaw(cookieName)
                    ];
                case 1:
                    cookies = _b.sent();
                    if (!cookies) return [
                        2 /*return*/ ,
                        {
                            optOut: false
                        }
                    ];
                    if (!deleteLegacyCookies) return [
                        3 /*break*/ ,
                        3
                    ];
                    return [
                        4 /*yield*/ ,
                        cookieStorage.remove(cookieName)
                    ];
                case 2:
                    _b.sent();
                    _b.label = 3;
                case 3:
                    _a = (0, _tslib.__read)(cookies.split('.'), 6), deviceId = _a[0], userId = _a[1], optOut = _a[2], sessionId = _a[3], lastEventTime = _a[4], lastEventId = _a[5];
                    return [
                        2 /*return*/ ,
                        {
                            deviceId: deviceId,
                            userId: decode(userId),
                            sessionId: parseTime(sessionId),
                            lastEventId: parseTime(lastEventId),
                            lastEventTime: parseTime(lastEventTime),
                            optOut: Boolean(optOut)
                        }
                    ];
            }
        });
    });
};
var parseTime = function parseTime(num) {
    var integer = parseInt(num, 32);
    if (isNaN(integer)) return undefined;
    return integer;
};
var decode = function decode(value) {
    if (!atob || !escape || !value) return undefined;
    try {
        return decodeURIComponent(escape(atob(value)));
    } catch (_a) {
        return undefined;
    }
};

},{"tslib":"C7UIb","@amplitude/analytics-core":"4c2pj","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"la8xP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_EVENT_PREFIX", function() {
    return DEFAULT_EVENT_PREFIX;
});
parcelHelpers.export(exports, "DEFAULT_PAGE_VIEW_EVENT", function() {
    return DEFAULT_PAGE_VIEW_EVENT;
});
parcelHelpers.export(exports, "DEFAULT_FORM_START_EVENT", function() {
    return DEFAULT_FORM_START_EVENT;
});
parcelHelpers.export(exports, "DEFAULT_FORM_SUBMIT_EVENT", function() {
    return DEFAULT_FORM_SUBMIT_EVENT;
});
parcelHelpers.export(exports, "DEFAULT_FILE_DOWNLOAD_EVENT", function() {
    return DEFAULT_FILE_DOWNLOAD_EVENT;
});
parcelHelpers.export(exports, "DEFAULT_SESSION_START_EVENT", function() {
    return DEFAULT_SESSION_START_EVENT;
});
parcelHelpers.export(exports, "DEFAULT_SESSION_END_EVENT", function() {
    return DEFAULT_SESSION_END_EVENT;
});
parcelHelpers.export(exports, "FILE_EXTENSION", function() {
    return FILE_EXTENSION;
});
parcelHelpers.export(exports, "FILE_NAME", function() {
    return FILE_NAME;
});
parcelHelpers.export(exports, "LINK_ID", function() {
    return LINK_ID;
});
parcelHelpers.export(exports, "LINK_TEXT", function() {
    return LINK_TEXT;
});
parcelHelpers.export(exports, "LINK_URL", function() {
    return LINK_URL;
});
parcelHelpers.export(exports, "FORM_ID", function() {
    return FORM_ID;
});
parcelHelpers.export(exports, "FORM_NAME", function() {
    return FORM_NAME;
});
parcelHelpers.export(exports, "FORM_DESTINATION", function() {
    return FORM_DESTINATION;
});
parcelHelpers.export(exports, "DEFAULT_IDENTITY_STORAGE", function() {
    return DEFAULT_IDENTITY_STORAGE;
});
parcelHelpers.export(exports, "DEFAULT_SERVER_ZONE", function() {
    return DEFAULT_SERVER_ZONE;
});
var DEFAULT_EVENT_PREFIX = '[Amplitude]';
var DEFAULT_PAGE_VIEW_EVENT = "".concat(DEFAULT_EVENT_PREFIX, " Page Viewed");
var DEFAULT_FORM_START_EVENT = "".concat(DEFAULT_EVENT_PREFIX, " Form Started");
var DEFAULT_FORM_SUBMIT_EVENT = "".concat(DEFAULT_EVENT_PREFIX, " Form Submitted");
var DEFAULT_FILE_DOWNLOAD_EVENT = "".concat(DEFAULT_EVENT_PREFIX, " File Downloaded");
var DEFAULT_SESSION_START_EVENT = 'session_start';
var DEFAULT_SESSION_END_EVENT = 'session_end';
var FILE_EXTENSION = "".concat(DEFAULT_EVENT_PREFIX, " File Extension");
var FILE_NAME = "".concat(DEFAULT_EVENT_PREFIX, " File Name");
var LINK_ID = "".concat(DEFAULT_EVENT_PREFIX, " Link ID");
var LINK_TEXT = "".concat(DEFAULT_EVENT_PREFIX, " Link Text");
var LINK_URL = "".concat(DEFAULT_EVENT_PREFIX, " Link URL");
var FORM_ID = "".concat(DEFAULT_EVENT_PREFIX, " Form ID");
var FORM_NAME = "".concat(DEFAULT_EVENT_PREFIX, " Form Name");
var FORM_DESTINATION = "".concat(DEFAULT_EVENT_PREFIX, " Form Destination");
var DEFAULT_IDENTITY_STORAGE = 'cookie';
var DEFAULT_SERVER_ZONE = 'US';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8wWFA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pageViewTrackingPlugin", function() {
    return 0, _pageViewTracking.pageViewTrackingPlugin;
});
parcelHelpers.export(exports, "plugin", function() {
    return 0, _pageViewTracking.pageViewTrackingPlugin;
});
var _pageViewTracking = require("./page-view-tracking");

},{"./page-view-tracking":"gBSZ3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gBSZ3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultPageViewEvent", function() {
    return defaultPageViewEvent;
});
parcelHelpers.export(exports, "pageViewTrackingPlugin", function() {
    return pageViewTrackingPlugin;
});
parcelHelpers.export(exports, "shouldTrackHistoryPageView", function() {
    return shouldTrackHistoryPageView;
});
var _tslib = require("tslib");
var _analyticsClientCommon = require("@amplitude/analytics-client-common");
var _analyticsTypes = require("@amplitude/analytics-types");
var _utils = require("./utils");
var defaultPageViewEvent = '[Amplitude] Page Viewed';
var pageViewTrackingPlugin = function pageViewTrackingPlugin(options) {
    if (options === void 0) options = {};
    var amplitude;
    var globalScope = (0, _analyticsClientCommon.getGlobalScope)();
    var loggerProvider = undefined;
    var pushState;
    var localConfig;
    var trackOn = options.trackOn, trackHistoryChanges = options.trackHistoryChanges, _a = options.eventType, eventType = _a === void 0 ? defaultPageViewEvent : _a;
    var getDecodeURI = function getDecodeURI(locationStr) {
        var decodedLocationStr = locationStr;
        try {
            decodedLocationStr = decodeURI(locationStr);
        } catch (e) {
            /* istanbul ignore next */ loggerProvider === null || loggerProvider === void 0 || loggerProvider.error('Malformed URI sequence: ', e);
        }
        return decodedLocationStr;
    };
    var createPageViewEvent = function createPageViewEvent() {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            var locationHREF, _a;
            var _b;
            return (0, _tslib.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        locationHREF = getDecodeURI(typeof location !== 'undefined' && location.href || '');
                        _b = {
                            event_type: eventType
                        };
                        _a = [
                            {}
                        ];
                        return [
                            4 /*yield*/ ,
                            getCampaignParams()
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            (_b.event_properties = (0, _tslib.__assign).apply(void 0, [
                                (0, _tslib.__assign).apply(void 0, _a.concat([
                                    _c.sent()
                                ])),
                                {
                                    '[Amplitude] Page Domain': /* istanbul ignore next */ typeof location !== 'undefined' && location.hostname || '',
                                    '[Amplitude] Page Location': locationHREF,
                                    '[Amplitude] Page Path': /* istanbul ignore next */ typeof location !== 'undefined' && getDecodeURI(location.pathname) || '',
                                    '[Amplitude] Page Title': /* istanbul ignore next */ typeof document !== 'undefined' && document.title || '',
                                    '[Amplitude] Page URL': locationHREF.split('?')[0]
                                }
                            ]), _b)
                        ];
                }
            });
        });
    };
    var shouldTrackOnPageLoad = function shouldTrackOnPageLoad() {
        return typeof trackOn === 'undefined' || typeof trackOn === 'function' && trackOn();
    };
    /* istanbul ignore next */ var previousURL = typeof location !== 'undefined' ? location.href : null;
    var trackHistoryPageView = function trackHistoryPageView() {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            var newURL, shouldTrackPageView, _a, _b, _c;
            return (0, _tslib.__generator)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        newURL = location.href;
                        shouldTrackPageView = shouldTrackHistoryPageView(trackHistoryChanges, newURL, previousURL || '') && shouldTrackOnPageLoad();
                        // Note: Update `previousURL` in the same clock tick as `shouldTrackHistoryPageView()`
                        // This was previously done after `amplitude?.track(await createPageViewEvent());` and
                        // causes a concurrency issue where app triggers `pushState` twice with the same URL target
                        // but `previousURL` is only updated after the second `pushState` producing two page viewed events
                        previousURL = newURL;
                        if (!shouldTrackPageView) return [
                            3 /*break*/ ,
                            4
                        ];
                        /* istanbul ignore next */ loggerProvider === null || loggerProvider === void 0 || loggerProvider.log('Tracking page view event');
                        if (!(amplitude === null || amplitude === void 0)) return [
                            3 /*break*/ ,
                            1
                        ];
                        _a = void 0;
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 1:
                        _c = (_b = amplitude).track;
                        return [
                            4 /*yield*/ ,
                            createPageViewEvent()
                        ];
                    case 2:
                        _a = _c.apply(_b, [
                            _d.sent()
                        ]);
                        _d.label = 3;
                    case 3:
                        _a;
                        _d.label = 4;
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /* istanbul ignore next */ var trackHistoryPageViewWrapper = function trackHistoryPageViewWrapper() {
        trackHistoryPageView();
    };
    var plugin = {
        name: '@amplitude/plugin-page-view-tracking-browser',
        type: 'enrichment',
        setup: function setup(config, client) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var _a, _b;
                return (0, _tslib.__generator)(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            amplitude = client;
                            localConfig = config;
                            loggerProvider = config.loggerProvider;
                            loggerProvider.log('Installing @amplitude/plugin-page-view-tracking-browser');
                            if (globalScope) {
                                globalScope.addEventListener('popstate', trackHistoryPageViewWrapper);
                                // Save reference to original push state, to be used in teardown
                                // eslint-disable-next-line @typescript-eslint/unbound-method
                                pushState = globalScope.history.pushState;
                                /* istanbul ignore next */ // There is no global browser listener for changes to history, so we have
                                // to modify pushState directly.
                                // https://stackoverflow.com/a/64927639
                                // eslint-disable-next-line @typescript-eslint/unbound-method
                                globalScope.history.pushState = new Proxy(globalScope.history.pushState, {
                                    apply: function apply(target, thisArg, _a) {
                                        var _b = (0, _tslib.__read)(_a, 3), state = _b[0], unused = _b[1], url = _b[2];
                                        target.apply(thisArg, [
                                            state,
                                            unused,
                                            url
                                        ]);
                                        trackHistoryPageView();
                                    }
                                });
                            }
                            if (!shouldTrackOnPageLoad()) return [
                                3 /*break*/ ,
                                2
                            ];
                            loggerProvider.log('Tracking page view event');
                            _b = (_a = amplitude).track;
                            return [
                                4 /*yield*/ ,
                                createPageViewEvent()
                            ];
                        case 1:
                            _b.apply(_a, [
                                _c.sent()
                            ]);
                            _c.label = 2;
                        case 2:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        },
        execute: function execute(event) {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                var pageViewEvent;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!(trackOn === 'attribution' && isCampaignEvent(event))) return [
                                3 /*break*/ ,
                                2
                            ];
                            /* istanbul ignore next */ // loggerProvider should be defined by the time execute is invoked
                            loggerProvider === null || loggerProvider === void 0 || loggerProvider.log('Enriching campaign event to page view event with campaign parameters');
                            return [
                                4 /*yield*/ ,
                                createPageViewEvent()
                            ];
                        case 1:
                            pageViewEvent = _a.sent();
                            event.event_type = pageViewEvent.event_type;
                            event.event_properties = (0, _tslib.__assign)((0, _tslib.__assign)({}, event.event_properties), pageViewEvent.event_properties);
                            _a.label = 2;
                        case 2:
                            // Update the pageCounter for the page view event
                            if (localConfig && event.event_type === eventType) {
                                localConfig.pageCounter = !localConfig.pageCounter ? 1 : localConfig.pageCounter + 1;
                                event.event_properties = (0, _tslib.__assign)((0, _tslib.__assign)({}, event.event_properties), {
                                    '[Amplitude] Page Counter': localConfig.pageCounter
                                });
                            }
                            return [
                                2 /*return*/ ,
                                event
                            ];
                    }
                });
            });
        },
        teardown: function teardown() {
            return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
                return (0, _tslib.__generator)(this, function(_a) {
                    if (globalScope) {
                        globalScope.removeEventListener('popstate', trackHistoryPageViewWrapper);
                        if (pushState) globalScope.history.pushState = pushState;
                    }
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        }
    };
    return plugin;
};
var getCampaignParams = function getCampaignParams() {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var _a;
        return (0, _tslib.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    _a = (0, _utils.omitUndefined);
                    return [
                        4 /*yield*/ ,
                        new (0, _analyticsClientCommon.CampaignParser)().parse()
                    ];
                case 1:
                    return [
                        2 /*return*/ ,
                        _a.apply(void 0, [
                            _b.sent()
                        ])
                    ];
            }
        });
    });
};
var isCampaignEvent = function isCampaignEvent(event) {
    if (event.event_type === '$identify' && event.user_properties) {
        var properties = event.user_properties;
        var $set = properties[(0, _analyticsTypes.IdentifyOperation).SET] || {};
        var $unset = properties[(0, _analyticsTypes.IdentifyOperation).UNSET] || {};
        var userProperties_1 = (0, _tslib.__spreadArray)((0, _tslib.__spreadArray)([], (0, _tslib.__read)(Object.keys($set)), false), (0, _tslib.__read)(Object.keys($unset)), false);
        return Object.keys((0, _analyticsClientCommon.BASE_CAMPAIGN)).every(function(value) {
            return userProperties_1.includes(value);
        });
    }
    return false;
};
var shouldTrackHistoryPageView = function shouldTrackHistoryPageView(trackingOption, newURLStr, oldURLStr) {
    switch(trackingOption){
        case 'pathOnly':
            if (oldURLStr == '') return true;
            var newURL = new URL(newURLStr);
            var oldURL = new URL(oldURLStr);
            var newBaseStr = newURL.origin + newURL.pathname;
            var oldBaseStr = oldURL.origin + oldURL.pathname;
            return newBaseStr !== oldBaseStr;
        default:
            return newURLStr !== oldURLStr;
    }
};

},{"tslib":"C7UIb","@amplitude/analytics-client-common":"kJc8f","@amplitude/analytics-types":"lQXD9","./utils":"94KwV","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"kJc8f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CampaignParser", function() {
    return 0, _campaignParser.CampaignParser;
});
parcelHelpers.export(exports, "CampaignTracker", function() {
    return 0, _campaignTracker.CampaignTracker;
});
parcelHelpers.export(exports, "isNewCampaign", function() {
    return 0, _helpers.isNewCampaign;
});
parcelHelpers.export(exports, "isExcludedReferrer", function() {
    return 0, _helpers.isExcludedReferrer;
});
parcelHelpers.export(exports, "createCampaignEvent", function() {
    return 0, _helpers.createCampaignEvent;
});
parcelHelpers.export(exports, "getDefaultExcludedReferrers", function() {
    return 0, _helpers.getDefaultExcludedReferrers;
});
parcelHelpers.export(exports, "WebAttribution", function() {
    return 0, _webAttribution.WebAttribution;
});
parcelHelpers.export(exports, "BASE_CAMPAIGN", function() {
    return 0, _constants.BASE_CAMPAIGN;
});
parcelHelpers.export(exports, "getQueryParams", function() {
    return 0, _queryParams.getQueryParams;
});
parcelHelpers.export(exports, "isNewSession", function() {
    return 0, _session.isNewSession;
});
parcelHelpers.export(exports, "getCookieName", function() {
    return 0, _cookieName.getCookieName;
});
parcelHelpers.export(exports, "getOldCookieName", function() {
    return 0, _cookieName.getOldCookieName;
});
parcelHelpers.export(exports, "getStorageKey", function() {
    return 0, _helpers1.getStorageKey;
});
parcelHelpers.export(exports, "CookieStorage", function() {
    return 0, _cookie.CookieStorage;
});
parcelHelpers.export(exports, "FetchTransport", function() {
    return 0, _fetch.FetchTransport;
});
parcelHelpers.export(exports, "getAnalyticsConnector", function() {
    return 0, _analyticsConnector.getAnalyticsConnector;
});
parcelHelpers.export(exports, "setConnectorDeviceId", function() {
    return 0, _analyticsConnector.setConnectorDeviceId;
});
parcelHelpers.export(exports, "setConnectorUserId", function() {
    return 0, _analyticsConnector.setConnectorUserId;
});
parcelHelpers.export(exports, "IdentityEventSender", function() {
    return 0, _identity.IdentityEventSender;
});
parcelHelpers.export(exports, "getLanguage", function() {
    return 0, _language.getLanguage;
});
parcelHelpers.export(exports, "getGlobalScope", function() {
    return 0, _globalScope.getGlobalScope;
});
parcelHelpers.export(exports, "getPageViewTrackingConfig", function() {
    return 0, _defaultTracking.getPageViewTrackingConfig;
});
parcelHelpers.export(exports, "getAttributionTrackingConfig", function() {
    return 0, _defaultTracking.getAttributionTrackingConfig;
});
parcelHelpers.export(exports, "getElementInteractionsConfig", function() {
    return 0, _defaultTracking.getElementInteractionsConfig;
});
parcelHelpers.export(exports, "isAttributionTrackingEnabled", function() {
    return 0, _defaultTracking.isAttributionTrackingEnabled;
});
parcelHelpers.export(exports, "isFileDownloadTrackingEnabled", function() {
    return 0, _defaultTracking.isFileDownloadTrackingEnabled;
});
parcelHelpers.export(exports, "isFormInteractionTrackingEnabled", function() {
    return 0, _defaultTracking.isFormInteractionTrackingEnabled;
});
parcelHelpers.export(exports, "isPageViewTrackingEnabled", function() {
    return 0, _defaultTracking.isPageViewTrackingEnabled;
});
parcelHelpers.export(exports, "isSessionTrackingEnabled", function() {
    return 0, _defaultTracking.isSessionTrackingEnabled;
});
parcelHelpers.export(exports, "isElementInteractionsEnabled", function() {
    return 0, _defaultTracking.isElementInteractionsEnabled;
});
var _campaignParser = require("./attribution/campaign-parser");
var _campaignTracker = require("./attribution/campaign-tracker");
var _helpers = require("./attribution/helpers");
var _webAttribution = require("./attribution/web-attribution");
var _constants = require("./attribution/constants");
var _queryParams = require("./query-params");
var _session = require("./session");
var _cookieName = require("./cookie-name");
var _helpers1 = require("./storage/helpers");
var _cookie = require("./storage/cookie");
var _fetch = require("./transports/fetch");
var _analyticsConnector = require("./analytics-connector");
var _identity = require("./plugins/identity");
var _language = require("./language");
var _globalScope = require("./global-scope");
var _defaultTracking = require("./default-tracking");

},{"./attribution/campaign-parser":"1pVVj","./attribution/campaign-tracker":false,"./attribution/helpers":false,"./attribution/web-attribution":false,"./attribution/constants":"aypvW","./query-params":false,"./session":false,"./cookie-name":false,"./storage/helpers":false,"./storage/cookie":false,"./transports/fetch":false,"./analytics-connector":false,"./plugins/identity":false,"./language":false,"./global-scope":"il1Fe","./default-tracking":false,"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1pVVj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CampaignParser", function() {
    return CampaignParser;
});
var _tslib = require("tslib");
var _queryParams = require("../query-params");
var _constants = require("./constants");
var CampaignParser = /** @class */ function() {
    function CampaignParser() {}
    CampaignParser.prototype.parse = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, (0, _constants.BASE_CAMPAIGN)), this.getUtmParam()), this.getReferrer()), this.getClickIds())
                ];
            });
        });
    };
    CampaignParser.prototype.getUtmParam = function() {
        var params = (0, _queryParams.getQueryParams)();
        var utmCampaign = params[0, _constants.UTM_CAMPAIGN];
        var utmContent = params[0, _constants.UTM_CONTENT];
        var utmId = params[0, _constants.UTM_ID];
        var utmMedium = params[0, _constants.UTM_MEDIUM];
        var utmSource = params[0, _constants.UTM_SOURCE];
        var utmTerm = params[0, _constants.UTM_TERM];
        return {
            utm_campaign: utmCampaign,
            utm_content: utmContent,
            utm_id: utmId,
            utm_medium: utmMedium,
            utm_source: utmSource,
            utm_term: utmTerm
        };
    };
    CampaignParser.prototype.getReferrer = function() {
        var _a, _b;
        var data = {
            referrer: undefined,
            referring_domain: undefined
        };
        try {
            data.referrer = document.referrer || undefined;
            data.referring_domain = (_b = (_a = data.referrer) === null || _a === void 0 ? void 0 : _a.split('/')[2]) !== null && _b !== void 0 ? _b : undefined;
        } catch (_c) {
        // nothing to track
        }
        return data;
    };
    CampaignParser.prototype.getClickIds = function() {
        var _a;
        var params = (0, _queryParams.getQueryParams)();
        return _a = {}, _a[0, _constants.DCLID] = params[0, _constants.DCLID], _a[0, _constants.FBCLID] = params[0, _constants.FBCLID], _a[0, _constants.GBRAID] = params[0, _constants.GBRAID], _a[0, _constants.GCLID] = params[0, _constants.GCLID], _a[0, _constants.KO_CLICK_ID] = params[0, _constants.KO_CLICK_ID], _a[0, _constants.LI_FAT_ID] = params[0, _constants.LI_FAT_ID], _a[0, _constants.MSCLKID] = params[0, _constants.MSCLKID], _a[0, _constants.RDT_CID] = params[0, _constants.RDT_CID], _a[0, _constants.TTCLID] = params[0, _constants.TTCLID], _a[0, _constants.TWCLID] = params[0, _constants.TWCLID], _a[0, _constants.WBRAID] = params[0, _constants.WBRAID], _a;
    };
    return CampaignParser;
}();

},{"tslib":"C7UIb","../query-params":"1wViq","./constants":"aypvW","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1wViq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getQueryParams", function() {
    return getQueryParams;
});
parcelHelpers.export(exports, "tryDecodeURIComponent", function() {
    return tryDecodeURIComponent;
});
var _globalScope = require("./global-scope");
var getQueryParams = function getQueryParams() {
    var _a;
    var globalScope = (0, _globalScope.getGlobalScope)();
    /* istanbul ignore if */ if (!((_a = globalScope === null || globalScope === void 0 ? void 0 : globalScope.location) === null || _a === void 0 ? void 0 : _a.search)) return {};
    var pairs = globalScope.location.search.substring(1).split('&').filter(Boolean);
    var params = pairs.reduce(function(acc, curr) {
        var query = curr.split('=', 2);
        var key = tryDecodeURIComponent(query[0]);
        var value = tryDecodeURIComponent(query[1]);
        if (!value) return acc;
        acc[key] = value;
        return acc;
    }, {});
    return params;
};
var tryDecodeURIComponent = function tryDecodeURIComponent(value) {
    if (value === void 0) value = '';
    try {
        return decodeURIComponent(value);
    } catch (_a) {
        return '';
    }
};

},{"./global-scope":"il1Fe","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"il1Fe":[function(require,module,exports,__globalThis) {
/* eslint-disable no-restricted-globals */ /* Only file allowed to access to globalThis, window, self */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getGlobalScope", function() {
    return getGlobalScope;
});
var global = arguments[3];
var getGlobalScope = function getGlobalScope() {
    // This should only be used for integrations with Amplitude that are not running in a browser environment
    //   We need to specify the name of the global variable as a string to prevent it from being minified
    var ampIntegrationContextName = 'ampIntegrationContext';
    if (typeof globalThis !== 'undefined' && typeof globalThis[ampIntegrationContextName] !== 'undefined') return globalThis[ampIntegrationContextName];
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof window !== 'undefined') return window;
    if (typeof self !== 'undefined') return self;
    if (typeof global !== 'undefined') return global;
    return undefined;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"aypvW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UTM_CAMPAIGN", function() {
    return UTM_CAMPAIGN;
});
parcelHelpers.export(exports, "UTM_CONTENT", function() {
    return UTM_CONTENT;
});
parcelHelpers.export(exports, "UTM_ID", function() {
    return UTM_ID;
});
parcelHelpers.export(exports, "UTM_MEDIUM", function() {
    return UTM_MEDIUM;
});
parcelHelpers.export(exports, "UTM_SOURCE", function() {
    return UTM_SOURCE;
});
parcelHelpers.export(exports, "UTM_TERM", function() {
    return UTM_TERM;
});
parcelHelpers.export(exports, "DCLID", function() {
    return DCLID;
});
parcelHelpers.export(exports, "FBCLID", function() {
    return FBCLID;
});
parcelHelpers.export(exports, "GBRAID", function() {
    return GBRAID;
});
parcelHelpers.export(exports, "GCLID", function() {
    return GCLID;
});
parcelHelpers.export(exports, "KO_CLICK_ID", function() {
    return KO_CLICK_ID;
});
parcelHelpers.export(exports, "LI_FAT_ID", function() {
    return LI_FAT_ID;
});
parcelHelpers.export(exports, "MSCLKID", function() {
    return MSCLKID;
});
parcelHelpers.export(exports, "RDT_CID", function() {
    return RDT_CID;
});
parcelHelpers.export(exports, "TTCLID", function() {
    return TTCLID;
});
parcelHelpers.export(exports, "TWCLID", function() {
    return TWCLID;
});
parcelHelpers.export(exports, "WBRAID", function() {
    return WBRAID;
});
parcelHelpers.export(exports, "EMPTY_VALUE", function() {
    return EMPTY_VALUE;
});
parcelHelpers.export(exports, "BASE_CAMPAIGN", function() {
    return BASE_CAMPAIGN;
});
parcelHelpers.export(exports, "MKTG", function() {
    return MKTG;
});
var UTM_CAMPAIGN = 'utm_campaign';
var UTM_CONTENT = 'utm_content';
var UTM_ID = 'utm_id';
var UTM_MEDIUM = 'utm_medium';
var UTM_SOURCE = 'utm_source';
var UTM_TERM = 'utm_term';
var DCLID = 'dclid';
var FBCLID = 'fbclid';
var GBRAID = 'gbraid';
var GCLID = 'gclid';
var KO_CLICK_ID = 'ko_click_id';
var LI_FAT_ID = 'li_fat_id';
var MSCLKID = 'msclkid';
var RDT_CID = 'rtd_cid';
var TTCLID = 'ttclid';
var TWCLID = 'twclid';
var WBRAID = 'wbraid';
var EMPTY_VALUE = 'EMPTY';
var BASE_CAMPAIGN = {
    utm_campaign: undefined,
    utm_content: undefined,
    utm_id: undefined,
    utm_medium: undefined,
    utm_source: undefined,
    utm_term: undefined,
    referrer: undefined,
    referring_domain: undefined,
    dclid: undefined,
    gbraid: undefined,
    gclid: undefined,
    fbclid: undefined,
    ko_click_id: undefined,
    li_fat_id: undefined,
    msclkid: undefined,
    rtd_cid: undefined,
    ttclid: undefined,
    twclid: undefined,
    wbraid: undefined
};
var MKTG = 'MKTG';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"lQXD9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SpecialEventType", function() {
    return 0, _event.SpecialEventType;
});
parcelHelpers.export(exports, "IdentifyOperation", function() {
    return 0, _event.IdentifyOperation;
});
parcelHelpers.export(exports, "RevenueProperty", function() {
    return 0, _event.RevenueProperty;
});
parcelHelpers.export(exports, "LogLevel", function() {
    return 0, _logger.LogLevel;
});
parcelHelpers.export(exports, "ServerZone", function() {
    return 0, _serverZone.ServerZone;
});
parcelHelpers.export(exports, "Status", function() {
    return 0, _status.Status;
});
parcelHelpers.export(exports, "OfflineDisabled", function() {
    return 0, _offline.OfflineDisabled;
});
parcelHelpers.export(exports, "DEFAULT_CSS_SELECTOR_ALLOWLIST", function() {
    return 0, _elementInteractions.DEFAULT_CSS_SELECTOR_ALLOWLIST;
});
parcelHelpers.export(exports, "DEFAULT_DATA_ATTRIBUTE_PREFIX", function() {
    return 0, _elementInteractions.DEFAULT_DATA_ATTRIBUTE_PREFIX;
});
parcelHelpers.export(exports, "DEFAULT_ACTION_CLICK_ALLOWLIST", function() {
    return 0, _elementInteractions.DEFAULT_ACTION_CLICK_ALLOWLIST;
});
var _event = require("./event");
var _logger = require("./logger");
var _serverZone = require("./server-zone");
var _status = require("./status");
var _offline = require("./offline");
var _elementInteractions = require("./element-interactions");

},{"./event":"e8KxT","./logger":"7JRoA","./server-zone":"jLJZf","./status":"7Q965","./offline":"3XuCV","./element-interactions":"jDq8s","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"e8KxT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IdentifyOperation", function() {
    return IdentifyOperation;
});
parcelHelpers.export(exports, "RevenueProperty", function() {
    return RevenueProperty;
});
parcelHelpers.export(exports, "SpecialEventType", function() {
    return SpecialEventType;
});
var IdentifyOperation;
(function(IdentifyOperation) {
    // Base Operations to set values
    IdentifyOperation["SET"] = "$set";
    IdentifyOperation["SET_ONCE"] = "$setOnce";
    // Operations around modifying existing values
    IdentifyOperation["ADD"] = "$add";
    IdentifyOperation["APPEND"] = "$append";
    IdentifyOperation["PREPEND"] = "$prepend";
    IdentifyOperation["REMOVE"] = "$remove";
    // Operations around appending values *if* they aren't present
    IdentifyOperation["PREINSERT"] = "$preInsert";
    IdentifyOperation["POSTINSERT"] = "$postInsert";
    // Operations around removing properties/values
    IdentifyOperation["UNSET"] = "$unset";
    IdentifyOperation["CLEAR_ALL"] = "$clearAll";
})(IdentifyOperation || (IdentifyOperation = {}));
var RevenueProperty;
(function(RevenueProperty) {
    RevenueProperty["REVENUE_PRODUCT_ID"] = "$productId";
    RevenueProperty["REVENUE_QUANTITY"] = "$quantity";
    RevenueProperty["REVENUE_PRICE"] = "$price";
    RevenueProperty["REVENUE_TYPE"] = "$revenueType";
    RevenueProperty["REVENUE_CURRENCY"] = "$currency";
    RevenueProperty["REVENUE"] = "$revenue";
})(RevenueProperty || (RevenueProperty = {}));
var SpecialEventType;
(function(SpecialEventType) {
    SpecialEventType["IDENTIFY"] = "$identify";
    SpecialEventType["GROUP_IDENTIFY"] = "$groupidentify";
    SpecialEventType["REVENUE"] = "revenue_amount";
})(SpecialEventType || (SpecialEventType = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7JRoA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LogLevel", function() {
    return LogLevel;
});
var LogLevel;
(function(LogLevel) {
    LogLevel[LogLevel["None"] = 0] = "None";
    LogLevel[LogLevel["Error"] = 1] = "Error";
    LogLevel[LogLevel["Warn"] = 2] = "Warn";
    LogLevel[LogLevel["Verbose"] = 3] = "Verbose";
    LogLevel[LogLevel["Debug"] = 4] = "Debug";
})(LogLevel || (LogLevel = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jLJZf":[function(require,module,exports,__globalThis) {
/**
 * @deprecated use ServerZoneType instead
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ServerZone", function() {
    return ServerZone;
});
var ServerZone;
(function(ServerZone) {
    ServerZone["US"] = "US";
    ServerZone["EU"] = "EU";
})(ServerZone || (ServerZone = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7Q965":[function(require,module,exports,__globalThis) {
/** The status of an event. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Status", function() {
    return Status;
});
var Status;
(function(Status) {
    /** The status could not be determined. */ Status["Unknown"] = "unknown";
    /** The event was skipped due to configuration or callbacks. */ Status["Skipped"] = "skipped";
    /** The event was sent successfully. */ Status["Success"] = "success";
    /** A user or device in the payload is currently rate limited and should try again later. */ Status["RateLimit"] = "rate_limit";
    /** The sent payload was too large to be processed. */ Status["PayloadTooLarge"] = "payload_too_large";
    /** The event could not be processed. */ Status["Invalid"] = "invalid";
    /** A server-side error ocurred during submission. */ Status["Failed"] = "failed";
    /** a server or client side error occuring when a request takes too long and is cancelled */ Status["Timeout"] = "Timeout";
    /** NodeJS runtime environment error.. E.g. disconnected from network */ Status["SystemError"] = "SystemError";
})(Status || (Status = {}));

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3XuCV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OfflineDisabled", function() {
    return OfflineDisabled;
});
var OfflineDisabled = null;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jDq8s":[function(require,module,exports,__globalThis) {
/**
 * Default CSS selectors to define which elements on the page to track.
 * Extend this list to include additional elements to track. For example:
 * ```
 * autocapturePlugin({
 *    cssSelectorAllowlist: [...DEFAULT_CSS_SELECTOR_ALLOWLIST, ".my-class"],
 * })
 * ```
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_CSS_SELECTOR_ALLOWLIST", function() {
    return DEFAULT_CSS_SELECTOR_ALLOWLIST;
});
parcelHelpers.export(exports, "DEFAULT_DATA_ATTRIBUTE_PREFIX", function() {
    return DEFAULT_DATA_ATTRIBUTE_PREFIX;
});
parcelHelpers.export(exports, "DEFAULT_ACTION_CLICK_ALLOWLIST", function() {
    return DEFAULT_ACTION_CLICK_ALLOWLIST;
});
var DEFAULT_CSS_SELECTOR_ALLOWLIST = [
    'a',
    'button',
    'input',
    'select',
    'textarea',
    'label',
    'video',
    'audio',
    '[contenteditable="true" i]',
    '[data-amp-default-track]',
    '.amp-default-track'
];
var DEFAULT_DATA_ATTRIBUTE_PREFIX = 'data-amp-track-';
var DEFAULT_ACTION_CLICK_ALLOWLIST = [
    'div',
    'span',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6'
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"94KwV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "omitUndefined", function() {
    return omitUndefined;
});
var omitUndefined = function omitUndefined(input) {
    var obj = {};
    for(var key in input){
        var val = input[key];
        if (val) obj[key] = val;
    }
    return obj;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"36Fvd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formInteractionTracking", function() {
    return formInteractionTracking;
});
parcelHelpers.export(exports, "stringOrUndefined", function() {
    return stringOrUndefined;
});
parcelHelpers.export(exports, "extractFormAction", function() {
    return extractFormAction;
});
var _tslib = require("tslib");
var _constants = require("../constants");
var _analyticsCore = require("@amplitude/analytics-core");
var formInteractionTracking = function formInteractionTracking() {
    var observer;
    var eventListeners = [];
    var addEventListener = function addEventListener(element, type, handler) {
        element.addEventListener(type, handler);
        eventListeners.push({
            element: element,
            type: type,
            handler: handler
        });
    };
    var removeClickListeners = function removeClickListeners() {
        eventListeners.forEach(function(_a) {
            var element = _a.element, type = _a.type, handler = _a.handler;
            /* istanbul ignore next */ element === null || element === void 0 || element.removeEventListener(type, handler);
        });
        eventListeners = [];
    };
    var name = '@amplitude/plugin-form-interaction-tracking-browser';
    var type = 'enrichment';
    var setup = function setup(config, amplitude) {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            var initializeFormTracking, window_1;
            return (0, _tslib.__generator)(this, function(_a) {
                initializeFormTracking = function initializeFormTracking() {
                    /* istanbul ignore if */ if (!amplitude) {
                        // TODO: Add required minimum version of @amplitude/analytics-browser
                        config.loggerProvider.warn('Form interaction tracking requires a later version of @amplitude/analytics-browser. Form interaction events are not tracked.');
                        return;
                    }
                    /* istanbul ignore if */ if (typeof document === 'undefined') return;
                    var addFormInteractionListener = function addFormInteractionListener(form) {
                        var hasFormChanged = false;
                        addEventListener(form, 'change', function() {
                            var _a;
                            var formDestination = extractFormAction(form);
                            if (!hasFormChanged) amplitude.track((0, _constants.DEFAULT_FORM_START_EVENT), (_a = {}, _a[0, _constants.FORM_ID] = stringOrUndefined(form.id), _a[0, _constants.FORM_NAME] = stringOrUndefined(form.name), _a[0, _constants.FORM_DESTINATION] = formDestination, _a));
                            hasFormChanged = true;
                        });
                        addEventListener(form, 'submit', function() {
                            var _a, _b;
                            var formDestination = extractFormAction(form);
                            if (!hasFormChanged) amplitude.track((0, _constants.DEFAULT_FORM_START_EVENT), (_a = {}, _a[0, _constants.FORM_ID] = stringOrUndefined(form.id), _a[0, _constants.FORM_NAME] = stringOrUndefined(form.name), _a[0, _constants.FORM_DESTINATION] = formDestination, _a));
                            amplitude.track((0, _constants.DEFAULT_FORM_SUBMIT_EVENT), (_b = {}, _b[0, _constants.FORM_ID] = stringOrUndefined(form.id), _b[0, _constants.FORM_NAME] = stringOrUndefined(form.name), _b[0, _constants.FORM_DESTINATION] = formDestination, _b));
                            hasFormChanged = false;
                        });
                    };
                    // Adds listener to existing anchor tags
                    var forms = Array.from(document.getElementsByTagName('form'));
                    forms.forEach(addFormInteractionListener);
                    // Adds listener to anchor tags added after initial load
                    /* istanbul ignore else */ if (typeof MutationObserver !== 'undefined') {
                        observer = new MutationObserver(function(mutations) {
                            mutations.forEach(function(mutation) {
                                mutation.addedNodes.forEach(function(node) {
                                    if (node.nodeName === 'FORM') addFormInteractionListener(node);
                                    if ('querySelectorAll' in node && typeof node.querySelectorAll === 'function') Array.from(node.querySelectorAll('form')).map(addFormInteractionListener);
                                });
                            });
                        });
                        observer.observe(document.body, {
                            subtree: true,
                            childList: true
                        });
                    }
                };
                // If the document is already loaded, initialize immediately.
                if (document.readyState === 'complete') initializeFormTracking();
                else {
                    window_1 = (0, _analyticsCore.getGlobalScope)();
                    /* istanbul ignore else*/ if (window_1) window_1.addEventListener('load', initializeFormTracking);
                    else config.loggerProvider.debug('Form interaction tracking is not installed because global is undefined.');
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    var execute = function execute(event) {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    event
                ];
            });
        });
    };
    var teardown = function teardown() {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                observer === null || observer === void 0 || observer.disconnect();
                removeClickListeners();
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return {
        name: name,
        type: type,
        setup: setup,
        execute: execute,
        teardown: teardown
    };
};
var stringOrUndefined = function stringOrUndefined(name) {
    /* istanbul ignore if */ if (typeof name !== 'string') // We found instances where the value of `name` is an Element and not a string.
    // Elements may have circular references and would throw an error when passed to `JSON.stringify(...)`.
    // If a non-string value is seen, assume there is no value.
    return undefined;
    return name;
};
var extractFormAction = function extractFormAction(form) {
    var formDestination = form.getAttribute('action');
    try {
        // eslint-disable-next-line no-restricted-globals
        formDestination = new URL(encodeURI(formDestination !== null && formDestination !== void 0 ? formDestination : ''), window.location.href).href;
    } catch (_a) {
    //
    }
    return formDestination;
};

},{"tslib":"C7UIb","../constants":"la8xP","@amplitude/analytics-core":"4c2pj","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2zrYN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fileDownloadTracking", function() {
    return fileDownloadTracking;
});
var _tslib = require("tslib");
var _constants = require("../constants");
var _analyticsCore = require("@amplitude/analytics-core");
var fileDownloadTracking = function fileDownloadTracking() {
    var observer;
    var eventListeners = [];
    var addEventListener = function addEventListener(element, type, handler) {
        element.addEventListener(type, handler);
        eventListeners.push({
            element: element,
            type: type,
            handler: handler
        });
    };
    var removeClickListeners = function removeClickListeners() {
        eventListeners.forEach(function(_a) {
            var element = _a.element, type = _a.type, handler = _a.handler;
            /* istanbul ignore next */ element === null || element === void 0 || element.removeEventListener(type, handler);
        });
        eventListeners = [];
    };
    var name = '@amplitude/plugin-file-download-tracking-browser';
    var type = 'enrichment';
    var setup = function setup(config, amplitude) {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            var initializeFileDownloadTracking, window_1;
            return (0, _tslib.__generator)(this, function(_a) {
                initializeFileDownloadTracking = function initializeFileDownloadTracking() {
                    /* istanbul ignore if */ if (!amplitude) {
                        // TODO: Add required minimum version of @amplitude/analytics-browser
                        config.loggerProvider.warn('File download tracking requires a later version of @amplitude/analytics-browser. File download events are not tracked.');
                        return;
                    }
                    /* istanbul ignore if */ if (typeof document === 'undefined') return;
                    var addFileDownloadListener = function addFileDownloadListener(a) {
                        var url;
                        try {
                            // eslint-disable-next-line no-restricted-globals
                            url = new URL(a.href, window.location.href);
                        } catch (_a) {
                            /* istanbul ignore next */ return;
                        }
                        var result = ext.exec(url.href);
                        var fileExtension = result === null || result === void 0 ? void 0 : result[1];
                        if (fileExtension) addEventListener(a, 'click', function() {
                            var _a;
                            if (fileExtension) amplitude.track((0, _constants.DEFAULT_FILE_DOWNLOAD_EVENT), (_a = {}, _a[0, _constants.FILE_EXTENSION] = fileExtension, _a[0, _constants.FILE_NAME] = url.pathname, _a[0, _constants.LINK_ID] = a.id, _a[0, _constants.LINK_TEXT] = a.text, _a[0, _constants.LINK_URL] = a.href, _a));
                        });
                    };
                    var ext = /\.(pdf|xlsx?|docx?|txt|rtf|csv|exe|key|pp(s|t|tx)|7z|pkg|rar|gz|zip|avi|mov|mp4|mpe?g|wmv|midi?|mp3|wav|wma)(\?.+)?$/;
                    // Adds listener to existing anchor tags
                    var links = Array.from(document.getElementsByTagName('a'));
                    links.forEach(addFileDownloadListener);
                    // Adds listener to anchor tags added after initial load
                    /* istanbul ignore else */ if (typeof MutationObserver !== 'undefined') {
                        observer = new MutationObserver(function(mutations) {
                            mutations.forEach(function(mutation) {
                                mutation.addedNodes.forEach(function(node) {
                                    if (node.nodeName === 'A') addFileDownloadListener(node);
                                    if ('querySelectorAll' in node && typeof node.querySelectorAll === 'function') Array.from(node.querySelectorAll('a')).map(addFileDownloadListener);
                                });
                            });
                        });
                        observer.observe(document.body, {
                            subtree: true,
                            childList: true
                        });
                    }
                };
                // If the document is already loaded, initialize immediately.
                /* istanbul ignore else*/ if (document.readyState === 'complete') initializeFileDownloadTracking();
                else {
                    window_1 = (0, _analyticsCore.getGlobalScope)();
                    /* istanbul ignore else*/ if (window_1) window_1.addEventListener('load', initializeFileDownloadTracking);
                    else config.loggerProvider.debug('File download tracking is not installed because global is undefined.');
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    var execute = function execute(event) {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    event
                ];
            });
        });
    };
    var teardown = function teardown() {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                observer === null || observer === void 0 || observer.disconnect();
                removeClickListeners();
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return {
        name: name,
        type: type,
        setup: setup,
        execute: execute,
        teardown: teardown
    };
};

},{"tslib":"C7UIb","../constants":"la8xP","@amplitude/analytics-core":"4c2pj","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2yhjP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "detNotify", function() {
    return detNotify;
});
parcelHelpers.export(exports, "resetNotify", function() {
    return resetNotify;
});
var notified = false;
var detNotify = function detNotify(config) {
    if (notified || config.defaultTracking !== undefined) return;
    var message = "`options.defaultTracking` is set to undefined. This implicitly configures your Amplitude instance to track Page Views, Sessions, File Downloads, and Form Interactions. You can suppress this warning by explicitly setting a value to `options.defaultTracking`. The value must either be a boolean, to enable and disable all default events, or an object, for advanced configuration. For example:\n\namplitude.init(<YOUR_API_KEY>, {\n  defaultTracking: true,\n});\n\nVisit https://www.docs.developers.amplitude.com/data/sdks/browser-2/#tracking-default-events for more details.";
    config.loggerProvider.warn(message);
    notified = true;
};
var resetNotify = function resetNotify() {
    notified = false;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"b6BGo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "networkConnectivityCheckerPlugin", function() {
    return networkConnectivityCheckerPlugin;
});
var _tslib = require("tslib");
var _analyticsCore = require("@amplitude/analytics-core");
var networkConnectivityCheckerPlugin = function networkConnectivityCheckerPlugin() {
    var name = '@amplitude/plugin-network-checker-browser';
    var type = 'before';
    var globalScope = (0, _analyticsCore.getGlobalScope)();
    var eventListeners = [];
    var addNetworkListener = function addNetworkListener(type, handler) {
        if (globalScope) {
            globalScope.addEventListener(type, handler);
            eventListeners.push({
                type: type,
                handler: handler
            });
        }
    };
    var removeNetworkListeners = function removeNetworkListeners() {
        eventListeners.forEach(function(_a) {
            var type = _a.type, handler = _a.handler;
            if (globalScope) globalScope.removeEventListener(type, handler);
        });
        eventListeners = [];
    };
    var setup = function setup(config, amplitude) {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                if (typeof navigator === 'undefined') {
                    config.loggerProvider.debug('Network connectivity checker plugin is disabled because navigator is not available.');
                    config.offline = false;
                    return [
                        2 /*return*/ 
                    ];
                }
                config.offline = !navigator.onLine;
                addNetworkListener('online', function() {
                    config.loggerProvider.debug('Network connectivity changed to online.');
                    config.offline = false;
                    // Flush immediately will cause ERR_NETWORK_CHANGED
                    setTimeout(function() {
                        amplitude.flush();
                    }, config.flushIntervalMillis);
                });
                addNetworkListener('offline', function() {
                    config.loggerProvider.debug('Network connectivity changed to offline.');
                    config.offline = true;
                });
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    var teardown = function teardown() {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                removeNetworkListeners();
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return {
        name: name,
        type: type,
        setup: setup,
        teardown: teardown
    };
};

},{"tslib":"C7UIb","@amplitude/analytics-core":"4c2pj","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"cwo2J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BrowserJoinedConfigGenerator", function() {
    return BrowserJoinedConfigGenerator;
});
parcelHelpers.export(exports, "createBrowserJoinedConfigGenerator", function() {
    return createBrowserJoinedConfigGenerator;
});
var _tslib = require("tslib");
var _analyticsRemoteConfig = require("@amplitude/analytics-remote-config");
var _analyticsCore = require("@amplitude/analytics-core");
var BrowserJoinedConfigGenerator = /** @class */ function() {
    function BrowserJoinedConfigGenerator(localConfig) {
        this.config = localConfig;
        this.config.loggerProvider.debug('Local configuration before merging with remote config', JSON.stringify(this.config, null, 2));
    }
    BrowserJoinedConfigGenerator.prototype.initialize = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var _a;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = this;
                        return [
                            4 /*yield*/ ,
                            (0, _analyticsRemoteConfig.createRemoteConfigFetch)({
                                localConfig: this.config,
                                configKeys: [
                                    'analyticsSDK'
                                ]
                            })
                        ];
                    case 1:
                        _a.remoteConfigFetch = _b.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    BrowserJoinedConfigGenerator.prototype.generateJoinedConfig = function() {
        var _a, _b, _c;
        var _d;
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var remoteConfig, _e, e_1;
            return (0, _tslib.__generator)(this, function(_f) {
                switch(_f.label){
                    case 0:
                        _f.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        _e = this.remoteConfigFetch;
                        if (!_e) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.remoteConfigFetch.getRemoteConfig('analyticsSDK', 'browserSDK', this.config.sessionId)
                        ];
                    case 1:
                        _e = _f.sent();
                        _f.label = 2;
                    case 2:
                        remoteConfig = _e;
                        this.config.loggerProvider.debug('Remote configuration:', JSON.stringify(remoteConfig, null, 2));
                        // merge remoteConfig.autocapture and this.config.autocapture
                        // if a field is in remoteConfig.autocapture, use that value
                        // if a field is not in remoteConfig.autocapture, use the value from this.config.autocapture
                        if (remoteConfig && 'autocapture' in remoteConfig) {
                            if (typeof remoteConfig.autocapture === 'boolean') this.config.autocapture = remoteConfig.autocapture;
                            if (typeof remoteConfig.autocapture === 'object') {
                                if (this.config.autocapture === undefined) this.config.autocapture = remoteConfig.autocapture;
                                if (typeof this.config.autocapture === 'boolean') this.config.autocapture = (0, _tslib.__assign)({
                                    attribution: this.config.autocapture,
                                    fileDownloads: this.config.autocapture,
                                    formInteractions: this.config.autocapture,
                                    pageViews: this.config.autocapture,
                                    sessions: this.config.autocapture,
                                    elementInteractions: this.config.autocapture
                                }, remoteConfig.autocapture);
                                if (typeof this.config.autocapture === 'object') this.config.autocapture = (0, _tslib.__assign)((0, _tslib.__assign)({}, this.config.autocapture), remoteConfig.autocapture);
                            }
                            // Override default tracking options if autocapture is updated by remote config
                            this.config.defaultTracking = this.config.autocapture;
                        }
                        this.config.loggerProvider.debug('Joined configuration: ', JSON.stringify(this.config, null, 2));
                        (_a = (_d = this.config).requestMetadata) !== null && _a !== void 0 ? _a : _d.requestMetadata = new (0, _analyticsCore.RequestMetadata)();
                        if ((_b = this.remoteConfigFetch) === null || _b === void 0 ? void 0 : _b.metrics.fetchTimeAPISuccess) this.config.requestMetadata.recordHistogram('remote_config_fetch_time_API_success', this.remoteConfigFetch.metrics.fetchTimeAPISuccess);
                        if ((_c = this.remoteConfigFetch) === null || _c === void 0 ? void 0 : _c.metrics.fetchTimeAPIFail) this.config.requestMetadata.recordHistogram('remote_config_fetch_time_API_fail', this.remoteConfigFetch.metrics.fetchTimeAPIFail);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_1 = _f.sent();
                        this.config.loggerProvider.error('Failed to fetch remote configuration because of error: ', e_1);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ ,
                            this.config
                        ];
                }
            });
        });
    };
    return BrowserJoinedConfigGenerator;
}();
var createBrowserJoinedConfigGenerator = function createBrowserJoinedConfigGenerator(localConfig) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        var joinedConfigGenerator;
        return (0, _tslib.__generator)(this, function(_a) {
            switch(_a.label){
                case 0:
                    joinedConfigGenerator = new BrowserJoinedConfigGenerator(localConfig);
                    return [
                        4 /*yield*/ ,
                        joinedConfigGenerator.initialize()
                    ];
                case 1:
                    _a.sent();
                    return [
                        2 /*return*/ ,
                        joinedConfigGenerator
                    ];
            }
        });
    });
};

},{"tslib":"C7UIb","@amplitude/analytics-remote-config":"3rpRD","@amplitude/analytics-core":"4c2pj","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3rpRD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createRemoteConfigFetch", function() {
    return createRemoteConfigFetch;
});
var _remoteConfig = require("./remote-config");
var createRemoteConfigFetch = _remoteConfig.createRemoteConfigFetch;

},{"./remote-config":"czqy7","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"czqy7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "REMOTE_CONFIG_SERVER_URL", function() {
    return REMOTE_CONFIG_SERVER_URL;
});
parcelHelpers.export(exports, "REMOTE_CONFIG_SERVER_URL_STAGING", function() {
    return REMOTE_CONFIG_SERVER_URL_STAGING;
});
parcelHelpers.export(exports, "REMOTE_CONFIG_SERVER_URL_EU", function() {
    return REMOTE_CONFIG_SERVER_URL_EU;
});
parcelHelpers.export(exports, "RemoteConfigFetch", function() {
    return RemoteConfigFetch;
});
parcelHelpers.export(exports, "createRemoteConfigFetch", function() {
    return createRemoteConfigFetch;
});
var _tslib = require("tslib");
var _analyticsCore = require("@amplitude/analytics-core");
var _analyticsTypes = require("@amplitude/analytics-types");
var UNEXPECTED_NETWORK_ERROR_MESSAGE = 'Network error occurred, remote config fetch failed';
var SUCCESS_REMOTE_CONFIG = 'Remote config successfully fetched';
var MAX_RETRIES_EXCEEDED_MESSAGE = 'Remote config fetch rejected due to exceeded retry count';
var TIMEOUT_MESSAGE = 'Remote config fetch rejected due to timeout after 5 seconds';
var UNEXPECTED_ERROR_MESSAGE = 'Unexpected error occurred';
var REMOTE_CONFIG_SERVER_URL = 'https://sr-client-cfg.amplitude.com/config';
var REMOTE_CONFIG_SERVER_URL_STAGING = 'https://sr-client-cfg.stag2.amplitude.com/config';
var REMOTE_CONFIG_SERVER_URL_EU = 'https://sr-client-cfg.eu.amplitude.com/config';
var RemoteConfigFetch = /** @class */ function() {
    function RemoteConfigFetch(_a) {
        var localConfig = _a.localConfig, configKeys = _a.configKeys;
        var _this = this;
        this.retryTimeout = 1000;
        this.attempts = 0;
        this.sessionTargetingMatch = false;
        this.metrics = {};
        this.getRemoteConfig = function(configNamespace, key, sessionId) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var fetchStartTime, configAPIResponse, remoteConfig;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            fetchStartTime = Date.now();
                            return [
                                4 /*yield*/ ,
                                this.fetchWithTimeout(sessionId)
                            ];
                        case 1:
                            configAPIResponse = _a.sent();
                            if (configAPIResponse) {
                                remoteConfig = configAPIResponse.configs && configAPIResponse.configs[configNamespace];
                                if (remoteConfig) {
                                    this.metrics.fetchTimeAPISuccess = Date.now() - fetchStartTime;
                                    return [
                                        2 /*return*/ ,
                                        remoteConfig[key]
                                    ];
                                }
                            }
                            this.metrics.fetchTimeAPIFail = Date.now() - fetchStartTime;
                            return [
                                2 /*return*/ ,
                                undefined
                            ];
                    }
                });
            });
        };
        this.fetchWithTimeout = function(sessionId) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var controller, timeoutId, remoteConfig;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            controller = new AbortController();
                            timeoutId = setTimeout(function() {
                                return controller.abort();
                            }, 5000);
                            return [
                                4 /*yield*/ ,
                                this.fetchRemoteConfig(controller.signal, sessionId)
                            ];
                        case 1:
                            remoteConfig = _a.sent();
                            clearTimeout(timeoutId);
                            return [
                                2 /*return*/ ,
                                remoteConfig
                            ];
                    }
                });
            });
        };
        this.fetchRemoteConfig = function(signal, sessionId) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var urlParams, _$_a, _b, configKey, options, serverUrl, res, parsedStatus, e_1, knownError;
                var e_2, _c;
                var _d;
                return (0, _tslib.__generator)(this, function(_e) {
                    switch(_e.label){
                        case 0:
                            if (sessionId === this.lastFetchedSessionId && this.attempts >= this.localConfig.flushMaxRetries) return [
                                2 /*return*/ ,
                                this.completeRequest({
                                    err: MAX_RETRIES_EXCEEDED_MESSAGE
                                })
                            ];
                            else if (signal.aborted) return [
                                2 /*return*/ ,
                                this.completeRequest({
                                    err: TIMEOUT_MESSAGE
                                })
                            ];
                            else if (sessionId !== this.lastFetchedSessionId) {
                                this.lastFetchedSessionId = sessionId;
                                this.attempts = 0;
                            }
                            _e.label = 1;
                        case 1:
                            _e.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            urlParams = new URLSearchParams({
                                api_key: this.localConfig.apiKey
                            });
                            try {
                                for(_$_a = (0, _tslib.__values)(this.configKeys), _b = _$_a.next(); !_b.done; _b = _$_a.next()){
                                    configKey = _b.value;
                                    urlParams.append('config_keys', configKey);
                                }
                            } catch (e_2_1) {
                                e_2 = {
                                    error: e_2_1
                                };
                            } finally{
                                try {
                                    if (_b && !_b.done && (_c = _$_a.return)) _c.call(_$_a);
                                } finally{
                                    if (e_2) throw e_2.error;
                                }
                            }
                            if (sessionId) urlParams.set('session_id', String(sessionId));
                            options = {
                                headers: {
                                    Accept: '*/*'
                                },
                                method: 'GET'
                            };
                            serverUrl = "".concat(this.getServerUrl(), "?").concat(urlParams.toString());
                            this.attempts += 1;
                            return [
                                4 /*yield*/ ,
                                fetch(serverUrl, (0, _tslib.__assign)((0, _tslib.__assign)({}, options), {
                                    signal: signal
                                }))
                            ];
                        case 2:
                            res = _e.sent();
                            if (res === null) return [
                                2 /*return*/ ,
                                this.completeRequest({
                                    err: UNEXPECTED_ERROR_MESSAGE
                                })
                            ];
                            parsedStatus = new (0, _analyticsCore.BaseTransport)().buildStatus(res.status);
                            switch(parsedStatus){
                                case (0, _analyticsTypes.Status).Success:
                                    this.attempts = 0;
                                    return [
                                        2 /*return*/ ,
                                        this.parseAndStoreConfig(res)
                                    ];
                                case (0, _analyticsTypes.Status).Failed:
                                    return [
                                        2 /*return*/ ,
                                        this.retryFetch(signal, sessionId)
                                    ];
                                default:
                                    return [
                                        2 /*return*/ ,
                                        this.completeRequest({
                                            err: UNEXPECTED_NETWORK_ERROR_MESSAGE
                                        })
                                    ];
                            }
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case 3:
                            e_1 = _e.sent();
                            knownError = e_1;
                            if (signal.aborted) return [
                                2 /*return*/ ,
                                this.completeRequest({
                                    err: TIMEOUT_MESSAGE
                                })
                            ];
                            return [
                                2 /*return*/ ,
                                this.completeRequest({
                                    err: (_d = knownError.message) !== null && _d !== void 0 ? _d : UNEXPECTED_ERROR_MESSAGE
                                })
                            ];
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        this.retryFetch = function(signal, sessionId) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var _this = this;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                new Promise(function(resolve) {
                                    return setTimeout(resolve, _this.attempts * _this.retryTimeout);
                                })
                            ];
                        case 1:
                            _a.sent();
                            return [
                                2 /*return*/ ,
                                this.fetchRemoteConfig(signal, sessionId)
                            ];
                    }
                });
            });
        };
        this.parseAndStoreConfig = function(res) {
            return (0, _tslib.__awaiter)(_this, void 0, void 0, function() {
                var remoteConfig;
                return (0, _tslib.__generator)(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                res.json()
                            ];
                        case 1:
                            remoteConfig = _a.sent();
                            this.completeRequest({
                                success: SUCCESS_REMOTE_CONFIG
                            });
                            return [
                                2 /*return*/ ,
                                remoteConfig
                            ];
                    }
                });
            });
        };
        this.localConfig = localConfig;
        this.configKeys = configKeys;
    }
    RemoteConfigFetch.prototype.getServerUrl = function() {
        if (this.localConfig.serverZone === (0, _analyticsTypes.ServerZone).STAGING) return REMOTE_CONFIG_SERVER_URL_STAGING;
        if (this.localConfig.serverZone === (0, _analyticsTypes.ServerZone).EU) return REMOTE_CONFIG_SERVER_URL_EU;
        return REMOTE_CONFIG_SERVER_URL;
    };
    RemoteConfigFetch.prototype.completeRequest = function(_a) {
        var err = _a.err, success = _a.success;
        if (err) throw new Error(err);
        else if (success) this.localConfig.loggerProvider.log(success);
    };
    return RemoteConfigFetch;
}();
var createRemoteConfigFetch = function createRemoteConfigFetch(_a) {
    var localConfig = _a.localConfig, configKeys = _a.configKeys;
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
        return (0, _tslib.__generator)(this, function(_b) {
            return [
                2 /*return*/ ,
                new RemoteConfigFetch({
                    localConfig: localConfig,
                    configKeys: configKeys
                })
            ];
        });
    });
};

},{"tslib":"C7UIb","@amplitude/analytics-core":"4c2pj","@amplitude/analytics-types":"lQXD9","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"kHUNZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "plugin", function() {
    return 0, _autocapturePlugin.autocapturePlugin;
});
parcelHelpers.export(exports, "autocapturePlugin", function() {
    return 0, _autocapturePlugin.autocapturePlugin;
});
parcelHelpers.export(exports, "WindowMessenger", function() {
    return 0, _messenger.WindowMessenger;
});
var _autocapturePlugin = require("./autocapture-plugin");
var _messenger = require("./libs/messenger");

},{"./autocapture-plugin":"5tMUQ","./libs/messenger":false,"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5tMUQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ObservablesEnum", function() {
    return ObservablesEnum;
});
// Type predicate
parcelHelpers.export(exports, "isElementBasedEvent", function() {
    return isElementBasedEvent;
});
parcelHelpers.export(exports, "autocapturePlugin", function() {
    return autocapturePlugin;
});
var _tslib = require("tslib");
/* eslint-disable no-restricted-globals */ var _analyticsCore = require("@amplitude/analytics-core");
var _constants = require("./constants");
var _rxjs = require("rxjs");
var _helpers = require("./helpers");
var _messenger = require("./libs/messenger");
var _hierarchy = require("./hierarchy");
var _trackClick = require("./autocapture/track-click");
var _trackChange = require("./autocapture/track-change");
var _trackActionClick = require("./autocapture/track-action-click");
var ObservablesEnum;
(function(ObservablesEnum) {
    ObservablesEnum["ClickObservable"] = "clickObservable";
    ObservablesEnum["ChangeObservable"] = "changeObservable";
    // ErrorObservable = 'errorObservable',
    ObservablesEnum["NavigateObservable"] = "navigateObservable";
    ObservablesEnum["MutationObservable"] = "mutationObservable";
})(ObservablesEnum || (ObservablesEnum = {}));
function isElementBasedEvent(event) {
    return event.type === 'click' || event.type === 'change';
}
var autocapturePlugin = function autocapturePlugin(options) {
    var _a, _b, _c;
    if (options === void 0) options = {};
    var _d = options.dataAttributePrefix, dataAttributePrefix = _d === void 0 ? (0, _analyticsCore.DEFAULT_DATA_ATTRIBUTE_PREFIX) : _d, _e = options.visualTaggingOptions, visualTaggingOptions = _e === void 0 ? {
        enabled: true,
        messenger: new (0, _messenger.WindowMessenger)()
    } : _e;
    options.cssSelectorAllowlist = (_a = options.cssSelectorAllowlist) !== null && _a !== void 0 ? _a : (0, _analyticsCore.DEFAULT_CSS_SELECTOR_ALLOWLIST);
    options.actionClickAllowlist = (_b = options.actionClickAllowlist) !== null && _b !== void 0 ? _b : (0, _analyticsCore.DEFAULT_ACTION_CLICK_ALLOWLIST);
    options.debounceTime = (_c = options.debounceTime) !== null && _c !== void 0 ? _c : 0; // TODO: update this when rage clicks are added to 1000ms
    var name = _constants.PLUGIN_NAME;
    var type = 'enrichment';
    var subscriptions = [];
    // Create observables on events on the window
    var createObservables = function createObservables() {
        var _a;
        // Create Observables from direct user events
        var clickObservable = (0, _rxjs.fromEvent)(document, 'click', {
            capture: true
        }).pipe((0, _rxjs.map)(function(click) {
            return addAdditionalEventProperties(click, 'click');
        }), (0, _rxjs.share)());
        var changeObservable = (0, _rxjs.fromEvent)(document, 'change', {
            capture: true
        }).pipe((0, _rxjs.map)(function(change) {
            return addAdditionalEventProperties(change, 'change');
        }), (0, _rxjs.share)());
        // Create Observable from unhandled errors
        // const errorObservable = fromEvent<ErrorEvent>(window, 'error').pipe(
        //   map((error) => addAdditionalEventProperties(error, 'error')),
        // );
        // Create observable for URL changes
        var navigateObservable;
        /* istanbul ignore next */ if (window.navigation) navigateObservable = (0, _rxjs.fromEvent)(window.navigation, 'navigate').pipe((0, _rxjs.map)(function(navigate) {
            return addAdditionalEventProperties(navigate, 'navigate');
        }), (0, _rxjs.share)());
        // Track DOM Mutations
        var mutationObservable = new (0, _rxjs.Observable)(function(observer) {
            var mutationObserver = new MutationObserver(function(mutations) {
                observer.next(mutations);
            });
            mutationObserver.observe(document.body, {
                childList: true,
                attributes: true,
                characterData: true,
                subtree: true
            });
            return function() {
                return mutationObserver.disconnect();
            };
        }).pipe((0, _rxjs.map)(function(mutation) {
            return addAdditionalEventProperties(mutation, 'mutation');
        }), (0, _rxjs.share)());
        return _a = {}, _a[ObservablesEnum.ClickObservable] = clickObservable, _a[ObservablesEnum.ChangeObservable] = changeObservable, // [ObservablesEnum.ErrorObservable]: errorObservable,
        _a[ObservablesEnum.NavigateObservable] = navigateObservable, _a[ObservablesEnum.MutationObservable] = mutationObservable, _a;
    };
    // Returns the Amplitude event properties for the given element.
    var getEventProperties = function getEventProperties(actionType, element) {
        var _a;
        var _b, _c;
        /* istanbul ignore next */ var tag = (_c = (_b = element === null || element === void 0 ? void 0 : element.tagName) === null || _b === void 0 ? void 0 : _b.toLowerCase) === null || _c === void 0 ? void 0 : _c.call(_b);
        /* istanbul ignore next */ var rect = typeof element.getBoundingClientRect === 'function' ? element.getBoundingClientRect() : {
            left: null,
            top: null
        };
        var ariaLabel = element.getAttribute('aria-label');
        var attributes = (0, _helpers.getAttributesWithPrefix)(element, dataAttributePrefix);
        var nearestLabel = (0, _helpers.getNearestLabel)(element);
        /* istanbul ignore next */ var properties = (_a = {}, _a[_constants.AMPLITUDE_EVENT_PROP_ELEMENT_ID] = element.getAttribute('id') || '', _a[_constants.AMPLITUDE_EVENT_PROP_ELEMENT_CLASS] = element.getAttribute('class'), _a[_constants.AMPLITUDE_EVENT_PROP_ELEMENT_HIERARCHY] = (0, _hierarchy.getHierarchy)(element), _a[_constants.AMPLITUDE_EVENT_PROP_ELEMENT_TAG] = tag, _a[_constants.AMPLITUDE_EVENT_PROP_ELEMENT_TEXT] = (0, _helpers.getText)(element), _a[_constants.AMPLITUDE_EVENT_PROP_ELEMENT_POSITION_LEFT] = rect.left == null ? null : Math.round(rect.left), _a[_constants.AMPLITUDE_EVENT_PROP_ELEMENT_POSITION_TOP] = rect.top == null ? null : Math.round(rect.top), _a[_constants.AMPLITUDE_EVENT_PROP_ELEMENT_ARIA_LABEL] = ariaLabel, _a[_constants.AMPLITUDE_EVENT_PROP_ELEMENT_ATTRIBUTES] = attributes, _a[_constants.AMPLITUDE_EVENT_PROP_ELEMENT_PARENT_LABEL] = nearestLabel, _a[_constants.AMPLITUDE_EVENT_PROP_PAGE_URL] = window.location.href.split('?')[0], _a[_constants.AMPLITUDE_EVENT_PROP_PAGE_TITLE] = typeof document !== 'undefined' && document.title || '', _a[_constants.AMPLITUDE_EVENT_PROP_VIEWPORT_HEIGHT] = window.innerHeight, _a[_constants.AMPLITUDE_EVENT_PROP_VIEWPORT_WIDTH] = window.innerWidth, _a);
        if (tag === 'a' && actionType === 'click' && element instanceof HTMLAnchorElement) properties[_constants.AMPLITUDE_EVENT_PROP_ELEMENT_HREF] = element.href;
        return (0, _helpers.removeEmptyProperties)(properties);
    };
    var addAdditionalEventProperties = function addAdditionalEventProperties(event, type) {
        var baseEvent = {
            event: event,
            timestamp: Date.now(),
            type: type
        };
        if (isElementBasedEvent(baseEvent) && baseEvent.event.target !== null) {
            // Retrieve additional event properties from the target element
            var closestTrackedAncestor = (0, _helpers.getClosestElement)(baseEvent.event.target, options.cssSelectorAllowlist);
            if (closestTrackedAncestor) {
                baseEvent.closestTrackedAncestor = closestTrackedAncestor;
                baseEvent.targetElementProperties = getEventProperties(baseEvent.type, closestTrackedAncestor);
            }
            return baseEvent;
        }
        return baseEvent;
    };
    var setup = function setup(config, amplitude) {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            var shouldTrackEvent, shouldTrackActionClick, allObservables, clickTrackingSubscription, changeSubscription, actionClickSubscription, allowlist, actionClickAllowlist;
            var _a, _b;
            return (0, _tslib.__generator)(this, function(_c) {
                /* istanbul ignore if */ if (typeof document === 'undefined') return [
                    2 /*return*/ 
                ];
                shouldTrackEvent = (0, _helpers.createShouldTrackEvent)(options, options.cssSelectorAllowlist);
                shouldTrackActionClick = (0, _helpers.createShouldTrackEvent)(options, options.actionClickAllowlist);
                allObservables = createObservables();
                clickTrackingSubscription = (0, _trackClick.trackClicks)({
                    allObservables: allObservables,
                    options: options,
                    amplitude: amplitude,
                    shouldTrackEvent: shouldTrackEvent
                });
                subscriptions.push(clickTrackingSubscription);
                changeSubscription = (0, _trackChange.trackChange)({
                    allObservables: allObservables,
                    getEventProperties: getEventProperties,
                    amplitude: amplitude,
                    shouldTrackEvent: shouldTrackEvent
                });
                subscriptions.push(changeSubscription);
                actionClickSubscription = (0, _trackActionClick.trackActionClick)({
                    allObservables: allObservables,
                    options: options,
                    getEventProperties: getEventProperties,
                    amplitude: amplitude,
                    shouldTrackEvent: shouldTrackEvent,
                    shouldTrackActionClick: shouldTrackActionClick
                });
                subscriptions.push(actionClickSubscription);
                /* istanbul ignore next */ (_a = config === null || config === void 0 ? void 0 : config.loggerProvider) === null || _a === void 0 || _a.log("".concat(name, " has been successfully added."));
                // Setup visual tagging selector
                if (window.opener && visualTaggingOptions.enabled) {
                    allowlist = options.cssSelectorAllowlist;
                    actionClickAllowlist = options.actionClickAllowlist;
                    /* istanbul ignore next */ (_b = visualTaggingOptions.messenger) === null || _b === void 0 || _b.setup((0, _tslib.__assign)((0, _tslib.__assign)({
                        logger: config === null || config === void 0 ? void 0 : config.loggerProvider
                    }, (config === null || config === void 0 ? void 0 : config.serverZone) && {
                        endpoint: _constants.AMPLITUDE_ORIGINS_MAP[config.serverZone]
                    }), {
                        isElementSelectable: (0, _helpers.createShouldTrackEvent)(options, (0, _tslib.__spreadArray)((0, _tslib.__spreadArray)([], (0, _tslib.__read)(allowlist), false), (0, _tslib.__read)(actionClickAllowlist), false)),
                        cssSelectorAllowlist: allowlist,
                        actionClickAllowlist: actionClickAllowlist
                    }));
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    var execute = function execute(event) {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    event
                ];
            });
        });
    };
    var teardown = function teardown() {
        return (0, _tslib.__awaiter)(void 0, void 0, void 0, function() {
            var subscriptions_1, subscriptions_1_1, subscription;
            var e_1, _a;
            return (0, _tslib.__generator)(this, function(_b) {
                try {
                    for(subscriptions_1 = (0, _tslib.__values)(subscriptions), subscriptions_1_1 = subscriptions_1.next(); !subscriptions_1_1.done; subscriptions_1_1 = subscriptions_1.next()){
                        subscription = subscriptions_1_1.value;
                        subscription.unsubscribe();
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (subscriptions_1_1 && !subscriptions_1_1.done && (_a = subscriptions_1.return)) _a.call(subscriptions_1);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return {
        name: name,
        type: type,
        setup: setup,
        execute: execute,
        teardown: teardown
    };
};

},{"tslib":"C7UIb","@amplitude/analytics-core":"4c2pj","./constants":"c6uAd","rxjs":"cqW5P","./helpers":"8nGGo","./libs/messenger":"fd4ca","./hierarchy":"8PIWh","./autocapture/track-click":"2GtPL","./autocapture/track-change":"jFzYn","./autocapture/track-action-click":"9lOMB","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"c6uAd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PLUGIN_NAME", function() {
    return PLUGIN_NAME;
});
parcelHelpers.export(exports, "AMPLITUDE_ELEMENT_CLICKED_EVENT", function() {
    return AMPLITUDE_ELEMENT_CLICKED_EVENT;
});
parcelHelpers.export(exports, "AMPLITUDE_ELEMENT_CHANGED_EVENT", function() {
    return AMPLITUDE_ELEMENT_CHANGED_EVENT;
});
parcelHelpers.export(exports, "AMPLITUDE_EVENT_PROP_ELEMENT_ID", function() {
    return AMPLITUDE_EVENT_PROP_ELEMENT_ID;
});
parcelHelpers.export(exports, "AMPLITUDE_EVENT_PROP_ELEMENT_CLASS", function() {
    return AMPLITUDE_EVENT_PROP_ELEMENT_CLASS;
});
parcelHelpers.export(exports, "AMPLITUDE_EVENT_PROP_ELEMENT_TAG", function() {
    return AMPLITUDE_EVENT_PROP_ELEMENT_TAG;
});
parcelHelpers.export(exports, "AMPLITUDE_EVENT_PROP_ELEMENT_TEXT", function() {
    return AMPLITUDE_EVENT_PROP_ELEMENT_TEXT;
});
parcelHelpers.export(exports, "AMPLITUDE_EVENT_PROP_ELEMENT_HIERARCHY", function() {
    return AMPLITUDE_EVENT_PROP_ELEMENT_HIERARCHY;
});
parcelHelpers.export(exports, "AMPLITUDE_EVENT_PROP_ELEMENT_HREF", function() {
    return AMPLITUDE_EVENT_PROP_ELEMENT_HREF;
});
parcelHelpers.export(exports, "AMPLITUDE_EVENT_PROP_ELEMENT_POSITION_LEFT", function() {
    return AMPLITUDE_EVENT_PROP_ELEMENT_POSITION_LEFT;
});
parcelHelpers.export(exports, "AMPLITUDE_EVENT_PROP_ELEMENT_POSITION_TOP", function() {
    return AMPLITUDE_EVENT_PROP_ELEMENT_POSITION_TOP;
});
parcelHelpers.export(exports, "AMPLITUDE_EVENT_PROP_ELEMENT_ARIA_LABEL", function() {
    return AMPLITUDE_EVENT_PROP_ELEMENT_ARIA_LABEL;
});
parcelHelpers.export(exports, "AMPLITUDE_EVENT_PROP_ELEMENT_ATTRIBUTES", function() {
    return AMPLITUDE_EVENT_PROP_ELEMENT_ATTRIBUTES;
});
parcelHelpers.export(exports, "AMPLITUDE_EVENT_PROP_ELEMENT_PARENT_LABEL", function() {
    return AMPLITUDE_EVENT_PROP_ELEMENT_PARENT_LABEL;
});
parcelHelpers.export(exports, "AMPLITUDE_EVENT_PROP_PAGE_URL", function() {
    return AMPLITUDE_EVENT_PROP_PAGE_URL;
});
parcelHelpers.export(exports, "AMPLITUDE_EVENT_PROP_PAGE_TITLE", function() {
    return AMPLITUDE_EVENT_PROP_PAGE_TITLE;
});
parcelHelpers.export(exports, "AMPLITUDE_EVENT_PROP_VIEWPORT_HEIGHT", function() {
    return AMPLITUDE_EVENT_PROP_VIEWPORT_HEIGHT;
});
parcelHelpers.export(exports, "AMPLITUDE_EVENT_PROP_VIEWPORT_WIDTH", function() {
    return AMPLITUDE_EVENT_PROP_VIEWPORT_WIDTH;
});
parcelHelpers.export(exports, "AMPLITUDE_ORIGIN", function() {
    return AMPLITUDE_ORIGIN;
});
parcelHelpers.export(exports, "AMPLITUDE_ORIGIN_EU", function() {
    return AMPLITUDE_ORIGIN_EU;
});
parcelHelpers.export(exports, "AMPLITUDE_ORIGIN_STAGING", function() {
    return AMPLITUDE_ORIGIN_STAGING;
});
parcelHelpers.export(exports, "AMPLITUDE_ORIGINS_MAP", function() {
    return AMPLITUDE_ORIGINS_MAP;
});
parcelHelpers.export(exports, "AMPLITUDE_VISUAL_TAGGING_SELECTOR_SCRIPT_URL", function() {
    return AMPLITUDE_VISUAL_TAGGING_SELECTOR_SCRIPT_URL;
});
parcelHelpers.export(exports, "AMPLITUDE_VISUAL_TAGGING_HIGHLIGHT_CLASS", function() {
    return AMPLITUDE_VISUAL_TAGGING_HIGHLIGHT_CLASS;
});
var PLUGIN_NAME = '@amplitude/plugin-autocapture-browser';
var AMPLITUDE_ELEMENT_CLICKED_EVENT = '[Amplitude] Element Clicked';
var AMPLITUDE_ELEMENT_CHANGED_EVENT = '[Amplitude] Element Changed';
var AMPLITUDE_EVENT_PROP_ELEMENT_ID = '[Amplitude] Element ID';
var AMPLITUDE_EVENT_PROP_ELEMENT_CLASS = '[Amplitude] Element Class';
var AMPLITUDE_EVENT_PROP_ELEMENT_TAG = '[Amplitude] Element Tag';
var AMPLITUDE_EVENT_PROP_ELEMENT_TEXT = '[Amplitude] Element Text';
var AMPLITUDE_EVENT_PROP_ELEMENT_HIERARCHY = '[Amplitude] Element Hierarchy';
var AMPLITUDE_EVENT_PROP_ELEMENT_HREF = '[Amplitude] Element Href';
var AMPLITUDE_EVENT_PROP_ELEMENT_POSITION_LEFT = '[Amplitude] Element Position Left';
var AMPLITUDE_EVENT_PROP_ELEMENT_POSITION_TOP = '[Amplitude] Element Position Top';
var AMPLITUDE_EVENT_PROP_ELEMENT_ARIA_LABEL = '[Amplitude] Element Aria Label';
var AMPLITUDE_EVENT_PROP_ELEMENT_ATTRIBUTES = '[Amplitude] Element Attributes';
var AMPLITUDE_EVENT_PROP_ELEMENT_PARENT_LABEL = '[Amplitude] Element Parent Label';
var AMPLITUDE_EVENT_PROP_PAGE_URL = '[Amplitude] Page URL';
var AMPLITUDE_EVENT_PROP_PAGE_TITLE = '[Amplitude] Page Title';
var AMPLITUDE_EVENT_PROP_VIEWPORT_HEIGHT = '[Amplitude] Viewport Height';
var AMPLITUDE_EVENT_PROP_VIEWPORT_WIDTH = '[Amplitude] Viewport Width';
var AMPLITUDE_ORIGIN = 'https://app.amplitude.com';
var AMPLITUDE_ORIGIN_EU = 'https://app.eu.amplitude.com';
var AMPLITUDE_ORIGIN_STAGING = 'https://apps.stag2.amplitude.com';
var AMPLITUDE_ORIGINS_MAP = {
    US: AMPLITUDE_ORIGIN,
    EU: AMPLITUDE_ORIGIN_EU,
    STAGING: AMPLITUDE_ORIGIN_STAGING
};
var AMPLITUDE_VISUAL_TAGGING_SELECTOR_SCRIPT_URL = 'https://cdn.amplitude.com/libs/visual-tagging-selector-1.0.0-alpha.js.gz';
var AMPLITUDE_VISUAL_TAGGING_HIGHLIGHT_CLASS = 'amp-visual-tagging-selector-highlight';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"cqW5P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Observable", function() {
    return 0, _observable.Observable;
});
parcelHelpers.export(exports, "ConnectableObservable", function() {
    return 0, _connectableObservable.ConnectableObservable;
});
parcelHelpers.export(exports, "observable", function() {
    return 0, _observable1.observable;
});
parcelHelpers.export(exports, "animationFrames", function() {
    return 0, _animationFrames.animationFrames;
});
parcelHelpers.export(exports, "Subject", function() {
    return 0, _subject.Subject;
});
parcelHelpers.export(exports, "BehaviorSubject", function() {
    return 0, _behaviorSubject.BehaviorSubject;
});
parcelHelpers.export(exports, "ReplaySubject", function() {
    return 0, _replaySubject.ReplaySubject;
});
parcelHelpers.export(exports, "AsyncSubject", function() {
    return 0, _asyncSubject.AsyncSubject;
});
parcelHelpers.export(exports, "asap", function() {
    return 0, _asap.asap;
});
parcelHelpers.export(exports, "asapScheduler", function() {
    return 0, _asap.asapScheduler;
});
parcelHelpers.export(exports, "async", function() {
    return 0, _async.async;
});
parcelHelpers.export(exports, "asyncScheduler", function() {
    return 0, _async.asyncScheduler;
});
parcelHelpers.export(exports, "queue", function() {
    return 0, _queue.queue;
});
parcelHelpers.export(exports, "queueScheduler", function() {
    return 0, _queue.queueScheduler;
});
parcelHelpers.export(exports, "animationFrame", function() {
    return 0, _animationFrame.animationFrame;
});
parcelHelpers.export(exports, "animationFrameScheduler", function() {
    return 0, _animationFrame.animationFrameScheduler;
});
parcelHelpers.export(exports, "VirtualTimeScheduler", function() {
    return 0, _virtualTimeScheduler.VirtualTimeScheduler;
});
parcelHelpers.export(exports, "VirtualAction", function() {
    return 0, _virtualTimeScheduler.VirtualAction;
});
parcelHelpers.export(exports, "Scheduler", function() {
    return 0, _scheduler.Scheduler;
});
parcelHelpers.export(exports, "Subscription", function() {
    return 0, _subscription.Subscription;
});
parcelHelpers.export(exports, "Subscriber", function() {
    return 0, _subscriber.Subscriber;
});
parcelHelpers.export(exports, "Notification", function() {
    return 0, _notification.Notification;
});
parcelHelpers.export(exports, "NotificationKind", function() {
    return 0, _notification.NotificationKind;
});
parcelHelpers.export(exports, "pipe", function() {
    return 0, _pipe.pipe;
});
parcelHelpers.export(exports, "noop", function() {
    return 0, _noop.noop;
});
parcelHelpers.export(exports, "identity", function() {
    return 0, _identity.identity;
});
parcelHelpers.export(exports, "isObservable", function() {
    return 0, _isObservable.isObservable;
});
parcelHelpers.export(exports, "lastValueFrom", function() {
    return 0, _lastValueFrom.lastValueFrom;
});
parcelHelpers.export(exports, "firstValueFrom", function() {
    return 0, _firstValueFrom.firstValueFrom;
});
parcelHelpers.export(exports, "ArgumentOutOfRangeError", function() {
    return 0, _argumentOutOfRangeError.ArgumentOutOfRangeError;
});
parcelHelpers.export(exports, "EmptyError", function() {
    return 0, _emptyError.EmptyError;
});
parcelHelpers.export(exports, "NotFoundError", function() {
    return 0, _notFoundError.NotFoundError;
});
parcelHelpers.export(exports, "ObjectUnsubscribedError", function() {
    return 0, _objectUnsubscribedError.ObjectUnsubscribedError;
});
parcelHelpers.export(exports, "SequenceError", function() {
    return 0, _sequenceError.SequenceError;
});
parcelHelpers.export(exports, "TimeoutError", function() {
    return 0, _timeout.TimeoutError;
});
parcelHelpers.export(exports, "UnsubscriptionError", function() {
    return 0, _unsubscriptionError.UnsubscriptionError;
});
parcelHelpers.export(exports, "bindCallback", function() {
    return 0, _bindCallback.bindCallback;
});
parcelHelpers.export(exports, "bindNodeCallback", function() {
    return 0, _bindNodeCallback.bindNodeCallback;
});
parcelHelpers.export(exports, "combineLatest", function() {
    return 0, _combineLatest.combineLatest;
});
parcelHelpers.export(exports, "concat", function() {
    return 0, _concat.concat;
});
parcelHelpers.export(exports, "connectable", function() {
    return 0, _connectable.connectable;
});
parcelHelpers.export(exports, "defer", function() {
    return 0, _defer.defer;
});
parcelHelpers.export(exports, "empty", function() {
    return 0, _empty.empty;
});
parcelHelpers.export(exports, "forkJoin", function() {
    return 0, _forkJoin.forkJoin;
});
parcelHelpers.export(exports, "from", function() {
    return 0, _from.from;
});
parcelHelpers.export(exports, "fromEvent", function() {
    return 0, _fromEvent.fromEvent;
});
parcelHelpers.export(exports, "fromEventPattern", function() {
    return 0, _fromEventPattern.fromEventPattern;
});
parcelHelpers.export(exports, "generate", function() {
    return 0, _generate.generate;
});
parcelHelpers.export(exports, "iif", function() {
    return 0, _iif.iif;
});
parcelHelpers.export(exports, "interval", function() {
    return 0, _interval.interval;
});
parcelHelpers.export(exports, "merge", function() {
    return 0, _merge.merge;
});
parcelHelpers.export(exports, "never", function() {
    return 0, _never.never;
});
parcelHelpers.export(exports, "of", function() {
    return 0, _of.of;
});
parcelHelpers.export(exports, "onErrorResumeNext", function() {
    return 0, _onErrorResumeNext.onErrorResumeNext;
});
parcelHelpers.export(exports, "pairs", function() {
    return 0, _pairs.pairs;
});
parcelHelpers.export(exports, "partition", function() {
    return 0, _partition.partition;
});
parcelHelpers.export(exports, "race", function() {
    return 0, _race.race;
});
parcelHelpers.export(exports, "range", function() {
    return 0, _range.range;
});
parcelHelpers.export(exports, "throwError", function() {
    return 0, _throwError.throwError;
});
parcelHelpers.export(exports, "timer", function() {
    return 0, _timer.timer;
});
parcelHelpers.export(exports, "using", function() {
    return 0, _using.using;
});
parcelHelpers.export(exports, "zip", function() {
    return 0, _zip.zip;
});
parcelHelpers.export(exports, "scheduled", function() {
    return 0, _scheduled.scheduled;
});
parcelHelpers.export(exports, "EMPTY", function() {
    return 0, _empty.EMPTY;
});
parcelHelpers.export(exports, "NEVER", function() {
    return 0, _never.NEVER;
});
parcelHelpers.export(exports, "config", function() {
    return 0, _config.config;
});
parcelHelpers.export(exports, "audit", function() {
    return 0, _audit.audit;
});
parcelHelpers.export(exports, "auditTime", function() {
    return 0, _auditTime.auditTime;
});
parcelHelpers.export(exports, "buffer", function() {
    return 0, _buffer.buffer;
});
parcelHelpers.export(exports, "bufferCount", function() {
    return 0, _bufferCount.bufferCount;
});
parcelHelpers.export(exports, "bufferTime", function() {
    return 0, _bufferTime.bufferTime;
});
parcelHelpers.export(exports, "bufferToggle", function() {
    return 0, _bufferToggle.bufferToggle;
});
parcelHelpers.export(exports, "bufferWhen", function() {
    return 0, _bufferWhen.bufferWhen;
});
parcelHelpers.export(exports, "catchError", function() {
    return 0, _catchError.catchError;
});
parcelHelpers.export(exports, "combineAll", function() {
    return 0, _combineAll.combineAll;
});
parcelHelpers.export(exports, "combineLatestAll", function() {
    return 0, _combineLatestAll.combineLatestAll;
});
parcelHelpers.export(exports, "combineLatestWith", function() {
    return 0, _combineLatestWith.combineLatestWith;
});
parcelHelpers.export(exports, "concatAll", function() {
    return 0, _concatAll.concatAll;
});
parcelHelpers.export(exports, "concatMap", function() {
    return 0, _concatMap.concatMap;
});
parcelHelpers.export(exports, "concatMapTo", function() {
    return 0, _concatMapTo.concatMapTo;
});
parcelHelpers.export(exports, "concatWith", function() {
    return 0, _concatWith.concatWith;
});
parcelHelpers.export(exports, "connect", function() {
    return 0, _connect.connect;
});
parcelHelpers.export(exports, "count", function() {
    return 0, _count.count;
});
parcelHelpers.export(exports, "debounce", function() {
    return 0, _debounce.debounce;
});
parcelHelpers.export(exports, "debounceTime", function() {
    return 0, _debounceTime.debounceTime;
});
parcelHelpers.export(exports, "defaultIfEmpty", function() {
    return 0, _defaultIfEmpty.defaultIfEmpty;
});
parcelHelpers.export(exports, "delay", function() {
    return 0, _delay.delay;
});
parcelHelpers.export(exports, "delayWhen", function() {
    return 0, _delayWhen.delayWhen;
});
parcelHelpers.export(exports, "dematerialize", function() {
    return 0, _dematerialize.dematerialize;
});
parcelHelpers.export(exports, "distinct", function() {
    return 0, _distinct.distinct;
});
parcelHelpers.export(exports, "distinctUntilChanged", function() {
    return 0, _distinctUntilChanged.distinctUntilChanged;
});
parcelHelpers.export(exports, "distinctUntilKeyChanged", function() {
    return 0, _distinctUntilKeyChanged.distinctUntilKeyChanged;
});
parcelHelpers.export(exports, "elementAt", function() {
    return 0, _elementAt.elementAt;
});
parcelHelpers.export(exports, "endWith", function() {
    return 0, _endWith.endWith;
});
parcelHelpers.export(exports, "every", function() {
    return 0, _every.every;
});
parcelHelpers.export(exports, "exhaust", function() {
    return 0, _exhaust.exhaust;
});
parcelHelpers.export(exports, "exhaustAll", function() {
    return 0, _exhaustAll.exhaustAll;
});
parcelHelpers.export(exports, "exhaustMap", function() {
    return 0, _exhaustMap.exhaustMap;
});
parcelHelpers.export(exports, "expand", function() {
    return 0, _expand.expand;
});
parcelHelpers.export(exports, "filter", function() {
    return 0, _filter.filter;
});
parcelHelpers.export(exports, "finalize", function() {
    return 0, _finalize.finalize;
});
parcelHelpers.export(exports, "find", function() {
    return 0, _find.find;
});
parcelHelpers.export(exports, "findIndex", function() {
    return 0, _findIndex.findIndex;
});
parcelHelpers.export(exports, "first", function() {
    return 0, _first.first;
});
parcelHelpers.export(exports, "groupBy", function() {
    return 0, _groupBy.groupBy;
});
parcelHelpers.export(exports, "ignoreElements", function() {
    return 0, _ignoreElements.ignoreElements;
});
parcelHelpers.export(exports, "isEmpty", function() {
    return 0, _isEmpty.isEmpty;
});
parcelHelpers.export(exports, "last", function() {
    return 0, _last.last;
});
parcelHelpers.export(exports, "map", function() {
    return 0, _map.map;
});
parcelHelpers.export(exports, "mapTo", function() {
    return 0, _mapTo.mapTo;
});
parcelHelpers.export(exports, "materialize", function() {
    return 0, _materialize.materialize;
});
parcelHelpers.export(exports, "max", function() {
    return 0, _max.max;
});
parcelHelpers.export(exports, "mergeAll", function() {
    return 0, _mergeAll.mergeAll;
});
parcelHelpers.export(exports, "flatMap", function() {
    return 0, _flatMap.flatMap;
});
parcelHelpers.export(exports, "mergeMap", function() {
    return 0, _mergeMap.mergeMap;
});
parcelHelpers.export(exports, "mergeMapTo", function() {
    return 0, _mergeMapTo.mergeMapTo;
});
parcelHelpers.export(exports, "mergeScan", function() {
    return 0, _mergeScan.mergeScan;
});
parcelHelpers.export(exports, "mergeWith", function() {
    return 0, _mergeWith.mergeWith;
});
parcelHelpers.export(exports, "min", function() {
    return 0, _min.min;
});
parcelHelpers.export(exports, "multicast", function() {
    return 0, _multicast.multicast;
});
parcelHelpers.export(exports, "observeOn", function() {
    return 0, _observeOn.observeOn;
});
parcelHelpers.export(exports, "onErrorResumeNextWith", function() {
    return 0, _onErrorResumeNextWith.onErrorResumeNextWith;
});
parcelHelpers.export(exports, "pairwise", function() {
    return 0, _pairwise.pairwise;
});
parcelHelpers.export(exports, "pluck", function() {
    return 0, _pluck.pluck;
});
parcelHelpers.export(exports, "publish", function() {
    return 0, _publish.publish;
});
parcelHelpers.export(exports, "publishBehavior", function() {
    return 0, _publishBehavior.publishBehavior;
});
parcelHelpers.export(exports, "publishLast", function() {
    return 0, _publishLast.publishLast;
});
parcelHelpers.export(exports, "publishReplay", function() {
    return 0, _publishReplay.publishReplay;
});
parcelHelpers.export(exports, "raceWith", function() {
    return 0, _raceWith.raceWith;
});
parcelHelpers.export(exports, "reduce", function() {
    return 0, _reduce.reduce;
});
parcelHelpers.export(exports, "repeat", function() {
    return 0, _repeat.repeat;
});
parcelHelpers.export(exports, "repeatWhen", function() {
    return 0, _repeatWhen.repeatWhen;
});
parcelHelpers.export(exports, "retry", function() {
    return 0, _retry.retry;
});
parcelHelpers.export(exports, "retryWhen", function() {
    return 0, _retryWhen.retryWhen;
});
parcelHelpers.export(exports, "refCount", function() {
    return 0, _refCount.refCount;
});
parcelHelpers.export(exports, "sample", function() {
    return 0, _sample.sample;
});
parcelHelpers.export(exports, "sampleTime", function() {
    return 0, _sampleTime.sampleTime;
});
parcelHelpers.export(exports, "scan", function() {
    return 0, _scan.scan;
});
parcelHelpers.export(exports, "sequenceEqual", function() {
    return 0, _sequenceEqual.sequenceEqual;
});
parcelHelpers.export(exports, "share", function() {
    return 0, _share.share;
});
parcelHelpers.export(exports, "shareReplay", function() {
    return 0, _shareReplay.shareReplay;
});
parcelHelpers.export(exports, "single", function() {
    return 0, _single.single;
});
parcelHelpers.export(exports, "skip", function() {
    return 0, _skip.skip;
});
parcelHelpers.export(exports, "skipLast", function() {
    return 0, _skipLast.skipLast;
});
parcelHelpers.export(exports, "skipUntil", function() {
    return 0, _skipUntil.skipUntil;
});
parcelHelpers.export(exports, "skipWhile", function() {
    return 0, _skipWhile.skipWhile;
});
parcelHelpers.export(exports, "startWith", function() {
    return 0, _startWith.startWith;
});
parcelHelpers.export(exports, "subscribeOn", function() {
    return 0, _subscribeOn.subscribeOn;
});
parcelHelpers.export(exports, "switchAll", function() {
    return 0, _switchAll.switchAll;
});
parcelHelpers.export(exports, "switchMap", function() {
    return 0, _switchMap.switchMap;
});
parcelHelpers.export(exports, "switchMapTo", function() {
    return 0, _switchMapTo.switchMapTo;
});
parcelHelpers.export(exports, "switchScan", function() {
    return 0, _switchScan.switchScan;
});
parcelHelpers.export(exports, "take", function() {
    return 0, _take.take;
});
parcelHelpers.export(exports, "takeLast", function() {
    return 0, _takeLast.takeLast;
});
parcelHelpers.export(exports, "takeUntil", function() {
    return 0, _takeUntil.takeUntil;
});
parcelHelpers.export(exports, "takeWhile", function() {
    return 0, _takeWhile.takeWhile;
});
parcelHelpers.export(exports, "tap", function() {
    return 0, _tap.tap;
});
parcelHelpers.export(exports, "throttle", function() {
    return 0, _throttle.throttle;
});
parcelHelpers.export(exports, "throttleTime", function() {
    return 0, _throttleTime.throttleTime;
});
parcelHelpers.export(exports, "throwIfEmpty", function() {
    return 0, _throwIfEmpty.throwIfEmpty;
});
parcelHelpers.export(exports, "timeInterval", function() {
    return 0, _timeInterval.timeInterval;
});
parcelHelpers.export(exports, "timeout", function() {
    return 0, _timeout.timeout;
});
parcelHelpers.export(exports, "timeoutWith", function() {
    return 0, _timeoutWith.timeoutWith;
});
parcelHelpers.export(exports, "timestamp", function() {
    return 0, _timestamp.timestamp;
});
parcelHelpers.export(exports, "toArray", function() {
    return 0, _toArray.toArray;
});
parcelHelpers.export(exports, "window", function() {
    return 0, _window.window;
});
parcelHelpers.export(exports, "windowCount", function() {
    return 0, _windowCount.windowCount;
});
parcelHelpers.export(exports, "windowTime", function() {
    return 0, _windowTime.windowTime;
});
parcelHelpers.export(exports, "windowToggle", function() {
    return 0, _windowToggle.windowToggle;
});
parcelHelpers.export(exports, "windowWhen", function() {
    return 0, _windowWhen.windowWhen;
});
parcelHelpers.export(exports, "withLatestFrom", function() {
    return 0, _withLatestFrom.withLatestFrom;
});
parcelHelpers.export(exports, "zipAll", function() {
    return 0, _zipAll.zipAll;
});
parcelHelpers.export(exports, "zipWith", function() {
    return 0, _zipWith.zipWith;
});
var _observable = require("./internal/Observable");
var _connectableObservable = require("./internal/observable/ConnectableObservable");
var _observable1 = require("./internal/symbol/observable");
var _animationFrames = require("./internal/observable/dom/animationFrames");
var _subject = require("./internal/Subject");
var _behaviorSubject = require("./internal/BehaviorSubject");
var _replaySubject = require("./internal/ReplaySubject");
var _asyncSubject = require("./internal/AsyncSubject");
var _asap = require("./internal/scheduler/asap");
var _async = require("./internal/scheduler/async");
var _queue = require("./internal/scheduler/queue");
var _animationFrame = require("./internal/scheduler/animationFrame");
var _virtualTimeScheduler = require("./internal/scheduler/VirtualTimeScheduler");
var _scheduler = require("./internal/Scheduler");
var _subscription = require("./internal/Subscription");
var _subscriber = require("./internal/Subscriber");
var _notification = require("./internal/Notification");
var _pipe = require("./internal/util/pipe");
var _noop = require("./internal/util/noop");
var _identity = require("./internal/util/identity");
var _isObservable = require("./internal/util/isObservable");
var _lastValueFrom = require("./internal/lastValueFrom");
var _firstValueFrom = require("./internal/firstValueFrom");
var _argumentOutOfRangeError = require("./internal/util/ArgumentOutOfRangeError");
var _emptyError = require("./internal/util/EmptyError");
var _notFoundError = require("./internal/util/NotFoundError");
var _objectUnsubscribedError = require("./internal/util/ObjectUnsubscribedError");
var _sequenceError = require("./internal/util/SequenceError");
var _timeout = require("./internal/operators/timeout");
var _unsubscriptionError = require("./internal/util/UnsubscriptionError");
var _bindCallback = require("./internal/observable/bindCallback");
var _bindNodeCallback = require("./internal/observable/bindNodeCallback");
var _combineLatest = require("./internal/observable/combineLatest");
var _concat = require("./internal/observable/concat");
var _connectable = require("./internal/observable/connectable");
var _defer = require("./internal/observable/defer");
var _empty = require("./internal/observable/empty");
var _forkJoin = require("./internal/observable/forkJoin");
var _from = require("./internal/observable/from");
var _fromEvent = require("./internal/observable/fromEvent");
var _fromEventPattern = require("./internal/observable/fromEventPattern");
var _generate = require("./internal/observable/generate");
var _iif = require("./internal/observable/iif");
var _interval = require("./internal/observable/interval");
var _merge = require("./internal/observable/merge");
var _never = require("./internal/observable/never");
var _of = require("./internal/observable/of");
var _onErrorResumeNext = require("./internal/observable/onErrorResumeNext");
var _pairs = require("./internal/observable/pairs");
var _partition = require("./internal/observable/partition");
var _race = require("./internal/observable/race");
var _range = require("./internal/observable/range");
var _throwError = require("./internal/observable/throwError");
var _timer = require("./internal/observable/timer");
var _using = require("./internal/observable/using");
var _zip = require("./internal/observable/zip");
var _scheduled = require("./internal/scheduled/scheduled");
var _types = require("./internal/types");
parcelHelpers.exportAll(_types, exports);
var _config = require("./internal/config");
var _audit = require("./internal/operators/audit");
var _auditTime = require("./internal/operators/auditTime");
var _buffer = require("./internal/operators/buffer");
var _bufferCount = require("./internal/operators/bufferCount");
var _bufferTime = require("./internal/operators/bufferTime");
var _bufferToggle = require("./internal/operators/bufferToggle");
var _bufferWhen = require("./internal/operators/bufferWhen");
var _catchError = require("./internal/operators/catchError");
var _combineAll = require("./internal/operators/combineAll");
var _combineLatestAll = require("./internal/operators/combineLatestAll");
var _combineLatestWith = require("./internal/operators/combineLatestWith");
var _concatAll = require("./internal/operators/concatAll");
var _concatMap = require("./internal/operators/concatMap");
var _concatMapTo = require("./internal/operators/concatMapTo");
var _concatWith = require("./internal/operators/concatWith");
var _connect = require("./internal/operators/connect");
var _count = require("./internal/operators/count");
var _debounce = require("./internal/operators/debounce");
var _debounceTime = require("./internal/operators/debounceTime");
var _defaultIfEmpty = require("./internal/operators/defaultIfEmpty");
var _delay = require("./internal/operators/delay");
var _delayWhen = require("./internal/operators/delayWhen");
var _dematerialize = require("./internal/operators/dematerialize");
var _distinct = require("./internal/operators/distinct");
var _distinctUntilChanged = require("./internal/operators/distinctUntilChanged");
var _distinctUntilKeyChanged = require("./internal/operators/distinctUntilKeyChanged");
var _elementAt = require("./internal/operators/elementAt");
var _endWith = require("./internal/operators/endWith");
var _every = require("./internal/operators/every");
var _exhaust = require("./internal/operators/exhaust");
var _exhaustAll = require("./internal/operators/exhaustAll");
var _exhaustMap = require("./internal/operators/exhaustMap");
var _expand = require("./internal/operators/expand");
var _filter = require("./internal/operators/filter");
var _finalize = require("./internal/operators/finalize");
var _find = require("./internal/operators/find");
var _findIndex = require("./internal/operators/findIndex");
var _first = require("./internal/operators/first");
var _groupBy = require("./internal/operators/groupBy");
var _ignoreElements = require("./internal/operators/ignoreElements");
var _isEmpty = require("./internal/operators/isEmpty");
var _last = require("./internal/operators/last");
var _map = require("./internal/operators/map");
var _mapTo = require("./internal/operators/mapTo");
var _materialize = require("./internal/operators/materialize");
var _max = require("./internal/operators/max");
var _mergeAll = require("./internal/operators/mergeAll");
var _flatMap = require("./internal/operators/flatMap");
var _mergeMap = require("./internal/operators/mergeMap");
var _mergeMapTo = require("./internal/operators/mergeMapTo");
var _mergeScan = require("./internal/operators/mergeScan");
var _mergeWith = require("./internal/operators/mergeWith");
var _min = require("./internal/operators/min");
var _multicast = require("./internal/operators/multicast");
var _observeOn = require("./internal/operators/observeOn");
var _onErrorResumeNextWith = require("./internal/operators/onErrorResumeNextWith");
var _pairwise = require("./internal/operators/pairwise");
var _pluck = require("./internal/operators/pluck");
var _publish = require("./internal/operators/publish");
var _publishBehavior = require("./internal/operators/publishBehavior");
var _publishLast = require("./internal/operators/publishLast");
var _publishReplay = require("./internal/operators/publishReplay");
var _raceWith = require("./internal/operators/raceWith");
var _reduce = require("./internal/operators/reduce");
var _repeat = require("./internal/operators/repeat");
var _repeatWhen = require("./internal/operators/repeatWhen");
var _retry = require("./internal/operators/retry");
var _retryWhen = require("./internal/operators/retryWhen");
var _refCount = require("./internal/operators/refCount");
var _sample = require("./internal/operators/sample");
var _sampleTime = require("./internal/operators/sampleTime");
var _scan = require("./internal/operators/scan");
var _sequenceEqual = require("./internal/operators/sequenceEqual");
var _share = require("./internal/operators/share");
var _shareReplay = require("./internal/operators/shareReplay");
var _single = require("./internal/operators/single");
var _skip = require("./internal/operators/skip");
var _skipLast = require("./internal/operators/skipLast");
var _skipUntil = require("./internal/operators/skipUntil");
var _skipWhile = require("./internal/operators/skipWhile");
var _startWith = require("./internal/operators/startWith");
var _subscribeOn = require("./internal/operators/subscribeOn");
var _switchAll = require("./internal/operators/switchAll");
var _switchMap = require("./internal/operators/switchMap");
var _switchMapTo = require("./internal/operators/switchMapTo");
var _switchScan = require("./internal/operators/switchScan");
var _take = require("./internal/operators/take");
var _takeLast = require("./internal/operators/takeLast");
var _takeUntil = require("./internal/operators/takeUntil");
var _takeWhile = require("./internal/operators/takeWhile");
var _tap = require("./internal/operators/tap");
var _throttle = require("./internal/operators/throttle");
var _throttleTime = require("./internal/operators/throttleTime");
var _throwIfEmpty = require("./internal/operators/throwIfEmpty");
var _timeInterval = require("./internal/operators/timeInterval");
var _timeoutWith = require("./internal/operators/timeoutWith");
var _timestamp = require("./internal/operators/timestamp");
var _toArray = require("./internal/operators/toArray");
var _window = require("./internal/operators/window");
var _windowCount = require("./internal/operators/windowCount");
var _windowTime = require("./internal/operators/windowTime");
var _windowToggle = require("./internal/operators/windowToggle");
var _windowWhen = require("./internal/operators/windowWhen");
var _withLatestFrom = require("./internal/operators/withLatestFrom");
var _zipAll = require("./internal/operators/zipAll");
var _zipWith = require("./internal/operators/zipWith");

},{"./internal/Observable":"lgLU4","./internal/observable/ConnectableObservable":false,"./internal/symbol/observable":false,"./internal/observable/dom/animationFrames":false,"./internal/Subject":false,"./internal/BehaviorSubject":false,"./internal/ReplaySubject":false,"./internal/AsyncSubject":false,"./internal/scheduler/asap":false,"./internal/scheduler/async":false,"./internal/scheduler/queue":false,"./internal/scheduler/animationFrame":false,"./internal/scheduler/VirtualTimeScheduler":false,"./internal/Scheduler":false,"./internal/Subscription":false,"./internal/Subscriber":false,"./internal/Notification":false,"./internal/util/pipe":false,"./internal/util/noop":false,"./internal/util/identity":false,"./internal/util/isObservable":false,"./internal/lastValueFrom":false,"./internal/firstValueFrom":false,"./internal/util/ArgumentOutOfRangeError":false,"./internal/util/EmptyError":false,"./internal/util/NotFoundError":false,"./internal/util/ObjectUnsubscribedError":false,"./internal/util/SequenceError":false,"./internal/operators/timeout":"igiqc","./internal/util/UnsubscriptionError":false,"./internal/observable/bindCallback":false,"./internal/observable/bindNodeCallback":false,"./internal/observable/combineLatest":false,"./internal/observable/concat":false,"./internal/observable/connectable":false,"./internal/observable/defer":false,"./internal/observable/empty":"4e9jT","./internal/observable/forkJoin":false,"./internal/observable/from":false,"./internal/observable/fromEvent":"klaUi","./internal/observable/fromEventPattern":false,"./internal/observable/generate":false,"./internal/observable/iif":false,"./internal/observable/interval":false,"./internal/observable/merge":"379yM","./internal/observable/never":false,"./internal/observable/of":false,"./internal/observable/onErrorResumeNext":false,"./internal/observable/pairs":false,"./internal/observable/partition":false,"./internal/observable/race":false,"./internal/observable/range":false,"./internal/observable/throwError":false,"./internal/observable/timer":false,"./internal/observable/using":false,"./internal/observable/zip":false,"./internal/scheduled/scheduled":false,"./internal/types":false,"./internal/config":false,"./internal/operators/audit":false,"./internal/operators/auditTime":false,"./internal/operators/buffer":"dixVg","./internal/operators/bufferCount":false,"./internal/operators/bufferTime":false,"./internal/operators/bufferToggle":false,"./internal/operators/bufferWhen":false,"./internal/operators/catchError":false,"./internal/operators/combineAll":false,"./internal/operators/combineLatestAll":false,"./internal/operators/combineLatestWith":false,"./internal/operators/concatAll":false,"./internal/operators/concatMap":false,"./internal/operators/concatMapTo":false,"./internal/operators/concatWith":false,"./internal/operators/connect":false,"./internal/operators/count":false,"./internal/operators/debounce":false,"./internal/operators/debounceTime":"6vFnF","./internal/operators/defaultIfEmpty":false,"./internal/operators/delay":"8CEK4","./internal/operators/delayWhen":false,"./internal/operators/dematerialize":false,"./internal/operators/distinct":false,"./internal/operators/distinctUntilChanged":false,"./internal/operators/distinctUntilKeyChanged":false,"./internal/operators/elementAt":false,"./internal/operators/endWith":false,"./internal/operators/every":false,"./internal/operators/exhaust":false,"./internal/operators/exhaustAll":false,"./internal/operators/exhaustMap":false,"./internal/operators/expand":false,"./internal/operators/filter":"9HGKT","./internal/operators/finalize":false,"./internal/operators/find":false,"./internal/operators/findIndex":false,"./internal/operators/first":false,"./internal/operators/groupBy":false,"./internal/operators/ignoreElements":false,"./internal/operators/isEmpty":false,"./internal/operators/last":false,"./internal/operators/map":"3BG2Y","./internal/operators/mapTo":false,"./internal/operators/materialize":false,"./internal/operators/max":false,"./internal/operators/mergeAll":false,"./internal/operators/flatMap":false,"./internal/operators/mergeMap":false,"./internal/operators/mergeMapTo":false,"./internal/operators/mergeScan":false,"./internal/operators/mergeWith":false,"./internal/operators/min":false,"./internal/operators/multicast":false,"./internal/operators/observeOn":false,"./internal/operators/onErrorResumeNextWith":false,"./internal/operators/pairwise":"fcHHb","./internal/operators/pluck":false,"./internal/operators/publish":false,"./internal/operators/publishBehavior":false,"./internal/operators/publishLast":false,"./internal/operators/publishReplay":false,"./internal/operators/raceWith":false,"./internal/operators/reduce":false,"./internal/operators/repeat":false,"./internal/operators/repeatWhen":false,"./internal/operators/retry":false,"./internal/operators/retryWhen":false,"./internal/operators/refCount":false,"./internal/operators/sample":false,"./internal/operators/sampleTime":false,"./internal/operators/scan":false,"./internal/operators/sequenceEqual":false,"./internal/operators/share":"lapCG","./internal/operators/shareReplay":false,"./internal/operators/single":false,"./internal/operators/skip":false,"./internal/operators/skipLast":false,"./internal/operators/skipUntil":false,"./internal/operators/skipWhile":false,"./internal/operators/startWith":false,"./internal/operators/subscribeOn":false,"./internal/operators/switchAll":false,"./internal/operators/switchMap":"jbzdM","./internal/operators/switchMapTo":false,"./internal/operators/switchScan":false,"./internal/operators/take":"4mjMK","./internal/operators/takeLast":false,"./internal/operators/takeUntil":false,"./internal/operators/takeWhile":false,"./internal/operators/tap":false,"./internal/operators/throttle":false,"./internal/operators/throttleTime":false,"./internal/operators/throwIfEmpty":false,"./internal/operators/timeInterval":false,"./internal/operators/timeoutWith":false,"./internal/operators/timestamp":false,"./internal/operators/toArray":false,"./internal/operators/window":false,"./internal/operators/windowCount":false,"./internal/operators/windowTime":false,"./internal/operators/windowToggle":false,"./internal/operators/windowWhen":false,"./internal/operators/withLatestFrom":false,"./internal/operators/zipAll":false,"./internal/operators/zipWith":false,"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"lgLU4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Observable", function() {
    return Observable;
});
var _subscriber = require("./Subscriber");
var _subscription = require("./Subscription");
var _observable = require("./symbol/observable");
var _pipe = require("./util/pipe");
var _config = require("./config");
var _isFunction = require("./util/isFunction");
var _errorContext = require("./util/errorContext");
var Observable = function() {
    function Observable(subscribe) {
        if (subscribe) this._subscribe = subscribe;
    }
    Observable.prototype.lift = function(operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    Observable.prototype.subscribe = function(observerOrNext, error, complete) {
        var _this = this;
        var subscriber = isSubscriber(observerOrNext) ? observerOrNext : new (0, _subscriber.SafeSubscriber)(observerOrNext, error, complete);
        (0, _errorContext.errorContext)(function() {
            var _a = _this, operator = _a.operator, source = _a.source;
            subscriber.add(operator ? operator.call(subscriber, source) : source ? _this._subscribe(subscriber) : _this._trySubscribe(subscriber));
        });
        return subscriber;
    };
    Observable.prototype._trySubscribe = function(sink) {
        try {
            return this._subscribe(sink);
        } catch (err) {
            sink.error(err);
        }
    };
    Observable.prototype.forEach = function(next, promiseCtor) {
        var _this = this;
        promiseCtor = getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var subscriber = new (0, _subscriber.SafeSubscriber)({
                next: function next1(value) {
                    try {
                        next(value);
                    } catch (err) {
                        reject(err);
                        subscriber.unsubscribe();
                    }
                },
                error: reject,
                complete: resolve
            });
            _this.subscribe(subscriber);
        });
    };
    Observable.prototype._subscribe = function(subscriber) {
        var _a;
        return (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber);
    };
    Observable.prototype[0, _observable.observable] = function() {
        return this;
    };
    Observable.prototype.pipe = function() {
        var operations = [];
        for(var _i = 0; _i < arguments.length; _i++)operations[_i] = arguments[_i];
        return (0, _pipe.pipeFromArray)(operations)(this);
    };
    Observable.prototype.toPromise = function(promiseCtor) {
        var _this = this;
        promiseCtor = getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var value;
            _this.subscribe(function(x) {
                return value = x;
            }, function(err) {
                return reject(err);
            }, function() {
                return resolve(value);
            });
        });
    };
    Observable.create = function(subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}();
function getPromiseCtor(promiseCtor) {
    var _a;
    return (_a = promiseCtor !== null && promiseCtor !== void 0 ? promiseCtor : (0, _config.config).Promise) !== null && _a !== void 0 ? _a : Promise;
}
function isObserver(value) {
    return value && (0, _isFunction.isFunction)(value.next) && (0, _isFunction.isFunction)(value.error) && (0, _isFunction.isFunction)(value.complete);
}
function isSubscriber(value) {
    return value && value instanceof (0, _subscriber.Subscriber) || isObserver(value) && (0, _subscription.isSubscription)(value);
}

},{"./Subscriber":"fQCkt","./Subscription":"e97vZ","./symbol/observable":"adphY","./util/pipe":"8bloc","./config":"bQchF","./util/isFunction":"7Ztzn","./util/errorContext":"iXGRe","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"fQCkt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Subscriber", function() {
    return Subscriber;
});
parcelHelpers.export(exports, "SafeSubscriber", function() {
    return SafeSubscriber;
});
parcelHelpers.export(exports, "EMPTY_OBSERVER", function() {
    return EMPTY_OBSERVER;
});
var _tslib = require("tslib");
var _isFunction = require("./util/isFunction");
var _subscription = require("./Subscription");
var _config = require("./config");
var _reportUnhandledError = require("./util/reportUnhandledError");
var _noop = require("./util/noop");
var _notificationFactories = require("./NotificationFactories");
var _timeoutProvider = require("./scheduler/timeoutProvider");
var _errorContext = require("./util/errorContext");
var Subscriber = function(_super) {
    (0, _tslib.__extends)(Subscriber, _super);
    function Subscriber(destination) {
        var _this = _super.call(this) || this;
        _this.isStopped = false;
        if (destination) {
            _this.destination = destination;
            if ((0, _subscription.isSubscription)(destination)) destination.add(_this);
        } else _this.destination = EMPTY_OBSERVER;
        return _this;
    }
    Subscriber.create = function(next, error, complete) {
        return new SafeSubscriber(next, error, complete);
    };
    Subscriber.prototype.next = function(value) {
        if (this.isStopped) handleStoppedNotification((0, _notificationFactories.nextNotification)(value), this);
        else this._next(value);
    };
    Subscriber.prototype.error = function(err) {
        if (this.isStopped) handleStoppedNotification((0, _notificationFactories.errorNotification)(err), this);
        else {
            this.isStopped = true;
            this._error(err);
        }
    };
    Subscriber.prototype.complete = function() {
        if (this.isStopped) handleStoppedNotification((0, _notificationFactories.COMPLETE_NOTIFICATION), this);
        else {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function() {
        if (!this.closed) {
            this.isStopped = true;
            _super.prototype.unsubscribe.call(this);
            this.destination = null;
        }
    };
    Subscriber.prototype._next = function(value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function(err) {
        try {
            this.destination.error(err);
        } finally{
            this.unsubscribe();
        }
    };
    Subscriber.prototype._complete = function() {
        try {
            this.destination.complete();
        } finally{
            this.unsubscribe();
        }
    };
    return Subscriber;
}((0, _subscription.Subscription));
var _bind = Function.prototype.bind;
function bind(fn, thisArg) {
    return _bind.call(fn, thisArg);
}
var ConsumerObserver = function() {
    function ConsumerObserver(partialObserver) {
        this.partialObserver = partialObserver;
    }
    ConsumerObserver.prototype.next = function(value) {
        var partialObserver = this.partialObserver;
        if (partialObserver.next) try {
            partialObserver.next(value);
        } catch (error) {
            handleUnhandledError(error);
        }
    };
    ConsumerObserver.prototype.error = function(err) {
        var partialObserver = this.partialObserver;
        if (partialObserver.error) try {
            partialObserver.error(err);
        } catch (error) {
            handleUnhandledError(error);
        }
        else handleUnhandledError(err);
    };
    ConsumerObserver.prototype.complete = function() {
        var partialObserver = this.partialObserver;
        if (partialObserver.complete) try {
            partialObserver.complete();
        } catch (error) {
            handleUnhandledError(error);
        }
    };
    return ConsumerObserver;
}();
var SafeSubscriber = function(_super) {
    (0, _tslib.__extends)(SafeSubscriber, _super);
    function SafeSubscriber(observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        var partialObserver;
        if ((0, _isFunction.isFunction)(observerOrNext) || !observerOrNext) partialObserver = {
            next: observerOrNext !== null && observerOrNext !== void 0 ? observerOrNext : undefined,
            error: error !== null && error !== void 0 ? error : undefined,
            complete: complete !== null && complete !== void 0 ? complete : undefined
        };
        else {
            var context_1;
            if (_this && (0, _config.config).useDeprecatedNextContext) {
                context_1 = Object.create(observerOrNext);
                context_1.unsubscribe = function() {
                    return _this.unsubscribe();
                };
                partialObserver = {
                    next: observerOrNext.next && bind(observerOrNext.next, context_1),
                    error: observerOrNext.error && bind(observerOrNext.error, context_1),
                    complete: observerOrNext.complete && bind(observerOrNext.complete, context_1)
                };
            } else partialObserver = observerOrNext;
        }
        _this.destination = new ConsumerObserver(partialObserver);
        return _this;
    }
    return SafeSubscriber;
}(Subscriber);
function handleUnhandledError(error) {
    if ((0, _config.config).useDeprecatedSynchronousErrorHandling) (0, _errorContext.captureError)(error);
    else (0, _reportUnhandledError.reportUnhandledError)(error);
}
function defaultErrorHandler(err) {
    throw err;
}
function handleStoppedNotification(notification, subscriber) {
    var onStoppedNotification = (0, _config.config).onStoppedNotification;
    onStoppedNotification && (0, _timeoutProvider.timeoutProvider).setTimeout(function() {
        return onStoppedNotification(notification, subscriber);
    });
}
var EMPTY_OBSERVER = {
    closed: true,
    next: (0, _noop.noop),
    error: defaultErrorHandler,
    complete: (0, _noop.noop)
};

},{"tslib":"C7UIb","./util/isFunction":"7Ztzn","./Subscription":"e97vZ","./config":"bQchF","./util/reportUnhandledError":"cEKjy","./util/noop":"eXHGP","./NotificationFactories":"ddtkR","./scheduler/timeoutProvider":"1vpns","./util/errorContext":"iXGRe","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7Ztzn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isFunction", function() {
    return isFunction;
});
function isFunction(value) {
    return typeof value === 'function';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"e97vZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Subscription", function() {
    return Subscription;
});
parcelHelpers.export(exports, "EMPTY_SUBSCRIPTION", function() {
    return EMPTY_SUBSCRIPTION;
});
parcelHelpers.export(exports, "isSubscription", function() {
    return isSubscription;
});
var _tslib = require("tslib");
var _isFunction = require("./util/isFunction");
var _unsubscriptionError = require("./util/UnsubscriptionError");
var _arrRemove = require("./util/arrRemove");
var Subscription = function() {
    function Subscription(initialTeardown) {
        this.initialTeardown = initialTeardown;
        this.closed = false;
        this._parentage = null;
        this._finalizers = null;
    }
    Subscription.prototype.unsubscribe = function() {
        var e_1, _a, e_2, _b;
        var errors;
        if (!this.closed) {
            this.closed = true;
            var _parentage = this._parentage;
            if (_parentage) {
                this._parentage = null;
                if (Array.isArray(_parentage)) try {
                    for(var _parentage_1 = (0, _tslib.__values)(_parentage), _parentage_1_1 = _parentage_1.next(); !_parentage_1_1.done; _parentage_1_1 = _parentage_1.next()){
                        var parent_1 = _parentage_1_1.value;
                        parent_1.remove(this);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_parentage_1_1 && !_parentage_1_1.done && (_a = _parentage_1.return)) _a.call(_parentage_1);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
                else _parentage.remove(this);
            }
            var initialFinalizer = this.initialTeardown;
            if ((0, _isFunction.isFunction)(initialFinalizer)) try {
                initialFinalizer();
            } catch (e) {
                errors = e instanceof (0, _unsubscriptionError.UnsubscriptionError) ? e.errors : [
                    e
                ];
            }
            var _finalizers = this._finalizers;
            if (_finalizers) {
                this._finalizers = null;
                try {
                    for(var _finalizers_1 = (0, _tslib.__values)(_finalizers), _finalizers_1_1 = _finalizers_1.next(); !_finalizers_1_1.done; _finalizers_1_1 = _finalizers_1.next()){
                        var finalizer = _finalizers_1_1.value;
                        try {
                            execFinalizer(finalizer);
                        } catch (err) {
                            errors = errors !== null && errors !== void 0 ? errors : [];
                            if (err instanceof (0, _unsubscriptionError.UnsubscriptionError)) errors = (0, _tslib.__spreadArray)((0, _tslib.__spreadArray)([], (0, _tslib.__read)(errors)), (0, _tslib.__read)(err.errors));
                            else errors.push(err);
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_finalizers_1_1 && !_finalizers_1_1.done && (_b = _finalizers_1.return)) _b.call(_finalizers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
            if (errors) throw new (0, _unsubscriptionError.UnsubscriptionError)(errors);
        }
    };
    Subscription.prototype.add = function(teardown) {
        var _a;
        if (teardown && teardown !== this) {
            if (this.closed) execFinalizer(teardown);
            else {
                if (teardown instanceof Subscription) {
                    if (teardown.closed || teardown._hasParent(this)) return;
                    teardown._addParent(this);
                }
                (this._finalizers = (_a = this._finalizers) !== null && _a !== void 0 ? _a : []).push(teardown);
            }
        }
    };
    Subscription.prototype._hasParent = function(parent) {
        var _parentage = this._parentage;
        return _parentage === parent || Array.isArray(_parentage) && _parentage.includes(parent);
    };
    Subscription.prototype._addParent = function(parent) {
        var _parentage = this._parentage;
        this._parentage = Array.isArray(_parentage) ? (_parentage.push(parent), _parentage) : _parentage ? [
            _parentage,
            parent
        ] : parent;
    };
    Subscription.prototype._removeParent = function(parent) {
        var _parentage = this._parentage;
        if (_parentage === parent) this._parentage = null;
        else if (Array.isArray(_parentage)) (0, _arrRemove.arrRemove)(_parentage, parent);
    };
    Subscription.prototype.remove = function(teardown) {
        var _finalizers = this._finalizers;
        _finalizers && (0, _arrRemove.arrRemove)(_finalizers, teardown);
        if (teardown instanceof Subscription) teardown._removeParent(this);
    };
    Subscription.EMPTY = function() {
        var empty = new Subscription();
        empty.closed = true;
        return empty;
    }();
    return Subscription;
}();
var EMPTY_SUBSCRIPTION = Subscription.EMPTY;
function isSubscription(value) {
    return value instanceof Subscription || value && 'closed' in value && (0, _isFunction.isFunction)(value.remove) && (0, _isFunction.isFunction)(value.add) && (0, _isFunction.isFunction)(value.unsubscribe);
}
function execFinalizer(finalizer) {
    if ((0, _isFunction.isFunction)(finalizer)) finalizer();
    else finalizer.unsubscribe();
}

},{"tslib":"C7UIb","./util/isFunction":"7Ztzn","./util/UnsubscriptionError":"dZBhZ","./util/arrRemove":"fO3fK","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"dZBhZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UnsubscriptionError", function() {
    return UnsubscriptionError;
});
var _createErrorClass = require("./createErrorClass");
var UnsubscriptionError = (0, _createErrorClass.createErrorClass)(function(_super) {
    return function UnsubscriptionErrorImpl(errors) {
        _super(this);
        this.message = errors ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function(err, i) {
            return i + 1 + ") " + err.toString();
        }).join('\n  ') : '';
        this.name = 'UnsubscriptionError';
        this.errors = errors;
    };
});

},{"./createErrorClass":"gNlVv","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gNlVv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createErrorClass", function() {
    return createErrorClass;
});
function createErrorClass(createImpl) {
    var _super = function _super(instance) {
        Error.call(instance);
        instance.stack = new Error().stack;
    };
    var ctorFunc = createImpl(_super);
    ctorFunc.prototype = Object.create(Error.prototype);
    ctorFunc.prototype.constructor = ctorFunc;
    return ctorFunc;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"fO3fK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "arrRemove", function() {
    return arrRemove;
});
function arrRemove(arr, item) {
    if (arr) {
        var index = arr.indexOf(item);
        0 <= index && arr.splice(index, 1);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"bQchF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "config", function() {
    return config;
});
var config = {
    onUnhandledError: null,
    onStoppedNotification: null,
    Promise: undefined,
    useDeprecatedSynchronousErrorHandling: false,
    useDeprecatedNextContext: false
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"cEKjy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "reportUnhandledError", function() {
    return reportUnhandledError;
});
var _config = require("../config");
var _timeoutProvider = require("../scheduler/timeoutProvider");
function reportUnhandledError(err) {
    (0, _timeoutProvider.timeoutProvider).setTimeout(function() {
        var onUnhandledError = (0, _config.config).onUnhandledError;
        if (onUnhandledError) onUnhandledError(err);
        else throw err;
    });
}

},{"../config":"bQchF","../scheduler/timeoutProvider":"1vpns","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1vpns":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeoutProvider", function() {
    return timeoutProvider;
});
var _tslib = require("tslib");
var timeoutProvider = {
    setTimeout: function setTimeout1(handler, timeout) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        var delegate = timeoutProvider.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setTimeout) return delegate.setTimeout.apply(delegate, (0, _tslib.__spreadArray)([
            handler,
            timeout
        ], (0, _tslib.__read)(args)));
        return setTimeout.apply(void 0, (0, _tslib.__spreadArray)([
            handler,
            timeout
        ], (0, _tslib.__read)(args)));
    },
    clearTimeout: function clearTimeout1(handle) {
        var delegate = timeoutProvider.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearTimeout) || clearTimeout)(handle);
    },
    delegate: undefined
};

},{"tslib":"C7UIb","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"eXHGP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "noop", function() {
    return noop;
});
function noop() {}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"ddtkR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "COMPLETE_NOTIFICATION", function() {
    return COMPLETE_NOTIFICATION;
});
parcelHelpers.export(exports, "errorNotification", function() {
    return errorNotification;
});
parcelHelpers.export(exports, "nextNotification", function() {
    return nextNotification;
});
parcelHelpers.export(exports, "createNotification", function() {
    return createNotification;
});
var COMPLETE_NOTIFICATION = function() {
    return createNotification('C', undefined, undefined);
}();
function errorNotification(error) {
    return createNotification('E', undefined, error);
}
function nextNotification(value) {
    return createNotification('N', value, undefined);
}
function createNotification(kind, value, error) {
    return {
        kind: kind,
        value: value,
        error: error
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"iXGRe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "errorContext", function() {
    return errorContext;
});
parcelHelpers.export(exports, "captureError", function() {
    return captureError;
});
var _config = require("../config");
var context = null;
function errorContext(cb) {
    if ((0, _config.config).useDeprecatedSynchronousErrorHandling) {
        var isRoot = !context;
        if (isRoot) context = {
            errorThrown: false,
            error: null
        };
        cb();
        if (isRoot) {
            var _a = context, errorThrown = _a.errorThrown, error = _a.error;
            context = null;
            if (errorThrown) throw error;
        }
    } else cb();
}
function captureError(err) {
    if ((0, _config.config).useDeprecatedSynchronousErrorHandling && context) {
        context.errorThrown = true;
        context.error = err;
    }
}

},{"../config":"bQchF","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"adphY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "observable", function() {
    return observable;
});
var observable = function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8bloc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pipe", function() {
    return pipe;
});
parcelHelpers.export(exports, "pipeFromArray", function() {
    return pipeFromArray;
});
var _identity = require("./identity");
function pipe() {
    var fns = [];
    for(var _i = 0; _i < arguments.length; _i++)fns[_i] = arguments[_i];
    return pipeFromArray(fns);
}
function pipeFromArray(fns) {
    if (fns.length === 0) return 0, _identity.identity;
    if (fns.length === 1) return fns[0];
    return function piped(input) {
        return fns.reduce(function(prev, fn) {
            return fn(prev);
        }, input);
    };
}

},{"./identity":"2cZmM","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2cZmM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "identity", function() {
    return identity;
});
function identity(x) {
    return x;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1HcMp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Subject", function() {
    return Subject;
});
parcelHelpers.export(exports, "AnonymousSubject", function() {
    return AnonymousSubject;
});
var _tslib = require("tslib");
var _observable = require("./Observable");
var _subscription = require("./Subscription");
var _objectUnsubscribedError = require("./util/ObjectUnsubscribedError");
var _arrRemove = require("./util/arrRemove");
var _errorContext = require("./util/errorContext");
var Subject = function(_super) {
    (0, _tslib.__extends)(Subject, _super);
    function Subject() {
        var _this = _super.call(this) || this;
        _this.closed = false;
        _this.currentObservers = null;
        _this.observers = [];
        _this.isStopped = false;
        _this.hasError = false;
        _this.thrownError = null;
        return _this;
    }
    Subject.prototype.lift = function(operator) {
        var subject = new AnonymousSubject(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype._throwIfClosed = function() {
        if (this.closed) throw new (0, _objectUnsubscribedError.ObjectUnsubscribedError)();
    };
    Subject.prototype.next = function(value) {
        var _this = this;
        (0, _errorContext.errorContext)(function() {
            var e_1, _a;
            _this._throwIfClosed();
            if (!_this.isStopped) {
                if (!_this.currentObservers) _this.currentObservers = Array.from(_this.observers);
                try {
                    for(var _b = (0, _tslib.__values)(_this.currentObservers), _c = _b.next(); !_c.done; _c = _b.next()){
                        var observer = _c.value;
                        observer.next(value);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
            }
        });
    };
    Subject.prototype.error = function(err) {
        var _this = this;
        (0, _errorContext.errorContext)(function() {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.hasError = _this.isStopped = true;
                _this.thrownError = err;
                var observers = _this.observers;
                while(observers.length)observers.shift().error(err);
            }
        });
    };
    Subject.prototype.complete = function() {
        var _this = this;
        (0, _errorContext.errorContext)(function() {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.isStopped = true;
                var observers = _this.observers;
                while(observers.length)observers.shift().complete();
            }
        });
    };
    Subject.prototype.unsubscribe = function() {
        this.isStopped = this.closed = true;
        this.observers = this.currentObservers = null;
    };
    Object.defineProperty(Subject.prototype, "observed", {
        get: function get() {
            var _a;
            return ((_a = this.observers) === null || _a === void 0 ? void 0 : _a.length) > 0;
        },
        enumerable: false,
        configurable: true
    });
    Subject.prototype._trySubscribe = function(subscriber) {
        this._throwIfClosed();
        return _super.prototype._trySubscribe.call(this, subscriber);
    };
    Subject.prototype._subscribe = function(subscriber) {
        this._throwIfClosed();
        this._checkFinalizedStatuses(subscriber);
        return this._innerSubscribe(subscriber);
    };
    Subject.prototype._innerSubscribe = function(subscriber) {
        var _this = this;
        var _a = this, hasError = _a.hasError, isStopped = _a.isStopped, observers = _a.observers;
        if (hasError || isStopped) return 0, _subscription.EMPTY_SUBSCRIPTION;
        this.currentObservers = null;
        observers.push(subscriber);
        return new (0, _subscription.Subscription)(function() {
            _this.currentObservers = null;
            (0, _arrRemove.arrRemove)(observers, subscriber);
        });
    };
    Subject.prototype._checkFinalizedStatuses = function(subscriber) {
        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, isStopped = _a.isStopped;
        if (hasError) subscriber.error(thrownError);
        else if (isStopped) subscriber.complete();
    };
    Subject.prototype.asObservable = function() {
        var observable = new (0, _observable.Observable)();
        observable.source = this;
        return observable;
    };
    Subject.create = function(destination, source) {
        return new AnonymousSubject(destination, source);
    };
    return Subject;
}((0, _observable.Observable));
var AnonymousSubject = function(_super) {
    (0, _tslib.__extends)(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        var _this = _super.call(this) || this;
        _this.destination = destination;
        _this.source = source;
        return _this;
    }
    AnonymousSubject.prototype.next = function(value) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.next) === null || _b === void 0 || _b.call(_a, value);
    };
    AnonymousSubject.prototype.error = function(err) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 || _b.call(_a, err);
    };
    AnonymousSubject.prototype.complete = function() {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.complete) === null || _b === void 0 || _b.call(_a);
    };
    AnonymousSubject.prototype._subscribe = function(subscriber) {
        var _a, _b;
        return (_b = (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber)) !== null && _b !== void 0 ? _b : (0, _subscription.EMPTY_SUBSCRIPTION);
    };
    return AnonymousSubject;
}(Subject);

},{"tslib":"C7UIb","./Observable":"lgLU4","./Subscription":"e97vZ","./util/ObjectUnsubscribedError":"28QWT","./util/arrRemove":"fO3fK","./util/errorContext":"iXGRe","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"28QWT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ObjectUnsubscribedError", function() {
    return ObjectUnsubscribedError;
});
var _createErrorClass = require("./createErrorClass");
var ObjectUnsubscribedError = (0, _createErrorClass.createErrorClass)(function(_super) {
    return function ObjectUnsubscribedErrorImpl() {
        _super(this);
        this.name = 'ObjectUnsubscribedError';
        this.message = 'object unsubscribed';
    };
});

},{"./createErrorClass":"gNlVv","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"24XQb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "asyncScheduler", function() {
    return asyncScheduler;
});
parcelHelpers.export(exports, "async", function() {
    return async;
});
var _asyncAction = require("./AsyncAction");
var _asyncScheduler = require("./AsyncScheduler");
var asyncScheduler = new (0, _asyncScheduler.AsyncScheduler)((0, _asyncAction.AsyncAction));
var async = asyncScheduler;

},{"./AsyncAction":"iDyLe","./AsyncScheduler":"3nhAP","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"iDyLe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AsyncAction", function() {
    return AsyncAction;
});
var _tslib = require("tslib");
var _action = require("./Action");
var _intervalProvider = require("./intervalProvider");
var _arrRemove = require("../util/arrRemove");
var AsyncAction = function(_super) {
    (0, _tslib.__extends)(AsyncAction, _super);
    function AsyncAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        _this.pending = false;
        return _this;
    }
    AsyncAction.prototype.schedule = function(state, delay) {
        var _a;
        if (delay === void 0) delay = 0;
        if (this.closed) return this;
        this.state = state;
        var id = this.id;
        var scheduler = this.scheduler;
        if (id != null) this.id = this.recycleAsyncId(scheduler, id, delay);
        this.pending = true;
        this.delay = delay;
        this.id = (_a = this.id) !== null && _a !== void 0 ? _a : this.requestAsyncId(scheduler, this.id, delay);
        return this;
    };
    AsyncAction.prototype.requestAsyncId = function(scheduler, _id, delay) {
        if (delay === void 0) delay = 0;
        return (0, _intervalProvider.intervalProvider).setInterval(scheduler.flush.bind(scheduler, this), delay);
    };
    AsyncAction.prototype.recycleAsyncId = function(_scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay != null && this.delay === delay && this.pending === false) return id;
        if (id != null) (0, _intervalProvider.intervalProvider).clearInterval(id);
        return undefined;
    };
    AsyncAction.prototype.execute = function(state, delay) {
        if (this.closed) return new Error('executing a cancelled action');
        this.pending = false;
        var error = this._execute(state, delay);
        if (error) return error;
        else if (this.pending === false && this.id != null) this.id = this.recycleAsyncId(this.scheduler, this.id, null);
    };
    AsyncAction.prototype._execute = function(state, _delay) {
        var errored = false;
        var errorValue;
        try {
            this.work(state);
        } catch (e) {
            errored = true;
            errorValue = e ? e : new Error('Scheduled action threw falsy error');
        }
        if (errored) {
            this.unsubscribe();
            return errorValue;
        }
    };
    AsyncAction.prototype.unsubscribe = function() {
        if (!this.closed) {
            var _a = this, id = _a.id, scheduler = _a.scheduler;
            var actions = scheduler.actions;
            this.work = this.state = this.scheduler = null;
            this.pending = false;
            (0, _arrRemove.arrRemove)(actions, this);
            if (id != null) this.id = this.recycleAsyncId(scheduler, id, null);
            this.delay = null;
            _super.prototype.unsubscribe.call(this);
        }
    };
    return AsyncAction;
}((0, _action.Action));

},{"tslib":"C7UIb","./Action":"hvU3y","./intervalProvider":"gervS","../util/arrRemove":"fO3fK","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"hvU3y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Action", function() {
    return Action;
});
var _tslib = require("tslib");
var _subscription = require("../Subscription");
var Action = function(_super) {
    (0, _tslib.__extends)(Action, _super);
    function Action(scheduler, work) {
        return _super.call(this) || this;
    }
    Action.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        return this;
    };
    return Action;
}((0, _subscription.Subscription));

},{"tslib":"C7UIb","../Subscription":"e97vZ","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gervS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "intervalProvider", function() {
    return intervalProvider;
});
var _tslib = require("tslib");
var intervalProvider = {
    setInterval: function setInterval1(handler, timeout) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        var delegate = intervalProvider.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setInterval) return delegate.setInterval.apply(delegate, (0, _tslib.__spreadArray)([
            handler,
            timeout
        ], (0, _tslib.__read)(args)));
        return setInterval.apply(void 0, (0, _tslib.__spreadArray)([
            handler,
            timeout
        ], (0, _tslib.__read)(args)));
    },
    clearInterval: function clearInterval1(handle) {
        var delegate = intervalProvider.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearInterval) || clearInterval)(handle);
    },
    delegate: undefined
};

},{"tslib":"C7UIb","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3nhAP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AsyncScheduler", function() {
    return AsyncScheduler;
});
var _tslib = require("tslib");
var _scheduler = require("../Scheduler");
var AsyncScheduler = function(_super) {
    (0, _tslib.__extends)(AsyncScheduler, _super);
    function AsyncScheduler(SchedulerAction, now) {
        if (now === void 0) now = (0, _scheduler.Scheduler).now;
        var _this = _super.call(this, SchedulerAction, now) || this;
        _this.actions = [];
        _this._active = false;
        return _this;
    }
    AsyncScheduler.prototype.flush = function(action) {
        var actions = this.actions;
        if (this._active) {
            actions.push(action);
            return;
        }
        var error;
        this._active = true;
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while (action = actions.shift());
        this._active = false;
        if (error) {
            while(action = actions.shift())action.unsubscribe();
            throw error;
        }
    };
    return AsyncScheduler;
}((0, _scheduler.Scheduler));

},{"tslib":"C7UIb","../Scheduler":"2uI3u","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2uI3u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Scheduler", function() {
    return Scheduler;
});
var _dateTimestampProvider = require("./scheduler/dateTimestampProvider");
var Scheduler = function() {
    function Scheduler(schedulerActionCtor, now) {
        if (now === void 0) now = Scheduler.now;
        this.schedulerActionCtor = schedulerActionCtor;
        this.now = now;
    }
    Scheduler.prototype.schedule = function(work, delay, state) {
        if (delay === void 0) delay = 0;
        return new this.schedulerActionCtor(this, work).schedule(state, delay);
    };
    Scheduler.now = (0, _dateTimestampProvider.dateTimestampProvider).now;
    return Scheduler;
}();

},{"./scheduler/dateTimestampProvider":"e2s6f","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"e2s6f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dateTimestampProvider", function() {
    return dateTimestampProvider;
});
var dateTimestampProvider = {
    now: function now() {
        return (dateTimestampProvider.delegate || Date).now();
    },
    delegate: undefined
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"igiqc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimeoutError", function() {
    return TimeoutError;
});
parcelHelpers.export(exports, "timeout", function() {
    return timeout;
});
var _async = require("../scheduler/async");
var _isDate = require("../util/isDate");
var _lift = require("../util/lift");
var _innerFrom = require("../observable/innerFrom");
var _createErrorClass = require("../util/createErrorClass");
var _operatorSubscriber = require("./OperatorSubscriber");
var _executeSchedule = require("../util/executeSchedule");
var TimeoutError = (0, _createErrorClass.createErrorClass)(function(_super) {
    return function TimeoutErrorImpl(info) {
        if (info === void 0) info = null;
        _super(this);
        this.message = 'Timeout has occurred';
        this.name = 'TimeoutError';
        this.info = info;
    };
});
function timeout(config, schedulerArg) {
    var _a = (0, _isDate.isValidDate)(config) ? {
        first: config
    } : typeof config === 'number' ? {
        each: config
    } : config, first = _a.first, each = _a.each, _b = _a.with, _with = _b === void 0 ? timeoutErrorFactory : _b, _c = _a.scheduler, scheduler = _c === void 0 ? schedulerArg !== null && schedulerArg !== void 0 ? schedulerArg : (0, _async.asyncScheduler) : _c, _d = _a.meta, meta = _d === void 0 ? null : _d;
    if (first == null && each == null) throw new TypeError('No timeout provided.');
    return (0, _lift.operate)(function(source, subscriber) {
        var originalSourceSubscription;
        var timerSubscription;
        var lastValue = null;
        var seen = 0;
        var startTimer = function startTimer(delay) {
            timerSubscription = (0, _executeSchedule.executeSchedule)(subscriber, scheduler, function() {
                try {
                    originalSourceSubscription.unsubscribe();
                    (0, _innerFrom.innerFrom)(_with({
                        meta: meta,
                        lastValue: lastValue,
                        seen: seen
                    })).subscribe(subscriber);
                } catch (err) {
                    subscriber.error(err);
                }
            }, delay);
        };
        originalSourceSubscription = source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            timerSubscription === null || timerSubscription === void 0 || timerSubscription.unsubscribe();
            seen++;
            subscriber.next(lastValue = value);
            each > 0 && startTimer(each);
        }, undefined, undefined, function() {
            if (!(timerSubscription === null || timerSubscription === void 0 ? void 0 : timerSubscription.closed)) timerSubscription === null || timerSubscription === void 0 || timerSubscription.unsubscribe();
            lastValue = null;
        }));
        !seen && startTimer(first != null ? typeof first === 'number' ? first : +first - scheduler.now() : each);
    });
}
function timeoutErrorFactory(info) {
    throw new TimeoutError(info);
}

},{"../scheduler/async":"24XQb","../util/isDate":"cK1Y0","../util/lift":"fFjpf","../observable/innerFrom":"1GoHu","../util/createErrorClass":"gNlVv","./OperatorSubscriber":"1bN4L","../util/executeSchedule":"2kRZ7","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"cK1Y0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isValidDate", function() {
    return isValidDate;
});
function isValidDate(value) {
    return value instanceof Date && !isNaN(value);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"fFjpf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasLift", function() {
    return hasLift;
});
parcelHelpers.export(exports, "operate", function() {
    return operate;
});
var _isFunction = require("./isFunction");
function hasLift(source) {
    return (0, _isFunction.isFunction)(source === null || source === void 0 ? void 0 : source.lift);
}
function operate(init) {
    return function(source) {
        if (hasLift(source)) return source.lift(function(liftedSource) {
            try {
                return init(liftedSource, this);
            } catch (err) {
                this.error(err);
            }
        });
        throw new TypeError('Unable to lift unknown Observable type');
    };
}

},{"./isFunction":"7Ztzn","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1GoHu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "innerFrom", function() {
    return innerFrom;
});
parcelHelpers.export(exports, "fromInteropObservable", function() {
    return fromInteropObservable;
});
parcelHelpers.export(exports, "fromArrayLike", function() {
    return fromArrayLike;
});
parcelHelpers.export(exports, "fromPromise", function() {
    return fromPromise;
});
parcelHelpers.export(exports, "fromIterable", function() {
    return fromIterable;
});
parcelHelpers.export(exports, "fromAsyncIterable", function() {
    return fromAsyncIterable;
});
parcelHelpers.export(exports, "fromReadableStreamLike", function() {
    return fromReadableStreamLike;
});
var _tslib = require("tslib");
var _isArrayLike = require("../util/isArrayLike");
var _isPromise = require("../util/isPromise");
var _observable = require("../Observable");
var _isInteropObservable = require("../util/isInteropObservable");
var _isAsyncIterable = require("../util/isAsyncIterable");
var _throwUnobservableError = require("../util/throwUnobservableError");
var _isIterable = require("../util/isIterable");
var _isReadableStreamLike = require("../util/isReadableStreamLike");
var _isFunction = require("../util/isFunction");
var _reportUnhandledError = require("../util/reportUnhandledError");
var _observable1 = require("../symbol/observable");
function innerFrom(input) {
    if (input instanceof (0, _observable.Observable)) return input;
    if (input != null) {
        if ((0, _isInteropObservable.isInteropObservable)(input)) return fromInteropObservable(input);
        if ((0, _isArrayLike.isArrayLike)(input)) return fromArrayLike(input);
        if ((0, _isPromise.isPromise)(input)) return fromPromise(input);
        if ((0, _isAsyncIterable.isAsyncIterable)(input)) return fromAsyncIterable(input);
        if ((0, _isIterable.isIterable)(input)) return fromIterable(input);
        if ((0, _isReadableStreamLike.isReadableStreamLike)(input)) return fromReadableStreamLike(input);
    }
    throw (0, _throwUnobservableError.createInvalidObservableTypeError)(input);
}
function fromInteropObservable(obj) {
    return new (0, _observable.Observable)(function(subscriber) {
        var obs = obj[0, _observable1.observable]();
        if ((0, _isFunction.isFunction)(obs.subscribe)) return obs.subscribe(subscriber);
        throw new TypeError('Provided object does not correctly implement Symbol.observable');
    });
}
function fromArrayLike(array) {
    return new (0, _observable.Observable)(function(subscriber) {
        for(var i = 0; i < array.length && !subscriber.closed; i++)subscriber.next(array[i]);
        subscriber.complete();
    });
}
function fromPromise(promise) {
    return new (0, _observable.Observable)(function(subscriber) {
        promise.then(function(value) {
            if (!subscriber.closed) {
                subscriber.next(value);
                subscriber.complete();
            }
        }, function(err) {
            return subscriber.error(err);
        }).then(null, (0, _reportUnhandledError.reportUnhandledError));
    });
}
function fromIterable(iterable) {
    return new (0, _observable.Observable)(function(subscriber) {
        var e_1, _a;
        try {
            for(var iterable_1 = (0, _tslib.__values)(iterable), iterable_1_1 = iterable_1.next(); !iterable_1_1.done; iterable_1_1 = iterable_1.next()){
                var value = iterable_1_1.value;
                subscriber.next(value);
                if (subscriber.closed) return;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (iterable_1_1 && !iterable_1_1.done && (_a = iterable_1.return)) _a.call(iterable_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        subscriber.complete();
    });
}
function fromAsyncIterable(asyncIterable) {
    return new (0, _observable.Observable)(function(subscriber) {
        process(asyncIterable, subscriber).catch(function(err) {
            return subscriber.error(err);
        });
    });
}
function fromReadableStreamLike(readableStream) {
    return fromAsyncIterable((0, _isReadableStreamLike.readableStreamLikeToAsyncGenerator)(readableStream));
}
function process(asyncIterable, subscriber) {
    var asyncIterable_1, asyncIterable_1_1;
    var e_2, _a;
    return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
        var value, e_2_1;
        return (0, _tslib.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    _b.trys.push([
                        0,
                        5,
                        6,
                        11
                    ]);
                    asyncIterable_1 = (0, _tslib.__asyncValues)(asyncIterable);
                    _b.label = 1;
                case 1:
                    return [
                        4,
                        asyncIterable_1.next()
                    ];
                case 2:
                    if (!(asyncIterable_1_1 = _b.sent(), !asyncIterable_1_1.done)) return [
                        3,
                        4
                    ];
                    value = asyncIterable_1_1.value;
                    subscriber.next(value);
                    if (subscriber.closed) return [
                        2
                    ];
                    _b.label = 3;
                case 3:
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        3,
                        11
                    ];
                case 5:
                    e_2_1 = _b.sent();
                    e_2 = {
                        error: e_2_1
                    };
                    return [
                        3,
                        11
                    ];
                case 6:
                    _b.trys.push([
                        6,
                        ,
                        9,
                        10
                    ]);
                    if (!(asyncIterable_1_1 && !asyncIterable_1_1.done && (_a = asyncIterable_1.return))) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        _a.call(asyncIterable_1)
                    ];
                case 7:
                    _b.sent();
                    _b.label = 8;
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    if (e_2) throw e_2.error;
                    return [
                        7
                    ];
                case 10:
                    return [
                        7
                    ];
                case 11:
                    subscriber.complete();
                    return [
                        2
                    ];
            }
        });
    });
}

},{"tslib":"C7UIb","../util/isArrayLike":"eFM80","../util/isPromise":"b7wgD","../Observable":"lgLU4","../util/isInteropObservable":"64QKY","../util/isAsyncIterable":"9MhxD","../util/throwUnobservableError":"jWRvy","../util/isIterable":"5YdZv","../util/isReadableStreamLike":"6bgze","../util/isFunction":"7Ztzn","../util/reportUnhandledError":"cEKjy","../symbol/observable":"adphY","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"eFM80":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isArrayLike", function() {
    return isArrayLike;
});
var isArrayLike = function isArrayLike(x) {
    return x && typeof x.length === 'number' && typeof x !== 'function';
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"b7wgD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isPromise", function() {
    return isPromise;
});
var _isFunction = require("./isFunction");
function isPromise(value) {
    return (0, _isFunction.isFunction)(value === null || value === void 0 ? void 0 : value.then);
}

},{"./isFunction":"7Ztzn","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"64QKY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isInteropObservable", function() {
    return isInteropObservable;
});
var _observable = require("../symbol/observable");
var _isFunction = require("./isFunction");
function isInteropObservable(input) {
    return (0, _isFunction.isFunction)(input[0, _observable.observable]);
}

},{"../symbol/observable":"adphY","./isFunction":"7Ztzn","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"9MhxD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isAsyncIterable", function() {
    return isAsyncIterable;
});
var _isFunction = require("./isFunction");
function isAsyncIterable(obj) {
    return Symbol.asyncIterator && (0, _isFunction.isFunction)(obj === null || obj === void 0 ? void 0 : obj[Symbol.asyncIterator]);
}

},{"./isFunction":"7Ztzn","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jWRvy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createInvalidObservableTypeError", function() {
    return createInvalidObservableTypeError;
});
function createInvalidObservableTypeError(input) {
    return new TypeError("You provided " + (input !== null && typeof input === 'object' ? 'an invalid object' : "'" + input + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5YdZv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isIterable", function() {
    return isIterable;
});
var _iterator = require("../symbol/iterator");
var _isFunction = require("./isFunction");
function isIterable(input) {
    return (0, _isFunction.isFunction)(input === null || input === void 0 ? void 0 : input[0, _iterator.iterator]);
}

},{"../symbol/iterator":"8miVP","./isFunction":"7Ztzn","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8miVP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSymbolIterator", function() {
    return getSymbolIterator;
});
parcelHelpers.export(exports, "iterator", function() {
    return iterator;
});
function getSymbolIterator() {
    if (typeof Symbol !== 'function' || !Symbol.iterator) return '@@iterator';
    return Symbol.iterator;
}
var iterator = getSymbolIterator();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6bgze":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "readableStreamLikeToAsyncGenerator", function() {
    return readableStreamLikeToAsyncGenerator;
});
parcelHelpers.export(exports, "isReadableStreamLike", function() {
    return isReadableStreamLike;
});
var _tslib = require("tslib");
var _isFunction = require("./isFunction");
function readableStreamLikeToAsyncGenerator(readableStream) {
    return (0, _tslib.__asyncGenerator)(this, arguments, function readableStreamLikeToAsyncGenerator_1() {
        var reader, _a, value, done;
        return (0, _tslib.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    reader = readableStream.getReader();
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        ,
                        9,
                        10
                    ]);
                    _b.label = 2;
                case 2:
                    return [
                        4,
                        (0, _tslib.__await)(reader.read())
                    ];
                case 3:
                    _a = _b.sent(), value = _a.value, done = _a.done;
                    if (!done) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        (0, _tslib.__await)(void 0)
                    ];
                case 4:
                    return [
                        2,
                        _b.sent()
                    ];
                case 5:
                    return [
                        4,
                        (0, _tslib.__await)(value)
                    ];
                case 6:
                    return [
                        4,
                        _b.sent()
                    ];
                case 7:
                    _b.sent();
                    return [
                        3,
                        2
                    ];
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    reader.releaseLock();
                    return [
                        7
                    ];
                case 10:
                    return [
                        2
                    ];
            }
        });
    });
}
function isReadableStreamLike(obj) {
    return (0, _isFunction.isFunction)(obj === null || obj === void 0 ? void 0 : obj.getReader);
}

},{"tslib":"C7UIb","./isFunction":"7Ztzn","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1bN4L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createOperatorSubscriber", function() {
    return createOperatorSubscriber;
});
parcelHelpers.export(exports, "OperatorSubscriber", function() {
    return OperatorSubscriber;
});
var _tslib = require("tslib");
var _subscriber = require("../Subscriber");
function createOperatorSubscriber(destination, onNext, onComplete, onError, onFinalize) {
    return new OperatorSubscriber(destination, onNext, onComplete, onError, onFinalize);
}
var OperatorSubscriber = function(_super) {
    (0, _tslib.__extends)(OperatorSubscriber, _super);
    function OperatorSubscriber(destination, onNext, onComplete, onError, onFinalize, shouldUnsubscribe) {
        var _this = _super.call(this, destination) || this;
        _this.onFinalize = onFinalize;
        _this.shouldUnsubscribe = shouldUnsubscribe;
        _this._next = onNext ? function(value) {
            try {
                onNext(value);
            } catch (err) {
                destination.error(err);
            }
        } : _super.prototype._next;
        _this._error = onError ? function(err) {
            try {
                onError(err);
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._error;
        _this._complete = onComplete ? function() {
            try {
                onComplete();
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._complete;
        return _this;
    }
    OperatorSubscriber.prototype.unsubscribe = function() {
        var _a;
        if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
            var closed_1 = this.closed;
            _super.prototype.unsubscribe.call(this);
            !closed_1 && ((_a = this.onFinalize) === null || _a === void 0 || _a.call(this));
        }
    };
    return OperatorSubscriber;
}((0, _subscriber.Subscriber));

},{"tslib":"C7UIb","../Subscriber":"fQCkt","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2kRZ7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "executeSchedule", function() {
    return executeSchedule;
});
function executeSchedule(parentSubscription, scheduler, work, delay, repeat) {
    if (delay === void 0) delay = 0;
    if (repeat === void 0) repeat = false;
    var scheduleSubscription = scheduler.schedule(function() {
        work();
        if (repeat) parentSubscription.add(this.schedule(null, delay));
        else this.unsubscribe();
    }, delay);
    parentSubscription.add(scheduleSubscription);
    if (!repeat) return scheduleSubscription;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"aN1A8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "concat", function() {
    return concat;
});
var _concatAll = require("../operators/concatAll");
var _args = require("../util/args");
var _from = require("./from");
function concat() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return (0, _concatAll.concatAll)()((0, _from.from)(args, (0, _args.popScheduler)(args)));
}

},{"../operators/concatAll":"fU2du","../util/args":"iTb1F","./from":"20N0q","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"fU2du":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "concatAll", function() {
    return concatAll;
});
var _mergeAll = require("./mergeAll");
function concatAll() {
    return (0, _mergeAll.mergeAll)(1);
}

},{"./mergeAll":"anbYP","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"anbYP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mergeAll", function() {
    return mergeAll;
});
var _mergeMap = require("./mergeMap");
var _identity = require("../util/identity");
function mergeAll(concurrent) {
    if (concurrent === void 0) concurrent = Infinity;
    return (0, _mergeMap.mergeMap)((0, _identity.identity), concurrent);
}

},{"./mergeMap":"goSDz","../util/identity":"2cZmM","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"goSDz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mergeMap", function() {
    return mergeMap;
});
var _map = require("./map");
var _innerFrom = require("../observable/innerFrom");
var _lift = require("../util/lift");
var _mergeInternals = require("./mergeInternals");
var _isFunction = require("../util/isFunction");
function mergeMap(project, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Infinity;
    if ((0, _isFunction.isFunction)(resultSelector)) return mergeMap(function(a, i) {
        return (0, _map.map)(function(b, ii) {
            return resultSelector(a, b, i, ii);
        })((0, _innerFrom.innerFrom)(project(a, i)));
    }, concurrent);
    else if (typeof resultSelector === 'number') concurrent = resultSelector;
    return (0, _lift.operate)(function(source, subscriber) {
        return (0, _mergeInternals.mergeInternals)(source, subscriber, project, concurrent);
    });
}

},{"./map":"3BG2Y","../observable/innerFrom":"1GoHu","../util/lift":"fFjpf","./mergeInternals":"gs6KC","../util/isFunction":"7Ztzn","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3BG2Y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "map", function() {
    return map;
});
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function map(project, thisArg) {
    return (0, _lift.operate)(function(source, subscriber) {
        var index = 0;
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            subscriber.next(project.call(thisArg, value, index++));
        }));
    });
}

},{"../util/lift":"fFjpf","./OperatorSubscriber":"1bN4L","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gs6KC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mergeInternals", function() {
    return mergeInternals;
});
var _innerFrom = require("../observable/innerFrom");
var _executeSchedule = require("../util/executeSchedule");
var _operatorSubscriber = require("./OperatorSubscriber");
function mergeInternals(source, subscriber, project, concurrent, onBeforeNext, expand, innerSubScheduler, additionalFinalizer) {
    var buffer = [];
    var active = 0;
    var index = 0;
    var isComplete = false;
    var checkComplete = function checkComplete() {
        if (isComplete && !buffer.length && !active) subscriber.complete();
    };
    var outerNext = function outerNext(value) {
        return active < concurrent ? doInnerSub(value) : buffer.push(value);
    };
    var doInnerSub = function doInnerSub1(value) {
        expand && subscriber.next(value);
        active++;
        var innerComplete = false;
        (0, _innerFrom.innerFrom)(project(value, index++)).subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(innerValue) {
            onBeforeNext === null || onBeforeNext === void 0 || onBeforeNext(innerValue);
            if (expand) outerNext(innerValue);
            else subscriber.next(innerValue);
        }, function() {
            innerComplete = true;
        }, undefined, function() {
            if (innerComplete) try {
                active--;
                var _loop_1 = function _loop_1() {
                    var bufferedValue = buffer.shift();
                    if (innerSubScheduler) (0, _executeSchedule.executeSchedule)(subscriber, innerSubScheduler, function() {
                        return doInnerSub(bufferedValue);
                    });
                    else doInnerSub(bufferedValue);
                };
                while(buffer.length && active < concurrent)_loop_1();
                checkComplete();
            } catch (err) {
                subscriber.error(err);
            }
        }));
    };
    source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, outerNext, function() {
        isComplete = true;
        checkComplete();
    }));
    return function() {
        additionalFinalizer === null || additionalFinalizer === void 0 || additionalFinalizer();
    };
}

},{"../observable/innerFrom":"1GoHu","../util/executeSchedule":"2kRZ7","./OperatorSubscriber":"1bN4L","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"iTb1F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "popResultSelector", function() {
    return popResultSelector;
});
parcelHelpers.export(exports, "popScheduler", function() {
    return popScheduler;
});
parcelHelpers.export(exports, "popNumber", function() {
    return popNumber;
});
var _isFunction = require("./isFunction");
var _isScheduler = require("./isScheduler");
function last(arr) {
    return arr[arr.length - 1];
}
function popResultSelector(args) {
    return (0, _isFunction.isFunction)(last(args)) ? args.pop() : undefined;
}
function popScheduler(args) {
    return (0, _isScheduler.isScheduler)(last(args)) ? args.pop() : undefined;
}
function popNumber(args, defaultValue) {
    return typeof last(args) === 'number' ? args.pop() : defaultValue;
}

},{"./isFunction":"7Ztzn","./isScheduler":"aj8VU","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"aj8VU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isScheduler", function() {
    return isScheduler;
});
var _isFunction = require("./isFunction");
function isScheduler(value) {
    return value && (0, _isFunction.isFunction)(value.schedule);
}

},{"./isFunction":"7Ztzn","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"20N0q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "from", function() {
    return from;
});
var _scheduled = require("../scheduled/scheduled");
var _innerFrom = require("./innerFrom");
function from(input, scheduler) {
    return scheduler ? (0, _scheduled.scheduled)(input, scheduler) : (0, _innerFrom.innerFrom)(input);
}

},{"../scheduled/scheduled":"jq5C7","./innerFrom":"1GoHu","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jq5C7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheduled", function() {
    return scheduled;
});
var _scheduleObservable = require("./scheduleObservable");
var _schedulePromise = require("./schedulePromise");
var _scheduleArray = require("./scheduleArray");
var _scheduleIterable = require("./scheduleIterable");
var _scheduleAsyncIterable = require("./scheduleAsyncIterable");
var _isInteropObservable = require("../util/isInteropObservable");
var _isPromise = require("../util/isPromise");
var _isArrayLike = require("../util/isArrayLike");
var _isIterable = require("../util/isIterable");
var _isAsyncIterable = require("../util/isAsyncIterable");
var _throwUnobservableError = require("../util/throwUnobservableError");
var _isReadableStreamLike = require("../util/isReadableStreamLike");
var _scheduleReadableStreamLike = require("./scheduleReadableStreamLike");
function scheduled(input, scheduler) {
    if (input != null) {
        if ((0, _isInteropObservable.isInteropObservable)(input)) return (0, _scheduleObservable.scheduleObservable)(input, scheduler);
        if ((0, _isArrayLike.isArrayLike)(input)) return (0, _scheduleArray.scheduleArray)(input, scheduler);
        if ((0, _isPromise.isPromise)(input)) return (0, _schedulePromise.schedulePromise)(input, scheduler);
        if ((0, _isAsyncIterable.isAsyncIterable)(input)) return (0, _scheduleAsyncIterable.scheduleAsyncIterable)(input, scheduler);
        if ((0, _isIterable.isIterable)(input)) return (0, _scheduleIterable.scheduleIterable)(input, scheduler);
        if ((0, _isReadableStreamLike.isReadableStreamLike)(input)) return (0, _scheduleReadableStreamLike.scheduleReadableStreamLike)(input, scheduler);
    }
    throw (0, _throwUnobservableError.createInvalidObservableTypeError)(input);
}

},{"./scheduleObservable":"gUKfe","./schedulePromise":"jIsGE","./scheduleArray":"4XomX","./scheduleIterable":"kEZFB","./scheduleAsyncIterable":"iRK2d","../util/isInteropObservable":"64QKY","../util/isPromise":"b7wgD","../util/isArrayLike":"eFM80","../util/isIterable":"5YdZv","../util/isAsyncIterable":"9MhxD","../util/throwUnobservableError":"jWRvy","../util/isReadableStreamLike":"6bgze","./scheduleReadableStreamLike":"haTrM","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gUKfe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheduleObservable", function() {
    return scheduleObservable;
});
var _innerFrom = require("../observable/innerFrom");
var _observeOn = require("../operators/observeOn");
var _subscribeOn = require("../operators/subscribeOn");
function scheduleObservable(input, scheduler) {
    return (0, _innerFrom.innerFrom)(input).pipe((0, _subscribeOn.subscribeOn)(scheduler), (0, _observeOn.observeOn)(scheduler));
}

},{"../observable/innerFrom":"1GoHu","../operators/observeOn":"4CWhq","../operators/subscribeOn":"kWbka","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4CWhq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "observeOn", function() {
    return observeOn;
});
var _executeSchedule = require("../util/executeSchedule");
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function observeOn(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return (0, _lift.operate)(function(source, subscriber) {
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            return (0, _executeSchedule.executeSchedule)(subscriber, scheduler, function() {
                return subscriber.next(value);
            }, delay);
        }, function() {
            return (0, _executeSchedule.executeSchedule)(subscriber, scheduler, function() {
                return subscriber.complete();
            }, delay);
        }, function(err) {
            return (0, _executeSchedule.executeSchedule)(subscriber, scheduler, function() {
                return subscriber.error(err);
            }, delay);
        }));
    });
}

},{"../util/executeSchedule":"2kRZ7","../util/lift":"fFjpf","./OperatorSubscriber":"1bN4L","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"kWbka":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "subscribeOn", function() {
    return subscribeOn;
});
var _lift = require("../util/lift");
function subscribeOn(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return (0, _lift.operate)(function(source, subscriber) {
        subscriber.add(scheduler.schedule(function() {
            return source.subscribe(subscriber);
        }, delay));
    });
}

},{"../util/lift":"fFjpf","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jIsGE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "schedulePromise", function() {
    return schedulePromise;
});
var _innerFrom = require("../observable/innerFrom");
var _observeOn = require("../operators/observeOn");
var _subscribeOn = require("../operators/subscribeOn");
function schedulePromise(input, scheduler) {
    return (0, _innerFrom.innerFrom)(input).pipe((0, _subscribeOn.subscribeOn)(scheduler), (0, _observeOn.observeOn)(scheduler));
}

},{"../observable/innerFrom":"1GoHu","../operators/observeOn":"4CWhq","../operators/subscribeOn":"kWbka","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4XomX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheduleArray", function() {
    return scheduleArray;
});
var _observable = require("../Observable");
function scheduleArray(input, scheduler) {
    return new (0, _observable.Observable)(function(subscriber) {
        var i = 0;
        return scheduler.schedule(function() {
            if (i === input.length) subscriber.complete();
            else {
                subscriber.next(input[i++]);
                if (!subscriber.closed) this.schedule();
            }
        });
    });
}

},{"../Observable":"lgLU4","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"kEZFB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheduleIterable", function() {
    return scheduleIterable;
});
var _observable = require("../Observable");
var _iterator = require("../symbol/iterator");
var _isFunction = require("../util/isFunction");
var _executeSchedule = require("../util/executeSchedule");
function scheduleIterable(input, scheduler) {
    return new (0, _observable.Observable)(function(subscriber) {
        var iterator;
        (0, _executeSchedule.executeSchedule)(subscriber, scheduler, function() {
            iterator = input[0, _iterator.iterator]();
            (0, _executeSchedule.executeSchedule)(subscriber, scheduler, function() {
                var _a;
                var value;
                var done;
                try {
                    _a = iterator.next(), value = _a.value, done = _a.done;
                } catch (err) {
                    subscriber.error(err);
                    return;
                }
                if (done) subscriber.complete();
                else subscriber.next(value);
            }, 0, true);
        });
        return function() {
            return (0, _isFunction.isFunction)(iterator === null || iterator === void 0 ? void 0 : iterator.return) && iterator.return();
        };
    });
}

},{"../Observable":"lgLU4","../symbol/iterator":"8miVP","../util/isFunction":"7Ztzn","../util/executeSchedule":"2kRZ7","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"iRK2d":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheduleAsyncIterable", function() {
    return scheduleAsyncIterable;
});
var _observable = require("../Observable");
var _executeSchedule = require("../util/executeSchedule");
function scheduleAsyncIterable(input, scheduler) {
    if (!input) throw new Error('Iterable cannot be null');
    return new (0, _observable.Observable)(function(subscriber) {
        (0, _executeSchedule.executeSchedule)(subscriber, scheduler, function() {
            var iterator = input[Symbol.asyncIterator]();
            (0, _executeSchedule.executeSchedule)(subscriber, scheduler, function() {
                iterator.next().then(function(result) {
                    if (result.done) subscriber.complete();
                    else subscriber.next(result.value);
                });
            }, 0, true);
        });
    });
}

},{"../Observable":"lgLU4","../util/executeSchedule":"2kRZ7","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"haTrM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scheduleReadableStreamLike", function() {
    return scheduleReadableStreamLike;
});
var _scheduleAsyncIterable = require("./scheduleAsyncIterable");
var _isReadableStreamLike = require("../util/isReadableStreamLike");
function scheduleReadableStreamLike(input, scheduler) {
    return (0, _scheduleAsyncIterable.scheduleAsyncIterable)((0, _isReadableStreamLike.readableStreamLikeToAsyncGenerator)(input), scheduler);
}

},{"./scheduleAsyncIterable":"iRK2d","../util/isReadableStreamLike":"6bgze","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4e9jT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EMPTY", function() {
    return EMPTY;
});
parcelHelpers.export(exports, "empty", function() {
    return empty;
});
var _observable = require("../Observable");
var EMPTY = new (0, _observable.Observable)(function(subscriber) {
    return subscriber.complete();
});
function empty(scheduler) {
    return scheduler ? emptyScheduled(scheduler) : EMPTY;
}
function emptyScheduled(scheduler) {
    return new (0, _observable.Observable)(function(subscriber) {
        return scheduler.schedule(function() {
            return subscriber.complete();
        });
    });
}

},{"../Observable":"lgLU4","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"klaUi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromEvent", function() {
    return fromEvent;
});
var _tslib = require("tslib");
var _innerFrom = require("../observable/innerFrom");
var _observable = require("../Observable");
var _mergeMap = require("../operators/mergeMap");
var _isArrayLike = require("../util/isArrayLike");
var _isFunction = require("../util/isFunction");
var _mapOneOrManyArgs = require("../util/mapOneOrManyArgs");
var nodeEventEmitterMethods = [
    'addListener',
    'removeListener'
];
var eventTargetMethods = [
    'addEventListener',
    'removeEventListener'
];
var jqueryMethods = [
    'on',
    'off'
];
function fromEvent(target, eventName, options, resultSelector) {
    if ((0, _isFunction.isFunction)(options)) {
        resultSelector = options;
        options = undefined;
    }
    if (resultSelector) return fromEvent(target, eventName, options).pipe((0, _mapOneOrManyArgs.mapOneOrManyArgs)(resultSelector));
    var _a = (0, _tslib.__read)(isEventTarget(target) ? eventTargetMethods.map(function(methodName) {
        return function(handler) {
            return target[methodName](eventName, handler, options);
        };
    }) : isNodeStyleEventEmitter(target) ? nodeEventEmitterMethods.map(toCommonHandlerRegistry(target, eventName)) : isJQueryStyleEventEmitter(target) ? jqueryMethods.map(toCommonHandlerRegistry(target, eventName)) : [], 2), add = _a[0], remove = _a[1];
    if (!add) {
        if ((0, _isArrayLike.isArrayLike)(target)) return (0, _mergeMap.mergeMap)(function(subTarget) {
            return fromEvent(subTarget, eventName, options);
        })((0, _innerFrom.innerFrom)(target));
    }
    if (!add) throw new TypeError('Invalid event target');
    return new (0, _observable.Observable)(function(subscriber) {
        var handler = function handler() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return subscriber.next(1 < args.length ? args : args[0]);
        };
        add(handler);
        return function() {
            return remove(handler);
        };
    });
}
function toCommonHandlerRegistry(target, eventName) {
    return function(methodName) {
        return function(handler) {
            return target[methodName](eventName, handler);
        };
    };
}
function isNodeStyleEventEmitter(target) {
    return (0, _isFunction.isFunction)(target.addListener) && (0, _isFunction.isFunction)(target.removeListener);
}
function isJQueryStyleEventEmitter(target) {
    return (0, _isFunction.isFunction)(target.on) && (0, _isFunction.isFunction)(target.off);
}
function isEventTarget(target) {
    return (0, _isFunction.isFunction)(target.addEventListener) && (0, _isFunction.isFunction)(target.removeEventListener);
}

},{"tslib":"C7UIb","../observable/innerFrom":"1GoHu","../Observable":"lgLU4","../operators/mergeMap":"goSDz","../util/isArrayLike":"eFM80","../util/isFunction":"7Ztzn","../util/mapOneOrManyArgs":"bGBLW","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"bGBLW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapOneOrManyArgs", function() {
    return mapOneOrManyArgs;
});
var _tslib = require("tslib");
var _map = require("../operators/map");
var isArray = Array.isArray;
function callOrApply(fn, args) {
    return isArray(args) ? fn.apply(void 0, (0, _tslib.__spreadArray)([], (0, _tslib.__read)(args))) : fn(args);
}
function mapOneOrManyArgs(fn) {
    return (0, _map.map)(function(args) {
        return callOrApply(fn, args);
    });
}

},{"tslib":"C7UIb","../operators/map":"3BG2Y","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"379yM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "merge", function() {
    return merge;
});
var _mergeAll = require("../operators/mergeAll");
var _innerFrom = require("./innerFrom");
var _empty = require("./empty");
var _args = require("../util/args");
var _from = require("./from");
function merge() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var scheduler = (0, _args.popScheduler)(args);
    var concurrent = (0, _args.popNumber)(args, Infinity);
    var sources = args;
    return !sources.length ? (0, _empty.EMPTY) : sources.length === 1 ? (0, _innerFrom.innerFrom)(sources[0]) : (0, _mergeAll.mergeAll)(concurrent)((0, _from.from)(sources, scheduler));
}

},{"../operators/mergeAll":"anbYP","./innerFrom":"1GoHu","./empty":"4e9jT","../util/args":"iTb1F","./from":"20N0q","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"dyexq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timer", function() {
    return timer;
});
var _observable = require("../Observable");
var _async = require("../scheduler/async");
var _isScheduler = require("../util/isScheduler");
var _isDate = require("../util/isDate");
function timer(dueTime, intervalOrScheduler, scheduler) {
    if (dueTime === void 0) dueTime = 0;
    if (scheduler === void 0) scheduler = (0, _async.async);
    var intervalDuration = -1;
    if (intervalOrScheduler != null) {
        if ((0, _isScheduler.isScheduler)(intervalOrScheduler)) scheduler = intervalOrScheduler;
        else intervalDuration = intervalOrScheduler;
    }
    return new (0, _observable.Observable)(function(subscriber) {
        var due = (0, _isDate.isValidDate)(dueTime) ? +dueTime - scheduler.now() : dueTime;
        if (due < 0) due = 0;
        var n = 0;
        return scheduler.schedule(function() {
            if (!subscriber.closed) {
                subscriber.next(n++);
                if (0 <= intervalDuration) this.schedule(undefined, intervalDuration);
                else subscriber.complete();
            }
        }, due);
    });
}

},{"../Observable":"lgLU4","../scheduler/async":"24XQb","../util/isScheduler":"aj8VU","../util/isDate":"cK1Y0","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"dixVg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buffer", function() {
    return buffer;
});
var _lift = require("../util/lift");
var _noop = require("../util/noop");
var _operatorSubscriber = require("./OperatorSubscriber");
var _innerFrom = require("../observable/innerFrom");
function buffer(closingNotifier) {
    return (0, _lift.operate)(function(source, subscriber) {
        var currentBuffer = [];
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            return currentBuffer.push(value);
        }, function() {
            subscriber.next(currentBuffer);
            subscriber.complete();
        }));
        (0, _innerFrom.innerFrom)(closingNotifier).subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function() {
            var b = currentBuffer;
            currentBuffer = [];
            subscriber.next(b);
        }, (0, _noop.noop)));
        return function() {
            currentBuffer = null;
        };
    });
}

},{"../util/lift":"fFjpf","../util/noop":"eXHGP","./OperatorSubscriber":"1bN4L","../observable/innerFrom":"1GoHu","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6vFnF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "debounceTime", function() {
    return debounceTime;
});
var _async = require("../scheduler/async");
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function debounceTime(dueTime, scheduler) {
    if (scheduler === void 0) scheduler = (0, _async.asyncScheduler);
    return (0, _lift.operate)(function(source, subscriber) {
        var activeTask = null;
        var lastValue = null;
        var lastTime = null;
        var emit = function emit() {
            if (activeTask) {
                activeTask.unsubscribe();
                activeTask = null;
                var value = lastValue;
                lastValue = null;
                subscriber.next(value);
            }
        };
        function emitWhenIdle() {
            var targetTime = lastTime + dueTime;
            var now = scheduler.now();
            if (now < targetTime) {
                activeTask = this.schedule(undefined, targetTime - now);
                subscriber.add(activeTask);
                return;
            }
            emit();
        }
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            lastValue = value;
            lastTime = scheduler.now();
            if (!activeTask) {
                activeTask = scheduler.schedule(emitWhenIdle, dueTime);
                subscriber.add(activeTask);
            }
        }, function() {
            emit();
            subscriber.complete();
        }, undefined, function() {
            lastValue = activeTask = null;
        }));
    });
}

},{"../scheduler/async":"24XQb","../util/lift":"fFjpf","./OperatorSubscriber":"1bN4L","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8CEK4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "delay", function() {
    return delay;
});
var _async = require("../scheduler/async");
var _delayWhen = require("./delayWhen");
var _timer = require("../observable/timer");
function delay(due, scheduler) {
    if (scheduler === void 0) scheduler = (0, _async.asyncScheduler);
    var duration = (0, _timer.timer)(due, scheduler);
    return (0, _delayWhen.delayWhen)(function() {
        return duration;
    });
}

},{"../scheduler/async":"24XQb","./delayWhen":"cw45t","../observable/timer":"dyexq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"cw45t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "delayWhen", function() {
    return delayWhen;
});
var _concat = require("../observable/concat");
var _take = require("./take");
var _ignoreElements = require("./ignoreElements");
var _mapTo = require("./mapTo");
var _mergeMap = require("./mergeMap");
var _innerFrom = require("../observable/innerFrom");
function delayWhen(delayDurationSelector, subscriptionDelay) {
    if (subscriptionDelay) return function(source) {
        return (0, _concat.concat)(subscriptionDelay.pipe((0, _take.take)(1), (0, _ignoreElements.ignoreElements)()), source.pipe(delayWhen(delayDurationSelector)));
    };
    return (0, _mergeMap.mergeMap)(function(value, index) {
        return (0, _innerFrom.innerFrom)(delayDurationSelector(value, index)).pipe((0, _take.take)(1), (0, _mapTo.mapTo)(value));
    });
}

},{"../observable/concat":"aN1A8","./take":"4mjMK","./ignoreElements":"3w42c","./mapTo":"gY0q5","./mergeMap":"goSDz","../observable/innerFrom":"1GoHu","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4mjMK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "take", function() {
    return take;
});
var _empty = require("../observable/empty");
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function take(count) {
    return count <= 0 ? function() {
        return 0, _empty.EMPTY;
    } : (0, _lift.operate)(function(source, subscriber) {
        var seen = 0;
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            if (++seen <= count) {
                subscriber.next(value);
                if (count <= seen) subscriber.complete();
            }
        }));
    });
}

},{"../observable/empty":"4e9jT","../util/lift":"fFjpf","./OperatorSubscriber":"1bN4L","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3w42c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ignoreElements", function() {
    return ignoreElements;
});
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
var _noop = require("../util/noop");
function ignoreElements() {
    return (0, _lift.operate)(function(source, subscriber) {
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, (0, _noop.noop)));
    });
}

},{"../util/lift":"fFjpf","./OperatorSubscriber":"1bN4L","../util/noop":"eXHGP","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gY0q5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapTo", function() {
    return mapTo;
});
var _map = require("./map");
function mapTo(value) {
    return (0, _map.map)(function() {
        return value;
    });
}

},{"./map":"3BG2Y","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"9HGKT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "filter", function() {
    return filter;
});
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function filter(predicate, thisArg) {
    return (0, _lift.operate)(function(source, subscriber) {
        var index = 0;
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            return predicate.call(thisArg, value, index++) && subscriber.next(value);
        }));
    });
}

},{"../util/lift":"fFjpf","./OperatorSubscriber":"1bN4L","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"fcHHb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pairwise", function() {
    return pairwise;
});
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function pairwise() {
    return (0, _lift.operate)(function(source, subscriber) {
        var prev;
        var hasPrev = false;
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            var p = prev;
            prev = value;
            hasPrev && subscriber.next([
                p,
                value
            ]);
            hasPrev = true;
        }));
    });
}

},{"../util/lift":"fFjpf","./OperatorSubscriber":"1bN4L","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"lapCG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "share", function() {
    return share;
});
var _tslib = require("tslib");
var _innerFrom = require("../observable/innerFrom");
var _subject = require("../Subject");
var _subscriber = require("../Subscriber");
var _lift = require("../util/lift");
function share(options) {
    if (options === void 0) options = {};
    var _a = options.connector, connector = _a === void 0 ? function connector() {
        return new (0, _subject.Subject)();
    } : _a, _b = options.resetOnError, resetOnError = _b === void 0 ? true : _b, _c = options.resetOnComplete, resetOnComplete = _c === void 0 ? true : _c, _d = options.resetOnRefCountZero, resetOnRefCountZero = _d === void 0 ? true : _d;
    return function(wrapperSource) {
        var connection;
        var resetConnection;
        var subject;
        var refCount = 0;
        var hasCompleted = false;
        var hasErrored = false;
        var cancelReset = function cancelReset() {
            resetConnection === null || resetConnection === void 0 || resetConnection.unsubscribe();
            resetConnection = undefined;
        };
        var reset = function reset() {
            cancelReset();
            connection = subject = undefined;
            hasCompleted = hasErrored = false;
        };
        var resetAndUnsubscribe = function resetAndUnsubscribe() {
            var conn = connection;
            reset();
            conn === null || conn === void 0 || conn.unsubscribe();
        };
        return (0, _lift.operate)(function(source, subscriber) {
            refCount++;
            if (!hasErrored && !hasCompleted) cancelReset();
            var dest = subject = subject !== null && subject !== void 0 ? subject : connector();
            subscriber.add(function() {
                refCount--;
                if (refCount === 0 && !hasErrored && !hasCompleted) resetConnection = handleReset(resetAndUnsubscribe, resetOnRefCountZero);
            });
            dest.subscribe(subscriber);
            if (!connection && refCount > 0) {
                connection = new (0, _subscriber.SafeSubscriber)({
                    next: function next(value) {
                        return dest.next(value);
                    },
                    error: function error(err) {
                        hasErrored = true;
                        cancelReset();
                        resetConnection = handleReset(reset, resetOnError, err);
                        dest.error(err);
                    },
                    complete: function complete() {
                        hasCompleted = true;
                        cancelReset();
                        resetConnection = handleReset(reset, resetOnComplete);
                        dest.complete();
                    }
                });
                (0, _innerFrom.innerFrom)(source).subscribe(connection);
            }
        })(wrapperSource);
    };
}
function handleReset(reset, on) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    if (on === true) {
        reset();
        return;
    }
    if (on === false) return;
    var onSubscriber = new (0, _subscriber.SafeSubscriber)({
        next: function next() {
            onSubscriber.unsubscribe();
            reset();
        }
    });
    return (0, _innerFrom.innerFrom)(on.apply(void 0, (0, _tslib.__spreadArray)([], (0, _tslib.__read)(args)))).subscribe(onSubscriber);
}

},{"tslib":"C7UIb","../observable/innerFrom":"1GoHu","../Subject":"1HcMp","../Subscriber":"fQCkt","../util/lift":"fFjpf","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jbzdM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "switchMap", function() {
    return switchMap;
});
var _innerFrom = require("../observable/innerFrom");
var _lift = require("../util/lift");
var _operatorSubscriber = require("./OperatorSubscriber");
function switchMap(project, resultSelector) {
    return (0, _lift.operate)(function(source, subscriber) {
        var innerSubscriber = null;
        var index = 0;
        var isComplete = false;
        var checkComplete = function checkComplete() {
            return isComplete && !innerSubscriber && subscriber.complete();
        };
        source.subscribe((0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(value) {
            innerSubscriber === null || innerSubscriber === void 0 || innerSubscriber.unsubscribe();
            var innerIndex = 0;
            var outerIndex = index++;
            (0, _innerFrom.innerFrom)(project(value, outerIndex)).subscribe(innerSubscriber = (0, _operatorSubscriber.createOperatorSubscriber)(subscriber, function(innerValue) {
                return subscriber.next(resultSelector ? resultSelector(value, innerValue, outerIndex, innerIndex++) : innerValue);
            }, function() {
                innerSubscriber = null;
                checkComplete();
            }));
        }, function() {
            isComplete = true;
            checkComplete();
        }));
    });
}

},{"../observable/innerFrom":"1GoHu","../util/lift":"fFjpf","./OperatorSubscriber":"1bN4L","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8nGGo":[function(require,module,exports,__globalThis) {
/* eslint-disable no-restricted-globals */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createShouldTrackEvent", function() {
    return createShouldTrackEvent;
});
parcelHelpers.export(exports, "isNonSensitiveString", function() {
    return isNonSensitiveString;
});
parcelHelpers.export(exports, "isTextNode", function() {
    return isTextNode;
});
parcelHelpers.export(exports, "isNonSensitiveElement", function() {
    return isNonSensitiveElement;
});
parcelHelpers.export(exports, "getText", function() {
    return getText;
});
parcelHelpers.export(exports, "isPageUrlAllowed", function() {
    return isPageUrlAllowed;
});
parcelHelpers.export(exports, "getAttributesWithPrefix", function() {
    return getAttributesWithPrefix;
});
parcelHelpers.export(exports, "isEmpty", function() {
    return isEmpty;
});
parcelHelpers.export(exports, "removeEmptyProperties", function() {
    return removeEmptyProperties;
});
parcelHelpers.export(exports, "getNearestLabel", function() {
    return getNearestLabel;
});
parcelHelpers.export(exports, "querySelectUniqueElements", function() {
    return querySelectUniqueElements;
});
parcelHelpers.export(exports, "getClosestElement", function() {
    return getClosestElement;
});
parcelHelpers.export(exports, "getEventTagProps", function() {
    return getEventTagProps;
});
parcelHelpers.export(exports, "asyncLoadScript", function() {
    return asyncLoadScript;
});
parcelHelpers.export(exports, "generateUniqueId", function() {
    return generateUniqueId;
});
parcelHelpers.export(exports, "filterOutNonTrackableEvents", function() {
    return filterOutNonTrackableEvents;
});
var _constants = require("./constants");
var SENSITIVE_TAGS = [
    'input',
    'select',
    'textarea'
];
var createShouldTrackEvent = function createShouldTrackEvent(autocaptureOptions, allowlist) {
    return function(actionType, element) {
        var _a, _b, _c;
        var pageUrlAllowlist = autocaptureOptions.pageUrlAllowlist, shouldTrackEventResolver = autocaptureOptions.shouldTrackEventResolver;
        /* istanbul ignore next */ var tag = (_b = (_a = element === null || element === void 0 ? void 0 : element.tagName) === null || _a === void 0 ? void 0 : _a.toLowerCase) === null || _b === void 0 ? void 0 : _b.call(_a);
        // window, document, and Text nodes have no tag
        if (!tag) return false;
        if (shouldTrackEventResolver) return shouldTrackEventResolver(actionType, element);
        if (!isPageUrlAllowed(window.location.href, pageUrlAllowlist)) return false;
        /* istanbul ignore next */ var elementType = String(element === null || element === void 0 ? void 0 : element.getAttribute('type')) || '';
        if (typeof elementType === 'string') switch(elementType.toLowerCase()){
            case 'hidden':
                return false;
            case 'password':
                return false;
        }
        /* istanbul ignore if */ if (allowlist) {
            var hasMatchAnyAllowedSelector = allowlist.some(function(selector) {
                var _a;
                return !!((_a = element === null || element === void 0 ? void 0 : element.matches) === null || _a === void 0 ? void 0 : _a.call(element, selector));
            });
            if (!hasMatchAnyAllowedSelector) return false;
        }
        switch(tag){
            case 'input':
            case 'select':
            case 'textarea':
                return actionType === 'change' || actionType === 'click';
            default:
                /* istanbul ignore next */ var computedStyle = (_c = window === null || window === void 0 ? void 0 : window.getComputedStyle) === null || _c === void 0 ? void 0 : _c.call(window, element);
                /* istanbul ignore next */ if (computedStyle && computedStyle.getPropertyValue('cursor') === 'pointer' && actionType === 'click') return true;
                return actionType === 'click';
        }
    };
};
var isNonSensitiveString = function isNonSensitiveString(text) {
    if (text == null) return false;
    if (typeof text === 'string') {
        var ccRegex = /^(?:(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11}))$/;
        if (ccRegex.test((text || '').replace(/[- ]/g, ''))) return false;
        var ssnRegex = /(^\d{3}-?\d{2}-?\d{4}$)/;
        if (ssnRegex.test(text)) return false;
    }
    return true;
};
var isTextNode = function isTextNode(node) {
    return !!node && node.nodeType === 3;
};
var isNonSensitiveElement = function isNonSensitiveElement(element) {
    var _a, _b, _c;
    /* istanbul ignore next */ var tag = (_b = (_a = element === null || element === void 0 ? void 0 : element.tagName) === null || _a === void 0 ? void 0 : _a.toLowerCase) === null || _b === void 0 ? void 0 : _b.call(_a);
    var isContentEditable = element instanceof HTMLElement ? ((_c = element.getAttribute('contenteditable')) === null || _c === void 0 ? void 0 : _c.toLowerCase()) === 'true' : false;
    return !SENSITIVE_TAGS.includes(tag) && !isContentEditable;
};
var getText = function getText1(element) {
    var text = '';
    if (isNonSensitiveElement(element) && element.childNodes && element.childNodes.length) element.childNodes.forEach(function(child) {
        var childText = '';
        if (isTextNode(child)) {
            if (child.textContent) childText = child.textContent;
        } else childText = getText(child);
        text += childText.split(/(\s+)/).filter(isNonSensitiveString).join('').replace(/[\r\n]/g, ' ').replace(/[ ]+/g, ' ').substring(0, 255);
    });
    return text;
};
var isPageUrlAllowed = function isPageUrlAllowed(url, pageUrlAllowlist) {
    if (!pageUrlAllowlist || !pageUrlAllowlist.length) return true;
    return pageUrlAllowlist.some(function(allowedUrl) {
        if (typeof allowedUrl === 'string') return url === allowedUrl;
        return url.match(allowedUrl);
    });
};
var getAttributesWithPrefix = function getAttributesWithPrefix(element, prefix) {
    return element.getAttributeNames().reduce(function(attributes, attributeName) {
        if (attributeName.startsWith(prefix)) {
            var attributeKey = attributeName.replace(prefix, '');
            var attributeValue = element.getAttribute(attributeName);
            if (attributeKey) attributes[attributeKey] = attributeValue || '';
        }
        return attributes;
    }, {});
};
var isEmpty = function isEmpty(value) {
    return value === undefined || value === null || typeof value === 'object' && Object.keys(value).length === 0 || typeof value === 'string' && value.trim().length === 0;
};
var removeEmptyProperties = function removeEmptyProperties(properties) {
    return Object.keys(properties).reduce(function(filteredProperties, key) {
        var value = properties[key];
        if (!isEmpty(value)) filteredProperties[key] = value;
        return filteredProperties;
    }, {});
};
var getNearestLabel = function getNearestLabel1(element) {
    var parent = element.parentElement;
    if (!parent) return '';
    var labelElement;
    try {
        labelElement = parent.querySelector(':scope>span,h1,h2,h3,h4,h5,h6');
    } catch (error) {
        labelElement = null;
    }
    if (labelElement) {
        /* istanbul ignore next */ var labelText = labelElement.textContent || '';
        return isNonSensitiveString(labelText) ? labelText : '';
    }
    return getNearestLabel(parent);
};
var querySelectUniqueElements = function querySelectUniqueElements(root, selectors) {
    if (root && 'querySelectorAll' in root && typeof root.querySelectorAll === 'function') {
        var elementSet = selectors.reduce(function(elements, selector) {
            if (selector) {
                var selectedElements = Array.from(root.querySelectorAll(selector));
                selectedElements.forEach(function(element) {
                    elements.add(element);
                });
            }
            return elements;
        }, new Set());
        return Array.from(elementSet);
    }
    return [];
};
var getClosestElement = function getClosestElement1(element, selectors) {
    if (!element) return null;
    /* istanbul ignore next */ if (selectors.some(function(selector) {
        var _a;
        return (_a = element === null || element === void 0 ? void 0 : element.matches) === null || _a === void 0 ? void 0 : _a.call(element, selector);
    })) return element;
    /* istanbul ignore next */ return getClosestElement(element === null || element === void 0 ? void 0 : element.parentElement, selectors);
};
var getEventTagProps = function getEventTagProps(element) {
    var _a;
    var _b, _c;
    if (!element) return {};
    /* istanbul ignore next */ var tag = (_c = (_b = element === null || element === void 0 ? void 0 : element.tagName) === null || _b === void 0 ? void 0 : _b.toLowerCase) === null || _c === void 0 ? void 0 : _c.call(_b);
    var properties = (_a = {}, _a[_constants.AMPLITUDE_EVENT_PROP_ELEMENT_TAG] = tag, _a[_constants.AMPLITUDE_EVENT_PROP_ELEMENT_TEXT] = getText(element), _a[_constants.AMPLITUDE_EVENT_PROP_PAGE_URL] = window.location.href.split('?')[0], _a);
    return removeEmptyProperties(properties);
};
var asyncLoadScript = function asyncLoadScript(url) {
    return new Promise(function(resolve, reject) {
        var _a;
        try {
            var scriptElement = document.createElement('script');
            scriptElement.type = 'text/javascript';
            scriptElement.async = true;
            scriptElement.src = url;
            scriptElement.addEventListener('load', function() {
                resolve({
                    status: true
                });
            }, {
                once: true
            });
            scriptElement.addEventListener('error', function() {
                reject({
                    status: false,
                    message: "Failed to load the script ".concat(url)
                });
            });
            /* istanbul ignore next */ (_a = document.head) === null || _a === void 0 || _a.appendChild(scriptElement);
        } catch (error) {
            /* istanbul ignore next */ reject(error);
        }
    });
};
function generateUniqueId() {
    return "".concat(Date.now(), "-").concat(Math.random().toString(36).substr(2, 9));
}
var filterOutNonTrackableEvents = function filterOutNonTrackableEvents(event) {
    // Filter out changeEvent events with no target
    // This could happen when change events are triggered programmatically
    if (event.event.target === null || !event.closestTrackedAncestor) return false;
    return true;
};

},{"./constants":"c6uAd","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"fd4ca":[function(require,module,exports,__globalThis) {
/* istanbul ignore file */ /* eslint-disable no-restricted-globals */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WindowMessenger", function() {
    return WindowMessenger;
});
var _constants = require("../constants");
var _helpers = require("../helpers");
// TODO: use MessageChannel instead of window.postMessage
var WindowMessenger = /** @class */ function() {
    function WindowMessenger(_a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.origin, origin = _c === void 0 ? (0, _constants.AMPLITUDE_ORIGIN) : _c;
        var _this = this;
        this.endpoint = (0, _constants.AMPLITUDE_ORIGIN);
        this.requestCallbacks = {};
        this.onSelect = function(data) {
            _this.notify({
                action: 'element-selected',
                data: data
            });
        };
        this.onTrack = function(type, properties) {
            if (type === 'selector-mode-changed') _this.notify({
                action: 'track-selector-mode-changed',
                data: properties
            });
            else if (type === 'selector-moved') _this.notify({
                action: 'track-selector-moved',
                data: properties
            });
        };
        this.endpoint = origin;
    }
    WindowMessenger.prototype.notify = function(message) {
        var _a, _b, _c, _d;
        (_b = (_a = this.logger) === null || _a === void 0 ? void 0 : _a.debug) === null || _b === void 0 || _b.call(_a, 'Message sent: ', JSON.stringify(message));
        (_d = (_c = window.opener) === null || _c === void 0 ? void 0 : _c.postMessage) === null || _d === void 0 || _d.call(_c, message, this.endpoint);
    };
    // Send an async request to the parent window
    WindowMessenger.prototype.sendRequest = function(action, args, options) {
        var _this = this;
        if (options === void 0) options = {
            timeout: 15000
        };
        // Create Request ID
        var id = (0, _helpers.generateUniqueId)();
        var request = {
            id: id,
            action: action,
            args: args
        };
        // Create a Promise that will be resolved when the response is received
        var promise = new Promise(function(resolve, reject) {
            _this.requestCallbacks[id] = {
                resolve: resolve,
                reject: reject
            };
            // Send the request
            _this.notify(request);
            // Handle request timeouts
            if ((options === null || options === void 0 ? void 0 : options.timeout) > 0) setTimeout(function() {
                reject(new Error("".concat(action, " timed out (id: ").concat(id, ")")));
                delete _this.requestCallbacks[id];
            }, options.timeout);
        });
        return promise;
    };
    // Handle messages from the parent window
    WindowMessenger.prototype.handleResponse = function(response) {
        var _a;
        if (!this.requestCallbacks[response.id]) {
            (_a = this.logger) === null || _a === void 0 || _a.warn("No callback found for request id: ".concat(response.id));
            return;
        }
        this.requestCallbacks[response.id].resolve(response.responseData);
        delete this.requestCallbacks[response.id];
    };
    WindowMessenger.prototype.setup = function(_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, logger = _b.logger, endpoint = _b.endpoint, isElementSelectable = _b.isElementSelectable, cssSelectorAllowlist = _b.cssSelectorAllowlist, actionClickAllowlist = _b.actionClickAllowlist;
        this.logger = logger;
        // If endpoint is customized, don't override it.
        if (endpoint && this.endpoint === (0, _constants.AMPLITUDE_ORIGIN)) this.endpoint = endpoint;
        var amplitudeVisualTaggingSelectorInstance = null;
        // Attach Event Listener to listen for messages from the parent window
        window.addEventListener('message', function(event) {
            var _$_a, _b, _c, _d, _e;
            (_b = (_$_a = _this.logger) === null || _$_a === void 0 ? void 0 : _$_a.debug) === null || _b === void 0 || _b.call(_$_a, 'Message received: ', JSON.stringify(event));
            // Only accept messages from the specified origin
            if (_this.endpoint !== event.origin) return;
            var eventData = event === null || event === void 0 ? void 0 : event.data;
            var action = eventData === null || eventData === void 0 ? void 0 : eventData.action;
            // Ignore messages without action
            if (!action) return;
            // If id exists, handle responses to previous requests
            if ('id' in eventData) {
                (_d = (_c = _this.logger) === null || _c === void 0 ? void 0 : _c.debug) === null || _d === void 0 || _d.call(_c, 'Received Response to previous request: ', JSON.stringify(event));
                _this.handleResponse(eventData);
            // If action exists, handle the action using existing handlers
            } else {
                if (action === 'ping') _this.notify({
                    action: 'pong'
                });
                else if (action === 'initialize-visual-tagging-selector') {
                    var actionData_1 = eventData === null || eventData === void 0 ? void 0 : eventData.data;
                    (0, _helpers.asyncLoadScript)((0, _constants.AMPLITUDE_VISUAL_TAGGING_SELECTOR_SCRIPT_URL)).then(function() {
                        var _$_a;
                        // eslint-disable-next-line
                        amplitudeVisualTaggingSelectorInstance = (_$_a = window === null || window === void 0 ? void 0 : window.amplitudeVisualTaggingSelector) === null || _$_a === void 0 ? void 0 : _$_a.call(window, {
                            getEventTagProps: (0, _helpers.getEventTagProps),
                            isElementSelectable: function isElementSelectable1(element) {
                                if (isElementSelectable) return isElementSelectable((actionData_1 === null || actionData_1 === void 0 ? void 0 : actionData_1.actionType) || 'click', element);
                                return true;
                            },
                            onTrack: _this.onTrack,
                            onSelect: _this.onSelect,
                            visualHighlightClass: (0, _constants.AMPLITUDE_VISUAL_TAGGING_HIGHLIGHT_CLASS),
                            messenger: _this,
                            cssSelectorAllowlist: cssSelectorAllowlist,
                            actionClickAllowlist: actionClickAllowlist
                        });
                        _this.notify({
                            action: 'selector-loaded'
                        });
                    }).catch(function() {
                        var _$_a;
                        (_$_a = _this.logger) === null || _$_a === void 0 || _$_a.warn('Failed to initialize visual tagging selector');
                    });
                } else if (action === 'close-visual-tagging-selector') // eslint-disable-next-line
                (_e = amplitudeVisualTaggingSelectorInstance === null || amplitudeVisualTaggingSelectorInstance === void 0 ? void 0 : amplitudeVisualTaggingSelectorInstance.close) === null || _e === void 0 || _e.call(amplitudeVisualTaggingSelectorInstance);
            }
        });
        // Notify the parent window that the page has loaded
        this.notify({
            action: 'page-loaded'
        });
    };
    return WindowMessenger;
}();

},{"../constants":"c6uAd","../helpers":"8nGGo","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8PIWh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getElementProperties", function() {
    return getElementProperties;
});
parcelHelpers.export(exports, "getAncestors", function() {
    return getAncestors;
});
parcelHelpers.export(exports, "getHierarchy", function() {
    return getHierarchy;
});
parcelHelpers.export(exports, "ensureListUnderLimit", function() {
    return ensureListUnderLimit;
});
/**
 * Converts a JSON-compatible value to a Python-compatible string representation.
 * This function handles various data types and ensures proper escaping and formatting.
 *
 * @param value - The value to be converted (can be any JSON-compatible type)
 * @param nested - Indicates if the value is nested within another structure (default: false)
 * @returns A string representation of the value compatible with Python, or null if conversion fails
 */ parcelHelpers.export(exports, "ensureUnicodePythonCompatible", function() {
    return ensureUnicodePythonCompatible;
});
var _tslib = require("tslib");
var _helpers = require("./helpers");
var BLOCKED_ATTRIBUTES = [
    // Already captured elsewhere in the hierarchy object
    'id',
    'class',
    // non-useful and potentially large attribute
    'style',
    // sensitive as prefilled form data may populate this attribute
    'value',
    // DOM events
    'onclick',
    'onchange',
    'oninput',
    'onblur',
    'onsubmit',
    'onfocus',
    'onkeydown',
    'onkeyup',
    'onkeypress',
    // React specific
    'data-reactid',
    'data-react-checksum',
    'data-reactroot'
];
var SENSITIVE_ELEMENT_ATTRIBUTE_ALLOWLIST = [
    'type'
];
var SVG_TAGS = [
    'svg',
    'path',
    'g'
];
var HIGHLY_SENSITIVE_INPUT_TYPES = [
    'password',
    'hidden'
];
var MAX_ATTRIBUTE_LENGTH = 128;
var MAX_HIERARCHY_LENGTH = 1024;
function getElementProperties(element) {
    var e_1, _a;
    var _b, _c, _d, _e;
    if (element === null) return null;
    var tagName = String(element.tagName).toLowerCase();
    var properties = {
        tag: tagName
    };
    var siblings = Array.from((_c = (_b = element.parentElement) === null || _b === void 0 ? void 0 : _b.children) !== null && _c !== void 0 ? _c : []);
    if (siblings.length) {
        properties.index = siblings.indexOf(element);
        properties.indexOfType = siblings.filter(function(el) {
            return el.tagName === element.tagName;
        }).indexOf(element);
    }
    var prevSiblingTag = (_e = (_d = element.previousElementSibling) === null || _d === void 0 ? void 0 : _d.tagName) === null || _e === void 0 ? void 0 : _e.toLowerCase();
    if (prevSiblingTag) properties.prevSib = String(prevSiblingTag);
    var id = element.getAttribute('id');
    if (id) properties.id = String(id);
    var classes = Array.from(element.classList);
    if (classes.length) properties.classes = classes;
    var attributes = {};
    var attributesArray = Array.from(element.attributes);
    var filteredAttributes = attributesArray.filter(function(attr) {
        return !BLOCKED_ATTRIBUTES.includes(attr.name);
    });
    var isSensitiveElement = !(0, _helpers.isNonSensitiveElement)(element);
    // if input is hidden or password or for SVGs, skip attribute collection entirely
    if (!HIGHLY_SENSITIVE_INPUT_TYPES.includes(String(element.getAttribute('type'))) && !SVG_TAGS.includes(tagName)) try {
        for(var filteredAttributes_1 = (0, _tslib.__values)(filteredAttributes), filteredAttributes_1_1 = filteredAttributes_1.next(); !filteredAttributes_1_1.done; filteredAttributes_1_1 = filteredAttributes_1.next()){
            var attr = filteredAttributes_1_1.value;
            // If sensitive element, only allow certain attributes
            if (isSensitiveElement && !SENSITIVE_ELEMENT_ATTRIBUTE_ALLOWLIST.includes(attr.name)) continue;
            // Finally cast attribute value to string and limit attribute value length
            attributes[attr.name] = String(attr.value).substring(0, MAX_ATTRIBUTE_LENGTH);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (filteredAttributes_1_1 && !filteredAttributes_1_1.done && (_a = filteredAttributes_1.return)) _a.call(filteredAttributes_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    if (Object.keys(attributes).length) properties.attrs = attributes;
    return properties;
}
function getAncestors(targetEl) {
    var ancestors = [];
    if (!targetEl) return ancestors;
    // Add self to the list of ancestors
    ancestors.push(targetEl);
    var current = targetEl.parentElement;
    while(current && current.tagName !== 'HTML'){
        ancestors.push(current);
        current = current.parentElement;
    }
    return ancestors;
}
var getHierarchy = function getHierarchy(element) {
    var hierarchy = [];
    if (!element) return [];
    // Get list of ancestors including itself and get properties at each level in the hierarchy
    var ancestors = getAncestors(element);
    hierarchy = ensureListUnderLimit(ancestors.map(function(el) {
        return getElementProperties(el);
    }), MAX_HIERARCHY_LENGTH);
    return hierarchy;
};
function ensureListUnderLimit(list, bytesLimit) {
    var numChars = 0;
    for(var i = 0; i < list.length; i++){
        var node = list[i];
        if (node === null) // simulate 'None' in python
        numChars += 4;
        else {
            var value = ensureUnicodePythonCompatible(node);
            // Using Array.from(string).length instead of string.length
            // to correctly count Unicode characters (including emojis)
            numChars += value ? Array.from(value).length : 4;
        }
        if (numChars > bytesLimit) return list.slice(0, i);
    }
    return list;
}
function ensureUnicodePythonCompatible(value, nested) {
    if (nested === void 0) nested = false;
    try {
        if (value == null) {
            // Handle null values
            if (nested) return 'None'; // Represent null as 'None' in Python when nested
            return null; // Return null for top-level null values
        } else if (typeof value === 'string') {
            if (nested) {
                // Escape special characters in nested strings
                value = value.replace(/\\/g, '\\\\').replace(/\n/g, '\\n').replace(/\t/g, '\\t').replace(/\r/g, '\\r');
                // Handle quotes in the string
                if (value.includes('"')) return "'".concat(value, "'"); // Wrap in single quotes if it contains double quotes
                if (value.includes("'")) return "\"".concat(value.replace(/'/g, "\\'"), "\""); // Wrap in double quotes and escape single quotes
                return "'".concat(value, "'"); // Default to wrapping in single quotes
            }
            return value; // Return non-nested strings as-is
        } else if (typeof value === 'boolean') // Convert boolean to Python-style capitalized string
        return value ? 'True' : 'False';
        else if (Array.isArray(value)) {
            // Handle arrays by recursively converting each element
            var elements = value.map(function(o) {
                return ensureUnicodePythonCompatible(o, true);
            });
            return "[".concat(elements.join(', '), "]");
        } else if (typeof value === 'object') {
            // Handle objects (dictionaries in Python)
            var entries = Object.entries(value).filter(function(_a) {
                var _b = (0, _tslib.__read)(_a, 1), key = _b[0];
                return key != null;
            }) // Filter out null keys
            .map(function(_a) {
                var _b = (0, _tslib.__read)(_a, 2), key = _b[0], val = _b[1];
                return "".concat(String(ensureUnicodePythonCompatible(key, true)), ": ").concat(String(ensureUnicodePythonCompatible(val, true)));
            });
            var result = "{".concat(entries.join(', '), "}");
            // Handle single quotes in the resulting string
            if (result.includes("\\'")) result = result.replace(/'/g, "'").replace(/'/g, "\\'");
            return result;
        }
        // For any other types, return their string representation;
        return value.toString();
    } catch (e) {
        // Return null if any error occurs during the conversion
        return null;
    }
}

},{"tslib":"C7UIb","./helpers":"8nGGo","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2GtPL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "trackClicks", function() {
    return trackClicks;
});
var _tslib = require("tslib");
var _rxjs = require("rxjs");
var _helpers = require("../helpers");
var _constants = require("../constants");
var RAGE_CLICK_THRESHOLD = 5;
function trackClicks(_a) {
    var amplitude = _a.amplitude, allObservables = _a.allObservables, options = _a.options, shouldTrackEvent = _a.shouldTrackEvent;
    var clickObservable = allObservables.clickObservable;
    // Trigger if the target of the click event has changed and position is different
    // Keeping track of position is important to avoid false positives when the user clicks on the same
    // element where certain frameworks could replace the element instance between rerenders
    var comparisonTrigger = clickObservable.pipe((0, _rxjs.pairwise)(), (0, _rxjs.filter)(function(_a) {
        var _b = (0, _tslib.__read)(_a, 2), prev = _b[0], current = _b[1];
        var targetChanged = prev.event.target !== current.event.target;
        /* istanbul ignore next */ var samePos = Math.abs(current.event.screenX - prev.event.screenX) <= 20 && Math.abs(current.event.screenY - prev.event.screenY) <= 20;
        return targetChanged && !samePos;
    }));
    // Trigger if there is no click event within 1 second
    var timeoutTrigger = clickObservable.pipe((0, _rxjs.debounceTime)(options.debounceTime), (0, _rxjs.map)(function() {
        return 'timeout';
    }));
    var triggers = (0, _rxjs.merge)(comparisonTrigger, timeoutTrigger);
    // Get buffers of clicks, if the buffer length is over 5, it is rage click
    var bufferedClicks = clickObservable.pipe((0, _rxjs.delay)(0), (0, _rxjs.filter)((0, _helpers.filterOutNonTrackableEvents)), (0, _rxjs.filter)(function(click) {
        // Only track clicks on elements that should be tracked,
        return shouldTrackEvent('click', click.closestTrackedAncestor);
    }), (0, _rxjs.buffer)(triggers));
    return bufferedClicks.subscribe(function(clicks) {
        var e_1, _$_a;
        // TODO: update this when rage clicks are added
        var clickType = clicks.length >= RAGE_CLICK_THRESHOLD ? (0, _constants.AMPLITUDE_ELEMENT_CLICKED_EVENT) : (0, _constants.AMPLITUDE_ELEMENT_CLICKED_EVENT);
        try {
            for(var clicks_1 = (0, _tslib.__values)(clicks), clicks_1_1 = clicks_1.next(); !clicks_1_1.done; clicks_1_1 = clicks_1.next()){
                var click = clicks_1_1.value;
                /* istanbul ignore next */ amplitude === null || amplitude === void 0 || amplitude.track(clickType, click.targetElementProperties);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (clicks_1_1 && !clicks_1_1.done && (_$_a = clicks_1.return)) _$_a.call(clicks_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    });
}

},{"tslib":"C7UIb","rxjs":"cqW5P","../helpers":"8nGGo","../constants":"c6uAd","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jFzYn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "trackChange", function() {
    return trackChange;
});
var _rxjs = require("rxjs");
var _helpers = require("../helpers");
var _constants = require("../constants");
function trackChange(_a) {
    var amplitude = _a.amplitude, allObservables = _a.allObservables, getEventProperties = _a.getEventProperties, shouldTrackEvent = _a.shouldTrackEvent;
    var changeObservable = allObservables.changeObservable;
    var filteredChangeObservable = changeObservable.pipe((0, _rxjs.filter)((0, _helpers.filterOutNonTrackableEvents)), (0, _rxjs.filter)(function(changeEvent) {
        // Only track change on elements that should be tracked,
        return shouldTrackEvent('change', changeEvent.closestTrackedAncestor);
    }));
    return filteredChangeObservable.subscribe(function(changeEvent) {
        /* istanbul ignore next */ amplitude === null || amplitude === void 0 || amplitude.track((0, _constants.AMPLITUDE_ELEMENT_CHANGED_EVENT), getEventProperties('change', changeEvent.closestTrackedAncestor));
    });
}

},{"rxjs":"cqW5P","../helpers":"8nGGo","../constants":"c6uAd","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"9lOMB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "trackActionClick", function() {
    return trackActionClick;
});
var _tslib = require("tslib");
var _rxjs = require("rxjs");
var _helpers = require("../helpers");
var _constants = require("../constants");
function trackActionClick(_a) {
    var amplitude = _a.amplitude, allObservables = _a.allObservables, options = _a.options, getEventProperties = _a.getEventProperties, shouldTrackEvent = _a.shouldTrackEvent, shouldTrackActionClick = _a.shouldTrackActionClick;
    var clickObservable = allObservables.clickObservable, mutationObservable = allObservables.mutationObservable, navigateObservable = allObservables.navigateObservable;
    var filteredClickObservable = clickObservable.pipe((0, _rxjs.filter)(function(click) {
        // Filter out regularly tracked click events that are already handled in trackClicks
        return !shouldTrackEvent('click', click.closestTrackedAncestor);
    }), (0, _rxjs.map)(function(click) {
        // overwrite the closestTrackedAncestor with the closest element that is on the actionClickAllowlist
        var closestActionClickEl = (0, _helpers.getClosestElement)(click.event.target, options.actionClickAllowlist);
        click.closestTrackedAncestor = closestActionClickEl;
        // overwrite the targetElementProperties with the properties of the closestActionClickEl
        if (click.closestTrackedAncestor !== null) click.targetElementProperties = getEventProperties(click.type, click.closestTrackedAncestor);
        return click;
    }), (0, _rxjs.filter)((0, _helpers.filterOutNonTrackableEvents)), (0, _rxjs.filter)(function(clickEvent) {
        // Only track change on elements that should be tracked
        return shouldTrackActionClick('click', clickEvent.closestTrackedAncestor);
    }));
    var changeObservables = [
        mutationObservable
    ];
    /* istanbul ignore next */ if (navigateObservable) changeObservables.push(navigateObservable);
    var mutationOrNavigate = (0, _rxjs.merge).apply(void 0, (0, _tslib.__spreadArray)([], (0, _tslib.__read)(changeObservables), false));
    var actionClicks = filteredClickObservable.pipe(// If a mutation occurs within 0.5 seconds of a click event (timeout({ first: 500 })), it emits the original first click event.
    // take 1 to only limit the action events in case there are multiple
    (0, _rxjs.switchMap)(function(click) {
        return mutationOrNavigate.pipe((0, _rxjs.take)(1), (0, _rxjs.timeout)({
            first: 500,
            with: function _with() {
                return 0, _rxjs.EMPTY;
            }
        }), (0, _rxjs.map)(function() {
            return click;
        }));
    }));
    return actionClicks.subscribe(function(actionClick) {
        /* istanbul ignore next */ amplitude === null || amplitude === void 0 || amplitude.track((0, _constants.AMPLITUDE_ELEMENT_CLICKED_EVENT), getEventProperties('click', actionClick.closestTrackedAncestor));
    });
}

},{"tslib":"C7UIb","rxjs":"cqW5P","../helpers":"8nGGo","../constants":"c6uAd","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5GcQ4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WebAttribution", function() {
    return WebAttribution;
});
var _tslib = require("tslib");
var _analyticsCore = require("@amplitude/analytics-core");
var _helpers = require("./helpers");
var _campaignParser = require("./campaign-parser");
var _constants = require("./constants");
var WebAttribution = /** @class */ function() {
    function WebAttribution(options, config) {
        var _a;
        this.shouldTrackNewCampaign = false;
        this.options = (0, _tslib.__assign)({
            initialEmptyValue: 'EMPTY',
            resetSessionOnNewCampaign: false,
            excludeReferrers: (0, _helpers.getDefaultExcludedReferrers)((_a = config.cookieOptions) === null || _a === void 0 ? void 0 : _a.domain)
        }, options);
        this.storage = config.cookieStorage;
        this.storageKey = (0, _analyticsCore.getStorageKey)(config.apiKey, 'MKTG');
        this.currentCampaign = (0, _constants.BASE_CAMPAIGN);
        this.sessionTimeout = config.sessionTimeout;
        this.lastEventTime = config.lastEventTime;
        this.logger = config.loggerProvider;
        config.loggerProvider.log('Installing web attribution tracking.');
    }
    WebAttribution.prototype.init = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            var isEventInNewSession;
            var _a;
            return (0, _tslib.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.fetchCampaign()
                        ];
                    case 1:
                        _a = (0, _tslib.__read).apply(void 0, [
                            _b.sent(),
                            2
                        ]), this.currentCampaign = _a[0], this.previousCampaign = _a[1];
                        isEventInNewSession = !this.lastEventTime ? true : (0, _analyticsCore.isNewSession)(this.sessionTimeout, this.lastEventTime);
                        if (!(0, _helpers.isNewCampaign)(this.currentCampaign, this.previousCampaign, this.options, this.logger, isEventInNewSession)) return [
                            3 /*break*/ ,
                            3
                        ];
                        this.shouldTrackNewCampaign = true;
                        return [
                            4 /*yield*/ ,
                            this.storage.set(this.storageKey, this.currentCampaign)
                        ];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    WebAttribution.prototype.fetchCampaign = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            Promise.all([
                                new (0, _campaignParser.CampaignParser)().parse(),
                                this.storage.get(this.storageKey)
                            ])
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    /**
     * This can be called when enable web attribution and either
     * 1. set a new session
     * 2. has new campaign and enable resetSessionOnNewCampaign
     */ WebAttribution.prototype.generateCampaignEvent = function(event_id) {
        // Mark this campaign has been tracked
        this.shouldTrackNewCampaign = false;
        var campaignEvent = (0, _helpers.createCampaignEvent)(this.currentCampaign, this.options);
        if (event_id) campaignEvent.event_id = event_id;
        return campaignEvent;
    };
    WebAttribution.prototype.shouldSetSessionIdOnNewCampaign = function() {
        return this.shouldTrackNewCampaign && !!this.options.resetSessionOnNewCampaign;
    };
    return WebAttribution;
}();

},{"tslib":"C7UIb","@amplitude/analytics-core":"4c2pj","./helpers":"iFPau","./campaign-parser":"eZofG","./constants":"dWrau","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"iFPau":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isNewCampaign", function() {
    return isNewCampaign;
});
parcelHelpers.export(exports, "isExcludedReferrer", function() {
    return isExcludedReferrer;
});
parcelHelpers.export(exports, "createCampaignEvent", function() {
    return createCampaignEvent;
});
parcelHelpers.export(exports, "getDefaultExcludedReferrers", function() {
    return getDefaultExcludedReferrers;
});
var _tslib = require("tslib");
var _analyticsCore = require("@amplitude/analytics-core");
var _constants = require("./constants");
var domainWithoutSubdomain = function domainWithoutSubdomain(domain) {
    var parts = domain.split('.');
    if (parts.length <= 2) return domain;
    return parts.slice(parts.length - 2, parts.length).join('.');
};
//Direct traffic mean no external referral, no UTMs, no click-ids, and no other customer identified marketing campaign url params.
var isDirectTraffic = function isDirectTraffic(current) {
    return Object.values(current).every(function(value) {
        return !value;
    });
};
var isNewCampaign = function isNewCampaign(current, previous, options, logger, isNewSession) {
    if (isNewSession === void 0) isNewSession = true;
    var referrer = current.referrer, referring_domain = current.referring_domain, currentCampaign = (0, _tslib.__rest)(current, [
        "referrer",
        "referring_domain"
    ]);
    var _a = previous || {}, _previous_referrer = _a.referrer, prevReferringDomain = _a.referring_domain, previousCampaign = (0, _tslib.__rest)(_a, [
        "referrer",
        "referring_domain"
    ]);
    if (isExcludedReferrer(options.excludeReferrers, current.referring_domain)) {
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        logger.debug("This is not a new campaign because ".concat(current.referring_domain, " is in the exclude referrer list."));
        return false;
    }
    //In the same session, direct traffic should not override or unset any persisting query params
    if (!isNewSession && isDirectTraffic(current) && previous) {
        logger.debug('This is not a new campaign because this is a direct traffic in the same session.');
        return false;
    }
    var hasNewCampaign = JSON.stringify(currentCampaign) !== JSON.stringify(previousCampaign);
    var hasNewDomain = domainWithoutSubdomain(referring_domain || '') !== domainWithoutSubdomain(prevReferringDomain || '');
    var result = !previous || hasNewCampaign || hasNewDomain;
    if (!result) logger.debug("This is not a new campaign because it's the same as the previous one.");
    else logger.debug("This is a new campaign. An $identify event will be sent.");
    return result;
};
var isExcludedReferrer = function isExcludedReferrer(excludeReferrers, referringDomain) {
    if (excludeReferrers === void 0) excludeReferrers = [];
    if (referringDomain === void 0) referringDomain = '';
    return excludeReferrers.some(function(value) {
        return value instanceof RegExp ? value.test(referringDomain) : value === referringDomain;
    });
};
var createCampaignEvent = function createCampaignEvent(campaign, options) {
    var campaignParameters = (0, _tslib.__assign)((0, _tslib.__assign)({}, (0, _constants.BASE_CAMPAIGN)), campaign);
    var identifyEvent = Object.entries(campaignParameters).reduce(function(identify, _a) {
        var _b;
        var _c = (0, _tslib.__read)(_a, 2), key = _c[0], value = _c[1];
        identify.setOnce("initial_".concat(key), (_b = value !== null && value !== void 0 ? value : options.initialEmptyValue) !== null && _b !== void 0 ? _b : 'EMPTY');
        if (value) return identify.set(key, value);
        return identify.unset(key);
    }, new (0, _analyticsCore.Identify)());
    return (0, _analyticsCore.createIdentifyEvent)(identifyEvent);
};
var getDefaultExcludedReferrers = function getDefaultExcludedReferrers(cookieDomain) {
    var domain = cookieDomain;
    if (domain) {
        if (domain.startsWith('.')) domain = domain.substring(1);
        return [
            new RegExp("".concat(domain.replace('.', '\\.'), "$"))
        ];
    }
    return [];
};

},{"tslib":"C7UIb","@amplitude/analytics-core":"4c2pj","./constants":"dWrau","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"dWrau":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UTM_CAMPAIGN", function() {
    return UTM_CAMPAIGN;
});
parcelHelpers.export(exports, "UTM_CONTENT", function() {
    return UTM_CONTENT;
});
parcelHelpers.export(exports, "UTM_ID", function() {
    return UTM_ID;
});
parcelHelpers.export(exports, "UTM_MEDIUM", function() {
    return UTM_MEDIUM;
});
parcelHelpers.export(exports, "UTM_SOURCE", function() {
    return UTM_SOURCE;
});
parcelHelpers.export(exports, "UTM_TERM", function() {
    return UTM_TERM;
});
parcelHelpers.export(exports, "DCLID", function() {
    return DCLID;
});
parcelHelpers.export(exports, "FBCLID", function() {
    return FBCLID;
});
parcelHelpers.export(exports, "GBRAID", function() {
    return GBRAID;
});
parcelHelpers.export(exports, "GCLID", function() {
    return GCLID;
});
parcelHelpers.export(exports, "KO_CLICK_ID", function() {
    return KO_CLICK_ID;
});
parcelHelpers.export(exports, "LI_FAT_ID", function() {
    return LI_FAT_ID;
});
parcelHelpers.export(exports, "MSCLKID", function() {
    return MSCLKID;
});
parcelHelpers.export(exports, "RDT_CID", function() {
    return RDT_CID;
});
parcelHelpers.export(exports, "TTCLID", function() {
    return TTCLID;
});
parcelHelpers.export(exports, "TWCLID", function() {
    return TWCLID;
});
parcelHelpers.export(exports, "WBRAID", function() {
    return WBRAID;
});
parcelHelpers.export(exports, "EMPTY_VALUE", function() {
    return EMPTY_VALUE;
});
parcelHelpers.export(exports, "BASE_CAMPAIGN", function() {
    return BASE_CAMPAIGN;
});
parcelHelpers.export(exports, "MKTG", function() {
    return MKTG;
});
var UTM_CAMPAIGN = 'utm_campaign';
var UTM_CONTENT = 'utm_content';
var UTM_ID = 'utm_id';
var UTM_MEDIUM = 'utm_medium';
var UTM_SOURCE = 'utm_source';
var UTM_TERM = 'utm_term';
var DCLID = 'dclid';
var FBCLID = 'fbclid';
var GBRAID = 'gbraid';
var GCLID = 'gclid';
var KO_CLICK_ID = 'ko_click_id';
var LI_FAT_ID = 'li_fat_id';
var MSCLKID = 'msclkid';
var RDT_CID = 'rtd_cid';
var TTCLID = 'ttclid';
var TWCLID = 'twclid';
var WBRAID = 'wbraid';
var EMPTY_VALUE = 'EMPTY';
var BASE_CAMPAIGN = {
    utm_campaign: undefined,
    utm_content: undefined,
    utm_id: undefined,
    utm_medium: undefined,
    utm_source: undefined,
    utm_term: undefined,
    referrer: undefined,
    referring_domain: undefined,
    dclid: undefined,
    gbraid: undefined,
    gclid: undefined,
    fbclid: undefined,
    ko_click_id: undefined,
    li_fat_id: undefined,
    msclkid: undefined,
    rtd_cid: undefined,
    ttclid: undefined,
    twclid: undefined,
    wbraid: undefined
};
var MKTG = 'MKTG';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"eZofG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CampaignParser", function() {
    return CampaignParser;
});
var _tslib = require("tslib");
var _analyticsCore = require("@amplitude/analytics-core");
var _constants = require("./constants");
var CampaignParser = /** @class */ function() {
    function CampaignParser() {}
    CampaignParser.prototype.parse = function() {
        return (0, _tslib.__awaiter)(this, void 0, void 0, function() {
            return (0, _tslib.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    (0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)((0, _tslib.__assign)({}, (0, _constants.BASE_CAMPAIGN)), this.getUtmParam()), this.getReferrer()), this.getClickIds())
                ];
            });
        });
    };
    CampaignParser.prototype.getUtmParam = function() {
        var params = (0, _analyticsCore.getQueryParams)();
        var utmCampaign = params[0, _constants.UTM_CAMPAIGN];
        var utmContent = params[0, _constants.UTM_CONTENT];
        var utmId = params[0, _constants.UTM_ID];
        var utmMedium = params[0, _constants.UTM_MEDIUM];
        var utmSource = params[0, _constants.UTM_SOURCE];
        var utmTerm = params[0, _constants.UTM_TERM];
        return {
            utm_campaign: utmCampaign,
            utm_content: utmContent,
            utm_id: utmId,
            utm_medium: utmMedium,
            utm_source: utmSource,
            utm_term: utmTerm
        };
    };
    CampaignParser.prototype.getReferrer = function() {
        var _a, _b;
        var data = {
            referrer: undefined,
            referring_domain: undefined
        };
        try {
            data.referrer = document.referrer || undefined;
            data.referring_domain = (_b = (_a = data.referrer) === null || _a === void 0 ? void 0 : _a.split('/')[2]) !== null && _b !== void 0 ? _b : undefined;
        } catch (_c) {
        // nothing to track
        }
        return data;
    };
    CampaignParser.prototype.getClickIds = function() {
        var _a;
        var params = (0, _analyticsCore.getQueryParams)();
        return _a = {}, _a[0, _constants.DCLID] = params[0, _constants.DCLID], _a[0, _constants.FBCLID] = params[0, _constants.FBCLID], _a[0, _constants.GBRAID] = params[0, _constants.GBRAID], _a[0, _constants.GCLID] = params[0, _constants.GCLID], _a[0, _constants.KO_CLICK_ID] = params[0, _constants.KO_CLICK_ID], _a[0, _constants.LI_FAT_ID] = params[0, _constants.LI_FAT_ID], _a[0, _constants.MSCLKID] = params[0, _constants.MSCLKID], _a[0, _constants.RDT_CID] = params[0, _constants.RDT_CID], _a[0, _constants.TTCLID] = params[0, _constants.TTCLID], _a[0, _constants.TWCLID] = params[0, _constants.TWCLID], _a[0, _constants.WBRAID] = params[0, _constants.WBRAID], _a;
    };
    return CampaignParser;
}();

},{"tslib":"C7UIb","@amplitude/analytics-core":"4c2pj","./constants":"dWrau","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"ePjGe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OrderHistoryDetails", function() {
    return OrderHistoryDetails;
});
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _ordersHistoryDetailsView = require("../../../../../app/views/ordersHistoryDetailsView");
var _reactRouterDom = require("react-router-dom");
var _layout = require("../Layout");
var _hooks = require("../../../../../std/hooks");
var _loadAccountSaga = require("../../../../../app/sagas/loadAccountSaga");
var _orderDetails = require("../OrderDetails/OrderDetails");
function OrderHistoryDetails() {
    var orderId = useOrderId();
    var view = (0, _reactRedux.useSelector)((0, _ordersHistoryDetailsView.orderHistoryDetailsView)(orderId));
    var dispatch = (0, _hooks.useDispatch)();
    var isLoading = !view;
    (0, _react.useEffect)(function() {
        dispatch((0, _loadAccountSaga.LoadAccount)());
    }, []);
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _layout.Layout), {
        page: (0, _layout.Page).OrderHistoryDetails,
        isLoading: isLoading,
        children: view && /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _orderDetails.OrderDetails), {
            view: view,
            backCta: {
                text: `Retour aux commandes`,
                linkTo: '/pages/commandes'
            }
        }, void 0, false, {
            fileName: "src/script/src/dom/views/Account/views/OrderHistoryList/OrderHistoryDetails.tsx",
            lineNumber: 20,
            columnNumber: 22
        }, this)
    }, void 0, false, {
        fileName: "src/script/src/dom/views/Account/views/OrderHistoryList/OrderHistoryDetails.tsx",
        lineNumber: 19,
        columnNumber: 9
    }, this);
}
function useOrderId() {
    return Number((0, _reactRouterDom.useParams)().orderId);
}

},{"react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","react-redux":"ghMZu","../../../../../app/views/ordersHistoryDetailsView":"2LJ9N","react-router-dom":"9VDGr","../Layout":"gnkXt","../../../../../std/hooks":"j9RPQ","../../../../../app/sagas/loadAccountSaga":"fo1BR","../OrderDetails/OrderDetails":"x9f1w","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2LJ9N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "orderHistoryDetailsView", function() {
    return orderHistoryDetailsView;
});
var _reselect = require("reselect");
var _orders = require("../store/state/data/orders");
var _variants = require("../store/state/data/variants");
var _prepareOrderView = require("./services/prepareOrderView");
function orderHistoryDetailsView(orderId) {
    return (0, _reselect.createSelector)(function() {
        return orderId;
    }, (0, _orders.ordersSelector), (0, _variants.variantsSelector), prepareView);
}
function prepareView(orderId, ordersState, variantsState) {
    var order = selectOrder();
    if (!order) return null;
    return (0, _prepareOrderView.prepareOrderView)(order, variantsState);
    function selectOrder() {
        var orders = ordersState.entities;
        var _find;
        return (_find = (orders !== null && orders !== void 0 ? orders : []).find(function(order) {
            return order.id === orderId;
        })) !== null && _find !== void 0 ? _find : null;
    }
}

},{"reselect":"fb6q1","../store/state/data/orders":"4hVLS","../store/state/data/variants":"11hc8","./services/prepareOrderView":"4Ug3S","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4Ug3S":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "prepareOrderView", function() {
    return prepareOrderView;
});
function prepareOrderView(order, variantsState) {
    return prepareOrder();
    function prepareOrder() {
        return {
            orderId: order.id,
            number: order.number,
            invoiceDownloadLink: order.invoiceDownloadLink,
            shippingAddress: order.shippingAddress,
            discountCode: order.discountCode,
            totals: {
                subTotal: order.cartPrice,
                discount: order.discountPrice,
                shipping: order.shippingPrice,
                taxes: order.taxPrice,
                total: order.orderPrice,
                refund: order.refundPrice
            },
            date: order.date,
            lines: prepareLines(),
            status: order.status,
            trackingLinks: prepareTrackingLinks()
        };
    }
    function prepareLines() {
        return order.itemsLines.map(prepareLine);
    }
    function prepareLine(line) {
        var variant = selectVariant(line.variantId);
        var _variant_productTitle, _variant_variantTitle;
        return {
            title: (_variant_productTitle = variant === null || variant === void 0 ? void 0 : variant.productTitle) !== null && _variant_productTitle !== void 0 ? _variant_productTitle : line.title,
            variantTitle: (_variant_variantTitle = variant === null || variant === void 0 ? void 0 : variant.variantTitle) !== null && _variant_variantTitle !== void 0 ? _variant_variantTitle : '',
            originalPrice: line.originalPrice,
            price: line.price,
            picture: line.picture,
            quantity: line.quantity
        };
    }
    function prepareTrackingLinks() {
        if (!order.shippingTrackings) return [];
        return order.shippingTrackings.map(function(tracking) {
            return tracking.url;
        });
    }
    function selectVariant(variantId) {
        var _variantsState_entities_find;
        return (_variantsState_entities_find = variantsState.entities.find(function(variant) {
            return variant.variantId === variantId;
        })) !== null && _variantsState_entities_find !== void 0 ? _variantsState_entities_find : null;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"x9f1w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OrderDetails", function() {
    return OrderDetails;
});
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _fp = require("date-fns/fp");
var _statusLabel = require("../../functions/statusLabel");
var _price = require("../../../../../std/price");
var _reactRouterDom = require("react-router-dom");
var _useShopifyAsset = require("../../../../hooks/useShopifyAsset");
var _prepareShippingAddress = require("../../functions/prepareShippingAddress");
var _hooks = require("../../../../../std/hooks");
var _loadAccountSaga = require("../../../../../app/sagas/loadAccountSaga");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
function OrderDetails(props) {
    var view = props.view;
    var shopifyAsset = (0, _useShopifyAsset.useShopifyAsset)();
    var dispatch = (0, _hooks.useDispatch)();
    (0, _react.useEffect)(function() {
        dispatch((0, _loadAccountSaga.LoadAccount)());
    }, []);
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
        className: "orderDetails",
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _reactRouterDom.Link), {
                to: props.backCta.linkTo,
                className: "orderDetails_backCta",
                children: [
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("img", {
                        src: shopifyAsset('image_icon_arrow_previous_blue_base.svg')
                    }, void 0, false, {
                        fileName: "src/script/src/dom/views/Account/views/OrderDetails/OrderDetails.tsx",
                        lineNumber: 29,
                        columnNumber: 17
                    }, this),
                    props.backCta.text
                ]
            }, void 0, true, {
                fileName: "src/script/src/dom/views/Account/views/OrderDetails/OrderDetails.tsx",
                lineNumber: 28,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                className: "orderDetails_container",
                children: [
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                        className: "orderDetails_header",
                        children: [
                            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(Ids, {
                                view: view
                            }, void 0, false, {
                                fileName: "src/script/src/dom/views/Account/views/OrderDetails/OrderDetails.tsx",
                                lineNumber: 34,
                                columnNumber: 21
                            }, this),
                            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(StatusAndActions, {
                                view: view
                            }, void 0, false, {
                                fileName: "src/script/src/dom/views/Account/views/OrderDetails/OrderDetails.tsx",
                                lineNumber: 35,
                                columnNumber: 21
                            }, this),
                            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(Carrier, {
                                view: view
                            }, void 0, false, {
                                fileName: "src/script/src/dom/views/Account/views/OrderDetails/OrderDetails.tsx",
                                lineNumber: 36,
                                columnNumber: 21
                            }, this),
                            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(AddressBlock, {
                                view: view
                            }, void 0, false, {
                                fileName: "src/script/src/dom/views/Account/views/OrderDetails/OrderDetails.tsx",
                                lineNumber: 37,
                                columnNumber: 21
                            }, this)
                        ]
                    }, void 0, true, {
                        fileName: "src/script/src/dom/views/Account/views/OrderDetails/OrderDetails.tsx",
                        lineNumber: 33,
                        columnNumber: 17
                    }, this),
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                        className: "orderDetails_lines",
                        children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(Lines, {
                            view: view
                        }, void 0, false, {
                            fileName: "src/script/src/dom/views/Account/views/OrderDetails/OrderDetails.tsx",
                            lineNumber: 40,
                            columnNumber: 21
                        }, this)
                    }, void 0, false, {
                        fileName: "src/script/src/dom/views/Account/views/OrderDetails/OrderDetails.tsx",
                        lineNumber: 39,
                        columnNumber: 17
                    }, this),
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                        className: "orderDetails_totals",
                        children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(Total, {
                            view: view
                        }, void 0, false, {
                            fileName: "src/script/src/dom/views/Account/views/OrderDetails/OrderDetails.tsx",
                            lineNumber: 43,
                            columnNumber: 21
                        }, this)
                    }, void 0, false, {
                        fileName: "src/script/src/dom/views/Account/views/OrderDetails/OrderDetails.tsx",
                        lineNumber: 42,
                        columnNumber: 17
                    }, this)
                ]
            }, void 0, true, {
                fileName: "src/script/src/dom/views/Account/views/OrderDetails/OrderDetails.tsx",
                lineNumber: 32,
                columnNumber: 13
            }, this)
        ]
    }, void 0, true, {
        fileName: "src/script/src/dom/views/Account/views/OrderDetails/OrderDetails.tsx",
        lineNumber: 27,
        columnNumber: 9
    }, this);
}
function StatusAndActions(props) {
    var view = props.view;
    function renderStatusOrTrackingLing() {
        if (view.trackingLinks.length === 0) return renderStatus();
        return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("p", {
            children: view.trackingLinks.map(renderTrackingLink)
        }, void 0, false, {
            fileName: "src/script/src/dom/views/Account/views/OrderDetails/OrderDetails.tsx",
            lineNumber: 59,
            columnNumber: 16
        }, this);
    }
    function renderTrackingLink(link, index) {
        var title = view.trackingLinks.length > 1 ? `Suivre le colis ${index + 1}` : `Suivre mon colis`;
        return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _react.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("a", {
                    href: link,
                    target: "_blank",
                    children: title
                }, void 0, false, {
                    fileName: "src/script/src/dom/views/Account/views/OrderDetails/OrderDetails.tsx",
                    lineNumber: 64,
                    columnNumber: 38
                }, this),
                /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("br", {}, void 0, false, {
                    fileName: "src/script/src/dom/views/Account/views/OrderDetails/OrderDetails.tsx",
                    lineNumber: 64,
                    columnNumber: 80
                }, this)
            ]
        }, link, true, {
            fileName: "src/script/src/dom/views/Account/views/OrderDetails/OrderDetails.tsx",
            lineNumber: 64,
            columnNumber: 16
        }, this);
    }
    function renderStatus() {
        return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("p", {
            children: (0, _statusLabel.statusLabel)(view.status)
        }, void 0, false, {
            fileName: "src/script/src/dom/views/Account/views/OrderDetails/OrderDetails.tsx",
            lineNumber: 68,
            columnNumber: 16
        }, this);
    }
    function renderDownloadInvoice() {
        return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("p", {
            children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("a", {
                href: view.invoiceDownloadLink,
                target: "_blank",
                children: "T\xe9l\xe9charger ma facture"
            }, void 0, false, {
                fileName: "src/script/src/dom/views/Account/views/OrderDetails/OrderDetails.tsx",
                lineNumber: 72,
                columnNumber: 19
            }, this)
        }, void 0, false, {
            fileName: "src/script/src/dom/views/Account/views/OrderDetails/OrderDetails.tsx",
            lineNumber: 72,
            columnNumber: 16
        }, this);
    }
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
        children: [
            renderStatusOrTrackingLing(),
            renderDownloadInvoice()
        ]
    }, void 0, true, {
        fileName: "src/script/src/dom/views/Account/views/OrderDetails/OrderDetails.tsx",
        lineNumber: 76,
        columnNumber: 9
    }, this);
}
function Ids(props) {
    var view = props.view;
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("p", {
        children: [
            "Commande ",
            view.number,
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("br", {}, void 0, false, {
                fileName: "src/script/src/dom/views/Account/views/OrderDetails/OrderDetails.tsx",
                lineNumber: 90,
                columnNumber: 35
            }, this),
            "le ",
            (0, _fp.format)('dd/MM/yyyy')(view.date)
        ]
    }, void 0, true, {
        fileName: "src/script/src/dom/views/Account/views/OrderDetails/OrderDetails.tsx",
        lineNumber: 89,
        columnNumber: 9
    }, this);
}
function Carrier(props) {
    var view = props.view;
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("p", {
                className: "orderDetails_subtitle",
                children: "Mode de livraison"
            }, void 0, false, {
                fileName: "src/script/src/dom/views/Account/views/OrderDetails/OrderDetails.tsx",
                lineNumber: 104,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("p", {
                children: view.shippingAddress.carrier
            }, void 0, false, {
                fileName: "src/script/src/dom/views/Account/views/OrderDetails/OrderDetails.tsx",
                lineNumber: 105,
                columnNumber: 13
            }, this)
        ]
    }, void 0, true, {
        fileName: "src/script/src/dom/views/Account/views/OrderDetails/OrderDetails.tsx",
        lineNumber: 103,
        columnNumber: 9
    }, this);
}
function AddressBlock(props) {
    var view = props.view;
    var _prepareShippingAddress1 = (0, _prepareShippingAddress.prepareShippingAddress)(view.shippingAddress), address = _prepareShippingAddress1.address, title = _prepareShippingAddress1.title;
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _jsxDevRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("p", {
                className: "orderDetails_subtitle",
                children: title
            }, void 0, false, {
                fileName: "src/script/src/dom/views/Account/views/OrderDetails/OrderDetails.tsx",
                lineNumber: 118,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("p", {
                children: address
            }, void 0, false, {
                fileName: "src/script/src/dom/views/Account/views/OrderDetails/OrderDetails.tsx",
                lineNumber: 119,
                columnNumber: 13
            }, this)
        ]
    }, void 0, true);
}
function Lines(props) {
    var view = props.view;
    function renderLine(line, index) {
        return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _react.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                    children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("img", {
                        src: line.picture
                    }, void 0, false, {
                        fileName: "src/script/src/dom/views/Account/views/OrderDetails/OrderDetails.tsx",
                        lineNumber: 133,
                        columnNumber: 22
                    }, this)
                }, void 0, false, {
                    fileName: "src/script/src/dom/views/Account/views/OrderDetails/OrderDetails.tsx",
                    lineNumber: 133,
                    columnNumber: 17
                }, this),
                /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                    children: [
                        /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                            className: "orderDetails_subtitle",
                            children: line.title
                        }, void 0, false, {
                            fileName: "src/script/src/dom/views/Account/views/OrderDetails/OrderDetails.tsx",
                            lineNumber: 135,
                            columnNumber: 21
                        }, this),
                        line.variantTitle && /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                            children: line.variantTitle
                        }, void 0, false, {
                            fileName: "src/script/src/dom/views/Account/views/OrderDetails/OrderDetails.tsx",
                            lineNumber: 136,
                            columnNumber: 43
                        }, this)
                    ]
                }, void 0, true, {
                    fileName: "src/script/src/dom/views/Account/views/OrderDetails/OrderDetails.tsx",
                    lineNumber: 134,
                    columnNumber: 17
                }, this),
                /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                    children: [
                        "x",
                        line.quantity
                    ]
                }, void 0, true, {
                    fileName: "src/script/src/dom/views/Account/views/OrderDetails/OrderDetails.tsx",
                    lineNumber: 138,
                    columnNumber: 17
                }, this),
                /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                    children: renderOriginalPrice(line)
                }, void 0, false, {
                    fileName: "src/script/src/dom/views/Account/views/OrderDetails/OrderDetails.tsx",
                    lineNumber: 139,
                    columnNumber: 17
                }, this),
                /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                    children: (0, _price.formatPrice)(line.price)
                }, void 0, false, {
                    fileName: "src/script/src/dom/views/Account/views/OrderDetails/OrderDetails.tsx",
                    lineNumber: 140,
                    columnNumber: 17
                }, this)
            ]
        }, index, true, {
            fileName: "src/script/src/dom/views/Account/views/OrderDetails/OrderDetails.tsx",
            lineNumber: 132,
            columnNumber: 13
        }, this);
    }
    function renderOriginalPrice(line) {
        if (line.originalPrice === line.price) return;
        return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("span", {
            className: "orderDetails_lineOriginalPrice",
            children: (0, _price.formatPrice)(line.originalPrice)
        }, void 0, false, {
            fileName: "src/script/src/dom/views/Account/views/OrderDetails/OrderDetails.tsx",
            lineNumber: 150,
            columnNumber: 13
        }, this);
    }
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _jsxDevRuntime.Fragment), {
        children: view.lines.map(renderLine)
    }, void 0, false);
}
function Total(props) {
    var view = props.view;
    function renderLines() {
        var _this = this;
        return prepareLines().map(function(line) {
            return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("tr", {
                className: (0, _classnamesDefault.default)({
                    'orderDetails_totals__line--bold': line.bold
                }),
                children: [
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("td", {
                        children: line.label
                    }, void 0, false, {
                        fileName: "src/script/src/dom/views/Account/views/OrderDetails/OrderDetails.tsx",
                        lineNumber: 177,
                        columnNumber: 17
                    }, _this),
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("td", {
                        children: (0, _price.formatPrice)(line.amount)
                    }, void 0, false, {
                        fileName: "src/script/src/dom/views/Account/views/OrderDetails/OrderDetails.tsx",
                        lineNumber: 178,
                        columnNumber: 17
                    }, _this)
                ]
            }, line.label, true, {
                fileName: "src/script/src/dom/views/Account/views/OrderDetails/OrderDetails.tsx",
                lineNumber: 176,
                columnNumber: 13
            }, _this);
        });
    }
    function prepareLines() {
        var lines = [];
        lines.push({
            label: 'Sous-total',
            amount: view.totals.subTotal
        });
        if (view.totals.discount > 0) {
            var label = "R\xe9duction" + (view.discountCode && ` (${view.discountCode})`);
            lines.push({
                label: label,
                amount: view.totals.discount
            });
        }
        lines.push({
            label: 'Livraison',
            amount: view.totals.shipping
        });
        lines.push({
            label: 'TVA',
            amount: view.totals.taxes
        });
        lines.push({
            label: 'Total',
            amount: view.totals.total,
            bold: true
        });
        if (view.totals.refund > 0) lines.push({
            label: 'Remboursement',
            amount: view.totals.refund
        });
        return lines;
    }
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("table", {
        children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("tbody", {
            children: renderLines()
        }, void 0, false, {
            fileName: "src/script/src/dom/views/Account/views/OrderDetails/OrderDetails.tsx",
            lineNumber: 201,
            columnNumber: 13
        }, this)
    }, void 0, false, {
        fileName: "src/script/src/dom/views/Account/views/OrderDetails/OrderDetails.tsx",
        lineNumber: 200,
        columnNumber: 9
    }, this);
}

},{"react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","date-fns/fp":"lVPZP","../../functions/statusLabel":"dlTaP","../../../../../std/price":"bpfMV","react-router-dom":"9VDGr","../../../../hooks/useShopifyAsset":"aJ4wV","../../functions/prepareShippingAddress":"4WRgM","../../../../../std/hooks":"j9RPQ","../../../../../app/sagas/loadAccountSaga":"fo1BR","classnames":"4SuBi","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4WRgM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "prepareShippingAddress", function() {
    return prepareShippingAddress;
});
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function prepareShippingAddress(address) {
    function renderLine(line) {
        if (line) return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _jsxDevRuntime.Fragment), {
            children: [
                line,
                /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("br", {}, void 0, false, {
                    fileName: "src/script/src/dom/views/Account/functions/prepareShippingAddress.tsx",
                    lineNumber: 24,
                    columnNumber: 28
                }, this)
            ]
        }, void 0, true);
        return null;
    }
    function prepareName() {
        return `${address.firstName} ${address.lastName}`.trim();
    }
    function renderTitle() {
        if (address.pickUpPoint) return 'Point relais';
        return 'Adresse de livraison';
    }
    function renderAddress() {
        if (address.pickUpPoint) return renderPickUpAddress(address.pickUpPoint);
        return renderHomeAddress();
    }
    function renderPickUpAddress(pickUp) {
        return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _jsxDevRuntime.Fragment), {
            children: [
                renderLine(pickUp.name),
                renderLine(pickUp.address),
                renderLine(`${pickUp.zipCode} ${pickUp.city}`)
            ]
        }, void 0, true);
    }
    function renderHomeAddress() {
        return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _jsxDevRuntime.Fragment), {
            children: [
                renderLine(prepareName()),
                renderLine(address.address1),
                renderLine(address.address2),
                renderLine(`${address.zipCode} ${address.city}`)
            ]
        }, void 0, true);
    }
    return {
        title: renderTitle(),
        address: renderAddress()
    };
}

},{"react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"lUAoT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Subscription", function() {
    return Subscription;
});
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _paymentMethodError = require("./PaymentMethodError");
var _nextOrder = require("./NextOrder");
var _starter = require("./Starter");
var _customerHelp = require("./CustomerHelp");
var _layout = require("../Layout");
var _hooks = require("../../../../../std/hooks");
var _loadAccountSaga = require("../../../../../app/sagas/loadAccountSaga");
var _details = require("./Details");
var _reactRedux = require("react-redux");
var _mySubscriptionView = require("../../../../../app/views/mySubscriptionView");
var _lastOrder = require("./LastOrder");
function Subscription() {
    var dispatch = (0, _hooks.useDispatch)();
    var view = (0, _reactRedux.useSelector)((0, _mySubscriptionView.mySubscriptionView));
    (0, _react.useEffect)(function() {
        dispatch((0, _loadAccountSaga.LoadAccount)());
    }, []);
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _layout.Layout), {
        page: (0, _layout.Page).Subscription,
        isLoading: view.state === 'loading',
        children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
            className: "accountSubscription",
            children: [
                view.state === 'activeSubscription' && /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _jsxDevRuntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("h3", {
                            className: "accountSubscription_title",
                            children: "Mon abonnement"
                        }, void 0, false, {
                            fileName: "src/script/src/dom/views/Account/views/Subscription/Subscription.tsx",
                            lineNumber: 24,
                            columnNumber: 21
                        }, this),
                        /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _paymentMethodError.PaymentMethodError), {}, void 0, false, {
                            fileName: "src/script/src/dom/views/Account/views/Subscription/Subscription.tsx",
                            lineNumber: 25,
                            columnNumber: 21
                        }, this),
                        /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _details.Details), {
                            view: view
                        }, void 0, false, {
                            fileName: "src/script/src/dom/views/Account/views/Subscription/Subscription.tsx",
                            lineNumber: 26,
                            columnNumber: 21
                        }, this),
                        /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _lastOrder.LastOrder), {}, void 0, false, {
                            fileName: "src/script/src/dom/views/Account/views/Subscription/Subscription.tsx",
                            lineNumber: 27,
                            columnNumber: 21
                        }, this),
                        /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _nextOrder.NextOrder), {
                            view: view
                        }, void 0, false, {
                            fileName: "src/script/src/dom/views/Account/views/Subscription/Subscription.tsx",
                            lineNumber: 28,
                            columnNumber: 21
                        }, this),
                        /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _customerHelp.CustomerHelp), {}, void 0, false, {
                            fileName: "src/script/src/dom/views/Account/views/Subscription/Subscription.tsx",
                            lineNumber: 29,
                            columnNumber: 21
                        }, this)
                    ]
                }, void 0, true),
                view.state === 'inactiveSubscription' && /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _jsxDevRuntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _starter.Starter), {}, void 0, false, {
                            fileName: "src/script/src/dom/views/Account/views/Subscription/Subscription.tsx",
                            lineNumber: 32,
                            columnNumber: 21
                        }, this),
                        /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _customerHelp.CustomerHelp), {}, void 0, false, {
                            fileName: "src/script/src/dom/views/Account/views/Subscription/Subscription.tsx",
                            lineNumber: 33,
                            columnNumber: 21
                        }, this)
                    ]
                }, void 0, true)
            ]
        }, void 0, true, {
            fileName: "src/script/src/dom/views/Account/views/Subscription/Subscription.tsx",
            lineNumber: 22,
            columnNumber: 13
        }, this)
    }, void 0, false, {
        fileName: "src/script/src/dom/views/Account/views/Subscription/Subscription.tsx",
        lineNumber: 21,
        columnNumber: 9
    }, this);
}

},{"react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","./PaymentMethodError":"2OVma","./NextOrder":"hBP5H","./Starter":"7hmRR","./CustomerHelp":"5tghw","../Layout":"gnkXt","../../../../../std/hooks":"j9RPQ","../../../../../app/sagas/loadAccountSaga":"fo1BR","./Details":"calNm","react-redux":"ghMZu","../../../../../app/views/mySubscriptionView":"gDy3a","./LastOrder":"6gNLC","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2OVma":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PaymentMethodError", function() {
    return PaymentMethodError;
});
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _preparePaymentErrorMessage = require("../../functions/preparePaymentErrorMessage");
var _updatePaymentMethodCta = require("../../components/UpdatePaymentMethodCta");
var _std = require("@reglo/std");
var _reactRedux = require("react-redux");
var _paymentMethodErrorView = require("../../../../../app/views/paymentMethodErrorView");
function PaymentMethodError() {
    var _this = this;
    var view = (0, _reactRedux.useSelector)((0, _paymentMethodErrorView.paymentMethodErrorView));
    if (!view) return null;
    var renderPaymentMethod = function() {
        var methodDetails = view.methodDetails;
        if (methodDetails.type === 'CREDIT_CARD') return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _jsxDevRuntime.Fragment), {
            children: [
                methodDetails.brand,
                " terminant par **** ",
                methodDetails.lastDigits,
                /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("br", {}, void 0, false, {
                    fileName: "src/script/src/dom/views/Account/views/Subscription/PaymentMethodError.tsx",
                    lineNumber: 20,
                    columnNumber: 88
                }, _this),
                "Expire le ",
                (0, _std.addLeadingZeros)(methodDetails.expirationMonth, 2),
                "/",
                methodDetails.expirationYear
            ]
        }, void 0, true);
        return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _jsxDevRuntime.Fragment), {
            children: [
                "Compte PayPal de ",
                methodDetails.email
            ]
        }, void 0, true);
    };
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
        className: "accountSubscriptionPaymentMethodError",
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                className: "cardTitle",
                children: "Paiement refus\xe9"
            }, void 0, false, {
                fileName: "src/script/src/dom/views/Account/views/Subscription/PaymentMethodError.tsx",
                lineNumber: 34,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                children: [
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("p", {
                        children: "Le paiement de votre nouvelle livraison a \xe9t\xe9 refus\xe9. Nous vous invitons \xe0 mettre \xe0 jour votre moyen de paiement ou \xe0 nous contacter pour d\xe9bloquer l'exp\xe9dition."
                    }, void 0, false, {
                        fileName: "src/script/src/dom/views/Account/views/Subscription/PaymentMethodError.tsx",
                        lineNumber: 36,
                        columnNumber: 17
                    }, this),
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                        className: "detail",
                        children: [
                            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("p", {
                                        className: "detailTitle",
                                        children: "Mon moyen de paiement"
                                    }, void 0, false, {
                                        fileName: "src/script/src/dom/views/Account/views/Subscription/PaymentMethodError.tsx",
                                        lineNumber: 41,
                                        columnNumber: 25
                                    }, this),
                                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("p", {
                                        children: renderPaymentMethod()
                                    }, void 0, false, {
                                        fileName: "src/script/src/dom/views/Account/views/Subscription/PaymentMethodError.tsx",
                                        lineNumber: 42,
                                        columnNumber: 25
                                    }, this)
                                ]
                            }, void 0, true, {
                                fileName: "src/script/src/dom/views/Account/views/Subscription/PaymentMethodError.tsx",
                                lineNumber: 40,
                                columnNumber: 21
                            }, this),
                            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("p", {
                                        className: "detailTitle",
                                        children: "Derni\xe8re tentative"
                                    }, void 0, false, {
                                        fileName: "src/script/src/dom/views/Account/views/Subscription/PaymentMethodError.tsx",
                                        lineNumber: 45,
                                        columnNumber: 25
                                    }, this),
                                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("p", {
                                        children: [
                                            (0, _std.formatDate)(view.errorDate, {
                                                withTime: true,
                                                withYear: true,
                                                withShortMonth: true
                                            }),
                                            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("br", {}, void 0, false, {
                                                fileName: "src/script/src/dom/views/Account/views/Subscription/PaymentMethodError.tsx",
                                                lineNumber: 51,
                                                columnNumber: 32
                                            }, this),
                                            view.error && `Message\xa0: ${(0, _preparePaymentErrorMessage.preparePaymentErrorMessage)(view.error)}`
                                        ]
                                    }, void 0, true, {
                                        fileName: "src/script/src/dom/views/Account/views/Subscription/PaymentMethodError.tsx",
                                        lineNumber: 46,
                                        columnNumber: 25
                                    }, this)
                                ]
                            }, void 0, true, {
                                fileName: "src/script/src/dom/views/Account/views/Subscription/PaymentMethodError.tsx",
                                lineNumber: 44,
                                columnNumber: 21
                            }, this)
                        ]
                    }, void 0, true, {
                        fileName: "src/script/src/dom/views/Account/views/Subscription/PaymentMethodError.tsx",
                        lineNumber: 39,
                        columnNumber: 17
                    }, this)
                ]
            }, void 0, true, {
                fileName: "src/script/src/dom/views/Account/views/Subscription/PaymentMethodError.tsx",
                lineNumber: 35,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _updatePaymentMethodCta.UpdatePaymentMethodCta), {}, void 0, false, {
                fileName: "src/script/src/dom/views/Account/views/Subscription/PaymentMethodError.tsx",
                lineNumber: 57,
                columnNumber: 13
            }, this)
        ]
    }, void 0, true, {
        fileName: "src/script/src/dom/views/Account/views/Subscription/PaymentMethodError.tsx",
        lineNumber: 33,
        columnNumber: 9
    }, this);
}

},{"react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","../../functions/preparePaymentErrorMessage":"uv4f0","../../components/UpdatePaymentMethodCta":"8QdZK","@reglo/std":"1USo0","react-redux":"ghMZu","../../../../../app/views/paymentMethodErrorView":"7IlcY","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"uv4f0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "preparePaymentErrorMessage", function() {
    return preparePaymentErrorMessage;
});
var _paymentMethod = require("../../../../app/entities/PaymentMethod");
function preparePaymentErrorMessage(error) {
    switch(error){
        case (0, _paymentMethod.PaymentMethodError).SubscriptionNotSupported:
            return `Carte incompatible avec l'abonnement`;
        case (0, _paymentMethod.PaymentMethodError).ExpiredCard:
            return "Carte expir\xe9e";
        case (0, _paymentMethod.PaymentMethodError).InsufficientFunds:
            return 'Fonds insuffisants';
        case (0, _paymentMethod.PaymentMethodError).RefusedPayment:
        case null:
            return "Paiement refus\xe9";
    }
}

},{"../../../../app/entities/PaymentMethod":"5OJGM","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5OJGM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PaymentMethodError", function() {
    return PaymentMethodError;
});
var PaymentMethodError = /*#__PURE__*/ function(PaymentMethodError) {
    PaymentMethodError[PaymentMethodError["SubscriptionNotSupported"] = 0] = "SubscriptionNotSupported";
    PaymentMethodError[PaymentMethodError["InsufficientFunds"] = 1] = "InsufficientFunds";
    PaymentMethodError[PaymentMethodError["ExpiredCard"] = 2] = "ExpiredCard";
    PaymentMethodError[PaymentMethodError["RefusedPayment"] = 3] = "RefusedPayment";
    return PaymentMethodError;
}({});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8QdZK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UpdatePaymentMethodCta", function() {
    return UpdatePaymentMethodCta;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _hooks = require("../../../../std/hooks");
var _account = require("../../../../app/events/Account");
var _cta = require("../../../components/Cta");
function UpdatePaymentMethodCta() {
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), loading = _useState[0], setLoading = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(''), 2), message = _useState1[0], setMessage = _useState1[1];
    var dispatch = (0, _hooks.useDispatch)();
    (0, _hooks.useOnEvent)((0, _account.RequestPaymentMethodUpdateKey), function() {
        setLoading(true);
        setMessage('');
    });
    (0, _hooks.useOnEvent)((0, _account.PaymentMethodUpdateRequestedKey), function() {
        setLoading(false);
        setMessage("Un e-mail vient de vous \xeatre envoy\xe9 pour mettre votre moyen de paiement \xe0 jour.");
    });
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _jsxDevRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _cta.Cta), {
                label: "Mettre \xe0 jour mon moyen de paiement",
                className: "cta",
                isLoading: loading,
                onClick: function() {
                    return dispatch((0, _account.RequestPaymentMethodUpdate)());
                }
            }, void 0, false, {
                fileName: "src/script/src/dom/views/Account/components/UpdatePaymentMethodCta.tsx",
                lineNumber: 26,
                columnNumber: 13
            }, this),
            message && /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                className: "successMessage",
                children: message
            }, void 0, false, {
                fileName: "src/script/src/dom/views/Account/components/UpdatePaymentMethodCta.tsx",
                lineNumber: 32,
                columnNumber: 25
            }, this)
        ]
    }, void 0, true);
}

},{"@swc/helpers/_/_sliced_to_array":"ha6sq","react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","../../../../std/hooks":"j9RPQ","../../../../app/events/Account":"em32I","../../../components/Cta":"beDOe","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"em32I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RequestPaymentMethodUpdateKey", function() {
    return RequestPaymentMethodUpdateKey;
});
parcelHelpers.export(exports, "RequestPaymentMethodUpdate", function() {
    return RequestPaymentMethodUpdate;
});
parcelHelpers.export(exports, "PaymentMethodUpdateRequestedKey", function() {
    return PaymentMethodUpdateRequestedKey;
});
parcelHelpers.export(exports, "PaymentMethodUpdateRequested", function() {
    return PaymentMethodUpdateRequested;
});
var _eventFactory = require("../../std/eventFactory");
var RequestPaymentMethodUpdateKey = 'RequestPaymentMethodUpdate';
var RequestPaymentMethodUpdate = (0, _eventFactory.eventFactory)(RequestPaymentMethodUpdateKey)();
var PaymentMethodUpdateRequestedKey = 'PaymentMethodUpdateRequested';
var PaymentMethodUpdateRequested = (0, _eventFactory.eventFactory)(PaymentMethodUpdateRequestedKey)();

},{"../../std/eventFactory":"f2PpV","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"beDOe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Cta", function() {
    return Cta;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _useHandleClickOutside = require("../hooks/useHandleClickOutside");
var _reactRouterDom = require("react-router-dom");
function Cta(props) {
    var dropdownItems = props.dropdownItems;
    var _props_isDisabled;
    var isDisabled = (_props_isDisabled = props.isDisabled) !== null && _props_isDisabled !== void 0 ? _props_isDisabled : false;
    var _props_isInverted;
    var isInverted = (_props_isInverted = props.isInverted) !== null && _props_isInverted !== void 0 ? _props_isInverted : false;
    var _props_isLoading;
    var isLoading = (_props_isLoading = props.isLoading) !== null && _props_isLoading !== void 0 ? _props_isLoading : false;
    var type = props.formToSubmit ? 'submit' : undefined;
    var _props_className;
    var className = (_props_className = props.className) !== null && _props_className !== void 0 ? _props_className : '';
    var isDropdown = !!dropdownItems;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), dropdownOpened = _useState[0], setDropdownOpened = _useState[1];
    var ctaRef = (0, _useHandleClickOutside.useHandleClickOutside)(closeDropdown);
    var navigate = (0, _reactRouterDom.useNavigate)();
    var _obj;
    var classes = (0, _classnamesDefault.default)((_obj = {
        componentCtaOld: true
    }, (0, _defineProperty._)(_obj, className, true), (0, _defineProperty._)(_obj, "isInverted", isInverted), (0, _defineProperty._)(_obj, "isDisabled", isDisabled), (0, _defineProperty._)(_obj, "isLoading", isLoading), (0, _defineProperty._)(_obj, "isDropdown", isDropdown), _obj));
    function closeDropdown() {
        setDropdownOpened(false);
    }
    function handleClick(event) {
        if (isDisabled) return event.preventDefault();
        if (isDropdown) {
            event.preventDefault();
            return setDropdownOpened(!dropdownOpened);
        }
        if (isLoading) return event.preventDefault();
        if (props.onClick) {
            event.preventDefault();
            return props.onClick();
        }
        if (props.linkTo) {
            event.preventDefault();
            return navigate(props.linkTo);
        }
    }
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
        className: classes,
        ref: ctaRef,
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("button", {
                className: "componentCtaOld__button",
                onClick: handleClick,
                type: type,
                form: props.formToSubmit,
                "data-size": props.size,
                children: [
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("span", {
                        className: "componentCtaOld__label",
                        children: props.label
                    }, void 0, false, {
                        fileName: "src/script/src/dom/components/Cta.tsx",
                        lineNumber: 79,
                        columnNumber: 17
                    }, this),
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(Loader, {
                        isLoading: isLoading
                    }, void 0, false, {
                        fileName: "src/script/src/dom/components/Cta.tsx",
                        lineNumber: 82,
                        columnNumber: 17
                    }, this)
                ]
            }, void 0, true, {
                fileName: "src/script/src/dom/components/Cta.tsx",
                lineNumber: 72,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(Dropdown, {
                dropdownItems: dropdownItems,
                opened: dropdownOpened,
                closeDropdown: closeDropdown
            }, void 0, false, {
                fileName: "src/script/src/dom/components/Cta.tsx",
                lineNumber: 84,
                columnNumber: 13
            }, this)
        ]
    }, void 0, true, {
        fileName: "src/script/src/dom/components/Cta.tsx",
        lineNumber: 71,
        columnNumber: 9
    }, this);
}
function Loader(props) {
    if (!props.isLoading) return null;
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("span", {
        className: "componentCtaOld__loader",
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                className: "componentCtaOld__loader__circle componentCtaOld__loader__circle--one"
            }, void 0, false, {
                fileName: "src/script/src/dom/components/Cta.tsx",
                lineNumber: 102,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                className: "componentCtaOld__loader__circle componentCtaOld__loader__circle--two"
            }, void 0, false, {
                fileName: "src/script/src/dom/components/Cta.tsx",
                lineNumber: 103,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                className: "componentCtaOld__loader__circle componentCtaOld__loader__circle--three"
            }, void 0, false, {
                fileName: "src/script/src/dom/components/Cta.tsx",
                lineNumber: 104,
                columnNumber: 13
            }, this)
        ]
    }, void 0, true, {
        fileName: "src/script/src/dom/components/Cta.tsx",
        lineNumber: 101,
        columnNumber: 9
    }, this);
}
function Dropdown(props) {
    var _this = this;
    var dropdownItems = props.dropdownItems, opened = props.opened, closeDropdown = props.closeDropdown;
    if (!dropdownItems || !opened) return null;
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
        className: "componentCtaOld__dropdown",
        children: dropdownItems.map(function(item, index) {
            return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(DropdownItem, {
                item: item,
                closeDropdown: closeDropdown
            }, index, false, {
                fileName: "src/script/src/dom/components/Cta.tsx",
                lineNumber: 122,
                columnNumber: 49
            }, _this);
        })
    }, void 0, false, {
        fileName: "src/script/src/dom/components/Cta.tsx",
        lineNumber: 121,
        columnNumber: 9
    }, this);
}
function DropdownItem(props) {
    var item = props.item, closeDropdown = props.closeDropdown;
    if (item === 'separator') return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
        className: "componentCtaOld__dropdown__separator"
    }, void 0, false, {
        fileName: "src/script/src/dom/components/Cta.tsx",
        lineNumber: 139,
        columnNumber: 13
    }, this);
    var handleClick = function() {
        closeDropdown();
        item.onClick();
    };
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("a", {
        className: "componentCtaOld__dropdown__item",
        onClick: handleClick,
        children: item.label
    }, void 0, false, {
        fileName: "src/script/src/dom/components/Cta.tsx",
        lineNumber: 149,
        columnNumber: 9
    }, this);
}

},{"@swc/helpers/_/_define_property":"54Zvk","@swc/helpers/_/_sliced_to_array":"ha6sq","react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","classnames":"4SuBi","../hooks/useHandleClickOutside":"3e8te","react-router-dom":"9VDGr","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3e8te":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useHandleClickOutside", function() {
    return useHandleClickOutside;
});
var _react = require("react");
function useHandleClickOutside(callback) {
    var elementRef = (0, _react.useRef)(null);
    (0, _react.useEffect)(function() {
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    function handleClickOutside(event) {
        if (!isOutside(event)) return;
        if (!callback) return;
        callback();
    }
    function isOutside(event) {
        return elementRef.current && !elementRef.current.contains(event.target);
    }
    return elementRef;
}

},{"react":"c8CN1","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7IlcY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "paymentMethodErrorView", function() {
    return paymentMethodErrorView;
});
var _reselect = require("reselect");
var _customerSubscription = require("../store/state/data/customerSubscription");
var _std = require("@reglo/std");
var paymentMethodErrorView = (0, _reselect.createSelector)((0, _customerSubscription.customerSubscriptionSelector), prepareView);
function prepareView(subscriptionState) {
    var paymentMethod = subscriptionState.paymentMethod;
    if (!paymentMethod || paymentMethod.status !== 'ERROR') return null;
    return {
        methodDetails: paymentMethod.details,
        error: paymentMethod.error,
        errorDate: (0, _std.unwrap)(paymentMethod.errorDate)
    };
}

},{"reselect":"fb6q1","../store/state/data/customerSubscription":"3ipiV","@reglo/std":"1USo0","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"hBP5H":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NextOrder", function() {
    return NextOrder;
});
parcelHelpers.export(exports, "AddProduct", function() {
    return AddProduct;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _price = require("../../../../../std/price");
var _productLines = require("./ProductLines");
var _editNextOrderDate = require("./EditNextOrderDate");
var _reactRedux = require("react-redux");
var _hooks = require("../../../../../std/hooks");
var _editableInfo = require("../../components/EditableInfo");
var _accountCard = require("../../components/AccountCard");
var _cancelSubscriptions = require("./CancelSubscriptions");
var _cta = require("../../../../components/Cta");
var _cancelSubscription = require("../../../../../app/useCases/cancelSubscription");
var _selectProductPopup = require("./SelectProductPopup");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _addProductView = require("../../../../../app/views/addProductView");
var _std = require("@reglo/std");
var _editFrequency = require("./EditFrequency");
var _presentFrequency = require("./presentFrequency");
function NextOrder(props) {
    var view = props.view;
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _accountCard.AccountCard), {
        title: "Prochaine livraison",
        underActions: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(Cancel, {}, void 0, false, {
                fileName: "src/script/src/dom/views/Account/views/Subscription/NextOrder.tsx",
                lineNumber: 28,
                columnNumber: 28
            }, void 0)
        ],
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(Details, {
                view: view
            }, void 0, false, {
                fileName: "src/script/src/dom/views/Account/views/Subscription/NextOrder.tsx",
                lineNumber: 30,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _productLines.ProductLines), {
                linesViews: view.lines
            }, void 0, false, {
                fileName: "src/script/src/dom/views/Account/views/Subscription/NextOrder.tsx",
                lineNumber: 31,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(AddProduct, {}, void 0, false, {
                fileName: "src/script/src/dom/views/Account/views/Subscription/NextOrder.tsx",
                lineNumber: 32,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(Total, {
                view: view
            }, void 0, false, {
                fileName: "src/script/src/dom/views/Account/views/Subscription/NextOrder.tsx",
                lineNumber: 33,
                columnNumber: 13
            }, this)
        ]
    }, void 0, true, {
        fileName: "src/script/src/dom/views/Account/views/Subscription/NextOrder.tsx",
        lineNumber: 26,
        columnNumber: 9
    }, this);
}
function AddProduct() {
    var view = (0, _reactRedux.useSelector)((0, _addProductView.addProductView));
    var _useTrigger = (0, _slicedToArray._)((0, _hooks.useTrigger)(), 2), triggerOpenListener = _useTrigger[0], triggerOpen = _useTrigger[1];
    function open() {
        triggerOpen();
    }
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
        className: "accountSubscription__nextOrder__addProduct",
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _cta.Cta), {
                label: "Ajouter un produit",
                size: "XS",
                onClick: open
            }, void 0, false, {
                fileName: "src/script/src/dom/views/Account/views/Subscription/NextOrder.tsx",
                lineNumber: 48,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _selectProductPopup.SelectProductPopup), {
                title: "Ajouter un produit",
                cta: "Ajouter",
                triggerListener: triggerOpenListener,
                view: view
            }, void 0, false, {
                fileName: "src/script/src/dom/views/Account/views/Subscription/NextOrder.tsx",
                lineNumber: 49,
                columnNumber: 13
            }, this)
        ]
    }, void 0, true, {
        fileName: "src/script/src/dom/views/Account/views/Subscription/NextOrder.tsx",
        lineNumber: 47,
        columnNumber: 9
    }, this);
}
function Details(props) {
    var view = props.view;
    var _useTrigger = (0, _slicedToArray._)((0, _hooks.useTrigger)(), 2), onEditNextDate = _useTrigger[0], initEditNextDate = _useTrigger[1];
    var _useTrigger1 = (0, _slicedToArray._)((0, _hooks.useTrigger)(), 2), onEditFrequency = _useTrigger1[0], initEditFrequency = _useTrigger1[1];
    function renderDeliveryDateRange() {
        if (view.status === 'ERROR') {
            var retryDate = view.retryDate;
            return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _jsxDevRuntime.Fragment), {
                children: [
                    "En attente du paiement",
                    retryDate && /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _jsxDevRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("br", {}, void 0, false, {
                                fileName: "src/script/src/dom/views/Account/views/Subscription/NextOrder.tsx",
                                lineNumber: 73,
                                columnNumber: 25
                            }, this),
                            "Prochain essai\xa0: ",
                            (0, _std.formatDate)(retryDate, {
                                withTime: true,
                                withYear: true,
                                withShortMonth: true
                            })
                        ]
                    }, void 0, true)
                ]
            }, void 0, true);
        }
        return (0, _std.formatRange)(view.deliveryDateRange);
    }
    var renderFrequency = function() {
        return (0, _presentFrequency.presentFrequency)(view.frequency);
    };
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
        className: "accountSubscription__nextOrder__details",
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _editableInfo.EditableInfo), {
                title: "Date de livraison",
                content: renderDeliveryDateRange(),
                onStartEdit: initEditNextDate
            }, void 0, false, {
                fileName: "src/script/src/dom/views/Account/views/Subscription/NextOrder.tsx",
                lineNumber: 90,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _editNextOrderDate.EditNextOrderDate), {
                open: onEditNextDate,
                view: view
            }, void 0, false, {
                fileName: "src/script/src/dom/views/Account/views/Subscription/NextOrder.tsx",
                lineNumber: 95,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _editableInfo.EditableInfo), {
                title: "Fr\xe9quence",
                content: renderFrequency(),
                onStartEdit: initEditFrequency
            }, void 0, false, {
                fileName: "src/script/src/dom/views/Account/views/Subscription/NextOrder.tsx",
                lineNumber: 96,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _editFrequency.EditFrequency), {
                open: onEditFrequency,
                view: view
            }, void 0, false, {
                fileName: "src/script/src/dom/views/Account/views/Subscription/NextOrder.tsx",
                lineNumber: 101,
                columnNumber: 13
            }, this)
        ]
    }, void 0, true, {
        fileName: "src/script/src/dom/views/Account/views/Subscription/NextOrder.tsx",
        lineNumber: 89,
        columnNumber: 9
    }, this);
}
function Total(props) {
    var view = props.view;
    function renderLines() {
        var _this = this;
        return prepareLines().map(function(line) {
            return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("tr", {
                className: (0, _classnamesDefault.default)({
                    'accountSubscription__nextOrder__totals__line--bold': line.bold
                }),
                children: [
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("td", {
                        children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("span", {
                            children: line.label
                        }, void 0, false, {
                            fileName: "src/script/src/dom/views/Account/views/Subscription/NextOrder.tsx",
                            lineNumber: 120,
                            columnNumber: 21
                        }, _this)
                    }, void 0, false, {
                        fileName: "src/script/src/dom/views/Account/views/Subscription/NextOrder.tsx",
                        lineNumber: 120,
                        columnNumber: 17
                    }, _this),
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("td", {
                        children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("span", {
                            children: (0, _price.formatPrice)(line.amount)
                        }, void 0, false, {
                            fileName: "src/script/src/dom/views/Account/views/Subscription/NextOrder.tsx",
                            lineNumber: 121,
                            columnNumber: 21
                        }, _this)
                    }, void 0, false, {
                        fileName: "src/script/src/dom/views/Account/views/Subscription/NextOrder.tsx",
                        lineNumber: 121,
                        columnNumber: 17
                    }, _this)
                ]
            }, line.label, true, {
                fileName: "src/script/src/dom/views/Account/views/Subscription/NextOrder.tsx",
                lineNumber: 119,
                columnNumber: 13
            }, _this);
        });
    }
    function prepareLines() {
        var lines = [];
        lines.push({
            label: 'Sous-total',
            amount: view.totalLinesPrice
        });
        if (view.totalDiscounts > 0) lines.push({
            label: "R\xe9duction",
            amount: view.totalDiscounts
        });
        lines.push({
            label: 'Livraison',
            amount: view.totalShippingPrice
        });
        lines.push({
            label: 'TVA',
            amount: view.totalTaxPrice
        });
        lines.push({
            label: 'Total',
            amount: view.totalPrice,
            bold: true
        });
        return lines;
    }
    var classes = (0, _classnamesDefault.default)({
        'accountSubscription__nextOrder__totals': true,
        'accountSubscription__nextOrder__totals--isRefreshing': view.isRefreshing
    });
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
        className: classes,
        children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("table", {
            children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("tbody", {
                children: renderLines()
            }, void 0, false, {
                fileName: "src/script/src/dom/views/Account/views/Subscription/NextOrder.tsx",
                lineNumber: 146,
                columnNumber: 17
            }, this)
        }, void 0, false, {
            fileName: "src/script/src/dom/views/Account/views/Subscription/NextOrder.tsx",
            lineNumber: 145,
            columnNumber: 13
        }, this)
    }, void 0, false, {
        fileName: "src/script/src/dom/views/Account/views/Subscription/NextOrder.tsx",
        lineNumber: 144,
        columnNumber: 9
    }, this);
}
function Cancel() {
    var dispatch = (0, _reactRedux.useDispatch)();
    var _useAskForFeedbackBeforeUnsubscribe = (0, _cancelSubscriptions.useAskForFeedbackBeforeUnsubscribe)(), askForFeedbackBeforeUnsubscribe = _useAskForFeedbackBeforeUnsubscribe.askForFeedbackBeforeUnsubscribe, AskForFeedbackBeforeUnsubscribeComponent = _useAskForFeedbackBeforeUnsubscribe.AskForFeedbackBeforeUnsubscribeComponent, closeAskForFeedbackBeforeUnsubscribe = _useAskForFeedbackBeforeUnsubscribe.closeAskForFeedbackBeforeUnsubscribe;
    function handleClick() {
        askForFeedbackBeforeUnsubscribe(function(feedback) {
            setTimeout(function() {
                dispatch((0, _cancelSubscription.CancelSubscription)(feedback));
                closeAskForFeedbackBeforeUnsubscribe();
            }, 600);
        });
    }
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _jsxDevRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _cta.Cta), {
                label: "Annuler mon abonnement",
                isInverted: true,
                size: "XS",
                onClick: handleClick
            }, void 0, false, {
                fileName: "src/script/src/dom/views/Account/views/Subscription/NextOrder.tsx",
                lineNumber: 174,
                columnNumber: 13
            }, this),
            AskForFeedbackBeforeUnsubscribeComponent
        ]
    }, void 0, true);
}

},{"@swc/helpers/_/_sliced_to_array":"ha6sq","react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","../../../../../std/price":"bpfMV","./ProductLines":"1NTEc","./EditNextOrderDate":"aOO68","react-redux":"ghMZu","../../../../../std/hooks":"j9RPQ","../../components/EditableInfo":"j35EA","../../components/AccountCard":"foulu","./CancelSubscriptions":"7PS0Y","../../../../components/Cta":"beDOe","../../../../../app/useCases/cancelSubscription":"qpH7L","./SelectProductPopup":"lNfEP","classnames":"4SuBi","../../../../../app/views/addProductView":"alMr2","@reglo/std":"1USo0","./EditFrequency":"j9xAX","./presentFrequency":"59mai","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1NTEc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProductLines", function() {
    return ProductLines;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _price = require("../../../../../std/price");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _hooks = require("../../../../../std/hooks");
var _threeDotsMenu = require("../../../../components/ThreeDotsMenu");
var _cancelSubscriptions = require("./CancelSubscriptions");
var _selectProductPopup = require("./SelectProductPopup");
var _swapProductView = require("../../../../../app/views/swapProductView");
var _select = require("../../../../../../../snippets/components/select");
var _updateSubscriptionQuantity = require("../../../../../app/useCases/updateSubscriptionQuantity");
var _refreshCustomerSubscriptions = require("../../../../../app/useCases/refreshCustomerSubscriptions");
function ProductLines(props) {
    var _this = this;
    var linesViews = props.linesViews;
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
        className: (0, _classnamesDefault.default)({
            accountSubscriptionProductLines: true
        }),
        children: linesViews.map(function(view) {
            return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(Line, {
                view: view
            }, view.key, false, {
                fileName: "src/script/src/dom/views/Account/views/Subscription/ProductLines.tsx",
                lineNumber: 23,
                columnNumber: 37
            }, _this);
        })
    }, void 0, false, {
        fileName: "src/script/src/dom/views/Account/views/Subscription/ProductLines.tsx",
        lineNumber: 20,
        columnNumber: 9
    }, this);
}
function Line(props) {
    var view = props.view;
    return view.isLoading ? /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(LoadingLine, {
        view: view
    }, void 0, false, {
        fileName: "src/script/src/dom/views/Account/views/Subscription/ProductLines.tsx",
        lineNumber: 32,
        columnNumber: 29
    }, this) : /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(LoadedLine, {
        view: view
    }, void 0, false, {
        fileName: "src/script/src/dom/views/Account/views/Subscription/ProductLines.tsx",
        lineNumber: 32,
        columnNumber: 58
    }, this);
}
function LoadingLine(props) {
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(LineDom, {
        view: props.view,
        isLoaded: false
    }, void 0, false, {
        fileName: "src/script/src/dom/views/Account/views/Subscription/ProductLines.tsx",
        lineNumber: 38,
        columnNumber: 12
    }, this);
}
function LoadedLine(props) {
    var view = props.view;
    var dispatch = (0, _hooks.useDispatch)();
    var AskForFeedbackBeforeUnsubscribeComponent = (0, _cancelSubscriptions.useAskForFeedbackBeforeUnsubscribe)().AskForFeedbackBeforeUnsubscribeComponent;
    var handleUpdateQuantity = function(quantity) {
        return dispatch(view.actions.updateQuantity(quantity));
    };
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(LineDom, {
        view: props.view,
        isLoaded: true,
        handleUpdateQuantity: handleUpdateQuantity,
        askForFeedBackComponent: AskForFeedbackBeforeUnsubscribeComponent
    }, void 0, false, {
        fileName: "src/script/src/dom/views/Account/views/Subscription/ProductLines.tsx",
        lineNumber: 50,
        columnNumber: 9
    }, this);
}
function LineDom(props) {
    var view = props.view;
    var _React_useState = (0, _slicedToArray._)((0, _reactDefault.default).useState(false), 2), isPriceRefreshing = _React_useState[0], setIsPriceRefreshing = _React_useState[1];
    (0, _hooks.useOnEvent)((0, _updateSubscriptionQuantity.UpdateSubscriptionQuantityKey), function(event) {
        if (event.payload.subscriptionId === view.subscriptionId) setIsPriceRefreshing(true);
    });
    (0, _hooks.useOnEvent)((0, _refreshCustomerSubscriptions.CustomerSubscriptionsRefreshedKey), function() {
        setIsPriceRefreshing(false);
    });
    var classes = function(className) {
        var _obj;
        return (0, _classnamesDefault.default)((_obj = {}, (0, _defineProperty._)(_obj, className, true), (0, _defineProperty._)(_obj, "isLoading", props.view.isLoading), (0, _defineProperty._)(_obj, "isPriceRefreshing", isPriceRefreshing), _obj));
    };
    var handleUpdateQuantity = function(quantity) {
        return props.isLoaded && props.handleUpdateQuantity(quantity);
    };
    function prepareQuantityOptions() {
        if (view.isLoading) return [];
        var defaultQuantityOptions = Array.from({
            length: view.maxQuantitySelector
        }, function(_, i) {
            return i + 1;
        });
        var quantityOptions = view.quantity > view.maxQuantitySelector ? (0, _toConsumableArray._)(defaultQuantityOptions).concat([
            view.quantity
        ]) : defaultQuantityOptions;
        return quantityOptions.map(function(option) {
            var bulkDiscount = view.bulkDiscount.sort(function(a, b) {
                return b.minQuantity - a.minQuantity;
            }).find(function(discount) {
                return option >= discount.minQuantity;
            });
            var bulkDiscountText = bulkDiscount ? ` (-${bulkDiscount.discount}%)` : '';
            return {
                value: option,
                label: `${option}`,
                shortLabel: `${option}${bulkDiscountText}`
            };
        });
    }
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _jsxDevRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                className: classes('pictureColumn'),
                children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                    className: "placeholder",
                    children: props.isLoaded && /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("img", {
                        src: props.view.picture
                    }, void 0, false, {
                        fileName: "src/script/src/dom/views/Account/views/Subscription/ProductLines.tsx",
                        lineNumber: 113,
                        columnNumber: 40
                    }, this)
                }, void 0, false, {
                    fileName: "src/script/src/dom/views/Account/views/Subscription/ProductLines.tsx",
                    lineNumber: 112,
                    columnNumber: 17
                }, this)
            }, void 0, false, {
                fileName: "src/script/src/dom/views/Account/views/Subscription/ProductLines.tsx",
                lineNumber: 111,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                className: classes('titleColumn'),
                children: [
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("span", {
                        className: "title placeholder",
                        children: view.isLoading ? "\xa0" : /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _jsxDevRuntime.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("span", {
                                    children: view.productTitle
                                }, void 0, false, {
                                    fileName: "src/script/src/dom/views/Account/views/Subscription/ProductLines.tsx",
                                    lineNumber: 118,
                                    columnNumber: 23
                                }, this),
                                view.productSubtitle && /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("span", {
                                    className: "subtitle",
                                    children: [
                                        " - ",
                                        view.productSubtitle
                                    ]
                                }, void 0, true, {
                                    fileName: "src/script/src/dom/views/Account/views/Subscription/ProductLines.tsx",
                                    lineNumber: 118,
                                    columnNumber: 80
                                }, this)
                            ]
                        }, void 0, true)
                    }, void 0, false, {
                        fileName: "src/script/src/dom/views/Account/views/Subscription/ProductLines.tsx",
                        lineNumber: 117,
                        columnNumber: 17
                    }, this),
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("span", {
                        className: "variantTitle placeholder",
                        children: view.isLoading ? "\xa0" : view.variantTitle
                    }, void 0, false, {
                        fileName: "src/script/src/dom/views/Account/views/Subscription/ProductLines.tsx",
                        lineNumber: 120,
                        columnNumber: 17
                    }, this),
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _select.NumberSelect), {
                        className: "quantityDropdown",
                        options: prepareQuantityOptions(),
                        value: view.isLoading ? 0 : view.quantity,
                        onChange: function(quantity) {
                            return handleUpdateQuantity(quantity);
                        },
                        isLoading: !view.isLoading && view.quantityIsLoading,
                        isPlaceholder: view.isLoading
                    }, void 0, false, {
                        fileName: "src/script/src/dom/views/Account/views/Subscription/ProductLines.tsx",
                        lineNumber: 121,
                        columnNumber: 17
                    }, this)
                ]
            }, void 0, true, {
                fileName: "src/script/src/dom/views/Account/views/Subscription/ProductLines.tsx",
                lineNumber: 116,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                className: classes('originalPriceColumn'),
                children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("span", {
                    className: "lineOriginalPrice placeholder",
                    children: view.isLoading ? "\xa0" : view.originalPrice !== view.price && (0, _price.formatPrice)(view.originalPrice)
                }, void 0, false, {
                    fileName: "src/script/src/dom/views/Account/views/Subscription/ProductLines.tsx",
                    lineNumber: 131,
                    columnNumber: 17
                }, this)
            }, void 0, false, {
                fileName: "src/script/src/dom/views/Account/views/Subscription/ProductLines.tsx",
                lineNumber: 130,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                className: classes('priceColumn'),
                children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("span", {
                    className: "price placeholder",
                    children: view.isLoading ? "\xa0" : (0, _price.formatPrice)(view.price)
                }, void 0, false, {
                    fileName: "src/script/src/dom/views/Account/views/Subscription/ProductLines.tsx",
                    lineNumber: 136,
                    columnNumber: 17
                }, this)
            }, void 0, false, {
                fileName: "src/script/src/dom/views/Account/views/Subscription/ProductLines.tsx",
                lineNumber: 135,
                columnNumber: 13
            }, this),
            props.isLoaded && /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(Ctas, {
                view: props.view
            }, void 0, false, {
                fileName: "src/script/src/dom/views/Account/views/Subscription/ProductLines.tsx",
                lineNumber: 138,
                columnNumber: 32
            }, this),
            props.isLoaded && props.askForFeedBackComponent
        ]
    }, void 0, true);
}
function Ctas(props) {
    var view = props.view;
    var swapView = (0, _hooks.useSelector)((0, _swapProductView.swapProductView)(view.subscriptionId));
    var _useTrigger = (0, _slicedToArray._)((0, _hooks.useTrigger)(), 2), triggerSwapListener = _useTrigger[0], triggerSwap = _useTrigger[1];
    var _useAskForFeedbackBeforeUnsubscribe = (0, _cancelSubscriptions.useAskForFeedbackBeforeUnsubscribe)(), closeAskForFeedbackBeforeUnsubscribe = _useAskForFeedbackBeforeUnsubscribe.closeAskForFeedbackBeforeUnsubscribe, askForFeedbackBeforeUnsubscribe = _useAskForFeedbackBeforeUnsubscribe.askForFeedbackBeforeUnsubscribe, AskForFeedbackBeforeUnsubscribeComponent = _useAskForFeedbackBeforeUnsubscribe.AskForFeedbackBeforeUnsubscribeComponent;
    var dispatch = (0, _hooks.useDispatch)();
    var handleRemove = function() {
        return view.actions.remove({
            onShouldAskForFeedback: function(onFeedback) {
                askForFeedbackBeforeUnsubscribe(function(feedback) {
                    setTimeout(function() {
                        onFeedback(feedback);
                        closeAskForFeedbackBeforeUnsubscribe();
                    }, 600);
                });
            },
            onDispatch: dispatch
        });
    };
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
        className: "ctasColumn",
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _threeDotsMenu.ThreeDotsMenu), {
                dropdownItems: [
                    {
                        label: 'Retirer le produit',
                        onClick: handleRemove
                    },
                    'separator',
                    {
                        label: 'Remplacer par un autre produit',
                        onClick: triggerSwap
                    }
                ]
            }, void 0, false, {
                fileName: "src/script/src/dom/views/Account/views/Subscription/ProductLines.tsx",
                lineNumber: 171,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _selectProductPopup.SelectProductPopup), {
                title: "Remplacer par",
                cta: "S\xe9lectionner",
                triggerListener: triggerSwapListener,
                view: swapView
            }, void 0, false, {
                fileName: "src/script/src/dom/views/Account/views/Subscription/ProductLines.tsx",
                lineNumber: 176,
                columnNumber: 13
            }, this),
            AskForFeedbackBeforeUnsubscribeComponent
        ]
    }, void 0, true, {
        fileName: "src/script/src/dom/views/Account/views/Subscription/ProductLines.tsx",
        lineNumber: 170,
        columnNumber: 9
    }, this);
}

},{"@swc/helpers/_/_define_property":"54Zvk","@swc/helpers/_/_sliced_to_array":"ha6sq","@swc/helpers/_/_to_consumable_array":"eqNDD","react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","../../../../../std/price":"bpfMV","classnames":"4SuBi","../../../../../std/hooks":"j9RPQ","../../../../components/ThreeDotsMenu":"5d2wm","./CancelSubscriptions":"7PS0Y","./SelectProductPopup":"lNfEP","../../../../../app/views/swapProductView":"7iboA","../../../../../../../snippets/components/select":"fqaEu","../../../../../app/useCases/updateSubscriptionQuantity":"2ruvf","../../../../../app/useCases/refreshCustomerSubscriptions":"f4vE2","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5d2wm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ThreeDotsMenu", function() {
    return ThreeDotsMenu;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _useHandleClickOutside = require("../hooks/useHandleClickOutside");
var _useShopifyAsset = require("../hooks/useShopifyAsset");
var _dotsLoader = require("./DotsLoader");
function ThreeDotsMenu(props) {
    var dropdownItems = props.dropdownItems;
    var _props_className;
    var className = (_props_className = props.className) !== null && _props_className !== void 0 ? _props_className : '';
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), dropdownOpened = _useState[0], setDropdownOpened = _useState[1];
    var iconRef = (0, _useHandleClickOutside.useHandleClickOutside)(closeDropdown);
    var shopifyAsset = (0, _useShopifyAsset.useShopifyAsset)();
    var classes = (0, _classnamesDefault.default)((0, _defineProperty._)({
        componentThreeDotsMenu: true
    }, className, true));
    function closeDropdown() {
        setDropdownOpened(false);
    }
    function handleClick(event) {
        event.preventDefault();
        return setDropdownOpened(!dropdownOpened);
    }
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
        className: classes,
        ref: iconRef,
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("img", {
                src: shopifyAsset('icons/three_dots.svg'),
                className: "componentThreeDotsMenu__icon",
                onClick: handleClick,
                alt: ""
            }, void 0, false, {
                fileName: "src/script/src/dom/components/ThreeDotsMenu.tsx",
                lineNumber: 40,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(Dropdown, {
                dropdownItems: dropdownItems,
                opened: dropdownOpened,
                closeDropdown: closeDropdown
            }, void 0, false, {
                fileName: "src/script/src/dom/components/ThreeDotsMenu.tsx",
                lineNumber: 46,
                columnNumber: 13
            }, this)
        ]
    }, void 0, true, {
        fileName: "src/script/src/dom/components/ThreeDotsMenu.tsx",
        lineNumber: 39,
        columnNumber: 9
    }, this);
}
function Dropdown(props) {
    var _this = this;
    var dropdownItems = props.dropdownItems, opened = props.opened, closeDropdown = props.closeDropdown;
    if (!dropdownItems || !opened) return null;
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
        className: "componentThreeDotsMenu__dropdown",
        children: dropdownItems.map(function(item, index) {
            return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(DropdownItem, {
                item: item,
                closeDropdown: closeDropdown
            }, index, false, {
                fileName: "src/script/src/dom/components/ThreeDotsMenu.tsx",
                lineNumber: 68,
                columnNumber: 49
            }, _this);
        })
    }, void 0, false, {
        fileName: "src/script/src/dom/components/ThreeDotsMenu.tsx",
        lineNumber: 67,
        columnNumber: 9
    }, this);
}
function DropdownItem(props) {
    var item = props.item, closeDropdown = props.closeDropdown;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), isLoading = _useState[0], setIsLoading = _useState[1];
    if (item === 'separator') return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
        className: "componentThreeDotsMenu__dropdown__separator"
    }, void 0, false, {
        fileName: "src/script/src/dom/components/ThreeDotsMenu.tsx",
        lineNumber: 86,
        columnNumber: 13
    }, this);
    var handleClick = function() {
        setIsLoading(true);
        setTimeout(function() {
            closeDropdown();
            item.onClick();
        }, 600);
    };
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("a", {
        className: "componentThreeDotsMenu__dropdown__item",
        onClick: handleClick,
        children: [
            item.label,
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _dotsLoader.DotsLoader), {
                isLoading: isLoading,
                className: "componentThreeDotsMenu__dropdown__loader"
            }, void 0, false, {
                fileName: "src/script/src/dom/components/ThreeDotsMenu.tsx",
                lineNumber: 101,
                columnNumber: 13
            }, this)
        ]
    }, void 0, true, {
        fileName: "src/script/src/dom/components/ThreeDotsMenu.tsx",
        lineNumber: 99,
        columnNumber: 9
    }, this);
}

},{"@swc/helpers/_/_define_property":"54Zvk","@swc/helpers/_/_sliced_to_array":"ha6sq","react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","classnames":"4SuBi","../hooks/useHandleClickOutside":"3e8te","../hooks/useShopifyAsset":"aJ4wV","./DotsLoader":"4kA39","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4kA39":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DotsLoader", function() {
    return DotsLoader;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
function DotsLoader(props) {
    if (!props.isLoading) return null;
    var _props_className;
    var classes = (0, _classnamesDefault.default)((0, _defineProperty._)({
        componentDotsLoader: true
    }, (_props_className = props.className) !== null && _props_className !== void 0 ? _props_className : '', true));
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("span", {
        className: classes,
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                className: "componentDotsLoader__circle componentDotsLoader__circle--one"
            }, void 0, false, {
                fileName: "src/script/src/dom/components/DotsLoader.tsx",
                lineNumber: 19,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                className: "componentDotsLoader__circle componentDotsLoader__circle--two"
            }, void 0, false, {
                fileName: "src/script/src/dom/components/DotsLoader.tsx",
                lineNumber: 20,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                className: "componentDotsLoader__circle componentDotsLoader__circle--three"
            }, void 0, false, {
                fileName: "src/script/src/dom/components/DotsLoader.tsx",
                lineNumber: 21,
                columnNumber: 13
            }, this)
        ]
    }, void 0, true, {
        fileName: "src/script/src/dom/components/DotsLoader.tsx",
        lineNumber: 18,
        columnNumber: 9
    }, this);
}

},{"@swc/helpers/_/_define_property":"54Zvk","react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","classnames":"4SuBi","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7PS0Y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useAskForFeedbackBeforeUnsubscribe", function() {
    return useAskForFeedbackBeforeUnsubscribe;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _modal = require("../../../../components/Modal");
var _radioOptions = require("../../../../../../../snippets/components/form/radioOptions");
var _inputGroup = require("../../../../../../../snippets/components/form/inputGroup");
var _textArea = require("../../../../../../../snippets/components/form/textArea");
var _form = require("../../components/Form");
function useAskForFeedbackBeforeUnsubscribe() {
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), opened = _useState[0], setOpened = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(), 2), onFeedback = _useState1[0], setOnFeedback = _useState1[1];
    var closeAskForFeedbackBeforeUnsubscribe = function() {
        return setOpened(false);
    };
    var askForFeedbackBeforeUnsubscribe = function(onFeedback) {
        setOnFeedback(function() {
            return onFeedback;
        });
        setOpened(true);
    };
    var AskForFeedbackBeforeUnsubscribeComponent = /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(Popup, {
        onSubmit: onFeedback,
        opened: opened,
        setOpened: setOpened
    }, void 0, false, {
        fileName: "src/script/src/dom/views/Account/views/Subscription/CancelSubscriptions.tsx",
        lineNumber: 22,
        columnNumber: 9
    }, this);
    return {
        closeAskForFeedbackBeforeUnsubscribe: closeAskForFeedbackBeforeUnsubscribe,
        askForFeedbackBeforeUnsubscribe: askForFeedbackBeforeUnsubscribe,
        AskForFeedbackBeforeUnsubscribeComponent: AskForFeedbackBeforeUnsubscribeComponent
    };
}
function Popup(props) {
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), submitting = _useState[0], setSubmitting = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(null), 2), reason = _useState1[0], setReason = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)(''), 2), observation = _useState2[0], setObservation = _useState2[1];
    var formId = (0, _form.useFormId)();
    function close() {
        props.setOpened(false);
    }
    function handleSubmit() {
        var _props_onSubmit;
        if (reason === null) throw new Error('undefined reason');
        (_props_onSubmit = props.onSubmit) === null || _props_onSubmit === void 0 ? void 0 : _props_onSubmit.call(props, {
            reason: reason,
            observation: observation
        });
        setSubmitting(true);
    }
    var options = [
        {
            value: 'trop_cher',
            label: `Les produits sont trop chers`
        },
        {
            value: 'abonne_par_erreur',
            label: `Je me suis abonn\xe9 par erreur`
        },
        {
            value: 'probleme_livraison',
            label: `Probl\xe8me de livraison`
        },
        {
            value: 'animal_naime_pas',
            label: `Mon animal n'aime pas`
        },
        {
            value: 'probleme_digestion',
            label: `Probl\xe8me de digestion`
        },
        {
            value: 'trop_de_stock',
            label: `J'ai trop de stock`
        },
        {
            value: 'recommandation_veterinaire',
            label: `Mon v\xe9t\xe9rinaire me le recommande`
        },
        {
            value: 'probleme_produit',
            label: `Probl\xe8me sur les produits`
        },
        {
            value: 'prefere_sans_abonnement',
            label: `Je pr\xe9f\xe8re commander sans abonnement`
        },
        {
            value: 'deces_animal',
            label: `Mon animal est d\xe9c\xe9d\xe9`
        },
        {
            value: 'narrive_pas_a_modifier_abonnement',
            label: `Je n'arrive pas \xe0 modifier mon abonnement`
        }
    ];
    if (!props.opened) return null;
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _modal.Modal), {
        title: "Vous souhaitez nous quitter\xa0?",
        ctas: [
            {
                isInverted: true,
                label: 'Annuler',
                onClick: close
            },
            {
                label: "Me d\xe9sabonner",
                formToSubmit: formId,
                isLoading: submitting
            }
        ],
        className: "accountSubscriptionDisableSubscription",
        onClose: close,
        onSubmit: handleSubmit,
        children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _form.Form), {
            onSubmit: handleSubmit,
            id: formId,
            children: [
                /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _radioOptions.RadioOptions), {
                    label: "Je me d\xe9sabonne parce que\xa0?",
                    options: options,
                    selected: reason,
                    onChange: setReason,
                    randomize: true,
                    required: true
                }, void 0, false, {
                    fileName: "src/script/src/dom/views/Account/views/Subscription/CancelSubscriptions.tsx",
                    lineNumber: 88,
                    columnNumber: 17
                }, this),
                /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _inputGroup.InputGroup), {
                    label: "Une remarque pour nous aider \xe0 nous am\xe9liorer\xa0?",
                    children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _textArea.TextArea), {
                        value: observation,
                        onChange: setObservation,
                        placeHolder: "Aidez-nous \xe0 nous am\xe9liorer"
                    }, void 0, false, {
                        fileName: "src/script/src/dom/views/Account/views/Subscription/CancelSubscriptions.tsx",
                        lineNumber: 90,
                        columnNumber: 21
                    }, this)
                }, void 0, false, {
                    fileName: "src/script/src/dom/views/Account/views/Subscription/CancelSubscriptions.tsx",
                    lineNumber: 89,
                    columnNumber: 17
                }, this)
            ]
        }, void 0, true, {
            fileName: "src/script/src/dom/views/Account/views/Subscription/CancelSubscriptions.tsx",
            lineNumber: 87,
            columnNumber: 13
        }, this)
    }, void 0, false, {
        fileName: "src/script/src/dom/views/Account/views/Subscription/CancelSubscriptions.tsx",
        lineNumber: 77,
        columnNumber: 9
    }, this);
}

},{"@swc/helpers/_/_sliced_to_array":"ha6sq","react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","../../../../components/Modal":"1uIeH","../../../../../../../snippets/components/form/radioOptions":"jXHmz","../../../../../../../snippets/components/form/inputGroup":"gXBfF","../../../../../../../snippets/components/form/textArea":"5h7ho","../../components/Form":"iExNs","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1uIeH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Modal", function() {
    return Modal;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _cta = require("./Cta");
var _hooks = require("../../std/hooks");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _useShopifyAsset = require("../hooks/useShopifyAsset");
var _useHandleClickOutside = require("../hooks/useHandleClickOutside");
function Modal(props) {
    var _this = this;
    var _props_className;
    var className = (_props_className = props.className) !== null && _props_className !== void 0 ? _props_className : '';
    var shopifyAsset = (0, _useShopifyAsset.useShopifyAsset)();
    (0, _hooks.usePreventBackgroundScroll)(true);
    var modalRef = (0, _useHandleClickOutside.useHandleClickOutside)(props.onClose);
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
        className: (0, _classnamesDefault.default)((0, _defineProperty._)({
            componentModal: true
        }, className, true)),
        "data-is_open": true,
        children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
            className: "dialog",
            role: "document",
            children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                className: "content",
                ref: modalRef,
                children: [
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                        className: "header",
                        children: [
                            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                                className: "title",
                                children: props.title
                            }, void 0, false, {
                                fileName: "src/script/src/dom/components/Modal.tsx",
                                lineNumber: 30,
                                columnNumber: 25
                            }, this),
                            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("img", {
                                className: "close",
                                src: shopifyAsset('image_icon_close_blue_base.svg'),
                                onClick: props.onClose,
                                alt: ""
                            }, void 0, false, {
                                fileName: "src/script/src/dom/components/Modal.tsx",
                                lineNumber: 31,
                                columnNumber: 25
                            }, this)
                        ]
                    }, void 0, true, {
                        fileName: "src/script/src/dom/components/Modal.tsx",
                        lineNumber: 29,
                        columnNumber: 21
                    }, this),
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                        className: "body",
                        children: props.children
                    }, void 0, false, {
                        fileName: "src/script/src/dom/components/Modal.tsx",
                        lineNumber: 33,
                        columnNumber: 21
                    }, this),
                    props.ctas && /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                        className: "footer",
                        children: props.ctas.map(function(cta) {
                            return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _cta.Cta), (0, _objectSpread._)({}, cta), cta.label, false, {
                                fileName: "src/script/src/dom/components/Modal.tsx",
                                lineNumber: 37,
                                columnNumber: 48
                            }, _this);
                        })
                    }, void 0, false, {
                        fileName: "src/script/src/dom/components/Modal.tsx",
                        lineNumber: 36,
                        columnNumber: 36
                    }, this)
                ]
            }, void 0, true, {
                fileName: "src/script/src/dom/components/Modal.tsx",
                lineNumber: 28,
                columnNumber: 17
            }, this)
        }, void 0, false, {
            fileName: "src/script/src/dom/components/Modal.tsx",
            lineNumber: 27,
            columnNumber: 13
        }, this)
    }, void 0, false, {
        fileName: "src/script/src/dom/components/Modal.tsx",
        lineNumber: 23,
        columnNumber: 9
    }, this);
}

},{"@swc/helpers/_/_define_property":"54Zvk","@swc/helpers/_/_object_spread":"4bEWH","react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","./Cta":"beDOe","../../std/hooks":"j9RPQ","classnames":"4SuBi","../hooks/useShopifyAsset":"aJ4wV","../hooks/useHandleClickOutside":"3e8te","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jXHmz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RadioOptions", function() {
    return RadioOptions;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _std = require("@reglo/std");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _input = require("../../../script/src/dom/views/Account/components/Input");
function RadioOptions(props) {
    var _this = this;
    var randomize = props.randomize;
    var _useState = (0, _slicedToArray._)((0, _react.useState)((0, _std.uuid)()), 1), name = _useState[0];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(randomize ? shuffleArray(props.options) : props.options), 1), options = _useState1[0];
    var id = (0, _input.inputId)();
    function shuffleArray(array) {
        var arrayCopy = (0, _toConsumableArray._)(array);
        var remainingLength = array.length;
        while(remainingLength){
            var index = Math.floor(Math.random() * remainingLength--);
            var temporary = arrayCopy[remainingLength];
            arrayCopy[remainingLength] = arrayCopy[index];
            arrayCopy[index] = temporary;
        }
        return arrayCopy;
    }
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _input.Input), {
        id: id,
        label: props.label,
        children: options.map(function(param) {
            var value = param.value, label = param.label;
            return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                className: "componentRadioOptions__options",
                children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("label", {
                    className: "componentRadioOptions__option",
                    children: [
                        /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("input", {
                            id: id,
                            type: "radio",
                            required: props.required,
                            name: name,
                            checked: value === props.selected,
                            onChange: function() {
                                return props.onChange(value);
                            }
                        }, void 0, false, {
                            fileName: "src/snippets/components/form/radioOptions.tsx",
                            lineNumber: 35,
                            columnNumber: 25
                        }, _this),
                        label
                    ]
                }, value, true, {
                    fileName: "src/snippets/components/form/radioOptions.tsx",
                    lineNumber: 34,
                    columnNumber: 21
                }, _this)
            }, void 0, false, {
                fileName: "src/snippets/components/form/radioOptions.tsx",
                lineNumber: 33,
                columnNumber: 17
            }, _this);
        })
    }, void 0, false, {
        fileName: "src/snippets/components/form/radioOptions.tsx",
        lineNumber: 31,
        columnNumber: 9
    }, this);
}

},{"@swc/helpers/_/_sliced_to_array":"ha6sq","@swc/helpers/_/_to_consumable_array":"eqNDD","react/jsx-dev-runtime":"jXZ8I","@reglo/std":"1USo0","react":"c8CN1","../../../script/src/dom/views/Account/components/Input":"3dkG8","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3dkG8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "inputId", function() {
    return inputId;
});
parcelHelpers.export(exports, "Input", function() {
    return Input;
});
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _std = require("@reglo/std");
function inputId() {
    return (0, _react.useState)((0, _std.uuid)())[0];
}
function Input(props) {
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
        className: "componentInput",
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("label", {
                className: "componentInput__label",
                htmlFor: props.id,
                children: props.label
            }, void 0, false, {
                fileName: "src/script/src/dom/views/Account/components/Input.tsx",
                lineNumber: 15,
                columnNumber: 13
            }, this),
            props.children
        ]
    }, void 0, true, {
        fileName: "src/script/src/dom/views/Account/components/Input.tsx",
        lineNumber: 14,
        columnNumber: 9
    }, this);
}

},{"react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","@reglo/std":"1USo0","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gXBfF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InputGroup", function() {
    return InputGroup;
});
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function InputGroup(props) {
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
        className: "componentOldInputGroup",
        children: [
            props.label && /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("label", {
                className: "componentOldInputGroup__label",
                children: props.label
            }, void 0, false, {
                fileName: "src/snippets/components/form/inputGroup.tsx",
                lineNumber: 10,
                columnNumber: 17
            }, this),
            props.children
        ]
    }, void 0, true, {
        fileName: "src/snippets/components/form/inputGroup.tsx",
        lineNumber: 8,
        columnNumber: 9
    }, this);
}

},{"react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5h7ho":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TextArea", function() {
    return TextArea;
});
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactTextareaAutosize = require("react-textarea-autosize");
var _reactTextareaAutosizeDefault = parcelHelpers.interopDefault(_reactTextareaAutosize);
function TextArea(props) {
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _reactTextareaAutosizeDefault.default), {
        placeholder: props.placeHolder,
        value: props.value,
        onChange: function(event) {
            return props.onChange(event.target.value);
        },
        className: "componentTextArea",
        minRows: 4,
        maxRows: 20
    }, void 0, false, {
        fileName: "src/snippets/components/form/textArea.tsx",
        lineNumber: 10,
        columnNumber: 9
    }, this);
}

},{"react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","react-textarea-autosize":"rYtxW","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"rYtxW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return index;
});
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _react = require("react");
var _useLatest = require("use-latest");
var _useLatestDefault = parcelHelpers.interopDefault(_useLatest);
var _useComposedRef = require("use-composed-ref");
var _useComposedRefDefault = parcelHelpers.interopDefault(_useComposedRef);
var HIDDEN_TEXTAREA_STYLE = {
    'min-height': '0',
    'max-height': 'none',
    height: '0',
    visibility: 'hidden',
    overflow: 'hidden',
    position: 'absolute',
    'z-index': '-1000',
    top: '0',
    right: '0',
    display: 'block'
};
var forceHiddenStyles = function forceHiddenStyles(node) {
    Object.keys(HIDDEN_TEXTAREA_STYLE).forEach(function(key) {
        node.style.setProperty(key, HIDDEN_TEXTAREA_STYLE[key], 'important');
    });
};
var forceHiddenStyles$1 = forceHiddenStyles;
var hiddenTextarea = null;
var getHeight = function getHeight(node, sizingData) {
    var height = node.scrollHeight;
    if (sizingData.sizingStyle.boxSizing === 'border-box') // border-box: add border, since height = content + padding + border
    return height + sizingData.borderSize;
    // remove padding, since height = content
    return height - sizingData.paddingSize;
};
function calculateNodeHeight(sizingData, value, minRows, maxRows) {
    if (minRows === void 0) minRows = 1;
    if (maxRows === void 0) maxRows = Infinity;
    if (!hiddenTextarea) {
        hiddenTextarea = document.createElement('textarea');
        hiddenTextarea.setAttribute('tabindex', '-1');
        hiddenTextarea.setAttribute('aria-hidden', 'true');
        forceHiddenStyles$1(hiddenTextarea);
    }
    if (hiddenTextarea.parentNode === null) document.body.appendChild(hiddenTextarea);
    var paddingSize = sizingData.paddingSize, borderSize = sizingData.borderSize, sizingStyle = sizingData.sizingStyle;
    var boxSizing = sizingStyle.boxSizing;
    Object.keys(sizingStyle).forEach(function(_key) {
        var key = _key;
        hiddenTextarea.style[key] = sizingStyle[key];
    });
    forceHiddenStyles$1(hiddenTextarea);
    hiddenTextarea.value = value;
    var height = getHeight(hiddenTextarea, sizingData);
    // Double set and calc due to Firefox bug: https://bugzilla.mozilla.org/show_bug.cgi?id=1795904
    hiddenTextarea.value = value;
    height = getHeight(hiddenTextarea, sizingData);
    // measure height of a textarea with a single row
    hiddenTextarea.value = 'x';
    var rowHeight = hiddenTextarea.scrollHeight - paddingSize;
    var minHeight = rowHeight * minRows;
    if (boxSizing === 'border-box') minHeight = minHeight + paddingSize + borderSize;
    height = Math.max(minHeight, height);
    var maxHeight = rowHeight * maxRows;
    if (boxSizing === 'border-box') maxHeight = maxHeight + paddingSize + borderSize;
    height = Math.min(maxHeight, height);
    return [
        height,
        rowHeight
    ];
}
var noop = function noop() {};
var pick = function pick(props, obj) {
    return props.reduce(function(acc, prop) {
        acc[prop] = obj[prop];
        return acc;
    }, {});
};
var SIZING_STYLE = [
    'borderBottomWidth',
    'borderLeftWidth',
    'borderRightWidth',
    'borderTopWidth',
    'boxSizing',
    'fontFamily',
    'fontSize',
    'fontStyle',
    'fontWeight',
    'letterSpacing',
    'lineHeight',
    'paddingBottom',
    'paddingLeft',
    'paddingRight',
    'paddingTop',
    // non-standard
    'tabSize',
    'textIndent',
    // non-standard
    'textRendering',
    'textTransform',
    'width',
    'wordBreak',
    'wordSpacing',
    'scrollbarGutter'
];
var isIE = !!document.documentElement.currentStyle;
var getSizingData = function getSizingData(node) {
    var style = window.getComputedStyle(node);
    if (style === null) return null;
    var sizingStyle = pick(SIZING_STYLE, style);
    var boxSizing = sizingStyle.boxSizing;
    // probably node is detached from DOM, can't read computed dimensions
    if (boxSizing === '') return null;
    // IE (Edge has already correct behaviour) returns content width as computed width
    // so we need to add manually padding and border widths
    if (isIE && boxSizing === 'border-box') sizingStyle.width = parseFloat(sizingStyle.width) + parseFloat(sizingStyle.borderRightWidth) + parseFloat(sizingStyle.borderLeftWidth) + parseFloat(sizingStyle.paddingRight) + parseFloat(sizingStyle.paddingLeft) + 'px';
    var paddingSize = parseFloat(sizingStyle.paddingBottom) + parseFloat(sizingStyle.paddingTop);
    var borderSize = parseFloat(sizingStyle.borderBottomWidth) + parseFloat(sizingStyle.borderTopWidth);
    return {
        sizingStyle: sizingStyle,
        paddingSize: paddingSize,
        borderSize: borderSize
    };
};
var getSizingData$1 = getSizingData;
function useListener(target, type, listener) {
    var latestListener = (0, _useLatestDefault.default)(listener);
    _react.useLayoutEffect(function() {
        var handler = function handler(ev) {
            return latestListener.current(ev);
        };
        // might happen if document.fonts is not defined, for instance
        if (!target) return;
        target.addEventListener(type, handler);
        return function() {
            return target.removeEventListener(type, handler);
        };
    }, []);
}
var useFormResetListener = function useFormResetListener(libRef, listener) {
    useListener(document.body, 'reset', function(ev) {
        if (libRef.current.form === ev.target) listener(ev);
    });
};
var useWindowResizeListener = function useWindowResizeListener(listener) {
    useListener(window, 'resize', listener);
};
var useFontsLoadedListener = function useFontsLoadedListener(listener) {
    useListener(document.fonts, 'loadingdone', listener);
};
var _excluded = [
    "cacheMeasurements",
    "maxRows",
    "minRows",
    "onChange",
    "onHeightChange"
];
var TextareaAutosize = function TextareaAutosize(_ref, userRef) {
    var cacheMeasurements = _ref.cacheMeasurements, maxRows = _ref.maxRows, minRows = _ref.minRows, _ref$onChange = _ref.onChange, onChange = _ref$onChange === void 0 ? noop : _ref$onChange, _ref$onHeightChange = _ref.onHeightChange, onHeightChange = _ref$onHeightChange === void 0 ? noop : _ref$onHeightChange, props = (0, _objectWithoutPropertiesLooseDefault.default)(_ref, _excluded);
    var isControlled = props.value !== undefined;
    var libRef = _react.useRef(null);
    var ref = (0, _useComposedRefDefault.default)(libRef, userRef);
    var heightRef = _react.useRef(0);
    var measurementsCacheRef = _react.useRef();
    var resizeTextarea = function resizeTextarea() {
        var node = libRef.current;
        var nodeSizingData = cacheMeasurements && measurementsCacheRef.current ? measurementsCacheRef.current : getSizingData$1(node);
        if (!nodeSizingData) return;
        measurementsCacheRef.current = nodeSizingData;
        var _calculateNodeHeight = calculateNodeHeight(nodeSizingData, node.value || node.placeholder || 'x', minRows, maxRows), height = _calculateNodeHeight[0], rowHeight = _calculateNodeHeight[1];
        if (heightRef.current !== height) {
            heightRef.current = height;
            node.style.setProperty('height', height + "px", 'important');
            onHeightChange(height, {
                rowHeight: rowHeight
            });
        }
    };
    var handleChange = function handleChange(event) {
        if (!isControlled) resizeTextarea();
        onChange(event);
    };
    _react.useLayoutEffect(resizeTextarea);
    useFormResetListener(libRef, function() {
        if (!isControlled) {
            var currentValue = libRef.current.value;
            requestAnimationFrame(function() {
                var node = libRef.current;
                if (node && currentValue !== node.value) resizeTextarea();
            });
        }
    });
    useWindowResizeListener(resizeTextarea);
    useFontsLoadedListener(resizeTextarea);
    return /*#__PURE__*/ _react.createElement("textarea", (0, _extendsDefault.default)({}, props, {
        onChange: handleChange,
        ref: ref
    }));
};
var index = /* #__PURE__ */ _react.forwardRef(TextareaAutosize);

},{"@babel/runtime/helpers/esm/extends":"jSPXj","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dAnBs","react":"c8CN1","use-latest":"bQ0xz","use-composed-ref":"cMV99","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"bQ0xz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return useLatest;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useIsomorphicLayoutEffect = require("use-isomorphic-layout-effect");
var _useIsomorphicLayoutEffectDefault = parcelHelpers.interopDefault(_useIsomorphicLayoutEffect);
var useLatest = function useLatest(value) {
    var ref = (0, _reactDefault.default).useRef(value);
    (0, _useIsomorphicLayoutEffectDefault.default)(function() {
        ref.current = value;
    });
    return ref;
};

},{"react":"c8CN1","use-isomorphic-layout-effect":"g72I3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"g72I3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return index;
});
var _react = require("react");
var index = (0, _react.useLayoutEffect);

},{"react":"c8CN1","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"cMV99":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return useComposedRef;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
// basically Exclude<React.ClassAttributes<T>["ref"], string>
var updateRef = function updateRef(ref, value) {
    if (typeof ref === 'function') {
        ref(value);
        return;
    }
    ref.current = value;
};
var useComposedRef = function useComposedRef(libRef, userRef) {
    var prevUserRef = (0, _reactDefault.default).useRef();
    return (0, _reactDefault.default).useCallback(function(instance) {
        libRef.current = instance;
        if (prevUserRef.current) updateRef(prevUserRef.current, null);
        prevUserRef.current = userRef;
        if (!userRef) return;
        updateRef(userRef, instance);
    }, [
        userRef
    ]);
};

},{"react":"c8CN1","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"iExNs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useFormId", function() {
    return useFormId;
});
parcelHelpers.export(exports, "Form", function() {
    return Form;
});
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _std = require("@reglo/std");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function useFormId() {
    return (0, _react.useState)((0, _std.uuid)())[0];
}
function Form(props) {
    function handleSubmit(event) {
        event.preventDefault();
        props.onSubmit();
    }
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("form", {
        id: props.id,
        className: "componentForm",
        onSubmit: handleSubmit,
        children: props.children
    }, void 0, false, {
        fileName: "src/script/src/dom/views/Account/components/Form.tsx",
        lineNumber: 19,
        columnNumber: 9
    }, this);
}

},{"react/jsx-dev-runtime":"jXZ8I","@reglo/std":"1USo0","react":"c8CN1","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"lNfEP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SelectProductPopup", function() {
    return SelectProductPopup;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _modal = require("../../../../components/Modal");
var _cta = require("../../../../components/Cta");
var _price = require("../../../../../std/price");
var _hooks = require("../../../../../std/hooks");
function SelectProductPopup(props) {
    var _this = this;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), opened = _useState[0], setOpened = _useState[1];
    props.triggerListener(open);
    function open() {
        setOpened(true);
    }
    function close() {
        setOpened(false);
    }
    if (!opened) return null;
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _modal.Modal), {
        title: props.title,
        className: "accountSubscription__selectProductPopup",
        onClose: close,
        children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
            className: "accountSubscription__selectProductPopup__products",
            children: props.view.products.map(function(productView) {
                return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(Product, {
                    view: productView,
                    onClose: close,
                    cta: props.cta
                }, productView.variantId, false, {
                    fileName: "src/script/src/dom/views/Account/views/Subscription/SelectProductPopup.tsx",
                    lineNumber: 40,
                    columnNumber: 57
                }, _this);
            })
        }, void 0, false, {
            fileName: "src/script/src/dom/views/Account/views/Subscription/SelectProductPopup.tsx",
            lineNumber: 39,
            columnNumber: 13
        }, this)
    }, void 0, false, {
        fileName: "src/script/src/dom/views/Account/views/Subscription/SelectProductPopup.tsx",
        lineNumber: 34,
        columnNumber: 9
    }, this);
}
function Product(props) {
    var view = props.view;
    var dispatch = (0, _hooks.useDispatch)();
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), isSubmitting = _useState[0], setIsSubmitting = _useState[1];
    var isDisabled = view.action === null;
    function handleAdd() {
        setIsSubmitting(true);
        setTimeout(function() {
            props.onClose();
            dispatch(view.action);
        }, 600);
    }
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
        className: "accountSubscription__selectProductPopup__product",
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                className: "accountSubscription__selectProductPopup__product__imgContainer",
                children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("img", {
                    className: "accountSubscription__selectProductPopup__product__img",
                    src: view.picture
                }, void 0, false, {
                    fileName: "src/script/src/dom/views/Account/views/Subscription/SelectProductPopup.tsx",
                    lineNumber: 73,
                    columnNumber: 17
                }, this)
            }, void 0, false, {
                fileName: "src/script/src/dom/views/Account/views/Subscription/SelectProductPopup.tsx",
                lineNumber: 72,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("p", {
                className: "accountSubscription__selectProductPopup__product__format",
                children: [
                    view.variantTitle,
                    " - ",
                    (0, _price.formatPrice)(view.price)
                ]
            }, void 0, true, {
                fileName: "src/script/src/dom/views/Account/views/Subscription/SelectProductPopup.tsx",
                lineNumber: 75,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("p", {
                className: "accountSubscription__selectProductPopup__product__title",
                children: [
                    view.productTitle
                ].concat((0, _toConsumableArray._)(view.productSubtitle ? [
                    view.productSubtitle
                ] : [])).join(' - ')
            }, void 0, false, {
                fileName: "src/script/src/dom/views/Account/views/Subscription/SelectProductPopup.tsx",
                lineNumber: 76,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _cta.Cta), {
                label: props.cta,
                size: "XS",
                className: "accountSubscription__selectProductPopup__product__cta",
                onClick: handleAdd,
                isLoading: isSubmitting,
                isDisabled: isDisabled
            }, void 0, false, {
                fileName: "src/script/src/dom/views/Account/views/Subscription/SelectProductPopup.tsx",
                lineNumber: 79,
                columnNumber: 13
            }, this)
        ]
    }, void 0, true, {
        fileName: "src/script/src/dom/views/Account/views/Subscription/SelectProductPopup.tsx",
        lineNumber: 71,
        columnNumber: 9
    }, this);
}

},{"@swc/helpers/_/_sliced_to_array":"ha6sq","@swc/helpers/_/_to_consumable_array":"eqNDD","react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","../../../../components/Modal":"1uIeH","../../../../components/Cta":"beDOe","../../../../../std/price":"bpfMV","../../../../../std/hooks":"j9RPQ","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7iboA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "swapProductView", function() {
    return swapProductView;
});
var _reselect = require("reselect");
var _customerSubscription = require("../store/state/data/customerSubscription");
var _variants = require("../store/state/data/variants");
var _swapProductOfSubscription = require("../useCases/swapProductOfSubscription");
var _selectProductView = require("./selectProductView");
function swapProductView(subscriptionId) {
    return (0, _reselect.createSelector)([
        (0, _customerSubscription.activeSubscriptionsSelector),
        (0, _variants.variantsSelector),
        function() {
            return subscriptionId;
        }
    ], prepareView);
}
function prepareView(subscriptions, variantsState, subscriptionId) {
    return (0, _selectProductView.selectProductView)(subscriptions, variantsState, prepareAction);
    function prepareAction(variantId) {
        return (0, _swapProductOfSubscription.SwapProductOfSubscription)({
            subscriptionId: subscriptionId,
            variantId: variantId
        });
    }
}

},{"reselect":"fb6q1","../store/state/data/customerSubscription":"3ipiV","../store/state/data/variants":"11hc8","../useCases/swapProductOfSubscription":"5sLIq","./selectProductView":"5vPiB","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5vPiB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "selectProductView", function() {
    return selectProductView;
});
var _std = require("@reglo/std");
function selectProductView(subscriptions, variantsState, prepareAction) {
    return {
        products: prepareProducts()
    };
    function selectProducts() {
        return [
            (0, _std.SKU).CHIEN_BISCUITS,
            (0, _std.SKU).CHIEN_STICK_SM,
            (0, _std.SKU).CHIEN_STICK_L,
            (0, _std.SKU).CHIEN_HYPO_S_2,
            (0, _std.SKU).CHIEN_HYPO_S_6,
            (0, _std.SKU).CHIEN_HYPO_M_3,
            (0, _std.SKU).CHIEN_HYPO_M_12,
            (0, _std.SKU).CHIEN_HYPO_L_3,
            (0, _std.SKU).CHIEN_HYPO_L_12,
            (0, _std.SKU).CHIEN_LOWGRAIN_S_2,
            (0, _std.SKU).CHIEN_LOWGRAIN_S_6,
            (0, _std.SKU).CHIEN_LOWGRAIN_M_3,
            (0, _std.SKU).CHIEN_LOWGRAIN_M_12,
            (0, _std.SKU).CHIEN_LOWGRAIN_L_3,
            (0, _std.SKU).CHIEN_LOWGRAIN_L_12,
            (0, _std.SKU).CHIEN_GRAINFREE_S_2,
            (0, _std.SKU).CHIEN_GRAINFREE_S_6,
            (0, _std.SKU).CHIEN_GRAINFREE_M_3,
            (0, _std.SKU).CHIEN_GRAINFREE_M_12,
            (0, _std.SKU).CHIEN_GRAINFREE_L_3,
            (0, _std.SKU).CHIEN_GRAINFREE_L_12,
            (0, _std.SKU).CHIOT_LOWGRAIN_SM_3,
            (0, _std.SKU).CHIOT_LOWGRAIN_SM_12,
            (0, _std.SKU).CHIOT_LOWGRAIN_L_3,
            (0, _std.SKU).CHIOT_LOWGRAIN_L_12,
            (0, _std.SKU).CHIOT_GRAINFREE_3,
            (0, _std.SKU).CHIOT_GRAINFREE_12,
            (0, _std.SKU).CHIEN_LIGHT_3,
            (0, _std.SKU).CHIEN_LIGHT_12,
            (0, _std.SKU).CHIEN_SENIOR_3,
            (0, _std.SKU).CHIEN_SENIOR_12
        ];
    }
    function prepareProducts() {
        return selectProducts().filter(filterOutOfStockProducts).map(prepareProduct);
    }
    function filterOutOfStockProducts(sku) {
        var variant = selectVariantFromSku(sku);
        return variant.outOfStock !== true;
    }
    function prepareProduct(sku) {
        var variant = selectVariantFromSku(sku);
        return {
            variantId: variant.variantId,
            picture: variant.picture,
            productTitle: variant.productTitle,
            productSubtitle: variant.productSubtitle,
            variantTitle: variant.variantTitle,
            price: (0, _std.unwrap)(variant.price.subscription),
            originalPrice: variant.price.original,
            action: localPrepareAction(variant)
        };
    }
    function localPrepareAction(variant) {
        var subscription = selectSubscription(variant);
        if (subscription) return null;
        return prepareAction(variant.variantId);
    }
    function selectSubscription(variant) {
        var _subscriptions_find;
        return (_subscriptions_find = subscriptions.find(function(subscription) {
            return variant.variantId === subscription.variantId;
        })) !== null && _subscriptions_find !== void 0 ? _subscriptions_find : null;
    }
    function selectVariantFromSku(sku) {
        return (0, _std.unwrap)(variantsState.entities.find(function(variant) {
            return variant.sku === sku;
        }));
    }
}

},{"@reglo/std":"1USo0","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"fqaEu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Select", function() {
    return Select;
});
parcelHelpers.export(exports, "NumberSelect", function() {
    return NumberSelect;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _input = require("../../../script/src/dom/views/Account/components/Input");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _dotsLoader = require("../../../script/src/dom/components/DotsLoader");
function Select(props) {
    var id = (0, _input.inputId)();
    var _props_isLoading;
    var isLoading = (_props_isLoading = props.isLoading) !== null && _props_isLoading !== void 0 ? _props_isLoading : false;
    var _props_isPlaceholder;
    var isPlaceholder = (_props_isPlaceholder = props.isPlaceholder) !== null && _props_isPlaceholder !== void 0 ? _props_isPlaceholder : false;
    function select() {
        var _this = this;
        var _props_className;
        var _obj;
        return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
            className: (0, _classnamesDefault.default)((_obj = {
                'componentSelect': true
            }, (0, _defineProperty._)(_obj, (_props_className = props.className) !== null && _props_className !== void 0 ? _props_className : '', true), (0, _defineProperty._)(_obj, 'componentSelect--isLoading', isLoading), (0, _defineProperty._)(_obj, 'componentSelect--isPlaceholder', isPlaceholder), _obj)),
            'data-has_short_labels': hasShortLabels() ? '' : undefined,
            children: [
                hasShortLabels() && /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("select", {
                    id: id,
                    className: "componentSelect__field",
                    "data-id": "shortLabels",
                    required: props.required,
                    onClick: function(event) {
                        return event.stopPropagation();
                    },
                    onChange: function(event) {
                        return props.onChange(event.target.value);
                    },
                    value: props.value,
                    children: props.options.map(function(option) {
                        var _option_shortLabel;
                        return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("option", {
                            value: option.value,
                            children: (_option_shortLabel = option.shortLabel) !== null && _option_shortLabel !== void 0 ? _option_shortLabel : option.label
                        }, option.value, false, {
                            fileName: "src/snippets/components/select/index.tsx",
                            lineNumber: 48,
                            columnNumber: 25
                        }, _this);
                    })
                }, void 0, false, {
                    fileName: "src/snippets/components/select/index.tsx",
                    lineNumber: 38,
                    columnNumber: 38
                }, this),
                /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("select", {
                    id: id,
                    className: "componentSelect__field",
                    "data-id": "fullLabels",
                    required: props.required,
                    onClick: function(event) {
                        return event.stopPropagation();
                    },
                    onChange: function(event) {
                        return props.onChange(event.target.value);
                    },
                    value: props.value,
                    children: props.options.map(function(option) {
                        return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("option", {
                            value: option.value,
                            children: option.label
                        }, option.value, false, {
                            fileName: "src/snippets/components/select/index.tsx",
                            lineNumber: 61,
                            columnNumber: 25
                        }, _this);
                    })
                }, void 0, false, {
                    fileName: "src/snippets/components/select/index.tsx",
                    lineNumber: 51,
                    columnNumber: 17
                }, this),
                /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _dotsLoader.DotsLoader), {
                    isLoading: isLoading
                }, void 0, false, {
                    fileName: "src/snippets/components/select/index.tsx",
                    lineNumber: 64,
                    columnNumber: 17
                }, this)
            ]
        }, void 0, true, {
            fileName: "src/snippets/components/select/index.tsx",
            lineNumber: 29,
            columnNumber: 13
        }, this);
    }
    function hasShortLabels() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = props.options[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var option = _step.value;
                if (option.shortLabel) return true;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return false;
    }
    if (!props.label) return select();
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _input.Input), {
        label: props.label,
        id: id,
        children: select()
    }, void 0, false, {
        fileName: "src/snippets/components/select/index.tsx",
        lineNumber: 83,
        columnNumber: 9
    }, this);
}
function NumberSelect(props) {
    var _props_value;
    function handleChange(value) {
        props.onChange(Number(value));
    }
    var _props_value_toString;
    var value = (_props_value_toString = (_props_value = props.value) === null || _props_value === void 0 ? void 0 : _props_value.toString()) !== null && _props_value_toString !== void 0 ? _props_value_toString : null;
    var options = props.options.map(function(option) {
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, option), {
            value: option.value.toString()
        });
    });
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(Select, (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        onChange: handleChange,
        value: value,
        options: options
    }), void 0, false, {
        fileName: "src/snippets/components/select/index.tsx",
        lineNumber: 100,
        columnNumber: 9
    }, this);
}

},{"@swc/helpers/_/_define_property":"54Zvk","@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_object_spread_props":"fLCYP","react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","../../../script/src/dom/views/Account/components/Input":"3dkG8","classnames":"4SuBi","../../../script/src/dom/components/DotsLoader":"4kA39","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"aOO68":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EditNextOrderDate", function() {
    return EditNextOrderDate;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _modal = require("../../../../components/Modal");
var _datePicker = require("../../../../components/DatePicker");
var _reactRedux = require("react-redux");
var _hooks = require("../../../../../std/hooks");
var _dateFns = require("date-fns");
var _updateNextChargeDate = require("../../../../../app/useCases/updateNextChargeDate");
var _refreshCustomerSubscriptions = require("../../../../../app/useCases/refreshCustomerSubscriptions");
var _std = require("@reglo/std");
var MAX_DATE = 365;
function EditNextOrderDate(props) {
    var view = props.view;
    var dispatch = (0, _reactRedux.useDispatch)();
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), opened = _useState[0], setOpened = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(view.shippingDate), 2), date = _useState1[0], setDate = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)(false), 2), submitting = _useState2[0], setSubmitting = _useState2[1];
    var today = new Date();
    var tomorrow = (0, _dateFns.addDays)(today, 1);
    var deliveryDateRange = (0, _std.calculateEstimatedDeliveryDateRange)(date, view.shippingAddress.carrierCode);
    var _useState3 = (0, _slicedToArray._)((0, _react.useState)(prepareDatesToExclude()), 1), datesToExclude = _useState3[0];
    props.open(open);
    (0, _hooks.useOnEvent)((0, _refreshCustomerSubscriptions.CustomerSubscriptionsRefreshedKey), close);
    function open() {
        setOpened(true);
        setSubmitting(false);
    }
    function close() {
        setOpened(false);
        setSubmitting(false);
    }
    function handleSubmit() {
        dispatch((0, _updateNextChargeDate.UpdateNextChargeDate)({
            date: date
        }));
        setSubmitting(true);
    }
    function renderDeliveryDateRange() {
        var insideDates = [];
        for(var i = 1; i < 10; i++){
            var nextDate = (0, _dateFns.addDays)(deliveryDateRange.start, i);
            if ((0, _dateFns.isBefore)(nextDate, deliveryDateRange.end)) {
                insideDates.push(nextDate);
                continue;
            }
            break;
        }
        var holidaysDates = insideDates.filter(function(date) {
            return !(0, _std.isCarrierWorking)(date);
        });
        return [
            {
                date: deliveryDateRange.start,
                className: "accountSubscriptionEditNextOrderDate__deliveryRange--start"
            }
        ].concat((0, _toConsumableArray._)(insideDates.map(function(date) {
            return {
                date: date,
                className: "accountSubscriptionEditNextOrderDate__deliveryRange"
            };
        })), [
            {
                date: deliveryDateRange.end,
                className: "accountSubscriptionEditNextOrderDate__deliveryRange--end"
            }
        ], (0, _toConsumableArray._)(holidaysDates.map(function(date) {
            return {
                date: date,
                className: "accountSubscriptionEditNextOrderDate__deliveryRange--holiday"
            };
        })));
    }
    function prepareDatesToExclude() {
        var dates = [];
        for(var i = 1; i < MAX_DATE; i++){
            var date = (0, _dateFns.addDays)(today, i);
            if (!(0, _std.isWarehouseWorking)(date)) dates.push(date);
        }
        return dates;
    }
    if (!opened) return null;
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _modal.Modal), {
        title: "Choisir date d'exp\xe9dition",
        ctas: [
            {
                isInverted: true,
                label: 'Annuler',
                onClick: close
            },
            {
                label: 'Enregistrer',
                onClick: handleSubmit,
                isLoading: submitting
            }
        ],
        className: "accountSubscriptionEditNextOrderDate",
        onClose: close,
        children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
            className: "accountSubscriptionEditNextOrderDate__container",
            children: [
                /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _datePicker.DatePicker), {
                    selectedDate: date,
                    onChange: function(date) {
                        return setDate(date);
                    },
                    minDate: tomorrow,
                    maxDate: (0, _dateFns.addDays)(today, MAX_DATE),
                    datesToExclude: datesToExclude,
                    highlights: renderDeliveryDateRange(),
                    className: "accountSubscriptionEditNextOrderDate__datePicker"
                }, void 0, false, {
                    fileName: "src/script/src/dom/views/Account/views/Subscription/EditNextOrderDate.tsx",
                    lineNumber: 91,
                    columnNumber: 17
                }, this),
                /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                    className: "accountSubscriptionEditNextOrderDate__legend",
                    children: [
                        /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                            className: "accountSubscriptionEditNextOrderDate__legend__icon accountSubscriptionEditNextOrderDate__legend__icon--shipping"
                        }, void 0, false, {
                            fileName: "src/script/src/dom/views/Account/views/Subscription/EditNextOrderDate.tsx",
                            lineNumber: 101,
                            columnNumber: 21
                        }, this),
                        "exp\xe9dition : ",
                        (0, _std.formatDate)(date, {
                            withYear: true,
                            withShortMonth: true
                        })
                    ]
                }, void 0, true, {
                    fileName: "src/script/src/dom/views/Account/views/Subscription/EditNextOrderDate.tsx",
                    lineNumber: 100,
                    columnNumber: 17
                }, this),
                /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                    className: "accountSubscriptionEditNextOrderDate__legend",
                    children: [
                        /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                            className: "accountSubscriptionEditNextOrderDate__legend__icon accountSubscriptionEditNextOrderDate__legend__icon--delivery"
                        }, void 0, false, {
                            fileName: "src/script/src/dom/views/Account/views/Subscription/EditNextOrderDate.tsx",
                            lineNumber: 108,
                            columnNumber: 21
                        }, this),
                        "livraison : ",
                        (0, _std.formatRange)(deliveryDateRange)
                    ]
                }, void 0, true, {
                    fileName: "src/script/src/dom/views/Account/views/Subscription/EditNextOrderDate.tsx",
                    lineNumber: 107,
                    columnNumber: 17
                }, this)
            ]
        }, void 0, true, {
            fileName: "src/script/src/dom/views/Account/views/Subscription/EditNextOrderDate.tsx",
            lineNumber: 90,
            columnNumber: 13
        }, this)
    }, void 0, false, {
        fileName: "src/script/src/dom/views/Account/views/Subscription/EditNextOrderDate.tsx",
        lineNumber: 81,
        columnNumber: 9
    }, this);
}

},{"@swc/helpers/_/_sliced_to_array":"ha6sq","@swc/helpers/_/_to_consumable_array":"eqNDD","react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","../../../../components/Modal":"1uIeH","../../../../components/DatePicker":"2aiwZ","react-redux":"ghMZu","../../../../../std/hooks":"j9RPQ","date-fns":"6cTOl","../../../../../app/useCases/updateNextChargeDate":"hgcCc","../../../../../app/useCases/refreshCustomerSubscriptions":"f4vE2","@reglo/std":"1USo0","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2aiwZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DatePicker", function() {
    return DatePicker;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDatepicker = require("react-datepicker");
var _reactDatepickerDefault = parcelHelpers.interopDefault(_reactDatepicker);
var _locale = require("date-fns/locale");
function DatePicker(props) {
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
        className: `componentDatePicker ${props.className}`,
        children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _reactDatepickerDefault.default), {
            selected: props.selectedDate,
            onChange: props.onChange,
            locale: (0, _locale.fr),
            minDate: props.minDate,
            maxDate: props.maxDate,
            excludeDates: props.datesToExclude,
            dateFormat: "dd/MM/yyyy",
            inline: true,
            fixedHeight: true,
            highlightDates: props.highlights ? props.highlights.map(function(highlight) {
                return (0, _defineProperty._)({}, highlight.className, [
                    highlight.date
                ]);
            }) : undefined
        }, void 0, false, {
            fileName: "src/script/src/dom/components/DatePicker.tsx",
            lineNumber: 19,
            columnNumber: 13
        }, this)
    }, void 0, false, {
        fileName: "src/script/src/dom/components/DatePicker.tsx",
        lineNumber: 18,
        columnNumber: 9
    }, this);
}

},{"@swc/helpers/_/_define_property":"54Zvk","react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","react-datepicker":"g4Xdo","date-fns/locale":"gjKaW","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"g4Xdo":[function(require,module,exports,__globalThis) {
!function(e, t) {
    t(exports, require("55b400dfb9477df9"), require("6a082dc438cb1ca2"), require("3647656f9c7ebc5e"), require("13c776570732a9da"), require("6553b0b4b603e1c3"), require("d7b993ace1eca80"), require("786b9925c1b6b5ed"), require("4f1b37d05fed00b3"), require("5fc940b8b11b2f30"), require("b78d0278e54da1b4"), require("baecc74d7df402ea"), require("13428a01c277b105"), require("7360dafd9cf06bde"), require("aa659b497503e983"), require("7b7bf8fb2c20e0c7"), require("f501b8cd52ae4ff"), require("d616e9f0b9bc7b7a"), require("9e212fc4b323ed41"), require("e8ff49b0d1cab426"), require("12eec1f6d562e008"), require("72fc20cc52029f11"), require("42e3036b4499153e"), require("5592c752ef1290f4"), require("8406427195a66845"), require("fa470ac376b26caf"), require("bf3222da2f520817"), require("685dda4962dc82e1"), require("d6dea87c85b53e02"), require("b9a1398c1c94250d"), require("e1fbbdf633f9e5ae"), require("8ac41f1b252a0973"), require("156a522b3b8fd124"), require("f2620442a53b80d6"), require("1b94d4eb34edeca3"), require("47020b485e994171"), require("9818583261d8a102"), require("1a7d4440a348b466"), require("50dce9ec585a5332"), require("cdc90b6df52760f"), require("2fdd28e51cf3c8b2"), require("72fb68fdc0d9bca3"), require("964e71bf85841794"), require("38468de993ee0549"), require("ec1866b328e982ea"), require("5c05196fbf6d6b4d"), require("9a6937c0aa7a418e"), require("23c6d2169b7feabe"), require("7ec00ac1947d54ca"), require("fda4089c257f1876"), require("b5061c3c95f48e73"), require("f57afb99b9b06613"), require("496ef8c8ed2b34d6"), require("6663b9b2b265a941"), require("c3348d940b830a7f"), require("53a4aaeeb87e1c51"), require("45f66dd8a17e85aa"), require("a3a5398768dc185f"), require("201a807b2e6adc5e"), require("a89a534c753bb4c3"), require("11a993db5effee60"), require("96de361de41dc920"), require("acb830835f9d8af1"), require("80c2a8fbe4339722"));
}(this, function(e, t, r, a, n, o, s, i, p, l, c, d, u, f, h, m, y, v, D, g, k, w, b, S, C, _, M, P, E, N, x, Y, O, I, T, R, L, F, A, W, q, K, B, Q, H, j, V, U, z, $, G, J, X, Z, ee, te, re, ae, ne, oe, se, ie, pe, le) {
    "use strict";
    function ce(e) {
        return e && "object" == typeof e && "default" in e ? e : {
            default: e
        };
    }
    var de = ce(t), ue = ce(a), fe = ce(n), he = ce(o), me = ce(s), ye = ce(i), ve = ce(p), De = ce(l), ge = ce(c), ke = ce(d), we = ce(u), be = ce(f), Se = ce(h), Ce = ce(m), _e = ce(y), Me = ce(v), Pe = ce(D), Ee = ce(g), Ne = ce(k), xe = ce(w), Ye = ce(b), Oe = ce(S), Ie = ce(C), Te = ce(_), Re = ce(M), Le = ce(P), Fe = ce(E), Ae = ce(N), We = ce(x), qe = ce(Y), Ke = ce(O), Be = ce(I), Qe = ce(T), He = ce(R), je = ce(L), Ve = ce(F), Ue = ce(A), ze = ce(W), $e = ce(q), Ge = ce(K), Je = ce(B), Xe = ce(Q), Ze = ce(H), et = ce(j), tt = ce(U), rt = ce(z), at = ce($), nt = ce(G), ot = ce(J), st = ce(X), it = ce(Z), pt = ce(ee), lt = ce(te), ct = ce(re), dt = ce(ae), ut = ce(ne), ft = ce(oe), ht = ce(se), mt = ce(ie), yt = ce(le);
    function vt(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var _$a = Object.getOwnPropertySymbols(e);
            t && (_$a = _$a.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), r.push.apply(r, _$a);
        }
        return r;
    }
    function Dt(e) {
        for(var _$t = 1; _$t < arguments.length; _$t++){
            var r = null != arguments[_$t] ? arguments[_$t] : {};
            _$t % 2 ? vt(Object(r), !0).forEach(function(t) {
                St(e, t, r[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : vt(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
            });
        }
        return e;
    }
    function gt(e) {
        return gt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function gt(e) {
            return typeof e;
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        }, gt(e);
    }
    function kt(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function wt(e, t) {
        for(var r = 0; r < t.length; r++){
            var _$a = t[r];
            _$a.enumerable = _$a.enumerable || !1, _$a.configurable = !0, "value" in _$a && (_$a.writable = !0), Object.defineProperty(e, Ot(_$a.key), _$a);
        }
    }
    function bt(e, t, r) {
        return t && wt(e.prototype, t), r && wt(e, r), Object.defineProperty(e, "prototype", {
            writable: !1
        }), e;
    }
    function St(e, t, r) {
        return (t = Ot(t)) in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e;
    }
    function Ct() {
        return Ct = Object.assign ? Object.assign.bind() : function Ct(e) {
            for(var _$t = 1; _$t < arguments.length; _$t++){
                var r = arguments[_$t];
                for(var _$a in r)Object.prototype.hasOwnProperty.call(r, _$a) && (e[_$a] = r[_$a]);
            }
            return e;
        }, Ct.apply(this, arguments);
    }
    function _t(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
            constructor: {
                value: e,
                writable: !0,
                configurable: !0
            }
        }), Object.defineProperty(e, "prototype", {
            writable: !1
        }), t && Pt(e, t);
    }
    function Mt(e) {
        return Mt = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function Mt(e) {
            return e.__proto__ || Object.getPrototypeOf(e);
        }, Mt(e);
    }
    function Pt(e, t) {
        return Pt = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function Pt(e, t) {
            return e.__proto__ = t, e;
        }, Pt(e, t);
    }
    function Et(e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
    }
    function Nt(e) {
        var _$t = function() {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, _$a = Mt(e);
            if (_$t) {
                var _$n = Mt(this).constructor;
                r = Reflect.construct(_$a, arguments, _$n);
            } else r = _$a.apply(this, arguments);
            return function(e, t) {
                if (t && ("object" == typeof t || "function" == typeof t)) return t;
                if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                return Et(e);
            }(this, r);
        };
    }
    function xt(e) {
        return function(e) {
            if (Array.isArray(e)) return Yt(e);
        }(e) || function(e) {
            if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
        }(e) || function(e, t) {
            if (!e) return;
            if ("string" == typeof e) return Yt(e, t);
            var r = Object.prototype.toString.call(e).slice(8, -1);
            "Object" === r && e.constructor && (r = e.constructor.name);
            if ("Map" === r || "Set" === r) return Array.from(e);
            if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Yt(e, t);
        }(e) || function() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
    }
    function Yt(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for(var r = 0, _$a = new Array(t); r < t; r++)_$a[r] = e[r];
        return _$a;
    }
    function Ot(e) {
        var _$t = function(e, t) {
            if ("object" != typeof e || null === e) return e;
            var r = e[Symbol.toPrimitive];
            if (void 0 !== r) {
                var _$a = r.call(e, t || "default");
                if ("object" != typeof _$a) return _$a;
                throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return ("string" === t ? String : Number)(e);
        }(e, "string");
        return "symbol" == typeof _$t ? _$t : String(_$t);
    }
    var It = function It(e, t) {
        switch(e){
            case "P":
                return t.date({
                    width: "short"
                });
            case "PP":
                return t.date({
                    width: "medium"
                });
            case "PPP":
                return t.date({
                    width: "long"
                });
            default:
                return t.date({
                    width: "full"
                });
        }
    }, Tt = function Tt(e, t) {
        switch(e){
            case "p":
                return t.time({
                    width: "short"
                });
            case "pp":
                return t.time({
                    width: "medium"
                });
            case "ppp":
                return t.time({
                    width: "long"
                });
            default:
                return t.time({
                    width: "full"
                });
        }
    }, Rt = {
        p: Tt,
        P: function P(e, t) {
            var r, _$a = e.match(/(P+)(p+)?/) || [], _$n = _$a[1], _$o = _$a[2];
            if (!_$o) return It(e, t);
            switch(_$n){
                case "P":
                    r = t.dateTime({
                        width: "short"
                    });
                    break;
                case "PP":
                    r = t.dateTime({
                        width: "medium"
                    });
                    break;
                case "PPP":
                    r = t.dateTime({
                        width: "long"
                    });
                    break;
                default:
                    r = t.dateTime({
                        width: "full"
                    });
            }
            return r.replace("{{date}}", It(_$n, t)).replace("{{time}}", Tt(_$o, t));
        }
    }, Lt = 12, Ft = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
    function At(e) {
        var _$t = e ? "string" == typeof e || e instanceof String ? ft.default(e) : dt.default(e) : new Date;
        return Wt(_$t) ? _$t : null;
    }
    function Wt(e, t) {
        return t = t || new Date("1/1/1000"), he.default(e) && !lt.default(e, t);
    }
    function qt(e, t, r) {
        if ("en" === r) return me.default(e, t, {
            awareOfUnicodeTokens: !0
        });
        var _$a = tr(r);
        return r && !_$a && console.warn('A locale object was not found for the provided string ["'.concat(r, '"].')), !_$a && er() && tr(er()) && (_$a = tr(er())), me.default(e, t, {
            locale: _$a || null,
            awareOfUnicodeTokens: !0
        });
    }
    function Kt(e, t) {
        var r = t.dateFormat, _$a = t.locale;
        return e && qt(e, Array.isArray(r) ? r[0] : r, _$a) || "";
    }
    function Bt(e, t) {
        var r = t.hour, _$a = void 0 === r ? 0 : r, _$n = t.minute, _$o = void 0 === _$n ? 0 : _$n, _$s = t.second, _$i = void 0 === _$s ? 0 : _$s;
        return qe.default(We.default(Ae.default(e, _$i), _$o), _$a);
    }
    function Qt(e, t, r) {
        var _$a = tr(t || er());
        return Ge.default(e, {
            locale: _$a,
            weekStartsOn: r
        });
    }
    function Ht(e) {
        return Je.default(e);
    }
    function jt(e) {
        return Ze.default(e);
    }
    function Vt(e) {
        return Xe.default(e);
    }
    function Ut() {
        return $e.default(At());
    }
    function zt(e, t) {
        return e && t ? st.default(e, t) : !e && !t;
    }
    function $t(e, t) {
        return e && t ? ot.default(e, t) : !e && !t;
    }
    function Gt(e, t) {
        return e && t ? it.default(e, t) : !e && !t;
    }
    function Jt(e, t) {
        return e && t ? nt.default(e, t) : !e && !t;
    }
    function Xt(e, t) {
        return e && t ? at.default(e, t) : !e && !t;
    }
    function Zt(e, t, r) {
        var _$a, _$n = $e.default(t), _$o = et.default(r);
        try {
            _$a = ct.default(e, {
                start: _$n,
                end: _$o
            });
        } catch (e) {
            _$a = !1;
        }
        return _$a;
    }
    function er() {
        return ("undefined" != typeof window ? window : globalThis).__localeId__;
    }
    function tr(e) {
        if ("string" == typeof e) {
            var _$t = "undefined" != typeof window ? window : globalThis;
            return _$t.__localeData__ ? _$t.__localeData__[e] : null;
        }
        return e;
    }
    function rr(e, t) {
        return qt(Ke.default(At(), e), "LLLL", t);
    }
    function ar(e, t) {
        return qt(Ke.default(At(), e), "LLL", t);
    }
    function nr(e) {
        var _$t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = _$t.minDate, _$a = _$t.maxDate, _$n = _$t.excludeDates, _$o = _$t.excludeDateIntervals, _$s = _$t.includeDates, _$i = _$t.includeDateIntervals, _$p = _$t.filterDate;
        return ur(e, {
            minDate: r,
            maxDate: _$a
        }) || _$n && _$n.some(function(t) {
            return Jt(e, t);
        }) || _$o && _$o.some(function(t) {
            var r = t.start, _$a = t.end;
            return ct.default(e, {
                start: r,
                end: _$a
            });
        }) || _$s && !_$s.some(function(t) {
            return Jt(e, t);
        }) || _$i && !_$i.some(function(t) {
            var r = t.start, _$a = t.end;
            return ct.default(e, {
                start: r,
                end: _$a
            });
        }) || _$p && !_$p(At(e)) || !1;
    }
    function or(e) {
        var _$t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = _$t.excludeDates, _$a = _$t.excludeDateIntervals;
        return _$a && _$a.length > 0 ? _$a.some(function(t) {
            var r = t.start, _$a = t.end;
            return ct.default(e, {
                start: r,
                end: _$a
            });
        }) : r && r.some(function(t) {
            return Jt(e, t);
        }) || !1;
    }
    function sr(e) {
        var _$t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = _$t.minDate, _$a = _$t.maxDate, _$n = _$t.excludeDates, _$o = _$t.includeDates, _$s = _$t.filterDate;
        return ur(e, {
            minDate: Je.default(r),
            maxDate: tt.default(_$a)
        }) || _$n && _$n.some(function(t) {
            return $t(e, t);
        }) || _$o && !_$o.some(function(t) {
            return $t(e, t);
        }) || _$s && !_$s(At(e)) || !1;
    }
    function ir(e, t, r, a) {
        var _$n = Le.default(e), _$o = Te.default(e), _$s = Le.default(t), _$i = Te.default(t), _$p = Le.default(a);
        return _$n === _$s && _$n === _$p ? _$o <= r && r <= _$i : _$n < _$s ? _$p === _$n && _$o <= r || _$p === _$s && _$i >= r || _$p < _$s && _$p > _$n : void 0;
    }
    function pr(e) {
        var _$t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = _$t.minDate, _$a = _$t.maxDate, _$n = _$t.excludeDates, _$o = _$t.includeDates, _$s = _$t.filterDate;
        return ur(e, {
            minDate: r,
            maxDate: _$a
        }) || _$n && _$n.some(function(t) {
            return Gt(e, t);
        }) || _$o && !_$o.some(function(t) {
            return Gt(e, t);
        }) || _$s && !_$s(At(e)) || !1;
    }
    function lr(e, t, r) {
        if (!he.default(t) || !he.default(r)) return !1;
        var _$a = Le.default(t), _$n = Le.default(r);
        return _$a <= e && _$n >= e;
    }
    function cr(e) {
        var _$t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = _$t.minDate, _$a = _$t.maxDate, _$n = _$t.excludeDates, _$o = _$t.includeDates, _$s = _$t.filterDate, _$i = new Date(e, 0, 1);
        return ur(_$i, {
            minDate: Ze.default(r),
            maxDate: rt.default(_$a)
        }) || _$n && _$n.some(function(e) {
            return zt(_$i, e);
        }) || _$o && !_$o.some(function(e) {
            return zt(_$i, e);
        }) || _$s && !_$s(At(_$i)) || !1;
    }
    function dr(e, t, r, a) {
        var _$n = Le.default(e), _$o = Re.default(e), _$s = Le.default(t), _$i = Re.default(t), _$p = Le.default(a);
        return _$n === _$s && _$n === _$p ? _$o <= r && r <= _$i : _$n < _$s ? _$p === _$n && _$o <= r || _$p === _$s && _$i >= r || _$p < _$s && _$p > _$n : void 0;
    }
    function ur(e) {
        var _$t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = _$t.minDate, _$a = _$t.maxDate;
        return r && Ve.default(e, r) < 0 || _$a && Ve.default(e, _$a) > 0;
    }
    function fr(e, t) {
        return t.some(function(t) {
            return xe.default(t) === xe.default(e) && Ne.default(t) === Ne.default(e);
        });
    }
    function hr(e) {
        var _$t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = _$t.excludeTimes, _$a = _$t.includeTimes, _$n = _$t.filterTime;
        return r && fr(e, r) || _$a && !fr(e, _$a) || _$n && !_$n(e) || !1;
    }
    function mr(e, t) {
        var r = t.minTime, _$a = t.maxTime;
        if (!r || !_$a) throw new Error("Both minTime and maxTime props required");
        var _$n, _$o = At(), _$s = qe.default(We.default(_$o, Ne.default(e)), xe.default(e)), _$i = qe.default(We.default(_$o, Ne.default(r)), xe.default(r)), _$p = qe.default(We.default(_$o, Ne.default(_$a)), xe.default(_$a));
        try {
            _$n = !ct.default(_$s, {
                start: _$i,
                end: _$p
            });
        } catch (e) {
            _$n = !1;
        }
        return _$n;
    }
    function yr(e) {
        var _$t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = _$t.minDate, _$a = _$t.includeDates, _$n = _e.default(e, 1);
        return r && Ue.default(r, _$n) > 0 || _$a && _$a.every(function(e) {
            return Ue.default(e, _$n) > 0;
        }) || !1;
    }
    function vr(e) {
        var _$t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = _$t.maxDate, _$a = _$t.includeDates, _$n = ke.default(e, 1);
        return r && Ue.default(_$n, r) > 0 || _$a && _$a.every(function(e) {
            return Ue.default(_$n, e) > 0;
        }) || !1;
    }
    function Dr(e) {
        var _$t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = _$t.minDate, _$a = _$t.includeDates, _$n = Pe.default(e, 1);
        return r && ze.default(r, _$n) > 0 || _$a && _$a.every(function(e) {
            return ze.default(e, _$n) > 0;
        }) || !1;
    }
    function gr(e) {
        var _$t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = _$t.maxDate, _$a = _$t.includeDates, _$n = be.default(e, 1);
        return r && ze.default(_$n, r) > 0 || _$a && _$a.every(function(e) {
            return ze.default(_$n, e) > 0;
        }) || !1;
    }
    function kr(e) {
        var _$t = e.minDate, r = e.includeDates;
        if (r && _$t) {
            var _$a = r.filter(function(e) {
                return Ve.default(e, _$t) >= 0;
            });
            return He.default(_$a);
        }
        return r ? He.default(r) : _$t;
    }
    function wr(e) {
        var _$t = e.maxDate, r = e.includeDates;
        if (r && _$t) {
            var _$a = r.filter(function(e) {
                return Ve.default(e, _$t) <= 0;
            });
            return je.default(_$a);
        }
        return r ? je.default(r) : _$t;
    }
    function br() {
        for(var _$e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], _$t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "react-datepicker__day--highlighted", r = new Map, _$a = 0, _$n = _$e.length; _$a < _$n; _$a++){
            var _$o = _$e[_$a];
            if (fe.default(_$o)) {
                var _$s = qt(_$o, "MM.dd.yyyy"), _$i = r.get(_$s) || [];
                _$i.includes(_$t) || (_$i.push(_$t), r.set(_$s, _$i));
            } else if ("object" === gt(_$o)) {
                var _$p = Object.keys(_$o), _$l = _$p[0], _$c = _$o[_$p[0]];
                if ("string" == typeof _$l && _$c.constructor === Array) for(var _$d = 0, _$u = _$c.length; _$d < _$u; _$d++){
                    var _$f = qt(_$c[_$d], "MM.dd.yyyy"), _$h = r.get(_$f) || [];
                    _$h.includes(_$l) || (_$h.push(_$l), r.set(_$f, _$h));
                }
            }
        }
        return r;
    }
    function Sr() {
        var _$e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], _$t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "react-datepicker__day--holidays", r = new Map;
        return _$e.forEach(function(e) {
            var _$a = e.date, _$n = e.holidayName;
            if (fe.default(_$a)) {
                var _$o = qt(_$a, "MM.dd.yyyy"), _$s = r.get(_$o) || {};
                if (!("className" in _$s) || _$s.className !== _$t || (_$i = _$s.holidayNames, _$p = [
                    _$n
                ], _$i.length !== _$p.length || !_$i.every(function(e, t) {
                    return e === _$p[t];
                }))) {
                    var _$i, _$p;
                    _$s.className = _$t;
                    var _$l = _$s.holidayNames;
                    _$s.holidayNames = _$l ? [].concat(xt(_$l), [
                        _$n
                    ]) : [
                        _$n
                    ], r.set(_$o, _$s);
                }
            }
        }), r;
    }
    function Cr(e, t, r, a, n) {
        for(var _$o = n.length, _$s = [], _$i = 0; _$i < _$o; _$i++){
            var _$p = ye.default(ve.default(e, xe.default(n[_$i])), Ne.default(n[_$i])), _$l = ye.default(e, (r + 1) * a);
            pt.default(_$p, t) && lt.default(_$p, _$l) && _$s.push(n[_$i]);
        }
        return _$s;
    }
    function _r(e) {
        return e < 10 ? "0".concat(e) : "".concat(e);
    }
    function Mr(e) {
        var _$t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Lt, r = Math.ceil(Le.default(e) / _$t) * _$t;
        return {
            startPeriod: r - (_$t - 1),
            endPeriod: r
        };
    }
    function Pr(e) {
        var _$t = e.getSeconds(), r = e.getMilliseconds();
        return dt.default(e.getTime() - 1e3 * _$t - r);
    }
    function Er(e, t, r, a) {
        for(var _$n = [], _$o = 0; _$o < 2 * t + 1; _$o++){
            var _$s = e + t - _$o, _$i = !0;
            r && (_$i = Le.default(r) <= _$s), a && _$i && (_$i = Le.default(a) >= _$s), _$i && _$n.push(_$s);
        }
        return _$n;
    }
    var Nr = function(e) {
        _t(a, e);
        var r = Nt(a);
        function a(e) {
            var _$n;
            kt(this, a), St(Et(_$n = r.call(this, e)), "renderOptions", function() {
                var _$e = _$n.props.year, _$t = _$n.state.yearsList.map(function(t) {
                    return de.default.createElement("div", {
                        className: _$e === t ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option",
                        key: t,
                        onClick: _$n.onChange.bind(Et(_$n), t),
                        "aria-selected": _$e === t ? "true" : void 0
                    }, _$e === t ? de.default.createElement("span", {
                        className: "react-datepicker__year-option--selected"
                    }, "\u2713") : "", t);
                }), r = _$n.props.minDate ? Le.default(_$n.props.minDate) : null, _$a = _$n.props.maxDate ? Le.default(_$n.props.maxDate) : null;
                return _$a && _$n.state.yearsList.find(function(e) {
                    return e === _$a;
                }) || _$t.unshift(de.default.createElement("div", {
                    className: "react-datepicker__year-option",
                    key: "upcoming",
                    onClick: _$n.incrementYears
                }, de.default.createElement("a", {
                    className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming"
                }))), r && _$n.state.yearsList.find(function(e) {
                    return e === r;
                }) || _$t.push(de.default.createElement("div", {
                    className: "react-datepicker__year-option",
                    key: "previous",
                    onClick: _$n.decrementYears
                }, de.default.createElement("a", {
                    className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous"
                }))), _$t;
            }), St(Et(_$n), "onChange", function(e) {
                _$n.props.onChange(e);
            }), St(Et(_$n), "handleClickOutside", function() {
                _$n.props.onCancel();
            }), St(Et(_$n), "shiftYears", function(e) {
                var _$t = _$n.state.yearsList.map(function(t) {
                    return t + e;
                });
                _$n.setState({
                    yearsList: _$t
                });
            }), St(Et(_$n), "incrementYears", function() {
                return _$n.shiftYears(1);
            }), St(Et(_$n), "decrementYears", function() {
                return _$n.shiftYears(-1);
            });
            var _$o = e.yearDropdownItemNumber, _$s = e.scrollableYearDropdown, _$i = _$o || (_$s ? 10 : 5);
            return _$n.state = {
                yearsList: Er(_$n.props.year, _$i, _$n.props.minDate, _$n.props.maxDate)
            }, _$n.dropdownRef = t.createRef(), _$n;
        }
        return bt(a, [
            {
                key: "componentDidMount",
                value: function value() {
                    var _$e = this.dropdownRef.current;
                    if (_$e) {
                        var _$t = _$e.children ? Array.from(_$e.children) : null, r = _$t ? _$t.find(function(e) {
                            return e.ariaSelected;
                        }) : null;
                        _$e.scrollTop = r ? r.offsetTop + (r.clientHeight - _$e.clientHeight) / 2 : (_$e.scrollHeight - _$e.clientHeight) / 2;
                    }
                }
            },
            {
                key: "render",
                value: function value() {
                    var _$e = ue.default({
                        "react-datepicker__year-dropdown": !0,
                        "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown
                    });
                    return de.default.createElement("div", {
                        className: _$e,
                        ref: this.dropdownRef
                    }, this.renderOptions());
                }
            }
        ]), a;
    }(de.default.Component), xr = ht.default(Nr), Yr = function(e) {
        _t(r, e);
        var _$t = Nt(r);
        function r() {
            var _$e;
            kt(this, r);
            for(var _$a = arguments.length, _$n = new Array(_$a), _$o = 0; _$o < _$a; _$o++)_$n[_$o] = arguments[_$o];
            return St(Et(_$e = _$t.call.apply(_$t, [
                this
            ].concat(_$n))), "state", {
                dropdownVisible: !1
            }), St(Et(_$e), "renderSelectOptions", function() {
                for(var _$t = _$e.props.minDate ? Le.default(_$e.props.minDate) : 1900, _$r = _$e.props.maxDate ? Le.default(_$e.props.maxDate) : 2100, _$a = [], _$n = _$t; _$n <= _$r; _$n++)_$a.push(de.default.createElement("option", {
                    key: _$n,
                    value: _$n
                }, _$n));
                return _$a;
            }), St(Et(_$e), "onSelectChange", function(t) {
                _$e.onChange(t.target.value);
            }), St(Et(_$e), "renderSelectMode", function() {
                return de.default.createElement("select", {
                    value: _$e.props.year,
                    className: "react-datepicker__year-select",
                    onChange: _$e.onSelectChange
                }, _$e.renderSelectOptions());
            }), St(Et(_$e), "renderReadView", function(t) {
                return de.default.createElement("div", {
                    key: "read",
                    style: {
                        visibility: t ? "visible" : "hidden"
                    },
                    className: "react-datepicker__year-read-view",
                    onClick: function onClick(t) {
                        return _$e.toggleDropdown(t);
                    }
                }, de.default.createElement("span", {
                    className: "react-datepicker__year-read-view--down-arrow"
                }), de.default.createElement("span", {
                    className: "react-datepicker__year-read-view--selected-year"
                }, _$e.props.year));
            }), St(Et(_$e), "renderDropdown", function() {
                return de.default.createElement(xr, {
                    key: "dropdown",
                    year: _$e.props.year,
                    onChange: _$e.onChange,
                    onCancel: _$e.toggleDropdown,
                    minDate: _$e.props.minDate,
                    maxDate: _$e.props.maxDate,
                    scrollableYearDropdown: _$e.props.scrollableYearDropdown,
                    yearDropdownItemNumber: _$e.props.yearDropdownItemNumber
                });
            }), St(Et(_$e), "renderScrollMode", function() {
                var _$t = _$e.state.dropdownVisible, _$r = [
                    _$e.renderReadView(!_$t)
                ];
                return _$t && _$r.unshift(_$e.renderDropdown()), _$r;
            }), St(Et(_$e), "onChange", function(t) {
                _$e.toggleDropdown(), t !== _$e.props.year && _$e.props.onChange(t);
            }), St(Et(_$e), "toggleDropdown", function(t) {
                _$e.setState({
                    dropdownVisible: !_$e.state.dropdownVisible
                }, function() {
                    _$e.props.adjustDateOnChange && _$e.handleYearChange(_$e.props.date, t);
                });
            }), St(Et(_$e), "handleYearChange", function(t, r) {
                _$e.onSelect(t, r), _$e.setOpen();
            }), St(Et(_$e), "onSelect", function(t, r) {
                _$e.props.onSelect && _$e.props.onSelect(t, r);
            }), St(Et(_$e), "setOpen", function() {
                _$e.props.setOpen && _$e.props.setOpen(!0);
            }), _$e;
        }
        return bt(r, [
            {
                key: "render",
                value: function value() {
                    var _$e;
                    switch(this.props.dropdownMode){
                        case "scroll":
                            _$e = this.renderScrollMode();
                            break;
                        case "select":
                            _$e = this.renderSelectMode();
                    }
                    return de.default.createElement("div", {
                        className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode)
                    }, _$e);
                }
            }
        ]), r;
    }(de.default.Component), Or = function(e) {
        _t(r, e);
        var _$t = Nt(r);
        function r() {
            var _$e;
            kt(this, r);
            for(var _$a = arguments.length, _$n = new Array(_$a), _$o = 0; _$o < _$a; _$o++)_$n[_$o] = arguments[_$o];
            return St(Et(_$e = _$t.call.apply(_$t, [
                this
            ].concat(_$n))), "isSelectedMonth", function(t) {
                return _$e.props.month === t;
            }), St(Et(_$e), "renderOptions", function() {
                return _$e.props.monthNames.map(function(t, r) {
                    return de.default.createElement("div", {
                        className: _$e.isSelectedMonth(r) ? "react-datepicker__month-option react-datepicker__month-option--selected_month" : "react-datepicker__month-option",
                        key: t,
                        onClick: _$e.onChange.bind(Et(_$e), r),
                        "aria-selected": _$e.isSelectedMonth(r) ? "true" : void 0
                    }, _$e.isSelectedMonth(r) ? de.default.createElement("span", {
                        className: "react-datepicker__month-option--selected"
                    }, "\u2713") : "", t);
                });
            }), St(Et(_$e), "onChange", function(t) {
                return _$e.props.onChange(t);
            }), St(Et(_$e), "handleClickOutside", function() {
                return _$e.props.onCancel();
            }), _$e;
        }
        return bt(r, [
            {
                key: "render",
                value: function value() {
                    return de.default.createElement("div", {
                        className: "react-datepicker__month-dropdown"
                    }, this.renderOptions());
                }
            }
        ]), r;
    }(de.default.Component), Ir = ht.default(Or), Tr = function(e) {
        _t(r, e);
        var _$t = Nt(r);
        function r() {
            var _$e;
            kt(this, r);
            for(var _$a = arguments.length, _$n = new Array(_$a), _$o = 0; _$o < _$a; _$o++)_$n[_$o] = arguments[_$o];
            return St(Et(_$e = _$t.call.apply(_$t, [
                this
            ].concat(_$n))), "state", {
                dropdownVisible: !1
            }), St(Et(_$e), "renderSelectOptions", function(e) {
                return e.map(function(e, t) {
                    return de.default.createElement("option", {
                        key: t,
                        value: t
                    }, e);
                });
            }), St(Et(_$e), "renderSelectMode", function(t) {
                return de.default.createElement("select", {
                    value: _$e.props.month,
                    className: "react-datepicker__month-select",
                    onChange: function onChange(t) {
                        return _$e.onChange(t.target.value);
                    }
                }, _$e.renderSelectOptions(t));
            }), St(Et(_$e), "renderReadView", function(t, r) {
                return de.default.createElement("div", {
                    key: "read",
                    style: {
                        visibility: t ? "visible" : "hidden"
                    },
                    className: "react-datepicker__month-read-view",
                    onClick: _$e.toggleDropdown
                }, de.default.createElement("span", {
                    className: "react-datepicker__month-read-view--down-arrow"
                }), de.default.createElement("span", {
                    className: "react-datepicker__month-read-view--selected-month"
                }, r[_$e.props.month]));
            }), St(Et(_$e), "renderDropdown", function(t) {
                return de.default.createElement(Ir, {
                    key: "dropdown",
                    month: _$e.props.month,
                    monthNames: t,
                    onChange: _$e.onChange,
                    onCancel: _$e.toggleDropdown
                });
            }), St(Et(_$e), "renderScrollMode", function(t) {
                var _$r = _$e.state.dropdownVisible, _$a = [
                    _$e.renderReadView(!_$r, t)
                ];
                return _$r && _$a.unshift(_$e.renderDropdown(t)), _$a;
            }), St(Et(_$e), "onChange", function(t) {
                _$e.toggleDropdown(), t !== _$e.props.month && _$e.props.onChange(t);
            }), St(Et(_$e), "toggleDropdown", function() {
                return _$e.setState({
                    dropdownVisible: !_$e.state.dropdownVisible
                });
            }), _$e;
        }
        return bt(r, [
            {
                key: "render",
                value: function value() {
                    var _$e, _$t = this, _$r = [
                        0,
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7,
                        8,
                        9,
                        10,
                        11
                    ].map(this.props.useShortMonthInDropdown ? function(e) {
                        return ar(e, _$t.props.locale);
                    } : function(e) {
                        return rr(e, _$t.props.locale);
                    });
                    switch(this.props.dropdownMode){
                        case "scroll":
                            _$e = this.renderScrollMode(_$r);
                            break;
                        case "select":
                            _$e = this.renderSelectMode(_$r);
                    }
                    return de.default.createElement("div", {
                        className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode)
                    }, _$e);
                }
            }
        ]), r;
    }(de.default.Component);
    function Rr(e, t) {
        for(var r = [], _$a = Ht(e), _$n = Ht(t); !pt.default(_$a, _$n);)r.push(At(_$a)), _$a = ke.default(_$a, 1);
        return r;
    }
    var Lr = function(e) {
        _t(r, e);
        var _$t = Nt(r);
        function r(e) {
            var _$a;
            return kt(this, r), St(Et(_$a = _$t.call(this, e)), "renderOptions", function() {
                return _$a.state.monthYearsList.map(function(e) {
                    var _$t = Fe.default(e), _$r = zt(_$a.props.date, e) && $t(_$a.props.date, e);
                    return de.default.createElement("div", {
                        className: _$r ? "react-datepicker__month-year-option--selected_month-year" : "react-datepicker__month-year-option",
                        key: _$t,
                        onClick: _$a.onChange.bind(Et(_$a), _$t),
                        "aria-selected": _$r ? "true" : void 0
                    }, _$r ? de.default.createElement("span", {
                        className: "react-datepicker__month-year-option--selected"
                    }, "\u2713") : "", qt(e, _$a.props.dateFormat, _$a.props.locale));
                });
            }), St(Et(_$a), "onChange", function(e) {
                return _$a.props.onChange(e);
            }), St(Et(_$a), "handleClickOutside", function() {
                _$a.props.onCancel();
            }), _$a.state = {
                monthYearsList: Rr(_$a.props.minDate, _$a.props.maxDate)
            }, _$a;
        }
        return bt(r, [
            {
                key: "render",
                value: function value() {
                    var _$e = ue.default({
                        "react-datepicker__month-year-dropdown": !0,
                        "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown
                    });
                    return de.default.createElement("div", {
                        className: _$e
                    }, this.renderOptions());
                }
            }
        ]), r;
    }(de.default.Component), Fr = ht.default(Lr), Ar = function(e) {
        _t(r, e);
        var _$t = Nt(r);
        function r() {
            var _$e;
            kt(this, r);
            for(var _$a = arguments.length, _$n = new Array(_$a), _$o = 0; _$o < _$a; _$o++)_$n[_$o] = arguments[_$o];
            return St(Et(_$e = _$t.call.apply(_$t, [
                this
            ].concat(_$n))), "state", {
                dropdownVisible: !1
            }), St(Et(_$e), "renderSelectOptions", function() {
                for(var _$t = Ht(_$e.props.minDate), _$r = Ht(_$e.props.maxDate), _$a = []; !pt.default(_$t, _$r);){
                    var _$n = Fe.default(_$t);
                    _$a.push(de.default.createElement("option", {
                        key: _$n,
                        value: _$n
                    }, qt(_$t, _$e.props.dateFormat, _$e.props.locale))), _$t = ke.default(_$t, 1);
                }
                return _$a;
            }), St(Et(_$e), "onSelectChange", function(t) {
                _$e.onChange(t.target.value);
            }), St(Et(_$e), "renderSelectMode", function() {
                return de.default.createElement("select", {
                    value: Fe.default(Ht(_$e.props.date)),
                    className: "react-datepicker__month-year-select",
                    onChange: _$e.onSelectChange
                }, _$e.renderSelectOptions());
            }), St(Et(_$e), "renderReadView", function(t) {
                var _$r = qt(_$e.props.date, _$e.props.dateFormat, _$e.props.locale);
                return de.default.createElement("div", {
                    key: "read",
                    style: {
                        visibility: t ? "visible" : "hidden"
                    },
                    className: "react-datepicker__month-year-read-view",
                    onClick: function onClick(t) {
                        return _$e.toggleDropdown(t);
                    }
                }, de.default.createElement("span", {
                    className: "react-datepicker__month-year-read-view--down-arrow"
                }), de.default.createElement("span", {
                    className: "react-datepicker__month-year-read-view--selected-month-year"
                }, _$r));
            }), St(Et(_$e), "renderDropdown", function() {
                return de.default.createElement(Fr, {
                    key: "dropdown",
                    date: _$e.props.date,
                    dateFormat: _$e.props.dateFormat,
                    onChange: _$e.onChange,
                    onCancel: _$e.toggleDropdown,
                    minDate: _$e.props.minDate,
                    maxDate: _$e.props.maxDate,
                    scrollableMonthYearDropdown: _$e.props.scrollableMonthYearDropdown,
                    locale: _$e.props.locale
                });
            }), St(Et(_$e), "renderScrollMode", function() {
                var _$t = _$e.state.dropdownVisible, _$r = [
                    _$e.renderReadView(!_$t)
                ];
                return _$t && _$r.unshift(_$e.renderDropdown()), _$r;
            }), St(Et(_$e), "onChange", function(t) {
                _$e.toggleDropdown();
                var _$r = At(parseInt(t));
                zt(_$e.props.date, _$r) && $t(_$e.props.date, _$r) || _$e.props.onChange(_$r);
            }), St(Et(_$e), "toggleDropdown", function() {
                return _$e.setState({
                    dropdownVisible: !_$e.state.dropdownVisible
                });
            }), _$e;
        }
        return bt(r, [
            {
                key: "render",
                value: function value() {
                    var _$e;
                    switch(this.props.dropdownMode){
                        case "scroll":
                            _$e = this.renderScrollMode();
                            break;
                        case "select":
                            _$e = this.renderSelectMode();
                    }
                    return de.default.createElement("div", {
                        className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode)
                    }, _$e);
                }
            }
        ]), r;
    }(de.default.Component), Wr = function(e) {
        _t(r, e);
        var _$t = Nt(r);
        function r() {
            var _$e;
            kt(this, r);
            for(var _$a = arguments.length, _$n = new Array(_$a), _$o = 0; _$o < _$a; _$o++)_$n[_$o] = arguments[_$o];
            return St(Et(_$e = _$t.call.apply(_$t, [
                this
            ].concat(_$n))), "dayEl", de.default.createRef()), St(Et(_$e), "handleClick", function(t) {
                !_$e.isDisabled() && _$e.props.onClick && _$e.props.onClick(t);
            }), St(Et(_$e), "handleMouseEnter", function(t) {
                !_$e.isDisabled() && _$e.props.onMouseEnter && _$e.props.onMouseEnter(t);
            }), St(Et(_$e), "handleOnKeyDown", function(t) {
                " " === t.key && (t.preventDefault(), t.key = "Enter"), _$e.props.handleOnKeyDown(t);
            }), St(Et(_$e), "isSameDay", function(t) {
                return Jt(_$e.props.day, t);
            }), St(Et(_$e), "isKeyboardSelected", function() {
                return !_$e.props.disabledKeyboardNavigation && !(_$e.isSameDay(_$e.props.selected) || _$e.isSameWeek(_$e.props.selected)) && (_$e.isSameDay(_$e.props.preSelection) || _$e.isSameWeek(_$e.props.preSelection));
            }), St(Et(_$e), "isDisabled", function() {
                return nr(_$e.props.day, _$e.props);
            }), St(Et(_$e), "isExcluded", function() {
                return or(_$e.props.day, _$e.props);
            }), St(Et(_$e), "isStartOfWeek", function() {
                return Jt(_$e.props.day, Qt(_$e.props.day, _$e.props.locale, _$e.props.calendarStartDay));
            }), St(Et(_$e), "isSameWeek", function(t) {
                return _$e.props.showWeekPicker && Jt(t, Qt(_$e.props.day, _$e.props.locale, _$e.props.calendarStartDay));
            }), St(Et(_$e), "getHighLightedClass", function() {
                var _$t = _$e.props, _$r = _$t.day, _$a = _$t.highlightDates;
                if (!_$a) return !1;
                var _$n = qt(_$r, "MM.dd.yyyy");
                return _$a.get(_$n);
            }), St(Et(_$e), "getHolidaysClass", function() {
                var _$t = _$e.props, _$r = _$t.day, _$a = _$t.holidays;
                if (!_$a) return !1;
                var _$n = qt(_$r, "MM.dd.yyyy");
                return _$a.has(_$n) ? [
                    _$a.get(_$n).className
                ] : void 0;
            }), St(Et(_$e), "isInRange", function() {
                var _$t = _$e.props, _$r = _$t.day, _$a = _$t.startDate, _$n = _$t.endDate;
                return !(!_$a || !_$n) && Zt(_$r, _$a, _$n);
            }), St(Et(_$e), "isInSelectingRange", function() {
                var _$t, _$r = _$e.props, _$a = _$r.day, _$n = _$r.selectsStart, _$o = _$r.selectsEnd, _$s = _$r.selectsRange, _$i = _$r.selectsDisabledDaysInRange, _$p = _$r.startDate, _$l = _$r.endDate, _$c = null !== (_$t = _$e.props.selectingDate) && void 0 !== _$t ? _$t : _$e.props.preSelection;
                return !(!(_$n || _$o || _$s) || !_$c || !_$i && _$e.isDisabled()) && (_$n && _$l && (lt.default(_$c, _$l) || Xt(_$c, _$l)) ? Zt(_$a, _$c, _$l) : (_$o && _$p && (pt.default(_$c, _$p) || Xt(_$c, _$p)) || !(!_$s || !_$p || _$l || !pt.default(_$c, _$p) && !Xt(_$c, _$p))) && Zt(_$a, _$p, _$c));
            }), St(Et(_$e), "isSelectingRangeStart", function() {
                var _$t;
                if (!_$e.isInSelectingRange()) return !1;
                var _$r = _$e.props, _$a = _$r.day, _$n = _$r.startDate, _$o = _$r.selectsStart, _$s = null !== (_$t = _$e.props.selectingDate) && void 0 !== _$t ? _$t : _$e.props.preSelection;
                return Jt(_$a, _$o ? _$s : _$n);
            }), St(Et(_$e), "isSelectingRangeEnd", function() {
                var _$t;
                if (!_$e.isInSelectingRange()) return !1;
                var _$r = _$e.props, _$a = _$r.day, _$n = _$r.endDate, _$o = _$r.selectsEnd, _$s = _$r.selectsRange, _$i = null !== (_$t = _$e.props.selectingDate) && void 0 !== _$t ? _$t : _$e.props.preSelection;
                return Jt(_$a, _$o || _$s ? _$i : _$n);
            }), St(Et(_$e), "isRangeStart", function() {
                var _$t = _$e.props, _$r = _$t.day, _$a = _$t.startDate, _$n = _$t.endDate;
                return !(!_$a || !_$n) && Jt(_$a, _$r);
            }), St(Et(_$e), "isRangeEnd", function() {
                var _$t = _$e.props, _$r = _$t.day, _$a = _$t.startDate, _$n = _$t.endDate;
                return !(!_$a || !_$n) && Jt(_$n, _$r);
            }), St(Et(_$e), "isWeekend", function() {
                var _$t = Ye.default(_$e.props.day);
                return 0 === _$t || 6 === _$t;
            }), St(Et(_$e), "isAfterMonth", function() {
                return void 0 !== _$e.props.month && (_$e.props.month + 1) % 12 === Te.default(_$e.props.day);
            }), St(Et(_$e), "isBeforeMonth", function() {
                return void 0 !== _$e.props.month && (Te.default(_$e.props.day) + 1) % 12 === _$e.props.month;
            }), St(Et(_$e), "isCurrentDay", function() {
                return _$e.isSameDay(At());
            }), St(Et(_$e), "isSelected", function() {
                return _$e.isSameDay(_$e.props.selected) || _$e.isSameWeek(_$e.props.selected);
            }), St(Et(_$e), "getClassNames", function(t) {
                var _$r, _$a = _$e.props.dayClassName ? _$e.props.dayClassName(t) : void 0;
                return ue.default("react-datepicker__day", _$a, "react-datepicker__day--" + qt(_$e.props.day, "ddd", _$r), {
                    "react-datepicker__day--disabled": _$e.isDisabled(),
                    "react-datepicker__day--excluded": _$e.isExcluded(),
                    "react-datepicker__day--selected": _$e.isSelected(),
                    "react-datepicker__day--keyboard-selected": _$e.isKeyboardSelected(),
                    "react-datepicker__day--range-start": _$e.isRangeStart(),
                    "react-datepicker__day--range-end": _$e.isRangeEnd(),
                    "react-datepicker__day--in-range": _$e.isInRange(),
                    "react-datepicker__day--in-selecting-range": _$e.isInSelectingRange(),
                    "react-datepicker__day--selecting-range-start": _$e.isSelectingRangeStart(),
                    "react-datepicker__day--selecting-range-end": _$e.isSelectingRangeEnd(),
                    "react-datepicker__day--today": _$e.isCurrentDay(),
                    "react-datepicker__day--weekend": _$e.isWeekend(),
                    "react-datepicker__day--outside-month": _$e.isAfterMonth() || _$e.isBeforeMonth()
                }, _$e.getHighLightedClass("react-datepicker__day--highlighted"), _$e.getHolidaysClass());
            }), St(Et(_$e), "getAriaLabel", function() {
                var _$t = _$e.props, _$r = _$t.day, _$a = _$t.ariaLabelPrefixWhenEnabled, _$n = void 0 === _$a ? "Choose" : _$a, _$o = _$t.ariaLabelPrefixWhenDisabled, _$s = void 0 === _$o ? "Not available" : _$o, _$i = _$e.isDisabled() || _$e.isExcluded() ? _$s : _$n;
                return "".concat(_$i, " ").concat(qt(_$r, "PPPP", _$e.props.locale));
            }), St(Et(_$e), "getTitle", function() {
                var _$t = _$e.props, _$r = _$t.day, _$a = _$t.holidays, _$n = void 0 === _$a ? new Map : _$a, _$o = qt(_$r, "MM.dd.yyyy");
                return _$n.has(_$o) && _$n.get(_$o).holidayNames.length > 0 ? _$n.get(_$o).holidayNames.join(", ") : "";
            }), St(Et(_$e), "getTabIndex", function(t, r) {
                var _$a = t || _$e.props.selected, _$n = r || _$e.props.preSelection;
                return (!_$e.props.showWeekPicker || !_$e.props.showWeekNumber && _$e.isStartOfWeek()) && (_$e.isKeyboardSelected() || _$e.isSameDay(_$a) && Jt(_$n, _$a)) ? 0 : -1;
            }), St(Et(_$e), "handleFocusDay", function() {
                var _$t, _$r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, _$a = !1;
                0 === _$e.getTabIndex() && !_$r.isInputFocused && _$e.isSameDay(_$e.props.preSelection) && (document.activeElement && document.activeElement !== document.body || (_$a = !0), _$e.props.inline && !_$e.props.shouldFocusDayInline && (_$a = !1), _$e.props.containerRef && _$e.props.containerRef.current && _$e.props.containerRef.current.contains(document.activeElement) && document.activeElement.classList.contains("react-datepicker__day") && (_$a = !0), _$e.props.monthShowsDuplicateDaysEnd && _$e.isAfterMonth() && (_$a = !1), _$e.props.monthShowsDuplicateDaysStart && _$e.isBeforeMonth() && (_$a = !1)), _$a && (null === (_$t = _$e.dayEl.current) || void 0 === _$t || _$t.focus({
                    preventScroll: !0
                }));
            }), St(Et(_$e), "renderDayContents", function() {
                return _$e.props.monthShowsDuplicateDaysEnd && _$e.isAfterMonth() || _$e.props.monthShowsDuplicateDaysStart && _$e.isBeforeMonth() ? null : _$e.props.renderDayContents ? _$e.props.renderDayContents(Oe.default(_$e.props.day), _$e.props.day) : Oe.default(_$e.props.day);
            }), St(Et(_$e), "render", function() {
                return de.default.createElement("div", {
                    ref: _$e.dayEl,
                    className: _$e.getClassNames(_$e.props.day),
                    onKeyDown: _$e.handleOnKeyDown,
                    onClick: _$e.handleClick,
                    onMouseEnter: _$e.handleMouseEnter,
                    tabIndex: _$e.getTabIndex(),
                    "aria-label": _$e.getAriaLabel(),
                    role: "option",
                    title: _$e.getTitle(),
                    "aria-disabled": _$e.isDisabled(),
                    "aria-current": _$e.isCurrentDay() ? "date" : void 0,
                    "aria-selected": _$e.isSelected() || _$e.isInRange()
                }, _$e.renderDayContents(), "" !== _$e.getTitle() && de.default.createElement("span", {
                    className: "holiday-overlay"
                }, _$e.getTitle()));
            }), _$e;
        }
        return bt(r, [
            {
                key: "componentDidMount",
                value: function value() {
                    this.handleFocusDay();
                }
            },
            {
                key: "componentDidUpdate",
                value: function value(e) {
                    this.handleFocusDay(e);
                }
            }
        ]), r;
    }(de.default.Component), qr = function(e) {
        _t(r, e);
        var _$t = Nt(r);
        function r() {
            var _$e;
            kt(this, r);
            for(var _$a = arguments.length, _$n = new Array(_$a), _$o = 0; _$o < _$a; _$o++)_$n[_$o] = arguments[_$o];
            return St(Et(_$e = _$t.call.apply(_$t, [
                this
            ].concat(_$n))), "weekNumberEl", de.default.createRef()), St(Et(_$e), "handleClick", function(t) {
                _$e.props.onClick && _$e.props.onClick(t);
            }), St(Et(_$e), "handleOnKeyDown", function(t) {
                " " === t.key && (t.preventDefault(), t.key = "Enter"), _$e.props.handleOnKeyDown(t);
            }), St(Et(_$e), "isKeyboardSelected", function() {
                return !_$e.props.disabledKeyboardNavigation && !Jt(_$e.props.date, _$e.props.selected) && Jt(_$e.props.date, _$e.props.preSelection);
            }), St(Et(_$e), "getTabIndex", function() {
                return _$e.props.showWeekPicker && _$e.props.showWeekNumber && (_$e.isKeyboardSelected() || Jt(_$e.props.date, _$e.props.selected) && Jt(_$e.props.preSelection, _$e.props.selected)) ? 0 : -1;
            }), St(Et(_$e), "handleFocusWeekNumber", function() {
                var _$t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, _$r = !1;
                0 === _$e.getTabIndex() && !_$t.isInputFocused && Jt(_$e.props.date, _$e.props.preSelection) && (document.activeElement && document.activeElement !== document.body || (_$r = !0), _$e.props.inline && !_$e.props.shouldFocusDayInline && (_$r = !1), _$e.props.containerRef && _$e.props.containerRef.current && _$e.props.containerRef.current.contains(document.activeElement) && document.activeElement && document.activeElement.classList.contains("react-datepicker__week-number") && (_$r = !0)), _$r && _$e.weekNumberEl.current && _$e.weekNumberEl.current.focus({
                    preventScroll: !0
                });
            }), _$e;
        }
        return bt(r, [
            {
                key: "componentDidMount",
                value: function value() {
                    this.handleFocusWeekNumber();
                }
            },
            {
                key: "componentDidUpdate",
                value: function value(e) {
                    this.handleFocusWeekNumber(e);
                }
            },
            {
                key: "render",
                value: function value() {
                    var _$e = this.props, _$t = _$e.weekNumber, _$r = _$e.ariaLabelPrefix, _$a = void 0 === _$r ? "week " : _$r, _$n = {
                        "react-datepicker__week-number": !0,
                        "react-datepicker__week-number--clickable": !!_$e.onClick,
                        "react-datepicker__week-number--selected": Jt(this.props.date, this.props.selected),
                        "react-datepicker__week-number--keyboard-selected": this.isKeyboardSelected()
                    };
                    return de.default.createElement("div", {
                        ref: this.weekNumberEl,
                        className: ue.default(_$n),
                        "aria-label": "".concat(_$a, " ").concat(this.props.weekNumber),
                        onClick: this.handleClick,
                        onKeyDown: this.handleOnKeyDown,
                        tabIndex: this.getTabIndex()
                    }, _$t);
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function get() {
                    return {
                        ariaLabelPrefix: "week "
                    };
                }
            }
        ]), r;
    }(de.default.Component), Kr = function(e) {
        _t(r, e);
        var _$t = Nt(r);
        function r() {
            var _$e;
            kt(this, r);
            for(var _$a = arguments.length, _$n = new Array(_$a), _$o = 0; _$o < _$a; _$o++)_$n[_$o] = arguments[_$o];
            return St(Et(_$e = _$t.call.apply(_$t, [
                this
            ].concat(_$n))), "handleDayClick", function(t, r) {
                _$e.props.onDayClick && _$e.props.onDayClick(t, r);
            }), St(Et(_$e), "handleDayMouseEnter", function(t) {
                _$e.props.onDayMouseEnter && _$e.props.onDayMouseEnter(t);
            }), St(Et(_$e), "handleWeekClick", function(t, r, a) {
                if ("function" == typeof _$e.props.onWeekSelect && _$e.props.onWeekSelect(t, r, a), _$e.props.showWeekPicker) {
                    var _$n = Qt(t, _$e.props.locale, _$e.props.calendarStartDay);
                    _$e.handleDayClick(_$n, a);
                }
                _$e.props.shouldCloseOnSelect && _$e.props.setOpen(!1);
            }), St(Et(_$e), "formatWeekNumber", function(t) {
                return _$e.props.formatWeekNumber ? _$e.props.formatWeekNumber(t) : function(e, t) {
                    var _$r = t && tr(t) || er() && tr(er());
                    return Ie.default(e, _$r ? {
                        locale: _$r
                    } : null);
                }(t);
            }), St(Et(_$e), "renderDays", function() {
                var _$t = Qt(_$e.props.day, _$e.props.locale, _$e.props.calendarStartDay), _$r = [], _$a = _$e.formatWeekNumber(_$t);
                if (_$e.props.showWeekNumber) {
                    var _$n = _$e.props.onWeekSelect || _$e.props.showWeekPicker ? _$e.handleWeekClick.bind(Et(_$e), _$t, _$a) : void 0;
                    _$r.push(de.default.createElement(qr, {
                        key: "W",
                        weekNumber: _$a,
                        date: _$t,
                        onClick: _$n,
                        selected: _$e.props.selected,
                        preSelection: _$e.props.preSelection,
                        ariaLabelPrefix: _$e.props.ariaLabelPrefix,
                        showWeekPicker: _$e.props.showWeekPicker,
                        showWeekNumber: _$e.props.showWeekNumber,
                        disabledKeyboardNavigation: _$e.props.disabledKeyboardNavigation,
                        handleOnKeyDown: _$e.props.handleOnKeyDown,
                        isInputFocused: _$e.props.isInputFocused,
                        containerRef: _$e.props.containerRef
                    }));
                }
                return _$r.concat([
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6
                ].map(function(r) {
                    var _$a = De.default(_$t, r);
                    return de.default.createElement(Wr, {
                        ariaLabelPrefixWhenEnabled: _$e.props.chooseDayAriaLabelPrefix,
                        ariaLabelPrefixWhenDisabled: _$e.props.disabledDayAriaLabelPrefix,
                        key: _$a.valueOf(),
                        day: _$a,
                        month: _$e.props.month,
                        onClick: _$e.handleDayClick.bind(Et(_$e), _$a),
                        onMouseEnter: _$e.handleDayMouseEnter.bind(Et(_$e), _$a),
                        minDate: _$e.props.minDate,
                        maxDate: _$e.props.maxDate,
                        excludeDates: _$e.props.excludeDates,
                        excludeDateIntervals: _$e.props.excludeDateIntervals,
                        includeDates: _$e.props.includeDates,
                        includeDateIntervals: _$e.props.includeDateIntervals,
                        highlightDates: _$e.props.highlightDates,
                        holidays: _$e.props.holidays,
                        selectingDate: _$e.props.selectingDate,
                        filterDate: _$e.props.filterDate,
                        preSelection: _$e.props.preSelection,
                        selected: _$e.props.selected,
                        selectsStart: _$e.props.selectsStart,
                        selectsEnd: _$e.props.selectsEnd,
                        selectsRange: _$e.props.selectsRange,
                        showWeekPicker: _$e.props.showWeekPicker,
                        showWeekNumber: _$e.props.showWeekNumber,
                        selectsDisabledDaysInRange: _$e.props.selectsDisabledDaysInRange,
                        startDate: _$e.props.startDate,
                        endDate: _$e.props.endDate,
                        dayClassName: _$e.props.dayClassName,
                        renderDayContents: _$e.props.renderDayContents,
                        disabledKeyboardNavigation: _$e.props.disabledKeyboardNavigation,
                        handleOnKeyDown: _$e.props.handleOnKeyDown,
                        isInputFocused: _$e.props.isInputFocused,
                        containerRef: _$e.props.containerRef,
                        inline: _$e.props.inline,
                        shouldFocusDayInline: _$e.props.shouldFocusDayInline,
                        monthShowsDuplicateDaysEnd: _$e.props.monthShowsDuplicateDaysEnd,
                        monthShowsDuplicateDaysStart: _$e.props.monthShowsDuplicateDaysStart,
                        locale: _$e.props.locale
                    });
                }));
            }), St(Et(_$e), "startOfWeek", function() {
                return Qt(_$e.props.day, _$e.props.locale, _$e.props.calendarStartDay);
            }), St(Et(_$e), "isKeyboardSelected", function() {
                return !_$e.props.disabledKeyboardNavigation && !Jt(_$e.startOfWeek(), _$e.props.selected) && Jt(_$e.startOfWeek(), _$e.props.preSelection);
            }), _$e;
        }
        return bt(r, [
            {
                key: "render",
                value: function value() {
                    var _$e = {
                        "react-datepicker__week": !0,
                        "react-datepicker__week--selected": Jt(this.startOfWeek(), this.props.selected),
                        "react-datepicker__week--keyboard-selected": this.isKeyboardSelected()
                    };
                    return de.default.createElement("div", {
                        className: ue.default(_$e)
                    }, this.renderDays());
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function get() {
                    return {
                        shouldCloseOnSelect: !0
                    };
                }
            }
        ]), r;
    }(de.default.Component), Br = "two_columns", Qr = "three_columns", Hr = "four_columns", jr = St(St(St({}, Br, {
        grid: [
            [
                0,
                1
            ],
            [
                2,
                3
            ],
            [
                4,
                5
            ],
            [
                6,
                7
            ],
            [
                8,
                9
            ],
            [
                10,
                11
            ]
        ],
        verticalNavigationOffset: 2
    }), Qr, {
        grid: [
            [
                0,
                1,
                2
            ],
            [
                3,
                4,
                5
            ],
            [
                6,
                7,
                8
            ],
            [
                9,
                10,
                11
            ]
        ],
        verticalNavigationOffset: 3
    }), Hr, {
        grid: [
            [
                0,
                1,
                2,
                3
            ],
            [
                4,
                5,
                6,
                7
            ],
            [
                8,
                9,
                10,
                11
            ]
        ],
        verticalNavigationOffset: 4
    });
    function Vr(e, t) {
        return e ? Hr : t ? Br : Qr;
    }
    var Ur = function(e) {
        _t(r, e);
        var _$t = Nt(r);
        function r() {
            var _$e;
            kt(this, r);
            for(var _$a = arguments.length, _$n = new Array(_$a), _$o = 0; _$o < _$a; _$o++)_$n[_$o] = arguments[_$o];
            return St(Et(_$e = _$t.call.apply(_$t, [
                this
            ].concat(_$n))), "MONTH_REFS", xt(Array(12)).map(function() {
                return de.default.createRef();
            })), St(Et(_$e), "QUARTER_REFS", xt(Array(4)).map(function() {
                return de.default.createRef();
            })), St(Et(_$e), "isDisabled", function(t) {
                return nr(t, _$e.props);
            }), St(Et(_$e), "isExcluded", function(t) {
                return or(t, _$e.props);
            }), St(Et(_$e), "handleDayClick", function(t, r) {
                _$e.props.onDayClick && _$e.props.onDayClick(t, r, _$e.props.orderInDisplay);
            }), St(Et(_$e), "handleDayMouseEnter", function(t) {
                _$e.props.onDayMouseEnter && _$e.props.onDayMouseEnter(t);
            }), St(Et(_$e), "handleMouseLeave", function() {
                _$e.props.onMouseLeave && _$e.props.onMouseLeave();
            }), St(Et(_$e), "isRangeStartMonth", function(t) {
                var _$r = _$e.props, _$a = _$r.day, _$n = _$r.startDate, _$o = _$r.endDate;
                return !(!_$n || !_$o) && $t(Ke.default(_$a, t), _$n);
            }), St(Et(_$e), "isRangeStartQuarter", function(t) {
                var _$r = _$e.props, _$a = _$r.day, _$n = _$r.startDate, _$o = _$r.endDate;
                return !(!_$n || !_$o) && Gt(Be.default(_$a, t), _$n);
            }), St(Et(_$e), "isRangeEndMonth", function(t) {
                var _$r = _$e.props, _$a = _$r.day, _$n = _$r.startDate, _$o = _$r.endDate;
                return !(!_$n || !_$o) && $t(Ke.default(_$a, t), _$o);
            }), St(Et(_$e), "isRangeEndQuarter", function(t) {
                var _$r = _$e.props, _$a = _$r.day, _$n = _$r.startDate, _$o = _$r.endDate;
                return !(!_$n || !_$o) && Gt(Be.default(_$a, t), _$o);
            }), St(Et(_$e), "isInSelectingRangeMonth", function(t) {
                var _$r, _$a = _$e.props, _$n = _$a.day, _$o = _$a.selectsStart, _$s = _$a.selectsEnd, _$i = _$a.selectsRange, _$p = _$a.startDate, _$l = _$a.endDate, _$c = null !== (_$r = _$e.props.selectingDate) && void 0 !== _$r ? _$r : _$e.props.preSelection;
                return !(!(_$o || _$s || _$i) || !_$c) && (_$o && _$l ? ir(_$c, _$l, t, _$n) : (_$s && _$p || !(!_$i || !_$p || _$l)) && ir(_$p, _$c, t, _$n));
            }), St(Et(_$e), "isSelectingMonthRangeStart", function(t) {
                var _$r;
                if (!_$e.isInSelectingRangeMonth(t)) return !1;
                var _$a = _$e.props, _$n = _$a.day, _$o = _$a.startDate, _$s = _$a.selectsStart, _$i = Ke.default(_$n, t), _$p = null !== (_$r = _$e.props.selectingDate) && void 0 !== _$r ? _$r : _$e.props.preSelection;
                return $t(_$i, _$s ? _$p : _$o);
            }), St(Et(_$e), "isSelectingMonthRangeEnd", function(t) {
                var _$r;
                if (!_$e.isInSelectingRangeMonth(t)) return !1;
                var _$a = _$e.props, _$n = _$a.day, _$o = _$a.endDate, _$s = _$a.selectsEnd, _$i = _$a.selectsRange, _$p = Ke.default(_$n, t), _$l = null !== (_$r = _$e.props.selectingDate) && void 0 !== _$r ? _$r : _$e.props.preSelection;
                return $t(_$p, _$s || _$i ? _$l : _$o);
            }), St(Et(_$e), "isInSelectingRangeQuarter", function(t) {
                var _$r, _$a = _$e.props, _$n = _$a.day, _$o = _$a.selectsStart, _$s = _$a.selectsEnd, _$i = _$a.selectsRange, _$p = _$a.startDate, _$l = _$a.endDate, _$c = null !== (_$r = _$e.props.selectingDate) && void 0 !== _$r ? _$r : _$e.props.preSelection;
                return !(!(_$o || _$s || _$i) || !_$c) && (_$o && _$l ? dr(_$c, _$l, t, _$n) : (_$s && _$p || !(!_$i || !_$p || _$l)) && dr(_$p, _$c, t, _$n));
            }), St(Et(_$e), "isWeekInMonth", function(t) {
                var _$r = _$e.props.day, _$a = De.default(t, 6);
                return $t(t, _$r) || $t(_$a, _$r);
            }), St(Et(_$e), "isCurrentMonth", function(e, t) {
                return Le.default(e) === Le.default(At()) && t === Te.default(At());
            }), St(Et(_$e), "isCurrentQuarter", function(e, t) {
                return Le.default(e) === Le.default(At()) && t === Re.default(At());
            }), St(Et(_$e), "isSelectedMonth", function(e, t, r) {
                return Te.default(r) === t && Le.default(e) === Le.default(r);
            }), St(Et(_$e), "isSelectedQuarter", function(e, t, r) {
                return Re.default(e) === t && Le.default(e) === Le.default(r);
            }), St(Et(_$e), "renderWeeks", function() {
                for(var _$t = [], _$r = _$e.props.fixedHeight, _$a = 0, _$n = !1, _$o = Qt(Ht(_$e.props.day), _$e.props.locale, _$e.props.calendarStartDay); _$t.push(de.default.createElement(Kr, {
                    ariaLabelPrefix: _$e.props.weekAriaLabelPrefix,
                    chooseDayAriaLabelPrefix: _$e.props.chooseDayAriaLabelPrefix,
                    disabledDayAriaLabelPrefix: _$e.props.disabledDayAriaLabelPrefix,
                    key: _$a,
                    day: _$o,
                    month: Te.default(_$e.props.day),
                    onDayClick: _$e.handleDayClick,
                    onDayMouseEnter: _$e.handleDayMouseEnter,
                    onWeekSelect: _$e.props.onWeekSelect,
                    formatWeekNumber: _$e.props.formatWeekNumber,
                    locale: _$e.props.locale,
                    minDate: _$e.props.minDate,
                    maxDate: _$e.props.maxDate,
                    excludeDates: _$e.props.excludeDates,
                    excludeDateIntervals: _$e.props.excludeDateIntervals,
                    includeDates: _$e.props.includeDates,
                    includeDateIntervals: _$e.props.includeDateIntervals,
                    inline: _$e.props.inline,
                    shouldFocusDayInline: _$e.props.shouldFocusDayInline,
                    highlightDates: _$e.props.highlightDates,
                    holidays: _$e.props.holidays,
                    selectingDate: _$e.props.selectingDate,
                    filterDate: _$e.props.filterDate,
                    preSelection: _$e.props.preSelection,
                    selected: _$e.props.selected,
                    selectsStart: _$e.props.selectsStart,
                    selectsEnd: _$e.props.selectsEnd,
                    selectsRange: _$e.props.selectsRange,
                    selectsDisabledDaysInRange: _$e.props.selectsDisabledDaysInRange,
                    showWeekNumber: _$e.props.showWeekNumbers,
                    showWeekPicker: _$e.props.showWeekPicker,
                    startDate: _$e.props.startDate,
                    endDate: _$e.props.endDate,
                    dayClassName: _$e.props.dayClassName,
                    setOpen: _$e.props.setOpen,
                    shouldCloseOnSelect: _$e.props.shouldCloseOnSelect,
                    disabledKeyboardNavigation: _$e.props.disabledKeyboardNavigation,
                    renderDayContents: _$e.props.renderDayContents,
                    handleOnKeyDown: _$e.props.handleOnKeyDown,
                    isInputFocused: _$e.props.isInputFocused,
                    containerRef: _$e.props.containerRef,
                    calendarStartDay: _$e.props.calendarStartDay,
                    monthShowsDuplicateDaysEnd: _$e.props.monthShowsDuplicateDaysEnd,
                    monthShowsDuplicateDaysStart: _$e.props.monthShowsDuplicateDaysStart
                })), !_$n;){
                    _$a++, _$o = ge.default(_$o, 1);
                    var _$s = _$r && _$a >= 6, _$i = !_$r && !_$e.isWeekInMonth(_$o);
                    if (_$s || _$i) {
                        if (!_$e.props.peekNextMonth) break;
                        _$n = !0;
                    }
                }
                return _$t;
            }), St(Et(_$e), "onMonthClick", function(t, r) {
                _$e.handleDayClick(Ht(Ke.default(_$e.props.day, r)), t);
            }), St(Et(_$e), "onMonthMouseEnter", function(t) {
                _$e.handleDayMouseEnter(Ht(Ke.default(_$e.props.day, t)));
            }), St(Et(_$e), "handleMonthNavigation", function(t, r) {
                _$e.isDisabled(r) || _$e.isExcluded(r) || (_$e.props.setPreSelection(r), _$e.MONTH_REFS[t].current && _$e.MONTH_REFS[t].current.focus());
            }), St(Et(_$e), "onMonthKeyDown", function(t, r) {
                var _$a = _$e.props, _$n = _$a.selected, _$o = _$a.preSelection, _$s = _$a.disabledKeyboardNavigation, _$i = _$a.showTwoColumnMonthYearPicker, _$p = _$a.showFourColumnMonthYearPicker, _$l = _$a.setPreSelection, _$c = t.key;
                if ("Tab" !== _$c && t.preventDefault(), !_$s) {
                    var _$d = Vr(_$p, _$i), _$u = jr[_$d].verticalNavigationOffset, _$f = jr[_$d].grid;
                    switch(_$c){
                        case "Enter":
                            _$e.onMonthClick(t, r), _$l(_$n);
                            break;
                        case "ArrowRight":
                            _$e.handleMonthNavigation(11 === r ? 0 : r + 1, ke.default(_$o, 1));
                            break;
                        case "ArrowLeft":
                            _$e.handleMonthNavigation(0 === r ? 11 : r - 1, _e.default(_$o, 1));
                            break;
                        case "ArrowUp":
                            _$e.handleMonthNavigation(_$f[0].includes(r) ? r + 12 - _$u : r - _$u, _e.default(_$o, _$u));
                            break;
                        case "ArrowDown":
                            _$e.handleMonthNavigation(_$f[_$f.length - 1].includes(r) ? r - 12 + _$u : r + _$u, ke.default(_$o, _$u));
                    }
                }
            }), St(Et(_$e), "onQuarterClick", function(t, r) {
                _$e.handleDayClick(Vt(Be.default(_$e.props.day, r)), t);
            }), St(Et(_$e), "onQuarterMouseEnter", function(t) {
                _$e.handleDayMouseEnter(Vt(Be.default(_$e.props.day, t)));
            }), St(Et(_$e), "handleQuarterNavigation", function(t, r) {
                _$e.isDisabled(r) || _$e.isExcluded(r) || (_$e.props.setPreSelection(r), _$e.QUARTER_REFS[t - 1].current && _$e.QUARTER_REFS[t - 1].current.focus());
            }), St(Et(_$e), "onQuarterKeyDown", function(t, r) {
                var _$a = t.key;
                if (!_$e.props.disabledKeyboardNavigation) switch(_$a){
                    case "Enter":
                        _$e.onQuarterClick(t, r), _$e.props.setPreSelection(_$e.props.selected);
                        break;
                    case "ArrowRight":
                        _$e.handleQuarterNavigation(4 === r ? 1 : r + 1, we.default(_$e.props.preSelection, 1));
                        break;
                    case "ArrowLeft":
                        _$e.handleQuarterNavigation(1 === r ? 4 : r - 1, Me.default(_$e.props.preSelection, 1));
                }
            }), St(Et(_$e), "getMonthClassNames", function(t) {
                var _$r = _$e.props, _$a = _$r.day, _$n = _$r.startDate, _$o = _$r.endDate, _$s = _$r.selected, _$i = _$r.minDate, _$p = _$r.maxDate, _$l = _$r.preSelection, _$c = _$r.monthClassName, _$d = _$r.excludeDates, _$u = _$r.includeDates, _$f = _$c ? _$c(Ke.default(_$a, t)) : void 0, _$h = Ke.default(_$a, t);
                return ue.default("react-datepicker__month-text", "react-datepicker__month-".concat(t), _$f, {
                    "react-datepicker__month-text--disabled": (_$i || _$p || _$d || _$u) && sr(_$h, _$e.props),
                    "react-datepicker__month-text--selected": _$e.isSelectedMonth(_$a, t, _$s),
                    "react-datepicker__month-text--keyboard-selected": !_$e.props.disabledKeyboardNavigation && Te.default(_$l) === t,
                    "react-datepicker__month-text--in-selecting-range": _$e.isInSelectingRangeMonth(t),
                    "react-datepicker__month-text--in-range": ir(_$n, _$o, t, _$a),
                    "react-datepicker__month-text--range-start": _$e.isRangeStartMonth(t),
                    "react-datepicker__month-text--range-end": _$e.isRangeEndMonth(t),
                    "react-datepicker__month-text--selecting-range-start": _$e.isSelectingMonthRangeStart(t),
                    "react-datepicker__month-text--selecting-range-end": _$e.isSelectingMonthRangeEnd(t),
                    "react-datepicker__month-text--today": _$e.isCurrentMonth(_$a, t)
                });
            }), St(Et(_$e), "getTabIndex", function(t) {
                var _$r = Te.default(_$e.props.preSelection);
                return _$e.props.disabledKeyboardNavigation || t !== _$r ? "-1" : "0";
            }), St(Et(_$e), "getQuarterTabIndex", function(t) {
                var _$r = Re.default(_$e.props.preSelection);
                return _$e.props.disabledKeyboardNavigation || t !== _$r ? "-1" : "0";
            }), St(Et(_$e), "getAriaLabel", function(t) {
                var _$r = _$e.props, _$a = _$r.chooseDayAriaLabelPrefix, _$n = void 0 === _$a ? "Choose" : _$a, _$o = _$r.disabledDayAriaLabelPrefix, _$s = void 0 === _$o ? "Not available" : _$o, _$i = _$r.day, _$p = Ke.default(_$i, t), _$l = _$e.isDisabled(_$p) || _$e.isExcluded(_$p) ? _$s : _$n;
                return "".concat(_$l, " ").concat(qt(_$p, "MMMM yyyy"));
            }), St(Et(_$e), "getQuarterClassNames", function(t) {
                var _$r = _$e.props, _$a = _$r.day, _$n = _$r.startDate, _$o = _$r.endDate, _$s = _$r.selected, _$i = _$r.minDate, _$p = _$r.maxDate, _$l = _$r.preSelection, _$c = _$r.disabledKeyboardNavigation;
                return ue.default("react-datepicker__quarter-text", "react-datepicker__quarter-".concat(t), {
                    "react-datepicker__quarter-text--disabled": (_$i || _$p) && pr(Be.default(_$a, t), _$e.props),
                    "react-datepicker__quarter-text--selected": _$e.isSelectedQuarter(_$a, t, _$s),
                    "react-datepicker__quarter-text--keyboard-selected": !_$c && Re.default(_$l) === t,
                    "react-datepicker__quarter-text--in-selecting-range": _$e.isInSelectingRangeQuarter(t),
                    "react-datepicker__quarter-text--in-range": dr(_$n, _$o, t, _$a),
                    "react-datepicker__quarter-text--range-start": _$e.isRangeStartQuarter(t),
                    "react-datepicker__quarter-text--range-end": _$e.isRangeEndQuarter(t)
                });
            }), St(Et(_$e), "getMonthContent", function(t) {
                var _$r = _$e.props, _$a = _$r.showFullMonthYearPicker, _$n = _$r.renderMonthContent, _$o = _$r.locale, _$s = _$r.day, _$i = ar(t, _$o), _$p = rr(t, _$o);
                return _$n ? _$n(t, _$i, _$p, _$s) : _$a ? _$p : _$i;
            }), St(Et(_$e), "getQuarterContent", function(t) {
                var _$r = _$e.props, _$a = _$r.renderQuarterContent, _$n = function(e, t) {
                    return qt(Be.default(At(), e), "QQQ", t);
                }(t, _$r.locale);
                return _$a ? _$a(t, _$n) : _$n;
            }), St(Et(_$e), "renderMonths", function() {
                var _$t = _$e.props, _$r = _$t.showTwoColumnMonthYearPicker, _$a = _$t.showFourColumnMonthYearPicker, _$n = _$t.day, _$o = _$t.selected;
                return jr[Vr(_$a, _$r)].grid.map(function(t, r) {
                    return de.default.createElement("div", {
                        className: "react-datepicker__month-wrapper",
                        key: r
                    }, t.map(function(t, r) {
                        return de.default.createElement("div", {
                            ref: _$e.MONTH_REFS[t],
                            key: r,
                            onClick: function onClick(r) {
                                _$e.onMonthClick(r, t);
                            },
                            onKeyDown: function onKeyDown(r) {
                                _$e.onMonthKeyDown(r, t);
                            },
                            onMouseEnter: function onMouseEnter() {
                                return _$e.onMonthMouseEnter(t);
                            },
                            tabIndex: _$e.getTabIndex(t),
                            className: _$e.getMonthClassNames(t),
                            role: "option",
                            "aria-label": _$e.getAriaLabel(t),
                            "aria-current": _$e.isCurrentMonth(_$n, t) ? "date" : void 0,
                            "aria-selected": _$e.isSelectedMonth(_$n, t, _$o)
                        }, _$e.getMonthContent(t));
                    }));
                });
            }), St(Et(_$e), "renderQuarters", function() {
                var _$t = _$e.props, _$r = _$t.day, _$a = _$t.selected;
                return de.default.createElement("div", {
                    className: "react-datepicker__quarter-wrapper"
                }, [
                    1,
                    2,
                    3,
                    4
                ].map(function(t, n) {
                    return de.default.createElement("div", {
                        key: n,
                        ref: _$e.QUARTER_REFS[n],
                        role: "option",
                        onClick: function onClick(r) {
                            _$e.onQuarterClick(r, t);
                        },
                        onKeyDown: function onKeyDown(r) {
                            _$e.onQuarterKeyDown(r, t);
                        },
                        onMouseEnter: function onMouseEnter() {
                            return _$e.onQuarterMouseEnter(t);
                        },
                        className: _$e.getQuarterClassNames(t),
                        "aria-selected": _$e.isSelectedQuarter(_$r, t, _$a),
                        tabIndex: _$e.getQuarterTabIndex(t),
                        "aria-current": _$e.isCurrentQuarter(_$r, t) ? "date" : void 0
                    }, _$e.getQuarterContent(t));
                }));
            }), St(Et(_$e), "getClassNames", function() {
                var _$t = _$e.props, _$r = _$t.selectingDate, _$a = _$t.selectsStart, _$n = _$t.selectsEnd, _$o = _$t.showMonthYearPicker, _$s = _$t.showQuarterYearPicker, _$i = _$t.showWeekPicker;
                return ue.default("react-datepicker__month", {
                    "react-datepicker__month--selecting-range": _$r && (_$a || _$n)
                }, {
                    "react-datepicker__monthPicker": _$o
                }, {
                    "react-datepicker__quarterPicker": _$s
                }, {
                    "react-datepicker__weekPicker": _$i
                });
            }), _$e;
        }
        return bt(r, [
            {
                key: "render",
                value: function value() {
                    var _$e = this.props, _$t = _$e.showMonthYearPicker, _$r = _$e.showQuarterYearPicker, _$a = _$e.day, _$n = _$e.ariaLabelPrefix, _$o = void 0 === _$n ? "month " : _$n;
                    return de.default.createElement("div", {
                        className: this.getClassNames(),
                        onMouseLeave: this.handleMouseLeave,
                        "aria-label": "".concat(_$o, " ").concat(qt(_$a, "yyyy-MM")),
                        role: "listbox"
                    }, _$t ? this.renderMonths() : _$r ? this.renderQuarters() : this.renderWeeks());
                }
            }
        ]), r;
    }(de.default.Component), zr = function(e) {
        _t(r, e);
        var _$t = Nt(r);
        function r() {
            var _$e;
            kt(this, r);
            for(var _$a = arguments.length, _$n = new Array(_$a), _$o = 0; _$o < _$a; _$o++)_$n[_$o] = arguments[_$o];
            return St(Et(_$e = _$t.call.apply(_$t, [
                this
            ].concat(_$n))), "state", {
                height: null
            }), St(Et(_$e), "scrollToTheSelectedTime", function() {
                requestAnimationFrame(function() {
                    _$e.list && (_$e.list.scrollTop = _$e.centerLi && r.calcCenterPosition(_$e.props.monthRef ? _$e.props.monthRef.clientHeight - _$e.header.clientHeight : _$e.list.clientHeight, _$e.centerLi));
                });
            }), St(Et(_$e), "handleClick", function(t) {
                (_$e.props.minTime || _$e.props.maxTime) && mr(t, _$e.props) || (_$e.props.excludeTimes || _$e.props.includeTimes || _$e.props.filterTime) && hr(t, _$e.props) || _$e.props.onChange(t);
            }), St(Et(_$e), "isSelectedTime", function(t) {
                var _$r, _$a;
                return _$e.props.selected && (_$r = _$e.props.selected, _$a = t, Pr(_$r).getTime() === Pr(_$a).getTime());
            }), St(Et(_$e), "isDisabledTime", function(t) {
                return (_$e.props.minTime || _$e.props.maxTime) && mr(t, _$e.props) || (_$e.props.excludeTimes || _$e.props.includeTimes || _$e.props.filterTime) && hr(t, _$e.props);
            }), St(Et(_$e), "liClasses", function(t) {
                var _$r = [
                    "react-datepicker__time-list-item",
                    _$e.props.timeClassName ? _$e.props.timeClassName(t) : void 0
                ];
                return _$e.isSelectedTime(t) && _$r.push("react-datepicker__time-list-item--selected"), _$e.isDisabledTime(t) && _$r.push("react-datepicker__time-list-item--disabled"), _$e.props.injectTimes && (60 * xe.default(t) + Ne.default(t)) % _$e.props.intervals != 0 && _$r.push("react-datepicker__time-list-item--injected"), _$r.join(" ");
            }), St(Et(_$e), "handleOnKeyDown", function(t, r) {
                " " === t.key && (t.preventDefault(), t.key = "Enter"), "ArrowUp" !== t.key && "ArrowLeft" !== t.key || !t.target.previousSibling || (t.preventDefault(), t.target.previousSibling.focus()), "ArrowDown" !== t.key && "ArrowRight" !== t.key || !t.target.nextSibling || (t.preventDefault(), t.target.nextSibling.focus()), "Enter" === t.key && _$e.handleClick(r), _$e.props.handleOnKeyDown(t);
            }), St(Et(_$e), "renderTimes", function() {
                for(var _$t, _$r = [], _$a = _$e.props.format ? _$e.props.format : "p", _$n = _$e.props.intervals, _$o = _$e.props.selected || _$e.props.openToDate || At(), _$s = (_$t = _$o, $e.default(_$t)), _$i = _$e.props.injectTimes && _$e.props.injectTimes.sort(function(e, t) {
                    return e - t;
                }), _$p = 60 * function(e) {
                    var _$t = new Date(e.getFullYear(), e.getMonth(), e.getDate()), _$r = new Date(e.getFullYear(), e.getMonth(), e.getDate(), 24);
                    return Math.round((+_$r - +_$t) / 36e5);
                }(_$o), _$l = _$p / _$n, _$c = 0; _$c < _$l; _$c++){
                    var _$d = ye.default(_$s, _$c * _$n);
                    if (_$r.push(_$d), _$i) {
                        var _$u = Cr(_$s, _$d, _$c, _$n, _$i);
                        _$r = _$r.concat(_$u);
                    }
                }
                var _$f = _$r.reduce(function(e, t) {
                    return t.getTime() <= _$o.getTime() ? t : e;
                }, _$r[0]);
                return _$r.map(function(t, r) {
                    return de.default.createElement("li", {
                        key: r,
                        onClick: _$e.handleClick.bind(Et(_$e), t),
                        className: _$e.liClasses(t),
                        ref: function ref(r) {
                            t === _$f && (_$e.centerLi = r);
                        },
                        onKeyDown: function onKeyDown(r) {
                            _$e.handleOnKeyDown(r, t);
                        },
                        tabIndex: t === _$f ? 0 : -1,
                        role: "option",
                        "aria-selected": _$e.isSelectedTime(t) ? "true" : void 0,
                        "aria-disabled": _$e.isDisabledTime(t) ? "true" : void 0
                    }, qt(t, _$a, _$e.props.locale));
                });
            }), _$e;
        }
        return bt(r, [
            {
                key: "componentDidMount",
                value: function value() {
                    this.scrollToTheSelectedTime(), this.props.monthRef && this.header && this.setState({
                        height: this.props.monthRef.clientHeight - this.header.clientHeight
                    });
                }
            },
            {
                key: "render",
                value: function value() {
                    var _$e = this, _$t = this.state.height;
                    return de.default.createElement("div", {
                        className: "react-datepicker__time-container ".concat(this.props.todayButton ? "react-datepicker__time-container--with-today-button" : "")
                    }, de.default.createElement("div", {
                        className: "react-datepicker__header react-datepicker__header--time ".concat(this.props.showTimeSelectOnly ? "react-datepicker__header--time--only" : ""),
                        ref: function ref(t) {
                            _$e.header = t;
                        }
                    }, de.default.createElement("div", {
                        className: "react-datepicker-time__header"
                    }, this.props.timeCaption)), de.default.createElement("div", {
                        className: "react-datepicker__time"
                    }, de.default.createElement("div", {
                        className: "react-datepicker__time-box"
                    }, de.default.createElement("ul", {
                        className: "react-datepicker__time-list",
                        ref: function ref(t) {
                            _$e.list = t;
                        },
                        style: _$t ? {
                            height: _$t
                        } : {},
                        role: "listbox",
                        "aria-label": this.props.timeCaption
                    }, this.renderTimes()))));
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function get() {
                    return {
                        intervals: 30,
                        onTimeChange: function onTimeChange() {},
                        todayButton: null,
                        timeCaption: "Time"
                    };
                }
            }
        ]), r;
    }(de.default.Component);
    St(zr, "calcCenterPosition", function(e, t) {
        return t.offsetTop - (e / 2 - t.clientHeight / 2);
    });
    var $r = function(e) {
        _t(r, e);
        var _$t = Nt(r);
        function r(e) {
            var _$a;
            return kt(this, r), St(Et(_$a = _$t.call(this, e)), "YEAR_REFS", xt(Array(_$a.props.yearItemNumber)).map(function() {
                return de.default.createRef();
            })), St(Et(_$a), "isDisabled", function(e) {
                return nr(e, _$a.props);
            }), St(Et(_$a), "isExcluded", function(e) {
                return or(e, _$a.props);
            }), St(Et(_$a), "selectingDate", function() {
                var _$e;
                return null !== (_$e = _$a.props.selectingDate) && void 0 !== _$e ? _$e : _$a.props.preSelection;
            }), St(Et(_$a), "updateFocusOnPaginate", function(e) {
                var _$t = (function() {
                    this.YEAR_REFS[e].current.focus();
                }).bind(Et(_$a));
                window.requestAnimationFrame(_$t);
            }), St(Et(_$a), "handleYearClick", function(e, t) {
                _$a.props.onDayClick && _$a.props.onDayClick(e, t);
            }), St(Et(_$a), "handleYearNavigation", function(e, t) {
                var _$r = _$a.props, _$n = _$r.date, _$o = _$r.yearItemNumber, _$s = Mr(_$n, _$o).startPeriod;
                _$a.isDisabled(t) || _$a.isExcluded(t) || (_$a.props.setPreSelection(t), e - _$s == -1 ? _$a.updateFocusOnPaginate(_$o - 1) : e - _$s === _$o ? _$a.updateFocusOnPaginate(0) : _$a.YEAR_REFS[e - _$s].current.focus());
            }), St(Et(_$a), "isSameDay", function(e, t) {
                return Jt(e, t);
            }), St(Et(_$a), "isCurrentYear", function(e) {
                return e === Le.default(At());
            }), St(Et(_$a), "isRangeStart", function(e) {
                return _$a.props.startDate && _$a.props.endDate && zt(Qe.default(At(), e), _$a.props.startDate);
            }), St(Et(_$a), "isRangeEnd", function(e) {
                return _$a.props.startDate && _$a.props.endDate && zt(Qe.default(At(), e), _$a.props.endDate);
            }), St(Et(_$a), "isInRange", function(e) {
                return lr(e, _$a.props.startDate, _$a.props.endDate);
            }), St(Et(_$a), "isInSelectingRange", function(e) {
                var _$t = _$a.props, _$r = _$t.selectsStart, _$n = _$t.selectsEnd, _$o = _$t.selectsRange, _$s = _$t.startDate, _$i = _$t.endDate;
                return !(!(_$r || _$n || _$o) || !_$a.selectingDate()) && (_$r && _$i ? lr(e, _$a.selectingDate(), _$i) : (_$n && _$s || !(!_$o || !_$s || _$i)) && lr(e, _$s, _$a.selectingDate()));
            }), St(Et(_$a), "isSelectingRangeStart", function(e) {
                if (!_$a.isInSelectingRange(e)) return !1;
                var _$t = _$a.props, _$r = _$t.startDate, _$n = _$t.selectsStart, _$o = Qe.default(At(), e);
                return zt(_$o, _$n ? _$a.selectingDate() : _$r);
            }), St(Et(_$a), "isSelectingRangeEnd", function(e) {
                if (!_$a.isInSelectingRange(e)) return !1;
                var _$t = _$a.props, _$r = _$t.endDate, _$n = _$t.selectsEnd, _$o = _$t.selectsRange, _$s = Qe.default(At(), e);
                return zt(_$s, _$n || _$o ? _$a.selectingDate() : _$r);
            }), St(Et(_$a), "isKeyboardSelected", function(e) {
                var _$t = jt(Qe.default(_$a.props.date, e));
                return !_$a.props.disabledKeyboardNavigation && !_$a.props.inline && !Jt(_$t, jt(_$a.props.selected)) && Jt(_$t, jt(_$a.props.preSelection));
            }), St(Et(_$a), "onYearClick", function(e, t) {
                var _$r = _$a.props.date;
                _$a.handleYearClick(jt(Qe.default(_$r, t)), e);
            }), St(Et(_$a), "onYearKeyDown", function(e, t) {
                var _$r = e.key;
                if (!_$a.props.disabledKeyboardNavigation) switch(_$r){
                    case "Enter":
                        _$a.onYearClick(e, t), _$a.props.setPreSelection(_$a.props.selected);
                        break;
                    case "ArrowRight":
                        _$a.handleYearNavigation(t + 1, be.default(_$a.props.preSelection, 1));
                        break;
                    case "ArrowLeft":
                        _$a.handleYearNavigation(t - 1, Pe.default(_$a.props.preSelection, 1));
                }
            }), St(Et(_$a), "getYearClassNames", function(e) {
                var _$t = _$a.props, _$r = _$t.minDate, _$n = _$t.maxDate, _$o = _$t.selected, _$s = _$t.excludeDates, _$i = _$t.includeDates, _$p = _$t.filterDate;
                return ue.default("react-datepicker__year-text", {
                    "react-datepicker__year-text--selected": e === Le.default(_$o),
                    "react-datepicker__year-text--disabled": (_$r || _$n || _$s || _$i || _$p) && cr(e, _$a.props),
                    "react-datepicker__year-text--keyboard-selected": _$a.isKeyboardSelected(e),
                    "react-datepicker__year-text--range-start": _$a.isRangeStart(e),
                    "react-datepicker__year-text--range-end": _$a.isRangeEnd(e),
                    "react-datepicker__year-text--in-range": _$a.isInRange(e),
                    "react-datepicker__year-text--in-selecting-range": _$a.isInSelectingRange(e),
                    "react-datepicker__year-text--selecting-range-start": _$a.isSelectingRangeStart(e),
                    "react-datepicker__year-text--selecting-range-end": _$a.isSelectingRangeEnd(e),
                    "react-datepicker__year-text--today": _$a.isCurrentYear(e)
                });
            }), St(Et(_$a), "getYearTabIndex", function(e) {
                return _$a.props.disabledKeyboardNavigation ? "-1" : e === Le.default(_$a.props.preSelection) ? "0" : "-1";
            }), St(Et(_$a), "getYearContainerClassNames", function() {
                var _$e = _$a.props, _$t = _$e.selectingDate, _$r = _$e.selectsStart, _$n = _$e.selectsEnd, _$o = _$e.selectsRange;
                return ue.default("react-datepicker__year", {
                    "react-datepicker__year--selecting-range": _$t && (_$r || _$n || _$o)
                });
            }), St(Et(_$a), "getYearContent", function(e) {
                return _$a.props.renderYearContent ? _$a.props.renderYearContent(e) : e;
            }), _$a;
        }
        return bt(r, [
            {
                key: "render",
                value: function value() {
                    for(var _$e = this, _$t = [], _$r = this.props, _$a = _$r.date, _$n = _$r.yearItemNumber, _$o = _$r.onYearMouseEnter, _$s = _$r.onYearMouseLeave, _$i = Mr(_$a, _$n), _$p = _$i.startPeriod, _$l = _$i.endPeriod, _$c = function c(r) {
                        _$t.push(de.default.createElement("div", {
                            ref: _$e.YEAR_REFS[r - _$p],
                            onClick: function onClick(t) {
                                _$e.onYearClick(t, r);
                            },
                            onKeyDown: function onKeyDown(t) {
                                _$e.onYearKeyDown(t, r);
                            },
                            tabIndex: _$e.getYearTabIndex(r),
                            className: _$e.getYearClassNames(r),
                            onMouseEnter: function onMouseEnter(e) {
                                return _$o(e, r);
                            },
                            onMouseLeave: function onMouseLeave(e) {
                                return _$s(e, r);
                            },
                            key: r,
                            "aria-current": _$e.isCurrentYear(r) ? "date" : void 0
                        }, _$e.getYearContent(r)));
                    }, _$d = _$p; _$d <= _$l; _$d++)_$c(_$d);
                    return de.default.createElement("div", {
                        className: this.getYearContainerClassNames()
                    }, de.default.createElement("div", {
                        className: "react-datepicker__year-wrapper",
                        onMouseLeave: this.props.clearSelectingDate
                    }, _$t));
                }
            }
        ]), r;
    }(de.default.Component), Gr = function(e) {
        _t(r, e);
        var _$t = Nt(r);
        function r(e) {
            var _$a;
            return kt(this, r), St(Et(_$a = _$t.call(this, e)), "onTimeChange", function(e) {
                _$a.setState({
                    time: e
                });
                var _$t = _$a.props.date, _$r = _$t instanceof Date && !isNaN(_$t) ? _$t : new Date;
                _$r.setHours(e.split(":")[0]), _$r.setMinutes(e.split(":")[1]), _$a.props.onChange(_$r);
            }), St(Et(_$a), "renderTimeInput", function() {
                var _$e = _$a.state.time, _$t = _$a.props, _$r = _$t.date, _$n = _$t.timeString, _$o = _$t.customTimeInput;
                return _$o ? de.default.cloneElement(_$o, {
                    date: _$r,
                    value: _$e,
                    onChange: _$a.onTimeChange
                }) : de.default.createElement("input", {
                    type: "time",
                    className: "react-datepicker-time__input",
                    placeholder: "Time",
                    name: "time-input",
                    required: !0,
                    value: _$e,
                    onChange: function onChange(e) {
                        _$a.onTimeChange(e.target.value || _$n);
                    }
                });
            }), _$a.state = {
                time: _$a.props.timeString
            }, _$a;
        }
        return bt(r, [
            {
                key: "render",
                value: function value() {
                    return de.default.createElement("div", {
                        className: "react-datepicker__input-time-container"
                    }, de.default.createElement("div", {
                        className: "react-datepicker-time__caption"
                    }, this.props.timeInputLabel), de.default.createElement("div", {
                        className: "react-datepicker-time__input-container"
                    }, de.default.createElement("div", {
                        className: "react-datepicker-time__input"
                    }, this.renderTimeInput())));
                }
            }
        ], [
            {
                key: "getDerivedStateFromProps",
                value: function value(e, t) {
                    return e.timeString !== t.time ? {
                        time: e.timeString
                    } : null;
                }
            }
        ]), r;
    }(de.default.Component);
    function Jr(e) {
        var _$t = e.className, r = e.children, _$a = e.showPopperArrow, _$n = e.arrowProps, _$o = void 0 === _$n ? {} : _$n;
        return de.default.createElement("div", {
            className: _$t
        }, _$a && de.default.createElement("div", Ct({
            className: "react-datepicker__triangle"
        }, _$o)), r);
    }
    var Xr = [
        "react-datepicker__year-select",
        "react-datepicker__month-select",
        "react-datepicker__month-year-select"
    ], Zr = function(e) {
        _t(r, e);
        var _$t = Nt(r);
        function r(e) {
            var _$a;
            return kt(this, r), St(Et(_$a = _$t.call(this, e)), "handleClickOutside", function(e) {
                _$a.props.onClickOutside(e);
            }), St(Et(_$a), "setClickOutsideRef", function() {
                return _$a.containerRef.current;
            }), St(Et(_$a), "handleDropdownFocus", function(e) {
                (function() {
                    var _$e = ((arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}).className || "").split(/\s+/);
                    return Xr.some(function(t) {
                        return _$e.indexOf(t) >= 0;
                    });
                })(e.target) && _$a.props.onDropdownFocus();
            }), St(Et(_$a), "getDateInView", function() {
                var _$e = _$a.props, _$t = _$e.preSelection, _$r = _$e.selected, _$n = _$e.openToDate, _$o = kr(_$a.props), _$s = wr(_$a.props), _$i = At(), _$p = _$n || _$r || _$t;
                return _$p || (_$o && lt.default(_$i, _$o) ? _$o : _$s && pt.default(_$i, _$s) ? _$s : _$i);
            }), St(Et(_$a), "increaseMonth", function() {
                _$a.setState(function(e) {
                    var _$t = e.date;
                    return {
                        date: ke.default(_$t, 1)
                    };
                }, function() {
                    return _$a.handleMonthChange(_$a.state.date);
                });
            }), St(Et(_$a), "decreaseMonth", function() {
                _$a.setState(function(e) {
                    var _$t = e.date;
                    return {
                        date: _e.default(_$t, 1)
                    };
                }, function() {
                    return _$a.handleMonthChange(_$a.state.date);
                });
            }), St(Et(_$a), "handleDayClick", function(e, t, r) {
                _$a.props.onSelect(e, t, r), _$a.props.setPreSelection && _$a.props.setPreSelection(e);
            }), St(Et(_$a), "handleDayMouseEnter", function(e) {
                _$a.setState({
                    selectingDate: e
                }), _$a.props.onDayMouseEnter && _$a.props.onDayMouseEnter(e);
            }), St(Et(_$a), "handleMonthMouseLeave", function() {
                _$a.setState({
                    selectingDate: null
                }), _$a.props.onMonthMouseLeave && _$a.props.onMonthMouseLeave();
            }), St(Et(_$a), "handleYearMouseEnter", function(e, t) {
                _$a.setState({
                    selectingDate: Qe.default(At(), t)
                }), _$a.props.onYearMouseEnter && _$a.props.onYearMouseEnter(e, t);
            }), St(Et(_$a), "handleYearMouseLeave", function(e, t) {
                _$a.props.onYearMouseLeave && _$a.props.onYearMouseLeave(e, t);
            }), St(Et(_$a), "handleYearChange", function(e) {
                _$a.props.onYearChange && (_$a.props.onYearChange(e), _$a.setState({
                    isRenderAriaLiveMessage: !0
                })), _$a.props.adjustDateOnChange && (_$a.props.onSelect && _$a.props.onSelect(e), _$a.props.setOpen && _$a.props.setOpen(!0)), _$a.props.setPreSelection && _$a.props.setPreSelection(e);
            }), St(Et(_$a), "handleMonthChange", function(e) {
                _$a.handleCustomMonthChange(e), _$a.props.adjustDateOnChange && (_$a.props.onSelect && _$a.props.onSelect(e), _$a.props.setOpen && _$a.props.setOpen(!0)), _$a.props.setPreSelection && _$a.props.setPreSelection(e);
            }), St(Et(_$a), "handleCustomMonthChange", function(e) {
                _$a.props.onMonthChange && (_$a.props.onMonthChange(e), _$a.setState({
                    isRenderAriaLiveMessage: !0
                }));
            }), St(Et(_$a), "handleMonthYearChange", function(e) {
                _$a.handleYearChange(e), _$a.handleMonthChange(e);
            }), St(Et(_$a), "changeYear", function(e) {
                _$a.setState(function(t) {
                    var _$r = t.date;
                    return {
                        date: Qe.default(_$r, e)
                    };
                }, function() {
                    return _$a.handleYearChange(_$a.state.date);
                });
            }), St(Et(_$a), "changeMonth", function(e) {
                _$a.setState(function(t) {
                    var _$r = t.date;
                    return {
                        date: Ke.default(_$r, e)
                    };
                }, function() {
                    return _$a.handleMonthChange(_$a.state.date);
                });
            }), St(Et(_$a), "changeMonthYear", function(e) {
                _$a.setState(function(t) {
                    var _$r = t.date;
                    return {
                        date: Qe.default(Ke.default(_$r, Te.default(e)), Le.default(e))
                    };
                }, function() {
                    return _$a.handleMonthYearChange(_$a.state.date);
                });
            }), St(Et(_$a), "header", function() {
                var _$e = Qt(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : _$a.state.date, _$a.props.locale, _$a.props.calendarStartDay), _$t = [];
                return _$a.props.showWeekNumbers && _$t.push(de.default.createElement("div", {
                    key: "W",
                    className: "react-datepicker__day-name"
                }, _$a.props.weekLabel || "#")), _$t.concat([
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6
                ].map(function(t) {
                    var _$r = De.default(_$e, t), _$n = _$a.formatWeekday(_$r, _$a.props.locale), _$o = _$a.props.weekDayClassName ? _$a.props.weekDayClassName(_$r) : void 0;
                    return de.default.createElement("div", {
                        key: t,
                        className: ue.default("react-datepicker__day-name", _$o)
                    }, _$n);
                }));
            }), St(Et(_$a), "formatWeekday", function(e, t) {
                return _$a.props.formatWeekDay ? function(e, t, r) {
                    return t(qt(e, "EEEE", r));
                }(e, _$a.props.formatWeekDay, t) : _$a.props.useWeekdaysShort ? function(e, t) {
                    return qt(e, "EEE", t);
                }(e, t) : function(e, t) {
                    return qt(e, "EEEEEE", t);
                }(e, t);
            }), St(Et(_$a), "decreaseYear", function() {
                _$a.setState(function(e) {
                    var _$t = e.date;
                    return {
                        date: Pe.default(_$t, _$a.props.showYearPicker ? _$a.props.yearItemNumber : 1)
                    };
                }, function() {
                    return _$a.handleYearChange(_$a.state.date);
                });
            }), St(Et(_$a), "clearSelectingDate", function() {
                _$a.setState({
                    selectingDate: null
                });
            }), St(Et(_$a), "renderPreviousButton", function() {
                if (!_$a.props.renderCustomHeader) {
                    var _$e;
                    switch(!0){
                        case _$a.props.showMonthYearPicker:
                            _$e = Dr(_$a.state.date, _$a.props);
                            break;
                        case _$a.props.showYearPicker:
                            _$e = function(e) {
                                var _$t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, _$r = _$t.minDate, _$a = _$t.yearItemNumber, _$n = void 0 === _$a ? Lt : _$a, _$o = Mr(jt(Pe.default(e, _$n)), _$n).endPeriod, _$s = _$r && Le.default(_$r);
                                return _$s && _$s > _$o || !1;
                            }(_$a.state.date, _$a.props);
                            break;
                        default:
                            _$e = yr(_$a.state.date, _$a.props);
                    }
                    if ((_$a.props.forceShowMonthNavigation || _$a.props.showDisabledMonthNavigation || !_$e) && !_$a.props.showTimeSelectOnly) {
                        var _$t = [
                            "react-datepicker__navigation",
                            "react-datepicker__navigation--previous"
                        ], _$r = _$a.decreaseMonth;
                        (_$a.props.showMonthYearPicker || _$a.props.showQuarterYearPicker || _$a.props.showYearPicker) && (_$r = _$a.decreaseYear), _$e && _$a.props.showDisabledMonthNavigation && (_$t.push("react-datepicker__navigation--previous--disabled"), _$r = null);
                        var _$n = _$a.props.showMonthYearPicker || _$a.props.showQuarterYearPicker || _$a.props.showYearPicker, _$o = _$a.props, _$s = _$o.previousMonthButtonLabel, _$i = _$o.previousYearButtonLabel, _$p = _$a.props, _$l = _$p.previousMonthAriaLabel, _$c = void 0 === _$l ? "string" == typeof _$s ? _$s : "Previous Month" : _$l, _$d = _$p.previousYearAriaLabel, _$u = void 0 === _$d ? "string" == typeof _$i ? _$i : "Previous Year" : _$d;
                        return de.default.createElement("button", {
                            type: "button",
                            className: _$t.join(" "),
                            onClick: _$r,
                            onKeyDown: _$a.props.handleOnKeyDown,
                            "aria-label": _$n ? _$u : _$c
                        }, de.default.createElement("span", {
                            className: [
                                "react-datepicker__navigation-icon",
                                "react-datepicker__navigation-icon--previous"
                            ].join(" ")
                        }, _$n ? _$a.props.previousYearButtonLabel : _$a.props.previousMonthButtonLabel));
                    }
                }
            }), St(Et(_$a), "increaseYear", function() {
                _$a.setState(function(e) {
                    var _$t = e.date;
                    return {
                        date: be.default(_$t, _$a.props.showYearPicker ? _$a.props.yearItemNumber : 1)
                    };
                }, function() {
                    return _$a.handleYearChange(_$a.state.date);
                });
            }), St(Et(_$a), "renderNextButton", function() {
                if (!_$a.props.renderCustomHeader) {
                    var _$e;
                    switch(!0){
                        case _$a.props.showMonthYearPicker:
                            _$e = gr(_$a.state.date, _$a.props);
                            break;
                        case _$a.props.showYearPicker:
                            _$e = function(e) {
                                var _$t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, _$r = _$t.maxDate, _$a = _$t.yearItemNumber, _$n = void 0 === _$a ? Lt : _$a, _$o = Mr(be.default(e, _$n), _$n).startPeriod, _$s = _$r && Le.default(_$r);
                                return _$s && _$s < _$o || !1;
                            }(_$a.state.date, _$a.props);
                            break;
                        default:
                            _$e = vr(_$a.state.date, _$a.props);
                    }
                    if ((_$a.props.forceShowMonthNavigation || _$a.props.showDisabledMonthNavigation || !_$e) && !_$a.props.showTimeSelectOnly) {
                        var _$t = [
                            "react-datepicker__navigation",
                            "react-datepicker__navigation--next"
                        ];
                        _$a.props.showTimeSelect && _$t.push("react-datepicker__navigation--next--with-time"), _$a.props.todayButton && _$t.push("react-datepicker__navigation--next--with-today-button");
                        var _$r = _$a.increaseMonth;
                        (_$a.props.showMonthYearPicker || _$a.props.showQuarterYearPicker || _$a.props.showYearPicker) && (_$r = _$a.increaseYear), _$e && _$a.props.showDisabledMonthNavigation && (_$t.push("react-datepicker__navigation--next--disabled"), _$r = null);
                        var _$n = _$a.props.showMonthYearPicker || _$a.props.showQuarterYearPicker || _$a.props.showYearPicker, _$o = _$a.props, _$s = _$o.nextMonthButtonLabel, _$i = _$o.nextYearButtonLabel, _$p = _$a.props, _$l = _$p.nextMonthAriaLabel, _$c = void 0 === _$l ? "string" == typeof _$s ? _$s : "Next Month" : _$l, _$d = _$p.nextYearAriaLabel, _$u = void 0 === _$d ? "string" == typeof _$i ? _$i : "Next Year" : _$d;
                        return de.default.createElement("button", {
                            type: "button",
                            className: _$t.join(" "),
                            onClick: _$r,
                            onKeyDown: _$a.props.handleOnKeyDown,
                            "aria-label": _$n ? _$u : _$c
                        }, de.default.createElement("span", {
                            className: [
                                "react-datepicker__navigation-icon",
                                "react-datepicker__navigation-icon--next"
                            ].join(" ")
                        }, _$n ? _$a.props.nextYearButtonLabel : _$a.props.nextMonthButtonLabel));
                    }
                }
            }), St(Et(_$a), "renderCurrentMonth", function() {
                var _$e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : _$a.state.date, _$t = [
                    "react-datepicker__current-month"
                ];
                return _$a.props.showYearDropdown && _$t.push("react-datepicker__current-month--hasYearDropdown"), _$a.props.showMonthDropdown && _$t.push("react-datepicker__current-month--hasMonthDropdown"), _$a.props.showMonthYearDropdown && _$t.push("react-datepicker__current-month--hasMonthYearDropdown"), de.default.createElement("div", {
                    className: _$t.join(" ")
                }, qt(_$e, _$a.props.dateFormat, _$a.props.locale));
            }), St(Et(_$a), "renderYearDropdown", function() {
                var _$e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                if (_$a.props.showYearDropdown && !_$e) return de.default.createElement(Yr, {
                    adjustDateOnChange: _$a.props.adjustDateOnChange,
                    date: _$a.state.date,
                    onSelect: _$a.props.onSelect,
                    setOpen: _$a.props.setOpen,
                    dropdownMode: _$a.props.dropdownMode,
                    onChange: _$a.changeYear,
                    minDate: _$a.props.minDate,
                    maxDate: _$a.props.maxDate,
                    year: Le.default(_$a.state.date),
                    scrollableYearDropdown: _$a.props.scrollableYearDropdown,
                    yearDropdownItemNumber: _$a.props.yearDropdownItemNumber
                });
            }), St(Et(_$a), "renderMonthDropdown", function() {
                var _$e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                if (_$a.props.showMonthDropdown && !_$e) return de.default.createElement(Tr, {
                    dropdownMode: _$a.props.dropdownMode,
                    locale: _$a.props.locale,
                    onChange: _$a.changeMonth,
                    month: Te.default(_$a.state.date),
                    useShortMonthInDropdown: _$a.props.useShortMonthInDropdown
                });
            }), St(Et(_$a), "renderMonthYearDropdown", function() {
                var _$e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                if (_$a.props.showMonthYearDropdown && !_$e) return de.default.createElement(Ar, {
                    dropdownMode: _$a.props.dropdownMode,
                    locale: _$a.props.locale,
                    dateFormat: _$a.props.dateFormat,
                    onChange: _$a.changeMonthYear,
                    minDate: _$a.props.minDate,
                    maxDate: _$a.props.maxDate,
                    date: _$a.state.date,
                    scrollableMonthYearDropdown: _$a.props.scrollableMonthYearDropdown
                });
            }), St(Et(_$a), "handleTodayButtonClick", function(e) {
                _$a.props.onSelect(Ut(), e), _$a.props.setPreSelection && _$a.props.setPreSelection(Ut());
            }), St(Et(_$a), "renderTodayButton", function() {
                if (_$a.props.todayButton && !_$a.props.showTimeSelectOnly) return de.default.createElement("div", {
                    className: "react-datepicker__today-button",
                    onClick: function onClick(e) {
                        return _$a.handleTodayButtonClick(e);
                    }
                }, _$a.props.todayButton);
            }), St(Et(_$a), "renderDefaultHeader", function(e) {
                var _$t = e.monthDate, _$r = e.i;
                return de.default.createElement("div", {
                    className: "react-datepicker__header ".concat(_$a.props.showTimeSelect ? "react-datepicker__header--has-time-select" : "")
                }, _$a.renderCurrentMonth(_$t), de.default.createElement("div", {
                    className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(_$a.props.dropdownMode),
                    onFocus: _$a.handleDropdownFocus
                }, _$a.renderMonthDropdown(0 !== _$r), _$a.renderMonthYearDropdown(0 !== _$r), _$a.renderYearDropdown(0 !== _$r)), de.default.createElement("div", {
                    className: "react-datepicker__day-names"
                }, _$a.header(_$t)));
            }), St(Et(_$a), "renderCustomHeader", function() {
                var _$e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, _$t = _$e.monthDate, _$r = _$e.i;
                if (_$a.props.showTimeSelect && !_$a.state.monthContainer || _$a.props.showTimeSelectOnly) return null;
                var _$n = yr(_$a.state.date, _$a.props), _$o = vr(_$a.state.date, _$a.props), _$s = Dr(_$a.state.date, _$a.props), _$i = gr(_$a.state.date, _$a.props), _$p = !_$a.props.showMonthYearPicker && !_$a.props.showQuarterYearPicker && !_$a.props.showYearPicker;
                return de.default.createElement("div", {
                    className: "react-datepicker__header react-datepicker__header--custom",
                    onFocus: _$a.props.onDropdownFocus
                }, _$a.props.renderCustomHeader(Dt(Dt({}, _$a.state), {}, {
                    customHeaderCount: _$r,
                    monthDate: _$t,
                    changeMonth: _$a.changeMonth,
                    changeYear: _$a.changeYear,
                    decreaseMonth: _$a.decreaseMonth,
                    increaseMonth: _$a.increaseMonth,
                    decreaseYear: _$a.decreaseYear,
                    increaseYear: _$a.increaseYear,
                    prevMonthButtonDisabled: _$n,
                    nextMonthButtonDisabled: _$o,
                    prevYearButtonDisabled: _$s,
                    nextYearButtonDisabled: _$i
                })), _$p && de.default.createElement("div", {
                    className: "react-datepicker__day-names"
                }, _$a.header(_$t)));
            }), St(Et(_$a), "renderYearHeader", function() {
                var _$e = _$a.state.date, _$t = _$a.props, _$r = _$t.showYearPicker, _$n = Mr(_$e, _$t.yearItemNumber), _$o = _$n.startPeriod, _$s = _$n.endPeriod;
                return de.default.createElement("div", {
                    className: "react-datepicker__header react-datepicker-year-header"
                }, _$r ? "".concat(_$o, " - ").concat(_$s) : Le.default(_$e));
            }), St(Et(_$a), "renderHeader", function(e) {
                switch(!0){
                    case void 0 !== _$a.props.renderCustomHeader:
                        return _$a.renderCustomHeader(e);
                    case _$a.props.showMonthYearPicker || _$a.props.showQuarterYearPicker || _$a.props.showYearPicker:
                        return _$a.renderYearHeader(e);
                    default:
                        return _$a.renderDefaultHeader(e);
                }
            }), St(Et(_$a), "renderMonths", function() {
                var _$e;
                if (!_$a.props.showTimeSelectOnly && !_$a.props.showYearPicker) {
                    for(var _$t = [], _$r = _$a.props.showPreviousMonths ? _$a.props.monthsShown - 1 : 0, _$n = _e.default(_$a.state.date, _$r), _$o = null !== (_$e = _$a.props.monthSelectedIn) && void 0 !== _$e ? _$e : _$r, _$s = 0; _$s < _$a.props.monthsShown; ++_$s){
                        var _$i = _$s - _$o + _$r, _$p = ke.default(_$n, _$i), _$l = "month-".concat(_$s), _$c = _$s < _$a.props.monthsShown - 1, _$d = _$s > 0;
                        _$t.push(de.default.createElement("div", {
                            key: _$l,
                            ref: function ref(e) {
                                _$a.monthContainer = e;
                            },
                            className: "react-datepicker__month-container"
                        }, _$a.renderHeader({
                            monthDate: _$p,
                            i: _$s
                        }), de.default.createElement(Ur, {
                            chooseDayAriaLabelPrefix: _$a.props.chooseDayAriaLabelPrefix,
                            disabledDayAriaLabelPrefix: _$a.props.disabledDayAriaLabelPrefix,
                            weekAriaLabelPrefix: _$a.props.weekAriaLabelPrefix,
                            ariaLabelPrefix: _$a.props.monthAriaLabelPrefix,
                            onChange: _$a.changeMonthYear,
                            day: _$p,
                            dayClassName: _$a.props.dayClassName,
                            calendarStartDay: _$a.props.calendarStartDay,
                            monthClassName: _$a.props.monthClassName,
                            onDayClick: _$a.handleDayClick,
                            handleOnKeyDown: _$a.props.handleOnDayKeyDown,
                            onDayMouseEnter: _$a.handleDayMouseEnter,
                            onMouseLeave: _$a.handleMonthMouseLeave,
                            onWeekSelect: _$a.props.onWeekSelect,
                            orderInDisplay: _$s,
                            formatWeekNumber: _$a.props.formatWeekNumber,
                            locale: _$a.props.locale,
                            minDate: _$a.props.minDate,
                            maxDate: _$a.props.maxDate,
                            excludeDates: _$a.props.excludeDates,
                            excludeDateIntervals: _$a.props.excludeDateIntervals,
                            highlightDates: _$a.props.highlightDates,
                            holidays: _$a.props.holidays,
                            selectingDate: _$a.state.selectingDate,
                            includeDates: _$a.props.includeDates,
                            includeDateIntervals: _$a.props.includeDateIntervals,
                            inline: _$a.props.inline,
                            shouldFocusDayInline: _$a.props.shouldFocusDayInline,
                            fixedHeight: _$a.props.fixedHeight,
                            filterDate: _$a.props.filterDate,
                            preSelection: _$a.props.preSelection,
                            setPreSelection: _$a.props.setPreSelection,
                            selected: _$a.props.selected,
                            selectsStart: _$a.props.selectsStart,
                            selectsEnd: _$a.props.selectsEnd,
                            selectsRange: _$a.props.selectsRange,
                            selectsDisabledDaysInRange: _$a.props.selectsDisabledDaysInRange,
                            showWeekNumbers: _$a.props.showWeekNumbers,
                            startDate: _$a.props.startDate,
                            endDate: _$a.props.endDate,
                            peekNextMonth: _$a.props.peekNextMonth,
                            setOpen: _$a.props.setOpen,
                            shouldCloseOnSelect: _$a.props.shouldCloseOnSelect,
                            renderDayContents: _$a.props.renderDayContents,
                            renderMonthContent: _$a.props.renderMonthContent,
                            renderQuarterContent: _$a.props.renderQuarterContent,
                            renderYearContent: _$a.props.renderYearContent,
                            disabledKeyboardNavigation: _$a.props.disabledKeyboardNavigation,
                            showMonthYearPicker: _$a.props.showMonthYearPicker,
                            showFullMonthYearPicker: _$a.props.showFullMonthYearPicker,
                            showTwoColumnMonthYearPicker: _$a.props.showTwoColumnMonthYearPicker,
                            showFourColumnMonthYearPicker: _$a.props.showFourColumnMonthYearPicker,
                            showYearPicker: _$a.props.showYearPicker,
                            showQuarterYearPicker: _$a.props.showQuarterYearPicker,
                            showWeekPicker: _$a.props.showWeekPicker,
                            isInputFocused: _$a.props.isInputFocused,
                            containerRef: _$a.containerRef,
                            monthShowsDuplicateDaysEnd: _$c,
                            monthShowsDuplicateDaysStart: _$d
                        })));
                    }
                    return _$t;
                }
            }), St(Et(_$a), "renderYears", function() {
                if (!_$a.props.showTimeSelectOnly) return _$a.props.showYearPicker ? de.default.createElement("div", {
                    className: "react-datepicker__year--container"
                }, _$a.renderHeader(), de.default.createElement($r, Ct({
                    onDayClick: _$a.handleDayClick,
                    selectingDate: _$a.state.selectingDate,
                    clearSelectingDate: _$a.clearSelectingDate,
                    date: _$a.state.date
                }, _$a.props, {
                    onYearMouseEnter: _$a.handleYearMouseEnter,
                    onYearMouseLeave: _$a.handleYearMouseLeave
                }))) : void 0;
            }), St(Et(_$a), "renderTimeSection", function() {
                if (_$a.props.showTimeSelect && (_$a.state.monthContainer || _$a.props.showTimeSelectOnly)) return de.default.createElement(zr, {
                    selected: _$a.props.selected,
                    openToDate: _$a.props.openToDate,
                    onChange: _$a.props.onTimeChange,
                    timeClassName: _$a.props.timeClassName,
                    format: _$a.props.timeFormat,
                    includeTimes: _$a.props.includeTimes,
                    intervals: _$a.props.timeIntervals,
                    minTime: _$a.props.minTime,
                    maxTime: _$a.props.maxTime,
                    excludeTimes: _$a.props.excludeTimes,
                    filterTime: _$a.props.filterTime,
                    timeCaption: _$a.props.timeCaption,
                    todayButton: _$a.props.todayButton,
                    showMonthDropdown: _$a.props.showMonthDropdown,
                    showMonthYearDropdown: _$a.props.showMonthYearDropdown,
                    showYearDropdown: _$a.props.showYearDropdown,
                    withPortal: _$a.props.withPortal,
                    monthRef: _$a.state.monthContainer,
                    injectTimes: _$a.props.injectTimes,
                    locale: _$a.props.locale,
                    handleOnKeyDown: _$a.props.handleOnKeyDown,
                    showTimeSelectOnly: _$a.props.showTimeSelectOnly
                });
            }), St(Et(_$a), "renderInputTimeSection", function() {
                var _$e = new Date(_$a.props.selected), _$t = Wt(_$e) && Boolean(_$a.props.selected) ? "".concat(_r(_$e.getHours()), ":").concat(_r(_$e.getMinutes())) : "";
                if (_$a.props.showTimeInput) return de.default.createElement(Gr, {
                    date: _$e,
                    timeString: _$t,
                    timeInputLabel: _$a.props.timeInputLabel,
                    onChange: _$a.props.onTimeChange,
                    customTimeInput: _$a.props.customTimeInput
                });
            }), St(Et(_$a), "renderAriaLiveRegion", function() {
                var _$e, _$t = Mr(_$a.state.date, _$a.props.yearItemNumber), _$r = _$t.startPeriod, _$n = _$t.endPeriod;
                return _$e = _$a.props.showYearPicker ? "".concat(_$r, " - ").concat(_$n) : _$a.props.showMonthYearPicker || _$a.props.showQuarterYearPicker ? Le.default(_$a.state.date) : "".concat(rr(Te.default(_$a.state.date), _$a.props.locale), " ").concat(Le.default(_$a.state.date)), de.default.createElement("span", {
                    role: "alert",
                    "aria-live": "polite",
                    className: "react-datepicker__aria-live"
                }, _$a.state.isRenderAriaLiveMessage && _$e);
            }), St(Et(_$a), "renderChildren", function() {
                if (_$a.props.children) return de.default.createElement("div", {
                    className: "react-datepicker__children-container"
                }, _$a.props.children);
            }), _$a.containerRef = de.default.createRef(), _$a.state = {
                date: _$a.getDateInView(),
                selectingDate: null,
                monthContainer: null,
                isRenderAriaLiveMessage: !1
            }, _$a;
        }
        return bt(r, [
            {
                key: "componentDidMount",
                value: function value() {
                    var _$e = this;
                    this.props.showTimeSelect && (this.assignMonthContainer = void _$e.setState({
                        monthContainer: _$e.monthContainer
                    }));
                }
            },
            {
                key: "componentDidUpdate",
                value: function value(e) {
                    var _$t = this;
                    if (!this.props.preSelection || Jt(this.props.preSelection, e.preSelection) && this.props.monthSelectedIn === e.monthSelectedIn) this.props.openToDate && !Jt(this.props.openToDate, e.openToDate) && this.setState({
                        date: this.props.openToDate
                    });
                    else {
                        var _$r = !$t(this.state.date, this.props.preSelection);
                        this.setState({
                            date: this.props.preSelection
                        }, function() {
                            return _$r && _$t.handleCustomMonthChange(_$t.state.date);
                        });
                    }
                }
            },
            {
                key: "render",
                value: function value() {
                    var _$e = this.props.container || Jr;
                    return de.default.createElement("div", {
                        style: {
                            display: "contents"
                        },
                        ref: this.containerRef
                    }, de.default.createElement(_$e, {
                        className: ue.default("react-datepicker", this.props.className, {
                            "react-datepicker--time-only": this.props.showTimeSelectOnly
                        }),
                        showPopperArrow: this.props.showPopperArrow,
                        arrowProps: this.props.arrowProps
                    }, this.renderAriaLiveRegion(), this.renderPreviousButton(), this.renderNextButton(), this.renderMonths(), this.renderYears(), this.renderTodayButton(), this.renderTimeSection(), this.renderInputTimeSection(), this.renderChildren()));
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function get() {
                    return {
                        onDropdownFocus: function onDropdownFocus() {},
                        monthsShown: 1,
                        forceShowMonthNavigation: !1,
                        timeCaption: "Time",
                        previousYearButtonLabel: "Previous Year",
                        nextYearButtonLabel: "Next Year",
                        previousMonthButtonLabel: "Previous Month",
                        nextMonthButtonLabel: "Next Month",
                        customTimeInput: null,
                        yearItemNumber: Lt
                    };
                }
            }
        ]), r;
    }(de.default.Component), ea = function ea(e) {
        var _$t = e.icon, r = e.className, _$a = void 0 === r ? "" : r, _$n = e.onClick, _$o = "react-datepicker__calendar-icon";
        return de.default.isValidElement(_$t) ? de.default.cloneElement(_$t, {
            className: "".concat(_$t.props.className || "", " ").concat(_$o, " ").concat(_$a),
            onClick: function onClick(e) {
                "function" == typeof _$t.props.onClick && _$t.props.onClick(e), "function" == typeof _$n && _$n(e);
            }
        }) : "string" == typeof _$t ? de.default.createElement("i", {
            className: "".concat(_$o, " ").concat(_$t, " ").concat(_$a),
            "aria-hidden": "true",
            onClick: _$n
        }) : de.default.createElement("svg", {
            className: "".concat(_$o, " ").concat(_$a),
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 448 512",
            onClick: _$n
        }, de.default.createElement("path", {
            d: "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z"
        }));
    }, ta = function(e) {
        _t(r, e);
        var _$t = Nt(r);
        function r(e) {
            var _$a;
            return kt(this, r), (_$a = _$t.call(this, e)).el = document.createElement("div"), _$a;
        }
        return bt(r, [
            {
                key: "componentDidMount",
                value: function value() {
                    this.portalRoot = (this.props.portalHost || document).getElementById(this.props.portalId), this.portalRoot || (this.portalRoot = document.createElement("div"), this.portalRoot.setAttribute("id", this.props.portalId), (this.props.portalHost || document.body).appendChild(this.portalRoot)), this.portalRoot.appendChild(this.el);
                }
            },
            {
                key: "componentWillUnmount",
                value: function value() {
                    this.portalRoot.removeChild(this.el);
                }
            },
            {
                key: "render",
                value: function value() {
                    return mt.default.createPortal(this.props.children, this.el);
                }
            }
        ]), r;
    }(de.default.Component), ra = function ra(e) {
        return !e.disabled && -1 !== e.tabIndex;
    }, aa = function(e) {
        _t(r, e);
        var _$t = Nt(r);
        function r(e) {
            var _$a;
            return kt(this, r), St(Et(_$a = _$t.call(this, e)), "getTabChildren", function() {
                return Array.prototype.slice.call(_$a.tabLoopRef.current.querySelectorAll("[tabindex], a, button, input, select, textarea"), 1, -1).filter(ra);
            }), St(Et(_$a), "handleFocusStart", function() {
                var _$e = _$a.getTabChildren();
                _$e && _$e.length > 1 && _$e[_$e.length - 1].focus();
            }), St(Et(_$a), "handleFocusEnd", function() {
                var _$e = _$a.getTabChildren();
                _$e && _$e.length > 1 && _$e[0].focus();
            }), _$a.tabLoopRef = de.default.createRef(), _$a;
        }
        return bt(r, [
            {
                key: "render",
                value: function value() {
                    return this.props.enableTabLoop ? de.default.createElement("div", {
                        className: "react-datepicker__tab-loop",
                        ref: this.tabLoopRef
                    }, de.default.createElement("div", {
                        className: "react-datepicker__tab-loop__start",
                        tabIndex: "0",
                        onFocus: this.handleFocusStart
                    }), this.props.children, de.default.createElement("div", {
                        className: "react-datepicker__tab-loop__end",
                        tabIndex: "0",
                        onFocus: this.handleFocusEnd
                    })) : this.props.children;
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function get() {
                    return {
                        enableTabLoop: !0
                    };
                }
            }
        ]), r;
    }(de.default.Component), na = function(e) {
        _t(r, e);
        var _$t = Nt(r);
        function r() {
            return kt(this, r), _$t.apply(this, arguments);
        }
        return bt(r, [
            {
                key: "render",
                value: function value() {
                    var _$e, _$t = this.props, _$r = _$t.className, _$a = _$t.wrapperClassName, _$n = _$t.hidePopper, _$o = _$t.popperComponent, _$s = _$t.popperModifiers, _$i = _$t.popperPlacement, _$p = _$t.popperProps, _$l = _$t.targetComponent, _$c = _$t.enableTabLoop, _$d = _$t.popperOnKeyDown, _$u = _$t.portalId, _$f = _$t.portalHost;
                    if (!_$n) {
                        var _$h = ue.default("react-datepicker-popper", _$r);
                        _$e = de.default.createElement(pe.Popper, Ct({
                            modifiers: _$s,
                            placement: _$i
                        }, _$p), function(e) {
                            var _$t = e.ref, _$r = e.style, _$a = e.placement, _$n = e.arrowProps;
                            return de.default.createElement(aa, {
                                enableTabLoop: _$c
                            }, de.default.createElement("div", {
                                ref: _$t,
                                style: _$r,
                                className: _$h,
                                "data-placement": _$a,
                                onKeyDown: _$d
                            }, de.default.cloneElement(_$o, {
                                arrowProps: _$n
                            })));
                        });
                    }
                    this.props.popperContainer && (_$e = de.default.createElement(this.props.popperContainer, {}, _$e)), _$u && !_$n && (_$e = de.default.createElement(ta, {
                        portalId: _$u,
                        portalHost: _$f
                    }, _$e));
                    var _$m = ue.default("react-datepicker-wrapper", _$a);
                    return de.default.createElement(pe.Manager, {
                        className: "react-datepicker-manager"
                    }, de.default.createElement(pe.Reference, null, function(e) {
                        var _$t = e.ref;
                        return de.default.createElement("div", {
                            ref: _$t,
                            className: _$m
                        }, _$l);
                    }), _$e);
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function get() {
                    return {
                        hidePopper: !0,
                        popperModifiers: [],
                        popperProps: {},
                        popperPlacement: "bottom-start"
                    };
                }
            }
        ]), r;
    }(de.default.Component), oa = "react-datepicker-ignore-onclickoutside", sa = ht.default(Zr);
    var ia = "Date input not valid.", pa = function(e) {
        _t(r, e);
        var _$t = Nt(r);
        function r(e) {
            var _$a;
            return kt(this, r), St(Et(_$a = _$t.call(this, e)), "getPreSelection", function() {
                return _$a.props.openToDate ? _$a.props.openToDate : _$a.props.selectsEnd && _$a.props.startDate ? _$a.props.startDate : _$a.props.selectsStart && _$a.props.endDate ? _$a.props.endDate : At();
            }), St(Et(_$a), "modifyHolidays", function() {
                var _$e;
                return null === (_$e = _$a.props.holidays) || void 0 === _$e ? void 0 : _$e.reduce(function(e, t) {
                    var _$r = new Date(t.date);
                    return he.default(_$r) ? [].concat(xt(e), [
                        Dt(Dt({}, t), {}, {
                            date: _$r
                        })
                    ]) : e;
                }, []);
            }), St(Et(_$a), "calcInitialState", function() {
                var _$e, _$t = _$a.getPreSelection(), _$r = kr(_$a.props), _$n = wr(_$a.props), _$o = _$r && lt.default(_$t, $e.default(_$r)) ? _$r : _$n && pt.default(_$t, et.default(_$n)) ? _$n : _$t;
                return {
                    open: _$a.props.startOpen || !1,
                    preventFocus: !1,
                    preSelection: null !== (_$e = _$a.props.selectsRange ? _$a.props.startDate : _$a.props.selected) && void 0 !== _$e ? _$e : _$o,
                    highlightDates: br(_$a.props.highlightDates),
                    focused: !1,
                    shouldFocusDayInline: !1,
                    isRenderAriaLiveMessage: !1
                };
            }), St(Et(_$a), "clearPreventFocusTimeout", function() {
                _$a.preventFocusTimeout && clearTimeout(_$a.preventFocusTimeout);
            }), St(Et(_$a), "setFocus", function() {
                _$a.input && _$a.input.focus && _$a.input.focus({
                    preventScroll: !0
                });
            }), St(Et(_$a), "setBlur", function() {
                _$a.input && _$a.input.blur && _$a.input.blur(), _$a.cancelFocusInput();
            }), St(Et(_$a), "setOpen", function(e) {
                var _$t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                _$a.setState({
                    open: e,
                    preSelection: e && _$a.state.open ? _$a.state.preSelection : _$a.calcInitialState().preSelection,
                    lastPreSelectChange: ca
                }, function() {
                    e || _$a.setState(function(e) {
                        return {
                            focused: !!_$t && e.focused
                        };
                    }, function() {
                        !_$t && _$a.setBlur(), _$a.setState({
                            inputValue: null
                        });
                    });
                });
            }), St(Et(_$a), "inputOk", function() {
                return fe.default(_$a.state.preSelection);
            }), St(Et(_$a), "isCalendarOpen", function() {
                return void 0 === _$a.props.open ? _$a.state.open && !_$a.props.disabled && !_$a.props.readOnly : _$a.props.open;
            }), St(Et(_$a), "handleFocus", function(e) {
                _$a.state.preventFocus || (_$a.props.onFocus(e), _$a.props.preventOpenOnFocus || _$a.props.readOnly || _$a.setOpen(!0)), _$a.setState({
                    focused: !0
                });
            }), St(Et(_$a), "sendFocusBackToInput", function() {
                _$a.preventFocusTimeout && _$a.clearPreventFocusTimeout(), _$a.setState({
                    preventFocus: !0
                }, function() {
                    _$a.preventFocusTimeout = setTimeout(function() {
                        _$a.setFocus(), _$a.setState({
                            preventFocus: !1
                        });
                    });
                });
            }), St(Et(_$a), "cancelFocusInput", function() {
                clearTimeout(_$a.inputFocusTimeout), _$a.inputFocusTimeout = null;
            }), St(Et(_$a), "deferFocusInput", function() {
                _$a.cancelFocusInput(), _$a.inputFocusTimeout = setTimeout(function() {
                    return _$a.setFocus();
                }, 1);
            }), St(Et(_$a), "handleDropdownFocus", function() {
                _$a.cancelFocusInput();
            }), St(Et(_$a), "handleBlur", function(e) {
                (!_$a.state.open || _$a.props.withPortal || _$a.props.showTimeInput) && _$a.props.onBlur(e), _$a.setState({
                    focused: !1
                });
            }), St(Et(_$a), "handleCalendarClickOutside", function(e) {
                _$a.props.inline || _$a.setOpen(!1), _$a.props.onClickOutside(e), _$a.props.withPortal && e.preventDefault();
            }), St(Et(_$a), "handleChange", function() {
                for(var _$e = arguments.length, _$t = new Array(_$e), _$r = 0; _$r < _$e; _$r++)_$t[_$r] = arguments[_$r];
                var _$n = _$t[0];
                if (!_$a.props.onChangeRaw || (_$a.props.onChangeRaw.apply(Et(_$a), _$t), "function" == typeof _$n.isDefaultPrevented && !_$n.isDefaultPrevented())) {
                    _$a.setState({
                        inputValue: _$n.target.value,
                        lastPreSelectChange: la
                    });
                    var _$o, _$s, _$i, _$p, _$l, _$c, _$d, _$u, _$f = (_$o = _$n.target.value, _$s = _$a.props.dateFormat, _$i = _$a.props.locale, _$p = _$a.props.strictParsing, _$l = _$a.props.minDate, _$c = null, _$d = tr(_$i) || tr(er()), _$u = !0, Array.isArray(_$s) ? (_$s.forEach(function(e) {
                        var _$t = ut.default(_$o, e, new Date, {
                            locale: _$d
                        });
                        _$p && (_$u = Wt(_$t, _$l) && _$o === qt(_$t, e, _$i)), Wt(_$t, _$l) && _$u && (_$c = _$t);
                    }), _$c) : (_$c = ut.default(_$o, _$s, new Date, {
                        locale: _$d
                    }), _$p ? _$u = Wt(_$c) && _$o === qt(_$c, _$s, _$i) : Wt(_$c) || (_$s = _$s.match(Ft).map(function(e) {
                        var _$t = e[0];
                        return "p" === _$t || "P" === _$t ? _$d ? (0, Rt[_$t])(e, _$d.formatLong) : _$t : e;
                    }).join(""), _$o.length > 0 && (_$c = ut.default(_$o, _$s.slice(0, _$o.length), new Date)), Wt(_$c) || (_$c = new Date(_$o))), Wt(_$c) && _$u ? _$c : null));
                    _$a.props.showTimeSelectOnly && _$a.props.selected && _$f && !Jt(_$f, _$a.props.selected) && (_$f = yt.default(_$a.props.selected, {
                        hours: xe.default(_$f),
                        minutes: Ne.default(_$f),
                        seconds: Ee.default(_$f)
                    })), !_$f && _$n.target.value || (_$a.props.showWeekPicker && (_$f = Qt(_$f, _$a.props.locale, _$a.props.calendarStartDay)), _$a.setSelected(_$f, _$n, !0));
                }
            }), St(Et(_$a), "handleSelect", function(e, t, r) {
                if (_$a.props.shouldCloseOnSelect && !_$a.props.showTimeSelect && _$a.sendFocusBackToInput(), _$a.props.onChangeRaw && _$a.props.onChangeRaw(t), _$a.props.showWeekPicker && (e = Qt(e, _$a.props.locale, _$a.props.calendarStartDay)), _$a.setSelected(e, t, !1, r), _$a.props.showDateSelect && _$a.setState({
                    isRenderAriaLiveMessage: !0
                }), !_$a.props.shouldCloseOnSelect || _$a.props.showTimeSelect) _$a.setPreSelection(e);
                else if (!_$a.props.inline) {
                    _$a.props.selectsRange || _$a.setOpen(!1);
                    var _$n = _$a.props, _$o = _$n.startDate, _$s = _$n.endDate;
                    !_$o || _$s || lt.default(e, _$o) || _$a.setOpen(!1);
                }
            }), St(Et(_$a), "setSelected", function(e, t, r, n) {
                var _$o = e;
                if (_$a.props.showYearPicker) {
                    if (null !== _$o && cr(Le.default(_$o), _$a.props)) return;
                } else if (_$a.props.showMonthYearPicker) {
                    if (null !== _$o && sr(_$o, _$a.props)) return;
                } else if (null !== _$o && nr(_$o, _$a.props)) return;
                var _$s = _$a.props, _$i = _$s.onChange, _$p = _$s.selectsRange, _$l = _$s.startDate, _$c = _$s.endDate;
                if (!Xt(_$a.props.selected, _$o) || _$a.props.allowSameDay || _$p) {
                    if (null !== _$o && (!_$a.props.selected || r && (_$a.props.showTimeSelect || _$a.props.showTimeSelectOnly || _$a.props.showTimeInput) || (_$o = Bt(_$o, {
                        hour: xe.default(_$a.props.selected),
                        minute: Ne.default(_$a.props.selected),
                        second: Ee.default(_$a.props.selected)
                    })), _$a.props.inline || _$a.setState({
                        preSelection: _$o
                    }), _$a.props.focusSelectedMonth || _$a.setState({
                        monthSelectedIn: n
                    })), _$p) {
                        var _$d = _$l && !_$c, _$u = _$l && _$c;
                        !_$l && !_$c ? _$i([
                            _$o,
                            null
                        ], t) : _$d && (lt.default(_$o, _$l) ? _$i([
                            _$o,
                            null
                        ], t) : _$i([
                            _$l,
                            _$o
                        ], t)), _$u && _$i([
                            _$o,
                            null
                        ], t);
                    } else _$i(_$o, t);
                }
                r || (_$a.props.onSelect(_$o, t), _$a.setState({
                    inputValue: null
                }));
            }), St(Et(_$a), "setPreSelection", function(e) {
                var _$t = void 0 !== _$a.props.minDate, _$r = void 0 !== _$a.props.maxDate, _$n = !0;
                if (e) {
                    _$a.props.showWeekPicker && (e = Qt(e, _$a.props.locale, _$a.props.calendarStartDay));
                    var _$o = $e.default(e);
                    if (_$t && _$r) _$n = Zt(e, _$a.props.minDate, _$a.props.maxDate);
                    else if (_$t) {
                        var _$s = $e.default(_$a.props.minDate);
                        _$n = pt.default(e, _$s) || Xt(_$o, _$s);
                    } else if (_$r) {
                        var _$i = et.default(_$a.props.maxDate);
                        _$n = lt.default(e, _$i) || Xt(_$o, _$i);
                    }
                }
                _$n && _$a.setState({
                    preSelection: e
                });
            }), St(Et(_$a), "toggleCalendar", function() {
                _$a.setOpen(!_$a.state.open);
            }), St(Et(_$a), "handleTimeChange", function(e) {
                var _$t = _$a.props.selected ? _$a.props.selected : _$a.getPreSelection(), _$r = _$a.props.selected ? e : Bt(_$t, {
                    hour: xe.default(e),
                    minute: Ne.default(e)
                });
                _$a.setState({
                    preSelection: _$r
                }), _$a.props.onChange(_$r), _$a.props.shouldCloseOnSelect && (_$a.sendFocusBackToInput(), _$a.setOpen(!1)), _$a.props.showTimeInput && _$a.setOpen(!0), (_$a.props.showTimeSelectOnly || _$a.props.showTimeSelect) && _$a.setState({
                    isRenderAriaLiveMessage: !0
                }), _$a.setState({
                    inputValue: null
                });
            }), St(Et(_$a), "onInputClick", function() {
                _$a.props.disabled || _$a.props.readOnly || _$a.setOpen(!0), _$a.props.onInputClick();
            }), St(Et(_$a), "onInputKeyDown", function(e) {
                _$a.props.onKeyDown(e);
                var _$t = e.key;
                if (_$a.state.open || _$a.props.inline || _$a.props.preventOpenOnFocus) {
                    if (_$a.state.open) {
                        if ("ArrowDown" === _$t || "ArrowUp" === _$t) {
                            e.preventDefault();
                            var _$r = _$a.props.showWeekPicker && _$a.props.showWeekNumbers ? '.react-datepicker__week-number[tabindex="0"]' : '.react-datepicker__day[tabindex="0"]', _$n = _$a.calendar.componentNode && _$a.calendar.componentNode.querySelector(_$r);
                            return void (_$n && _$n.focus({
                                preventScroll: !0
                            }));
                        }
                        var _$o = At(_$a.state.preSelection);
                        "Enter" === _$t ? (e.preventDefault(), _$a.inputOk() && _$a.state.lastPreSelectChange === ca ? (_$a.handleSelect(_$o, e), !_$a.props.shouldCloseOnSelect && _$a.setPreSelection(_$o)) : _$a.setOpen(!1)) : "Escape" === _$t ? (e.preventDefault(), _$a.sendFocusBackToInput(), _$a.setOpen(!1)) : "Tab" === _$t && _$a.setOpen(!1), _$a.inputOk() || _$a.props.onInputError({
                            code: 1,
                            msg: ia
                        });
                    }
                } else "ArrowDown" !== _$t && "ArrowUp" !== _$t && "Enter" !== _$t || _$a.onInputClick();
            }), St(Et(_$a), "onPortalKeyDown", function(e) {
                "Escape" === e.key && (e.preventDefault(), _$a.setState({
                    preventFocus: !0
                }, function() {
                    _$a.setOpen(!1), setTimeout(function() {
                        _$a.setFocus(), _$a.setState({
                            preventFocus: !1
                        });
                    });
                }));
            }), St(Et(_$a), "onDayKeyDown", function(e) {
                _$a.props.onKeyDown(e);
                var _$t = e.key, _$r = At(_$a.state.preSelection);
                if ("Enter" === _$t) e.preventDefault(), _$a.handleSelect(_$r, e), !_$a.props.shouldCloseOnSelect && _$a.setPreSelection(_$r);
                else if ("Escape" === _$t) e.preventDefault(), _$a.setOpen(!1), _$a.inputOk() || _$a.props.onInputError({
                    code: 1,
                    msg: ia
                });
                else if (!_$a.props.disabledKeyboardNavigation) {
                    var _$n;
                    switch(_$t){
                        case "ArrowLeft":
                            _$n = _$a.props.showWeekPicker ? Ce.default(_$r, 1) : Se.default(_$r, 1);
                            break;
                        case "ArrowRight":
                            _$n = _$a.props.showWeekPicker ? ge.default(_$r, 1) : De.default(_$r, 1);
                            break;
                        case "ArrowUp":
                            _$n = Ce.default(_$r, 1);
                            break;
                        case "ArrowDown":
                            _$n = ge.default(_$r, 1);
                            break;
                        case "PageUp":
                            _$n = _e.default(_$r, 1);
                            break;
                        case "PageDown":
                            _$n = ke.default(_$r, 1);
                            break;
                        case "Home":
                            _$n = Pe.default(_$r, 1);
                            break;
                        case "End":
                            _$n = be.default(_$r, 1);
                            break;
                        default:
                            _$n = null;
                    }
                    if (!_$n) return void (_$a.props.onInputError && _$a.props.onInputError({
                        code: 1,
                        msg: ia
                    }));
                    if (e.preventDefault(), _$a.setState({
                        lastPreSelectChange: ca
                    }), _$a.props.adjustDateOnChange && _$a.setSelected(_$n), _$a.setPreSelection(_$n), _$a.props.inline) {
                        var _$o = Te.default(_$r), _$s = Te.default(_$n), _$i = Le.default(_$r), _$p = Le.default(_$n);
                        _$o !== _$s || _$i !== _$p ? _$a.setState({
                            shouldFocusDayInline: !0
                        }) : _$a.setState({
                            shouldFocusDayInline: !1
                        });
                    }
                }
            }), St(Et(_$a), "onPopperKeyDown", function(e) {
                "Escape" === e.key && (e.preventDefault(), _$a.sendFocusBackToInput());
            }), St(Et(_$a), "onClearClick", function(e) {
                e && e.preventDefault && e.preventDefault(), _$a.sendFocusBackToInput(), _$a.props.selectsRange ? _$a.props.onChange([
                    null,
                    null
                ], e) : _$a.props.onChange(null, e), _$a.setState({
                    inputValue: null
                });
            }), St(Et(_$a), "clear", function() {
                _$a.onClearClick();
            }), St(Et(_$a), "onScroll", function(e) {
                "boolean" == typeof _$a.props.closeOnScroll && _$a.props.closeOnScroll ? e.target !== document && e.target !== document.documentElement && e.target !== document.body || _$a.setOpen(!1) : "function" == typeof _$a.props.closeOnScroll && _$a.props.closeOnScroll(e) && _$a.setOpen(!1);
            }), St(Et(_$a), "renderCalendar", function() {
                return _$a.props.inline || _$a.isCalendarOpen() ? de.default.createElement(sa, {
                    ref: function ref(e) {
                        _$a.calendar = e;
                    },
                    locale: _$a.props.locale,
                    calendarStartDay: _$a.props.calendarStartDay,
                    chooseDayAriaLabelPrefix: _$a.props.chooseDayAriaLabelPrefix,
                    disabledDayAriaLabelPrefix: _$a.props.disabledDayAriaLabelPrefix,
                    weekAriaLabelPrefix: _$a.props.weekAriaLabelPrefix,
                    monthAriaLabelPrefix: _$a.props.monthAriaLabelPrefix,
                    adjustDateOnChange: _$a.props.adjustDateOnChange,
                    setOpen: _$a.setOpen,
                    shouldCloseOnSelect: _$a.props.shouldCloseOnSelect,
                    dateFormat: _$a.props.dateFormatCalendar,
                    useWeekdaysShort: _$a.props.useWeekdaysShort,
                    formatWeekDay: _$a.props.formatWeekDay,
                    dropdownMode: _$a.props.dropdownMode,
                    selected: _$a.props.selected,
                    preSelection: _$a.state.preSelection,
                    onSelect: _$a.handleSelect,
                    onWeekSelect: _$a.props.onWeekSelect,
                    openToDate: _$a.props.openToDate,
                    minDate: _$a.props.minDate,
                    maxDate: _$a.props.maxDate,
                    selectsStart: _$a.props.selectsStart,
                    selectsEnd: _$a.props.selectsEnd,
                    selectsRange: _$a.props.selectsRange,
                    startDate: _$a.props.startDate,
                    endDate: _$a.props.endDate,
                    excludeDates: _$a.props.excludeDates,
                    excludeDateIntervals: _$a.props.excludeDateIntervals,
                    filterDate: _$a.props.filterDate,
                    onClickOutside: _$a.handleCalendarClickOutside,
                    formatWeekNumber: _$a.props.formatWeekNumber,
                    highlightDates: _$a.state.highlightDates,
                    holidays: Sr(_$a.modifyHolidays()),
                    includeDates: _$a.props.includeDates,
                    includeDateIntervals: _$a.props.includeDateIntervals,
                    includeTimes: _$a.props.includeTimes,
                    injectTimes: _$a.props.injectTimes,
                    inline: _$a.props.inline,
                    shouldFocusDayInline: _$a.state.shouldFocusDayInline,
                    peekNextMonth: _$a.props.peekNextMonth,
                    showMonthDropdown: _$a.props.showMonthDropdown,
                    showPreviousMonths: _$a.props.showPreviousMonths,
                    useShortMonthInDropdown: _$a.props.useShortMonthInDropdown,
                    showMonthYearDropdown: _$a.props.showMonthYearDropdown,
                    showWeekNumbers: _$a.props.showWeekNumbers,
                    showYearDropdown: _$a.props.showYearDropdown,
                    withPortal: _$a.props.withPortal,
                    forceShowMonthNavigation: _$a.props.forceShowMonthNavigation,
                    showDisabledMonthNavigation: _$a.props.showDisabledMonthNavigation,
                    scrollableYearDropdown: _$a.props.scrollableYearDropdown,
                    scrollableMonthYearDropdown: _$a.props.scrollableMonthYearDropdown,
                    todayButton: _$a.props.todayButton,
                    weekLabel: _$a.props.weekLabel,
                    outsideClickIgnoreClass: oa,
                    fixedHeight: _$a.props.fixedHeight,
                    monthsShown: _$a.props.monthsShown,
                    monthSelectedIn: _$a.state.monthSelectedIn,
                    onDropdownFocus: _$a.handleDropdownFocus,
                    onMonthChange: _$a.props.onMonthChange,
                    onYearChange: _$a.props.onYearChange,
                    dayClassName: _$a.props.dayClassName,
                    weekDayClassName: _$a.props.weekDayClassName,
                    monthClassName: _$a.props.monthClassName,
                    timeClassName: _$a.props.timeClassName,
                    showDateSelect: _$a.props.showDateSelect,
                    showTimeSelect: _$a.props.showTimeSelect,
                    showTimeSelectOnly: _$a.props.showTimeSelectOnly,
                    onTimeChange: _$a.handleTimeChange,
                    timeFormat: _$a.props.timeFormat,
                    timeIntervals: _$a.props.timeIntervals,
                    minTime: _$a.props.minTime,
                    maxTime: _$a.props.maxTime,
                    excludeTimes: _$a.props.excludeTimes,
                    filterTime: _$a.props.filterTime,
                    timeCaption: _$a.props.timeCaption,
                    className: _$a.props.calendarClassName,
                    container: _$a.props.calendarContainer,
                    yearItemNumber: _$a.props.yearItemNumber,
                    yearDropdownItemNumber: _$a.props.yearDropdownItemNumber,
                    previousMonthAriaLabel: _$a.props.previousMonthAriaLabel,
                    previousMonthButtonLabel: _$a.props.previousMonthButtonLabel,
                    nextMonthAriaLabel: _$a.props.nextMonthAriaLabel,
                    nextMonthButtonLabel: _$a.props.nextMonthButtonLabel,
                    previousYearAriaLabel: _$a.props.previousYearAriaLabel,
                    previousYearButtonLabel: _$a.props.previousYearButtonLabel,
                    nextYearAriaLabel: _$a.props.nextYearAriaLabel,
                    nextYearButtonLabel: _$a.props.nextYearButtonLabel,
                    timeInputLabel: _$a.props.timeInputLabel,
                    disabledKeyboardNavigation: _$a.props.disabledKeyboardNavigation,
                    renderCustomHeader: _$a.props.renderCustomHeader,
                    popperProps: _$a.props.popperProps,
                    renderDayContents: _$a.props.renderDayContents,
                    renderMonthContent: _$a.props.renderMonthContent,
                    renderQuarterContent: _$a.props.renderQuarterContent,
                    renderYearContent: _$a.props.renderYearContent,
                    onDayMouseEnter: _$a.props.onDayMouseEnter,
                    onMonthMouseLeave: _$a.props.onMonthMouseLeave,
                    onYearMouseEnter: _$a.props.onYearMouseEnter,
                    onYearMouseLeave: _$a.props.onYearMouseLeave,
                    selectsDisabledDaysInRange: _$a.props.selectsDisabledDaysInRange,
                    showTimeInput: _$a.props.showTimeInput,
                    showMonthYearPicker: _$a.props.showMonthYearPicker,
                    showFullMonthYearPicker: _$a.props.showFullMonthYearPicker,
                    showTwoColumnMonthYearPicker: _$a.props.showTwoColumnMonthYearPicker,
                    showFourColumnMonthYearPicker: _$a.props.showFourColumnMonthYearPicker,
                    showYearPicker: _$a.props.showYearPicker,
                    showQuarterYearPicker: _$a.props.showQuarterYearPicker,
                    showWeekPicker: _$a.props.showWeekPicker,
                    showPopperArrow: _$a.props.showPopperArrow,
                    excludeScrollbar: _$a.props.excludeScrollbar,
                    handleOnKeyDown: _$a.props.onKeyDown,
                    handleOnDayKeyDown: _$a.onDayKeyDown,
                    isInputFocused: _$a.state.focused,
                    customTimeInput: _$a.props.customTimeInput,
                    setPreSelection: _$a.setPreSelection
                }, _$a.props.children) : null;
            }), St(Et(_$a), "renderAriaLiveRegion", function() {
                var _$e, _$t = _$a.props, _$r = _$t.dateFormat, _$n = _$t.locale, _$o = _$a.props.showTimeInput || _$a.props.showTimeSelect ? "PPPPp" : "PPPP";
                return _$e = _$a.props.selectsRange ? "Selected start date: ".concat(Kt(_$a.props.startDate, {
                    dateFormat: _$o,
                    locale: _$n
                }), ". ").concat(_$a.props.endDate ? "End date: " + Kt(_$a.props.endDate, {
                    dateFormat: _$o,
                    locale: _$n
                }) : "") : _$a.props.showTimeSelectOnly ? "Selected time: ".concat(Kt(_$a.props.selected, {
                    dateFormat: _$r,
                    locale: _$n
                })) : _$a.props.showYearPicker ? "Selected year: ".concat(Kt(_$a.props.selected, {
                    dateFormat: "yyyy",
                    locale: _$n
                })) : _$a.props.showMonthYearPicker ? "Selected month: ".concat(Kt(_$a.props.selected, {
                    dateFormat: "MMMM yyyy",
                    locale: _$n
                })) : _$a.props.showQuarterYearPicker ? "Selected quarter: ".concat(Kt(_$a.props.selected, {
                    dateFormat: "yyyy, QQQ",
                    locale: _$n
                })) : "Selected date: ".concat(Kt(_$a.props.selected, {
                    dateFormat: _$o,
                    locale: _$n
                })), de.default.createElement("span", {
                    role: "alert",
                    "aria-live": "polite",
                    className: "react-datepicker__aria-live"
                }, _$e);
            }), St(Et(_$a), "renderDateInput", function() {
                var _$e, _$t = ue.default(_$a.props.className, St({}, oa, _$a.state.open)), _$r = _$a.props.customInput || de.default.createElement("input", {
                    type: "text"
                }), _$n = _$a.props.customInputRef || "ref", _$o = "string" == typeof _$a.props.value ? _$a.props.value : "string" == typeof _$a.state.inputValue ? _$a.state.inputValue : _$a.props.selectsRange ? function(e, t, r) {
                    if (!e) return "";
                    var _$a = Kt(e, r), _$n = t ? Kt(t, r) : "";
                    return "".concat(_$a, " - ").concat(_$n);
                }(_$a.props.startDate, _$a.props.endDate, _$a.props) : Kt(_$a.props.selected, _$a.props);
                return de.default.cloneElement(_$r, (St(St(St(St(St(St(St(St(St(St(_$e = {}, _$n, function(e) {
                    _$a.input = e;
                }), "value", _$o), "onBlur", _$a.handleBlur), "onChange", _$a.handleChange), "onClick", _$a.onInputClick), "onFocus", _$a.handleFocus), "onKeyDown", _$a.onInputKeyDown), "id", _$a.props.id), "name", _$a.props.name), "form", _$a.props.form), St(St(St(St(St(St(St(St(St(St(_$e, "autoFocus", _$a.props.autoFocus), "placeholder", _$a.props.placeholderText), "disabled", _$a.props.disabled), "autoComplete", _$a.props.autoComplete), "className", ue.default(_$r.props.className, _$t)), "title", _$a.props.title), "readOnly", _$a.props.readOnly), "required", _$a.props.required), "tabIndex", _$a.props.tabIndex), "aria-describedby", _$a.props.ariaDescribedBy), St(St(St(_$e, "aria-invalid", _$a.props.ariaInvalid), "aria-labelledby", _$a.props.ariaLabelledBy), "aria-required", _$a.props.ariaRequired)));
            }), St(Et(_$a), "renderClearButton", function() {
                var _$e = _$a.props, _$t = _$e.isClearable, _$r = _$e.disabled, _$n = _$e.selected, _$o = _$e.startDate, _$s = _$e.endDate, _$i = _$e.clearButtonTitle, _$p = _$e.clearButtonClassName, _$l = void 0 === _$p ? "" : _$p, _$c = _$e.ariaLabelClose, _$d = void 0 === _$c ? "Close" : _$c;
                return !_$t || null == _$n && null == _$o && null == _$s ? null : de.default.createElement("button", {
                    type: "button",
                    className: ue.default("react-datepicker__close-icon", _$l, {
                        "react-datepicker__close-icon--disabled": _$r
                    }),
                    disabled: _$r,
                    "aria-label": _$d,
                    onClick: _$a.onClearClick,
                    title: _$i,
                    tabIndex: -1
                });
            }), _$a.state = _$a.calcInitialState(), _$a.preventFocusTimeout = null, _$a;
        }
        return bt(r, [
            {
                key: "componentDidMount",
                value: function value() {
                    window.addEventListener("scroll", this.onScroll, !0);
                }
            },
            {
                key: "componentDidUpdate",
                value: function value(e, t) {
                    var _$r, _$a;
                    e.inline && (_$r = e.selected, _$a = this.props.selected, _$r && _$a ? Te.default(_$r) !== Te.default(_$a) || Le.default(_$r) !== Le.default(_$a) : _$r !== _$a) && this.setPreSelection(this.props.selected), void 0 !== this.state.monthSelectedIn && e.monthsShown !== this.props.monthsShown && this.setState({
                        monthSelectedIn: 0
                    }), e.highlightDates !== this.props.highlightDates && this.setState({
                        highlightDates: br(this.props.highlightDates)
                    }), t.focused || Xt(e.selected, this.props.selected) || this.setState({
                        inputValue: null
                    }), t.open !== this.state.open && (!1 === t.open && !0 === this.state.open && this.props.onCalendarOpen(), !0 === t.open && !1 === this.state.open && this.props.onCalendarClose());
                }
            },
            {
                key: "componentWillUnmount",
                value: function value() {
                    this.clearPreventFocusTimeout(), window.removeEventListener("scroll", this.onScroll, !0);
                }
            },
            {
                key: "renderInputContainer",
                value: function value() {
                    var _$e = this.props, _$t = _$e.showIcon, _$r = _$e.icon, _$a = _$e.calendarIconClassname, _$n = _$e.toggleCalendarOnIconClick, _$o = this.state.open;
                    return de.default.createElement("div", {
                        className: "react-datepicker__input-container".concat(_$t ? " react-datepicker__view-calendar-icon" : "")
                    }, _$t && de.default.createElement(ea, Ct({
                        icon: _$r,
                        className: "".concat(_$a, " ").concat(_$o && "react-datepicker-ignore-onclickoutside")
                    }, _$n ? {
                        onClick: this.toggleCalendar
                    } : null)), this.state.isRenderAriaLiveMessage && this.renderAriaLiveRegion(), this.renderDateInput(), this.renderClearButton());
                }
            },
            {
                key: "render",
                value: function value() {
                    var _$e = this.renderCalendar();
                    if (this.props.inline) return _$e;
                    if (this.props.withPortal) {
                        var _$t = this.state.open ? de.default.createElement(aa, {
                            enableTabLoop: this.props.enableTabLoop
                        }, de.default.createElement("div", {
                            className: "react-datepicker__portal",
                            tabIndex: -1,
                            onKeyDown: this.onPortalKeyDown
                        }, _$e)) : null;
                        return this.state.open && this.props.portalId && (_$t = de.default.createElement(ta, {
                            portalId: this.props.portalId,
                            portalHost: this.props.portalHost
                        }, _$t)), de.default.createElement("div", null, this.renderInputContainer(), _$t);
                    }
                    return de.default.createElement(na, {
                        className: this.props.popperClassName,
                        wrapperClassName: this.props.wrapperClassName,
                        hidePopper: !this.isCalendarOpen(),
                        portalId: this.props.portalId,
                        portalHost: this.props.portalHost,
                        popperModifiers: this.props.popperModifiers,
                        targetComponent: this.renderInputContainer(),
                        popperContainer: this.props.popperContainer,
                        popperComponent: _$e,
                        popperPlacement: this.props.popperPlacement,
                        popperProps: this.props.popperProps,
                        popperOnKeyDown: this.onPopperKeyDown,
                        enableTabLoop: this.props.enableTabLoop
                    });
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function get() {
                    return {
                        allowSameDay: !1,
                        dateFormat: "MM/dd/yyyy",
                        dateFormatCalendar: "LLLL yyyy",
                        onChange: function onChange() {},
                        disabled: !1,
                        disabledKeyboardNavigation: !1,
                        dropdownMode: "scroll",
                        onFocus: function onFocus() {},
                        onBlur: function onBlur() {},
                        onKeyDown: function onKeyDown() {},
                        onInputClick: function onInputClick() {},
                        onSelect: function onSelect() {},
                        onClickOutside: function onClickOutside() {},
                        onMonthChange: function onMonthChange() {},
                        onCalendarOpen: function onCalendarOpen() {},
                        onCalendarClose: function onCalendarClose() {},
                        preventOpenOnFocus: !1,
                        onYearChange: function onYearChange() {},
                        onInputError: function onInputError() {},
                        monthsShown: 1,
                        readOnly: !1,
                        withPortal: !1,
                        selectsDisabledDaysInRange: !1,
                        shouldCloseOnSelect: !0,
                        showTimeSelect: !1,
                        showTimeInput: !1,
                        showPreviousMonths: !1,
                        showMonthYearPicker: !1,
                        showFullMonthYearPicker: !1,
                        showTwoColumnMonthYearPicker: !1,
                        showFourColumnMonthYearPicker: !1,
                        showYearPicker: !1,
                        showQuarterYearPicker: !1,
                        showWeekPicker: !1,
                        strictParsing: !1,
                        timeIntervals: 30,
                        timeCaption: "Time",
                        previousMonthAriaLabel: "Previous Month",
                        previousMonthButtonLabel: "Previous Month",
                        nextMonthAriaLabel: "Next Month",
                        nextMonthButtonLabel: "Next Month",
                        previousYearAriaLabel: "Previous Year",
                        previousYearButtonLabel: "Previous Year",
                        nextYearAriaLabel: "Next Year",
                        nextYearButtonLabel: "Next Year",
                        timeInputLabel: "Time",
                        enableTabLoop: !0,
                        yearItemNumber: Lt,
                        focusSelectedMonth: !1,
                        showPopperArrow: !0,
                        excludeScrollbar: !0,
                        customTimeInput: null,
                        calendarStartDay: void 0,
                        toggleCalendarOnIconClick: !1
                    };
                }
            }
        ]), r;
    }(de.default.Component), la = "input", ca = "navigate";
    e.CalendarContainer = Jr, e.default = pa, e.getDefaultLocale = er, e.registerLocale = function(e, t) {
        var r = "undefined" != typeof window ? window : globalThis;
        r.__localeData__ || (r.__localeData__ = {}), r.__localeData__[e] = t;
    }, e.setDefaultLocale = function(e) {
        ("undefined" != typeof window ? window : globalThis).__localeId__ = e;
    }, Object.defineProperty(e, "__esModule", {
        value: !0
    });
});

},{"55b400dfb9477df9":"c8CN1","6a082dc438cb1ca2":"6jeze","3647656f9c7ebc5e":"4SuBi","13c776570732a9da":"kf7MH","6553b0b4b603e1c3":"3ObFu","d7b993ace1eca80":"jiVQj","786b9925c1b6b5ed":"fHgOy","4f1b37d05fed00b3":"yE0Wz","5fc940b8b11b2f30":"6e3pH","b78d0278e54da1b4":"18VNy","baecc74d7df402ea":"b6CDb","13428a01c277b105":"5SOib","7360dafd9cf06bde":"h6bgS","aa659b497503e983":"gJbai","7b7bf8fb2c20e0c7":"agARD","f501b8cd52ae4ff":"fRDfS","d616e9f0b9bc7b7a":"7vZQY","9e212fc4b323ed41":"1rE32","e8ff49b0d1cab426":"35XPm","12eec1f6d562e008":"3RGKD","72fc20cc52029f11":"65WjS","42e3036b4499153e":"klmhq","5592c752ef1290f4":"l7Zuc","8406427195a66845":"bmNCw","fa470ac376b26caf":"cnODP","bf3222da2f520817":"jDMyH","685dda4962dc82e1":"4ZJa8","d6dea87c85b53e02":"j3VlY","b9a1398c1c94250d":"bYFI3","e1fbbdf633f9e5ae":"4VZRB","8ac41f1b252a0973":"9jZyE","156a522b3b8fd124":"isBz6","f2620442a53b80d6":"dZOpv","1b94d4eb34edeca3":"eLz4E","47020b485e994171":"hUKvz","9818583261d8a102":"gIISe","1a7d4440a348b466":"bMGwV","50dce9ec585a5332":"NQu1U","cdc90b6df52760f":"8hgjY","2fdd28e51cf3c8b2":"aFCju","72fb68fdc0d9bca3":"hhgyL","964e71bf85841794":"3rkgH","38468de993ee0549":"Bvqxz","ec1866b328e982ea":"9Ctlo","5c05196fbf6d6b4d":"j5enF","9a6937c0aa7a418e":"evui7","23c6d2169b7feabe":"fx4gV","7ec00ac1947d54ca":"4smkA","fda4089c257f1876":"dHYGl","b5061c3c95f48e73":"aYTa1","f57afb99b9b06613":"cFQrm","496ef8c8ed2b34d6":"aw7Lm","6663b9b2b265a941":"jU9RR","c3348d940b830a7f":"bboqU","53a4aaeeb87e1c51":"8uE9w","45f66dd8a17e85aa":"2M8Px","a3a5398768dc185f":"j2pWU","201a807b2e6adc5e":"iDRva","a89a534c753bb4c3":"hoQhg","11a993db5effee60":"8oP9q","96de361de41dc920":"kFYAC","acb830835f9d8af1":"aIW5W","80c2a8fbe4339722":"46CGV"}],"6jeze":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var ReactIs = require("96e34ae03f5a2631");
// By explicitly using `prop-types` you are opting into new development behavior.
// http://fb.me/prop-types-in-prod
var throwOnDirectAccess = true;
module.exports = require("cb216452e2171041")(ReactIs.isElement, throwOnDirectAccess);

},{"96e34ae03f5a2631":"MjK33","cb216452e2171041":"6ub7L"}],"6ub7L":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var ReactIs = require("c437388b089702c3");
var assign = require("c067a60101d8520c");
var ReactPropTypesSecret = require("74a0f89a70b9f3c2");
var has = require("18441b11647bc78");
var checkPropTypes = require("bec3f6ff89f0b072");
var printWarning = function printWarning() {};
printWarning = function printWarning(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') console.error(message);
    try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
    } catch (x) {}
};
function emptyFunctionThatReturnsNull() {
    return null;
}
module.exports = function(isValidElement, throwOnDirectAccess) {
    /* global Symbol */ var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
    /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */ function getIteratorFn(maybeIterable) {
        var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
        if (typeof iteratorFn === 'function') return iteratorFn;
    }
    /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */ var ANONYMOUS = '<<anonymous>>';
    // Important!
    // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
    var ReactPropTypes = {
        array: createPrimitiveTypeChecker('array'),
        bigint: createPrimitiveTypeChecker('bigint'),
        bool: createPrimitiveTypeChecker('boolean'),
        func: createPrimitiveTypeChecker('function'),
        number: createPrimitiveTypeChecker('number'),
        object: createPrimitiveTypeChecker('object'),
        string: createPrimitiveTypeChecker('string'),
        symbol: createPrimitiveTypeChecker('symbol'),
        any: createAnyTypeChecker(),
        arrayOf: createArrayOfTypeChecker,
        element: createElementTypeChecker(),
        elementType: createElementTypeTypeChecker(),
        instanceOf: createInstanceTypeChecker,
        node: createNodeChecker(),
        objectOf: createObjectOfTypeChecker,
        oneOf: createEnumTypeChecker,
        oneOfType: createUnionTypeChecker,
        shape: createShapeTypeChecker,
        exact: createStrictShapeTypeChecker
    };
    /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */ /*eslint-disable no-self-compare*/ function is(x, y) {
        // SameValue algorithm
        if (x === y) // Steps 1-5, 7-10
        // Steps 6.b-6.e: +0 != -0
        return x !== 0 || 1 / x === 1 / y;
        else // Step 6.a: NaN == NaN
        return x !== x && y !== y;
    }
    /*eslint-enable no-self-compare*/ /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */ function PropTypeError(message, data) {
        this.message = message;
        this.data = data && typeof data === 'object' ? data : {};
        this.stack = '';
    }
    // Make `instanceof Error` still work for returned errors.
    PropTypeError.prototype = Error.prototype;
    function createChainableTypeChecker(validate) {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
        function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
            componentName = componentName || ANONYMOUS;
            propFullName = propFullName || propName;
            if (secret !== ReactPropTypesSecret) {
                if (throwOnDirectAccess) {
                    // New behavior only for users of `prop-types` package
                    var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
                    err.name = 'Invariant Violation';
                    throw err;
                } else if (typeof console !== 'undefined') {
                    // Old behavior for people using React.PropTypes
                    var cacheKey = componentName + ':' + propName;
                    if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
                    manualPropTypeWarningCount < 3) {
                        printWarning("You are manually calling a React.PropTypes validation function for the `" + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
                        manualPropTypeCallCache[cacheKey] = true;
                        manualPropTypeWarningCount++;
                    }
                }
            }
            if (props[propName] == null) {
                if (isRequired) {
                    if (props[propName] === null) return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
                    return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
                }
                return null;
            } else return validate(props, propName, componentName, location, propFullName);
        }
        var chainedCheckType = checkType.bind(null, false);
        chainedCheckType.isRequired = checkType.bind(null, true);
        return chainedCheckType;
    }
    function createPrimitiveTypeChecker(expectedType) {
        function validate(props, propName, componentName, location, propFullName, secret) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== expectedType) {
                // `propValue` being instance of, say, date/regexp, pass the 'object'
                // check, but we can offer a more precise error message here rather than
                // 'of type `object`'.
                var preciseType = getPreciseType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'), {
                    expectedType: expectedType
                });
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createAnyTypeChecker() {
        return createChainableTypeChecker(emptyFunctionThatReturnsNull);
    }
    function createArrayOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
            if (typeof typeChecker !== 'function') return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
            var propValue = props[propName];
            if (!Array.isArray(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
            }
            for(var i = 0; i < propValue.length; i++){
                var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
                if (error instanceof Error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createElementTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            if (!isValidElement(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createElementTypeTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            if (!ReactIs.isValidElementType(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createInstanceTypeChecker(expectedClass) {
        function validate(props, propName, componentName, location, propFullName) {
            if (!(props[propName] instanceof expectedClass)) {
                var expectedClassName = expectedClass.name || ANONYMOUS;
                var actualClassName = getClassName(props[propName]);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createEnumTypeChecker(expectedValues) {
        if (!Array.isArray(expectedValues)) {
            {
                if (arguments.length > 1) printWarning('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
                else printWarning('Invalid argument supplied to oneOf, expected an array.');
            }
            return emptyFunctionThatReturnsNull;
        }
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            for(var i = 0; i < expectedValues.length; i++){
                if (is(propValue, expectedValues[i])) return null;
            }
            var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
                var type = getPreciseType(value);
                if (type === 'symbol') return String(value);
                return value;
            });
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
        }
        return createChainableTypeChecker(validate);
    }
    function createObjectOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
            if (typeof typeChecker !== 'function') return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== 'object') return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
            for(var key in propValue)if (has(propValue, key)) {
                var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
                if (error instanceof Error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createUnionTypeChecker(arrayOfTypeCheckers) {
        if (!Array.isArray(arrayOfTypeCheckers)) {
            printWarning('Invalid argument supplied to oneOfType, expected an instance of array.');
            return emptyFunctionThatReturnsNull;
        }
        for(var i = 0; i < arrayOfTypeCheckers.length; i++){
            var checker = arrayOfTypeCheckers[i];
            if (typeof checker !== 'function') {
                printWarning("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
                return emptyFunctionThatReturnsNull;
            }
        }
        function validate(props, propName, componentName, location, propFullName) {
            var expectedTypes = [];
            for(var i = 0; i < arrayOfTypeCheckers.length; i++){
                var checker = arrayOfTypeCheckers[i];
                var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
                if (checkerResult == null) return null;
                if (checkerResult.data && has(checkerResult.data, 'expectedType')) expectedTypes.push(checkerResult.data.expectedType);
            }
            var expectedTypesMessage = expectedTypes.length > 0 ? ', expected one of type [' + expectedTypes.join(', ') + ']' : '';
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
        }
        return createChainableTypeChecker(validate);
    }
    function createNodeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            if (!isNode(props[propName])) return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function invalidValidatorError(componentName, location, propFullName, key, type) {
        return new PropTypeError((componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + type + '`.');
    }
    function createShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== 'object') return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
            for(var key in shapeTypes){
                var checker = shapeTypes[key];
                if (typeof checker !== 'function') return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
                var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
                if (error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createStrictShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== 'object') return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
            // We need to check all keys in case some are required but missing from props.
            var allKeys = assign({}, props[propName], shapeTypes);
            for(var key in allKeys){
                var checker = shapeTypes[key];
                if (has(shapeTypes, key) && typeof checker !== 'function') return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
                if (!checker) return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
                var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
                if (error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function isNode(propValue) {
        switch(typeof propValue){
            case 'number':
            case 'string':
            case 'undefined':
                return true;
            case 'boolean':
                return !propValue;
            case 'object':
                if (Array.isArray(propValue)) return propValue.every(isNode);
                if (propValue === null || isValidElement(propValue)) return true;
                var iteratorFn = getIteratorFn(propValue);
                if (iteratorFn) {
                    var iterator = iteratorFn.call(propValue);
                    var step;
                    if (iteratorFn !== propValue.entries) while(!(step = iterator.next()).done){
                        if (!isNode(step.value)) return false;
                    }
                    else // Iterator will provide entry [k,v] tuples rather than values.
                    while(!(step = iterator.next()).done){
                        var entry = step.value;
                        if (entry) {
                            if (!isNode(entry[1])) return false;
                        }
                    }
                } else return false;
                return true;
            default:
                return false;
        }
    }
    function isSymbol(propType, propValue) {
        // Native Symbol.
        if (propType === 'symbol') return true;
        // falsy value can't be a Symbol
        if (!propValue) return false;
        // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
        if (propValue['@@toStringTag'] === 'Symbol') return true;
        // Fallback for non-spec compliant Symbols which are polyfilled.
        if (typeof Symbol === 'function' && propValue instanceof Symbol) return true;
        return false;
    }
    // Equivalent of `typeof` but with special handling for array and regexp.
    function getPropType(propValue) {
        var propType = typeof propValue;
        if (Array.isArray(propValue)) return 'array';
        if (propValue instanceof RegExp) // Old webkits (at least until Android 4.0) return 'function' rather than
        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
        // passes PropTypes.object.
        return 'object';
        if (isSymbol(propType, propValue)) return 'symbol';
        return propType;
    }
    // This handles more types than `getPropType`. Only used for error messages.
    // See `createPrimitiveTypeChecker`.
    function getPreciseType(propValue) {
        if (typeof propValue === 'undefined' || propValue === null) return '' + propValue;
        var propType = getPropType(propValue);
        if (propType === 'object') {
            if (propValue instanceof Date) return 'date';
            else if (propValue instanceof RegExp) return 'regexp';
        }
        return propType;
    }
    // Returns a string that is postfixed to a warning about an invalid type.
    // For example, "undefined" or "of type array"
    function getPostfixForTypeWarning(value) {
        var type = getPreciseType(value);
        switch(type){
            case 'array':
            case 'object':
                return 'an ' + type;
            case 'boolean':
            case 'date':
            case 'regexp':
                return 'a ' + type;
            default:
                return type;
        }
    }
    // Returns class name of the object, if any.
    function getClassName(propValue) {
        if (!propValue.constructor || !propValue.constructor.name) return ANONYMOUS;
        return propValue.constructor.name;
    }
    ReactPropTypes.checkPropTypes = checkPropTypes;
    ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

},{"c437388b089702c3":"MjK33","c067a60101d8520c":"cTTVQ","74a0f89a70b9f3c2":"7Fzv5","18441b11647bc78":"cn2QW","bec3f6ff89f0b072":"aebCl"}],"cTTVQ":[function(require,module,exports,__globalThis) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
function toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if (hasOwnProperty.call(from, key)) to[key] = from[key];
        if (getOwnPropertySymbols) {
            symbols = getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if (propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

},{}],"7Fzv5":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = ReactPropTypesSecret;

},{}],"cn2QW":[function(require,module,exports,__globalThis) {
module.exports = Function.call.bind(Object.prototype.hasOwnProperty);

},{}],"aebCl":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var printWarning = function printWarning() {};
var ReactPropTypesSecret = require("24ba1e58d167a82c");
var loggedTypeFailures = {};
var has = require("898bc82f39d83f7c");
printWarning = function printWarning(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') console.error(message);
    try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
    } catch (x) {}
};
/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */ function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
    for(var typeSpecName in typeSpecs)if (has(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
            // This is intentionally an invariant that gets caught. It's the same
            // behavior as without this statement except with a better message.
            if (typeof typeSpecs[typeSpecName] !== 'function') {
                var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
                err.name = 'Invariant Violation';
                throw err;
            }
            error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
            error = ex;
        }
        if (error && !(error instanceof Error)) printWarning((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
            // Only monitor this failure once because there tends to be a lot of the
            // same error.
            loggedTypeFailures[error.message] = true;
            var stack = getStack ? getStack() : '';
            printWarning('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
        }
    }
}
/**
 * Resets warning cache when testing.
 *
 * @private
 */ checkPropTypes.resetWarningCache = function() {
    loggedTypeFailures = {};
};
module.exports = checkPropTypes;

},{"24ba1e58d167a82c":"7Fzv5","898bc82f39d83f7c":"cn2QW"}],"fHgOy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return addMinutes;
});
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../addMilliseconds/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var MILLISECONDS_IN_MINUTE = 60000;
function addMinutes(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    return (0, _indexJsDefault1.default)(dirtyDate, amount * MILLISECONDS_IN_MINUTE);
}

},{"../_lib/toInteger/index.js":"l2SJM","../addMilliseconds/index.js":"5O0Rn","../_lib/requiredArgs/index.js":"a3mwq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"yE0Wz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return addHours;
});
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../addMilliseconds/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var MILLISECONDS_IN_HOUR = 3600000;
function addHours(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    return (0, _indexJsDefault1.default)(dirtyDate, amount * MILLISECONDS_IN_HOUR);
}

},{"../_lib/toInteger/index.js":"l2SJM","../addMilliseconds/index.js":"5O0Rn","../_lib/requiredArgs/index.js":"a3mwq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6e3pH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return addDays;
});
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function addDays(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}

},{"../_lib/toInteger/index.js":"l2SJM","../toDate/index.js":"j2pWU","../_lib/requiredArgs/index.js":"a3mwq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"18VNy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return addWeeks;
});
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../addDays/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function addWeeks(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    var days = amount * 7;
    return (0, _indexJsDefault1.default)(dirtyDate, days);
}

},{"../_lib/toInteger/index.js":"l2SJM","../addDays/index.js":"6e3pH","../_lib/requiredArgs/index.js":"a3mwq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"b6CDb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return addMonths;
});
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function addMonths(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
    var dayOfMonth = date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return date;
    }
}

},{"../_lib/toInteger/index.js":"l2SJM","../toDate/index.js":"j2pWU","../_lib/requiredArgs/index.js":"a3mwq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5SOib":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return addQuarters;
});
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../addMonths/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function addQuarters(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    var months = amount * 3;
    return (0, _indexJsDefault1.default)(dirtyDate, months);
}

},{"../_lib/toInteger/index.js":"l2SJM","../addMonths/index.js":"b6CDb","../_lib/requiredArgs/index.js":"a3mwq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"h6bgS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return addYears;
});
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../addMonths/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function addYears(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    return (0, _indexJsDefault1.default)(dirtyDate, amount * 12);
}

},{"../_lib/toInteger/index.js":"l2SJM","../addMonths/index.js":"b6CDb","../_lib/requiredArgs/index.js":"a3mwq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gJbai":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return subDays;
});
var _indexJs = require("../addDays/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function subDays(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault1.default)(2, arguments);
    var amount = (0, _indexJsDefault2.default)(dirtyAmount);
    return (0, _indexJsDefault.default)(dirtyDate, -amount);
}

},{"../addDays/index.js":"6e3pH","../_lib/requiredArgs/index.js":"a3mwq","../_lib/toInteger/index.js":"l2SJM","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"agARD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return subWeeks;
});
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../addWeeks/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function subWeeks(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    return (0, _indexJsDefault1.default)(dirtyDate, -amount);
}

},{"../_lib/toInteger/index.js":"l2SJM","../addWeeks/index.js":"18VNy","../_lib/requiredArgs/index.js":"a3mwq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"fRDfS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return subMonths;
});
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../addMonths/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function subMonths(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    return (0, _indexJsDefault1.default)(dirtyDate, -amount);
}

},{"../_lib/toInteger/index.js":"l2SJM","../addMonths/index.js":"b6CDb","../_lib/requiredArgs/index.js":"a3mwq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7vZQY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return subQuarters;
});
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../addQuarters/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function subQuarters(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    return (0, _indexJsDefault1.default)(dirtyDate, -amount);
}

},{"../_lib/toInteger/index.js":"l2SJM","../addQuarters/index.js":"5SOib","../_lib/requiredArgs/index.js":"a3mwq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1rE32":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return subYears;
});
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../addYears/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function subYears(dirtyDate, dirtyAmount) {
    (0, _indexJsDefault2.default)(2, arguments);
    var amount = (0, _indexJsDefault.default)(dirtyAmount);
    return (0, _indexJsDefault1.default)(dirtyDate, -amount);
}

},{"../_lib/toInteger/index.js":"l2SJM","../addYears/index.js":"h6bgS","../_lib/requiredArgs/index.js":"a3mwq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"35XPm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getSeconds;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getSeconds(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var seconds = date.getSeconds();
    return seconds;
}

},{"../toDate/index.js":"j2pWU","../_lib/requiredArgs/index.js":"a3mwq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3RGKD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getMinutes;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getMinutes(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var minutes = date.getMinutes();
    return minutes;
}

},{"../toDate/index.js":"j2pWU","../_lib/requiredArgs/index.js":"a3mwq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"65WjS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getHours;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getHours(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var hours = date.getHours();
    return hours;
}

},{"../toDate/index.js":"j2pWU","../_lib/requiredArgs/index.js":"a3mwq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"klmhq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getDay;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getDay(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var day = date.getDay();
    return day;
}

},{"../toDate/index.js":"j2pWU","../_lib/requiredArgs/index.js":"a3mwq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"l7Zuc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getDate;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getDate(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var dayOfMonth = date.getDate();
    return dayOfMonth;
}

},{"../toDate/index.js":"j2pWU","../_lib/requiredArgs/index.js":"a3mwq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"bmNCw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getISOWeek;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfISOWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../startOfISOWeekYear/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var MILLISECONDS_IN_WEEK = 604800000;
function getISOWeek(dirtyDate) {
    (0, _indexJsDefault3.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var diff = (0, _indexJsDefault1.default)(date).getTime() - (0, _indexJsDefault2.default)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

},{"../toDate/index.js":"j2pWU","../startOfISOWeek/index.js":"59Vgn","../startOfISOWeekYear/index.js":"wSWYq","../_lib/requiredArgs/index.js":"a3mwq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"59Vgn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return startOfISOWeek;
});
var _indexJs = require("../startOfWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function startOfISOWeek(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    return (0, _indexJsDefault.default)(dirtyDate, {
        weekStartsOn: 1
    });
}

},{"../startOfWeek/index.js":"hhgyL","../_lib/requiredArgs/index.js":"a3mwq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"hhgyL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return startOfWeek;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/toInteger/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/defaultOptions/index.js");
function startOfWeek(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault2.default)(1, arguments);
    var defaultOptions = (0, _indexJs3.getDefaultOptions)();
    var weekStartsOn = (0, _indexJsDefault1.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setDate(date.getDate() - diff);
    date.setHours(0, 0, 0, 0);
    return date;
}

},{"../toDate/index.js":"j2pWU","../_lib/toInteger/index.js":"l2SJM","../_lib/requiredArgs/index.js":"a3mwq","../_lib/defaultOptions/index.js":"f8LK0","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"wSWYq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return startOfISOWeekYear;
});
var _indexJs = require("../getISOWeekYear/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfISOWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function startOfISOWeekYear(dirtyDate) {
    (0, _indexJsDefault2.default)(1, arguments);
    var year = (0, _indexJsDefault.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    var date = (0, _indexJsDefault1.default)(fourthOfJanuary);
    return date;
}

},{"../getISOWeekYear/index.js":"5VD6R","../startOfISOWeek/index.js":"59Vgn","../_lib/requiredArgs/index.js":"a3mwq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5VD6R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getISOWeekYear;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfISOWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function getISOWeekYear(dirtyDate) {
    (0, _indexJsDefault2.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var year = date.getFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    var startOfNextYear = (0, _indexJsDefault1.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    var startOfThisYear = (0, _indexJsDefault1.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

},{"../toDate/index.js":"j2pWU","../startOfISOWeek/index.js":"59Vgn","../_lib/requiredArgs/index.js":"a3mwq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"cnODP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getMonth;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getMonth(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var month = date.getMonth();
    return month;
}

},{"../toDate/index.js":"j2pWU","../_lib/requiredArgs/index.js":"a3mwq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jDMyH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getQuarter;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getQuarter(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var quarter = Math.floor(date.getMonth() / 3) + 1;
    return quarter;
}

},{"../toDate/index.js":"j2pWU","../_lib/requiredArgs/index.js":"a3mwq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4ZJa8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getYear;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getYear(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    return (0, _indexJsDefault.default)(dirtyDate).getFullYear();
}

},{"../toDate/index.js":"j2pWU","../_lib/requiredArgs/index.js":"a3mwq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"j3VlY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getTime;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getTime(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var timestamp = date.getTime();
    return timestamp;
}

},{"../toDate/index.js":"j2pWU","../_lib/requiredArgs/index.js":"a3mwq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"bYFI3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return setSeconds;
});
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function setSeconds(dirtyDate, dirtySeconds) {
    (0, _indexJsDefault2.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var seconds = (0, _indexJsDefault.default)(dirtySeconds);
    date.setSeconds(seconds);
    return date;
}

},{"../_lib/toInteger/index.js":"l2SJM","../toDate/index.js":"j2pWU","../_lib/requiredArgs/index.js":"a3mwq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4VZRB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return setMinutes;
});
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function setMinutes(dirtyDate, dirtyMinutes) {
    (0, _indexJsDefault2.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var minutes = (0, _indexJsDefault.default)(dirtyMinutes);
    date.setMinutes(minutes);
    return date;
}

},{"../_lib/toInteger/index.js":"l2SJM","../toDate/index.js":"j2pWU","../_lib/requiredArgs/index.js":"a3mwq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"9jZyE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return setHours;
});
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function setHours(dirtyDate, dirtyHours) {
    (0, _indexJsDefault2.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var hours = (0, _indexJsDefault.default)(dirtyHours);
    date.setHours(hours);
    return date;
}

},{"../_lib/toInteger/index.js":"l2SJM","../toDate/index.js":"j2pWU","../_lib/requiredArgs/index.js":"a3mwq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"isBz6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return setMonth;
});
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../getDaysInMonth/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
function setMonth(dirtyDate, dirtyMonth) {
    (0, _indexJsDefault3.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var month = (0, _indexJsDefault.default)(dirtyMonth);
    var year = date.getFullYear();
    var day = date.getDate();
    var dateWithDesiredMonth = new Date(0);
    dateWithDesiredMonth.setFullYear(year, month, 15);
    dateWithDesiredMonth.setHours(0, 0, 0, 0);
    var daysInMonth = (0, _indexJsDefault2.default)(dateWithDesiredMonth);
    // Set the last day of the new month
    // if the original date was the last day of the longer month
    date.setMonth(month, Math.min(day, daysInMonth));
    return date;
}

},{"../_lib/toInteger/index.js":"l2SJM","../toDate/index.js":"j2pWU","../getDaysInMonth/index.js":"bV0Bp","../_lib/requiredArgs/index.js":"a3mwq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"bV0Bp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getDaysInMonth;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function getDaysInMonth(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var year = date.getFullYear();
    var monthIndex = date.getMonth();
    var lastDayOfMonth = new Date(0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}

},{"../toDate/index.js":"j2pWU","../_lib/requiredArgs/index.js":"a3mwq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"dZOpv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return setQuarter;
});
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../setMonth/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
function setQuarter(dirtyDate, dirtyQuarter) {
    (0, _indexJsDefault3.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var quarter = (0, _indexJsDefault.default)(dirtyQuarter);
    var oldQuarter = Math.floor(date.getMonth() / 3) + 1;
    var diff = quarter - oldQuarter;
    return (0, _indexJsDefault2.default)(date, date.getMonth() + diff * 3);
}

},{"../_lib/toInteger/index.js":"l2SJM","../toDate/index.js":"j2pWU","../setMonth/index.js":"isBz6","../_lib/requiredArgs/index.js":"a3mwq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"eLz4E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return setYear;
});
var _indexJs = require("../_lib/toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function setYear(dirtyDate, dirtyYear) {
    (0, _indexJsDefault2.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var year = (0, _indexJsDefault.default)(dirtyYear);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(date.getTime())) return new Date(NaN);
    date.setFullYear(year);
    return date;
}

},{"../_lib/toInteger/index.js":"l2SJM","../toDate/index.js":"j2pWU","../_lib/requiredArgs/index.js":"a3mwq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"hUKvz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return min;
});
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function min(dirtyDatesArray) {
    (0, _indexJsDefault1.default)(1, arguments);
    var datesArray;
    // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
    if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') datesArray = dirtyDatesArray;
    else if ((0, _typeofDefault.default)(dirtyDatesArray) === 'object' && dirtyDatesArray !== null) datesArray = Array.prototype.slice.call(dirtyDatesArray);
    else // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
    var result;
    datesArray.forEach(function(dirtyDate) {
        var currentDate = (0, _indexJsDefault.default)(dirtyDate);
        if (result === undefined || result > currentDate || isNaN(currentDate.getDate())) result = currentDate;
    });
    return result || new Date(NaN);
}

},{"@babel/runtime/helpers/esm/typeof":"iu2gT","../toDate/index.js":"j2pWU","../_lib/requiredArgs/index.js":"a3mwq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gIISe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return max;
});
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function max(dirtyDatesArray) {
    (0, _indexJsDefault1.default)(1, arguments);
    var datesArray;
    // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
    if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') datesArray = dirtyDatesArray;
    else if ((0, _typeofDefault.default)(dirtyDatesArray) === 'object' && dirtyDatesArray !== null) datesArray = Array.prototype.slice.call(dirtyDatesArray);
    else // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
    var result;
    datesArray.forEach(function(dirtyDate) {
        var currentDate = (0, _indexJsDefault.default)(dirtyDate);
        if (result === undefined || result < currentDate || isNaN(Number(currentDate))) result = currentDate;
    });
    return result || new Date(NaN);
}

},{"@babel/runtime/helpers/esm/typeof":"iu2gT","../toDate/index.js":"j2pWU","../_lib/requiredArgs/index.js":"a3mwq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"bMGwV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return differenceInCalendarDays;
});
var _indexJs = require("../_lib/getTimezoneOffsetInMilliseconds/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../startOfDay/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var MILLISECONDS_IN_DAY = 86400000;
function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault2.default)(2, arguments);
    var startOfDayLeft = (0, _indexJsDefault1.default)(dirtyDateLeft);
    var startOfDayRight = (0, _indexJsDefault1.default)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, _indexJsDefault.default)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, _indexJsDefault.default)(startOfDayRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
}

},{"../_lib/getTimezoneOffsetInMilliseconds/index.js":"i5oJ5","../startOfDay/index.js":"aFCju","../_lib/requiredArgs/index.js":"a3mwq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"aFCju":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return startOfDay;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function startOfDay(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}

},{"../toDate/index.js":"j2pWU","../_lib/requiredArgs/index.js":"a3mwq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"NQu1U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return differenceInCalendarMonths;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateLeft = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRight = (0, _indexJsDefault.default)(dirtyDateRight);
    var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
    var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}

},{"../toDate/index.js":"j2pWU","../_lib/requiredArgs/index.js":"a3mwq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8hgjY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return differenceInCalendarYears;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function differenceInCalendarYears(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateLeft = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRight = (0, _indexJsDefault.default)(dirtyDateRight);
    return dateLeft.getFullYear() - dateRight.getFullYear();
}

},{"../toDate/index.js":"j2pWU","../_lib/requiredArgs/index.js":"a3mwq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3rkgH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return startOfMonth;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function startOfMonth(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
    return date;
}

},{"../toDate/index.js":"j2pWU","../_lib/requiredArgs/index.js":"a3mwq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"Bvqxz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return startOfQuarter;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function startOfQuarter(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var currentMonth = date.getMonth();
    var month = currentMonth - currentMonth % 3;
    date.setMonth(month, 1);
    date.setHours(0, 0, 0, 0);
    return date;
}

},{"../toDate/index.js":"j2pWU","../_lib/requiredArgs/index.js":"a3mwq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"9Ctlo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return startOfYear;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function startOfYear(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var cleanDate = (0, _indexJsDefault.default)(dirtyDate);
    var date = new Date(0);
    date.setFullYear(cleanDate.getFullYear(), 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
}

},{"../toDate/index.js":"j2pWU","../_lib/requiredArgs/index.js":"a3mwq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"j5enF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return endOfDay;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function endOfDay(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    date.setHours(23, 59, 59, 999);
    return date;
}

},{"../toDate/index.js":"j2pWU","../_lib/requiredArgs/index.js":"a3mwq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"evui7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return endOfWeek;
});
var _indexJs = require("../_lib/defaultOptions/index.js");
var _indexJs1 = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/toInteger/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs3);
function endOfWeek(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault2.default)(1, arguments);
    var defaultOptions = (0, _indexJs.getDefaultOptions)();
    var weekStartsOn = (0, _indexJsDefault1.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    date.setDate(date.getDate() + diff);
    date.setHours(23, 59, 59, 999);
    return date;
}

},{"../_lib/defaultOptions/index.js":"f8LK0","../toDate/index.js":"j2pWU","../_lib/toInteger/index.js":"l2SJM","../_lib/requiredArgs/index.js":"a3mwq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"fx4gV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return endOfMonth;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function endOfMonth(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}

},{"../toDate/index.js":"j2pWU","../_lib/requiredArgs/index.js":"a3mwq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4smkA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return endOfYear;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function endOfYear(dirtyDate) {
    (0, _indexJsDefault1.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var year = date.getFullYear();
    date.setFullYear(year + 1, 0, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}

},{"../toDate/index.js":"j2pWU","../_lib/requiredArgs/index.js":"a3mwq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"dHYGl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isEqual;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isEqual(dirtyLeftDate, dirtyRightDate) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateLeft = (0, _indexJsDefault.default)(dirtyLeftDate);
    var dateRight = (0, _indexJsDefault.default)(dirtyRightDate);
    return dateLeft.getTime() === dateRight.getTime();
}

},{"../toDate/index.js":"j2pWU","../_lib/requiredArgs/index.js":"a3mwq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"aYTa1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isSameDay;
});
var _indexJs = require("../startOfDay/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isSameDay(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateLeftStartOfDay = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRightStartOfDay = (0, _indexJsDefault.default)(dirtyDateRight);
    return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

},{"../startOfDay/index.js":"aFCju","../_lib/requiredArgs/index.js":"a3mwq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"cFQrm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isSameMonth;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isSameMonth(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateLeft = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRight = (0, _indexJsDefault.default)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}

},{"../toDate/index.js":"j2pWU","../_lib/requiredArgs/index.js":"a3mwq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"aw7Lm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isSameYear;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isSameYear(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateLeft = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRight = (0, _indexJsDefault.default)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear();
}

},{"../toDate/index.js":"j2pWU","../_lib/requiredArgs/index.js":"a3mwq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jU9RR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isSameQuarter;
});
var _indexJs = require("../startOfQuarter/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isSameQuarter(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateLeftStartOfQuarter = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRightStartOfQuarter = (0, _indexJsDefault.default)(dirtyDateRight);
    return dateLeftStartOfQuarter.getTime() === dateRightStartOfQuarter.getTime();
}

},{"../startOfQuarter/index.js":"Bvqxz","../_lib/requiredArgs/index.js":"a3mwq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"bboqU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isAfter;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isAfter(dirtyDate, dirtyDateToCompare) {
    (0, _indexJsDefault1.default)(2, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var dateToCompare = (0, _indexJsDefault.default)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}

},{"../toDate/index.js":"j2pWU","../_lib/requiredArgs/index.js":"a3mwq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8uE9w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isBefore;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isBefore(dirtyDate, dirtyDateToCompare) {
    (0, _indexJsDefault1.default)(2, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var dateToCompare = (0, _indexJsDefault.default)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}

},{"../toDate/index.js":"j2pWU","../_lib/requiredArgs/index.js":"a3mwq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2M8Px":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isWithinInterval;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function isWithinInterval(dirtyDate, interval) {
    (0, _indexJsDefault1.default)(2, arguments);
    var time = (0, _indexJsDefault.default)(dirtyDate).getTime();
    var startTime = (0, _indexJsDefault.default)(interval.start).getTime();
    var endTime = (0, _indexJsDefault.default)(interval.end).getTime();
    // Throw an exception if start date is after end date or if any date is `Invalid Date`
    if (!(startTime <= endTime)) throw new RangeError('Invalid interval');
    return time >= startTime && time <= endTime;
}

},{"../toDate/index.js":"j2pWU","../_lib/requiredArgs/index.js":"a3mwq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"iDRva":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return parse;
});
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _createForOfIteratorHelper = require("@babel/runtime/helpers/esm/createForOfIteratorHelper");
var _createForOfIteratorHelperDefault = parcelHelpers.interopDefault(_createForOfIteratorHelper);
var _indexJs = require("../_lib/defaultLocale/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../subMilliseconds/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../toDate/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/assign/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../_lib/format/longFormatters/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
var _indexJs5 = require("../_lib/getTimezoneOffsetInMilliseconds/index.js");
var _indexJsDefault5 = parcelHelpers.interopDefault(_indexJs5);
var _indexJs6 = require("../_lib/protectedTokens/index.js");
var _indexJs7 = require("../_lib/toInteger/index.js");
var _indexJsDefault6 = parcelHelpers.interopDefault(_indexJs7);
var _indexJs8 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault7 = parcelHelpers.interopDefault(_indexJs8);
var _setterJs = require("./_lib/Setter.js");
var _indexJs9 = require("./_lib/parsers/index.js");
var _indexJs10 = require("../_lib/defaultOptions/index.js"); // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var notWhitespaceRegExp = /\S/;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function parse(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, _indexJsDefault7.default)(3, arguments);
    var dateString = String(dirtyDateString);
    var formatString = String(dirtyFormatString);
    var defaultOptions = (0, _indexJs10.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, _indexJsDefault.default);
    if (!locale.match) throw new RangeError('locale must contain match property');
    var firstWeekContainsDate = (0, _indexJsDefault6.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, _indexJsDefault6.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (formatString === '') {
        if (dateString === '') return (0, _indexJsDefault2.default)(dirtyReferenceDate);
        else return new Date(NaN);
    }
    var subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will be set to the system timezone
    var setters = [
        new (0, _setterJs.DateToSystemTimezoneSetter)()
    ];
    var tokens = formatString.match(longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter in (0, _indexJsDefault4.default)) {
            var longFormatter = (0, _indexJsDefault4.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match(formattingTokensRegExp);
    var usedTokens = [];
    var _iterator = (0, _createForOfIteratorHelperDefault.default)(tokens), _step;
    try {
        var _loop = function _loop() {
            var token = _step.value;
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, _indexJs6.isProtectedWeekYearToken)(token)) (0, _indexJs6.throwProtectedError)(token, formatString, dirtyDateString);
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, _indexJs6.isProtectedDayOfYearToken)(token)) (0, _indexJs6.throwProtectedError)(token, formatString, dirtyDateString);
            var firstCharacter = token[0];
            var parser = (0, _indexJs9.parsers)[firstCharacter];
            if (parser) {
                var incompatibleTokens = parser.incompatibleTokens;
                if (Array.isArray(incompatibleTokens)) {
                    var incompatibleToken = usedTokens.find(function(usedToken) {
                        return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
                    });
                    if (incompatibleToken) throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
                } else if (parser.incompatibleTokens === '*' && usedTokens.length > 0) throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
                usedTokens.push({
                    token: firstCharacter,
                    fullToken: token
                });
                var parseResult = parser.run(dateString, token, locale.match, subFnOptions);
                if (!parseResult) return {
                    v: new Date(NaN)
                };
                setters.push(parseResult.setter);
                dateString = parseResult.rest;
            } else {
                if (firstCharacter.match(unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
                // Replace two single quote characters with one single quote character
                if (token === "''") token = "'";
                else if (firstCharacter === "'") token = cleanEscapedString(token);
                // Cut token from string, or, if string doesn't match the token, return Invalid Date
                if (dateString.indexOf(token) === 0) dateString = dateString.slice(token.length);
                else return {
                    v: new Date(NaN)
                };
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _ret = _loop();
            if ((0, _typeofDefault.default)(_ret) === "object") return _ret.v;
        }
    // Check if the remaining input contains something other than whitespace
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) return new Date(NaN);
    var uniquePrioritySetters = setters.map(function(setter) {
        return setter.priority;
    }).sort(function(a, b) {
        return b - a;
    }).filter(function(priority, index, array) {
        return array.indexOf(priority) === index;
    }).map(function(priority) {
        return setters.filter(function(setter) {
            return setter.priority === priority;
        }).sort(function(a, b) {
            return b.subPriority - a.subPriority;
        });
    }).map(function(setterArray) {
        return setterArray[0];
    });
    var date = (0, _indexJsDefault2.default)(dirtyReferenceDate);
    if (isNaN(date.getTime())) return new Date(NaN);
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    var utcDate = (0, _indexJsDefault1.default)(date, (0, _indexJsDefault5.default)(date));
    var flags = {};
    var _iterator2 = (0, _createForOfIteratorHelperDefault.default)(uniquePrioritySetters), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var setter = _step2.value;
            if (!setter.validate(utcDate, subFnOptions)) return new Date(NaN);
            var result = setter.set(utcDate, flags, subFnOptions);
            // Result is tuple (date, flags)
            if (Array.isArray(result)) {
                utcDate = result[0];
                (0, _indexJsDefault3.default)(flags, result[1]);
            // Result is date
            } else utcDate = result;
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    return utcDate;
}
function cleanEscapedString(input) {
    return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}

},{"@babel/runtime/helpers/esm/typeof":"iu2gT","@babel/runtime/helpers/esm/createForOfIteratorHelper":"5RJqY","../_lib/defaultLocale/index.js":"1ggW0","../subMilliseconds/index.js":"5b6Uh","../toDate/index.js":"j2pWU","../_lib/assign/index.js":"eINUi","../_lib/format/longFormatters/index.js":"6kxpi","../_lib/getTimezoneOffsetInMilliseconds/index.js":"i5oJ5","../_lib/protectedTokens/index.js":"lJQbo","../_lib/toInteger/index.js":"l2SJM","../_lib/requiredArgs/index.js":"a3mwq","./_lib/Setter.js":"dXl5x","./_lib/parsers/index.js":"hG9AS","../_lib/defaultOptions/index.js":"f8LK0","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5RJqY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _createForOfIteratorHelper;
});
var _unsupportedIterableToArrayJs = require("./unsupportedIterableToArray.js");
var _unsupportedIterableToArrayJsDefault = parcelHelpers.interopDefault(_unsupportedIterableToArrayJs);
function _createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = (0, _unsupportedIterableToArrayJsDefault.default)(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var _$r = t.next();
            return a = _$r.done, _$r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}

},{"./unsupportedIterableToArray.js":"1NpSF","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1NpSF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _unsupportedIterableToArray;
});
var _arrayLikeToArrayJs = require("./arrayLikeToArray.js");
var _arrayLikeToArrayJsDefault = parcelHelpers.interopDefault(_arrayLikeToArrayJs);
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, _arrayLikeToArrayJsDefault.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, _arrayLikeToArrayJsDefault.default)(r, a) : void 0;
    }
}

},{"./arrayLikeToArray.js":"aXjdP","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"aXjdP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _arrayLikeToArray;
});
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"eINUi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return assign;
});
function assign(target, object) {
    if (target == null) throw new TypeError('assign requires that input parameter not be null or undefined');
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"dXl5x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Setter", function() {
    return Setter;
});
parcelHelpers.export(exports, "ValueSetter", function() {
    return ValueSetter;
});
parcelHelpers.export(exports, "DateToSystemTimezoneSetter", function() {
    return DateToSystemTimezoneSetter;
});
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var TIMEZONE_UNIT_PRIORITY = 10;
var Setter = /*#__PURE__*/ function() {
    function Setter() {
        (0, _classCallCheckDefault.default)(this, Setter);
        (0, _definePropertyDefault.default)(this, "priority", void 0);
        (0, _definePropertyDefault.default)(this, "subPriority", 0);
    }
    (0, _createClassDefault.default)(Setter, [
        {
            key: "validate",
            value: function validate(_utcDate, _options) {
                return true;
            }
        }
    ]);
    return Setter;
}();
var ValueSetter = /*#__PURE__*/ function(_Setter) {
    (0, _inheritsDefault.default)(ValueSetter, _Setter);
    var _super = (0, _createSuperDefault.default)(ValueSetter);
    function ValueSetter(value, validateValue, setValue, priority, subPriority) {
        var _this;
        (0, _classCallCheckDefault.default)(this, ValueSetter);
        _this = _super.call(this);
        _this.value = value;
        _this.validateValue = validateValue;
        _this.setValue = setValue;
        _this.priority = priority;
        if (subPriority) _this.subPriority = subPriority;
        return _this;
    }
    (0, _createClassDefault.default)(ValueSetter, [
        {
            key: "validate",
            value: function validate(utcDate, options) {
                return this.validateValue(utcDate, this.value, options);
            }
        },
        {
            key: "set",
            value: function set(utcDate, flags, options) {
                return this.setValue(utcDate, flags, this.value, options);
            }
        }
    ]);
    return ValueSetter;
}(Setter);
var DateToSystemTimezoneSetter = /*#__PURE__*/ function(_Setter2) {
    (0, _inheritsDefault.default)(DateToSystemTimezoneSetter, _Setter2);
    var _super2 = (0, _createSuperDefault.default)(DateToSystemTimezoneSetter);
    function DateToSystemTimezoneSetter() {
        var _this2;
        (0, _classCallCheckDefault.default)(this, DateToSystemTimezoneSetter);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this2), "priority", TIMEZONE_UNIT_PRIORITY);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this2), "subPriority", -1);
        return _this2;
    }
    (0, _createClassDefault.default)(DateToSystemTimezoneSetter, [
        {
            key: "set",
            value: function set(date, flags) {
                if (flags.timestampIsSet) return date;
                var convertedDate = new Date(0);
                convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
                convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
                return convertedDate;
            }
        }
    ]);
    return DateToSystemTimezoneSetter;
}(Setter);

},{"@babel/runtime/helpers/esm/assertThisInitialized":"i1uh5","@babel/runtime/helpers/esm/inherits":"kXaEX","@babel/runtime/helpers/esm/createSuper":"iLuEE","@babel/runtime/helpers/esm/classCallCheck":"8FUFf","@babel/runtime/helpers/esm/createClass":"iJi2M","@babel/runtime/helpers/esm/defineProperty":"hxCfo","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"i1uh5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _assertThisInitialized;
});
function _assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"kXaEX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _inherits;
});
var _setPrototypeOfJs = require("./setPrototypeOf.js");
var _setPrototypeOfJsDefault = parcelHelpers.interopDefault(_setPrototypeOfJs);
function _inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, _setPrototypeOfJsDefault.default)(t, e);
}

},{"./setPrototypeOf.js":"lPZGv","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"lPZGv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _setPrototypeOf;
});
function _setPrototypeOf(t, e) {
    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(t, e) {
        return t.__proto__ = e, t;
    }, _setPrototypeOf(t, e);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"iLuEE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _createSuper;
});
var _getPrototypeOfJs = require("./getPrototypeOf.js");
var _getPrototypeOfJsDefault = parcelHelpers.interopDefault(_getPrototypeOfJs);
var _isNativeReflectConstructJs = require("./isNativeReflectConstruct.js");
var _isNativeReflectConstructJsDefault = parcelHelpers.interopDefault(_isNativeReflectConstructJs);
var _possibleConstructorReturnJs = require("./possibleConstructorReturn.js");
var _possibleConstructorReturnJsDefault = parcelHelpers.interopDefault(_possibleConstructorReturnJs);
function _createSuper(t) {
    var r = (0, _isNativeReflectConstructJsDefault.default)();
    return function() {
        var e, o = (0, _getPrototypeOfJsDefault.default)(t);
        if (r) {
            var s = (0, _getPrototypeOfJsDefault.default)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, _possibleConstructorReturnJsDefault.default)(this, e);
    };
}

},{"./getPrototypeOf.js":"3c54X","./isNativeReflectConstruct.js":"7JEYn","./possibleConstructorReturn.js":"aBM2k","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3c54X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _getPrototypeOf;
});
function _getPrototypeOf(t) {
    return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, _getPrototypeOf(t);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7JEYn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _isNativeReflectConstruct;
});
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"aBM2k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _possibleConstructorReturn;
});
var _typeofJs = require("./typeof.js");
var _typeofJsDefault = parcelHelpers.interopDefault(_typeofJs);
var _assertThisInitializedJs = require("./assertThisInitialized.js");
var _assertThisInitializedJsDefault = parcelHelpers.interopDefault(_assertThisInitializedJs);
function _possibleConstructorReturn(t, e) {
    if (e && ("object" == (0, _typeofJsDefault.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, _assertThisInitializedJsDefault.default)(t);
}

},{"./typeof.js":"iu2gT","./assertThisInitialized.js":"i1uh5","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8FUFf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _classCallCheck;
});
function _classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"iJi2M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _createClass;
});
var _toPropertyKeyJs = require("./toPropertyKey.js");
var _toPropertyKeyJsDefault = parcelHelpers.interopDefault(_toPropertyKeyJs);
function _defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, _toPropertyKeyJsDefault.default)(o.key), o);
    }
}
function _createClass(e, r, t) {
    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

},{"./toPropertyKey.js":"f3cuC","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"hG9AS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parsers", function() {
    return parsers;
});
var _eraParserJs = require("./EraParser.js");
var _yearParserJs = require("./YearParser.js");
var _localWeekYearParserJs = require("./LocalWeekYearParser.js");
var _isoweekYearParserJs = require("./ISOWeekYearParser.js");
var _extendedYearParserJs = require("./ExtendedYearParser.js");
var _quarterParserJs = require("./QuarterParser.js");
var _standAloneQuarterParserJs = require("./StandAloneQuarterParser.js");
var _monthParserJs = require("./MonthParser.js");
var _standAloneMonthParserJs = require("./StandAloneMonthParser.js");
var _localWeekParserJs = require("./LocalWeekParser.js");
var _isoweekParserJs = require("./ISOWeekParser.js");
var _dateParserJs = require("./DateParser.js");
var _dayOfYearParserJs = require("./DayOfYearParser.js");
var _dayParserJs = require("./DayParser.js");
var _localDayParserJs = require("./LocalDayParser.js");
var _standAloneLocalDayParserJs = require("./StandAloneLocalDayParser.js");
var _isodayParserJs = require("./ISODayParser.js");
var _ampmparserJs = require("./AMPMParser.js");
var _ampmmidnightParserJs = require("./AMPMMidnightParser.js");
var _dayPeriodParserJs = require("./DayPeriodParser.js");
var _hour1To12ParserJs = require("./Hour1to12Parser.js");
var _hour0To23ParserJs = require("./Hour0to23Parser.js");
var _hour0To11ParserJs = require("./Hour0To11Parser.js");
var _hour1To24ParserJs = require("./Hour1To24Parser.js");
var _minuteParserJs = require("./MinuteParser.js");
var _secondParserJs = require("./SecondParser.js");
var _fractionOfSecondParserJs = require("./FractionOfSecondParser.js");
var _isotimezoneWithZParserJs = require("./ISOTimezoneWithZParser.js");
var _isotimezoneParserJs = require("./ISOTimezoneParser.js");
var _timestampSecondsParserJs = require("./TimestampSecondsParser.js");
var _timestampMillisecondsParserJs = require("./TimestampMillisecondsParser.js");
var parsers = {
    G: new (0, _eraParserJs.EraParser)(),
    y: new (0, _yearParserJs.YearParser)(),
    Y: new (0, _localWeekYearParserJs.LocalWeekYearParser)(),
    R: new (0, _isoweekYearParserJs.ISOWeekYearParser)(),
    u: new (0, _extendedYearParserJs.ExtendedYearParser)(),
    Q: new (0, _quarterParserJs.QuarterParser)(),
    q: new (0, _standAloneQuarterParserJs.StandAloneQuarterParser)(),
    M: new (0, _monthParserJs.MonthParser)(),
    L: new (0, _standAloneMonthParserJs.StandAloneMonthParser)(),
    w: new (0, _localWeekParserJs.LocalWeekParser)(),
    I: new (0, _isoweekParserJs.ISOWeekParser)(),
    d: new (0, _dateParserJs.DateParser)(),
    D: new (0, _dayOfYearParserJs.DayOfYearParser)(),
    E: new (0, _dayParserJs.DayParser)(),
    e: new (0, _localDayParserJs.LocalDayParser)(),
    c: new (0, _standAloneLocalDayParserJs.StandAloneLocalDayParser)(),
    i: new (0, _isodayParserJs.ISODayParser)(),
    a: new (0, _ampmparserJs.AMPMParser)(),
    b: new (0, _ampmmidnightParserJs.AMPMMidnightParser)(),
    B: new (0, _dayPeriodParserJs.DayPeriodParser)(),
    h: new (0, _hour1To12ParserJs.Hour1to12Parser)(),
    H: new (0, _hour0To23ParserJs.Hour0to23Parser)(),
    K: new (0, _hour0To11ParserJs.Hour0To11Parser)(),
    k: new (0, _hour1To24ParserJs.Hour1To24Parser)(),
    m: new (0, _minuteParserJs.MinuteParser)(),
    s: new (0, _secondParserJs.SecondParser)(),
    S: new (0, _fractionOfSecondParserJs.FractionOfSecondParser)(),
    X: new (0, _isotimezoneWithZParserJs.ISOTimezoneWithZParser)(),
    x: new (0, _isotimezoneParserJs.ISOTimezoneParser)(),
    t: new (0, _timestampSecondsParserJs.TimestampSecondsParser)(),
    T: new (0, _timestampMillisecondsParserJs.TimestampMillisecondsParser)()
};

},{"./EraParser.js":"hJY6G","./YearParser.js":"8xZB7","./LocalWeekYearParser.js":"6pz6Q","./ISOWeekYearParser.js":"7DsbF","./ExtendedYearParser.js":"jKkS7","./QuarterParser.js":"f1viy","./StandAloneQuarterParser.js":"6cNMc","./MonthParser.js":"3o7V2","./StandAloneMonthParser.js":"rd6oe","./LocalWeekParser.js":"h71sB","./ISOWeekParser.js":"5pAmj","./DateParser.js":"9qYLQ","./DayOfYearParser.js":"90GXF","./DayParser.js":"cWZ9P","./LocalDayParser.js":"h0CaV","./StandAloneLocalDayParser.js":"bgZVT","./ISODayParser.js":"9XtMd","./AMPMParser.js":"81tcL","./AMPMMidnightParser.js":"gUq3N","./DayPeriodParser.js":"8aSvb","./Hour1to12Parser.js":"6YuJ0","./Hour0to23Parser.js":"aMbeF","./Hour0To11Parser.js":"caPxU","./Hour1To24Parser.js":"axnXL","./MinuteParser.js":"2Xm7l","./SecondParser.js":"8IXh5","./FractionOfSecondParser.js":"83o8i","./ISOTimezoneWithZParser.js":"gDwlQ","./ISOTimezoneParser.js":"2QZdw","./TimestampSecondsParser.js":"eYezF","./TimestampMillisecondsParser.js":"3KTDA","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"hJY6G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EraParser", function() {
    return EraParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var EraParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(EraParser, _Parser);
    var _super = (0, _createSuperDefault.default)(EraParser);
    function EraParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, EraParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 140);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'R',
            'u',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(EraParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // AD, BC
                    case 'G':
                    case 'GG':
                    case 'GGG':
                        return match.era(dateString, {
                            width: 'abbreviated'
                        }) || match.era(dateString, {
                            width: 'narrow'
                        });
                    // A, B
                    case 'GGGGG':
                        return match.era(dateString, {
                            width: 'narrow'
                        });
                    // Anno Domini, Before Christ
                    case 'GGGG':
                    default:
                        return match.era(dateString, {
                            width: 'wide'
                        }) || match.era(dateString, {
                            width: 'abbreviated'
                        }) || match.era(dateString, {
                            width: 'narrow'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                flags.era = value;
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return EraParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"8FUFf","@babel/runtime/helpers/esm/createClass":"iJi2M","@babel/runtime/helpers/esm/assertThisInitialized":"i1uh5","@babel/runtime/helpers/esm/inherits":"kXaEX","@babel/runtime/helpers/esm/createSuper":"iLuEE","@babel/runtime/helpers/esm/defineProperty":"hxCfo","../Parser.js":"hXd3a","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"hXd3a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Parser", function() {
    return Parser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _setterJs = require("./Setter.js");
var Parser = /*#__PURE__*/ function() {
    function Parser() {
        (0, _classCallCheckDefault.default)(this, Parser);
        (0, _definePropertyDefault.default)(this, "incompatibleTokens", void 0);
        (0, _definePropertyDefault.default)(this, "priority", void 0);
        (0, _definePropertyDefault.default)(this, "subPriority", void 0);
    }
    (0, _createClassDefault.default)(Parser, [
        {
            key: "run",
            value: function run(dateString, token, match, options) {
                var result = this.parse(dateString, token, match, options);
                if (!result) return null;
                return {
                    setter: new (0, _setterJs.ValueSetter)(result.value, this.validate, this.set, this.priority, this.subPriority),
                    rest: result.rest
                };
            }
        },
        {
            key: "validate",
            value: function validate(_utcDate, _value, _options) {
                return true;
            }
        }
    ]);
    return Parser;
}();

},{"@babel/runtime/helpers/esm/classCallCheck":"8FUFf","@babel/runtime/helpers/esm/createClass":"iJi2M","@babel/runtime/helpers/esm/defineProperty":"hxCfo","./Setter.js":"dXl5x","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8xZB7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "YearParser", function() {
    return YearParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var YearParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(YearParser, _Parser);
    var _super = (0, _createSuperDefault.default)(YearParser);
    function YearParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, YearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 130);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'u',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(YearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === 'yy'
                    };
                };
                switch(token){
                    case 'y':
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(4, dateString), valueCallback);
                    case 'yo':
                        return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'year'
                        }), valueCallback);
                    default:
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                var currentYear = date.getUTCFullYear();
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, _utilsJs.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
                    date.setUTCHours(0, 0, 0, 0);
                    return date;
                }
                var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return YearParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"8FUFf","@babel/runtime/helpers/esm/createClass":"iJi2M","@babel/runtime/helpers/esm/assertThisInitialized":"i1uh5","@babel/runtime/helpers/esm/inherits":"kXaEX","@babel/runtime/helpers/esm/createSuper":"iLuEE","@babel/runtime/helpers/esm/defineProperty":"hxCfo","../Parser.js":"hXd3a","../utils.js":"goAqq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"goAqq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapValue", function() {
    return mapValue;
});
parcelHelpers.export(exports, "parseNumericPattern", function() {
    return parseNumericPattern;
});
parcelHelpers.export(exports, "parseTimezonePattern", function() {
    return parseTimezonePattern;
});
parcelHelpers.export(exports, "parseAnyDigitsSigned", function() {
    return parseAnyDigitsSigned;
});
parcelHelpers.export(exports, "parseNDigits", function() {
    return parseNDigits;
});
parcelHelpers.export(exports, "parseNDigitsSigned", function() {
    return parseNDigitsSigned;
});
parcelHelpers.export(exports, "dayPeriodEnumToHours", function() {
    return dayPeriodEnumToHours;
});
parcelHelpers.export(exports, "normalizeTwoDigitYear", function() {
    return normalizeTwoDigitYear;
});
parcelHelpers.export(exports, "isLeapYearIndex", function() {
    return isLeapYearIndex;
});
var _indexJs = require("../../constants/index.js");
var _constantsJs = require("./constants.js");
function mapValue(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function parseNumericPattern(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function parseTimezonePattern(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === 'Z') return {
        value: 0,
        rest: dateString.slice(1)
    };
    var sign = matchResult[1] === '+' ? 1 : -1;
    var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, _indexJs.millisecondsInHour) + minutes * (0, _indexJs.millisecondsInMinute) + seconds * (0, _indexJs.millisecondsInSecond)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function parseAnyDigitsSigned(dateString) {
    return parseNumericPattern((0, _constantsJs.numericPatterns).anyDigitsSigned, dateString);
}
function parseNDigits(n, dateString) {
    switch(n){
        case 1:
            return parseNumericPattern((0, _constantsJs.numericPatterns).singleDigit, dateString);
        case 2:
            return parseNumericPattern((0, _constantsJs.numericPatterns).twoDigits, dateString);
        case 3:
            return parseNumericPattern((0, _constantsJs.numericPatterns).threeDigits, dateString);
        case 4:
            return parseNumericPattern((0, _constantsJs.numericPatterns).fourDigits, dateString);
        default:
            return parseNumericPattern(new RegExp('^\\d{1,' + n + '}'), dateString);
    }
}
function parseNDigitsSigned(n, dateString) {
    switch(n){
        case 1:
            return parseNumericPattern((0, _constantsJs.numericPatterns).singleDigitSigned, dateString);
        case 2:
            return parseNumericPattern((0, _constantsJs.numericPatterns).twoDigitsSigned, dateString);
        case 3:
            return parseNumericPattern((0, _constantsJs.numericPatterns).threeDigitsSigned, dateString);
        case 4:
            return parseNumericPattern((0, _constantsJs.numericPatterns).fourDigitsSigned, dateString);
        default:
            return parseNumericPattern(new RegExp('^-?\\d{1,' + n + '}'), dateString);
    }
}
function dayPeriodEnumToHours(dayPeriod) {
    switch(dayPeriod){
        case 'morning':
            return 4;
        case 'evening':
            return 17;
        case 'pm':
        case 'noon':
        case 'afternoon':
            return 12;
        case 'am':
        case 'midnight':
        case 'night':
        default:
            return 0;
    }
}
function normalizeTwoDigitYear(twoDigitYear, currentYear) {
    var isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    var result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        var rangeEnd = absCurrentYear + 50;
        var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
        var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

},{"../../constants/index.js":"ieaI6","./constants.js":"eqrVH","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"eqrVH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "numericPatterns", function() {
    return numericPatterns;
});
parcelHelpers.export(exports, "timezonePatterns", function() {
    return timezonePatterns;
});
var numericPatterns = {
    month: /^(1[0-2]|0?\d)/,
    // 0 to 12
    date: /^(3[0-1]|[0-2]?\d)/,
    // 0 to 31
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    // 0 to 366
    week: /^(5[0-3]|[0-4]?\d)/,
    // 0 to 53
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    // 0 to 23
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    // 0 to 24
    hour11h: /^(1[0-1]|0?\d)/,
    // 0 to 11
    hour12h: /^(1[0-2]|0?\d)/,
    // 0 to 12
    minute: /^[0-5]?\d/,
    // 0 to 59
    second: /^[0-5]?\d/,
    // 0 to 59
    singleDigit: /^\d/,
    // 0 to 9
    twoDigits: /^\d{1,2}/,
    // 0 to 99
    threeDigits: /^\d{1,3}/,
    // 0 to 999
    fourDigits: /^\d{1,4}/,
    // 0 to 9999
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    // 0 to 9, -0 to -9
    twoDigitsSigned: /^-?\d{1,2}/,
    // 0 to 99, -0 to -99
    threeDigitsSigned: /^-?\d{1,3}/,
    // 0 to 999, -0 to -999
    fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};
var timezonePatterns = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6pz6Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LocalWeekYearParser", function() {
    return LocalWeekYearParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/getUTCWeekYear/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/startOfUTCWeek/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var LocalWeekYearParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(LocalWeekYearParser, _Parser);
    var _super = (0, _createSuperDefault.default)(LocalWeekYearParser);
    function LocalWeekYearParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, LocalWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 130);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(LocalWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === 'YY'
                    };
                };
                switch(token){
                    case 'Y':
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(4, dateString), valueCallback);
                    case 'Yo':
                        return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'year'
                        }), valueCallback);
                    default:
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value, options) {
                var currentYear = (0, _indexJsDefault.default)(date, options);
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, _utilsJs.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
                    date.setUTCHours(0, 0, 0, 0);
                    return (0, _indexJsDefault1.default)(date, options);
                }
                var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
                date.setUTCHours(0, 0, 0, 0);
                return (0, _indexJsDefault1.default)(date, options);
            }
        }
    ]);
    return LocalWeekYearParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"8FUFf","@babel/runtime/helpers/esm/createClass":"iJi2M","@babel/runtime/helpers/esm/assertThisInitialized":"i1uh5","@babel/runtime/helpers/esm/inherits":"kXaEX","@babel/runtime/helpers/esm/createSuper":"iLuEE","@babel/runtime/helpers/esm/defineProperty":"hxCfo","../Parser.js":"hXd3a","../utils.js":"goAqq","../../../_lib/getUTCWeekYear/index.js":"aGFqe","../../../_lib/startOfUTCWeek/index.js":"lFep6","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7DsbF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ISOWeekYearParser", function() {
    return ISOWeekYearParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/startOfUTCISOWeek/index.js"); // ISO week-numbering year
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var ISOWeekYearParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(ISOWeekYearParser, _Parser);
    var _super = (0, _createSuperDefault.default)(ISOWeekYearParser);
    function ISOWeekYearParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, ISOWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 130);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'G',
            'y',
            'Y',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(ISOWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === 'R') return (0, _utilsJs.parseNDigitsSigned)(4, dateString);
                return (0, _utilsJs.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                var firstWeekOfYear = new Date(0);
                firstWeekOfYear.setUTCFullYear(value, 0, 4);
                firstWeekOfYear.setUTCHours(0, 0, 0, 0);
                return (0, _indexJsDefault.default)(firstWeekOfYear);
            }
        }
    ]);
    return ISOWeekYearParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"8FUFf","@babel/runtime/helpers/esm/createClass":"iJi2M","@babel/runtime/helpers/esm/assertThisInitialized":"i1uh5","@babel/runtime/helpers/esm/inherits":"kXaEX","@babel/runtime/helpers/esm/createSuper":"iLuEE","@babel/runtime/helpers/esm/defineProperty":"hxCfo","../Parser.js":"hXd3a","../utils.js":"goAqq","../../../_lib/startOfUTCISOWeek/index.js":"bber1","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jKkS7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ExtendedYearParser", function() {
    return ExtendedYearParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var ExtendedYearParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(ExtendedYearParser, _Parser);
    var _super = (0, _createSuperDefault.default)(ExtendedYearParser);
    function ExtendedYearParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, ExtendedYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 130);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'G',
            'y',
            'Y',
            'R',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(ExtendedYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === 'u') return (0, _utilsJs.parseNDigitsSigned)(4, dateString);
                return (0, _utilsJs.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ExtendedYearParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"8FUFf","@babel/runtime/helpers/esm/createClass":"iJi2M","@babel/runtime/helpers/esm/assertThisInitialized":"i1uh5","@babel/runtime/helpers/esm/inherits":"kXaEX","@babel/runtime/helpers/esm/createSuper":"iLuEE","@babel/runtime/helpers/esm/defineProperty":"hxCfo","../Parser.js":"hXd3a","../utils.js":"goAqq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"f1viy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QuarterParser", function() {
    return QuarterParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var QuarterParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(QuarterParser, _Parser);
    var _super = (0, _createSuperDefault.default)(QuarterParser);
    function QuarterParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, QuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 120);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(QuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case 'Q':
                    case 'QQ':
                        // 01, 02, 03, 04
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case 'Qo':
                        return match.ordinalNumber(dateString, {
                            unit: 'quarter'
                        });
                    // Q1, Q2, Q3, Q4
                    case 'QQQ':
                        return match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case 'QQQQQ':
                        return match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // 1st quarter, 2nd quarter, ...
                    case 'QQQQ':
                    default:
                        return match.quarter(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return QuarterParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"8FUFf","@babel/runtime/helpers/esm/createClass":"iJi2M","@babel/runtime/helpers/esm/assertThisInitialized":"i1uh5","@babel/runtime/helpers/esm/inherits":"kXaEX","@babel/runtime/helpers/esm/createSuper":"iLuEE","@babel/runtime/helpers/esm/defineProperty":"hxCfo","../Parser.js":"hXd3a","../utils.js":"goAqq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6cNMc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StandAloneQuarterParser", function() {
    return StandAloneQuarterParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var StandAloneQuarterParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(StandAloneQuarterParser, _Parser);
    var _super = (0, _createSuperDefault.default)(StandAloneQuarterParser);
    function StandAloneQuarterParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, StandAloneQuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 120);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(StandAloneQuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case 'q':
                    case 'qq':
                        // 01, 02, 03, 04
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case 'qo':
                        return match.ordinalNumber(dateString, {
                            unit: 'quarter'
                        });
                    // Q1, Q2, Q3, Q4
                    case 'qqq':
                        return match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case 'qqqqq':
                        return match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // 1st quarter, 2nd quarter, ...
                    case 'qqqq':
                    default:
                        return match.quarter(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneQuarterParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"8FUFf","@babel/runtime/helpers/esm/createClass":"iJi2M","@babel/runtime/helpers/esm/assertThisInitialized":"i1uh5","@babel/runtime/helpers/esm/inherits":"kXaEX","@babel/runtime/helpers/esm/createSuper":"iLuEE","@babel/runtime/helpers/esm/defineProperty":"hxCfo","../Parser.js":"hXd3a","../utils.js":"goAqq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3o7V2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MonthParser", function() {
    return MonthParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _utilsJs = require("../utils.js");
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var MonthParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(MonthParser, _Parser);
    var _super = (0, _createSuperDefault.default)(MonthParser);
    function MonthParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, MonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'L',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 110);
        return _this;
    }
    (0, _createClassDefault.default)(MonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case 'M':
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case 'MM':
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case 'Mo':
                        return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'month'
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case 'MMM':
                        return match.month(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // J, F, ..., D
                    case 'MMMMM':
                        return match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // January, February, ..., December
                    case 'MMMM':
                    default:
                        return match.month(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return MonthParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"8FUFf","@babel/runtime/helpers/esm/createClass":"iJi2M","@babel/runtime/helpers/esm/assertThisInitialized":"i1uh5","@babel/runtime/helpers/esm/inherits":"kXaEX","@babel/runtime/helpers/esm/createSuper":"iLuEE","@babel/runtime/helpers/esm/defineProperty":"hxCfo","../utils.js":"goAqq","../Parser.js":"hXd3a","../constants.js":"eqrVH","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"rd6oe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StandAloneMonthParser", function() {
    return StandAloneMonthParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var StandAloneMonthParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(StandAloneMonthParser, _Parser);
    var _super = (0, _createSuperDefault.default)(StandAloneMonthParser);
    function StandAloneMonthParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, StandAloneMonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 110);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(StandAloneMonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case 'L':
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case 'LL':
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case 'Lo':
                        return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'month'
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case 'LLL':
                        return match.month(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // J, F, ..., D
                    case 'LLLLL':
                        return match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // January, February, ..., December
                    case 'LLLL':
                    default:
                        return match.month(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneMonthParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"8FUFf","@babel/runtime/helpers/esm/createClass":"iJi2M","@babel/runtime/helpers/esm/assertThisInitialized":"i1uh5","@babel/runtime/helpers/esm/inherits":"kXaEX","@babel/runtime/helpers/esm/createSuper":"iLuEE","@babel/runtime/helpers/esm/defineProperty":"hxCfo","../Parser.js":"hXd3a","../constants.js":"eqrVH","../utils.js":"goAqq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"h71sB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LocalWeekParser", function() {
    return LocalWeekParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/setUTCWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/startOfUTCWeek/index.js"); // Local week of year
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var LocalWeekParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(LocalWeekParser, _Parser);
    var _super = (0, _createSuperDefault.default)(LocalWeekParser);
    function LocalWeekParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, LocalWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 100);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(LocalWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'w':
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).week, dateString);
                    case 'wo':
                        return match.ordinalNumber(dateString, {
                            unit: 'week'
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                return (0, _indexJsDefault1.default)((0, _indexJsDefault.default)(date, value, options), options);
            }
        }
    ]);
    return LocalWeekParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"8FUFf","@babel/runtime/helpers/esm/createClass":"iJi2M","@babel/runtime/helpers/esm/assertThisInitialized":"i1uh5","@babel/runtime/helpers/esm/inherits":"kXaEX","@babel/runtime/helpers/esm/createSuper":"iLuEE","@babel/runtime/helpers/esm/defineProperty":"hxCfo","../Parser.js":"hXd3a","../constants.js":"eqrVH","../utils.js":"goAqq","../../../_lib/setUTCWeek/index.js":"19M8I","../../../_lib/startOfUTCWeek/index.js":"lFep6","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"19M8I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return setUTCWeek;
});
var _indexJs = require("../toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../getUTCWeek/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
function setUTCWeek(dirtyDate, dirtyWeek, options) {
    (0, _indexJsDefault3.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var week = (0, _indexJsDefault.default)(dirtyWeek);
    var diff = (0, _indexJsDefault2.default)(date, options) - week;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

},{"../toInteger/index.js":"l2SJM","../../toDate/index.js":"j2pWU","../getUTCWeek/index.js":"iNdq4","../requiredArgs/index.js":"a3mwq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5pAmj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ISOWeekParser", function() {
    return ISOWeekParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/setUTCISOWeek/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/startOfUTCISOWeek/index.js"); // ISO week of year
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var ISOWeekParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(ISOWeekParser, _Parser);
    var _super = (0, _createSuperDefault.default)(ISOWeekParser);
    function ISOWeekParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, ISOWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 100);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(ISOWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'I':
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).week, dateString);
                    case 'Io':
                        return match.ordinalNumber(dateString, {
                            unit: 'week'
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                return (0, _indexJsDefault1.default)((0, _indexJsDefault.default)(date, value));
            }
        }
    ]);
    return ISOWeekParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"8FUFf","@babel/runtime/helpers/esm/createClass":"iJi2M","@babel/runtime/helpers/esm/assertThisInitialized":"i1uh5","@babel/runtime/helpers/esm/inherits":"kXaEX","@babel/runtime/helpers/esm/createSuper":"iLuEE","@babel/runtime/helpers/esm/defineProperty":"hxCfo","../Parser.js":"hXd3a","../constants.js":"eqrVH","../utils.js":"goAqq","../../../_lib/setUTCISOWeek/index.js":"gePe6","../../../_lib/startOfUTCISOWeek/index.js":"bber1","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gePe6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return setUTCISOWeek;
});
var _indexJs = require("../toInteger/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../toDate/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../getUTCISOWeek/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
    (0, _indexJsDefault3.default)(2, arguments);
    var date = (0, _indexJsDefault1.default)(dirtyDate);
    var isoWeek = (0, _indexJsDefault.default)(dirtyISOWeek);
    var diff = (0, _indexJsDefault2.default)(date) - isoWeek;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

},{"../toInteger/index.js":"l2SJM","../../toDate/index.js":"j2pWU","../getUTCISOWeek/index.js":"gE4Bi","../requiredArgs/index.js":"a3mwq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"9qYLQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DateParser", function() {
    return DateParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _utilsJs = require("../utils.js");
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var DateParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(DateParser, _Parser);
    var _super = (0, _createSuperDefault.default)(DateParser);
    function DateParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, DateParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 90);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "subPriority", 1);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(DateParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'd':
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).date, dateString);
                    case 'do':
                        return match.ordinalNumber(dateString, {
                            unit: 'date'
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, _utilsJs.isLeapYearIndex)(year);
                var month = date.getUTCMonth();
                if (isLeapYear) return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
                else return value >= 1 && value <= DAYS_IN_MONTH[month];
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCDate(value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DateParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"8FUFf","@babel/runtime/helpers/esm/createClass":"iJi2M","@babel/runtime/helpers/esm/assertThisInitialized":"i1uh5","@babel/runtime/helpers/esm/inherits":"kXaEX","@babel/runtime/helpers/esm/createSuper":"iLuEE","@babel/runtime/helpers/esm/defineProperty":"hxCfo","../utils.js":"goAqq","../Parser.js":"hXd3a","../constants.js":"eqrVH","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"90GXF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DayOfYearParser", function() {
    return DayOfYearParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var DayOfYearParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(DayOfYearParser, _Parser);
    var _super = (0, _createSuperDefault.default)(DayOfYearParser);
    function DayOfYearParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, DayOfYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 90);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "subpriority", 1);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'E',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(DayOfYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'D':
                    case 'DD':
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).dayOfYear, dateString);
                    case 'Do':
                        return match.ordinalNumber(dateString, {
                            unit: 'date'
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, _utilsJs.isLeapYearIndex)(year);
                if (isLeapYear) return value >= 1 && value <= 366;
                else return value >= 1 && value <= 365;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(0, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayOfYearParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"8FUFf","@babel/runtime/helpers/esm/createClass":"iJi2M","@babel/runtime/helpers/esm/assertThisInitialized":"i1uh5","@babel/runtime/helpers/esm/inherits":"kXaEX","@babel/runtime/helpers/esm/createSuper":"iLuEE","@babel/runtime/helpers/esm/defineProperty":"hxCfo","../Parser.js":"hXd3a","../constants.js":"eqrVH","../utils.js":"goAqq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"cWZ9P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DayParser", function() {
    return DayParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _indexJs = require("../../../_lib/setUTCDay/index.js"); // Day of week
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var DayParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(DayParser, _Parser);
    var _super = (0, _createSuperDefault.default)(DayParser);
    function DayParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, DayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 90);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(DayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // Tue
                    case 'E':
                    case 'EE':
                    case 'EEE':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // T
                    case 'EEEEE':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tu
                    case 'EEEEEE':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tuesday
                    case 'EEEE':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, _indexJsDefault.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"8FUFf","@babel/runtime/helpers/esm/createClass":"iJi2M","@babel/runtime/helpers/esm/assertThisInitialized":"i1uh5","@babel/runtime/helpers/esm/inherits":"kXaEX","@babel/runtime/helpers/esm/createSuper":"iLuEE","@babel/runtime/helpers/esm/defineProperty":"hxCfo","../Parser.js":"hXd3a","../../../_lib/setUTCDay/index.js":"8kVEQ","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8kVEQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return setUTCDay;
});
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../defaultOptions/index.js");
function setUTCDay(dirtyDate, dirtyDay, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, _indexJsDefault1.default)(2, arguments);
    var defaultOptions = (0, _indexJs3.getDefaultOptions)();
    var weekStartsOn = (0, _indexJsDefault2.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var day = (0, _indexJsDefault2.default)(dirtyDay);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

},{"../../toDate/index.js":"j2pWU","../requiredArgs/index.js":"a3mwq","../toInteger/index.js":"l2SJM","../defaultOptions/index.js":"f8LK0","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"h0CaV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LocalDayParser", function() {
    return LocalDayParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/setUTCDay/index.js"); // Local day of week
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var LocalDayParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(LocalDayParser, _Parser);
    var _super = (0, _createSuperDefault.default)(LocalDayParser);
    function LocalDayParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, LocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 90);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(LocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case 'e':
                    case 'ee':
                        // 03
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case 'eo':
                        return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'day'
                        }), valueCallback);
                    // Tue
                    case 'eee':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // T
                    case 'eeeee':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tu
                    case 'eeeeee':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tuesday
                    case 'eeee':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, _indexJsDefault.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return LocalDayParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"8FUFf","@babel/runtime/helpers/esm/createClass":"iJi2M","@babel/runtime/helpers/esm/assertThisInitialized":"i1uh5","@babel/runtime/helpers/esm/inherits":"kXaEX","@babel/runtime/helpers/esm/createSuper":"iLuEE","@babel/runtime/helpers/esm/defineProperty":"hxCfo","../Parser.js":"hXd3a","../utils.js":"goAqq","../../../_lib/setUTCDay/index.js":"8kVEQ","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"bgZVT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StandAloneLocalDayParser", function() {
    return StandAloneLocalDayParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/setUTCDay/index.js"); // Stand-alone local day of week
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var StandAloneLocalDayParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(StandAloneLocalDayParser, _Parser);
    var _super = (0, _createSuperDefault.default)(StandAloneLocalDayParser);
    function StandAloneLocalDayParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, StandAloneLocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 90);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'e',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(StandAloneLocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case 'c':
                    case 'cc':
                        // 03
                        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case 'co':
                        return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                            unit: 'day'
                        }), valueCallback);
                    // Tue
                    case 'ccc':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // T
                    case 'ccccc':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // Tu
                    case 'cccccc':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // Tuesday
                    case 'cccc':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, _indexJsDefault.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneLocalDayParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"8FUFf","@babel/runtime/helpers/esm/createClass":"iJi2M","@babel/runtime/helpers/esm/assertThisInitialized":"i1uh5","@babel/runtime/helpers/esm/inherits":"kXaEX","@babel/runtime/helpers/esm/createSuper":"iLuEE","@babel/runtime/helpers/esm/defineProperty":"hxCfo","../Parser.js":"hXd3a","../utils.js":"goAqq","../../../_lib/setUTCDay/index.js":"8kVEQ","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"9XtMd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ISODayParser", function() {
    return ISODayParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var _indexJs = require("../../../_lib/setUTCISODay/index.js"); // ISO day of week
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var ISODayParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(ISODayParser, _Parser);
    var _super = (0, _createSuperDefault.default)(ISODayParser);
    function ISODayParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, ISODayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 90);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'E',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(ISODayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    if (value === 0) return 7;
                    return value;
                };
                switch(token){
                    // 2
                    case 'i':
                    case 'ii':
                        // 02
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                    // 2nd
                    case 'io':
                        return match.ordinalNumber(dateString, {
                            unit: 'day'
                        });
                    // Tue
                    case 'iii':
                        return (0, _utilsJs.mapValue)(match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // T
                    case 'iiiii':
                        return (0, _utilsJs.mapValue)(match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // Tu
                    case 'iiiiii':
                        return (0, _utilsJs.mapValue)(match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // Tuesday
                    case 'iiii':
                    default:
                        return (0, _utilsJs.mapValue)(match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 7;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date = (0, _indexJsDefault.default)(date, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ISODayParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"8FUFf","@babel/runtime/helpers/esm/createClass":"iJi2M","@babel/runtime/helpers/esm/assertThisInitialized":"i1uh5","@babel/runtime/helpers/esm/inherits":"kXaEX","@babel/runtime/helpers/esm/createSuper":"iLuEE","@babel/runtime/helpers/esm/defineProperty":"hxCfo","../Parser.js":"hXd3a","../utils.js":"goAqq","../../../_lib/setUTCISODay/index.js":"3i6Z8","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3i6Z8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return setUTCISODay;
});
var _indexJs = require("../../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
function setUTCISODay(dirtyDate, dirtyDay) {
    (0, _indexJsDefault1.default)(2, arguments);
    var day = (0, _indexJsDefault2.default)(dirtyDay);
    if (day % 7 === 0) day = day - 7;
    var weekStartsOn = 1;
    var date = (0, _indexJsDefault.default)(dirtyDate);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

},{"../../toDate/index.js":"j2pWU","../requiredArgs/index.js":"a3mwq","../toInteger/index.js":"l2SJM","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"81tcL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AMPMParser", function() {
    return AMPMParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var AMPMParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(AMPMParser, _Parser);
    var _super = (0, _createSuperDefault.default)(AMPMParser);
    function AMPMParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, AMPMParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 80);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'b',
            'B',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(AMPMParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'a':
                    case 'aa':
                    case 'aaa':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'aaaaa':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'aaaa':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, _utilsJs.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"8FUFf","@babel/runtime/helpers/esm/createClass":"iJi2M","@babel/runtime/helpers/esm/assertThisInitialized":"i1uh5","@babel/runtime/helpers/esm/inherits":"kXaEX","@babel/runtime/helpers/esm/createSuper":"iLuEE","@babel/runtime/helpers/esm/defineProperty":"hxCfo","../Parser.js":"hXd3a","../utils.js":"goAqq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gUq3N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AMPMMidnightParser", function() {
    return AMPMMidnightParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var AMPMMidnightParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(AMPMMidnightParser, _Parser);
    var _super = (0, _createSuperDefault.default)(AMPMMidnightParser);
    function AMPMMidnightParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, AMPMMidnightParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 80);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'a',
            'B',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(AMPMMidnightParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'b':
                    case 'bb':
                    case 'bbb':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'bbbbb':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'bbbb':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, _utilsJs.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMMidnightParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"8FUFf","@babel/runtime/helpers/esm/createClass":"iJi2M","@babel/runtime/helpers/esm/assertThisInitialized":"i1uh5","@babel/runtime/helpers/esm/inherits":"kXaEX","@babel/runtime/helpers/esm/createSuper":"iLuEE","@babel/runtime/helpers/esm/defineProperty":"hxCfo","../Parser.js":"hXd3a","../utils.js":"goAqq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8aSvb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DayPeriodParser", function() {
    return DayPeriodParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js"); // in the morning, in the afternoon, in the evening, at night
var DayPeriodParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(DayPeriodParser, _Parser);
    var _super = (0, _createSuperDefault.default)(DayPeriodParser);
    function DayPeriodParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, DayPeriodParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 80);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(DayPeriodParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'B':
                    case 'BB':
                    case 'BBB':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'BBBBB':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'BBBB':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, _utilsJs.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayPeriodParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"8FUFf","@babel/runtime/helpers/esm/createClass":"iJi2M","@babel/runtime/helpers/esm/assertThisInitialized":"i1uh5","@babel/runtime/helpers/esm/inherits":"kXaEX","@babel/runtime/helpers/esm/createSuper":"iLuEE","@babel/runtime/helpers/esm/defineProperty":"hxCfo","../Parser.js":"hXd3a","../utils.js":"goAqq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6YuJ0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hour1to12Parser", function() {
    return Hour1to12Parser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var Hour1to12Parser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(Hour1to12Parser, _Parser);
    var _super = (0, _createSuperDefault.default)(Hour1to12Parser);
    function Hour1to12Parser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, Hour1to12Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 70);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'H',
            'K',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(Hour1to12Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'h':
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).hour12h, dateString);
                    case 'ho':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 12;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else if (!isPM && value === 12) date.setUTCHours(0, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1to12Parser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"8FUFf","@babel/runtime/helpers/esm/createClass":"iJi2M","@babel/runtime/helpers/esm/assertThisInitialized":"i1uh5","@babel/runtime/helpers/esm/inherits":"kXaEX","@babel/runtime/helpers/esm/createSuper":"iLuEE","@babel/runtime/helpers/esm/defineProperty":"hxCfo","../Parser.js":"hXd3a","../constants.js":"eqrVH","../utils.js":"goAqq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"aMbeF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hour0to23Parser", function() {
    return Hour0to23Parser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var Hour0to23Parser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(Hour0to23Parser, _Parser);
    var _super = (0, _createSuperDefault.default)(Hour0to23Parser);
    function Hour0to23Parser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, Hour0to23Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 70);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            'h',
            'K',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(Hour0to23Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'H':
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).hour23h, dateString);
                    case 'Ho':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 23;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0to23Parser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"8FUFf","@babel/runtime/helpers/esm/createClass":"iJi2M","@babel/runtime/helpers/esm/assertThisInitialized":"i1uh5","@babel/runtime/helpers/esm/inherits":"kXaEX","@babel/runtime/helpers/esm/createSuper":"iLuEE","@babel/runtime/helpers/esm/defineProperty":"hxCfo","../Parser.js":"hXd3a","../constants.js":"eqrVH","../utils.js":"goAqq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"caPxU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hour0To11Parser", function() {
    return Hour0To11Parser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var Hour0To11Parser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(Hour0To11Parser, _Parser);
    var _super = (0, _createSuperDefault.default)(Hour0To11Parser);
    function Hour0To11Parser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, Hour0To11Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 70);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'h',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(Hour0To11Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'K':
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).hour11h, dateString);
                    case 'Ko':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0To11Parser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"8FUFf","@babel/runtime/helpers/esm/createClass":"iJi2M","@babel/runtime/helpers/esm/assertThisInitialized":"i1uh5","@babel/runtime/helpers/esm/inherits":"kXaEX","@babel/runtime/helpers/esm/createSuper":"iLuEE","@babel/runtime/helpers/esm/defineProperty":"hxCfo","../Parser.js":"hXd3a","../constants.js":"eqrVH","../utils.js":"goAqq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"axnXL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hour1To24Parser", function() {
    return Hour1To24Parser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var Hour1To24Parser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(Hour1To24Parser, _Parser);
    var _super = (0, _createSuperDefault.default)(Hour1To24Parser);
    function Hour1To24Parser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, Hour1To24Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 70);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            'a',
            'b',
            'h',
            'H',
            'K',
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(Hour1To24Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'k':
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).hour24h, dateString);
                    case 'ko':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 24;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var hours = value <= 24 ? value % 24 : value;
                date.setUTCHours(hours, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1To24Parser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"8FUFf","@babel/runtime/helpers/esm/createClass":"iJi2M","@babel/runtime/helpers/esm/assertThisInitialized":"i1uh5","@babel/runtime/helpers/esm/inherits":"kXaEX","@babel/runtime/helpers/esm/createSuper":"iLuEE","@babel/runtime/helpers/esm/defineProperty":"hxCfo","../Parser.js":"hXd3a","../constants.js":"eqrVH","../utils.js":"goAqq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2Xm7l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MinuteParser", function() {
    return MinuteParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var MinuteParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(MinuteParser, _Parser);
    var _super = (0, _createSuperDefault.default)(MinuteParser);
    function MinuteParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, MinuteParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 60);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(MinuteParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'm':
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).minute, dateString);
                    case 'mo':
                        return match.ordinalNumber(dateString, {
                            unit: 'minute'
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMinutes(value, 0, 0);
                return date;
            }
        }
    ]);
    return MinuteParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"8FUFf","@babel/runtime/helpers/esm/createClass":"iJi2M","@babel/runtime/helpers/esm/assertThisInitialized":"i1uh5","@babel/runtime/helpers/esm/inherits":"kXaEX","@babel/runtime/helpers/esm/createSuper":"iLuEE","@babel/runtime/helpers/esm/defineProperty":"hxCfo","../Parser.js":"hXd3a","../constants.js":"eqrVH","../utils.js":"goAqq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8IXh5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SecondParser", function() {
    return SecondParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js");
var SecondParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(SecondParser, _Parser);
    var _super = (0, _createSuperDefault.default)(SecondParser);
    function SecondParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, SecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 50);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(SecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 's':
                        return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).second, dateString);
                    case 'so':
                        return match.ordinalNumber(dateString, {
                            unit: 'second'
                        });
                    default:
                        return (0, _utilsJs.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCSeconds(value, 0);
                return date;
            }
        }
    ]);
    return SecondParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"8FUFf","@babel/runtime/helpers/esm/createClass":"iJi2M","@babel/runtime/helpers/esm/assertThisInitialized":"i1uh5","@babel/runtime/helpers/esm/inherits":"kXaEX","@babel/runtime/helpers/esm/createSuper":"iLuEE","@babel/runtime/helpers/esm/defineProperty":"hxCfo","../Parser.js":"hXd3a","../constants.js":"eqrVH","../utils.js":"goAqq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"83o8i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FractionOfSecondParser", function() {
    return FractionOfSecondParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var FractionOfSecondParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(FractionOfSecondParser, _Parser);
    var _super = (0, _createSuperDefault.default)(FractionOfSecondParser);
    function FractionOfSecondParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, FractionOfSecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 30);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(FractionOfSecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                var valueCallback = function valueCallback(value) {
                    return Math.floor(value * Math.pow(10, -token.length + 3));
                };
                return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(token.length, dateString), valueCallback);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMilliseconds(value);
                return date;
            }
        }
    ]);
    return FractionOfSecondParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"8FUFf","@babel/runtime/helpers/esm/createClass":"iJi2M","@babel/runtime/helpers/esm/assertThisInitialized":"i1uh5","@babel/runtime/helpers/esm/inherits":"kXaEX","@babel/runtime/helpers/esm/createSuper":"iLuEE","@babel/runtime/helpers/esm/defineProperty":"hxCfo","../Parser.js":"hXd3a","../utils.js":"goAqq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gDwlQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ISOTimezoneWithZParser", function() {
    return ISOTimezoneWithZParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js"); // Timezone (ISO-8601. +00:00 is `'Z'`)
var ISOTimezoneWithZParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(ISOTimezoneWithZParser, _Parser);
    var _super = (0, _createSuperDefault.default)(ISOTimezoneWithZParser);
    function ISOTimezoneWithZParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, ISOTimezoneWithZParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 10);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            't',
            'T',
            'x'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(ISOTimezoneWithZParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case 'X':
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basicOptionalMinutes, dateString);
                    case 'XX':
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basic, dateString);
                    case 'XXXX':
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basicOptionalSeconds, dateString);
                    case 'XXXXX':
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).extendedOptionalSeconds, dateString);
                    case 'XXX':
                    default:
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneWithZParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"8FUFf","@babel/runtime/helpers/esm/createClass":"iJi2M","@babel/runtime/helpers/esm/assertThisInitialized":"i1uh5","@babel/runtime/helpers/esm/inherits":"kXaEX","@babel/runtime/helpers/esm/createSuper":"iLuEE","@babel/runtime/helpers/esm/defineProperty":"hxCfo","../Parser.js":"hXd3a","../constants.js":"eqrVH","../utils.js":"goAqq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2QZdw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ISOTimezoneParser", function() {
    return ISOTimezoneParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _constantsJs = require("../constants.js");
var _utilsJs = require("../utils.js"); // Timezone (ISO-8601)
var ISOTimezoneParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(ISOTimezoneParser, _Parser);
    var _super = (0, _createSuperDefault.default)(ISOTimezoneParser);
    function ISOTimezoneParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, ISOTimezoneParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 10);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", [
            't',
            'T',
            'X'
        ]);
        return _this;
    }
    (0, _createClassDefault.default)(ISOTimezoneParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case 'x':
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basicOptionalMinutes, dateString);
                    case 'xx':
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basic, dateString);
                    case 'xxxx':
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basicOptionalSeconds, dateString);
                    case 'xxxxx':
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).extendedOptionalSeconds, dateString);
                    case 'xxx':
                    default:
                        return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"8FUFf","@babel/runtime/helpers/esm/createClass":"iJi2M","@babel/runtime/helpers/esm/assertThisInitialized":"i1uh5","@babel/runtime/helpers/esm/inherits":"kXaEX","@babel/runtime/helpers/esm/createSuper":"iLuEE","@babel/runtime/helpers/esm/defineProperty":"hxCfo","../Parser.js":"hXd3a","../constants.js":"eqrVH","../utils.js":"goAqq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"eYezF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimestampSecondsParser", function() {
    return TimestampSecondsParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var TimestampSecondsParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(TimestampSecondsParser, _Parser);
    var _super = (0, _createSuperDefault.default)(TimestampSecondsParser);
    function TimestampSecondsParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, TimestampSecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 40);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", '*');
        return _this;
    }
    (0, _createClassDefault.default)(TimestampSecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, _utilsJs.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value * 1000),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampSecondsParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"8FUFf","@babel/runtime/helpers/esm/createClass":"iJi2M","@babel/runtime/helpers/esm/assertThisInitialized":"i1uh5","@babel/runtime/helpers/esm/inherits":"kXaEX","@babel/runtime/helpers/esm/createSuper":"iLuEE","@babel/runtime/helpers/esm/defineProperty":"hxCfo","../Parser.js":"hXd3a","../utils.js":"goAqq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3KTDA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimestampMillisecondsParser", function() {
    return TimestampMillisecondsParser;
});
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
var TimestampMillisecondsParser = /*#__PURE__*/ function(_Parser) {
    (0, _inheritsDefault.default)(TimestampMillisecondsParser, _Parser);
    var _super = (0, _createSuperDefault.default)(TimestampMillisecondsParser);
    function TimestampMillisecondsParser() {
        var _this;
        (0, _classCallCheckDefault.default)(this, TimestampMillisecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "priority", 20);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "incompatibleTokens", '*');
        return _this;
    }
    (0, _createClassDefault.default)(TimestampMillisecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, _utilsJs.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampMillisecondsParser;
}((0, _parserJs.Parser));

},{"@babel/runtime/helpers/esm/classCallCheck":"8FUFf","@babel/runtime/helpers/esm/createClass":"iJi2M","@babel/runtime/helpers/esm/assertThisInitialized":"i1uh5","@babel/runtime/helpers/esm/inherits":"kXaEX","@babel/runtime/helpers/esm/createSuper":"iLuEE","@babel/runtime/helpers/esm/defineProperty":"hxCfo","../Parser.js":"hXd3a","../utils.js":"goAqq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"hoQhg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return parseISO;
});
var _indexJs = require("../constants/index.js");
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/toInteger/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs2);
function parseISO(argument, options) {
    var _options$additionalDi;
    (0, _indexJsDefault.default)(1, arguments);
    var additionalDigits = (0, _indexJsDefault1.default)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = parseYear(dateStrings.date, additionalDigits);
        date = parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time);
        // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split(patterns.dateTimeDelimiter);
    var timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function parseYear(dateString, additionalDigits) {
    var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
    var captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ''
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match(dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = parseDateUnit(captures[1]);
    var month = parseDateUnit(captures[2]) - 1;
    var day = parseDateUnit(captures[3]);
    var week = parseDateUnit(captures[4]);
    var dayOfWeek = parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function parseTime(timeString) {
    var captures = timeString.match(timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = parseTimeUnit(captures[1]);
    var minutes = parseTimeUnit(captures[2]);
    var seconds = parseTimeUnit(captures[3]);
    if (!validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, _indexJs.millisecondsInHour) + minutes * (0, _indexJs.millisecondsInMinute) + seconds * 1000;
}
function parseTimeUnit(value) {
    return value && parseFloat(value.replace(',', '.')) || 0;
}
function parseTimezone(timezoneString) {
    if (timezoneString === 'Z') return 0;
    var captures = timezoneString.match(timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === '+' ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, _indexJs.millisecondsInHour) + minutes * (0, _indexJs.millisecondsInMinute));
}
function dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
var daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
}
function validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
}
function validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}

},{"../constants/index.js":"ieaI6","../_lib/requiredArgs/index.js":"a3mwq","../_lib/toInteger/index.js":"l2SJM","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8oP9q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IGNORE_CLASS_NAME", function() {
    return IGNORE_CLASS_NAME;
});
var _react = require("react");
var _reactDom = require("react-dom");
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
} /**
 * Check whether some DOM node is our Component's node.
 */ 
function isNodeFound(current, componentNode, ignoreClass) {
    if (current === componentNode) return true;
     // SVG <use/> elements do not technically reside in the rendered DOM, so
    // they do not have classList directly, but they offer a link to their
    // corresponding element, which can have classList. This extra check is for
    // that case.
    // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
    // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17
    if (current.correspondingElement) return current.correspondingElement.classList.contains(ignoreClass);
    return current.classList.contains(ignoreClass);
}
/**
 * Try to find our node in a hierarchy of nodes, returning the document
 * node as highest node if our node is not found in the path up.
 */ function findHighest(current, componentNode, ignoreClass) {
    if (current === componentNode) return true;
     // If source=local then this event came from 'somewhere'
    // inside and should be ignored. We could handle this with
    // a layered approach, too, but that requires going back to
    // thinking in terms of Dom node nesting, running counter
    // to React's 'you shouldn't care about the DOM' philosophy.
    // Also cover shadowRoot node by checking current.host
    while(current.parentNode || current.host){
        // Only check normal node without shadowRoot
        if (current.parentNode && isNodeFound(current, componentNode, ignoreClass)) return true;
        current = current.parentNode || current.host;
    }
    return current;
}
/**
 * Check if the browser scrollbar was clicked
 */ function clickedScrollbar(evt) {
    return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
} // ideally will get replaced with external dep
// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
var testPassiveEventSupport = function testPassiveEventSupport() {
    if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') return;
    var passive = false;
    var options = Object.defineProperty({}, 'passive', {
        get: function get() {
            passive = true;
        }
    });
    var noop = function noop() {};
    window.addEventListener('testPassiveEventSupport', noop, options);
    window.removeEventListener('testPassiveEventSupport', noop, options);
    return passive;
};
function autoInc(seed) {
    if (seed === void 0) seed = 0;
    return function() {
        return ++seed;
    };
}
var uid = autoInc();
var passiveEventSupport;
var handlersMap = {};
var enabledInstances = {};
var touchEvents = [
    'touchstart',
    'touchmove'
];
var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
/**
 * Options for addEventHandler and removeEventHandler
 */ function getEventHandlerOptions(instance, eventName) {
    var handlerOptions = {};
    var isTouchEvent = touchEvents.indexOf(eventName) !== -1;
    if (isTouchEvent && passiveEventSupport) handlerOptions.passive = !instance.props.preventDefault;
    return handlerOptions;
}
/**
 * This function generates the HOC function that you'll use
 * in order to impart onOutsideClick listening to an
 * arbitrary component. It gets called at the end of the
 * bootstrapping code to yield an instance of the
 * onClickOutsideHOC function defined inside setupHOC().
 */ function onClickOutsideHOC(WrappedComponent, config) {
    var _class, _temp;
    var componentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    return _temp = _class = /*#__PURE__*/ function(_Component) {
        _inheritsLoose(onClickOutside, _Component);
        function onClickOutside(props) {
            var _this;
            _this = _Component.call(this, props) || this;
            _this.__outsideClickHandler = function(event) {
                if (typeof _this.__clickOutsideHandlerProp === 'function') {
                    _this.__clickOutsideHandlerProp(event);
                    return;
                }
                var instance = _this.getInstance();
                if (typeof instance.props.handleClickOutside === 'function') {
                    instance.props.handleClickOutside(event);
                    return;
                }
                if (typeof instance.handleClickOutside === 'function') {
                    instance.handleClickOutside(event);
                    return;
                }
                throw new Error("WrappedComponent: " + componentName + " lacks a handleClickOutside(event) function for processing outside click events.");
            };
            _this.__getComponentNode = function() {
                var instance = _this.getInstance();
                if (config && typeof config.setClickOutsideRef === 'function') return config.setClickOutsideRef()(instance);
                if (typeof instance.setClickOutsideRef === 'function') return instance.setClickOutsideRef();
                return (0, _reactDom.findDOMNode)(instance);
            };
            _this.enableOnClickOutside = function() {
                if (typeof document === 'undefined' || enabledInstances[_this._uid]) return;
                if (typeof passiveEventSupport === 'undefined') passiveEventSupport = testPassiveEventSupport();
                enabledInstances[_this._uid] = true;
                var events = _this.props.eventTypes;
                if (!events.forEach) events = [
                    events
                ];
                handlersMap[_this._uid] = function(event) {
                    if (_this.componentNode === null) return;
                    if (_this.initTimeStamp > event.timeStamp) return;
                    if (_this.props.preventDefault) event.preventDefault();
                    if (_this.props.stopPropagation) event.stopPropagation();
                    if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
                    var current = event.composed && event.composedPath && event.composedPath().shift() || event.target;
                    if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) return;
                    _this.__outsideClickHandler(event);
                };
                events.forEach(function(eventName) {
                    document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_assertThisInitialized(_this), eventName));
                });
            };
            _this.disableOnClickOutside = function() {
                delete enabledInstances[_this._uid];
                var fn = handlersMap[_this._uid];
                if (fn && typeof document !== 'undefined') {
                    var events = _this.props.eventTypes;
                    if (!events.forEach) events = [
                        events
                    ];
                    events.forEach(function(eventName) {
                        return document.removeEventListener(eventName, fn, getEventHandlerOptions(_assertThisInitialized(_this), eventName));
                    });
                    delete handlersMap[_this._uid];
                }
            };
            _this.getRef = function(ref) {
                return _this.instanceRef = ref;
            };
            _this._uid = uid();
            _this.initTimeStamp = performance.now();
            return _this;
        }
        /**
     * Access the WrappedComponent's instance.
     */ var _proto = onClickOutside.prototype;
        _proto.getInstance = function getInstance() {
            if (WrappedComponent.prototype && !WrappedComponent.prototype.isReactComponent) return this;
            var ref = this.instanceRef;
            return ref.getInstance ? ref.getInstance() : ref;
        };
        /**
     * Add click listeners to the current document,
     * linked to this component's state.
     */ _proto.componentDidMount = function componentDidMount() {
            // If we are in an environment without a DOM such
            // as shallow rendering or snapshots then we exit
            // early to prevent any unhandled errors being thrown.
            if (typeof document === 'undefined' || !document.createElement) return;
            var instance = this.getInstance();
            if (config && typeof config.handleClickOutside === 'function') {
                this.__clickOutsideHandlerProp = config.handleClickOutside(instance);
                if (typeof this.__clickOutsideHandlerProp !== 'function') throw new Error("WrappedComponent: " + componentName + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
            }
            this.componentNode = this.__getComponentNode(); // return early so we dont initiate onClickOutside
            if (this.props.disableOnClickOutside) return;
            this.enableOnClickOutside();
        };
        _proto.componentDidUpdate = function componentDidUpdate() {
            this.componentNode = this.__getComponentNode();
        } /**
     * Remove all document's event listeners for this component
     */ ;
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.disableOnClickOutside();
        } /**
     * Can be called to explicitly enable event listening
     * for clicks and touches outside of this element.
     */ ;
        /**
     * Pass-through render
     */ _proto.render = function render() {
            // eslint-disable-next-line no-unused-vars
            var _this$props = this.props;
            _this$props.excludeScrollbar;
            var props = _objectWithoutPropertiesLoose(_this$props, [
                "excludeScrollbar"
            ]);
            if (WrappedComponent.prototype && WrappedComponent.prototype.isReactComponent) props.ref = this.getRef;
            else props.wrappedRef = this.getRef;
            props.disableOnClickOutside = this.disableOnClickOutside;
            props.enableOnClickOutside = this.enableOnClickOutside;
            return (0, _react.createElement)(WrappedComponent, props);
        };
        return onClickOutside;
    }((0, _react.Component)), _class.displayName = "OnClickOutside(" + componentName + ")", _class.defaultProps = {
        eventTypes: [
            'mousedown',
            'touchstart'
        ],
        excludeScrollbar: config && config.excludeScrollbar || false,
        outsideClickIgnoreClass: IGNORE_CLASS_NAME,
        preventDefault: false,
        stopPropagation: false
    }, _class.getClass = function() {
        return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
    }, _temp;
}
exports.default = onClickOutsideHOC;

},{"react":"c8CN1","react-dom":"kFYAC","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"aIW5W":[function(require,module,exports,__globalThis) {
// Public components
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Popper", function() {
    return 0, _popper.Popper;
}) // Public types
;
parcelHelpers.export(exports, "Manager", function() {
    return 0, _manager.Manager;
});
parcelHelpers.export(exports, "Reference", function() {
    return 0, _reference.Reference;
});
parcelHelpers.export(exports, "usePopper", function() {
    return 0, _usePopper.usePopper;
});
var _popper = require("./Popper");
var _manager = require("./Manager");
var _reference = require("./Reference");
var _usePopper = require("./usePopper");

},{"./Popper":"6pXkW","./Manager":"hBRcl","./Reference":"2fiay","./usePopper":"8mXqR","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6pXkW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Popper", function() {
    return Popper;
});
var _react = require("react");
var _manager = require("./Manager");
var _utils = require("./utils");
var _usePopper = require("./usePopper");
var NOOP = function NOOP() {
    return void 0;
};
var NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var EMPTY_MODIFIERS = [];
function Popper(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = _react.useContext((0, _manager.ManagerReferenceNodeContext));
    var _React$useState = _react.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = _react.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    _react.useEffect(function() {
        (0, _utils.setRef)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = _react.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: 'arrow',
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper1 = (0, _usePopper.usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper1.state, styles = _usePopper1.styles, forceUpdate = _usePopper1.forceUpdate, update = _usePopper1.update;
    var childrenProps = _react.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || NOOP,
            update: update || NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, _utils.unwrapArray)(children)(childrenProps);
}

},{"react":"c8CN1","./Manager":"hBRcl","./utils":"7NEny","./usePopper":"8mXqR","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"hBRcl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ManagerReferenceNodeContext", function() {
    return ManagerReferenceNodeContext;
});
parcelHelpers.export(exports, "ManagerReferenceNodeSetterContext", function() {
    return ManagerReferenceNodeSetterContext;
});
parcelHelpers.export(exports, "Manager", function() {
    return Manager;
});
var _react = require("react");
var ManagerReferenceNodeContext = _react.createContext();
var ManagerReferenceNodeSetterContext = _react.createContext();
function Manager(_ref) {
    var children = _ref.children;
    var _React$useState = _react.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = _react.useRef(false);
    _react.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = _react.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ _react.createElement(ManagerReferenceNodeContext.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ _react.createElement(ManagerReferenceNodeSetterContext.Provider, {
        value: handleSetReferenceNode
    }, children));
}

},{"react":"c8CN1","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7NEny":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unwrapArray", function() {
    return unwrapArray;
});
parcelHelpers.export(exports, "safeInvoke", function() {
    return safeInvoke;
});
parcelHelpers.export(exports, "setRef", function() {
    return setRef;
});
parcelHelpers.export(exports, "fromEntries", function() {
    return fromEntries;
});
parcelHelpers.export(exports, "useIsomorphicLayoutEffect", function() {
    return useIsomorphicLayoutEffect;
});
var _react = require("react");
var unwrapArray = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var safeInvoke = function safeInvoke(fn) {
    if (typeof fn === 'function') {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var setRef = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === 'function') return safeInvoke(ref, node);
    else if (ref != null) ref.current = node;
};
var fromEntries = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var useIsomorphicLayoutEffect = typeof window !== 'undefined' && window.document && window.document.createElement ? _react.useLayoutEffect : _react.useEffect;

},{"react":"c8CN1","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8mXqR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "usePopper", function() {
    return usePopper;
});
var _react = require("react");
var _reactDom = require("react-dom");
var _core = require("@popperjs/core");
var _reactFastCompare = require("react-fast-compare");
var _reactFastCompareDefault = parcelHelpers.interopDefault(_reactFastCompare);
var _utils = require("./utils");
var EMPTY_MODIFIERS = [];
var usePopper = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = _react.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || 'bottom',
        strategy: options.strategy || 'absolute',
        modifiers: options.modifiers || EMPTY_MODIFIERS
    };
    var _React$useState = _react.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: '0',
                top: '0'
            },
            arrow: {
                position: 'absolute'
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = _react.useMemo(function() {
        return {
            name: 'updateState',
            enabled: true,
            phase: 'write',
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                _reactDom.flushSync(function() {
                    setState({
                        styles: (0, _utils.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, _utils.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                'computeStyles'
            ]
        };
    }, []);
    var popperOptions = _react.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ])
        };
        if ((0, _reactFastCompareDefault.default)(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = _react.useRef();
    (0, _utils.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, _utils.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, _core.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

},{"react":"c8CN1","react-dom":"kFYAC","@popperjs/core":"ysQ0D","react-fast-compare":"29bxR","./utils":"7NEny","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"ysQ0D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "popperGenerator", function() {
    return 0, _createPopperJs.popperGenerator;
}) // eslint-disable-next-line import/no-unused-modules
;
parcelHelpers.export(exports, "detectOverflow", function() {
    return 0, _createPopperJs.detectOverflow;
});
parcelHelpers.export(exports, "createPopperBase", function() {
    return 0, _createPopperJs.createPopper;
});
parcelHelpers.export(exports, "createPopper", function() {
    return 0, _popperJs.createPopper;
}) // eslint-disable-next-line import/no-unused-modules
;
parcelHelpers.export(exports, "createPopperLite", function() {
    return 0, _popperLiteJs.createPopper;
});
var _enumsJs = require("./enums.js");
parcelHelpers.exportAll(_enumsJs, exports);
var _indexJs = require("./modifiers/index.js"); // eslint-disable-next-line import/no-unused-modules
parcelHelpers.exportAll(_indexJs, exports);
var _createPopperJs = require("./createPopper.js");
var _popperJs = require("./popper.js");
var _popperLiteJs = require("./popper-lite.js");

},{"./enums.js":false,"./modifiers/index.js":"9VYGv","./createPopper.js":false,"./popper.js":"5M4Q8","./popper-lite.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"g7T9Z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "top", function() {
    return top;
});
parcelHelpers.export(exports, "bottom", function() {
    return bottom;
});
parcelHelpers.export(exports, "right", function() {
    return right;
});
parcelHelpers.export(exports, "left", function() {
    return left;
});
parcelHelpers.export(exports, "auto", function() {
    return auto;
});
parcelHelpers.export(exports, "basePlacements", function() {
    return basePlacements;
});
parcelHelpers.export(exports, "start", function() {
    return start;
});
parcelHelpers.export(exports, "end", function() {
    return end;
});
parcelHelpers.export(exports, "clippingParents", function() {
    return clippingParents;
});
parcelHelpers.export(exports, "viewport", function() {
    return viewport;
});
parcelHelpers.export(exports, "popper", function() {
    return popper;
});
parcelHelpers.export(exports, "reference", function() {
    return reference;
});
parcelHelpers.export(exports, "variationPlacements", function() {
    return variationPlacements;
});
parcelHelpers.export(exports, "placements", function() {
    return placements;
});
parcelHelpers.export(exports, "beforeRead", function() {
    return beforeRead;
});
parcelHelpers.export(exports, "read", function() {
    return read;
});
parcelHelpers.export(exports, "afterRead", function() {
    return afterRead;
});
parcelHelpers.export(exports, "beforeMain", function() {
    return beforeMain;
});
parcelHelpers.export(exports, "main", function() {
    return main;
});
parcelHelpers.export(exports, "afterMain", function() {
    return afterMain;
});
parcelHelpers.export(exports, "beforeWrite", function() {
    return beforeWrite;
});
parcelHelpers.export(exports, "write", function() {
    return write;
});
parcelHelpers.export(exports, "afterWrite", function() {
    return afterWrite;
});
parcelHelpers.export(exports, "modifierPhases", function() {
    return modifierPhases;
});
var top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [
    top,
    bottom,
    right,
    left
];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/ basePlacements.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + start,
        placement + "-" + end
    ]);
}, []);
var placements = /*#__PURE__*/ [].concat(basePlacements, [
    auto
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + start,
        placement + "-" + end
    ]);
}, []); // modifiers that need to read the DOM
var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers
var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [
    beforeRead,
    read,
    afterRead,
    beforeMain,
    main,
    afterMain,
    beforeWrite,
    write,
    afterWrite
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"9VYGv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "applyStyles", function() {
    return 0, _applyStylesJsDefault.default;
});
parcelHelpers.export(exports, "arrow", function() {
    return 0, _arrowJsDefault.default;
});
parcelHelpers.export(exports, "computeStyles", function() {
    return 0, _computeStylesJsDefault.default;
});
parcelHelpers.export(exports, "eventListeners", function() {
    return 0, _eventListenersJsDefault.default;
});
parcelHelpers.export(exports, "flip", function() {
    return 0, _flipJsDefault.default;
});
parcelHelpers.export(exports, "hide", function() {
    return 0, _hideJsDefault.default;
});
parcelHelpers.export(exports, "offset", function() {
    return 0, _offsetJsDefault.default;
});
parcelHelpers.export(exports, "popperOffsets", function() {
    return 0, _popperOffsetsJsDefault.default;
});
parcelHelpers.export(exports, "preventOverflow", function() {
    return 0, _preventOverflowJsDefault.default;
});
var _applyStylesJs = require("./applyStyles.js");
var _applyStylesJsDefault = parcelHelpers.interopDefault(_applyStylesJs);
var _arrowJs = require("./arrow.js");
var _arrowJsDefault = parcelHelpers.interopDefault(_arrowJs);
var _computeStylesJs = require("./computeStyles.js");
var _computeStylesJsDefault = parcelHelpers.interopDefault(_computeStylesJs);
var _eventListenersJs = require("./eventListeners.js");
var _eventListenersJsDefault = parcelHelpers.interopDefault(_eventListenersJs);
var _flipJs = require("./flip.js");
var _flipJsDefault = parcelHelpers.interopDefault(_flipJs);
var _hideJs = require("./hide.js");
var _hideJsDefault = parcelHelpers.interopDefault(_hideJs);
var _offsetJs = require("./offset.js");
var _offsetJsDefault = parcelHelpers.interopDefault(_offsetJs);
var _popperOffsetsJs = require("./popperOffsets.js");
var _popperOffsetsJsDefault = parcelHelpers.interopDefault(_popperOffsetsJs);
var _preventOverflowJs = require("./preventOverflow.js");
var _preventOverflowJsDefault = parcelHelpers.interopDefault(_preventOverflowJs);

},{"./applyStyles.js":"e36W4","./arrow.js":false,"./computeStyles.js":false,"./eventListeners.js":false,"./flip.js":false,"./hide.js":false,"./offset.js":false,"./popperOffsets.js":false,"./preventOverflow.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"e36W4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getNodeNameJs = require("../dom-utils/getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _instanceOfJs = require("../dom-utils/instanceOf.js"); // This modifier takes the styles prepared by the `computeStyles` modifier
// and applies them to the HTMLElements such as popper and arrow
function applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, _instanceOfJs.isHTMLElement)(element) || !(0, _getNodeNameJsDefault.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, _instanceOfJs.isHTMLElement)(element) || !(0, _getNodeNameJsDefault.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: applyStyles,
    effect: effect,
    requires: [
        'computeStyles'
    ]
};

},{"../dom-utils/getNodeName.js":"l2FYq","../dom-utils/instanceOf.js":"l7mSt","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"l2FYq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getNodeName;
});
function getNodeName(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"l7mSt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isElement", function() {
    return isElement;
});
parcelHelpers.export(exports, "isHTMLElement", function() {
    return isHTMLElement;
});
parcelHelpers.export(exports, "isShadowRoot", function() {
    return isShadowRoot;
});
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
function isElement(node) {
    var OwnElement = (0, _getWindowJsDefault.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function isHTMLElement(node) {
    var OwnElement = (0, _getWindowJsDefault.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function isShadowRoot(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, _getWindowJsDefault.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

},{"./getWindow.js":"fHjvp","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"fHjvp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getWindow;
});
function getWindow(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6YkzC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getLayoutRectJs = require("../dom-utils/getLayoutRect.js");
var _getLayoutRectJsDefault = parcelHelpers.interopDefault(_getLayoutRectJs);
var _containsJs = require("../dom-utils/contains.js");
var _containsJsDefault = parcelHelpers.interopDefault(_containsJs);
var _getOffsetParentJs = require("../dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _getMainAxisFromPlacementJs = require("../utils/getMainAxisFromPlacement.js");
var _getMainAxisFromPlacementJsDefault = parcelHelpers.interopDefault(_getMainAxisFromPlacementJs);
var _withinJs = require("../utils/within.js");
var _mergePaddingObjectJs = require("../utils/mergePaddingObject.js");
var _mergePaddingObjectJsDefault = parcelHelpers.interopDefault(_mergePaddingObjectJs);
var _expandToHashMapJs = require("../utils/expandToHashMap.js");
var _expandToHashMapJsDefault = parcelHelpers.interopDefault(_expandToHashMapJs);
var _enumsJs = require("../enums.js"); // eslint-disable-next-line import/no-unused-modules
var toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, _mergePaddingObjectJsDefault.default)(typeof padding !== 'number' ? padding : (0, _expandToHashMapJsDefault.default)(padding, (0, _enumsJs.basePlacements)));
};
function arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, _getBasePlacementJsDefault.default)(state.placement);
    var axis = (0, _getMainAxisFromPlacementJsDefault.default)(basePlacement);
    var isVertical = [
        (0, _enumsJs.left),
        (0, _enumsJs.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = toPaddingObject(options.padding, state);
    var arrowRect = (0, _getLayoutRectJsDefault.default)(arrowElement);
    var minProp = axis === 'y' ? (0, _enumsJs.top) : (0, _enumsJs.left);
    var maxProp = axis === 'y' ? (0, _enumsJs.bottom) : (0, _enumsJs.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, _getOffsetParentJsDefault.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, _withinJs.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, _containsJsDefault.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: arrow,
    effect: effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

},{"../utils/getBasePlacement.js":"cL1CY","../dom-utils/getLayoutRect.js":"i6tXM","../dom-utils/contains.js":"7ds3b","../dom-utils/getOffsetParent.js":"ib3Pg","../utils/getMainAxisFromPlacement.js":"bLW66","../utils/within.js":"EqwG1","../utils/mergePaddingObject.js":"c8XUJ","../utils/expandToHashMap.js":"28N2J","../enums.js":"g7T9Z","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"cL1CY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getBasePlacement;
});
var _enumsJs = require("../enums.js");
function getBasePlacement(placement) {
    return placement.split('-')[0];
}

},{"../enums.js":"g7T9Z","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"i6tXM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getLayoutRect;
});
var _getBoundingClientRectJs = require("./getBoundingClientRect.js"); // Returns the layout rect of an element relative to its offsetParent. Layout
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
function getLayoutRect(element) {
    var clientRect = (0, _getBoundingClientRectJsDefault.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

},{"./getBoundingClientRect.js":"8k6oB","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8k6oB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getBoundingClientRect;
});
var _instanceOfJs = require("./instanceOf.js");
var _mathJs = require("../utils/math.js");
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _isLayoutViewportJs = require("./isLayoutViewport.js");
var _isLayoutViewportJsDefault = parcelHelpers.interopDefault(_isLayoutViewportJs);
function getBoundingClientRect(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, _instanceOfJs.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, _mathJs.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, _mathJs.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, _instanceOfJs.isElement)(element) ? (0, _getWindowJsDefault.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, _isLayoutViewportJsDefault.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

},{"./instanceOf.js":"l7mSt","../utils/math.js":"7ddDh","./getWindow.js":"fHjvp","./isLayoutViewport.js":"6rohp","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7ddDh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "max", function() {
    return max;
});
parcelHelpers.export(exports, "min", function() {
    return min;
});
parcelHelpers.export(exports, "round", function() {
    return round;
});
var max = Math.max;
var min = Math.min;
var round = Math.round;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6rohp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isLayoutViewport;
});
var _userAgentJs = require("../utils/userAgent.js");
var _userAgentJsDefault = parcelHelpers.interopDefault(_userAgentJs);
function isLayoutViewport() {
    return !/^((?!chrome|android).)*safari/i.test((0, _userAgentJsDefault.default)());
}

},{"../utils/userAgent.js":"3PuOh","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3PuOh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getUAString;
});
function getUAString() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7ds3b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return contains;
});
var _instanceOfJs = require("./instanceOf.js");
function contains(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, _instanceOfJs.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

},{"./instanceOf.js":"l7mSt","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"ib3Pg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getOffsetParent;
});
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _instanceOfJs = require("./instanceOf.js");
var _isTableElementJs = require("./isTableElement.js");
var _isTableElementJsDefault = parcelHelpers.interopDefault(_isTableElementJs);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _userAgentJs = require("../utils/userAgent.js");
var _userAgentJsDefault = parcelHelpers.interopDefault(_userAgentJs);
function getTrueOffsetParent(element) {
    if (!(0, _instanceOfJs.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, _getComputedStyleJsDefault.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, _userAgentJsDefault.default)());
    var isIE = /Trident/i.test((0, _userAgentJsDefault.default)());
    if (isIE && (0, _instanceOfJs.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, _getComputedStyleJsDefault.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, _getParentNodeJsDefault.default)(element);
    if ((0, _instanceOfJs.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, _instanceOfJs.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, _getNodeNameJsDefault.default)(currentNode)) < 0){
        var css = (0, _getComputedStyleJsDefault.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function getOffsetParent(element) {
    var window = (0, _getWindowJsDefault.default)(element);
    var offsetParent = getTrueOffsetParent(element);
    while(offsetParent && (0, _isTableElementJsDefault.default)(offsetParent) && (0, _getComputedStyleJsDefault.default)(offsetParent).position === 'static')offsetParent = getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, _getNodeNameJsDefault.default)(offsetParent) === 'html' || (0, _getNodeNameJsDefault.default)(offsetParent) === 'body' && (0, _getComputedStyleJsDefault.default)(offsetParent).position === 'static')) return window;
    return offsetParent || getContainingBlock(element) || window;
}

},{"./getWindow.js":"fHjvp","./getNodeName.js":"l2FYq","./getComputedStyle.js":"41Aj4","./instanceOf.js":"l7mSt","./isTableElement.js":"ew54c","./getParentNode.js":"1MGGR","../utils/userAgent.js":"3PuOh","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"41Aj4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getComputedStyle;
});
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
function getComputedStyle(element) {
    return (0, _getWindowJsDefault.default)(element).getComputedStyle(element);
}

},{"./getWindow.js":"fHjvp","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"ew54c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isTableElement;
});
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
function isTableElement(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, _getNodeNameJsDefault.default)(element)) >= 0;
}

},{"./getNodeName.js":"l2FYq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1MGGR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getParentNode;
});
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _instanceOfJs = require("./instanceOf.js");
function getParentNode(element) {
    if ((0, _getNodeNameJsDefault.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, _instanceOfJs.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, _getDocumentElementJsDefault.default)(element) // fallback
    );
}

},{"./getNodeName.js":"l2FYq","./getDocumentElement.js":"lk0NH","./instanceOf.js":"l7mSt","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"lk0NH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getDocumentElement;
});
var _instanceOfJs = require("./instanceOf.js");
function getDocumentElement(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, _instanceOfJs.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

},{"./instanceOf.js":"l7mSt","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"bLW66":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getMainAxisFromPlacement;
});
function getMainAxisFromPlacement(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"EqwG1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "within", function() {
    return within;
});
parcelHelpers.export(exports, "withinMaxClamp", function() {
    return withinMaxClamp;
});
var _mathJs = require("./math.js");
function within(min, value, max) {
    return (0, _mathJs.max)(min, (0, _mathJs.min)(value, max));
}
function withinMaxClamp(min, value, max) {
    var v = within(min, value, max);
    return v > max ? max : v;
}

},{"./math.js":"7ddDh","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"c8XUJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return mergePaddingObject;
});
var _getFreshSideObjectJs = require("./getFreshSideObject.js");
var _getFreshSideObjectJsDefault = parcelHelpers.interopDefault(_getFreshSideObjectJs);
function mergePaddingObject(paddingObject) {
    return Object.assign({}, (0, _getFreshSideObjectJsDefault.default)(), paddingObject);
}

},{"./getFreshSideObject.js":"kawDW","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"kawDW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getFreshSideObject;
});
function getFreshSideObject() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"28N2J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return expandToHashMap;
});
function expandToHashMap(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"i0UR7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapToStyles", function() {
    return mapToStyles;
});
var _enumsJs = require("../enums.js");
var _getOffsetParentJs = require("../dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _getWindowJs = require("../dom-utils/getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _getDocumentElementJs = require("../dom-utils/getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getComputedStyleJs = require("../dom-utils/getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getVariationJs = require("../utils/getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _mathJs = require("../utils/math.js"); // eslint-disable-next-line import/no-unused-modules
var unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, _mathJs.round)(x * dpr) / dpr || 0,
        y: (0, _mathJs.round)(y * dpr) / dpr || 0
    };
}
function mapToStyles(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, _enumsJs.left);
    var sideY = (0, _enumsJs.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, _getOffsetParentJsDefault.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, _getWindowJsDefault.default)(popper)) {
            offsetParent = (0, _getDocumentElementJsDefault.default)(popper);
            if ((0, _getComputedStyleJsDefault.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, _enumsJs.top) || (placement === (0, _enumsJs.left) || placement === (0, _enumsJs.right)) && variation === (0, _enumsJs.end)) {
            sideY = (0, _enumsJs.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, _enumsJs.left) || (placement === (0, _enumsJs.top) || placement === (0, _enumsJs.bottom)) && variation === (0, _enumsJs.end)) {
            sideX = (0, _enumsJs.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && unsetSides);
    var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, _getWindowJsDefault.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, _getBasePlacementJsDefault.default)(state.placement),
        variation: (0, _getVariationJsDefault.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: computeStyles,
    data: {}
};

},{"../enums.js":"g7T9Z","../dom-utils/getOffsetParent.js":"ib3Pg","../dom-utils/getWindow.js":"fHjvp","../dom-utils/getDocumentElement.js":"lk0NH","../dom-utils/getComputedStyle.js":"41Aj4","../utils/getBasePlacement.js":"cL1CY","../utils/getVariation.js":"3tMWm","../utils/math.js":"7ddDh","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3tMWm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getVariation;
});
function getVariation(placement) {
    return placement.split('-')[1];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7VGb5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getWindowJs = require("../dom-utils/getWindow.js"); // eslint-disable-next-line import/no-unused-modules
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var passive = {
    passive: true
};
function effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, _getWindowJsDefault.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, passive);
    });
    if (resize) window.addEventListener('resize', instance.update, passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, passive);
    };
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: effect,
    data: {}
};

},{"../dom-utils/getWindow.js":"fHjvp","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7M76f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _getOppositePlacementJs = require("../utils/getOppositePlacement.js");
var _getOppositePlacementJsDefault = parcelHelpers.interopDefault(_getOppositePlacementJs);
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getOppositeVariationPlacementJs = require("../utils/getOppositeVariationPlacement.js");
var _getOppositeVariationPlacementJsDefault = parcelHelpers.interopDefault(_getOppositeVariationPlacementJs);
var _detectOverflowJs = require("../utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _computeAutoPlacementJs = require("../utils/computeAutoPlacement.js");
var _computeAutoPlacementJsDefault = parcelHelpers.interopDefault(_computeAutoPlacementJs);
var _enumsJs = require("../enums.js");
var _getVariationJs = require("../utils/getVariation.js"); // eslint-disable-next-line import/no-unused-modules
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
function getExpandedFallbackPlacements(placement) {
    if ((0, _getBasePlacementJsDefault.default)(placement) === (0, _enumsJs.auto)) return [];
    var oppositePlacement = (0, _getOppositePlacementJsDefault.default)(placement);
    return [
        (0, _getOppositeVariationPlacementJsDefault.default)(placement),
        oppositePlacement,
        (0, _getOppositeVariationPlacementJsDefault.default)(oppositePlacement)
    ];
}
function flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, _getBasePlacementJsDefault.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, _getOppositePlacementJsDefault.default)(preferredPlacement)
    ] : getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, _getBasePlacementJsDefault.default)(placement) === (0, _enumsJs.auto) ? (0, _computeAutoPlacementJsDefault.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, _getBasePlacementJsDefault.default)(placement);
        var isStartVariation = (0, _getVariationJsDefault.default)(placement) === (0, _enumsJs.start);
        var isVertical = [
            (0, _enumsJs.top),
            (0, _enumsJs.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, _detectOverflowJsDefault.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, _enumsJs.right) : (0, _enumsJs.left) : isStartVariation ? (0, _enumsJs.bottom) : (0, _enumsJs.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, _getOppositePlacementJsDefault.default)(mainVariationSide);
        var altVariationSide = (0, _getOppositePlacementJsDefault.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

},{"../utils/getOppositePlacement.js":"5qQgJ","../utils/getBasePlacement.js":"cL1CY","../utils/getOppositeVariationPlacement.js":"3X64y","../utils/detectOverflow.js":"9HCeV","../utils/computeAutoPlacement.js":"63zV7","../enums.js":"g7T9Z","../utils/getVariation.js":"3tMWm","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5qQgJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getOppositePlacement;
});
var hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function getOppositePlacement(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return hash[matched];
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3X64y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getOppositeVariationPlacement;
});
var hash = {
    start: 'end',
    end: 'start'
};
function getOppositeVariationPlacement(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return hash[matched];
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"9HCeV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return detectOverflow;
});
var _getClippingRectJs = require("../dom-utils/getClippingRect.js");
var _getClippingRectJsDefault = parcelHelpers.interopDefault(_getClippingRectJs);
var _getDocumentElementJs = require("../dom-utils/getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getBoundingClientRectJs = require("../dom-utils/getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _computeOffsetsJs = require("./computeOffsets.js");
var _computeOffsetsJsDefault = parcelHelpers.interopDefault(_computeOffsetsJs);
var _rectToClientRectJs = require("./rectToClientRect.js");
var _rectToClientRectJsDefault = parcelHelpers.interopDefault(_rectToClientRectJs);
var _enumsJs = require("../enums.js");
var _instanceOfJs = require("../dom-utils/instanceOf.js");
var _mergePaddingObjectJs = require("./mergePaddingObject.js");
var _mergePaddingObjectJsDefault = parcelHelpers.interopDefault(_mergePaddingObjectJs);
var _expandToHashMapJs = require("./expandToHashMap.js"); // eslint-disable-next-line import/no-unused-modules
var _expandToHashMapJsDefault = parcelHelpers.interopDefault(_expandToHashMapJs);
function detectOverflow(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, _enumsJs.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, _enumsJs.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, _enumsJs.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, _mergePaddingObjectJsDefault.default)(typeof padding !== 'number' ? padding : (0, _expandToHashMapJsDefault.default)(padding, (0, _enumsJs.basePlacements)));
    var altContext = elementContext === (0, _enumsJs.popper) ? (0, _enumsJs.reference) : (0, _enumsJs.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, _getClippingRectJsDefault.default)((0, _instanceOfJs.isElement)(element) ? element : element.contextElement || (0, _getDocumentElementJsDefault.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, _getBoundingClientRectJsDefault.default)(state.elements.reference);
    var popperOffsets = (0, _computeOffsetsJsDefault.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, _rectToClientRectJsDefault.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, _enumsJs.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, _enumsJs.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, _enumsJs.right),
                (0, _enumsJs.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, _enumsJs.top),
                (0, _enumsJs.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

},{"../dom-utils/getClippingRect.js":"1DcmY","../dom-utils/getDocumentElement.js":"lk0NH","../dom-utils/getBoundingClientRect.js":"8k6oB","./computeOffsets.js":"bpb02","./rectToClientRect.js":"3C6Fi","../enums.js":"g7T9Z","../dom-utils/instanceOf.js":"l7mSt","./mergePaddingObject.js":"c8XUJ","./expandToHashMap.js":"28N2J","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1DcmY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getClippingRect;
});
var _enumsJs = require("../enums.js");
var _getViewportRectJs = require("./getViewportRect.js");
var _getViewportRectJsDefault = parcelHelpers.interopDefault(_getViewportRectJs);
var _getDocumentRectJs = require("./getDocumentRect.js");
var _getDocumentRectJsDefault = parcelHelpers.interopDefault(_getDocumentRectJs);
var _listScrollParentsJs = require("./listScrollParents.js");
var _listScrollParentsJsDefault = parcelHelpers.interopDefault(_listScrollParentsJs);
var _getOffsetParentJs = require("./getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _instanceOfJs = require("./instanceOf.js");
var _getBoundingClientRectJs = require("./getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _containsJs = require("./contains.js");
var _containsJsDefault = parcelHelpers.interopDefault(_containsJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _rectToClientRectJs = require("../utils/rectToClientRect.js");
var _rectToClientRectJsDefault = parcelHelpers.interopDefault(_rectToClientRectJs);
var _mathJs = require("../utils/math.js");
function getInnerBoundingClientRect(element, strategy) {
    var rect = (0, _getBoundingClientRectJsDefault.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, _enumsJs.viewport) ? (0, _rectToClientRectJsDefault.default)((0, _getViewportRectJsDefault.default)(element, strategy)) : (0, _instanceOfJs.isElement)(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : (0, _rectToClientRectJsDefault.default)((0, _getDocumentRectJsDefault.default)((0, _getDocumentElementJsDefault.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function getClippingParents(element) {
    var clippingParents = (0, _listScrollParentsJsDefault.default)((0, _getParentNodeJsDefault.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, _getComputedStyleJsDefault.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, _instanceOfJs.isHTMLElement)(element) ? (0, _getOffsetParentJsDefault.default)(element) : element;
    if (!(0, _instanceOfJs.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, _instanceOfJs.isElement)(clippingParent) && (0, _containsJsDefault.default)(clippingParent, clipperElement) && (0, _getNodeNameJsDefault.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function getClippingRect(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, _mathJs.max)(rect.top, accRect.top);
        accRect.right = (0, _mathJs.min)(rect.right, accRect.right);
        accRect.bottom = (0, _mathJs.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, _mathJs.max)(rect.left, accRect.left);
        return accRect;
    }, getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

},{"../enums.js":"g7T9Z","./getViewportRect.js":"7yrDM","./getDocumentRect.js":"cd7sD","./listScrollParents.js":"eR2cS","./getOffsetParent.js":"ib3Pg","./getDocumentElement.js":"lk0NH","./getComputedStyle.js":"41Aj4","./instanceOf.js":"l7mSt","./getBoundingClientRect.js":"8k6oB","./getParentNode.js":"1MGGR","./contains.js":"7ds3b","./getNodeName.js":"l2FYq","../utils/rectToClientRect.js":"3C6Fi","../utils/math.js":"7ddDh","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7yrDM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getViewportRect;
});
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getWindowScrollBarXJs = require("./getWindowScrollBarX.js");
var _getWindowScrollBarXJsDefault = parcelHelpers.interopDefault(_getWindowScrollBarXJs);
var _isLayoutViewportJs = require("./isLayoutViewport.js");
var _isLayoutViewportJsDefault = parcelHelpers.interopDefault(_isLayoutViewportJs);
function getViewportRect(element, strategy) {
    var win = (0, _getWindowJsDefault.default)(element);
    var html = (0, _getDocumentElementJsDefault.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, _isLayoutViewportJsDefault.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, _getWindowScrollBarXJsDefault.default)(element),
        y: y
    };
}

},{"./getWindow.js":"fHjvp","./getDocumentElement.js":"lk0NH","./getWindowScrollBarX.js":"8OwyU","./isLayoutViewport.js":"6rohp","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8OwyU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getWindowScrollBarX;
});
var _getBoundingClientRectJs = require("./getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getWindowScrollJs = require("./getWindowScroll.js");
var _getWindowScrollJsDefault = parcelHelpers.interopDefault(_getWindowScrollJs);
function getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, _getBoundingClientRectJsDefault.default)((0, _getDocumentElementJsDefault.default)(element)).left + (0, _getWindowScrollJsDefault.default)(element).scrollLeft;
}

},{"./getBoundingClientRect.js":"8k6oB","./getDocumentElement.js":"lk0NH","./getWindowScroll.js":"ffJd3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"ffJd3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getWindowScroll;
});
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
function getWindowScroll(node) {
    var win = (0, _getWindowJsDefault.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

},{"./getWindow.js":"fHjvp","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"cd7sD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getDocumentRect;
});
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
var _getWindowScrollBarXJs = require("./getWindowScrollBarX.js");
var _getWindowScrollBarXJsDefault = parcelHelpers.interopDefault(_getWindowScrollBarXJs);
var _getWindowScrollJs = require("./getWindowScroll.js");
var _getWindowScrollJsDefault = parcelHelpers.interopDefault(_getWindowScrollJs);
var _mathJs = require("../utils/math.js"); // Gets the entire size of the scrollable document area, even extending outside
function getDocumentRect(element) {
    var _element$ownerDocumen;
    var html = (0, _getDocumentElementJsDefault.default)(element);
    var winScroll = (0, _getWindowScrollJsDefault.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, _mathJs.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, _mathJs.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, _getWindowScrollBarXJsDefault.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, _getComputedStyleJsDefault.default)(body || html).direction === 'rtl') x += (0, _mathJs.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

},{"./getDocumentElement.js":"lk0NH","./getComputedStyle.js":"41Aj4","./getWindowScrollBarX.js":"8OwyU","./getWindowScroll.js":"ffJd3","../utils/math.js":"7ddDh","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"eR2cS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return listScrollParents;
});
var _getScrollParentJs = require("./getScrollParent.js");
var _getScrollParentJsDefault = parcelHelpers.interopDefault(_getScrollParentJs);
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _isScrollParentJs = require("./isScrollParent.js");
var _isScrollParentJsDefault = parcelHelpers.interopDefault(_isScrollParentJs);
function listScrollParents(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, _getScrollParentJsDefault.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, _getWindowJsDefault.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, _isScrollParentJsDefault.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat(listScrollParents((0, _getParentNodeJsDefault.default)(target)));
}

},{"./getScrollParent.js":"bdDsk","./getParentNode.js":"1MGGR","./getWindow.js":"fHjvp","./isScrollParent.js":"1lnZ3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"bdDsk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getScrollParent;
});
var _getParentNodeJs = require("./getParentNode.js");
var _getParentNodeJsDefault = parcelHelpers.interopDefault(_getParentNodeJs);
var _isScrollParentJs = require("./isScrollParent.js");
var _isScrollParentJsDefault = parcelHelpers.interopDefault(_isScrollParentJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _instanceOfJs = require("./instanceOf.js");
function getScrollParent(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, _getNodeNameJsDefault.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, _instanceOfJs.isHTMLElement)(node) && (0, _isScrollParentJsDefault.default)(node)) return node;
    return getScrollParent((0, _getParentNodeJsDefault.default)(node));
}

},{"./getParentNode.js":"1MGGR","./isScrollParent.js":"1lnZ3","./getNodeName.js":"l2FYq","./instanceOf.js":"l7mSt","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1lnZ3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isScrollParent;
});
var _getComputedStyleJs = require("./getComputedStyle.js");
var _getComputedStyleJsDefault = parcelHelpers.interopDefault(_getComputedStyleJs);
function isScrollParent(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, _getComputedStyleJsDefault.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

},{"./getComputedStyle.js":"41Aj4","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3C6Fi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return rectToClientRect;
});
function rectToClientRect(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"bpb02":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return computeOffsets;
});
var _getBasePlacementJs = require("./getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getVariationJs = require("./getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _getMainAxisFromPlacementJs = require("./getMainAxisFromPlacement.js");
var _getMainAxisFromPlacementJsDefault = parcelHelpers.interopDefault(_getMainAxisFromPlacementJs);
var _enumsJs = require("../enums.js");
function computeOffsets(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, _getBasePlacementJsDefault.default)(placement) : null;
    var variation = placement ? (0, _getVariationJsDefault.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, _enumsJs.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, _enumsJs.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, _enumsJs.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, _enumsJs.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, _getMainAxisFromPlacementJsDefault.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, _enumsJs.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, _enumsJs.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

},{"./getBasePlacement.js":"cL1CY","./getVariation.js":"3tMWm","./getMainAxisFromPlacement.js":"bLW66","../enums.js":"g7T9Z","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"63zV7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return computeAutoPlacement;
});
var _getVariationJs = require("./getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _enumsJs = require("../enums.js");
var _detectOverflowJs = require("./detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _getBasePlacementJs = require("./getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
function computeAutoPlacement(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, _enumsJs.placements) : _options$allowedAutoP;
    var variation = (0, _getVariationJsDefault.default)(placement);
    var placements = variation ? flipVariations ? (0, _enumsJs.variationPlacements) : (0, _enumsJs.variationPlacements).filter(function(placement) {
        return (0, _getVariationJsDefault.default)(placement) === variation;
    }) : (0, _enumsJs.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, _detectOverflowJsDefault.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, _getBasePlacementJsDefault.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

},{"./getVariation.js":"3tMWm","../enums.js":"g7T9Z","./detectOverflow.js":"9HCeV","./getBasePlacement.js":"cL1CY","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jkJKV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _enumsJs = require("../enums.js");
var _detectOverflowJs = require("../utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
function getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function isAnySideFullyClipped(overflow) {
    return [
        (0, _enumsJs.top),
        (0, _enumsJs.right),
        (0, _enumsJs.bottom),
        (0, _enumsJs.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, _detectOverflowJsDefault.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, _detectOverflowJsDefault.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: hide
};

},{"../enums.js":"g7T9Z","../utils/detectOverflow.js":"9HCeV","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3DXLK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "distanceAndSkiddingToXY", function() {
    return distanceAndSkiddingToXY;
});
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _enumsJs = require("../enums.js"); // eslint-disable-next-line import/no-unused-modules
function distanceAndSkiddingToXY(placement, rects, offset) {
    var basePlacement = (0, _getBasePlacementJsDefault.default)(placement);
    var invertDistance = [
        (0, _enumsJs.left),
        (0, _enumsJs.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, _enumsJs.left),
        (0, _enumsJs.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, _$offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, _enumsJs.placements).reduce(function(acc, placement) {
        acc[placement] = distanceAndSkiddingToXY(placement, state.rects, _$offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: offset
};

},{"../utils/getBasePlacement.js":"cL1CY","../enums.js":"g7T9Z","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"d455N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _computeOffsetsJs = require("../utils/computeOffsets.js");
var _computeOffsetsJsDefault = parcelHelpers.interopDefault(_computeOffsetsJs);
function popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, _computeOffsetsJsDefault.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: popperOffsets,
    data: {}
};

},{"../utils/computeOffsets.js":"bpb02","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1Sum9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _enumsJs = require("../enums.js");
var _getBasePlacementJs = require("../utils/getBasePlacement.js");
var _getBasePlacementJsDefault = parcelHelpers.interopDefault(_getBasePlacementJs);
var _getMainAxisFromPlacementJs = require("../utils/getMainAxisFromPlacement.js");
var _getMainAxisFromPlacementJsDefault = parcelHelpers.interopDefault(_getMainAxisFromPlacementJs);
var _getAltAxisJs = require("../utils/getAltAxis.js");
var _getAltAxisJsDefault = parcelHelpers.interopDefault(_getAltAxisJs);
var _withinJs = require("../utils/within.js");
var _getLayoutRectJs = require("../dom-utils/getLayoutRect.js");
var _getLayoutRectJsDefault = parcelHelpers.interopDefault(_getLayoutRectJs);
var _getOffsetParentJs = require("../dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _detectOverflowJs = require("../utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _getVariationJs = require("../utils/getVariation.js");
var _getVariationJsDefault = parcelHelpers.interopDefault(_getVariationJs);
var _getFreshSideObjectJs = require("../utils/getFreshSideObject.js");
var _getFreshSideObjectJsDefault = parcelHelpers.interopDefault(_getFreshSideObjectJs);
var _mathJs = require("../utils/math.js");
function preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, _detectOverflowJsDefault.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, _getBasePlacementJsDefault.default)(state.placement);
    var variation = (0, _getVariationJsDefault.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, _getMainAxisFromPlacementJsDefault.default)(basePlacement);
    var altAxis = (0, _getAltAxisJsDefault.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, _enumsJs.top) : (0, _enumsJs.left);
        var altSide = mainAxis === 'y' ? (0, _enumsJs.bottom) : (0, _enumsJs.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, _enumsJs.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, _enumsJs.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, _getLayoutRectJsDefault.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, _getFreshSideObjectJsDefault.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, _withinJs.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, _getOffsetParentJsDefault.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, _withinJs.within)(tether ? (0, _mathJs.min)(min, tetherMin) : min, offset, tether ? (0, _mathJs.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, _enumsJs.top) : (0, _enumsJs.left);
        var _altSide = mainAxis === 'x' ? (0, _enumsJs.bottom) : (0, _enumsJs.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, _enumsJs.top),
            (0, _enumsJs.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, _withinJs.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, _withinJs.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
exports.default = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

},{"../enums.js":"g7T9Z","../utils/getBasePlacement.js":"cL1CY","../utils/getMainAxisFromPlacement.js":"bLW66","../utils/getAltAxis.js":"3vP5y","../utils/within.js":"EqwG1","../dom-utils/getLayoutRect.js":"i6tXM","../dom-utils/getOffsetParent.js":"ib3Pg","../utils/detectOverflow.js":"9HCeV","../utils/getVariation.js":"3tMWm","../utils/getFreshSideObject.js":"kawDW","../utils/math.js":"7ddDh","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3vP5y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getAltAxis;
});
function getAltAxis(axis) {
    return axis === 'x' ? 'y' : 'x';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3isJa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "popperGenerator", function() {
    return popperGenerator;
});
parcelHelpers.export(exports, "createPopper", function() {
    return createPopper;
});
parcelHelpers.export(exports, "detectOverflow", function() {
    return 0, _detectOverflowJsDefault.default;
});
var _getCompositeRectJs = require("./dom-utils/getCompositeRect.js");
var _getCompositeRectJsDefault = parcelHelpers.interopDefault(_getCompositeRectJs);
var _getLayoutRectJs = require("./dom-utils/getLayoutRect.js");
var _getLayoutRectJsDefault = parcelHelpers.interopDefault(_getLayoutRectJs);
var _listScrollParentsJs = require("./dom-utils/listScrollParents.js");
var _listScrollParentsJsDefault = parcelHelpers.interopDefault(_listScrollParentsJs);
var _getOffsetParentJs = require("./dom-utils/getOffsetParent.js");
var _getOffsetParentJsDefault = parcelHelpers.interopDefault(_getOffsetParentJs);
var _orderModifiersJs = require("./utils/orderModifiers.js");
var _orderModifiersJsDefault = parcelHelpers.interopDefault(_orderModifiersJs);
var _debounceJs = require("./utils/debounce.js");
var _debounceJsDefault = parcelHelpers.interopDefault(_debounceJs);
var _mergeByNameJs = require("./utils/mergeByName.js");
var _mergeByNameJsDefault = parcelHelpers.interopDefault(_mergeByNameJs);
var _detectOverflowJs = require("./utils/detectOverflow.js");
var _detectOverflowJsDefault = parcelHelpers.interopDefault(_detectOverflowJs);
var _instanceOfJs = require("./dom-utils/instanceOf.js");
var DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function popperGenerator(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var _$options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, _$options);
                state.scrollParents = {
                    reference: (0, _instanceOfJs.isElement)(reference) ? (0, _listScrollParentsJsDefault.default)(reference) : reference.contextElement ? (0, _listScrollParentsJsDefault.default)(reference.contextElement) : [],
                    popper: (0, _listScrollParentsJsDefault.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, _orderModifiersJsDefault.default)((0, _mergeByNameJsDefault.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, _$reference = _state$elements.reference, _$popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!areValidElements(_$reference, _$popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, _getCompositeRectJsDefault.default)(_$reference, (0, _getOffsetParentJsDefault.default)(_$popper), state.options.strategy === 'fixed'),
                    popper: (0, _getLayoutRectJsDefault.default)(_$popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, _debounceJsDefault.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, _$options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: _$options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var createPopper = /*#__PURE__*/ popperGenerator(); // eslint-disable-next-line import/no-unused-modules

},{"./dom-utils/getCompositeRect.js":"cYwF4","./dom-utils/getLayoutRect.js":"i6tXM","./dom-utils/listScrollParents.js":"eR2cS","./dom-utils/getOffsetParent.js":"ib3Pg","./utils/orderModifiers.js":"6T2OJ","./utils/debounce.js":"89dXc","./utils/mergeByName.js":"879zu","./utils/detectOverflow.js":false,"./dom-utils/instanceOf.js":"l7mSt","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"cYwF4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getCompositeRect;
});
var _getBoundingClientRectJs = require("./getBoundingClientRect.js");
var _getBoundingClientRectJsDefault = parcelHelpers.interopDefault(_getBoundingClientRectJs);
var _getNodeScrollJs = require("./getNodeScroll.js");
var _getNodeScrollJsDefault = parcelHelpers.interopDefault(_getNodeScrollJs);
var _getNodeNameJs = require("./getNodeName.js");
var _getNodeNameJsDefault = parcelHelpers.interopDefault(_getNodeNameJs);
var _instanceOfJs = require("./instanceOf.js");
var _getWindowScrollBarXJs = require("./getWindowScrollBarX.js");
var _getWindowScrollBarXJsDefault = parcelHelpers.interopDefault(_getWindowScrollBarXJs);
var _getDocumentElementJs = require("./getDocumentElement.js");
var _getDocumentElementJsDefault = parcelHelpers.interopDefault(_getDocumentElementJs);
var _isScrollParentJs = require("./isScrollParent.js");
var _isScrollParentJsDefault = parcelHelpers.interopDefault(_isScrollParentJs);
var _mathJs = require("../utils/math.js");
function isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, _mathJs.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, _mathJs.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, _instanceOfJs.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, _instanceOfJs.isHTMLElement)(offsetParent) && isElementScaled(offsetParent);
    var documentElement = (0, _getDocumentElementJsDefault.default)(offsetParent);
    var rect = (0, _getBoundingClientRectJsDefault.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, _getNodeNameJsDefault.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, _isScrollParentJsDefault.default)(documentElement)) scroll = (0, _getNodeScrollJsDefault.default)(offsetParent);
        if ((0, _instanceOfJs.isHTMLElement)(offsetParent)) {
            offsets = (0, _getBoundingClientRectJsDefault.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, _getWindowScrollBarXJsDefault.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

},{"./getBoundingClientRect.js":"8k6oB","./getNodeScroll.js":"f8XIV","./getNodeName.js":"l2FYq","./instanceOf.js":"l7mSt","./getWindowScrollBarX.js":"8OwyU","./getDocumentElement.js":"lk0NH","./isScrollParent.js":"1lnZ3","../utils/math.js":"7ddDh","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"f8XIV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getNodeScroll;
});
var _getWindowScrollJs = require("./getWindowScroll.js");
var _getWindowScrollJsDefault = parcelHelpers.interopDefault(_getWindowScrollJs);
var _getWindowJs = require("./getWindow.js");
var _getWindowJsDefault = parcelHelpers.interopDefault(_getWindowJs);
var _instanceOfJs = require("./instanceOf.js");
var _getHTMLElementScrollJs = require("./getHTMLElementScroll.js");
var _getHTMLElementScrollJsDefault = parcelHelpers.interopDefault(_getHTMLElementScrollJs);
function getNodeScroll(node) {
    if (node === (0, _getWindowJsDefault.default)(node) || !(0, _instanceOfJs.isHTMLElement)(node)) return (0, _getWindowScrollJsDefault.default)(node);
    else return (0, _getHTMLElementScrollJsDefault.default)(node);
}

},{"./getWindowScroll.js":"ffJd3","./getWindow.js":"fHjvp","./instanceOf.js":"l7mSt","./getHTMLElementScroll.js":"2bRmR","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2bRmR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return getHTMLElementScroll;
});
function getHTMLElementScroll(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6T2OJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return orderModifiers;
});
var _enumsJs = require("../enums.js"); // source: https://stackoverflow.com/questions/49875255
function order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function orderModifiers(modifiers) {
    // order based on dependencies
    var orderedModifiers = order(modifiers); // order based on phase
    return (0, _enumsJs.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

},{"../enums.js":"g7T9Z","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"89dXc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return debounce;
});
function debounce(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"879zu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return mergeByName;
});
function mergeByName(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5M4Q8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createPopperLite", function() {
    return 0, _popperLiteJs.createPopper;
}) // eslint-disable-next-line import/no-unused-modules
;
parcelHelpers.export(exports, "createPopper", function() {
    return createPopper;
}) // eslint-disable-next-line import/no-unused-modules
;
parcelHelpers.export(exports, "popperGenerator", function() {
    return 0, _createPopperJs.popperGenerator;
});
parcelHelpers.export(exports, "defaultModifiers", function() {
    return defaultModifiers;
});
parcelHelpers.export(exports, "detectOverflow", function() {
    return 0, _createPopperJs.detectOverflow;
});
var _createPopperJs = require("./createPopper.js");
var _eventListenersJs = require("./modifiers/eventListeners.js");
var _eventListenersJsDefault = parcelHelpers.interopDefault(_eventListenersJs);
var _popperOffsetsJs = require("./modifiers/popperOffsets.js");
var _popperOffsetsJsDefault = parcelHelpers.interopDefault(_popperOffsetsJs);
var _computeStylesJs = require("./modifiers/computeStyles.js");
var _computeStylesJsDefault = parcelHelpers.interopDefault(_computeStylesJs);
var _applyStylesJs = require("./modifiers/applyStyles.js");
var _applyStylesJsDefault = parcelHelpers.interopDefault(_applyStylesJs);
var _offsetJs = require("./modifiers/offset.js");
var _offsetJsDefault = parcelHelpers.interopDefault(_offsetJs);
var _flipJs = require("./modifiers/flip.js");
var _flipJsDefault = parcelHelpers.interopDefault(_flipJs);
var _preventOverflowJs = require("./modifiers/preventOverflow.js");
var _preventOverflowJsDefault = parcelHelpers.interopDefault(_preventOverflowJs);
var _arrowJs = require("./modifiers/arrow.js");
var _arrowJsDefault = parcelHelpers.interopDefault(_arrowJs);
var _hideJs = require("./modifiers/hide.js");
var _hideJsDefault = parcelHelpers.interopDefault(_hideJs);
var _popperLiteJs = require("./popper-lite.js");
var _indexJs = require("./modifiers/index.js");
parcelHelpers.exportAll(_indexJs, exports);
var defaultModifiers = [
    (0, _eventListenersJsDefault.default),
    (0, _popperOffsetsJsDefault.default),
    (0, _computeStylesJsDefault.default),
    (0, _applyStylesJsDefault.default),
    (0, _offsetJsDefault.default),
    (0, _flipJsDefault.default),
    (0, _preventOverflowJsDefault.default),
    (0, _arrowJsDefault.default),
    (0, _hideJsDefault.default)
];
var createPopper = /*#__PURE__*/ (0, _createPopperJs.popperGenerator)({
    defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

},{"./createPopper.js":"3isJa","./modifiers/eventListeners.js":"7VGb5","./modifiers/popperOffsets.js":"d455N","./modifiers/computeStyles.js":"i0UR7","./modifiers/applyStyles.js":"e36W4","./modifiers/offset.js":"3DXLK","./modifiers/flip.js":"7M76f","./modifiers/preventOverflow.js":"1Sum9","./modifiers/arrow.js":"6YkzC","./modifiers/hide.js":"jkJKV","./popper-lite.js":false,"./modifiers/index.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"29bxR":[function(require,module,exports,__globalThis) {
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var hasElementType = typeof Element !== 'undefined';
var hasMap = typeof Map === 'function';
var hasSet = typeof Set === 'function';
var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if (hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if (hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if (hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function isEqual(a, b) {
    try {
        return equal(a, b);
    } catch (error) {
        if ((error.message || '').match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('react-fast-compare cannot handle circular refs');
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

},{}],"2fiay":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Reference", function() {
    return Reference;
});
var _react = require("react");
var _warning = require("warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
var _manager = require("./Manager");
var _utils = require("./utils");
function Reference(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = _react.useContext((0, _manager.ManagerReferenceNodeSetterContext));
    var refHandler = _react.useCallback(function(node) {
        (0, _utils.setRef)(innerRef, node);
        (0, _utils.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    _react.useEffect(function() {
        return function() {
            return (0, _utils.setRef)(innerRef, null);
        };
    }, []);
    _react.useEffect(function() {
        (0, _warningDefault.default)(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    }, [
        setReferenceNode
    ]);
    return (0, _utils.unwrapArray)(children)({
        ref: refHandler
    });
}

},{"react":"c8CN1","warning":"1Ir5c","./Manager":"hBRcl","./utils":"7NEny","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1Ir5c":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var __DEV__ = true;
var warning = function warning() {};
if (__DEV__) {
    var printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    warning = function warning(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) printWarning.apply(null, [
            format
        ].concat(args));
    };
}
module.exports = warning;

},{}],"46CGV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return set;
});
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../setMonth/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../_lib/toInteger/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
function set(dirtyDate, values) {
    (0, _indexJsDefault3.default)(2, arguments);
    if ((0, _typeofDefault.default)(values) !== 'object' || values === null) throw new RangeError('values parameter must be an object');
    var date = (0, _indexJsDefault.default)(dirtyDate);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(date.getTime())) return new Date(NaN);
    if (values.year != null) date.setFullYear(values.year);
    if (values.month != null) date = (0, _indexJsDefault1.default)(date, values.month);
    if (values.date != null) date.setDate((0, _indexJsDefault2.default)(values.date));
    if (values.hours != null) date.setHours((0, _indexJsDefault2.default)(values.hours));
    if (values.minutes != null) date.setMinutes((0, _indexJsDefault2.default)(values.minutes));
    if (values.seconds != null) date.setSeconds((0, _indexJsDefault2.default)(values.seconds));
    if (values.milliseconds != null) date.setMilliseconds((0, _indexJsDefault2.default)(values.milliseconds));
    return date;
}

},{"@babel/runtime/helpers/esm/typeof":"iu2gT","../toDate/index.js":"j2pWU","../setMonth/index.js":"isBz6","../_lib/toInteger/index.js":"l2SJM","../_lib/requiredArgs/index.js":"a3mwq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gjKaW":[function(require,module,exports,__globalThis) {
// This file is generated automatically by `scripts/build/indices.ts`. Please, don't change it.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "af", function() {
    return 0, _indexJsDefault.default;
});
parcelHelpers.export(exports, "ar", function() {
    return 0, _indexJsDefault1.default;
});
parcelHelpers.export(exports, "arDZ", function() {
    return 0, _indexJsDefault2.default;
});
parcelHelpers.export(exports, "arEG", function() {
    return 0, _indexJsDefault3.default;
});
parcelHelpers.export(exports, "arMA", function() {
    return 0, _indexJsDefault4.default;
});
parcelHelpers.export(exports, "arSA", function() {
    return 0, _indexJsDefault5.default;
});
parcelHelpers.export(exports, "arTN", function() {
    return 0, _indexJsDefault6.default;
});
parcelHelpers.export(exports, "az", function() {
    return 0, _indexJsDefault7.default;
});
parcelHelpers.export(exports, "be", function() {
    return 0, _indexJsDefault8.default;
});
parcelHelpers.export(exports, "beTarask", function() {
    return 0, _indexJsDefault9.default;
});
parcelHelpers.export(exports, "bg", function() {
    return 0, _indexJsDefault10.default;
});
parcelHelpers.export(exports, "bn", function() {
    return 0, _indexJsDefault11.default;
});
parcelHelpers.export(exports, "bs", function() {
    return 0, _indexJsDefault12.default;
});
parcelHelpers.export(exports, "ca", function() {
    return 0, _indexJsDefault13.default;
});
parcelHelpers.export(exports, "cs", function() {
    return 0, _indexJsDefault14.default;
});
parcelHelpers.export(exports, "cy", function() {
    return 0, _indexJsDefault15.default;
});
parcelHelpers.export(exports, "da", function() {
    return 0, _indexJsDefault16.default;
});
parcelHelpers.export(exports, "de", function() {
    return 0, _indexJsDefault17.default;
});
parcelHelpers.export(exports, "deAT", function() {
    return 0, _indexJsDefault18.default;
});
parcelHelpers.export(exports, "el", function() {
    return 0, _indexJsDefault19.default;
});
parcelHelpers.export(exports, "enAU", function() {
    return 0, _indexJsDefault20.default;
});
parcelHelpers.export(exports, "enCA", function() {
    return 0, _indexJsDefault21.default;
});
parcelHelpers.export(exports, "enGB", function() {
    return 0, _indexJsDefault22.default;
});
parcelHelpers.export(exports, "enIE", function() {
    return 0, _indexJsDefault23.default;
});
parcelHelpers.export(exports, "enIN", function() {
    return 0, _indexJsDefault24.default;
});
parcelHelpers.export(exports, "enNZ", function() {
    return 0, _indexJsDefault25.default;
});
parcelHelpers.export(exports, "enUS", function() {
    return 0, _indexJsDefault26.default;
});
parcelHelpers.export(exports, "enZA", function() {
    return 0, _indexJsDefault27.default;
});
parcelHelpers.export(exports, "eo", function() {
    return 0, _indexJsDefault28.default;
});
parcelHelpers.export(exports, "es", function() {
    return 0, _indexJsDefault29.default;
});
parcelHelpers.export(exports, "et", function() {
    return 0, _indexJsDefault30.default;
});
parcelHelpers.export(exports, "eu", function() {
    return 0, _indexJsDefault31.default;
});
parcelHelpers.export(exports, "faIR", function() {
    return 0, _indexJsDefault32.default;
});
parcelHelpers.export(exports, "fi", function() {
    return 0, _indexJsDefault33.default;
});
parcelHelpers.export(exports, "fr", function() {
    return 0, _indexJsDefault34.default;
});
parcelHelpers.export(exports, "frCA", function() {
    return 0, _indexJsDefault35.default;
});
parcelHelpers.export(exports, "frCH", function() {
    return 0, _indexJsDefault36.default;
});
parcelHelpers.export(exports, "fy", function() {
    return 0, _indexJsDefault37.default;
});
parcelHelpers.export(exports, "gd", function() {
    return 0, _indexJsDefault38.default;
});
parcelHelpers.export(exports, "gl", function() {
    return 0, _indexJsDefault39.default;
});
parcelHelpers.export(exports, "gu", function() {
    return 0, _indexJsDefault40.default;
});
parcelHelpers.export(exports, "he", function() {
    return 0, _indexJsDefault41.default;
});
parcelHelpers.export(exports, "hi", function() {
    return 0, _indexJsDefault42.default;
});
parcelHelpers.export(exports, "hr", function() {
    return 0, _indexJsDefault43.default;
});
parcelHelpers.export(exports, "ht", function() {
    return 0, _indexJsDefault44.default;
});
parcelHelpers.export(exports, "hu", function() {
    return 0, _indexJsDefault45.default;
});
parcelHelpers.export(exports, "hy", function() {
    return 0, _indexJsDefault46.default;
});
parcelHelpers.export(exports, "id", function() {
    return 0, _indexJsDefault47.default;
});
parcelHelpers.export(exports, "is", function() {
    return 0, _indexJsDefault48.default;
});
parcelHelpers.export(exports, "it", function() {
    return 0, _indexJsDefault49.default;
});
parcelHelpers.export(exports, "itCH", function() {
    return 0, _indexJsDefault50.default;
});
parcelHelpers.export(exports, "ja", function() {
    return 0, _indexJsDefault51.default;
});
parcelHelpers.export(exports, "jaHira", function() {
    return 0, _indexJsDefault52.default;
});
parcelHelpers.export(exports, "ka", function() {
    return 0, _indexJsDefault53.default;
});
parcelHelpers.export(exports, "kk", function() {
    return 0, _indexJsDefault54.default;
});
parcelHelpers.export(exports, "km", function() {
    return 0, _indexJsDefault55.default;
});
parcelHelpers.export(exports, "kn", function() {
    return 0, _indexJsDefault56.default;
});
parcelHelpers.export(exports, "ko", function() {
    return 0, _indexJsDefault57.default;
});
parcelHelpers.export(exports, "lb", function() {
    return 0, _indexJsDefault58.default;
});
parcelHelpers.export(exports, "lt", function() {
    return 0, _indexJsDefault59.default;
});
parcelHelpers.export(exports, "lv", function() {
    return 0, _indexJsDefault60.default;
});
parcelHelpers.export(exports, "mk", function() {
    return 0, _indexJsDefault61.default;
});
parcelHelpers.export(exports, "mn", function() {
    return 0, _indexJsDefault62.default;
});
parcelHelpers.export(exports, "ms", function() {
    return 0, _indexJsDefault63.default;
});
parcelHelpers.export(exports, "mt", function() {
    return 0, _indexJsDefault64.default;
});
parcelHelpers.export(exports, "nb", function() {
    return 0, _indexJsDefault65.default;
});
parcelHelpers.export(exports, "nl", function() {
    return 0, _indexJsDefault66.default;
});
parcelHelpers.export(exports, "nlBE", function() {
    return 0, _indexJsDefault67.default;
});
parcelHelpers.export(exports, "nn", function() {
    return 0, _indexJsDefault68.default;
});
parcelHelpers.export(exports, "oc", function() {
    return 0, _indexJsDefault69.default;
});
parcelHelpers.export(exports, "pl", function() {
    return 0, _indexJsDefault70.default;
});
parcelHelpers.export(exports, "pt", function() {
    return 0, _indexJsDefault71.default;
});
parcelHelpers.export(exports, "ptBR", function() {
    return 0, _indexJsDefault72.default;
});
parcelHelpers.export(exports, "ro", function() {
    return 0, _indexJsDefault73.default;
});
parcelHelpers.export(exports, "ru", function() {
    return 0, _indexJsDefault74.default;
});
parcelHelpers.export(exports, "sk", function() {
    return 0, _indexJsDefault75.default;
});
parcelHelpers.export(exports, "sl", function() {
    return 0, _indexJsDefault76.default;
});
parcelHelpers.export(exports, "sq", function() {
    return 0, _indexJsDefault77.default;
});
parcelHelpers.export(exports, "sr", function() {
    return 0, _indexJsDefault78.default;
});
parcelHelpers.export(exports, "srLatn", function() {
    return 0, _indexJsDefault79.default;
});
parcelHelpers.export(exports, "sv", function() {
    return 0, _indexJsDefault80.default;
});
parcelHelpers.export(exports, "ta", function() {
    return 0, _indexJsDefault81.default;
});
parcelHelpers.export(exports, "te", function() {
    return 0, _indexJsDefault82.default;
});
parcelHelpers.export(exports, "th", function() {
    return 0, _indexJsDefault83.default;
});
parcelHelpers.export(exports, "tr", function() {
    return 0, _indexJsDefault84.default;
});
parcelHelpers.export(exports, "ug", function() {
    return 0, _indexJsDefault85.default;
});
parcelHelpers.export(exports, "uk", function() {
    return 0, _indexJsDefault86.default;
});
parcelHelpers.export(exports, "uz", function() {
    return 0, _indexJsDefault87.default;
});
parcelHelpers.export(exports, "uzCyrl", function() {
    return 0, _indexJsDefault88.default;
});
parcelHelpers.export(exports, "vi", function() {
    return 0, _indexJsDefault89.default;
});
parcelHelpers.export(exports, "zhCN", function() {
    return 0, _indexJsDefault90.default;
});
parcelHelpers.export(exports, "zhHK", function() {
    return 0, _indexJsDefault91.default;
});
parcelHelpers.export(exports, "zhTW", function() {
    return 0, _indexJsDefault92.default;
});
var _indexJs = require("./af/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./ar/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./ar-DZ/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./ar-EG/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./ar-MA/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
var _indexJs5 = require("./ar-SA/index.js");
var _indexJsDefault5 = parcelHelpers.interopDefault(_indexJs5);
var _indexJs6 = require("./ar-TN/index.js");
var _indexJsDefault6 = parcelHelpers.interopDefault(_indexJs6);
var _indexJs7 = require("./az/index.js");
var _indexJsDefault7 = parcelHelpers.interopDefault(_indexJs7);
var _indexJs8 = require("./be/index.js");
var _indexJsDefault8 = parcelHelpers.interopDefault(_indexJs8);
var _indexJs9 = require("./be-tarask/index.js");
var _indexJsDefault9 = parcelHelpers.interopDefault(_indexJs9);
var _indexJs10 = require("./bg/index.js");
var _indexJsDefault10 = parcelHelpers.interopDefault(_indexJs10);
var _indexJs11 = require("./bn/index.js");
var _indexJsDefault11 = parcelHelpers.interopDefault(_indexJs11);
var _indexJs12 = require("./bs/index.js");
var _indexJsDefault12 = parcelHelpers.interopDefault(_indexJs12);
var _indexJs13 = require("./ca/index.js");
var _indexJsDefault13 = parcelHelpers.interopDefault(_indexJs13);
var _indexJs14 = require("./cs/index.js");
var _indexJsDefault14 = parcelHelpers.interopDefault(_indexJs14);
var _indexJs15 = require("./cy/index.js");
var _indexJsDefault15 = parcelHelpers.interopDefault(_indexJs15);
var _indexJs16 = require("./da/index.js");
var _indexJsDefault16 = parcelHelpers.interopDefault(_indexJs16);
var _indexJs17 = require("./de/index.js");
var _indexJsDefault17 = parcelHelpers.interopDefault(_indexJs17);
var _indexJs18 = require("./de-AT/index.js");
var _indexJsDefault18 = parcelHelpers.interopDefault(_indexJs18);
var _indexJs19 = require("./el/index.js");
var _indexJsDefault19 = parcelHelpers.interopDefault(_indexJs19);
var _indexJs20 = require("./en-AU/index.js");
var _indexJsDefault20 = parcelHelpers.interopDefault(_indexJs20);
var _indexJs21 = require("./en-CA/index.js");
var _indexJsDefault21 = parcelHelpers.interopDefault(_indexJs21);
var _indexJs22 = require("./en-GB/index.js");
var _indexJsDefault22 = parcelHelpers.interopDefault(_indexJs22);
var _indexJs23 = require("./en-IE/index.js");
var _indexJsDefault23 = parcelHelpers.interopDefault(_indexJs23);
var _indexJs24 = require("./en-IN/index.js");
var _indexJsDefault24 = parcelHelpers.interopDefault(_indexJs24);
var _indexJs25 = require("./en-NZ/index.js");
var _indexJsDefault25 = parcelHelpers.interopDefault(_indexJs25);
var _indexJs26 = require("./en-US/index.js");
var _indexJsDefault26 = parcelHelpers.interopDefault(_indexJs26);
var _indexJs27 = require("./en-ZA/index.js");
var _indexJsDefault27 = parcelHelpers.interopDefault(_indexJs27);
var _indexJs28 = require("./eo/index.js");
var _indexJsDefault28 = parcelHelpers.interopDefault(_indexJs28);
var _indexJs29 = require("./es/index.js");
var _indexJsDefault29 = parcelHelpers.interopDefault(_indexJs29);
var _indexJs30 = require("./et/index.js");
var _indexJsDefault30 = parcelHelpers.interopDefault(_indexJs30);
var _indexJs31 = require("./eu/index.js");
var _indexJsDefault31 = parcelHelpers.interopDefault(_indexJs31);
var _indexJs32 = require("./fa-IR/index.js");
var _indexJsDefault32 = parcelHelpers.interopDefault(_indexJs32);
var _indexJs33 = require("./fi/index.js");
var _indexJsDefault33 = parcelHelpers.interopDefault(_indexJs33);
var _indexJs34 = require("./fr/index.js");
var _indexJsDefault34 = parcelHelpers.interopDefault(_indexJs34);
var _indexJs35 = require("./fr-CA/index.js");
var _indexJsDefault35 = parcelHelpers.interopDefault(_indexJs35);
var _indexJs36 = require("./fr-CH/index.js");
var _indexJsDefault36 = parcelHelpers.interopDefault(_indexJs36);
var _indexJs37 = require("./fy/index.js");
var _indexJsDefault37 = parcelHelpers.interopDefault(_indexJs37);
var _indexJs38 = require("./gd/index.js");
var _indexJsDefault38 = parcelHelpers.interopDefault(_indexJs38);
var _indexJs39 = require("./gl/index.js");
var _indexJsDefault39 = parcelHelpers.interopDefault(_indexJs39);
var _indexJs40 = require("./gu/index.js");
var _indexJsDefault40 = parcelHelpers.interopDefault(_indexJs40);
var _indexJs41 = require("./he/index.js");
var _indexJsDefault41 = parcelHelpers.interopDefault(_indexJs41);
var _indexJs42 = require("./hi/index.js");
var _indexJsDefault42 = parcelHelpers.interopDefault(_indexJs42);
var _indexJs43 = require("./hr/index.js");
var _indexJsDefault43 = parcelHelpers.interopDefault(_indexJs43);
var _indexJs44 = require("./ht/index.js");
var _indexJsDefault44 = parcelHelpers.interopDefault(_indexJs44);
var _indexJs45 = require("./hu/index.js");
var _indexJsDefault45 = parcelHelpers.interopDefault(_indexJs45);
var _indexJs46 = require("./hy/index.js");
var _indexJsDefault46 = parcelHelpers.interopDefault(_indexJs46);
var _indexJs47 = require("./id/index.js");
var _indexJsDefault47 = parcelHelpers.interopDefault(_indexJs47);
var _indexJs48 = require("./is/index.js");
var _indexJsDefault48 = parcelHelpers.interopDefault(_indexJs48);
var _indexJs49 = require("./it/index.js");
var _indexJsDefault49 = parcelHelpers.interopDefault(_indexJs49);
var _indexJs50 = require("./it-CH/index.js");
var _indexJsDefault50 = parcelHelpers.interopDefault(_indexJs50);
var _indexJs51 = require("./ja/index.js");
var _indexJsDefault51 = parcelHelpers.interopDefault(_indexJs51);
var _indexJs52 = require("./ja-Hira/index.js");
var _indexJsDefault52 = parcelHelpers.interopDefault(_indexJs52);
var _indexJs53 = require("./ka/index.js");
var _indexJsDefault53 = parcelHelpers.interopDefault(_indexJs53);
var _indexJs54 = require("./kk/index.js");
var _indexJsDefault54 = parcelHelpers.interopDefault(_indexJs54);
var _indexJs55 = require("./km/index.js");
var _indexJsDefault55 = parcelHelpers.interopDefault(_indexJs55);
var _indexJs56 = require("./kn/index.js");
var _indexJsDefault56 = parcelHelpers.interopDefault(_indexJs56);
var _indexJs57 = require("./ko/index.js");
var _indexJsDefault57 = parcelHelpers.interopDefault(_indexJs57);
var _indexJs58 = require("./lb/index.js");
var _indexJsDefault58 = parcelHelpers.interopDefault(_indexJs58);
var _indexJs59 = require("./lt/index.js");
var _indexJsDefault59 = parcelHelpers.interopDefault(_indexJs59);
var _indexJs60 = require("./lv/index.js");
var _indexJsDefault60 = parcelHelpers.interopDefault(_indexJs60);
var _indexJs61 = require("./mk/index.js");
var _indexJsDefault61 = parcelHelpers.interopDefault(_indexJs61);
var _indexJs62 = require("./mn/index.js");
var _indexJsDefault62 = parcelHelpers.interopDefault(_indexJs62);
var _indexJs63 = require("./ms/index.js");
var _indexJsDefault63 = parcelHelpers.interopDefault(_indexJs63);
var _indexJs64 = require("./mt/index.js");
var _indexJsDefault64 = parcelHelpers.interopDefault(_indexJs64);
var _indexJs65 = require("./nb/index.js");
var _indexJsDefault65 = parcelHelpers.interopDefault(_indexJs65);
var _indexJs66 = require("./nl/index.js");
var _indexJsDefault66 = parcelHelpers.interopDefault(_indexJs66);
var _indexJs67 = require("./nl-BE/index.js");
var _indexJsDefault67 = parcelHelpers.interopDefault(_indexJs67);
var _indexJs68 = require("./nn/index.js");
var _indexJsDefault68 = parcelHelpers.interopDefault(_indexJs68);
var _indexJs69 = require("./oc/index.js");
var _indexJsDefault69 = parcelHelpers.interopDefault(_indexJs69);
var _indexJs70 = require("./pl/index.js");
var _indexJsDefault70 = parcelHelpers.interopDefault(_indexJs70);
var _indexJs71 = require("./pt/index.js");
var _indexJsDefault71 = parcelHelpers.interopDefault(_indexJs71);
var _indexJs72 = require("./pt-BR/index.js");
var _indexJsDefault72 = parcelHelpers.interopDefault(_indexJs72);
var _indexJs73 = require("./ro/index.js");
var _indexJsDefault73 = parcelHelpers.interopDefault(_indexJs73);
var _indexJs74 = require("./ru/index.js");
var _indexJsDefault74 = parcelHelpers.interopDefault(_indexJs74);
var _indexJs75 = require("./sk/index.js");
var _indexJsDefault75 = parcelHelpers.interopDefault(_indexJs75);
var _indexJs76 = require("./sl/index.js");
var _indexJsDefault76 = parcelHelpers.interopDefault(_indexJs76);
var _indexJs77 = require("./sq/index.js");
var _indexJsDefault77 = parcelHelpers.interopDefault(_indexJs77);
var _indexJs78 = require("./sr/index.js");
var _indexJsDefault78 = parcelHelpers.interopDefault(_indexJs78);
var _indexJs79 = require("./sr-Latn/index.js");
var _indexJsDefault79 = parcelHelpers.interopDefault(_indexJs79);
var _indexJs80 = require("./sv/index.js");
var _indexJsDefault80 = parcelHelpers.interopDefault(_indexJs80);
var _indexJs81 = require("./ta/index.js");
var _indexJsDefault81 = parcelHelpers.interopDefault(_indexJs81);
var _indexJs82 = require("./te/index.js");
var _indexJsDefault82 = parcelHelpers.interopDefault(_indexJs82);
var _indexJs83 = require("./th/index.js");
var _indexJsDefault83 = parcelHelpers.interopDefault(_indexJs83);
var _indexJs84 = require("./tr/index.js");
var _indexJsDefault84 = parcelHelpers.interopDefault(_indexJs84);
var _indexJs85 = require("./ug/index.js");
var _indexJsDefault85 = parcelHelpers.interopDefault(_indexJs85);
var _indexJs86 = require("./uk/index.js");
var _indexJsDefault86 = parcelHelpers.interopDefault(_indexJs86);
var _indexJs87 = require("./uz/index.js");
var _indexJsDefault87 = parcelHelpers.interopDefault(_indexJs87);
var _indexJs88 = require("./uz-Cyrl/index.js");
var _indexJsDefault88 = parcelHelpers.interopDefault(_indexJs88);
var _indexJs89 = require("./vi/index.js");
var _indexJsDefault89 = parcelHelpers.interopDefault(_indexJs89);
var _indexJs90 = require("./zh-CN/index.js");
var _indexJsDefault90 = parcelHelpers.interopDefault(_indexJs90);
var _indexJs91 = require("./zh-HK/index.js");
var _indexJsDefault91 = parcelHelpers.interopDefault(_indexJs91);
var _indexJs92 = require("./zh-TW/index.js");
var _indexJsDefault92 = parcelHelpers.interopDefault(_indexJs92);

},{"./af/index.js":false,"./ar/index.js":false,"./ar-DZ/index.js":false,"./ar-EG/index.js":false,"./ar-MA/index.js":false,"./ar-SA/index.js":false,"./ar-TN/index.js":false,"./az/index.js":false,"./be/index.js":false,"./be-tarask/index.js":false,"./bg/index.js":false,"./bn/index.js":false,"./bs/index.js":false,"./ca/index.js":false,"./cs/index.js":false,"./cy/index.js":false,"./da/index.js":false,"./de/index.js":false,"./de-AT/index.js":false,"./el/index.js":false,"./en-AU/index.js":false,"./en-CA/index.js":false,"./en-GB/index.js":false,"./en-IE/index.js":false,"./en-IN/index.js":false,"./en-NZ/index.js":false,"./en-US/index.js":false,"./en-ZA/index.js":false,"./eo/index.js":false,"./es/index.js":false,"./et/index.js":false,"./eu/index.js":false,"./fa-IR/index.js":false,"./fi/index.js":false,"./fr/index.js":"8V8Gz","./fr-CA/index.js":false,"./fr-CH/index.js":false,"./fy/index.js":false,"./gd/index.js":false,"./gl/index.js":false,"./gu/index.js":false,"./he/index.js":false,"./hi/index.js":false,"./hr/index.js":false,"./ht/index.js":false,"./hu/index.js":false,"./hy/index.js":false,"./id/index.js":false,"./is/index.js":false,"./it/index.js":false,"./it-CH/index.js":false,"./ja/index.js":false,"./ja-Hira/index.js":false,"./ka/index.js":false,"./kk/index.js":false,"./km/index.js":false,"./kn/index.js":false,"./ko/index.js":false,"./lb/index.js":false,"./lt/index.js":false,"./lv/index.js":false,"./mk/index.js":false,"./mn/index.js":false,"./ms/index.js":false,"./mt/index.js":false,"./nb/index.js":false,"./nl/index.js":false,"./nl-BE/index.js":false,"./nn/index.js":false,"./oc/index.js":false,"./pl/index.js":false,"./pt/index.js":false,"./pt-BR/index.js":false,"./ro/index.js":false,"./ru/index.js":false,"./sk/index.js":false,"./sl/index.js":false,"./sq/index.js":false,"./sr/index.js":false,"./sr-Latn/index.js":false,"./sv/index.js":false,"./ta/index.js":false,"./te/index.js":false,"./th/index.js":false,"./tr/index.js":false,"./ug/index.js":false,"./uk/index.js":false,"./uz/index.js":false,"./uz-Cyrl/index.js":false,"./vi/index.js":false,"./zh-CN/index.js":false,"./zh-HK/index.js":false,"./zh-TW/index.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8V8Gz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./_lib/formatDistance/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./_lib/formatLong/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./_lib/formatRelative/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./_lib/localize/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./_lib/match/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
/**
 * @type {Locale}
 * @category Locales
 * @summary French locale.
 * @language French
 * @iso-639-2 fra
 * @author Jean Dupouy [@izeau]{@link https://github.com/izeau}
 * @author François B [@fbonzon]{@link https://github.com/fbonzon}
 */ var locale = {
    code: 'fr',
    formatDistance: (0, _indexJsDefault.default),
    formatLong: (0, _indexJsDefault1.default),
    formatRelative: (0, _indexJsDefault2.default),
    localize: (0, _indexJsDefault3.default),
    match: (0, _indexJsDefault4.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
exports.default = locale;

},{"./_lib/formatDistance/index.js":"fnNyk","./_lib/formatLong/index.js":"bIPY4","./_lib/formatRelative/index.js":"5ZYjg","./_lib/localize/index.js":"3ONeA","./_lib/match/index.js":"eTCOm","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"fnNyk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatDistanceLocale = {
    lessThanXSeconds: {
        one: "moins d\u2019une seconde",
        other: 'moins de {{count}} secondes'
    },
    xSeconds: {
        one: '1 seconde',
        other: '{{count}} secondes'
    },
    halfAMinute: '30 secondes',
    lessThanXMinutes: {
        one: "moins d\u2019une minute",
        other: 'moins de {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'environ 1 heure',
        other: 'environ {{count}} heures'
    },
    xHours: {
        one: '1 heure',
        other: '{{count}} heures'
    },
    xDays: {
        one: '1 jour',
        other: '{{count}} jours'
    },
    aboutXWeeks: {
        one: 'environ 1 semaine',
        other: 'environ {{count}} semaines'
    },
    xWeeks: {
        one: '1 semaine',
        other: '{{count}} semaines'
    },
    aboutXMonths: {
        one: 'environ 1 mois',
        other: 'environ {{count}} mois'
    },
    xMonths: {
        one: '1 mois',
        other: '{{count}} mois'
    },
    aboutXYears: {
        one: 'environ 1 an',
        other: 'environ {{count}} ans'
    },
    xYears: {
        one: '1 an',
        other: '{{count}} ans'
    },
    overXYears: {
        one: "plus d\u2019un an",
        other: 'plus de {{count}} ans'
    },
    almostXYears: {
        one: "presqu\u2019un an",
        other: 'presque {{count}} ans'
    }
};
var formatDistance = function formatDistance(token, count, options) {
    var result;
    var form = formatDistanceLocale[token];
    if (typeof form === 'string') result = form;
    else if (count === 1) result = form.one;
    else result = form.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'dans ' + result;
        else return 'il y a ' + result;
    }
    return result;
};
exports.default = formatDistance;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"bIPY4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildFormatLongFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd/MM/y'
};
var timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var dateTimeFormats = {
    full: "{{date}} '\xe0' {{time}}",
    long: "{{date}} '\xe0' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var formatLong = {
    date: (0, _indexJsDefault.default)({
        formats: dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, _indexJsDefault.default)({
        formats: timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, _indexJsDefault.default)({
        formats: dateTimeFormats,
        defaultWidth: 'full'
    })
};
exports.default = formatLong;

},{"../../../_lib/buildFormatLongFn/index.js":"xh7vF","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5ZYjg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var formatRelativeLocale = {
    lastWeek: "eeee 'dernier \xe0' p",
    yesterday: "'hier \xe0' p",
    today: "'aujourd\u2019hui \xe0' p",
    tomorrow: "'demain \xe0' p'",
    nextWeek: "eeee 'prochain \xe0' p",
    other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
};
exports.default = formatRelative;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3ONeA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildLocalizeFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var eraValues = {
    narrow: [
        'av. J.-C',
        'ap. J.-C'
    ],
    abbreviated: [
        'av. J.-C',
        'ap. J.-C'
    ],
    wide: [
        "avant J\xe9sus-Christ",
        "apr\xe8s J\xe9sus-Christ"
    ]
};
var quarterValues = {
    narrow: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    abbreviated: [
        '1er trim.',
        "2\xe8me trim.",
        "3\xe8me trim.",
        "4\xe8me trim."
    ],
    wide: [
        '1er trimestre',
        "2\xe8me trimestre",
        "3\xe8me trimestre",
        "4\xe8me trimestre"
    ]
};
var monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'janv.',
        "f\xe9vr.",
        'mars',
        'avr.',
        'mai',
        'juin',
        'juil.',
        "ao\xfbt",
        'sept.',
        'oct.',
        'nov.',
        "d\xe9c."
    ],
    wide: [
        'janvier',
        "f\xe9vrier",
        'mars',
        'avril',
        'mai',
        'juin',
        'juillet',
        "ao\xfbt",
        'septembre',
        'octobre',
        'novembre',
        "d\xe9cembre"
    ]
};
var dayValues = {
    narrow: [
        'D',
        'L',
        'M',
        'M',
        'J',
        'V',
        'S'
    ],
    short: [
        'di',
        'lu',
        'ma',
        'me',
        'je',
        've',
        'sa'
    ],
    abbreviated: [
        'dim.',
        'lun.',
        'mar.',
        'mer.',
        'jeu.',
        'ven.',
        'sam.'
    ],
    wide: [
        'dimanche',
        'lundi',
        'mardi',
        'mercredi',
        'jeudi',
        'vendredi',
        'samedi'
    ]
};
var dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'minuit',
        noon: 'midi',
        morning: 'mat.',
        afternoon: 'ap.m.',
        evening: 'soir',
        night: 'mat.'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'minuit',
        noon: 'midi',
        morning: 'matin',
        afternoon: "apr\xe8s-midi",
        evening: 'soir',
        night: 'matin'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'minuit',
        noon: 'midi',
        morning: 'du matin',
        afternoon: "de l\u2019apr\xe8s-midi",
        evening: 'du soir',
        night: 'du matin'
    }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    if (number === 0) return '0';
    var feminineUnits = [
        'year',
        'week',
        'hour',
        'minute',
        'second'
    ];
    var suffix;
    if (number === 1) suffix = unit && feminineUnits.includes(unit) ? "\xe8re" : 'er';
    else suffix = "\xe8me";
    return number + suffix;
};
var localize = {
    ordinalNumber: ordinalNumber,
    era: (0, _indexJsDefault.default)({
        values: eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, _indexJsDefault.default)({
        values: quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        values: monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, _indexJsDefault.default)({
        values: dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        values: dayPeriodValues,
        defaultWidth: 'wide'
    })
};
exports.default = localize;

},{"../../../_lib/buildLocalizeFn/index.js":"5bKyZ","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"eTCOm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../../../_lib/buildMatchFn/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../../../_lib/buildMatchPatternFn/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var matchOrdinalNumberPattern = /^(\d+)(ième|ère|ème|er|e)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
    narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
    abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
    wide: /^(avant Jésus-Christ|après Jésus-Christ)/i
};
var parseEraPatterns = {
    any: [
        /^av/i,
        /^ap/i
    ]
};
var matchQuarterPatterns = {
    narrow: /^T?[1234]/i,
    abbreviated: /^[1234](er|ème|e)? trim\.?/i,
    wide: /^[1234](er|ème|e)? trimestre/i
};
var parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
    wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
};
var parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^av/i,
        /^ma/i,
        /^juin/i,
        /^juil/i,
        /^ao/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var matchDayPatterns = {
    narrow: /^[lmjvsd]/i,
    short: /^(di|lu|ma|me|je|ve|sa)/i,
    abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
    wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
};
var parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^di/i,
        /^lu/i,
        /^ma/i,
        /^me/i,
        /^je/i,
        /^ve/i,
        /^sa/i
    ]
};
var matchDayPeriodPatterns = {
    narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
    any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
};
var parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^min/i,
        noon: /^mid/i,
        morning: /mat/i,
        afternoon: /ap/i,
        evening: /soir/i,
        night: /nuit/i
    }
};
var match = {
    ordinalNumber: (0, _indexJsDefault1.default)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value);
        }
    }),
    era: (0, _indexJsDefault.default)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, _indexJsDefault.default)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, _indexJsDefault.default)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, _indexJsDefault.default)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
exports.default = match;

},{"../../../_lib/buildMatchFn/index.js":"iGdRV","../../../_lib/buildMatchPatternFn/index.js":"6eYoV","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6cTOl":[function(require,module,exports,__globalThis) {
// This file is generated automatically by `scripts/build/indices.ts`. Please, don't change it.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "add", function() {
    return 0, _indexJsDefault.default;
});
parcelHelpers.export(exports, "addBusinessDays", function() {
    return 0, _indexJsDefault1.default;
});
parcelHelpers.export(exports, "addDays", function() {
    return 0, _indexJsDefault2.default;
});
parcelHelpers.export(exports, "addHours", function() {
    return 0, _indexJsDefault3.default;
});
parcelHelpers.export(exports, "addISOWeekYears", function() {
    return 0, _indexJsDefault4.default;
});
parcelHelpers.export(exports, "addMilliseconds", function() {
    return 0, _indexJsDefault5.default;
});
parcelHelpers.export(exports, "addMinutes", function() {
    return 0, _indexJsDefault6.default;
});
parcelHelpers.export(exports, "addMonths", function() {
    return 0, _indexJsDefault7.default;
});
parcelHelpers.export(exports, "addQuarters", function() {
    return 0, _indexJsDefault8.default;
});
parcelHelpers.export(exports, "addSeconds", function() {
    return 0, _indexJsDefault9.default;
});
parcelHelpers.export(exports, "addWeeks", function() {
    return 0, _indexJsDefault10.default;
});
parcelHelpers.export(exports, "addYears", function() {
    return 0, _indexJsDefault11.default;
});
parcelHelpers.export(exports, "areIntervalsOverlapping", function() {
    return 0, _indexJsDefault12.default;
});
parcelHelpers.export(exports, "clamp", function() {
    return 0, _indexJsDefault13.default;
});
parcelHelpers.export(exports, "closestIndexTo", function() {
    return 0, _indexJsDefault14.default;
});
parcelHelpers.export(exports, "closestTo", function() {
    return 0, _indexJsDefault15.default;
});
parcelHelpers.export(exports, "compareAsc", function() {
    return 0, _indexJsDefault16.default;
});
parcelHelpers.export(exports, "compareDesc", function() {
    return 0, _indexJsDefault17.default;
});
parcelHelpers.export(exports, "daysToWeeks", function() {
    return 0, _indexJsDefault18.default;
});
parcelHelpers.export(exports, "differenceInBusinessDays", function() {
    return 0, _indexJsDefault19.default;
});
parcelHelpers.export(exports, "differenceInCalendarDays", function() {
    return 0, _indexJsDefault20.default;
});
parcelHelpers.export(exports, "differenceInCalendarISOWeekYears", function() {
    return 0, _indexJsDefault21.default;
});
parcelHelpers.export(exports, "differenceInCalendarISOWeeks", function() {
    return 0, _indexJsDefault22.default;
});
parcelHelpers.export(exports, "differenceInCalendarMonths", function() {
    return 0, _indexJsDefault23.default;
});
parcelHelpers.export(exports, "differenceInCalendarQuarters", function() {
    return 0, _indexJsDefault24.default;
});
parcelHelpers.export(exports, "differenceInCalendarWeeks", function() {
    return 0, _indexJsDefault25.default;
});
parcelHelpers.export(exports, "differenceInCalendarYears", function() {
    return 0, _indexJsDefault26.default;
});
parcelHelpers.export(exports, "differenceInDays", function() {
    return 0, _indexJsDefault27.default;
});
parcelHelpers.export(exports, "differenceInHours", function() {
    return 0, _indexJsDefault28.default;
});
parcelHelpers.export(exports, "differenceInISOWeekYears", function() {
    return 0, _indexJsDefault29.default;
});
parcelHelpers.export(exports, "differenceInMilliseconds", function() {
    return 0, _indexJsDefault30.default;
});
parcelHelpers.export(exports, "differenceInMinutes", function() {
    return 0, _indexJsDefault31.default;
});
parcelHelpers.export(exports, "differenceInMonths", function() {
    return 0, _indexJsDefault32.default;
});
parcelHelpers.export(exports, "differenceInQuarters", function() {
    return 0, _indexJsDefault33.default;
});
parcelHelpers.export(exports, "differenceInSeconds", function() {
    return 0, _indexJsDefault34.default;
});
parcelHelpers.export(exports, "differenceInWeeks", function() {
    return 0, _indexJsDefault35.default;
});
parcelHelpers.export(exports, "differenceInYears", function() {
    return 0, _indexJsDefault36.default;
});
parcelHelpers.export(exports, "eachDayOfInterval", function() {
    return 0, _indexJsDefault37.default;
});
parcelHelpers.export(exports, "eachHourOfInterval", function() {
    return 0, _indexJsDefault38.default;
});
parcelHelpers.export(exports, "eachMinuteOfInterval", function() {
    return 0, _indexJsDefault39.default;
});
parcelHelpers.export(exports, "eachMonthOfInterval", function() {
    return 0, _indexJsDefault40.default;
});
parcelHelpers.export(exports, "eachQuarterOfInterval", function() {
    return 0, _indexJsDefault41.default;
});
parcelHelpers.export(exports, "eachWeekOfInterval", function() {
    return 0, _indexJsDefault42.default;
});
parcelHelpers.export(exports, "eachWeekendOfInterval", function() {
    return 0, _indexJsDefault43.default;
});
parcelHelpers.export(exports, "eachWeekendOfMonth", function() {
    return 0, _indexJsDefault44.default;
});
parcelHelpers.export(exports, "eachWeekendOfYear", function() {
    return 0, _indexJsDefault45.default;
});
parcelHelpers.export(exports, "eachYearOfInterval", function() {
    return 0, _indexJsDefault46.default;
});
parcelHelpers.export(exports, "endOfDay", function() {
    return 0, _indexJsDefault47.default;
});
parcelHelpers.export(exports, "endOfDecade", function() {
    return 0, _indexJsDefault48.default;
});
parcelHelpers.export(exports, "endOfHour", function() {
    return 0, _indexJsDefault49.default;
});
parcelHelpers.export(exports, "endOfISOWeek", function() {
    return 0, _indexJsDefault50.default;
});
parcelHelpers.export(exports, "endOfISOWeekYear", function() {
    return 0, _indexJsDefault51.default;
});
parcelHelpers.export(exports, "endOfMinute", function() {
    return 0, _indexJsDefault52.default;
});
parcelHelpers.export(exports, "endOfMonth", function() {
    return 0, _indexJsDefault53.default;
});
parcelHelpers.export(exports, "endOfQuarter", function() {
    return 0, _indexJsDefault54.default;
});
parcelHelpers.export(exports, "endOfSecond", function() {
    return 0, _indexJsDefault55.default;
});
parcelHelpers.export(exports, "endOfToday", function() {
    return 0, _indexJsDefault56.default;
});
parcelHelpers.export(exports, "endOfTomorrow", function() {
    return 0, _indexJsDefault57.default;
});
parcelHelpers.export(exports, "endOfWeek", function() {
    return 0, _indexJsDefault58.default;
});
parcelHelpers.export(exports, "endOfYear", function() {
    return 0, _indexJsDefault59.default;
});
parcelHelpers.export(exports, "endOfYesterday", function() {
    return 0, _indexJsDefault60.default;
});
parcelHelpers.export(exports, "format", function() {
    return 0, _indexJsDefault61.default;
});
parcelHelpers.export(exports, "formatDistance", function() {
    return 0, _indexJsDefault62.default;
});
parcelHelpers.export(exports, "formatDistanceStrict", function() {
    return 0, _indexJsDefault63.default;
});
parcelHelpers.export(exports, "formatDistanceToNow", function() {
    return 0, _indexJsDefault64.default;
});
parcelHelpers.export(exports, "formatDistanceToNowStrict", function() {
    return 0, _indexJsDefault65.default;
});
parcelHelpers.export(exports, "formatDuration", function() {
    return 0, _indexJsDefault66.default;
});
parcelHelpers.export(exports, "formatISO", function() {
    return 0, _indexJsDefault67.default;
});
parcelHelpers.export(exports, "formatISO9075", function() {
    return 0, _indexJsDefault68.default;
});
parcelHelpers.export(exports, "formatISODuration", function() {
    return 0, _indexJsDefault69.default;
});
parcelHelpers.export(exports, "formatRFC3339", function() {
    return 0, _indexJsDefault70.default;
});
parcelHelpers.export(exports, "formatRFC7231", function() {
    return 0, _indexJsDefault71.default;
});
parcelHelpers.export(exports, "formatRelative", function() {
    return 0, _indexJsDefault72.default;
});
parcelHelpers.export(exports, "fromUnixTime", function() {
    return 0, _indexJsDefault73.default;
});
parcelHelpers.export(exports, "getDate", function() {
    return 0, _indexJsDefault74.default;
});
parcelHelpers.export(exports, "getDay", function() {
    return 0, _indexJsDefault75.default;
});
parcelHelpers.export(exports, "getDayOfYear", function() {
    return 0, _indexJsDefault76.default;
});
parcelHelpers.export(exports, "getDaysInMonth", function() {
    return 0, _indexJsDefault77.default;
});
parcelHelpers.export(exports, "getDaysInYear", function() {
    return 0, _indexJsDefault78.default;
});
parcelHelpers.export(exports, "getDecade", function() {
    return 0, _indexJsDefault79.default;
});
parcelHelpers.export(exports, "getDefaultOptions", function() {
    return 0, _indexJsDefault80.default;
});
parcelHelpers.export(exports, "getHours", function() {
    return 0, _indexJsDefault81.default;
});
parcelHelpers.export(exports, "getISODay", function() {
    return 0, _indexJsDefault82.default;
});
parcelHelpers.export(exports, "getISOWeek", function() {
    return 0, _indexJsDefault83.default;
});
parcelHelpers.export(exports, "getISOWeekYear", function() {
    return 0, _indexJsDefault84.default;
});
parcelHelpers.export(exports, "getISOWeeksInYear", function() {
    return 0, _indexJsDefault85.default;
});
parcelHelpers.export(exports, "getMilliseconds", function() {
    return 0, _indexJsDefault86.default;
});
parcelHelpers.export(exports, "getMinutes", function() {
    return 0, _indexJsDefault87.default;
});
parcelHelpers.export(exports, "getMonth", function() {
    return 0, _indexJsDefault88.default;
});
parcelHelpers.export(exports, "getOverlappingDaysInIntervals", function() {
    return 0, _indexJsDefault89.default;
});
parcelHelpers.export(exports, "getQuarter", function() {
    return 0, _indexJsDefault90.default;
});
parcelHelpers.export(exports, "getSeconds", function() {
    return 0, _indexJsDefault91.default;
});
parcelHelpers.export(exports, "getTime", function() {
    return 0, _indexJsDefault92.default;
});
parcelHelpers.export(exports, "getUnixTime", function() {
    return 0, _indexJsDefault93.default;
});
parcelHelpers.export(exports, "getWeek", function() {
    return 0, _indexJsDefault94.default;
});
parcelHelpers.export(exports, "getWeekOfMonth", function() {
    return 0, _indexJsDefault95.default;
});
parcelHelpers.export(exports, "getWeekYear", function() {
    return 0, _indexJsDefault96.default;
});
parcelHelpers.export(exports, "getWeeksInMonth", function() {
    return 0, _indexJsDefault97.default;
});
parcelHelpers.export(exports, "getYear", function() {
    return 0, _indexJsDefault98.default;
});
parcelHelpers.export(exports, "hoursToMilliseconds", function() {
    return 0, _indexJsDefault99.default;
});
parcelHelpers.export(exports, "hoursToMinutes", function() {
    return 0, _indexJsDefault100.default;
});
parcelHelpers.export(exports, "hoursToSeconds", function() {
    return 0, _indexJsDefault101.default;
});
parcelHelpers.export(exports, "intervalToDuration", function() {
    return 0, _indexJsDefault102.default;
});
parcelHelpers.export(exports, "intlFormat", function() {
    return 0, _indexJsDefault103.default;
});
parcelHelpers.export(exports, "intlFormatDistance", function() {
    return 0, _indexJsDefault104.default;
});
parcelHelpers.export(exports, "isAfter", function() {
    return 0, _indexJsDefault105.default;
});
parcelHelpers.export(exports, "isBefore", function() {
    return 0, _indexJsDefault106.default;
});
parcelHelpers.export(exports, "isDate", function() {
    return 0, _indexJsDefault107.default;
});
parcelHelpers.export(exports, "isEqual", function() {
    return 0, _indexJsDefault108.default;
});
parcelHelpers.export(exports, "isExists", function() {
    return 0, _indexJsDefault109.default;
});
parcelHelpers.export(exports, "isFirstDayOfMonth", function() {
    return 0, _indexJsDefault110.default;
});
parcelHelpers.export(exports, "isFriday", function() {
    return 0, _indexJsDefault111.default;
});
parcelHelpers.export(exports, "isFuture", function() {
    return 0, _indexJsDefault112.default;
});
parcelHelpers.export(exports, "isLastDayOfMonth", function() {
    return 0, _indexJsDefault113.default;
});
parcelHelpers.export(exports, "isLeapYear", function() {
    return 0, _indexJsDefault114.default;
});
parcelHelpers.export(exports, "isMatch", function() {
    return 0, _indexJsDefault115.default;
});
parcelHelpers.export(exports, "isMonday", function() {
    return 0, _indexJsDefault116.default;
});
parcelHelpers.export(exports, "isPast", function() {
    return 0, _indexJsDefault117.default;
});
parcelHelpers.export(exports, "isSameDay", function() {
    return 0, _indexJsDefault118.default;
});
parcelHelpers.export(exports, "isSameHour", function() {
    return 0, _indexJsDefault119.default;
});
parcelHelpers.export(exports, "isSameISOWeek", function() {
    return 0, _indexJsDefault120.default;
});
parcelHelpers.export(exports, "isSameISOWeekYear", function() {
    return 0, _indexJsDefault121.default;
});
parcelHelpers.export(exports, "isSameMinute", function() {
    return 0, _indexJsDefault122.default;
});
parcelHelpers.export(exports, "isSameMonth", function() {
    return 0, _indexJsDefault123.default;
});
parcelHelpers.export(exports, "isSameQuarter", function() {
    return 0, _indexJsDefault124.default;
});
parcelHelpers.export(exports, "isSameSecond", function() {
    return 0, _indexJsDefault125.default;
});
parcelHelpers.export(exports, "isSameWeek", function() {
    return 0, _indexJsDefault126.default;
});
parcelHelpers.export(exports, "isSameYear", function() {
    return 0, _indexJsDefault127.default;
});
parcelHelpers.export(exports, "isSaturday", function() {
    return 0, _indexJsDefault128.default;
});
parcelHelpers.export(exports, "isSunday", function() {
    return 0, _indexJsDefault129.default;
});
parcelHelpers.export(exports, "isThisHour", function() {
    return 0, _indexJsDefault130.default;
});
parcelHelpers.export(exports, "isThisISOWeek", function() {
    return 0, _indexJsDefault131.default;
});
parcelHelpers.export(exports, "isThisMinute", function() {
    return 0, _indexJsDefault132.default;
});
parcelHelpers.export(exports, "isThisMonth", function() {
    return 0, _indexJsDefault133.default;
});
parcelHelpers.export(exports, "isThisQuarter", function() {
    return 0, _indexJsDefault134.default;
});
parcelHelpers.export(exports, "isThisSecond", function() {
    return 0, _indexJsDefault135.default;
});
parcelHelpers.export(exports, "isThisWeek", function() {
    return 0, _indexJsDefault136.default;
});
parcelHelpers.export(exports, "isThisYear", function() {
    return 0, _indexJsDefault137.default;
});
parcelHelpers.export(exports, "isThursday", function() {
    return 0, _indexJsDefault138.default;
});
parcelHelpers.export(exports, "isToday", function() {
    return 0, _indexJsDefault139.default;
});
parcelHelpers.export(exports, "isTomorrow", function() {
    return 0, _indexJsDefault140.default;
});
parcelHelpers.export(exports, "isTuesday", function() {
    return 0, _indexJsDefault141.default;
});
parcelHelpers.export(exports, "isValid", function() {
    return 0, _indexJsDefault142.default;
});
parcelHelpers.export(exports, "isWednesday", function() {
    return 0, _indexJsDefault143.default;
});
parcelHelpers.export(exports, "isWeekend", function() {
    return 0, _indexJsDefault144.default;
});
parcelHelpers.export(exports, "isWithinInterval", function() {
    return 0, _indexJsDefault145.default;
});
parcelHelpers.export(exports, "isYesterday", function() {
    return 0, _indexJsDefault146.default;
});
parcelHelpers.export(exports, "lastDayOfDecade", function() {
    return 0, _indexJsDefault147.default;
});
parcelHelpers.export(exports, "lastDayOfISOWeek", function() {
    return 0, _indexJsDefault148.default;
});
parcelHelpers.export(exports, "lastDayOfISOWeekYear", function() {
    return 0, _indexJsDefault149.default;
});
parcelHelpers.export(exports, "lastDayOfMonth", function() {
    return 0, _indexJsDefault150.default;
});
parcelHelpers.export(exports, "lastDayOfQuarter", function() {
    return 0, _indexJsDefault151.default;
});
parcelHelpers.export(exports, "lastDayOfWeek", function() {
    return 0, _indexJsDefault152.default;
});
parcelHelpers.export(exports, "lastDayOfYear", function() {
    return 0, _indexJsDefault153.default;
});
parcelHelpers.export(exports, "lightFormat", function() {
    return 0, _indexJsDefault154.default;
});
parcelHelpers.export(exports, "max", function() {
    return 0, _indexJsDefault155.default;
});
parcelHelpers.export(exports, "milliseconds", function() {
    return 0, _indexJsDefault156.default;
});
parcelHelpers.export(exports, "millisecondsToHours", function() {
    return 0, _indexJsDefault157.default;
});
parcelHelpers.export(exports, "millisecondsToMinutes", function() {
    return 0, _indexJsDefault158.default;
});
parcelHelpers.export(exports, "millisecondsToSeconds", function() {
    return 0, _indexJsDefault159.default;
});
parcelHelpers.export(exports, "min", function() {
    return 0, _indexJsDefault160.default;
});
parcelHelpers.export(exports, "minutesToHours", function() {
    return 0, _indexJsDefault161.default;
});
parcelHelpers.export(exports, "minutesToMilliseconds", function() {
    return 0, _indexJsDefault162.default;
});
parcelHelpers.export(exports, "minutesToSeconds", function() {
    return 0, _indexJsDefault163.default;
});
parcelHelpers.export(exports, "monthsToQuarters", function() {
    return 0, _indexJsDefault164.default;
});
parcelHelpers.export(exports, "monthsToYears", function() {
    return 0, _indexJsDefault165.default;
});
parcelHelpers.export(exports, "nextDay", function() {
    return 0, _indexJsDefault166.default;
});
parcelHelpers.export(exports, "nextFriday", function() {
    return 0, _indexJsDefault167.default;
});
parcelHelpers.export(exports, "nextMonday", function() {
    return 0, _indexJsDefault168.default;
});
parcelHelpers.export(exports, "nextSaturday", function() {
    return 0, _indexJsDefault169.default;
});
parcelHelpers.export(exports, "nextSunday", function() {
    return 0, _indexJsDefault170.default;
});
parcelHelpers.export(exports, "nextThursday", function() {
    return 0, _indexJsDefault171.default;
});
parcelHelpers.export(exports, "nextTuesday", function() {
    return 0, _indexJsDefault172.default;
});
parcelHelpers.export(exports, "nextWednesday", function() {
    return 0, _indexJsDefault173.default;
});
parcelHelpers.export(exports, "parse", function() {
    return 0, _indexJsDefault174.default;
});
parcelHelpers.export(exports, "parseISO", function() {
    return 0, _indexJsDefault175.default;
});
parcelHelpers.export(exports, "parseJSON", function() {
    return 0, _indexJsDefault176.default;
});
parcelHelpers.export(exports, "previousDay", function() {
    return 0, _indexJsDefault177.default;
});
parcelHelpers.export(exports, "previousFriday", function() {
    return 0, _indexJsDefault178.default;
});
parcelHelpers.export(exports, "previousMonday", function() {
    return 0, _indexJsDefault179.default;
});
parcelHelpers.export(exports, "previousSaturday", function() {
    return 0, _indexJsDefault180.default;
});
parcelHelpers.export(exports, "previousSunday", function() {
    return 0, _indexJsDefault181.default;
});
parcelHelpers.export(exports, "previousThursday", function() {
    return 0, _indexJsDefault182.default;
});
parcelHelpers.export(exports, "previousTuesday", function() {
    return 0, _indexJsDefault183.default;
});
parcelHelpers.export(exports, "previousWednesday", function() {
    return 0, _indexJsDefault184.default;
});
parcelHelpers.export(exports, "quartersToMonths", function() {
    return 0, _indexJsDefault185.default;
});
parcelHelpers.export(exports, "quartersToYears", function() {
    return 0, _indexJsDefault186.default;
});
parcelHelpers.export(exports, "roundToNearestMinutes", function() {
    return 0, _indexJsDefault187.default;
});
parcelHelpers.export(exports, "secondsToHours", function() {
    return 0, _indexJsDefault188.default;
});
parcelHelpers.export(exports, "secondsToMilliseconds", function() {
    return 0, _indexJsDefault189.default;
});
parcelHelpers.export(exports, "secondsToMinutes", function() {
    return 0, _indexJsDefault190.default;
});
parcelHelpers.export(exports, "set", function() {
    return 0, _indexJsDefault191.default;
});
parcelHelpers.export(exports, "setDate", function() {
    return 0, _indexJsDefault192.default;
});
parcelHelpers.export(exports, "setDay", function() {
    return 0, _indexJsDefault193.default;
});
parcelHelpers.export(exports, "setDayOfYear", function() {
    return 0, _indexJsDefault194.default;
});
parcelHelpers.export(exports, "setDefaultOptions", function() {
    return 0, _indexJsDefault195.default;
});
parcelHelpers.export(exports, "setHours", function() {
    return 0, _indexJsDefault196.default;
});
parcelHelpers.export(exports, "setISODay", function() {
    return 0, _indexJsDefault197.default;
});
parcelHelpers.export(exports, "setISOWeek", function() {
    return 0, _indexJsDefault198.default;
});
parcelHelpers.export(exports, "setISOWeekYear", function() {
    return 0, _indexJsDefault199.default;
});
parcelHelpers.export(exports, "setMilliseconds", function() {
    return 0, _indexJsDefault200.default;
});
parcelHelpers.export(exports, "setMinutes", function() {
    return 0, _indexJsDefault201.default;
});
parcelHelpers.export(exports, "setMonth", function() {
    return 0, _indexJsDefault202.default;
});
parcelHelpers.export(exports, "setQuarter", function() {
    return 0, _indexJsDefault203.default;
});
parcelHelpers.export(exports, "setSeconds", function() {
    return 0, _indexJsDefault204.default;
});
parcelHelpers.export(exports, "setWeek", function() {
    return 0, _indexJsDefault205.default;
});
parcelHelpers.export(exports, "setWeekYear", function() {
    return 0, _indexJsDefault206.default;
});
parcelHelpers.export(exports, "setYear", function() {
    return 0, _indexJsDefault207.default;
});
parcelHelpers.export(exports, "startOfDay", function() {
    return 0, _indexJsDefault208.default;
});
parcelHelpers.export(exports, "startOfDecade", function() {
    return 0, _indexJsDefault209.default;
});
parcelHelpers.export(exports, "startOfHour", function() {
    return 0, _indexJsDefault210.default;
});
parcelHelpers.export(exports, "startOfISOWeek", function() {
    return 0, _indexJsDefault211.default;
});
parcelHelpers.export(exports, "startOfISOWeekYear", function() {
    return 0, _indexJsDefault212.default;
});
parcelHelpers.export(exports, "startOfMinute", function() {
    return 0, _indexJsDefault213.default;
});
parcelHelpers.export(exports, "startOfMonth", function() {
    return 0, _indexJsDefault214.default;
});
parcelHelpers.export(exports, "startOfQuarter", function() {
    return 0, _indexJsDefault215.default;
});
parcelHelpers.export(exports, "startOfSecond", function() {
    return 0, _indexJsDefault216.default;
});
parcelHelpers.export(exports, "startOfToday", function() {
    return 0, _indexJsDefault217.default;
});
parcelHelpers.export(exports, "startOfTomorrow", function() {
    return 0, _indexJsDefault218.default;
});
parcelHelpers.export(exports, "startOfWeek", function() {
    return 0, _indexJsDefault219.default;
});
parcelHelpers.export(exports, "startOfWeekYear", function() {
    return 0, _indexJsDefault220.default;
});
parcelHelpers.export(exports, "startOfYear", function() {
    return 0, _indexJsDefault221.default;
});
parcelHelpers.export(exports, "startOfYesterday", function() {
    return 0, _indexJsDefault222.default;
});
parcelHelpers.export(exports, "sub", function() {
    return 0, _indexJsDefault223.default;
});
parcelHelpers.export(exports, "subBusinessDays", function() {
    return 0, _indexJsDefault224.default;
});
parcelHelpers.export(exports, "subDays", function() {
    return 0, _indexJsDefault225.default;
});
parcelHelpers.export(exports, "subHours", function() {
    return 0, _indexJsDefault226.default;
});
parcelHelpers.export(exports, "subISOWeekYears", function() {
    return 0, _indexJsDefault227.default;
});
parcelHelpers.export(exports, "subMilliseconds", function() {
    return 0, _indexJsDefault228.default;
});
parcelHelpers.export(exports, "subMinutes", function() {
    return 0, _indexJsDefault229.default;
});
parcelHelpers.export(exports, "subMonths", function() {
    return 0, _indexJsDefault230.default;
});
parcelHelpers.export(exports, "subQuarters", function() {
    return 0, _indexJsDefault231.default;
});
parcelHelpers.export(exports, "subSeconds", function() {
    return 0, _indexJsDefault232.default;
});
parcelHelpers.export(exports, "subWeeks", function() {
    return 0, _indexJsDefault233.default;
});
parcelHelpers.export(exports, "subYears", function() {
    return 0, _indexJsDefault234.default;
});
parcelHelpers.export(exports, "toDate", function() {
    return 0, _indexJsDefault235.default;
});
parcelHelpers.export(exports, "weeksToDays", function() {
    return 0, _indexJsDefault236.default;
});
parcelHelpers.export(exports, "yearsToMonths", function() {
    return 0, _indexJsDefault237.default;
});
parcelHelpers.export(exports, "yearsToQuarters", function() {
    return 0, _indexJsDefault238.default;
});
var _indexJs = require("./add/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("./addBusinessDays/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("./addDays/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("./addHours/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("./addISOWeekYears/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
var _indexJs5 = require("./addMilliseconds/index.js");
var _indexJsDefault5 = parcelHelpers.interopDefault(_indexJs5);
var _indexJs6 = require("./addMinutes/index.js");
var _indexJsDefault6 = parcelHelpers.interopDefault(_indexJs6);
var _indexJs7 = require("./addMonths/index.js");
var _indexJsDefault7 = parcelHelpers.interopDefault(_indexJs7);
var _indexJs8 = require("./addQuarters/index.js");
var _indexJsDefault8 = parcelHelpers.interopDefault(_indexJs8);
var _indexJs9 = require("./addSeconds/index.js");
var _indexJsDefault9 = parcelHelpers.interopDefault(_indexJs9);
var _indexJs10 = require("./addWeeks/index.js");
var _indexJsDefault10 = parcelHelpers.interopDefault(_indexJs10);
var _indexJs11 = require("./addYears/index.js");
var _indexJsDefault11 = parcelHelpers.interopDefault(_indexJs11);
var _indexJs12 = require("./areIntervalsOverlapping/index.js");
var _indexJsDefault12 = parcelHelpers.interopDefault(_indexJs12);
var _indexJs13 = require("./clamp/index.js");
var _indexJsDefault13 = parcelHelpers.interopDefault(_indexJs13);
var _indexJs14 = require("./closestIndexTo/index.js");
var _indexJsDefault14 = parcelHelpers.interopDefault(_indexJs14);
var _indexJs15 = require("./closestTo/index.js");
var _indexJsDefault15 = parcelHelpers.interopDefault(_indexJs15);
var _indexJs16 = require("./compareAsc/index.js");
var _indexJsDefault16 = parcelHelpers.interopDefault(_indexJs16);
var _indexJs17 = require("./compareDesc/index.js");
var _indexJsDefault17 = parcelHelpers.interopDefault(_indexJs17);
var _indexJs18 = require("./daysToWeeks/index.js");
var _indexJsDefault18 = parcelHelpers.interopDefault(_indexJs18);
var _indexJs19 = require("./differenceInBusinessDays/index.js");
var _indexJsDefault19 = parcelHelpers.interopDefault(_indexJs19);
var _indexJs20 = require("./differenceInCalendarDays/index.js");
var _indexJsDefault20 = parcelHelpers.interopDefault(_indexJs20);
var _indexJs21 = require("./differenceInCalendarISOWeekYears/index.js");
var _indexJsDefault21 = parcelHelpers.interopDefault(_indexJs21);
var _indexJs22 = require("./differenceInCalendarISOWeeks/index.js");
var _indexJsDefault22 = parcelHelpers.interopDefault(_indexJs22);
var _indexJs23 = require("./differenceInCalendarMonths/index.js");
var _indexJsDefault23 = parcelHelpers.interopDefault(_indexJs23);
var _indexJs24 = require("./differenceInCalendarQuarters/index.js");
var _indexJsDefault24 = parcelHelpers.interopDefault(_indexJs24);
var _indexJs25 = require("./differenceInCalendarWeeks/index.js");
var _indexJsDefault25 = parcelHelpers.interopDefault(_indexJs25);
var _indexJs26 = require("./differenceInCalendarYears/index.js");
var _indexJsDefault26 = parcelHelpers.interopDefault(_indexJs26);
var _indexJs27 = require("./differenceInDays/index.js");
var _indexJsDefault27 = parcelHelpers.interopDefault(_indexJs27);
var _indexJs28 = require("./differenceInHours/index.js");
var _indexJsDefault28 = parcelHelpers.interopDefault(_indexJs28);
var _indexJs29 = require("./differenceInISOWeekYears/index.js");
var _indexJsDefault29 = parcelHelpers.interopDefault(_indexJs29);
var _indexJs30 = require("./differenceInMilliseconds/index.js");
var _indexJsDefault30 = parcelHelpers.interopDefault(_indexJs30);
var _indexJs31 = require("./differenceInMinutes/index.js");
var _indexJsDefault31 = parcelHelpers.interopDefault(_indexJs31);
var _indexJs32 = require("./differenceInMonths/index.js");
var _indexJsDefault32 = parcelHelpers.interopDefault(_indexJs32);
var _indexJs33 = require("./differenceInQuarters/index.js");
var _indexJsDefault33 = parcelHelpers.interopDefault(_indexJs33);
var _indexJs34 = require("./differenceInSeconds/index.js");
var _indexJsDefault34 = parcelHelpers.interopDefault(_indexJs34);
var _indexJs35 = require("./differenceInWeeks/index.js");
var _indexJsDefault35 = parcelHelpers.interopDefault(_indexJs35);
var _indexJs36 = require("./differenceInYears/index.js");
var _indexJsDefault36 = parcelHelpers.interopDefault(_indexJs36);
var _indexJs37 = require("./eachDayOfInterval/index.js");
var _indexJsDefault37 = parcelHelpers.interopDefault(_indexJs37);
var _indexJs38 = require("./eachHourOfInterval/index.js");
var _indexJsDefault38 = parcelHelpers.interopDefault(_indexJs38);
var _indexJs39 = require("./eachMinuteOfInterval/index.js");
var _indexJsDefault39 = parcelHelpers.interopDefault(_indexJs39);
var _indexJs40 = require("./eachMonthOfInterval/index.js");
var _indexJsDefault40 = parcelHelpers.interopDefault(_indexJs40);
var _indexJs41 = require("./eachQuarterOfInterval/index.js");
var _indexJsDefault41 = parcelHelpers.interopDefault(_indexJs41);
var _indexJs42 = require("./eachWeekOfInterval/index.js");
var _indexJsDefault42 = parcelHelpers.interopDefault(_indexJs42);
var _indexJs43 = require("./eachWeekendOfInterval/index.js");
var _indexJsDefault43 = parcelHelpers.interopDefault(_indexJs43);
var _indexJs44 = require("./eachWeekendOfMonth/index.js");
var _indexJsDefault44 = parcelHelpers.interopDefault(_indexJs44);
var _indexJs45 = require("./eachWeekendOfYear/index.js");
var _indexJsDefault45 = parcelHelpers.interopDefault(_indexJs45);
var _indexJs46 = require("./eachYearOfInterval/index.js");
var _indexJsDefault46 = parcelHelpers.interopDefault(_indexJs46);
var _indexJs47 = require("./endOfDay/index.js");
var _indexJsDefault47 = parcelHelpers.interopDefault(_indexJs47);
var _indexJs48 = require("./endOfDecade/index.js");
var _indexJsDefault48 = parcelHelpers.interopDefault(_indexJs48);
var _indexJs49 = require("./endOfHour/index.js");
var _indexJsDefault49 = parcelHelpers.interopDefault(_indexJs49);
var _indexJs50 = require("./endOfISOWeek/index.js");
var _indexJsDefault50 = parcelHelpers.interopDefault(_indexJs50);
var _indexJs51 = require("./endOfISOWeekYear/index.js");
var _indexJsDefault51 = parcelHelpers.interopDefault(_indexJs51);
var _indexJs52 = require("./endOfMinute/index.js");
var _indexJsDefault52 = parcelHelpers.interopDefault(_indexJs52);
var _indexJs53 = require("./endOfMonth/index.js");
var _indexJsDefault53 = parcelHelpers.interopDefault(_indexJs53);
var _indexJs54 = require("./endOfQuarter/index.js");
var _indexJsDefault54 = parcelHelpers.interopDefault(_indexJs54);
var _indexJs55 = require("./endOfSecond/index.js");
var _indexJsDefault55 = parcelHelpers.interopDefault(_indexJs55);
var _indexJs56 = require("./endOfToday/index.js");
var _indexJsDefault56 = parcelHelpers.interopDefault(_indexJs56);
var _indexJs57 = require("./endOfTomorrow/index.js");
var _indexJsDefault57 = parcelHelpers.interopDefault(_indexJs57);
var _indexJs58 = require("./endOfWeek/index.js");
var _indexJsDefault58 = parcelHelpers.interopDefault(_indexJs58);
var _indexJs59 = require("./endOfYear/index.js");
var _indexJsDefault59 = parcelHelpers.interopDefault(_indexJs59);
var _indexJs60 = require("./endOfYesterday/index.js");
var _indexJsDefault60 = parcelHelpers.interopDefault(_indexJs60);
var _indexJs61 = require("./format/index.js");
var _indexJsDefault61 = parcelHelpers.interopDefault(_indexJs61);
var _indexJs62 = require("./formatDistance/index.js");
var _indexJsDefault62 = parcelHelpers.interopDefault(_indexJs62);
var _indexJs63 = require("./formatDistanceStrict/index.js");
var _indexJsDefault63 = parcelHelpers.interopDefault(_indexJs63);
var _indexJs64 = require("./formatDistanceToNow/index.js");
var _indexJsDefault64 = parcelHelpers.interopDefault(_indexJs64);
var _indexJs65 = require("./formatDistanceToNowStrict/index.js");
var _indexJsDefault65 = parcelHelpers.interopDefault(_indexJs65);
var _indexJs66 = require("./formatDuration/index.js");
var _indexJsDefault66 = parcelHelpers.interopDefault(_indexJs66);
var _indexJs67 = require("./formatISO/index.js");
var _indexJsDefault67 = parcelHelpers.interopDefault(_indexJs67);
var _indexJs68 = require("./formatISO9075/index.js");
var _indexJsDefault68 = parcelHelpers.interopDefault(_indexJs68);
var _indexJs69 = require("./formatISODuration/index.js");
var _indexJsDefault69 = parcelHelpers.interopDefault(_indexJs69);
var _indexJs70 = require("./formatRFC3339/index.js");
var _indexJsDefault70 = parcelHelpers.interopDefault(_indexJs70);
var _indexJs71 = require("./formatRFC7231/index.js");
var _indexJsDefault71 = parcelHelpers.interopDefault(_indexJs71);
var _indexJs72 = require("./formatRelative/index.js");
var _indexJsDefault72 = parcelHelpers.interopDefault(_indexJs72);
var _indexJs73 = require("./fromUnixTime/index.js");
var _indexJsDefault73 = parcelHelpers.interopDefault(_indexJs73);
var _indexJs74 = require("./getDate/index.js");
var _indexJsDefault74 = parcelHelpers.interopDefault(_indexJs74);
var _indexJs75 = require("./getDay/index.js");
var _indexJsDefault75 = parcelHelpers.interopDefault(_indexJs75);
var _indexJs76 = require("./getDayOfYear/index.js");
var _indexJsDefault76 = parcelHelpers.interopDefault(_indexJs76);
var _indexJs77 = require("./getDaysInMonth/index.js");
var _indexJsDefault77 = parcelHelpers.interopDefault(_indexJs77);
var _indexJs78 = require("./getDaysInYear/index.js");
var _indexJsDefault78 = parcelHelpers.interopDefault(_indexJs78);
var _indexJs79 = require("./getDecade/index.js");
var _indexJsDefault79 = parcelHelpers.interopDefault(_indexJs79);
var _indexJs80 = require("./getDefaultOptions/index.js");
var _indexJsDefault80 = parcelHelpers.interopDefault(_indexJs80);
var _indexJs81 = require("./getHours/index.js");
var _indexJsDefault81 = parcelHelpers.interopDefault(_indexJs81);
var _indexJs82 = require("./getISODay/index.js");
var _indexJsDefault82 = parcelHelpers.interopDefault(_indexJs82);
var _indexJs83 = require("./getISOWeek/index.js");
var _indexJsDefault83 = parcelHelpers.interopDefault(_indexJs83);
var _indexJs84 = require("./getISOWeekYear/index.js");
var _indexJsDefault84 = parcelHelpers.interopDefault(_indexJs84);
var _indexJs85 = require("./getISOWeeksInYear/index.js");
var _indexJsDefault85 = parcelHelpers.interopDefault(_indexJs85);
var _indexJs86 = require("./getMilliseconds/index.js");
var _indexJsDefault86 = parcelHelpers.interopDefault(_indexJs86);
var _indexJs87 = require("./getMinutes/index.js");
var _indexJsDefault87 = parcelHelpers.interopDefault(_indexJs87);
var _indexJs88 = require("./getMonth/index.js");
var _indexJsDefault88 = parcelHelpers.interopDefault(_indexJs88);
var _indexJs89 = require("./getOverlappingDaysInIntervals/index.js");
var _indexJsDefault89 = parcelHelpers.interopDefault(_indexJs89);
var _indexJs90 = require("./getQuarter/index.js");
var _indexJsDefault90 = parcelHelpers.interopDefault(_indexJs90);
var _indexJs91 = require("./getSeconds/index.js");
var _indexJsDefault91 = parcelHelpers.interopDefault(_indexJs91);
var _indexJs92 = require("./getTime/index.js");
var _indexJsDefault92 = parcelHelpers.interopDefault(_indexJs92);
var _indexJs93 = require("./getUnixTime/index.js");
var _indexJsDefault93 = parcelHelpers.interopDefault(_indexJs93);
var _indexJs94 = require("./getWeek/index.js");
var _indexJsDefault94 = parcelHelpers.interopDefault(_indexJs94);
var _indexJs95 = require("./getWeekOfMonth/index.js");
var _indexJsDefault95 = parcelHelpers.interopDefault(_indexJs95);
var _indexJs96 = require("./getWeekYear/index.js");
var _indexJsDefault96 = parcelHelpers.interopDefault(_indexJs96);
var _indexJs97 = require("./getWeeksInMonth/index.js");
var _indexJsDefault97 = parcelHelpers.interopDefault(_indexJs97);
var _indexJs98 = require("./getYear/index.js");
var _indexJsDefault98 = parcelHelpers.interopDefault(_indexJs98);
var _indexJs99 = require("./hoursToMilliseconds/index.js");
var _indexJsDefault99 = parcelHelpers.interopDefault(_indexJs99);
var _indexJs100 = require("./hoursToMinutes/index.js");
var _indexJsDefault100 = parcelHelpers.interopDefault(_indexJs100);
var _indexJs101 = require("./hoursToSeconds/index.js");
var _indexJsDefault101 = parcelHelpers.interopDefault(_indexJs101);
var _indexJs102 = require("./intervalToDuration/index.js");
var _indexJsDefault102 = parcelHelpers.interopDefault(_indexJs102);
var _indexJs103 = require("./intlFormat/index.js");
var _indexJsDefault103 = parcelHelpers.interopDefault(_indexJs103);
var _indexJs104 = require("./intlFormatDistance/index.js");
var _indexJsDefault104 = parcelHelpers.interopDefault(_indexJs104);
var _indexJs105 = require("./isAfter/index.js");
var _indexJsDefault105 = parcelHelpers.interopDefault(_indexJs105);
var _indexJs106 = require("./isBefore/index.js");
var _indexJsDefault106 = parcelHelpers.interopDefault(_indexJs106);
var _indexJs107 = require("./isDate/index.js");
var _indexJsDefault107 = parcelHelpers.interopDefault(_indexJs107);
var _indexJs108 = require("./isEqual/index.js");
var _indexJsDefault108 = parcelHelpers.interopDefault(_indexJs108);
var _indexJs109 = require("./isExists/index.js");
var _indexJsDefault109 = parcelHelpers.interopDefault(_indexJs109);
var _indexJs110 = require("./isFirstDayOfMonth/index.js");
var _indexJsDefault110 = parcelHelpers.interopDefault(_indexJs110);
var _indexJs111 = require("./isFriday/index.js");
var _indexJsDefault111 = parcelHelpers.interopDefault(_indexJs111);
var _indexJs112 = require("./isFuture/index.js");
var _indexJsDefault112 = parcelHelpers.interopDefault(_indexJs112);
var _indexJs113 = require("./isLastDayOfMonth/index.js");
var _indexJsDefault113 = parcelHelpers.interopDefault(_indexJs113);
var _indexJs114 = require("./isLeapYear/index.js");
var _indexJsDefault114 = parcelHelpers.interopDefault(_indexJs114);
var _indexJs115 = require("./isMatch/index.js");
var _indexJsDefault115 = parcelHelpers.interopDefault(_indexJs115);
var _indexJs116 = require("./isMonday/index.js");
var _indexJsDefault116 = parcelHelpers.interopDefault(_indexJs116);
var _indexJs117 = require("./isPast/index.js");
var _indexJsDefault117 = parcelHelpers.interopDefault(_indexJs117);
var _indexJs118 = require("./isSameDay/index.js");
var _indexJsDefault118 = parcelHelpers.interopDefault(_indexJs118);
var _indexJs119 = require("./isSameHour/index.js");
var _indexJsDefault119 = parcelHelpers.interopDefault(_indexJs119);
var _indexJs120 = require("./isSameISOWeek/index.js");
var _indexJsDefault120 = parcelHelpers.interopDefault(_indexJs120);
var _indexJs121 = require("./isSameISOWeekYear/index.js");
var _indexJsDefault121 = parcelHelpers.interopDefault(_indexJs121);
var _indexJs122 = require("./isSameMinute/index.js");
var _indexJsDefault122 = parcelHelpers.interopDefault(_indexJs122);
var _indexJs123 = require("./isSameMonth/index.js");
var _indexJsDefault123 = parcelHelpers.interopDefault(_indexJs123);
var _indexJs124 = require("./isSameQuarter/index.js");
var _indexJsDefault124 = parcelHelpers.interopDefault(_indexJs124);
var _indexJs125 = require("./isSameSecond/index.js");
var _indexJsDefault125 = parcelHelpers.interopDefault(_indexJs125);
var _indexJs126 = require("./isSameWeek/index.js");
var _indexJsDefault126 = parcelHelpers.interopDefault(_indexJs126);
var _indexJs127 = require("./isSameYear/index.js");
var _indexJsDefault127 = parcelHelpers.interopDefault(_indexJs127);
var _indexJs128 = require("./isSaturday/index.js");
var _indexJsDefault128 = parcelHelpers.interopDefault(_indexJs128);
var _indexJs129 = require("./isSunday/index.js");
var _indexJsDefault129 = parcelHelpers.interopDefault(_indexJs129);
var _indexJs130 = require("./isThisHour/index.js");
var _indexJsDefault130 = parcelHelpers.interopDefault(_indexJs130);
var _indexJs131 = require("./isThisISOWeek/index.js");
var _indexJsDefault131 = parcelHelpers.interopDefault(_indexJs131);
var _indexJs132 = require("./isThisMinute/index.js");
var _indexJsDefault132 = parcelHelpers.interopDefault(_indexJs132);
var _indexJs133 = require("./isThisMonth/index.js");
var _indexJsDefault133 = parcelHelpers.interopDefault(_indexJs133);
var _indexJs134 = require("./isThisQuarter/index.js");
var _indexJsDefault134 = parcelHelpers.interopDefault(_indexJs134);
var _indexJs135 = require("./isThisSecond/index.js");
var _indexJsDefault135 = parcelHelpers.interopDefault(_indexJs135);
var _indexJs136 = require("./isThisWeek/index.js");
var _indexJsDefault136 = parcelHelpers.interopDefault(_indexJs136);
var _indexJs137 = require("./isThisYear/index.js");
var _indexJsDefault137 = parcelHelpers.interopDefault(_indexJs137);
var _indexJs138 = require("./isThursday/index.js");
var _indexJsDefault138 = parcelHelpers.interopDefault(_indexJs138);
var _indexJs139 = require("./isToday/index.js");
var _indexJsDefault139 = parcelHelpers.interopDefault(_indexJs139);
var _indexJs140 = require("./isTomorrow/index.js");
var _indexJsDefault140 = parcelHelpers.interopDefault(_indexJs140);
var _indexJs141 = require("./isTuesday/index.js");
var _indexJsDefault141 = parcelHelpers.interopDefault(_indexJs141);
var _indexJs142 = require("./isValid/index.js");
var _indexJsDefault142 = parcelHelpers.interopDefault(_indexJs142);
var _indexJs143 = require("./isWednesday/index.js");
var _indexJsDefault143 = parcelHelpers.interopDefault(_indexJs143);
var _indexJs144 = require("./isWeekend/index.js");
var _indexJsDefault144 = parcelHelpers.interopDefault(_indexJs144);
var _indexJs145 = require("./isWithinInterval/index.js");
var _indexJsDefault145 = parcelHelpers.interopDefault(_indexJs145);
var _indexJs146 = require("./isYesterday/index.js");
var _indexJsDefault146 = parcelHelpers.interopDefault(_indexJs146);
var _indexJs147 = require("./lastDayOfDecade/index.js");
var _indexJsDefault147 = parcelHelpers.interopDefault(_indexJs147);
var _indexJs148 = require("./lastDayOfISOWeek/index.js");
var _indexJsDefault148 = parcelHelpers.interopDefault(_indexJs148);
var _indexJs149 = require("./lastDayOfISOWeekYear/index.js");
var _indexJsDefault149 = parcelHelpers.interopDefault(_indexJs149);
var _indexJs150 = require("./lastDayOfMonth/index.js");
var _indexJsDefault150 = parcelHelpers.interopDefault(_indexJs150);
var _indexJs151 = require("./lastDayOfQuarter/index.js");
var _indexJsDefault151 = parcelHelpers.interopDefault(_indexJs151);
var _indexJs152 = require("./lastDayOfWeek/index.js");
var _indexJsDefault152 = parcelHelpers.interopDefault(_indexJs152);
var _indexJs153 = require("./lastDayOfYear/index.js");
var _indexJsDefault153 = parcelHelpers.interopDefault(_indexJs153);
var _indexJs154 = require("./lightFormat/index.js");
var _indexJsDefault154 = parcelHelpers.interopDefault(_indexJs154);
var _indexJs155 = require("./max/index.js");
var _indexJsDefault155 = parcelHelpers.interopDefault(_indexJs155);
var _indexJs156 = require("./milliseconds/index.js");
var _indexJsDefault156 = parcelHelpers.interopDefault(_indexJs156);
var _indexJs157 = require("./millisecondsToHours/index.js");
var _indexJsDefault157 = parcelHelpers.interopDefault(_indexJs157);
var _indexJs158 = require("./millisecondsToMinutes/index.js");
var _indexJsDefault158 = parcelHelpers.interopDefault(_indexJs158);
var _indexJs159 = require("./millisecondsToSeconds/index.js");
var _indexJsDefault159 = parcelHelpers.interopDefault(_indexJs159);
var _indexJs160 = require("./min/index.js");
var _indexJsDefault160 = parcelHelpers.interopDefault(_indexJs160);
var _indexJs161 = require("./minutesToHours/index.js");
var _indexJsDefault161 = parcelHelpers.interopDefault(_indexJs161);
var _indexJs162 = require("./minutesToMilliseconds/index.js");
var _indexJsDefault162 = parcelHelpers.interopDefault(_indexJs162);
var _indexJs163 = require("./minutesToSeconds/index.js");
var _indexJsDefault163 = parcelHelpers.interopDefault(_indexJs163);
var _indexJs164 = require("./monthsToQuarters/index.js");
var _indexJsDefault164 = parcelHelpers.interopDefault(_indexJs164);
var _indexJs165 = require("./monthsToYears/index.js");
var _indexJsDefault165 = parcelHelpers.interopDefault(_indexJs165);
var _indexJs166 = require("./nextDay/index.js");
var _indexJsDefault166 = parcelHelpers.interopDefault(_indexJs166);
var _indexJs167 = require("./nextFriday/index.js");
var _indexJsDefault167 = parcelHelpers.interopDefault(_indexJs167);
var _indexJs168 = require("./nextMonday/index.js");
var _indexJsDefault168 = parcelHelpers.interopDefault(_indexJs168);
var _indexJs169 = require("./nextSaturday/index.js");
var _indexJsDefault169 = parcelHelpers.interopDefault(_indexJs169);
var _indexJs170 = require("./nextSunday/index.js");
var _indexJsDefault170 = parcelHelpers.interopDefault(_indexJs170);
var _indexJs171 = require("./nextThursday/index.js");
var _indexJsDefault171 = parcelHelpers.interopDefault(_indexJs171);
var _indexJs172 = require("./nextTuesday/index.js");
var _indexJsDefault172 = parcelHelpers.interopDefault(_indexJs172);
var _indexJs173 = require("./nextWednesday/index.js");
var _indexJsDefault173 = parcelHelpers.interopDefault(_indexJs173);
var _indexJs174 = require("./parse/index.js");
var _indexJsDefault174 = parcelHelpers.interopDefault(_indexJs174);
var _indexJs175 = require("./parseISO/index.js");
var _indexJsDefault175 = parcelHelpers.interopDefault(_indexJs175);
var _indexJs176 = require("./parseJSON/index.js");
var _indexJsDefault176 = parcelHelpers.interopDefault(_indexJs176);
var _indexJs177 = require("./previousDay/index.js");
var _indexJsDefault177 = parcelHelpers.interopDefault(_indexJs177);
var _indexJs178 = require("./previousFriday/index.js");
var _indexJsDefault178 = parcelHelpers.interopDefault(_indexJs178);
var _indexJs179 = require("./previousMonday/index.js");
var _indexJsDefault179 = parcelHelpers.interopDefault(_indexJs179);
var _indexJs180 = require("./previousSaturday/index.js");
var _indexJsDefault180 = parcelHelpers.interopDefault(_indexJs180);
var _indexJs181 = require("./previousSunday/index.js");
var _indexJsDefault181 = parcelHelpers.interopDefault(_indexJs181);
var _indexJs182 = require("./previousThursday/index.js");
var _indexJsDefault182 = parcelHelpers.interopDefault(_indexJs182);
var _indexJs183 = require("./previousTuesday/index.js");
var _indexJsDefault183 = parcelHelpers.interopDefault(_indexJs183);
var _indexJs184 = require("./previousWednesday/index.js");
var _indexJsDefault184 = parcelHelpers.interopDefault(_indexJs184);
var _indexJs185 = require("./quartersToMonths/index.js");
var _indexJsDefault185 = parcelHelpers.interopDefault(_indexJs185);
var _indexJs186 = require("./quartersToYears/index.js");
var _indexJsDefault186 = parcelHelpers.interopDefault(_indexJs186);
var _indexJs187 = require("./roundToNearestMinutes/index.js");
var _indexJsDefault187 = parcelHelpers.interopDefault(_indexJs187);
var _indexJs188 = require("./secondsToHours/index.js");
var _indexJsDefault188 = parcelHelpers.interopDefault(_indexJs188);
var _indexJs189 = require("./secondsToMilliseconds/index.js");
var _indexJsDefault189 = parcelHelpers.interopDefault(_indexJs189);
var _indexJs190 = require("./secondsToMinutes/index.js");
var _indexJsDefault190 = parcelHelpers.interopDefault(_indexJs190);
var _indexJs191 = require("./set/index.js");
var _indexJsDefault191 = parcelHelpers.interopDefault(_indexJs191);
var _indexJs192 = require("./setDate/index.js");
var _indexJsDefault192 = parcelHelpers.interopDefault(_indexJs192);
var _indexJs193 = require("./setDay/index.js");
var _indexJsDefault193 = parcelHelpers.interopDefault(_indexJs193);
var _indexJs194 = require("./setDayOfYear/index.js");
var _indexJsDefault194 = parcelHelpers.interopDefault(_indexJs194);
var _indexJs195 = require("./setDefaultOptions/index.js");
var _indexJsDefault195 = parcelHelpers.interopDefault(_indexJs195);
var _indexJs196 = require("./setHours/index.js");
var _indexJsDefault196 = parcelHelpers.interopDefault(_indexJs196);
var _indexJs197 = require("./setISODay/index.js");
var _indexJsDefault197 = parcelHelpers.interopDefault(_indexJs197);
var _indexJs198 = require("./setISOWeek/index.js");
var _indexJsDefault198 = parcelHelpers.interopDefault(_indexJs198);
var _indexJs199 = require("./setISOWeekYear/index.js");
var _indexJsDefault199 = parcelHelpers.interopDefault(_indexJs199);
var _indexJs200 = require("./setMilliseconds/index.js");
var _indexJsDefault200 = parcelHelpers.interopDefault(_indexJs200);
var _indexJs201 = require("./setMinutes/index.js");
var _indexJsDefault201 = parcelHelpers.interopDefault(_indexJs201);
var _indexJs202 = require("./setMonth/index.js");
var _indexJsDefault202 = parcelHelpers.interopDefault(_indexJs202);
var _indexJs203 = require("./setQuarter/index.js");
var _indexJsDefault203 = parcelHelpers.interopDefault(_indexJs203);
var _indexJs204 = require("./setSeconds/index.js");
var _indexJsDefault204 = parcelHelpers.interopDefault(_indexJs204);
var _indexJs205 = require("./setWeek/index.js");
var _indexJsDefault205 = parcelHelpers.interopDefault(_indexJs205);
var _indexJs206 = require("./setWeekYear/index.js");
var _indexJsDefault206 = parcelHelpers.interopDefault(_indexJs206);
var _indexJs207 = require("./setYear/index.js");
var _indexJsDefault207 = parcelHelpers.interopDefault(_indexJs207);
var _indexJs208 = require("./startOfDay/index.js");
var _indexJsDefault208 = parcelHelpers.interopDefault(_indexJs208);
var _indexJs209 = require("./startOfDecade/index.js");
var _indexJsDefault209 = parcelHelpers.interopDefault(_indexJs209);
var _indexJs210 = require("./startOfHour/index.js");
var _indexJsDefault210 = parcelHelpers.interopDefault(_indexJs210);
var _indexJs211 = require("./startOfISOWeek/index.js");
var _indexJsDefault211 = parcelHelpers.interopDefault(_indexJs211);
var _indexJs212 = require("./startOfISOWeekYear/index.js");
var _indexJsDefault212 = parcelHelpers.interopDefault(_indexJs212);
var _indexJs213 = require("./startOfMinute/index.js");
var _indexJsDefault213 = parcelHelpers.interopDefault(_indexJs213);
var _indexJs214 = require("./startOfMonth/index.js");
var _indexJsDefault214 = parcelHelpers.interopDefault(_indexJs214);
var _indexJs215 = require("./startOfQuarter/index.js");
var _indexJsDefault215 = parcelHelpers.interopDefault(_indexJs215);
var _indexJs216 = require("./startOfSecond/index.js");
var _indexJsDefault216 = parcelHelpers.interopDefault(_indexJs216);
var _indexJs217 = require("./startOfToday/index.js");
var _indexJsDefault217 = parcelHelpers.interopDefault(_indexJs217);
var _indexJs218 = require("./startOfTomorrow/index.js");
var _indexJsDefault218 = parcelHelpers.interopDefault(_indexJs218);
var _indexJs219 = require("./startOfWeek/index.js");
var _indexJsDefault219 = parcelHelpers.interopDefault(_indexJs219);
var _indexJs220 = require("./startOfWeekYear/index.js");
var _indexJsDefault220 = parcelHelpers.interopDefault(_indexJs220);
var _indexJs221 = require("./startOfYear/index.js");
var _indexJsDefault221 = parcelHelpers.interopDefault(_indexJs221);
var _indexJs222 = require("./startOfYesterday/index.js");
var _indexJsDefault222 = parcelHelpers.interopDefault(_indexJs222);
var _indexJs223 = require("./sub/index.js");
var _indexJsDefault223 = parcelHelpers.interopDefault(_indexJs223);
var _indexJs224 = require("./subBusinessDays/index.js");
var _indexJsDefault224 = parcelHelpers.interopDefault(_indexJs224);
var _indexJs225 = require("./subDays/index.js");
var _indexJsDefault225 = parcelHelpers.interopDefault(_indexJs225);
var _indexJs226 = require("./subHours/index.js");
var _indexJsDefault226 = parcelHelpers.interopDefault(_indexJs226);
var _indexJs227 = require("./subISOWeekYears/index.js");
var _indexJsDefault227 = parcelHelpers.interopDefault(_indexJs227);
var _indexJs228 = require("./subMilliseconds/index.js");
var _indexJsDefault228 = parcelHelpers.interopDefault(_indexJs228);
var _indexJs229 = require("./subMinutes/index.js");
var _indexJsDefault229 = parcelHelpers.interopDefault(_indexJs229);
var _indexJs230 = require("./subMonths/index.js");
var _indexJsDefault230 = parcelHelpers.interopDefault(_indexJs230);
var _indexJs231 = require("./subQuarters/index.js");
var _indexJsDefault231 = parcelHelpers.interopDefault(_indexJs231);
var _indexJs232 = require("./subSeconds/index.js");
var _indexJsDefault232 = parcelHelpers.interopDefault(_indexJs232);
var _indexJs233 = require("./subWeeks/index.js");
var _indexJsDefault233 = parcelHelpers.interopDefault(_indexJs233);
var _indexJs234 = require("./subYears/index.js");
var _indexJsDefault234 = parcelHelpers.interopDefault(_indexJs234);
var _indexJs235 = require("./toDate/index.js");
var _indexJsDefault235 = parcelHelpers.interopDefault(_indexJs235);
var _indexJs236 = require("./weeksToDays/index.js");
var _indexJsDefault236 = parcelHelpers.interopDefault(_indexJs236);
var _indexJs237 = require("./yearsToMonths/index.js");
var _indexJsDefault237 = parcelHelpers.interopDefault(_indexJs237);
var _indexJs238 = require("./yearsToQuarters/index.js");
var _indexJsDefault238 = parcelHelpers.interopDefault(_indexJs238);
var _indexJs239 = require("./constants/index.js");
parcelHelpers.exportAll(_indexJs239, exports);

},{"./add/index.js":false,"./addBusinessDays/index.js":false,"./addDays/index.js":"6e3pH","./addHours/index.js":false,"./addISOWeekYears/index.js":false,"./addMilliseconds/index.js":false,"./addMinutes/index.js":false,"./addMonths/index.js":false,"./addQuarters/index.js":false,"./addSeconds/index.js":false,"./addWeeks/index.js":false,"./addYears/index.js":false,"./areIntervalsOverlapping/index.js":false,"./clamp/index.js":false,"./closestIndexTo/index.js":false,"./closestTo/index.js":false,"./compareAsc/index.js":"gcHVn","./compareDesc/index.js":false,"./daysToWeeks/index.js":false,"./differenceInBusinessDays/index.js":false,"./differenceInCalendarDays/index.js":false,"./differenceInCalendarISOWeekYears/index.js":false,"./differenceInCalendarISOWeeks/index.js":false,"./differenceInCalendarMonths/index.js":false,"./differenceInCalendarQuarters/index.js":false,"./differenceInCalendarWeeks/index.js":false,"./differenceInCalendarYears/index.js":false,"./differenceInDays/index.js":false,"./differenceInHours/index.js":false,"./differenceInISOWeekYears/index.js":false,"./differenceInMilliseconds/index.js":false,"./differenceInMinutes/index.js":false,"./differenceInMonths/index.js":"5wHhv","./differenceInQuarters/index.js":false,"./differenceInSeconds/index.js":false,"./differenceInWeeks/index.js":false,"./differenceInYears/index.js":false,"./eachDayOfInterval/index.js":false,"./eachHourOfInterval/index.js":false,"./eachMinuteOfInterval/index.js":false,"./eachMonthOfInterval/index.js":false,"./eachQuarterOfInterval/index.js":false,"./eachWeekOfInterval/index.js":false,"./eachWeekendOfInterval/index.js":false,"./eachWeekendOfMonth/index.js":false,"./eachWeekendOfYear/index.js":false,"./eachYearOfInterval/index.js":false,"./endOfDay/index.js":false,"./endOfDecade/index.js":false,"./endOfHour/index.js":false,"./endOfISOWeek/index.js":false,"./endOfISOWeekYear/index.js":false,"./endOfMinute/index.js":false,"./endOfMonth/index.js":false,"./endOfQuarter/index.js":false,"./endOfSecond/index.js":false,"./endOfToday/index.js":false,"./endOfTomorrow/index.js":false,"./endOfWeek/index.js":false,"./endOfYear/index.js":false,"./endOfYesterday/index.js":false,"./format/index.js":"jiVQj","./formatDistance/index.js":false,"./formatDistanceStrict/index.js":false,"./formatDistanceToNow/index.js":false,"./formatDistanceToNowStrict/index.js":false,"./formatDuration/index.js":false,"./formatISO/index.js":false,"./formatISO9075/index.js":false,"./formatISODuration/index.js":false,"./formatRFC3339/index.js":false,"./formatRFC7231/index.js":false,"./formatRelative/index.js":false,"./fromUnixTime/index.js":false,"./getDate/index.js":false,"./getDay/index.js":false,"./getDayOfYear/index.js":false,"./getDaysInMonth/index.js":false,"./getDaysInYear/index.js":false,"./getDecade/index.js":false,"./getDefaultOptions/index.js":false,"./getHours/index.js":false,"./getISODay/index.js":false,"./getISOWeek/index.js":false,"./getISOWeekYear/index.js":false,"./getISOWeeksInYear/index.js":false,"./getMilliseconds/index.js":false,"./getMinutes/index.js":false,"./getMonth/index.js":false,"./getOverlappingDaysInIntervals/index.js":false,"./getQuarter/index.js":false,"./getSeconds/index.js":false,"./getTime/index.js":false,"./getUnixTime/index.js":false,"./getWeek/index.js":false,"./getWeekOfMonth/index.js":false,"./getWeekYear/index.js":false,"./getWeeksInMonth/index.js":false,"./getYear/index.js":false,"./hoursToMilliseconds/index.js":false,"./hoursToMinutes/index.js":false,"./hoursToSeconds/index.js":false,"./intervalToDuration/index.js":false,"./intlFormat/index.js":false,"./intlFormatDistance/index.js":false,"./isAfter/index.js":false,"./isBefore/index.js":"8uE9w","./isDate/index.js":false,"./isEqual/index.js":false,"./isExists/index.js":false,"./isFirstDayOfMonth/index.js":false,"./isFriday/index.js":false,"./isFuture/index.js":false,"./isLastDayOfMonth/index.js":false,"./isLeapYear/index.js":false,"./isMatch/index.js":false,"./isMonday/index.js":false,"./isPast/index.js":false,"./isSameDay/index.js":false,"./isSameHour/index.js":false,"./isSameISOWeek/index.js":false,"./isSameISOWeekYear/index.js":false,"./isSameMinute/index.js":false,"./isSameMonth/index.js":false,"./isSameQuarter/index.js":false,"./isSameSecond/index.js":false,"./isSameWeek/index.js":false,"./isSameYear/index.js":false,"./isSaturday/index.js":false,"./isSunday/index.js":false,"./isThisHour/index.js":false,"./isThisISOWeek/index.js":false,"./isThisMinute/index.js":false,"./isThisMonth/index.js":false,"./isThisQuarter/index.js":false,"./isThisSecond/index.js":false,"./isThisWeek/index.js":false,"./isThisYear/index.js":false,"./isThursday/index.js":false,"./isToday/index.js":false,"./isTomorrow/index.js":false,"./isTuesday/index.js":false,"./isValid/index.js":false,"./isWednesday/index.js":false,"./isWeekend/index.js":false,"./isWithinInterval/index.js":false,"./isYesterday/index.js":false,"./lastDayOfDecade/index.js":false,"./lastDayOfISOWeek/index.js":false,"./lastDayOfISOWeekYear/index.js":false,"./lastDayOfMonth/index.js":false,"./lastDayOfQuarter/index.js":false,"./lastDayOfWeek/index.js":false,"./lastDayOfYear/index.js":false,"./lightFormat/index.js":false,"./max/index.js":false,"./milliseconds/index.js":false,"./millisecondsToHours/index.js":false,"./millisecondsToMinutes/index.js":false,"./millisecondsToSeconds/index.js":false,"./min/index.js":false,"./minutesToHours/index.js":false,"./minutesToMilliseconds/index.js":false,"./minutesToSeconds/index.js":false,"./monthsToQuarters/index.js":false,"./monthsToYears/index.js":false,"./nextDay/index.js":false,"./nextFriday/index.js":false,"./nextMonday/index.js":false,"./nextSaturday/index.js":false,"./nextSunday/index.js":false,"./nextThursday/index.js":false,"./nextTuesday/index.js":false,"./nextWednesday/index.js":false,"./parse/index.js":false,"./parseISO/index.js":false,"./parseJSON/index.js":false,"./previousDay/index.js":false,"./previousFriday/index.js":false,"./previousMonday/index.js":false,"./previousSaturday/index.js":false,"./previousSunday/index.js":false,"./previousThursday/index.js":false,"./previousTuesday/index.js":false,"./previousWednesday/index.js":false,"./quartersToMonths/index.js":false,"./quartersToYears/index.js":false,"./roundToNearestMinutes/index.js":false,"./secondsToHours/index.js":false,"./secondsToMilliseconds/index.js":false,"./secondsToMinutes/index.js":false,"./set/index.js":false,"./setDate/index.js":false,"./setDay/index.js":false,"./setDayOfYear/index.js":false,"./setDefaultOptions/index.js":false,"./setHours/index.js":false,"./setISODay/index.js":false,"./setISOWeek/index.js":false,"./setISOWeekYear/index.js":false,"./setMilliseconds/index.js":false,"./setMinutes/index.js":false,"./setMonth/index.js":false,"./setQuarter/index.js":false,"./setSeconds/index.js":false,"./setWeek/index.js":false,"./setWeekYear/index.js":false,"./setYear/index.js":false,"./startOfDay/index.js":false,"./startOfDecade/index.js":false,"./startOfHour/index.js":false,"./startOfISOWeek/index.js":false,"./startOfISOWeekYear/index.js":false,"./startOfMinute/index.js":false,"./startOfMonth/index.js":false,"./startOfQuarter/index.js":false,"./startOfSecond/index.js":false,"./startOfToday/index.js":false,"./startOfTomorrow/index.js":false,"./startOfWeek/index.js":false,"./startOfWeekYear/index.js":false,"./startOfYear/index.js":false,"./startOfYesterday/index.js":false,"./sub/index.js":false,"./subBusinessDays/index.js":false,"./subDays/index.js":false,"./subHours/index.js":false,"./subISOWeekYears/index.js":false,"./subMilliseconds/index.js":false,"./subMinutes/index.js":false,"./subMonths/index.js":false,"./subQuarters/index.js":false,"./subSeconds/index.js":false,"./subWeeks/index.js":false,"./subYears/index.js":false,"./toDate/index.js":false,"./weeksToDays/index.js":false,"./yearsToMonths/index.js":false,"./yearsToQuarters/index.js":false,"./constants/index.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gcHVn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return compareAsc;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
function compareAsc(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault1.default)(2, arguments);
    var dateLeft = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRight = (0, _indexJsDefault.default)(dirtyDateRight);
    var diff = dateLeft.getTime() - dateRight.getTime();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}

},{"../toDate/index.js":"j2pWU","../_lib/requiredArgs/index.js":"a3mwq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5wHhv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return differenceInMonths;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../differenceInCalendarMonths/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../compareAsc/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
var _indexJs4 = require("../isLastDayOfMonth/index.js");
var _indexJsDefault4 = parcelHelpers.interopDefault(_indexJs4);
function differenceInMonths(dirtyDateLeft, dirtyDateRight) {
    (0, _indexJsDefault3.default)(2, arguments);
    var dateLeft = (0, _indexJsDefault.default)(dirtyDateLeft);
    var dateRight = (0, _indexJsDefault.default)(dirtyDateRight);
    var sign = (0, _indexJsDefault2.default)(dateLeft, dateRight);
    var difference = Math.abs((0, _indexJsDefault1.default)(dateLeft, dateRight));
    var result;
    // Check for the difference of less than month
    if (difference < 1) result = 0;
    else {
        if (dateLeft.getMonth() === 1 && dateLeft.getDate() > 27) // This will check if the date is end of Feb and assign a higher end of month date
        // to compare it with Jan
        dateLeft.setDate(30);
        dateLeft.setMonth(dateLeft.getMonth() - sign * difference);
        // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
        // If so, result must be decreased by 1 in absolute value
        var isLastMonthNotFull = (0, _indexJsDefault2.default)(dateLeft, dateRight) === -sign;
        // Check for cases of one full calendar month
        if ((0, _indexJsDefault4.default)((0, _indexJsDefault.default)(dirtyDateLeft)) && difference === 1 && (0, _indexJsDefault2.default)(dirtyDateLeft, dateRight) === 1) isLastMonthNotFull = false;
        result = sign * (difference - Number(isLastMonthNotFull));
    }
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

},{"../toDate/index.js":"j2pWU","../differenceInCalendarMonths/index.js":"NQu1U","../compareAsc/index.js":"gcHVn","../_lib/requiredArgs/index.js":"a3mwq","../isLastDayOfMonth/index.js":"cJHsN","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"cJHsN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return isLastDayOfMonth;
});
var _indexJs = require("../toDate/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _indexJs1 = require("../endOfDay/index.js");
var _indexJsDefault1 = parcelHelpers.interopDefault(_indexJs1);
var _indexJs2 = require("../endOfMonth/index.js");
var _indexJsDefault2 = parcelHelpers.interopDefault(_indexJs2);
var _indexJs3 = require("../_lib/requiredArgs/index.js");
var _indexJsDefault3 = parcelHelpers.interopDefault(_indexJs3);
function isLastDayOfMonth(dirtyDate) {
    (0, _indexJsDefault3.default)(1, arguments);
    var date = (0, _indexJsDefault.default)(dirtyDate);
    return (0, _indexJsDefault1.default)(date).getTime() === (0, _indexJsDefault2.default)(date).getTime();
}

},{"../toDate/index.js":"j2pWU","../endOfDay/index.js":"j5enF","../endOfMonth/index.js":"fx4gV","../_lib/requiredArgs/index.js":"a3mwq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"hgcCc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UpdateNextChargeDateKey", function() {
    return UpdateNextChargeDateKey;
});
parcelHelpers.export(exports, "UpdateNextChargeDate", function() {
    return UpdateNextChargeDate;
});
parcelHelpers.export(exports, "NextChargeDateUpdatedKey", function() {
    return NextChargeDateUpdatedKey;
});
parcelHelpers.export(exports, "NextChargeDateUpdated", function() {
    return NextChargeDateUpdated;
});
parcelHelpers.export(exports, "updateNextChargeDate", function() {
    return updateNextChargeDate;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _eventFactory = require("../../std/eventFactory");
var _customerSubscription = require("../store/state/data/customerSubscription");
var _std = require("@reglo/std");
var UpdateNextChargeDateKey = 'UpdateNextChargeDate';
var UpdateNextChargeDate = (0, _eventFactory.eventFactory)(UpdateNextChargeDateKey)();
var NextChargeDateUpdatedKey = 'NextChargeDateUpdated';
var NextChargeDateUpdated = (0, _eventFactory.eventFactory)(NextChargeDateUpdatedKey)();
function updateNextChargeDate(deps) {
    return /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(event) {
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            track(event)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            update(event)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            publishSuccessEvent(event)
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }();
    function update(event) {
        return _update.apply(this, arguments);
    }
    function _update() {
        _update = (0, _asyncToGenerator._)(function(event) {
            var date;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        date = event.payload.date;
                        return [
                            4,
                            deps.updateSubscriptionsDate(date)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return _update.apply(this, arguments);
    }
    function publishSuccessEvent(event) {
        return _publishSuccessEvent.apply(this, arguments);
    }
    function _publishSuccessEvent() {
        _publishSuccessEvent = (0, _asyncToGenerator._)(function(event) {
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            deps.publishEvent(NextChargeDateUpdated())
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return _publishSuccessEvent.apply(this, arguments);
    }
    function track(event) {
        return _track.apply(this, arguments);
    }
    function _track() {
        _track = (0, _asyncToGenerator._)(function(event) {
            var from, to;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        from = selectInitialDate();
                        to = event.payload.date;
                        return [
                            4,
                            deps.track('UpdateNextChargeDate', {
                                from: from,
                                to: to
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return _track.apply(this, arguments);
    }
    function selectInitialDate() {
        var _deps_getState_nextOrder;
        return (0, _std.unwrap)((_deps_getState_nextOrder = deps.getState((0, _customerSubscription.customerSubscriptionSelector)).nextOrder) === null || _deps_getState_nextOrder === void 0 ? void 0 : _deps_getState_nextOrder.date);
    }
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_ts_generator":"f2hGH","../../std/eventFactory":"f2PpV","../store/state/data/customerSubscription":"3ipiV","@reglo/std":"1USo0","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"j35EA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EditableInfo", function() {
    return EditableInfo;
});
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _cta = require("../../../components/Cta");
function EditableInfo(props) {
    var _props_isEditable;
    var isEditable = (_props_isEditable = props.isEditable) !== null && _props_isEditable !== void 0 ? _props_isEditable : true;
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
        className: "accountEditableInfo",
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                children: [
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("p", {
                        className: "accountEditableInfo__title",
                        children: props.title
                    }, void 0, false, {
                        fileName: "src/script/src/dom/views/Account/components/EditableInfo.tsx",
                        lineNumber: 15,
                        columnNumber: 17
                    }, this),
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("p", {
                        children: props.content
                    }, void 0, false, {
                        fileName: "src/script/src/dom/views/Account/components/EditableInfo.tsx",
                        lineNumber: 16,
                        columnNumber: 17
                    }, this)
                ]
            }, void 0, true, {
                fileName: "src/script/src/dom/views/Account/components/EditableInfo.tsx",
                lineNumber: 14,
                columnNumber: 13
            }, this),
            isEditable && /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _cta.Cta), {
                label: "Modifier",
                className: "accountEditableInfo__cta",
                size: "XS",
                isInverted: true,
                onClick: props.onStartEdit
            }, void 0, false, {
                fileName: "src/script/src/dom/views/Account/components/EditableInfo.tsx",
                lineNumber: 18,
                columnNumber: 28
            }, this)
        ]
    }, void 0, true, {
        fileName: "src/script/src/dom/views/Account/components/EditableInfo.tsx",
        lineNumber: 13,
        columnNumber: 9
    }, this);
}

},{"react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","../../../components/Cta":"beDOe","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"foulu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AccountCard", function() {
    return AccountCard;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
function AccountCard(props) {
    var _this = this;
    var _props_className;
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
        className: (0, _classnamesDefault.default)((0, _defineProperty._)({
            componentAccountCard: true
        }, (_props_className = props.className) !== null && _props_className !== void 0 ? _props_className : '', true)),
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                className: "componentAccountCard__container",
                children: [
                    props.title && /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                        className: "componentAccountCard__titleContainer",
                        children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                            className: "componentAccountCard__title",
                            children: props.title
                        }, void 0, false, {
                            fileName: "src/script/src/dom/views/Account/components/AccountCard.tsx",
                            lineNumber: 18,
                            columnNumber: 21
                        }, this)
                    }, void 0, false, {
                        fileName: "src/script/src/dom/views/Account/components/AccountCard.tsx",
                        lineNumber: 17,
                        columnNumber: 33
                    }, this),
                    props.children
                ]
            }, void 0, true, {
                fileName: "src/script/src/dom/views/Account/components/AccountCard.tsx",
                lineNumber: 16,
                columnNumber: 13
            }, this),
            props.underActions && /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                className: "componentAccountCard__underActions",
                children: props.underActions.map(function(action, index) {
                    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _react.Fragment), {
                        children: action
                    }, index, false, {
                        fileName: "src/script/src/dom/views/Account/components/AccountCard.tsx",
                        lineNumber: 23,
                        columnNumber: 60
                    }, _this);
                })
            }, void 0, false, {
                fileName: "src/script/src/dom/views/Account/components/AccountCard.tsx",
                lineNumber: 22,
                columnNumber: 36
            }, this)
        ]
    }, void 0, true, {
        fileName: "src/script/src/dom/views/Account/components/AccountCard.tsx",
        lineNumber: 12,
        columnNumber: 9
    }, this);
}

},{"@swc/helpers/_/_define_property":"54Zvk","react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","classnames":"4SuBi","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"qpH7L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CancelSubscriptionKey", function() {
    return CancelSubscriptionKey;
});
parcelHelpers.export(exports, "CancelSubscription", function() {
    return CancelSubscription;
});
parcelHelpers.export(exports, "SubscriptionCancelledKey", function() {
    return SubscriptionCancelledKey;
});
parcelHelpers.export(exports, "SubscriptionCancelled", function() {
    return SubscriptionCancelled;
});
parcelHelpers.export(exports, "cancelSubscription", function() {
    return cancelSubscription;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _customerSubscription = require("../store/state/data/customerSubscription");
var _eventFactory = require("../../std/eventFactory");
var CancelSubscriptionKey = 'CancelSubscription';
var CancelSubscription = (0, _eventFactory.eventFactory)(CancelSubscriptionKey)();
var SubscriptionCancelledKey = 'SubscriptionCancelled';
var SubscriptionCancelled = (0, _eventFactory.eventFactory)(SubscriptionCancelledKey)();
function cancelSubscription(deps) {
    return /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(event) {
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            deps.track('CancelSubscription', event.payload)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            update()
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            deps.publishEvent(SubscriptionCancelled())
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }();
    function update() {
        return _update.apply(this, arguments);
    }
    function _update() {
        _update = (0, _asyncToGenerator._)(function() {
            var ids;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        ids = deps.getState((0, _customerSubscription.customerSubscriptionSelector)).subscriptions.map(function(subscription) {
                            return subscription.id;
                        });
                        return [
                            4,
                            deps.disableSubscriptions(ids)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return _update.apply(this, arguments);
    }
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_ts_generator":"f2hGH","../store/state/data/customerSubscription":"3ipiV","../../std/eventFactory":"f2PpV","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"alMr2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addProductView", function() {
    return addProductView;
});
var _reselect = require("reselect");
var _customerSubscription = require("../store/state/data/customerSubscription");
var _variants = require("../store/state/data/variants");
var _addProductToSubscription = require("../useCases/addProductToSubscription");
var _selectProductView = require("./selectProductView");
var addProductView = (0, _reselect.createSelector)((0, _customerSubscription.activeSubscriptionsSelector), (0, _variants.variantsSelector), prepareView);
function prepareView(subscriptions, variantsState) {
    return (0, _selectProductView.selectProductView)(subscriptions, variantsState, prepareAction);
    function prepareAction(variantId) {
        return (0, _addProductToSubscription.AddProductToSubscription)({
            variantId: variantId
        });
    }
}

},{"reselect":"fb6q1","../store/state/data/customerSubscription":"3ipiV","../store/state/data/variants":"11hc8","../useCases/addProductToSubscription":"76m1k","./selectProductView":"5vPiB","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"j9xAX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EditFrequency", function() {
    return EditFrequency;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _modal = require("../../../../components/Modal");
var _reactRedux = require("react-redux");
var _hooks = require("../../../../../std/hooks");
var _updateFrequency = require("../../../../../app/useCases/updateFrequency");
var _select = require("../../../../../../../snippets/components/select");
function EditFrequency(props) {
    var view = props.view;
    var dispatch = (0, _reactRedux.useDispatch)();
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), opened = _useState[0], setOpened = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(defaultFrequency()), 2), frequencyInWeek = _useState1[0], setFrequencyInWeek = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)(false), 2), submitting = _useState2[0], setSubmitting = _useState2[1];
    props.open(open);
    (0, _hooks.useOnEvent)((0, _updateFrequency.FrequencyUpdatedKey), close);
    var options = view.frequencyInWeekOptions.map(function(option) {
        return {
            value: option,
            label: option % 4 === 0 ? `Livraison tous les ${option / 4} mois` : `Livraison toutes les ${option} semaines`
        };
    });
    function defaultFrequency() {
        var defaultValue = 4;
        if (!view.frequencyInWeekOptions.includes(view.frequency.value)) return defaultValue;
        return view.frequency.value;
    }
    function open() {
        setOpened(true);
        setSubmitting(false);
    }
    function close() {
        setOpened(false);
        setSubmitting(false);
    }
    function handleSubmit() {
        dispatch((0, _updateFrequency.UpdateFrequency)({
            frequencyInWeek: frequencyInWeek
        }));
        setSubmitting(true);
    }
    if (!opened) return null;
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _modal.Modal), {
        title: "Modifier la fr\xe9quence de mon abonnement",
        ctas: [
            {
                isInverted: true,
                label: 'Annuler',
                onClick: close
            },
            {
                label: 'Enregistrer',
                onClick: handleSubmit,
                isLoading: submitting
            }
        ],
        className: "accountSubscriptionEditNextFrequency",
        onClose: close,
        children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
            className: "container",
            children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _select.NumberSelect), {
                label: "Fr\xe9quence",
                required: true,
                options: options,
                value: frequencyInWeek,
                onChange: setFrequencyInWeek
            }, void 0, false, {
                fileName: "src/script/src/dom/views/Account/views/Subscription/EditFrequency.tsx",
                lineNumber: 65,
                columnNumber: 17
            }, this)
        }, void 0, false, {
            fileName: "src/script/src/dom/views/Account/views/Subscription/EditFrequency.tsx",
            lineNumber: 64,
            columnNumber: 13
        }, this)
    }, void 0, false, {
        fileName: "src/script/src/dom/views/Account/views/Subscription/EditFrequency.tsx",
        lineNumber: 55,
        columnNumber: 9
    }, this);
}

},{"@swc/helpers/_/_sliced_to_array":"ha6sq","react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","../../../../components/Modal":"1uIeH","react-redux":"ghMZu","../../../../../std/hooks":"j9RPQ","../../../../../app/useCases/updateFrequency":"eXHAW","../../../../../../../snippets/components/select":"fqaEu","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"59mai":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "presentFrequency", function() {
    return presentFrequency;
});
function presentFrequency(frequency) {
    if (frequency.unit === 'day') return `Livraison tous les ${frequency.value} ${frequency.value === 1 ? 'jour' : 'jours'}`;
    if (frequency.unit === 'week') {
        if (frequency.value % 4 === 0) return `Livraison tous les ${frequency.value / 4} mois`;
        return `Livraison toutes les ${frequency.value} ${frequency.value === 1 ? 'semaine' : 'semaines'}`;
    }
    if (frequency.unit === 'month') return `Livraison tous les ${frequency.value} mois`;
    throw new Error();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7hmRR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Starter", function() {
    return Starter;
});
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _accountCard = require("../../components/AccountCard");
function Starter() {
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _accountCard.AccountCard), {
        className: "accountSubscriptionStarter",
        title: "Profitez de l'abonnement",
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("ul", {
                children: [
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("li", {
                        children: [
                            settings.subscription__discount,
                            "% de r\xe9duction sur vos commandes"
                        ]
                    }, void 0, true, {
                        fileName: "src/script/src/dom/views/Account/views/Subscription/Starter.tsx",
                        lineNumber: 11,
                        columnNumber: 17
                    }, this),
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("li", {
                        children: "aucun engagement"
                    }, void 0, false, {
                        fileName: "src/script/src/dom/views/Account/views/Subscription/Starter.tsx",
                        lineNumber: 12,
                        columnNumber: 17
                    }, this)
                ]
            }, void 0, true, {
                fileName: "src/script/src/dom/views/Account/views/Subscription/Starter.tsx",
                lineNumber: 10,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                className: "ctaContainer",
                children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("a", {
                    href: "/collections/chien",
                    className: "cta",
                    children: "Pour mon chien"
                }, void 0, false, {
                    fileName: "src/script/src/dom/views/Account/views/Subscription/Starter.tsx",
                    lineNumber: 15,
                    columnNumber: 17
                }, this)
            }, void 0, false, {
                fileName: "src/script/src/dom/views/Account/views/Subscription/Starter.tsx",
                lineNumber: 14,
                columnNumber: 13
            }, this)
        ]
    }, void 0, true, {
        fileName: "src/script/src/dom/views/Account/views/Subscription/Starter.tsx",
        lineNumber: 6,
        columnNumber: 9
    }, this);
}

},{"react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","../../components/AccountCard":"foulu","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5tghw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CustomerHelp", function() {
    return CustomerHelp;
});
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _mySubscriptionView = require("../../../../../app/views/mySubscriptionView");
function CustomerHelp() {
    var view = (0, _reactRedux.useSelector)((0, _mySubscriptionView.mySubscriptionView));
    function prepareTitle() {
        if (view.state === 'activeSubscription') return `Des questions \xe0 propos de votre abonnement\xa0? Besoin d'aide pour le modifier\xa0?`;
        return `Vous ne retrouvez pas votre abonnement\xa0? Envie de vous abonner\xa0?`;
    }
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
        className: "accountSubscriptionCustomerHelp",
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                className: "title",
                children: prepareTitle()
            }, void 0, false, {
                fileName: "src/script/src/dom/views/Account/views/Subscription/CustomerHelp.tsx",
                lineNumber: 17,
                columnNumber: 13
            }, this),
            "Nous sommes \xe0 votre service au ",
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("a", {
                href: "tel:+33187200240",
                className: "no-wrap",
                children: "01 87 20 02 40"
            }, void 0, false, {
                fileName: "src/script/src/dom/views/Account/views/Subscription/CustomerHelp.tsx",
                lineNumber: 18,
                columnNumber: 44
            }, this),
            ", sur ",
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("a", {
                href: "https://api.whatsapp.com/send?phone=33187200240",
                className: "no-wrap",
                children: "WhatsApp"
            }, void 0, false, {
                fileName: "src/script/src/dom/views/Account/views/Subscription/CustomerHelp.tsx",
                lineNumber: 18,
                columnNumber: 115
            }, this),
            " (m\xeame num\xe9ro) et par email ",
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("a", {
                href: "mailto:bonjour@reglo.fr?subject=Allo%20r\xe9glo",
                className: "no-wrap",
                children: "bonjour@reglo.fr"
            }, void 0, false, {
                fileName: "src/script/src/dom/views/Account/views/Subscription/CustomerHelp.tsx",
                lineNumber: 18,
                columnNumber: 233
            }, this)
        ]
    }, void 0, true, {
        fileName: "src/script/src/dom/views/Account/views/Subscription/CustomerHelp.tsx",
        lineNumber: 16,
        columnNumber: 9
    }, this);
}

},{"react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","react-redux":"ghMZu","../../../../../app/views/mySubscriptionView":"gDy3a","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gDy3a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mySubscriptionView", function() {
    return mySubscriptionView;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _reselect = require("reselect");
var _customerSubscription = require("../store/state/data/customerSubscription");
var _variants = require("../store/state/data/variants");
var _customer = require("../store/state/data/customer");
var _std = require("@reglo/std");
var _shippingRates = require("../store/state/data/shippingRates");
var _updateSubscriptionQuantity = require("../useCases/updateSubscriptionQuantity");
var _removeProductFromSubscription = require("../useCases/removeProductFromSubscription");
var mySubscriptionView = (0, _reselect.createSelector)((0, _customerSubscription.customerSubscriptionSelector), (0, _variants.variantsSelector), (0, _customer.customerSelector), (0, _shippingRates.shippingRatesSelector), prepareView);
function prepareView(subscriptionState, variantsState, customerState, shippingRatesStates) {
    return exec();
    function exec() {
        if (subscriptionState.isLoading) return {
            state: 'loading'
        };
        if (!subscriptionState.nextOrder) return {
            state: 'inactiveSubscription'
        };
        var nextOrder = (0, _std.unwrap)(subscriptionState.nextOrder);
        return {
            state: 'activeSubscription',
            isRefreshing: subscriptionState.isRefreshing,
            shippingDate: nextOrder.date,
            deliveryDateRange: prepareDeliveryDateRange(),
            frequency: nextOrder.frequency,
            frequencyInWeekOptions: [
                3,
                4,
                5,
                6,
                7,
                8,
                12,
                16,
                20
            ],
            retryDate: nextOrder.retryDate,
            status: nextOrder.status,
            shippingAddress: (0, _std.unwrap)(customerState.entity).shippingAddress,
            lines: prepareLines(),
            totalLinesPrice: nextOrder.totalLinesPrice,
            totalDiscounts: nextOrder.totalDiscounts,
            totalShippingPrice: prepareShippingPrice(),
            totalTaxPrice: Math.ceil(nextOrder.totalPrice / 1.2 * 0.2),
            totalPrice: nextOrder.totalPrice
        };
    }
    function prepareDeliveryDateRange() {
        return (0, _std.calculateEstimatedDeliveryDateRange)((0, _std.unwrap)(subscriptionState.nextOrder).date, (0, _std.unwrap)(customerState.entity).shippingAddress.carrierCode);
    }
    function prepareLines() {
        var lines = selectSubscriptions().map(prepareLine);
        return (0, _toConsumableArray._)(lines).concat((0, _toConsumableArray._)(prepareAddingLine()));
    }
    function prepareAddingLine() {
        if (!subscriptionState.isAddingSubscription) return [];
        return [
            {
                isLoading: true,
                key: 'adding',
                subscriptionId: -1
            }
        ];
    }
    function prepareLine(subscription) {
        if (subscription.isUpdating) return {
            isLoading: true,
            key: subscription.id.toString(),
            subscriptionId: subscription.id
        };
        var variant = selectVariant(subscription.variantId);
        var _variant_picture, _variant_price_oneTime;
        return {
            isLoading: false,
            key: subscription.id.toString(),
            subscriptionId: subscription.id,
            picture: (_variant_picture = variant.picture) !== null && _variant_picture !== void 0 ? _variant_picture : '',
            productTitle: variant.productTitle,
            productSubtitle: variant.productSubtitle,
            variantTitle: variant.variantTitle,
            originalPrice: (_variant_price_oneTime = variant.price.oneTime) !== null && _variant_price_oneTime !== void 0 ? _variant_price_oneTime : subscription.price,
            price: subscription.price,
            quantity: subscription.quantity,
            maxQuantitySelector: variant.maxQuantitySelector,
            bulkDiscount: variant.bulkDiscount,
            quantityIsLoading: subscription.quantityIsLoading,
            actions: prepareActions(subscription)
        };
    }
    function prepareActions(subscription) {
        var subscriptionId = subscription.id;
        var quantity = subscription.quantity;
        return {
            updateQuantity: function(quantity) {
                return (0, _updateSubscriptionQuantity.UpdateSubscriptionQuantity)({
                    subscriptionId: subscriptionId,
                    quantity: quantity
                });
            },
            remove: prepareHandleRemove(subscription)
        };
    }
    function prepareHandleRemove(subscription) {
        return function(params) {
            var subscriptionId = subscription.id;
            if (isLast()) return params.onShouldAskForFeedback(function(feedback) {
                params.onDispatch((0, _removeProductFromSubscription.RemoveProductFromSubscription)({
                    subscriptionId: subscriptionId,
                    feedback: feedback
                }));
            });
            return params.onDispatch((0, _removeProductFromSubscription.RemoveProductFromSubscription)({
                subscriptionId: subscriptionId
            }));
        };
    }
    function selectVariant(variantId) {
        var variant = variantsState.entities.find(function(variant) {
            return variant.variantId === variantId;
        });
        if (!variant) // DEBUG should log to Sentry
        return variantsState.entities[0];
        return variant;
    }
    function prepareShippingPrice() {
        var nextOrder = (0, _std.unwrap)(subscriptionState.nextOrder);
        var shippingRates = shippingRatesStates.entities;
        if (!shippingRates) return nextOrder.totalShippingPrice;
        return computeShippingPriceFromRates();
    }
    function isLast() {
        return subscriptionState.subscriptions.filter(function(current) {
            return current.status === 'ACTIVE';
        }).length === 1;
    }
    function computeShippingPriceFromRates() {
        var shippingRates = (0, _std.unwrap)(shippingRatesStates.entities);
        var shippingAddress = (0, _std.unwrap)(customerState.entity).shippingAddress;
        var nextOrder = (0, _std.unwrap)(subscriptionState.nextOrder);
        var filteredRates = shippingRates.filter(function(rate) {
            return rate.carrier === shippingAddress.carrierCode && rate.country === shippingAddress.countryCode && rate.minimalOrderTotalInCents <= nextOrder.totalLinesPrice;
        });
        if (filteredRates.length === 0) throw new Error(`Cannot find rates for carrier: ${shippingAddress.carrierCode}, country: ${shippingAddress.countryCode}, orderTotal: ${nextOrder.totalLinesPrice}`);
        var bestRate = filteredRates.reduce(function(minRate, currentRate) {
            return currentRate.priceInCents < minRate.priceInCents ? currentRate : minRate;
        });
        return bestRate.priceInCents;
    }
    function selectSubscriptions() {
        var subscriptions = subscriptionState.subscriptions;
        var lines = (0, _std.unwrap)(subscriptionState.nextOrder).lines;
        return lines.map(function(line) {
            return (0, _std.unwrap)(subscriptions.find(function(subscription) {
                return subscription.id === line.subscriptionId;
            }));
        });
    }
}

},{"@swc/helpers/_/_to_consumable_array":"eqNDD","reselect":"fb6q1","../store/state/data/customerSubscription":"3ipiV","../store/state/data/variants":"11hc8","../store/state/data/customer":"hDp3A","@reglo/std":"1USo0","../store/state/data/shippingRates":"9lFur","../useCases/updateSubscriptionQuantity":"2ruvf","../useCases/removeProductFromSubscription":"eGpss","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"calNm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Details", function() {
    return Details;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _accountCard = require("../../components/AccountCard");
var _editableInfo = require("../../components/EditableInfo");
var _prepareShippingAddress = require("../../functions/prepareShippingAddress");
var _std = require("@reglo/std");
var _hooks = require("../../../../../std/hooks");
var _editAddress = require("./EditAddress");
function Details(props) {
    var view = props.view;
    var _useTrigger = (0, _slicedToArray._)((0, _hooks.useTrigger)(), 2), onStartAddressEdit = _useTrigger[0], startAddressEdit = _useTrigger[1];
    if (!view) return null;
    var prepareAddress = function() {
        return (0, _prepareShippingAddress.prepareShippingAddress)(view.shippingAddress);
    };
    var isAddressEditable = function() {
        return view.shippingAddress.carrierCode !== (0, _std.Carrier).MONDIAL_RELAY;
    };
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _accountCard.AccountCard), {
        children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
            className: "accountSubscription__details__container",
            children: [
                /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _editableInfo.EditableInfo), {
                    title: "Mode de livraison",
                    content: view.shippingAddress.carrier,
                    onStartEdit: function() {
                        return console.log('edit carrier');
                    },
                    isEditable: false
                }, void 0, false, {
                    fileName: "src/script/src/dom/views/Account/views/Subscription/Details.tsx",
                    lineNumber: 26,
                    columnNumber: 17
                }, this),
                /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _editableInfo.EditableInfo), {
                    title: prepareAddress().title,
                    content: prepareAddress().address,
                    onStartEdit: startAddressEdit,
                    isEditable: isAddressEditable()
                }, void 0, false, {
                    fileName: "src/script/src/dom/views/Account/views/Subscription/Details.tsx",
                    lineNumber: 32,
                    columnNumber: 17
                }, this),
                /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _editAddress.EditAddress), {
                    onStartEdit: onStartAddressEdit,
                    view: view
                }, void 0, false, {
                    fileName: "src/script/src/dom/views/Account/views/Subscription/Details.tsx",
                    lineNumber: 38,
                    columnNumber: 17
                }, this)
            ]
        }, void 0, true, {
            fileName: "src/script/src/dom/views/Account/views/Subscription/Details.tsx",
            lineNumber: 25,
            columnNumber: 13
        }, this)
    }, void 0, false, {
        fileName: "src/script/src/dom/views/Account/views/Subscription/Details.tsx",
        lineNumber: 24,
        columnNumber: 9
    }, this);
}

},{"@swc/helpers/_/_sliced_to_array":"ha6sq","react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","../../components/AccountCard":"foulu","../../components/EditableInfo":"j35EA","../../functions/prepareShippingAddress":"4WRgM","@reglo/std":"1USo0","../../../../../std/hooks":"j9RPQ","./EditAddress":"84JOb","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"84JOb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EditAddress", function() {
    return EditAddress;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _modal = require("../../../../components/Modal");
var _reactRedux = require("react-redux");
var _hooks = require("../../../../../std/hooks");
var _textField = require("../../components/TextField");
var _select = require("../../../../../../../snippets/components/select");
var _inputGroup = require("../../components/InputGroup");
var _std = require("@reglo/std");
var _form = require("../../components/Form");
var _updateShippingAddress = require("../../../../../app/useCases/updateShippingAddress");
function EditAddress(props) {
    var view = props.view;
    var dispatch = (0, _reactRedux.useDispatch)();
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), opened = _useState[0], setOpened = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(false), 2), submitting = _useState1[0], setSubmitting = _useState1[1];
    var formId = (0, _form.useFormId)();
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)(view.shippingAddress.countryCode), 2), countryCode = _useState2[0], setCountryCode = _useState2[1];
    var _useState3 = (0, _slicedToArray._)((0, _react.useState)(view.shippingAddress.firstName), 2), firstName = _useState3[0], setFirstName = _useState3[1];
    var _useState4 = (0, _slicedToArray._)((0, _react.useState)(view.shippingAddress.lastName), 2), lastName = _useState4[0], setLastName = _useState4[1];
    var _useState5 = (0, _slicedToArray._)((0, _react.useState)(view.shippingAddress.address1), 2), address1 = _useState5[0], setAddress1 = _useState5[1];
    var _useState6 = (0, _slicedToArray._)((0, _react.useState)(view.shippingAddress.address2), 2), address2 = _useState6[0], setAddress2 = _useState6[1];
    var _useState7 = (0, _slicedToArray._)((0, _react.useState)(view.shippingAddress.zipCode), 2), zipCode = _useState7[0], setZipCode = _useState7[1];
    var _useState8 = (0, _slicedToArray._)((0, _react.useState)(view.shippingAddress.city), 2), city = _useState8[0], setCity = _useState8[1];
    var _useState9 = (0, _slicedToArray._)((0, _react.useState)(view.shippingAddress.phone), 2), phone = _useState9[0], setPhone = _useState9[1];
    var countryOptions = [
        {
            value: (0, _std.CountryCode).FR,
            label: 'France'
        },
        {
            value: (0, _std.CountryCode).BE,
            label: 'Belgique'
        },
        {
            value: (0, _std.CountryCode).LU,
            label: 'Luxembourg'
        }
    ];
    props.onStartEdit(open);
    (0, _hooks.useOnEvent)((0, _updateShippingAddress.ShippingAddressUpdatedKey), close);
    function open() {
        setOpened(true);
        setSubmitting(false);
    }
    function close() {
        setOpened(false);
        setSubmitting(false);
    }
    function handleSubmit() {
        var shippingAddress = (0, _updateShippingAddress.formatShippingAddress)({
            firstName: firstName,
            lastName: lastName,
            address1: address1,
            address2: address2,
            zipCode: zipCode,
            city: city,
            countryCode: countryCode,
            phone: phone
        });
        dispatch((0, _updateShippingAddress.UpdateShippingAddress)({
            shippingAddress: shippingAddress
        }));
        setSubmitting(true);
    }
    if (!opened) return null;
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _modal.Modal), {
        title: "Modifier mon adresse de livraison",
        ctas: [
            {
                isInverted: true,
                label: 'Annuler',
                onClick: close
            },
            {
                label: 'Enregistrer',
                formToSubmit: formId,
                isLoading: submitting
            }
        ],
        className: "accountSubscriptionEditNextOrderDate",
        onClose: close,
        children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
            className: "container",
            children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _form.Form), {
                onSubmit: handleSubmit,
                id: formId,
                children: [
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _inputGroup.InputGroup), {
                        children: [
                            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _textField.TextField), {
                                label: "Pr\xe9nom *",
                                required: true,
                                value: firstName,
                                onChange: setFirstName
                            }, void 0, false, {
                                fileName: "src/script/src/dom/views/Account/views/Subscription/EditAddress.tsx",
                                lineNumber: 74,
                                columnNumber: 25
                            }, this),
                            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _textField.TextField), {
                                label: "Nom *",
                                required: true,
                                value: lastName,
                                onChange: setLastName
                            }, void 0, false, {
                                fileName: "src/script/src/dom/views/Account/views/Subscription/EditAddress.tsx",
                                lineNumber: 75,
                                columnNumber: 25
                            }, this)
                        ]
                    }, void 0, true, {
                        fileName: "src/script/src/dom/views/Account/views/Subscription/EditAddress.tsx",
                        lineNumber: 73,
                        columnNumber: 21
                    }, this),
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _textField.TextField), {
                        label: "Adresse *",
                        required: true,
                        value: address1,
                        onChange: setAddress1
                    }, void 0, false, {
                        fileName: "src/script/src/dom/views/Account/views/Subscription/EditAddress.tsx",
                        lineNumber: 77,
                        columnNumber: 21
                    }, this),
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _textField.TextField), {
                        label: "Appartement, suite, etc.",
                        value: address2,
                        onChange: setAddress2
                    }, void 0, false, {
                        fileName: "src/script/src/dom/views/Account/views/Subscription/EditAddress.tsx",
                        lineNumber: 78,
                        columnNumber: 21
                    }, this),
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _inputGroup.InputGroup), {
                        children: [
                            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _textField.TextField), {
                                label: "Code postal *",
                                required: true,
                                value: zipCode,
                                onChange: setZipCode
                            }, void 0, false, {
                                fileName: "src/script/src/dom/views/Account/views/Subscription/EditAddress.tsx",
                                lineNumber: 80,
                                columnNumber: 25
                            }, this),
                            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _textField.TextField), {
                                label: "Ville *",
                                required: true,
                                value: city,
                                onChange: setCity
                            }, void 0, false, {
                                fileName: "src/script/src/dom/views/Account/views/Subscription/EditAddress.tsx",
                                lineNumber: 81,
                                columnNumber: 25
                            }, this)
                        ]
                    }, void 0, true, {
                        fileName: "src/script/src/dom/views/Account/views/Subscription/EditAddress.tsx",
                        lineNumber: 79,
                        columnNumber: 21
                    }, this),
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _select.Select), {
                        label: "Pays *",
                        required: true,
                        options: countryOptions,
                        onChange: setCountryCode,
                        value: countryCode
                    }, void 0, false, {
                        fileName: "src/script/src/dom/views/Account/views/Subscription/EditAddress.tsx",
                        lineNumber: 83,
                        columnNumber: 21
                    }, this),
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _textField.TextField), {
                        label: "T\xe9l\xe9phone pour le livreur *",
                        required: true,
                        value: phone,
                        onChange: setPhone
                    }, void 0, false, {
                        fileName: "src/script/src/dom/views/Account/views/Subscription/EditAddress.tsx",
                        lineNumber: 84,
                        columnNumber: 21
                    }, this)
                ]
            }, void 0, true, {
                fileName: "src/script/src/dom/views/Account/views/Subscription/EditAddress.tsx",
                lineNumber: 72,
                columnNumber: 17
            }, this)
        }, void 0, false, {
            fileName: "src/script/src/dom/views/Account/views/Subscription/EditAddress.tsx",
            lineNumber: 71,
            columnNumber: 13
        }, this)
    }, void 0, false, {
        fileName: "src/script/src/dom/views/Account/views/Subscription/EditAddress.tsx",
        lineNumber: 62,
        columnNumber: 9
    }, this);
}

},{"@swc/helpers/_/_sliced_to_array":"ha6sq","react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","../../../../components/Modal":"1uIeH","react-redux":"ghMZu","../../../../../std/hooks":"j9RPQ","../../components/TextField":"hdX1l","../../../../../../../snippets/components/select":"fqaEu","../../components/InputGroup":"iTFI2","@reglo/std":"1USo0","../../components/Form":"iExNs","../../../../../app/useCases/updateShippingAddress":"bzbXd","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"hdX1l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TextField", function() {
    return TextField;
});
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _input = require("./Input");
function TextField(props) {
    var id = (0, _input.inputId)();
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _input.Input), {
        label: props.label,
        id: id,
        children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("input", {
            id: id,
            className: "componentTextField__field",
            required: props.required,
            value: props.value,
            onChange: function(event) {
                return props.onChange(event.target.value);
            }
        }, void 0, false, {
            fileName: "src/script/src/dom/views/Account/components/TextField.tsx",
            lineNumber: 14,
            columnNumber: 13
        }, this)
    }, void 0, false, {
        fileName: "src/script/src/dom/views/Account/components/TextField.tsx",
        lineNumber: 13,
        columnNumber: 9
    }, this);
}

},{"react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","./Input":"3dkG8","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"iTFI2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InputGroup", function() {
    return InputGroup;
});
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function InputGroup(props) {
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
        className: "componentInputGroup",
        children: props.children
    }, void 0, false, {
        fileName: "src/script/src/dom/views/Account/components/InputGroup.tsx",
        lineNumber: 7,
        columnNumber: 9
    }, this);
}

},{"react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6gNLC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LastOrder", function() {
    return LastOrder;
});
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _accountCard = require("../../components/AccountCard");
var _std = require("@reglo/std");
var _lastOrderView = require("../../../../../app/views/lastOrderView");
var _statusLabel = require("../../functions/statusLabel");
var _cta = require("../../../../components/Cta");
function LastOrder() {
    var view = (0, _reactRedux.useSelector)((0, _lastOrderView.lastOrderView));
    if (view.state === 'loading') return null;
    if (!view.order) return null;
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _accountCard.AccountCard), {
        title: "Derni\xe8re commande",
        children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(Content, {
            view: view.order
        }, void 0, false, {
            fileName: "src/script/src/dom/views/Account/views/Subscription/LastOrder.tsx",
            lineNumber: 24,
            columnNumber: 13
        }, this)
    }, void 0, false, {
        fileName: "src/script/src/dom/views/Account/views/Subscription/LastOrder.tsx",
        lineNumber: 21,
        columnNumber: 9
    }, this);
}
function Content(props) {
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
        className: "account__mySubscription__lastOrder",
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                className: "account__mySubscription__lastOrder__status",
                children: [
                    "Commande du ",
                    (0, _std.formatDate)(props.view.date),
                    " : ",
                    (0, _statusLabel.statusLabel)(props.view.status)
                ]
            }, void 0, true, {
                fileName: "src/script/src/dom/views/Account/views/Subscription/LastOrder.tsx",
                lineNumber: 34,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                className: "account__mySubscription__lastOrder__tracking",
                children: props.view.trackingLinks.map(renderTrackingLink)
            }, void 0, false, {
                fileName: "src/script/src/dom/views/Account/views/Subscription/LastOrder.tsx",
                lineNumber: 37,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _cta.Cta), {
                className: "account__mySubscription__lastOrder__detailsCta",
                label: "Voir le d\xe9tail",
                isInverted: true,
                size: "XS",
                linkTo: "/pages/commandes/derniere"
            }, void 0, false, {
                fileName: "src/script/src/dom/views/Account/views/Subscription/LastOrder.tsx",
                lineNumber: 40,
                columnNumber: 13
            }, this)
        ]
    }, void 0, true, {
        fileName: "src/script/src/dom/views/Account/views/Subscription/LastOrder.tsx",
        lineNumber: 33,
        columnNumber: 9
    }, this);
    function renderTrackingLink(link, index) {
        var title = props.view.trackingLinks.length > 1 ? `Suivre le colis ${index + 1}` : `Suivre mon colis`;
        return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("a", {
            href: link,
            className: "link",
            target: "_blank",
            children: title
        }, link, false, {
            fileName: "src/script/src/dom/views/Account/views/Subscription/LastOrder.tsx",
            lineNumber: 52,
            columnNumber: 16
        }, this);
    }
}

},{"react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","react-redux":"ghMZu","../../components/AccountCard":"foulu","@reglo/std":"1USo0","../../../../../app/views/lastOrderView":"ewcjJ","../../functions/statusLabel":"dlTaP","../../../../components/Cta":"beDOe","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"ewcjJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "lastOrderView", function() {
    return lastOrderView;
});
var _reselect = require("reselect");
var _orders = require("../store/state/data/orders");
var _variants = require("../store/state/data/variants");
var _prepareOrderView = require("./services/prepareOrderView");
var lastOrderView = (0, _reselect.createSelector)((0, _orders.ordersSelector), (0, _variants.variantsSelector), prepareView);
function prepareView(ordersState, variantsState) {
    if (isLoading()) return {
        state: 'loading'
    };
    var order = prepareOrder();
    return {
        state: 'ready',
        order: order
    };
    function prepareOrder() {
        var order = selectOrder();
        if (!order) return null;
        return (0, _prepareOrderView.prepareOrderView)(order, variantsState);
    }
    function isLoading() {
        return ordersState.isLoading;
    }
    function selectOrder() {
        if (!ordersState.entities) return null;
        var orders = ordersState.entities.sort(function(a, b) {
            return b.date.getTime() - a.date.getTime();
        });
        return orders[0];
    }
}

},{"reselect":"fb6q1","../store/state/data/orders":"4hVLS","../store/state/data/variants":"11hc8","./services/prepareOrderView":"4Ug3S","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"fJSro":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PaymentMethod", function() {
    return PaymentMethod;
});
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _paymentMethodView = require("../../../../../app/views/paymentMethodView");
var _std = require("@reglo/std");
var _preparePaymentErrorMessage = require("../../functions/preparePaymentErrorMessage");
var _updatePaymentMethodCta = require("../../components/UpdatePaymentMethodCta");
var _layout = require("../Layout");
var _hooks = require("../../../../../std/hooks");
var _loadAccountSaga = require("../../../../../app/sagas/loadAccountSaga");
function PaymentMethod() {
    var view = (0, _reactRedux.useSelector)((0, _paymentMethodView.paymentMethodView));
    var dispatch = (0, _hooks.useDispatch)();
    var isLoading = !view;
    (0, _react.useEffect)(function() {
        dispatch((0, _loadAccountSaga.LoadAccount)());
    }, []);
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _layout.Layout), {
        page: (0, _layout.Page).PaymentMethod,
        isLoading: isLoading,
        children: view && /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
            className: "pagePaymentMethod",
            children: [
                /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("h3", {
                    className: "title",
                    children: "Moyen de paiement"
                }, void 0, false, {
                    fileName: "src/script/src/dom/views/Account/views/PaymentMethod/PaymentMethod.tsx",
                    lineNumber: 22,
                    columnNumber: 17
                }, this),
                /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                    className: "card",
                    children: [
                        /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(Details, {
                            method: view.current
                        }, void 0, false, {
                            fileName: "src/script/src/dom/views/Account/views/PaymentMethod/PaymentMethod.tsx",
                            lineNumber: 24,
                            columnNumber: 21
                        }, this),
                        /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(Error, {
                            method: view.current
                        }, void 0, false, {
                            fileName: "src/script/src/dom/views/Account/views/PaymentMethod/PaymentMethod.tsx",
                            lineNumber: 25,
                            columnNumber: 21
                        }, this),
                        /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(Update, {
                            method: view.current
                        }, void 0, false, {
                            fileName: "src/script/src/dom/views/Account/views/PaymentMethod/PaymentMethod.tsx",
                            lineNumber: 26,
                            columnNumber: 21
                        }, this)
                    ]
                }, void 0, true, {
                    fileName: "src/script/src/dom/views/Account/views/PaymentMethod/PaymentMethod.tsx",
                    lineNumber: 23,
                    columnNumber: 17
                }, this)
            ]
        }, void 0, true, {
            fileName: "src/script/src/dom/views/Account/views/PaymentMethod/PaymentMethod.tsx",
            lineNumber: 21,
            columnNumber: 22
        }, this)
    }, void 0, false, {
        fileName: "src/script/src/dom/views/Account/views/PaymentMethod/PaymentMethod.tsx",
        lineNumber: 20,
        columnNumber: 9
    }, this);
}
function Details(props) {
    var _this = this;
    var method = props.method;
    if (!method) return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _jsxDevRuntime.Fragment), {
        children: "Aucun moyen de paiement enregistr\xe9"
    }, void 0, false);
    var prepareTitle = function() {
        var details = method.details;
        if (details.type === 'CREDIT_CARD') return details.brand;
        return 'PayPal';
    };
    var renderDetails = function() {
        var details = method.details;
        if (details.type === 'CREDIT_CARD') return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _jsxDevRuntime.Fragment), {
            children: [
                "Carte terminant par **** ",
                details.lastDigits,
                /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("br", {}, void 0, false, {
                    fileName: "src/script/src/dom/views/Account/views/PaymentMethod/PaymentMethod.tsx",
                    lineNumber: 57,
                    columnNumber: 66
                }, _this),
                "Expire le ",
                (0, _std.addLeadingZeros)(details.expirationMonth, 2),
                "/",
                details.expirationYear
            ]
        }, void 0, true);
        return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _jsxDevRuntime.Fragment), {
            children: [
                "Compte PayPal de ",
                details.email
            ]
        }, void 0, true);
    };
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _jsxDevRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                className: "cardTitle",
                children: prepareTitle()
            }, void 0, false, {
                fileName: "src/script/src/dom/views/Account/views/PaymentMethod/PaymentMethod.tsx",
                lineNumber: 71,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                children: renderDetails()
            }, void 0, false, {
                fileName: "src/script/src/dom/views/Account/views/PaymentMethod/PaymentMethod.tsx",
                lineNumber: 72,
                columnNumber: 13
            }, this)
        ]
    }, void 0, true);
}
function Error(props) {
    var method = props.method;
    function renderErrorDate() {
        return (0, _std.formatDate)((0, _std.unwrap)(method === null || method === void 0 ? void 0 : method.errorDate), {
            withTime: true,
            withYear: true,
            withShortMonth: true
        });
    }
    if (!method || !method.error) return null;
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
        className: "errorMessage",
        children: [
            "Paiement refus\xe9 le ",
            renderErrorDate(),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("br", {}, void 0, false, {
                fileName: "src/script/src/dom/views/Account/views/PaymentMethod/PaymentMethod.tsx",
                lineNumber: 96,
                columnNumber: 51
            }, this),
            method.error && `Message\xa0: ${(0, _preparePaymentErrorMessage.preparePaymentErrorMessage)(method.error)}`
        ]
    }, void 0, true, {
        fileName: "src/script/src/dom/views/Account/views/PaymentMethod/PaymentMethod.tsx",
        lineNumber: 95,
        columnNumber: 9
    }, this);
}
function Update(props) {
    if (!props.method) return null;
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _updatePaymentMethodCta.UpdatePaymentMethodCta), {}, void 0, false, {
        fileName: "src/script/src/dom/views/Account/views/PaymentMethod/PaymentMethod.tsx",
        lineNumber: 110,
        columnNumber: 9
    }, this);
}

},{"react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","react-redux":"ghMZu","../../../../../app/views/paymentMethodView":"gJxSE","@reglo/std":"1USo0","../../functions/preparePaymentErrorMessage":"uv4f0","../../components/UpdatePaymentMethodCta":"8QdZK","../Layout":"gnkXt","../../../../../std/hooks":"j9RPQ","../../../../../app/sagas/loadAccountSaga":"fo1BR","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gJxSE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "paymentMethodView", function() {
    return paymentMethodView;
});
var _reselect = require("reselect");
var _customerSubscription = require("../store/state/data/customerSubscription");
var paymentMethodView = (0, _reselect.createSelector)((0, _customerSubscription.customerSubscriptionSelector), prepareView);
function prepareView(subscriptionState) {
    if (subscriptionState.isLoading) return null;
    return {
        current: prepareDetails(subscriptionState)
    };
}
function prepareDetails(subscriptionState) {
    var paymentMethod = subscriptionState.paymentMethod;
    if (!paymentMethod) return null;
    return {
        details: paymentMethod.details,
        status: paymentMethod.status,
        error: paymentMethod.error,
        errorDate: paymentMethod.errorDate
    };
}

},{"reselect":"fb6q1","../store/state/data/customerSubscription":"3ipiV","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"caL9L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Login", function() {
    return Login;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _isValidEmail = require("../../../../services/isValidEmail");
var _hooks = require("../../../../../std/hooks");
var _form = require("./Form");
var _input = require("./Input");
var _recoverPassword = require("../../../../../app/useCases/recoverPassword");
var _logInAccount = require("../../../../../app/useCases/logInAccount");
var _verifyAccountExistence = require("../../../../../app/useCases/verifyAccountExistence");
var _cta = require("./Cta");
var _std = require("@reglo/std");
function Login() {
    var _useState = (0, _slicedToArray._)((0, _react.useState)(null), 2), notification = _useState[0], setNotification = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)('emailVerification'), 2), form = _useState1[0], setForm = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)(''), 2), email = _useState2[0], setEmail = _useState2[1];
    var _useState3 = (0, _slicedToArray._)((0, _react.useState)(''), 2), password = _useState3[0], setPassword = _useState3[1];
    var _useState4 = (0, _slicedToArray._)((0, _react.useState)(false), 2), isLoading = _useState4[0], setIsLoading = _useState4[1];
    var dispatch = (0, _hooks.useDispatch)();
    var navigate = (0, _reactRouterDom.useNavigate)();
    var location = (0, _reactRouterDom.useLocation)();
    var redirectTo = getRedirectTo();
    (0, _hooks.useOnEvent)((0, _verifyAccountExistence.CustomerHasAccountKey), function() {
        setForm('login');
        setPassword('');
        setNotification(null);
        setIsLoading(false);
    });
    (0, _hooks.useOnEvent)((0, _verifyAccountExistence.CustomerHasNoAccountKey), accessRegisterForm);
    (0, _hooks.useOnEvent)((0, _verifyAccountExistence.AccountActivationEmailSentKey), function() {
        setForm('activationRequested');
        setNotification({
            type: 'success',
            message: `Nous avons envoy\xe9 un e-mail \xe0 ${email}, merci de suivre les instructions contenues dans cet e-mail pour activer votre compte.`
        });
        setIsLoading(false);
    });
    (0, _hooks.useOnEvent)((0, _logInAccount.AccountLoginSucceedKey), function(event) {
        var _event_payload_redirectTo;
        window.location.href = (_event_payload_redirectTo = event.payload.redirectTo) !== null && _event_payload_redirectTo !== void 0 ? _event_payload_redirectTo : '/pages/mon-compte';
    });
    (0, _hooks.useOnEvent)((0, _logInAccount.AccountLoginFailedKey), function(event) {
        setPassword('');
        setNotification({
            type: 'error',
            message: event.payload.error
        });
        setIsLoading(false);
    });
    (0, _hooks.useOnEvent)((0, _recoverPassword.PasswordRecoverEmailSentKey), function() {
        setPassword('password');
        setNotification({
            type: 'success',
            message: "Un lien pour r\xe9initialiser votre mot de passe vous a \xe9t\xe9 envoy\xe9 par e-mail."
        });
        setIsLoading(false);
    });
    (0, _hooks.useOnEvent)((0, _recoverPassword.PasswordRecoveringFailedKey), function(event) {
        setNotification({
            type: 'error',
            message: event.payload.error
        });
        setIsLoading(false);
    });
    function handleSubmit() {
        setIsLoading(true);
        dispatch(submitEvent());
    }
    function submitEvent() {
        switch(form){
            case 'emailVerification':
                return (0, _verifyAccountExistence.VerifyAccountExistence)({
                    email: email
                });
            case 'login':
                return (0, _logInAccount.LogInAccount)({
                    email: email,
                    password: password,
                    redirectTo: redirectTo
                });
            case 'recover':
                return (0, _recoverPassword.RecoverPassword)({
                    email: email
                });
            case 'activationRequested':
                return;
            default:
                (0, _std.assertNever)(form);
        }
    }
    function getRedirectTo() {
        return new URLSearchParams(location.search).get('checkout_url');
    }
    function accessRecoverForm() {
        setNotification(null);
        setIsLoading(false);
        setForm('recover');
    }
    function accessLoginForm() {
        setNotification(null);
        setIsLoading(false);
        setForm('emailVerification');
    }
    function accessRegisterForm() {
        navigate('/account/register', {
            state: {
                email: email
            }
        });
    }
    function isDisabled() {
        switch(form){
            case 'emailVerification':
            case 'recover':
                return !(0, _isValidEmail.isValidEmail)(email);
            case 'login':
                return !(0, _isValidEmail.isValidEmail)(email) || !password;
            case 'activationRequested':
                return false;
        }
    }
    function prepareTitle() {
        switch(form){
            case 'emailVerification':
                return 'Mon compte client';
            case 'login':
                return 'Me connecter';
            case 'recover':
                return "Mot de passe oubli\xe9\xa0?";
            case 'activationRequested':
                return "Premi\xe8re connexion";
        }
    }
    function prepareDescription() {
        switch(form){
            case 'emailVerification':
                return 'Saissisez votre adresse e-mail.';
            case 'recover':
                return "Nous allons vous envoyer des instructions par e-mail pour r\xe9initialiser le mot de passe.";
            case 'login':
                return 'Saissisez votre mot de passe.';
            case 'activationRequested':
                return "Vous vous connectez \xe0 votre compte pour la premi\xe8re fois.";
            default:
                (0, _std.assertNever)(form);
        }
    }
    function prepareCtaLabel() {
        switch(form){
            case 'emailVerification':
                return 'Valider';
            case 'login':
                return 'Me connecter';
            case 'recover':
                return "R\xe9initialiser le mot de passe";
            case 'activationRequested':
                return '';
        }
    }
    function hasLoginInput() {
        return form !== 'activationRequested';
    }
    function hasPasswordInput() {
        return form === 'login';
    }
    function hasCta() {
        return form !== 'activationRequested';
    }
    function renderHelperLink() {
        switch(form){
            case 'recover':
            case 'activationRequested':
                return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("a", {
                    onClick: accessLoginForm,
                    children: "Retour \xe0 la page de connexion"
                }, void 0, false, {
                    fileName: "src/script/src/dom/views/Account/views/Login/Login.tsx",
                    lineNumber: 183,
                    columnNumber: 24
                }, this);
            case 'login':
            case 'emailVerification':
                return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _jsxDevRuntime.Fragment), {
                    children: [
                        "Nouveau chez R\xe9glo\xa0? ",
                        /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("a", {
                            onClick: accessRegisterForm,
                            children: "Cr\xe9ez votre compte"
                        }, void 0, false, {
                            fileName: "src/script/src/dom/views/Account/views/Login/Login.tsx",
                            lineNumber: 186,
                            columnNumber: 47
                        }, this)
                    ]
                }, void 0, true);
            default:
                (0, _std.assertNever)(form);
        }
    }
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _form.Form), {
        title: prepareTitle(),
        description: prepareDescription(),
        notification: notification !== null && notification !== void 0 ? notification : undefined,
        onSubmit: handleSubmit,
        isLoading: isLoading,
        children: [
            hasLoginInput() && /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _input.Input), {
                label: "Adresse e-mail",
                type: "login",
                value: email,
                onChange: setEmail
            }, void 0, false, {
                fileName: "src/script/src/dom/views/Account/views/Login/Login.tsx",
                lineNumber: 200,
                columnNumber: 33
            }, this),
            hasPasswordInput() && /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _input.Input), {
                label: "Mot de passe",
                type: "password",
                value: password,
                onChange: setPassword,
                instruction: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("a", {
                    onClick: accessRecoverForm,
                    children: "Mot de passe oubli\xe9\xa0?"
                }, void 0, false, {
                    fileName: "src/script/src/dom/views/Account/views/Login/Login.tsx",
                    lineNumber: 211,
                    columnNumber: 30
                }, void 0)
            }, void 0, false, {
                fileName: "src/script/src/dom/views/Account/views/Login/Login.tsx",
                lineNumber: 206,
                columnNumber: 36
            }, this),
            hasCta() && /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _cta.Cta), {
                label: prepareCtaLabel(),
                isDisabled: isDisabled()
            }, void 0, false, {
                fileName: "src/script/src/dom/views/Account/views/Login/Login.tsx",
                lineNumber: 213,
                columnNumber: 26
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                className: "accountLogin_form__links",
                children: renderHelperLink()
            }, void 0, false, {
                fileName: "src/script/src/dom/views/Account/views/Login/Login.tsx",
                lineNumber: 217,
                columnNumber: 14
            }, this)
        ]
    }, void 0, true, {
        fileName: "src/script/src/dom/views/Account/views/Login/Login.tsx",
        lineNumber: 193,
        columnNumber: 9
    }, this);
}

},{"@swc/helpers/_/_sliced_to_array":"ha6sq","react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","react-router-dom":"9VDGr","../../../../services/isValidEmail":"ckWap","../../../../../std/hooks":"j9RPQ","./Form":"hakLH","./Input":"30BMV","../../../../../app/useCases/recoverPassword":"1c5YK","../../../../../app/useCases/logInAccount":"iGbZs","../../../../../app/useCases/verifyAccountExistence":"6e41n","./Cta":"9uy0y","@reglo/std":"1USo0","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"ckWap":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isValidEmail", function() {
    return isValidEmail;
});
function isValidEmail(email) {
    return email.match(/.+@.{2,}\.[^.]{2,}/) !== null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"hakLH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Form", function() {
    return Form;
});
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _notification = require("./Notification");
var _circleLoader = require("../../../../../../../snippets/components/circleLoader");
function Form(props) {
    var notification = props.notification, description = props.description;
    function handleSubmit(event) {
        event.preventDefault();
        props.onSubmit();
    }
    var _props_isLoading;
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
        className: "accountLogin_form",
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _circleLoader.CircleLoader), {
                loading: (_props_isLoading = props.isLoading) !== null && _props_isLoading !== void 0 ? _props_isLoading : false,
                opacityLayer: true
            }, void 0, false, {
                fileName: "src/script/src/dom/views/Account/views/Login/Form.tsx",
                lineNumber: 22,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                className: "accountLogin_form__sectionContainer",
                children: [
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("h1", {
                        className: "accountLogin_form__title",
                        children: props.title
                    }, void 0, false, {
                        fileName: "src/script/src/dom/views/Account/views/Login/Form.tsx",
                        lineNumber: 24,
                        columnNumber: 17
                    }, this),
                    description && /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                        className: "accountLogin_form__description",
                        children: description
                    }, void 0, false, {
                        fileName: "src/script/src/dom/views/Account/views/Login/Form.tsx",
                        lineNumber: 25,
                        columnNumber: 33
                    }, this),
                    notification && /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _notification.Notification), {
                        value: notification
                    }, void 0, false, {
                        fileName: "src/script/src/dom/views/Account/views/Login/Form.tsx",
                        lineNumber: 26,
                        columnNumber: 34
                    }, this),
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("form", {
                        className: "accountLogin_form__inputs",
                        onSubmit: handleSubmit,
                        children: props.children
                    }, void 0, false, {
                        fileName: "src/script/src/dom/views/Account/views/Login/Form.tsx",
                        lineNumber: 27,
                        columnNumber: 17
                    }, this)
                ]
            }, void 0, true, {
                fileName: "src/script/src/dom/views/Account/views/Login/Form.tsx",
                lineNumber: 23,
                columnNumber: 13
            }, this)
        ]
    }, void 0, true, {
        fileName: "src/script/src/dom/views/Account/views/Login/Form.tsx",
        lineNumber: 21,
        columnNumber: 9
    }, this);
}

},{"react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","./Notification":"8m3gF","../../../../../../../snippets/components/circleLoader":"6ifIi","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8m3gF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Notification", function() {
    return Notification;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
function Notification(props) {
    var className = (0, _classnamesDefault.default)((0, _defineProperty._)({
        accountLogin_notification: true
    }, `accountLogin_notification--${props.value.type}`, true));
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
        className: className,
        children: props.value.message
    }, void 0, false, {
        fileName: "src/script/src/dom/views/Account/views/Login/Notification.tsx",
        lineNumber: 18,
        columnNumber: 9
    }, this);
}

},{"@swc/helpers/_/_define_property":"54Zvk","react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","classnames":"4SuBi","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"30BMV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Input", function() {
    return Input;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _std = require("@reglo/std");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
function Input(props) {
    var _useState = (0, _slicedToArray._)((0, _react.useState)((0, _std.uuid)()), 1), id = _useState[0];
    var attributes = (0, _objectSpread._)({
        name: props.type
    }, props.type === 'firstName' && {
        type: 'text',
        autoComplete: 'given-name',
        required: true
    }, props.type === 'lastName' && {
        type: 'text',
        autoComplete: 'family-name',
        required: true
    }, props.type === 'login' && {
        type: 'email',
        autoComplete: 'username',
        autoCorrect: 'off',
        autoCapitalize: 'off',
        required: true
    }, props.type === 'password' && {
        type: 'password',
        autoComplete: 'current-password',
        required: true
    }, props.type === 'newPassword' && {
        type: 'password',
        autoComplete: 'password',
        required: true
    });
    var className = (0, _classnamesDefault.default)({
        accountLogin_input: true,
        'accountLogin_input--error': !!props.error
    });
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("label", {
                className: "accountLogin_input__label",
                htmlFor: id,
                children: props.label
            }, void 0, false, {
                fileName: "src/script/src/dom/views/Account/views/Login/Input.tsx",
                lineNumber: 52,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("input", (0, _objectSpread._)({
                id: id,
                className: "accountLogin_input__field",
                value: props.value,
                onChange: function(event) {
                    return props.onChange(event.target.value);
                }
            }, attributes), void 0, false, {
                fileName: "src/script/src/dom/views/Account/views/Login/Input.tsx",
                lineNumber: 58,
                columnNumber: 13
            }, this),
            props.error && /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                className: "accountLogin_input__error",
                children: props.error
            }, void 0, false, {
                fileName: "src/script/src/dom/views/Account/views/Login/Input.tsx",
                lineNumber: 65,
                columnNumber: 29
            }, this),
            props.instruction
        ]
    }, void 0, true, {
        fileName: "src/script/src/dom/views/Account/views/Login/Input.tsx",
        lineNumber: 51,
        columnNumber: 9
    }, this);
}

},{"@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_sliced_to_array":"ha6sq","react/jsx-dev-runtime":"jXZ8I","@reglo/std":"1USo0","react":"c8CN1","classnames":"4SuBi","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1c5YK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RecoverPasswordKey", function() {
    return RecoverPasswordKey;
});
parcelHelpers.export(exports, "RecoverPassword", function() {
    return RecoverPassword;
});
parcelHelpers.export(exports, "PasswordRecoveringFailedKey", function() {
    return PasswordRecoveringFailedKey;
});
parcelHelpers.export(exports, "PasswordRecoveringFailed", function() {
    return PasswordRecoveringFailed;
});
parcelHelpers.export(exports, "PasswordRecoverEmailSentKey", function() {
    return PasswordRecoverEmailSentKey;
});
parcelHelpers.export(exports, "PasswordRecoverEmailSent", function() {
    return PasswordRecoverEmailSent;
});
parcelHelpers.export(exports, "recoverPassword", function() {
    return recoverPassword;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _eventFactory = require("../../std/eventFactory");
var _either = require("fp-ts/Either");
var RecoverPasswordKey = 'RecoverPassword';
var RecoverPassword = (0, _eventFactory.eventFactory)(RecoverPasswordKey)();
var PasswordRecoveringFailedKey = 'PasswordRecoveringFailed';
var PasswordRecoveringFailed = (0, _eventFactory.eventFactory)(PasswordRecoveringFailedKey)();
var PasswordRecoverEmailSentKey = 'PasswordRecoverEmailSent';
var PasswordRecoverEmailSent = (0, _eventFactory.eventFactory)(PasswordRecoverEmailSentKey)();
function recoverPassword(deps) {
    return /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(event) {
            var execution, response;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        execution = deps.sendRecoverPasswordEmail(event.payload.email);
                        return [
                            4,
                            deps.waitAtLeast(execution, 2000)
                        ];
                    case 1:
                        response = _state.sent();
                        if (_either.isLeft(response)) return [
                            2,
                            deps.publishEvent(PasswordRecoverEmailSent())
                        ];
                        return [
                            2,
                            deps.publishEvent(PasswordRecoveringFailed(response.right))
                        ];
                }
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }();
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_ts_generator":"f2hGH","../../std/eventFactory":"f2PpV","fp-ts/Either":"jW2NS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jW2NS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "left", function() {
    return left;
});
parcelHelpers.export(exports, "right", function() {
    return right;
});
parcelHelpers.export(exports, "flatMap", function() {
    return flatMap;
});
parcelHelpers.export(exports, "URI", function() {
    return URI;
});
parcelHelpers.export(exports, "getShow", function() {
    return getShow;
});
parcelHelpers.export(exports, "getEq", function() {
    return getEq;
});
parcelHelpers.export(exports, "getSemigroup", function() {
    return getSemigroup;
});
parcelHelpers.export(exports, "getCompactable", function() {
    return getCompactable;
});
parcelHelpers.export(exports, "getFilterable", function() {
    return getFilterable;
});
parcelHelpers.export(exports, "getWitherable", function() {
    return getWitherable;
});
parcelHelpers.export(exports, "getApplicativeValidation", function() {
    return getApplicativeValidation;
});
parcelHelpers.export(exports, "getAltValidation", function() {
    return getAltValidation;
});
parcelHelpers.export(exports, "map", function() {
    return map;
});
parcelHelpers.export(exports, "Functor", function() {
    return Functor;
});
parcelHelpers.export(exports, "as", function() {
    return as;
});
parcelHelpers.export(exports, "asUnit", function() {
    return asUnit;
});
parcelHelpers.export(exports, "of", function() {
    return of;
});
parcelHelpers.export(exports, "Pointed", function() {
    return Pointed;
});
parcelHelpers.export(exports, "apW", function() {
    return apW;
});
parcelHelpers.export(exports, "ap", function() {
    return ap;
});
parcelHelpers.export(exports, "Apply", function() {
    return Apply;
});
parcelHelpers.export(exports, "Applicative", function() {
    return Applicative;
});
parcelHelpers.export(exports, "Chain", function() {
    return Chain;
});
parcelHelpers.export(exports, "Monad", function() {
    return Monad;
});
parcelHelpers.export(exports, "reduce", function() {
    return reduce;
});
parcelHelpers.export(exports, "foldMap", function() {
    return foldMap;
});
parcelHelpers.export(exports, "reduceRight", function() {
    return reduceRight;
});
parcelHelpers.export(exports, "Foldable", function() {
    return Foldable;
});
parcelHelpers.export(exports, "traverse", function() {
    return traverse;
});
parcelHelpers.export(exports, "sequence", function() {
    return sequence;
});
parcelHelpers.export(exports, "Traversable", function() {
    return Traversable;
});
parcelHelpers.export(exports, "bimap", function() {
    return bimap;
});
parcelHelpers.export(exports, "mapLeft", function() {
    return mapLeft;
});
parcelHelpers.export(exports, "Bifunctor", function() {
    return Bifunctor;
});
parcelHelpers.export(exports, "altW", function() {
    return altW;
});
parcelHelpers.export(exports, "alt", function() {
    return alt;
});
parcelHelpers.export(exports, "Alt", function() {
    return Alt;
});
parcelHelpers.export(exports, "extend", function() {
    return extend;
});
parcelHelpers.export(exports, "Extend", function() {
    return Extend;
});
parcelHelpers.export(exports, "ChainRec", function() {
    return ChainRec;
});
parcelHelpers.export(exports, "throwError", function() {
    return throwError;
});
parcelHelpers.export(exports, "MonadThrow", function() {
    return MonadThrow;
});
parcelHelpers.export(exports, "FromEither", function() {
    return FromEither;
});
parcelHelpers.export(exports, "fromPredicate", function() {
    return fromPredicate;
});
parcelHelpers.export(exports, "fromOption", function() {
    return fromOption;
});
parcelHelpers.export(exports, "isLeft", function() {
    return isLeft;
});
parcelHelpers.export(exports, "isRight", function() {
    return isRight;
});
parcelHelpers.export(exports, "matchW", function() {
    return matchW;
});
parcelHelpers.export(exports, "foldW", function() {
    return foldW;
});
parcelHelpers.export(exports, "match", function() {
    return match;
});
parcelHelpers.export(exports, "fold", function() {
    return fold;
});
parcelHelpers.export(exports, "getOrElseW", function() {
    return getOrElseW;
});
parcelHelpers.export(exports, "getOrElse", function() {
    return getOrElse;
});
parcelHelpers.export(exports, "flap", function() {
    return flap;
});
parcelHelpers.export(exports, "apFirst", function() {
    return apFirst;
});
parcelHelpers.export(exports, "apFirstW", function() {
    return apFirstW;
});
parcelHelpers.export(exports, "apSecond", function() {
    return apSecond;
});
parcelHelpers.export(exports, "apSecondW", function() {
    return apSecondW;
});
parcelHelpers.export(exports, "tap", function() {
    return tap;
});
parcelHelpers.export(exports, "flattenW", function() {
    return flattenW;
});
parcelHelpers.export(exports, "flatten", function() {
    return flatten;
});
parcelHelpers.export(exports, "duplicate", function() {
    return duplicate;
});
parcelHelpers.export(exports, "fromOptionK", function() {
    return fromOptionK;
});
parcelHelpers.export(exports, "chainOptionK", function() {
    return chainOptionK;
});
parcelHelpers.export(exports, "chainOptionKW", function() {
    return chainOptionKW;
});
parcelHelpers.export(exports, "liftNullable", function() {
    return liftNullable;
});
parcelHelpers.export(exports, "liftOption", function() {
    return liftOption;
});
parcelHelpers.export(exports, "flatMapNullable", function() {
    return flatMapNullable;
});
parcelHelpers.export(exports, "flatMapOption", function() {
    return flatMapOption;
});
parcelHelpers.export(exports, "filterOrElse", function() {
    return filterOrElse;
});
parcelHelpers.export(exports, "filterOrElseW", function() {
    return filterOrElseW;
});
parcelHelpers.export(exports, "swap", function() {
    return swap;
});
parcelHelpers.export(exports, "orElseW", function() {
    return orElseW;
});
parcelHelpers.export(exports, "orElse", function() {
    return orElse;
});
parcelHelpers.export(exports, "fromNullable", function() {
    return fromNullable;
});
parcelHelpers.export(exports, "tryCatch", function() {
    return tryCatch;
});
parcelHelpers.export(exports, "tryCatchK", function() {
    return tryCatchK;
});
parcelHelpers.export(exports, "fromNullableK", function() {
    return fromNullableK;
});
parcelHelpers.export(exports, "chainNullableK", function() {
    return chainNullableK;
});
parcelHelpers.export(exports, "toUnion", function() {
    return toUnion;
});
// -------------------------------------------------------------------------------------
// utils
// -------------------------------------------------------------------------------------
/**
 * Default value for the `onError` argument of `tryCatch`
 *
 * @since 2.0.0
 */ parcelHelpers.export(exports, "toError", function() {
    return toError;
});
parcelHelpers.export(exports, "elem", function() {
    return elem;
});
parcelHelpers.export(exports, "exists", function() {
    return exists;
});
parcelHelpers.export(exports, "Do", function() {
    return Do;
});
parcelHelpers.export(exports, "bindTo", function() {
    return bindTo;
});
parcelHelpers.export(exports, "let", function() {
    return(/**
 * @category do notation
 * @since 2.13.0
 */ let_);
});
parcelHelpers.export(exports, "bind", function() {
    return bind;
});
parcelHelpers.export(exports, "bindW", function() {
    return bindW;
});
parcelHelpers.export(exports, "apS", function() {
    return apS;
});
parcelHelpers.export(exports, "apSW", function() {
    return apSW;
});
parcelHelpers.export(exports, "ApT", function() {
    return ApT;
});
parcelHelpers.export(exports, "traverseReadonlyNonEmptyArrayWithIndex", function() {
    return traverseReadonlyNonEmptyArrayWithIndex;
});
parcelHelpers.export(exports, "traverseReadonlyArrayWithIndex", function() {
    return traverseReadonlyArrayWithIndex;
});
parcelHelpers.export(exports, "traverseArrayWithIndex", function() {
    return traverseArrayWithIndex;
});
parcelHelpers.export(exports, "traverseArray", function() {
    return traverseArray;
});
parcelHelpers.export(exports, "sequenceArray", function() {
    return sequenceArray;
});
parcelHelpers.export(exports, "chainW", function() {
    return chainW;
});
parcelHelpers.export(exports, "chain", function() {
    return chain;
});
parcelHelpers.export(exports, "chainFirst", function() {
    return chainFirst;
});
parcelHelpers.export(exports, "chainFirstW", function() {
    return chainFirstW;
});
/**
 * Use [`parse`](./Json.ts.html#parse) instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ parcelHelpers.export(exports, "parseJSON", function() {
    return parseJSON;
});
parcelHelpers.export(exports, "stringifyJSON", function() {
    return stringifyJSON;
});
parcelHelpers.export(exports, "either", function() {
    return either;
});
parcelHelpers.export(exports, "getApplySemigroup", function() {
    return getApplySemigroup;
});
parcelHelpers.export(exports, "getApplyMonoid", function() {
    return getApplyMonoid;
});
parcelHelpers.export(exports, "getValidationSemigroup", function() {
    return getValidationSemigroup;
});
parcelHelpers.export(exports, "getValidationMonoid", function() {
    return getValidationMonoid;
});
/**
 * Use [`getApplicativeValidation`](#getapplicativevalidation) and [`getAltValidation`](#getaltvalidation) instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ parcelHelpers.export(exports, "getValidation", function() {
    return getValidation;
});
var _applicative = require("./Applicative");
var _apply = require("./Apply");
var _chain = require("./Chain");
var _chainRec = require("./ChainRec");
var _fromEither = require("./FromEither");
var _function = require("./function");
var _functor = require("./Functor");
var _internal = require("./internal");
var _separated = require("./Separated");
var _witherable = require("./Witherable");
var left = _internal.left;
var right = _internal.right;
var flatMap = /*#__PURE__*/ (0, _function.dual)(2, function(ma, f) {
    return isLeft(ma) ? ma : f(ma.right);
});
var _map = function _map(fa, f) {
    return (0, _function.pipe)(fa, map(f));
};
var _ap = function _ap(fab, fa) {
    return (0, _function.pipe)(fab, ap(fa));
};
/* istanbul ignore next */ var _reduce = function _reduce(fa, b, f) {
    return (0, _function.pipe)(fa, reduce(b, f));
};
/* istanbul ignore next */ var _foldMap = function _foldMap(M) {
    return function(fa, f) {
        var foldMapM = foldMap(M);
        return (0, _function.pipe)(fa, foldMapM(f));
    };
};
/* istanbul ignore next */ var _reduceRight = function _reduceRight(fa, b, f) {
    return (0, _function.pipe)(fa, reduceRight(b, f));
};
var _traverse = function _traverse(F) {
    var traverseF = traverse(F);
    return function(ta, f) {
        return (0, _function.pipe)(ta, traverseF(f));
    };
};
var _bimap = function _bimap(fa, f, g) {
    return (0, _function.pipe)(fa, bimap(f, g));
};
var _mapLeft = function _mapLeft(fa, f) {
    return (0, _function.pipe)(fa, mapLeft(f));
};
/* istanbul ignore next */ var _alt = function _alt(fa, that) {
    return (0, _function.pipe)(fa, alt(that));
};
/* istanbul ignore next */ var _extend = function _extend(wa, f) {
    return (0, _function.pipe)(wa, extend(f));
};
var _chainRec1 = function _chainRec1(a, f) {
    return (0, _chainRec.tailRec)(f(a), function(e) {
        return isLeft(e) ? right(left(e.left)) : isLeft(e.right) ? left(f(e.right.left)) : right(right(e.right.right));
    });
};
var URI = 'Either';
var getShow = function getShow(SE, SA) {
    return {
        show: function show(ma) {
            return isLeft(ma) ? "left(".concat(SE.show(ma.left), ")") : "right(".concat(SA.show(ma.right), ")");
        }
    };
};
var getEq = function getEq(EL, EA) {
    return {
        equals: function equals(x, y) {
            return x === y || (isLeft(x) ? isLeft(y) && EL.equals(x.left, y.left) : isRight(y) && EA.equals(x.right, y.right));
        }
    };
};
var getSemigroup = function getSemigroup(S) {
    return {
        concat: function concat(x, y) {
            return isLeft(y) ? x : isLeft(x) ? y : right(S.concat(x.right, y.right));
        }
    };
};
var getCompactable = function getCompactable(M) {
    var empty = left(M.empty);
    return {
        URI: URI,
        _E: undefined,
        compact: function compact(ma) {
            return isLeft(ma) ? ma : ma.right._tag === 'None' ? empty : right(ma.right.value);
        },
        separate: function separate(ma) {
            return isLeft(ma) ? (0, _separated.separated)(ma, ma) : isLeft(ma.right) ? (0, _separated.separated)(right(ma.right.left), empty) : (0, _separated.separated)(empty, right(ma.right.right));
        }
    };
};
var getFilterable = function getFilterable(M) {
    var empty = left(M.empty);
    var _a = getCompactable(M), compact = _a.compact, separate = _a.separate;
    var filter = function filter(ma, predicate) {
        return isLeft(ma) ? ma : predicate(ma.right) ? ma : empty;
    };
    var partition = function partition(ma, p) {
        return isLeft(ma) ? (0, _separated.separated)(ma, ma) : p(ma.right) ? (0, _separated.separated)(empty, right(ma.right)) : (0, _separated.separated)(right(ma.right), empty);
    };
    return {
        URI: URI,
        _E: undefined,
        map: _map,
        compact: compact,
        separate: separate,
        filter: filter,
        filterMap: function filterMap(ma, f) {
            if (isLeft(ma)) return ma;
            var ob = f(ma.right);
            return ob._tag === 'None' ? empty : right(ob.value);
        },
        partition: partition,
        partitionMap: function partitionMap(ma, f) {
            if (isLeft(ma)) return (0, _separated.separated)(ma, ma);
            var e = f(ma.right);
            return isLeft(e) ? (0, _separated.separated)(right(e.left), empty) : (0, _separated.separated)(empty, right(e.right));
        }
    };
};
var getWitherable = function getWitherable(M) {
    var F_ = getFilterable(M);
    var C = getCompactable(M);
    return {
        URI: URI,
        _E: undefined,
        map: _map,
        compact: F_.compact,
        separate: F_.separate,
        filter: F_.filter,
        filterMap: F_.filterMap,
        partition: F_.partition,
        partitionMap: F_.partitionMap,
        traverse: _traverse,
        sequence: sequence,
        reduce: _reduce,
        foldMap: _foldMap,
        reduceRight: _reduceRight,
        wither: (0, _witherable.witherDefault)(Traversable, C),
        wilt: (0, _witherable.wiltDefault)(Traversable, C)
    };
};
var getApplicativeValidation = function getApplicativeValidation(SE) {
    return {
        URI: URI,
        _E: undefined,
        map: _map,
        ap: function ap(fab, fa) {
            return isLeft(fab) ? isLeft(fa) ? left(SE.concat(fab.left, fa.left)) : fab : isLeft(fa) ? fa : right(fab.right(fa.right));
        },
        of: of
    };
};
var getAltValidation = function getAltValidation(SE) {
    return {
        URI: URI,
        _E: undefined,
        map: _map,
        alt: function alt(me, that) {
            if (isRight(me)) return me;
            var ea = that();
            return isLeft(ea) ? left(SE.concat(me.left, ea.left)) : ea;
        }
    };
};
var map = function map(f) {
    return function(fa) {
        return isLeft(fa) ? fa : right(f(fa.right));
    };
};
var Functor = {
    URI: URI,
    map: _map
};
var as = (0, _function.dual)(2, (0, _functor.as)(Functor));
var asUnit = (0, _functor.asUnit)(Functor);
var of = right;
var Pointed = {
    URI: URI,
    of: of
};
var apW = function apW(fa) {
    return function(fab) {
        return isLeft(fab) ? fab : isLeft(fa) ? fa : right(fab.right(fa.right));
    };
};
var ap = apW;
var Apply = {
    URI: URI,
    map: _map,
    ap: _ap
};
var Applicative = {
    URI: URI,
    map: _map,
    ap: _ap,
    of: of
};
var Chain = {
    URI: URI,
    map: _map,
    ap: _ap,
    chain: flatMap
};
var Monad = {
    URI: URI,
    map: _map,
    ap: _ap,
    of: of,
    chain: flatMap
};
var reduce = function reduce(b, f) {
    return function(fa) {
        return isLeft(fa) ? b : f(b, fa.right);
    };
};
var foldMap = function foldMap(M) {
    return function(f) {
        return function(fa) {
            return isLeft(fa) ? M.empty : f(fa.right);
        };
    };
};
var reduceRight = function reduceRight(b, f) {
    return function(fa) {
        return isLeft(fa) ? b : f(fa.right, b);
    };
};
var Foldable = {
    URI: URI,
    reduce: _reduce,
    foldMap: _foldMap,
    reduceRight: _reduceRight
};
var traverse = function traverse(F) {
    return function(f) {
        return function(ta) {
            return isLeft(ta) ? F.of(left(ta.left)) : F.map(f(ta.right), right);
        };
    };
};
var sequence = function sequence(F) {
    return function(ma) {
        return isLeft(ma) ? F.of(left(ma.left)) : F.map(ma.right, right);
    };
};
var Traversable = {
    URI: URI,
    map: _map,
    reduce: _reduce,
    foldMap: _foldMap,
    reduceRight: _reduceRight,
    traverse: _traverse,
    sequence: sequence
};
var bimap = function bimap(f, g) {
    return function(fa) {
        return isLeft(fa) ? left(f(fa.left)) : right(g(fa.right));
    };
};
var mapLeft = function mapLeft(f) {
    return function(fa) {
        return isLeft(fa) ? left(f(fa.left)) : fa;
    };
};
var Bifunctor = {
    URI: URI,
    bimap: _bimap,
    mapLeft: _mapLeft
};
var altW = function altW(that) {
    return function(fa) {
        return isLeft(fa) ? that() : fa;
    };
};
var alt = altW;
var Alt = {
    URI: URI,
    map: _map,
    alt: _alt
};
var extend = function extend(f) {
    return function(wa) {
        return isLeft(wa) ? wa : right(f(wa));
    };
};
var Extend = {
    URI: URI,
    map: _map,
    extend: _extend
};
var ChainRec = {
    URI: URI,
    map: _map,
    ap: _ap,
    chain: flatMap,
    chainRec: _chainRec1
};
var throwError = left;
var MonadThrow = {
    URI: URI,
    map: _map,
    ap: _ap,
    of: of,
    chain: flatMap,
    throwError: throwError
};
var FromEither = {
    URI: URI,
    fromEither: (0, _function.identity)
};
var fromPredicate = /*#__PURE__*/ (0, _fromEither.fromPredicate)(FromEither);
var fromOption = /*#__PURE__*/ (0, _fromEither.fromOption)(FromEither);
var isLeft = _internal.isLeft;
var isRight = _internal.isRight;
var matchW = function matchW(onLeft, onRight) {
    return function(ma) {
        return isLeft(ma) ? onLeft(ma.left) : onRight(ma.right);
    };
};
var foldW = matchW;
var match = matchW;
var fold = match;
var getOrElseW = function getOrElseW(onLeft) {
    return function(ma) {
        return isLeft(ma) ? onLeft(ma.left) : ma.right;
    };
};
var getOrElse = getOrElseW;
var flap = /*#__PURE__*/ (0, _functor.flap)(Functor);
var apFirst = /*#__PURE__*/ (0, _apply.apFirst)(Apply);
var apFirstW = apFirst;
var apSecond = /*#__PURE__*/ (0, _apply.apSecond)(Apply);
var apSecondW = apSecond;
var tap = /*#__PURE__*/ (0, _function.dual)(2, _chain.tap(Chain));
var flattenW = /*#__PURE__*/ flatMap((0, _function.identity));
var flatten = flattenW;
var duplicate = /*#__PURE__*/ extend((0, _function.identity));
var fromOptionK = /*#__PURE__*/ (0, _fromEither.fromOptionK)(FromEither);
var chainOptionK = /*#__PURE__*/ (0, _fromEither.chainOptionK)(FromEither, Chain);
var chainOptionKW = chainOptionK;
/** @internal */ var _FromEither = {
    fromEither: FromEither.fromEither
};
var liftNullable = /*#__PURE__*/ _internal.liftNullable(_FromEither);
var liftOption = /*#__PURE__*/ _internal.liftOption(_FromEither);
/** @internal */ var _FlatMap = {
    flatMap: flatMap
};
var flatMapNullable = /*#__PURE__*/ _internal.flatMapNullable(_FromEither, _FlatMap);
var flatMapOption = /*#__PURE__*/ _internal.flatMapOption(_FromEither, _FlatMap);
var filterOrElse = /*#__PURE__*/ (0, _fromEither.filterOrElse)(FromEither, Chain);
var filterOrElseW = filterOrElse;
var swap = function swap(ma) {
    return isLeft(ma) ? right(ma.left) : left(ma.right);
};
var orElseW = function orElseW(onLeft) {
    return function(ma) {
        return isLeft(ma) ? onLeft(ma.left) : ma;
    };
};
var orElse = orElseW;
var fromNullable = function fromNullable(e) {
    return function(a) {
        return a == null ? left(e) : right(a);
    };
};
var tryCatch = function tryCatch(f, onThrow) {
    try {
        return right(f());
    } catch (e) {
        return left(onThrow(e));
    }
};
var tryCatchK = function tryCatchK(f, onThrow) {
    return function() {
        var a = [];
        for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
        return tryCatch(function() {
            return f.apply(void 0, a);
        }, onThrow);
    };
};
var fromNullableK = function fromNullableK(e) {
    var from = fromNullable(e);
    return function(f) {
        return (0, _function.flow)(f, from);
    };
};
var chainNullableK = function chainNullableK(e) {
    var from = fromNullableK(e);
    return function(f) {
        return flatMap(from(f));
    };
};
var toUnion = /*#__PURE__*/ foldW((0, _function.identity), (0, _function.identity));
function toError(e) {
    try {
        return e instanceof Error ? e : new Error(String(e));
    } catch (error) {
        return new Error();
    }
}
function elem(E) {
    return function(a, ma) {
        if (ma === undefined) {
            var elemE_1 = elem(E);
            return function(ma) {
                return elemE_1(a, ma);
            };
        }
        return isLeft(ma) ? false : E.equals(a, ma.right);
    };
}
var exists = function exists(predicate) {
    return function(ma) {
        return isLeft(ma) ? false : predicate(ma.right);
    };
};
var Do = /*#__PURE__*/ of(_internal.emptyRecord);
var bindTo = /*#__PURE__*/ (0, _functor.bindTo)(Functor);
var let_ = /*#__PURE__*/ (0, _functor.let)(Functor);
var bind = /*#__PURE__*/ _chain.bind(Chain);
var bindW = bind;
var apS = /*#__PURE__*/ (0, _apply.apS)(Apply);
var apSW = apS;
var ApT = /*#__PURE__*/ of(_internal.emptyReadonlyArray);
var traverseReadonlyNonEmptyArrayWithIndex = function traverseReadonlyNonEmptyArrayWithIndex(f) {
    return function(as) {
        var e = f(0, _internal.head(as));
        if (isLeft(e)) return e;
        var out = [
            e.right
        ];
        for(var i = 1; i < as.length; i++){
            var e_1 = f(i, as[i]);
            if (isLeft(e_1)) return e_1;
            out.push(e_1.right);
        }
        return right(out);
    };
};
var traverseReadonlyArrayWithIndex = function traverseReadonlyArrayWithIndex(f) {
    var g = traverseReadonlyNonEmptyArrayWithIndex(f);
    return function(as) {
        return _internal.isNonEmpty(as) ? g(as) : ApT;
    };
};
var traverseArrayWithIndex = traverseReadonlyArrayWithIndex;
var traverseArray = function traverseArray(f) {
    return traverseReadonlyArrayWithIndex(function(_, a) {
        return f(a);
    });
};
var sequenceArray = /*#__PURE__*/ traverseArray((0, _function.identity));
var chainW = flatMap;
var chain = flatMap;
var chainFirst = tap;
var chainFirstW = tap;
function parseJSON(s, onError) {
    return tryCatch(function() {
        return JSON.parse(s);
    }, onError);
}
var stringifyJSON = function stringifyJSON(u, onError) {
    return tryCatch(function() {
        var s = JSON.stringify(u);
        if (typeof s !== 'string') throw new Error('Converting unsupported structure to JSON');
        return s;
    }, onError);
};
var either = {
    URI: URI,
    map: _map,
    of: of,
    ap: _ap,
    chain: flatMap,
    reduce: _reduce,
    foldMap: _foldMap,
    reduceRight: _reduceRight,
    traverse: _traverse,
    sequence: sequence,
    bimap: _bimap,
    mapLeft: _mapLeft,
    alt: _alt,
    extend: _extend,
    chainRec: _chainRec1,
    throwError: throwError
};
var getApplySemigroup = /*#__PURE__*/ (0, _apply.getApplySemigroup)(Apply);
var getApplyMonoid = /*#__PURE__*/ (0, _applicative.getApplicativeMonoid)(Applicative);
var getValidationSemigroup = function getValidationSemigroup(SE, SA) {
    return (0, _apply.getApplySemigroup)(getApplicativeValidation(SE))(SA);
};
var getValidationMonoid = function getValidationMonoid(SE, MA) {
    return (0, _applicative.getApplicativeMonoid)(getApplicativeValidation(SE))(MA);
};
function getValidation(SE) {
    var ap = getApplicativeValidation(SE).ap;
    var alt = getAltValidation(SE).alt;
    return {
        URI: URI,
        _E: undefined,
        map: _map,
        of: of,
        chain: flatMap,
        bimap: _bimap,
        mapLeft: _mapLeft,
        reduce: _reduce,
        foldMap: _foldMap,
        reduceRight: _reduceRight,
        extend: _extend,
        traverse: _traverse,
        sequence: sequence,
        chainRec: _chainRec1,
        throwError: throwError,
        ap: ap,
        alt: alt
    };
}

},{"./Applicative":"fHoCl","./Apply":"4DdQ5","./Chain":"e7tsl","./ChainRec":"6DDwz","./FromEither":"aKl3h","./function":"lQP8S","./Functor":"h16ze","./internal":"gslSm","./Separated":"gBLap","./Witherable":"bQMCw","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"fHoCl":[function(require,module,exports,__globalThis) {
/**
 * The `Applicative` type class extends the `Apply` type class with a `of` function, which can be used to create values
 * of type `f a` from values of type `a`.
 *
 * Where `Apply` provides the ability to lift functions of two or more arguments to functions whose arguments are
 * wrapped using `f`, and `Functor` provides the ability to lift functions of one argument, `pure` can be seen as the
 * function which lifts functions of _zero_ arguments. That is, `Applicative` functors support a lifting operation for
 * any number of function arguments.
 *
 * Instances must satisfy the following laws in addition to the `Apply` laws:
 *
 * 1. Identity: `A.ap(A.of(a => a), fa) <-> fa`
 * 2. Homomorphism: `A.ap(A.of(ab), A.of(a)) <-> A.of(ab(a))`
 * 3. Interchange: `A.ap(fab, A.of(a)) <-> A.ap(A.of(ab => ab(a)), fab)`
 *
 * Note. `Functor`'s `map` can be derived: `A.map(x, f) = A.ap(A.of(f), x)`
 *
 * @since 2.0.0
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getApplicativeMonoid", function() {
    return getApplicativeMonoid;
});
/** @deprecated */ parcelHelpers.export(exports, "getApplicativeComposition", function() {
    return getApplicativeComposition;
});
var _apply = require("./Apply");
var _function = require("./function");
var _functor = require("./Functor");
function getApplicativeMonoid(F) {
    var f = (0, _apply.getApplySemigroup)(F);
    return function(M) {
        return {
            concat: f(M).concat,
            empty: F.of(M.empty)
        };
    };
}
function getApplicativeComposition(F, G) {
    var map = (0, _functor.getFunctorComposition)(F, G).map;
    var _ap = (0, _apply.ap)(F, G);
    return {
        map: map,
        of: function of(a) {
            return F.of(G.of(a));
        },
        ap: function ap(fgab, fga) {
            return (0, _function.pipe)(fgab, _ap(fga));
        }
    };
}

},{"./Apply":"4DdQ5","./function":"lQP8S","./Functor":"h16ze","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4DdQ5":[function(require,module,exports,__globalThis) {
/**
 * The `Apply` class provides the `ap` which is used to apply a function to an argument under a type constructor.
 *
 * `Apply` can be used to lift functions of two or more arguments to work on values wrapped with the type constructor
 * `f`.
 *
 * Instances must satisfy the following law in addition to the `Functor` laws:
 *
 * 1. Associative composition: `F.ap(F.ap(F.map(fbc, bc => ab => a => bc(ab(a))), fab), fa) <-> F.ap(fbc, F.ap(fab, fa))`
 *
 * Formally, `Apply` represents a strong lax semi-monoidal endofunctor.
 *
 * @example
 * import * as O from 'fp-ts/Option'
 * import { pipe } from 'fp-ts/function'
 *
 * const f = (a: string) => (b: number) => (c: boolean) => a + String(b) + String(c)
 * const fa: O.Option<string> = O.some('s')
 * const fb: O.Option<number> = O.some(1)
 * const fc: O.Option<boolean> = O.some(true)
 *
 * assert.deepStrictEqual(
 *   pipe(
 *     // lift a function
 *     O.some(f),
 *     // apply the first argument
 *     O.ap(fa),
 *     // apply the second argument
 *     O.ap(fb),
 *     // apply the third argument
 *     O.ap(fc)
 *   ),
 *   O.some('s1true')
 * )
 *
 * @since 2.0.0
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ap", function() {
    return ap;
});
parcelHelpers.export(exports, "apFirst", function() {
    return apFirst;
});
parcelHelpers.export(exports, "apSecond", function() {
    return apSecond;
});
parcelHelpers.export(exports, "apS", function() {
    return apS;
});
parcelHelpers.export(exports, "getApplySemigroup", function() {
    return getApplySemigroup;
});
parcelHelpers.export(exports, "sequenceT", function() {
    return sequenceT;
});
parcelHelpers.export(exports, "sequenceS", function() {
    return sequenceS;
});
var _function = require("./function");
var _internal = require("./internal");
function ap(F, G) {
    return function(fa) {
        return function(fab) {
            return F.ap(F.map(fab, function(gab) {
                return function(ga) {
                    return G.ap(gab, ga);
                };
            }), fa);
        };
    };
}
function apFirst(A) {
    return function(second) {
        return function(first) {
            return A.ap(A.map(first, function(a) {
                return function() {
                    return a;
                };
            }), second);
        };
    };
}
function apSecond(A) {
    return function(second) {
        return function(first) {
            return A.ap(A.map(first, function() {
                return function(b) {
                    return b;
                };
            }), second);
        };
    };
}
function apS(F) {
    return function(name, fb) {
        return function(fa) {
            return F.ap(F.map(fa, function(a) {
                return function(b) {
                    var _a;
                    return Object.assign({}, a, (_a = {}, _a[name] = b, _a));
                };
            }), fb);
        };
    };
}
function getApplySemigroup(F) {
    return function(S) {
        return {
            concat: function concat(first, second) {
                return F.ap(F.map(first, function(x) {
                    return function(y) {
                        return S.concat(x, y);
                    };
                }), second);
            }
        };
    };
}
function curried(f, n, acc) {
    return function(x) {
        var combined = Array(acc.length + 1);
        for(var i = 0; i < acc.length; i++)combined[i] = acc[i];
        combined[acc.length] = x;
        return n === 0 ? f.apply(null, combined) : curried(f, n - 1, combined);
    };
}
var tupleConstructors = {
    1: function(a) {
        return [
            a
        ];
    },
    2: function(a) {
        return function(b) {
            return [
                a,
                b
            ];
        };
    },
    3: function(a) {
        return function(b) {
            return function(c) {
                return [
                    a,
                    b,
                    c
                ];
            };
        };
    },
    4: function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return [
                        a,
                        b,
                        c,
                        d
                    ];
                };
            };
        };
    },
    5: function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return [
                            a,
                            b,
                            c,
                            d,
                            e
                        ];
                    };
                };
            };
        };
    }
};
function getTupleConstructor(len) {
    if (!_internal.has.call(tupleConstructors, len)) tupleConstructors[len] = curried((0, _function.tuple), len - 1, []);
    return tupleConstructors[len];
}
function sequenceT(F) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var len = args.length;
        var f = getTupleConstructor(len);
        var fas = F.map(args[0], f);
        for(var i = 1; i < len; i++)fas = F.ap(fas, args[i]);
        return fas;
    };
}
function getRecordConstructor(keys) {
    var len = keys.length;
    switch(len){
        case 1:
            return function(a) {
                var _a;
                return _a = {}, _a[keys[0]] = a, _a;
            };
        case 2:
            return function(a) {
                return function(b) {
                    var _a;
                    return _a = {}, _a[keys[0]] = a, _a[keys[1]] = b, _a;
                };
            };
        case 3:
            return function(a) {
                return function(b) {
                    return function(c) {
                        var _a;
                        return _a = {}, _a[keys[0]] = a, _a[keys[1]] = b, _a[keys[2]] = c, _a;
                    };
                };
            };
        case 4:
            return function(a) {
                return function(b) {
                    return function(c) {
                        return function(d) {
                            var _a;
                            return _a = {}, _a[keys[0]] = a, _a[keys[1]] = b, _a[keys[2]] = c, _a[keys[3]] = d, _a;
                        };
                    };
                };
            };
        case 5:
            return function(a) {
                return function(b) {
                    return function(c) {
                        return function(d) {
                            return function(e) {
                                var _a;
                                return _a = {}, _a[keys[0]] = a, _a[keys[1]] = b, _a[keys[2]] = c, _a[keys[3]] = d, _a[keys[4]] = e, _a;
                            };
                        };
                    };
                };
            };
        default:
            return curried(function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                var r = {};
                for(var i = 0; i < len; i++)r[keys[i]] = args[i];
                return r;
            }, len - 1, []);
    }
}
function sequenceS(F) {
    return function(r) {
        var keys = Object.keys(r);
        var len = keys.length;
        var f = getRecordConstructor(keys);
        var fr = F.map(r[keys[0]], f);
        for(var i = 1; i < len; i++)fr = F.ap(fr, r[keys[i]]);
        return fr;
    };
}

},{"./function":"lQP8S","./internal":"gslSm","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"lQP8S":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getBooleanAlgebra", function() {
    return getBooleanAlgebra;
});
parcelHelpers.export(exports, "getSemigroup", function() {
    return getSemigroup;
});
parcelHelpers.export(exports, "getMonoid", function() {
    return getMonoid;
});
parcelHelpers.export(exports, "getSemiring", function() {
    return getSemiring;
});
parcelHelpers.export(exports, "getRing", function() {
    return getRing;
});
parcelHelpers.export(exports, "apply", function() {
    return apply;
});
/**
 * @since 2.0.0
 */ parcelHelpers.export(exports, "identity", function() {
    return identity;
});
parcelHelpers.export(exports, "unsafeCoerce", function() {
    return unsafeCoerce;
});
/**
 * @since 2.0.0
 */ parcelHelpers.export(exports, "constant", function() {
    return constant;
});
parcelHelpers.export(exports, "constTrue", function() {
    return constTrue;
});
parcelHelpers.export(exports, "constFalse", function() {
    return constFalse;
});
parcelHelpers.export(exports, "constNull", function() {
    return constNull;
});
parcelHelpers.export(exports, "constUndefined", function() {
    return constUndefined;
});
parcelHelpers.export(exports, "constVoid", function() {
    return constVoid;
});
parcelHelpers.export(exports, "flip", function() {
    return flip;
});
parcelHelpers.export(exports, "flow", function() {
    return flow;
});
/**
 * @since 2.0.0
 */ parcelHelpers.export(exports, "tuple", function() {
    return tuple;
});
/**
 * @since 2.0.0
 */ parcelHelpers.export(exports, "increment", function() {
    return increment;
});
/**
 * @since 2.0.0
 */ parcelHelpers.export(exports, "decrement", function() {
    return decrement;
});
/**
 * @since 2.0.0
 */ parcelHelpers.export(exports, "absurd", function() {
    return absurd;
});
/**
 * Creates a tupled version of this function: instead of `n` arguments, it accepts a single tuple argument.
 *
 * @example
 * import { tupled } from 'fp-ts/function'
 *
 * const add = tupled((x: number, y: number): number => x + y)
 *
 * assert.strictEqual(add([1, 2]), 3)
 *
 * @since 2.4.0
 */ parcelHelpers.export(exports, "tupled", function() {
    return tupled;
});
/**
 * Inverse function of `tupled`
 *
 * @since 2.4.0
 */ parcelHelpers.export(exports, "untupled", function() {
    return untupled;
});
parcelHelpers.export(exports, "pipe", function() {
    return pipe;
});
parcelHelpers.export(exports, "hole", function() {
    return hole;
});
parcelHelpers.export(exports, "SK", function() {
    return SK;
});
/**
 * Use `Predicate` module instead.
 *
 * @category zone of death
 * @since 2.0.0
 * @deprecated
 */ parcelHelpers.export(exports, "not", function() {
    return not;
});
parcelHelpers.export(exports, "getEndomorphismMonoid", function() {
    return getEndomorphismMonoid;
});
parcelHelpers.export(exports, "dual", function() {
    return dual;
});
var __spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var getBooleanAlgebra = function getBooleanAlgebra(B) {
    return function() {
        return {
            meet: function meet(x, y) {
                return function(a) {
                    return B.meet(x(a), y(a));
                };
            },
            join: function join(x, y) {
                return function(a) {
                    return B.join(x(a), y(a));
                };
            },
            zero: function zero() {
                return B.zero;
            },
            one: function one() {
                return B.one;
            },
            implies: function implies(x, y) {
                return function(a) {
                    return B.implies(x(a), y(a));
                };
            },
            not: function not(x) {
                return function(a) {
                    return B.not(x(a));
                };
            }
        };
    };
};
var getSemigroup = function getSemigroup(S) {
    return function() {
        return {
            concat: function concat(f, g) {
                return function(a) {
                    return S.concat(f(a), g(a));
                };
            }
        };
    };
};
var getMonoid = function getMonoid(M) {
    var getSemigroupM = getSemigroup(M);
    return function() {
        return {
            concat: getSemigroupM().concat,
            empty: function empty() {
                return M.empty;
            }
        };
    };
};
var getSemiring = function getSemiring(S) {
    return {
        add: function add(f, g) {
            return function(x) {
                return S.add(f(x), g(x));
            };
        },
        zero: function zero() {
            return S.zero;
        },
        mul: function mul(f, g) {
            return function(x) {
                return S.mul(f(x), g(x));
            };
        },
        one: function one() {
            return S.one;
        }
    };
};
var getRing = function getRing(R) {
    var S = getSemiring(R);
    return {
        add: S.add,
        mul: S.mul,
        one: S.one,
        zero: S.zero,
        sub: function sub(f, g) {
            return function(x) {
                return R.sub(f(x), g(x));
            };
        }
    };
};
var apply = function apply(a) {
    return function(f) {
        return f(a);
    };
};
function identity(a) {
    return a;
}
var unsafeCoerce = identity;
function constant(a) {
    return function() {
        return a;
    };
}
var constTrue = /*#__PURE__*/ constant(true);
var constFalse = /*#__PURE__*/ constant(false);
var constNull = /*#__PURE__*/ constant(null);
var constUndefined = /*#__PURE__*/ constant(undefined);
var constVoid = constUndefined;
function flip(f) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (args.length > 1) return f(args[1], args[0]);
        return function(a) {
            return f(a)(args[0]);
        };
    };
}
function flow(ab, bc, cd, de, ef, fg, gh, hi, ij) {
    switch(arguments.length){
        case 1:
            return ab;
        case 2:
            return function() {
                return bc(ab.apply(this, arguments));
            };
        case 3:
            return function() {
                return cd(bc(ab.apply(this, arguments)));
            };
        case 4:
            return function() {
                return de(cd(bc(ab.apply(this, arguments))));
            };
        case 5:
            return function() {
                return ef(de(cd(bc(ab.apply(this, arguments)))));
            };
        case 6:
            return function() {
                return fg(ef(de(cd(bc(ab.apply(this, arguments))))));
            };
        case 7:
            return function() {
                return gh(fg(ef(de(cd(bc(ab.apply(this, arguments)))))));
            };
        case 8:
            return function() {
                return hi(gh(fg(ef(de(cd(bc(ab.apply(this, arguments))))))));
            };
        case 9:
            return function() {
                return ij(hi(gh(fg(ef(de(cd(bc(ab.apply(this, arguments)))))))));
            };
    }
    return;
}
function tuple() {
    var t = [];
    for(var _i = 0; _i < arguments.length; _i++)t[_i] = arguments[_i];
    return t;
}
function increment(n) {
    return n + 1;
}
function decrement(n) {
    return n - 1;
}
function absurd(_) {
    throw new Error('Called `absurd` function which should be uncallable');
}
function tupled(f) {
    return function(a) {
        return f.apply(void 0, a);
    };
}
function untupled(f) {
    return function() {
        var a = [];
        for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
        return f(a);
    };
}
function pipe(a, ab, bc, cd, de, ef, fg, gh, hi) {
    switch(arguments.length){
        case 1:
            return a;
        case 2:
            return ab(a);
        case 3:
            return bc(ab(a));
        case 4:
            return cd(bc(ab(a)));
        case 5:
            return de(cd(bc(ab(a))));
        case 6:
            return ef(de(cd(bc(ab(a)))));
        case 7:
            return fg(ef(de(cd(bc(ab(a))))));
        case 8:
            return gh(fg(ef(de(cd(bc(ab(a)))))));
        case 9:
            return hi(gh(fg(ef(de(cd(bc(ab(a))))))));
        default:
            var ret = arguments[0];
            for(var i = 1; i < arguments.length; i++)ret = arguments[i](ret);
            return ret;
    }
}
var hole = absurd;
var SK = function SK(_, b) {
    return b;
};
function not(predicate) {
    return function(a) {
        return !predicate(a);
    };
}
var getEndomorphismMonoid = function getEndomorphismMonoid() {
    return {
        concat: function concat(first, second) {
            return flow(first, second);
        },
        empty: identity
    };
};
var dual = function dual(arity, body) {
    var isDataFirst = typeof arity === 'number' ? function isDataFirst(args) {
        return args.length >= arity;
    } : arity;
    return function() {
        var args = Array.from(arguments);
        if (isDataFirst(arguments)) return body.apply(this, args);
        return function(self) {
            return body.apply(void 0, __spreadArray([
                self
            ], args, false));
        };
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gslSm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isNone", function() {
    return isNone;
});
parcelHelpers.export(exports, "isSome", function() {
    return isSome;
});
parcelHelpers.export(exports, "none", function() {
    return none;
});
parcelHelpers.export(exports, "some", function() {
    return some;
});
parcelHelpers.export(exports, "isLeft", function() {
    return isLeft;
});
parcelHelpers.export(exports, "isRight", function() {
    return isRight;
});
parcelHelpers.export(exports, "left", function() {
    return left;
});
parcelHelpers.export(exports, "right", function() {
    return right;
});
parcelHelpers.export(exports, "singleton", function() {
    return singleton;
});
parcelHelpers.export(exports, "isNonEmpty", function() {
    return isNonEmpty;
});
parcelHelpers.export(exports, "head", function() {
    return head;
});
parcelHelpers.export(exports, "tail", function() {
    return tail;
});
parcelHelpers.export(exports, "emptyReadonlyArray", function() {
    return emptyReadonlyArray;
});
parcelHelpers.export(exports, "emptyRecord", function() {
    return emptyRecord;
});
parcelHelpers.export(exports, "has", function() {
    return has;
});
parcelHelpers.export(exports, "fromReadonlyNonEmptyArray", function() {
    return fromReadonlyNonEmptyArray;
});
parcelHelpers.export(exports, "liftNullable", function() {
    return liftNullable;
});
parcelHelpers.export(exports, "liftOption", function() {
    return liftOption;
});
parcelHelpers.export(exports, "flatMapNullable", function() {
    return flatMapNullable;
});
parcelHelpers.export(exports, "flatMapOption", function() {
    return flatMapOption;
});
parcelHelpers.export(exports, "flatMapEither", function() {
    return flatMapEither;
});
parcelHelpers.export(exports, "flatMapIO", function() {
    return flatMapIO;
});
parcelHelpers.export(exports, "flatMapTask", function() {
    return flatMapTask;
});
parcelHelpers.export(exports, "flatMapReader", function() {
    return flatMapReader;
});
var _function = require("./function");
var __spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var isNone = function isNone(fa) {
    return fa._tag === 'None';
};
var isSome = function isSome(fa) {
    return fa._tag === 'Some';
};
var none = {
    _tag: 'None'
};
var some = function some(a) {
    return {
        _tag: 'Some',
        value: a
    };
};
var isLeft = function isLeft(ma) {
    return ma._tag === 'Left';
};
var isRight = function isRight(ma) {
    return ma._tag === 'Right';
};
var left = function left(e) {
    return {
        _tag: 'Left',
        left: e
    };
};
var right = function right(a) {
    return {
        _tag: 'Right',
        right: a
    };
};
var singleton = function singleton(a) {
    return [
        a
    ];
};
var isNonEmpty = function isNonEmpty(as) {
    return as.length > 0;
};
var head = function head(as) {
    return as[0];
};
var tail = function tail(as) {
    return as.slice(1);
};
var emptyReadonlyArray = [];
var emptyRecord = {};
var has = Object.prototype.hasOwnProperty;
var fromReadonlyNonEmptyArray = function fromReadonlyNonEmptyArray(as) {
    return __spreadArray([
        as[0]
    ], as.slice(1), true);
};
var liftNullable = function liftNullable(F) {
    return function(f, onNullable) {
        return function() {
            var a = [];
            for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
            var o = f.apply(void 0, a);
            return F.fromEither(o == null ? left(onNullable.apply(void 0, a)) : right(o));
        };
    };
};
var liftOption = function liftOption(F) {
    return function(f, onNone) {
        return function() {
            var a = [];
            for(var _i = 0; _i < arguments.length; _i++)a[_i] = arguments[_i];
            var o = f.apply(void 0, a);
            return F.fromEither(isNone(o) ? left(onNone.apply(void 0, a)) : right(o.value));
        };
    };
};
var flatMapNullable = function flatMapNullable(F, M) {
    return /*#__PURE__*/ (0, _function.dual)(3, function(self, f, onNullable) {
        return M.flatMap(self, liftNullable(F)(f, onNullable));
    });
};
var flatMapOption = function flatMapOption(F, M) {
    return /*#__PURE__*/ (0, _function.dual)(3, function(self, f, onNone) {
        return M.flatMap(self, liftOption(F)(f, onNone));
    });
};
var flatMapEither = function flatMapEither(F, M) {
    return /*#__PURE__*/ (0, _function.dual)(2, function(self, f) {
        return M.flatMap(self, function(a) {
            return F.fromEither(f(a));
        });
    });
};
var flatMapIO = function flatMapIO(F, M) {
    return /*#__PURE__*/ (0, _function.dual)(2, function(self, f) {
        return M.flatMap(self, function(a) {
            return F.fromIO(f(a));
        });
    });
};
var flatMapTask = function flatMapTask(F, M) {
    return /*#__PURE__*/ (0, _function.dual)(2, function(self, f) {
        return M.flatMap(self, function(a) {
            return F.fromTask(f(a));
        });
    });
};
var flatMapReader = function flatMapReader(F, M) {
    return /*#__PURE__*/ (0, _function.dual)(2, function(self, f) {
        return M.flatMap(self, function(a) {
            return F.fromReader(f(a));
        });
    });
};

},{"./function":"lQP8S","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"h16ze":[function(require,module,exports,__globalThis) {
/**
 * A `Functor` is a type constructor which supports a mapping operation `map`.
 *
 * `map` can be used to turn functions `a -> b` into functions `f a -> f b` whose argument and return types use the type
 * constructor `f` to represent some computational context.
 *
 * Instances must satisfy the following laws:
 *
 * 1. Identity: `F.map(fa, a => a) <-> fa`
 * 2. Composition: `F.map(fa, a => bc(ab(a))) <-> F.map(F.map(fa, ab), bc)`
 *
 * @since 2.0.0
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "map", function() {
    return map;
});
parcelHelpers.export(exports, "flap", function() {
    return flap;
});
parcelHelpers.export(exports, "bindTo", function() {
    return bindTo;
});
parcelHelpers.export(exports, "let", function() {
    return(/**
 * @since 2.13.0
 */ let_);
});
/** @deprecated */ parcelHelpers.export(exports, "getFunctorComposition", function() {
    return getFunctorComposition;
});
/** @internal */ parcelHelpers.export(exports, "as", function() {
    return as;
});
/** @internal */ parcelHelpers.export(exports, "asUnit", function() {
    return asUnit;
});
var _function = require("./function");
function map(F, G) {
    return function(f) {
        return function(fa) {
            return F.map(fa, function(ga) {
                return G.map(ga, f);
            });
        };
    };
}
function flap(F) {
    return function(a) {
        return function(fab) {
            return F.map(fab, function(f) {
                return f(a);
            });
        };
    };
}
function bindTo(F) {
    return function(name) {
        return function(fa) {
            return F.map(fa, function(a) {
                var _a;
                return _a = {}, _a[name] = a, _a;
            });
        };
    };
}
function let_(F) {
    return function(name, f) {
        return function(fa) {
            return F.map(fa, function(a) {
                var _a;
                return Object.assign({}, a, (_a = {}, _a[name] = f(a), _a));
            });
        };
    };
}
function getFunctorComposition(F, G) {
    var _map = map(F, G);
    return {
        map: function map(fga, f) {
            return (0, _function.pipe)(fga, _map(f));
        }
    };
}
function as(F) {
    return function(self, b) {
        return F.map(self, function() {
            return b;
        });
    };
}
function asUnit(F) {
    var asM = as(F);
    return function(self) {
        return asM(self, undefined);
    };
}

},{"./function":"lQP8S","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"e7tsl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "chainFirst", function() {
    return chainFirst;
});
/** @internal */ parcelHelpers.export(exports, "tap", function() {
    return tap;
});
parcelHelpers.export(exports, "bind", function() {
    return bind;
});
function chainFirst(M) {
    var tapM = tap(M);
    return function(f) {
        return function(first) {
            return tapM(first, f);
        };
    };
}
function tap(M) {
    return function(first, f) {
        return M.chain(first, function(a) {
            return M.map(f(a), function() {
                return a;
            });
        });
    };
}
function bind(M) {
    return function(name, f) {
        return function(ma) {
            return M.chain(ma, function(a) {
                return M.map(f(a), function(b) {
                    var _a;
                    return Object.assign({}, a, (_a = {}, _a[name] = b, _a));
                });
            });
        };
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6DDwz":[function(require,module,exports,__globalThis) {
/**
 * @since 2.0.0
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "tailRec", function() {
    return tailRec;
});
var tailRec = function tailRec(startWith, f) {
    var ab = f(startWith);
    while(ab._tag === 'Left')ab = f(ab.left);
    return ab.right;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"aKl3h":[function(require,module,exports,__globalThis) {
/**
 * The `FromEither` type class represents those data types which support errors.
 *
 * @since 2.10.0
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fromOption", function() {
    return fromOption;
});
parcelHelpers.export(exports, "fromPredicate", function() {
    return fromPredicate;
});
parcelHelpers.export(exports, "fromOptionK", function() {
    return fromOptionK;
});
parcelHelpers.export(exports, "chainOptionK", function() {
    return chainOptionK;
});
parcelHelpers.export(exports, "fromEitherK", function() {
    return fromEitherK;
});
parcelHelpers.export(exports, "chainEitherK", function() {
    return chainEitherK;
});
parcelHelpers.export(exports, "chainFirstEitherK", function() {
    return chainFirstEitherK;
});
parcelHelpers.export(exports, "filterOrElse", function() {
    return filterOrElse;
});
/** @internal */ parcelHelpers.export(exports, "tapEither", function() {
    return tapEither;
});
var _chain = require("./Chain");
var _function = require("./function");
var _internal = require("./internal");
function fromOption(F) {
    return function(onNone) {
        return function(ma) {
            return F.fromEither(_internal.isNone(ma) ? _internal.left(onNone()) : _internal.right(ma.value));
        };
    };
}
function fromPredicate(F) {
    return function(predicate, onFalse) {
        return function(a) {
            return F.fromEither(predicate(a) ? _internal.right(a) : _internal.left(onFalse(a)));
        };
    };
}
function fromOptionK(F) {
    var fromOptionF = fromOption(F);
    return function(onNone) {
        var from = fromOptionF(onNone);
        return function(f) {
            return (0, _function.flow)(f, from);
        };
    };
}
function chainOptionK(F, M) {
    var fromOptionKF = fromOptionK(F);
    return function(onNone) {
        var from = fromOptionKF(onNone);
        return function(f) {
            return function(ma) {
                return M.chain(ma, from(f));
            };
        };
    };
}
function fromEitherK(F) {
    return function(f) {
        return (0, _function.flow)(f, F.fromEither);
    };
}
function chainEitherK(F, M) {
    var fromEitherKF = fromEitherK(F);
    return function(f) {
        return function(ma) {
            return M.chain(ma, fromEitherKF(f));
        };
    };
}
function chainFirstEitherK(F, M) {
    var tapEitherM = tapEither(F, M);
    return function(f) {
        return function(ma) {
            return tapEitherM(ma, f);
        };
    };
}
function filterOrElse(F, M) {
    return function(predicate, onFalse) {
        return function(ma) {
            return M.chain(ma, function(a) {
                return F.fromEither(predicate(a) ? _internal.right(a) : _internal.left(onFalse(a)));
            });
        };
    };
}
function tapEither(F, M) {
    var fromEither = fromEitherK(F);
    var tapM = (0, _chain.tap)(M);
    return function(self, f) {
        return tapM(self, fromEither(f));
    };
}

},{"./Chain":"e7tsl","./function":"lQP8S","./internal":"gslSm","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gBLap":[function(require,module,exports,__globalThis) {
/**
 * ```ts
 * interface Separated<E, A> {
 *    readonly left: E
 *    readonly right: A
 * }
 * ```
 *
 * Represents a result of separating a whole into two parts.
 *
 * @since 2.10.0
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "separated", function() {
    return separated;
});
parcelHelpers.export(exports, "map", function() {
    return map;
});
parcelHelpers.export(exports, "mapLeft", function() {
    return mapLeft;
});
parcelHelpers.export(exports, "bimap", function() {
    return bimap;
});
parcelHelpers.export(exports, "URI", function() {
    return URI;
});
parcelHelpers.export(exports, "Bifunctor", function() {
    return Bifunctor;
});
parcelHelpers.export(exports, "Functor", function() {
    return Functor;
});
parcelHelpers.export(exports, "flap", function() {
    return flap;
});
parcelHelpers.export(exports, "left", function() {
    return left;
});
parcelHelpers.export(exports, "right", function() {
    return right;
});
var _function = require("./function");
var _functor = require("./Functor");
var separated = function separated(left, right) {
    return {
        left: left,
        right: right
    };
};
var _map = function _map(fa, f) {
    return (0, _function.pipe)(fa, map(f));
};
var _mapLeft = function _mapLeft(fa, f) {
    return (0, _function.pipe)(fa, mapLeft(f));
};
var _bimap = function _bimap(fa, g, f) {
    return (0, _function.pipe)(fa, bimap(g, f));
};
var map = function map(f) {
    return function(fa) {
        return separated(left(fa), f(right(fa)));
    };
};
var mapLeft = function mapLeft(f) {
    return function(fa) {
        return separated(f(left(fa)), right(fa));
    };
};
var bimap = function bimap(f, g) {
    return function(fa) {
        return separated(f(left(fa)), g(right(fa)));
    };
};
var URI = 'Separated';
var Bifunctor = {
    URI: URI,
    mapLeft: _mapLeft,
    bimap: _bimap
};
var Functor = {
    URI: URI,
    map: _map
};
var flap = /*#__PURE__*/ (0, _functor.flap)(Functor);
var left = function left(s) {
    return s.left;
};
var right = function right(s) {
    return s.right;
};

},{"./function":"lQP8S","./Functor":"h16ze","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"bQMCw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "wiltDefault", function() {
    return wiltDefault;
});
parcelHelpers.export(exports, "witherDefault", function() {
    return witherDefault;
});
parcelHelpers.export(exports, "filterE", function() {
    return filterE;
});
var _internal = require("./internal");
function wiltDefault(T, C) {
    return function(F) {
        var traverseF = T.traverse(F);
        return function(wa, f) {
            return F.map(traverseF(wa, f), C.separate);
        };
    };
}
function witherDefault(T, C) {
    return function(F) {
        var traverseF = T.traverse(F);
        return function(wa, f) {
            return F.map(traverseF(wa, f), C.compact);
        };
    };
}
function filterE(W) {
    return function(F) {
        var witherF = W.wither(F);
        return function(predicate) {
            return function(ga) {
                return witherF(ga, function(a) {
                    return F.map(predicate(a), function(b) {
                        return b ? _internal.some(a) : _internal.none;
                    });
                });
            };
        };
    };
}

},{"./internal":"gslSm","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"iGbZs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LogInAccountKey", function() {
    return LogInAccountKey;
});
parcelHelpers.export(exports, "LogInAccount", function() {
    return LogInAccount;
});
parcelHelpers.export(exports, "AccountLoginSucceedKey", function() {
    return AccountLoginSucceedKey;
});
parcelHelpers.export(exports, "AccountLoginSucceed", function() {
    return AccountLoginSucceed;
});
parcelHelpers.export(exports, "AccountLoginFailedKey", function() {
    return AccountLoginFailedKey;
});
parcelHelpers.export(exports, "AccountLoginFailed", function() {
    return AccountLoginFailed;
});
parcelHelpers.export(exports, "logInAccount", function() {
    return logInAccount;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _either = require("fp-ts/Either");
var _eventFactory = require("../../std/eventFactory");
var LogInAccountKey = 'LogInAccount';
var LogInAccount = (0, _eventFactory.eventFactory)(LogInAccountKey)();
var AccountLoginSucceedKey = 'AccountLoginSucceed';
var AccountLoginSucceed = (0, _eventFactory.eventFactory)(AccountLoginSucceedKey)();
var AccountLoginFailedKey = 'AccountLoginFailed';
var AccountLoginFailed = (0, _eventFactory.eventFactory)(AccountLoginFailedKey)();
function logInAccount(deps) {
    return /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(event) {
            var execution, response, redirectTo;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        execution = deps.logIn(event.payload);
                        return [
                            4,
                            deps.waitAtLeast(execution, 2000)
                        ];
                    case 1:
                        response = _state.sent();
                        if (_either.isLeft(response)) {
                            redirectTo = event.payload.redirectTo;
                            return [
                                2,
                                deps.publishEvent(AccountLoginSucceed({
                                    redirectTo: redirectTo
                                }))
                            ];
                        }
                        return [
                            2,
                            deps.publishEvent(AccountLoginFailed(response.right))
                        ];
                }
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }();
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_ts_generator":"f2hGH","fp-ts/Either":"jW2NS","../../std/eventFactory":"f2PpV","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6e41n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VerifyAccountExistenceKey", function() {
    return VerifyAccountExistenceKey;
});
parcelHelpers.export(exports, "VerifyAccountExistence", function() {
    return VerifyAccountExistence;
});
parcelHelpers.export(exports, "CustomerHasAccountKey", function() {
    return CustomerHasAccountKey;
});
parcelHelpers.export(exports, "CustomerHasAccount", function() {
    return CustomerHasAccount;
});
parcelHelpers.export(exports, "AccountActivationEmailSentKey", function() {
    return AccountActivationEmailSentKey;
});
parcelHelpers.export(exports, "AccountActivationEmailSent", function() {
    return AccountActivationEmailSent;
});
parcelHelpers.export(exports, "CustomerHasNoAccountKey", function() {
    return CustomerHasNoAccountKey;
});
parcelHelpers.export(exports, "CustomerHasNoAccount", function() {
    return CustomerHasNoAccount;
});
parcelHelpers.export(exports, "verifyAccountExistence", function() {
    return verifyAccountExistence;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _eventFactory = require("../../std/eventFactory");
var _std = require("@reglo/std");
var VerifyAccountExistenceKey = 'VerifyAccountExistence';
var VerifyAccountExistence = (0, _eventFactory.eventFactory)(VerifyAccountExistenceKey)();
var CustomerHasAccountKey = 'CustomerHasAccount';
var CustomerHasAccount = (0, _eventFactory.eventFactory)(CustomerHasAccountKey)();
var AccountActivationEmailSentKey = 'AccountActivationEmailSent';
var AccountActivationEmailSent = (0, _eventFactory.eventFactory)(AccountActivationEmailSentKey)();
var CustomerHasNoAccountKey = 'CustomerHasNoAccount';
var CustomerHasNoAccount = (0, _eventFactory.eventFactory)(CustomerHasNoAccountKey)();
function verifyAccountExistence(deps) {
    return /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(event) {
            var queryExecution, state;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        queryExecution = query(event);
                        return [
                            4,
                            deps.waitAtLeast(queryExecution, 2000)
                        ];
                    case 1:
                        state = _state.sent().state;
                        switch(state){
                            case (0, _std.AccountState).HasNoAccount:
                                return [
                                    3,
                                    2
                                ];
                            case (0, _std.AccountState).RequireActivation:
                                return [
                                    3,
                                    3
                                ];
                            case (0, _std.AccountState).HasAccount:
                                return [
                                    3,
                                    5
                                ];
                        }
                        return [
                            3,
                            6
                        ];
                    case 2:
                        return [
                            2,
                            deps.publishEvent(CustomerHasNoAccount())
                        ];
                    case 3:
                        return [
                            4,
                            deps.sendAccountActivationEmail(event.payload.email)
                        ];
                    case 4:
                        _state.sent();
                        return [
                            2,
                            deps.publishEvent(AccountActivationEmailSent())
                        ];
                    case 5:
                        return [
                            2,
                            deps.publishEvent(CustomerHasAccount())
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }();
    function query(event) {
        return _query.apply(this, arguments);
    }
    function _query() {
        _query = (0, _asyncToGenerator._)(function(event) {
            var email;
            return (0, _tsGenerator._)(this, function(_state) {
                email = event.payload.email;
                return [
                    2,
                    deps.doesCustomerHasAccount(email)
                ];
            });
        });
        return _query.apply(this, arguments);
    }
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_ts_generator":"f2hGH","../../std/eventFactory":"f2PpV","@reglo/std":"1USo0","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"9uy0y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Cta", function() {
    return Cta;
});
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _cta = require("../../../../components/Cta");
function Cta(props) {
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _cta.Cta), {
        label: props.label,
        isLoading: props.isLoading,
        isDisabled: props.isDisabled,
        formToSubmit: props.formToSubmit,
        className: "accountLogin_form__cta"
    }, void 0, false, {
        fileName: "src/script/src/dom/views/Account/views/Login/Cta.tsx",
        lineNumber: 11,
        columnNumber: 9
    }, this);
}

},{"react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","../../../../components/Cta":"beDOe","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"crChd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Register", function() {
    return Register;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _isValidEmail = require("../../../../services/isValidEmail");
var _reactRedux = require("react-redux");
var _form = require("./Form");
var _input = require("./Input");
var _cta = require("./Cta");
var _createAccount = require("../../../../../app/useCases/createAccount");
var _hooks = require("../../../../../std/hooks");
function Register() {
    var _useState = (0, _slicedToArray._)((0, _react.useState)(''), 2), firstName = _useState[0], setFirstName = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(''), 2), lastName = _useState1[0], setLastName = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)(''), 2), email = _useState2[0], setEmail = _useState2[1];
    var _useState3 = (0, _slicedToArray._)((0, _react.useState)(''), 2), emailError = _useState3[0], setEmailError = _useState3[1];
    var _useState4 = (0, _slicedToArray._)((0, _react.useState)(''), 2), password = _useState4[0], setPassword = _useState4[1];
    var _useState5 = (0, _slicedToArray._)((0, _react.useState)(''), 2), passwordError = _useState5[0], setPasswordError = _useState5[1];
    var _useState6 = (0, _slicedToArray._)((0, _react.useState)(null), 2), notification = _useState6[0], setNotification = _useState6[1];
    var _useState7 = (0, _slicedToArray._)((0, _react.useState)(false), 2), isLoading = _useState7[0], setIsLoading = _useState7[1];
    var dispatch = (0, _reactRedux.useDispatch)();
    var location = (0, _reactRouterDom.useLocation)();
    (0, _hooks.useOnEvent)((0, _createAccount.AccountCreationFailedKey), function(event) {
        var errors = event.payload.errors;
        setNotification(errors.form ? {
            type: 'error',
            message: errors.form
        } : null);
        var _errors_email;
        setEmailError((_errors_email = errors.email) !== null && _errors_email !== void 0 ? _errors_email : '');
        var _errors_password;
        setPasswordError((_errors_password = errors.password) !== null && _errors_password !== void 0 ? _errors_password : '');
        setIsLoading(false);
    });
    (0, _hooks.useOnEvent)((0, _createAccount.AccountCreatedKey), function() {
        window.location.href = '/pages/mon-compte';
    });
    useProvidedEmail();
    function handleSubmit() {
        setIsLoading(true);
        dispatch((0, _createAccount.CreateAccount)({
            firstName: firstName,
            lastName: lastName,
            email: email,
            password: password
        }));
    }
    function isDisabled() {
        return !firstName || !lastName || !(0, _isValidEmail.isValidEmail)(email) || !password;
    }
    function useProvidedEmail() {
        var _location_state;
        var _location_state_email;
        var emailFromPreviousPage = (_location_state_email = (_location_state = location.state) === null || _location_state === void 0 ? void 0 : _location_state.email) !== null && _location_state_email !== void 0 ? _location_state_email : '';
        (0, _react.useEffect)(function() {
            if (!email) setEmail(emailFromPreviousPage);
        }, [
            emailFromPreviousPage
        ]);
    }
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _form.Form), {
        title: "Nouveau chez r\xe9glo\xa0?",
        description: "Cr\xe9er mon compte client",
        notification: notification !== null && notification !== void 0 ? notification : undefined,
        onSubmit: handleSubmit,
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _input.Input), {
                label: "Pr\xe9nom",
                type: "firstName",
                value: firstName,
                onChange: setFirstName
            }, void 0, false, {
                fileName: "src/script/src/dom/views/Account/views/Login/Register.tsx",
                lineNumber: 67,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _input.Input), {
                label: "Nom",
                type: "lastName",
                value: lastName,
                onChange: setLastName
            }, void 0, false, {
                fileName: "src/script/src/dom/views/Account/views/Login/Register.tsx",
                lineNumber: 73,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _input.Input), {
                label: "Adresse e-mail",
                type: "login",
                value: email,
                onChange: setEmail,
                error: emailError
            }, void 0, false, {
                fileName: "src/script/src/dom/views/Account/views/Login/Register.tsx",
                lineNumber: 79,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _input.Input), {
                label: "Choisir mon mot de passe",
                type: "newPassword",
                value: password,
                onChange: setPassword,
                error: passwordError
            }, void 0, false, {
                fileName: "src/script/src/dom/views/Account/views/Login/Register.tsx",
                lineNumber: 86,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _cta.Cta), {
                label: "Enregistrer",
                isLoading: isLoading,
                isDisabled: isDisabled()
            }, void 0, false, {
                fileName: "src/script/src/dom/views/Account/views/Login/Register.tsx",
                lineNumber: 93,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                className: "accountLogin_form__links",
                children: [
                    "Vous avez d\xe9j\xe0 un compte\xa0? ",
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("a", {
                        href: "/account/login",
                        children: "Connectez-vous"
                    }, void 0, false, {
                        fileName: "src/script/src/dom/views/Account/views/Login/Register.tsx",
                        lineNumber: 98,
                        columnNumber: 82
                    }, this)
                ]
            }, void 0, true, {
                fileName: "src/script/src/dom/views/Account/views/Login/Register.tsx",
                lineNumber: 98,
                columnNumber: 13
            }, this)
        ]
    }, void 0, true, {
        fileName: "src/script/src/dom/views/Account/views/Login/Register.tsx",
        lineNumber: 61,
        columnNumber: 9
    }, this);
}

},{"@swc/helpers/_/_sliced_to_array":"ha6sq","react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","react-router-dom":"9VDGr","../../../../services/isValidEmail":"ckWap","react-redux":"ghMZu","./Form":"hakLH","./Input":"30BMV","./Cta":"9uy0y","../../../../../app/useCases/createAccount":"ypKSi","../../../../../std/hooks":"j9RPQ","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"ypKSi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CreateAccountKey", function() {
    return CreateAccountKey;
});
parcelHelpers.export(exports, "CreateAccount", function() {
    return CreateAccount;
});
parcelHelpers.export(exports, "AccountCreatedKey", function() {
    return AccountCreatedKey;
});
parcelHelpers.export(exports, "AccountCreated", function() {
    return AccountCreated;
});
parcelHelpers.export(exports, "AccountCreationFailedKey", function() {
    return AccountCreationFailedKey;
});
parcelHelpers.export(exports, "AccountCreationFailed", function() {
    return AccountCreationFailed;
});
parcelHelpers.export(exports, "createAccount", function() {
    return createAccount;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _eventFactory = require("../../std/eventFactory");
var _either = require("fp-ts/Either");
var CreateAccountKey = 'CreateAccount';
var CreateAccount = (0, _eventFactory.eventFactory)(CreateAccountKey)();
var AccountCreatedKey = 'AccountCreated';
var AccountCreated = (0, _eventFactory.eventFactory)(AccountCreatedKey)();
var AccountCreationFailedKey = 'AccountCreationFailed';
var AccountCreationFailed = (0, _eventFactory.eventFactory)(AccountCreationFailedKey)();
function createAccount(deps) {
    return /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(event) {
            var execution, response;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        execution = deps.createAccount(event.payload);
                        return [
                            4,
                            deps.waitAtLeast(execution, 2000)
                        ];
                    case 1:
                        response = _state.sent();
                        if (_either.isLeft(response)) return [
                            2,
                            deps.publishEvent(AccountCreated())
                        ];
                        return [
                            2,
                            deps.publishEvent(AccountCreationFailed(response.right))
                        ];
                }
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }();
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_ts_generator":"f2hGH","../../std/eventFactory":"f2PpV","fp-ts/Either":"jW2NS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"hiaZZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LastOrderDetails", function() {
    return LastOrderDetails;
});
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _layout = require("../Layout");
var _lastOrderView = require("../../../../../app/views/lastOrderView");
var _orderDetails = require("../OrderDetails/OrderDetails");
var _std = require("@reglo/std");
var _loadAccountSaga = require("../../../../../app/sagas/loadAccountSaga");
var _hooks = require("../../../../../std/hooks");
function LastOrderDetails() {
    var view = (0, _reactRedux.useSelector)((0, _lastOrderView.lastOrderView));
    var dispatch = (0, _hooks.useDispatch)();
    (0, _react.useEffect)(function() {
        dispatch((0, _loadAccountSaga.LoadAccount)());
    }, []);
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _layout.Layout), {
        page: (0, _layout.Page).LastOrderDetails,
        isLoading: view.state === 'loading',
        children: view.state !== 'loading' && /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _orderDetails.OrderDetails), {
            view: (0, _std.unwrap)(view.order),
            backCta: {
                text: `Retour \xe0 l'abonnement`,
                linkTo: '/pages/abonnement'
            }
        }, void 0, false, {
            fileName: "src/script/src/dom/views/Account/views/LastOrderDetails/LastOrderDetails.tsx",
            lineNumber: 18,
            columnNumber: 42
        }, this)
    }, void 0, false, {
        fileName: "src/script/src/dom/views/Account/views/LastOrderDetails/LastOrderDetails.tsx",
        lineNumber: 17,
        columnNumber: 9
    }, this);
}

},{"react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","react-redux":"ghMZu","../Layout":"gnkXt","../../../../../app/views/lastOrderView":"ewcjJ","../OrderDetails/OrderDetails":"x9f1w","@reglo/std":"1USo0","../../../../../app/sagas/loadAccountSaga":"fo1BR","../../../../../std/hooks":"j9RPQ","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jp6rK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReloadDomAppKey", function() {
    return ReloadDomAppKey;
});
parcelHelpers.export(exports, "ReloadDomApp", function() {
    return ReloadDomApp;
});
parcelHelpers.export(exports, "DomApp", function() {
    return DomApp;
});
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _startApp = require("../../app/events/StartApp");
var _hooks = require("../../std/hooks");
var _blocks = require("../../../../snippets/blocks");
var _snippets = require("../../../../snippets");
var _sections = require("../../../../sections");
var _eventFactory = require("../../std/eventFactory");
var _useReload = require("../hooks/useReload");
var ReloadDomAppKey = 'ReviewsPreview.ReloadDomApp';
var ReloadDomApp = (0, _eventFactory.eventFactory)(ReloadDomAppKey)();
function DomApp() {
    var dispatch = (0, _hooks.useDispatch)();
    var reload = (0, _useReload.useReload)();
    (0, _react.useEffect)(function() {
        dispatch((0, _startApp.StartApp)());
    }, []);
    (0, _hooks.useOnEvent)(ReloadDomAppKey, reload);
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _jsxDevRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _sections.Sections), {}, void 0, false, {
                fileName: "src/script/src/dom/views/App.tsx",
                lineNumber: 24,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _blocks.Blocks), {}, void 0, false, {
                fileName: "src/script/src/dom/views/App.tsx",
                lineNumber: 25,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _snippets.Snippets), {}, void 0, false, {
                fileName: "src/script/src/dom/views/App.tsx",
                lineNumber: 26,
                columnNumber: 13
            }, this)
        ]
    }, void 0, true);
}

},{"react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","../../app/events/StartApp":"ggoaD","../../std/hooks":"j9RPQ","../../../../snippets/blocks":"fDHIY","../../../../snippets":"cuYXS","../../../../sections":"8H2M7","../../std/eventFactory":"f2PpV","../hooks/useReload":"f9rI7","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"ggoaD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StartAppKey", function() {
    return StartAppKey;
});
parcelHelpers.export(exports, "StartApp", function() {
    return StartApp;
});
var _eventFactory = require("../../std/eventFactory");
var StartAppKey = 'Core.StartApp';
var StartApp = (0, _eventFactory.eventFactory)(StartAppKey)();

},{"../../std/eventFactory":"f2PpV","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"fDHIY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Blocks", function() {
    return Blocks;
});
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _ratingLink = require("./ratingLink");
var _accordion = require("./accordion");
var _youtube = require("./media/youtube");
var _paragraph = require("./paragraph");
function Blocks() {
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _jsxDevRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _accordion.Accordions), {}, void 0, false, {
                fileName: "src/snippets/blocks/index.tsx",
                lineNumber: 10,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _ratingLink.RatingLinks), {}, void 0, false, {
                fileName: "src/snippets/blocks/index.tsx",
                lineNumber: 11,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _youtube.YoutubeMedias), {}, void 0, false, {
                fileName: "src/snippets/blocks/index.tsx",
                lineNumber: 12,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _paragraph.Paragraphs), {}, void 0, false, {
                fileName: "src/snippets/blocks/index.tsx",
                lineNumber: 13,
                columnNumber: 13
            }, this)
        ]
    }, void 0, true);
}

},{"react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","./ratingLink":"4clZH","./accordion":"lAfoI","./media/youtube":"gGSYD","./paragraph":"c6sIC","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4clZH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RatingLinks", function() {
    return RatingLinks;
});
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _domElement = require("../../../script/src/dom/library/DomElement");
var _hooks = require("../../../script/src/std/hooks");
var _domArray = require("../../../script/src/dom/library/DomArray");
var _domComponent = require("../../../script/src/dom/library/DomComponent");
function RatingLinks() {
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domArray.DomArray), {
        selector: ".blockRatingLink",
        child: function(param) {
            var key = param.key, selector = param.selector;
            return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(RatingLink, {
                selector: selector
            }, key, false, {
                fileName: "src/snippets/blocks/ratingLink/index.tsx",
                lineNumber: 9,
                columnNumber: 77
            }, void 0);
        }
    }, void 0, false, {
        fileName: "src/snippets/blocks/ratingLink/index.tsx",
        lineNumber: 9,
        columnNumber: 9
    }, this);
}
function RatingLink(props) {
    var selector = props.selector;
    var target = (0, _domElement.useNullableAttributeValue)('data-scrollTo', selector);
    var scrollTo = (0, _hooks.useScrollTo)({
        selector: target ? `[data-section_id=${target}]` : undefined
    });
    function onClick(event) {
        if (!target) return;
        event.preventDefault();
        scrollTo();
    }
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
        selector: selector,
        onClick: onClick
    }, void 0, false, {
        fileName: "src/snippets/blocks/ratingLink/index.tsx",
        lineNumber: 29,
        columnNumber: 9
    }, this);
}

},{"react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","../../../script/src/dom/library/DomElement":"15N7Q","../../../script/src/std/hooks":"j9RPQ","../../../script/src/dom/library/DomArray":"ZEl1X","../../../script/src/dom/library/DomComponent":"8H9za","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"lAfoI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Accordions", function() {
    return Accordions;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _domArray = require("../../../script/src/dom/library/DomArray");
var _domComponent = require("../../../script/src/dom/library/DomComponent");
var _std = require("@reglo/std");
var _domElement = require("../../../script/src/dom/library/DomElement");
var _hooks = require("../../../script/src/std/hooks");
var _useTrack = require("../../../script/src/dom/hooks/useTrack");
function Accordions() {
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domArray.DomArray), {
        selector: ".blockAccordion",
        child: function(param) {
            var key = param.key, selector = param.selector;
            return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(Accordion, {
                selector: selector
            }, key, false, {
                fileName: "src/snippets/blocks/accordion/index.tsx",
                lineNumber: 16,
                columnNumber: 76
            }, void 0);
        }
    }, void 0, false, {
        fileName: "src/snippets/blocks/accordion/index.tsx",
        lineNumber: 16,
        columnNumber: 9
    }, this);
}
function Accordion(props) {
    var selector = props.selector;
    var openedCssClass = 'blockAccordion--opened';
    var track = (0, _useTrack.useTrack)();
    var isOpenedOnLoad = (0, _domElement.doesElementHasClass)(openedCssClass, selector);
    var _useState = (0, _slicedToArray._)((0, _react.useState)(isOpenedOnLoad), 2), opened = _useState[0], setOpened = _useState[1];
    var sectionId = (0, _domElement.useSectionId)(props.selector);
    var title = (0, _domElement.useDomElementText)(`${props.selector} [data-id=title]`);
    function toggle() {
        opened ? close() : open();
    }
    function open() {
        setOpened(true);
        track('OpenAccordion', {
            sectionId: sectionId,
            title: title
        });
    }
    function close() {
        setOpened(false);
    }
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
        selector: selector,
        classes: (0, _defineProperty._)({}, openedCssClass, opened),
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
                selector: "&__header",
                onClick: toggle
            }, void 0, false, {
                fileName: "src/snippets/blocks/accordion/index.tsx",
                lineNumber: 46,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(AccordionBody, {
                opened: opened
            }, void 0, false, {
                fileName: "src/snippets/blocks/accordion/index.tsx",
                lineNumber: 47,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(ImagesPreloader, {}, void 0, false, {
                fileName: "src/snippets/blocks/accordion/index.tsx",
                lineNumber: 48,
                columnNumber: 13
            }, this)
        ]
    }, void 0, true, {
        fileName: "src/snippets/blocks/accordion/index.tsx",
        lineNumber: 45,
        columnNumber: 9
    }, this);
}
function ImagesPreloader() {
    var elementSelector = (0, _domElement.useDomElement)().elementSelector;
    (0, _hooks.useOnElementFirstAppearanceInScreen)(preloadImages, {
        delayOnPageLoad: 3000
    });
    function preloadImages() {
        document.querySelectorAll(`${elementSelector} img`).forEach(function(element) {
            element.removeAttribute('loading');
        });
    }
    return null;
}
function AccordionBody(props) {
    var element = (0, _std.unwrap)((0, _domElement.useDomElement)('&__body').element);
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), previouslyOpened = _useState[0], setPreviouslyOpened = _useState[1];
    (0, _react.useEffect)(function() {
        return props.opened ? openAccordion() : closeAccordion();
    }, [
        props.opened
    ]);
    return null;
    function closeAccordion() {
        if (previouslyOpened) element.style.height = `${element.scrollHeight}px`;
        setTimeout(function() {
            element.style.height = '0px';
        }, 1);
    }
    function openAccordion() {
        element.style.height = `${element.scrollHeight}px`;
        if (!previouslyOpened) setPreviouslyOpened(true);
        setTimeout(function() {
            element.style.height = '';
        }, 500);
    }
}

},{"@swc/helpers/_/_define_property":"54Zvk","@swc/helpers/_/_sliced_to_array":"ha6sq","react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","../../../script/src/dom/library/DomArray":"ZEl1X","../../../script/src/dom/library/DomComponent":"8H9za","@reglo/std":"1USo0","../../../script/src/dom/library/DomElement":"15N7Q","../../../script/src/std/hooks":"j9RPQ","../../../script/src/dom/hooks/useTrack":"iL2dq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gGSYD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "YoutubeMedias", function() {
    return YoutubeMedias;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _domElement = require("../../../script/src/dom/library/DomElement");
var _domArray = require("../../../script/src/dom/library/DomArray");
var _domComponent = require("../../../script/src/dom/library/DomComponent");
var _youtubePlayer = require("youtube-player");
var _youtubePlayerDefault = parcelHelpers.interopDefault(_youtubePlayer);
var _std = require("@reglo/std");
var _useTrack = require("../../../script/src/dom/hooks/useTrack");
function YoutubeMedias() {
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domArray.DomArray), {
        selector: ".blockMedia__youtube",
        child: function(param) {
            var key = param.key, selector = param.selector;
            return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(YoutubeMedia, {
                selector: selector
            }, key, false, {
                fileName: "src/snippets/blocks/media/youtube.tsx",
                lineNumber: 12,
                columnNumber: 81
            }, void 0);
        }
    }, void 0, false, {
        fileName: "src/snippets/blocks/media/youtube.tsx",
        lineNumber: 12,
        columnNumber: 9
    }, this);
}
function YoutubeMedia(props) {
    var videoId = (0, _std.unwrap)((0, _domElement.useNullableAttributeValue)('data-video-id', props.selector));
    var containerSelector = `${props.selector} .blockMedia__youtube__video`;
    var containerId = (0, _std.unwrap)((0, _domElement.useNullableAttributeValue)('id', containerSelector));
    var _useState = (0, _slicedToArray._)((0, _react.useState)(), 2), player = _useState[0], setPlayer = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(false), 2), play = _useState1[0], setPlay = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)(), 2), title = _useState2[0], setTitle = _useState2[1];
    var track = (0, _useTrack.useTrack)();
    (0, _react.useEffect)(function() {
        var player = (0, _youtubePlayerDefault.default)(containerId, {
            videoId: videoId,
            playerVars: {
                rel: 0
            }
        });
        // @ts-ignore
        player.on('ready', function(event) {
            return setTitle(event.target.videoTitle);
        });
        setPlayer(player);
    }, []);
    function onClick(event) {
        return _onClick.apply(this, arguments);
    }
    function _onClick() {
        _onClick = (0, _asyncToGenerator._)(function(event) {
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        event.preventDefault();
                        setPlay(true);
                        return [
                            4,
                            (0, _std.unwrap)(player).playVideo()
                        ];
                    case 1:
                        _state.sent();
                        track('PlayVideo', {
                            title: title,
                            videoId: videoId
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return _onClick.apply(this, arguments);
    }
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
        selector: props.selector,
        classes: {
            play: play
        },
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
                selector: ".blockMedia__youtube__video"
            }, void 0, false, {
                fileName: "src/snippets/blocks/media/youtube.tsx",
                lineNumber: 43,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
                selector: ".blockMedia__youtube__play",
                onClick: onClick
            }, void 0, false, {
                fileName: "src/snippets/blocks/media/youtube.tsx",
                lineNumber: 44,
                columnNumber: 13
            }, this)
        ]
    }, void 0, true, {
        fileName: "src/snippets/blocks/media/youtube.tsx",
        lineNumber: 42,
        columnNumber: 9
    }, this);
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_sliced_to_array":"ha6sq","@swc/helpers/_/_ts_generator":"f2hGH","react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","../../../script/src/dom/library/DomElement":"15N7Q","../../../script/src/dom/library/DomArray":"ZEl1X","../../../script/src/dom/library/DomComponent":"8H9za","youtube-player":"9hp7s","@reglo/std":"1USo0","../../../script/src/dom/hooks/useTrack":"iL2dq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"9hp7s":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _sister = require("b57d8c412065127f");
var _sister2 = _interopRequireDefault(_sister);
var _YouTubePlayer = require("e7235fa0d15c4f0b");
var _YouTubePlayer2 = _interopRequireDefault(_YouTubePlayer);
var _loadYouTubeIframeApi = require("c5742c4f1dbc1159");
var _loadYouTubeIframeApi2 = _interopRequireDefault(_loadYouTubeIframeApi);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * @typedef YT.Player
 * @see https://developers.google.com/youtube/iframe_api_reference
 */ /**
 * @see https://developers.google.com/youtube/iframe_api_reference#Loading_a_Video_Player
 */ var youtubeIframeAPI;
/**
 * A factory function used to produce an instance of YT.Player and queue function calls and proxy events of the resulting object.
 *
 * @param maybeElementId Either An existing YT.Player instance,
 * the DOM element or the id of the HTML element where the API will insert an <iframe>.
 * @param options See `options` (Ignored when using an existing YT.Player instance).
 * @param strictState A flag designating whether or not to wait for
 * an acceptable state when calling supported functions. Default: `false`.
 * See `FunctionStateMap.js` for supported functions and acceptable states.
 */ exports.default = function(maybeElementId) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, strictState = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var emitter = (0, _sister2.default)();
    if (!youtubeIframeAPI) youtubeIframeAPI = (0, _loadYouTubeIframeApi2.default)(emitter);
    if (options.events) throw new Error('Event handlers cannot be overwritten.');
    // eslint-disable-next-line unicorn/prefer-query-selector
    if (typeof maybeElementId === 'string' && !document.getElementById(maybeElementId)) throw new Error('Element "' + maybeElementId + '" does not exist.');
    options.events = _YouTubePlayer2.default.proxyEvents(emitter);
    var playerAPIReady = new Promise(function(resolve) {
        if (typeof maybeElementId === 'object' && maybeElementId.playVideo instanceof Function) {
            var player = maybeElementId;
            resolve(player);
        } else // asume maybeElementId can be rendered inside
        // eslint-disable-next-line promise/catch-or-return
        youtubeIframeAPI.then(function(YT) {
            // eslint-disable-line promise/prefer-await-to-then
            var player = new YT.Player(maybeElementId, options);
            emitter.on('ready', function() {
                resolve(player);
            });
            return null;
        });
    });
    var playerApi = _YouTubePlayer2.default.promisifyPlayer(playerAPIReady, strictState);
    playerApi.on = emitter.on;
    playerApi.off = emitter.off;
    return playerApi;
};
module.exports = exports['default'];

},{"b57d8c412065127f":"1o3Pg","e7235fa0d15c4f0b":"9b0iZ","c5742c4f1dbc1159":"6zEzf"}],"1o3Pg":[function(require,module,exports,__globalThis) {
'use strict';
var Sister;
/**
* @link https://github.com/gajus/sister for the canonical source repository
* @license https://github.com/gajus/sister/blob/master/LICENSE BSD 3-Clause
*/ Sister = function Sister() {
    var sister = {}, events = {};
    /**
     * @name handler
     * @function
     * @param {Object} data Event data.
     */ /**
     * @param {String} name Event name.
     * @param {handler} handler
     * @return {listener}
     */ sister.on = function(name, handler) {
        var listener = {
            name: name,
            handler: handler
        };
        events[name] = events[name] || [];
        events[name].unshift(listener);
        return listener;
    };
    /**
     * @param {listener}
     */ sister.off = function(listener) {
        var index = events[listener.name].indexOf(listener);
        if (index !== -1) events[listener.name].splice(index, 1);
    };
    /**
     * @param {String} name Event name.
     * @param {Object} data Event data.
     */ sister.trigger = function(name, data) {
        var listeners = events[name], i;
        if (listeners) {
            i = listeners.length;
            while(i--)listeners[i].handler(data);
        }
    };
    return sister;
};
module.exports = Sister;

},{}],"9b0iZ":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _debug = require("d666b3669dc861db");
var _debug2 = _interopRequireDefault(_debug);
var _FunctionStateMap = require("76c2169923072471");
var _FunctionStateMap2 = _interopRequireDefault(_FunctionStateMap);
var _eventNames = require("9d738db9b6ef0302");
var _eventNames2 = _interopRequireDefault(_eventNames);
var _functionNames = require("2c53efa60e6c47a5");
var _functionNames2 = _interopRequireDefault(_functionNames);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/* eslint-disable promise/prefer-await-to-then */ var debug = (0, _debug2.default)('youtube-player');
var YouTubePlayer = {};
/**
 * Construct an object that defines an event handler for all of the YouTube
 * player events. Proxy captured events through an event emitter.
 *
 * @todo Capture event parameters.
 * @see https://developers.google.com/youtube/iframe_api_reference#Events
 */ YouTubePlayer.proxyEvents = function(emitter) {
    var events = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var eventName = _step.value;
            var onEventName = 'on' + eventName.slice(0, 1).toUpperCase() + eventName.slice(1);
            events[onEventName] = function(event) {
                debug('event "%s"', onEventName, event);
                emitter.trigger(eventName, event);
            };
        };
        for(var _iterator = _eventNames2.default[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return events;
};
/**
 * Delays player API method execution until player state is ready.
 *
 * @todo Proxy all of the methods using Object.keys.
 * @todo See TRICKY below.
 * @param playerAPIReady Promise that resolves when player is ready.
 * @param strictState A flag designating whether or not to wait for
 * an acceptable state when calling supported functions.
 * @returns {object}
 */ YouTubePlayer.promisifyPlayer = function(playerAPIReady) {
    var strictState = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var functions = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var functionName = _step.value;
            if (strictState && _FunctionStateMap2.default[functionName]) functions[functionName] = function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return playerAPIReady.then(function(player) {
                    var stateInfo = _FunctionStateMap2.default[functionName];
                    var playerState = player.getPlayerState();
                    // eslint-disable-next-line no-warning-comments
                    // TODO: Just spread the args into the function once Babel is fixed:
                    // https://github.com/babel/babel/issues/4270
                    //
                    // eslint-disable-next-line prefer-spread
                    var value = player[functionName].apply(player, args);
                    // TRICKY: For functions like `seekTo`, a change in state must be
                    // triggered given that the resulting state could match the initial
                    // state.
                    if (stateInfo.stateChangeRequired || // eslint-disable-next-line no-extra-parens
                    Array.isArray(stateInfo.acceptableStates) && !stateInfo.acceptableStates.includes(playerState)) return new Promise(function(resolve) {
                        var onPlayerStateChange = function() {
                            var playerStateAfterChange = player.getPlayerState();
                            var timeout;
                            if (typeof stateInfo.timeout === 'number') timeout = setTimeout(function() {
                                player.removeEventListener('onStateChange', onPlayerStateChange);
                                resolve();
                            }, stateInfo.timeout);
                            if (Array.isArray(stateInfo.acceptableStates) && stateInfo.acceptableStates.includes(playerStateAfterChange)) {
                                player.removeEventListener('onStateChange', onPlayerStateChange);
                                clearTimeout(timeout);
                                resolve();
                            }
                        };
                        player.addEventListener('onStateChange', onPlayerStateChange);
                    }).then(function() {
                        return value;
                    });
                    return value;
                });
            };
            else functions[functionName] = function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return playerAPIReady.then(function(player) {
                    // eslint-disable-next-line no-warning-comments
                    // TODO: Just spread the args into the function once Babel is fixed:
                    // https://github.com/babel/babel/issues/4270
                    //
                    // eslint-disable-next-line prefer-spread
                    return player[functionName].apply(player, args);
                });
            };
        };
        for(var _iterator = _functionNames2.default[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return functions;
};
exports.default = YouTubePlayer;
module.exports = exports['default'];

},{"d666b3669dc861db":"490Cd","76c2169923072471":"gvDzr","9d738db9b6ef0302":"azAev","2c53efa60e6c47a5":"3KlV0"}],"490Cd":[function(require,module,exports,__globalThis) {
/* eslint-env browser */ /**
 * This is the web browser implementation of `debug()`.
 */ exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = localstorage();
exports.destroy = function() {
    var warned = false;
    return function() {
        if (!warned) {
            warned = true;
            console.warn('Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.');
        }
    };
}();
/**
 * Colors.
 */ exports.colors = [
    '#0000CC',
    '#0000FF',
    '#0033CC',
    '#0033FF',
    '#0066CC',
    '#0066FF',
    '#0099CC',
    '#0099FF',
    '#00CC00',
    '#00CC33',
    '#00CC66',
    '#00CC99',
    '#00CCCC',
    '#00CCFF',
    '#3300CC',
    '#3300FF',
    '#3333CC',
    '#3333FF',
    '#3366CC',
    '#3366FF',
    '#3399CC',
    '#3399FF',
    '#33CC00',
    '#33CC33',
    '#33CC66',
    '#33CC99',
    '#33CCCC',
    '#33CCFF',
    '#6600CC',
    '#6600FF',
    '#6633CC',
    '#6633FF',
    '#66CC00',
    '#66CC33',
    '#9900CC',
    '#9900FF',
    '#9933CC',
    '#9933FF',
    '#99CC00',
    '#99CC33',
    '#CC0000',
    '#CC0033',
    '#CC0066',
    '#CC0099',
    '#CC00CC',
    '#CC00FF',
    '#CC3300',
    '#CC3333',
    '#CC3366',
    '#CC3399',
    '#CC33CC',
    '#CC33FF',
    '#CC6600',
    '#CC6633',
    '#CC9900',
    '#CC9933',
    '#CCCC00',
    '#CCCC33',
    '#FF0000',
    '#FF0033',
    '#FF0066',
    '#FF0099',
    '#FF00CC',
    '#FF00FF',
    '#FF3300',
    '#FF3333',
    '#FF3366',
    '#FF3399',
    '#FF33CC',
    '#FF33FF',
    '#FF6600',
    '#FF6633',
    '#FF9900',
    '#FF9933',
    '#FFCC00',
    '#FFCC33'
];
/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */ // eslint-disable-next-line complexity
function useColors() {
    // NB: In an Electron preload script, document will be defined but not fully
    // initialized. Since we know we're in Chrome, we'll just detect this case
    // explicitly
    if (typeof window !== 'undefined' && window.process && (window.process.type === 'renderer' || window.process.__nwjs)) return true;
    // Internet Explorer and Edge do not support colors.
    if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) return false;
    var m;
    // Is webkit? http://stackoverflow.com/a/16459606/376773
    // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
    // eslint-disable-next-line no-return-assign
    return typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // Is firebug? http://stackoverflow.com/a/398120/376773
    typeof window !== 'undefined' && window.console && (window.console.firebug || window.console.exception && window.console.table) || // Is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    typeof navigator !== 'undefined' && navigator.userAgent && (m = navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/)) && parseInt(m[1], 10) >= 31 || // Double check webkit in userAgent just in case we are in a worker
    typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
}
/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */ function formatArgs(args) {
    args[0] = (this.useColors ? '%c' : '') + this.namespace + (this.useColors ? ' %c' : ' ') + args[0] + (this.useColors ? '%c ' : ' ') + '+' + module.exports.humanize(this.diff);
    if (!this.useColors) return;
    var c = 'color: ' + this.color;
    args.splice(1, 0, c, 'color: inherit');
    // The final "%c" is somewhat tricky, because there could be other
    // arguments passed either before or after the %c, so we need to
    // figure out the correct index to insert the CSS into
    var index = 0;
    var lastC = 0;
    args[0].replace(/%[a-zA-Z%]/g, function(match) {
        if (match === '%%') return;
        index++;
        if (match === '%c') // We only are interested in the *last* %c
        // (the user may have provided their own)
        lastC = index;
    });
    args.splice(lastC, 0, c);
}
/**
 * Invokes `console.debug()` when available.
 * No-op when `console.debug` is not a "function".
 * If `console.debug` is not available, falls back
 * to `console.log`.
 *
 * @api public
 */ exports.log = console.debug || console.log || function() {};
/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */ function save(namespaces) {
    try {
        if (namespaces) exports.storage.setItem('debug', namespaces);
        else exports.storage.removeItem('debug');
    } catch (error) {
    // Swallow
    // XXX (@Qix-) should we be logging these?
    }
}
/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */ function load() {
    var r;
    try {
        r = exports.storage.getItem('debug');
    } catch (error) {
    // Swallow
    // XXX (@Qix-) should we be logging these?
    }
    return r;
}
/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */ function localstorage() {
    try {
        // TVMLKit (Apple TV JS Runtime) does not have a window object, just localStorage in the global context
        // The Browser also has localStorage in the global context.
        return localStorage;
    } catch (error) {
    // Swallow
    // XXX (@Qix-) should we be logging these?
    }
}
module.exports = require("93aa844dc8971dcd")(exports);
var formatters = module.exports.formatters;
/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */ formatters.j = function(v) {
    try {
        return JSON.stringify(v);
    } catch (error) {
        return '[UnexpectedJSONParseError]: ' + error.message;
    }
};

},{"93aa844dc8971dcd":"4g4pr"}],"4g4pr":[function(require,module,exports,__globalThis) {
/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 */ var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
function setup(env) {
    createDebug.debug = createDebug;
    createDebug.default = createDebug;
    createDebug.coerce = coerce;
    createDebug.disable = disable;
    createDebug.enable = enable;
    createDebug.enabled = enabled;
    createDebug.humanize = require("a57a5992a3072d81");
    createDebug.destroy = destroy;
    Object.keys(env).forEach(function(key) {
        createDebug[key] = env[key];
    });
    /**
	* The currently active debug mode names, and names to skip.
	*/ createDebug.names = [];
    createDebug.skips = [];
    /**
	* Map of special "%n" handling functions, for the debug "format" argument.
	*
	* Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	*/ createDebug.formatters = {};
    /**
	* Selects a color for a debug namespace
	* @param {String} namespace The namespace string for the debug instance to be colored
	* @return {Number|String} An ANSI color code for the given namespace
	* @api private
	*/ function selectColor(namespace) {
        var hash = 0;
        for(var i = 0; i < namespace.length; i++){
            hash = (hash << 5) - hash + namespace.charCodeAt(i);
            hash |= 0; // Convert to 32bit integer
        }
        return createDebug.colors[Math.abs(hash) % createDebug.colors.length];
    }
    createDebug.selectColor = selectColor;
    /**
	* Create a debugger with the given `namespace`.
	*
	* @param {String} namespace
	* @return {Function}
	* @api public
	*/ function createDebug(namespace) {
        var prevTime;
        var enableOverride = null;
        var namespacesCache;
        var enabledCache;
        function debug() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            // Disabled?
            if (!debug.enabled) return;
            var self = debug;
            // Set `diff` timestamp
            var curr = Number(new Date());
            var ms = curr - (prevTime || curr);
            self.diff = ms;
            self.prev = prevTime;
            self.curr = curr;
            prevTime = curr;
            args[0] = createDebug.coerce(args[0]);
            if (typeof args[0] !== 'string') // Anything else let's inspect with %O
            args.unshift('%O');
            // Apply any `formatters` transformations
            var index = 0;
            args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
                // If we encounter an escaped % then don't increase the array index
                if (match === '%%') return '%';
                index++;
                var formatter = createDebug.formatters[format];
                if (typeof formatter === 'function') {
                    var val = args[index];
                    match = formatter.call(self, val);
                    // Now we need to remove `args[index]` since it's inlined in the `format`
                    args.splice(index, 1);
                    index--;
                }
                return match;
            });
            // Apply env-specific formatting (colors, etc.)
            createDebug.formatArgs.call(self, args);
            var logFn = self.log || createDebug.log;
            logFn.apply(self, args);
        }
        debug.namespace = namespace;
        debug.useColors = createDebug.useColors();
        debug.color = createDebug.selectColor(namespace);
        debug.extend = extend;
        debug.destroy = createDebug.destroy; // XXX Temporary. Will be removed in the next major release.
        Object.defineProperty(debug, 'enabled', {
            enumerable: true,
            configurable: false,
            get: function() {
                if (enableOverride !== null) return enableOverride;
                if (namespacesCache !== createDebug.namespaces) {
                    namespacesCache = createDebug.namespaces;
                    enabledCache = createDebug.enabled(namespace);
                }
                return enabledCache;
            },
            set: function(v) {
                enableOverride = v;
            }
        });
        // Env-specific initialization logic for debug instances
        if (typeof createDebug.init === 'function') createDebug.init(debug);
        return debug;
    }
    function extend(namespace, delimiter) {
        var newDebug = createDebug(this.namespace + (typeof delimiter === 'undefined' ? ':' : delimiter) + namespace);
        newDebug.log = this.log;
        return newDebug;
    }
    /**
	* Enables a debug mode by namespaces. This can include modes
	* separated by a colon and wildcards.
	*
	* @param {String} namespaces
	* @api public
	*/ function enable(namespaces) {
        createDebug.save(namespaces);
        createDebug.namespaces = namespaces;
        createDebug.names = [];
        createDebug.skips = [];
        var split = (typeof namespaces === 'string' ? namespaces : '').trim().replace(' ', ',').split(',').filter(Boolean);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = split[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var ns = _step.value;
                if (ns[0] === '-') createDebug.skips.push(ns.slice(1));
                else createDebug.names.push(ns);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    /**
	 * Checks if the given string matches a namespace template, honoring
	 * asterisks as wildcards.
	 *
	 * @param {String} search
	 * @param {String} template
	 * @return {Boolean}
	 */ function matchesTemplate(search, template) {
        var searchIndex = 0;
        var templateIndex = 0;
        var starIndex = -1;
        var matchIndex = 0;
        while(searchIndex < search.length){
            if (templateIndex < template.length && (template[templateIndex] === search[searchIndex] || template[templateIndex] === '*')) {
                // Match character or proceed with wildcard
                if (template[templateIndex] === '*') {
                    starIndex = templateIndex;
                    matchIndex = searchIndex;
                    templateIndex++; // Skip the '*'
                } else {
                    searchIndex++;
                    templateIndex++;
                }
            } else if (starIndex !== -1) {
                // Backtrack to the last '*' and try to match more characters
                templateIndex = starIndex + 1;
                matchIndex++;
                searchIndex = matchIndex;
            } else return false; // No match
        }
        // Handle trailing '*' in template
        while(templateIndex < template.length && template[templateIndex] === '*')templateIndex++;
        return templateIndex === template.length;
    }
    /**
	* Disable debug output.
	*
	* @return {String} namespaces
	* @api public
	*/ function disable() {
        var namespaces = (0, _toConsumableArray._)(createDebug.names).concat((0, _toConsumableArray._)(createDebug.skips.map(function(namespace) {
            return '-' + namespace;
        }))).join(',');
        createDebug.enable('');
        return namespaces;
    }
    /**
	* Returns true if the given mode name is enabled, false otherwise.
	*
	* @param {String} name
	* @return {Boolean}
	* @api public
	*/ function enabled(name) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = createDebug.skips[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var skip = _step.value;
                if (matchesTemplate(name, skip)) return false;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = createDebug.names[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var ns = _step1.value;
                if (matchesTemplate(name, ns)) return true;
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        return false;
    }
    /**
	* Coerce `val`.
	*
	* @param {Mixed} val
	* @return {Mixed}
	* @api private
	*/ function coerce(val) {
        if (val instanceof Error) return val.stack || val.message;
        return val;
    }
    /**
	* XXX DO NOT USE. This is a temporary stub function.
	* XXX It WILL be removed in the next major release.
	*/ function destroy() {
        console.warn('Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.');
    }
    createDebug.enable(createDebug.load());
    return createDebug;
}
module.exports = setup;

},{"@swc/helpers/_/_to_consumable_array":"eqNDD","a57a5992a3072d81":"a5OQ9"}],"a5OQ9":[function(require,module,exports,__globalThis) {
/**
 * Helpers.
 */ var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var w = d * 7;
var y = d * 365.25;
/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */ module.exports = function(val, options) {
    options = options || {};
    var type = typeof val;
    if (type === 'string' && val.length > 0) return parse(val);
    else if (type === 'number' && isFinite(val)) return options.long ? fmtLong(val) : fmtShort(val);
    throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val));
};
/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */ function parse(str) {
    str = String(str);
    if (str.length > 100) return;
    var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(str);
    if (!match) return;
    var n = parseFloat(match[1]);
    var type = (match[2] || 'ms').toLowerCase();
    switch(type){
        case 'years':
        case 'year':
        case 'yrs':
        case 'yr':
        case 'y':
            return n * y;
        case 'weeks':
        case 'week':
        case 'w':
            return n * w;
        case 'days':
        case 'day':
        case 'd':
            return n * d;
        case 'hours':
        case 'hour':
        case 'hrs':
        case 'hr':
        case 'h':
            return n * h;
        case 'minutes':
        case 'minute':
        case 'mins':
        case 'min':
        case 'm':
            return n * m;
        case 'seconds':
        case 'second':
        case 'secs':
        case 'sec':
        case 's':
            return n * s;
        case 'milliseconds':
        case 'millisecond':
        case 'msecs':
        case 'msec':
        case 'ms':
            return n;
        default:
            return undefined;
    }
}
/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function fmtShort(ms) {
    var msAbs = Math.abs(ms);
    if (msAbs >= d) return Math.round(ms / d) + 'd';
    if (msAbs >= h) return Math.round(ms / h) + 'h';
    if (msAbs >= m) return Math.round(ms / m) + 'm';
    if (msAbs >= s) return Math.round(ms / s) + 's';
    return ms + 'ms';
}
/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function fmtLong(ms) {
    var msAbs = Math.abs(ms);
    if (msAbs >= d) return plural(ms, msAbs, d, 'day');
    if (msAbs >= h) return plural(ms, msAbs, h, 'hour');
    if (msAbs >= m) return plural(ms, msAbs, m, 'minute');
    if (msAbs >= s) return plural(ms, msAbs, s, 'second');
    return ms + ' ms';
}
/**
 * Pluralization helper.
 */ function plural(ms, msAbs, n, name) {
    var isPlural = msAbs >= n * 1.5;
    return Math.round(ms / n) + ' ' + name + (isPlural ? 's' : '');
}

},{}],"gvDzr":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _PlayerStates = require("ee14195859f97da8");
var _PlayerStates2 = _interopRequireDefault(_PlayerStates);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
exports.default = {
    pauseVideo: {
        acceptableStates: [
            _PlayerStates2.default.ENDED,
            _PlayerStates2.default.PAUSED
        ],
        stateChangeRequired: false
    },
    playVideo: {
        acceptableStates: [
            _PlayerStates2.default.ENDED,
            _PlayerStates2.default.PLAYING
        ],
        stateChangeRequired: false
    },
    seekTo: {
        acceptableStates: [
            _PlayerStates2.default.ENDED,
            _PlayerStates2.default.PLAYING,
            _PlayerStates2.default.PAUSED
        ],
        stateChangeRequired: true,
        // TRICKY: `seekTo` may not cause a state change if no buffering is
        // required.
        // eslint-disable-next-line unicorn/numeric-separators-style
        timeout: 3000
    }
};
module.exports = exports['default'];

},{"ee14195859f97da8":"6OLvC"}],"6OLvC":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    BUFFERING: 3,
    ENDED: 0,
    PAUSED: 2,
    PLAYING: 1,
    UNSTARTED: -1,
    VIDEO_CUED: 5
};
module.exports = exports["default"];

},{}],"azAev":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * @see https://developers.google.com/youtube/iframe_api_reference#Events
 * `volumeChange` is not officially supported but seems to work
 * it emits an object: `{volume: 82.6923076923077, muted: false}`
 */ exports.default = [
    'ready',
    'stateChange',
    'playbackQualityChange',
    'playbackRateChange',
    'error',
    'apiChange',
    'volumeChange'
];
module.exports = exports['default'];

},{}],"3KlV0":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * @see https://developers.google.com/youtube/iframe_api_reference#Functions
 */ exports.default = [
    'cueVideoById',
    'loadVideoById',
    'cueVideoByUrl',
    'loadVideoByUrl',
    'playVideo',
    'pauseVideo',
    'stopVideo',
    'getVideoLoadedFraction',
    'cuePlaylist',
    'loadPlaylist',
    'nextVideo',
    'previousVideo',
    'playVideoAt',
    'setShuffle',
    'setLoop',
    'getPlaylist',
    'getPlaylistIndex',
    'setOption',
    'mute',
    'unMute',
    'isMuted',
    'setVolume',
    'getVolume',
    'seekTo',
    'getPlayerState',
    'getPlaybackRate',
    'setPlaybackRate',
    'getAvailablePlaybackRates',
    'getPlaybackQuality',
    'setPlaybackQuality',
    'getAvailableQualityLevels',
    'getCurrentTime',
    'getDuration',
    'removeEventListener',
    'getVideoUrl',
    'getVideoEmbedCode',
    'getOptions',
    'getOption',
    'addEventListener',
    'destroy',
    'setSize',
    'getIframe',
    'getSphericalProperties',
    'setSphericalProperties'
];
module.exports = exports['default'];

},{}],"6zEzf":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _loadScript = require("38b3238846c649bc");
var _loadScript2 = _interopRequireDefault(_loadScript);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
exports.default = function(emitter) {
    /**
   * A promise that is resolved when window.onYouTubeIframeAPIReady is called.
   * The promise is resolved with a reference to window.YT object.
   */ var iframeAPIReady = new Promise(function(resolve) {
        if (window.YT && window.YT.Player && window.YT.Player instanceof Function) {
            resolve(window.YT);
            return;
        } else {
            var protocol = window.location.protocol === 'http:' ? 'http:' : 'https:';
            (0, _loadScript2.default)(protocol + '//www.youtube.com/iframe_api', function(error) {
                if (error) emitter.trigger('error', error);
            });
        }
        var previous = window.onYouTubeIframeAPIReady;
        // The API will call this function when page has finished downloading
        // the JavaScript for the player API.
        window.onYouTubeIframeAPIReady = function() {
            if (previous) previous();
            resolve(window.YT);
        };
    });
    return iframeAPIReady;
};
module.exports = exports['default'];

},{"38b3238846c649bc":"ehh3B"}],"ehh3B":[function(require,module,exports,__globalThis) {
module.exports = function load(src, opts, cb) {
    var head = document.head || document.getElementsByTagName('head')[0];
    var script = document.createElement('script');
    if (typeof opts === 'function') {
        cb = opts;
        opts = {};
    }
    opts = opts || {};
    cb = cb || function() {};
    script.type = opts.type || 'text/javascript';
    script.charset = opts.charset || 'utf8';
    script.async = 'async' in opts ? !!opts.async : true;
    script.src = src;
    if (opts.attrs) setAttributes(script, opts.attrs);
    if (opts.text) script.text = '' + opts.text;
    var onend = 'onload' in script ? stdOnEnd : ieOnEnd;
    onend(script, cb);
    // some good legacy browsers (firefox) fail the 'in' detection above
    // so as a fallback we always set onload
    // old IE will ignore this and new IE will set onload
    if (!script.onload) stdOnEnd(script, cb);
    head.appendChild(script);
};
function setAttributes(script, attrs) {
    for(var attr in attrs)script.setAttribute(attr, attrs[attr]);
}
function stdOnEnd(script, cb) {
    script.onload = function() {
        this.onerror = this.onload = null;
        cb(null, script);
    };
    script.onerror = function() {
        // this.onload = null here is necessary
        // because even IE9 works not like others
        this.onerror = this.onload = null;
        cb(new Error('Failed to load ' + this.src), script);
    };
}
function ieOnEnd(script, cb) {
    script.onreadystatechange = function() {
        if (this.readyState != 'complete' && this.readyState != 'loaded') return;
        this.onreadystatechange = null;
        cb(null, script) // there is no way to catch loading errors in IE8
        ;
    };
}

},{}],"c6sIC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Paragraphs", function() {
    return Paragraphs;
});
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _domArray = require("../../../script/src/dom/library/DomArray");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _domComponent = require("../../../script/src/dom/library/DomComponent");
var _domElement = require("../../../script/src/dom/library/DomElement");
var _tippyJs = require("tippy.js");
var _tippyJsDefault = parcelHelpers.interopDefault(_tippyJs);
var _std = require("@reglo/std");
function Paragraphs() {
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domArray.DomArray), {
        selector: ".blockParagraph",
        child: function(param) {
            var key = param.key, selector = param.selector;
            return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
                selector: selector,
                children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(Paragraph, {}, void 0, false, {
                    fileName: "src/snippets/blocks/paragraph/index.tsx",
                    lineNumber: 11,
                    columnNumber: 57
                }, void 0)
            }, key, false, {
                fileName: "src/snippets/blocks/paragraph/index.tsx",
                lineNumber: 11,
                columnNumber: 13
            }, void 0);
        }
    }, void 0, false, {
        fileName: "src/snippets/blocks/paragraph/index.tsx",
        lineNumber: 10,
        columnNumber: 9
    }, this);
}
function Paragraph() {
    var hasTooltip = !!(0, _domElement.useDomElement)('[data-id=tooltip]').element;
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _jsxDevRuntime.Fragment), {
        children: hasTooltip && /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(Tooltip, {}, void 0, false, {
            fileName: "src/snippets/blocks/paragraph/index.tsx",
            lineNumber: 21,
            columnNumber: 28
        }, this)
    }, void 0, false);
}
function Tooltip() {
    var target = (0, _std.unwrap)((0, _domElement.useDomElement)('[data-id=tooltip]').element);
    var content = (0, _std.unwrap)((0, _domElement.useDomElement)('[data-id=tooltipContent]').element);
    var a = false;
    (0, _react.useEffect)(function() {
        if (a) return;
        a = true;
        (0, _tippyJsDefault.default)(target, {
            content: content.innerHTML,
            allowHTML: true
        });
    }, []);
    return null;
}

},{"react/jsx-dev-runtime":"jXZ8I","../../../script/src/dom/library/DomArray":"ZEl1X","react":"c8CN1","../../../script/src/dom/library/DomComponent":"8H9za","../../../script/src/dom/library/DomElement":"15N7Q","tippy.js":"c2lyw","@reglo/std":"1USo0","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"c2lyw":[function(require,module,exports,__globalThis) {
/**!
* tippy.js v6.3.7
* (c) 2017-2021 atomiks
* MIT License
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "animateFill", function() {
    return animateFill;
});
parcelHelpers.export(exports, "createSingleton", function() {
    return createSingleton;
});
parcelHelpers.export(exports, "delegate", function() {
    return delegate;
});
parcelHelpers.export(exports, "followCursor", function() {
    return followCursor;
});
parcelHelpers.export(exports, "hideAll", function() {
    return hideAll;
});
parcelHelpers.export(exports, "inlinePositioning", function() {
    return inlinePositioning;
});
parcelHelpers.export(exports, "roundArrow", function() {
    return ROUND_ARROW;
});
parcelHelpers.export(exports, "sticky", function() {
    return sticky;
});
var _core = require("@popperjs/core");
var ROUND_ARROW = '<svg width="16" height="6" xmlns="http://www.w3.org/2000/svg"><path d="M0 6s1.796-.013 4.67-3.615C5.851.9 6.93.006 8 0c1.07-.006 2.148.887 3.343 2.385C14.233 6.005 16 6 16 6H0z"></svg>';
var BOX_CLASS = "tippy-box";
var CONTENT_CLASS = "tippy-content";
var BACKDROP_CLASS = "tippy-backdrop";
var ARROW_CLASS = "tippy-arrow";
var SVG_ARROW_CLASS = "tippy-svg-arrow";
var TOUCH_OPTIONS = {
    passive: true,
    capture: true
};
var TIPPY_DEFAULT_APPEND_TO = function TIPPY_DEFAULT_APPEND_TO() {
    return document.body;
};
function hasOwnProperty(obj, key) {
    return ({}).hasOwnProperty.call(obj, key);
}
function getValueAtIndexOrReturn(value, index, defaultValue) {
    if (Array.isArray(value)) {
        var v = value[index];
        return v == null ? Array.isArray(defaultValue) ? defaultValue[index] : defaultValue : v;
    }
    return value;
}
function isType(value, type) {
    var str = ({}).toString.call(value);
    return str.indexOf('[object') === 0 && str.indexOf(type + "]") > -1;
}
function invokeWithArgsOrReturn(value, args) {
    return typeof value === 'function' ? value.apply(void 0, args) : value;
}
function debounce(fn, ms) {
    // Avoid wrapping in `setTimeout` if ms is 0 anyway
    if (ms === 0) return fn;
    var timeout;
    return function(arg) {
        clearTimeout(timeout);
        timeout = setTimeout(function() {
            fn(arg);
        }, ms);
    };
}
function removeProperties(obj, keys) {
    var clone = Object.assign({}, obj);
    keys.forEach(function(key) {
        delete clone[key];
    });
    return clone;
}
function splitBySpaces(value) {
    return value.split(/\s+/).filter(Boolean);
}
function normalizeToArray(value) {
    return [].concat(value);
}
function pushIfUnique(arr, value) {
    if (arr.indexOf(value) === -1) arr.push(value);
}
function unique(arr) {
    return arr.filter(function(item, index) {
        return arr.indexOf(item) === index;
    });
}
function getBasePlacement(placement) {
    return placement.split('-')[0];
}
function arrayFrom(value) {
    return [].slice.call(value);
}
function removeUndefinedProps(obj) {
    return Object.keys(obj).reduce(function(acc, key) {
        if (obj[key] !== undefined) acc[key] = obj[key];
        return acc;
    }, {});
}
function div() {
    return document.createElement('div');
}
function isElement(value) {
    return [
        'Element',
        'Fragment'
    ].some(function(type) {
        return isType(value, type);
    });
}
function isNodeList(value) {
    return isType(value, 'NodeList');
}
function isMouseEvent(value) {
    return isType(value, 'MouseEvent');
}
function isReferenceElement(value) {
    return !!(value && value._tippy && value._tippy.reference === value);
}
function getArrayOfElements(value) {
    if (isElement(value)) return [
        value
    ];
    if (isNodeList(value)) return arrayFrom(value);
    if (Array.isArray(value)) return value;
    return arrayFrom(document.querySelectorAll(value));
}
function setTransitionDuration(els, value) {
    els.forEach(function(el) {
        if (el) el.style.transitionDuration = value + "ms";
    });
}
function setVisibilityState(els, state) {
    els.forEach(function(el) {
        if (el) el.setAttribute('data-state', state);
    });
}
function getOwnerDocument(elementOrElements) {
    var _element$ownerDocumen;
    var _normalizeToArray = normalizeToArray(elementOrElements), element = _normalizeToArray[0]; // Elements created via a <template> have an ownerDocument with no reference to the body
    return element != null && (_element$ownerDocumen = element.ownerDocument) != null && _element$ownerDocumen.body ? element.ownerDocument : document;
}
function isCursorOutsideInteractiveBorder(popperTreeData, event) {
    var clientX = event.clientX, clientY = event.clientY;
    return popperTreeData.every(function(_ref) {
        var popperRect = _ref.popperRect, popperState = _ref.popperState, props = _ref.props;
        var interactiveBorder = props.interactiveBorder;
        var basePlacement = getBasePlacement(popperState.placement);
        var offsetData = popperState.modifiersData.offset;
        if (!offsetData) return true;
        var topDistance = basePlacement === 'bottom' ? offsetData.top.y : 0;
        var bottomDistance = basePlacement === 'top' ? offsetData.bottom.y : 0;
        var leftDistance = basePlacement === 'right' ? offsetData.left.x : 0;
        var rightDistance = basePlacement === 'left' ? offsetData.right.x : 0;
        var exceedsTop = popperRect.top - clientY + topDistance > interactiveBorder;
        var exceedsBottom = clientY - popperRect.bottom - bottomDistance > interactiveBorder;
        var exceedsLeft = popperRect.left - clientX + leftDistance > interactiveBorder;
        var exceedsRight = clientX - popperRect.right - rightDistance > interactiveBorder;
        return exceedsTop || exceedsBottom || exceedsLeft || exceedsRight;
    });
}
function updateTransitionEndListener(box, action, listener) {
    var method = action + "EventListener"; // some browsers apparently support `transition` (unprefixed) but only fire
    // `webkitTransitionEnd`...
    [
        'transitionend',
        'webkitTransitionEnd'
    ].forEach(function(event) {
        box[method](event, listener);
    });
}
/**
 * Compared to xxx.contains, this function works for dom structures with shadow
 * dom
 */ function actualContains(parent, child) {
    var target = child;
    while(target){
        var _target$getRootNode;
        if (parent.contains(target)) return true;
        target = target.getRootNode == null ? void 0 : (_target$getRootNode = target.getRootNode()) == null ? void 0 : _target$getRootNode.host;
    }
    return false;
}
var currentInput = {
    isTouch: false
};
var lastMouseMoveTime = 0;
/**
 * When a `touchstart` event is fired, it's assumed the user is using touch
 * input. We'll bind a `mousemove` event listener to listen for mouse input in
 * the future. This way, the `isTouch` property is fully dynamic and will handle
 * hybrid devices that use a mix of touch + mouse input.
 */ function onDocumentTouchStart() {
    if (currentInput.isTouch) return;
    currentInput.isTouch = true;
    if (window.performance) document.addEventListener('mousemove', onDocumentMouseMove);
}
/**
 * When two `mousemove` event are fired consecutively within 20ms, it's assumed
 * the user is using mouse input again. `mousemove` can fire on touch devices as
 * well, but very rarely that quickly.
 */ function onDocumentMouseMove() {
    var now = performance.now();
    if (now - lastMouseMoveTime < 20) {
        currentInput.isTouch = false;
        document.removeEventListener('mousemove', onDocumentMouseMove);
    }
    lastMouseMoveTime = now;
}
/**
 * When an element is in focus and has a tippy, leaving the tab/window and
 * returning causes it to show again. For mouse users this is unexpected, but
 * for keyboard use it makes sense.
 * TODO: find a better technique to solve this problem
 */ function onWindowBlur() {
    var activeElement = document.activeElement;
    if (isReferenceElement(activeElement)) {
        var instance = activeElement._tippy;
        if (activeElement.blur && !instance.state.isVisible) activeElement.blur();
    }
}
function bindGlobalEventListeners() {
    document.addEventListener('touchstart', onDocumentTouchStart, TOUCH_OPTIONS);
    window.addEventListener('blur', onWindowBlur);
}
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
var isIE11 = isBrowser ? !!window.msCrypto : false;
function createMemoryLeakWarning(method) {
    var txt = method === 'destroy' ? 'n already-' : ' ';
    return [
        method + "() was called on a" + txt + "destroyed instance. This is a no-op but",
        'indicates a potential memory leak.'
    ].join(' ');
}
function clean(value) {
    var spacesAndTabs = /[ \t]{2,}/g;
    var lineStartWithSpaces = /^[ \t]*/gm;
    return value.replace(spacesAndTabs, ' ').replace(lineStartWithSpaces, '').trim();
}
function getDevMessage(message) {
    return clean("\n  %ctippy.js\n\n  %c" + clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development-only message. It will be removed in production.\n  ");
}
function getFormattedMessage(message) {
    return [
        getDevMessage(message),
        'color: #00C584; font-size: 1.3em; font-weight: bold;',
        'line-height: 1.5',
        'color: #a6a095;'
    ];
} // Assume warnings and errors never have the same message
var visitedMessages;
resetVisitedMessages();
function resetVisitedMessages() {
    visitedMessages = new Set();
}
function warnWhen(condition, message) {
    if (condition && !visitedMessages.has(message)) {
        var _console;
        visitedMessages.add(message);
        (_console = console).warn.apply(_console, getFormattedMessage(message));
    }
}
function errorWhen(condition, message) {
    if (condition && !visitedMessages.has(message)) {
        var _console2;
        visitedMessages.add(message);
        (_console2 = console).error.apply(_console2, getFormattedMessage(message));
    }
}
function validateTargets(targets) {
    var didPassFalsyValue = !targets;
    var didPassPlainObject = Object.prototype.toString.call(targets) === '[object Object]' && !targets.addEventListener;
    errorWhen(didPassFalsyValue, [
        'tippy() was passed',
        '`' + String(targets) + '`',
        'as its targets (first) argument. Valid types are: String, Element,',
        'Element[], or NodeList.'
    ].join(' '));
    errorWhen(didPassPlainObject, [
        'tippy() was passed a plain object which is not supported as an argument',
        'for virtual positioning. Use props.getReferenceClientRect instead.'
    ].join(' '));
}
var pluginProps = {
    animateFill: false,
    followCursor: false,
    inlinePositioning: false,
    sticky: false
};
var renderProps = {
    allowHTML: false,
    animation: 'fade',
    arrow: true,
    content: '',
    inertia: false,
    maxWidth: 350,
    role: 'tooltip',
    theme: '',
    zIndex: 9999
};
var defaultProps = Object.assign({
    appendTo: TIPPY_DEFAULT_APPEND_TO,
    aria: {
        content: 'auto',
        expanded: 'auto'
    },
    delay: 0,
    duration: [
        300,
        250
    ],
    getReferenceClientRect: null,
    hideOnClick: true,
    ignoreAttributes: false,
    interactive: false,
    interactiveBorder: 2,
    interactiveDebounce: 0,
    moveTransition: '',
    offset: [
        0,
        10
    ],
    onAfterUpdate: function onAfterUpdate() {},
    onBeforeUpdate: function onBeforeUpdate() {},
    onCreate: function onCreate() {},
    onDestroy: function onDestroy() {},
    onHidden: function onHidden() {},
    onHide: function onHide() {},
    onMount: function onMount() {},
    onShow: function onShow() {},
    onShown: function onShown() {},
    onTrigger: function onTrigger() {},
    onUntrigger: function onUntrigger() {},
    onClickOutside: function onClickOutside() {},
    placement: 'top',
    plugins: [],
    popperOptions: {},
    render: null,
    showOnCreate: false,
    touch: true,
    trigger: 'mouseenter focus',
    triggerTarget: null
}, pluginProps, renderProps);
var defaultKeys = Object.keys(defaultProps);
var setDefaultProps = function setDefaultProps(partialProps) {
    validateProps(partialProps, []);
    var keys = Object.keys(partialProps);
    keys.forEach(function(key) {
        defaultProps[key] = partialProps[key];
    });
};
function getExtendedPassedProps(passedProps) {
    var plugins = passedProps.plugins || [];
    var pluginProps = plugins.reduce(function(acc, plugin) {
        var name = plugin.name, defaultValue = plugin.defaultValue;
        if (name) {
            var _name;
            acc[name] = passedProps[name] !== undefined ? passedProps[name] : (_name = defaultProps[name]) != null ? _name : defaultValue;
        }
        return acc;
    }, {});
    return Object.assign({}, passedProps, pluginProps);
}
function getDataAttributeProps(reference, plugins) {
    var propKeys = plugins ? Object.keys(getExtendedPassedProps(Object.assign({}, defaultProps, {
        plugins: plugins
    }))) : defaultKeys;
    var props = propKeys.reduce(function(acc, key) {
        var valueAsString = (reference.getAttribute("data-tippy-" + key) || '').trim();
        if (!valueAsString) return acc;
        if (key === 'content') acc[key] = valueAsString;
        else try {
            acc[key] = JSON.parse(valueAsString);
        } catch (e) {
            acc[key] = valueAsString;
        }
        return acc;
    }, {});
    return props;
}
function evaluateProps(reference, props) {
    var out = Object.assign({}, props, {
        content: invokeWithArgsOrReturn(props.content, [
            reference
        ])
    }, props.ignoreAttributes ? {} : getDataAttributeProps(reference, props.plugins));
    out.aria = Object.assign({}, defaultProps.aria, out.aria);
    out.aria = {
        expanded: out.aria.expanded === 'auto' ? props.interactive : out.aria.expanded,
        content: out.aria.content === 'auto' ? props.interactive ? null : 'describedby' : out.aria.content
    };
    return out;
}
function validateProps(partialProps, plugins) {
    if (partialProps === void 0) partialProps = {};
    if (plugins === void 0) plugins = [];
    var keys = Object.keys(partialProps);
    keys.forEach(function(prop) {
        var nonPluginProps = removeProperties(defaultProps, Object.keys(pluginProps));
        var didPassUnknownProp = !hasOwnProperty(nonPluginProps, prop); // Check if the prop exists in `plugins`
        if (didPassUnknownProp) didPassUnknownProp = plugins.filter(function(plugin) {
            return plugin.name === prop;
        }).length === 0;
        warnWhen(didPassUnknownProp, [
            "`" + prop + "`",
            "is not a valid prop. You may have spelled it incorrectly, or if it's",
            'a plugin, forgot to pass it in an array as props.plugins.',
            '\n\n',
            'All props: https://atomiks.github.io/tippyjs/v6/all-props/\n',
            'Plugins: https://atomiks.github.io/tippyjs/v6/plugins/'
        ].join(' '));
    });
}
var innerHTML = function innerHTML() {
    return 'innerHTML';
};
function dangerouslySetInnerHTML(element, html) {
    element[innerHTML()] = html;
}
function createArrowElement(value) {
    var arrow = div();
    if (value === true) arrow.className = ARROW_CLASS;
    else {
        arrow.className = SVG_ARROW_CLASS;
        if (isElement(value)) arrow.appendChild(value);
        else dangerouslySetInnerHTML(arrow, value);
    }
    return arrow;
}
function setContent(content, props) {
    if (isElement(props.content)) {
        dangerouslySetInnerHTML(content, '');
        content.appendChild(props.content);
    } else if (typeof props.content !== 'function') {
        if (props.allowHTML) dangerouslySetInnerHTML(content, props.content);
        else content.textContent = props.content;
    }
}
function getChildren(popper) {
    var box = popper.firstElementChild;
    var boxChildren = arrayFrom(box.children);
    return {
        box: box,
        content: boxChildren.find(function(node) {
            return node.classList.contains(CONTENT_CLASS);
        }),
        arrow: boxChildren.find(function(node) {
            return node.classList.contains(ARROW_CLASS) || node.classList.contains(SVG_ARROW_CLASS);
        }),
        backdrop: boxChildren.find(function(node) {
            return node.classList.contains(BACKDROP_CLASS);
        })
    };
}
function render(instance) {
    var popper = div();
    var box = div();
    box.className = BOX_CLASS;
    box.setAttribute('data-state', 'hidden');
    box.setAttribute('tabindex', '-1');
    var content = div();
    content.className = CONTENT_CLASS;
    content.setAttribute('data-state', 'hidden');
    setContent(content, instance.props);
    popper.appendChild(box);
    box.appendChild(content);
    onUpdate(instance.props, instance.props);
    function onUpdate(prevProps, nextProps) {
        var _getChildren = getChildren(popper), box = _getChildren.box, content = _getChildren.content, arrow = _getChildren.arrow;
        if (nextProps.theme) box.setAttribute('data-theme', nextProps.theme);
        else box.removeAttribute('data-theme');
        if (typeof nextProps.animation === 'string') box.setAttribute('data-animation', nextProps.animation);
        else box.removeAttribute('data-animation');
        if (nextProps.inertia) box.setAttribute('data-inertia', '');
        else box.removeAttribute('data-inertia');
        box.style.maxWidth = typeof nextProps.maxWidth === 'number' ? nextProps.maxWidth + "px" : nextProps.maxWidth;
        if (nextProps.role) box.setAttribute('role', nextProps.role);
        else box.removeAttribute('role');
        if (prevProps.content !== nextProps.content || prevProps.allowHTML !== nextProps.allowHTML) setContent(content, instance.props);
        if (nextProps.arrow) {
            if (!arrow) box.appendChild(createArrowElement(nextProps.arrow));
            else if (prevProps.arrow !== nextProps.arrow) {
                box.removeChild(arrow);
                box.appendChild(createArrowElement(nextProps.arrow));
            }
        } else if (arrow) box.removeChild(arrow);
    }
    return {
        popper: popper,
        onUpdate: onUpdate
    };
} // Runtime check to identify if the render function is the default one; this
// way we can apply default CSS transitions logic and it can be tree-shaken away
render.$$tippy = true;
var idCounter = 1;
var mouseMoveListeners = []; // Used by `hideAll()`
var mountedInstances = [];
function createTippy(reference, passedProps) {
    var props = evaluateProps(reference, Object.assign({}, defaultProps, getExtendedPassedProps(removeUndefinedProps(passedProps)))); // ===========================================================================
    // 🔒 Private members
    // ===========================================================================
    var showTimeout;
    var hideTimeout;
    var scheduleHideAnimationFrame;
    var isVisibleFromClick = false;
    var didHideDueToDocumentMouseDown = false;
    var didTouchMove = false;
    var ignoreOnFirstUpdate = false;
    var lastTriggerEvent;
    var currentTransitionEndListener;
    var onFirstUpdate;
    var listeners = [];
    var debouncedOnMouseMove = debounce(onMouseMove, props.interactiveDebounce);
    var currentTarget; // ===========================================================================
    // 🔑 Public members
    // ===========================================================================
    var id = idCounter++;
    var popperInstance = null;
    var plugins = unique(props.plugins);
    var state = {
        // Is the instance currently enabled?
        isEnabled: true,
        // Is the tippy currently showing and not transitioning out?
        isVisible: false,
        // Has the instance been destroyed?
        isDestroyed: false,
        // Is the tippy currently mounted to the DOM?
        isMounted: false,
        // Has the tippy finished transitioning in?
        isShown: false
    };
    var instance = {
        // properties
        id: id,
        reference: reference,
        popper: div(),
        popperInstance: popperInstance,
        props: props,
        state: state,
        plugins: plugins,
        // methods
        clearDelayTimeouts: clearDelayTimeouts,
        setProps: setProps,
        setContent: setContent,
        show: show,
        hide: hide,
        hideWithInteractivity: hideWithInteractivity,
        enable: enable,
        disable: disable,
        unmount: unmount,
        destroy: destroy
    }; // TODO: Investigate why this early return causes a TDZ error in the tests —
    // it doesn't seem to happen in the browser
    /* istanbul ignore if */ if (!props.render) {
        errorWhen(true, 'render() function has not been supplied.');
        return instance;
    } // ===========================================================================
    // Initial mutations
    // ===========================================================================
    var _props$render = props.render(instance), popper = _props$render.popper, onUpdate = _props$render.onUpdate;
    popper.setAttribute('data-tippy-root', '');
    popper.id = "tippy-" + instance.id;
    instance.popper = popper;
    reference._tippy = instance;
    popper._tippy = instance;
    var pluginsHooks = plugins.map(function(plugin) {
        return plugin.fn(instance);
    });
    var hasAriaExpanded = reference.hasAttribute('aria-expanded');
    addListeners();
    handleAriaExpandedAttribute();
    handleStyles();
    invokeHook('onCreate', [
        instance
    ]);
    if (props.showOnCreate) scheduleShow();
     // Prevent a tippy with a delay from hiding if the cursor left then returned
    // before it started hiding
    popper.addEventListener('mouseenter', function() {
        if (instance.props.interactive && instance.state.isVisible) instance.clearDelayTimeouts();
    });
    popper.addEventListener('mouseleave', function() {
        if (instance.props.interactive && instance.props.trigger.indexOf('mouseenter') >= 0) getDocument().addEventListener('mousemove', debouncedOnMouseMove);
    });
    return instance; // ===========================================================================
    // 🔒 Private methods
    // ===========================================================================
    function getNormalizedTouchSettings() {
        var touch = instance.props.touch;
        return Array.isArray(touch) ? touch : [
            touch,
            0
        ];
    }
    function getIsCustomTouchBehavior() {
        return getNormalizedTouchSettings()[0] === 'hold';
    }
    function getIsDefaultRenderFn() {
        var _instance$props$rende;
        // @ts-ignore
        return !!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy);
    }
    function getCurrentTarget() {
        return currentTarget || reference;
    }
    function getDocument() {
        var parent = getCurrentTarget().parentNode;
        return parent ? getOwnerDocument(parent) : document;
    }
    function getDefaultTemplateChildren() {
        return getChildren(popper);
    }
    function getDelay(isShow) {
        // For touch or keyboard input, force `0` delay for UX reasons
        // Also if the instance is mounted but not visible (transitioning out),
        // ignore delay
        if (instance.state.isMounted && !instance.state.isVisible || currentInput.isTouch || lastTriggerEvent && lastTriggerEvent.type === 'focus') return 0;
        return getValueAtIndexOrReturn(instance.props.delay, isShow ? 0 : 1, defaultProps.delay);
    }
    function handleStyles(fromHide) {
        if (fromHide === void 0) fromHide = false;
        popper.style.pointerEvents = instance.props.interactive && !fromHide ? '' : 'none';
        popper.style.zIndex = "" + instance.props.zIndex;
    }
    function invokeHook(hook, args, shouldInvokePropsHook) {
        if (shouldInvokePropsHook === void 0) shouldInvokePropsHook = true;
        pluginsHooks.forEach(function(pluginHooks) {
            if (pluginHooks[hook]) pluginHooks[hook].apply(pluginHooks, args);
        });
        if (shouldInvokePropsHook) {
            var _instance$props;
            (_instance$props = instance.props)[hook].apply(_instance$props, args);
        }
    }
    function handleAriaContentAttribute() {
        var aria = instance.props.aria;
        if (!aria.content) return;
        var attr = "aria-" + aria.content;
        var id = popper.id;
        var nodes = normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            var currentValue = node.getAttribute(attr);
            if (instance.state.isVisible) node.setAttribute(attr, currentValue ? currentValue + " " + id : id);
            else {
                var nextValue = currentValue && currentValue.replace(id, '').trim();
                if (nextValue) node.setAttribute(attr, nextValue);
                else node.removeAttribute(attr);
            }
        });
    }
    function handleAriaExpandedAttribute() {
        if (hasAriaExpanded || !instance.props.aria.expanded) return;
        var nodes = normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            if (instance.props.interactive) node.setAttribute('aria-expanded', instance.state.isVisible && node === getCurrentTarget() ? 'true' : 'false');
            else node.removeAttribute('aria-expanded');
        });
    }
    function cleanupInteractiveMouseListeners() {
        getDocument().removeEventListener('mousemove', debouncedOnMouseMove);
        mouseMoveListeners = mouseMoveListeners.filter(function(listener) {
            return listener !== debouncedOnMouseMove;
        });
    }
    function onDocumentPress(event) {
        // Moved finger to scroll instead of an intentional tap outside
        if (currentInput.isTouch) {
            if (didTouchMove || event.type === 'mousedown') return;
        }
        var actualTarget = event.composedPath && event.composedPath()[0] || event.target; // Clicked on interactive popper
        if (instance.props.interactive && actualContains(popper, actualTarget)) return;
         // Clicked on the event listeners target
        if (normalizeToArray(instance.props.triggerTarget || reference).some(function(el) {
            return actualContains(el, actualTarget);
        })) {
            if (currentInput.isTouch) return;
            if (instance.state.isVisible && instance.props.trigger.indexOf('click') >= 0) return;
        } else invokeHook('onClickOutside', [
            instance,
            event
        ]);
        if (instance.props.hideOnClick === true) {
            instance.clearDelayTimeouts();
            instance.hide(); // `mousedown` event is fired right before `focus` if pressing the
            // currentTarget. This lets a tippy with `focus` trigger know that it
            // should not show
            didHideDueToDocumentMouseDown = true;
            setTimeout(function() {
                didHideDueToDocumentMouseDown = false;
            }); // The listener gets added in `scheduleShow()`, but this may be hiding it
            // before it shows, and hide()'s early bail-out behavior can prevent it
            // from being cleaned up
            if (!instance.state.isMounted) removeDocumentPress();
        }
    }
    function onTouchMove() {
        didTouchMove = true;
    }
    function onTouchStart() {
        didTouchMove = false;
    }
    function addDocumentPress() {
        var doc = getDocument();
        doc.addEventListener('mousedown', onDocumentPress, true);
        doc.addEventListener('touchend', onDocumentPress, TOUCH_OPTIONS);
        doc.addEventListener('touchstart', onTouchStart, TOUCH_OPTIONS);
        doc.addEventListener('touchmove', onTouchMove, TOUCH_OPTIONS);
    }
    function removeDocumentPress() {
        var doc = getDocument();
        doc.removeEventListener('mousedown', onDocumentPress, true);
        doc.removeEventListener('touchend', onDocumentPress, TOUCH_OPTIONS);
        doc.removeEventListener('touchstart', onTouchStart, TOUCH_OPTIONS);
        doc.removeEventListener('touchmove', onTouchMove, TOUCH_OPTIONS);
    }
    function onTransitionedOut(duration, callback) {
        onTransitionEnd(duration, function() {
            if (!instance.state.isVisible && popper.parentNode && popper.parentNode.contains(popper)) callback();
        });
    }
    function onTransitionedIn(duration, callback) {
        onTransitionEnd(duration, callback);
    }
    function onTransitionEnd(duration, callback) {
        var box = getDefaultTemplateChildren().box;
        function listener(event) {
            if (event.target === box) {
                updateTransitionEndListener(box, 'remove', listener);
                callback();
            }
        } // Make callback synchronous if duration is 0
        // `transitionend` won't fire otherwise
        if (duration === 0) return callback();
        updateTransitionEndListener(box, 'remove', currentTransitionEndListener);
        updateTransitionEndListener(box, 'add', listener);
        currentTransitionEndListener = listener;
    }
    function on(eventType, handler, options) {
        if (options === void 0) options = false;
        var nodes = normalizeToArray(instance.props.triggerTarget || reference);
        nodes.forEach(function(node) {
            node.addEventListener(eventType, handler, options);
            listeners.push({
                node: node,
                eventType: eventType,
                handler: handler,
                options: options
            });
        });
    }
    function addListeners() {
        if (getIsCustomTouchBehavior()) {
            on('touchstart', onTrigger, {
                passive: true
            });
            on('touchend', onMouseLeave, {
                passive: true
            });
        }
        splitBySpaces(instance.props.trigger).forEach(function(eventType) {
            if (eventType === 'manual') return;
            on(eventType, onTrigger);
            switch(eventType){
                case 'mouseenter':
                    on('mouseleave', onMouseLeave);
                    break;
                case 'focus':
                    on(isIE11 ? 'focusout' : 'blur', onBlurOrFocusOut);
                    break;
                case 'focusin':
                    on('focusout', onBlurOrFocusOut);
                    break;
            }
        });
    }
    function removeListeners() {
        listeners.forEach(function(_ref) {
            var node = _ref.node, eventType = _ref.eventType, handler = _ref.handler, options = _ref.options;
            node.removeEventListener(eventType, handler, options);
        });
        listeners = [];
    }
    function onTrigger(event) {
        var _lastTriggerEvent;
        var shouldScheduleClickHide = false;
        if (!instance.state.isEnabled || isEventListenerStopped(event) || didHideDueToDocumentMouseDown) return;
        var wasFocused = ((_lastTriggerEvent = lastTriggerEvent) == null ? void 0 : _lastTriggerEvent.type) === 'focus';
        lastTriggerEvent = event;
        currentTarget = event.currentTarget;
        handleAriaExpandedAttribute();
        if (!instance.state.isVisible && isMouseEvent(event)) // If scrolling, `mouseenter` events can be fired if the cursor lands
        // over a new target, but `mousemove` events don't get fired. This
        // causes interactive tooltips to get stuck open until the cursor is
        // moved
        mouseMoveListeners.forEach(function(listener) {
            return listener(event);
        });
         // Toggle show/hide when clicking click-triggered tooltips
        if (event.type === 'click' && (instance.props.trigger.indexOf('mouseenter') < 0 || isVisibleFromClick) && instance.props.hideOnClick !== false && instance.state.isVisible) shouldScheduleClickHide = true;
        else scheduleShow(event);
        if (event.type === 'click') isVisibleFromClick = !shouldScheduleClickHide;
        if (shouldScheduleClickHide && !wasFocused) scheduleHide(event);
    }
    function onMouseMove(event) {
        var target = event.target;
        var isCursorOverReferenceOrPopper = getCurrentTarget().contains(target) || popper.contains(target);
        if (event.type === 'mousemove' && isCursorOverReferenceOrPopper) return;
        var popperTreeData = getNestedPopperTree().concat(popper).map(function(popper) {
            var _instance$popperInsta;
            var instance = popper._tippy;
            var state = (_instance$popperInsta = instance.popperInstance) == null ? void 0 : _instance$popperInsta.state;
            if (state) return {
                popperRect: popper.getBoundingClientRect(),
                popperState: state,
                props: props
            };
            return null;
        }).filter(Boolean);
        if (isCursorOutsideInteractiveBorder(popperTreeData, event)) {
            cleanupInteractiveMouseListeners();
            scheduleHide(event);
        }
    }
    function onMouseLeave(event) {
        var shouldBail = isEventListenerStopped(event) || instance.props.trigger.indexOf('click') >= 0 && isVisibleFromClick;
        if (shouldBail) return;
        if (instance.props.interactive) {
            instance.hideWithInteractivity(event);
            return;
        }
        scheduleHide(event);
    }
    function onBlurOrFocusOut(event) {
        if (instance.props.trigger.indexOf('focusin') < 0 && event.target !== getCurrentTarget()) return;
         // If focus was moved to within the popper
        if (instance.props.interactive && event.relatedTarget && popper.contains(event.relatedTarget)) return;
        scheduleHide(event);
    }
    function isEventListenerStopped(event) {
        return currentInput.isTouch ? getIsCustomTouchBehavior() !== event.type.indexOf('touch') >= 0 : false;
    }
    function createPopperInstance() {
        destroyPopperInstance();
        var _instance$props2 = instance.props, popperOptions = _instance$props2.popperOptions, placement = _instance$props2.placement, offset = _instance$props2.offset, getReferenceClientRect = _instance$props2.getReferenceClientRect, moveTransition = _instance$props2.moveTransition;
        var arrow = getIsDefaultRenderFn() ? getChildren(popper).arrow : null;
        var computedReference = getReferenceClientRect ? {
            getBoundingClientRect: getReferenceClientRect,
            contextElement: getReferenceClientRect.contextElement || getCurrentTarget()
        } : reference;
        var tippyModifier = {
            name: '$$tippy',
            enabled: true,
            phase: 'beforeWrite',
            requires: [
                'computeStyles'
            ],
            fn: function fn(_ref2) {
                var state = _ref2.state;
                if (getIsDefaultRenderFn()) {
                    var _getDefaultTemplateCh = getDefaultTemplateChildren(), box = _getDefaultTemplateCh.box;
                    [
                        'placement',
                        'reference-hidden',
                        'escaped'
                    ].forEach(function(attr) {
                        if (attr === 'placement') box.setAttribute('data-placement', state.placement);
                        else if (state.attributes.popper["data-popper-" + attr]) box.setAttribute("data-" + attr, '');
                        else box.removeAttribute("data-" + attr);
                    });
                    state.attributes.popper = {};
                }
            }
        };
        var modifiers = [
            {
                name: 'offset',
                options: {
                    offset: offset
                }
            },
            {
                name: 'preventOverflow',
                options: {
                    padding: {
                        top: 2,
                        bottom: 2,
                        left: 5,
                        right: 5
                    }
                }
            },
            {
                name: 'flip',
                options: {
                    padding: 5
                }
            },
            {
                name: 'computeStyles',
                options: {
                    adaptive: !moveTransition
                }
            },
            tippyModifier
        ];
        if (getIsDefaultRenderFn() && arrow) modifiers.push({
            name: 'arrow',
            options: {
                element: arrow,
                padding: 3
            }
        });
        modifiers.push.apply(modifiers, (popperOptions == null ? void 0 : popperOptions.modifiers) || []);
        instance.popperInstance = (0, _core.createPopper)(computedReference, popper, Object.assign({}, popperOptions, {
            placement: placement,
            onFirstUpdate: onFirstUpdate,
            modifiers: modifiers
        }));
    }
    function destroyPopperInstance() {
        if (instance.popperInstance) {
            instance.popperInstance.destroy();
            instance.popperInstance = null;
        }
    }
    function mount() {
        var appendTo = instance.props.appendTo;
        var parentNode; // By default, we'll append the popper to the triggerTargets's parentNode so
        // it's directly after the reference element so the elements inside the
        // tippy can be tabbed to
        // If there are clipping issues, the user can specify a different appendTo
        // and ensure focus management is handled correctly manually
        var node = getCurrentTarget();
        if (instance.props.interactive && appendTo === TIPPY_DEFAULT_APPEND_TO || appendTo === 'parent') parentNode = node.parentNode;
        else parentNode = invokeWithArgsOrReturn(appendTo, [
            node
        ]);
         // The popper element needs to exist on the DOM before its position can be
        // updated as Popper needs to read its dimensions
        if (!parentNode.contains(popper)) parentNode.appendChild(popper);
        instance.state.isMounted = true;
        createPopperInstance();
        // Accessibility check
        warnWhen(instance.props.interactive && appendTo === defaultProps.appendTo && node.nextElementSibling !== popper, [
            'Interactive tippy element may not be accessible via keyboard',
            'navigation because it is not directly after the reference element',
            'in the DOM source order.',
            '\n\n',
            'Using a wrapper <div> or <span> tag around the reference element',
            'solves this by creating a new parentNode context.',
            '\n\n',
            'Specifying `appendTo: document.body` silences this warning, but it',
            'assumes you are using a focus management solution to handle',
            'keyboard navigation.',
            '\n\n',
            'See: https://atomiks.github.io/tippyjs/v6/accessibility/#interactivity'
        ].join(' '));
    }
    function getNestedPopperTree() {
        return arrayFrom(popper.querySelectorAll('[data-tippy-root]'));
    }
    function scheduleShow(event) {
        instance.clearDelayTimeouts();
        if (event) invokeHook('onTrigger', [
            instance,
            event
        ]);
        addDocumentPress();
        var delay = getDelay(true);
        var _getNormalizedTouchSe = getNormalizedTouchSettings(), touchValue = _getNormalizedTouchSe[0], touchDelay = _getNormalizedTouchSe[1];
        if (currentInput.isTouch && touchValue === 'hold' && touchDelay) delay = touchDelay;
        if (delay) showTimeout = setTimeout(function() {
            instance.show();
        }, delay);
        else instance.show();
    }
    function scheduleHide(event) {
        instance.clearDelayTimeouts();
        invokeHook('onUntrigger', [
            instance,
            event
        ]);
        if (!instance.state.isVisible) {
            removeDocumentPress();
            return;
        } // For interactive tippies, scheduleHide is added to a document.body handler
        // from onMouseLeave so must intercept scheduled hides from mousemove/leave
        // events when trigger contains mouseenter and click, and the tip is
        // currently shown as a result of a click.
        if (instance.props.trigger.indexOf('mouseenter') >= 0 && instance.props.trigger.indexOf('click') >= 0 && [
            'mouseleave',
            'mousemove'
        ].indexOf(event.type) >= 0 && isVisibleFromClick) return;
        var delay = getDelay(false);
        if (delay) hideTimeout = setTimeout(function() {
            if (instance.state.isVisible) instance.hide();
        }, delay);
        else // Fixes a `transitionend` problem when it fires 1 frame too
        // late sometimes, we don't want hide() to be called.
        scheduleHideAnimationFrame = requestAnimationFrame(function() {
            instance.hide();
        });
    } // ===========================================================================
    // 🔑 Public methods
    // ===========================================================================
    function enable() {
        instance.state.isEnabled = true;
    }
    function disable() {
        // Disabling the instance should also hide it
        // https://github.com/atomiks/tippy.js-react/issues/106
        instance.hide();
        instance.state.isEnabled = false;
    }
    function clearDelayTimeouts() {
        clearTimeout(showTimeout);
        clearTimeout(hideTimeout);
        cancelAnimationFrame(scheduleHideAnimationFrame);
    }
    function setProps(partialProps) {
        warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('setProps'));
        if (instance.state.isDestroyed) return;
        invokeHook('onBeforeUpdate', [
            instance,
            partialProps
        ]);
        removeListeners();
        var prevProps = instance.props;
        var nextProps = evaluateProps(reference, Object.assign({}, prevProps, removeUndefinedProps(partialProps), {
            ignoreAttributes: true
        }));
        instance.props = nextProps;
        addListeners();
        if (prevProps.interactiveDebounce !== nextProps.interactiveDebounce) {
            cleanupInteractiveMouseListeners();
            debouncedOnMouseMove = debounce(onMouseMove, nextProps.interactiveDebounce);
        } // Ensure stale aria-expanded attributes are removed
        if (prevProps.triggerTarget && !nextProps.triggerTarget) normalizeToArray(prevProps.triggerTarget).forEach(function(node) {
            node.removeAttribute('aria-expanded');
        });
        else if (nextProps.triggerTarget) reference.removeAttribute('aria-expanded');
        handleAriaExpandedAttribute();
        handleStyles();
        if (onUpdate) onUpdate(prevProps, nextProps);
        if (instance.popperInstance) {
            createPopperInstance(); // Fixes an issue with nested tippies if they are all getting re-rendered,
            // and the nested ones get re-rendered first.
            // https://github.com/atomiks/tippyjs-react/issues/177
            // TODO: find a cleaner / more efficient solution(!)
            getNestedPopperTree().forEach(function(nestedPopper) {
                // React (and other UI libs likely) requires a rAF wrapper as it flushes
                // its work in one
                requestAnimationFrame(nestedPopper._tippy.popperInstance.forceUpdate);
            });
        }
        invokeHook('onAfterUpdate', [
            instance,
            partialProps
        ]);
    }
    function setContent(content) {
        instance.setProps({
            content: content
        });
    }
    function show() {
        warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('show'));
        var isAlreadyVisible = instance.state.isVisible;
        var isDestroyed = instance.state.isDestroyed;
        var isDisabled = !instance.state.isEnabled;
        var isTouchAndTouchDisabled = currentInput.isTouch && !instance.props.touch;
        var duration = getValueAtIndexOrReturn(instance.props.duration, 0, defaultProps.duration);
        if (isAlreadyVisible || isDestroyed || isDisabled || isTouchAndTouchDisabled) return;
         // Normalize `disabled` behavior across browsers.
        // Firefox allows events on disabled elements, but Chrome doesn't.
        // Using a wrapper element (i.e. <span>) is recommended.
        if (getCurrentTarget().hasAttribute('disabled')) return;
        invokeHook('onShow', [
            instance
        ], false);
        if (instance.props.onShow(instance) === false) return;
        instance.state.isVisible = true;
        if (getIsDefaultRenderFn()) popper.style.visibility = 'visible';
        handleStyles();
        addDocumentPress();
        if (!instance.state.isMounted) popper.style.transition = 'none';
         // If flipping to the opposite side after hiding at least once, the
        // animation will use the wrong placement without resetting the duration
        if (getIsDefaultRenderFn()) {
            var _getDefaultTemplateCh2 = getDefaultTemplateChildren(), box = _getDefaultTemplateCh2.box, content = _getDefaultTemplateCh2.content;
            setTransitionDuration([
                box,
                content
            ], 0);
        }
        onFirstUpdate = function onFirstUpdate() {
            var _instance$popperInsta2;
            if (!instance.state.isVisible || ignoreOnFirstUpdate) return;
            ignoreOnFirstUpdate = true; // reflow
            popper.offsetHeight;
            popper.style.transition = instance.props.moveTransition;
            if (getIsDefaultRenderFn() && instance.props.animation) {
                var _getDefaultTemplateCh3 = getDefaultTemplateChildren(), _box = _getDefaultTemplateCh3.box, _content = _getDefaultTemplateCh3.content;
                setTransitionDuration([
                    _box,
                    _content
                ], duration);
                setVisibilityState([
                    _box,
                    _content
                ], 'visible');
            }
            handleAriaContentAttribute();
            handleAriaExpandedAttribute();
            pushIfUnique(mountedInstances, instance); // certain modifiers (e.g. `maxSize`) require a second update after the
            // popper has been positioned for the first time
            (_instance$popperInsta2 = instance.popperInstance) == null || _instance$popperInsta2.forceUpdate();
            invokeHook('onMount', [
                instance
            ]);
            if (instance.props.animation && getIsDefaultRenderFn()) onTransitionedIn(duration, function() {
                instance.state.isShown = true;
                invokeHook('onShown', [
                    instance
                ]);
            });
        };
        mount();
    }
    function hide() {
        warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('hide'));
        var isAlreadyHidden = !instance.state.isVisible;
        var isDestroyed = instance.state.isDestroyed;
        var isDisabled = !instance.state.isEnabled;
        var duration = getValueAtIndexOrReturn(instance.props.duration, 1, defaultProps.duration);
        if (isAlreadyHidden || isDestroyed || isDisabled) return;
        invokeHook('onHide', [
            instance
        ], false);
        if (instance.props.onHide(instance) === false) return;
        instance.state.isVisible = false;
        instance.state.isShown = false;
        ignoreOnFirstUpdate = false;
        isVisibleFromClick = false;
        if (getIsDefaultRenderFn()) popper.style.visibility = 'hidden';
        cleanupInteractiveMouseListeners();
        removeDocumentPress();
        handleStyles(true);
        if (getIsDefaultRenderFn()) {
            var _getDefaultTemplateCh4 = getDefaultTemplateChildren(), box = _getDefaultTemplateCh4.box, content = _getDefaultTemplateCh4.content;
            if (instance.props.animation) {
                setTransitionDuration([
                    box,
                    content
                ], duration);
                setVisibilityState([
                    box,
                    content
                ], 'hidden');
            }
        }
        handleAriaContentAttribute();
        handleAriaExpandedAttribute();
        if (instance.props.animation) {
            if (getIsDefaultRenderFn()) onTransitionedOut(duration, instance.unmount);
        } else instance.unmount();
    }
    function hideWithInteractivity(event) {
        warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('hideWithInteractivity'));
        getDocument().addEventListener('mousemove', debouncedOnMouseMove);
        pushIfUnique(mouseMoveListeners, debouncedOnMouseMove);
        debouncedOnMouseMove(event);
    }
    function unmount() {
        warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('unmount'));
        if (instance.state.isVisible) instance.hide();
        if (!instance.state.isMounted) return;
        destroyPopperInstance(); // If a popper is not interactive, it will be appended outside the popper
        // tree by default. This seems mainly for interactive tippies, but we should
        // find a workaround if possible
        getNestedPopperTree().forEach(function(nestedPopper) {
            nestedPopper._tippy.unmount();
        });
        if (popper.parentNode) popper.parentNode.removeChild(popper);
        mountedInstances = mountedInstances.filter(function(i) {
            return i !== instance;
        });
        instance.state.isMounted = false;
        invokeHook('onHidden', [
            instance
        ]);
    }
    function destroy() {
        warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('destroy'));
        if (instance.state.isDestroyed) return;
        instance.clearDelayTimeouts();
        instance.unmount();
        removeListeners();
        delete reference._tippy;
        instance.state.isDestroyed = true;
        invokeHook('onDestroy', [
            instance
        ]);
    }
}
function tippy(targets, optionalProps) {
    if (optionalProps === void 0) optionalProps = {};
    var plugins = defaultProps.plugins.concat(optionalProps.plugins || []);
    validateTargets(targets);
    validateProps(optionalProps, plugins);
    bindGlobalEventListeners();
    var passedProps = Object.assign({}, optionalProps, {
        plugins: plugins
    });
    var elements = getArrayOfElements(targets);
    var isSingleContentElement = isElement(passedProps.content);
    var isMoreThanOneReferenceElement = elements.length > 1;
    warnWhen(isSingleContentElement && isMoreThanOneReferenceElement, [
        'tippy() was passed an Element as the `content` prop, but more than',
        'one tippy instance was created by this invocation. This means the',
        'content element will only be appended to the last tippy instance.',
        '\n\n',
        'Instead, pass the .innerHTML of the element, or use a function that',
        'returns a cloned version of the element instead.',
        '\n\n',
        '1) content: element.innerHTML\n',
        '2) content: () => element.cloneNode(true)'
    ].join(' '));
    var instances = elements.reduce(function(acc, reference) {
        var instance = reference && createTippy(reference, passedProps);
        if (instance) acc.push(instance);
        return acc;
    }, []);
    return isElement(targets) ? instances[0] : instances;
}
tippy.defaultProps = defaultProps;
tippy.setDefaultProps = setDefaultProps;
tippy.currentInput = currentInput;
var hideAll = function hideAll(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, excludedReferenceOrInstance = _ref.exclude, duration = _ref.duration;
    mountedInstances.forEach(function(instance) {
        var isExcluded = false;
        if (excludedReferenceOrInstance) isExcluded = isReferenceElement(excludedReferenceOrInstance) ? instance.reference === excludedReferenceOrInstance : instance.popper === excludedReferenceOrInstance.popper;
        if (!isExcluded) {
            var originalDuration = instance.props.duration;
            instance.setProps({
                duration: duration
            });
            instance.hide();
            if (!instance.state.isDestroyed) instance.setProps({
                duration: originalDuration
            });
        }
    });
};
// every time the popper is destroyed (i.e. a new target), removing the styles
// and causing transitions to break for singletons when the console is open, but
// most notably for non-transform styles being used, `gpuAcceleration: false`.
var applyStylesModifier = Object.assign({}, (0, _core.applyStyles), {
    effect: function effect(_ref) {
        var state = _ref.state;
        var initialStyles = {
            popper: {
                position: state.options.strategy,
                left: '0',
                top: '0',
                margin: '0'
            },
            arrow: {
                position: 'absolute'
            },
            reference: {}
        };
        Object.assign(state.elements.popper.style, initialStyles.popper);
        state.styles = initialStyles;
        if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
         // intentionally return no cleanup function
    // return () => { ... }
    }
});
var createSingleton = function createSingleton(tippyInstances, optionalProps) {
    var _optionalProps$popper;
    if (optionalProps === void 0) optionalProps = {};
    errorWhen(!Array.isArray(tippyInstances), [
        'The first argument passed to createSingleton() must be an array of',
        'tippy instances. The passed value was',
        String(tippyInstances)
    ].join(' '));
    var individualInstances = tippyInstances;
    var references = [];
    var triggerTargets = [];
    var currentTarget;
    var overrides = optionalProps.overrides;
    var interceptSetPropsCleanups = [];
    var shownOnCreate = false;
    function setTriggerTargets() {
        triggerTargets = individualInstances.map(function(instance) {
            return normalizeToArray(instance.props.triggerTarget || instance.reference);
        }).reduce(function(acc, item) {
            return acc.concat(item);
        }, []);
    }
    function setReferences() {
        references = individualInstances.map(function(instance) {
            return instance.reference;
        });
    }
    function enableInstances(isEnabled) {
        individualInstances.forEach(function(instance) {
            if (isEnabled) instance.enable();
            else instance.disable();
        });
    }
    function interceptSetProps(singleton) {
        return individualInstances.map(function(instance) {
            var originalSetProps = instance.setProps;
            instance.setProps = function(props) {
                originalSetProps(props);
                if (instance.reference === currentTarget) singleton.setProps(props);
            };
            return function() {
                instance.setProps = originalSetProps;
            };
        });
    } // have to pass singleton, as it maybe undefined on first call
    function prepareInstance(singleton, target) {
        var index = triggerTargets.indexOf(target); // bail-out
        if (target === currentTarget) return;
        currentTarget = target;
        var overrideProps = (overrides || []).concat('content').reduce(function(acc, prop) {
            acc[prop] = individualInstances[index].props[prop];
            return acc;
        }, {});
        singleton.setProps(Object.assign({}, overrideProps, {
            getReferenceClientRect: typeof overrideProps.getReferenceClientRect === 'function' ? overrideProps.getReferenceClientRect : function() {
                var _references$index;
                return (_references$index = references[index]) == null ? void 0 : _references$index.getBoundingClientRect();
            }
        }));
    }
    enableInstances(false);
    setReferences();
    setTriggerTargets();
    var plugin = {
        fn: function fn() {
            return {
                onDestroy: function onDestroy() {
                    enableInstances(true);
                },
                onHidden: function onHidden() {
                    currentTarget = null;
                },
                onClickOutside: function onClickOutside(instance) {
                    if (instance.props.showOnCreate && !shownOnCreate) {
                        shownOnCreate = true;
                        currentTarget = null;
                    }
                },
                onShow: function onShow(instance) {
                    if (instance.props.showOnCreate && !shownOnCreate) {
                        shownOnCreate = true;
                        prepareInstance(instance, references[0]);
                    }
                },
                onTrigger: function onTrigger(instance, event) {
                    prepareInstance(instance, event.currentTarget);
                }
            };
        }
    };
    var singleton = tippy(div(), Object.assign({}, removeProperties(optionalProps, [
        'overrides'
    ]), {
        plugins: [
            plugin
        ].concat(optionalProps.plugins || []),
        triggerTarget: triggerTargets,
        popperOptions: Object.assign({}, optionalProps.popperOptions, {
            modifiers: [].concat(((_optionalProps$popper = optionalProps.popperOptions) == null ? void 0 : _optionalProps$popper.modifiers) || [], [
                applyStylesModifier
            ])
        })
    }));
    var originalShow = singleton.show;
    singleton.show = function(target) {
        originalShow(); // first time, showOnCreate or programmatic call with no params
        // default to showing first instance
        if (!currentTarget && target == null) return prepareInstance(singleton, references[0]);
         // triggered from event (do nothing as prepareInstance already called by onTrigger)
        // programmatic call with no params when already visible (do nothing again)
        if (currentTarget && target == null) return;
         // target is index of instance
        if (typeof target === 'number') return references[target] && prepareInstance(singleton, references[target]);
         // target is a child tippy instance
        if (individualInstances.indexOf(target) >= 0) {
            var ref = target.reference;
            return prepareInstance(singleton, ref);
        } // target is a ReferenceElement
        if (references.indexOf(target) >= 0) return prepareInstance(singleton, target);
    };
    singleton.showNext = function() {
        var first = references[0];
        if (!currentTarget) return singleton.show(0);
        var index = references.indexOf(currentTarget);
        singleton.show(references[index + 1] || first);
    };
    singleton.showPrevious = function() {
        var last = references[references.length - 1];
        if (!currentTarget) return singleton.show(last);
        var index = references.indexOf(currentTarget);
        var target = references[index - 1] || last;
        singleton.show(target);
    };
    var originalSetProps = singleton.setProps;
    singleton.setProps = function(props) {
        overrides = props.overrides || overrides;
        originalSetProps(props);
    };
    singleton.setInstances = function(nextInstances) {
        enableInstances(true);
        interceptSetPropsCleanups.forEach(function(fn) {
            return fn();
        });
        individualInstances = nextInstances;
        enableInstances(false);
        setReferences();
        setTriggerTargets();
        interceptSetPropsCleanups = interceptSetProps(singleton);
        singleton.setProps({
            triggerTarget: triggerTargets
        });
    };
    interceptSetPropsCleanups = interceptSetProps(singleton);
    return singleton;
};
var BUBBLING_EVENTS_MAP = {
    mouseover: 'mouseenter',
    focusin: 'focus',
    click: 'click'
};
/**
 * Creates a delegate instance that controls the creation of tippy instances
 * for child elements (`target` CSS selector).
 */ function delegate(targets, props) {
    errorWhen(!(props && props.target), [
        'You must specity a `target` prop indicating a CSS selector string matching',
        'the target elements that should receive a tippy.'
    ].join(' '));
    var listeners = [];
    var childTippyInstances = [];
    var disabled = false;
    var target = props.target;
    var nativeProps = removeProperties(props, [
        'target'
    ]);
    var parentProps = Object.assign({}, nativeProps, {
        trigger: 'manual',
        touch: false
    });
    var childProps = Object.assign({
        touch: defaultProps.touch
    }, nativeProps, {
        showOnCreate: true
    });
    var returnValue = tippy(targets, parentProps);
    var normalizedReturnValue = normalizeToArray(returnValue);
    function onTrigger(event) {
        if (!event.target || disabled) return;
        var targetNode = event.target.closest(target);
        if (!targetNode) return;
         // Get relevant trigger with fallbacks:
        // 1. Check `data-tippy-trigger` attribute on target node
        // 2. Fallback to `trigger` passed to `delegate()`
        // 3. Fallback to `defaultProps.trigger`
        var trigger = targetNode.getAttribute('data-tippy-trigger') || props.trigger || defaultProps.trigger; // @ts-ignore
        if (targetNode._tippy) return;
        if (event.type === 'touchstart' && typeof childProps.touch === 'boolean') return;
        if (event.type !== 'touchstart' && trigger.indexOf(BUBBLING_EVENTS_MAP[event.type]) < 0) return;
        var instance = tippy(targetNode, childProps);
        if (instance) childTippyInstances = childTippyInstances.concat(instance);
    }
    function on(node, eventType, handler, options) {
        if (options === void 0) options = false;
        node.addEventListener(eventType, handler, options);
        listeners.push({
            node: node,
            eventType: eventType,
            handler: handler,
            options: options
        });
    }
    function addEventListeners(instance) {
        var reference = instance.reference;
        on(reference, 'touchstart', onTrigger, TOUCH_OPTIONS);
        on(reference, 'mouseover', onTrigger);
        on(reference, 'focusin', onTrigger);
        on(reference, 'click', onTrigger);
    }
    function removeEventListeners() {
        listeners.forEach(function(_ref) {
            var node = _ref.node, eventType = _ref.eventType, handler = _ref.handler, options = _ref.options;
            node.removeEventListener(eventType, handler, options);
        });
        listeners = [];
    }
    function applyMutations(instance) {
        var originalDestroy = instance.destroy;
        var originalEnable = instance.enable;
        var originalDisable = instance.disable;
        instance.destroy = function(shouldDestroyChildInstances) {
            if (shouldDestroyChildInstances === void 0) shouldDestroyChildInstances = true;
            if (shouldDestroyChildInstances) childTippyInstances.forEach(function(instance) {
                instance.destroy();
            });
            childTippyInstances = [];
            removeEventListeners();
            originalDestroy();
        };
        instance.enable = function() {
            originalEnable();
            childTippyInstances.forEach(function(instance) {
                return instance.enable();
            });
            disabled = false;
        };
        instance.disable = function() {
            originalDisable();
            childTippyInstances.forEach(function(instance) {
                return instance.disable();
            });
            disabled = true;
        };
        addEventListeners(instance);
    }
    normalizedReturnValue.forEach(applyMutations);
    return returnValue;
}
var animateFill = {
    name: 'animateFill',
    defaultValue: false,
    fn: function fn(instance) {
        var _instance$props$rende;
        // @ts-ignore
        if (!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy)) {
            errorWhen(instance.props.animateFill, 'The `animateFill` plugin requires the default render function.');
            return {};
        }
        var _getChildren = getChildren(instance.popper), box = _getChildren.box, content = _getChildren.content;
        var backdrop = instance.props.animateFill ? createBackdropElement() : null;
        return {
            onCreate: function onCreate() {
                if (backdrop) {
                    box.insertBefore(backdrop, box.firstElementChild);
                    box.setAttribute('data-animatefill', '');
                    box.style.overflow = 'hidden';
                    instance.setProps({
                        arrow: false,
                        animation: 'shift-away'
                    });
                }
            },
            onMount: function onMount() {
                if (backdrop) {
                    var transitionDuration = box.style.transitionDuration;
                    var duration = Number(transitionDuration.replace('ms', '')); // The content should fade in after the backdrop has mostly filled the
                    // tooltip element. `clip-path` is the other alternative but is not
                    // well-supported and is buggy on some devices.
                    content.style.transitionDelay = Math.round(duration / 10) + "ms";
                    backdrop.style.transitionDuration = transitionDuration;
                    setVisibilityState([
                        backdrop
                    ], 'visible');
                }
            },
            onShow: function onShow() {
                if (backdrop) backdrop.style.transitionDuration = '0ms';
            },
            onHide: function onHide() {
                if (backdrop) setVisibilityState([
                    backdrop
                ], 'hidden');
            }
        };
    }
};
function createBackdropElement() {
    var backdrop = div();
    backdrop.className = BACKDROP_CLASS;
    setVisibilityState([
        backdrop
    ], 'hidden');
    return backdrop;
}
var mouseCoords = {
    clientX: 0,
    clientY: 0
};
var activeInstances = [];
function storeMouseCoords(_ref) {
    var clientX = _ref.clientX, clientY = _ref.clientY;
    mouseCoords = {
        clientX: clientX,
        clientY: clientY
    };
}
function addMouseCoordsListener(doc) {
    doc.addEventListener('mousemove', storeMouseCoords);
}
function removeMouseCoordsListener(doc) {
    doc.removeEventListener('mousemove', storeMouseCoords);
}
var followCursor = {
    name: 'followCursor',
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference;
        var doc = getOwnerDocument(instance.props.triggerTarget || reference);
        var isInternalUpdate = false;
        var wasFocusEvent = false;
        var isUnmounted = true;
        var prevProps = instance.props;
        function getIsInitialBehavior() {
            return instance.props.followCursor === 'initial' && instance.state.isVisible;
        }
        function addListener() {
            doc.addEventListener('mousemove', onMouseMove);
        }
        function removeListener() {
            doc.removeEventListener('mousemove', onMouseMove);
        }
        function unsetGetReferenceClientRect() {
            isInternalUpdate = true;
            instance.setProps({
                getReferenceClientRect: null
            });
            isInternalUpdate = false;
        }
        function onMouseMove(event) {
            // If the instance is interactive, avoid updating the position unless it's
            // over the reference element
            var isCursorOverReference = event.target ? reference.contains(event.target) : true;
            var followCursor = instance.props.followCursor;
            var clientX = event.clientX, clientY = event.clientY;
            var rect = reference.getBoundingClientRect();
            var relativeX = clientX - rect.left;
            var relativeY = clientY - rect.top;
            if (isCursorOverReference || !instance.props.interactive) instance.setProps({
                // @ts-ignore - unneeded DOMRect properties
                getReferenceClientRect: function getReferenceClientRect() {
                    var rect = reference.getBoundingClientRect();
                    var x = clientX;
                    var y = clientY;
                    if (followCursor === 'initial') {
                        x = rect.left + relativeX;
                        y = rect.top + relativeY;
                    }
                    var top = followCursor === 'horizontal' ? rect.top : y;
                    var right = followCursor === 'vertical' ? rect.right : x;
                    var bottom = followCursor === 'horizontal' ? rect.bottom : y;
                    var left = followCursor === 'vertical' ? rect.left : x;
                    return {
                        width: right - left,
                        height: bottom - top,
                        top: top,
                        right: right,
                        bottom: bottom,
                        left: left
                    };
                }
            });
        }
        function create() {
            if (instance.props.followCursor) {
                activeInstances.push({
                    instance: instance,
                    doc: doc
                });
                addMouseCoordsListener(doc);
            }
        }
        function destroy() {
            activeInstances = activeInstances.filter(function(data) {
                return data.instance !== instance;
            });
            if (activeInstances.filter(function(data) {
                return data.doc === doc;
            }).length === 0) removeMouseCoordsListener(doc);
        }
        return {
            onCreate: create,
            onDestroy: destroy,
            onBeforeUpdate: function onBeforeUpdate() {
                prevProps = instance.props;
            },
            onAfterUpdate: function onAfterUpdate(_, _ref2) {
                var followCursor = _ref2.followCursor;
                if (isInternalUpdate) return;
                if (followCursor !== undefined && prevProps.followCursor !== followCursor) {
                    destroy();
                    if (followCursor) {
                        create();
                        if (instance.state.isMounted && !wasFocusEvent && !getIsInitialBehavior()) addListener();
                    } else {
                        removeListener();
                        unsetGetReferenceClientRect();
                    }
                }
            },
            onMount: function onMount() {
                if (instance.props.followCursor && !wasFocusEvent) {
                    if (isUnmounted) {
                        onMouseMove(mouseCoords);
                        isUnmounted = false;
                    }
                    if (!getIsInitialBehavior()) addListener();
                }
            },
            onTrigger: function onTrigger(_, event) {
                if (isMouseEvent(event)) mouseCoords = {
                    clientX: event.clientX,
                    clientY: event.clientY
                };
                wasFocusEvent = event.type === 'focus';
            },
            onHidden: function onHidden() {
                if (instance.props.followCursor) {
                    unsetGetReferenceClientRect();
                    removeListener();
                    isUnmounted = true;
                }
            }
        };
    }
};
function getProps(props, modifier) {
    var _props$popperOptions;
    return {
        popperOptions: Object.assign({}, props.popperOptions, {
            modifiers: [].concat((((_props$popperOptions = props.popperOptions) == null ? void 0 : _props$popperOptions.modifiers) || []).filter(function(_ref) {
                var name = _ref.name;
                return name !== modifier.name;
            }), [
                modifier
            ])
        })
    };
}
var inlinePositioning = {
    name: 'inlinePositioning',
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference;
        function isEnabled() {
            return !!instance.props.inlinePositioning;
        }
        var placement;
        var cursorRectIndex = -1;
        var isInternalUpdate = false;
        var triedPlacements = [];
        var modifier = {
            name: 'tippyInlinePositioning',
            enabled: true,
            phase: 'afterWrite',
            fn: function fn(_ref2) {
                var state = _ref2.state;
                if (isEnabled()) {
                    if (triedPlacements.indexOf(state.placement) !== -1) triedPlacements = [];
                    if (placement !== state.placement && triedPlacements.indexOf(state.placement) === -1) {
                        triedPlacements.push(state.placement);
                        instance.setProps({
                            // @ts-ignore - unneeded DOMRect properties
                            getReferenceClientRect: function getReferenceClientRect() {
                                return _getReferenceClientRect(state.placement);
                            }
                        });
                    }
                    placement = state.placement;
                }
            }
        };
        function _getReferenceClientRect(placement) {
            return getInlineBoundingClientRect(getBasePlacement(placement), reference.getBoundingClientRect(), arrayFrom(reference.getClientRects()), cursorRectIndex);
        }
        function setInternalProps(partialProps) {
            isInternalUpdate = true;
            instance.setProps(partialProps);
            isInternalUpdate = false;
        }
        function addModifier() {
            if (!isInternalUpdate) setInternalProps(getProps(instance.props, modifier));
        }
        return {
            onCreate: addModifier,
            onAfterUpdate: addModifier,
            onTrigger: function onTrigger(_, event) {
                if (isMouseEvent(event)) {
                    var rects = arrayFrom(instance.reference.getClientRects());
                    var cursorRect = rects.find(function(rect) {
                        return rect.left - 2 <= event.clientX && rect.right + 2 >= event.clientX && rect.top - 2 <= event.clientY && rect.bottom + 2 >= event.clientY;
                    });
                    var index = rects.indexOf(cursorRect);
                    cursorRectIndex = index > -1 ? index : cursorRectIndex;
                }
            },
            onHidden: function onHidden() {
                cursorRectIndex = -1;
            }
        };
    }
};
function getInlineBoundingClientRect(currentBasePlacement, boundingRect, clientRects, cursorRectIndex) {
    // Not an inline element, or placement is not yet known
    if (clientRects.length < 2 || currentBasePlacement === null) return boundingRect;
     // There are two rects and they are disjoined
    if (clientRects.length === 2 && cursorRectIndex >= 0 && clientRects[0].left > clientRects[1].right) return clientRects[cursorRectIndex] || boundingRect;
    switch(currentBasePlacement){
        case 'top':
        case 'bottom':
            var firstRect = clientRects[0];
            var lastRect = clientRects[clientRects.length - 1];
            var isTop = currentBasePlacement === 'top';
            var top = firstRect.top;
            var bottom = lastRect.bottom;
            var left = isTop ? firstRect.left : lastRect.left;
            var right = isTop ? firstRect.right : lastRect.right;
            var width = right - left;
            var height = bottom - top;
            return {
                top: top,
                bottom: bottom,
                left: left,
                right: right,
                width: width,
                height: height
            };
        case 'left':
        case 'right':
            var minLeft = Math.min.apply(Math, clientRects.map(function(rects) {
                return rects.left;
            }));
            var maxRight = Math.max.apply(Math, clientRects.map(function(rects) {
                return rects.right;
            }));
            var measureRects = clientRects.filter(function(rect) {
                return currentBasePlacement === 'left' ? rect.left === minLeft : rect.right === maxRight;
            });
            var _top = measureRects[0].top;
            var _bottom = measureRects[measureRects.length - 1].bottom;
            var _left = minLeft;
            var _right = maxRight;
            var _width = _right - _left;
            var _height = _bottom - _top;
            return {
                top: _top,
                bottom: _bottom,
                left: _left,
                right: _right,
                width: _width,
                height: _height
            };
        default:
            return boundingRect;
    }
}
var sticky = {
    name: 'sticky',
    defaultValue: false,
    fn: function fn(instance) {
        var reference = instance.reference, popper = instance.popper;
        function getReference() {
            return instance.popperInstance ? instance.popperInstance.state.elements.reference : reference;
        }
        function shouldCheck(value) {
            return instance.props.sticky === true || instance.props.sticky === value;
        }
        var prevRefRect = null;
        var prevPopRect = null;
        function updatePosition() {
            var currentRefRect = shouldCheck('reference') ? getReference().getBoundingClientRect() : null;
            var currentPopRect = shouldCheck('popper') ? popper.getBoundingClientRect() : null;
            if (currentRefRect && areRectsDifferent(prevRefRect, currentRefRect) || currentPopRect && areRectsDifferent(prevPopRect, currentPopRect)) {
                if (instance.popperInstance) instance.popperInstance.update();
            }
            prevRefRect = currentRefRect;
            prevPopRect = currentPopRect;
            if (instance.state.isMounted) requestAnimationFrame(updatePosition);
        }
        return {
            onMount: function onMount() {
                if (instance.props.sticky) updatePosition();
            }
        };
    }
};
function areRectsDifferent(rectA, rectB) {
    if (rectA && rectB) return rectA.top !== rectB.top || rectA.right !== rectB.right || rectA.bottom !== rectB.bottom || rectA.left !== rectB.left;
    return true;
}
tippy.setDefaultProps({
    render: render
});
exports.default = tippy;

},{"@popperjs/core":"ysQ0D","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"cuYXS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Snippets", function() {
    return Snippets;
});
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _components = require("./components");
var _settings = require("./settings");
function Snippets() {
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _jsxDevRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _components.Components), {}, void 0, false, {
                fileName: "src/snippets/index.tsx",
                lineNumber: 8,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _settings.Settings), {}, void 0, false, {
                fileName: "src/snippets/index.tsx",
                lineNumber: 9,
                columnNumber: 13
            }, this)
        ]
    }, void 0, true);
}

},{"react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","./components":"1f8Ky","./settings":"5FFxb","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1f8Ky":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Components", function() {
    return Components;
});
parcelHelpers.export(exports, "componentsReducer", function() {
    return componentsReducer;
});
parcelHelpers.export(exports, "componentsDeps", function() {
    return componentsDeps;
});
parcelHelpers.export(exports, "componentsHandlers", function() {
    return componentsHandlers;
});
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _cartIcon = require("./cartIcon");
var _liquid = require("./products/liquid");
var _redux = require("redux");
var _state = require("./products/state");
var _liquid1 = require("./stickyPanel/liquid");
var _liquid2 = require("./cart/liquid");
var _state1 = require("./cart/state");
var _deps = require("./cart/deps");
var _handlers = require("./cart/handlers");
var _linkTracking = require("./linkTracking");
var _liquid3 = require("./productSelectionPanel/liquid");
var _state2 = require("./productSelectionPanel/state");
var _defaultHeader = require("./defaultHeader");
var _state3 = require("./stickyPanel/state");
function Components() {
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _jsxDevRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _cartIcon.CartIcon), {}, void 0, false, {
                fileName: "src/snippets/components/index.tsx",
                lineNumber: 27,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _liquid.Products), {}, void 0, false, {
                fileName: "src/snippets/components/index.tsx",
                lineNumber: 28,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _liquid1.StickyPanel), {}, void 0, false, {
                fileName: "src/snippets/components/index.tsx",
                lineNumber: 29,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _liquid2.Cart), {}, void 0, false, {
                fileName: "src/snippets/components/index.tsx",
                lineNumber: 30,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _linkTracking.LinkTracking), {}, void 0, false, {
                fileName: "src/snippets/components/index.tsx",
                lineNumber: 31,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _liquid3.ProductSelectionPanels), {}, void 0, false, {
                fileName: "src/snippets/components/index.tsx",
                lineNumber: 32,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _defaultHeader.DefaultHeader), {}, void 0, false, {
                fileName: "src/snippets/components/index.tsx",
                lineNumber: 33,
                columnNumber: 13
            }, this)
        ]
    }, void 0, true);
}
var componentsReducer = (0, _redux.combineReducers)({
    products: (0, _state.productsReducer),
    cart: (0, _state1.cartReducer),
    productSelectionPanel: (0, _state2.productSelectionPanelReducer),
    stickyPanel: (0, _state3.stickyPanelReducer)
});
function componentsDeps(ref) {
    return {
        cart: function() {
            return (0, _deps.cartDeps)(ref.deps);
        }
    };
}
function componentsHandlers(params) {
    (0, _handlers.cartHandlers)(params);
}

},{"react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","./cartIcon":"aDEgq","./products/liquid":"dcaZf","redux":"lKoa8","./products/state":"jAvr4","./stickyPanel/liquid":"7xSQR","./cart/liquid":"8Bmga","./cart/state":"1HyQc","./cart/deps":"9eUl5","./cart/handlers":"jAqmR","./linkTracking":"3oAoW","./productSelectionPanel/liquid":"490fV","./productSelectionPanel/state":"3nAmi","./defaultHeader":"0PP6H","./stickyPanel/state":"bTsl6","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"aDEgq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CartIcon", function() {
    return CartIcon;
});
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _cartView = require("./cart/view/cartView");
var _domArray = require("../../script/src/dom/library/DomArray");
var _domComponent = require("../../script/src/dom/library/DomComponent");
var _hooks = require("../../script/src/std/hooks");
var _openCart = require("./cart/useCases/openCart");
function CartIcon() {
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domArray.DomArray), {
        selector: ".componentCartIcon",
        child: function(param) {
            var key = param.key, selector = param.selector;
            return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(Element, {
                selector: selector
            }, key, false, {
                fileName: "src/snippets/components/cartIcon.tsx",
                lineNumber: 11,
                columnNumber: 79
            }, void 0);
        }
    }, void 0, false, {
        fileName: "src/snippets/components/cartIcon.tsx",
        lineNumber: 11,
        columnNumber: 9
    }, this);
}
function Element(props) {
    var view = (0, _reactRedux.useSelector)((0, _cartView.cartView));
    var dispatch = (0, _hooks.useDispatch)();
    if (!view) return null;
    var itemCount = view.itemCount > 9 ? '9+' : view.itemCount.toString();
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
        selector: props.selector,
        onClick: function() {
            return dispatch((0, _openCart.OpenCart)());
        },
        children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
            selector: "&__count",
            innerHtml: itemCount
        }, void 0, false, {
            fileName: "src/snippets/components/cartIcon.tsx",
            lineNumber: 29,
            columnNumber: 13
        }, this)
    }, void 0, false, {
        fileName: "src/snippets/components/cartIcon.tsx",
        lineNumber: 28,
        columnNumber: 9
    }, this);
}

},{"react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","react-redux":"ghMZu","./cart/view/cartView":"6eowi","../../script/src/dom/library/DomArray":"ZEl1X","../../script/src/dom/library/DomComponent":"8H9za","../../script/src/std/hooks":"j9RPQ","./cart/useCases/openCart":"cSUzZ","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6eowi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cartView", function() {
    return cartView;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _reselect = require("reselect");
var _variants = require("../../../../script/src/app/store/state/data/variants");
var _state = require("../state");
var _std = require("@reglo/std");
var _cartPriceSelector = require("../selectors/cartPriceSelector");
var _selectedSubscriptionFrequencySelector = require("../selectors/selectedSubscriptionFrequencySelector");
var _changeCartItemQuantity = require("../useCases/changeCartItemQuantity");
var _changeItemSubscriptionPlanInCart = require("../useCases/changeItemSubscriptionPlanInCart");
var _removeCartItem = require("../useCases/removeCartItem");
var _selectedSubscriptionPlanSelector = require("../selectors/selectedSubscriptionPlanSelector");
var _cartItemPriceSelector = require("../selectors/cartItemPriceSelector");
var cartView = (0, _reselect.createSelector)((0, _state.cartSelector), (0, _variants.variantsSelector), prepareView);
function prepareView(cartState, variantsState) {
    if (isLoading()) return null;
    return (0, _objectSpread._)({
        opened: cartState.opened,
        updating: cartState.updating,
        isEmpty: isEmpty(),
        items: prepareItems(),
        itemCount: prepareItemCount(),
        hasMarketingOperationItem: prepareHasMarketingOperationItem(),
        frequencyOptions: prepareFrequencyOptions(),
        selectedFrequency: prepareSelectedFrequency(),
        estimatedDelivery: prepareEstimatedDeliveryDate()
    }, (0, _std.unwrap)((0, _cartPriceSelector.cartPriceSelector)(cartState, variantsState)));
    function selectItems() {
        return cartState.items.filter(function(item) {
            var variant = selectVariantFromItem(item);
            if (!variant) return false;
            return !variant.hidden;
        });
    }
    function prepareEstimatedDeliveryDate() {
        return selectActiveItems().map(function(item) {
            return (0, _std.unwrap)(selectVariantFromItem(item));
        }).reduce(function(estimatedDelivery, variant) {
            var _estimatedDelivery_match, _variant_estimatedDelivery_match;
            var current = Number((_estimatedDelivery_match = estimatedDelivery.match(/(\d+)/)) === null || _estimatedDelivery_match === void 0 ? void 0 : _estimatedDelivery_match[1]);
            var next = Number((_variant_estimatedDelivery_match = variant.estimatedDelivery.match(/(\d+)/)) === null || _variant_estimatedDelivery_match === void 0 ? void 0 : _variant_estimatedDelivery_match[1]);
            if (estimatedDelivery === '' || current < next) return variant.estimatedDelivery;
            return estimatedDelivery;
        }, '');
    }
    function selectActiveItems() {
        return selectItems().filter(function(item) {
            return !item.removed;
        });
    }
    function isLoading() {
        return cartState.loading || variantsState.loading;
    }
    function isEmpty() {
        var itemCount = selectActiveItems().reduce(function(count, item) {
            return count + item.quantity;
        }, 0);
        return itemCount === 0 && !cartState.updating;
    }
    function prepareItems() {
        return selectItems().map(prepareItem);
    }
    function prepareItem(item) {
        var variant = (0, _std.unwrap)(selectVariantFromItem(item));
        return (0, _objectSpreadProps._)((0, _objectSpread._)({
            key: item.key,
            productTitle: variant.productTitle,
            productSubtitle: variant.productSubtitle,
            variantTitle: variant.variantTitle,
            allowSubscription: prepareAllowSubscription(item),
            isSubscription: item.subscriptionSelected,
            picture: variant.picture,
            quantity: item.quantity,
            maxQuantitySelector: variant.maxQuantitySelector,
            maximumQuantity: variant.maximumQuantity,
            deleted: item.removed,
            url: prepareUrl(item),
            bulkDiscount: variant.bulkDiscount
        }, (0, _std.unwrap)((0, _cartItemPriceSelector.cartItemPriceSelector)(item, cartState, variantsState))), {
            actions: {
                decrement: (0, _changeCartItemQuantity.ChangeCartItemQuantity)({
                    key: item.key,
                    quantity: item.quantity - 1
                }),
                increment: (0, _changeCartItemQuantity.ChangeCartItemQuantity)({
                    key: item.key,
                    quantity: item.quantity + 1
                }),
                updateQuantity: function(quantity) {
                    return (0, _changeCartItemQuantity.ChangeCartItemQuantity)({
                        key: item.key,
                        quantity: quantity
                    });
                },
                toggleSubscription: (0, _changeItemSubscriptionPlanInCart.ChangeItemSubscriptionPlanInCart)({
                    key: item.key,
                    subscriptionPlanId: item.subscriptionSelected ? null : selectSubscriptionPlanId(item)
                }),
                remove: (0, _removeCartItem.RemoveCartItem)({
                    key: item.key
                })
            }
        });
    }
    function selectVariantFromItem(item) {
        var _variantsState_entities_find;
        return (_variantsState_entities_find = variantsState.entities.find(function(variant) {
            return variant.variantId === item.variantId;
        })) !== null && _variantsState_entities_find !== void 0 ? _variantsState_entities_find : null;
    }
    function selectSubscriptionPlanId(item) {
        return (0, _std.unwrap)((0, _selectedSubscriptionPlanSelector.selectedSubscriptionPlanSelector)(item.variantId, variantsState, cartState)).subscriptionPlanId;
    }
    function prepareSelectedFrequency() {
        return (0, _std.unwrap)((0, _selectedSubscriptionFrequencySelector.selectedSubscriptionFrequencySelector)(variantsState, cartState)).frequency;
    }
    function prepareUrl(item) {
        var variant = (0, _std.unwrap)(selectVariantFromItem(item));
        var subscriptionPlanId = item.subscriptionSelected ? item.subscriptionPlanId : null;
        return `${variant.url}${subscriptionPlanId ? `&selling_plan=${subscriptionPlanId}` : ''}`;
    }
    function prepareFrequencyOptions() {
        return [
            3,
            4,
            5,
            6,
            7,
            8,
            12,
            16,
            20
        ].map(function(frequency) {
            return {
                frequencyInWeeks: frequency,
                mostChosen: frequency === 4
            };
        });
    }
    function prepareAllowSubscription(item) {
        var variant = (0, _std.unwrap)(selectVariantFromItem(item));
        if (variant.isSample) return false;
        return hasSubscriptionOptions(item);
    }
    function hasSubscriptionOptions(item) {
        var variant = (0, _std.unwrap)(variantsState.entities.find(function(variant) {
            return variant.variantId === item.variantId;
        }));
        return variant.subscriptionPlans.length > 0;
    }
    function prepareItemCount() {
        return selectActiveItems().reduce(function(sum, item) {
            return sum + item.quantity;
        }, 0);
    }
    function prepareHasMarketingOperationItem() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = selectItems()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var item = _step.value;
                var variant = selectVariantFromItem(item);
                if (item.quantity > 0 && (variant === null || variant === void 0 ? void 0 : variant.productId) === 8422146441561) return true;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return false;
    }
}

},{"@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_object_spread_props":"fLCYP","reselect":"fb6q1","../../../../script/src/app/store/state/data/variants":"11hc8","../state":"1HyQc","@reglo/std":"1USo0","../selectors/cartPriceSelector":"icBq9","../selectors/selectedSubscriptionFrequencySelector":"iW02l","../useCases/changeCartItemQuantity":"b69iv","../useCases/changeItemSubscriptionPlanInCart":"d0Ejd","../useCases/removeCartItem":"32Oeg","../selectors/selectedSubscriptionPlanSelector":"dXpbD","../selectors/cartItemPriceSelector":"7ICgX","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"icBq9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cartPriceSelector", function() {
    return cartPriceSelector;
});
var _variants = require("../../../../script/src/app/store/state/data/variants");
var _std = require("@reglo/std");
var _cartItemPriceSelector = require("./cartItemPriceSelector");
function cartPriceSelector(cartState, variantsState) {
    if (isLoading()) return null;
    return {
        shippingPrice: prepareShippingPrice(),
        itemsOriginalPrice: prepareItemsOriginalPrice(),
        itemsTotalPrice: prepareItemsTotalPrice(),
        totalPrice: prepareTotalPrice()
    };
    function selectActiveItems() {
        return cartState.items.filter(function(item) {
            var variant = (0, _std.unwrap)((0, _variants.selectVariantInState)(variantsState, item.variantId));
            return !variant.hidden;
        }).filter(function(item) {
            return !item.removed;
        });
    }
    function isLoading() {
        return cartState.loading || variantsState.loading;
    }
    function prepareItemsOriginalPrice() {
        return selectActiveItems().reduce(function(sum, item) {
            var itemPrice = selectItemOriginalPrice(item);
            return sum + itemPrice * item.quantity;
        }, 0);
    }
    function prepareItemsTotalPrice() {
        return selectActiveItems().reduce(function(sum, item) {
            var itemPrice = selectItemPrice(item);
            return sum + itemPrice * item.quantity;
        }, 0);
    }
    function prepareShippingPrice() {
        var itemsPrice = prepareItemsTotalPrice();
        return itemsPrice >= settings.shipping__minimum * 100 ? 0 : 390;
    }
    function prepareTotalPrice() {
        var itemsPrice = prepareItemsTotalPrice();
        var shippingPrice = prepareShippingPrice();
        return itemsPrice + shippingPrice;
    }
    function selectItemOriginalPrice(item) {
        var prices = (0, _cartItemPriceSelector.cartItemPriceSelector)(item, cartState, variantsState);
        return (0, _std.unwrap)(prices).originalPrice;
    }
    function selectItemPrice(item) {
        var prices = (0, _cartItemPriceSelector.cartItemPriceSelector)(item, cartState, variantsState);
        return (0, _std.unwrap)(prices).price;
    }
}

},{"../../../../script/src/app/store/state/data/variants":"11hc8","@reglo/std":"1USo0","./cartItemPriceSelector":"7ICgX","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7ICgX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cartItemPriceSelector", function() {
    return cartItemPriceSelector;
});
var _variants = require("../../../../script/src/app/store/state/data/variants");
var _std = require("@reglo/std");
function cartItemPriceSelector(item, cartState, variantsState) {
    if (isLoading()) return null;
    return {
        originalPrice: selectItemOriginalPrice(),
        price: selectItemPrice()
    };
    function isLoading() {
        return cartState.loading || variantsState.loading;
    }
    function selectItemOriginalPrice() {
        var variant = (0, _std.unwrap)((0, _variants.selectVariantInState)(variantsState, item.variantId));
        return variant.price.original;
    }
    function selectItemPrice() {
        var variant = (0, _std.unwrap)((0, _variants.selectVariantInState)(variantsState, item.variantId));
        var price = item.subscriptionSelected ? (0, _std.unwrap)(variant.price.subscription) : variant.price.oneTime;
        var discount = selectBulkDiscount();
        return Math.round(price * (100 - discount) / 100);
    }
    function selectBulkDiscount() {
        var variant = (0, _std.unwrap)((0, _variants.selectVariantInState)(variantsState, item.variantId));
        return variant.bulkDiscount.reduce(function(discount, next) {
            if (item.quantity >= next.minQuantity && next.discount > discount) return next.discount;
            return discount;
        }, 0);
    }
}

},{"../../../../script/src/app/store/state/data/variants":"11hc8","@reglo/std":"1USo0","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"iW02l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "selectedSubscriptionFrequencySelector", function() {
    return selectedSubscriptionFrequencySelector;
});
var _variants = require("../../../../script/src/app/store/state/data/variants");
var _std = require("@reglo/std");
function selectedSubscriptionFrequencySelector(variantsState, cartState) {
    if (isLoading()) return null;
    return {
        frequency: prepareFrequency()
    };
    function prepareFrequency() {
        var item = cartState.items.find(function(item) {
            return item.subscriptionSelected;
        });
        if (!item) return null;
        var variant = (0, _std.unwrap)((0, _variants.selectVariantInState)(variantsState, item.variantId));
        var subscriptionPlan = variant.subscriptionPlans.find(function(subscriptionPlan) {
            return subscriptionPlan.subscriptionPlanId === item.subscriptionPlanId;
        });
        return (0, _std.unwrap)(subscriptionPlan).weekFrequency;
    }
    function isLoading() {
        return cartState.loading || variantsState.loading;
    }
}

},{"../../../../script/src/app/store/state/data/variants":"11hc8","@reglo/std":"1USo0","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"dXpbD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "selectedSubscriptionPlanSelector", function() {
    return selectedSubscriptionPlanSelector;
});
var _variants = require("../../../../script/src/app/store/state/data/variants");
var _std = require("@reglo/std");
var _selectedSubscriptionFrequencySelector = require("./selectedSubscriptionFrequencySelector");
function selectedSubscriptionPlanSelector(variantId, variantsState, cartState) {
    if (isLoading()) return null;
    return {
        subscriptionPlanId: prepareSubscriptionPlanId()
    };
    function prepareSubscriptionPlanId() {
        var cartFrequency = (0, _std.unwrap)((0, _selectedSubscriptionFrequencySelector.selectedSubscriptionFrequencySelector)(variantsState, cartState)).frequency;
        if (!cartFrequency) return selectSubscriptionPlanIdByFrequency(4);
        return selectSubscriptionPlanIdByFrequency(cartFrequency);
    }
    function selectSubscriptionPlanIdByFrequency(frequency) {
        var variant = (0, _std.unwrap)((0, _variants.selectVariantInState)(variantsState, variantId));
        var subscriptionPlan = variant.subscriptionPlans.find(function(subscriptionPlan) {
            return subscriptionPlan.weekFrequency === frequency;
        });
        var _subscriptionPlan_subscriptionPlanId;
        return (_subscriptionPlan_subscriptionPlanId = subscriptionPlan === null || subscriptionPlan === void 0 ? void 0 : subscriptionPlan.subscriptionPlanId) !== null && _subscriptionPlan_subscriptionPlanId !== void 0 ? _subscriptionPlan_subscriptionPlanId : null;
    }
    function isLoading() {
        return cartState.loading || variantsState.loading;
    }
}

},{"../../../../script/src/app/store/state/data/variants":"11hc8","@reglo/std":"1USo0","./selectedSubscriptionFrequencySelector":"iW02l","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"dcaZf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Products", function() {
    return Products;
});
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _domComponent = require("../../../../script/src/dom/library/DomComponent");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _domArray = require("../../../../script/src/dom/library/DomArray");
var _domElement = require("../../../../script/src/dom/library/DomElement");
var _selectVariant = require("../useCases/selectVariant");
var _hooks = require("../../../../script/src/std/hooks");
var _selectSubscriptionCtaView = require("../views/selectSubscriptionCtaView");
var _initSelectedVariant = require("../useCases/initSelectedVariant");
var _selectSubscriptionVariantView = require("../views/selectSubscriptionVariantView");
var _price = require("../../../../script/src/std/price");
var _indexLiquid = require("../../cta/index--liquid");
function Products() {
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domArray.DomArray), {
        selector: ".componentProducts__product[data-product_id]",
        child: function(param) {
            var key = param.key, selector = param.selector;
            return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(Product, {
                selector: selector
            }, key, false, {
                fileName: "src/snippets/components/products/liquid/index.tsx",
                lineNumber: 21,
                columnNumber: 17
            }, void 0);
        }
    }, void 0, false, {
        fileName: "src/snippets/components/products/liquid/index.tsx",
        lineNumber: 18,
        columnNumber: 9
    }, this);
}
function Product(props) {
    var productId = (0, _domElement.useNumberAttributeValue)('data-product_id', props.selector);
    var view = (0, _hooks.useSelector)(function(state) {
        return (0, _selectSubscriptionCtaView.selectSubscriptionCtaView)(state, productId);
    });
    var dispatch = (0, _hooks.useDispatch)();
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
        selector: props.selector,
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domArray.DomArray), {
                selector: "[data-id=variant]",
                discriminator: "data-key",
                child: function(param) {
                    var key = param.key, selector = param.selector;
                    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(Variant, {
                        variantId: Number(key),
                        selector: selector,
                        productId: productId
                    }, key, false, {
                        fileName: "src/snippets/components/products/liquid/index.tsx",
                        lineNumber: 43,
                        columnNumber: 21
                    }, void 0);
                }
            }, void 0, false, {
                fileName: "src/snippets/components/products/liquid/index.tsx",
                lineNumber: 39,
                columnNumber: 13
            }, this),
            view && /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _jsxDevRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
                        selector: "[data-id=price]",
                        children: [
                            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
                                selector: "[data-id=newPrice]",
                                text: (0, _price.formatPrice)(view.price)
                            }, void 0, false, {
                                fileName: "src/snippets/components/products/liquid/index.tsx",
                                lineNumber: 54,
                                columnNumber: 25
                            }, this),
                            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
                                selector: "[data-id=originalPrice]",
                                text: (0, _price.formatPrice)(view.originalPrice)
                            }, void 0, false, {
                                fileName: "src/snippets/components/products/liquid/index.tsx",
                                lineNumber: 55,
                                columnNumber: 25
                            }, this)
                        ]
                    }, void 0, true, {
                        fileName: "src/snippets/components/products/liquid/index.tsx",
                        lineNumber: 53,
                        columnNumber: 21
                    }, this),
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _indexLiquid.LiquidCta), {
                        selector: "[data-id=cta]",
                        onClick: function() {
                            return dispatch(view.actions.addToCart);
                        },
                        price: view.price,
                        originalPrice: view.originalPrice
                    }, void 0, false, {
                        fileName: "src/snippets/components/products/liquid/index.tsx",
                        lineNumber: 57,
                        columnNumber: 21
                    }, this)
                ]
            }, void 0, true)
        ]
    }, void 0, true, {
        fileName: "src/snippets/components/products/liquid/index.tsx",
        lineNumber: 38,
        columnNumber: 9
    }, this);
}
function Variant(props) {
    var isDisabled = (0, _domElement.useBooleanAttributeValue)('data-is_disabled', props.selector);
    var isDefaultSelection = (0, _domElement.useBooleanAttributeValue)('data-is_selected', props.selector);
    var dispatch = (0, _hooks.useDispatch)();
    var view = (0, _hooks.useSelector)(function(state) {
        return (0, _selectSubscriptionVariantView.selectSubscriptionVariantView)(state, props);
    });
    (0, _react.useEffect)(function() {
        if (isDefaultSelection) dispatch((0, _initSelectedVariant.InitSelectedVariant)(props));
    }, []);
    function handleClick() {
        if (isDisabled) return;
        dispatch((0, _selectVariant.SelectVariant)(props));
    }
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
        selector: props.selector,
        onClick: handleClick,
        data: {
            is_selected: view.isSelected
        }
    }, void 0, false, {
        fileName: "src/snippets/components/products/liquid/index.tsx",
        lineNumber: 93,
        columnNumber: 9
    }, this);
}

},{"react/jsx-dev-runtime":"jXZ8I","../../../../script/src/dom/library/DomComponent":"8H9za","react":"c8CN1","../../../../script/src/dom/library/DomArray":"ZEl1X","../../../../script/src/dom/library/DomElement":"15N7Q","../useCases/selectVariant":"jOas3","../../../../script/src/std/hooks":"j9RPQ","../views/selectSubscriptionCtaView":"96n8A","../useCases/initSelectedVariant":"lqayC","../views/selectSubscriptionVariantView":"1Vt1R","../../../../script/src/std/price":"bpfMV","../../cta/index--liquid":"2Hp5o","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jOas3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SelectVariantKey", function() {
    return SelectVariantKey;
});
parcelHelpers.export(exports, "SelectVariant", function() {
    return SelectVariant;
});
var _eventFactory = require("../../../../script/src/std/eventFactory");
var SelectVariantKey = 'ComponentProducts.SelectVariant';
var SelectVariant = (0, _eventFactory.eventFactory)(SelectVariantKey)();

},{"../../../../script/src/std/eventFactory":"f2PpV","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"96n8A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "selectSubscriptionCtaView", function() {
    return selectSubscriptionCtaView;
});
var _reReselect = require("re-reselect");
var _state = require("../state");
var _variants = require("../../../../script/src/app/store/state/data/variants");
var _std = require("@reglo/std");
var _addProductToCart = require("../../cart/useCases/addProductToCart");
var _selectedSubscriptionPlanSelector = require("../../cart/selectors/selectedSubscriptionPlanSelector");
var _state1 = require("../../cart/state");
var selectSubscriptionCtaView = (0, _reReselect.createCachedSelector)(function(_, productId) {
    return productId;
}, (0, _state.productsSelector), (0, _variants.variantsSelector), (0, _state1.cartSelector), prepareView)(function(state, productId) {
    return productId;
});
function prepareView(productId, productsState, variantsState, cartState) {
    if (isLoading()) return null;
    return {
        price: preparePrice(),
        originalPrice: prepareOriginalPrice(),
        actions: {
            addToCart: prepareAddToCartAction()
        }
    };
    function prepareAddToCartAction() {
        var variant = (0, _std.unwrap)(localSelectVariant());
        return (0, _addProductToCart.AddProductToCart)({
            source: 'subscriptionPage',
            subscriptionPlanId: subscriptionPlanId(variant),
            variantId: variant.variantId,
            quantity: 1
        });
    }
    function subscriptionPlanId(variant) {
        var _selectedSubscriptionPlanSelector1;
        return (0, _std.unwrap)((_selectedSubscriptionPlanSelector1 = (0, _selectedSubscriptionPlanSelector.selectedSubscriptionPlanSelector)(variant.variantId, variantsState, cartState)) === null || _selectedSubscriptionPlanSelector1 === void 0 ? void 0 : _selectedSubscriptionPlanSelector1.subscriptionPlanId);
    }
    function isLoading() {
        return !localSelectVariant() || variantsState.loading || cartState.loading;
    }
    function prepareOriginalPrice() {
        var variant = (0, _std.unwrap)(localSelectVariant());
        return (0, _std.unwrap)(variant.price.original);
    }
    function preparePrice() {
        var variant = (0, _std.unwrap)(localSelectVariant());
        return (0, _std.unwrap)(variant.price.subscription);
    }
    function localSelectVariant() {
        var product = (0, _state.selectProduct)(productsState, productId);
        if (!(product === null || product === void 0 ? void 0 : product.selectedVariantId)) return null;
        return (0, _variants.selectVariantInState)(variantsState, product.selectedVariantId);
    }
}

},{"re-reselect":"fUjlV","../state":"jAvr4","../../../../script/src/app/store/state/data/variants":"11hc8","@reglo/std":"1USo0","../../cart/useCases/addProductToCart":"bC9NF","../../cart/selectors/selectedSubscriptionPlanSelector":"dXpbD","../../cart/state":"1HyQc","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"fUjlV":[function(require,module,exports,__globalThis) {
(function(global, factory) {
    factory(exports, require("b6488beaedb04f90"));
})(this, function(exports1, reselect) {
    'use strict';
    function isStringOrNumber(value) {
        return typeof value === 'string' || typeof value === 'number';
    }
    var FlatObjectCache = /*#__PURE__*/ function() {
        function FlatObjectCache() {
            this._cache = {};
        }
        var _proto = FlatObjectCache.prototype;
        _proto.set = function set(key, selectorFn) {
            this._cache[key] = selectorFn;
        };
        _proto.get = function get(key) {
            return this._cache[key];
        };
        _proto.remove = function remove(key) {
            delete this._cache[key];
        };
        _proto.clear = function clear() {
            this._cache = {};
        };
        _proto.isValidCacheKey = function isValidCacheKey(cacheKey) {
            return isStringOrNumber(cacheKey);
        };
        return FlatObjectCache;
    }();
    var defaultCacheCreator = FlatObjectCache;
    var defaultCacheKeyValidator = function defaultCacheKeyValidator() {
        return true;
    };
    function parseReselectArgs(reselectArgs) {
        var args = [].concat(reselectArgs);
        var lastArgument = args[args.length - 1];
        var resultFunc;
        var createSelectorOptions = undefined;
        // Last argument is resultFunc
        if (typeof lastArgument === 'function') resultFunc = args.pop();
        else {
            // Last argument is createSelectorOptions object
            createSelectorOptions = args.pop();
            resultFunc = args.pop();
        }
        return {
            inputSelectors: Array.isArray(args[0]) ? args[0] : [].concat(args),
            resultFunc: resultFunc,
            createSelectorOptions: createSelectorOptions
        };
    }
    function createCachedSelector() {
        for(var _len = arguments.length, reselectArgs = new Array(_len), _key = 0; _key < _len; _key++)reselectArgs[_key] = arguments[_key];
        var _parseReselectArgs = parseReselectArgs(reselectArgs), inputSelectors = _parseReselectArgs.inputSelectors, resultFunc = _parseReselectArgs.resultFunc, createSelectorOptions = _parseReselectArgs.createSelectorOptions;
        return function(polymorphicOptions) {
            var options = typeof polymorphicOptions === 'function' ? {
                keySelector: polymorphicOptions
            } : Object.assign({}, polymorphicOptions);
            // https://github.com/reduxjs/reselect/blob/v4.0.0/src/index.js#L54
            var recomputations = 0;
            var resultFuncWithRecomputations = function resultFuncWithRecomputations() {
                recomputations++;
                return resultFunc.apply(void 0, arguments);
            };
            // Patch reselect call arguments with a custom resultFunc
            var patchedReselectArgs = [
                inputSelectors,
                resultFuncWithRecomputations
            ];
            if (createSelectorOptions) patchedReselectArgs.push(createSelectorOptions);
            var cache = options.cacheObject || new defaultCacheCreator();
            var selectorCreator = options.selectorCreator || reselect.createSelector;
            var isValidCacheKey = cache.isValidCacheKey || defaultCacheKeyValidator;
            if (options.keySelectorCreator) options.keySelector = options.keySelectorCreator({
                keySelector: options.keySelector,
                inputSelectors: inputSelectors,
                resultFunc: resultFunc
            });
            // User receives this function
            var selector = function selector() {
                var cacheKey = options.keySelector.apply(options, arguments);
                if (isValidCacheKey(cacheKey)) {
                    var cacheResponse = cache.get(cacheKey);
                    if (cacheResponse === undefined) {
                        cacheResponse = selectorCreator.apply(void 0, patchedReselectArgs);
                        cache.set(cacheKey, cacheResponse);
                    }
                    return cacheResponse.apply(void 0, arguments);
                }
                console.warn("[re-reselect] Invalid cache key \"" + cacheKey + "\" has been returned by keySelector function.");
                return undefined;
            };
            // Further selector methods
            selector.getMatchingSelector = function() {
                var cacheKey = options.keySelector.apply(options, arguments);
                // @NOTE It might update cache hit count in LRU-like caches
                return cache.get(cacheKey);
            };
            selector.removeMatchingSelector = function() {
                var cacheKey = options.keySelector.apply(options, arguments);
                cache.remove(cacheKey);
            };
            selector.clearCache = function() {
                cache.clear();
            };
            selector.resultFunc = resultFunc;
            selector.dependencies = inputSelectors;
            selector.cache = cache;
            selector.recomputations = function() {
                return recomputations;
            };
            selector.resetRecomputations = function() {
                return recomputations = 0;
            };
            selector.keySelector = options.keySelector;
            return selector;
        };
    }
    function createStructuredCachedSelector(selectors) {
        return reselect.createStructuredSelector(selectors, createCachedSelector);
    }
    function validateCacheSize(cacheSize) {
        if (cacheSize === undefined) throw new Error('Missing the required property "cacheSize".');
        if (!Number.isInteger(cacheSize) || cacheSize <= 0) throw new Error('The "cacheSize" property must be a positive integer value.');
    }
    var FifoObjectCache = /*#__PURE__*/ function() {
        function FifoObjectCache(_temp) {
            var _ref = _temp === void 0 ? {} : _temp, cacheSize = _ref.cacheSize;
            validateCacheSize(cacheSize);
            this._cache = {};
            this._cacheOrdering = [];
            this._cacheSize = cacheSize;
        }
        var _proto = FifoObjectCache.prototype;
        _proto.set = function set(key, selectorFn) {
            this._cache[key] = selectorFn;
            this._cacheOrdering.push(key);
            if (this._cacheOrdering.length > this._cacheSize) {
                var earliest = this._cacheOrdering[0];
                this.remove(earliest);
            }
        };
        _proto.get = function get(key) {
            return this._cache[key];
        };
        _proto.remove = function remove(key) {
            var index = this._cacheOrdering.indexOf(key);
            if (index > -1) this._cacheOrdering.splice(index, 1);
            delete this._cache[key];
        };
        _proto.clear = function clear() {
            this._cache = {};
            this._cacheOrdering = [];
        };
        _proto.isValidCacheKey = function isValidCacheKey(cacheKey) {
            return isStringOrNumber(cacheKey);
        };
        return FifoObjectCache;
    }();
    var LruObjectCache = /*#__PURE__*/ function() {
        function LruObjectCache(_temp) {
            var _ref = _temp === void 0 ? {} : _temp, cacheSize = _ref.cacheSize;
            validateCacheSize(cacheSize);
            this._cache = {};
            this._cacheOrdering = [];
            this._cacheSize = cacheSize;
        }
        var _proto = LruObjectCache.prototype;
        _proto.set = function set(key, selectorFn) {
            this._cache[key] = selectorFn;
            this._registerCacheHit(key);
            if (this._cacheOrdering.length > this._cacheSize) {
                var earliest = this._cacheOrdering[0];
                this.remove(earliest);
            }
        };
        _proto.get = function get(key) {
            this._registerCacheHit(key);
            return this._cache[key];
        };
        _proto.remove = function remove(key) {
            this._deleteCacheHit(key);
            delete this._cache[key];
        };
        _proto.clear = function clear() {
            this._cache = {};
            this._cacheOrdering = [];
        };
        _proto._registerCacheHit = function _registerCacheHit(key) {
            this._deleteCacheHit(key);
            this._cacheOrdering.push(key);
        };
        _proto._deleteCacheHit = function _deleteCacheHit(key) {
            var index = this._cacheOrdering.indexOf(key);
            if (index > -1) this._cacheOrdering.splice(index, 1);
        };
        _proto.isValidCacheKey = function isValidCacheKey(cacheKey) {
            return isStringOrNumber(cacheKey);
        };
        return LruObjectCache;
    }();
    var FlatMapCache = /*#__PURE__*/ function() {
        function FlatMapCache() {
            this._cache = new Map();
        }
        var _proto = FlatMapCache.prototype;
        _proto.set = function set(key, selectorFn) {
            this._cache.set(key, selectorFn);
        };
        _proto.get = function get(key) {
            return this._cache.get(key);
        };
        _proto.remove = function remove(key) {
            this._cache["delete"](key);
        };
        _proto.clear = function clear() {
            this._cache.clear();
        };
        return FlatMapCache;
    }();
    var FifoMapCache = /*#__PURE__*/ function() {
        function FifoMapCache(_temp) {
            var _ref = _temp === void 0 ? {} : _temp, cacheSize = _ref.cacheSize;
            validateCacheSize(cacheSize);
            this._cache = new Map();
            this._cacheSize = cacheSize;
        }
        var _proto = FifoMapCache.prototype;
        _proto.set = function set(key, selectorFn) {
            this._cache.set(key, selectorFn);
            if (this._cache.size > this._cacheSize) {
                var earliest = this._cache.keys().next().value;
                this.remove(earliest);
            }
        };
        _proto.get = function get(key) {
            return this._cache.get(key);
        };
        _proto.remove = function remove(key) {
            this._cache["delete"](key);
        };
        _proto.clear = function clear() {
            this._cache.clear();
        };
        return FifoMapCache;
    }();
    var LruMapCache = /*#__PURE__*/ function() {
        function LruMapCache(_temp) {
            var _ref = _temp === void 0 ? {} : _temp, cacheSize = _ref.cacheSize;
            validateCacheSize(cacheSize);
            this._cache = new Map();
            this._cacheSize = cacheSize;
        }
        var _proto = LruMapCache.prototype;
        _proto.set = function set(key, selectorFn) {
            this._cache.set(key, selectorFn);
            if (this._cache.size > this._cacheSize) {
                var earliest = this._cache.keys().next().value;
                this.remove(earliest);
            }
        };
        _proto.get = function get(key) {
            var value = this._cache.get(key);
            // Register cache hit
            if (this._cache.has(key)) {
                this.remove(key);
                this._cache.set(key, value);
            }
            return value;
        };
        _proto.remove = function remove(key) {
            this._cache["delete"](key);
        };
        _proto.clear = function clear() {
            this._cache.clear();
        };
        return LruMapCache;
    }();
    exports1.FifoMapCache = FifoMapCache;
    exports1.FifoObjectCache = FifoObjectCache;
    exports1.FlatMapCache = FlatMapCache;
    exports1.FlatObjectCache = FlatObjectCache;
    exports1.LruMapCache = LruMapCache;
    exports1.LruObjectCache = LruObjectCache;
    exports1.createCachedSelector = createCachedSelector;
    exports1.createStructuredCachedSelector = createStructuredCachedSelector;
});

},{"b6488beaedb04f90":"fb6q1"}],"jAvr4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "productsReducer", function() {
    return productsReducer;
});
parcelHelpers.export(exports, "productsSelector", function() {
    return productsSelector;
});
parcelHelpers.export(exports, "selectProduct", function() {
    return selectProduct;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _initSelectedVariant = require("../useCases/initSelectedVariant");
var _selectVariant = require("../useCases/selectVariant");
var initialState = {
    products: {}
};
function productsReducer() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, event = arguments.length > 1 ? arguments[1] : void 0;
    switch(event.type){
        case 0, _initSelectedVariant.InitSelectedVariantKey:
        case 0, _selectVariant.SelectVariantKey:
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                products: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.products), (0, _defineProperty._)({}, event.payload.productId, {
                    selectedVariantId: event.payload.variantId
                }))
            });
        default:
            return state;
    }
}
function productsSelector(state) {
    return state.components.products;
}
function selectProduct(state, productId) {
    var _state_products_productId;
    return (_state_products_productId = state.products[productId]) !== null && _state_products_productId !== void 0 ? _state_products_productId : null;
}

},{"@swc/helpers/_/_define_property":"54Zvk","@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_object_spread_props":"fLCYP","../useCases/initSelectedVariant":"lqayC","../useCases/selectVariant":"jOas3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"lqayC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InitSelectedVariantKey", function() {
    return InitSelectedVariantKey;
});
parcelHelpers.export(exports, "InitSelectedVariant", function() {
    return InitSelectedVariant;
});
var _eventFactory = require("../../../../script/src/std/eventFactory");
var InitSelectedVariantKey = 'ComponentProducts.InitSelectedVariant';
var InitSelectedVariant = (0, _eventFactory.eventFactory)(InitSelectedVariantKey)();

},{"../../../../script/src/std/eventFactory":"f2PpV","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1Vt1R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "selectSubscriptionVariantView", function() {
    return selectSubscriptionVariantView;
});
var _reReselect = require("re-reselect");
var _state = require("../state");
var _selectVariant = require("../useCases/selectVariant");
var selectSubscriptionVariantView = (0, _reReselect.createCachedSelector)(function(_, params) {
    return params;
}, (0, _state.productsSelector), prepareView)(function(state, params) {
    return params.variantId;
});
function prepareView(params, productsState) {
    return {
        isSelected: prepareIsSelected(),
        actions: {
            select: (0, _selectVariant.SelectVariant)(params)
        }
    };
    function prepareIsSelected() {
        var product = (0, _state.selectProduct)(productsState, params.productId);
        return (product === null || product === void 0 ? void 0 : product.selectedVariantId) === params.variantId;
    }
}

},{"re-reselect":"fUjlV","../state":"jAvr4","../useCases/selectVariant":"jOas3","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2Hp5o":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LiquidCta", function() {
    return LiquidCta;
});
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _price = require("../../../script/src/std/price");
var _domComponent = require("../../../script/src/dom/library/DomComponent");
function LiquidCta(props) {
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
        selector: props.selector,
        onClick: props.onClick,
        data: {
            hide_original_price: !props.originalPrice || !props.price || props.originalPrice >= props.price
        },
        children: [
            props.price && /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
                selector: "[data-id=newPrice]",
                text: (0, _price.formatPrice)(props.price)
            }, void 0, false, {
                fileName: "src/snippets/components/cta/index--liquid.tsx",
                lineNumber: 19,
                columnNumber: 29
            }, this),
            props.originalPrice && /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
                selector: "[data-id=originalPrice]",
                text: (0, _price.formatPrice)(props.originalPrice)
            }, void 0, false, {
                fileName: "src/snippets/components/cta/index--liquid.tsx",
                lineNumber: 20,
                columnNumber: 37
            }, this)
        ]
    }, void 0, true, {
        fileName: "src/snippets/components/cta/index--liquid.tsx",
        lineNumber: 12,
        columnNumber: 9
    }, this);
}

},{"react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","../../../script/src/std/price":"bpfMV","../../../script/src/dom/library/DomComponent":"8H9za","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7xSQR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StickyPanel", function() {
    return StickyPanel;
});
parcelHelpers.export(exports, "useStickyPanel", function() {
    return useStickyPanel;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _domArray = require("../../../../script/src/dom/library/DomArray");
var _domComponent = require("../../../../script/src/dom/library/DomComponent");
var _hooks = require("../../../../script/src/std/hooks");
var _domElement = require("../../../../script/src/dom/library/DomElement");
var _state = require("../state");
var _toggle = require("../useCases/toggle");
function StickyPanel() {
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domArray.DomArray), {
        selector: ".componentStickyPanel",
        discriminator: "data-key",
        child: function(param) {
            var key = param.key, selector = param.selector;
            return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(Element, {
                selector: selector,
                componentId: key
            }, key, false, {
                fileName: "src/snippets/components/stickyPanel/liquid/index.tsx",
                lineNumber: 17,
                columnNumber: 107
            }, void 0);
        }
    }, void 0, false, {
        fileName: "src/snippets/components/stickyPanel/liquid/index.tsx",
        lineNumber: 17,
        columnNumber: 9
    }, this);
}
function useStickyPanel(selector) {
    var dispatch = (0, _hooks.useDispatch)();
    var componentId = (0, _domElement.useAttributeValue)('data-key', selector);
    var state = (0, _hooks.useSelector)(function(state) {
        return (0, _state.stickyPanelSelector)(state, componentId);
    });
    function toggle() {
        dispatch((0, _toggle.Toggle)({
            componentId: componentId
        }));
    }
    return {
        toggle: toggle,
        state: state
    };
}
function Element(props) {
    var dispatch = (0, _hooks.useDispatch)();
    var state = (0, _hooks.useSelector)(function(state) {
        return (0, _state.stickyPanelSelector)(state, props.componentId);
    });
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), hidden = _useState[0], setHidden = _useState[1];
    var opened = state.opened;
    var relativeTo = (0, _domElement.useAttributeValue)('data-relative_to', props.selector);
    var mode = (0, _domElement.useAttributeValue)('data-mode', props.selector);
    var toggleable = (0, _domElement.useBooleanAttributeValue)('data-toggleable', props.selector);
    (0, _hooks.useOnElementAboveScreen)(relativeTo, function(isAboveScreen) {
        return mode === 'above' && setHidden(!isAboveScreen);
    });
    (0, _hooks.useSectionIsVisible)(relativeTo, function(isVisible) {
        return mode === 'section' && setHidden(!isVisible);
    });
    (0, _hooks.usePreventBackgroundScroll)(toggleable && opened);
    function toggle() {
        dispatch((0, _toggle.Toggle)({
            componentId: props.componentId
        }));
    }
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
        selector: props.selector,
        data: {
            hidden: hidden,
            opened: opened
        },
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
                selector: "[data-id=overlay]",
                onClick: toggle
            }, void 0, false, {
                fileName: "src/snippets/components/stickyPanel/liquid/index.tsx",
                lineNumber: 58,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
                selector: "[data-id=toggleButton]",
                onClick: toggle
            }, void 0, false, {
                fileName: "src/snippets/components/stickyPanel/liquid/index.tsx",
                lineNumber: 59,
                columnNumber: 13
            }, this)
        ]
    }, void 0, true, {
        fileName: "src/snippets/components/stickyPanel/liquid/index.tsx",
        lineNumber: 57,
        columnNumber: 9
    }, this);
}

},{"@swc/helpers/_/_sliced_to_array":"ha6sq","react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","../../../../script/src/dom/library/DomArray":"ZEl1X","../../../../script/src/dom/library/DomComponent":"8H9za","../../../../script/src/std/hooks":"j9RPQ","../../../../script/src/dom/library/DomElement":"15N7Q","../state":"bTsl6","../useCases/toggle":"95aDF","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"bTsl6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "stickyPanelReducer", function() {
    return stickyPanelReducer;
});
parcelHelpers.export(exports, "stickyPanelSelector", function() {
    return stickyPanelSelector;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _toggle = require("../useCases/toggle");
var initialState = {
    panels: {}
};
var initialPanelState = {
    opened: false
};
function stickyPanelReducer() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, event = arguments.length > 1 ? arguments[1] : void 0;
    switch(event.type){
        case 0, _toggle.ToggleKey:
            return toggle(event);
        default:
            return state;
    }
    function toggle(event) {
        var _state_panels_event_payload_componentId;
        var panel = (_state_panels_event_payload_componentId = state.panels[event.payload.componentId]) !== null && _state_panels_event_payload_componentId !== void 0 ? _state_panels_event_payload_componentId : initialPanelState;
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
            panels: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.panels), (0, _defineProperty._)({}, event.payload.componentId, (0, _objectSpreadProps._)((0, _objectSpread._)({}, panel), {
                opened: !panel.opened
            })))
        });
    }
}
function stickyPanelSelector(state, componentId) {
    var _state_components_stickyPanel_panels_componentId;
    return (_state_components_stickyPanel_panels_componentId = state.components.stickyPanel.panels[componentId]) !== null && _state_components_stickyPanel_panels_componentId !== void 0 ? _state_components_stickyPanel_panels_componentId : initialPanelState;
}

},{"@swc/helpers/_/_define_property":"54Zvk","@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_object_spread_props":"fLCYP","../useCases/toggle":"95aDF","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"95aDF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ToggleKey", function() {
    return ToggleKey;
});
parcelHelpers.export(exports, "Toggle", function() {
    return Toggle;
});
var _eventFactory = require("../../../../script/src/std/eventFactory");
var ToggleKey = 'ComponentStickyPanel.Toggle';
var Toggle = (0, _eventFactory.eventFactory)(ToggleKey)();

},{"../../../../script/src/std/eventFactory":"f2PpV","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8Bmga":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Cart", function() {
    return Cart;
});
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _cartView = require("../view/cartView");
var _hooks = require("../../../../script/src/std/hooks");
var _reactTransitionGroup = require("react-transition-group");
var _circleLoader = require("../../circleLoader");
var _useShopifyAsset = require("../../../../script/src/dom/hooks/useShopifyAsset");
var _loadCart = require("../useCases/loadCart");
var _startCheckout = require("../../../../script/src/app/useCases/startCheckout");
var _indexReact = require("../../cta/index--react");
var _domPortal = require("../../../../script/src/dom/library/DomPortal");
var _openCart = require("../useCases/openCart");
var _closeCart = require("../useCases/closeCart");
var _upsell = require("./upsell");
var _freeShippingProgress = require("./freeShippingProgress");
var _subscriptionItems = require("./subscriptionItems");
var _oneTimeItems = require("./oneTimeItems");
function Cart() {
    var view = (0, _reactRedux.useSelector)((0, _cartView.cartView));
    init();
    var _view_opened;
    (0, _hooks.usePreventBackgroundScroll)((_view_opened = view === null || view === void 0 ? void 0 : view.opened) !== null && _view_opened !== void 0 ? _view_opened : false);
    if (!view) return null;
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domPortal.DomPortal), {
        selector: "#cart",
        children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(CartContainer, {
            view: view
        }, void 0, false, {
            fileName: "src/snippets/components/cart/liquid/index.tsx",
            lineNumber: 31,
            columnNumber: 13
        }, this)
    }, void 0, false, {
        fileName: "src/snippets/components/cart/liquid/index.tsx",
        lineNumber: 30,
        columnNumber: 9
    }, this);
}
function init() {
    var dispatch = (0, _hooks.useDispatch)();
    (0, _react.useEffect)(function() {
        if (getParam('cart')) dispatch((0, _openCart.OpenCart)());
        dispatch((0, _loadCart.LoadCart)());
    }, []);
    function getParam(name) {
        var paramsString = window.location.search.substr(1);
        var value = new URLSearchParams(paramsString).get(name);
        return value === '' ? true : value;
    }
}
function CartContainer(props) {
    var view = props.view;
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _reactTransitionGroup.CSSTransition), {
        in: view.opened,
        timeout: 300,
        classNames: "cart",
        mountOnEnter: true,
        unmountOnExit: true,
        children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
            className: "cart",
            children: [
                /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(Overlay, {}, void 0, false, {
                    fileName: "src/snippets/components/cart/liquid/index.tsx",
                    lineNumber: 67,
                    columnNumber: 17
                }, this),
                /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                    className: "wrap-container",
                    children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                        className: "container",
                        children: [
                            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(Header, {}, void 0, false, {
                                fileName: "src/snippets/components/cart/liquid/index.tsx",
                                lineNumber: 70,
                                columnNumber: 25
                            }, this),
                            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                                className: "cart-content",
                                children: [
                                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _circleLoader.CircleLoader), {
                                        loading: view.updating,
                                        opacityLayer: true
                                    }, void 0, false, {
                                        fileName: "src/snippets/components/cart/liquid/index.tsx",
                                        lineNumber: 72,
                                        columnNumber: 29
                                    }, this),
                                    !view.items.length && /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(EmptyCartContent, {}, void 0, false, {
                                        fileName: "src/snippets/components/cart/liquid/index.tsx",
                                        lineNumber: 73,
                                        columnNumber: 52
                                    }, this),
                                    !!view.items.length && /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(CartContent, {}, void 0, false, {
                                        fileName: "src/snippets/components/cart/liquid/index.tsx",
                                        lineNumber: 74,
                                        columnNumber: 53
                                    }, this)
                                ]
                            }, void 0, true, {
                                fileName: "src/snippets/components/cart/liquid/index.tsx",
                                lineNumber: 71,
                                columnNumber: 25
                            }, this),
                            view.isEmpty && /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(EmptyCta, {}, void 0, false, {
                                fileName: "src/snippets/components/cart/liquid/index.tsx",
                                lineNumber: 76,
                                columnNumber: 42
                            }, this),
                            !view.isEmpty && /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(Checkout, {
                                view: view
                            }, void 0, false, {
                                fileName: "src/snippets/components/cart/liquid/index.tsx",
                                lineNumber: 77,
                                columnNumber: 43
                            }, this)
                        ]
                    }, void 0, true, {
                        fileName: "src/snippets/components/cart/liquid/index.tsx",
                        lineNumber: 69,
                        columnNumber: 21
                    }, this)
                }, void 0, false, {
                    fileName: "src/snippets/components/cart/liquid/index.tsx",
                    lineNumber: 68,
                    columnNumber: 17
                }, this)
            ]
        }, void 0, true, {
            fileName: "src/snippets/components/cart/liquid/index.tsx",
            lineNumber: 66,
            columnNumber: 13
        }, this)
    }, void 0, false, {
        fileName: "src/snippets/components/cart/liquid/index.tsx",
        lineNumber: 59,
        columnNumber: 9
    }, this);
}
function Overlay() {
    var dispatch = (0, _hooks.useDispatch)();
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
        className: "overlay",
        onClick: function() {
            return dispatch((0, _closeCart.CloseCart)());
        }
    }, void 0, false, {
        fileName: "src/snippets/components/cart/liquid/index.tsx",
        lineNumber: 89,
        columnNumber: 9
    }, this);
}
function Header() {
    var dispatch = (0, _hooks.useDispatch)();
    var shopifyAsset = (0, _useShopifyAsset.useShopifyAsset)();
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
        className: "header",
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("h3", {
                className: "header-title",
                children: "Panier"
            }, void 0, false, {
                fileName: "src/snippets/components/cart/liquid/index.tsx",
                lineNumber: 99,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("img", {
                className: "close",
                src: shopifyAsset('image_icon_close_blue_base.svg'),
                onClick: function() {
                    return dispatch((0, _closeCart.CloseCart)());
                }
            }, void 0, false, {
                fileName: "src/snippets/components/cart/liquid/index.tsx",
                lineNumber: 100,
                columnNumber: 13
            }, this)
        ]
    }, void 0, true, {
        fileName: "src/snippets/components/cart/liquid/index.tsx",
        lineNumber: 98,
        columnNumber: 9
    }, this);
}
function EmptyCartContent() {
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
        className: "empty",
        children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
            children: "Votre panier est vide"
        }, void 0, false, {
            fileName: "src/snippets/components/cart/liquid/index.tsx",
            lineNumber: 108,
            columnNumber: 13
        }, this)
    }, void 0, false, {
        fileName: "src/snippets/components/cart/liquid/index.tsx",
        lineNumber: 107,
        columnNumber: 9
    }, this);
}
function CartContent() {
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
        className: "items",
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _subscriptionItems.SubscriptionItems), {}, void 0, false, {
                fileName: "src/snippets/components/cart/liquid/index.tsx",
                lineNumber: 116,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _oneTimeItems.OneTimeItems), {}, void 0, false, {
                fileName: "src/snippets/components/cart/liquid/index.tsx",
                lineNumber: 117,
                columnNumber: 13
            }, this)
        ]
    }, void 0, true, {
        fileName: "src/snippets/components/cart/liquid/index.tsx",
        lineNumber: 115,
        columnNumber: 9
    }, this);
}
function Checkout(props) {
    var view = props.view;
    var dispatch = (0, _hooks.useDispatch)();
    function handleStartCheckout() {
        dispatch((0, _startCheckout.StartCheckout)());
    }
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
        className: "componentCart__checkout",
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _freeShippingProgress.FreeShippingProgress), {}, void 0, false, {
                fileName: "src/snippets/components/cart/liquid/index.tsx",
                lineNumber: 134,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _upsell.Upsell), {}, void 0, false, {
                fileName: "src/snippets/components/cart/liquid/index.tsx",
                lineNumber: 135,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _indexReact.ReactCta), {
                text: "Commander",
                className: "componentCart__checkout__cta",
                price: view.itemsTotalPrice,
                originalPrice: view.itemsOriginalPrice,
                onClick: handleStartCheckout,
                href: "/checkout",
                size: "XL"
            }, void 0, false, {
                fileName: "src/snippets/components/cart/liquid/index.tsx",
                lineNumber: 136,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("p", {
                className: "componentCart__checkout__deliveryInfo",
                children: [
                    "livraison ",
                    view.estimatedDelivery
                ]
            }, void 0, true, {
                fileName: "src/snippets/components/cart/liquid/index.tsx",
                lineNumber: 145,
                columnNumber: 13
            }, this)
        ]
    }, void 0, true, {
        fileName: "src/snippets/components/cart/liquid/index.tsx",
        lineNumber: 133,
        columnNumber: 9
    }, this);
}
function EmptyCta() {
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
        className: "discover-cta",
        children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("a", {
            className: "cta",
            href: "/collections/chien",
            children: "D\xe9couvrez les croquettes r\xe9glo"
        }, void 0, false, {
            fileName: "src/snippets/components/cart/liquid/index.tsx",
            lineNumber: 153,
            columnNumber: 13
        }, this)
    }, void 0, false, {
        fileName: "src/snippets/components/cart/liquid/index.tsx",
        lineNumber: 152,
        columnNumber: 9
    }, this);
}

},{"react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","react-redux":"ghMZu","../view/cartView":"6eowi","../../../../script/src/std/hooks":"j9RPQ","react-transition-group":"bay3k","../../circleLoader":"6ifIi","../../../../script/src/dom/hooks/useShopifyAsset":"aJ4wV","../useCases/loadCart":"3fYue","../../../../script/src/app/useCases/startCheckout":"dwgwB","../../cta/index--react":"2TBvE","../../../../script/src/dom/library/DomPortal":"6g2UR","../useCases/openCart":"cSUzZ","../useCases/closeCart":"nTTZT","./upsell":"cqzQ8","./freeShippingProgress":"iRHYx","./subscriptionItems":"k5u85","./oneTimeItems":"7WMeQ","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"bay3k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CSSTransition", function() {
    return 0, _csstransitionDefault.default;
});
parcelHelpers.export(exports, "ReplaceTransition", function() {
    return 0, _replaceTransitionDefault.default;
});
parcelHelpers.export(exports, "SwitchTransition", function() {
    return 0, _switchTransitionDefault.default;
});
parcelHelpers.export(exports, "TransitionGroup", function() {
    return 0, _transitionGroupDefault.default;
});
parcelHelpers.export(exports, "Transition", function() {
    return 0, _transitionDefault.default;
});
parcelHelpers.export(exports, "config", function() {
    return 0, _configDefault.default;
});
var _csstransition = require("./CSSTransition");
var _csstransitionDefault = parcelHelpers.interopDefault(_csstransition);
var _replaceTransition = require("./ReplaceTransition");
var _replaceTransitionDefault = parcelHelpers.interopDefault(_replaceTransition);
var _switchTransition = require("./SwitchTransition");
var _switchTransitionDefault = parcelHelpers.interopDefault(_switchTransition);
var _transitionGroup = require("./TransitionGroup");
var _transitionGroupDefault = parcelHelpers.interopDefault(_transitionGroup);
var _transition = require("./Transition");
var _transitionDefault = parcelHelpers.interopDefault(_transition);
var _config = require("./config");
var _configDefault = parcelHelpers.interopDefault(_config);

},{"./CSSTransition":"elbRR","./ReplaceTransition":false,"./SwitchTransition":false,"./TransitionGroup":false,"./Transition":false,"./config":false,"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"elbRR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _addClass = require("dom-helpers/addClass");
var _addClassDefault = parcelHelpers.interopDefault(_addClass);
var _removeClass = require("dom-helpers/removeClass");
var _removeClassDefault = parcelHelpers.interopDefault(_removeClass);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _transition = require("./Transition");
var _transitionDefault = parcelHelpers.interopDefault(_transition);
var _propTypes1 = require("./utils/PropTypes");
var _reflow = require("./utils/reflow");
var _addClass1 = function addClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, _addClassDefault.default)(node, c);
    });
};
var removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, _removeClassDefault.default)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */ var CSSTransition = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.appliedClasses = {
            appear: {},
            enter: {},
            exit: {}
        };
        _this.onEnter = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument[0], appearing = _this$resolveArgument[1];
            _this.removeClasses(node, 'exit');
            _this.addClass(node, appearing ? 'appear' : 'enter', 'base');
            if (_this.props.onEnter) _this.props.onEnter(maybeNode, maybeAppearing);
        };
        _this.onEntering = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument2[0], appearing = _this$resolveArgument2[1];
            var type = appearing ? 'appear' : 'enter';
            _this.addClass(node, type, 'active');
            if (_this.props.onEntering) _this.props.onEntering(maybeNode, maybeAppearing);
        };
        _this.onEntered = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument3[0], appearing = _this$resolveArgument3[1];
            var type = appearing ? 'appear' : 'enter';
            _this.removeClasses(node, type);
            _this.addClass(node, type, 'done');
            if (_this.props.onEntered) _this.props.onEntered(maybeNode, maybeAppearing);
        };
        _this.onExit = function(maybeNode) {
            var _this$resolveArgument4 = _this.resolveArguments(maybeNode), node = _this$resolveArgument4[0];
            _this.removeClasses(node, 'appear');
            _this.removeClasses(node, 'enter');
            _this.addClass(node, 'exit', 'base');
            if (_this.props.onExit) _this.props.onExit(maybeNode);
        };
        _this.onExiting = function(maybeNode) {
            var _this$resolveArgument5 = _this.resolveArguments(maybeNode), node = _this$resolveArgument5[0];
            _this.addClass(node, 'exit', 'active');
            if (_this.props.onExiting) _this.props.onExiting(maybeNode);
        };
        _this.onExited = function(maybeNode) {
            var _this$resolveArgument6 = _this.resolveArguments(maybeNode), node = _this$resolveArgument6[0];
            _this.removeClasses(node, 'exit');
            _this.addClass(node, 'exit', 'done');
            if (_this.props.onExited) _this.props.onExited(maybeNode);
        };
        _this.resolveArguments = function(maybeNode, maybeAppearing) {
            return _this.props.nodeRef ? [
                _this.props.nodeRef.current,
                maybeNode
            ] // here `maybeNode` is actually `appearing`
             : [
                maybeNode,
                maybeAppearing
            ];
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === 'string';
            var prefix = isStringClassNames && classNames ? classNames + "-" : '';
            var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
            return {
                baseClassName: baseClassName,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.addClass = function addClass(node, type, phase) {
        var className = this.getClassNames(type)[phase + "ClassName"];
        var _this$getClassNames = this.getClassNames('enter'), doneClassName = _this$getClassNames.doneClassName;
        if (type === 'appear' && phase === 'done' && doneClassName) className += " " + doneClassName;
         // This is to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (phase === 'active') {
            if (node) (0, _reflow.forceReflow)(node);
        }
        if (className) {
            this.appliedClasses[type][phase] = className;
            _addClass1(node, className);
        }
    };
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$appliedClasses$ = this.appliedClasses[type], baseClassName = _this$appliedClasses$.base, activeClassName = _this$appliedClasses$.active, doneClassName = _this$appliedClasses$.done;
        this.appliedClasses[type] = {};
        if (baseClassName) removeClass(node, baseClassName);
        if (activeClassName) removeClass(node, activeClassName);
        if (doneClassName) removeClass(node, doneClassName);
    };
    _proto.render = function render() {
        var _this$props = this.props, _ = _this$props.classNames, props = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props, [
            "classNames"
        ]);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _transitionDefault.default), (0, _extendsDefault.default)({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}((0, _reactDefault.default).Component);
CSSTransition.defaultProps = {
    classNames: ''
};
CSSTransition.propTypes = (0, _extendsDefault.default)({}, (0, _transitionDefault.default).propTypes, {
    /**
   * The animation classNames applied to the component as it appears, enters,
   * exits or has finished the transition. A single name can be provided, which
   * will be suffixed for each stage, e.g. `classNames="fade"` applies:
   *
   * - `fade-appear`, `fade-appear-active`, `fade-appear-done`
   * - `fade-enter`, `fade-enter-active`, `fade-enter-done`
   * - `fade-exit`, `fade-exit-active`, `fade-exit-done`
   *
   * A few details to note about how these classes are applied:
   *
   * 1. They are _joined_ with the ones that are already defined on the child
   *    component, so if you want to add some base styles, you can use
   *    `className` without worrying that it will be overridden.
   *
   * 2. If the transition component mounts with `in={false}`, no classes are
   *    applied yet. You might be expecting `*-exit-done`, but if you think
   *    about it, a component cannot finish exiting if it hasn't entered yet.
   *
   * 2. `fade-appear-done` and `fade-enter-done` will _both_ be applied. This
   *    allows you to define different behavior for when appearing is done and
   *    when regular entering is done, using selectors like
   *    `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply
   *    an epic entrance animation when element first appears in the DOM using
   *    [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   *    simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */ classNames: (0, _propTypes1.classNamesShape),
    /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */ onEnter: (0, _propTypesDefault.default).func,
    /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */ onEntering: (0, _propTypesDefault.default).func,
    /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */ onEntered: (0, _propTypesDefault.default).func,
    /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */ onExit: (0, _propTypesDefault.default).func,
    /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */ onExiting: (0, _propTypesDefault.default).func,
    /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */ onExited: (0, _propTypesDefault.default).func
});
exports.default = CSSTransition;

},{"@babel/runtime/helpers/esm/extends":"jSPXj","@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dAnBs","@babel/runtime/helpers/esm/inheritsLoose":"d2pAB","prop-types":"6jeze","dom-helpers/addClass":"k2JfW","dom-helpers/removeClass":"kCHEi","react":"c8CN1","./Transition":"bUYVy","./utils/PropTypes":"7XGY5","./utils/reflow":"iBP0A","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"d2pAB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return _inheritsLoose;
});
var _setPrototypeOfJs = require("./setPrototypeOf.js");
var _setPrototypeOfJsDefault = parcelHelpers.interopDefault(_setPrototypeOfJs);
function _inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, _setPrototypeOfJsDefault.default)(t, o);
}

},{"./setPrototypeOf.js":"lPZGv","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"k2JfW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return addClass;
});
var _hasClass = require("./hasClass");
var _hasClassDefault = parcelHelpers.interopDefault(_hasClass);
function addClass(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, _hasClassDefault.default)(element, className)) {
        if (typeof element.className === 'string') element.className = element.className + " " + className;
        else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
    }
}

},{"./hasClass":"iwrDu","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"iwrDu":[function(require,module,exports,__globalThis) {
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return hasClass;
});
function hasClass(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"kCHEi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return removeClass;
});
function replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
function removeClass(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);
    else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"bUYVy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UNMOUNTED", function() {
    return UNMOUNTED;
});
parcelHelpers.export(exports, "EXITED", function() {
    return EXITED;
});
parcelHelpers.export(exports, "ENTERING", function() {
    return ENTERING;
});
parcelHelpers.export(exports, "ENTERED", function() {
    return ENTERED;
});
parcelHelpers.export(exports, "EXITING", function() {
    return EXITING;
});
var _objectWithoutPropertiesLoose = require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose");
var _objectWithoutPropertiesLooseDefault = parcelHelpers.interopDefault(_objectWithoutPropertiesLoose);
var _inheritsLoose = require("@babel/runtime/helpers/esm/inheritsLoose");
var _inheritsLooseDefault = parcelHelpers.interopDefault(_inheritsLoose);
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var _config = require("./config");
var _configDefault = parcelHelpers.interopDefault(_config);
var _propTypes1 = require("./utils/PropTypes");
var _transitionGroupContext = require("./TransitionGroupContext");
var _transitionGroupContextDefault = parcelHelpers.interopDefault(_transitionGroupContext);
var _reflow = require("./utils/reflow");
var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var Transition = /*#__PURE__*/ function(_React$Component) {
    (0, _inheritsLooseDefault.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = EXITED;
                _this.appearStatus = ENTERING;
            } else initialStatus = ENTERED;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = UNMOUNTED;
        else initialStatus = EXITED;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === UNMOUNTED) return {
            status: EXITED
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== ENTERING && status !== ENTERED) nextStatus = ENTERING;
            } else if (status === ENTERING || status === ENTERED) nextStatus = EXITING;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === ENTERING) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, _reactDomDefault.default).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, _reflow.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === EXITED) this.setState({
            status: UNMOUNTED
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, _reactDomDefault.default).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, _configDefault.default).disabled) {
            this.safeSetState({
                status: ENTERED
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: ENTERING
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: ENTERED
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, _reactDomDefault.default).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, _configDefault.default).disabled) {
            this.safeSetState({
                status: EXITED
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: EXITING
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: EXITED
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, _reactDomDefault.default).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === UNMOUNTED) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, _objectWithoutPropertiesLooseDefault.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, _reactDefault.default).createElement((0, _transitionGroupContextDefault.default).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, _reactDefault.default).cloneElement((0, _reactDefault.default).Children.only(children), childProps)));
    };
    return Transition;
}((0, _reactDefault.default).Component);
Transition.contextType = (0, _transitionGroupContextDefault.default);
Transition.propTypes = {
    /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */ nodeRef: (0, _propTypesDefault.default).shape({
        current: typeof Element === 'undefined' ? (0, _propTypesDefault.default).any : function(propValue, key, componentName, location, propFullName, secret) {
            var value = propValue[key];
            return (0, _propTypesDefault.default).instanceOf(value && 'ownerDocument' in value ? value.ownerDocument.defaultView.Element : Element)(propValue, key, componentName, location, propFullName, secret);
        }
    }),
    /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */ children: (0, _propTypesDefault.default).oneOfType([
        (0, _propTypesDefault.default).func.isRequired,
        (0, _propTypesDefault.default).element.isRequired
    ]).isRequired,
    /**
   * Show the component; triggers the enter or exit states
   */ in: (0, _propTypesDefault.default).bool,
    /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */ mountOnEnter: (0, _propTypesDefault.default).bool,
    /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */ unmountOnExit: (0, _propTypesDefault.default).bool,
    /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */ appear: (0, _propTypesDefault.default).bool,
    /**
   * Enable or disable enter transitions.
   */ enter: (0, _propTypesDefault.default).bool,
    /**
   * Enable or disable exit transitions.
   */ exit: (0, _propTypesDefault.default).bool,
    /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */ timeout: function timeout(props) {
        var pt = (0, _propTypes1.timeoutsShape);
        if (!props.addEndListener) pt = pt.isRequired;
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return pt.apply(void 0, [
            props
        ].concat(args));
    },
    /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */ addEndListener: (0, _propTypesDefault.default).func,
    /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */ onEnter: (0, _propTypesDefault.default).func,
    /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */ onEntering: (0, _propTypesDefault.default).func,
    /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */ onEntered: (0, _propTypesDefault.default).func,
    /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */ onExit: (0, _propTypesDefault.default).func,
    /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */ onExiting: (0, _propTypesDefault.default).func,
    /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */ onExited: (0, _propTypesDefault.default).func
}; // Name the function so it is clearer in the documentation
function noop() {}
Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: noop,
    onEntering: noop,
    onEntered: noop,
    onExit: noop,
    onExiting: noop,
    onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
exports.default = Transition;

},{"@babel/runtime/helpers/esm/objectWithoutPropertiesLoose":"dAnBs","@babel/runtime/helpers/esm/inheritsLoose":"d2pAB","prop-types":"6jeze","react":"c8CN1","react-dom":"kFYAC","./config":"iRsJW","./utils/PropTypes":"7XGY5","./TransitionGroupContext":"k5ECN","./utils/reflow":"iBP0A","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"iRsJW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    disabled: false
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7XGY5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeoutsShape", function() {
    return timeoutsShape;
});
parcelHelpers.export(exports, "classNamesShape", function() {
    return classNamesShape;
});
var _propTypes = require("prop-types");
var _propTypesDefault = parcelHelpers.interopDefault(_propTypes);
var timeoutsShape = (0, _propTypesDefault.default).oneOfType([
    (0, _propTypesDefault.default).number,
    (0, _propTypesDefault.default).shape({
        enter: (0, _propTypesDefault.default).number,
        exit: (0, _propTypesDefault.default).number,
        appear: (0, _propTypesDefault.default).number
    }).isRequired
]);
var classNamesShape = (0, _propTypesDefault.default).oneOfType([
    (0, _propTypesDefault.default).string,
    (0, _propTypesDefault.default).shape({
        enter: (0, _propTypesDefault.default).string,
        exit: (0, _propTypesDefault.default).string,
        active: (0, _propTypesDefault.default).string
    }),
    (0, _propTypesDefault.default).shape({
        enter: (0, _propTypesDefault.default).string,
        enterDone: (0, _propTypesDefault.default).string,
        enterActive: (0, _propTypesDefault.default).string,
        exit: (0, _propTypesDefault.default).string,
        exitDone: (0, _propTypesDefault.default).string,
        exitActive: (0, _propTypesDefault.default).string
    })
]);

},{"prop-types":"6jeze","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"k5ECN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
exports.default = (0, _reactDefault.default).createContext(null);

},{"react":"c8CN1","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"iBP0A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "forceReflow", function() {
    return forceReflow;
});
var forceReflow = function forceReflow(node) {
    return node.scrollTop;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"dwgwB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StartCheckoutKey", function() {
    return StartCheckoutKey;
});
parcelHelpers.export(exports, "StartCheckout", function() {
    return StartCheckout;
});
parcelHelpers.export(exports, "startCheckout", function() {
    return startCheckout;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _std = require("@reglo/std");
var StartCheckoutKey = 'StartCheckout';
var StartCheckout = (0, _std.eventFactory)(StartCheckoutKey)();
function startCheckout(deps) {
    return /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(event) {
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            deps.track('StartCheckout')
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }();
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_ts_generator":"f2hGH","@reglo/std":"1USo0","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2TBvE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactCta", function() {
    return ReactCta;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _price = require("../../../script/src/std/price");
var _std = require("@reglo/std");
function ReactCta(props) {
    var _this = this;
    var hasPrice = !!props.price;
    var hasOriginalPrice = !!props.originalPrice && props.price !== props.originalPrice;
    var _props_priceBreakpoint;
    var priceBreakpoint = (_props_priceBreakpoint = props.priceBreakpoint) !== null && _props_priceBreakpoint !== void 0 ? _props_priceBreakpoint : 'xs-up';
    var _props_pricePosition;
    var pricePosition = (_props_pricePosition = props.pricePosition) !== null && _props_pricePosition !== void 0 ? _props_pricePosition : 'right';
    var _props_className;
    var _obj;
    var classes = (0, _classnamesDefault.default)((_obj = {}, (0, _defineProperty._)(_obj, (_props_className = props.className) !== null && _props_className !== void 0 ? _props_className : '', true), (0, _defineProperty._)(_obj, `componentCta`, true), (0, _defineProperty._)(_obj, `componentCta--size--${props.size}`, !!props.size), (0, _defineProperty._)(_obj, `componentCta--pricePosition--${pricePosition}`, hasPrice), (0, _defineProperty._)(_obj, `componentCta--priceBreakpoint--${priceBreakpoint}`, hasPrice), _obj));
    var priceElement = function() {
        return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
            className: "componentCta__price",
            children: [
                /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                    className: "componentCta__newPrice",
                    "data-id": "newPrice",
                    children: (0, _price.formatPrice)((0, _std.unwrap)(props.price))
                }, void 0, false, {
                    fileName: "src/snippets/components/cta/index--react.tsx",
                    lineNumber: 33,
                    columnNumber: 13
                }, _this),
                hasOriginalPrice && /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                    className: "componentCta__originalPrice",
                    "data-id": "originalPrice",
                    children: (0, _price.formatPrice)((0, _std.unwrap)(props.originalPrice))
                }, void 0, false, {
                    fileName: "src/snippets/components/cta/index--react.tsx",
                    lineNumber: 34,
                    columnNumber: 34
                }, _this)
            ]
        }, void 0, true, {
            fileName: "src/snippets/components/cta/index--react.tsx",
            lineNumber: 32,
            columnNumber: 9
        }, _this);
    };
    var attributes = {
        className: classes,
        'data-id': props.dataId,
        'data-disabled': props.isDisabled ? '' : undefined,
        'data-with_price': hasPrice ? '' : undefined,
        'data-with_original_price': hasOriginalPrice ? '' : undefined,
        onClick: props.onClick
    };
    var root = function(content) {
        return props.href ? /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("a", (0, _objectSpreadProps._)((0, _objectSpread._)({
            href: props.href
        }, attributes), {
            children: content
        }), void 0, false, {
            fileName: "src/snippets/components/cta/index--react.tsx",
            lineNumber: 48,
            columnNumber: 11
        }, _this) : /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", (0, _objectSpreadProps._)((0, _objectSpread._)({}, attributes), {
            children: content
        }), void 0, false, {
            fileName: "src/snippets/components/cta/index--react.tsx",
            lineNumber: 49,
            columnNumber: 11
        }, _this);
    };
    return root(/*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _jsxDevRuntime.Fragment), {
        children: [
            hasPrice && pricePosition === 'left' && priceElement(),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                className: "componentCta__text",
                children: props.text
            }, void 0, false, {
                fileName: "src/snippets/components/cta/index--react.tsx",
                lineNumber: 53,
                columnNumber: 9
            }, this),
            hasPrice && pricePosition === 'right' && priceElement()
        ]
    }, void 0, true));
}

},{"@swc/helpers/_/_define_property":"54Zvk","@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_object_spread_props":"fLCYP","react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","classnames":"4SuBi","../../../script/src/std/price":"bpfMV","@reglo/std":"1USo0","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6g2UR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DomPortal", function() {
    return DomPortal;
});
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _domElement = require("./DomElement");
var _std = require("@reglo/std");
var _reactDom = require("react-dom");
function DomPortal(props) {
    var element = (0, _domElement.useDomElement)(props.selector).element;
    return /*#__PURE__*/ (0, _reactDom.createPortal)(props.children, (0, _std.unwrap)(element));
}

},{"react":"c8CN1","./DomElement":"15N7Q","@reglo/std":"1USo0","react-dom":"kFYAC","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"cqzQ8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Upsell", function() {
    return Upsell;
});
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _reactRedux = require("react-redux");
var _upsellView = require("../view/upsellView");
var _hooks = require("../../../../script/src/std/hooks");
var _swiperReact = require("swiper/swiper-react");
var _price = require("../../../../script/src/std/price");
var _indexReact = require("../../cta/index--react");
var _addProductToCart = require("../useCases/addProductToCart");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _modules = require("swiper/modules");
function Upsell() {
    var _this = this;
    var view = (0, _reactRedux.useSelector)((0, _upsellView.upsellView));
    if (!view || view.items.length === 0) return null;
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
        className: "componentCart__upsell",
        children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
            className: "componentCart__upsell__items",
            children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _swiperReact.Swiper), {
                modules: [
                    (0, _modules.Pagination),
                    (0, _modules.Mousewheel),
                    (0, _modules.Navigation)
                ],
                slidesPerView: 1.3,
                pagination: true,
                navigation: view.items.length > 1,
                mousewheel: true,
                loop: true,
                children: view.items.map(function(item, index) {
                    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _swiperReact.SwiperSlide), {
                        className: "componentCart__upsell__itemContainer",
                        children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(Item, {
                            view: item
                        }, void 0, false, {
                            fileName: "src/snippets/components/cart/liquid/upsell.tsx",
                            lineNumber: 32,
                            columnNumber: 29
                        }, _this)
                    }, `${item.variantId}_${index}`, false, {
                        fileName: "src/snippets/components/cart/liquid/upsell.tsx",
                        lineNumber: 31,
                        columnNumber: 25
                    }, _this);
                })
            }, void 0, false, {
                fileName: "src/snippets/components/cart/liquid/upsell.tsx",
                lineNumber: 22,
                columnNumber: 17
            }, this)
        }, void 0, false, {
            fileName: "src/snippets/components/cart/liquid/upsell.tsx",
            lineNumber: 21,
            columnNumber: 13
        }, this)
    }, void 0, false, {
        fileName: "src/snippets/components/cart/liquid/upsell.tsx",
        lineNumber: 20,
        columnNumber: 9
    }, this);
}
function Item(props) {
    var dispatch = (0, _hooks.useDispatch)();
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
        className: "componentCart__upsell__item",
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("a", {
                className: "componentCart__upsell__item__pictureContainer",
                href: props.view.url,
                children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("img", {
                    src: props.view.picture
                }, void 0, false, {
                    fileName: "src/snippets/components/cart/liquid/upsell.tsx",
                    lineNumber: 49,
                    columnNumber: 17
                }, this)
            }, void 0, false, {
                fileName: "src/snippets/components/cart/liquid/upsell.tsx",
                lineNumber: 48,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                className: "componentCart__upsell__item__content",
                children: [
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("a", {
                        href: props.view.url,
                        children: [
                            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                                className: "componentCart__upsell__item__title",
                                children: props.view.upsellTitle
                            }, void 0, false, {
                                fileName: "src/snippets/components/cart/liquid/upsell.tsx",
                                lineNumber: 53,
                                columnNumber: 21
                            }, this),
                            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                                className: "componentCart__upsell__item__detail",
                                children: props.view.upsellDescription
                            }, void 0, false, {
                                fileName: "src/snippets/components/cart/liquid/upsell.tsx",
                                lineNumber: 54,
                                columnNumber: 21
                            }, this)
                        ]
                    }, void 0, true, {
                        fileName: "src/snippets/components/cart/liquid/upsell.tsx",
                        lineNumber: 52,
                        columnNumber: 17
                    }, this),
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                        className: "componentCart__upsell__item__ctaContainer",
                        children: [
                            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                                className: "componentCart__upsell__item__price",
                                children: (0, _price.formatPrice)(props.view.price.oneTime)
                            }, void 0, false, {
                                fileName: "src/snippets/components/cart/liquid/upsell.tsx",
                                lineNumber: 57,
                                columnNumber: 21
                            }, this),
                            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _indexReact.ReactCta), {
                                text: "Ajouter",
                                onClick: function() {
                                    return dispatch((0, _addProductToCart.AddProductToCart)({
                                        quantity: 1,
                                        variantId: props.view.variantId,
                                        subscriptionPlanId: null,
                                        source: 'cartUpsell'
                                    }));
                                },
                                size: "XS"
                            }, void 0, false, {
                                fileName: "src/snippets/components/cart/liquid/upsell.tsx",
                                lineNumber: 58,
                                columnNumber: 21
                            }, this)
                        ]
                    }, void 0, true, {
                        fileName: "src/snippets/components/cart/liquid/upsell.tsx",
                        lineNumber: 56,
                        columnNumber: 17
                    }, this)
                ]
            }, void 0, true, {
                fileName: "src/snippets/components/cart/liquid/upsell.tsx",
                lineNumber: 51,
                columnNumber: 13
            }, this)
        ]
    }, void 0, true, {
        fileName: "src/snippets/components/cart/liquid/upsell.tsx",
        lineNumber: 47,
        columnNumber: 9
    }, this);
}

},{"react/jsx-dev-runtime":"jXZ8I","react-redux":"ghMZu","../view/upsellView":"dnmge","../../../../script/src/std/hooks":"j9RPQ","swiper/swiper-react":"4H3gu","../../../../script/src/std/price":"bpfMV","../../cta/index--react":"2TBvE","../useCases/addProductToCart":"bC9NF","react":"c8CN1","swiper/modules":"4UOSx","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"dnmge":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "upsellView", function() {
    return upsellView;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _reselect = require("reselect");
var _variants = require("../../../../script/src/app/store/state/data/variants");
var _state = require("../state");
var _std = require("@reglo/std");
var upsellView = (0, _reselect.createSelector)((0, _state.cartSelector), (0, _variants.variantsSelector), prepareView);
var SKUS = [
    (0, _std.SKU).CHIEN_BISCUITS,
    (0, _std.SKU).CHIEN_STICK_SM,
    (0, _std.SKU).CHIEN_STICK_L
];
function prepareView(cartState, variantsState) {
    if (notLoaded()) return null;
    return {
        items: prepareItems()
    };
    function prepareItems() {
        return (0, _std.chain)(SKUS).then(skusToVariants).then(removeAlreadyInCart).then(orderFromSmallDogsToLargeDogs).unwrap();
    }
    function skusToVariants(skus) {
        return skus.map(function(sku) {
            return (0, _std.unwrap)((0, _variants.selectVariantInStateBySku)(variantsState, sku));
        });
    }
    function orderFromSmallDogsToLargeDogs(variants) {
        return (0, _toConsumableArray._)(variants).sort(function(a, b) {
            var _a_dogSize, _b_dogSize, _a_dogSize1, _a_dogSize2, _b_dogSize1, _b_dogSize2;
            var aIsLarge = (_a_dogSize = a.dogSize) === null || _a_dogSize === void 0 ? void 0 : _a_dogSize.includes((0, _std.DogSize).Large);
            var bIsLarge = (_b_dogSize = b.dogSize) === null || _b_dogSize === void 0 ? void 0 : _b_dogSize.includes((0, _std.DogSize).Large);
            var aIsSmallOrMedium = ((_a_dogSize1 = a.dogSize) === null || _a_dogSize1 === void 0 ? void 0 : _a_dogSize1.includes((0, _std.DogSize).Small)) || ((_a_dogSize2 = a.dogSize) === null || _a_dogSize2 === void 0 ? void 0 : _a_dogSize2.includes((0, _std.DogSize).Medium));
            var bIsSmallOrMedium = ((_b_dogSize1 = b.dogSize) === null || _b_dogSize1 === void 0 ? void 0 : _b_dogSize1.includes((0, _std.DogSize).Small)) || ((_b_dogSize2 = b.dogSize) === null || _b_dogSize2 === void 0 ? void 0 : _b_dogSize2.includes((0, _std.DogSize).Medium));
            if (hasLargeDogItemsInCart()) {
                if (aIsLarge && bIsLarge) return 0;
                if (aIsLarge) return -1;
            }
            if (!hasLargeDogItemsInCart()) {
                if (aIsSmallOrMedium && bIsSmallOrMedium) return 0;
                if (aIsSmallOrMedium) return -1;
            }
            return 1;
        });
    }
    function hasLargeDogItemsInCart() {
        return !!(0, _std.unwrap)(cartState.initialContent).find(function(item) {
            var _variant_dogSize;
            var variant = (0, _std.unwrap)((0, _variants.selectVariantInState)(variantsState, item.variantId));
            return (_variant_dogSize = variant.dogSize) === null || _variant_dogSize === void 0 ? void 0 : _variant_dogSize.includes((0, _std.DogSize).Large);
        });
    }
    function notLoaded() {
        return (0, variantsState.loading) || cartState.loading || !cartState.initialContent;
    }
    function removeAlreadyInCart(variants) {
        return variants.filter(function(variant) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = (0, _std.unwrap)(cartState.initialContent)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var cartItem = _step.value;
                    var cartItemVariant = (0, _std.unwrap)((0, _variants.selectVariantInState)(variantsState, cartItem.variantId));
                    if (variant.productId === cartItemVariant.productId) return false;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return true;
        });
    }
}

},{"@swc/helpers/_/_to_consumable_array":"eqNDD","reselect":"fb6q1","../../../../script/src/app/store/state/data/variants":"11hc8","../state":"1HyQc","@reglo/std":"1USo0","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4H3gu":[function(require,module,exports,__globalThis) {
/**
 * Swiper React 11.2.6
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2025 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: March 19, 2025
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Swiper", function() {
    return Swiper;
});
parcelHelpers.export(exports, "SwiperSlide", function() {
    return SwiperSlide;
});
parcelHelpers.export(exports, "useSwiper", function() {
    return useSwiper;
});
parcelHelpers.export(exports, "useSwiperSlide", function() {
    return useSwiperSlide;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _swiperCoreMjs = require("./shared/swiper-core.mjs");
var _updateOnVirtualDataMjs = require("./shared/update-on-virtual-data.mjs");
var _updateSwiperMjs = require("./shared/update-swiper.mjs");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function isChildSwiperSlide(child) {
    return child.type && child.type.displayName && child.type.displayName.includes('SwiperSlide');
}
function processChildren(c) {
    var slides = [];
    (0, _reactDefault.default).Children.toArray(c).forEach(function(child) {
        if (isChildSwiperSlide(child)) slides.push(child);
        else if (child.props && child.props.children) processChildren(child.props.children).forEach(function(slide) {
            return slides.push(slide);
        });
    });
    return slides;
}
function getChildren(c) {
    var slides = [];
    var slots = {
        'container-start': [],
        'container-end': [],
        'wrapper-start': [],
        'wrapper-end': []
    };
    (0, _reactDefault.default).Children.toArray(c).forEach(function(child) {
        if (isChildSwiperSlide(child)) slides.push(child);
        else if (child.props && child.props.slot && slots[child.props.slot]) slots[child.props.slot].push(child);
        else if (child.props && child.props.children) {
            var foundSlides = processChildren(child.props.children);
            if (foundSlides.length > 0) foundSlides.forEach(function(slide) {
                return slides.push(slide);
            });
            else slots['container-end'].push(child);
        } else slots['container-end'].push(child);
    });
    return {
        slides: slides,
        slots: slots
    };
}
function renderVirtual(swiper, slides, virtualData) {
    if (!virtualData) return null;
    var getSlideIndex = function(index) {
        var slideIndex = index;
        if (index < 0) slideIndex = slides.length + index;
        else if (slideIndex >= slides.length) // eslint-disable-next-line
        slideIndex = slideIndex - slides.length;
        return slideIndex;
    };
    var style = swiper.isHorizontal() ? (0, _defineProperty._)({}, swiper.rtlTranslate ? 'right' : 'left', `${virtualData.offset}px`) : {
        top: `${virtualData.offset}px`
    };
    var from = virtualData.from, to = virtualData.to;
    var loopFrom = swiper.params.loop ? -slides.length : 0;
    var loopTo = swiper.params.loop ? slides.length * 2 : slides.length;
    var slidesToRender = [];
    for(var i = loopFrom; i < loopTo; i += 1)if (i >= from && i <= to) slidesToRender.push(slides[getSlideIndex(i)]);
    return slidesToRender.map(function(child, index) {
        return /*#__PURE__*/ (0, _reactDefault.default).cloneElement(child, {
            swiper: swiper,
            style: style,
            key: child.props.virtualIndex || child.key || `slide-${index}`
        });
    });
}
function useIsomorphicLayoutEffect(callback, deps) {
    // eslint-disable-next-line
    if (typeof window === 'undefined') return (0, _react.useEffect)(callback, deps);
    return (0, _react.useLayoutEffect)(callback, deps);
}
var SwiperSlideContext = /*#__PURE__*/ (0, _react.createContext)(null);
var useSwiperSlide = function() {
    return (0, _react.useContext)(SwiperSlideContext);
};
var SwiperContext = /*#__PURE__*/ (0, _react.createContext)(null);
var useSwiper = function() {
    return (0, _react.useContext)(SwiperContext);
};
var Swiper = /*#__PURE__*/ (0, _react.forwardRef)(function(_temp, externalElRef) {
    var _ref = _temp === void 0 ? {} : _temp, className = _ref.className, tmp = _ref.tag, Tag = tmp === void 0 ? 'div' : tmp, tmp1 = _ref.wrapperTag, WrapperTag = tmp1 === void 0 ? 'div' : tmp1, children = _ref.children, onSwiper = _ref.onSwiper, rest = (0, _objectWithoutProperties._)(_ref, [
        "className",
        "tag",
        "wrapperTag",
        "children",
        "onSwiper"
    ]);
    var eventsAssigned = false;
    var _useState = (0, _slicedToArray._)((0, _react.useState)('swiper'), 2), containerClasses = _useState[0], setContainerClasses = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(null), 2), virtualData = _useState1[0], setVirtualData = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)(false), 2), breakpointChanged = _useState2[0], setBreakpointChanged = _useState2[1];
    var initializedRef = (0, _react.useRef)(false);
    var swiperElRef = (0, _react.useRef)(null);
    var swiperRef = (0, _react.useRef)(null);
    var oldPassedParamsRef = (0, _react.useRef)(null);
    var oldSlides = (0, _react.useRef)(null);
    var nextElRef = (0, _react.useRef)(null);
    var prevElRef = (0, _react.useRef)(null);
    var paginationElRef = (0, _react.useRef)(null);
    var scrollbarElRef = (0, _react.useRef)(null);
    var _getParams = (0, _updateOnVirtualDataMjs.g)(rest), swiperParams = _getParams.params, passedParams = _getParams.passedParams, restProps = _getParams.rest, events = _getParams.events;
    var _getChildren = getChildren(children), slides = _getChildren.slides, slots = _getChildren.slots;
    var onBeforeBreakpoint = function() {
        setBreakpointChanged(!breakpointChanged);
    };
    Object.assign(swiperParams.on, {
        _containerClasses: function(swiper, classes) {
            setContainerClasses(classes);
        }
    });
    var initSwiper = function() {
        // init swiper
        Object.assign(swiperParams.on, events);
        eventsAssigned = true;
        var passParams = (0, _objectSpread._)({}, swiperParams);
        delete passParams.wrapperClass;
        swiperRef.current = new (0, _swiperCoreMjs.S)(passParams);
        if (swiperRef.current.virtual && swiperRef.current.params.virtual.enabled) {
            swiperRef.current.virtual.slides = slides;
            var extendWith = {
                cache: false,
                slides: slides,
                renderExternal: setVirtualData,
                renderExternalUpdate: false
            };
            (0, _updateSwiperMjs.e)(swiperRef.current.params.virtual, extendWith);
            (0, _updateSwiperMjs.e)(swiperRef.current.originalParams.virtual, extendWith);
        }
    };
    if (!swiperElRef.current) initSwiper();
    // Listen for breakpoints change
    if (swiperRef.current) swiperRef.current.on('_beforeBreakpoint', onBeforeBreakpoint);
    var attachEvents = function() {
        if (eventsAssigned || !events || !swiperRef.current) return;
        Object.keys(events).forEach(function(eventName) {
            swiperRef.current.on(eventName, events[eventName]);
        });
    };
    var detachEvents = function() {
        if (!events || !swiperRef.current) return;
        Object.keys(events).forEach(function(eventName) {
            swiperRef.current.off(eventName, events[eventName]);
        });
    };
    (0, _react.useEffect)(function() {
        return function() {
            if (swiperRef.current) swiperRef.current.off('_beforeBreakpoint', onBeforeBreakpoint);
        };
    });
    // set initialized flag
    (0, _react.useEffect)(function() {
        if (!initializedRef.current && swiperRef.current) {
            swiperRef.current.emitSlidesClasses();
            initializedRef.current = true;
        }
    });
    // mount swiper
    useIsomorphicLayoutEffect(function() {
        if (externalElRef) externalElRef.current = swiperElRef.current;
        if (!swiperElRef.current) return;
        if (swiperRef.current.destroyed) initSwiper();
        (0, _updateOnVirtualDataMjs.m)({
            el: swiperElRef.current,
            nextEl: nextElRef.current,
            prevEl: prevElRef.current,
            paginationEl: paginationElRef.current,
            scrollbarEl: scrollbarElRef.current,
            swiper: swiperRef.current
        }, swiperParams);
        if (onSwiper && !swiperRef.current.destroyed) onSwiper(swiperRef.current);
        // eslint-disable-next-line
        return function() {
            if (swiperRef.current && !swiperRef.current.destroyed) swiperRef.current.destroy(true, false);
        };
    }, []);
    // watch for params change
    useIsomorphicLayoutEffect(function() {
        attachEvents();
        var changedParams = (0, _updateOnVirtualDataMjs.a)(passedParams, oldPassedParamsRef.current, slides, oldSlides.current, function(c) {
            return c.key;
        });
        oldPassedParamsRef.current = passedParams;
        oldSlides.current = slides;
        if (changedParams.length && swiperRef.current && !swiperRef.current.destroyed) (0, _updateSwiperMjs.u)({
            swiper: swiperRef.current,
            slides: slides,
            passedParams: passedParams,
            changedParams: changedParams,
            nextEl: nextElRef.current,
            prevEl: prevElRef.current,
            scrollbarEl: scrollbarElRef.current,
            paginationEl: paginationElRef.current
        });
        return function() {
            detachEvents();
        };
    });
    // update on virtual update
    useIsomorphicLayoutEffect(function() {
        (0, _updateOnVirtualDataMjs.u)(swiperRef.current);
    }, [
        virtualData
    ]);
    // bypass swiper instance to slides
    function renderSlides() {
        if (swiperParams.virtual) return renderVirtual(swiperRef.current, slides, virtualData);
        return slides.map(function(child, index) {
            return /*#__PURE__*/ (0, _reactDefault.default).cloneElement(child, {
                swiper: swiperRef.current,
                swiperSlideIndex: index
            });
        });
    }
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, _extends({
        ref: swiperElRef,
        className: (0, _updateSwiperMjs.d)(`${containerClasses}${className ? ` ${className}` : ''}`)
    }, restProps), /*#__PURE__*/ (0, _reactDefault.default).createElement(SwiperContext.Provider, {
        value: swiperRef.current
    }, slots['container-start'], /*#__PURE__*/ (0, _reactDefault.default).createElement(WrapperTag, {
        className: (0, _updateSwiperMjs.w)(swiperParams.wrapperClass)
    }, slots['wrapper-start'], renderSlides(), slots['wrapper-end']), (0, _updateSwiperMjs.n)(swiperParams) && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ref: prevElRef,
        className: "swiper-button-prev"
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ref: nextElRef,
        className: "swiper-button-next"
    })), (0, _updateSwiperMjs.b)(swiperParams) && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ref: scrollbarElRef,
        className: "swiper-scrollbar"
    }), (0, _updateSwiperMjs.a)(swiperParams) && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ref: paginationElRef,
        className: "swiper-pagination"
    }), slots['container-end']));
});
Swiper.displayName = 'Swiper';
var SwiperSlide = /*#__PURE__*/ (0, _react.forwardRef)(function(_temp, externalRef) {
    var _ref = _temp === void 0 ? {} : _temp, tmp = _ref.tag, Tag = tmp === void 0 ? 'div' : tmp, children = _ref.children, _ref_className = _ref.className, className = _ref_className === void 0 ? '' : _ref_className, swiper = _ref.swiper, zoom = _ref.zoom, lazy = _ref.lazy, virtualIndex = _ref.virtualIndex, swiperSlideIndex = _ref.swiperSlideIndex, rest = (0, _objectWithoutProperties._)(_ref, [
        "tag",
        "children",
        "className",
        "swiper",
        "zoom",
        "lazy",
        "virtualIndex",
        "swiperSlideIndex"
    ]);
    var slideElRef = (0, _react.useRef)(null);
    var _useState = (0, _slicedToArray._)((0, _react.useState)('swiper-slide'), 2), slideClasses = _useState[0], setSlideClasses = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(false), 2), lazyLoaded = _useState1[0], setLazyLoaded = _useState1[1];
    function updateClasses(_s, el, classNames) {
        if (el === slideElRef.current) setSlideClasses(classNames);
    }
    useIsomorphicLayoutEffect(function() {
        if (typeof swiperSlideIndex !== 'undefined') slideElRef.current.swiperSlideIndex = swiperSlideIndex;
        if (externalRef) externalRef.current = slideElRef.current;
        if (!slideElRef.current || !swiper) return;
        if (swiper.destroyed) {
            if (slideClasses !== 'swiper-slide') setSlideClasses('swiper-slide');
            return;
        }
        swiper.on('_slideClass', updateClasses);
        // eslint-disable-next-line
        return function() {
            if (!swiper) return;
            swiper.off('_slideClass', updateClasses);
        };
    });
    useIsomorphicLayoutEffect(function() {
        if (swiper && slideElRef.current && !swiper.destroyed) setSlideClasses(swiper.getSlideClasses(slideElRef.current));
    }, [
        swiper
    ]);
    var slideData = {
        isActive: slideClasses.indexOf('swiper-slide-active') >= 0,
        isVisible: slideClasses.indexOf('swiper-slide-visible') >= 0,
        isPrev: slideClasses.indexOf('swiper-slide-prev') >= 0,
        isNext: slideClasses.indexOf('swiper-slide-next') >= 0
    };
    var renderChildren = function() {
        return typeof children === 'function' ? children(slideData) : children;
    };
    var onLoad = function() {
        setLazyLoaded(true);
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(Tag, _extends({
        ref: slideElRef,
        className: (0, _updateSwiperMjs.d)(`${slideClasses}${className ? ` ${className}` : ''}`),
        "data-swiper-slide-index": virtualIndex,
        onLoad: onLoad
    }, rest), zoom && /*#__PURE__*/ (0, _reactDefault.default).createElement(SwiperSlideContext.Provider, {
        value: slideData
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "swiper-zoom-container",
        "data-swiper-zoom": typeof zoom === 'number' ? zoom : undefined
    }, renderChildren(), lazy && !lazyLoaded && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "swiper-lazy-preloader"
    }))), !zoom && /*#__PURE__*/ (0, _reactDefault.default).createElement(SwiperSlideContext.Provider, {
        value: slideData
    }, renderChildren(), lazy && !lazyLoaded && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: "swiper-lazy-preloader"
    })));
});
SwiperSlide.displayName = 'SwiperSlide';

},{"@swc/helpers/_/_define_property":"54Zvk","@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_object_without_properties":"1waVD","@swc/helpers/_/_sliced_to_array":"ha6sq","react":"c8CN1","./shared/swiper-core.mjs":"frzgY","./shared/update-on-virtual-data.mjs":"jpzTZ","./shared/update-swiper.mjs":"33nsa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"frzgY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "S", function() {
    return Swiper;
});
parcelHelpers.export(exports, "d", function() {
    return defaults;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _ssrWindowEsmMjs = require("./ssr-window.esm.mjs");
var _utilsMjs = require("./utils.mjs");
var support;
function calcSupport() {
    var window1 = (0, _ssrWindowEsmMjs.a)();
    var document1 = (0, _ssrWindowEsmMjs.g)();
    return {
        smoothScroll: document1.documentElement && document1.documentElement.style && 'scrollBehavior' in document1.documentElement.style,
        touch: !!('ontouchstart' in window1 || window1.DocumentTouch && document1 instanceof window1.DocumentTouch)
    };
}
function getSupport() {
    if (!support) support = calcSupport();
    return support;
}
var deviceCached;
function calcDevice(_temp) {
    var userAgent = (_temp === void 0 ? {} : _temp).userAgent;
    var support = getSupport();
    var window1 = (0, _ssrWindowEsmMjs.a)();
    var platform = window1.navigator.platform;
    var ua = userAgent || window1.navigator.userAgent;
    var device = {
        ios: false,
        android: false
    };
    var screenWidth = window1.screen.width;
    var screenHeight = window1.screen.height;
    var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
    var windows = platform === 'Win32';
    var macos = platform === 'MacIntel';
    // iPadOs 13 fix
    var iPadScreens = [
        '1024x1366',
        '1366x1024',
        '834x1194',
        '1194x834',
        '834x1112',
        '1112x834',
        '768x1024',
        '1024x768',
        '820x1180',
        '1180x820',
        '810x1080',
        '1080x810'
    ];
    if (!ipad && macos && support.touch && iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0) {
        ipad = ua.match(/(Version)\/([\d.]+)/);
        if (!ipad) ipad = [
            0,
            1,
            '13_0_0'
        ];
        macos = false;
    }
    // Android
    if (android && !windows) {
        device.os = 'android';
        device.android = true;
    }
    if (ipad || iphone || ipod) {
        device.os = 'ios';
        device.ios = true;
    }
    // Export object
    return device;
}
function getDevice(overrides) {
    if (overrides === void 0) overrides = {};
    if (!deviceCached) deviceCached = calcDevice(overrides);
    return deviceCached;
}
var browser;
function calcBrowser() {
    var window1 = (0, _ssrWindowEsmMjs.a)();
    var device = getDevice();
    var needPerspectiveFix = false;
    function isSafari() {
        var ua = window1.navigator.userAgent.toLowerCase();
        return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
    }
    if (isSafari()) {
        var ua = String(window1.navigator.userAgent);
        if (ua.includes('Version/')) {
            var _ua_split__split__split_map = (0, _slicedToArray._)(ua.split('Version/')[1].split(' ')[0].split('.').map(function(num) {
                return Number(num);
            }), 2), major = _ua_split__split__split_map[0], minor = _ua_split__split__split_map[1];
            needPerspectiveFix = major < 16 || major === 16 && minor < 2;
        }
    }
    var isWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window1.navigator.userAgent);
    var isSafariBrowser = isSafari();
    var need3dFix = isSafariBrowser || isWebView && device.ios;
    return {
        isSafari: needPerspectiveFix || isSafariBrowser,
        needPerspectiveFix: needPerspectiveFix,
        need3dFix: need3dFix,
        isWebView: isWebView
    };
}
function getBrowser() {
    if (!browser) browser = calcBrowser();
    return browser;
}
function Resize(_ref) {
    var swiper = _ref.swiper, on = _ref.on, emit = _ref.emit;
    var window1 = (0, _ssrWindowEsmMjs.a)();
    var observer = null;
    var animationFrame = null;
    var resizeHandler = function() {
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit('beforeResize');
        emit('resize');
    };
    var createObserver = function() {
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        observer = new ResizeObserver(function(entries) {
            animationFrame = window1.requestAnimationFrame(function() {
                var width = swiper.width, height = swiper.height;
                var newWidth = width;
                var newHeight = height;
                entries.forEach(function(_ref2) {
                    var contentBoxSize = _ref2.contentBoxSize, contentRect = _ref2.contentRect, target = _ref2.target;
                    if (target && target !== swiper.el) return;
                    newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
                    newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
                });
                if (newWidth !== width || newHeight !== height) resizeHandler();
            });
        });
        observer.observe(swiper.el);
    };
    var removeObserver = function() {
        if (animationFrame) window1.cancelAnimationFrame(animationFrame);
        if (observer && observer.unobserve && swiper.el) {
            observer.unobserve(swiper.el);
            observer = null;
        }
    };
    var orientationChangeHandler = function() {
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit('orientationchange');
    };
    on('init', function() {
        if (swiper.params.resizeObserver && typeof window1.ResizeObserver !== 'undefined') {
            createObserver();
            return;
        }
        window1.addEventListener('resize', resizeHandler);
        window1.addEventListener('orientationchange', orientationChangeHandler);
    });
    on('destroy', function() {
        removeObserver();
        window1.removeEventListener('resize', resizeHandler);
        window1.removeEventListener('orientationchange', orientationChangeHandler);
    });
}
function Observer(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, on = _ref.on, emit = _ref.emit;
    var observers = [];
    var window1 = (0, _ssrWindowEsmMjs.a)();
    var attach = function attach(target, options) {
        if (options === void 0) options = {};
        var ObserverFunc = window1.MutationObserver || window1.WebkitMutationObserver;
        var observer = new ObserverFunc(function(mutations) {
            // The observerUpdate event should only be triggered
            // once despite the number of mutations.  Additional
            // triggers are redundant and are very costly
            if (swiper.__preventObserver__) return;
            if (mutations.length === 1) {
                emit('observerUpdate', mutations[0]);
                return;
            }
            var observerUpdate = function observerUpdate() {
                emit('observerUpdate', mutations[0]);
            };
            if (window1.requestAnimationFrame) window1.requestAnimationFrame(observerUpdate);
            else window1.setTimeout(observerUpdate, 0);
        });
        observer.observe(target, {
            attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
            childList: swiper.isElement || (typeof options.childList === 'undefined' ? true : options).childList,
            characterData: typeof options.characterData === 'undefined' ? true : options.characterData
        });
        observers.push(observer);
    };
    var init = function() {
        if (!swiper.params.observer) return;
        if (swiper.params.observeParents) {
            var containerParents = (0, _utilsMjs.a)(swiper.hostEl);
            for(var i = 0; i < containerParents.length; i += 1)attach(containerParents[i]);
        }
        // Observe container
        attach(swiper.hostEl, {
            childList: swiper.params.observeSlideChildren
        });
        // Observe wrapper
        attach(swiper.wrapperEl, {
            attributes: false
        });
    };
    var destroy = function() {
        observers.forEach(function(observer) {
            observer.disconnect();
        });
        observers.splice(0, observers.length);
    };
    extendParams({
        observer: false,
        observeParents: false,
        observeSlideChildren: false
    });
    on('init', init);
    on('destroy', destroy);
}
/* eslint-disable no-underscore-dangle */ var eventsEmitter = {
    on: function(events, handler, priority) {
        var self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        var method = priority ? 'unshift' : 'push';
        events.split(' ').forEach(function(event) {
            if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
            self.eventsListeners[event][method](handler);
        });
        return self;
    },
    once: function(events, handler, priority) {
        var self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        function onceHandler() {
            self.off(events, onceHandler);
            if (onceHandler.__emitterProxy) delete onceHandler.__emitterProxy;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            handler.apply(self, args);
        }
        onceHandler.__emitterProxy = handler;
        return self.on(events, onceHandler, priority);
    },
    onAny: function(handler, priority) {
        var self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        var method = priority ? 'unshift' : 'push';
        if (self.eventsAnyListeners.indexOf(handler) < 0) self.eventsAnyListeners[method](handler);
        return self;
    },
    offAny: function(handler) {
        var self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsAnyListeners) return self;
        var index = self.eventsAnyListeners.indexOf(handler);
        if (index >= 0) self.eventsAnyListeners.splice(index, 1);
        return self;
    },
    off: function(events, handler) {
        var self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        events.split(' ').forEach(function(event) {
            if (typeof handler === 'undefined') self.eventsListeners[event] = [];
            else if (self.eventsListeners[event]) self.eventsListeners[event].forEach(function(eventHandler, index) {
                if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) self.eventsListeners[event].splice(index, 1);
            });
        });
        return self;
    },
    emit: function() {
        var self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        var events;
        var data;
        var context;
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        if (typeof args[0] === 'string' || Array.isArray(args[0])) {
            events = args[0];
            data = args.slice(1, args.length);
            context = self;
        } else {
            events = args[0].events;
            data = args[0].data;
            context = args[0].context || self;
        }
        data.unshift(context);
        var eventsArray = Array.isArray(events) ? events : events.split(' ');
        eventsArray.forEach(function(event) {
            if (self.eventsAnyListeners && self.eventsAnyListeners.length) self.eventsAnyListeners.forEach(function(eventHandler) {
                eventHandler.apply(context, [
                    event
                ].concat((0, _toConsumableArray._)(data)));
            });
            if (self.eventsListeners && self.eventsListeners[event]) self.eventsListeners[event].forEach(function(eventHandler) {
                eventHandler.apply(context, data);
            });
        });
        return self;
    }
};
function updateSize() {
    var swiper = this;
    var width;
    var height;
    var el = swiper.el;
    if (typeof swiper.params.width !== 'undefined' && swiper.params.width !== null) width = swiper.params.width;
    else width = el.clientWidth;
    if (typeof swiper.params.height !== 'undefined' && swiper.params.height !== null) height = swiper.params.height;
    else height = el.clientHeight;
    if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) return;
    // Subtract paddings
    width = width - parseInt((0, _utilsMjs.p)(el, 'padding-left') || 0, 10) - parseInt((0, _utilsMjs.p)(el, 'padding-right') || 0, 10);
    height = height - parseInt((0, _utilsMjs.p)(el, 'padding-top') || 0, 10) - parseInt((0, _utilsMjs.p)(el, 'padding-bottom') || 0, 10);
    if (Number.isNaN(width)) width = 0;
    if (Number.isNaN(height)) height = 0;
    Object.assign(swiper, {
        width: width,
        height: height,
        size: swiper.isHorizontal() ? width : height
    });
}
function updateSlides() {
    var swiper = this;
    function getDirectionPropertyValue(node, label) {
        return parseFloat(node.getPropertyValue(swiper.getDirectionLabel(label)) || 0);
    }
    var params = swiper.params;
    var wrapperEl = swiper.wrapperEl, slidesEl = swiper.slidesEl, swiperSize = swiper.size, rtl = swiper.rtlTranslate, wrongRTL = swiper.wrongRTL;
    var isVirtual = swiper.virtual && params.virtual.enabled;
    var previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    var slides = (0, _utilsMjs.e)(slidesEl, `.${swiper.params.slideClass}, swiper-slide`);
    var slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    var snapGrid = [];
    var slidesGrid = [];
    var slidesSizesGrid = [];
    var offsetBefore = params.slidesOffsetBefore;
    if (typeof offsetBefore === 'function') offsetBefore = params.slidesOffsetBefore.call(swiper);
    var offsetAfter = params.slidesOffsetAfter;
    if (typeof offsetAfter === 'function') offsetAfter = params.slidesOffsetAfter.call(swiper);
    var previousSnapGridLength = swiper.snapGrid.length;
    var previousSlidesGridLength = swiper.slidesGrid.length;
    var spaceBetween = params.spaceBetween;
    var slidePosition = -offsetBefore;
    var prevSlideSize = 0;
    var index = 0;
    if (typeof swiperSize === 'undefined') return;
    if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
    else if (typeof spaceBetween === 'string') spaceBetween = parseFloat(spaceBetween);
    swiper.virtualSize = -spaceBetween;
    // reset margins
    slides.forEach(function(slideEl) {
        if (rtl) slideEl.style.marginLeft = '';
        else slideEl.style.marginRight = '';
        slideEl.style.marginBottom = '';
        slideEl.style.marginTop = '';
    });
    // reset cssMode offsets
    if (params.centeredSlides && params.cssMode) {
        (0, _utilsMjs.s)(wrapperEl, '--swiper-centered-offset-before', '');
        (0, _utilsMjs.s)(wrapperEl, '--swiper-centered-offset-after', '');
    }
    var gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
    if (gridEnabled) swiper.grid.initSlides(slides);
    else if (swiper.grid) swiper.grid.unsetSlides();
    // Calc slides
    var slideSize;
    var shouldResetSlideSize = params.slidesPerView === 'auto' && params.breakpoints && Object.keys(params.breakpoints).filter(function(key) {
        return typeof params.breakpoints[key].slidesPerView !== 'undefined';
    }).length > 0;
    for(var i = 0; i < slidesLength; i += 1){
        slideSize = 0;
        var slide = void 0;
        if (slides[i]) slide = slides[i];
        if (gridEnabled) swiper.grid.updateSlide(i, slide, slides);
        if (slides[i] && (0, _utilsMjs.p)(slide, 'display') === 'none') continue; // eslint-disable-line
        if (params.slidesPerView === 'auto') {
            if (shouldResetSlideSize) slides[i].style[swiper.getDirectionLabel('width')] = ``;
            var slideStyles = getComputedStyle(slide);
            var currentTransform = slide.style.transform;
            var currentWebKitTransform = slide.style.webkitTransform;
            if (currentTransform) slide.style.transform = 'none';
            if (currentWebKitTransform) slide.style.webkitTransform = 'none';
            if (params.roundLengths) slideSize = swiper.isHorizontal() ? (0, _utilsMjs.f)(slide, 'width', true) : (0, _utilsMjs.f)(slide, 'height', true);
            else {
                // eslint-disable-next-line
                var width = getDirectionPropertyValue(slideStyles, 'width');
                var paddingLeft = getDirectionPropertyValue(slideStyles, 'padding-left');
                var paddingRight = getDirectionPropertyValue(slideStyles, 'padding-right');
                var marginLeft = getDirectionPropertyValue(slideStyles, 'margin-left');
                var marginRight = getDirectionPropertyValue(slideStyles, 'margin-right');
                var boxSizing = slideStyles.getPropertyValue('box-sizing');
                if (boxSizing && boxSizing === 'border-box') slideSize = width + marginLeft + marginRight;
                else {
                    var clientWidth = slide.clientWidth, offsetWidth = slide.offsetWidth;
                    slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
                }
            }
            if (currentTransform) slide.style.transform = currentTransform;
            if (currentWebKitTransform) slide.style.webkitTransform = currentWebKitTransform;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
        } else {
            slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
            if (slides[i]) slides[i].style[swiper.getDirectionLabel('width')] = `${slideSize}px`;
        }
        if (slides[i]) slides[i].swiperSlideSize = slideSize;
        slidesSizesGrid.push(slideSize);
        if (params.centeredSlides) {
            slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
            if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (Math.abs(slidePosition) < 0.001) slidePosition = 0;
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
        } else {
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
            slidePosition = slidePosition + slideSize + spaceBetween;
        }
        swiper.virtualSize += slideSize + spaceBetween;
        prevSlideSize = slideSize;
        index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) wrapperEl.style.width = `${swiper.virtualSize + spaceBetween}px`;
    if (params.setWrapperSize) wrapperEl.style[swiper.getDirectionLabel('width')] = `${swiper.virtualSize + spaceBetween}px`;
    if (gridEnabled) swiper.grid.updateWrapperSize(slideSize, snapGrid);
    // Remove last grid elements depending on width
    if (!params.centeredSlides) {
        var newSlidesGrid = [];
        for(var i1 = 0; i1 < snapGrid.length; i1 += 1){
            var slidesGridItem = snapGrid[i1];
            if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
            if (snapGrid[i1] <= swiper.virtualSize - swiperSize) newSlidesGrid.push(slidesGridItem);
        }
        snapGrid = newSlidesGrid;
        if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) snapGrid.push(swiper.virtualSize - swiperSize);
    }
    if (isVirtual && params.loop) {
        var size = slidesSizesGrid[0] + spaceBetween;
        if (params.slidesPerGroup > 1) {
            var groups = Math.ceil((swiper.virtual.slidesBefore + swiper.virtual.slidesAfter) / params.slidesPerGroup);
            var groupSize = size * params.slidesPerGroup;
            for(var i2 = 0; i2 < groups; i2 += 1)snapGrid.push(snapGrid[snapGrid.length - 1] + groupSize);
        }
        for(var i3 = 0; i3 < swiper.virtual.slidesBefore + swiper.virtual.slidesAfter; i3 += 1){
            if (params.slidesPerGroup === 1) snapGrid.push(snapGrid[snapGrid.length - 1] + size);
            slidesGrid.push(slidesGrid[slidesGrid.length - 1] + size);
            swiper.virtualSize += size;
        }
    }
    if (snapGrid.length === 0) snapGrid = [
        0
    ];
    if (spaceBetween !== 0) {
        var key = swiper.isHorizontal() && rtl ? 'marginLeft' : swiper.getDirectionLabel('marginRight');
        slides.filter(function(_, slideIndex) {
            if (!params.cssMode || params.loop) return true;
            if (slideIndex === slides.length - 1) return false;
            return true;
        }).forEach(function(slideEl) {
            slideEl.style[key] = `${spaceBetween}px`;
        });
    }
    if (params.centeredSlides && params.centeredSlidesBounds) {
        var allSlidesSize = 0;
        slidesSizesGrid.forEach(function(slideSizeValue) {
            allSlidesSize += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize -= spaceBetween;
        var maxSnap = allSlidesSize > swiperSize ? allSlidesSize - swiperSize : 0;
        snapGrid = snapGrid.map(function(snap) {
            if (snap <= 0) return -offsetBefore;
            if (snap > maxSnap) return maxSnap + offsetAfter;
            return snap;
        });
    }
    if (params.centerInsufficientSlides) {
        var allSlidesSize1 = 0;
        slidesSizesGrid.forEach(function(slideSizeValue) {
            allSlidesSize1 += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize1 -= spaceBetween;
        var offsetSize = (params.slidesOffsetBefore || 0) + (params.slidesOffsetAfter || 0);
        if (allSlidesSize1 + offsetSize < swiperSize) {
            var allSlidesOffset = (swiperSize - allSlidesSize1 - offsetSize) / 2;
            snapGrid.forEach(function(snap, snapIndex) {
                snapGrid[snapIndex] = snap - allSlidesOffset;
            });
            slidesGrid.forEach(function(snap, snapIndex) {
                slidesGrid[snapIndex] = snap + allSlidesOffset;
            });
        }
    }
    Object.assign(swiper, {
        slides: slides,
        snapGrid: snapGrid,
        slidesGrid: slidesGrid,
        slidesSizesGrid: slidesSizesGrid
    });
    if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
        (0, _utilsMjs.s)(wrapperEl, '--swiper-centered-offset-before', `${-snapGrid[0]}px`);
        (0, _utilsMjs.s)(wrapperEl, '--swiper-centered-offset-after', `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
        var addToSnapGrid = -swiper.snapGrid[0];
        var addToSlidesGrid = -swiper.slidesGrid[0];
        swiper.snapGrid = swiper.snapGrid.map(function(v) {
            return v + addToSnapGrid;
        });
        swiper.slidesGrid = swiper.slidesGrid.map(function(v) {
            return v + addToSlidesGrid;
        });
    }
    if (slidesLength !== previousSlidesLength) swiper.emit('slidesLengthChange');
    if (snapGrid.length !== previousSnapGridLength) {
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        swiper.emit('snapGridLengthChange');
    }
    if (slidesGrid.length !== previousSlidesGridLength) swiper.emit('slidesGridLengthChange');
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    swiper.emit('slidesUpdated');
    if (!isVirtual && !params.cssMode && (params.effect === 'slide' || params.effect === 'fade')) {
        var backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
        var hasClassBackfaceClassAdded = swiper.el.classList.contains(backFaceHiddenClass);
        if (slidesLength <= params.maxBackfaceHiddenSlides) {
            if (!hasClassBackfaceClassAdded) swiper.el.classList.add(backFaceHiddenClass);
        } else if (hasClassBackfaceClassAdded) swiper.el.classList.remove(backFaceHiddenClass);
    }
}
function updateAutoHeight(speed) {
    var swiper = this;
    var activeSlides = [];
    var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    var newHeight = 0;
    var i;
    if (typeof speed === 'number') swiper.setTransition(speed);
    else if (speed === true) swiper.setTransition(swiper.params.speed);
    var getSlideByIndex = function(index) {
        if (isVirtual) return swiper.slides[swiper.getSlideIndexByData(index)];
        return swiper.slides[index];
    };
    // Find slides currently in view
    if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
        if (swiper.params.centeredSlides) (swiper.visibleSlides || []).forEach(function(slide) {
            activeSlides.push(slide);
        });
        else for(i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1){
            var index = swiper.activeIndex + i;
            if (index > swiper.slides.length && !isVirtual) break;
            activeSlides.push(getSlideByIndex(index));
        }
    } else activeSlides.push(getSlideByIndex(swiper.activeIndex));
    // Find new height from highest slide in view
    for(i = 0; i < activeSlides.length; i += 1)if (typeof activeSlides[i] !== 'undefined') {
        var height = activeSlides[i].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
    }
    // Update Height
    if (newHeight || newHeight === 0) swiper.wrapperEl.style.height = `${newHeight}px`;
}
function updateSlidesOffset() {
    var swiper = this;
    var slides = swiper.slides;
    // eslint-disable-next-line
    var minusOffset = swiper.isElement ? swiper.isHorizontal() ? swiper.wrapperEl.offsetLeft : swiper.wrapperEl.offsetTop : 0;
    for(var i = 0; i < slides.length; i += 1)slides[i].swiperSlideOffset = (swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop) - minusOffset - swiper.cssOverflowAdjustment();
}
var toggleSlideClasses$1 = function(slideEl, condition, className) {
    if (condition && !slideEl.classList.contains(className)) slideEl.classList.add(className);
    else if (!condition && slideEl.classList.contains(className)) slideEl.classList.remove(className);
};
function updateSlidesProgress(translate) {
    if (translate === void 0) translate = this && this.translate || 0;
    var swiper = this;
    var params = swiper.params;
    var slides = swiper.slides, rtl = swiper.rtlTranslate, snapGrid = swiper.snapGrid;
    if (slides.length === 0) return;
    if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
    var offsetCenter = -translate;
    if (rtl) offsetCenter = translate;
    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];
    var spaceBetween = params.spaceBetween;
    if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiper.size;
    else if (typeof spaceBetween === 'string') spaceBetween = parseFloat(spaceBetween);
    for(var i = 0; i < slides.length; i += 1){
        var slide = slides[i];
        var slideOffset = slide.swiperSlideOffset;
        if (params.cssMode && params.centeredSlides) slideOffset -= slides[0].swiperSlideOffset;
        var slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
        var originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
        var slideBefore = -(offsetCenter - slideOffset);
        var slideAfter = slideBefore + swiper.slidesSizesGrid[i];
        var isFullyVisible = slideBefore >= 0 && slideBefore <= swiper.size - swiper.slidesSizesGrid[i];
        var isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
        if (isVisible) {
            swiper.visibleSlides.push(slide);
            swiper.visibleSlidesIndexes.push(i);
        }
        toggleSlideClasses$1(slide, isVisible, params.slideVisibleClass);
        toggleSlideClasses$1(slide, isFullyVisible, params.slideFullyVisibleClass);
        slide.progress = rtl ? -slideProgress : slideProgress;
        slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
    }
}
function updateProgress(translate) {
    var swiper = this;
    if (typeof translate === 'undefined') {
        var multiplier = swiper.rtlTranslate ? -1 : 1;
        // eslint-disable-next-line
        translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
    }
    var params = swiper.params;
    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    var progress = swiper.progress, isBeginning = swiper.isBeginning, isEnd = swiper.isEnd, progressLoop = swiper.progressLoop;
    var wasBeginning = isBeginning;
    var wasEnd = isEnd;
    if (translatesDiff === 0) {
        progress = 0;
        isBeginning = true;
        isEnd = true;
    } else {
        progress = (translate - swiper.minTranslate()) / translatesDiff;
        var isBeginningRounded = Math.abs(translate - swiper.minTranslate()) < 1;
        var isEndRounded = Math.abs(translate - swiper.maxTranslate()) < 1;
        isBeginning = isBeginningRounded || progress <= 0;
        isEnd = isEndRounded || progress >= 1;
        if (isBeginningRounded) progress = 0;
        if (isEndRounded) progress = 1;
    }
    if (params.loop) {
        var firstSlideIndex = swiper.getSlideIndexByData(0);
        var lastSlideIndex = swiper.getSlideIndexByData(swiper.slides.length - 1);
        var firstSlideTranslate = swiper.slidesGrid[firstSlideIndex];
        var lastSlideTranslate = swiper.slidesGrid[lastSlideIndex];
        var translateMax = swiper.slidesGrid[swiper.slidesGrid.length - 1];
        var translateAbs = Math.abs(translate);
        if (translateAbs >= firstSlideTranslate) progressLoop = (translateAbs - firstSlideTranslate) / translateMax;
        else progressLoop = (translateAbs + translateMax - lastSlideTranslate) / translateMax;
        if (progressLoop > 1) progressLoop -= 1;
    }
    Object.assign(swiper, {
        progress: progress,
        progressLoop: progressLoop,
        isBeginning: isBeginning,
        isEnd: isEnd
    });
    if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
    if (isBeginning && !wasBeginning) swiper.emit('reachBeginning toEdge');
    if (isEnd && !wasEnd) swiper.emit('reachEnd toEdge');
    if (wasBeginning && !isBeginning || wasEnd && !isEnd) swiper.emit('fromEdge');
    swiper.emit('progress', progress);
}
var toggleSlideClasses = function(slideEl, condition, className) {
    if (condition && !slideEl.classList.contains(className)) slideEl.classList.add(className);
    else if (!condition && slideEl.classList.contains(className)) slideEl.classList.remove(className);
};
function updateSlidesClasses() {
    var swiper = this;
    var slides = swiper.slides, params = swiper.params, slidesEl = swiper.slidesEl, activeIndex = swiper.activeIndex;
    var isVirtual = swiper.virtual && params.virtual.enabled;
    var gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    var getFilteredSlide = function(selector) {
        return (0, _utilsMjs.e)(slidesEl, `.${params.slideClass}${selector}, swiper-slide${selector}`)[0];
    };
    var activeSlide;
    var prevSlide;
    var nextSlide;
    if (isVirtual) {
        if (params.loop) {
            var slideIndex = activeIndex - swiper.virtual.slidesBefore;
            if (slideIndex < 0) slideIndex = swiper.virtual.slides.length + slideIndex;
            if (slideIndex >= swiper.virtual.slides.length) slideIndex -= swiper.virtual.slides.length;
            activeSlide = getFilteredSlide(`[data-swiper-slide-index="${slideIndex}"]`);
        } else activeSlide = getFilteredSlide(`[data-swiper-slide-index="${activeIndex}"]`);
    } else if (gridEnabled) {
        activeSlide = slides.find(function(slideEl) {
            return slideEl.column === activeIndex;
        });
        nextSlide = slides.find(function(slideEl) {
            return slideEl.column === activeIndex + 1;
        });
        prevSlide = slides.find(function(slideEl) {
            return slideEl.column === activeIndex - 1;
        });
    } else activeSlide = slides[activeIndex];
    if (activeSlide) {
        if (!gridEnabled) {
            // Next Slide
            nextSlide = (0, _utilsMjs.q)(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
            if (params.loop && !nextSlide) nextSlide = slides[0];
            // Prev Slide
            prevSlide = (0, _utilsMjs.r)(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
            params.loop;
        }
    }
    slides.forEach(function(slideEl) {
        toggleSlideClasses(slideEl, slideEl === activeSlide, params.slideActiveClass);
        toggleSlideClasses(slideEl, slideEl === nextSlide, params.slideNextClass);
        toggleSlideClasses(slideEl, slideEl === prevSlide, params.slidePrevClass);
    });
    swiper.emitSlidesClasses();
}
var processLazyPreloader = function(swiper, imageEl) {
    if (!swiper || swiper.destroyed || !swiper.params) return;
    var slideSelector = function() {
        return swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
    };
    var slideEl = imageEl.closest(slideSelector());
    if (slideEl) {
        var lazyEl = slideEl.querySelector(`.${swiper.params.lazyPreloaderClass}`);
        if (!lazyEl && swiper.isElement) {
            if (slideEl.shadowRoot) lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
            else // init later
            requestAnimationFrame(function() {
                if (slideEl.shadowRoot) {
                    lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
                    if (lazyEl) lazyEl.remove();
                }
            });
        }
        if (lazyEl) lazyEl.remove();
    }
};
var unlazy = function(swiper, index) {
    if (!swiper.slides[index]) return;
    var imageEl = swiper.slides[index].querySelector('[loading="lazy"]');
    if (imageEl) imageEl.removeAttribute('loading');
};
var preload = function(swiper) {
    if (!swiper || swiper.destroyed || !swiper.params) return;
    var amount = swiper.params.lazyPreloadPrevNext;
    var len = swiper.slides.length;
    if (!len || !amount || amount < 0) return;
    amount = Math.min(amount, len);
    var slidesPerView = swiper.params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : Math.ceil(swiper.params.slidesPerView);
    var activeIndex = swiper.activeIndex;
    if (swiper.params.grid && swiper.params.grid.rows > 1) {
        var _preloadColumns;
        var activeColumn = activeIndex;
        var preloadColumns = [
            activeColumn - amount
        ];
        (_preloadColumns = preloadColumns).push.apply(_preloadColumns, (0, _toConsumableArray._)(Array.from({
            length: amount
        }).map(function(_, i) {
            return activeColumn + slidesPerView + i;
        })));
        swiper.slides.forEach(function(slideEl, i) {
            if (preloadColumns.includes(slideEl.column)) unlazy(swiper, i);
        });
        return;
    }
    var slideIndexLastInView = activeIndex + slidesPerView - 1;
    if (swiper.params.rewind || swiper.params.loop) for(var i = activeIndex - amount; i <= slideIndexLastInView + amount; i += 1){
        var realIndex = (i % len + len) % len;
        if (realIndex < activeIndex || realIndex > slideIndexLastInView) unlazy(swiper, realIndex);
    }
    else {
        for(var i1 = Math.max(activeIndex - amount, 0); i1 <= Math.min(slideIndexLastInView + amount, len - 1); i1 += 1)if (i1 !== activeIndex && (i1 > slideIndexLastInView || i1 < activeIndex)) unlazy(swiper, i1);
    }
};
function getActiveIndexByTranslate(swiper) {
    var slidesGrid = swiper.slidesGrid, params = swiper.params;
    var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    var activeIndex;
    for(var i = 0; i < slidesGrid.length; i += 1){
        if (typeof slidesGrid[i + 1] !== 'undefined') {
            if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) activeIndex = i;
            else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) activeIndex = i + 1;
        } else if (translate >= slidesGrid[i]) activeIndex = i;
    }
    // Normalize slideIndex
    if (params.normalizeSlideIndex) {
        if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
    }
    return activeIndex;
}
function updateActiveIndex(newActiveIndex) {
    var swiper = this;
    var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    var snapGrid = swiper.snapGrid, params = swiper.params, previousIndex = swiper.activeIndex, previousRealIndex = swiper.realIndex, previousSnapIndex = swiper.snapIndex;
    var activeIndex = newActiveIndex;
    var snapIndex;
    var getVirtualRealIndex = function(aIndex) {
        var realIndex = aIndex - swiper.virtual.slidesBefore;
        if (realIndex < 0) realIndex = swiper.virtual.slides.length + realIndex;
        if (realIndex >= swiper.virtual.slides.length) realIndex -= swiper.virtual.slides.length;
        return realIndex;
    };
    if (typeof activeIndex === 'undefined') activeIndex = getActiveIndexByTranslate(swiper);
    if (snapGrid.indexOf(translate) >= 0) snapIndex = snapGrid.indexOf(translate);
    else {
        var skip = Math.min(params.slidesPerGroupSkip, activeIndex);
        snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if (activeIndex === previousIndex && !swiper.params.loop) {
        if (snapIndex !== previousSnapIndex) {
            swiper.snapIndex = snapIndex;
            swiper.emit('snapIndexChange');
        }
        return;
    }
    if (activeIndex === previousIndex && swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) {
        swiper.realIndex = getVirtualRealIndex(activeIndex);
        return;
    }
    var gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    // Get real index
    var realIndex;
    if (swiper.virtual && params.virtual.enabled && params.loop) realIndex = getVirtualRealIndex(activeIndex);
    else if (gridEnabled) {
        var firstSlideInColumn = swiper.slides.find(function(slideEl) {
            return slideEl.column === activeIndex;
        });
        var activeSlideIndex = parseInt(firstSlideInColumn.getAttribute('data-swiper-slide-index'), 10);
        if (Number.isNaN(activeSlideIndex)) activeSlideIndex = Math.max(swiper.slides.indexOf(firstSlideInColumn), 0);
        realIndex = Math.floor(activeSlideIndex / params.grid.rows);
    } else if (swiper.slides[activeIndex]) {
        var slideIndex = swiper.slides[activeIndex].getAttribute('data-swiper-slide-index');
        if (slideIndex) realIndex = parseInt(slideIndex, 10);
        else realIndex = activeIndex;
    } else realIndex = activeIndex;
    Object.assign(swiper, {
        previousSnapIndex: previousSnapIndex,
        snapIndex: snapIndex,
        previousRealIndex: previousRealIndex,
        realIndex: realIndex,
        previousIndex: previousIndex,
        activeIndex: activeIndex
    });
    if (swiper.initialized) preload(swiper);
    swiper.emit('activeIndexChange');
    swiper.emit('snapIndexChange');
    if (swiper.initialized || swiper.params.runCallbacksOnInit) {
        if (previousRealIndex !== realIndex) swiper.emit('realIndexChange');
        swiper.emit('slideChange');
    }
}
function updateClickedSlide(el, path) {
    var swiper = this;
    var params = swiper.params;
    var slide = el.closest(`.${params.slideClass}, swiper-slide`);
    if (!slide && swiper.isElement && path && path.length > 1 && path.includes(el)) (0, _toConsumableArray._)(path.slice(path.indexOf(el) + 1, path.length)).forEach(function(pathEl) {
        if (!slide && pathEl.matches && pathEl.matches(`.${params.slideClass}, swiper-slide`)) slide = pathEl;
    });
    var slideFound = false;
    var slideIndex;
    if (slide) {
        for(var i = 0; i < swiper.slides.length; i += 1)if (swiper.slides[i] === slide) {
            slideFound = true;
            slideIndex = i;
            break;
        }
    }
    if (slide && slideFound) {
        swiper.clickedSlide = slide;
        if (swiper.virtual && swiper.params.virtual.enabled) swiper.clickedIndex = parseInt(slide.getAttribute('data-swiper-slide-index'), 10);
        else swiper.clickedIndex = slideIndex;
    } else {
        swiper.clickedSlide = undefined;
        swiper.clickedIndex = undefined;
        return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) swiper.slideToClickedSlide();
}
var update = {
    updateSize: updateSize,
    updateSlides: updateSlides,
    updateAutoHeight: updateAutoHeight,
    updateSlidesOffset: updateSlidesOffset,
    updateSlidesProgress: updateSlidesProgress,
    updateProgress: updateProgress,
    updateSlidesClasses: updateSlidesClasses,
    updateActiveIndex: updateActiveIndex,
    updateClickedSlide: updateClickedSlide
};
function getSwiperTranslate(axis) {
    if (axis === void 0) axis = this.isHorizontal() ? 'x' : 'y';
    var swiper = this;
    var params = swiper.params, rtl = swiper.rtlTranslate, translate = swiper.translate, wrapperEl = swiper.wrapperEl;
    if (params.virtualTranslate) return rtl ? -translate : translate;
    if (params.cssMode) return translate;
    var currentTranslate = (0, _utilsMjs.j)(wrapperEl, axis);
    currentTranslate += swiper.cssOverflowAdjustment();
    if (rtl) currentTranslate = -currentTranslate;
    return currentTranslate || 0;
}
function setTranslate(translate, byController) {
    var swiper = this;
    var rtl = swiper.rtlTranslate, params = swiper.params, wrapperEl = swiper.wrapperEl, progress = swiper.progress;
    var x = 0;
    var y = 0;
    var z = 0;
    if (swiper.isHorizontal()) x = rtl ? -translate : translate;
    else y = translate;
    if (params.roundLengths) {
        x = Math.floor(x);
        y = Math.floor(y);
    }
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y;
    if (params.cssMode) wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
    else if (!params.virtualTranslate) {
        if (swiper.isHorizontal()) x -= swiper.cssOverflowAdjustment();
        else y -= swiper.cssOverflowAdjustment();
        wrapperEl.style.transform = `translate3d(${x}px, ${y}px, ${z}px)`;
    }
    // Check if we need to update progress
    var newProgress;
    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== progress) swiper.updateProgress(translate);
    swiper.emit('setTranslate', swiper.translate, byController);
}
function minTranslate() {
    return -this.snapGrid[0];
}
function maxTranslate() {
    return -this.snapGrid[this.snapGrid.length - 1];
}
function translateTo(translate, speed, runCallbacks, translateBounds, internal) {
    if (translate === void 0) translate = 0;
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    if (translateBounds === void 0) translateBounds = true;
    var swiper = this;
    var params = swiper.params, wrapperEl = swiper.wrapperEl;
    if (swiper.animating && params.preventInteractionOnTransition) return false;
    var _$minTranslate = swiper.minTranslate();
    var _$maxTranslate = swiper.maxTranslate();
    var newTranslate;
    if (translateBounds && translate > _$minTranslate) newTranslate = _$minTranslate;
    else if (translateBounds && translate < _$maxTranslate) newTranslate = _$maxTranslate;
    else newTranslate = translate;
    // Update progress
    swiper.updateProgress(newTranslate);
    if (params.cssMode) {
        var isH = swiper.isHorizontal();
        if (speed === 0) wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
        else {
            if (!swiper.support.smoothScroll) {
                (0, _utilsMjs.t)({
                    swiper: swiper,
                    targetPosition: -newTranslate,
                    side: isH ? 'left' : 'top'
                });
                return true;
            }
            var _obj;
            wrapperEl.scrollTo((_obj = {}, (0, _defineProperty._)(_obj, isH ? 'left' : 'top', -newTranslate), (0, _defineProperty._)(_obj, "behavior", 'smooth'), _obj));
        }
        return true;
    }
    if (speed === 0) {
        swiper.setTransition(0);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit('beforeTransitionStart', speed, internal);
            swiper.emit('transitionEnd');
        }
    } else {
        swiper.setTransition(speed);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit('beforeTransitionStart', speed, internal);
            swiper.emit('transitionStart');
        }
        if (!swiper.animating) {
            swiper.animating = true;
            if (!swiper.onTranslateToWrapperTransitionEnd) swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
                if (!swiper || swiper.destroyed) return;
                if (e.target !== this) return;
                swiper.wrapperEl.removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
                swiper.onTranslateToWrapperTransitionEnd = null;
                delete swiper.onTranslateToWrapperTransitionEnd;
                swiper.animating = false;
                if (runCallbacks) swiper.emit('transitionEnd');
            };
            swiper.wrapperEl.addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
        }
    }
    return true;
}
var translate = {
    getTranslate: getSwiperTranslate,
    setTranslate: setTranslate,
    minTranslate: minTranslate,
    maxTranslate: maxTranslate,
    translateTo: translateTo
};
function setTransition(duration, byController) {
    var swiper = this;
    if (!swiper.params.cssMode) {
        swiper.wrapperEl.style.transitionDuration = `${duration}ms`;
        swiper.wrapperEl.style.transitionDelay = duration === 0 ? `0ms` : '';
    }
    swiper.emit('setTransition', duration, byController);
}
function transitionEmit(_ref) {
    var swiper = _ref.swiper, runCallbacks = _ref.runCallbacks, direction = _ref.direction, step = _ref.step;
    var activeIndex = swiper.activeIndex, previousIndex = swiper.previousIndex;
    var dir = direction;
    if (!dir) {
        if (activeIndex > previousIndex) dir = 'next';
        else if (activeIndex < previousIndex) dir = 'prev';
        else dir = 'reset';
    }
    swiper.emit(`transition${step}`);
    if (runCallbacks && activeIndex !== previousIndex) {
        if (dir === 'reset') {
            swiper.emit(`slideResetTransition${step}`);
            return;
        }
        swiper.emit(`slideChangeTransition${step}`);
        if (dir === 'next') swiper.emit(`slideNextTransition${step}`);
        else swiper.emit(`slidePrevTransition${step}`);
    }
}
function transitionStart(runCallbacks, direction) {
    if (runCallbacks === void 0) runCallbacks = true;
    var swiper = this;
    var params = swiper.params;
    if (params.cssMode) return;
    if (params.autoHeight) swiper.updateAutoHeight();
    transitionEmit({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: 'Start'
    });
}
function transitionEnd(runCallbacks, direction) {
    if (runCallbacks === void 0) runCallbacks = true;
    var swiper = this;
    var params = swiper.params;
    swiper.animating = false;
    if (params.cssMode) return;
    swiper.setTransition(0);
    transitionEmit({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: 'End'
    });
}
var transition = {
    setTransition: setTransition,
    transitionStart: transitionStart,
    transitionEnd: transitionEnd
};
function slideTo(index, speed, runCallbacks, internal, initial) {
    if (index === void 0) index = 0;
    if (runCallbacks === void 0) runCallbacks = true;
    if (typeof index === 'string') index = parseInt(index, 10);
    var swiper = this;
    var slideIndex = index;
    if (slideIndex < 0) slideIndex = 0;
    var params = swiper.params, snapGrid = swiper.snapGrid, slidesGrid = swiper.slidesGrid, previousIndex = swiper.previousIndex, activeIndex = swiper.activeIndex, rtl = swiper.rtlTranslate, wrapperEl = swiper.wrapperEl, enabled = swiper.enabled;
    if (!enabled && !internal && !initial || swiper.destroyed || swiper.animating && params.preventInteractionOnTransition) return false;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    var skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
    var snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    var translate = -snapGrid[snapIndex];
    // Normalize slideIndex
    if (params.normalizeSlideIndex) for(var i = 0; i < slidesGrid.length; i += 1){
        var normalizedTranslate = -Math.floor(translate * 100);
        var normalizedGrid = Math.floor(slidesGrid[i] * 100);
        var normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
        if (typeof slidesGrid[i + 1] !== 'undefined') {
            if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) slideIndex = i;
            else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) slideIndex = i + 1;
        } else if (normalizedTranslate >= normalizedGrid) slideIndex = i;
    }
    // Directions locks
    if (swiper.initialized && slideIndex !== activeIndex) {
        if (!swiper.allowSlideNext && (rtl ? translate > swiper.translate && translate > swiper.minTranslate() : translate < swiper.translate && translate < swiper.minTranslate())) return false;
        if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
            if ((activeIndex || 0) !== slideIndex) return false;
        }
    }
    if (slideIndex !== (previousIndex || 0) && runCallbacks) swiper.emit('beforeSlideChangeStart');
    // Update progress
    swiper.updateProgress(translate);
    var direction;
    if (slideIndex > activeIndex) direction = 'next';
    else if (slideIndex < activeIndex) direction = 'prev';
    else direction = 'reset';
    // initial virtual
    var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    var isInitialVirtual = isVirtual && initial;
    // Update Index
    if (!isInitialVirtual && (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate)) {
        swiper.updateActiveIndex(slideIndex);
        // Update Height
        if (params.autoHeight) swiper.updateAutoHeight();
        swiper.updateSlidesClasses();
        if (params.effect !== 'slide') swiper.setTranslate(translate);
        if (direction !== 'reset') {
            swiper.transitionStart(runCallbacks, direction);
            swiper.transitionEnd(runCallbacks, direction);
        }
        return false;
    }
    if (params.cssMode) {
        var isH = swiper.isHorizontal();
        var t = rtl ? translate : -translate;
        if (speed === 0) {
            if (isVirtual) {
                swiper.wrapperEl.style.scrollSnapType = 'none';
                swiper._immediateVirtual = true;
            }
            if (isVirtual && !swiper._cssModeVirtualInitialSet && swiper.params.initialSlide > 0) {
                swiper._cssModeVirtualInitialSet = true;
                requestAnimationFrame(function() {
                    wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
                });
            } else wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
            if (isVirtual) requestAnimationFrame(function() {
                swiper.wrapperEl.style.scrollSnapType = '';
                swiper._immediateVirtual = false;
            });
        } else {
            if (!swiper.support.smoothScroll) {
                (0, _utilsMjs.t)({
                    swiper: swiper,
                    targetPosition: t,
                    side: isH ? 'left' : 'top'
                });
                return true;
            }
            var _obj;
            wrapperEl.scrollTo((_obj = {}, (0, _defineProperty._)(_obj, isH ? 'left' : 'top', t), (0, _defineProperty._)(_obj, "behavior", 'smooth'), _obj));
        }
        return true;
    }
    var browser = getBrowser();
    var isSafari = browser.isSafari;
    if (isVirtual && !initial && isSafari && swiper.isElement) swiper.virtual.update(false, false, slideIndex);
    swiper.setTransition(speed);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit('beforeTransitionStart', speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    if (speed === 0) swiper.transitionEnd(runCallbacks, direction);
    else if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onSlideToWrapperTransitionEnd) swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) return;
            if (e.target !== this) return;
            swiper.wrapperEl.removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
            swiper.onSlideToWrapperTransitionEnd = null;
            delete swiper.onSlideToWrapperTransitionEnd;
            swiper.transitionEnd(runCallbacks, direction);
        };
        swiper.wrapperEl.addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
    }
    return true;
}
function slideToLoop(index, speed, runCallbacks, internal) {
    if (index === void 0) index = 0;
    if (runCallbacks === void 0) runCallbacks = true;
    if (typeof index === 'string') {
        var indexAsNumber = parseInt(index, 10);
        index = indexAsNumber;
    }
    var swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    var gridEnabled = swiper.grid && swiper.params.grid && swiper.params.grid.rows > 1;
    var newIndex = index;
    if (swiper.params.loop) {
        if (swiper.virtual && swiper.params.virtual.enabled) // eslint-disable-next-line
        newIndex = newIndex + swiper.virtual.slidesBefore;
        else {
            var targetSlideIndex;
            if (gridEnabled) {
                var slideIndex = newIndex * swiper.params.grid.rows;
                targetSlideIndex = swiper.slides.find(function(slideEl) {
                    return slideEl.getAttribute('data-swiper-slide-index') * 1 === slideIndex;
                }).column;
            } else targetSlideIndex = swiper.getSlideIndexByData(newIndex);
            var cols = gridEnabled ? Math.ceil(swiper.slides.length / swiper.params.grid.rows) : swiper.slides.length;
            var centeredSlides = swiper.params.centeredSlides;
            var slidesPerView = swiper.params.slidesPerView;
            if (slidesPerView === 'auto') slidesPerView = swiper.slidesPerViewDynamic();
            else {
                slidesPerView = Math.ceil(parseFloat(swiper.params.slidesPerView, 10));
                if (centeredSlides && slidesPerView % 2 === 0) slidesPerView = slidesPerView + 1;
            }
            var needLoopFix = cols - targetSlideIndex < slidesPerView;
            if (centeredSlides) needLoopFix = needLoopFix || targetSlideIndex < Math.ceil(slidesPerView / 2);
            if (internal && centeredSlides && swiper.params.slidesPerView !== 'auto' && !gridEnabled) needLoopFix = false;
            if (needLoopFix) {
                var direction = centeredSlides ? targetSlideIndex < swiper.activeIndex ? 'prev' : 'next' : targetSlideIndex - swiper.activeIndex - 1 < swiper.params.slidesPerView ? 'next' : 'prev';
                swiper.loopFix({
                    direction: direction,
                    slideTo: true,
                    activeSlideIndex: direction === 'next' ? targetSlideIndex + 1 : targetSlideIndex - cols + 1,
                    slideRealIndex: direction === 'next' ? swiper.realIndex : undefined
                });
            }
            if (gridEnabled) {
                var slideIndex1 = newIndex * swiper.params.grid.rows;
                newIndex = swiper.slides.find(function(slideEl) {
                    return slideEl.getAttribute('data-swiper-slide-index') * 1 === slideIndex1;
                }).column;
            } else newIndex = swiper.getSlideIndexByData(newIndex);
        }
    }
    requestAnimationFrame(function() {
        swiper.slideTo(newIndex, speed, runCallbacks, internal);
    });
    return swiper;
}
/* eslint no-unused-vars: "off" */ function slideNext(speed, runCallbacks, internal) {
    if (runCallbacks === void 0) runCallbacks = true;
    var swiper = this;
    var enabled = swiper.enabled, params = swiper.params, animating = swiper.animating;
    if (!enabled || swiper.destroyed) return swiper;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    var perGroup = params.slidesPerGroup;
    if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) perGroup = Math.max(swiper.slidesPerViewDynamic('current', true), 1);
    var increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
    var isVirtual = swiper.virtual && params.virtual.enabled;
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
            direction: 'next'
        });
        // eslint-disable-next-line
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
        if (swiper.activeIndex === swiper.slides.length - 1 && params.cssMode) {
            requestAnimationFrame(function() {
                swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
            });
            return true;
        }
    }
    if (params.rewind && swiper.isEnd) return swiper.slideTo(0, speed, runCallbacks, internal);
    return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function slidePrev(speed, runCallbacks, internal) {
    if (runCallbacks === void 0) runCallbacks = true;
    var swiper = this;
    var params = swiper.params, snapGrid = swiper.snapGrid, slidesGrid = swiper.slidesGrid, rtlTranslate = swiper.rtlTranslate, enabled = swiper.enabled, animating = swiper.animating;
    if (!enabled || swiper.destroyed) return swiper;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    var isVirtual = swiper.virtual && params.virtual.enabled;
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
            direction: 'prev'
        });
        // eslint-disable-next-line
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
    }
    var translate = rtlTranslate ? swiper.translate : -swiper.translate;
    function normalize(val) {
        if (val < 0) return -Math.floor(Math.abs(val));
        return Math.floor(val);
    }
    var normalizedTranslate = normalize(translate);
    var normalizedSnapGrid = snapGrid.map(function(val) {
        return normalize(val);
    });
    var isFreeMode = params.freeMode && params.freeMode.enabled;
    var prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    if (typeof prevSnap === 'undefined' && (params.cssMode || isFreeMode)) {
        var prevSnapIndex;
        snapGrid.forEach(function(snap, snapIndex) {
            if (normalizedTranslate >= snap) // prevSnap = snap;
            prevSnapIndex = snapIndex;
        });
        if (typeof prevSnapIndex !== 'undefined') prevSnap = isFreeMode ? snapGrid[prevSnapIndex] : snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
    var prevIndex = 0;
    if (typeof prevSnap !== 'undefined') {
        prevIndex = slidesGrid.indexOf(prevSnap);
        if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
        if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
            prevIndex = prevIndex - swiper.slidesPerViewDynamic('previous', true) + 1;
            prevIndex = Math.max(prevIndex, 0);
        }
    }
    if (params.rewind && swiper.isBeginning) {
        var lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
    } else if (params.loop && swiper.activeIndex === 0 && params.cssMode) {
        requestAnimationFrame(function() {
            swiper.slideTo(prevIndex, speed, runCallbacks, internal);
        });
        return true;
    }
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function slideReset(speed, runCallbacks, internal) {
    if (runCallbacks === void 0) runCallbacks = true;
    var swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function slideToClosest(speed, runCallbacks, internal, threshold) {
    if (runCallbacks === void 0) runCallbacks = true;
    if (threshold === void 0) threshold = 0.5;
    var swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    var index = swiper.activeIndex;
    var skip = Math.min(swiper.params.slidesPerGroupSkip, index);
    var snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
    var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    if (translate >= swiper.snapGrid[snapIndex]) {
        // The current translate is on or after the current snap index, so the choice
        // is between the current index and the one after it.
        var currentSnap = swiper.snapGrid[snapIndex];
        var nextSnap = swiper.snapGrid[snapIndex + 1];
        if (translate - currentSnap > (nextSnap - currentSnap) * threshold) index += swiper.params.slidesPerGroup;
    } else {
        // The current translate is before the current snap index, so the choice
        // is between the current index and the one before it.
        var prevSnap = swiper.snapGrid[snapIndex - 1];
        var currentSnap1 = swiper.snapGrid[snapIndex];
        if (translate - prevSnap <= (currentSnap1 - prevSnap) * threshold) index -= swiper.params.slidesPerGroup;
    }
    index = Math.max(index, 0);
    index = Math.min(index, swiper.slidesGrid.length - 1);
    return swiper.slideTo(index, speed, runCallbacks, internal);
}
function slideToClickedSlide() {
    var swiper = this;
    if (swiper.destroyed) return;
    var params = swiper.params, slidesEl = swiper.slidesEl;
    var slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    var slideToIndex = swiper.clickedIndex;
    var realIndex;
    var slideSelector = swiper.isElement ? `swiper-slide` : `.${params.slideClass}`;
    if (params.loop) {
        if (swiper.animating) return;
        realIndex = parseInt(swiper.clickedSlide.getAttribute('data-swiper-slide-index'), 10);
        if (params.centeredSlides) {
            if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
                swiper.loopFix();
                slideToIndex = swiper.getSlideIndex((0, _utilsMjs.e)(slidesEl, `${slideSelector}[data-swiper-slide-index="${realIndex}"]`)[0]);
                (0, _utilsMjs.n)(function() {
                    swiper.slideTo(slideToIndex);
                });
            } else swiper.slideTo(slideToIndex);
        } else if (slideToIndex > swiper.slides.length - slidesPerView) {
            swiper.loopFix();
            slideToIndex = swiper.getSlideIndex((0, _utilsMjs.e)(slidesEl, `${slideSelector}[data-swiper-slide-index="${realIndex}"]`)[0]);
            (0, _utilsMjs.n)(function() {
                swiper.slideTo(slideToIndex);
            });
        } else swiper.slideTo(slideToIndex);
    } else swiper.slideTo(slideToIndex);
}
var slide = {
    slideTo: slideTo,
    slideToLoop: slideToLoop,
    slideNext: slideNext,
    slidePrev: slidePrev,
    slideReset: slideReset,
    slideToClosest: slideToClosest,
    slideToClickedSlide: slideToClickedSlide
};
function loopCreate(slideRealIndex, initial) {
    var swiper = this;
    var params = swiper.params, slidesEl = swiper.slidesEl;
    if (!params.loop || swiper.virtual && swiper.params.virtual.enabled) return;
    var initSlides = function() {
        var slides = (0, _utilsMjs.e)(slidesEl, `.${params.slideClass}, swiper-slide`);
        slides.forEach(function(el, index) {
            el.setAttribute('data-swiper-slide-index', index);
        });
    };
    var gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    var slidesPerGroup = params.slidesPerGroup * (gridEnabled ? params.grid.rows : 1);
    var shouldFillGroup = swiper.slides.length % slidesPerGroup !== 0;
    var shouldFillGrid = gridEnabled && swiper.slides.length % params.grid.rows !== 0;
    var addBlankSlides = function(amountOfSlides) {
        for(var i = 0; i < amountOfSlides; i += 1){
            var slideEl = swiper.isElement ? (0, _utilsMjs.c)('swiper-slide', [
                params.slideBlankClass
            ]) : (0, _utilsMjs.c)('div', [
                params.slideClass,
                params.slideBlankClass
            ]);
            swiper.slidesEl.append(slideEl);
        }
    };
    if (shouldFillGroup) {
        if (params.loopAddBlankSlides) {
            var slidesToAdd = slidesPerGroup - swiper.slides.length % slidesPerGroup;
            addBlankSlides(slidesToAdd);
            swiper.recalcSlides();
            swiper.updateSlides();
        } else (0, _utilsMjs.u)('Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)');
        initSlides();
    } else if (shouldFillGrid) {
        if (params.loopAddBlankSlides) {
            var slidesToAdd1 = params.grid.rows - swiper.slides.length % params.grid.rows;
            addBlankSlides(slidesToAdd1);
            swiper.recalcSlides();
            swiper.updateSlides();
        } else (0, _utilsMjs.u)('Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)');
        initSlides();
    } else initSlides();
    swiper.loopFix({
        slideRealIndex: slideRealIndex,
        direction: params.centeredSlides ? undefined : 'next',
        initial: initial
    });
}
function loopFix(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, slideRealIndex = _ref.slideRealIndex, _ref_slideTo = _ref.slideTo, _$slideTo = _ref_slideTo === void 0 ? true : _ref_slideTo, direction = _ref.direction, _$setTranslate = _ref.setTranslate, activeSlideIndex = _ref.activeSlideIndex, initial = _ref.initial, byController = _ref.byController, byMousewheel = _ref.byMousewheel;
    var swiper = this;
    if (!swiper.params.loop) return;
    swiper.emit('beforeLoopFix');
    var slides = swiper.slides, allowSlidePrev = swiper.allowSlidePrev, allowSlideNext = swiper.allowSlideNext, slidesEl = swiper.slidesEl, params = swiper.params;
    var centeredSlides = params.centeredSlides, initialSlide = params.initialSlide;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;
    if (swiper.virtual && params.virtual.enabled) {
        if (_$slideTo) {
            if (!params.centeredSlides && swiper.snapIndex === 0) swiper.slideTo(swiper.virtual.slides.length, 0, false, true);
            else if (params.centeredSlides && swiper.snapIndex < params.slidesPerView) swiper.slideTo(swiper.virtual.slides.length + swiper.snapIndex, 0, false, true);
            else if (swiper.snapIndex === swiper.snapGrid.length - 1) swiper.slideTo(swiper.virtual.slidesBefore, 0, false, true);
        }
        swiper.allowSlidePrev = allowSlidePrev;
        swiper.allowSlideNext = allowSlideNext;
        swiper.emit('loopFix');
        return;
    }
    var slidesPerView = params.slidesPerView;
    if (slidesPerView === 'auto') slidesPerView = swiper.slidesPerViewDynamic();
    else {
        slidesPerView = Math.ceil(parseFloat(params.slidesPerView, 10));
        if (centeredSlides && slidesPerView % 2 === 0) slidesPerView = slidesPerView + 1;
    }
    var slidesPerGroup = params.slidesPerGroupAuto ? slidesPerView : params.slidesPerGroup;
    var loopedSlides = slidesPerGroup;
    if (loopedSlides % slidesPerGroup !== 0) loopedSlides += slidesPerGroup - loopedSlides % slidesPerGroup;
    loopedSlides += params.loopAdditionalSlides;
    swiper.loopedSlides = loopedSlides;
    var gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    if (slides.length < slidesPerView + loopedSlides || swiper.params.effect === 'cards' && slides.length < slidesPerView + loopedSlides * 2) (0, _utilsMjs.u)('Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled or not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters');
    else if (gridEnabled && params.grid.fill === 'row') (0, _utilsMjs.u)('Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`');
    var prependSlidesIndexes = [];
    var appendSlidesIndexes = [];
    var cols = gridEnabled ? Math.ceil(slides.length / params.grid.rows) : slides.length;
    var isInitialOverflow = initial && cols - initialSlide < slidesPerView && !centeredSlides;
    var activeIndex = isInitialOverflow ? initialSlide : swiper.activeIndex;
    if (typeof activeSlideIndex === 'undefined') activeSlideIndex = swiper.getSlideIndex(slides.find(function(el) {
        return el.classList.contains(params.slideActiveClass);
    }));
    else activeIndex = activeSlideIndex;
    var isNext = direction === 'next' || !direction;
    var isPrev = direction === 'prev' || !direction;
    var slidesPrepended = 0;
    var slidesAppended = 0;
    var activeColIndex = gridEnabled ? slides[activeSlideIndex].column : activeSlideIndex;
    var activeColIndexWithShift = activeColIndex + (centeredSlides && typeof _$setTranslate === 'undefined' ? -slidesPerView / 2 + 0.5 : 0);
    // prepend last slides before start
    if (activeColIndexWithShift < loopedSlides) {
        slidesPrepended = Math.max(loopedSlides - activeColIndexWithShift, slidesPerGroup);
        for(var i = 0; i < loopedSlides - activeColIndexWithShift; i += 1){
            var index = i - Math.floor(i / cols) * cols;
            if (gridEnabled) {
                var colIndexToPrepend = cols - index - 1;
                for(var i1 = slides.length - 1; i1 >= 0; i1 -= 1)if (slides[i1].column === colIndexToPrepend) prependSlidesIndexes.push(i1);
            // slides.forEach((slide, slideIndex) => {
            //   if (slide.column === colIndexToPrepend) prependSlidesIndexes.push(slideIndex);
            // });
            } else prependSlidesIndexes.push(cols - index - 1);
        }
    } else if (activeColIndexWithShift + slidesPerView > cols - loopedSlides) {
        var _loop = function(i2) {
            var index = i2 - Math.floor(i2 / cols) * cols;
            if (gridEnabled) slides.forEach(function(slide, slideIndex) {
                if (slide.column === index) appendSlidesIndexes.push(slideIndex);
            });
            else appendSlidesIndexes.push(index);
        };
        slidesAppended = Math.max(activeColIndexWithShift - (cols - loopedSlides * 2), slidesPerGroup);
        if (isInitialOverflow) slidesAppended = Math.max(slidesAppended, slidesPerView - cols + initialSlide + 1);
        for(var i2 = 0; i2 < slidesAppended; i2 += 1)_loop(i2);
    }
    swiper.__preventObserver__ = true;
    requestAnimationFrame(function() {
        swiper.__preventObserver__ = false;
    });
    if (swiper.params.effect === 'cards' && slides.length < slidesPerView + loopedSlides * 2) {
        if (appendSlidesIndexes.includes(activeSlideIndex)) appendSlidesIndexes.splice(appendSlidesIndexes.indexOf(activeSlideIndex), 1);
        if (prependSlidesIndexes.includes(activeSlideIndex)) prependSlidesIndexes.splice(prependSlidesIndexes.indexOf(activeSlideIndex), 1);
    }
    if (isPrev) prependSlidesIndexes.forEach(function(index) {
        slides[index].swiperLoopMoveDOM = true;
        slidesEl.prepend(slides[index]);
        slides[index].swiperLoopMoveDOM = false;
    });
    if (isNext) appendSlidesIndexes.forEach(function(index) {
        slides[index].swiperLoopMoveDOM = true;
        slidesEl.append(slides[index]);
        slides[index].swiperLoopMoveDOM = false;
    });
    swiper.recalcSlides();
    if (params.slidesPerView === 'auto') swiper.updateSlides();
    else if (gridEnabled && (prependSlidesIndexes.length > 0 && isPrev || appendSlidesIndexes.length > 0 && isNext)) swiper.slides.forEach(function(slide, slideIndex) {
        swiper.grid.updateSlide(slideIndex, slide, swiper.slides);
    });
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    if (_$slideTo) {
        if (prependSlidesIndexes.length > 0 && isPrev) {
            if (typeof slideRealIndex === 'undefined') {
                var currentSlideTranslate = swiper.slidesGrid[activeIndex];
                var newSlideTranslate = swiper.slidesGrid[activeIndex + slidesPrepended];
                var diff = newSlideTranslate - currentSlideTranslate;
                if (byMousewheel) swiper.setTranslate(swiper.translate - diff);
                else {
                    swiper.slideTo(activeIndex + Math.ceil(slidesPrepended), 0, false, true);
                    if (_$setTranslate) {
                        swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
                        swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
                    }
                }
            } else if (_$setTranslate) {
                var shift = gridEnabled ? prependSlidesIndexes.length / params.grid.rows : prependSlidesIndexes.length;
                swiper.slideTo(swiper.activeIndex + shift, 0, false, true);
                swiper.touchEventsData.currentTranslate = swiper.translate;
            }
        } else if (appendSlidesIndexes.length > 0 && isNext) {
            if (typeof slideRealIndex === 'undefined') {
                var currentSlideTranslate1 = swiper.slidesGrid[activeIndex];
                var newSlideTranslate1 = swiper.slidesGrid[activeIndex - slidesAppended];
                var diff1 = newSlideTranslate1 - currentSlideTranslate1;
                if (byMousewheel) swiper.setTranslate(swiper.translate - diff1);
                else {
                    swiper.slideTo(activeIndex - slidesAppended, 0, false, true);
                    if (_$setTranslate) {
                        swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff1;
                        swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff1;
                    }
                }
            } else {
                var shift1 = gridEnabled ? appendSlidesIndexes.length / params.grid.rows : appendSlidesIndexes.length;
                swiper.slideTo(swiper.activeIndex - shift1, 0, false, true);
            }
        }
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.controller && swiper.controller.control && !byController) {
        var loopParams = {
            slideRealIndex: slideRealIndex,
            direction: direction,
            setTranslate: _$setTranslate,
            activeSlideIndex: activeSlideIndex,
            byController: true
        };
        if (Array.isArray(swiper.controller.control)) swiper.controller.control.forEach(function(c) {
            if (!c.destroyed && c.params.loop) c.loopFix((0, _objectSpreadProps._)((0, _objectSpread._)({}, loopParams), {
                slideTo: c.params.slidesPerView === params.slidesPerView ? _$slideTo : false
            }));
        });
        else if (swiper.controller.control instanceof swiper.constructor && swiper.controller.control.params.loop) swiper.controller.control.loopFix((0, _objectSpreadProps._)((0, _objectSpread._)({}, loopParams), {
            slideTo: swiper.controller.control.params.slidesPerView === params.slidesPerView ? _$slideTo : false
        }));
    }
    swiper.emit('loopFix');
}
function loopDestroy() {
    var swiper = this;
    var params = swiper.params, slidesEl = swiper.slidesEl;
    if (!params.loop || !slidesEl || swiper.virtual && swiper.params.virtual.enabled) return;
    swiper.recalcSlides();
    var newSlidesOrder = [];
    swiper.slides.forEach(function(slideEl) {
        var index = typeof slideEl.swiperSlideIndex === 'undefined' ? slideEl.getAttribute('data-swiper-slide-index') * 1 : slideEl.swiperSlideIndex;
        newSlidesOrder[index] = slideEl;
    });
    swiper.slides.forEach(function(slideEl) {
        slideEl.removeAttribute('data-swiper-slide-index');
    });
    newSlidesOrder.forEach(function(slideEl) {
        slidesEl.append(slideEl);
    });
    swiper.recalcSlides();
    swiper.slideTo(swiper.realIndex, 0);
}
var loop = {
    loopCreate: loopCreate,
    loopFix: loopFix,
    loopDestroy: loopDestroy
};
function setGrabCursor(moving) {
    var swiper = this;
    if (!swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    var el = swiper.params.touchEventsTarget === 'container' ? swiper.el : swiper.wrapperEl;
    if (swiper.isElement) swiper.__preventObserver__ = true;
    el.style.cursor = 'move';
    el.style.cursor = moving ? 'grabbing' : 'grab';
    if (swiper.isElement) requestAnimationFrame(function() {
        swiper.__preventObserver__ = false;
    });
}
function unsetGrabCursor() {
    var swiper = this;
    if (swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    if (swiper.isElement) swiper.__preventObserver__ = true;
    swiper[swiper.params.touchEventsTarget === 'container' ? 'el' : 'wrapperEl'].style.cursor = '';
    if (swiper.isElement) requestAnimationFrame(function() {
        swiper.__preventObserver__ = false;
    });
}
var grabCursor = {
    setGrabCursor: setGrabCursor,
    unsetGrabCursor: unsetGrabCursor
};
// Modified from https://stackoverflow.com/questions/54520554/custom-element-getrootnode-closest-function-crossing-multiple-parent-shadowd
function closestElement(selector, base) {
    if (base === void 0) base = this;
    function __closestFrom(el) {
        if (!el || el === (0, _ssrWindowEsmMjs.g)() || el === (0, _ssrWindowEsmMjs.a)()) return null;
        if (el.assignedSlot) el = el.assignedSlot;
        var found = el.closest(selector);
        if (!found && !el.getRootNode) return null;
        return found || __closestFrom(el.getRootNode().host);
    }
    return __closestFrom(base);
}
function preventEdgeSwipe(swiper, event, startX) {
    var window1 = (0, _ssrWindowEsmMjs.a)();
    var params = swiper.params;
    var edgeSwipeDetection = params.edgeSwipeDetection;
    var edgeSwipeThreshold = params.edgeSwipeThreshold;
    if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window1.innerWidth - edgeSwipeThreshold)) {
        if (edgeSwipeDetection === 'prevent') {
            event.preventDefault();
            return true;
        }
        return false;
    }
    return true;
}
function onTouchStart(event) {
    var swiper = this;
    var document1 = (0, _ssrWindowEsmMjs.g)();
    var e = event;
    if (e.originalEvent) e = e.originalEvent;
    var data = swiper.touchEventsData;
    if (e.type === 'pointerdown') {
        if (data.pointerId !== null && data.pointerId !== e.pointerId) return;
        data.pointerId = e.pointerId;
    } else if (e.type === 'touchstart' && e.targetTouches.length === 1) data.touchId = e.targetTouches[0].identifier;
    if (e.type === 'touchstart') {
        // don't proceed touch event
        preventEdgeSwipe(swiper, e, e.targetTouches[0].pageX);
        return;
    }
    var params = swiper.params, touches = swiper.touches, enabled = swiper.enabled;
    if (!enabled) return;
    if (!params.simulateTouch && e.pointerType === 'mouse') return;
    if (swiper.animating && params.preventInteractionOnTransition) return;
    if (!swiper.animating && params.cssMode && params.loop) swiper.loopFix();
    var targetEl = e.target;
    if (params.touchEventsTarget === 'wrapper') {
        if (!(0, _utilsMjs.v)(targetEl, swiper.wrapperEl)) return;
    }
    if ('which' in e && e.which === 3) return;
    if ('button' in e && e.button > 0) return;
    if (data.isTouched && data.isMoved) return;
    // change target el for shadow root component
    var swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== '';
    // eslint-disable-next-line
    var eventPath = e.composedPath ? e.composedPath() : e.path;
    if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) targetEl = eventPath[0];
    var noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
    var isTargetShadow = !!(e.target && e.target.shadowRoot);
    // use closestElement for shadow root element to get the actual closest for nested shadow root element
    if (params.noSwiping && (isTargetShadow ? closestElement(noSwipingSelector, targetEl) : targetEl.closest(noSwipingSelector))) {
        swiper.allowClick = true;
        return;
    }
    if (params.swipeHandler) {
        if (!targetEl.closest(params.swipeHandler)) return;
    }
    touches.currentX = e.pageX;
    touches.currentY = e.pageY;
    var startX = touches.currentX;
    var startY = touches.currentY;
    // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore
    if (!preventEdgeSwipe(swiper, e, startX)) return;
    Object.assign(data, {
        isTouched: true,
        isMoved: false,
        allowTouchCallbacks: true,
        isScrolling: undefined,
        startMoving: undefined
    });
    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = (0, _utilsMjs.d)();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = undefined;
    if (params.threshold > 0) data.allowThresholdMove = false;
    var preventDefault = true;
    if (targetEl.matches(data.focusableElements)) {
        preventDefault = false;
        if (targetEl.nodeName === 'SELECT') data.isTouched = false;
    }
    if (document1.activeElement && document1.activeElement.matches(data.focusableElements) && document1.activeElement !== targetEl && (e.pointerType === 'mouse' || e.pointerType !== 'mouse' && !targetEl.matches(data.focusableElements))) document1.activeElement.blur();
    var shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
    if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !targetEl.isContentEditable) e.preventDefault();
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) swiper.freeMode.onTouchStart();
    swiper.emit('touchStart', e);
}
function onTouchMove(event) {
    var document1 = (0, _ssrWindowEsmMjs.g)();
    var swiper = this;
    var data = swiper.touchEventsData;
    var params = swiper.params, touches = swiper.touches, rtl = swiper.rtlTranslate, enabled = swiper.enabled;
    if (!enabled) return;
    if (!params.simulateTouch && event.pointerType === 'mouse') return;
    var e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (e.type === 'pointermove') {
        if (data.touchId !== null) return; // return from pointer if we use touch
        var id = e.pointerId;
        if (id !== data.pointerId) return;
    }
    var targetTouch;
    if (e.type === 'touchmove') {
        targetTouch = (0, _toConsumableArray._)(e.changedTouches).find(function(t) {
            return t.identifier === data.touchId;
        });
        if (!targetTouch || targetTouch.identifier !== data.touchId) return;
    } else targetTouch = e;
    if (!data.isTouched) {
        if (data.startMoving && data.isScrolling) swiper.emit('touchMoveOpposite', e);
        return;
    }
    var pageX = targetTouch.pageX;
    var pageY = targetTouch.pageY;
    if (e.preventedByNestedSwiper) {
        touches.startX = pageX;
        touches.startY = pageY;
        return;
    }
    if (!swiper.allowTouchMove) {
        if (!e.target.matches(data.focusableElements)) swiper.allowClick = false;
        if (data.isTouched) {
            Object.assign(touches, {
                startX: pageX,
                startY: pageY,
                currentX: pageX,
                currentY: pageY
            });
            data.touchStartTime = (0, _utilsMjs.d)();
        }
        return;
    }
    if (params.touchReleaseOnEdges && !params.loop) {
        if (swiper.isVertical()) // Vertical
        {
            if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
                data.isTouched = false;
                data.isMoved = false;
                return;
            }
        } else if (rtl && (pageX > touches.startX && -swiper.translate <= swiper.maxTranslate() || pageX < touches.startX && -swiper.translate >= swiper.minTranslate())) return;
        else if (!rtl && (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate())) return;
    }
    if (document1.activeElement && document1.activeElement.matches(data.focusableElements) && document1.activeElement !== e.target && e.pointerType !== 'mouse') document1.activeElement.blur();
    if (document1.activeElement) {
        if (e.target === document1.activeElement && e.target.matches(data.focusableElements)) {
            data.isMoved = true;
            swiper.allowClick = false;
            return;
        }
    }
    if (data.allowTouchCallbacks) swiper.emit('touchMove', e);
    touches.previousX = touches.currentX;
    touches.previousY = touches.currentY;
    touches.currentX = pageX;
    touches.currentY = pageY;
    var diffX = touches.currentX - touches.startX;
    var diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt(Math.pow(diffX, 2) + Math.pow(diffY, 2)) < swiper.params.threshold) return;
    if (typeof data.isScrolling === 'undefined') {
        var touchAngle;
        if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) data.isScrolling = false;
        else // eslint-disable-next-line
        if (diffX * diffX + diffY * diffY >= 25) {
            touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
            data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
        }
    }
    if (data.isScrolling) swiper.emit('touchMoveOpposite', e);
    if (typeof data.startMoving === 'undefined') {
        if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) data.startMoving = true;
    }
    if (data.isScrolling || e.type === 'touchmove' && data.preventTouchMoveFromPointerMove) {
        data.isTouched = false;
        return;
    }
    if (!data.startMoving) return;
    swiper.allowClick = false;
    if (!params.cssMode && e.cancelable) e.preventDefault();
    if (params.touchMoveStopPropagation && !params.nested) e.stopPropagation();
    var diff = swiper.isHorizontal() ? diffX : diffY;
    var touchesDiff = swiper.isHorizontal() ? touches.currentX - touches.previousX : touches.currentY - touches.previousY;
    if (params.oneWayMovement) {
        diff = Math.abs(diff) * (rtl ? 1 : -1);
        touchesDiff = Math.abs(touchesDiff) * (rtl ? 1 : -1);
    }
    touches.diff = diff;
    diff *= params.touchRatio;
    if (rtl) {
        diff = -diff;
        touchesDiff = -touchesDiff;
    }
    var prevTouchesDirection = swiper.touchesDirection;
    swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
    swiper.touchesDirection = touchesDiff > 0 ? 'prev' : 'next';
    var isLoop = swiper.params.loop && !params.cssMode;
    var allowLoopFix = swiper.touchesDirection === 'next' && swiper.allowSlideNext || swiper.touchesDirection === 'prev' && swiper.allowSlidePrev;
    if (!data.isMoved) {
        if (isLoop && allowLoopFix) swiper.loopFix({
            direction: swiper.swipeDirection
        });
        data.startTranslate = swiper.getTranslate();
        swiper.setTransition(0);
        if (swiper.animating) {
            var evt = new window.CustomEvent('transitionend', {
                bubbles: true,
                cancelable: true,
                detail: {
                    bySwiperTouchMove: true
                }
            });
            swiper.wrapperEl.dispatchEvent(evt);
        }
        data.allowMomentumBounce = false;
        // Grab Cursor
        if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(true);
        swiper.emit('sliderFirstMove', e);
    }
    var loopFixed;
    new Date().getTime();
    if (params._loopSwapReset !== false && data.isMoved && data.allowThresholdMove && prevTouchesDirection !== swiper.touchesDirection && isLoop && allowLoopFix && Math.abs(diff) >= 1) {
        Object.assign(touches, {
            startX: pageX,
            startY: pageY,
            currentX: pageX,
            currentY: pageY,
            startTranslate: data.currentTranslate
        });
        data.loopSwapReset = true;
        data.startTranslate = data.currentTranslate;
        return;
    }
    swiper.emit('sliderMove', e);
    data.isMoved = true;
    data.currentTranslate = diff + data.startTranslate;
    var disableParentSwiper = true;
    var resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) resistanceRatio = 0;
    if (diff > 0) {
        if (isLoop && allowLoopFix && !loopFixed && data.allowThresholdMove && data.currentTranslate > (params.centeredSlides ? swiper.minTranslate() - swiper.slidesSizesGrid[swiper.activeIndex + 1] - (params.slidesPerView !== 'auto' && swiper.slides.length - params.slidesPerView >= 2 ? swiper.slidesSizesGrid[swiper.activeIndex + 1] + swiper.params.spaceBetween : 0) - swiper.params.spaceBetween : swiper.minTranslate())) swiper.loopFix({
            direction: 'prev',
            setTranslate: true,
            activeSlideIndex: 0
        });
        if (data.currentTranslate > swiper.minTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + Math.pow(-swiper.minTranslate() + data.startTranslate + diff, resistanceRatio);
        }
    } else if (diff < 0) {
        if (isLoop && allowLoopFix && !loopFixed && data.allowThresholdMove && data.currentTranslate < (params.centeredSlides ? swiper.maxTranslate() + swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] + swiper.params.spaceBetween + (params.slidesPerView !== 'auto' && swiper.slides.length - params.slidesPerView >= 2 ? swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] + swiper.params.spaceBetween : 0) : swiper.maxTranslate())) swiper.loopFix({
            direction: 'next',
            setTranslate: true,
            activeSlideIndex: swiper.slides.length - (params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : Math.ceil(parseFloat(params.slidesPerView, 10)))
        });
        if (data.currentTranslate < swiper.maxTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - Math.pow(swiper.maxTranslate() - data.startTranslate - diff, resistanceRatio);
        }
    }
    if (disableParentSwiper) e.preventedByNestedSwiper = true;
    // Directions locks
    if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && !swiper.allowSlideNext) data.currentTranslate = data.startTranslate;
    // Threshold
    if (params.threshold > 0) {
        if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
            if (!data.allowThresholdMove) {
                data.allowThresholdMove = true;
                touches.startX = touches.currentX;
                touches.startY = touches.currentY;
                data.currentTranslate = data.startTranslate;
                touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
                return;
            }
        } else {
            data.currentTranslate = data.startTranslate;
            return;
        }
    }
    if (!params.followFinger || params.cssMode) return;
    // Update active index in free mode
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode) swiper.freeMode.onTouchMove();
    // Update progress
    swiper.updateProgress(data.currentTranslate);
    // Update translate
    swiper.setTranslate(data.currentTranslate);
}
function onTouchEnd(event) {
    var swiper = this;
    var data = swiper.touchEventsData;
    var e = event;
    if (e.originalEvent) e = e.originalEvent;
    var targetTouch;
    var isTouchEvent = e.type === 'touchend' || e.type === 'touchcancel';
    if (!isTouchEvent) {
        if (data.touchId !== null) return; // return from pointer if we use touch
        if (e.pointerId !== data.pointerId) return;
        targetTouch = e;
    } else {
        targetTouch = (0, _toConsumableArray._)(e.changedTouches).find(function(t) {
            return t.identifier === data.touchId;
        });
        if (!targetTouch || targetTouch.identifier !== data.touchId) return;
    }
    if ([
        'pointercancel',
        'pointerout',
        'pointerleave',
        'contextmenu'
    ].includes(e.type)) {
        var proceed = [
            'pointercancel',
            'contextmenu'
        ].includes(e.type) && (swiper.browser.isSafari || swiper.browser.isWebView);
        if (!proceed) return;
    }
    data.pointerId = null;
    data.touchId = null;
    var params = swiper.params, touches = swiper.touches, rtl = swiper.rtlTranslate, slidesGrid = swiper.slidesGrid, enabled = swiper.enabled;
    if (!enabled) return;
    if (!params.simulateTouch && e.pointerType === 'mouse') return;
    if (data.allowTouchCallbacks) swiper.emit('touchEnd', e);
    data.allowTouchCallbacks = false;
    if (!data.isTouched) {
        if (data.isMoved && params.grabCursor) swiper.setGrabCursor(false);
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    // Return Grab Cursor
    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(false);
    // Time diff
    var touchEndTime = (0, _utilsMjs.d)();
    var timeDiff = touchEndTime - data.touchStartTime;
    // Tap, doubleTap, Click
    if (swiper.allowClick) {
        var pathTree = e.path || e.composedPath && e.composedPath();
        swiper.updateClickedSlide(pathTree && pathTree[0] || e.target, pathTree);
        swiper.emit('tap click', e);
        if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) swiper.emit('doubleTap doubleClick', e);
    }
    data.lastClickTime = (0, _utilsMjs.d)();
    (0, _utilsMjs.n)(function() {
        if (!swiper.destroyed) swiper.allowClick = true;
    });
    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 && !data.loopSwapReset || data.currentTranslate === data.startTranslate && !data.loopSwapReset) {
        data.isTouched = false;
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    var currentPos;
    if (params.followFinger) currentPos = rtl ? swiper.translate : -swiper.translate;
    else currentPos = -data.currentTranslate;
    if (params.cssMode) return;
    if (params.freeMode && params.freeMode.enabled) {
        swiper.freeMode.onTouchEnd({
            currentPos: currentPos
        });
        return;
    }
    // Find current slide
    var swipeToLast = currentPos >= -swiper.maxTranslate() && !swiper.params.loop;
    var stopIndex = 0;
    var groupSize = swiper.slidesSizesGrid[0];
    for(var i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup){
        var increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
        if (typeof slidesGrid[i + increment] !== 'undefined') {
            if (swipeToLast || currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
                stopIndex = i;
                groupSize = slidesGrid[i + increment] - slidesGrid[i];
            }
        } else if (swipeToLast || currentPos >= slidesGrid[i]) {
            stopIndex = i;
            groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
        }
    }
    var rewindFirstIndex = null;
    var rewindLastIndex = null;
    if (params.rewind) {
        if (swiper.isBeginning) rewindLastIndex = params.virtual && params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        else if (swiper.isEnd) rewindFirstIndex = 0;
    }
    // Find current slide size
    var ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
    var increment1 = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (timeDiff > params.longSwipesMs) {
        // Long touches
        if (!params.longSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (swiper.swipeDirection === 'next') {
            if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment1);
            else swiper.slideTo(stopIndex);
        }
        if (swiper.swipeDirection === 'prev') {
            if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment1);
            else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) swiper.slideTo(rewindLastIndex);
            else swiper.slideTo(stopIndex);
        }
    } else {
        // Short swipes
        if (!params.shortSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        var isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
        if (!isNavButtonTarget) {
            if (swiper.swipeDirection === 'next') swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment1);
            if (swiper.swipeDirection === 'prev') swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
        } else if (e.target === swiper.navigation.nextEl) swiper.slideTo(stopIndex + increment1);
        else swiper.slideTo(stopIndex);
    }
}
function onResize() {
    var swiper = this;
    var params = swiper.params, el = swiper.el;
    if (el && el.offsetWidth === 0) return;
    // Breakpoints
    if (params.breakpoints) swiper.setBreakpoint();
    // Save locks
    var allowSlideNext = swiper.allowSlideNext, allowSlidePrev = swiper.allowSlidePrev, snapGrid = swiper.snapGrid;
    var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    // Disable locks on resize
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateSlidesClasses();
    var isVirtualLoop = isVirtual && params.loop;
    if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides && !isVirtualLoop) swiper.slideTo(swiper.slides.length - 1, 0, false, true);
    else if (swiper.params.loop && !isVirtual) swiper.slideToLoop(swiper.realIndex, 0, false, true);
    else swiper.slideTo(swiper.activeIndex, 0, false, true);
    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
        clearTimeout(swiper.autoplay.resizeTimeout);
        swiper.autoplay.resizeTimeout = setTimeout(function() {
            if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) swiper.autoplay.resume();
        }, 500);
    }
    // Return locks after resize
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
}
function onClick(e) {
    var swiper = this;
    if (!swiper.enabled) return;
    if (!swiper.allowClick) {
        if (swiper.params.preventClicks) e.preventDefault();
        if (swiper.params.preventClicksPropagation && swiper.animating) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        }
    }
}
function onScroll() {
    var swiper = this;
    var wrapperEl = swiper.wrapperEl, rtlTranslate = swiper.rtlTranslate, enabled = swiper.enabled;
    if (!enabled) return;
    swiper.previousTranslate = swiper.translate;
    if (swiper.isHorizontal()) swiper.translate = -wrapperEl.scrollLeft;
    else swiper.translate = -wrapperEl.scrollTop;
    // eslint-disable-next-line
    if (swiper.translate === 0) swiper.translate = 0;
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
    var newProgress;
    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== swiper.progress) swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
    swiper.emit('setTranslate', swiper.translate, false);
}
function onLoad(e) {
    var swiper = this;
    processLazyPreloader(swiper, e.target);
    if (swiper.params.cssMode || swiper.params.slidesPerView !== 'auto' && !swiper.params.autoHeight) return;
    swiper.update();
}
function onDocumentTouchStart() {
    var swiper = this;
    if (swiper.documentTouchHandlerProceeded) return;
    swiper.documentTouchHandlerProceeded = true;
    if (swiper.params.touchReleaseOnEdges) swiper.el.style.touchAction = 'auto';
}
var events = function(swiper, method) {
    var document1 = (0, _ssrWindowEsmMjs.g)();
    var params = swiper.params, el = swiper.el, wrapperEl = swiper.wrapperEl, device = swiper.device;
    var capture = !!params.nested;
    var domMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
    var swiperMethod = method;
    if (!el || typeof el === 'string') return;
    // Touch Events
    document1[domMethod]('touchstart', swiper.onDocumentTouchStart, {
        passive: false,
        capture: capture
    });
    el[domMethod]('touchstart', swiper.onTouchStart, {
        passive: false
    });
    el[domMethod]('pointerdown', swiper.onTouchStart, {
        passive: false
    });
    document1[domMethod]('touchmove', swiper.onTouchMove, {
        passive: false,
        capture: capture
    });
    document1[domMethod]('pointermove', swiper.onTouchMove, {
        passive: false,
        capture: capture
    });
    document1[domMethod]('touchend', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('pointerup', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('pointercancel', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('touchcancel', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('pointerout', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('pointerleave', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('contextmenu', swiper.onTouchEnd, {
        passive: true
    });
    // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) el[domMethod]('click', swiper.onClick, true);
    if (params.cssMode) wrapperEl[domMethod]('scroll', swiper.onScroll);
    // Resize handler
    if (params.updateOnWindowResize) swiper[swiperMethod](device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', onResize, true);
    else swiper[swiperMethod]('observerUpdate', onResize, true);
    // Images loader
    el[domMethod]('load', swiper.onLoad, {
        capture: true
    });
};
function attachEvents() {
    var swiper = this;
    var params = swiper.params;
    swiper.onTouchStart = onTouchStart.bind(swiper);
    swiper.onTouchMove = onTouchMove.bind(swiper);
    swiper.onTouchEnd = onTouchEnd.bind(swiper);
    swiper.onDocumentTouchStart = onDocumentTouchStart.bind(swiper);
    if (params.cssMode) swiper.onScroll = onScroll.bind(swiper);
    swiper.onClick = onClick.bind(swiper);
    swiper.onLoad = onLoad.bind(swiper);
    events(swiper, 'on');
}
function detachEvents() {
    var swiper = this;
    events(swiper, 'off');
}
var events$1 = {
    attachEvents: attachEvents,
    detachEvents: detachEvents
};
var isGridEnabled = function(swiper, params) {
    return swiper.grid && params.grid && params.grid.rows > 1;
};
function setBreakpoint() {
    var swiper = this;
    var realIndex = swiper.realIndex, initialized = swiper.initialized, params = swiper.params, el = swiper.el;
    var breakpoints = params.breakpoints;
    if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return;
    var document1 = (0, _ssrWindowEsmMjs.g)();
    // Get breakpoint for window/container width and update parameters
    var breakpointsBase = params.breakpointsBase === 'window' || !params.breakpointsBase ? params.breakpointsBase : 'container';
    var breakpointContainer = [
        'window',
        'container'
    ].includes(params.breakpointsBase) || !params.breakpointsBase ? swiper.el : document1.querySelector(params.breakpointsBase);
    var breakpoint = swiper.getBreakpoint(breakpoints, breakpointsBase, breakpointContainer);
    if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
    var breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
    var breakpointParams = breakpointOnlyParams || swiper.originalParams;
    var wasMultiRow = isGridEnabled(swiper, params);
    var isMultiRow = isGridEnabled(swiper, breakpointParams);
    var wasGrabCursor = swiper.params.grabCursor;
    var isGrabCursor = breakpointParams.grabCursor;
    var wasEnabled = params.enabled;
    if (wasMultiRow && !isMultiRow) {
        el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    } else if (!wasMultiRow && isMultiRow) {
        el.classList.add(`${params.containerModifierClass}grid`);
        if (breakpointParams.grid.fill && breakpointParams.grid.fill === 'column' || !breakpointParams.grid.fill && params.grid.fill === 'column') el.classList.add(`${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    }
    if (wasGrabCursor && !isGrabCursor) swiper.unsetGrabCursor();
    else if (!wasGrabCursor && isGrabCursor) swiper.setGrabCursor();
    // Toggle navigation, pagination, scrollbar
    [
        'navigation',
        'pagination',
        'scrollbar'
    ].forEach(function(prop) {
        if (typeof breakpointParams[prop] === 'undefined') return;
        var wasModuleEnabled = params[prop] && params[prop].enabled;
        var isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;
        if (wasModuleEnabled && !isModuleEnabled) swiper[prop].disable();
        if (!wasModuleEnabled && isModuleEnabled) swiper[prop].enable();
    });
    var directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
    var needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
    var wasLoop = params.loop;
    if (directionChanged && initialized) swiper.changeDirection();
    (0, _utilsMjs.w)(swiper.params, breakpointParams);
    var isEnabled = swiper.params.enabled;
    var hasLoop = swiper.params.loop;
    Object.assign(swiper, {
        allowTouchMove: swiper.params.allowTouchMove,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev
    });
    if (wasEnabled && !isEnabled) swiper.disable();
    else if (!wasEnabled && isEnabled) swiper.enable();
    swiper.currentBreakpoint = breakpoint;
    swiper.emit('_beforeBreakpoint', breakpointParams);
    if (initialized) {
        if (needsReLoop) {
            swiper.loopDestroy();
            swiper.loopCreate(realIndex);
            swiper.updateSlides();
        } else if (!wasLoop && hasLoop) {
            swiper.loopCreate(realIndex);
            swiper.updateSlides();
        } else if (wasLoop && !hasLoop) swiper.loopDestroy();
    }
    swiper.emit('breakpoint', breakpointParams);
}
function getBreakpoint(breakpoints, base, containerEl) {
    if (base === void 0) base = 'window';
    if (!breakpoints || base === 'container' && !containerEl) return undefined;
    var breakpoint = false;
    var window1 = (0, _ssrWindowEsmMjs.a)();
    var currentHeight = base === 'window' ? window1.innerHeight : containerEl.clientHeight;
    var points = Object.keys(breakpoints).map(function(point) {
        if (typeof point === 'string' && point.indexOf('@') === 0) {
            var minRatio = parseFloat(point.substr(1));
            var value = currentHeight * minRatio;
            return {
                value: value,
                point: point
            };
        }
        return {
            value: point,
            point: point
        };
    });
    points.sort(function(a, b) {
        return parseInt(a.value, 10) - parseInt(b.value, 10);
    });
    for(var i = 0; i < points.length; i += 1){
        var _points_i = points[i], point = _points_i.point, value = _points_i.value;
        if (base === 'window') {
            if (window1.matchMedia(`(min-width: ${value}px)`).matches) breakpoint = point;
        } else if (value <= containerEl.clientWidth) breakpoint = point;
    }
    return breakpoint || 'max';
}
var breakpoints = {
    setBreakpoint: setBreakpoint,
    getBreakpoint: getBreakpoint
};
function prepareClasses(entries, prefix) {
    var resultClasses = [];
    entries.forEach(function(item) {
        if (typeof item === 'object') Object.keys(item).forEach(function(classNames) {
            if (item[classNames]) resultClasses.push(prefix + classNames);
        });
        else if (typeof item === 'string') resultClasses.push(prefix + item);
    });
    return resultClasses;
}
function addClasses() {
    var _classNames, _el_classList;
    var swiper = this;
    var classNames = swiper.classNames, params = swiper.params, rtl = swiper.rtl, el = swiper.el, device = swiper.device;
    // prettier-ignore
    var suffixes = prepareClasses([
        'initialized',
        params.direction,
        {
            'free-mode': swiper.params.freeMode && params.freeMode.enabled
        },
        {
            'autoheight': params.autoHeight
        },
        {
            'rtl': rtl
        },
        {
            'grid': params.grid && params.grid.rows > 1
        },
        {
            'grid-column': params.grid && params.grid.rows > 1 && params.grid.fill === 'column'
        },
        {
            'android': device.android
        },
        {
            'ios': device.ios
        },
        {
            'css-mode': params.cssMode
        },
        {
            'centered': params.cssMode && params.centeredSlides
        },
        {
            'watch-progress': params.watchSlidesProgress
        }
    ], params.containerModifierClass);
    (_classNames = classNames).push.apply(_classNames, (0, _toConsumableArray._)(suffixes));
    (_el_classList = el.classList).add.apply(_el_classList, (0, _toConsumableArray._)(classNames));
    swiper.emitContainerClasses();
}
function removeClasses() {
    var _el_classList;
    var swiper = this;
    var el = swiper.el, classNames = swiper.classNames;
    if (!el || typeof el === 'string') return;
    (_el_classList = el.classList).remove.apply(_el_classList, (0, _toConsumableArray._)(classNames));
    swiper.emitContainerClasses();
}
var classes = {
    addClasses: addClasses,
    removeClasses: removeClasses
};
function checkOverflow() {
    var swiper = this;
    var wasLocked = swiper.isLocked, params = swiper.params;
    var slidesOffsetBefore = params.slidesOffsetBefore;
    if (slidesOffsetBefore) {
        var lastSlideIndex = swiper.slides.length - 1;
        var lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
        swiper.isLocked = swiper.size > lastSlideRightEdge;
    } else swiper.isLocked = swiper.snapGrid.length === 1;
    if (params.allowSlideNext === true) swiper.allowSlideNext = !swiper.isLocked;
    if (params.allowSlidePrev === true) swiper.allowSlidePrev = !swiper.isLocked;
    if (wasLocked && wasLocked !== swiper.isLocked) swiper.isEnd = false;
    if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? 'lock' : 'unlock');
}
var checkOverflow$1 = {
    checkOverflow: checkOverflow
};
var defaults = {
    init: true,
    direction: 'horizontal',
    oneWayMovement: false,
    swiperElementNodeName: 'SWIPER-CONTAINER',
    touchEventsTarget: 'wrapper',
    initialSlide: 0,
    speed: 300,
    cssMode: false,
    updateOnWindowResize: true,
    resizeObserver: true,
    nested: false,
    createElements: false,
    eventsPrefix: 'swiper',
    enabled: true,
    focusableElements: 'input, select, option, textarea, button, video, label',
    // Overrides
    width: null,
    height: null,
    //
    preventInteractionOnTransition: false,
    // ssr
    userAgent: null,
    url: null,
    // To support iOS's swipe-to-go-back gesture (when being used in-app).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,
    // Autoheight
    autoHeight: false,
    // Set wrapper width
    setWrapperSize: false,
    // Virtual Translate
    virtualTranslate: false,
    // Effects
    effect: 'slide',
    // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
    // Breakpoints
    breakpoints: undefined,
    breakpointsBase: 'window',
    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: false,
    centeredSlides: false,
    centeredSlidesBounds: false,
    slidesOffsetBefore: 0,
    // in px
    slidesOffsetAfter: 0,
    // in px
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,
    // Disable swiper and hide navigation when container not overflow
    watchOverflow: true,
    // Round length
    roundLengths: false,
    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 5,
    touchMoveStopPropagation: false,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,
    // Unique Navigation Elements
    uniqueNavElements: true,
    // Resistance
    resistance: true,
    resistanceRatio: 0.85,
    // Progress
    watchSlidesProgress: false,
    // Cursor
    grabCursor: false,
    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,
    // loop
    loop: false,
    loopAddBlankSlides: true,
    loopAdditionalSlides: 0,
    loopPreventsSliding: true,
    // rewind
    rewind: false,
    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null,
    // '.swipe-handler',
    noSwiping: true,
    noSwipingClass: 'swiper-no-swiping',
    noSwipingSelector: null,
    // Passive Listeners
    passiveListeners: true,
    maxBackfaceHiddenSlides: 10,
    // NS
    containerModifierClass: 'swiper-',
    // NEW
    slideClass: 'swiper-slide',
    slideBlankClass: 'swiper-slide-blank',
    slideActiveClass: 'swiper-slide-active',
    slideVisibleClass: 'swiper-slide-visible',
    slideFullyVisibleClass: 'swiper-slide-fully-visible',
    slideNextClass: 'swiper-slide-next',
    slidePrevClass: 'swiper-slide-prev',
    wrapperClass: 'swiper-wrapper',
    lazyPreloaderClass: 'swiper-lazy-preloader',
    lazyPreloadPrevNext: 0,
    // Callbacks
    runCallbacksOnInit: true,
    // Internals
    _emitClasses: false
};
function moduleExtendParams(params, allModulesParams) {
    return function extendParams(obj) {
        if (obj === void 0) obj = {};
        var moduleParamName = Object.keys(obj)[0];
        var moduleParams = obj[moduleParamName];
        if (typeof moduleParams !== 'object' || moduleParams === null) {
            (0, _utilsMjs.w)(allModulesParams, obj);
            return;
        }
        if (params[moduleParamName] === true) params[moduleParamName] = {
            enabled: true
        };
        if (moduleParamName === 'navigation' && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].prevEl && !params[moduleParamName].nextEl) params[moduleParamName].auto = true;
        if ([
            'pagination',
            'scrollbar'
        ].indexOf(moduleParamName) >= 0 && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].el) params[moduleParamName].auto = true;
        if (!(moduleParamName in params && 'enabled' in moduleParams)) {
            (0, _utilsMjs.w)(allModulesParams, obj);
            return;
        }
        if (typeof params[moduleParamName] === 'object' && !('enabled' in params[moduleParamName])) params[moduleParamName].enabled = true;
        if (!params[moduleParamName]) params[moduleParamName] = {
            enabled: false
        };
        (0, _utilsMjs.w)(allModulesParams, obj);
    };
}
/* eslint no-param-reassign: "off" */ var prototypes = {
    eventsEmitter: eventsEmitter,
    update: update,
    translate: translate,
    transition: transition,
    slide: slide,
    loop: loop,
    grabCursor: grabCursor,
    events: events$1,
    breakpoints: breakpoints,
    checkOverflow: checkOverflow$1,
    classes: classes
};
var extendedDefaults = {};
var Swiper = /*#__PURE__*/ function() {
    "use strict";
    function Swiper() {
        var _swiper_modules;
        (0, _classCallCheck._)(this, Swiper);
        var el;
        var params;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var ref;
        if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === 'Object') params = args[0];
        else ref = (0, _slicedToArray._)(args, 2), el = ref[0], params = ref[1], ref;
        if (!params) params = {};
        params = (0, _utilsMjs.w)({}, params);
        if (el && !params.el) params.el = el;
        var document1 = (0, _ssrWindowEsmMjs.g)();
        if (params.el && typeof params.el === 'string' && document1.querySelectorAll(params.el).length > 1) {
            var swipers = [];
            document1.querySelectorAll(params.el).forEach(function(containerEl) {
                var newParams = (0, _utilsMjs.w)({}, params, {
                    el: containerEl
                });
                swipers.push(new Swiper(newParams));
            });
            // eslint-disable-next-line no-constructor-return
            return swipers;
        }
        // Swiper Instance
        var swiper = this;
        swiper.__swiper__ = true;
        swiper.support = getSupport();
        swiper.device = getDevice({
            userAgent: params.userAgent
        });
        swiper.browser = getBrowser();
        swiper.eventsListeners = {};
        swiper.eventsAnyListeners = [];
        swiper.modules = (0, _toConsumableArray._)(swiper.__modules__);
        if (params.modules && Array.isArray(params.modules)) (_swiper_modules = swiper.modules).push.apply(_swiper_modules, (0, _toConsumableArray._)(params.modules));
        var allModulesParams = {};
        swiper.modules.forEach(function(mod) {
            mod({
                params: params,
                swiper: swiper,
                extendParams: moduleExtendParams(params, allModulesParams),
                on: swiper.on.bind(swiper),
                once: swiper.once.bind(swiper),
                off: swiper.off.bind(swiper),
                emit: swiper.emit.bind(swiper)
            });
        });
        // Extend defaults with modules params
        var swiperParams = (0, _utilsMjs.w)({}, defaults, allModulesParams);
        // Extend defaults with passed params
        swiper.params = (0, _utilsMjs.w)({}, swiperParams, extendedDefaults, params);
        swiper.originalParams = (0, _utilsMjs.w)({}, swiper.params);
        swiper.passedParams = (0, _utilsMjs.w)({}, params);
        // add event listeners
        if (swiper.params && swiper.params.on) Object.keys(swiper.params.on).forEach(function(eventName) {
            swiper.on(eventName, swiper.params.on[eventName]);
        });
        if (swiper.params && swiper.params.onAny) swiper.onAny(swiper.params.onAny);
        // Extend Swiper
        Object.assign(swiper, {
            enabled: swiper.params.enabled,
            el: el,
            // Classes
            classNames: [],
            // Slides
            slides: [],
            slidesGrid: [],
            snapGrid: [],
            slidesSizesGrid: [],
            // isDirection
            isHorizontal: function() {
                return swiper.params.direction === 'horizontal';
            },
            isVertical: function() {
                return swiper.params.direction === 'vertical';
            },
            // Indexes
            activeIndex: 0,
            realIndex: 0,
            //
            isBeginning: true,
            isEnd: false,
            // Props
            translate: 0,
            previousTranslate: 0,
            progress: 0,
            velocity: 0,
            animating: false,
            cssOverflowAdjustment: function() {
                // Returns 0 unless `translate` is > 2**23
                // Should be subtracted from css values to prevent overflow
                return Math.trunc(this.translate / Math.pow(2, 23)) * Math.pow(2, 23);
            },
            // Locks
            allowSlideNext: swiper.params.allowSlideNext,
            allowSlidePrev: swiper.params.allowSlidePrev,
            // Touch Events
            touchEventsData: {
                isTouched: undefined,
                isMoved: undefined,
                allowTouchCallbacks: undefined,
                touchStartTime: undefined,
                isScrolling: undefined,
                currentTranslate: undefined,
                startTranslate: undefined,
                allowThresholdMove: undefined,
                // Form elements to match
                focusableElements: swiper.params.focusableElements,
                // Last click time
                lastClickTime: 0,
                clickTimeout: undefined,
                // Velocities
                velocities: [],
                allowMomentumBounce: undefined,
                startMoving: undefined,
                pointerId: null,
                touchId: null
            },
            // Clicks
            allowClick: true,
            // Touches
            allowTouchMove: swiper.params.allowTouchMove,
            touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0
            },
            // Images
            imagesToLoad: [],
            imagesLoaded: 0
        });
        swiper.emit('_swiper');
        // Init
        if (swiper.params.init) swiper.init();
        // Return app instance
        // eslint-disable-next-line no-constructor-return
        return swiper;
    }
    (0, _createClass._)(Swiper, [
        {
            key: "getDirectionLabel",
            value: function getDirectionLabel(property) {
                if (this.isHorizontal()) return property;
                // prettier-ignore
                return ({
                    'width': 'height',
                    'margin-top': 'margin-left',
                    'margin-bottom ': 'margin-right',
                    'margin-left': 'margin-top',
                    'margin-right': 'margin-bottom',
                    'padding-left': 'padding-top',
                    'padding-right': 'padding-bottom',
                    'marginRight': 'marginBottom'
                })[property];
            }
        },
        {
            key: "getSlideIndex",
            value: function getSlideIndex(slideEl) {
                var _this = this, slidesEl = _this.slidesEl, params = _this.params;
                var slides = (0, _utilsMjs.e)(slidesEl, `.${params.slideClass}, swiper-slide`);
                var firstSlideIndex = (0, _utilsMjs.h)(slides[0]);
                return (0, _utilsMjs.h)(slideEl) - firstSlideIndex;
            }
        },
        {
            key: "getSlideIndexByData",
            value: function getSlideIndexByData(index) {
                return this.getSlideIndex(this.slides.find(function(slideEl) {
                    return slideEl.getAttribute('data-swiper-slide-index') * 1 === index;
                }));
            }
        },
        {
            key: "recalcSlides",
            value: function recalcSlides() {
                var swiper = this;
                var slidesEl = swiper.slidesEl, params = swiper.params;
                swiper.slides = (0, _utilsMjs.e)(slidesEl, `.${params.slideClass}, swiper-slide`);
            }
        },
        {
            key: "enable",
            value: function enable() {
                var swiper = this;
                if (swiper.enabled) return;
                swiper.enabled = true;
                if (swiper.params.grabCursor) swiper.setGrabCursor();
                swiper.emit('enable');
            }
        },
        {
            key: "disable",
            value: function disable() {
                var swiper = this;
                if (!swiper.enabled) return;
                swiper.enabled = false;
                if (swiper.params.grabCursor) swiper.unsetGrabCursor();
                swiper.emit('disable');
            }
        },
        {
            key: "setProgress",
            value: function setProgress(progress, speed) {
                var swiper = this;
                progress = Math.min(Math.max(progress, 0), 1);
                var min = swiper.minTranslate();
                var max = swiper.maxTranslate();
                var current = (max - min) * progress + min;
                swiper.translateTo(current, typeof speed === 'undefined' ? 0 : speed);
                swiper.updateActiveIndex();
                swiper.updateSlidesClasses();
            }
        },
        {
            key: "emitContainerClasses",
            value: function emitContainerClasses() {
                var swiper = this;
                if (!swiper.params._emitClasses || !swiper.el) return;
                var cls = swiper.el.className.split(' ').filter(function(className) {
                    return className.indexOf('swiper') === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
                });
                swiper.emit('_containerClasses', cls.join(' '));
            }
        },
        {
            key: "getSlideClasses",
            value: function getSlideClasses(slideEl) {
                var swiper = this;
                if (swiper.destroyed) return '';
                return slideEl.className.split(' ').filter(function(className) {
                    return className.indexOf('swiper-slide') === 0 || className.indexOf(swiper.params.slideClass) === 0;
                }).join(' ');
            }
        },
        {
            key: "emitSlidesClasses",
            value: function emitSlidesClasses() {
                var swiper = this;
                if (!swiper.params._emitClasses || !swiper.el) return;
                var updates = [];
                swiper.slides.forEach(function(slideEl) {
                    var classNames = swiper.getSlideClasses(slideEl);
                    updates.push({
                        slideEl: slideEl,
                        classNames: classNames
                    });
                    swiper.emit('_slideClass', slideEl, classNames);
                });
                swiper.emit('_slideClasses', updates);
            }
        },
        {
            key: "slidesPerViewDynamic",
            value: function slidesPerViewDynamic(view, exact) {
                if (view === void 0) view = 'current';
                if (exact === void 0) exact = false;
                var swiper = this;
                var params = swiper.params, slides = swiper.slides, slidesGrid = swiper.slidesGrid, slidesSizesGrid = swiper.slidesSizesGrid, swiperSize = swiper.size, activeIndex = swiper.activeIndex;
                var spv = 1;
                if (typeof params.slidesPerView === 'number') return params.slidesPerView;
                if (params.centeredSlides) {
                    var slideSize = slides[activeIndex] ? Math.ceil(slides[activeIndex].swiperSlideSize) : 0;
                    var breakLoop;
                    for(var i = activeIndex + 1; i < slides.length; i += 1)if (slides[i] && !breakLoop) {
                        slideSize += Math.ceil(slides[i].swiperSlideSize);
                        spv += 1;
                        if (slideSize > swiperSize) breakLoop = true;
                    }
                    for(var i1 = activeIndex - 1; i1 >= 0; i1 -= 1)if (slides[i1] && !breakLoop) {
                        slideSize += slides[i1].swiperSlideSize;
                        spv += 1;
                        if (slideSize > swiperSize) breakLoop = true;
                    }
                } else {
                    // eslint-disable-next-line
                    if (view === 'current') for(var i2 = activeIndex + 1; i2 < slides.length; i2 += 1){
                        var slideInView = exact ? slidesGrid[i2] + slidesSizesGrid[i2] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i2] - slidesGrid[activeIndex] < swiperSize;
                        if (slideInView) spv += 1;
                    }
                    else // previous
                    for(var i3 = activeIndex - 1; i3 >= 0; i3 -= 1){
                        var slideInView1 = slidesGrid[activeIndex] - slidesGrid[i3] < swiperSize;
                        if (slideInView1) spv += 1;
                    }
                }
                return spv;
            }
        },
        {
            key: "update",
            value: function update() {
                var swiper = this;
                if (!swiper || swiper.destroyed) return;
                var snapGrid = swiper.snapGrid, params = swiper.params;
                // Breakpoints
                if (params.breakpoints) swiper.setBreakpoint();
                (0, _toConsumableArray._)(swiper.el.querySelectorAll('[loading="lazy"]')).forEach(function(imageEl) {
                    if (imageEl.complete) processLazyPreloader(swiper, imageEl);
                });
                swiper.updateSize();
                swiper.updateSlides();
                swiper.updateProgress();
                swiper.updateSlidesClasses();
                function setTranslate() {
                    var translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
                    var newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
                    swiper.setTranslate(newTranslate);
                    swiper.updateActiveIndex();
                    swiper.updateSlidesClasses();
                }
                var translated;
                if (params.freeMode && params.freeMode.enabled && !params.cssMode) {
                    setTranslate();
                    if (params.autoHeight) swiper.updateAutoHeight();
                } else {
                    if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !params.centeredSlides) {
                        var slides = swiper.virtual && params.virtual.enabled ? swiper.virtual.slides : swiper.slides;
                        translated = swiper.slideTo(slides.length - 1, 0, false, true);
                    } else translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
                    if (!translated) setTranslate();
                }
                if (params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
                swiper.emit('update');
            }
        },
        {
            key: "changeDirection",
            value: function changeDirection(newDirection, needUpdate) {
                if (needUpdate === void 0) needUpdate = true;
                var swiper = this;
                var currentDirection = swiper.params.direction;
                if (!newDirection) // eslint-disable-next-line
                newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
                if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') return swiper;
                swiper.el.classList.remove(`${swiper.params.containerModifierClass}${currentDirection}`);
                swiper.el.classList.add(`${swiper.params.containerModifierClass}${newDirection}`);
                swiper.emitContainerClasses();
                swiper.params.direction = newDirection;
                swiper.slides.forEach(function(slideEl) {
                    if (newDirection === 'vertical') slideEl.style.width = '';
                    else slideEl.style.height = '';
                });
                swiper.emit('changeDirection');
                if (needUpdate) swiper.update();
                return swiper;
            }
        },
        {
            key: "changeLanguageDirection",
            value: function changeLanguageDirection(direction) {
                var swiper = this;
                if (swiper.rtl && direction === 'rtl' || !swiper.rtl && direction === 'ltr') return;
                swiper.rtl = direction === 'rtl';
                swiper.rtlTranslate = swiper.params.direction === 'horizontal' && swiper.rtl;
                if (swiper.rtl) {
                    swiper.el.classList.add(`${swiper.params.containerModifierClass}rtl`);
                    swiper.el.dir = 'rtl';
                } else {
                    swiper.el.classList.remove(`${swiper.params.containerModifierClass}rtl`);
                    swiper.el.dir = 'ltr';
                }
                swiper.update();
            }
        },
        {
            key: "mount",
            value: function mount(element) {
                var swiper = this;
                if (swiper.mounted) return true;
                // Find el
                var el = element || swiper.params.el;
                if (typeof el === 'string') el = document.querySelector(el);
                if (!el) return false;
                el.swiper = swiper;
                if (el.parentNode && el.parentNode.host && el.parentNode.host.nodeName === swiper.params.swiperElementNodeName.toUpperCase()) swiper.isElement = true;
                var getWrapperSelector = function() {
                    return `.${(swiper.params.wrapperClass || '').trim().split(' ').join('.')}`;
                };
                var getWrapper = function() {
                    if (el && el.shadowRoot && el.shadowRoot.querySelector) {
                        var res = el.shadowRoot.querySelector(getWrapperSelector());
                        // Children needs to return slot items
                        return res;
                    }
                    return (0, _utilsMjs.e)(el, getWrapperSelector())[0];
                };
                // Find Wrapper
                var wrapperEl = getWrapper();
                if (!wrapperEl && swiper.params.createElements) {
                    wrapperEl = (0, _utilsMjs.c)('div', swiper.params.wrapperClass);
                    el.append(wrapperEl);
                    (0, _utilsMjs.e)(el, `.${swiper.params.slideClass}`).forEach(function(slideEl) {
                        wrapperEl.append(slideEl);
                    });
                }
                Object.assign(swiper, {
                    el: el,
                    wrapperEl: wrapperEl,
                    slidesEl: swiper.isElement && !el.parentNode.host.slideSlots ? el.parentNode.host : wrapperEl,
                    hostEl: swiper.isElement ? el.parentNode.host : el,
                    mounted: true,
                    // RTL
                    rtl: el.dir.toLowerCase() === 'rtl' || (0, _utilsMjs.p)(el, 'direction') === 'rtl',
                    rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || (0, _utilsMjs.p)(el, 'direction') === 'rtl'),
                    wrongRTL: (0, _utilsMjs.p)(wrapperEl, 'display') === '-webkit-box'
                });
                return true;
            }
        },
        {
            key: "init",
            value: function init(el) {
                var _lazyElements;
                var swiper = this;
                if (swiper.initialized) return swiper;
                var mounted = swiper.mount(el);
                if (mounted === false) return swiper;
                swiper.emit('beforeInit');
                // Set breakpoint
                if (swiper.params.breakpoints) swiper.setBreakpoint();
                // Add Classes
                swiper.addClasses();
                // Update size
                swiper.updateSize();
                // Update slides
                swiper.updateSlides();
                if (swiper.params.watchOverflow) swiper.checkOverflow();
                // Set Grab Cursor
                if (swiper.params.grabCursor && swiper.enabled) swiper.setGrabCursor();
                // Slide To Initial Slide
                if (swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) swiper.slideTo(swiper.params.initialSlide + swiper.virtual.slidesBefore, 0, swiper.params.runCallbacksOnInit, false, true);
                else swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
                // Create loop
                if (swiper.params.loop) swiper.loopCreate(undefined, true);
                // Attach events
                swiper.attachEvents();
                var lazyElements = (0, _toConsumableArray._)(swiper.el.querySelectorAll('[loading="lazy"]'));
                if (swiper.isElement) (_lazyElements = lazyElements).push.apply(_lazyElements, (0, _toConsumableArray._)(swiper.hostEl.querySelectorAll('[loading="lazy"]')));
                lazyElements.forEach(function(imageEl) {
                    if (imageEl.complete) processLazyPreloader(swiper, imageEl);
                    else imageEl.addEventListener('load', function(e) {
                        processLazyPreloader(swiper, e.target);
                    });
                });
                preload(swiper);
                // Init Flag
                swiper.initialized = true;
                preload(swiper);
                // Emit
                swiper.emit('init');
                swiper.emit('afterInit');
                return swiper;
            }
        },
        {
            key: "destroy",
            value: function destroy(deleteInstance, cleanStyles) {
                if (deleteInstance === void 0) deleteInstance = true;
                if (cleanStyles === void 0) cleanStyles = true;
                var swiper = this;
                var params = swiper.params, el = swiper.el, wrapperEl = swiper.wrapperEl, slides = swiper.slides;
                if (typeof swiper.params === 'undefined' || swiper.destroyed) return null;
                swiper.emit('beforeDestroy');
                // Init Flag
                swiper.initialized = false;
                // Detach events
                swiper.detachEvents();
                // Destroy loop
                if (params.loop) swiper.loopDestroy();
                // Cleanup styles
                if (cleanStyles) {
                    swiper.removeClasses();
                    if (el && typeof el !== 'string') el.removeAttribute('style');
                    if (wrapperEl) wrapperEl.removeAttribute('style');
                    if (slides && slides.length) slides.forEach(function(slideEl) {
                        slideEl.classList.remove(params.slideVisibleClass, params.slideFullyVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
                        slideEl.removeAttribute('style');
                        slideEl.removeAttribute('data-swiper-slide-index');
                    });
                }
                swiper.emit('destroy');
                // Detach emitter events
                Object.keys(swiper.eventsListeners).forEach(function(eventName) {
                    swiper.off(eventName);
                });
                if (deleteInstance !== false) {
                    if (swiper.el && typeof swiper.el !== 'string') swiper.el.swiper = null;
                    (0, _utilsMjs.x)(swiper);
                }
                swiper.destroyed = true;
                return null;
            }
        }
    ], [
        {
            key: "extendDefaults",
            value: function extendDefaults(newDefaults) {
                (0, _utilsMjs.w)(extendedDefaults, newDefaults);
            }
        },
        {
            key: "extendedDefaults",
            get: function get() {
                return extendedDefaults;
            }
        },
        {
            key: "defaults",
            get: function get() {
                return defaults;
            }
        },
        {
            key: "installModule",
            value: function installModule(mod) {
                if (!Swiper.prototype.__modules__) Swiper.prototype.__modules__ = [];
                var modules = Swiper.prototype.__modules__;
                if (typeof mod === 'function' && modules.indexOf(mod) < 0) modules.push(mod);
            }
        },
        {
            key: "use",
            value: function use(module) {
                if (Array.isArray(module)) {
                    module.forEach(function(m) {
                        return Swiper.installModule(m);
                    });
                    return Swiper;
                }
                Swiper.installModule(module);
                return Swiper;
            }
        }
    ]);
    return Swiper;
}();
Object.keys(prototypes).forEach(function(prototypeGroup) {
    Object.keys(prototypes[prototypeGroup]).forEach(function(protoMethod) {
        Swiper.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
    });
});
Swiper.use([
    Resize,
    Observer
]);

},{"@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","@swc/helpers/_/_define_property":"54Zvk","@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_object_spread_props":"fLCYP","@swc/helpers/_/_sliced_to_array":"ha6sq","@swc/helpers/_/_to_consumable_array":"eqNDD","./ssr-window.esm.mjs":"6ooWP","./utils.mjs":"7Cawp","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6ooWP":[function(require,module,exports,__globalThis) {
/**
 * SSR Window 5.0.0
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2025, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: February 12, 2025
 */ /* eslint-disable no-param-reassign */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "a", function() {
    return getWindow;
});
parcelHelpers.export(exports, "g", function() {
    return getDocument;
});
function isObject(obj) {
    return obj !== null && typeof obj === 'object' && 'constructor' in obj && obj.constructor === Object;
}
function extend(target, src) {
    if (target === void 0) target = {};
    if (src === void 0) src = {};
    var noExtend = [
        '__proto__',
        'constructor',
        'prototype'
    ];
    Object.keys(src).filter(function(key) {
        return noExtend.indexOf(key) < 0;
    }).forEach(function(key) {
        if (typeof target[key] === 'undefined') target[key] = src[key];
        else if (isObject(src[key]) && isObject(target[key]) && Object.keys(src[key]).length > 0) extend(target[key], src[key]);
    });
}
var ssrDocument = {
    body: {},
    addEventListener: function() {},
    removeEventListener: function() {},
    activeElement: {
        blur: function() {},
        nodeName: ''
    },
    querySelector: function() {
        return null;
    },
    querySelectorAll: function() {
        return [];
    },
    getElementById: function() {
        return null;
    },
    createEvent: function() {
        return {
            initEvent: function() {}
        };
    },
    createElement: function() {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute: function() {},
            getElementsByTagName: function() {
                return [];
            }
        };
    },
    createElementNS: function() {
        return {};
    },
    importNode: function() {
        return null;
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: ''
    }
};
function getDocument() {
    var doc = typeof document !== 'undefined' ? document : {};
    extend(doc, ssrDocument);
    return doc;
}
var ssrWindow = {
    document: ssrDocument,
    navigator: {
        userAgent: ''
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: ''
    },
    history: {
        replaceState: function() {},
        pushState: function() {},
        go: function() {},
        back: function() {}
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener: function() {},
    removeEventListener: function() {},
    getComputedStyle: function() {
        return {
            getPropertyValue: function() {
                return '';
            }
        };
    },
    Image: function() {},
    Date: function() {},
    screen: {},
    setTimeout: function() {},
    clearTimeout: function() {},
    matchMedia: function() {
        return {};
    },
    requestAnimationFrame: function(callback) {
        if (typeof setTimeout === 'undefined') {
            callback();
            return null;
        }
        return setTimeout(callback, 0);
    },
    cancelAnimationFrame: function(id) {
        if (typeof setTimeout === 'undefined') return;
        clearTimeout(id);
    }
};
function getWindow() {
    var win = typeof window !== 'undefined' ? window : {};
    extend(win, ssrWindow);
    return win;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7Cawp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "a", function() {
    return elementParents;
});
parcelHelpers.export(exports, "b", function() {
    return elementOffset;
});
parcelHelpers.export(exports, "c", function() {
    return createElement;
});
parcelHelpers.export(exports, "d", function() {
    return now;
});
parcelHelpers.export(exports, "e", function() {
    return elementChildren;
});
parcelHelpers.export(exports, "f", function() {
    return elementOuterSize;
});
parcelHelpers.export(exports, "g", function() {
    return getSlideTransformEl;
});
parcelHelpers.export(exports, "h", function() {
    return elementIndex;
});
parcelHelpers.export(exports, "i", function() {
    return classesToTokens;
});
parcelHelpers.export(exports, "j", function() {
    return getTranslate;
});
parcelHelpers.export(exports, "k", function() {
    return elementTransitionEnd;
});
parcelHelpers.export(exports, "l", function() {
    return isObject;
});
parcelHelpers.export(exports, "m", function() {
    return makeElementsArray;
});
parcelHelpers.export(exports, "n", function() {
    return nextTick;
});
parcelHelpers.export(exports, "o", function() {
    return getRotateFix;
});
parcelHelpers.export(exports, "p", function() {
    return elementStyle;
});
parcelHelpers.export(exports, "q", function() {
    return elementNextAll;
});
parcelHelpers.export(exports, "r", function() {
    return elementPrevAll;
});
parcelHelpers.export(exports, "s", function() {
    return setCSSProperty;
});
parcelHelpers.export(exports, "t", function() {
    return animateCSSModeScroll;
});
parcelHelpers.export(exports, "u", function() {
    return showWarning;
});
parcelHelpers.export(exports, "v", function() {
    return elementIsChildOf;
});
parcelHelpers.export(exports, "w", function() {
    return extend;
});
parcelHelpers.export(exports, "x", function() {
    return deleteProps;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _ssrWindowEsmMjs = require("./ssr-window.esm.mjs");
function classesToTokens(classes) {
    if (classes === void 0) classes = '';
    return classes.trim().split(' ').filter(function(c) {
        return !!c.trim();
    });
}
function deleteProps(obj) {
    var object = obj;
    Object.keys(object).forEach(function(key) {
        try {
            object[key] = null;
        } catch (e) {
        // no getter for object
        }
        try {
            delete object[key];
        } catch (e) {
        // something got wrong
        }
    });
}
function nextTick(callback, delay) {
    if (delay === void 0) delay = 0;
    return setTimeout(callback, delay);
}
function now() {
    return Date.now();
}
function getComputedStyle(el) {
    var window1 = (0, _ssrWindowEsmMjs.a)();
    var style;
    if (window1.getComputedStyle) style = window1.getComputedStyle(el, null);
    if (!style && el.currentStyle) style = el.currentStyle;
    if (!style) style = el.style;
    return style;
}
function getTranslate(el, axis) {
    if (axis === void 0) axis = 'x';
    var window1 = (0, _ssrWindowEsmMjs.a)();
    var matrix;
    var curTransform;
    var transformMatrix;
    var curStyle = getComputedStyle(el);
    if (window1.WebKitCSSMatrix) {
        curTransform = curStyle.transform || curStyle.webkitTransform;
        if (curTransform.split(',').length > 6) curTransform = curTransform.split(', ').map(function(a) {
            return a.replace(',', '.');
        }).join(', ');
        // Some old versions of Webkit choke when 'none' is passed; pass
        // empty string instead in this case
        transformMatrix = new window1.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
    } else {
        transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
        matrix = transformMatrix.toString().split(',');
    }
    if (axis === 'x') {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m41;
        else if (matrix.length === 16) curTransform = parseFloat(matrix[12]);
        else curTransform = parseFloat(matrix[4]);
    }
    if (axis === 'y') {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m42;
        else if (matrix.length === 16) curTransform = parseFloat(matrix[13]);
        else curTransform = parseFloat(matrix[5]);
    }
    return curTransform || 0;
}
function isObject(o) {
    return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}
function isNode(node) {
    // eslint-disable-next-line
    if (typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined') return node instanceof HTMLElement;
    return node && (node.nodeType === 1 || node.nodeType === 11);
}
function extend() {
    var to = Object(arguments.length <= 0 ? undefined : arguments[0]);
    var noExtend = [
        '__proto__',
        'constructor',
        'prototype'
    ];
    for(var i = 1; i < arguments.length; i += 1){
        var nextSource = i < 0 || arguments.length <= i ? undefined : arguments[i];
        if (nextSource !== undefined && nextSource !== null && !isNode(nextSource)) {
            var keysArray = Object.keys(Object(nextSource)).filter(function(key) {
                return noExtend.indexOf(key) < 0;
            });
            for(var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1){
                var nextKey = keysArray[nextIndex];
                var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                if (desc !== undefined && desc.enumerable) {
                    if (isObject(to[nextKey]) && isObject(nextSource[nextKey])) {
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else extend(to[nextKey], nextSource[nextKey]);
                    } else if (!isObject(to[nextKey]) && isObject(nextSource[nextKey])) {
                        to[nextKey] = {};
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else extend(to[nextKey], nextSource[nextKey]);
                    } else to[nextKey] = nextSource[nextKey];
                }
            }
        }
    }
    return to;
}
function setCSSProperty(el, varName, varValue) {
    el.style.setProperty(varName, varValue);
}
function animateCSSModeScroll(_ref) {
    var swiper = _ref.swiper, targetPosition = _ref.targetPosition, side = _ref.side;
    var window1 = (0, _ssrWindowEsmMjs.a)();
    var startPosition = -swiper.translate;
    var startTime = null;
    var time;
    var duration = swiper.params.speed;
    swiper.wrapperEl.style.scrollSnapType = 'none';
    window1.cancelAnimationFrame(swiper.cssModeFrameID);
    var dir = targetPosition > startPosition ? 'next' : 'prev';
    var isOutOfBound = function(current, target) {
        return dir === 'next' && current >= target || dir === 'prev' && current <= target;
    };
    var animate = function() {
        time = new Date().getTime();
        if (startTime === null) startTime = time;
        var progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
        var easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
        var currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
        if (isOutOfBound(currentPosition, targetPosition)) currentPosition = targetPosition;
        swiper.wrapperEl.scrollTo((0, _defineProperty._)({}, side, currentPosition));
        if (isOutOfBound(currentPosition, targetPosition)) {
            swiper.wrapperEl.style.overflow = 'hidden';
            swiper.wrapperEl.style.scrollSnapType = '';
            setTimeout(function() {
                swiper.wrapperEl.style.overflow = '';
                swiper.wrapperEl.scrollTo((0, _defineProperty._)({}, side, currentPosition));
            });
            window1.cancelAnimationFrame(swiper.cssModeFrameID);
            return;
        }
        swiper.cssModeFrameID = window1.requestAnimationFrame(animate);
    };
    animate();
}
function getSlideTransformEl(slideEl) {
    return slideEl.querySelector('.swiper-slide-transform') || slideEl.shadowRoot && slideEl.shadowRoot.querySelector('.swiper-slide-transform') || slideEl;
}
function elementChildren(element, selector) {
    var _children;
    if (selector === void 0) selector = '';
    var window1 = (0, _ssrWindowEsmMjs.a)();
    var children = (0, _toConsumableArray._)(element.children);
    if (window1.HTMLSlotElement && element instanceof HTMLSlotElement) (_children = children).push.apply(_children, (0, _toConsumableArray._)(element.assignedElements()));
    if (!selector) return children;
    return children.filter(function(el) {
        return el.matches(selector);
    });
}
function elementIsChildOfSlot(el, slot) {
    // Breadth-first search through all parent's children and assigned elements
    var elementsQueue = [
        slot
    ];
    while(elementsQueue.length > 0){
        var _elementsQueue;
        var elementToCheck = elementsQueue.shift();
        if (el === elementToCheck) return true;
        (_elementsQueue = elementsQueue).push.apply(_elementsQueue, (0, _toConsumableArray._)(elementToCheck.children).concat((0, _toConsumableArray._)(elementToCheck.shadowRoot ? elementToCheck.shadowRoot.children : []), (0, _toConsumableArray._)(elementToCheck.assignedElements ? elementToCheck.assignedElements() : [])));
    }
}
function elementIsChildOf(el, parent) {
    var window1 = (0, _ssrWindowEsmMjs.a)();
    var isChild = parent.contains(el);
    if (!isChild && window1.HTMLSlotElement && parent instanceof HTMLSlotElement) {
        var children = (0, _toConsumableArray._)(parent.assignedElements());
        isChild = children.includes(el);
        if (!isChild) isChild = elementIsChildOfSlot(el, parent);
    }
    return isChild;
}
function showWarning(text) {
    try {
        console.warn(text);
        return;
    } catch (err) {
    // err
    }
}
function createElement(tag, classes) {
    var _el_classList;
    if (classes === void 0) classes = [];
    var el = document.createElement(tag);
    (_el_classList = el.classList).add.apply(_el_classList, (0, _toConsumableArray._)(Array.isArray(classes) ? classes : classesToTokens(classes)));
    return el;
}
function elementOffset(el) {
    var window1 = (0, _ssrWindowEsmMjs.a)();
    var document1 = (0, _ssrWindowEsmMjs.g)();
    var box = el.getBoundingClientRect();
    var body = document1.body;
    var clientTop = el.clientTop || body.clientTop || 0;
    var clientLeft = el.clientLeft || body.clientLeft || 0;
    var scrollTop = el === window1 ? window1.scrollY : el.scrollTop;
    var scrollLeft = el === window1 ? window1.scrollX : el.scrollLeft;
    return {
        top: box.top + scrollTop - clientTop,
        left: box.left + scrollLeft - clientLeft
    };
}
function elementPrevAll(el, selector) {
    var prevEls = [];
    while(el.previousElementSibling){
        var prev = el.previousElementSibling; // eslint-disable-line
        if (selector) {
            if (prev.matches(selector)) prevEls.push(prev);
        } else prevEls.push(prev);
        el = prev;
    }
    return prevEls;
}
function elementNextAll(el, selector) {
    var nextEls = [];
    while(el.nextElementSibling){
        var next = el.nextElementSibling; // eslint-disable-line
        if (selector) {
            if (next.matches(selector)) nextEls.push(next);
        } else nextEls.push(next);
        el = next;
    }
    return nextEls;
}
function elementStyle(el, prop) {
    var window1 = (0, _ssrWindowEsmMjs.a)();
    return window1.getComputedStyle(el, null).getPropertyValue(prop);
}
function elementIndex(el) {
    var child = el;
    var i;
    if (child) {
        i = 0;
        // eslint-disable-next-line
        while((child = child.previousSibling) !== null)if (child.nodeType === 1) i += 1;
        return i;
    }
    return undefined;
}
function elementParents(el, selector) {
    var parents = []; // eslint-disable-line
    var parent = el.parentElement; // eslint-disable-line
    while(parent){
        if (selector) {
            if (parent.matches(selector)) parents.push(parent);
        } else parents.push(parent);
        parent = parent.parentElement;
    }
    return parents;
}
function elementTransitionEnd(el, callback) {
    function fireCallBack(e) {
        if (e.target !== el) return;
        callback.call(el, e);
        el.removeEventListener('transitionend', fireCallBack);
    }
    if (callback) el.addEventListener('transitionend', fireCallBack);
}
function elementOuterSize(el, size, includeMargins) {
    var window1 = (0, _ssrWindowEsmMjs.a)();
    if (includeMargins) return el[size === 'width' ? 'offsetWidth' : 'offsetHeight'] + parseFloat(window1.getComputedStyle(el, null).getPropertyValue(size === 'width' ? 'margin-right' : 'margin-top')) + parseFloat(window1.getComputedStyle(el, null).getPropertyValue(size === 'width' ? 'margin-left' : 'margin-bottom'));
    return el.offsetWidth;
}
function makeElementsArray(el) {
    return (Array.isArray(el) ? el : [
        el
    ]).filter(function(e) {
        return !!e;
    });
}
function getRotateFix(swiper) {
    return function(v) {
        if (Math.abs(v) > 0 && swiper.browser && swiper.browser.need3dFix && Math.abs(v) % 90 === 0) return v + 0.001;
        return v;
    };
}

},{"@swc/helpers/_/_define_property":"54Zvk","@swc/helpers/_/_to_consumable_array":"eqNDD","./ssr-window.esm.mjs":"6ooWP","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jpzTZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "a", function() {
    return getChangedParams;
});
parcelHelpers.export(exports, "g", function() {
    return getParams;
});
parcelHelpers.export(exports, "m", function() {
    return mountSwiper;
});
parcelHelpers.export(exports, "u", function() {
    return updateOnVirtualData;
});
var _updateSwiperMjs = require("./update-swiper.mjs");
var _swiperCoreMjs = require("./swiper-core.mjs");
function getParams(obj, splitEvents) {
    if (obj === void 0) obj = {};
    if (splitEvents === void 0) splitEvents = true;
    var params = {
        on: {}
    };
    var events = {};
    var passedParams = {};
    (0, _updateSwiperMjs.e)(params, (0, _swiperCoreMjs.d));
    params._emitClasses = true;
    params.init = false;
    var rest = {};
    var allowedParams = (0, _updateSwiperMjs.p).map(function(key) {
        return key.replace(/_/, '');
    });
    var plainObj = Object.assign({}, obj);
    Object.keys(plainObj).forEach(function(key) {
        if (typeof obj[key] === 'undefined') return;
        if (allowedParams.indexOf(key) >= 0) {
            if ((0, _updateSwiperMjs.i)(obj[key])) {
                params[key] = {};
                passedParams[key] = {};
                (0, _updateSwiperMjs.e)(params[key], obj[key]);
                (0, _updateSwiperMjs.e)(passedParams[key], obj[key]);
            } else {
                params[key] = obj[key];
                passedParams[key] = obj[key];
            }
        } else if (key.search(/on[A-Z]/) === 0 && typeof obj[key] === 'function') {
            if (splitEvents) events[`${key[2].toLowerCase()}${key.substr(3)}`] = obj[key];
            else params.on[`${key[2].toLowerCase()}${key.substr(3)}`] = obj[key];
        } else rest[key] = obj[key];
    });
    [
        'navigation',
        'pagination',
        'scrollbar'
    ].forEach(function(key) {
        if (params[key] === true) params[key] = {};
        if (params[key] === false) delete params[key];
    });
    return {
        params: params,
        passedParams: passedParams,
        rest: rest,
        events: events
    };
}
function mountSwiper(_ref, swiperParams) {
    var el = _ref.el, nextEl = _ref.nextEl, prevEl = _ref.prevEl, paginationEl = _ref.paginationEl, scrollbarEl = _ref.scrollbarEl, swiper = _ref.swiper;
    if ((0, _updateSwiperMjs.n)(swiperParams) && nextEl && prevEl) {
        swiper.params.navigation.nextEl = nextEl;
        swiper.originalParams.navigation.nextEl = nextEl;
        swiper.params.navigation.prevEl = prevEl;
        swiper.originalParams.navigation.prevEl = prevEl;
    }
    if ((0, _updateSwiperMjs.a)(swiperParams) && paginationEl) {
        swiper.params.pagination.el = paginationEl;
        swiper.originalParams.pagination.el = paginationEl;
    }
    if ((0, _updateSwiperMjs.b)(swiperParams) && scrollbarEl) {
        swiper.params.scrollbar.el = scrollbarEl;
        swiper.originalParams.scrollbar.el = scrollbarEl;
    }
    swiper.init(el);
}
function getChangedParams(swiperParams, oldParams, children, oldChildren, getKey) {
    var keys = [];
    if (!oldParams) return keys;
    var addKey = function(key) {
        if (keys.indexOf(key) < 0) keys.push(key);
    };
    if (children && oldChildren) {
        var oldChildrenKeys = oldChildren.map(getKey);
        var childrenKeys = children.map(getKey);
        if (oldChildrenKeys.join('') !== childrenKeys.join('')) addKey('children');
        if (oldChildren.length !== children.length) addKey('children');
    }
    var watchParams = (0, _updateSwiperMjs.p).filter(function(key) {
        return key[0] === '_';
    }).map(function(key) {
        return key.replace(/_/, '');
    });
    watchParams.forEach(function(key) {
        if (key in swiperParams && key in oldParams) {
            if ((0, _updateSwiperMjs.i)(swiperParams[key]) && (0, _updateSwiperMjs.i)(oldParams[key])) {
                var newKeys = Object.keys(swiperParams[key]);
                var oldKeys = Object.keys(oldParams[key]);
                if (newKeys.length !== oldKeys.length) addKey(key);
                else {
                    newKeys.forEach(function(newKey) {
                        if (swiperParams[key][newKey] !== oldParams[key][newKey]) addKey(key);
                    });
                    oldKeys.forEach(function(oldKey) {
                        if (swiperParams[key][oldKey] !== oldParams[key][oldKey]) addKey(key);
                    });
                }
            } else if (swiperParams[key] !== oldParams[key]) addKey(key);
        }
    });
    return keys;
}
var updateOnVirtualData = function(swiper) {
    if (!swiper || swiper.destroyed || !swiper.params.virtual || swiper.params.virtual && !swiper.params.virtual.enabled) return;
    swiper.updateSlides();
    swiper.updateProgress();
    swiper.updateSlidesClasses();
    if (swiper.parallax && swiper.params.parallax && swiper.params.parallax.enabled) swiper.parallax.setTranslate();
};

},{"./update-swiper.mjs":"33nsa","./swiper-core.mjs":"frzgY","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"33nsa":[function(require,module,exports,__globalThis) {
/* underscore in name -> watch for changes */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "a", function() {
    return needsPagination;
});
parcelHelpers.export(exports, "b", function() {
    return needsScrollbar;
});
parcelHelpers.export(exports, "c", function() {
    return attrToProp;
});
parcelHelpers.export(exports, "d", function() {
    return uniqueClasses;
});
parcelHelpers.export(exports, "e", function() {
    return extend;
});
parcelHelpers.export(exports, "i", function() {
    return isObject;
});
parcelHelpers.export(exports, "n", function() {
    return needsNavigation;
});
parcelHelpers.export(exports, "p", function() {
    return paramsList;
});
parcelHelpers.export(exports, "u", function() {
    return updateSwiper;
});
parcelHelpers.export(exports, "w", function() {
    return wrapperClass;
});
var paramsList = [
    'eventsPrefix',
    'injectStyles',
    'injectStylesUrls',
    'modules',
    'init',
    '_direction',
    'oneWayMovement',
    'swiperElementNodeName',
    'touchEventsTarget',
    'initialSlide',
    '_speed',
    'cssMode',
    'updateOnWindowResize',
    'resizeObserver',
    'nested',
    'focusableElements',
    '_enabled',
    '_width',
    '_height',
    'preventInteractionOnTransition',
    'userAgent',
    'url',
    '_edgeSwipeDetection',
    '_edgeSwipeThreshold',
    '_freeMode',
    '_autoHeight',
    'setWrapperSize',
    'virtualTranslate',
    '_effect',
    'breakpoints',
    'breakpointsBase',
    '_spaceBetween',
    '_slidesPerView',
    'maxBackfaceHiddenSlides',
    '_grid',
    '_slidesPerGroup',
    '_slidesPerGroupSkip',
    '_slidesPerGroupAuto',
    '_centeredSlides',
    '_centeredSlidesBounds',
    '_slidesOffsetBefore',
    '_slidesOffsetAfter',
    'normalizeSlideIndex',
    '_centerInsufficientSlides',
    '_watchOverflow',
    'roundLengths',
    'touchRatio',
    'touchAngle',
    'simulateTouch',
    '_shortSwipes',
    '_longSwipes',
    'longSwipesRatio',
    'longSwipesMs',
    '_followFinger',
    'allowTouchMove',
    '_threshold',
    'touchMoveStopPropagation',
    'touchStartPreventDefault',
    'touchStartForcePreventDefault',
    'touchReleaseOnEdges',
    'uniqueNavElements',
    '_resistance',
    '_resistanceRatio',
    '_watchSlidesProgress',
    '_grabCursor',
    'preventClicks',
    'preventClicksPropagation',
    '_slideToClickedSlide',
    '_loop',
    'loopAdditionalSlides',
    'loopAddBlankSlides',
    'loopPreventsSliding',
    '_rewind',
    '_allowSlidePrev',
    '_allowSlideNext',
    '_swipeHandler',
    '_noSwiping',
    'noSwipingClass',
    'noSwipingSelector',
    'passiveListeners',
    'containerModifierClass',
    'slideClass',
    'slideActiveClass',
    'slideVisibleClass',
    'slideFullyVisibleClass',
    'slideNextClass',
    'slidePrevClass',
    'slideBlankClass',
    'wrapperClass',
    'lazyPreloaderClass',
    'lazyPreloadPrevNext',
    'runCallbacksOnInit',
    'observer',
    'observeParents',
    'observeSlideChildren',
    // modules
    'a11y',
    '_autoplay',
    '_controller',
    'coverflowEffect',
    'cubeEffect',
    'fadeEffect',
    'flipEffect',
    'creativeEffect',
    'cardsEffect',
    'hashNavigation',
    'history',
    'keyboard',
    'mousewheel',
    '_navigation',
    '_pagination',
    'parallax',
    '_scrollbar',
    '_thumbs',
    'virtual',
    'zoom',
    'control'
];
function isObject(o) {
    return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object' && !o.__swiper__;
}
function extend(target, src) {
    var noExtend = [
        '__proto__',
        'constructor',
        'prototype'
    ];
    Object.keys(src).filter(function(key) {
        return noExtend.indexOf(key) < 0;
    }).forEach(function(key) {
        if (typeof target[key] === 'undefined') target[key] = src[key];
        else if (isObject(src[key]) && isObject(target[key]) && Object.keys(src[key]).length > 0) {
            if (src[key].__swiper__) target[key] = src[key];
            else extend(target[key], src[key]);
        } else target[key] = src[key];
    });
}
function needsNavigation(params) {
    if (params === void 0) params = {};
    return params.navigation && typeof params.navigation.nextEl === 'undefined' && typeof params.navigation.prevEl === 'undefined';
}
function needsPagination(params) {
    if (params === void 0) params = {};
    return params.pagination && typeof params.pagination.el === 'undefined';
}
function needsScrollbar(params) {
    if (params === void 0) params = {};
    return params.scrollbar && typeof params.scrollbar.el === 'undefined';
}
function uniqueClasses(classNames) {
    if (classNames === void 0) classNames = '';
    var classes = classNames.split(' ').map(function(c) {
        return c.trim();
    }).filter(function(c) {
        return !!c;
    });
    var unique = [];
    classes.forEach(function(c) {
        if (unique.indexOf(c) < 0) unique.push(c);
    });
    return unique.join(' ');
}
function attrToProp(attrName) {
    if (attrName === void 0) attrName = '';
    return attrName.replace(/-[a-z]/g, function(l) {
        return l.toUpperCase().replace('-', '');
    });
}
function wrapperClass(className) {
    if (className === void 0) className = '';
    if (!className) return 'swiper-wrapper';
    if (!className.includes('swiper-wrapper')) return `swiper-wrapper ${className}`;
    return className;
}
function updateSwiper(_ref) {
    var swiper = _ref.swiper, slides = _ref.slides, passedParams = _ref.passedParams, changedParams = _ref.changedParams, nextEl = _ref.nextEl, prevEl = _ref.prevEl, scrollbarEl = _ref.scrollbarEl, paginationEl = _ref.paginationEl;
    var updateParams = changedParams.filter(function(key) {
        return key !== 'children' && key !== 'direction' && key !== 'wrapperClass';
    });
    var currentParams = swiper.params, pagination = swiper.pagination, navigation = swiper.navigation, scrollbar = swiper.scrollbar, virtual = swiper.virtual, thumbs = swiper.thumbs;
    var needThumbsInit;
    var needControllerInit;
    var needPaginationInit;
    var needScrollbarInit;
    var needNavigationInit;
    var loopNeedDestroy;
    var loopNeedEnable;
    var loopNeedReloop;
    if (changedParams.includes('thumbs') && passedParams.thumbs && passedParams.thumbs.swiper && !passedParams.thumbs.swiper.destroyed && currentParams.thumbs && (!currentParams.thumbs.swiper || currentParams.thumbs.swiper.destroyed)) needThumbsInit = true;
    if (changedParams.includes('controller') && passedParams.controller && passedParams.controller.control && currentParams.controller && !currentParams.controller.control) needControllerInit = true;
    if (changedParams.includes('pagination') && passedParams.pagination && (passedParams.pagination.el || paginationEl) && (currentParams.pagination || currentParams.pagination === false) && pagination && !pagination.el) needPaginationInit = true;
    if (changedParams.includes('scrollbar') && passedParams.scrollbar && (passedParams.scrollbar.el || scrollbarEl) && (currentParams.scrollbar || currentParams.scrollbar === false) && scrollbar && !scrollbar.el) needScrollbarInit = true;
    if (changedParams.includes('navigation') && passedParams.navigation && (passedParams.navigation.prevEl || prevEl) && (passedParams.navigation.nextEl || nextEl) && (currentParams.navigation || currentParams.navigation === false) && navigation && !navigation.prevEl && !navigation.nextEl) needNavigationInit = true;
    var destroyModule = function(mod) {
        if (!swiper[mod]) return;
        swiper[mod].destroy();
        if (mod === 'navigation') {
            if (swiper.isElement) {
                swiper[mod].prevEl.remove();
                swiper[mod].nextEl.remove();
            }
            currentParams[mod].prevEl = undefined;
            currentParams[mod].nextEl = undefined;
            swiper[mod].prevEl = undefined;
            swiper[mod].nextEl = undefined;
        } else {
            if (swiper.isElement) swiper[mod].el.remove();
            currentParams[mod].el = undefined;
            swiper[mod].el = undefined;
        }
    };
    if (changedParams.includes('loop') && swiper.isElement) {
        if (currentParams.loop && !passedParams.loop) loopNeedDestroy = true;
        else if (!currentParams.loop && passedParams.loop) loopNeedEnable = true;
        else loopNeedReloop = true;
    }
    updateParams.forEach(function(key) {
        if (isObject(currentParams[key]) && isObject(passedParams[key])) {
            Object.assign(currentParams[key], passedParams[key]);
            if ((key === 'navigation' || key === 'pagination' || key === 'scrollbar') && 'enabled' in passedParams[key] && !passedParams[key].enabled) destroyModule(key);
        } else {
            var newValue = passedParams[key];
            if ((newValue === true || newValue === false) && (key === 'navigation' || key === 'pagination' || key === 'scrollbar')) {
                if (newValue === false) destroyModule(key);
            } else currentParams[key] = passedParams[key];
        }
    });
    if (updateParams.includes('controller') && !needControllerInit && swiper.controller && swiper.controller.control && currentParams.controller && currentParams.controller.control) swiper.controller.control = currentParams.controller.control;
    if (changedParams.includes('children') && slides && virtual && currentParams.virtual.enabled) {
        virtual.slides = slides;
        virtual.update(true);
    } else if (changedParams.includes('virtual') && virtual && currentParams.virtual.enabled) {
        if (slides) virtual.slides = slides;
        virtual.update(true);
    }
    if (changedParams.includes('children') && slides && currentParams.loop) loopNeedReloop = true;
    if (needThumbsInit) {
        var initialized = thumbs.init();
        if (initialized) thumbs.update(true);
    }
    if (needControllerInit) swiper.controller.control = currentParams.controller.control;
    if (needPaginationInit) {
        if (swiper.isElement && (!paginationEl || typeof paginationEl === 'string')) {
            paginationEl = document.createElement('div');
            paginationEl.classList.add('swiper-pagination');
            paginationEl.part.add('pagination');
            swiper.el.appendChild(paginationEl);
        }
        if (paginationEl) currentParams.pagination.el = paginationEl;
        pagination.init();
        pagination.render();
        pagination.update();
    }
    if (needScrollbarInit) {
        if (swiper.isElement && (!scrollbarEl || typeof scrollbarEl === 'string')) {
            scrollbarEl = document.createElement('div');
            scrollbarEl.classList.add('swiper-scrollbar');
            scrollbarEl.part.add('scrollbar');
            swiper.el.appendChild(scrollbarEl);
        }
        if (scrollbarEl) currentParams.scrollbar.el = scrollbarEl;
        scrollbar.init();
        scrollbar.updateSize();
        scrollbar.setTranslate();
    }
    if (needNavigationInit) {
        if (swiper.isElement) {
            if (!nextEl || typeof nextEl === 'string') {
                nextEl = document.createElement('div');
                nextEl.classList.add('swiper-button-next');
                nextEl.innerHTML = swiper.hostEl.constructor.nextButtonSvg;
                nextEl.part.add('button-next');
                swiper.el.appendChild(nextEl);
            }
            if (!prevEl || typeof prevEl === 'string') {
                prevEl = document.createElement('div');
                prevEl.classList.add('swiper-button-prev');
                prevEl.innerHTML = swiper.hostEl.constructor.prevButtonSvg;
                prevEl.part.add('button-prev');
                swiper.el.appendChild(prevEl);
            }
        }
        if (nextEl) currentParams.navigation.nextEl = nextEl;
        if (prevEl) currentParams.navigation.prevEl = prevEl;
        navigation.init();
        navigation.update();
    }
    if (changedParams.includes('allowSlideNext')) swiper.allowSlideNext = passedParams.allowSlideNext;
    if (changedParams.includes('allowSlidePrev')) swiper.allowSlidePrev = passedParams.allowSlidePrev;
    if (changedParams.includes('direction')) swiper.changeDirection(passedParams.direction, false);
    if (loopNeedDestroy || loopNeedReloop) swiper.loopDestroy();
    if (loopNeedEnable || loopNeedReloop) swiper.loopCreate();
    swiper.update();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4UOSx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Virtual", function() {
    return 0, _virtualMjsDefault.default;
});
parcelHelpers.export(exports, "Keyboard", function() {
    return 0, _keyboardMjsDefault.default;
});
parcelHelpers.export(exports, "Mousewheel", function() {
    return 0, _mousewheelMjsDefault.default;
});
parcelHelpers.export(exports, "Navigation", function() {
    return 0, _navigationMjsDefault.default;
});
parcelHelpers.export(exports, "Pagination", function() {
    return 0, _paginationMjsDefault.default;
});
parcelHelpers.export(exports, "Scrollbar", function() {
    return 0, _scrollbarMjsDefault.default;
});
parcelHelpers.export(exports, "Parallax", function() {
    return 0, _parallaxMjsDefault.default;
});
parcelHelpers.export(exports, "Zoom", function() {
    return 0, _zoomMjsDefault.default;
});
parcelHelpers.export(exports, "Controller", function() {
    return 0, _controllerMjsDefault.default;
});
parcelHelpers.export(exports, "A11y", function() {
    return 0, _a11YMjsDefault.default;
});
parcelHelpers.export(exports, "History", function() {
    return 0, _historyMjsDefault.default;
});
parcelHelpers.export(exports, "HashNavigation", function() {
    return 0, _hashNavigationMjsDefault.default;
});
parcelHelpers.export(exports, "Autoplay", function() {
    return 0, _autoplayMjsDefault.default;
});
parcelHelpers.export(exports, "Thumbs", function() {
    return 0, _thumbsMjsDefault.default;
});
parcelHelpers.export(exports, "FreeMode", function() {
    return 0, _freeModeMjsDefault.default;
});
parcelHelpers.export(exports, "Grid", function() {
    return 0, _gridMjsDefault.default;
});
parcelHelpers.export(exports, "Manipulation", function() {
    return 0, _manipulationMjsDefault.default;
});
parcelHelpers.export(exports, "EffectFade", function() {
    return 0, _effectFadeMjsDefault.default;
});
parcelHelpers.export(exports, "EffectCube", function() {
    return 0, _effectCubeMjsDefault.default;
});
parcelHelpers.export(exports, "EffectFlip", function() {
    return 0, _effectFlipMjsDefault.default;
});
parcelHelpers.export(exports, "EffectCoverflow", function() {
    return 0, _effectCoverflowMjsDefault.default;
});
parcelHelpers.export(exports, "EffectCreative", function() {
    return 0, _effectCreativeMjsDefault.default;
});
parcelHelpers.export(exports, "EffectCards", function() {
    return 0, _effectCardsMjsDefault.default;
});
var _virtualMjs = require("./virtual.mjs");
var _virtualMjsDefault = parcelHelpers.interopDefault(_virtualMjs);
var _keyboardMjs = require("./keyboard.mjs");
var _keyboardMjsDefault = parcelHelpers.interopDefault(_keyboardMjs);
var _mousewheelMjs = require("./mousewheel.mjs");
var _mousewheelMjsDefault = parcelHelpers.interopDefault(_mousewheelMjs);
var _navigationMjs = require("./navigation.mjs");
var _navigationMjsDefault = parcelHelpers.interopDefault(_navigationMjs);
var _paginationMjs = require("./pagination.mjs");
var _paginationMjsDefault = parcelHelpers.interopDefault(_paginationMjs);
var _scrollbarMjs = require("./scrollbar.mjs");
var _scrollbarMjsDefault = parcelHelpers.interopDefault(_scrollbarMjs);
var _parallaxMjs = require("./parallax.mjs");
var _parallaxMjsDefault = parcelHelpers.interopDefault(_parallaxMjs);
var _zoomMjs = require("./zoom.mjs");
var _zoomMjsDefault = parcelHelpers.interopDefault(_zoomMjs);
var _controllerMjs = require("./controller.mjs");
var _controllerMjsDefault = parcelHelpers.interopDefault(_controllerMjs);
var _a11YMjs = require("./a11y.mjs");
var _a11YMjsDefault = parcelHelpers.interopDefault(_a11YMjs);
var _historyMjs = require("./history.mjs");
var _historyMjsDefault = parcelHelpers.interopDefault(_historyMjs);
var _hashNavigationMjs = require("./hash-navigation.mjs");
var _hashNavigationMjsDefault = parcelHelpers.interopDefault(_hashNavigationMjs);
var _autoplayMjs = require("./autoplay.mjs");
var _autoplayMjsDefault = parcelHelpers.interopDefault(_autoplayMjs);
var _thumbsMjs = require("./thumbs.mjs");
var _thumbsMjsDefault = parcelHelpers.interopDefault(_thumbsMjs);
var _freeModeMjs = require("./free-mode.mjs");
var _freeModeMjsDefault = parcelHelpers.interopDefault(_freeModeMjs);
var _gridMjs = require("./grid.mjs");
var _gridMjsDefault = parcelHelpers.interopDefault(_gridMjs);
var _manipulationMjs = require("./manipulation.mjs");
var _manipulationMjsDefault = parcelHelpers.interopDefault(_manipulationMjs);
var _effectFadeMjs = require("./effect-fade.mjs");
var _effectFadeMjsDefault = parcelHelpers.interopDefault(_effectFadeMjs);
var _effectCubeMjs = require("./effect-cube.mjs");
var _effectCubeMjsDefault = parcelHelpers.interopDefault(_effectCubeMjs);
var _effectFlipMjs = require("./effect-flip.mjs");
var _effectFlipMjsDefault = parcelHelpers.interopDefault(_effectFlipMjs);
var _effectCoverflowMjs = require("./effect-coverflow.mjs");
var _effectCoverflowMjsDefault = parcelHelpers.interopDefault(_effectCoverflowMjs);
var _effectCreativeMjs = require("./effect-creative.mjs");
var _effectCreativeMjsDefault = parcelHelpers.interopDefault(_effectCreativeMjs);
var _effectCardsMjs = require("./effect-cards.mjs");
var _effectCardsMjsDefault = parcelHelpers.interopDefault(_effectCardsMjs);

},{"./virtual.mjs":"2WMg4","./keyboard.mjs":"6Rqtk","./mousewheel.mjs":"f1oN0","./navigation.mjs":"6OxPd","./pagination.mjs":"dYewt","./scrollbar.mjs":"ap72I","./parallax.mjs":"3LSbE","./zoom.mjs":"i4oHc","./controller.mjs":"ezD0Z","./a11y.mjs":"p8V2f","./history.mjs":"3KcoE","./hash-navigation.mjs":"3oUT0","./autoplay.mjs":"9yXUw","./thumbs.mjs":"4QrR0","./free-mode.mjs":"gRDqR","./grid.mjs":"dtt0J","./manipulation.mjs":"iliyF","./effect-fade.mjs":"7Il1W","./effect-cube.mjs":"ibQ1t","./effect-flip.mjs":"kVRbP","./effect-coverflow.mjs":"15Uag","./effect-creative.mjs":"pNNAI","./effect-cards.mjs":"gC8Gv","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2WMg4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return Virtual;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _ssrWindowEsmMjs = require("../shared/ssr-window.esm.mjs");
var _utilsMjs = require("../shared/utils.mjs");
function Virtual(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, on = _ref.on, emit = _ref.emit;
    extendParams({
        virtual: {
            enabled: false,
            slides: [],
            cache: true,
            renderSlide: null,
            renderExternal: null,
            renderExternalUpdate: true,
            addSlidesBefore: 0,
            addSlidesAfter: 0
        }
    });
    var cssModeTimeout;
    var document = (0, _ssrWindowEsmMjs.g)();
    swiper.virtual = {
        cache: {},
        from: undefined,
        to: undefined,
        slides: [],
        offset: 0,
        slidesGrid: []
    };
    var tempDOM = document.createElement('div');
    function renderSlide(slide, index) {
        var params = swiper.params.virtual;
        if (params.cache && swiper.virtual.cache[index]) return swiper.virtual.cache[index];
        // eslint-disable-next-line
        var slideEl;
        if (params.renderSlide) {
            slideEl = params.renderSlide.call(swiper, slide, index);
            if (typeof slideEl === 'string') {
                tempDOM.innerHTML = slideEl;
                slideEl = tempDOM.children[0];
            }
        } else if (swiper.isElement) slideEl = (0, _utilsMjs.c)('swiper-slide');
        else slideEl = (0, _utilsMjs.c)('div', swiper.params.slideClass);
        slideEl.setAttribute('data-swiper-slide-index', index);
        if (!params.renderSlide) slideEl.innerHTML = slide;
        if (params.cache) swiper.virtual.cache[index] = slideEl;
        return slideEl;
    }
    function update(force, beforeInit, forceActiveIndex) {
        var _swiper_params = swiper.params, slidesPerView = _swiper_params.slidesPerView, slidesPerGroup = _swiper_params.slidesPerGroup, centeredSlides = _swiper_params.centeredSlides, isLoop = _swiper_params.loop, initialSlide = _swiper_params.initialSlide;
        if (beforeInit && !isLoop && initialSlide > 0) return;
        var _swiper_params_virtual = swiper.params.virtual, addSlidesBefore = _swiper_params_virtual.addSlidesBefore, addSlidesAfter = _swiper_params_virtual.addSlidesAfter;
        var _swiper_virtual = swiper.virtual, previousFrom = _swiper_virtual.from, previousTo = _swiper_virtual.to, slides = _swiper_virtual.slides, previousSlidesGrid = _swiper_virtual.slidesGrid, previousOffset = _swiper_virtual.offset;
        if (!swiper.params.cssMode) swiper.updateActiveIndex();
        var activeIndex = typeof forceActiveIndex === 'undefined' ? swiper.activeIndex || 0 : forceActiveIndex;
        var offsetProp;
        if (swiper.rtlTranslate) offsetProp = 'right';
        else offsetProp = swiper.isHorizontal() ? 'left' : 'top';
        var slidesAfter;
        var slidesBefore;
        if (centeredSlides) {
            slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
            slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
        } else {
            slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesAfter;
            slidesBefore = (isLoop ? slidesPerView : slidesPerGroup) + addSlidesBefore;
        }
        var from = activeIndex - slidesBefore;
        var to = activeIndex + slidesAfter;
        if (!isLoop) {
            from = Math.max(from, 0);
            to = Math.min(to, slides.length - 1);
        }
        var offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
        if (isLoop && activeIndex >= slidesBefore) {
            from -= slidesBefore;
            if (!centeredSlides) offset += swiper.slidesGrid[0];
        } else if (isLoop && activeIndex < slidesBefore) {
            from = -slidesBefore;
            if (centeredSlides) offset += swiper.slidesGrid[0];
        }
        Object.assign(swiper.virtual, {
            from: from,
            to: to,
            offset: offset,
            slidesGrid: swiper.slidesGrid,
            slidesBefore: slidesBefore,
            slidesAfter: slidesAfter
        });
        function onRendered() {
            swiper.updateSlides();
            swiper.updateProgress();
            swiper.updateSlidesClasses();
            emit('virtualUpdate');
        }
        if (previousFrom === from && previousTo === to && !force) {
            if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) swiper.slides.forEach(function(slideEl) {
                slideEl.style[offsetProp] = `${offset - Math.abs(swiper.cssOverflowAdjustment())}px`;
            });
            swiper.updateProgress();
            emit('virtualUpdate');
            return;
        }
        if (swiper.params.virtual.renderExternal) {
            swiper.params.virtual.renderExternal.call(swiper, {
                offset: offset,
                from: from,
                to: to,
                slides: function getSlides() {
                    var slidesToRender = [];
                    for(var i = from; i <= to; i += 1)slidesToRender.push(slides[i]);
                    return slidesToRender;
                }()
            });
            if (swiper.params.virtual.renderExternalUpdate) onRendered();
            else emit('virtualUpdate');
            return;
        }
        var prependIndexes = [];
        var appendIndexes = [];
        var getSlideIndex = function(index) {
            var slideIndex = index;
            if (index < 0) slideIndex = slides.length + index;
            else if (slideIndex >= slides.length) // eslint-disable-next-line
            slideIndex = slideIndex - slides.length;
            return slideIndex;
        };
        if (force) swiper.slides.filter(function(el) {
            return el.matches(`.${swiper.params.slideClass}, swiper-slide`);
        }).forEach(function(slideEl) {
            slideEl.remove();
        });
        else {
            var _loop = function(i) {
                if (i < from || i > to) {
                    var slideIndex = getSlideIndex(i);
                    swiper.slides.filter(function(el) {
                        return el.matches(`.${swiper.params.slideClass}[data-swiper-slide-index="${slideIndex}"], swiper-slide[data-swiper-slide-index="${slideIndex}"]`);
                    }).forEach(function(slideEl) {
                        slideEl.remove();
                    });
                }
            };
            for(var i = previousFrom; i <= previousTo; i += 1)_loop(i);
        }
        var loopFrom = isLoop ? -slides.length : 0;
        var loopTo = isLoop ? slides.length * 2 : slides.length;
        for(var i1 = loopFrom; i1 < loopTo; i1 += 1)if (i1 >= from && i1 <= to) {
            var slideIndex = getSlideIndex(i1);
            if (typeof previousTo === 'undefined' || force) appendIndexes.push(slideIndex);
            else {
                if (i1 > previousTo) appendIndexes.push(slideIndex);
                if (i1 < previousFrom) prependIndexes.push(slideIndex);
            }
        }
        appendIndexes.forEach(function(index) {
            swiper.slidesEl.append(renderSlide(slides[index], index));
        });
        if (isLoop) for(var i2 = prependIndexes.length - 1; i2 >= 0; i2 -= 1){
            var index = prependIndexes[i2];
            swiper.slidesEl.prepend(renderSlide(slides[index], index));
        }
        else {
            prependIndexes.sort(function(a, b) {
                return b - a;
            });
            prependIndexes.forEach(function(index) {
                swiper.slidesEl.prepend(renderSlide(slides[index], index));
            });
        }
        (0, _utilsMjs.e)(swiper.slidesEl, '.swiper-slide, swiper-slide').forEach(function(slideEl) {
            slideEl.style[offsetProp] = `${offset - Math.abs(swiper.cssOverflowAdjustment())}px`;
        });
        onRendered();
    }
    function appendSlide(slides) {
        if (typeof slides === 'object' && 'length' in slides) {
            for(var i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.push(slides[i]);
        } else swiper.virtual.slides.push(slides);
        update(true);
    }
    function prependSlide(slides) {
        var activeIndex = swiper.activeIndex;
        var newActiveIndex = activeIndex + 1;
        var numberOfNewSlides = 1;
        if (Array.isArray(slides)) {
            for(var i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
            newActiveIndex = activeIndex + slides.length;
            numberOfNewSlides = slides.length;
        } else swiper.virtual.slides.unshift(slides);
        if (swiper.params.virtual.cache) {
            var cache = swiper.virtual.cache;
            var newCache = {};
            Object.keys(cache).forEach(function(cachedIndex) {
                var cachedEl = cache[cachedIndex];
                var cachedElIndex = cachedEl.getAttribute('data-swiper-slide-index');
                if (cachedElIndex) cachedEl.setAttribute('data-swiper-slide-index', parseInt(cachedElIndex, 10) + numberOfNewSlides);
                newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = cachedEl;
            });
            swiper.virtual.cache = newCache;
        }
        update(true);
        swiper.slideTo(newActiveIndex, 0);
    }
    function removeSlide(slidesIndexes) {
        if (typeof slidesIndexes === 'undefined' || slidesIndexes === null) return;
        var activeIndex = swiper.activeIndex;
        if (Array.isArray(slidesIndexes)) for(var i = slidesIndexes.length - 1; i >= 0; i -= 1){
            if (swiper.params.virtual.cache) {
                delete swiper.virtual.cache[slidesIndexes[i]];
                // shift cache indexes
                Object.keys(swiper.virtual.cache).forEach(function(key) {
                    if (key > slidesIndexes) {
                        swiper.virtual.cache[key - 1] = swiper.virtual.cache[key];
                        swiper.virtual.cache[key - 1].setAttribute('data-swiper-slide-index', key - 1);
                        delete swiper.virtual.cache[key];
                    }
                });
            }
            swiper.virtual.slides.splice(slidesIndexes[i], 1);
            if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        else {
            if (swiper.params.virtual.cache) {
                delete swiper.virtual.cache[slidesIndexes];
                // shift cache indexes
                Object.keys(swiper.virtual.cache).forEach(function(key) {
                    if (key > slidesIndexes) {
                        swiper.virtual.cache[key - 1] = swiper.virtual.cache[key];
                        swiper.virtual.cache[key - 1].setAttribute('data-swiper-slide-index', key - 1);
                        delete swiper.virtual.cache[key];
                    }
                });
            }
            swiper.virtual.slides.splice(slidesIndexes, 1);
            if (slidesIndexes < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        update(true);
        swiper.slideTo(activeIndex, 0);
    }
    function removeAllSlides() {
        swiper.virtual.slides = [];
        if (swiper.params.virtual.cache) swiper.virtual.cache = {};
        update(true);
        swiper.slideTo(0, 0);
    }
    on('beforeInit', function() {
        if (!swiper.params.virtual.enabled) return;
        var domSlidesAssigned;
        if (typeof swiper.passedParams.virtual.slides === 'undefined') {
            var slides = (0, _toConsumableArray._)(swiper.slidesEl.children).filter(function(el) {
                return el.matches(`.${swiper.params.slideClass}, swiper-slide`);
            });
            if (slides && slides.length) {
                swiper.virtual.slides = (0, _toConsumableArray._)(slides);
                domSlidesAssigned = true;
                slides.forEach(function(slideEl, slideIndex) {
                    slideEl.setAttribute('data-swiper-slide-index', slideIndex);
                    swiper.virtual.cache[slideIndex] = slideEl;
                    slideEl.remove();
                });
            }
        }
        if (!domSlidesAssigned) swiper.virtual.slides = swiper.params.virtual.slides;
        swiper.classNames.push(`${swiper.params.containerModifierClass}virtual`);
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
        update(false, true);
    });
    on('setTranslate', function() {
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode && !swiper._immediateVirtual) {
            clearTimeout(cssModeTimeout);
            cssModeTimeout = setTimeout(function() {
                update();
            }, 100);
        } else update();
    });
    on('init update resize', function() {
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode) (0, _utilsMjs.s)(swiper.wrapperEl, '--swiper-virtual-size', `${swiper.virtualSize}px`);
    });
    Object.assign(swiper.virtual, {
        appendSlide: appendSlide,
        prependSlide: prependSlide,
        removeSlide: removeSlide,
        removeAllSlides: removeAllSlides,
        update: update
    });
}

},{"@swc/helpers/_/_to_consumable_array":"eqNDD","../shared/ssr-window.esm.mjs":"6ooWP","../shared/utils.mjs":"7Cawp","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6Rqtk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return Keyboard;
});
var _ssrWindowEsmMjs = require("../shared/ssr-window.esm.mjs");
var _utilsMjs = require("../shared/utils.mjs");
/* eslint-disable consistent-return */ function Keyboard(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, on = _ref.on, emit = _ref.emit;
    var document = (0, _ssrWindowEsmMjs.g)();
    var window = (0, _ssrWindowEsmMjs.a)();
    swiper.keyboard = {
        enabled: false
    };
    extendParams({
        keyboard: {
            enabled: false,
            onlyInViewport: true,
            pageUpDown: true
        }
    });
    function handle(event) {
        if (!swiper.enabled) return;
        var rtl = swiper.rtlTranslate;
        var e = event;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        var kc = e.keyCode || e.charCode;
        var pageUpDown = swiper.params.keyboard.pageUpDown;
        var isPageUp = pageUpDown && kc === 33;
        var isPageDown = pageUpDown && kc === 34;
        var isArrowLeft = kc === 37;
        var isArrowRight = kc === 39;
        var isArrowUp = kc === 38;
        var isArrowDown = kc === 40;
        // Directions locks
        if (!swiper.allowSlideNext && (swiper.isHorizontal() && isArrowRight || swiper.isVertical() && isArrowDown || isPageDown)) return false;
        if (!swiper.allowSlidePrev && (swiper.isHorizontal() && isArrowLeft || swiper.isVertical() && isArrowUp || isPageUp)) return false;
        if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) return undefined;
        if (document.activeElement && document.activeElement.nodeName && (document.activeElement.nodeName.toLowerCase() === 'input' || document.activeElement.nodeName.toLowerCase() === 'textarea')) return undefined;
        if (swiper.params.keyboard.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
            var inView = false;
            // Check that swiper should be inside of visible area of window
            if ((0, _utilsMjs.a)(swiper.el, `.${swiper.params.slideClass}, swiper-slide`).length > 0 && (0, _utilsMjs.a)(swiper.el, `.${swiper.params.slideActiveClass}`).length === 0) return undefined;
            var el = swiper.el;
            var swiperWidth = el.clientWidth;
            var swiperHeight = el.clientHeight;
            var windowWidth = window.innerWidth;
            var windowHeight = window.innerHeight;
            var swiperOffset = (0, _utilsMjs.b)(el);
            if (rtl) swiperOffset.left -= el.scrollLeft;
            var swiperCoord = [
                [
                    swiperOffset.left,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left,
                    swiperOffset.top + swiperHeight
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top + swiperHeight
                ]
            ];
            for(var i = 0; i < swiperCoord.length; i += 1){
                var point = swiperCoord[i];
                if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
                    if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
                    inView = true;
                }
            }
            if (!inView) return undefined;
        }
        if (swiper.isHorizontal()) {
            if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if ((isPageDown || isArrowRight) && !rtl || (isPageUp || isArrowLeft) && rtl) swiper.slideNext();
            if ((isPageUp || isArrowLeft) && !rtl || (isPageDown || isArrowRight) && rtl) swiper.slidePrev();
        } else {
            if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if (isPageDown || isArrowDown) swiper.slideNext();
            if (isPageUp || isArrowUp) swiper.slidePrev();
        }
        emit('keyPress', kc);
        return undefined;
    }
    function enable() {
        if (swiper.keyboard.enabled) return;
        document.addEventListener('keydown', handle);
        swiper.keyboard.enabled = true;
    }
    function disable() {
        if (!swiper.keyboard.enabled) return;
        document.removeEventListener('keydown', handle);
        swiper.keyboard.enabled = false;
    }
    on('init', function() {
        if (swiper.params.keyboard.enabled) enable();
    });
    on('destroy', function() {
        if (swiper.keyboard.enabled) disable();
    });
    Object.assign(swiper.keyboard, {
        enable: enable,
        disable: disable
    });
}

},{"../shared/ssr-window.esm.mjs":"6ooWP","../shared/utils.mjs":"7Cawp","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"f1oN0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return Mousewheel;
});
var _ssrWindowEsmMjs = require("../shared/ssr-window.esm.mjs");
var _utilsMjs = require("../shared/utils.mjs");
/* eslint-disable consistent-return */ function Mousewheel(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, on = _ref.on, emit = _ref.emit;
    var window = (0, _ssrWindowEsmMjs.a)();
    extendParams({
        mousewheel: {
            enabled: false,
            releaseOnEdges: false,
            invert: false,
            forceToAxis: false,
            sensitivity: 1,
            eventsTarget: 'container',
            thresholdDelta: null,
            thresholdTime: null,
            noMousewheelClass: 'swiper-no-mousewheel'
        }
    });
    swiper.mousewheel = {
        enabled: false
    };
    var timeout;
    var lastScrollTime = (0, _utilsMjs.d)();
    var lastEventBeforeSnap;
    var recentWheelEvents = [];
    function normalize(e) {
        // Reasonable defaults
        var PIXEL_STEP = 10;
        var LINE_HEIGHT = 40;
        var PAGE_HEIGHT = 800;
        var sX = 0;
        var sY = 0; // spinX, spinY
        var pX = 0;
        var pY = 0; // pixelX, pixelY
        // Legacy
        if ('detail' in e) sY = e.detail;
        if ('wheelDelta' in e) sY = -e.wheelDelta / 120;
        if ('wheelDeltaY' in e) sY = -e.wheelDeltaY / 120;
        if ('wheelDeltaX' in e) sX = -e.wheelDeltaX / 120;
        // side scrolling on FF with DOMMouseScroll
        if ('axis' in e && e.axis === e.HORIZONTAL_AXIS) {
            sX = sY;
            sY = 0;
        }
        pX = sX * PIXEL_STEP;
        pY = sY * PIXEL_STEP;
        if ('deltaY' in e) pY = e.deltaY;
        if ('deltaX' in e) pX = e.deltaX;
        if (e.shiftKey && !pX) {
            // if user scrolls with shift he wants horizontal scroll
            pX = pY;
            pY = 0;
        }
        if ((pX || pY) && e.deltaMode) {
            if (e.deltaMode === 1) {
                // delta in LINE units
                pX *= LINE_HEIGHT;
                pY *= LINE_HEIGHT;
            } else {
                // delta in PAGE units
                pX *= PAGE_HEIGHT;
                pY *= PAGE_HEIGHT;
            }
        }
        // Fall-back if spin cannot be determined
        if (pX && !sX) sX = pX < 1 ? -1 : 1;
        if (pY && !sY) sY = pY < 1 ? -1 : 1;
        return {
            spinX: sX,
            spinY: sY,
            pixelX: pX,
            pixelY: pY
        };
    }
    function handleMouseEnter() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = true;
    }
    function handleMouseLeave() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = false;
    }
    function animateSlider(newEvent) {
        if (swiper.params.mousewheel.thresholdDelta && newEvent.delta < swiper.params.mousewheel.thresholdDelta) // Prevent if delta of wheel scroll delta is below configured threshold
        return false;
        if (swiper.params.mousewheel.thresholdTime && (0, _utilsMjs.d)() - lastScrollTime < swiper.params.mousewheel.thresholdTime) // Prevent if time between scrolls is below configured threshold
        return false;
        // If the movement is NOT big enough and
        // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
        //   Don't go any further (avoid insignificant scroll movement).
        if (newEvent.delta >= 6 && (0, _utilsMjs.d)() - lastScrollTime < 60) // Return false as a default
        return true;
        // If user is scrolling towards the end:
        //   If the slider hasn't hit the latest slide or
        //   if the slider is a loop and
        //   if the slider isn't moving right now:
        //     Go to next slide and
        //     emit a scroll event.
        // Else (the user is scrolling towards the beginning) and
        // if the slider hasn't hit the first slide or
        // if the slider is a loop and
        // if the slider isn't moving right now:
        //   Go to prev slide and
        //   emit a scroll event.
        if (newEvent.direction < 0) {
            if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
                swiper.slideNext();
                emit('scroll', newEvent.raw);
            }
        } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
            swiper.slidePrev();
            emit('scroll', newEvent.raw);
        }
        // If you got here is because an animation has been triggered so store the current time
        lastScrollTime = new window.Date().getTime();
        // Return false as a default
        return false;
    }
    function releaseScroll(newEvent) {
        var params = swiper.params.mousewheel;
        if (newEvent.direction < 0) {
            if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
            return true;
        } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
        return true;
        return false;
    }
    function handle(event1) {
        var e = event1;
        var disableParentSwiper = true;
        if (!swiper.enabled) return;
        // Ignore event if the target or its parents have the swiper-no-mousewheel class
        if (event1.target.closest(`.${swiper.params.mousewheel.noMousewheelClass}`)) return;
        var params = swiper.params.mousewheel;
        if (swiper.params.cssMode) e.preventDefault();
        var targetEl = swiper.el;
        if (swiper.params.mousewheel.eventsTarget !== 'container') targetEl = document.querySelector(swiper.params.mousewheel.eventsTarget);
        var targetElContainsTarget = targetEl && targetEl.contains(e.target);
        if (!swiper.mouseEntered && !targetElContainsTarget && !params.releaseOnEdges) return true;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        var delta = 0;
        var rtlFactor = swiper.rtlTranslate ? -1 : 1;
        var data = normalize(e);
        if (params.forceToAxis) {
            if (swiper.isHorizontal()) {
                if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;
                else return true;
            } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;
            else return true;
        } else delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
        if (delta === 0) return true;
        if (params.invert) delta = -delta;
        // Get the scroll positions
        var positions = swiper.getTranslate() + delta * params.sensitivity;
        if (positions >= swiper.minTranslate()) positions = swiper.minTranslate();
        if (positions <= swiper.maxTranslate()) positions = swiper.maxTranslate();
        // When loop is true:
        //     the disableParentSwiper will be true.
        // When loop is false:
        //     if the scroll positions is not on edge,
        //     then the disableParentSwiper will be true.
        //     if the scroll on edge positions,
        //     then the disableParentSwiper will be false.
        disableParentSwiper = swiper.params.loop ? true : !(positions === swiper.minTranslate() || positions === swiper.maxTranslate());
        if (disableParentSwiper && swiper.params.nested) e.stopPropagation();
        if (!swiper.params.freeMode || !swiper.params.freeMode.enabled) {
            // Register the new event in a variable which stores the relevant data
            var newEvent = {
                time: (0, _utilsMjs.d)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta),
                raw: event1
            };
            // Keep the most recent events
            if (recentWheelEvents.length >= 2) recentWheelEvents.shift(); // only store the last N events
            var prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
            recentWheelEvents.push(newEvent);
            // If there is at least one previous recorded event:
            //   If direction has changed or
            //   if the scroll is quicker than the previous one:
            //     Animate the slider.
            // Else (this is the first time the wheel is moved):
            //     Animate the slider.
            if (prevEvent) {
                if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) animateSlider(newEvent);
            } else animateSlider(newEvent);
            // If it's time to release the scroll:
            //   Return now so you don't hit the preventDefault.
            if (releaseScroll(newEvent)) return true;
        } else {
            // Freemode or scrollContainer:
            // If we recently snapped after a momentum scroll, then ignore wheel events
            // to give time for the deceleration to finish. Stop ignoring after 500 msecs
            // or if it's a new scroll (larger delta or inverse sign as last event before
            // an end-of-momentum snap).
            var newEvent1 = {
                time: (0, _utilsMjs.d)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta)
            };
            var ignoreWheelEvents = lastEventBeforeSnap && newEvent1.time < lastEventBeforeSnap.time + 500 && newEvent1.delta <= lastEventBeforeSnap.delta && newEvent1.direction === lastEventBeforeSnap.direction;
            if (!ignoreWheelEvents) {
                lastEventBeforeSnap = undefined;
                var position = swiper.getTranslate() + delta * params.sensitivity;
                var wasBeginning = swiper.isBeginning;
                var wasEnd = swiper.isEnd;
                if (position >= swiper.minTranslate()) position = swiper.minTranslate();
                if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
                swiper.setTransition(0);
                swiper.setTranslate(position);
                swiper.updateProgress();
                swiper.updateActiveIndex();
                swiper.updateSlidesClasses();
                if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) swiper.updateSlidesClasses();
                if (swiper.params.loop) swiper.loopFix({
                    direction: newEvent1.direction < 0 ? 'next' : 'prev',
                    byMousewheel: true
                });
                if (swiper.params.freeMode.sticky) {
                    // When wheel scrolling starts with sticky (aka snap) enabled, then detect
                    // the end of a momentum scroll by storing recent (N=15?) wheel events.
                    // 1. do all N events have decreasing or same (absolute value) delta?
                    // 2. did all N events arrive in the last M (M=500?) msecs?
                    // 3. does the earliest event have an (absolute value) delta that's
                    //    at least P (P=1?) larger than the most recent event's delta?
                    // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
                    // If 1-4 are "yes" then we're near the end of a momentum scroll deceleration.
                    // Snap immediately and ignore remaining wheel events in this scroll.
                    // See comment above for "remaining wheel events in this scroll" determination.
                    // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
                    clearTimeout(timeout);
                    timeout = undefined;
                    if (recentWheelEvents.length >= 15) recentWheelEvents.shift(); // only store the last N events
                    var prevEvent1 = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
                    var firstEvent = recentWheelEvents[0];
                    recentWheelEvents.push(newEvent1);
                    if (prevEvent1 && (newEvent1.delta > prevEvent1.delta || newEvent1.direction !== prevEvent1.direction)) // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
                    recentWheelEvents.splice(0);
                    else if (recentWheelEvents.length >= 15 && newEvent1.time - firstEvent.time < 500 && firstEvent.delta - newEvent1.delta >= 1 && newEvent1.delta <= 6) {
                        // We're at the end of the deceleration of a momentum scroll, so there's no need
                        // to wait for more events. Snap ASAP on the next tick.
                        // Also, because there's some remaining momentum we'll bias the snap in the
                        // direction of the ongoing scroll because it's better UX for the scroll to snap
                        // in the same direction as the scroll instead of reversing to snap.  Therefore,
                        // if it's already scrolled more than 20% in the current direction, keep going.
                        var snapToThreshold = delta > 0 ? 0.8 : 0.2;
                        lastEventBeforeSnap = newEvent1;
                        recentWheelEvents.splice(0);
                        timeout = (0, _utilsMjs.n)(function() {
                            if (swiper.destroyed || !swiper.params) return;
                            swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                        }, 0); // no delay; move on next tick
                    }
                    if (!timeout) // if we get here, then we haven't detected the end of a momentum scroll, so
                    // we'll consider a scroll "complete" when there haven't been any wheel events
                    // for 500ms.
                    timeout = (0, _utilsMjs.n)(function() {
                        if (swiper.destroyed || !swiper.params) return;
                        var snapToThreshold = 0.5;
                        lastEventBeforeSnap = newEvent1;
                        recentWheelEvents.splice(0);
                        swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                    }, 500);
                }
                // Emit event
                if (!ignoreWheelEvents) emit('scroll', e);
                // Stop autoplay
                if (swiper.params.autoplay && swiper.params.autoplay.disableOnInteraction) swiper.autoplay.stop();
                // Return page scroll on edge positions
                if (params.releaseOnEdges && (position === swiper.minTranslate() || position === swiper.maxTranslate())) return true;
            }
        }
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return false;
    }
    function events(method) {
        var targetEl = swiper.el;
        if (swiper.params.mousewheel.eventsTarget !== 'container') targetEl = document.querySelector(swiper.params.mousewheel.eventsTarget);
        targetEl[method]('mouseenter', handleMouseEnter);
        targetEl[method]('mouseleave', handleMouseLeave);
        targetEl[method]('wheel', handle);
    }
    function enable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.removeEventListener('wheel', handle);
            return true;
        }
        if (swiper.mousewheel.enabled) return false;
        events('addEventListener');
        swiper.mousewheel.enabled = true;
        return true;
    }
    function disable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.addEventListener(event, handle);
            return true;
        }
        if (!swiper.mousewheel.enabled) return false;
        events('removeEventListener');
        swiper.mousewheel.enabled = false;
        return true;
    }
    on('init', function() {
        if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) disable();
        if (swiper.params.mousewheel.enabled) enable();
    });
    on('destroy', function() {
        if (swiper.params.cssMode) enable();
        if (swiper.mousewheel.enabled) disable();
    });
    Object.assign(swiper.mousewheel, {
        enable: enable,
        disable: disable
    });
}

},{"../shared/ssr-window.esm.mjs":"6ooWP","../shared/utils.mjs":"7Cawp","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6OxPd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return Navigation;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _createElementIfNotDefinedMjs = require("../shared/create-element-if-not-defined.mjs");
var _utilsMjs = require("../shared/utils.mjs");
function Navigation(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, on = _ref.on, emit = _ref.emit;
    extendParams({
        navigation: {
            nextEl: null,
            prevEl: null,
            hideOnClick: false,
            disabledClass: 'swiper-button-disabled',
            hiddenClass: 'swiper-button-hidden',
            lockClass: 'swiper-button-lock',
            navigationDisabledClass: 'swiper-navigation-disabled'
        }
    });
    swiper.navigation = {
        nextEl: null,
        prevEl: null
    };
    function getEl(el) {
        var res;
        if (el && typeof el === 'string' && swiper.isElement) {
            res = swiper.el.querySelector(el) || swiper.hostEl.querySelector(el);
            if (res) return res;
        }
        if (el) {
            if (typeof el === 'string') res = (0, _toConsumableArray._)(document.querySelectorAll(el));
            if (swiper.params.uniqueNavElements && typeof el === 'string' && res && res.length > 1 && swiper.el.querySelectorAll(el).length === 1) res = swiper.el.querySelector(el);
            else if (res && res.length === 1) res = res[0];
        }
        if (el && !res) return el;
        // if (Array.isArray(res) && res.length === 1) res = res[0];
        return res;
    }
    function toggleEl(el, disabled) {
        var params = swiper.params.navigation;
        el = (0, _utilsMjs.m)(el);
        el.forEach(function(subEl) {
            if (subEl) {
                var _subEl_classList;
                (_subEl_classList = subEl.classList)[disabled ? 'add' : 'remove'].apply(_subEl_classList, (0, _toConsumableArray._)(params.disabledClass.split(' ')));
                if (subEl.tagName === 'BUTTON') subEl.disabled = disabled;
                if (swiper.params.watchOverflow && swiper.enabled) subEl.classList[swiper.isLocked ? 'add' : 'remove'](params.lockClass);
            }
        });
    }
    function update() {
        // Update Navigation Buttons
        var _swiper_navigation = swiper.navigation, nextEl = _swiper_navigation.nextEl, prevEl = _swiper_navigation.prevEl;
        if (swiper.params.loop) {
            toggleEl(prevEl, false);
            toggleEl(nextEl, false);
            return;
        }
        toggleEl(prevEl, swiper.isBeginning && !swiper.params.rewind);
        toggleEl(nextEl, swiper.isEnd && !swiper.params.rewind);
    }
    function onPrevClick(e) {
        e.preventDefault();
        if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slidePrev();
        emit('navigationPrev');
    }
    function onNextClick(e) {
        e.preventDefault();
        if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slideNext();
        emit('navigationNext');
    }
    function init() {
        var params = swiper.params.navigation;
        swiper.params.navigation = (0, _createElementIfNotDefinedMjs.c)(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
            nextEl: 'swiper-button-next',
            prevEl: 'swiper-button-prev'
        });
        if (!(params.nextEl || params.prevEl)) return;
        var nextEl = getEl(params.nextEl);
        var prevEl = getEl(params.prevEl);
        Object.assign(swiper.navigation, {
            nextEl: nextEl,
            prevEl: prevEl
        });
        nextEl = (0, _utilsMjs.m)(nextEl);
        prevEl = (0, _utilsMjs.m)(prevEl);
        var initButton = function(el, dir) {
            var _el_classList;
            if (el) el.addEventListener('click', dir === 'next' ? onNextClick : onPrevClick);
            if (!swiper.enabled && el) (_el_classList = el.classList).add.apply(_el_classList, (0, _toConsumableArray._)(params.lockClass.split(' ')));
        };
        nextEl.forEach(function(el) {
            return initButton(el, 'next');
        });
        prevEl.forEach(function(el) {
            return initButton(el, 'prev');
        });
    }
    function destroy() {
        var _swiper_navigation = swiper.navigation, nextEl = _swiper_navigation.nextEl, prevEl = _swiper_navigation.prevEl;
        nextEl = (0, _utilsMjs.m)(nextEl);
        prevEl = (0, _utilsMjs.m)(prevEl);
        var destroyButton = function(el, dir) {
            var _el_classList;
            el.removeEventListener('click', dir === 'next' ? onNextClick : onPrevClick);
            (_el_classList = el.classList).remove.apply(_el_classList, (0, _toConsumableArray._)(swiper.params.navigation.disabledClass.split(' ')));
        };
        nextEl.forEach(function(el) {
            return destroyButton(el, 'next');
        });
        prevEl.forEach(function(el) {
            return destroyButton(el, 'prev');
        });
    }
    on('init', function() {
        if (swiper.params.navigation.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            update();
        }
    });
    on('toEdge fromEdge lock unlock', function() {
        update();
    });
    on('destroy', function() {
        destroy();
    });
    on('enable disable', function() {
        var _swiper_navigation = swiper.navigation, nextEl = _swiper_navigation.nextEl, prevEl = _swiper_navigation.prevEl;
        nextEl = (0, _utilsMjs.m)(nextEl);
        prevEl = (0, _utilsMjs.m)(prevEl);
        if (swiper.enabled) {
            update();
            return;
        }
        (0, _toConsumableArray._)(nextEl).concat((0, _toConsumableArray._)(prevEl)).filter(function(el) {
            return !!el;
        }).forEach(function(el) {
            return el.classList.add(swiper.params.navigation.lockClass);
        });
    });
    on('click', function(_s, e) {
        var _swiper_navigation = swiper.navigation, nextEl = _swiper_navigation.nextEl, prevEl = _swiper_navigation.prevEl;
        nextEl = (0, _utilsMjs.m)(nextEl);
        prevEl = (0, _utilsMjs.m)(prevEl);
        var targetEl = e.target;
        var targetIsButton = prevEl.includes(targetEl) || nextEl.includes(targetEl);
        if (swiper.isElement && !targetIsButton) {
            var path = e.path || e.composedPath && e.composedPath();
            if (path) targetIsButton = path.find(function(pathEl) {
                return nextEl.includes(pathEl) || prevEl.includes(pathEl);
            });
        }
        if (swiper.params.navigation.hideOnClick && !targetIsButton) {
            if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
            var isHidden;
            if (nextEl.length) isHidden = nextEl[0].classList.contains(swiper.params.navigation.hiddenClass);
            else if (prevEl.length) isHidden = prevEl[0].classList.contains(swiper.params.navigation.hiddenClass);
            if (isHidden === true) emit('navigationShow');
            else emit('navigationHide');
            (0, _toConsumableArray._)(nextEl).concat((0, _toConsumableArray._)(prevEl)).filter(function(el) {
                return !!el;
            }).forEach(function(el) {
                return el.classList.toggle(swiper.params.navigation.hiddenClass);
            });
        }
    });
    var enable = function() {
        var _swiper_el_classList;
        (_swiper_el_classList = swiper.el.classList).remove.apply(_swiper_el_classList, (0, _toConsumableArray._)(swiper.params.navigation.navigationDisabledClass.split(' ')));
        init();
        update();
    };
    var disable = function() {
        var _swiper_el_classList;
        (_swiper_el_classList = swiper.el.classList).add.apply(_swiper_el_classList, (0, _toConsumableArray._)(swiper.params.navigation.navigationDisabledClass.split(' ')));
        destroy();
    };
    Object.assign(swiper.navigation, {
        enable: enable,
        disable: disable,
        update: update,
        init: init,
        destroy: destroy
    });
}

},{"@swc/helpers/_/_to_consumable_array":"eqNDD","../shared/create-element-if-not-defined.mjs":"7M0LJ","../shared/utils.mjs":"7Cawp","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7M0LJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "c", function() {
    return createElementIfNotDefined;
});
var _utilsMjs = require("./utils.mjs");
function createElementIfNotDefined(swiper, originalParams, params, checkProps) {
    if (swiper.params.createElements) Object.keys(checkProps).forEach(function(key) {
        if (!params[key] && params.auto === true) {
            var element = (0, _utilsMjs.e)(swiper.el, `.${checkProps[key]}`)[0];
            if (!element) {
                element = (0, _utilsMjs.c)('div', checkProps[key]);
                element.className = checkProps[key];
                swiper.el.append(element);
            }
            params[key] = element;
            originalParams[key] = element;
        }
    });
    return params;
}

},{"./utils.mjs":"7Cawp","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"dYewt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return Pagination;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _classesToSelectorMjs = require("../shared/classes-to-selector.mjs");
var _createElementIfNotDefinedMjs = require("../shared/create-element-if-not-defined.mjs");
var _utilsMjs = require("../shared/utils.mjs");
function Pagination(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, on = _ref.on, emit = _ref.emit;
    var pfx = 'swiper-pagination';
    extendParams({
        pagination: {
            el: null,
            bulletElement: 'span',
            clickable: false,
            hideOnClick: false,
            renderBullet: null,
            renderProgressbar: null,
            renderFraction: null,
            renderCustom: null,
            progressbarOpposite: false,
            type: 'bullets',
            // 'bullets' or 'progressbar' or 'fraction' or 'custom'
            dynamicBullets: false,
            dynamicMainBullets: 1,
            formatFractionCurrent: function(number) {
                return number;
            },
            formatFractionTotal: function(number) {
                return number;
            },
            bulletClass: `${pfx}-bullet`,
            bulletActiveClass: `${pfx}-bullet-active`,
            modifierClass: `${pfx}-`,
            currentClass: `${pfx}-current`,
            totalClass: `${pfx}-total`,
            hiddenClass: `${pfx}-hidden`,
            progressbarFillClass: `${pfx}-progressbar-fill`,
            progressbarOppositeClass: `${pfx}-progressbar-opposite`,
            clickableClass: `${pfx}-clickable`,
            lockClass: `${pfx}-lock`,
            horizontalClass: `${pfx}-horizontal`,
            verticalClass: `${pfx}-vertical`,
            paginationDisabledClass: `${pfx}-disabled`
        }
    });
    swiper.pagination = {
        el: null,
        bullets: []
    };
    var bulletSize;
    var dynamicBulletIndex = 0;
    function isPaginationDisabled() {
        return !swiper.params.pagination.el || !swiper.pagination.el || Array.isArray(swiper.pagination.el) && swiper.pagination.el.length === 0;
    }
    function setSideBullets(bulletEl, position) {
        var bulletActiveClass = swiper.params.pagination.bulletActiveClass;
        if (!bulletEl) return;
        bulletEl = bulletEl[`${position === 'prev' ? 'previous' : 'next'}ElementSibling`];
        if (bulletEl) {
            bulletEl.classList.add(`${bulletActiveClass}-${position}`);
            bulletEl = bulletEl[`${position === 'prev' ? 'previous' : 'next'}ElementSibling`];
            if (bulletEl) bulletEl.classList.add(`${bulletActiveClass}-${position}-${position}`);
        }
    }
    function getMoveDirection(prevIndex, nextIndex, length) {
        prevIndex = prevIndex % length;
        nextIndex = nextIndex % length;
        if (nextIndex === prevIndex + 1) return 'next';
        else if (nextIndex === prevIndex - 1) return 'previous';
        return;
    }
    function onBulletClick(e) {
        var bulletEl = e.target.closest((0, _classesToSelectorMjs.c)(swiper.params.pagination.bulletClass));
        if (!bulletEl) return;
        e.preventDefault();
        var index = (0, _utilsMjs.h)(bulletEl) * swiper.params.slidesPerGroup;
        if (swiper.params.loop) {
            if (swiper.realIndex === index) return;
            var moveDirection = getMoveDirection(swiper.realIndex, index, swiper.slides.length);
            if (moveDirection === 'next') swiper.slideNext();
            else if (moveDirection === 'previous') swiper.slidePrev();
            else swiper.slideToLoop(index);
        } else swiper.slideTo(index);
    }
    function update() {
        // Render || Update Pagination bullets/items
        var rtl = swiper.rtl;
        var params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        var el = swiper.pagination.el;
        el = (0, _utilsMjs.m)(el);
        // Current/Total
        var current;
        var previousIndex;
        var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        var total = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
        if (swiper.params.loop) {
            previousIndex = swiper.previousRealIndex || 0;
            current = swiper.params.slidesPerGroup > 1 ? Math.floor(swiper.realIndex / swiper.params.slidesPerGroup) : swiper.realIndex;
        } else if (typeof swiper.snapIndex !== 'undefined') {
            current = swiper.snapIndex;
            previousIndex = swiper.previousSnapIndex;
        } else {
            previousIndex = swiper.previousIndex || 0;
            current = swiper.activeIndex || 0;
        }
        // Types
        if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
            var bullets = swiper.pagination.bullets;
            var firstIndex;
            var lastIndex;
            var midIndex;
            if (params.dynamicBullets) {
                bulletSize = (0, _utilsMjs.f)(bullets[0], swiper.isHorizontal() ? 'width' : 'height', true);
                el.forEach(function(subEl) {
                    subEl.style[swiper.isHorizontal() ? 'width' : 'height'] = `${bulletSize * (params.dynamicMainBullets + 4)}px`;
                });
                if (params.dynamicMainBullets > 1 && previousIndex !== undefined) {
                    dynamicBulletIndex += current - (previousIndex || 0);
                    if (dynamicBulletIndex > params.dynamicMainBullets - 1) dynamicBulletIndex = params.dynamicMainBullets - 1;
                    else if (dynamicBulletIndex < 0) dynamicBulletIndex = 0;
                }
                firstIndex = Math.max(current - dynamicBulletIndex, 0);
                lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
                midIndex = (lastIndex + firstIndex) / 2;
            }
            bullets.forEach(function(bulletEl) {
                var _bulletEl_classList;
                var classesToRemove = (0, _toConsumableArray._)([
                    '',
                    '-next',
                    '-next-next',
                    '-prev',
                    '-prev-prev',
                    '-main'
                ].map(function(suffix) {
                    return `${params.bulletActiveClass}${suffix}`;
                })).map(function(s) {
                    return typeof s === 'string' && s.includes(' ') ? s.split(' ') : s;
                }).flat();
                (_bulletEl_classList = bulletEl.classList).remove.apply(_bulletEl_classList, (0, _toConsumableArray._)(classesToRemove));
            });
            if (el.length > 1) bullets.forEach(function(bullet) {
                var _bullet_classList;
                var bulletIndex = (0, _utilsMjs.h)(bullet);
                if (bulletIndex === current) (_bullet_classList = bullet.classList).add.apply(_bullet_classList, (0, _toConsumableArray._)(params.bulletActiveClass.split(' ')));
                else if (swiper.isElement) bullet.setAttribute('part', 'bullet');
                if (params.dynamicBullets) {
                    var _bullet_classList1;
                    if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) (_bullet_classList1 = bullet.classList).add.apply(_bullet_classList1, (0, _toConsumableArray._)(`${params.bulletActiveClass}-main`.split(' ')));
                    if (bulletIndex === firstIndex) setSideBullets(bullet, 'prev');
                    if (bulletIndex === lastIndex) setSideBullets(bullet, 'next');
                }
            });
            else {
                var _bullet_classList;
                var bullet = bullets[current];
                if (bullet) (_bullet_classList = bullet.classList).add.apply(_bullet_classList, (0, _toConsumableArray._)(params.bulletActiveClass.split(' ')));
                if (swiper.isElement) bullets.forEach(function(bulletEl, bulletIndex) {
                    bulletEl.setAttribute('part', bulletIndex === current ? 'bullet-active' : 'bullet');
                });
                if (params.dynamicBullets) {
                    var _bullets_i_classList;
                    var firstDisplayedBullet = bullets[firstIndex];
                    var lastDisplayedBullet = bullets[lastIndex];
                    for(var i = firstIndex; i <= lastIndex; i += 1)if (bullets[i]) (_bullets_i_classList = bullets[i].classList).add.apply(_bullets_i_classList, (0, _toConsumableArray._)(`${params.bulletActiveClass}-main`.split(' ')));
                    setSideBullets(firstDisplayedBullet, 'prev');
                    setSideBullets(lastDisplayedBullet, 'next');
                }
            }
            if (params.dynamicBullets) {
                var dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
                var bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
                var offsetProp = rtl ? 'right' : 'left';
                bullets.forEach(function(bullet) {
                    bullet.style[swiper.isHorizontal() ? offsetProp : 'top'] = `${bulletsOffset}px`;
                });
            }
        }
        el.forEach(function(subEl, subElIndex) {
            if (params.type === 'fraction') {
                subEl.querySelectorAll((0, _classesToSelectorMjs.c)(params.currentClass)).forEach(function(fractionEl) {
                    fractionEl.textContent = params.formatFractionCurrent(current + 1);
                });
                subEl.querySelectorAll((0, _classesToSelectorMjs.c)(params.totalClass)).forEach(function(totalEl) {
                    totalEl.textContent = params.formatFractionTotal(total);
                });
            }
            if (params.type === 'progressbar') {
                var progressbarDirection;
                if (params.progressbarOpposite) progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
                else progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
                var scale = (current + 1) / total;
                var scaleX = 1;
                var scaleY = 1;
                if (progressbarDirection === 'horizontal') scaleX = scale;
                else scaleY = scale;
                subEl.querySelectorAll((0, _classesToSelectorMjs.c)(params.progressbarFillClass)).forEach(function(progressEl) {
                    progressEl.style.transform = `translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`;
                    progressEl.style.transitionDuration = `${swiper.params.speed}ms`;
                });
            }
            if (params.type === 'custom' && params.renderCustom) {
                subEl.innerHTML = params.renderCustom(swiper, current + 1, total);
                if (subElIndex === 0) emit('paginationRender', subEl);
            } else {
                if (subElIndex === 0) emit('paginationRender', subEl);
                emit('paginationUpdate', subEl);
            }
            if (swiper.params.watchOverflow && swiper.enabled) subEl.classList[swiper.isLocked ? 'add' : 'remove'](params.lockClass);
        });
    }
    function render() {
        // Render Container
        var params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.grid && swiper.params.grid.rows > 1 ? swiper.slides.length / Math.ceil(swiper.params.grid.rows) : swiper.slides.length;
        var el = swiper.pagination.el;
        el = (0, _utilsMjs.m)(el);
        var paginationHTML = '';
        if (params.type === 'bullets') {
            var numberOfBullets = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
            if (swiper.params.freeMode && swiper.params.freeMode.enabled && numberOfBullets > slidesLength) numberOfBullets = slidesLength;
            for(var i = 0; i < numberOfBullets; i += 1)if (params.renderBullet) paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
            else // prettier-ignore
            paginationHTML += `<${params.bulletElement} ${swiper.isElement ? 'part="bullet"' : ''} class="${params.bulletClass}"></${params.bulletElement}>`;
        }
        if (params.type === 'fraction') {
            if (params.renderFraction) paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
            else paginationHTML = `<span class="${params.currentClass}"></span>` + ' / ' + `<span class="${params.totalClass}"></span>`;
        }
        if (params.type === 'progressbar') {
            if (params.renderProgressbar) paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
            else paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
        }
        swiper.pagination.bullets = [];
        el.forEach(function(subEl) {
            var _swiper_pagination_bullets;
            if (params.type !== 'custom') subEl.innerHTML = paginationHTML || '';
            if (params.type === 'bullets') (_swiper_pagination_bullets = swiper.pagination.bullets).push.apply(_swiper_pagination_bullets, (0, _toConsumableArray._)(subEl.querySelectorAll((0, _classesToSelectorMjs.c)(params.bulletClass))));
        });
        if (params.type !== 'custom') emit('paginationRender', el[0]);
    }
    function init() {
        swiper.params.pagination = (0, _createElementIfNotDefinedMjs.c)(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
            el: 'swiper-pagination'
        });
        var params = swiper.params.pagination;
        if (!params.el) return;
        var el;
        if (typeof params.el === 'string' && swiper.isElement) el = swiper.el.querySelector(params.el);
        if (!el && typeof params.el === 'string') el = (0, _toConsumableArray._)(document.querySelectorAll(params.el));
        if (!el) el = params.el;
        if (!el || el.length === 0) return;
        if (swiper.params.uniqueNavElements && typeof params.el === 'string' && Array.isArray(el) && el.length > 1) {
            el = (0, _toConsumableArray._)(swiper.el.querySelectorAll(params.el));
            // check if it belongs to another nested Swiper
            if (el.length > 1) el = el.find(function(subEl) {
                if ((0, _utilsMjs.a)(subEl, '.swiper')[0] !== swiper.el) return false;
                return true;
            });
        }
        if (Array.isArray(el) && el.length === 1) el = el[0];
        Object.assign(swiper.pagination, {
            el: el
        });
        el = (0, _utilsMjs.m)(el);
        el.forEach(function(subEl) {
            var _subEl_classList;
            if (params.type === 'bullets' && params.clickable) (_subEl_classList = subEl.classList).add.apply(_subEl_classList, (0, _toConsumableArray._)((params.clickableClass || '').split(' ')));
            subEl.classList.add(params.modifierClass + params.type);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
            if (params.type === 'bullets' && params.dynamicBullets) {
                subEl.classList.add(`${params.modifierClass}${params.type}-dynamic`);
                dynamicBulletIndex = 0;
                if (params.dynamicMainBullets < 1) params.dynamicMainBullets = 1;
            }
            if (params.type === 'progressbar' && params.progressbarOpposite) subEl.classList.add(params.progressbarOppositeClass);
            if (params.clickable) subEl.addEventListener('click', onBulletClick);
            if (!swiper.enabled) subEl.classList.add(params.lockClass);
        });
    }
    function destroy() {
        var _subEl_classList;
        var params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        var el = swiper.pagination.el;
        if (el) {
            el = (0, _utilsMjs.m)(el);
            el.forEach(function(subEl) {
                subEl.classList.remove(params.hiddenClass);
                subEl.classList.remove(params.modifierClass + params.type);
                subEl.classList.remove(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
                if (params.clickable) {
                    var _subEl_classList;
                    (_subEl_classList = subEl.classList).remove.apply(_subEl_classList, (0, _toConsumableArray._)((params.clickableClass || '').split(' ')));
                    subEl.removeEventListener('click', onBulletClick);
                }
            });
        }
        if (swiper.pagination.bullets) swiper.pagination.bullets.forEach(function(subEl) {
            return (_subEl_classList = subEl.classList).remove.apply(_subEl_classList, (0, _toConsumableArray._)(params.bulletActiveClass.split(' ')));
        });
    }
    on('changeDirection', function() {
        if (!swiper.pagination || !swiper.pagination.el) return;
        var params = swiper.params.pagination;
        var el = swiper.pagination.el;
        el = (0, _utilsMjs.m)(el);
        el.forEach(function(subEl) {
            subEl.classList.remove(params.horizontalClass, params.verticalClass);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        });
    });
    on('init', function() {
        if (swiper.params.pagination.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            render();
            update();
        }
    });
    on('activeIndexChange', function() {
        if (typeof swiper.snapIndex === 'undefined') update();
    });
    on('snapIndexChange', function() {
        update();
    });
    on('snapGridLengthChange', function() {
        render();
        update();
    });
    on('destroy', function() {
        destroy();
    });
    on('enable disable', function() {
        var el = swiper.pagination.el;
        if (el) {
            el = (0, _utilsMjs.m)(el);
            el.forEach(function(subEl) {
                return subEl.classList[swiper.enabled ? 'remove' : 'add'](swiper.params.pagination.lockClass);
            });
        }
    });
    on('lock unlock', function() {
        update();
    });
    on('click', function(_s, e) {
        var targetEl = e.target;
        var el = (0, _utilsMjs.m)(swiper.pagination.el);
        if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && el && el.length > 0 && !targetEl.classList.contains(swiper.params.pagination.bulletClass)) {
            if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
            var isHidden = el[0].classList.contains(swiper.params.pagination.hiddenClass);
            if (isHidden === true) emit('paginationShow');
            else emit('paginationHide');
            el.forEach(function(subEl) {
                return subEl.classList.toggle(swiper.params.pagination.hiddenClass);
            });
        }
    });
    var enable = function() {
        swiper.el.classList.remove(swiper.params.pagination.paginationDisabledClass);
        var el = swiper.pagination.el;
        if (el) {
            el = (0, _utilsMjs.m)(el);
            el.forEach(function(subEl) {
                return subEl.classList.remove(swiper.params.pagination.paginationDisabledClass);
            });
        }
        init();
        render();
        update();
    };
    var disable = function() {
        swiper.el.classList.add(swiper.params.pagination.paginationDisabledClass);
        var el = swiper.pagination.el;
        if (el) {
            el = (0, _utilsMjs.m)(el);
            el.forEach(function(subEl) {
                return subEl.classList.add(swiper.params.pagination.paginationDisabledClass);
            });
        }
        destroy();
    };
    Object.assign(swiper.pagination, {
        enable: enable,
        disable: disable,
        render: render,
        update: update,
        init: init,
        destroy: destroy
    });
}

},{"@swc/helpers/_/_to_consumable_array":"eqNDD","../shared/classes-to-selector.mjs":"aZg9M","../shared/create-element-if-not-defined.mjs":"7M0LJ","../shared/utils.mjs":"7Cawp","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"aZg9M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "c", function() {
    return classesToSelector;
});
function classesToSelector(classes) {
    if (classes === void 0) classes = '';
    return `.${classes.trim().replace(/([\.:!+\/])/g, '\\$1') // eslint-disable-line
    .replace(/ /g, '.')}`;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"ap72I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return Scrollbar;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _ssrWindowEsmMjs = require("../shared/ssr-window.esm.mjs");
var _utilsMjs = require("../shared/utils.mjs");
var _createElementIfNotDefinedMjs = require("../shared/create-element-if-not-defined.mjs");
var _classesToSelectorMjs = require("../shared/classes-to-selector.mjs");
function Scrollbar(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, on = _ref.on, emit = _ref.emit;
    var document = (0, _ssrWindowEsmMjs.g)();
    var isTouched = false;
    var timeout = null;
    var dragTimeout = null;
    var dragStartPos;
    var dragSize;
    var trackSize;
    var divider;
    extendParams({
        scrollbar: {
            el: null,
            dragSize: 'auto',
            hide: false,
            draggable: false,
            snapOnRelease: true,
            lockClass: 'swiper-scrollbar-lock',
            dragClass: 'swiper-scrollbar-drag',
            scrollbarDisabledClass: 'swiper-scrollbar-disabled',
            horizontalClass: `swiper-scrollbar-horizontal`,
            verticalClass: `swiper-scrollbar-vertical`
        }
    });
    swiper.scrollbar = {
        el: null,
        dragEl: null
    };
    function setTranslate() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        var scrollbar = swiper.scrollbar, rtl = swiper.rtlTranslate;
        var dragEl = scrollbar.dragEl, el = scrollbar.el;
        var params = swiper.params.scrollbar;
        var progress = swiper.params.loop ? swiper.progressLoop : swiper.progress;
        var newSize = dragSize;
        var newPos = (trackSize - dragSize) * progress;
        if (rtl) {
            newPos = -newPos;
            if (newPos > 0) {
                newSize = dragSize - newPos;
                newPos = 0;
            } else if (-newPos + dragSize > trackSize) newSize = trackSize + newPos;
        } else if (newPos < 0) {
            newSize = dragSize + newPos;
            newPos = 0;
        } else if (newPos + dragSize > trackSize) newSize = trackSize - newPos;
        if (swiper.isHorizontal()) {
            dragEl.style.transform = `translate3d(${newPos}px, 0, 0)`;
            dragEl.style.width = `${newSize}px`;
        } else {
            dragEl.style.transform = `translate3d(0px, ${newPos}px, 0)`;
            dragEl.style.height = `${newSize}px`;
        }
        if (params.hide) {
            clearTimeout(timeout);
            el.style.opacity = 1;
            timeout = setTimeout(function() {
                el.style.opacity = 0;
                el.style.transitionDuration = '400ms';
            }, 1000);
        }
    }
    function setTransition(duration) {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        swiper.scrollbar.dragEl.style.transitionDuration = `${duration}ms`;
    }
    function updateSize() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        var scrollbar = swiper.scrollbar;
        var dragEl = scrollbar.dragEl, el = scrollbar.el;
        dragEl.style.width = '';
        dragEl.style.height = '';
        trackSize = swiper.isHorizontal() ? el.offsetWidth : el.offsetHeight;
        divider = swiper.size / (swiper.virtualSize + swiper.params.slidesOffsetBefore - (swiper.params.centeredSlides ? swiper.snapGrid[0] : 0));
        if (swiper.params.scrollbar.dragSize === 'auto') dragSize = trackSize * divider;
        else dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
        if (swiper.isHorizontal()) dragEl.style.width = `${dragSize}px`;
        else dragEl.style.height = `${dragSize}px`;
        if (divider >= 1) el.style.display = 'none';
        else el.style.display = '';
        if (swiper.params.scrollbar.hide) el.style.opacity = 0;
        if (swiper.params.watchOverflow && swiper.enabled) scrollbar.el.classList[swiper.isLocked ? 'add' : 'remove'](swiper.params.scrollbar.lockClass);
    }
    function getPointerPosition(e) {
        return swiper.isHorizontal() ? e.clientX : e.clientY;
    }
    function setDragPosition(e) {
        var scrollbar = swiper.scrollbar, rtl = swiper.rtlTranslate;
        var el = scrollbar.el;
        var positionRatio;
        positionRatio = (getPointerPosition(e) - (0, _utilsMjs.b)(el)[swiper.isHorizontal() ? 'left' : 'top'] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
        positionRatio = Math.max(Math.min(positionRatio, 1), 0);
        if (rtl) positionRatio = 1 - positionRatio;
        var position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
        swiper.updateProgress(position);
        swiper.setTranslate(position);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    function onDragStart(e) {
        var params = swiper.params.scrollbar;
        var scrollbar = swiper.scrollbar, wrapperEl = swiper.wrapperEl;
        var el = scrollbar.el, dragEl = scrollbar.dragEl;
        isTouched = true;
        dragStartPos = e.target === dragEl ? getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? 'left' : 'top'] : null;
        e.preventDefault();
        e.stopPropagation();
        wrapperEl.style.transitionDuration = '100ms';
        dragEl.style.transitionDuration = '100ms';
        setDragPosition(e);
        clearTimeout(dragTimeout);
        el.style.transitionDuration = '0ms';
        if (params.hide) el.style.opacity = 1;
        if (swiper.params.cssMode) swiper.wrapperEl.style['scroll-snap-type'] = 'none';
        emit('scrollbarDragStart', e);
    }
    function onDragMove(e) {
        var scrollbar = swiper.scrollbar, wrapperEl = swiper.wrapperEl;
        var el = scrollbar.el, dragEl = scrollbar.dragEl;
        if (!isTouched) return;
        if (e.preventDefault && e.cancelable) e.preventDefault();
        else e.returnValue = false;
        setDragPosition(e);
        wrapperEl.style.transitionDuration = '0ms';
        el.style.transitionDuration = '0ms';
        dragEl.style.transitionDuration = '0ms';
        emit('scrollbarDragMove', e);
    }
    function onDragEnd(e) {
        var params = swiper.params.scrollbar;
        var scrollbar = swiper.scrollbar, wrapperEl = swiper.wrapperEl;
        var el = scrollbar.el;
        if (!isTouched) return;
        isTouched = false;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style['scroll-snap-type'] = '';
            wrapperEl.style.transitionDuration = '';
        }
        if (params.hide) {
            clearTimeout(dragTimeout);
            dragTimeout = (0, _utilsMjs.n)(function() {
                el.style.opacity = 0;
                el.style.transitionDuration = '400ms';
            }, 1000);
        }
        emit('scrollbarDragEnd', e);
        if (params.snapOnRelease) swiper.slideToClosest();
    }
    function events(method) {
        var scrollbar = swiper.scrollbar, params = swiper.params;
        var el = scrollbar.el;
        if (!el) return;
        var target = el;
        var activeListener = params.passiveListeners ? {
            passive: false,
            capture: false
        } : false;
        var passiveListener = params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        if (!target) return;
        var eventMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
        target[eventMethod]('pointerdown', onDragStart, activeListener);
        document[eventMethod]('pointermove', onDragMove, activeListener);
        document[eventMethod]('pointerup', onDragEnd, passiveListener);
    }
    function enableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events('on');
    }
    function disableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events('off');
    }
    function init() {
        var _el_classList;
        var scrollbar = swiper.scrollbar, swiperEl = swiper.el;
        swiper.params.scrollbar = (0, _createElementIfNotDefinedMjs.c)(swiper, swiper.originalParams.scrollbar, swiper.params.scrollbar, {
            el: 'swiper-scrollbar'
        });
        var params = swiper.params.scrollbar;
        if (!params.el) return;
        var el;
        if (typeof params.el === 'string' && swiper.isElement) el = swiper.el.querySelector(params.el);
        if (!el && typeof params.el === 'string') {
            el = document.querySelectorAll(params.el);
            if (!el.length) return;
        } else if (!el) el = params.el;
        if (swiper.params.uniqueNavElements && typeof params.el === 'string' && el.length > 1 && swiperEl.querySelectorAll(params.el).length === 1) el = swiperEl.querySelector(params.el);
        if (el.length > 0) el = el[0];
        el.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        var dragEl;
        if (el) {
            dragEl = el.querySelector((0, _classesToSelectorMjs.c)(swiper.params.scrollbar.dragClass));
            if (!dragEl) {
                dragEl = (0, _utilsMjs.c)('div', swiper.params.scrollbar.dragClass);
                el.append(dragEl);
            }
        }
        Object.assign(scrollbar, {
            el: el,
            dragEl: dragEl
        });
        if (params.draggable) enableDraggable();
        if (el) (_el_classList = el.classList)[swiper.enabled ? 'remove' : 'add'].apply(_el_classList, (0, _toConsumableArray._)((0, _utilsMjs.i)(swiper.params.scrollbar.lockClass)));
    }
    function destroy() {
        var _el_classList;
        var params = swiper.params.scrollbar;
        var el = swiper.scrollbar.el;
        if (el) (_el_classList = el.classList).remove.apply(_el_classList, (0, _toConsumableArray._)((0, _utilsMjs.i)(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass)));
        disableDraggable();
    }
    on('changeDirection', function() {
        if (!swiper.scrollbar || !swiper.scrollbar.el) return;
        var params = swiper.params.scrollbar;
        var el = swiper.scrollbar.el;
        el = (0, _utilsMjs.m)(el);
        el.forEach(function(subEl) {
            subEl.classList.remove(params.horizontalClass, params.verticalClass);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        });
    });
    on('init', function() {
        if (swiper.params.scrollbar.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            updateSize();
            setTranslate();
        }
    });
    on('update resize observerUpdate lock unlock changeDirection', function() {
        updateSize();
    });
    on('setTranslate', function() {
        setTranslate();
    });
    on('setTransition', function(_s, duration) {
        setTransition(duration);
    });
    on('enable disable', function() {
        var _el_classList;
        var el = swiper.scrollbar.el;
        if (el) (_el_classList = el.classList)[swiper.enabled ? 'remove' : 'add'].apply(_el_classList, (0, _toConsumableArray._)((0, _utilsMjs.i)(swiper.params.scrollbar.lockClass)));
    });
    on('destroy', function() {
        destroy();
    });
    var enable = function() {
        var _swiper_el_classList, _swiper_scrollbar_el_classList;
        (_swiper_el_classList = swiper.el.classList).remove.apply(_swiper_el_classList, (0, _toConsumableArray._)((0, _utilsMjs.i)(swiper.params.scrollbar.scrollbarDisabledClass)));
        if (swiper.scrollbar.el) (_swiper_scrollbar_el_classList = swiper.scrollbar.el.classList).remove.apply(_swiper_scrollbar_el_classList, (0, _toConsumableArray._)((0, _utilsMjs.i)(swiper.params.scrollbar.scrollbarDisabledClass)));
        init();
        updateSize();
        setTranslate();
    };
    var disable = function() {
        var _swiper_el_classList, _swiper_scrollbar_el_classList;
        (_swiper_el_classList = swiper.el.classList).add.apply(_swiper_el_classList, (0, _toConsumableArray._)((0, _utilsMjs.i)(swiper.params.scrollbar.scrollbarDisabledClass)));
        if (swiper.scrollbar.el) (_swiper_scrollbar_el_classList = swiper.scrollbar.el.classList).add.apply(_swiper_scrollbar_el_classList, (0, _toConsumableArray._)((0, _utilsMjs.i)(swiper.params.scrollbar.scrollbarDisabledClass)));
        destroy();
    };
    Object.assign(swiper.scrollbar, {
        enable: enable,
        disable: disable,
        updateSize: updateSize,
        setTranslate: setTranslate,
        init: init,
        destroy: destroy
    });
}

},{"@swc/helpers/_/_to_consumable_array":"eqNDD","../shared/ssr-window.esm.mjs":"6ooWP","../shared/utils.mjs":"7Cawp","../shared/create-element-if-not-defined.mjs":"7M0LJ","../shared/classes-to-selector.mjs":"aZg9M","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3LSbE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return Parallax;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _utilsMjs = require("../shared/utils.mjs");
function Parallax(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, on = _ref.on;
    extendParams({
        parallax: {
            enabled: false
        }
    });
    var elementsSelector = '[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]';
    var setTransform = function(el, progress) {
        var rtl = swiper.rtl;
        var rtlFactor = rtl ? -1 : 1;
        var p = el.getAttribute('data-swiper-parallax') || '0';
        var x = el.getAttribute('data-swiper-parallax-x');
        var y = el.getAttribute('data-swiper-parallax-y');
        var scale = el.getAttribute('data-swiper-parallax-scale');
        var opacity = el.getAttribute('data-swiper-parallax-opacity');
        var rotate = el.getAttribute('data-swiper-parallax-rotate');
        if (x || y) {
            x = x || '0';
            y = y || '0';
        } else if (swiper.isHorizontal()) {
            x = p;
            y = '0';
        } else {
            y = p;
            x = '0';
        }
        if (x.indexOf('%') >= 0) x = `${parseInt(x, 10) * progress * rtlFactor}%`;
        else x = `${x * progress * rtlFactor}px`;
        if (y.indexOf('%') >= 0) y = `${parseInt(y, 10) * progress}%`;
        else y = `${y * progress}px`;
        if (typeof opacity !== 'undefined' && opacity !== null) {
            var currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
            el.style.opacity = currentOpacity;
        }
        var transform = `translate3d(${x}, ${y}, 0px)`;
        if (typeof scale !== 'undefined' && scale !== null) {
            var currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
            transform += ` scale(${currentScale})`;
        }
        if (rotate && typeof rotate !== 'undefined' && rotate !== null) {
            var currentRotate = rotate * progress * -1;
            transform += ` rotate(${currentRotate}deg)`;
        }
        el.style.transform = transform;
    };
    var setTranslate = function() {
        var _elements;
        var el = swiper.el, slides = swiper.slides, progress = swiper.progress, snapGrid = swiper.snapGrid, isElement = swiper.isElement;
        var elements = (0, _utilsMjs.e)(el, elementsSelector);
        if (swiper.isElement) (_elements = elements).push.apply(_elements, (0, _toConsumableArray._)((0, _utilsMjs.e)(swiper.hostEl, elementsSelector)));
        elements.forEach(function(subEl) {
            setTransform(subEl, progress);
        });
        slides.forEach(function(slideEl, slideIndex) {
            var slideProgress = slideEl.progress;
            if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
            slideProgress = Math.min(Math.max(slideProgress, -1), 1);
            slideEl.querySelectorAll(`${elementsSelector}, [data-swiper-parallax-rotate]`).forEach(function(subEl) {
                setTransform(subEl, slideProgress);
            });
        });
    };
    var setTransition = function setTransition(duration) {
        var _elements;
        if (duration === void 0) duration = swiper.params.speed;
        var el = swiper.el, hostEl = swiper.hostEl;
        var elements = (0, _toConsumableArray._)(el.querySelectorAll(elementsSelector));
        if (swiper.isElement) (_elements = elements).push.apply(_elements, (0, _toConsumableArray._)(hostEl.querySelectorAll(elementsSelector)));
        elements.forEach(function(parallaxEl) {
            var parallaxDuration = parseInt(parallaxEl.getAttribute('data-swiper-parallax-duration'), 10) || duration;
            if (duration === 0) parallaxDuration = 0;
            parallaxEl.style.transitionDuration = `${parallaxDuration}ms`;
        });
    };
    on('beforeInit', function() {
        if (!swiper.params.parallax.enabled) return;
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
    });
    on('init', function() {
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on('setTranslate', function() {
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on('setTransition', function(_swiper, duration) {
        if (!swiper.params.parallax.enabled) return;
        setTransition(duration);
    });
}

},{"@swc/helpers/_/_to_consumable_array":"eqNDD","../shared/utils.mjs":"7Cawp","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"i4oHc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return Zoom;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _ssrWindowEsmMjs = require("../shared/ssr-window.esm.mjs");
var _utilsMjs = require("../shared/utils.mjs");
function Zoom(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, on = _ref.on, emit = _ref.emit;
    var window = (0, _ssrWindowEsmMjs.a)();
    extendParams({
        zoom: {
            enabled: false,
            limitToOriginalSize: false,
            maxRatio: 3,
            minRatio: 1,
            panOnMouseMove: false,
            toggle: true,
            containerClass: 'swiper-zoom-container',
            zoomedSlideClass: 'swiper-slide-zoomed'
        }
    });
    swiper.zoom = {
        enabled: false
    };
    var currentScale = 1;
    var isScaling = false;
    var isPanningWithMouse = false;
    var mousePanStart = {
        x: 0,
        y: 0
    };
    var mousePanSensitivity = -3; // Negative to invert pan direction
    var fakeGestureTouched;
    var fakeGestureMoved;
    var evCache = [];
    var gesture = {
        originX: 0,
        originY: 0,
        slideEl: undefined,
        slideWidth: undefined,
        slideHeight: undefined,
        imageEl: undefined,
        imageWrapEl: undefined,
        maxRatio: 3
    };
    var image = {
        isTouched: undefined,
        isMoved: undefined,
        currentX: undefined,
        currentY: undefined,
        minX: undefined,
        minY: undefined,
        maxX: undefined,
        maxY: undefined,
        width: undefined,
        height: undefined,
        startX: undefined,
        startY: undefined,
        touchesStart: {},
        touchesCurrent: {}
    };
    var velocity = {
        x: undefined,
        y: undefined,
        prevPositionX: undefined,
        prevPositionY: undefined,
        prevTime: undefined
    };
    var scale = 1;
    Object.defineProperty(swiper.zoom, 'scale', {
        get: function() {
            return scale;
        },
        set: function(value) {
            if (scale !== value) {
                var imageEl = gesture.imageEl;
                var slideEl = gesture.slideEl;
                emit('zoomChange', value, imageEl, slideEl);
            }
            scale = value;
        }
    });
    function getDistanceBetweenTouches() {
        if (evCache.length < 2) return 1;
        var x1 = evCache[0].pageX;
        var y1 = evCache[0].pageY;
        var x2 = evCache[1].pageX;
        var y2 = evCache[1].pageY;
        var distance = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
        return distance;
    }
    function getMaxRatio() {
        var params = swiper.params.zoom;
        var maxRatio = gesture.imageWrapEl.getAttribute('data-swiper-zoom') || params.maxRatio;
        if (params.limitToOriginalSize && gesture.imageEl && gesture.imageEl.naturalWidth) {
            var imageMaxRatio = gesture.imageEl.naturalWidth / gesture.imageEl.offsetWidth;
            return Math.min(imageMaxRatio, maxRatio);
        }
        return maxRatio;
    }
    function getScaleOrigin() {
        if (evCache.length < 2) return {
            x: null,
            y: null
        };
        var box = gesture.imageEl.getBoundingClientRect();
        return [
            (evCache[0].pageX + (evCache[1].pageX - evCache[0].pageX) / 2 - box.x - window.scrollX) / currentScale,
            (evCache[0].pageY + (evCache[1].pageY - evCache[0].pageY) / 2 - box.y - window.scrollY) / currentScale
        ];
    }
    function getSlideSelector() {
        return swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
    }
    function eventWithinSlide(e) {
        var slideSelector = getSlideSelector();
        if (e.target.matches(slideSelector)) return true;
        if (swiper.slides.filter(function(slideEl) {
            return slideEl.contains(e.target);
        }).length > 0) return true;
        return false;
    }
    function eventWithinZoomContainer(e) {
        var selector = `.${swiper.params.zoom.containerClass}`;
        if (e.target.matches(selector)) return true;
        if ((0, _toConsumableArray._)(swiper.hostEl.querySelectorAll(selector)).filter(function(containerEl) {
            return containerEl.contains(e.target);
        }).length > 0) return true;
        return false;
    }
    // Events
    function onGestureStart(e) {
        if (e.pointerType === 'mouse') evCache.splice(0, evCache.length);
        if (!eventWithinSlide(e)) return;
        var params = swiper.params.zoom;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        evCache.push(e);
        if (evCache.length < 2) return;
        fakeGestureTouched = true;
        gesture.scaleStart = getDistanceBetweenTouches();
        if (!gesture.slideEl) {
            gesture.slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
            if (!gesture.slideEl) gesture.slideEl = swiper.slides[swiper.activeIndex];
            var imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
            if (imageEl) imageEl = imageEl.querySelectorAll('picture, img, svg, canvas, .swiper-zoom-target')[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, _utilsMjs.a)(gesture.imageEl, `.${params.containerClass}`)[0];
            else gesture.imageWrapEl = undefined;
            if (!gesture.imageWrapEl) {
                gesture.imageEl = undefined;
                return;
            }
            gesture.maxRatio = getMaxRatio();
        }
        if (gesture.imageEl) {
            var _getScaleOrigin = (0, _slicedToArray._)(getScaleOrigin(), 2), originX = _getScaleOrigin[0], originY = _getScaleOrigin[1];
            gesture.originX = originX;
            gesture.originY = originY;
            gesture.imageEl.style.transitionDuration = '0ms';
        }
        isScaling = true;
    }
    function onGestureChange(e) {
        if (!eventWithinSlide(e)) return;
        var params = swiper.params.zoom;
        var zoom = swiper.zoom;
        var pointerIndex = evCache.findIndex(function(cachedEv) {
            return cachedEv.pointerId === e.pointerId;
        });
        if (pointerIndex >= 0) evCache[pointerIndex] = e;
        if (evCache.length < 2) return;
        fakeGestureMoved = true;
        gesture.scaleMove = getDistanceBetweenTouches();
        if (!gesture.imageEl) return;
        zoom.scale = gesture.scaleMove / gesture.scaleStart * currentScale;
        if (zoom.scale > gesture.maxRatio) zoom.scale = gesture.maxRatio - 1 + Math.pow(zoom.scale - gesture.maxRatio + 1, 0.5);
        if (zoom.scale < params.minRatio) zoom.scale = params.minRatio + 1 - Math.pow(params.minRatio - zoom.scale + 1, 0.5);
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
    }
    function onGestureEnd(e) {
        if (!eventWithinSlide(e)) return;
        if (e.pointerType === 'mouse' && e.type === 'pointerout') return;
        var params = swiper.params.zoom;
        var zoom = swiper.zoom;
        var pointerIndex = evCache.findIndex(function(cachedEv) {
            return cachedEv.pointerId === e.pointerId;
        });
        if (pointerIndex >= 0) evCache.splice(pointerIndex, 1);
        if (!fakeGestureTouched || !fakeGestureMoved) return;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        if (!gesture.imageEl) return;
        zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
        gesture.imageEl.style.transitionDuration = `${swiper.params.speed}ms`;
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
        currentScale = zoom.scale;
        isScaling = false;
        if (zoom.scale > 1 && gesture.slideEl) gesture.slideEl.classList.add(`${params.zoomedSlideClass}`);
        else if (zoom.scale <= 1 && gesture.slideEl) gesture.slideEl.classList.remove(`${params.zoomedSlideClass}`);
        if (zoom.scale === 1) {
            gesture.originX = 0;
            gesture.originY = 0;
            gesture.slideEl = undefined;
        }
    }
    var allowTouchMoveTimeout;
    function allowTouchMove() {
        swiper.touchEventsData.preventTouchMoveFromPointerMove = false;
    }
    function preventTouchMove() {
        clearTimeout(allowTouchMoveTimeout);
        swiper.touchEventsData.preventTouchMoveFromPointerMove = true;
        allowTouchMoveTimeout = setTimeout(function() {
            if (swiper.destroyed) return;
            allowTouchMove();
        });
    }
    function onTouchStart(e) {
        var device = swiper.device;
        if (!gesture.imageEl) return;
        if (image.isTouched) return;
        if (device.android && e.cancelable) e.preventDefault();
        image.isTouched = true;
        var event = evCache.length > 0 ? evCache[0] : e;
        image.touchesStart.x = event.pageX;
        image.touchesStart.y = event.pageY;
    }
    function onTouchMove(e) {
        var isMouseEvent = e.pointerType === 'mouse';
        var isMousePan = isMouseEvent && swiper.params.zoom.panOnMouseMove;
        if (!eventWithinSlide(e) || !eventWithinZoomContainer(e)) return;
        var zoom = swiper.zoom;
        if (!gesture.imageEl) return;
        if (!image.isTouched || !gesture.slideEl) {
            if (isMousePan) onMouseMove(e);
            return;
        }
        if (isMousePan) {
            onMouseMove(e);
            return;
        }
        if (!image.isMoved) {
            image.width = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            image.height = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            image.startX = (0, _utilsMjs.j)(gesture.imageWrapEl, 'x') || 0;
            image.startY = (0, _utilsMjs.j)(gesture.imageWrapEl, 'y') || 0;
            gesture.slideWidth = gesture.slideEl.offsetWidth;
            gesture.slideHeight = gesture.slideEl.offsetHeight;
            gesture.imageWrapEl.style.transitionDuration = '0ms';
        }
        // Define if we need image drag
        var scaledWidth = image.width * zoom.scale;
        var scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.touchesCurrent.x = evCache.length > 0 ? evCache[0].pageX : e.pageX;
        image.touchesCurrent.y = evCache.length > 0 ? evCache[0].pageY : e.pageY;
        var touchesDiff = Math.max(Math.abs(image.touchesCurrent.x - image.touchesStart.x), Math.abs(image.touchesCurrent.y - image.touchesStart.y));
        if (touchesDiff > 5) swiper.allowClick = false;
        if (!image.isMoved && !isScaling) {
            if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
                image.isTouched = false;
                allowTouchMove();
                return;
            }
            if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
                image.isTouched = false;
                allowTouchMove();
                return;
            }
        }
        if (e.cancelable) e.preventDefault();
        e.stopPropagation();
        preventTouchMove();
        image.isMoved = true;
        var scaleRatio = (zoom.scale - currentScale) / (gesture.maxRatio - swiper.params.zoom.minRatio);
        var originX = gesture.originX, originY = gesture.originY;
        image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX + scaleRatio * (image.width - originX * 2);
        image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY + scaleRatio * (image.height - originY * 2);
        if (image.currentX < image.minX) image.currentX = image.minX + 1 - Math.pow(image.minX - image.currentX + 1, 0.8);
        if (image.currentX > image.maxX) image.currentX = image.maxX - 1 + Math.pow(image.currentX - image.maxX + 1, 0.8);
        if (image.currentY < image.minY) image.currentY = image.minY + 1 - Math.pow(image.minY - image.currentY + 1, 0.8);
        if (image.currentY > image.maxY) image.currentY = image.maxY - 1 + Math.pow(image.currentY - image.maxY + 1, 0.8);
        // Velocity
        if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
        if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
        if (!velocity.prevTime) velocity.prevTime = Date.now();
        velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
        velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
        if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
        if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
        velocity.prevPositionX = image.touchesCurrent.x;
        velocity.prevPositionY = image.touchesCurrent.y;
        velocity.prevTime = Date.now();
        gesture.imageWrapEl.style.transform = `translate3d(${image.currentX}px, ${image.currentY}px,0)`;
    }
    function onTouchEnd() {
        var zoom = swiper.zoom;
        evCache.length = 0;
        if (!gesture.imageEl) return;
        if (!image.isTouched || !image.isMoved) {
            image.isTouched = false;
            image.isMoved = false;
            return;
        }
        image.isTouched = false;
        image.isMoved = false;
        var momentumDurationX = 300;
        var momentumDurationY = 300;
        var momentumDistanceX = velocity.x * momentumDurationX;
        var newPositionX = image.currentX + momentumDistanceX;
        var momentumDistanceY = velocity.y * momentumDurationY;
        var newPositionY = image.currentY + momentumDistanceY;
        // Fix duration
        if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
        if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
        var momentumDuration = Math.max(momentumDurationX, momentumDurationY);
        image.currentX = newPositionX;
        image.currentY = newPositionY;
        // Define if we need image drag
        var scaledWidth = image.width * zoom.scale;
        var scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
        image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
        gesture.imageWrapEl.style.transitionDuration = `${momentumDuration}ms`;
        gesture.imageWrapEl.style.transform = `translate3d(${image.currentX}px, ${image.currentY}px,0)`;
    }
    function onTransitionEnd() {
        var zoom = swiper.zoom;
        if (gesture.slideEl && swiper.activeIndex !== swiper.slides.indexOf(gesture.slideEl)) {
            if (gesture.imageEl) gesture.imageEl.style.transform = 'translate3d(0,0,0) scale(1)';
            if (gesture.imageWrapEl) gesture.imageWrapEl.style.transform = 'translate3d(0,0,0)';
            gesture.slideEl.classList.remove(`${swiper.params.zoom.zoomedSlideClass}`);
            zoom.scale = 1;
            currentScale = 1;
            gesture.slideEl = undefined;
            gesture.imageEl = undefined;
            gesture.imageWrapEl = undefined;
            gesture.originX = 0;
            gesture.originY = 0;
        }
    }
    function onMouseMove(e) {
        // Only pan if zoomed in and mouse panning is enabled
        if (currentScale <= 1 || !gesture.imageWrapEl) return;
        if (!eventWithinSlide(e) || !eventWithinZoomContainer(e)) return;
        var currentTransform = window.getComputedStyle(gesture.imageWrapEl).transform;
        var matrix = new window.DOMMatrix(currentTransform);
        if (!isPanningWithMouse) {
            isPanningWithMouse = true;
            mousePanStart.x = e.clientX;
            mousePanStart.y = e.clientY;
            image.startX = matrix.e;
            image.startY = matrix.f;
            image.width = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            image.height = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            gesture.slideWidth = gesture.slideEl.offsetWidth;
            gesture.slideHeight = gesture.slideEl.offsetHeight;
            return;
        }
        var deltaX = (e.clientX - mousePanStart.x) * mousePanSensitivity;
        var deltaY = (e.clientY - mousePanStart.y) * mousePanSensitivity;
        var scaledWidth = image.width * currentScale;
        var scaledHeight = image.height * currentScale;
        var slideWidth = gesture.slideWidth;
        var slideHeight = gesture.slideHeight;
        var minX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
        var maxX = -minX;
        var minY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
        var maxY = -minY;
        var newX = Math.max(Math.min(image.startX + deltaX, maxX), minX);
        var newY = Math.max(Math.min(image.startY + deltaY, maxY), minY);
        gesture.imageWrapEl.style.transitionDuration = '0ms';
        gesture.imageWrapEl.style.transform = `translate3d(${newX}px, ${newY}px, 0)`;
        mousePanStart.x = e.clientX;
        mousePanStart.y = e.clientY;
        image.startX = newX;
        image.startY = newY;
        image.currentX = newX;
        image.currentY = newY;
    }
    function zoomIn(e) {
        var zoom = swiper.zoom;
        var params = swiper.params.zoom;
        if (!gesture.slideEl) {
            if (e && e.target) gesture.slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
            if (!gesture.slideEl) {
                if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.slideEl = (0, _utilsMjs.e)(swiper.slidesEl, `.${swiper.params.slideActiveClass}`)[0];
                else gesture.slideEl = swiper.slides[swiper.activeIndex];
            }
            var imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
            if (imageEl) imageEl = imageEl.querySelectorAll('picture, img, svg, canvas, .swiper-zoom-target')[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, _utilsMjs.a)(gesture.imageEl, `.${params.containerClass}`)[0];
            else gesture.imageWrapEl = undefined;
        }
        if (!gesture.imageEl || !gesture.imageWrapEl) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = 'hidden';
            swiper.wrapperEl.style.touchAction = 'none';
        }
        gesture.slideEl.classList.add(`${params.zoomedSlideClass}`);
        var touchX;
        var touchY;
        var offsetX;
        var offsetY;
        var diffX;
        var diffY;
        var translateX;
        var translateY;
        var imageWidth;
        var imageHeight;
        var scaledWidth;
        var scaledHeight;
        var translateMinX;
        var translateMinY;
        var translateMaxX;
        var translateMaxY;
        var slideWidth;
        var slideHeight;
        if (typeof image.touchesStart.x === 'undefined' && e) {
            touchX = e.pageX;
            touchY = e.pageY;
        } else {
            touchX = image.touchesStart.x;
            touchY = image.touchesStart.y;
        }
        var prevScale = currentScale;
        var forceZoomRatio = typeof e === 'number' ? e : null;
        if (currentScale === 1 && forceZoomRatio) {
            touchX = undefined;
            touchY = undefined;
            image.touchesStart.x = undefined;
            image.touchesStart.y = undefined;
        }
        var maxRatio = getMaxRatio();
        zoom.scale = forceZoomRatio || maxRatio;
        currentScale = forceZoomRatio || maxRatio;
        if (e && !(currentScale === 1 && forceZoomRatio)) {
            slideWidth = gesture.slideEl.offsetWidth;
            slideHeight = gesture.slideEl.offsetHeight;
            offsetX = (0, _utilsMjs.b)(gesture.slideEl).left + window.scrollX;
            offsetY = (0, _utilsMjs.b)(gesture.slideEl).top + window.scrollY;
            diffX = offsetX + slideWidth / 2 - touchX;
            diffY = offsetY + slideHeight / 2 - touchY;
            imageWidth = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            imageHeight = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            scaledWidth = imageWidth * zoom.scale;
            scaledHeight = imageHeight * zoom.scale;
            translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
            translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
            translateMaxX = -translateMinX;
            translateMaxY = -translateMinY;
            if (prevScale > 0 && forceZoomRatio && typeof image.currentX === 'number' && typeof image.currentY === 'number') {
                translateX = image.currentX * zoom.scale / prevScale;
                translateY = image.currentY * zoom.scale / prevScale;
            } else {
                translateX = diffX * zoom.scale;
                translateY = diffY * zoom.scale;
            }
            if (translateX < translateMinX) translateX = translateMinX;
            if (translateX > translateMaxX) translateX = translateMaxX;
            if (translateY < translateMinY) translateY = translateMinY;
            if (translateY > translateMaxY) translateY = translateMaxY;
        } else {
            translateX = 0;
            translateY = 0;
        }
        if (forceZoomRatio && zoom.scale === 1) {
            gesture.originX = 0;
            gesture.originY = 0;
        }
        image.currentX = translateX;
        image.currentY = translateY;
        gesture.imageWrapEl.style.transitionDuration = '300ms';
        gesture.imageWrapEl.style.transform = `translate3d(${translateX}px, ${translateY}px,0)`;
        gesture.imageEl.style.transitionDuration = '300ms';
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
    }
    function zoomOut() {
        var zoom = swiper.zoom;
        var params = swiper.params.zoom;
        if (!gesture.slideEl) {
            if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.slideEl = (0, _utilsMjs.e)(swiper.slidesEl, `.${swiper.params.slideActiveClass}`)[0];
            else gesture.slideEl = swiper.slides[swiper.activeIndex];
            var imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
            if (imageEl) imageEl = imageEl.querySelectorAll('picture, img, svg, canvas, .swiper-zoom-target')[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, _utilsMjs.a)(gesture.imageEl, `.${params.containerClass}`)[0];
            else gesture.imageWrapEl = undefined;
        }
        if (!gesture.imageEl || !gesture.imageWrapEl) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = '';
            swiper.wrapperEl.style.touchAction = '';
        }
        zoom.scale = 1;
        currentScale = 1;
        image.currentX = undefined;
        image.currentY = undefined;
        image.touchesStart.x = undefined;
        image.touchesStart.y = undefined;
        gesture.imageWrapEl.style.transitionDuration = '300ms';
        gesture.imageWrapEl.style.transform = 'translate3d(0,0,0)';
        gesture.imageEl.style.transitionDuration = '300ms';
        gesture.imageEl.style.transform = 'translate3d(0,0,0) scale(1)';
        gesture.slideEl.classList.remove(`${params.zoomedSlideClass}`);
        gesture.slideEl = undefined;
        gesture.originX = 0;
        gesture.originY = 0;
        if (swiper.params.zoom.panOnMouseMove) {
            mousePanStart = {
                x: 0,
                y: 0
            };
            if (isPanningWithMouse) {
                isPanningWithMouse = false;
                image.startX = 0;
                image.startY = 0;
            }
        }
    }
    // Toggle Zoom
    function zoomToggle(e) {
        var zoom = swiper.zoom;
        if (zoom.scale && zoom.scale !== 1) // Zoom Out
        zoomOut();
        else // Zoom In
        zoomIn(e);
    }
    function getListeners() {
        var passiveListener = swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        var activeListenerWithCapture = swiper.params.passiveListeners ? {
            passive: false,
            capture: true
        } : true;
        return {
            passiveListener: passiveListener,
            activeListenerWithCapture: activeListenerWithCapture
        };
    }
    // Attach/Detach Events
    function enable() {
        var zoom = swiper.zoom;
        if (zoom.enabled) return;
        zoom.enabled = true;
        var _getListeners = getListeners(), passiveListener = _getListeners.passiveListener, activeListenerWithCapture = _getListeners.activeListenerWithCapture;
        // Scale image
        swiper.wrapperEl.addEventListener('pointerdown', onGestureStart, passiveListener);
        swiper.wrapperEl.addEventListener('pointermove', onGestureChange, activeListenerWithCapture);
        [
            'pointerup',
            'pointercancel',
            'pointerout'
        ].forEach(function(eventName) {
            swiper.wrapperEl.addEventListener(eventName, onGestureEnd, passiveListener);
        });
        // Move image
        swiper.wrapperEl.addEventListener('pointermove', onTouchMove, activeListenerWithCapture);
    }
    function disable() {
        var zoom = swiper.zoom;
        if (!zoom.enabled) return;
        zoom.enabled = false;
        var _getListeners = getListeners(), passiveListener = _getListeners.passiveListener, activeListenerWithCapture = _getListeners.activeListenerWithCapture;
        // Scale image
        swiper.wrapperEl.removeEventListener('pointerdown', onGestureStart, passiveListener);
        swiper.wrapperEl.removeEventListener('pointermove', onGestureChange, activeListenerWithCapture);
        [
            'pointerup',
            'pointercancel',
            'pointerout'
        ].forEach(function(eventName) {
            swiper.wrapperEl.removeEventListener(eventName, onGestureEnd, passiveListener);
        });
        // Move image
        swiper.wrapperEl.removeEventListener('pointermove', onTouchMove, activeListenerWithCapture);
    }
    on('init', function() {
        if (swiper.params.zoom.enabled) enable();
    });
    on('destroy', function() {
        disable();
    });
    on('touchStart', function(_s, e) {
        if (!swiper.zoom.enabled) return;
        onTouchStart(e);
    });
    on('touchEnd', function(_s, e) {
        if (!swiper.zoom.enabled) return;
        onTouchEnd();
    });
    on('doubleTap', function(_s, e) {
        if (!swiper.animating && swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) zoomToggle(e);
    });
    on('transitionEnd', function() {
        if (swiper.zoom.enabled && swiper.params.zoom.enabled) onTransitionEnd();
    });
    on('slideChange', function() {
        if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) onTransitionEnd();
    });
    Object.assign(swiper.zoom, {
        enable: enable,
        disable: disable,
        in: zoomIn,
        out: zoomOut,
        toggle: zoomToggle
    });
}

},{"@swc/helpers/_/_sliced_to_array":"ha6sq","@swc/helpers/_/_to_consumable_array":"eqNDD","../shared/ssr-window.esm.mjs":"6ooWP","../shared/utils.mjs":"7Cawp","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"ezD0Z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return Controller;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _utilsMjs = require("../shared/utils.mjs");
/* eslint no-bitwise: ["error", { "allow": [">>"] }] */ function Controller(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, on = _ref.on;
    extendParams({
        controller: {
            control: undefined,
            inverse: false,
            by: 'slide' // or 'container'
        }
    });
    swiper.controller = {
        control: undefined
    };
    function LinearSpline(x, y) {
        var binarySearch = function search() {
            var maxIndex;
            var minIndex;
            var guess;
            return function(array, val) {
                minIndex = -1;
                maxIndex = array.length;
                while(maxIndex - minIndex > 1){
                    guess = maxIndex + minIndex >> 1;
                    if (array[guess] <= val) minIndex = guess;
                    else maxIndex = guess;
                }
                return maxIndex;
            };
        }();
        this.x = x;
        this.y = y;
        this.lastIndex = x.length - 1;
        // Given an x value (x2), return the expected y2 value:
        // (x1,y1) is the known point before given value,
        // (x3,y3) is the known point after given value.
        var i1;
        var i3;
        this.interpolate = function interpolate(x2) {
            if (!x2) return 0;
            // Get the indexes of x1 and x3 (the array indexes before and after given x2):
            i3 = binarySearch(this.x, x2);
            i1 = i3 - 1;
            // We have our indexes i1 & i3, so we can calculate already:
            // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
            return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
        };
        return this;
    }
    function getInterpolateFunction(c) {
        swiper.controller.spline = swiper.params.loop ? new LinearSpline(swiper.slidesGrid, c.slidesGrid) : new LinearSpline(swiper.snapGrid, c.snapGrid);
    }
    function setTranslate(_t, byController) {
        var controlled = swiper.controller.control;
        var multiplier;
        var controlledTranslate;
        var Swiper = swiper.constructor;
        function setControlledTranslate(c) {
            if (c.destroyed) return;
            // this will create an Interpolate function based on the snapGrids
            // x is the Grid of the scrolled scroller and y will be the controlled scroller
            // it makes sense to create this only once and recall it for the interpolation
            // the function does a lot of value caching for performance
            var translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
            if (swiper.params.controller.by === 'slide') {
                getInterpolateFunction(c);
                // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
                // but it did not work out
                controlledTranslate = -swiper.controller.spline.interpolate(-translate);
            }
            if (!controlledTranslate || swiper.params.controller.by === 'container') {
                multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
                if (Number.isNaN(multiplier) || !Number.isFinite(multiplier)) multiplier = 1;
                controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
            }
            if (swiper.params.controller.inverse) controlledTranslate = c.maxTranslate() - controlledTranslate;
            c.updateProgress(controlledTranslate);
            c.setTranslate(controlledTranslate, swiper);
            c.updateActiveIndex();
            c.updateSlidesClasses();
        }
        if (Array.isArray(controlled)) {
            for(var i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTranslate(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTranslate(controlled);
    }
    function setTransition(duration, byController) {
        var Swiper = swiper.constructor;
        var controlled = swiper.controller.control;
        var i;
        function setControlledTransition(c) {
            if (c.destroyed) return;
            c.setTransition(duration, swiper);
            if (duration !== 0) {
                c.transitionStart();
                if (c.params.autoHeight) (0, _utilsMjs.n)(function() {
                    c.updateAutoHeight();
                });
                (0, _utilsMjs.k)(c.wrapperEl, function() {
                    if (!controlled) return;
                    c.transitionEnd();
                });
            }
        }
        if (Array.isArray(controlled)) {
            for(i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTransition(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTransition(controlled);
    }
    function removeSpline() {
        if (!swiper.controller.control) return;
        if (swiper.controller.spline) {
            swiper.controller.spline = undefined;
            delete swiper.controller.spline;
        }
    }
    on('beforeInit', function() {
        if (typeof window !== 'undefined' && // eslint-disable-line
        (typeof swiper.params.controller.control === 'string' || swiper.params.controller.control instanceof HTMLElement)) {
            var controlElements = typeof swiper.params.controller.control === 'string' ? (0, _toConsumableArray._)(document.querySelectorAll(swiper.params.controller.control)) : [
                swiper.params.controller.control
            ];
            controlElements.forEach(function(controlElement) {
                if (!swiper.controller.control) swiper.controller.control = [];
                if (controlElement && controlElement.swiper) swiper.controller.control.push(controlElement.swiper);
                else if (controlElement) {
                    var eventName = `${swiper.params.eventsPrefix}init`;
                    var onControllerSwiper = function(e) {
                        swiper.controller.control.push(e.detail[0]);
                        swiper.update();
                        controlElement.removeEventListener(eventName, onControllerSwiper);
                    };
                    controlElement.addEventListener(eventName, onControllerSwiper);
                }
            });
            return;
        }
        swiper.controller.control = swiper.params.controller.control;
    });
    on('update', function() {
        removeSpline();
    });
    on('resize', function() {
        removeSpline();
    });
    on('observerUpdate', function() {
        removeSpline();
    });
    on('setTranslate', function(_s, translate, byController) {
        if (!swiper.controller.control || swiper.controller.control.destroyed) return;
        swiper.controller.setTranslate(translate, byController);
    });
    on('setTransition', function(_s, duration, byController) {
        if (!swiper.controller.control || swiper.controller.control.destroyed) return;
        swiper.controller.setTransition(duration, byController);
    });
    Object.assign(swiper.controller, {
        setTranslate: setTranslate,
        setTransition: setTransition
    });
}

},{"@swc/helpers/_/_to_consumable_array":"eqNDD","../shared/utils.mjs":"7Cawp","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"p8V2f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return A11y;
});
var _ssrWindowEsmMjs = require("../shared/ssr-window.esm.mjs");
var _classesToSelectorMjs = require("../shared/classes-to-selector.mjs");
var _utilsMjs = require("../shared/utils.mjs");
function A11y(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, on = _ref.on;
    extendParams({
        a11y: {
            enabled: true,
            notificationClass: 'swiper-notification',
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
            firstSlideMessage: 'This is the first slide',
            lastSlideMessage: 'This is the last slide',
            paginationBulletMessage: 'Go to slide {{index}}',
            slideLabelMessage: '{{index}} / {{slidesLength}}',
            containerMessage: null,
            containerRoleDescriptionMessage: null,
            containerRole: null,
            itemRoleDescriptionMessage: null,
            slideRole: 'group',
            id: null,
            scrollOnFocus: true
        }
    });
    swiper.a11y = {
        clicked: false
    };
    var liveRegion = null;
    var preventFocusHandler;
    var focusTargetSlideEl;
    var visibilityChangedTimestamp = new Date().getTime();
    function notify(message) {
        var notification = liveRegion;
        if (notification.length === 0) return;
        notification.innerHTML = '';
        notification.innerHTML = message;
    }
    function getRandomNumber(size) {
        if (size === void 0) size = 16;
        var randomChar = function() {
            return Math.round(16 * Math.random()).toString(16);
        };
        return 'x'.repeat(size).replace(/x/g, randomChar);
    }
    function makeElFocusable(el) {
        el = (0, _utilsMjs.m)(el);
        el.forEach(function(subEl) {
            subEl.setAttribute('tabIndex', '0');
        });
    }
    function makeElNotFocusable(el) {
        el = (0, _utilsMjs.m)(el);
        el.forEach(function(subEl) {
            subEl.setAttribute('tabIndex', '-1');
        });
    }
    function addElRole(el, role) {
        el = (0, _utilsMjs.m)(el);
        el.forEach(function(subEl) {
            subEl.setAttribute('role', role);
        });
    }
    function addElRoleDescription(el, description) {
        el = (0, _utilsMjs.m)(el);
        el.forEach(function(subEl) {
            subEl.setAttribute('aria-roledescription', description);
        });
    }
    function addElControls(el, controls) {
        el = (0, _utilsMjs.m)(el);
        el.forEach(function(subEl) {
            subEl.setAttribute('aria-controls', controls);
        });
    }
    function addElLabel(el, label) {
        el = (0, _utilsMjs.m)(el);
        el.forEach(function(subEl) {
            subEl.setAttribute('aria-label', label);
        });
    }
    function addElId(el, id) {
        el = (0, _utilsMjs.m)(el);
        el.forEach(function(subEl) {
            subEl.setAttribute('id', id);
        });
    }
    function addElLive(el, live) {
        el = (0, _utilsMjs.m)(el);
        el.forEach(function(subEl) {
            subEl.setAttribute('aria-live', live);
        });
    }
    function disableEl(el) {
        el = (0, _utilsMjs.m)(el);
        el.forEach(function(subEl) {
            subEl.setAttribute('aria-disabled', true);
        });
    }
    function enableEl(el) {
        el = (0, _utilsMjs.m)(el);
        el.forEach(function(subEl) {
            subEl.setAttribute('aria-disabled', false);
        });
    }
    function onEnterOrSpaceKey(e) {
        if (e.keyCode !== 13 && e.keyCode !== 32) return;
        var params = swiper.params.a11y;
        var targetEl = e.target;
        if (swiper.pagination && swiper.pagination.el && (targetEl === swiper.pagination.el || swiper.pagination.el.contains(e.target))) {
            if (!e.target.matches((0, _classesToSelectorMjs.c)(swiper.params.pagination.bulletClass))) return;
        }
        if (swiper.navigation && swiper.navigation.prevEl && swiper.navigation.nextEl) {
            var prevEls = (0, _utilsMjs.m)(swiper.navigation.prevEl);
            var nextEls = (0, _utilsMjs.m)(swiper.navigation.nextEl);
            if (nextEls.includes(targetEl)) {
                if (!(swiper.isEnd && !swiper.params.loop)) swiper.slideNext();
                if (swiper.isEnd) notify(params.lastSlideMessage);
                else notify(params.nextSlideMessage);
            }
            if (prevEls.includes(targetEl)) {
                if (!(swiper.isBeginning && !swiper.params.loop)) swiper.slidePrev();
                if (swiper.isBeginning) notify(params.firstSlideMessage);
                else notify(params.prevSlideMessage);
            }
        }
        if (swiper.pagination && targetEl.matches((0, _classesToSelectorMjs.c)(swiper.params.pagination.bulletClass))) targetEl.click();
    }
    function updateNavigation() {
        if (swiper.params.loop || swiper.params.rewind || !swiper.navigation) return;
        var _swiper_navigation = swiper.navigation, nextEl = _swiper_navigation.nextEl, prevEl = _swiper_navigation.prevEl;
        if (prevEl) {
            if (swiper.isBeginning) {
                disableEl(prevEl);
                makeElNotFocusable(prevEl);
            } else {
                enableEl(prevEl);
                makeElFocusable(prevEl);
            }
        }
        if (nextEl) {
            if (swiper.isEnd) {
                disableEl(nextEl);
                makeElNotFocusable(nextEl);
            } else {
                enableEl(nextEl);
                makeElFocusable(nextEl);
            }
        }
    }
    function hasPagination() {
        return swiper.pagination && swiper.pagination.bullets && swiper.pagination.bullets.length;
    }
    function hasClickablePagination() {
        return hasPagination() && swiper.params.pagination.clickable;
    }
    function updatePagination() {
        var params = swiper.params.a11y;
        if (!hasPagination()) return;
        swiper.pagination.bullets.forEach(function(bulletEl) {
            if (swiper.params.pagination.clickable) {
                makeElFocusable(bulletEl);
                if (!swiper.params.pagination.renderBullet) {
                    addElRole(bulletEl, 'button');
                    addElLabel(bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, (0, _utilsMjs.h)(bulletEl) + 1));
                }
            }
            if (bulletEl.matches((0, _classesToSelectorMjs.c)(swiper.params.pagination.bulletActiveClass))) bulletEl.setAttribute('aria-current', 'true');
            else bulletEl.removeAttribute('aria-current');
        });
    }
    var initNavEl = function(el, wrapperId, message) {
        makeElFocusable(el);
        if (el.tagName !== 'BUTTON') {
            addElRole(el, 'button');
            el.addEventListener('keydown', onEnterOrSpaceKey);
        }
        addElLabel(el, message);
        addElControls(el, wrapperId);
    };
    var handlePointerDown = function(e) {
        if (focusTargetSlideEl && focusTargetSlideEl !== e.target && !focusTargetSlideEl.contains(e.target)) preventFocusHandler = true;
        swiper.a11y.clicked = true;
    };
    var handlePointerUp = function() {
        preventFocusHandler = false;
        requestAnimationFrame(function() {
            requestAnimationFrame(function() {
                if (!swiper.destroyed) swiper.a11y.clicked = false;
            });
        });
    };
    var onVisibilityChange = function(e) {
        visibilityChangedTimestamp = new Date().getTime();
    };
    var handleFocus = function(e) {
        if (swiper.a11y.clicked || !swiper.params.a11y.scrollOnFocus) return;
        if (new Date().getTime() - visibilityChangedTimestamp < 100) return;
        var slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
        if (!slideEl || !swiper.slides.includes(slideEl)) return;
        focusTargetSlideEl = slideEl;
        var isActive = swiper.slides.indexOf(slideEl) === swiper.activeIndex;
        var isVisible = swiper.params.watchSlidesProgress && swiper.visibleSlides && swiper.visibleSlides.includes(slideEl);
        if (isActive || isVisible) return;
        if (e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents) return;
        if (swiper.isHorizontal()) swiper.el.scrollLeft = 0;
        else swiper.el.scrollTop = 0;
        requestAnimationFrame(function() {
            if (preventFocusHandler) return;
            if (swiper.params.loop) swiper.slideToLoop(parseInt(slideEl.getAttribute('data-swiper-slide-index')), 0);
            else swiper.slideTo(swiper.slides.indexOf(slideEl), 0);
            preventFocusHandler = false;
        });
    };
    var initSlides = function() {
        var params = swiper.params.a11y;
        if (params.itemRoleDescriptionMessage) addElRoleDescription(swiper.slides, params.itemRoleDescriptionMessage);
        if (params.slideRole) addElRole(swiper.slides, params.slideRole);
        var slidesLength = swiper.slides.length;
        if (params.slideLabelMessage) swiper.slides.forEach(function(slideEl, index) {
            var slideIndex = swiper.params.loop ? parseInt(slideEl.getAttribute('data-swiper-slide-index'), 10) : index;
            var ariaLabelMessage = params.slideLabelMessage.replace(/\{\{index\}\}/, slideIndex + 1).replace(/\{\{slidesLength\}\}/, slidesLength);
            addElLabel(slideEl, ariaLabelMessage);
        });
    };
    var init = function() {
        var params = swiper.params.a11y;
        swiper.el.append(liveRegion);
        // Container
        var containerEl = swiper.el;
        if (params.containerRoleDescriptionMessage) addElRoleDescription(containerEl, params.containerRoleDescriptionMessage);
        if (params.containerMessage) addElLabel(containerEl, params.containerMessage);
        if (params.containerRole) addElRole(containerEl, params.containerRole);
        // Wrapper
        var wrapperEl = swiper.wrapperEl;
        var wrapperId = params.id || wrapperEl.getAttribute('id') || `swiper-wrapper-${getRandomNumber(16)}`;
        var live = swiper.params.autoplay && swiper.params.autoplay.enabled ? 'off' : 'polite';
        addElId(wrapperEl, wrapperId);
        addElLive(wrapperEl, live);
        // Slide
        initSlides();
        // Navigation
        var _$_ref = swiper.navigation ? swiper.navigation : {}, nextEl = _$_ref.nextEl, prevEl = _$_ref.prevEl;
        nextEl = (0, _utilsMjs.m)(nextEl);
        prevEl = (0, _utilsMjs.m)(prevEl);
        if (nextEl) nextEl.forEach(function(el) {
            return initNavEl(el, wrapperId, params.nextSlideMessage);
        });
        if (prevEl) prevEl.forEach(function(el) {
            return initNavEl(el, wrapperId, params.prevSlideMessage);
        });
        // Pagination
        if (hasClickablePagination()) {
            var paginationEl = (0, _utilsMjs.m)(swiper.pagination.el);
            paginationEl.forEach(function(el) {
                el.addEventListener('keydown', onEnterOrSpaceKey);
            });
        }
        // Tab focus
        var document = (0, _ssrWindowEsmMjs.g)();
        document.addEventListener('visibilitychange', onVisibilityChange);
        swiper.el.addEventListener('focus', handleFocus, true);
        swiper.el.addEventListener('focus', handleFocus, true);
        swiper.el.addEventListener('pointerdown', handlePointerDown, true);
        swiper.el.addEventListener('pointerup', handlePointerUp, true);
    };
    function destroy() {
        if (liveRegion) liveRegion.remove();
        var _$_ref = swiper.navigation ? swiper.navigation : {}, nextEl = _$_ref.nextEl, prevEl = _$_ref.prevEl;
        nextEl = (0, _utilsMjs.m)(nextEl);
        prevEl = (0, _utilsMjs.m)(prevEl);
        if (nextEl) nextEl.forEach(function(el) {
            return el.removeEventListener('keydown', onEnterOrSpaceKey);
        });
        if (prevEl) prevEl.forEach(function(el) {
            return el.removeEventListener('keydown', onEnterOrSpaceKey);
        });
        // Pagination
        if (hasClickablePagination()) {
            var paginationEl = (0, _utilsMjs.m)(swiper.pagination.el);
            paginationEl.forEach(function(el) {
                el.removeEventListener('keydown', onEnterOrSpaceKey);
            });
        }
        var document = (0, _ssrWindowEsmMjs.g)();
        document.removeEventListener('visibilitychange', onVisibilityChange);
        // Tab focus
        if (swiper.el && typeof swiper.el !== 'string') {
            swiper.el.removeEventListener('focus', handleFocus, true);
            swiper.el.removeEventListener('pointerdown', handlePointerDown, true);
            swiper.el.removeEventListener('pointerup', handlePointerUp, true);
        }
    }
    on('beforeInit', function() {
        liveRegion = (0, _utilsMjs.c)('span', swiper.params.a11y.notificationClass);
        liveRegion.setAttribute('aria-live', 'assertive');
        liveRegion.setAttribute('aria-atomic', 'true');
    });
    on('afterInit', function() {
        if (!swiper.params.a11y.enabled) return;
        init();
    });
    on('slidesLengthChange snapGridLengthChange slidesGridLengthChange', function() {
        if (!swiper.params.a11y.enabled) return;
        initSlides();
    });
    on('fromEdge toEdge afterInit lock unlock', function() {
        if (!swiper.params.a11y.enabled) return;
        updateNavigation();
    });
    on('paginationUpdate', function() {
        if (!swiper.params.a11y.enabled) return;
        updatePagination();
    });
    on('destroy', function() {
        if (!swiper.params.a11y.enabled) return;
        destroy();
    });
}

},{"../shared/ssr-window.esm.mjs":"6ooWP","../shared/classes-to-selector.mjs":"aZg9M","../shared/utils.mjs":"7Cawp","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3KcoE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return History;
});
var _ssrWindowEsmMjs = require("../shared/ssr-window.esm.mjs");
function History(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, on = _ref.on;
    extendParams({
        history: {
            enabled: false,
            root: '',
            replaceState: false,
            key: 'slides',
            keepQuery: false
        }
    });
    var initialized = false;
    var paths = {};
    var slugify = function(text) {
        return text.toString().replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace(/--+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
    };
    var getPathValues = function(urlOverride) {
        var window = (0, _ssrWindowEsmMjs.a)();
        var location;
        if (urlOverride) location = new URL(urlOverride);
        else location = window.location;
        var pathArray = location.pathname.slice(1).split('/').filter(function(part) {
            return part !== '';
        });
        var total = pathArray.length;
        var key = pathArray[total - 2];
        var value = pathArray[total - 1];
        return {
            key: key,
            value: value
        };
    };
    var setHistory = function(key, index) {
        var window = (0, _ssrWindowEsmMjs.a)();
        if (!initialized || !swiper.params.history.enabled) return;
        var location;
        if (swiper.params.url) location = new URL(swiper.params.url);
        else location = window.location;
        var slide = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${index}"]`) : swiper.slides[index];
        var value = slugify(slide.getAttribute('data-history'));
        if (swiper.params.history.root.length > 0) {
            var root = swiper.params.history.root;
            if (root[root.length - 1] === '/') root = root.slice(0, root.length - 1);
            value = `${root}/${key ? `${key}/` : ''}${value}`;
        } else if (!location.pathname.includes(key)) value = `${key ? `${key}/` : ''}${value}`;
        if (swiper.params.history.keepQuery) value += location.search;
        var currentState = window.history.state;
        if (currentState && currentState.value === value) return;
        if (swiper.params.history.replaceState) window.history.replaceState({
            value: value
        }, null, value);
        else window.history.pushState({
            value: value
        }, null, value);
    };
    var scrollToSlide = function(speed, value, runCallbacks) {
        if (value) for(var i = 0, length = swiper.slides.length; i < length; i += 1){
            var slide = swiper.slides[i];
            var slideHistory = slugify(slide.getAttribute('data-history'));
            if (slideHistory === value) {
                var index = swiper.getSlideIndex(slide);
                swiper.slideTo(index, speed, runCallbacks);
            }
        }
        else swiper.slideTo(0, speed, runCallbacks);
    };
    var setHistoryPopState = function() {
        paths = getPathValues(swiper.params.url);
        scrollToSlide(swiper.params.speed, paths.value, false);
    };
    var init = function() {
        var window = (0, _ssrWindowEsmMjs.a)();
        if (!swiper.params.history) return;
        if (!window.history || !window.history.pushState) {
            swiper.params.history.enabled = false;
            swiper.params.hashNavigation.enabled = true;
            return;
        }
        initialized = true;
        paths = getPathValues(swiper.params.url);
        if (!paths.key && !paths.value) {
            if (!swiper.params.history.replaceState) window.addEventListener('popstate', setHistoryPopState);
            return;
        }
        scrollToSlide(0, paths.value, swiper.params.runCallbacksOnInit);
        if (!swiper.params.history.replaceState) window.addEventListener('popstate', setHistoryPopState);
    };
    var destroy = function() {
        var window = (0, _ssrWindowEsmMjs.a)();
        if (!swiper.params.history.replaceState) window.removeEventListener('popstate', setHistoryPopState);
    };
    on('init', function() {
        if (swiper.params.history.enabled) init();
    });
    on('destroy', function() {
        if (swiper.params.history.enabled) destroy();
    });
    on('transitionEnd _freeModeNoMomentumRelease', function() {
        if (initialized) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
    on('slideChange', function() {
        if (initialized && swiper.params.cssMode) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
}

},{"../shared/ssr-window.esm.mjs":"6ooWP","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3oUT0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return HashNavigation;
});
var _ssrWindowEsmMjs = require("../shared/ssr-window.esm.mjs");
var _utilsMjs = require("../shared/utils.mjs");
function HashNavigation(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, emit = _ref.emit, on = _ref.on;
    var initialized = false;
    var document = (0, _ssrWindowEsmMjs.g)();
    var window = (0, _ssrWindowEsmMjs.a)();
    extendParams({
        hashNavigation: {
            enabled: false,
            replaceState: false,
            watchState: false,
            getSlideIndex: function(_s, hash) {
                if (swiper.virtual && swiper.params.virtual.enabled) {
                    var slideWithHash = swiper.slides.find(function(slideEl) {
                        return slideEl.getAttribute('data-hash') === hash;
                    });
                    if (!slideWithHash) return 0;
                    var index = parseInt(slideWithHash.getAttribute('data-swiper-slide-index'), 10);
                    return index;
                }
                return swiper.getSlideIndex((0, _utilsMjs.e)(swiper.slidesEl, `.${swiper.params.slideClass}[data-hash="${hash}"], swiper-slide[data-hash="${hash}"]`)[0]);
            }
        }
    });
    var onHashChange = function() {
        emit('hashChange');
        var newHash = document.location.hash.replace('#', '');
        var activeSlideEl = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${swiper.activeIndex}"]`) : swiper.slides[swiper.activeIndex];
        var activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute('data-hash') : '';
        if (newHash !== activeSlideHash) {
            var newIndex = swiper.params.hashNavigation.getSlideIndex(swiper, newHash);
            if (typeof newIndex === 'undefined' || Number.isNaN(newIndex)) return;
            swiper.slideTo(newIndex);
        }
    };
    var setHash = function() {
        if (!initialized || !swiper.params.hashNavigation.enabled) return;
        var activeSlideEl = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${swiper.activeIndex}"]`) : swiper.slides[swiper.activeIndex];
        var activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute('data-hash') || activeSlideEl.getAttribute('data-history') : '';
        if (swiper.params.hashNavigation.replaceState && window.history && window.history.replaceState) {
            window.history.replaceState(null, null, `#${activeSlideHash}` || '');
            emit('hashSet');
        } else {
            document.location.hash = activeSlideHash || '';
            emit('hashSet');
        }
    };
    var init = function() {
        if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled) return;
        initialized = true;
        var hash = document.location.hash.replace('#', '');
        if (hash) {
            var speed = 0;
            var index = swiper.params.hashNavigation.getSlideIndex(swiper, hash);
            swiper.slideTo(index || 0, speed, swiper.params.runCallbacksOnInit, true);
        }
        if (swiper.params.hashNavigation.watchState) window.addEventListener('hashchange', onHashChange);
    };
    var destroy = function() {
        if (swiper.params.hashNavigation.watchState) window.removeEventListener('hashchange', onHashChange);
    };
    on('init', function() {
        if (swiper.params.hashNavigation.enabled) init();
    });
    on('destroy', function() {
        if (swiper.params.hashNavigation.enabled) destroy();
    });
    on('transitionEnd _freeModeNoMomentumRelease', function() {
        if (initialized) setHash();
    });
    on('slideChange', function() {
        if (initialized && swiper.params.cssMode) setHash();
    });
}

},{"../shared/ssr-window.esm.mjs":"6ooWP","../shared/utils.mjs":"7Cawp","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"9yXUw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return Autoplay;
});
var _ssrWindowEsmMjs = require("../shared/ssr-window.esm.mjs");
/* eslint no-underscore-dangle: "off" */ /* eslint no-use-before-define: "off" */ function Autoplay(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, on = _ref.on, emit = _ref.emit, params = _ref.params;
    swiper.autoplay = {
        running: false,
        paused: false,
        timeLeft: 0
    };
    extendParams({
        autoplay: {
            enabled: false,
            delay: 3000,
            waitForTransition: true,
            disableOnInteraction: false,
            stopOnLastSlide: false,
            reverseDirection: false,
            pauseOnMouseEnter: false
        }
    });
    var timeout;
    var raf;
    var autoplayDelayTotal = params && params.autoplay ? params.autoplay.delay : 3000;
    var autoplayDelayCurrent = params && params.autoplay ? params.autoplay.delay : 3000;
    var autoplayTimeLeft;
    var autoplayStartTime = new Date().getTime();
    var wasPaused;
    var isTouched;
    var pausedByTouch;
    var touchStartTimeout;
    var slideChanged;
    var pausedByInteraction;
    var pausedByPointerEnter;
    function onTransitionEnd(e) {
        if (!swiper || swiper.destroyed || !swiper.wrapperEl) return;
        if (e.target !== swiper.wrapperEl) return;
        swiper.wrapperEl.removeEventListener('transitionend', onTransitionEnd);
        if (pausedByPointerEnter || e.detail && e.detail.bySwiperTouchMove) return;
        resume();
    }
    var calcTimeLeft = function() {
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (swiper.autoplay.paused) wasPaused = true;
        else if (wasPaused) {
            autoplayDelayCurrent = autoplayTimeLeft;
            wasPaused = false;
        }
        var timeLeft = swiper.autoplay.paused ? autoplayTimeLeft : autoplayStartTime + autoplayDelayCurrent - new Date().getTime();
        swiper.autoplay.timeLeft = timeLeft;
        emit('autoplayTimeLeft', timeLeft, timeLeft / autoplayDelayTotal);
        raf = requestAnimationFrame(function() {
            calcTimeLeft();
        });
    };
    var getSlideDelay = function() {
        var activeSlideEl;
        if (swiper.virtual && swiper.params.virtual.enabled) activeSlideEl = swiper.slides.find(function(slideEl) {
            return slideEl.classList.contains('swiper-slide-active');
        });
        else activeSlideEl = swiper.slides[swiper.activeIndex];
        if (!activeSlideEl) return undefined;
        var currentSlideDelay = parseInt(activeSlideEl.getAttribute('data-swiper-autoplay'), 10);
        return currentSlideDelay;
    };
    var run = function(delayForce) {
        if (swiper.destroyed || !swiper.autoplay.running) return;
        cancelAnimationFrame(raf);
        calcTimeLeft();
        var delay = typeof delayForce === 'undefined' ? swiper.params.autoplay.delay : delayForce;
        autoplayDelayTotal = swiper.params.autoplay.delay;
        autoplayDelayCurrent = swiper.params.autoplay.delay;
        var currentSlideDelay = getSlideDelay();
        if (!Number.isNaN(currentSlideDelay) && currentSlideDelay > 0 && typeof delayForce === 'undefined') {
            delay = currentSlideDelay;
            autoplayDelayTotal = currentSlideDelay;
            autoplayDelayCurrent = currentSlideDelay;
        }
        autoplayTimeLeft = delay;
        var speed = swiper.params.speed;
        var proceed = function() {
            if (!swiper || swiper.destroyed) return;
            if (swiper.params.autoplay.reverseDirection) {
                if (!swiper.isBeginning || swiper.params.loop || swiper.params.rewind) {
                    swiper.slidePrev(speed, true, true);
                    emit('autoplay');
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    swiper.slideTo(swiper.slides.length - 1, speed, true, true);
                    emit('autoplay');
                }
            } else {
                if (!swiper.isEnd || swiper.params.loop || swiper.params.rewind) {
                    swiper.slideNext(speed, true, true);
                    emit('autoplay');
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    swiper.slideTo(0, speed, true, true);
                    emit('autoplay');
                }
            }
            if (swiper.params.cssMode) {
                autoplayStartTime = new Date().getTime();
                requestAnimationFrame(function() {
                    run();
                });
            }
        };
        if (delay > 0) {
            clearTimeout(timeout);
            timeout = setTimeout(function() {
                proceed();
            }, delay);
        } else requestAnimationFrame(function() {
            proceed();
        });
        // eslint-disable-next-line
        return delay;
    };
    var start = function() {
        autoplayStartTime = new Date().getTime();
        swiper.autoplay.running = true;
        run();
        emit('autoplayStart');
    };
    var stop = function() {
        swiper.autoplay.running = false;
        clearTimeout(timeout);
        cancelAnimationFrame(raf);
        emit('autoplayStop');
    };
    var pause = function(internal, reset) {
        if (swiper.destroyed || !swiper.autoplay.running) return;
        clearTimeout(timeout);
        if (!internal) pausedByInteraction = true;
        var proceed = function() {
            emit('autoplayPause');
            if (swiper.params.autoplay.waitForTransition) swiper.wrapperEl.addEventListener('transitionend', onTransitionEnd);
            else resume();
        };
        swiper.autoplay.paused = true;
        if (reset) {
            if (slideChanged) autoplayTimeLeft = swiper.params.autoplay.delay;
            slideChanged = false;
            proceed();
            return;
        }
        var delay = autoplayTimeLeft || swiper.params.autoplay.delay;
        autoplayTimeLeft = delay - (new Date().getTime() - autoplayStartTime);
        if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop) return;
        if (autoplayTimeLeft < 0) autoplayTimeLeft = 0;
        proceed();
    };
    var resume = function() {
        if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop || swiper.destroyed || !swiper.autoplay.running) return;
        autoplayStartTime = new Date().getTime();
        if (pausedByInteraction) {
            pausedByInteraction = false;
            run(autoplayTimeLeft);
        } else run();
        swiper.autoplay.paused = false;
        emit('autoplayResume');
    };
    var onVisibilityChange = function() {
        if (swiper.destroyed || !swiper.autoplay.running) return;
        var document = (0, _ssrWindowEsmMjs.g)();
        if (document.visibilityState === 'hidden') {
            pausedByInteraction = true;
            pause(true);
        }
        if (document.visibilityState === 'visible') resume();
    };
    var onPointerEnter = function(e) {
        if (e.pointerType !== 'mouse') return;
        pausedByInteraction = true;
        pausedByPointerEnter = true;
        if (swiper.animating || swiper.autoplay.paused) return;
        pause(true);
    };
    var onPointerLeave = function(e) {
        if (e.pointerType !== 'mouse') return;
        pausedByPointerEnter = false;
        if (swiper.autoplay.paused) resume();
    };
    var attachMouseEvents = function() {
        if (swiper.params.autoplay.pauseOnMouseEnter) {
            swiper.el.addEventListener('pointerenter', onPointerEnter);
            swiper.el.addEventListener('pointerleave', onPointerLeave);
        }
    };
    var detachMouseEvents = function() {
        if (swiper.el && typeof swiper.el !== 'string') {
            swiper.el.removeEventListener('pointerenter', onPointerEnter);
            swiper.el.removeEventListener('pointerleave', onPointerLeave);
        }
    };
    var attachDocumentEvents = function() {
        var document = (0, _ssrWindowEsmMjs.g)();
        document.addEventListener('visibilitychange', onVisibilityChange);
    };
    var detachDocumentEvents = function() {
        var document = (0, _ssrWindowEsmMjs.g)();
        document.removeEventListener('visibilitychange', onVisibilityChange);
    };
    on('init', function() {
        if (swiper.params.autoplay.enabled) {
            attachMouseEvents();
            attachDocumentEvents();
            start();
        }
    });
    on('destroy', function() {
        detachMouseEvents();
        detachDocumentEvents();
        if (swiper.autoplay.running) stop();
    });
    on('_freeModeStaticRelease', function() {
        if (pausedByTouch || pausedByInteraction) resume();
    });
    on('_freeModeNoMomentumRelease', function() {
        if (!swiper.params.autoplay.disableOnInteraction) pause(true, true);
        else stop();
    });
    on('beforeTransitionStart', function(_s, speed, internal) {
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (internal || !swiper.params.autoplay.disableOnInteraction) pause(true, true);
        else stop();
    });
    on('sliderFirstMove', function() {
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (swiper.params.autoplay.disableOnInteraction) {
            stop();
            return;
        }
        isTouched = true;
        pausedByTouch = false;
        pausedByInteraction = false;
        touchStartTimeout = setTimeout(function() {
            pausedByInteraction = true;
            pausedByTouch = true;
            pause(true);
        }, 200);
    });
    on('touchEnd', function() {
        if (swiper.destroyed || !swiper.autoplay.running || !isTouched) return;
        clearTimeout(touchStartTimeout);
        clearTimeout(timeout);
        if (swiper.params.autoplay.disableOnInteraction) {
            pausedByTouch = false;
            isTouched = false;
            return;
        }
        if (pausedByTouch && swiper.params.cssMode) resume();
        pausedByTouch = false;
        isTouched = false;
    });
    on('slideChange', function() {
        if (swiper.destroyed || !swiper.autoplay.running) return;
        slideChanged = true;
    });
    Object.assign(swiper.autoplay, {
        start: start,
        stop: stop,
        pause: pause,
        resume: resume
    });
}

},{"../shared/ssr-window.esm.mjs":"6ooWP","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4QrR0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return Thumb;
});
var _ssrWindowEsmMjs = require("../shared/ssr-window.esm.mjs");
var _utilsMjs = require("../shared/utils.mjs");
function Thumb(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, on = _ref.on;
    extendParams({
        thumbs: {
            swiper: null,
            multipleActiveThumbs: true,
            autoScrollOffset: 0,
            slideThumbActiveClass: 'swiper-slide-thumb-active',
            thumbsContainerClass: 'swiper-thumbs'
        }
    });
    var initialized = false;
    var swiperCreated = false;
    swiper.thumbs = {
        swiper: null
    };
    function onThumbClick() {
        var thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        var clickedIndex = thumbsSwiper.clickedIndex;
        var clickedSlide = thumbsSwiper.clickedSlide;
        if (clickedSlide && clickedSlide.classList.contains(swiper.params.thumbs.slideThumbActiveClass)) return;
        if (typeof clickedIndex === 'undefined' || clickedIndex === null) return;
        var slideToIndex;
        if (thumbsSwiper.params.loop) slideToIndex = parseInt(thumbsSwiper.clickedSlide.getAttribute('data-swiper-slide-index'), 10);
        else slideToIndex = clickedIndex;
        if (swiper.params.loop) swiper.slideToLoop(slideToIndex);
        else swiper.slideTo(slideToIndex);
    }
    function init() {
        var _swiper_params = swiper.params, thumbsParams = _swiper_params.thumbs;
        if (initialized) return false;
        initialized = true;
        var SwiperClass = swiper.constructor;
        if (thumbsParams.swiper instanceof SwiperClass) {
            if (thumbsParams.swiper.destroyed) {
                initialized = false;
                return false;
            }
            swiper.thumbs.swiper = thumbsParams.swiper;
            Object.assign(swiper.thumbs.swiper.originalParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            Object.assign(swiper.thumbs.swiper.params, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper.update();
        } else if ((0, _utilsMjs.l)(thumbsParams.swiper)) {
            var thumbsSwiperParams = Object.assign({}, thumbsParams.swiper);
            Object.assign(thumbsSwiperParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper = new SwiperClass(thumbsSwiperParams);
            swiperCreated = true;
        }
        swiper.thumbs.swiper.el.classList.add(swiper.params.thumbs.thumbsContainerClass);
        swiper.thumbs.swiper.on('tap', onThumbClick);
        return true;
    }
    function update(initial) {
        var thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        var slidesPerView = thumbsSwiper.params.slidesPerView === 'auto' ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView;
        // Activate thumbs
        var thumbsToActivate = 1;
        var thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;
        if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) thumbsToActivate = swiper.params.slidesPerView;
        if (!swiper.params.thumbs.multipleActiveThumbs) thumbsToActivate = 1;
        thumbsToActivate = Math.floor(thumbsToActivate);
        thumbsSwiper.slides.forEach(function(slideEl) {
            return slideEl.classList.remove(thumbActiveClass);
        });
        if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled) for(var i = 0; i < thumbsToActivate; i += 1)(0, _utilsMjs.e)(thumbsSwiper.slidesEl, `[data-swiper-slide-index="${swiper.realIndex + i}"]`).forEach(function(slideEl) {
            slideEl.classList.add(thumbActiveClass);
        });
        else {
            for(var i1 = 0; i1 < thumbsToActivate; i1 += 1)if (thumbsSwiper.slides[swiper.realIndex + i1]) thumbsSwiper.slides[swiper.realIndex + i1].classList.add(thumbActiveClass);
        }
        var autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
        var useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
        if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
            var currentThumbsIndex = thumbsSwiper.activeIndex;
            var newThumbsIndex;
            var direction;
            if (thumbsSwiper.params.loop) {
                var newThumbsSlide = thumbsSwiper.slides.find(function(slideEl) {
                    return slideEl.getAttribute('data-swiper-slide-index') === `${swiper.realIndex}`;
                });
                newThumbsIndex = thumbsSwiper.slides.indexOf(newThumbsSlide);
                direction = swiper.activeIndex > swiper.previousIndex ? 'next' : 'prev';
            } else {
                newThumbsIndex = swiper.realIndex;
                direction = newThumbsIndex > swiper.previousIndex ? 'next' : 'prev';
            }
            if (useOffset) newThumbsIndex += direction === 'next' ? autoScrollOffset : -1 * autoScrollOffset;
            if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
                if (thumbsSwiper.params.centeredSlides) {
                    if (newThumbsIndex > currentThumbsIndex) newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
                    else newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
                } else newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup;
                thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
            }
        }
    }
    on('beforeInit', function() {
        var thumbs = swiper.params.thumbs;
        if (!thumbs || !thumbs.swiper) return;
        if (typeof thumbs.swiper === 'string' || thumbs.swiper instanceof HTMLElement) {
            var document = (0, _ssrWindowEsmMjs.g)();
            var getThumbsElementAndInit = function() {
                var thumbsElement = typeof thumbs.swiper === 'string' ? document.querySelector(thumbs.swiper) : thumbs.swiper;
                if (thumbsElement && thumbsElement.swiper) {
                    thumbs.swiper = thumbsElement.swiper;
                    init();
                    update(true);
                } else if (thumbsElement) {
                    var eventName = `${swiper.params.eventsPrefix}init`;
                    var onThumbsSwiper = function(e) {
                        thumbs.swiper = e.detail[0];
                        thumbsElement.removeEventListener(eventName, onThumbsSwiper);
                        init();
                        update(true);
                        thumbs.swiper.update();
                        swiper.update();
                    };
                    thumbsElement.addEventListener(eventName, onThumbsSwiper);
                }
                return thumbsElement;
            };
            var watchForThumbsToAppear = function() {
                if (swiper.destroyed) return;
                var thumbsElement = getThumbsElementAndInit();
                if (!thumbsElement) requestAnimationFrame(watchForThumbsToAppear);
            };
            requestAnimationFrame(watchForThumbsToAppear);
        } else {
            init();
            update(true);
        }
    });
    on('slideChange update resize observerUpdate', function() {
        update();
    });
    on('setTransition', function(_s, duration) {
        var thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        thumbsSwiper.setTransition(duration);
    });
    on('beforeDestroy', function() {
        var thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        if (swiperCreated) thumbsSwiper.destroy();
    });
    Object.assign(swiper.thumbs, {
        init: init,
        update: update
    });
}

},{"../shared/ssr-window.esm.mjs":"6ooWP","../shared/utils.mjs":"7Cawp","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gRDqR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return freeMode;
});
var _utilsMjs = require("../shared/utils.mjs");
function freeMode(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, emit = _ref.emit, once = _ref.once;
    extendParams({
        freeMode: {
            enabled: false,
            momentum: true,
            momentumRatio: 1,
            momentumBounce: true,
            momentumBounceRatio: 1,
            momentumVelocityRatio: 1,
            sticky: false,
            minimumVelocity: 0.02
        }
    });
    function onTouchStart() {
        if (swiper.params.cssMode) return;
        var translate = swiper.getTranslate();
        swiper.setTranslate(translate);
        swiper.setTransition(0);
        swiper.touchEventsData.velocities.length = 0;
        swiper.freeMode.onTouchEnd({
            currentPos: swiper.rtl ? swiper.translate : -swiper.translate
        });
    }
    function onTouchMove() {
        if (swiper.params.cssMode) return;
        var data = swiper.touchEventsData, touches = swiper.touches;
        // Velocity
        if (data.velocities.length === 0) data.velocities.push({
            position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
            time: data.touchStartTime
        });
        data.velocities.push({
            position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
            time: (0, _utilsMjs.d)()
        });
    }
    function onTouchEnd(_ref2) {
        var currentPos = _ref2.currentPos;
        if (swiper.params.cssMode) return;
        var params = swiper.params, wrapperEl = swiper.wrapperEl, rtl = swiper.rtlTranslate, snapGrid = swiper.snapGrid, data = swiper.touchEventsData;
        // Time diff
        var touchEndTime = (0, _utilsMjs.d)();
        var timeDiff = touchEndTime - data.touchStartTime;
        if (currentPos < -swiper.minTranslate()) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (currentPos > -swiper.maxTranslate()) {
            if (swiper.slides.length < snapGrid.length) swiper.slideTo(snapGrid.length - 1);
            else swiper.slideTo(swiper.slides.length - 1);
            return;
        }
        if (params.freeMode.momentum) {
            if (data.velocities.length > 1) {
                var lastMoveEvent = data.velocities.pop();
                var velocityEvent = data.velocities.pop();
                var distance = lastMoveEvent.position - velocityEvent.position;
                var time = lastMoveEvent.time - velocityEvent.time;
                swiper.velocity = distance / time;
                swiper.velocity /= 2;
                if (Math.abs(swiper.velocity) < params.freeMode.minimumVelocity) swiper.velocity = 0;
                // this implies that the user stopped moving a finger then released.
                // There would be no events with distance zero, so the last event is stale.
                if (time > 150 || (0, _utilsMjs.d)() - lastMoveEvent.time > 300) swiper.velocity = 0;
            } else swiper.velocity = 0;
            swiper.velocity *= params.freeMode.momentumVelocityRatio;
            data.velocities.length = 0;
            var momentumDuration = 1000 * params.freeMode.momentumRatio;
            var momentumDistance = swiper.velocity * momentumDuration;
            var newPosition = swiper.translate + momentumDistance;
            if (rtl) newPosition = -newPosition;
            var doBounce = false;
            var afterBouncePosition;
            var bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeMode.momentumBounceRatio;
            var needsLoopFix;
            if (newPosition < swiper.maxTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition + swiper.maxTranslate() < -bounceAmount) newPosition = swiper.maxTranslate() - bounceAmount;
                    afterBouncePosition = swiper.maxTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.maxTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (newPosition > swiper.minTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition - swiper.minTranslate() > bounceAmount) newPosition = swiper.minTranslate() + bounceAmount;
                    afterBouncePosition = swiper.minTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.minTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (params.freeMode.sticky) {
                var nextSlide;
                for(var j = 0; j < snapGrid.length; j += 1)if (snapGrid[j] > -newPosition) {
                    nextSlide = j;
                    break;
                }
                if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') newPosition = snapGrid[nextSlide];
                else newPosition = snapGrid[nextSlide - 1];
                newPosition = -newPosition;
            }
            if (needsLoopFix) once('transitionEnd', function() {
                swiper.loopFix();
            });
            // Fix duration
            if (swiper.velocity !== 0) {
                if (rtl) momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
                else momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
                if (params.freeMode.sticky) {
                    // If freeMode.sticky is active and the user ends a swipe with a slow-velocity
                    // event, then durations can be 20+ seconds to slide one (or zero!) slides.
                    // It's easy to see this when simulating touch with mouse events. To fix this,
                    // limit single-slide swipes to the default slide duration. This also has the
                    // nice side effect of matching slide speed if the user stopped moving before
                    // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
                    // For faster swipes, also apply limits (albeit higher ones).
                    var moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
                    var currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
                    if (moveDistance < currentSlideSize) momentumDuration = params.speed;
                    else if (moveDistance < 2 * currentSlideSize) momentumDuration = params.speed * 1.5;
                    else momentumDuration = params.speed * 2.5;
                }
            } else if (params.freeMode.sticky) {
                swiper.slideToClosest();
                return;
            }
            if (params.freeMode.momentumBounce && doBounce) {
                swiper.updateProgress(afterBouncePosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                swiper.animating = true;
                (0, _utilsMjs.k)(wrapperEl, function() {
                    if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
                    emit('momentumBounce');
                    swiper.setTransition(params.speed);
                    setTimeout(function() {
                        swiper.setTranslate(afterBouncePosition);
                        (0, _utilsMjs.k)(wrapperEl, function() {
                            if (!swiper || swiper.destroyed) return;
                            swiper.transitionEnd();
                        });
                    }, 0);
                });
            } else if (swiper.velocity) {
                emit('_freeModeNoMomentumRelease');
                swiper.updateProgress(newPosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                if (!swiper.animating) {
                    swiper.animating = true;
                    (0, _utilsMjs.k)(wrapperEl, function() {
                        if (!swiper || swiper.destroyed) return;
                        swiper.transitionEnd();
                    });
                }
            } else swiper.updateProgress(newPosition);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        } else if (params.freeMode.sticky) {
            swiper.slideToClosest();
            return;
        } else if (params.freeMode) emit('_freeModeNoMomentumRelease');
        if (!params.freeMode.momentum || timeDiff >= params.longSwipesMs) {
            emit('_freeModeStaticRelease');
            swiper.updateProgress();
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
    }
    Object.assign(swiper, {
        freeMode: {
            onTouchStart: onTouchStart,
            onTouchMove: onTouchMove,
            onTouchEnd: onTouchEnd
        }
    });
}

},{"../shared/utils.mjs":"7Cawp","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"dtt0J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return Grid;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
function Grid(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, on = _ref.on;
    extendParams({
        grid: {
            rows: 1,
            fill: 'column'
        }
    });
    var slidesNumberEvenToRows;
    var slidesPerRow;
    var numFullColumns;
    var wasMultiRow;
    var getSpaceBetween = function() {
        var spaceBetween = swiper.params.spaceBetween;
        if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiper.size;
        else if (typeof spaceBetween === 'string') spaceBetween = parseFloat(spaceBetween);
        return spaceBetween;
    };
    var initSlides = function(slides) {
        var slidesPerView = swiper.params.slidesPerView;
        var _swiper_params_grid = swiper.params.grid, rows = _swiper_params_grid.rows, fill = _swiper_params_grid.fill;
        var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : slides.length;
        numFullColumns = Math.floor(slidesLength / rows);
        if (Math.floor(slidesLength / rows) === slidesLength / rows) slidesNumberEvenToRows = slidesLength;
        else slidesNumberEvenToRows = Math.ceil(slidesLength / rows) * rows;
        if (slidesPerView !== 'auto' && fill === 'row') slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, slidesPerView * rows);
        slidesPerRow = slidesNumberEvenToRows / rows;
    };
    var unsetSlides = function() {
        if (swiper.slides) swiper.slides.forEach(function(slide) {
            if (slide.swiperSlideGridSet) {
                slide.style.height = '';
                slide.style[swiper.getDirectionLabel('margin-top')] = '';
            }
        });
    };
    var updateSlide = function(i, slide, slides) {
        var slidesPerGroup = swiper.params.slidesPerGroup;
        var spaceBetween = getSpaceBetween();
        var _swiper_params_grid = swiper.params.grid, rows = _swiper_params_grid.rows, fill = _swiper_params_grid.fill;
        var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : slides.length;
        // Set slides order
        var newSlideOrderIndex;
        var column;
        var row;
        if (fill === 'row' && slidesPerGroup > 1) {
            var groupIndex = Math.floor(i / (slidesPerGroup * rows));
            var slideIndexInGroup = i - rows * slidesPerGroup * groupIndex;
            var columnsInGroup = groupIndex === 0 ? slidesPerGroup : Math.min(Math.ceil((slidesLength - groupIndex * rows * slidesPerGroup) / rows), slidesPerGroup);
            row = Math.floor(slideIndexInGroup / columnsInGroup);
            column = slideIndexInGroup - row * columnsInGroup + groupIndex * slidesPerGroup;
            newSlideOrderIndex = column + row * slidesNumberEvenToRows / rows;
            slide.style.order = newSlideOrderIndex;
        } else if (fill === 'column') {
            column = Math.floor(i / rows);
            row = i - column * rows;
            if (column > numFullColumns || column === numFullColumns && row === rows - 1) {
                row += 1;
                if (row >= rows) {
                    row = 0;
                    column += 1;
                }
            }
        } else {
            row = Math.floor(i / slidesPerRow);
            column = i - row * slidesPerRow;
        }
        slide.row = row;
        slide.column = column;
        slide.style.height = `calc((100% - ${(rows - 1) * spaceBetween}px) / ${rows})`;
        slide.style[swiper.getDirectionLabel('margin-top')] = row !== 0 ? spaceBetween && `${spaceBetween}px` : '';
        slide.swiperSlideGridSet = true;
    };
    var updateWrapperSize = function(slideSize, snapGrid) {
        var _swiper_params = swiper.params, centeredSlides = _swiper_params.centeredSlides, roundLengths = _swiper_params.roundLengths;
        var spaceBetween = getSpaceBetween();
        var rows = swiper.params.grid.rows;
        swiper.virtualSize = (slideSize + spaceBetween) * slidesNumberEvenToRows;
        swiper.virtualSize = Math.ceil(swiper.virtualSize / rows) - spaceBetween;
        if (!swiper.params.cssMode) swiper.wrapperEl.style[swiper.getDirectionLabel('width')] = `${swiper.virtualSize + spaceBetween}px`;
        if (centeredSlides) {
            var _snapGrid;
            var newSlidesGrid = [];
            for(var i = 0; i < snapGrid.length; i += 1){
                var slidesGridItem = snapGrid[i];
                if (roundLengths) slidesGridItem = Math.floor(slidesGridItem);
                if (snapGrid[i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
            }
            snapGrid.splice(0, snapGrid.length);
            (_snapGrid = snapGrid).push.apply(_snapGrid, (0, _toConsumableArray._)(newSlidesGrid));
        }
    };
    var onInit = function() {
        wasMultiRow = swiper.params.grid && swiper.params.grid.rows > 1;
    };
    var onUpdate = function() {
        var params = swiper.params, el = swiper.el;
        var isMultiRow = params.grid && params.grid.rows > 1;
        if (wasMultiRow && !isMultiRow) {
            el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
            numFullColumns = 1;
            swiper.emitContainerClasses();
        } else if (!wasMultiRow && isMultiRow) {
            el.classList.add(`${params.containerModifierClass}grid`);
            if (params.grid.fill === 'column') el.classList.add(`${params.containerModifierClass}grid-column`);
            swiper.emitContainerClasses();
        }
        wasMultiRow = isMultiRow;
    };
    on('init', onInit);
    on('update', onUpdate);
    swiper.grid = {
        initSlides: initSlides,
        unsetSlides: unsetSlides,
        updateSlide: updateSlide,
        updateWrapperSize: updateWrapperSize
    };
}

},{"@swc/helpers/_/_to_consumable_array":"eqNDD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"iliyF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return Manipulation;
});
function appendSlide(slides) {
    var swiper = this;
    var params = swiper.params, slidesEl = swiper.slidesEl;
    if (params.loop) swiper.loopDestroy();
    var appendElement = function(slideEl) {
        if (typeof slideEl === 'string') {
            var tempDOM = document.createElement('div');
            tempDOM.innerHTML = slideEl;
            slidesEl.append(tempDOM.children[0]);
            tempDOM.innerHTML = '';
        } else slidesEl.append(slideEl);
    };
    if (typeof slides === 'object' && 'length' in slides) {
        for(var i = 0; i < slides.length; i += 1)if (slides[i]) appendElement(slides[i]);
    } else appendElement(slides);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
}
function prependSlide(slides) {
    var swiper = this;
    var params = swiper.params, activeIndex = swiper.activeIndex, slidesEl = swiper.slidesEl;
    if (params.loop) swiper.loopDestroy();
    var newActiveIndex = activeIndex + 1;
    var prependElement = function(slideEl) {
        if (typeof slideEl === 'string') {
            var tempDOM = document.createElement('div');
            tempDOM.innerHTML = slideEl;
            slidesEl.prepend(tempDOM.children[0]);
            tempDOM.innerHTML = '';
        } else slidesEl.prepend(slideEl);
    };
    if (typeof slides === 'object' && 'length' in slides) {
        for(var i = 0; i < slides.length; i += 1)if (slides[i]) prependElement(slides[i]);
        newActiveIndex = activeIndex + slides.length;
    } else prependElement(slides);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    swiper.slideTo(newActiveIndex, 0, false);
}
function addSlide(index, slides) {
    var swiper = this;
    var params = swiper.params, activeIndex = swiper.activeIndex, slidesEl = swiper.slidesEl;
    var activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.recalcSlides();
    }
    var baseLength = swiper.slides.length;
    if (index <= 0) {
        swiper.prependSlide(slides);
        return;
    }
    if (index >= baseLength) {
        swiper.appendSlide(slides);
        return;
    }
    var newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
    var slidesBuffer = [];
    for(var i = baseLength - 1; i >= index; i -= 1){
        var currentSlide = swiper.slides[i];
        currentSlide.remove();
        slidesBuffer.unshift(currentSlide);
    }
    if (typeof slides === 'object' && 'length' in slides) {
        for(var i1 = 0; i1 < slides.length; i1 += 1)if (slides[i1]) slidesEl.append(slides[i1]);
        newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
    } else slidesEl.append(slides);
    for(var i2 = 0; i2 < slidesBuffer.length; i2 += 1)slidesEl.append(slidesBuffer[i2]);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}
function removeSlide(slidesIndexes) {
    var swiper = this;
    var params = swiper.params, activeIndex = swiper.activeIndex;
    var activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
    }
    var newActiveIndex = activeIndexBuffer;
    var indexToRemove;
    if (typeof slidesIndexes === 'object' && 'length' in slidesIndexes) {
        for(var i = 0; i < slidesIndexes.length; i += 1){
            indexToRemove = slidesIndexes[i];
            if (swiper.slides[indexToRemove]) swiper.slides[indexToRemove].remove();
            if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        }
        newActiveIndex = Math.max(newActiveIndex, 0);
    } else {
        indexToRemove = slidesIndexes;
        if (swiper.slides[indexToRemove]) swiper.slides[indexToRemove].remove();
        if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        newActiveIndex = Math.max(newActiveIndex, 0);
    }
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}
function removeAllSlides() {
    var swiper = this;
    var slidesIndexes = [];
    for(var i = 0; i < swiper.slides.length; i += 1)slidesIndexes.push(i);
    swiper.removeSlide(slidesIndexes);
}
function Manipulation(_ref) {
    var swiper = _ref.swiper;
    Object.assign(swiper, {
        appendSlide: appendSlide.bind(swiper),
        prependSlide: prependSlide.bind(swiper),
        addSlide: addSlide.bind(swiper),
        removeSlide: removeSlide.bind(swiper),
        removeAllSlides: removeAllSlides.bind(swiper)
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7Il1W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return EffectFade;
});
var _effectInitMjs = require("../shared/effect-init.mjs");
var _effectTargetMjs = require("../shared/effect-target.mjs");
var _effectVirtualTransitionEndMjs = require("../shared/effect-virtual-transition-end.mjs");
var _utilsMjs = require("../shared/utils.mjs");
function EffectFade(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, on = _ref.on;
    extendParams({
        fadeEffect: {
            crossFade: false
        }
    });
    var setTranslate = function() {
        var slides = swiper.slides;
        var params = swiper.params.fadeEffect;
        for(var i = 0; i < slides.length; i += 1){
            var slideEl = swiper.slides[i];
            var offset = slideEl.swiperSlideOffset;
            var tx = -offset;
            if (!swiper.params.virtualTranslate) tx -= swiper.translate;
            var ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
            }
            var slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(slideEl.progress), 0) : 1 + Math.min(Math.max(slideEl.progress, -1), 0);
            var targetEl = (0, _effectTargetMjs.e)(params, slideEl);
            targetEl.style.opacity = slideOpacity;
            targetEl.style.transform = `translate3d(${tx}px, ${ty}px, 0px)`;
        }
    };
    var setTransition = function(duration) {
        var transformElements = swiper.slides.map(function(slideEl) {
            return (0, _utilsMjs.g)(slideEl);
        });
        transformElements.forEach(function(el) {
            el.style.transitionDuration = `${duration}ms`;
        });
        (0, _effectVirtualTransitionEndMjs.e)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements,
            allSlides: true
        });
    };
    (0, _effectInitMjs.e)({
        effect: 'fade',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        overwriteParams: function() {
            return {
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            };
        }
    });
}

},{"../shared/effect-init.mjs":"6vQR2","../shared/effect-target.mjs":"mrhtm","../shared/effect-virtual-transition-end.mjs":"5Mqrb","../shared/utils.mjs":"7Cawp","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6vQR2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "e", function() {
    return effectInit;
});
function effectInit(params) {
    var effect = params.effect, swiper = params.swiper, on = params.on, setTranslate = params.setTranslate, setTransition = params.setTransition, overwriteParams = params.overwriteParams, perspective = params.perspective, recreateShadows = params.recreateShadows, getEffectParams = params.getEffectParams;
    on('beforeInit', function() {
        if (swiper.params.effect !== effect) return;
        swiper.classNames.push(`${swiper.params.containerModifierClass}${effect}`);
        if (perspective && perspective()) swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);
        var overwriteParamsResult = overwriteParams ? overwriteParams() : {};
        Object.assign(swiper.params, overwriteParamsResult);
        Object.assign(swiper.originalParams, overwriteParamsResult);
    });
    on('setTranslate', function() {
        if (swiper.params.effect !== effect) return;
        setTranslate();
    });
    on('setTransition', function(_s, duration) {
        if (swiper.params.effect !== effect) return;
        setTransition(duration);
    });
    on('transitionEnd', function() {
        if (swiper.params.effect !== effect) return;
        if (recreateShadows) {
            if (!getEffectParams || !getEffectParams().slideShadows) return;
            // remove shadows
            swiper.slides.forEach(function(slideEl) {
                slideEl.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach(function(shadowEl) {
                    return shadowEl.remove();
                });
            });
            // create new one
            recreateShadows();
        }
    });
    var requireUpdateOnVirtual;
    on('virtualUpdate', function() {
        if (swiper.params.effect !== effect) return;
        if (!swiper.slides.length) requireUpdateOnVirtual = true;
        requestAnimationFrame(function() {
            if (requireUpdateOnVirtual && swiper.slides && swiper.slides.length) {
                setTranslate();
                requireUpdateOnVirtual = false;
            }
        });
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"mrhtm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "e", function() {
    return effectTarget;
});
var _utilsMjs = require("./utils.mjs");
function effectTarget(effectParams, slideEl) {
    var transformEl = (0, _utilsMjs.g)(slideEl);
    if (transformEl !== slideEl) {
        transformEl.style.backfaceVisibility = 'hidden';
        transformEl.style['-webkit-backface-visibility'] = 'hidden';
    }
    return transformEl;
}

},{"./utils.mjs":"7Cawp","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5Mqrb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "e", function() {
    return effectVirtualTransitionEnd;
});
var _utilsMjs = require("./utils.mjs");
function effectVirtualTransitionEnd(_ref) {
    var swiper = _ref.swiper, duration = _ref.duration, transformElements = _ref.transformElements, allSlides = _ref.allSlides;
    var activeIndex = swiper.activeIndex;
    var getSlide = function(el) {
        if (!el.parentElement) {
            // assume shadow root
            var slide = swiper.slides.find(function(slideEl) {
                return slideEl.shadowRoot && slideEl.shadowRoot === el.parentNode;
            });
            return slide;
        }
        return el.parentElement;
    };
    if (swiper.params.virtualTranslate && duration !== 0) {
        var eventTriggered = false;
        var transitionEndTarget;
        if (allSlides) transitionEndTarget = transformElements;
        else transitionEndTarget = transformElements.filter(function(transformEl) {
            var el = transformEl.classList.contains('swiper-slide-transform') ? getSlide(transformEl) : transformEl;
            return swiper.getSlideIndex(el) === activeIndex;
        });
        transitionEndTarget.forEach(function(el) {
            (0, _utilsMjs.k)(el, function() {
                if (eventTriggered) return;
                if (!swiper || swiper.destroyed) return;
                eventTriggered = true;
                swiper.animating = false;
                var evt = new window.CustomEvent('transitionend', {
                    bubbles: true,
                    cancelable: true
                });
                swiper.wrapperEl.dispatchEvent(evt);
            });
        });
    }
}

},{"./utils.mjs":"7Cawp","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"ibQ1t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return EffectCube;
});
var _effectInitMjs = require("../shared/effect-init.mjs");
var _utilsMjs = require("../shared/utils.mjs");
function EffectCube(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, on = _ref.on;
    extendParams({
        cubeEffect: {
            slideShadows: true,
            shadow: true,
            shadowOffset: 20,
            shadowScale: 0.94
        }
    });
    var createSlideShadows = function(slideEl, progress, isHorizontal) {
        var shadowBefore = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-left') : slideEl.querySelector('.swiper-slide-shadow-top');
        var shadowAfter = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-right') : slideEl.querySelector('.swiper-slide-shadow-bottom');
        if (!shadowBefore) {
            shadowBefore = (0, _utilsMjs.c)('div', `swiper-slide-shadow-cube swiper-slide-shadow-${isHorizontal ? 'left' : 'top'}`.split(' '));
            slideEl.append(shadowBefore);
        }
        if (!shadowAfter) {
            shadowAfter = (0, _utilsMjs.c)('div', `swiper-slide-shadow-cube swiper-slide-shadow-${isHorizontal ? 'right' : 'bottom'}`.split(' '));
            slideEl.append(shadowAfter);
        }
        if (shadowBefore) shadowBefore.style.opacity = Math.max(-progress, 0);
        if (shadowAfter) shadowAfter.style.opacity = Math.max(progress, 0);
    };
    var recreateShadows = function() {
        // create new ones
        var isHorizontal = swiper.isHorizontal();
        swiper.slides.forEach(function(slideEl) {
            var progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows(slideEl, progress, isHorizontal);
        });
    };
    var setTranslate = function() {
        var el = swiper.el, wrapperEl = swiper.wrapperEl, slides = swiper.slides, swiperWidth = swiper.width, swiperHeight = swiper.height, rtl = swiper.rtlTranslate, swiperSize = swiper.size, browser = swiper.browser;
        var r = (0, _utilsMjs.o)(swiper);
        var params = swiper.params.cubeEffect;
        var isHorizontal = swiper.isHorizontal();
        var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        var wrapperRotate = 0;
        var cubeShadowEl;
        if (params.shadow) {
            if (isHorizontal) {
                cubeShadowEl = swiper.wrapperEl.querySelector('.swiper-cube-shadow');
                if (!cubeShadowEl) {
                    cubeShadowEl = (0, _utilsMjs.c)('div', 'swiper-cube-shadow');
                    swiper.wrapperEl.append(cubeShadowEl);
                }
                cubeShadowEl.style.height = `${swiperWidth}px`;
            } else {
                cubeShadowEl = el.querySelector('.swiper-cube-shadow');
                if (!cubeShadowEl) {
                    cubeShadowEl = (0, _utilsMjs.c)('div', 'swiper-cube-shadow');
                    el.append(cubeShadowEl);
                }
            }
        }
        for(var i = 0; i < slides.length; i += 1){
            var slideEl = slides[i];
            var slideIndex = i;
            if (isVirtual) slideIndex = parseInt(slideEl.getAttribute('data-swiper-slide-index'), 10);
            var slideAngle = slideIndex * 90;
            var round = Math.floor(slideAngle / 360);
            if (rtl) {
                slideAngle = -slideAngle;
                round = Math.floor(-slideAngle / 360);
            }
            var progress = Math.max(Math.min(slideEl.progress, 1), -1);
            var tx = 0;
            var ty = 0;
            var tz = 0;
            if (slideIndex % 4 === 0) {
                tx = -round * 4 * swiperSize;
                tz = 0;
            } else if ((slideIndex - 1) % 4 === 0) {
                tx = 0;
                tz = -round * 4 * swiperSize;
            } else if ((slideIndex - 2) % 4 === 0) {
                tx = swiperSize + round * 4 * swiperSize;
                tz = swiperSize;
            } else if ((slideIndex - 3) % 4 === 0) {
                tx = -swiperSize;
                tz = 3 * swiperSize + swiperSize * 4 * round;
            }
            if (rtl) tx = -tx;
            if (!isHorizontal) {
                ty = tx;
                tx = 0;
            }
            var transform = `rotateX(${r(isHorizontal ? 0 : -slideAngle)}deg) rotateY(${r(isHorizontal ? slideAngle : 0)}deg) translate3d(${tx}px, ${ty}px, ${tz}px)`;
            if (progress <= 1 && progress > -1) {
                wrapperRotate = slideIndex * 90 + progress * 90;
                if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
            }
            slideEl.style.transform = transform;
            if (params.slideShadows) createSlideShadows(slideEl, progress, isHorizontal);
        }
        wrapperEl.style.transformOrigin = `50% 50% -${swiperSize / 2}px`;
        wrapperEl.style['-webkit-transform-origin'] = `50% 50% -${swiperSize / 2}px`;
        if (params.shadow) {
            if (isHorizontal) cubeShadowEl.style.transform = `translate3d(0px, ${swiperWidth / 2 + params.shadowOffset}px, ${-swiperWidth / 2}px) rotateX(89.99deg) rotateZ(0deg) scale(${params.shadowScale})`;
            else {
                var shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
                var multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
                var scale1 = params.shadowScale;
                var scale2 = params.shadowScale / multiplier;
                var offset = params.shadowOffset;
                cubeShadowEl.style.transform = `scale3d(${scale1}, 1, ${scale2}) translate3d(0px, ${swiperHeight / 2 + offset}px, ${-swiperHeight / 2 / scale2}px) rotateX(-89.99deg)`;
            }
        }
        var zFactor = (browser.isSafari || browser.isWebView) && browser.needPerspectiveFix ? -swiperSize / 2 : 0;
        wrapperEl.style.transform = `translate3d(0px,0,${zFactor}px) rotateX(${r(swiper.isHorizontal() ? 0 : wrapperRotate)}deg) rotateY(${r(swiper.isHorizontal() ? -wrapperRotate : 0)}deg)`;
        wrapperEl.style.setProperty('--swiper-cube-translate-z', `${zFactor}px`);
    };
    var setTransition = function(duration) {
        var el = swiper.el, slides = swiper.slides;
        slides.forEach(function(slideEl) {
            slideEl.style.transitionDuration = `${duration}ms`;
            slideEl.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach(function(subEl) {
                subEl.style.transitionDuration = `${duration}ms`;
            });
        });
        if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
            var shadowEl = el.querySelector('.swiper-cube-shadow');
            if (shadowEl) shadowEl.style.transitionDuration = `${duration}ms`;
        }
    };
    (0, _effectInitMjs.e)({
        effect: 'cube',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: function() {
            return swiper.params.cubeEffect;
        },
        perspective: function() {
            return true;
        },
        overwriteParams: function() {
            return {
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                resistanceRatio: 0,
                spaceBetween: 0,
                centeredSlides: false,
                virtualTranslate: true
            };
        }
    });
}

},{"../shared/effect-init.mjs":"6vQR2","../shared/utils.mjs":"7Cawp","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"kVRbP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return EffectFlip;
});
var _createShadowMjs = require("../shared/create-shadow.mjs");
var _effectInitMjs = require("../shared/effect-init.mjs");
var _effectTargetMjs = require("../shared/effect-target.mjs");
var _effectVirtualTransitionEndMjs = require("../shared/effect-virtual-transition-end.mjs");
var _utilsMjs = require("../shared/utils.mjs");
function EffectFlip(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, on = _ref.on;
    extendParams({
        flipEffect: {
            slideShadows: true,
            limitRotation: true
        }
    });
    var createSlideShadows = function(slideEl, progress) {
        var shadowBefore = swiper.isHorizontal() ? slideEl.querySelector('.swiper-slide-shadow-left') : slideEl.querySelector('.swiper-slide-shadow-top');
        var shadowAfter = swiper.isHorizontal() ? slideEl.querySelector('.swiper-slide-shadow-right') : slideEl.querySelector('.swiper-slide-shadow-bottom');
        if (!shadowBefore) shadowBefore = (0, _createShadowMjs.c)('flip', slideEl, swiper.isHorizontal() ? 'left' : 'top');
        if (!shadowAfter) shadowAfter = (0, _createShadowMjs.c)('flip', slideEl, swiper.isHorizontal() ? 'right' : 'bottom');
        if (shadowBefore) shadowBefore.style.opacity = Math.max(-progress, 0);
        if (shadowAfter) shadowAfter.style.opacity = Math.max(progress, 0);
    };
    var recreateShadows = function() {
        // Set shadows
        swiper.params.flipEffect;
        swiper.slides.forEach(function(slideEl) {
            var progress = slideEl.progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows(slideEl, progress);
        });
    };
    var setTranslate = function() {
        var slides = swiper.slides, rtl = swiper.rtlTranslate;
        var params = swiper.params.flipEffect;
        var rotateFix = (0, _utilsMjs.o)(swiper);
        for(var i = 0; i < slides.length; i += 1){
            var slideEl = slides[i];
            var progress = slideEl.progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min(slideEl.progress, 1), -1);
            var offset = slideEl.swiperSlideOffset;
            var rotate = -180 * progress;
            var rotateY = rotate;
            var rotateX = 0;
            var tx = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            var ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
                rotateX = -rotateY;
                rotateY = 0;
            } else if (rtl) rotateY = -rotateY;
            slideEl.style.zIndex = -Math.abs(Math.round(progress)) + slides.length;
            if (params.slideShadows) createSlideShadows(slideEl, progress);
            var transform = `translate3d(${tx}px, ${ty}px, 0px) rotateX(${rotateFix(rotateX)}deg) rotateY(${rotateFix(rotateY)}deg)`;
            var targetEl = (0, _effectTargetMjs.e)(params, slideEl);
            targetEl.style.transform = transform;
        }
    };
    var setTransition = function(duration) {
        var transformElements = swiper.slides.map(function(slideEl) {
            return (0, _utilsMjs.g)(slideEl);
        });
        transformElements.forEach(function(el) {
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach(function(shadowEl) {
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, _effectVirtualTransitionEndMjs.e)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements
        });
    };
    (0, _effectInitMjs.e)({
        effect: 'flip',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: function() {
            return swiper.params.flipEffect;
        },
        perspective: function() {
            return true;
        },
        overwriteParams: function() {
            return {
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            };
        }
    });
}

},{"../shared/create-shadow.mjs":"agHIK","../shared/effect-init.mjs":"6vQR2","../shared/effect-target.mjs":"mrhtm","../shared/effect-virtual-transition-end.mjs":"5Mqrb","../shared/utils.mjs":"7Cawp","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"agHIK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "c", function() {
    return createShadow;
});
var _utilsMjs = require("./utils.mjs");
function createShadow(suffix, slideEl, side) {
    var shadowClass = `swiper-slide-shadow${side ? `-${side}` : ''}${suffix ? ` swiper-slide-shadow-${suffix}` : ''}`;
    var shadowContainer = (0, _utilsMjs.g)(slideEl);
    var shadowEl = shadowContainer.querySelector(`.${shadowClass.split(' ').join('.')}`);
    if (!shadowEl) {
        shadowEl = (0, _utilsMjs.c)('div', shadowClass.split(' '));
        shadowContainer.append(shadowEl);
    }
    return shadowEl;
}

},{"./utils.mjs":"7Cawp","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"15Uag":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return EffectCoverflow;
});
var _createShadowMjs = require("../shared/create-shadow.mjs");
var _effectInitMjs = require("../shared/effect-init.mjs");
var _effectTargetMjs = require("../shared/effect-target.mjs");
var _utilsMjs = require("../shared/utils.mjs");
function EffectCoverflow(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, on = _ref.on;
    extendParams({
        coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            scale: 1,
            modifier: 1,
            slideShadows: true
        }
    });
    var setTranslate = function() {
        var swiperWidth = swiper.width, swiperHeight = swiper.height, slides = swiper.slides, slidesSizesGrid = swiper.slidesSizesGrid;
        var params = swiper.params.coverflowEffect;
        var isHorizontal = swiper.isHorizontal();
        var transform = swiper.translate;
        var center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
        var rotate = isHorizontal ? params.rotate : -params.rotate;
        var translate = params.depth;
        var r = (0, _utilsMjs.o)(swiper);
        // Each slide offset from center
        for(var i = 0, length = slides.length; i < length; i += 1){
            var slideEl = slides[i];
            var slideSize = slidesSizesGrid[i];
            var slideOffset = slideEl.swiperSlideOffset;
            var centerOffset = (center - slideOffset - slideSize / 2) / slideSize;
            var offsetMultiplier = typeof params.modifier === 'function' ? params.modifier(centerOffset) : centerOffset * params.modifier;
            var rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
            var rotateX = isHorizontal ? 0 : rotate * offsetMultiplier;
            // var rotateZ = 0
            var translateZ = -translate * Math.abs(offsetMultiplier);
            var stretch = params.stretch;
            // Allow percentage to make a relative stretch for responsive sliders
            if (typeof stretch === 'string' && stretch.indexOf('%') !== -1) stretch = parseFloat(params.stretch) / 100 * slideSize;
            var translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
            var translateX = isHorizontal ? stretch * offsetMultiplier : 0;
            var scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier);
            // Fix for ultra small values
            if (Math.abs(translateX) < 0.001) translateX = 0;
            if (Math.abs(translateY) < 0.001) translateY = 0;
            if (Math.abs(translateZ) < 0.001) translateZ = 0;
            if (Math.abs(rotateY) < 0.001) rotateY = 0;
            if (Math.abs(rotateX) < 0.001) rotateX = 0;
            if (Math.abs(scale) < 0.001) scale = 0;
            var slideTransform = `translate3d(${translateX}px,${translateY}px,${translateZ}px)  rotateX(${r(rotateX)}deg) rotateY(${r(rotateY)}deg) scale(${scale})`;
            var targetEl = (0, _effectTargetMjs.e)(params, slideEl);
            targetEl.style.transform = slideTransform;
            slideEl.style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
            if (params.slideShadows) {
                // Set shadows
                var shadowBeforeEl = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-left') : slideEl.querySelector('.swiper-slide-shadow-top');
                var shadowAfterEl = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-right') : slideEl.querySelector('.swiper-slide-shadow-bottom');
                if (!shadowBeforeEl) shadowBeforeEl = (0, _createShadowMjs.c)('coverflow', slideEl, isHorizontal ? 'left' : 'top');
                if (!shadowAfterEl) shadowAfterEl = (0, _createShadowMjs.c)('coverflow', slideEl, isHorizontal ? 'right' : 'bottom');
                if (shadowBeforeEl) shadowBeforeEl.style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
                if (shadowAfterEl) shadowAfterEl.style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
            }
        }
    };
    var setTransition = function(duration) {
        var transformElements = swiper.slides.map(function(slideEl) {
            return (0, _utilsMjs.g)(slideEl);
        });
        transformElements.forEach(function(el) {
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach(function(shadowEl) {
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
    };
    (0, _effectInitMjs.e)({
        effect: 'coverflow',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: function() {
            return true;
        },
        overwriteParams: function() {
            return {
                watchSlidesProgress: true
            };
        }
    });
}

},{"../shared/create-shadow.mjs":"agHIK","../shared/effect-init.mjs":"6vQR2","../shared/effect-target.mjs":"mrhtm","../shared/utils.mjs":"7Cawp","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"pNNAI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return EffectCreative;
});
var _createShadowMjs = require("../shared/create-shadow.mjs");
var _effectInitMjs = require("../shared/effect-init.mjs");
var _effectTargetMjs = require("../shared/effect-target.mjs");
var _effectVirtualTransitionEndMjs = require("../shared/effect-virtual-transition-end.mjs");
var _utilsMjs = require("../shared/utils.mjs");
function EffectCreative(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, on = _ref.on;
    extendParams({
        creativeEffect: {
            limitProgress: 1,
            shadowPerProgress: false,
            progressMultiplier: 1,
            perspective: true,
            prev: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            },
            next: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            }
        }
    });
    var getTranslateValue = function(value) {
        if (typeof value === 'string') return value;
        return `${value}px`;
    };
    var setTranslate = function() {
        var _loop = function(i) {
            var slideEl = slides[i];
            var slideProgress = slideEl.progress;
            var progress = Math.min(Math.max(slideEl.progress, -params.limitProgress), params.limitProgress);
            var originalProgress = progress;
            if (!isCenteredSlides) originalProgress = Math.min(Math.max(slideEl.originalProgress, -params.limitProgress), params.limitProgress);
            var offset = slideEl.swiperSlideOffset;
            var t = [
                swiper.params.cssMode ? -offset - swiper.translate : -offset,
                0,
                0
            ];
            var r = [
                0,
                0,
                0
            ];
            var custom = false;
            if (!swiper.isHorizontal()) {
                t[1] = t[0];
                t[0] = 0;
            }
            var data = {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                scale: 1,
                opacity: 1
            };
            if (progress < 0) {
                data = params.next;
                custom = true;
            } else if (progress > 0) {
                data = params.prev;
                custom = true;
            }
            // set translate
            t.forEach(function(value, index) {
                t[index] = `calc(${value}px + (${getTranslateValue(data.translate[index])} * ${Math.abs(progress * multiplier)}))`;
            });
            // set rotates
            r.forEach(function(value, index) {
                var val = data.rotate[index] * Math.abs(progress * multiplier);
                r[index] = val;
            });
            slideEl.style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            var translateString = t.join(', ');
            var rotateString = `rotateX(${rotateFix(r[0])}deg) rotateY(${rotateFix(r[1])}deg) rotateZ(${rotateFix(r[2])}deg)`;
            var scaleString = originalProgress < 0 ? `scale(${1 + (1 - data.scale) * originalProgress * multiplier})` : `scale(${1 - (1 - data.scale) * originalProgress * multiplier})`;
            var opacityString = originalProgress < 0 ? 1 + (1 - data.opacity) * originalProgress * multiplier : 1 - (1 - data.opacity) * originalProgress * multiplier;
            var transform = `translate3d(${translateString}) ${rotateString} ${scaleString}`;
            // Set shadows
            if (custom && data.shadow || !custom) {
                var shadowEl = slideEl.querySelector('.swiper-slide-shadow');
                if (!shadowEl && data.shadow) shadowEl = (0, _createShadowMjs.c)('creative', slideEl);
                if (shadowEl) {
                    var shadowOpacity = params.shadowPerProgress ? progress * (1 / params.limitProgress) : progress;
                    shadowEl.style.opacity = Math.min(Math.max(Math.abs(shadowOpacity), 0), 1);
                }
            }
            var targetEl = (0, _effectTargetMjs.e)(params, slideEl);
            targetEl.style.transform = transform;
            targetEl.style.opacity = opacityString;
            if (data.origin) targetEl.style.transformOrigin = data.origin;
        };
        var slides = swiper.slides, wrapperEl = swiper.wrapperEl, slidesSizesGrid = swiper.slidesSizesGrid;
        var params = swiper.params.creativeEffect;
        var multiplier = params.progressMultiplier;
        var isCenteredSlides = swiper.params.centeredSlides;
        var rotateFix = (0, _utilsMjs.o)(swiper);
        if (isCenteredSlides) {
            var margin = slidesSizesGrid[0] / 2 - swiper.params.slidesOffsetBefore || 0;
            wrapperEl.style.transform = `translateX(calc(50% - ${margin}px))`;
        }
        for(var i = 0; i < slides.length; i += 1)_loop(i);
    };
    var setTransition = function(duration) {
        var transformElements = swiper.slides.map(function(slideEl) {
            return (0, _utilsMjs.g)(slideEl);
        });
        transformElements.forEach(function(el) {
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll('.swiper-slide-shadow').forEach(function(shadowEl) {
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, _effectVirtualTransitionEndMjs.e)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements,
            allSlides: true
        });
    };
    (0, _effectInitMjs.e)({
        effect: 'creative',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: function() {
            return swiper.params.creativeEffect.perspective;
        },
        overwriteParams: function() {
            return {
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            };
        }
    });
}

},{"../shared/create-shadow.mjs":"agHIK","../shared/effect-init.mjs":"6vQR2","../shared/effect-target.mjs":"mrhtm","../shared/effect-virtual-transition-end.mjs":"5Mqrb","../shared/utils.mjs":"7Cawp","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gC8Gv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", function() {
    return EffectCards;
});
var _createShadowMjs = require("../shared/create-shadow.mjs");
var _effectInitMjs = require("../shared/effect-init.mjs");
var _effectTargetMjs = require("../shared/effect-target.mjs");
var _effectVirtualTransitionEndMjs = require("../shared/effect-virtual-transition-end.mjs");
var _utilsMjs = require("../shared/utils.mjs");
function EffectCards(_ref) {
    var swiper = _ref.swiper, extendParams = _ref.extendParams, on = _ref.on;
    extendParams({
        cardsEffect: {
            slideShadows: true,
            rotate: true,
            perSlideRotate: 2,
            perSlideOffset: 8
        }
    });
    var setTranslate = function() {
        var slides = swiper.slides, activeIndex = swiper.activeIndex, rtl = swiper.rtlTranslate;
        var params = swiper.params.cardsEffect;
        var _swiper_touchEventsData = swiper.touchEventsData, startTranslate = _swiper_touchEventsData.startTranslate, isTouched = _swiper_touchEventsData.isTouched;
        var currentTranslate = rtl ? -swiper.translate : swiper.translate;
        for(var i = 0; i < slides.length; i += 1){
            var slideEl = slides[i];
            var slideProgress = slideEl.progress;
            var progress = Math.min(Math.max(slideProgress, -4), 4);
            var offset = slideEl.swiperSlideOffset;
            if (swiper.params.centeredSlides && !swiper.params.cssMode) swiper.wrapperEl.style.transform = `translateX(${swiper.minTranslate()}px)`;
            if (swiper.params.centeredSlides && swiper.params.cssMode) offset -= slides[0].swiperSlideOffset;
            var tX = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            var tY = 0;
            var tZ = -100 * Math.abs(progress);
            var scale = 1;
            var rotate = -params.perSlideRotate * progress;
            var tXAdd = params.perSlideOffset - Math.abs(progress) * 0.75;
            var slideIndex = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.from + i : i;
            var isSwipeToNext = (slideIndex === activeIndex || slideIndex === activeIndex - 1) && progress > 0 && progress < 1 && (isTouched || swiper.params.cssMode) && currentTranslate < startTranslate;
            var isSwipeToPrev = (slideIndex === activeIndex || slideIndex === activeIndex + 1) && progress < 0 && progress > -1 && (isTouched || swiper.params.cssMode) && currentTranslate > startTranslate;
            if (isSwipeToNext || isSwipeToPrev) {
                var subProgress = Math.pow(1 - Math.abs((Math.abs(progress) - 0.5) / 0.5), 0.5);
                rotate += -28 * progress * subProgress;
                scale += -0.5 * subProgress;
                tXAdd += 96 * subProgress;
                tY = `${-25 * subProgress * Math.abs(progress)}%`;
            }
            if (progress < 0) // next
            tX = `calc(${tX}px ${rtl ? '-' : '+'} (${tXAdd * Math.abs(progress)}%))`;
            else if (progress > 0) // prev
            tX = `calc(${tX}px ${rtl ? '-' : '+'} (-${tXAdd * Math.abs(progress)}%))`;
            else tX = `${tX}px`;
            if (!swiper.isHorizontal()) {
                var prevY = tY;
                tY = tX;
                tX = prevY;
            }
            var scaleString = progress < 0 ? `${1 + (1 - scale) * progress}` : `${1 - (1 - scale) * progress}`;
            /* eslint-disable */ var transform = `
        translate3d(${tX}, ${tY}, ${tZ}px)
        rotateZ(${params.rotate ? rtl ? -rotate : rotate : 0}deg)
        scale(${scaleString})
      `;
            /* eslint-enable */ if (params.slideShadows) {
                // Set shadows
                var shadowEl = slideEl.querySelector('.swiper-slide-shadow');
                if (!shadowEl) shadowEl = (0, _createShadowMjs.c)('cards', slideEl);
                if (shadowEl) shadowEl.style.opacity = Math.min(Math.max((Math.abs(progress) - 0.5) / 0.5, 0), 1);
            }
            slideEl.style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            var targetEl = (0, _effectTargetMjs.e)(params, slideEl);
            targetEl.style.transform = transform;
        }
    };
    var setTransition = function(duration) {
        var transformElements = swiper.slides.map(function(slideEl) {
            return (0, _utilsMjs.g)(slideEl);
        });
        transformElements.forEach(function(el) {
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll('.swiper-slide-shadow').forEach(function(shadowEl) {
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, _effectVirtualTransitionEndMjs.e)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements
        });
    };
    (0, _effectInitMjs.e)({
        effect: 'cards',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: function() {
            return true;
        },
        overwriteParams: function() {
            return {
                _loopSwapReset: false,
                watchSlidesProgress: true,
                loopAdditionalSlides: swiper.params.cardsEffect.rotate ? 3 : 2,
                centeredSlides: true,
                virtualTranslate: !swiper.params.cssMode
            };
        }
    });
}

},{"../shared/create-shadow.mjs":"agHIK","../shared/effect-init.mjs":"6vQR2","../shared/effect-target.mjs":"mrhtm","../shared/effect-virtual-transition-end.mjs":"5Mqrb","../shared/utils.mjs":"7Cawp","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"iRHYx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FreeShippingProgress", function() {
    return FreeShippingProgress;
});
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _reactRedux = require("react-redux");
var _freeShippingProgressView = require("../view/freeShippingProgressView");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _price = require("../../../../script/src/std/price");
function FreeShippingProgress() {
    var _this = this;
    var view = (0, _reactRedux.useSelector)((0, _freeShippingProgressView.freeShippingProgressView));
    if (!view) return null;
    var headerContent = function() {
        var remaining = view.targetTotalPrice - view.currentTotalPrice;
        if (remaining > 0) return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _jsxDevRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                    children: "Compl\xe9tez pour la livraison gratuite"
                }, void 0, false, {
                    fileName: "src/snippets/components/cart/liquid/freeShippingProgress.tsx",
                    lineNumber: 18,
                    columnNumber: 21
                }, _this),
                /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                    children: [
                        (0, _price.formatPrice)(remaining),
                        " restant"
                    ]
                }, void 0, true, {
                    fileName: "src/snippets/components/cart/liquid/freeShippingProgress.tsx",
                    lineNumber: 19,
                    columnNumber: 21
                }, _this)
            ]
        }, void 0, true);
        return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
            children: "Livraison offerte\xa0!"
        }, void 0, false, {
            fileName: "src/snippets/components/cart/liquid/freeShippingProgress.tsx",
            lineNumber: 24,
            columnNumber: 13
        }, _this);
    };
    var shippingCost = function() {
        return view.estimatedShippingPrice === 0 ? 'Offerts' : (0, _price.formatPrice)(view.estimatedShippingPrice);
    };
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
        className: "componentCart__freeShippingProgress",
        children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
            className: "componentCart__freeShippingProgress__container",
            children: [
                /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                    className: "componentCart__freeShippingProgress__header",
                    children: headerContent()
                }, void 0, false, {
                    fileName: "src/snippets/components/cart/liquid/freeShippingProgress.tsx",
                    lineNumber: 35,
                    columnNumber: 17
                }, this),
                /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                    className: "componentCart__freeShippingProgress__progressBar",
                    style: {
                        '--progress': view.currentTotalPrice / view.targetTotalPrice
                    }
                }, void 0, false, {
                    fileName: "src/snippets/components/cart/liquid/freeShippingProgress.tsx",
                    lineNumber: 36,
                    columnNumber: 17
                }, this),
                /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                    className: "componentCart__freeShippingProgress__footer",
                    children: [
                        /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                            children: "Frais de livraison estim\xe9s"
                        }, void 0, false, {
                            fileName: "src/snippets/components/cart/liquid/freeShippingProgress.tsx",
                            lineNumber: 40,
                            columnNumber: 21
                        }, this),
                        /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                            children: shippingCost()
                        }, void 0, false, {
                            fileName: "src/snippets/components/cart/liquid/freeShippingProgress.tsx",
                            lineNumber: 41,
                            columnNumber: 21
                        }, this)
                    ]
                }, void 0, true, {
                    fileName: "src/snippets/components/cart/liquid/freeShippingProgress.tsx",
                    lineNumber: 39,
                    columnNumber: 17
                }, this)
            ]
        }, void 0, true, {
            fileName: "src/snippets/components/cart/liquid/freeShippingProgress.tsx",
            lineNumber: 34,
            columnNumber: 13
        }, this)
    }, void 0, false, {
        fileName: "src/snippets/components/cart/liquid/freeShippingProgress.tsx",
        lineNumber: 33,
        columnNumber: 9
    }, this);
}

},{"react/jsx-dev-runtime":"jXZ8I","react-redux":"ghMZu","../view/freeShippingProgressView":"ky5ya","react":"c8CN1","../../../../script/src/std/price":"bpfMV","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"ky5ya":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "freeShippingProgressView", function() {
    return freeShippingProgressView;
});
var _std = require("@reglo/std");
var _reselect = require("reselect");
var _cartPriceSelector = require("../selectors/cartPriceSelector");
var _state = require("../state");
var _variants = require("../../../../script/src/app/store/state/data/variants");
var freeShippingProgressView = (0, _reselect.createSelector)((0, _state.cartSelector), (0, _variants.variantsSelector), prepareView);
function prepareView(cartState, variantsState) {
    if (isLoading()) return null;
    return {
        targetTotalPrice: prepareTotalTarget(),
        currentTotalPrice: prepareTotalCurrent(),
        estimatedShippingPrice: prepareEstimatedShippingPrice()
    };
    function isLoading() {
        return cartState.loading || variantsState.loading;
    }
    function prepareTotalTarget() {
        return settings.shipping__minimum * 100;
    }
    function prepareTotalCurrent() {
        var prices = (0, _cartPriceSelector.cartPriceSelector)(cartState, variantsState);
        return (0, _std.unwrap)(prices === null || prices === void 0 ? void 0 : prices.itemsTotalPrice);
    }
    function prepareEstimatedShippingPrice() {
        var prices = (0, _cartPriceSelector.cartPriceSelector)(cartState, variantsState);
        return (0, _std.unwrap)(prices === null || prices === void 0 ? void 0 : prices.shippingPrice);
    }
}

},{"@reglo/std":"1USo0","reselect":"fb6q1","../selectors/cartPriceSelector":"icBq9","../state":"1HyQc","../../../../script/src/app/store/state/data/variants":"11hc8","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"k5u85":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SubscriptionItems", function() {
    return SubscriptionItems;
});
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _reactRedux = require("react-redux");
var _cartView = require("../view/cartView");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _item = require("./item");
var _select = require("../../select");
var _std = require("@reglo/std");
var _changeAllCartSubscriptionFrequency = require("../useCases/changeAllCartSubscriptionFrequency");
function SubscriptionItems() {
    var _this = this;
    var view = (0, _reactRedux.useSelector)((0, _cartView.cartView));
    var dispatch = (0, _reactRedux.useDispatch)();
    if (!view) return null;
    var subscriptionItems = view.items.filter(function(item) {
        return !!item.isSubscription;
    });
    var doesntHaveSubscriptionItems = subscriptionItems.length === 0;
    var productCount = subscriptionItems.reduce(function(count, item) {
        return count + item.quantity;
    }, 0);
    var hasNotDeletedItems = subscriptionItems.filter(function(item) {
        return !item.deleted;
    }).length > 0;
    if (doesntHaveSubscriptionItems) return null;
    function prepareLabel(option, type) {
        var isMonthlyFrequency = option.frequencyInWeeks % 4 === 0;
        return (type === 'full' ? 'Livraison ' + (isMonthlyFrequency ? 'tous' : 'toutes') + ' les ' : '') + (isMonthlyFrequency ? option.frequencyInWeeks / 4 : option.frequencyInWeeks) + (isMonthlyFrequency ? ' mois' : ' semaines') + (option.mostChosen ? ' (le plus choisi)' : '');
    }
    function selectSubscriptionPlan(frequencyInWeeks) {
        dispatch((0, _changeAllCartSubscriptionFrequency.ChangeAllCartSubscriptionFrequency)({
            frequencyInWeeks: frequencyInWeeks
        }));
    }
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
        className: "componentCart__subscriptionItems",
        children: [
            hasNotDeletedItems && /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                className: "componentCart__subscriptionItems__header",
                children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                    className: "componentCart__subscriptionItems__title",
                    children: "Abonnement sans engagement"
                }, void 0, false, {
                    fileName: "src/snippets/components/cart/liquid/subscriptionItems.tsx",
                    lineNumber: 41,
                    columnNumber: 17
                }, this)
            }, void 0, false, {
                fileName: "src/snippets/components/cart/liquid/subscriptionItems.tsx",
                lineNumber: 40,
                columnNumber: 36
            }, this),
            subscriptionItems.map(function(item, index) {
                return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _item.Item), {
                    view: item,
                    last: index === subscriptionItems.length - 1
                }, item.key, false, {
                    fileName: "src/snippets/components/cart/liquid/subscriptionItems.tsx",
                    lineNumber: 43,
                    columnNumber: 53
                }, _this);
            }),
            hasNotDeletedItems && /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                className: "componentCart__subscriptionItems__frequency",
                children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _select.NumberSelect), {
                    options: view.frequencyOptions.map(function(option) {
                        return {
                            value: option.frequencyInWeeks,
                            label: prepareLabel(option, 'full'),
                            shortLabel: prepareLabel(option, 'short')
                        };
                    }),
                    value: (0, _std.unwrap)(view.selectedFrequency),
                    onChange: selectSubscriptionPlan,
                    className: "componentCart__subscriptionItems__frequency__select"
                }, void 0, false, {
                    fileName: "src/snippets/components/cart/liquid/subscriptionItems.tsx",
                    lineNumber: 49,
                    columnNumber: 17
                }, this)
            }, void 0, false, {
                fileName: "src/snippets/components/cart/liquid/subscriptionItems.tsx",
                lineNumber: 48,
                columnNumber: 36
            }, this)
        ]
    }, void 0, true, {
        fileName: "src/snippets/components/cart/liquid/subscriptionItems.tsx",
        lineNumber: 39,
        columnNumber: 9
    }, this);
}

},{"react/jsx-dev-runtime":"jXZ8I","react-redux":"ghMZu","../view/cartView":"6eowi","react":"c8CN1","./item":"7oieR","../../select":"fqaEu","@reglo/std":"1USo0","../useCases/changeAllCartSubscriptionFrequency":"gJIad","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7oieR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Item", function() {
    return Item;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _cartView = require("../view/cartView");
var _hooks = require("../../../../script/src/std/hooks");
var _price = require("../../../../script/src/std/price");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useShopifyAsset = require("../../../../script/src/dom/hooks/useShopifyAsset");
var _reactRedux = require("react-redux");
var _select = require("../../select");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
function Item(props) {
    var view = props.view;
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _jsxDevRuntime.Fragment), {
        children: [
            view.deleted ? /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(DeletedItem, {
                view: view
            }, void 0, false, {
                fileName: "src/snippets/components/cart/liquid/item.tsx",
                lineNumber: 18,
                columnNumber: 29
            }, this) : /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(ExistingItem, {
                view: view
            }, void 0, false, {
                fileName: "src/snippets/components/cart/liquid/item.tsx",
                lineNumber: 18,
                columnNumber: 58
            }, this),
            !props.last && /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                className: "separator"
            }, void 0, false, {
                fileName: "src/snippets/components/cart/liquid/item.tsx",
                lineNumber: 19,
                columnNumber: 29
            }, this)
        ]
    }, void 0, true);
}
function DeletedItem(props) {
    var view = props.view;
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
        className: "deleted-item",
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("a", {
                href: view.url,
                children: [
                    view.productTitle,
                    " - ",
                    view.variantTitle
                ]
            }, void 0, true, {
                fileName: "src/snippets/components/cart/liquid/item.tsx",
                lineNumber: 31,
                columnNumber: 13
            }, this),
            " a \xe9t\xe9 supprim\xe9 de votre panier."
        ]
    }, void 0, true, {
        fileName: "src/snippets/components/cart/liquid/item.tsx",
        lineNumber: 30,
        columnNumber: 9
    }, this);
}
function ExistingItem(props) {
    var parentView = (0, _reactRedux.useSelector)((0, _cartView.cartView));
    var dispatch = (0, _hooks.useDispatch)();
    var shopifyAsset = (0, _useShopifyAsset.useShopifyAsset)();
    if (!parentView) return null;
    var view = props.view;
    var isQuantityDisabled = view.maximumQuantity === 1;
    var defaultQuantityOptions = Array.from({
        length: view.maxQuantitySelector
    }, function(_, i) {
        return i + 1;
    });
    var quantityOptions = view.quantity > view.maxQuantitySelector ? (0, _toConsumableArray._)(defaultQuantityOptions).concat([
        view.quantity
    ]) : defaultQuantityOptions;
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
        className: "item",
        children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
            className: "item__infoContainer",
            children: [
                /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                    className: "item__pictureContainer",
                    children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("img", {
                        src: view.picture
                    }, void 0, false, {
                        fileName: "src/snippets/components/cart/liquid/item.tsx",
                        lineNumber: 56,
                        columnNumber: 21
                    }, this)
                }, void 0, false, {
                    fileName: "src/snippets/components/cart/liquid/item.tsx",
                    lineNumber: 55,
                    columnNumber: 17
                }, this),
                /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                    className: "item__title",
                    children: view.productTitle
                }, void 0, false, {
                    fileName: "src/snippets/components/cart/liquid/item.tsx",
                    lineNumber: 58,
                    columnNumber: 17
                }, this),
                view.price > 0 && /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                    className: "item__price",
                    children: [
                        view.originalPrice > view.price && /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                            className: "item__price__original",
                            children: (0, _price.formatPrice)(view.originalPrice)
                        }, void 0, false, {
                            fileName: "src/snippets/components/cart/liquid/item.tsx",
                            lineNumber: 61,
                            columnNumber: 25
                        }, this),
                        /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                            className: "item__price__current",
                            children: (0, _price.formatPrice)(view.price)
                        }, void 0, false, {
                            fileName: "src/snippets/components/cart/liquid/item.tsx",
                            lineNumber: 63,
                            columnNumber: 21
                        }, this)
                    ]
                }, void 0, true, {
                    fileName: "src/snippets/components/cart/liquid/item.tsx",
                    lineNumber: 59,
                    columnNumber: 36
                }, this),
                /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                    className: "item__detail",
                    children: (0, _toConsumableArray._)(view.productSubtitle ? [
                        view.productSubtitle
                    ] : []).concat([
                        view.variantTitle.replace(/ /g, "\xa0")
                    ]).join(' - ')
                }, void 0, false, {
                    fileName: "src/snippets/components/cart/liquid/item.tsx",
                    lineNumber: 65,
                    columnNumber: 17
                }, this),
                !isQuantityDisabled && /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _select.NumberSelect), {
                    className: "item__quantitySelector",
                    options: quantityOptions.map(function(option) {
                        var bulkDiscount = view.bulkDiscount.sort(function(a, b) {
                            return b.minQuantity - a.minQuantity;
                        }).find(function(discount) {
                            return option >= discount.minQuantity;
                        });
                        var bulkDiscountText = bulkDiscount ? ` (-${bulkDiscount.discount}%)` : '';
                        return {
                            value: option,
                            label: `${option}`,
                            shortLabel: `${option}${bulkDiscountText}`
                        };
                    }),
                    value: view.quantity,
                    onChange: function(quantity) {
                        return dispatch(view.actions.updateQuantity(quantity));
                    }
                }, void 0, false, {
                    fileName: "src/snippets/components/cart/liquid/item.tsx",
                    lineNumber: 68,
                    columnNumber: 41
                }, this),
                /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("img", {
                    className: "item__removeCta",
                    src: shopifyAsset('component/cart/bin.svg'),
                    onClick: function() {
                        return dispatch(view.actions.remove);
                    }
                }, void 0, false, {
                    fileName: "src/snippets/components/cart/liquid/item.tsx",
                    lineNumber: 84,
                    columnNumber: 17
                }, this),
                /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("button", {
                    className: "item__subscriptionToggle",
                    onClick: function() {
                        return dispatch(view.actions.toggleSubscription);
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                            className: (0, _classnamesDefault.default)({
                                'item__subscriptionToggle__checkbox': true,
                                'item__subscriptionToggle__checkbox--checked': view.isSubscription
                            })
                        }, void 0, false, {
                            fileName: "src/snippets/components/cart/liquid/item.tsx",
                            lineNumber: 90,
                            columnNumber: 21
                        }, this),
                        /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                            children: [
                                "Abonnement flexible (-",
                                settings.subscription__discount,
                                "%)"
                            ]
                        }, void 0, true, {
                            fileName: "src/snippets/components/cart/liquid/item.tsx",
                            lineNumber: 94,
                            columnNumber: 21
                        }, this)
                    ]
                }, void 0, true, {
                    fileName: "src/snippets/components/cart/liquid/item.tsx",
                    lineNumber: 89,
                    columnNumber: 17
                }, this)
            ]
        }, void 0, true, {
            fileName: "src/snippets/components/cart/liquid/item.tsx",
            lineNumber: 54,
            columnNumber: 13
        }, this)
    }, void 0, false, {
        fileName: "src/snippets/components/cart/liquid/item.tsx",
        lineNumber: 53,
        columnNumber: 9
    }, this);
}

},{"@swc/helpers/_/_to_consumable_array":"eqNDD","react/jsx-dev-runtime":"jXZ8I","../view/cartView":"6eowi","../../../../script/src/std/hooks":"j9RPQ","../../../../script/src/std/price":"bpfMV","react":"c8CN1","../../../../script/src/dom/hooks/useShopifyAsset":"aJ4wV","react-redux":"ghMZu","../../select":"fqaEu","classnames":"4SuBi","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7WMeQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OneTimeItems", function() {
    return OneTimeItems;
});
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _reactRedux = require("react-redux");
var _cartView = require("../view/cartView");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _item = require("./item");
function OneTimeItems() {
    var _this = this;
    var view = (0, _reactRedux.useSelector)((0, _cartView.cartView));
    if (!view) return null;
    var oneTimeItems = view.items.filter(function(item) {
        return !item.isSubscription;
    });
    var doesntHaveOneTimeItems = oneTimeItems.length === 0;
    if (doesntHaveOneTimeItems) return null;
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
        className: "componentCart__oneTimeItems",
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                className: "componentCart__oneTimeItems__header",
                children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                    className: "componentCart__oneTimeItems__title",
                    children: "Achats hors abonnement"
                }, void 0, false, {
                    fileName: "src/snippets/components/cart/liquid/oneTimeItems.tsx",
                    lineNumber: 23,
                    columnNumber: 17
                }, this)
            }, void 0, false, {
                fileName: "src/snippets/components/cart/liquid/oneTimeItems.tsx",
                lineNumber: 22,
                columnNumber: 13
            }, this),
            oneTimeItems.map(function(item, index) {
                return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _item.Item), {
                    view: item,
                    last: index === oneTimeItems.length - 1
                }, item.key, false, {
                    fileName: "src/snippets/components/cart/liquid/oneTimeItems.tsx",
                    lineNumber: 25,
                    columnNumber: 48
                }, _this);
            })
        ]
    }, void 0, true, {
        fileName: "src/snippets/components/cart/liquid/oneTimeItems.tsx",
        lineNumber: 21,
        columnNumber: 9
    }, this);
}

},{"react/jsx-dev-runtime":"jXZ8I","react-redux":"ghMZu","../view/cartView":"6eowi","react":"c8CN1","./item":"7oieR","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"9eUl5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cartDeps", function() {
    return cartDeps;
});
var _updateCartItems = require("./updateCartItems");
var _retrieveCartItems = require("./retrieveCartItems");
function cartDeps(deps) {
    return {
        retrieveCartItems: (0, _retrieveCartItems.retrieveCartItems)(deps),
        updateCartItems: (0, _updateCartItems.updateCartItems)(deps)
    };
}

},{"./updateCartItems":"df1zm","./retrieveCartItems":"e6MOL","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"df1zm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "updateCartItems", function() {
    return updateCartItems;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toArray = require("@swc/helpers/_/_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _state = require("../state");
var _std = require("@reglo/std");
function updateCartItems(deps) {
    return /*#__PURE__*/ (0, _asyncToGenerator._)(function() {
        var _len, updates, _key, initialCart, cart;
        var _arguments = arguments;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    for(_len = _arguments.length, updates = new Array(_len), _key = 0; _key < _len; _key++){
                        updates[_key] = _arguments[_key];
                    }
                    return [
                        4,
                        deps.request.getRequest('/cart.js')
                    ];
                case 1:
                    initialCart = _state.sent();
                    return [
                        4,
                        applyUpdates(updates, initialCart)
                    ];
                case 2:
                    cart = _state.sent();
                    return [
                        2,
                        prepareResponse(initialCart, cart, updates)
                    ];
            }
        });
    });
    function prepareResponse(initialCart, cart, updates) {
        var items = (0, _toConsumableArray._)(cart.items).reverse().map(function(item) {
            var _item_selling_plan_allocation, _item_selling_plan_allocation1;
            var _item_selling_plan_allocation_selling_plan_id;
            return {
                key: item.key,
                variantId: item.variant_id,
                quantity: item.quantity,
                subscriptionSelected: !!((_item_selling_plan_allocation = item.selling_plan_allocation) === null || _item_selling_plan_allocation === void 0 ? void 0 : _item_selling_plan_allocation.selling_plan.id),
                subscriptionPlanId: (_item_selling_plan_allocation_selling_plan_id = (_item_selling_plan_allocation1 = item.selling_plan_allocation) === null || _item_selling_plan_allocation1 === void 0 ? void 0 : _item_selling_plan_allocation1.selling_plan.id) !== null && _item_selling_plan_allocation_selling_plan_id !== void 0 ? _item_selling_plan_allocation_selling_plan_id : null,
                removed: false
            };
        });
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var _step_value = (0, _slicedToArray._)(_step.value, 2), index = _step_value[0], item = _step_value[1];
                var hasBeenRemoved = updates.filter(isRemoveUpdate).find(function(update) {
                    return update.key === item.key;
                });
                if (hasBeenRemoved) items = (0, _std.insertAt)(items, index, (0, _objectSpreadProps._)((0, _objectSpread._)({}, item), {
                    removed: true
                }));
            };
            for(var _iterator = deps.getState((0, _state.activeCartItemsSelector)).entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return items;
    }
    function isRemoveUpdate(update) {
        return update.type === 'Remove';
    }
    function applyUpdates(updates, cart) {
        return _applyUpdates.apply(this, arguments);
    }
    function _applyUpdates() {
        _applyUpdates = (0, _asyncToGenerator._)(function(updates, cart) {
            var _updates, update, nextUpdates, updatedCart;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (updates.length === 0) return [
                            2,
                            cart
                        ];
                        _updates = (0, _toArray._)(updates), update = _updates[0], nextUpdates = _updates.slice(1);
                        return [
                            4,
                            applyUpdate(update, cart)
                        ];
                    case 1:
                        updatedCart = _state.sent();
                        return [
                            2,
                            applyUpdates(nextUpdates, updatedCart)
                        ];
                }
            });
        });
        return _applyUpdates.apply(this, arguments);
    }
    function applyUpdate(update, cart) {
        return _applyUpdate.apply(this, arguments);
    }
    function _applyUpdate() {
        _applyUpdate = (0, _asyncToGenerator._)(function(update, cart) {
            return (0, _tsGenerator._)(this, function(_state) {
                switch(update.type){
                    case 'Empty':
                        return [
                            2,
                            emptyCart(cart)
                        ];
                    case 'Add':
                        return [
                            2,
                            addItem(update, cart)
                        ];
                    case 'UpdateQuantity':
                        return [
                            2,
                            updateQuantity(update)
                        ];
                    case 'UpdateSubscription':
                        return [
                            2,
                            updateSubscription(update)
                        ];
                    case 'Remove':
                        return [
                            2,
                            removeItem(update)
                        ];
                }
                return [
                    2
                ];
            });
        });
        return _applyUpdate.apply(this, arguments);
    }
    function emptyCart(cart) {
        return _emptyCart.apply(this, arguments);
    }
    function _emptyCart() {
        _emptyCart = (0, _asyncToGenerator._)(function(cart) {
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(cart.items.length > 0)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            deps.request.postRequest('/cart/clear.js', {})
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            2,
                            (0, _objectSpreadProps._)((0, _objectSpread._)({}, cart), {
                                items: []
                            })
                        ];
                }
            });
        });
        return _emptyCart.apply(this, arguments);
    }
    function updateQuantity(update) {
        return _updateQuantity.apply(this, arguments);
    }
    function _updateQuantity() {
        _updateQuantity = (0, _asyncToGenerator._)(function(update) {
            return (0, _tsGenerator._)(this, function(_state) {
                return [
                    2,
                    deps.request.postWithResponse('/cart/change.js', {
                        id: update.key,
                        quantity: update.quantity
                    })
                ];
            });
        });
        return _updateQuantity.apply(this, arguments);
    }
    function updateSubscription(update) {
        return _updateSubscription.apply(this, arguments);
    }
    function _updateSubscription() {
        _updateSubscription = (0, _asyncToGenerator._)(function(update) {
            return (0, _tsGenerator._)(this, function(_state) {
                return [
                    2,
                    deps.request.postWithResponse('/cart/change.js', {
                        id: update.key,
                        selling_plan: update.subscriptionPlanId
                    })
                ];
            });
        });
        return _updateSubscription.apply(this, arguments);
    }
    function addItem(update, cart) {
        return _addItem.apply(this, arguments);
    }
    function _addItem() {
        _addItem = (0, _asyncToGenerator._)(function(update, cart) {
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            deps.request.postWithResponse('/cart/add.js', {
                                items: [
                                    {
                                        id: update.variantId,
                                        selling_plan: update.subscriptionPlanId,
                                        quantity: update.quantity
                                    }
                                ]
                            }).then(function(response) {
                                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, cart), {
                                    items: (0, _toConsumableArray._)(response.items).concat((0, _toConsumableArray._)(cart.items))
                                });
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return _addItem.apply(this, arguments);
    }
    function removeItem(update) {
        return _removeItem.apply(this, arguments);
    }
    function _removeItem() {
        _removeItem = (0, _asyncToGenerator._)(function(update) {
            return (0, _tsGenerator._)(this, function(_state) {
                return [
                    2,
                    deps.request.postWithResponse('/cart/update.js', {
                        updates: (0, _defineProperty._)({}, update.key, 0)
                    })
                ];
            });
        });
        return _removeItem.apply(this, arguments);
    }
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_define_property":"54Zvk","@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_object_spread_props":"fLCYP","@swc/helpers/_/_sliced_to_array":"ha6sq","@swc/helpers/_/_to_array":"wdLug","@swc/helpers/_/_to_consumable_array":"eqNDD","@swc/helpers/_/_ts_generator":"f2hGH","../state":"1HyQc","@reglo/std":"1USo0","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"e6MOL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "retrieveCartItems", function() {
    return retrieveCartItems;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
function retrieveCartItems(deps) {
    return /*#__PURE__*/ (0, _asyncToGenerator._)(function() {
        var data;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        deps.request.getRequest('/cart.js')
                    ];
                case 1:
                    data = _state.sent();
                    return [
                        2,
                        data.items.map(function(item, index) {
                            var _item_selling_plan_allocation, _item_selling_plan_allocation1;
                            var _item_selling_plan_allocation_selling_plan_id;
                            return {
                                key: item.key,
                                variantId: item.variant_id,
                                subscriptionSelected: !!((_item_selling_plan_allocation = item.selling_plan_allocation) === null || _item_selling_plan_allocation === void 0 ? void 0 : _item_selling_plan_allocation.selling_plan.id),
                                subscriptionPlanId: (_item_selling_plan_allocation_selling_plan_id = (_item_selling_plan_allocation1 = item.selling_plan_allocation) === null || _item_selling_plan_allocation1 === void 0 ? void 0 : _item_selling_plan_allocation1.selling_plan.id) !== null && _item_selling_plan_allocation_selling_plan_id !== void 0 ? _item_selling_plan_allocation_selling_plan_id : null,
                                quantity: item.quantity,
                                removed: false
                            };
                        }).slice().reverse()
                    ];
            }
        });
    });
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_ts_generator":"f2hGH","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jAqmR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cartHandlers", function() {
    return cartHandlers;
});
var _openCartWithContent = require("../useCases/openCartWithContent");
var _removeCartItem = require("../useCases/removeCartItem");
var _changeCartItemQuantity = require("../useCases/changeCartItemQuantity");
var _changeItemSubscriptionPlanInCart = require("../useCases/changeItemSubscriptionPlanInCart");
var _addProductToCart = require("../useCases/addProductToCart");
var _loadCart = require("../useCases/loadCart");
var _changeAllCartSubscriptionFrequency = require("../useCases/changeAllCartSubscriptionFrequency");
function cartHandlers(param) {
    var eventBus = param.eventBus, deps = param.deps;
    eventBus.subscribeTo((0, _loadCart.LoadCartKey), (0, _loadCart.loadCart)(deps));
    eventBus.subscribeTo((0, _addProductToCart.AddProductToCartKey), (0, _addProductToCart.addProductToCart)(deps));
    eventBus.subscribeTo((0, _removeCartItem.RemoveCartItemKey), (0, _removeCartItem.removeCartItem)(deps));
    eventBus.subscribeTo((0, _changeCartItemQuantity.ChangeCartItemQuantityKey), (0, _changeCartItemQuantity.changeCartItemQuantity)(deps));
    eventBus.subscribeTo((0, _openCartWithContent.OpenCartWithContentKey), (0, _openCartWithContent.openCartWithContent)(deps));
    eventBus.subscribeTo((0, _changeItemSubscriptionPlanInCart.ChangeItemSubscriptionPlanInCartKey), (0, _changeItemSubscriptionPlanInCart.changeSubscriptionPlanInCart)(deps));
    eventBus.subscribeTo((0, _changeAllCartSubscriptionFrequency.ChangeAllCartSubscriptionFrequencyKey), (0, _changeAllCartSubscriptionFrequency.changeAllItemsSubscriptionFrequencyInCart)(deps));
}

},{"../useCases/openCartWithContent":"eaTox","../useCases/removeCartItem":"32Oeg","../useCases/changeCartItemQuantity":"b69iv","../useCases/changeItemSubscriptionPlanInCart":"d0Ejd","../useCases/addProductToCart":"bC9NF","../useCases/loadCart":"3fYue","../useCases/changeAllCartSubscriptionFrequency":"gJIad","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3oAoW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LinkTracking", function() {
    return LinkTracking;
});
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _domElement = require("../../../script/src/dom/library/DomElement");
var _domArray = require("../../../script/src/dom/library/DomArray");
var _domComponent = require("../../../script/src/dom/library/DomComponent");
var _useTrack = require("../../../script/src/dom/hooks/useTrack");
function LinkTracking() {
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domArray.DomArray), {
        selector: "[href]",
        child: function(param) {
            var key = param.key, selector = param.selector;
            return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(Link, {
                selector: selector
            }, key, false, {
                fileName: "src/snippets/components/linkTracking/index.tsx",
                lineNumber: 9,
                columnNumber: 67
            }, void 0);
        }
    }, void 0, false, {
        fileName: "src/snippets/components/linkTracking/index.tsx",
        lineNumber: 9,
        columnNumber: 9
    }, this);
}
function Link(props) {
    var selector = props.selector;
    var sectionId = (0, _domElement.useSectionId)(selector);
    var href = (0, _domElement.useNullableAttributeValue)('href', selector);
    var track = (0, _useTrack.useTrack)();
    function onClick() {
        track('ClickLink', {
            sectionId: sectionId,
            href: href
        });
    }
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
        selector: selector,
        onClick: onClick
    }, void 0, false, {
        fileName: "src/snippets/components/linkTracking/index.tsx",
        lineNumber: 26,
        columnNumber: 9
    }, this);
}

},{"react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","../../../script/src/dom/library/DomElement":"15N7Q","../../../script/src/dom/library/DomArray":"ZEl1X","../../../script/src/dom/library/DomComponent":"8H9za","../../../script/src/dom/hooks/useTrack":"iL2dq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"490fV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProductSelectionPanels", function() {
    return ProductSelectionPanels;
});
parcelHelpers.export(exports, "ProductSelectionPanel", function() {
    return ProductSelectionPanel;
});
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _domComponent = require("../../../../script/src/dom/library/DomComponent");
var _domArray = require("../../../../script/src/dom/library/DomArray");
var _inPagePanel = require("./inPagePanel");
var _stickyPanel = require("./stickyPanel");
var _hooks = require("../../../../script/src/std/hooks");
var _initPanel = require("../useCases/initPanel");
var _domElement = require("../../../../script/src/dom/library/DomElement");
function ProductSelectionPanels() {
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domArray.DomArray), {
        selector: "[data-component=productSelectionPanel]",
        child: function(param) {
            var key = param.key, selector = param.selector;
            return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
                selector: selector,
                children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(ProductSelectionPanel, {
                    componentId: key
                }, void 0, false, {
                    fileName: "src/snippets/components/productSelectionPanel/liquid/index.tsx",
                    lineNumber: 22,
                    columnNumber: 13
                }, void 0)
            }, key, false, {
                fileName: "src/snippets/components/productSelectionPanel/liquid/index.tsx",
                lineNumber: 21,
                columnNumber: 99
            }, void 0);
        }
    }, void 0, false, {
        fileName: "src/snippets/components/productSelectionPanel/liquid/index.tsx",
        lineNumber: 21,
        columnNumber: 9
    }, this);
}
function ProductSelectionPanel(props) {
    var dispatch = (0, _hooks.useDispatch)();
    var productIds = useProductIds();
    var selectedProductId = (0, _domElement.useNumberAttributeValue)('data-selected_product_id');
    var selectedVariantId = (0, _domElement.useNumberAttributeValue)('data-selected_variant_id');
    var subscriptionIsSelected = (0, _domElement.useBooleanAttributeValue)('data-subscription_is_selected');
    var selectedSubscriptionPlanId = (0, _domElement.useNumberAttributeValue)('data-selected_subscription_plan_id');
    var withProductSelection = (0, _domElement.useBooleanAttributeValue)('data-with_product_selection');
    var withVariantSelection = (0, _domElement.useBooleanAttributeValue)('data-with_variant_selection');
    var withFrequencySelection = (0, _domElement.useBooleanAttributeValue)('data-with_frequency_selection');
    var settings = (0, _domElement.useJsonAttributeValue)('data-settings');
    function useProductIds() {
        var productIds = (0, _domElement.useAttributeValue)('data-product_ids');
        return productIds.split(',').map(Number);
    }
    (0, _react.useEffect)(function() {
        dispatch((0, _initPanel.InitPanel)({
            componentId: props.componentId,
            productIds: productIds,
            selectedProductId: selectedProductId,
            selectedVariantId: selectedVariantId,
            subscriptionIsSelected: subscriptionIsSelected,
            selectedSubscriptionPlanId: selectedSubscriptionPlanId
        }));
    }, []);
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _jsxDevRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _inPagePanel.InPagePanel), {
                componentId: props.componentId,
                settings: settings,
                withProductSelection: withProductSelection,
                withVariantSelection: withVariantSelection,
                withFrequencySelection: withFrequencySelection
            }, void 0, false, {
                fileName: "src/snippets/components/productSelectionPanel/liquid/index.tsx",
                lineNumber: 59,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _stickyPanel.StickyPanel), {
                componentId: props.componentId,
                withProductSelection: withProductSelection,
                withVariantSelection: withVariantSelection
            }, void 0, false, {
                fileName: "src/snippets/components/productSelectionPanel/liquid/index.tsx",
                lineNumber: 66,
                columnNumber: 13
            }, this)
        ]
    }, void 0, true);
}

},{"react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","../../../../script/src/dom/library/DomComponent":"8H9za","../../../../script/src/dom/library/DomArray":"ZEl1X","./inPagePanel":"9DXG3","./stickyPanel":"gN041","../../../../script/src/std/hooks":"j9RPQ","../useCases/initPanel":"2dj7J","../../../../script/src/dom/library/DomElement":"15N7Q","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"9DXG3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InPagePanel", function() {
    return InPagePanel;
});
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _hooks = require("../../../../script/src/std/hooks");
var _panelView = require("../views/panelView");
var _domComponent = require("../../../../script/src/dom/library/DomComponent");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _variantSelectors = require("./variantSelectors");
var _frequencySelector = require("./frequencySelector");
var _productSelectors = require("./productSelectors");
var _rationGuide = require("./rationGuide");
var _dogSizeVariantSelectors = require("./dogSizeVariantSelectors");
var _bundleSelectors = require("./bundleSelectors");
var _cta = require("./cta");
function InPagePanel(props) {
    var view = (0, _hooks.useSelector)(function(state) {
        return (0, _panelView.panelView)(state, props.componentId);
    });
    var dispatch = (0, _hooks.useDispatch)();
    if (!view) return null;
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
        selector: "[data-id=inPagePanel]",
        children: [
            props.withProductSelection && /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _productSelectors.ProductSelectors), {
                componentId: props.componentId,
                source: "inPage"
            }, void 0, false, {
                fileName: "src/snippets/components/productSelectionPanel/liquid/inPagePanel.tsx",
                lineNumber: 32,
                columnNumber: 44
            }, this),
            props.withVariantSelection && /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _variantSelectors.VariantSelectors), {
                componentId: props.componentId,
                source: "inPage"
            }, void 0, false, {
                fileName: "src/snippets/components/productSelectionPanel/liquid/inPagePanel.tsx",
                lineNumber: 33,
                columnNumber: 44
            }, this),
            props.withFrequencySelection && /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _frequencySelector.FrequencySelector), {
                componentId: props.componentId,
                settings: props.settings
            }, void 0, false, {
                fileName: "src/snippets/components/productSelectionPanel/liquid/inPagePanel.tsx",
                lineNumber: 34,
                columnNumber: 46
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _dogSizeVariantSelectors.DogSizeVariantSelectors), {
                componentId: props.componentId,
                source: "inPage"
            }, void 0, false, {
                fileName: "src/snippets/components/productSelectionPanel/liquid/inPagePanel.tsx",
                lineNumber: 35,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _bundleSelectors.BundleSelectors), {
                componentId: props.componentId,
                source: "inPage"
            }, void 0, false, {
                fileName: "src/snippets/components/productSelectionPanel/liquid/inPagePanel.tsx",
                lineNumber: 36,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _rationGuide.RationGuide), {}, void 0, false, {
                fileName: "src/snippets/components/productSelectionPanel/liquid/inPagePanel.tsx",
                lineNumber: 37,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _cta.Cta), {
                componentId: props.componentId
            }, void 0, false, {
                fileName: "src/snippets/components/productSelectionPanel/liquid/inPagePanel.tsx",
                lineNumber: 38,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
                selector: "[data-id=estimatedDelivery]",
                text: view.estimatedDelivery
            }, void 0, false, {
                fileName: "src/snippets/components/productSelectionPanel/liquid/inPagePanel.tsx",
                lineNumber: 39,
                columnNumber: 13
            }, this)
        ]
    }, void 0, true, {
        fileName: "src/snippets/components/productSelectionPanel/liquid/inPagePanel.tsx",
        lineNumber: 31,
        columnNumber: 9
    }, this);
}

},{"react/jsx-dev-runtime":"jXZ8I","../../../../script/src/std/hooks":"j9RPQ","../views/panelView":"jRtEY","../../../../script/src/dom/library/DomComponent":"8H9za","react":"c8CN1","./variantSelectors":"84wND","./frequencySelector":"2s7eE","./productSelectors":"5sYHL","./rationGuide":"4kXD5","./dogSizeVariantSelectors":"a9AMM","./bundleSelectors":"cRV1J","./cta":"4wTD1","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jRtEY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "panelView", function() {
    return panelView;
});
var _variants = require("../../../../script/src/app/store/state/data/variants");
var _std = require("@reglo/std");
var _computeSelectionPrice = require("../../../../script/src/app/views/services/computeSelectionPrice");
var _addProductToCart = require("../../cart/useCases/addProductToCart");
var _selectedSubscriptionPlanSelector = require("../../cart/selectors/selectedSubscriptionPlanSelector");
var _state = require("../../cart/state");
var _reReselect = require("re-reselect");
var _state1 = require("../state");
var _selectOneTimePurchase = require("../useCases/selectOneTimePurchase");
var _selectSubscriptionPurchase = require("../useCases/selectSubscriptionPurchase");
var _selectQuantity = require("../useCases/selectQuantity");
var _selectSubscriptionPlan = require("../useCases/SelectSubscriptionPlan");
var _selectedVariantSelector = require("../selectors/selectedVariantSelector");
var panelView = (0, _reReselect.createCachedSelector)(function(state, componentId) {
    return componentId;
}, (0, _state1.productSelectionPanelSelector), (0, _variants.variantsSelector), (0, _selectedVariantSelector.selectedVariantSelector), (0, _state.cartSelector), prepareView)(function(state, componentId) {
    return componentId;
});
function prepareView(componentId, panelState, variantsState, selectedVariant, cartState) {
    if (isLoading()) return null;
    return {
        totalPrice: prepareTotalPrice(),
        totalPriceWithoutSubscription: prepareTotalPriceWithoutSubscription(),
        totalPriceWithSubscription: prepareTotalPriceWithSubscription(),
        itemOriginalPrice: prepareOriginalPrice(),
        itemPriceWithSubscription: preparePriceSubscription(),
        itemPriceWithoutSubscription: preparePriceWithoutSubscription(),
        itemPriceWithoutSubscriptionAndQuantity: preparePriceWithoutSubscriptionAndQuantity(),
        allowSubscription: prepareAllowSubscription(),
        selectedVariantId: (0, _std.unwrap)(selectedVariant).variantId,
        subscriptionIsSelected: prepareSubscriptionIsSelected(),
        selectedSubscriptionPlanId: (0, _std.unwrap)(panelState).selectedSubscriptionPlanId,
        quantity: (0, _std.unwrap)(panelState).quantity,
        actions: prepareActions(),
        estimatedDelivery: prepareEstimatedDelivery()
    };
    function isLoading() {
        return !panelState || cartState.loading || variantsState.loading;
    }
    function prepareEstimatedDelivery() {
        return (0, _std.unwrap)(selectedVariant).estimatedDelivery;
    }
    function prepareAllowSubscription() {
        return !(0, _std.unwrap)(selectedVariant).isSample;
    }
    function prepareSubscriptionIsSelected() {
        return (0, _std.unwrap)(panelState).subscriptionIsSelected;
    }
    function prepareActions() {
        return {
            selectOneTimePurchase: (0, _selectOneTimePurchase.SelectOneTimePurchase)({
                componentId: componentId
            }),
            selectSubscriptionPurchase: (0, _selectSubscriptionPurchase.SelectSubscriptionPurchase)({
                componentId: componentId
            }),
            addToCartWithoutSubscriptionAndQuantity: prepareAddToCartAction(false, false),
            addToCartWithSelection: prepareAddToCartAction('currentSelection', true),
            addOneTimeToCart: prepareAddToCartAction(false, true),
            addSubscriptionToCart: prepareAddToCartAction(true, true),
            selectSubscriptionPlan: function(subscriptionPlanId) {
                return (0, _selectSubscriptionPlan.SelectSubscriptionPlan)({
                    componentId: componentId,
                    subscriptionPlanId: subscriptionPlanId
                });
            },
            selectQuantity: function(quantity) {
                return (0, _selectQuantity.SelectQuantity)({
                    componentId: componentId,
                    quantity: quantity
                });
            }
        };
    }
    function prepareOriginalPrice() {
        return (0, _computeSelectionPrice.computeSelectionPrice)(variantsState, (0, _std.unwrap)(selectedVariant).variantId, (0, _std.unwrap)(panelState).quantity).original;
    }
    function prepareTotalPrice() {
        var prices = (0, _computeSelectionPrice.computeSelectionPrice)(variantsState, (0, _std.unwrap)(selectedVariant).variantId, (0, _std.unwrap)(panelState).quantity);
        var itemPrice = (0, _std.unwrap)(panelState).subscriptionIsSelected ? prices.withSubscription : prices.withoutSubscription;
        return itemPrice * (0, _std.unwrap)(panelState).quantity;
    }
    function prepareTotalPriceWithoutSubscription() {
        var prices = (0, _computeSelectionPrice.computeSelectionPrice)(variantsState, (0, _std.unwrap)(selectedVariant).variantId, (0, _std.unwrap)(panelState).quantity);
        return prices.withoutSubscription * (0, _std.unwrap)(panelState).quantity;
    }
    function prepareTotalPriceWithSubscription() {
        var prices = (0, _computeSelectionPrice.computeSelectionPrice)(variantsState, (0, _std.unwrap)(selectedVariant).variantId, (0, _std.unwrap)(panelState).quantity);
        return prices.withSubscription * (0, _std.unwrap)(panelState).quantity;
    }
    function preparePriceWithoutSubscription() {
        return (0, _computeSelectionPrice.computeSelectionPrice)(variantsState, (0, _std.unwrap)(selectedVariant).variantId, (0, _std.unwrap)(panelState).quantity).withoutSubscription;
    }
    function preparePriceWithoutSubscriptionAndQuantity() {
        return (0, _computeSelectionPrice.computeSelectionPrice)(variantsState, (0, _std.unwrap)(selectedVariant).variantId, 1).withoutSubscription;
    }
    function preparePriceSubscription() {
        return (0, _computeSelectionPrice.computeSelectionPrice)(variantsState, (0, _std.unwrap)(selectedVariant).variantId, (0, _std.unwrap)(panelState).quantity).withSubscription;
    }
    function prepareAddToCartAction(subscription, withQuantity) {
        var subscriptionPlanId = function() {
            var selectedSubscriptionPlanId = (0, _std.unwrap)((0, _selectedSubscriptionPlanSelector.selectedSubscriptionPlanSelector)((0, _std.unwrap)(selectedVariant).variantId, variantsState, cartState)).subscriptionPlanId;
            if (subscription === 'currentSelection' && (0, _std.unwrap)(panelState).subscriptionIsSelected) return selectedSubscriptionPlanId;
            if (subscription === true) return selectedSubscriptionPlanId;
            return null;
        }();
        var quantity = withQuantity ? (0, _std.unwrap)(panelState).quantity : 1;
        return function(source) {
            return (0, _addProductToCart.AddProductToCart)({
                quantity: quantity,
                variantId: (0, _std.unwrap)(selectedVariant).variantId,
                subscriptionPlanId: subscriptionPlanId,
                source: source
            });
        };
    }
}

},{"../../../../script/src/app/store/state/data/variants":"11hc8","@reglo/std":"1USo0","../../../../script/src/app/views/services/computeSelectionPrice":"eDc4K","../../cart/useCases/addProductToCart":"bC9NF","../../cart/selectors/selectedSubscriptionPlanSelector":"dXpbD","../../cart/state":"1HyQc","re-reselect":"fUjlV","../state":"3nAmi","../useCases/selectOneTimePurchase":"edhdS","../useCases/selectSubscriptionPurchase":"f83Xv","../useCases/selectQuantity":"cgyOz","../useCases/SelectSubscriptionPlan":"iwNPe","../selectors/selectedVariantSelector":"5WKmf","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"eDc4K":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "computeSelectionPrice", function() {
    return computeSelectionPrice;
});
var _variants = require("../../store/state/data/variants");
var _std = require("@reglo/std");
function computeSelectionPrice(variantsState, variantId, quantity) {
    return {
        original: prepareOriginalPrice(),
        withSubscription: prepareWithSubscription(),
        withoutSubscription: prepareWithoutSubscription()
    };
    function prepareOriginalPrice() {
        var variant = (0, _std.unwrap)((0, _variants.selectVariantInState)(variantsState, variantId));
        return variant.price.original;
    }
    function prepareWithSubscription() {
        var variant = (0, _std.unwrap)((0, _variants.selectVariantInState)(variantsState, variantId));
        var discount = selectBulkDiscount();
        var _variant_price_subscription;
        return Math.round(((_variant_price_subscription = variant.price.subscription) !== null && _variant_price_subscription !== void 0 ? _variant_price_subscription : 0) * (100 - discount) / 100);
    }
    function prepareWithoutSubscription() {
        var variant = (0, _std.unwrap)((0, _variants.selectVariantInState)(variantsState, variantId));
        var discount = selectBulkDiscount();
        return Math.round(variant.price.oneTime * (100 - discount) / 100);
    }
    function selectBulkDiscount() {
        var variant = (0, _std.unwrap)((0, _variants.selectVariantInState)(variantsState, variantId));
        return variant.bulkDiscount.reduce(function(discount, next) {
            if (quantity >= next.minQuantity && next.discount > discount) return next.discount;
            return discount;
        }, 0);
    }
}

},{"../../store/state/data/variants":"11hc8","@reglo/std":"1USo0","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3nAmi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "productSelectionPanelReducer", function() {
    return productSelectionPanelReducer;
});
parcelHelpers.export(exports, "productSelectionPanelSelector", function() {
    return productSelectionPanelSelector;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _initPanel = require("../useCases/initPanel");
var _selectVariant = require("../useCases/selectVariant");
var _selectQuantity = require("../useCases/selectQuantity");
var _selectOneTimePurchase = require("../useCases/selectOneTimePurchase");
var _selectSubscriptionPurchase = require("../useCases/selectSubscriptionPurchase");
var _selectSubscriptionPlan = require("../useCases/SelectSubscriptionPlan");
var _selectProduct = require("../useCases/selectProduct");
var initialState = {
    panels: {}
};
function productSelectionPanelReducer() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, event = arguments.length > 1 ? arguments[1] : void 0;
    switch(event.type){
        case 0, _initPanel.InitPanelKey:
            return initPanel(event.payload.componentId, {
                productIds: event.payload.productIds,
                selectedProductId: event.payload.selectedProductId,
                selectedVariantId: event.payload.selectedVariantId,
                subscriptionIsSelected: event.payload.subscriptionIsSelected,
                selectedSubscriptionPlanId: event.payload.selectedSubscriptionPlanId,
                quantity: 1
            });
        case 0, _selectProduct.SelectProductKey:
            return updatePanel(event.payload.componentId, function(panel) {
                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, panel), {
                    selectedProductId: event.payload.productId,
                    selectedVariantId: null
                });
            });
        case 0, _selectVariant.SelectVariantKey:
            return updatePanel(event.payload.componentId, function(panel) {
                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, panel), {
                    selectedVariantId: event.payload.variantId
                });
            });
        case 0, _selectQuantity.SelectQuantityKey:
            return updatePanel(event.payload.componentId, function(panel) {
                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, panel), {
                    quantity: event.payload.quantity
                });
            });
        case 0, _selectOneTimePurchase.SelectOneTimePurchaseKey:
            return updatePanel(event.payload.componentId, function(panel) {
                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, panel), {
                    subscriptionIsSelected: false
                });
            });
        case 0, _selectSubscriptionPurchase.SelectSubscriptionPurchaseKey:
            return updatePanel(event.payload.componentId, function(panel) {
                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, panel), {
                    subscriptionIsSelected: true
                });
            });
        case 0, _selectSubscriptionPlan.SelectSubscriptionPlanKey:
            return updatePanel(event.payload.componentId, function(panel) {
                return (0, _objectSpreadProps._)((0, _objectSpread._)({}, panel), {
                    selectedSubscriptionPlanId: event.payload.subscriptionPlanId
                });
            });
        default:
            return state;
    }
    function initPanel(componentId, panel) {
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
            panels: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.panels), (0, _defineProperty._)({}, componentId, panel))
        });
    }
    function updatePanel(componentId, callback) {
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
            panels: (0, _objectSpreadProps._)((0, _objectSpread._)({}, state.panels), (0, _defineProperty._)({}, componentId, callback(state.panels[componentId])))
        });
    }
}
function productSelectionPanelSelector(state, componentId) {
    var _state_components_productSelectionPanel_panels_componentId;
    return (_state_components_productSelectionPanel_panels_componentId = state.components.productSelectionPanel.panels[componentId]) !== null && _state_components_productSelectionPanel_panels_componentId !== void 0 ? _state_components_productSelectionPanel_panels_componentId : null;
}

},{"@swc/helpers/_/_define_property":"54Zvk","@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_object_spread_props":"fLCYP","../useCases/initPanel":"2dj7J","../useCases/selectVariant":"53UOt","../useCases/selectQuantity":"cgyOz","../useCases/selectOneTimePurchase":"edhdS","../useCases/selectSubscriptionPurchase":"f83Xv","../useCases/SelectSubscriptionPlan":"iwNPe","../useCases/selectProduct":"3GtA8","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2dj7J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InitPanelKey", function() {
    return InitPanelKey;
});
parcelHelpers.export(exports, "InitPanel", function() {
    return InitPanel;
});
var _eventFactory = require("../../../../script/src/std/eventFactory");
var InitPanelKey = 'ComponentProductSelectionPanel.InitPanel';
var InitPanel = (0, _eventFactory.eventFactory)(InitPanelKey)();

},{"../../../../script/src/std/eventFactory":"f2PpV","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"53UOt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SelectVariantKey", function() {
    return SelectVariantKey;
});
parcelHelpers.export(exports, "SelectVariant", function() {
    return SelectVariant;
});
var _eventFactory = require("../../../../script/src/std/eventFactory");
var SelectVariantKey = 'ComponentProductSelectionPanel.SelectVariant';
var SelectVariant = (0, _eventFactory.eventFactory)(SelectVariantKey)();

},{"../../../../script/src/std/eventFactory":"f2PpV","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"cgyOz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SelectQuantityKey", function() {
    return SelectQuantityKey;
});
parcelHelpers.export(exports, "SelectQuantity", function() {
    return SelectQuantity;
});
var _eventFactory = require("../../../../script/src/std/eventFactory");
var SelectQuantityKey = 'ComponentProductSelectionPanel.SelectQuantity';
var SelectQuantity = (0, _eventFactory.eventFactory)(SelectQuantityKey)();

},{"../../../../script/src/std/eventFactory":"f2PpV","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"edhdS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SelectOneTimePurchaseKey", function() {
    return SelectOneTimePurchaseKey;
});
parcelHelpers.export(exports, "SelectOneTimePurchase", function() {
    return SelectOneTimePurchase;
});
var _eventFactory = require("../../../../script/src/std/eventFactory");
var SelectOneTimePurchaseKey = 'ComponentProductSelectionPanel.SelectOneTimePurchase';
var SelectOneTimePurchase = (0, _eventFactory.eventFactory)(SelectOneTimePurchaseKey)();

},{"../../../../script/src/std/eventFactory":"f2PpV","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"f83Xv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SelectSubscriptionPurchaseKey", function() {
    return SelectSubscriptionPurchaseKey;
});
parcelHelpers.export(exports, "SelectSubscriptionPurchase", function() {
    return SelectSubscriptionPurchase;
});
var _eventFactory = require("../../../../script/src/std/eventFactory");
var SelectSubscriptionPurchaseKey = 'ProductHero.SelectSubscriptionPurchase';
var SelectSubscriptionPurchase = (0, _eventFactory.eventFactory)(SelectSubscriptionPurchaseKey)();

},{"../../../../script/src/std/eventFactory":"f2PpV","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"iwNPe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SelectSubscriptionPlanKey", function() {
    return SelectSubscriptionPlanKey;
});
parcelHelpers.export(exports, "SelectSubscriptionPlan", function() {
    return SelectSubscriptionPlan;
});
var _eventFactory = require("../../../../script/src/std/eventFactory");
var SelectSubscriptionPlanKey = 'ComponentProductSelectionPanel.SelectSubscriptionPlanKey';
var SelectSubscriptionPlan = (0, _eventFactory.eventFactory)(SelectSubscriptionPlanKey)();

},{"../../../../script/src/std/eventFactory":"f2PpV","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3GtA8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SelectProductKey", function() {
    return SelectProductKey;
});
parcelHelpers.export(exports, "SelectProduct", function() {
    return SelectProduct;
});
var _eventFactory = require("../../../../script/src/std/eventFactory");
var SelectProductKey = 'ComponentProductSelectionPanel.SelectProduct';
var SelectProduct = (0, _eventFactory.eventFactory)(SelectProductKey)();

},{"../../../../script/src/std/eventFactory":"f2PpV","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5WKmf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "selectedVariantSelector", function() {
    return selectedVariantSelector;
});
var _std = require("@reglo/std");
var _variants = require("../../../../script/src/app/store/state/data/variants");
var _state = require("../state");
function selectedVariantSelector(state, componentId) {
    var variantsState = (0, _variants.variantsSelector)(state);
    var panelState = (0, _state.productSelectionPanelSelector)(state, componentId);
    if (isLoading()) return null;
    return selectedVariant();
    function selectedVariant() {
        var _variantsState_entities_find;
        return (_variantsState_entities_find = variantsState.entities.find(function(variant) {
            return variant.variantId === selectedVariantId();
        })) !== null && _variantsState_entities_find !== void 0 ? _variantsState_entities_find : null;
    }
    function selectedVariantId() {
        var currentProductVariantIds = variantsState.entities.filter(function(variant) {
            return variant.productId === (0, _std.unwrap)(panelState).selectedProductId;
        }).map(function(variant) {
            return variant.variantId;
        });
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = currentProductVariantIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var variantId = _step.value;
                if (variantId === (0, _std.unwrap)(panelState).selectedVariantId) return variantId;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return currentProductVariantIds[0];
    }
    function isLoading() {
        if (!panelState) return true;
        return false;
    }
}

},{"@reglo/std":"1USo0","../../../../script/src/app/store/state/data/variants":"11hc8","../state":"3nAmi","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"84wND":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VariantSelectors", function() {
    return VariantSelectors;
});
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _price = require("../../../../script/src/std/price");
var _domComponent = require("../../../../script/src/dom/library/DomComponent");
var _hooks = require("../../../../script/src/std/hooks");
var _variantsView = require("../views/variantsView");
function VariantSelectors(props) {
    var _this = this;
    var view = (0, _hooks.useSelector)(function(state) {
        return (0, _variantsView.variantsView)(state, props.componentId);
    });
    if (!view) return null;
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
        selector: "[data-id=variantSelectors]",
        optional: true,
        children: view.variants.map(function(variant) {
            return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _react.Fragment), {
                children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(VariantSelector, {
                    view: variant,
                    source: props.source
                }, void 0, false, {
                    fileName: "src/snippets/components/productSelectionPanel/liquid/variantSelectors.tsx",
                    lineNumber: 24,
                    columnNumber: 17
                }, _this)
            }, variant.key, false, {
                fileName: "src/snippets/components/productSelectionPanel/liquid/variantSelectors.tsx",
                lineNumber: 23,
                columnNumber: 43
            }, _this);
        })
    }, void 0, false, {
        fileName: "src/snippets/components/productSelectionPanel/liquid/variantSelectors.tsx",
        lineNumber: 22,
        columnNumber: 9
    }, this);
}
function VariantSelector(props) {
    var view = props.view;
    var dispatch = (0, _hooks.useDispatch)();
    var selector = `[data-id=selector][data-variant_id="${view.variantId}"]`;
    function pricePerUnit(unit) {
        return `${(0, _price.formatPrice)(view.pricePerUnit)}/${unit}`;
    }
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
        selector: selector,
        data: {
            selected: view.selected,
            hidden: view.hidden
        },
        onClick: function() {
            return dispatch(view.actions.select(props.source));
        },
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
                selector: "[data-price_per=kg]",
                optional: true,
                text: pricePerUnit('kg')
            }, void 0, false, {
                fileName: "src/snippets/components/productSelectionPanel/liquid/variantSelectors.tsx",
                lineNumber: 51,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
                selector: "[data-price_per=L]",
                optional: true,
                text: pricePerUnit('L')
            }, void 0, false, {
                fileName: "src/snippets/components/productSelectionPanel/liquid/variantSelectors.tsx",
                lineNumber: 52,
                columnNumber: 13
            }, this)
        ]
    }, void 0, true, {
        fileName: "src/snippets/components/productSelectionPanel/liquid/variantSelectors.tsx",
        lineNumber: 43,
        columnNumber: 9
    }, this);
}

},{"react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","../../../../script/src/std/price":"bpfMV","../../../../script/src/dom/library/DomComponent":"8H9za","../../../../script/src/std/hooks":"j9RPQ","../views/variantsView":"d7xAX","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"d7xAX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "variantsView", function() {
    return variantsView;
});
var _variants = require("../../../../script/src/app/store/state/data/variants");
var _std = require("@reglo/std");
var _state = require("../../cart/state");
var _reReselect = require("re-reselect");
var _state1 = require("../state");
var _selectVariant = require("../useCases/selectVariant");
var _selectedVariantSelector = require("../selectors/selectedVariantSelector");
var variantsView = (0, _reReselect.createCachedSelector)(function(state, componentId) {
    return componentId;
}, (0, _state1.productSelectionPanelSelector), (0, _variants.variantsSelector), (0, _selectedVariantSelector.selectedVariantSelector), (0, _state.cartSelector), prepareView)(function(state, componentId) {
    return componentId;
});
function prepareView(componentId, panelState, variantsState, selectedVariant, cartState) {
    if (isLoading()) return null;
    return {
        variants: prepareVariantsViews()
    };
    function isLoading() {
        return !panelState || cartState.loading || variantsState.loading;
    }
    function prepareVariantsViews() {
        return variantsState.entities.filter(function(variant) {
            return (0, _std.unwrap)(panelState).productIds.includes(variant.productId);
        }).filter(function(variant) {
            return !variant.notForSale;
        }).map(function(variant) {
            return prepareVariantView(variant);
        });
    }
    function prepareVariantView(variant) {
        var isSelectable = prepareIsSelectable(variant);
        return {
            key: variant.variantId.toString(),
            variantId: variant.variantId,
            selected: variant.variantId === (0, _std.unwrap)(selectedVariant).variantId,
            hidden: variant.productId !== (0, _std.unwrap)(panelState).selectedProductId,
            isSelectable: isSelectable,
            pricePerUnit: preparePricePerUnit(variant),
            actions: {
                select: function(source) {
                    return isSelectable ? (0, _selectVariant.SelectVariant)({
                        componentId: componentId,
                        variantId: variant.variantId,
                        source: source
                    }) : null;
                }
            }
        };
    }
    function prepareIsSelectable(variant) {
        return !variant.outOfStock;
    }
    function preparePricePerUnit(variant) {
        var price = (0, _std.unwrap)(panelState).subscriptionIsSelected ? (0, _std.unwrap)(variant.price.subscription) : variant.price.oneTime;
        return Math.round(price / selectProductSize(variant));
    }
    function selectProductSize(variant) {
        switch(variant.format.unit){
            case 'kg':
                return variant.format.value;
            case 'L':
                return variant.format.value;
            default:
                return 0;
        }
    }
}

},{"../../../../script/src/app/store/state/data/variants":"11hc8","@reglo/std":"1USo0","../../cart/state":"1HyQc","re-reselect":"fUjlV","../state":"3nAmi","../useCases/selectVariant":"53UOt","../selectors/selectedVariantSelector":"5WKmf","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2s7eE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FrequencySelector", function() {
    return FrequencySelector;
});
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _panelView = require("../views/panelView");
var _hooks = require("../../../../script/src/std/hooks");
var _domComponent = require("../../../../script/src/dom/library/DomComponent");
var _price = require("../../../../script/src/std/price");
function FrequencySelector(props) {
    var view = (0, _hooks.useSelector)(function(state) {
        return (0, _panelView.panelView)(state, props.componentId);
    });
    var dispatch = (0, _hooks.useDispatch)();
    if (!view) return null;
    var oneTimePrice = props.settings.bundleSelectors ? view.totalPriceWithoutSubscription : view.itemPriceWithoutSubscription;
    var subscriptionPrice = props.settings.bundleSelectors ? view.totalPriceWithSubscription : view.itemPriceWithSubscription;
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _jsxDevRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
                selector: "[data-id=oneTimeSelector]",
                onClick: function() {
                    return dispatch(view.actions.selectOneTimePurchase);
                },
                data: {
                    is_selected: !view.subscriptionIsSelected
                },
                children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
                    selector: "[data-id=price]",
                    text: (0, _price.formatPrice)(oneTimePrice)
                }, void 0, false, {
                    fileName: "src/snippets/components/productSelectionPanel/liquid/frequencySelector.tsx",
                    lineNumber: 29,
                    columnNumber: 17
                }, this)
            }, void 0, false, {
                fileName: "src/snippets/components/productSelectionPanel/liquid/frequencySelector.tsx",
                lineNumber: 24,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
                selector: "[data-id=subscriptionSelector]",
                onClick: function() {
                    return dispatch(view.actions.selectSubscriptionPurchase);
                },
                data: {
                    is_selected: view.subscriptionIsSelected
                },
                children: [
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
                        selector: "[data-id=originalPrice]",
                        optional: true,
                        text: (0, _price.formatPrice)(view.itemPriceWithoutSubscription)
                    }, void 0, false, {
                        fileName: "src/snippets/components/productSelectionPanel/liquid/frequencySelector.tsx",
                        lineNumber: 39,
                        columnNumber: 17
                    }, this),
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
                        selector: "[data-id=price]",
                        text: (0, _price.formatPrice)(subscriptionPrice)
                    }, void 0, false, {
                        fileName: "src/snippets/components/productSelectionPanel/liquid/frequencySelector.tsx",
                        lineNumber: 44,
                        columnNumber: 17
                    }, this)
                ]
            }, void 0, true, {
                fileName: "src/snippets/components/productSelectionPanel/liquid/frequencySelector.tsx",
                lineNumber: 34,
                columnNumber: 13
            }, this)
        ]
    }, void 0, true);
}

},{"react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","../views/panelView":"jRtEY","../../../../script/src/std/hooks":"j9RPQ","../../../../script/src/dom/library/DomComponent":"8H9za","../../../../script/src/std/price":"bpfMV","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5sYHL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProductSelectors", function() {
    return ProductSelectors;
});
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _domComponent = require("../../../../script/src/dom/library/DomComponent");
var _productsView = require("../views/productsView");
var _hooks = require("../../../../script/src/std/hooks");
var _dogSizeSelector = require("./dogSizeSelector");
function ProductSelectors(props) {
    var _this = this;
    var view = (0, _hooks.useSelector)(function(state) {
        return (0, _productsView.productsView)(state, props.componentId);
    });
    if (!view) return null;
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
        selector: "[data-id=productSelectors]",
        children: view.products.map(function(product) {
            return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _dogSizeSelector.DogSizeSelector), {
                productId: product.productId,
                selected: product.selected,
                onClick: product.actions.select(props.source)
            }, product.key, false, {
                fileName: "src/snippets/components/productSelectionPanel/liquid/productSelectors.tsx",
                lineNumber: 21,
                columnNumber: 43
            }, _this);
        })
    }, void 0, false, {
        fileName: "src/snippets/components/productSelectionPanel/liquid/productSelectors.tsx",
        lineNumber: 20,
        columnNumber: 9
    }, this);
}

},{"react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","../../../../script/src/dom/library/DomComponent":"8H9za","../views/productsView":"6ueef","../../../../script/src/std/hooks":"j9RPQ","./dogSizeSelector":"7f0iS","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6ueef":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "productsView", function() {
    return productsView;
});
var _products = require("../../../../script/src/app/store/state/data/products");
var _std = require("@reglo/std");
var _state = require("../../cart/state");
var _reReselect = require("re-reselect");
var _state1 = require("../state");
var _selectProduct = require("../useCases/selectProduct");
var productsView = (0, _reReselect.createCachedSelector)(function(state, componentId) {
    return componentId;
}, (0, _state1.productSelectionPanelSelector), (0, _products.productsSelector), (0, _state.cartSelector), prepareView)(function(state, componentId) {
    return componentId;
});
function prepareView(componentId, panelState, productsState, cartState) {
    if (isLoading()) return null;
    return {
        products: prepareProductsViews()
    };
    function isLoading() {
        return !panelState || !panelState.selectedProductId || cartState.loading || productsState.loading;
    }
    function prepareProductsViews() {
        return (0, _std.unwrap)(panelState).productIds.map(function(productId) {
            return prepareProductView(productId);
        });
    }
    function prepareProductView(productId) {
        return {
            key: productId.toString(),
            productId: productId,
            selected: productId === (0, _std.unwrap)(panelState).selectedProductId,
            actions: {
                select: function(source) {
                    return (0, _selectProduct.SelectProduct)({
                        componentId: componentId,
                        productId: productId,
                        source: source
                    });
                }
            }
        };
    }
}

},{"../../../../script/src/app/store/state/data/products":"17rrh","@reglo/std":"1USo0","../../cart/state":"1HyQc","re-reselect":"fUjlV","../state":"3nAmi","../useCases/selectProduct":"3GtA8","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7f0iS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DogSizeSelector", function() {
    return DogSizeSelector;
});
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _domComponent = require("../../../../script/src/dom/library/DomComponent");
var _hooks = require("../../../../script/src/std/hooks");
function DogSizeSelector(props) {
    var dispatch = (0, _hooks.useDispatch)();
    var _props_productId;
    var entityId = (_props_productId = props.productId) !== null && _props_productId !== void 0 ? _props_productId : props.variantId;
    var selector = `[data-id=selector][data-entity_id="${entityId}"]`;
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
        selector: selector,
        data: {
            selected: props.selected
        },
        onClick: function() {
            return dispatch(props.onClick);
        }
    }, void 0, false, {
        fileName: "src/snippets/components/productSelectionPanel/liquid/dogSizeSelector.tsx",
        lineNumber: 18,
        columnNumber: 9
    }, this);
}

},{"react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","../../../../script/src/dom/library/DomComponent":"8H9za","../../../../script/src/std/hooks":"j9RPQ","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4kXD5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RationGuide", function() {
    return RationGuide;
});
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _liquid = require("../../modal/liquid");
var _domComponent = require("../../../../script/src/dom/library/DomComponent");
function RationGuide() {
    var modalRef = (0, _liquid.useModalRef)();
    var openModal = function() {
        console.log('open');
        modalRef.current.open();
    };
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
        optional: true,
        selector: "[data-id=rationGuide]",
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
                selector: "[data-id=open]",
                onClick: openModal
            }, void 0, false, {
                fileName: "src/snippets/components/productSelectionPanel/liquid/rationGuide.tsx",
                lineNumber: 16,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _liquid.Modal), {
                ref: modalRef,
                dataId: "modal"
            }, void 0, false, {
                fileName: "src/snippets/components/productSelectionPanel/liquid/rationGuide.tsx",
                lineNumber: 17,
                columnNumber: 13
            }, this)
        ]
    }, void 0, true, {
        fileName: "src/snippets/components/productSelectionPanel/liquid/rationGuide.tsx",
        lineNumber: 15,
        columnNumber: 9
    }, this);
}

},{"react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","../../modal/liquid":"9Dsm1","../../../../script/src/dom/library/DomComponent":"8H9za","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"9Dsm1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useModalRef", function() {
    return useModalRef;
});
parcelHelpers.export(exports, "Modal", function() {
    return Modal;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _domComponent = require("../../../../script/src/dom/library/DomComponent");
var _hooks = require("../../../../script/src/std/hooks");
var _this = undefined;
var useModalRef = function() {
    return (0, _react.useRef)({
        open: function() {}
    });
};
var Modal = /*#__PURE__*/ (0, _react.forwardRef)(function(props, ref) {
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), isOpen = _useState[0], setIsOpen = _useState[1];
    (0, _hooks.usePreventBackgroundScroll)(isOpen);
    (0, _react.useImperativeHandle)(ref, function() {
        return {
            open: open
        };
    });
    function open() {
        setIsOpen(true);
    }
    function close() {
        setIsOpen(false);
    }
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
        selector: `[data-id=${props.dataId}]`,
        data: {
            is_open: isOpen
        },
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
                selector: "[data-id=overlay]",
                onClick: close
            }, void 0, false, {
                fileName: "src/snippets/components/modal/liquid/index.tsx",
                lineNumber: 34,
                columnNumber: 13
            }, _this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
                selector: "[data-id=content]",
                onClick: function(e) {
                    return e.stopPropagation();
                }
            }, void 0, false, {
                fileName: "src/snippets/components/modal/liquid/index.tsx",
                lineNumber: 35,
                columnNumber: 13
            }, _this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
                selector: "[data-id=close]",
                onClick: close
            }, void 0, false, {
                fileName: "src/snippets/components/modal/liquid/index.tsx",
                lineNumber: 36,
                columnNumber: 13
            }, _this)
        ]
    }, void 0, true, {
        fileName: "src/snippets/components/modal/liquid/index.tsx",
        lineNumber: 33,
        columnNumber: 9
    }, _this);
});

},{"@swc/helpers/_/_sliced_to_array":"ha6sq","react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","../../../../script/src/dom/library/DomComponent":"8H9za","../../../../script/src/std/hooks":"j9RPQ","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"a9AMM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DogSizeVariantSelectors", function() {
    return DogSizeVariantSelectors;
});
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _hooks = require("../../../../script/src/std/hooks");
var _domComponent = require("../../../../script/src/dom/library/DomComponent");
var _dogSizeSelector = require("./dogSizeSelector");
var _variantsView = require("../views/variantsView");
function DogSizeVariantSelectors(props) {
    var _this = this;
    var view = (0, _hooks.useSelector)(function(state) {
        return (0, _variantsView.variantsView)(state, props.componentId);
    });
    if (!view) return null;
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
        selector: "[data-id=dogSizeVariantSelectors]",
        optional: true,
        children: view.variants.map(function(variant) {
            return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _dogSizeSelector.DogSizeSelector), {
                variantId: variant.variantId,
                selected: variant.selected,
                onClick: variant.actions.select(props.source)
            }, variant.key, false, {
                fileName: "src/snippets/components/productSelectionPanel/liquid/dogSizeVariantSelectors.tsx",
                lineNumber: 21,
                columnNumber: 43
            }, _this);
        })
    }, void 0, false, {
        fileName: "src/snippets/components/productSelectionPanel/liquid/dogSizeVariantSelectors.tsx",
        lineNumber: 20,
        columnNumber: 9
    }, this);
}

},{"react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","../../../../script/src/std/hooks":"j9RPQ","../../../../script/src/dom/library/DomComponent":"8H9za","./dogSizeSelector":"7f0iS","../views/variantsView":"d7xAX","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"cRV1J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BundleSelectors", function() {
    return BundleSelectors;
});
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _domComponent = require("../../../../script/src/dom/library/DomComponent");
var _domArray = require("../../../../script/src/dom/library/DomArray");
var _domElement = require("../../../../script/src/dom/library/DomElement");
var _hooks = require("../../../../script/src/std/hooks");
var _bundleView = require("../views/bundleView");
function BundleSelectors(props) {
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
        selector: "[data-id=bundleSelectors]",
        optional: true,
        children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domArray.DomArray), {
            selector: "[data-id=bundleSelector]",
            child: function(param) {
                var key = param.key, selector = param.selector;
                return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(BundleSelector, {
                    selector: selector,
                    componentId: props.componentId
                }, key, false, {
                    fileName: "src/snippets/components/productSelectionPanel/liquid/bundleSelectors.tsx",
                    lineNumber: 20,
                    columnNumber: 17
                }, void 0);
            }
        }, void 0, false, {
            fileName: "src/snippets/components/productSelectionPanel/liquid/bundleSelectors.tsx",
            lineNumber: 17,
            columnNumber: 13
        }, this)
    }, void 0, false, {
        fileName: "src/snippets/components/productSelectionPanel/liquid/bundleSelectors.tsx",
        lineNumber: 16,
        columnNumber: 9
    }, this);
}
function BundleSelector(props) {
    var dispatch = (0, _hooks.useDispatch)();
    var quantity = (0, _domElement.useNumberAttributeValue)('data-value', props.selector);
    var componentId = props.componentId;
    var view = (0, _hooks.useSelector)(function(state) {
        return (0, _bundleView.bundleView)(state, componentId, quantity);
    });
    if (!view) return null;
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
        selector: props.selector,
        data: {
            selected: view.selected
        },
        onClick: function() {
            return dispatch(view.actions.selectQuantity);
        }
    }, void 0, false, {
        fileName: "src/snippets/components/productSelectionPanel/liquid/bundleSelectors.tsx",
        lineNumber: 40,
        columnNumber: 9
    }, this);
}

},{"react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","../../../../script/src/dom/library/DomComponent":"8H9za","../../../../script/src/dom/library/DomArray":"ZEl1X","../../../../script/src/dom/library/DomElement":"15N7Q","../../../../script/src/std/hooks":"j9RPQ","../views/bundleView":"cNSkK","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"cNSkK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bundleView", function() {
    return bundleView;
});
var _reReselect = require("re-reselect");
var _state = require("../state");
var _selectQuantity = require("../useCases/selectQuantity");
var bundleView = (0, _reReselect.createCachedSelector)(function(state, componentId, quantity) {
    return componentId;
}, function(state, componentId, quantity) {
    return quantity;
}, (0, _state.productSelectionPanelSelector), prepareView)(function(state, componentId, quantity) {
    return `${componentId}_${quantity}`;
});
function prepareView(componentId, quantity, panelState) {
    if (isLoading()) return null;
    return {
        selected: (panelState === null || panelState === void 0 ? void 0 : panelState.quantity) === quantity,
        actions: {
            selectQuantity: (0, _selectQuantity.SelectQuantity)({
                componentId: componentId,
                quantity: quantity
            })
        }
    };
    function isLoading() {
        return !panelState;
    }
}

},{"re-reselect":"fUjlV","../state":"3nAmi","../useCases/selectQuantity":"cgyOz","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4wTD1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Cta", function() {
    return Cta;
});
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _hooks = require("../../../../script/src/std/hooks");
var _liquid = require("../../select/liquid");
var _indexLiquid = require("../../cta/index--liquid");
var _panelView = require("../views/panelView");
var _domArray = require("../../../../script/src/dom/library/DomArray");
function Cta(props) {
    var view = (0, _hooks.useSelector)(function(state) {
        return (0, _panelView.panelView)(state, props.componentId);
    });
    var dispatch = (0, _hooks.useDispatch)();
    if (!view) return null;
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _jsxDevRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(QuantitySelectors, {
                view: view
            }, void 0, false, {
                fileName: "src/snippets/components/productSelectionPanel/liquid/cta.tsx",
                lineNumber: 20,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _indexLiquid.LiquidCta), {
                selector: "[data-id=cta]",
                onClick: function() {
                    return dispatch(view.actions.addToCartWithSelection('inPage'));
                },
                price: view.totalPrice
            }, void 0, false, {
                fileName: "src/snippets/components/productSelectionPanel/liquid/cta.tsx",
                lineNumber: 21,
                columnNumber: 13
            }, this)
        ]
    }, void 0, true);
}
function QuantitySelectors(props) {
    var dispatch = (0, _hooks.useDispatch)();
    var view = props.view;
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domArray.DomArray), {
        selector: "[data-id=quantitySelector]",
        discriminator: "data-variant_id",
        child: function(param) {
            var key = param.key, selector = param.selector;
            return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _liquid.NumberLiquidSelect), {
                selector: selector,
                data: {
                    selected: Number(key) === view.selectedVariantId
                },
                onChange: function(quantity) {
                    return dispatch(view.actions.selectQuantity(quantity));
                },
                value: view.quantity
            }, key, false, {
                fileName: "src/snippets/components/productSelectionPanel/liquid/cta.tsx",
                lineNumber: 38,
                columnNumber: 13
            }, void 0);
        }
    }, void 0, false, {
        fileName: "src/snippets/components/productSelectionPanel/liquid/cta.tsx",
        lineNumber: 37,
        columnNumber: 9
    }, this);
}

},{"react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","../../../../script/src/std/hooks":"j9RPQ","../../select/liquid":"ifxDA","../../cta/index--liquid":"2Hp5o","../views/panelView":"jRtEY","../../../../script/src/dom/library/DomArray":"ZEl1X","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"ifxDA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LiquidSelect", function() {
    return LiquidSelect;
});
parcelHelpers.export(exports, "NumberLiquidSelect", function() {
    return NumberLiquidSelect;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _domComponent = require("../../../script/src/dom/library/DomComponent");
function LiquidSelect(props) {
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(Select, (0, _objectSpread._)({}, props), void 0, false, {
        fileName: "src/snippets/components/select/liquid.tsx",
        lineNumber: 15,
        columnNumber: 9
    }, this);
}
function NumberLiquidSelect(props) {
    var _props_value;
    var _props_value_toString;
    var value = (_props_value_toString = (_props_value = props.value) === null || _props_value === void 0 ? void 0 : _props_value.toString()) !== null && _props_value_toString !== void 0 ? _props_value_toString : null;
    function handleChange(value) {
        props.onChange(Number(value));
    }
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(Select, (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        onChange: handleChange,
        value: value
    }), void 0, false, {
        fileName: "src/snippets/components/select/liquid.tsx",
        lineNumber: 27,
        columnNumber: 9
    }, this);
}
function Select(props) {
    var cleared = props.value === null;
    function handleChange(value) {
        var _props_onClear;
        if (value === '') return (_props_onClear = props.onClear) === null || _props_onClear === void 0 ? void 0 : _props_onClear.call(props);
        return props.onChange(value);
    }
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
        selector: props.selector,
        optional: props.optionnal,
        data: (0, _objectSpreadProps._)((0, _objectSpread._)({}, props.data), {
            cleared: cleared
        }),
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
                selector: "[data-id=shortLabels]",
                optional: true,
                onChange: function(value) {
                    return handleChange(value);
                },
                selectedValue: props.value
            }, void 0, false, {
                fileName: "src/snippets/components/select/liquid.tsx",
                lineNumber: 47,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
                selector: "[data-id=fullLabels]",
                onChange: function(value) {
                    return handleChange(value);
                },
                selectedValue: props.value
            }, void 0, false, {
                fileName: "src/snippets/components/select/liquid.tsx",
                lineNumber: 53,
                columnNumber: 13
            }, this)
        ]
    }, void 0, true, {
        fileName: "src/snippets/components/select/liquid.tsx",
        lineNumber: 42,
        columnNumber: 9
    }, this);
}

},{"@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_object_spread_props":"fLCYP","react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","../../../script/src/dom/library/DomComponent":"8H9za","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gN041":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StickyPanel", function() {
    return StickyPanel;
});
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _domComponent = require("../../../../script/src/dom/library/DomComponent");
var _hooks = require("../../../../script/src/std/hooks");
var _panelView = require("../views/panelView");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _variantSelectors = require("./variantSelectors");
var _indexLiquid = require("../../cta/index--liquid");
var _productSelectors = require("./productSelectors");
var _liquid = require("../../stickyPanel/liquid");
function StickyPanel(props) {
    var view = (0, _hooks.useSelector)(function(state) {
        return (0, _panelView.panelView)(state, props.componentId);
    });
    var dispatch = (0, _hooks.useDispatch)();
    var stickyPanel = (0, _liquid.useStickyPanel)('[data-id=stickyPanel]');
    if (!view) return null;
    var handleAddToCart = function() {
        dispatch(view.actions.addToCartWithoutSubscriptionAndQuantity('sticky'));
    };
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
        selector: "[data-id=stickyPanel]",
        children: [
            props.withProductSelection && /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _productSelectors.ProductSelectors), {
                componentId: props.componentId,
                source: "inPage"
            }, void 0, false, {
                fileName: "src/snippets/components/productSelectionPanel/liquid/stickyPanel.tsx",
                lineNumber: 29,
                columnNumber: 44
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _variantSelectors.VariantSelectors), {
                componentId: props.componentId,
                source: "sticky"
            }, void 0, false, {
                fileName: "src/snippets/components/productSelectionPanel/liquid/stickyPanel.tsx",
                lineNumber: 30,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _indexLiquid.LiquidCta), {
                selector: "[data-id=cta]",
                onClick: handleAddToCart,
                price: view.itemPriceWithoutSubscriptionAndQuantity
            }, void 0, false, {
                fileName: "src/snippets/components/productSelectionPanel/liquid/stickyPanel.tsx",
                lineNumber: 31,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _indexLiquid.LiquidCta), {
                selector: "[data-id=openCta]",
                onClick: stickyPanel.toggle
            }, void 0, false, {
                fileName: "src/snippets/components/productSelectionPanel/liquid/stickyPanel.tsx",
                lineNumber: 36,
                columnNumber: 13
            }, this)
        ]
    }, void 0, true, {
        fileName: "src/snippets/components/productSelectionPanel/liquid/stickyPanel.tsx",
        lineNumber: 28,
        columnNumber: 9
    }, this);
}

},{"react/jsx-dev-runtime":"jXZ8I","../../../../script/src/dom/library/DomComponent":"8H9za","../../../../script/src/std/hooks":"j9RPQ","../views/panelView":"jRtEY","react":"c8CN1","./variantSelectors":"84wND","../../cta/index--liquid":"2Hp5o","./productSelectors":"5sYHL","../../stickyPanel/liquid":"7xSQR","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"0PP6H":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DefaultHeader", function() {
    return DefaultHeader;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _domComponent = require("../../../script/src/dom/library/DomComponent");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _hooks = require("../../../script/src/std/hooks");
var _header = require("../../../script/src/app/events/Header");
var _domArray = require("../../../script/src/dom/library/DomArray");
var _useTrack = require("../../../script/src/dom/hooks/useTrack");
function DefaultHeader() {
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domArray.DomArray), {
        selector: ".componentDefaultHeader",
        child: function(param) {
            var key = param.key, selector = param.selector;
            return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(Section, {
                selector: selector
            }, key, false, {
                fileName: "src/snippets/components/defaultHeader/index.tsx",
                lineNumber: 10,
                columnNumber: 84
            }, void 0);
        }
    }, void 0, false, {
        fileName: "src/snippets/components/defaultHeader/index.tsx",
        lineNumber: 10,
        columnNumber: 9
    }, this);
}
function Section(props) {
    var selector = props.selector;
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), opened = _useState[0], setOpened = _useState[1];
    var dispatch = (0, _hooks.useDispatch)();
    var track = (0, _useTrack.useTrack)();
    (0, _hooks.useOnEvent)((0, _header.OpenMenuKey), open);
    (0, _hooks.useOnEvent)((0, _header.CloseMenuKey), close);
    (0, _hooks.usePreventBackgroundScroll)(opened);
    function open() {
        setOpened(true);
        track('OpenMenu');
    }
    function close() {
        setOpened(false);
    }
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
        selector: selector,
        data: {
            opened: opened
        },
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
                selector: ".componentDefaultHeader__header__burger",
                onClick: function() {
                    return dispatch((0, _header.OpenMenu)());
                }
            }, void 0, false, {
                fileName: "src/snippets/components/defaultHeader/index.tsx",
                lineNumber: 38,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
                selector: ".componentDefaultHeader__foldingMenu__close",
                onClick: function() {
                    return dispatch((0, _header.CloseMenu)());
                }
            }, void 0, false, {
                fileName: "src/snippets/components/defaultHeader/index.tsx",
                lineNumber: 39,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
                selector: ".componentDefaultHeader__foldingMenu__overlay",
                onClick: function() {
                    return dispatch((0, _header.CloseMenu)());
                }
            }, void 0, false, {
                fileName: "src/snippets/components/defaultHeader/index.tsx",
                lineNumber: 40,
                columnNumber: 13
            }, this)
        ]
    }, void 0, true, {
        fileName: "src/snippets/components/defaultHeader/index.tsx",
        lineNumber: 37,
        columnNumber: 9
    }, this);
}

},{"@swc/helpers/_/_sliced_to_array":"ha6sq","react/jsx-dev-runtime":"jXZ8I","../../../script/src/dom/library/DomComponent":"8H9za","react":"c8CN1","../../../script/src/std/hooks":"j9RPQ","../../../script/src/app/events/Header":"fUHjR","../../../script/src/dom/library/DomArray":"ZEl1X","../../../script/src/dom/hooks/useTrack":"iL2dq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"fUHjR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OpenMenuKey", function() {
    return OpenMenuKey;
});
parcelHelpers.export(exports, "OpenMenu", function() {
    return OpenMenu;
});
parcelHelpers.export(exports, "CloseMenuKey", function() {
    return CloseMenuKey;
});
parcelHelpers.export(exports, "CloseMenu", function() {
    return CloseMenu;
});
var _eventFactory = require("../../std/eventFactory");
var OpenMenuKey = 'OpenMenu';
var OpenMenu = (0, _eventFactory.eventFactory)('OpenMenu')();
var CloseMenuKey = 'CloseMenu';
var CloseMenu = (0, _eventFactory.eventFactory)('CloseMenu')();

},{"../../std/eventFactory":"f2PpV","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5FFxb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Settings", function() {
    return Settings;
});
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _link = require("./link");
function Settings() {
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _jsxDevRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _link.Links), {}, void 0, false, {
            fileName: "src/snippets/settings/index.tsx",
            lineNumber: 7,
            columnNumber: 13
        }, this)
    }, void 0, false);
}

},{"react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","./link":"belQC","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"belQC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Links", function() {
    return Links;
});
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _domElement = require("../../../script/src/dom/library/DomElement");
var _hooks = require("../../../script/src/std/hooks");
var _domArray = require("../../../script/src/dom/library/DomArray");
var _domComponent = require("../../../script/src/dom/library/DomComponent");
function Links() {
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domArray.DomArray), {
        selector: "[data-setting_id=link]",
        child: function(param) {
            var key = param.key, selector = param.selector;
            return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(Link, {
                selector: selector
            }, key, false, {
                fileName: "src/snippets/settings/link/index.tsx",
                lineNumber: 9,
                columnNumber: 83
            }, void 0);
        }
    }, void 0, false, {
        fileName: "src/snippets/settings/link/index.tsx",
        lineNumber: 9,
        columnNumber: 9
    }, this);
}
function Link(props) {
    var selector = props.selector;
    var target = (0, _domElement.useNullableAttributeValue)('data-scrollTo', selector);
    var scrollTo = (0, _hooks.useScrollTo)({
        selector: target ? `[data-section_id=${target}]` : undefined
    });
    function onClick(event) {
        if (!target) return;
        event.preventDefault();
        scrollTo();
    }
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
        selector: selector,
        onClick: onClick
    }, void 0, false, {
        fileName: "src/snippets/settings/link/index.tsx",
        lineNumber: 29,
        columnNumber: 9
    }, this);
}

},{"react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","../../../script/src/dom/library/DomElement":"15N7Q","../../../script/src/std/hooks":"j9RPQ","../../../script/src/dom/library/DomArray":"ZEl1X","../../../script/src/dom/library/DomComponent":"8H9za","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"f9rI7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useReload", function() {
    return useReload;
});
parcelHelpers.export(exports, "useReloadDomApp", function() {
    return useReloadDomApp;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _react = require("react");
var _reactRedux = require("react-redux");
var _app = require("../views/App");
function useReload() {
    var _useState = (0, _slicedToArray._)((0, _react.useState)(), 2), reload = _useState[1];
    return function() {
        return reload(Math.random());
    };
}
function useReloadDomApp() {
    var dispatch = (0, _reactRedux.useDispatch)();
    return function() {
        dispatch((0, _app.ReloadDomApp)());
    };
}

},{"@swc/helpers/_/_sliced_to_array":"ha6sq","react":"c8CN1","react-redux":"ghMZu","../views/App":"jp6rK","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3HY3R":[function(require,module,exports,__globalThis) {
'use strict';
var m = require("aaccff5d309d9239");
var i = m.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
exports.createRoot = function(c, o) {
    i.usingClientEntryPoint = true;
    try {
        return m.createRoot(c, o);
    } finally{
        i.usingClientEntryPoint = false;
    }
};
exports.hydrateRoot = function(c, h, o) {
    i.usingClientEntryPoint = true;
    try {
        return m.hydrateRoot(c, h, o);
    } finally{
        i.usingClientEntryPoint = false;
    }
};

},{"aaccff5d309d9239":"kFYAC"}],"hMCO5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dontWaitFor", function() {
    return dontWaitFor;
});
function dontWaitFor(response) {}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8wPRQ":[function(require,module,exports,__globalThis) {
/**
 * Swiper 11.2.6
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2025 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: March 19, 2025
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Swiper", function() {
    return 0, _swiperCoreMjs.S;
});
parcelHelpers.export(exports, "default", function() {
    return 0, _swiperCoreMjs.S;
});
var _swiperCoreMjs = require("./shared/swiper-core.mjs");

},{"./shared/swiper-core.mjs":"frzgY","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"31IQY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReviewsPreview", function() {
    return ReviewsPreview;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _std = require("@reglo/std");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _domSection = require("../../../script/src/dom/library/DomSection");
var _domComponent = require("../../../script/src/dom/library/DomComponent");
var _domArray = require("../../../script/src/dom/library/DomArray");
var _domElement = require("../../../script/src/dom/library/DomElement");
var _dontWaitFor = require("../../../script/src/std/dontWaitFor");
var _hooks = require("../../../script/src/std/hooks");
var _loadReviews = require("../useCases/loadReviews");
var _init = require("../useCases/init");
var _selectReviewTag = require("../useCases/selectReviewTag");
var _pagination = require("./snippets/pagination");
var _breedSelector = require("./snippets/breedSelector");
function ReviewsPreview() {
    var _this = this;
    return (0, _domSection.DomSection)('sectionReviewsPreview', function() {
        return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(Section, {}, void 0, false, {
            fileName: "src/sections/reviewsPreview/liquid/index.tsx",
            lineNumber: 16,
            columnNumber: 54
        }, _this);
    });
}
function Section() {
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _jsxDevRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _breedSelector.BreedSelector), {}, void 0, false, {
                fileName: "src/sections/reviewsPreview/liquid/index.tsx",
                lineNumber: 22,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(Tags, {}, void 0, false, {
                fileName: "src/sections/reviewsPreview/liquid/index.tsx",
                lineNumber: 23,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(Collection, {}, void 0, false, {
                fileName: "src/sections/reviewsPreview/liquid/index.tsx",
                lineNumber: 24,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(Grid, {}, void 0, false, {
                fileName: "src/sections/reviewsPreview/liquid/index.tsx",
                lineNumber: 25,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _pagination.Pagination), {}, void 0, false, {
                fileName: "src/sections/reviewsPreview/liquid/index.tsx",
                lineNumber: 26,
                columnNumber: 13
            }, this)
        ]
    }, void 0, true);
}
function Tags() {
    var _useState = (0, _slicedToArray._)((0, _react.useState)('all'), 2), selectedTag = _useState[0], setSelected = _useState[1];
    (0, _hooks.useOnEvent)((0, _selectReviewTag.SelectReviewTagKey), function(event) {
        return setSelected(event.payload.tag);
    });
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
        selector: "&__tags",
        optional: true,
        children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domArray.DomArray), {
            selector: "&__tag",
            child: function(param) {
                var key = param.key, selector = param.selector;
                return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(Tag, {
                    selector: selector,
                    selectedTag: selectedTag
                }, key, false, {
                    fileName: "src/sections/reviewsPreview/liquid/index.tsx",
                    lineNumber: 39,
                    columnNumber: 17
                }, void 0);
            }
        }, void 0, false, {
            fileName: "src/sections/reviewsPreview/liquid/index.tsx",
            lineNumber: 38,
            columnNumber: 13
        }, this)
    }, void 0, false, {
        fileName: "src/sections/reviewsPreview/liquid/index.tsx",
        lineNumber: 37,
        columnNumber: 9
    }, this);
}
function Tag(props) {
    var dispatch = (0, _hooks.useDispatch)();
    var selectedTag = props.selectedTag;
    var tag = (0, _std.unwrap)((0, _domElement.useNullableAttributeValue)('data-tag', props.selector));
    var handleClick = function() {
        return dispatch((0, _selectReviewTag.SelectReviewTag)({
            tag: tag
        }));
    };
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
        selector: props.selector,
        onClick: handleClick,
        classes: {
            '&--selected': tag === selectedTag
        }
    }, void 0, false, {
        fileName: "src/sections/reviewsPreview/liquid/index.tsx",
        lineNumber: 56,
        columnNumber: 9
    }, this);
}
function Collection() {
    var dispatch = (0, _hooks.useDispatch)();
    var collection = (0, _std.unwrap)((0, _domElement.useNullableAttributeValue)('data-collection', '[data-collection]'));
    (0, _react.useEffect)(function() {
        dispatch((0, _init.Init)({
            collection: collection
        }));
    }, []);
    return null;
}
function Grid() {
    var _useState = (0, _slicedToArray._)((0, _react.useState)(null), 2), html = _useState[0], setHtml = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(false), 2), isLoading = _useState1[0], setIsLoading = _useState1[1];
    var scrollToTop = (0, _hooks.useScrollTo)({
        selector: '[data-id=scrollAnchor]',
        scrollDown: false
    });
    (0, _hooks.useOnEvent)((0, _loadReviews.LoadReviewsKey), function() {
        scrollToTop();
        setIsLoading(true);
    });
    (0, _hooks.useOnEvent)((0, _loadReviews.ReviewsLoadedKey), function(event) {
        setHtml(event.payload.reviewsHtml);
        setIsLoading(false);
    });
    (0, _react.useEffect)(function() {
        refreshGrid();
    }, [
        html
    ]);
    function refreshGrid() {
        (0, _dontWaitFor.dontWaitFor)((0, _asyncToGenerator._)(function() {
            var Masonry;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0, _std.importImplicitDefault)(require("95f4c4a904954fbf"))
                        ];
                    case 1:
                        Masonry = _state.sent();
                        new Masonry('.sectionReviewsPreview__items', {
                            itemSelector: '.sectionReviewsPreview__item',
                            horizontalOrder: false
                        });
                        return [
                            2
                        ];
                }
            });
        })());
    }
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
        selector: "&__items",
        innerHtml: html !== null && html !== void 0 ? html : undefined,
        classes: {
            '&--loading': isLoading
        }
    }, void 0, false, {
        fileName: "src/sections/reviewsPreview/liquid/index.tsx",
        lineNumber: 108,
        columnNumber: 9
    }, this);
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_sliced_to_array":"ha6sq","@swc/helpers/_/_ts_generator":"f2hGH","react/jsx-dev-runtime":"jXZ8I","@reglo/std":"1USo0","react":"c8CN1","../../../script/src/dom/library/DomSection":"gcFCP","../../../script/src/dom/library/DomComponent":"8H9za","../../../script/src/dom/library/DomArray":"ZEl1X","../../../script/src/dom/library/DomElement":"15N7Q","../../../script/src/std/dontWaitFor":"hMCO5","../../../script/src/std/hooks":"j9RPQ","../useCases/loadReviews":"fKFqv","../useCases/init":"8guS5","../useCases/selectReviewTag":"korzW","./snippets/pagination":"io9bk","./snippets/breedSelector":"3NMCX","95f4c4a904954fbf":"hvasH","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"io9bk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Pagination", function() {
    return Pagination;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _domComponent = require("../../../../script/src/dom/library/DomComponent");
var _domArray = require("../../../../script/src/dom/library/DomArray");
var _domElement = require("../../../../script/src/dom/library/DomElement");
var _hooks = require("../../../../script/src/std/hooks");
var _loadReviews = require("../../useCases/loadReviews");
var _goToReviewsPage = require("../../useCases/goToReviewsPage");
var _std = require("@reglo/std");
function Pagination() {
    var _useState = (0, _slicedToArray._)((0, _react.useState)(null), 2), html = _useState[0], setHtml = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(null), 2), pageCount = _useState1[0], setPageCount = _useState1[1];
    var dispatch = (0, _hooks.useDispatch)();
    var hidden = pageCount !== null && pageCount <= 1;
    (0, _hooks.useOnEvent)((0, _loadReviews.ReviewsLoadedKey), function(event) {
        setHtml(event.payload.paginationHtml);
        setPageCount(event.payload.pageCount);
    });
    function handleClick(page) {
        dispatch((0, _goToReviewsPage.GoToReviewsPage)({
            page: page
        }));
    }
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _jsxDevRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
            selector: "&__nav",
            innerHtml: html !== null && html !== void 0 ? html : undefined,
            data: {
                hidden: hidden
            },
            children: [
                /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(PaginationItem, {
                    selector: "&__prev",
                    onClick: handleClick
                }, void 0, false, {
                    fileName: "src/sections/reviewsPreview/liquid/snippets/pagination.tsx",
                    lineNumber: 28,
                    columnNumber: 17
                }, this),
                /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domArray.DomArray), {
                    selector: "&__item:not(&__item--selected)",
                    child: function(param) {
                        var key = param.key, selector = param.selector;
                        return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(PaginationItem, {
                            selector: selector,
                            onClick: handleClick
                        }, key, false, {
                            fileName: "src/sections/reviewsPreview/liquid/snippets/pagination.tsx",
                            lineNumber: 30,
                            columnNumber: 28
                        }, void 0);
                    }
                }, void 0, false, {
                    fileName: "src/sections/reviewsPreview/liquid/snippets/pagination.tsx",
                    lineNumber: 29,
                    columnNumber: 17
                }, this),
                /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(PaginationItem, {
                    selector: "&__next",
                    onClick: handleClick
                }, void 0, false, {
                    fileName: "src/sections/reviewsPreview/liquid/snippets/pagination.tsx",
                    lineNumber: 32,
                    columnNumber: 17
                }, this)
            ]
        }, void 0, true, {
            fileName: "src/sections/reviewsPreview/liquid/snippets/pagination.tsx",
            lineNumber: 27,
            columnNumber: 13
        }, this)
    }, void 0, false);
}
function PaginationItem(props) {
    var page = Number((0, _std.unwrap)((0, _domElement.useNullableAttributeValue)('data-page', props.selector)));
    function handleClick() {
        props.onClick(page);
    }
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
        selector: props.selector,
        onClick: handleClick
    }, void 0, false, {
        fileName: "src/sections/reviewsPreview/liquid/snippets/pagination.tsx",
        lineNumber: 49,
        columnNumber: 9
    }, this);
}

},{"@swc/helpers/_/_sliced_to_array":"ha6sq","react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","../../../../script/src/dom/library/DomComponent":"8H9za","../../../../script/src/dom/library/DomArray":"ZEl1X","../../../../script/src/dom/library/DomElement":"15N7Q","../../../../script/src/std/hooks":"j9RPQ","../../useCases/loadReviews":"fKFqv","../../useCases/goToReviewsPage":"9IBl6","@reglo/std":"1USo0","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3NMCX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BreedSelector", function() {
    return BreedSelector;
});
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _reactRedux = require("react-redux");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _domComponent = require("../../../../script/src/dom/library/DomComponent");
var _hooks = require("../../../../script/src/std/hooks");
var _state = require("../../state");
var _liquid = require("../../../../snippets/components/select/liquid");
var _selectBreed = require("../../useCases/selectBreed");
var _clearBreed = require("../../useCases/clearBreed");
var _domElement = require("../../../../script/src/dom/library/DomElement");
function BreedSelector() {
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
        selector: "[data-id=filters]",
        children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(BreedSelectorFilter, {}, void 0, false, {
            fileName: "src/sections/reviewsPreview/liquid/snippets/breedSelector.tsx",
            lineNumber: 15,
            columnNumber: 13
        }, this)
    }, void 0, false, {
        fileName: "src/sections/reviewsPreview/liquid/snippets/breedSelector.tsx",
        lineNumber: 14,
        columnNumber: 9
    }, this);
}
function BreedSelectorFilter() {
    var dispatch = (0, _hooks.useDispatch)();
    var value = (0, _reactRedux.useSelector)((0, _state.breedIdSelector));
    var isDisplayed = (0, _domElement.useBooleanAttributeValue)('data-has_breed_selector_filter');
    if (!isDisplayed) return null;
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _liquid.NumberLiquidSelect), {
        selector: "[data-id=breedSelector]",
        onChange: function(breedId) {
            return dispatch((0, _selectBreed.SelectBreed)({
                breedId: breedId
            }));
        },
        onClear: function() {
            return dispatch((0, _clearBreed.ClearBreed)());
        },
        value: value
    }, void 0, false, {
        fileName: "src/sections/reviewsPreview/liquid/snippets/breedSelector.tsx",
        lineNumber: 30,
        columnNumber: 9
    }, this);
}

},{"react/jsx-dev-runtime":"jXZ8I","react-redux":"ghMZu","react":"c8CN1","../../../../script/src/dom/library/DomComponent":"8H9za","../../../../script/src/std/hooks":"j9RPQ","../../state":"kx1bN","../../../../snippets/components/select/liquid":"ifxDA","../../useCases/selectBreed":"7xLoF","../../useCases/clearBreed":"8rZwx","../../../../script/src/dom/library/DomElement":"15N7Q","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"hvasH":[function(require,module,exports,__globalThis) {
module.exports = require("43d1a2abe0da341")(module.bundle.resolve("masonry.7ebcad5b.js")).catch(function(err) {
    delete module.bundle.cache[module.id];
    throw err;
}).then(function() {
    return module.bundle.root('hWDTZ');
});

},{"43d1a2abe0da341":"3wULj"}],"3wULj":[function(require,module,exports,__globalThis) {
"use strict";
var cacheLoader = require("ca2a84f7fa4a3bb0");
module.exports = cacheLoader(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

},{"ca2a84f7fa4a3bb0":"3ktIr"}],"3ktIr":[function(require,module,exports,__globalThis) {
"use strict";
var cachedBundles = {};
var cachedPreloads = {};
var cachedPrefetches = {};
function getCache(type) {
    switch(type){
        case 'preload':
            return cachedPreloads;
        case 'prefetch':
            return cachedPrefetches;
        default:
            return cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

},{}],"dfGqs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Faq", function() {
    return Faq;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _domSection = require("../../script/src/dom/library/DomSection");
var _domComponent = require("../../script/src/dom/library/DomComponent");
var _domElement = require("../../script/src/dom/library/DomElement");
var _domArray = require("../../script/src/dom/library/DomArray");
var _std = require("@reglo/std");
var _useTrack = require("../../script/src/dom/hooks/useTrack");
function Faq() {
    var _this = this;
    return (0, _domSection.DomSection)('sectionFaq', function() {
        return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(Section, {}, void 0, false, {
            fileName: "src/sections/faq/index.tsx",
            lineNumber: 10,
            columnNumber: 43
        }, _this);
    });
}
function Section() {
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domArray.DomArray), {
        selector: ".sectionFaq__accordion",
        child: function(param) {
            var key = param.key, selector = param.selector;
            return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(Accordion, {
                selector: selector
            }, key, false, {
                fileName: "src/sections/faq/index.tsx",
                lineNumber: 17,
                columnNumber: 43
            }, void 0);
        }
    }, void 0, false, {
        fileName: "src/sections/faq/index.tsx",
        lineNumber: 15,
        columnNumber: 9
    }, this);
}
function Accordion(props) {
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), opened = _useState[0], setOpened = _useState[1];
    var track = (0, _useTrack.useTrack)();
    var sectionId = (0, _domElement.useSectionId)(props.selector);
    var title = (0, _domElement.useDomElementText)(`${props.selector} [data-id=title]`);
    function toggle() {
        opened ? close() : open();
    }
    function open() {
        setOpened(true);
        track('OpenAccordion', {
            sectionId: sectionId,
            title: title
        });
    }
    function close() {
        setOpened(false);
    }
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
        selector: props.selector,
        classes: {
            opened: opened
        },
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
                selector: ".sectionFaq__accordion__titleContainer",
                onClick: toggle
            }, void 0, false, {
                fileName: "src/sections/faq/index.tsx",
                lineNumber: 45,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
                selector: ".sectionFaq__accordion__contentContainer",
                children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(AccordionContent, {
                    opened: opened
                }, void 0, false, {
                    fileName: "src/sections/faq/index.tsx",
                    lineNumber: 47,
                    columnNumber: 17
                }, this)
            }, void 0, false, {
                fileName: "src/sections/faq/index.tsx",
                lineNumber: 46,
                columnNumber: 13
            }, this)
        ]
    }, void 0, true, {
        fileName: "src/sections/faq/index.tsx",
        lineNumber: 44,
        columnNumber: 9
    }, this);
}
function AccordionContent(props) {
    var element = (0, _std.unwrap)((0, _domElement.useDomElement)().element);
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), previouslyOpened = _useState[0], setPreviouslyOpened = _useState[1];
    (0, _react.useEffect)(function() {
        return props.opened ? openAccordion() : closeAccordion();
    }, [
        props.opened
    ]);
    return null;
    function closeAccordion() {
        if (previouslyOpened) element.style.height = `${element.scrollHeight}px`;
        setTimeout(function() {
            element.style.height = '0px';
        }, 1);
    }
    function openAccordion() {
        element.style.height = `${element.scrollHeight}px`;
        if (!previouslyOpened) setPreviouslyOpened(true);
        setTimeout(function() {
            element.style.height = '';
        }, 500);
    }
}

},{"@swc/helpers/_/_sliced_to_array":"ha6sq","react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","../../script/src/dom/library/DomSection":"gcFCP","../../script/src/dom/library/DomComponent":"8H9za","../../script/src/dom/library/DomElement":"15N7Q","../../script/src/dom/library/DomArray":"ZEl1X","@reglo/std":"1USo0","../../script/src/dom/hooks/useTrack":"iL2dq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"ccm9w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "reviewsPreviewDeps", function() {
    return reviewsPreviewDeps;
});
var _loadReviews = require("./loadReviews");
function reviewsPreviewDeps(deps) {
    return {
        loadReviews: (0, _loadReviews.loadReviews)(deps)
    };
}

},{"./loadReviews":"9wYiZ","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"9wYiZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loadReviews", function() {
    return loadReviews;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _std = require("@reglo/std");
function loadReviews(deps) {
    return /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(params) {
            var _ref, reviewsHtml, paginationHtml, data;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            deps.waitAtLeast(Promise.all([
                                requestView(params, 'reviews'),
                                requestView(params, 'pagination'),
                                requestData(params)
                            ]), 600)
                        ];
                    case 1:
                        _ref = (0, _slicedToArray._).apply(void 0, [
                            _state.sent(),
                            3
                        ]), reviewsHtml = _ref[0], paginationHtml = _ref[1], data = _ref[2];
                        return [
                            2,
                            (0, _objectSpread._)({
                                reviewsHtml: reviewsHtml,
                                paginationHtml: paginationHtml
                            }, data)
                        ];
                }
            });
        });
        return function(params) {
            return _ref.apply(this, arguments);
        };
    }();
    function requestView(params, view) {
        return deps.request.getRequestRaw(prepareUrl(params, view));
    }
    function requestData(params) {
        return deps.request.getRequest(prepareUrl(params, 'data'));
    }
    function prepareUrl(params, view) {
        var tagsUrlPart = prepareTags(params);
        var viewUrlPart = prepareView(view);
        return `/blogs/avis-clients/tagged/${tagsUrlPart}?view=${viewUrlPart}&page=${params.page}`;
    }
    function prepareView(view) {
        switch(view){
            case 'reviews':
                return 'reviewsPreview__ajaxReviews';
            case 'pagination':
                return 'reviewsPreview__ajaxPagination';
            case 'data':
                return 'reviewsPreview__ajaxData';
            default:
                return (0, _std.assertNever)(view);
        }
    }
    function prepareTags(params) {
        return [
            `collection-${params.collection}`
        ].concat((0, _toConsumableArray._)(params.breedId ? [
            `breed-${params.breedId}`
        ] : []), (0, _toConsumableArray._)(params.tag === 'all' ? [] : [
            `tag-${params.tag}`
        ])).join('+');
    }
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_sliced_to_array":"ha6sq","@swc/helpers/_/_to_consumable_array":"eqNDD","@swc/helpers/_/_ts_generator":"f2hGH","@reglo/std":"1USo0","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"cILyh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProductsWithFilter", function() {
    return ProductsWithFilter;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _domSection = require("../../../../script/src/dom/library/DomSection");
var _domElement = require("../../../../script/src/dom/library/DomElement");
var _std = require("@reglo/std");
var _domArray = require("../../../../script/src/dom/library/DomArray");
var _domComponent = require("../../../../script/src/dom/library/DomComponent");
var _startDom = require("../../../../script/startDom");
var _useReload = require("../../../../script/src/dom/hooks/useReload");
function ProductsWithFilter() {
    var _this = this;
    return (0, _domSection.DomSection)('sectionProductsWithFilter', function() {
        return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(Section, {}, void 0, false, {
            fileName: "src/sections/productsWithFilter/js/dom/index.tsx",
            lineNumber: 11,
            columnNumber: 58
        }, _this);
    });
}
function Section() {
    var section = (0, _std.unwrap)((0, _domElement.useDomElement)().element);
    var reloadDomApp = (0, _useReload.useReloadDomApp)();
    var deps = (0, _react.useContext)((0, _startDom.DomParamsContext)).deps;
    var filtersForm = (0, _std.unwrap)((0, _domElement.useDomElement)('[data-id=filtersForm]').element);
    var drawerFilters = (0, _std.unwrap)((0, _domElement.useDomElement)('[data-id=drawerFilters]').element);
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), isLoading = _useState[0], setIsLoading = _useState[1];
    var _useState1 = (0, _slicedToArray._)((0, _react.useState)(), 2), filtersFormStateOnOpen = _useState1[0], setFiltersFormStateOnOpen = _useState1[1];
    var _useState2 = (0, _slicedToArray._)((0, _react.useState)(false), 2), filtersOpened = _useState2[0], setFiltersOpened = _useState2[1];
    var sectionShopifyId = (0, _domElement.useNullableAttributeValue)('data-section_shopify_id', '[data-section_shopify_id]');
    function applyFilters(filters) {
        return _applyFilters.apply(this, arguments);
    }
    function _applyFilters() {
        _applyFilters = (0, _asyncToGenerator._)(function(filters) {
            var result;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        closeFilters();
                        setIsLoading(true);
                        return [
                            4,
                            deps.waitAtLeast(fetch(`?section_id=${sectionShopifyId}&${filters}`).then(function(result) {
                                return result.text();
                            }), 600)
                        ];
                    case 1:
                        result = _state.sent();
                        section.outerHTML = result;
                        setIsLoading(false);
                        reloadDomApp();
                        return [
                            2
                        ];
                }
            });
        });
        return _applyFilters.apply(this, arguments);
    }
    function applyDrawerFilters() {
        return _applyDrawerFilters.apply(this, arguments);
    }
    function _applyDrawerFilters() {
        _applyDrawerFilters = (0, _asyncToGenerator._)(function() {
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            applyFilters(getDrawerFiltersStringValue())
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return _applyDrawerFilters.apply(this, arguments);
    }
    function getDrawerFiltersStringValue() {
        var formData = new FormData(filtersForm);
        return new URLSearchParams(formData).toString();
    }
    function openFilters() {
        setFiltersOpened(true);
        setFiltersFormStateOnOpen(filtersForm.outerHTML);
    }
    function closeFilters() {
        setFiltersOpened(false);
        if (filtersFormStateOnOpen) filtersForm.outerHTML = filtersFormStateOnOpen;
    }
    function resetDrawerFilters() {
        filtersForm.querySelectorAll('input[type=checkbox]').forEach(function(el) {
            return el.checked = false;
        });
    }
    function updateDrawerFilters() {
        return _updateDrawerFilters.apply(this, arguments);
    }
    function _updateDrawerFilters() {
        _updateDrawerFilters = (0, _asyncToGenerator._)(function() {
            var filters, result;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        filters = getDrawerFiltersStringValue();
                        return [
                            4,
                            fetch(`?view=productsWithFilter__drawerFilters&${filters}`).then(function(result) {
                                return result.text();
                            })
                        ];
                    case 1:
                        result = _state.sent();
                        drawerFilters.outerHTML = result;
                        reloadDomApp();
                        return [
                            2
                        ];
                }
            });
        });
        return _updateDrawerFilters.apply(this, arguments);
    }
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _jsxDevRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
                selector: "[data-id=drawerFilters]",
                data: {
                    opened: filtersOpened
                }
            }, void 0, false, {
                fileName: "src/sections/productsWithFilter/js/dom/index.tsx",
                lineNumber: 70,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
                selector: "[data-id=products]",
                data: {
                    isLoading: isLoading
                }
            }, void 0, false, {
                fileName: "src/sections/productsWithFilter/js/dom/index.tsx",
                lineNumber: 71,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(LiquidActions, {
                actions: {
                    applyFilters: applyFilters,
                    applyDrawerFilters: applyDrawerFilters,
                    openFilters: openFilters,
                    closeFilters: closeFilters,
                    resetDrawerFilters: resetDrawerFilters,
                    updateDrawerFilters: updateDrawerFilters
                }
            }, void 0, false, {
                fileName: "src/sections/productsWithFilter/js/dom/index.tsx",
                lineNumber: 72,
                columnNumber: 13
            }, this)
        ]
    }, void 0, true);
}
function LiquidActions(props) {
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _jsxDevRuntime.Fragment), {
        children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domArray.DomArray), {
            selector: "[data-onClick]",
            child: function(param) {
                var key = param.key, selector = param.selector;
                var type = (0, _domElement.useNullableAttributeValue)('data-onClick', selector);
                var filters = (0, _domElement.useNullableAttributeValue)('data-filters', selector);
                function handleOpen() {
                    switch(type){
                        case 'applyFilters':
                            return props.actions.applyFilters((0, _std.unwrap)(filters));
                        case 'applyDrawerFilters':
                            return props.actions.applyDrawerFilters();
                        case 'openFilters':
                            return props.actions.openFilters();
                        case 'closeFilters':
                            return props.actions.closeFilters();
                        case 'resetDrawerFilters':
                            return props.actions.resetDrawerFilters();
                        case 'updateDrawerFilters':
                            return props.actions.updateDrawerFilters();
                    }
                }
                return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
                    selector: selector,
                    onClick: handleOpen
                }, key, false, {
                    fileName: "src/sections/productsWithFilter/js/dom/index.tsx",
                    lineNumber: 118,
                    columnNumber: 21
                }, void 0);
            }
        }, void 0, false, {
            fileName: "src/sections/productsWithFilter/js/dom/index.tsx",
            lineNumber: 96,
            columnNumber: 13
        }, this)
    }, void 0, false);
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_sliced_to_array":"ha6sq","@swc/helpers/_/_ts_generator":"f2hGH","react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","../../../../script/src/dom/library/DomSection":"gcFCP","../../../../script/src/dom/library/DomElement":"15N7Q","@reglo/std":"1USo0","../../../../script/src/dom/library/DomArray":"ZEl1X","../../../../script/src/dom/library/DomComponent":"8H9za","../../../../script/startDom":"iwlTF","../../../../script/src/dom/hooks/useReload":"f9rI7","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"246fu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChoiceHelper", function() {
    return ChoiceHelper;
});
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _domSection = require("../../../script/src/dom/library/DomSection");
var _reactRedux = require("react-redux");
var _domComponent = require("../../../script/src/dom/library/DomComponent");
var _choiceHelperView = require("../views/choiceHelperView");
var _form = require("./form");
var _results = require("./results");
var _loadForm = require("../useCases/loadForm");
function ChoiceHelper() {
    var _this = this;
    return (0, _domSection.DomSection)('sectionChoiceHelper', function() {
        return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(Section, {}, void 0, false, {
            fileName: "src/sections/choiceHelper/liquid/index.tsx",
            lineNumber: 11,
            columnNumber: 52
        }, _this);
    });
}
function Section() {
    var dispatch = (0, _reactRedux.useDispatch)();
    (0, _react.useEffect)(function() {
        dispatch((0, _loadForm.LoadForm)());
    }, []);
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _jsxDevRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(Loader, {}, void 0, false, {
                fileName: "src/sections/choiceHelper/liquid/index.tsx",
                lineNumber: 23,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _form.Form), {}, void 0, false, {
                fileName: "src/sections/choiceHelper/liquid/index.tsx",
                lineNumber: 24,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _results.Results), {}, void 0, false, {
                fileName: "src/sections/choiceHelper/liquid/index.tsx",
                lineNumber: 25,
                columnNumber: 13
            }, this)
        ]
    }, void 0, true);
}
function Loader() {
    var view = (0, _reactRedux.useSelector)((0, _choiceHelperView.choiceHelperView));
    var isLoading = view.step === 'loading' || view.step === 'computing';
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
        selector: "[data-id=loader]",
        data: {
            isLoading: isLoading
        }
    }, void 0, false, {
        fileName: "src/sections/choiceHelper/liquid/index.tsx",
        lineNumber: 35,
        columnNumber: 9
    }, this);
}

},{"react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","../../../script/src/dom/library/DomSection":"gcFCP","react-redux":"ghMZu","../../../script/src/dom/library/DomComponent":"8H9za","../views/choiceHelperView":"6ICEJ","./form":"3fwCV","./results":"l7tde","../useCases/loadForm":"4qcHz","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6ICEJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "choiceHelperView", function() {
    return choiceHelperView;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _std = require("@reglo/std");
var _reselect = require("reselect");
var _state = require("../state");
var choiceHelperView = (0, _reselect.createSelector)((0, _state.choiceHelperSelector), prepareView);
function prepareView(state) {
    var _state_results, _state_results1;
    var _ref;
    var selectedResult = (_ref = state.selectedResult ? (_state_results = state.results) === null || _state_results === void 0 ? void 0 : _state_results.find(function(result) {
        return result.productType === state.selectedResult;
    }) : (_state_results1 = state.results) === null || _state_results1 === void 0 ? void 0 : _state_results1[0]) !== null && _ref !== void 0 ? _ref : null;
    var _state_results2;
    return {
        step: state.step,
        results: (_state_results2 = state.results) !== null && _state_results2 !== void 0 ? _state_results2 : [],
        selectedResult: selectedResult ? (0, _objectSpread._)({
            dogName: (0, _std.unwrap)(state.dogName),
            dogSize: (0, _std.unwrap)(state.dogSize)
        }, selectedResult) : null
    };
}

},{"@swc/helpers/_/_object_spread":"4bEWH","@reglo/std":"1USo0","reselect":"fb6q1","../state":"jTUgf","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jTUgf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "choiceHelperReducer", function() {
    return choiceHelperReducer;
});
parcelHelpers.export(exports, "choiceHelperSelector", function() {
    return choiceHelperSelector;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _loadForm = require("../useCases/loadForm");
var _computeResult = require("../useCases/computeResult");
var _selectResult = require("../useCases/selectResult");
var initialState = {
    step: 'loading',
    dogName: null,
    dogSize: null,
    results: null,
    selectedResult: null
};
function choiceHelperReducer() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, event = arguments.length > 1 ? arguments[1] : void 0;
    switch(event.type){
        case 0, _loadForm.FormLoadedKey:
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                step: 'form'
            });
        case 0, _computeResult.ComputeResultsKey:
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                step: 'computing'
            });
        case 0, _computeResult.ResultsComputedKey:
            return (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                step: 'result'
            }), event.payload);
        case 0, _selectResult.SelectResultKey:
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, state), {
                selectedResult: event.payload.productType
            });
        default:
            return state;
    }
}
function choiceHelperSelector(state) {
    return state.sections.choiceHelper;
}

},{"@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_object_spread_props":"fLCYP","../useCases/loadForm":"4qcHz","../useCases/computeResult":"aaxUw","../useCases/selectResult":"iRVDh","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4qcHz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LoadFormKey", function() {
    return LoadFormKey;
});
parcelHelpers.export(exports, "LoadForm", function() {
    return LoadForm;
});
parcelHelpers.export(exports, "FormLoadedKey", function() {
    return FormLoadedKey;
});
parcelHelpers.export(exports, "FormLoaded", function() {
    return FormLoaded;
});
parcelHelpers.export(exports, "loadForm", function() {
    return loadForm;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _eventFactory = require("../../../script/src/std/eventFactory");
var LoadFormKey = 'ChoiceHelper.LoadForm';
var LoadForm = (0, _eventFactory.eventFactory)(LoadFormKey)();
var FormLoadedKey = 'ChoiceHelper.FormLoaded';
var FormLoaded = (0, _eventFactory.eventFactory)(FormLoadedKey)();
function loadForm(deps) {
    return /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(event) {
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            deps.track('StartChoiceHelperForm')
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }();
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_ts_generator":"f2hGH","../../../script/src/std/eventFactory":"f2PpV","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"aaxUw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ComputeResultsKey", function() {
    return ComputeResultsKey;
});
parcelHelpers.export(exports, "ComputeResults", function() {
    return ComputeResults;
});
parcelHelpers.export(exports, "ResultsComputedKey", function() {
    return ResultsComputedKey;
});
parcelHelpers.export(exports, "ResultsComputed", function() {
    return ResultsComputed;
});
parcelHelpers.export(exports, "computeResults", function() {
    return computeResults;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _eventFactory = require("../../../script/src/std/eventFactory");
var _std = require("@reglo/std");
var ComputeResultsKey = 'ChoiceHelper.ComputeResults';
var ComputeResults = (0, _eventFactory.eventFactory)(ComputeResultsKey)();
var ResultsComputedKey = 'ChoiceHelper.ResultsComputed';
var ResultsComputed = (0, _eventFactory.eventFactory)(ResultsComputedKey)();
function computeResults(deps) {
    return /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(event) {
            var response, resultsParams, results;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        response = event.payload.response;
                        resultsParams = computeResultsParams(response);
                        return [
                            4,
                            deps.waitAtLeast(loadResults(resultsParams), 3000)
                        ];
                    case 1:
                        results = _state.sent();
                        return [
                            4,
                            deps.publishEvent(ResultsComputed({
                                dogName: response.name,
                                dogSize: computeDogSize(response),
                                results: results
                            }))
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            deps.track('ChoiceHelperRecommendation', {
                                dogSize: computeDogSize(response),
                                dogAge: computeAge(response),
                                wantsNoGrain: response.wantsNoGrain,
                                needsHypoallergenic: response.needsHypoallergenic
                            })
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }();
    function computeDogSize(response) {
        var age = computeAge(response);
        if (age === 'puppy') return response.weight < 10 ? 'small' : response.weight < 25 ? 'medium' : 'large';
        return response.weight < 10 ? 'small' : response.weight < 30 ? 'medium' : 'large';
    }
    function computeAge(response) {
        var months = response.age.years * 12 + response.age.months;
        if (months > 9 && response.weight <= 5) return 'adult';
        if (months > 10 && response.weight <= 10) return 'adult';
        if (months > 12 && response.weight <= 25) return 'adult';
        if (months > 14) return 'adult';
        return 'puppy';
    }
    function computeResultsParams(response) {
        var size = computeDogSize(response);
        var age = computeAge(response);
        var products = [
            {
                type: 'CHIEN-LOWGRAIN-S',
                age: 'adult',
                category: 'lowgrain',
                size: [
                    'small'
                ]
            },
            {
                type: 'CHIEN-LOWGRAIN-M',
                age: 'adult',
                category: 'lowgrain',
                size: [
                    'medium'
                ]
            },
            {
                type: 'CHIEN-LOWGRAIN-L',
                age: 'adult',
                category: 'lowgrain',
                size: [
                    'large'
                ]
            },
            {
                type: 'CHIEN-GRAINFREE-S',
                age: 'adult',
                category: 'grainfree',
                size: [
                    'small'
                ]
            },
            {
                type: 'CHIEN-GRAINFREE-M',
                age: 'adult',
                category: 'grainfree',
                size: [
                    'medium'
                ]
            },
            {
                type: 'CHIEN-GRAINFREE-L',
                age: 'adult',
                category: 'grainfree',
                size: [
                    'large'
                ]
            },
            {
                type: 'CHIEN-HYPO-S',
                age: 'adult',
                category: 'hypo',
                size: [
                    'small'
                ]
            },
            {
                type: 'CHIEN-HYPO-M',
                age: 'adult',
                category: 'hypo',
                size: [
                    'medium'
                ]
            },
            {
                type: 'CHIEN-HYPO-L',
                age: 'adult',
                category: 'hypo',
                size: [
                    'large'
                ]
            },
            {
                type: 'CHIOT-LOWGRAIN-SM',
                age: 'puppy',
                category: 'lowgrain',
                size: [
                    'small',
                    'medium'
                ]
            },
            {
                type: 'CHIOT-LOWGRAIN-L',
                age: 'puppy',
                category: 'lowgrain',
                size: [
                    'large'
                ]
            },
            {
                type: 'CHIOT-GRAINFREE',
                age: 'puppy',
                category: 'grainfree',
                size: [
                    'small',
                    'medium',
                    'large'
                ]
            }
        ];
        var results = [];
        if (!response.needsHypoallergenic && !response.wantsNoGrain) results.push({
            category: 'lowgrain',
            type: age === 'puppy' ? 'puppy_default' : 'dog_default'
        });
        if (response.needsHypoallergenic) results.push({
            category: age === 'puppy' ? 'grainfree' : 'hypo',
            type: age === 'puppy' ? 'puppy_default' : 'dog_hypo'
        });
        else results.push({
            category: 'grainfree',
            type: age === 'puppy' ? 'puppy_default' : 'dog_default'
        });
        return results.map(function(result) {
            return {
                productType: (0, _std.unwrap)(products.find(function(product) {
                    return product.size.includes(size) && product.age === age && product.category === result.category;
                })).type,
                resultType: result.type
            };
        });
    }
    function loadResults(resultsParams) {
        return Promise.all(resultsParams.map(deps.choiceHelper.loadProductResult));
    }
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_ts_generator":"f2hGH","../../../script/src/std/eventFactory":"f2PpV","@reglo/std":"1USo0","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"iRVDh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SelectResultKey", function() {
    return SelectResultKey;
});
parcelHelpers.export(exports, "SelectResult", function() {
    return SelectResult;
});
var _eventFactory = require("../../../script/src/std/eventFactory");
var SelectResultKey = 'ChoiceHelper.SelectResult';
var SelectResult = (0, _eventFactory.eventFactory)(SelectResultKey)();

},{"../../../script/src/std/eventFactory":"f2PpV","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3fwCV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Form", function() {
    return Form;
});
parcelHelpers.export(exports, "parseFormResult", function() {
    return parseFormResult;
});
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _reactRedux = require("react-redux");
var _choiceHelperView = require("../views/choiceHelperView");
var _loadForm = require("../useCases/loadForm");
var _classnames = require("classnames");
var _classnamesDefault = parcelHelpers.interopDefault(_classnames);
var _tally = require("../../../snippets/components/tally/Tally");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _std = require("@reglo/std");
var _dateFns = require("date-fns");
var _computeResult = require("../useCases/computeResult");
var _domPortal = require("../../../script/src/dom/library/DomPortal");
function Form() {
    var view = (0, _reactRedux.useSelector)((0, _choiceHelperView.choiceHelperView));
    var isActive = view.step === 'loading' || view.step === 'form';
    var dispatch = (0, _reactRedux.useDispatch)();
    var exec = false;
    (0, _react.useEffect)(function() {
        return; // DEBUG
    }, []);
    function handleLoaded() {
        return dispatch((0, _loadForm.FormLoaded)());
    }
    function handleSubmit(payload) {
        var response = parseFormResult(payload);
        return dispatch((0, _computeResult.ComputeResults)({
            response: response
        }));
    }
    if (!isActive) return null;
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domPortal.DomPortal), {
        selector: "[data-id=form]",
        children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
            className: (0, _classnamesDefault.default)({
                'sectionChoiceHelper__form': true,
                'sectionChoiceHelper__form--isHidden': view.step === 'loading'
            }),
            children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _tally.TallyComponent), {
                formId: "mVzdVy",
                onLoaded: handleLoaded,
                onSubmit: handleSubmit
            }, void 0, false, {
                fileName: "src/sections/choiceHelper/liquid/form.tsx",
                lineNumber: 67,
                columnNumber: 17
            }, this)
        }, void 0, false, {
            fileName: "src/sections/choiceHelper/liquid/form.tsx",
            lineNumber: 63,
            columnNumber: 13
        }, this)
    }, void 0, false, {
        fileName: "src/sections/choiceHelper/liquid/form.tsx",
        lineNumber: 62,
        columnNumber: 9
    }, this);
}
function parseFormResult(data) {
    return {
        name: data.fields.find(function(field) {
            return field.title === 'name';
        }).answer.value,
        sex: data.fields.find(function(field) {
            return field.title === 'sex';
        }).answer.value,
        breed: prepareBreed(),
        sterilized: data.fields.find(function(field) {
            return field.title === 'sterilized';
        }).answer.value === 'true',
        weight: data.fields.find(function(field) {
            return field.title === 'weight';
        }).answer.value,
        age: prepareAge(),
        activity: data.fields.find(function(field) {
            return field.title === 'activity';
        }).answer.value,
        corpulence: data.fields.find(function(field) {
            return field.title === 'corpulence';
        }).answer.value,
        wantsNoGrain: data.fields.find(function(field) {
            return field.title === 'no_grain';
        }).answer.value === "true",
        needsHypoallergenic: prepareNeedsHypoallergenic()
    };
    function prepareAge() {
        var usingBirthday = !!data.fields.find(function(field) {
            return field.title === 'input_birthday';
        }).answer.value;
        if (usingBirthday) {
            var birthday = new Date(data.fields.find(function(field) {
                return field.title === 'birthday';
            }).answer.value);
            var months = (0, _dateFns.differenceInMonths)(new Date(), birthday);
            return {
                years: Math.floor(months / 12),
                months: months % 12
            };
        }
        var _data_fields_find_answer_value;
        var months1 = data.fields.find(function(field) {
            return field.title === 'age_years';
        }).answer.value * 12 + ((_data_fields_find_answer_value = data.fields.find(function(field) {
            return field.title === 'age_months';
        }).answer.value) !== null && _data_fields_find_answer_value !== void 0 ? _data_fields_find_answer_value : 0);
        return {
            years: Math.floor(months1 / 12),
            months: months1 % 12
        };
    }
    function prepareBreed() {
        var field = data.fields.find(function(field) {
            return field.title === 'breed';
        });
        if (field.answer.value === '') return false;
        else if (field.answer.raw.length === 1) return (0, _std.dogBreedFromName)(field.answer.value);
        else if (field.answer.raw.length === 2) return field.answer.value.split(',').map(function(value) {
            return (0, _std.dogBreedFromName)(value.trim());
        });
        else throw new Error();
    }
    function prepareNeedsHypoallergenic() {
        var hasAllergies = data.fields.find(function(field) {
            return field.title === 'has_allergies';
        }).answer.value === "true";
        if (hasAllergies) return true;
        return !!data.fields.find(function(field) {
            return field.title === 'symptomes_text' && field.answer.value;
        });
    }
}

},{"react/jsx-dev-runtime":"jXZ8I","react-redux":"ghMZu","../views/choiceHelperView":"6ICEJ","../useCases/loadForm":"4qcHz","classnames":"4SuBi","../../../snippets/components/tally/Tally":"163TP","react":"c8CN1","@reglo/std":"1USo0","date-fns":"6cTOl","../useCases/computeResult":"aaxUw","../../../script/src/dom/library/DomPortal":"6g2UR","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"163TP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TallyComponent", function() {
    return TallyComponent;
});
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _std = require("@reglo/std");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function TallyComponent(props) {
    (0, _react.useEffect)(function() {
        var widgetScriptSrc = 'https://tally.so/widgets/embed.js';
        var load = function() {
            // Load Tally embeds
            if (typeof Tally !== 'undefined') {
                Tally.loadEmbeds();
                return;
            }
            // Fallback if window.Tally is not available
            document.querySelectorAll('iframe[data-tally-src]:not([src])').forEach(function(iframeEl) {
                var iframeElCast = iframeEl;
                iframeElCast.src = (0, _std.unwrap)(iframeElCast.dataset.tallySrc);
            });
        };
        // If Tally is already loaded, load the embeds
        if (typeof Tally !== 'undefined') {
            load();
            return;
        }
        // If the Tally widget script is not loaded yet, load it
        if (document.querySelector(`script[src="${widgetScriptSrc}"]`) === null) {
            var script = document.createElement('script');
            script.src = widgetScriptSrc;
            script.onload = load;
            script.onerror = load;
            document.body.appendChild(script);
            return;
        }
    }, []);
    (0, _react.useEffect)(function() {
        window.addEventListener('message', listener);
        return function() {
            return window.removeEventListener('message', listener);
        };
    }, []);
    function listener(event) {
        try {
            var data = JSON.parse(event.data);
            switch(data === null || data === void 0 ? void 0 : data.event){
                case 'Tally.FormLoaded':
                    var _props_onLoaded;
                    return (_props_onLoaded = props.onLoaded) === null || _props_onLoaded === void 0 ? void 0 : _props_onLoaded.call(props);
                case 'Tally.FormSubmitted':
                    var _props_onSubmit;
                    return (_props_onSubmit = props.onSubmit) === null || _props_onSubmit === void 0 ? void 0 : _props_onSubmit.call(props, data.payload);
            }
        } catch (error) {}
    }
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("iframe", {
        "data-tally-src": `https://tally.so/embed/${props.formId}?alignLeft=1&hideTitle=1&transparentBackground=1&dynamicHeight=1`,
        loading: "lazy",
        width: "100%",
        height: "1",
        frameBorder: 0,
        marginHeight: 0,
        marginWidth: 0
    }, void 0, false, {
        fileName: "src/snippets/components/tally/Tally.tsx",
        lineNumber: 64,
        columnNumber: 9
    }, this);
}

},{"react/jsx-dev-runtime":"jXZ8I","@reglo/std":"1USo0","react":"c8CN1","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"l7tde":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Results", function() {
    return Results;
});
parcelHelpers.export(exports, "ResultComponent", function() {
    return ResultComponent;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRedux = require("react-redux");
var _choiceHelperView = require("../views/choiceHelperView");
var _domComponent = require("../../../script/src/dom/library/DomComponent");
var _useReload = require("../../../script/src/dom/hooks/useReload");
var _domPortal = require("../../../script/src/dom/library/DomPortal");
var _std = require("@reglo/std");
var _selectResult = require("../useCases/selectResult");
var _hooks = require("../../../script/src/std/hooks");
function Results() {
    var _this = this;
    var _view_selectedResult;
    var view = (0, _reactRedux.useSelector)((0, _choiceHelperView.choiceHelperView));
    var reloadDomApp = (0, _useReload.useReloadDomApp)();
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), isLoading = _useState[0], setIsLoading = _useState[1];
    (0, _react.useEffect)(reloadDomApp, [
        (_view_selectedResult = view.selectedResult) === null || _view_selectedResult === void 0 ? void 0 : _view_selectedResult.pageHtml
    ]);
    (0, _hooks.useOnEvent)((0, _selectResult.SelectResultKey), function() {
        setIsLoading(true);
        setTimeout(function() {
            setIsLoading(false);
        }, 600);
    });
    if (view.step !== 'result') return null;
    var selectedResult = (0, _std.unwrap)(view.selectedResult);
    var hasMultipleResults = view.results.length > 1;
    var size = {
        'small': 'moins de 10 kg',
        'medium': "10 \xe0 30 kg",
        'large': 'plus de 30 kg'
    }[selectedResult.dogSize];
    var body = selectedResult.pageHtml.replace('[[ quizz__name ]]', selectedResult.dogName).replace('[[ quizz__size ]]', size);
    var title = hasMultipleResults ? `Nos recommandations pour ${selectedResult.dogName}` : `Notre recommandation pour ${selectedResult.dogName}`;
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
        selector: "[data-id=results]",
        data: {
            isLoading: isLoading
        },
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domPortal.DomPortal), {
                selector: "[data-id=results__header]",
                children: [
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("h1", {
                        className: "sectionChoiceHelper__results__header__title",
                        children: title
                    }, void 0, false, {
                        fileName: "src/sections/choiceHelper/liquid/results.tsx",
                        lineNumber: 47,
                        columnNumber: 17
                    }, this),
                    hasMultipleResults && /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
                        className: "sectionChoiceHelper__results__header__selector",
                        children: view.results.map(function(result) {
                            return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(ResultComponent, {
                                result: result
                            }, result.productType, false, {
                                fileName: "src/sections/choiceHelper/liquid/results.tsx",
                                lineNumber: 49,
                                columnNumber: 49
                            }, _this);
                        })
                    }, void 0, false, {
                        fileName: "src/sections/choiceHelper/liquid/results.tsx",
                        lineNumber: 48,
                        columnNumber: 40
                    }, this)
                ]
            }, void 0, true, {
                fileName: "src/sections/choiceHelper/liquid/results.tsx",
                lineNumber: 46,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
                selector: "[data-id=results__body]",
                innerHtml: body
            }, void 0, false, {
                fileName: "src/sections/choiceHelper/liquid/results.tsx",
                lineNumber: 52,
                columnNumber: 13
            }, this)
        ]
    }, void 0, true, {
        fileName: "src/sections/choiceHelper/liquid/results.tsx",
        lineNumber: 45,
        columnNumber: 9
    }, this);
}
function ResultComponent(props) {
    var _view_selectedResult;
    var view = (0, _reactRedux.useSelector)((0, _choiceHelperView.choiceHelperView));
    var dispatch = (0, _hooks.useDispatch)();
    var productType = (0, _std.unwrap)(props.result).productType;
    var isSelected = ((_view_selectedResult = view.selectedResult) === null || _view_selectedResult === void 0 ? void 0 : _view_selectedResult.productType) === props.result.productType;
    function html() {
        if (!isSelected) return props.result.selectorHtml;
        return props.result.selectorHtml.replace(/<([^ ]+) /, '<$1 data-isSelected ');
    }
    function handleClick() {
        if (isSelected) return;
        dispatch((0, _selectResult.SelectResult)({
            productType: productType
        }));
    }
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)("div", {
        dangerouslySetInnerHTML: {
            __html: html()
        },
        onClick: handleClick
    }, void 0, false, {
        fileName: "src/sections/choiceHelper/liquid/results.tsx",
        lineNumber: 81,
        columnNumber: 9
    }, this);
}

},{"@swc/helpers/_/_sliced_to_array":"ha6sq","react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","react-redux":"ghMZu","../views/choiceHelperView":"6ICEJ","../../../script/src/dom/library/DomComponent":"8H9za","../../../script/src/dom/hooks/useReload":"f9rI7","../../../script/src/dom/library/DomPortal":"6g2UR","@reglo/std":"1USo0","../useCases/selectResult":"iRVDh","../../../script/src/std/hooks":"j9RPQ","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8HnTs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "choiceHelperDeps", function() {
    return choiceHelperDeps;
});
var _loadProductResult = require("./loadProductResult");
function choiceHelperDeps(deps) {
    return {
        loadProductResult: (0, _loadProductResult.loadProductResult)(deps)
    };
}

},{"./loadProductResult":"dF4dO","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"dF4dO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loadProductResult", function() {
    return loadProductResult;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _std = require("@reglo/std");
var _products = require("../../../script/src/app/store/state/data/products");
function loadProductResult(deps) {
    return /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(params) {
            var rawHtml, selectorHtml, pageHtml;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            requestRawHtmls(params)
                        ];
                    case 1:
                        rawHtml = _state.sent();
                        selectorHtml = rawHtml.selectorHtml;
                        pageHtml = prepareHtml(rawHtml);
                        return [
                            2,
                            (0, _objectSpreadProps._)((0, _objectSpread._)({}, params), {
                                selectorHtml: selectorHtml,
                                pageHtml: pageHtml
                            })
                        ];
                }
            });
        });
        return function(params) {
            return _ref.apply(this, arguments);
        };
    }();
    function requestRawHtmls(params) {
        return _requestRawHtmls.apply(this, arguments);
    }
    function _requestRawHtmls() {
        _requestRawHtmls = (0, _asyncToGenerator._)(function(params) {
            var productHandle, view, _ref, selectorHtml, heroHtml, coreHtml;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        productHandle = prepareProductHandle(params);
                        view = prepareView(params);
                        return [
                            4,
                            Promise.all([
                                fetch(`/products/${productHandle}?view=choiceHelper__resultSelector`).then(function(result) {
                                    return result.text();
                                }),
                                fetch(`/products/${productHandle}?view=${view}`).then(function(result) {
                                    return result.text();
                                }),
                                fetch(`/products/${productHandle}`).then(function(result) {
                                    return result.text();
                                })
                            ])
                        ];
                    case 1:
                        _ref = (0, _slicedToArray._).apply(void 0, [
                            _state.sent(),
                            3
                        ]), selectorHtml = _ref[0], heroHtml = _ref[1], coreHtml = _ref[2];
                        return [
                            2,
                            {
                                selectorHtml: selectorHtml,
                                heroHtml: heroHtml,
                                coreHtml: coreHtml
                            }
                        ];
                }
            });
        });
        return _requestRawHtmls.apply(this, arguments);
    }
    function prepareProductHandle(params) {
        var product = (0, _std.unwrap)(deps.getState((0, _products.productByTypeSelector)(params.productType)));
        return product.handle;
    }
    function prepareView(params) {
        switch(params.resultType){
            case 'dog_default':
                return 'quizz_chien_defaut';
            case 'dog_digestion':
                return 'quizz_chien_digest';
            case 'dog_hypo':
                return 'quizz_chien_hypo';
            case 'puppy_default':
                return 'quizz_chiot_defaut';
            default:
                return (0, _std.assertNever)(params.resultType);
        }
    }
    function prepareHtml(params) {
        var _params_heroHtml_match, _params_coreHtml_match;
        var heroHtml = (_params_heroHtml_match = params.heroHtml.match(RegExp("<main>(.*)<\\/main>", "s"))) === null || _params_heroHtml_match === void 0 ? void 0 : _params_heroHtml_match[1];
        var coreHtml = (_params_coreHtml_match = params.coreHtml.match(RegExp("<main>(.*)<\\/main>", "s"))) === null || _params_coreHtml_match === void 0 ? void 0 : _params_coreHtml_match[1].replace(RegExp("<section [^>]*sectionProductHero[^>]*>.*?<\\/section>", "s"), '');
        return `${heroHtml}${coreHtml}`;
    }
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_object_spread_props":"fLCYP","@swc/helpers/_/_sliced_to_array":"ha6sq","@swc/helpers/_/_ts_generator":"f2hGH","@reglo/std":"1USo0","../../../script/src/app/store/state/data/products":"17rrh","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"FC17t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "choiceHelperHandlers", function() {
    return choiceHelperHandlers;
});
var _computeResult = require("../useCases/computeResult");
var _loadForm = require("../useCases/loadForm");
function choiceHelperHandlers(param) {
    var eventBus = param.eventBus, deps = param.deps;
    eventBus.subscribeTo((0, _computeResult.ComputeResultsKey), (0, _computeResult.computeResults)(deps));
    eventBus.subscribeTo((0, _loadForm.LoadFormKey), (0, _loadForm.loadForm)(deps));
}

},{"../useCases/computeResult":"aaxUw","../useCases/loadForm":"4qcHz","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"9ReXb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Testimonials", function() {
    return Testimonials;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _domArray = require("../../../script/src/dom/library/DomArray");
var _std = require("@reglo/std");
var _domElement = require("../../../script/src/dom/library/DomElement");
var _domComponent = require("../../../script/src/dom/library/DomComponent");
var _swiper = require("swiper");
var _swiperDefault = parcelHelpers.interopDefault(_swiper);
var _modules = require("swiper/modules");
var _layout = require("../../../script/src/dom/layout");
var _testimonial = require("../snippets/testimonial");
var _videoPlayer = require("../snippets/videoPlayer");
function Testimonials() {
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domArray.DomArray), {
        selector: ".sectionTestimonials",
        child: function(param) {
            var key = param.key, selector = param.selector;
            return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
                selector: selector,
                children: [
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(Slider, {}, void 0, false, {
                        fileName: "src/sections/testimonials/liquid/index.tsx",
                        lineNumber: 16,
                        columnNumber: 13
                    }, void 0),
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(Items, {}, void 0, false, {
                        fileName: "src/sections/testimonials/liquid/index.tsx",
                        lineNumber: 17,
                        columnNumber: 13
                    }, void 0),
                    /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _videoPlayer.VideoPlayer), {}, void 0, false, {
                        fileName: "src/sections/testimonials/liquid/index.tsx",
                        lineNumber: 18,
                        columnNumber: 13
                    }, void 0)
                ]
            }, key, true, {
                fileName: "src/sections/testimonials/liquid/index.tsx",
                lineNumber: 15,
                columnNumber: 81
            }, void 0);
        }
    }, void 0, false, {
        fileName: "src/sections/testimonials/liquid/index.tsx",
        lineNumber: 15,
        columnNumber: 9
    }, this);
}
function Items() {
    var layout = useLayout();
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domArray.DomArray), {
        selector: "[data-id=testimonial]",
        child: function(param) {
            var key = param.key, selector = param.selector;
            return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
                selector: selector,
                children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _testimonial.Testimonial), {
                    layout: layout
                }, void 0, false, {
                    fileName: "src/sections/testimonials/liquid/index.tsx",
                    lineNumber: 27,
                    columnNumber: 126
                }, void 0)
            }, key, false, {
                fileName: "src/sections/testimonials/liquid/index.tsx",
                lineNumber: 27,
                columnNumber: 82
            }, void 0);
        }
    }, void 0, false, {
        fileName: "src/sections/testimonials/liquid/index.tsx",
        lineNumber: 27,
        columnNumber: 9
    }, this);
}
function useLayout() {
    return (0, _domElement.useAttributeValue)('data-layout', '.sectionTestimonials__sliderContainer');
}
function Slider() {
    var container = (0, _std.unwrap)((0, _domElement.useDomElement)('[data-id=slider]').element);
    var pagination = (0, _std.unwrap)((0, _domElement.useDomElement)('[data-id=pagination]').element);
    var layout = useLayout();
    function sliderConfig() {
        switch(layout){
            case 'photos':
                return {
                    modules: [
                        (0, _modules.FreeMode),
                        (0, _modules.Mousewheel),
                        (0, _modules.Pagination)
                    ],
                    freeMode: true,
                    slidesPerView: 'auto',
                    spaceBetween: 17,
                    breakpoints: (0, _defineProperty._)({}, (0, _layout.Breakpoint).MD, {
                        spaceBetween: 26
                    })
                };
            case 'videos':
                var _obj;
                return {
                    modules: [
                        (0, _modules.Mousewheel),
                        (0, _modules.Pagination),
                        (0, _modules.Navigation)
                    ],
                    freeMode: false,
                    slidesPerView: 1,
                    spaceBetween: 17,
                    loop: true,
                    navigation: {
                        prevEl: '[data-id=leftControl]',
                        nextEl: '[data-id=rightControl]'
                    },
                    breakpoints: (_obj = {}, (0, _defineProperty._)(_obj, (0, _layout.Breakpoint).MD, {
                        slidesPerView: 2,
                        spaceBetween: 26
                    }), (0, _defineProperty._)(_obj, (0, _layout.Breakpoint).LG, {
                        slidesPerView: 3
                    }), _obj)
                };
            default:
                throw new Error();
        }
    }
    var init = false;
    (0, _react.useEffect)(function() {
        if (init) return;
        init = true;
        new (0, _swiperDefault.default)(container, (0, _objectSpreadProps._)((0, _objectSpread._)({}, sliderConfig()), {
            mousewheel: {
                forceToAxis: true
            },
            pagination: {
                el: pagination
            }
        }));
        container.setAttribute('data-is_initialized', '');
    }, []);
    return null;
}

},{"@swc/helpers/_/_define_property":"54Zvk","@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_object_spread_props":"fLCYP","react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","../../../script/src/dom/library/DomArray":"ZEl1X","@reglo/std":"1USo0","../../../script/src/dom/library/DomElement":"15N7Q","../../../script/src/dom/library/DomComponent":"8H9za","swiper":"8wPRQ","swiper/modules":"4UOSx","../../../script/src/dom/layout":"bHp5c","../snippets/testimonial":"gTIiw","../snippets/videoPlayer":"hdDJA","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"bHp5c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Breakpoint", function() {
    return Breakpoint;
});
var Breakpoint = /*#__PURE__*/ function(Breakpoint) {
    Breakpoint[Breakpoint["XS"] = 0] = "XS";
    Breakpoint[Breakpoint["SM"] = 432] = "SM";
    Breakpoint[Breakpoint["MD"] = 688] = "MD";
    Breakpoint[Breakpoint["LG"] = 992] = "LG";
    Breakpoint[Breakpoint["XL"] = 1300] = "XL";
    return Breakpoint;
}({});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gTIiw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Testimonial", function() {
    return Testimonial;
});
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _domComponent = require("../../../script/src/dom/library/DomComponent");
var _hooks = require("../../../script/src/std/hooks");
var _domElement = require("../../../script/src/dom/library/DomElement");
var _startVideo = require("../useCases/startVideo");
var _useTrack = require("../../../script/src/dom/hooks/useTrack");
function Testimonial(props) {
    var dispatch = (0, _hooks.useDispatch)();
    var videoId = (0, _domElement.useAttributeValue)('data-video-id');
    var track = (0, _useTrack.useTrack)();
    if (props.layout === 'photos') return null;
    function startVideo() {
        dispatch((0, _startVideo.StartVideo)({
            videoId: videoId
        }));
        track('StartVideo', {
            videoId: videoId
        });
    }
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
        selector: "[data-id=thumbnail]",
        onClick: startVideo
    }, void 0, false, {
        fileName: "src/sections/testimonials/snippets/testimonial.tsx",
        lineNumber: 25,
        columnNumber: 9
    }, this);
}

},{"react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","../../../script/src/dom/library/DomComponent":"8H9za","../../../script/src/std/hooks":"j9RPQ","../../../script/src/dom/library/DomElement":"15N7Q","../useCases/startVideo":"6uDXH","../../../script/src/dom/hooks/useTrack":"iL2dq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6uDXH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StartVideoKey", function() {
    return StartVideoKey;
});
parcelHelpers.export(exports, "StartVideo", function() {
    return StartVideo;
});
var _eventFactory = require("../../../script/src/std/eventFactory");
var StartVideoKey = 'Testimonials.StartVideo';
var StartVideo = (0, _eventFactory.eventFactory)(StartVideoKey)();

},{"../../../script/src/std/eventFactory":"f2PpV","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"hdDJA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VideoPlayer", function() {
    return VideoPlayer;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _domComponent = require("../../../script/src/dom/library/DomComponent");
var _hooks = require("../../../script/src/std/hooks");
var _domElement = require("../../../script/src/dom/library/DomElement");
var _startVideo = require("../useCases/startVideo");
var _domArray = require("../../../script/src/dom/library/DomArray");
var _std = require("@reglo/std");
var _stopVideo = require("../useCases/stopVideo");
function VideoPlayer() {
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), playing = _useState[0], setPlaying = _useState[1];
    var dispatch = (0, _hooks.useDispatch)();
    (0, _hooks.usePreventBackgroundScroll)(playing);
    (0, _hooks.useOnEvent)((0, _startVideo.StartVideoKey), function(event) {
        setPlaying(true);
    });
    (0, _hooks.useOnEvent)((0, _stopVideo.StopVideoKey), function(event) {
        setPlaying(false);
    });
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
        selector: "[data-id=videoPlayer]",
        data: {
            playing: playing
        },
        onClick: function() {
            return dispatch((0, _stopVideo.StopVideo)());
        },
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
                selector: "[data-id=close]",
                onClick: function() {
                    return dispatch((0, _stopVideo.StopVideo)());
                }
            }, void 0, false, {
                fileName: "src/sections/testimonials/snippets/videoPlayer.tsx",
                lineNumber: 25,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domArray.DomArray), {
                selector: "[data-id=video]",
                discriminator: "data-video-id",
                child: function(param) {
                    var key = param.key, selector = param.selector;
                    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(Video, {
                        selector: selector,
                        videoId: key
                    }, key, false, {
                        fileName: "src/sections/testimonials/snippets/videoPlayer.tsx",
                        lineNumber: 27,
                        columnNumber: 17
                    }, void 0);
                }
            }, void 0, false, {
                fileName: "src/sections/testimonials/snippets/videoPlayer.tsx",
                lineNumber: 26,
                columnNumber: 13
            }, this)
        ]
    }, void 0, true, {
        fileName: "src/sections/testimonials/snippets/videoPlayer.tsx",
        lineNumber: 24,
        columnNumber: 9
    }, this);
}
function Video(props) {
    var _useState = (0, _slicedToArray._)((0, _react.useState)(false), 2), playing = _useState[0], setPlaying = _useState[1];
    var video = (0, _std.unwrap)((0, _domElement.useDomElement)(props.selector).element);
    (0, _hooks.useOnEvent)((0, _startVideo.StartVideoKey), function(event) {
        setPlaying(event.payload.videoId === props.videoId);
    });
    (0, _hooks.useOnEvent)((0, _stopVideo.StopVideoKey), function(event) {
        setPlaying(false);
    });
    (0, _react.useEffect)(function() {
        playing ? video.play() : video.pause();
    }, [
        playing
    ]);
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
        selector: props.selector,
        data: {
            playing: playing
        },
        onClick: function(event) {
            return event.stopPropagation();
        }
    }, void 0, false, {
        fileName: "src/sections/testimonials/snippets/videoPlayer.tsx",
        lineNumber: 53,
        columnNumber: 9
    }, this);
}

},{"@swc/helpers/_/_sliced_to_array":"ha6sq","react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","../../../script/src/dom/library/DomComponent":"8H9za","../../../script/src/std/hooks":"j9RPQ","../../../script/src/dom/library/DomElement":"15N7Q","../useCases/startVideo":"6uDXH","../../../script/src/dom/library/DomArray":"ZEl1X","@reglo/std":"1USo0","../useCases/stopVideo":"aDQXu","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"aDQXu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StopVideoKey", function() {
    return StopVideoKey;
});
parcelHelpers.export(exports, "StopVideo", function() {
    return StopVideo;
});
var _eventFactory = require("../../../script/src/std/eventFactory");
var StopVideoKey = 'Testimonials.StopVideo';
var StopVideo = (0, _eventFactory.eventFactory)(StopVideoKey)();

},{"../../../script/src/std/eventFactory":"f2PpV","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"ehF57":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Offers", function() {
    return Offers;
});
parcelHelpers.export(exports, "Elements", function() {
    return Elements;
});
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _domArray = require("../../script/src/dom/library/DomArray");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _domComponent = require("../../script/src/dom/library/DomComponent");
var _offer = require("./snippets/offer");
function Offers() {
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domArray.DomArray), {
        selector: ".sectionOffers",
        child: function(param) {
            var key = param.key, selector = param.selector;
            return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
                selector: selector,
                children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(Elements, {}, void 0, false, {
                    fileName: "src/sections/offers/index.tsx",
                    lineNumber: 9,
                    columnNumber: 57
                }, void 0)
            }, key, false, {
                fileName: "src/sections/offers/index.tsx",
                lineNumber: 9,
                columnNumber: 13
            }, void 0);
        }
    }, void 0, false, {
        fileName: "src/sections/offers/index.tsx",
        lineNumber: 8,
        columnNumber: 9
    }, this);
}
function Elements() {
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domArray.DomArray), {
        selector: "[data-id=offer]",
        child: function(param) {
            var key = param.key, selector = param.selector;
            return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
                selector: selector,
                children: /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _offer.Offer), {}, void 0, false, {
                    fileName: "src/sections/offers/index.tsx",
                    lineNumber: 17,
                    columnNumber: 57
                }, void 0)
            }, key, false, {
                fileName: "src/sections/offers/index.tsx",
                lineNumber: 17,
                columnNumber: 13
            }, void 0);
        }
    }, void 0, false, {
        fileName: "src/sections/offers/index.tsx",
        lineNumber: 16,
        columnNumber: 9
    }, this);
}

},{"react/jsx-dev-runtime":"jXZ8I","../../script/src/dom/library/DomArray":"ZEl1X","react":"c8CN1","../../script/src/dom/library/DomComponent":"8H9za","./snippets/offer":"8t8UF","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8t8UF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Offer", function() {
    return Offer;
});
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _domElement = require("../../../script/src/dom/library/DomElement");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _indexLiquid = require("../../../snippets/components/cta/index--liquid");
var _hooks = require("../../../script/src/std/hooks");
var _addProductToCart = require("../../../snippets/components/cart/useCases/addProductToCart");
function Offer() {
    var variantId = (0, _domElement.useNumberAttributeValue)('data-variant_id');
    var dispatch = (0, _hooks.useDispatch)();
    function handleClick() {
        dispatch((0, _addProductToCart.AddProductToCart)({
            variantId: variantId,
            quantity: 1,
            subscriptionPlanId: null,
            source: 'offersSection'
        }));
    }
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _indexLiquid.LiquidCta), {
        selector: "[data-id=cta]",
        onClick: handleClick
    }, void 0, false, {
        fileName: "src/sections/offers/snippets/offer.tsx",
        lineNumber: 23,
        columnNumber: 9
    }, this);
}

},{"react/jsx-dev-runtime":"jXZ8I","../../../script/src/dom/library/DomElement":"15N7Q","react":"c8CN1","../../../snippets/components/cta/index--liquid":"2Hp5o","../../../script/src/std/hooks":"j9RPQ","../../../snippets/components/cart/useCases/addProductToCart":"bC9NF","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"407d8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LpDestinationQuiz", function() {
    return LpDestinationQuiz;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _jsxDevRuntime = require("react/jsx-dev-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _domSection = require("../../../script/src/dom/library/DomSection");
var _domArray = require("../../../script/src/dom/library/DomArray");
var _domComponent = require("../../../script/src/dom/library/DomComponent");
var _domElement = require("../../../script/src/dom/library/DomElement");
var _hooks = require("../../../script/src/std/hooks");
var _choseDestination = require("../useCases/choseDestination");
var _std = require("@reglo/std");
function LpDestinationQuiz() {
    var _this = this;
    return (0, _domSection.DomSection)('sectionLpDestinationQuiz', function() {
        return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(Section, {}, void 0, false, {
            fileName: "src/sections/lpDestinationQuiz/dom/index.tsx",
            lineNumber: 11,
            columnNumber: 57
        }, _this);
    });
}
function Section() {
    var scrollTo = (0, _hooks.useScrollTo)({
        selector: '[data-id=page]:nth-of-type(2)'
    });
    (0, _hooks.useOnEvent)((0, _choseDestination.ChoseDestinationKey), function(event) {
        return scrollTo();
    });
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _jsxDevRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domArray.DomArray), {
                selector: "[data-id=choiceCta]",
                child: function(param) {
                    var key = param.key, selector = param.selector;
                    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(ChoiceCta, {
                        selector: selector
                    }, key, false, {
                        fileName: "src/sections/lpDestinationQuiz/dom/index.tsx",
                        lineNumber: 23,
                        columnNumber: 84
                    }, void 0);
                }
            }, void 0, false, {
                fileName: "src/sections/lpDestinationQuiz/dom/index.tsx",
                lineNumber: 23,
                columnNumber: 13
            }, this),
            /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domArray.DomArray), {
                selector: "[data-id=submitCta]",
                child: function(param) {
                    var key = param.key, selector = param.selector;
                    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)(SubmitCta, {
                        selector: selector
                    }, key, false, {
                        fileName: "src/sections/lpDestinationQuiz/dom/index.tsx",
                        lineNumber: 24,
                        columnNumber: 84
                    }, void 0);
                }
            }, void 0, false, {
                fileName: "src/sections/lpDestinationQuiz/dom/index.tsx",
                lineNumber: 24,
                columnNumber: 13
            }, this)
        ]
    }, void 0, true);
}
function ChoiceCta(props) {
    var destination = (0, _std.unwrap)((0, _domElement.useNullableAttributeValue)('data-href', props.selector));
    var dispatch = (0, _hooks.useDispatch)();
    function handleChoiceClick() {
        dispatch((0, _choseDestination.ChoseDestination)({
            destination: destination
        }));
    }
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
        selector: props.selector,
        onClick: handleChoiceClick
    }, void 0, false, {
        fileName: "src/sections/lpDestinationQuiz/dom/index.tsx",
        lineNumber: 40,
        columnNumber: 9
    }, this);
}
function SubmitCta(props) {
    var defaultDestination = (0, _std.unwrap)((0, _domElement.useNullableAttributeValue)('href', props.selector));
    var _useState = (0, _slicedToArray._)((0, _react.useState)(defaultDestination), 2), destination = _useState[0], setDestination = _useState[1];
    (0, _hooks.useOnEvent)((0, _choseDestination.ChoseDestinationKey), function(event) {
        return setDestination(event.payload.destination);
    });
    return /*#__PURE__*/ (0, _jsxDevRuntime.jsxDEV)((0, _domComponent.DomComponent), {
        selector: props.selector,
        href: destination
    }, void 0, false, {
        fileName: "src/sections/lpDestinationQuiz/dom/index.tsx",
        lineNumber: 53,
        columnNumber: 9
    }, this);
}

},{"@swc/helpers/_/_sliced_to_array":"ha6sq","react/jsx-dev-runtime":"jXZ8I","react":"c8CN1","../../../script/src/dom/library/DomSection":"gcFCP","../../../script/src/dom/library/DomArray":"ZEl1X","../../../script/src/dom/library/DomComponent":"8H9za","../../../script/src/dom/library/DomElement":"15N7Q","../../../script/src/std/hooks":"j9RPQ","../useCases/choseDestination":"fwPJx","@reglo/std":"1USo0","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"fwPJx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChoseDestinationKey", function() {
    return ChoseDestinationKey;
});
parcelHelpers.export(exports, "ChoseDestination", function() {
    return ChoseDestination;
});
var _eventFactory = require("../../../script/src/std/eventFactory");
var ChoseDestinationKey = 'LpDestinationQuiz.ChoseDestination';
var ChoseDestination = (0, _eventFactory.eventFactory)(ChoseDestinationKey)();

},{"../../../script/src/std/eventFactory":"f2PpV","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"g8Lrm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FunctionToString", function() {
    return 0, _core.FunctionToString;
});
parcelHelpers.export(exports, "Hub", function() {
    return 0, _core.Hub;
});
parcelHelpers.export(exports, "InboundFilters", function() {
    return 0, _core.InboundFilters;
});
parcelHelpers.export(exports, "ModuleMetadata", function() {
    return 0, _core.ModuleMetadata;
});
parcelHelpers.export(exports, "SDK_VERSION", function() {
    return 0, _core.SDK_VERSION;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_OP", function() {
    return 0, _core.SEMANTIC_ATTRIBUTE_SENTRY_OP;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN", function() {
    return 0, _core.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE", function() {
    return 0, _core.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_SOURCE", function() {
    return 0, _core.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE;
});
parcelHelpers.export(exports, "Scope", function() {
    return 0, _core.Scope;
});
parcelHelpers.export(exports, "addBreadcrumb", function() {
    return 0, _core.addBreadcrumb;
});
parcelHelpers.export(exports, "addEventProcessor", function() {
    return 0, _core.addEventProcessor;
});
parcelHelpers.export(exports, "addGlobalEventProcessor", function() {
    return 0, _core.addGlobalEventProcessor;
});
parcelHelpers.export(exports, "addIntegration", function() {
    return 0, _core.addIntegration;
});
parcelHelpers.export(exports, "addTracingExtensions", function() {
    return 0, _core.addTracingExtensions;
});
parcelHelpers.export(exports, "captureEvent", function() {
    return 0, _core.captureEvent;
});
parcelHelpers.export(exports, "captureException", function() {
    return 0, _core.captureException;
});
parcelHelpers.export(exports, "captureMessage", function() {
    return 0, _core.captureMessage;
});
parcelHelpers.export(exports, "captureSession", function() {
    return 0, _core.captureSession;
});
parcelHelpers.export(exports, "close", function() {
    return 0, _core.close;
});
parcelHelpers.export(exports, "configureScope", function() {
    return 0, _core.configureScope;
});
parcelHelpers.export(exports, "continueTrace", function() {
    return 0, _core.continueTrace;
});
parcelHelpers.export(exports, "createTransport", function() {
    return 0, _core.createTransport;
});
parcelHelpers.export(exports, "endSession", function() {
    return 0, _core.endSession;
});
parcelHelpers.export(exports, "extractTraceparentData", function() {
    return 0, _core.extractTraceparentData;
});
parcelHelpers.export(exports, "flush", function() {
    return 0, _core.flush;
});
parcelHelpers.export(exports, "functionToStringIntegration", function() {
    return 0, _core.functionToStringIntegration;
});
parcelHelpers.export(exports, "getActiveSpan", function() {
    return 0, _core.getActiveSpan;
});
parcelHelpers.export(exports, "getActiveTransaction", function() {
    return 0, _core.getActiveTransaction;
});
parcelHelpers.export(exports, "getClient", function() {
    return 0, _core.getClient;
});
parcelHelpers.export(exports, "getCurrentHub", function() {
    return 0, _core.getCurrentHub;
});
parcelHelpers.export(exports, "getCurrentScope", function() {
    return 0, _core.getCurrentScope;
});
parcelHelpers.export(exports, "getHubFromCarrier", function() {
    return 0, _core.getHubFromCarrier;
});
parcelHelpers.export(exports, "getSpanStatusFromHttpCode", function() {
    return 0, _core.getSpanStatusFromHttpCode;
});
parcelHelpers.export(exports, "inboundFiltersIntegration", function() {
    return 0, _core.inboundFiltersIntegration;
});
parcelHelpers.export(exports, "isInitialized", function() {
    return 0, _core.isInitialized;
});
parcelHelpers.export(exports, "lastEventId", function() {
    return 0, _core.lastEventId;
});
parcelHelpers.export(exports, "makeMain", function() {
    return 0, _core.makeMain;
});
parcelHelpers.export(exports, "makeMultiplexedTransport", function() {
    return 0, _core.makeMultiplexedTransport;
});
parcelHelpers.export(exports, "metrics", function() {
    return 0, _core.metrics;
});
parcelHelpers.export(exports, "moduleMetadataIntegration", function() {
    return 0, _core.moduleMetadataIntegration;
});
parcelHelpers.export(exports, "parameterize", function() {
    return 0, _core.parameterize;
});
parcelHelpers.export(exports, "setContext", function() {
    return 0, _core.setContext;
});
parcelHelpers.export(exports, "setCurrentClient", function() {
    return 0, _core.setCurrentClient;
});
parcelHelpers.export(exports, "setExtra", function() {
    return 0, _core.setExtra;
});
parcelHelpers.export(exports, "setExtras", function() {
    return 0, _core.setExtras;
});
parcelHelpers.export(exports, "setHttpStatus", function() {
    return 0, _core.setHttpStatus;
});
parcelHelpers.export(exports, "setMeasurement", function() {
    return 0, _core.setMeasurement;
});
parcelHelpers.export(exports, "setTag", function() {
    return 0, _core.setTag;
});
parcelHelpers.export(exports, "setTags", function() {
    return 0, _core.setTags;
});
parcelHelpers.export(exports, "setUser", function() {
    return 0, _core.setUser;
});
parcelHelpers.export(exports, "spanStatusfromHttpCode", function() {
    return 0, _core.spanStatusfromHttpCode;
});
parcelHelpers.export(exports, "startInactiveSpan", function() {
    return 0, _core.startInactiveSpan;
});
parcelHelpers.export(exports, "startSession", function() {
    return 0, _core.startSession;
});
parcelHelpers.export(exports, "startSpan", function() {
    return 0, _core.startSpan;
});
parcelHelpers.export(exports, "startSpanManual", function() {
    return 0, _core.startSpanManual;
});
parcelHelpers.export(exports, "startTransaction", function() {
    return 0, _core.startTransaction;
});
parcelHelpers.export(exports, "trace", function() {
    return 0, _core.trace;
});
parcelHelpers.export(exports, "withActiveSpan", function() {
    return 0, _core.withActiveSpan;
});
parcelHelpers.export(exports, "withIsolationScope", function() {
    return 0, _core.withIsolationScope;
});
parcelHelpers.export(exports, "withScope", function() {
    return 0, _core.withScope;
});
parcelHelpers.export(exports, "WINDOW", function() {
    return 0, _helpersJs.WINDOW;
});
parcelHelpers.export(exports, "BrowserClient", function() {
    return 0, _clientJs.BrowserClient;
});
parcelHelpers.export(exports, "makeFetchTransport", function() {
    return 0, _fetchJs.makeFetchTransport;
});
parcelHelpers.export(exports, "makeXHRTransport", function() {
    return 0, _xhrJs.makeXHRTransport;
});
parcelHelpers.export(exports, "chromeStackLineParser", function() {
    return 0, _stackParsersJs.chromeStackLineParser;
});
parcelHelpers.export(exports, "defaultStackLineParsers", function() {
    return 0, _stackParsersJs.defaultStackLineParsers;
});
parcelHelpers.export(exports, "defaultStackParser", function() {
    return 0, _stackParsersJs.defaultStackParser;
});
parcelHelpers.export(exports, "geckoStackLineParser", function() {
    return 0, _stackParsersJs.geckoStackLineParser;
});
parcelHelpers.export(exports, "opera10StackLineParser", function() {
    return 0, _stackParsersJs.opera10StackLineParser;
});
parcelHelpers.export(exports, "opera11StackLineParser", function() {
    return 0, _stackParsersJs.opera11StackLineParser;
});
parcelHelpers.export(exports, "winjsStackLineParser", function() {
    return 0, _stackParsersJs.winjsStackLineParser;
});
parcelHelpers.export(exports, "eventFromException", function() {
    return 0, _eventbuilderJs.eventFromException;
});
parcelHelpers.export(exports, "eventFromMessage", function() {
    return 0, _eventbuilderJs.eventFromMessage;
});
parcelHelpers.export(exports, "exceptionFromError", function() {
    return 0, _eventbuilderJs.exceptionFromError;
});
parcelHelpers.export(exports, "createUserFeedbackEnvelope", function() {
    return 0, _userfeedbackJs.createUserFeedbackEnvelope;
});
parcelHelpers.export(exports, "captureUserFeedback", function() {
    return 0, _sdkJs.captureUserFeedback;
});
parcelHelpers.export(exports, "defaultIntegrations", function() {
    return 0, _sdkJs.defaultIntegrations;
});
parcelHelpers.export(exports, "forceLoad", function() {
    return 0, _sdkJs.forceLoad;
});
parcelHelpers.export(exports, "getDefaultIntegrations", function() {
    return 0, _sdkJs.getDefaultIntegrations;
});
parcelHelpers.export(exports, "init", function() {
    return 0, _sdkJs.init;
});
parcelHelpers.export(exports, "onLoad", function() {
    return 0, _sdkJs.onLoad;
});
parcelHelpers.export(exports, "showReportDialog", function() {
    return 0, _sdkJs.showReportDialog;
});
parcelHelpers.export(exports, "wrap", function() {
    return 0, _sdkJs.wrap;
});
parcelHelpers.export(exports, "Breadcrumbs", function() {
    return 0, _breadcrumbsJs.Breadcrumbs;
});
parcelHelpers.export(exports, "breadcrumbsIntegration", function() {
    return 0, _breadcrumbsJs.breadcrumbsIntegration;
});
parcelHelpers.export(exports, "Dedupe", function() {
    return 0, _dedupeJs.Dedupe;
});
parcelHelpers.export(exports, "GlobalHandlers", function() {
    return 0, _globalhandlersJs.GlobalHandlers;
});
parcelHelpers.export(exports, "globalHandlersIntegration", function() {
    return 0, _globalhandlersJs.globalHandlersIntegration;
});
parcelHelpers.export(exports, "HttpContext", function() {
    return 0, _httpcontextJs.HttpContext;
});
parcelHelpers.export(exports, "httpContextIntegration", function() {
    return 0, _httpcontextJs.httpContextIntegration;
});
parcelHelpers.export(exports, "LinkedErrors", function() {
    return 0, _linkederrorsJs.LinkedErrors;
});
parcelHelpers.export(exports, "linkedErrorsIntegration", function() {
    return 0, _linkederrorsJs.linkedErrorsIntegration;
});
parcelHelpers.export(exports, "TryCatch", function() {
    return 0, _trycatchJs.TryCatch;
});
parcelHelpers.export(exports, "browserApiErrorsIntegration", function() {
    return 0, _trycatchJs.browserApiErrorsIntegration;
});
parcelHelpers.export(exports, "Replay", function() {
    return 0, _replay.InternalReplay;
});
parcelHelpers.export(exports, "getReplay", function() {
    return 0, _replay.internalGetReplay;
});
parcelHelpers.export(exports, "replayIntegration", function() {
    return 0, _replay.internalReplayIntegration;
});
parcelHelpers.export(exports, "ReplayCanvas", function() {
    return 0, _replayCanvas.ReplayCanvas;
});
parcelHelpers.export(exports, "replayCanvasIntegration", function() {
    return 0, _replayCanvas.replayCanvasIntegration;
});
parcelHelpers.export(exports, "Feedback", function() {
    return 0, _feedback.Feedback;
});
parcelHelpers.export(exports, "feedbackIntegration", function() {
    return 0, _feedback.feedbackIntegration;
});
parcelHelpers.export(exports, "sendFeedback", function() {
    return 0, _feedback.sendFeedback;
});
parcelHelpers.export(exports, "captureConsoleIntegration", function() {
    return 0, _integrations.captureConsoleIntegration;
});
parcelHelpers.export(exports, "contextLinesIntegration", function() {
    return 0, _integrations.contextLinesIntegration;
});
parcelHelpers.export(exports, "debugIntegration", function() {
    return 0, _integrations.debugIntegration;
});
parcelHelpers.export(exports, "dedupeIntegration", function() {
    return 0, _integrations.dedupeIntegration;
});
parcelHelpers.export(exports, "extraErrorDataIntegration", function() {
    return 0, _integrations.extraErrorDataIntegration;
});
parcelHelpers.export(exports, "httpClientIntegration", function() {
    return 0, _integrations.httpClientIntegration;
});
parcelHelpers.export(exports, "reportingObserverIntegration", function() {
    return 0, _integrations.reportingObserverIntegration;
});
parcelHelpers.export(exports, "rewriteFramesIntegration", function() {
    return 0, _integrations.rewriteFramesIntegration;
});
parcelHelpers.export(exports, "sessionTimingIntegration", function() {
    return 0, _integrations.sessionTimingIntegration;
});
parcelHelpers.export(exports, "BrowserTracing", function() {
    return 0, _tracing.BrowserTracing;
});
parcelHelpers.export(exports, "browserTracingIntegration", function() {
    return 0, _tracing.browserTracingIntegration;
});
parcelHelpers.export(exports, "defaultRequestInstrumentationOptions", function() {
    return 0, _tracing.defaultRequestInstrumentationOptions;
});
parcelHelpers.export(exports, "instrumentOutgoingRequests", function() {
    return 0, _tracing.instrumentOutgoingRequests;
});
parcelHelpers.export(exports, "startBrowserTracingNavigationSpan", function() {
    return 0, _tracing.startBrowserTracingNavigationSpan;
});
parcelHelpers.export(exports, "startBrowserTracingPageLoadSpan", function() {
    return 0, _tracing.startBrowserTracingPageLoadSpan;
});
parcelHelpers.export(exports, "makeBrowserOfflineTransport", function() {
    return 0, _offlineJs.makeBrowserOfflineTransport;
});
parcelHelpers.export(exports, "onProfilingStartRouteTransaction", function() {
    return 0, _hubextensionsJs.onProfilingStartRouteTransaction;
});
parcelHelpers.export(exports, "BrowserProfilingIntegration", function() {
    return 0, _integrationJs.BrowserProfilingIntegration;
});
parcelHelpers.export(exports, "browserProfilingIntegration", function() {
    return 0, _integrationJs.browserProfilingIntegration;
});
parcelHelpers.export(exports, "Integrations", function() {
    return INTEGRATIONS;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _core = require("@sentry/core");
var _helpersJs = require("./helpers.js");
var _clientJs = require("./client.js");
var _fetchJs = require("./transports/fetch.js");
var _xhrJs = require("./transports/xhr.js");
var _stackParsersJs = require("./stack-parsers.js");
var _eventbuilderJs = require("./eventbuilder.js");
var _userfeedbackJs = require("./userfeedback.js");
var _sdkJs = require("./sdk.js");
var _breadcrumbsJs = require("./integrations/breadcrumbs.js");
var _dedupeJs = require("./integrations/dedupe.js");
var _globalhandlersJs = require("./integrations/globalhandlers.js");
var _httpcontextJs = require("./integrations/httpcontext.js");
var _linkederrorsJs = require("./integrations/linkederrors.js");
var _trycatchJs = require("./integrations/trycatch.js");
var _indexJs = require("./integrations/index.js");
var _replay = require("@sentry/replay");
var _replayCanvas = require("@sentry-internal/replay-canvas");
var _feedback = require("@sentry-internal/feedback");
var _integrations = require("@sentry/integrations");
var _tracing = require("@sentry-internal/tracing");
var _offlineJs = require("./transports/offline.js");
var _hubextensionsJs = require("./profiling/hubextensions.js");
var _integrationJs = require("./profiling/integration.js");
var windowIntegrations = {};
// This block is needed to add compatibility with the integrations packages when used with a CDN
if ((0, _helpersJs.WINDOW).Sentry && (0, _helpersJs.WINDOW).Sentry.Integrations) windowIntegrations = (0, _helpersJs.WINDOW).Sentry.Integrations;
/** @deprecated Import the integration function directly, e.g. `inboundFiltersIntegration()` instead of `new Integrations.InboundFilter(). */ var INTEGRATIONS = (0, _objectSpread._)({}, windowIntegrations, (0, _core.Integrations), _indexJs);

},{"@swc/helpers/_/_object_spread":"4bEWH","@sentry/core":"8bBGI","./helpers.js":"gFT9f","./client.js":"5cJ51","./transports/fetch.js":"icY9Q","./transports/xhr.js":"9NFC5","./stack-parsers.js":"a9hXX","./eventbuilder.js":"iw4zL","./userfeedback.js":"l9KIs","./sdk.js":"iBFmu","./integrations/breadcrumbs.js":"4enzp","./integrations/dedupe.js":"eScBY","./integrations/globalhandlers.js":"eOTsK","./integrations/httpcontext.js":"c80HE","./integrations/linkederrors.js":"iWIUb","./integrations/trycatch.js":"bQJCw","./integrations/index.js":"guXvd","@sentry/replay":"1f5z6","@sentry-internal/replay-canvas":"brIPY","@sentry-internal/feedback":"hlyIz","@sentry/integrations":"gi4iA","@sentry-internal/tracing":"imA5v","./transports/offline.js":"5BwsG","./profiling/hubextensions.js":"64Exn","./profiling/integration.js":"kh9Z4","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8bBGI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addTracingExtensions", function() {
    return 0, _hubextensionsJs.addTracingExtensions;
});
parcelHelpers.export(exports, "startIdleTransaction", function() {
    return 0, _hubextensionsJs.startIdleTransaction;
});
parcelHelpers.export(exports, "IdleTransaction", function() {
    return 0, _idletransactionJs.IdleTransaction;
});
parcelHelpers.export(exports, "TRACING_DEFAULTS", function() {
    return 0, _idletransactionJs.TRACING_DEFAULTS;
});
parcelHelpers.export(exports, "Span", function() {
    return 0, _spanJs.Span;
});
parcelHelpers.export(exports, "Transaction", function() {
    return 0, _transactionJs.Transaction;
});
parcelHelpers.export(exports, "extractTraceparentData", function() {
    return 0, _utilsJs.extractTraceparentData;
});
parcelHelpers.export(exports, "getActiveTransaction", function() {
    return 0, _utilsJs.getActiveTransaction;
});
parcelHelpers.export(exports, "SpanStatus", function() {
    return 0, _spanstatusJs.SpanStatus;
});
parcelHelpers.export(exports, "getSpanStatusFromHttpCode", function() {
    return 0, _spanstatusJs.getSpanStatusFromHttpCode;
});
parcelHelpers.export(exports, "setHttpStatus", function() {
    return 0, _spanstatusJs.setHttpStatus;
});
parcelHelpers.export(exports, "spanStatusfromHttpCode", function() {
    return 0, _spanstatusJs.spanStatusfromHttpCode;
});
parcelHelpers.export(exports, "continueTrace", function() {
    return 0, _traceJs.continueTrace;
});
parcelHelpers.export(exports, "getActiveSpan", function() {
    return 0, _traceJs.getActiveSpan;
});
parcelHelpers.export(exports, "startActiveSpan", function() {
    return 0, _traceJs.startActiveSpan;
});
parcelHelpers.export(exports, "startInactiveSpan", function() {
    return 0, _traceJs.startInactiveSpan;
});
parcelHelpers.export(exports, "startSpan", function() {
    return 0, _traceJs.startSpan;
});
parcelHelpers.export(exports, "startSpanManual", function() {
    return 0, _traceJs.startSpanManual;
});
parcelHelpers.export(exports, "trace", function() {
    return 0, _traceJs.trace;
});
parcelHelpers.export(exports, "getDynamicSamplingContextFromClient", function() {
    return 0, _dynamicSamplingContextJs.getDynamicSamplingContextFromClient;
});
parcelHelpers.export(exports, "getDynamicSamplingContextFromSpan", function() {
    return 0, _dynamicSamplingContextJs.getDynamicSamplingContextFromSpan;
});
parcelHelpers.export(exports, "setMeasurement", function() {
    return 0, _measurementJs.setMeasurement;
});
parcelHelpers.export(exports, "isValidSampleRate", function() {
    return 0, _samplingJs.isValidSampleRate;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_PROFILE_ID", function() {
    return 0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_PROFILE_ID;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_OP", function() {
    return 0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_OP;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN", function() {
    return 0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE", function() {
    return 0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_SOURCE", function() {
    return 0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE;
});
parcelHelpers.export(exports, "createEventEnvelope", function() {
    return 0, _envelopeJs.createEventEnvelope;
});
parcelHelpers.export(exports, "createSessionEnvelope", function() {
    return 0, _envelopeJs.createSessionEnvelope;
});
parcelHelpers.export(exports, "addBreadcrumb", function() {
    return 0, _exportsJs.addBreadcrumb;
});
parcelHelpers.export(exports, "captureCheckIn", function() {
    return 0, _exportsJs.captureCheckIn;
});
parcelHelpers.export(exports, "captureEvent", function() {
    return 0, _exportsJs.captureEvent;
});
parcelHelpers.export(exports, "captureException", function() {
    return 0, _exportsJs.captureException;
});
parcelHelpers.export(exports, "captureMessage", function() {
    return 0, _exportsJs.captureMessage;
});
parcelHelpers.export(exports, "captureSession", function() {
    return 0, _exportsJs.captureSession;
});
parcelHelpers.export(exports, "close", function() {
    return 0, _exportsJs.close;
});
parcelHelpers.export(exports, "configureScope", function() {
    return 0, _exportsJs.configureScope;
});
parcelHelpers.export(exports, "endSession", function() {
    return 0, _exportsJs.endSession;
});
parcelHelpers.export(exports, "flush", function() {
    return 0, _exportsJs.flush;
});
parcelHelpers.export(exports, "getClient", function() {
    return 0, _exportsJs.getClient;
});
parcelHelpers.export(exports, "getCurrentScope", function() {
    return 0, _exportsJs.getCurrentScope;
});
parcelHelpers.export(exports, "isInitialized", function() {
    return 0, _exportsJs.isInitialized;
});
parcelHelpers.export(exports, "lastEventId", function() {
    return 0, _exportsJs.lastEventId;
});
parcelHelpers.export(exports, "setContext", function() {
    return 0, _exportsJs.setContext;
});
parcelHelpers.export(exports, "setExtra", function() {
    return 0, _exportsJs.setExtra;
});
parcelHelpers.export(exports, "setExtras", function() {
    return 0, _exportsJs.setExtras;
});
parcelHelpers.export(exports, "setTag", function() {
    return 0, _exportsJs.setTag;
});
parcelHelpers.export(exports, "setTags", function() {
    return 0, _exportsJs.setTags;
});
parcelHelpers.export(exports, "setUser", function() {
    return 0, _exportsJs.setUser;
});
parcelHelpers.export(exports, "startSession", function() {
    return 0, _exportsJs.startSession;
});
parcelHelpers.export(exports, "startTransaction", function() {
    return 0, _exportsJs.startTransaction;
});
parcelHelpers.export(exports, "withActiveSpan", function() {
    return 0, _exportsJs.withActiveSpan;
});
parcelHelpers.export(exports, "withIsolationScope", function() {
    return 0, _exportsJs.withIsolationScope;
});
parcelHelpers.export(exports, "withMonitor", function() {
    return 0, _exportsJs.withMonitor;
});
parcelHelpers.export(exports, "withScope", function() {
    return 0, _exportsJs.withScope;
});
parcelHelpers.export(exports, "Hub", function() {
    return 0, _hubJs.Hub;
});
parcelHelpers.export(exports, "ensureHubOnCarrier", function() {
    return 0, _hubJs.ensureHubOnCarrier;
});
parcelHelpers.export(exports, "getCurrentHub", function() {
    return 0, _hubJs.getCurrentHub;
});
parcelHelpers.export(exports, "getHubFromCarrier", function() {
    return 0, _hubJs.getHubFromCarrier;
});
parcelHelpers.export(exports, "getIsolationScope", function() {
    return 0, _hubJs.getIsolationScope;
});
parcelHelpers.export(exports, "getMainCarrier", function() {
    return 0, _hubJs.getMainCarrier;
});
parcelHelpers.export(exports, "makeMain", function() {
    return 0, _hubJs.makeMain;
});
parcelHelpers.export(exports, "runWithAsyncContext", function() {
    return 0, _hubJs.runWithAsyncContext;
});
parcelHelpers.export(exports, "setAsyncContextStrategy", function() {
    return 0, _hubJs.setAsyncContextStrategy;
});
parcelHelpers.export(exports, "setHubOnCarrier", function() {
    return 0, _hubJs.setHubOnCarrier;
});
parcelHelpers.export(exports, "closeSession", function() {
    return 0, _sessionJs.closeSession;
});
parcelHelpers.export(exports, "makeSession", function() {
    return 0, _sessionJs.makeSession;
});
parcelHelpers.export(exports, "updateSession", function() {
    return 0, _sessionJs.updateSession;
});
parcelHelpers.export(exports, "SessionFlusher", function() {
    return 0, _sessionflusherJs.SessionFlusher;
});
parcelHelpers.export(exports, "Scope", function() {
    return 0, _scopeJs.Scope;
});
parcelHelpers.export(exports, "getGlobalScope", function() {
    return 0, _scopeJs.getGlobalScope;
});
parcelHelpers.export(exports, "setGlobalScope", function() {
    return 0, _scopeJs.setGlobalScope;
});
parcelHelpers.export(exports, "addGlobalEventProcessor", function() {
    return 0, _eventProcessorsJs.addGlobalEventProcessor;
});
parcelHelpers.export(exports, "notifyEventProcessors", function() {
    return 0, _eventProcessorsJs.notifyEventProcessors;
});
parcelHelpers.export(exports, "getEnvelopeEndpointWithUrlEncodedAuth", function() {
    return 0, _apiJs.getEnvelopeEndpointWithUrlEncodedAuth;
});
parcelHelpers.export(exports, "getReportDialogEndpoint", function() {
    return 0, _apiJs.getReportDialogEndpoint;
});
parcelHelpers.export(exports, "BaseClient", function() {
    return 0, _baseclientJs.BaseClient;
});
parcelHelpers.export(exports, "addEventProcessor", function() {
    return 0, _baseclientJs.addEventProcessor;
});
parcelHelpers.export(exports, "ServerRuntimeClient", function() {
    return 0, _serverRuntimeClientJs.ServerRuntimeClient;
});
parcelHelpers.export(exports, "initAndBind", function() {
    return 0, _sdkJs.initAndBind;
});
parcelHelpers.export(exports, "setCurrentClient", function() {
    return 0, _sdkJs.setCurrentClient;
});
parcelHelpers.export(exports, "createTransport", function() {
    return 0, _baseJs.createTransport;
});
parcelHelpers.export(exports, "makeOfflineTransport", function() {
    return 0, _offlineJs.makeOfflineTransport;
});
parcelHelpers.export(exports, "makeMultiplexedTransport", function() {
    return 0, _multiplexedJs.makeMultiplexedTransport;
});
parcelHelpers.export(exports, "SDK_VERSION", function() {
    return 0, _versionJs.SDK_VERSION;
});
parcelHelpers.export(exports, "addIntegration", function() {
    return 0, _integrationJs.addIntegration;
});
parcelHelpers.export(exports, "convertIntegrationFnToClass", function() {
    return 0, _integrationJs.convertIntegrationFnToClass;
});
parcelHelpers.export(exports, "defineIntegration", function() {
    return 0, _integrationJs.defineIntegration;
});
parcelHelpers.export(exports, "getIntegrationsToSetup", function() {
    return 0, _integrationJs.getIntegrationsToSetup;
});
parcelHelpers.export(exports, "applyScopeDataToEvent", function() {
    return 0, _applyScopeDataToEventJs.applyScopeDataToEvent;
});
parcelHelpers.export(exports, "mergeScopeData", function() {
    return 0, _applyScopeDataToEventJs.mergeScopeData;
});
parcelHelpers.export(exports, "prepareEvent", function() {
    return 0, _prepareEventJs.prepareEvent;
});
parcelHelpers.export(exports, "createCheckInEnvelope", function() {
    return 0, _checkinJs.createCheckInEnvelope;
});
parcelHelpers.export(exports, "createSpanEnvelope", function() {
    return 0, _spanJs1.createSpanEnvelope;
});
parcelHelpers.export(exports, "hasTracingEnabled", function() {
    return 0, _hasTracingEnabledJs.hasTracingEnabled;
});
parcelHelpers.export(exports, "isSentryRequestUrl", function() {
    return 0, _isSentryRequestUrlJs.isSentryRequestUrl;
});
parcelHelpers.export(exports, "handleCallbackErrors", function() {
    return 0, _handleCallbackErrorsJs.handleCallbackErrors;
});
parcelHelpers.export(exports, "parameterize", function() {
    return 0, _parameterizeJs.parameterize;
});
parcelHelpers.export(exports, "spanIsSampled", function() {
    return 0, _spanUtilsJs.spanIsSampled;
});
parcelHelpers.export(exports, "spanToJSON", function() {
    return 0, _spanUtilsJs.spanToJSON;
});
parcelHelpers.export(exports, "spanToTraceContext", function() {
    return 0, _spanUtilsJs.spanToTraceContext;
});
parcelHelpers.export(exports, "spanToTraceHeader", function() {
    return 0, _spanUtilsJs.spanToTraceHeader;
});
parcelHelpers.export(exports, "getRootSpan", function() {
    return 0, _getRootSpanJs.getRootSpan;
});
parcelHelpers.export(exports, "applySdkMetadata", function() {
    return 0, _sdkMetadataJs.applySdkMetadata;
});
parcelHelpers.export(exports, "DEFAULT_ENVIRONMENT", function() {
    return 0, _constantsJs.DEFAULT_ENVIRONMENT;
});
parcelHelpers.export(exports, "ModuleMetadata", function() {
    return 0, _metadataJs.ModuleMetadata;
});
parcelHelpers.export(exports, "moduleMetadataIntegration", function() {
    return 0, _metadataJs.moduleMetadataIntegration;
});
parcelHelpers.export(exports, "RequestData", function() {
    return 0, _requestdataJs.RequestData;
});
parcelHelpers.export(exports, "requestDataIntegration", function() {
    return 0, _requestdataJs.requestDataIntegration;
});
parcelHelpers.export(exports, "InboundFilters", function() {
    return 0, _inboundfiltersJs.InboundFilters;
});
parcelHelpers.export(exports, "inboundFiltersIntegration", function() {
    return 0, _inboundfiltersJs.inboundFiltersIntegration;
});
parcelHelpers.export(exports, "FunctionToString", function() {
    return 0, _functiontostringJs.FunctionToString;
});
parcelHelpers.export(exports, "functionToStringIntegration", function() {
    return 0, _functiontostringJs.functionToStringIntegration;
});
parcelHelpers.export(exports, "LinkedErrors", function() {
    return 0, _linkederrorsJs.LinkedErrors;
});
parcelHelpers.export(exports, "linkedErrorsIntegration", function() {
    return 0, _linkederrorsJs.linkedErrorsIntegration;
});
parcelHelpers.export(exports, "metrics", function() {
    return 0, _exportsJs1.metrics;
});
parcelHelpers.export(exports, "Integrations", function() {
    return Integrations;
});
var _hubextensionsJs = require("./tracing/hubextensions.js");
var _idletransactionJs = require("./tracing/idletransaction.js");
var _spanJs = require("./tracing/span.js");
var _transactionJs = require("./tracing/transaction.js");
var _utilsJs = require("./tracing/utils.js");
var _spanstatusJs = require("./tracing/spanstatus.js");
var _traceJs = require("./tracing/trace.js");
var _dynamicSamplingContextJs = require("./tracing/dynamicSamplingContext.js");
var _measurementJs = require("./tracing/measurement.js");
var _samplingJs = require("./tracing/sampling.js");
var _semanticAttributesJs = require("./semanticAttributes.js");
var _envelopeJs = require("./envelope.js");
var _exportsJs = require("./exports.js");
var _hubJs = require("./hub.js");
var _sessionJs = require("./session.js");
var _sessionflusherJs = require("./sessionflusher.js");
var _scopeJs = require("./scope.js");
var _eventProcessorsJs = require("./eventProcessors.js");
var _apiJs = require("./api.js");
var _baseclientJs = require("./baseclient.js");
var _serverRuntimeClientJs = require("./server-runtime-client.js");
var _sdkJs = require("./sdk.js");
var _baseJs = require("./transports/base.js");
var _offlineJs = require("./transports/offline.js");
var _multiplexedJs = require("./transports/multiplexed.js");
var _versionJs = require("./version.js");
var _integrationJs = require("./integration.js");
var _applyScopeDataToEventJs = require("./utils/applyScopeDataToEvent.js");
var _prepareEventJs = require("./utils/prepareEvent.js");
var _checkinJs = require("./checkin.js");
var _spanJs1 = require("./span.js");
var _hasTracingEnabledJs = require("./utils/hasTracingEnabled.js");
var _isSentryRequestUrlJs = require("./utils/isSentryRequestUrl.js");
var _handleCallbackErrorsJs = require("./utils/handleCallbackErrors.js");
var _parameterizeJs = require("./utils/parameterize.js");
var _spanUtilsJs = require("./utils/spanUtils.js");
var _getRootSpanJs = require("./utils/getRootSpan.js");
var _sdkMetadataJs = require("./utils/sdkMetadata.js");
var _constantsJs = require("./constants.js");
var _metadataJs = require("./integrations/metadata.js");
var _requestdataJs = require("./integrations/requestdata.js");
var _inboundfiltersJs = require("./integrations/inboundfilters.js");
var _functiontostringJs = require("./integrations/functiontostring.js");
var _linkederrorsJs = require("./integrations/linkederrors.js");
var _indexJs = require("./integrations/index.js");
var _exportsJs1 = require("./metrics/exports.js");
/** @deprecated Import the integration function directly, e.g. `inboundFiltersIntegration()` instead of `new Integrations.InboundFilter(). */ var Integrations = _indexJs;

},{"./tracing/hubextensions.js":"cbvDC","./tracing/idletransaction.js":"iX6z1","./tracing/span.js":"6f6Gg","./tracing/transaction.js":"jZqz5","./tracing/utils.js":"g76dG","./tracing/spanstatus.js":"N1JbW","./tracing/trace.js":"h9X0g","./tracing/dynamicSamplingContext.js":"1rgNT","./tracing/measurement.js":"a2NVZ","./tracing/sampling.js":"kk5So","./semanticAttributes.js":"jJahK","./envelope.js":"4N3YN","./exports.js":"1Khf7","./hub.js":"jixbC","./session.js":"7FcOX","./sessionflusher.js":"ivoF2","./scope.js":"kKynH","./eventProcessors.js":"bSGgA","./api.js":"4yCrc","./baseclient.js":"j7SLY","./server-runtime-client.js":"kKCN0","./sdk.js":"bH3tG","./transports/base.js":"hIfuf","./transports/offline.js":"ce5XR","./transports/multiplexed.js":"boqD5","./version.js":"8NqlU","./integration.js":"dKOes","./utils/applyScopeDataToEvent.js":"e0xJW","./utils/prepareEvent.js":"dVYHl","./checkin.js":"axY4K","./span.js":"iqR6V","./utils/hasTracingEnabled.js":"f4XrA","./utils/isSentryRequestUrl.js":"eRNn4","./utils/handleCallbackErrors.js":"6Ui4q","./utils/parameterize.js":"5vMfI","./utils/spanUtils.js":"ce0Ij","./utils/getRootSpan.js":"3Qg37","./utils/sdkMetadata.js":"bF4Xb","./constants.js":"1t8zr","./integrations/metadata.js":"5gfkZ","./integrations/requestdata.js":"2ftSB","./integrations/inboundfilters.js":"dgoRx","./integrations/functiontostring.js":"jjoeh","./integrations/linkederrors.js":"kY9ai","./integrations/index.js":"3D9in","./metrics/exports.js":"6RGy2","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"cbvDC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addTracingExtensions", function() {
    return addTracingExtensions;
});
parcelHelpers.export(exports, "startIdleTransaction", function() {
    return startIdleTransaction;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _utils = require("@sentry/utils");
var _debugBuildJs = require("../debug-build.js");
var _hubJs = require("../hub.js");
var _spanUtilsJs = require("../utils/spanUtils.js");
var _errorsJs = require("./errors.js");
var _idletransactionJs = require("./idletransaction.js");
var _samplingJs = require("./sampling.js");
var _transactionJs = require("./transaction.js");
/** Returns all trace headers that are currently on the top scope. */ // eslint-disable-next-line deprecation/deprecation
function traceHeaders() {
    // eslint-disable-next-line deprecation/deprecation
    var scope = this.getScope();
    // eslint-disable-next-line deprecation/deprecation
    var span = scope.getSpan();
    return span ? {
        'sentry-trace': (0, _spanUtilsJs.spanToTraceHeader)(span)
    } : {};
}
/**
 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
 *
 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
 * "extension method."
 *
 * @param this: The Hub starting the transaction
 * @param transactionContext: Data used to configure the transaction
 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
 *
 * @returns The new transaction
 *
 * @see {@link Hub.startTransaction}
 */ function _startTransaction(// eslint-disable-next-line deprecation/deprecation
transactionContext, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    var client = this.getClient();
    var options = client && client.getOptions() || {};
    var configInstrumenter = options.instrumenter || 'sentry';
    var transactionInstrumenter = transactionContext.instrumenter || 'sentry';
    if (configInstrumenter !== transactionInstrumenter) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).error(`A transaction was started with instrumenter=\`${transactionInstrumenter}\`, but the SDK is configured with the \`${configInstrumenter}\` instrumenter.
The transaction will not be sampled. Please use the ${configInstrumenter} instrumentation to start transactions.`);
        // eslint-disable-next-line deprecation/deprecation
        transactionContext.sampled = false;
    }
    // eslint-disable-next-line deprecation/deprecation
    var transaction = new (0, _transactionJs.Transaction)(transactionContext, this);
    transaction = (0, _samplingJs.sampleTransaction)(transaction, options, (0, _objectSpread._)({
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        attributes: (0, _objectSpread._)({}, transactionContext.data, transactionContext.attributes)
    }, customSamplingContext));
    if (transaction.isRecording()) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit('startTransaction', transaction);
    return transaction;
}
/**
 * Create new idle transaction.
 */ function startIdleTransaction(// eslint-disable-next-line deprecation/deprecation
hub, transactionContext, idleTimeout, finalTimeout, onScope, customSamplingContext, heartbeatInterval) {
    var delayAutoFinishUntilSignal = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : false;
    // eslint-disable-next-line deprecation/deprecation
    var client = hub.getClient();
    var options = client && client.getOptions() || {};
    // eslint-disable-next-line deprecation/deprecation
    var transaction = new (0, _idletransactionJs.IdleTransaction)(transactionContext, hub, idleTimeout, finalTimeout, heartbeatInterval, onScope, delayAutoFinishUntilSignal);
    transaction = (0, _samplingJs.sampleTransaction)(transaction, options, (0, _objectSpread._)({
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        attributes: (0, _objectSpread._)({}, transactionContext.data, transactionContext.attributes)
    }, customSamplingContext));
    if (transaction.isRecording()) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit('startTransaction', transaction);
    return transaction;
}
/**
 * Adds tracing extensions to the global hub.
 */ function addTracingExtensions() {
    var carrier = (0, _hubJs.getMainCarrier)();
    if (!carrier.__SENTRY__) return;
    carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
    if (!carrier.__SENTRY__.extensions.startTransaction) carrier.__SENTRY__.extensions.startTransaction = _startTransaction;
    if (!carrier.__SENTRY__.extensions.traceHeaders) carrier.__SENTRY__.extensions.traceHeaders = traceHeaders;
    (0, _errorsJs.registerErrorInstrumentation)();
}

},{"@swc/helpers/_/_object_spread":"4bEWH","@sentry/utils":"gElXU","../debug-build.js":"4R9PX","../hub.js":"jixbC","../utils/spanUtils.js":"ce0Ij","./errors.js":"51uwJ","./idletransaction.js":"iX6z1","./sampling.js":"kk5So","./transaction.js":"jZqz5","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gElXU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "applyAggregateErrorsToEvent", function() {
    return 0, _aggregateErrorsJs.applyAggregateErrorsToEvent;
});
parcelHelpers.export(exports, "getComponentName", function() {
    return 0, _browserJs.getComponentName;
});
parcelHelpers.export(exports, "getDomElement", function() {
    return 0, _browserJs.getDomElement;
});
parcelHelpers.export(exports, "getLocationHref", function() {
    return 0, _browserJs.getLocationHref;
});
parcelHelpers.export(exports, "htmlTreeAsString", function() {
    return 0, _browserJs.htmlTreeAsString;
});
parcelHelpers.export(exports, "dsnFromString", function() {
    return 0, _dsnJs.dsnFromString;
});
parcelHelpers.export(exports, "dsnToString", function() {
    return 0, _dsnJs.dsnToString;
});
parcelHelpers.export(exports, "makeDsn", function() {
    return 0, _dsnJs.makeDsn;
});
parcelHelpers.export(exports, "SentryError", function() {
    return 0, _errorJs.SentryError;
});
parcelHelpers.export(exports, "GLOBAL_OBJ", function() {
    return 0, _worldwideJs.GLOBAL_OBJ;
});
parcelHelpers.export(exports, "getGlobalObject", function() {
    return 0, _worldwideJs.getGlobalObject;
});
parcelHelpers.export(exports, "getGlobalSingleton", function() {
    return 0, _worldwideJs.getGlobalSingleton;
});
parcelHelpers.export(exports, "addInstrumentationHandler", function() {
    return 0, _indexJs.addInstrumentationHandler;
});
parcelHelpers.export(exports, "isDOMError", function() {
    return 0, _isJs.isDOMError;
});
parcelHelpers.export(exports, "isDOMException", function() {
    return 0, _isJs.isDOMException;
});
parcelHelpers.export(exports, "isElement", function() {
    return 0, _isJs.isElement;
});
parcelHelpers.export(exports, "isError", function() {
    return 0, _isJs.isError;
});
parcelHelpers.export(exports, "isErrorEvent", function() {
    return 0, _isJs.isErrorEvent;
});
parcelHelpers.export(exports, "isEvent", function() {
    return 0, _isJs.isEvent;
});
parcelHelpers.export(exports, "isInstanceOf", function() {
    return 0, _isJs.isInstanceOf;
});
parcelHelpers.export(exports, "isNaN", function() {
    return 0, _isJs.isNaN;
});
parcelHelpers.export(exports, "isParameterizedString", function() {
    return 0, _isJs.isParameterizedString;
});
parcelHelpers.export(exports, "isPlainObject", function() {
    return 0, _isJs.isPlainObject;
});
parcelHelpers.export(exports, "isPrimitive", function() {
    return 0, _isJs.isPrimitive;
});
parcelHelpers.export(exports, "isRegExp", function() {
    return 0, _isJs.isRegExp;
});
parcelHelpers.export(exports, "isString", function() {
    return 0, _isJs.isString;
});
parcelHelpers.export(exports, "isSyntheticEvent", function() {
    return 0, _isJs.isSyntheticEvent;
});
parcelHelpers.export(exports, "isThenable", function() {
    return 0, _isJs.isThenable;
});
parcelHelpers.export(exports, "isVueViewModel", function() {
    return 0, _isJs.isVueViewModel;
});
parcelHelpers.export(exports, "isBrowser", function() {
    return 0, _isBrowserJs.isBrowser;
});
parcelHelpers.export(exports, "CONSOLE_LEVELS", function() {
    return 0, _loggerJs.CONSOLE_LEVELS;
});
parcelHelpers.export(exports, "consoleSandbox", function() {
    return 0, _loggerJs.consoleSandbox;
});
parcelHelpers.export(exports, "logger", function() {
    return 0, _loggerJs.logger;
});
parcelHelpers.export(exports, "originalConsoleMethods", function() {
    return 0, _loggerJs.originalConsoleMethods;
});
parcelHelpers.export(exports, "memoBuilder", function() {
    return 0, _memoJs.memoBuilder;
});
parcelHelpers.export(exports, "addContextToFrame", function() {
    return 0, _miscJs.addContextToFrame;
});
parcelHelpers.export(exports, "addExceptionMechanism", function() {
    return 0, _miscJs.addExceptionMechanism;
});
parcelHelpers.export(exports, "addExceptionTypeValue", function() {
    return 0, _miscJs.addExceptionTypeValue;
});
parcelHelpers.export(exports, "arrayify", function() {
    return 0, _miscJs.arrayify;
});
parcelHelpers.export(exports, "checkOrSetAlreadyCaught", function() {
    return 0, _miscJs.checkOrSetAlreadyCaught;
});
parcelHelpers.export(exports, "getEventDescription", function() {
    return 0, _miscJs.getEventDescription;
});
parcelHelpers.export(exports, "parseSemver", function() {
    return 0, _miscJs.parseSemver;
});
parcelHelpers.export(exports, "uuid4", function() {
    return 0, _miscJs.uuid4;
});
parcelHelpers.export(exports, "dynamicRequire", function() {
    return 0, _nodeJs.dynamicRequire;
});
parcelHelpers.export(exports, "isNodeEnv", function() {
    return 0, _nodeJs.isNodeEnv;
});
parcelHelpers.export(exports, "loadModule", function() {
    return 0, _nodeJs.loadModule;
});
parcelHelpers.export(exports, "normalize", function() {
    return 0, _normalizeJs.normalize;
});
parcelHelpers.export(exports, "normalizeToSize", function() {
    return 0, _normalizeJs.normalizeToSize;
});
parcelHelpers.export(exports, "normalizeUrlToBase", function() {
    return 0, _normalizeJs.normalizeUrlToBase;
});
parcelHelpers.export(exports, "walk", function() {
    return 0, _normalizeJs.walk;
});
parcelHelpers.export(exports, "addNonEnumerableProperty", function() {
    return 0, _objectJs.addNonEnumerableProperty;
});
parcelHelpers.export(exports, "convertToPlainObject", function() {
    return 0, _objectJs.convertToPlainObject;
});
parcelHelpers.export(exports, "dropUndefinedKeys", function() {
    return 0, _objectJs.dropUndefinedKeys;
});
parcelHelpers.export(exports, "extractExceptionKeysForMessage", function() {
    return 0, _objectJs.extractExceptionKeysForMessage;
});
parcelHelpers.export(exports, "fill", function() {
    return 0, _objectJs.fill;
});
parcelHelpers.export(exports, "getOriginalFunction", function() {
    return 0, _objectJs.getOriginalFunction;
});
parcelHelpers.export(exports, "markFunctionWrapped", function() {
    return 0, _objectJs.markFunctionWrapped;
});
parcelHelpers.export(exports, "objectify", function() {
    return 0, _objectJs.objectify;
});
parcelHelpers.export(exports, "urlEncode", function() {
    return 0, _objectJs.urlEncode;
});
parcelHelpers.export(exports, "basename", function() {
    return 0, _pathJs.basename;
});
parcelHelpers.export(exports, "dirname", function() {
    return 0, _pathJs.dirname;
});
parcelHelpers.export(exports, "isAbsolute", function() {
    return 0, _pathJs.isAbsolute;
});
parcelHelpers.export(exports, "join", function() {
    return 0, _pathJs.join;
});
parcelHelpers.export(exports, "normalizePath", function() {
    return 0, _pathJs.normalizePath;
});
parcelHelpers.export(exports, "relative", function() {
    return 0, _pathJs.relative;
});
parcelHelpers.export(exports, "resolve", function() {
    return 0, _pathJs.resolve;
});
parcelHelpers.export(exports, "makePromiseBuffer", function() {
    return 0, _promisebufferJs.makePromiseBuffer;
});
parcelHelpers.export(exports, "DEFAULT_USER_INCLUDES", function() {
    return 0, _requestdataJs.DEFAULT_USER_INCLUDES;
});
parcelHelpers.export(exports, "addRequestDataToEvent", function() {
    return 0, _requestdataJs.addRequestDataToEvent;
});
parcelHelpers.export(exports, "addRequestDataToTransaction", function() {
    return 0, _requestdataJs.addRequestDataToTransaction;
});
parcelHelpers.export(exports, "extractPathForTransaction", function() {
    return 0, _requestdataJs.extractPathForTransaction;
});
parcelHelpers.export(exports, "extractRequestData", function() {
    return 0, _requestdataJs.extractRequestData;
});
parcelHelpers.export(exports, "winterCGHeadersToDict", function() {
    return 0, _requestdataJs.winterCGHeadersToDict;
});
parcelHelpers.export(exports, "winterCGRequestToRequestData", function() {
    return 0, _requestdataJs.winterCGRequestToRequestData;
});
parcelHelpers.export(exports, "severityFromString", function() {
    return 0, _severityJs.severityFromString;
});
parcelHelpers.export(exports, "severityLevelFromString", function() {
    return 0, _severityJs.severityLevelFromString;
});
parcelHelpers.export(exports, "validSeverityLevels", function() {
    return 0, _severityJs.validSeverityLevels;
});
parcelHelpers.export(exports, "createStackParser", function() {
    return 0, _stacktraceJs.createStackParser;
});
parcelHelpers.export(exports, "getFunctionName", function() {
    return 0, _stacktraceJs.getFunctionName;
});
parcelHelpers.export(exports, "nodeStackLineParser", function() {
    return 0, _stacktraceJs.nodeStackLineParser;
});
parcelHelpers.export(exports, "stackParserFromStackParserOptions", function() {
    return 0, _stacktraceJs.stackParserFromStackParserOptions;
});
parcelHelpers.export(exports, "stripSentryFramesAndReverse", function() {
    return 0, _stacktraceJs.stripSentryFramesAndReverse;
});
parcelHelpers.export(exports, "isMatchingPattern", function() {
    return 0, _stringJs.isMatchingPattern;
});
parcelHelpers.export(exports, "safeJoin", function() {
    return 0, _stringJs.safeJoin;
});
parcelHelpers.export(exports, "snipLine", function() {
    return 0, _stringJs.snipLine;
});
parcelHelpers.export(exports, "stringMatchesSomePattern", function() {
    return 0, _stringJs.stringMatchesSomePattern;
});
parcelHelpers.export(exports, "truncate", function() {
    return 0, _stringJs.truncate;
});
parcelHelpers.export(exports, "isNativeFetch", function() {
    return 0, _supportsJs.isNativeFetch;
});
parcelHelpers.export(exports, "supportsDOMError", function() {
    return 0, _supportsJs.supportsDOMError;
});
parcelHelpers.export(exports, "supportsDOMException", function() {
    return 0, _supportsJs.supportsDOMException;
});
parcelHelpers.export(exports, "supportsErrorEvent", function() {
    return 0, _supportsJs.supportsErrorEvent;
});
parcelHelpers.export(exports, "supportsFetch", function() {
    return 0, _supportsJs.supportsFetch;
});
parcelHelpers.export(exports, "supportsNativeFetch", function() {
    return 0, _supportsJs.supportsNativeFetch;
});
parcelHelpers.export(exports, "supportsReferrerPolicy", function() {
    return 0, _supportsJs.supportsReferrerPolicy;
});
parcelHelpers.export(exports, "supportsReportingObserver", function() {
    return 0, _supportsJs.supportsReportingObserver;
});
parcelHelpers.export(exports, "SyncPromise", function() {
    return 0, _syncpromiseJs.SyncPromise;
});
parcelHelpers.export(exports, "rejectedSyncPromise", function() {
    return 0, _syncpromiseJs.rejectedSyncPromise;
});
parcelHelpers.export(exports, "resolvedSyncPromise", function() {
    return 0, _syncpromiseJs.resolvedSyncPromise;
});
parcelHelpers.export(exports, "_browserPerformanceTimeOriginMode", function() {
    return 0, _timeJs._browserPerformanceTimeOriginMode;
});
parcelHelpers.export(exports, "browserPerformanceTimeOrigin", function() {
    return 0, _timeJs.browserPerformanceTimeOrigin;
});
parcelHelpers.export(exports, "dateTimestampInSeconds", function() {
    return 0, _timeJs.dateTimestampInSeconds;
});
parcelHelpers.export(exports, "timestampInSeconds", function() {
    return 0, _timeJs.timestampInSeconds;
});
parcelHelpers.export(exports, "timestampWithMs", function() {
    return 0, _timeJs.timestampWithMs;
});
parcelHelpers.export(exports, "TRACEPARENT_REGEXP", function() {
    return 0, _tracingJs.TRACEPARENT_REGEXP;
});
parcelHelpers.export(exports, "extractTraceparentData", function() {
    return 0, _tracingJs.extractTraceparentData;
});
parcelHelpers.export(exports, "generateSentryTraceHeader", function() {
    return 0, _tracingJs.generateSentryTraceHeader;
});
parcelHelpers.export(exports, "propagationContextFromHeaders", function() {
    return 0, _tracingJs.propagationContextFromHeaders;
});
parcelHelpers.export(exports, "tracingContextFromHeaders", function() {
    return 0, _tracingJs.tracingContextFromHeaders;
});
parcelHelpers.export(exports, "getSDKSource", function() {
    return 0, _envJs.getSDKSource;
});
parcelHelpers.export(exports, "isBrowserBundle", function() {
    return 0, _envJs.isBrowserBundle;
});
parcelHelpers.export(exports, "addItemToEnvelope", function() {
    return 0, _envelopeJs.addItemToEnvelope;
});
parcelHelpers.export(exports, "createAttachmentEnvelopeItem", function() {
    return 0, _envelopeJs.createAttachmentEnvelopeItem;
});
parcelHelpers.export(exports, "createEnvelope", function() {
    return 0, _envelopeJs.createEnvelope;
});
parcelHelpers.export(exports, "createEventEnvelopeHeaders", function() {
    return 0, _envelopeJs.createEventEnvelopeHeaders;
});
parcelHelpers.export(exports, "envelopeContainsItemType", function() {
    return 0, _envelopeJs.envelopeContainsItemType;
});
parcelHelpers.export(exports, "envelopeItemTypeToDataCategory", function() {
    return 0, _envelopeJs.envelopeItemTypeToDataCategory;
});
parcelHelpers.export(exports, "forEachEnvelopeItem", function() {
    return 0, _envelopeJs.forEachEnvelopeItem;
});
parcelHelpers.export(exports, "getSdkMetadataForEnvelopeHeader", function() {
    return 0, _envelopeJs.getSdkMetadataForEnvelopeHeader;
});
parcelHelpers.export(exports, "parseEnvelope", function() {
    return 0, _envelopeJs.parseEnvelope;
});
parcelHelpers.export(exports, "serializeEnvelope", function() {
    return 0, _envelopeJs.serializeEnvelope;
});
parcelHelpers.export(exports, "createClientReportEnvelope", function() {
    return 0, _clientreportJs.createClientReportEnvelope;
});
parcelHelpers.export(exports, "DEFAULT_RETRY_AFTER", function() {
    return 0, _ratelimitJs.DEFAULT_RETRY_AFTER;
});
parcelHelpers.export(exports, "disabledUntil", function() {
    return 0, _ratelimitJs.disabledUntil;
});
parcelHelpers.export(exports, "isRateLimited", function() {
    return 0, _ratelimitJs.isRateLimited;
});
parcelHelpers.export(exports, "parseRetryAfterHeader", function() {
    return 0, _ratelimitJs.parseRetryAfterHeader;
});
parcelHelpers.export(exports, "updateRateLimits", function() {
    return 0, _ratelimitJs.updateRateLimits;
});
parcelHelpers.export(exports, "BAGGAGE_HEADER_NAME", function() {
    return 0, _baggageJs.BAGGAGE_HEADER_NAME;
});
parcelHelpers.export(exports, "MAX_BAGGAGE_STRING_LENGTH", function() {
    return 0, _baggageJs.MAX_BAGGAGE_STRING_LENGTH;
});
parcelHelpers.export(exports, "SENTRY_BAGGAGE_KEY_PREFIX", function() {
    return 0, _baggageJs.SENTRY_BAGGAGE_KEY_PREFIX;
});
parcelHelpers.export(exports, "SENTRY_BAGGAGE_KEY_PREFIX_REGEX", function() {
    return 0, _baggageJs.SENTRY_BAGGAGE_KEY_PREFIX_REGEX;
});
parcelHelpers.export(exports, "baggageHeaderToDynamicSamplingContext", function() {
    return 0, _baggageJs.baggageHeaderToDynamicSamplingContext;
});
parcelHelpers.export(exports, "dynamicSamplingContextToSentryBaggageHeader", function() {
    return 0, _baggageJs.dynamicSamplingContextToSentryBaggageHeader;
});
parcelHelpers.export(exports, "getNumberOfUrlSegments", function() {
    return 0, _urlJs.getNumberOfUrlSegments;
});
parcelHelpers.export(exports, "getSanitizedUrlString", function() {
    return 0, _urlJs.getSanitizedUrlString;
});
parcelHelpers.export(exports, "parseUrl", function() {
    return 0, _urlJs.parseUrl;
});
parcelHelpers.export(exports, "stripUrlQueryAndFragment", function() {
    return 0, _urlJs.stripUrlQueryAndFragment;
});
parcelHelpers.export(exports, "addOrUpdateIntegration", function() {
    return 0, _userIntegrationsJs.addOrUpdateIntegration;
});
parcelHelpers.export(exports, "makeFifoCache", function() {
    return 0, _cacheJs.makeFifoCache;
});
parcelHelpers.export(exports, "eventFromMessage", function() {
    return 0, _eventbuilderJs.eventFromMessage;
});
parcelHelpers.export(exports, "eventFromUnknownInput", function() {
    return 0, _eventbuilderJs.eventFromUnknownInput;
});
parcelHelpers.export(exports, "exceptionFromError", function() {
    return 0, _eventbuilderJs.exceptionFromError;
});
parcelHelpers.export(exports, "parseStackFrames", function() {
    return 0, _eventbuilderJs.parseStackFrames;
});
parcelHelpers.export(exports, "callFrameToStackFrame", function() {
    return 0, _anrJs.callFrameToStackFrame;
});
parcelHelpers.export(exports, "watchdogTimer", function() {
    return 0, _anrJs.watchdogTimer;
});
parcelHelpers.export(exports, "LRUMap", function() {
    return 0, _lruJs.LRUMap;
});
parcelHelpers.export(exports, "_asyncNullishCoalesce", function() {
    return 0, _asyncNullishCoalesceJs._asyncNullishCoalesce;
});
parcelHelpers.export(exports, "_asyncOptionalChain", function() {
    return 0, _asyncOptionalChainJs._asyncOptionalChain;
});
parcelHelpers.export(exports, "_asyncOptionalChainDelete", function() {
    return 0, _asyncOptionalChainDeleteJs._asyncOptionalChainDelete;
});
parcelHelpers.export(exports, "_nullishCoalesce", function() {
    return 0, _nullishCoalesceJs._nullishCoalesce;
});
parcelHelpers.export(exports, "_optionalChain", function() {
    return 0, _optionalChainJs._optionalChain;
});
parcelHelpers.export(exports, "_optionalChainDelete", function() {
    return 0, _optionalChainDeleteJs._optionalChainDelete;
});
parcelHelpers.export(exports, "addConsoleInstrumentationHandler", function() {
    return 0, _consoleJs.addConsoleInstrumentationHandler;
});
parcelHelpers.export(exports, "addClickKeypressInstrumentationHandler", function() {
    return 0, _domJs.addClickKeypressInstrumentationHandler;
});
parcelHelpers.export(exports, "SENTRY_XHR_DATA_KEY", function() {
    return 0, _xhrJs.SENTRY_XHR_DATA_KEY;
});
parcelHelpers.export(exports, "addXhrInstrumentationHandler", function() {
    return 0, _xhrJs.addXhrInstrumentationHandler;
});
parcelHelpers.export(exports, "addFetchInstrumentationHandler", function() {
    return 0, _fetchJs.addFetchInstrumentationHandler;
});
parcelHelpers.export(exports, "addHistoryInstrumentationHandler", function() {
    return 0, _historyJs.addHistoryInstrumentationHandler;
});
parcelHelpers.export(exports, "addGlobalErrorInstrumentationHandler", function() {
    return 0, _globalErrorJs.addGlobalErrorInstrumentationHandler;
});
parcelHelpers.export(exports, "addGlobalUnhandledRejectionInstrumentationHandler", function() {
    return 0, _globalUnhandledRejectionJs.addGlobalUnhandledRejectionInstrumentationHandler;
});
parcelHelpers.export(exports, "resetInstrumentationHandlers", function() {
    return 0, _handlersJs.resetInstrumentationHandlers;
});
parcelHelpers.export(exports, "filenameIsInApp", function() {
    return 0, _nodeStackTraceJs.filenameIsInApp;
});
parcelHelpers.export(exports, "escapeStringForRegex", function() {
    return 0, _escapeStringForRegexJs.escapeStringForRegex;
});
parcelHelpers.export(exports, "supportsHistory", function() {
    return 0, _supportsHistoryJs.supportsHistory;
});
var _aggregateErrorsJs = require("./aggregate-errors.js");
var _browserJs = require("./browser.js");
var _dsnJs = require("./dsn.js");
var _errorJs = require("./error.js");
var _worldwideJs = require("./worldwide.js");
var _indexJs = require("./instrument/index.js");
var _isJs = require("./is.js");
var _isBrowserJs = require("./isBrowser.js");
var _loggerJs = require("./logger.js");
var _memoJs = require("./memo.js");
var _miscJs = require("./misc.js");
var _nodeJs = require("./node.js");
var _normalizeJs = require("./normalize.js");
var _objectJs = require("./object.js");
var _pathJs = require("./path.js");
var _promisebufferJs = require("./promisebuffer.js");
var _requestdataJs = require("./requestdata.js");
var _severityJs = require("./severity.js");
var _stacktraceJs = require("./stacktrace.js");
var _stringJs = require("./string.js");
var _supportsJs = require("./supports.js");
var _syncpromiseJs = require("./syncpromise.js");
var _timeJs = require("./time.js");
var _tracingJs = require("./tracing.js");
var _envJs = require("./env.js");
var _envelopeJs = require("./envelope.js");
var _clientreportJs = require("./clientreport.js");
var _ratelimitJs = require("./ratelimit.js");
var _baggageJs = require("./baggage.js");
var _urlJs = require("./url.js");
var _userIntegrationsJs = require("./userIntegrations.js");
var _cacheJs = require("./cache.js");
var _eventbuilderJs = require("./eventbuilder.js");
var _anrJs = require("./anr.js");
var _lruJs = require("./lru.js");
var _asyncNullishCoalesceJs = require("./buildPolyfills/_asyncNullishCoalesce.js");
var _asyncOptionalChainJs = require("./buildPolyfills/_asyncOptionalChain.js");
var _asyncOptionalChainDeleteJs = require("./buildPolyfills/_asyncOptionalChainDelete.js");
var _nullishCoalesceJs = require("./buildPolyfills/_nullishCoalesce.js");
var _optionalChainJs = require("./buildPolyfills/_optionalChain.js");
var _optionalChainDeleteJs = require("./buildPolyfills/_optionalChainDelete.js");
var _consoleJs = require("./instrument/console.js");
var _domJs = require("./instrument/dom.js");
var _xhrJs = require("./instrument/xhr.js");
var _fetchJs = require("./instrument/fetch.js");
var _historyJs = require("./instrument/history.js");
var _globalErrorJs = require("./instrument/globalError.js");
var _globalUnhandledRejectionJs = require("./instrument/globalUnhandledRejection.js");
var _handlersJs = require("./instrument/_handlers.js");
var _nodeStackTraceJs = require("./node-stack-trace.js");
var _escapeStringForRegexJs = require("./vendor/escapeStringForRegex.js");
var _supportsHistoryJs = require("./vendor/supportsHistory.js");

},{"./aggregate-errors.js":"gUgAH","./browser.js":"6jrio","./dsn.js":"iPwy7","./error.js":"6fvda","./worldwide.js":"aZo8o","./instrument/index.js":"9uKaJ","./is.js":"7y7Yx","./isBrowser.js":"4jmSN","./logger.js":"it07k","./memo.js":"37i7z","./misc.js":"fyY3i","./node.js":"kyjyZ","./normalize.js":"b1fOd","./object.js":"auET5","./path.js":"eRzHf","./promisebuffer.js":"55UvO","./requestdata.js":"lJcCU","./severity.js":"k8Uku","./stacktrace.js":"9vw3J","./string.js":"ily1y","./supports.js":"iobKj","./syncpromise.js":"eZXt9","./time.js":"5WKyq","./tracing.js":"38pRJ","./env.js":"boGOz","./envelope.js":"jaYLL","./clientreport.js":"6lWHX","./ratelimit.js":"hNjcc","./baggage.js":"ghVrT","./url.js":"iIvME","./userIntegrations.js":"jlPfK","./cache.js":"bF1Wf","./eventbuilder.js":"2sAyX","./anr.js":"cSbuX","./lru.js":"dq8pf","./buildPolyfills/_asyncNullishCoalesce.js":"7Ym4p","./buildPolyfills/_asyncOptionalChain.js":"aX8Pj","./buildPolyfills/_asyncOptionalChainDelete.js":"dodKv","./buildPolyfills/_nullishCoalesce.js":"1nnqc","./buildPolyfills/_optionalChain.js":"8sZr1","./buildPolyfills/_optionalChainDelete.js":"2rKpD","./instrument/console.js":"lHfOB","./instrument/dom.js":"3jxfc","./instrument/xhr.js":"jff0W","./instrument/fetch.js":"fJi32","./instrument/history.js":"iTKnL","./instrument/globalError.js":"ezS5O","./instrument/globalUnhandledRejection.js":"eNVB1","./instrument/_handlers.js":"4eGNw","./node-stack-trace.js":"khf3c","./vendor/escapeStringForRegex.js":"5nlT8","./vendor/supportsHistory.js":"kMW0Q","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gUgAH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "applyAggregateErrorsToEvent", function() {
    return applyAggregateErrorsToEvent;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _isJs = require("./is.js");
var _stringJs = require("./string.js");
/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function applyAggregateErrorsToEvent(exceptionFromErrorImplementation, parser) {
    var maxValueLimit = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 250, key = arguments.length > 3 ? arguments[3] : void 0, limit = arguments.length > 4 ? arguments[4] : void 0, event = arguments.length > 5 ? arguments[5] : void 0, hint = arguments.length > 6 ? arguments[6] : void 0;
    if (!event.exception || !event.exception.values || !hint || !(0, _isJs.isInstanceOf)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    var originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = truncateAggregateExceptions(aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0), maxValueLimit);
}
function aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    var newExceptions = (0, _toConsumableArray._)(prevExceptions);
    // Recursively call this function in order to walk down a chain of errors
    if ((0, _isJs.isInstanceOf)(error[key], Error)) {
        applyExceptionGroupFieldsForParentException(exception, exceptionId);
        var newException = exceptionFromErrorImplementation(parser, error[key]);
        var newExceptionId = newExceptions.length;
        applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException
        ].concat((0, _toConsumableArray._)(newExceptions)), newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach(function(childError, i) {
        if ((0, _isJs.isInstanceOf)(childError, Error)) {
            applyExceptionGroupFieldsForParentException(exception, exceptionId);
            var newException = exceptionFromErrorImplementation(parser, childError);
            var newExceptionId = newExceptions.length;
            applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException
            ].concat((0, _toConsumableArray._)(newExceptions)), newException, newExceptionId);
        }
    });
    return newExceptions;
}
function applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = (0, _objectSpreadProps._)((0, _objectSpread._)({}, exception.mechanism, exception.type === 'AggregateError' && {
        is_exception_group: true
    }), {
        exception_id: exceptionId
    });
}
function applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = (0, _objectSpreadProps._)((0, _objectSpread._)({}, exception.mechanism), {
        type: 'chained',
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    });
}
/**
 * Truncate the message (exception.value) of all exceptions in the event.
 * Because this event processor is ran after `applyClientOptions`,
 * we need to truncate the message of the added exceptions here.
 */ function truncateAggregateExceptions(exceptions, maxValueLength) {
    return exceptions.map(function(exception) {
        if (exception.value) exception.value = (0, _stringJs.truncate)(exception.value, maxValueLength);
        return exception;
    });
}

},{"@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_object_spread_props":"fLCYP","@swc/helpers/_/_to_consumable_array":"eqNDD","./is.js":"7y7Yx","./string.js":"ily1y","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7y7Yx":[function(require,module,exports,__globalThis) {
// eslint-disable-next-line @typescript-eslint/unbound-method
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isDOMError", function() {
    return isDOMError;
});
parcelHelpers.export(exports, "isDOMException", function() {
    return isDOMException;
});
parcelHelpers.export(exports, "isElement", function() {
    return isElement;
});
parcelHelpers.export(exports, "isError", function() {
    return isError;
});
parcelHelpers.export(exports, "isErrorEvent", function() {
    return isErrorEvent;
});
parcelHelpers.export(exports, "isEvent", function() {
    return isEvent;
});
parcelHelpers.export(exports, "isInstanceOf", function() {
    return isInstanceOf;
});
parcelHelpers.export(exports, "isNaN", function() {
    return isNaN;
});
parcelHelpers.export(exports, "isParameterizedString", function() {
    return isParameterizedString;
});
parcelHelpers.export(exports, "isPlainObject", function() {
    return isPlainObject;
});
parcelHelpers.export(exports, "isPrimitive", function() {
    return isPrimitive;
});
parcelHelpers.export(exports, "isRegExp", function() {
    return isRegExp;
});
parcelHelpers.export(exports, "isString", function() {
    return isString;
});
parcelHelpers.export(exports, "isSyntheticEvent", function() {
    return isSyntheticEvent;
});
parcelHelpers.export(exports, "isThenable", function() {
    return isThenable;
});
parcelHelpers.export(exports, "isVueViewModel", function() {
    return isVueViewModel;
});
var objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isError(wat) {
    switch(objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return isInstanceOf(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function isBuiltin(wat, className) {
    return objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isErrorEvent(wat) {
    return isBuiltin(wat, 'ErrorEvent');
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isDOMError(wat) {
    return isBuiltin(wat, 'DOMError');
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isDOMException(wat) {
    return isBuiltin(wat, 'DOMException');
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isString(wat) {
    return isBuiltin(wat, 'String');
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isParameterizedString(wat) {
    return typeof wat === 'object' && wat !== null && '__sentry_template_string__' in wat && '__sentry_template_values__' in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isPrimitive(wat) {
    return wat === null || isParameterizedString(wat) || typeof wat !== 'object' && typeof wat !== 'function';
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isPlainObject(wat) {
    return isBuiltin(wat, 'Object');
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isEvent(wat) {
    return typeof Event !== 'undefined' && isInstanceOf(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isElement(wat) {
    return typeof Element !== 'undefined' && isInstanceOf(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isRegExp(wat) {
    return isBuiltin(wat, 'RegExp');
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function isThenable(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isSyntheticEvent(wat) {
    return isPlainObject(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isNaN(wat) {
    return typeof wat === 'number' && wat !== wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function isInstanceOf(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function isVueViewModel(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === 'object' && wat !== null && (wat.__isVue || wat._isVue));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"ily1y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isMatchingPattern", function() {
    return isMatchingPattern;
});
parcelHelpers.export(exports, "safeJoin", function() {
    return safeJoin;
});
parcelHelpers.export(exports, "snipLine", function() {
    return snipLine;
});
parcelHelpers.export(exports, "stringMatchesSomePattern", function() {
    return stringMatchesSomePattern;
});
parcelHelpers.export(exports, "truncate", function() {
    return truncate;
});
var _isJs = require("./is.js");
/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function truncate(str) {
    var max = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function snipLine(line, colno) {
    var newLine = line;
    var lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    var start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    var end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function safeJoin(input, delimiter) {
    if (!Array.isArray(input)) return '';
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(var i = 0; i < input.length; i++){
        var value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, _isJs.isVueViewModel)(value)) output.push('[VueViewModel]');
            else output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function isMatchingPattern(value, pattern) {
    var requireExactStringMatch = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (!(0, _isJs.isString)(value)) return false;
    if ((0, _isJs.isRegExp)(pattern)) return pattern.test(value);
    if ((0, _isJs.isString)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function stringMatchesSomePattern(testString) {
    var patterns = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], requireExactStringMatch = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return patterns.some(function(pattern) {
        return isMatchingPattern(testString, pattern, requireExactStringMatch);
    });
}

},{"./is.js":"7y7Yx","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6jrio":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getComponentName", function() {
    return getComponentName;
});
parcelHelpers.export(exports, "getDomElement", function() {
    return getDomElement;
});
parcelHelpers.export(exports, "getLocationHref", function() {
    return getLocationHref;
});
parcelHelpers.export(exports, "htmlTreeAsString", function() {
    return htmlTreeAsString;
});
var _isJs = require("./is.js");
var _worldwideJs = require("./worldwide.js");
// eslint-disable-next-line deprecation/deprecation
var WINDOW = (0, _worldwideJs.getGlobalObject)();
var DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function htmlTreeAsString(elem) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!elem) return '<unknown>';
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = ' > ';
        var sepLength = separator.length;
        var nextStr;
        var keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        var maxStringLength = !Array.isArray(options) && options.maxStringLength || DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = _htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function _htmlElementAsString(el, keyAttrs) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) return '';
    // @ts-expect-error WINDOW has HTMLElement
    if (WINDOW.HTMLElement) {
        // If using the component name annotation plugin, this value may be available on the DOM node
        if (elem instanceof HTMLElement && elem.dataset && elem.dataset['sentryComponent']) return elem.dataset['sentryComponent'];
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    var keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter(function(keyAttr) {
        return elem.getAttribute(keyAttr);
    }).map(function(keyAttr) {
        return [
            keyAttr,
            elem.getAttribute(keyAttr)
        ];
    }) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach(function(keyAttrPair) {
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, _isJs.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push(`.${classes[i]}`);
        }
    }
    var allowedAttrs = [
        'aria-label',
        'type',
        'name',
        'title',
        'alt'
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push(`[${key}="${attr}"]`);
    }
    return out.join('');
}
/**
 * A safe form of location.href
 */ function getLocationHref() {
    try {
        return WINDOW.document.location.href;
    } catch (oO) {
        return '';
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function getDomElement(selector) {
    if (WINDOW.document && WINDOW.document.querySelector) return WINDOW.document.querySelector(selector);
    return null;
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` attribute. This attribute is added at build-time
 * by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function getComponentName(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!WINDOW.HTMLElement) return null;
    var currentElem = elem;
    var MAX_TRAVERSE_HEIGHT = 5;
    for(var i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement && currentElem.dataset['sentryComponent']) return currentElem.dataset['sentryComponent'];
        currentElem = currentElem.parentNode;
    }
    return null;
}

},{"./is.js":"7y7Yx","./worldwide.js":"aZo8o","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"aZo8o":[function(require,module,exports,__globalThis) {
/** Internal global with common properties and Sentry extensions  */ // The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
/** Returns 'obj' if it's the global object, otherwise returns undefined */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GLOBAL_OBJ", function() {
    return GLOBAL_OBJ;
});
parcelHelpers.export(exports, "getGlobalObject", function() {
    return getGlobalObject;
});
parcelHelpers.export(exports, "getGlobalSingleton", function() {
    return getGlobalSingleton;
});
var global = arguments[3];
function isGlobalObj(obj) {
    return obj && obj.Math == Math ? obj : undefined;
}
/** Get's the global object for the current JavaScript runtime */ var GLOBAL_OBJ = typeof globalThis == 'object' && isGlobalObj(globalThis) || // eslint-disable-next-line no-restricted-globals
typeof window == 'object' && isGlobalObj(window) || typeof self == 'object' && isGlobalObj(self) || typeof global == 'object' && isGlobalObj(global) || function() {
    return this;
}() || {};
/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */ function getGlobalObject() {
    return GLOBAL_OBJ;
}
/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function getGlobalSingleton(name, creator, obj) {
    var gbl = obj || GLOBAL_OBJ;
    var __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    var singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"iPwy7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dsnFromString", function() {
    return dsnFromString;
});
parcelHelpers.export(exports, "dsnToString", function() {
    return dsnToString;
});
parcelHelpers.export(exports, "makeDsn", function() {
    return makeDsn;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _debugBuildJs = require("./debug-build.js");
var _loggerJs = require("./logger.js");
/** Regular expression used to parse a Dsn. */ var DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function dsnToString(dsn) {
    var withPassword = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var host = dsn.host, path = dsn.path, pass = dsn.pass, port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol, publicKey = dsn.publicKey;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ''}` + `@${host}${port ? `:${port}` : ''}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function dsnFromString(str) {
    var match = DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, _loggerJs.consoleSandbox)(function() {
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    var _match_slice = (0, _slicedToArray._)(match.slice(1), 6), protocol = _match_slice[0], publicKey = _match_slice[1], tmp = _match_slice[2], pass = tmp === void 0 ? '' : tmp, host = _match_slice[3], tmp1 = _match_slice[4], port = tmp1 === void 0 ? '' : tmp1, lastPath = _match_slice[5];
    var path = '';
    var projectId = lastPath;
    var split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        var projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId
    };
}
function validateDsn(dsn) {
    if (!(0, _debugBuildJs.DEBUG_BUILD)) return true;
    var port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol;
    var requiredComponents = [
        'protocol',
        'publicKey',
        'host',
        'projectId'
    ];
    var hasMissingRequiredComponent = requiredComponents.find(function(component) {
        if (!dsn[component]) {
            (0, _loggerJs.logger).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, _loggerJs.logger).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!isValidProtocol(protocol)) {
        (0, _loggerJs.logger).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, _loggerJs.logger).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function makeDsn(from) {
    var components = typeof from === 'string' ? dsnFromString(from) : dsnFromComponents(from);
    if (!components || !validateDsn(components)) return undefined;
    return components;
}

},{"@swc/helpers/_/_sliced_to_array":"ha6sq","./debug-build.js":"2NN5Y","./logger.js":"it07k","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2NN5Y":[function(require,module,exports,__globalThis) {
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEBUG_BUILD", function() {
    return DEBUG_BUILD;
});
var DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"it07k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CONSOLE_LEVELS", function() {
    return CONSOLE_LEVELS;
});
parcelHelpers.export(exports, "consoleSandbox", function() {
    return consoleSandbox;
});
parcelHelpers.export(exports, "logger", function() {
    return logger;
});
parcelHelpers.export(exports, "originalConsoleMethods", function() {
    return originalConsoleMethods;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _debugBuildJs = require("./debug-build.js");
var _worldwideJs = require("./worldwide.js");
/** Prefix for logging strings */ var PREFIX = 'Sentry Logger ';
var CONSOLE_LEVELS = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert',
    'trace'
];
/** This may be mutated by the console instrumentation. */ var originalConsoleMethods = {};
/** JSDoc */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function consoleSandbox(callback) {
    if (!('console' in (0, _worldwideJs.GLOBAL_OBJ))) return callback();
    var console = (0, _worldwideJs.GLOBAL_OBJ).console;
    var wrappedFuncs = {};
    var wrappedLevels = Object.keys(originalConsoleMethods);
    // Restore all wrapped console methods
    wrappedLevels.forEach(function(level) {
        var originalConsoleMethod = originalConsoleMethods[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach(function(level) {
            console[level] = wrappedFuncs[level];
        });
    }
}
function makeLogger() {
    var enabled = false;
    var logger = {
        enable: function() {
            enabled = true;
        },
        disable: function() {
            enabled = false;
        },
        isEnabled: function() {
            return enabled;
        }
    };
    if (0, _debugBuildJs.DEBUG_BUILD) CONSOLE_LEVELS.forEach(function(name) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (enabled) consoleSandbox(function() {
                var _GLOBAL_OBJ_console;
                (_GLOBAL_OBJ_console = (0, _worldwideJs.GLOBAL_OBJ).console)[name].apply(_GLOBAL_OBJ_console, [
                    `${PREFIX}[${name}]:`
                ].concat((0, _toConsumableArray._)(args)));
            });
        };
    });
    else CONSOLE_LEVELS.forEach(function(name) {
        logger[name] = function() {
            return undefined;
        };
    });
    return logger;
}
var logger = makeLogger();

},{"@swc/helpers/_/_to_consumable_array":"eqNDD","./debug-build.js":"2NN5Y","./worldwide.js":"aZo8o","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6fvda":[function(require,module,exports,__globalThis) {
/** An error emitted by Sentry SDKs and related utilities. */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SentryError", function() {
    return SentryError;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _inherits = require("@swc/helpers/_/_inherits");
var _wrapNativeSuper = require("@swc/helpers/_/_wrap_native_super");
var SentryError = /*#__PURE__*/ function _target(Error1) {
    "use strict";
    (0, _inherits._)(SentryError, Error1);
    function SentryError(message) {
        var logLevel = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'warn';
        (0, _classCallCheck._)(this, SentryError);
        var _this;
        _this = (0, _callSuper._)(this, SentryError, [
            message
        ]);
        _this.message = message;
        _this.name = (this instanceof SentryError ? this.constructor : void 0).prototype.constructor.name;
        // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
        // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
        // instances of `SentryError` fail `obj instanceof SentryError` checks.
        Object.setPrototypeOf(_this, (this instanceof SentryError ? this.constructor : void 0).prototype);
        _this.logLevel = logLevel;
        return _this;
    }
    return SentryError;
}((0, _wrapNativeSuper._)(Error));

},{"@swc/helpers/_/_call_super":"5oPMc","@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_inherits":"j8HRi","@swc/helpers/_/_wrap_native_super":"gNmVc","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"9uKaJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addConsoleInstrumentationHandler", function() {
    return 0, _consoleJs.addConsoleInstrumentationHandler;
});
parcelHelpers.export(exports, "addClickKeypressInstrumentationHandler", function() {
    return 0, _domJs.addClickKeypressInstrumentationHandler;
});
parcelHelpers.export(exports, "addFetchInstrumentationHandler", function() {
    return 0, _fetchJs.addFetchInstrumentationHandler;
});
parcelHelpers.export(exports, "addGlobalErrorInstrumentationHandler", function() {
    return 0, _globalErrorJs.addGlobalErrorInstrumentationHandler;
});
parcelHelpers.export(exports, "addGlobalUnhandledRejectionInstrumentationHandler", function() {
    return 0, _globalUnhandledRejectionJs.addGlobalUnhandledRejectionInstrumentationHandler;
});
parcelHelpers.export(exports, "addHistoryInstrumentationHandler", function() {
    return 0, _historyJs.addHistoryInstrumentationHandler;
});
parcelHelpers.export(exports, "SENTRY_XHR_DATA_KEY", function() {
    return 0, _xhrJs.SENTRY_XHR_DATA_KEY;
});
parcelHelpers.export(exports, "addXhrInstrumentationHandler", function() {
    return 0, _xhrJs.addXhrInstrumentationHandler;
});
parcelHelpers.export(exports, "addInstrumentationHandler", function() {
    return addInstrumentationHandler;
});
var _debugBuildJs = require("../debug-build.js");
var _loggerJs = require("../logger.js");
var _consoleJs = require("./console.js");
var _domJs = require("./dom.js");
var _fetchJs = require("./fetch.js");
var _globalErrorJs = require("./globalError.js");
var _globalUnhandledRejectionJs = require("./globalUnhandledRejection.js");
var _historyJs = require("./history.js");
var _xhrJs = require("./xhr.js");
// TODO(v8): Consider moving this file (or at least parts of it) into the browser package. The registered handlers are mostly non-generic and we risk leaking runtime specific code into generic packages.
/**
 * Add handler that will be called when given type of instrumentation triggers.
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 * @deprecated Use the proper function per instrumentation type instead!
 */ function addInstrumentationHandler(type, callback) {
    switch(type){
        case 'console':
            return (0, _consoleJs.addConsoleInstrumentationHandler)(callback);
        case 'dom':
            return (0, _domJs.addClickKeypressInstrumentationHandler)(callback);
        case 'xhr':
            return (0, _xhrJs.addXhrInstrumentationHandler)(callback);
        case 'fetch':
            return (0, _fetchJs.addFetchInstrumentationHandler)(callback);
        case 'history':
            return (0, _historyJs.addHistoryInstrumentationHandler)(callback);
        case 'error':
            return (0, _globalErrorJs.addGlobalErrorInstrumentationHandler)(callback);
        case 'unhandledrejection':
            return (0, _globalUnhandledRejectionJs.addGlobalUnhandledRejectionInstrumentationHandler)(callback);
        default:
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _loggerJs.logger).warn('unknown instrumentation type:', type);
    }
}

},{"../debug-build.js":"2NN5Y","../logger.js":"it07k","./console.js":"lHfOB","./dom.js":"3jxfc","./fetch.js":"fJi32","./globalError.js":"ezS5O","./globalUnhandledRejection.js":"eNVB1","./history.js":"iTKnL","./xhr.js":"jff0W","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"lHfOB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addConsoleInstrumentationHandler", function() {
    return addConsoleInstrumentationHandler;
});
var _loggerJs = require("../logger.js");
var _objectJs = require("../object.js");
var _worldwideJs = require("../worldwide.js");
var _handlersJs = require("./_handlers.js");
/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function addConsoleInstrumentationHandler(handler) {
    var type = 'console';
    (0, _handlersJs.addHandler)(type, handler);
    (0, _handlersJs.maybeInstrument)(type, instrumentConsole);
}
function instrumentConsole() {
    if (!('console' in (0, _worldwideJs.GLOBAL_OBJ))) return;
    (0, _loggerJs.CONSOLE_LEVELS).forEach(function(level) {
        if (!(level in (0, _worldwideJs.GLOBAL_OBJ).console)) return;
        (0, _objectJs.fill)((0, _worldwideJs.GLOBAL_OBJ).console, level, function(originalConsoleMethod) {
            (0, _loggerJs.originalConsoleMethods)[level] = originalConsoleMethod;
            return function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var handlerData = {
                    args: args,
                    level: level
                };
                (0, _handlersJs.triggerHandlers)('console', handlerData);
                var log = (0, _loggerJs.originalConsoleMethods)[level];
                log && log.apply((0, _worldwideJs.GLOBAL_OBJ).console, args);
            };
        });
    });
}

},{"../logger.js":"it07k","../object.js":"auET5","../worldwide.js":"aZo8o","./_handlers.js":"4eGNw","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"auET5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addNonEnumerableProperty", function() {
    return addNonEnumerableProperty;
});
parcelHelpers.export(exports, "convertToPlainObject", function() {
    return convertToPlainObject;
});
parcelHelpers.export(exports, "dropUndefinedKeys", function() {
    return dropUndefinedKeys;
});
parcelHelpers.export(exports, "extractExceptionKeysForMessage", function() {
    return extractExceptionKeysForMessage;
});
parcelHelpers.export(exports, "fill", function() {
    return fill;
});
parcelHelpers.export(exports, "getOriginalFunction", function() {
    return getOriginalFunction;
});
parcelHelpers.export(exports, "markFunctionWrapped", function() {
    return markFunctionWrapped;
});
parcelHelpers.export(exports, "objectify", function() {
    return objectify;
});
parcelHelpers.export(exports, "urlEncode", function() {
    return urlEncode;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _browserJs = require("./browser.js");
var _debugBuildJs = require("./debug-build.js");
var _isJs = require("./is.js");
var _loggerJs = require("./logger.js");
var _stringJs = require("./string.js");
/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function fill(source, name, replacementFactory) {
    if (!(name in source)) return;
    var original = source[name];
    var wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') markFunctionWrapped(wrapped, original);
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function addNonEnumerableProperty(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _loggerJs.logger).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function markFunctionWrapped(wrapped, original) {
    try {
        var proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        addNonEnumerableProperty(wrapped, '__sentry_original__', original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ function getOriginalFunction(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */ function urlEncode(object) {
    return Object.keys(object).map(function(key) {
        return `${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`;
    }).join('&');
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */ function convertToPlainObject(value) {
    if ((0, _isJs.isError)(value)) return (0, _objectSpread._)({
        message: value.message,
        name: value.name,
        stack: value.stack
    }, getOwnProperties(value));
    else if ((0, _isJs.isEvent)(value)) {
        var newObj = (0, _objectSpread._)({
            type: value.type,
            target: serializeEventTarget(value.target),
            currentTarget: serializeEventTarget(value.currentTarget)
        }, getOwnProperties(value));
        if (typeof CustomEvent !== 'undefined' && (0, _isJs.isInstanceOf)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function serializeEventTarget(target) {
    try {
        return (0, _isJs.isElement)(target) ? (0, _browserJs.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function getOwnProperties(obj) {
    if (typeof obj === 'object' && obj !== null) {
        var extractedProps = {};
        for(var property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function extractExceptionKeysForMessage(exception) {
    var maxLength = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 40;
    var keys = Object.keys(convertToPlainObject(exception));
    keys.sort();
    if (!keys.length) return '[object has no keys]';
    if (keys[0].length >= maxLength) return (0, _stringJs.truncate)(keys[0], maxLength);
    for(var includedKeys = keys.length; includedKeys > 0; includedKeys--){
        var serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, _stringJs.truncate)(serialized, maxLength);
    }
    return '';
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function dropUndefinedKeys(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    var memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return _dropUndefinedKeys(inputValue, memoizationMap);
}
function _dropUndefinedKeys(inputValue, memoizationMap) {
    if (isPojo(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        var memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        var returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = Object.keys(inputValue)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                if (typeof inputValue[key] !== 'undefined') returnValue[key] = _dropUndefinedKeys(inputValue[key], memoizationMap);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        var memoVal1 = memoizationMap.get(inputValue);
        if (memoVal1 !== undefined) return memoVal1;
        var returnValue1 = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue1);
        inputValue.forEach(function(item) {
            returnValue1.push(_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue1;
    }
    return inputValue;
}
function isPojo(input) {
    if (!(0, _isJs.isPlainObject)(input)) return false;
    try {
        var name = Object.getPrototypeOf(input).constructor.name;
        return !name || name === 'Object';
    } catch (e) {
        return true;
    }
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function objectify(wat) {
    var objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, _isJs.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

},{"@swc/helpers/_/_object_spread":"4bEWH","./browser.js":"6jrio","./debug-build.js":"2NN5Y","./is.js":"7y7Yx","./logger.js":"it07k","./string.js":"ily1y","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4eGNw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addHandler", function() {
    return addHandler;
});
parcelHelpers.export(exports, "maybeInstrument", function() {
    return maybeInstrument;
});
parcelHelpers.export(exports, "resetInstrumentationHandlers", function() {
    return resetInstrumentationHandlers;
});
parcelHelpers.export(exports, "triggerHandlers", function() {
    return triggerHandlers;
});
var _debugBuildJs = require("../debug-build.js");
var _loggerJs = require("../logger.js");
var _stacktraceJs = require("../stacktrace.js");
// We keep the handlers globally
var handlers = {};
var instrumented = {};
/** Add a handler function. */ function addHandler(type, handler) {
    handlers[type] = handlers[type] || [];
    handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function resetInstrumentationHandlers() {
    Object.keys(handlers).forEach(function(key) {
        handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function maybeInstrument(type, instrumentFn) {
    if (!instrumented[type]) {
        instrumentFn();
        instrumented[type] = true;
    }
}
/** Trigger handlers for a given instrumentation type. */ function triggerHandlers(type, data) {
    var typeHandlers = type && handlers[type];
    if (!typeHandlers) return;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = typeHandlers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var handler = _step.value;
            try {
                handler(data);
            } catch (e) {
                (0, _debugBuildJs.DEBUG_BUILD) && (0, _loggerJs.logger).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, _stacktraceJs.getFunctionName)(handler)}\nError:`, e);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}

},{"../debug-build.js":"2NN5Y","../logger.js":"it07k","../stacktrace.js":"9vw3J","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"9vw3J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "filenameIsInApp", function() {
    return 0, _nodeStackTraceJs.filenameIsInApp;
});
parcelHelpers.export(exports, "createStackParser", function() {
    return createStackParser;
});
parcelHelpers.export(exports, "getFunctionName", function() {
    return getFunctionName;
});
parcelHelpers.export(exports, "nodeStackLineParser", function() {
    return nodeStackLineParser;
});
parcelHelpers.export(exports, "stackParserFromStackParserOptions", function() {
    return stackParserFromStackParserOptions;
});
parcelHelpers.export(exports, "stripSentryFramesAndReverse", function() {
    return stripSentryFramesAndReverse;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _nodeStackTraceJs = require("./node-stack-trace.js");
var STACKTRACE_FRAME_LIMIT = 50;
// Used to sanitize webpack (error: *) wrapped stack errors
var WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
var STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function createStackParser() {
    for(var _len = arguments.length, parsers = new Array(_len), _key = 0; _key < _len; _key++){
        parsers[_key] = arguments[_key];
    }
    var sortedParsers = parsers.sort(function(a, b) {
        return a[0] - b[0];
    }).map(function(p) {
        return p[1];
    });
    return function(stack) {
        var skipFirst = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        var frames = [];
        var lines = stack.split('\n');
        for(var i = skipFirst; i < lines.length; i++){
            var line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            var cleanedLine = WEBPACK_ERROR_REGEXP.test(line) ? line.replace(WEBPACK_ERROR_REGEXP, '$1') : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = sortedParsers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var parser = _step.value;
                    var frame = parser(cleanedLine);
                    if (frame) {
                        frames.push(frame);
                        break;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            if (frames.length >= STACKTRACE_FRAME_LIMIT) break;
        }
        return stripSentryFramesAndReverse(frames);
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function stackParserFromStackParserOptions(stackParser) {
    if (Array.isArray(stackParser)) return createStackParser.apply(void 0, (0, _toConsumableArray._)(stackParser));
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function stripSentryFramesAndReverse(stack) {
    if (!stack.length) return [];
    var localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test(localStack[localStack.length - 1].function || '')) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || '')) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the hub itself, making it:
        //
        //   Sentry.captureException()
        //   getCurrentHub().captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if (STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || '')) localStack.pop();
    }
    return localStack.slice(0, STACKTRACE_FRAME_LIMIT).map(function(frame) {
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, frame), {
            filename: frame.filename || localStack[localStack.length - 1].filename,
            function: frame.function || '?'
        });
    });
}
var defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */ function getFunctionName(fn) {
    try {
        if (!fn || typeof fn !== 'function') return defaultFunctionName;
        return fn.name || defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return defaultFunctionName;
    }
}
/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */ function nodeStackLineParser(getModule) {
    return [
        90,
        (0, _nodeStackTraceJs.node)(getModule)
    ];
}

},{"@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_object_spread_props":"fLCYP","@swc/helpers/_/_to_consumable_array":"eqNDD","./node-stack-trace.js":"khf3c","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"khf3c":[function(require,module,exports,__globalThis) {
/**
 * Does this filename look like it's part of the app code?
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "filenameIsInApp", function() {
    return filenameIsInApp;
});
parcelHelpers.export(exports, "node", function() {
    return node;
});
function filenameIsInApp(filename) {
    var isNative = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var isInternal = isNative || filename && // It's not internal if it's an absolute linux path
    !filename.startsWith('/') && // It's not internal if it's an absolute windows path
    !filename.match(/^[A-Z]:/) && // It's not internal if the path is starting with a dot
    !filename.startsWith('.') && // It's not internal if the frame has a protocol. In node, this is usually the case if the file got pre-processed with a bundler like webpack
    !filename.match(/^[a-zA-Z]([a-zA-Z0-9.\-+])*:\/\//); // Schema from: https://stackoverflow.com/a/3641782
    // in_app is all that's not an internal Node function or a module within node_modules
    // note that isNative appears to return true even for node core libraries
    // see https://github.com/getsentry/raven-node/issues/176
    return !isInternal && filename !== undefined && !filename.includes('node_modules/');
}
/** Node Stack line parser */ // eslint-disable-next-line complexity
function node(getModule) {
    var FILENAME_MATCH = /^\s*[-]{4,}$/;
    var FULL_MATCH = /at (?:async )?(?:(.+?)\s+\()?(?:(.+):(\d+):(\d+)?|([^)]+))\)?/;
    // eslint-disable-next-line complexity
    return function(line) {
        var lineMatch = line.match(FULL_MATCH);
        if (lineMatch) {
            var object;
            var method;
            var functionName;
            var typeName;
            var methodName;
            if (lineMatch[1]) {
                functionName = lineMatch[1];
                var methodStart = functionName.lastIndexOf('.');
                if (functionName[methodStart - 1] === '.') methodStart--;
                if (methodStart > 0) {
                    object = functionName.slice(0, methodStart);
                    method = functionName.slice(methodStart + 1);
                    var objectEnd = object.indexOf('.Module');
                    if (objectEnd > 0) {
                        functionName = functionName.slice(objectEnd + 1);
                        object = object.slice(0, objectEnd);
                    }
                }
                typeName = undefined;
            }
            if (method) {
                typeName = object;
                methodName = method;
            }
            if (method === '<anonymous>') {
                methodName = undefined;
                functionName = undefined;
            }
            if (functionName === undefined) {
                methodName = methodName || '<anonymous>';
                functionName = typeName ? `${typeName}.${methodName}` : methodName;
            }
            var filename = lineMatch[2] && lineMatch[2].startsWith('file://') ? lineMatch[2].slice(7) : lineMatch[2];
            var isNative = lineMatch[5] === 'native';
            // If it's a Windows path, trim the leading slash so that `/C:/foo` becomes `C:/foo`
            if (filename && filename.match(/\/[A-Z]:/)) filename = filename.slice(1);
            if (!filename && lineMatch[5] && !isNative) filename = lineMatch[5];
            return {
                filename: filename,
                module: getModule ? getModule(filename) : undefined,
                function: functionName,
                lineno: parseInt(lineMatch[3], 10) || undefined,
                colno: parseInt(lineMatch[4], 10) || undefined,
                in_app: filenameIsInApp(filename, isNative)
            };
        }
        if (line.match(FILENAME_MATCH)) return {
            filename: line
        };
        return undefined;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3jxfc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addClickKeypressInstrumentationHandler", function() {
    return addClickKeypressInstrumentationHandler;
});
parcelHelpers.export(exports, "instrumentDOM", function() {
    return instrumentDOM;
});
var _miscJs = require("../misc.js");
var _objectJs = require("../object.js");
var _worldwideJs = require("../worldwide.js");
var _handlersJs = require("./_handlers.js");
var WINDOW = (0, _worldwideJs.GLOBAL_OBJ);
var DEBOUNCE_DURATION = 1000;
var debounceTimerID;
var lastCapturedEventType;
var lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function addClickKeypressInstrumentationHandler(handler) {
    var type = 'dom';
    (0, _handlersJs.addHandler)(type, handler);
    (0, _handlersJs.maybeInstrument)(type, instrumentDOM);
}
/** Exported for tests only. */ function instrumentDOM() {
    if (!WINDOW.document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    var triggerDOMHandler = (0, _handlersJs.triggerHandlers).bind(null, 'dom');
    var globalDOMEventHandler = makeDOMEventHandler(triggerDOMHandler, true);
    WINDOW.document.addEventListener('click', globalDOMEventHandler, false);
    WINDOW.document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        'EventTarget',
        'Node'
    ].forEach(function(target) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        var proto = WINDOW[target] && WINDOW[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
        (0, _objectJs.fill)(proto, 'addEventListener', function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    var el = this;
                    var handlers = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    var handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        var handler = makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, _objectJs.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    var el = this;
                    var handlers = el.__sentry_instrumentation_handlers__ || {};
                    var handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== lastCapturedEventTargetId) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== 'keypress') return false;
    if (!target || !target.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function makeDOMEventHandler(handler) {
    var globalListener = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return function(event) {
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event['_sentryCaptured']) return;
        var target = getEventTarget(event);
        // We always want to skip _some_ events.
        if (shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, _objectJs.addNonEnumerableProperty)(event, '_sentryCaptured', true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, _objectJs.addNonEnumerableProperty)(target, '_sentryId', (0, _miscJs.uuid4)());
        var name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!isSimilarToLastCapturedEvent(event)) {
            var handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            lastCapturedEventType = event.type;
            lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout(debounceTimerID);
        debounceTimerID = WINDOW.setTimeout(function() {
            lastCapturedEventTargetId = undefined;
            lastCapturedEventType = undefined;
        }, DEBOUNCE_DURATION);
    };
}
function getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}

},{"../misc.js":"fyY3i","../object.js":"auET5","../worldwide.js":"aZo8o","./_handlers.js":"4eGNw","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"fyY3i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addContextToFrame", function() {
    return addContextToFrame;
});
parcelHelpers.export(exports, "addExceptionMechanism", function() {
    return addExceptionMechanism;
});
parcelHelpers.export(exports, "addExceptionTypeValue", function() {
    return addExceptionTypeValue;
});
parcelHelpers.export(exports, "arrayify", function() {
    return arrayify;
});
parcelHelpers.export(exports, "checkOrSetAlreadyCaught", function() {
    return checkOrSetAlreadyCaught;
});
parcelHelpers.export(exports, "getEventDescription", function() {
    return getEventDescription;
});
parcelHelpers.export(exports, "parseSemver", function() {
    return parseSemver;
});
parcelHelpers.export(exports, "uuid4", function() {
    return uuid4;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectJs = require("./object.js");
var _stringJs = require("./string.js");
var _worldwideJs = require("./worldwide.js");
/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function uuid4() {
    var gbl = (0, _worldwideJs.GLOBAL_OBJ);
    var crypto = gbl.crypto || gbl.msCrypto;
    var getRandomByte = function() {
        return Math.random() * 16;
    };
    try {
        if (crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, '');
        if (crypto && crypto.getRandomValues) getRandomByte = function() {
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            var typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, function(c) {
        return(// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
    });
}
function getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function getEventDescription(event) {
    var message = event.message, eventId = event.event_id;
    if (message) return message;
    var firstException = getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function addExceptionTypeValue(event, value, type) {
    var exception = event.exception = event.exception || {};
    var values = exception.values = exception.values || [];
    var firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function addExceptionMechanism(event, newMechanism) {
    var firstException = getFirstException(event);
    if (!firstException) return;
    var defaultMechanism = {
        type: 'generic',
        handled: true
    };
    var currentMechanism = firstException.mechanism;
    firstException.mechanism = (0, _objectSpread._)({}, defaultMechanism, currentMechanism, newMechanism);
    if (newMechanism && 'data' in newMechanism) {
        var mergedData = (0, _objectSpread._)({}, currentMechanism && currentMechanism.data, newMechanism.data);
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
var SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ /**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function parseSemver(input) {
    var match = input.match(SEMVER_REGEXP) || [];
    var major = parseInt(match[1], 10);
    var minor = parseInt(match[2], 10);
    var patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function addContextToFrame(lines, frame) {
    var linesOfContext = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 5;
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    var maxLines = lines.length;
    var sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map(function(line) {
        return (0, _stringJs.snipLine)(line, 0);
    });
    frame.context_line = (0, _stringJs.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map(function(line) {
        return (0, _stringJs.snipLine)(line, 0);
    });
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function checkOrSetAlreadyCaught(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, _objectJs.addNonEnumerableProperty)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */ function arrayify(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}

},{"@swc/helpers/_/_object_spread":"4bEWH","./object.js":"auET5","./string.js":"ily1y","./worldwide.js":"aZo8o","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"fJi32":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addFetchInstrumentationHandler", function() {
    return addFetchInstrumentationHandler;
});
parcelHelpers.export(exports, "parseFetchArgs", function() {
    return parseFetchArgs;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _objectJs = require("../object.js");
var _supportsJs = require("../supports.js");
var _worldwideJs = require("../worldwide.js");
var _handlersJs = require("./_handlers.js");
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function addFetchInstrumentationHandler(handler) {
    var type = 'fetch';
    (0, _handlersJs.addHandler)(type, handler);
    (0, _handlersJs.maybeInstrument)(type, instrumentFetch);
}
function instrumentFetch() {
    if (!(0, _supportsJs.supportsNativeFetch)()) return;
    (0, _objectJs.fill)((0, _worldwideJs.GLOBAL_OBJ), 'fetch', function(originalFetch) {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var _parseFetchArgs = parseFetchArgs(args), method = _parseFetchArgs.method, url = _parseFetchArgs.url;
            var handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: Date.now()
            };
            (0, _handlersJs.triggerHandlers)('fetch', (0, _objectSpread._)({}, handlerData));
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, _worldwideJs.GLOBAL_OBJ), args).then(function(response) {
                var finishedHandlerData = (0, _objectSpreadProps._)((0, _objectSpread._)({}, handlerData), {
                    endTimestamp: Date.now(),
                    response: response
                });
                (0, _handlersJs.triggerHandlers)('fetch', finishedHandlerData);
                return response;
            }, function(error) {
                var erroredHandlerData = (0, _objectSpreadProps._)((0, _objectSpread._)({}, handlerData), {
                    endTimestamp: Date.now(),
                    error: error
                });
                (0, _handlersJs.triggerHandlers)('fetch', erroredHandlerData);
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
function hasProp(obj, prop) {
    return !!obj && typeof obj === 'object' && !!obj[prop];
}
function getUrlFromResource(resource) {
    if (typeof resource === 'string') return resource;
    if (!resource) return '';
    if (hasProp(resource, 'url')) return resource.url;
    if (resource.toString) return resource.toString();
    return '';
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function parseFetchArgs(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: 'GET',
        url: ''
    };
    if (fetchArgs.length === 2) {
        var _fetchArgs = (0, _slicedToArray._)(fetchArgs, 2), url = _fetchArgs[0], options = _fetchArgs[1];
        return {
            url: getUrlFromResource(url),
            method: hasProp(options, 'method') ? String(options.method).toUpperCase() : 'GET'
        };
    }
    var arg = fetchArgs[0];
    return {
        url: getUrlFromResource(arg),
        method: hasProp(arg, 'method') ? String(arg.method).toUpperCase() : 'GET'
    };
}

},{"@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_object_spread_props":"fLCYP","@swc/helpers/_/_sliced_to_array":"ha6sq","../object.js":"auET5","../supports.js":"iobKj","../worldwide.js":"aZo8o","./_handlers.js":"4eGNw","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"iobKj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isNativeFetch", function() {
    return isNativeFetch;
});
parcelHelpers.export(exports, "supportsDOMError", function() {
    return supportsDOMError;
});
parcelHelpers.export(exports, "supportsDOMException", function() {
    return supportsDOMException;
});
parcelHelpers.export(exports, "supportsErrorEvent", function() {
    return supportsErrorEvent;
});
parcelHelpers.export(exports, "supportsFetch", function() {
    return supportsFetch;
});
parcelHelpers.export(exports, "supportsNativeFetch", function() {
    return supportsNativeFetch;
});
parcelHelpers.export(exports, "supportsReferrerPolicy", function() {
    return supportsReferrerPolicy;
});
parcelHelpers.export(exports, "supportsReportingObserver", function() {
    return supportsReportingObserver;
});
var _debugBuildJs = require("./debug-build.js");
var _loggerJs = require("./logger.js");
var _worldwideJs = require("./worldwide.js");
// eslint-disable-next-line deprecation/deprecation
var WINDOW = (0, _worldwideJs.getGlobalObject)();
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function supportsErrorEvent() {
    try {
        new ErrorEvent('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function supportsDOMError() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function supportsDOMException() {
    try {
        new DOMException('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function supportsFetch() {
    if (!('fetch' in WINDOW)) return false;
    try {
        new Headers();
        new Request('http://www.example.com');
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function isNativeFetch(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function supportsNativeFetch() {
    if (typeof EdgeRuntime === 'string') return true;
    if (!supportsFetch()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if (isNativeFetch(WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    var result = false;
    var doc = WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        var sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = isNativeFetch(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _loggerJs.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function supportsReportingObserver() {
    return 'ReportingObserver' in WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function supportsReferrerPolicy() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!supportsFetch()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch (e) {
        return false;
    }
}

},{"./debug-build.js":"2NN5Y","./logger.js":"it07k","./worldwide.js":"aZo8o","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"ezS5O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addGlobalErrorInstrumentationHandler", function() {
    return addGlobalErrorInstrumentationHandler;
});
var _worldwideJs = require("../worldwide.js");
var _handlersJs = require("./_handlers.js");
var _oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function addGlobalErrorInstrumentationHandler(handler) {
    var type = 'error';
    (0, _handlersJs.addHandler)(type, handler);
    (0, _handlersJs.maybeInstrument)(type, instrumentError);
}
function instrumentError() {
    _oldOnErrorHandler = (0, _worldwideJs.GLOBAL_OBJ).onerror;
    (0, _worldwideJs.GLOBAL_OBJ).onerror = function(msg, url, line, column, error) {
        var handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, _handlersJs.triggerHandlers)('error', handlerData);
        if (_oldOnErrorHandler && !_oldOnErrorHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return _oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, _worldwideJs.GLOBAL_OBJ).onerror.__SENTRY_INSTRUMENTED__ = true;
}

},{"../worldwide.js":"aZo8o","./_handlers.js":"4eGNw","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"eNVB1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addGlobalUnhandledRejectionInstrumentationHandler", function() {
    return addGlobalUnhandledRejectionInstrumentationHandler;
});
var _worldwideJs = require("../worldwide.js");
var _handlersJs = require("./_handlers.js");
var _oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function addGlobalUnhandledRejectionInstrumentationHandler(handler) {
    var type = 'unhandledrejection';
    (0, _handlersJs.addHandler)(type, handler);
    (0, _handlersJs.maybeInstrument)(type, instrumentUnhandledRejection);
}
function instrumentUnhandledRejection() {
    _oldOnUnhandledRejectionHandler = (0, _worldwideJs.GLOBAL_OBJ).onunhandledrejection;
    (0, _worldwideJs.GLOBAL_OBJ).onunhandledrejection = function(e) {
        var handlerData = e;
        (0, _handlersJs.triggerHandlers)('unhandledrejection', handlerData);
        if (_oldOnUnhandledRejectionHandler && !_oldOnUnhandledRejectionHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return _oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, _worldwideJs.GLOBAL_OBJ).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}

},{"../worldwide.js":"aZo8o","./_handlers.js":"4eGNw","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"iTKnL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addHistoryInstrumentationHandler", function() {
    return addHistoryInstrumentationHandler;
});
var _objectJs = require("../object.js");
var _debugBuildJs = require("../debug-build.js");
var _loggerJs = require("../logger.js");
var _worldwideJs = require("../worldwide.js");
var _supportsHistoryJs = require("../vendor/supportsHistory.js");
var _handlersJs = require("./_handlers.js");
var WINDOW = (0, _worldwideJs.GLOBAL_OBJ);
var lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function addHistoryInstrumentationHandler(handler) {
    var type = 'history';
    (0, _handlersJs.addHandler)(type, handler);
    (0, _handlersJs.maybeInstrument)(type, instrumentHistory);
}
function instrumentHistory() {
    if (!(0, _supportsHistoryJs.supportsHistory)()) return;
    var oldOnPopState = WINDOW.onpopstate;
    WINDOW.onpopstate = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var to = WINDOW.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        var from = lastHref;
        lastHref = to;
        var handlerData = {
            from: from,
            to: to
        };
        (0, _handlersJs.triggerHandlers)('history', handlerData);
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    function historyReplacementFunction(originalHistoryFunction) {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                var from = lastHref;
                var to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                lastHref = to;
                var handlerData = {
                    from: from,
                    to: to
                };
                (0, _handlersJs.triggerHandlers)('history', handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, _objectJs.fill)(WINDOW.history, 'pushState', historyReplacementFunction);
    (0, _objectJs.fill)(WINDOW.history, 'replaceState', historyReplacementFunction);
}

},{"../object.js":"auET5","../debug-build.js":"2NN5Y","../logger.js":"it07k","../worldwide.js":"aZo8o","../vendor/supportsHistory.js":"kMW0Q","./_handlers.js":"4eGNw","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"kMW0Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "supportsHistory", function() {
    return supportsHistory;
});
var _worldwideJs = require("../worldwide.js");
// Based on https://github.com/angular/angular.js/pull/13945/files
// eslint-disable-next-line deprecation/deprecation
var WINDOW = (0, _worldwideJs.getGlobalObject)();
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function supportsHistory() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var chromeVar = WINDOW.chrome;
    var isChromePackagedApp = chromeVar && chromeVar.app && chromeVar.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ var hasHistoryApi = 'history' in WINDOW && !!WINDOW.history.pushState && !!WINDOW.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}

},{"../worldwide.js":"aZo8o","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jff0W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SENTRY_XHR_DATA_KEY", function() {
    return SENTRY_XHR_DATA_KEY;
});
parcelHelpers.export(exports, "addXhrInstrumentationHandler", function() {
    return addXhrInstrumentationHandler;
});
parcelHelpers.export(exports, "instrumentXHR", function() {
    return instrumentXHR;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _isJs = require("../is.js");
var _objectJs = require("../object.js");
var _worldwideJs = require("../worldwide.js");
var _handlersJs = require("./_handlers.js");
var WINDOW = (0, _worldwideJs.GLOBAL_OBJ);
var SENTRY_XHR_DATA_KEY = '__sentry_xhr_v3__';
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function addXhrInstrumentationHandler(handler) {
    var type = 'xhr';
    (0, _handlersJs.addHandler)(type, handler);
    (0, _handlersJs.maybeInstrument)(type, instrumentXHR);
}
/** Exported only for tests. */ function instrumentXHR() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (!WINDOW.XMLHttpRequest) return;
    var xhrproto = XMLHttpRequest.prototype;
    (0, _objectJs.fill)(xhrproto, 'open', function(originalOpen) {
        return function() {
            var _this = this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var startTimestamp = Date.now();
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            var method = (0, _isJs.isString)(args[0]) ? args[0].toUpperCase() : undefined;
            var url = parseUrl(args[1]);
            if (!method || !url) return originalOpen.apply(this, args);
            this[SENTRY_XHR_DATA_KEY] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === 'POST' && url.match(/sentry_key/)) this.__sentry_own_request__ = true;
            var onreadystatechangeHandler = function() {
                // For whatever reason, this is not the same instance here as from the outer method
                var xhrInfo = _this[SENTRY_XHR_DATA_KEY];
                if (!xhrInfo) return;
                if (_this.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = _this.status;
                    } catch (e) {
                    /* do nothing */ }
                    var handlerData = {
                        args: [
                            method,
                            url
                        ],
                        endTimestamp: Date.now(),
                        startTimestamp: startTimestamp,
                        xhr: _this
                    };
                    (0, _handlersJs.triggerHandlers)('xhr', handlerData);
                }
            };
            if ('onreadystatechange' in this && typeof this.onreadystatechange === 'function') (0, _objectJs.fill)(this, 'onreadystatechange', function(original) {
                return function() {
                    for(var _len = arguments.length, readyStateArgs = new Array(_len), _key = 0; _key < _len; _key++){
                        readyStateArgs[_key] = arguments[_key];
                    }
                    onreadystatechangeHandler();
                    return original.apply(this, readyStateArgs);
                };
            });
            else this.addEventListener('readystatechange', onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            (0, _objectJs.fill)(this, 'setRequestHeader', function(original) {
                return function() {
                    for(var _len = arguments.length, setRequestHeaderArgs = new Array(_len), _key = 0; _key < _len; _key++){
                        setRequestHeaderArgs[_key] = arguments[_key];
                    }
                    var _setRequestHeaderArgs = (0, _slicedToArray._)(setRequestHeaderArgs, 2), header = _setRequestHeaderArgs[0], value = _setRequestHeaderArgs[1];
                    var xhrInfo = this[SENTRY_XHR_DATA_KEY];
                    if (xhrInfo && (0, _isJs.isString)(header) && (0, _isJs.isString)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return original.apply(this, setRequestHeaderArgs);
                };
            });
            return originalOpen.apply(this, args);
        };
    });
    (0, _objectJs.fill)(xhrproto, 'send', function(originalSend) {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var sentryXhrData = this[SENTRY_XHR_DATA_KEY];
            if (!sentryXhrData) return originalSend.apply(this, args);
            if (args[0] !== undefined) sentryXhrData.body = args[0];
            var handlerData = {
                args: [
                    sentryXhrData.method,
                    sentryXhrData.url
                ],
                startTimestamp: Date.now(),
                xhr: this
            };
            (0, _handlersJs.triggerHandlers)('xhr', handlerData);
            return originalSend.apply(this, args);
        };
    });
}
function parseUrl(url) {
    if ((0, _isJs.isString)(url)) return url;
    try {
        // url can be a string or URL
        // but since URL is not available in IE11, we do not check for it,
        // but simply assume it is an URL and return `toString()` from it (which returns the full URL)
        // If that fails, we just return undefined
        return url.toString();
    } catch (e2) {} // eslint-disable-line no-empty
    return undefined;
}

},{"@swc/helpers/_/_sliced_to_array":"ha6sq","../is.js":"7y7Yx","../object.js":"auET5","../worldwide.js":"aZo8o","./_handlers.js":"4eGNw","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4jmSN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isBrowser", function() {
    return isBrowser;
});
var _nodeJs = require("./node.js");
var _worldwideJs = require("./worldwide.js");
/**
 * Returns true if we are in the browser.
 */ function isBrowser() {
    // eslint-disable-next-line no-restricted-globals
    return typeof window !== 'undefined' && (!(0, _nodeJs.isNodeEnv)() || isElectronNodeRenderer());
}
// Electron renderers with nodeIntegration enabled are detected as Node.js so we specifically test for them
function isElectronNodeRenderer() {
    return(// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
    (0, _worldwideJs.GLOBAL_OBJ).process !== undefined && (0, _worldwideJs.GLOBAL_OBJ).process.type === 'renderer');
}

},{"./node.js":"kyjyZ","./worldwide.js":"aZo8o","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"kyjyZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dynamicRequire", function() {
    return dynamicRequire;
});
parcelHelpers.export(exports, "isNodeEnv", function() {
    return isNodeEnv;
});
parcelHelpers.export(exports, "loadModule", function() {
    return loadModule;
});
var _envJs = require("./env.js");
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ /**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */ function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, _envJs.isBrowserBundle)() && Object.prototype.toString.call(0) === '[object process]';
}
/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @returns possibly required module
 */ function loadModule(moduleName) {
    var mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        var cwd = dynamicRequire(module, 'process').cwd;
        mod = dynamicRequire(module, `${cwd()}/node_modules/${moduleName}`);
    } catch (e) {
    // no-empty
    }
    return mod;
}

},{"./env.js":"boGOz","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"boGOz":[function(require,module,exports,__globalThis) {
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSDKSource", function() {
    return getSDKSource;
});
parcelHelpers.export(exports, "isBrowserBundle", function() {
    return isBrowserBundle;
});
function isBrowserBundle() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function getSDKSource() {
    // @ts-expect-error "npm" is injected by rollup during build process
    return "npm";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"37i7z":[function(require,module,exports,__globalThis) {
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "memoBuilder", function() {
    return memoBuilder;
});
function memoBuilder() {
    var hasWeakSet = typeof WeakSet === 'function';
    var inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(var i = 0; i < inner.length; i++){
            var value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(var i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"b1fOd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "normalize", function() {
    return normalize;
});
parcelHelpers.export(exports, "normalizeToSize", function() {
    return normalizeToSize;
});
parcelHelpers.export(exports, "normalizeUrlToBase", function() {
    return normalizeUrlToBase;
});
parcelHelpers.export(exports, "walk", function() {
    return visit;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _isJs = require("./is.js");
var _memoJs = require("./memo.js");
var _objectJs = require("./object.js");
var _stacktraceJs = require("./stacktrace.js");
var global = arguments[3];
/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function normalize(input) {
    var depth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 100, maxProperties = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Infinity;
    try {
        // since we're at the outermost level, we don't provide a key
        return visit('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function normalizeToSize(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object) {
    var // Default Node.js REPL depth
    depth = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
    maxSize = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 102400;
    var normalized = normalize(object, depth);
    if (jsonSize(normalized) > maxSize) return normalizeToSize(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function visit(key, value) {
    var depth = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Infinity, maxProperties = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Infinity, memo = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : (0, _memoJs.memoBuilder)();
    var _memo = (0, _slicedToArray._)(memo, 2), memoize = _memo[0], unmemoize = _memo[1];
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        'number',
        'boolean',
        'string'
    ].includes(typeof value) && !(0, _isJs.isNaN)(value)) return value;
    var stringified = stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value['__sentry_skip_normalization__']) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    var remainingDepth = typeof value['__sentry_override_normalization_depth__'] === 'number' ? value['__sentry_override_normalization_depth__'] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // If the value has a `toJSON` method, we call it to extract more information
    var valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        var jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return visit('', jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    var normalized = Array.isArray(value) ? [] : {};
    var numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    var visitable = (0, _objectJs.convertToPlainObject)(value);
    for(var visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        var visitValue = visitable[visitKey];
        normalized[visitKey] = visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof global !== 'undefined' && value === global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        if ((0, _isJs.isVueViewModel)(value)) return '[VueViewModel]';
        // React's SyntheticEvent thingy
        if ((0, _isJs.isSyntheticEvent)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && value !== value) return '[NaN]';
        if (typeof value === 'function') return `[Function: ${(0, _stacktraceJs.getFunctionName)(value)}]`;
        if (typeof value === 'symbol') return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        var objName = getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function getConstructorName(value) {
    var prototype = Object.getPrototypeOf(value);
    return prototype ? prototype.constructor.name : 'null prototype';
}
/** Calculates bytes size of input string */ function utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function jsonSize(value) {
    return utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function normalizeUrlToBase(url, basePath) {
    var escapedBase = basePath// Backslash to forward
    .replace(/\\/g, '/')// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
    var newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, '/').replace(/webpack:\/?/g, '') // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, 'ig'), 'app:///');
}

},{"@swc/helpers/_/_sliced_to_array":"ha6sq","./is.js":"7y7Yx","./memo.js":"37i7z","./object.js":"auET5","./stacktrace.js":"9vw3J","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"eRzHf":[function(require,module,exports,__globalThis) {
// Slightly modified (no IE8 support, ES6) and transcribed to TypeScript
// https://github.com/calvinmetcalf/rollup-plugin-node-builtins/blob/63ab8aacd013767445ca299e468d9a60a95328d7/src/es6/path.js
//
// Copyright Joyent, Inc.and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
/** JSDoc */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "basename", function() {
    return basename;
});
parcelHelpers.export(exports, "dirname", function() {
    return dirname;
});
parcelHelpers.export(exports, "isAbsolute", function() {
    return isAbsolute;
});
parcelHelpers.export(exports, "join", function() {
    return join;
});
parcelHelpers.export(exports, "normalizePath", function() {
    return normalizePath;
});
parcelHelpers.export(exports, "relative", function() {
    return relative;
});
parcelHelpers.export(exports, "resolve", function() {
    return resolve;
});
function normalizeArray(parts, allowAboveRoot) {
    // if the path tries to go above the root, `up` ends up > 0
    var up = 0;
    for(var i = parts.length - 1; i >= 0; i--){
        var last = parts[i];
        if (last === '.') parts.splice(i, 1);
        else if (last === '..') {
            parts.splice(i, 1);
            up++;
        } else if (up) {
            parts.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (allowAboveRoot) for(; up--; up)parts.unshift('..');
    return parts;
}
// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
var splitPathRe = /^(\S+:\\|\/?)([\s\S]*?)((?:\.{1,2}|[^/\\]+?|)(\.[^./\\]*|))(?:[/\\]*)$/;
/** JSDoc */ function splitPath(filename) {
    // Truncate files names greater than 1024 characters to avoid regex dos
    // https://github.com/getsentry/sentry-javascript/pull/8737#discussion_r1285719172
    var truncated = filename.length > 1024 ? `<truncated>${filename.slice(-1024)}` : filename;
    var parts = splitPathRe.exec(truncated);
    return parts ? parts.slice(1) : [];
}
// path.resolve([from ...], to)
// posix version
/** JSDoc */ function resolve() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var resolvedPath = '';
    var resolvedAbsolute = false;
    for(var i = args.length - 1; i >= -1 && !resolvedAbsolute; i--){
        var path = i >= 0 ? args[i] : '/';
        // Skip empty entries
        if (!path) continue;
        resolvedPath = `${path}/${resolvedPath}`;
        resolvedAbsolute = path.charAt(0) === '/';
    }
    // At this point the path should be resolved to a full absolute path, but
    // handle relative paths to be safe (might happen when process.cwd() fails)
    // Normalize the path
    resolvedPath = normalizeArray(resolvedPath.split('/').filter(function(p) {
        return !!p;
    }), !resolvedAbsolute).join('/');
    return (resolvedAbsolute ? '/' : '') + resolvedPath || '.';
}
/** JSDoc */ function trim(arr) {
    var start = 0;
    for(; start < arr.length; start++){
        if (arr[start] !== '') break;
    }
    var end = arr.length - 1;
    for(; end >= 0; end--){
        if (arr[end] !== '') break;
    }
    if (start > end) return [];
    return arr.slice(start, end - start + 1);
}
// path.relative(from, to)
// posix version
/** JSDoc */ function relative(from, to) {
    /* eslint-disable no-param-reassign */ from = resolve(from).slice(1);
    to = resolve(to).slice(1);
    /* eslint-enable no-param-reassign */ var fromParts = trim(from.split('/'));
    var toParts = trim(to.split('/'));
    var length = Math.min(fromParts.length, toParts.length);
    var samePartsLength = length;
    for(var i = 0; i < length; i++)if (fromParts[i] !== toParts[i]) {
        samePartsLength = i;
        break;
    }
    var outputParts = [];
    for(var i1 = samePartsLength; i1 < fromParts.length; i1++)outputParts.push('..');
    outputParts = outputParts.concat(toParts.slice(samePartsLength));
    return outputParts.join('/');
}
// path.normalize(path)
// posix version
/** JSDoc */ function normalizePath(path) {
    var isPathAbsolute = isAbsolute(path);
    var trailingSlash = path.slice(-1) === '/';
    // Normalize the path
    var normalizedPath = normalizeArray(path.split('/').filter(function(p) {
        return !!p;
    }), !isPathAbsolute).join('/');
    if (!normalizedPath && !isPathAbsolute) normalizedPath = '.';
    if (normalizedPath && trailingSlash) normalizedPath += '/';
    return (isPathAbsolute ? '/' : '') + normalizedPath;
}
// posix version
/** JSDoc */ function isAbsolute(path) {
    return path.charAt(0) === '/';
}
// posix version
/** JSDoc */ function join() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return normalizePath(args.join('/'));
}
/** JSDoc */ function dirname(path) {
    var result = splitPath(path);
    var root = result[0];
    var dir = result[1];
    if (!root && !dir) // No dirname whatsoever
    return '.';
    if (dir) // It has a dirname, strip trailing slash
    dir = dir.slice(0, dir.length - 1);
    return root + dir;
}
/** JSDoc */ function basename(path, ext) {
    var f = splitPath(path)[2];
    if (ext && f.slice(ext.length * -1) === ext) f = f.slice(0, f.length - ext.length);
    return f;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"55UvO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "makePromiseBuffer", function() {
    return makePromiseBuffer;
});
var _errorJs = require("./error.js");
var _syncpromiseJs = require("./syncpromise.js");
/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function makePromiseBuffer(limit) {
    var buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, _syncpromiseJs.rejectedSyncPromise)(new (0, _errorJs.SentryError)('Not adding Promise because buffer limit was reached.'));
        // start the task and add its promise to the queue
        var task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(function() {
            return remove(task);
        })// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, function() {
            return remove(task).then(null, function() {
            // We have to add another catch here because `remove()` starts a new promise chain.
            });
        });
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, _syncpromiseJs.SyncPromise)(function(resolve, reject) {
            var counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            var capturedSetTimeout = setTimeout(function() {
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach(function(item) {
                (0, _syncpromiseJs.resolvedSyncPromise)(item).then(function() {
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}

},{"./error.js":"6fvda","./syncpromise.js":"eZXt9","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"eZXt9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SyncPromise", function() {
    return SyncPromise;
});
parcelHelpers.export(exports, "rejectedSyncPromise", function() {
    return rejectedSyncPromise;
});
parcelHelpers.export(exports, "resolvedSyncPromise", function() {
    return resolvedSyncPromise;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _isJs = require("./is.js");
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /** SyncPromise internal states */ var States;
(function(States) {
    /** Pending */ var PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ var RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ var REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})(States || (States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function resolvedSyncPromise(value) {
    return new SyncPromise(function(resolve) {
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function rejectedSyncPromise(reason) {
    return new SyncPromise(function(_, reject) {
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ var SyncPromise = /*#__PURE__*/ function() {
    "use strict";
    function SyncPromise(executor) {
        (0, _classCallCheck._)(this, SyncPromise);
        SyncPromise.prototype.__init.call(this);
        SyncPromise.prototype.__init2.call(this);
        SyncPromise.prototype.__init3.call(this);
        SyncPromise.prototype.__init4.call(this);
        this._state = States.PENDING;
        this._handlers = [];
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    (0, _createClass._)(SyncPromise, [
        {
            /** JSDoc */ key: "then",
            value: function then(onfulfilled, onrejected) {
                var _this = this;
                return new SyncPromise(function(resolve, reject) {
                    _this._handlers.push([
                        false,
                        function(result) {
                            if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                            // TODO: FIXME
                            resolve(result);
                            else try {
                                resolve(onfulfilled(result));
                            } catch (e) {
                                reject(e);
                            }
                        },
                        function(reason) {
                            if (!onrejected) reject(reason);
                            else try {
                                resolve(onrejected(reason));
                            } catch (e) {
                                reject(e);
                            }
                        }
                    ]);
                    _this._executeHandlers();
                });
            }
        },
        {
            /** JSDoc */ key: "catch",
            value: function _catch(onrejected) {
                return this.then(function(val) {
                    return val;
                }, onrejected);
            }
        },
        {
            /** JSDoc */ key: "finally",
            value: function _finally(onfinally) {
                var _this = this;
                return new SyncPromise(function(resolve, reject) {
                    var val;
                    var isRejected;
                    return _this.then(function(value) {
                        isRejected = false;
                        val = value;
                        if (onfinally) onfinally();
                    }, function(reason) {
                        isRejected = true;
                        val = reason;
                        if (onfinally) onfinally();
                    }).then(function() {
                        if (isRejected) {
                            reject(val);
                            return;
                        }
                        resolve(val);
                    });
                });
            }
        },
        {
            /** JSDoc */ key: "__init",
            value: function __init() {
                var _this = this;
                this._resolve = function(value) {
                    _this._setResult(States.RESOLVED, value);
                };
            }
        },
        {
            /** JSDoc */ key: "__init2",
            value: function __init2() {
                var _this = this;
                this._reject = function(reason) {
                    _this._setResult(States.REJECTED, reason);
                };
            }
        },
        {
            /** JSDoc */ key: "__init3",
            value: function __init3() {
                var _this = this;
                this._setResult = function(state, value) {
                    if (_this._state !== States.PENDING) return;
                    if ((0, _isJs.isThenable)(value)) {
                        value.then(_this._resolve, _this._reject);
                        return;
                    }
                    _this._state = state;
                    _this._value = value;
                    _this._executeHandlers();
                };
            }
        },
        {
            /** JSDoc */ key: "__init4",
            value: function __init4() {
                var _this = this;
                this._executeHandlers = function() {
                    if (_this._state === States.PENDING) return;
                    var cachedHandlers = _this._handlers.slice();
                    _this._handlers = [];
                    cachedHandlers.forEach(function(handler) {
                        if (handler[0]) return;
                        if (_this._state === States.RESOLVED) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                        handler[1](_this._value);
                        if (_this._state === States.REJECTED) handler[2](_this._value);
                        handler[0] = true;
                    });
                };
            }
        }
    ]);
    return SyncPromise;
}();

},{"@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","./is.js":"7y7Yx","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"lJcCU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_USER_INCLUDES", function() {
    return DEFAULT_USER_INCLUDES;
});
parcelHelpers.export(exports, "addRequestDataToEvent", function() {
    return addRequestDataToEvent;
});
parcelHelpers.export(exports, "addRequestDataToTransaction", function() {
    return addRequestDataToTransaction;
});
parcelHelpers.export(exports, "extractPathForTransaction", function() {
    return extractPathForTransaction;
});
parcelHelpers.export(exports, "extractRequestData", function() {
    return extractRequestData;
});
parcelHelpers.export(exports, "winterCGHeadersToDict", function() {
    return winterCGHeadersToDict;
});
parcelHelpers.export(exports, "winterCGRequestToRequestData", function() {
    return winterCGRequestToRequestData;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _cookieJs = require("./cookie.js");
var _debugBuildJs = require("./debug-build.js");
var _isJs = require("./is.js");
var _loggerJs = require("./logger.js");
var _normalizeJs = require("./normalize.js");
var _urlJs = require("./url.js");
var DEFAULT_INCLUDES = {
    ip: false,
    request: true,
    transaction: true,
    user: true
};
var DEFAULT_REQUEST_INCLUDES = [
    'cookies',
    'data',
    'headers',
    'method',
    'query_string',
    'url'
];
var DEFAULT_USER_INCLUDES = [
    'id',
    'username',
    'email'
];
/**
 * Sets parameterized route as transaction name e.g.: `GET /users/:id`
 * Also adds more context data on the transaction from the request.
 *
 * @deprecated This utility will be removed in v8.
 */ function addRequestDataToTransaction(transaction, req, deps) {
    if (!transaction) return;
    // eslint-disable-next-line deprecation/deprecation
    if (!transaction.metadata.source || transaction.metadata.source === 'url') {
        // Attempt to grab a parameterized route off of the request
        var _extractPathForTransaction = (0, _slicedToArray._)(extractPathForTransaction(req, {
            path: true,
            method: true
        }), 2), name = _extractPathForTransaction[0], source = _extractPathForTransaction[1];
        transaction.updateName(name);
        // TODO: SEMANTIC_ATTRIBUTE_SENTRY_SOURCE is in core, align this once we merge utils & core
        // eslint-disable-next-line deprecation/deprecation
        transaction.setMetadata({
            source: source
        });
    }
    transaction.setAttribute('url', req.originalUrl || req.url);
    if (req.baseUrl) transaction.setAttribute('baseUrl', req.baseUrl);
    // TODO: We need to rewrite this to a flat format?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setData('query', extractQueryParams(req, deps));
}
/**
 * Extracts a complete and parameterized path from the request object and uses it to construct transaction name.
 * If the parameterized transaction name cannot be extracted, we fall back to the raw URL.
 *
 * Additionally, this function determines and returns the transaction name source
 *
 * eg. GET /mountpoint/user/:id
 *
 * @param req A request object
 * @param options What to include in the transaction name (method, path, or a custom route name to be
 *                used instead of the request's route)
 *
 * @returns A tuple of the fully constructed transaction name [0] and its source [1] (can be either 'route' or 'url')
 */ function extractPathForTransaction(req) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var method = req.method && req.method.toUpperCase();
    var path = '';
    var source = 'url';
    // Check to see if there's a parameterized route we can use (as there is in Express)
    if (options.customRoute || req.route) {
        path = options.customRoute || `${req.baseUrl || ''}${req.route && req.route.path}`;
        source = 'route';
    } else if (req.originalUrl || req.url) path = (0, _urlJs.stripUrlQueryAndFragment)(req.originalUrl || req.url || '');
    var name = '';
    if (options.method && method) name += method;
    if (options.method && options.path) name += ' ';
    if (options.path && path) name += path;
    return [
        name,
        source
    ];
}
/** JSDoc */ function extractTransaction(req, type) {
    switch(type){
        case 'path':
            return extractPathForTransaction(req, {
                path: true
            })[0];
        case 'handler':
            return req.route && req.route.stack && req.route.stack[0] && req.route.stack[0].name || '<anonymous>';
        case 'methodPath':
        default:
            {
                // if exist _reconstructedRoute return that path instead of route.path
                var customRoute = req._reconstructedRoute ? req._reconstructedRoute : undefined;
                return extractPathForTransaction(req, {
                    path: true,
                    method: true,
                    customRoute: customRoute
                })[0];
            }
    }
}
/** JSDoc */ function extractUserData(user, keys) {
    var extractedUser = {};
    var attributes = Array.isArray(keys) ? keys : DEFAULT_USER_INCLUDES;
    attributes.forEach(function(key) {
        if (user && key in user) extractedUser[key] = user[key];
    });
    return extractedUser;
}
/**
 * Normalize data from the request object, accounting for framework differences.
 *
 * @param req The request object from which to extract data
 * @param options.include An optional array of keys to include in the normalized data. Defaults to
 * DEFAULT_REQUEST_INCLUDES if not provided.
 * @param options.deps Injected, platform-specific dependencies
 * @returns An object containing normalized request data
 */ function extractRequestData(req, options) {
    var _ref = options || {}, _ref_include = _ref.include, include = _ref_include === void 0 ? DEFAULT_REQUEST_INCLUDES : _ref_include, deps = _ref.deps;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var requestData = {};
    // headers:
    //   node, express, koa, nextjs: req.headers
    var headers = req.headers || {};
    // method:
    //   node, express, koa, nextjs: req.method
    var method = req.method;
    // host:
    //   express: req.hostname in > 4 and req.host in < 4
    //   koa: req.host
    //   node, nextjs: req.headers.host
    // Express 4 mistakenly strips off port number from req.host / req.hostname so we can't rely on them
    // See: https://github.com/expressjs/express/issues/3047#issuecomment-236653223
    // Also: https://github.com/getsentry/sentry-javascript/issues/1917
    var host = headers.host || req.hostname || req.host || '<no host>';
    // protocol:
    //   node, nextjs: <n/a>
    //   express, koa: req.protocol
    var protocol = req.protocol === 'https' || req.socket && req.socket.encrypted ? 'https' : 'http';
    // url (including path and query string):
    //   node, express: req.originalUrl
    //   koa, nextjs: req.url
    var originalUrl = req.originalUrl || req.url || '';
    // absolute url
    var absoluteUrl = originalUrl.startsWith(protocol) ? originalUrl : `${protocol}://${host}${originalUrl}`;
    include.forEach(function(key) {
        switch(key){
            case 'headers':
                requestData.headers = headers;
                // Remove the Cookie header in case cookie data should not be included in the event
                if (!include.includes('cookies')) delete requestData.headers.cookie;
                break;
            case 'method':
                requestData.method = method;
                break;
            case 'url':
                requestData.url = absoluteUrl;
                break;
            case 'cookies':
                // cookies:
                //   node, express, koa: req.headers.cookie
                //   vercel, sails.js, express (w/ cookie middleware), nextjs: req.cookies
                requestData.cookies = // TODO (v8 / #5257): We're only sending the empty object for backwards compatibility, so the last bit can
                // come off in v8
                req.cookies || headers.cookie && (0, _cookieJs.parseCookie)(headers.cookie) || {};
                break;
            case 'query_string':
                // query string:
                //   node: req.url (raw)
                //   express, koa, nextjs: req.query
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                requestData.query_string = extractQueryParams(req, deps);
                break;
            case 'data':
                if (method === 'GET' || method === 'HEAD') break;
                // body data:
                //   express, koa, nextjs: req.body
                //
                //   when using node by itself, you have to read the incoming stream(see
                //   https://nodejs.dev/learn/get-http-request-body-data-using-nodejs); if a user is doing that, we can't know
                //   where they're going to store the final result, so they'll have to capture this data themselves
                if (req.body !== undefined) requestData.data = (0, _isJs.isString)(req.body) ? req.body : JSON.stringify((0, _normalizeJs.normalize)(req.body));
                break;
            default:
                if (({}).hasOwnProperty.call(req, key)) requestData[key] = req[key];
        }
    });
    return requestData;
}
/**
 * Add data from the given request to the given event
 *
 * @param event The event to which the request data will be added
 * @param req Request object
 * @param options.include Flags to control what data is included
 * @param options.deps Injected platform-specific dependencies
 * @returns The mutated `Event` object
 */ function addRequestDataToEvent(event, req, options) {
    var include = (0, _objectSpread._)({}, DEFAULT_INCLUDES, options && options.include);
    if (include.request) {
        var extractedRequestData = Array.isArray(include.request) ? extractRequestData(req, {
            include: include.request,
            deps: options && options.deps
        }) : extractRequestData(req, {
            deps: options && options.deps
        });
        event.request = (0, _objectSpread._)({}, event.request, extractedRequestData);
    }
    if (include.user) {
        var extractedUser = req.user && (0, _isJs.isPlainObject)(req.user) ? extractUserData(req.user, include.user) : {};
        if (Object.keys(extractedUser).length) event.user = (0, _objectSpread._)({}, event.user, extractedUser);
    }
    // client ip:
    //   node, nextjs: req.socket.remoteAddress
    //   express, koa: req.ip
    if (include.ip) {
        var ip = req.ip || req.socket && req.socket.remoteAddress;
        if (ip) event.user = (0, _objectSpreadProps._)((0, _objectSpread._)({}, event.user), {
            ip_address: ip
        });
    }
    if (include.transaction && !event.transaction) // TODO do we even need this anymore?
    // TODO make this work for nextjs
    event.transaction = extractTransaction(req, include.transaction);
    return event;
}
function extractQueryParams(req, deps) {
    // url (including path and query string):
    //   node, express: req.originalUrl
    //   koa, nextjs: req.url
    var originalUrl = req.originalUrl || req.url || '';
    if (!originalUrl) return;
    // The `URL` constructor can't handle internal URLs of the form `/some/path/here`, so stick a dummy protocol and
    // hostname on the beginning. Since the point here is just to grab the query string, it doesn't matter what we use.
    if (originalUrl.startsWith('/')) originalUrl = `http://dogs.are.great${originalUrl}`;
    try {
        return req.query || typeof URL !== 'undefined' && new URL(originalUrl).search.slice(1) || // In Node 8, `URL` isn't in the global scope, so we have to use the built-in module from Node
        deps && deps.url && deps.url.parse(originalUrl).query || undefined;
    } catch (e2) {
        return undefined;
    }
}
/**
 * Transforms a `Headers` object that implements the `Web Fetch API` (https://developer.mozilla.org/en-US/docs/Web/API/Headers) into a simple key-value dict.
 * The header keys will be lower case: e.g. A "Content-Type" header will be stored as "content-type".
 */ // TODO(v8): Make this function return undefined when the extraction fails.
function winterCGHeadersToDict(winterCGHeaders) {
    var headers = {};
    try {
        winterCGHeaders.forEach(function(value, key) {
            if (typeof value === 'string') // We check that value is a string even though it might be redundant to make sure prototype pollution is not possible.
            headers[key] = value;
        });
    } catch (e) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _loggerJs.logger).warn('Sentry failed extracting headers from a request object. If you see this, please file an issue.');
    }
    return headers;
}
/**
 * Converts a `Request` object that implements the `Web Fetch API` (https://developer.mozilla.org/en-US/docs/Web/API/Headers) into the format that the `RequestData` integration understands.
 */ function winterCGRequestToRequestData(req) {
    var headers = winterCGHeadersToDict(req.headers);
    return {
        method: req.method,
        url: req.url,
        headers: headers
    };
}

},{"@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_object_spread_props":"fLCYP","@swc/helpers/_/_sliced_to_array":"ha6sq","./cookie.js":"lcpyk","./debug-build.js":"2NN5Y","./is.js":"7y7Yx","./logger.js":"it07k","./normalize.js":"b1fOd","./url.js":"iIvME","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"lcpyk":[function(require,module,exports,__globalThis) {
/**
 * This code was originally copied from the 'cookie` module at v0.5.0 and was simplified for our use case.
 * https://github.com/jshttp/cookie/blob/a0c84147aab6266bdb3996cf4062e93907c0b0fc/index.js
 * It had the following license:
 *
 * (The MIT License)
 *
 * Copyright (c) 2012-2014 Roman Shtylman <shtylman@gmail.com>
 * Copyright (c) 2015 Douglas Christopher Wilson <doug@somethingdoug.com>
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * 'Software'), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ /**
 * Parses a cookie string
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseCookie", function() {
    return parseCookie;
});
function parseCookie(str) {
    var obj = {};
    var index = 0;
    while(index < str.length){
        var eqIdx = str.indexOf('=', index);
        // no more cookie pairs
        if (eqIdx === -1) break;
        var endIdx = str.indexOf(';', index);
        if (endIdx === -1) endIdx = str.length;
        else if (endIdx < eqIdx) {
            // backtrack on prior semicolon
            index = str.lastIndexOf(';', eqIdx - 1) + 1;
            continue;
        }
        var key = str.slice(index, eqIdx).trim();
        // only assign once
        if (undefined === obj[key]) {
            var val = str.slice(eqIdx + 1, endIdx).trim();
            // quoted values
            if (val.charCodeAt(0) === 0x22) val = val.slice(1, -1);
            try {
                obj[key] = val.indexOf('%') !== -1 ? decodeURIComponent(val) : val;
            } catch (e) {
                obj[key] = val;
            }
        }
        index = endIdx + 1;
    }
    return obj;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"iIvME":[function(require,module,exports,__globalThis) {
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getNumberOfUrlSegments", function() {
    return getNumberOfUrlSegments;
});
parcelHelpers.export(exports, "getSanitizedUrlString", function() {
    return getSanitizedUrlString;
});
parcelHelpers.export(exports, "parseUrl", function() {
    return parseUrl;
});
parcelHelpers.export(exports, "stripUrlQueryAndFragment", function() {
    return stripUrlQueryAndFragment;
});
function parseUrl(url) {
    if (!url) return {};
    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || '';
    var fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function stripUrlQueryAndFragment(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
/**
 * Returns number of URL segments of a passed string URL.
 */ function getNumberOfUrlSegments(url) {
    // split at '/' or at '\/' to split regex urls correctly
    return url.split(/\\?\//).filter(function(s) {
        return s.length > 0 && s !== ',';
    }).length;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span description
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function getSanitizedUrlString(url) {
    var protocol = url.protocol, host = url.host, path = url.path;
    var filteredHost = host && host// Always filter out authority
    .replace(/^.*@/, '[filtered]:[filtered]@')// Don't show standard :80 (http) and :443 (https) ports to reduce the noise
    // TODO: Use new URL global if it exists
    .replace(/(:80)$/, '').replace(/(:443)$/, '') || '';
    return `${protocol ? `${protocol}://` : ''}${filteredHost}${path}`;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"k8Uku":[function(require,module,exports,__globalThis) {
// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "severityFromString", function() {
    return severityFromString;
});
parcelHelpers.export(exports, "severityLevelFromString", function() {
    return severityLevelFromString;
});
parcelHelpers.export(exports, "validSeverityLevels", function() {
    return validSeverityLevels;
});
var validSeverityLevels = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug'
];
/**
 * Converts a string-based level into a member of the deprecated {@link Severity} enum.
 *
 * @deprecated `severityFromString` is deprecated. Please use `severityLevelFromString` instead.
 *
 * @param level String representation of Severity
 * @returns Severity
 */ function severityFromString(level) {
    return severityLevelFromString(level);
}
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function severityLevelFromString(level) {
    return level === 'warn' ? 'warning' : validSeverityLevels.includes(level) ? level : 'log';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5WKyq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_browserPerformanceTimeOriginMode", function() {
    return _browserPerformanceTimeOriginMode;
});
parcelHelpers.export(exports, "browserPerformanceTimeOrigin", function() {
    return browserPerformanceTimeOrigin;
});
parcelHelpers.export(exports, "dateTimestampInSeconds", function() {
    return dateTimestampInSeconds;
});
parcelHelpers.export(exports, "timestampInSeconds", function() {
    return timestampInSeconds;
});
parcelHelpers.export(exports, "timestampWithMs", function() {
    return timestampWithMs;
});
var _worldwideJs = require("./worldwide.js");
var ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 *
 * TODO(v8): Return type should be rounded.
 */ function dateTimestampInSeconds() {
    return Date.now() / ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function createUnixTimestampInSecondsFunc() {
    var performance = (0, _worldwideJs.GLOBAL_OBJ).performance;
    if (!performance || !performance.now) return dateTimestampInSeconds;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    var approxStartingTimeOrigin = Date.now() - performance.now();
    var timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return function() {
        return (timeOrigin + performance.now()) / ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ var timestampInSeconds = createUnixTimestampInSecondsFunc();
/**
 * Re-exported with an old name for backwards-compatibility.
 * TODO (v8): Remove this
 *
 * @deprecated Use `timestampInSeconds` instead.
 */ var timestampWithMs = timestampInSeconds;
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */ var _browserPerformanceTimeOriginMode;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ var browserPerformanceTimeOrigin = function() {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    var performance = (0, _worldwideJs.GLOBAL_OBJ).performance;
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = 'none';
        return undefined;
    }
    var threshold = 3600000;
    var performanceNow = performance.now();
    var dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    var timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    var timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    var navigationStart = performance.timing && performance.timing.navigationStart;
    var hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    var navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            _browserPerformanceTimeOriginMode = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = 'dateNow';
    return dateNow;
}();

},{"./worldwide.js":"aZo8o","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"38pRJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TRACEPARENT_REGEXP", function() {
    return TRACEPARENT_REGEXP;
});
parcelHelpers.export(exports, "extractTraceparentData", function() {
    return extractTraceparentData;
});
parcelHelpers.export(exports, "generateSentryTraceHeader", function() {
    return generateSentryTraceHeader;
});
parcelHelpers.export(exports, "propagationContextFromHeaders", function() {
    return propagationContextFromHeaders;
});
parcelHelpers.export(exports, "tracingContextFromHeaders", function() {
    return tracingContextFromHeaders;
});
var _baggageJs = require("./baggage.js");
var _miscJs = require("./misc.js");
// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
var TRACEPARENT_REGEXP = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function extractTraceparentData(traceparent) {
    if (!traceparent) return undefined;
    var matches = traceparent.match(TRACEPARENT_REGEXP);
    if (!matches) return undefined;
    var parentSampled;
    if (matches[3] === '1') parentSampled = true;
    else if (matches[3] === '0') parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create tracing context from incoming headers.
 *
 * @deprecated Use `propagationContextFromHeaders` instead.
 */ // TODO(v8): Remove this function
function tracingContextFromHeaders(sentryTrace, baggage) {
    var traceparentData = extractTraceparentData(sentryTrace);
    var dynamicSamplingContext = (0, _baggageJs.baggageHeaderToDynamicSamplingContext)(baggage);
    var _ref = traceparentData || {}, traceId = _ref.traceId, parentSpanId = _ref.parentSpanId, parentSampled = _ref.parentSampled;
    if (!traceparentData) return {
        traceparentData: traceparentData,
        dynamicSamplingContext: undefined,
        propagationContext: {
            traceId: traceId || (0, _miscJs.uuid4)(),
            spanId: (0, _miscJs.uuid4)().substring(16)
        }
    };
    else return {
        traceparentData: traceparentData,
        dynamicSamplingContext: dynamicSamplingContext || {},
        propagationContext: {
            traceId: traceId || (0, _miscJs.uuid4)(),
            parentSpanId: parentSpanId || (0, _miscJs.uuid4)().substring(16),
            spanId: (0, _miscJs.uuid4)().substring(16),
            sampled: parentSampled,
            dsc: dynamicSamplingContext || {}
        }
    };
}
/**
 * Create a propagation context from incoming headers.
 */ function propagationContextFromHeaders(sentryTrace, baggage) {
    var traceparentData = extractTraceparentData(sentryTrace);
    var dynamicSamplingContext = (0, _baggageJs.baggageHeaderToDynamicSamplingContext)(baggage);
    var _ref = traceparentData || {}, traceId = _ref.traceId, parentSpanId = _ref.parentSpanId, parentSampled = _ref.parentSampled;
    if (!traceparentData) return {
        traceId: traceId || (0, _miscJs.uuid4)(),
        spanId: (0, _miscJs.uuid4)().substring(16)
    };
    else return {
        traceId: traceId || (0, _miscJs.uuid4)(),
        parentSpanId: parentSpanId || (0, _miscJs.uuid4)().substring(16),
        spanId: (0, _miscJs.uuid4)().substring(16),
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {}
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function generateSentryTraceHeader() {
    var traceId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (0, _miscJs.uuid4)(), spanId = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (0, _miscJs.uuid4)().substring(16), sampled = arguments.length > 2 ? arguments[2] : void 0;
    var sampledString = '';
    if (sampled !== undefined) sampledString = sampled ? '-1' : '-0';
    return `${traceId}-${spanId}${sampledString}`;
}

},{"./baggage.js":"ghVrT","./misc.js":"fyY3i","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"ghVrT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BAGGAGE_HEADER_NAME", function() {
    return BAGGAGE_HEADER_NAME;
});
parcelHelpers.export(exports, "MAX_BAGGAGE_STRING_LENGTH", function() {
    return MAX_BAGGAGE_STRING_LENGTH;
});
parcelHelpers.export(exports, "SENTRY_BAGGAGE_KEY_PREFIX", function() {
    return SENTRY_BAGGAGE_KEY_PREFIX;
});
parcelHelpers.export(exports, "SENTRY_BAGGAGE_KEY_PREFIX_REGEX", function() {
    return SENTRY_BAGGAGE_KEY_PREFIX_REGEX;
});
parcelHelpers.export(exports, "baggageHeaderToDynamicSamplingContext", function() {
    return baggageHeaderToDynamicSamplingContext;
});
parcelHelpers.export(exports, "dynamicSamplingContextToSentryBaggageHeader", function() {
    return dynamicSamplingContextToSentryBaggageHeader;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _debugBuildJs = require("./debug-build.js");
var _isJs = require("./is.js");
var _loggerJs = require("./logger.js");
var BAGGAGE_HEADER_NAME = 'baggage';
var SENTRY_BAGGAGE_KEY_PREFIX = 'sentry-';
var SENTRY_BAGGAGE_KEY_PREFIX_REGEX = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ var MAX_BAGGAGE_STRING_LENGTH = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function baggageHeaderToDynamicSamplingContext(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    if (!(0, _isJs.isString)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    // Intermediary object to store baggage key value pairs of incoming baggage headers on.
    // It is later used to read Sentry-DSC-values from.
    var baggageObject = {};
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    baggageObject = baggageHeader.reduce(function(acc, curr) {
        var currBaggageObject = baggageHeaderToObject(curr);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = Object.keys(currBaggageObject)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                acc[key] = currBaggageObject[key];
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return acc;
    }, {});
    else {
        // Return undefined if baggage header is an empty string (technically an empty baggage header is not spec conform but
        // this is how we choose to handle it)
        if (!baggageHeader) return undefined;
        baggageObject = baggageHeaderToObject(baggageHeader);
    }
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    var dynamicSamplingContext = Object.entries(baggageObject).reduce(function(acc, param) {
        var _param = (0, _slicedToArray._)(param, 2), key = _param[0], value = _param[1];
        if (key.match(SENTRY_BAGGAGE_KEY_PREFIX_REGEX)) {
            var nonPrefixedKey = key.slice(SENTRY_BAGGAGE_KEY_PREFIX.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function dynamicSamplingContextToSentryBaggageHeader(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    var sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce(function(acc, param) {
        var _param = (0, _slicedToArray._)(param, 2), dscKey = _param[0], dscValue = _param[1];
        if (dscValue) acc[`${SENTRY_BAGGAGE_KEY_PREFIX}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(',').map(function(baggageEntry) {
        return baggageEntry.split('=').map(function(keyOrValue) {
            return decodeURIComponent(keyOrValue.trim());
        });
    }).reduce(function(acc, param) {
        var _param = (0, _slicedToArray._)(param, 2), key = _param[0], value = _param[1];
        acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce(function(baggageHeader, param, currentIndex) {
        var _param = (0, _slicedToArray._)(param, 2), objectKey = _param[0], objectValue = _param[1];
        var baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        var newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > MAX_BAGGAGE_STRING_LENGTH) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _loggerJs.logger).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, '');
}

},{"@swc/helpers/_/_sliced_to_array":"ha6sq","./debug-build.js":"2NN5Y","./is.js":"7y7Yx","./logger.js":"it07k","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jaYLL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addItemToEnvelope", function() {
    return addItemToEnvelope;
});
parcelHelpers.export(exports, "createAttachmentEnvelopeItem", function() {
    return createAttachmentEnvelopeItem;
});
parcelHelpers.export(exports, "createEnvelope", function() {
    return createEnvelope;
});
parcelHelpers.export(exports, "createEventEnvelopeHeaders", function() {
    return createEventEnvelopeHeaders;
});
parcelHelpers.export(exports, "envelopeContainsItemType", function() {
    return envelopeContainsItemType;
});
parcelHelpers.export(exports, "envelopeItemTypeToDataCategory", function() {
    return envelopeItemTypeToDataCategory;
});
parcelHelpers.export(exports, "forEachEnvelopeItem", function() {
    return forEachEnvelopeItem;
});
parcelHelpers.export(exports, "getSdkMetadataForEnvelopeHeader", function() {
    return getSdkMetadataForEnvelopeHeader;
});
parcelHelpers.export(exports, "parseEnvelope", function() {
    return parseEnvelope;
});
parcelHelpers.export(exports, "serializeEnvelope", function() {
    return serializeEnvelope;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _dsnJs = require("./dsn.js");
var _normalizeJs = require("./normalize.js");
var _objectJs = require("./object.js");
/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function createEnvelope(headers) {
    var items = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function addItemToEnvelope(envelope, newItem) {
    var _envelope = (0, _slicedToArray._)(envelope, 2), headers = _envelope[0], items = _envelope[1];
    return [
        headers,
        (0, _toConsumableArray._)(items).concat([
            newItem
        ])
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function forEachEnvelopeItem(envelope, callback) {
    var envelopeItems = envelope[1];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = envelopeItems[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var envelopeItem = _step.value;
            var envelopeItemType = envelopeItem[0].type;
            var result = callback(envelopeItem, envelopeItemType);
            if (result) return true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function envelopeContainsItemType(envelope, types) {
    return forEachEnvelopeItem(envelope, function(_, type) {
        return types.includes(type);
    });
}
/**
 * Encode a string to UTF8.
 */ function encodeUTF8(input, textEncoder) {
    var utf8 = textEncoder || new TextEncoder();
    return utf8.encode(input);
}
/**
 * Serializes an envelope.
 */ function serializeEnvelope(envelope, textEncoder) {
    var _envelope = (0, _slicedToArray._)(envelope, 2), envHeaders = _envelope[0], items = _envelope[1];
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    var parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === 'string') parts = typeof next === 'string' ? parts + next : [
            encodeUTF8(parts, textEncoder),
            next
        ];
        else parts.push(typeof next === 'string' ? encodeUTF8(next, textEncoder) : next);
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            var _item = (0, _slicedToArray._)(item, 2), itemHeaders = _item[0], payload = _item[1];
            append(`\n${JSON.stringify(itemHeaders)}\n`);
            if (typeof payload === 'string' || payload instanceof Uint8Array) append(payload);
            else {
                var stringifiedPayload = void 0;
                try {
                    stringifiedPayload = JSON.stringify(payload);
                } catch (e) {
                    // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.strinify()` still
                    // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                    // performance impact but in this case a performance hit is better than throwing.
                    stringifiedPayload = JSON.stringify((0, _normalizeJs.normalize)(payload));
                }
                append(stringifiedPayload);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return typeof parts === 'string' ? parts : concatBuffers(parts);
}
function concatBuffers(buffers) {
    var totalLength = buffers.reduce(function(acc, buf) {
        return acc + buf.length;
    }, 0);
    var merged = new Uint8Array(totalLength);
    var offset = 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = buffers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var buffer = _step.value;
            merged.set(buffer, offset);
            offset += buffer.length;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return merged;
}
/**
 * Parses an envelope
 */ function parseEnvelope(env, textEncoder, textDecoder) {
    var buffer = typeof env === 'string' ? textEncoder.encode(env) : env;
    function readBinary(length) {
        var bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        var i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse(textDecoder.decode(readBinary(i)));
    }
    var envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var items = [];
    while(buffer.length){
        var itemHeader = readJson();
        var binaryLength = typeof itemHeader.length === 'number' ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates attachment envelope items
 */ function createAttachmentEnvelopeItem(attachment, textEncoder) {
    var buffer = typeof attachment.data === 'string' ? encodeUTF8(attachment.data, textEncoder) : attachment.data;
    return [
        (0, _objectJs.dropUndefinedKeys)({
            type: 'attachment',
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        }),
        buffer
    ];
}
var ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: 'session',
    sessions: 'session',
    attachment: 'attachment',
    transaction: 'transaction',
    event: 'error',
    client_report: 'internal',
    user_report: 'default',
    profile: 'profile',
    replay_event: 'replay',
    replay_recording: 'replay',
    check_in: 'monitor',
    feedback: 'feedback',
    span: 'span',
    statsd: 'metric_bucket'
};
/**
 * Maps the type of an envelope item to a data category.
 */ function envelopeItemTypeToDataCategory(type) {
    return ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function getSdkMetadataForEnvelopeHeader(metadataOrEvent) {
    if (!metadataOrEvent || !metadataOrEvent.sdk) return;
    var _metadataOrEvent_sdk = metadataOrEvent.sdk, name = _metadataOrEvent_sdk.name, version = _metadataOrEvent_sdk.version;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function createEventEnvelopeHeaders(event, sdkInfo, tunnel, dsn) {
    var dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
    return (0, _objectSpread._)({
        event_id: event.event_id,
        sent_at: new Date().toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }, !!tunnel && dsn && {
        dsn: (0, _dsnJs.dsnToString)(dsn)
    }, dynamicSamplingContext && {
        trace: (0, _objectJs.dropUndefinedKeys)((0, _objectSpread._)({}, dynamicSamplingContext))
    });
}

},{"@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_sliced_to_array":"ha6sq","@swc/helpers/_/_to_consumable_array":"eqNDD","./dsn.js":"iPwy7","./normalize.js":"b1fOd","./object.js":"auET5","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6lWHX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createClientReportEnvelope", function() {
    return createClientReportEnvelope;
});
var _envelopeJs = require("./envelope.js");
var _timeJs = require("./time.js");
/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function createClientReportEnvelope(discarded_events, dsn, timestamp) {
    var clientReportItem = [
        {
            type: 'client_report'
        },
        {
            timestamp: timestamp || (0, _timeJs.dateTimestampInSeconds)(),
            discarded_events: discarded_events
        }
    ];
    return (0, _envelopeJs.createEnvelope)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}

},{"./envelope.js":"jaYLL","./time.js":"5WKyq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"hNjcc":[function(require,module,exports,__globalThis) {
// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_RETRY_AFTER", function() {
    return DEFAULT_RETRY_AFTER;
});
parcelHelpers.export(exports, "disabledUntil", function() {
    return disabledUntil;
});
parcelHelpers.export(exports, "isRateLimited", function() {
    return isRateLimited;
});
parcelHelpers.export(exports, "parseRetryAfterHeader", function() {
    return parseRetryAfterHeader;
});
parcelHelpers.export(exports, "updateRateLimits", function() {
    return updateRateLimits;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var DEFAULT_RETRY_AFTER = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function parseRetryAfterHeader(header) {
    var now = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Date.now();
    var headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    var headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return DEFAULT_RETRY_AFTER;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function disabledUntil(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function isRateLimited(limits, dataCategory) {
    var now = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Date.now();
    return disabledUntil(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function updateRateLimits(limits, param) {
    var statusCode = param.statusCode, headers = param.headers, now = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Date.now();
    var updatedRateLimits = (0, _objectSpread._)({}, limits);
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    var rateLimitHeader = headers && headers['x-sentry-rate-limits'];
    var retryAfterHeader = headers && headers['retry-after'];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (rateLimitHeader) try {
        /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for(var _iterator = rateLimitHeader.trim().split(',')[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var limit = _step.value;
            var _limit_split = (0, _slicedToArray._)(limit.split(':', 5), 5), retryAfter = _limit_split[0], categories = _limit_split[1], namespaces = _limit_split[4];
            var headerDelay = parseInt(retryAfter, 10);
            var delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            if (!categories) updatedRateLimits.all = now + delay;
            else try {
                for(var _iterator1 = categories.split(';')[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var category = _step1.value;
                    if (category === 'metric_bucket') // namespaces will be present when category === 'metric_bucket'
                    {
                        if (!namespaces || namespaces.split(';').includes('custom')) updatedRateLimits[category] = now + delay;
                    } else updatedRateLimits[category] = now + delay;
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + parseRetryAfterHeader(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}

},{"@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_sliced_to_array":"ha6sq","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jlPfK":[function(require,module,exports,__globalThis) {
/**
 * Recursively traverses an object to update an existing nested key.
 * Note: The provided key path must include existing properties,
 * the function will not create objects while traversing.
 *
 * @param obj An object to update
 * @param value The value to update the nested key with
 * @param keyPath The path to the key to update ex. fizz.buzz.foo
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addOrUpdateIntegration", function() {
    return addOrUpdateIntegration;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
function setNestedKey(obj, keyPath, value) {
    // Ex. foo.bar.zoop will extract foo and bar.zoop
    var match = keyPath.match(/([a-z_]+)\.(.*)/i);
    // The match will be null when there's no more recursing to do, i.e., when we've reached the right level of the object
    if (match === null) obj[keyPath] = value;
    else {
        // `match[1]` is the initial segment of the path, and `match[2]` is the remainder of the path
        var innerObj = obj[match[1]];
        setNestedKey(innerObj, match[2], value);
    }
}
/**
 * Enforces inclusion of a given integration with specified options in an integration array originally determined by the
 * user, by either including the given default instance or by patching an existing user instance with the given options.
 *
 * Ideally this would happen when integrations are set up, but there isn't currently a mechanism there for merging
 * options from a default integration instance with those from a user-provided instance of the same integration, only
 * for allowing the user to override a default instance entirely. (TODO: Fix that.)
 *
 * @param defaultIntegrationInstance An instance of the integration with the correct options already set
 * @param userIntegrations Integrations defined by the user.
 * @param forcedOptions Options with which to patch an existing user-derived instance on the integration.
 * @returns A final integrations array.
 *
 * @deprecated This will be removed in v8.
 */ function addOrUpdateIntegration(defaultIntegrationInstance, userIntegrations) {
    var forcedOptions = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return Array.isArray(userIntegrations) ? addOrUpdateIntegrationInArray(defaultIntegrationInstance, userIntegrations, forcedOptions) : addOrUpdateIntegrationInFunction(defaultIntegrationInstance, // Somehow TS can't figure out that not being an array makes this necessarily a function
    userIntegrations, forcedOptions);
}
function addOrUpdateIntegrationInArray(defaultIntegrationInstance, userIntegrations, forcedOptions) {
    var userInstance = userIntegrations.find(function(integration) {
        return integration.name === defaultIntegrationInstance.name;
    });
    if (userInstance) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = Object.entries(forcedOptions)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, _slicedToArray._)(_step.value, 2), keyPath = _step_value[0], value = _step_value[1];
                setNestedKey(userInstance, keyPath, value);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return userIntegrations;
    }
    return (0, _toConsumableArray._)(userIntegrations).concat([
        defaultIntegrationInstance
    ]);
}
function addOrUpdateIntegrationInFunction(defaultIntegrationInstance, userIntegrationsFunc, forcedOptions) {
    var wrapper = function(defaultIntegrations) {
        var userFinalIntegrations = userIntegrationsFunc(defaultIntegrations);
        // There are instances where we want the user to be able to prevent an integration from appearing at all, which they
        // would do by providing a function which filters out the integration in question. If that's happened in one of
        // those cases, don't add our default back in.
        if (defaultIntegrationInstance.allowExclusionByUser) {
            var userFinalInstance = userFinalIntegrations.find(function(integration) {
                return integration.name === defaultIntegrationInstance.name;
            });
            if (!userFinalInstance) return userFinalIntegrations;
        }
        return addOrUpdateIntegrationInArray(defaultIntegrationInstance, userFinalIntegrations, forcedOptions);
    };
    return wrapper;
}

},{"@swc/helpers/_/_sliced_to_array":"ha6sq","@swc/helpers/_/_to_consumable_array":"eqNDD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"bF1Wf":[function(require,module,exports,__globalThis) {
/**
 * Creates a cache that evicts keys in fifo order
 * @param size {Number}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "makeFifoCache", function() {
    return makeFifoCache;
});
function makeFifoCache(size) {
    // Maintain a fifo queue of keys, we cannot rely on Object.keys as the browser may not support it.
    var evictionOrder = [];
    var cache = {};
    return {
        add: function(key, value) {
            while(evictionOrder.length >= size){
                // shift is O(n) but this is small size and only happens if we are
                // exceeding the cache size so it should be fine.
                var evictCandidate = evictionOrder.shift();
                if (evictCandidate !== undefined) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                delete cache[evictCandidate];
            }
            // in case we have a collision, delete the old key.
            if (cache[key]) this.delete(key);
            evictionOrder.push(key);
            cache[key] = value;
        },
        clear: function() {
            cache = {};
            evictionOrder = [];
        },
        get: function(key) {
            return cache[key];
        },
        size: function() {
            return evictionOrder.length;
        },
        // Delete cache key and return true if it existed, false otherwise.
        delete: function(key) {
            if (!cache[key]) return false;
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete cache[key];
            for(var i = 0; i < evictionOrder.length; i++)if (evictionOrder[i] === key) {
                evictionOrder.splice(i, 1);
                break;
            }
            return true;
        }
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2sAyX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "eventFromMessage", function() {
    return eventFromMessage;
});
parcelHelpers.export(exports, "eventFromUnknownInput", function() {
    return eventFromUnknownInput;
});
parcelHelpers.export(exports, "exceptionFromError", function() {
    return exceptionFromError;
});
parcelHelpers.export(exports, "parseStackFrames", function() {
    return parseStackFrames;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _isJs = require("./is.js");
var _miscJs = require("./misc.js");
var _normalizeJs = require("./normalize.js");
var _objectJs = require("./object.js");
/**
 * Extracts stack frames from the error.stack string
 */ function parseStackFrames(stackParser, error) {
    return stackParser(error.stack || '', 1);
}
/**
 * Extracts stack frames from the error and builds a Sentry Exception
 */ function exceptionFromError(stackParser, error) {
    var exception = {
        type: error.name || error.constructor.name,
        value: error.message
    };
    var frames = parseStackFrames(stackParser, error);
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    return exception;
}
function getMessageForObject(exception) {
    if ('name' in exception && typeof exception.name === 'string') {
        var message = `'${exception.name}' captured as exception`;
        if ('message' in exception && typeof exception.message === 'string') message += ` with message '${exception.message}'`;
        return message;
    } else if ('message' in exception && typeof exception.message === 'string') return exception.message;
    else // This will allow us to group events based on top-level keys
    // which is much better than creating new group when any key/value change
    return `Object captured as exception with keys: ${(0, _objectJs.extractExceptionKeysForMessage)(exception)}`;
}
/**
 * Builds and Event from a Exception
 *
 * TODO(v8): Remove getHub fallback
 * @hidden
 */ function eventFromUnknownInput(// eslint-disable-next-line deprecation/deprecation
getHubOrClient, stackParser, exception, hint) {
    var client = typeof getHubOrClient === 'function' ? getHubOrClient().getClient() : getHubOrClient;
    var ex = exception;
    var providedMechanism = hint && hint.data && hint.data.mechanism;
    var mechanism = providedMechanism || {
        handled: true,
        type: 'generic'
    };
    var extras;
    if (!(0, _isJs.isError)(exception)) {
        if ((0, _isJs.isPlainObject)(exception)) {
            var normalizeDepth = client && client.getOptions().normalizeDepth;
            extras = (0, _defineProperty._)({}, '__serialized__', (0, _normalizeJs.normalizeToSize)(exception, normalizeDepth));
            var message = getMessageForObject(exception);
            ex = hint && hint.syntheticException || new Error(message);
            ex.message = message;
        } else {
            // This handles when someone does: `throw "something awesome";`
            // We use synthesized Error here so we can extract a (rough) stack trace.
            ex = hint && hint.syntheticException || new Error(exception);
            ex.message = exception;
        }
        mechanism.synthetic = true;
    }
    var event = {
        exception: {
            values: [
                exceptionFromError(stackParser, ex)
            ]
        }
    };
    if (extras) event.extra = extras;
    (0, _miscJs.addExceptionTypeValue)(event, undefined, undefined);
    (0, _miscJs.addExceptionMechanism)(event, mechanism);
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, event), {
        event_id: hint && hint.event_id
    });
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function eventFromMessage(stackParser, message) {
    var // eslint-disable-next-line deprecation/deprecation
    level = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'info', hint = arguments.length > 3 ? arguments[3] : void 0, attachStacktrace = arguments.length > 4 ? arguments[4] : void 0;
    var event = {
        event_id: hint && hint.event_id,
        level: level
    };
    if (attachStacktrace && hint && hint.syntheticException) {
        var frames = parseStackFrames(stackParser, hint.syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
    }
    if ((0, _isJs.isParameterizedString)(message)) {
        var __sentry_template_string__ = message.__sentry_template_string__, __sentry_template_values__ = message.__sentry_template_values__;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}

},{"@swc/helpers/_/_define_property":"54Zvk","@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_object_spread_props":"fLCYP","./is.js":"7y7Yx","./misc.js":"fyY3i","./normalize.js":"b1fOd","./object.js":"auET5","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"cSbuX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "callFrameToStackFrame", function() {
    return callFrameToStackFrame;
});
parcelHelpers.export(exports, "watchdogTimer", function() {
    return watchdogTimer;
});
var _objectJs = require("./object.js");
var _nodeStackTraceJs = require("./node-stack-trace.js");
/**
 * A node.js watchdog timer
 * @param pollInterval The interval that we expect to get polled at
 * @param anrThreshold The threshold for when we consider ANR
 * @param callback The callback to call for ANR
 * @returns An object with `poll` and `enabled` functions {@link WatchdogReturn}
 */ function watchdogTimer(createTimer, pollInterval, anrThreshold, callback) {
    var timer = createTimer();
    var triggered = false;
    var enabled = true;
    setInterval(function() {
        var diffMs = timer.getTimeMs();
        if (triggered === false && diffMs > pollInterval + anrThreshold) {
            triggered = true;
            if (enabled) callback();
        }
        if (diffMs < pollInterval + anrThreshold) triggered = false;
    }, 20);
    return {
        poll: function() {
            timer.reset();
        },
        enabled: function(state) {
            enabled = state;
        }
    };
}
// types copied from inspector.d.ts
/**
 * Converts Debugger.CallFrame to Sentry StackFrame
 */ function callFrameToStackFrame(frame, url, getModuleFromFilename) {
    var filename = url ? url.replace(/^file:\/\//, '') : undefined;
    // CallFrame row/col are 0 based, whereas StackFrame are 1 based
    var colno = frame.location.columnNumber ? frame.location.columnNumber + 1 : undefined;
    var lineno = frame.location.lineNumber ? frame.location.lineNumber + 1 : undefined;
    return (0, _objectJs.dropUndefinedKeys)({
        filename: filename,
        module: getModuleFromFilename(filename),
        function: frame.functionName || '?',
        colno: colno,
        lineno: lineno,
        in_app: filename ? (0, _nodeStackTraceJs.filenameIsInApp)(filename) : undefined
    });
}

},{"./object.js":"auET5","./node-stack-trace.js":"khf3c","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"dq8pf":[function(require,module,exports,__globalThis) {
/** A simple Least Recently Used map */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LRUMap", function() {
    return LRUMap;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var LRUMap = /*#__PURE__*/ function() {
    "use strict";
    function LRUMap(_maxSize) {
        (0, _classCallCheck._)(this, LRUMap);
        this._maxSize = _maxSize;
        this._cache = new Map();
    }
    (0, _createClass._)(LRUMap, [
        {
            key: "size",
            get: /** Get the current size of the cache */ function get() {
                return this._cache.size;
            }
        },
        {
            /** Get an entry or undefined if it was not in the cache. Re-inserts to update the recently used order */ key: "get",
            value: function get(key) {
                var value = this._cache.get(key);
                if (value === undefined) return undefined;
                // Remove and re-insert to update the order
                this._cache.delete(key);
                this._cache.set(key, value);
                return value;
            }
        },
        {
            /** Insert an entry and evict an older entry if we've reached maxSize */ key: "set",
            value: function set(key, value) {
                if (this._cache.size >= this._maxSize) // keys() returns an iterator in insertion order so keys().next() gives us the oldest key
                this._cache.delete(this._cache.keys().next().value);
                this._cache.set(key, value);
            }
        },
        {
            /** Remove an entry and return the entry if it was in the cache */ key: "remove",
            value: function remove(key) {
                var value = this._cache.get(key);
                if (value) this._cache.delete(key);
                return value;
            }
        },
        {
            /** Clear all entries */ key: "clear",
            value: function clear() {
                this._cache.clear();
            }
        },
        {
            /** Get all the keys */ key: "keys",
            value: function keys() {
                return Array.from(this._cache.keys());
            }
        },
        {
            /** Get all the values */ key: "values",
            value: function values() {
                var values = [];
                this._cache.forEach(function(value) {
                    return values.push(value);
                });
                return values;
            }
        }
    ]);
    return LRUMap;
}();

},{"@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7Ym4p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Sucrase version:
// async function _asyncNullishCoalesce(lhs, rhsFn) {
//   if (lhs != null) {
//     return lhs;
//   } else {
//     return await rhsFn();
//   }
// }
parcelHelpers.export(exports, "_asyncNullishCoalesce", function() {
    return _asyncNullishCoalesce;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _nullishCoalesceJs = require("./_nullishCoalesce.js");
function _asyncNullishCoalesce(lhs, rhsFn) {
    return __asyncNullishCoalesce.apply(this, arguments);
}
function __asyncNullishCoalesce() {
    __asyncNullishCoalesce = // https://github.com/alangpierce/sucrase/tree/265887868966917f3b924ce38dfad01fbab1329f
    /**
 * Polyfill for the nullish coalescing operator (`??`), when used in situations where at least one of the values is the
 * result of an async operation.
 *
 * Note that the RHS is wrapped in a function so that if it's a computed value, that evaluation won't happen unless the
 * LHS evaluates to a nullish value, to mimic the operator's short-circuiting behavior.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 *
 * @param lhs The value of the expression to the left of the `??`
 * @param rhsFn A function returning the value of the expression to the right of the `??`
 * @returns The LHS value, unless it's `null` or `undefined`, in which case, the RHS value
 */ (0, _asyncToGenerator._)(function(lhs, rhsFn) {
        return (0, _tsGenerator._)(this, function(_state) {
            return [
                2,
                (0, _nullishCoalesceJs._nullishCoalesce)(lhs, rhsFn)
            ];
        });
    });
    return __asyncNullishCoalesce.apply(this, arguments);
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_ts_generator":"f2hGH","./_nullishCoalesce.js":"1nnqc","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1nnqc":[function(require,module,exports,__globalThis) {
// https://github.com/alangpierce/sucrase/tree/265887868966917f3b924ce38dfad01fbab1329f
//
// The MIT License (MIT)
//
// Copyright (c) 2012-2018 various contributors (see AUTHORS)
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.
/**
 * Polyfill for the nullish coalescing operator (`??`).
 *
 * Note that the RHS is wrapped in a function so that if it's a computed value, that evaluation won't happen unless the
 * LHS evaluates to a nullish value, to mimic the operator's short-circuiting behavior.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 *
 * @param lhs The value of the expression to the left of the `??`
 * @param rhsFn A function returning the value of the expression to the right of the `??`
 * @returns The LHS value, unless it's `null` or `undefined`, in which case, the RHS value
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Sucrase version:
// function _nullishCoalesce(lhs, rhsFn) {
//   if (lhs != null) {
//     return lhs;
//   } else {
//     return rhsFn();
//   }
// }
parcelHelpers.export(exports, "_nullishCoalesce", function() {
    return _nullishCoalesce;
});
function _nullishCoalesce(lhs, rhsFn) {
    // by checking for loose equality to `null`, we catch both `null` and `undefined`
    return lhs != null ? lhs : rhsFn();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"aX8Pj":[function(require,module,exports,__globalThis) {
/**
 * Polyfill for the optional chain operator, `?.`, given previous conversion of the expression into an array of values,
 * descriptors, and functions, for situations in which at least one part of the expression is async.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase) See
 * https://github.com/alangpierce/sucrase/blob/265887868966917f3b924ce38dfad01fbab1329f/src/transformers/OptionalChainingNullishTransformer.ts#L15
 *
 * @param ops Array result of expression conversion
 * @returns The value of the expression
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Sucrase version:
// async function _asyncOptionalChain(ops) {
//   let lastAccessLHS = undefined;
//   let value = ops[0];
//   let i = 1;
//   while (i < ops.length) {
//     const op = ops[i];
//     const fn = ops[i + 1];
//     i += 2;
//     if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
//       return undefined;
//     }
//     if (op === 'access' || op === 'optionalAccess') {
//       lastAccessLHS = value;
//       value = await fn(value);
//     } else if (op === 'call' || op === 'optionalCall') {
//       value = await fn((...args) => value.call(lastAccessLHS, ...args));
//       lastAccessLHS = undefined;
//     }
//   }
//   return value;
// }
parcelHelpers.export(exports, "_asyncOptionalChain", function() {
    return _asyncOptionalChain;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
function _asyncOptionalChain(ops) {
    return __asyncOptionalChain.apply(this, arguments);
}
function __asyncOptionalChain() {
    __asyncOptionalChain = (0, _asyncToGenerator._)(function(ops) {
        var lastAccessLHS, value, i, op, fn, _value;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    lastAccessLHS = undefined;
                    value = ops[0];
                    i = 1;
                    _state.label = 1;
                case 1:
                    if (!(i < ops.length)) return [
                        3,
                        6
                    ];
                    op = ops[i];
                    fn = ops[i + 1];
                    i += 2;
                    // by checking for loose equality to `null`, we catch both `null` and `undefined`
                    if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) // really we're meaning to return `undefined` as an actual value here, but it saves bytes not to write it
                    return [
                        2
                    ];
                    if (!(op === 'access' || op === 'optionalAccess')) return [
                        3,
                        3
                    ];
                    lastAccessLHS = value;
                    return [
                        4,
                        fn(value)
                    ];
                case 2:
                    value = _state.sent();
                    return [
                        3,
                        5
                    ];
                case 3:
                    if (!(op === 'call' || op === 'optionalCall')) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        fn(function() {
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                                args[_key] = arguments[_key];
                            }
                            return (_value = value).call.apply(_value, [
                                lastAccessLHS
                            ].concat((0, _toConsumableArray._)(args)));
                        })
                    ];
                case 4:
                    value = _state.sent();
                    lastAccessLHS = undefined;
                    _state.label = 5;
                case 5:
                    return [
                        3,
                        1
                    ];
                case 6:
                    return [
                        2,
                        value
                    ];
            }
        });
    });
    return __asyncOptionalChain.apply(this, arguments);
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_to_consumable_array":"eqNDD","@swc/helpers/_/_ts_generator":"f2hGH","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"dodKv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Sucrase version:
// async function asyncOptionalChainDelete(ops) {
//   const result = await ASYNC_OPTIONAL_CHAIN_NAME(ops);
//   return result == null ? true : result;
// }
parcelHelpers.export(exports, "_asyncOptionalChainDelete", function() {
    return _asyncOptionalChainDelete;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _asyncOptionalChainJs = require("./_asyncOptionalChain.js");
function _asyncOptionalChainDelete(ops) {
    return __asyncOptionalChainDelete.apply(this, arguments);
}
function __asyncOptionalChainDelete() {
    __asyncOptionalChainDelete = // https://github.com/alangpierce/sucrase/tree/265887868966917f3b924ce38dfad01fbab1329f
    /**
 * Polyfill for the optional chain operator, `?.`, given previous conversion of the expression into an array of values,
 * descriptors, and functions, in cases where the value of the expression is to be deleted.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase) See
 * https://github.com/alangpierce/sucrase/blob/265887868966917f3b924ce38dfad01fbab1329f/src/transformers/OptionalChainingNullishTransformer.ts#L15
 *
 * @param ops Array result of expression conversion
 * @returns The return value of the `delete` operator: `true`, unless the deletion target is an own, non-configurable
 * property (one which can't be deleted or turned into an accessor, and whose enumerability can't be changed), in which
 * case `false`.
 */ (0, _asyncToGenerator._)(function(ops) {
        var result;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0, _asyncOptionalChainJs._asyncOptionalChain)(ops)
                    ];
                case 1:
                    result = _state.sent();
                    // If `result` is `null`, it means we didn't get to the end of the chain and so nothing was deleted (in which case,
                    // return `true` since that's what `delete` does when it no-ops). If it's non-null, we know the delete happened, in
                    // which case we return whatever the `delete` returned, which will be a boolean.
                    return [
                        2,
                        result == null ? true : result
                    ];
            }
        });
    });
    return __asyncOptionalChainDelete.apply(this, arguments);
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_ts_generator":"f2hGH","./_asyncOptionalChain.js":"aX8Pj","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8sZr1":[function(require,module,exports,__globalThis) {
/**
 * Polyfill for the optional chain operator, `?.`, given previous conversion of the expression into an array of values,
 * descriptors, and functions.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 * See https://github.com/alangpierce/sucrase/blob/265887868966917f3b924ce38dfad01fbab1329f/src/transformers/OptionalChainingNullishTransformer.ts#L15
 *
 * @param ops Array result of expression conversion
 * @returns The value of the expression
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Sucrase version
// function _optionalChain(ops) {
//   let lastAccessLHS = undefined;
//   let value = ops[0];
//   let i = 1;
//   while (i < ops.length) {
//     const op = ops[i];
//     const fn = ops[i + 1];
//     i += 2;
//     if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
//       return undefined;
//     }
//     if (op === 'access' || op === 'optionalAccess') {
//       lastAccessLHS = value;
//       value = fn(value);
//     } else if (op === 'call' || op === 'optionalCall') {
//       value = fn((...args) => value.call(lastAccessLHS, ...args));
//       lastAccessLHS = undefined;
//     }
//   }
//   return value;
// }
parcelHelpers.export(exports, "_optionalChain", function() {
    return _optionalChain;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
function _optionalChain(ops) {
    var lastAccessLHS = undefined;
    var value = ops[0];
    var i = 1;
    while(i < ops.length){
        var op = ops[i];
        var fn = ops[i + 1];
        i += 2;
        // by checking for loose equality to `null`, we catch both `null` and `undefined`
        if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) // really we're meaning to return `undefined` as an actual value here, but it saves bytes not to write it
        return;
        if (op === 'access' || op === 'optionalAccess') {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === 'call' || op === 'optionalCall') {
            var _value;
            value = fn(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return (_value = value).call.apply(_value, [
                    lastAccessLHS
                ].concat((0, _toConsumableArray._)(args)));
            });
            lastAccessLHS = undefined;
        }
    }
    return value;
}

},{"@swc/helpers/_/_to_consumable_array":"eqNDD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2rKpD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Sucrase version:
// function _optionalChainDelete(ops) {
//   const result = _optionalChain(ops);
//   // by checking for loose equality to `null`, we catch both `null` and `undefined`
//   return result == null ? true : result;
// }
parcelHelpers.export(exports, "_optionalChainDelete", function() {
    return _optionalChainDelete;
});
var _optionalChainJs = require("./_optionalChain.js");
// https://github.com/alangpierce/sucrase/tree/265887868966917f3b924ce38dfad01fbab1329f
/**
 * Polyfill for the optional chain operator, `?.`, given previous conversion of the expression into an array of values,
 * descriptors, and functions, in cases where the value of the expression is to be deleted.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase) See
 * https://github.com/alangpierce/sucrase/blob/265887868966917f3b924ce38dfad01fbab1329f/src/transformers/OptionalChainingNullishTransformer.ts#L15
 *
 * @param ops Array result of expression conversion
 * @returns The return value of the `delete` operator: `true`, unless the deletion target is an own, non-configurable
 * property (one which can't be deleted or turned into an accessor, and whose enumerability can't be changed), in which
 * case `false`.
 */ function _optionalChainDelete(ops) {
    var result = (0, _optionalChainJs._optionalChain)(ops);
    // If `result` is `null`, it means we didn't get to the end of the chain and so nothing was deleted (in which case,
    // return `true` since that's what `delete` does when it no-ops). If it's non-null, we know the delete happened, in
    // which case we return whatever the `delete` returned, which will be a boolean.
    return result == null ? true : result;
}

},{"./_optionalChain.js":"8sZr1","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5nlT8":[function(require,module,exports,__globalThis) {
// Based on https://github.com/sindresorhus/escape-string-regexp but with modifications to:
//   a) reduce the size by skipping the runtime type - checking
//   b) ensure it gets down - compiled for old versions of Node(the published package only supports Node 12+).
//
// MIT License
//
// Copyright (c) Sindre Sorhus <sindresorhus@gmail.com> (https://sindresorhus.com)
//
// Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated
// documentation files(the "Software"), to deal in the Software without restriction, including without limitation
// the rights to use, copy, modify, merge, publish, distribute, sublicense, and / or sell copies of the Software, and
// to permit persons to whom the Software is furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all copies or substantial portions of
// the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO
// THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
// TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
// IN THE SOFTWARE.
/**
 * Given a string, escape characters which have meaning in the regex grammar, such that the result is safe to feed to
 * `new RegExp()`.
 *
 * @param regexString The string to escape
 * @returns An version of the string with all special regex characters escaped
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "escapeStringForRegex", function() {
    return escapeStringForRegex;
});
function escapeStringForRegex(regexString) {
    // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
    // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
    return regexString.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4R9PX":[function(require,module,exports,__globalThis) {
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEBUG_BUILD", function() {
    return DEBUG_BUILD;
});
var DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jixbC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "API_VERSION", function() {
    return API_VERSION;
});
parcelHelpers.export(exports, "Hub", function() {
    return Hub;
});
parcelHelpers.export(exports, "ensureHubOnCarrier", function() {
    return ensureHubOnCarrier;
});
parcelHelpers.export(exports, "getCurrentHub", function() {
    return getCurrentHub;
});
parcelHelpers.export(exports, "getHubFromCarrier", function() {
    return getHubFromCarrier;
});
parcelHelpers.export(exports, "getIsolationScope", function() {
    return getIsolationScope;
});
parcelHelpers.export(exports, "getMainCarrier", function() {
    return getMainCarrier;
});
parcelHelpers.export(exports, "makeMain", function() {
    return makeMain;
});
parcelHelpers.export(exports, "runWithAsyncContext", function() {
    return runWithAsyncContext;
});
parcelHelpers.export(exports, "setAsyncContextStrategy", function() {
    return setAsyncContextStrategy;
});
parcelHelpers.export(exports, "setHubOnCarrier", function() {
    return setHubOnCarrier;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _utils = require("@sentry/utils");
var _constantsJs = require("./constants.js");
var _debugBuildJs = require("./debug-build.js");
var _scopeJs = require("./scope.js");
var _sessionJs = require("./session.js");
var _versionJs = require("./version.js");
/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */ var API_VERSION = parseFloat((0, _versionJs.SDK_VERSION));
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ var DEFAULT_BREADCRUMBS = 100;
/**
 * @deprecated The `Hub` class will be removed in version 8 of the SDK in favour of `Scope` and `Client` objects.
 *
 * If you previously used the `Hub` class directly, replace it with `Scope` and `Client` objects. More information:
 * - [Multiple Sentry Instances](https://docs.sentry.io/platforms/javascript/best-practices/multiple-sentry-instances/)
 * - [Browser Extensions](https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/)
 *
 * Some of our APIs are typed with the Hub class instead of the interface (e.g. `getCurrentHub`). Most of them are deprecated
 * themselves and will also be removed in version 8. More information:
 * - [Migration Guide](https://github.com/getsentry/sentry-javascript/blob/develop/MIGRATION.md#deprecate-hub)
 */ // eslint-disable-next-line deprecation/deprecation
var Hub = /*#__PURE__*/ function() {
    "use strict";
    function Hub(client, scope, isolationScope) {
        var _version = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : API_VERSION;
        (0, _classCallCheck._)(this, Hub);
        this._version = _version;
        var assignedScope;
        if (!scope) {
            assignedScope = new (0, _scopeJs.Scope)();
            assignedScope.setClient(client);
        } else assignedScope = scope;
        var assignedIsolationScope;
        if (!isolationScope) {
            assignedIsolationScope = new (0, _scopeJs.Scope)();
            assignedIsolationScope.setClient(client);
        } else assignedIsolationScope = isolationScope;
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        if (client) // eslint-disable-next-line deprecation/deprecation
        this.bindClient(client);
        this._isolationScope = assignedIsolationScope;
    }
    (0, _createClass._)(Hub, [
        {
            /**
   * Checks if this hub's version is older than the given version.
   *
   * @param version A version number to compare to.
   * @return True if the given version is newer; otherwise false.
   *
   * @deprecated This will be removed in v8.
   */ key: "isOlderThan",
            value: function isOlderThan(version) {
                return this._version < version;
            }
        },
        {
            /**
   * This binds the given client to the current scope.
   * @param client An SDK client (client) instance.
   *
   * @deprecated Use `initAndBind()` directly, or `setCurrentClient()` and/or `client.init()` instead.
   */ key: "bindClient",
            value: function bindClient(client) {
                // eslint-disable-next-line deprecation/deprecation
                var top = this.getStackTop();
                top.client = client;
                top.scope.setClient(client);
                // eslint-disable-next-line deprecation/deprecation
                if (client && client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
                client.setupIntegrations();
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ key: "pushScope",
            value: function pushScope() {
                // We want to clone the content of prev scope
                // eslint-disable-next-line deprecation/deprecation
                var scope = this.getScope().clone();
                // eslint-disable-next-line deprecation/deprecation
                this.getStack().push({
                    // eslint-disable-next-line deprecation/deprecation
                    client: this.getClient(),
                    scope: scope
                });
                return scope;
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ key: "popScope",
            value: function popScope() {
                // eslint-disable-next-line deprecation/deprecation
                if (this.getStack().length <= 1) return false;
                // eslint-disable-next-line deprecation/deprecation
                return !!this.getStack().pop();
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.withScope()` instead.
   */ key: "withScope",
            value: function withScope(callback) {
                var _this = this;
                // eslint-disable-next-line deprecation/deprecation
                var scope = this.pushScope();
                var maybePromiseResult;
                try {
                    maybePromiseResult = callback(scope);
                } catch (e) {
                    // eslint-disable-next-line deprecation/deprecation
                    this.popScope();
                    throw e;
                }
                if ((0, _utils.isThenable)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
                return maybePromiseResult.then(function(res) {
                    // eslint-disable-next-line deprecation/deprecation
                    _this.popScope();
                    return res;
                }, function(e) {
                    // eslint-disable-next-line deprecation/deprecation
                    _this.popScope();
                    throw e;
                });
                // eslint-disable-next-line deprecation/deprecation
                this.popScope();
                return maybePromiseResult;
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.getClient()` instead.
   */ key: "getClient",
            value: function getClient() {
                // eslint-disable-next-line deprecation/deprecation
                return this.getStackTop().client;
            }
        },
        {
            /**
   * Returns the scope of the top stack.
   *
   * @deprecated Use `Sentry.getCurrentScope()` instead.
   */ key: "getScope",
            value: function getScope() {
                // eslint-disable-next-line deprecation/deprecation
                return this.getStackTop().scope;
            }
        },
        {
            /**
   * @deprecated Use `Sentry.getIsolationScope()` instead.
   */ key: "getIsolationScope",
            value: function getIsolationScope() {
                return this._isolationScope;
            }
        },
        {
            /**
   * Returns the scope stack for domains or the process.
   * @deprecated This will be removed in v8.
   */ key: "getStack",
            value: function getStack() {
                return this._stack;
            }
        },
        {
            /**
   * Returns the topmost scope layer in the order domain > local > process.
   * @deprecated This will be removed in v8.
   */ key: "getStackTop",
            value: function getStackTop() {
                return this._stack[this._stack.length - 1];
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureException()` instead.
   */ key: "captureException",
            value: function captureException(exception, hint) {
                var eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, _utils.uuid4)();
                var syntheticException = new Error('Sentry syntheticException');
                // eslint-disable-next-line deprecation/deprecation
                this.getScope().captureException(exception, (0, _objectSpreadProps._)((0, _objectSpread._)({
                    originalException: exception,
                    syntheticException: syntheticException
                }, hint), {
                    event_id: eventId
                }));
                return eventId;
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use  `Sentry.captureMessage()` instead.
   */ key: "captureMessage",
            value: function captureMessage(message, // eslint-disable-next-line deprecation/deprecation
            level, hint) {
                var eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, _utils.uuid4)();
                var syntheticException = new Error(message);
                // eslint-disable-next-line deprecation/deprecation
                this.getScope().captureMessage(message, level, (0, _objectSpreadProps._)((0, _objectSpread._)({
                    originalException: message,
                    syntheticException: syntheticException
                }, hint), {
                    event_id: eventId
                }));
                return eventId;
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureEvent()` instead.
   */ key: "captureEvent",
            value: function captureEvent(event, hint) {
                var eventId = hint && hint.event_id ? hint.event_id : (0, _utils.uuid4)();
                if (!event.type) this._lastEventId = eventId;
                // eslint-disable-next-line deprecation/deprecation
                this.getScope().captureEvent(event, (0, _objectSpreadProps._)((0, _objectSpread._)({}, hint), {
                    event_id: eventId
                }));
                return eventId;
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated This will be removed in v8.
   */ key: "lastEventId",
            value: function lastEventId() {
                return this._lastEventId;
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.addBreadcrumb()` instead.
   */ key: "addBreadcrumb",
            value: function addBreadcrumb(breadcrumb, hint) {
                // eslint-disable-next-line deprecation/deprecation
                var _this_getStackTop = this.getStackTop(), scope = _this_getStackTop.scope, client = _this_getStackTop.client;
                if (!client) return;
                var _ref = client.getOptions && client.getOptions() || {}, _ref_beforeBreadcrumb = _ref.beforeBreadcrumb, beforeBreadcrumb = _ref_beforeBreadcrumb === void 0 ? null : _ref_beforeBreadcrumb, _ref_maxBreadcrumbs = _ref.maxBreadcrumbs, maxBreadcrumbs = _ref_maxBreadcrumbs === void 0 ? DEFAULT_BREADCRUMBS : _ref_maxBreadcrumbs;
                if (maxBreadcrumbs <= 0) return;
                var timestamp = (0, _utils.dateTimestampInSeconds)();
                var mergedBreadcrumb = (0, _objectSpread._)({
                    timestamp: timestamp
                }, breadcrumb);
                var finalBreadcrumb = beforeBreadcrumb ? (0, _utils.consoleSandbox)(function() {
                    return beforeBreadcrumb(mergedBreadcrumb, hint);
                }) : mergedBreadcrumb;
                if (finalBreadcrumb === null) return;
                if (client.emit) client.emit('beforeAddBreadcrumb', finalBreadcrumb, hint);
                // TODO(v8): I know this comment doesn't make much sense because the hub will be deprecated but I still wanted to
                // write it down. In theory, we would have to add the breadcrumbs to the isolation scope here, however, that would
                // duplicate all of the breadcrumbs. There was the possibility of adding breadcrumbs to both, the isolation scope
                // and the normal scope, and deduplicating it down the line in the event processing pipeline. However, that would
                // have been very fragile, because the breadcrumb objects would have needed to keep their identity all throughout
                // the event processing pipeline.
                // In the new implementation, the top level `Sentry.addBreadcrumb()` should ONLY write to the isolation scope.
                scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
            }
        },
        {
            /**
   * @inheritDoc
   * @deprecated Use `Sentry.setUser()` instead.
   */ key: "setUser",
            value: function setUser(user) {
                // TODO(v8): The top level `Sentry.setUser()` function should write ONLY to the isolation scope.
                // eslint-disable-next-line deprecation/deprecation
                this.getScope().setUser(user);
                // eslint-disable-next-line deprecation/deprecation
                this.getIsolationScope().setUser(user);
            }
        },
        {
            /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTags()` instead.
   */ key: "setTags",
            value: function setTags(tags) {
                // TODO(v8): The top level `Sentry.setTags()` function should write ONLY to the isolation scope.
                // eslint-disable-next-line deprecation/deprecation
                this.getScope().setTags(tags);
                // eslint-disable-next-line deprecation/deprecation
                this.getIsolationScope().setTags(tags);
            }
        },
        {
            /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtras()` instead.
   */ key: "setExtras",
            value: function setExtras(extras) {
                // TODO(v8): The top level `Sentry.setExtras()` function should write ONLY to the isolation scope.
                // eslint-disable-next-line deprecation/deprecation
                this.getScope().setExtras(extras);
                // eslint-disable-next-line deprecation/deprecation
                this.getIsolationScope().setExtras(extras);
            }
        },
        {
            /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTag()` instead.
   */ key: "setTag",
            value: function setTag(key, value) {
                // TODO(v8): The top level `Sentry.setTag()` function should write ONLY to the isolation scope.
                // eslint-disable-next-line deprecation/deprecation
                this.getScope().setTag(key, value);
                // eslint-disable-next-line deprecation/deprecation
                this.getIsolationScope().setTag(key, value);
            }
        },
        {
            /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtra()` instead.
   */ key: "setExtra",
            value: function setExtra(key, extra) {
                // TODO(v8): The top level `Sentry.setExtra()` function should write ONLY to the isolation scope.
                // eslint-disable-next-line deprecation/deprecation
                this.getScope().setExtra(key, extra);
                // eslint-disable-next-line deprecation/deprecation
                this.getIsolationScope().setExtra(key, extra);
            }
        },
        {
            /**
   * @inheritDoc
   * @deprecated Use `Sentry.setContext()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
            key: "setContext",
            value: function setContext(name, context) {
                // TODO(v8): The top level `Sentry.setContext()` function should write ONLY to the isolation scope.
                // eslint-disable-next-line deprecation/deprecation
                this.getScope().setContext(name, context);
                // eslint-disable-next-line deprecation/deprecation
                this.getIsolationScope().setContext(name, context);
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use `getScope()` directly.
   */ key: "configureScope",
            value: function configureScope(callback) {
                // eslint-disable-next-line deprecation/deprecation
                var _this_getStackTop = this.getStackTop(), scope = _this_getStackTop.scope, client = _this_getStackTop.client;
                if (client) callback(scope);
            }
        },
        {
            /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
            key: "run",
            value: function run(callback) {
                // eslint-disable-next-line deprecation/deprecation
                var oldHub = makeMain(this);
                try {
                    callback(this);
                } finally{
                    // eslint-disable-next-line deprecation/deprecation
                    makeMain(oldHub);
                }
            }
        },
        {
            /**
   * @inheritDoc
   * @deprecated Use `Sentry.getClient().getIntegrationByName()` instead.
   */ key: "getIntegration",
            value: function getIntegration(integration) {
                // eslint-disable-next-line deprecation/deprecation
                var client = this.getClient();
                if (!client) return null;
                try {
                    // eslint-disable-next-line deprecation/deprecation
                    return client.getIntegration(integration);
                } catch (_oO) {
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
                    return null;
                }
            }
        },
        {
            /**
   * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
   *
   * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
   * new child span within the transaction or any span, call the respective `.startChild()` method.
   *
   * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
   *
   * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
   * finished child spans will be sent to Sentry.
   *
   * @param context Properties of the new `Transaction`.
   * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
   * default values). See {@link Options.tracesSampler}.
   *
   * @returns The transaction which was just started
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ key: "startTransaction",
            value: function startTransaction(context, customSamplingContext) {
                var result = this._callExtensionMethod('startTransaction', context, customSamplingContext);
                if ((0, _debugBuildJs.DEBUG_BUILD) && !result) {
                    // eslint-disable-next-line deprecation/deprecation
                    var client = this.getClient();
                    if (!client) (0, _utils.logger).warn("Tracing extension 'startTransaction' is missing. You should 'init' the SDK before calling 'startTransaction'");
                    else (0, _utils.logger).warn(`Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':
Sentry.addTracingExtensions();
Sentry.init({...});
`);
                }
                return result;
            }
        },
        {
            /**
   * @inheritDoc
   * @deprecated Use `spanToTraceHeader()` instead.
   */ key: "traceHeaders",
            value: function traceHeaders() {
                return this._callExtensionMethod('traceHeaders');
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use top level `captureSession` instead.
   */ key: "captureSession",
            value: function captureSession() {
                var endSession = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                // both send the update and pull the session from the scope
                if (endSession) // eslint-disable-next-line deprecation/deprecation
                return this.endSession();
                // only send the update
                this._sendSessionUpdate();
            }
        },
        {
            /**
   * @inheritDoc
   * @deprecated Use top level `endSession` instead.
   */ key: "endSession",
            value: function endSession() {
                // eslint-disable-next-line deprecation/deprecation
                var layer = this.getStackTop();
                var scope = layer.scope;
                var session = scope.getSession();
                if (session) (0, _sessionJs.closeSession)(session);
                this._sendSessionUpdate();
                // the session is over; take it off of the scope
                scope.setSession();
            }
        },
        {
            /**
   * @inheritDoc
   * @deprecated Use top level `startSession` instead.
   */ key: "startSession",
            value: function startSession(context) {
                // eslint-disable-next-line deprecation/deprecation
                var _this_getStackTop = this.getStackTop(), scope = _this_getStackTop.scope, client = _this_getStackTop.client;
                var _ref = client && client.getOptions() || {}, release = _ref.release, _ref_environment = _ref.environment, environment = _ref_environment === void 0 ? (0, _constantsJs.DEFAULT_ENVIRONMENT) : _ref_environment;
                // Will fetch userAgent if called from browser sdk
                var userAgent = ((0, _utils.GLOBAL_OBJ).navigator || {}).userAgent;
                var session = (0, _sessionJs.makeSession)((0, _objectSpread._)({
                    release: release,
                    environment: environment,
                    user: scope.getUser()
                }, userAgent && {
                    userAgent: userAgent
                }, context));
                // End existing session if there's one
                var currentSession = scope.getSession && scope.getSession();
                if (currentSession && currentSession.status === 'ok') (0, _sessionJs.updateSession)(currentSession, {
                    status: 'exited'
                });
                // eslint-disable-next-line deprecation/deprecation
                this.endSession();
                // Afterwards we set the new session on the scope
                scope.setSession(session);
                return session;
            }
        },
        {
            /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   *
   * @deprecated Use top-level `getClient().getOptions().sendDefaultPii` instead. This function
   * only unnecessarily increased API surface but only wrapped accessing the option.
   */ key: "shouldSendDefaultPii",
            value: function shouldSendDefaultPii() {
                // eslint-disable-next-line deprecation/deprecation
                var client = this.getClient();
                var options = client && client.getOptions();
                return Boolean(options && options.sendDefaultPii);
            }
        },
        {
            /**
   * Sends the current Session on the scope
   */ key: "_sendSessionUpdate",
            value: function _sendSessionUpdate() {
                // eslint-disable-next-line deprecation/deprecation
                var _this_getStackTop = this.getStackTop(), scope = _this_getStackTop.scope, client = _this_getStackTop.client;
                var session = scope.getSession();
                if (session && client && client.captureSession) client.captureSession(session);
            }
        },
        {
            /**
   * Calls global extension method and binding current instance to the function call
   */ // @ts-expect-error Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            key: "_callExtensionMethod",
            value: function _callExtensionMethod(method) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                var carrier = getMainCarrier();
                var sentry = carrier.__SENTRY__;
                if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') return sentry.extensions[method].apply(this, args);
                (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn(`Extension method ${method} couldn't be found, doing nothing.`);
            }
        }
    ]);
    return Hub;
}();
/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function getMainCarrier() {
    (0, _utils.GLOBAL_OBJ).__SENTRY__ = (0, _utils.GLOBAL_OBJ).__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return 0, _utils.GLOBAL_OBJ;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 *
 * @deprecated Use `setCurrentClient()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
function makeMain(hub) {
    var registry = getMainCarrier();
    var oldHub = getHubFromCarrier(registry);
    setHubOnCarrier(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 *
 * @deprecated Use the respective replacement method directly instead.
 */ // eslint-disable-next-line deprecation/deprecation
function getCurrentHub() {
    // Get main carrier (global for every environment)
    var registry = getMainCarrier();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
        var hub = registry.__SENTRY__.acs.getCurrentHub();
        if (hub) return hub;
    }
    // Return hub that lives on a global object
    return getGlobalHub(registry);
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current exection context,
 * meaning that it will remain stable for the same Hub.
 */ function getIsolationScope() {
    // eslint-disable-next-line deprecation/deprecation
    return getCurrentHub().getIsolationScope();
}
// eslint-disable-next-line deprecation/deprecation
function getGlobalHub() {
    var registry = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : getMainCarrier();
    // If there's no hub, or its an old API, assign a new one
    if (!hasHubOnCarrier(registry) || // eslint-disable-next-line deprecation/deprecation
    getHubFromCarrier(registry).isOlderThan(API_VERSION)) // eslint-disable-next-line deprecation/deprecation
    setHubOnCarrier(registry, new Hub());
    // Return hub that lives on a global object
    return getHubFromCarrier(registry);
}
/**
 * @private Private API with no semver guarantees!
 *
 * If the carrier does not contain a hub, a new hub is created with the global hub client and scope.
 */ // eslint-disable-next-line deprecation/deprecation
function ensureHubOnCarrier(carrier) {
    var parent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : getGlobalHub();
    // If there's no hub on current domain, or it's an old API, assign a new one
    if (!hasHubOnCarrier(carrier) || // eslint-disable-next-line deprecation/deprecation
    getHubFromCarrier(carrier).isOlderThan(API_VERSION)) {
        // eslint-disable-next-line deprecation/deprecation
        var client = parent.getClient();
        // eslint-disable-next-line deprecation/deprecation
        var scope = parent.getScope();
        // eslint-disable-next-line deprecation/deprecation
        var isolationScope = parent.getIsolationScope();
        // eslint-disable-next-line deprecation/deprecation
        setHubOnCarrier(carrier, new Hub(client, scope.clone(), isolationScope.clone()));
    }
}
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function setAsyncContextStrategy(strategy) {
    // Get main carrier (global for every environment)
    var registry = getMainCarrier();
    registry.__SENTRY__ = registry.__SENTRY__ || {};
    registry.__SENTRY__.acs = strategy;
}
/**
 * Runs the supplied callback in its own async context. Async Context strategies are defined per SDK.
 *
 * @param callback The callback to run in its own async context
 * @param options Options to pass to the async context strategy
 * @returns The result of the callback
 */ function runWithAsyncContext(callback) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var registry = getMainCarrier();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) return registry.__SENTRY__.acs.runWithAsyncContext(callback, options);
    // if there was no strategy, fallback to just calling the callback
    return callback();
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */ // eslint-disable-next-line deprecation/deprecation
function getHubFromCarrier(carrier) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, _utils.getGlobalSingleton)('hub', function() {
        return new Hub();
    }, carrier);
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */ // eslint-disable-next-line deprecation/deprecation
function setHubOnCarrier(carrier, hub) {
    if (!carrier) return false;
    var __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}

},{"@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_object_spread_props":"fLCYP","@sentry/utils":"gElXU","./constants.js":"1t8zr","./debug-build.js":"4R9PX","./scope.js":"kKynH","./session.js":"7FcOX","./version.js":"8NqlU","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1t8zr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_ENVIRONMENT", function() {
    return DEFAULT_ENVIRONMENT;
});
var DEFAULT_ENVIRONMENT = 'production';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"kKynH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Scope", function() {
    return Scope;
});
parcelHelpers.export(exports, "getGlobalScope", function() {
    return getGlobalScope;
});
parcelHelpers.export(exports, "setGlobalScope", function() {
    return setGlobalScope;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _utils = require("@sentry/utils");
var _eventProcessorsJs = require("./eventProcessors.js");
var _sessionJs = require("./session.js");
var _applyScopeDataToEventJs = require("./utils/applyScopeDataToEvent.js");
/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ var DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * The global scope is kept in this module.
 * When accessing this via `getGlobalScope()` we'll make sure to set one if none is currently present.
 */ var globalScope;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ var Scope = /*#__PURE__*/ function() {
    "use strict";
    function Scope() {
        (0, _classCallCheck._)(this, Scope);
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = generatePropagationContext();
    }
    (0, _createClass._)(Scope, [
        {
            /**
   * Clone this scope instance.
   */ key: "clone",
            value: function clone() {
                var newScope = new Scope();
                newScope._breadcrumbs = (0, _toConsumableArray._)(this._breadcrumbs);
                newScope._tags = (0, _objectSpread._)({}, this._tags);
                newScope._extra = (0, _objectSpread._)({}, this._extra);
                newScope._contexts = (0, _objectSpread._)({}, this._contexts);
                newScope._user = this._user;
                newScope._level = this._level;
                newScope._span = this._span;
                newScope._session = this._session;
                newScope._transactionName = this._transactionName;
                newScope._fingerprint = this._fingerprint;
                newScope._eventProcessors = (0, _toConsumableArray._)(this._eventProcessors);
                newScope._requestSession = this._requestSession;
                newScope._attachments = (0, _toConsumableArray._)(this._attachments);
                newScope._sdkProcessingMetadata = (0, _objectSpread._)({}, this._sdkProcessingMetadata);
                newScope._propagationContext = (0, _objectSpread._)({}, this._propagationContext);
                newScope._client = this._client;
                return newScope;
            }
        },
        {
            /** Update the client on the scope. */ key: "setClient",
            value: function setClient(client) {
                this._client = client;
            }
        },
        {
            /**
   * Get the client assigned to this scope.
   *
   * It is generally recommended to use the global function `Sentry.getClient()` instead, unless you know what you are doing.
   */ key: "getClient",
            value: function getClient() {
                return this._client;
            }
        },
        {
            /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */ key: "addScopeListener",
            value: function addScopeListener(callback) {
                this._scopeListeners.push(callback);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "addEventProcessor",
            value: function addEventProcessor(callback) {
                this._eventProcessors.push(callback);
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setUser",
            value: function setUser(user) {
                // If null is passed we want to unset everything, but still define keys,
                // so that later down in the pipeline any existing values are cleared.
                this._user = user || {
                    email: undefined,
                    id: undefined,
                    ip_address: undefined,
                    segment: undefined,
                    username: undefined
                };
                if (this._session) (0, _sessionJs.updateSession)(this._session, {
                    user: user
                });
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "getUser",
            value: function getUser() {
                return this._user;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "getRequestSession",
            value: function getRequestSession() {
                return this._requestSession;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setRequestSession",
            value: function setRequestSession(requestSession) {
                this._requestSession = requestSession;
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setTags",
            value: function setTags(tags) {
                this._tags = (0, _objectSpread._)({}, this._tags, tags);
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setTag",
            value: function setTag(key, value) {
                this._tags = (0, _objectSpreadProps._)((0, _objectSpread._)({}, this._tags), (0, _defineProperty._)({}, key, value));
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setExtras",
            value: function setExtras(extras) {
                this._extra = (0, _objectSpread._)({}, this._extra, extras);
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setExtra",
            value: function setExtra(key, extra) {
                this._extra = (0, _objectSpreadProps._)((0, _objectSpread._)({}, this._extra), (0, _defineProperty._)({}, key, extra));
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setFingerprint",
            value: function setFingerprint(fingerprint) {
                this._fingerprint = fingerprint;
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setLevel",
            value: function setLevel(// eslint-disable-next-line deprecation/deprecation
            level) {
                this._level = level;
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * Sets the transaction name on the scope for future events.
   */ key: "setTransactionName",
            value: function setTransactionName(name) {
                this._transactionName = name;
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setContext",
            value: function setContext(key, context) {
                if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                delete this._contexts[key];
                else this._contexts[key] = context;
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * Sets the Span on the scope.
   * @param span Span
   * @deprecated Instead of setting a span on a scope, use `startSpan()`/`startSpanManual()` instead.
   */ key: "setSpan",
            value: function setSpan(span) {
                this._span = span;
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * Returns the `Span` if there is one.
   * @deprecated Use `getActiveSpan()` instead.
   */ key: "getSpan",
            value: function getSpan() {
                return this._span;
            }
        },
        {
            /**
   * Returns the `Transaction` attached to the scope (if there is one).
   * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
   */ key: "getTransaction",
            value: function getTransaction() {
                // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
                // have a pointer to the currently-active transaction.
                var span = this._span;
                // Cannot replace with getRootSpan because getRootSpan returns a span, not a transaction
                // Also, this method will be removed anyway.
                // eslint-disable-next-line deprecation/deprecation
                return span && span.transaction;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setSession",
            value: function setSession(session) {
                if (!session) delete this._session;
                else this._session = session;
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "getSession",
            value: function getSession() {
                return this._session;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "update",
            value: function update(captureContext) {
                if (!captureContext) return this;
                var scopeToMerge = typeof captureContext === 'function' ? captureContext(this) : captureContext;
                if (scopeToMerge instanceof Scope) {
                    var scopeData = scopeToMerge.getScopeData();
                    this._tags = (0, _objectSpread._)({}, this._tags, scopeData.tags);
                    this._extra = (0, _objectSpread._)({}, this._extra, scopeData.extra);
                    this._contexts = (0, _objectSpread._)({}, this._contexts, scopeData.contexts);
                    if (scopeData.user && Object.keys(scopeData.user).length) this._user = scopeData.user;
                    if (scopeData.level) this._level = scopeData.level;
                    if (scopeData.fingerprint.length) this._fingerprint = scopeData.fingerprint;
                    if (scopeToMerge.getRequestSession()) this._requestSession = scopeToMerge.getRequestSession();
                    if (scopeData.propagationContext) this._propagationContext = scopeData.propagationContext;
                } else if ((0, _utils.isPlainObject)(scopeToMerge)) {
                    var scopeContext = captureContext;
                    this._tags = (0, _objectSpread._)({}, this._tags, scopeContext.tags);
                    this._extra = (0, _objectSpread._)({}, this._extra, scopeContext.extra);
                    this._contexts = (0, _objectSpread._)({}, this._contexts, scopeContext.contexts);
                    if (scopeContext.user) this._user = scopeContext.user;
                    if (scopeContext.level) this._level = scopeContext.level;
                    if (scopeContext.fingerprint) this._fingerprint = scopeContext.fingerprint;
                    if (scopeContext.requestSession) this._requestSession = scopeContext.requestSession;
                    if (scopeContext.propagationContext) this._propagationContext = scopeContext.propagationContext;
                }
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "clear",
            value: function clear() {
                this._breadcrumbs = [];
                this._tags = {};
                this._extra = {};
                this._user = {};
                this._contexts = {};
                this._level = undefined;
                this._transactionName = undefined;
                this._fingerprint = undefined;
                this._requestSession = undefined;
                this._span = undefined;
                this._session = undefined;
                this._notifyScopeListeners();
                this._attachments = [];
                this._propagationContext = generatePropagationContext();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "addBreadcrumb",
            value: function addBreadcrumb(breadcrumb, maxBreadcrumbs) {
                var maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : DEFAULT_MAX_BREADCRUMBS;
                // No data has been changed, so don't notify scope listeners
                if (maxCrumbs <= 0) return this;
                var mergedBreadcrumb = (0, _objectSpread._)({
                    timestamp: (0, _utils.dateTimestampInSeconds)()
                }, breadcrumb);
                var breadcrumbs = this._breadcrumbs;
                breadcrumbs.push(mergedBreadcrumb);
                this._breadcrumbs = breadcrumbs.length > maxCrumbs ? breadcrumbs.slice(-maxCrumbs) : breadcrumbs;
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "getLastBreadcrumb",
            value: function getLastBreadcrumb() {
                return this._breadcrumbs[this._breadcrumbs.length - 1];
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "clearBreadcrumbs",
            value: function clearBreadcrumbs() {
                this._breadcrumbs = [];
                this._notifyScopeListeners();
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "addAttachment",
            value: function addAttachment(attachment) {
                this._attachments.push(attachment);
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   * @deprecated Use `getScopeData()` instead.
   */ key: "getAttachments",
            value: function getAttachments() {
                var data = this.getScopeData();
                return data.attachments;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "clearAttachments",
            value: function clearAttachments() {
                this._attachments = [];
                return this;
            }
        },
        {
            /** @inheritDoc */ key: "getScopeData",
            value: function getScopeData() {
                var _this = this, _breadcrumbs = _this._breadcrumbs, _attachments = _this._attachments, _contexts = _this._contexts, _tags = _this._tags, _extra = _this._extra, _user = _this._user, _level = _this._level, _fingerprint = _this._fingerprint, _eventProcessors = _this._eventProcessors, _propagationContext = _this._propagationContext, _sdkProcessingMetadata = _this._sdkProcessingMetadata, _transactionName = _this._transactionName, _span = _this._span;
                return {
                    breadcrumbs: _breadcrumbs,
                    attachments: _attachments,
                    contexts: _contexts,
                    tags: _tags,
                    extra: _extra,
                    user: _user,
                    level: _level,
                    fingerprint: _fingerprint || [],
                    eventProcessors: _eventProcessors,
                    propagationContext: _propagationContext,
                    sdkProcessingMetadata: _sdkProcessingMetadata,
                    transactionName: _transactionName,
                    span: _span
                };
            }
        },
        {
            /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   * @deprecated Use `applyScopeDataToEvent()` directly
   */ key: "applyToEvent",
            value: function applyToEvent(event) {
                var hint = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, additionalEventProcessors = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
                (0, _applyScopeDataToEventJs.applyScopeDataToEvent)(event, this.getScopeData());
                // TODO (v8): Update this order to be: Global > Client > Scope
                var eventProcessors = (0, _toConsumableArray._)(additionalEventProcessors).concat(// eslint-disable-next-line deprecation/deprecation
                (0, _toConsumableArray._)((0, _eventProcessorsJs.getGlobalEventProcessors)()), (0, _toConsumableArray._)(this._eventProcessors));
                return (0, _eventProcessorsJs.notifyEventProcessors)(eventProcessors, event, hint);
            }
        },
        {
            /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */ key: "setSDKProcessingMetadata",
            value: function setSDKProcessingMetadata(newData) {
                this._sdkProcessingMetadata = (0, _objectSpread._)({}, this._sdkProcessingMetadata, newData);
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setPropagationContext",
            value: function setPropagationContext(context) {
                this._propagationContext = context;
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "getPropagationContext",
            value: function getPropagationContext() {
                return this._propagationContext;
            }
        },
        {
            /**
   * Capture an exception for this scope.
   *
   * @param exception The exception to capture.
   * @param hint Optinal additional data to attach to the Sentry event.
   * @returns the id of the captured Sentry event.
   */ key: "captureException",
            value: function captureException(exception, hint) {
                var eventId = hint && hint.event_id ? hint.event_id : (0, _utils.uuid4)();
                if (!this._client) {
                    (0, _utils.logger).warn('No client configured on scope - will not capture exception!');
                    return eventId;
                }
                var syntheticException = new Error('Sentry syntheticException');
                this._client.captureException(exception, (0, _objectSpreadProps._)((0, _objectSpread._)({
                    originalException: exception,
                    syntheticException: syntheticException
                }, hint), {
                    event_id: eventId
                }), this);
                return eventId;
            }
        },
        {
            /**
   * Capture a message for this scope.
   *
   * @param message The message to capture.
   * @param level An optional severity level to report the message with.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured message.
   */ key: "captureMessage",
            value: function captureMessage(message, level, hint) {
                var eventId = hint && hint.event_id ? hint.event_id : (0, _utils.uuid4)();
                if (!this._client) {
                    (0, _utils.logger).warn('No client configured on scope - will not capture message!');
                    return eventId;
                }
                var syntheticException = new Error(message);
                this._client.captureMessage(message, level, (0, _objectSpreadProps._)((0, _objectSpread._)({
                    originalException: message,
                    syntheticException: syntheticException
                }, hint), {
                    event_id: eventId
                }), this);
                return eventId;
            }
        },
        {
            /**
   * Captures a manually created event for this scope and sends it to Sentry.
   *
   * @param exception The event to capture.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured event.
   */ key: "captureEvent",
            value: function captureEvent(event, hint) {
                var eventId = hint && hint.event_id ? hint.event_id : (0, _utils.uuid4)();
                if (!this._client) {
                    (0, _utils.logger).warn('No client configured on scope - will not capture event!');
                    return eventId;
                }
                this._client.captureEvent(event, (0, _objectSpreadProps._)((0, _objectSpread._)({}, hint), {
                    event_id: eventId
                }), this);
                return eventId;
            }
        },
        {
            /**
   * This will be called on every set call.
   */ key: "_notifyScopeListeners",
            value: function _notifyScopeListeners() {
                var _this = this;
                // We need this check for this._notifyingListeners to be able to work on scope during updates
                // If this check is not here we'll produce endless recursion when something is done with the scope
                // during the callback.
                if (!this._notifyingListeners) {
                    this._notifyingListeners = true;
                    this._scopeListeners.forEach(function(callback) {
                        callback(_this);
                    });
                    this._notifyingListeners = false;
                }
            }
        }
    ], [
        {
            key: "clone",
            value: /**
   * Inherit values from the parent scope.
   * @deprecated Use `scope.clone()` and `new Scope()` instead.
   */ function clone(scope) {
                return scope ? scope.clone() : new Scope();
            }
        }
    ]);
    return Scope;
}();
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function getGlobalScope() {
    if (!globalScope) globalScope = new Scope();
    return globalScope;
}
/**
 * This is mainly needed for tests.
 * DO NOT USE this, as this is an internal API and subject to change.
 * @hidden
 */ function setGlobalScope(scope) {
    globalScope = scope;
}
function generatePropagationContext() {
    return {
        traceId: (0, _utils.uuid4)(),
        spanId: (0, _utils.uuid4)().substring(16)
    };
}

},{"@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","@swc/helpers/_/_define_property":"54Zvk","@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_object_spread_props":"fLCYP","@swc/helpers/_/_to_consumable_array":"eqNDD","@sentry/utils":"gElXU","./eventProcessors.js":"bSGgA","./session.js":"7FcOX","./utils/applyScopeDataToEvent.js":"e0xJW","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"bSGgA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addGlobalEventProcessor", function() {
    return addGlobalEventProcessor;
});
parcelHelpers.export(exports, "getGlobalEventProcessors", function() {
    return getGlobalEventProcessors;
});
parcelHelpers.export(exports, "notifyEventProcessors", function() {
    return notifyEventProcessors;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _utils = require("@sentry/utils");
var _debugBuildJs = require("./debug-build.js");
/**
 * Returns the global event processors.
 * @deprecated Global event processors will be removed in v8.
 */ function getGlobalEventProcessors() {
    return (0, _utils.getGlobalSingleton)('globalEventProcessors', function() {
        return [];
    });
}
/**
 * Add a EventProcessor to be kept globally.
 * @deprecated Use `addEventProcessor` instead. Global event processors will be removed in v8.
 */ function addGlobalEventProcessor(callback) {
    // eslint-disable-next-line deprecation/deprecation
    getGlobalEventProcessors().push(callback);
}
/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function notifyEventProcessors(processors, event, hint) {
    var index = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
    return new (0, _utils.SyncPromise)(function(resolve, reject) {
        var processor = processors[index];
        if (event === null || typeof processor !== 'function') resolve(event);
        else {
            var result = processor((0, _objectSpread._)({}, event), hint);
            (0, _debugBuildJs.DEBUG_BUILD) && processor.id && result === null && (0, _utils.logger).log(`Event processor "${processor.id}" dropped event`);
            if ((0, _utils.isThenable)(result)) result.then(function(final) {
                return notifyEventProcessors(processors, final, hint, index + 1).then(resolve);
            }).then(null, reject);
            else notifyEventProcessors(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}

},{"@swc/helpers/_/_object_spread":"4bEWH","@sentry/utils":"gElXU","./debug-build.js":"4R9PX","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7FcOX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "closeSession", function() {
    return closeSession;
});
parcelHelpers.export(exports, "makeSession", function() {
    return makeSession;
});
parcelHelpers.export(exports, "updateSession", function() {
    return updateSession;
});
var _utils = require("@sentry/utils");
/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function makeSession(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    var startingTime = (0, _utils.timestampInSeconds)();
    var session = {
        sid: (0, _utils.uuid4)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: 'ok',
        errors: 0,
        ignoreDuration: false,
        toJSON: function() {
            return sessionToJSON(session);
        }
    };
    if (context) updateSession(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function updateSession(session) {
    var context = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, _utils.timestampInSeconds)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, _utils.uuid4)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === 'number') session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === 'number') session.duration = context.duration;
    else {
        var duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === 'number') session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function closeSession(session, status) {
    var context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === 'ok') context = {
        status: 'exited'
    };
    updateSession(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function sessionToJSON(session) {
    return (0, _utils.dropUndefinedKeys)({
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}

},{"@sentry/utils":"gElXU","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"e0xJW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "applyScopeDataToEvent", function() {
    return applyScopeDataToEvent;
});
parcelHelpers.export(exports, "mergeAndOverwriteScopeData", function() {
    return mergeAndOverwriteScopeData;
});
parcelHelpers.export(exports, "mergeScopeData", function() {
    return mergeScopeData;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _utils = require("@sentry/utils");
var _dynamicSamplingContextJs = require("../tracing/dynamicSamplingContext.js");
var _getRootSpanJs = require("./getRootSpan.js");
var _spanUtilsJs = require("./spanUtils.js");
/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function applyScopeDataToEvent(event, data) {
    var fingerprint = data.fingerprint, span = data.span, breadcrumbs = data.breadcrumbs, sdkProcessingMetadata = data.sdkProcessingMetadata;
    // Apply general data
    applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) applySpanToEvent(event, span);
    applyFingerprintToEvent(event, fingerprint);
    applyBreadcrumbsToEvent(event, breadcrumbs);
    applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function mergeScopeData(data, mergeData) {
    var extra = mergeData.extra, tags = mergeData.tags, user = mergeData.user, contexts = mergeData.contexts, level = mergeData.level, sdkProcessingMetadata = mergeData.sdkProcessingMetadata, breadcrumbs = mergeData.breadcrumbs, fingerprint = mergeData.fingerprint, eventProcessors = mergeData.eventProcessors, attachments = mergeData.attachments, propagationContext = mergeData.propagationContext, // eslint-disable-next-line deprecation/deprecation
    transactionName = mergeData.transactionName, span = mergeData.span;
    mergeAndOverwriteScopeData(data, 'extra', extra);
    mergeAndOverwriteScopeData(data, 'tags', tags);
    mergeAndOverwriteScopeData(data, 'user', user);
    mergeAndOverwriteScopeData(data, 'contexts', contexts);
    mergeAndOverwriteScopeData(data, 'sdkProcessingMetadata', sdkProcessingMetadata);
    if (level) data.level = level;
    if (transactionName) // eslint-disable-next-line deprecation/deprecation
    data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = (0, _toConsumableArray._)(data.breadcrumbs).concat((0, _toConsumableArray._)(breadcrumbs));
    if (fingerprint.length) data.fingerprint = (0, _toConsumableArray._)(data.fingerprint).concat((0, _toConsumableArray._)(fingerprint));
    if (eventProcessors.length) data.eventProcessors = (0, _toConsumableArray._)(data.eventProcessors).concat((0, _toConsumableArray._)(eventProcessors));
    if (attachments.length) data.attachments = (0, _toConsumableArray._)(data.attachments).concat((0, _toConsumableArray._)(attachments));
    data.propagationContext = (0, _objectSpread._)({}, data.propagationContext, propagationContext);
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function mergeAndOverwriteScopeData(data, prop, mergeVal) {
    if (mergeVal && Object.keys(mergeVal).length) {
        // Clone object
        data[prop] = (0, _objectSpread._)({}, data[prop]);
        for(var key in mergeVal)if (Object.prototype.hasOwnProperty.call(mergeVal, key)) data[prop][key] = mergeVal[key];
    }
}
function applyDataToEvent(event, data) {
    var extra = data.extra, tags = data.tags, user = data.user, contexts = data.contexts, level = data.level, // eslint-disable-next-line deprecation/deprecation
    transactionName = data.transactionName;
    var cleanedExtra = (0, _utils.dropUndefinedKeys)(extra);
    if (cleanedExtra && Object.keys(cleanedExtra).length) event.extra = (0, _objectSpread._)({}, cleanedExtra, event.extra);
    var cleanedTags = (0, _utils.dropUndefinedKeys)(tags);
    if (cleanedTags && Object.keys(cleanedTags).length) event.tags = (0, _objectSpread._)({}, cleanedTags, event.tags);
    var cleanedUser = (0, _utils.dropUndefinedKeys)(user);
    if (cleanedUser && Object.keys(cleanedUser).length) event.user = (0, _objectSpread._)({}, cleanedUser, event.user);
    var cleanedContexts = (0, _utils.dropUndefinedKeys)(contexts);
    if (cleanedContexts && Object.keys(cleanedContexts).length) event.contexts = (0, _objectSpread._)({}, cleanedContexts, event.contexts);
    if (level) event.level = level;
    if (transactionName) event.transaction = transactionName;
}
function applyBreadcrumbsToEvent(event, breadcrumbs) {
    var mergedBreadcrumbs = (0, _toConsumableArray._)(event.breadcrumbs || []).concat((0, _toConsumableArray._)(breadcrumbs));
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = (0, _objectSpread._)({}, event.sdkProcessingMetadata, sdkProcessingMetadata);
}
function applySpanToEvent(event, span) {
    event.contexts = (0, _objectSpread._)({
        trace: (0, _spanUtilsJs.spanToTraceContext)(span)
    }, event.contexts);
    var rootSpan = (0, _getRootSpanJs.getRootSpan)(span);
    if (rootSpan) {
        event.sdkProcessingMetadata = (0, _objectSpread._)({
            dynamicSamplingContext: (0, _dynamicSamplingContextJs.getDynamicSamplingContextFromSpan)(span)
        }, event.sdkProcessingMetadata);
        var transactionName = (0, _spanUtilsJs.spanToJSON)(rootSpan).description;
        if (transactionName) event.tags = (0, _objectSpread._)({
            transaction: transactionName
        }, event.tags);
    }
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? (0, _utils.arrayify)(event.fingerprint) : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
}

},{"@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_to_consumable_array":"eqNDD","@sentry/utils":"gElXU","../tracing/dynamicSamplingContext.js":"1rgNT","./getRootSpan.js":"3Qg37","./spanUtils.js":"ce0Ij","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1rgNT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDynamicSamplingContextFromClient", function() {
    return getDynamicSamplingContextFromClient;
});
parcelHelpers.export(exports, "getDynamicSamplingContextFromSpan", function() {
    return getDynamicSamplingContextFromSpan;
});
var _utils = require("@sentry/utils");
var _constantsJs = require("../constants.js");
var _exportsJs = require("../exports.js");
var _getRootSpanJs = require("../utils/getRootSpan.js");
var _spanUtilsJs = require("../utils/spanUtils.js");
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function getDynamicSamplingContextFromClient(trace_id, client, scope) {
    var options = client.getOptions();
    var _ref = client.getDsn() || {}, public_key = _ref.publicKey;
    // TODO(v8): Remove segment from User
    // eslint-disable-next-line deprecation/deprecation
    var _ref1 = scope && scope.getUser() || {}, user_segment = _ref1.segment;
    var dsc = (0, _utils.dropUndefinedKeys)({
        environment: options.environment || (0, _constantsJs.DEFAULT_ENVIRONMENT),
        release: options.release,
        user_segment: user_segment,
        public_key: public_key,
        trace_id: trace_id
    });
    client.emit && client.emit('createDsc', dsc);
    return dsc;
}
/**
 * A Span with a frozen dynamic sampling context.
 */ /**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function getDynamicSamplingContextFromSpan(span) {
    var client = (0, _exportsJs.getClient)();
    if (!client) return {};
    // passing emit=false here to only emit later once the DSC is actually populated
    var dsc = getDynamicSamplingContextFromClient((0, _spanUtilsJs.spanToJSON)(span).trace_id || '', client, (0, _exportsJs.getCurrentScope)());
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    var txn = (0, _getRootSpanJs.getRootSpan)(span);
    if (!txn) return dsc;
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    // For now we need to avoid breaking users who directly created a txn with a DSC, where this field is still set.
    // @see Transaction class constructor
    var v7FrozenDsc = txn && txn._frozenDynamicSamplingContext;
    if (v7FrozenDsc) return v7FrozenDsc;
    // TODO (v8): Replace txn.metadata with txn.attributes[]
    // We can't do this yet because attributes aren't always set yet.
    // eslint-disable-next-line deprecation/deprecation
    var _txn_metadata = txn.metadata, maybeSampleRate = _txn_metadata.sampleRate, source = _txn_metadata.source;
    if (maybeSampleRate != null) dsc.sample_rate = `${maybeSampleRate}`;
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    var jsonSpan = (0, _spanUtilsJs.spanToJSON)(txn);
    // after JSON conversion, txn.name becomes jsonSpan.description
    if (source && source !== 'url') dsc.transaction = jsonSpan.description;
    dsc.sampled = String((0, _spanUtilsJs.spanIsSampled)(txn));
    client.emit && client.emit('createDsc', dsc);
    return dsc;
}

},{"@sentry/utils":"gElXU","../constants.js":"1t8zr","../exports.js":"1Khf7","../utils/getRootSpan.js":"3Qg37","../utils/spanUtils.js":"ce0Ij","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1Khf7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addBreadcrumb", function() {
    return addBreadcrumb;
});
parcelHelpers.export(exports, "captureCheckIn", function() {
    return captureCheckIn;
});
parcelHelpers.export(exports, "captureEvent", function() {
    return captureEvent;
});
parcelHelpers.export(exports, "captureException", function() {
    return captureException;
});
parcelHelpers.export(exports, "captureMessage", function() {
    return captureMessage;
});
parcelHelpers.export(exports, "captureSession", function() {
    return captureSession;
});
parcelHelpers.export(exports, "close", function() {
    return close;
});
parcelHelpers.export(exports, "configureScope", function() {
    return configureScope;
});
parcelHelpers.export(exports, "endSession", function() {
    return endSession;
});
parcelHelpers.export(exports, "flush", function() {
    return flush;
});
parcelHelpers.export(exports, "getClient", function() {
    return getClient;
});
parcelHelpers.export(exports, "getCurrentScope", function() {
    return getCurrentScope;
});
parcelHelpers.export(exports, "isInitialized", function() {
    return isInitialized;
});
parcelHelpers.export(exports, "lastEventId", function() {
    return lastEventId;
});
parcelHelpers.export(exports, "setContext", function() {
    return setContext;
});
parcelHelpers.export(exports, "setExtra", function() {
    return setExtra;
});
parcelHelpers.export(exports, "setExtras", function() {
    return setExtras;
});
parcelHelpers.export(exports, "setTag", function() {
    return setTag;
});
parcelHelpers.export(exports, "setTags", function() {
    return setTags;
});
parcelHelpers.export(exports, "setUser", function() {
    return setUser;
});
parcelHelpers.export(exports, "startSession", function() {
    return startSession;
});
parcelHelpers.export(exports, "startTransaction", function() {
    return startTransaction;
});
parcelHelpers.export(exports, "withActiveSpan", function() {
    return withActiveSpan;
});
parcelHelpers.export(exports, "withIsolationScope", function() {
    return withIsolationScope;
});
parcelHelpers.export(exports, "withMonitor", function() {
    return withMonitor;
});
parcelHelpers.export(exports, "withScope", function() {
    return withScope;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _utils = require("@sentry/utils");
var _constantsJs = require("./constants.js");
var _debugBuildJs = require("./debug-build.js");
var _hubJs = require("./hub.js");
var _sessionJs = require("./session.js");
var _prepareEventJs = require("./utils/prepareEvent.js");
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function captureException(// eslint-disable-next-line @typescript-eslint/no-explicit-any
exception, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, _hubJs.getCurrentHub)().captureException(exception, (0, _prepareEventJs.parseEventHintOrCaptureContext)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function captureMessage(message, // eslint-disable-next-line deprecation/deprecation
captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    var level = typeof captureContext === 'string' ? captureContext : undefined;
    var context = typeof captureContext !== 'string' ? {
        captureContext: captureContext
    } : undefined;
    // eslint-disable-next-line deprecation/deprecation
    return (0, _hubJs.getCurrentHub)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param exception The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function captureEvent(event, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, _hubJs.getCurrentHub)().captureEvent(event, hint);
}
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 *
 * @deprecated Use getCurrentScope() directly.
 */ // eslint-disable-next-line deprecation/deprecation
function configureScope(callback) {
    // eslint-disable-next-line deprecation/deprecation
    (0, _hubJs.getCurrentHub)().configureScope(callback);
}
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */ // eslint-disable-next-line deprecation/deprecation
function addBreadcrumb(breadcrumb, hint) {
    // eslint-disable-next-line deprecation/deprecation
    (0, _hubJs.getCurrentHub)().addBreadcrumb(breadcrumb, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, deprecation/deprecation
function setContext(name, context) {
    // eslint-disable-next-line deprecation/deprecation
    (0, _hubJs.getCurrentHub)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function setExtras(extras) {
    // eslint-disable-next-line deprecation/deprecation
    (0, _hubJs.getCurrentHub)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line deprecation/deprecation
function setExtra(key, extra) {
    // eslint-disable-next-line deprecation/deprecation
    (0, _hubJs.getCurrentHub)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function setTags(tags) {
    // eslint-disable-next-line deprecation/deprecation
    (0, _hubJs.getCurrentHub)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ // eslint-disable-next-line deprecation/deprecation
function setTag(key, value) {
    // eslint-disable-next-line deprecation/deprecation
    (0, _hubJs.getCurrentHub)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ // eslint-disable-next-line deprecation/deprecation
function setUser(user) {
    // eslint-disable-next-line deprecation/deprecation
    (0, _hubJs.getCurrentHub)().setUser(user);
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function withScope() {
    for(var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++){
        rest[_key] = arguments[_key];
    }
    // eslint-disable-next-line deprecation/deprecation
    var hub = (0, _hubJs.getCurrentHub)();
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        var _rest = (0, _slicedToArray._)(rest, 2), scope = _rest[0], callback = _rest[1];
        if (!scope) // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(callback);
        // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(function() {
            // eslint-disable-next-line deprecation/deprecation
            hub.getStackTop().scope = scope;
            return callback(scope);
        });
    }
    // eslint-disable-next-line deprecation/deprecation
    return hub.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 *
 * @param callback The callback in which the passed isolation scope is active. (Note: In environments without async
 * context strategy, the currently active isolation scope may change within execution of the callback.)
 * @returns The same value that `callback` returns.
 */ function withIsolationScope(callback) {
    return (0, _hubJs.runWithAsyncContext)(function() {
        return callback((0, _hubJs.getIsolationScope)());
    });
}
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback.
 *
 * @param span Spans started in the context of the provided callback will be children of this span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function withActiveSpan(span, callback) {
    return withScope(function(scope) {
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(span);
        return callback(scope);
    });
}
/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 *
 * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
 */ function startTransaction(context, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, _hubJs.getCurrentHub)().startTransaction((0, _objectSpread._)({}, context), customSamplingContext);
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function captureCheckIn(checkIn, upsertMonitorConfig) {
    var scope = getCurrentScope();
    var client = getClient();
    if (!client) (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn('Cannot capture check-in. No client defined.');
    else if (!client.captureCheckIn) (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn('Cannot capture check-in. Client does not support sending check-ins.');
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, _utils.uuid4)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function withMonitor(monitorSlug, callback, upsertMonitorConfig) {
    var checkInId = captureCheckIn({
        monitorSlug: monitorSlug,
        status: 'in_progress'
    }, upsertMonitorConfig);
    var now = (0, _utils.timestampInSeconds)();
    function finishCheckIn(status) {
        captureCheckIn({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, _utils.timestampInSeconds)() - now
        });
    }
    var maybePromiseResult;
    try {
        maybePromiseResult = callback();
    } catch (e) {
        finishCheckIn('error');
        throw e;
    }
    if ((0, _utils.isThenable)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(function() {
        finishCheckIn('ok');
    }, function() {
        finishCheckIn('error');
    });
    else finishCheckIn('ok');
    return maybePromiseResult;
}
function flush(timeout) {
    return _flush.apply(this, arguments);
}
function _flush() {
    _flush = /**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ (0, _asyncToGenerator._)(function(timeout) {
        var client;
        return (0, _tsGenerator._)(this, function(_state) {
            client = getClient();
            if (client) return [
                2,
                client.flush(timeout)
            ];
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn('Cannot flush events. No client defined.');
            return [
                2,
                Promise.resolve(false)
            ];
        });
    });
    return _flush.apply(this, arguments);
}
function close(timeout) {
    return _close.apply(this, arguments);
}
function _close() {
    _close = /**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ (0, _asyncToGenerator._)(function(timeout) {
        var client;
        return (0, _tsGenerator._)(this, function(_state) {
            client = getClient();
            if (client) return [
                2,
                client.close(timeout)
            ];
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn('Cannot flush events and disable SDK. No client defined.');
            return [
                2,
                Promise.resolve(false)
            ];
        });
    });
    return _close.apply(this, arguments);
}
/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */ function lastEventId() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, _hubJs.getCurrentHub)().lastEventId();
}
/**
 * Get the currently active client.
 */ function getClient() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, _hubJs.getCurrentHub)().getClient();
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function isInitialized() {
    return !!getClient();
}
/**
 * Get the currently active scope.
 */ function getCurrentScope() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, _hubJs.getCurrentHub)().getScope();
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function startSession(context) {
    var client = getClient();
    var isolationScope = (0, _hubJs.getIsolationScope)();
    var currentScope = getCurrentScope();
    var _ref = client && client.getOptions() || {}, release = _ref.release, _ref_environment = _ref.environment, environment = _ref_environment === void 0 ? (0, _constantsJs.DEFAULT_ENVIRONMENT) : _ref_environment;
    // Will fetch userAgent if called from browser sdk
    var userAgent = ((0, _utils.GLOBAL_OBJ).navigator || {}).userAgent;
    var session = (0, _sessionJs.makeSession)((0, _objectSpread._)({
        release: release,
        environment: environment,
        user: currentScope.getUser() || isolationScope.getUser()
    }, userAgent && {
        userAgent: userAgent
    }, context));
    // End existing session if there's one
    var currentSession = isolationScope.getSession();
    if (currentSession && currentSession.status === 'ok') (0, _sessionJs.updateSession)(currentSession, {
        status: 'exited'
    });
    endSession();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function endSession() {
    var isolationScope = (0, _hubJs.getIsolationScope)();
    var currentScope = getCurrentScope();
    var session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, _sessionJs.closeSession)(session);
    _sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function _sendSessionUpdate() {
    var isolationScope = (0, _hubJs.getIsolationScope)();
    var currentScope = getCurrentScope();
    var client = getClient();
    // TODO (v8): Remove currentScope and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    var session = currentScope.getSession() || isolationScope.getSession();
    if (session && client && client.captureSession) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function captureSession() {
    var end = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    // both send the update and pull the session from the scope
    if (end) {
        endSession();
        return;
    }
    // only send the update
    _sendSessionUpdate();
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_sliced_to_array":"ha6sq","@swc/helpers/_/_ts_generator":"f2hGH","@sentry/utils":"gElXU","./constants.js":"1t8zr","./debug-build.js":"4R9PX","./hub.js":"jixbC","./session.js":"7FcOX","./utils/prepareEvent.js":"dVYHl","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"dVYHl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "applyDebugIds", function() {
    return applyDebugIds;
});
parcelHelpers.export(exports, "applyDebugMeta", function() {
    return applyDebugMeta;
});
parcelHelpers.export(exports, "parseEventHintOrCaptureContext", function() {
    return parseEventHintOrCaptureContext;
});
parcelHelpers.export(exports, "prepareEvent", function() {
    return prepareEvent;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _utils = require("@sentry/utils");
var _constantsJs = require("../constants.js");
var _eventProcessorsJs = require("../eventProcessors.js");
var _scopeJs = require("../scope.js");
var _applyScopeDataToEventJs = require("./applyScopeDataToEvent.js");
var _spanUtilsJs = require("./spanUtils.js");
/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * Note: This also triggers callbacks for `addGlobalEventProcessor`, but not `beforeSend`.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function prepareEvent(options, event, hint, scope, client, isolationScope) {
    var _options_normalizeDepth = options.normalizeDepth, normalizeDepth = _options_normalizeDepth === void 0 ? 3 : _options_normalizeDepth, _options_normalizeMaxBreadth = options.normalizeMaxBreadth, normalizeMaxBreadth = _options_normalizeMaxBreadth === void 0 ? 1000 : _options_normalizeMaxBreadth;
    var prepared = (0, _objectSpreadProps._)((0, _objectSpread._)({}, event), {
        event_id: event.event_id || hint.event_id || (0, _utils.uuid4)(),
        timestamp: event.timestamp || (0, _utils.dateTimestampInSeconds)()
    });
    var integrations = hint.integrations || options.integrations.map(function(i) {
        return i.name;
    });
    applyClientOptions(prepared, options);
    applyIntegrationsMetadata(prepared, integrations);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) applyDebugIds(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    var finalScope = getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, _utils.addExceptionMechanism)(prepared, hint.mechanism);
    var clientEventProcessors = client && client.getEventProcessors ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Hub.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    var data = (0, _scopeJs.getGlobalScope)().getScopeData();
    if (isolationScope) {
        var isolationData = isolationScope.getScopeData();
        (0, _applyScopeDataToEventJs.mergeScopeData)(data, isolationData);
    }
    if (finalScope) {
        var finalScopeData = finalScope.getScopeData();
        (0, _applyScopeDataToEventJs.mergeScopeData)(data, finalScopeData);
    }
    var attachments = (0, _toConsumableArray._)(hint.attachments || []).concat((0, _toConsumableArray._)(data.attachments));
    if (attachments.length) hint.attachments = attachments;
    (0, _applyScopeDataToEventJs.applyScopeDataToEvent)(prepared, data);
    // TODO (v8): Update this order to be: Global > Client > Scope
    var eventProcessors = (0, _toConsumableArray._)(clientEventProcessors).concat(// eslint-disable-next-line deprecation/deprecation
    (0, _toConsumableArray._)((0, _eventProcessorsJs.getGlobalEventProcessors)()), // Run scope event processors _after_ all other processors
    (0, _toConsumableArray._)(data.eventProcessors));
    var result = (0, _eventProcessorsJs.notifyEventProcessors)(eventProcessors, prepared, hint);
    return result.then(function(evt) {
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        applyDebugMeta(evt);
        if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 *  Enhances event using the client configuration.
 *  It takes care of all "static" values like environment, release and `dist`,
 *  as well as truncating overly long values.
 * @param event event instance to be enhanced
 */ function applyClientOptions(event, options) {
    var environment = options.environment, release = options.release, dist = options.dist, _options_maxValueLength = options.maxValueLength, maxValueLength = _options_maxValueLength === void 0 ? 250 : _options_maxValueLength;
    if (!('environment' in event)) event.environment = 'environment' in options ? environment : (0, _constantsJs.DEFAULT_ENVIRONMENT);
    if (event.release === undefined && release !== undefined) event.release = release;
    if (event.dist === undefined && dist !== undefined) event.dist = dist;
    if (event.message) event.message = (0, _utils.truncate)(event.message, maxValueLength);
    var exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) exception.value = (0, _utils.truncate)(exception.value, maxValueLength);
    var request = event.request;
    if (request && request.url) request.url = (0, _utils.truncate)(request.url, maxValueLength);
}
var debugIdStackParserCache = new WeakMap();
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function applyDebugIds(event, stackParser) {
    var debugIdMap = (0, _utils.GLOBAL_OBJ)._sentryDebugIds;
    if (!debugIdMap) return;
    var debugIdStackFramesCache;
    var cachedDebugIdStackFrameCache = debugIdStackParserCache.get(stackParser);
    if (cachedDebugIdStackFrameCache) debugIdStackFramesCache = cachedDebugIdStackFrameCache;
    else {
        debugIdStackFramesCache = new Map();
        debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
    }
    // Build a map of filename -> debug_id
    var filenameDebugIdMap = Object.keys(debugIdMap).reduce(function(acc, debugIdStackTrace) {
        var parsedStack;
        var cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
        if (cachedParsedStack) parsedStack = cachedParsedStack;
        else {
            parsedStack = stackParser(debugIdStackTrace);
            debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
        }
        for(var i = parsedStack.length - 1; i >= 0; i--){
            var stackFrame = parsedStack[i];
            if (stackFrame.filename) {
                acc[stackFrame.filename] = debugIdMap[debugIdStackTrace];
                break;
            }
        }
        return acc;
    }, {});
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach(function(exception) {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach(function(frame) {
                if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function applyDebugMeta(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    var filenameDebugIdMap = {};
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach(function(exception) {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach(function(frame) {
                if (frame.debug_id) {
                    if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                    else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                    delete frame.debug_id;
                }
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    var images = event.debug_meta.images;
    Object.keys(filenameDebugIdMap).forEach(function(filename) {
        images.push({
            type: 'sourcemap',
            code_file: filename,
            debug_id: filenameDebugIdMap[filename]
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = (0, _toConsumableArray._)(event.sdk.integrations || []).concat((0, _toConsumableArray._)(integrationNames));
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    var normalized = (0, _objectSpread._)({}, event, event.breadcrumbs && {
        breadcrumbs: event.breadcrumbs.map(function(b) {
            return (0, _objectSpread._)({}, b, b.data && {
                data: (0, _utils.normalize)(b.data, depth, maxBreadth)
            });
        })
    }, event.user && {
        user: (0, _utils.normalize)(event.user, depth, maxBreadth)
    }, event.contexts && {
        contexts: (0, _utils.normalize)(event.contexts, depth, maxBreadth)
    }, event.extra && {
        extra: (0, _utils.normalize)(event.extra, depth, maxBreadth)
    });
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, _utils.normalize)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map(function(span) {
        var data = (0, _spanUtilsJs.spanToJSON)(span).data;
        if (data) // This is a bit weird, as we generally have `Span` instances here, but to be safe we do not assume so
        // eslint-disable-next-line deprecation/deprecation
        span.data = (0, _utils.normalize)(data, depth, maxBreadth);
        return span;
    });
    return normalized;
}
function getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    var finalScope = scope ? scope.clone() : new (0, _scopeJs.Scope)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function parseEventHintOrCaptureContext(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if (hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if (hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function hintIsScopeOrFunction(hint) {
    return hint instanceof (0, _scopeJs.Scope) || typeof hint === 'function';
}
var captureContextKeys = [
    'user',
    'level',
    'extra',
    'contexts',
    'tags',
    'fingerprint',
    'requestSession',
    'propagationContext'
];
function hintIsScopeContext(hint) {
    return Object.keys(hint).some(function(key) {
        return captureContextKeys.includes(key);
    });
}

},{"@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_object_spread_props":"fLCYP","@swc/helpers/_/_to_consumable_array":"eqNDD","@sentry/utils":"gElXU","../constants.js":"1t8zr","../eventProcessors.js":"bSGgA","../scope.js":"kKynH","./applyScopeDataToEvent.js":"e0xJW","./spanUtils.js":"ce0Ij","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"ce0Ij":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TRACE_FLAG_NONE", function() {
    return TRACE_FLAG_NONE;
});
parcelHelpers.export(exports, "TRACE_FLAG_SAMPLED", function() {
    return TRACE_FLAG_SAMPLED;
});
parcelHelpers.export(exports, "spanIsSampled", function() {
    return spanIsSampled;
});
parcelHelpers.export(exports, "spanTimeInputToSeconds", function() {
    return spanTimeInputToSeconds;
});
parcelHelpers.export(exports, "spanToJSON", function() {
    return spanToJSON;
});
parcelHelpers.export(exports, "spanToTraceContext", function() {
    return spanToTraceContext;
});
parcelHelpers.export(exports, "spanToTraceHeader", function() {
    return spanToTraceHeader;
});
var _utils = require("@sentry/utils");
// These are aligned with OpenTelemetry trace flags
var TRACE_FLAG_NONE = 0x0;
var TRACE_FLAG_SAMPLED = 0x1;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 */ function spanToTraceContext(span) {
    var _span_spanContext = span.spanContext(), span_id = _span_spanContext.spanId, trace_id = _span_spanContext.traceId;
    var _spanToJSON = spanToJSON(span), data = _spanToJSON.data, op = _spanToJSON.op, parent_span_id = _spanToJSON.parent_span_id, status = _spanToJSON.status, tags = _spanToJSON.tags, origin = _spanToJSON.origin;
    return (0, _utils.dropUndefinedKeys)({
        data: data,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id,
        status: status,
        tags: tags,
        trace_id: trace_id,
        origin: origin
    });
}
/**
 * Convert a Span to a Sentry trace header.
 */ function spanToTraceHeader(span) {
    var _span_spanContext = span.spanContext(), traceId = _span_spanContext.traceId, spanId = _span_spanContext.spanId;
    var sampled = spanIsSampled(span);
    return (0, _utils.generateSentryTraceHeader)(traceId, spanId, sampled);
}
/**
 * Convert a span time input intp a timestamp in seconds.
 */ function spanTimeInputToSeconds(input) {
    if (typeof input === 'number') return ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return ensureTimestampInSeconds(input.getTime());
    return (0, _utils.timestampInSeconds)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function ensureTimestampInSeconds(timestamp) {
    var isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 * Note that all fields returned here are optional and need to be guarded against.
 *
 * Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
 * This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
 * And `spanToJSON` needs the Span class from `span.ts` to check here.
 * TODO v8: When we remove the deprecated stuff from `span.ts`, we can remove the circular dependency again.
 */ function spanToJSON(span) {
    if (spanIsSpanClass(span)) return span.getSpanJSON();
    // Fallback: We also check for `.toJSON()` here...
    // eslint-disable-next-line deprecation/deprecation
    if (typeof span.toJSON === 'function') // eslint-disable-next-line deprecation/deprecation
    return span.toJSON();
    return {};
}
/**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function spanIsSpanClass(span) {
    return typeof span.getSpanJSON === 'function';
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function spanIsSampled(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    var traceFlags = span.spanContext().traceFlags;
    // eslint-disable-next-line no-bitwise
    return Boolean(traceFlags & TRACE_FLAG_SAMPLED);
}

},{"@sentry/utils":"gElXU","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3Qg37":[function(require,module,exports,__globalThis) {
/**
 * Returns the root span of a given span.
 *
 * As long as we use `Transaction`s internally, the returned root span
 * will be a `Transaction` but be aware that this might change in the future.
 *
 * If the given span has no root span or transaction, `undefined` is returned.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRootSpan", function() {
    return getRootSpan;
});
function getRootSpan(span) {
    // TODO (v8): Remove this check and just return span
    // eslint-disable-next-line deprecation/deprecation
    return span.transaction;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8NqlU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SDK_VERSION", function() {
    return SDK_VERSION;
});
var SDK_VERSION = '7.120.3';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"51uwJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "registerErrorInstrumentation", function() {
    return registerErrorInstrumentation;
});
var _utils = require("@sentry/utils");
var _debugBuildJs = require("../debug-build.js");
var _utilsJs = require("./utils.js");
var errorsInstrumented = false;
/**
 * Configures global error listeners
 */ function registerErrorInstrumentation() {
    if (errorsInstrumented) return;
    errorsInstrumented = true;
    (0, _utils.addGlobalErrorInstrumentationHandler)(errorCallback);
    (0, _utils.addGlobalUnhandledRejectionInstrumentationHandler)(errorCallback);
}
/**
 * If an error or unhandled promise occurs, we mark the active transaction as failed
 */ function errorCallback() {
    // eslint-disable-next-line deprecation/deprecation
    var activeTransaction = (0, _utilsJs.getActiveTransaction)();
    if (activeTransaction) {
        var status = 'internal_error';
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log(`[Tracing] Transaction: ${status} -> Global error occured`);
        activeTransaction.setStatus(status);
    }
}
// The function name will be lost when bundling but we need to be able to identify this listener later to maintain the
// node.js default exit behaviour
errorCallback.tag = 'sentry_tracingErrorCallback';

},{"@sentry/utils":"gElXU","../debug-build.js":"4R9PX","./utils.js":"g76dG","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"g76dG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "stripUrlQueryAndFragment", function() {
    return 0, _utils.stripUrlQueryAndFragment;
});
parcelHelpers.export(exports, "extractTraceparentData", function() {
    return extractTraceparentData;
});
parcelHelpers.export(exports, "getActiveTransaction", function() {
    return getActiveTransaction;
});
var _utils = require("@sentry/utils");
var _hubJs = require("../hub.js");
/**
 * Grabs active transaction off scope.
 *
 * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
 */ // eslint-disable-next-line deprecation/deprecation
function getActiveTransaction(maybeHub) {
    // eslint-disable-next-line deprecation/deprecation
    var hub = maybeHub || (0, _hubJs.getCurrentHub)();
    // eslint-disable-next-line deprecation/deprecation
    var scope = hub.getScope();
    // eslint-disable-next-line deprecation/deprecation
    return scope.getTransaction();
}
/**
 * The `extractTraceparentData` function and `TRACEPARENT_REGEXP` constant used
 * to be declared in this file. It was later moved into `@sentry/utils` as part of a
 * move to remove `@sentry/tracing` dependencies from `@sentry/node` (`extractTraceparentData`
 * is the only tracing function used by `@sentry/node`).
 *
 * These exports are kept here for backwards compatability's sake.
 *
 * See https://github.com/getsentry/sentry-javascript/issues/4642 for more details.
 *
 * @deprecated Import this function from `@sentry/utils` instead
 */ var extractTraceparentData = (0, _utils.extractTraceparentData);

},{"@sentry/utils":"gElXU","../hub.js":"jixbC","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"iX6z1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IdleTransaction", function() {
    return IdleTransaction;
});
parcelHelpers.export(exports, "IdleTransactionSpanRecorder", function() {
    return IdleTransactionSpanRecorder;
});
parcelHelpers.export(exports, "TRACING_DEFAULTS", function() {
    return TRACING_DEFAULTS;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _get = require("@swc/helpers/_/_get");
var _getPrototypeOf = require("@swc/helpers/_/_get_prototype_of");
var _inherits = require("@swc/helpers/_/_inherits");
var _utils = require("@sentry/utils");
var _debugBuildJs = require("../debug-build.js");
var _spanUtilsJs = require("../utils/spanUtils.js");
var _spanJs = require("./span.js");
var _transactionJs = require("./transaction.js");
var TRACING_DEFAULTS = {
    idleTimeout: 1000,
    finalTimeout: 30000,
    heartbeatInterval: 5000
};
var FINISH_REASON_TAG = 'finishReason';
var IDLE_TRANSACTION_FINISH_REASONS = [
    'heartbeatFailed',
    'idleTimeout',
    'documentHidden',
    'finalTimeout',
    'externalFinish',
    'cancelled'
];
/**
 * @inheritDoc
 */ var IdleTransactionSpanRecorder = /*#__PURE__*/ function(SpanRecorder) {
    "use strict";
    (0, _inherits._)(IdleTransactionSpanRecorder, SpanRecorder);
    function IdleTransactionSpanRecorder(_pushActivity, _popActivity, transactionSpanId, maxlen) {
        (0, _classCallCheck._)(this, IdleTransactionSpanRecorder);
        var _this;
        _this = (0, _callSuper._)(this, IdleTransactionSpanRecorder, [
            maxlen
        ]);
        _this._pushActivity = _pushActivity;
        _this._popActivity = _popActivity;
        _this.transactionSpanId = transactionSpanId;
        return _this;
    }
    (0, _createClass._)(IdleTransactionSpanRecorder, [
        {
            /**
   * @inheritDoc
   */ key: "add",
            value: function add(span) {
                // We should make sure we do not push and pop activities for
                // the transaction that this span recorder belongs to.
                if (span.spanContext().spanId !== this.transactionSpanId) {
                    var _this = this;
                    // We patch span.end() to pop an activity after setting an endTimestamp.
                    // eslint-disable-next-line @typescript-eslint/unbound-method
                    var originalEnd = span.end;
                    span.end = function() {
                        for(var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++){
                            rest[_key] = arguments[_key];
                        }
                        _this._popActivity(span.spanContext().spanId);
                        return originalEnd.apply(span, rest);
                    };
                    // We should only push new activities if the span does not have an end timestamp.
                    if ((0, _spanUtilsJs.spanToJSON)(span).timestamp === undefined) this._pushActivity(span.spanContext().spanId);
                }
                (0, _get._)((0, _getPrototypeOf._)(IdleTransactionSpanRecorder.prototype), "add", this).call(this, span);
            }
        }
    ]);
    return IdleTransactionSpanRecorder;
}((0, _spanJs.SpanRecorder));
/**
 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
 * put itself on the scope on creation.
 */ var IdleTransaction = /*#__PURE__*/ function(Transaction) {
    "use strict";
    (0, _inherits._)(IdleTransaction, Transaction);
    function IdleTransaction(transactionContext, // eslint-disable-next-line deprecation/deprecation
    _idleHub) {
        var /**
     * The time to wait in ms until the idle transaction will be finished. This timer is started each time
     * there are no active spans on this transaction.
     */ _idleTimeout = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : TRACING_DEFAULTS.idleTimeout, /**
     * The final value in ms that a transaction cannot exceed
     */ _finalTimeout = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : TRACING_DEFAULTS.finalTimeout, _heartbeatInterval = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : TRACING_DEFAULTS.heartbeatInterval, // Whether or not the transaction should put itself on the scope when it starts and pop itself off when it ends
        _onScope = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false, /**
     * When set to `true`, will disable the idle timeout (`_idleTimeout` option) and heartbeat mechanisms (`_heartbeatInterval`
     * option) until the `sendAutoFinishSignal()` method is called. The final timeout mechanism (`_finalTimeout` option)
     * will not be affected by this option, meaning the transaction will definitely be finished when the final timeout is
     * reached, no matter what this option is configured to.
     *
     * Defaults to `false`.
     */ delayAutoFinishUntilSignal = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : false;
        (0, _classCallCheck._)(this, IdleTransaction);
        var _this;
        _this = (0, _callSuper._)(this, IdleTransaction, [
            transactionContext,
            _idleHub
        ]);
        _this._idleHub = _idleHub;
        _this._idleTimeout = _idleTimeout;
        _this._finalTimeout = _finalTimeout;
        _this._heartbeatInterval = _heartbeatInterval;
        _this._onScope = _onScope;
        _this.activities = {};
        _this._heartbeatCounter = 0;
        _this._finished = false;
        _this._idleTimeoutCanceledPermanently = false;
        _this._beforeFinishCallbacks = [];
        _this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[4];
        _this._autoFinishAllowed = !delayAutoFinishUntilSignal;
        if (_onScope) {
            // We set the transaction here on the scope so error events pick up the trace
            // context and attach it to the error.
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log(`Setting idle transaction on scope. Span ID: ${_this.spanContext().spanId}`);
            // eslint-disable-next-line deprecation/deprecation
            _idleHub.getScope().setSpan(_this);
        }
        if (!delayAutoFinishUntilSignal) _this._restartIdleTimeout();
        setTimeout(function() {
            if (!_this._finished) {
                _this.setStatus('deadline_exceeded');
                _this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[3];
                _this.end();
            }
        }, _this._finalTimeout);
        return _this;
    }
    (0, _createClass._)(IdleTransaction, [
        {
            /** {@inheritDoc} */ key: "end",
            value: function end(endTimestamp) {
                var _this = this;
                var endTimestampInS = (0, _spanUtilsJs.spanTimeInputToSeconds)(endTimestamp);
                this._finished = true;
                this.activities = {};
                // eslint-disable-next-line deprecation/deprecation
                if (this.op === 'ui.action.click') this.setAttribute(FINISH_REASON_TAG, this._finishReason);
                // eslint-disable-next-line deprecation/deprecation
                if (this.spanRecorder) {
                    (0, _debugBuildJs.DEBUG_BUILD) && // eslint-disable-next-line deprecation/deprecation
                    (0, _utils.logger).log('[Tracing] finishing IdleTransaction', new Date(endTimestampInS * 1000).toISOString(), this.op);
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = this._beforeFinishCallbacks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var callback = _step.value;
                            callback(this, endTimestampInS);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    // eslint-disable-next-line deprecation/deprecation
                    this.spanRecorder.spans = this.spanRecorder.spans.filter(function(span) {
                        // If we are dealing with the transaction itself, we just return it
                        if (span.spanContext().spanId === _this.spanContext().spanId) return true;
                        // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
                        if (!(0, _spanUtilsJs.spanToJSON)(span).timestamp) {
                            span.setStatus('cancelled');
                            span.end(endTimestampInS);
                            (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log('[Tracing] cancelling span since transaction ended early', JSON.stringify(span, undefined, 2));
                        }
                        var _spanToJSON = (0, _spanUtilsJs.spanToJSON)(span), startTime = _spanToJSON.start_timestamp, endTime = _spanToJSON.timestamp;
                        var spanStartedBeforeTransactionFinish = startTime && startTime < endTimestampInS;
                        // Add a delta with idle timeout so that we prevent false positives
                        var timeoutWithMarginOfError = (_this._finalTimeout + _this._idleTimeout) / 1000;
                        var spanEndedBeforeFinalTimeout = endTime && startTime && endTime - startTime < timeoutWithMarginOfError;
                        if (0, _debugBuildJs.DEBUG_BUILD) {
                            var stringifiedSpan = JSON.stringify(span, undefined, 2);
                            if (!spanStartedBeforeTransactionFinish) (0, _utils.logger).log('[Tracing] discarding Span since it happened after Transaction was finished', stringifiedSpan);
                            else if (!spanEndedBeforeFinalTimeout) (0, _utils.logger).log('[Tracing] discarding Span since it finished after Transaction final timeout', stringifiedSpan);
                        }
                        return spanStartedBeforeTransactionFinish && spanEndedBeforeFinalTimeout;
                    });
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log('[Tracing] flushing IdleTransaction');
                } else (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log('[Tracing] No active IdleTransaction');
                // if `this._onScope` is `true`, the transaction put itself on the scope when it started
                if (this._onScope) {
                    // eslint-disable-next-line deprecation/deprecation
                    var scope = this._idleHub.getScope();
                    // eslint-disable-next-line deprecation/deprecation
                    if (scope.getTransaction() === this) // eslint-disable-next-line deprecation/deprecation
                    scope.setSpan(undefined);
                }
                return (0, _get._)((0, _getPrototypeOf._)(IdleTransaction.prototype), "end", this).call(this, endTimestamp);
            }
        },
        {
            /**
   * Register a callback function that gets executed before the transaction finishes.
   * Useful for cleanup or if you want to add any additional spans based on current context.
   *
   * This is exposed because users have no other way of running something before an idle transaction
   * finishes.
   */ key: "registerBeforeFinishCallback",
            value: function registerBeforeFinishCallback(callback) {
                this._beforeFinishCallbacks.push(callback);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "initSpanRecorder",
            value: function initSpanRecorder(maxlen) {
                var _this = this;
                // eslint-disable-next-line deprecation/deprecation
                if (!this.spanRecorder) {
                    var pushActivity = function(id) {
                        if (_this._finished) return;
                        _this._pushActivity(id);
                    };
                    var popActivity = function(id) {
                        if (_this._finished) return;
                        _this._popActivity(id);
                    };
                    // eslint-disable-next-line deprecation/deprecation
                    this.spanRecorder = new IdleTransactionSpanRecorder(pushActivity, popActivity, this.spanContext().spanId, maxlen);
                    // Start heartbeat so that transactions do not run forever.
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log('Starting heartbeat');
                    this._pingHeartbeat();
                }
                // eslint-disable-next-line deprecation/deprecation
                this.spanRecorder.add(this);
            }
        },
        {
            /**
   * Cancels the existing idle timeout, if there is one.
   * @param restartOnChildSpanChange Default is `true`.
   *                                 If set to false the transaction will end
   *                                 with the last child span.
   */ key: "cancelIdleTimeout",
            value: function cancelIdleTimeout(endTimestamp) {
                var restartOnChildSpanChange = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
                    restartOnChildSpanChange: true
                }).restartOnChildSpanChange;
                this._idleTimeoutCanceledPermanently = restartOnChildSpanChange === false;
                if (this._idleTimeoutID) {
                    clearTimeout(this._idleTimeoutID);
                    this._idleTimeoutID = undefined;
                    if (Object.keys(this.activities).length === 0 && this._idleTimeoutCanceledPermanently) {
                        this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[5];
                        this.end(endTimestamp);
                    }
                }
            }
        },
        {
            /**
   * Temporary method used to externally set the transaction's `finishReason`
   *
   * ** WARNING**
   * This is for the purpose of experimentation only and will be removed in the near future, do not use!
   *
   * @internal
   *
   */ key: "setFinishReason",
            value: function setFinishReason(reason) {
                this._finishReason = reason;
            }
        },
        {
            /**
   * Permits the IdleTransaction to automatically end itself via the idle timeout and heartbeat mechanisms when the `delayAutoFinishUntilSignal` option was set to `true`.
   */ key: "sendAutoFinishSignal",
            value: function sendAutoFinishSignal() {
                if (!this._autoFinishAllowed) {
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log('[Tracing] Received finish signal for idle transaction.');
                    this._restartIdleTimeout();
                    this._autoFinishAllowed = true;
                }
            }
        },
        {
            /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */ key: "_restartIdleTimeout",
            value: function _restartIdleTimeout(endTimestamp) {
                var _this = this;
                this.cancelIdleTimeout();
                this._idleTimeoutID = setTimeout(function() {
                    if (!_this._finished && Object.keys(_this.activities).length === 0) {
                        _this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[1];
                        _this.end(endTimestamp);
                    }
                }, this._idleTimeout);
            }
        },
        {
            /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */ key: "_pushActivity",
            value: function _pushActivity(spanId) {
                this.cancelIdleTimeout(undefined, {
                    restartOnChildSpanChange: !this._idleTimeoutCanceledPermanently
                });
                (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log(`[Tracing] pushActivity: ${spanId}`);
                this.activities[spanId] = true;
                (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log('[Tracing] new activities count', Object.keys(this.activities).length);
            }
        },
        {
            /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */ key: "_popActivity",
            value: function _popActivity(spanId) {
                if (this.activities[spanId]) {
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log(`[Tracing] popActivity ${spanId}`);
                    // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                    delete this.activities[spanId];
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log('[Tracing] new activities count', Object.keys(this.activities).length);
                }
                if (Object.keys(this.activities).length === 0) {
                    var endTimestamp = (0, _utils.timestampInSeconds)();
                    if (this._idleTimeoutCanceledPermanently) {
                        if (this._autoFinishAllowed) {
                            this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[5];
                            this.end(endTimestamp);
                        }
                    } else // We need to add the timeout here to have the real endtimestamp of the transaction
                    // Remember timestampInSeconds is in seconds, timeout is in ms
                    this._restartIdleTimeout(endTimestamp + this._idleTimeout / 1000);
                }
            }
        },
        {
            /**
   * Checks when entries of this.activities are not changing for 3 beats.
   * If this occurs we finish the transaction.
   */ key: "_beat",
            value: function _beat() {
                // We should not be running heartbeat if the idle transaction is finished.
                if (this._finished) return;
                var heartbeatString = Object.keys(this.activities).join('');
                if (heartbeatString === this._prevHeartbeatString) this._heartbeatCounter++;
                else this._heartbeatCounter = 1;
                this._prevHeartbeatString = heartbeatString;
                if (this._heartbeatCounter >= 3) {
                    if (this._autoFinishAllowed) {
                        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log('[Tracing] Transaction finished because of no change for 3 heart beats');
                        this.setStatus('deadline_exceeded');
                        this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[0];
                        this.end();
                    }
                } else this._pingHeartbeat();
            }
        },
        {
            /**
   * Pings the heartbeat
   */ key: "_pingHeartbeat",
            value: function _pingHeartbeat() {
                var _this = this;
                (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log(`pinging Heartbeat -> current counter: ${this._heartbeatCounter}`);
                setTimeout(function() {
                    _this._beat();
                }, this._heartbeatInterval);
            }
        }
    ]);
    return IdleTransaction;
}((0, _transactionJs.Transaction));

},{"@swc/helpers/_/_call_super":"5oPMc","@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","@swc/helpers/_/_get":"lJChW","@swc/helpers/_/_get_prototype_of":"fF8vn","@swc/helpers/_/_inherits":"j8HRi","@sentry/utils":"gElXU","../debug-build.js":"4R9PX","../utils/spanUtils.js":"ce0Ij","./span.js":"6f6Gg","./transaction.js":"jZqz5","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"lJChW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _get;
});
var _superPropBaseJs = require("./_super_prop_base.js");
function _get(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) _get = Reflect.get;
    else _get = function get(target, property, receiver) {
        var base = (0, _superPropBaseJs._)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return _get(target, property, receiver || target);
}

},{"./_super_prop_base.js":"I6SuA","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"I6SuA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _super_prop_base;
});
var _getPrototypeOfJs = require("./_get_prototype_of.js");
function _super_prop_base(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, _getPrototypeOfJs._)(object);
        if (object === null) break;
    }
    return object;
}

},{"./_get_prototype_of.js":"fF8vn","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6f6Gg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Span", function() {
    return Span;
});
parcelHelpers.export(exports, "SpanRecorder", function() {
    return SpanRecorder;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _utils = require("@sentry/utils");
var _debugBuildJs = require("../debug-build.js");
var _metricSummaryJs = require("../metrics/metric-summary.js");
var _semanticAttributesJs = require("../semanticAttributes.js");
var _getRootSpanJs = require("../utils/getRootSpan.js");
var _spanUtilsJs = require("../utils/spanUtils.js");
var _spanstatusJs = require("./spanstatus.js");
/**
 * Keeps track of finished spans for a given transaction
 * @internal
 * @hideconstructor
 * @hidden
 */ var SpanRecorder = /*#__PURE__*/ function() {
    "use strict";
    function SpanRecorder() {
        var maxlen = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1000;
        (0, _classCallCheck._)(this, SpanRecorder);
        this._maxlen = maxlen;
        this.spans = [];
    }
    (0, _createClass._)(SpanRecorder, [
        {
            /**
   * This is just so that we don't run out of memory while recording a lot
   * of spans. At some point we just stop and flush out the start of the
   * trace tree (i.e.the first n spans with the smallest
   * start_timestamp).
   */ key: "add",
            value: function add(span) {
                if (this.spans.length > this._maxlen) // eslint-disable-next-line deprecation/deprecation
                span.spanRecorder = undefined;
                else this.spans.push(span);
            }
        }
    ]);
    return SpanRecorder;
}();
/**
 * Span contains all data about a span
 */ var Span = /*#__PURE__*/ function() {
    "use strict";
    function Span() {
        var spanContext = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0, _classCallCheck._)(this, Span);
        this._traceId = spanContext.traceId || (0, _utils.uuid4)();
        this._spanId = spanContext.spanId || (0, _utils.uuid4)().substring(16);
        this._startTime = spanContext.startTimestamp || (0, _utils.timestampInSeconds)();
        // eslint-disable-next-line deprecation/deprecation
        this.tags = spanContext.tags ? (0, _objectSpread._)({}, spanContext.tags) : {};
        // eslint-disable-next-line deprecation/deprecation
        this.data = spanContext.data ? (0, _objectSpread._)({}, spanContext.data) : {};
        // eslint-disable-next-line deprecation/deprecation
        this.instrumenter = spanContext.instrumenter || 'sentry';
        this._attributes = {};
        var _obj;
        this.setAttributes((0, _objectSpread._)((_obj = {}, (0, _defineProperty._)(_obj, (0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), spanContext.origin || 'manual'), (0, _defineProperty._)(_obj, (0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_OP), spanContext.op), _obj), spanContext.attributes));
        // eslint-disable-next-line deprecation/deprecation
        this._name = spanContext.name || spanContext.description;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ('sampled' in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.status) this._status = spanContext.status;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        if (spanContext.exclusiveTime !== undefined) this._exclusiveTime = spanContext.exclusiveTime;
        this._measurements = spanContext.measurements ? (0, _objectSpread._)({}, spanContext.measurements) : {};
    }
    (0, _createClass._)(Span, [
        {
            key: "name",
            get: // This rule conflicts with another eslint rule :(
            /* eslint-disable @typescript-eslint/member-ordering */ /**
   * An alias for `description` of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ function get() {
                return this._name || '';
            },
            set: /**
   * Update the name of the span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ function set(name) {
                this.updateName(name);
            }
        },
        {
            key: "description",
            get: /**
   * Get the description of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ function get() {
                return this._name;
            },
            set: /**
   * Get the description of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ function set(description) {
                this._name = description;
            }
        },
        {
            key: "traceId",
            get: /**
   * The ID of the trace.
   * @deprecated Use `spanContext().traceId` instead.
   */ function get() {
                return this._traceId;
            },
            set: /**
   * The ID of the trace.
   * @deprecated You cannot update the traceId of a span after span creation.
   */ function set(traceId) {
                this._traceId = traceId;
            }
        },
        {
            key: "spanId",
            get: /**
   * The ID of the span.
   * @deprecated Use `spanContext().spanId` instead.
   */ function get() {
                return this._spanId;
            },
            set: /**
   * The ID of the span.
   * @deprecated You cannot update the spanId of a span after span creation.
   */ function set(spanId) {
                this._spanId = spanId;
            }
        },
        {
            key: "parentSpanId",
            get: /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON(span).parent_span_id` instead.
   */ function get() {
                return this._parentSpanId;
            },
            set: /**
   * @inheritDoc
   *
   * @deprecated Use `startSpan` functions instead.
   */ function set(string) {
                this._parentSpanId = string;
            }
        },
        {
            key: "sampled",
            get: /**
   * Was this span chosen to be sent as part of the sample?
   * @deprecated Use `isRecording()` instead.
   */ function get() {
                return this._sampled;
            },
            set: /**
   * Was this span chosen to be sent as part of the sample?
   * @deprecated You cannot update the sampling decision of a span after span creation.
   */ function set(sampled) {
                this._sampled = sampled;
            }
        },
        {
            key: "attributes",
            get: /**
   * Attributes for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ function get() {
                return this._attributes;
            },
            set: /**
   * Attributes for the span.
   * @deprecated Use `setAttributes()` instead.
   */ function set(attributes) {
                this._attributes = attributes;
            }
        },
        {
            key: "startTimestamp",
            get: /**
   * Timestamp in seconds (epoch time) indicating when the span started.
   * @deprecated Use `spanToJSON()` instead.
   */ function get() {
                return this._startTime;
            },
            set: /**
   * Timestamp in seconds (epoch time) indicating when the span started.
   * @deprecated In v8, you will not be able to update the span start time after creation.
   */ function set(startTime) {
                this._startTime = startTime;
            }
        },
        {
            key: "endTimestamp",
            get: /**
   * Timestamp in seconds when the span ended.
   * @deprecated Use `spanToJSON()` instead.
   */ function get() {
                return this._endTime;
            },
            set: /**
   * Timestamp in seconds when the span ended.
   * @deprecated Set the end time via `span.end()` instead.
   */ function set(endTime) {
                this._endTime = endTime;
            }
        },
        {
            key: "status",
            get: /**
   * The status of the span.
   *
   * @deprecated Use `spanToJSON().status` instead to get the status.
   */ function get() {
                return this._status;
            },
            set: /**
   * The status of the span.
   *
   * @deprecated Use `.setStatus()` instead to set or update the status.
   */ function set(status) {
                this._status = status;
            }
        },
        {
            key: "op",
            get: /**
   * Operation of the span
   *
   * @deprecated Use `spanToJSON().op` to read the op instead.
   */ function get() {
                return this._attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_OP];
            },
            set: /**
   * Operation of the span
   *
   * @deprecated Use `startSpan()` functions to set or `span.setAttribute(SEMANTIC_ATTRIBUTE_SENTRY_OP, 'op')
   *             to update the span instead.
   */ function set(op) {
                this.setAttribute((0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_OP), op);
            }
        },
        {
            key: "origin",
            get: /**
   * The origin of the span, giving context about what created the span.
   *
   * @deprecated Use `spanToJSON().origin` to read the origin instead.
   */ function get() {
                return this._attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN];
            },
            set: /**
   * The origin of the span, giving context about what created the span.
   *
   * @deprecated Use `startSpan()` functions to set the origin instead.
   */ function set(origin) {
                this.setAttribute((0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), origin);
            }
        },
        {
            /* eslint-enable @typescript-eslint/member-ordering */ /** @inheritdoc */ key: "spanContext",
            value: function spanContext() {
                var _this = this, spanId = _this._spanId, traceId = _this._traceId, sampled = _this._sampled;
                return {
                    spanId: spanId,
                    traceId: traceId,
                    traceFlags: sampled ? (0, _spanUtilsJs.TRACE_FLAG_SAMPLED) : (0, _spanUtilsJs.TRACE_FLAG_NONE)
                };
            }
        },
        {
            /**
   * Creates a new `Span` while setting the current `Span.id` as `parentSpanId`.
   * Also the `sampled` decision will be inherited.
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ key: "startChild",
            value: function startChild(spanContext) {
                var childSpan = new Span((0, _objectSpreadProps._)((0, _objectSpread._)({}, spanContext), {
                    parentSpanId: this._spanId,
                    sampled: this._sampled,
                    traceId: this._traceId
                }));
                // eslint-disable-next-line deprecation/deprecation
                childSpan.spanRecorder = this.spanRecorder;
                // eslint-disable-next-line deprecation/deprecation
                if (childSpan.spanRecorder) // eslint-disable-next-line deprecation/deprecation
                childSpan.spanRecorder.add(childSpan);
                var rootSpan = (0, _getRootSpanJs.getRootSpan)(this);
                // TODO: still set span.transaction here until we have a more permanent solution
                // Probably similarly to the weakmap we hold in node-experimental
                // eslint-disable-next-line deprecation/deprecation
                childSpan.transaction = rootSpan;
                if ((0, _debugBuildJs.DEBUG_BUILD) && rootSpan) {
                    var opStr = spanContext && spanContext.op || '< unknown op >';
                    var nameStr = (0, _spanUtilsJs.spanToJSON)(childSpan).description || '< unknown name >';
                    var idStr = rootSpan.spanContext().spanId;
                    var logMessage = `[Tracing] Starting '${opStr}' span on transaction '${nameStr}' (${idStr}).`;
                    (0, _utils.logger).log(logMessage);
                    this._logMessage = logMessage;
                }
                return childSpan;
            }
        },
        {
            /**
   * Sets the tag attribute on the current span.
   *
   * Can also be used to unset a tag, by passing `undefined`.
   *
   * @param key Tag key
   * @param value Tag value
   * @deprecated Use `setAttribute()` instead.
   */ key: "setTag",
            value: function setTag(key, value) {
                // eslint-disable-next-line deprecation/deprecation
                this.tags = (0, _objectSpreadProps._)((0, _objectSpread._)({}, this.tags), (0, _defineProperty._)({}, key, value));
                return this;
            }
        },
        {
            /**
   * Sets the data attribute on the current span
   * @param key Data key
   * @param value Data value
   * @deprecated Use `setAttribute()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
            key: "setData",
            value: function setData(key, value) {
                // eslint-disable-next-line deprecation/deprecation
                this.data = (0, _objectSpreadProps._)((0, _objectSpread._)({}, this.data), (0, _defineProperty._)({}, key, value));
                return this;
            }
        },
        {
            /** @inheritdoc */ key: "setAttribute",
            value: function setAttribute(key, value) {
                if (value === undefined) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                delete this._attributes[key];
                else this._attributes[key] = value;
            }
        },
        {
            /** @inheritdoc */ key: "setAttributes",
            value: function setAttributes(attributes) {
                var _this = this;
                Object.keys(attributes).forEach(function(key) {
                    return _this.setAttribute(key, attributes[key]);
                });
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "setStatus",
            value: function setStatus(value) {
                this._status = value;
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   * @deprecated Use top-level `setHttpStatus()` instead.
   */ key: "setHttpStatus",
            value: function setHttpStatus(httpStatus) {
                (0, _spanstatusJs.setHttpStatus)(this, httpStatus);
                return this;
            }
        },
        {
            /**
   * @inheritdoc
   *
   * @deprecated Use `.updateName()` instead.
   */ key: "setName",
            value: function setName(name) {
                this.updateName(name);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "updateName",
            value: function updateName(name) {
                this._name = name;
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON(span).status === 'ok'` instead.
   */ key: "isSuccess",
            value: function isSuccess() {
                return this._status === 'ok';
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use `.end()` instead.
   */ key: "finish",
            value: function finish(endTimestamp) {
                return this.end(endTimestamp);
            }
        },
        {
            /** @inheritdoc */ key: "end",
            value: function end(endTimestamp) {
                // If already ended, skip
                if (this._endTime) return;
                var rootSpan = (0, _getRootSpanJs.getRootSpan)(this);
                if ((0, _debugBuildJs.DEBUG_BUILD) && // Don't call this for transactions
                rootSpan && rootSpan.spanContext().spanId !== this._spanId) {
                    var logMessage = this._logMessage;
                    if (logMessage) (0, _utils.logger).log(logMessage.replace('Starting', 'Finishing'));
                }
                this._endTime = (0, _spanUtilsJs.spanTimeInputToSeconds)(endTimestamp);
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use `spanToTraceHeader()` instead.
   */ key: "toTraceparent",
            value: function toTraceparent() {
                return (0, _spanUtilsJs.spanToTraceHeader)(this);
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON()` or access the fields directly instead.
   */ key: "toContext",
            value: function toContext() {
                return (0, _utils.dropUndefinedKeys)({
                    data: this._getData(),
                    description: this._name,
                    endTimestamp: this._endTime,
                    // eslint-disable-next-line deprecation/deprecation
                    op: this.op,
                    parentSpanId: this._parentSpanId,
                    sampled: this._sampled,
                    spanId: this._spanId,
                    startTimestamp: this._startTime,
                    status: this._status,
                    // eslint-disable-next-line deprecation/deprecation
                    tags: this.tags,
                    traceId: this._traceId
                });
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Update the fields directly instead.
   */ key: "updateWithContext",
            value: function updateWithContext(spanContext) {
                // eslint-disable-next-line deprecation/deprecation
                this.data = spanContext.data || {};
                // eslint-disable-next-line deprecation/deprecation
                this._name = spanContext.name || spanContext.description;
                this._endTime = spanContext.endTimestamp;
                // eslint-disable-next-line deprecation/deprecation
                this.op = spanContext.op;
                this._parentSpanId = spanContext.parentSpanId;
                this._sampled = spanContext.sampled;
                this._spanId = spanContext.spanId || this._spanId;
                this._startTime = spanContext.startTimestamp || this._startTime;
                this._status = spanContext.status;
                // eslint-disable-next-line deprecation/deprecation
                this.tags = spanContext.tags || {};
                this._traceId = spanContext.traceId || this._traceId;
                return this;
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use `spanToTraceContext()` util function instead.
   */ key: "getTraceContext",
            value: function getTraceContext() {
                return (0, _spanUtilsJs.spanToTraceContext)(this);
            }
        },
        {
            /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ key: "getSpanJSON",
            value: function getSpanJSON() {
                return (0, _utils.dropUndefinedKeys)({
                    data: this._getData(),
                    description: this._name,
                    op: this._attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_OP],
                    parent_span_id: this._parentSpanId,
                    span_id: this._spanId,
                    start_timestamp: this._startTime,
                    status: this._status,
                    // eslint-disable-next-line deprecation/deprecation
                    tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
                    timestamp: this._endTime,
                    trace_id: this._traceId,
                    origin: this._attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN],
                    _metrics_summary: (0, _metricSummaryJs.getMetricSummaryJsonForSpan)(this),
                    profile_id: this._attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_PROFILE_ID],
                    exclusive_time: this._exclusiveTime,
                    measurements: Object.keys(this._measurements).length > 0 ? this._measurements : undefined
                });
            }
        },
        {
            /** @inheritdoc */ key: "isRecording",
            value: function isRecording() {
                return !this._endTime && !!this._sampled;
            }
        },
        {
            /**
   * Convert the object to JSON.
   * @deprecated Use `spanToJSON(span)` instead.
   */ key: "toJSON",
            value: function toJSON() {
                return this.getSpanJSON();
            }
        },
        {
            /**
   * Get the merged data for this span.
   * For now, this combines `data` and `attributes` together,
   * until eventually we can ingest `attributes` directly.
   */ key: "_getData",
            value: function _getData() {
                // eslint-disable-next-line deprecation/deprecation
                var _this = this, data = _this.data, attributes = _this._attributes;
                var hasData = Object.keys(data).length > 0;
                var hasAttributes = Object.keys(attributes).length > 0;
                if (!hasData && !hasAttributes) return undefined;
                if (hasData && hasAttributes) return (0, _objectSpread._)({}, data, attributes);
                return hasData ? data : attributes;
            }
        }
    ]);
    return Span;
}();

},{"@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","@swc/helpers/_/_define_property":"54Zvk","@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_object_spread_props":"fLCYP","@sentry/utils":"gElXU","../debug-build.js":"4R9PX","../metrics/metric-summary.js":"1EBEa","../semanticAttributes.js":"jJahK","../utils/getRootSpan.js":"3Qg37","../utils/spanUtils.js":"ce0Ij","./spanstatus.js":"N1JbW","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1EBEa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getMetricSummaryJsonForSpan", function() {
    return getMetricSummaryJsonForSpan;
});
parcelHelpers.export(exports, "updateMetricSummaryOnActiveSpan", function() {
    return updateMetricSummaryOnActiveSpan;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _utils = require("@sentry/utils");
var _debugBuildJs = require("../debug-build.js");
var _errorsJs = require("../tracing/errors.js");
var _spanstatusJs = require("../tracing/spanstatus.js");
var _traceJs = require("../tracing/trace.js");
/**
 * key: bucketKey
 * value: [exportKey, MetricSummary]
 */ var SPAN_METRIC_SUMMARY;
function getMetricStorageForSpan(span) {
    return SPAN_METRIC_SUMMARY ? SPAN_METRIC_SUMMARY.get(span) : undefined;
}
/**
 * Fetches the metric summary if it exists for the passed span
 */ function getMetricSummaryJsonForSpan(span) {
    var storage = getMetricStorageForSpan(span);
    if (!storage) return undefined;
    var output = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = storage[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, _slicedToArray._)(_step.value, 2), _step_value_ = (0, _slicedToArray._)(_step_value[1], 2), exportKey = _step_value_[0], summary = _step_value_[1];
            if (!output[exportKey]) output[exportKey] = [];
            output[exportKey].push((0, _utils.dropUndefinedKeys)(summary));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return output;
}
/**
 * Updates the metric summary on the currently active span
 */ function updateMetricSummaryOnActiveSpan(metricType, sanitizedName, value, unit, tags, bucketKey) {
    var span = (0, _traceJs.getActiveSpan)();
    if (span) {
        var storage = getMetricStorageForSpan(span) || new Map();
        var exportKey = `${metricType}:${sanitizedName}@${unit}`;
        var bucketItem = storage.get(bucketKey);
        if (bucketItem) {
            var _bucketItem = (0, _slicedToArray._)(bucketItem, 2), summary = _bucketItem[1];
            storage.set(bucketKey, [
                exportKey,
                {
                    min: Math.min(summary.min, value),
                    max: Math.max(summary.max, value),
                    count: summary.count += 1,
                    sum: summary.sum += value,
                    tags: summary.tags
                }
            ]);
        } else storage.set(bucketKey, [
            exportKey,
            {
                min: value,
                max: value,
                count: 1,
                sum: value,
                tags: tags
            }
        ]);
        if (!SPAN_METRIC_SUMMARY) SPAN_METRIC_SUMMARY = new WeakMap();
        SPAN_METRIC_SUMMARY.set(span, storage);
    }
}

},{"@swc/helpers/_/_sliced_to_array":"ha6sq","@sentry/utils":"gElXU","../debug-build.js":"4R9PX","../tracing/errors.js":"51uwJ","../tracing/spanstatus.js":"N1JbW","../tracing/trace.js":"h9X0g","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"N1JbW":[function(require,module,exports,__globalThis) {
/** The status of an Span.
 *
 * @deprecated Use string literals - if you require type casting, cast to SpanStatusType type
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SpanStatus", function() {
    return SpanStatus;
});
parcelHelpers.export(exports, "getSpanStatusFromHttpCode", function() {
    return getSpanStatusFromHttpCode;
});
parcelHelpers.export(exports, "setHttpStatus", function() {
    return setHttpStatus;
});
parcelHelpers.export(exports, "spanStatusfromHttpCode", function() {
    return spanStatusfromHttpCode;
});
var SpanStatus;
(function(SpanStatus) {
    /** The operation completed successfully. */ var Ok = 'ok';
    SpanStatus["Ok"] = Ok;
    /** Deadline expired before operation could complete. */ var DeadlineExceeded = 'deadline_exceeded';
    SpanStatus["DeadlineExceeded"] = DeadlineExceeded;
    /** 401 Unauthorized (actually does mean unauthenticated according to RFC 7235) */ var Unauthenticated = 'unauthenticated';
    SpanStatus["Unauthenticated"] = Unauthenticated;
    /** 403 Forbidden */ var PermissionDenied = 'permission_denied';
    SpanStatus["PermissionDenied"] = PermissionDenied;
    /** 404 Not Found. Some requested entity (file or directory) was not found. */ var NotFound = 'not_found';
    SpanStatus["NotFound"] = NotFound;
    /** 429 Too Many Requests */ var ResourceExhausted = 'resource_exhausted';
    SpanStatus["ResourceExhausted"] = ResourceExhausted;
    /** Client specified an invalid argument. 4xx. */ var InvalidArgument = 'invalid_argument';
    SpanStatus["InvalidArgument"] = InvalidArgument;
    /** 501 Not Implemented */ var Unimplemented = 'unimplemented';
    SpanStatus["Unimplemented"] = Unimplemented;
    /** 503 Service Unavailable */ var Unavailable = 'unavailable';
    SpanStatus["Unavailable"] = Unavailable;
    /** Other/generic 5xx. */ var InternalError = 'internal_error';
    SpanStatus["InternalError"] = InternalError;
    /** Unknown. Any non-standard HTTP status code. */ var UnknownError = 'unknown_error';
    SpanStatus["UnknownError"] = UnknownError;
    /** The operation was cancelled (typically by the user). */ var Cancelled = 'cancelled';
    SpanStatus["Cancelled"] = Cancelled;
    /** Already exists (409) */ var AlreadyExists = 'already_exists';
    SpanStatus["AlreadyExists"] = AlreadyExists;
    /** Operation was rejected because the system is not in a state required for the operation's */ var FailedPrecondition = 'failed_precondition';
    SpanStatus["FailedPrecondition"] = FailedPrecondition;
    /** The operation was aborted, typically due to a concurrency issue. */ var Aborted = 'aborted';
    SpanStatus["Aborted"] = Aborted;
    /** Operation was attempted past the valid range. */ var OutOfRange = 'out_of_range';
    SpanStatus["OutOfRange"] = OutOfRange;
    /** Unrecoverable data loss or corruption */ var DataLoss = 'data_loss';
    SpanStatus["DataLoss"] = DataLoss;
})(SpanStatus || (SpanStatus = {}));
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ function getSpanStatusFromHttpCode(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return 'ok';
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return 'unauthenticated';
        case 403:
            return 'permission_denied';
        case 404:
            return 'not_found';
        case 409:
            return 'already_exists';
        case 413:
            return 'failed_precondition';
        case 429:
            return 'resource_exhausted';
        default:
            return 'invalid_argument';
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return 'unimplemented';
        case 503:
            return 'unavailable';
        case 504:
            return 'deadline_exceeded';
        default:
            return 'internal_error';
    }
    return 'unknown_error';
}
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @deprecated Use {@link spanStatusFromHttpCode} instead.
 * This export will be removed in v8 as the signature contains a typo.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ var spanStatusfromHttpCode = getSpanStatusFromHttpCode;
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function setHttpStatus(span, httpStatus) {
    // TODO (v8): Remove these calls
    // Relay does not require us to send the status code as a tag
    // For now, just because users might expect it to land as a tag we keep sending it.
    // Same with data.
    // In v8, we replace both, simply with
    // span.setAttribute('http.response.status_code', httpStatus);
    // eslint-disable-next-line deprecation/deprecation
    span.setTag('http.status_code', String(httpStatus));
    // eslint-disable-next-line deprecation/deprecation
    span.setData('http.response.status_code', httpStatus);
    var spanStatus = getSpanStatusFromHttpCode(httpStatus);
    if (spanStatus !== 'unknown_error') span.setStatus(spanStatus);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"h9X0g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "continueTrace", function() {
    return continueTrace;
});
parcelHelpers.export(exports, "getActiveSpan", function() {
    return getActiveSpan;
});
parcelHelpers.export(exports, "getCapturedScopesOnSpan", function() {
    return getCapturedScopesOnSpan;
});
parcelHelpers.export(exports, "startActiveSpan", function() {
    return startActiveSpan;
});
parcelHelpers.export(exports, "startInactiveSpan", function() {
    return startInactiveSpan;
});
parcelHelpers.export(exports, "startSpan", function() {
    return startSpan;
});
parcelHelpers.export(exports, "startSpanManual", function() {
    return startSpanManual;
});
parcelHelpers.export(exports, "trace", function() {
    return trace;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _utils = require("@sentry/utils");
var _debugBuildJs = require("../debug-build.js");
var _hubJs = require("../hub.js");
var _spanUtilsJs = require("../utils/spanUtils.js");
var _errorsJs = require("./errors.js");
var _spanstatusJs = require("./spanstatus.js");
var _dynamicSamplingContextJs = require("./dynamicSamplingContext.js");
var _exportsJs = require("../exports.js");
var _handleCallbackErrorsJs = require("../utils/handleCallbackErrors.js");
var _hasTracingEnabledJs = require("../utils/hasTracingEnabled.js");
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 *
 * This function is meant to be used internally and may break at any time. Use at your own risk.
 *
 * @internal
 * @private
 *
 * @deprecated Use `startSpan` instead.
 */ function trace(context, callback) {
    var // eslint-disable-next-line @typescript-eslint/no-empty-function
    onError = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function() {}, // eslint-disable-next-line @typescript-eslint/no-empty-function
    afterFinish = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : function() {};
    // eslint-disable-next-line deprecation/deprecation
    var hub = (0, _hubJs.getCurrentHub)();
    var scope = (0, _exportsJs.getCurrentScope)();
    // eslint-disable-next-line deprecation/deprecation
    var parentSpan = scope.getSpan();
    var spanContext = normalizeContext(context);
    var activeSpan = createChildSpanOrTransaction(hub, {
        parentSpan: parentSpan,
        spanContext: spanContext,
        forceTransaction: false,
        scope: scope
    });
    // eslint-disable-next-line deprecation/deprecation
    scope.setSpan(activeSpan);
    return (0, _handleCallbackErrorsJs.handleCallbackErrors)(function() {
        return callback(activeSpan);
    }, function(error) {
        activeSpan && activeSpan.setStatus('internal_error');
        onError(error, activeSpan);
    }, function() {
        activeSpan && activeSpan.end();
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(parentSpan);
        afterFinish();
    });
}
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getSpan()`, as long as the function is executed while the scope is active.
 *
 * If you want to create a span that is not set as active, use {@link startInactiveSpan}.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function startSpan(context, callback) {
    var spanContext = normalizeContext(context);
    return (0, _hubJs.runWithAsyncContext)(function() {
        return (0, _exportsJs.withScope)(context.scope, function(scope) {
            // eslint-disable-next-line deprecation/deprecation
            var hub = (0, _hubJs.getCurrentHub)();
            // eslint-disable-next-line deprecation/deprecation
            var parentSpan = scope.getSpan();
            var shouldSkipSpan = context.onlyIfParent && !parentSpan;
            var activeSpan = shouldSkipSpan ? undefined : createChildSpanOrTransaction(hub, {
                parentSpan: parentSpan,
                spanContext: spanContext,
                forceTransaction: context.forceTransaction,
                scope: scope
            });
            return (0, _handleCallbackErrorsJs.handleCallbackErrors)(function() {
                return callback(activeSpan);
            }, function() {
                // Only update the span status if it hasn't been changed yet
                if (activeSpan) {
                    var status = (0, _spanUtilsJs.spanToJSON)(activeSpan).status;
                    if (!status || status === 'ok') activeSpan.setStatus('internal_error');
                }
            }, function() {
                return activeSpan && activeSpan.end();
            });
        });
    });
}
/**
 * @deprecated Use {@link startSpan} instead.
 */ var startActiveSpan = startSpan;
/**
 * Similar to `Sentry.startSpan`. Wraps a function with a transaction/span, but does not finish the span
 * after the function is done automatically. You'll have to call `span.end()` manually.
 *
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function startSpanManual(context, callback) {
    var spanContext = normalizeContext(context);
    return (0, _hubJs.runWithAsyncContext)(function() {
        return (0, _exportsJs.withScope)(context.scope, function(scope) {
            // eslint-disable-next-line deprecation/deprecation
            var hub = (0, _hubJs.getCurrentHub)();
            // eslint-disable-next-line deprecation/deprecation
            var parentSpan = scope.getSpan();
            var shouldSkipSpan = context.onlyIfParent && !parentSpan;
            var activeSpan = shouldSkipSpan ? undefined : createChildSpanOrTransaction(hub, {
                parentSpan: parentSpan,
                spanContext: spanContext,
                forceTransaction: context.forceTransaction,
                scope: scope
            });
            function finishAndSetSpan() {
                activeSpan && activeSpan.end();
            }
            return (0, _handleCallbackErrorsJs.handleCallbackErrors)(function() {
                return callback(activeSpan, finishAndSetSpan);
            }, function() {
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                if (activeSpan && activeSpan.isRecording()) {
                    var status = (0, _spanUtilsJs.spanToJSON)(activeSpan).status;
                    if (!status || status === 'ok') activeSpan.setStatus('internal_error');
                }
            });
        });
    });
}
/**
 * Creates a span. This span is not set as active, so will not get automatic instrumentation spans
 * as children or be able to be accessed via `Sentry.getSpan()`.
 *
 * If you want to create a span that is set as active, use {@link startSpan}.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate` or `tracesSampler`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function startInactiveSpan(context) {
    if (!(0, _hasTracingEnabledJs.hasTracingEnabled)()) return undefined;
    var spanContext = normalizeContext(context);
    // eslint-disable-next-line deprecation/deprecation
    var hub = (0, _hubJs.getCurrentHub)();
    var parentSpan = context.scope ? context.scope.getSpan() : getActiveSpan();
    var shouldSkipSpan = context.onlyIfParent && !parentSpan;
    if (shouldSkipSpan) return undefined;
    var scope = context.scope || (0, _exportsJs.getCurrentScope)();
    // Even though we don't actually want to make this span active on the current scope,
    // we need to make it active on a temporary scope that we use for event processing
    // as otherwise, it won't pick the correct span for the event when processing it
    var temporaryScope = scope.clone();
    return createChildSpanOrTransaction(hub, {
        parentSpan: parentSpan,
        spanContext: spanContext,
        forceTransaction: context.forceTransaction,
        scope: temporaryScope
    });
}
/**
 * Returns the currently active span.
 */ function getActiveSpan() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, _exportsJs.getCurrentScope)().getSpan();
}
var continueTrace = function(param, callback) {
    var sentryTrace = param.sentryTrace, baggage = param.baggage;
    // TODO(v8): Change this function so it doesn't do anything besides setting the propagation context on the current scope:
    /*
    return withScope((scope) => {
      const propagationContext = propagationContextFromHeaders(sentryTrace, baggage);
      scope.setPropagationContext(propagationContext);
      return callback();
    })
  */ var currentScope = (0, _exportsJs.getCurrentScope)();
    // eslint-disable-next-line deprecation/deprecation
    var _tracingContextFromHeaders = (0, _utils.tracingContextFromHeaders)(sentryTrace, baggage), traceparentData = _tracingContextFromHeaders.traceparentData, dynamicSamplingContext = _tracingContextFromHeaders.dynamicSamplingContext, propagationContext = _tracingContextFromHeaders.propagationContext;
    currentScope.setPropagationContext(propagationContext);
    if ((0, _debugBuildJs.DEBUG_BUILD) && traceparentData) (0, _utils.logger).log(`[Tracing] Continuing trace ${traceparentData.traceId}.`);
    var transactionContext = (0, _objectSpreadProps._)((0, _objectSpread._)({}, traceparentData), {
        metadata: (0, _utils.dropUndefinedKeys)({
            dynamicSamplingContext: dynamicSamplingContext
        })
    });
    if (!callback) return transactionContext;
    return (0, _hubJs.runWithAsyncContext)(function() {
        return callback(transactionContext);
    });
};
function createChildSpanOrTransaction(// eslint-disable-next-line deprecation/deprecation
hub, param) {
    var parentSpan = param.parentSpan, spanContext = param.spanContext, forceTransaction = param.forceTransaction, scope = param.scope;
    if (!(0, _hasTracingEnabledJs.hasTracingEnabled)()) return undefined;
    var isolationScope = (0, _hubJs.getIsolationScope)();
    var span;
    if (parentSpan && !forceTransaction) // eslint-disable-next-line deprecation/deprecation
    span = parentSpan.startChild(spanContext);
    else if (parentSpan) {
        // If we forced a transaction but have a parent span, make sure to continue from the parent span, not the scope
        var dsc = (0, _dynamicSamplingContextJs.getDynamicSamplingContextFromSpan)(parentSpan);
        var _parentSpan_spanContext = parentSpan.spanContext(), traceId = _parentSpan_spanContext.traceId, parentSpanId = _parentSpan_spanContext.spanId;
        var sampled = (0, _spanUtilsJs.spanIsSampled)(parentSpan);
        // eslint-disable-next-line deprecation/deprecation
        span = hub.startTransaction((0, _objectSpreadProps._)((0, _objectSpread._)({
            traceId: traceId,
            parentSpanId: parentSpanId,
            parentSampled: sampled
        }, spanContext), {
            metadata: (0, _objectSpread._)({
                dynamicSamplingContext: dsc
            }, spanContext.metadata)
        }));
    } else {
        var _$_object_spread = (0, _objectSpread._)({}, isolationScope.getPropagationContext(), scope.getPropagationContext()), traceId1 = _$_object_spread.traceId, dsc1 = _$_object_spread.dsc, parentSpanId1 = _$_object_spread.parentSpanId, sampled1 = _$_object_spread.sampled;
        // eslint-disable-next-line deprecation/deprecation
        span = hub.startTransaction((0, _objectSpreadProps._)((0, _objectSpread._)({
            traceId: traceId1,
            parentSpanId: parentSpanId1,
            parentSampled: sampled1
        }, spanContext), {
            metadata: (0, _objectSpread._)({
                dynamicSamplingContext: dsc1
            }, spanContext.metadata)
        }));
    }
    // We always set this as active span on the scope
    // In the case of this being an inactive span, we ensure to pass a detached scope in here in the first place
    // But by having this here, we can ensure that the lookup through `getCapturedScopesOnSpan` results in the correct scope & span combo
    // eslint-disable-next-line deprecation/deprecation
    scope.setSpan(span);
    setCapturedScopesOnSpan(span, scope, isolationScope);
    return span;
}
/**
 * This converts StartSpanOptions to TransactionContext.
 * For the most part (for now) we accept the same options,
 * but some of them need to be transformed.
 *
 * Eventually the StartSpanOptions will be more aligned with OpenTelemetry.
 */ function normalizeContext(context) {
    if (context.startTime) {
        var ctx = (0, _objectSpread._)({}, context);
        ctx.startTimestamp = (0, _spanUtilsJs.spanTimeInputToSeconds)(context.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return context;
}
var SCOPE_ON_START_SPAN_FIELD = '_sentryScope';
var ISOLATION_SCOPE_ON_START_SPAN_FIELD = '_sentryIsolationScope';
function setCapturedScopesOnSpan(span, scope, isolationScope) {
    if (span) {
        (0, _utils.addNonEnumerableProperty)(span, ISOLATION_SCOPE_ON_START_SPAN_FIELD, isolationScope);
        (0, _utils.addNonEnumerableProperty)(span, SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 */ function getCapturedScopesOnSpan(span) {
    return {
        scope: span[SCOPE_ON_START_SPAN_FIELD],
        isolationScope: span[ISOLATION_SCOPE_ON_START_SPAN_FIELD]
    };
}

},{"@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_object_spread_props":"fLCYP","@sentry/utils":"gElXU","../debug-build.js":"4R9PX","../hub.js":"jixbC","../utils/spanUtils.js":"ce0Ij","./errors.js":"51uwJ","./spanstatus.js":"N1JbW","./dynamicSamplingContext.js":"1rgNT","../exports.js":"1Khf7","../utils/handleCallbackErrors.js":"6Ui4q","../utils/hasTracingEnabled.js":"f4XrA","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6Ui4q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "handleCallbackErrors", function() {
    return handleCallbackErrors;
});
var _utils = require("@sentry/utils");
/**
 * Wrap a callback function with error handling.
 * If an error is thrown, it will be passed to the `onError` callback and re-thrown.
 *
 * If the return value of the function is a promise, it will be handled with `maybeHandlePromiseRejection`.
 *
 * If an `onFinally` callback is provided, this will be called when the callback has finished
 * - so if it returns a promise, once the promise resolved/rejected,
 * else once the callback has finished executing.
 * The `onFinally` callback will _always_ be called, no matter if an error was thrown or not.
 */ function handleCallbackErrors(fn, onError) {
    var // eslint-disable-next-line @typescript-eslint/no-empty-function
    onFinally = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function() {};
    var maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally);
}
/**
 * Maybe handle a promise rejection.
 * This expects to be given a value that _may_ be a promise, or any other value.
 * If it is a promise, and it rejects, it will call the `onError` callback.
 * Other than this, it will generally return the given value as-is.
 */ function maybeHandlePromiseRejection(value, onError, onFinally) {
    if ((0, _utils.isThenable)(value)) // @ts-expect-error - the isThenable check returns the "wrong" type here
    return value.then(function(res) {
        onFinally();
        return res;
    }, function(e) {
        onError(e);
        onFinally();
        throw e;
    });
    onFinally();
    return value;
}

},{"@sentry/utils":"gElXU","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"f4XrA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasTracingEnabled", function() {
    return hasTracingEnabled;
});
var _exportsJs = require("../exports.js");
// Treeshakable guard to remove all code related to tracing
/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */ function hasTracingEnabled(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === 'boolean' && !__SENTRY_TRACING__) return false;
    var client = (0, _exportsJs.getClient)();
    var options = maybeOptions || client && client.getOptions();
    return !!options && (options.enableTracing || 'tracesSampleRate' in options || 'tracesSampler' in options);
}

},{"../exports.js":"1Khf7","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jJahK":[function(require,module,exports,__globalThis) {
/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_PROFILE_ID", function() {
    return SEMANTIC_ATTRIBUTE_PROFILE_ID;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_OP", function() {
    return SEMANTIC_ATTRIBUTE_SENTRY_OP;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN", function() {
    return SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE", function() {
    return SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE;
});
parcelHelpers.export(exports, "SEMANTIC_ATTRIBUTE_SENTRY_SOURCE", function() {
    return SEMANTIC_ATTRIBUTE_SENTRY_SOURCE;
});
var SEMANTIC_ATTRIBUTE_SENTRY_SOURCE = 'sentry.source';
/**
 * Use this attribute to represent the sample rate used for a span.
 */ var SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE = 'sentry.sample_rate';
/**
 * Use this attribute to represent the operation of a span.
 */ var SEMANTIC_ATTRIBUTE_SENTRY_OP = 'sentry.op';
/**
 * Use this attribute to represent the origin of a span.
 */ var SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN = 'sentry.origin';
/**
 * The id of the profile that this span occured in.
 */ var SEMANTIC_ATTRIBUTE_PROFILE_ID = 'profile_id';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jZqz5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Transaction", function() {
    return Transaction;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _get = require("@swc/helpers/_/_get");
var _getPrototypeOf = require("@swc/helpers/_/_get_prototype_of");
var _inherits = require("@swc/helpers/_/_inherits");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _utils = require("@sentry/utils");
var _debugBuildJs = require("../debug-build.js");
var _hubJs = require("../hub.js");
var _metricSummaryJs = require("../metrics/metric-summary.js");
var _semanticAttributesJs = require("../semanticAttributes.js");
var _spanUtilsJs = require("../utils/spanUtils.js");
var _dynamicSamplingContextJs = require("./dynamicSamplingContext.js");
var _spanJs = require("./span.js");
var _traceJs = require("./trace.js");
/** JSDoc */ var Transaction = /*#__PURE__*/ function(Span) {
    "use strict";
    (0, _inherits._)(Transaction, Span);
    function Transaction(transactionContext, hub) {
        (0, _classCallCheck._)(this, Transaction);
        var _this;
        _this = (0, _callSuper._)(this, Transaction, [
            transactionContext
        ]);
        _this._contexts = {};
        // eslint-disable-next-line deprecation/deprecation
        _this._hub = hub || (0, _hubJs.getCurrentHub)();
        _this._name = transactionContext.name || '';
        _this._metadata = (0, _objectSpread._)({}, transactionContext.metadata);
        _this._trimEnd = transactionContext.trimEnd;
        // this is because transactions are also spans, and spans have a transaction pointer
        // TODO (v8): Replace this with another way to set the root span
        // eslint-disable-next-line deprecation/deprecation
        _this.transaction = _this;
        // If Dynamic Sampling Context is provided during the creation of the transaction, we freeze it as it usually means
        // there is incoming Dynamic Sampling Context. (Either through an incoming request, a baggage meta-tag, or other means)
        var incomingDynamicSamplingContext = _this._metadata.dynamicSamplingContext;
        if (incomingDynamicSamplingContext) // We shallow copy this in case anything writes to the original reference of the passed in `dynamicSamplingContext`
        _this._frozenDynamicSamplingContext = (0, _objectSpread._)({}, incomingDynamicSamplingContext);
        return _this;
    }
    (0, _createClass._)(Transaction, [
        {
            key: "name",
            get: // This sadly conflicts with the getter/setter ordering :(
            /* eslint-disable @typescript-eslint/member-ordering */ /**
   * Getter for `name` property.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ function get() {
                return this._name;
            },
            set: /**
   * Setter for `name` property, which also sets `source` as custom.
   * @deprecated Use `updateName()` and `setMetadata()` instead.
   */ function set(newName) {
                // eslint-disable-next-line deprecation/deprecation
                this.setName(newName);
            }
        },
        {
            key: "metadata",
            get: /**
   * Get the metadata for this transaction.
   * @deprecated Use `spanGetMetadata(transaction)` instead.
   */ function get() {
                // We merge attributes in for backwards compatibility
                return (0, _objectSpread._)({
                    // Defaults
                    // eslint-disable-next-line deprecation/deprecation
                    source: 'custom',
                    spanMetadata: {}
                }, this._metadata, this._attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] && {
                    source: this._attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]
                }, this._attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE] && {
                    sampleRate: this._attributes[0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE]
                });
            },
            set: /**
   * Update the metadata for this transaction.
   * @deprecated Use `spanGetMetadata(transaction)` instead.
   */ function set(metadata) {
                this._metadata = metadata;
            }
        },
        {
            /* eslint-enable @typescript-eslint/member-ordering */ /**
   * Setter for `name` property, which also sets `source` on the metadata.
   *
   * @deprecated Use `.updateName()` and `.setAttribute()` instead.
   */ key: "setName",
            value: function setName(name) {
                var source = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'custom';
                this._name = name;
                this.setAttribute((0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), source);
            }
        },
        {
            /** @inheritdoc */ key: "updateName",
            value: function updateName(name) {
                this._name = name;
                return this;
            }
        },
        {
            /**
   * Attaches SpanRecorder to the span itself
   * @param maxlen maximum number of spans that can be recorded
   */ key: "initSpanRecorder",
            value: function initSpanRecorder() {
                var maxlen = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1000;
                // eslint-disable-next-line deprecation/deprecation
                if (!this.spanRecorder) // eslint-disable-next-line deprecation/deprecation
                this.spanRecorder = new (0, _spanJs.SpanRecorder)(maxlen);
                // eslint-disable-next-line deprecation/deprecation
                this.spanRecorder.add(this);
            }
        },
        {
            /**
   * Set the context of a transaction event.
   * @deprecated Use either `.setAttribute()`, or set the context on the scope before creating the transaction.
   */ key: "setContext",
            value: function setContext(key, context) {
                if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                delete this._contexts[key];
                else this._contexts[key] = context;
            }
        },
        {
            /**
   * @inheritDoc
   *
   * @deprecated Use top-level `setMeasurement()` instead.
   */ key: "setMeasurement",
            value: function setMeasurement(name, value) {
                var unit = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : '';
                this._measurements[name] = {
                    value: value,
                    unit: unit
                };
            }
        },
        {
            /**
   * Store metadata on this transaction.
   * @deprecated Use attributes or store data on the scope instead.
   */ key: "setMetadata",
            value: function setMetadata(newMetadata) {
                this._metadata = (0, _objectSpread._)({}, this._metadata, newMetadata);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "end",
            value: function end(endTimestamp) {
                var timestampInS = (0, _spanUtilsJs.spanTimeInputToSeconds)(endTimestamp);
                var transaction = this._finishTransaction(timestampInS);
                if (!transaction) return undefined;
                // eslint-disable-next-line deprecation/deprecation
                return this._hub.captureEvent(transaction);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "toContext",
            value: function toContext() {
                // eslint-disable-next-line deprecation/deprecation
                var spanContext = (0, _get._)((0, _getPrototypeOf._)(Transaction.prototype), "toContext", this).call(this);
                return (0, _utils.dropUndefinedKeys)((0, _objectSpreadProps._)((0, _objectSpread._)({}, spanContext), {
                    name: this._name,
                    trimEnd: this._trimEnd
                }));
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "updateWithContext",
            value: function updateWithContext(transactionContext) {
                // eslint-disable-next-line deprecation/deprecation
                (0, _get._)((0, _getPrototypeOf._)(Transaction.prototype), "updateWithContext", this).call(this, transactionContext);
                this._name = transactionContext.name || '';
                this._trimEnd = transactionContext.trimEnd;
                return this;
            }
        },
        {
            /**
   * @inheritdoc
   *
   * @experimental
   *
   * @deprecated Use top-level `getDynamicSamplingContextFromSpan` instead.
   */ key: "getDynamicSamplingContext",
            value: function getDynamicSamplingContext() {
                return (0, _dynamicSamplingContextJs.getDynamicSamplingContextFromSpan)(this);
            }
        },
        {
            /**
   * Override the current hub with a new one.
   * Used if you want another hub to finish the transaction.
   *
   * @internal
   */ // eslint-disable-next-line deprecation/deprecation
            key: "setHub",
            value: function setHub(hub) {
                this._hub = hub;
            }
        },
        {
            /**
   * Get the profile id of the transaction.
   */ key: "getProfileId",
            value: function getProfileId() {
                if (this._contexts !== undefined && this._contexts['profile'] !== undefined) return this._contexts['profile'].profile_id;
                return undefined;
            }
        },
        {
            /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ key: "_finishTransaction",
            value: function _finishTransaction(endTimestamp) {
                var _this = this;
                // This transaction is already finished, so we should not flush it again.
                if (this._endTime !== undefined) return undefined;
                if (!this._name) {
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
                    this._name = '<unlabeled transaction>';
                }
                // just sets the end timestamp
                (0, _get._)((0, _getPrototypeOf._)(Transaction.prototype), "end", this).call(this, endTimestamp);
                // eslint-disable-next-line deprecation/deprecation
                var client = this._hub.getClient();
                if (client && client.emit) client.emit('finishTransaction', this);
                if (this._sampled !== true) {
                    // At this point if `sampled !== true` we want to discard the transaction.
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log('[Tracing] Discarding transaction because its trace was not chosen to be sampled.');
                    if (client) client.recordDroppedEvent('sample_rate', 'transaction');
                    return undefined;
                }
                // eslint-disable-next-line deprecation/deprecation
                var finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter(function(span) {
                    return span !== _this && (0, _spanUtilsJs.spanToJSON)(span).timestamp;
                }) : [];
                if (this._trimEnd && finishedSpans.length > 0) {
                    var endTimes = finishedSpans.map(function(span) {
                        return (0, _spanUtilsJs.spanToJSON)(span).timestamp;
                    }).filter(Boolean);
                    this._endTime = endTimes.reduce(function(prev, current) {
                        return prev > current ? prev : current;
                    });
                }
                var _getCapturedScopesOnSpan = (0, _traceJs.getCapturedScopesOnSpan)(this), capturedSpanScope = _getCapturedScopesOnSpan.scope, capturedSpanIsolationScope = _getCapturedScopesOnSpan.isolationScope;
                // eslint-disable-next-line deprecation/deprecation
                var metadata = this.metadata;
                // eslint-disable-next-line deprecation/deprecation
                var source = metadata.source;
                var transaction = (0, _objectSpread._)({
                    contexts: (0, _objectSpreadProps._)((0, _objectSpread._)({}, this._contexts), {
                        // We don't want to override trace context
                        trace: (0, _spanUtilsJs.spanToTraceContext)(this)
                    }),
                    // TODO: Pass spans serialized via `spanToJSON()` here instead in v8.
                    spans: finishedSpans,
                    start_timestamp: this._startTime,
                    // eslint-disable-next-line deprecation/deprecation
                    tags: this.tags,
                    timestamp: this._endTime,
                    transaction: this._name,
                    type: 'transaction',
                    sdkProcessingMetadata: (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, metadata), {
                        capturedSpanScope: capturedSpanScope,
                        capturedSpanIsolationScope: capturedSpanIsolationScope
                    }), (0, _utils.dropUndefinedKeys)({
                        dynamicSamplingContext: (0, _dynamicSamplingContextJs.getDynamicSamplingContextFromSpan)(this)
                    })),
                    _metrics_summary: (0, _metricSummaryJs.getMetricSummaryJsonForSpan)(this)
                }, source && {
                    transaction_info: {
                        source: source
                    }
                });
                var hasMeasurements = Object.keys(this._measurements).length > 0;
                if (hasMeasurements) {
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log('[Measurements] Adding measurements to transaction', JSON.stringify(this._measurements, undefined, 2));
                    transaction.measurements = this._measurements;
                }
                // eslint-disable-next-line deprecation/deprecation
                (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log(`[Tracing] Finishing ${this.op} transaction: ${this._name}.`);
                return transaction;
            }
        }
    ]);
    return Transaction;
}((0, _spanJs.Span));

},{"@swc/helpers/_/_call_super":"5oPMc","@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","@swc/helpers/_/_get":"lJChW","@swc/helpers/_/_get_prototype_of":"fF8vn","@swc/helpers/_/_inherits":"j8HRi","@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_object_spread_props":"fLCYP","@sentry/utils":"gElXU","../debug-build.js":"4R9PX","../hub.js":"jixbC","../metrics/metric-summary.js":"1EBEa","../semanticAttributes.js":"jJahK","../utils/spanUtils.js":"ce0Ij","./dynamicSamplingContext.js":"1rgNT","./span.js":"6f6Gg","./trace.js":"h9X0g","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"kk5So":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isValidSampleRate", function() {
    return isValidSampleRate;
});
parcelHelpers.export(exports, "sampleTransaction", function() {
    return sampleTransaction;
});
var _utils = require("@sentry/utils");
var _debugBuildJs = require("../debug-build.js");
var _semanticAttributesJs = require("../semanticAttributes.js");
var _hasTracingEnabledJs = require("../utils/hasTracingEnabled.js");
var _spanUtilsJs = require("../utils/spanUtils.js");
/**
 * Makes a sampling decision for the given transaction and stores it on the transaction.
 *
 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 *
 * This method muttes the given `transaction` and will set the `sampled` value on it.
 * It returns the same transaction, for convenience.
 */ function sampleTransaction(transaction, options, samplingContext) {
    // nothing to do if tracing is not enabled
    if (!(0, _hasTracingEnabledJs.hasTracingEnabled)(options)) {
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
    // eslint-disable-next-line deprecation/deprecation
    if (transaction.sampled !== undefined) {
        // eslint-disable-next-line deprecation/deprecation
        transaction.setAttribute((0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE), Number(transaction.sampled));
        return transaction;
    }
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` nor `enableTracing` were defined, so one of these should
    // work; prefer the hook if so
    var sampleRate;
    if (typeof options.tracesSampler === 'function') {
        sampleRate = options.tracesSampler(samplingContext);
        transaction.setAttribute((0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE), Number(sampleRate));
    } else if (samplingContext.parentSampled !== undefined) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== 'undefined') {
        sampleRate = options.tracesSampleRate;
        transaction.setAttribute((0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE), Number(sampleRate));
    } else {
        // When `enableTracing === true`, we use a sample rate of 100%
        sampleRate = 1;
        transaction.setAttribute((0, _semanticAttributesJs.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE), sampleRate);
    }
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
    // only valid values are booleans or numbers between 0 and 1.)
    if (!isValidSampleRate(sampleRate)) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn('[Tracing] Discarding transaction because of invalid sample rate.');
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!sampleRate) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === 'function' ? 'tracesSampler returned 0 or false' : 'a negative sampling decision was inherited or tracesSampleRate is set to 0'}`);
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    // eslint-disable-next-line deprecation/deprecation
    transaction.sampled = Math.random() < sampleRate;
    // if we're not going to keep it, we're done
    // eslint-disable-next-line deprecation/deprecation
    if (!transaction.sampled) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
        return transaction;
    }
    (0, _debugBuildJs.DEBUG_BUILD) && // eslint-disable-next-line deprecation/deprecation
    (0, _utils.logger).log(`[Tracing] starting ${transaction.op} transaction - ${(0, _spanUtilsJs.spanToJSON)(transaction).description}`);
    return transaction;
}
/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */ function isValidSampleRate(rate) {
    // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((0, _utils.isNaN)(rate) || !(typeof rate === 'number' || typeof rate === 'boolean')) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn(`[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(rate)} of type ${JSON.stringify(typeof rate)}.`);
        return false;
    }
    // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
    if (rate < 0 || rate > 1) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn(`[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got ${rate}.`);
        return false;
    }
    return true;
}

},{"@sentry/utils":"gElXU","../debug-build.js":"4R9PX","../semanticAttributes.js":"jJahK","../utils/hasTracingEnabled.js":"f4XrA","../utils/spanUtils.js":"ce0Ij","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"a2NVZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setMeasurement", function() {
    return setMeasurement;
});
var _utilsJs = require("./utils.js");
/**
 * Adds a measurement to the current active transaction.
 */ function setMeasurement(name, value, unit) {
    // eslint-disable-next-line deprecation/deprecation
    var transaction = (0, _utilsJs.getActiveTransaction)();
    if (transaction) // eslint-disable-next-line deprecation/deprecation
    transaction.setMeasurement(name, value, unit);
}

},{"./utils.js":"g76dG","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4N3YN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createEventEnvelope", function() {
    return createEventEnvelope;
});
parcelHelpers.export(exports, "createSessionEnvelope", function() {
    return createSessionEnvelope;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _utils = require("@sentry/utils");
/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = (0, _toConsumableArray._)(event.sdk.integrations || []).concat((0, _toConsumableArray._)(sdkInfo.integrations || []));
    event.sdk.packages = (0, _toConsumableArray._)(event.sdk.packages || []).concat((0, _toConsumableArray._)(sdkInfo.packages || []));
    return event;
}
/** Creates an envelope from a Session */ function createSessionEnvelope(session, dsn, metadata, tunnel) {
    var sdkInfo = (0, _utils.getSdkMetadataForEnvelopeHeader)(metadata);
    var envelopeHeaders = (0, _objectSpread._)({
        sent_at: new Date().toISOString()
    }, sdkInfo && {
        sdk: sdkInfo
    }, !!tunnel && dsn && {
        dsn: (0, _utils.dsnToString)(dsn)
    });
    var envelopeItem = 'aggregates' in session ? [
        {
            type: 'sessions'
        },
        session
    ] : [
        {
            type: 'session'
        },
        session.toJSON()
    ];
    return (0, _utils.createEnvelope)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function createEventEnvelope(event, dsn, metadata, tunnel) {
    var sdkInfo = (0, _utils.getSdkMetadataForEnvelopeHeader)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjut a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ var eventType = event.type && event.type !== 'replay_event' ? event.type : 'event';
    enhanceEventWithSdkInfo(event, metadata && metadata.sdk);
    var envelopeHeaders = (0, _utils.createEventEnvelopeHeaders)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    var eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, _utils.createEnvelope)(envelopeHeaders, [
        eventItem
    ]);
}

},{"@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_to_consumable_array":"eqNDD","@sentry/utils":"gElXU","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"ivoF2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SessionFlusher", function() {
    return SessionFlusher;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _utils = require("@sentry/utils");
var _exportsJs = require("./exports.js");
/**
 * @inheritdoc
 */ var SessionFlusher = /*#__PURE__*/ function() {
    "use strict";
    function SessionFlusher(client, attrs) {
        var _this = this;
        (0, _classCallCheck._)(this, SessionFlusher);
        this._client = client;
        this.flushTimeout = 60;
        this._pendingAggregates = {};
        this._isEnabled = true;
        // Call to setInterval, so that flush is called every 60 seconds.
        this._intervalId = setInterval(function() {
            return _this.flush();
        }, this.flushTimeout * 1000);
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        if (this._intervalId.unref) // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        this._intervalId.unref();
        this._sessionAttrs = attrs;
    }
    (0, _createClass._)(SessionFlusher, [
        {
            /** Checks if `pendingAggregates` has entries, and if it does flushes them by calling `sendSession` */ key: "flush",
            value: function flush() {
                var sessionAggregates = this.getSessionAggregates();
                if (sessionAggregates.aggregates.length === 0) return;
                this._pendingAggregates = {};
                this._client.sendSession(sessionAggregates);
            }
        },
        {
            /** Massages the entries in `pendingAggregates` and returns aggregated sessions */ key: "getSessionAggregates",
            value: function getSessionAggregates() {
                var _this = this;
                var aggregates = Object.keys(this._pendingAggregates).map(function(key) {
                    return _this._pendingAggregates[parseInt(key)];
                });
                var sessionAggregates = {
                    attrs: this._sessionAttrs,
                    aggregates: aggregates
                };
                return (0, _utils.dropUndefinedKeys)(sessionAggregates);
            }
        },
        {
            /** JSDoc */ key: "close",
            value: function close() {
                clearInterval(this._intervalId);
                this._isEnabled = false;
                this.flush();
            }
        },
        {
            /**
   * Wrapper function for _incrementSessionStatusCount that checks if the instance of SessionFlusher is enabled then
   * fetches the session status of the request from `Scope.getRequestSession().status` on the scope and passes them to
   * `_incrementSessionStatusCount` along with the start date
   */ key: "incrementSessionStatusCount",
            value: function incrementSessionStatusCount() {
                if (!this._isEnabled) return;
                var scope = (0, _exportsJs.getCurrentScope)();
                var requestSession = scope.getRequestSession();
                if (requestSession && requestSession.status) {
                    this._incrementSessionStatusCount(requestSession.status, new Date());
                    // This is not entirely necessarily but is added as a safe guard to indicate the bounds of a request and so in
                    // case captureRequestSession is called more than once to prevent double count
                    scope.setRequestSession(undefined);
                /* eslint-enable @typescript-eslint/no-unsafe-member-access */ }
            }
        },
        {
            /**
   * Increments status bucket in pendingAggregates buffer (internal state) corresponding to status of
   * the session received
   */ key: "_incrementSessionStatusCount",
            value: function _incrementSessionStatusCount(status, date) {
                // Truncate minutes and seconds on Session Started attribute to have one minute bucket keys
                var sessionStartedTrunc = new Date(date).setSeconds(0, 0);
                this._pendingAggregates[sessionStartedTrunc] = this._pendingAggregates[sessionStartedTrunc] || {};
                // corresponds to aggregated sessions in one specific minute bucket
                // for example, {"started":"2021-03-16T08:00:00.000Z","exited":4, "errored": 1}
                var aggregationCounts = this._pendingAggregates[sessionStartedTrunc];
                if (!aggregationCounts.started) aggregationCounts.started = new Date(sessionStartedTrunc).toISOString();
                switch(status){
                    case 'errored':
                        aggregationCounts.errored = (aggregationCounts.errored || 0) + 1;
                        return aggregationCounts.errored;
                    case 'ok':
                        aggregationCounts.exited = (aggregationCounts.exited || 0) + 1;
                        return aggregationCounts.exited;
                    default:
                        aggregationCounts.crashed = (aggregationCounts.crashed || 0) + 1;
                        return aggregationCounts.crashed;
                }
            }
        }
    ]);
    return SessionFlusher;
}();

},{"@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","@sentry/utils":"gElXU","./exports.js":"1Khf7","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4yCrc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getEnvelopeEndpointWithUrlEncodedAuth", function() {
    return getEnvelopeEndpointWithUrlEncodedAuth;
});
parcelHelpers.export(exports, "getReportDialogEndpoint", function() {
    return getReportDialogEndpoint;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _utils = require("@sentry/utils");
var SENTRY_API_VERSION = '7';
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function getBaseApiEndpoint(dsn) {
    var protocol = dsn.protocol ? `${dsn.protocol}:` : '';
    var port = dsn.port ? `:${dsn.port}` : '';
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ''}/api/`;
}
/** Returns the ingest API endpoint for target. */ function _getIngestEndpoint(dsn) {
    return `${getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function _encodedAuth(dsn, sdkInfo) {
    return (0, _utils.urlEncode)((0, _objectSpread._)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: SENTRY_API_VERSION
    }, sdkInfo && {
        sentry_client: `${sdkInfo.name}/${sdkInfo.version}`
    }));
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function getEnvelopeEndpointWithUrlEncodedAuth(dsn) {
    var // TODO (v8): Remove `tunnelOrOptions` in favor of `options`, and use the substitute code below
    // options: ClientOptions = {} as ClientOptions,
    tunnelOrOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    // TODO (v8): Use this code instead
    // const { tunnel, _metadata = {} } = options;
    // return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, _metadata.sdk)}`;
    var tunnel = typeof tunnelOrOptions === 'string' ? tunnelOrOptions : tunnelOrOptions.tunnel;
    var sdkInfo = typeof tunnelOrOptions === 'string' || !tunnelOrOptions._metadata ? undefined : tunnelOrOptions._metadata.sdk;
    return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function getReportDialogEndpoint(dsnLike, dialogOptions) {
    var dsn = (0, _utils.makeDsn)(dsnLike);
    if (!dsn) return '';
    var endpoint = `${getBaseApiEndpoint(dsn)}embed/error-page/`;
    var encodedOptions = `dsn=${(0, _utils.dsnToString)(dsn)}`;
    for(var key in dialogOptions){
        if (key === 'dsn') continue;
        if (key === 'onClose') continue;
        if (key === 'user') {
            var user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}

},{"@swc/helpers/_/_object_spread":"4bEWH","@sentry/utils":"gElXU","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"j7SLY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BaseClient", function() {
    return BaseClient;
});
parcelHelpers.export(exports, "addEventProcessor", function() {
    return addEventProcessor;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _utils = require("@sentry/utils");
var _apiJs = require("./api.js");
var _debugBuildJs = require("./debug-build.js");
var _envelopeJs = require("./envelope.js");
var _exportsJs = require("./exports.js");
var _hubJs = require("./hub.js");
var _integrationJs = require("./integration.js");
var _envelopeJs1 = require("./metrics/envelope.js");
var _sessionJs = require("./session.js");
var _dynamicSamplingContextJs = require("./tracing/dynamicSamplingContext.js");
var _prepareEventJs = require("./utils/prepareEvent.js");
var ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ var BaseClient = /*#__PURE__*/ function() {
    "use strict";
    function BaseClient(options) {
        (0, _classCallCheck._)(this, BaseClient);
        this._options = options;
        this._integrations = {};
        this._integrationsInitialized = false;
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, _utils.makeDsn)(options.dsn);
        else (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn('No DSN provided, client will not send events.');
        if (this._dsn) {
            var url = (0, _apiJs.getEnvelopeEndpointWithUrlEncodedAuth)(this._dsn, options);
            this._transport = options.transport((0, _objectSpreadProps._)((0, _objectSpread._)({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this)
            }, options.transportOptions), {
                url: url
            }));
        }
    }
    (0, _createClass._)(BaseClient, [
        {
            /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
            key: "captureException",
            value: function captureException(exception, hint, scope) {
                var _this = this;
                // ensure we haven't captured this very object before
                if ((0, _utils.checkOrSetAlreadyCaught)(exception)) {
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log(ALREADY_SEEN_ERROR);
                    return;
                }
                var eventId = hint && hint.event_id;
                this._process(this.eventFromException(exception, hint).then(function(event) {
                    return _this._captureEvent(event, hint, scope);
                }).then(function(result) {
                    eventId = result;
                }));
                return eventId;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "captureMessage",
            value: function captureMessage(message, // eslint-disable-next-line deprecation/deprecation
            level, hint, scope) {
                var _this = this;
                var eventId = hint && hint.event_id;
                var eventMessage = (0, _utils.isParameterizedString)(message) ? message : String(message);
                var promisedEvent = (0, _utils.isPrimitive)(message) ? this.eventFromMessage(eventMessage, level, hint) : this.eventFromException(message, hint);
                this._process(promisedEvent.then(function(event) {
                    return _this._captureEvent(event, hint, scope);
                }).then(function(result) {
                    eventId = result;
                }));
                return eventId;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "captureEvent",
            value: function captureEvent(event, hint, scope) {
                // ensure we haven't captured this very object before
                if (hint && hint.originalException && (0, _utils.checkOrSetAlreadyCaught)(hint.originalException)) {
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log(ALREADY_SEEN_ERROR);
                    return;
                }
                var eventId = hint && hint.event_id;
                var sdkProcessingMetadata = event.sdkProcessingMetadata || {};
                var capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
                this._process(this._captureEvent(event, hint, capturedSpanScope || scope).then(function(result) {
                    eventId = result;
                }));
                return eventId;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "captureSession",
            value: function captureSession(session) {
                if (!(typeof session.release === 'string')) (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn('Discarded session because of missing or non-string release');
                else {
                    this.sendSession(session);
                    // After sending, we set init false to indicate it's not the first occurrence
                    (0, _sessionJs.updateSession)(session, {
                        init: false
                    });
                }
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "getDsn",
            value: function getDsn() {
                return this._dsn;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "getOptions",
            value: function getOptions() {
                return this._options;
            }
        },
        {
            /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */ key: "getSdkMetadata",
            value: function getSdkMetadata() {
                return this._options._metadata;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "getTransport",
            value: function getTransport() {
                return this._transport;
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "flush",
            value: function flush(timeout) {
                var transport = this._transport;
                if (transport) {
                    if (this.metricsAggregator) this.metricsAggregator.flush();
                    return this._isClientDoneProcessing(timeout).then(function(clientFinished) {
                        return transport.flush(timeout).then(function(transportFlushed) {
                            return clientFinished && transportFlushed;
                        });
                    });
                } else return (0, _utils.resolvedSyncPromise)(true);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "close",
            value: function close(timeout) {
                var _this = this;
                return this.flush(timeout).then(function(result) {
                    _this.getOptions().enabled = false;
                    if (_this.metricsAggregator) _this.metricsAggregator.close();
                    return result;
                });
            }
        },
        {
            /** Get all installed event processors. */ key: "getEventProcessors",
            value: function getEventProcessors() {
                return this._eventProcessors;
            }
        },
        {
            /** @inheritDoc */ key: "addEventProcessor",
            value: function addEventProcessor(eventProcessor) {
                this._eventProcessors.push(eventProcessor);
            }
        },
        {
            /**
   * This is an internal function to setup all integrations that should run on the client.
   * @deprecated Use `client.init()` instead.
   */ key: "setupIntegrations",
            value: function setupIntegrations(forceInitialize) {
                if (forceInitialize && !this._integrationsInitialized || this._isEnabled() && !this._integrationsInitialized) this._setupIntegrations();
            }
        },
        {
            /** @inheritdoc */ key: "init",
            value: function init() {
                if (this._isEnabled()) this._setupIntegrations();
            }
        },
        {
            /**
   * Gets an installed integration by its `id`.
   *
   * @returns The installed integration or `undefined` if no integration with that `id` was installed.
   * @deprecated Use `getIntegrationByName()` instead.
   */ key: "getIntegrationById",
            value: function getIntegrationById(integrationId) {
                return this.getIntegrationByName(integrationId);
            }
        },
        {
            /**
   * Gets an installed integration by its name.
   *
   * @returns The installed integration or `undefined` if no integration with that `name` was installed.
   */ key: "getIntegrationByName",
            value: function getIntegrationByName(integrationName) {
                return this._integrations[integrationName];
            }
        },
        {
            /**
   * Returns the client's instance of the given integration class, it any.
   * @deprecated Use `getIntegrationByName()` instead.
   */ key: "getIntegration",
            value: function getIntegration(integration) {
                try {
                    return this._integrations[integration.id] || null;
                } catch (_oO) {
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn(`Cannot retrieve integration ${integration.id} from the current Client`);
                    return null;
                }
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "addIntegration",
            value: function addIntegration(integration) {
                var isAlreadyInstalled = this._integrations[integration.name];
                // This hook takes care of only installing if not already installed
                (0, _integrationJs.setupIntegration)(this, integration, this._integrations);
                // Here we need to check manually to make sure to not run this multiple times
                if (!isAlreadyInstalled) (0, _integrationJs.afterSetupIntegrations)(this, [
                    integration
                ]);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "sendEvent",
            value: function sendEvent(event) {
                var _this = this;
                var hint = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                this.emit('beforeSendEvent', event, hint);
                var env = (0, _envelopeJs.createEventEnvelope)(event, this._dsn, this._options._metadata, this._options.tunnel);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = (hint.attachments || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var attachment = _step.value;
                        env = (0, _utils.addItemToEnvelope)(env, (0, _utils.createAttachmentEnvelopeItem)(attachment, this._options.transportOptions && this._options.transportOptions.textEncoder));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var promise = this._sendEnvelope(env);
                if (promise) promise.then(function(sendResponse) {
                    return _this.emit('afterSendEvent', event, sendResponse);
                }, null);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "sendSession",
            value: function sendSession(session) {
                var env = (0, _envelopeJs.createSessionEnvelope)(session, this._dsn, this._options._metadata, this._options.tunnel);
                // _sendEnvelope should not throw
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this._sendEnvelope(env);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "recordDroppedEvent",
            value: function recordDroppedEvent(reason, category, eventOrCount) {
                if (this._options.sendClientReports) {
                    // TODO v9: We do not need the `event` passed as third argument anymore, and can possibly remove this overload
                    // If event is passed as third argument, we assume this is a count of 1
                    var count = typeof eventOrCount === 'number' ? eventOrCount : 1;
                    // We want to track each category (error, transaction, session, replay_event) separately
                    // but still keep the distinction between different type of outcomes.
                    // We could use nested maps, but it's much easier to read and type this way.
                    // A correct type for map-based implementation if we want to go that route
                    // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
                    // With typescript 4.1 we could even use template literal types
                    var key = `${reason}:${category}`;
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ''}`);
                    this._outcomes[key] = (this._outcomes[key] || 0) + count;
                }
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "captureAggregateMetrics",
            value: function captureAggregateMetrics(metricBucketItems) {
                (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log(`Flushing aggregated metrics, number of metrics: ${metricBucketItems.length}`);
                var metricsEnvelope = (0, _envelopeJs1.createMetricEnvelope)(metricBucketItems, this._dsn, this._options._metadata, this._options.tunnel);
                // _sendEnvelope should not throw
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this._sendEnvelope(metricsEnvelope);
            }
        },
        {
            // Keep on() & emit() signatures in sync with types' client.ts interface
            /* eslint-disable @typescript-eslint/unified-signatures */ /** @inheritdoc */ /** @inheritdoc */ key: "on",
            value: function on(hook, callback) {
                if (!this._hooks[hook]) this._hooks[hook] = [];
                // @ts-expect-error We assue the types are correct
                this._hooks[hook].push(callback);
            }
        },
        {
            /** @inheritdoc */ /** @inheritdoc */ key: "emit",
            value: function emit(hook) {
                for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    rest[_key - 1] = arguments[_key];
                }
                if (this._hooks[hook]) this._hooks[hook].forEach(function(callback) {
                    return callback.apply(void 0, (0, _toConsumableArray._)(rest));
                });
            }
        },
        {
            /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ key: "_setupIntegrations",
            value: function _setupIntegrations() {
                var integrations = this._options.integrations;
                this._integrations = (0, _integrationJs.setupIntegrations)(this, integrations);
                (0, _integrationJs.afterSetupIntegrations)(this, integrations);
                // TODO v8: We don't need this flag anymore
                this._integrationsInitialized = true;
            }
        },
        {
            /** Updates existing session based on the provided event */ key: "_updateSessionFromEvent",
            value: function _updateSessionFromEvent(session, event) {
                var crashed = false;
                var errored = false;
                var exceptions = event.exception && event.exception.values;
                if (exceptions) {
                    errored = true;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = exceptions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var ex = _step.value;
                            var mechanism = ex.mechanism;
                            if (mechanism && mechanism.handled === false) {
                                crashed = true;
                                break;
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
                // A session is updated and that session update is sent in only one of the two following scenarios:
                // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
                // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
                var sessionNonTerminal = session.status === 'ok';
                var shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
                if (shouldUpdateAndSend) {
                    (0, _sessionJs.updateSession)(session, (0, _objectSpreadProps._)((0, _objectSpread._)({}, crashed && {
                        status: 'crashed'
                    }), {
                        errors: session.errors || Number(errored || crashed)
                    }));
                    this.captureSession(session);
                }
            }
        },
        {
            /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ key: "_isClientDoneProcessing",
            value: function _isClientDoneProcessing(timeout) {
                var _this = this;
                return new (0, _utils.SyncPromise)(function(resolve) {
                    var ticked = 0;
                    var tick = 1;
                    var interval = setInterval(function() {
                        if (_this._numProcessing == 0) {
                            clearInterval(interval);
                            resolve(true);
                        } else {
                            ticked += tick;
                            if (timeout && ticked >= timeout) {
                                clearInterval(interval);
                                resolve(false);
                            }
                        }
                    }, tick);
                });
            }
        },
        {
            /** Determines whether this SDK is enabled and a transport is present. */ key: "_isEnabled",
            value: function _isEnabled() {
                return this.getOptions().enabled !== false && this._transport !== undefined;
            }
        },
        {
            /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */ key: "_prepareEvent",
            value: function _prepareEvent(event, hint, scope) {
                var _this = this;
                var isolationScope = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : (0, _hubJs.getIsolationScope)();
                var options = this.getOptions();
                var integrations = Object.keys(this._integrations);
                if (!hint.integrations && integrations.length > 0) hint.integrations = integrations;
                this.emit('preprocessEvent', event, hint);
                return (0, _prepareEventJs.prepareEvent)(options, event, hint, scope, this, isolationScope).then(function(evt) {
                    if (evt === null) return evt;
                    var propagationContext = (0, _objectSpread._)({}, isolationScope.getPropagationContext(), scope ? scope.getPropagationContext() : undefined);
                    var trace = evt.contexts && evt.contexts.trace;
                    if (!trace && propagationContext) {
                        var trace_id = propagationContext.traceId, spanId = propagationContext.spanId, parentSpanId = propagationContext.parentSpanId, dsc = propagationContext.dsc;
                        evt.contexts = (0, _objectSpread._)({
                            trace: {
                                trace_id: trace_id,
                                span_id: spanId,
                                parent_span_id: parentSpanId
                            }
                        }, evt.contexts);
                        var dynamicSamplingContext = dsc ? dsc : (0, _dynamicSamplingContextJs.getDynamicSamplingContextFromClient)(trace_id, _this, scope);
                        evt.sdkProcessingMetadata = (0, _objectSpread._)({
                            dynamicSamplingContext: dynamicSamplingContext
                        }, evt.sdkProcessingMetadata);
                    }
                    return evt;
                });
            }
        },
        {
            /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ key: "_captureEvent",
            value: function _captureEvent(event) {
                var hint = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, scope = arguments.length > 2 ? arguments[2] : void 0;
                return this._processEvent(event, hint, scope).then(function(finalEvent) {
                    return finalEvent.event_id;
                }, function(reason) {
                    if (0, _debugBuildJs.DEBUG_BUILD) {
                        // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
                        // control flow, log just the message (no stack) as a log-level log.
                        var sentryError = reason;
                        if (sentryError.logLevel === 'log') (0, _utils.logger).log(sentryError.message);
                        else (0, _utils.logger).warn(sentryError);
                    }
                    return undefined;
                });
            }
        },
        {
            /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ key: "_processEvent",
            value: function _processEvent(event, hint, scope) {
                var _this = this;
                var options = this.getOptions();
                var sampleRate = options.sampleRate;
                var isTransaction = isTransactionEvent(event);
                var isError = isErrorEvent(event);
                var eventType = event.type || 'error';
                var beforeSendLabel = `before send for type \`${eventType}\``;
                // 1.0 === 100% events are sent
                // 0.0 === 0% events are sent
                // Sampling for transaction happens somewhere else
                if (isError && typeof sampleRate === 'number' && Math.random() > sampleRate) {
                    this.recordDroppedEvent('sample_rate', 'error', event);
                    return (0, _utils.rejectedSyncPromise)(new (0, _utils.SentryError)(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`, 'log'));
                }
                var dataCategory = eventType === 'replay_event' ? 'replay' : eventType;
                var sdkProcessingMetadata = event.sdkProcessingMetadata || {};
                var capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
                return this._prepareEvent(event, hint, scope, capturedSpanIsolationScope).then(function(prepared) {
                    if (prepared === null) {
                        _this.recordDroppedEvent('event_processor', dataCategory, event);
                        throw new (0, _utils.SentryError)('An event processor returned `null`, will not send event.', 'log');
                    }
                    var isInternalException = hint.data && hint.data.__sentry__ === true;
                    if (isInternalException) return prepared;
                    var result = processBeforeSend(options, prepared, hint);
                    return _validateBeforeSendResult(result, beforeSendLabel);
                }).then(function(processedEvent) {
                    if (processedEvent === null) {
                        _this.recordDroppedEvent('before_send', dataCategory, event);
                        if (isTransaction) {
                            var spans = event.spans || [];
                            // the transaction itself counts as one span, plus all the child spans that are added
                            var spanCount = 1 + spans.length;
                            _this.recordDroppedEvent('before_send', 'span', spanCount);
                        }
                        throw new (0, _utils.SentryError)(`${beforeSendLabel} returned \`null\`, will not send event.`, 'log');
                    }
                    var session = scope && scope.getSession();
                    if (!isTransaction && session) _this._updateSessionFromEvent(session, processedEvent);
                    if (isTransaction) {
                        var spanCountBefore = processedEvent.sdkProcessingMetadata && processedEvent.sdkProcessingMetadata.spanCountBeforeProcessing || 0;
                        var spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                        var droppedSpanCount = spanCountBefore - spanCountAfter;
                        if (droppedSpanCount > 0) _this.recordDroppedEvent('before_send', 'span', droppedSpanCount);
                    }
                    // None of the Sentry built event processor will update transaction name,
                    // so if the transaction name has been changed by an event processor, we know
                    // it has to come from custom event processor added by a user
                    var transactionInfo = processedEvent.transaction_info;
                    if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                        var source = 'custom';
                        processedEvent.transaction_info = (0, _objectSpreadProps._)((0, _objectSpread._)({}, transactionInfo), {
                            source: source
                        });
                    }
                    _this.sendEvent(processedEvent, hint);
                    return processedEvent;
                }).then(null, function(reason) {
                    if (reason instanceof (0, _utils.SentryError)) throw reason;
                    _this.captureException(reason, {
                        data: {
                            __sentry__: true
                        },
                        originalException: reason
                    });
                    throw new (0, _utils.SentryError)(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
                });
            }
        },
        {
            /**
   * Occupies the client with processing and event
   */ key: "_process",
            value: function _process(promise) {
                var _this = this;
                this._numProcessing++;
                promise.then(function(value) {
                    _this._numProcessing--;
                    return value;
                }, function(reason) {
                    _this._numProcessing--;
                    return reason;
                });
            }
        },
        {
            /**
   * @inheritdoc
   */ key: "_sendEnvelope",
            value: function _sendEnvelope(envelope) {
                this.emit('beforeEnvelope', envelope);
                if (this._isEnabled() && this._transport) return this._transport.send(envelope).then(null, function(reason) {
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).error('Error while sending event:', reason);
                });
                else (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).error('Transport disabled');
            }
        },
        {
            /**
   * Clears outcomes on this client and returns them.
   */ key: "_clearOutcomes",
            value: function _clearOutcomes() {
                var outcomes = this._outcomes;
                this._outcomes = {};
                return Object.keys(outcomes).map(function(key) {
                    var _key_split = (0, _slicedToArray._)(key.split(':'), 2), reason = _key_split[0], category = _key_split[1];
                    return {
                        reason: reason,
                        category: category,
                        quantity: outcomes[key]
                    };
                });
            }
        }
    ]);
    return BaseClient;
}();
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function _validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    var invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, _utils.isThenable)(beforeSendResult)) return beforeSendResult.then(function(event) {
        if (!(0, _utils.isPlainObject)(event) && event !== null) throw new (0, _utils.SentryError)(invalidValueError);
        return event;
    }, function(e) {
        throw new (0, _utils.SentryError)(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, _utils.isPlainObject)(beforeSendResult) && beforeSendResult !== null) throw new (0, _utils.SentryError)(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function processBeforeSend(options, event, hint) {
    var beforeSend = options.beforeSend, beforeSendTransaction = options.beforeSendTransaction;
    if (isErrorEvent(event) && beforeSend) return beforeSend(event, hint);
    if (isTransactionEvent(event) && beforeSendTransaction) {
        if (event.spans) {
            // We store the # of spans before processing in SDK metadata,
            // so we can compare it afterwards to determine how many spans were dropped
            var spanCountBefore = event.spans.length;
            event.sdkProcessingMetadata = (0, _objectSpreadProps._)((0, _objectSpread._)({}, event.sdkProcessingMetadata), {
                spanCountBeforeProcessing: spanCountBefore
            });
        }
        return beforeSendTransaction(event, hint);
    }
    return event;
}
function isErrorEvent(event) {
    return event.type === undefined;
}
function isTransactionEvent(event) {
    return event.type === 'transaction';
}
/**
 * Add an event processor to the current client.
 * This event processor will run for all events processed by this client.
 */ function addEventProcessor(callback) {
    var client = (0, _exportsJs.getClient)();
    if (!client || !client.addEventProcessor) return;
    client.addEventProcessor(callback);
}

},{"@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_object_spread_props":"fLCYP","@swc/helpers/_/_sliced_to_array":"ha6sq","@swc/helpers/_/_to_consumable_array":"eqNDD","@sentry/utils":"gElXU","./api.js":"4yCrc","./debug-build.js":"4R9PX","./envelope.js":"4N3YN","./exports.js":"1Khf7","./hub.js":"jixbC","./integration.js":"dKOes","./metrics/envelope.js":"lmccH","./session.js":"7FcOX","./tracing/dynamicSamplingContext.js":"1rgNT","./utils/prepareEvent.js":"dVYHl","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"dKOes":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addIntegration", function() {
    return addIntegration;
});
parcelHelpers.export(exports, "afterSetupIntegrations", function() {
    return afterSetupIntegrations;
});
parcelHelpers.export(exports, "convertIntegrationFnToClass", function() {
    return convertIntegrationFnToClass;
});
parcelHelpers.export(exports, "defineIntegration", function() {
    return defineIntegration;
});
parcelHelpers.export(exports, "getIntegrationsToSetup", function() {
    return getIntegrationsToSetup;
});
parcelHelpers.export(exports, "installedIntegrations", function() {
    return installedIntegrations;
});
parcelHelpers.export(exports, "setupIntegration", function() {
    return setupIntegration;
});
parcelHelpers.export(exports, "setupIntegrations", function() {
    return setupIntegrations;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _utils = require("@sentry/utils");
var _debugBuildJs = require("./debug-build.js");
var _eventProcessorsJs = require("./eventProcessors.js");
var _exportsJs = require("./exports.js");
var _hubJs = require("./hub.js");
var installedIntegrations = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preseve the order of integrations in the array.
 *
 * @private
 */ function filterDuplicates(integrations) {
    var integrationsByName = {};
    integrations.forEach(function(currentInstance) {
        var name = currentInstance.name;
        var existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.keys(integrationsByName).map(function(k) {
        return integrationsByName[k];
    });
}
/** Gets integrations to install */ function getIntegrationsToSetup(options) {
    var defaultIntegrations = options.defaultIntegrations || [];
    var userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach(function(integration) {
        integration.isDefaultInstance = true;
    });
    var integrations;
    if (Array.isArray(userIntegrations)) integrations = (0, _toConsumableArray._)(defaultIntegrations).concat((0, _toConsumableArray._)(userIntegrations));
    else if (typeof userIntegrations === 'function') integrations = (0, _utils.arrayify)(userIntegrations(defaultIntegrations));
    else integrations = defaultIntegrations;
    var finalIntegrations = filterDuplicates(integrations);
    // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
    // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
    // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
    // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
    var debugIndex = findIndex(finalIntegrations, function(integration) {
        return integration.name === 'Debug';
    });
    if (debugIndex !== -1) {
        var _finalIntegrations_splice = (0, _slicedToArray._)(finalIntegrations.splice(debugIndex, 1), 1), debugInstance = _finalIntegrations_splice[0];
        finalIntegrations.push(debugInstance);
    }
    return finalIntegrations;
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function setupIntegrations(client, integrations) {
    var integrationIndex = {};
    integrations.forEach(function(integration) {
        // guard against empty provided integrations
        if (integration) setupIntegration(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function afterSetupIntegrations(client, integrations) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = integrations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var integration = _step.value;
            // guard against empty provided integrations
            if (integration && integration.afterAllSetup) integration.afterAllSetup(client);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
/** Setup a single integration.  */ function setupIntegration(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if (installedIntegrations.indexOf(integration.name) === -1) {
        // eslint-disable-next-line deprecation/deprecation
        integration.setupOnce((0, _eventProcessorsJs.addGlobalEventProcessor), (0, _hubJs.getCurrentHub));
        installedIntegrations.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === 'function') integration.setup(client);
    if (client.on && typeof integration.preprocessEvent === 'function') {
        var callback = integration.preprocessEvent.bind(integration);
        client.on('preprocessEvent', function(event, hint) {
            return callback(event, hint, client);
        });
    }
    if (client.addEventProcessor && typeof integration.processEvent === 'function') {
        var callback1 = integration.processEvent.bind(integration);
        var processor = Object.assign(function(event, hint) {
            return callback1(event, hint, client);
        }, {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current hub's client. */ function addIntegration(integration) {
    var client = (0, _exportsJs.getClient)();
    if (!client || !client.addIntegration) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
// Polyfill for Array.findIndex(), which is not supported in ES5
function findIndex(arr, callback) {
    for(var i = 0; i < arr.length; i++){
        if (callback(arr[i]) === true) return i;
    }
    return -1;
}
/**
 * Convert a new integration function to the legacy class syntax.
 * In v8, we can remove this and instead export the integration functions directly.
 *
 * @deprecated This will be removed in v8!
 */ function convertIntegrationFnToClass(name, fn) {
    return Object.assign(function ConvertedIntegration() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return fn.apply(void 0, (0, _toConsumableArray._)(args));
    }, {
        id: name
    });
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function defineIntegration(fn) {
    return fn;
}

},{"@swc/helpers/_/_sliced_to_array":"ha6sq","@swc/helpers/_/_to_consumable_array":"eqNDD","@sentry/utils":"gElXU","./debug-build.js":"4R9PX","./eventProcessors.js":"bSGgA","./exports.js":"1Khf7","./hub.js":"jixbC","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"lmccH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createMetricEnvelope", function() {
    return createMetricEnvelope;
});
var _utils = require("@sentry/utils");
var _utilsJs = require("./utils.js");
/**
 * Create envelope from a metric aggregate.
 */ function createMetricEnvelope(metricBucketItems, dsn, metadata, tunnel) {
    var headers = {
        sent_at: new Date().toISOString()
    };
    if (metadata && metadata.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && dsn) headers.dsn = (0, _utils.dsnToString)(dsn);
    var item = createMetricEnvelopeItem(metricBucketItems);
    return (0, _utils.createEnvelope)(headers, [
        item
    ]);
}
function createMetricEnvelopeItem(metricBucketItems) {
    var payload = (0, _utilsJs.serializeMetricBuckets)(metricBucketItems);
    var metricHeaders = {
        type: 'statsd',
        length: payload.length
    };
    return [
        metricHeaders,
        payload
    ];
}

},{"@sentry/utils":"gElXU","./utils.js":"eoxAY","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"eoxAY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getBucketKey", function() {
    return getBucketKey;
});
parcelHelpers.export(exports, "sanitizeMetricKey", function() {
    return sanitizeMetricKey;
});
parcelHelpers.export(exports, "sanitizeTags", function() {
    return sanitizeTags;
});
parcelHelpers.export(exports, "sanitizeUnit", function() {
    return sanitizeUnit;
});
parcelHelpers.export(exports, "serializeMetricBuckets", function() {
    return serializeMetricBuckets;
});
parcelHelpers.export(exports, "simpleHash", function() {
    return simpleHash;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _utils = require("@sentry/utils");
/**
 * Generate bucket key from metric properties.
 */ function getBucketKey(metricType, name, unit, tags) {
    var stringifiedTags = Object.entries((0, _utils.dropUndefinedKeys)(tags)).sort(function(a, b) {
        return a[0].localeCompare(b[0]);
    });
    return `${metricType}${name}${unit}${stringifiedTags}`;
}
/* eslint-disable no-bitwise */ /**
 * Simple hash function for strings.
 */ function simpleHash(s) {
    var rv = 0;
    for(var i = 0; i < s.length; i++){
        var c = s.charCodeAt(i);
        rv = (rv << 5) - rv + c;
        rv &= rv;
    }
    return rv >>> 0;
}
/* eslint-enable no-bitwise */ /**
 * Serialize metrics buckets into a string based on statsd format.
 *
 * Example of format:
 * metric.name@second:1:1.2|d|#a:value,b:anothervalue|T12345677
 * Segments:
 * name: metric.name
 * unit: second
 * value: [1, 1.2]
 * type of metric: d (distribution)
 * tags: { a: value, b: anothervalue }
 * timestamp: 12345677
 */ function serializeMetricBuckets(metricBucketItems) {
    var out = '';
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = metricBucketItems[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            var tagEntries = Object.entries(item.tags);
            var maybeTags = tagEntries.length > 0 ? `|#${tagEntries.map(function(param) {
                var _param = (0, _slicedToArray._)(param, 2), key = _param[0], value = _param[1];
                return `${key}:${value}`;
            }).join(',')}` : '';
            out += `${item.name}@${item.unit}:${item.metric}|${item.metricType}${maybeTags}|T${item.timestamp}\n`;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return out;
}
/** Sanitizes units */ function sanitizeUnit(unit) {
    return unit.replace(/[^\w]+/gi, '_');
}
/** Sanitizes metric keys */ function sanitizeMetricKey(key) {
    return key.replace(/[^\w\-.]+/gi, '_');
}
function sanitizeTagKey(key) {
    return key.replace(/[^\w\-./]+/gi, '');
}
var tagValueReplacements = [
    [
        '\n',
        '\\n'
    ],
    [
        '\r',
        '\\r'
    ],
    [
        '\t',
        '\\t'
    ],
    [
        '\\',
        '\\\\'
    ],
    [
        '|',
        '\\u{7c}'
    ],
    [
        ',',
        '\\u{2c}'
    ]
];
function getCharOrReplacement(input) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = tagValueReplacements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, _slicedToArray._)(_step.value, 2), search = _step_value[0], replacement = _step_value[1];
            if (input === search) return replacement;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return input;
}
function sanitizeTagValue(value) {
    return (0, _toConsumableArray._)(value).reduce(function(acc, char) {
        return acc + getCharOrReplacement(char);
    }, '');
}
/**
 * Sanitizes tags.
 */ function sanitizeTags(unsanitizedTags) {
    var tags = {};
    for(var key in unsanitizedTags)if (Object.prototype.hasOwnProperty.call(unsanitizedTags, key)) {
        var sanitizedKey = sanitizeTagKey(key);
        tags[sanitizedKey] = sanitizeTagValue(String(unsanitizedTags[key]));
    }
    return tags;
}

},{"@swc/helpers/_/_sliced_to_array":"ha6sq","@swc/helpers/_/_to_consumable_array":"eqNDD","@sentry/utils":"gElXU","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"kKCN0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ServerRuntimeClient", function() {
    return ServerRuntimeClient;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _get = require("@swc/helpers/_/_get");
var _getPrototypeOf = require("@swc/helpers/_/_get_prototype_of");
var _inherits = require("@swc/helpers/_/_inherits");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _utils = require("@sentry/utils");
var _baseclientJs = require("./baseclient.js");
var _checkinJs = require("./checkin.js");
var _debugBuildJs = require("./debug-build.js");
var _exportsJs = require("./exports.js");
var _aggregatorJs = require("./metrics/aggregator.js");
var _sessionflusherJs = require("./sessionflusher.js");
var _hubextensionsJs = require("./tracing/hubextensions.js");
var _spanUtilsJs = require("./utils/spanUtils.js");
var _getRootSpanJs = require("./utils/getRootSpan.js");
var _spanstatusJs = require("./tracing/spanstatus.js");
var _dynamicSamplingContextJs = require("./tracing/dynamicSamplingContext.js");
/**
 * The Sentry Server Runtime Client SDK.
 */ var ServerRuntimeClient = /*#__PURE__*/ function(BaseClient) {
    "use strict";
    (0, _inherits._)(ServerRuntimeClient, BaseClient);
    function ServerRuntimeClient(options) {
        (0, _classCallCheck._)(this, ServerRuntimeClient);
        var _this;
        // Server clients always support tracing
        (0, _hubextensionsJs.addTracingExtensions)();
        _this = (0, _callSuper._)(this, ServerRuntimeClient, [
            options
        ]);
        if (options._experiments && options._experiments['metricsAggregator']) _this.metricsAggregator = new (0, _aggregatorJs.MetricsAggregator)(_this);
        return _this;
    }
    (0, _createClass._)(ServerRuntimeClient, [
        {
            /**
   * @inheritDoc
   */ key: "eventFromException",
            value: function eventFromException(exception, hint) {
                return (0, _utils.resolvedSyncPromise)((0, _utils.eventFromUnknownInput)((0, _exportsJs.getClient)(), this._options.stackParser, exception, hint));
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "eventFromMessage",
            value: function eventFromMessage(message) {
                var // eslint-disable-next-line deprecation/deprecation
                level = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'info', hint = arguments.length > 2 ? arguments[2] : void 0;
                return (0, _utils.resolvedSyncPromise)((0, _utils.eventFromMessage)(this._options.stackParser, message, level, hint, this._options.attachStacktrace));
            }
        },
        {
            /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
            key: "captureException",
            value: function captureException(exception, hint, scope) {
                // Check if the flag `autoSessionTracking` is enabled, and if `_sessionFlusher` exists because it is initialised only
                // when the `requestHandler` middleware is used, and hence the expectation is to have SessionAggregates payload
                // sent to the Server only when the `requestHandler` middleware is used
                if (this._options.autoSessionTracking && this._sessionFlusher && scope) {
                    var requestSession = scope.getRequestSession();
                    // Necessary checks to ensure this is code block is executed only within a request
                    // Should override the status only if `requestSession.status` is `Ok`, which is its initial stage
                    if (requestSession && requestSession.status === 'ok') requestSession.status = 'errored';
                }
                return (0, _get._)((0, _getPrototypeOf._)(ServerRuntimeClient.prototype), "captureException", this).call(this, exception, hint, scope);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "captureEvent",
            value: function captureEvent(event, hint, scope) {
                // Check if the flag `autoSessionTracking` is enabled, and if `_sessionFlusher` exists because it is initialised only
                // when the `requestHandler` middleware is used, and hence the expectation is to have SessionAggregates payload
                // sent to the Server only when the `requestHandler` middleware is used
                if (this._options.autoSessionTracking && this._sessionFlusher && scope) {
                    var eventType = event.type || 'exception';
                    var isException = eventType === 'exception' && event.exception && event.exception.values && event.exception.values.length > 0;
                    // If the event is of type Exception, then a request session should be captured
                    if (isException) {
                        var requestSession = scope.getRequestSession();
                        // Ensure that this is happening within the bounds of a request, and make sure not to override
                        // Session Status if Errored / Crashed
                        if (requestSession && requestSession.status === 'ok') requestSession.status = 'errored';
                    }
                }
                return (0, _get._)((0, _getPrototypeOf._)(ServerRuntimeClient.prototype), "captureEvent", this).call(this, event, hint, scope);
            }
        },
        {
            /**
   *
   * @inheritdoc
   */ key: "close",
            value: function close(timeout) {
                if (this._sessionFlusher) this._sessionFlusher.close();
                return (0, _get._)((0, _getPrototypeOf._)(ServerRuntimeClient.prototype), "close", this).call(this, timeout);
            }
        },
        {
            /** Method that initialises an instance of SessionFlusher on Client */ key: "initSessionFlusher",
            value: function initSessionFlusher() {
                var _this__options = this._options, release = _this__options.release, environment = _this__options.environment;
                if (!release) (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn('Cannot initialise an instance of SessionFlusher if no release is provided!');
                else this._sessionFlusher = new (0, _sessionflusherJs.SessionFlusher)(this, {
                    release: release,
                    environment: environment
                });
            }
        },
        {
            /**
   * Create a cron monitor check in and send it to Sentry.
   *
   * @param checkIn An object that describes a check in.
   * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
   * to create a monitor automatically when sending a check in.
   */ key: "captureCheckIn",
            value: function captureCheckIn(checkIn, monitorConfig, scope) {
                var id = 'checkInId' in checkIn && checkIn.checkInId ? checkIn.checkInId : (0, _utils.uuid4)();
                if (!this._isEnabled()) {
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn('SDK not enabled, will not capture checkin.');
                    return id;
                }
                var options = this.getOptions();
                var release = options.release, environment = options.environment, tunnel = options.tunnel;
                var serializedCheckIn = {
                    check_in_id: id,
                    monitor_slug: checkIn.monitorSlug,
                    status: checkIn.status,
                    release: release,
                    environment: environment
                };
                if ('duration' in checkIn) serializedCheckIn.duration = checkIn.duration;
                if (monitorConfig) serializedCheckIn.monitor_config = {
                    schedule: monitorConfig.schedule,
                    checkin_margin: monitorConfig.checkinMargin,
                    max_runtime: monitorConfig.maxRuntime,
                    timezone: monitorConfig.timezone
                };
                var _this__getTraceInfoFromScope = (0, _slicedToArray._)(this._getTraceInfoFromScope(scope), 2), dynamicSamplingContext = _this__getTraceInfoFromScope[0], traceContext = _this__getTraceInfoFromScope[1];
                if (traceContext) serializedCheckIn.contexts = {
                    trace: traceContext
                };
                var envelope = (0, _checkinJs.createCheckInEnvelope)(serializedCheckIn, dynamicSamplingContext, this.getSdkMetadata(), tunnel, this.getDsn());
                (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).info('Sending checkin:', checkIn.monitorSlug, checkIn.status);
                // _sendEnvelope should not throw
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this._sendEnvelope(envelope);
                return id;
            }
        },
        {
            /**
   * Method responsible for capturing/ending a request session by calling `incrementSessionStatusCount` to increment
   * appropriate session aggregates bucket
   */ key: "_captureRequestSession",
            value: function _captureRequestSession() {
                if (!this._sessionFlusher) (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn('Discarded request mode session because autoSessionTracking option was disabled');
                else this._sessionFlusher.incrementSessionStatusCount();
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "_prepareEvent",
            value: function _prepareEvent(event, hint, scope, isolationScope) {
                if (this._options.platform) event.platform = event.platform || this._options.platform;
                if (this._options.runtime) event.contexts = (0, _objectSpreadProps._)((0, _objectSpread._)({}, event.contexts), {
                    runtime: (event.contexts || {}).runtime || this._options.runtime
                });
                if (this._options.serverName) event.server_name = event.server_name || this._options.serverName;
                return (0, _get._)((0, _getPrototypeOf._)(ServerRuntimeClient.prototype), "_prepareEvent", this).call(this, event, hint, scope, isolationScope);
            }
        },
        {
            /** Extract trace information from scope */ key: "_getTraceInfoFromScope",
            value: function _getTraceInfoFromScope(scope) {
                if (!scope) return [
                    undefined,
                    undefined
                ];
                // eslint-disable-next-line deprecation/deprecation
                var span = scope.getSpan();
                if (span) {
                    var samplingContext = (0, _getRootSpanJs.getRootSpan)(span) ? (0, _dynamicSamplingContextJs.getDynamicSamplingContextFromSpan)(span) : undefined;
                    return [
                        samplingContext,
                        (0, _spanUtilsJs.spanToTraceContext)(span)
                    ];
                }
                var _scope_getPropagationContext = scope.getPropagationContext(), traceId = _scope_getPropagationContext.traceId, spanId = _scope_getPropagationContext.spanId, parentSpanId = _scope_getPropagationContext.parentSpanId, dsc = _scope_getPropagationContext.dsc;
                var traceContext = {
                    trace_id: traceId,
                    span_id: spanId,
                    parent_span_id: parentSpanId
                };
                if (dsc) return [
                    dsc,
                    traceContext
                ];
                return [
                    (0, _dynamicSamplingContextJs.getDynamicSamplingContextFromClient)(traceId, this, scope),
                    traceContext
                ];
            }
        }
    ]);
    return ServerRuntimeClient;
}((0, _baseclientJs.BaseClient));

},{"@swc/helpers/_/_call_super":"5oPMc","@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","@swc/helpers/_/_get":"lJChW","@swc/helpers/_/_get_prototype_of":"fF8vn","@swc/helpers/_/_inherits":"j8HRi","@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_object_spread_props":"fLCYP","@swc/helpers/_/_sliced_to_array":"ha6sq","@sentry/utils":"gElXU","./baseclient.js":"j7SLY","./checkin.js":"axY4K","./debug-build.js":"4R9PX","./exports.js":"1Khf7","./metrics/aggregator.js":"c05Sd","./sessionflusher.js":"ivoF2","./tracing/hubextensions.js":"cbvDC","./utils/spanUtils.js":"ce0Ij","./utils/getRootSpan.js":"3Qg37","./tracing/spanstatus.js":"N1JbW","./tracing/dynamicSamplingContext.js":"1rgNT","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"axY4K":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createCheckInEnvelope", function() {
    return createCheckInEnvelope;
});
var _utils = require("@sentry/utils");
/**
 * Create envelope from check in item.
 */ function createCheckInEnvelope(checkIn, dynamicSamplingContext, metadata, tunnel, dsn) {
    var headers = {
        sent_at: new Date().toISOString()
    };
    if (metadata && metadata.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn) headers.dsn = (0, _utils.dsnToString)(dsn);
    if (dynamicSamplingContext) headers.trace = (0, _utils.dropUndefinedKeys)(dynamicSamplingContext);
    var item = createCheckInEnvelopeItem(checkIn);
    return (0, _utils.createEnvelope)(headers, [
        item
    ]);
}
function createCheckInEnvelopeItem(checkIn) {
    var checkInHeaders = {
        type: 'check_in'
    };
    return [
        checkInHeaders,
        checkIn
    ];
}

},{"@sentry/utils":"gElXU","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"c05Sd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MetricsAggregator", function() {
    return MetricsAggregator;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _utils = require("@sentry/utils");
var _constantsJs = require("./constants.js");
var _instanceJs = require("./instance.js");
var _metricSummaryJs = require("./metric-summary.js");
var _utilsJs = require("./utils.js");
/**
 * A metrics aggregator that aggregates metrics in memory and flushes them periodically.
 */ var MetricsAggregator = /*#__PURE__*/ function() {
    "use strict";
    function MetricsAggregator(_client) {
        var _this = this;
        (0, _classCallCheck._)(this, MetricsAggregator);
        this._client = _client;
        this._buckets = new Map();
        this._bucketsTotalWeight = 0;
        this._interval = setInterval(function() {
            return _this._flush();
        }, (0, _constantsJs.DEFAULT_FLUSH_INTERVAL));
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        if (this._interval.unref) // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        this._interval.unref();
        this._flushShift = Math.floor(Math.random() * (0, _constantsJs.DEFAULT_FLUSH_INTERVAL) / 1000);
        this._forceFlush = false;
    }
    (0, _createClass._)(MetricsAggregator, [
        {
            /**
   * @inheritDoc
   */ key: "add",
            value: function add(metricType, unsanitizedName, value) {
                var unsanitizedUnit = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 'none', unsanitizedTags = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {}, maybeFloatTimestamp = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : (0, _utils.timestampInSeconds)();
                var timestamp = Math.floor(maybeFloatTimestamp);
                var name = (0, _utilsJs.sanitizeMetricKey)(unsanitizedName);
                var tags = (0, _utilsJs.sanitizeTags)(unsanitizedTags);
                var unit = (0, _utilsJs.sanitizeUnit)(unsanitizedUnit);
                var bucketKey = (0, _utilsJs.getBucketKey)(metricType, name, unit, tags);
                var bucketItem = this._buckets.get(bucketKey);
                // If this is a set metric, we need to calculate the delta from the previous weight.
                var previousWeight = bucketItem && metricType === (0, _constantsJs.SET_METRIC_TYPE) ? bucketItem.metric.weight : 0;
                if (bucketItem) {
                    bucketItem.metric.add(value);
                    // TODO(abhi): Do we need this check?
                    if (bucketItem.timestamp < timestamp) bucketItem.timestamp = timestamp;
                } else {
                    bucketItem = {
                        // @ts-expect-error we don't need to narrow down the type of value here, saves bundle size.
                        metric: new (0, _instanceJs.METRIC_MAP)[metricType](value),
                        timestamp: timestamp,
                        metricType: metricType,
                        name: name,
                        unit: unit,
                        tags: tags
                    };
                    this._buckets.set(bucketKey, bucketItem);
                }
                // If value is a string, it's a set metric so calculate the delta from the previous weight.
                var val = typeof value === 'string' ? bucketItem.metric.weight - previousWeight : value;
                (0, _metricSummaryJs.updateMetricSummaryOnActiveSpan)(metricType, name, val, unit, unsanitizedTags, bucketKey);
                // We need to keep track of the total weight of the buckets so that we can
                // flush them when we exceed the max weight.
                this._bucketsTotalWeight += bucketItem.metric.weight;
                if (this._bucketsTotalWeight >= (0, _constantsJs.MAX_WEIGHT)) this.flush();
            }
        },
        {
            /**
   * Flushes the current metrics to the transport via the transport.
   */ key: "flush",
            value: function flush() {
                this._forceFlush = true;
                this._flush();
            }
        },
        {
            /**
   * Shuts down metrics aggregator and clears all metrics.
   */ key: "close",
            value: function close() {
                this._forceFlush = true;
                clearInterval(this._interval);
                this._flush();
            }
        },
        {
            /**
   * Flushes the buckets according to the internal state of the aggregator.
   * If it is a force flush, which happens on shutdown, it will flush all buckets.
   * Otherwise, it will only flush buckets that are older than the flush interval,
   * and according to the flush shift.
   *
   * This function mutates `_forceFlush` and `_bucketsTotalWeight` properties.
   */ key: "_flush",
            value: function _flush() {
                // TODO(@anonrig): Add Atomics for locking to avoid having force flush and regular flush
                // running at the same time.
                // Ref: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Atomics
                // This path eliminates the need for checking for timestamps since we're forcing a flush.
                // Remember to reset the flag, or it will always flush all metrics.
                if (this._forceFlush) {
                    this._forceFlush = false;
                    this._bucketsTotalWeight = 0;
                    this._captureMetrics(this._buckets);
                    this._buckets.clear();
                    return;
                }
                var cutoffSeconds = Math.floor((0, _utils.timestampInSeconds)()) - (0, _constantsJs.DEFAULT_FLUSH_INTERVAL) / 1000 - this._flushShift;
                // TODO(@anonrig): Optimization opportunity.
                // Convert this map to an array and store key in the bucketItem.
                var flushedBuckets = new Map();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._buckets[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, _slicedToArray._)(_step.value, 2), key = _step_value[0], bucket = _step_value[1];
                        if (bucket.timestamp <= cutoffSeconds) {
                            flushedBuckets.set(key, bucket);
                            this._bucketsTotalWeight -= bucket.metric.weight;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = flushedBuckets[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var _step_value1 = (0, _slicedToArray._)(_step1.value, 1), key1 = _step_value1[0];
                        this._buckets.delete(key1);
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                this._captureMetrics(flushedBuckets);
            }
        },
        {
            /**
   * Only captures a subset of the buckets passed to this function.
   * @param flushedBuckets
   */ key: "_captureMetrics",
            value: function _captureMetrics(flushedBuckets) {
                if (flushedBuckets.size > 0 && this._client.captureAggregateMetrics) {
                    // TODO(@anonrig): Optimization opportunity.
                    // This copy operation can be avoided if we store the key in the bucketItem.
                    var buckets = Array.from(flushedBuckets).map(function(param) {
                        var _param = (0, _slicedToArray._)(param, 2), bucketItem = _param[1];
                        return bucketItem;
                    });
                    this._client.captureAggregateMetrics(buckets);
                }
            }
        }
    ]);
    return MetricsAggregator;
}();

},{"@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","@swc/helpers/_/_sliced_to_array":"ha6sq","@sentry/utils":"gElXU","./constants.js":"jj1Q5","./instance.js":"4BMsE","./metric-summary.js":"1EBEa","./utils.js":"eoxAY","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jj1Q5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "COUNTER_METRIC_TYPE", function() {
    return COUNTER_METRIC_TYPE;
});
parcelHelpers.export(exports, "DEFAULT_BROWSER_FLUSH_INTERVAL", function() {
    return DEFAULT_BROWSER_FLUSH_INTERVAL;
});
parcelHelpers.export(exports, "DEFAULT_FLUSH_INTERVAL", function() {
    return DEFAULT_FLUSH_INTERVAL;
});
parcelHelpers.export(exports, "DISTRIBUTION_METRIC_TYPE", function() {
    return DISTRIBUTION_METRIC_TYPE;
});
parcelHelpers.export(exports, "GAUGE_METRIC_TYPE", function() {
    return GAUGE_METRIC_TYPE;
});
parcelHelpers.export(exports, "MAX_WEIGHT", function() {
    return MAX_WEIGHT;
});
parcelHelpers.export(exports, "SET_METRIC_TYPE", function() {
    return SET_METRIC_TYPE;
});
var COUNTER_METRIC_TYPE = 'c';
var GAUGE_METRIC_TYPE = 'g';
var SET_METRIC_TYPE = 's';
var DISTRIBUTION_METRIC_TYPE = 'd';
/**
 * This does not match spec in https://develop.sentry.dev/sdk/metrics
 * but was chosen to optimize for the most common case in browser environments.
 */ var DEFAULT_BROWSER_FLUSH_INTERVAL = 5000;
/**
 * SDKs are required to bucket into 10 second intervals (rollup in seconds)
 * which is the current lower bound of metric accuracy.
 */ var DEFAULT_FLUSH_INTERVAL = 10000;
/**
 * The maximum number of metrics that should be stored in memory.
 */ var MAX_WEIGHT = 10000;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4BMsE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CounterMetric", function() {
    return CounterMetric;
});
parcelHelpers.export(exports, "DistributionMetric", function() {
    return DistributionMetric;
});
parcelHelpers.export(exports, "GaugeMetric", function() {
    return GaugeMetric;
});
parcelHelpers.export(exports, "METRIC_MAP", function() {
    return METRIC_MAP;
});
parcelHelpers.export(exports, "SetMetric", function() {
    return SetMetric;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _constantsJs = require("./constants.js");
var _utilsJs = require("./utils.js");
/**
 * A metric instance representing a counter.
 */ var CounterMetric = /*#__PURE__*/ function() {
    "use strict";
    function CounterMetric(_value) {
        (0, _classCallCheck._)(this, CounterMetric);
        this._value = _value;
    }
    (0, _createClass._)(CounterMetric, [
        {
            key: "weight",
            get: /** @inheritDoc */ function get() {
                return 1;
            }
        },
        {
            /** @inheritdoc */ key: "add",
            value: function add(value) {
                this._value += value;
            }
        },
        {
            /** @inheritdoc */ key: "toString",
            value: function toString() {
                return `${this._value}`;
            }
        }
    ]);
    return CounterMetric;
}();
/**
 * A metric instance representing a gauge.
 */ var GaugeMetric = /*#__PURE__*/ function() {
    "use strict";
    function GaugeMetric(value) {
        (0, _classCallCheck._)(this, GaugeMetric);
        this._last = value;
        this._min = value;
        this._max = value;
        this._sum = value;
        this._count = 1;
    }
    (0, _createClass._)(GaugeMetric, [
        {
            key: "weight",
            get: /** @inheritDoc */ function get() {
                return 5;
            }
        },
        {
            /** @inheritdoc */ key: "add",
            value: function add(value) {
                this._last = value;
                if (value < this._min) this._min = value;
                if (value > this._max) this._max = value;
                this._sum += value;
                this._count++;
            }
        },
        {
            /** @inheritdoc */ key: "toString",
            value: function toString() {
                return `${this._last}:${this._min}:${this._max}:${this._sum}:${this._count}`;
            }
        }
    ]);
    return GaugeMetric;
}();
/**
 * A metric instance representing a distribution.
 */ var DistributionMetric = /*#__PURE__*/ function() {
    "use strict";
    function DistributionMetric(first) {
        (0, _classCallCheck._)(this, DistributionMetric);
        this._value = [
            first
        ];
    }
    (0, _createClass._)(DistributionMetric, [
        {
            key: "weight",
            get: /** @inheritDoc */ function get() {
                return this._value.length;
            }
        },
        {
            /** @inheritdoc */ key: "add",
            value: function add(value) {
                this._value.push(value);
            }
        },
        {
            /** @inheritdoc */ key: "toString",
            value: function toString() {
                return this._value.join(':');
            }
        }
    ]);
    return DistributionMetric;
}();
/**
 * A metric instance representing a set.
 */ var SetMetric = /*#__PURE__*/ function() {
    "use strict";
    function SetMetric(first) {
        (0, _classCallCheck._)(this, SetMetric);
        this.first = first;
        this._value = new Set([
            first
        ]);
    }
    (0, _createClass._)(SetMetric, [
        {
            key: "weight",
            get: /** @inheritDoc */ function get() {
                return this._value.size;
            }
        },
        {
            /** @inheritdoc */ key: "add",
            value: function add(value) {
                this._value.add(value);
            }
        },
        {
            /** @inheritdoc */ key: "toString",
            value: function toString() {
                return Array.from(this._value).map(function(val) {
                    return typeof val === 'string' ? (0, _utilsJs.simpleHash)(val) : val;
                }).join(':');
            }
        }
    ]);
    return SetMetric;
}();
var _obj;
var METRIC_MAP = (_obj = {}, (0, _defineProperty._)(_obj, (0, _constantsJs.COUNTER_METRIC_TYPE), CounterMetric), (0, _defineProperty._)(_obj, (0, _constantsJs.GAUGE_METRIC_TYPE), GaugeMetric), (0, _defineProperty._)(_obj, (0, _constantsJs.DISTRIBUTION_METRIC_TYPE), DistributionMetric), (0, _defineProperty._)(_obj, (0, _constantsJs.SET_METRIC_TYPE), SetMetric), _obj);

},{"@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","@swc/helpers/_/_define_property":"54Zvk","./constants.js":"jj1Q5","./utils.js":"eoxAY","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"bH3tG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initAndBind", function() {
    return initAndBind;
});
parcelHelpers.export(exports, "setCurrentClient", function() {
    return setCurrentClient;
});
var _utils = require("@sentry/utils");
var _debugBuildJs = require("./debug-build.js");
var _exportsJs = require("./exports.js");
var _hubJs = require("./hub.js");
/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function initAndBind(clientClass, options) {
    if (options.debug === true) {
        if (0, _debugBuildJs.DEBUG_BUILD) (0, _utils.logger).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        (0, _utils.consoleSandbox)(function() {
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
        });
    }
    var scope = (0, _exportsJs.getCurrentScope)();
    scope.update(options.initialScope);
    var client = new clientClass(options);
    setCurrentClient(client);
    initializeClient(client);
}
/**
 * Make the given client the current client.
 */ function setCurrentClient(client) {
    // eslint-disable-next-line deprecation/deprecation
    var hub = (0, _hubJs.getCurrentHub)();
    // eslint-disable-next-line deprecation/deprecation
    var top = hub.getStackTop();
    top.client = client;
    top.scope.setClient(client);
}
/**
 * Initialize the client for the current scope.
 * Make sure to call this after `setCurrentClient()`.
 */ function initializeClient(client) {
    if (client.init) client.init();
    else if (client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
    client.setupIntegrations();
}

},{"@sentry/utils":"gElXU","./debug-build.js":"4R9PX","./exports.js":"1Khf7","./hub.js":"jixbC","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"hIfuf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_TRANSPORT_BUFFER_SIZE", function() {
    return DEFAULT_TRANSPORT_BUFFER_SIZE;
});
parcelHelpers.export(exports, "createTransport", function() {
    return createTransport;
});
var _utils = require("@sentry/utils");
var _debugBuildJs = require("../debug-build.js");
var DEFAULT_TRANSPORT_BUFFER_SIZE = 30;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function createTransport(options, makeRequest) {
    var buffer = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : (0, _utils.makePromiseBuffer)(options.bufferSize || DEFAULT_TRANSPORT_BUFFER_SIZE);
    var rateLimits = {};
    var flush = function(timeout) {
        return buffer.drain(timeout);
    };
    function send(envelope) {
        var filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, _utils.forEachEnvelopeItem)(envelope, function(item, type) {
            var dataCategory = (0, _utils.envelopeItemTypeToDataCategory)(type);
            if ((0, _utils.isRateLimited)(rateLimits, dataCategory)) {
                var event = getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent('ratelimit_backoff', dataCategory, event);
            } else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, _utils.resolvedSyncPromise)();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var filteredEnvelope = (0, _utils.createEnvelope)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        var recordEnvelopeLoss = function(reason) {
            (0, _utils.forEachEnvelopeItem)(filteredEnvelope, function(item, type) {
                var event = getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent(reason, (0, _utils.envelopeItemTypeToDataCategory)(type), event);
            });
        };
        var requestTask = function() {
            return makeRequest({
                body: (0, _utils.serializeEnvelope)(filteredEnvelope, options.textEncoder)
            }).then(function(response) {
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, _utils.updateRateLimits)(rateLimits, response);
                return response;
            }, function(error) {
                recordEnvelopeLoss('network_error');
                throw error;
            });
        };
        return buffer.add(requestTask).then(function(result) {
            return result;
        }, function(error) {
            if (error instanceof (0, _utils.SentryError)) {
                (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).error('Skipped sending event because buffer is full.');
                recordEnvelopeLoss('queue_overflow');
                return (0, _utils.resolvedSyncPromise)();
            } else throw error;
        });
    }
    // We use this to identifify if the transport is the base transport
    // TODO (v8): Remove this again as we'll no longer need it
    send.__sentry__baseTransport__ = true;
    return {
        send: send,
        flush: flush
    };
}
function getEventForEnvelopeItem(item, type) {
    if (type !== 'event' && type !== 'transaction') return undefined;
    return Array.isArray(item) ? item[1] : undefined;
}

},{"@sentry/utils":"gElXU","../debug-build.js":"4R9PX","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"ce5XR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MIN_DELAY", function() {
    return MIN_DELAY;
});
parcelHelpers.export(exports, "START_DELAY", function() {
    return START_DELAY;
});
parcelHelpers.export(exports, "makeOfflineTransport", function() {
    return makeOfflineTransport;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _utils = require("@sentry/utils");
var _debugBuildJs = require("../debug-build.js");
var MIN_DELAY = 100; // 100 ms
var START_DELAY = 5000; // 5 seconds
var MAX_DELAY = 3.6e6; // 1 hour
function log(msg, error) {
    (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).info(`[Offline]: ${msg}`, error);
}
/**
 * Wraps a transport and stores and retries events when they fail to send.
 *
 * @param createTransport The transport to wrap.
 */ function makeOfflineTransport(createTransport) {
    return function(options) {
        var transport = createTransport(options);
        var store = options.createStore ? options.createStore(options) : undefined;
        var retryDelay = START_DELAY;
        var flushTimer;
        function shouldQueue(env, error, retryDelay) {
            // We don't queue Session Replay envelopes because they are:
            // - Ordered and Replay relies on the response status to know when they're successfully sent.
            // - Likely to fill the queue quickly and block other events from being sent.
            // We also want to drop client reports because they can be generated when we retry sending events while offline.
            if ((0, _utils.envelopeContainsItemType)(env, [
                'replay_event',
                'replay_recording',
                'client_report'
            ])) return false;
            if (options.shouldStore) return options.shouldStore(env, error, retryDelay);
            return true;
        }
        function flushIn(delay) {
            if (!store) return;
            if (flushTimer) clearTimeout(flushTimer);
            flushTimer = setTimeout(/*#__PURE__*/ (0, _asyncToGenerator._)(function() {
                var found;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            flushTimer = undefined;
                            return [
                                4,
                                store.pop()
                            ];
                        case 1:
                            found = _state.sent();
                            if (found) {
                                log('Attempting to send previously queued event');
                                send(found).catch(function(e) {
                                    log('Failed to retry sending', e);
                                });
                            }
                            return [
                                2
                            ];
                    }
                });
            }), delay);
            // We need to unref the timer in node.js, otherwise the node process never exit.
            if (typeof flushTimer !== 'number' && flushTimer.unref) flushTimer.unref();
        }
        function flushWithBackOff() {
            if (flushTimer) return;
            flushIn(retryDelay);
            retryDelay = Math.min(retryDelay * 2, MAX_DELAY);
        }
        function send(envelope) {
            return _send.apply(this, arguments);
        }
        function _send() {
            _send = (0, _asyncToGenerator._)(function(envelope) {
                var result, delay, e, _tmp;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                8
                            ]);
                            return [
                                4,
                                transport.send(envelope)
                            ];
                        case 1:
                            result = _state.sent();
                            delay = MIN_DELAY;
                            if (result) {
                                // If there's a retry-after header, use that as the next delay.
                                if (result.headers && result.headers['retry-after']) delay = (0, _utils.parseRetryAfterHeader)(result.headers['retry-after']);
                                else if ((result.statusCode || 0) >= 400) return [
                                    2,
                                    result
                                ];
                            }
                            flushIn(delay);
                            retryDelay = START_DELAY;
                            return [
                                2,
                                result
                            ];
                        case 2:
                            e = _state.sent();
                            _tmp = store;
                            if (!_tmp) return [
                                3,
                                4
                            ];
                            return [
                                4,
                                shouldQueue(envelope, e, retryDelay)
                            ];
                        case 3:
                            _tmp = _state.sent();
                            _state.label = 4;
                        case 4:
                            if (!_tmp) return [
                                3,
                                6
                            ];
                            return [
                                4,
                                store.insert(envelope)
                            ];
                        case 5:
                            _state.sent();
                            flushWithBackOff();
                            log('Error sending. Event queued', e);
                            return [
                                2,
                                {}
                            ];
                        case 6:
                            throw e;
                        case 7:
                            return [
                                3,
                                8
                            ];
                        case 8:
                            return [
                                2
                            ];
                    }
                });
            });
            return _send.apply(this, arguments);
        }
        if (options.flushAtStartup) flushWithBackOff();
        return {
            send: send,
            flush: function(t) {
                return transport.flush(t);
            }
        };
    };
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_ts_generator":"f2hGH","@sentry/utils":"gElXU","../debug-build.js":"4R9PX","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"boqD5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "eventFromEnvelope", function() {
    return eventFromEnvelope;
});
parcelHelpers.export(exports, "makeMultiplexedTransport", function() {
    return makeMultiplexedTransport;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _utils = require("@sentry/utils");
var _apiJs = require("../api.js");
/**
 * Gets an event from an envelope.
 *
 * This is only exported for use in the tests
 */ function eventFromEnvelope(env, types) {
    var event;
    (0, _utils.forEachEnvelopeItem)(env, function(item, type) {
        if (types.includes(type)) event = Array.isArray(item) ? item[1] : undefined;
        // bail out if we found an event
        return !!event;
    });
    return event;
}
/**
 * Creates a transport that overrides the release on all events.
 */ function makeOverrideReleaseTransport(createTransport, release) {
    return function(options) {
        var transport = createTransport(options);
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, transport), {
            send: /*#__PURE__*/ function() {
                var _ref = (0, _asyncToGenerator._)(function(envelope) {
                    var event;
                    return (0, _tsGenerator._)(this, function(_state) {
                        event = eventFromEnvelope(envelope, [
                            'event',
                            'transaction',
                            'profile',
                            'replay_event'
                        ]);
                        if (event) event.release = release;
                        return [
                            2,
                            transport.send(envelope)
                        ];
                    });
                });
                return function(envelope) {
                    return _ref.apply(this, arguments);
                };
            }()
        });
    };
}
/** Overrides the DSN in the envelope header  */ function overrideDsn(envelope, dsn) {
    return (0, _utils.createEnvelope)(dsn ? (0, _objectSpreadProps._)((0, _objectSpread._)({}, envelope[0]), {
        dsn: dsn
    }) : envelope[0], envelope[1]);
}
/**
 * Creates a transport that can send events to different DSNs depending on the envelope contents.
 */ function makeMultiplexedTransport(createTransport, matcher) {
    return function(options) {
        var fallbackTransport = createTransport(options);
        var otherTransports = new Map();
        function getTransport(dsn, release) {
            // We create a transport for every unique dsn/release combination as there may be code from multiple releases in
            // use at the same time
            var key = release ? `${dsn}:${release}` : dsn;
            var transport = otherTransports.get(key);
            if (!transport) {
                var validatedDsn = (0, _utils.dsnFromString)(dsn);
                if (!validatedDsn) return undefined;
                var url = (0, _apiJs.getEnvelopeEndpointWithUrlEncodedAuth)(validatedDsn, options.tunnel);
                transport = release ? makeOverrideReleaseTransport(createTransport, release)((0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
                    url: url
                })) : createTransport((0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
                    url: url
                }));
                otherTransports.set(key, transport);
            }
            return [
                dsn,
                transport
            ];
        }
        function send(envelope) {
            return _send.apply(this, arguments);
        }
        function _send() {
            _send = (0, _asyncToGenerator._)(function(envelope) {
                var transports, results;
                function getEvent(types) {
                    var eventTypes = types && types.length ? types : [
                        'event'
                    ];
                    return eventFromEnvelope(envelope, eventTypes);
                }
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            transports = matcher({
                                envelope: envelope,
                                getEvent: getEvent
                            }).map(function(result) {
                                if (typeof result === 'string') return getTransport(result, undefined);
                                else return getTransport(result.dsn, result.release);
                            }).filter(function(t) {
                                return !!t;
                            });
                            // If we have no transports to send to, use the fallback transport
                            if (transports.length === 0) // Don't override the DSN in the header for the fallback transport. '' is falsy
                            transports.push([
                                '',
                                fallbackTransport
                            ]);
                            return [
                                4,
                                Promise.all(transports.map(function(param) {
                                    var _param = (0, _slicedToArray._)(param, 2), dsn = _param[0], transport = _param[1];
                                    return transport.send(overrideDsn(envelope, dsn));
                                }))
                            ];
                        case 1:
                            results = _state.sent();
                            return [
                                2,
                                results[0]
                            ];
                    }
                });
            });
            return _send.apply(this, arguments);
        }
        function flush(timeout) {
            return _flush.apply(this, arguments);
        }
        function _flush() {
            _flush = (0, _asyncToGenerator._)(function(timeout) {
                var promises, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step_value, transport, _, err;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                fallbackTransport.flush(timeout)
                            ];
                        case 1:
                            promises = [
                                _state.sent()
                            ];
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 2;
                        case 2:
                            _state.trys.push([
                                2,
                                7,
                                8,
                                9
                            ]);
                            _iterator = otherTransports[Symbol.iterator]();
                            _state.label = 3;
                        case 3:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                6
                            ];
                            _step_value = (0, _slicedToArray._)(_step.value, 2), transport = _step_value[1];
                            _ = promises.push;
                            return [
                                4,
                                transport.flush(timeout)
                            ];
                        case 4:
                            _.apply(promises, [
                                _state.sent()
                            ]);
                            _state.label = 5;
                        case 5:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                3
                            ];
                        case 6:
                            return [
                                3,
                                9
                            ];
                        case 7:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                9
                            ];
                        case 8:
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 9:
                            return [
                                2,
                                promises.every(function(r) {
                                    return r;
                                })
                            ];
                    }
                });
            });
            return _flush.apply(this, arguments);
        }
        return {
            send: send,
            flush: flush
        };
    };
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_object_spread_props":"fLCYP","@swc/helpers/_/_sliced_to_array":"ha6sq","@swc/helpers/_/_ts_generator":"f2hGH","@sentry/utils":"gElXU","../api.js":"4yCrc","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"iqR6V":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createSpanEnvelope", function() {
    return createSpanEnvelope;
});
var _utils = require("@sentry/utils");
/**
 * Create envelope from Span item.
 */ function createSpanEnvelope(spans, dsn) {
    var headers = {
        sent_at: new Date().toISOString()
    };
    if (dsn) headers.dsn = (0, _utils.dsnToString)(dsn);
    var items = spans.map(createSpanItem);
    return (0, _utils.createEnvelope)(headers, items);
}
function createSpanItem(span) {
    var spanHeaders = {
        type: 'span'
    };
    return [
        spanHeaders,
        span
    ];
}

},{"@sentry/utils":"gElXU","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"eRNn4":[function(require,module,exports,__globalThis) {
/**
 * Checks whether given url points to Sentry server
 * @param url url to verify
 *
 * TODO(v8): Remove Hub fallback type
 */ // eslint-disable-next-line deprecation/deprecation
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isSentryRequestUrl", function() {
    return isSentryRequestUrl;
});
function isSentryRequestUrl(url, hubOrClient) {
    var client = hubOrClient && isHub(hubOrClient) ? hubOrClient.getClient() : hubOrClient;
    var dsn = client && client.getDsn();
    var tunnel = client && client.getOptions().tunnel;
    return checkDsn(url, dsn) || checkTunnel(url, tunnel);
}
function checkTunnel(url, tunnel) {
    if (!tunnel) return false;
    return removeTrailingSlash(url) === removeTrailingSlash(tunnel);
}
function checkDsn(url, dsn) {
    return dsn ? url.includes(dsn.host) : false;
}
function removeTrailingSlash(str) {
    return str[str.length - 1] === '/' ? str.slice(0, -1) : str;
}
// eslint-disable-next-line deprecation/deprecation
function isHub(hubOrClient) {
    // eslint-disable-next-line deprecation/deprecation
    return hubOrClient.getClient !== undefined;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5vMfI":[function(require,module,exports,__globalThis) {
/**
 * Tagged template function which returns paramaterized representation of the message
 * For example: parameterize`This is a log statement with ${x} and ${y} params`, would return:
 * "__sentry_template_string__": 'This is a log statement with %s and %s params',
 * "__sentry_template_values__": ['first', 'second']
 * @param strings An array of string values splitted between expressions
 * @param values Expressions extracted from template string
 * @returns String with template information in __sentry_template_string__ and __sentry_template_values__ properties
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parameterize", function() {
    return parameterize;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
function parameterize(strings) {
    for(var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        values[_key - 1] = arguments[_key];
    }
    var _String;
    var formatted = new String((_String = String).raw.apply(_String, [
        strings
    ].concat((0, _toConsumableArray._)(values))));
    formatted.__sentry_template_string__ = strings.join('\x00').replace(/%/g, '%%').replace(/\0/g, '%s');
    formatted.__sentry_template_values__ = values;
    return formatted;
}

},{"@swc/helpers/_/_to_consumable_array":"eqNDD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"bF4Xb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "applySdkMetadata", function() {
    return applySdkMetadata;
});
var _versionJs = require("../version.js");
/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function applySdkMetadata(options, name) {
    var names = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [
        name
    ], source = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 'npm';
    var metadata = options._metadata || {};
    if (!metadata.sdk) metadata.sdk = {
        name: `sentry.javascript.${name}`,
        packages: names.map(function(name) {
            return {
                name: `${source}:@sentry/${name}`,
                version: (0, _versionJs.SDK_VERSION)
            };
        }),
        version: (0, _versionJs.SDK_VERSION)
    };
    options._metadata = metadata;
}

},{"../version.js":"8NqlU","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5gfkZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ModuleMetadata", function() {
    return ModuleMetadata;
});
parcelHelpers.export(exports, "moduleMetadataIntegration", function() {
    return moduleMetadataIntegration;
});
var _utils = require("@sentry/utils");
var _integrationJs = require("../integration.js");
var _metadataJs = require("../metadata.js");
var INTEGRATION_NAME = 'ModuleMetadata';
var _moduleMetadataIntegration = function() {
    return {
        name: INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce: function() {},
        setup: function(client) {
            if (typeof client.on !== 'function') return;
            // We need to strip metadata from stack frames before sending them to Sentry since these are client side only.
            client.on('beforeEnvelope', function(envelope) {
                (0, _utils.forEachEnvelopeItem)(envelope, function(item, type) {
                    if (type === 'event') {
                        var event = Array.isArray(item) ? item[1] : undefined;
                        if (event) {
                            (0, _metadataJs.stripMetadataFromStackFrames)(event);
                            item[1] = event;
                        }
                    }
                });
            });
        },
        processEvent: function(event, _hint, client) {
            var stackParser = client.getOptions().stackParser;
            (0, _metadataJs.addMetadataToStackFrames)(stackParser, event);
            return event;
        }
    };
};
var moduleMetadataIntegration = (0, _integrationJs.defineIntegration)(_moduleMetadataIntegration);
/**
 * Adds module metadata to stack frames.
 *
 * Metadata can be injected by the Sentry bundler plugins using the `_experiments.moduleMetadata` config option.
 *
 * When this integration is added, the metadata passed to the bundler plugin is added to the stack frames of all events
 * under the `module_metadata` property. This can be used to help in tagging or routing of events from different teams
 * our sources
 *
 * @deprecated Use `moduleMetadataIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
var ModuleMetadata = (0, _integrationJs.convertIntegrationFnToClass)(INTEGRATION_NAME, moduleMetadataIntegration);

},{"@sentry/utils":"gElXU","../integration.js":"dKOes","../metadata.js":"gJJBR","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gJJBR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addMetadataToStackFrames", function() {
    return addMetadataToStackFrames;
});
parcelHelpers.export(exports, "getMetadataForUrl", function() {
    return getMetadataForUrl;
});
parcelHelpers.export(exports, "stripMetadataFromStackFrames", function() {
    return stripMetadataFromStackFrames;
});
var _utils = require("@sentry/utils");
/** Keys are source filename/url, values are metadata objects. */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
var filenameMetadataMap = new Map();
/** Set of stack strings that have already been parsed. */ var parsedStacks = new Set();
function ensureMetadataStacksAreParsed(parser) {
    if (!(0, _utils.GLOBAL_OBJ)._sentryModuleMetadata) return;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.keys((0, _utils.GLOBAL_OBJ)._sentryModuleMetadata)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var stack = _step.value;
            var metadata = (0, _utils.GLOBAL_OBJ)._sentryModuleMetadata[stack];
            if (parsedStacks.has(stack)) continue;
            // Ensure this stack doesn't get parsed again
            parsedStacks.add(stack);
            var frames = parser(stack);
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                // Go through the frames starting from the top of the stack and find the first one with a filename
                for(var _iterator1 = frames.reverse()[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var frame = _step1.value;
                    if (frame.filename) {
                        // Save the metadata for this filename
                        filenameMetadataMap.set(frame.filename, metadata);
                        break;
                    }
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
/**
 * Retrieve metadata for a specific JavaScript file URL.
 *
 * Metadata is injected by the Sentry bundler plugins using the `_experiments.moduleMetadata` config option.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function getMetadataForUrl(parser, filename) {
    ensureMetadataStacksAreParsed(parser);
    return filenameMetadataMap.get(filename);
}
/**
 * Adds metadata to stack frames.
 *
 * Metadata is injected by the Sentry bundler plugins using the `_experiments.moduleMetadata` config option.
 */ function addMetadataToStackFrames(parser, event) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach(function(exception) {
            if (!exception.stacktrace) return;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = (exception.stacktrace.frames || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var frame = _step.value;
                    if (!frame.filename) continue;
                    var metadata = getMetadataForUrl(parser, frame.filename);
                    if (metadata) frame.module_metadata = metadata;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        });
    } catch (_) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
/**
 * Strips metadata from stack frames.
 */ function stripMetadataFromStackFrames(event) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach(function(exception) {
            if (!exception.stacktrace) return;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = (exception.stacktrace.frames || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var frame = _step.value;
                    delete frame.module_metadata;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        });
    } catch (_) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}

},{"@sentry/utils":"gElXU","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2ftSB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RequestData", function() {
    return RequestData;
});
parcelHelpers.export(exports, "requestDataIntegration", function() {
    return requestDataIntegration;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _utils = require("@sentry/utils");
var _integrationJs = require("../integration.js");
var _spanUtilsJs = require("../utils/spanUtils.js");
var DEFAULT_OPTIONS = {
    include: {
        cookies: true,
        data: true,
        headers: true,
        ip: false,
        query_string: true,
        url: true,
        user: {
            id: true,
            username: true,
            email: true
        }
    },
    transactionNamingScheme: 'methodPath'
};
var INTEGRATION_NAME = 'RequestData';
var _requestDataIntegration = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _addRequestData = (0, _utils.addRequestDataToEvent);
    var _options = (0, _objectSpreadProps._)((0, _objectSpread._)({}, DEFAULT_OPTIONS, options), {
        include: (0, _objectSpreadProps._)((0, _objectSpread._)({
            // @ts-expect-error It's mad because `method` isn't a known `include` key. (It's only here and not set by default in
            // `addRequestDataToEvent` for legacy reasons. TODO (v8): Change that.)
            method: true
        }, DEFAULT_OPTIONS.include, options.include), {
            user: options.include && typeof options.include.user === 'boolean' ? options.include.user : (0, _objectSpread._)({}, DEFAULT_OPTIONS.include.user, (options.include || {}).user)
        })
    });
    return {
        name: INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce: function() {},
        processEvent: function(event, _hint, client) {
            // Note: In the long run, most of the logic here should probably move into the request data utility functions. For
            // the moment it lives here, though, until https://github.com/getsentry/sentry-javascript/issues/5718 is addressed.
            // (TL;DR: Those functions touch many parts of the repo in many different ways, and need to be clened up. Once
            // that's happened, it will be easier to add this logic in without worrying about unexpected side effects.)
            var transactionNamingScheme = _options.transactionNamingScheme;
            var _event_sdkProcessingMetadata = event.sdkProcessingMetadata, sdkProcessingMetadata = _event_sdkProcessingMetadata === void 0 ? {} : _event_sdkProcessingMetadata;
            var req = sdkProcessingMetadata.request;
            if (!req) return event;
            // The Express request handler takes a similar `include` option to that which can be passed to this integration.
            // If passed there, we store it in `sdkProcessingMetadata`. TODO(v8): Force express and GCP people to use this
            // integration, so that all of this passing and conversion isn't necessary
            var addRequestDataOptions = sdkProcessingMetadata.requestDataOptionsFromExpressHandler || sdkProcessingMetadata.requestDataOptionsFromGCPWrapper || convertReqDataIntegrationOptsToAddReqDataOpts(_options);
            var processedEvent = _addRequestData(event, req, addRequestDataOptions);
            // Transaction events already have the right `transaction` value
            if (event.type === 'transaction' || transactionNamingScheme === 'handler') return processedEvent;
            // In all other cases, use the request's associated transaction (if any) to overwrite the event's `transaction`
            // value with a high-quality one
            var reqWithTransaction = req;
            var transaction = reqWithTransaction._sentryTransaction;
            if (transaction) {
                var name = (0, _spanUtilsJs.spanToJSON)(transaction).description || '';
                // TODO (v8): Remove the nextjs check and just base it on `transactionNamingScheme` for all SDKs. (We have to
                // keep it the way it is for the moment, because changing the names of transactions in Sentry has the potential
                // to break things like alert rules.)
                var shouldIncludeMethodInTransactionName = getSDKName(client) === 'sentry.javascript.nextjs' ? name.startsWith('/api') : transactionNamingScheme !== 'path';
                var _extractPathForTransaction = (0, _slicedToArray._)((0, _utils.extractPathForTransaction)(req, {
                    path: true,
                    method: shouldIncludeMethodInTransactionName,
                    customRoute: name
                }), 1), transactionValue = _extractPathForTransaction[0];
                processedEvent.transaction = transactionValue;
            }
            return processedEvent;
        }
    };
};
var requestDataIntegration = (0, _integrationJs.defineIntegration)(_requestDataIntegration);
/**
 * Add data about a request to an event. Primarily for use in Node-based SDKs, but included in `@sentry/integrations`
 * so it can be used in cross-platform SDKs like `@sentry/nextjs`.
 * @deprecated Use `requestDataIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
var RequestData = (0, _integrationJs.convertIntegrationFnToClass)(INTEGRATION_NAME, requestDataIntegration);
/** Convert this integration's options to match what `addRequestDataToEvent` expects */ /** TODO: Can possibly be deleted once https://github.com/getsentry/sentry-javascript/issues/5718 is fixed */ function convertReqDataIntegrationOptsToAddReqDataOpts(integrationOptions) {
    var transactionNamingScheme = integrationOptions.transactionNamingScheme, _integrationOptions_include = integrationOptions.include, ip = _integrationOptions_include.ip, user = _integrationOptions_include.user, requestOptions = (0, _objectWithoutProperties._)(integrationOptions.include, [
        "ip",
        "user"
    ]);
    var requestIncludeKeys = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(requestOptions)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, _slicedToArray._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            if (value) requestIncludeKeys.push(key);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var addReqDataUserOpt;
    if (user === undefined) addReqDataUserOpt = true;
    else if (typeof user === 'boolean') addReqDataUserOpt = user;
    else {
        var userIncludeKeys = [];
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = Object.entries(user)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var _step_value1 = (0, _slicedToArray._)(_step1.value, 2), key1 = _step_value1[0], value1 = _step_value1[1];
                if (value1) userIncludeKeys.push(key1);
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        addReqDataUserOpt = userIncludeKeys;
    }
    return {
        include: {
            ip: ip,
            user: addReqDataUserOpt,
            request: requestIncludeKeys.length !== 0 ? requestIncludeKeys : undefined,
            transaction: transactionNamingScheme
        }
    };
}
function getSDKName(client) {
    try {
        // For a long chain like this, it's fewer bytes to combine a try-catch with assuming everything is there than to
        // write out a long chain of `a && a.b && a.b.c && ...`
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return client.getOptions()._metadata.sdk.name;
    } catch (err) {
        // In theory we should never get here
        return undefined;
    }
}

},{"@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_object_spread_props":"fLCYP","@swc/helpers/_/_object_without_properties":"1waVD","@swc/helpers/_/_sliced_to_array":"ha6sq","@sentry/utils":"gElXU","../integration.js":"dKOes","../utils/spanUtils.js":"ce0Ij","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"dgoRx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InboundFilters", function() {
    return InboundFilters;
});
parcelHelpers.export(exports, "inboundFiltersIntegration", function() {
    return inboundFiltersIntegration;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _utils = require("@sentry/utils");
var _debugBuildJs = require("../debug-build.js");
var _integrationJs = require("../integration.js");
// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
var DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/
];
var DEFAULT_IGNORE_TRANSACTIONS = [
    /^.*\/healthcheck$/,
    /^.*\/healthy$/,
    /^.*\/live$/,
    /^.*\/ready$/,
    /^.*\/heartbeat$/,
    /^.*\/health$/,
    /^.*\/healthz$/
];
/** Options for the InboundFilters integration */ var INTEGRATION_NAME = 'InboundFilters';
var _inboundFiltersIntegration = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return {
        name: INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce: function() {},
        processEvent: function(event, _hint, client) {
            var clientOptions = client.getOptions();
            var mergedOptions = _mergeOptions(options, clientOptions);
            return _shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
};
var inboundFiltersIntegration = (0, _integrationJs.defineIntegration)(_inboundFiltersIntegration);
/**
 * Inbound filters configurable by the user.
 * @deprecated Use `inboundFiltersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
var InboundFilters = (0, _integrationJs.convertIntegrationFnToClass)(INTEGRATION_NAME, inboundFiltersIntegration);
function _mergeOptions() {
    var internalOptions = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, clientOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return {
        allowUrls: (0, _toConsumableArray._)(internalOptions.allowUrls || []).concat((0, _toConsumableArray._)(clientOptions.allowUrls || [])),
        denyUrls: (0, _toConsumableArray._)(internalOptions.denyUrls || []).concat((0, _toConsumableArray._)(clientOptions.denyUrls || [])),
        ignoreErrors: (0, _toConsumableArray._)(internalOptions.ignoreErrors || []).concat((0, _toConsumableArray._)(clientOptions.ignoreErrors || []), (0, _toConsumableArray._)(internalOptions.disableErrorDefaults ? [] : DEFAULT_IGNORE_ERRORS)),
        ignoreTransactions: (0, _toConsumableArray._)(internalOptions.ignoreTransactions || []).concat((0, _toConsumableArray._)(clientOptions.ignoreTransactions || []), (0, _toConsumableArray._)(internalOptions.disableTransactionDefaults ? [] : DEFAULT_IGNORE_TRANSACTIONS)),
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
function _shouldDropEvent(event, options) {
    if (options.ignoreInternal && _isSentryError(event)) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0, _utils.getEventDescription)(event)}`);
        return true;
    }
    if (_isIgnoredError(event, options.ignoreErrors)) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, _utils.getEventDescription)(event)}`);
        return true;
    }
    if (_isIgnoredTransaction(event, options.ignoreTransactions)) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, _utils.getEventDescription)(event)}`);
        return true;
    }
    if (_isDeniedUrl(event, options.denyUrls)) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, _utils.getEventDescription)(event)}.\nUrl: ${_getEventFilterUrl(event)}`);
        return true;
    }
    if (!_isAllowedUrl(event, options.allowUrls)) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, _utils.getEventDescription)(event)}.\nUrl: ${_getEventFilterUrl(event)}`);
        return true;
    }
    return false;
}
function _isIgnoredError(event, ignoreErrors) {
    // If event.type, this is not an error
    if (event.type || !ignoreErrors || !ignoreErrors.length) return false;
    return _getPossibleEventMessages(event).some(function(message) {
        return (0, _utils.stringMatchesSomePattern)(message, ignoreErrors);
    });
}
function _isIgnoredTransaction(event, ignoreTransactions) {
    if (event.type !== 'transaction' || !ignoreTransactions || !ignoreTransactions.length) return false;
    var name = event.transaction;
    return name ? (0, _utils.stringMatchesSomePattern)(name, ignoreTransactions) : false;
}
function _isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    var url = _getEventFilterUrl(event);
    return !url ? false : (0, _utils.stringMatchesSomePattern)(url, denyUrls);
}
function _isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    var url = _getEventFilterUrl(event);
    return !url ? true : (0, _utils.stringMatchesSomePattern)(url, allowUrls);
}
function _getPossibleEventMessages(event) {
    var possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    var lastException;
    try {
        // @ts-expect-error Try catching to save bundle size
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        lastException = event.exception.values[event.exception.values.length - 1];
    } catch (e) {
    // try catching to save bundle size checking existence of variables
    }
    if (lastException) {
        if (lastException.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    }
    if ((0, _debugBuildJs.DEBUG_BUILD) && possibleMessages.length === 0) (0, _utils.logger).error(`Could not extract message for event ${(0, _utils.getEventDescription)(event)}`);
    return possibleMessages;
}
function _isSentryError(event) {
    try {
        // @ts-expect-error can't be a sentry error if undefined
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return event.exception.values[0].type === 'SentryError';
    } catch (e) {
    // ignore
    }
    return false;
}
function _getLastValidUrl() {
    var frames = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    for(var i = frames.length - 1; i >= 0; i--){
        var frame = frames[i];
        if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') return frame.filename || null;
    }
    return null;
}
function _getEventFilterUrl(event) {
    try {
        var frames;
        try {
            // @ts-expect-error we only care about frames if the whole thing here is defined
            frames = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames ? _getLastValidUrl(frames) : null;
    } catch (oO) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).error(`Cannot extract url for event ${(0, _utils.getEventDescription)(event)}`);
        return null;
    }
}

},{"@swc/helpers/_/_to_consumable_array":"eqNDD","@sentry/utils":"gElXU","../debug-build.js":"4R9PX","../integration.js":"dKOes","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jjoeh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// eslint-disable-next-line deprecation/deprecation
parcelHelpers.export(exports, "FunctionToString", function() {
    return FunctionToString;
});
parcelHelpers.export(exports, "functionToStringIntegration", function() {
    return functionToStringIntegration;
});
var _utils = require("@sentry/utils");
var _exportsJs = require("../exports.js");
var _integrationJs = require("../integration.js");
var originalFunctionToString;
var INTEGRATION_NAME = 'FunctionToString';
var SETUP_CLIENTS = new WeakMap();
var _functionToStringIntegration = function() {
    return {
        name: INTEGRATION_NAME,
        setupOnce: function() {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                Function.prototype.toString = function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = arguments[_key];
                    }
                    var originalFunction = (0, _utils.getOriginalFunction)(this);
                    var context = SETUP_CLIENTS.has((0, _exportsJs.getClient)()) && originalFunction !== undefined ? originalFunction : this;
                    return originalFunctionToString.apply(context, args);
                };
            } catch (e) {
            // ignore errors here, just don't patch this
            }
        },
        setup: function(client) {
            SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ var functionToStringIntegration = (0, _integrationJs.defineIntegration)(_functionToStringIntegration);
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * @deprecated Use `functionToStringIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
var FunctionToString = (0, _integrationJs.convertIntegrationFnToClass)(INTEGRATION_NAME, functionToStringIntegration);

},{"@sentry/utils":"gElXU","../exports.js":"1Khf7","../integration.js":"dKOes","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"kY9ai":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LinkedErrors", function() {
    return LinkedErrors;
});
parcelHelpers.export(exports, "linkedErrorsIntegration", function() {
    return linkedErrorsIntegration;
});
var _utils = require("@sentry/utils");
var _integrationJs = require("../integration.js");
var DEFAULT_KEY = 'cause';
var DEFAULT_LIMIT = 5;
var INTEGRATION_NAME = 'LinkedErrors';
var _linkedErrorsIntegration = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var limit = options.limit || DEFAULT_LIMIT;
    var key = options.key || DEFAULT_KEY;
    return {
        name: INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce: function() {},
        preprocessEvent: function(event, hint, client) {
            var options = client.getOptions();
            (0, _utils.applyAggregateErrorsToEvent)((0, _utils.exceptionFromError), options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
var linkedErrorsIntegration = (0, _integrationJs.defineIntegration)(_linkedErrorsIntegration);
/**
 * Adds SDK info to an event.
 * @deprecated Use `linkedErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
var LinkedErrors = (0, _integrationJs.convertIntegrationFnToClass)(INTEGRATION_NAME, linkedErrorsIntegration);

},{"@sentry/utils":"gElXU","../integration.js":"dKOes","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3D9in":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FunctionToString", function() {
    return 0, _functiontostringJs.FunctionToString;
});
parcelHelpers.export(exports, "InboundFilters", function() {
    return 0, _inboundfiltersJs.InboundFilters;
});
parcelHelpers.export(exports, "LinkedErrors", function() {
    return 0, _linkederrorsJs.LinkedErrors;
}) /* eslint-disable deprecation/deprecation */ ;
var _functiontostringJs = require("./functiontostring.js");
var _inboundfiltersJs = require("./inboundfilters.js");
var _linkederrorsJs = require("./linkederrors.js");

},{"./functiontostring.js":"jjoeh","./inboundfilters.js":"dgoRx","./linkederrors.js":"kY9ai","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6RGy2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "distribution", function() {
    return distribution;
});
parcelHelpers.export(exports, "gauge", function() {
    return gauge;
});
parcelHelpers.export(exports, "increment", function() {
    return increment;
});
parcelHelpers.export(exports, "metrics", function() {
    return metrics;
});
parcelHelpers.export(exports, "set", function() {
    return set;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _utils = require("@sentry/utils");
var _debugBuildJs = require("../debug-build.js");
var _exportsJs = require("../exports.js");
var _spanUtilsJs = require("../utils/spanUtils.js");
var _constantsJs = require("./constants.js");
var _integrationJs = require("./integration.js");
function addToMetricsAggregator(metricType, name, value) {
    var data = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    var client = (0, _exportsJs.getClient)();
    var scope = (0, _exportsJs.getCurrentScope)();
    if (client) {
        if (!client.metricsAggregator) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn('No metrics aggregator enabled. Please add the MetricsAggregator integration to use metrics APIs');
            return;
        }
        var unit = data.unit, tags = data.tags, timestamp = data.timestamp;
        var _client_getOptions = client.getOptions(), release = _client_getOptions.release, environment = _client_getOptions.environment;
        // eslint-disable-next-line deprecation/deprecation
        var transaction = scope.getTransaction();
        var metricTags = {};
        if (release) metricTags.release = release;
        if (environment) metricTags.environment = environment;
        if (transaction) metricTags.transaction = (0, _spanUtilsJs.spanToJSON)(transaction).description || '';
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log(`Adding value of ${value} to ${metricType} metric ${name}`);
        client.metricsAggregator.add(metricType, name, value, unit, (0, _objectSpread._)({}, metricTags, tags), timestamp);
    }
}
/**
 * Adds a value to a counter metric
 *
 * @experimental This API is experimental and might have breaking changes in the future.
 */ function increment(name) {
    var value = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, data = arguments.length > 2 ? arguments[2] : void 0;
    addToMetricsAggregator((0, _constantsJs.COUNTER_METRIC_TYPE), name, value, data);
}
/**
 * Adds a value to a distribution metric
 *
 * @experimental This API is experimental and might have breaking changes in the future.
 */ function distribution(name, value, data) {
    addToMetricsAggregator((0, _constantsJs.DISTRIBUTION_METRIC_TYPE), name, value, data);
}
/**
 * Adds a value to a set metric. Value must be a string or integer.
 *
 * @experimental This API is experimental and might have breaking changes in the future.
 */ function set(name, value, data) {
    addToMetricsAggregator((0, _constantsJs.SET_METRIC_TYPE), name, value, data);
}
/**
 * Adds a value to a gauge metric
 *
 * @experimental This API is experimental and might have breaking changes in the future.
 */ function gauge(name, value, data) {
    addToMetricsAggregator((0, _constantsJs.GAUGE_METRIC_TYPE), name, value, data);
}
var metrics = {
    increment: increment,
    distribution: distribution,
    set: set,
    gauge: gauge,
    /** @deprecated Use `metrics.metricsAggregratorIntegration()` instead. */ // eslint-disable-next-line deprecation/deprecation
    MetricsAggregator: (0, _integrationJs.MetricsAggregator),
    metricsAggregatorIntegration: (0, _integrationJs.metricsAggregatorIntegration)
};

},{"@swc/helpers/_/_object_spread":"4bEWH","@sentry/utils":"gElXU","../debug-build.js":"4R9PX","../exports.js":"1Khf7","../utils/spanUtils.js":"ce0Ij","./constants.js":"jj1Q5","./integration.js":"faMh0","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"faMh0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MetricsAggregator", function() {
    return MetricsAggregator;
});
parcelHelpers.export(exports, "metricsAggregatorIntegration", function() {
    return metricsAggregatorIntegration;
});
var _integrationJs = require("../integration.js");
var _browserAggregatorJs = require("./browser-aggregator.js");
var INTEGRATION_NAME = 'MetricsAggregator';
var _metricsAggregatorIntegration = function() {
    return {
        name: INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce: function() {},
        setup: function(client) {
            client.metricsAggregator = new (0, _browserAggregatorJs.BrowserMetricsAggregator)(client);
        }
    };
};
var metricsAggregatorIntegration = (0, _integrationJs.defineIntegration)(_metricsAggregatorIntegration);
/**
 * Enables Sentry metrics monitoring.
 *
 * @experimental This API is experimental and might having breaking changes in the future.
 * @deprecated Use `metricsAggegratorIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
var MetricsAggregator = (0, _integrationJs.convertIntegrationFnToClass)(INTEGRATION_NAME, metricsAggregatorIntegration);

},{"../integration.js":"dKOes","./browser-aggregator.js":"8jJbk","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8jJbk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BrowserMetricsAggregator", function() {
    return BrowserMetricsAggregator;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _utils = require("@sentry/utils");
var _constantsJs = require("./constants.js");
var _instanceJs = require("./instance.js");
var _metricSummaryJs = require("./metric-summary.js");
var _utilsJs = require("./utils.js");
/**
 * A simple metrics aggregator that aggregates metrics in memory and flushes them periodically.
 * Default flush interval is 5 seconds.
 *
 * @experimental This API is experimental and might change in the future.
 */ var BrowserMetricsAggregator = /*#__PURE__*/ function() {
    "use strict";
    function BrowserMetricsAggregator(_client) {
        var _this = this;
        (0, _classCallCheck._)(this, BrowserMetricsAggregator);
        this._client = _client;
        this._buckets = new Map();
        this._interval = setInterval(function() {
            return _this.flush();
        }, (0, _constantsJs.DEFAULT_BROWSER_FLUSH_INTERVAL));
    }
    (0, _createClass._)(BrowserMetricsAggregator, [
        {
            /**
   * @inheritDoc
   */ key: "add",
            value: function add(metricType, unsanitizedName, value) {
                var unsanitizedUnit = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 'none', unsanitizedTags = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {}, maybeFloatTimestamp = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : (0, _utils.timestampInSeconds)();
                var timestamp = Math.floor(maybeFloatTimestamp);
                var name = (0, _utilsJs.sanitizeMetricKey)(unsanitizedName);
                var tags = (0, _utilsJs.sanitizeTags)(unsanitizedTags);
                var unit = (0, _utilsJs.sanitizeUnit)(unsanitizedUnit);
                var bucketKey = (0, _utilsJs.getBucketKey)(metricType, name, unit, tags);
                var bucketItem = this._buckets.get(bucketKey);
                // If this is a set metric, we need to calculate the delta from the previous weight.
                var previousWeight = bucketItem && metricType === (0, _constantsJs.SET_METRIC_TYPE) ? bucketItem.metric.weight : 0;
                if (bucketItem) {
                    bucketItem.metric.add(value);
                    // TODO(abhi): Do we need this check?
                    if (bucketItem.timestamp < timestamp) bucketItem.timestamp = timestamp;
                } else {
                    bucketItem = {
                        // @ts-expect-error we don't need to narrow down the type of value here, saves bundle size.
                        metric: new (0, _instanceJs.METRIC_MAP)[metricType](value),
                        timestamp: timestamp,
                        metricType: metricType,
                        name: name,
                        unit: unit,
                        tags: tags
                    };
                    this._buckets.set(bucketKey, bucketItem);
                }
                // If value is a string, it's a set metric so calculate the delta from the previous weight.
                var val = typeof value === 'string' ? bucketItem.metric.weight - previousWeight : value;
                (0, _metricSummaryJs.updateMetricSummaryOnActiveSpan)(metricType, name, val, unit, unsanitizedTags, bucketKey);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "flush",
            value: function flush() {
                // short circuit if buckets are empty.
                if (this._buckets.size === 0) return;
                if (this._client.captureAggregateMetrics) {
                    // TODO(@anonrig): Use Object.values() when we support ES6+
                    var metricBuckets = Array.from(this._buckets).map(function(param) {
                        var _param = (0, _slicedToArray._)(param, 2), bucketItem = _param[1];
                        return bucketItem;
                    });
                    this._client.captureAggregateMetrics(metricBuckets);
                }
                this._buckets.clear();
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "close",
            value: function close() {
                clearInterval(this._interval);
                this.flush();
            }
        }
    ]);
    return BrowserMetricsAggregator;
}();

},{"@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","@swc/helpers/_/_sliced_to_array":"ha6sq","@sentry/utils":"gElXU","./constants.js":"jj1Q5","./instance.js":"4BMsE","./metric-summary.js":"1EBEa","./utils.js":"eoxAY","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gFT9f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WINDOW", function() {
    return WINDOW;
});
parcelHelpers.export(exports, "ignoreNextOnError", function() {
    return ignoreNextOnError;
});
parcelHelpers.export(exports, "shouldIgnoreOnError", function() {
    return shouldIgnoreOnError;
});
parcelHelpers.export(exports, "wrap", function() {
    return wrap;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _tracing = require("@sentry-internal/tracing");
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
var WINDOW = (0, _utils.GLOBAL_OBJ);
var ignoreOnError = 0;
/**
 * @hidden
 */ function shouldIgnoreOnError() {
    return ignoreOnError > 0;
}
/**
 * @hidden
 */ function ignoreNextOnError() {
    // onerror should trigger before setTimeout
    ignoreOnError++;
    setTimeout(function() {
        ignoreOnError--;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function wrap(fn) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, before = arguments.length > 2 ? arguments[2] : void 0;
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (typeof fn !== 'function') return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        var wrapper = fn.__sentry_wrapped__;
        if (wrapper) {
            if (typeof wrapper === 'function') return wrapper;
            else // If we find that the `__sentry_wrapped__` function is not a function at the time of accessing it, it means
            // that something messed with it. In that case we want to return the originally passed function.
            return fn;
        }
        // We don't wanna wrap it twice
        if ((0, _utils.getOriginalFunction)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    var sentryWrapped = function sentryWrapped() {
        var args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === 'function') before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            var wrappedArguments = args.map(function(arg) {
                return wrap(arg, options);
            });
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            ignoreNextOnError();
            (0, _core.withScope)(function(scope) {
                scope.addEventProcessor(function(event) {
                    if (options.mechanism) {
                        (0, _utils.addExceptionTypeValue)(event, undefined, undefined);
                        (0, _utils.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = (0, _objectSpreadProps._)((0, _objectSpread._)({}, event.extra), {
                        arguments: args
                    });
                    return event;
                });
                (0, _core.captureException)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(var property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, _utils.markFunctionWrapped)(sentryWrapped, fn);
    (0, _utils.addNonEnumerableProperty)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        var descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
            get: function() {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}

},{"@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_object_spread_props":"fLCYP","@sentry-internal/tracing":"imA5v","@sentry/core":"8bBGI","@sentry/utils":"gElXU","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"imA5v":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IdleTransaction", function() {
    return 0, _core.IdleTransaction;
});
parcelHelpers.export(exports, "Span", function() {
    return 0, _core.Span;
});
parcelHelpers.export(exports, "SpanStatus", function() {
    return 0, _core.SpanStatus;
});
parcelHelpers.export(exports, "Transaction", function() {
    return 0, _core.Transaction;
});
parcelHelpers.export(exports, "extractTraceparentData", function() {
    return 0, _core.extractTraceparentData;
});
parcelHelpers.export(exports, "getActiveTransaction", function() {
    return 0, _core.getActiveTransaction;
});
parcelHelpers.export(exports, "hasTracingEnabled", function() {
    return 0, _core.hasTracingEnabled;
});
parcelHelpers.export(exports, "spanStatusfromHttpCode", function() {
    return 0, _core.spanStatusfromHttpCode;
});
parcelHelpers.export(exports, "startIdleTransaction", function() {
    return 0, _core.startIdleTransaction;
});
parcelHelpers.export(exports, "TRACEPARENT_REGEXP", function() {
    return 0, _utils.TRACEPARENT_REGEXP;
});
parcelHelpers.export(exports, "stripUrlQueryAndFragment", function() {
    return 0, _utils.stripUrlQueryAndFragment;
});
parcelHelpers.export(exports, "Express", function() {
    return 0, _expressJs.Express;
});
parcelHelpers.export(exports, "Postgres", function() {
    return 0, _postgresJs.Postgres;
});
parcelHelpers.export(exports, "Mysql", function() {
    return 0, _mysqlJs.Mysql;
});
parcelHelpers.export(exports, "Mongo", function() {
    return 0, _mongoJs.Mongo;
});
parcelHelpers.export(exports, "Prisma", function() {
    return 0, _prismaJs.Prisma;
});
parcelHelpers.export(exports, "GraphQL", function() {
    return 0, _graphqlJs.GraphQL;
});
parcelHelpers.export(exports, "Apollo", function() {
    return 0, _apolloJs.Apollo;
});
parcelHelpers.export(exports, "lazyLoadedNodePerformanceMonitoringIntegrations", function() {
    return 0, _lazyJs.lazyLoadedNodePerformanceMonitoringIntegrations;
});
parcelHelpers.export(exports, "BROWSER_TRACING_INTEGRATION_ID", function() {
    return 0, _browsertracingJs.BROWSER_TRACING_INTEGRATION_ID;
});
parcelHelpers.export(exports, "BrowserTracing", function() {
    return 0, _browsertracingJs.BrowserTracing;
});
parcelHelpers.export(exports, "browserTracingIntegration", function() {
    return 0, _browserTracingIntegrationJs.browserTracingIntegration;
});
parcelHelpers.export(exports, "startBrowserTracingNavigationSpan", function() {
    return 0, _browserTracingIntegrationJs.startBrowserTracingNavigationSpan;
});
parcelHelpers.export(exports, "startBrowserTracingPageLoadSpan", function() {
    return 0, _browserTracingIntegrationJs.startBrowserTracingPageLoadSpan;
});
parcelHelpers.export(exports, "defaultRequestInstrumentationOptions", function() {
    return 0, _requestJs.defaultRequestInstrumentationOptions;
});
parcelHelpers.export(exports, "instrumentOutgoingRequests", function() {
    return 0, _requestJs.instrumentOutgoingRequests;
});
parcelHelpers.export(exports, "addClsInstrumentationHandler", function() {
    return 0, _instrumentJs.addClsInstrumentationHandler;
});
parcelHelpers.export(exports, "addFidInstrumentationHandler", function() {
    return 0, _instrumentJs.addFidInstrumentationHandler;
});
parcelHelpers.export(exports, "addLcpInstrumentationHandler", function() {
    return 0, _instrumentJs.addLcpInstrumentationHandler;
});
parcelHelpers.export(exports, "addPerformanceInstrumentationHandler", function() {
    return 0, _instrumentJs.addPerformanceInstrumentationHandler;
});
parcelHelpers.export(exports, "addTracingHeadersToFetchRequest", function() {
    return 0, _fetchJs.addTracingHeadersToFetchRequest;
});
parcelHelpers.export(exports, "instrumentFetchRequest", function() {
    return 0, _fetchJs.instrumentFetchRequest;
});
parcelHelpers.export(exports, "addExtensionMethods", function() {
    return 0, _extensionsJs.addExtensionMethods;
});
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
var _expressJs = require("./node/integrations/express.js");
var _postgresJs = require("./node/integrations/postgres.js");
var _mysqlJs = require("./node/integrations/mysql.js");
var _mongoJs = require("./node/integrations/mongo.js");
var _prismaJs = require("./node/integrations/prisma.js");
var _graphqlJs = require("./node/integrations/graphql.js");
var _apolloJs = require("./node/integrations/apollo.js");
var _lazyJs = require("./node/integrations/lazy.js");
var _browsertracingJs = require("./browser/browsertracing.js");
var _browserTracingIntegrationJs = require("./browser/browserTracingIntegration.js");
var _requestJs = require("./browser/request.js");
var _instrumentJs = require("./browser/instrument.js");
var _fetchJs = require("./common/fetch.js");
var _extensionsJs = require("./extensions.js");

},{"@sentry/core":"8bBGI","@sentry/utils":"gElXU","./node/integrations/express.js":"j32C5","./node/integrations/postgres.js":"8UyK9","./node/integrations/mysql.js":"aCYBA","./node/integrations/mongo.js":"4mbRc","./node/integrations/prisma.js":"dcfCa","./node/integrations/graphql.js":"kNJIz","./node/integrations/apollo.js":"fqAwb","./node/integrations/lazy.js":"kyxXT","./browser/browsertracing.js":"eJmoM","./browser/browserTracingIntegration.js":"h9TQL","./browser/request.js":"eGI7D","./browser/instrument.js":"2jXyu","./common/fetch.js":"jfjgO","./extensions.js":"904il","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"j32C5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Express", function() {
    return Express;
});
parcelHelpers.export(exports, "extractOriginalRoute", function() {
    return extractOriginalRoute;
});
parcelHelpers.export(exports, "preventDuplicateSegments", function() {
    return preventDuplicateSegments;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toArray = require("@swc/helpers/_/_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _utils = require("@sentry/utils");
var _core = require("@sentry/core");
var _debugBuildJs = require("../../common/debug-build.js");
var _nodeUtilsJs = require("./utils/node-utils.js");
/* eslint-disable max-lines */ /**
 * Express integration
 *
 * Provides an request and error handler for Express framework as well as tracing capabilities
 */ var Express = /*#__PURE__*/ function() {
    "use strict";
    function Express() {
        var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0, _classCallCheck._)(this, Express);
        this.name = Express.id;
        this._router = options.router || options.app;
        this._methods = (Array.isArray(options.methods) ? options.methods : []).concat('use');
    }
    (0, _createClass._)(Express, [
        {
            /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
            key: "setupOnce",
            value: function setupOnce(_, getCurrentHub) {
                if (!this._router) {
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).error('ExpressIntegration is missing an Express instance');
                    return;
                }
                if ((0, _nodeUtilsJs.shouldDisableAutoInstrumentation)(getCurrentHub)) {
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log('Express Integration is skipped because of instrumenter configuration.');
                    return;
                }
                instrumentMiddlewares(this._router, this._methods);
                instrumentRouter(this._router);
            }
        }
    ], [
        {
            key: "__initStatic",
            value: /**
   * @inheritDoc
   */ function __initStatic() {
                this.id = 'Express';
            }
        }
    ]);
    return Express;
}();
Express.__initStatic();
/**
 * Wraps original middleware function in a tracing call, which stores the info about the call as a span,
 * and finishes it once the middleware is done invoking.
 *
 * Express middlewares have 3 various forms, thus we have to take care of all of them:
 * // sync
 * app.use(function (req, res) { ... })
 * // async
 * app.use(function (req, res, next) { ... })
 * // error handler
 * app.use(function (err, req, res, next) { ... })
 *
 * They all internally delegate to the `router[method]` of the given application instance.
 */ // eslint-disable-next-line @typescript-eslint/ban-types, @typescript-eslint/no-explicit-any
function wrap(fn, method) {
    var arity = fn.length;
    switch(arity){
        case 2:
            return function(req, res) {
                var transaction = res.__sentry_transaction;
                if (transaction) {
                    // eslint-disable-next-line deprecation/deprecation
                    var span = transaction.startChild({
                        description: fn.name,
                        op: `middleware.express.${method}`,
                        origin: 'auto.middleware.express'
                    });
                    res.once('finish', function() {
                        span.end();
                    });
                }
                return fn.call(this, req, res);
            };
        case 3:
            return function(req, res, next) {
                var transaction = res.__sentry_transaction;
                // eslint-disable-next-line deprecation/deprecation
                var span = (0, _utils._optionalChain)([
                    transaction,
                    'optionalAccess',
                    function(_2) {
                        return _2.startChild;
                    },
                    'call',
                    function(_3) {
                        return _3({
                            description: fn.name,
                            op: `middleware.express.${method}`,
                            origin: 'auto.middleware.express'
                        });
                    }
                ]);
                fn.call(this, req, res, function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = arguments[_key];
                    }
                    var _next;
                    (0, _utils._optionalChain)([
                        span,
                        'optionalAccess',
                        function(_4) {
                            return _4.end;
                        },
                        'call',
                        function(_5) {
                            return _5();
                        }
                    ]);
                    (_next = next).call.apply(_next, [
                        this
                    ].concat((0, _toConsumableArray._)(args)));
                });
            };
        case 4:
            return function(err, req, res, next) {
                var transaction = res.__sentry_transaction;
                // eslint-disable-next-line deprecation/deprecation
                var span = (0, _utils._optionalChain)([
                    transaction,
                    'optionalAccess',
                    function(_6) {
                        return _6.startChild;
                    },
                    'call',
                    function(_7) {
                        return _7({
                            description: fn.name,
                            op: `middleware.express.${method}`,
                            origin: 'auto.middleware.express'
                        });
                    }
                ]);
                fn.call(this, err, req, res, function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = arguments[_key];
                    }
                    var _next;
                    (0, _utils._optionalChain)([
                        span,
                        'optionalAccess',
                        function(_8) {
                            return _8.end;
                        },
                        'call',
                        function(_9) {
                            return _9();
                        }
                    ]);
                    (_next = next).call.apply(_next, [
                        this
                    ].concat((0, _toConsumableArray._)(args)));
                });
            };
        default:
            throw new Error(`Express middleware takes 2-4 arguments. Got: ${arity}`);
    }
}
/**
 * Takes all the function arguments passed to the original `app` or `router` method, eg. `app.use` or `router.use`
 * and wraps every function, as well as array of functions with a call to our `wrap` method.
 * We have to take care of the arrays as well as iterate over all of the arguments,
 * as `app.use` can accept middlewares in few various forms.
 *
 * app.use([<path>], <fn>)
 * app.use([<path>], <fn>, ...<fn>)
 * app.use([<path>], ...<fn>[])
 */ function wrapMiddlewareArgs(args, method) {
    return args.map(function(arg) {
        if (typeof arg === 'function') return wrap(arg, method);
        if (Array.isArray(arg)) return arg.map(function(a) {
            if (typeof a === 'function') return wrap(a, method);
            return a;
        });
        return arg;
    });
}
/**
 * Patches original router to utilize our tracing functionality
 */ function patchMiddleware(router, method) {
    var originalCallback = router[method];
    router[method] = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _originalCallback;
        return (_originalCallback = originalCallback).call.apply(_originalCallback, [
            this
        ].concat((0, _toConsumableArray._)(wrapMiddlewareArgs(args, method))));
    };
    return router;
}
/**
 * Patches original router methods
 */ function instrumentMiddlewares(router) {
    var methods = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    methods.forEach(function(method) {
        return patchMiddleware(router, method);
    });
}
/**
 * Patches the prototype of Express.Router to accumulate the resolved route
 * if a layer instance's `match` function was called and it returned a successful match.
 *
 * @see https://github.com/expressjs/express/blob/master/lib/router/index.js
 *
 * @param appOrRouter the router instance which can either be an app (i.e. top-level) or a (nested) router.
 */ function instrumentRouter(appOrRouter) {
    // This is how we can distinguish between app and routers
    var isApp = 'settings' in appOrRouter;
    // In case the app's top-level router hasn't been initialized yet, we have to do it now
    if (isApp && appOrRouter._router === undefined && appOrRouter.lazyrouter) appOrRouter.lazyrouter();
    var router = isApp ? appOrRouter._router : appOrRouter;
    if (!router) {
        /*
    If we end up here, this means likely that this integration is used with Express 3 or Express 5.
    For now, we don't support these versions (3 is very old and 5 is still in beta). To support Express 5,
    we'd need to make more changes to the routing instrumentation because the router is no longer part of
    the Express core package but maintained in its own package. The new router has different function
    signatures and works slightly differently, demanding more changes than just taking the router from
    `app.router` instead of `app._router`.
    @see https://github.com/pillarjs/router

    TODO: Proper Express 5 support
    */ (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).debug('Cannot instrument router for URL Parameterization (did not find a valid router).');
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).debug('Routing instrumentation is currently only supported in Express 4.');
        return;
    }
    var routerProto = Object.getPrototypeOf(router);
    var originalProcessParams = routerProto.process_params;
    routerProto.process_params = function process_params(layer, called, req, res, done) {
        // Base case: We're in the first part of the URL (thus we start with the root '/')
        if (!req._reconstructedRoute) req._reconstructedRoute = '';
        // If the layer's partial route has params, is a regex or an array, the route is stored in layer.route.
        var _getLayerRoutePathInfo = getLayerRoutePathInfo(layer), layerRoutePath = _getLayerRoutePathInfo.layerRoutePath, isRegex = _getLayerRoutePathInfo.isRegex, isArray = _getLayerRoutePathInfo.isArray, numExtraSegments = _getLayerRoutePathInfo.numExtraSegments;
        if (layerRoutePath || isRegex || isArray) req._hasParameters = true;
        // Otherwise, the hardcoded path (i.e. a partial route without params) is stored in layer.path
        var partialRoute;
        if (layerRoutePath) partialRoute = layerRoutePath;
        else /**
       * prevent duplicate segment in _reconstructedRoute param if router match multiple routes before final path
       * example:
       * original url: /api/v1/1234
       * prevent: /api/api/v1/:userId
       * router structure
       * /api -> middleware
       * /api/v1 -> middleware
       * /1234 -> endpoint with param :userId
       * final _reconstructedRoute is /api/v1/:userId
       */ partialRoute = preventDuplicateSegments(req.originalUrl, req._reconstructedRoute, layer.path) || '';
        // Normalize the partial route so that it doesn't contain leading or trailing slashes
        // and exclude empty or '*' wildcard routes.
        // The exclusion of '*' routes is our best effort to not "pollute" the transaction name
        // with interim handlers (e.g. ones that check authentication or do other middleware stuff).
        // We want to end up with the parameterized URL of the incoming request without any extraneous path segments.
        var finalPartialRoute = partialRoute.split('/').filter(function(segment) {
            return segment.length > 0 && (isRegex || isArray || !segment.includes('*'));
        }).join('/');
        // If we found a valid partial URL, we append it to the reconstructed route
        if (finalPartialRoute && finalPartialRoute.length > 0) // If the partial route is from a regex route, we append a '/' to close the regex
        req._reconstructedRoute += `/${finalPartialRoute}${isRegex ? '/' : ''}`;
        // Now we check if we are in the "last" part of the route. We determine this by comparing the
        // number of URL segments from the original URL to that of our reconstructed parameterized URL.
        // If we've reached our final destination, we update the transaction name.
        var urlLength = (0, _utils.getNumberOfUrlSegments)((0, _utils.stripUrlQueryAndFragment)(req.originalUrl || '')) + numExtraSegments;
        var routeLength = (0, _utils.getNumberOfUrlSegments)(req._reconstructedRoute);
        if (urlLength === routeLength) {
            if (!req._hasParameters) {
                if (req._reconstructedRoute !== req.originalUrl) req._reconstructedRoute = req.originalUrl ? (0, _utils.stripUrlQueryAndFragment)(req.originalUrl) : req.originalUrl;
            }
            var transaction = res.__sentry_transaction;
            var attributes = transaction && (0, _core.spanToJSON)(transaction).data || {};
            if (transaction && attributes[0, _core.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] !== 'custom') {
                // If the request URL is '/' or empty, the reconstructed route will be empty.
                // Therefore, we fall back to setting the final route to '/' in this case.
                var finalRoute = req._reconstructedRoute || '/';
                var _extractPathForTransaction = (0, _slicedToArray._)((0, _utils.extractPathForTransaction)(req, {
                    path: true,
                    method: true,
                    customRoute: finalRoute
                }), 2), name = _extractPathForTransaction[0], source = _extractPathForTransaction[1];
                transaction.updateName(name);
                transaction.setAttribute((0, _core.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), source);
            }
        }
        return originalProcessParams.call(this, layer, called, req, res, done);
    };
}
/**
 * Recreate layer.route.path from layer.regexp and layer.keys.
 * Works until express.js used package path-to-regexp@0.1.7
 * or until layer.keys contain offset attribute
 *
 * @param layer the layer to extract the stringified route from
 *
 * @returns string in layer.route.path structure 'router/:pathParam' or undefined
 */ var extractOriginalRoute = function(path, regexp, keys) {
    if (!path || !regexp || !keys || Object.keys(keys).length === 0 || (0, _utils._optionalChain)([
        keys,
        'access',
        function(_10) {
            return _10[0];
        },
        'optionalAccess',
        function(_11) {
            return _11.offset;
        }
    ]) === undefined || (0, _utils._optionalChain)([
        keys,
        'access',
        function(_12) {
            return _12[0];
        },
        'optionalAccess',
        function(_13) {
            return _13.offset;
        }
    ]) === null) return undefined;
    var orderedKeys = keys.sort(function(a, b) {
        return a.offset - b.offset;
    });
    // add d flag for getting indices from regexp result
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- regexp comes from express.js
    var pathRegex = new RegExp(regexp, `${regexp.flags}d`);
    /**
   * use custom type cause of TS error with missing indices in RegExpExecArray
   */ var execResult = pathRegex.exec(path);
    if (!execResult || !execResult.indices) return undefined;
    /**
   * remove first match from regex cause contain whole layer.path
   */ var _execResult_indices = (0, _toArray._)(execResult.indices), paramIndices = _execResult_indices.slice(1);
    if (paramIndices.length !== orderedKeys.length) return undefined;
    var resultPath = path;
    var indexShift = 0;
    /**
   * iterate param matches from regexp.exec
   */ paramIndices.forEach(function(item, index) {
        /** check if offsets is define because in some cases regex d flag returns undefined */ if (item) {
            var _item = (0, _slicedToArray._)(item, 2), startOffset = _item[0], endOffset = _item[1];
            /**
       * isolate part before param
       */ var substr1 = resultPath.substring(0, startOffset - indexShift);
            /**
       * define paramName as replacement in format :pathParam
       */ var replacement = `:${orderedKeys[index].name}`;
            /**
       * isolate part after param
       */ var substr2 = resultPath.substring(endOffset - indexShift);
            /**
       * recreate original path but with param replacement
       */ resultPath = substr1 + replacement + substr2;
            /**
       * calculate new index shift after resultPath was modified
       */ indexShift = indexShift + (endOffset - startOffset - replacement.length);
        }
    });
    return resultPath;
};
/**
 * Extracts and stringifies the layer's route which can either be a string with parameters (`users/:id`),
 * a RegEx (`/test/`) or an array of strings and regexes (`['/path1', /\/path[2-5]/, /path/:id]`). Additionally
 * returns extra information about the route, such as if the route is defined as regex or as an array.
 *
 * @param layer the layer to extract the stringified route from
 *
 * @returns an object containing the stringified route, a flag determining if the route was a regex
 *          and the number of extra segments to the matched path that are additionally in the route,
 *          if the route was an array (defaults to 0).
 */ function getLayerRoutePathInfo(layer) {
    var lrp = (0, _utils._optionalChain)([
        layer,
        'access',
        function(_14) {
            return _14.route;
        },
        'optionalAccess',
        function(_15) {
            return _15.path;
        }
    ]);
    var isRegex = (0, _utils.isRegExp)(lrp);
    var isArray = Array.isArray(lrp);
    if (!lrp) {
        // parse node.js major version
        // Next.js will complain if we directly use `proces.versions` here because of edge runtime.
        var _GLOBAL_OBJ_process_versions_node_split_map = (0, _slicedToArray._)((0, _utils.GLOBAL_OBJ).process.versions.node.split('.').map(Number), 1), major = _GLOBAL_OBJ_process_versions_node_split_map[0];
        // allow call extractOriginalRoute only if node version support Regex d flag, node 16+
        if (major >= 16) /**
       * If lrp does not exist try to recreate original layer path from route regexp
       */ lrp = extractOriginalRoute(layer.path, layer.regexp, layer.keys);
    }
    if (!lrp) return {
        isRegex: isRegex,
        isArray: isArray,
        numExtraSegments: 0
    };
    var numExtraSegments = isArray ? Math.max(getNumberOfArrayUrlSegments(lrp) - (0, _utils.getNumberOfUrlSegments)(layer.path || ''), 0) : 0;
    var layerRoutePath = getLayerRoutePathString(isArray, lrp);
    return {
        layerRoutePath: layerRoutePath,
        isRegex: isRegex,
        isArray: isArray,
        numExtraSegments: numExtraSegments
    };
}
/**
 * Returns the number of URL segments in an array of routes
 *
 * Example: ['/api/test', /\/api\/post[0-9]/, '/users/:id/details`] -> 7
 */ function getNumberOfArrayUrlSegments(routesArray) {
    return routesArray.reduce(function(accNumSegments, currentRoute) {
        // array members can be a RegEx -> convert them toString
        return accNumSegments + (0, _utils.getNumberOfUrlSegments)(currentRoute.toString());
    }, 0);
}
/**
 * Extracts and returns the stringified version of the layers route path
 * Handles route arrays (by joining the paths together) as well as RegExp and normal
 * string values (in the latter case the toString conversion is technically unnecessary but
 * it doesn't hurt us either).
 */ function getLayerRoutePathString(isArray, lrp) {
    if (isArray) return lrp.map(function(r) {
        return r.toString();
    }).join(',');
    return lrp && lrp.toString();
}
/**
 * remove duplicate segment contain in layerPath against reconstructedRoute,
 * and return only unique segment that can be added into reconstructedRoute
 */ function preventDuplicateSegments(originalUrl, reconstructedRoute, layerPath) {
    // filter query params
    var normalizeURL = (0, _utils.stripUrlQueryAndFragment)(originalUrl || '');
    var originalUrlSplit = (0, _utils._optionalChain)([
        normalizeURL,
        'optionalAccess',
        function(_16) {
            return _16.split;
        },
        'call',
        function(_17) {
            return _17('/');
        },
        'access',
        function(_18) {
            return _18.filter;
        },
        'call',
        function(_19) {
            return _19(function(v) {
                return !!v;
            });
        }
    ]);
    var tempCounter = 0;
    var currentOffset = (0, _utils._optionalChain)([
        reconstructedRoute,
        'optionalAccess',
        function(_20) {
            return _20.split;
        },
        'call',
        function(_21) {
            return _21('/');
        },
        'access',
        function(_22) {
            return _22.filter;
        },
        'call',
        function(_23) {
            return _23(function(v) {
                return !!v;
            });
        },
        'access',
        function(_24) {
            return _24.length;
        }
    ]) || 0;
    var result = (0, _utils._optionalChain)([
        layerPath,
        'optionalAccess',
        function(_25) {
            return _25.split;
        },
        'call',
        function(_26) {
            return _26('/');
        },
        'access',
        function(_27) {
            return _27.filter;
        },
        'call',
        function(_28) {
            return _28(function(segment) {
                if ((0, _utils._optionalChain)([
                    originalUrlSplit,
                    'optionalAccess',
                    function(_29) {
                        return _29[currentOffset + tempCounter];
                    }
                ]) === segment) {
                    tempCounter += 1;
                    return true;
                }
                return false;
            });
        },
        'access',
        function(_30) {
            return _30.join;
        },
        'call',
        function(_31) {
            return _31('/');
        }
    ]);
    return result;
}

},{"@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","@swc/helpers/_/_sliced_to_array":"ha6sq","@swc/helpers/_/_to_array":"wdLug","@swc/helpers/_/_to_consumable_array":"eqNDD","@sentry/utils":"gElXU","@sentry/core":"8bBGI","../../common/debug-build.js":"eGerB","./utils/node-utils.js":"QKyBb","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"eGerB":[function(require,module,exports,__globalThis) {
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEBUG_BUILD", function() {
    return DEBUG_BUILD;
});
var DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"QKyBb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "shouldDisableAutoInstrumentation", function() {
    return shouldDisableAutoInstrumentation;
});
var _utils = require("@sentry/utils");
/**
 * Check if Sentry auto-instrumentation should be disabled.
 *
 * @param getCurrentHub A method to fetch the current hub
 * @returns boolean
 */ // eslint-disable-next-line deprecation/deprecation
function shouldDisableAutoInstrumentation(getCurrentHub) {
    // eslint-disable-next-line deprecation/deprecation
    var clientOptions = (0, _utils._optionalChain)([
        getCurrentHub,
        'call',
        function(_) {
            return _();
        },
        'access',
        function(_2) {
            return _2.getClient;
        },
        'call',
        function(_3) {
            return _3();
        },
        'optionalAccess',
        function(_4) {
            return _4.getOptions;
        },
        'call',
        function(_5) {
            return _5();
        }
    ]);
    var instrumenter = (0, _utils._optionalChain)([
        clientOptions,
        'optionalAccess',
        function(_6) {
            return _6.instrumenter;
        }
    ]) || 'sentry';
    return instrumenter !== 'sentry';
}

},{"@sentry/utils":"gElXU","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8UyK9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Postgres", function() {
    return Postgres;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _utils = require("@sentry/utils");
var _debugBuildJs = require("../../common/debug-build.js");
var _nodeUtilsJs = require("./utils/node-utils.js");
/** Tracing integration for node-postgres package */ var Postgres = /*#__PURE__*/ function() {
    "use strict";
    function Postgres() {
        var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0, _classCallCheck._)(this, Postgres);
        this.name = Postgres.id;
        this._usePgNative = !!options.usePgNative;
        this._module = options.module;
    }
    (0, _createClass._)(Postgres, [
        {
            /** @inheritdoc */ key: "loadDependency",
            value: function loadDependency() {
                return this._module = this._module || (0, _utils.loadModule)('pg');
            }
        },
        {
            /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
            key: "setupOnce",
            value: function setupOnce(_, getCurrentHub) {
                if ((0, _nodeUtilsJs.shouldDisableAutoInstrumentation)(getCurrentHub)) {
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log('Postgres Integration is skipped because of instrumenter configuration.');
                    return;
                }
                var pkg = this.loadDependency();
                if (!pkg) {
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).error('Postgres Integration was unable to require `pg` package.');
                    return;
                }
                var Client = this._usePgNative ? (0, _utils._optionalChain)([
                    pkg,
                    'access',
                    function(_2) {
                        return _2.native;
                    },
                    'optionalAccess',
                    function(_3) {
                        return _3.Client;
                    }
                ]) : pkg.Client;
                if (!Client) {
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).error("Postgres Integration was unable to access 'pg-native' bindings.");
                    return;
                }
                /**
     * function (query, callback) => void
     * function (query, params, callback) => void
     * function (query) => Promise
     * function (query, params) => Promise
     * function (pg.Cursor) => pg.Cursor
     */ (0, _utils.fill)(Client.prototype, 'query', function(orig) {
                    return function(config, values, callback) {
                        // eslint-disable-next-line deprecation/deprecation
                        var scope = getCurrentHub().getScope();
                        // eslint-disable-next-line deprecation/deprecation
                        var parentSpan = scope.getSpan();
                        var data = {
                            'db.system': 'postgresql'
                        };
                        try {
                            if (this.database) data['db.name'] = this.database;
                            if (this.host) data['server.address'] = this.host;
                            if (this.port) data['server.port'] = this.port;
                            if (this.user) data['db.user'] = this.user;
                        } catch (e) {
                        // ignore
                        }
                        // eslint-disable-next-line deprecation/deprecation
                        var span = (0, _utils._optionalChain)([
                            parentSpan,
                            'optionalAccess',
                            function(_4) {
                                return _4.startChild;
                            },
                            'call',
                            function(_5) {
                                return _5({
                                    description: typeof config === 'string' ? config : config.text,
                                    op: 'db',
                                    origin: 'auto.db.postgres',
                                    data: data
                                });
                            }
                        ]);
                        if (typeof callback === 'function') return orig.call(this, config, values, function(err, result) {
                            (0, _utils._optionalChain)([
                                span,
                                'optionalAccess',
                                function(_6) {
                                    return _6.end;
                                },
                                'call',
                                function(_7) {
                                    return _7();
                                }
                            ]);
                            callback(err, result);
                        });
                        if (typeof values === 'function') return orig.call(this, config, function(err, result) {
                            (0, _utils._optionalChain)([
                                span,
                                'optionalAccess',
                                function(_8) {
                                    return _8.end;
                                },
                                'call',
                                function(_9) {
                                    return _9();
                                }
                            ]);
                            values(err, result);
                        });
                        var rv = typeof values !== 'undefined' ? orig.call(this, config, values) : orig.call(this, config);
                        if ((0, _utils.isThenable)(rv)) return rv.then(function(res) {
                            (0, _utils._optionalChain)([
                                span,
                                'optionalAccess',
                                function(_10) {
                                    return _10.end;
                                },
                                'call',
                                function(_11) {
                                    return _11();
                                }
                            ]);
                            return res;
                        });
                        (0, _utils._optionalChain)([
                            span,
                            'optionalAccess',
                            function(_12) {
                                return _12.end;
                            },
                            'call',
                            function(_13) {
                                return _13();
                            }
                        ]);
                        return rv;
                    };
                });
            }
        }
    ], [
        {
            key: "__initStatic",
            value: /**
   * @inheritDoc
   */ function __initStatic() {
                this.id = 'Postgres';
            }
        }
    ]);
    return Postgres;
}();
Postgres.__initStatic();

},{"@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","@sentry/utils":"gElXU","../../common/debug-build.js":"eGerB","./utils/node-utils.js":"QKyBb","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"aCYBA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Mysql", function() {
    return Mysql;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _utils = require("@sentry/utils");
var _debugBuildJs = require("../../common/debug-build.js");
var _nodeUtilsJs = require("./utils/node-utils.js");
/** Tracing integration for node-mysql package */ var Mysql = /*#__PURE__*/ function() {
    "use strict";
    function Mysql() {
        (0, _classCallCheck._)(this, Mysql);
        this.name = Mysql.id;
    }
    (0, _createClass._)(Mysql, [
        {
            /** @inheritdoc */ key: "loadDependency",
            value: function loadDependency() {
                return this._module = this._module || (0, _utils.loadModule)('mysql/lib/Connection.js');
            }
        },
        {
            /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
            key: "setupOnce",
            value: function setupOnce(_, getCurrentHub) {
                if ((0, _nodeUtilsJs.shouldDisableAutoInstrumentation)(getCurrentHub)) {
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log('Mysql Integration is skipped because of instrumenter configuration.');
                    return;
                }
                var pkg = this.loadDependency();
                if (!pkg) {
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).error('Mysql Integration was unable to require `mysql` package.');
                    return;
                }
                var mySqlConfig = undefined;
                try {
                    pkg.prototype.connect = new Proxy(pkg.prototype.connect, {
                        apply: function(wrappingTarget, thisArg, args) {
                            if (!mySqlConfig) mySqlConfig = thisArg.config;
                            return wrappingTarget.apply(thisArg, args);
                        }
                    });
                } catch (e) {
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).error('Mysql Integration was unable to instrument `mysql` config.');
                }
                function spanDataFromConfig() {
                    if (!mySqlConfig) return {};
                    return {
                        'server.address': mySqlConfig.host,
                        'server.port': mySqlConfig.port,
                        'db.user': mySqlConfig.user
                    };
                }
                function finishSpan(span) {
                    if (!span) return;
                    var data = spanDataFromConfig();
                    Object.keys(data).forEach(function(key) {
                        span.setAttribute(key, data[key]);
                    });
                    span.end();
                }
                // The original function will have one of these signatures:
                //    function (callback) => void
                //    function (options, callback) => void
                //    function (options, values, callback) => void
                (0, _utils.fill)(pkg, 'createQuery', function(orig) {
                    return function(options, values, callback) {
                        // eslint-disable-next-line deprecation/deprecation
                        var scope = getCurrentHub().getScope();
                        // eslint-disable-next-line deprecation/deprecation
                        var parentSpan = scope.getSpan();
                        // eslint-disable-next-line deprecation/deprecation
                        var span = (0, _utils._optionalChain)([
                            parentSpan,
                            'optionalAccess',
                            function(_2) {
                                return _2.startChild;
                            },
                            'call',
                            function(_3) {
                                return _3({
                                    description: typeof options === 'string' ? options : options.sql,
                                    op: 'db',
                                    origin: 'auto.db.mysql',
                                    data: {
                                        'db.system': 'mysql'
                                    }
                                });
                            }
                        ]);
                        if (typeof callback === 'function') return orig.call(this, options, values, function(err, result, fields) {
                            finishSpan(span);
                            callback(err, result, fields);
                        });
                        if (typeof values === 'function') return orig.call(this, options, function(err, result, fields) {
                            finishSpan(span);
                            values(err, result, fields);
                        });
                        // streaming, no callback!
                        var query = orig.call(this, options, values);
                        query.on('end', function() {
                            finishSpan(span);
                        });
                        return query;
                    };
                });
            }
        }
    ], [
        {
            key: "__initStatic",
            value: /**
   * @inheritDoc
   */ function __initStatic() {
                this.id = 'Mysql';
            }
        }
    ]);
    return Mysql;
}();
Mysql.__initStatic();

},{"@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","@sentry/utils":"gElXU","../../common/debug-build.js":"eGerB","./utils/node-utils.js":"QKyBb","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4mbRc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Mongo", function() {
    return Mongo;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _utils = require("@sentry/utils");
var _debugBuildJs = require("../../common/debug-build.js");
var _nodeUtilsJs = require("./utils/node-utils.js");
// This allows us to use the same array for both defaults options and the type itself.
// (note `as const` at the end to make it a union of string literal types (i.e. "a" | "b" | ... )
// and not just a string[])
var OPERATIONS = [
    'aggregate',
    'bulkWrite',
    'countDocuments',
    'createIndex',
    'createIndexes',
    'deleteMany',
    'deleteOne',
    'distinct',
    'drop',
    'dropIndex',
    'dropIndexes',
    'estimatedDocumentCount',
    'find',
    'findOne',
    'findOneAndDelete',
    'findOneAndReplace',
    'findOneAndUpdate',
    'indexes',
    'indexExists',
    'indexInformation',
    'initializeOrderedBulkOp',
    'insertMany',
    'insertOne',
    'isCapped',
    'mapReduce',
    'options',
    'parallelCollectionScan',
    'rename',
    'replaceOne',
    'stats',
    'updateMany',
    'updateOne'
];
// All of the operations above take `options` and `callback` as their final parameters, but some of them
// take additional parameters as well. For those operations, this is a map of
// { <operation name>:  [<names of additional parameters>] }, as a way to know what to call the operation's
// positional arguments when we add them to the span's `data` object later
var OPERATION_SIGNATURES = {
    // aggregate intentionally not included because `pipeline` arguments are too complex to serialize well
    // see https://github.com/getsentry/sentry-javascript/pull/3102
    bulkWrite: [
        'operations'
    ],
    countDocuments: [
        'query'
    ],
    createIndex: [
        'fieldOrSpec'
    ],
    createIndexes: [
        'indexSpecs'
    ],
    deleteMany: [
        'filter'
    ],
    deleteOne: [
        'filter'
    ],
    distinct: [
        'key',
        'query'
    ],
    dropIndex: [
        'indexName'
    ],
    find: [
        'query'
    ],
    findOne: [
        'query'
    ],
    findOneAndDelete: [
        'filter'
    ],
    findOneAndReplace: [
        'filter',
        'replacement'
    ],
    findOneAndUpdate: [
        'filter',
        'update'
    ],
    indexExists: [
        'indexes'
    ],
    insertMany: [
        'docs'
    ],
    insertOne: [
        'doc'
    ],
    mapReduce: [
        'map',
        'reduce'
    ],
    rename: [
        'newName'
    ],
    replaceOne: [
        'filter',
        'doc'
    ],
    updateMany: [
        'filter',
        'update'
    ],
    updateOne: [
        'filter',
        'update'
    ]
};
function isCursor(maybeCursor) {
    return maybeCursor && typeof maybeCursor === 'object' && maybeCursor.once && typeof maybeCursor.once === 'function';
}
/** Tracing integration for mongo package */ var Mongo = /*#__PURE__*/ function() {
    "use strict";
    function Mongo() {
        var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0, _classCallCheck._)(this, Mongo);
        this.name = Mongo.id;
        this._operations = Array.isArray(options.operations) ? options.operations : OPERATIONS;
        this._describeOperations = 'describeOperations' in options ? options.describeOperations : true;
        this._useMongoose = !!options.useMongoose;
    }
    (0, _createClass._)(Mongo, [
        {
            /** @inheritdoc */ key: "loadDependency",
            value: function loadDependency() {
                var moduleName = this._useMongoose ? 'mongoose' : 'mongodb';
                return this._module = this._module || (0, _utils.loadModule)(moduleName);
            }
        },
        {
            /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
            key: "setupOnce",
            value: function setupOnce(_, getCurrentHub) {
                if ((0, _nodeUtilsJs.shouldDisableAutoInstrumentation)(getCurrentHub)) {
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log('Mongo Integration is skipped because of instrumenter configuration.');
                    return;
                }
                var pkg = this.loadDependency();
                if (!pkg) {
                    var moduleName = this._useMongoose ? 'mongoose' : 'mongodb';
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).error(`Mongo Integration was unable to require \`${moduleName}\` package.`);
                    return;
                }
                this._instrumentOperations(pkg.Collection, this._operations, getCurrentHub);
            }
        },
        {
            /**
   * Patches original collection methods
   */ // eslint-disable-next-line deprecation/deprecation
            key: "_instrumentOperations",
            value: function _instrumentOperations(collection, operations, getCurrentHub) {
                var _this = this;
                operations.forEach(function(operation) {
                    return _this._patchOperation(collection, operation, getCurrentHub);
                });
            }
        },
        {
            /**
   * Patches original collection to utilize our tracing functionality
   */ // eslint-disable-next-line deprecation/deprecation
            key: "_patchOperation",
            value: function _patchOperation(collection, operation, getCurrentHub) {
                if (!(operation in collection.prototype)) return;
                var getSpanContext = this._getSpanContextFromOperationArguments.bind(this);
                (0, _utils.fill)(collection.prototype, operation, function(orig) {
                    return function() {
                        var _this = this;
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                            args[_key] = arguments[_key];
                        }
                        var _orig;
                        var lastArg = args[args.length - 1];
                        // eslint-disable-next-line deprecation/deprecation
                        var hub = getCurrentHub();
                        // eslint-disable-next-line deprecation/deprecation
                        var scope = hub.getScope();
                        // eslint-disable-next-line deprecation/deprecation
                        var client = hub.getClient();
                        // eslint-disable-next-line deprecation/deprecation
                        var parentSpan = scope.getSpan();
                        var sendDefaultPii = (0, _utils._optionalChain)([
                            client,
                            'optionalAccess',
                            function(_2) {
                                return _2.getOptions;
                            },
                            'call',
                            function(_3) {
                                return _3();
                            },
                            'access',
                            function(_4) {
                                return _4.sendDefaultPii;
                            }
                        ]);
                        // Check if the operation was passed a callback. (mapReduce requires a different check, as
                        // its (non-callback) arguments can also be functions.)
                        if (typeof lastArg !== 'function' || operation === 'mapReduce' && args.length === 2) {
                            var _orig1;
                            // eslint-disable-next-line deprecation/deprecation
                            var span = (0, _utils._optionalChain)([
                                parentSpan,
                                'optionalAccess',
                                function(_5) {
                                    return _5.startChild;
                                },
                                'call',
                                function(_6) {
                                    return _6(getSpanContext(_this, operation, args, sendDefaultPii));
                                }
                            ]);
                            var maybePromiseOrCursor = (_orig1 = orig).call.apply(_orig1, [
                                this
                            ].concat((0, _toConsumableArray._)(args)));
                            if ((0, _utils.isThenable)(maybePromiseOrCursor)) return maybePromiseOrCursor.then(function(res) {
                                (0, _utils._optionalChain)([
                                    span,
                                    'optionalAccess',
                                    function(_7) {
                                        return _7.end;
                                    },
                                    'call',
                                    function(_8) {
                                        return _8();
                                    }
                                ]);
                                return res;
                            });
                            else if (isCursor(maybePromiseOrCursor)) {
                                var cursor = maybePromiseOrCursor;
                                try {
                                    cursor.once('close', function() {
                                        (0, _utils._optionalChain)([
                                            span,
                                            'optionalAccess',
                                            function(_9) {
                                                return _9.end;
                                            },
                                            'call',
                                            function(_10) {
                                                return _10();
                                            }
                                        ]);
                                    });
                                } catch (e) {
                                    // If the cursor is already closed, `once` will throw an error. In that case, we can
                                    // finish the span immediately.
                                    (0, _utils._optionalChain)([
                                        span,
                                        'optionalAccess',
                                        function(_11) {
                                            return _11.end;
                                        },
                                        'call',
                                        function(_12) {
                                            return _12();
                                        }
                                    ]);
                                }
                                return cursor;
                            } else {
                                (0, _utils._optionalChain)([
                                    span,
                                    'optionalAccess',
                                    function(_13) {
                                        return _13.end;
                                    },
                                    'call',
                                    function(_14) {
                                        return _14();
                                    }
                                ]);
                                return maybePromiseOrCursor;
                            }
                        }
                        // eslint-disable-next-line deprecation/deprecation
                        var span1 = (0, _utils._optionalChain)([
                            parentSpan,
                            'optionalAccess',
                            function(_15) {
                                return _15.startChild;
                            },
                            'call',
                            function(_16) {
                                return _16(getSpanContext(_this, operation, args.slice(0, -1)));
                            }
                        ]);
                        return (_orig = orig).call.apply(_orig, [
                            this
                        ].concat((0, _toConsumableArray._)(args.slice(0, -1)), [
                            function(err, result) {
                                (0, _utils._optionalChain)([
                                    span1,
                                    'optionalAccess',
                                    function(_17) {
                                        return _17.end;
                                    },
                                    'call',
                                    function(_18) {
                                        return _18();
                                    }
                                ]);
                                lastArg(err, result);
                            }
                        ]));
                    };
                });
            }
        },
        {
            /**
   * Form a SpanContext based on the user input to a given operation.
   */ key: "_getSpanContextFromOperationArguments",
            value: function _getSpanContextFromOperationArguments(collection, operation, args) {
                var sendDefaultPii = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
                var data = {
                    'db.system': 'mongodb',
                    'db.name': collection.dbName,
                    'db.operation': operation,
                    'db.mongodb.collection': collection.collectionName
                };
                var spanContext = {
                    op: 'db',
                    // TODO v8: Use `${collection.collectionName}.${operation}`
                    origin: 'auto.db.mongo',
                    description: operation,
                    data: data
                };
                // If the operation takes no arguments besides `options` and `callback`, or if argument
                // collection is disabled for this operation, just return early.
                var signature = OPERATION_SIGNATURES[operation];
                var shouldDescribe = Array.isArray(this._describeOperations) ? this._describeOperations.includes(operation) : this._describeOperations;
                if (!signature || !shouldDescribe || !sendDefaultPii) return spanContext;
                try {
                    // Special case for `mapReduce`, as the only one accepting functions as arguments.
                    if (operation === 'mapReduce') {
                        var _args = (0, _slicedToArray._)(args, 2), map = _args[0], reduce = _args[1];
                        data[signature[0]] = typeof map === 'string' ? map : map.name || '<anonymous>';
                        data[signature[1]] = typeof reduce === 'string' ? reduce : reduce.name || '<anonymous>';
                    } else for(var i = 0; i < signature.length; i++)data[`db.mongodb.${signature[i]}`] = JSON.stringify(args[i]);
                } catch (_oO) {
                // no-empty
                }
                return spanContext;
            }
        }
    ], [
        {
            key: "__initStatic",
            value: /**
   * @inheritDoc
   */ function __initStatic() {
                this.id = 'Mongo';
            }
        }
    ]);
    return Mongo;
}();
Mongo.__initStatic();

},{"@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","@swc/helpers/_/_sliced_to_array":"ha6sq","@swc/helpers/_/_to_consumable_array":"eqNDD","@sentry/utils":"gElXU","../../common/debug-build.js":"eGerB","./utils/node-utils.js":"QKyBb","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"dcfCa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Prisma", function() {
    return Prisma;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
var _debugBuildJs = require("../../common/debug-build.js");
var _nodeUtilsJs = require("./utils/node-utils.js");
function isValidPrismaClient(possibleClient) {
    return !!possibleClient && !!possibleClient['$use'];
}
/** Tracing integration for @prisma/client package */ var Prisma = /*#__PURE__*/ function() {
    "use strict";
    function Prisma() {
        var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0, _classCallCheck._)(this, Prisma);
        this.name = Prisma.id;
        // We instrument the PrismaClient inside the constructor and not inside `setupOnce` because in some cases of server-side
        // bundling (Next.js) multiple Prisma clients can be instantiated, even though users don't intend to. When instrumenting
        // in setupOnce we can only ever instrument one client.
        // https://github.com/getsentry/sentry-javascript/issues/7216#issuecomment-1602375012
        // In the future we might explore providing a dedicated PrismaClient middleware instead of this hack.
        if (isValidPrismaClient(options.client) && !options.client._sentryInstrumented) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, _utils.addNonEnumerableProperty)(options.client, '_sentryInstrumented', true);
            var clientData = {};
            try {
                var engineConfig = options.client._engineConfig;
                if (engineConfig) {
                    var activeProvider = engineConfig.activeProvider, clientVersion = engineConfig.clientVersion;
                    if (activeProvider) clientData['db.system'] = activeProvider;
                    if (clientVersion) clientData['db.prisma.version'] = clientVersion;
                }
            } catch (e) {
            // ignore
            }
            options.client.$use(function(params, next) {
                // eslint-disable-next-line deprecation/deprecation
                if ((0, _nodeUtilsJs.shouldDisableAutoInstrumentation)((0, _core.getCurrentHub))) return next(params);
                var action = params.action;
                var model = params.model;
                return (0, _core.startSpan)({
                    name: model ? `${model} ${action}` : action,
                    onlyIfParent: true,
                    op: 'db.prisma',
                    attributes: (0, _defineProperty._)({}, (0, _core.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), 'auto.db.prisma'),
                    data: (0, _objectSpreadProps._)((0, _objectSpread._)({}, clientData), {
                        'db.operation': action
                    })
                }, function() {
                    return next(params);
                });
            });
        } else (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn('Unsupported Prisma client provided to PrismaIntegration. Provided client:', options.client);
    }
    (0, _createClass._)(Prisma, [
        {
            /**
   * @inheritDoc
   */ key: "setupOnce",
            value: function setupOnce() {
            // Noop - here for backwards compatibility
            }
        }
    ], [
        {
            key: "__initStatic",
            value: /**
   * @inheritDoc
   */ function __initStatic() {
                this.id = 'Prisma';
            }
        }
    ]);
    return Prisma;
}();
Prisma.__initStatic();

},{"@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","@swc/helpers/_/_define_property":"54Zvk","@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_object_spread_props":"fLCYP","@sentry/core":"8bBGI","@sentry/utils":"gElXU","../../common/debug-build.js":"eGerB","./utils/node-utils.js":"QKyBb","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"kNJIz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GraphQL", function() {
    return GraphQL;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _utils = require("@sentry/utils");
var _debugBuildJs = require("../../common/debug-build.js");
var _nodeUtilsJs = require("./utils/node-utils.js");
/** Tracing integration for graphql package */ var GraphQL = /*#__PURE__*/ function() {
    "use strict";
    function GraphQL() {
        (0, _classCallCheck._)(this, GraphQL);
        this.name = GraphQL.id;
    }
    (0, _createClass._)(GraphQL, [
        {
            /** @inheritdoc */ key: "loadDependency",
            value: function loadDependency() {
                return this._module = this._module || (0, _utils.loadModule)('graphql/execution/execute.js');
            }
        },
        {
            /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
            key: "setupOnce",
            value: function setupOnce(_, getCurrentHub) {
                if ((0, _nodeUtilsJs.shouldDisableAutoInstrumentation)(getCurrentHub)) {
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log('GraphQL Integration is skipped because of instrumenter configuration.');
                    return;
                }
                var pkg = this.loadDependency();
                if (!pkg) {
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).error('GraphQL Integration was unable to require graphql/execution package.');
                    return;
                }
                (0, _utils.fill)(pkg, 'execute', function(orig) {
                    return function() {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                            args[_key] = arguments[_key];
                        }
                        var _orig;
                        // eslint-disable-next-line deprecation/deprecation
                        var scope = getCurrentHub().getScope();
                        // eslint-disable-next-line deprecation/deprecation
                        var parentSpan = scope.getSpan();
                        // eslint-disable-next-line deprecation/deprecation
                        var span = (0, _utils._optionalChain)([
                            parentSpan,
                            'optionalAccess',
                            function(_2) {
                                return _2.startChild;
                            },
                            'call',
                            function(_3) {
                                return _3({
                                    description: 'execute',
                                    op: 'graphql.execute',
                                    origin: 'auto.graphql.graphql'
                                });
                            }
                        ]);
                        // eslint-disable-next-line deprecation/deprecation
                        (0, _utils._optionalChain)([
                            scope,
                            'optionalAccess',
                            function(_4) {
                                return _4.setSpan;
                            },
                            'call',
                            function(_5) {
                                return _5(span);
                            }
                        ]);
                        var rv = (_orig = orig).call.apply(_orig, [
                            this
                        ].concat((0, _toConsumableArray._)(args)));
                        if ((0, _utils.isThenable)(rv)) return rv.then(function(res) {
                            (0, _utils._optionalChain)([
                                span,
                                'optionalAccess',
                                function(_6) {
                                    return _6.end;
                                },
                                'call',
                                function(_7) {
                                    return _7();
                                }
                            ]);
                            // eslint-disable-next-line deprecation/deprecation
                            (0, _utils._optionalChain)([
                                scope,
                                'optionalAccess',
                                function(_8) {
                                    return _8.setSpan;
                                },
                                'call',
                                function(_9) {
                                    return _9(parentSpan);
                                }
                            ]);
                            return res;
                        });
                        (0, _utils._optionalChain)([
                            span,
                            'optionalAccess',
                            function(_10) {
                                return _10.end;
                            },
                            'call',
                            function(_11) {
                                return _11();
                            }
                        ]);
                        // eslint-disable-next-line deprecation/deprecation
                        (0, _utils._optionalChain)([
                            scope,
                            'optionalAccess',
                            function(_12) {
                                return _12.setSpan;
                            },
                            'call',
                            function(_13) {
                                return _13(parentSpan);
                            }
                        ]);
                        return rv;
                    };
                });
            }
        }
    ], [
        {
            key: "__initStatic",
            value: /**
   * @inheritDoc
   */ function __initStatic() {
                this.id = 'GraphQL';
            }
        }
    ]);
    return GraphQL;
}();
GraphQL.__initStatic();

},{"@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","@swc/helpers/_/_to_consumable_array":"eqNDD","@sentry/utils":"gElXU","../../common/debug-build.js":"eGerB","./utils/node-utils.js":"QKyBb","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"fqAwb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Apollo", function() {
    return Apollo;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _utils = require("@sentry/utils");
var _debugBuildJs = require("../../common/debug-build.js");
var _nodeUtilsJs = require("./utils/node-utils.js");
/** Tracing integration for Apollo */ var Apollo = /*#__PURE__*/ function() {
    "use strict";
    function Apollo() {
        var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
            useNestjs: false
        };
        (0, _classCallCheck._)(this, Apollo);
        this.name = Apollo.id;
        this._useNest = !!options.useNestjs;
    }
    (0, _createClass._)(Apollo, [
        {
            /** @inheritdoc */ key: "loadDependency",
            value: function loadDependency() {
                if (this._useNest) this._module = this._module || (0, _utils.loadModule)('@nestjs/graphql');
                else this._module = this._module || (0, _utils.loadModule)('apollo-server-core');
                return this._module;
            }
        },
        {
            /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
            key: "setupOnce",
            value: function setupOnce(_, getCurrentHub) {
                if ((0, _nodeUtilsJs.shouldDisableAutoInstrumentation)(getCurrentHub)) {
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log('Apollo Integration is skipped because of instrumenter configuration.');
                    return;
                }
                if (this._useNest) {
                    var pkg = this.loadDependency();
                    if (!pkg) {
                        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).error('Apollo-NestJS Integration was unable to require @nestjs/graphql package.');
                        return;
                    }
                    /**
       * Iterate over resolvers of NestJS ResolversExplorerService before schemas are constructed.
       */ (0, _utils.fill)(pkg.GraphQLFactory.prototype, 'mergeWithSchema', function(orig) {
                        return function() {
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                                args[_key] = arguments[_key];
                            }
                            var _orig;
                            (0, _utils.fill)(this.resolversExplorerService, 'explore', function(orig) {
                                return function() {
                                    var resolvers = (0, _utils.arrayify)(orig.call(this));
                                    var instrumentedResolvers = instrumentResolvers(resolvers, getCurrentHub);
                                    return instrumentedResolvers;
                                };
                            });
                            return (_orig = orig).call.apply(_orig, [
                                this
                            ].concat((0, _toConsumableArray._)(args)));
                        };
                    });
                } else {
                    var pkg1 = this.loadDependency();
                    if (!pkg1) {
                        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).error('Apollo Integration was unable to require apollo-server-core package.');
                        return;
                    }
                    /**
       * Iterate over resolvers of the ApolloServer instance before schemas are constructed.
       */ (0, _utils.fill)(pkg1.ApolloServerBase.prototype, 'constructSchema', function(orig) {
                        return function() {
                            if (!this.config.resolvers) {
                                if (0, _debugBuildJs.DEBUG_BUILD) {
                                    if (this.config.schema) {
                                        (0, _utils.logger).warn("Apollo integration is not able to trace `ApolloServer` instances constructed via `schema` property.If you are using NestJS with Apollo, please use `Sentry.Integrations.Apollo({ useNestjs: true })` instead.");
                                        (0, _utils.logger).warn();
                                    } else if (this.config.modules) (0, _utils.logger).warn('Apollo integration is not able to trace `ApolloServer` instances constructed via `modules` property.');
                                    (0, _utils.logger).error('Skipping tracing as no resolvers found on the `ApolloServer` instance.');
                                }
                                return orig.call(this);
                            }
                            var resolvers = (0, _utils.arrayify)(this.config.resolvers);
                            this.config.resolvers = instrumentResolvers(resolvers, getCurrentHub);
                            return orig.call(this);
                        };
                    });
                }
            }
        }
    ], [
        {
            key: "__initStatic",
            value: /**
   * @inheritDoc
   */ function __initStatic() {
                this.id = 'Apollo';
            }
        }
    ]);
    return Apollo;
}();
Apollo.__initStatic();
// eslint-disable-next-line deprecation/deprecation
function instrumentResolvers(resolvers, getCurrentHub) {
    return resolvers.map(function(model) {
        Object.keys(model).forEach(function(resolverGroupName) {
            Object.keys(model[resolverGroupName]).forEach(function(resolverName) {
                if (typeof model[resolverGroupName][resolverName] !== 'function') return;
                wrapResolver(model, resolverGroupName, resolverName, getCurrentHub);
            });
        });
        return model;
    });
}
/**
 * Wrap a single resolver which can be a parent of other resolvers and/or db operations.
 */ function wrapResolver(model, resolverGroupName, resolverName, // eslint-disable-next-line deprecation/deprecation
getCurrentHub) {
    (0, _utils.fill)(model[resolverGroupName], resolverName, function(orig) {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var _orig;
            // eslint-disable-next-line deprecation/deprecation
            var scope = getCurrentHub().getScope();
            // eslint-disable-next-line deprecation/deprecation
            var parentSpan = scope.getSpan();
            // eslint-disable-next-line deprecation/deprecation
            var span = (0, _utils._optionalChain)([
                parentSpan,
                'optionalAccess',
                function(_2) {
                    return _2.startChild;
                },
                'call',
                function(_3) {
                    return _3({
                        description: `${resolverGroupName}.${resolverName}`,
                        op: 'graphql.resolve',
                        origin: 'auto.graphql.apollo'
                    });
                }
            ]);
            var rv = (_orig = orig).call.apply(_orig, [
                this
            ].concat((0, _toConsumableArray._)(args)));
            if ((0, _utils.isThenable)(rv)) return rv.then(function(res) {
                (0, _utils._optionalChain)([
                    span,
                    'optionalAccess',
                    function(_4) {
                        return _4.end;
                    },
                    'call',
                    function(_5) {
                        return _5();
                    }
                ]);
                return res;
            });
            (0, _utils._optionalChain)([
                span,
                'optionalAccess',
                function(_6) {
                    return _6.end;
                },
                'call',
                function(_7) {
                    return _7();
                }
            ]);
            return rv;
        };
    });
}

},{"@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","@swc/helpers/_/_to_consumable_array":"eqNDD","@sentry/utils":"gElXU","../../common/debug-build.js":"eGerB","./utils/node-utils.js":"QKyBb","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"kyxXT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "lazyLoadedNodePerformanceMonitoringIntegrations", function() {
    return lazyLoadedNodePerformanceMonitoringIntegrations;
});
var _utils = require("@sentry/utils");
var lazyLoadedNodePerformanceMonitoringIntegrations = [
    function() {
        var integration = (0, _utils.dynamicRequire)(module, './apollo');
        return new integration.Apollo();
    },
    function() {
        var integration = (0, _utils.dynamicRequire)(module, './apollo');
        return new integration.Apollo({
            useNestjs: true
        });
    },
    function() {
        var integration = (0, _utils.dynamicRequire)(module, './graphql');
        return new integration.GraphQL();
    },
    function() {
        var integration = (0, _utils.dynamicRequire)(module, './mongo');
        return new integration.Mongo();
    },
    function() {
        var integration = (0, _utils.dynamicRequire)(module, './mongo');
        return new integration.Mongo({
            mongoose: true
        });
    },
    function() {
        var integration = (0, _utils.dynamicRequire)(module, './mysql');
        return new integration.Mysql();
    },
    function() {
        var integration = (0, _utils.dynamicRequire)(module, './postgres');
        return new integration.Postgres();
    }
];

},{"@sentry/utils":"gElXU","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"eJmoM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BROWSER_TRACING_INTEGRATION_ID", function() {
    return BROWSER_TRACING_INTEGRATION_ID;
});
parcelHelpers.export(exports, "BrowserTracing", function() {
    return BrowserTracing;
});
parcelHelpers.export(exports, "getMetaContent", function() {
    return getMetaContent;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
var _debugBuildJs = require("../common/debug-build.js");
var _backgroundtabJs = require("./backgroundtab.js");
var _instrumentJs = require("./instrument.js");
var _indexJs = require("./metrics/index.js");
var _requestJs = require("./request.js");
var _routerJs = require("./router.js");
var _typesJs = require("./types.js");
var BROWSER_TRACING_INTEGRATION_ID = 'BrowserTracing';
/** Options for Browser Tracing integration */ var DEFAULT_BROWSER_TRACING_OPTIONS = (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _core.TRACING_DEFAULTS)), {
    markBackgroundTransactions: true,
    routingInstrumentation: (0, _routerJs.instrumentRoutingWithDefaults),
    startTransactionOnLocationChange: true,
    startTransactionOnPageLoad: true,
    enableLongTask: true,
    enableInp: false,
    interactionsSampleRate: 1,
    _experiments: {}
}), (0, _requestJs.defaultRequestInstrumentationOptions));
/** We store up to 10 interaction candidates max to cap memory usage. This is the same cap as getINP from web-vitals */ var MAX_INTERACTIONS = 10;
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 *
 * @deprecated Use `browserTracingIntegration()` instead.
 */ var BrowserTracing = /*#__PURE__*/ function() {
    "use strict";
    function BrowserTracing(_options) {
        (0, _classCallCheck._)(this, BrowserTracing);
        this.name = BROWSER_TRACING_INTEGRATION_ID;
        this._hasSetTracePropagationTargets = false;
        (0, _core.addTracingExtensions)();
        if (0, _debugBuildJs.DEBUG_BUILD) this._hasSetTracePropagationTargets = !!(_options && // eslint-disable-next-line deprecation/deprecation
        (_options.tracePropagationTargets || _options.tracingOrigins));
        this.options = (0, _objectSpread._)({}, DEFAULT_BROWSER_TRACING_OPTIONS, _options);
        // Special case: enableLongTask can be set in _experiments
        // TODO (v8): Remove this in v8
        if (this.options._experiments.enableLongTask !== undefined) this.options.enableLongTask = this.options._experiments.enableLongTask;
        // TODO (v8): remove this block after tracingOrigins is removed
        // Set tracePropagationTargets to tracingOrigins if specified by the user
        // In case both are specified, tracePropagationTargets takes precedence
        // eslint-disable-next-line deprecation/deprecation
        if (_options && !_options.tracePropagationTargets && _options.tracingOrigins) // eslint-disable-next-line deprecation/deprecation
        this.options.tracePropagationTargets = _options.tracingOrigins;
        this._collectWebVitals = (0, _indexJs.startTrackingWebVitals)();
        /** Stores a mapping of interactionIds from PerformanceEventTimings to the origin interaction path */ this._interactionIdToRouteNameMapping = {};
        if (this.options.enableInp) (0, _indexJs.startTrackingINP)(this._interactionIdToRouteNameMapping, this.options.interactionsSampleRate);
        if (this.options.enableLongTask) (0, _indexJs.startTrackingLongTasks)();
        if (this.options._experiments.enableInteractions) (0, _indexJs.startTrackingInteractions)();
        this._latestRoute = {
            name: undefined,
            context: undefined
        };
    }
    (0, _createClass._)(BrowserTracing, [
        {
            /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
            key: "setupOnce",
            value: function setupOnce(_, getCurrentHub) {
                var _this = this;
                this._getCurrentHub = getCurrentHub;
                var hub = getCurrentHub();
                // eslint-disable-next-line deprecation/deprecation
                var client = hub.getClient();
                var clientOptions = client && client.getOptions();
                var _this_options = this.options, instrumentRouting = _this_options.routingInstrumentation, startTransactionOnLocationChange = _this_options.startTransactionOnLocationChange, startTransactionOnPageLoad = _this_options.startTransactionOnPageLoad, markBackgroundTransactions = _this_options.markBackgroundTransactions, traceFetch = _this_options.traceFetch, traceXHR = _this_options.traceXHR, shouldCreateSpanForRequest = _this_options.shouldCreateSpanForRequest, enableHTTPTimings = _this_options.enableHTTPTimings, _experiments = _this_options._experiments;
                var clientOptionsTracePropagationTargets = clientOptions && clientOptions.tracePropagationTargets;
                // There are three ways to configure tracePropagationTargets:
                // 1. via top level client option `tracePropagationTargets`
                // 2. via BrowserTracing option `tracePropagationTargets`
                // 3. via BrowserTracing option `tracingOrigins` (deprecated)
                //
                // To avoid confusion, favour top level client option `tracePropagationTargets`, and fallback to
                // BrowserTracing option `tracePropagationTargets` and then `tracingOrigins` (deprecated).
                // This is done as it minimizes bundle size (we don't have to have undefined checks).
                //
                // If both 1 and either one of 2 or 3 are set (from above), we log out a warning.
                // eslint-disable-next-line deprecation/deprecation
                var tracePropagationTargets = clientOptionsTracePropagationTargets || this.options.tracePropagationTargets;
                if ((0, _debugBuildJs.DEBUG_BUILD) && this._hasSetTracePropagationTargets && clientOptionsTracePropagationTargets) (0, _utils.logger).warn('[Tracing] The `tracePropagationTargets` option was set in the BrowserTracing integration and top level `Sentry.init`. The top level `Sentry.init` value is being used.');
                instrumentRouting(function(context) {
                    var transaction = _this._createRouteTransaction(context);
                    _this.options._experiments.onStartRouteTransaction && _this.options._experiments.onStartRouteTransaction(transaction, context, getCurrentHub);
                    return transaction;
                }, startTransactionOnPageLoad, startTransactionOnLocationChange);
                if (markBackgroundTransactions) (0, _backgroundtabJs.registerBackgroundTabDetection)();
                if (_experiments.enableInteractions) this._registerInteractionListener();
                if (this.options.enableInp) this._registerInpInteractionListener();
                (0, _requestJs.instrumentOutgoingRequests)({
                    traceFetch: traceFetch,
                    traceXHR: traceXHR,
                    tracePropagationTargets: tracePropagationTargets,
                    shouldCreateSpanForRequest: shouldCreateSpanForRequest,
                    enableHTTPTimings: enableHTTPTimings
                });
            }
        },
        {
            /** Create routing idle transaction. */ key: "_createRouteTransaction",
            value: function _createRouteTransaction(context) {
                var _this = this;
                if (!this._getCurrentHub) {
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn(`[Tracing] Did not create ${context.op} transaction because _getCurrentHub is invalid.`);
                    return undefined;
                }
                var hub = this._getCurrentHub();
                var _this_options = this.options, beforeNavigate = _this_options.beforeNavigate, idleTimeout = _this_options.idleTimeout, finalTimeout = _this_options.finalTimeout, heartbeatInterval = _this_options.heartbeatInterval;
                var isPageloadTransaction = context.op === 'pageload';
                var expandedContext;
                if (isPageloadTransaction) {
                    var sentryTrace = isPageloadTransaction ? getMetaContent('sentry-trace') : '';
                    var baggage = isPageloadTransaction ? getMetaContent('baggage') : undefined;
                    var _propagationContextFromHeaders = (0, _utils.propagationContextFromHeaders)(sentryTrace, baggage), traceId = _propagationContextFromHeaders.traceId, dsc = _propagationContextFromHeaders.dsc, parentSpanId = _propagationContextFromHeaders.parentSpanId, sampled = _propagationContextFromHeaders.sampled;
                    expandedContext = (0, _objectSpreadProps._)((0, _objectSpread._)({
                        traceId: traceId,
                        parentSpanId: parentSpanId,
                        parentSampled: sampled
                    }, context), {
                        metadata: (0, _objectSpreadProps._)((0, _objectSpread._)({}, context.metadata), {
                            dynamicSamplingContext: dsc
                        }),
                        trimEnd: true
                    });
                } else expandedContext = (0, _objectSpread._)({
                    trimEnd: true
                }, context);
                var modifiedContext = typeof beforeNavigate === 'function' ? beforeNavigate(expandedContext) : expandedContext;
                // For backwards compatibility reasons, beforeNavigate can return undefined to "drop" the transaction (prevent it
                // from being sent to Sentry).
                var finalContext = modifiedContext === undefined ? (0, _objectSpreadProps._)((0, _objectSpread._)({}, expandedContext), {
                    sampled: false
                }) : modifiedContext;
                // If `beforeNavigate` set a custom name, record that fact
                // eslint-disable-next-line deprecation/deprecation
                finalContext.metadata = finalContext.name !== expandedContext.name ? (0, _objectSpreadProps._)((0, _objectSpread._)({}, finalContext.metadata), {
                    source: 'custom'
                }) : finalContext.metadata;
                this._latestRoute.name = finalContext.name;
                this._latestRoute.context = finalContext;
                // eslint-disable-next-line deprecation/deprecation
                if (finalContext.sampled === false) (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log(`[Tracing] Will not send ${finalContext.op} transaction because of beforeNavigate.`);
                (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log(`[Tracing] Starting ${finalContext.op} transaction on scope`);
                var location = (0, _typesJs.WINDOW).location;
                var idleTransaction = (0, _core.startIdleTransaction)(hub, finalContext, idleTimeout, finalTimeout, true, {
                    location: location
                }, heartbeatInterval, isPageloadTransaction);
                if (isPageloadTransaction) {
                    if ((0, _typesJs.WINDOW).document) {
                        (0, _typesJs.WINDOW).document.addEventListener('readystatechange', function() {
                            if ([
                                'interactive',
                                'complete'
                            ].includes((0, _typesJs.WINDOW).document.readyState)) idleTransaction.sendAutoFinishSignal();
                        });
                        if ([
                            'interactive',
                            'complete'
                        ].includes((0, _typesJs.WINDOW).document.readyState)) idleTransaction.sendAutoFinishSignal();
                    }
                }
                idleTransaction.registerBeforeFinishCallback(function(transaction) {
                    _this._collectWebVitals();
                    (0, _indexJs.addPerformanceEntries)(transaction);
                });
                return idleTransaction;
            }
        },
        {
            /** Start listener for interaction transactions */ key: "_registerInteractionListener",
            value: function _registerInteractionListener() {
                var _this = this;
                var inflightInteractionTransaction;
                var registerInteractionTransaction = function() {
                    var _this_options = _this.options, idleTimeout = _this_options.idleTimeout, finalTimeout = _this_options.finalTimeout, heartbeatInterval = _this_options.heartbeatInterval;
                    var op = 'ui.action.click';
                    // eslint-disable-next-line deprecation/deprecation
                    var currentTransaction = (0, _core.getActiveTransaction)();
                    if (currentTransaction && currentTransaction.op && [
                        'navigation',
                        'pageload'
                    ].includes(currentTransaction.op)) {
                        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn(`[Tracing] Did not create ${op} transaction because a pageload or navigation transaction is in progress.`);
                        return undefined;
                    }
                    if (inflightInteractionTransaction) {
                        inflightInteractionTransaction.setFinishReason('interactionInterrupted');
                        inflightInteractionTransaction.end();
                        inflightInteractionTransaction = undefined;
                    }
                    if (!_this._getCurrentHub) {
                        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn(`[Tracing] Did not create ${op} transaction because _getCurrentHub is invalid.`);
                        return undefined;
                    }
                    if (!_this._latestRoute.name) {
                        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
                        return undefined;
                    }
                    var hub = _this._getCurrentHub();
                    var location = (0, _typesJs.WINDOW).location;
                    var context = {
                        name: _this._latestRoute.name,
                        op: op,
                        trimEnd: true,
                        data: (0, _defineProperty._)({}, (0, _core.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), _this._latestRoute.context ? getSource(_this._latestRoute.context) : 'url')
                    };
                    inflightInteractionTransaction = (0, _core.startIdleTransaction)(hub, context, idleTimeout, finalTimeout, true, {
                        location: location
                    }, heartbeatInterval);
                };
                [
                    'click'
                ].forEach(function(type) {
                    if ((0, _typesJs.WINDOW).document) addEventListener(type, registerInteractionTransaction, {
                        once: false,
                        capture: true
                    });
                });
            }
        },
        {
            /** Creates a listener on interaction entries, and maps interactionIds to the origin path of the interaction */ key: "_registerInpInteractionListener",
            value: function _registerInpInteractionListener() {
                var _this = this;
                var handleEntries = function(param) {
                    var entries = param.entries;
                    var client = (0, _core.getClient)();
                    // We need to get the replay, user, and activeTransaction from the current scope
                    // so that we can associate replay id, profile id, and a user display to the span
                    var replay = client !== undefined && client.getIntegrationByName !== undefined ? client.getIntegrationByName('Replay') : undefined;
                    var replayId = replay !== undefined ? replay.getReplayId() : undefined;
                    // eslint-disable-next-line deprecation/deprecation
                    var activeTransaction = (0, _core.getActiveTransaction)();
                    var currentScope = (0, _core.getCurrentScope)();
                    var user = currentScope !== undefined ? currentScope.getUser() : undefined;
                    entries.forEach(function(entry) {
                        if (isPerformanceEventTiming(entry)) {
                            var interactionId = entry.interactionId;
                            if (interactionId === undefined) return;
                            var existingInteraction = _this._interactionIdToRouteNameMapping[interactionId];
                            var duration = entry.duration;
                            var startTime = entry.startTime;
                            var keys = Object.keys(_this._interactionIdToRouteNameMapping);
                            var minInteractionId = keys.length > 0 ? keys.reduce(function(a, b) {
                                return _this._interactionIdToRouteNameMapping[a].duration < _this._interactionIdToRouteNameMapping[b].duration ? a : b;
                            }) : undefined;
                            // For a first input event to be considered, we must check that an interaction event does not already exist with the same duration and start time.
                            // This is also checked in the web-vitals library.
                            if (entry.entryType === 'first-input') {
                                var matchingEntry = keys.map(function(key) {
                                    return _this._interactionIdToRouteNameMapping[key];
                                }).some(function(interaction) {
                                    return interaction.duration === duration && interaction.startTime === startTime;
                                });
                                if (matchingEntry) return;
                            }
                            // Interactions with an id of 0 and are not first-input are not valid.
                            if (!interactionId) return;
                            // If the interaction already exists, we want to use the duration of the longest entry, since that is what the INP metric uses.
                            if (existingInteraction) existingInteraction.duration = Math.max(existingInteraction.duration, duration);
                            else if (keys.length < MAX_INTERACTIONS || minInteractionId === undefined || duration > _this._interactionIdToRouteNameMapping[minInteractionId].duration) {
                                // If the interaction does not exist, we want to add it to the mapping if there is space, or if the duration is longer than the shortest entry.
                                var routeName = _this._latestRoute.name;
                                var parentContext = _this._latestRoute.context;
                                if (routeName && parentContext) {
                                    if (minInteractionId && Object.keys(_this._interactionIdToRouteNameMapping).length >= MAX_INTERACTIONS) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                                    delete _this._interactionIdToRouteNameMapping[minInteractionId];
                                    _this._interactionIdToRouteNameMapping[interactionId] = {
                                        routeName: routeName,
                                        duration: duration,
                                        parentContext: parentContext,
                                        user: user,
                                        activeTransaction: activeTransaction,
                                        replayId: replayId,
                                        startTime: startTime
                                    };
                                }
                            }
                        }
                    });
                };
                (0, _instrumentJs.addPerformanceInstrumentationHandler)('event', handleEntries);
                (0, _instrumentJs.addPerformanceInstrumentationHandler)('first-input', handleEntries);
            }
        }
    ]);
    return BrowserTracing;
}();
/** Returns the value of a meta tag */ function getMetaContent(metaName) {
    // Can't specify generic to `getDomElement` because tracing can be used
    // in a variety of environments, have to disable `no-unsafe-member-access`
    // as a result.
    var metaTag = (0, _utils.getDomElement)(`meta[name=${metaName}]`);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return metaTag ? metaTag.getAttribute('content') : undefined;
}
function getSource(context) {
    var sourceFromAttributes = context.attributes && context.attributes[0, _core.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    // eslint-disable-next-line deprecation/deprecation
    var sourceFromData = context.data && context.data[0, _core.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    // eslint-disable-next-line deprecation/deprecation
    var sourceFromMetadata = context.metadata && context.metadata.source;
    return sourceFromAttributes || sourceFromData || sourceFromMetadata;
}
function isPerformanceEventTiming(entry) {
    return 'duration' in entry;
}

},{"@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","@swc/helpers/_/_define_property":"54Zvk","@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_object_spread_props":"fLCYP","@sentry/core":"8bBGI","@sentry/utils":"gElXU","../common/debug-build.js":"eGerB","./backgroundtab.js":"1rWmz","./instrument.js":"2jXyu","./metrics/index.js":"iTapn","./request.js":"eGI7D","./router.js":"2AA3Q","./types.js":"dT4HR","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1rWmz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "registerBackgroundTabDetection", function() {
    return registerBackgroundTabDetection;
});
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
var _debugBuildJs = require("../common/debug-build.js");
var _typesJs = require("./types.js");
/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */ function registerBackgroundTabDetection() {
    if ((0, _typesJs.WINDOW).document) (0, _typesJs.WINDOW).document.addEventListener('visibilitychange', function() {
        // eslint-disable-next-line deprecation/deprecation
        var activeTransaction = (0, _core.getActiveTransaction)();
        if ((0, _typesJs.WINDOW).document.hidden && activeTransaction) {
            var statusType = 'cancelled';
            var _spanToJSON = (0, _core.spanToJSON)(activeTransaction), op = _spanToJSON.op, status = _spanToJSON.status;
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log(`[Tracing] Transaction: ${statusType} -> since tab moved to the background, op: ${op}`);
            // We should not set status if it is already set, this prevent important statuses like
            // error or data loss from being overwritten on transaction.
            if (!status) activeTransaction.setStatus(statusType);
            // TODO: Can we rewrite this to an attribute?
            // eslint-disable-next-line deprecation/deprecation
            activeTransaction.setTag('visibilitychange', 'document.hidden');
            activeTransaction.end();
        }
    });
    else (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn('[Tracing] Could not set up background tab detection due to lack of global document');
}

},{"@sentry/core":"8bBGI","@sentry/utils":"gElXU","../common/debug-build.js":"eGerB","./types.js":"dT4HR","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"dT4HR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WINDOW", function() {
    return WINDOW;
});
var _utils = require("@sentry/utils");
var WINDOW = (0, _utils.GLOBAL_OBJ);

},{"@sentry/utils":"gElXU","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2jXyu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addClsInstrumentationHandler", function() {
    return addClsInstrumentationHandler;
});
parcelHelpers.export(exports, "addFidInstrumentationHandler", function() {
    return addFidInstrumentationHandler;
});
parcelHelpers.export(exports, "addInpInstrumentationHandler", function() {
    return addInpInstrumentationHandler;
});
parcelHelpers.export(exports, "addLcpInstrumentationHandler", function() {
    return addLcpInstrumentationHandler;
});
parcelHelpers.export(exports, "addPerformanceInstrumentationHandler", function() {
    return addPerformanceInstrumentationHandler;
});
parcelHelpers.export(exports, "addTtfbInstrumentationHandler", function() {
    return addTtfbInstrumentationHandler;
});
var _utils = require("@sentry/utils");
var _debugBuildJs = require("../common/debug-build.js");
var _getCLSJs = require("./web-vitals/getCLS.js");
var _getFIDJs = require("./web-vitals/getFID.js");
var _getINPJs = require("./web-vitals/getINP.js");
var _getLCPJs = require("./web-vitals/getLCP.js");
var _observeJs = require("./web-vitals/lib/observe.js");
var _onTTFBJs = require("./web-vitals/onTTFB.js");
var handlers = {};
var instrumented = {};
var _previousCls;
var _previousFid;
var _previousLcp;
var _previousTtfb;
var _previousInp;
/**
 * Add a callback that will be triggered when a CLS metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for CLS when the cleanup callback is called.
 * This will lead to the CLS being finalized and frozen.
 */ function addClsInstrumentationHandler(callback) {
    var stopOnCallback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return addMetricObserver('cls', callback, instrumentCls, _previousCls, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a LCP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for LCP when the cleanup callback is called.
 * This will lead to the LCP being finalized and frozen.
 */ function addLcpInstrumentationHandler(callback) {
    var stopOnCallback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return addMetricObserver('lcp', callback, instrumentLcp, _previousLcp, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 */ function addTtfbInstrumentationHandler(callback) {
    return addMetricObserver('ttfb', callback, instrumentTtfb, _previousTtfb);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function addFidInstrumentationHandler(callback) {
    return addMetricObserver('fid', callback, instrumentFid, _previousFid);
}
/**
 * Add a callback that will be triggered when a INP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function addInpInstrumentationHandler(callback) {
    return addMetricObserver('inp', callback, instrumentInp, _previousInp);
}
/**
 * Add a callback that will be triggered when a performance observer is triggered,
 * and receives the entries of the observer.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function addPerformanceInstrumentationHandler(type, callback) {
    addHandler(type, callback);
    if (!instrumented[type]) {
        instrumentPerformanceObserver(type);
        instrumented[type] = true;
    }
    return getCleanupCallback(type, callback);
}
/** Trigger all handlers of a given type. */ function triggerHandlers(type, data) {
    var typeHandlers = handlers[type];
    if (!typeHandlers || !typeHandlers.length) return;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = typeHandlers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var handler = _step.value;
            try {
                handler(data);
            } catch (e) {
                (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, _utils.getFunctionName)(handler)}\nError:`, e);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function instrumentCls() {
    return (0, _getCLSJs.onCLS)(function(metric) {
        triggerHandlers('cls', {
            metric: metric
        });
        _previousCls = metric;
    }, {
        reportAllChanges: true
    });
}
function instrumentFid() {
    return (0, _getFIDJs.onFID)(function(metric) {
        triggerHandlers('fid', {
            metric: metric
        });
        _previousFid = metric;
    });
}
function instrumentLcp() {
    return (0, _getLCPJs.onLCP)(function(metric) {
        triggerHandlers('lcp', {
            metric: metric
        });
        _previousLcp = metric;
    });
}
function instrumentTtfb() {
    return (0, _onTTFBJs.onTTFB)(function(metric) {
        triggerHandlers('ttfb', {
            metric: metric
        });
        _previousTtfb = metric;
    });
}
function instrumentInp() {
    return (0, _getINPJs.onINP)(function(metric) {
        triggerHandlers('inp', {
            metric: metric
        });
        _previousInp = metric;
    });
}
function addMetricObserver(type, callback, instrumentFn, previousValue) {
    var stopOnCallback = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    addHandler(type, callback);
    var stopListening;
    if (!instrumented[type]) {
        stopListening = instrumentFn();
        instrumented[type] = true;
    }
    if (previousValue) callback({
        metric: previousValue
    });
    return getCleanupCallback(type, callback, stopOnCallback ? stopListening : undefined);
}
function instrumentPerformanceObserver(type) {
    var options = {};
    // Special per-type options we want to use
    if (type === 'event') options.durationThreshold = 0;
    (0, _observeJs.observe)(type, function(entries) {
        triggerHandlers(type, {
            entries: entries
        });
    }, options);
}
function addHandler(type, handler) {
    handlers[type] = handlers[type] || [];
    handlers[type].push(handler);
}
// Get a callback which can be called to remove the instrumentation handler
function getCleanupCallback(type, callback, stopListening) {
    return function() {
        if (stopListening) stopListening();
        var typeHandlers = handlers[type];
        if (!typeHandlers) return;
        var index = typeHandlers.indexOf(callback);
        if (index !== -1) typeHandlers.splice(index, 1);
    };
}

},{"@sentry/utils":"gElXU","../common/debug-build.js":"eGerB","./web-vitals/getCLS.js":"2e4TI","./web-vitals/getFID.js":"8LJeH","./web-vitals/getINP.js":"1HBSL","./web-vitals/getLCP.js":"1rVpM","./web-vitals/lib/observe.js":"9pvai","./web-vitals/onTTFB.js":"hxUQa","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2e4TI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "onCLS", function() {
    return onCLS;
});
var _bindReporterJs = require("./lib/bindReporter.js");
var _initMetricJs = require("./lib/initMetric.js");
var _observeJs = require("./lib/observe.js");
var _onHiddenJs = require("./lib/onHidden.js");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [CLS](https://web.dev/cls/) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/cls/#layout-shift-score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ var onCLS = function(onReport) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var metric = (0, _initMetricJs.initMetric)('CLS', 0);
    var report;
    var sessionValue = 0;
    var sessionEntries = [];
    // const handleEntries = (entries: Metric['entries']) => {
    var handleEntries = function(entries) {
        entries.forEach(function(entry) {
            // Only count layout shifts without recent user input.
            if (!entry.hadRecentInput) {
                var firstSessionEntry = sessionEntries[0];
                var lastSessionEntry = sessionEntries[sessionEntries.length - 1];
                // If the entry occurred less than 1 second after the previous entry and
                // less than 5 seconds after the first entry in the session, include the
                // entry in the current session. Otherwise, start a new session.
                if (sessionValue && sessionEntries.length !== 0 && entry.startTime - lastSessionEntry.startTime < 1000 && entry.startTime - firstSessionEntry.startTime < 5000) {
                    sessionValue += entry.value;
                    sessionEntries.push(entry);
                } else {
                    sessionValue = entry.value;
                    sessionEntries = [
                        entry
                    ];
                }
                // If the current session value is larger than the current CLS value,
                // update CLS and the entries contributing to it.
                if (sessionValue > metric.value) {
                    metric.value = sessionValue;
                    metric.entries = sessionEntries;
                    if (report) report();
                }
            }
        });
    };
    var po = (0, _observeJs.observe)('layout-shift', handleEntries);
    if (po) {
        report = (0, _bindReporterJs.bindReporter)(onReport, metric, options.reportAllChanges);
        var stopListening = function() {
            handleEntries(po.takeRecords());
            report(true);
        };
        (0, _onHiddenJs.onHidden)(stopListening);
        return stopListening;
    }
    return;
};

},{"./lib/bindReporter.js":"bnXmm","./lib/initMetric.js":"5Nfpk","./lib/observe.js":"9pvai","./lib/onHidden.js":"fcsZ4","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"bnXmm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "bindReporter", function() {
    return bindReporter;
});
var bindReporter = function(callback, metric, reportAllChanges) {
    var prevValue;
    var delta;
    return function(forceReport) {
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                delta = metric.value - (prevValue || 0);
                // Report the metric if there's a non-zero delta or if no previous
                // value exists (which can happen in the case of the document becoming
                // hidden when the metric value is 0).
                // See: https://github.com/GoogleChrome/web-vitals/issues/14
                if (delta || prevValue === undefined) {
                    prevValue = metric.value;
                    metric.delta = delta;
                    callback(metric);
                }
            }
        }
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5Nfpk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initMetric", function() {
    return initMetric;
});
var _typesJs = require("../../types.js");
var _generateUniqueIDJs = require("./generateUniqueID.js");
var _getActivationStartJs = require("./getActivationStart.js");
var _getNavigationEntryJs = require("./getNavigationEntry.js");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var initMetric = function(name, value) {
    var navEntry = (0, _getNavigationEntryJs.getNavigationEntry)();
    var navigationType = 'navigate';
    if (navEntry) {
        if ((0, _typesJs.WINDOW).document && (0, _typesJs.WINDOW).document.prerendering || (0, _getActivationStartJs.getActivationStart)() > 0) navigationType = 'prerender';
        else navigationType = navEntry.type.replace(/_/g, '-');
    }
    return {
        name: name,
        value: typeof value === 'undefined' ? -1 : value,
        rating: 'good',
        delta: 0,
        entries: [],
        id: (0, _generateUniqueIDJs.generateUniqueID)(),
        navigationType: navigationType
    };
};

},{"../../types.js":"dT4HR","./generateUniqueID.js":"keb5h","./getActivationStart.js":"dEHwR","./getNavigationEntry.js":"l6LK2","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"keb5h":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generateUniqueID", function() {
    return generateUniqueID;
});
var generateUniqueID = function() {
    return `v3-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"dEHwR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getActivationStart", function() {
    return getActivationStart;
});
var _getNavigationEntryJs = require("./getNavigationEntry.js");
/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var getActivationStart = function() {
    var navEntry = (0, _getNavigationEntryJs.getNavigationEntry)();
    return navEntry && navEntry.activationStart || 0;
};

},{"./getNavigationEntry.js":"l6LK2","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"l6LK2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getNavigationEntry", function() {
    return getNavigationEntry;
});
var _typesJs = require("../../types.js");
/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var getNavigationEntryFromPerformanceTiming = function() {
    // eslint-disable-next-line deprecation/deprecation
    var timing = (0, _typesJs.WINDOW).performance.timing;
    // eslint-disable-next-line deprecation/deprecation
    var type = (0, _typesJs.WINDOW).performance.navigation.type;
    var navigationEntry = {
        entryType: 'navigation',
        startTime: 0,
        type: type == 2 ? 'back_forward' : type === 1 ? 'reload' : 'navigate'
    };
    for(var key in timing)if (key !== 'navigationStart' && key !== 'toJSON') // eslint-disable-next-line deprecation/deprecation
    navigationEntry[key] = Math.max(timing[key] - timing.navigationStart, 0);
    return navigationEntry;
};
var getNavigationEntry = function() {
    if ((0, _typesJs.WINDOW).__WEB_VITALS_POLYFILL__) return (0, _typesJs.WINDOW).performance && (performance.getEntriesByType && performance.getEntriesByType('navigation')[0] || getNavigationEntryFromPerformanceTiming());
    else return (0, _typesJs.WINDOW).performance && performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
};

},{"../../types.js":"dT4HR","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"9pvai":[function(require,module,exports,__globalThis) {
/**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "observe", function() {
    return observe;
});
var observe = function(type, callback, opts) {
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            var po = new PerformanceObserver(function(list) {
                callback(list.getEntries());
            });
            po.observe(Object.assign({
                type: type,
                buffered: true
            }, opts || {}));
            return po;
        }
    } catch (e) {
    // Do nothing.
    }
    return;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"fcsZ4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "onHidden", function() {
    return onHidden;
});
var _typesJs = require("../../types.js");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var onHidden = function(cb, once) {
    var onHiddenOrPageHide = function(event) {
        if (event.type === 'pagehide' || (0, _typesJs.WINDOW).document.visibilityState === 'hidden') {
            cb(event);
            if (once) {
                removeEventListener('visibilitychange', onHiddenOrPageHide, true);
                removeEventListener('pagehide', onHiddenOrPageHide, true);
            }
        }
    };
    if ((0, _typesJs.WINDOW).document) {
        addEventListener('visibilitychange', onHiddenOrPageHide, true);
        // Some browsers have buggy implementations of visibilitychange,
        // so we use pagehide in addition, just to be safe.
        addEventListener('pagehide', onHiddenOrPageHide, true);
    }
};

},{"../../types.js":"dT4HR","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8LJeH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "onFID", function() {
    return onFID;
});
var _bindReporterJs = require("./lib/bindReporter.js");
var _getVisibilityWatcherJs = require("./lib/getVisibilityWatcher.js");
var _initMetricJs = require("./lib/initMetric.js");
var _observeJs = require("./lib/observe.js");
var _onHiddenJs = require("./lib/onHidden.js");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [FID](https://web.dev/fid/) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `first-input` performance entry used to determine the value. The
 * reported value is a `DOMHighResTimeStamp`.
 *
 * _**Important:** since FID is only reported after the user interacts with the
 * page, it's possible that it will not be reported for some page loads._
 */ var onFID = function(onReport) {
    var visibilityWatcher = (0, _getVisibilityWatcherJs.getVisibilityWatcher)();
    var metric = (0, _initMetricJs.initMetric)('FID');
    // eslint-disable-next-line prefer-const
    var report;
    var handleEntry = function(entry) {
        // Only report if the page wasn't hidden prior to the first input.
        if (entry.startTime < visibilityWatcher.firstHiddenTime) {
            metric.value = entry.processingStart - entry.startTime;
            metric.entries.push(entry);
            report(true);
        }
    };
    var handleEntries = function(entries) {
        entries.forEach(handleEntry);
    };
    var po = (0, _observeJs.observe)('first-input', handleEntries);
    report = (0, _bindReporterJs.bindReporter)(onReport, metric);
    if (po) (0, _onHiddenJs.onHidden)(function() {
        handleEntries(po.takeRecords());
        po.disconnect();
    }, true);
};

},{"./lib/bindReporter.js":"bnXmm","./lib/getVisibilityWatcher.js":"ccy9E","./lib/initMetric.js":"5Nfpk","./lib/observe.js":"9pvai","./lib/onHidden.js":"fcsZ4","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"ccy9E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getVisibilityWatcher", function() {
    return getVisibilityWatcher;
});
var _typesJs = require("../../types.js");
var _onHiddenJs = require("./onHidden.js");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var firstHiddenTime = -1;
var initHiddenTime = function() {
    // If the document is hidden and not prerendering, assume it was always
    // hidden and the page was loaded in the background.
    if ((0, _typesJs.WINDOW).document && (0, _typesJs.WINDOW).document.visibilityState) firstHiddenTime = (0, _typesJs.WINDOW).document.visibilityState === 'hidden' && !(0, _typesJs.WINDOW).document.prerendering ? 0 : Infinity;
};
var trackChanges = function() {
    // Update the time if/when the document becomes hidden.
    (0, _onHiddenJs.onHidden)(function(param) {
        var timeStamp = param.timeStamp;
        firstHiddenTime = timeStamp;
    }, true);
};
var getVisibilityWatcher = function() {
    if (firstHiddenTime < 0) {
        // If the document is hidden when this code runs, assume it was hidden
        // since navigation start. This isn't a perfect heuristic, but it's the
        // best we can do until an API is available to support querying past
        // visibilityState.
        initHiddenTime();
        trackChanges();
    }
    return {
        get firstHiddenTime () {
            return firstHiddenTime;
        }
    };
};

},{"../../types.js":"dT4HR","./onHidden.js":"fcsZ4","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1HBSL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "onINP", function() {
    return onINP;
});
var _bindReporterJs = require("./lib/bindReporter.js");
var _initMetricJs = require("./lib/initMetric.js");
var _observeJs = require("./lib/observe.js");
var _onHiddenJs = require("./lib/onHidden.js");
var _interactionCountPolyfillJs = require("./lib/polyfills/interactionCountPolyfill.js");
/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the interaction count since the last bfcache restore (or for the
 * full page lifecycle if there were no bfcache restores).
 */ var getInteractionCountForNavigation = function() {
    return (0, _interactionCountPolyfillJs.getInteractionCount)();
};
// To prevent unnecessary memory usage on pages with lots of interactions,
// store at most 10 of the longest interactions to consider as INP candidates.
var MAX_INTERACTIONS_TO_CONSIDER = 10;
// A list of longest interactions on the page (by latency) sorted so the
// longest one is first. The list is as most MAX_INTERACTIONS_TO_CONSIDER long.
var longestInteractionList = [];
// A mapping of longest interactions by their interaction ID.
// This is used for faster lookup.
var longestInteractionMap = {};
/**
 * Takes a performance entry and adds it to the list of worst interactions
 * if its duration is long enough to make it among the worst. If the
 * entry is part of an existing interaction, it is merged and the latency
 * and entries list is updated as needed.
 */ var processEntry = function(entry) {
    // The least-long of the 10 longest interactions.
    var minLongestInteraction = longestInteractionList[longestInteractionList.length - 1];
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    var existingInteraction = longestInteractionMap[entry.interactionId];
    // Only process the entry if it's possibly one of the ten longest,
    // or if it's part of an existing interaction.
    if (existingInteraction || longestInteractionList.length < MAX_INTERACTIONS_TO_CONSIDER || entry.duration > minLongestInteraction.latency) {
        // If the interaction already exists, update it. Otherwise create one.
        if (existingInteraction) {
            existingInteraction.entries.push(entry);
            existingInteraction.latency = Math.max(existingInteraction.latency, entry.duration);
        } else {
            var interaction = {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                id: entry.interactionId,
                latency: entry.duration,
                entries: [
                    entry
                ]
            };
            longestInteractionMap[interaction.id] = interaction;
            longestInteractionList.push(interaction);
        }
        // Sort the entries by latency (descending) and keep only the top ten.
        longestInteractionList.sort(function(a, b) {
            return b.latency - a.latency;
        });
        longestInteractionList.splice(MAX_INTERACTIONS_TO_CONSIDER).forEach(function(i) {
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete longestInteractionMap[i.id];
        });
    }
};
/**
 * Returns the estimated p98 longest interaction based on the stored
 * interaction candidates and the interaction count for the current page.
 */ var estimateP98LongestInteraction = function() {
    var candidateInteractionIndex = Math.min(longestInteractionList.length - 1, Math.floor(getInteractionCountForNavigation() / 50));
    return longestInteractionList[candidateInteractionIndex];
};
/**
 * Calculates the [INP](https://web.dev/responsiveness/) value for the current
 * page and calls the `callback` function once the value is ready, along with
 * the `event` performance entries reported for that interaction. The reported
 * value is a `DOMHighResTimeStamp`.
 *
 * A custom `durationThreshold` configuration option can optionally be passed to
 * control what `event-timing` entries are considered for INP reporting. The
 * default threshold is `40`, which means INP scores of less than 40 are
 * reported as 0. Note that this will not affect your 75th percentile INP value
 * unless that value is also less than 40 (well below the recommended
 * [good](https://web.dev/inp/#what-is-a-good-inp-score) threshold).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** INP should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ var onINP = function(onReport, opts) {
    // Set defaults
    // eslint-disable-next-line no-param-reassign
    opts = opts || {};
    // https://web.dev/inp/#what's-a-%22good%22-inp-value
    // const thresholds = [200, 500];
    // TODO(philipwalton): remove once the polyfill is no longer needed.
    (0, _interactionCountPolyfillJs.initInteractionCountPolyfill)();
    var metric = (0, _initMetricJs.initMetric)('INP');
    // eslint-disable-next-line prefer-const
    var report;
    var handleEntries = function(entries) {
        entries.forEach(function(entry) {
            if (entry.interactionId) processEntry(entry);
            // Entries of type `first-input` don't currently have an `interactionId`,
            // so to consider them in INP we have to first check that an existing
            // entry doesn't match the `duration` and `startTime`.
            // Note that this logic assumes that `event` entries are dispatched
            // before `first-input` entries. This is true in Chrome but it is not
            // true in Firefox; however, Firefox doesn't support interactionId, so
            // it's not an issue at the moment.
            // TODO(philipwalton): remove once crbug.com/1325826 is fixed.
            if (entry.entryType === 'first-input') {
                var noMatchingEntry = !longestInteractionList.some(function(interaction) {
                    return interaction.entries.some(function(prevEntry) {
                        return entry.duration === prevEntry.duration && entry.startTime === prevEntry.startTime;
                    });
                });
                if (noMatchingEntry) processEntry(entry);
            }
        });
        var inp = estimateP98LongestInteraction();
        if (inp && inp.latency !== metric.value) {
            metric.value = inp.latency;
            metric.entries = inp.entries;
            report();
        }
    };
    var po = (0, _observeJs.observe)('event', handleEntries, {
        // Event Timing entries have their durations rounded to the nearest 8ms,
        // so a duration of 40ms would be any event that spans 2.5 or more frames
        // at 60Hz. This threshold is chosen to strike a balance between usefulness
        // and performance. Running this callback for any interaction that spans
        // just one or two frames is likely not worth the insight that could be
        // gained.
        durationThreshold: opts.durationThreshold || 40
    });
    report = (0, _bindReporterJs.bindReporter)(onReport, metric, opts.reportAllChanges);
    if (po) {
        // Also observe entries of type `first-input`. This is useful in cases
        // where the first interaction is less than the `durationThreshold`.
        po.observe({
            type: 'first-input',
            buffered: true
        });
        (0, _onHiddenJs.onHidden)(function() {
            handleEntries(po.takeRecords());
            // If the interaction count shows that there were interactions but
            // none were captured by the PerformanceObserver, report a latency of 0.
            if (metric.value < 0 && getInteractionCountForNavigation() > 0) {
                metric.value = 0;
                metric.entries = [];
            }
            report(true);
        });
    }
};

},{"./lib/bindReporter.js":"bnXmm","./lib/initMetric.js":"5Nfpk","./lib/observe.js":"9pvai","./lib/onHidden.js":"fcsZ4","./lib/polyfills/interactionCountPolyfill.js":"jxh6f","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jxh6f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getInteractionCount", function() {
    return getInteractionCount;
});
parcelHelpers.export(exports, "initInteractionCountPolyfill", function() {
    return initInteractionCountPolyfill;
});
var _observeJs = require("../observe.js");
var interactionCountEstimate = 0;
var minKnownInteractionId = Infinity;
var maxKnownInteractionId = 0;
var updateEstimate = function(entries) {
    entries.forEach(function(e) {
        if (e.interactionId) {
            minKnownInteractionId = Math.min(minKnownInteractionId, e.interactionId);
            maxKnownInteractionId = Math.max(maxKnownInteractionId, e.interactionId);
            interactionCountEstimate = maxKnownInteractionId ? (maxKnownInteractionId - minKnownInteractionId) / 7 + 1 : 0;
        }
    });
};
var po;
/**
 * Returns the `interactionCount` value using the native API (if available)
 * or the polyfill estimate in this module.
 */ var getInteractionCount = function() {
    return po ? interactionCountEstimate : performance.interactionCount || 0;
};
/**
 * Feature detects native support or initializes the polyfill if needed.
 */ var initInteractionCountPolyfill = function() {
    if ('interactionCount' in performance || po) return;
    po = (0, _observeJs.observe)('event', updateEstimate, {
        type: 'event',
        buffered: true,
        durationThreshold: 0
    });
};

},{"../observe.js":"9pvai","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1rVpM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "onLCP", function() {
    return onLCP;
});
var _typesJs = require("../types.js");
var _bindReporterJs = require("./lib/bindReporter.js");
var _getActivationStartJs = require("./lib/getActivationStart.js");
var _getVisibilityWatcherJs = require("./lib/getVisibilityWatcher.js");
var _initMetricJs = require("./lib/initMetric.js");
var _observeJs = require("./lib/observe.js");
var _onHiddenJs = require("./lib/onHidden.js");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var reportedMetricIDs = {};
/**
 * Calculates the [LCP](https://web.dev/lcp/) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 */ var onLCP = function(onReport) {
    var visibilityWatcher = (0, _getVisibilityWatcherJs.getVisibilityWatcher)();
    var metric = (0, _initMetricJs.initMetric)('LCP');
    var report;
    var handleEntries = function(entries) {
        var lastEntry = entries[entries.length - 1];
        if (lastEntry) {
            // The startTime attribute returns the value of the renderTime if it is
            // not 0, and the value of the loadTime otherwise. The activationStart
            // reference is used because LCP should be relative to page activation
            // rather than navigation start if the page was prerendered.
            var value = Math.max(lastEntry.startTime - (0, _getActivationStartJs.getActivationStart)(), 0);
            // Only report if the page wasn't hidden prior to LCP.
            if (value < visibilityWatcher.firstHiddenTime) {
                metric.value = value;
                metric.entries = [
                    lastEntry
                ];
                report();
            }
        }
    };
    var po = (0, _observeJs.observe)('largest-contentful-paint', handleEntries);
    if (po) {
        report = (0, _bindReporterJs.bindReporter)(onReport, metric);
        var stopListening = function() {
            if (!reportedMetricIDs[metric.id]) {
                handleEntries(po.takeRecords());
                po.disconnect();
                reportedMetricIDs[metric.id] = true;
                report(true);
            }
        };
        // Stop listening after input. Note: while scrolling is an input that
        // stop LCP observation, it's unreliable since it can be programmatically
        // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
        [
            'keydown',
            'click'
        ].forEach(function(type) {
            if ((0, _typesJs.WINDOW).document) addEventListener(type, stopListening, {
                once: true,
                capture: true
            });
        });
        (0, _onHiddenJs.onHidden)(stopListening, true);
        return stopListening;
    }
    return;
};

},{"../types.js":"dT4HR","./lib/bindReporter.js":"bnXmm","./lib/getActivationStart.js":"dEHwR","./lib/getVisibilityWatcher.js":"ccy9E","./lib/initMetric.js":"5Nfpk","./lib/observe.js":"9pvai","./lib/onHidden.js":"fcsZ4","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"hxUQa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "onTTFB", function() {
    return onTTFB;
});
var _typesJs = require("../types.js");
var _bindReporterJs = require("./lib/bindReporter.js");
var _getActivationStartJs = require("./lib/getActivationStart.js");
var _getNavigationEntryJs = require("./lib/getNavigationEntry.js");
var _initMetricJs = require("./lib/initMetric.js");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Runs in the next task after the page is done loading and/or prerendering.
 * @param callback
 */ var whenReady = function(callback) {
    if (!(0, _typesJs.WINDOW).document) return;
    if ((0, _typesJs.WINDOW).document.prerendering) addEventListener('prerenderingchange', function() {
        return whenReady(callback);
    }, true);
    else if ((0, _typesJs.WINDOW).document.readyState !== 'complete') addEventListener('load', function() {
        return whenReady(callback);
    }, true);
    else // Queue a task so the callback runs after `loadEventEnd`.
    setTimeout(callback, 0);
};
/**
 * Calculates the [TTFB](https://web.dev/time-to-first-byte/) value for the
 * current page and calls the `callback` function once the page has loaded,
 * along with the relevant `navigation` performance entry used to determine the
 * value. The reported value is a `DOMHighResTimeStamp`.
 *
 * Note, this function waits until after the page is loaded to call `callback`
 * in order to ensure all properties of the `navigation` entry are populated.
 * This is useful if you want to report on other metrics exposed by the
 * [Navigation Timing API](https://w3c.github.io/navigation-timing/). For
 * example, the TTFB metric starts from the page's [time
 * origin](https://www.w3.org/TR/hr-time-2/#sec-time-origin), which means it
 * includes time spent on DNS lookup, connection negotiation, network latency,
 * and server processing time.
 */ var onTTFB = function(onReport, opts) {
    // Set defaults
    // eslint-disable-next-line no-param-reassign
    opts = opts || {};
    // https://web.dev/ttfb/#what-is-a-good-ttfb-score
    // const thresholds = [800, 1800];
    var metric = (0, _initMetricJs.initMetric)('TTFB');
    var report = (0, _bindReporterJs.bindReporter)(onReport, metric, opts.reportAllChanges);
    whenReady(function() {
        var navEntry = (0, _getNavigationEntryJs.getNavigationEntry)();
        if (navEntry) {
            // The activationStart reference is used because TTFB should be
            // relative to page activation rather than navigation start if the
            // page was prerendered. But in cases where `activationStart` occurs
            // after the first byte is received, this time should be clamped at 0.
            metric.value = Math.max(navEntry.responseStart - (0, _getActivationStartJs.getActivationStart)(), 0);
            // In some cases the value reported is negative or is larger
            // than the current page time. Ignore these cases:
            // https://github.com/GoogleChrome/web-vitals/issues/137
            // https://github.com/GoogleChrome/web-vitals/issues/162
            if (metric.value < 0 || metric.value > performance.now()) return;
            metric.entries = [
                navEntry
            ];
            report(true);
        }
    });
};

},{"../types.js":"dT4HR","./lib/bindReporter.js":"bnXmm","./lib/getActivationStart.js":"dEHwR","./lib/getNavigationEntry.js":"l6LK2","./lib/initMetric.js":"5Nfpk","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"iTapn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_addMeasureSpans", function() {
    return _addMeasureSpans;
});
parcelHelpers.export(exports, "_addResourceSpans", function() {
    return _addResourceSpans;
});
parcelHelpers.export(exports, "addPerformanceEntries", function() {
    return addPerformanceEntries;
});
parcelHelpers.export(exports, "startTrackingINP", function() {
    return startTrackingINP;
});
parcelHelpers.export(exports, "startTrackingInteractions", function() {
    return startTrackingInteractions;
});
parcelHelpers.export(exports, "startTrackingLongTasks", function() {
    return startTrackingLongTasks;
});
parcelHelpers.export(exports, "startTrackingWebVitals", function() {
    return startTrackingWebVitals;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
var _debugBuildJs = require("../../common/debug-build.js");
var _instrumentJs = require("../instrument.js");
var _typesJs = require("../types.js");
var _getVisibilityWatcherJs = require("../web-vitals/lib/getVisibilityWatcher.js");
var _utilsJs = require("./utils.js");
var _getNavigationEntryJs = require("../web-vitals/lib/getNavigationEntry.js");
var MAX_INT_AS_BYTES = 2147483647;
/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */ function msToSec(time) {
    return time / 1000;
}
function getBrowserPerformanceAPI() {
    // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
    return (0, _typesJs.WINDOW) && (0, _typesJs.WINDOW).addEventListener && (0, _typesJs.WINDOW).performance;
}
var _performanceCursor = 0;
var _measurements = {};
var _lcpEntry;
var _clsEntry;
/**
 * Start tracking web vitals.
 * The callback returned by this function can be used to stop tracking & ensure all measurements are final & captured.
 *
 * @returns A function that forces web vitals collection
 */ function startTrackingWebVitals() {
    var performance = getBrowserPerformanceAPI();
    if (performance && (0, _utils.browserPerformanceTimeOrigin)) {
        // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
        if (performance.mark) (0, _typesJs.WINDOW).performance.mark('sentry-tracing-init');
        var fidCallback = _trackFID();
        var clsCallback = _trackCLS();
        var lcpCallback = _trackLCP();
        var ttfbCallback = _trackTtfb();
        return function() {
            fidCallback();
            clsCallback();
            lcpCallback();
            ttfbCallback();
        };
    }
    return function() {
        return undefined;
    };
}
/**
 * Start tracking long tasks.
 */ function startTrackingLongTasks() {
    (0, _instrumentJs.addPerformanceInstrumentationHandler)('longtask', function(param) {
        var entries = param.entries;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var entry = _step.value;
                // eslint-disable-next-line deprecation/deprecation
                var transaction = (0, _core.getActiveTransaction)();
                if (!transaction) return;
                var startTime = msToSec((0, _utils.browserPerformanceTimeOrigin) + entry.startTime);
                var duration = msToSec(entry.duration);
                // eslint-disable-next-line deprecation/deprecation
                transaction.startChild({
                    description: 'Main UI thread blocked',
                    op: 'ui.long-task',
                    origin: 'auto.ui.browser.metrics',
                    startTimestamp: startTime,
                    endTimestamp: startTime + duration
                });
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
}
/**
 * Start tracking interaction events.
 */ function startTrackingInteractions() {
    (0, _instrumentJs.addPerformanceInstrumentationHandler)('event', function(param) {
        var entries = param.entries;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var entry = _step.value;
                // eslint-disable-next-line deprecation/deprecation
                var transaction = (0, _core.getActiveTransaction)();
                if (!transaction) return;
                if (entry.name === 'click') {
                    var startTime = msToSec((0, _utils.browserPerformanceTimeOrigin) + entry.startTime);
                    var duration = msToSec(entry.duration);
                    var span = {
                        description: (0, _utils.htmlTreeAsString)(entry.target),
                        op: `ui.interaction.${entry.name}`,
                        origin: 'auto.ui.browser.metrics',
                        startTimestamp: startTime,
                        endTimestamp: startTime + duration
                    };
                    var componentName = (0, _utils.getComponentName)(entry.target);
                    if (componentName) span.attributes = {
                        'ui.component_name': componentName
                    };
                    // eslint-disable-next-line deprecation/deprecation
                    transaction.startChild(span);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
}
/**
 * Start tracking INP webvital events.
 */ function startTrackingINP(interactionIdtoRouteNameMapping, interactionsSampleRate) {
    var performance = getBrowserPerformanceAPI();
    if (performance && (0, _utils.browserPerformanceTimeOrigin)) {
        var inpCallback = _trackINP(interactionIdtoRouteNameMapping, interactionsSampleRate);
        return function() {
            inpCallback();
        };
    }
    return function() {
        return undefined;
    };
}
/** Starts tracking the Cumulative Layout Shift on the current page. */ function _trackCLS() {
    return (0, _instrumentJs.addClsInstrumentationHandler)(function(param) {
        var metric = param.metric;
        var entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log('[Measurements] Adding CLS');
        _measurements['cls'] = {
            value: metric.value,
            unit: ''
        };
        _clsEntry = entry;
    }, true);
}
/** Starts tracking the Largest Contentful Paint on the current page. */ function _trackLCP() {
    return (0, _instrumentJs.addLcpInstrumentationHandler)(function(param) {
        var metric = param.metric;
        var entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log('[Measurements] Adding LCP');
        _measurements['lcp'] = {
            value: metric.value,
            unit: 'millisecond'
        };
        _lcpEntry = entry;
    }, true);
}
/** Starts tracking the First Input Delay on the current page. */ function _trackFID() {
    return (0, _instrumentJs.addFidInstrumentationHandler)(function(param) {
        var metric = param.metric;
        var entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        var timeOrigin = msToSec((0, _utils.browserPerformanceTimeOrigin));
        var startTime = msToSec(entry.startTime);
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log('[Measurements] Adding FID');
        _measurements['fid'] = {
            value: metric.value,
            unit: 'millisecond'
        };
        _measurements['mark.fid'] = {
            value: timeOrigin + startTime,
            unit: 'second'
        };
    });
}
function _trackTtfb() {
    return (0, _instrumentJs.addTtfbInstrumentationHandler)(function(param) {
        var metric = param.metric;
        var entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log('[Measurements] Adding TTFB');
        _measurements['ttfb'] = {
            value: metric.value,
            unit: 'millisecond'
        };
    });
}
var INP_ENTRY_MAP = {
    click: 'click',
    pointerdown: 'click',
    pointerup: 'click',
    mousedown: 'click',
    mouseup: 'click',
    touchstart: 'click',
    touchend: 'click',
    mouseover: 'hover',
    mouseout: 'hover',
    mouseenter: 'hover',
    mouseleave: 'hover',
    pointerover: 'hover',
    pointerout: 'hover',
    pointerenter: 'hover',
    pointerleave: 'hover',
    dragstart: 'drag',
    dragend: 'drag',
    drag: 'drag',
    dragenter: 'drag',
    dragleave: 'drag',
    dragover: 'drag',
    drop: 'drag',
    keydown: 'press',
    keyup: 'press',
    keypress: 'press',
    input: 'press'
};
/** Starts tracking the Interaction to Next Paint on the current page. */ function _trackINP(interactionIdToRouteNameMapping, interactionsSampleRate) {
    return (0, _instrumentJs.addInpInstrumentationHandler)(function(param) {
        var metric = param.metric;
        if (metric.value === undefined) return;
        var entry = metric.entries.find(function(entry) {
            return entry.duration === metric.value && INP_ENTRY_MAP[entry.name] !== undefined;
        });
        var client = (0, _core.getClient)();
        if (!entry || !client) return;
        var interactionType = INP_ENTRY_MAP[entry.name];
        var options = client.getOptions();
        /** Build the INP span, create an envelope from the span, and then send the envelope */ var startTime = msToSec((0, _utils.browserPerformanceTimeOrigin) + entry.startTime);
        var duration = msToSec(metric.value);
        var interaction = entry.interactionId !== undefined ? interactionIdToRouteNameMapping[entry.interactionId] : undefined;
        if (interaction === undefined) return;
        var routeName = interaction.routeName, parentContext = interaction.parentContext, activeTransaction = interaction.activeTransaction, user = interaction.user, replayId = interaction.replayId;
        var userDisplay = user !== undefined ? user.email || user.id || user.ip_address : undefined;
        // eslint-disable-next-line deprecation/deprecation
        var profileId = activeTransaction !== undefined ? activeTransaction.getProfileId() : undefined;
        var span = new (0, _core.Span)({
            startTimestamp: startTime,
            endTimestamp: startTime + duration,
            op: `ui.interaction.${interactionType}`,
            name: (0, _utils.htmlTreeAsString)(entry.target),
            attributes: (0, _objectSpread._)({
                release: options.release,
                environment: options.environment,
                transaction: routeName
            }, userDisplay !== undefined && userDisplay !== '' ? {
                user: userDisplay
            } : {}, profileId !== undefined ? {
                profile_id: profileId
            } : {}, replayId !== undefined ? {
                replay_id: replayId
            } : {}),
            exclusiveTime: metric.value,
            measurements: {
                inp: {
                    value: metric.value,
                    unit: 'millisecond'
                }
            }
        });
        /** Check to see if the span should be sampled */ var sampleRate = getSampleRate(parentContext, options, interactionsSampleRate);
        if (!sampleRate) return;
        if (Math.random() < sampleRate) {
            var envelope = span ? (0, _core.createSpanEnvelope)([
                span
            ], client.getDsn()) : undefined;
            var transport = client && client.getTransport();
            if (transport && envelope) transport.send(envelope).then(null, function(reason) {
                (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).error('Error while sending interaction:', reason);
            });
            return;
        }
    });
}
/** Add performance related spans to a transaction */ function addPerformanceEntries(transaction) {
    var performance = getBrowserPerformanceAPI();
    if (!performance || !(0, _typesJs.WINDOW).performance.getEntries || !(0, _utils.browserPerformanceTimeOrigin)) // Gatekeeper if performance API not available
    return;
    (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log('[Tracing] Adding & adjusting spans using Performance API');
    var timeOrigin = msToSec((0, _utils.browserPerformanceTimeOrigin));
    var performanceEntries = performance.getEntries();
    var _spanToJSON = (0, _core.spanToJSON)(transaction), op = _spanToJSON.op, transactionStartTime = _spanToJSON.start_timestamp;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    performanceEntries.slice(_performanceCursor).forEach(function(entry) {
        var startTime = msToSec(entry.startTime);
        var duration = msToSec(entry.duration);
        // eslint-disable-next-line deprecation/deprecation
        if (transaction.op === 'navigation' && transactionStartTime && timeOrigin + startTime < transactionStartTime) return;
        switch(entry.entryType){
            case 'navigation':
                _addNavigationSpans(transaction, entry, timeOrigin);
                break;
            case 'mark':
            case 'paint':
            case 'measure':
                {
                    _addMeasureSpans(transaction, entry, startTime, duration, timeOrigin);
                    // capture web vitals
                    var firstHidden = (0, _getVisibilityWatcherJs.getVisibilityWatcher)();
                    // Only report if the page wasn't hidden prior to the web vital.
                    var shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
                    if (entry.name === 'first-paint' && shouldRecord) {
                        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log('[Measurements] Adding FP');
                        _measurements['fp'] = {
                            value: entry.startTime,
                            unit: 'millisecond'
                        };
                    }
                    if (entry.name === 'first-contentful-paint' && shouldRecord) {
                        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log('[Measurements] Adding FCP');
                        _measurements['fcp'] = {
                            value: entry.startTime,
                            unit: 'millisecond'
                        };
                    }
                    break;
                }
            case 'resource':
                _addResourceSpans(transaction, entry, entry.name, startTime, duration, timeOrigin);
                break;
        }
    });
    _performanceCursor = Math.max(performanceEntries.length - 1, 0);
    _trackNavigator(transaction);
    // Measurements are only available for pageload transactions
    if (op === 'pageload') {
        _addTtfbRequestTimeToMeasurements(_measurements);
        [
            'fcp',
            'fp',
            'lcp'
        ].forEach(function(name) {
            if (!_measurements[name] || !transactionStartTime || timeOrigin >= transactionStartTime) return;
            // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
            // Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
            // to be adjusted to be relative to transaction.startTimestamp.
            var oldValue = _measurements[name].value;
            var measurementTimestamp = timeOrigin + msToSec(oldValue);
            // normalizedValue should be in milliseconds
            var normalizedValue = Math.abs((measurementTimestamp - transactionStartTime) * 1000);
            var delta = normalizedValue - oldValue;
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log(`[Measurements] Normalized ${name} from ${oldValue} to ${normalizedValue} (${delta})`);
            _measurements[name].value = normalizedValue;
        });
        var fidMark = _measurements['mark.fid'];
        if (fidMark && _measurements['fid']) {
            // create span for FID
            (0, _utilsJs._startChild)(transaction, {
                description: 'first input delay',
                endTimestamp: fidMark.value + msToSec(_measurements['fid'].value),
                op: 'ui.action',
                origin: 'auto.ui.browser.metrics',
                startTimestamp: fidMark.value
            });
            // Delete mark.fid as we don't want it to be part of final payload
            delete _measurements['mark.fid'];
        }
        // If FCP is not recorded we should not record the cls value
        // according to the new definition of CLS.
        if (!('fcp' in _measurements)) delete _measurements.cls;
        Object.keys(_measurements).forEach(function(measurementName) {
            (0, _core.setMeasurement)(measurementName, _measurements[measurementName].value, _measurements[measurementName].unit);
        });
        _tagMetricInfo(transaction);
    }
    _lcpEntry = undefined;
    _clsEntry = undefined;
    _measurements = {};
}
/** Create measure related spans */ function _addMeasureSpans(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, startTime, duration, timeOrigin) {
    var measureStartTimestamp = timeOrigin + startTime;
    var measureEndTimestamp = measureStartTimestamp + duration;
    (0, _utilsJs._startChild)(transaction, {
        description: entry.name,
        endTimestamp: measureEndTimestamp,
        op: entry.entryType,
        origin: 'auto.resource.browser.metrics',
        startTimestamp: measureStartTimestamp
    });
    return measureStartTimestamp;
}
/** Instrument navigation entries */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function _addNavigationSpans(transaction, entry, timeOrigin) {
    [
        'unloadEvent',
        'redirect',
        'domContentLoadedEvent',
        'loadEvent',
        'connect'
    ].forEach(function(event) {
        _addPerformanceNavigationTiming(transaction, entry, event, timeOrigin);
    });
    _addPerformanceNavigationTiming(transaction, entry, 'secureConnection', timeOrigin, 'TLS/SSL', 'connectEnd');
    _addPerformanceNavigationTiming(transaction, entry, 'fetch', timeOrigin, 'cache', 'domainLookupStart');
    _addPerformanceNavigationTiming(transaction, entry, 'domainLookup', timeOrigin, 'DNS');
    _addRequest(transaction, entry, timeOrigin);
}
/** Create performance navigation related spans */ function _addPerformanceNavigationTiming(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, event, timeOrigin, description, eventEnd) {
    var end = eventEnd ? entry[eventEnd] : entry[`${event}End`];
    var start = entry[`${event}Start`];
    if (!start || !end) return;
    (0, _utilsJs._startChild)(transaction, {
        op: 'browser',
        origin: 'auto.browser.browser.metrics',
        description: description || event,
        startTimestamp: timeOrigin + msToSec(start),
        endTimestamp: timeOrigin + msToSec(end)
    });
}
/** Create request and response related spans */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function _addRequest(transaction, entry, timeOrigin) {
    if (entry.responseEnd) {
        // It is possible that we are collecting these metrics when the page hasn't finished loading yet, for example when the HTML slowly streams in.
        // In this case, ie. when the document request hasn't finished yet, `entry.responseEnd` will be 0.
        // In order not to produce faulty spans, where the end timestamp is before the start timestamp, we will only collect
        // these spans when the responseEnd value is available. The backend (Relay) would drop the entire transaction if it contained faulty spans.
        (0, _utilsJs._startChild)(transaction, {
            op: 'browser',
            origin: 'auto.browser.browser.metrics',
            description: 'request',
            startTimestamp: timeOrigin + msToSec(entry.requestStart),
            endTimestamp: timeOrigin + msToSec(entry.responseEnd)
        });
        (0, _utilsJs._startChild)(transaction, {
            op: 'browser',
            origin: 'auto.browser.browser.metrics',
            description: 'response',
            startTimestamp: timeOrigin + msToSec(entry.responseStart),
            endTimestamp: timeOrigin + msToSec(entry.responseEnd)
        });
    }
}
/** Create resource-related spans */ function _addResourceSpans(transaction, entry, resourceUrl, startTime, duration, timeOrigin) {
    // we already instrument based on fetch and xhr, so we don't need to
    // duplicate spans here.
    if (entry.initiatorType === 'xmlhttprequest' || entry.initiatorType === 'fetch') return;
    var parsedUrl = (0, _utils.parseUrl)(resourceUrl);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var data = {};
    setResourceEntrySizeData(data, entry, 'transferSize', 'http.response_transfer_size');
    setResourceEntrySizeData(data, entry, 'encodedBodySize', 'http.response_content_length');
    setResourceEntrySizeData(data, entry, 'decodedBodySize', 'http.decoded_response_content_length');
    if ('renderBlockingStatus' in entry) data['resource.render_blocking_status'] = entry.renderBlockingStatus;
    if (parsedUrl.protocol) data['url.scheme'] = parsedUrl.protocol.split(':').pop(); // the protocol returned by parseUrl includes a :, but OTEL spec does not, so we remove it.
    if (parsedUrl.host) data['server.address'] = parsedUrl.host;
    data['url.same_origin'] = resourceUrl.includes((0, _typesJs.WINDOW).location.origin);
    var startTimestamp = timeOrigin + startTime;
    var endTimestamp = startTimestamp + duration;
    (0, _utilsJs._startChild)(transaction, {
        description: resourceUrl.replace((0, _typesJs.WINDOW).location.origin, ''),
        endTimestamp: endTimestamp,
        op: entry.initiatorType ? `resource.${entry.initiatorType}` : 'resource.other',
        origin: 'auto.resource.browser.metrics',
        startTimestamp: startTimestamp,
        data: data
    });
}
/**
 * Capture the information of the user agent.
 */ function _trackNavigator(transaction) {
    var navigator = (0, _typesJs.WINDOW).navigator;
    if (!navigator) return;
    // track network connectivity
    var connection = navigator.connection;
    if (connection) {
        if (connection.effectiveType) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag('effectiveConnectionType', connection.effectiveType);
        if (connection.type) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag('connectionType', connection.type);
        if ((0, _utilsJs.isMeasurementValue)(connection.rtt)) _measurements['connection.rtt'] = {
            value: connection.rtt,
            unit: 'millisecond'
        };
    }
    if ((0, _utilsJs.isMeasurementValue)(navigator.deviceMemory)) // TODO: Can we rewrite this to an attribute?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setTag('deviceMemory', `${navigator.deviceMemory} GB`);
    if ((0, _utilsJs.isMeasurementValue)(navigator.hardwareConcurrency)) // TODO: Can we rewrite this to an attribute?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setTag('hardwareConcurrency', String(navigator.hardwareConcurrency));
}
/** Add LCP / CLS data to transaction to allow debugging */ function _tagMetricInfo(transaction) {
    if (_lcpEntry) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log('[Measurements] Adding LCP Data');
        // Capture Properties of the LCP element that contributes to the LCP.
        if (_lcpEntry.element) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag('lcp.element', (0, _utils.htmlTreeAsString)(_lcpEntry.element));
        if (_lcpEntry.id) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag('lcp.id', _lcpEntry.id);
        if (_lcpEntry.url) // Trim URL to the first 200 characters.
        // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag('lcp.url', _lcpEntry.url.trim().slice(0, 200));
        // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag('lcp.size', _lcpEntry.size);
    }
    // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
    if (_clsEntry && _clsEntry.sources) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log('[Measurements] Adding CLS Data');
        _clsEntry.sources.forEach(function(source, index) {
            return(// TODO: Can we rewrite this to an attribute?
            // eslint-disable-next-line deprecation/deprecation
            transaction.setTag(`cls.source.${index + 1}`, (0, _utils.htmlTreeAsString)(source.node)));
        });
    }
}
function setResourceEntrySizeData(data, entry, key, dataKey) {
    var entryVal = entry[key];
    if (entryVal != null && entryVal < MAX_INT_AS_BYTES) data[dataKey] = entryVal;
}
/**
 * Add ttfb request time information to measurements.
 *
 * ttfb information is added via vendored web vitals library.
 */ function _addTtfbRequestTimeToMeasurements(_measurements) {
    var navEntry = (0, _getNavigationEntryJs.getNavigationEntry)();
    if (!navEntry) return;
    var responseStart = navEntry.responseStart, requestStart = navEntry.requestStart;
    if (requestStart <= responseStart) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log('[Measurements] Adding TTFB Request Time');
        _measurements['ttfb.requestTime'] = {
            value: responseStart - requestStart,
            unit: 'millisecond'
        };
    }
}
/** Taken from @sentry/core sampling.ts */ function getSampleRate(transactionContext, options, interactionsSampleRate) {
    if (!(0, _core.hasTracingEnabled)(options)) return false;
    var sampleRate;
    if (transactionContext !== undefined && typeof options.tracesSampler === 'function') sampleRate = options.tracesSampler({
        transactionContext: transactionContext,
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        attributes: (0, _objectSpread._)({}, transactionContext.data, transactionContext.attributes),
        location: (0, _typesJs.WINDOW).location
    });
    else if (transactionContext !== undefined && transactionContext.sampled !== undefined) sampleRate = transactionContext.sampled;
    else if (typeof options.tracesSampleRate !== 'undefined') sampleRate = options.tracesSampleRate;
    else sampleRate = 1;
    if (!(0, _core.isValidSampleRate)(sampleRate)) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn('[Tracing] Discarding interaction span because of invalid sample rate.');
        return false;
    }
    if (sampleRate === true) return interactionsSampleRate;
    else if (sampleRate === false) return 0;
    return sampleRate * interactionsSampleRate;
}

},{"@swc/helpers/_/_object_spread":"4bEWH","@sentry/core":"8bBGI","@sentry/utils":"gElXU","../../common/debug-build.js":"eGerB","../instrument.js":"2jXyu","../types.js":"dT4HR","../web-vitals/lib/getVisibilityWatcher.js":"ccy9E","./utils.js":"4QZKb","../web-vitals/lib/getNavigationEntry.js":"l6LK2","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4QZKb":[function(require,module,exports,__globalThis) {
/**
 * Checks if a given value is a valid measurement value.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_startChild", function() {
    return _startChild;
});
parcelHelpers.export(exports, "isMeasurementValue", function() {
    return isMeasurementValue;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
function isMeasurementValue(value) {
    return typeof value === 'number' && isFinite(value);
}
/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 *
 * Note: this will not be possible anymore in v8,
 * unless we do some special handling for browser here...
 */ function _startChild(transaction, _param) {
    var startTimestamp = _param.startTimestamp, ctx = (0, _objectWithoutProperties._)(_param, [
        "startTimestamp"
    ]);
    // eslint-disable-next-line deprecation/deprecation
    if (startTimestamp && transaction.startTimestamp > startTimestamp) // eslint-disable-next-line deprecation/deprecation
    transaction.startTimestamp = startTimestamp;
    // eslint-disable-next-line deprecation/deprecation
    return transaction.startChild((0, _objectSpread._)({
        startTimestamp: startTimestamp
    }, ctx));
}

},{"@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_object_without_properties":"1waVD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"eGI7D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_TRACE_PROPAGATION_TARGETS", function() {
    return DEFAULT_TRACE_PROPAGATION_TARGETS;
});
parcelHelpers.export(exports, "defaultRequestInstrumentationOptions", function() {
    return defaultRequestInstrumentationOptions;
});
parcelHelpers.export(exports, "extractNetworkProtocol", function() {
    return extractNetworkProtocol;
});
parcelHelpers.export(exports, "instrumentOutgoingRequests", function() {
    return instrumentOutgoingRequests;
});
parcelHelpers.export(exports, "shouldAttachHeaders", function() {
    return shouldAttachHeaders;
});
parcelHelpers.export(exports, "xhrCallback", function() {
    return xhrCallback;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
var _fetchJs = require("../common/fetch.js");
var _instrumentJs = require("./instrument.js");
var _typesJs = require("./types.js");
/* eslint-disable max-lines */ var DEFAULT_TRACE_PROPAGATION_TARGETS = [
    'localhost',
    /^\/(?!\/)/
];
/** Options for Request Instrumentation */ var defaultRequestInstrumentationOptions = {
    traceFetch: true,
    traceXHR: true,
    enableHTTPTimings: true,
    // TODO (v8): Remove this property
    tracingOrigins: DEFAULT_TRACE_PROPAGATION_TARGETS,
    tracePropagationTargets: DEFAULT_TRACE_PROPAGATION_TARGETS
};
/** Registers span creators for xhr and fetch requests  */ function instrumentOutgoingRequests(_options) {
    var _$_object_spread = (0, _objectSpread._)({
        traceFetch: defaultRequestInstrumentationOptions.traceFetch,
        traceXHR: defaultRequestInstrumentationOptions.traceXHR
    }, _options), traceFetch = _$_object_spread.traceFetch, traceXHR = _$_object_spread.traceXHR, // eslint-disable-next-line deprecation/deprecation
    tracePropagationTargets = _$_object_spread.tracePropagationTargets, // eslint-disable-next-line deprecation/deprecation
    tracingOrigins = _$_object_spread.tracingOrigins, shouldCreateSpanForRequest = _$_object_spread.shouldCreateSpanForRequest, enableHTTPTimings = _$_object_spread.enableHTTPTimings;
    var shouldCreateSpan = typeof shouldCreateSpanForRequest === 'function' ? shouldCreateSpanForRequest : function(_) {
        return true;
    };
    // TODO(v8) Remove tracingOrigins here
    // The only reason we're passing it in here is because this instrumentOutgoingRequests function is publicly exported
    // and we don't want to break the API. We can remove it in v8.
    var shouldAttachHeadersWithTargets = function(url) {
        return shouldAttachHeaders(url, tracePropagationTargets || tracingOrigins);
    };
    var spans = {};
    if (traceFetch) (0, _utils.addFetchInstrumentationHandler)(function(handlerData) {
        var createdSpan = (0, _fetchJs.instrumentFetchRequest)(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        // We cannot use `window.location` in the generic fetch instrumentation,
        // but we need it for reliable `server.address` attribute.
        // so we extend this in here
        if (createdSpan) {
            var fullUrl = getFullURL(handlerData.fetchData.url);
            var host = fullUrl ? (0, _utils.parseUrl)(fullUrl).host : undefined;
            createdSpan.setAttributes({
                'http.url': fullUrl,
                'server.address': host
            });
        }
        if (enableHTTPTimings && createdSpan) addHTTPTimings(createdSpan);
    });
    if (traceXHR) (0, _utils.addXhrInstrumentationHandler)(function(handlerData) {
        var createdSpan = xhrCallback(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        if (enableHTTPTimings && createdSpan) addHTTPTimings(createdSpan);
    });
}
function isPerformanceResourceTiming(entry) {
    return entry.entryType === 'resource' && 'initiatorType' in entry && typeof entry.nextHopProtocol === 'string' && (entry.initiatorType === 'fetch' || entry.initiatorType === 'xmlhttprequest');
}
/**
 * Creates a temporary observer to listen to the next fetch/xhr resourcing timings,
 * so that when timings hit their per-browser limit they don't need to be removed.
 *
 * @param span A span that has yet to be finished, must contain `url` on data.
 */ function addHTTPTimings(span) {
    var url = ((0, _core.spanToJSON)(span).data || {}).url;
    if (!url || typeof url !== 'string') return;
    var cleanup = (0, _instrumentJs.addPerformanceInstrumentationHandler)('resource', function(param) {
        var entries = param.entries;
        entries.forEach(function(entry) {
            if (isPerformanceResourceTiming(entry) && entry.name.endsWith(url)) {
                var _span;
                var spanData = resourceTimingEntryToSpanData(entry);
                spanData.forEach(function(data) {
                    return (_span = span).setAttribute.apply(_span, (0, _toConsumableArray._)(data));
                });
                // In the next tick, clean this handler up
                // We have to wait here because otherwise this cleans itself up before it is fully done
                setTimeout(cleanup);
            }
        });
    });
}
/**
 * Converts ALPN protocol ids to name and version.
 *
 * (https://www.iana.org/assignments/tls-extensiontype-values/tls-extensiontype-values.xhtml#alpn-protocol-ids)
 * @param nextHopProtocol PerformanceResourceTiming.nextHopProtocol
 */ function extractNetworkProtocol(nextHopProtocol) {
    var name = 'unknown';
    var version = 'unknown';
    var _name = '';
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = nextHopProtocol[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var char = _step.value;
            // http/1.1 etc.
            if (char === '/') {
                var ref;
                ref = (0, _slicedToArray._)(nextHopProtocol.split('/'), 2), name = ref[0], version = ref[1], ref;
                break;
            }
            // h2, h3 etc.
            if (!isNaN(Number(char))) {
                name = _name === 'h' ? 'http' : _name;
                version = nextHopProtocol.split(_name)[1];
                break;
            }
            _name += char;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (_name === nextHopProtocol) // webrtc, ftp, etc.
    name = _name;
    return {
        name: name,
        version: version
    };
}
function getAbsoluteTime() {
    var time = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return (((0, _utils.browserPerformanceTimeOrigin) || performance.timeOrigin) + time) / 1000;
}
function resourceTimingEntryToSpanData(resourceTiming) {
    var _extractNetworkProtocol = extractNetworkProtocol(resourceTiming.nextHopProtocol), name = _extractNetworkProtocol.name, version = _extractNetworkProtocol.version;
    var timingSpanData = [];
    timingSpanData.push([
        'network.protocol.version',
        version
    ], [
        'network.protocol.name',
        name
    ]);
    if (!(0, _utils.browserPerformanceTimeOrigin)) return timingSpanData;
    return (0, _toConsumableArray._)(timingSpanData).concat([
        [
            'http.request.redirect_start',
            getAbsoluteTime(resourceTiming.redirectStart)
        ],
        [
            'http.request.fetch_start',
            getAbsoluteTime(resourceTiming.fetchStart)
        ],
        [
            'http.request.domain_lookup_start',
            getAbsoluteTime(resourceTiming.domainLookupStart)
        ],
        [
            'http.request.domain_lookup_end',
            getAbsoluteTime(resourceTiming.domainLookupEnd)
        ],
        [
            'http.request.connect_start',
            getAbsoluteTime(resourceTiming.connectStart)
        ],
        [
            'http.request.secure_connection_start',
            getAbsoluteTime(resourceTiming.secureConnectionStart)
        ],
        [
            'http.request.connection_end',
            getAbsoluteTime(resourceTiming.connectEnd)
        ],
        [
            'http.request.request_start',
            getAbsoluteTime(resourceTiming.requestStart)
        ],
        [
            'http.request.response_start',
            getAbsoluteTime(resourceTiming.responseStart)
        ],
        [
            'http.request.response_end',
            getAbsoluteTime(resourceTiming.responseEnd)
        ]
    ]);
}
/**
 * A function that determines whether to attach tracing headers to a request.
 * This was extracted from `instrumentOutgoingRequests` to make it easier to test shouldAttachHeaders.
 * We only export this fuction for testing purposes.
 */ function shouldAttachHeaders(url, tracePropagationTargets) {
    return (0, _utils.stringMatchesSomePattern)(url, tracePropagationTargets || DEFAULT_TRACE_PROPAGATION_TARGETS);
}
/**
 * Create and track xhr request spans
 *
 * @returns Span if a span was created, otherwise void.
 */ // eslint-disable-next-line complexity
function xhrCallback(handlerData, shouldCreateSpan, shouldAttachHeaders, spans) {
    var xhr = handlerData.xhr;
    var sentryXhrData = xhr && xhr[0, _utils.SENTRY_XHR_DATA_KEY];
    if (!(0, _core.hasTracingEnabled)() || !xhr || xhr.__sentry_own_request__ || !sentryXhrData) return undefined;
    var shouldCreateSpanResult = shouldCreateSpan(sentryXhrData.url);
    // check first if the request has finished and is tracked by an existing span which should now end
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        var spanId = xhr.__sentry_xhr_span_id__;
        if (!spanId) return;
        var span = spans[spanId];
        if (span && sentryXhrData.status_code !== undefined) {
            (0, _core.setHttpStatus)(span, sentryXhrData.status_code);
            span.end();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    var scope = (0, _core.getCurrentScope)();
    var isolationScope = (0, _core.getIsolationScope)();
    var fullUrl = getFullURL(sentryXhrData.url);
    var host = fullUrl ? (0, _utils.parseUrl)(fullUrl).host : undefined;
    var span1 = shouldCreateSpanResult ? (0, _core.startInactiveSpan)({
        name: `${sentryXhrData.method} ${sentryXhrData.url}`,
        onlyIfParent: true,
        attributes: (0, _defineProperty._)({
            type: 'xhr',
            'http.method': sentryXhrData.method,
            'http.url': fullUrl,
            url: sentryXhrData.url,
            'server.address': host
        }, (0, _core.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), 'auto.http.browser'),
        op: 'http.client'
    }) : undefined;
    if (span1) {
        xhr.__sentry_xhr_span_id__ = span1.spanContext().spanId;
        spans[xhr.__sentry_xhr_span_id__] = span1;
    }
    var client = (0, _core.getClient)();
    if (xhr.setRequestHeader && shouldAttachHeaders(sentryXhrData.url) && client) {
        var _$_object_spread = (0, _objectSpread._)({}, isolationScope.getPropagationContext(), scope.getPropagationContext()), traceId = _$_object_spread.traceId, spanId1 = _$_object_spread.spanId, sampled = _$_object_spread.sampled, dsc = _$_object_spread.dsc;
        var sentryTraceHeader = span1 ? (0, _core.spanToTraceHeader)(span1) : (0, _utils.generateSentryTraceHeader)(traceId, spanId1, sampled);
        var sentryBaggageHeader = (0, _utils.dynamicSamplingContextToSentryBaggageHeader)(dsc || (span1 ? (0, _core.getDynamicSamplingContextFromSpan)(span1) : (0, _core.getDynamicSamplingContextFromClient)(traceId, client, scope)));
        setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader);
    }
    return span1;
}
function setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader('sentry-trace', sentryTraceHeader);
        if (sentryBaggageHeader) // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
        // We can therefore simply set a baggage header without checking what was there before
        // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader((0, _utils.BAGGAGE_HEADER_NAME), sentryBaggageHeader);
    } catch (_) {
    // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
    }
}
function getFullURL(url) {
    try {
        // By adding a base URL to new URL(), this will also work for relative urls
        // If `url` is a full URL, the base URL is ignored anyhow
        var parsed = new URL(url, (0, _typesJs.WINDOW).location.origin);
        return parsed.href;
    } catch (e) {
        return undefined;
    }
}

},{"@swc/helpers/_/_define_property":"54Zvk","@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_sliced_to_array":"ha6sq","@swc/helpers/_/_to_consumable_array":"eqNDD","@sentry/core":"8bBGI","@sentry/utils":"gElXU","../common/fetch.js":"jfjgO","./instrument.js":"2jXyu","./types.js":"dT4HR","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jfjgO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addTracingHeadersToFetchRequest", function() {
    return addTracingHeadersToFetchRequest;
});
parcelHelpers.export(exports, "instrumentFetchRequest", function() {
    return instrumentFetchRequest;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
/**
 * Create and track fetch request spans for usage in combination with `addInstrumentationHandler`.
 *
 * @returns Span if a span was created, otherwise void.
 */ function instrumentFetchRequest(handlerData, shouldCreateSpan, shouldAttachHeaders, spans) {
    var spanOrigin = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 'auto.http.browser';
    if (!(0, _core.hasTracingEnabled)() || !handlerData.fetchData) return undefined;
    var shouldCreateSpanResult = shouldCreateSpan(handlerData.fetchData.url);
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        var spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        var span = spans[spanId];
        if (span) {
            endSpan(span, handlerData);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    var scope = (0, _core.getCurrentScope)();
    var client = (0, _core.getClient)();
    var _handlerData_fetchData = handlerData.fetchData, method = _handlerData_fetchData.method, url = _handlerData_fetchData.url;
    var fullUrl = getFullURL(url);
    var host = fullUrl ? (0, _utils.parseUrl)(fullUrl).host : undefined;
    var span1 = shouldCreateSpanResult ? (0, _core.startInactiveSpan)({
        name: `${method} ${url}`,
        onlyIfParent: true,
        attributes: (0, _defineProperty._)({
            url: url,
            type: 'fetch',
            'http.method': method,
            'http.url': fullUrl,
            'server.address': host
        }, (0, _core.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN), spanOrigin),
        op: 'http.client'
    }) : undefined;
    if (span1) {
        handlerData.fetchData.__span = span1.spanContext().spanId;
        spans[span1.spanContext().spanId] = span1;
    }
    if (shouldAttachHeaders(handlerData.fetchData.url) && client) {
        var request = handlerData.args[0];
        // In case the user hasn't set the second argument of a fetch call we default it to `{}`.
        handlerData.args[1] = handlerData.args[1] || {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var options = handlerData.args[1];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
        options.headers = addTracingHeadersToFetchRequest(request, client, scope, options, span1);
    }
    return span1;
}
/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers
 */ function addTracingHeadersToFetchRequest(request, client, scope, options, requestSpan) {
    // eslint-disable-next-line deprecation/deprecation
    var span = requestSpan || scope.getSpan();
    var isolationScope = (0, _core.getIsolationScope)();
    var _$_object_spread = (0, _objectSpread._)({}, isolationScope.getPropagationContext(), scope.getPropagationContext()), traceId = _$_object_spread.traceId, spanId = _$_object_spread.spanId, sampled = _$_object_spread.sampled, dsc = _$_object_spread.dsc;
    var sentryTraceHeader = span ? (0, _core.spanToTraceHeader)(span) : (0, _utils.generateSentryTraceHeader)(traceId, spanId, sampled);
    var sentryBaggageHeader = (0, _utils.dynamicSamplingContextToSentryBaggageHeader)(dsc || (span ? (0, _core.getDynamicSamplingContextFromSpan)(span) : (0, _core.getDynamicSamplingContextFromClient)(traceId, client, scope)));
    var headers = options.headers || (typeof Request !== 'undefined' && (0, _utils.isInstanceOf)(request, Request) ? request.headers : undefined);
    if (!headers) return {
        'sentry-trace': sentryTraceHeader,
        baggage: sentryBaggageHeader
    };
    else if (typeof Headers !== 'undefined' && (0, _utils.isInstanceOf)(headers, Headers)) {
        var newHeaders = new Headers(headers);
        newHeaders.append('sentry-trace', sentryTraceHeader);
        if (sentryBaggageHeader) // If the same header is appended multiple times the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.append((0, _utils.BAGGAGE_HEADER_NAME), sentryBaggageHeader);
        return newHeaders;
    } else if (Array.isArray(headers)) {
        var newHeaders1 = (0, _toConsumableArray._)(headers).concat([
            [
                'sentry-trace',
                sentryTraceHeader
            ]
        ]);
        if (sentryBaggageHeader) // If there are multiple entries with the same key, the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders1.push([
            (0, _utils.BAGGAGE_HEADER_NAME),
            sentryBaggageHeader
        ]);
        return newHeaders1;
    } else {
        var _newBaggageHeaders;
        var existingBaggageHeader = 'baggage' in headers ? headers.baggage : undefined;
        var newBaggageHeaders = [];
        if (Array.isArray(existingBaggageHeader)) (_newBaggageHeaders = newBaggageHeaders).push.apply(_newBaggageHeaders, (0, _toConsumableArray._)(existingBaggageHeader));
        else if (existingBaggageHeader) newBaggageHeaders.push(existingBaggageHeader);
        if (sentryBaggageHeader) newBaggageHeaders.push(sentryBaggageHeader);
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, headers), {
            'sentry-trace': sentryTraceHeader,
            baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(',') : undefined
        });
    }
}
function getFullURL(url) {
    try {
        var parsed = new URL(url);
        return parsed.href;
    } catch (e) {
        return undefined;
    }
}
function endSpan(span, handlerData) {
    if (handlerData.response) {
        (0, _core.setHttpStatus)(span, handlerData.response.status);
        var contentLength = handlerData.response && handlerData.response.headers && handlerData.response.headers.get('content-length');
        if (contentLength) {
            var contentLengthNum = parseInt(contentLength);
            if (contentLengthNum > 0) span.setAttribute('http.response_content_length', contentLengthNum);
        }
    } else if (handlerData.error) span.setStatus('internal_error');
    span.end();
}

},{"@swc/helpers/_/_define_property":"54Zvk","@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_object_spread_props":"fLCYP","@swc/helpers/_/_to_consumable_array":"eqNDD","@sentry/core":"8bBGI","@sentry/utils":"gElXU","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2AA3Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "instrumentRoutingWithDefaults", function() {
    return instrumentRoutingWithDefaults;
});
var _utils = require("@sentry/utils");
var _debugBuildJs = require("../common/debug-build.js");
var _typesJs = require("./types.js");
/**
 * Default function implementing pageload and navigation transactions
 */ function instrumentRoutingWithDefaults(customStartTransaction) {
    var startTransactionOnPageLoad = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, startTransactionOnLocationChange = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    if (!(0, _typesJs.WINDOW) || !(0, _typesJs.WINDOW).location) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn('Could not initialize routing instrumentation due to invalid location');
        return;
    }
    var startingUrl = (0, _typesJs.WINDOW).location.href;
    var activeTransaction;
    if (startTransactionOnPageLoad) activeTransaction = customStartTransaction({
        name: (0, _typesJs.WINDOW).location.pathname,
        // pageload should always start at timeOrigin (and needs to be in s, not ms)
        startTimestamp: (0, _utils.browserPerformanceTimeOrigin) ? (0, _utils.browserPerformanceTimeOrigin) / 1000 : undefined,
        op: 'pageload',
        origin: 'auto.pageload.browser',
        metadata: {
            source: 'url'
        }
    });
    if (startTransactionOnLocationChange) (0, _utils.addHistoryInstrumentationHandler)(function(param) {
        var to = param.to, from = param.from;
        /**
       * This early return is there to account for some cases where a navigation transaction starts right after
       * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
       * create an uneccessary navigation transaction.
       *
       * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
       * only be caused in certain development environments where the usage of a hot module reloader is causing
       * errors.
       */ if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
            startingUrl = undefined;
            return;
        }
        if (from !== to) {
            startingUrl = undefined;
            if (activeTransaction) {
                (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log(`[Tracing] Finishing current transaction with op: ${activeTransaction.op}`);
                // If there's an open transaction on the scope, we need to finish it before creating an new one.
                activeTransaction.end();
            }
            activeTransaction = customStartTransaction({
                name: (0, _typesJs.WINDOW).location.pathname,
                op: 'navigation',
                origin: 'auto.navigation.browser',
                metadata: {
                    source: 'url'
                }
            });
        }
    });
}

},{"@sentry/utils":"gElXU","../common/debug-build.js":"eGerB","./types.js":"dT4HR","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"h9TQL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BROWSER_TRACING_INTEGRATION_ID", function() {
    return BROWSER_TRACING_INTEGRATION_ID;
});
parcelHelpers.export(exports, "browserTracingIntegration", function() {
    return browserTracingIntegration;
});
parcelHelpers.export(exports, "getMetaContent", function() {
    return getMetaContent;
});
parcelHelpers.export(exports, "startBrowserTracingNavigationSpan", function() {
    return startBrowserTracingNavigationSpan;
});
parcelHelpers.export(exports, "startBrowserTracingPageLoadSpan", function() {
    return startBrowserTracingPageLoadSpan;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
var _debugBuildJs = require("../common/debug-build.js");
var _backgroundtabJs = require("./backgroundtab.js");
var _instrumentJs = require("./instrument.js");
var _indexJs = require("./metrics/index.js");
var _requestJs = require("./request.js");
var _typesJs = require("./types.js");
var BROWSER_TRACING_INTEGRATION_ID = 'BrowserTracing';
/** Options for Browser Tracing integration */ var DEFAULT_BROWSER_TRACING_OPTIONS = (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _core.TRACING_DEFAULTS)), {
    instrumentNavigation: true,
    instrumentPageLoad: true,
    markBackgroundSpan: true,
    enableLongTask: true,
    enableInp: false,
    interactionsSampleRate: 1,
    _experiments: {}
}), (0, _requestJs.defaultRequestInstrumentationOptions));
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 *
 * We explicitly export the proper type here, as this has to be extended in some cases.
 */ var browserTracingIntegration = function() {
    var _options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _hasSetTracePropagationTargets = (0, _debugBuildJs.DEBUG_BUILD) ? !!// eslint-disable-next-line deprecation/deprecation
    (_options.tracePropagationTargets || _options.tracingOrigins) : false;
    (0, _core.addTracingExtensions)();
    // TODO (v8): remove this block after tracingOrigins is removed
    // Set tracePropagationTargets to tracingOrigins if specified by the user
    // In case both are specified, tracePropagationTargets takes precedence
    // eslint-disable-next-line deprecation/deprecation
    if (!_options.tracePropagationTargets && _options.tracingOrigins) // eslint-disable-next-line deprecation/deprecation
    _options.tracePropagationTargets = _options.tracingOrigins;
    var options = (0, _objectSpread._)({}, DEFAULT_BROWSER_TRACING_OPTIONS, _options);
    var _collectWebVitals = (0, _indexJs.startTrackingWebVitals)();
    /** Stores a mapping of interactionIds from PerformanceEventTimings to the origin interaction path */ var interactionIdToRouteNameMapping = {};
    if (options.enableInp) (0, _indexJs.startTrackingINP)(interactionIdToRouteNameMapping, options.interactionsSampleRate);
    if (options.enableLongTask) (0, _indexJs.startTrackingLongTasks)();
    if (options._experiments.enableInteractions) (0, _indexJs.startTrackingInteractions)();
    var latestRoute = {
        name: undefined,
        context: undefined
    };
    /** Create routing idle transaction. */ function _createRouteTransaction(context) {
        // eslint-disable-next-line deprecation/deprecation
        var hub = (0, _core.getCurrentHub)();
        var beforeStartSpan = options.beforeStartSpan, idleTimeout = options.idleTimeout, finalTimeout = options.finalTimeout, heartbeatInterval = options.heartbeatInterval;
        var isPageloadTransaction = context.op === 'pageload';
        var expandedContext;
        if (isPageloadTransaction) {
            var sentryTrace = isPageloadTransaction ? getMetaContent('sentry-trace') : '';
            var baggage = isPageloadTransaction ? getMetaContent('baggage') : undefined;
            var _propagationContextFromHeaders = (0, _utils.propagationContextFromHeaders)(sentryTrace, baggage), traceId = _propagationContextFromHeaders.traceId, dsc = _propagationContextFromHeaders.dsc, parentSpanId = _propagationContextFromHeaders.parentSpanId, sampled = _propagationContextFromHeaders.sampled;
            expandedContext = (0, _objectSpreadProps._)((0, _objectSpread._)({
                traceId: traceId,
                parentSpanId: parentSpanId,
                parentSampled: sampled
            }, context), {
                metadata: (0, _objectSpreadProps._)((0, _objectSpread._)({}, context.metadata), {
                    dynamicSamplingContext: dsc
                }),
                trimEnd: true
            });
        } else expandedContext = (0, _objectSpread._)({
            trimEnd: true
        }, context);
        var finalContext = beforeStartSpan ? beforeStartSpan(expandedContext) : expandedContext;
        // If `beforeStartSpan` set a custom name, record that fact
        // eslint-disable-next-line deprecation/deprecation
        finalContext.metadata = finalContext.name !== expandedContext.name ? (0, _objectSpreadProps._)((0, _objectSpread._)({}, finalContext.metadata), {
            source: 'custom'
        }) : finalContext.metadata;
        latestRoute.name = finalContext.name;
        latestRoute.context = finalContext;
        if (finalContext.sampled === false) (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log(`[Tracing] Will not send ${finalContext.op} transaction because of beforeNavigate.`);
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log(`[Tracing] Starting ${finalContext.op} transaction on scope`);
        var location = (0, _typesJs.WINDOW).location;
        var idleTransaction = (0, _core.startIdleTransaction)(hub, finalContext, idleTimeout, finalTimeout, true, {
            location: location
        }, heartbeatInterval, isPageloadTransaction);
        if (isPageloadTransaction && (0, _typesJs.WINDOW).document) {
            (0, _typesJs.WINDOW).document.addEventListener('readystatechange', function() {
                if ([
                    'interactive',
                    'complete'
                ].includes((0, _typesJs.WINDOW).document.readyState)) idleTransaction.sendAutoFinishSignal();
            });
            if ([
                'interactive',
                'complete'
            ].includes((0, _typesJs.WINDOW).document.readyState)) idleTransaction.sendAutoFinishSignal();
        }
        idleTransaction.registerBeforeFinishCallback(function(transaction) {
            _collectWebVitals();
            (0, _indexJs.addPerformanceEntries)(transaction);
        });
        return idleTransaction;
    }
    return {
        name: BROWSER_TRACING_INTEGRATION_ID,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        setupOnce: function() {},
        afterAllSetup: function(client) {
            var clientOptions = client.getOptions();
            var markBackgroundSpan = options.markBackgroundSpan, traceFetch = options.traceFetch, traceXHR = options.traceXHR, shouldCreateSpanForRequest = options.shouldCreateSpanForRequest, enableHTTPTimings = options.enableHTTPTimings, _experiments = options._experiments;
            var clientOptionsTracePropagationTargets = clientOptions && clientOptions.tracePropagationTargets;
            // There are three ways to configure tracePropagationTargets:
            // 1. via top level client option `tracePropagationTargets`
            // 2. via BrowserTracing option `tracePropagationTargets`
            // 3. via BrowserTracing option `tracingOrigins` (deprecated)
            //
            // To avoid confusion, favour top level client option `tracePropagationTargets`, and fallback to
            // BrowserTracing option `tracePropagationTargets` and then `tracingOrigins` (deprecated).
            // This is done as it minimizes bundle size (we don't have to have undefined checks).
            //
            // If both 1 and either one of 2 or 3 are set (from above), we log out a warning.
            // eslint-disable-next-line deprecation/deprecation
            var tracePropagationTargets = clientOptionsTracePropagationTargets || options.tracePropagationTargets;
            if ((0, _debugBuildJs.DEBUG_BUILD) && _hasSetTracePropagationTargets && clientOptionsTracePropagationTargets) (0, _utils.logger).warn('[Tracing] The `tracePropagationTargets` option was set in the BrowserTracing integration and top level `Sentry.init`. The top level `Sentry.init` value is being used.');
            var activeSpan;
            var startingUrl = (0, _typesJs.WINDOW).location && (0, _typesJs.WINDOW).location.href;
            if (client.on) {
                client.on('startNavigationSpan', function(context) {
                    if (activeSpan) {
                        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log(`[Tracing] Finishing current transaction with op: ${(0, _core.spanToJSON)(activeSpan).op}`);
                        // If there's an open transaction on the scope, we need to finish it before creating an new one.
                        activeSpan.end();
                    }
                    activeSpan = _createRouteTransaction((0, _objectSpread._)({
                        op: 'navigation'
                    }, context));
                });
                client.on('startPageLoadSpan', function(context) {
                    if (activeSpan) {
                        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log(`[Tracing] Finishing current transaction with op: ${(0, _core.spanToJSON)(activeSpan).op}`);
                        // If there's an open transaction on the scope, we need to finish it before creating an new one.
                        activeSpan.end();
                    }
                    activeSpan = _createRouteTransaction((0, _objectSpread._)({
                        op: 'pageload'
                    }, context));
                });
            }
            if (options.instrumentPageLoad && client.emit && (0, _typesJs.WINDOW).location) {
                var context = {
                    name: (0, _typesJs.WINDOW).location.pathname,
                    // pageload should always start at timeOrigin (and needs to be in s, not ms)
                    startTimestamp: (0, _utils.browserPerformanceTimeOrigin) ? (0, _utils.browserPerformanceTimeOrigin) / 1000 : undefined,
                    origin: 'auto.pageload.browser',
                    attributes: (0, _defineProperty._)({}, (0, _core.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), 'url')
                };
                startBrowserTracingPageLoadSpan(client, context);
            }
            if (options.instrumentNavigation && client.emit && (0, _typesJs.WINDOW).location) (0, _utils.addHistoryInstrumentationHandler)(function(param) {
                var to = param.to, from = param.from;
                /**
           * This early return is there to account for some cases where a navigation transaction starts right after
           * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
           * create an uneccessary navigation transaction.
           *
           * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
           * only be caused in certain development environments where the usage of a hot module reloader is causing
           * errors.
           */ if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
                    startingUrl = undefined;
                    return;
                }
                if (from !== to) {
                    startingUrl = undefined;
                    var context = {
                        name: (0, _typesJs.WINDOW).location.pathname,
                        origin: 'auto.navigation.browser',
                        attributes: (0, _defineProperty._)({}, (0, _core.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), 'url')
                    };
                    startBrowserTracingNavigationSpan(client, context);
                }
            });
            if (markBackgroundSpan) (0, _backgroundtabJs.registerBackgroundTabDetection)();
            if (_experiments.enableInteractions) registerInteractionListener(options, latestRoute);
            if (options.enableInp) registerInpInteractionListener(interactionIdToRouteNameMapping, latestRoute);
            (0, _requestJs.instrumentOutgoingRequests)({
                traceFetch: traceFetch,
                traceXHR: traceXHR,
                tracePropagationTargets: tracePropagationTargets,
                shouldCreateSpanForRequest: shouldCreateSpanForRequest,
                enableHTTPTimings: enableHTTPTimings
            });
        },
        // TODO v8: Remove this again
        // This is private API that we use to fix converted BrowserTracing integrations in Next.js & SvelteKit
        options: options
    };
};
/**
 * Manually start a page load span.
 * This will only do something if the BrowserTracing integration has been setup.
 */ function startBrowserTracingPageLoadSpan(client, spanOptions) {
    if (!client.emit) return;
    client.emit('startPageLoadSpan', spanOptions);
    var span = (0, _core.getActiveSpan)();
    var op = span && (0, _core.spanToJSON)(span).op;
    return op === 'pageload' ? span : undefined;
}
/**
 * Manually start a navigation span.
 * This will only do something if the BrowserTracing integration has been setup.
 */ function startBrowserTracingNavigationSpan(client, spanOptions) {
    if (!client.emit) return;
    client.emit('startNavigationSpan', spanOptions);
    var span = (0, _core.getActiveSpan)();
    var op = span && (0, _core.spanToJSON)(span).op;
    return op === 'navigation' ? span : undefined;
}
/** Returns the value of a meta tag */ function getMetaContent(metaName) {
    // Can't specify generic to `getDomElement` because tracing can be used
    // in a variety of environments, have to disable `no-unsafe-member-access`
    // as a result.
    var metaTag = (0, _utils.getDomElement)(`meta[name=${metaName}]`);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return metaTag ? metaTag.getAttribute('content') : undefined;
}
/** Start listener for interaction transactions */ function registerInteractionListener(options, latestRoute) {
    var inflightInteractionTransaction;
    var registerInteractionTransaction = function() {
        var idleTimeout = options.idleTimeout, finalTimeout = options.finalTimeout, heartbeatInterval = options.heartbeatInterval;
        var op = 'ui.action.click';
        // eslint-disable-next-line deprecation/deprecation
        var currentTransaction = (0, _core.getActiveTransaction)();
        if (currentTransaction && currentTransaction.op && [
            'navigation',
            'pageload'
        ].includes(currentTransaction.op)) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn(`[Tracing] Did not create ${op} transaction because a pageload or navigation transaction is in progress.`);
            return undefined;
        }
        if (inflightInteractionTransaction) {
            inflightInteractionTransaction.setFinishReason('interactionInterrupted');
            inflightInteractionTransaction.end();
            inflightInteractionTransaction = undefined;
        }
        if (!latestRoute.name) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
            return undefined;
        }
        var location = (0, _typesJs.WINDOW).location;
        var context = {
            name: latestRoute.name,
            op: op,
            trimEnd: true,
            data: (0, _defineProperty._)({}, (0, _core.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE), latestRoute.context ? getSource(latestRoute.context) : 'url')
        };
        inflightInteractionTransaction = (0, _core.startIdleTransaction)(// eslint-disable-next-line deprecation/deprecation
        (0, _core.getCurrentHub)(), context, idleTimeout, finalTimeout, true, {
            location: location
        }, heartbeatInterval);
    };
    [
        'click'
    ].forEach(function(type) {
        if ((0, _typesJs.WINDOW).document) addEventListener(type, registerInteractionTransaction, {
            once: false,
            capture: true
        });
    });
}
function isPerformanceEventTiming(entry) {
    return 'duration' in entry;
}
/** We store up to 10 interaction candidates max to cap memory usage. This is the same cap as getINP from web-vitals */ var MAX_INTERACTIONS = 10;
/** Creates a listener on interaction entries, and maps interactionIds to the origin path of the interaction */ function registerInpInteractionListener(interactionIdToRouteNameMapping, latestRoute) {
    var handleEntries = function(param) {
        var entries = param.entries;
        var client = (0, _core.getClient)();
        // We need to get the replay, user, and activeTransaction from the current scope
        // so that we can associate replay id, profile id, and a user display to the span
        var replay = client !== undefined && client.getIntegrationByName !== undefined ? client.getIntegrationByName('Replay') : undefined;
        var replayId = replay !== undefined ? replay.getReplayId() : undefined;
        // eslint-disable-next-line deprecation/deprecation
        var activeTransaction = (0, _core.getActiveTransaction)();
        var currentScope = (0, _core.getCurrentScope)();
        var user = currentScope !== undefined ? currentScope.getUser() : undefined;
        entries.forEach(function(entry) {
            if (isPerformanceEventTiming(entry)) {
                var interactionId = entry.interactionId;
                if (interactionId === undefined) return;
                var existingInteraction = interactionIdToRouteNameMapping[interactionId];
                var duration = entry.duration;
                var startTime = entry.startTime;
                var keys = Object.keys(interactionIdToRouteNameMapping);
                var minInteractionId = keys.length > 0 ? keys.reduce(function(a, b) {
                    return interactionIdToRouteNameMapping[a].duration < interactionIdToRouteNameMapping[b].duration ? a : b;
                }) : undefined;
                // For a first input event to be considered, we must check that an interaction event does not already exist with the same duration and start time.
                // This is also checked in the web-vitals library.
                if (entry.entryType === 'first-input') {
                    var matchingEntry = keys.map(function(key) {
                        return interactionIdToRouteNameMapping[key];
                    }).some(function(interaction) {
                        return interaction.duration === duration && interaction.startTime === startTime;
                    });
                    if (matchingEntry) return;
                }
                // Interactions with an id of 0 and are not first-input are not valid.
                if (!interactionId) return;
                // If the interaction already exists, we want to use the duration of the longest entry, since that is what the INP metric uses.
                if (existingInteraction) existingInteraction.duration = Math.max(existingInteraction.duration, duration);
                else if (keys.length < MAX_INTERACTIONS || minInteractionId === undefined || duration > interactionIdToRouteNameMapping[minInteractionId].duration) {
                    // If the interaction does not exist, we want to add it to the mapping if there is space, or if the duration is longer than the shortest entry.
                    var routeName = latestRoute.name;
                    var parentContext = latestRoute.context;
                    if (routeName && parentContext) {
                        if (minInteractionId && Object.keys(interactionIdToRouteNameMapping).length >= MAX_INTERACTIONS) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                        delete interactionIdToRouteNameMapping[minInteractionId];
                        interactionIdToRouteNameMapping[interactionId] = {
                            routeName: routeName,
                            duration: duration,
                            parentContext: parentContext,
                            user: user,
                            activeTransaction: activeTransaction,
                            replayId: replayId,
                            startTime: startTime
                        };
                    }
                }
            }
        });
    };
    (0, _instrumentJs.addPerformanceInstrumentationHandler)('event', handleEntries);
    (0, _instrumentJs.addPerformanceInstrumentationHandler)('first-input', handleEntries);
}
function getSource(context) {
    var sourceFromAttributes = context.attributes && context.attributes[0, _core.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    // eslint-disable-next-line deprecation/deprecation
    var sourceFromData = context.data && context.data[0, _core.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
    // eslint-disable-next-line deprecation/deprecation
    var sourceFromMetadata = context.metadata && context.metadata.source;
    return sourceFromAttributes || sourceFromData || sourceFromMetadata;
}

},{"@swc/helpers/_/_define_property":"54Zvk","@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_object_spread_props":"fLCYP","@sentry/core":"8bBGI","@sentry/utils":"gElXU","../common/debug-build.js":"eGerB","./backgroundtab.js":"1rWmz","./instrument.js":"2jXyu","./metrics/index.js":"iTapn","./request.js":"eGI7D","./types.js":"dT4HR","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"904il":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addExtensionMethods", function() {
    return addExtensionMethods;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
/**
 * @private
 */ function _autoloadDatabaseIntegrations() {
    var carrier = (0, _core.getMainCarrier)();
    if (!carrier.__SENTRY__) return;
    var packageToIntegrationMapping = {
        mongodb: function() {
            var integration = (0, _utils.dynamicRequire)(module, './node/integrations/mongo');
            return new integration.Mongo();
        },
        mongoose: function() {
            var integration = (0, _utils.dynamicRequire)(module, './node/integrations/mongo');
            return new integration.Mongo();
        },
        mysql: function() {
            var integration = (0, _utils.dynamicRequire)(module, './node/integrations/mysql');
            return new integration.Mysql();
        },
        pg: function() {
            var integration = (0, _utils.dynamicRequire)(module, './node/integrations/postgres');
            return new integration.Postgres();
        }
    };
    var mappedPackages = Object.keys(packageToIntegrationMapping).filter(function(moduleName) {
        return !!(0, _utils.loadModule)(moduleName);
    }).map(function(pkg) {
        try {
            return packageToIntegrationMapping[pkg]();
        } catch (e) {
            return undefined;
        }
    }).filter(function(p) {
        return p;
    });
    if (mappedPackages.length > 0) carrier.__SENTRY__.integrations = (0, _toConsumableArray._)(carrier.__SENTRY__.integrations || []).concat((0, _toConsumableArray._)(mappedPackages));
}
/**
 * This patches the global object and injects the Tracing extensions methods
 */ function addExtensionMethods() {
    (0, _core.addTracingExtensions)();
    // Detect and automatically load specified integrations.
    if ((0, _utils.isNodeEnv)()) _autoloadDatabaseIntegrations();
}

},{"@swc/helpers/_/_to_consumable_array":"eqNDD","@sentry/core":"8bBGI","@sentry/utils":"gElXU","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5cJ51":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BrowserClient", function() {
    return BrowserClient;
});
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _get = require("@swc/helpers/_/_get");
var _getPrototypeOf = require("@swc/helpers/_/_get_prototype_of");
var _inherits = require("@swc/helpers/_/_inherits");
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
var _debugBuildJs = require("./debug-build.js");
var _eventbuilderJs = require("./eventbuilder.js");
var _helpersJs = require("./helpers.js");
var _userfeedbackJs = require("./userfeedback.js");
/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/types Options for more information.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ var BrowserClient = /*#__PURE__*/ function(BaseClient) {
    "use strict";
    (0, _inherits._)(BrowserClient, BaseClient);
    function BrowserClient(options) {
        (0, _classCallCheck._)(this, BrowserClient);
        var _this;
        var sdkSource = (0, _helpersJs.WINDOW).SENTRY_SDK_SOURCE || (0, _utils.getSDKSource)();
        (0, _core.applySdkMetadata)(options, 'browser', [
            'browser'
        ], sdkSource);
        _this = (0, _callSuper._)(this, BrowserClient, [
            options
        ]);
        if (options.sendClientReports && (0, _helpersJs.WINDOW).document) (0, _helpersJs.WINDOW).document.addEventListener('visibilitychange', function() {
            if ((0, _helpersJs.WINDOW).document.visibilityState === 'hidden') _this._flushOutcomes();
        });
        return _this;
    }
    (0, _createClass._)(BrowserClient, [
        {
            /**
   * @inheritDoc
   */ key: "eventFromException",
            value: function eventFromException(exception, hint) {
                return (0, _eventbuilderJs.eventFromException)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "eventFromMessage",
            value: function eventFromMessage(message) {
                var // eslint-disable-next-line deprecation/deprecation
                level = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'info', hint = arguments.length > 2 ? arguments[2] : void 0;
                return (0, _eventbuilderJs.eventFromMessage)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
            }
        },
        {
            /**
   * Sends user feedback to Sentry.
   */ key: "captureUserFeedback",
            value: function captureUserFeedback(feedback) {
                if (!this._isEnabled()) {
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn('SDK not enabled, will not capture user feedback.');
                    return;
                }
                var envelope = (0, _userfeedbackJs.createUserFeedbackEnvelope)(feedback, {
                    metadata: this.getSdkMetadata(),
                    dsn: this.getDsn(),
                    tunnel: this.getOptions().tunnel
                });
                // _sendEnvelope should not throw
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this._sendEnvelope(envelope);
            }
        },
        {
            /**
   * @inheritDoc
   */ key: "_prepareEvent",
            value: function _prepareEvent(event, hint, scope) {
                event.platform = event.platform || 'javascript';
                return (0, _get._)((0, _getPrototypeOf._)(BrowserClient.prototype), "_prepareEvent", this).call(this, event, hint, scope);
            }
        },
        {
            /**
   * Sends client reports as an envelope.
   */ key: "_flushOutcomes",
            value: function _flushOutcomes() {
                var outcomes = this._clearOutcomes();
                if (outcomes.length === 0) {
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log('No outcomes to send');
                    return;
                }
                // This is really the only place where we want to check for a DSN and only send outcomes then
                if (!this._dsn) {
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log('No dsn provided, will not send outcomes');
                    return;
                }
                (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log('Sending outcomes:', outcomes);
                var envelope = (0, _utils.createClientReportEnvelope)(outcomes, this._options.tunnel && (0, _utils.dsnToString)(this._dsn));
                // _sendEnvelope should not throw
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this._sendEnvelope(envelope);
            }
        }
    ]);
    return BrowserClient;
}((0, _core.BaseClient));

},{"@swc/helpers/_/_call_super":"5oPMc","@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","@swc/helpers/_/_get":"lJChW","@swc/helpers/_/_get_prototype_of":"fF8vn","@swc/helpers/_/_inherits":"j8HRi","@sentry/core":"8bBGI","@sentry/utils":"gElXU","./debug-build.js":"3hH8w","./eventbuilder.js":"iw4zL","./helpers.js":"gFT9f","./userfeedback.js":"l9KIs","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3hH8w":[function(require,module,exports,__globalThis) {
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEBUG_BUILD", function() {
    return DEBUG_BUILD;
});
var DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"iw4zL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "eventFromError", function() {
    return eventFromError;
});
parcelHelpers.export(exports, "eventFromException", function() {
    return eventFromException;
});
parcelHelpers.export(exports, "eventFromMessage", function() {
    return eventFromMessage;
});
parcelHelpers.export(exports, "eventFromPlainObject", function() {
    return eventFromPlainObject;
});
parcelHelpers.export(exports, "eventFromString", function() {
    return eventFromString;
});
parcelHelpers.export(exports, "eventFromUnknownInput", function() {
    return eventFromUnknownInput;
});
parcelHelpers.export(exports, "exceptionFromError", function() {
    return exceptionFromError;
});
parcelHelpers.export(exports, "parseStackFrames", function() {
    return parseStackFrames;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
/**
 * This function creates an exception from a JavaScript Error
 */ function exceptionFromError(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    var frames = parseStackFrames(stackParser, ex);
    var exception = {
        type: ex && ex.name,
        value: extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
/**
 * @hidden
 */ function eventFromPlainObject(stackParser, exception, syntheticException, isUnhandledRejection) {
    var client = (0, _core.getClient)();
    var normalizeDepth = client && client.getOptions().normalizeDepth;
    var event = {
        exception: {
            values: [
                {
                    type: (0, _utils.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: {
            __serialized__: (0, _utils.normalizeToSize)(exception, normalizeDepth)
        }
    };
    if (syntheticException) {
        var frames = parseStackFrames(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
/**
 * @hidden
 */ function eventFromError(stackParser, ex) {
    return {
        exception: {
            values: [
                exceptionFromError(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function parseStackFrames(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    var stacktrace = ex.stacktrace || ex.stack || '';
    var popSize = getPopSize(ex);
    try {
        return stackParser(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
var reactMinifiedRegexp = /Minified React error #\d+;/i;
function getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === 'number') return ex.framesToPop;
        if (reactMinifiedRegexp.test(ex.message)) return 1;
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function extractMessage(ex) {
    var message = ex && ex.message;
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function eventFromException(stackParser, exception, hint, attachStacktrace) {
    var syntheticException = hint && hint.syntheticException || undefined;
    var event = eventFromUnknownInput(stackParser, exception, syntheticException, attachStacktrace);
    (0, _utils.addExceptionMechanism)(event); // defaults to { type: 'generic', handled: true }
    event.level = 'error';
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, _utils.resolvedSyncPromise)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function eventFromMessage(stackParser, message) {
    var // eslint-disable-next-line deprecation/deprecation
    level = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 'info', hint = arguments.length > 3 ? arguments[3] : void 0, attachStacktrace = arguments.length > 4 ? arguments[4] : void 0;
    var syntheticException = hint && hint.syntheticException || undefined;
    var event = eventFromString(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, _utils.resolvedSyncPromise)(event);
}
/**
 * @hidden
 */ function eventFromUnknownInput(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    var event;
    if ((0, _utils.isErrorEvent)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        var errorEvent = exception;
        return eventFromError(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, _utils.isDOMError)(exception) || (0, _utils.isDOMException)(exception)) {
        var domException = exception;
        if ('stack' in exception) event = eventFromError(stackParser, exception);
        else {
            var name = domException.name || ((0, _utils.isDOMError)(domException) ? 'DOMError' : 'DOMException');
            var message = domException.message ? `${name}: ${domException.message}` : name;
            event = eventFromString(stackParser, message, syntheticException, attachStacktrace);
            (0, _utils.addExceptionTypeValue)(event, message);
        }
        if ('code' in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = (0, _objectSpreadProps._)((0, _objectSpread._)({}, event.tags), {
            'DOMException.code': `${domException.code}`
        });
        return event;
    }
    if ((0, _utils.isError)(exception)) // we have a real Error object, do nothing
    return eventFromError(stackParser, exception);
    if ((0, _utils.isPlainObject)(exception) || (0, _utils.isEvent)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        var objectException = exception;
        event = eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, _utils.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = eventFromString(stackParser, exception, syntheticException, attachStacktrace);
    (0, _utils.addExceptionTypeValue)(event, `${exception}`, undefined);
    (0, _utils.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
/**
 * @hidden
 */ function eventFromString(stackParser, message, syntheticException, attachStacktrace) {
    var event = {};
    if (attachStacktrace && syntheticException) {
        var frames = parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
    }
    if ((0, _utils.isParameterizedString)(message)) {
        var __sentry_template_string__ = message.__sentry_template_string__, __sentry_template_values__ = message.__sentry_template_values__;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function getNonErrorObjectExceptionValue(exception, param) {
    var isUnhandledRejection = param.isUnhandledRejection;
    var keys = (0, _utils.extractExceptionKeysForMessage)(exception);
    var captureType = isUnhandledRejection ? 'promise rejection' : 'exception';
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, _utils.isErrorEvent)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, _utils.isEvent)(exception)) {
        var className = getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function getObjectClassName(obj) {
    try {
        var prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}

},{"@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_object_spread_props":"fLCYP","@sentry/core":"8bBGI","@sentry/utils":"gElXU","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"l9KIs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createUserFeedbackEnvelope", function() {
    return createUserFeedbackEnvelope;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _utils = require("@sentry/utils");
/**
 * Creates an envelope from a user feedback.
 */ function createUserFeedbackEnvelope(feedback, param) {
    var metadata = param.metadata, tunnel = param.tunnel, dsn = param.dsn;
    var headers = (0, _objectSpread._)({
        event_id: feedback.event_id,
        sent_at: new Date().toISOString()
    }, metadata && metadata.sdk && {
        sdk: {
            name: metadata.sdk.name,
            version: metadata.sdk.version
        }
    }, !!tunnel && !!dsn && {
        dsn: (0, _utils.dsnToString)(dsn)
    });
    var item = createUserFeedbackEnvelopeItem(feedback);
    return (0, _utils.createEnvelope)(headers, [
        item
    ]);
}
function createUserFeedbackEnvelopeItem(feedback) {
    var feedbackHeaders = {
        type: 'user_report'
    };
    return [
        feedbackHeaders,
        feedback
    ];
}

},{"@swc/helpers/_/_object_spread":"4bEWH","@sentry/utils":"gElXU","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"icY9Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "makeFetchTransport", function() {
    return makeFetchTransport;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
var _utilsJs = require("./utils.js");
/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function makeFetchTransport(options) {
    var nativeFetch = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (0, _utilsJs.getNativeFetchImplementation)();
    var pendingBodySize = 0;
    var pendingCount = 0;
    function makeRequest(request) {
        var requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        var requestOptions = (0, _objectSpread._)({
            body: request.body,
            method: 'POST',
            referrerPolicy: 'origin',
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15
        }, options.fetchOptions);
        try {
            return nativeFetch(options.url, requestOptions).then(function(response) {
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    }
                };
            });
        } catch (e) {
            (0, _utilsJs.clearCachedFetchImplementation)();
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, _utils.rejectedSyncPromise)(e);
        }
    }
    return (0, _core.createTransport)(options, makeRequest);
}

},{"@swc/helpers/_/_object_spread":"4bEWH","@sentry/core":"8bBGI","@sentry/utils":"gElXU","./utils.js":"hT9of","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"hT9of":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clearCachedFetchImplementation", function() {
    return clearCachedFetchImplementation;
});
parcelHelpers.export(exports, "getNativeFetchImplementation", function() {
    return getNativeFetchImplementation;
});
var _utils = require("@sentry/utils");
var _debugBuildJs = require("../debug-build.js");
var _helpersJs = require("../helpers.js");
var cachedFetchImpl = undefined;
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function getNativeFetchImplementation() {
    if (cachedFetchImpl) return cachedFetchImpl;
    /* eslint-disable @typescript-eslint/unbound-method */ // Fast path to avoid DOM I/O
    if ((0, _utils.isNativeFetch)((0, _helpersJs.WINDOW).fetch)) return cachedFetchImpl = (0, _helpersJs.WINDOW).fetch.bind((0, _helpersJs.WINDOW));
    var document = (0, _helpersJs.WINDOW).document;
    var fetchImpl = (0, _helpersJs.WINDOW).fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') try {
        var sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        var contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.fetch) fetchImpl = contentWindow.fetch;
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', e);
    }
    return cachedFetchImpl = fetchImpl.bind((0, _helpersJs.WINDOW));
/* eslint-enable @typescript-eslint/unbound-method */ }
/** Clears cached fetch impl */ function clearCachedFetchImplementation() {
    cachedFetchImpl = undefined;
}

},{"@sentry/utils":"gElXU","../debug-build.js":"3hH8w","../helpers.js":"gFT9f","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"9NFC5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "makeXHRTransport", function() {
    return makeXHRTransport;
});
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */ var XHR_READYSTATE_DONE = 4;
/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */ function makeXHRTransport(options) {
    function makeRequest(request) {
        return new (0, _utils.SyncPromise)(function(resolve, reject) {
            var xhr = new XMLHttpRequest();
            xhr.onerror = reject;
            xhr.onreadystatechange = function() {
                if (xhr.readyState === XHR_READYSTATE_DONE) resolve({
                    statusCode: xhr.status,
                    headers: {
                        'x-sentry-rate-limits': xhr.getResponseHeader('X-Sentry-Rate-Limits'),
                        'retry-after': xhr.getResponseHeader('Retry-After')
                    }
                });
            };
            xhr.open('POST', options.url);
            for(var header in options.headers)if (Object.prototype.hasOwnProperty.call(options.headers, header)) xhr.setRequestHeader(header, options.headers[header]);
            xhr.send(request.body);
        });
    }
    return (0, _core.createTransport)(options, makeRequest);
}

},{"@sentry/core":"8bBGI","@sentry/utils":"gElXU","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"a9hXX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "chromeStackLineParser", function() {
    return chromeStackLineParser;
});
parcelHelpers.export(exports, "defaultStackLineParsers", function() {
    return defaultStackLineParsers;
});
parcelHelpers.export(exports, "defaultStackParser", function() {
    return defaultStackParser;
});
parcelHelpers.export(exports, "geckoStackLineParser", function() {
    return geckoStackLineParser;
});
parcelHelpers.export(exports, "opera10StackLineParser", function() {
    return opera10StackLineParser;
});
parcelHelpers.export(exports, "opera11StackLineParser", function() {
    return opera11StackLineParser;
});
parcelHelpers.export(exports, "winjsStackLineParser", function() {
    return winjsStackLineParser;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _utils = require("@sentry/utils");
// global reference to slice
var UNKNOWN_FUNCTION = '?';
var OPERA10_PRIORITY = 10;
var OPERA11_PRIORITY = 20;
var CHROME_PRIORITY = 30;
var WINJS_PRIORITY = 40;
var GECKO_PRIORITY = 50;
function createFrame(filename, func, lineno, colno) {
    var frame = {
        filename: filename,
        function: func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
var chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
var chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
var chromeStackParserFn = function(line) {
    var parts = chromeRegex.exec(line);
    if (parts) {
        var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            var subMatch = chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        var _extractSafariExtensionDetails = (0, _slicedToArray._)(extractSafariExtensionDetails(parts[1] || UNKNOWN_FUNCTION, parts[2]), 2), func = _extractSafariExtensionDetails[0], filename = _extractSafariExtensionDetails[1];
        return createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
var chromeStackLineParser = [
    CHROME_PRIORITY,
    chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
var geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
var geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
var gecko = function(line) {
    var parts = geckoREgex.exec(line);
    if (parts) {
        var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            var subMatch = geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        var filename = parts[3];
        var func = parts[1] || UNKNOWN_FUNCTION;
        var ref;
        ref = (0, _slicedToArray._)(extractSafariExtensionDetails(func, filename), 2), func = ref[0], filename = ref[1], ref;
        return createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
var geckoStackLineParser = [
    GECKO_PRIORITY,
    gecko
];
var winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
var winjs = function(line) {
    var parts = winjsRegex.exec(line);
    return parts ? createFrame(parts[2], parts[1] || UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
var winjsStackLineParser = [
    WINJS_PRIORITY,
    winjs
];
var opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
var opera10 = function(line) {
    var parts = opera10Regex.exec(line);
    return parts ? createFrame(parts[2], parts[3] || UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
var opera10StackLineParser = [
    OPERA10_PRIORITY,
    opera10
];
var opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
var opera11 = function(line) {
    var parts = opera11Regex.exec(line);
    return parts ? createFrame(parts[5], parts[3] || parts[4] || UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
var opera11StackLineParser = [
    OPERA11_PRIORITY,
    opera11
];
var defaultStackLineParsers = [
    chromeStackLineParser,
    geckoStackLineParser,
    winjsStackLineParser
];
var defaultStackParser = (0, _utils.createStackParser).apply(void 0, (0, _toConsumableArray._)(defaultStackLineParsers));
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ var extractSafariExtensionDetails = function(func, filename) {
    var isSafariExtension = func.indexOf('safari-extension') !== -1;
    var isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : UNKNOWN_FUNCTION,
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};

},{"@swc/helpers/_/_sliced_to_array":"ha6sq","@swc/helpers/_/_to_consumable_array":"eqNDD","@sentry/utils":"gElXU","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"iBFmu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "captureUserFeedback", function() {
    return captureUserFeedback;
});
parcelHelpers.export(exports, "defaultIntegrations", function() {
    return defaultIntegrations;
});
parcelHelpers.export(exports, "forceLoad", function() {
    return forceLoad;
});
parcelHelpers.export(exports, "getDefaultIntegrations", function() {
    return getDefaultIntegrations;
});
parcelHelpers.export(exports, "init", function() {
    return init;
});
parcelHelpers.export(exports, "onLoad", function() {
    return onLoad;
});
parcelHelpers.export(exports, "showReportDialog", function() {
    return showReportDialog;
});
parcelHelpers.export(exports, "wrap", function() {
    return wrap;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
var _clientJs = require("./client.js");
var _debugBuildJs = require("./debug-build.js");
var _helpersJs = require("./helpers.js");
var _breadcrumbsJs = require("./integrations/breadcrumbs.js");
var _dedupeJs = require("./integrations/dedupe.js");
var _globalhandlersJs = require("./integrations/globalhandlers.js");
var _httpcontextJs = require("./integrations/httpcontext.js");
var _linkederrorsJs = require("./integrations/linkederrors.js");
var _trycatchJs = require("./integrations/trycatch.js");
var _stackParsersJs = require("./stack-parsers.js");
var _fetchJs = require("./transports/fetch.js");
var _xhrJs = require("./transports/xhr.js");
/** @deprecated Use `getDefaultIntegrations(options)` instead. */ var defaultIntegrations = [
    (0, _core.inboundFiltersIntegration)(),
    (0, _core.functionToStringIntegration)(),
    (0, _trycatchJs.browserApiErrorsIntegration)(),
    (0, _breadcrumbsJs.breadcrumbsIntegration)(),
    (0, _globalhandlersJs.globalHandlersIntegration)(),
    (0, _linkederrorsJs.linkedErrorsIntegration)(),
    (0, _dedupeJs.dedupeIntegration)(),
    (0, _httpcontextJs.httpContextIntegration)()
];
/** Get the default integrations for the browser SDK. */ function getDefaultIntegrations(_options) {
    // We return a copy of the defaultIntegrations here to avoid mutating this
    return(// eslint-disable-next-line deprecation/deprecation
    (0, _toConsumableArray._)(defaultIntegrations));
}
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function init() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (options.defaultIntegrations === undefined) options.defaultIntegrations = getDefaultIntegrations();
    if (options.release === undefined) {
        // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
        if (typeof __SENTRY_RELEASE__ === 'string') options.release = __SENTRY_RELEASE__;
        // This supports the variable that sentry-webpack-plugin injects
        if ((0, _helpersJs.WINDOW).SENTRY_RELEASE && (0, _helpersJs.WINDOW).SENTRY_RELEASE.id) options.release = (0, _helpersJs.WINDOW).SENTRY_RELEASE.id;
    }
    if (options.autoSessionTracking === undefined) options.autoSessionTracking = true;
    if (options.sendClientReports === undefined) options.sendClientReports = true;
    var clientOptions = (0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
        stackParser: (0, _utils.stackParserFromStackParserOptions)(options.stackParser || (0, _stackParsersJs.defaultStackParser)),
        integrations: (0, _core.getIntegrationsToSetup)(options),
        transport: options.transport || ((0, _utils.supportsFetch)() ? (0, _fetchJs.makeFetchTransport) : (0, _xhrJs.makeXHRTransport))
    });
    (0, _core.initAndBind)((0, _clientJs.BrowserClient), clientOptions);
    if (options.autoSessionTracking) startSessionTracking();
}
var showReportDialog = function() {
    var // eslint-disable-next-line deprecation/deprecation
    options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, // eslint-disable-next-line deprecation/deprecation
    hub = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (0, _core.getCurrentHub)();
    // doesn't work without a document (React Native)
    if (!(0, _helpersJs.WINDOW).document) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).error('Global document not defined in showReportDialog call');
        return;
    }
    // eslint-disable-next-line deprecation/deprecation
    var _hub_getStackTop = hub.getStackTop(), client = _hub_getStackTop.client, scope = _hub_getStackTop.scope;
    var dsn = options.dsn || client && client.getDsn();
    if (!dsn) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).error('DSN not configured for showReportDialog call');
        return;
    }
    if (scope) options.user = (0, _objectSpread._)({}, scope.getUser(), options.user);
    if (!options.eventId) // eslint-disable-next-line deprecation/deprecation
    options.eventId = hub.lastEventId();
    var script = (0, _helpersJs.WINDOW).document.createElement('script');
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.src = (0, _core.getReportDialogEndpoint)(dsn, options);
    if (options.onLoad) script.onload = options.onLoad;
    var onClose = options.onClose;
    if (onClose) {
        var reportDialogClosedMessageHandler = function(event) {
            if (event.data === '__sentry_reportdialog_closed__') try {
                onClose();
            } finally{
                (0, _helpersJs.WINDOW).removeEventListener('message', reportDialogClosedMessageHandler);
            }
        };
        (0, _helpersJs.WINDOW).addEventListener('message', reportDialogClosedMessageHandler);
    }
    var injectionPoint = (0, _helpersJs.WINDOW).document.head || (0, _helpersJs.WINDOW).document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
    else (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).error('Not injecting report dialog. No injection point found in HTML');
};
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function forceLoad() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function onLoad(callback) {
    callback();
}
/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @deprecated This function will be removed in v8.
 * It is not part of Sentry's official API and it's easily replaceable by using a try/catch block
 * and calling Sentry.captureException.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */ // TODO(v8): Remove this function
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function wrap(fn) {
    return (0, _helpersJs.wrap)(fn)();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function startSessionTracking() {
    if (typeof (0, _helpersJs.WINDOW).document === 'undefined') {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn('Session tracking in non-browser environment with @sentry/browser is not supported.');
        return;
    }
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    (0, _core.startSession)({
        ignoreDuration: true
    });
    (0, _core.captureSession)();
    // We want to create a session for every navigation as well
    (0, _utils.addHistoryInstrumentationHandler)(function(param) {
        var from = param.from, to = param.to;
        // Don't create an additional session for the initial route or if the location did not change
        if (from !== undefined && from !== to) {
            (0, _core.startSession)({
                ignoreDuration: true
            });
            (0, _core.captureSession)();
        }
    });
}
/**
 * Captures user feedback and sends it to Sentry.
 */ function captureUserFeedback(feedback) {
    var client = (0, _core.getClient)();
    if (client) client.captureUserFeedback(feedback);
}

},{"@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_object_spread_props":"fLCYP","@swc/helpers/_/_to_consumable_array":"eqNDD","@sentry/core":"8bBGI","@sentry/utils":"gElXU","./client.js":"5cJ51","./debug-build.js":"3hH8w","./helpers.js":"gFT9f","./integrations/breadcrumbs.js":"4enzp","./integrations/dedupe.js":"eScBY","./integrations/globalhandlers.js":"eOTsK","./integrations/httpcontext.js":"c80HE","./integrations/linkederrors.js":"iWIUb","./integrations/trycatch.js":"bQJCw","./stack-parsers.js":"a9hXX","./transports/fetch.js":"icY9Q","./transports/xhr.js":"9NFC5","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4enzp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Breadcrumbs", function() {
    return Breadcrumbs;
});
parcelHelpers.export(exports, "breadcrumbsIntegration", function() {
    return breadcrumbsIntegration;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
var _debugBuildJs = require("../debug-build.js");
var _helpersJs = require("../helpers.js");
/* eslint-disable max-lines */ /** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ var MAX_ALLOWED_STRING_LENGTH = 1024;
var INTEGRATION_NAME = 'Breadcrumbs';
var _breadcrumbsIntegration = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _options = (0, _objectSpread._)({
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true
    }, options);
    return {
        name: INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce: function() {},
        setup: function(client) {
            if (_options.console) (0, _utils.addConsoleInstrumentationHandler)(_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, _utils.addClickKeypressInstrumentationHandler)(_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, _utils.addXhrInstrumentationHandler)(_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, _utils.addFetchInstrumentationHandler)(_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, _utils.addHistoryInstrumentationHandler)(_getHistoryBreadcrumbHandler(client));
            if (_options.sentry && client.on) client.on('beforeSendEvent', _getSentryBreadcrumbHandler(client));
        }
    };
};
var breadcrumbsIntegration = (0, _core.defineIntegration)(_breadcrumbsIntegration);
/**
 * Default Breadcrumbs instrumentations
 *
 * @deprecated Use `breadcrumbsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
var Breadcrumbs = (0, _core.convertIntegrationFnToClass)(INTEGRATION_NAME, breadcrumbsIntegration);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function _getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, _core.getClient)() !== client) return;
        (0, _core.addBreadcrumb)({
            category: `sentry.${event.type === 'transaction' ? 'transaction' : 'event'}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, _utils.getEventDescription)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function _getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, _core.getClient)() !== client) return;
        var target;
        var componentName;
        var keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        var maxStringLength = typeof dom === 'object' && typeof dom.maxStringLength === 'number' ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > MAX_ALLOWED_STRING_LENGTH) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn(`\`dom.maxStringLength\` cannot exceed ${MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === 'string') keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            var event = handlerData.event;
            var element = _isEvent(event) ? event.target : event;
            target = (0, _utils.htmlTreeAsString)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, _utils.getComponentName)(element);
        } catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) return;
        var breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            'ui.component_name': componentName
        };
        (0, _core.addBreadcrumb)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function _getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, _core.getClient)() !== client) return;
        var breadcrumb = {
            category: 'console',
            data: {
                arguments: handlerData.args,
                logger: 'console'
            },
            level: (0, _utils.severityLevelFromString)(handlerData.level),
            message: (0, _utils.safeJoin)(handlerData.args, ' ')
        };
        if (handlerData.level === 'assert') {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, _utils.safeJoin)(handlerData.args.slice(1), ' ') || 'console.assert'}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, _core.addBreadcrumb)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function _getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, _core.getClient)() !== client) return;
        var startTimestamp = handlerData.startTimestamp, endTimestamp = handlerData.endTimestamp;
        var sentryXhrData = handlerData.xhr[0, _utils.SENTRY_XHR_DATA_KEY];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        var method = sentryXhrData.method, url = sentryXhrData.url, status_code = sentryXhrData.status_code, body = sentryXhrData.body;
        var data = {
            method: method,
            url: url,
            status_code: status_code
        };
        var hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        (0, _core.addBreadcrumb)({
            category: 'xhr',
            data: data,
            type: 'http'
        }, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function _getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, _core.getClient)() !== client) return;
        var startTimestamp = handlerData.startTimestamp, endTimestamp = handlerData.endTimestamp;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        if (handlerData.error) {
            var data = handlerData.fetchData;
            var hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, _core.addBreadcrumb)({
                category: 'fetch',
                data: data,
                level: 'error',
                type: 'http'
            }, hint);
        } else {
            var response = handlerData.response;
            var data1 = (0, _objectSpreadProps._)((0, _objectSpread._)({}, handlerData.fetchData), {
                status_code: response && response.status
            });
            var hint1 = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, _core.addBreadcrumb)({
                category: 'fetch',
                data: data1,
                type: 'http'
            }, hint1);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function _getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, _core.getClient)() !== client) return;
        var from = handlerData.from;
        var to = handlerData.to;
        var parsedLoc = (0, _utils.parseUrl)((0, _helpersJs.WINDOW).location.href);
        var parsedFrom = from ? (0, _utils.parseUrl)(from) : undefined;
        var parsedTo = (0, _utils.parseUrl)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom || !parsedFrom.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, _core.addBreadcrumb)({
            category: 'navigation',
            data: {
                from: from,
                to: to
            }
        });
    };
}
function _isEvent(event) {
    return !!event && !!event.target;
}

},{"@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_object_spread_props":"fLCYP","@sentry/core":"8bBGI","@sentry/utils":"gElXU","../debug-build.js":"3hH8w","../helpers.js":"gFT9f","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"eScBY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Dedupe", function() {
    return Dedupe;
});
parcelHelpers.export(exports, "dedupeIntegration", function() {
    return dedupeIntegration;
});
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
var _debugBuildJs = require("../debug-build.js");
var INTEGRATION_NAME = 'Dedupe';
var _dedupeIntegration = function() {
    var previousEvent;
    return {
        name: INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce: function() {},
        processEvent: function(currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if (_shouldDropEvent(currentEvent, previousEvent)) {
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn('Event dropped due to being a duplicate of previously captured event.');
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
var dedupeIntegration = (0, _core.defineIntegration)(_dedupeIntegration);
/**
 * Deduplication filter.
 * @deprecated Use `dedupeIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
var Dedupe = (0, _core.convertIntegrationFnToClass)(INTEGRATION_NAME, dedupeIntegration);
function _shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if (_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if (_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function _isSameMessageEvent(currentEvent, previousEvent) {
    var currentMessage = currentEvent.message;
    var previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function _isSameExceptionEvent(currentEvent, previousEvent) {
    var previousException = _getExceptionFromEvent(previousEvent);
    var currentException = _getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function _isSameStacktrace(currentEvent, previousEvent) {
    var currentFrames = _getFramesFromEvent(currentEvent);
    var previousFrames = _getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(var i = 0; i < previousFrames.length; i++){
        var frameA = previousFrames[i];
        var frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function _isSameFingerprint(currentEvent, previousEvent) {
    var currentFingerprint = currentEvent.fingerprint;
    var previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
function _getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
function _getFramesFromEvent(event) {
    var exception = event.exception;
    if (exception) try {
        // @ts-expect-error Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    return undefined;
}

},{"@sentry/core":"8bBGI","@sentry/utils":"gElXU","../debug-build.js":"3hH8w","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"eOTsK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GlobalHandlers", function() {
    return GlobalHandlers;
});
parcelHelpers.export(exports, "globalHandlersIntegration", function() {
    return globalHandlersIntegration;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
var _debugBuildJs = require("../debug-build.js");
var _eventbuilderJs = require("../eventbuilder.js");
var _helpersJs = require("../helpers.js");
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ var INTEGRATION_NAME = 'GlobalHandlers';
var _globalHandlersIntegration = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _options = (0, _objectSpread._)({
        onerror: true,
        onunhandledrejection: true
    }, options);
    return {
        name: INTEGRATION_NAME,
        setupOnce: function() {
            Error.stackTraceLimit = 50;
        },
        setup: function(client) {
            if (_options.onerror) {
                _installGlobalOnErrorHandler(client);
                globalHandlerLog('onerror');
            }
            if (_options.onunhandledrejection) {
                _installGlobalOnUnhandledRejectionHandler(client);
                globalHandlerLog('onunhandledrejection');
            }
        }
    };
};
var globalHandlersIntegration = (0, _core.defineIntegration)(_globalHandlersIntegration);
/**
 * Global handlers.
 * @deprecated Use `globalHandlersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
var GlobalHandlers = (0, _core.convertIntegrationFnToClass)(INTEGRATION_NAME, globalHandlersIntegration);
function _installGlobalOnErrorHandler(client) {
    (0, _utils.addGlobalErrorInstrumentationHandler)(function(data) {
        var _getOptions = getOptions(), stackParser = _getOptions.stackParser, attachStacktrace = _getOptions.attachStacktrace;
        if ((0, _core.getClient)() !== client || (0, _helpersJs.shouldIgnoreOnError)()) return;
        var msg = data.msg, url = data.url, line = data.line, column = data.column, error = data.error;
        var event = error === undefined && (0, _utils.isString)(msg) ? _eventFromIncompleteOnError(msg, url, line, column) : _enhanceEventWithInitialFrame((0, _eventbuilderJs.eventFromUnknownInput)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = 'error';
        (0, _core.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onerror'
            }
        });
    });
}
function _installGlobalOnUnhandledRejectionHandler(client) {
    (0, _utils.addGlobalUnhandledRejectionInstrumentationHandler)(function(e) {
        var _getOptions = getOptions(), stackParser = _getOptions.stackParser, attachStacktrace = _getOptions.attachStacktrace;
        if ((0, _core.getClient)() !== client || (0, _helpersJs.shouldIgnoreOnError)()) return;
        var error = _getUnhandledRejectionError(e);
        var event = (0, _utils.isPrimitive)(error) ? _eventFromRejectionWithPrimitive(error) : (0, _eventbuilderJs.eventFromUnknownInput)(stackParser, error, undefined, attachStacktrace, true);
        event.level = 'error';
        (0, _core.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onunhandledrejection'
            }
        });
    });
}
function _getUnhandledRejectionError(error) {
    if ((0, _utils.isPrimitive)(error)) return error;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var e = error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ('reason' in e) return e.reason;
        else if ('detail' in e && 'reason' in e.detail) return e.detail.reason;
    } catch (e2) {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function _eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function _eventFromIncompleteOnError(msg, url, line, column) {
    var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    var message = (0, _utils.isErrorEvent)(msg) ? msg.message : msg;
    var name = 'Error';
    var groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    var event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message
                }
            ]
        }
    };
    return _enhanceEventWithInitialFrame(event, url, line, column);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    var e = event.exception = event.exception || {};
    // event.exception.values
    var ev = e.values = e.values || [];
    // event.exception.values[0]
    var ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    var ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    var ev0sf = ev0s.frames = ev0s.frames || [];
    var colno = isNaN(parseInt(column, 10)) ? undefined : column;
    var lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    var filename = (0, _utils.isString)(url) && url.length > 0 ? url : (0, _utils.getLocationHref)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: '?',
        in_app: true,
        lineno: lineno
    });
    return event;
}
function globalHandlerLog(type) {
    (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log(`Global Handler attached: ${type}`);
}
function getOptions() {
    var client = (0, _core.getClient)();
    var options = client && client.getOptions() || {
        stackParser: function() {
            return [];
        },
        attachStacktrace: false
    };
    return options;
}

},{"@swc/helpers/_/_object_spread":"4bEWH","@sentry/core":"8bBGI","@sentry/utils":"gElXU","../debug-build.js":"3hH8w","../eventbuilder.js":"iw4zL","../helpers.js":"gFT9f","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"c80HE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HttpContext", function() {
    return HttpContext;
});
parcelHelpers.export(exports, "httpContextIntegration", function() {
    return httpContextIntegration;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _core = require("@sentry/core");
var _helpersJs = require("../helpers.js");
var INTEGRATION_NAME = 'HttpContext';
var _httpContextIntegration = function() {
    return {
        name: INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce: function() {},
        preprocessEvent: function(event) {
            // if none of the information we want exists, don't bother
            if (!(0, _helpersJs.WINDOW).navigator && !(0, _helpersJs.WINDOW).location && !(0, _helpersJs.WINDOW).document) return;
            // grab as much info as exists and add it to the event
            var url = event.request && event.request.url || (0, _helpersJs.WINDOW).location && (0, _helpersJs.WINDOW).location.href;
            var referrer = ((0, _helpersJs.WINDOW).document || {}).referrer;
            var userAgent = ((0, _helpersJs.WINDOW).navigator || {}).userAgent;
            var headers = (0, _objectSpread._)({}, event.request && event.request.headers, referrer && {
                Referer: referrer
            }, userAgent && {
                'User-Agent': userAgent
            });
            var request = (0, _objectSpreadProps._)((0, _objectSpread._)({}, event.request, url && {
                url: url
            }), {
                headers: headers
            });
            event.request = request;
        }
    };
};
var httpContextIntegration = (0, _core.defineIntegration)(_httpContextIntegration);
/**
 * HttpContext integration collects information about HTTP request headers.
 * @deprecated Use `httpContextIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
var HttpContext = (0, _core.convertIntegrationFnToClass)(INTEGRATION_NAME, httpContextIntegration);

},{"@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_object_spread_props":"fLCYP","@sentry/core":"8bBGI","../helpers.js":"gFT9f","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"iWIUb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LinkedErrors", function() {
    return LinkedErrors;
});
parcelHelpers.export(exports, "linkedErrorsIntegration", function() {
    return linkedErrorsIntegration;
});
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
var _eventbuilderJs = require("../eventbuilder.js");
var DEFAULT_KEY = 'cause';
var DEFAULT_LIMIT = 5;
var INTEGRATION_NAME = 'LinkedErrors';
var _linkedErrorsIntegration = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var limit = options.limit || DEFAULT_LIMIT;
    var key = options.key || DEFAULT_KEY;
    return {
        name: INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce: function() {},
        preprocessEvent: function(event, hint, client) {
            var options = client.getOptions();
            (0, _utils.applyAggregateErrorsToEvent)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, _eventbuilderJs.exceptionFromError), options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
var linkedErrorsIntegration = (0, _core.defineIntegration)(_linkedErrorsIntegration);
/**
 * Aggregrate linked errors in an event.
 * @deprecated Use `linkedErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
var LinkedErrors = (0, _core.convertIntegrationFnToClass)(INTEGRATION_NAME, linkedErrorsIntegration);

},{"@sentry/core":"8bBGI","@sentry/utils":"gElXU","../eventbuilder.js":"iw4zL","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"bQJCw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TryCatch", function() {
    return TryCatch;
});
parcelHelpers.export(exports, "browserApiErrorsIntegration", function() {
    return browserApiErrorsIntegration;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
var _helpersJs = require("../helpers.js");
var DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'BroadcastChannel',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'SharedWorker',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload'
];
var INTEGRATION_NAME = 'TryCatch';
var _browserApiErrorsIntegration = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _options = (0, _objectSpread._)({
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true
    }, options);
    return {
        name: INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce: function() {
            if (_options.setTimeout) (0, _utils.fill)((0, _helpersJs.WINDOW), 'setTimeout', _wrapTimeFunction);
            if (_options.setInterval) (0, _utils.fill)((0, _helpersJs.WINDOW), 'setInterval', _wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, _utils.fill)((0, _helpersJs.WINDOW), 'requestAnimationFrame', _wrapRAF);
            if (_options.XMLHttpRequest && 'XMLHttpRequest' in (0, _helpersJs.WINDOW)) (0, _utils.fill)(XMLHttpRequest.prototype, 'send', _wrapXHR);
            var eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                var eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : DEFAULT_EVENT_TARGET;
                eventTarget.forEach(_wrapEventTarget);
            }
        }
    };
};
var browserApiErrorsIntegration = (0, _core.defineIntegration)(_browserApiErrorsIntegration);
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 * @deprecated Use `browserApiErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
var TryCatch = (0, _core.convertIntegrationFnToClass)(INTEGRATION_NAME, browserApiErrorsIntegration);
function _wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var originalCallback = args[0];
        args[0] = (0, _helpersJs.wrap)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, _utils.getFunctionName)(original)
                },
                handled: false,
                type: 'instrument'
            }
        });
        return original.apply(this, args);
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0, _helpersJs.wrap)(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: (0, _utils.getFunctionName)(original)
                    },
                    handled: false,
                    type: 'instrument'
                }
            })
        ]);
    };
}
function _wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var xhr = this;
        var xmlHttpRequestProps = [
            'onload',
            'onerror',
            'onprogress',
            'onreadystatechange'
        ];
        xmlHttpRequestProps.forEach(function(prop) {
            if (prop in xhr && typeof xhr[prop] === 'function') // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, _utils.fill)(xhr, prop, function(original) {
                var wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, _utils.getFunctionName)(original)
                        },
                        handled: false,
                        type: 'instrument'
                    }
                };
                // If Instrument integration has been called before TryCatch, get the name of original function
                var originalFunction = (0, _utils.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, _utils.getFunctionName)(originalFunction);
                // Otherwise wrap directly
                return (0, _helpersJs.wrap)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function _wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var globalObject = (0, _helpersJs.WINDOW);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    var proto = globalObject[target] && globalObject[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
    (0, _utils.fill)(proto, 'addEventListener', function(original) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === 'function') // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, _helpersJs.wrap)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: 'handleEvent',
                            handler: (0, _utils.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                });
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, _helpersJs.wrap)(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: (0, _utils.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                }),
                options
            ]);
        };
    });
    (0, _utils.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */ var wrappedEventHandler = fn;
            try {
                var originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}

},{"@swc/helpers/_/_object_spread":"4bEWH","@sentry/core":"8bBGI","@sentry/utils":"gElXU","../helpers.js":"gFT9f","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"guXvd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GlobalHandlers", function() {
    return 0, _globalhandlersJs.GlobalHandlers;
});
parcelHelpers.export(exports, "TryCatch", function() {
    return 0, _trycatchJs.TryCatch;
});
parcelHelpers.export(exports, "Breadcrumbs", function() {
    return 0, _breadcrumbsJs.Breadcrumbs;
});
parcelHelpers.export(exports, "LinkedErrors", function() {
    return 0, _linkederrorsJs.LinkedErrors;
});
parcelHelpers.export(exports, "HttpContext", function() {
    return 0, _httpcontextJs.HttpContext;
});
parcelHelpers.export(exports, "Dedupe", function() {
    return 0, _dedupeJs.Dedupe;
}) /* eslint-disable deprecation/deprecation */ ;
var _globalhandlersJs = require("./globalhandlers.js");
var _trycatchJs = require("./trycatch.js");
var _breadcrumbsJs = require("./breadcrumbs.js");
var _linkederrorsJs = require("./linkederrors.js");
var _httpcontextJs = require("./httpcontext.js");
var _dedupeJs = require("./dedupe.js");

},{"./globalhandlers.js":"eOTsK","./trycatch.js":"bQJCw","./breadcrumbs.js":"4enzp","./linkederrors.js":"iWIUb","./httpcontext.js":"c80HE","./dedupe.js":"eScBY","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1f5z6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InternalReplay", function() {
    return Replay$1;
});
parcelHelpers.export(exports, "Replay", function() {
    return Replay;
});
parcelHelpers.export(exports, "getReplay", function() {
    return getReplay;
});
parcelHelpers.export(exports, "internalGetReplay", function() {
    return getReplay$1;
});
parcelHelpers.export(exports, "internalReplayIntegration", function() {
    return replayIntegration$1;
});
parcelHelpers.export(exports, "replayIntegration", function() {
    return replayIntegration;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _callSuper = require("@swc/helpers/_/_call_super");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _wrapNativeSuper = require("@swc/helpers/_/_wrap_native_super");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _utils = require("@sentry/utils");
var _core = require("@sentry/core");
var _tracing = require("@sentry-internal/tracing");
// exporting a separate copy of `WINDOW` rather than exporting the one from `@sentry/browser`
// prevents the browser package from being bundled in the CDN bundle, and avoids a
// circular dependency between the browser and replay packages should `@sentry/browser` import
// from `@sentry/replay` in the future
var WINDOW = (0, _utils.GLOBAL_OBJ);
var REPLAY_SESSION_KEY = 'sentryReplaySession';
var REPLAY_EVENT_NAME = 'replay_event';
var UNABLE_TO_SEND_REPLAY = 'Unable to send Replay';
// The idle limit for a session after which recording is paused.
var SESSION_IDLE_PAUSE_DURATION = 300000; // 5 minutes in ms
// The idle limit for a session after which the session expires.
var SESSION_IDLE_EXPIRE_DURATION = 900000; // 15 minutes in ms
/** Default flush delays */ var DEFAULT_FLUSH_MIN_DELAY = 5000;
// XXX: Temp fix for our debounce logic where `maxWait` would never occur if it
// was the same as `wait`
var DEFAULT_FLUSH_MAX_DELAY = 5500;
/* How long to wait for error checkouts */ var BUFFER_CHECKOUT_TIME = 60000;
var RETRY_BASE_INTERVAL = 5000;
var RETRY_MAX_COUNT = 3;
/* The max (uncompressed) size in bytes of a network body. Any body larger than this will be truncated. */ var NETWORK_BODY_MAX_SIZE = 150000;
/* The max size of a single console arg that is captured. Any arg larger than this will be truncated. */ var CONSOLE_ARG_MAX_SIZE = 5000;
/* Min. time to wait before we consider something a slow click. */ var SLOW_CLICK_THRESHOLD = 3000;
/* For scroll actions after a click, we only look for a very short time period to detect programmatic scrolling. */ var SLOW_CLICK_SCROLL_TIMEOUT = 300;
/** When encountering a total segment size exceeding this size, stop the replay (as we cannot properly ingest it). */ var REPLAY_MAX_EVENT_BUFFER_SIZE = 20000000; // ~20MB
/** Replays must be min. 5s long before we send them. */ var MIN_REPLAY_DURATION = 4999;
/* The max. allowed value that the minReplayDuration can be set to. */ var MIN_REPLAY_DURATION_LIMIT = 15000;
/** The max. length of a replay. */ var MAX_REPLAY_DURATION = 3600000; // 60 minutes in ms;
function _nullishCoalesce$1(lhs, rhsFn) {
    if (lhs != null) return lhs;
    else return rhsFn();
}
function _optionalChain$5(ops) {
    var lastAccessLHS = undefined;
    var value = ops[0];
    var i = 1;
    while(i < ops.length){
        var op = ops[i];
        var fn = ops[i + 1];
        i += 2;
        if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) return undefined;
        if (op === 'access' || op === 'optionalAccess') {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === 'call' || op === 'optionalCall') {
            var _value;
            value = fn(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return (_value = value).call.apply(_value, [
                    lastAccessLHS
                ].concat((0, _toConsumableArray._)(args)));
            });
            lastAccessLHS = undefined;
        }
    }
    return value;
}
var NodeType$1;
(function(NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})(NodeType$1 || (NodeType$1 = {}));
function isElement$1(n) {
    return n.nodeType === n.ELEMENT_NODE;
}
function isShadowRoot(n) {
    var host = _optionalChain$5([
        n,
        'optionalAccess',
        function(_) {
            return _.host;
        }
    ]);
    return Boolean(_optionalChain$5([
        host,
        'optionalAccess',
        function(_2) {
            return _2.shadowRoot;
        }
    ]) === n);
}
function isNativeShadowDom(shadowRoot) {
    return Object.prototype.toString.call(shadowRoot) === '[object ShadowRoot]';
}
function fixBrowserCompatibilityIssuesInCSS(cssText) {
    if (cssText.includes(' background-clip: text;') && !cssText.includes(' -webkit-background-clip: text;')) cssText = cssText.replace(' background-clip: text;', ' -webkit-background-clip: text; background-clip: text;');
    return cssText;
}
function escapeImportStatement(rule) {
    var cssText = rule.cssText;
    if (cssText.split('"').length < 3) return cssText;
    var statement = [
        '@import',
        `url(${JSON.stringify(rule.href)})`
    ];
    if (rule.layerName === '') statement.push(`layer`);
    else if (rule.layerName) statement.push(`layer(${rule.layerName})`);
    if (rule.supportsText) statement.push(`supports(${rule.supportsText})`);
    if (rule.media.length) statement.push(rule.media.mediaText);
    return statement.join(' ') + ';';
}
function stringifyStylesheet(s) {
    try {
        var rules = s.rules || s.cssRules;
        return rules ? fixBrowserCompatibilityIssuesInCSS(Array.from(rules, stringifyRule).join('')) : null;
    } catch (error) {
        return null;
    }
}
function stringifyRule(rule) {
    var importStringified;
    if (isCSSImportRule(rule)) try {
        importStringified = stringifyStylesheet(rule.styleSheet) || escapeImportStatement(rule);
    } catch (error) {}
    else if (isCSSStyleRule(rule) && rule.selectorText.includes(':')) return fixSafariColons(rule.cssText);
    return importStringified || rule.cssText;
}
function fixSafariColons(cssStringified) {
    var regex = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
    return cssStringified.replace(regex, '$1\\$2');
}
function isCSSImportRule(rule) {
    return 'styleSheet' in rule;
}
function isCSSStyleRule(rule) {
    return 'selectorText' in rule;
}
var Mirror = /*#__PURE__*/ function() {
    "use strict";
    function Mirror() {
        (0, _classCallCheck._)(this, Mirror);
        this.idNodeMap = new Map();
        this.nodeMetaMap = new WeakMap();
    }
    (0, _createClass._)(Mirror, [
        {
            key: "getId",
            value: function getId(n) {
                if (!n) return -1;
                var id = _optionalChain$5([
                    this,
                    'access',
                    function(_3) {
                        return _3.getMeta;
                    },
                    'call',
                    function(_4) {
                        return _4(n);
                    },
                    'optionalAccess',
                    function(_5) {
                        return _5.id;
                    }
                ]);
                return _nullishCoalesce$1(id, function() {
                    return -1;
                });
            }
        },
        {
            key: "getNode",
            value: function getNode(id) {
                return this.idNodeMap.get(id) || null;
            }
        },
        {
            key: "getIds",
            value: function getIds() {
                return Array.from(this.idNodeMap.keys());
            }
        },
        {
            key: "getMeta",
            value: function getMeta(n) {
                return this.nodeMetaMap.get(n) || null;
            }
        },
        {
            key: "removeNodeFromMap",
            value: function removeNodeFromMap(n) {
                var _this = this;
                var id = this.getId(n);
                this.idNodeMap.delete(id);
                if (n.childNodes) n.childNodes.forEach(function(childNode) {
                    return _this.removeNodeFromMap(childNode);
                });
            }
        },
        {
            key: "has",
            value: function has(id) {
                return this.idNodeMap.has(id);
            }
        },
        {
            key: "hasNode",
            value: function hasNode(node) {
                return this.nodeMetaMap.has(node);
            }
        },
        {
            key: "add",
            value: function add(n, meta) {
                var id = meta.id;
                this.idNodeMap.set(id, n);
                this.nodeMetaMap.set(n, meta);
            }
        },
        {
            key: "replace",
            value: function replace(id, n) {
                var oldNode = this.getNode(id);
                if (oldNode) {
                    var meta = this.nodeMetaMap.get(oldNode);
                    if (meta) this.nodeMetaMap.set(n, meta);
                }
                this.idNodeMap.set(id, n);
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.idNodeMap = new Map();
                this.nodeMetaMap = new WeakMap();
            }
        }
    ]);
    return Mirror;
}();
function createMirror() {
    return new Mirror();
}
function shouldMaskInput(param) {
    var maskInputOptions = param.maskInputOptions, tagName = param.tagName, type = param.type;
    if (tagName === 'OPTION') tagName = 'SELECT';
    return Boolean(maskInputOptions[tagName.toLowerCase()] || type && maskInputOptions[type] || type === 'password' || tagName === 'INPUT' && !type && maskInputOptions['text']);
}
function maskInputValue(param) {
    var isMasked = param.isMasked, element = param.element, value = param.value, maskInputFn = param.maskInputFn;
    var text = value || '';
    if (!isMasked) return text;
    if (maskInputFn) text = maskInputFn(text, element);
    return '*'.repeat(text.length);
}
function toLowerCase(str) {
    return str.toLowerCase();
}
function toUpperCase(str) {
    return str.toUpperCase();
}
var ORIGINAL_ATTRIBUTE_NAME = '__rrweb_original__';
function is2DCanvasBlank(canvas) {
    var ctx = canvas.getContext('2d');
    if (!ctx) return true;
    var chunkSize = 50;
    for(var x = 0; x < canvas.width; x += chunkSize)for(var y = 0; y < canvas.height; y += chunkSize){
        var getImageData = ctx.getImageData;
        var originalGetImageData = ORIGINAL_ATTRIBUTE_NAME in getImageData ? getImageData[ORIGINAL_ATTRIBUTE_NAME] : getImageData;
        var pixelBuffer = new Uint32Array(originalGetImageData.call(ctx, x, y, Math.min(chunkSize, canvas.width - x), Math.min(chunkSize, canvas.height - y)).data.buffer);
        if (pixelBuffer.some(function(pixel) {
            return pixel !== 0;
        })) return false;
    }
    return true;
}
function getInputType(element) {
    var type = element.type;
    return element.hasAttribute('data-rr-is-password') ? 'password' : type ? toLowerCase(type) : null;
}
function getInputValue(el, tagName, type) {
    if (tagName === 'INPUT' && (type === 'radio' || type === 'checkbox')) return el.getAttribute('value') || '';
    return el.value;
}
var _id = 1;
var tagNameRegex = new RegExp('[^a-z0-9-_:]');
var IGNORED_NODE = -2;
function genId() {
    return _id++;
}
function getValidTagName(element) {
    if (element instanceof HTMLFormElement) return 'form';
    var processedTagName = toLowerCase(element.tagName);
    if (tagNameRegex.test(processedTagName)) return 'div';
    return processedTagName;
}
function extractOrigin(url) {
    var origin = '';
    if (url.indexOf('//') > -1) origin = url.split('/').slice(0, 3).join('/');
    else origin = url.split('/')[0];
    origin = origin.split('?')[0];
    return origin;
}
var canvasService;
var canvasCtx;
var URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm;
var URL_PROTOCOL_MATCH = /^(?:[a-z+]+:)?\/\//i;
var URL_WWW_MATCH = /^www\..*/i;
var DATA_URI = /^(data:)([^,]*),(.*)/i;
function absoluteToStylesheet(cssText, href) {
    return (cssText || '').replace(URL_IN_CSS_REF, function(origin, quote1, path1, quote2, path2, path3) {
        var filePath = path1 || path2 || path3;
        var maybeQuote = quote1 || quote2 || '';
        if (!filePath) return origin;
        if (URL_PROTOCOL_MATCH.test(filePath) || URL_WWW_MATCH.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if (DATA_URI.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if (filePath[0] === '/') return `url(${maybeQuote}${extractOrigin(href) + filePath}${maybeQuote})`;
        var stack = href.split('/');
        var parts = filePath.split('/');
        stack.pop();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = parts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var part = _step.value;
                if (part === '.') continue;
                else if (part === '..') stack.pop();
                else stack.push(part);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return `url(${maybeQuote}${stack.join('/')}${maybeQuote})`;
    });
}
var SRCSET_NOT_SPACES = /^[^ \t\n\r\u000c]+/;
var SRCSET_COMMAS_OR_SPACES = /^[, \t\n\r\u000c]+/;
function getAbsoluteSrcsetString(doc, attributeValue) {
    if (attributeValue.trim() === '') return attributeValue;
    var pos = 0;
    function collectCharacters(regEx) {
        var chars;
        var match = regEx.exec(attributeValue.substring(pos));
        if (match) {
            chars = match[0];
            pos += chars.length;
            return chars;
        }
        return '';
    }
    var output = [];
    while(true){
        collectCharacters(SRCSET_COMMAS_OR_SPACES);
        if (pos >= attributeValue.length) break;
        var url = collectCharacters(SRCSET_NOT_SPACES);
        if (url.slice(-1) === ',') {
            url = absoluteToDoc(doc, url.substring(0, url.length - 1));
            output.push(url);
        } else {
            var descriptorsStr = '';
            url = absoluteToDoc(doc, url);
            var inParens = false;
            while(true){
                var c = attributeValue.charAt(pos);
                if (c === '') {
                    output.push((url + descriptorsStr).trim());
                    break;
                } else if (!inParens) {
                    if (c === ',') {
                        pos += 1;
                        output.push((url + descriptorsStr).trim());
                        break;
                    } else if (c === '(') inParens = true;
                } else if (c === ')') inParens = false;
                descriptorsStr += c;
                pos += 1;
            }
        }
    }
    return output.join(', ');
}
function absoluteToDoc(doc, attributeValue) {
    if (!attributeValue || attributeValue.trim() === '') return attributeValue;
    var a = doc.createElement('a');
    a.href = attributeValue;
    return a.href;
}
function isSVGElement(el) {
    return Boolean(el.tagName === 'svg' || el.ownerSVGElement);
}
function getHref() {
    var a = document.createElement('a');
    a.href = '';
    return a.href;
}
function transformAttribute(doc, tagName, name, value, element, maskAttributeFn) {
    if (!value) return value;
    if (name === 'src' || name === 'href' && !(tagName === 'use' && value[0] === '#')) return absoluteToDoc(doc, value);
    else if (name === 'xlink:href' && value[0] !== '#') return absoluteToDoc(doc, value);
    else if (name === 'background' && (tagName === 'table' || tagName === 'td' || tagName === 'th')) return absoluteToDoc(doc, value);
    else if (name === 'srcset') return getAbsoluteSrcsetString(doc, value);
    else if (name === 'style') return absoluteToStylesheet(value, getHref());
    else if (tagName === 'object' && name === 'data') return absoluteToDoc(doc, value);
    if (typeof maskAttributeFn === 'function') return maskAttributeFn(name, value, element);
    return value;
}
function ignoreAttribute(tagName, name, _value) {
    return (tagName === 'video' || tagName === 'audio') && name === 'autoplay';
}
function _isBlockedElement(element, blockClass, blockSelector, unblockSelector) {
    try {
        if (unblockSelector && element.matches(unblockSelector)) return false;
        if (typeof blockClass === 'string') {
            if (element.classList.contains(blockClass)) return true;
        } else for(var eIndex = element.classList.length; eIndex--;){
            var className = element.classList[eIndex];
            if (blockClass.test(className)) return true;
        }
        if (blockSelector) return element.matches(blockSelector);
    } catch (e) {}
    return false;
}
function elementClassMatchesRegex(el, regex) {
    for(var eIndex = el.classList.length; eIndex--;){
        var className = el.classList[eIndex];
        if (regex.test(className)) return true;
    }
    return false;
}
function distanceToMatch(node, matchPredicate) {
    var limit = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Infinity, distance = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
    if (!node) return -1;
    if (node.nodeType !== node.ELEMENT_NODE) return -1;
    if (distance > limit) return -1;
    if (matchPredicate(node)) return distance;
    return distanceToMatch(node.parentNode, matchPredicate, limit, distance + 1);
}
function createMatchPredicate(className, selector) {
    return function(node) {
        var el = node;
        if (el === null) return false;
        try {
            if (className) {
                if (typeof className === 'string') {
                    if (el.matches(`.${className}`)) return true;
                } else if (elementClassMatchesRegex(el, className)) return true;
            }
            if (selector && el.matches(selector)) return true;
            return false;
        } catch (e2) {
            return false;
        }
    };
}
function needMaskingText(node, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, maskAllText) {
    try {
        var el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
        if (el === null) return false;
        if (el.tagName === 'INPUT') {
            var autocomplete = el.getAttribute('autocomplete');
            var disallowedAutocompleteValues = [
                'current-password',
                'new-password',
                'cc-number',
                'cc-exp',
                'cc-exp-month',
                'cc-exp-year',
                'cc-csc'
            ];
            if (disallowedAutocompleteValues.includes(autocomplete)) return true;
        }
        var maskDistance = -1;
        var unmaskDistance = -1;
        if (maskAllText) {
            unmaskDistance = distanceToMatch(el, createMatchPredicate(unmaskTextClass, unmaskTextSelector));
            if (unmaskDistance < 0) return true;
            maskDistance = distanceToMatch(el, createMatchPredicate(maskTextClass, maskTextSelector), unmaskDistance >= 0 ? unmaskDistance : Infinity);
        } else {
            maskDistance = distanceToMatch(el, createMatchPredicate(maskTextClass, maskTextSelector));
            if (maskDistance < 0) return false;
            unmaskDistance = distanceToMatch(el, createMatchPredicate(unmaskTextClass, unmaskTextSelector), maskDistance >= 0 ? maskDistance : Infinity);
        }
        return maskDistance >= 0 ? unmaskDistance >= 0 ? maskDistance <= unmaskDistance : true : unmaskDistance >= 0 ? false : !!maskAllText;
    } catch (e) {}
    return !!maskAllText;
}
function onceIframeLoaded(iframeEl, listener, iframeLoadTimeout) {
    var win = iframeEl.contentWindow;
    if (!win) return;
    var fired = false;
    var readyState;
    try {
        readyState = win.document.readyState;
    } catch (error) {
        return;
    }
    if (readyState !== 'complete') {
        var timer = setTimeout(function() {
            if (!fired) {
                listener();
                fired = true;
            }
        }, iframeLoadTimeout);
        iframeEl.addEventListener('load', function() {
            clearTimeout(timer);
            fired = true;
            listener();
        });
        return;
    }
    var blankUrl = 'about:blank';
    if (win.location.href !== blankUrl || iframeEl.src === blankUrl || iframeEl.src === '') {
        setTimeout(listener, 0);
        return iframeEl.addEventListener('load', listener);
    }
    iframeEl.addEventListener('load', listener);
}
function onceStylesheetLoaded(link, listener, styleSheetLoadTimeout) {
    var fired = false;
    var styleSheetLoaded;
    try {
        styleSheetLoaded = link.sheet;
    } catch (error) {
        return;
    }
    if (styleSheetLoaded) return;
    var timer = setTimeout(function() {
        if (!fired) {
            listener();
            fired = true;
        }
    }, styleSheetLoadTimeout);
    link.addEventListener('load', function() {
        clearTimeout(timer);
        fired = true;
        listener();
    });
}
function serializeNode(n, options) {
    var doc = options.doc, mirror = options.mirror, blockClass = options.blockClass, blockSelector = options.blockSelector, unblockSelector = options.unblockSelector, maskAllText = options.maskAllText, maskAttributeFn = options.maskAttributeFn, maskTextClass = options.maskTextClass, unmaskTextClass = options.unmaskTextClass, maskTextSelector = options.maskTextSelector, unmaskTextSelector = options.unmaskTextSelector, inlineStylesheet = options.inlineStylesheet, _options_maskInputOptions = options.maskInputOptions, maskInputOptions = _options_maskInputOptions === void 0 ? {} : _options_maskInputOptions, maskTextFn = options.maskTextFn, maskInputFn = options.maskInputFn, _options_dataURLOptions = options.dataURLOptions, dataURLOptions = _options_dataURLOptions === void 0 ? {} : _options_dataURLOptions, inlineImages = options.inlineImages, recordCanvas = options.recordCanvas, keepIframeSrcFn = options.keepIframeSrcFn, _options_newlyAddedElement = options.newlyAddedElement, newlyAddedElement = _options_newlyAddedElement === void 0 ? false : _options_newlyAddedElement;
    var rootId = getRootId(doc, mirror);
    switch(n.nodeType){
        case n.DOCUMENT_NODE:
            if (n.compatMode !== 'CSS1Compat') return {
                type: NodeType$1.Document,
                childNodes: [],
                compatMode: n.compatMode
            };
            else return {
                type: NodeType$1.Document,
                childNodes: []
            };
        case n.DOCUMENT_TYPE_NODE:
            return {
                type: NodeType$1.DocumentType,
                name: n.name,
                publicId: n.publicId,
                systemId: n.systemId,
                rootId: rootId
            };
        case n.ELEMENT_NODE:
            return serializeElementNode(n, {
                doc: doc,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                inlineStylesheet: inlineStylesheet,
                maskAttributeFn: maskAttributeFn,
                maskInputOptions: maskInputOptions,
                maskInputFn: maskInputFn,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                keepIframeSrcFn: keepIframeSrcFn,
                newlyAddedElement: newlyAddedElement,
                rootId: rootId,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector
            });
        case n.TEXT_NODE:
            return serializeTextNode(n, {
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                maskTextFn: maskTextFn,
                maskInputOptions: maskInputOptions,
                maskInputFn: maskInputFn,
                rootId: rootId
            });
        case n.CDATA_SECTION_NODE:
            return {
                type: NodeType$1.CDATA,
                textContent: '',
                rootId: rootId
            };
        case n.COMMENT_NODE:
            return {
                type: NodeType$1.Comment,
                textContent: n.textContent || '',
                rootId: rootId
            };
        default:
            return false;
    }
}
function getRootId(doc, mirror) {
    if (!mirror.hasNode(doc)) return undefined;
    var docId = mirror.getId(doc);
    return docId === 1 ? undefined : docId;
}
function serializeTextNode(n, options) {
    var maskAllText = options.maskAllText, maskTextClass = options.maskTextClass, unmaskTextClass = options.unmaskTextClass, maskTextSelector = options.maskTextSelector, unmaskTextSelector = options.unmaskTextSelector, maskTextFn = options.maskTextFn, maskInputOptions = options.maskInputOptions, maskInputFn = options.maskInputFn, rootId = options.rootId;
    var parentTagName = n.parentNode && n.parentNode.tagName;
    var textContent = n.textContent;
    var isStyle = parentTagName === 'STYLE' ? true : undefined;
    var isScript = parentTagName === 'SCRIPT' ? true : undefined;
    var isTextarea = parentTagName === 'TEXTAREA' ? true : undefined;
    if (isStyle && textContent) {
        try {
            if (n.nextSibling || n.previousSibling) ;
            else if (_optionalChain$5([
                n,
                'access',
                function(_6) {
                    return _6.parentNode;
                },
                'access',
                function(_7) {
                    return _7.sheet;
                },
                'optionalAccess',
                function(_8) {
                    return _8.cssRules;
                }
            ])) textContent = stringifyStylesheet(n.parentNode.sheet);
        } catch (err) {
            console.warn(`Cannot get CSS styles from text's parentNode. Error: ${err}`, n);
        }
        textContent = absoluteToStylesheet(textContent, getHref());
    }
    if (isScript) textContent = 'SCRIPT_PLACEHOLDER';
    var forceMask = needMaskingText(n, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, maskAllText);
    if (!isStyle && !isScript && !isTextarea && textContent && forceMask) textContent = maskTextFn ? maskTextFn(textContent, n.parentElement) : textContent.replace(/[\S]/g, '*');
    if (isTextarea && textContent && (maskInputOptions.textarea || forceMask)) textContent = maskInputFn ? maskInputFn(textContent, n.parentNode) : textContent.replace(/[\S]/g, '*');
    if (parentTagName === 'OPTION' && textContent) {
        var isInputMasked = shouldMaskInput({
            type: null,
            tagName: parentTagName,
            maskInputOptions: maskInputOptions
        });
        textContent = maskInputValue({
            isMasked: needMaskingText(n, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, isInputMasked),
            element: n,
            value: textContent,
            maskInputFn: maskInputFn
        });
    }
    return {
        type: NodeType$1.Text,
        textContent: textContent || '',
        isStyle: isStyle,
        rootId: rootId
    };
}
function serializeElementNode(n, options) {
    var doc = options.doc, blockClass = options.blockClass, blockSelector = options.blockSelector, unblockSelector = options.unblockSelector, inlineStylesheet = options.inlineStylesheet, _options_maskInputOptions = options.maskInputOptions, maskInputOptions = _options_maskInputOptions === void 0 ? {} : _options_maskInputOptions, maskAttributeFn = options.maskAttributeFn, maskInputFn = options.maskInputFn, _options_dataURLOptions = options.dataURLOptions, dataURLOptions = _options_dataURLOptions === void 0 ? {} : _options_dataURLOptions, inlineImages = options.inlineImages, recordCanvas = options.recordCanvas, keepIframeSrcFn = options.keepIframeSrcFn, _options_newlyAddedElement = options.newlyAddedElement, newlyAddedElement = _options_newlyAddedElement === void 0 ? false : _options_newlyAddedElement, rootId = options.rootId, maskAllText = options.maskAllText, maskTextClass = options.maskTextClass, unmaskTextClass = options.unmaskTextClass, maskTextSelector = options.maskTextSelector, unmaskTextSelector = options.unmaskTextSelector;
    var needBlock = _isBlockedElement(n, blockClass, blockSelector, unblockSelector);
    var tagName = getValidTagName(n);
    var attributes = {};
    var len = n.attributes.length;
    for(var i = 0; i < len; i++){
        var attr = n.attributes[i];
        if (attr.name && !ignoreAttribute(tagName, attr.name, attr.value)) attributes[attr.name] = transformAttribute(doc, tagName, toLowerCase(attr.name), attr.value, n, maskAttributeFn);
    }
    if (tagName === 'link' && inlineStylesheet) {
        var stylesheet = Array.from(doc.styleSheets).find(function(s) {
            return s.href === n.href;
        });
        var cssText = null;
        if (stylesheet) cssText = stringifyStylesheet(stylesheet);
        if (cssText) {
            delete attributes.rel;
            delete attributes.href;
            attributes._cssText = absoluteToStylesheet(cssText, stylesheet.href);
        }
    }
    if (tagName === 'style' && n.sheet && !(n.innerText || n.textContent || '').trim().length) {
        var cssText1 = stringifyStylesheet(n.sheet);
        if (cssText1) attributes._cssText = absoluteToStylesheet(cssText1, getHref());
    }
    if (tagName === 'input' || tagName === 'textarea' || tagName === 'select' || tagName === 'option') {
        var el = n;
        var type = getInputType(el);
        var value = getInputValue(el, toUpperCase(tagName), type);
        var checked = el.checked;
        if (type !== 'submit' && type !== 'button' && value) {
            var forceMask = needMaskingText(el, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, shouldMaskInput({
                type: type,
                tagName: toUpperCase(tagName),
                maskInputOptions: maskInputOptions
            }));
            attributes.value = maskInputValue({
                isMasked: forceMask,
                element: el,
                value: value,
                maskInputFn: maskInputFn
            });
        }
        if (checked) attributes.checked = checked;
    }
    if (tagName === 'option') {
        if (n.selected && !maskInputOptions['select']) attributes.selected = true;
        else delete attributes.selected;
    }
    if (tagName === 'canvas' && recordCanvas) {
        if (n.__context === '2d') {
            if (!is2DCanvasBlank(n)) attributes.rr_dataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
        } else if (!('__context' in n)) {
            var canvasDataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            var blankCanvas = document.createElement('canvas');
            blankCanvas.width = n.width;
            blankCanvas.height = n.height;
            var blankCanvasDataURL = blankCanvas.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            if (canvasDataURL !== blankCanvasDataURL) attributes.rr_dataURL = canvasDataURL;
        }
    }
    if (tagName === 'img' && inlineImages) {
        if (!canvasService) {
            canvasService = doc.createElement('canvas');
            canvasCtx = canvasService.getContext('2d');
        }
        var image = n;
        var oldValue = image.crossOrigin;
        image.crossOrigin = 'anonymous';
        var recordInlineImage = function() {
            image.removeEventListener('load', recordInlineImage);
            try {
                canvasService.width = image.naturalWidth;
                canvasService.height = image.naturalHeight;
                canvasCtx.drawImage(image, 0, 0);
                attributes.rr_dataURL = canvasService.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            } catch (err) {
                console.warn(`Cannot inline img src=${image.currentSrc}! Error: ${err}`);
            }
            oldValue ? attributes.crossOrigin = oldValue : image.removeAttribute('crossorigin');
        };
        if (image.complete && image.naturalWidth !== 0) recordInlineImage();
        else image.addEventListener('load', recordInlineImage);
    }
    if (tagName === 'audio' || tagName === 'video') {
        attributes.rr_mediaState = n.paused ? 'paused' : 'played';
        attributes.rr_mediaCurrentTime = n.currentTime;
    }
    if (!newlyAddedElement) {
        if (n.scrollLeft) attributes.rr_scrollLeft = n.scrollLeft;
        if (n.scrollTop) attributes.rr_scrollTop = n.scrollTop;
    }
    if (needBlock) {
        var _n_getBoundingClientRect = n.getBoundingClientRect(), width = _n_getBoundingClientRect.width, height = _n_getBoundingClientRect.height;
        attributes = {
            class: attributes.class,
            rr_width: `${width}px`,
            rr_height: `${height}px`
        };
    }
    if (tagName === 'iframe' && !keepIframeSrcFn(attributes.src)) {
        if (!n.contentDocument) attributes.rr_src = attributes.src;
        delete attributes.src;
    }
    var isCustomElement;
    try {
        if (customElements.get(tagName)) isCustomElement = true;
    } catch (e) {}
    return {
        type: NodeType$1.Element,
        tagName: tagName,
        attributes: attributes,
        childNodes: [],
        isSVG: isSVGElement(n) || undefined,
        needBlock: needBlock,
        rootId: rootId,
        isCustom: isCustomElement
    };
}
function lowerIfExists(maybeAttr) {
    if (maybeAttr === undefined || maybeAttr === null) return '';
    else return maybeAttr.toLowerCase();
}
function slimDOMExcluded(sn, slimDOMOptions) {
    if (slimDOMOptions.comment && sn.type === NodeType$1.Comment) return true;
    else if (sn.type === NodeType$1.Element) {
        if (slimDOMOptions.script && (sn.tagName === 'script' || sn.tagName === 'link' && (sn.attributes.rel === 'preload' || sn.attributes.rel === 'modulepreload') && sn.attributes.as === 'script' || sn.tagName === 'link' && sn.attributes.rel === 'prefetch' && typeof sn.attributes.href === 'string' && sn.attributes.href.endsWith('.js'))) return true;
        else if (slimDOMOptions.headFavicon && (sn.tagName === 'link' && sn.attributes.rel === 'shortcut icon' || sn.tagName === 'meta' && (lowerIfExists(sn.attributes.name).match(/^msapplication-tile(image|color)$/) || lowerIfExists(sn.attributes.name) === 'application-name' || lowerIfExists(sn.attributes.rel) === 'icon' || lowerIfExists(sn.attributes.rel) === 'apple-touch-icon' || lowerIfExists(sn.attributes.rel) === 'shortcut icon'))) return true;
        else if (sn.tagName === 'meta') {
            if (slimDOMOptions.headMetaDescKeywords && lowerIfExists(sn.attributes.name).match(/^description|keywords$/)) return true;
            else if (slimDOMOptions.headMetaSocial && (lowerIfExists(sn.attributes.property).match(/^(og|twitter|fb):/) || lowerIfExists(sn.attributes.name).match(/^(og|twitter):/) || lowerIfExists(sn.attributes.name) === 'pinterest')) return true;
            else if (slimDOMOptions.headMetaRobots && (lowerIfExists(sn.attributes.name) === 'robots' || lowerIfExists(sn.attributes.name) === 'googlebot' || lowerIfExists(sn.attributes.name) === 'bingbot')) return true;
            else if (slimDOMOptions.headMetaHttpEquiv && sn.attributes['http-equiv'] !== undefined) return true;
            else if (slimDOMOptions.headMetaAuthorship && (lowerIfExists(sn.attributes.name) === 'author' || lowerIfExists(sn.attributes.name) === 'generator' || lowerIfExists(sn.attributes.name) === 'framework' || lowerIfExists(sn.attributes.name) === 'publisher' || lowerIfExists(sn.attributes.name) === 'progid' || lowerIfExists(sn.attributes.property).match(/^article:/) || lowerIfExists(sn.attributes.property).match(/^product:/))) return true;
            else if (slimDOMOptions.headMetaVerification && (lowerIfExists(sn.attributes.name) === 'google-site-verification' || lowerIfExists(sn.attributes.name) === 'yandex-verification' || lowerIfExists(sn.attributes.name) === 'csrf-token' || lowerIfExists(sn.attributes.name) === 'p:domain_verify' || lowerIfExists(sn.attributes.name) === 'verify-v1' || lowerIfExists(sn.attributes.name) === 'verification' || lowerIfExists(sn.attributes.name) === 'shopify-checkout-api-token')) return true;
        }
    }
    return false;
}
function serializeNodeWithId(n, options) {
    var doc = options.doc, mirror = options.mirror, blockClass = options.blockClass, blockSelector = options.blockSelector, unblockSelector = options.unblockSelector, maskAllText = options.maskAllText, maskTextClass = options.maskTextClass, unmaskTextClass = options.unmaskTextClass, maskTextSelector = options.maskTextSelector, unmaskTextSelector = options.unmaskTextSelector, _options_skipChild = options.skipChild, skipChild = _options_skipChild === void 0 ? false : _options_skipChild, _options_inlineStylesheet = options.inlineStylesheet, inlineStylesheet = _options_inlineStylesheet === void 0 ? true : _options_inlineStylesheet, _options_maskInputOptions = options.maskInputOptions, maskInputOptions = _options_maskInputOptions === void 0 ? {} : _options_maskInputOptions, maskAttributeFn = options.maskAttributeFn, maskTextFn = options.maskTextFn, maskInputFn = options.maskInputFn, slimDOMOptions = options.slimDOMOptions, _options_dataURLOptions = options.dataURLOptions, dataURLOptions = _options_dataURLOptions === void 0 ? {} : _options_dataURLOptions, _options_inlineImages = options.inlineImages, inlineImages = _options_inlineImages === void 0 ? false : _options_inlineImages, _options_recordCanvas = options.recordCanvas, recordCanvas = _options_recordCanvas === void 0 ? false : _options_recordCanvas, onSerialize = options.onSerialize, onIframeLoad = options.onIframeLoad, _options_iframeLoadTimeout = options.iframeLoadTimeout, iframeLoadTimeout = _options_iframeLoadTimeout === void 0 ? 5000 : _options_iframeLoadTimeout, onStylesheetLoad = options.onStylesheetLoad, _options_stylesheetLoadTimeout = options.stylesheetLoadTimeout, stylesheetLoadTimeout = _options_stylesheetLoadTimeout === void 0 ? 5000 : _options_stylesheetLoadTimeout, _options_keepIframeSrcFn = options.keepIframeSrcFn, keepIframeSrcFn = _options_keepIframeSrcFn === void 0 ? function() {
        return false;
    } : _options_keepIframeSrcFn, _options_newlyAddedElement = options.newlyAddedElement, newlyAddedElement = _options_newlyAddedElement === void 0 ? false : _options_newlyAddedElement;
    var _options_preserveWhiteSpace = options.preserveWhiteSpace, preserveWhiteSpace = _options_preserveWhiteSpace === void 0 ? true : _options_preserveWhiteSpace;
    var _serializedNode = serializeNode(n, {
        doc: doc,
        mirror: mirror,
        blockClass: blockClass,
        blockSelector: blockSelector,
        maskAllText: maskAllText,
        unblockSelector: unblockSelector,
        maskTextClass: maskTextClass,
        unmaskTextClass: unmaskTextClass,
        maskTextSelector: maskTextSelector,
        unmaskTextSelector: unmaskTextSelector,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskAttributeFn: maskAttributeFn,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: newlyAddedElement
    });
    if (!_serializedNode) {
        console.warn(n, 'not serialized');
        return null;
    }
    var id;
    if (mirror.hasNode(n)) id = mirror.getId(n);
    else if (slimDOMExcluded(_serializedNode, slimDOMOptions) || !preserveWhiteSpace && _serializedNode.type === NodeType$1.Text && !_serializedNode.isStyle && !_serializedNode.textContent.replace(/^\s+|\s+$/gm, '').length) id = IGNORED_NODE;
    else id = genId();
    var serializedNode = Object.assign(_serializedNode, {
        id: id
    });
    mirror.add(n, serializedNode);
    if (id === IGNORED_NODE) return null;
    if (onSerialize) onSerialize(n);
    var recordChild = !skipChild;
    if (serializedNode.type === NodeType$1.Element) {
        recordChild = recordChild && !serializedNode.needBlock;
        delete serializedNode.needBlock;
        var shadowRoot = n.shadowRoot;
        if (shadowRoot && isNativeShadowDom(shadowRoot)) serializedNode.isShadowHost = true;
    }
    if ((serializedNode.type === NodeType$1.Document || serializedNode.type === NodeType$1.Element) && recordChild) {
        if (slimDOMOptions.headWhitespace && serializedNode.type === NodeType$1.Element && serializedNode.tagName === 'head') preserveWhiteSpace = false;
        var bypassOptions = {
            doc: doc,
            mirror: mirror,
            blockClass: blockClass,
            blockSelector: blockSelector,
            maskAllText: maskAllText,
            unblockSelector: unblockSelector,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            skipChild: skipChild,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            maskAttributeFn: maskAttributeFn,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            slimDOMOptions: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            inlineImages: inlineImages,
            recordCanvas: recordCanvas,
            preserveWhiteSpace: preserveWhiteSpace,
            onSerialize: onSerialize,
            onIframeLoad: onIframeLoad,
            iframeLoadTimeout: iframeLoadTimeout,
            onStylesheetLoad: onStylesheetLoad,
            stylesheetLoadTimeout: stylesheetLoadTimeout,
            keepIframeSrcFn: keepIframeSrcFn
        };
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = Array.from(n.childNodes)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var childN = _step.value;
                var serializedChildNode = serializeNodeWithId(childN, bypassOptions);
                if (serializedChildNode) serializedNode.childNodes.push(serializedChildNode);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        if (isElement$1(n) && n.shadowRoot) try {
            for(var _iterator1 = Array.from(n.shadowRoot.childNodes)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var childN1 = _step1.value;
                var serializedChildNode1 = serializeNodeWithId(childN1, bypassOptions);
                if (serializedChildNode1) {
                    isNativeShadowDom(n.shadowRoot) && (serializedChildNode1.isShadow = true);
                    serializedNode.childNodes.push(serializedChildNode1);
                }
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    }
    if (n.parentNode && isShadowRoot(n.parentNode) && isNativeShadowDom(n.parentNode)) serializedNode.isShadow = true;
    if (serializedNode.type === NodeType$1.Element && serializedNode.tagName === 'iframe') onceIframeLoaded(n, function() {
        var iframeDoc = n.contentDocument;
        if (iframeDoc && onIframeLoad) {
            var serializedIframeNode = serializeNodeWithId(iframeDoc, {
                doc: iframeDoc,
                mirror: mirror,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskAttributeFn: maskAttributeFn,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn
            });
            if (serializedIframeNode) onIframeLoad(n, serializedIframeNode);
        }
    }, iframeLoadTimeout);
    if (serializedNode.type === NodeType$1.Element && serializedNode.tagName === 'link' && serializedNode.attributes.rel === 'stylesheet') onceStylesheetLoaded(n, function() {
        if (onStylesheetLoad) {
            var serializedLinkNode = serializeNodeWithId(n, {
                doc: doc,
                mirror: mirror,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskAttributeFn: maskAttributeFn,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn
            });
            if (serializedLinkNode) onStylesheetLoad(n, serializedLinkNode);
        }
    }, stylesheetLoadTimeout);
    return serializedNode;
}
function snapshot(n, options) {
    var _ref = options || {}, _ref_mirror = _ref.mirror, mirror = _ref_mirror === void 0 ? new Mirror() : _ref_mirror, _ref_blockClass = _ref.blockClass, blockClass = _ref_blockClass === void 0 ? 'rr-block' : _ref_blockClass, _ref_blockSelector = _ref.blockSelector, blockSelector = _ref_blockSelector === void 0 ? null : _ref_blockSelector, _ref_unblockSelector = _ref.unblockSelector, unblockSelector = _ref_unblockSelector === void 0 ? null : _ref_unblockSelector, _ref_maskAllText = _ref.maskAllText, maskAllText = _ref_maskAllText === void 0 ? false : _ref_maskAllText, _ref_maskTextClass = _ref.maskTextClass, maskTextClass = _ref_maskTextClass === void 0 ? 'rr-mask' : _ref_maskTextClass, _ref_unmaskTextClass = _ref.unmaskTextClass, unmaskTextClass = _ref_unmaskTextClass === void 0 ? null : _ref_unmaskTextClass, _ref_maskTextSelector = _ref.maskTextSelector, maskTextSelector = _ref_maskTextSelector === void 0 ? null : _ref_maskTextSelector, _ref_unmaskTextSelector = _ref.unmaskTextSelector, unmaskTextSelector = _ref_unmaskTextSelector === void 0 ? null : _ref_unmaskTextSelector, _ref_inlineStylesheet = _ref.inlineStylesheet, inlineStylesheet = _ref_inlineStylesheet === void 0 ? true : _ref_inlineStylesheet, _ref_inlineImages = _ref.inlineImages, inlineImages = _ref_inlineImages === void 0 ? false : _ref_inlineImages, _ref_recordCanvas = _ref.recordCanvas, recordCanvas = _ref_recordCanvas === void 0 ? false : _ref_recordCanvas, _ref_maskAllInputs = _ref.maskAllInputs, maskAllInputs = _ref_maskAllInputs === void 0 ? false : _ref_maskAllInputs, maskAttributeFn = _ref.maskAttributeFn, maskTextFn = _ref.maskTextFn, maskInputFn = _ref.maskInputFn, _ref_slimDOM = _ref.slimDOM, slimDOM = _ref_slimDOM === void 0 ? false : _ref_slimDOM, dataURLOptions = _ref.dataURLOptions, preserveWhiteSpace = _ref.preserveWhiteSpace, onSerialize = _ref.onSerialize, onIframeLoad = _ref.onIframeLoad, iframeLoadTimeout = _ref.iframeLoadTimeout, onStylesheetLoad = _ref.onStylesheetLoad, stylesheetLoadTimeout = _ref.stylesheetLoadTimeout, _ref_keepIframeSrcFn = _ref.keepIframeSrcFn, keepIframeSrcFn = _ref_keepIframeSrcFn === void 0 ? function() {
        return false;
    } : _ref_keepIframeSrcFn;
    var maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        'datetime-local': true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true
    } : maskAllInputs === false ? {} : maskAllInputs;
    var slimDOMOptions = slimDOM === true || slimDOM === 'all' ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaDescKeywords: slimDOM === 'all',
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaAuthorship: true,
        headMetaVerification: true
    } : slimDOM === false ? {} : slimDOM;
    return serializeNodeWithId(n, {
        doc: n,
        mirror: mirror,
        blockClass: blockClass,
        blockSelector: blockSelector,
        unblockSelector: unblockSelector,
        maskAllText: maskAllText,
        maskTextClass: maskTextClass,
        unmaskTextClass: unmaskTextClass,
        maskTextSelector: maskTextSelector,
        unmaskTextSelector: unmaskTextSelector,
        skipChild: false,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskAttributeFn: maskAttributeFn,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        slimDOMOptions: slimDOMOptions,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        preserveWhiteSpace: preserveWhiteSpace,
        onSerialize: onSerialize,
        onIframeLoad: onIframeLoad,
        iframeLoadTimeout: iframeLoadTimeout,
        onStylesheetLoad: onStylesheetLoad,
        stylesheetLoadTimeout: stylesheetLoadTimeout,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: false
    });
}
function _optionalChain$4(ops) {
    var lastAccessLHS = undefined;
    var value = ops[0];
    var i = 1;
    while(i < ops.length){
        var op = ops[i];
        var fn = ops[i + 1];
        i += 2;
        if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) return undefined;
        if (op === 'access' || op === 'optionalAccess') {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === 'call' || op === 'optionalCall') {
            var _value;
            value = fn(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return (_value = value).call.apply(_value, [
                    lastAccessLHS
                ].concat((0, _toConsumableArray._)(args)));
            });
            lastAccessLHS = undefined;
        }
    }
    return value;
}
function on(type, fn) {
    var target = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : document;
    var options = {
        capture: true,
        passive: true
    };
    target.addEventListener(type, fn, options);
    return function() {
        return target.removeEventListener(type, fn, options);
    };
}
var DEPARTED_MIRROR_ACCESS_WARNING = "Please stop import mirror directly. Instead of that,\r\nnow you can use replayer.getMirror() to access the mirror instance of a replayer,\r\nor you can use record.mirror to access the mirror instance during recording.";
var _mirror = {
    map: {},
    getId: function() {
        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
        return -1;
    },
    getNode: function() {
        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
        return null;
    },
    removeNodeFromMap: function() {
        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
    },
    has: function() {
        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
        return false;
    },
    reset: function() {
        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
    }
};
if (typeof window !== 'undefined' && window.Proxy && window.Reflect) _mirror = new Proxy(_mirror, {
    get: function(target, prop, receiver) {
        if (prop === 'map') console.error(DEPARTED_MIRROR_ACCESS_WARNING);
        return Reflect.get(target, prop, receiver);
    }
});
function throttle$1(func, wait) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var timeout = null;
    var previous = 0;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var now = Date.now();
        if (!previous && options.leading === false) previous = now;
        var remaining = wait - (now - previous);
        var context = this;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout$1(timeout);
                timeout = null;
            }
            previous = now;
            func.apply(context, args);
        } else if (!timeout && options.trailing !== false) timeout = setTimeout$1(function() {
            previous = options.leading === false ? 0 : Date.now();
            timeout = null;
            func.apply(context, args);
        }, remaining);
    };
}
function hookSetter(target, key, d, isRevoked) {
    var win = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : window;
    var original = win.Object.getOwnPropertyDescriptor(target, key);
    win.Object.defineProperty(target, key, isRevoked ? d : {
        set: function(value) {
            var _this = this;
            setTimeout$1(function() {
                d.set.call(_this, value);
            }, 0);
            if (original && original.set) original.set.call(this, value);
        }
    });
    return function() {
        return hookSetter(target, key, original || {}, true);
    };
}
function patch(source, name, replacement) {
    try {
        if (!(name in source)) return function() {};
        var original = source[name];
        var wrapped = replacement(original);
        if (typeof wrapped === 'function') {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __rrweb_original__: {
                    enumerable: false,
                    value: original
                }
            });
        }
        source[name] = wrapped;
        return function() {
            source[name] = original;
        };
    } catch (e2) {
        return function() {};
    }
}
var nowTimestamp = Date.now;
if (!/[1-9][0-9]{12}/.test(Date.now().toString())) nowTimestamp = function() {
    return new Date().getTime();
};
function getWindowScroll(win) {
    var doc = win.document;
    return {
        left: doc.scrollingElement ? doc.scrollingElement.scrollLeft : win.pageXOffset !== undefined ? win.pageXOffset : _optionalChain$4([
            doc,
            'optionalAccess',
            function(_) {
                return _.documentElement;
            },
            'access',
            function(_2) {
                return _2.scrollLeft;
            }
        ]) || _optionalChain$4([
            doc,
            'optionalAccess',
            function(_3) {
                return _3.body;
            },
            'optionalAccess',
            function(_4) {
                return _4.parentElement;
            },
            'optionalAccess',
            function(_5) {
                return _5.scrollLeft;
            }
        ]) || _optionalChain$4([
            doc,
            'optionalAccess',
            function(_6) {
                return _6.body;
            },
            'optionalAccess',
            function(_7) {
                return _7.scrollLeft;
            }
        ]) || 0,
        top: doc.scrollingElement ? doc.scrollingElement.scrollTop : win.pageYOffset !== undefined ? win.pageYOffset : _optionalChain$4([
            doc,
            'optionalAccess',
            function(_8) {
                return _8.documentElement;
            },
            'access',
            function(_9) {
                return _9.scrollTop;
            }
        ]) || _optionalChain$4([
            doc,
            'optionalAccess',
            function(_10) {
                return _10.body;
            },
            'optionalAccess',
            function(_11) {
                return _11.parentElement;
            },
            'optionalAccess',
            function(_12) {
                return _12.scrollTop;
            }
        ]) || _optionalChain$4([
            doc,
            'optionalAccess',
            function(_13) {
                return _13.body;
            },
            'optionalAccess',
            function(_14) {
                return _14.scrollTop;
            }
        ]) || 0
    };
}
function getWindowHeight() {
    return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
}
function getWindowWidth() {
    return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
}
function closestElementOfNode(node) {
    if (!node) return null;
    var el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
    return el;
}
function isBlocked(node, blockClass, blockSelector, unblockSelector, checkAncestors) {
    if (!node) return false;
    var el = closestElementOfNode(node);
    if (!el) return false;
    var blockedPredicate = createMatchPredicate(blockClass, blockSelector);
    if (!checkAncestors) {
        var isUnblocked = unblockSelector && el.matches(unblockSelector);
        return blockedPredicate(el) && !isUnblocked;
    }
    var blockDistance = distanceToMatch(el, blockedPredicate);
    var unblockDistance = -1;
    if (blockDistance < 0) return false;
    if (unblockSelector) unblockDistance = distanceToMatch(el, createMatchPredicate(null, unblockSelector));
    if (blockDistance > -1 && unblockDistance < 0) return true;
    return blockDistance < unblockDistance;
}
function isSerialized(n, mirror) {
    return mirror.getId(n) !== -1;
}
function isIgnored(n, mirror) {
    return mirror.getId(n) === IGNORED_NODE;
}
function isAncestorRemoved(target, mirror) {
    if (isShadowRoot(target)) return false;
    var id = mirror.getId(target);
    if (!mirror.has(id)) return true;
    if (target.parentNode && target.parentNode.nodeType === target.DOCUMENT_NODE) return false;
    if (!target.parentNode) return true;
    return isAncestorRemoved(target.parentNode, mirror);
}
function legacy_isTouchEvent(event) {
    return Boolean(event.changedTouches);
}
function polyfill() {
    var win = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window;
    var _this = this;
    if ('NodeList' in win && !win.NodeList.prototype.forEach) win.NodeList.prototype.forEach = Array.prototype.forEach;
    if ('DOMTokenList' in win && !win.DOMTokenList.prototype.forEach) win.DOMTokenList.prototype.forEach = Array.prototype.forEach;
    if (!Node.prototype.contains) Node.prototype.contains = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var node = args[0];
        if (!(0 in args)) throw new TypeError('1 argument is required');
        do {
            if (_this === node) return true;
        }while (node = node && node.parentNode);
        return false;
    };
}
function isSerializedIframe(n, mirror) {
    return Boolean(n.nodeName === 'IFRAME' && mirror.getMeta(n));
}
function isSerializedStylesheet(n, mirror) {
    return Boolean(n.nodeName === 'LINK' && n.nodeType === n.ELEMENT_NODE && n.getAttribute && n.getAttribute('rel') === 'stylesheet' && mirror.getMeta(n));
}
function hasShadowRoot(n) {
    return Boolean(_optionalChain$4([
        n,
        'optionalAccess',
        function(_18) {
            return _18.shadowRoot;
        }
    ]));
}
var StyleSheetMirror = /*#__PURE__*/ function() {
    "use strict";
    function StyleSheetMirror() {
        (0, _classCallCheck._)(this, StyleSheetMirror);
        this.id = 1;
        this.styleIDMap = new WeakMap();
        this.idStyleMap = new Map();
    }
    (0, _createClass._)(StyleSheetMirror, [
        {
            key: "getId",
            value: function getId(stylesheet) {
                return (0, _utils._nullishCoalesce)(this.styleIDMap.get(stylesheet), function() {
                    return -1;
                });
            }
        },
        {
            key: "has",
            value: function has(stylesheet) {
                return this.styleIDMap.has(stylesheet);
            }
        },
        {
            key: "add",
            value: function add(stylesheet, id) {
                if (this.has(stylesheet)) return this.getId(stylesheet);
                var newId;
                if (id === undefined) newId = this.id++;
                else newId = id;
                this.styleIDMap.set(stylesheet, newId);
                this.idStyleMap.set(newId, stylesheet);
                return newId;
            }
        },
        {
            key: "getStyle",
            value: function getStyle(id) {
                return this.idStyleMap.get(id) || null;
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.styleIDMap = new WeakMap();
                this.idStyleMap = new Map();
                this.id = 1;
            }
        },
        {
            key: "generateId",
            value: function generateId() {
                return this.id++;
            }
        }
    ]);
    return StyleSheetMirror;
}();
function getShadowHost(n) {
    var shadowHost = null;
    if (_optionalChain$4([
        n,
        'access',
        function(_19) {
            return _19.getRootNode;
        },
        'optionalCall',
        function(_20) {
            return _20();
        },
        'optionalAccess',
        function(_21) {
            return _21.nodeType;
        }
    ]) === Node.DOCUMENT_FRAGMENT_NODE && n.getRootNode().host) shadowHost = n.getRootNode().host;
    return shadowHost;
}
function getRootShadowHost(n) {
    var rootShadowHost = n;
    var shadowHost;
    while(shadowHost = getShadowHost(rootShadowHost))rootShadowHost = shadowHost;
    return rootShadowHost;
}
function shadowHostInDom(n) {
    var doc = n.ownerDocument;
    if (!doc) return false;
    var shadowHost = getRootShadowHost(n);
    return doc.contains(shadowHost);
}
function inDom(n) {
    var doc = n.ownerDocument;
    if (!doc) return false;
    return doc.contains(n) || shadowHostInDom(n);
}
var cachedImplementations = {};
function getImplementation(name) {
    var cached = cachedImplementations[name];
    if (cached) return cached;
    var document1 = window.document;
    var impl = window[name];
    if (document1 && typeof document1.createElement === 'function') try {
        var sandbox = document1.createElement('iframe');
        sandbox.hidden = true;
        document1.head.appendChild(sandbox);
        var contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow[name]) impl = contentWindow[name];
        document1.head.removeChild(sandbox);
    } catch (e) {}
    return cachedImplementations[name] = impl.bind(window);
}
function onRequestAnimationFrame() {
    for(var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++){
        rest[_key] = arguments[_key];
    }
    return getImplementation('requestAnimationFrame').apply(this, (0, _toConsumableArray._)(rest));
}
function setTimeout$1() {
    for(var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++){
        rest[_key] = arguments[_key];
    }
    return getImplementation('setTimeout').apply(this, (0, _toConsumableArray._)(rest));
}
function clearTimeout$1() {
    for(var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++){
        rest[_key] = arguments[_key];
    }
    return getImplementation('clearTimeout').apply(this, (0, _toConsumableArray._)(rest));
}
var EventType = /* @__PURE__ */ function(EventType2) {
    EventType2[EventType2["DomContentLoaded"] = 0] = "DomContentLoaded";
    EventType2[EventType2["Load"] = 1] = "Load";
    EventType2[EventType2["FullSnapshot"] = 2] = "FullSnapshot";
    EventType2[EventType2["IncrementalSnapshot"] = 3] = "IncrementalSnapshot";
    EventType2[EventType2["Meta"] = 4] = "Meta";
    EventType2[EventType2["Custom"] = 5] = "Custom";
    EventType2[EventType2["Plugin"] = 6] = "Plugin";
    return EventType2;
}(EventType || {});
var IncrementalSource = /* @__PURE__ */ function(IncrementalSource2) {
    IncrementalSource2[IncrementalSource2["Mutation"] = 0] = "Mutation";
    IncrementalSource2[IncrementalSource2["MouseMove"] = 1] = "MouseMove";
    IncrementalSource2[IncrementalSource2["MouseInteraction"] = 2] = "MouseInteraction";
    IncrementalSource2[IncrementalSource2["Scroll"] = 3] = "Scroll";
    IncrementalSource2[IncrementalSource2["ViewportResize"] = 4] = "ViewportResize";
    IncrementalSource2[IncrementalSource2["Input"] = 5] = "Input";
    IncrementalSource2[IncrementalSource2["TouchMove"] = 6] = "TouchMove";
    IncrementalSource2[IncrementalSource2["MediaInteraction"] = 7] = "MediaInteraction";
    IncrementalSource2[IncrementalSource2["StyleSheetRule"] = 8] = "StyleSheetRule";
    IncrementalSource2[IncrementalSource2["CanvasMutation"] = 9] = "CanvasMutation";
    IncrementalSource2[IncrementalSource2["Font"] = 10] = "Font";
    IncrementalSource2[IncrementalSource2["Log"] = 11] = "Log";
    IncrementalSource2[IncrementalSource2["Drag"] = 12] = "Drag";
    IncrementalSource2[IncrementalSource2["StyleDeclaration"] = 13] = "StyleDeclaration";
    IncrementalSource2[IncrementalSource2["Selection"] = 14] = "Selection";
    IncrementalSource2[IncrementalSource2["AdoptedStyleSheet"] = 15] = "AdoptedStyleSheet";
    IncrementalSource2[IncrementalSource2["CustomElement"] = 16] = "CustomElement";
    return IncrementalSource2;
}(IncrementalSource || {});
var MouseInteractions = /* @__PURE__ */ function(MouseInteractions2) {
    MouseInteractions2[MouseInteractions2["MouseUp"] = 0] = "MouseUp";
    MouseInteractions2[MouseInteractions2["MouseDown"] = 1] = "MouseDown";
    MouseInteractions2[MouseInteractions2["Click"] = 2] = "Click";
    MouseInteractions2[MouseInteractions2["ContextMenu"] = 3] = "ContextMenu";
    MouseInteractions2[MouseInteractions2["DblClick"] = 4] = "DblClick";
    MouseInteractions2[MouseInteractions2["Focus"] = 5] = "Focus";
    MouseInteractions2[MouseInteractions2["Blur"] = 6] = "Blur";
    MouseInteractions2[MouseInteractions2["TouchStart"] = 7] = "TouchStart";
    MouseInteractions2[MouseInteractions2["TouchMove_Departed"] = 8] = "TouchMove_Departed";
    MouseInteractions2[MouseInteractions2["TouchEnd"] = 9] = "TouchEnd";
    MouseInteractions2[MouseInteractions2["TouchCancel"] = 10] = "TouchCancel";
    return MouseInteractions2;
}(MouseInteractions || {});
var PointerTypes = /* @__PURE__ */ function(PointerTypes2) {
    PointerTypes2[PointerTypes2["Mouse"] = 0] = "Mouse";
    PointerTypes2[PointerTypes2["Pen"] = 1] = "Pen";
    PointerTypes2[PointerTypes2["Touch"] = 2] = "Touch";
    return PointerTypes2;
}(PointerTypes || {});
function _optionalChain$3(ops) {
    var lastAccessLHS = undefined;
    var value = ops[0];
    var i = 1;
    while(i < ops.length){
        var op = ops[i];
        var fn = ops[i + 1];
        i += 2;
        if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) return undefined;
        if (op === 'access' || op === 'optionalAccess') {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === 'call' || op === 'optionalCall') {
            var _value;
            value = fn(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return (_value = value).call.apply(_value, [
                    lastAccessLHS
                ].concat((0, _toConsumableArray._)(args)));
            });
            lastAccessLHS = undefined;
        }
    }
    return value;
}
function isNodeInLinkedList(n) {
    return '__ln' in n;
}
var DoubleLinkedList = /*#__PURE__*/ function() {
    "use strict";
    function DoubleLinkedList() {
        (0, _classCallCheck._)(this, DoubleLinkedList);
        this.length = 0;
        this.head = null;
        this.tail = null;
    }
    (0, _createClass._)(DoubleLinkedList, [
        {
            key: "get",
            value: function get(position) {
                if (position >= this.length) throw new Error('Position outside of list range');
                var current = this.head;
                for(var index = 0; index < position; index++)current = _optionalChain$3([
                    current,
                    'optionalAccess',
                    function(_) {
                        return _.next;
                    }
                ]) || null;
                return current;
            }
        },
        {
            key: "addNode",
            value: function addNode(n) {
                var node = {
                    value: n,
                    previous: null,
                    next: null
                };
                n.__ln = node;
                if (n.previousSibling && isNodeInLinkedList(n.previousSibling)) {
                    var current = n.previousSibling.__ln.next;
                    node.next = current;
                    node.previous = n.previousSibling.__ln;
                    n.previousSibling.__ln.next = node;
                    if (current) current.previous = node;
                } else if (n.nextSibling && isNodeInLinkedList(n.nextSibling) && n.nextSibling.__ln.previous) {
                    var current1 = n.nextSibling.__ln.previous;
                    node.previous = current1;
                    node.next = n.nextSibling.__ln;
                    n.nextSibling.__ln.previous = node;
                    if (current1) current1.next = node;
                } else {
                    if (this.head) this.head.previous = node;
                    node.next = this.head;
                    this.head = node;
                }
                if (node.next === null) this.tail = node;
                this.length++;
            }
        },
        {
            key: "removeNode",
            value: function removeNode(n) {
                var current = n.__ln;
                if (!this.head) return;
                if (!current.previous) {
                    this.head = current.next;
                    if (this.head) this.head.previous = null;
                    else this.tail = null;
                } else {
                    current.previous.next = current.next;
                    if (current.next) current.next.previous = current.previous;
                    else this.tail = current.previous;
                }
                if (n.__ln) delete n.__ln;
                this.length--;
            }
        }
    ]);
    return DoubleLinkedList;
}();
var moveKey = function(id, parentId) {
    return `${id}@${parentId}`;
};
var MutationBuffer = /*#__PURE__*/ function() {
    "use strict";
    function MutationBuffer() {
        var _this = this;
        (0, _classCallCheck._)(this, MutationBuffer);
        this.frozen = false;
        this.locked = false;
        this.texts = [];
        this.attributes = [];
        this.attributeMap = new WeakMap();
        this.removes = [];
        this.mapRemoves = [];
        this.movedMap = {};
        this.addedSet = new Set();
        this.movedSet = new Set();
        this.droppedSet = new Set();
        this.processMutations = function(mutations) {
            mutations.forEach(_this.processMutation);
            _this.emit();
        };
        this.emit = function() {
            if (_this.frozen || _this.locked) return;
            var adds = [];
            var addedIds = new Set();
            var addList = new DoubleLinkedList();
            var getNextId = function(n) {
                var ns = n;
                var nextId = IGNORED_NODE;
                while(nextId === IGNORED_NODE){
                    ns = ns && ns.nextSibling;
                    nextId = ns && _this.mirror.getId(ns);
                }
                return nextId;
            };
            var pushAdd = function(n) {
                if (!n.parentNode || !inDom(n)) return;
                var parentId = isShadowRoot(n.parentNode) ? _this.mirror.getId(getShadowHost(n)) : _this.mirror.getId(n.parentNode);
                var nextId = getNextId(n);
                if (parentId === -1 || nextId === -1) return addList.addNode(n);
                var sn = serializeNodeWithId(n, {
                    doc: _this.doc,
                    mirror: _this.mirror,
                    blockClass: _this.blockClass,
                    blockSelector: _this.blockSelector,
                    maskAllText: _this.maskAllText,
                    unblockSelector: _this.unblockSelector,
                    maskTextClass: _this.maskTextClass,
                    unmaskTextClass: _this.unmaskTextClass,
                    maskTextSelector: _this.maskTextSelector,
                    unmaskTextSelector: _this.unmaskTextSelector,
                    skipChild: true,
                    newlyAddedElement: true,
                    inlineStylesheet: _this.inlineStylesheet,
                    maskInputOptions: _this.maskInputOptions,
                    maskAttributeFn: _this.maskAttributeFn,
                    maskTextFn: _this.maskTextFn,
                    maskInputFn: _this.maskInputFn,
                    slimDOMOptions: _this.slimDOMOptions,
                    dataURLOptions: _this.dataURLOptions,
                    recordCanvas: _this.recordCanvas,
                    inlineImages: _this.inlineImages,
                    onSerialize: function(currentN) {
                        if (isSerializedIframe(currentN, _this.mirror)) _this.iframeManager.addIframe(currentN);
                        if (isSerializedStylesheet(currentN, _this.mirror)) _this.stylesheetManager.trackLinkElement(currentN);
                        if (hasShadowRoot(n)) _this.shadowDomManager.addShadowRoot(n.shadowRoot, _this.doc);
                    },
                    onIframeLoad: function(iframe, childSn) {
                        _this.iframeManager.attachIframe(iframe, childSn);
                        _this.shadowDomManager.observeAttachShadow(iframe);
                    },
                    onStylesheetLoad: function(link, childSn) {
                        _this.stylesheetManager.attachLinkElement(link, childSn);
                    }
                });
                if (sn) {
                    adds.push({
                        parentId: parentId,
                        nextId: nextId,
                        node: sn
                    });
                    addedIds.add(sn.id);
                }
            };
            while(_this.mapRemoves.length)_this.mirror.removeNodeFromMap(_this.mapRemoves.shift());
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = _this.movedSet[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var n = _step.value;
                    if (isParentRemoved(_this.removes, n, _this.mirror) && !_this.movedSet.has(n.parentNode)) continue;
                    pushAdd(n);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = _this.addedSet[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var n1 = _step1.value;
                    if (!isAncestorInSet(_this.droppedSet, n1) && !isParentRemoved(_this.removes, n1, _this.mirror)) pushAdd(n1);
                    else if (isAncestorInSet(_this.movedSet, n1)) pushAdd(n1);
                    else _this.droppedSet.add(n1);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            var candidate = null;
            while(addList.length){
                var node = null;
                if (candidate) {
                    var parentId = _this.mirror.getId(candidate.value.parentNode);
                    var nextId = getNextId(candidate.value);
                    if (parentId !== -1 && nextId !== -1) node = candidate;
                }
                if (!node) {
                    var tailNode = addList.tail;
                    while(tailNode){
                        var _node = tailNode;
                        tailNode = tailNode.previous;
                        if (_node) {
                            var parentId1 = _this.mirror.getId(_node.value.parentNode);
                            var nextId1 = getNextId(_node.value);
                            if (nextId1 === -1) continue;
                            else if (parentId1 !== -1) {
                                node = _node;
                                break;
                            } else {
                                var unhandledNode = _node.value;
                                if (unhandledNode.parentNode && unhandledNode.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                                    var shadowHost = unhandledNode.parentNode.host;
                                    var parentId2 = _this.mirror.getId(shadowHost);
                                    if (parentId2 !== -1) {
                                        node = _node;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
                if (!node) {
                    while(addList.head)addList.removeNode(addList.head.value);
                    break;
                }
                candidate = node.previous;
                addList.removeNode(node.value);
                pushAdd(node.value);
            }
            var payload = {
                texts: _this.texts.map(function(text) {
                    return {
                        id: _this.mirror.getId(text.node),
                        value: text.value
                    };
                }).filter(function(text) {
                    return !addedIds.has(text.id);
                }).filter(function(text) {
                    return _this.mirror.has(text.id);
                }),
                attributes: _this.attributes.map(function(attribute) {
                    var attributes = attribute.attributes;
                    if (typeof attributes.style === 'string') {
                        var diffAsStr = JSON.stringify(attribute.styleDiff);
                        var unchangedAsStr = JSON.stringify(attribute._unchangedStyles);
                        if (diffAsStr.length < attributes.style.length) {
                            if ((diffAsStr + unchangedAsStr).split('var(').length === attributes.style.split('var(').length) attributes.style = attribute.styleDiff;
                        }
                    }
                    return {
                        id: _this.mirror.getId(attribute.node),
                        attributes: attributes
                    };
                }).filter(function(attribute) {
                    return !addedIds.has(attribute.id);
                }).filter(function(attribute) {
                    return _this.mirror.has(attribute.id);
                }),
                removes: _this.removes,
                adds: adds
            };
            if (!payload.texts.length && !payload.attributes.length && !payload.removes.length && !payload.adds.length) return;
            _this.texts = [];
            _this.attributes = [];
            _this.attributeMap = new WeakMap();
            _this.removes = [];
            _this.addedSet = new Set();
            _this.movedSet = new Set();
            _this.droppedSet = new Set();
            _this.movedMap = {};
            _this.mutationCb(payload);
        };
        this.processMutation = function(m) {
            if (isIgnored(m.target, _this.mirror)) return;
            switch(m.type){
                case 'characterData':
                    {
                        var value = m.target.textContent;
                        if (!isBlocked(m.target, _this.blockClass, _this.blockSelector, _this.unblockSelector, false) && value !== m.oldValue) _this.texts.push({
                            value: needMaskingText(m.target, _this.maskTextClass, _this.maskTextSelector, _this.unmaskTextClass, _this.unmaskTextSelector, _this.maskAllText) && value ? _this.maskTextFn ? _this.maskTextFn(value, closestElementOfNode(m.target)) : value.replace(/[\S]/g, '*') : value,
                            node: m.target
                        });
                        break;
                    }
                case 'attributes':
                    {
                        var target = m.target;
                        var attributeName = m.attributeName;
                        var value1 = m.target.getAttribute(attributeName);
                        if (attributeName === 'value') {
                            var type = getInputType(target);
                            var tagName = target.tagName;
                            value1 = getInputValue(target, tagName, type);
                            var isInputMasked = shouldMaskInput({
                                maskInputOptions: _this.maskInputOptions,
                                tagName: tagName,
                                type: type
                            });
                            var forceMask = needMaskingText(m.target, _this.maskTextClass, _this.maskTextSelector, _this.unmaskTextClass, _this.unmaskTextSelector, isInputMasked);
                            value1 = maskInputValue({
                                isMasked: forceMask,
                                element: target,
                                value: value1,
                                maskInputFn: _this.maskInputFn
                            });
                        }
                        if (isBlocked(m.target, _this.blockClass, _this.blockSelector, _this.unblockSelector, false) || value1 === m.oldValue) return;
                        var item = _this.attributeMap.get(m.target);
                        if (target.tagName === 'IFRAME' && attributeName === 'src' && !_this.keepIframeSrcFn(value1)) {
                            if (!target.contentDocument) attributeName = 'rr_src';
                            else return;
                        }
                        if (!item) {
                            item = {
                                node: m.target,
                                attributes: {},
                                styleDiff: {},
                                _unchangedStyles: {}
                            };
                            _this.attributes.push(item);
                            _this.attributeMap.set(m.target, item);
                        }
                        if (attributeName === 'type' && target.tagName === 'INPUT' && (m.oldValue || '').toLowerCase() === 'password') target.setAttribute('data-rr-is-password', 'true');
                        if (!ignoreAttribute(target.tagName, attributeName)) {
                            item.attributes[attributeName] = transformAttribute(_this.doc, toLowerCase(target.tagName), toLowerCase(attributeName), value1, target, _this.maskAttributeFn);
                            if (attributeName === 'style') {
                                if (!_this.unattachedDoc) try {
                                    _this.unattachedDoc = document.implementation.createHTMLDocument();
                                } catch (e) {
                                    _this.unattachedDoc = _this.doc;
                                }
                                var old = _this.unattachedDoc.createElement('span');
                                if (m.oldValue) old.setAttribute('style', m.oldValue);
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = Array.from(target.style)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var pname = _step.value;
                                        var newValue = target.style.getPropertyValue(pname);
                                        var newPriority = target.style.getPropertyPriority(pname);
                                        if (newValue !== old.style.getPropertyValue(pname) || newPriority !== old.style.getPropertyPriority(pname)) {
                                            if (newPriority === '') item.styleDiff[pname] = newValue;
                                            else item.styleDiff[pname] = [
                                                newValue,
                                                newPriority
                                            ];
                                        } else item._unchangedStyles[pname] = [
                                            newValue,
                                            newPriority
                                        ];
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                try {
                                    for(var _iterator1 = Array.from(old.style)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                        var pname1 = _step1.value;
                                        if (target.style.getPropertyValue(pname1) === '') item.styleDiff[pname1] = false;
                                    }
                                } catch (err) {
                                    _didIteratorError1 = true;
                                    _iteratorError1 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                            _iterator1.return();
                                        }
                                    } finally{
                                        if (_didIteratorError1) {
                                            throw _iteratorError1;
                                        }
                                    }
                                }
                            }
                        }
                        break;
                    }
                case 'childList':
                    if (isBlocked(m.target, _this.blockClass, _this.blockSelector, _this.unblockSelector, true)) return;
                    m.addedNodes.forEach(function(n) {
                        return _this.genAdds(n, m.target);
                    });
                    m.removedNodes.forEach(function(n) {
                        var nodeId = _this.mirror.getId(n);
                        var parentId = isShadowRoot(m.target) ? _this.mirror.getId(m.target.host) : _this.mirror.getId(m.target);
                        if (isBlocked(m.target, _this.blockClass, _this.blockSelector, _this.unblockSelector, false) || isIgnored(n, _this.mirror) || !isSerialized(n, _this.mirror)) return;
                        if (_this.addedSet.has(n)) {
                            deepDelete(_this.addedSet, n);
                            _this.droppedSet.add(n);
                        } else if (_this.addedSet.has(m.target) && nodeId === -1) ;
                        else if (isAncestorRemoved(m.target, _this.mirror)) ;
                        else if (_this.movedSet.has(n) && _this.movedMap[moveKey(nodeId, parentId)]) deepDelete(_this.movedSet, n);
                        else _this.removes.push({
                            parentId: parentId,
                            id: nodeId,
                            isShadow: isShadowRoot(m.target) && isNativeShadowDom(m.target) ? true : undefined
                        });
                        _this.mapRemoves.push(n);
                    });
                    break;
            }
        };
        this.genAdds = function(n, target) {
            if (_this.processedNodeManager.inOtherBuffer(n, _this)) return;
            if (_this.addedSet.has(n) || _this.movedSet.has(n)) return;
            if (_this.mirror.hasNode(n)) {
                if (isIgnored(n, _this.mirror)) return;
                _this.movedSet.add(n);
                var targetId = null;
                if (target && _this.mirror.hasNode(target)) targetId = _this.mirror.getId(target);
                if (targetId && targetId !== -1) _this.movedMap[moveKey(_this.mirror.getId(n), targetId)] = true;
            } else {
                _this.addedSet.add(n);
                _this.droppedSet.delete(n);
            }
            if (!isBlocked(n, _this.blockClass, _this.blockSelector, _this.unblockSelector, false)) {
                n.childNodes.forEach(function(childN) {
                    return _this.genAdds(childN);
                });
                if (hasShadowRoot(n)) n.shadowRoot.childNodes.forEach(function(childN) {
                    _this.processedNodeManager.add(childN, _this);
                    _this.genAdds(childN, n);
                });
            }
        };
    }
    (0, _createClass._)(MutationBuffer, [
        {
            key: "init",
            value: function init(options) {
                var _this = this;
                [
                    'mutationCb',
                    'blockClass',
                    'blockSelector',
                    'unblockSelector',
                    'maskAllText',
                    'maskTextClass',
                    'unmaskTextClass',
                    'maskTextSelector',
                    'unmaskTextSelector',
                    'inlineStylesheet',
                    'maskInputOptions',
                    'maskAttributeFn',
                    'maskTextFn',
                    'maskInputFn',
                    'keepIframeSrcFn',
                    'recordCanvas',
                    'inlineImages',
                    'slimDOMOptions',
                    'dataURLOptions',
                    'doc',
                    'mirror',
                    'iframeManager',
                    'stylesheetManager',
                    'shadowDomManager',
                    'canvasManager',
                    'processedNodeManager'
                ].forEach(function(key) {
                    _this[key] = options[key];
                });
            }
        },
        {
            key: "freeze",
            value: function freeze() {
                this.frozen = true;
                this.canvasManager.freeze();
            }
        },
        {
            key: "unfreeze",
            value: function unfreeze() {
                this.frozen = false;
                this.canvasManager.unfreeze();
                this.emit();
            }
        },
        {
            key: "isFrozen",
            value: function isFrozen() {
                return this.frozen;
            }
        },
        {
            key: "lock",
            value: function lock() {
                this.locked = true;
                this.canvasManager.lock();
            }
        },
        {
            key: "unlock",
            value: function unlock() {
                this.locked = false;
                this.canvasManager.unlock();
                this.emit();
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.shadowDomManager.reset();
                this.canvasManager.reset();
            }
        }
    ]);
    return MutationBuffer;
}();
function deepDelete(addsSet, n) {
    addsSet.delete(n);
    n.childNodes.forEach(function(childN) {
        return deepDelete(addsSet, childN);
    });
}
function isParentRemoved(removes, n, mirror) {
    if (removes.length === 0) return false;
    return _isParentRemoved(removes, n, mirror);
}
function _isParentRemoved(removes, n, mirror) {
    var parentNode = n.parentNode;
    if (!parentNode) return false;
    var parentId = mirror.getId(parentNode);
    if (removes.some(function(r) {
        return r.id === parentId;
    })) return true;
    return _isParentRemoved(removes, parentNode, mirror);
}
function isAncestorInSet(set, n) {
    if (set.size === 0) return false;
    return _isAncestorInSet(set, n);
}
function _isAncestorInSet(set, n) {
    var parentNode = n.parentNode;
    if (!parentNode) return false;
    if (set.has(parentNode)) return true;
    return _isAncestorInSet(set, parentNode);
}
var errorHandler;
function registerErrorHandler(handler) {
    errorHandler = handler;
}
function unregisterErrorHandler() {
    errorHandler = undefined;
}
var callbackWrapper = function(cb) {
    if (!errorHandler) return cb;
    var rrwebWrapped = function() {
        for(var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++){
            rest[_key] = arguments[_key];
        }
        try {
            return cb.apply(void 0, (0, _toConsumableArray._)(rest));
        } catch (error) {
            if (errorHandler && errorHandler(error) === true) return function() {};
            throw error;
        }
    };
    return rrwebWrapped;
};
function _optionalChain$2(ops) {
    var lastAccessLHS = undefined;
    var value = ops[0];
    var i = 1;
    while(i < ops.length){
        var op = ops[i];
        var fn = ops[i + 1];
        i += 2;
        if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) return undefined;
        if (op === 'access' || op === 'optionalAccess') {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === 'call' || op === 'optionalCall') {
            var _value;
            value = fn(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return (_value = value).call.apply(_value, [
                    lastAccessLHS
                ].concat((0, _toConsumableArray._)(args)));
            });
            lastAccessLHS = undefined;
        }
    }
    return value;
}
var mutationBuffers = [];
function getEventTarget(event) {
    try {
        if ('composedPath' in event) {
            var path = event.composedPath();
            if (path.length) return path[0];
        } else if ('path' in event && event.path.length) return event.path[0];
    } catch (e2) {}
    return event && event.target;
}
function initMutationObserver(options, rootEl) {
    var mutationBuffer = new MutationBuffer();
    mutationBuffers.push(mutationBuffer);
    mutationBuffer.init(options);
    var mutationObserverCtor = window.MutationObserver || window.__rrMutationObserver;
    var angularZoneSymbol = _optionalChain$2([
        window,
        'optionalAccess',
        function(_) {
            return _.Zone;
        },
        'optionalAccess',
        function(_2) {
            return _2.__symbol__;
        },
        'optionalCall',
        function(_3) {
            return _3('MutationObserver');
        }
    ]);
    if (angularZoneSymbol && window[angularZoneSymbol]) mutationObserverCtor = window[angularZoneSymbol];
    var observer = new mutationObserverCtor(callbackWrapper(function(mutations) {
        if (options.onMutation && options.onMutation(mutations) === false) return;
        mutationBuffer.processMutations.bind(mutationBuffer)(mutations);
    }));
    observer.observe(rootEl, {
        attributes: true,
        attributeOldValue: true,
        characterData: true,
        characterDataOldValue: true,
        childList: true,
        subtree: true
    });
    return observer;
}
function initMoveObserver(param) {
    var mousemoveCb = param.mousemoveCb, sampling = param.sampling, doc = param.doc, mirror = param.mirror;
    if (sampling.mousemove === false) return function() {};
    var threshold = typeof sampling.mousemove === 'number' ? sampling.mousemove : 50;
    var callbackThreshold = typeof sampling.mousemoveCallback === 'number' ? sampling.mousemoveCallback : 500;
    var positions = [];
    var timeBaseline;
    var wrappedCb = throttle$1(callbackWrapper(function(source) {
        var totalOffset = Date.now() - timeBaseline;
        mousemoveCb(positions.map(function(p) {
            p.timeOffset -= totalOffset;
            return p;
        }), source);
        positions = [];
        timeBaseline = null;
    }), callbackThreshold);
    var updatePosition = callbackWrapper(throttle$1(callbackWrapper(function(evt) {
        var target = getEventTarget(evt);
        var _ref = legacy_isTouchEvent(evt) ? evt.changedTouches[0] : evt, clientX = _ref.clientX, clientY = _ref.clientY;
        if (!timeBaseline) timeBaseline = nowTimestamp();
        positions.push({
            x: clientX,
            y: clientY,
            id: mirror.getId(target),
            timeOffset: nowTimestamp() - timeBaseline
        });
        wrappedCb(typeof DragEvent !== 'undefined' && evt instanceof DragEvent ? IncrementalSource.Drag : evt instanceof MouseEvent ? IncrementalSource.MouseMove : IncrementalSource.TouchMove);
    }), threshold, {
        trailing: false
    }));
    var handlers = [
        on('mousemove', updatePosition, doc),
        on('touchmove', updatePosition, doc),
        on('drag', updatePosition, doc)
    ];
    return callbackWrapper(function() {
        handlers.forEach(function(h) {
            return h();
        });
    });
}
function initMouseInteractionObserver(param) {
    var mouseInteractionCb = param.mouseInteractionCb, doc = param.doc, mirror = param.mirror, blockClass = param.blockClass, blockSelector = param.blockSelector, unblockSelector = param.unblockSelector, sampling = param.sampling;
    if (sampling.mouseInteraction === false) return function() {};
    var disableMap = sampling.mouseInteraction === true || sampling.mouseInteraction === undefined ? {} : sampling.mouseInteraction;
    var handlers = [];
    var currentPointerType = null;
    var getHandler = function(eventKey) {
        return function(event) {
            var target = getEventTarget(event);
            if (isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
            var pointerType = null;
            var thisEventKey = eventKey;
            if ('pointerType' in event) {
                switch(event.pointerType){
                    case 'mouse':
                        pointerType = PointerTypes.Mouse;
                        break;
                    case 'touch':
                        pointerType = PointerTypes.Touch;
                        break;
                    case 'pen':
                        pointerType = PointerTypes.Pen;
                        break;
                }
                if (pointerType === PointerTypes.Touch) {
                    if (MouseInteractions[eventKey] === MouseInteractions.MouseDown) thisEventKey = 'TouchStart';
                    else if (MouseInteractions[eventKey] === MouseInteractions.MouseUp) thisEventKey = 'TouchEnd';
                } else PointerTypes.Pen;
            } else if (legacy_isTouchEvent(event)) pointerType = PointerTypes.Touch;
            if (pointerType !== null) {
                currentPointerType = pointerType;
                if (thisEventKey.startsWith('Touch') && pointerType === PointerTypes.Touch || thisEventKey.startsWith('Mouse') && pointerType === PointerTypes.Mouse) pointerType = null;
            } else if (MouseInteractions[eventKey] === MouseInteractions.Click) {
                pointerType = currentPointerType;
                currentPointerType = null;
            }
            var e = legacy_isTouchEvent(event) ? event.changedTouches[0] : event;
            if (!e) return;
            var id = mirror.getId(target);
            var clientX = e.clientX, clientY = e.clientY;
            callbackWrapper(mouseInteractionCb)((0, _objectSpread._)({
                type: MouseInteractions[thisEventKey],
                id: id,
                x: clientX,
                y: clientY
            }, pointerType !== null && {
                pointerType: pointerType
            }));
        };
    };
    Object.keys(MouseInteractions).filter(function(key) {
        return Number.isNaN(Number(key)) && !key.endsWith('_Departed') && disableMap[key] !== false;
    }).forEach(function(eventKey) {
        var eventName = toLowerCase(eventKey);
        var handler = getHandler(eventKey);
        if (window.PointerEvent) switch(MouseInteractions[eventKey]){
            case MouseInteractions.MouseDown:
            case MouseInteractions.MouseUp:
                eventName = eventName.replace('mouse', 'pointer');
                break;
            case MouseInteractions.TouchStart:
            case MouseInteractions.TouchEnd:
                return;
        }
        handlers.push(on(eventName, handler, doc));
    });
    return callbackWrapper(function() {
        handlers.forEach(function(h) {
            return h();
        });
    });
}
function initScrollObserver(param) {
    var scrollCb = param.scrollCb, doc = param.doc, mirror = param.mirror, blockClass = param.blockClass, blockSelector = param.blockSelector, unblockSelector = param.unblockSelector, sampling = param.sampling;
    var updatePosition = callbackWrapper(throttle$1(callbackWrapper(function(evt) {
        var target = getEventTarget(evt);
        if (!target || isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
        var id = mirror.getId(target);
        if (target === doc && doc.defaultView) {
            var scrollLeftTop = getWindowScroll(doc.defaultView);
            scrollCb({
                id: id,
                x: scrollLeftTop.left,
                y: scrollLeftTop.top
            });
        } else scrollCb({
            id: id,
            x: target.scrollLeft,
            y: target.scrollTop
        });
    }), sampling.scroll || 100));
    return on('scroll', updatePosition, doc);
}
function initViewportResizeObserver(param, param1) {
    var viewportResizeCb = param.viewportResizeCb, win = param1.win;
    var lastH = -1;
    var lastW = -1;
    var updateDimension = callbackWrapper(throttle$1(callbackWrapper(function() {
        var height = getWindowHeight();
        var width = getWindowWidth();
        if (lastH !== height || lastW !== width) {
            viewportResizeCb({
                width: Number(width),
                height: Number(height)
            });
            lastH = height;
            lastW = width;
        }
    }), 200));
    return on('resize', updateDimension, win);
}
var INPUT_TAGS = [
    'INPUT',
    'TEXTAREA',
    'SELECT'
];
var lastInputValueMap = new WeakMap();
function initInputObserver(param) {
    var inputCb = param.inputCb, doc = param.doc, mirror = param.mirror, blockClass = param.blockClass, blockSelector = param.blockSelector, unblockSelector = param.unblockSelector, ignoreClass = param.ignoreClass, ignoreSelector = param.ignoreSelector, maskInputOptions = param.maskInputOptions, maskInputFn = param.maskInputFn, sampling = param.sampling, userTriggeredOnInput = param.userTriggeredOnInput, maskTextClass = param.maskTextClass, unmaskTextClass = param.unmaskTextClass, maskTextSelector = param.maskTextSelector, unmaskTextSelector = param.unmaskTextSelector;
    var _handlers;
    function eventHandler(event) {
        var target = getEventTarget(event);
        var userTriggered = event.isTrusted;
        var tagName = target && toUpperCase(target.tagName);
        if (tagName === 'OPTION') target = target.parentElement;
        if (!target || !tagName || INPUT_TAGS.indexOf(tagName) < 0 || isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
        var el = target;
        if (el.classList.contains(ignoreClass) || ignoreSelector && el.matches(ignoreSelector)) return;
        var type = getInputType(target);
        var text = getInputValue(el, tagName, type);
        var isChecked = false;
        var isInputMasked = shouldMaskInput({
            maskInputOptions: maskInputOptions,
            tagName: tagName,
            type: type
        });
        var forceMask = needMaskingText(target, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, isInputMasked);
        if (type === 'radio' || type === 'checkbox') isChecked = target.checked;
        text = maskInputValue({
            isMasked: forceMask,
            element: target,
            value: text,
            maskInputFn: maskInputFn
        });
        cbWithDedup(target, userTriggeredOnInput ? {
            text: text,
            isChecked: isChecked,
            userTriggered: userTriggered
        } : {
            text: text,
            isChecked: isChecked
        });
        var name = target.name;
        if (type === 'radio' && name && isChecked) doc.querySelectorAll(`input[type="radio"][name="${name}"]`).forEach(function(el) {
            if (el !== target) {
                var text = maskInputValue({
                    isMasked: forceMask,
                    element: el,
                    value: getInputValue(el, tagName, type),
                    maskInputFn: maskInputFn
                });
                cbWithDedup(el, userTriggeredOnInput ? {
                    text: text,
                    isChecked: !isChecked,
                    userTriggered: false
                } : {
                    text: text,
                    isChecked: !isChecked
                });
            }
        });
    }
    function cbWithDedup(target, v) {
        var lastInputValue = lastInputValueMap.get(target);
        if (!lastInputValue || lastInputValue.text !== v.text || lastInputValue.isChecked !== v.isChecked) {
            lastInputValueMap.set(target, v);
            var id = mirror.getId(target);
            callbackWrapper(inputCb)((0, _objectSpreadProps._)((0, _objectSpread._)({}, v), {
                id: id
            }));
        }
    }
    var events = sampling.input === 'last' ? [
        'change'
    ] : [
        'input',
        'change'
    ];
    var handlers = events.map(function(eventName) {
        return on(eventName, callbackWrapper(eventHandler), doc);
    });
    var currentWindow = doc.defaultView;
    if (!currentWindow) return function() {
        handlers.forEach(function(h) {
            return h();
        });
    };
    var propertyDescriptor = currentWindow.Object.getOwnPropertyDescriptor(currentWindow.HTMLInputElement.prototype, 'value');
    var hookProperties = [
        [
            currentWindow.HTMLInputElement.prototype,
            'value'
        ],
        [
            currentWindow.HTMLInputElement.prototype,
            'checked'
        ],
        [
            currentWindow.HTMLSelectElement.prototype,
            'value'
        ],
        [
            currentWindow.HTMLTextAreaElement.prototype,
            'value'
        ],
        [
            currentWindow.HTMLSelectElement.prototype,
            'selectedIndex'
        ],
        [
            currentWindow.HTMLOptionElement.prototype,
            'selected'
        ]
    ];
    if (propertyDescriptor && propertyDescriptor.set) (_handlers = handlers).push.apply(_handlers, (0, _toConsumableArray._)(hookProperties.map(function(p) {
        return hookSetter(p[0], p[1], {
            set: function() {
                callbackWrapper(eventHandler)({
                    target: this,
                    isTrusted: false
                });
            }
        }, false, currentWindow);
    })));
    return callbackWrapper(function() {
        handlers.forEach(function(h) {
            return h();
        });
    });
}
function getNestedCSSRulePositions(rule) {
    var positions = [];
    function recurse(childRule, pos) {
        if (hasNestedCSSRule('CSSGroupingRule') && childRule.parentRule instanceof CSSGroupingRule || hasNestedCSSRule('CSSMediaRule') && childRule.parentRule instanceof CSSMediaRule || hasNestedCSSRule('CSSSupportsRule') && childRule.parentRule instanceof CSSSupportsRule || hasNestedCSSRule('CSSConditionRule') && childRule.parentRule instanceof CSSConditionRule) {
            var rules = Array.from(childRule.parentRule.cssRules);
            var index = rules.indexOf(childRule);
            pos.unshift(index);
        } else if (childRule.parentStyleSheet) {
            var rules1 = Array.from(childRule.parentStyleSheet.cssRules);
            var index1 = rules1.indexOf(childRule);
            pos.unshift(index1);
        }
        return pos;
    }
    return recurse(rule, positions);
}
function getIdAndStyleId(sheet, mirror, styleMirror) {
    var id, styleId;
    if (!sheet) return {};
    if (sheet.ownerNode) id = mirror.getId(sheet.ownerNode);
    else styleId = styleMirror.getId(sheet);
    return {
        styleId: styleId,
        id: id
    };
}
function initStyleSheetObserver(param, param1) {
    var styleSheetRuleCb = param.styleSheetRuleCb, mirror = param.mirror, stylesheetManager = param.stylesheetManager, win = param1.win;
    if (!win.CSSStyleSheet || !win.CSSStyleSheet.prototype) return function() {};
    var insertRule = win.CSSStyleSheet.prototype.insertRule;
    win.CSSStyleSheet.prototype.insertRule = new Proxy(insertRule, {
        apply: callbackWrapper(function(target, thisArg, argumentsList) {
            var _argumentsList = (0, _slicedToArray._)(argumentsList, 2), rule = _argumentsList[0], index = _argumentsList[1];
            var _getIdAndStyleId = getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                adds: [
                    {
                        rule: rule,
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    var deleteRule = win.CSSStyleSheet.prototype.deleteRule;
    win.CSSStyleSheet.prototype.deleteRule = new Proxy(deleteRule, {
        apply: callbackWrapper(function(target, thisArg, argumentsList) {
            var _argumentsList = (0, _slicedToArray._)(argumentsList, 1), index = _argumentsList[0];
            var _getIdAndStyleId = getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                removes: [
                    {
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    var replace;
    if (win.CSSStyleSheet.prototype.replace) {
        replace = win.CSSStyleSheet.prototype.replace;
        win.CSSStyleSheet.prototype.replace = new Proxy(replace, {
            apply: callbackWrapper(function(target, thisArg, argumentsList) {
                var _argumentsList = (0, _slicedToArray._)(argumentsList, 1), text = _argumentsList[0];
                var _getIdAndStyleId = getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replace: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    var replaceSync;
    if (win.CSSStyleSheet.prototype.replaceSync) {
        replaceSync = win.CSSStyleSheet.prototype.replaceSync;
        win.CSSStyleSheet.prototype.replaceSync = new Proxy(replaceSync, {
            apply: callbackWrapper(function(target, thisArg, argumentsList) {
                var _argumentsList = (0, _slicedToArray._)(argumentsList, 1), text = _argumentsList[0];
                var _getIdAndStyleId = getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replaceSync: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    var supportedNestedCSSRuleTypes = {};
    if (canMonkeyPatchNestedCSSRule('CSSGroupingRule')) supportedNestedCSSRuleTypes.CSSGroupingRule = win.CSSGroupingRule;
    else {
        if (canMonkeyPatchNestedCSSRule('CSSMediaRule')) supportedNestedCSSRuleTypes.CSSMediaRule = win.CSSMediaRule;
        if (canMonkeyPatchNestedCSSRule('CSSConditionRule')) supportedNestedCSSRuleTypes.CSSConditionRule = win.CSSConditionRule;
        if (canMonkeyPatchNestedCSSRule('CSSSupportsRule')) supportedNestedCSSRuleTypes.CSSSupportsRule = win.CSSSupportsRule;
    }
    var unmodifiedFunctions = {};
    Object.entries(supportedNestedCSSRuleTypes).forEach(function(param) {
        var _param = (0, _slicedToArray._)(param, 2), typeKey = _param[0], type = _param[1];
        unmodifiedFunctions[typeKey] = {
            insertRule: type.prototype.insertRule,
            deleteRule: type.prototype.deleteRule
        };
        type.prototype.insertRule = new Proxy(unmodifiedFunctions[typeKey].insertRule, {
            apply: callbackWrapper(function(target, thisArg, argumentsList) {
                var _argumentsList = (0, _slicedToArray._)(argumentsList, 2), rule = _argumentsList[0], index = _argumentsList[1];
                var _getIdAndStyleId = getIdAndStyleId(thisArg.parentStyleSheet, mirror, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    adds: [
                        {
                            rule: rule,
                            index: (0, _toConsumableArray._)(getNestedCSSRulePositions(thisArg)).concat([
                                index || 0
                            ])
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
        type.prototype.deleteRule = new Proxy(unmodifiedFunctions[typeKey].deleteRule, {
            apply: callbackWrapper(function(target, thisArg, argumentsList) {
                var _argumentsList = (0, _slicedToArray._)(argumentsList, 1), index = _argumentsList[0];
                var _getIdAndStyleId = getIdAndStyleId(thisArg.parentStyleSheet, mirror, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    removes: [
                        {
                            index: (0, _toConsumableArray._)(getNestedCSSRulePositions(thisArg)).concat([
                                index
                            ])
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    });
    return callbackWrapper(function() {
        win.CSSStyleSheet.prototype.insertRule = insertRule;
        win.CSSStyleSheet.prototype.deleteRule = deleteRule;
        replace && (win.CSSStyleSheet.prototype.replace = replace);
        replaceSync && (win.CSSStyleSheet.prototype.replaceSync = replaceSync);
        Object.entries(supportedNestedCSSRuleTypes).forEach(function(param) {
            var _param = (0, _slicedToArray._)(param, 2), typeKey = _param[0], type = _param[1];
            type.prototype.insertRule = unmodifiedFunctions[typeKey].insertRule;
            type.prototype.deleteRule = unmodifiedFunctions[typeKey].deleteRule;
        });
    });
}
function initAdoptedStyleSheetObserver(param, host) {
    var mirror = param.mirror, stylesheetManager = param.stylesheetManager;
    var hostId = null;
    if (host.nodeName === '#document') hostId = mirror.getId(host);
    else hostId = mirror.getId(host.host);
    var patchTarget = host.nodeName === '#document' ? _optionalChain$2([
        host,
        'access',
        function(_4) {
            return _4.defaultView;
        },
        'optionalAccess',
        function(_5) {
            return _5.Document;
        }
    ]) : _optionalChain$2([
        host,
        'access',
        function(_6) {
            return _6.ownerDocument;
        },
        'optionalAccess',
        function(_7) {
            return _7.defaultView;
        },
        'optionalAccess',
        function(_8) {
            return _8.ShadowRoot;
        }
    ]);
    var originalPropertyDescriptor = _optionalChain$2([
        patchTarget,
        'optionalAccess',
        function(_9) {
            return _9.prototype;
        }
    ]) ? Object.getOwnPropertyDescriptor(_optionalChain$2([
        patchTarget,
        'optionalAccess',
        function(_10) {
            return _10.prototype;
        }
    ]), 'adoptedStyleSheets') : undefined;
    if (hostId === null || hostId === -1 || !patchTarget || !originalPropertyDescriptor) return function() {};
    Object.defineProperty(host, 'adoptedStyleSheets', {
        configurable: originalPropertyDescriptor.configurable,
        enumerable: originalPropertyDescriptor.enumerable,
        get: function() {
            var _this = this;
            return _optionalChain$2([
                originalPropertyDescriptor,
                'access',
                function(_11) {
                    return _11.get;
                },
                'optionalAccess',
                function(_12) {
                    return _12.call;
                },
                'call',
                function(_13) {
                    return _13(_this);
                }
            ]);
        },
        set: function(sheets) {
            var _this = this;
            var result = _optionalChain$2([
                originalPropertyDescriptor,
                'access',
                function(_14) {
                    return _14.set;
                },
                'optionalAccess',
                function(_15) {
                    return _15.call;
                },
                'call',
                function(_16) {
                    return _16(_this, sheets);
                }
            ]);
            if (hostId !== null && hostId !== -1) try {
                stylesheetManager.adoptStyleSheets(sheets, hostId);
            } catch (e) {}
            return result;
        }
    });
    return callbackWrapper(function() {
        Object.defineProperty(host, 'adoptedStyleSheets', {
            configurable: originalPropertyDescriptor.configurable,
            enumerable: originalPropertyDescriptor.enumerable,
            get: originalPropertyDescriptor.get,
            set: originalPropertyDescriptor.set
        });
    });
}
function initStyleDeclarationObserver(param, param1) {
    var styleDeclarationCb = param.styleDeclarationCb, mirror = param.mirror, ignoreCSSAttributes = param.ignoreCSSAttributes, stylesheetManager = param.stylesheetManager, win = param1.win;
    var setProperty = win.CSSStyleDeclaration.prototype.setProperty;
    win.CSSStyleDeclaration.prototype.setProperty = new Proxy(setProperty, {
        apply: callbackWrapper(function(target, thisArg, argumentsList) {
            var _argumentsList = (0, _slicedToArray._)(argumentsList, 3), property = _argumentsList[0], value = _argumentsList[1], priority = _argumentsList[2];
            if (ignoreCSSAttributes.has(property)) return setProperty.apply(thisArg, [
                property,
                value,
                priority
            ]);
            var _getIdAndStyleId = getIdAndStyleId(_optionalChain$2([
                thisArg,
                'access',
                function(_17) {
                    return _17.parentRule;
                },
                'optionalAccess',
                function(_18) {
                    return _18.parentStyleSheet;
                }
            ]), mirror, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                set: {
                    property: property,
                    value: value,
                    priority: priority
                },
                index: getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    var removeProperty = win.CSSStyleDeclaration.prototype.removeProperty;
    win.CSSStyleDeclaration.prototype.removeProperty = new Proxy(removeProperty, {
        apply: callbackWrapper(function(target, thisArg, argumentsList) {
            var _argumentsList = (0, _slicedToArray._)(argumentsList, 1), property = _argumentsList[0];
            if (ignoreCSSAttributes.has(property)) return removeProperty.apply(thisArg, [
                property
            ]);
            var _getIdAndStyleId = getIdAndStyleId(_optionalChain$2([
                thisArg,
                'access',
                function(_19) {
                    return _19.parentRule;
                },
                'optionalAccess',
                function(_20) {
                    return _20.parentStyleSheet;
                }
            ]), mirror, stylesheetManager.styleMirror), id = _getIdAndStyleId.id, styleId = _getIdAndStyleId.styleId;
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                remove: {
                    property: property
                },
                index: getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    return callbackWrapper(function() {
        win.CSSStyleDeclaration.prototype.setProperty = setProperty;
        win.CSSStyleDeclaration.prototype.removeProperty = removeProperty;
    });
}
function initMediaInteractionObserver(param) {
    var mediaInteractionCb = param.mediaInteractionCb, blockClass = param.blockClass, blockSelector = param.blockSelector, unblockSelector = param.unblockSelector, mirror = param.mirror, sampling = param.sampling, doc = param.doc;
    var handler = callbackWrapper(function(type) {
        return throttle$1(callbackWrapper(function(event) {
            var target = getEventTarget(event);
            if (!target || isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
            var currentTime = target.currentTime, volume = target.volume, muted = target.muted, playbackRate = target.playbackRate;
            mediaInteractionCb({
                type: type,
                id: mirror.getId(target),
                currentTime: currentTime,
                volume: volume,
                muted: muted,
                playbackRate: playbackRate
            });
        }), sampling.media || 500);
    });
    var handlers = [
        on('play', handler(0), doc),
        on('pause', handler(1), doc),
        on('seeked', handler(2), doc),
        on('volumechange', handler(3), doc),
        on('ratechange', handler(4), doc)
    ];
    return callbackWrapper(function() {
        handlers.forEach(function(h) {
            return h();
        });
    });
}
function initFontObserver(param) {
    var fontCb = param.fontCb, doc = param.doc;
    var win = doc.defaultView;
    if (!win) return function() {};
    var handlers = [];
    var fontMap = new WeakMap();
    var originalFontFace = win.FontFace;
    win.FontFace = function FontFace(family, source, descriptors) {
        var fontFace = new originalFontFace(family, source, descriptors);
        fontMap.set(fontFace, {
            family: family,
            buffer: typeof source !== 'string',
            descriptors: descriptors,
            fontSource: typeof source === 'string' ? source : JSON.stringify(Array.from(new Uint8Array(source)))
        });
        return fontFace;
    };
    var restoreHandler = patch(doc.fonts, 'add', function(original) {
        return function(fontFace) {
            setTimeout$1(callbackWrapper(function() {
                var p = fontMap.get(fontFace);
                if (p) {
                    fontCb(p);
                    fontMap.delete(fontFace);
                }
            }), 0);
            return original.apply(this, [
                fontFace
            ]);
        };
    });
    handlers.push(function() {
        win.FontFace = originalFontFace;
    });
    handlers.push(restoreHandler);
    return callbackWrapper(function() {
        handlers.forEach(function(h) {
            return h();
        });
    });
}
function initSelectionObserver(param) {
    var doc = param.doc, mirror = param.mirror, blockClass = param.blockClass, blockSelector = param.blockSelector, unblockSelector = param.unblockSelector, selectionCb = param.selectionCb;
    var collapsed = true;
    var updateSelection = callbackWrapper(function() {
        var selection = doc.getSelection();
        if (!selection || collapsed && _optionalChain$2([
            selection,
            'optionalAccess',
            function(_21) {
                return _21.isCollapsed;
            }
        ])) return;
        collapsed = selection.isCollapsed || false;
        var ranges = [];
        var count = selection.rangeCount || 0;
        for(var i = 0; i < count; i++){
            var range = selection.getRangeAt(i);
            var startContainer = range.startContainer, startOffset = range.startOffset, endContainer = range.endContainer, endOffset = range.endOffset;
            var blocked = isBlocked(startContainer, blockClass, blockSelector, unblockSelector, true) || isBlocked(endContainer, blockClass, blockSelector, unblockSelector, true);
            if (blocked) continue;
            ranges.push({
                start: mirror.getId(startContainer),
                startOffset: startOffset,
                end: mirror.getId(endContainer),
                endOffset: endOffset
            });
        }
        selectionCb({
            ranges: ranges
        });
    });
    updateSelection();
    return on('selectionchange', updateSelection);
}
function initCustomElementObserver(param) {
    var doc = param.doc, customElementCb = param.customElementCb;
    var win = doc.defaultView;
    if (!win || !win.customElements) return function() {};
    var restoreHandler = patch(win.customElements, 'define', function(original) {
        return function(name, constructor, options) {
            try {
                customElementCb({
                    define: {
                        name: name
                    }
                });
            } catch (e) {}
            return original.apply(this, [
                name,
                constructor,
                options
            ]);
        };
    });
    return restoreHandler;
}
function initObservers(o) {
    var _hooks = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var currentWindow = o.doc.defaultView;
    if (!currentWindow) return function() {};
    var mutationObserver = initMutationObserver(o, o.doc);
    var mousemoveHandler = initMoveObserver(o);
    var mouseInteractionHandler = initMouseInteractionObserver(o);
    var scrollHandler = initScrollObserver(o);
    var viewportResizeHandler = initViewportResizeObserver(o, {
        win: currentWindow
    });
    var inputHandler = initInputObserver(o);
    var mediaInteractionHandler = initMediaInteractionObserver(o);
    var styleSheetObserver = initStyleSheetObserver(o, {
        win: currentWindow
    });
    var adoptedStyleSheetObserver = initAdoptedStyleSheetObserver(o, o.doc);
    var styleDeclarationObserver = initStyleDeclarationObserver(o, {
        win: currentWindow
    });
    var fontObserver = o.collectFonts ? initFontObserver(o) : function() {};
    var selectionObserver = initSelectionObserver(o);
    var customElementObserver = initCustomElementObserver(o);
    var pluginHandlers = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = o.plugins[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var plugin = _step.value;
            pluginHandlers.push(plugin.observer(plugin.callback, currentWindow, plugin.options));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return callbackWrapper(function() {
        mutationBuffers.forEach(function(b) {
            return b.reset();
        });
        mutationObserver.disconnect();
        mousemoveHandler();
        mouseInteractionHandler();
        scrollHandler();
        viewportResizeHandler();
        inputHandler();
        mediaInteractionHandler();
        styleSheetObserver();
        adoptedStyleSheetObserver();
        styleDeclarationObserver();
        fontObserver();
        selectionObserver();
        customElementObserver();
        pluginHandlers.forEach(function(h) {
            return h();
        });
    });
}
function hasNestedCSSRule(prop) {
    return typeof window[prop] !== 'undefined';
}
function canMonkeyPatchNestedCSSRule(prop) {
    return Boolean(typeof window[prop] !== 'undefined' && window[prop].prototype && 'insertRule' in window[prop].prototype && 'deleteRule' in window[prop].prototype);
}
var CrossOriginIframeMirror = /*#__PURE__*/ function() {
    "use strict";
    function CrossOriginIframeMirror(generateIdFn) {
        (0, _classCallCheck._)(this, CrossOriginIframeMirror);
        this.generateIdFn = generateIdFn;
        this.iframeIdToRemoteIdMap = new WeakMap();
        this.iframeRemoteIdToIdMap = new WeakMap();
    }
    (0, _createClass._)(CrossOriginIframeMirror, [
        {
            key: "getId",
            value: function getId(iframe, remoteId, idToRemoteMap, remoteToIdMap) {
                var idToRemoteIdMap = idToRemoteMap || this.getIdToRemoteIdMap(iframe);
                var remoteIdToIdMap = remoteToIdMap || this.getRemoteIdToIdMap(iframe);
                var id = idToRemoteIdMap.get(remoteId);
                if (!id) {
                    id = this.generateIdFn();
                    idToRemoteIdMap.set(remoteId, id);
                    remoteIdToIdMap.set(id, remoteId);
                }
                return id;
            }
        },
        {
            key: "getIds",
            value: function getIds(iframe, remoteId) {
                var _this = this;
                var idToRemoteIdMap = this.getIdToRemoteIdMap(iframe);
                var remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
                return remoteId.map(function(id) {
                    return _this.getId(iframe, id, idToRemoteIdMap, remoteIdToIdMap);
                });
            }
        },
        {
            key: "getRemoteId",
            value: function getRemoteId(iframe, id, map) {
                var remoteIdToIdMap = map || this.getRemoteIdToIdMap(iframe);
                if (typeof id !== 'number') return id;
                var remoteId = remoteIdToIdMap.get(id);
                if (!remoteId) return -1;
                return remoteId;
            }
        },
        {
            key: "getRemoteIds",
            value: function getRemoteIds(iframe, ids) {
                var _this = this;
                var remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
                return ids.map(function(id) {
                    return _this.getRemoteId(iframe, id, remoteIdToIdMap);
                });
            }
        },
        {
            key: "reset",
            value: function reset(iframe) {
                if (!iframe) {
                    this.iframeIdToRemoteIdMap = new WeakMap();
                    this.iframeRemoteIdToIdMap = new WeakMap();
                    return;
                }
                this.iframeIdToRemoteIdMap.delete(iframe);
                this.iframeRemoteIdToIdMap.delete(iframe);
            }
        },
        {
            key: "getIdToRemoteIdMap",
            value: function getIdToRemoteIdMap(iframe) {
                var idToRemoteIdMap = this.iframeIdToRemoteIdMap.get(iframe);
                if (!idToRemoteIdMap) {
                    idToRemoteIdMap = new Map();
                    this.iframeIdToRemoteIdMap.set(iframe, idToRemoteIdMap);
                }
                return idToRemoteIdMap;
            }
        },
        {
            key: "getRemoteIdToIdMap",
            value: function getRemoteIdToIdMap(iframe) {
                var remoteIdToIdMap = this.iframeRemoteIdToIdMap.get(iframe);
                if (!remoteIdToIdMap) {
                    remoteIdToIdMap = new Map();
                    this.iframeRemoteIdToIdMap.set(iframe, remoteIdToIdMap);
                }
                return remoteIdToIdMap;
            }
        }
    ]);
    return CrossOriginIframeMirror;
}();
function _optionalChain$1(ops) {
    var lastAccessLHS = undefined;
    var value = ops[0];
    var i = 1;
    while(i < ops.length){
        var op = ops[i];
        var fn = ops[i + 1];
        i += 2;
        if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) return undefined;
        if (op === 'access' || op === 'optionalAccess') {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === 'call' || op === 'optionalCall') {
            var _value;
            value = fn(function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return (_value = value).call.apply(_value, [
                    lastAccessLHS
                ].concat((0, _toConsumableArray._)(args)));
            });
            lastAccessLHS = undefined;
        }
    }
    return value;
}
var IframeManagerNoop = /*#__PURE__*/ function() {
    "use strict";
    function IframeManagerNoop() {
        (0, _classCallCheck._)(this, IframeManagerNoop);
        this.crossOriginIframeMirror = new CrossOriginIframeMirror(genId);
        this.crossOriginIframeRootIdMap = new WeakMap();
    }
    (0, _createClass._)(IframeManagerNoop, [
        {
            key: "addIframe",
            value: function addIframe() {}
        },
        {
            key: "addLoadListener",
            value: function addLoadListener() {}
        },
        {
            key: "attachIframe",
            value: function attachIframe() {}
        }
    ]);
    return IframeManagerNoop;
}();
var IframeManager = /*#__PURE__*/ function() {
    "use strict";
    function IframeManager(options) {
        (0, _classCallCheck._)(this, IframeManager);
        this.iframes = new WeakMap();
        this.crossOriginIframeMap = new WeakMap();
        this.crossOriginIframeMirror = new CrossOriginIframeMirror(genId);
        this.crossOriginIframeRootIdMap = new WeakMap();
        this.mutationCb = options.mutationCb;
        this.wrappedEmit = options.wrappedEmit;
        this.stylesheetManager = options.stylesheetManager;
        this.recordCrossOriginIframes = options.recordCrossOriginIframes;
        this.crossOriginIframeStyleMirror = new CrossOriginIframeMirror(this.stylesheetManager.styleMirror.generateId.bind(this.stylesheetManager.styleMirror));
        this.mirror = options.mirror;
        if (this.recordCrossOriginIframes) window.addEventListener('message', this.handleMessage.bind(this));
    }
    (0, _createClass._)(IframeManager, [
        {
            key: "addIframe",
            value: function addIframe(iframeEl) {
                this.iframes.set(iframeEl, true);
                if (iframeEl.contentWindow) this.crossOriginIframeMap.set(iframeEl.contentWindow, iframeEl);
            }
        },
        {
            key: "addLoadListener",
            value: function addLoadListener(cb) {
                this.loadListener = cb;
            }
        },
        {
            key: "attachIframe",
            value: function attachIframe(iframeEl, childSn) {
                this.mutationCb({
                    adds: [
                        {
                            parentId: this.mirror.getId(iframeEl),
                            nextId: null,
                            node: childSn
                        }
                    ],
                    removes: [],
                    texts: [],
                    attributes: [],
                    isAttachIframe: true
                });
                _optionalChain$1([
                    this,
                    'access',
                    function(_) {
                        return _.loadListener;
                    },
                    'optionalCall',
                    function(_2) {
                        return _2(iframeEl);
                    }
                ]);
                if (iframeEl.contentDocument && iframeEl.contentDocument.adoptedStyleSheets && iframeEl.contentDocument.adoptedStyleSheets.length > 0) this.stylesheetManager.adoptStyleSheets(iframeEl.contentDocument.adoptedStyleSheets, this.mirror.getId(iframeEl.contentDocument));
            }
        },
        {
            key: "handleMessage",
            value: function handleMessage(message) {
                var crossOriginMessageEvent = message;
                if (crossOriginMessageEvent.data.type !== 'rrweb' || crossOriginMessageEvent.origin !== crossOriginMessageEvent.data.origin) return;
                var iframeSourceWindow = message.source;
                if (!iframeSourceWindow) return;
                var iframeEl = this.crossOriginIframeMap.get(message.source);
                if (!iframeEl) return;
                var transformedEvent = this.transformCrossOriginEvent(iframeEl, crossOriginMessageEvent.data.event);
                if (transformedEvent) this.wrappedEmit(transformedEvent, crossOriginMessageEvent.data.isCheckout);
            }
        },
        {
            key: "transformCrossOriginEvent",
            value: function transformCrossOriginEvent(iframeEl, e) {
                var _this = this;
                switch(e.type){
                    case EventType.FullSnapshot:
                        {
                            this.crossOriginIframeMirror.reset(iframeEl);
                            this.crossOriginIframeStyleMirror.reset(iframeEl);
                            this.replaceIdOnNode(e.data.node, iframeEl);
                            var rootId = e.data.node.id;
                            this.crossOriginIframeRootIdMap.set(iframeEl, rootId);
                            this.patchRootIdOnNode(e.data.node, rootId);
                            return {
                                timestamp: e.timestamp,
                                type: EventType.IncrementalSnapshot,
                                data: {
                                    source: IncrementalSource.Mutation,
                                    adds: [
                                        {
                                            parentId: this.mirror.getId(iframeEl),
                                            nextId: null,
                                            node: e.data.node
                                        }
                                    ],
                                    removes: [],
                                    texts: [],
                                    attributes: [],
                                    isAttachIframe: true
                                }
                            };
                        }
                    case EventType.Meta:
                    case EventType.Load:
                    case EventType.DomContentLoaded:
                        return false;
                    case EventType.Plugin:
                        return e;
                    case EventType.Custom:
                        this.replaceIds(e.data.payload, iframeEl, [
                            'id',
                            'parentId',
                            'previousId',
                            'nextId'
                        ]);
                        return e;
                    case EventType.IncrementalSnapshot:
                        switch(e.data.source){
                            case IncrementalSource.Mutation:
                                e.data.adds.forEach(function(n) {
                                    _this.replaceIds(n, iframeEl, [
                                        'parentId',
                                        'nextId',
                                        'previousId'
                                    ]);
                                    _this.replaceIdOnNode(n.node, iframeEl);
                                    var rootId = _this.crossOriginIframeRootIdMap.get(iframeEl);
                                    rootId && _this.patchRootIdOnNode(n.node, rootId);
                                });
                                e.data.removes.forEach(function(n) {
                                    _this.replaceIds(n, iframeEl, [
                                        'parentId',
                                        'id'
                                    ]);
                                });
                                e.data.attributes.forEach(function(n) {
                                    _this.replaceIds(n, iframeEl, [
                                        'id'
                                    ]);
                                });
                                e.data.texts.forEach(function(n) {
                                    _this.replaceIds(n, iframeEl, [
                                        'id'
                                    ]);
                                });
                                return e;
                            case IncrementalSource.Drag:
                            case IncrementalSource.TouchMove:
                            case IncrementalSource.MouseMove:
                                e.data.positions.forEach(function(p) {
                                    _this.replaceIds(p, iframeEl, [
                                        'id'
                                    ]);
                                });
                                return e;
                            case IncrementalSource.ViewportResize:
                                return false;
                            case IncrementalSource.MediaInteraction:
                            case IncrementalSource.MouseInteraction:
                            case IncrementalSource.Scroll:
                            case IncrementalSource.CanvasMutation:
                            case IncrementalSource.Input:
                                this.replaceIds(e.data, iframeEl, [
                                    'id'
                                ]);
                                return e;
                            case IncrementalSource.StyleSheetRule:
                            case IncrementalSource.StyleDeclaration:
                                this.replaceIds(e.data, iframeEl, [
                                    'id'
                                ]);
                                this.replaceStyleIds(e.data, iframeEl, [
                                    'styleId'
                                ]);
                                return e;
                            case IncrementalSource.Font:
                                return e;
                            case IncrementalSource.Selection:
                                e.data.ranges.forEach(function(range) {
                                    _this.replaceIds(range, iframeEl, [
                                        'start',
                                        'end'
                                    ]);
                                });
                                return e;
                            case IncrementalSource.AdoptedStyleSheet:
                                this.replaceIds(e.data, iframeEl, [
                                    'id'
                                ]);
                                this.replaceStyleIds(e.data, iframeEl, [
                                    'styleIds'
                                ]);
                                _optionalChain$1([
                                    e,
                                    'access',
                                    function(_3) {
                                        return _3.data;
                                    },
                                    'access',
                                    function(_4) {
                                        return _4.styles;
                                    },
                                    'optionalAccess',
                                    function(_5) {
                                        return _5.forEach;
                                    },
                                    'call',
                                    function(_6) {
                                        return _6(function(style) {
                                            _this.replaceStyleIds(style, iframeEl, [
                                                'styleId'
                                            ]);
                                        });
                                    }
                                ]);
                                return e;
                        }
                }
                return false;
            }
        },
        {
            key: "replace",
            value: function replace(iframeMirror, obj, iframeEl, keys) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        if (!Array.isArray(obj[key]) && typeof obj[key] !== 'number') continue;
                        if (Array.isArray(obj[key])) obj[key] = iframeMirror.getIds(iframeEl, obj[key]);
                        else obj[key] = iframeMirror.getId(iframeEl, obj[key]);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return obj;
            }
        },
        {
            key: "replaceIds",
            value: function replaceIds(obj, iframeEl, keys) {
                return this.replace(this.crossOriginIframeMirror, obj, iframeEl, keys);
            }
        },
        {
            key: "replaceStyleIds",
            value: function replaceStyleIds(obj, iframeEl, keys) {
                return this.replace(this.crossOriginIframeStyleMirror, obj, iframeEl, keys);
            }
        },
        {
            key: "replaceIdOnNode",
            value: function replaceIdOnNode(node, iframeEl) {
                var _this = this;
                this.replaceIds(node, iframeEl, [
                    'id',
                    'rootId'
                ]);
                if ('childNodes' in node) node.childNodes.forEach(function(child) {
                    _this.replaceIdOnNode(child, iframeEl);
                });
            }
        },
        {
            key: "patchRootIdOnNode",
            value: function patchRootIdOnNode(node, rootId) {
                var _this = this;
                if (node.type !== NodeType$1.Document && !node.rootId) node.rootId = rootId;
                if ('childNodes' in node) node.childNodes.forEach(function(child) {
                    _this.patchRootIdOnNode(child, rootId);
                });
            }
        }
    ]);
    return IframeManager;
}();
var ShadowDomManagerNoop = /*#__PURE__*/ function() {
    "use strict";
    function ShadowDomManagerNoop() {
        (0, _classCallCheck._)(this, ShadowDomManagerNoop);
    }
    (0, _createClass._)(ShadowDomManagerNoop, [
        {
            key: "init",
            value: function init() {}
        },
        {
            key: "addShadowRoot",
            value: function addShadowRoot() {}
        },
        {
            key: "observeAttachShadow",
            value: function observeAttachShadow() {}
        },
        {
            key: "reset",
            value: function reset() {}
        }
    ]);
    return ShadowDomManagerNoop;
}();
var ShadowDomManager = /*#__PURE__*/ function() {
    "use strict";
    function ShadowDomManager(options) {
        (0, _classCallCheck._)(this, ShadowDomManager);
        this.shadowDoms = new WeakSet();
        this.restoreHandlers = [];
        this.mutationCb = options.mutationCb;
        this.scrollCb = options.scrollCb;
        this.bypassOptions = options.bypassOptions;
        this.mirror = options.mirror;
        this.init();
    }
    (0, _createClass._)(ShadowDomManager, [
        {
            key: "init",
            value: function init() {
                this.reset();
                this.patchAttachShadow(Element, document);
            }
        },
        {
            key: "addShadowRoot",
            value: function addShadowRoot(shadowRoot, doc) {
                var _this = this;
                if (!isNativeShadowDom(shadowRoot)) return;
                if (this.shadowDoms.has(shadowRoot)) return;
                this.shadowDoms.add(shadowRoot);
                var observer = initMutationObserver((0, _objectSpreadProps._)((0, _objectSpread._)({}, this.bypassOptions), {
                    doc: doc,
                    mutationCb: this.mutationCb,
                    mirror: this.mirror,
                    shadowDomManager: this
                }), shadowRoot);
                this.restoreHandlers.push(function() {
                    return observer.disconnect();
                });
                this.restoreHandlers.push(initScrollObserver((0, _objectSpreadProps._)((0, _objectSpread._)({}, this.bypassOptions), {
                    scrollCb: this.scrollCb,
                    doc: shadowRoot,
                    mirror: this.mirror
                })));
                setTimeout$1(function() {
                    if (shadowRoot.adoptedStyleSheets && shadowRoot.adoptedStyleSheets.length > 0) _this.bypassOptions.stylesheetManager.adoptStyleSheets(shadowRoot.adoptedStyleSheets, _this.mirror.getId(shadowRoot.host));
                    _this.restoreHandlers.push(initAdoptedStyleSheetObserver({
                        mirror: _this.mirror,
                        stylesheetManager: _this.bypassOptions.stylesheetManager
                    }, shadowRoot));
                }, 0);
            }
        },
        {
            key: "observeAttachShadow",
            value: function observeAttachShadow(iframeElement) {
                if (!iframeElement.contentWindow || !iframeElement.contentDocument) return;
                this.patchAttachShadow(iframeElement.contentWindow.Element, iframeElement.contentDocument);
            }
        },
        {
            key: "patchAttachShadow",
            value: function patchAttachShadow(element, doc) {
                var manager = this;
                this.restoreHandlers.push(patch(element.prototype, 'attachShadow', function(original) {
                    return function(option) {
                        var shadowRoot = original.call(this, option);
                        if (this.shadowRoot && inDom(this)) manager.addShadowRoot(this.shadowRoot, doc);
                        return shadowRoot;
                    };
                }));
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.restoreHandlers.forEach(function(handler) {
                    try {
                        handler();
                    } catch (e) {}
                });
                this.restoreHandlers = [];
                this.shadowDoms = new WeakSet();
            }
        }
    ]);
    return ShadowDomManager;
}();
var CanvasManagerNoop = /*#__PURE__*/ function() {
    "use strict";
    function CanvasManagerNoop() {
        (0, _classCallCheck._)(this, CanvasManagerNoop);
    }
    (0, _createClass._)(CanvasManagerNoop, [
        {
            key: "reset",
            value: function reset() {}
        },
        {
            key: "freeze",
            value: function freeze() {}
        },
        {
            key: "unfreeze",
            value: function unfreeze() {}
        },
        {
            key: "lock",
            value: function lock() {}
        },
        {
            key: "unlock",
            value: function unlock() {}
        },
        {
            key: "snapshot",
            value: function snapshot() {}
        }
    ]);
    return CanvasManagerNoop;
}();
var StylesheetManager = /*#__PURE__*/ function() {
    "use strict";
    function StylesheetManager(options) {
        (0, _classCallCheck._)(this, StylesheetManager);
        this.trackedLinkElements = new WeakSet();
        this.styleMirror = new StyleSheetMirror();
        this.mutationCb = options.mutationCb;
        this.adoptedStyleSheetCb = options.adoptedStyleSheetCb;
    }
    (0, _createClass._)(StylesheetManager, [
        {
            key: "attachLinkElement",
            value: function attachLinkElement(linkEl, childSn) {
                if ('_cssText' in childSn.attributes) this.mutationCb({
                    adds: [],
                    removes: [],
                    texts: [],
                    attributes: [
                        {
                            id: childSn.id,
                            attributes: childSn.attributes
                        }
                    ]
                });
                this.trackLinkElement(linkEl);
            }
        },
        {
            key: "trackLinkElement",
            value: function trackLinkElement(linkEl) {
                if (this.trackedLinkElements.has(linkEl)) return;
                this.trackedLinkElements.add(linkEl);
                this.trackStylesheetInLinkElement(linkEl);
            }
        },
        {
            key: "adoptStyleSheets",
            value: function adoptStyleSheets(sheets, hostId) {
                if (sheets.length === 0) return;
                var adoptedStyleSheetData = {
                    id: hostId,
                    styleIds: []
                };
                var styles = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = sheets[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var sheet = _step.value;
                        var styleId = void 0;
                        if (!this.styleMirror.has(sheet)) {
                            styleId = this.styleMirror.add(sheet);
                            styles.push({
                                styleId: styleId,
                                rules: Array.from(sheet.rules || CSSRule, function(r, index) {
                                    return {
                                        rule: stringifyRule(r),
                                        index: index
                                    };
                                })
                            });
                        } else styleId = this.styleMirror.getId(sheet);
                        adoptedStyleSheetData.styleIds.push(styleId);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (styles.length > 0) adoptedStyleSheetData.styles = styles;
                this.adoptedStyleSheetCb(adoptedStyleSheetData);
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.styleMirror.reset();
                this.trackedLinkElements = new WeakSet();
            }
        },
        {
            key: "trackStylesheetInLinkElement",
            value: function trackStylesheetInLinkElement(linkEl) {}
        }
    ]);
    return StylesheetManager;
}();
var ProcessedNodeManager = /*#__PURE__*/ function() {
    "use strict";
    function ProcessedNodeManager() {
        (0, _classCallCheck._)(this, ProcessedNodeManager);
        this.nodeMap = new WeakMap();
        this.loop = true;
        this.periodicallyClear();
    }
    (0, _createClass._)(ProcessedNodeManager, [
        {
            key: "periodicallyClear",
            value: function periodicallyClear() {
                var _this = this;
                onRequestAnimationFrame(function() {
                    _this.clear();
                    if (_this.loop) _this.periodicallyClear();
                });
            }
        },
        {
            key: "inOtherBuffer",
            value: function inOtherBuffer(node, thisBuffer) {
                var buffers = this.nodeMap.get(node);
                return buffers && Array.from(buffers).some(function(buffer) {
                    return buffer !== thisBuffer;
                });
            }
        },
        {
            key: "add",
            value: function add(node, buffer) {
                this.nodeMap.set(node, (this.nodeMap.get(node) || new Set()).add(buffer));
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.nodeMap = new WeakMap();
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.loop = false;
            }
        }
    ]);
    return ProcessedNodeManager;
}();
var wrappedEmit;
var _takeFullSnapshot;
var mirror = createMirror();
function record() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var emit = options.emit, checkoutEveryNms = options.checkoutEveryNms, checkoutEveryNth = options.checkoutEveryNth, _options_blockClass = options.blockClass, blockClass = _options_blockClass === void 0 ? 'rr-block' : _options_blockClass, _options_blockSelector = options.blockSelector, blockSelector = _options_blockSelector === void 0 ? null : _options_blockSelector, _options_unblockSelector = options.unblockSelector, unblockSelector = _options_unblockSelector === void 0 ? null : _options_unblockSelector, _options_ignoreClass = options.ignoreClass, ignoreClass = _options_ignoreClass === void 0 ? 'rr-ignore' : _options_ignoreClass, _options_ignoreSelector = options.ignoreSelector, ignoreSelector = _options_ignoreSelector === void 0 ? null : _options_ignoreSelector, _options_maskAllText = options.maskAllText, maskAllText = _options_maskAllText === void 0 ? false : _options_maskAllText, _options_maskTextClass = options.maskTextClass, maskTextClass = _options_maskTextClass === void 0 ? 'rr-mask' : _options_maskTextClass, _options_unmaskTextClass = options.unmaskTextClass, unmaskTextClass = _options_unmaskTextClass === void 0 ? null : _options_unmaskTextClass, _options_maskTextSelector = options.maskTextSelector, maskTextSelector = _options_maskTextSelector === void 0 ? null : _options_maskTextSelector, _options_unmaskTextSelector = options.unmaskTextSelector, unmaskTextSelector = _options_unmaskTextSelector === void 0 ? null : _options_unmaskTextSelector, _options_inlineStylesheet = options.inlineStylesheet, inlineStylesheet = _options_inlineStylesheet === void 0 ? true : _options_inlineStylesheet, maskAllInputs = options.maskAllInputs, _maskInputOptions = options.maskInputOptions, _slimDOMOptions = options.slimDOMOptions, maskAttributeFn = options.maskAttributeFn, maskInputFn = options.maskInputFn, maskTextFn = options.maskTextFn, _options_maxCanvasSize = options.maxCanvasSize, maxCanvasSize = _options_maxCanvasSize === void 0 ? null : _options_maxCanvasSize, packFn = options.packFn, _options_sampling = options.sampling, sampling = _options_sampling === void 0 ? {} : _options_sampling, _options_dataURLOptions = options.dataURLOptions, dataURLOptions = _options_dataURLOptions === void 0 ? {} : _options_dataURLOptions, mousemoveWait = options.mousemoveWait, _options_recordCanvas = options.recordCanvas, recordCanvas = _options_recordCanvas === void 0 ? false : _options_recordCanvas, _options_recordCrossOriginIframes = options.recordCrossOriginIframes, recordCrossOriginIframes = _options_recordCrossOriginIframes === void 0 ? false : _options_recordCrossOriginIframes, _options_recordAfter = options.recordAfter, recordAfter = _options_recordAfter === void 0 ? options.recordAfter === 'DOMContentLoaded' ? options.recordAfter : 'load' : _options_recordAfter, _options_userTriggeredOnInput = options.userTriggeredOnInput, userTriggeredOnInput = _options_userTriggeredOnInput === void 0 ? false : _options_userTriggeredOnInput, _options_collectFonts = options.collectFonts, collectFonts = _options_collectFonts === void 0 ? false : _options_collectFonts, _options_inlineImages = options.inlineImages, inlineImages = _options_inlineImages === void 0 ? false : _options_inlineImages, plugins = options.plugins, _options_keepIframeSrcFn = options.keepIframeSrcFn, keepIframeSrcFn = _options_keepIframeSrcFn === void 0 ? function() {
        return false;
    } : _options_keepIframeSrcFn, _options_ignoreCSSAttributes = options.ignoreCSSAttributes, ignoreCSSAttributes = _options_ignoreCSSAttributes === void 0 ? new Set([]) : _options_ignoreCSSAttributes, errorHandler = options.errorHandler, onMutation = options.onMutation, getCanvasManager = options.getCanvasManager;
    registerErrorHandler(errorHandler);
    var inEmittingFrame = recordCrossOriginIframes ? window.parent === window : true;
    var passEmitsToParent = false;
    if (!inEmittingFrame) try {
        if (window.parent.document) passEmitsToParent = false;
    } catch (e) {
        passEmitsToParent = true;
    }
    if (inEmittingFrame && !emit) throw new Error('emit function is required');
    if (mousemoveWait !== undefined && sampling.mousemove === undefined) sampling.mousemove = mousemoveWait;
    mirror.reset();
    var maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        'datetime-local': true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true,
        radio: true,
        checkbox: true
    } : _maskInputOptions !== undefined ? _maskInputOptions : {};
    var slimDOMOptions = _slimDOMOptions === true || _slimDOMOptions === 'all' ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaVerification: true,
        headMetaAuthorship: _slimDOMOptions === 'all',
        headMetaDescKeywords: _slimDOMOptions === 'all'
    } : _slimDOMOptions ? _slimDOMOptions : {};
    polyfill();
    var lastFullSnapshotEvent;
    var incrementalSnapshotCount = 0;
    var eventProcessor = function(e) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = (plugins || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var plugin = _step.value;
                if (plugin.eventProcessor) e = plugin.eventProcessor(e);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (packFn && !passEmitsToParent) e = packFn(e);
        return e;
    };
    wrappedEmit = function(r, isCheckout) {
        var e = r;
        e.timestamp = nowTimestamp();
        if ((0, _utils._optionalChain)([
            mutationBuffers,
            'access',
            function(_) {
                return _[0];
            },
            'optionalAccess',
            function(_2) {
                return _2.isFrozen;
            },
            'call',
            function(_3) {
                return _3();
            }
        ]) && e.type !== EventType.FullSnapshot && !(e.type === EventType.IncrementalSnapshot && e.data.source === IncrementalSource.Mutation)) mutationBuffers.forEach(function(buf) {
            return buf.unfreeze();
        });
        if (inEmittingFrame) (0, _utils._optionalChain)([
            emit,
            'optionalCall',
            function(_4) {
                return _4(eventProcessor(e), isCheckout);
            }
        ]);
        else if (passEmitsToParent) {
            var message = {
                type: 'rrweb',
                event: eventProcessor(e),
                origin: window.location.origin,
                isCheckout: isCheckout
            };
            window.parent.postMessage(message, '*');
        }
        if (e.type === EventType.FullSnapshot) {
            lastFullSnapshotEvent = e;
            incrementalSnapshotCount = 0;
        } else if (e.type === EventType.IncrementalSnapshot) {
            if (e.data.source === IncrementalSource.Mutation && e.data.isAttachIframe) return;
            incrementalSnapshotCount++;
            var exceedCount = checkoutEveryNth && incrementalSnapshotCount >= checkoutEveryNth;
            var exceedTime = checkoutEveryNms && lastFullSnapshotEvent && e.timestamp - lastFullSnapshotEvent.timestamp > checkoutEveryNms;
            if (exceedCount || exceedTime) _$takeFullSnapshot(true);
        }
    };
    var wrappedMutationEmit = function(m) {
        wrappedEmit({
            type: EventType.IncrementalSnapshot,
            data: (0, _objectSpread._)({
                source: IncrementalSource.Mutation
            }, m)
        });
    };
    var wrappedScrollEmit = function(p) {
        return wrappedEmit({
            type: EventType.IncrementalSnapshot,
            data: (0, _objectSpread._)({
                source: IncrementalSource.Scroll
            }, p)
        });
    };
    var wrappedCanvasMutationEmit = function(p) {
        return wrappedEmit({
            type: EventType.IncrementalSnapshot,
            data: (0, _objectSpread._)({
                source: IncrementalSource.CanvasMutation
            }, p)
        });
    };
    var wrappedAdoptedStyleSheetEmit = function(a) {
        return wrappedEmit({
            type: EventType.IncrementalSnapshot,
            data: (0, _objectSpread._)({
                source: IncrementalSource.AdoptedStyleSheet
            }, a)
        });
    };
    var stylesheetManager = new StylesheetManager({
        mutationCb: wrappedMutationEmit,
        adoptedStyleSheetCb: wrappedAdoptedStyleSheetEmit
    });
    var iframeManager = typeof __RRWEB_EXCLUDE_IFRAME__ === 'boolean' && __RRWEB_EXCLUDE_IFRAME__ ? new IframeManagerNoop() : new IframeManager({
        mirror: mirror,
        mutationCb: wrappedMutationEmit,
        stylesheetManager: stylesheetManager,
        recordCrossOriginIframes: recordCrossOriginIframes,
        wrappedEmit: wrappedEmit
    });
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = (plugins || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var plugin = _step.value;
            if (plugin.getMirror) plugin.getMirror({
                nodeMirror: mirror,
                crossOriginIframeMirror: iframeManager.crossOriginIframeMirror,
                crossOriginIframeStyleMirror: iframeManager.crossOriginIframeStyleMirror
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var processedNodeManager = new ProcessedNodeManager();
    var canvasManager = _getCanvasManager(getCanvasManager, {
        mirror: mirror,
        win: window,
        mutationCb: function(p) {
            return wrappedEmit({
                type: EventType.IncrementalSnapshot,
                data: (0, _objectSpread._)({
                    source: IncrementalSource.CanvasMutation
                }, p)
            });
        },
        recordCanvas: recordCanvas,
        blockClass: blockClass,
        blockSelector: blockSelector,
        unblockSelector: unblockSelector,
        maxCanvasSize: maxCanvasSize,
        sampling: sampling['canvas'],
        dataURLOptions: dataURLOptions,
        errorHandler: errorHandler
    });
    var shadowDomManager = typeof __RRWEB_EXCLUDE_SHADOW_DOM__ === 'boolean' && __RRWEB_EXCLUDE_SHADOW_DOM__ ? new ShadowDomManagerNoop() : new ShadowDomManager({
        mutationCb: wrappedMutationEmit,
        scrollCb: wrappedScrollEmit,
        bypassOptions: {
            onMutation: onMutation,
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskAllText: maskAllText,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            dataURLOptions: dataURLOptions,
            maskAttributeFn: maskAttributeFn,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            sampling: sampling,
            slimDOMOptions: slimDOMOptions,
            iframeManager: iframeManager,
            stylesheetManager: stylesheetManager,
            canvasManager: canvasManager,
            keepIframeSrcFn: keepIframeSrcFn,
            processedNodeManager: processedNodeManager
        },
        mirror: mirror
    });
    var _$takeFullSnapshot = function() {
        var isCheckout = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        wrappedEmit({
            type: EventType.Meta,
            data: {
                href: window.location.href,
                width: getWindowWidth(),
                height: getWindowHeight()
            }
        }, isCheckout);
        stylesheetManager.reset();
        shadowDomManager.init();
        mutationBuffers.forEach(function(buf) {
            return buf.lock();
        });
        var node = snapshot(document, {
            mirror: mirror,
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskAllText: maskAllText,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskAllInputs: maskInputOptions,
            maskAttributeFn: maskAttributeFn,
            maskInputFn: maskInputFn,
            maskTextFn: maskTextFn,
            slimDOM: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            onSerialize: function(n) {
                if (isSerializedIframe(n, mirror)) iframeManager.addIframe(n);
                if (isSerializedStylesheet(n, mirror)) stylesheetManager.trackLinkElement(n);
                if (hasShadowRoot(n)) shadowDomManager.addShadowRoot(n.shadowRoot, document);
            },
            onIframeLoad: function(iframe, childSn) {
                iframeManager.attachIframe(iframe, childSn);
                shadowDomManager.observeAttachShadow(iframe);
            },
            onStylesheetLoad: function(linkEl, childSn) {
                stylesheetManager.attachLinkElement(linkEl, childSn);
            },
            keepIframeSrcFn: keepIframeSrcFn
        });
        if (!node) return console.warn('Failed to snapshot the document');
        wrappedEmit({
            type: EventType.FullSnapshot,
            data: {
                node: node,
                initialOffset: getWindowScroll(window)
            }
        });
        mutationBuffers.forEach(function(buf) {
            return buf.unlock();
        });
        if (document.adoptedStyleSheets && document.adoptedStyleSheets.length > 0) stylesheetManager.adoptStyleSheets(document.adoptedStyleSheets, mirror.getId(document));
    };
    _takeFullSnapshot = _$takeFullSnapshot;
    try {
        var handlers = [];
        var observe = function(doc) {
            return callbackWrapper(initObservers)({
                onMutation: onMutation,
                mutationCb: wrappedMutationEmit,
                mousemoveCb: function(positions, source) {
                    return wrappedEmit({
                        type: EventType.IncrementalSnapshot,
                        data: {
                            source: source,
                            positions: positions
                        }
                    });
                },
                mouseInteractionCb: function(d) {
                    return wrappedEmit({
                        type: EventType.IncrementalSnapshot,
                        data: (0, _objectSpread._)({
                            source: IncrementalSource.MouseInteraction
                        }, d)
                    });
                },
                scrollCb: wrappedScrollEmit,
                viewportResizeCb: function(d) {
                    return wrappedEmit({
                        type: EventType.IncrementalSnapshot,
                        data: (0, _objectSpread._)({
                            source: IncrementalSource.ViewportResize
                        }, d)
                    });
                },
                inputCb: function(v) {
                    return wrappedEmit({
                        type: EventType.IncrementalSnapshot,
                        data: (0, _objectSpread._)({
                            source: IncrementalSource.Input
                        }, v)
                    });
                },
                mediaInteractionCb: function(p) {
                    return wrappedEmit({
                        type: EventType.IncrementalSnapshot,
                        data: (0, _objectSpread._)({
                            source: IncrementalSource.MediaInteraction
                        }, p)
                    });
                },
                styleSheetRuleCb: function(r) {
                    return wrappedEmit({
                        type: EventType.IncrementalSnapshot,
                        data: (0, _objectSpread._)({
                            source: IncrementalSource.StyleSheetRule
                        }, r)
                    });
                },
                styleDeclarationCb: function(r) {
                    return wrappedEmit({
                        type: EventType.IncrementalSnapshot,
                        data: (0, _objectSpread._)({
                            source: IncrementalSource.StyleDeclaration
                        }, r)
                    });
                },
                canvasMutationCb: wrappedCanvasMutationEmit,
                fontCb: function(p) {
                    return wrappedEmit({
                        type: EventType.IncrementalSnapshot,
                        data: (0, _objectSpread._)({
                            source: IncrementalSource.Font
                        }, p)
                    });
                },
                selectionCb: function(p) {
                    wrappedEmit({
                        type: EventType.IncrementalSnapshot,
                        data: (0, _objectSpread._)({
                            source: IncrementalSource.Selection
                        }, p)
                    });
                },
                customElementCb: function(c) {
                    wrappedEmit({
                        type: EventType.IncrementalSnapshot,
                        data: (0, _objectSpread._)({
                            source: IncrementalSource.CustomElement
                        }, c)
                    });
                },
                blockClass: blockClass,
                ignoreClass: ignoreClass,
                ignoreSelector: ignoreSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                maskInputOptions: maskInputOptions,
                inlineStylesheet: inlineStylesheet,
                sampling: sampling,
                recordCanvas: recordCanvas,
                inlineImages: inlineImages,
                userTriggeredOnInput: userTriggeredOnInput,
                collectFonts: collectFonts,
                doc: doc,
                maskAttributeFn: maskAttributeFn,
                maskInputFn: maskInputFn,
                maskTextFn: maskTextFn,
                keepIframeSrcFn: keepIframeSrcFn,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                mirror: mirror,
                iframeManager: iframeManager,
                stylesheetManager: stylesheetManager,
                shadowDomManager: shadowDomManager,
                processedNodeManager: processedNodeManager,
                canvasManager: canvasManager,
                ignoreCSSAttributes: ignoreCSSAttributes,
                plugins: (0, _utils._optionalChain)([
                    plugins,
                    'optionalAccess',
                    function(_5) {
                        return _5.filter;
                    },
                    'call',
                    function(_6) {
                        return _6(function(p) {
                            return p.observer;
                        });
                    },
                    'optionalAccess',
                    function(_7) {
                        return _7.map;
                    },
                    'call',
                    function(_8) {
                        return _8(function(p) {
                            return {
                                observer: p.observer,
                                options: p.options,
                                callback: function(payload) {
                                    return wrappedEmit({
                                        type: EventType.Plugin,
                                        data: {
                                            plugin: p.name,
                                            payload: payload
                                        }
                                    });
                                }
                            };
                        });
                    }
                ]) || []
            }, {});
        };
        iframeManager.addLoadListener(function(iframeEl) {
            try {
                handlers.push(observe(iframeEl.contentDocument));
            } catch (error) {
                console.warn(error);
            }
        });
        var init = function() {
            _$takeFullSnapshot();
            handlers.push(observe(document));
        };
        if (document.readyState === 'interactive' || document.readyState === 'complete') init();
        else {
            handlers.push(on('DOMContentLoaded', function() {
                wrappedEmit({
                    type: EventType.DomContentLoaded,
                    data: {}
                });
                if (recordAfter === 'DOMContentLoaded') init();
            }));
            handlers.push(on('load', function() {
                wrappedEmit({
                    type: EventType.Load,
                    data: {}
                });
                if (recordAfter === 'load') init();
            }, window));
        }
        return function() {
            handlers.forEach(function(h) {
                return h();
            });
            processedNodeManager.destroy();
            _takeFullSnapshot = undefined;
            unregisterErrorHandler();
        };
    } catch (error) {
        console.warn(error);
    }
}
function takeFullSnapshot(isCheckout) {
    if (!_takeFullSnapshot) throw new Error('please take full snapshot after start recording');
    _takeFullSnapshot(isCheckout);
}
record.mirror = mirror;
record.takeFullSnapshot = takeFullSnapshot;
function _getCanvasManager(getCanvasManagerFn, options) {
    try {
        return getCanvasManagerFn ? getCanvasManagerFn(options) : new CanvasManagerNoop();
    } catch (e2) {
        console.warn('Unable to initialize CanvasManager');
        return new CanvasManagerNoop();
    }
}
var ReplayEventTypeIncrementalSnapshot = 3;
var ReplayEventTypeCustom = 5;
/**
 * Converts a timestamp to ms, if it was in s, or keeps it as ms.
 */ function timestampToMs(timestamp) {
    var isMs = timestamp > 9999999999;
    return isMs ? timestamp : timestamp * 1000;
}
/**
 * Converts a timestamp to s, if it was in ms, or keeps it as s.
 */ function timestampToS(timestamp) {
    var isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Add a breadcrumb event to replay.
 */ function addBreadcrumbEvent(replay, breadcrumb) {
    if (breadcrumb.category === 'sentry.transaction') return;
    if ([
        'ui.click',
        'ui.input'
    ].includes(breadcrumb.category)) replay.triggerUserActivity();
    else replay.checkAndHandleExpiredSession();
    replay.addUpdate(function() {
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        replay.throttledAddEvent({
            type: EventType.Custom,
            // TODO: We were converting from ms to seconds for breadcrumbs, spans,
            // but maybe we should just keep them as milliseconds
            timestamp: (breadcrumb.timestamp || 0) * 1000,
            data: {
                tag: 'breadcrumb',
                // normalize to max. 10 depth and 1_000 properties per object
                payload: (0, _utils.normalize)(breadcrumb, 10, 1000)
            }
        });
        // Do not flush after console log messages
        return breadcrumb.category === 'console';
    });
}
var INTERACTIVE_SELECTOR = 'button,a';
/** Get the closest interactive parent element, or else return the given element. */ function getClosestInteractive(element) {
    var closestInteractive = element.closest(INTERACTIVE_SELECTOR);
    return closestInteractive || element;
}
/**
 * For clicks, we check if the target is inside of a button or link
 * If so, we use this as the target instead
 * This is useful because if you click on the image in <button><img></button>,
 * The target will be the image, not the button, which we don't want here
 */ function getClickTargetNode(event) {
    var target = getTargetNode(event);
    if (!target || !(target instanceof Element)) return target;
    return getClosestInteractive(target);
}
/** Get the event target node. */ function getTargetNode(event) {
    if (isEventWithTarget(event)) return event.target;
    return event;
}
function isEventWithTarget(event) {
    return typeof event === 'object' && !!event && 'target' in event;
}
var handlers;
/**
 * Register a handler to be called when `window.open()` is called.
 * Returns a cleanup function.
 */ function onWindowOpen(cb) {
    // Ensure to only register this once
    if (!handlers) {
        handlers = [];
        monkeyPatchWindowOpen();
    }
    handlers.push(cb);
    return function() {
        var pos = handlers ? handlers.indexOf(cb) : -1;
        if (pos > -1) handlers.splice(pos, 1);
    };
}
function monkeyPatchWindowOpen() {
    (0, _utils.fill)(WINDOW, 'open', function(originalWindowOpen) {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (handlers) try {
                handlers.forEach(function(handler) {
                    return handler();
                });
            } catch (e) {
            // ignore errors in here
            }
            return originalWindowOpen.apply(WINDOW, args);
        };
    });
}
/** Handle a click. */ function handleClick(clickDetector, clickBreadcrumb, node) {
    clickDetector.handleClick(clickBreadcrumb, node);
}
/** A click detector class that can be used to detect slow or rage clicks on elements. */ var ClickDetector = /*#__PURE__*/ function() {
    "use strict";
    function ClickDetector(replay, slowClickConfig) {
        var // Just for easier testing
        _addBreadcrumbEvent = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : addBreadcrumbEvent;
        (0, _classCallCheck._)(this, ClickDetector);
        this._lastMutation = 0;
        this._lastScroll = 0;
        this._clicks = [];
        // We want everything in s, but options are in ms
        this._timeout = slowClickConfig.timeout / 1000;
        this._threshold = slowClickConfig.threshold / 1000;
        this._scollTimeout = slowClickConfig.scrollTimeout / 1000;
        this._replay = replay;
        this._ignoreSelector = slowClickConfig.ignoreSelector;
        this._addBreadcrumbEvent = _addBreadcrumbEvent;
    }
    (0, _createClass._)(ClickDetector, [
        {
            /** Register click detection handlers on mutation or scroll. */ key: "addListeners",
            value: function addListeners() {
                var _this = this;
                var cleanupWindowOpen = onWindowOpen(function() {
                    // Treat window.open as mutation
                    _this._lastMutation = nowInSeconds();
                });
                this._teardown = function() {
                    cleanupWindowOpen();
                    _this._clicks = [];
                    _this._lastMutation = 0;
                    _this._lastScroll = 0;
                };
            }
        },
        {
            /** Clean up listeners. */ key: "removeListeners",
            value: function removeListeners() {
                if (this._teardown) this._teardown();
                if (this._checkClickTimeout) clearTimeout(this._checkClickTimeout);
            }
        },
        {
            /** @inheritDoc */ key: "handleClick",
            value: function handleClick(breadcrumb, node) {
                if (ignoreElement(node, this._ignoreSelector) || !isClickBreadcrumb(breadcrumb)) return;
                var newClick = {
                    timestamp: timestampToS(breadcrumb.timestamp),
                    clickBreadcrumb: breadcrumb,
                    // Set this to 0 so we know it originates from the click breadcrumb
                    clickCount: 0,
                    node: node
                };
                // If there was a click in the last 1s on the same element, ignore it - only keep a single reference per second
                if (this._clicks.some(function(click) {
                    return click.node === newClick.node && Math.abs(click.timestamp - newClick.timestamp) < 1;
                })) return;
                this._clicks.push(newClick);
                // If this is the first new click, set a timeout to check for multi clicks
                if (this._clicks.length === 1) this._scheduleCheckClicks();
            }
        },
        {
            /** @inheritDoc */ key: "registerMutation",
            value: function registerMutation() {
                var timestamp = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Date.now();
                this._lastMutation = timestampToS(timestamp);
            }
        },
        {
            /** @inheritDoc */ key: "registerScroll",
            value: function registerScroll() {
                var timestamp = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Date.now();
                this._lastScroll = timestampToS(timestamp);
            }
        },
        {
            /** @inheritDoc */ key: "registerClick",
            value: function registerClick(element) {
                var node = getClosestInteractive(element);
                this._handleMultiClick(node);
            }
        },
        {
            /** Count multiple clicks on elements. */ key: "_handleMultiClick",
            value: function _handleMultiClick(node) {
                this._getClicks(node).forEach(function(click) {
                    click.clickCount++;
                });
            }
        },
        {
            /** Get all pending clicks for a given node. */ key: "_getClicks",
            value: function _getClicks(node) {
                return this._clicks.filter(function(click) {
                    return click.node === node;
                });
            }
        },
        {
            /** Check the clicks that happened. */ key: "_checkClicks",
            value: function _checkClicks() {
                var _this = this;
                var timedOutClicks = [];
                var now = nowInSeconds();
                this._clicks.forEach(function(click) {
                    if (!click.mutationAfter && _this._lastMutation) click.mutationAfter = click.timestamp <= _this._lastMutation ? _this._lastMutation - click.timestamp : undefined;
                    if (!click.scrollAfter && _this._lastScroll) click.scrollAfter = click.timestamp <= _this._lastScroll ? _this._lastScroll - click.timestamp : undefined;
                    // All of these are in seconds!
                    if (click.timestamp + _this._timeout <= now) timedOutClicks.push(click);
                });
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    // Remove "old" clicks
                    for(var _iterator = timedOutClicks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var click = _step.value;
                        var pos = this._clicks.indexOf(click);
                        if (pos > -1) {
                            this._generateBreadcrumbs(click);
                            this._clicks.splice(pos, 1);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                // Trigger new check, unless no clicks left
                if (this._clicks.length) this._scheduleCheckClicks();
            }
        },
        {
            /** Generate matching breadcrumb(s) for the click. */ key: "_generateBreadcrumbs",
            value: function _generateBreadcrumbs(click) {
                var replay = this._replay;
                var hadScroll = click.scrollAfter && click.scrollAfter <= this._scollTimeout;
                var hadMutation = click.mutationAfter && click.mutationAfter <= this._threshold;
                var isSlowClick = !hadScroll && !hadMutation;
                var clickCount = click.clickCount, clickBreadcrumb = click.clickBreadcrumb;
                // Slow click
                if (isSlowClick) {
                    // If `mutationAfter` is set, it means a mutation happened after the threshold, but before the timeout
                    // If not, it means we just timed out without scroll & mutation
                    var timeAfterClickMs = Math.min(click.mutationAfter || this._timeout, this._timeout) * 1000;
                    var endReason = timeAfterClickMs < this._timeout * 1000 ? 'mutation' : 'timeout';
                    var breadcrumb = {
                        type: 'default',
                        message: clickBreadcrumb.message,
                        timestamp: clickBreadcrumb.timestamp,
                        category: 'ui.slowClickDetected',
                        data: (0, _objectSpreadProps._)((0, _objectSpread._)({}, clickBreadcrumb.data), {
                            url: WINDOW.location.href,
                            route: replay.getCurrentRoute(),
                            timeAfterClickMs: timeAfterClickMs,
                            endReason: endReason,
                            // If clickCount === 0, it means multiClick was not correctly captured here
                            // - we still want to send 1 in this case
                            clickCount: clickCount || 1
                        })
                    };
                    this._addBreadcrumbEvent(replay, breadcrumb);
                    return;
                }
                // Multi click
                if (clickCount > 1) {
                    var breadcrumb1 = {
                        type: 'default',
                        message: clickBreadcrumb.message,
                        timestamp: clickBreadcrumb.timestamp,
                        category: 'ui.multiClick',
                        data: (0, _objectSpreadProps._)((0, _objectSpread._)({}, clickBreadcrumb.data), {
                            url: WINDOW.location.href,
                            route: replay.getCurrentRoute(),
                            clickCount: clickCount,
                            metric: true
                        })
                    };
                    this._addBreadcrumbEvent(replay, breadcrumb1);
                }
            }
        },
        {
            /** Schedule to check current clicks. */ key: "_scheduleCheckClicks",
            value: function _scheduleCheckClicks() {
                var _this = this;
                if (this._checkClickTimeout) clearTimeout(this._checkClickTimeout);
                this._checkClickTimeout = setTimeout(function() {
                    return _this._checkClicks();
                }, 1000);
            }
        }
    ]);
    return ClickDetector;
}();
var SLOW_CLICK_TAGS = [
    'A',
    'BUTTON',
    'INPUT'
];
/** exported for tests only */ function ignoreElement(node, ignoreSelector) {
    if (!SLOW_CLICK_TAGS.includes(node.tagName)) return true;
    // If <input> tag, we only want to consider input[type='submit'] & input[type='button']
    if (node.tagName === 'INPUT' && ![
        'submit',
        'button'
    ].includes(node.getAttribute('type') || '')) return true;
    // If <a> tag, detect special variants that may not lead to an action
    // If target !== _self, we may open the link somewhere else, which would lead to no action
    // Also, when downloading a file, we may not leave the page, but still not trigger an action
    if (node.tagName === 'A' && (node.hasAttribute('download') || node.hasAttribute('target') && node.getAttribute('target') !== '_self')) return true;
    if (ignoreSelector && node.matches(ignoreSelector)) return true;
    return false;
}
function isClickBreadcrumb(breadcrumb) {
    return !!(breadcrumb.data && typeof breadcrumb.data.nodeId === 'number' && breadcrumb.timestamp);
}
// This is good enough for us, and is easier to test/mock than `timestampInSeconds`
function nowInSeconds() {
    return Date.now() / 1000;
}
/** Update the click detector based on a recording event of rrweb. */ function updateClickDetectorForRecordingEvent(clickDetector, event) {
    try {
        // note: We only consider incremental snapshots here
        // This means that any full snapshot is ignored for mutation detection - the reason is that we simply cannot know if a mutation happened here.
        // E.g. think that we are buffering, an error happens and we take a full snapshot because we switched to session mode -
        // in this scenario, we would not know if a dead click happened because of the error, which is a key dead click scenario.
        // Instead, by ignoring full snapshots, we have the risk that we generate a false positive
        // (if a mutation _did_ happen but was "swallowed" by the full snapshot)
        // But this should be more unlikely as we'd generally capture the incremental snapshot right away
        if (!isIncrementalEvent(event)) return;
        var source = event.data.source;
        if (source === IncrementalSource.Mutation) clickDetector.registerMutation(event.timestamp);
        if (source === IncrementalSource.Scroll) clickDetector.registerScroll(event.timestamp);
        if (isIncrementalMouseInteraction(event)) {
            var _event_data = event.data, type = _event_data.type, id = _event_data.id;
            var node = record.mirror.getNode(id);
            if (node instanceof HTMLElement && type === MouseInteractions.Click) clickDetector.registerClick(node);
        }
    } catch (e) {
    // ignore errors here, e.g. if accessing something that does not exist
    }
}
function isIncrementalEvent(event) {
    return event.type === ReplayEventTypeIncrementalSnapshot;
}
function isIncrementalMouseInteraction(event) {
    return event.data.source === IncrementalSource.MouseInteraction;
}
/**
 * Create a breadcrumb for a replay.
 */ function createBreadcrumb(breadcrumb) {
    return (0, _objectSpread._)({
        timestamp: Date.now() / 1000,
        type: 'default'
    }, breadcrumb);
}
var NodeType;
(function(NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})(NodeType || (NodeType = {}));
// Note that these are the serialized attributes and not attributes directly on
// the DOM Node. Attributes we are interested in:
var ATTRIBUTES_TO_RECORD = new Set([
    'id',
    'class',
    'aria-label',
    'role',
    'name',
    'alt',
    'title',
    'data-test-id',
    'data-testid',
    'disabled',
    'aria-disabled',
    'data-sentry-component'
]);
/**
 * Inclusion list of attributes that we want to record from the DOM element
 */ function getAttributesToRecord(attributes) {
    var obj = {};
    for(var key in attributes)if (ATTRIBUTES_TO_RECORD.has(key)) {
        var normalizedKey = key;
        if (key === 'data-testid' || key === 'data-test-id') normalizedKey = 'testId';
        obj[normalizedKey] = attributes[key];
    }
    return obj;
}
var handleDomListener = function(replay) {
    return function(handlerData) {
        if (!replay.isEnabled()) return;
        var result = handleDom(handlerData);
        if (!result) return;
        var isClick = handlerData.name === 'click';
        var event = isClick ? handlerData.event : undefined;
        // Ignore clicks if ctrl/alt/meta/shift keys are held down as they alter behavior of clicks (e.g. open in new tab)
        if (isClick && replay.clickDetector && event && event.target && !event.altKey && !event.metaKey && !event.ctrlKey && !event.shiftKey) handleClick(replay.clickDetector, result, getClickTargetNode(handlerData.event));
        addBreadcrumbEvent(replay, result);
    };
};
/** Get the base DOM breadcrumb. */ function getBaseDomBreadcrumb(target, message) {
    var nodeId = record.mirror.getId(target);
    var node = nodeId && record.mirror.getNode(nodeId);
    var meta = node && record.mirror.getMeta(node);
    var element = meta && isElement(meta) ? meta : null;
    return {
        message: message,
        data: element ? {
            nodeId: nodeId,
            node: {
                id: nodeId,
                tagName: element.tagName,
                textContent: Array.from(element.childNodes).map(function(node) {
                    return node.type === NodeType.Text && node.textContent;
                }).filter(Boolean) // filter out empty values
                .map(function(text) {
                    return text.trim();
                }).join(''),
                attributes: getAttributesToRecord(element.attributes)
            }
        } : {}
    };
}
/**
 * An event handler to react to DOM events.
 * Exported for tests.
 */ function handleDom(handlerData) {
    var _getDomTarget = getDomTarget(handlerData), target = _getDomTarget.target, message = _getDomTarget.message;
    return createBreadcrumb((0, _objectSpread._)({
        category: `ui.${handlerData.name}`
    }, getBaseDomBreadcrumb(target, message)));
}
function getDomTarget(handlerData) {
    var isClick = handlerData.name === 'click';
    var message;
    var target = null;
    // Accessing event.target can throw (see getsentry/raven-js#838, #768)
    try {
        target = isClick ? getClickTargetNode(handlerData.event) : getTargetNode(handlerData.event);
        message = (0, _utils.htmlTreeAsString)(target, {
            maxStringLength: 200
        }) || '<unknown>';
    } catch (e) {
        message = '<unknown>';
    }
    return {
        target: target,
        message: message
    };
}
function isElement(node) {
    return node.type === NodeType.Element;
}
/** Handle keyboard events & create breadcrumbs. */ function handleKeyboardEvent(replay, event) {
    if (!replay.isEnabled()) return;
    // Update user activity, but do not restart recording as it can create
    // noisy/low-value replays (e.g. user comes back from idle, hits alt-tab, new
    // session with a single "keydown" breadcrumb is created)
    replay.updateUserActivity();
    var breadcrumb = getKeyboardBreadcrumb(event);
    if (!breadcrumb) return;
    addBreadcrumbEvent(replay, breadcrumb);
}
/** exported only for tests */ function getKeyboardBreadcrumb(event) {
    var metaKey = event.metaKey, shiftKey = event.shiftKey, ctrlKey = event.ctrlKey, altKey = event.altKey, key = event.key, target = event.target;
    // never capture for input fields
    if (!target || isInputElement(target) || !key) return null;
    // Note: We do not consider shift here, as that means "uppercase"
    var hasModifierKey = metaKey || ctrlKey || altKey;
    var isCharacterKey = key.length === 1; // other keys like Escape, Tab, etc have a longer length
    // Do not capture breadcrumb if only a word key is pressed
    // This could leak e.g. user input
    if (!hasModifierKey && isCharacterKey) return null;
    var message = (0, _utils.htmlTreeAsString)(target, {
        maxStringLength: 200
    }) || '<unknown>';
    var baseBreadcrumb = getBaseDomBreadcrumb(target, message);
    return createBreadcrumb({
        category: 'ui.keyDown',
        message: message,
        data: (0, _objectSpreadProps._)((0, _objectSpread._)({}, baseBreadcrumb.data), {
            metaKey: metaKey,
            shiftKey: shiftKey,
            ctrlKey: ctrlKey,
            altKey: altKey,
            key: key
        })
    });
}
function isInputElement(target) {
    return target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable;
}
// Map entryType -> function to normalize data for event
var ENTRY_TYPES = {
    // @ts-expect-error TODO: entry type does not fit the create* functions entry type
    resource: createResourceEntry,
    paint: createPaintEntry,
    // @ts-expect-error TODO: entry type does not fit the create* functions entry type
    navigation: createNavigationEntry
};
/**
 * Create replay performance entries from the browser performance entries.
 */ function createPerformanceEntries(entries) {
    return entries.map(createPerformanceEntry).filter(Boolean);
}
function createPerformanceEntry(entry) {
    if (!ENTRY_TYPES[entry.entryType]) return null;
    return ENTRY_TYPES[entry.entryType](entry);
}
function getAbsoluteTime(time) {
    // browserPerformanceTimeOrigin can be undefined if `performance` or
    // `performance.now` doesn't exist, but this is already checked by this integration
    return (((0, _utils.browserPerformanceTimeOrigin) || WINDOW.performance.timeOrigin) + time) / 1000;
}
function createPaintEntry(entry) {
    var duration = entry.duration, entryType = entry.entryType, name = entry.name, startTime = entry.startTime;
    var start = getAbsoluteTime(startTime);
    return {
        type: entryType,
        name: name,
        start: start,
        end: start + duration,
        data: undefined
    };
}
function createNavigationEntry(entry) {
    var entryType = entry.entryType, name = entry.name, decodedBodySize = entry.decodedBodySize, duration = entry.duration, domComplete = entry.domComplete, encodedBodySize = entry.encodedBodySize, domContentLoadedEventStart = entry.domContentLoadedEventStart, domContentLoadedEventEnd = entry.domContentLoadedEventEnd, domInteractive = entry.domInteractive, loadEventStart = entry.loadEventStart, loadEventEnd = entry.loadEventEnd, redirectCount = entry.redirectCount, startTime = entry.startTime, transferSize = entry.transferSize, type = entry.type;
    // Ignore entries with no duration, they do not seem to be useful and cause dupes
    if (duration === 0) return null;
    return {
        type: `${entryType}.${type}`,
        start: getAbsoluteTime(startTime),
        end: getAbsoluteTime(domComplete),
        name: name,
        data: {
            size: transferSize,
            decodedBodySize: decodedBodySize,
            encodedBodySize: encodedBodySize,
            duration: duration,
            domInteractive: domInteractive,
            domContentLoadedEventStart: domContentLoadedEventStart,
            domContentLoadedEventEnd: domContentLoadedEventEnd,
            loadEventStart: loadEventStart,
            loadEventEnd: loadEventEnd,
            domComplete: domComplete,
            redirectCount: redirectCount
        }
    };
}
function createResourceEntry(entry) {
    var entryType = entry.entryType, initiatorType = entry.initiatorType, name = entry.name, responseEnd = entry.responseEnd, startTime = entry.startTime, decodedBodySize = entry.decodedBodySize, encodedBodySize = entry.encodedBodySize, responseStatus = entry.responseStatus, transferSize = entry.transferSize;
    // Core SDK handles these
    if ([
        'fetch',
        'xmlhttprequest'
    ].includes(initiatorType)) return null;
    return {
        type: `${entryType}.${initiatorType}`,
        start: getAbsoluteTime(startTime),
        end: getAbsoluteTime(responseEnd),
        name: name,
        data: {
            size: transferSize,
            statusCode: responseStatus,
            decodedBodySize: decodedBodySize,
            encodedBodySize: encodedBodySize
        }
    };
}
/**
 * Add a LCP event to the replay based on an LCP metric.
 */ function getLargestContentfulPaint(metric) {
    var entries = metric.entries;
    var lastEntry = entries[entries.length - 1];
    var element = lastEntry ? lastEntry.element : undefined;
    var value = metric.value;
    var end = getAbsoluteTime(value);
    var data = {
        type: 'largest-contentful-paint',
        name: 'largest-contentful-paint',
        start: end,
        end: end,
        data: {
            value: value,
            size: value,
            nodeId: element ? record.mirror.getId(element) : undefined
        }
    };
    return data;
}
/**
 * Sets up a PerformanceObserver to listen to all performance entry types.
 * Returns a callback to stop observing.
 */ function setupPerformanceObserver(replay) {
    function addPerformanceEntry(entry) {
        // It is possible for entries to come up multiple times
        if (!replay.performanceEntries.includes(entry)) replay.performanceEntries.push(entry);
    }
    function onEntries(param) {
        var entries = param.entries;
        entries.forEach(addPerformanceEntry);
    }
    var clearCallbacks = [];
    [
        'navigation',
        'paint',
        'resource'
    ].forEach(function(type) {
        clearCallbacks.push((0, _tracing.addPerformanceInstrumentationHandler)(type, onEntries));
    });
    clearCallbacks.push((0, _tracing.addLcpInstrumentationHandler)(function(param) {
        var metric = param.metric;
        replay.replayPerformanceEntries.push(getLargestContentfulPaint(metric));
    }));
    // A callback to cleanup all handlers
    return function() {
        clearCallbacks.forEach(function(clearCallback) {
            return clearCallback();
        });
    };
}
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ var DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;
var r = `var t=Uint8Array,n=Uint16Array,r=Int32Array,e=new t([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0,0,0,0]),i=new t([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13,0,0]),a=new t([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),s=function(t,e){for(var i=new n(31),a=0;a<31;++a)i[a]=e+=1<<t[a-1];var s=new r(i[30]);for(a=1;a<30;++a)for(var o=i[a];o<i[a+1];++o)s[o]=o-i[a]<<5|a;return{b:i,r:s}},o=s(e,2),f=o.b,h=o.r;f[28]=258,h[258]=28;for(var l=s(i,0).r,u=new n(32768),c=0;c<32768;++c){var v=(43690&c)>>1|(21845&c)<<1;v=(61680&(v=(52428&v)>>2|(13107&v)<<2))>>4|(3855&v)<<4,u[c]=((65280&v)>>8|(255&v)<<8)>>1}var d=function(t,r,e){for(var i=t.length,a=0,s=new n(r);a<i;++a)t[a]&&++s[t[a]-1];var o,f=new n(r);for(a=1;a<r;++a)f[a]=f[a-1]+s[a-1]<<1;if(e){o=new n(1<<r);var h=15-r;for(a=0;a<i;++a)if(t[a])for(var l=a<<4|t[a],c=r-t[a],v=f[t[a]-1]++<<c,d=v|(1<<c)-1;v<=d;++v)o[u[v]>>h]=l}else for(o=new n(i),a=0;a<i;++a)t[a]&&(o[a]=u[f[t[a]-1]++]>>15-t[a]);return o},g=new t(288);for(c=0;c<144;++c)g[c]=8;for(c=144;c<256;++c)g[c]=9;for(c=256;c<280;++c)g[c]=7;for(c=280;c<288;++c)g[c]=8;var w=new t(32);for(c=0;c<32;++c)w[c]=5;var p=d(g,9,0),y=d(w,5,0),m=function(t){return(t+7)/8|0},b=function(n,r,e){return(null==r||r<0)&&(r=0),(null==e||e>n.length)&&(e=n.length),new t(n.subarray(r,e))},M=["unexpected EOF","invalid block type","invalid length/literal","invalid distance","stream finished","no stream handler",,"no callback","invalid UTF-8 data","extra field too long","date not in range 1980-2099","filename too long","stream finishing","invalid zip data"],E=function(t,n,r){var e=new Error(n||M[t]);if(e.code=t,Error.captureStackTrace&&Error.captureStackTrace(e,E),!r)throw e;return e},z=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8},A=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8,t[e+2]|=r>>16},_=function(r,e){for(var i=[],a=0;a<r.length;++a)r[a]&&i.push({s:a,f:r[a]});var s=i.length,o=i.slice();if(!s)return{t:F,l:0};if(1==s){var f=new t(i[0].s+1);return f[i[0].s]=1,{t:f,l:1}}i.sort((function(t,n){return t.f-n.f})),i.push({s:-1,f:25001});var h=i[0],l=i[1],u=0,c=1,v=2;for(i[0]={s:-1,f:h.f+l.f,l:h,r:l};c!=s-1;)h=i[i[u].f<i[v].f?u++:v++],l=i[u!=c&&i[u].f<i[v].f?u++:v++],i[c++]={s:-1,f:h.f+l.f,l:h,r:l};var d=o[0].s;for(a=1;a<s;++a)o[a].s>d&&(d=o[a].s);var g=new n(d+1),w=x(i[c-1],g,0);if(w>e){a=0;var p=0,y=w-e,m=1<<y;for(o.sort((function(t,n){return g[n.s]-g[t.s]||t.f-n.f}));a<s;++a){var b=o[a].s;if(!(g[b]>e))break;p+=m-(1<<w-g[b]),g[b]=e}for(p>>=y;p>0;){var M=o[a].s;g[M]<e?p-=1<<e-g[M]++-1:++a}for(;a>=0&&p;--a){var E=o[a].s;g[E]==e&&(--g[E],++p)}w=e}return{t:new t(g),l:w}},x=function(t,n,r){return-1==t.s?Math.max(x(t.l,n,r+1),x(t.r,n,r+1)):n[t.s]=r},D=function(t){for(var r=t.length;r&&!t[--r];);for(var e=new n(++r),i=0,a=t[0],s=1,o=function(t){e[i++]=t},f=1;f<=r;++f)if(t[f]==a&&f!=r)++s;else{if(!a&&s>2){for(;s>138;s-=138)o(32754);s>2&&(o(s>10?s-11<<5|28690:s-3<<5|12305),s=0)}else if(s>3){for(o(a),--s;s>6;s-=6)o(8304);s>2&&(o(s-3<<5|8208),s=0)}for(;s--;)o(a);s=1,a=t[f]}return{c:e.subarray(0,i),n:r}},T=function(t,n){for(var r=0,e=0;e<n.length;++e)r+=t[e]*n[e];return r},k=function(t,n,r){var e=r.length,i=m(n+2);t[i]=255&e,t[i+1]=e>>8,t[i+2]=255^t[i],t[i+3]=255^t[i+1];for(var a=0;a<e;++a)t[i+a+4]=r[a];return 8*(i+4+e)},C=function(t,r,s,o,f,h,l,u,c,v,m){z(r,m++,s),++f[256];for(var b=_(f,15),M=b.t,E=b.l,x=_(h,15),C=x.t,U=x.l,F=D(M),I=F.c,S=F.n,L=D(C),O=L.c,j=L.n,q=new n(19),B=0;B<I.length;++B)++q[31&I[B]];for(B=0;B<O.length;++B)++q[31&O[B]];for(var G=_(q,7),H=G.t,J=G.l,K=19;K>4&&!H[a[K-1]];--K);var N,P,Q,R,V=v+5<<3,W=T(f,g)+T(h,w)+l,X=T(f,M)+T(h,C)+l+14+3*K+T(q,H)+2*q[16]+3*q[17]+7*q[18];if(c>=0&&V<=W&&V<=X)return k(r,m,t.subarray(c,c+v));if(z(r,m,1+(X<W)),m+=2,X<W){N=d(M,E,0),P=M,Q=d(C,U,0),R=C;var Y=d(H,J,0);z(r,m,S-257),z(r,m+5,j-1),z(r,m+10,K-4),m+=14;for(B=0;B<K;++B)z(r,m+3*B,H[a[B]]);m+=3*K;for(var Z=[I,O],$=0;$<2;++$){var tt=Z[$];for(B=0;B<tt.length;++B){var nt=31&tt[B];z(r,m,Y[nt]),m+=H[nt],nt>15&&(z(r,m,tt[B]>>5&127),m+=tt[B]>>12)}}}else N=p,P=g,Q=y,R=w;for(B=0;B<u;++B){var rt=o[B];if(rt>255){A(r,m,N[(nt=rt>>18&31)+257]),m+=P[nt+257],nt>7&&(z(r,m,rt>>23&31),m+=e[nt]);var et=31&rt;A(r,m,Q[et]),m+=R[et],et>3&&(A(r,m,rt>>5&8191),m+=i[et])}else A(r,m,N[rt]),m+=P[rt]}return A(r,m,N[256]),m+P[256]},U=new r([65540,131080,131088,131104,262176,1048704,1048832,2114560,2117632]),F=new t(0),I=function(){for(var t=new Int32Array(256),n=0;n<256;++n){for(var r=n,e=9;--e;)r=(1&r&&-306674912)^r>>>1;t[n]=r}return t}(),S=function(){var t=1,n=0;return{p:function(r){for(var e=t,i=n,a=0|r.length,s=0;s!=a;){for(var o=Math.min(s+2655,a);s<o;++s)i+=e+=r[s];e=(65535&e)+15*(e>>16),i=(65535&i)+15*(i>>16)}t=e,n=i},d:function(){return(255&(t%=65521))<<24|(65280&t)<<8|(255&(n%=65521))<<8|n>>8}}},L=function(a,s,o,f,u){if(!u&&(u={l:1},s.dictionary)){var c=s.dictionary.subarray(-32768),v=new t(c.length+a.length);v.set(c),v.set(a,c.length),a=v,u.w=c.length}return function(a,s,o,f,u,c){var v=c.z||a.length,d=new t(f+v+5*(1+Math.ceil(v/7e3))+u),g=d.subarray(f,d.length-u),w=c.l,p=7&(c.r||0);if(s){p&&(g[0]=c.r>>3);for(var y=U[s-1],M=y>>13,E=8191&y,z=(1<<o)-1,A=c.p||new n(32768),_=c.h||new n(z+1),x=Math.ceil(o/3),D=2*x,T=function(t){return(a[t]^a[t+1]<<x^a[t+2]<<D)&z},F=new r(25e3),I=new n(288),S=new n(32),L=0,O=0,j=c.i||0,q=0,B=c.w||0,G=0;j+2<v;++j){var H=T(j),J=32767&j,K=_[H];if(A[J]=K,_[H]=J,B<=j){var N=v-j;if((L>7e3||q>24576)&&(N>423||!w)){p=C(a,g,0,F,I,S,O,q,G,j-G,p),q=L=O=0,G=j;for(var P=0;P<286;++P)I[P]=0;for(P=0;P<30;++P)S[P]=0}var Q=2,R=0,V=E,W=J-K&32767;if(N>2&&H==T(j-W))for(var X=Math.min(M,N)-1,Y=Math.min(32767,j),Z=Math.min(258,N);W<=Y&&--V&&J!=K;){if(a[j+Q]==a[j+Q-W]){for(var $=0;$<Z&&a[j+$]==a[j+$-W];++$);if($>Q){if(Q=$,R=W,$>X)break;var tt=Math.min(W,$-2),nt=0;for(P=0;P<tt;++P){var rt=j-W+P&32767,et=rt-A[rt]&32767;et>nt&&(nt=et,K=rt)}}}W+=(J=K)-(K=A[J])&32767}if(R){F[q++]=268435456|h[Q]<<18|l[R];var it=31&h[Q],at=31&l[R];O+=e[it]+i[at],++I[257+it],++S[at],B=j+Q,++L}else F[q++]=a[j],++I[a[j]]}}for(j=Math.max(j,B);j<v;++j)F[q++]=a[j],++I[a[j]];p=C(a,g,w,F,I,S,O,q,G,j-G,p),w||(c.r=7&p|g[p/8|0]<<3,p-=7,c.h=_,c.p=A,c.i=j,c.w=B)}else{for(j=c.w||0;j<v+w;j+=65535){var st=j+65535;st>=v&&(g[p/8|0]=w,st=v),p=k(g,p+1,a.subarray(j,st))}c.i=v}return b(d,0,f+m(p)+u)}(a,null==s.level?6:s.level,null==s.mem?Math.ceil(1.5*Math.max(8,Math.min(13,Math.log(a.length)))):12+s.mem,o,f,u)},O=function(t,n,r){for(;r;++n)t[n]=r,r>>>=8},j=function(){function n(n,r){if("function"==typeof n&&(r=n,n={}),this.ondata=r,this.o=n||{},this.s={l:0,i:32768,w:32768,z:32768},this.b=new t(98304),this.o.dictionary){var e=this.o.dictionary.subarray(-32768);this.b.set(e,32768-e.length),this.s.i=32768-e.length}}return n.prototype.p=function(t,n){this.ondata(L(t,this.o,0,0,this.s),n)},n.prototype.push=function(n,r){this.ondata||E(5),this.s.l&&E(4);var e=n.length+this.s.z;if(e>this.b.length){if(e>2*this.b.length-32768){var i=new t(-32768&e);i.set(this.b.subarray(0,this.s.z)),this.b=i}var a=this.b.length-this.s.z;a&&(this.b.set(n.subarray(0,a),this.s.z),this.s.z=this.b.length,this.p(this.b,!1)),this.b.set(this.b.subarray(-32768)),this.b.set(n.subarray(a),32768),this.s.z=n.length-a+32768,this.s.i=32766,this.s.w=32768}else this.b.set(n,this.s.z),this.s.z+=n.length;this.s.l=1&r,(this.s.z>this.s.w+8191||r)&&(this.p(this.b,r||!1),this.s.w=this.s.i,this.s.i-=2)},n}();function q(t,n){n||(n={});var r=function(){var t=-1;return{p:function(n){for(var r=t,e=0;e<n.length;++e)r=I[255&r^n[e]]^r>>>8;t=r},d:function(){return~t}}}(),e=t.length;r.p(t);var i,a=L(t,n,10+((i=n).filename?i.filename.length+1:0),8),s=a.length;return function(t,n){var r=n.filename;if(t[0]=31,t[1]=139,t[2]=8,t[8]=n.level<2?4:9==n.level?2:0,t[9]=3,0!=n.mtime&&O(t,4,Math.floor(new Date(n.mtime||Date.now())/1e3)),r){t[3]=8;for(var e=0;e<=r.length;++e)t[e+10]=r.charCodeAt(e)}}(a,n),O(a,s-8,r.d()),O(a,s-4,e),a}var B=function(){function t(t,n){this.c=S(),this.v=1,j.call(this,t,n)}return t.prototype.push=function(t,n){this.c.p(t),j.prototype.push.call(this,t,n)},t.prototype.p=function(t,n){var r=L(t,this.o,this.v&&(this.o.dictionary?6:2),n&&4,this.s);this.v&&(function(t,n){var r=n.level,e=0==r?0:r<6?1:9==r?3:2;if(t[0]=120,t[1]=e<<6|(n.dictionary&&32),t[1]|=31-(t[0]<<8|t[1])%31,n.dictionary){var i=S();i.p(n.dictionary),O(t,2,i.d())}}(r,this.o),this.v=0),n&&O(r,r.length-4,this.c.d()),this.ondata(r,n)},t}(),G="undefined"!=typeof TextEncoder&&new TextEncoder,H="undefined"!=typeof TextDecoder&&new TextDecoder;try{H.decode(F,{stream:!0})}catch(t){}var J=function(){function t(t){this.ondata=t}return t.prototype.push=function(t,n){this.ondata||E(5),this.d&&E(4),this.ondata(K(t),this.d=n||!1)},t}();function K(n,r){if(r){for(var e=new t(n.length),i=0;i<n.length;++i)e[i]=n.charCodeAt(i);return e}if(G)return G.encode(n);var a=n.length,s=new t(n.length+(n.length>>1)),o=0,f=function(t){s[o++]=t};for(i=0;i<a;++i){if(o+5>s.length){var h=new t(o+8+(a-i<<1));h.set(s),s=h}var l=n.charCodeAt(i);l<128||r?f(l):l<2048?(f(192|l>>6),f(128|63&l)):l>55295&&l<57344?(f(240|(l=65536+(1047552&l)|1023&n.charCodeAt(++i))>>18),f(128|l>>12&63),f(128|l>>6&63),f(128|63&l)):(f(224|l>>12),f(128|l>>6&63),f(128|63&l))}return b(s,0,o)}const N=new class{constructor(){this._init()}clear(){this._init()}addEvent(t){if(!t)throw new Error("Adding invalid event");const n=this._hasEvents?",":"";this.stream.push(n+t),this._hasEvents=!0}finish(){this.stream.push("]",!0);const t=function(t){let n=0;for(let r=0,e=t.length;r<e;r++)n+=t[r].length;const r=new Uint8Array(n);for(let n=0,e=0,i=t.length;n<i;n++){const i=t[n];r.set(i,e),e+=i.length}return r}(this._deflatedData);return this._init(),t}_init(){this._hasEvents=!1,this._deflatedData=[],this.deflate=new B,this.deflate.ondata=(t,n)=>{this._deflatedData.push(t)},this.stream=new J(((t,n)=>{this.deflate.push(t,n)})),this.stream.push("[")}},P={clear:()=>{N.clear()},addEvent:t=>N.addEvent(t),finish:()=>N.finish(),compress:t=>function(t){return q(K(t))}(t)};addEventListener("message",(function(t){const n=t.data.method,r=t.data.id,e=t.data.arg;if(n in P&&"function"==typeof P[n])try{const t=P[n](e);postMessage({id:r,method:n,success:!0,response:t})}catch(t){postMessage({id:r,method:n,success:!1,response:t.message}),console.error(t)}})),postMessage({id:void 0,method:"init",success:!0,response:void 0});`;
function e() {
    var e = new Blob([
        r
    ]);
    return URL.createObjectURL(e);
}
/**
 * Log a message in debug mode, and add a breadcrumb when _experiment.traceInternals is enabled.
 */ function logInfo(message, shouldAddBreadcrumb) {
    if (!DEBUG_BUILD) return;
    (0, _utils.logger).info(message);
    if (shouldAddBreadcrumb) addLogBreadcrumb(message);
}
/**
 * Log a message, and add a breadcrumb in the next tick.
 * This is necessary when the breadcrumb may be added before the replay is initialized.
 */ function logInfoNextTick(message, shouldAddBreadcrumb) {
    if (!DEBUG_BUILD) return;
    (0, _utils.logger).info(message);
    if (shouldAddBreadcrumb) // Wait a tick here to avoid race conditions for some initial logs
    // which may be added before replay is initialized
    setTimeout(function() {
        addLogBreadcrumb(message);
    }, 0);
}
function addLogBreadcrumb(message) {
    (0, _core.addBreadcrumb)({
        category: 'console',
        data: {
            logger: 'replay'
        },
        level: 'info',
        message: message
    }, {
        level: 'info'
    });
}
/** This error indicates that the event buffer size exceeded the limit.. */ var EventBufferSizeExceededError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, _inherits._)(EventBufferSizeExceededError, Error1);
    function EventBufferSizeExceededError() {
        (0, _classCallCheck._)(this, EventBufferSizeExceededError);
        return (0, _callSuper._)(this, EventBufferSizeExceededError, [
            `Event buffer exceeded maximum size of ${REPLAY_MAX_EVENT_BUFFER_SIZE}.`
        ]);
    }
    return EventBufferSizeExceededError;
}((0, _wrapNativeSuper._)(Error));
/**
 * A basic event buffer that does not do any compression.
 * Used as fallback if the compression worker cannot be loaded or is disabled.
 */ var EventBufferArray = /*#__PURE__*/ function() {
    "use strict";
    function EventBufferArray() {
        (0, _classCallCheck._)(this, EventBufferArray);
        this.events = [];
        this._totalSize = 0;
        this.hasCheckout = false;
    }
    (0, _createClass._)(EventBufferArray, [
        {
            key: "hasEvents",
            get: /** @inheritdoc */ function get() {
                return this.events.length > 0;
            }
        },
        {
            key: "type",
            get: /** @inheritdoc */ function get() {
                return 'sync';
            }
        },
        {
            /** @inheritdoc */ key: "destroy",
            value: function destroy() {
                this.events = [];
            }
        },
        {
            key: "addEvent",
            value: /** @inheritdoc */ function addEvent(event) {
                var _this = this;
                return (0, _asyncToGenerator._)(function() {
                    var eventSize;
                    return (0, _tsGenerator._)(this, function(_state) {
                        eventSize = JSON.stringify(event).length;
                        _this._totalSize += eventSize;
                        if (_this._totalSize > REPLAY_MAX_EVENT_BUFFER_SIZE) throw new EventBufferSizeExceededError();
                        _this.events.push(event);
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            /** @inheritdoc */ key: "finish",
            value: function finish() {
                var _this = this;
                return new Promise(function(resolve) {
                    // Make a copy of the events array reference and immediately clear the
                    // events member so that we do not lose new events while uploading
                    // attachment.
                    var eventsRet = _this.events;
                    _this.clear();
                    resolve(JSON.stringify(eventsRet));
                });
            }
        },
        {
            /** @inheritdoc */ key: "clear",
            value: function clear() {
                this.events = [];
                this._totalSize = 0;
                this.hasCheckout = false;
            }
        },
        {
            /** @inheritdoc */ key: "getEarliestTimestamp",
            value: function getEarliestTimestamp() {
                var timestamp = this.events.map(function(event) {
                    return event.timestamp;
                }).sort()[0];
                if (!timestamp) return null;
                return timestampToMs(timestamp);
            }
        }
    ]);
    return EventBufferArray;
}();
/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */ var WorkerHandler = /*#__PURE__*/ function() {
    "use strict";
    function WorkerHandler(worker) {
        (0, _classCallCheck._)(this, WorkerHandler);
        this._worker = worker;
        this._id = 0;
    }
    (0, _createClass._)(WorkerHandler, [
        {
            /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occured.
   */ key: "ensureReady",
            value: function ensureReady() {
                var _this = this;
                // Ensure we only check once
                if (this._ensureReadyPromise) return this._ensureReadyPromise;
                this._ensureReadyPromise = new Promise(function(resolve, reject) {
                    _this._worker.addEventListener('message', function(param) {
                        var data = param.data;
                        if (data.success) resolve();
                        else reject();
                    }, {
                        once: true
                    });
                    _this._worker.addEventListener('error', function(error) {
                        reject(error);
                    }, {
                        once: true
                    });
                });
                return this._ensureReadyPromise;
            }
        },
        {
            /**
   * Destroy the worker.
   */ key: "destroy",
            value: function destroy() {
                logInfo('[Replay] Destroying compression worker');
                this._worker.terminate();
            }
        },
        {
            /**
   * Post message to worker and wait for response before resolving promise.
   */ key: "postMessage",
            value: function postMessage(method, arg) {
                var _this = this;
                var id = this._getAndIncrementId();
                return new Promise(function(resolve, reject) {
                    var listener = function(param) {
                        var data = param.data;
                        var response = data;
                        if (response.method !== method) return;
                        // There can be multiple listeners for a single method, the id ensures
                        // that the response matches the caller.
                        if (response.id !== id) return;
                        // At this point, we'll always want to remove listener regardless of result status
                        _this._worker.removeEventListener('message', listener);
                        if (!response.success) {
                            // TODO: Do some error handling, not sure what
                            DEBUG_BUILD && (0, _utils.logger).error('[Replay]', response.response);
                            reject(new Error('Error in compression worker'));
                            return;
                        }
                        resolve(response.response);
                    };
                    // Note: we can't use `once` option because it's possible it needs to
                    // listen to multiple messages
                    _this._worker.addEventListener('message', listener);
                    _this._worker.postMessage({
                        id: id,
                        method: method,
                        arg: arg
                    });
                });
            }
        },
        {
            /** Get the current ID and increment it for the next call. */ key: "_getAndIncrementId",
            value: function _getAndIncrementId() {
                return this._id++;
            }
        }
    ]);
    return WorkerHandler;
}();
/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */ var EventBufferCompressionWorker = /*#__PURE__*/ function() {
    "use strict";
    function EventBufferCompressionWorker(worker) {
        (0, _classCallCheck._)(this, EventBufferCompressionWorker);
        this._worker = new WorkerHandler(worker);
        this._earliestTimestamp = null;
        this._totalSize = 0;
        this.hasCheckout = false;
    }
    (0, _createClass._)(EventBufferCompressionWorker, [
        {
            key: "hasEvents",
            get: /** @inheritdoc */ function get() {
                return !!this._earliestTimestamp;
            }
        },
        {
            key: "type",
            get: /** @inheritdoc */ function get() {
                return 'worker';
            }
        },
        {
            /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occured.
   */ key: "ensureReady",
            value: function ensureReady() {
                return this._worker.ensureReady();
            }
        },
        {
            /**
   * Destroy the event buffer.
   */ key: "destroy",
            value: function destroy() {
                this._worker.destroy();
            }
        },
        {
            /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfuly received and processed by worker.
   */ key: "addEvent",
            value: function addEvent(event) {
                var timestamp = timestampToMs(event.timestamp);
                if (!this._earliestTimestamp || timestamp < this._earliestTimestamp) this._earliestTimestamp = timestamp;
                var data = JSON.stringify(event);
                this._totalSize += data.length;
                if (this._totalSize > REPLAY_MAX_EVENT_BUFFER_SIZE) return Promise.reject(new EventBufferSizeExceededError());
                return this._sendEventToWorker(data);
            }
        },
        {
            /**
   * Finish the event buffer and return the compressed data.
   */ key: "finish",
            value: function finish() {
                return this._finishRequest();
            }
        },
        {
            /** @inheritdoc */ key: "clear",
            value: function clear() {
                this._earliestTimestamp = null;
                this._totalSize = 0;
                this.hasCheckout = false;
                // We do not wait on this, as we assume the order of messages is consistent for the worker
                this._worker.postMessage('clear').then(null, function(e) {
                    DEBUG_BUILD && (0, _utils.logger).warn('[Replay] Sending "clear" message to worker failed', e);
                });
            }
        },
        {
            /** @inheritdoc */ key: "getEarliestTimestamp",
            value: function getEarliestTimestamp() {
                return this._earliestTimestamp;
            }
        },
        {
            /**
   * Send the event to the worker.
   */ key: "_sendEventToWorker",
            value: function _sendEventToWorker(data) {
                return this._worker.postMessage('addEvent', data);
            }
        },
        {
            key: "_finishRequest",
            value: /**
   * Finish the request and return the compressed data from the worker.
   */ function _finishRequest() {
                var _this = this;
                return (0, _asyncToGenerator._)(function() {
                    var response;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    _this._worker.postMessage('finish')
                                ];
                            case 1:
                                response = _state.sent();
                                _this._earliestTimestamp = null;
                                _this._totalSize = 0;
                                return [
                                    2,
                                    response
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return EventBufferCompressionWorker;
}();
/**
 * This proxy will try to use the compression worker, and fall back to use the simple buffer if an error occurs there.
 * This can happen e.g. if the worker cannot be loaded.
 * Exported only for testing.
 */ var EventBufferProxy = /*#__PURE__*/ function() {
    "use strict";
    function EventBufferProxy(worker) {
        (0, _classCallCheck._)(this, EventBufferProxy);
        this._fallback = new EventBufferArray();
        this._compression = new EventBufferCompressionWorker(worker);
        this._used = this._fallback;
        this._ensureWorkerIsLoadedPromise = this._ensureWorkerIsLoaded();
    }
    (0, _createClass._)(EventBufferProxy, [
        {
            key: "type",
            get: /** @inheritdoc */ function get() {
                return this._used.type;
            }
        },
        {
            key: "hasEvents",
            get: /** @inheritDoc */ function get() {
                return this._used.hasEvents;
            }
        },
        {
            key: "hasCheckout",
            get: /** @inheritdoc */ function get() {
                return this._used.hasCheckout;
            },
            set: /** @inheritdoc */ function set(value) {
                this._used.hasCheckout = value;
            }
        },
        {
            /** @inheritDoc */ key: "destroy",
            value: function destroy() {
                this._fallback.destroy();
                this._compression.destroy();
            }
        },
        {
            /** @inheritdoc */ key: "clear",
            value: function clear() {
                return this._used.clear();
            }
        },
        {
            /** @inheritdoc */ key: "getEarliestTimestamp",
            value: function getEarliestTimestamp() {
                return this._used.getEarliestTimestamp();
            }
        },
        {
            /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfully added.
   */ key: "addEvent",
            value: function addEvent(event) {
                return this._used.addEvent(event);
            }
        },
        {
            key: "finish",
            value: /** @inheritDoc */ function finish() {
                var _this = this;
                return (0, _asyncToGenerator._)(function() {
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // Ensure the worker is loaded, so the sent event is compressed
                                return [
                                    4,
                                    _this.ensureWorkerIsLoaded()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2,
                                    _this._used.finish()
                                ];
                        }
                    });
                })();
            }
        },
        {
            /** Ensure the worker has loaded. */ key: "ensureWorkerIsLoaded",
            value: function ensureWorkerIsLoaded() {
                return this._ensureWorkerIsLoadedPromise;
            }
        },
        {
            key: "_ensureWorkerIsLoaded",
            value: /** Actually check if the worker has been loaded. */ function _ensureWorkerIsLoaded() {
                var _this = this;
                return (0, _asyncToGenerator._)(function() {
                    var error;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _this._compression.ensureReady()
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                error = _state.sent();
                                // If the worker fails to load, we fall back to the simple buffer.
                                // Nothing more to do from our side here
                                logInfo('[Replay] Failed to load the compression worker, falling back to simple buffer');
                                return [
                                    2
                                ];
                            case 3:
                                // Now we need to switch over the array buffer to the compression worker
                                return [
                                    4,
                                    _this._switchToCompressionWorker()
                                ];
                            case 4:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "_switchToCompressionWorker",
            value: /** Switch the used buffer to the compression worker. */ function _switchToCompressionWorker() {
                var _this = this;
                return (0, _asyncToGenerator._)(function() {
                    var _this__fallback, events, hasCheckout, addEventPromises, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, event, error;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this__fallback = _this._fallback, events = _this__fallback.events, hasCheckout = _this__fallback.hasCheckout;
                                addEventPromises = [];
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(_iterator = events[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        event = _step.value;
                                        addEventPromises.push(_this._compression.addEvent(event));
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                _this._compression.hasCheckout = hasCheckout;
                                // We switch over to the new buffer immediately - any further events will be added
                                // after the previously buffered ones
                                _this._used = _this._compression;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    Promise.all(addEventPromises)
                                ];
                            case 2:
                                _state.sent();
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                error = _state.sent();
                                DEBUG_BUILD && (0, _utils.logger).warn('[Replay] Failed to add events when switching buffers.', error);
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return EventBufferProxy;
}();
/**
 * Create an event buffer for replays.
 */ function createEventBuffer(param) {
    var useCompression = param.useCompression, customWorkerUrl = param.workerUrl;
    if (useCompression && // eslint-disable-next-line no-restricted-globals
    window.Worker) {
        var worker = _loadWorker(customWorkerUrl);
        if (worker) return worker;
    }
    logInfo('[Replay] Using simple buffer');
    return new EventBufferArray();
}
function _loadWorker(customWorkerUrl) {
    try {
        var workerUrl = customWorkerUrl || _getWorkerUrl();
        if (!workerUrl) return;
        logInfo(`[Replay] Using compression worker${customWorkerUrl ? ` from ${customWorkerUrl}` : ''}`);
        var worker = new Worker(workerUrl);
        return new EventBufferProxy(worker);
    } catch (error) {
        logInfo('[Replay] Failed to create compression worker');
    // Fall back to use simple event buffer array
    }
}
function _getWorkerUrl() {
    if (typeof __SENTRY_EXCLUDE_REPLAY_WORKER__ === 'undefined' || !__SENTRY_EXCLUDE_REPLAY_WORKER__) return e();
    return '';
}
/** If sessionStorage is available. */ function hasSessionStorage() {
    try {
        // This can throw, e.g. when being accessed in a sandboxed iframe
        return 'sessionStorage' in WINDOW && !!WINDOW.sessionStorage;
    } catch (e) {
        return false;
    }
}
/**
 * Removes the session from Session Storage and unsets session in replay instance
 */ function clearSession(replay) {
    deleteSession();
    replay.session = undefined;
}
/**
 * Deletes a session from storage
 */ function deleteSession() {
    if (!hasSessionStorage()) return;
    try {
        WINDOW.sessionStorage.removeItem(REPLAY_SESSION_KEY);
    } catch (e) {
    // Ignore potential SecurityError exceptions
    }
}
/**
 * Given a sample rate, returns true if replay should be sampled.
 *
 * 1.0 = 100% sampling
 * 0.0 = 0% sampling
 */ function isSampled(sampleRate) {
    if (sampleRate === undefined) return false;
    // Math.random() returns a number in range of 0 to 1 (inclusive of 0, but not 1)
    return Math.random() < sampleRate;
}
/**
 * Get a session with defaults & applied sampling.
 */ function makeSession(session) {
    var now = Date.now();
    var id = session.id || (0, _utils.uuid4)();
    // Note that this means we cannot set a started/lastActivity of `0`, but this should not be relevant outside of tests.
    var started = session.started || now;
    var lastActivity = session.lastActivity || now;
    var segmentId = session.segmentId || 0;
    var sampled = session.sampled;
    var previousSessionId = session.previousSessionId;
    return {
        id: id,
        started: started,
        lastActivity: lastActivity,
        segmentId: segmentId,
        sampled: sampled,
        previousSessionId: previousSessionId
    };
}
/**
 * Save a session to session storage.
 */ function saveSession(session) {
    if (!hasSessionStorage()) return;
    try {
        WINDOW.sessionStorage.setItem(REPLAY_SESSION_KEY, JSON.stringify(session));
    } catch (e) {
    // Ignore potential SecurityError exceptions
    }
}
/**
 * Get the sampled status for a session based on sample rates & current sampled status.
 */ function getSessionSampleType(sessionSampleRate, allowBuffering) {
    return isSampled(sessionSampleRate) ? 'session' : allowBuffering ? 'buffer' : false;
}
/**
 * Create a new session, which in its current implementation is a Sentry event
 * that all replays will be saved to as attachments. Currently, we only expect
 * one of these Sentry events per "replay session".
 */ function createSession(param) {
    var sessionSampleRate = param.sessionSampleRate, allowBuffering = param.allowBuffering, _param_stickySession = param.stickySession, stickySession = _param_stickySession === void 0 ? false : _param_stickySession, previousSessionId = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).previousSessionId;
    var sampled = getSessionSampleType(sessionSampleRate, allowBuffering);
    var session = makeSession({
        sampled: sampled,
        previousSessionId: previousSessionId
    });
    if (stickySession) saveSession(session);
    return session;
}
/**
 * Fetches a session from storage
 */ function fetchSession(traceInternals) {
    if (!hasSessionStorage()) return null;
    try {
        // This can throw if cookies are disabled
        var sessionStringFromStorage = WINDOW.sessionStorage.getItem(REPLAY_SESSION_KEY);
        if (!sessionStringFromStorage) return null;
        var sessionObj = JSON.parse(sessionStringFromStorage);
        logInfoNextTick('[Replay] Loading existing session', traceInternals);
        return makeSession(sessionObj);
    } catch (e) {
        return null;
    }
}
/**
 * Given an initial timestamp and an expiry duration, checks to see if current
 * time should be considered as expired.
 */ function isExpired(initialTime, expiry) {
    var targetTime = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : +new Date();
    // Always expired if < 0
    if (initialTime === null || expiry === undefined || expiry < 0) return true;
    // Never expires if == 0
    if (expiry === 0) return false;
    return initialTime + expiry <= targetTime;
}
/**
 * Checks to see if session is expired
 */ function isSessionExpired(session, param) {
    var maxReplayDuration = param.maxReplayDuration, sessionIdleExpire = param.sessionIdleExpire, _param_targetTime = param.targetTime, targetTime = _param_targetTime === void 0 ? Date.now() : _param_targetTime;
    return(// First, check that maximum session length has not been exceeded
    isExpired(session.started, maxReplayDuration, targetTime) || // check that the idle timeout has not been exceeded (i.e. user has
    // performed an action within the last `sessionIdleExpire` ms)
    isExpired(session.lastActivity, sessionIdleExpire, targetTime));
}
/** If the session should be refreshed or not. */ function shouldRefreshSession(session, param) {
    var sessionIdleExpire = param.sessionIdleExpire, maxReplayDuration = param.maxReplayDuration;
    // If not expired, all good, just keep the session
    if (!isSessionExpired(session, {
        sessionIdleExpire: sessionIdleExpire,
        maxReplayDuration: maxReplayDuration
    })) return false;
    // If we are buffering & haven't ever flushed yet, always continue
    if (session.sampled === 'buffer' && session.segmentId === 0) return false;
    return true;
}
/**
 * Get or create a session, when initializing the replay.
 * Returns a session that may be unsampled.
 */ function loadOrCreateSession(param, sessionOptions) {
    var traceInternals = param.traceInternals, sessionIdleExpire = param.sessionIdleExpire, maxReplayDuration = param.maxReplayDuration, previousSessionId = param.previousSessionId;
    var existingSession = sessionOptions.stickySession && fetchSession(traceInternals);
    // No session exists yet, just create a new one
    if (!existingSession) {
        logInfoNextTick('[Replay] Creating new session', traceInternals);
        return createSession(sessionOptions, {
            previousSessionId: previousSessionId
        });
    }
    if (!shouldRefreshSession(existingSession, {
        sessionIdleExpire: sessionIdleExpire,
        maxReplayDuration: maxReplayDuration
    })) return existingSession;
    logInfoNextTick('[Replay] Session in sessionStorage is expired, creating new one...');
    return createSession(sessionOptions, {
        previousSessionId: existingSession.id
    });
}
function isCustomEvent(event) {
    return event.type === EventType.Custom;
}
/**
 * Add an event to the event buffer.
 * In contrast to `addEvent`, this does not return a promise & does not wait for the adding of the event to succeed/fail.
 * Instead this returns `true` if we tried to add the event, else false.
 * It returns `false` e.g. if we are paused, disabled, or out of the max replay duration.
 *
 * `isCheckout` is true if this is either the very first event, or an event triggered by `checkoutEveryNms`.
 */ function addEventSync(replay, event, isCheckout) {
    if (!shouldAddEvent(replay, event)) return false;
    // This should never reject
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    _addEvent(replay, event, isCheckout);
    return true;
}
/**
 * Add an event to the event buffer.
 * Resolves to `null` if no event was added, else to `void`.
 *
 * `isCheckout` is true if this is either the very first event, or an event triggered by `checkoutEveryNms`.
 */ function addEvent(replay, event, isCheckout) {
    if (!shouldAddEvent(replay, event)) return Promise.resolve(null);
    return _addEvent(replay, event, isCheckout);
}
function _addEvent(replay, event, isCheckout) {
    return __addEvent.apply(this, arguments);
}
function __addEvent() {
    __addEvent = (0, _asyncToGenerator._)(function(replay, event, isCheckout) {
        var replayOptions, eventAfterPossibleCallback, error, reason, client;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!replay.eventBuffer) return [
                        2,
                        null
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        5
                    ]);
                    if (isCheckout && replay.recordingMode === 'buffer') replay.eventBuffer.clear();
                    if (isCheckout) replay.eventBuffer.hasCheckout = true;
                    replayOptions = replay.getOptions();
                    eventAfterPossibleCallback = maybeApplyCallback(event, replayOptions.beforeAddRecordingEvent);
                    if (!eventAfterPossibleCallback) return [
                        2
                    ];
                    return [
                        4,
                        replay.eventBuffer.addEvent(eventAfterPossibleCallback)
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
                case 3:
                    error = _state.sent();
                    reason = error && error instanceof EventBufferSizeExceededError ? 'addEventSizeExceeded' : 'addEvent';
                    DEBUG_BUILD && (0, _utils.logger).error(error);
                    return [
                        4,
                        replay.stop({
                            reason: reason
                        })
                    ];
                case 4:
                    _state.sent();
                    client = (0, _core.getClient)();
                    if (client) client.recordDroppedEvent('internal_sdk_error', 'replay');
                    return [
                        3,
                        5
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return __addEvent.apply(this, arguments);
}
/** Exported only for tests. */ function shouldAddEvent(replay, event) {
    if (!replay.eventBuffer || replay.isPaused() || !replay.isEnabled()) return false;
    var timestampInMs = timestampToMs(event.timestamp);
    // Throw out events that happen more than 5 minutes ago. This can happen if
    // page has been left open and idle for a long period of time and user
    // comes back to trigger a new session. The performance entries rely on
    // `performance.timeOrigin`, which is when the page first opened.
    if (timestampInMs + replay.timeouts.sessionIdlePause < Date.now()) return false;
    // Throw out events that are +60min from the initial timestamp
    if (timestampInMs > replay.getContext().initialTimestamp + replay.getOptions().maxReplayDuration) {
        logInfo(`[Replay] Skipping event with timestamp ${timestampInMs} because it is after maxReplayDuration`, replay.getOptions()._experiments.traceInternals);
        return false;
    }
    return true;
}
function maybeApplyCallback(event, callback) {
    try {
        if (typeof callback === 'function' && isCustomEvent(event)) return callback(event);
    } catch (error) {
        DEBUG_BUILD && (0, _utils.logger).error('[Replay] An error occured in the `beforeAddRecordingEvent` callback, skipping the event...', error);
        return null;
    }
    return event;
}
/** If the event is an error event */ function isErrorEvent(event) {
    return !event.type;
}
/** If the event is a transaction event */ function isTransactionEvent(event) {
    return event.type === 'transaction';
}
/** If the event is an replay event */ function isReplayEvent(event) {
    return event.type === 'replay_event';
}
/** If the event is a feedback event */ function isFeedbackEvent(event) {
    return event.type === 'feedback';
}
/**
 * Returns a listener to be added to `client.on('afterSendErrorEvent, listener)`.
 */ function handleAfterSendEvent(replay) {
    // Custom transports may still be returning `Promise<void>`, which means we cannot expect the status code to be available there
    // TODO (v8): remove this check as it will no longer be necessary
    var enforceStatusCode = isBaseTransportSend();
    return function(event, sendResponse) {
        if (!replay.isEnabled() || !isErrorEvent(event) && !isTransactionEvent(event)) return;
        var statusCode = sendResponse && sendResponse.statusCode;
        // We only want to do stuff on successful error sending, otherwise you get error replays without errors attached
        // If not using the base transport, we allow `undefined` response (as a custom transport may not implement this correctly yet)
        // If we do use the base transport, we skip if we encountered an non-OK status code
        if (enforceStatusCode && (!statusCode || statusCode < 200 || statusCode >= 300)) return;
        if (isTransactionEvent(event)) {
            handleTransactionEvent(replay, event);
            return;
        }
        handleErrorEvent(replay, event);
    };
}
function handleTransactionEvent(replay, event) {
    var replayContext = replay.getContext();
    // Collect traceIds in _context regardless of `recordingMode`
    // In error mode, _context gets cleared on every checkout
    // We limit to max. 100 transactions linked
    if (event.contexts && event.contexts.trace && event.contexts.trace.trace_id && replayContext.traceIds.size < 100) replayContext.traceIds.add(event.contexts.trace.trace_id);
}
function handleErrorEvent(replay, event) {
    var replayContext = replay.getContext();
    // Add error to list of errorIds of replay. This is ok to do even if not
    // sampled because context will get reset at next checkout.
    // XXX: There is also a race condition where it's possible to capture an
    // error to Sentry before Replay SDK has loaded, but response returns after
    // it was loaded, and this gets called.
    // We limit to max. 100 errors linked
    if (event.event_id && replayContext.errorIds.size < 100) replayContext.errorIds.add(event.event_id);
    // If error event is tagged with replay id it means it was sampled (when in buffer mode)
    // Need to be very careful that this does not cause an infinite loop
    if (replay.recordingMode !== 'buffer' || !event.tags || !event.tags.replayId) return;
    var beforeErrorSampling = replay.getOptions().beforeErrorSampling;
    if (typeof beforeErrorSampling === 'function' && !beforeErrorSampling(event)) return;
    setTimeout(function() {
        // Capture current event buffer as new replay
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        replay.sendBufferedReplayOrFlush();
    });
}
function isBaseTransportSend() {
    var client = (0, _core.getClient)();
    if (!client) return false;
    var transport = client.getTransport();
    if (!transport) return false;
    return transport.send.__sentry__baseTransport__ || false;
}
/**
 * Returns a listener to be added to `client.on('afterSendErrorEvent, listener)`.
 */ function handleBeforeSendEvent(replay) {
    return function(event) {
        if (!replay.isEnabled() || !isErrorEvent(event)) return;
        handleHydrationError(replay, event);
    };
}
function handleHydrationError(replay, event) {
    var exceptionValue = event.exception && event.exception.values && event.exception.values[0].value;
    if (typeof exceptionValue !== 'string') return;
    if (// Only matches errors in production builds of react-dom
    // Example https://reactjs.org/docs/error-decoder.html?invariant=423
    exceptionValue.match(/reactjs\.org\/docs\/error-decoder\.html\?invariant=(418|419|422|423|425)/) || // Development builds of react-dom
    // Error 1: Hydration failed because the initial UI does not match what was rendered on the server.
    // Error 2: Text content does not match server-rendered HTML. Warning: Text content did not match.
    exceptionValue.match(/(does not match server-rendered HTML|Hydration failed because)/i)) {
        var breadcrumb = createBreadcrumb({
            category: 'replay.hydrate-error'
        });
        addBreadcrumbEvent(replay, breadcrumb);
    }
}
/**
 * Returns true if we think the given event is an error originating inside of rrweb.
 */ function isRrwebError(event, hint) {
    if (event.type || !event.exception || !event.exception.values || !event.exception.values.length) return false;
    // @ts-expect-error this may be set by rrweb when it finds errors
    if (hint.originalException && hint.originalException.__rrweb__) return true;
    return false;
}
/**
 * Add a feedback breadcrumb event to replay.
 */ function addFeedbackBreadcrumb(replay, event) {
    replay.triggerUserActivity();
    replay.addUpdate(function() {
        if (!event.timestamp) // Ignore events that don't have timestamps (this shouldn't happen, more of a typing issue)
        // Return true here so that we don't flush
        return true;
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        replay.throttledAddEvent({
            type: EventType.Custom,
            timestamp: event.timestamp * 1000,
            data: {
                tag: 'breadcrumb',
                payload: {
                    timestamp: event.timestamp,
                    type: 'default',
                    category: 'sentry.feedback',
                    data: {
                        feedbackId: event.event_id
                    }
                }
            }
        });
        return false;
    });
}
/**
 * Determine if event should be sampled (only applies in buffer mode).
 * When an event is captured by `hanldleGlobalEvent`, when in buffer mode
 * we determine if we want to sample the error or not.
 */ function shouldSampleForBufferEvent(replay, event) {
    if (replay.recordingMode !== 'buffer') return false;
    // ignore this error because otherwise we could loop indefinitely with
    // trying to capture replay and failing
    if (event.message === UNABLE_TO_SEND_REPLAY) return false;
    // Require the event to be an error event & to have an exception
    if (!event.exception || event.type) return false;
    return isSampled(replay.getOptions().errorSampleRate);
}
/**
 * Returns a listener to be added to `addEventProcessor(listener)`.
 */ function handleGlobalEventListener(replay) {
    var includeAfterSendEventHandling = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var afterSendHandler = includeAfterSendEventHandling ? handleAfterSendEvent(replay) : undefined;
    return Object.assign(function(event, hint) {
        // Do nothing if replay has been disabled
        if (!replay.isEnabled()) return event;
        if (isReplayEvent(event)) {
            // Replays have separate set of breadcrumbs, do not include breadcrumbs
            // from core SDK
            delete event.breadcrumbs;
            return event;
        }
        // We only want to handle errors, transactions, and feedbacks, nothing else
        if (!isErrorEvent(event) && !isTransactionEvent(event) && !isFeedbackEvent(event)) return event;
        // Ensure we do not add replay_id if the session is expired
        var isSessionActive = replay.checkAndHandleExpiredSession();
        if (!isSessionActive) return event;
        if (isFeedbackEvent(event)) {
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            replay.flush();
            event.contexts.feedback.replay_id = replay.getSessionId();
            // Add a replay breadcrumb for this piece of feedback
            addFeedbackBreadcrumb(replay, event);
            return event;
        }
        // Unless `captureExceptions` is enabled, we want to ignore errors coming from rrweb
        // As there can be a bunch of stuff going wrong in internals there, that we don't want to bubble up to users
        if (isRrwebError(event, hint) && !replay.getOptions()._experiments.captureExceptions) {
            DEBUG_BUILD && (0, _utils.logger).log('[Replay] Ignoring error from rrweb internals', event);
            return null;
        }
        // When in buffer mode, we decide to sample here.
        // Later, in `handleAfterSendEvent`, if the replayId is set, we know that we sampled
        // And convert the buffer session to a full session
        var isErrorEventSampled = shouldSampleForBufferEvent(replay, event);
        // Tag errors if it has been sampled in buffer mode, or if it is session mode
        // Only tag transactions if in session mode
        var shouldTagReplayId = isErrorEventSampled || replay.recordingMode === 'session';
        if (shouldTagReplayId) event.tags = (0, _objectSpreadProps._)((0, _objectSpread._)({}, event.tags), {
            replayId: replay.getSessionId()
        });
        // In cases where a custom client is used that does not support the new hooks (yet),
        // we manually call this hook method here
        if (afterSendHandler) // Pretend the error had a 200 response so we always capture it
        afterSendHandler(event, {
            statusCode: 200
        });
        return event;
    }, {
        id: 'Replay'
    });
}
/**
 * Create a "span" for each performance entry.
 */ function createPerformanceSpans(replay, entries) {
    return entries.map(function(param) {
        var type = param.type, start = param.start, end = param.end, name = param.name, data = param.data;
        var response = replay.throttledAddEvent({
            type: EventType.Custom,
            timestamp: start,
            data: {
                tag: 'performanceSpan',
                payload: {
                    op: type,
                    description: name,
                    startTimestamp: start,
                    endTimestamp: end,
                    data: data
                }
            }
        });
        // If response is a string, it means its either THROTTLED or SKIPPED
        return typeof response === 'string' ? Promise.resolve(null) : response;
    });
}
function handleHistory(handlerData) {
    var from = handlerData.from, to = handlerData.to;
    var now = Date.now() / 1000;
    return {
        type: 'navigation.push',
        start: now,
        end: now,
        name: to,
        data: {
            previous: from
        }
    };
}
/**
 * Returns a listener to be added to `addHistoryInstrumentationHandler(listener)`.
 */ function handleHistorySpanListener(replay) {
    return function(handlerData) {
        if (!replay.isEnabled()) return;
        var result = handleHistory(handlerData);
        if (result === null) return;
        // Need to collect visited URLs
        replay.getContext().urls.push(result.name);
        replay.triggerUserActivity();
        replay.addUpdate(function() {
            createPerformanceSpans(replay, [
                result
            ]);
            // Returning false to flush
            return false;
        });
    };
}
/**
 * Check whether a given request URL should be filtered out. This is so we
 * don't log Sentry ingest requests.
 */ function shouldFilterRequest(replay, url) {
    // If we enabled the `traceInternals` experiment, we want to trace everything
    if (DEBUG_BUILD && replay.getOptions()._experiments.traceInternals) return false;
    return (0, _core.isSentryRequestUrl)(url, (0, _core.getClient)());
}
/** Add a performance entry breadcrumb */ function addNetworkBreadcrumb(replay, result) {
    if (!replay.isEnabled()) return;
    if (result === null) return;
    if (shouldFilterRequest(replay, result.name)) return;
    replay.addUpdate(function() {
        createPerformanceSpans(replay, [
            result
        ]);
        // Returning true will cause `addUpdate` to not flush
        // We do not want network requests to cause a flush. This will prevent
        // recurring/polling requests from keeping the replay session alive.
        return true;
    });
}
/** only exported for tests */ function handleFetch(handlerData) {
    var startTimestamp = handlerData.startTimestamp, endTimestamp = handlerData.endTimestamp, fetchData = handlerData.fetchData, response = handlerData.response;
    if (!endTimestamp) return null;
    // This is only used as a fallback, so we know the body sizes are never set here
    var method = fetchData.method, url = fetchData.url;
    return {
        type: 'resource.fetch',
        start: startTimestamp / 1000,
        end: endTimestamp / 1000,
        name: url,
        data: {
            method: method,
            statusCode: response ? response.status : undefined
        }
    };
}
/**
 * Returns a listener to be added to `addFetchInstrumentationHandler(listener)`.
 */ function handleFetchSpanListener(replay) {
    return function(handlerData) {
        if (!replay.isEnabled()) return;
        var result = handleFetch(handlerData);
        addNetworkBreadcrumb(replay, result);
    };
}
/** only exported for tests */ function handleXhr(handlerData) {
    var startTimestamp = handlerData.startTimestamp, endTimestamp = handlerData.endTimestamp, xhr = handlerData.xhr;
    var sentryXhrData = xhr[0, _utils.SENTRY_XHR_DATA_KEY];
    if (!startTimestamp || !endTimestamp || !sentryXhrData) return null;
    // This is only used as a fallback, so we know the body sizes are never set here
    var method = sentryXhrData.method, url = sentryXhrData.url, statusCode = sentryXhrData.status_code;
    if (url === undefined) return null;
    return {
        type: 'resource.xhr',
        name: url,
        start: startTimestamp / 1000,
        end: endTimestamp / 1000,
        data: {
            method: method,
            statusCode: statusCode
        }
    };
}
/**
 * Returns a listener to be added to `addXhrInstrumentationHandler(listener)`.
 */ function handleXhrSpanListener(replay) {
    return function(handlerData) {
        if (!replay.isEnabled()) return;
        var result = handleXhr(handlerData);
        addNetworkBreadcrumb(replay, result);
    };
}
/** Get the size of a body. */ function getBodySize(body, textEncoder) {
    if (!body) return undefined;
    try {
        if (typeof body === 'string') return textEncoder.encode(body).length;
        if (body instanceof URLSearchParams) return textEncoder.encode(body.toString()).length;
        if (body instanceof FormData) {
            var formDataStr = _serializeFormData(body);
            return textEncoder.encode(formDataStr).length;
        }
        if (body instanceof Blob) return body.size;
        if (body instanceof ArrayBuffer) return body.byteLength;
    // Currently unhandled types: ArrayBufferView, ReadableStream
    } catch (e) {
    // just return undefined
    }
    return undefined;
}
/** Convert a Content-Length header to number/undefined.  */ function parseContentLengthHeader(header) {
    if (!header) return undefined;
    var size = parseInt(header, 10);
    return isNaN(size) ? undefined : size;
}
/** Get the string representation of a body. */ function getBodyString(body) {
    try {
        if (typeof body === 'string') return [
            body
        ];
        if (body instanceof URLSearchParams) return [
            body.toString()
        ];
        if (body instanceof FormData) return [
            _serializeFormData(body)
        ];
        if (!body) return [
            undefined
        ];
    } catch (e2) {
        DEBUG_BUILD && (0, _utils.logger).warn('[Replay] Failed to serialize body', body);
        return [
            undefined,
            'BODY_PARSE_ERROR'
        ];
    }
    DEBUG_BUILD && (0, _utils.logger).info('[Replay] Skipping network body because of body type', body);
    return [
        undefined,
        'UNPARSEABLE_BODY_TYPE'
    ];
}
/** Merge a warning into an existing network request/response. */ function mergeWarning(info, warning) {
    if (!info) return {
        headers: {},
        size: undefined,
        _meta: {
            warnings: [
                warning
            ]
        }
    };
    var newMeta = (0, _objectSpread._)({}, info._meta);
    var existingWarnings = newMeta.warnings || [];
    newMeta.warnings = (0, _toConsumableArray._)(existingWarnings).concat([
        warning
    ]);
    info._meta = newMeta;
    return info;
}
/** Convert ReplayNetworkRequestData to a PerformanceEntry. */ function makeNetworkReplayBreadcrumb(type, data) {
    if (!data) return null;
    var startTimestamp = data.startTimestamp, endTimestamp = data.endTimestamp, url = data.url, method = data.method, statusCode = data.statusCode, request = data.request, response = data.response;
    var result = {
        type: type,
        start: startTimestamp / 1000,
        end: endTimestamp / 1000,
        name: url,
        data: (0, _utils.dropUndefinedKeys)({
            method: method,
            statusCode: statusCode,
            request: request,
            response: response
        })
    };
    return result;
}
/** Build the request or response part of a replay network breadcrumb that was skipped. */ function buildSkippedNetworkRequestOrResponse(bodySize) {
    return {
        headers: {},
        size: bodySize,
        _meta: {
            warnings: [
                'URL_SKIPPED'
            ]
        }
    };
}
/** Build the request or response part of a replay network breadcrumb. */ function buildNetworkRequestOrResponse(headers, bodySize, body) {
    if (!bodySize && Object.keys(headers).length === 0) return undefined;
    if (!bodySize) return {
        headers: headers
    };
    if (!body) return {
        headers: headers,
        size: bodySize
    };
    var info = {
        headers: headers,
        size: bodySize
    };
    var _normalizeNetworkBody = normalizeNetworkBody(body), normalizedBody = _normalizeNetworkBody.body, warnings = _normalizeNetworkBody.warnings;
    info.body = normalizedBody;
    if (warnings && warnings.length > 0) info._meta = {
        warnings: warnings
    };
    return info;
}
/** Filter a set of headers */ function getAllowedHeaders(headers, allowedHeaders) {
    return Object.keys(headers).reduce(function(filteredHeaders, key) {
        var normalizedKey = key.toLowerCase();
        // Avoid putting empty strings into the headers
        if (allowedHeaders.includes(normalizedKey) && headers[key]) filteredHeaders[normalizedKey] = headers[key];
        return filteredHeaders;
    }, {});
}
function _serializeFormData(formData) {
    // This is a bit simplified, but gives us a decent estimate
    // This converts e.g. { name: 'Anne Smith', age: 13 } to 'name=Anne+Smith&age=13'
    // @ts-expect-error passing FormData to URLSearchParams actually works
    return new URLSearchParams(formData).toString();
}
function normalizeNetworkBody(body) {
    if (!body || typeof body !== 'string') return {
        body: body
    };
    var exceedsSizeLimit = body.length > NETWORK_BODY_MAX_SIZE;
    var isProbablyJson = _strIsProbablyJson(body);
    if (exceedsSizeLimit) {
        var truncatedBody = body.slice(0, NETWORK_BODY_MAX_SIZE);
        if (isProbablyJson) return {
            body: truncatedBody,
            warnings: [
                'MAYBE_JSON_TRUNCATED'
            ]
        };
        return {
            body: `${truncatedBody}\u{2026}`,
            warnings: [
                'TEXT_TRUNCATED'
            ]
        };
    }
    if (isProbablyJson) try {
        var jsonBody = JSON.parse(body);
        return {
            body: jsonBody
        };
    } catch (e3) {
    // fall back to just send the body as string
    }
    return {
        body: body
    };
}
function _strIsProbablyJson(str) {
    var first = str[0];
    var last = str[str.length - 1];
    // Simple check: If this does not start & end with {} or [], it's not JSON
    return first === '[' && last === ']' || first === '{' && last === '}';
}
/** Match an URL against a list of strings/Regex. */ function urlMatches(url, urls) {
    var fullUrl = getFullUrl(url);
    return (0, _utils.stringMatchesSomePattern)(fullUrl, urls);
}
/** exported for tests */ function getFullUrl(url) {
    var baseURI = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : WINDOW.document.baseURI;
    // Short circuit for common cases:
    if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith(WINDOW.location.origin)) return url;
    var fixedUrl = new URL(url, baseURI);
    // If these do not match, we are not dealing with a relative URL, so just return it
    if (fixedUrl.origin !== new URL(baseURI).origin) return url;
    var fullUrl = fixedUrl.href;
    // Remove trailing slashes, if they don't match the original URL
    if (!url.endsWith('/') && fullUrl.endsWith('/')) return fullUrl.slice(0, -1);
    return fullUrl;
}
function captureFetchBreadcrumbToReplay(breadcrumb, hint, options) {
    return _captureFetchBreadcrumbToReplay.apply(this, arguments);
}
function _captureFetchBreadcrumbToReplay() {
    _captureFetchBreadcrumbToReplay = /**
 * Capture a fetch breadcrumb to a replay.
 * This adds additional data (where approriate).
 */ (0, _asyncToGenerator._)(function(breadcrumb, hint, options) {
        var data, result, error;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        _prepareFetchData(breadcrumb, hint, options)
                    ];
                case 1:
                    data = _state.sent();
                    // Create a replay performance entry from this breadcrumb
                    result = makeNetworkReplayBreadcrumb('resource.fetch', data);
                    addNetworkBreadcrumb(options.replay, result);
                    return [
                        3,
                        3
                    ];
                case 2:
                    error = _state.sent();
                    DEBUG_BUILD && (0, _utils.logger).error('[Replay] Failed to capture fetch breadcrumb', error);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _captureFetchBreadcrumbToReplay.apply(this, arguments);
}
/**
 * Enrich a breadcrumb with additional data.
 * This has to be sync & mutate the given breadcrumb,
 * as the breadcrumb is afterwards consumed by other handlers.
 */ function enrichFetchBreadcrumb(breadcrumb, hint, options) {
    var input = hint.input, response = hint.response;
    var body = input ? _getFetchRequestArgBody(input) : undefined;
    var reqSize = getBodySize(body, options.textEncoder);
    var resSize = response ? parseContentLengthHeader(response.headers.get('content-length')) : undefined;
    if (reqSize !== undefined) breadcrumb.data.request_body_size = reqSize;
    if (resSize !== undefined) breadcrumb.data.response_body_size = resSize;
}
function _prepareFetchData(breadcrumb, hint, options) {
    return __prepareFetchData.apply(this, arguments);
}
function __prepareFetchData() {
    __prepareFetchData = (0, _asyncToGenerator._)(function(breadcrumb, hint, options) {
        var now, _hint_startTimestamp, startTimestamp, _hint_endTimestamp, endTimestamp, _breadcrumb_data, url, method, tmp, statusCode, requestBodySize, responseBodySize, captureDetails, request, response;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    now = Date.now();
                    _hint_startTimestamp = hint.startTimestamp, startTimestamp = _hint_startTimestamp === void 0 ? now : _hint_startTimestamp, _hint_endTimestamp = hint.endTimestamp, endTimestamp = _hint_endTimestamp === void 0 ? now : _hint_endTimestamp;
                    _breadcrumb_data = breadcrumb.data, url = _breadcrumb_data.url, method = _breadcrumb_data.method, tmp = _breadcrumb_data.status_code, statusCode = tmp === void 0 ? 0 : tmp, requestBodySize = _breadcrumb_data.request_body_size, responseBodySize = _breadcrumb_data.response_body_size;
                    captureDetails = urlMatches(url, options.networkDetailAllowUrls) && !urlMatches(url, options.networkDetailDenyUrls);
                    request = captureDetails ? _getRequestInfo(options, hint.input, requestBodySize) : buildSkippedNetworkRequestOrResponse(requestBodySize);
                    return [
                        4,
                        _getResponseInfo(captureDetails, options, hint.response, responseBodySize)
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        {
                            startTimestamp: startTimestamp,
                            endTimestamp: endTimestamp,
                            url: url,
                            method: method,
                            statusCode: statusCode,
                            request: request,
                            response: response
                        }
                    ];
            }
        });
    });
    return __prepareFetchData.apply(this, arguments);
}
function _getRequestInfo(param, input, requestBodySize) {
    var networkCaptureBodies = param.networkCaptureBodies, networkRequestHeaders = param.networkRequestHeaders;
    var headers = input ? getRequestHeaders(input, networkRequestHeaders) : {};
    if (!networkCaptureBodies) return buildNetworkRequestOrResponse(headers, requestBodySize, undefined);
    // We only want to transmit string or string-like bodies
    var requestBody = _getFetchRequestArgBody(input);
    var _getBodyString = (0, _slicedToArray._)(getBodyString(requestBody), 2), bodyStr = _getBodyString[0], warning = _getBodyString[1];
    var data = buildNetworkRequestOrResponse(headers, requestBodySize, bodyStr);
    if (warning) return mergeWarning(data, warning);
    return data;
}
function _getResponseInfo(captureDetails, _, response, responseBodySize) {
    return __getResponseInfo.apply(this, arguments);
}
function __getResponseInfo() {
    __getResponseInfo = /** Exported only for tests. */ (0, _asyncToGenerator._)(function(captureDetails, param, response, responseBodySize) {
        var networkCaptureBodies, textEncoder, networkResponseHeaders, headers, _ref, bodyText, warning, result;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    networkCaptureBodies = param.networkCaptureBodies, textEncoder = param.textEncoder, networkResponseHeaders = param.networkResponseHeaders;
                    if (!captureDetails && responseBodySize !== undefined) return [
                        2,
                        buildSkippedNetworkRequestOrResponse(responseBodySize)
                    ];
                    headers = response ? getAllHeaders(response.headers, networkResponseHeaders) : {};
                    if (!response || !networkCaptureBodies && responseBodySize !== undefined) return [
                        2,
                        buildNetworkRequestOrResponse(headers, responseBodySize, undefined)
                    ];
                    return [
                        4,
                        _parseFetchResponseBody(response)
                    ];
                case 1:
                    _ref = (0, _slicedToArray._).apply(void 0, [
                        _state.sent(),
                        2
                    ]), bodyText = _ref[0], warning = _ref[1];
                    result = getResponseData(bodyText, {
                        networkCaptureBodies: networkCaptureBodies,
                        textEncoder: textEncoder,
                        responseBodySize: responseBodySize,
                        captureDetails: captureDetails,
                        headers: headers
                    });
                    if (warning) return [
                        2,
                        mergeWarning(result, warning)
                    ];
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return __getResponseInfo.apply(this, arguments);
}
function getResponseData(bodyText, param) {
    var networkCaptureBodies = param.networkCaptureBodies, textEncoder = param.textEncoder, responseBodySize = param.responseBodySize, captureDetails = param.captureDetails, headers = param.headers;
    try {
        var size = bodyText && bodyText.length && responseBodySize === undefined ? getBodySize(bodyText, textEncoder) : responseBodySize;
        if (!captureDetails) return buildSkippedNetworkRequestOrResponse(size);
        if (networkCaptureBodies) return buildNetworkRequestOrResponse(headers, size, bodyText);
        return buildNetworkRequestOrResponse(headers, size, undefined);
    } catch (error) {
        DEBUG_BUILD && (0, _utils.logger).warn('[Replay] Failed to serialize response body', error);
        // fallback
        return buildNetworkRequestOrResponse(headers, responseBodySize, undefined);
    }
}
function _parseFetchResponseBody(response) {
    return __parseFetchResponseBody.apply(this, arguments);
}
function __parseFetchResponseBody() {
    __parseFetchResponseBody = (0, _asyncToGenerator._)(function(response) {
        var res, text, error;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    res = _tryCloneResponse(response);
                    if (!res) return [
                        2,
                        [
                            undefined,
                            'BODY_PARSE_ERROR'
                        ]
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        _tryGetResponseText(res)
                    ];
                case 2:
                    text = _state.sent();
                    return [
                        2,
                        [
                            text
                        ]
                    ];
                case 3:
                    error = _state.sent();
                    DEBUG_BUILD && (0, _utils.logger).warn('[Replay] Failed to get text body from response', error);
                    return [
                        2,
                        [
                            undefined,
                            'BODY_PARSE_ERROR'
                        ]
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return __parseFetchResponseBody.apply(this, arguments);
}
function _getFetchRequestArgBody() {
    var fetchArgs = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    // We only support getting the body from the fetch options
    if (fetchArgs.length !== 2 || typeof fetchArgs[1] !== 'object') return undefined;
    return fetchArgs[1].body;
}
function getAllHeaders(headers, allowedHeaders) {
    var allHeaders = {};
    allowedHeaders.forEach(function(header) {
        if (headers.get(header)) allHeaders[header] = headers.get(header);
    });
    return allHeaders;
}
function getRequestHeaders(fetchArgs, allowedHeaders) {
    if (fetchArgs.length === 1 && typeof fetchArgs[0] !== 'string') return getHeadersFromOptions(fetchArgs[0], allowedHeaders);
    if (fetchArgs.length === 2) return getHeadersFromOptions(fetchArgs[1], allowedHeaders);
    return {};
}
function getHeadersFromOptions(input, allowedHeaders) {
    if (!input) return {};
    var headers = input.headers;
    if (!headers) return {};
    if (headers instanceof Headers) return getAllHeaders(headers, allowedHeaders);
    // We do not support this, as it is not really documented (anymore?)
    if (Array.isArray(headers)) return {};
    return getAllowedHeaders(headers, allowedHeaders);
}
function _tryCloneResponse(response) {
    try {
        // We have to clone this, as the body can only be read once
        return response.clone();
    } catch (error) {
        // this can throw if the response was already consumed before
        DEBUG_BUILD && (0, _utils.logger).warn('[Replay] Failed to clone response body', error);
    }
}
/**
 * Get the response body of a fetch request, or timeout after 500ms.
 * Fetch can return a streaming body, that may not resolve (or not for a long time).
 * If that happens, we rather abort after a short time than keep waiting for this.
 */ function _tryGetResponseText(response) {
    return new Promise(function(resolve, reject) {
        var timeout = setTimeout(function() {
            return reject(new Error('Timeout while trying to read response body'));
        }, 500);
        _getResponseText(response).then(function(txt) {
            return resolve(txt);
        }, function(reason) {
            return reject(reason);
        }).finally(function() {
            return clearTimeout(timeout);
        });
    });
}
function _getResponseText(response) {
    return __getResponseText.apply(this, arguments);
}
function __getResponseText() {
    __getResponseText = (0, _asyncToGenerator._)(function(response) {
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        response.text()
                    ];
                case 1:
                    // Force this to be a promise, just to be safe
                    // eslint-disable-next-line no-return-await
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return __getResponseText.apply(this, arguments);
}
function captureXhrBreadcrumbToReplay(breadcrumb, hint, options) {
    return _captureXhrBreadcrumbToReplay.apply(this, arguments);
}
function _captureXhrBreadcrumbToReplay() {
    _captureXhrBreadcrumbToReplay = /**
 * Capture an XHR breadcrumb to a replay.
 * This adds additional data (where approriate).
 */ (0, _asyncToGenerator._)(function(breadcrumb, hint, options) {
        var data, result;
        return (0, _tsGenerator._)(this, function(_state) {
            try {
                data = _prepareXhrData(breadcrumb, hint, options);
                // Create a replay performance entry from this breadcrumb
                result = makeNetworkReplayBreadcrumb('resource.xhr', data);
                addNetworkBreadcrumb(options.replay, result);
            } catch (error) {
                DEBUG_BUILD && (0, _utils.logger).error('[Replay] Failed to capture xhr breadcrumb', error);
            }
            return [
                2
            ];
        });
    });
    return _captureXhrBreadcrumbToReplay.apply(this, arguments);
}
/**
 * Enrich a breadcrumb with additional data.
 * This has to be sync & mutate the given breadcrumb,
 * as the breadcrumb is afterwards consumed by other handlers.
 */ function enrichXhrBreadcrumb(breadcrumb, hint, options) {
    var xhr = hint.xhr, input = hint.input;
    if (!xhr) return;
    var reqSize = getBodySize(input, options.textEncoder);
    var resSize = xhr.getResponseHeader('content-length') ? parseContentLengthHeader(xhr.getResponseHeader('content-length')) : _getBodySize(xhr.response, xhr.responseType, options.textEncoder);
    if (reqSize !== undefined) breadcrumb.data.request_body_size = reqSize;
    if (resSize !== undefined) breadcrumb.data.response_body_size = resSize;
}
function _prepareXhrData(breadcrumb, hint, options) {
    var now = Date.now();
    var _hint_startTimestamp = hint.startTimestamp, startTimestamp = _hint_startTimestamp === void 0 ? now : _hint_startTimestamp, _hint_endTimestamp = hint.endTimestamp, endTimestamp = _hint_endTimestamp === void 0 ? now : _hint_endTimestamp, input = hint.input, xhr = hint.xhr;
    var _breadcrumb_data = breadcrumb.data, url = _breadcrumb_data.url, method = _breadcrumb_data.method, tmp = _breadcrumb_data.status_code, statusCode = tmp === void 0 ? 0 : tmp, requestBodySize = _breadcrumb_data.request_body_size, responseBodySize = _breadcrumb_data.response_body_size;
    if (!url) return null;
    if (!xhr || !urlMatches(url, options.networkDetailAllowUrls) || urlMatches(url, options.networkDetailDenyUrls)) {
        var request = buildSkippedNetworkRequestOrResponse(requestBodySize);
        var response = buildSkippedNetworkRequestOrResponse(responseBodySize);
        return {
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp,
            url: url,
            method: method,
            statusCode: statusCode,
            request: request,
            response: response
        };
    }
    var xhrInfo = xhr[0, _utils.SENTRY_XHR_DATA_KEY];
    var networkRequestHeaders = xhrInfo ? getAllowedHeaders(xhrInfo.request_headers, options.networkRequestHeaders) : {};
    var networkResponseHeaders = getAllowedHeaders(getResponseHeaders(xhr), options.networkResponseHeaders);
    var _ref = (0, _slicedToArray._)(options.networkCaptureBodies ? getBodyString(input) : [
        undefined
    ], 2), requestBody = _ref[0], requestWarning = _ref[1];
    var _ref1 = (0, _slicedToArray._)(options.networkCaptureBodies ? _getXhrResponseBody(xhr) : [
        undefined
    ], 2), responseBody = _ref1[0], responseWarning = _ref1[1];
    var request1 = buildNetworkRequestOrResponse(networkRequestHeaders, requestBodySize, requestBody);
    var response1 = buildNetworkRequestOrResponse(networkResponseHeaders, responseBodySize, responseBody);
    return {
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp,
        url: url,
        method: method,
        statusCode: statusCode,
        request: requestWarning ? mergeWarning(request1, requestWarning) : request1,
        response: responseWarning ? mergeWarning(response1, responseWarning) : response1
    };
}
function getResponseHeaders(xhr) {
    var headers = xhr.getAllResponseHeaders();
    if (!headers) return {};
    return headers.split('\r\n').reduce(function(acc, line) {
        var _line_split = (0, _slicedToArray._)(line.split(': '), 2), key = _line_split[0], value = _line_split[1];
        acc[key.toLowerCase()] = value;
        return acc;
    }, {});
}
function _getXhrResponseBody(xhr) {
    var _logger;
    // We collect errors that happen, but only log them if we can't get any response body
    var errors = [];
    try {
        return [
            xhr.responseText
        ];
    } catch (e) {
        errors.push(e);
    }
    // Try to manually parse the response body, if responseText fails
    try {
        return _parseXhrResponse(xhr.response, xhr.responseType);
    } catch (e) {
        errors.push(e);
    }
    DEBUG_BUILD && (_logger = (0, _utils.logger)).warn.apply(_logger, [
        '[Replay] Failed to get xhr response body'
    ].concat((0, _toConsumableArray._)(errors)));
    return [
        undefined
    ];
}
/**
 * Get the string representation of the XHR response.
 * Based on MDN, these are the possible types of the response:
 * string
 * ArrayBuffer
 * Blob
 * Document
 * POJO
 *
 * Exported only for tests.
 */ function _parseXhrResponse(body, responseType) {
    try {
        if (typeof body === 'string') return [
            body
        ];
        if (body instanceof Document) return [
            body.body.outerHTML
        ];
        if (responseType === 'json' && body && typeof body === 'object') return [
            JSON.stringify(body)
        ];
        if (!body) return [
            undefined
        ];
    } catch (e2) {
        DEBUG_BUILD && (0, _utils.logger).warn('[Replay] Failed to serialize body', body);
        return [
            undefined,
            'BODY_PARSE_ERROR'
        ];
    }
    DEBUG_BUILD && (0, _utils.logger).info('[Replay] Skipping network body because of body type', body);
    return [
        undefined,
        'UNPARSEABLE_BODY_TYPE'
    ];
}
function _getBodySize(body, responseType, textEncoder) {
    try {
        var bodyStr = responseType === 'json' && body && typeof body === 'object' ? JSON.stringify(body) : body;
        return getBodySize(bodyStr, textEncoder);
    } catch (e3) {
        return undefined;
    }
}
/**
 * This method does two things:
 * - It enriches the regular XHR/fetch breadcrumbs with request/response size data
 * - It captures the XHR/fetch breadcrumbs to the replay
 *   (enriching it with further data that is _not_ added to the regular breadcrumbs)
 */ function handleNetworkBreadcrumbs(replay) {
    var client = (0, _core.getClient)();
    try {
        var textEncoder = new TextEncoder();
        var _replay_getOptions = replay.getOptions(), networkDetailAllowUrls = _replay_getOptions.networkDetailAllowUrls, networkDetailDenyUrls = _replay_getOptions.networkDetailDenyUrls, networkCaptureBodies = _replay_getOptions.networkCaptureBodies, networkRequestHeaders = _replay_getOptions.networkRequestHeaders, networkResponseHeaders = _replay_getOptions.networkResponseHeaders;
        var options = {
            replay: replay,
            textEncoder: textEncoder,
            networkDetailAllowUrls: networkDetailAllowUrls,
            networkDetailDenyUrls: networkDetailDenyUrls,
            networkCaptureBodies: networkCaptureBodies,
            networkRequestHeaders: networkRequestHeaders,
            networkResponseHeaders: networkResponseHeaders
        };
        if (client && client.on) client.on('beforeAddBreadcrumb', function(breadcrumb, hint) {
            return beforeAddNetworkBreadcrumb(options, breadcrumb, hint);
        });
        else {
            // Fallback behavior
            (0, _utils.addFetchInstrumentationHandler)(handleFetchSpanListener(replay));
            (0, _utils.addXhrInstrumentationHandler)(handleXhrSpanListener(replay));
        }
    } catch (e2) {
    // Do nothing
    }
}
/** just exported for tests */ function beforeAddNetworkBreadcrumb(options, breadcrumb, hint) {
    if (!breadcrumb.data) return;
    try {
        if (_isXhrBreadcrumb(breadcrumb) && _isXhrHint(hint)) {
            // This has to be sync, as we need to ensure the breadcrumb is enriched in the same tick
            // Because the hook runs synchronously, and the breadcrumb is afterwards passed on
            // So any async mutations to it will not be reflected in the final breadcrumb
            enrichXhrBreadcrumb(breadcrumb, hint, options);
            // This call should not reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            captureXhrBreadcrumbToReplay(breadcrumb, hint, options);
        }
        if (_isFetchBreadcrumb(breadcrumb) && _isFetchHint(hint)) {
            // This has to be sync, as we need to ensure the breadcrumb is enriched in the same tick
            // Because the hook runs synchronously, and the breadcrumb is afterwards passed on
            // So any async mutations to it will not be reflected in the final breadcrumb
            enrichFetchBreadcrumb(breadcrumb, hint, options);
            // This call should not reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            captureFetchBreadcrumbToReplay(breadcrumb, hint, options);
        }
    } catch (e) {
        DEBUG_BUILD && (0, _utils.logger).warn('Error when enriching network breadcrumb');
    }
}
function _isXhrBreadcrumb(breadcrumb) {
    return breadcrumb.category === 'xhr';
}
function _isFetchBreadcrumb(breadcrumb) {
    return breadcrumb.category === 'fetch';
}
function _isXhrHint(hint) {
    return hint && hint.xhr;
}
function _isFetchHint(hint) {
    return hint && hint.response;
}
var _LAST_BREADCRUMB = null;
function isBreadcrumbWithCategory(breadcrumb) {
    return !!breadcrumb.category;
}
var handleScopeListener = function(replay) {
    return function(scope) {
        if (!replay.isEnabled()) return;
        var result = handleScope(scope);
        if (!result) return;
        addBreadcrumbEvent(replay, result);
    };
};
/**
 * An event handler to handle scope changes.
 */ function handleScope(scope) {
    // TODO (v8): Remove this guard. This was put in place because we introduced
    // Scope.getLastBreadcrumb mid-v7 which caused incompatibilities with older SDKs.
    // For now, we'll just return null if the method doesn't exist but we should eventually
    // get rid of this guard.
    var newBreadcrumb = scope.getLastBreadcrumb && scope.getLastBreadcrumb();
    // Listener can be called when breadcrumbs have not changed, so we store the
    // reference to the last crumb and only return a crumb if it has changed
    if (_LAST_BREADCRUMB === newBreadcrumb || !newBreadcrumb) return null;
    _LAST_BREADCRUMB = newBreadcrumb;
    if (!isBreadcrumbWithCategory(newBreadcrumb) || [
        'fetch',
        'xhr',
        'sentry.event',
        'sentry.transaction'
    ].includes(newBreadcrumb.category) || newBreadcrumb.category.startsWith('ui.')) return null;
    if (newBreadcrumb.category === 'console') return normalizeConsoleBreadcrumb(newBreadcrumb);
    return createBreadcrumb(newBreadcrumb);
}
/** exported for tests only */ function normalizeConsoleBreadcrumb(breadcrumb) {
    var args = breadcrumb.data && breadcrumb.data.arguments;
    if (!Array.isArray(args) || args.length === 0) return createBreadcrumb(breadcrumb);
    var isTruncated = false;
    // Avoid giant args captures
    var normalizedArgs = args.map(function(arg) {
        if (!arg) return arg;
        if (typeof arg === 'string') {
            if (arg.length > CONSOLE_ARG_MAX_SIZE) {
                isTruncated = true;
                return `${arg.slice(0, CONSOLE_ARG_MAX_SIZE)}\u{2026}`;
            }
            return arg;
        }
        if (typeof arg === 'object') try {
            var normalizedArg = (0, _utils.normalize)(arg, 7);
            var stringified = JSON.stringify(normalizedArg);
            if (stringified.length > CONSOLE_ARG_MAX_SIZE) {
                isTruncated = true;
                // We use the pretty printed JSON string here as a base
                return `${JSON.stringify(normalizedArg, null, 2).slice(0, CONSOLE_ARG_MAX_SIZE)}\u{2026}`;
            }
            return normalizedArg;
        } catch (e) {
        // fall back to default
        }
        return arg;
    });
    return createBreadcrumb((0, _objectSpreadProps._)((0, _objectSpread._)({}, breadcrumb), {
        data: (0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, breadcrumb.data), {
            arguments: normalizedArgs
        }), isTruncated ? {
            _meta: {
                warnings: [
                    'CONSOLE_ARG_TRUNCATED'
                ]
            }
        } : {})
    }));
}
/**
 * Add global listeners that cannot be removed.
 */ function addGlobalListeners(replay) {
    // Listeners from core SDK //
    var scope = (0, _core.getCurrentScope)();
    var client = (0, _core.getClient)();
    scope.addScopeListener(handleScopeListener(replay));
    (0, _utils.addClickKeypressInstrumentationHandler)(handleDomListener(replay));
    (0, _utils.addHistoryInstrumentationHandler)(handleHistorySpanListener(replay));
    handleNetworkBreadcrumbs(replay);
    // Tag all (non replay) events that get sent to Sentry with the current
    // replay ID so that we can reference them later in the UI
    var eventProcessor = handleGlobalEventListener(replay, !hasHooks(client));
    if (client && client.addEventProcessor) client.addEventProcessor(eventProcessor);
    else (0, _core.addEventProcessor)(eventProcessor);
    // If a custom client has no hooks yet, we continue to use the "old" implementation
    if (hasHooks(client)) {
        client.on('beforeSendEvent', handleBeforeSendEvent(replay));
        client.on('afterSendEvent', handleAfterSendEvent(replay));
        client.on('createDsc', function(dsc) {
            var replayId = replay.getSessionId();
            // We do not want to set the DSC when in buffer mode, as that means the replay has not been sent (yet)
            if (replayId && replay.isEnabled() && replay.recordingMode === 'session') {
                // Ensure to check that the session is still active - it could have expired in the meanwhile
                var isSessionActive = replay.checkAndHandleExpiredSession();
                if (isSessionActive) dsc.replay_id = replayId;
            }
        });
        client.on('startTransaction', function(transaction) {
            replay.lastTransaction = transaction;
        });
        // We may be missing the initial startTransaction due to timing issues,
        // so we capture it on finish again.
        client.on('finishTransaction', function(transaction) {
            replay.lastTransaction = transaction;
        });
        // We want to flush replay
        client.on('beforeSendFeedback', function(feedbackEvent, options) {
            var replayId = replay.getSessionId();
            if (options && options.includeReplay && replay.isEnabled() && replayId) // This should never reject
            {
                if (feedbackEvent.contexts && feedbackEvent.contexts.feedback) feedbackEvent.contexts.feedback.replay_id = replayId;
            }
        });
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function hasHooks(client) {
    return !!(client && client.on);
}
function addMemoryEntry(replay) {
    return _addMemoryEntry.apply(this, arguments);
}
function _addMemoryEntry() {
    _addMemoryEntry = /**
 * Create a "span" for the total amount of memory being used by JS objects
 * (including v8 internal objects).
 */ (0, _asyncToGenerator._)(function(replay) {
        return (0, _tsGenerator._)(this, function(_state) {
            // window.performance.memory is a non-standard API and doesn't work on all browsers, so we try-catch this
            try {
                return [
                    2,
                    Promise.all(createPerformanceSpans(replay, [
                        // @ts-expect-error memory doesn't exist on type Performance as the API is non-standard (we check that it exists above)
                        createMemoryEntry(WINDOW.performance.memory)
                    ]))
                ];
            } catch (error) {
                // Do nothing
                return [
                    2,
                    []
                ];
            }
            return [
                2
            ];
        });
    });
    return _addMemoryEntry.apply(this, arguments);
}
function createMemoryEntry(memoryEntry) {
    var jsHeapSizeLimit = memoryEntry.jsHeapSizeLimit, totalJSHeapSize = memoryEntry.totalJSHeapSize, usedJSHeapSize = memoryEntry.usedJSHeapSize;
    // we don't want to use `getAbsoluteTime` because it adds the event time to the
    // time origin, so we get the current timestamp instead
    var time = Date.now() / 1000;
    return {
        type: 'memory',
        name: 'memory',
        start: time,
        end: time,
        data: {
            memory: {
                jsHeapSizeLimit: jsHeapSizeLimit,
                totalJSHeapSize: totalJSHeapSize,
                usedJSHeapSize: usedJSHeapSize
            }
        }
    };
}
/**
 * Heavily simplified debounce function based on lodash.debounce.
 *
 * This function takes a callback function (@param fun) and delays its invocation
 * by @param wait milliseconds. Optionally, a maxWait can be specified in @param options,
 * which ensures that the callback is invoked at least once after the specified max. wait time.
 *
 * @param func the function whose invocation is to be debounced
 * @param wait the minimum time until the function is invoked after it was called once
 * @param options the options object, which can contain the `maxWait` property
 *
 * @returns the debounced version of the function, which needs to be called at least once to start the
 *          debouncing process. Subsequent calls will reset the debouncing timer and, in case @paramfunc
 *          was already invoked in the meantime, return @param func's return value.
 *          The debounced function has two additional properties:
 *          - `flush`: Invokes the debounced function immediately and returns its return value
 *          - `cancel`: Cancels the debouncing process and resets the debouncing timer
 */ function debounce(func, wait, options) {
    var callbackReturnValue;
    var timerId;
    var maxTimerId;
    var maxWait = options && options.maxWait ? Math.max(options.maxWait, wait) : 0;
    function invokeFunc() {
        cancelTimers();
        callbackReturnValue = func();
        return callbackReturnValue;
    }
    function cancelTimers() {
        timerId !== undefined && clearTimeout(timerId);
        maxTimerId !== undefined && clearTimeout(maxTimerId);
        timerId = maxTimerId = undefined;
    }
    function flush() {
        if (timerId !== undefined || maxTimerId !== undefined) return invokeFunc();
        return callbackReturnValue;
    }
    function debounced() {
        if (timerId) clearTimeout(timerId);
        timerId = setTimeout(invokeFunc, wait);
        if (maxWait && maxTimerId === undefined) maxTimerId = setTimeout(invokeFunc, maxWait);
        return callbackReturnValue;
    }
    debounced.cancel = cancelTimers;
    debounced.flush = flush;
    return debounced;
}
/**
 * Handler for recording events.
 *
 * Adds to event buffer, and has varying flushing behaviors if the event was a checkout.
 */ function getHandleRecordingEmit(replay) {
    var hadFirstEvent = false;
    return function(event, _isCheckout) {
        // If this is false, it means session is expired, create and a new session and wait for checkout
        if (!replay.checkAndHandleExpiredSession()) {
            DEBUG_BUILD && (0, _utils.logger).warn('[Replay] Received replay event after session expired.');
            return;
        }
        // `_isCheckout` is only set when the checkout is due to `checkoutEveryNms`
        // We also want to treat the first event as a checkout, so we handle this specifically here
        var isCheckout = _isCheckout || !hadFirstEvent;
        hadFirstEvent = true;
        if (replay.clickDetector) updateClickDetectorForRecordingEvent(replay.clickDetector, event);
        // The handler returns `true` if we do not want to trigger debounced flush, `false` if we want to debounce flush.
        replay.addUpdate(function() {
            // The session is always started immediately on pageload/init, but for
            // error-only replays, it should reflect the most recent checkout
            // when an error occurs. Clear any state that happens before this current
            // checkout. This needs to happen before `addEvent()` which updates state
            // dependent on this reset.
            if (replay.recordingMode === 'buffer' && isCheckout) replay.setInitialState();
            // If the event is not added (e.g. due to being paused, disabled, or out of the max replay duration),
            // Skip all further steps
            if (!addEventSync(replay, event, isCheckout)) // Return true to skip scheduling a debounced flush
            return true;
            // Different behavior for full snapshots (type=2), ignore other event types
            // See https://github.com/rrweb-io/rrweb/blob/d8f9290ca496712aa1e7d472549480c4e7876594/packages/rrweb/src/types.ts#L16
            if (!isCheckout) return false;
            // Additionally, create a meta event that will capture certain SDK settings.
            // In order to handle buffer mode, this needs to either be done when we
            // receive checkout events or at flush time.
            //
            // `isCheckout` is always true, but want to be explicit that it should
            // only be added for checkouts
            addSettingsEvent(replay, isCheckout);
            // If there is a previousSessionId after a full snapshot occurs, then
            // the replay session was started due to session expiration. The new session
            // is started before triggering a new checkout and contains the id
            // of the previous session. Do not immediately flush in this case
            // to avoid capturing only the checkout and instead the replay will
            // be captured if they perform any follow-up actions.
            if (replay.session && replay.session.previousSessionId) return true;
            // When in buffer mode, make sure we adjust the session started date to the current earliest event of the buffer
            // this should usually be the timestamp of the checkout event, but to be safe...
            if (replay.recordingMode === 'buffer' && replay.session && replay.eventBuffer) {
                var earliestEvent = replay.eventBuffer.getEarliestTimestamp();
                if (earliestEvent) {
                    logInfo(`[Replay] Updating session start time to earliest event in buffer to ${new Date(earliestEvent)}`, replay.getOptions()._experiments.traceInternals);
                    replay.session.started = earliestEvent;
                    if (replay.getOptions().stickySession) saveSession(replay.session);
                }
            }
            if (replay.recordingMode === 'session') // If the full snapshot is due to an initial load, we will not have
            // a previous session ID. In this case, we want to buffer events
            // for a set amount of time before flushing. This can help avoid
            // capturing replays of users that immediately close the window.
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            replay.flush();
            return true;
        });
    };
}
/**
 * Exported for tests
 */ function createOptionsEvent(replay) {
    var options = replay.getOptions();
    return {
        type: EventType.Custom,
        timestamp: Date.now(),
        data: {
            tag: 'options',
            payload: {
                shouldRecordCanvas: replay.isRecordingCanvas(),
                sessionSampleRate: options.sessionSampleRate,
                errorSampleRate: options.errorSampleRate,
                useCompressionOption: options.useCompression,
                blockAllMedia: options.blockAllMedia,
                maskAllText: options.maskAllText,
                maskAllInputs: options.maskAllInputs,
                useCompression: replay.eventBuffer ? replay.eventBuffer.type === 'worker' : false,
                networkDetailHasUrls: options.networkDetailAllowUrls.length > 0,
                networkCaptureBodies: options.networkCaptureBodies,
                networkRequestHasHeaders: options.networkRequestHeaders.length > 0,
                networkResponseHasHeaders: options.networkResponseHeaders.length > 0
            }
        }
    };
}
/**
 * Add a "meta" event that contains a simplified view on current configuration
 * options. This should only be included on the first segment of a recording.
 */ function addSettingsEvent(replay, isCheckout) {
    // Only need to add this event when sending the first segment
    if (!isCheckout || !replay.session || replay.session.segmentId !== 0) return;
    addEventSync(replay, createOptionsEvent(replay), false);
}
/**
 * Create a replay envelope ready to be sent.
 * This includes both the replay event, as well as the recording data.
 */ function createReplayEnvelope(replayEvent, recordingData, dsn, tunnel) {
    return (0, _utils.createEnvelope)((0, _utils.createEventEnvelopeHeaders)(replayEvent, (0, _utils.getSdkMetadataForEnvelopeHeader)(replayEvent), tunnel, dsn), [
        [
            {
                type: 'replay_event'
            },
            replayEvent
        ],
        [
            {
                type: 'replay_recording',
                // If string then we need to encode to UTF8, otherwise will have
                // wrong size. TextEncoder has similar browser support to
                // MutationObserver, although it does not accept IE11.
                length: typeof recordingData === 'string' ? new TextEncoder().encode(recordingData).length : recordingData.length
            },
            recordingData
        ]
    ]);
}
/**
 * Prepare the recording data ready to be sent.
 */ function prepareRecordingData(param) {
    var recordingData = param.recordingData, headers = param.headers;
    var payloadWithSequence;
    // XXX: newline is needed to separate sequence id from events
    var replayHeaders = `${JSON.stringify(headers)}
`;
    if (typeof recordingData === 'string') payloadWithSequence = `${replayHeaders}${recordingData}`;
    else {
        var enc = new TextEncoder();
        // XXX: newline is needed to separate sequence id from events
        var sequence = enc.encode(replayHeaders);
        // Merge the two Uint8Arrays
        payloadWithSequence = new Uint8Array(sequence.length + recordingData.length);
        payloadWithSequence.set(sequence);
        payloadWithSequence.set(recordingData, sequence.length);
    }
    return payloadWithSequence;
}
function prepareReplayEvent(_) {
    return _prepareReplayEvent.apply(this, arguments);
}
function _prepareReplayEvent() {
    _prepareReplayEvent = /**
 * Prepare a replay event & enrich it with the SDK metadata.
 */ (0, _asyncToGenerator._)(function(param) {
        var client, scope, event_id, event, integrations, eventHint, preparedEvent, metadata, _ref, name, version;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    client = param.client, scope = param.scope, event_id = param.replayId, event = param.event;
                    integrations = typeof client._integrations === 'object' && client._integrations !== null && !Array.isArray(client._integrations) ? Object.keys(client._integrations) : undefined;
                    eventHint = {
                        event_id: event_id,
                        integrations: integrations
                    };
                    if (client.emit) client.emit('preprocessEvent', event, eventHint);
                    return [
                        4,
                        (0, _core.prepareEvent)(client.getOptions(), event, eventHint, scope, client, (0, _core.getIsolationScope)())
                    ];
                case 1:
                    preparedEvent = _state.sent();
                    // If e.g. a global event processor returned null
                    if (!preparedEvent) return [
                        2,
                        null
                    ];
                    // This normally happens in browser client "_prepareEvent"
                    // but since we do not use this private method from the client, but rather the plain import
                    // we need to do this manually.
                    preparedEvent.platform = preparedEvent.platform || 'javascript';
                    // extract the SDK name because `client._prepareEvent` doesn't add it to the event
                    metadata = client.getSdkMetadata && client.getSdkMetadata();
                    _ref = metadata && metadata.sdk || {}, name = _ref.name, version = _ref.version;
                    preparedEvent.sdk = (0, _objectSpreadProps._)((0, _objectSpread._)({}, preparedEvent.sdk), {
                        name: name || 'sentry.javascript.unknown',
                        version: version || '0.0.0'
                    });
                    return [
                        2,
                        preparedEvent
                    ];
            }
        });
    });
    return _prepareReplayEvent.apply(this, arguments);
}
function sendReplayRequest(_) {
    return _sendReplayRequest.apply(this, arguments);
}
function _sendReplayRequest() {
    _sendReplayRequest = /**
 * Send replay attachment using `fetch()`
 */ (0, _asyncToGenerator._)(function(param) {
        var recordingData, replayId, segment_id, eventContext, timestamp, session, preparedRecordingData, urls, errorIds, traceIds, initialTimestamp, client, scope, transport, dsn, baseEvent, replayEvent, envelope, response, err, error, rateLimits;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    recordingData = param.recordingData, replayId = param.replayId, segment_id = param.segmentId, eventContext = param.eventContext, timestamp = param.timestamp, session = param.session;
                    preparedRecordingData = prepareRecordingData({
                        recordingData: recordingData,
                        headers: {
                            segment_id: segment_id
                        }
                    });
                    urls = eventContext.urls, errorIds = eventContext.errorIds, traceIds = eventContext.traceIds, initialTimestamp = eventContext.initialTimestamp;
                    client = (0, _core.getClient)();
                    scope = (0, _core.getCurrentScope)();
                    transport = client && client.getTransport();
                    dsn = client && client.getDsn();
                    if (!client || !transport || !dsn || !session.sampled) return [
                        2
                    ];
                    baseEvent = {
                        type: REPLAY_EVENT_NAME,
                        replay_start_timestamp: initialTimestamp / 1000,
                        timestamp: timestamp / 1000,
                        error_ids: errorIds,
                        trace_ids: traceIds,
                        urls: urls,
                        replay_id: replayId,
                        segment_id: segment_id,
                        replay_type: session.sampled
                    };
                    return [
                        4,
                        prepareReplayEvent({
                            scope: scope,
                            client: client,
                            replayId: replayId,
                            event: baseEvent
                        })
                    ];
                case 1:
                    replayEvent = _state.sent();
                    if (!replayEvent) {
                        // Taken from baseclient's `_processEvent` method, where this is handled for errors/transactions
                        client.recordDroppedEvent('event_processor', 'replay', baseEvent);
                        logInfo('An event processor returned `null`, will not send event.');
                        return [
                            2
                        ];
                    }
                    /*
  For reference, the fully built event looks something like this:
  {
      "type": "replay_event",
      "timestamp": 1670837008.634,
      "error_ids": [
          "errorId"
      ],
      "trace_ids": [
          "traceId"
      ],
      "urls": [
          "https://example.com"
      ],
      "replay_id": "eventId",
      "segment_id": 3,
      "replay_type": "error",
      "platform": "javascript",
      "event_id": "eventId",
      "environment": "production",
      "sdk": {
          "integrations": [
              "BrowserTracing",
              "Replay"
          ],
          "name": "sentry.javascript.browser",
          "version": "7.25.0"
      },
      "sdkProcessingMetadata": {},
      "contexts": {
      },
  }
  */ // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
                    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
                    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
                    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
                    delete replayEvent.sdkProcessingMetadata;
                    envelope = createReplayEnvelope(replayEvent, preparedRecordingData, dsn, client.getOptions().tunnel);
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        transport.send(envelope)
                    ];
                case 3:
                    response = _state.sent();
                    return [
                        3,
                        5
                    ];
                case 4:
                    err = _state.sent();
                    error = new Error(UNABLE_TO_SEND_REPLAY);
                    try {
                        // In case browsers don't allow this property to be writable
                        // @ts-expect-error This needs lib es2022 and newer
                        error.cause = err;
                    } catch (e) {
                    // nothing to do
                    }
                    throw error;
                case 5:
                    // TODO (v8): we can remove this guard once transport.send's type signature doesn't include void anymore
                    if (!response) return [
                        2,
                        response
                    ];
                    // If the status code is invalid, we want to immediately stop & not retry
                    if (typeof response.statusCode === 'number' && (response.statusCode < 200 || response.statusCode >= 300)) throw new TransportStatusCodeError(response.statusCode);
                    rateLimits = (0, _utils.updateRateLimits)({}, response);
                    if ((0, _utils.isRateLimited)(rateLimits, 'replay')) throw new RateLimitError(rateLimits);
                    return [
                        2,
                        response
                    ];
            }
        });
    });
    return _sendReplayRequest.apply(this, arguments);
}
/**
 * This error indicates that the transport returned an invalid status code.
 */ var TransportStatusCodeError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, _inherits._)(TransportStatusCodeError, Error1);
    function TransportStatusCodeError(statusCode) {
        (0, _classCallCheck._)(this, TransportStatusCodeError);
        return (0, _callSuper._)(this, TransportStatusCodeError, [
            `Transport returned status code ${statusCode}`
        ]);
    }
    return TransportStatusCodeError;
}((0, _wrapNativeSuper._)(Error));
/**
 * This error indicates that we hit a rate limit API error.
 */ var RateLimitError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, _inherits._)(RateLimitError, Error1);
    function RateLimitError(rateLimits) {
        (0, _classCallCheck._)(this, RateLimitError);
        var _this;
        _this = (0, _callSuper._)(this, RateLimitError, [
            'Rate limit hit'
        ]);
        _this.rateLimits = rateLimits;
        return _this;
    }
    return RateLimitError;
}((0, _wrapNativeSuper._)(Error));
function sendReplay(replayData) {
    return _sendReplay.apply(this, arguments);
}
function _sendReplay() {
    _sendReplay = /**
 * Finalize and send the current replay event to Sentry
 */ (0, _asyncToGenerator._)(function(replayData) {
        var retryConfig, recordingData, options, err, error;
        var _arguments = arguments;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    retryConfig = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {
                        count: 0,
                        interval: RETRY_BASE_INTERVAL
                    };
                    recordingData = replayData.recordingData, options = replayData.options;
                    // short circuit if there's no events to upload (this shouldn't happen as _runFlush makes this check)
                    if (!recordingData.length) return [
                        2
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        sendReplayRequest(replayData)
                    ];
                case 2:
                    _state.sent();
                    return [
                        2,
                        true
                    ];
                case 3:
                    err = _state.sent();
                    if (err instanceof TransportStatusCodeError || err instanceof RateLimitError) throw err;
                    // Capture error for every failed replay
                    (0, _core.setContext)('Replays', {
                        _retryCount: retryConfig.count
                    });
                    if (DEBUG_BUILD && options._experiments && options._experiments.captureExceptions) (0, _core.captureException)(err);
                    // If an error happened here, it's likely that uploading the attachment
                    // failed, we'll can retry with the same events payload
                    if (retryConfig.count >= RETRY_MAX_COUNT) {
                        error = new Error(`${UNABLE_TO_SEND_REPLAY} - max retries exceeded`);
                        try {
                            // In case browsers don't allow this property to be writable
                            // @ts-expect-error This needs lib es2022 and newer
                            error.cause = err;
                        } catch (e) {
                        // nothing to do
                        }
                        throw error;
                    }
                    // will retry in intervals of 5, 10, 30
                    retryConfig.interval *= ++retryConfig.count;
                    return [
                        2,
                        new Promise(function(resolve, reject) {
                            setTimeout(/*#__PURE__*/ (0, _asyncToGenerator._)(function() {
                                var err;
                                return (0, _tsGenerator._)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            _state.trys.push([
                                                0,
                                                2,
                                                ,
                                                3
                                            ]);
                                            return [
                                                4,
                                                sendReplay(replayData, retryConfig)
                                            ];
                                        case 1:
                                            _state.sent();
                                            resolve(true);
                                            return [
                                                3,
                                                3
                                            ];
                                        case 2:
                                            err = _state.sent();
                                            reject(err);
                                            return [
                                                3,
                                                3
                                            ];
                                        case 3:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            }), retryConfig.interval);
                        })
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _sendReplay.apply(this, arguments);
}
var THROTTLED = '__THROTTLED';
var SKIPPED = '__SKIPPED';
/**
 * Create a throttled function off a given function.
 * When calling the throttled function, it will call the original function only
 * if it hasn't been called more than `maxCount` times in the last `durationSeconds`.
 *
 * Returns `THROTTLED` if throttled for the first time, after that `SKIPPED`,
 * or else the return value of the original function.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function throttle(fn, maxCount, durationSeconds) {
    var counter = new Map();
    var _cleanup = function(now) {
        var threshold = now - durationSeconds;
        counter.forEach(function(_value, key) {
            if (key < threshold) counter.delete(key);
        });
    };
    var _getTotalCount = function() {
        return (0, _toConsumableArray._)(counter.values()).reduce(function(a, b) {
            return a + b;
        }, 0);
    };
    var isThrottled = false;
    return function() {
        for(var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++){
            rest[_key] = arguments[_key];
        }
        // Date in second-precision, which we use as basis for the throttling
        var now = Math.floor(Date.now() / 1000);
        // First, make sure to delete any old entries
        _cleanup(now);
        // If already over limit, do nothing
        if (_getTotalCount() >= maxCount) {
            var wasThrottled = isThrottled;
            isThrottled = true;
            return wasThrottled ? SKIPPED : THROTTLED;
        }
        isThrottled = false;
        var count = counter.get(now) || 0;
        counter.set(now, count + 1);
        return fn.apply(void 0, (0, _toConsumableArray._)(rest));
    };
}
/* eslint-disable max-lines */ // TODO: We might want to split this file up
/**
 * The main replay container class, which holds all the state and methods for recording and sending replays.
 */ var ReplayContainer = /*#__PURE__*/ function() {
    "use strict";
    function ReplayContainer(param) {
        var _this = this;
        var options = param.options, recordingOptions = param.recordingOptions;
        (0, _classCallCheck._)(this, ReplayContainer);
        ReplayContainer.prototype.__init.call(this);
        ReplayContainer.prototype.__init2.call(this);
        ReplayContainer.prototype.__init3.call(this);
        ReplayContainer.prototype.__init4.call(this);
        ReplayContainer.prototype.__init5.call(this);
        ReplayContainer.prototype.__init6.call(this);
        this.eventBuffer = null;
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        this.recordingMode = 'session';
        this.timeouts = {
            sessionIdlePause: SESSION_IDLE_PAUSE_DURATION,
            sessionIdleExpire: SESSION_IDLE_EXPIRE_DURATION
        };
        this._lastActivity = Date.now();
        this._isEnabled = false;
        this._isPaused = false;
        this._hasInitializedCoreListeners = false;
        this._context = {
            errorIds: new Set(),
            traceIds: new Set(),
            urls: [],
            initialTimestamp: Date.now(),
            initialUrl: ''
        };
        this._recordingOptions = recordingOptions;
        this._options = options;
        this._debouncedFlush = debounce(function() {
            return _this._flush();
        }, this._options.flushMinDelay, {
            maxWait: this._options.flushMaxDelay
        });
        this._throttledAddEvent = throttle(function(event, isCheckout) {
            return addEvent(_this, event, isCheckout);
        }, // Max 300 events...
        300, // ... per 5s
        5);
        var _this_getOptions = this.getOptions(), slowClickTimeout = _this_getOptions.slowClickTimeout, slowClickIgnoreSelectors = _this_getOptions.slowClickIgnoreSelectors;
        var slowClickConfig = slowClickTimeout ? {
            threshold: Math.min(SLOW_CLICK_THRESHOLD, slowClickTimeout),
            timeout: slowClickTimeout,
            scrollTimeout: SLOW_CLICK_SCROLL_TIMEOUT,
            ignoreSelector: slowClickIgnoreSelectors ? slowClickIgnoreSelectors.join(',') : ''
        } : undefined;
        if (slowClickConfig) this.clickDetector = new ClickDetector(this, slowClickConfig);
    }
    (0, _createClass._)(ReplayContainer, [
        {
            /** Get the event context. */ key: "getContext",
            value: function getContext() {
                return this._context;
            }
        },
        {
            /** If recording is currently enabled. */ key: "isEnabled",
            value: function isEnabled() {
                return this._isEnabled;
            }
        },
        {
            /** If recording is currently paused. */ key: "isPaused",
            value: function isPaused() {
                return this._isPaused;
            }
        },
        {
            /**
   * Determine if canvas recording is enabled
   */ key: "isRecordingCanvas",
            value: function isRecordingCanvas() {
                return Boolean(this._canvas);
            }
        },
        {
            /** Get the replay integration options. */ key: "getOptions",
            value: function getOptions() {
                return this._options;
            }
        },
        {
            /**
   * Initializes the plugin based on sampling configuration. Should not be
   * called outside of constructor.
   */ key: "initializeSampling",
            value: function initializeSampling(previousSessionId) {
                var _this__options = this._options, errorSampleRate = _this__options.errorSampleRate, sessionSampleRate = _this__options.sessionSampleRate;
                // If neither sample rate is > 0, then do nothing - user will need to call one of
                // `start()` or `startBuffering` themselves.
                if (errorSampleRate <= 0 && sessionSampleRate <= 0) return;
                // Otherwise if there is _any_ sample rate set, try to load an existing
                // session, or create a new one.
                this._initializeSessionForSampling(previousSessionId);
                if (!this.session) {
                    // This should not happen, something wrong has occurred
                    this._handleException(new Error('Unable to initialize and create session'));
                    return;
                }
                if (this.session.sampled === false) // This should only occur if `errorSampleRate` is 0 and was unsampled for
                // session-based replay. In this case there is nothing to do.
                return;
                // If segmentId > 0, it means we've previously already captured this session
                // In this case, we still want to continue in `session` recording mode
                this.recordingMode = this.session.sampled === 'buffer' && this.session.segmentId === 0 ? 'buffer' : 'session';
                logInfoNextTick(`[Replay] Starting replay in ${this.recordingMode} mode`, this._options._experiments.traceInternals);
                this._initializeRecording();
            }
        },
        {
            /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will throw an error if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * _performanceObserver, Recording, Sentry SDK, etc)
   */ key: "start",
            value: function start() {
                if (this._isEnabled && this.recordingMode === 'session') throw new Error('Replay recording is already in progress');
                if (this._isEnabled && this.recordingMode === 'buffer') throw new Error('Replay buffering is in progress, call `flush()` to save the replay');
                logInfoNextTick('[Replay] Starting replay in session mode', this._options._experiments.traceInternals);
                // Required as user activity is initially set in
                // constructor, so if `start()` is called after
                // session idle expiration, a replay will not be
                // created due to an idle timeout.
                this._updateUserActivity();
                var session = loadOrCreateSession({
                    maxReplayDuration: this._options.maxReplayDuration,
                    sessionIdleExpire: this.timeouts.sessionIdleExpire,
                    traceInternals: this._options._experiments.traceInternals
                }, {
                    stickySession: this._options.stickySession,
                    // This is intentional: create a new session-based replay when calling `start()`
                    sessionSampleRate: 1,
                    allowBuffering: false
                });
                this.session = session;
                this._initializeRecording();
            }
        },
        {
            /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, an error occurs.
   */ key: "startBuffering",
            value: function startBuffering() {
                if (this._isEnabled) throw new Error('Replay recording is already in progress');
                logInfoNextTick('[Replay] Starting replay in buffer mode', this._options._experiments.traceInternals);
                var session = loadOrCreateSession({
                    sessionIdleExpire: this.timeouts.sessionIdleExpire,
                    maxReplayDuration: this._options.maxReplayDuration,
                    traceInternals: this._options._experiments.traceInternals
                }, {
                    stickySession: this._options.stickySession,
                    sessionSampleRate: 0,
                    allowBuffering: true
                });
                this.session = session;
                this.recordingMode = 'buffer';
                this._initializeRecording();
            }
        },
        {
            /**
   * Start recording.
   *
   * Note that this will cause a new DOM checkout
   */ key: "startRecording",
            value: function startRecording() {
                try {
                    var canvasOptions = this._canvas;
                    this._stopRecording = record((0, _objectSpread._)((0, _objectSpreadProps._)((0, _objectSpread._)({}, this._recordingOptions, this.recordingMode === 'buffer' && {
                        checkoutEveryNms: BUFFER_CHECKOUT_TIME
                    }), {
                        emit: getHandleRecordingEmit(this),
                        onMutation: this._onMutationHandler
                    }), canvasOptions ? {
                        recordCanvas: canvasOptions.recordCanvas,
                        getCanvasManager: canvasOptions.getCanvasManager,
                        sampling: canvasOptions.sampling,
                        dataURLOptions: canvasOptions.dataURLOptions
                    } : {}));
                } catch (err) {
                    this._handleException(err);
                }
            }
        },
        {
            /**
   * Stops the recording, if it was running.
   *
   * Returns true if it was previously stopped, or is now stopped,
   * otherwise false.
   */ key: "stopRecording",
            value: function stopRecording() {
                try {
                    if (this._stopRecording) {
                        this._stopRecording();
                        this._stopRecording = undefined;
                    }
                    return true;
                } catch (err) {
                    this._handleException(err);
                    return false;
                }
            }
        },
        {
            key: "stop",
            value: /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */ function stop() {
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_forceFlush = _ref.forceFlush, forceFlush = _ref_forceFlush === void 0 ? false : _ref_forceFlush, reason = _ref.reason;
                var _this = this;
                return (0, _asyncToGenerator._)(function() {
                    var err;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this._isEnabled) return [
                                    2
                                ];
                                // We can't move `_isEnabled` after awaiting a flush, otherwise we can
                                // enter into an infinite loop when `stop()` is called while flushing.
                                _this._isEnabled = false;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    4,
                                    ,
                                    5
                                ]);
                                logInfo(`[Replay] Stopping Replay${reason ? ` triggered by ${reason}` : ''}`, _this._options._experiments.traceInternals);
                                _this._removeListeners();
                                _this.stopRecording();
                                _this._debouncedFlush.cancel();
                                if (!forceFlush) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    _this._flush({
                                        force: true
                                    })
                                ];
                            case 2:
                                _state.sent();
                                _state.label = 3;
                            case 3:
                                // After flush, destroy event buffer
                                _this.eventBuffer && _this.eventBuffer.destroy();
                                _this.eventBuffer = null;
                                // Clear session from session storage, note this means if a new session
                                // is started after, it will not have `previousSessionId`
                                clearSession(_this);
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                err = _state.sent();
                                _this._handleException(err);
                                return [
                                    3,
                                    5
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
   * Pause some replay functionality. See comments for `_isPaused`.
   * This differs from stop as this only stops DOM recording, it is
   * not as thorough of a shutdown as `stop()`.
   */ key: "pause",
            value: function pause() {
                if (this._isPaused) return;
                this._isPaused = true;
                this.stopRecording();
                logInfo('[Replay] Pausing replay', this._options._experiments.traceInternals);
            }
        },
        {
            /**
   * Resumes recording, see notes for `pause().
   *
   * Note that calling `startRecording()` here will cause a
   * new DOM checkout.`
   */ key: "resume",
            value: function resume() {
                if (!this._isPaused || !this._checkSession()) return;
                this._isPaused = false;
                this.startRecording();
                logInfo('[Replay] Resuming replay', this._options._experiments.traceInternals);
            }
        },
        {
            key: "sendBufferedReplayOrFlush",
            value: /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */ function sendBufferedReplayOrFlush() {
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_continueRecording = _ref.continueRecording, continueRecording = _ref_continueRecording === void 0 ? true : _ref_continueRecording;
                var _this = this;
                return (0, _asyncToGenerator._)(function() {
                    var activityTime, hasStoppedRecording;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (_this.recordingMode === 'session') return [
                                    2,
                                    _this.flushImmediate()
                                ];
                                activityTime = Date.now();
                                logInfo('[Replay] Converting buffer to session', _this._options._experiments.traceInternals);
                                // Allow flush to complete before resuming as a session recording, otherwise
                                // the checkout from `startRecording` may be included in the payload.
                                // Prefer to keep the error replay as a separate (and smaller) segment
                                // than the session replay.
                                return [
                                    4,
                                    _this.flushImmediate()
                                ];
                            case 1:
                                _state.sent();
                                hasStoppedRecording = _this.stopRecording();
                                if (!continueRecording || !hasStoppedRecording) return [
                                    2
                                ];
                                // To avoid race conditions where this is called multiple times, we check here again that we are still buffering
                                if (_this.recordingMode === 'session') return [
                                    2
                                ];
                                // Re-start recording in session-mode
                                _this.recordingMode = 'session';
                                // Once this session ends, we do not want to refresh it
                                if (_this.session) {
                                    _this._updateUserActivity(activityTime);
                                    _this._updateSessionActivity(activityTime);
                                    _this._maybeSaveSession();
                                }
                                _this.startRecording();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
   * We want to batch uploads of replay events. Save events only if
   * `<flushMinDelay>` milliseconds have elapsed since the last event
   * *OR* if `<flushMaxDelay>` milliseconds have elapsed.
   *
   * Accepts a callback to perform side-effects and returns true to stop batch
   * processing and hand back control to caller.
   */ key: "addUpdate",
            value: function addUpdate(cb) {
                // We need to always run `cb` (e.g. in the case of `this.recordingMode == 'buffer'`)
                var cbResult = cb();
                // If this option is turned on then we will only want to call `flush`
                // explicitly
                if (this.recordingMode === 'buffer') return;
                // If callback is true, we do not want to continue with flushing -- the
                // caller will need to handle it.
                if (cbResult === true) return;
                // addUpdate is called quite frequently - use _debouncedFlush so that it
                // respects the flush delays and does not flush immediately
                this._debouncedFlush();
            }
        },
        {
            /**
   * Updates the user activity timestamp and resumes recording. This should be
   * called in an event handler for a user action that we consider as the user
   * being "active" (e.g. a mouse click).
   */ key: "triggerUserActivity",
            value: function triggerUserActivity() {
                this._updateUserActivity();
                // This case means that recording was once stopped due to inactivity.
                // Ensure that recording is resumed.
                if (!this._stopRecording) {
                    // Create a new session, otherwise when the user action is flushed, it
                    // will get rejected due to an expired session.
                    if (!this._checkSession()) return;
                    // Note: This will cause a new DOM checkout
                    this.resume();
                    return;
                }
                // Otherwise... recording was never suspended, continue as normalish
                this.checkAndHandleExpiredSession();
                this._updateSessionActivity();
            }
        },
        {
            /**
   * Updates the user activity timestamp *without* resuming
   * recording. Some user events (e.g. keydown) can be create
   * low-value replays that only contain the keypress as a
   * breadcrumb. Instead this would require other events to
   * create a new replay after a session has expired.
   */ key: "updateUserActivity",
            value: function updateUserActivity() {
                this._updateUserActivity();
                this._updateSessionActivity();
            }
        },
        {
            /**
   * Only flush if `this.recordingMode === 'session'`
   */ key: "conditionalFlush",
            value: function conditionalFlush() {
                if (this.recordingMode === 'buffer') return Promise.resolve();
                return this.flushImmediate();
            }
        },
        {
            /**
   * Flush using debounce flush
   */ key: "flush",
            value: function flush() {
                return this._debouncedFlush();
            }
        },
        {
            /**
   * Always flush via `_debouncedFlush` so that we do not have flushes triggered
   * from calling both `flush` and `_debouncedFlush`. Otherwise, there could be
   * cases of mulitple flushes happening closely together.
   */ key: "flushImmediate",
            value: function flushImmediate() {
                this._debouncedFlush();
                // `.flush` is provided by the debounced function, analogously to lodash.debounce
                return this._debouncedFlush.flush();
            }
        },
        {
            /**
   * Cancels queued up flushes.
   */ key: "cancelFlush",
            value: function cancelFlush() {
                this._debouncedFlush.cancel();
            }
        },
        {
            /** Get the current sesion (=replay) ID */ key: "getSessionId",
            value: function getSessionId() {
                return this.session && this.session.id;
            }
        },
        {
            /**
   * Checks if recording should be stopped due to user inactivity. Otherwise
   * check if session is expired and create a new session if so. Triggers a new
   * full snapshot on new session.
   *
   * Returns true if session is not expired, false otherwise.
   * @hidden
   */ key: "checkAndHandleExpiredSession",
            value: function checkAndHandleExpiredSession() {
                // Prevent starting a new session if the last user activity is older than
                // SESSION_IDLE_PAUSE_DURATION. Otherwise non-user activity can trigger a new
                // session+recording. This creates noisy replays that do not have much
                // content in them.
                if (this._lastActivity && isExpired(this._lastActivity, this.timeouts.sessionIdlePause) && this.session && this.session.sampled === 'session') {
                    // Pause recording only for session-based replays. Otherwise, resuming
                    // will create a new replay and will conflict with users who only choose
                    // to record error-based replays only. (e.g. the resumed replay will not
                    // contain a reference to an error)
                    this.pause();
                    return;
                }
                // --- There is recent user activity --- //
                // This will create a new session if expired, based on expiry length
                if (!this._checkSession()) // Check session handles the refreshing itself
                return false;
                return true;
            }
        },
        {
            /**
   * Capture some initial state that can change throughout the lifespan of the
   * replay. This is required because otherwise they would be captured at the
   * first flush.
   */ key: "setInitialState",
            value: function setInitialState() {
                var urlPath = `${WINDOW.location.pathname}${WINDOW.location.hash}${WINDOW.location.search}`;
                var url = `${WINDOW.location.origin}${urlPath}`;
                this.performanceEntries = [];
                this.replayPerformanceEntries = [];
                // Reset _context as well
                this._clearContext();
                this._context.initialUrl = url;
                this._context.initialTimestamp = Date.now();
                this._context.urls.push(url);
            }
        },
        {
            /**
   * Add a breadcrumb event, that may be throttled.
   * If it was throttled, we add a custom breadcrumb to indicate that.
   */ key: "throttledAddEvent",
            value: function throttledAddEvent(event, isCheckout) {
                var _this = this;
                var res = this._throttledAddEvent(event, isCheckout);
                // If this is THROTTLED, it means we have throttled the event for the first time
                // In this case, we want to add a breadcrumb indicating that something was skipped
                if (res === THROTTLED) {
                    var breadcrumb = createBreadcrumb({
                        category: 'replay.throttled'
                    });
                    this.addUpdate(function() {
                        // Return `false` if the event _was_ added, as that means we schedule a flush
                        return !addEventSync(_this, {
                            type: ReplayEventTypeCustom,
                            timestamp: breadcrumb.timestamp || 0,
                            data: {
                                tag: 'breadcrumb',
                                payload: breadcrumb,
                                metric: true
                            }
                        });
                    });
                }
                return res;
            }
        },
        {
            /**
   * This will get the parametrized route name of the current page.
   * This is only available if performance is enabled, and if an instrumented router is used.
   */ key: "getCurrentRoute",
            value: function getCurrentRoute() {
                // eslint-disable-next-line deprecation/deprecation
                var lastTransaction = this.lastTransaction || (0, _core.getCurrentScope)().getTransaction();
                var attributes = lastTransaction && (0, _core.spanToJSON)(lastTransaction).data || {};
                var source = attributes[0, _core.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
                if (!lastTransaction || !source || ![
                    'route',
                    'custom'
                ].includes(source)) return undefined;
                return (0, _core.spanToJSON)(lastTransaction).description;
            }
        },
        {
            /**
   * Initialize and start all listeners to varying events (DOM,
   * Performance Observer, Recording, Sentry SDK, etc)
   */ key: "_initializeRecording",
            value: function _initializeRecording() {
                this.setInitialState();
                // this method is generally called on page load or manually - in both cases
                // we should treat it as an activity
                this._updateSessionActivity();
                this.eventBuffer = createEventBuffer({
                    useCompression: this._options.useCompression,
                    workerUrl: this._options.workerUrl
                });
                this._removeListeners();
                this._addListeners();
                // Need to set as enabled before we start recording, as `record()` can trigger a flush with a new checkout
                this._isEnabled = true;
                this._isPaused = false;
                this.startRecording();
            }
        },
        {
            /** A wrapper to conditionally capture exceptions. */ key: "_handleException",
            value: function _handleException(error) {
                DEBUG_BUILD && (0, _utils.logger).error('[Replay]', error);
                if (DEBUG_BUILD && this._options._experiments && this._options._experiments.captureExceptions) (0, _core.captureException)(error);
            }
        },
        {
            /**
   * Loads (or refreshes) the current session.
   */ key: "_initializeSessionForSampling",
            value: function _initializeSessionForSampling(previousSessionId) {
                // Whenever there is _any_ error sample rate, we always allow buffering
                // Because we decide on sampling when an error occurs, we need to buffer at all times if sampling for errors
                var allowBuffering = this._options.errorSampleRate > 0;
                var session = loadOrCreateSession({
                    sessionIdleExpire: this.timeouts.sessionIdleExpire,
                    maxReplayDuration: this._options.maxReplayDuration,
                    traceInternals: this._options._experiments.traceInternals,
                    previousSessionId: previousSessionId
                }, {
                    stickySession: this._options.stickySession,
                    sessionSampleRate: this._options.sessionSampleRate,
                    allowBuffering: allowBuffering
                });
                this.session = session;
            }
        },
        {
            /**
   * Checks and potentially refreshes the current session.
   * Returns false if session is not recorded.
   */ key: "_checkSession",
            value: function _checkSession() {
                // If there is no session yet, we do not want to refresh anything
                // This should generally not happen, but to be safe....
                if (!this.session) return false;
                var currentSession = this.session;
                if (shouldRefreshSession(currentSession, {
                    sessionIdleExpire: this.timeouts.sessionIdleExpire,
                    maxReplayDuration: this._options.maxReplayDuration
                })) {
                    // This should never reject
                    // eslint-disable-next-line @typescript-eslint/no-floating-promises
                    this._refreshSession(currentSession);
                    return false;
                }
                return true;
            }
        },
        {
            key: "_refreshSession",
            value: /**
   * Refresh a session with a new one.
   * This stops the current session (without forcing a flush, as that would never work since we are expired),
   * and then does a new sampling based on the refreshed session.
   */ function _refreshSession(session) {
                var _this = this;
                return (0, _asyncToGenerator._)(function() {
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!_this._isEnabled) return [
                                    2
                                ];
                                return [
                                    4,
                                    _this.stop({
                                        reason: 'refresh session'
                                    })
                                ];
                            case 1:
                                _state.sent();
                                _this.initializeSampling(session.id);
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
   * Adds listeners to record events for the replay
   */ key: "_addListeners",
            value: function _addListeners() {
                try {
                    WINDOW.document.addEventListener('visibilitychange', this._handleVisibilityChange);
                    WINDOW.addEventListener('blur', this._handleWindowBlur);
                    WINDOW.addEventListener('focus', this._handleWindowFocus);
                    WINDOW.addEventListener('keydown', this._handleKeyboardEvent);
                    if (this.clickDetector) this.clickDetector.addListeners();
                    // There is no way to remove these listeners, so ensure they are only added once
                    if (!this._hasInitializedCoreListeners) {
                        addGlobalListeners(this);
                        this._hasInitializedCoreListeners = true;
                    }
                } catch (err) {
                    this._handleException(err);
                }
                this._performanceCleanupCallback = setupPerformanceObserver(this);
            }
        },
        {
            /**
   * Cleans up listeners that were created in `_addListeners`
   */ key: "_removeListeners",
            value: function _removeListeners() {
                try {
                    WINDOW.document.removeEventListener('visibilitychange', this._handleVisibilityChange);
                    WINDOW.removeEventListener('blur', this._handleWindowBlur);
                    WINDOW.removeEventListener('focus', this._handleWindowFocus);
                    WINDOW.removeEventListener('keydown', this._handleKeyboardEvent);
                    if (this.clickDetector) this.clickDetector.removeListeners();
                    if (this._performanceCleanupCallback) this._performanceCleanupCallback();
                } catch (err) {
                    this._handleException(err);
                }
            }
        },
        {
            /**
   * Handle when visibility of the page content changes. Opening a new tab will
   * cause the state to change to hidden because of content of current page will
   * be hidden. Likewise, moving a different window to cover the contents of the
   * page will also trigger a change to a hidden state.
   */ key: "__init",
            value: function __init() {
                var _this = this;
                this._handleVisibilityChange = function() {
                    if (WINDOW.document.visibilityState === 'visible') _this._doChangeToForegroundTasks();
                    else _this._doChangeToBackgroundTasks();
                };
            }
        },
        {
            /**
   * Handle when page is blurred
   */ key: "__init2",
            value: function __init2() {
                var _this = this;
                this._handleWindowBlur = function() {
                    var breadcrumb = createBreadcrumb({
                        category: 'ui.blur'
                    });
                    // Do not count blur as a user action -- it's part of the process of them
                    // leaving the page
                    _this._doChangeToBackgroundTasks(breadcrumb);
                };
            }
        },
        {
            /**
   * Handle when page is focused
   */ key: "__init3",
            value: function __init3() {
                var _this = this;
                this._handleWindowFocus = function() {
                    var breadcrumb = createBreadcrumb({
                        category: 'ui.focus'
                    });
                    // Do not count focus as a user action -- instead wait until they focus and
                    // interactive with page
                    _this._doChangeToForegroundTasks(breadcrumb);
                };
            }
        },
        {
            /** Ensure page remains active when a key is pressed. */ key: "__init4",
            value: function __init4() {
                var _this = this;
                this._handleKeyboardEvent = function(event) {
                    handleKeyboardEvent(_this, event);
                };
            }
        },
        {
            /**
   * Tasks to run when we consider a page to be hidden (via blurring and/or visibility)
   */ key: "_doChangeToBackgroundTasks",
            value: function _doChangeToBackgroundTasks(breadcrumb) {
                if (!this.session) return;
                var expired = isSessionExpired(this.session, {
                    maxReplayDuration: this._options.maxReplayDuration,
                    sessionIdleExpire: this.timeouts.sessionIdleExpire
                });
                if (expired) return;
                if (breadcrumb) this._createCustomBreadcrumb(breadcrumb);
                // Send replay when the page/tab becomes hidden. There is no reason to send
                // replay if it becomes visible, since no actions we care about were done
                // while it was hidden
                // This should never reject
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this.conditionalFlush();
            }
        },
        {
            /**
   * Tasks to run when we consider a page to be visible (via focus and/or visibility)
   */ key: "_doChangeToForegroundTasks",
            value: function _doChangeToForegroundTasks(breadcrumb) {
                if (!this.session) return;
                var isSessionActive = this.checkAndHandleExpiredSession();
                if (!isSessionActive) {
                    // If the user has come back to the page within SESSION_IDLE_PAUSE_DURATION
                    // ms, we will re-use the existing session, otherwise create a new
                    // session
                    logInfo('[Replay] Document has become active, but session has expired');
                    return;
                }
                if (breadcrumb) this._createCustomBreadcrumb(breadcrumb);
            }
        },
        {
            /**
   * Update user activity (across session lifespans)
   */ key: "_updateUserActivity",
            value: function _updateUserActivity() {
                var _lastActivity = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Date.now();
                this._lastActivity = _lastActivity;
            }
        },
        {
            /**
   * Updates the session's last activity timestamp
   */ key: "_updateSessionActivity",
            value: function _updateSessionActivity() {
                var _lastActivity = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Date.now();
                if (this.session) {
                    this.session.lastActivity = _lastActivity;
                    this._maybeSaveSession();
                }
            }
        },
        {
            /**
   * Helper to create (and buffer) a replay breadcrumb from a core SDK breadcrumb
   */ key: "_createCustomBreadcrumb",
            value: function _createCustomBreadcrumb(breadcrumb) {
                var _this = this;
                this.addUpdate(function() {
                    // This should never reject
                    // eslint-disable-next-line @typescript-eslint/no-floating-promises
                    _this.throttledAddEvent({
                        type: EventType.Custom,
                        timestamp: breadcrumb.timestamp || 0,
                        data: {
                            tag: 'breadcrumb',
                            payload: breadcrumb
                        }
                    });
                });
            }
        },
        {
            /**
   * Observed performance events are added to `this.performanceEntries`. These
   * are included in the replay event before it is finished and sent to Sentry.
   */ key: "_addPerformanceEntries",
            value: function _addPerformanceEntries() {
                var performanceEntries = createPerformanceEntries(this.performanceEntries).concat(this.replayPerformanceEntries);
                this.performanceEntries = [];
                this.replayPerformanceEntries = [];
                return Promise.all(createPerformanceSpans(this, performanceEntries));
            }
        },
        {
            /**
   * Clear _context
   */ key: "_clearContext",
            value: function _clearContext() {
                // XXX: `initialTimestamp` and `initialUrl` do not get cleared
                this._context.errorIds.clear();
                this._context.traceIds.clear();
                this._context.urls = [];
            }
        },
        {
            /** Update the initial timestamp based on the buffer content. */ key: "_updateInitialTimestampFromEventBuffer",
            value: function _updateInitialTimestampFromEventBuffer() {
                var _this = this, session = _this.session, eventBuffer = _this.eventBuffer;
                if (!session || !eventBuffer) return;
                // we only ever update this on the initial segment
                if (session.segmentId) return;
                var earliestEvent = eventBuffer.getEarliestTimestamp();
                if (earliestEvent && earliestEvent < this._context.initialTimestamp) this._context.initialTimestamp = earliestEvent;
            }
        },
        {
            /**
   * Return and clear _context
   */ key: "_popEventContext",
            value: function _popEventContext() {
                var _context = {
                    initialTimestamp: this._context.initialTimestamp,
                    initialUrl: this._context.initialUrl,
                    errorIds: Array.from(this._context.errorIds),
                    traceIds: Array.from(this._context.traceIds),
                    urls: this._context.urls
                };
                this._clearContext();
                return _context;
            }
        },
        {
            key: "_runFlush",
            value: /**
   * Flushes replay event buffer to Sentry.
   *
   * Performance events are only added right before flushing - this is
   * due to the buffered performance observer events.
   *
   * Should never be called directly, only by `flush`
   */ function _runFlush() {
                var _this = this;
                return (0, _asyncToGenerator._)(function() {
                    var replayId, timestamp, eventContext, segmentId, recordingData, err, client;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                replayId = _this.getSessionId();
                                if (!_this.session || !_this.eventBuffer || !replayId) {
                                    DEBUG_BUILD && (0, _utils.logger).error('[Replay] No session or eventBuffer found to flush.');
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    4,
                                    _this._addPerformanceEntries()
                                ];
                            case 1:
                                _state.sent();
                                // Check eventBuffer again, as it could have been stopped in the meanwhile
                                if (!_this.eventBuffer || !_this.eventBuffer.hasEvents) return [
                                    2
                                ];
                                // Only attach memory event if eventBuffer is not empty
                                return [
                                    4,
                                    addMemoryEntry(_this)
                                ];
                            case 2:
                                _state.sent();
                                // Check eventBuffer again, as it could have been stopped in the meanwhile
                                if (!_this.eventBuffer) return [
                                    2
                                ];
                                // if this changed in the meanwhile, e.g. because the session was refreshed or similar, we abort here
                                if (replayId !== _this.getSessionId()) return [
                                    2
                                ];
                                _state.label = 3;
                            case 3:
                                _state.trys.push([
                                    3,
                                    6,
                                    ,
                                    7
                                ]);
                                // This uses the data from the eventBuffer, so we need to call this before `finish()
                                _this._updateInitialTimestampFromEventBuffer();
                                timestamp = Date.now();
                                // Check total duration again, to avoid sending outdated stuff
                                // We leave 30s wiggle room to accomodate late flushing etc.
                                // This _could_ happen when the browser is suspended during flushing, in which case we just want to stop
                                if (timestamp - _this._context.initialTimestamp > _this._options.maxReplayDuration + 30000) throw new Error('Session is too long, not sending replay');
                                eventContext = _this._popEventContext();
                                // Always increment segmentId regardless of outcome of sending replay
                                segmentId = _this.session.segmentId++;
                                _this._maybeSaveSession();
                                return [
                                    4,
                                    _this.eventBuffer.finish()
                                ];
                            case 4:
                                recordingData = _state.sent();
                                return [
                                    4,
                                    sendReplay({
                                        replayId: replayId,
                                        recordingData: recordingData,
                                        segmentId: segmentId,
                                        eventContext: eventContext,
                                        session: _this.session,
                                        options: _this.getOptions(),
                                        timestamp: timestamp
                                    })
                                ];
                            case 5:
                                _state.sent();
                                return [
                                    3,
                                    7
                                ];
                            case 6:
                                err = _state.sent();
                                _this._handleException(err);
                                // This means we retried 3 times and all of them failed,
                                // or we ran into a problem we don't want to retry, like rate limiting.
                                // In this case, we want to completely stop the replay - otherwise, we may get inconsistent segments
                                // This should never reject
                                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                                _this.stop({
                                    reason: 'sendReplay'
                                });
                                client = (0, _core.getClient)();
                                if (client) client.recordDroppedEvent('send_error', 'replay');
                                return [
                                    3,
                                    7
                                ];
                            case 7:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            /**
   * Flush recording data to Sentry. Creates a lock so that only a single flush
   * can be active at a time. Do not call this directly.
   */ key: "__init5",
            value: function __init5() {
                var _this = this;
                this._flush = /*#__PURE__*/ (0, _asyncToGenerator._)(function() {
                    var _ref, _ref_force, force, start, now, duration, tooShort, tooLong, eventBuffer, err;
                    var _arguments = arguments;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _ref = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {}, _ref_force = _ref.force, force = _ref_force === void 0 ? false : _ref_force;
                                if (!_this._isEnabled && !force) // This can happen if e.g. the replay was stopped because of exceeding the retry limit
                                return [
                                    2
                                ];
                                if (!_this.checkAndHandleExpiredSession()) {
                                    DEBUG_BUILD && (0, _utils.logger).error('[Replay] Attempting to finish replay event after session expired.');
                                    return [
                                        2
                                    ];
                                }
                                if (!_this.session) // should never happen, as we would have bailed out before
                                return [
                                    2
                                ];
                                start = _this.session.started;
                                now = Date.now();
                                duration = now - start;
                                // A flush is about to happen, cancel any queued flushes
                                _this._debouncedFlush.cancel();
                                // If session is too short, or too long (allow some wiggle room over maxReplayDuration), do not send it
                                // This _should_ not happen, but it may happen if flush is triggered due to a page activity change or similar
                                tooShort = duration < _this._options.minReplayDuration;
                                tooLong = duration > _this._options.maxReplayDuration + 5000;
                                if (tooShort || tooLong) {
                                    logInfo(`[Replay] Session duration (${Math.floor(duration / 1000)}s) is too ${tooShort ? 'short' : 'long'}, not sending replay.`, _this._options._experiments.traceInternals);
                                    if (tooShort) _this._debouncedFlush();
                                    return [
                                        2
                                    ];
                                }
                                eventBuffer = _this.eventBuffer;
                                if (eventBuffer && _this.session.segmentId === 0 && !eventBuffer.hasCheckout) logInfo('[Replay] Flushing initial segment without checkout.', _this._options._experiments.traceInternals);
                                if (!!_this._flushLock) return [
                                    3,
                                    2
                                ];
                                _this._flushLock = _this._runFlush();
                                return [
                                    4,
                                    _this._flushLock
                                ];
                            case 1:
                                _state.sent();
                                _this._flushLock = undefined;
                                return [
                                    2
                                ];
                            case 2:
                                _state.trys.push([
                                    2,
                                    4,
                                    5,
                                    6
                                ]);
                                return [
                                    4,
                                    _this._flushLock
                                ];
                            case 3:
                                _state.sent();
                                return [
                                    3,
                                    6
                                ];
                            case 4:
                                err = _state.sent();
                                DEBUG_BUILD && (0, _utils.logger).error(err);
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                _this._debouncedFlush();
                                return [
                                    7
                                ];
                            case 6:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }
        },
        {
            /** Save the session, if it is sticky */ key: "_maybeSaveSession",
            value: function _maybeSaveSession() {
                if (this.session && this._options.stickySession) saveSession(this.session);
            }
        },
        {
            /** Handler for rrweb.record.onMutation */ key: "__init6",
            value: function __init6() {
                var _this = this;
                this._onMutationHandler = function(mutations) {
                    var count = mutations.length;
                    var mutationLimit = _this._options.mutationLimit;
                    var mutationBreadcrumbLimit = _this._options.mutationBreadcrumbLimit;
                    var overMutationLimit = mutationLimit && count > mutationLimit;
                    // Create a breadcrumb if a lot of mutations happen at the same time
                    // We can show this in the UI as an information with potential performance improvements
                    if (count > mutationBreadcrumbLimit || overMutationLimit) {
                        var breadcrumb = createBreadcrumb({
                            category: 'replay.mutations',
                            data: {
                                count: count,
                                limit: overMutationLimit
                            }
                        });
                        _this._createCustomBreadcrumb(breadcrumb);
                    }
                    // Stop replay if over the mutation limit
                    if (overMutationLimit) {
                        // This should never reject
                        // eslint-disable-next-line @typescript-eslint/no-floating-promises
                        _this.stop({
                            reason: 'mutationLimit',
                            forceFlush: _this.recordingMode === 'session'
                        });
                        return false;
                    }
                    // `true` means we use the regular mutation handling by rrweb
                    return true;
                };
            }
        }
    ]);
    return ReplayContainer;
}();
function getOption(selectors, defaultSelectors, deprecatedClassOption, deprecatedSelectorOption) {
    var deprecatedSelectors = typeof deprecatedSelectorOption === 'string' ? deprecatedSelectorOption.split(',') : [];
    var allSelectors = (0, _toConsumableArray._)(selectors).concat(// @deprecated
    (0, _toConsumableArray._)(deprecatedSelectors), // sentry defaults
    (0, _toConsumableArray._)(defaultSelectors));
    // @deprecated
    if (typeof deprecatedClassOption !== 'undefined') {
        // NOTE: No support for RegExp
        if (typeof deprecatedClassOption === 'string') allSelectors.push(`.${deprecatedClassOption}`);
        (0, _utils.consoleSandbox)(function() {
            // eslint-disable-next-line no-console
            console.warn('[Replay] You are using a deprecated configuration item for privacy. Read the documentation on how to use the new privacy configuration.');
        });
    }
    return allSelectors.join(',');
}
/**
 * Returns privacy related configuration for use in rrweb
 */ function getPrivacyOptions(param) {
    var mask = param.mask, unmask = param.unmask, block = param.block, unblock = param.unblock, ignore = param.ignore, // eslint-disable-next-line deprecation/deprecation
    blockClass = param.blockClass, // eslint-disable-next-line deprecation/deprecation
    blockSelector = param.blockSelector, // eslint-disable-next-line deprecation/deprecation
    maskTextClass = param.maskTextClass, // eslint-disable-next-line deprecation/deprecation
    maskTextSelector = param.maskTextSelector, // eslint-disable-next-line deprecation/deprecation
    ignoreClass = param.ignoreClass;
    var defaultBlockedElements = [
        'base[href="/"]'
    ];
    var maskSelector = getOption(mask, [
        '.sentry-mask',
        '[data-sentry-mask]'
    ], maskTextClass, maskTextSelector);
    var unmaskSelector = getOption(unmask, [
        '.sentry-unmask',
        '[data-sentry-unmask]'
    ]);
    var options = {
        // We are making the decision to make text and input selectors the same
        maskTextSelector: maskSelector,
        unmaskTextSelector: unmaskSelector,
        blockSelector: getOption(block, [
            '.sentry-block',
            '[data-sentry-block]'
        ].concat((0, _toConsumableArray._)(defaultBlockedElements)), blockClass, blockSelector),
        unblockSelector: getOption(unblock, [
            '.sentry-unblock',
            '[data-sentry-unblock]'
        ]),
        ignoreSelector: getOption(ignore, [
            '.sentry-ignore',
            '[data-sentry-ignore]',
            'input[type="file"]'
        ], ignoreClass)
    };
    if (blockClass instanceof RegExp) options.blockClass = blockClass;
    if (maskTextClass instanceof RegExp) options.maskTextClass = maskTextClass;
    return options;
}
/**
 * Masks an attribute if necessary, otherwise return attribute value as-is.
 */ function maskAttribute(param) {
    var el = param.el, key = param.key, maskAttributes = param.maskAttributes, maskAllText = param.maskAllText, privacyOptions = param.privacyOptions, value = param.value;
    // We only mask attributes if `maskAllText` is true
    if (!maskAllText) return value;
    // unmaskTextSelector takes precendence
    if (privacyOptions.unmaskTextSelector && el.matches(privacyOptions.unmaskTextSelector)) return value;
    if (maskAttributes.includes(key) || // Need to mask `value` attribute for `<input>` if it's a button-like
    // type
    key === 'value' && el.tagName === 'INPUT' && [
        'submit',
        'button'
    ].includes(el.getAttribute('type') || '')) return value.replace(/[\S]/g, '*');
    return value;
}
var MEDIA_SELECTORS = 'img,image,svg,video,object,picture,embed,map,audio,link[rel="icon"],link[rel="apple-touch-icon"]';
var DEFAULT_NETWORK_HEADERS = [
    'content-length',
    'content-type',
    'accept'
];
var _initialized = false;
var replayIntegration$1 = function(options) {
    // eslint-disable-next-line deprecation/deprecation
    return new Replay$1(options);
};
/**
 * The main replay integration class, to be passed to `init({  integrations: [] })`.
 * @deprecated Use `replayIntegration()` instead.
 */ var Replay$1 = /*#__PURE__*/ function() {
    "use strict";
    function Replay$1() {
        var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_flushMinDelay = _ref.flushMinDelay, flushMinDelay = _ref_flushMinDelay === void 0 ? DEFAULT_FLUSH_MIN_DELAY : _ref_flushMinDelay, _ref_flushMaxDelay = _ref.flushMaxDelay, flushMaxDelay = _ref_flushMaxDelay === void 0 ? DEFAULT_FLUSH_MAX_DELAY : _ref_flushMaxDelay, _ref_minReplayDuration = _ref.minReplayDuration, minReplayDuration = _ref_minReplayDuration === void 0 ? MIN_REPLAY_DURATION : _ref_minReplayDuration, _ref_maxReplayDuration = _ref.maxReplayDuration, maxReplayDuration = _ref_maxReplayDuration === void 0 ? MAX_REPLAY_DURATION : _ref_maxReplayDuration, _ref_stickySession = _ref.stickySession, stickySession = _ref_stickySession === void 0 ? true : _ref_stickySession, _ref_useCompression = _ref.useCompression, useCompression = _ref_useCompression === void 0 ? true : _ref_useCompression, workerUrl = _ref.workerUrl, _ref__experiments = _ref._experiments, _experiments = _ref__experiments === void 0 ? {} : _ref__experiments, sessionSampleRate = _ref.sessionSampleRate, errorSampleRate = _ref.errorSampleRate, _ref_maskAllText = _ref.maskAllText, maskAllText = _ref_maskAllText === void 0 ? true : _ref_maskAllText, _ref_maskAllInputs = _ref.maskAllInputs, maskAllInputs = _ref_maskAllInputs === void 0 ? true : _ref_maskAllInputs, _ref_blockAllMedia = _ref.blockAllMedia, blockAllMedia = _ref_blockAllMedia === void 0 ? true : _ref_blockAllMedia, _ref_mutationBreadcrumbLimit = _ref.mutationBreadcrumbLimit, mutationBreadcrumbLimit = _ref_mutationBreadcrumbLimit === void 0 ? 750 : _ref_mutationBreadcrumbLimit, _ref_mutationLimit = _ref.mutationLimit, mutationLimit = _ref_mutationLimit === void 0 ? 10000 : _ref_mutationLimit, _ref_slowClickTimeout = _ref.slowClickTimeout, slowClickTimeout = _ref_slowClickTimeout === void 0 ? 7000 : _ref_slowClickTimeout, _ref_slowClickIgnoreSelectors = _ref.slowClickIgnoreSelectors, slowClickIgnoreSelectors = _ref_slowClickIgnoreSelectors === void 0 ? [] : _ref_slowClickIgnoreSelectors, _ref_networkDetailAllowUrls = _ref.networkDetailAllowUrls, networkDetailAllowUrls = _ref_networkDetailAllowUrls === void 0 ? [] : _ref_networkDetailAllowUrls, _ref_networkDetailDenyUrls = _ref.networkDetailDenyUrls, networkDetailDenyUrls = _ref_networkDetailDenyUrls === void 0 ? [] : _ref_networkDetailDenyUrls, _ref_networkCaptureBodies = _ref.networkCaptureBodies, networkCaptureBodies = _ref_networkCaptureBodies === void 0 ? true : _ref_networkCaptureBodies, _ref_networkRequestHeaders = _ref.networkRequestHeaders, networkRequestHeaders = _ref_networkRequestHeaders === void 0 ? [] : _ref_networkRequestHeaders, _ref_networkResponseHeaders = _ref.networkResponseHeaders, networkResponseHeaders = _ref_networkResponseHeaders === void 0 ? [] : _ref_networkResponseHeaders, _ref_mask = _ref.mask, mask = _ref_mask === void 0 ? [] : _ref_mask, _ref_maskAttributes = _ref.maskAttributes, maskAttributes = _ref_maskAttributes === void 0 ? [
            'title',
            'placeholder'
        ] : _ref_maskAttributes, _ref_unmask = _ref.unmask, unmask = _ref_unmask === void 0 ? [] : _ref_unmask, _ref_block = _ref.block, block = _ref_block === void 0 ? [] : _ref_block, _ref_unblock = _ref.unblock, unblock = _ref_unblock === void 0 ? [] : _ref_unblock, _ref_ignore = _ref.ignore, ignore = _ref_ignore === void 0 ? [] : _ref_ignore, maskFn = _ref.maskFn, beforeAddRecordingEvent = _ref.beforeAddRecordingEvent, beforeErrorSampling = _ref.beforeErrorSampling, // eslint-disable-next-line deprecation/deprecation
        blockClass = _ref.blockClass, // eslint-disable-next-line deprecation/deprecation
        blockSelector = _ref.blockSelector, // eslint-disable-next-line deprecation/deprecation
        maskInputOptions = _ref.maskInputOptions, // eslint-disable-next-line deprecation/deprecation
        maskTextClass = _ref.maskTextClass, // eslint-disable-next-line deprecation/deprecation
        maskTextSelector = _ref.maskTextSelector, // eslint-disable-next-line deprecation/deprecation
        ignoreClass = _ref.ignoreClass;
        (0, _classCallCheck._)(this, Replay$1);
        // eslint-disable-next-line deprecation/deprecation
        this.name = Replay$1.id;
        var privacyOptions = getPrivacyOptions({
            mask: mask,
            unmask: unmask,
            block: block,
            unblock: unblock,
            ignore: ignore,
            blockClass: blockClass,
            blockSelector: blockSelector,
            maskTextClass: maskTextClass,
            maskTextSelector: maskTextSelector,
            ignoreClass: ignoreClass
        });
        this._recordingOptions = (0, _objectSpreadProps._)((0, _objectSpread._)({
            maskAllInputs: maskAllInputs,
            maskAllText: maskAllText,
            maskInputOptions: (0, _objectSpreadProps._)((0, _objectSpread._)({}, maskInputOptions || {}), {
                password: true
            }),
            maskTextFn: maskFn,
            maskInputFn: maskFn,
            maskAttributeFn: function(key, value, el) {
                return maskAttribute({
                    maskAttributes: maskAttributes,
                    maskAllText: maskAllText,
                    privacyOptions: privacyOptions,
                    key: key,
                    value: value,
                    el: el
                });
            }
        }, privacyOptions), {
            // Our defaults
            slimDOMOptions: 'all',
            inlineStylesheet: true,
            // Disable inline images as it will increase segment/replay size
            inlineImages: false,
            // collect fonts, but be aware that `sentry.io` needs to be an allowed
            // origin for playback
            collectFonts: true,
            errorHandler: function(err) {
                try {
                    err.__rrweb__ = true;
                } catch (error) {
                // ignore errors here
                // this can happen if the error is frozen or does not allow mutation for other reasons
                }
            }
        });
        this._initialOptions = {
            flushMinDelay: flushMinDelay,
            flushMaxDelay: flushMaxDelay,
            minReplayDuration: Math.min(minReplayDuration, MIN_REPLAY_DURATION_LIMIT),
            maxReplayDuration: Math.min(maxReplayDuration, MAX_REPLAY_DURATION),
            stickySession: stickySession,
            sessionSampleRate: sessionSampleRate,
            errorSampleRate: errorSampleRate,
            useCompression: useCompression,
            workerUrl: workerUrl,
            blockAllMedia: blockAllMedia,
            maskAllInputs: maskAllInputs,
            maskAllText: maskAllText,
            mutationBreadcrumbLimit: mutationBreadcrumbLimit,
            mutationLimit: mutationLimit,
            slowClickTimeout: slowClickTimeout,
            slowClickIgnoreSelectors: slowClickIgnoreSelectors,
            networkDetailAllowUrls: networkDetailAllowUrls,
            networkDetailDenyUrls: networkDetailDenyUrls,
            networkCaptureBodies: networkCaptureBodies,
            networkRequestHeaders: _getMergedNetworkHeaders(networkRequestHeaders),
            networkResponseHeaders: _getMergedNetworkHeaders(networkResponseHeaders),
            beforeAddRecordingEvent: beforeAddRecordingEvent,
            beforeErrorSampling: beforeErrorSampling,
            _experiments: _experiments
        };
        if (typeof sessionSampleRate === 'number') {
            // eslint-disable-next-line
            console.warn(`[Replay] You are passing \`sessionSampleRate\` to the Replay integration.
This option is deprecated and will be removed soon.
Instead, configure \`replaysSessionSampleRate\` directly in the SDK init options, e.g.:
Sentry.init({ replaysSessionSampleRate: ${sessionSampleRate} })`);
            this._initialOptions.sessionSampleRate = sessionSampleRate;
        }
        if (typeof errorSampleRate === 'number') {
            // eslint-disable-next-line
            console.warn(`[Replay] You are passing \`errorSampleRate\` to the Replay integration.
This option is deprecated and will be removed soon.
Instead, configure \`replaysOnErrorSampleRate\` directly in the SDK init options, e.g.:
Sentry.init({ replaysOnErrorSampleRate: ${errorSampleRate} })`);
            this._initialOptions.errorSampleRate = errorSampleRate;
        }
        if (this._initialOptions.blockAllMedia) // `blockAllMedia` is a more user friendly option to configure blocking
        // embedded media elements
        this._recordingOptions.blockSelector = !this._recordingOptions.blockSelector ? MEDIA_SELECTORS : `${this._recordingOptions.blockSelector},${MEDIA_SELECTORS}`;
        if (this._isInitialized && (0, _utils.isBrowser)()) throw new Error('Multiple Sentry Session Replay instances are not supported');
        this._isInitialized = true;
    }
    (0, _createClass._)(Replay$1, [
        {
            key: "_isInitialized",
            get: /** If replay has already been initialized */ function get() {
                return _initialized;
            },
            set: /** Update _isInitialized */ function set(value) {
                _initialized = value;
            }
        },
        {
            /**
   * Setup and initialize replay container
   */ key: "setupOnce",
            value: function setupOnce() {
                var _this = this;
                if (!(0, _utils.isBrowser)()) return;
                this._setup();
                // Once upon a time, we tried to create a transaction in `setupOnce` and it would
                // potentially create a transaction before some native SDK integrations have run
                // and applied their own global event processor. An example is:
                // https://github.com/getsentry/sentry-javascript/blob/b47ceafbdac7f8b99093ce6023726ad4687edc48/packages/browser/src/integrations/useragent.ts
                //
                // So we call `this._initialize()` in next event loop as a workaround to wait for other
                // global event processors to finish. This is no longer needed, but keeping it
                // here to avoid any future issues.
                setTimeout(function() {
                    return _this._initialize();
                });
            }
        },
        {
            /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will throw an error if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * PerformanceObserver, Recording, Sentry SDK, etc)
   */ key: "start",
            value: function start() {
                if (!this._replay) return;
                this._replay.start();
            }
        },
        {
            /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, until an error occurs.
   */ key: "startBuffering",
            value: function startBuffering() {
                if (!this._replay) return;
                this._replay.startBuffering();
            }
        },
        {
            /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */ key: "stop",
            value: function stop() {
                if (!this._replay) return Promise.resolve();
                return this._replay.stop({
                    forceFlush: this._replay.recordingMode === 'session'
                });
            }
        },
        {
            /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */ key: "flush",
            value: function flush(options) {
                if (!this._replay || !this._replay.isEnabled()) return Promise.resolve();
                return this._replay.sendBufferedReplayOrFlush(options);
            }
        },
        {
            /**
   * Get the current session ID.
   */ key: "getReplayId",
            value: function getReplayId() {
                if (!this._replay || !this._replay.isEnabled()) return;
                return this._replay.getSessionId();
            }
        },
        {
            /**
   * Initializes replay.
   */ key: "_initialize",
            value: function _initialize() {
                if (!this._replay) return;
                // We have to run this in _initialize, because this runs in setTimeout
                // So when this runs all integrations have been added
                // Before this, we cannot access integrations on the client,
                // so we need to mutate the options here
                this._maybeLoadFromReplayCanvasIntegration();
                this._replay.initializeSampling();
            }
        },
        {
            /** Setup the integration. */ key: "_setup",
            value: function _setup() {
                // Client is not available in constructor, so we need to wait until setupOnce
                var finalOptions = loadReplayOptionsFromClient(this._initialOptions);
                this._replay = new ReplayContainer({
                    options: finalOptions,
                    recordingOptions: this._recordingOptions
                });
            }
        },
        {
            /** Get canvas options from ReplayCanvas integration, if it is also added. */ key: "_maybeLoadFromReplayCanvasIntegration",
            value: function _maybeLoadFromReplayCanvasIntegration() {
                // To save bundle size, we skip checking for stuff here
                // and instead just try-catch everything - as generally this should all be defined
                /* eslint-disable @typescript-eslint/no-non-null-assertion */ try {
                    var client = (0, _core.getClient)();
                    var canvasIntegration = client.getIntegrationByName('ReplayCanvas');
                    if (!canvasIntegration) return;
                    this._replay['_canvas'] = canvasIntegration.getOptions();
                } catch (e) {
                // ignore errors here
                }
            /* eslint-enable @typescript-eslint/no-non-null-assertion */ }
        }
    ], [
        {
            key: "__initStatic",
            value: /**
   * @inheritDoc
   */ function __initStatic() {
                this.id = 'Replay';
            }
        }
    ]);
    return Replay$1;
}();
Replay$1.__initStatic();
/** Parse Replay-related options from SDK options */ function loadReplayOptionsFromClient(initialOptions) {
    var client = (0, _core.getClient)();
    var opt = client && client.getOptions();
    var finalOptions = (0, _objectSpread._)({
        sessionSampleRate: 0,
        errorSampleRate: 0
    }, (0, _utils.dropUndefinedKeys)(initialOptions));
    if (!opt) {
        (0, _utils.consoleSandbox)(function() {
            // eslint-disable-next-line no-console
            console.warn('SDK client is not available.');
        });
        return finalOptions;
    }
    if (initialOptions.sessionSampleRate == null && // TODO remove once deprecated rates are removed
    initialOptions.errorSampleRate == null && // TODO remove once deprecated rates are removed
    opt.replaysSessionSampleRate == null && opt.replaysOnErrorSampleRate == null) (0, _utils.consoleSandbox)(function() {
        // eslint-disable-next-line no-console
        console.warn('Replay is disabled because neither `replaysSessionSampleRate` nor `replaysOnErrorSampleRate` are set.');
    });
    if (typeof opt.replaysSessionSampleRate === 'number') finalOptions.sessionSampleRate = opt.replaysSessionSampleRate;
    if (typeof opt.replaysOnErrorSampleRate === 'number') finalOptions.errorSampleRate = opt.replaysOnErrorSampleRate;
    return finalOptions;
}
function _getMergedNetworkHeaders(headers) {
    return (0, _toConsumableArray._)(DEFAULT_NETWORK_HEADERS).concat((0, _toConsumableArray._)(headers.map(function(header) {
        return header.toLowerCase();
    })));
}
/**
 * This is a small utility to get a type-safe instance of the Replay integration.
 */ // eslint-disable-next-line deprecation/deprecation
function getReplay$1() {
    var client = (0, _core.getClient)();
    return client && client.getIntegrationByName && client.getIntegrationByName('Replay');
}
// eslint-disable-next-line deprecation/deprecation
/** @deprecated Use the export from `@sentry/replay` or from framework-specific SDKs like `@sentry/react` or `@sentry/vue` */ var getReplay = getReplay$1;
/** @deprecated Use the export from `@sentry/replay` or from framework-specific SDKs like `@sentry/react` or `@sentry/vue` */ var replayIntegration = replayIntegration$1;
/** @deprecated Use the export from `@sentry/replay` or from framework-specific SDKs like `@sentry/react` or `@sentry/vue` */ // eslint-disable-next-line deprecation/deprecation
var Replay = /*#__PURE__*/ function(Replay$1) {
    "use strict";
    (0, _inherits._)(Replay, Replay$1);
    function Replay() {
        (0, _classCallCheck._)(this, Replay);
        return (0, _callSuper._)(this, Replay, arguments);
    }
    return Replay;
}(Replay$1);

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_call_super":"5oPMc","@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","@swc/helpers/_/_inherits":"j8HRi","@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_object_spread_props":"fLCYP","@swc/helpers/_/_sliced_to_array":"ha6sq","@swc/helpers/_/_to_consumable_array":"eqNDD","@swc/helpers/_/_wrap_native_super":"gNmVc","@swc/helpers/_/_ts_generator":"f2hGH","@sentry/utils":"gElXU","@sentry/core":"8bBGI","@sentry-internal/tracing":"imA5v","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"brIPY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReplayCanvas", function() {
    return ReplayCanvas;
});
parcelHelpers.export(exports, "replayCanvasIntegration", function() {
    return replayCanvasIntegration;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _utils = require("@sentry/utils");
var _core = require("@sentry/core");
var NodeType;
(function(NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})(NodeType || (NodeType = {}));
function elementClassMatchesRegex(el, regex) {
    for(var eIndex = el.classList.length; eIndex--;){
        var className = el.classList[eIndex];
        if (regex.test(className)) return true;
    }
    return false;
}
function distanceToMatch(node, matchPredicate) {
    var limit = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Infinity, distance = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
    if (!node) return -1;
    if (node.nodeType !== node.ELEMENT_NODE) return -1;
    if (distance > limit) return -1;
    if (matchPredicate(node)) return distance;
    return distanceToMatch(node.parentNode, matchPredicate, limit, distance + 1);
}
function createMatchPredicate(className, selector) {
    return function(node) {
        var el = node;
        if (el === null) return false;
        try {
            if (className) {
                if (typeof className === 'string') {
                    if (el.matches(`.${className}`)) return true;
                } else if (elementClassMatchesRegex(el, className)) return true;
            }
            if (selector && el.matches(selector)) return true;
            return false;
        } catch (e2) {
            return false;
        }
    };
}
var DEPARTED_MIRROR_ACCESS_WARNING = "Please stop import mirror directly. Instead of that,\r\nnow you can use replayer.getMirror() to access the mirror instance of a replayer,\r\nor you can use record.mirror to access the mirror instance during recording.";
var _mirror = {
    map: {},
    getId: function() {
        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
        return -1;
    },
    getNode: function() {
        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
        return null;
    },
    removeNodeFromMap: function() {
        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
    },
    has: function() {
        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
        return false;
    },
    reset: function() {
        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
    }
};
if (typeof window !== 'undefined' && window.Proxy && window.Reflect) _mirror = new Proxy(_mirror, {
    get: function(target, prop, receiver) {
        if (prop === 'map') console.error(DEPARTED_MIRROR_ACCESS_WARNING);
        return Reflect.get(target, prop, receiver);
    }
});
function hookSetter(target, key, d, isRevoked) {
    var win = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : window;
    var original = win.Object.getOwnPropertyDescriptor(target, key);
    win.Object.defineProperty(target, key, isRevoked ? d : {
        set: function(value) {
            var _this = this;
            setTimeout(function() {
                d.set.call(_this, value);
            }, 0);
            if (original && original.set) original.set.call(this, value);
        }
    });
    return function() {
        return hookSetter(target, key, original || {}, true);
    };
}
function patch(source, name, replacement) {
    try {
        if (!(name in source)) return function() {};
        var original = source[name];
        var wrapped = replacement(original);
        if (typeof wrapped === 'function') {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __rrweb_original__: {
                    enumerable: false,
                    value: original
                }
            });
        }
        source[name] = wrapped;
        return function() {
            source[name] = original;
        };
    } catch (e2) {
        return function() {};
    }
}
/[1-9][0-9]{12}/.test(Date.now().toString());
function closestElementOfNode(node) {
    if (!node) return null;
    var el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
    return el;
}
function isBlocked(node, blockClass, blockSelector, unblockSelector, checkAncestors) {
    if (!node) return false;
    var el = closestElementOfNode(node);
    if (!el) return false;
    var blockedPredicate = createMatchPredicate(blockClass, blockSelector);
    if (!checkAncestors) {
        var isUnblocked = unblockSelector && el.matches(unblockSelector);
        return blockedPredicate(el) && !isUnblocked;
    }
    var blockDistance = distanceToMatch(el, blockedPredicate);
    var unblockDistance = -1;
    if (blockDistance < 0) return false;
    if (unblockSelector) unblockDistance = distanceToMatch(el, createMatchPredicate(null, unblockSelector));
    if (blockDistance > -1 && unblockDistance < 0) return true;
    return blockDistance < unblockDistance;
}
var cachedImplementations = {};
function getImplementation(name) {
    var cached = cachedImplementations[name];
    if (cached) return cached;
    var document = window.document;
    var impl = window[name];
    if (document && typeof document.createElement === 'function') try {
        var sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        var contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow[name]) impl = contentWindow[name];
        document.head.removeChild(sandbox);
    } catch (e) {}
    return cachedImplementations[name] = impl.bind(window);
}
function onRequestAnimationFrame() {
    for(var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++){
        rest[_key] = arguments[_key];
    }
    return getImplementation('requestAnimationFrame').apply(this, (0, _toConsumableArray._)(rest));
}
function setTimeout() {
    for(var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++){
        rest[_key] = arguments[_key];
    }
    return getImplementation('setTimeout').apply(this, (0, _toConsumableArray._)(rest));
}
var CanvasContext = /* @__PURE__ */ function(CanvasContext2) {
    CanvasContext2[CanvasContext2["2D"] = 0] = "2D";
    CanvasContext2[CanvasContext2["WebGL"] = 1] = "WebGL";
    CanvasContext2[CanvasContext2["WebGL2"] = 2] = "WebGL2";
    return CanvasContext2;
}(CanvasContext || {});
var errorHandler;
function registerErrorHandler(handler) {
    errorHandler = handler;
}
var callbackWrapper = function(cb) {
    if (!errorHandler) return cb;
    var rrwebWrapped = function() {
        for(var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++){
            rest[_key] = arguments[_key];
        }
        try {
            return cb.apply(void 0, (0, _toConsumableArray._)(rest));
        } catch (error) {
            if (errorHandler && errorHandler(error) === true) return function() {};
            throw error;
        }
    };
    return rrwebWrapped;
};
/*
 * base64-arraybuffer 1.0.1 <https://github.com/niklasvh/base64-arraybuffer>
 * Copyright (c) 2021 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */ var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
// Use a lookup table to find the index.
var lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
for(var i = 0; i < chars.length; i++)lookup[chars.charCodeAt(i)] = i;
var encode = function encode(arraybuffer) {
    var bytes = new Uint8Array(arraybuffer), i, len = bytes.length, base64 = '';
    for(i = 0; i < len; i += 3){
        base64 += chars[bytes[i] >> 2];
        base64 += chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64 += chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64 += chars[bytes[i + 2] & 63];
    }
    if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + '=';
    else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + '==';
    return base64;
};
var canvasVarMap = new Map();
function variableListFor(ctx, ctor) {
    var contextMap = canvasVarMap.get(ctx);
    if (!contextMap) {
        contextMap = new Map();
        canvasVarMap.set(ctx, contextMap);
    }
    if (!contextMap.has(ctor)) contextMap.set(ctor, []);
    return contextMap.get(ctor);
}
var saveWebGLVar = function(value, win, ctx) {
    if (!value || !(isInstanceOfWebGLObject(value, win) || typeof value === 'object')) return;
    var name = value.constructor.name;
    var list = variableListFor(ctx, name);
    var index = list.indexOf(value);
    if (index === -1) {
        index = list.length;
        list.push(value);
    }
    return index;
};
function serializeArg(value, win, ctx) {
    if (value instanceof Array) return value.map(function(arg) {
        return serializeArg(arg, win, ctx);
    });
    else if (value === null) return value;
    else if (value instanceof Float32Array || value instanceof Float64Array || value instanceof Int32Array || value instanceof Uint32Array || value instanceof Uint8Array || value instanceof Uint16Array || value instanceof Int16Array || value instanceof Int8Array || value instanceof Uint8ClampedArray) {
        var name = value.constructor.name;
        return {
            rr_type: name,
            args: [
                Object.values(value)
            ]
        };
    } else if (value instanceof ArrayBuffer) {
        var name1 = value.constructor.name;
        var base64 = encode(value);
        return {
            rr_type: name1,
            base64: base64
        };
    } else if (value instanceof DataView) {
        var name2 = value.constructor.name;
        return {
            rr_type: name2,
            args: [
                serializeArg(value.buffer, win, ctx),
                value.byteOffset,
                value.byteLength
            ]
        };
    } else if (value instanceof HTMLImageElement) {
        var name3 = value.constructor.name;
        var src = value.src;
        return {
            rr_type: name3,
            src: src
        };
    } else if (value instanceof HTMLCanvasElement) {
        var name4 = 'HTMLImageElement';
        var src1 = value.toDataURL();
        return {
            rr_type: name4,
            src: src1
        };
    } else if (value instanceof ImageData) {
        var name5 = value.constructor.name;
        return {
            rr_type: name5,
            args: [
                serializeArg(value.data, win, ctx),
                value.width,
                value.height
            ]
        };
    } else if (isInstanceOfWebGLObject(value, win) || typeof value === 'object') {
        var name6 = value.constructor.name;
        var index = saveWebGLVar(value, win, ctx);
        return {
            rr_type: name6,
            index: index
        };
    }
    return value;
}
var serializeArgs = function(args, win, ctx) {
    return args.map(function(arg) {
        return serializeArg(arg, win, ctx);
    });
};
var isInstanceOfWebGLObject = function(value, win) {
    var webGLConstructorNames = [
        'WebGLActiveInfo',
        'WebGLBuffer',
        'WebGLFramebuffer',
        'WebGLProgram',
        'WebGLRenderbuffer',
        'WebGLShader',
        'WebGLShaderPrecisionFormat',
        'WebGLTexture',
        'WebGLUniformLocation',
        'WebGLVertexArrayObject',
        'WebGLVertexArrayObjectOES'
    ];
    var supportedWebGLConstructorNames = webGLConstructorNames.filter(function(name) {
        return typeof win[name] === 'function';
    });
    return Boolean(supportedWebGLConstructorNames.find(function(name) {
        return value instanceof win[name];
    }));
};
function initCanvas2DMutationObserver(cb, win, blockClass, blockSelector, unblockSelector) {
    var handlers = [];
    var props2D = Object.getOwnPropertyNames(win.CanvasRenderingContext2D.prototype);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var prop = _step.value;
            try {
                if (typeof win.CanvasRenderingContext2D.prototype[prop] !== 'function') return "continue";
                var restoreHandler = patch(win.CanvasRenderingContext2D.prototype, prop, function(original) {
                    return function() {
                        var _this = this;
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                            args[_key] = arguments[_key];
                        }
                        if (!isBlocked(this.canvas, blockClass, blockSelector, unblockSelector, true)) setTimeout(function() {
                            var recordArgs = serializeArgs(args, win, _this);
                            cb(_this.canvas, {
                                type: CanvasContext['2D'],
                                property: prop,
                                args: recordArgs
                            });
                        }, 0);
                        return original.apply(this, args);
                    };
                });
                handlers.push(restoreHandler);
            } catch (e) {
                var hookHandler = hookSetter(win.CanvasRenderingContext2D.prototype, prop, {
                    set: function(v) {
                        cb(this.canvas, {
                            type: CanvasContext['2D'],
                            property: prop,
                            args: [
                                v
                            ],
                            setter: true
                        });
                    }
                });
                handlers.push(hookHandler);
            }
        };
        for(var _iterator = props2D[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return function() {
        handlers.forEach(function(h) {
            return h();
        });
    };
}
function getNormalizedContextName(contextType) {
    return contextType === 'experimental-webgl' ? 'webgl' : contextType;
}
function initCanvasContextObserver(win, blockClass, blockSelector, unblockSelector, setPreserveDrawingBufferToTrue) {
    var handlers = [];
    try {
        var restoreHandler = patch(win.HTMLCanvasElement.prototype, 'getContext', function(original) {
            return function(contextType) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                if (!isBlocked(this, blockClass, blockSelector, unblockSelector, true)) {
                    var ctxName = getNormalizedContextName(contextType);
                    if (!('__context' in this)) this.__context = ctxName;
                    if (setPreserveDrawingBufferToTrue && [
                        'webgl',
                        'webgl2'
                    ].includes(ctxName)) {
                        if (args[0] && typeof args[0] === 'object') {
                            var contextAttributes = args[0];
                            if (!contextAttributes.preserveDrawingBuffer) contextAttributes.preserveDrawingBuffer = true;
                        } else args.splice(0, 1, {
                            preserveDrawingBuffer: true
                        });
                    }
                }
                return original.apply(this, [
                    contextType
                ].concat((0, _toConsumableArray._)(args)));
            };
        });
        handlers.push(restoreHandler);
    } catch (e) {
        console.error('failed to patch HTMLCanvasElement.prototype.getContext');
    }
    return function() {
        handlers.forEach(function(h) {
            return h();
        });
    };
}
function patchGLPrototype(prototype, type, cb, blockClass, blockSelector, unblockSelector, mirror, win) {
    var handlers = [];
    var props = Object.getOwnPropertyNames(prototype);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var prop = _step.value;
            if ([
                'isContextLost',
                'canvas',
                'drawingBufferWidth',
                'drawingBufferHeight'
            ].includes(prop)) return "continue";
            try {
                if (typeof prototype[prop] !== 'function') return "continue";
                var restoreHandler = patch(prototype, prop, function(original) {
                    return function() {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                            args[_key] = arguments[_key];
                        }
                        var result = original.apply(this, args);
                        saveWebGLVar(result, win, this);
                        if ('tagName' in this.canvas && !isBlocked(this.canvas, blockClass, blockSelector, unblockSelector, true)) {
                            var recordArgs = serializeArgs(args, win, this);
                            var mutation = {
                                type: type,
                                property: prop,
                                args: recordArgs
                            };
                            cb(this.canvas, mutation);
                        }
                        return result;
                    };
                });
                handlers.push(restoreHandler);
            } catch (e) {
                var hookHandler = hookSetter(prototype, prop, {
                    set: function(v) {
                        cb(this.canvas, {
                            type: type,
                            property: prop,
                            args: [
                                v
                            ],
                            setter: true
                        });
                    }
                });
                handlers.push(hookHandler);
            }
        };
        for(var _iterator = props[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return handlers;
}
function initCanvasWebGLMutationObserver(cb, win, blockClass, blockSelector, unblockSelector, mirror) {
    var _handlers, _handlers1;
    var handlers = [];
    (_handlers = handlers).push.apply(_handlers, (0, _toConsumableArray._)(patchGLPrototype(win.WebGLRenderingContext.prototype, CanvasContext.WebGL, cb, blockClass, blockSelector, unblockSelector, mirror, win)));
    if (typeof win.WebGL2RenderingContext !== 'undefined') (_handlers1 = handlers).push.apply(_handlers1, (0, _toConsumableArray._)(patchGLPrototype(win.WebGL2RenderingContext.prototype, CanvasContext.WebGL2, cb, blockClass, blockSelector, unblockSelector, mirror, win)));
    return function() {
        handlers.forEach(function(h) {
            return h();
        });
    };
}
var r = `for(var e="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",t="undefined"==typeof Uint8Array?[]:new Uint8Array(256),a=0;a<64;a++)t[e.charCodeAt(a)]=a;var n=function(t){var a,n=new Uint8Array(t),r=n.length,s="";for(a=0;a<r;a+=3)s+=e[n[a]>>2],s+=e[(3&n[a])<<4|n[a+1]>>4],s+=e[(15&n[a+1])<<2|n[a+2]>>6],s+=e[63&n[a+2]];return r%3==2?s=s.substring(0,s.length-1)+"=":r%3==1&&(s=s.substring(0,s.length-2)+"=="),s};const r=new Map,s=new Map;const i=self;i.onmessage=async function(e){if(!("OffscreenCanvas"in globalThis))return i.postMessage({id:e.data.id});{const{id:t,bitmap:a,width:o,height:f,maxCanvasSize:c,dataURLOptions:g}=e.data,u=async function(e,t,a){const r=e+"-"+t;if("OffscreenCanvas"in globalThis){if(s.has(r))return s.get(r);const i=new OffscreenCanvas(e,t);i.getContext("2d");const o=await i.convertToBlob(a),f=await o.arrayBuffer(),c=n(f);return s.set(r,c),c}return""}(o,f,g),[h,d]=function(e,t,a){if(!a)return[e,t];const[n,r]=a;if(e<=n&&t<=r)return[e,t];let s=e,i=t;return s>n&&(i=Math.floor(n*t/e),s=n),i>r&&(s=Math.floor(r*e/t),i=r),[s,i]}(o,f,c),l=new OffscreenCanvas(h,d),w=l.getContext("bitmaprenderer"),p=h===o&&d===f?a:await createImageBitmap(a,{resizeWidth:h,resizeHeight:d,resizeQuality:"low"});w.transferFromImageBitmap(p),a.close();const y=await l.convertToBlob(g),v=y.type,b=await y.arrayBuffer(),m=n(b);if(p.close(),!r.has(t)&&await u===m)return r.set(t,m),i.postMessage({id:t});if(r.get(t)===m)return i.postMessage({id:t});i.postMessage({id:t,type:v,base64:m,width:o,height:f}),r.set(t,m)}};`;
function t() {
    var t = new Blob([
        r
    ]);
    return URL.createObjectURL(t);
}
var CanvasManager = /*#__PURE__*/ function() {
    "use strict";
    function CanvasManager(options) {
        var _this = this;
        (0, _classCallCheck._)(this, CanvasManager);
        this.pendingCanvasMutations = new Map();
        this.rafStamps = {
            latestId: 0,
            invokeId: null
        };
        this.frozen = false;
        this.locked = false;
        this.processMutation = function(target, mutation) {
            var newFrame = _this.rafStamps.invokeId && _this.rafStamps.latestId !== _this.rafStamps.invokeId;
            if (newFrame || !_this.rafStamps.invokeId) _this.rafStamps.invokeId = _this.rafStamps.latestId;
            if (!_this.pendingCanvasMutations.has(target)) _this.pendingCanvasMutations.set(target, []);
            _this.pendingCanvasMutations.get(target).push(mutation);
        };
        var _options_sampling = options.sampling, sampling = _options_sampling === void 0 ? 'all' : _options_sampling, win = options.win, blockClass = options.blockClass, blockSelector = options.blockSelector, unblockSelector = options.unblockSelector, maxCanvasSize = options.maxCanvasSize, recordCanvas = options.recordCanvas, dataURLOptions = options.dataURLOptions, errorHandler = options.errorHandler;
        this.mutationCb = options.mutationCb;
        this.mirror = options.mirror;
        this.options = options;
        if (errorHandler) registerErrorHandler(errorHandler);
        if (options.enableManualSnapshot) return;
        callbackWrapper(function() {
            if (recordCanvas && sampling === 'all') _this.initCanvasMutationObserver(win, blockClass, blockSelector, unblockSelector);
            if (recordCanvas && typeof sampling === 'number') _this.initCanvasFPSObserver(sampling, win, blockClass, blockSelector, unblockSelector, maxCanvasSize, {
                dataURLOptions: dataURLOptions
            });
        })();
    }
    (0, _createClass._)(CanvasManager, [
        {
            key: "reset",
            value: function reset() {
                this.pendingCanvasMutations.clear();
                this.resetObservers && this.resetObservers();
            }
        },
        {
            key: "freeze",
            value: function freeze() {
                this.frozen = true;
            }
        },
        {
            key: "unfreeze",
            value: function unfreeze() {
                this.frozen = false;
            }
        },
        {
            key: "lock",
            value: function lock() {
                this.locked = true;
            }
        },
        {
            key: "unlock",
            value: function unlock() {
                this.locked = false;
            }
        },
        {
            key: "initCanvasFPSObserver",
            value: function initCanvasFPSObserver(fps, win, blockClass, blockSelector, unblockSelector, maxCanvasSize, options) {
                var canvasContextReset = initCanvasContextObserver(win, blockClass, blockSelector, unblockSelector, true);
                var rafId = this.takeSnapshot(false, fps, win, blockClass, blockSelector, unblockSelector, maxCanvasSize, options.dataURLOptions);
                this.resetObservers = function() {
                    canvasContextReset();
                    cancelAnimationFrame(rafId);
                };
            }
        },
        {
            key: "initCanvasMutationObserver",
            value: function initCanvasMutationObserver(win, blockClass, blockSelector, unblockSelector) {
                this.startRAFTimestamping();
                this.startPendingCanvasMutationFlusher();
                var canvasContextReset = initCanvasContextObserver(win, blockClass, blockSelector, unblockSelector, false);
                var canvas2DReset = initCanvas2DMutationObserver(this.processMutation.bind(this), win, blockClass, blockSelector, unblockSelector);
                var canvasWebGL1and2Reset = initCanvasWebGLMutationObserver(this.processMutation.bind(this), win, blockClass, blockSelector, unblockSelector, this.mirror);
                this.resetObservers = function() {
                    canvasContextReset();
                    canvas2DReset();
                    canvasWebGL1and2Reset();
                };
            }
        },
        {
            key: "snapshot",
            value: function snapshot(canvasElement) {
                var options = this.options;
                var rafId = this.takeSnapshot(true, options.sampling === 'all' ? 2 : options.sampling || 2, options.win, options.blockClass, options.blockSelector, options.unblockSelector, options.maxCanvasSize, options.dataURLOptions, canvasElement);
                this.resetObservers = function() {
                    cancelAnimationFrame(rafId);
                };
            }
        },
        {
            key: "takeSnapshot",
            value: function takeSnapshot(isManualSnapshot, fps, win, blockClass, blockSelector, unblockSelector, maxCanvasSize, dataURLOptions, canvasElement) {
                var _this = this;
                var snapshotInProgressMap = new Map();
                var worker = new Worker(t());
                worker.onmessage = function(e) {
                    var data = e.data;
                    var id = data.id;
                    snapshotInProgressMap.set(id, false);
                    if (!('base64' in data)) return;
                    var base64 = data.base64, type = data.type, width = data.width, height = data.height;
                    _this.mutationCb({
                        id: id,
                        type: CanvasContext['2D'],
                        commands: [
                            {
                                property: 'clearRect',
                                args: [
                                    0,
                                    0,
                                    width,
                                    height
                                ]
                            },
                            {
                                property: 'drawImage',
                                args: [
                                    {
                                        rr_type: 'ImageBitmap',
                                        args: [
                                            {
                                                rr_type: 'Blob',
                                                data: [
                                                    {
                                                        rr_type: 'ArrayBuffer',
                                                        base64: base64
                                                    }
                                                ],
                                                type: type
                                            }
                                        ]
                                    },
                                    0,
                                    0,
                                    width,
                                    height
                                ]
                            }
                        ]
                    });
                };
                var timeBetweenSnapshots = 1000 / fps;
                var lastSnapshotTime = 0;
                var rafId;
                var getCanvas = function(canvasElement) {
                    if (canvasElement) return [
                        canvasElement
                    ];
                    var matchedCanvas = [];
                    win.document.querySelectorAll('canvas').forEach(function(canvas) {
                        if (!isBlocked(canvas, blockClass, blockSelector, unblockSelector, true)) matchedCanvas.push(canvas);
                    });
                    return matchedCanvas;
                };
                var takeCanvasSnapshots = function(timestamp) {
                    if (lastSnapshotTime && timestamp - lastSnapshotTime < timeBetweenSnapshots) {
                        rafId = onRequestAnimationFrame(takeCanvasSnapshots);
                        return;
                    }
                    lastSnapshotTime = timestamp;
                    getCanvas(canvasElement).forEach(function(canvas) {
                        var id = _this.mirror.getId(canvas);
                        if (snapshotInProgressMap.get(id)) return;
                        if (!canvas.width || !canvas.height) return;
                        snapshotInProgressMap.set(id, true);
                        if (!isManualSnapshot && [
                            'webgl',
                            'webgl2'
                        ].includes(canvas.__context)) {
                            var context = canvas.getContext(canvas.__context);
                            if ((0, _utils._optionalChain)([
                                context,
                                'optionalAccess',
                                function(_) {
                                    return _.getContextAttributes;
                                },
                                'call',
                                function(_2) {
                                    return _2();
                                },
                                'optionalAccess',
                                function(_3) {
                                    return _3.preserveDrawingBuffer;
                                }
                            ]) === false) context.clear(context.COLOR_BUFFER_BIT);
                        }
                        createImageBitmap(canvas).then(function(bitmap) {
                            worker.postMessage({
                                id: id,
                                bitmap: bitmap,
                                width: canvas.width,
                                height: canvas.height,
                                dataURLOptions: dataURLOptions,
                                maxCanvasSize: maxCanvasSize
                            }, [
                                bitmap
                            ]);
                        }).catch(function(error) {
                            callbackWrapper(function() {
                                throw error;
                            })();
                        });
                    });
                    rafId = onRequestAnimationFrame(takeCanvasSnapshots);
                };
                rafId = onRequestAnimationFrame(takeCanvasSnapshots);
                return rafId;
            }
        },
        {
            key: "startPendingCanvasMutationFlusher",
            value: function startPendingCanvasMutationFlusher() {
                var _this = this;
                onRequestAnimationFrame(function() {
                    return _this.flushPendingCanvasMutations();
                });
            }
        },
        {
            key: "startRAFTimestamping",
            value: function startRAFTimestamping() {
                var _this = this;
                var setLatestRAFTimestamp = function(timestamp) {
                    _this.rafStamps.latestId = timestamp;
                    onRequestAnimationFrame(setLatestRAFTimestamp);
                };
                onRequestAnimationFrame(setLatestRAFTimestamp);
            }
        },
        {
            key: "flushPendingCanvasMutations",
            value: function flushPendingCanvasMutations() {
                var _this = this;
                this.pendingCanvasMutations.forEach(function(values, canvas) {
                    var id = _this.mirror.getId(canvas);
                    _this.flushPendingCanvasMutationFor(canvas, id);
                });
                onRequestAnimationFrame(function() {
                    return _this.flushPendingCanvasMutations();
                });
            }
        },
        {
            key: "flushPendingCanvasMutationFor",
            value: function flushPendingCanvasMutationFor(canvas, id) {
                if (this.frozen || this.locked) return;
                var valuesWithType = this.pendingCanvasMutations.get(canvas);
                if (!valuesWithType || id === -1) return;
                var values = valuesWithType.map(function(value) {
                    var type = value.type, rest = (0, _objectWithoutProperties._)(value, [
                        "type"
                    ]);
                    return rest;
                });
                var type = valuesWithType[0].type;
                this.mutationCb({
                    id: id,
                    type: type,
                    commands: values
                });
                this.pendingCanvasMutations.delete(canvas);
            }
        }
    ]);
    return CanvasManager;
}();
var CANVAS_QUALITY = {
    low: {
        sampling: {
            canvas: 1
        },
        dataURLOptions: {
            type: 'image/webp',
            quality: 0.25
        }
    },
    medium: {
        sampling: {
            canvas: 2
        },
        dataURLOptions: {
            type: 'image/webp',
            quality: 0.4
        }
    },
    high: {
        sampling: {
            canvas: 4
        },
        dataURLOptions: {
            type: 'image/webp',
            quality: 0.5
        }
    }
};
var INTEGRATION_NAME = 'ReplayCanvas';
var DEFAULT_MAX_CANVAS_SIZE = 1280;
/** Exported only for type safe tests. */ var _replayCanvasIntegration = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _ref = (0, _slicedToArray._)(options.maxCanvasSize || [], 2), maxCanvasWidth = _ref[0], maxCanvasHeight = _ref[1];
    var _canvasOptions = {
        quality: options.quality || 'medium',
        enableManualSnapshot: options.enableManualSnapshot,
        maxCanvasSize: [
            maxCanvasWidth ? Math.min(maxCanvasWidth, DEFAULT_MAX_CANVAS_SIZE) : DEFAULT_MAX_CANVAS_SIZE,
            maxCanvasHeight ? Math.min(maxCanvasHeight, DEFAULT_MAX_CANVAS_SIZE) : DEFAULT_MAX_CANVAS_SIZE
        ]
    };
    var canvasManagerResolve;
    var _canvasManager = new Promise(function(resolve) {
        return canvasManagerResolve = resolve;
    });
    return {
        name: INTEGRATION_NAME,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        setupOnce: function() {},
        getOptions: function() {
            var quality = _canvasOptions.quality, enableManualSnapshot = _canvasOptions.enableManualSnapshot, maxCanvasSize = _canvasOptions.maxCanvasSize;
            return (0, _objectSpread._)({
                enableManualSnapshot: enableManualSnapshot,
                recordCanvas: true,
                getCanvasManager: function(getCanvasManagerOptions) {
                    var manager = new CanvasManager((0, _objectSpreadProps._)((0, _objectSpread._)({}, getCanvasManagerOptions), {
                        enableManualSnapshot: enableManualSnapshot,
                        maxCanvasSize: maxCanvasSize,
                        errorHandler: function(err) {
                            try {
                                if (typeof err === 'object') err.__rrweb__ = true;
                            } catch (error) {
                            // ignore errors here
                            // this can happen if the error is frozen or does not allow mutation for other reasons
                            }
                        }
                    }));
                    canvasManagerResolve(manager);
                    return manager;
                }
            }, CANVAS_QUALITY[quality || 'medium'] || CANVAS_QUALITY.medium);
        },
        snapshot: function(canvasElement) {
            return (0, _asyncToGenerator._)(function() {
                var canvasManager;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                _canvasManager
                            ];
                        case 1:
                            canvasManager = _state.sent();
                            canvasManager.snapshot(canvasElement);
                            return [
                                2
                            ];
                    }
                });
            })();
        }
    };
};
/**
 * Add this in addition to `replayIntegration()` to enable canvas recording.
 */ var replayCanvasIntegration = (0, _core.defineIntegration)(_replayCanvasIntegration);
/**
 * @deprecated Use `replayCanvasIntegration()` instead
 */ // eslint-disable-next-line deprecation/deprecation
var ReplayCanvas = (0, _core.convertIntegrationFnToClass)(INTEGRATION_NAME, replayCanvasIntegration);

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_object_spread_props":"fLCYP","@swc/helpers/_/_object_without_properties":"1waVD","@swc/helpers/_/_sliced_to_array":"ha6sq","@swc/helpers/_/_to_consumable_array":"eqNDD","@swc/helpers/_/_ts_generator":"f2hGH","@sentry/utils":"gElXU","@sentry/core":"8bBGI","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"hlyIz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Feedback", function() {
    return Feedback;
});
parcelHelpers.export(exports, "feedbackIntegration", function() {
    return feedbackIntegration;
});
parcelHelpers.export(exports, "sendFeedback", function() {
    return sendFeedback;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _utils = require("@sentry/utils");
var _core = require("@sentry/core");
// exporting a separate copy of `WINDOW` rather than exporting the one from `@sentry/browser`
// prevents the browser package from being bundled in the CDN bundle, and avoids a
// circular dependency between the browser and feedback packages
var WINDOW = (0, _utils.GLOBAL_OBJ);
var LIGHT_BACKGROUND = '#ffffff';
var INHERIT = 'inherit';
var SUBMIT_COLOR = 'rgba(108, 95, 199, 1)';
var LIGHT_THEME = {
    fontFamily: "system-ui, 'Helvetica Neue', Arial, sans-serif",
    fontSize: '14px',
    background: LIGHT_BACKGROUND,
    backgroundHover: '#f6f6f7',
    foreground: '#2b2233',
    border: '1.5px solid rgba(41, 35, 47, 0.13)',
    borderRadius: '25px',
    boxShadow: '0px 4px 24px 0px rgba(43, 34, 51, 0.12)',
    success: '#268d75',
    error: '#df3338',
    submitBackground: 'rgba(88, 74, 192, 1)',
    submitBackgroundHover: SUBMIT_COLOR,
    submitBorder: SUBMIT_COLOR,
    submitOutlineFocus: '#29232f',
    submitForeground: LIGHT_BACKGROUND,
    submitForegroundHover: LIGHT_BACKGROUND,
    cancelBackground: 'transparent',
    cancelBackgroundHover: 'var(--background-hover)',
    cancelBorder: 'var(--border)',
    cancelOutlineFocus: 'var(--input-outline-focus)',
    cancelForeground: 'var(--foreground)',
    cancelForegroundHover: 'var(--foreground)',
    inputBackground: INHERIT,
    inputForeground: INHERIT,
    inputBorder: 'var(--border)',
    inputOutlineFocus: SUBMIT_COLOR,
    formBorderRadius: '20px',
    formContentBorderRadius: '6px'
};
var DEFAULT_THEME = {
    light: LIGHT_THEME,
    dark: (0, _objectSpreadProps._)((0, _objectSpread._)({}, LIGHT_THEME), {
        background: '#29232f',
        backgroundHover: '#352f3b',
        foreground: '#ebe6ef',
        border: '1.5px solid rgba(235, 230, 239, 0.15)',
        success: '#2da98c',
        error: '#f55459'
    })
};
var ACTOR_LABEL = 'Report a Bug';
var CANCEL_BUTTON_LABEL = 'Cancel';
var SUBMIT_BUTTON_LABEL = 'Send Bug Report';
var FORM_TITLE = 'Report a Bug';
var EMAIL_PLACEHOLDER = 'your.email@example.org';
var EMAIL_LABEL = 'Email';
var MESSAGE_PLACEHOLDER = "What's the bug? What did you expect?";
var MESSAGE_LABEL = 'Description';
var NAME_PLACEHOLDER = 'Your Name';
var NAME_LABEL = 'Name';
var IS_REQUIRED_LABEL = '(required)';
var SUCCESS_MESSAGE_TEXT = 'Thank you for your report!';
var FEEDBACK_WIDGET_SOURCE = 'widget';
var FEEDBACK_API_SOURCE = 'api';
function prepareFeedbackEvent(_) {
    return _prepareFeedbackEvent.apply(this, arguments);
}
function _prepareFeedbackEvent() {
    _prepareFeedbackEvent = /**
 * Prepare a feedback event & enrich it with the SDK metadata.
 */ (0, _asyncToGenerator._)(function(param) {
        var client, scope, event, eventHint, preparedEvent;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    client = param.client, scope = param.scope, event = param.event;
                    eventHint = {};
                    if (client.emit) client.emit('preprocessEvent', event, eventHint);
                    return [
                        4,
                        (0, _core.prepareEvent)(client.getOptions(), event, eventHint, scope, client, (0, _core.getIsolationScope)())
                    ];
                case 1:
                    preparedEvent = _state.sent();
                    if (preparedEvent === null) {
                        // Taken from baseclient's `_processEvent` method, where this is handled for errors/transactions
                        client.recordDroppedEvent('event_processor', 'feedback', event);
                        return [
                            2,
                            null
                        ];
                    }
                    // This normally happens in browser client "_prepareEvent"
                    // but since we do not use this private method from the client, but rather the plain import
                    // we need to do this manually.
                    preparedEvent.platform = preparedEvent.platform || 'javascript';
                    return [
                        2,
                        preparedEvent
                    ];
            }
        });
    });
    return _prepareFeedbackEvent.apply(this, arguments);
}
function sendFeedbackRequest(_) {
    return _sendFeedbackRequest.apply(this, arguments);
}
function _sendFeedbackRequest() {
    _sendFeedbackRequest = /**
 * Send feedback using transport
 */ (0, _asyncToGenerator._)(function(param) {
        var _param_feedback, message, email, name, source, url, _ref, _ref_includeReplay, includeReplay, client, transport, dsn, baseEvent;
        var _arguments = arguments;
        return (0, _tsGenerator._)(this, function(_state) {
            _param_feedback = param.feedback, message = _param_feedback.message, email = _param_feedback.email, name = _param_feedback.name, source = _param_feedback.source, url = _param_feedback.url, _ref = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {}, _ref_includeReplay = _ref.includeReplay, includeReplay = _ref_includeReplay === void 0 ? true : _ref_includeReplay;
            client = (0, _core.getClient)();
            transport = client && client.getTransport();
            dsn = client && client.getDsn();
            if (!client || !transport || !dsn) return [
                2
            ];
            baseEvent = {
                contexts: {
                    feedback: {
                        contact_email: email,
                        name: name,
                        message: message,
                        url: url,
                        source: source
                    }
                },
                type: 'feedback'
            };
            return [
                2,
                (0, _core.withScope)(/*#__PURE__*/ function() {
                    var _ref = (0, _asyncToGenerator._)(function(scope) {
                        var feedbackEvent, envelope, response, err, error;
                        return (0, _tsGenerator._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    // No use for breadcrumbs in feedback
                                    scope.clearBreadcrumbs();
                                    if ([
                                        FEEDBACK_API_SOURCE,
                                        FEEDBACK_WIDGET_SOURCE
                                    ].includes(String(source))) scope.setLevel('info');
                                    return [
                                        4,
                                        prepareFeedbackEvent({
                                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                            scope: scope,
                                            client: client,
                                            event: baseEvent
                                        })
                                    ];
                                case 1:
                                    feedbackEvent = _state.sent();
                                    if (!feedbackEvent) return [
                                        2
                                    ];
                                    if (client.emit) client.emit('beforeSendFeedback', feedbackEvent, {
                                        includeReplay: Boolean(includeReplay)
                                    });
                                    envelope = (0, _core.createEventEnvelope)(feedbackEvent, dsn, client.getOptions()._metadata, client.getOptions().tunnel);
                                    _state.label = 2;
                                case 2:
                                    _state.trys.push([
                                        2,
                                        4,
                                        ,
                                        5
                                    ]);
                                    return [
                                        4,
                                        transport.send(envelope)
                                    ];
                                case 3:
                                    response = _state.sent();
                                    return [
                                        3,
                                        5
                                    ];
                                case 4:
                                    err = _state.sent();
                                    error = new Error('Unable to send Feedback');
                                    try {
                                        // In case browsers don't allow this property to be writable
                                        // @ts-expect-error This needs lib es2022 and newer
                                        error.cause = err;
                                    } catch (e) {
                                    // nothing to do
                                    }
                                    throw error;
                                case 5:
                                    // TODO (v8): we can remove this guard once transport.send's type signature doesn't include void anymore
                                    if (!response) return [
                                        2
                                    ];
                                    // Require valid status codes, otherwise can assume feedback was not sent successfully
                                    if (typeof response.statusCode === 'number' && (response.statusCode < 200 || response.statusCode >= 300)) throw new Error('Unable to send Feedback');
                                    return [
                                        2,
                                        response
                                    ];
                            }
                        });
                    });
                    return function(scope) {
                        return _ref.apply(this, arguments);
                    };
                }())
            ];
        });
    });
    return _sendFeedbackRequest.apply(this, arguments);
}
/*
 * For reference, the fully built event looks something like this:
 * {
 *     "type": "feedback",
 *     "event_id": "d2132d31b39445f1938d7e21b6bf0ec4",
 *     "timestamp": 1597977777.6189718,
 *     "dist": "1.12",
 *     "platform": "javascript",
 *     "environment": "production",
 *     "release": 42,
 *     "tags": {"transaction": "/organizations/:orgId/performance/:eventSlug/"},
 *     "sdk": {"name": "name", "version": "version"},
 *     "user": {
 *         "id": "123",
 *         "username": "user",
 *         "email": "user@site.com",
 *         "ip_address": "192.168.11.12",
 *     },
 *     "request": {
 *         "url": None,
 *         "headers": {
 *             "user-Agent": "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/15.5 Safari/605.1.15"
 *         },
 *     },
 *     "contexts": {
 *         "feedback": {
 *             "message": "test message",
 *             "contact_email": "test@example.com",
 *             "type": "feedback",
 *         },
 *         "trace": {
 *             "trace_id": "4C79F60C11214EB38604F4AE0781BFB2",
 *             "span_id": "FA90FDEAD5F74052",
 *             "type": "trace",
 *         },
 *         "replay": {
 *             "replay_id": "e2d42047b1c5431c8cba85ee2a8ab25d",
 *         },
 *     },
 *   }
 */ /**
 * Public API to send a Feedback item to Sentry
 */ function sendFeedback(param) {
    var name = param.name, email = param.email, message = param.message, _param_source = param.source, source = _param_source === void 0 ? FEEDBACK_API_SOURCE : _param_source, _param_url = param.url, url = _param_url === void 0 ? (0, _utils.getLocationHref)() : _param_url, options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!message) throw new Error('Unable to submit feedback with empty message');
    return sendFeedbackRequest({
        feedback: {
            name: name,
            email: email,
            message: message,
            url: url,
            source: source
        }
    }, options);
}
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ var DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;
/**
 * Quick and dirty deep merge for the Feedback integration options
 */ function mergeOptions(defaultOptions, optionOverrides) {
    return (0, _objectSpreadProps._)((0, _objectSpread._)({}, defaultOptions, optionOverrides), {
        themeDark: (0, _objectSpread._)({}, defaultOptions.themeDark, optionOverrides.themeDark),
        themeLight: (0, _objectSpread._)({}, defaultOptions.themeLight, optionOverrides.themeLight)
    });
}
/**
 * Creates <style> element for widget actor (button that opens the dialog)
 */ function createActorStyles(d) {
    var style = d.createElement('style');
    style.textContent = `
.widget__actor {
  position: fixed;
  left: var(--left);
  right: var(--right);
  bottom: var(--bottom);
  top: var(--top);
  z-index: var(--z-index);

  line-height: 16px;

  display: flex;
  align-items: center;
  gap: 8px;

  border-radius: var(--border-radius);
  cursor: pointer;
  font-family: inherit;
  font-size: var(--font-size);
  font-weight: 600;
  padding: 16px;
  text-decoration: none;
  z-index: 9000;

  color: var(--foreground);
  background-color: var(--background);
  border: var(--border);
  box-shadow: var(--box-shadow);
  opacity: 1;
  transition: opacity 0.1s ease-in-out;
}

.widget__actor:hover {
  background-color: var(--background-hover);
}

.widget__actor svg {
  width: 16px;
  height: 16px;
}

.widget__actor--hidden {
  opacity: 0;
  pointer-events: none;
  visibility: hidden;
}

.widget__actor__text {
}

@media (max-width: 600px) {
  .widget__actor__text {
    display: none;
  }
}

.feedback-icon path {
  fill: var(--foreground);
}
`;
    return style;
}
/**
 * Creates <style> element for widget dialog
 */ function createDialogStyles(d) {
    var style = d.createElement('style');
    style.textContent = `
.dialog {
  line-height: 25px;
  background-color: rgba(0, 0, 0, 0.05);
  border: none;
  position: fixed;
  inset: 0;
  z-index: 10000;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 1;
  transition: opacity 0.2s ease-in-out;
}

.dialog:not([open]) {
  opacity: 0;
  pointer-events: none;
  visibility: hidden;
}
.dialog:not([open]) .dialog__content {
  transform: translate(0, -16px) scale(0.98);
}

.dialog__content {
  position: fixed;
  left: var(--left);
  right: var(--right);
  bottom: var(--bottom);
  top: var(--top);

  border: var(--border);
  border-radius: var(--form-border-radius);
  background-color: var(--background);
  color: var(--foreground);

  width: 320px;
  max-width: 100%;
  max-height: calc(100% - 2rem);
  display: flex;
  flex-direction: column;
  box-shadow: var(--box-shadow);
  transition: transform 0.2s ease-in-out;
  transform: translate(0, 0) scale(1);
}

.dialog__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 20px;
  font-weight: 600;
  padding: 24px 24px 0 24px;
  margin: 0;
  margin-bottom: 16px;
}

.brand-link {
  display: inline-flex;
}

.error {
  color: var(--error);
  margin-bottom: 16px;
}

.form {
  display: grid;
  overflow: auto;
  flex-direction: column;
  gap: 16px;
  padding: 0 24px 24px;
}

.form__error-container {
  color: var(--error);
}

.form__error-container--hidden {
  display: none;
}

.form__label {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: 0px;
}

.form__label__text {
  display: grid;
  gap: 4px;
  align-items: center;
  grid-auto-flow: column;
  grid-auto-columns: max-content;
}

.form__label__text--required {
  font-size: 0.85em;
}

.form__input {
  line-height: inherit;
  background-color: var(--input-background);
  box-sizing: border-box;
  border: var(--input-border);
  border-radius: var(--form-content-border-radius);
  color: var(--input-foreground);
  font-family: inherit;
  font-size: var(--font-size);
  font-weight: 500;
  padding: 6px 12px;
}

.form__input::placeholder {
  color: var(--input-foreground);
  opacity: 0.65;
}

.form__input:focus-visible {
  outline: 1px auto var(--input-outline-focus);
}

.form__input--textarea {
  font-family: inherit;
  resize: vertical;
}

.btn-group {
  display: grid;
  gap: 8px;
  margin-top: 8px;
}

.btn {
  line-height: inherit;
  border: var(--cancel-border);
  border-radius: var(--form-content-border-radius);
  cursor: pointer;
  font-family: inherit;
  font-size: var(--font-size);
  font-weight: 600;
  padding: 6px 16px;
}
.btn[disabled] {
  opacity: 0.6;
  pointer-events: none;
}

.btn--primary {
  background-color: var(--submit-background);
  border-color: var(--submit-border);
  color: var(--submit-foreground);
}
.btn--primary:hover {
  background-color: var(--submit-background-hover);
  color: var(--submit-foreground-hover);
}
.btn--primary:focus-visible {
  outline: 1px auto var(--submit-outline-focus);
}

.btn--default {
  background-color: var(--cancel-background);
  color: var(--cancel-foreground);
  font-weight: 500;
}
.btn--default:hover {
  background-color: var(--cancel-background-hover);
  color: var(--cancel-foreground-hover);
}
.btn--default:focus-visible {
  outline: 1px auto var(--cancel-outline-focus);
}

.success-message {
  background-color: var(--background);
  border: var(--border);
  border-radius: var(--border-radius);
  box-shadow: var(--box-shadow);
  font-weight: 600;
  color: var(--success);
  padding: 12px 24px;
  line-height: 25px;
  display: grid;
  align-items: center;
  grid-auto-flow: column;
  gap: 6px;
  cursor: default;
}

.success-icon path {
  fill: var(--success);
}
`;
    return style;
}
function getThemedCssVariables(theme) {
    return `
  --background: ${theme.background};
  --background-hover: ${theme.backgroundHover};
  --foreground: ${theme.foreground};
  --error: ${theme.error};
  --success: ${theme.success};
  --border: ${theme.border};
  --border-radius: ${theme.borderRadius};
  --box-shadow: ${theme.boxShadow};

  --submit-background: ${theme.submitBackground};
  --submit-background-hover: ${theme.submitBackgroundHover};
  --submit-border: ${theme.submitBorder};
  --submit-outline-focus: ${theme.submitOutlineFocus};
  --submit-foreground: ${theme.submitForeground};
  --submit-foreground-hover: ${theme.submitForegroundHover};

  --cancel-background: ${theme.cancelBackground};
  --cancel-background-hover: ${theme.cancelBackgroundHover};
  --cancel-border: ${theme.cancelBorder};
  --cancel-outline-focus: ${theme.cancelOutlineFocus};
  --cancel-foreground: ${theme.cancelForeground};
  --cancel-foreground-hover: ${theme.cancelForegroundHover};

  --input-background: ${theme.inputBackground};
  --input-foreground: ${theme.inputForeground};
  --input-border: ${theme.inputBorder};
  --input-outline-focus: ${theme.inputOutlineFocus};

  --form-border-radius: ${theme.formBorderRadius};
  --form-content-border-radius: ${theme.formContentBorderRadius};
  `;
}
/**
 * Creates <style> element for widget actor (button that opens the dialog)
 */ function createMainStyles(d, colorScheme, themes) {
    var style = d.createElement('style');
    style.textContent = `
:host {
  --bottom: 1rem;
  --right: 1rem;
  --top: auto;
  --left: auto;
  --z-index: 100000;
  --font-family: ${themes.light.fontFamily};
  --font-size: ${themes.light.fontSize};

  position: fixed;
  left: var(--left);
  right: var(--right);
  bottom: var(--bottom);
  top: var(--top);
  z-index: var(--z-index);

  font-family: var(--font-family);
  font-size: var(--font-size);

  ${getThemedCssVariables(colorScheme === 'dark' ? themes.dark : themes.light)}
}

${colorScheme === 'system' ? `
@media (prefers-color-scheme: dark) {
  :host {
    ${getThemedCssVariables(themes.dark)}
  }
}` : ''}
}`;
    return style;
}
/**
 * Creates shadow host
 */ function createShadowHost(param) {
    var id = param.id, colorScheme = param.colorScheme, themeDark = param.themeDark, themeLight = param.themeLight;
    try {
        var doc = WINDOW.document;
        // Create the host
        var host = doc.createElement('div');
        host.id = id;
        // Create the shadow root
        var shadow = host.attachShadow({
            mode: 'open'
        });
        shadow.appendChild(createMainStyles(doc, colorScheme, {
            dark: themeDark,
            light: themeLight
        }));
        shadow.appendChild(createDialogStyles(doc));
        return {
            shadow: shadow,
            host: host
        };
    } catch (e) {
        // Shadow DOM probably not supported
        (0, _utils.logger).warn('[Feedback] Browser does not support shadow DOM API');
        throw new Error('Browser does not support shadow DOM API.');
    }
}
function handleFeedbackSubmit(dialog, feedback, options) {
    return _handleFeedbackSubmit.apply(this, arguments);
}
function _handleFeedbackSubmit() {
    _handleFeedbackSubmit = /**
 * Handles UI behavior of dialog when feedback is submitted, calls
 * `sendFeedback` to send feedback.
 */ (0, _asyncToGenerator._)(function(dialog, feedback, options) {
        var showFetchError, resp, err;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!dialog) // Not sure when this would happen
                    return [
                        2
                    ];
                    showFetchError = function() {
                        if (!dialog) return;
                        dialog.showError('There was a problem submitting feedback, please wait and try again.');
                    };
                    dialog.hideError();
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        sendFeedback((0, _objectSpreadProps._)((0, _objectSpread._)({}, feedback), {
                            source: FEEDBACK_WIDGET_SOURCE
                        }), options)
                    ];
                case 2:
                    resp = _state.sent();
                    // Success!
                    return [
                        2,
                        resp
                    ];
                case 3:
                    err = _state.sent();
                    DEBUG_BUILD && (0, _utils.logger).error(err);
                    showFetchError();
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _handleFeedbackSubmit.apply(this, arguments);
}
/**
 * Helper function to set a dict of attributes on element (w/ specified namespace)
 */ function setAttributesNS(el, attributes) {
    Object.entries(attributes).forEach(function(param) {
        var _param = (0, _slicedToArray._)(param, 2), key = _param[0], val = _param[1];
        el.setAttributeNS(null, key, val);
    });
    return el;
}
var SIZE = 20;
var XMLNS$2 = 'http://www.w3.org/2000/svg';
/**
 * Feedback Icon
 */ function Icon() {
    var createElementNS = function(tagName) {
        return WINDOW.document.createElementNS(XMLNS$2, tagName);
    };
    var svg = setAttributesNS(createElementNS('svg'), {
        class: 'feedback-icon',
        width: `${SIZE}`,
        height: `${SIZE}`,
        viewBox: `0 0 ${SIZE} ${SIZE}`,
        fill: 'none'
    });
    var g = setAttributesNS(createElementNS('g'), {
        clipPath: 'url(#clip0_57_80)'
    });
    var _obj;
    var path = setAttributesNS(createElementNS('path'), (_obj = {}, (0, _defineProperty._)(_obj, 'fill-rule', 'evenodd'), (0, _defineProperty._)(_obj, 'clip-rule', 'evenodd'), (0, _defineProperty._)(_obj, "d", 'M15.6622 15H12.3997C12.2129 14.9959 12.031 14.9396 11.8747 14.8375L8.04965 12.2H7.49956V19.1C7.4875 19.3348 7.3888 19.5568 7.22256 19.723C7.05632 19.8892 6.83435 19.9879 6.59956 20H2.04956C1.80193 19.9968 1.56535 19.8969 1.39023 19.7218C1.21511 19.5467 1.1153 19.3101 1.11206 19.0625V12.2H0.949652C0.824431 12.2017 0.700142 12.1783 0.584123 12.1311C0.468104 12.084 0.362708 12.014 0.274155 11.9255C0.185602 11.8369 0.115689 11.7315 0.0685419 11.6155C0.0213952 11.4995 -0.00202913 11.3752 -0.00034808 11.25V3.75C-0.00900498 3.62067 0.0092504 3.49095 0.0532651 3.36904C0.0972798 3.24712 0.166097 3.13566 0.255372 3.04168C0.344646 2.94771 0.452437 2.87327 0.571937 2.82307C0.691437 2.77286 0.82005 2.74798 0.949652 2.75H8.04965L11.8747 0.1625C12.031 0.0603649 12.2129 0.00407221 12.3997 0H15.6622C15.9098 0.00323746 16.1464 0.103049 16.3215 0.278167C16.4966 0.453286 16.5964 0.689866 16.5997 0.9375V3.25269C17.3969 3.42959 18.1345 3.83026 18.7211 4.41679C19.5322 5.22788 19.9878 6.32796 19.9878 7.47502C19.9878 8.62209 19.5322 9.72217 18.7211 10.5333C18.1345 11.1198 17.3969 11.5205 16.5997 11.6974V14.0125C16.6047 14.1393 16.5842 14.2659 16.5395 14.3847C16.4948 14.5035 16.4268 14.6121 16.3394 14.7042C16.252 14.7962 16.147 14.8698 16.0307 14.9206C15.9144 14.9714 15.7891 14.9984 15.6622 15ZM1.89695 10.325H1.88715V4.625H8.33715C8.52423 4.62301 8.70666 4.56654 8.86215 4.4625L12.6872 1.875H14.7247V13.125H12.6872L8.86215 10.4875C8.70666 10.3835 8.52423 10.327 8.33715 10.325H2.20217C2.15205 10.3167 2.10102 10.3125 2.04956 10.3125C1.9981 10.3125 1.94708 10.3167 1.89695 10.325ZM2.98706 12.2V18.1625H5.66206V12.2H2.98706ZM16.5997 9.93612V5.01393C16.6536 5.02355 16.7072 5.03495 16.7605 5.04814C17.1202 5.13709 17.4556 5.30487 17.7425 5.53934C18.0293 5.77381 18.2605 6.06912 18.4192 6.40389C18.578 6.73866 18.6603 7.10452 18.6603 7.47502C18.6603 7.84552 18.578 8.21139 18.4192 8.54616C18.2605 8.88093 18.0293 9.17624 17.7425 9.41071C17.4556 9.64518 17.1202 9.81296 16.7605 9.90191C16.7072 9.91509 16.6536 9.9265 16.5997 9.93612Z'), _obj));
    svg.appendChild(g).appendChild(path);
    var speakerDefs = createElementNS('defs');
    var speakerClipPathDef = setAttributesNS(createElementNS('clipPath'), {
        id: 'clip0_57_80'
    });
    var speakerRect = setAttributesNS(createElementNS('rect'), {
        width: `${SIZE}`,
        height: `${SIZE}`,
        fill: 'white'
    });
    speakerClipPathDef.appendChild(speakerRect);
    speakerDefs.appendChild(speakerClipPathDef);
    svg.appendChild(speakerDefs).appendChild(speakerClipPathDef).appendChild(speakerRect);
    return {
        get el () {
            return svg;
        }
    };
}
/**
 * Helper function to create an element. Could be used as a JSX factory
 * (i.e. React-like syntax).
 */ function createElement(tagName, attributes) {
    for(var _len = arguments.length, children = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        children[_key - 2] = arguments[_key];
    }
    var doc = WINDOW.document;
    var element = doc.createElement(tagName);
    if (attributes) Object.entries(attributes).forEach(function(param) {
        var _param = (0, _slicedToArray._)(param, 2), attribute = _param[0], attributeValue = _param[1];
        if (attribute === 'className' && typeof attributeValue === 'string') // JSX does not allow class as a valid name
        element.setAttribute('class', attributeValue);
        else if (typeof attributeValue === 'boolean' && attributeValue) element.setAttribute(attribute, '');
        else if (typeof attributeValue === 'string') element.setAttribute(attribute, attributeValue);
        else if (attribute.startsWith('on') && typeof attributeValue === 'function') element.addEventListener(attribute.substring(2).toLowerCase(), attributeValue);
    });
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var child = _step.value;
            appendChild(element, child);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return element;
}
function appendChild(parent, child) {
    var doc = WINDOW.document;
    if (typeof child === 'undefined' || child === null) return;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (Array.isArray(child)) try {
        for(var _iterator = child[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var value = _step.value;
            appendChild(parent, value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    else if (child === false) ;
    else if (typeof child === 'string') parent.appendChild(doc.createTextNode(child));
    else if (child instanceof Node) parent.appendChild(child);
    else parent.appendChild(doc.createTextNode(String(child)));
}
/**
 *
 */ function Actor(param) {
    var buttonLabel = param.buttonLabel, onClick = param.onClick;
    function _handleClick(e) {
        onClick && onClick(e);
    }
    var _obj;
    var el = createElement('button', (_obj = {
        type: 'button',
        className: 'widget__actor'
    }, (0, _defineProperty._)(_obj, 'aria-label', buttonLabel), (0, _defineProperty._)(_obj, 'aria-hidden', 'false'), _obj), Icon().el, buttonLabel ? createElement('span', {
        className: 'widget__actor__text'
    }, buttonLabel) : null);
    el.addEventListener('click', _handleClick);
    return {
        get el () {
            return el;
        },
        show: function() {
            el.classList.remove('widget__actor--hidden');
            el.setAttribute('aria-hidden', 'false');
        },
        hide: function() {
            el.classList.add('widget__actor--hidden');
            el.setAttribute('aria-hidden', 'true');
        }
    };
}
/**
 *
 */ function SubmitButton(param) {
    var label = param.label;
    var el = createElement('button', (0, _defineProperty._)({
        type: 'submit',
        className: 'btn btn--primary'
    }, 'aria-label', label), label);
    return {
        el: el
    };
}
function retrieveStringValue(formData, key) {
    var value = formData.get(key);
    if (typeof value === 'string') return value.trim();
    return '';
}
/**
 * Creates the form element
 */ function Form(param) {
    var nameLabel = param.nameLabel, namePlaceholder = param.namePlaceholder, emailLabel = param.emailLabel, emailPlaceholder = param.emailPlaceholder, messageLabel = param.messageLabel, messagePlaceholder = param.messagePlaceholder, isRequiredLabel = param.isRequiredLabel, cancelButtonLabel = param.cancelButtonLabel, submitButtonLabel = param.submitButtonLabel, showName = param.showName, showEmail = param.showEmail, isNameRequired = param.isNameRequired, isEmailRequired = param.isEmailRequired, defaultName = param.defaultName, defaultEmail = param.defaultEmail, onCancel = param.onCancel, onSubmit = param.onSubmit;
    var _SubmitButton = SubmitButton({
        label: submitButtonLabel
    }), submitEl = _SubmitButton.el;
    function handleSubmit(e) {
        e.preventDefault();
        if (!(e.target instanceof HTMLFormElement)) return;
        try {
            if (onSubmit) {
                var formData = new FormData(e.target);
                var feedback = {
                    name: retrieveStringValue(formData, 'name'),
                    email: retrieveStringValue(formData, 'email'),
                    message: retrieveStringValue(formData, 'message')
                };
                onSubmit(feedback);
            }
        } catch (e2) {
        // pass
        }
    }
    var errorEl = createElement('div', (0, _defineProperty._)({
        className: 'form__error-container form__error-container--hidden'
    }, 'aria-hidden', 'true'));
    function showError(message) {
        errorEl.textContent = message;
        errorEl.classList.remove('form__error-container--hidden');
        errorEl.setAttribute('aria-hidden', 'false');
    }
    function hideError() {
        errorEl.textContent = '';
        errorEl.classList.add('form__error-container--hidden');
        errorEl.setAttribute('aria-hidden', 'true');
    }
    var _obj;
    var nameEl = createElement('input', (_obj = {
        id: 'name',
        type: showName ? 'text' : 'hidden'
    }, (0, _defineProperty._)(_obj, 'aria-hidden', showName ? 'false' : 'true'), (0, _defineProperty._)(_obj, "name", 'name'), (0, _defineProperty._)(_obj, "required", isNameRequired), (0, _defineProperty._)(_obj, "className", 'form__input'), (0, _defineProperty._)(_obj, "placeholder", namePlaceholder), (0, _defineProperty._)(_obj, "value", defaultName), _obj));
    var _obj1;
    var emailEl = createElement('input', (_obj1 = {
        id: 'email',
        type: showEmail ? 'text' : 'hidden'
    }, (0, _defineProperty._)(_obj1, 'aria-hidden', showEmail ? 'false' : 'true'), (0, _defineProperty._)(_obj1, "name", 'email'), (0, _defineProperty._)(_obj1, "required", isEmailRequired), (0, _defineProperty._)(_obj1, "className", 'form__input'), (0, _defineProperty._)(_obj1, "placeholder", emailPlaceholder), (0, _defineProperty._)(_obj1, "value", defaultEmail), _obj1));
    var messageEl = createElement('textarea', {
        id: 'message',
        autoFocus: 'true',
        rows: '5',
        name: 'message',
        required: true,
        className: 'form__input form__input--textarea',
        placeholder: messagePlaceholder
    });
    var _obj2;
    var cancelEl = createElement('button', (_obj2 = {
        type: 'button',
        className: 'btn btn--default'
    }, (0, _defineProperty._)(_obj2, 'aria-label', cancelButtonLabel), (0, _defineProperty._)(_obj2, "onClick", function(e) {
        onCancel && onCancel(e);
    }), _obj2), cancelButtonLabel);
    var formEl = createElement('form', {
        className: 'form',
        onSubmit: handleSubmit
    }, [
        errorEl,
        showName && createElement('label', {
            htmlFor: 'name',
            className: 'form__label'
        }, [
            createElement('span', {
                className: 'form__label__text'
            }, nameLabel, isNameRequired && createElement('span', {
                className: 'form__label__text--required'
            }, ` ${isRequiredLabel}`)),
            nameEl
        ]),
        !showName && nameEl,
        showEmail && createElement('label', {
            htmlFor: 'email',
            className: 'form__label'
        }, [
            createElement('span', {
                className: 'form__label__text'
            }, emailLabel, isEmailRequired && createElement('span', {
                className: 'form__label__text--required'
            }, ` ${isRequiredLabel}`)),
            emailEl
        ]),
        !showEmail && emailEl,
        createElement('label', {
            htmlFor: 'message',
            className: 'form__label'
        }, [
            createElement('span', {
                className: 'form__label__text'
            }, messageLabel, createElement('span', {
                className: 'form__label__text--required'
            }, ` ${isRequiredLabel}`)),
            messageEl
        ]),
        createElement('div', {
            className: 'btn-group'
        }, [
            submitEl,
            cancelEl
        ])
    ]);
    return {
        get el () {
            return formEl;
        },
        showError: showError,
        hideError: hideError
    };
}
var XMLNS$1 = 'http://www.w3.org/2000/svg';
/**
 * Sentry Logo
 */ function Logo(param) {
    var colorScheme = param.colorScheme;
    var createElementNS = function(tagName) {
        return WINDOW.document.createElementNS(XMLNS$1, tagName);
    };
    var svg = setAttributesNS(createElementNS('svg'), {
        class: 'sentry-logo',
        width: '32',
        height: '30',
        viewBox: '0 0 72 66',
        fill: 'none'
    });
    var path = setAttributesNS(createElementNS('path'), {
        transform: 'translate(11, 11)',
        d: 'M29,2.26a4.67,4.67,0,0,0-8,0L14.42,13.53A32.21,32.21,0,0,1,32.17,40.19H27.55A27.68,27.68,0,0,0,12.09,17.47L6,28a15.92,15.92,0,0,1,9.23,12.17H4.62A.76.76,0,0,1,4,39.06l2.94-5a10.74,10.74,0,0,0-3.36-1.9l-2.91,5a4.54,4.54,0,0,0,1.69,6.24A4.66,4.66,0,0,0,4.62,44H19.15a19.4,19.4,0,0,0-8-17.31l2.31-4A23.87,23.87,0,0,1,23.76,44H36.07a35.88,35.88,0,0,0-16.41-31.8l4.67-8a.77.77,0,0,1,1.05-.27c.53.29,20.29,34.77,20.66,35.17a.76.76,0,0,1-.68,1.13H40.6q.09,1.91,0,3.81h4.78A4.59,4.59,0,0,0,50,39.43a4.49,4.49,0,0,0-.62-2.28Z'
    });
    svg.append(path);
    var defs = createElementNS('defs');
    var style = createElementNS('style');
    style.textContent = `
    path {
      fill: ${colorScheme === 'dark' ? '#fff' : '#362d59'};
    }`;
    if (colorScheme === 'system') style.textContent += `
    @media (prefers-color-scheme: dark) {
      path: {
        fill: '#fff';
      }
    }
    `;
    defs.append(style);
    svg.append(defs);
    return {
        get el () {
            return svg;
        }
    };
}
/**
 * Feedback dialog component that has the form
 */ function Dialog(_param) {
    var formTitle = _param.formTitle, showBranding = _param.showBranding, showName = _param.showName, showEmail = _param.showEmail, isNameRequired = _param.isNameRequired, isEmailRequired = _param.isEmailRequired, colorScheme = _param.colorScheme, defaultName = _param.defaultName, defaultEmail = _param.defaultEmail, onClosed = _param.onClosed, onCancel = _param.onCancel, onSubmit = _param.onSubmit, textLabels = (0, _objectWithoutProperties._)(_param, [
        "formTitle",
        "showBranding",
        "showName",
        "showEmail",
        "isNameRequired",
        "isEmailRequired",
        "colorScheme",
        "defaultName",
        "defaultEmail",
        "onClosed",
        "onCancel",
        "onSubmit"
    ]);
    var el = null;
    /**
   * Handles when the dialog is clicked. In our case, the dialog is the
   * semi-transparent bg behind the form. We want clicks outside of the form to
   * hide the form.
   */ function handleDialogClick() {
        close();
        // Only this should trigger `onClose`, we don't want the `close()` method to
        // trigger it, otherwise it can cause cycles.
        onClosed && onClosed();
    }
    /**
   * Close the dialog
   */ function close() {
        if (el) el.open = false;
    }
    /**
   * Opens the dialog
   */ function open() {
        if (el) el.open = true;
    }
    /**
   * Check if dialog is currently opened
   */ function checkIsOpen() {
        return el && el.open === true || false;
    }
    var _Form = Form((0, _objectSpread._)({
        showEmail: showEmail,
        showName: showName,
        isEmailRequired: isEmailRequired,
        isNameRequired: isNameRequired,
        defaultName: defaultName,
        defaultEmail: defaultEmail,
        onSubmit: onSubmit,
        onCancel: onCancel
    }, textLabels)), formEl = _Form.el, showError = _Form.showError, hideError = _Form.hideError;
    el = createElement('dialog', {
        className: 'dialog',
        open: true,
        onClick: handleDialogClick
    }, createElement('div', {
        className: 'dialog__content',
        onClick: function(e) {
            // Stop event propagation so clicks on content modal do not propagate to dialog (which will close dialog)
            e.stopPropagation();
        }
    }, createElement('h2', {
        className: 'dialog__header'
    }, formTitle, showBranding && createElement('a', {
        className: 'brand-link',
        target: '_blank',
        href: 'https://sentry.io/welcome/',
        title: 'Powered by Sentry',
        rel: 'noopener noreferrer'
    }, Logo({
        colorScheme: colorScheme
    }).el)), formEl));
    return {
        get el () {
            return el;
        },
        showError: showError,
        hideError: hideError,
        open: open,
        close: close,
        checkIsOpen: checkIsOpen
    };
}
var WIDTH = 16;
var HEIGHT = 17;
var XMLNS = 'http://www.w3.org/2000/svg';
/**
 * Success Icon (checkmark)
 */ function SuccessIcon() {
    var createElementNS = function(tagName) {
        return WINDOW.document.createElementNS(XMLNS, tagName);
    };
    var svg = setAttributesNS(createElementNS('svg'), {
        class: 'success-icon',
        width: `${WIDTH}`,
        height: `${HEIGHT}`,
        viewBox: `0 0 ${WIDTH} ${HEIGHT}`,
        fill: 'none'
    });
    var g = setAttributesNS(createElementNS('g'), {
        clipPath: 'url(#clip0_57_156)'
    });
    var _obj;
    var path2 = setAttributesNS(createElementNS('path'), (_obj = {}, (0, _defineProperty._)(_obj, 'fill-rule', 'evenodd'), (0, _defineProperty._)(_obj, 'clip-rule', 'evenodd'), (0, _defineProperty._)(_obj, "d", 'M3.55544 15.1518C4.87103 16.0308 6.41775 16.5 8 16.5C10.1217 16.5 12.1566 15.6571 13.6569 14.1569C15.1571 12.6566 16 10.6217 16 8.5C16 6.91775 15.5308 5.37103 14.6518 4.05544C13.7727 2.73985 12.5233 1.71447 11.0615 1.10897C9.59966 0.503466 7.99113 0.34504 6.43928 0.653721C4.88743 0.962403 3.46197 1.72433 2.34315 2.84315C1.22433 3.96197 0.462403 5.38743 0.153721 6.93928C-0.15496 8.49113 0.00346625 10.0997 0.608967 11.5615C1.21447 13.0233 2.23985 14.2727 3.55544 15.1518ZM4.40546 3.1204C5.46945 2.40946 6.72036 2.03 8 2.03C9.71595 2.03 11.3616 2.71166 12.575 3.92502C13.7883 5.13838 14.47 6.78405 14.47 8.5C14.47 9.77965 14.0905 11.0306 13.3796 12.0945C12.6687 13.1585 11.6582 13.9878 10.476 14.4775C9.29373 14.9672 7.99283 15.0953 6.73777 14.8457C5.48271 14.596 4.32987 13.9798 3.42502 13.075C2.52018 12.1701 1.90397 11.0173 1.65432 9.76224C1.40468 8.50718 1.5328 7.20628 2.0225 6.02404C2.5122 4.8418 3.34148 3.83133 4.40546 3.1204Z'), _obj));
    var path = setAttributesNS(createElementNS('path'), {
        d: 'M6.68775 12.4297C6.78586 12.4745 6.89218 12.4984 7 12.5C7.11275 12.4955 7.22315 12.4664 7.32337 12.4145C7.4236 12.3627 7.51121 12.2894 7.58 12.2L12 5.63999C12.0848 5.47724 12.1071 5.28902 12.0625 5.11098C12.0178 4.93294 11.9095 4.77744 11.7579 4.67392C11.6064 4.57041 11.4221 4.52608 11.24 4.54931C11.0579 4.57254 10.8907 4.66173 10.77 4.79999L6.88 10.57L5.13 8.56999C5.06508 8.49566 4.98613 8.43488 4.89768 8.39111C4.80922 8.34735 4.713 8.32148 4.61453 8.31498C4.51605 8.30847 4.41727 8.32147 4.32382 8.35322C4.23038 8.38497 4.14413 8.43484 4.07 8.49999C3.92511 8.63217 3.83692 8.81523 3.82387 9.01092C3.81083 9.2066 3.87393 9.39976 4 9.54999L6.43 12.24C6.50187 12.3204 6.58964 12.385 6.68775 12.4297Z'
    });
    svg.appendChild(g).append(path, path2);
    var speakerDefs = createElementNS('defs');
    var speakerClipPathDef = setAttributesNS(createElementNS('clipPath'), {
        id: 'clip0_57_156'
    });
    var speakerRect = setAttributesNS(createElementNS('rect'), {
        width: `${WIDTH}`,
        height: `${WIDTH}`,
        fill: 'white',
        transform: 'translate(0 0.5)'
    });
    speakerClipPathDef.appendChild(speakerRect);
    speakerDefs.appendChild(speakerClipPathDef);
    svg.appendChild(speakerDefs).appendChild(speakerClipPathDef).appendChild(speakerRect);
    return {
        get el () {
            return svg;
        }
    };
}
/**
 * Feedback dialog component that has the form
 */ function SuccessMessage(param) {
    var message = param.message, onRemove = param.onRemove;
    function remove() {
        if (!el) return;
        el.remove();
        onRemove && onRemove();
    }
    var el = createElement('div', {
        className: 'success-message',
        onClick: remove
    }, SuccessIcon().el, message);
    return {
        el: el,
        remove: remove
    };
}
/**
 * Creates a new widget. Returns public methods that control widget behavior.
 */ function createWidget(_param) {
    var shadow = _param.shadow, _param_options = _param.options, _param_options_shouldCreateActor = _param_options.shouldCreateActor, shouldCreateActor = _param_options_shouldCreateActor === void 0 ? true : _param_options_shouldCreateActor, attachTo = _param.attachTo, options = (0, _objectWithoutProperties._)(_param.options, [
        "shouldCreateActor"
    ]);
    var actor;
    var dialog;
    var isDialogOpen = false;
    /**
   * Show the success message for 5 seconds
   */ function showSuccessMessage() {
        if (!shadow) return;
        try {
            var success = SuccessMessage({
                message: options.successMessageText,
                onRemove: function() {
                    if (timeoutId) clearTimeout(timeoutId);
                    showActor();
                }
            });
            if (!success.el) throw new Error('Unable to show success message');
            shadow.appendChild(success.el);
            var timeoutId = setTimeout(function() {
                if (success) success.remove();
            }, 5000);
        } catch (err) {
            // TODO: error handling
            (0, _utils.logger).error(err);
        }
    }
    function _handleFeedbackSubmit(feedback) {
        return __handleFeedbackSubmit.apply(this, arguments);
    }
    function __handleFeedbackSubmit() {
        __handleFeedbackSubmit = /**
   * Handler for when the feedback form is completed by the user. This will
   * create and send the feedback message as an event.
   */ (0, _asyncToGenerator._)(function(feedback) {
            var emptyField, result;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!dialog) return [
                            2
                        ];
                        // Simple validation for now, just check for non-empty required fields
                        emptyField = [];
                        if (options.isNameRequired && !feedback.name) emptyField.push(options.nameLabel);
                        if (options.isEmailRequired && !feedback.email) emptyField.push(options.emailLabel);
                        if (!feedback.message) emptyField.push(options.messageLabel);
                        if (emptyField.length > 0) {
                            dialog.showError(`Please enter in the following required fields: ${emptyField.join(', ')}`);
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            handleFeedbackSubmit(dialog, feedback)
                        ];
                    case 1:
                        result = _state.sent();
                        // Error submitting feedback
                        if (!result) {
                            if (options.onSubmitError) options.onSubmitError();
                            return [
                                2
                            ];
                        }
                        // Success
                        removeDialog();
                        showSuccessMessage();
                        if (options.onSubmitSuccess) options.onSubmitSuccess();
                        return [
                            2
                        ];
                }
            });
        });
        return __handleFeedbackSubmit.apply(this, arguments);
    }
    /**
   * Internal handler when dialog is opened
   */ function handleOpenDialog() {
        // Flush replay if integration exists
        var client = (0, _core.getClient)();
        var replay = client && client.getIntegrationByName && client.getIntegrationByName('Replay');
        if (!replay) return;
        replay.flush().catch(function(err) {
            DEBUG_BUILD && (0, _utils.logger).error(err);
        });
    }
    /**
   * Displays the default actor
   */ function showActor() {
        actor && actor.show();
    }
    /**
   * Hides the default actor
   */ function hideActor() {
        actor && actor.hide();
    }
    /**
   * Removes the default actor element
   */ function removeActor() {
        actor && actor.el && actor.el.remove();
    }
    /**
   *
   */ function openDialog() {
        try {
            if (dialog) {
                dialog.open();
                isDialogOpen = true;
                if (options.onFormOpen) options.onFormOpen();
                handleOpenDialog();
                return;
            }
            var userKey = options.useSentryUser;
            var scope = (0, _core.getCurrentScope)();
            var user = scope && scope.getUser();
            dialog = Dialog({
                colorScheme: options.colorScheme,
                showBranding: options.showBranding,
                showName: options.showName || options.isNameRequired,
                showEmail: options.showEmail || options.isEmailRequired,
                isNameRequired: options.isNameRequired,
                isEmailRequired: options.isEmailRequired,
                formTitle: options.formTitle,
                cancelButtonLabel: options.cancelButtonLabel,
                submitButtonLabel: options.submitButtonLabel,
                emailLabel: options.emailLabel,
                emailPlaceholder: options.emailPlaceholder,
                messageLabel: options.messageLabel,
                messagePlaceholder: options.messagePlaceholder,
                nameLabel: options.nameLabel,
                namePlaceholder: options.namePlaceholder,
                isRequiredLabel: options.isRequiredLabel,
                defaultName: userKey && user && user[userKey.name] || '',
                defaultEmail: userKey && user && user[userKey.email] || '',
                onClosed: function() {
                    showActor();
                    isDialogOpen = false;
                    if (options.onFormClose) options.onFormClose();
                },
                onCancel: function() {
                    closeDialog();
                    showActor();
                },
                onSubmit: _handleFeedbackSubmit
            });
            if (!dialog.el) throw new Error('Unable to open Feedback dialog');
            shadow.appendChild(dialog.el);
            // Hides the default actor whenever dialog is opened
            hideActor();
            if (options.onFormOpen) options.onFormOpen();
            handleOpenDialog();
        } catch (err) {
            // TODO: Error handling?
            (0, _utils.logger).error(err);
        }
    }
    /**
   * Closes the dialog
   */ function closeDialog() {
        if (dialog) {
            dialog.close();
            isDialogOpen = false;
            if (options.onFormClose) options.onFormClose();
        }
    }
    /**
   * Removes the dialog element from DOM
   */ function removeDialog() {
        if (dialog) {
            closeDialog();
            var dialogEl = dialog.el;
            dialogEl && dialogEl.remove();
            dialog = undefined;
        }
    }
    /**
   *
   */ function handleActorClick() {
        // Open dialog
        if (!isDialogOpen) openDialog();
        // Hide actor button
        hideActor();
    }
    if (attachTo) attachTo.addEventListener('click', handleActorClick);
    else if (shouldCreateActor) {
        actor = Actor({
            buttonLabel: options.buttonLabel,
            onClick: handleActorClick
        });
        actor.el && shadow.appendChild(actor.el);
    }
    return {
        get actor () {
            return actor;
        },
        get dialog () {
            return dialog;
        },
        showActor: showActor,
        hideActor: hideActor,
        removeActor: removeActor,
        openDialog: openDialog,
        closeDialog: closeDialog,
        removeDialog: removeDialog
    };
}
var doc = WINDOW.document;
var feedbackIntegration = function(options) {
    // eslint-disable-next-line deprecation/deprecation
    return new Feedback(options);
};
/**
 * Feedback integration. When added as an integration to the SDK, it will
 * inject a button in the bottom-right corner of the window that opens a
 * feedback modal when clicked.
 *
 * @deprecated Use `feedbackIntegration()` instead.
 */ var Feedback = /*#__PURE__*/ function() {
    "use strict";
    function Feedback() {
        var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_autoInject = _ref.autoInject, autoInject = _ref_autoInject === void 0 ? true : _ref_autoInject, _ref_id = _ref.id, id = _ref_id === void 0 ? 'sentry-feedback' : _ref_id, _ref_isEmailRequired = _ref.isEmailRequired, isEmailRequired = _ref_isEmailRequired === void 0 ? false : _ref_isEmailRequired, _ref_isNameRequired = _ref.isNameRequired, isNameRequired = _ref_isNameRequired === void 0 ? false : _ref_isNameRequired, _ref_showBranding = _ref.showBranding, showBranding = _ref_showBranding === void 0 ? true : _ref_showBranding, _ref_showEmail = _ref.showEmail, showEmail = _ref_showEmail === void 0 ? true : _ref_showEmail, _ref_showName = _ref.showName, showName = _ref_showName === void 0 ? true : _ref_showName, _ref_useSentryUser = _ref.useSentryUser, useSentryUser = _ref_useSentryUser === void 0 ? {
            email: 'email',
            name: 'username'
        } : _ref_useSentryUser, themeDark = _ref.themeDark, themeLight = _ref.themeLight, _ref_colorScheme = _ref.colorScheme, colorScheme = _ref_colorScheme === void 0 ? 'system' : _ref_colorScheme, _ref_buttonLabel = _ref.buttonLabel, buttonLabel = _ref_buttonLabel === void 0 ? ACTOR_LABEL : _ref_buttonLabel, _ref_cancelButtonLabel = _ref.cancelButtonLabel, cancelButtonLabel = _ref_cancelButtonLabel === void 0 ? CANCEL_BUTTON_LABEL : _ref_cancelButtonLabel, _ref_submitButtonLabel = _ref.submitButtonLabel, submitButtonLabel = _ref_submitButtonLabel === void 0 ? SUBMIT_BUTTON_LABEL : _ref_submitButtonLabel, _ref_formTitle = _ref.formTitle, formTitle = _ref_formTitle === void 0 ? FORM_TITLE : _ref_formTitle, _ref_emailPlaceholder = _ref.emailPlaceholder, emailPlaceholder = _ref_emailPlaceholder === void 0 ? EMAIL_PLACEHOLDER : _ref_emailPlaceholder, _ref_emailLabel = _ref.emailLabel, emailLabel = _ref_emailLabel === void 0 ? EMAIL_LABEL : _ref_emailLabel, _ref_messagePlaceholder = _ref.messagePlaceholder, messagePlaceholder = _ref_messagePlaceholder === void 0 ? MESSAGE_PLACEHOLDER : _ref_messagePlaceholder, _ref_messageLabel = _ref.messageLabel, messageLabel = _ref_messageLabel === void 0 ? MESSAGE_LABEL : _ref_messageLabel, _ref_namePlaceholder = _ref.namePlaceholder, namePlaceholder = _ref_namePlaceholder === void 0 ? NAME_PLACEHOLDER : _ref_namePlaceholder, _ref_nameLabel = _ref.nameLabel, nameLabel = _ref_nameLabel === void 0 ? NAME_LABEL : _ref_nameLabel, _ref_isRequiredLabel = _ref.isRequiredLabel, isRequiredLabel = _ref_isRequiredLabel === void 0 ? IS_REQUIRED_LABEL : _ref_isRequiredLabel, _ref_successMessageText = _ref.successMessageText, successMessageText = _ref_successMessageText === void 0 ? SUCCESS_MESSAGE_TEXT : _ref_successMessageText, onFormClose = _ref.onFormClose, onFormOpen = _ref.onFormOpen, onSubmitError = _ref.onSubmitError, onSubmitSuccess = _ref.onSubmitSuccess;
        (0, _classCallCheck._)(this, Feedback);
        // eslint-disable-next-line deprecation/deprecation
        this.name = Feedback.id;
        // tsc fails if these are not initialized explicitly constructor, e.g. can't call `_initialize()`
        this._host = null;
        this._shadow = null;
        this._widget = null;
        this._widgets = new Set();
        this._hasInsertedActorStyles = false;
        this.options = {
            autoInject: autoInject,
            showBranding: showBranding,
            id: id,
            isEmailRequired: isEmailRequired,
            isNameRequired: isNameRequired,
            showEmail: showEmail,
            showName: showName,
            useSentryUser: useSentryUser,
            colorScheme: colorScheme,
            themeDark: (0, _objectSpread._)({}, DEFAULT_THEME.dark, themeDark),
            themeLight: (0, _objectSpread._)({}, DEFAULT_THEME.light, themeLight),
            buttonLabel: buttonLabel,
            cancelButtonLabel: cancelButtonLabel,
            submitButtonLabel: submitButtonLabel,
            formTitle: formTitle,
            emailLabel: emailLabel,
            emailPlaceholder: emailPlaceholder,
            messageLabel: messageLabel,
            messagePlaceholder: messagePlaceholder,
            nameLabel: nameLabel,
            namePlaceholder: namePlaceholder,
            isRequiredLabel: isRequiredLabel,
            successMessageText: successMessageText,
            onFormClose: onFormClose,
            onFormOpen: onFormOpen,
            onSubmitError: onSubmitError,
            onSubmitSuccess: onSubmitSuccess
        };
    }
    (0, _createClass._)(Feedback, [
        {
            /**
   * Setup and initialize feedback container
   */ key: "setupOnce",
            value: function setupOnce() {
                if (!(0, _utils.isBrowser)()) return;
                try {
                    this._cleanupWidgetIfExists();
                    var autoInject = this.options.autoInject;
                    if (!autoInject) // Nothing to do here
                    return;
                    this._createWidget(this.options);
                } catch (err) {
                    DEBUG_BUILD && (0, _utils.logger).error(err);
                }
            }
        },
        {
            /**
   * Allows user to open the dialog box. Creates a new widget if
   * `autoInject` was false, otherwise re-uses the default widget that was
   * created during initialization of the integration.
   */ key: "openDialog",
            value: function openDialog() {
                if (!this._widget) this._createWidget((0, _objectSpreadProps._)((0, _objectSpread._)({}, this.options), {
                    shouldCreateActor: false
                }));
                if (!this._widget) return;
                this._widget.openDialog();
            }
        },
        {
            /**
   * Closes the dialog for the default widget, if it exists
   */ key: "closeDialog",
            value: function closeDialog() {
                if (!this._widget) // Nothing to do if widget does not exist
                return;
                this._widget.closeDialog();
            }
        },
        {
            /**
   * Adds click listener to attached element to open a feedback dialog
   */ key: "attachTo",
            value: function attachTo(el, optionOverrides) {
                var _this = this;
                try {
                    var options = mergeOptions(this.options, optionOverrides || {});
                    return this._ensureShadowHost(options, function(param) {
                        var shadow = param.shadow;
                        var targetEl = typeof el === 'string' ? doc.querySelector(el) : typeof el.addEventListener === 'function' ? el : null;
                        if (!targetEl) {
                            DEBUG_BUILD && (0, _utils.logger).error('[Feedback] Unable to attach to target element');
                            return null;
                        }
                        var widget = createWidget({
                            shadow: shadow,
                            options: options,
                            attachTo: targetEl
                        });
                        _this._widgets.add(widget);
                        if (!_this._widget) _this._widget = widget;
                        return widget;
                    });
                } catch (err) {
                    DEBUG_BUILD && (0, _utils.logger).error(err);
                    return null;
                }
            }
        },
        {
            /**
   * Creates a new widget. Accepts partial options to override any options passed to constructor.
   */ key: "createWidget",
            value: function createWidget(optionOverrides) {
                try {
                    return this._createWidget(mergeOptions(this.options, optionOverrides || {}));
                } catch (err) {
                    DEBUG_BUILD && (0, _utils.logger).error(err);
                    return null;
                }
            }
        },
        {
            /**
   * Removes a single widget
   */ key: "removeWidget",
            value: function removeWidget(widget) {
                if (!widget) return false;
                try {
                    if (this._widgets.has(widget)) {
                        widget.removeActor();
                        widget.removeDialog();
                        this._widgets.delete(widget);
                        if (this._widget === widget) // TODO: is more clean-up needed? e.g. call remove()
                        this._widget = null;
                        return true;
                    }
                } catch (err) {
                    DEBUG_BUILD && (0, _utils.logger).error(err);
                }
                return false;
            }
        },
        {
            /**
   * Returns the default (first-created) widget
   */ key: "getWidget",
            value: function getWidget() {
                return this._widget;
            }
        },
        {
            /**
   * Removes the Feedback integration (including host, shadow DOM, and all widgets)
   */ key: "remove",
            value: function remove() {
                if (this._host) this._host.remove();
                this._initialize();
            }
        },
        {
            /**
   * Initializes values of protected properties
   */ key: "_initialize",
            value: function _initialize() {
                this._host = null;
                this._shadow = null;
                this._widget = null;
                this._widgets = new Set();
                this._hasInsertedActorStyles = false;
            }
        },
        {
            /**
   * Clean-up the widget if it already exists in the DOM. This shouldn't happen
   * in prod, but can happen in development with hot module reloading.
   */ key: "_cleanupWidgetIfExists",
            value: function _cleanupWidgetIfExists() {
                if (this._host) this.remove();
                var existingFeedback = doc.querySelector(`#${this.options.id}`);
                if (existingFeedback) existingFeedback.remove();
            }
        },
        {
            /**
   * Creates a new widget, after ensuring shadow DOM exists
   */ key: "_createWidget",
            value: function _createWidget(options) {
                var _this = this;
                return this._ensureShadowHost(options, function(param) {
                    var shadow = param.shadow;
                    var widget = createWidget({
                        shadow: shadow,
                        options: options
                    });
                    if (!_this._hasInsertedActorStyles && widget.actor) {
                        shadow.appendChild(createActorStyles(doc));
                        _this._hasInsertedActorStyles = true;
                    }
                    _this._widgets.add(widget);
                    if (!_this._widget) _this._widget = widget;
                    return widget;
                });
            }
        },
        {
            /**
   * Ensures that shadow DOM exists and is added to the DOM
   */ key: "_ensureShadowHost",
            value: function _ensureShadowHost(options, cb) {
                var needsAppendHost = false;
                // Don't create if it already exists
                if (!this._shadow || !this._host) {
                    var id = options.id, colorScheme = options.colorScheme, themeLight = options.themeLight, themeDark = options.themeDark;
                    var _createShadowHost = createShadowHost({
                        id: id,
                        colorScheme: colorScheme,
                        themeLight: themeLight,
                        themeDark: themeDark
                    }), shadow = _createShadowHost.shadow, host = _createShadowHost.host;
                    this._shadow = shadow;
                    this._host = host;
                    needsAppendHost = true;
                }
                // set data attribute on host for different themes
                this._host.dataset.sentryFeedbackColorscheme = options.colorScheme;
                var result = cb({
                    shadow: this._shadow,
                    host: this._host
                });
                if (needsAppendHost) doc.body.appendChild(this._host);
                return result;
            }
        }
    ], [
        {
            key: "__initStatic",
            value: /**
   * @inheritDoc
   */ function __initStatic() {
                this.id = 'Feedback';
            }
        }
    ]);
    return Feedback;
}();
Feedback.__initStatic();

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_class_call_check":"6UdKs","@swc/helpers/_/_create_class":"3Y9J0","@swc/helpers/_/_define_property":"54Zvk","@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_object_spread_props":"fLCYP","@swc/helpers/_/_object_without_properties":"1waVD","@swc/helpers/_/_sliced_to_array":"ha6sq","@swc/helpers/_/_ts_generator":"f2hGH","@sentry/utils":"gElXU","@sentry/core":"8bBGI","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gi4iA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CaptureConsole", function() {
    return 0, _captureconsoleJs.CaptureConsole;
});
parcelHelpers.export(exports, "captureConsoleIntegration", function() {
    return 0, _captureconsoleJs.captureConsoleIntegration;
});
parcelHelpers.export(exports, "Debug", function() {
    return 0, _debugJs.Debug;
});
parcelHelpers.export(exports, "debugIntegration", function() {
    return 0, _debugJs.debugIntegration;
});
parcelHelpers.export(exports, "Dedupe", function() {
    return 0, _dedupeJs.Dedupe;
});
parcelHelpers.export(exports, "dedupeIntegration", function() {
    return 0, _dedupeJs.dedupeIntegration;
});
parcelHelpers.export(exports, "ExtraErrorData", function() {
    return 0, _extraerrordataJs.ExtraErrorData;
});
parcelHelpers.export(exports, "extraErrorDataIntegration", function() {
    return 0, _extraerrordataJs.extraErrorDataIntegration;
});
parcelHelpers.export(exports, "Offline", function() {
    return 0, _offlineJs.Offline;
});
parcelHelpers.export(exports, "ReportingObserver", function() {
    return 0, _reportingobserverJs.ReportingObserver;
});
parcelHelpers.export(exports, "reportingObserverIntegration", function() {
    return 0, _reportingobserverJs.reportingObserverIntegration;
});
parcelHelpers.export(exports, "RewriteFrames", function() {
    return 0, _rewriteframesJs.RewriteFrames;
});
parcelHelpers.export(exports, "rewriteFramesIntegration", function() {
    return 0, _rewriteframesJs.rewriteFramesIntegration;
});
parcelHelpers.export(exports, "SessionTiming", function() {
    return 0, _sessiontimingJs.SessionTiming;
});
parcelHelpers.export(exports, "sessionTimingIntegration", function() {
    return 0, _sessiontimingJs.sessionTimingIntegration;
});
parcelHelpers.export(exports, "Transaction", function() {
    return 0, _transactionJs.Transaction;
});
parcelHelpers.export(exports, "HttpClient", function() {
    return 0, _httpclientJs.HttpClient;
});
parcelHelpers.export(exports, "httpClientIntegration", function() {
    return 0, _httpclientJs.httpClientIntegration;
});
parcelHelpers.export(exports, "ContextLines", function() {
    return 0, _contextlinesJs.ContextLines;
});
parcelHelpers.export(exports, "contextLinesIntegration", function() {
    return 0, _contextlinesJs.contextLinesIntegration;
});
var _captureconsoleJs = require("./captureconsole.js");
var _debugJs = require("./debug.js");
var _dedupeJs = require("./dedupe.js");
var _extraerrordataJs = require("./extraerrordata.js");
var _offlineJs = require("./offline.js");
var _reportingobserverJs = require("./reportingobserver.js");
var _rewriteframesJs = require("./rewriteframes.js");
var _sessiontimingJs = require("./sessiontiming.js");
var _transactionJs = require("./transaction.js");
var _httpclientJs = require("./httpclient.js");
var _contextlinesJs = require("./contextlines.js");

},{"./captureconsole.js":"2VN38","./debug.js":"9biot","./dedupe.js":"2z0db","./extraerrordata.js":"6JK7S","./offline.js":false,"./reportingobserver.js":"jeCdG","./rewriteframes.js":"1vKxf","./sessiontiming.js":"1VsT3","./transaction.js":false,"./httpclient.js":"aMMCw","./contextlines.js":"bJLPv","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2VN38":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CaptureConsole", function() {
    return CaptureConsole;
});
parcelHelpers.export(exports, "captureConsoleIntegration", function() {
    return captureConsoleIntegration;
});
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
var INTEGRATION_NAME = 'CaptureConsole';
var _captureConsoleIntegration = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var levels = options.levels || (0, _utils.CONSOLE_LEVELS);
    return {
        name: INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce: function() {},
        setup: function(client) {
            if (!('console' in (0, _utils.GLOBAL_OBJ))) return;
            (0, _utils.addConsoleInstrumentationHandler)(function(param) {
                var args = param.args, level = param.level;
                if ((0, _core.getClient)() !== client || !levels.includes(level)) return;
                consoleHandler(args, level);
            });
        }
    };
};
var captureConsoleIntegration = (0, _core.defineIntegration)(_captureConsoleIntegration);
/**
 * Send Console API calls as Sentry Events.
 * @deprecated Use `captureConsoleIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
var CaptureConsole = (0, _core.convertIntegrationFnToClass)(INTEGRATION_NAME, captureConsoleIntegration);
function consoleHandler(args, level) {
    var captureContext = {
        level: (0, _utils.severityLevelFromString)(level),
        extra: {
            arguments: args
        }
    };
    (0, _core.withScope)(function(scope) {
        scope.addEventProcessor(function(event) {
            event.logger = 'console';
            (0, _utils.addExceptionMechanism)(event, {
                handled: false,
                type: 'console'
            });
            return event;
        });
        if (level === 'assert' && args[0] === false) {
            var message = `Assertion failed: ${(0, _utils.safeJoin)(args.slice(1), ' ') || 'console.assert'}`;
            scope.setExtra('arguments', args.slice(1));
            (0, _core.captureMessage)(message, captureContext);
            return;
        }
        var error = args.find(function(arg) {
            return arg instanceof Error;
        });
        if (level === 'error' && error) {
            (0, _core.captureException)(error, captureContext);
            return;
        }
        var message1 = (0, _utils.safeJoin)(args, ' ');
        (0, _core.captureMessage)(message1, captureContext);
    });
}

},{"@sentry/core":"8bBGI","@sentry/utils":"gElXU","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"9biot":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Debug", function() {
    return Debug;
});
parcelHelpers.export(exports, "debugIntegration", function() {
    return debugIntegration;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
var INTEGRATION_NAME = 'Debug';
var _debugIntegration = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _options = (0, _objectSpread._)({
        debugger: false,
        stringify: false
    }, options);
    return {
        name: INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce: function() {},
        setup: function(client) {
            if (!client.on) return;
            client.on('beforeSendEvent', function(event, hint) {
                if (_options.debugger) // eslint-disable-next-line no-debugger
                debugger;
                /* eslint-disable no-console */ (0, _utils.consoleSandbox)(function() {
                    if (_options.stringify) {
                        console.log(JSON.stringify(event, null, 2));
                        if (hint && Object.keys(hint).length) console.log(JSON.stringify(hint, null, 2));
                    } else {
                        console.log(event);
                        if (hint && Object.keys(hint).length) console.log(hint);
                    }
                });
            /* eslint-enable no-console */ });
        }
    };
};
var debugIntegration = (0, _core.defineIntegration)(_debugIntegration);
/**
 * Integration to debug sent Sentry events.
 * This integration should not be used in production.
 *
 * @deprecated Use `debugIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
var Debug = (0, _core.convertIntegrationFnToClass)(INTEGRATION_NAME, debugIntegration);

},{"@swc/helpers/_/_object_spread":"4bEWH","@sentry/core":"8bBGI","@sentry/utils":"gElXU","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2z0db":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Dedupe", function() {
    return Dedupe;
});
parcelHelpers.export(exports, "_shouldDropEvent", function() {
    return _shouldDropEvent;
});
parcelHelpers.export(exports, "dedupeIntegration", function() {
    return dedupeIntegration;
});
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
var _debugBuildJs = require("./debug-build.js");
var INTEGRATION_NAME = 'Dedupe';
var _dedupeIntegration = function() {
    var previousEvent;
    return {
        name: INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce: function() {},
        processEvent: function(currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if (_shouldDropEvent(currentEvent, previousEvent)) {
                    (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn('Event dropped due to being a duplicate of previously captured event.');
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
var dedupeIntegration = (0, _core.defineIntegration)(_dedupeIntegration);
/**
 * Deduplication filter.
 * @deprecated Use `dedupeIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
var Dedupe = (0, _core.convertIntegrationFnToClass)(INTEGRATION_NAME, dedupeIntegration);
/** only exported for tests. */ function _shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if (_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if (_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function _isSameMessageEvent(currentEvent, previousEvent) {
    var currentMessage = currentEvent.message;
    var previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function _isSameExceptionEvent(currentEvent, previousEvent) {
    var previousException = _getExceptionFromEvent(previousEvent);
    var currentException = _getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function _isSameStacktrace(currentEvent, previousEvent) {
    var currentFrames = _getFramesFromEvent(currentEvent);
    var previousFrames = _getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(var i = 0; i < previousFrames.length; i++){
        var frameA = previousFrames[i];
        var frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function _isSameFingerprint(currentEvent, previousEvent) {
    var currentFingerprint = currentEvent.fingerprint;
    var previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
function _getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
function _getFramesFromEvent(event) {
    var exception = event.exception;
    if (exception) try {
        // @ts-expect-error Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    return undefined;
}

},{"@sentry/core":"8bBGI","@sentry/utils":"gElXU","./debug-build.js":"6i81I","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6i81I":[function(require,module,exports,__globalThis) {
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEBUG_BUILD", function() {
    return DEBUG_BUILD;
});
var DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6JK7S":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ExtraErrorData", function() {
    return ExtraErrorData;
});
parcelHelpers.export(exports, "extraErrorDataIntegration", function() {
    return extraErrorDataIntegration;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
var _debugBuildJs = require("./debug-build.js");
var INTEGRATION_NAME = 'ExtraErrorData';
var _extraErrorDataIntegration = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var depth = options.depth || 3;
    // TODO(v8): Flip the default for this option to true
    var captureErrorCause = options.captureErrorCause || false;
    return {
        name: INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce: function() {},
        processEvent: function(event, hint) {
            return _enhanceEventWithErrorData(event, hint, depth, captureErrorCause);
        }
    };
};
var extraErrorDataIntegration = (0, _core.defineIntegration)(_extraErrorDataIntegration);
/**
 * Extract additional data for from original exceptions.
 * @deprecated Use `extraErrorDataIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
var ExtraErrorData = (0, _core.convertIntegrationFnToClass)(INTEGRATION_NAME, extraErrorDataIntegration);
function _enhanceEventWithErrorData(event) {
    var hint = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, depth = arguments.length > 2 ? arguments[2] : void 0, captureErrorCause = arguments.length > 3 ? arguments[3] : void 0;
    if (!hint.originalException || !(0, _utils.isError)(hint.originalException)) return event;
    var exceptionName = hint.originalException.name || hint.originalException.constructor.name;
    var errorData = _extractErrorData(hint.originalException, captureErrorCause);
    if (errorData) {
        var contexts = (0, _objectSpread._)({}, event.contexts);
        var normalizedErrorData = (0, _utils.normalize)(errorData, depth);
        if ((0, _utils.isPlainObject)(normalizedErrorData)) {
            // We mark the error data as "already normalized" here, because we don't want other normalization procedures to
            // potentially truncate the data we just already normalized, with a certain depth setting.
            (0, _utils.addNonEnumerableProperty)(normalizedErrorData, '__sentry_skip_normalization__', true);
            contexts[exceptionName] = normalizedErrorData;
        }
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, event), {
            contexts: contexts
        });
    }
    return event;
}
/**
 * Extract extra information from the Error object
 */ function _extractErrorData(error, captureErrorCause) {
    // We are trying to enhance already existing event, so no harm done if it won't succeed
    try {
        var nativeKeys = [
            'name',
            'message',
            'stack',
            'line',
            'column',
            'fileName',
            'lineNumber',
            'columnNumber',
            'toJSON'
        ];
        var extraErrorInfo = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            // We want only enumerable properties, thus `getOwnPropertyNames` is redundant here, as we filter keys anyway.
            for(var _iterator = Object.keys(error)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                if (nativeKeys.indexOf(key) !== -1) continue;
                var value = error[key];
                extraErrorInfo[key] = (0, _utils.isError)(value) ? value.toString() : value;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        // Error.cause is a standard property that is non enumerable, we therefore need to access it separately.
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/cause
        if (captureErrorCause && error.cause !== undefined) extraErrorInfo.cause = (0, _utils.isError)(error.cause) ? error.cause.toString() : error.cause;
        // Check if someone attached `toJSON` method to grab even more properties (eg. axios is doing that)
        if (typeof error.toJSON === 'function') {
            var serializedError = error.toJSON();
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = Object.keys(serializedError)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var key1 = _step1.value;
                    var value1 = serializedError[key1];
                    extraErrorInfo[key1] = (0, _utils.isError)(value1) ? value1.toString() : value1;
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
        return extraErrorInfo;
    } catch (oO) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).error('Unable to extract extra data from the Error object:', oO);
    }
    return null;
}

},{"@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_object_spread_props":"fLCYP","@sentry/core":"8bBGI","@sentry/utils":"gElXU","./debug-build.js":"6i81I","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jeCdG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReportingObserver", function() {
    return ReportingObserver;
});
parcelHelpers.export(exports, "reportingObserverIntegration", function() {
    return reportingObserverIntegration;
});
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
var WINDOW = (0, _utils.GLOBAL_OBJ);
var INTEGRATION_NAME = 'ReportingObserver';
var SETUP_CLIENTS = new WeakMap();
var _reportingObserverIntegration = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var types = options.types || [
        'crash',
        'deprecation',
        'intervention'
    ];
    /** Handler for the reporting observer. */ function handler(reports) {
        if (!SETUP_CLIENTS.has((0, _core.getClient)())) return;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var report = _step.value;
                (0, _core.withScope)(function(scope) {
                    scope.setExtra('url', report.url);
                    var label = `ReportingObserver [${report.type}]`;
                    var details = 'No details available';
                    if (report.body) {
                        // Object.keys doesn't work on ReportBody, as all properties are inheirted
                        var plainBody = {};
                        // eslint-disable-next-line guard-for-in
                        for(var prop in report.body)plainBody[prop] = report.body[prop];
                        scope.setExtra('body', plainBody);
                        if (report.type === 'crash') {
                            var body = report.body;
                            // A fancy way to create a message out of crashId OR reason OR both OR fallback
                            details = [
                                body.crashId || '',
                                body.reason || ''
                            ].join(' ').trim() || details;
                        } else {
                            var body1 = report.body;
                            details = body1.message || details;
                        }
                    }
                    (0, _core.captureMessage)(`${label}: ${details}`);
                });
            };
            for(var _iterator = reports[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return {
        name: INTEGRATION_NAME,
        setupOnce: function() {
            if (!(0, _utils.supportsReportingObserver)()) return;
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
            var observer = new WINDOW.ReportingObserver(handler, {
                buffered: true,
                types: types
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            observer.observe();
        },
        setup: function(client) {
            SETUP_CLIENTS.set(client, true);
        }
    };
};
var reportingObserverIntegration = (0, _core.defineIntegration)(_reportingObserverIntegration);
/**
 * Reporting API integration - https://w3c.github.io/reporting/
 * @deprecated Use `reportingObserverIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
var ReportingObserver = (0, _core.convertIntegrationFnToClass)(INTEGRATION_NAME, reportingObserverIntegration);

},{"@sentry/core":"8bBGI","@sentry/utils":"gElXU","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1vKxf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RewriteFrames", function() {
    return RewriteFrames;
});
parcelHelpers.export(exports, "rewriteFramesIntegration", function() {
    return rewriteFramesIntegration;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
var INTEGRATION_NAME = 'RewriteFrames';
var _rewriteFramesIntegration = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var root = options.root;
    var prefix = options.prefix || 'app:///';
    var iteratee = options.iteratee || function(frame) {
        if (!frame.filename) return frame;
        // Determine if this is a Windows frame by checking for a Windows-style prefix such as `C:\`
        var isWindowsFrame = /^[a-zA-Z]:\\/.test(frame.filename) || // or the presence of a backslash without a forward slash (which are not allowed on Windows)
        frame.filename.includes('\\') && !frame.filename.includes('/');
        // Check if the frame filename begins with `/`
        var startsWithSlash = /^\//.test(frame.filename);
        if (isWindowsFrame || startsWithSlash) {
            var filename = isWindowsFrame ? frame.filename.replace(/^[a-zA-Z]:/, '') // remove Windows-style prefix
            .replace(/\\/g, '/') // replace all `\\` instances with `/`
             : frame.filename;
            var base = root ? (0, _utils.relative)(root, filename) : (0, _utils.basename)(filename);
            frame.filename = `${prefix}${base}`;
        }
        return frame;
    };
    /** Process an exception event. */ function _processExceptionsEvent(event) {
        try {
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, event), {
                exception: (0, _objectSpreadProps._)((0, _objectSpread._)({}, event.exception), {
                    // The check for this is performed inside `process` call itself, safe to skip here
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    values: event.exception.values.map(function(value) {
                        return (0, _objectSpread._)({}, value, value.stacktrace && {
                            stacktrace: _processStacktrace(value.stacktrace)
                        });
                    })
                })
            });
        } catch (_oO) {
            return event;
        }
    }
    /** Process a stack trace. */ function _processStacktrace(stacktrace) {
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, stacktrace), {
            frames: stacktrace && stacktrace.frames && stacktrace.frames.map(function(f) {
                return iteratee(f);
            })
        });
    }
    return {
        name: INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce: function() {},
        processEvent: function(originalEvent) {
            var processedEvent = originalEvent;
            if (originalEvent.exception && Array.isArray(originalEvent.exception.values)) processedEvent = _processExceptionsEvent(processedEvent);
            return processedEvent;
        }
    };
};
var rewriteFramesIntegration = (0, _core.defineIntegration)(_rewriteFramesIntegration);
/**
 * Rewrite event frames paths.
 * @deprecated Use `rewriteFramesIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
var RewriteFrames = (0, _core.convertIntegrationFnToClass)(INTEGRATION_NAME, rewriteFramesIntegration);

},{"@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_object_spread_props":"fLCYP","@sentry/core":"8bBGI","@sentry/utils":"gElXU","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1VsT3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SessionTiming", function() {
    return SessionTiming;
});
parcelHelpers.export(exports, "sessionTimingIntegration", function() {
    return sessionTimingIntegration;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _core = require("@sentry/core");
var INTEGRATION_NAME = 'SessionTiming';
var _sessionTimingIntegration = function() {
    var startTime = Date.now();
    return {
        name: INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce: function() {},
        processEvent: function(event) {
            var now = Date.now();
            var _obj;
            return (0, _objectSpreadProps._)((0, _objectSpread._)({}, event), {
                extra: (0, _objectSpreadProps._)((0, _objectSpread._)({}, event.extra), (_obj = {}, (0, _defineProperty._)(_obj, 'session:start', startTime), (0, _defineProperty._)(_obj, 'session:duration', now - startTime), (0, _defineProperty._)(_obj, 'session:end', now), _obj))
            });
        }
    };
};
var sessionTimingIntegration = (0, _core.defineIntegration)(_sessionTimingIntegration);
/**
 * This function adds duration since Sentry was initialized till the time event was sent.
 * @deprecated Use `sessionTimingIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
var SessionTiming = (0, _core.convertIntegrationFnToClass)(INTEGRATION_NAME, sessionTimingIntegration);

},{"@swc/helpers/_/_define_property":"54Zvk","@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_object_spread_props":"fLCYP","@sentry/core":"8bBGI","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"aMMCw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HttpClient", function() {
    return HttpClient;
});
parcelHelpers.export(exports, "httpClientIntegration", function() {
    return httpClientIntegration;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
var _debugBuildJs = require("./debug-build.js");
var INTEGRATION_NAME = 'HttpClient';
var _httpClientIntegration = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _options = (0, _objectSpread._)({
        failedRequestStatusCodes: [
            [
                500,
                599
            ]
        ],
        failedRequestTargets: [
            /.*/
        ]
    }, options);
    return {
        name: INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce: function() {},
        setup: function(client) {
            _wrapFetch(client, _options);
            _wrapXHR(client, _options);
        }
    };
};
var httpClientIntegration = (0, _core.defineIntegration)(_httpClientIntegration);
/**
 * Create events for failed client side HTTP requests.
 * @deprecated Use `httpClientIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
var HttpClient = (0, _core.convertIntegrationFnToClass)(INTEGRATION_NAME, httpClientIntegration);
/**
 * Interceptor function for fetch requests
 *
 * @param requestInfo The Fetch API request info
 * @param response The Fetch API response
 * @param requestInit The request init object
 */ function _fetchResponseHandler(options, requestInfo, response, requestInit) {
    if (_shouldCaptureResponse(options, response.status, response.url)) {
        var request = _getRequest(requestInfo, requestInit);
        var requestHeaders, responseHeaders, requestCookies, responseCookies;
        var ref, ref1, ref2;
        if (_shouldSendDefaultPii()) ref = (0, _slicedToArray._)([
            {
                cookieHeader: 'Cookie',
                obj: request
            },
            {
                cookieHeader: 'Set-Cookie',
                obj: response
            }
        ].map(function(param) {
            var cookieHeader = param.cookieHeader, obj = param.obj;
            var headers = _extractFetchHeaders(obj.headers);
            var cookies;
            try {
                var cookieString = headers[cookieHeader] || headers[cookieHeader.toLowerCase()] || undefined;
                if (cookieString) cookies = _parseCookieString(cookieString);
            } catch (e) {
                (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log(`Could not extract cookies from header ${cookieHeader}`);
            }
            return {
                headers: headers,
                cookies: cookies
            };
        }), 2), ref1 = ref[0], requestHeaders = ref1.headers, requestCookies = ref1.cookies, ref1, ref2 = ref[1], responseHeaders = ref2.headers, responseCookies = ref2.cookies, ref2, ref;
        var event = _createEvent({
            url: request.url,
            method: request.method,
            status: response.status,
            requestHeaders: requestHeaders,
            responseHeaders: responseHeaders,
            requestCookies: requestCookies,
            responseCookies: responseCookies
        });
        (0, _core.captureEvent)(event);
    }
}
/**
 * Interceptor function for XHR requests
 *
 * @param xhr The XHR request
 * @param method The HTTP method
 * @param headers The HTTP headers
 */ function _xhrResponseHandler(options, xhr, method, headers) {
    if (_shouldCaptureResponse(options, xhr.status, xhr.responseURL)) {
        var requestHeaders, responseCookies, responseHeaders;
        if (_shouldSendDefaultPii()) {
            try {
                var cookieString = xhr.getResponseHeader('Set-Cookie') || xhr.getResponseHeader('set-cookie') || undefined;
                if (cookieString) responseCookies = _parseCookieString(cookieString);
            } catch (e) {
                (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log('Could not extract cookies from response headers');
            }
            try {
                responseHeaders = _getXHRResponseHeaders(xhr);
            } catch (e) {
                (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log('Could not extract headers from response');
            }
            requestHeaders = headers;
        }
        var event = _createEvent({
            url: xhr.responseURL,
            method: method,
            status: xhr.status,
            requestHeaders: requestHeaders,
            // Can't access request cookies from XHR
            responseHeaders: responseHeaders,
            responseCookies: responseCookies
        });
        (0, _core.captureEvent)(event);
    }
}
/**
 * Extracts response size from `Content-Length` header when possible
 *
 * @param headers
 * @returns The response size in bytes or undefined
 */ function _getResponseSizeFromHeaders(headers) {
    if (headers) {
        var contentLength = headers['Content-Length'] || headers['content-length'];
        if (contentLength) return parseInt(contentLength, 10);
    }
    return undefined;
}
/**
 * Creates an object containing cookies from the given cookie string
 *
 * @param cookieString The cookie string to parse
 * @returns The parsed cookies
 */ function _parseCookieString(cookieString) {
    return cookieString.split('; ').reduce(function(acc, cookie) {
        var _cookie_split = (0, _slicedToArray._)(cookie.split('='), 2), key = _cookie_split[0], value = _cookie_split[1];
        acc[key] = value;
        return acc;
    }, {});
}
/**
 * Extracts the headers as an object from the given Fetch API request or response object
 *
 * @param headers The headers to extract
 * @returns The extracted headers as an object
 */ function _extractFetchHeaders(headers) {
    var result = {};
    headers.forEach(function(value, key) {
        result[key] = value;
    });
    return result;
}
/**
 * Extracts the response headers as an object from the given XHR object
 *
 * @param xhr The XHR object to extract the response headers from
 * @returns The response headers as an object
 */ function _getXHRResponseHeaders(xhr) {
    var headers = xhr.getAllResponseHeaders();
    if (!headers) return {};
    return headers.split('\r\n').reduce(function(acc, line) {
        var _line_split = (0, _slicedToArray._)(line.split(': '), 2), key = _line_split[0], value = _line_split[1];
        acc[key] = value;
        return acc;
    }, {});
}
/**
 * Checks if the given target url is in the given list of targets
 *
 * @param target The target url to check
 * @returns true if the target url is in the given list of targets, false otherwise
 */ function _isInGivenRequestTargets(failedRequestTargets, target) {
    return failedRequestTargets.some(function(givenRequestTarget) {
        if (typeof givenRequestTarget === 'string') return target.includes(givenRequestTarget);
        return givenRequestTarget.test(target);
    });
}
/**
 * Checks if the given status code is in the given range
 *
 * @param status The status code to check
 * @returns true if the status code is in the given range, false otherwise
 */ function _isInGivenStatusRanges(failedRequestStatusCodes, status) {
    return failedRequestStatusCodes.some(function(range) {
        if (typeof range === 'number') return range === status;
        return status >= range[0] && status <= range[1];
    });
}
/**
 * Wraps `fetch` function to capture request and response data
 */ function _wrapFetch(client, options) {
    if (!(0, _utils.supportsNativeFetch)()) return;
    (0, _utils.addFetchInstrumentationHandler)(function(handlerData) {
        if ((0, _core.getClient)() !== client) return;
        var response = handlerData.response, args = handlerData.args;
        var _args = (0, _slicedToArray._)(args, 2), requestInfo = _args[0], requestInit = _args[1];
        if (!response) return;
        _fetchResponseHandler(options, requestInfo, response, requestInit);
    });
}
/**
 * Wraps XMLHttpRequest to capture request and response data
 */ function _wrapXHR(client, options) {
    if (!('XMLHttpRequest' in (0, _utils.GLOBAL_OBJ))) return;
    (0, _utils.addXhrInstrumentationHandler)(function(handlerData) {
        if ((0, _core.getClient)() !== client) return;
        var xhr = handlerData.xhr;
        var sentryXhrData = xhr[0, _utils.SENTRY_XHR_DATA_KEY];
        if (!sentryXhrData) return;
        var method = sentryXhrData.method, headers = sentryXhrData.request_headers;
        try {
            _xhrResponseHandler(options, xhr, method, headers);
        } catch (e) {
            (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn('Error while extracting response event form XHR response', e);
        }
    });
}
/**
 * Checks whether to capture given response as an event
 *
 * @param status response status code
 * @param url response url
 */ function _shouldCaptureResponse(options, status, url) {
    return _isInGivenStatusRanges(options.failedRequestStatusCodes, status) && _isInGivenRequestTargets(options.failedRequestTargets, url) && !(0, _core.isSentryRequestUrl)(url, (0, _core.getClient)());
}
/**
 * Creates a synthetic Sentry event from given response data
 *
 * @param data response data
 * @returns event
 */ function _createEvent(data) {
    var message = `HTTP Client Error with status code: ${data.status}`;
    var event = {
        message: message,
        exception: {
            values: [
                {
                    type: 'Error',
                    value: message
                }
            ]
        },
        request: {
            url: data.url,
            method: data.method,
            headers: data.requestHeaders,
            cookies: data.requestCookies
        },
        contexts: {
            response: {
                status_code: data.status,
                headers: data.responseHeaders,
                cookies: data.responseCookies,
                body_size: _getResponseSizeFromHeaders(data.responseHeaders)
            }
        }
    };
    (0, _utils.addExceptionMechanism)(event, {
        type: 'http.client',
        handled: false
    });
    return event;
}
function _getRequest(requestInfo, requestInit) {
    if (!requestInit && requestInfo instanceof Request) return requestInfo;
    // If both are set, we try to construct a new Request with the given arguments
    // However, if e.g. the original request has a `body`, this will throw an error because it was already accessed
    // In this case, as a fallback, we just use the original request - using both is rather an edge case
    if (requestInfo instanceof Request && requestInfo.bodyUsed) return requestInfo;
    return new Request(requestInfo, requestInit);
}
function _shouldSendDefaultPii() {
    var client = (0, _core.getClient)();
    return client ? Boolean(client.getOptions().sendDefaultPii) : false;
}

},{"@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_sliced_to_array":"ha6sq","@sentry/core":"8bBGI","@sentry/utils":"gElXU","./debug-build.js":"6i81I","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"bJLPv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ContextLines", function() {
    return ContextLines;
});
parcelHelpers.export(exports, "applySourceContextToFrame", function() {
    return applySourceContextToFrame;
});
parcelHelpers.export(exports, "contextLinesIntegration", function() {
    return contextLinesIntegration;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
var WINDOW = (0, _utils.GLOBAL_OBJ);
var DEFAULT_LINES_OF_CONTEXT = 7;
var INTEGRATION_NAME = 'ContextLines';
var _contextLinesIntegration = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var contextLines = options.frameContextLines != null ? options.frameContextLines : DEFAULT_LINES_OF_CONTEXT;
    return {
        name: INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce: function() {},
        processEvent: function(event) {
            return addSourceContext(event, contextLines);
        }
    };
};
var contextLinesIntegration = (0, _core.defineIntegration)(_contextLinesIntegration);
/**
 * Collects source context lines around the lines of stackframes pointing to JS embedded in
 * the current page's HTML.
 *
 * This integration DOES NOT work for stack frames pointing to JS files that are loaded by the browser.
 * For frames pointing to files, context lines are added during ingestion and symbolication
 * by attempting to download the JS files to the Sentry backend.
 *
 * Use this integration if you have inline JS code in HTML pages that can't be accessed
 * by our backend (e.g. due to a login-protected page).
 *
 * @deprecated Use `contextLinesIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
var ContextLines = (0, _core.convertIntegrationFnToClass)(INTEGRATION_NAME, contextLinesIntegration);
/**
 * Processes an event and adds context lines.
 */ function addSourceContext(event, contextLines) {
    var doc = WINDOW.document;
    var htmlFilename = WINDOW.location && (0, _utils.stripUrlQueryAndFragment)(WINDOW.location.href);
    if (!doc || !htmlFilename) return event;
    var exceptions = event.exception && event.exception.values;
    if (!exceptions || !exceptions.length) return event;
    var html = doc.documentElement.innerHTML;
    if (!html) return event;
    var htmlLines = [
        '<!DOCTYPE html>',
        '<html>'
    ].concat((0, _toConsumableArray._)(html.split('\n')), [
        '</html>'
    ]);
    exceptions.forEach(function(exception) {
        var stacktrace = exception.stacktrace;
        if (stacktrace && stacktrace.frames) stacktrace.frames = stacktrace.frames.map(function(frame) {
            return applySourceContextToFrame(frame, htmlLines, htmlFilename, contextLines);
        });
    });
    return event;
}
/**
 * Only exported for testing
 */ function applySourceContextToFrame(frame, htmlLines, htmlFilename, linesOfContext) {
    if (frame.filename !== htmlFilename || !frame.lineno || !htmlLines.length) return frame;
    (0, _utils.addContextToFrame)(htmlLines, frame, linesOfContext);
    return frame;
}

},{"@swc/helpers/_/_to_consumable_array":"eqNDD","@sentry/core":"8bBGI","@sentry/utils":"gElXU","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"5BwsG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createStore", function() {
    return createStore;
});
parcelHelpers.export(exports, "insert", function() {
    return insert;
});
parcelHelpers.export(exports, "makeBrowserOfflineTransport", function() {
    return makeBrowserOfflineTransport;
});
parcelHelpers.export(exports, "pop", function() {
    return pop;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
// 'Store', 'promisifyRequest' and 'createStore' were originally copied from the 'idb-keyval' package before being
// modified and simplified: https://github.com/jakearchibald/idb-keyval
//
// At commit: 0420a704fd6cbb4225429c536b1f61112d012fca
// Original licence:
// Copyright 2016, Jake Archibald
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//   http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
function promisifyRequest(request) {
    return new Promise(function(resolve, reject) {
        // @ts-expect-error - file size hacks
        request.oncomplete = request.onsuccess = function() {
            return resolve(request.result);
        };
        // @ts-expect-error - file size hacks
        request.onabort = request.onerror = function() {
            return reject(request.error);
        };
    });
}
/** Create or open an IndexedDb store */ function createStore(dbName, storeName) {
    var request = indexedDB.open(dbName);
    request.onupgradeneeded = function() {
        return request.result.createObjectStore(storeName);
    };
    var dbp = promisifyRequest(request);
    return function(callback) {
        return dbp.then(function(db) {
            return callback(db.transaction(storeName, 'readwrite').objectStore(storeName));
        });
    };
}
function keys(store) {
    return promisifyRequest(store.getAllKeys());
}
/** Insert into the store */ function insert(store, value, maxQueueSize) {
    return store(function(store) {
        return keys(store).then(function(keys) {
            var _Math;
            if (keys.length >= maxQueueSize) return;
            // We insert with an incremented key so that the entries are popped in order
            store.put(value, (_Math = Math).max.apply(_Math, (0, _toConsumableArray._)(keys).concat([
                0
            ])) + 1);
            return promisifyRequest(store.transaction);
        });
    });
}
/** Pop the oldest value from the store */ function pop(store) {
    return store(function(store) {
        return keys(store).then(function(keys) {
            if (keys.length === 0) return undefined;
            return promisifyRequest(store.get(keys[0])).then(function(value) {
                store.delete(keys[0]);
                return promisifyRequest(store.transaction).then(function() {
                    return value;
                });
            });
        });
    });
}
function createIndexedDbStore(options) {
    var store;
    // Lazily create the store only when it's needed
    function getStore() {
        if (store == undefined) store = createStore(options.dbName || 'sentry-offline', options.storeName || 'queue');
        return store;
    }
    return {
        insert: /*#__PURE__*/ function() {
            var _ref = (0, _asyncToGenerator._)(function(env) {
                var serialized, _;
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                (0, _utils.serializeEnvelope)(env, options.textEncoder)
                            ];
                        case 1:
                            serialized = _state.sent();
                            return [
                                4,
                                insert(getStore(), serialized, options.maxQueueSize || 30)
                            ];
                        case 2:
                            _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            _ = _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(env) {
                return _ref.apply(this, arguments);
            };
        }(),
        pop: /*#__PURE__*/ (0, _asyncToGenerator._)(function() {
            var deserialized, _;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            pop(getStore())
                        ];
                    case 1:
                        deserialized = _state.sent();
                        if (deserialized) return [
                            2,
                            (0, _utils.parseEnvelope)(deserialized, options.textEncoder || new TextEncoder(), options.textDecoder || new TextDecoder())
                        ];
                        return [
                            3,
                            3
                        ];
                    case 2:
                        _ = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2,
                            undefined
                        ];
                }
            });
        })
    };
}
function makeIndexedDbOfflineTransport(createTransport) {
    return function(options) {
        return createTransport((0, _objectSpreadProps._)((0, _objectSpread._)({}, options), {
            createStore: createIndexedDbStore
        }));
    };
}
/**
 * Creates a transport that uses IndexedDb to store events when offline.
 */ function makeBrowserOfflineTransport(createTransport) {
    return makeIndexedDbOfflineTransport((0, _core.makeOfflineTransport)(createTransport));
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_object_spread_props":"fLCYP","@swc/helpers/_/_to_consumable_array":"eqNDD","@swc/helpers/_/_ts_generator":"f2hGH","@sentry/core":"8bBGI","@sentry/utils":"gElXU","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"64Exn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "onProfilingStartRouteTransaction", function() {
    return onProfilingStartRouteTransaction;
});
parcelHelpers.export(exports, "startProfileForTransaction", function() {
    return startProfileForTransaction;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
var _debugBuildJs = require("../debug-build.js");
var _helpersJs = require("../helpers.js");
var _utilsJs = require("./utils.js");
/* eslint-disable complexity */ /**
 * Safety wrapper for startTransaction for the unlikely case that transaction starts before tracing is imported -
 * if that happens we want to avoid throwing an error from profiling code.
 * see https://github.com/getsentry/sentry-javascript/issues/4731.
 *
 * @experimental
 */ function onProfilingStartRouteTransaction(transaction) {
    if (!transaction) {
        if (0, _debugBuildJs.DEBUG_BUILD) (0, _utils.logger).log('[Profiling] Transaction is undefined, skipping profiling');
        return transaction;
    }
    if ((0, _utilsJs.shouldProfileTransaction)(transaction)) return startProfileForTransaction(transaction);
    return transaction;
}
/**
 * Wraps startTransaction and stopTransaction with profiling related logic.
 * startProfileForTransaction is called after the call to startTransaction in order to avoid our own code from
 * being profiled. Because of that same reason, stopProfiling is called before the call to stopTransaction.
 */ function startProfileForTransaction(transaction) {
    // Start the profiler and get the profiler instance.
    var startTimestamp;
    if ((0, _utilsJs.isAutomatedPageLoadTransaction)(transaction)) startTimestamp = (0, _utils.timestampInSeconds)() * 1000;
    var profiler = (0, _utilsJs.startJSSelfProfile)();
    // We failed to construct the profiler, fallback to original transaction.
    // No need to log anything as this has already been logged in startProfile.
    if (!profiler) return transaction;
    if (0, _debugBuildJs.DEBUG_BUILD) (0, _utils.logger).log(`[Profiling] started profiling transaction: ${(0, _core.spanToJSON)(transaction).description}`);
    // We create "unique" transaction names to avoid concurrent transactions with same names
    // from being ignored by the profiler. From here on, only this transaction name should be used when
    // calling the profiler methods. Note: we log the original name to the user to avoid confusion.
    var profileId = (0, _utils.uuid4)();
    function onProfileHandler() {
        return _onProfileHandler.apply(this, arguments);
    }
    function _onProfileHandler() {
        _onProfileHandler = /**
   * Idempotent handler for profile stop
   */ (0, _asyncToGenerator._)(function() {
            return (0, _tsGenerator._)(this, function(_state) {
                // Check if the profile exists and return it the behavior has to be idempotent as users may call transaction.finish multiple times.
                if (!transaction) return [
                    2,
                    null
                ];
                // Satisfy the type checker, but profiler will always be defined here.
                if (!profiler) return [
                    2,
                    null
                ];
                return [
                    2,
                    profiler.stop().then(function(profile) {
                        if (maxDurationTimeoutID) {
                            (0, _helpersJs.WINDOW).clearTimeout(maxDurationTimeoutID);
                            maxDurationTimeoutID = undefined;
                        }
                        if (0, _debugBuildJs.DEBUG_BUILD) (0, _utils.logger).log(`[Profiling] stopped profiling of transaction: ${(0, _core.spanToJSON)(transaction).description}`);
                        // In case of an overlapping transaction, stopProfiling may return null and silently ignore the overlapping profile.
                        if (!profile) {
                            if (0, _debugBuildJs.DEBUG_BUILD) (0, _utils.logger).log(`[Profiling] profiler returned null profile for: ${(0, _core.spanToJSON)(transaction).description}`, 'this may indicate an overlapping transaction or a call to stopProfiling with a profile title that was never started');
                            return null;
                        }
                        (0, _utilsJs.addProfileToGlobalCache)(profileId, profile);
                        return null;
                    }).catch(function(error) {
                        if (0, _debugBuildJs.DEBUG_BUILD) (0, _utils.logger).log('[Profiling] error while stopping profiler:', error);
                        return null;
                    })
                ];
            });
        });
        return _onProfileHandler.apply(this, arguments);
    }
    // Enqueue a timeout to prevent profiles from running over max duration.
    var maxDurationTimeoutID = (0, _helpersJs.WINDOW).setTimeout(function() {
        if (0, _debugBuildJs.DEBUG_BUILD) (0, _utils.logger).log('[Profiling] max profile duration elapsed, stopping profiling for:', (0, _core.spanToJSON)(transaction).description);
        // If the timeout exceeds, we want to stop profiling, but not finish the transaction
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        onProfileHandler();
    }, (0, _utilsJs.MAX_PROFILE_DURATION_MS));
    // We need to reference the original end call to avoid creating an infinite loop
    var originalEnd = transaction.end.bind(transaction);
    /**
   * Wraps startTransaction and stopTransaction with profiling related logic.
   * startProfiling is called after the call to startTransaction in order to avoid our own code from
   * being profiled. Because of that same reason, stopProfiling is called before the call to stopTransaction.
   */ function profilingWrappedTransactionEnd() {
        if (!transaction) return originalEnd();
        // onProfileHandler should always return the same profile even if this is called multiple times.
        // Always call onProfileHandler to ensure stopProfiling is called and the timeout is cleared.
        onProfileHandler().then(function() {
            // TODO: Can we rewrite this to use attributes?
            // eslint-disable-next-line deprecation/deprecation
            transaction.setContext('profile', {
                profile_id: profileId,
                start_timestamp: startTimestamp
            });
            originalEnd();
        }, function() {
            // If onProfileHandler fails, we still want to call the original finish method.
            originalEnd();
        });
        return transaction;
    }
    transaction.end = profilingWrappedTransactionEnd;
    return transaction;
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_ts_generator":"f2hGH","@sentry/core":"8bBGI","@sentry/utils":"gElXU","../debug-build.js":"3hH8w","../helpers.js":"gFT9f","./utils.js":"8dNzY","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8dNzY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MAX_PROFILE_DURATION_MS", function() {
    return MAX_PROFILE_DURATION_MS;
});
parcelHelpers.export(exports, "addProfileToGlobalCache", function() {
    return addProfileToGlobalCache;
});
parcelHelpers.export(exports, "addProfilesToEnvelope", function() {
    return addProfilesToEnvelope;
});
parcelHelpers.export(exports, "applyDebugMetadata", function() {
    return applyDebugMetadata;
});
parcelHelpers.export(exports, "convertJSSelfProfileToSampledFormat", function() {
    return convertJSSelfProfileToSampledFormat;
});
parcelHelpers.export(exports, "createProfilePayload", function() {
    return createProfilePayload;
});
parcelHelpers.export(exports, "createProfilingEvent", function() {
    return createProfilingEvent;
});
parcelHelpers.export(exports, "enrichWithThreadInformation", function() {
    return enrichWithThreadInformation;
});
parcelHelpers.export(exports, "findProfiledTransactionsFromEnvelope", function() {
    return findProfiledTransactionsFromEnvelope;
});
parcelHelpers.export(exports, "getActiveProfilesCount", function() {
    return getActiveProfilesCount;
});
parcelHelpers.export(exports, "isAutomatedPageLoadTransaction", function() {
    return isAutomatedPageLoadTransaction;
});
parcelHelpers.export(exports, "isValidSampleRate", function() {
    return isValidSampleRate;
});
parcelHelpers.export(exports, "shouldProfileTransaction", function() {
    return shouldProfileTransaction;
});
parcelHelpers.export(exports, "startJSSelfProfile", function() {
    return startJSSelfProfile;
});
parcelHelpers.export(exports, "takeProfileFromGlobalCache", function() {
    return takeProfileFromGlobalCache;
});
var _defineProperty = require("@swc/helpers/_/_define_property");
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
var _debugBuildJs = require("../debug-build.js");
var _helpersJs = require("../helpers.js");
/* eslint-disable max-lines */ var MS_TO_NS = 1e6;
// Use 0 as main thread id which is identical to threadId in node:worker_threads
// where main logs 0 and workers seem to log in increments of 1
var THREAD_ID_STRING = String(0);
var THREAD_NAME = 'main';
// Machine properties (eval only once)
var OS_PLATFORM = '';
var OS_PLATFORM_VERSION = '';
var OS_ARCH = '';
var OS_BROWSER = (0, _helpersJs.WINDOW).navigator && (0, _helpersJs.WINDOW).navigator.userAgent || '';
var OS_MODEL = '';
var OS_LOCALE = (0, _helpersJs.WINDOW).navigator && (0, _helpersJs.WINDOW).navigator.language || (0, _helpersJs.WINDOW).navigator && (0, _helpersJs.WINDOW).navigator.languages && (0, _helpersJs.WINDOW).navigator.languages[0] || '';
function isUserAgentData(data) {
    return typeof data === 'object' && data !== null && 'getHighEntropyValues' in data;
}
// @ts-expect-error userAgentData is not part of the navigator interface yet
var userAgentData = (0, _helpersJs.WINDOW).navigator && (0, _helpersJs.WINDOW).navigator.userAgentData;
if (isUserAgentData(userAgentData)) userAgentData.getHighEntropyValues([
    'architecture',
    'model',
    'platform',
    'platformVersion',
    'fullVersionList'
]).then(function(ua) {
    OS_PLATFORM = ua.platform || '';
    OS_ARCH = ua.architecture || '';
    OS_MODEL = ua.model || '';
    OS_PLATFORM_VERSION = ua.platformVersion || '';
    if (ua.fullVersionList && ua.fullVersionList.length > 0) {
        var firstUa = ua.fullVersionList[ua.fullVersionList.length - 1];
        OS_BROWSER = `${firstUa.brand} ${firstUa.version}`;
    }
}).catch(function(e) {
    return void 0;
});
function isProcessedJSSelfProfile(profile) {
    return !('thread_metadata' in profile);
}
// Enriches the profile with threadId of the current thread.
// This is done in node as we seem to not be able to get the info from C native code.
/**
 *
 */ function enrichWithThreadInformation(profile) {
    if (!isProcessedJSSelfProfile(profile)) return profile;
    return convertJSSelfProfileToSampledFormat(profile);
}
// Profile is marked as optional because it is deleted from the metadata
// by the integration before the event is processed by other integrations.
function getTraceId(event) {
    var traceId = event && event.contexts && event.contexts['trace'] && event.contexts['trace']['trace_id'];
    // Log a warning if the profile has an invalid traceId (should be uuidv4).
    // All profiles and transactions are rejected if this is the case and we want to
    // warn users that this is happening if they enable debug flag
    if (typeof traceId === 'string' && traceId.length !== 32) {
        if (0, _debugBuildJs.DEBUG_BUILD) (0, _utils.logger).log(`[Profiling] Invalid traceId: ${traceId} on profiled event`);
    }
    if (typeof traceId !== 'string') return '';
    return traceId;
}
/**
 * Creates a profiling event envelope from a Sentry event. If profile does not pass
 * validation, returns null.
 * @param event
 * @param dsn
 * @param metadata
 * @param tunnel
 * @returns {EventEnvelope | null}
 */ /**
 * Creates a profiling event envelope from a Sentry event.
 */ function createProfilePayload(profile_id, start_timestamp, processed_profile, event) {
    if (event.type !== 'transaction') // createProfilingEventEnvelope should only be called for transactions,
    // we type guard this behavior with isProfiledTransactionEvent.
    throw new TypeError('Profiling events may only be attached to transactions, this should never occur.');
    if (processed_profile === undefined || processed_profile === null) throw new TypeError(`Cannot construct profiling event envelope without a valid profile. Got ${processed_profile} instead.`);
    var traceId = getTraceId(event);
    var enrichedThreadProfile = enrichWithThreadInformation(processed_profile);
    var transactionStartMs = start_timestamp ? start_timestamp : typeof event.start_timestamp === 'number' ? event.start_timestamp * 1000 : Date.now();
    var transactionEndMs = typeof event.timestamp === 'number' ? event.timestamp * 1000 : Date.now();
    var profile = {
        event_id: profile_id,
        timestamp: new Date(transactionStartMs).toISOString(),
        platform: 'javascript',
        version: '1',
        release: event.release || '',
        environment: event.environment || (0, _core.DEFAULT_ENVIRONMENT),
        runtime: {
            name: 'javascript',
            version: (0, _helpersJs.WINDOW).navigator.userAgent
        },
        os: {
            name: OS_PLATFORM,
            version: OS_PLATFORM_VERSION,
            build_number: OS_BROWSER
        },
        device: {
            locale: OS_LOCALE,
            model: OS_MODEL,
            manufacturer: OS_BROWSER,
            architecture: OS_ARCH,
            is_emulator: false
        },
        debug_meta: {
            images: applyDebugMetadata(processed_profile.resources)
        },
        profile: enrichedThreadProfile,
        transactions: [
            {
                name: event.transaction || '',
                id: event.event_id || (0, _utils.uuid4)(),
                trace_id: traceId,
                active_thread_id: THREAD_ID_STRING,
                relative_start_ns: '0',
                relative_end_ns: ((transactionEndMs - transactionStartMs) * 1e6).toFixed(0)
            }
        ]
    };
    return profile;
}
/*
  See packages/tracing-internal/src/browser/router.ts
*/ /**
 *
 */ function isAutomatedPageLoadTransaction(transaction) {
    return transaction.op === 'pageload';
}
/**
 * Converts a JSSelfProfile to a our sampled format.
 * Does not currently perform stack indexing.
 */ function convertJSSelfProfileToSampledFormat(input) {
    var EMPTY_STACK_ID = undefined;
    var STACK_ID = 0;
    // Initialize the profile that we will fill with data
    var profile = {
        samples: [],
        stacks: [],
        frames: [],
        thread_metadata: (0, _defineProperty._)({}, THREAD_ID_STRING, {
            name: THREAD_NAME
        })
    };
    if (!input.samples.length) return profile;
    // We assert samples.length > 0 above and timestamp should always be present
    var start = input.samples[0].timestamp;
    // The JS SDK might change it's time origin based on some heuristic (see See packages/utils/src/time.ts)
    // when that happens, we need to ensure we are correcting the profile timings so the two timelines stay in sync.
    // Since JS self profiling time origin is always initialized to performance.timeOrigin, we need to adjust for
    // the drift between the SDK selected value and our profile time origin.
    var origin = typeof performance.timeOrigin === 'number' ? performance.timeOrigin : (0, _utils.browserPerformanceTimeOrigin) || 0;
    var adjustForOriginChange = origin - ((0, _utils.browserPerformanceTimeOrigin) || origin);
    for(var i = 0; i < input.samples.length; i++){
        var jsSample = input.samples[i];
        // If sample has no stack, add an empty sample
        if (jsSample.stackId === undefined) {
            if (EMPTY_STACK_ID === undefined) {
                EMPTY_STACK_ID = STACK_ID;
                profile.stacks[EMPTY_STACK_ID] = [];
                STACK_ID++;
            }
            profile['samples'][i] = {
                // convert ms timestamp to ns
                elapsed_since_start_ns: ((jsSample.timestamp + adjustForOriginChange - start) * MS_TO_NS).toFixed(0),
                stack_id: EMPTY_STACK_ID,
                thread_id: THREAD_ID_STRING
            };
            continue;
        }
        var stackTop = input.stacks[jsSample.stackId];
        // Functions in top->down order (root is last)
        // We follow the stackTop.parentId trail and collect each visited frameId
        var stack = [];
        while(stackTop){
            stack.push(stackTop.frameId);
            var frame = input.frames[stackTop.frameId];
            // If our frame has not been indexed yet, index it
            if (profile.frames[stackTop.frameId] === undefined) profile.frames[stackTop.frameId] = {
                function: frame.name,
                abs_path: typeof frame.resourceId === 'number' ? input.resources[frame.resourceId] : undefined,
                lineno: frame.line,
                colno: frame.column
            };
            stackTop = stackTop.parentId === undefined ? undefined : input.stacks[stackTop.parentId];
        }
        var sample = {
            // convert ms timestamp to ns
            elapsed_since_start_ns: ((jsSample.timestamp + adjustForOriginChange - start) * MS_TO_NS).toFixed(0),
            stack_id: STACK_ID,
            thread_id: THREAD_ID_STRING
        };
        profile['stacks'][STACK_ID] = stack;
        profile['samples'][i] = sample;
        STACK_ID++;
    }
    return profile;
}
/**
 * Adds items to envelope if they are not already present - mutates the envelope.
 * @param envelope
 */ function addProfilesToEnvelope(envelope, profiles) {
    if (!profiles.length) return envelope;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = profiles[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var profile = _step.value;
            envelope[1].push([
                {
                    type: 'profile'
                },
                profile
            ]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return envelope;
}
/**
 * Finds transactions with profile_id context in the envelope
 * @param envelope
 * @returns
 */ function findProfiledTransactionsFromEnvelope(envelope) {
    var events = [];
    (0, _utils.forEachEnvelopeItem)(envelope, function(item, type) {
        if (type !== 'transaction') return;
        for(var j = 1; j < item.length; j++){
            var event = item[j];
            if (event && event.contexts && event.contexts['profile'] && event.contexts['profile']['profile_id']) events.push(item[j]);
        }
    });
    return events;
}
var debugIdStackParserCache = new WeakMap();
/**
 * Applies debug meta data to an event from a list of paths to resources (sourcemaps)
 */ function applyDebugMetadata(resource_paths) {
    var debugIdMap = (0, _utils.GLOBAL_OBJ)._sentryDebugIds;
    if (!debugIdMap) return [];
    var client = (0, _core.getClient)();
    var options = client && client.getOptions();
    var stackParser = options && options.stackParser;
    if (!stackParser) return [];
    var debugIdStackFramesCache;
    var cachedDebugIdStackFrameCache = debugIdStackParserCache.get(stackParser);
    if (cachedDebugIdStackFrameCache) debugIdStackFramesCache = cachedDebugIdStackFrameCache;
    else {
        debugIdStackFramesCache = new Map();
        debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
    }
    // Build a map of filename -> debug_id
    var filenameDebugIdMap = Object.keys(debugIdMap).reduce(function(acc, debugIdStackTrace) {
        var parsedStack;
        var cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
        if (cachedParsedStack) parsedStack = cachedParsedStack;
        else {
            parsedStack = stackParser(debugIdStackTrace);
            debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
        }
        for(var i = parsedStack.length - 1; i >= 0; i--){
            var stackFrame = parsedStack[i];
            var file = stackFrame && stackFrame.filename;
            if (stackFrame && file) {
                acc[file] = debugIdMap[debugIdStackTrace];
                break;
            }
        }
        return acc;
    }, {});
    var images = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = resource_paths[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var path = _step.value;
            if (path && filenameDebugIdMap[path]) images.push({
                type: 'sourcemap',
                code_file: path,
                debug_id: filenameDebugIdMap[path]
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return images;
}
/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */ function isValidSampleRate(rate) {
    // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
    if (typeof rate !== 'number' && typeof rate !== 'boolean' || typeof rate === 'number' && isNaN(rate)) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn(`[Profiling] Invalid sample rate. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(rate)} of type ${JSON.stringify(typeof rate)}.`);
        return false;
    }
    // Boolean sample rates are always valid
    if (rate === true || rate === false) return true;
    // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
    if (rate < 0 || rate > 1) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn(`[Profiling] Invalid sample rate. Sample rate must be between 0 and 1. Got ${rate}.`);
        return false;
    }
    return true;
}
function isValidProfile(profile) {
    if (profile.samples.length < 2) {
        if (0, _debugBuildJs.DEBUG_BUILD) // Log a warning if the profile has less than 2 samples so users can know why
        // they are not seeing any profiling data and we cant avoid the back and forth
        // of asking them to provide us with a dump of the profile data.
        (0, _utils.logger).log('[Profiling] Discarding profile because it contains less than 2 samples');
        return false;
    }
    if (!profile.frames.length) {
        if (0, _debugBuildJs.DEBUG_BUILD) (0, _utils.logger).log('[Profiling] Discarding profile because it contains no frames');
        return false;
    }
    return true;
}
// Keep a flag value to avoid re-initializing the profiler constructor. If it fails
// once, it will always fail and this allows us to early return.
var PROFILING_CONSTRUCTOR_FAILED = false;
var MAX_PROFILE_DURATION_MS = 30000;
/**
 * Check if profiler constructor is available.
 * @param maybeProfiler
 */ function isJSProfilerSupported(maybeProfiler) {
    return typeof maybeProfiler === 'function';
}
/**
 * Starts the profiler and returns the profiler instance.
 */ function startJSSelfProfile() {
    // Feature support check first
    var JSProfilerConstructor = (0, _helpersJs.WINDOW).Profiler;
    if (!isJSProfilerSupported(JSProfilerConstructor)) {
        if (0, _debugBuildJs.DEBUG_BUILD) (0, _utils.logger).log('[Profiling] Profiling is not supported by this browser, Profiler interface missing on window object.');
        return;
    }
    // From initial testing, it seems that the minimum value for sampleInterval is 10ms.
    var samplingIntervalMS = 10;
    // Start the profiler
    var maxSamples = Math.floor(MAX_PROFILE_DURATION_MS / samplingIntervalMS);
    // Attempt to initialize the profiler constructor, if it fails, we disable profiling for the current user session.
    // This is likely due to a missing 'Document-Policy': 'js-profiling' header. We do not want to throw an error if this happens
    // as we risk breaking the user's application, so just disable profiling and log an error.
    try {
        return new JSProfilerConstructor({
            sampleInterval: samplingIntervalMS,
            maxBufferSize: maxSamples
        });
    } catch (e) {
        if (0, _debugBuildJs.DEBUG_BUILD) {
            (0, _utils.logger).log("[Profiling] Failed to initialize the Profiling constructor, this is likely due to a missing 'Document-Policy': 'js-profiling' header.");
            (0, _utils.logger).log('[Profiling] Disabling profiling for current user session.');
        }
        PROFILING_CONSTRUCTOR_FAILED = true;
    }
    return;
}
/**
 * Determine if a profile should be profiled.
 */ function shouldProfileTransaction(transaction) {
    // If constructor failed once, it will always fail, so we can early return.
    if (PROFILING_CONSTRUCTOR_FAILED) {
        if (0, _debugBuildJs.DEBUG_BUILD) (0, _utils.logger).log('[Profiling] Profiling has been disabled for the duration of the current user session.');
        return false;
    }
    if (!transaction.isRecording()) {
        if (0, _debugBuildJs.DEBUG_BUILD) (0, _utils.logger).log('[Profiling] Discarding profile because transaction was not sampled.');
        return false;
    }
    var client = (0, _core.getClient)();
    var options = client && client.getOptions();
    if (!options) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log('[Profiling] Profiling disabled, no options found.');
        return false;
    }
    // @ts-expect-error profilesSampleRate is not part of the browser options yet
    var profilesSampleRate = options.profilesSampleRate;
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
    // only valid values are booleans or numbers between 0 and 1.)
    if (!isValidSampleRate(profilesSampleRate)) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).warn('[Profiling] Discarding profile because of invalid sample rate.');
        return false;
    }
    // if the function returned 0 (or false), or if `profileSampleRate` is 0, it's a sign the profile should be dropped
    if (!profilesSampleRate) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log('[Profiling] Discarding profile because a negative sampling decision was inherited or profileSampleRate is set to 0');
        return false;
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    var sampled = profilesSampleRate === true ? true : Math.random() < profilesSampleRate;
    // Check if we should sample this profile
    if (!sampled) {
        (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log(`[Profiling] Discarding profile because it's not included in the random sample (sampling rate = ${Number(profilesSampleRate)})`);
        return false;
    }
    return true;
}
/**
 * Creates a profiling envelope item, if the profile does not pass validation, returns null.
 * @param event
 * @returns {Profile | null}
 */ function createProfilingEvent(profile_id, start_timestamp, profile, event) {
    if (!isValidProfile(profile)) return null;
    return createProfilePayload(profile_id, start_timestamp, profile, event);
}
// TODO (v8): We need to obtain profile ids in @sentry-internal/tracing,
// but we don't have access to this map because importing this map would
// cause a circular dependancy. We need to resolve this in v8.
var PROFILE_MAP = new Map();
/**
 *
 */ function getActiveProfilesCount() {
    return PROFILE_MAP.size;
}
/**
 * Retrieves profile from global cache and removes it.
 */ function takeProfileFromGlobalCache(profile_id) {
    var profile = PROFILE_MAP.get(profile_id);
    if (profile) PROFILE_MAP.delete(profile_id);
    return profile;
}
/**
 * Adds profile to global cache and evicts the oldest profile if the cache is full.
 */ function addProfileToGlobalCache(profile_id, profile) {
    PROFILE_MAP.set(profile_id, profile);
    if (PROFILE_MAP.size > 30) {
        var last = PROFILE_MAP.keys().next().value;
        PROFILE_MAP.delete(last);
    }
}

},{"@swc/helpers/_/_define_property":"54Zvk","@sentry/core":"8bBGI","@sentry/utils":"gElXU","../debug-build.js":"3hH8w","../helpers.js":"gFT9f","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"kh9Z4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// eslint-disable-next-line deprecation/deprecation
parcelHelpers.export(exports, "BrowserProfilingIntegration", function() {
    return BrowserProfilingIntegration;
});
parcelHelpers.export(exports, "browserProfilingIntegration", function() {
    return browserProfilingIntegration;
});
var _core = require("@sentry/core");
var _utils = require("@sentry/utils");
var _debugBuildJs = require("../debug-build.js");
var _hubextensionsJs = require("./hubextensions.js");
var _utilsJs = require("./utils.js");
var INTEGRATION_NAME = 'BrowserProfiling';
var _browserProfilingIntegration = function() {
    return {
        name: INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce: function() {},
        setup: function(client) {
            var scope = (0, _core.getCurrentScope)();
            // eslint-disable-next-line deprecation/deprecation
            var transaction = scope.getTransaction();
            if (transaction && (0, _utilsJs.isAutomatedPageLoadTransaction)(transaction)) {
                if ((0, _utilsJs.shouldProfileTransaction)(transaction)) (0, _hubextensionsJs.startProfileForTransaction)(transaction);
            }
            if (typeof client.on !== 'function') {
                (0, _utils.logger).warn('[Profiling] Client does not support hooks, profiling will be disabled');
                return;
            }
            client.on('startTransaction', function(transaction) {
                if ((0, _utilsJs.shouldProfileTransaction)(transaction)) (0, _hubextensionsJs.startProfileForTransaction)(transaction);
            });
            client.on('beforeEnvelope', function(envelope) {
                // if not profiles are in queue, there is nothing to add to the envelope.
                if (!(0, _utilsJs.getActiveProfilesCount)()) return;
                var profiledTransactionEvents = (0, _utilsJs.findProfiledTransactionsFromEnvelope)(envelope);
                if (!profiledTransactionEvents.length) return;
                var profilesToAddToEnvelope = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = profiledTransactionEvents[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var profiledTransaction = _step.value;
                        var context = profiledTransaction && profiledTransaction.contexts;
                        var profile_id = context && context['profile'] && context['profile']['profile_id'];
                        var start_timestamp = context && context['profile'] && context['profile']['start_timestamp'];
                        if (typeof profile_id !== 'string') {
                            (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log('[Profiling] cannot find profile for a transaction without a profile context');
                            continue;
                        }
                        if (!profile_id) {
                            (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log('[Profiling] cannot find profile for a transaction without a profile context');
                            continue;
                        }
                        // Remove the profile from the transaction context before sending, relay will take care of the rest.
                        if (context && context['profile']) delete context.profile;
                        var profile = (0, _utilsJs.takeProfileFromGlobalCache)(profile_id);
                        if (!profile) {
                            (0, _debugBuildJs.DEBUG_BUILD) && (0, _utils.logger).log(`[Profiling] Could not retrieve profile for transaction: ${profile_id}`);
                            continue;
                        }
                        var profileEvent = (0, _utilsJs.createProfilingEvent)(profile_id, start_timestamp, profile, profiledTransaction);
                        if (profileEvent) profilesToAddToEnvelope.push(profileEvent);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                (0, _utilsJs.addProfilesToEnvelope)(envelope, profilesToAddToEnvelope);
            });
        }
    };
};
var browserProfilingIntegration = (0, _core.defineIntegration)(_browserProfilingIntegration);
/**
 * Browser profiling integration. Stores any event that has contexts["profile"]["profile_id"]
 * This exists because we do not want to await async profiler.stop calls as transaction.finish is called
 * in a synchronous context. Instead, we handle sending the profile async from the promise callback and
 * rely on being able to pull the event from the cache when we need to construct the envelope. This makes the
 * integration less reliable as we might be dropping profiles when the cache is full.
 *
 * @experimental
 * @deprecated Use `browserProfilingIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
var BrowserProfilingIntegration = (0, _core.convertIntegrationFnToClass)(INTEGRATION_NAME, browserProfilingIntegration);

},{"@sentry/core":"8bBGI","@sentry/utils":"gElXU","../debug-build.js":"3hH8w","./hubextensions.js":"64Exn","./utils.js":"8dNzY","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"9JzsQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "prepareDeps", function() {
    return prepareDeps;
});
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _wrapGetState = require("../../std/wrapGetState");
var _request = require("./request");
var _std = require("@reglo/std");
var _isLoggedIn = require("./isLoggedIn");
var _publishEvent = require("./publishEvent");
var _retrieveCustomer = require("./retrieveCustomer");
var _retrieveCustomerSubscriptions = require("./retrieveCustomerSubscriptions");
var _getRechargeCredentials = require("./getRechargeCredentials");
var _retrieveCustomerOrders = require("./retrieveCustomerOrders");
var _retrieveIntakeCalculatorData = require("./retrieveIntakeCalculatorData");
var _executeCommand = require("./executeCommand");
var _apiRequest = require("./apiRequest");
var _updateSubscriptionsDate = require("./updateSubscriptionsDate");
var _disableSubscriptions = require("./disableSubscriptions");
var _enableSubscription = require("./enableSubscription");
var _logIn = require("./logIn");
var _sendRecoverPasswordEmail = require("./sendRecoverPasswordEmail");
var _createAccount = require("./createAccount");
var _doesCustomerHasAccount = require("./doesCustomerHasAccount");
var _sendAccountActivationEmail = require("./sendAccountActivationEmail");
var _updateSubscriptionQuantity = require("./updateSubscriptionQuantity");
var _retrieveShippingRates = require("./retrieveShippingRates");
var _track = require("./track");
var _updateShippingAddress = require("./updateShippingAddress");
var _updateSubscriptionFrequency = require("./updateSubscriptionFrequency");
var _addProductToSubscription = require("./addProductToSubscription");
var _swapProductToSubscription = require("./swapProductToSubscription");
var _sections = require("../../../../sections");
var _location = require("./location");
var _components = require("../../../../snippets/components");
function prepareDeps(store, eventBus) {
    var ref = {
        deps: {}
    };
    ref.deps = depsContainer((0, _objectSpreadProps._)((0, _objectSpread._)({}, (0, _sections.sectionsDeps)(ref), (0, _components.componentsDeps)(ref)), {
        getState: function() {
            return (0, _wrapGetState.wrapGetState)(store.getState);
        },
        request: function() {
            return (0, _request.request)(ref.deps);
        },
        debounce: function() {
            return debounceInstance;
        },
        waitAtLeast: function() {
            return 0, _std.waitAtLeast;
        },
        wait: function() {
            return 0, _std.wait;
        },
        eventBus: function() {
            return eventBus;
        },
        isLoggedIn: function() {
            return (0, _isLoggedIn.isLoggedIn)(ref.deps);
        },
        publishEvent: function() {
            return (0, _publishEvent.publishEvent)(store);
        },
        retrieveCustomer: function() {
            return (0, _retrieveCustomer.retrieveCustomer)(ref.deps);
        },
        retrieveCustomerOrders: function() {
            return (0, _retrieveCustomerOrders.retrieveCustomerOrders)(ref.deps);
        },
        retrieveCustomerSubscriptions: function() {
            return (0, _retrieveCustomerSubscriptions.retrieveCustomerSubscriptions)(ref.deps);
        },
        getRechargeCredentials: function() {
            return (0, _getRechargeCredentials.getRechargeCredentials)(ref.deps);
        },
        retrieveIntakeCalculatorData: function() {
            return (0, _retrieveIntakeCalculatorData.retrieveIntakeCalculatorData)(ref.deps);
        },
        executeCommand: function() {
            return (0, _executeCommand.executeCommand)(ref.deps);
        },
        apiRequest: function() {
            return (0, _apiRequest.apiRequest)(ref.deps);
        },
        updateSubscriptionsDate: function() {
            return (0, _updateSubscriptionsDate.updateSubscriptionsDate)(ref.deps);
        },
        disableSubscriptions: function() {
            return (0, _disableSubscriptions.disableSubscriptions)(ref.deps);
        },
        enableSubscription: function() {
            return (0, _enableSubscription.enableSubscription)(ref.deps);
        },
        updateSubscriptionQuantity: function() {
            return (0, _updateSubscriptionQuantity.updateSubscriptionQuantity)(ref.deps);
        },
        logIn: function() {
            return (0, _logIn.logIn)(ref.deps);
        },
        sendRecoverPasswordEmail: function() {
            return (0, _sendRecoverPasswordEmail.sendRecoverPasswordEmail)(ref.deps);
        },
        createAccount: function() {
            return (0, _createAccount.createAccount)(ref.deps);
        },
        sendAccountActivationEmail: function() {
            return (0, _sendAccountActivationEmail.sendAccountActivationEmail)(ref.deps);
        },
        doesCustomerHasAccount: function() {
            return (0, _doesCustomerHasAccount.doesCustomerHasAccount)(ref.deps);
        },
        retrieveShippingRates: function() {
            return (0, _retrieveShippingRates.retrieveShippingRates)(ref.deps);
        },
        track: function() {
            return (0, _track.track)(ref.deps);
        },
        updateShippingAddress: function() {
            return (0, _updateShippingAddress.updateShippingAddress)(ref.deps);
        },
        updateSubscriptionFrequency: function() {
            return (0, _updateSubscriptionFrequency.updateSubscriptionFrequency)(ref.deps);
        },
        addProductToSubscription: function() {
            return (0, _addProductToSubscription.addProductToSubscription)(ref.deps);
        },
        swapProductToSubscription: function() {
            return (0, _swapProductToSubscription.swapProductToSubscription)(ref.deps);
        },
        location: function() {
            return (0, _location.location)(ref.deps);
        }
    }));
    var debounceInstance = (0, _std.debounce)(ref.deps.publishEvent);
    return ref.deps;
}
function depsContainer(constructors) {
    var instances = {};
    return new Proxy(constructors, {
        get: function(constructors, name) {
            if (!instances[name]) instances[name] = constructors[name]();
            return instances[name];
        }
    });
}

},{"@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_object_spread_props":"fLCYP","../../std/wrapGetState":"IKLkJ","./request":"cJ7hw","@reglo/std":"1USo0","./isLoggedIn":"8hbwz","./publishEvent":"8EDpC","./retrieveCustomer":"4oFs9","./retrieveCustomerSubscriptions":"i2ph9","./getRechargeCredentials":"2kHxh","./retrieveCustomerOrders":"4Yowr","./retrieveIntakeCalculatorData":"iGuSP","./executeCommand":"2z7eK","./apiRequest":"1L5FL","./updateSubscriptionsDate":"3ltHV","./disableSubscriptions":"b17Tm","./enableSubscription":"krepr","./logIn":"1N1UZ","./sendRecoverPasswordEmail":"32j87","./createAccount":"g7bud","./doesCustomerHasAccount":"l23vG","./sendAccountActivationEmail":"bH4lH","./updateSubscriptionQuantity":"80J3A","./retrieveShippingRates":"6bGCj","./track":"1rlsk","./updateShippingAddress":"251TQ","./updateSubscriptionFrequency":"7iLIq","./addProductToSubscription":"57slY","./swapProductToSubscription":"7zRx2","../../../../sections":"8H2M7","./location":"lNiJa","../../../../snippets/components":"1f8Ky","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"IKLkJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "wrapGetState", function() {
    return wrapGetState;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
function wrapGetState(getState) {
    return function(selector) {
        for(var _len = arguments.length, parameters = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            parameters[_key - 1] = arguments[_key];
        }
        return selector.apply(void 0, [
            getState()
        ].concat((0, _toConsumableArray._)(parameters)));
    };
}

},{"@swc/helpers/_/_to_consumable_array":"eqNDD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"cJ7hw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "request", function() {
    return request;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
function request(deps) {
    return {
        getRequest: getRequest,
        getRequestRaw: getRequestRaw,
        postRequest: postRequest,
        postWithResponse: postWithResponse,
        deleteRequest: deleteRequest
    };
    function getRequest(url) {
        return _getRequest.apply(this, arguments);
    }
    function _getRequest() {
        _getRequest = (0, _asyncToGenerator._)(function(url) {
            var response;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetch(url, {
                                credentials: 'same-origin'
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        return [
                            2,
                            response.json()
                        ];
                }
            });
        });
        return _getRequest.apply(this, arguments);
    }
    function getRequestRaw(url) {
        return _getRequestRaw.apply(this, arguments);
    }
    function _getRequestRaw() {
        _getRequestRaw = (0, _asyncToGenerator._)(function(url) {
            var response;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetch(url, {
                                credentials: 'same-origin'
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        return [
                            2,
                            response.text()
                        ];
                }
            });
        });
        return _getRequestRaw.apply(this, arguments);
    }
    function postRequest(url, data) {
        return _postRequest.apply(this, arguments);
    }
    function _postRequest() {
        _postRequest = (0, _asyncToGenerator._)(function(url, data) {
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            executePost(url, data)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return _postRequest.apply(this, arguments);
    }
    function postWithResponse(url, data) {
        return _postWithResponse.apply(this, arguments);
    }
    function _postWithResponse() {
        _postWithResponse = (0, _asyncToGenerator._)(function(url, data) {
            var response;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            executePost(url, data)
                        ];
                    case 1:
                        response = _state.sent();
                        return [
                            2,
                            response.json()
                        ];
                }
            });
        });
        return _postWithResponse.apply(this, arguments);
    }
    function deleteRequest(url) {
        return _deleteRequest.apply(this, arguments);
    }
    function _deleteRequest() {
        _deleteRequest = (0, _asyncToGenerator._)(function(url) {
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            executeDelete(url)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return _deleteRequest.apply(this, arguments);
    }
    function executePost(url, data) {
        return _executePost.apply(this, arguments);
    }
    function _executePost() {
        _executePost = (0, _asyncToGenerator._)(function(url, data) {
            var response;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetch(url, {
                                headers: {
                                    'Accept': 'application/json',
                                    'Content-Type': 'application/json'
                                },
                                credentials: 'same-origin',
                                method: "POST",
                                body: data ? JSON.stringify(data) : undefined
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        if (!response.ok) throw new Error(response.statusText);
                        return [
                            2,
                            response
                        ];
                }
            });
        });
        return _executePost.apply(this, arguments);
    }
    function executeDelete(url) {
        return _executeDelete.apply(this, arguments);
    }
    function _executeDelete() {
        _executeDelete = (0, _asyncToGenerator._)(function(url) {
            var response;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetch(url, {
                                headers: {
                                    'Accept': 'application/json',
                                    'Content-Type': 'application/json'
                                },
                                credentials: 'same-origin',
                                method: "POST"
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        if (!response.ok) throw new Error(response.statusText);
                        return [
                            2,
                            response
                        ];
                }
            });
        });
        return _executeDelete.apply(this, arguments);
    }
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_ts_generator":"f2hGH","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8hbwz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isLoggedIn", function() {
    return isLoggedIn;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
function isLoggedIn(deps) {
    return /*#__PURE__*/ (0, _asyncToGenerator._)(function() {
        var customer;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        deps.retrieveCustomer()
                    ];
                case 1:
                    customer = _state.sent();
                    return [
                        2,
                        !!customer
                    ];
            }
        });
    });
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_ts_generator":"f2hGH","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8EDpC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "publishEvent", function() {
    return publishEvent;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
function publishEvent(store) {
    return /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(event) {
            return (0, _tsGenerator._)(this, function(_state) {
                store.dispatch(event);
                return [
                    2
                ];
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }();
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_ts_generator":"f2hGH","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4oFs9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "retrieveCustomer", function() {
    return retrieveCustomer;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
function retrieveCustomer(deps) {
    return /*#__PURE__*/ (0, _asyncToGenerator._)(function() {
        var customer;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        deps.request.getRequest("/?view=data-customer")
                    ];
                case 1:
                    customer = _state.sent().customer;
                    return [
                        2,
                        customer
                    ];
            }
        });
    });
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_ts_generator":"f2hGH","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"i2ph9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "retrieveCustomerSubscriptions", function() {
    return retrieveCustomerSubscriptions;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _defineProperty = require("@swc/helpers/_/_define_property");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _paymentMethod = require("../entities/PaymentMethod");
var _std = require("@reglo/std");
var _browser = require("@sentry/browser");
var _dateFns = require("date-fns");
var _price = require("../../std/price");
function retrieveCustomerSubscriptions(deps) {
    return /*#__PURE__*/ (0, _asyncToGenerator._)(function() {
        var credentials, data;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        deps.getRechargeCredentials()
                    ];
                case 1:
                    credentials = _state.sent();
                    if (!credentials) return [
                        2,
                        {
                            addressId: null,
                            nextOrder: null,
                            paymentMethod: null,
                            subscriptions: []
                        }
                    ];
                    return [
                        4,
                        deps.request.getRequest(`/tools/recurring/portal/${credentials.rechargeId}/request_objects?token=${credentials.token}&schema={"addresses":[],"subscriptions":[],"charges":{"status":"QUEUED,ERROR"},"payment_methods":[]}`)
                    ];
                case 2:
                    data = _state.sent();
                    return [
                        2,
                        {
                            addressId: mapAddressId(data),
                            nextOrder: mapNextOrder(data),
                            paymentMethod: mapPaymentMethod(data),
                            subscriptions: data.subscriptions.map(mapSubscription)
                        }
                    ];
            }
        });
    });
    function mapAddressId(data) {
        if (data.addresses.length === 0) return null;
        return data.addresses[0].id;
    }
    function mapNextOrder(data) {
        var nextCharge = selectNextCharge(data);
        if (!nextCharge) return null;
        var firstActiveSubscription = (0, _std.unwrap)(data.subscriptions.find(function(subscription) {
            return subscription.status === 'ACTIVE';
        }));
        return {
            date: new Date(nextCharge.scheduled_at + '-0400'),
            retryDate: nextCharge.retry_date ? new Date(nextCharge.retry_date + '-0400') : null,
            status: nextCharge.status,
            lines: nextCharge.line_items.map(function(line) {
                return {
                    price: (0, _price.toCents)(line.price),
                    variantId: Number(line.shopify_variant_id),
                    subscriptionId: line.subscription_id,
                    quantity: line.quantity
                };
            }),
            frequency: {
                value: Number(firstActiveSubscription.order_interval_frequency),
                unit: firstActiveSubscription.order_interval_unit
            },
            totalLinesPrice: (0, _price.toCents)(nextCharge.total_line_items_price),
            totalDiscounts: (0, _price.toCents)(nextCharge.total_discounts),
            totalShippingPrice: nextCharge.shipping_lines.reduce(function(acc, line) {
                return acc + (0, _price.toCents)(line.price);
            }, 0),
            totalPrice: (0, _price.toCents)(nextCharge.total_price)
        };
    }
    function mapPaymentMethod(data) {
        var selectedPaymentMethod = selectPaymentMethod(data);
        var nextCharge = selectNextCharge(data);
        if (!selectedPaymentMethod) return null;
        return {
            id: selectedPaymentMethod.id,
            shopifyId: (0, _std.unwrap)(selectedPaymentMethod.processor_payment_method_token.match(/[^\/]+$/))[0],
            details: selectedPaymentMethod.payment_type === 'CREDIT_CARD' ? {
                type: 'CREDIT_CARD',
                brand: selectedPaymentMethod.payment_details.brand,
                expirationMonth: selectedPaymentMethod.payment_details.exp_month,
                expirationYear: selectedPaymentMethod.payment_details.exp_year,
                lastDigits: selectedPaymentMethod.payment_details.last4
            } : {
                type: 'PAYPAL',
                email: selectedPaymentMethod.payment_details.paypal_email
            },
            status: (nextCharge === null || nextCharge === void 0 ? void 0 : nextCharge.status) === 'ERROR' ? 'ERROR' : 'OK',
            error: mapChargeError(nextCharge),
            errorDate: (nextCharge === null || nextCharge === void 0 ? void 0 : nextCharge.last_charge_attempt_date) ? new Date(nextCharge.last_charge_attempt_date + '-0400') : null
        };
    }
    function selectNextCharge(data) {
        if (data.charges.length === 0) return null;
        var chargesOrderedByDate = (0, _toConsumableArray._)(data.charges).sort(function(a, b) {
            return (0, _dateFns.compareAsc)(new Date(a.scheduled_at), new Date(b.scheduled_at));
        });
        return chargesOrderedByDate[0];
    }
    function selectPaymentMethod(data) {
        if (data.payment_methods.length === 0) return null;
        var selected = data.payment_methods.find(function(paymentMethod) {
            return paymentMethod.subscriptions.length > 0;
        });
        if (selected) return selected;
        return data.payment_methods[0];
    }
    function mapChargeError(charge) {
        var _obj;
        var mapping = (_obj = {}, (0, _defineProperty._)(_obj, (0, _paymentMethod.PaymentMethodError).SubscriptionNotSupported, 'Your card does not support this type of purchase'), (0, _defineProperty._)(_obj, (0, _paymentMethod.PaymentMethodError).InsufficientFunds, 'Your card has insufficient funds'), (0, _defineProperty._)(_obj, (0, _paymentMethod.PaymentMethodError).ExpiredCard, 'Your card\'s expiration month is invalid'), (0, _defineProperty._)(_obj, (0, _paymentMethod.PaymentMethodError).RefusedPayment, 'Your card was declined'), _obj);
        if (!charge || !charge.error) return null;
        var lastError = (0, _std.unwrap)(charge.error.split("\n").pop());
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = (0, _std.getRecordKeys)(mapping)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var paymentMethodError = _step.value;
                var errorMessage = mapping[paymentMethodError];
                if (lastError.match(errorMessage)) return paymentMethodError;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        _browser.withScope(function(scope) {
            scope.setExtra('error', lastError);
            _browser.captureException(new Error('Unkown recharge payment error'));
        });
        return null;
    }
    function mapSubscription(data) {
        return {
            id: data.id,
            addressId: data.address_id,
            status: data.status,
            quantity: data.quantity,
            variantId: data.shopify_variant_id,
            price: (0, _price.toCents)(data.price),
            nextOrder: new Date(data.next_charge_scheduled_at + '-0400')
        };
    }
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_define_property":"54Zvk","@swc/helpers/_/_to_consumable_array":"eqNDD","@swc/helpers/_/_ts_generator":"f2hGH","../entities/PaymentMethod":"5OJGM","@reglo/std":"1USo0","@sentry/browser":"g8Lrm","date-fns":"6cTOl","../../std/price":"bpfMV","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2kHxh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRechargeCredentials", function() {
    return getRechargeCredentials;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _std = require("@reglo/std");
function getRechargeCredentials(deps) {
    var cache = null;
    return /*#__PURE__*/ (0, _asyncToGenerator._)(function() {
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!!cache) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        retrieveCredentials()
                    ];
                case 1:
                    cache = _state.sent();
                    _state.label = 2;
                case 2:
                    return [
                        2,
                        cache
                    ];
            }
        });
    });
    function retrieveCredentials() {
        return _retrieveCredentials.apply(this, arguments);
    }
    function _retrieveCredentials() {
        _retrieveCredentials = (0, _asyncToGenerator._)(function() {
            var _ref, rechargeId, shopifyId, token;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            getCustomerIds()
                        ];
                    case 1:
                        _ref = _state.sent(), rechargeId = _ref.rechargeId, shopifyId = _ref.shopifyId;
                        if (!rechargeId) return [
                            2,
                            null
                        ];
                        return [
                            4,
                            getRechargeToken(shopifyId)
                        ];
                    case 2:
                        token = _state.sent();
                        if (!token) return [
                            2,
                            null
                        ];
                        return [
                            2,
                            {
                                rechargeId: rechargeId,
                                token: token
                            }
                        ];
                }
            });
        });
        return _retrieveCredentials.apply(this, arguments);
    }
    function getRechargeToken(shopifyId) {
        return _getRechargeToken.apply(this, arguments);
    }
    function _getRechargeToken() {
        _getRechargeToken = (0, _asyncToGenerator._)(function(shopifyId) {
            var data;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            deps.request.getRequest(`/tools/recurring/get_rc_token/${shopifyId}`)
                        ];
                    case 1:
                        data = _state.sent();
                        if (data.rc_customer.error === 'customer_not_found') return [
                            2,
                            null
                        ];
                        return [
                            2,
                            (0, _std.unwrap)(data.rc_customer.token)
                        ];
                }
            });
        });
        return _getRechargeToken.apply(this, arguments);
    }
    function getCustomerIds() {
        return _getCustomerIds.apply(this, arguments);
    }
    function _getCustomerIds() {
        _getCustomerIds = (0, _asyncToGenerator._)(function() {
            var customer;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            deps.request.getRequest("/?view=data-rechargeIds")
                        ];
                    case 1:
                        customer = _state.sent().customer;
                        return [
                            2,
                            customer
                        ];
                }
            });
        });
        return _getCustomerIds.apply(this, arguments);
    }
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_ts_generator":"f2hGH","@reglo/std":"1USo0","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"4Yowr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "retrieveCustomerOrders", function() {
    return retrieveCustomerOrders;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
function retrieveCustomerOrders(deps) {
    return /*#__PURE__*/ (0, _asyncToGenerator._)(function() {
        var orders;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        deps.request.getRequest("/?view=data-orders")
                    ];
                case 1:
                    orders = _state.sent().orders;
                    return [
                        2,
                        orders.map(mapOrder)
                    ];
            }
        });
    });
    function mapOrder(data) {
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, data), {
            date: new Date(data.date * 1000)
        });
    }
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_object_spread_props":"fLCYP","@swc/helpers/_/_ts_generator":"f2hGH","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"iGuSP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "retrieveIntakeCalculatorData", function() {
    return retrieveIntakeCalculatorData;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _products = require("../store/state/data/products");
var _std = require("@reglo/std");
function retrieveIntakeCalculatorData(deps) {
    return /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(productId) {
            var url;
            return (0, _tsGenerator._)(this, function(_state) {
                url = prepareUrl(productId);
                return [
                    2,
                    deps.request.getRequest(url)
                ];
            });
        });
        return function(productId) {
            return _ref.apply(this, arguments);
        };
    }();
    function prepareUrl(productId) {
        var handle = selectProductHandle(productId);
        return `/products/${handle}?view=data-intakeCalculatorData`;
    }
    function selectProductHandle(productId) {
        var products = deps.getState((0, _products.productsSelector));
        var product = (0, _std.unwrap)(products.entities.find(function(product) {
            return product.productId === productId;
        }));
        return product.handle;
    }
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_ts_generator":"f2hGH","../store/state/data/products":"17rrh","@reglo/std":"1USo0","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2z7eK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "executeCommand", function() {
    return executeCommand;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
function executeCommand(deps) {
    return /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(command) {
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            deps.request.postRequest(`${"/tools/reglo-api"}/commands`, command)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(command) {
            return _ref.apply(this, arguments);
        };
    }();
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_ts_generator":"f2hGH","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1L5FL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "apiRequest", function() {
    return apiRequest;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
function apiRequest(deps) {
    return {
        get: get,
        post: post,
        postWithResponse: postWithResponse
    };
    function get(url) {
        return _get.apply(this, arguments);
    }
    function _get() {
        _get = (0, _asyncToGenerator._)(function(url) {
            return (0, _tsGenerator._)(this, function(_state) {
                return [
                    2,
                    deps.request.getRequest(`${"/tools/reglo-api"}${url}`)
                ];
            });
        });
        return _get.apply(this, arguments);
    }
    function post(url, data) {
        return _post.apply(this, arguments);
    }
    function _post() {
        _post = (0, _asyncToGenerator._)(function(url, data) {
            return (0, _tsGenerator._)(this, function(_state) {
                return [
                    2,
                    deps.request.postRequest(`${"/tools/reglo-api"}${url}`, data)
                ];
            });
        });
        return _post.apply(this, arguments);
    }
    function postWithResponse(url, data) {
        return _postWithResponse.apply(this, arguments);
    }
    function _postWithResponse() {
        _postWithResponse = (0, _asyncToGenerator._)(function(url, data) {
            return (0, _tsGenerator._)(this, function(_state) {
                return [
                    2,
                    deps.request.postWithResponse(`${"/tools/reglo-api"}${url}`, data)
                ];
            });
        });
        return _postWithResponse.apply(this, arguments);
    }
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_ts_generator":"f2hGH","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3ltHV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "updateSubscriptionsDate", function() {
    return updateSubscriptionsDate;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _customerSubscription = require("../store/state/data/customerSubscription");
var _std = require("@reglo/std");
var _dateFns = require("date-fns");
function updateSubscriptionsDate(deps) {
    return /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(date) {
            var url, subscriptionsIds, next_charge_scheduled_at;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            prepareUrl()
                        ];
                    case 1:
                        url = _state.sent();
                        subscriptionsIds = selectSubscriptionsIds();
                        next_charge_scheduled_at = (0, _dateFns.format)(date, 'yyyy-MM-dd');
                        return [
                            4,
                            deps.request.postRequest(url, {
                                subscriptions: subscriptionsIds.map(function(id) {
                                    return {
                                        id: id,
                                        next_charge_scheduled_at: next_charge_scheduled_at
                                    };
                                })
                            })
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(date) {
            return _ref.apply(this, arguments);
        };
    }();
    function prepareUrl() {
        return _prepareUrl.apply(this, arguments);
    }
    function _prepareUrl() {
        _prepareUrl = (0, _asyncToGenerator._)(function() {
            var credentials, addressId;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            deps.getRechargeCredentials().then((0, _std.unwrap))
                        ];
                    case 1:
                        credentials = _state.sent();
                        addressId = selectAddressId();
                        return [
                            2,
                            `/tools/recurring/portal/${credentials.rechargeId}/addresses/${addressId}/subscriptions-bulk-update?token=${credentials.token}`
                        ];
                }
            });
        });
        return _prepareUrl.apply(this, arguments);
    }
    function selectAddressId() {
        var state = deps.getState((0, _customerSubscription.customerSubscriptionSelector));
        return (0, _std.unwrap)(state.addressId);
    }
    function selectSubscriptionsIds() {
        var state = deps.getState((0, _customerSubscription.customerSubscriptionSelector));
        return state.subscriptions.map(function(subscription) {
            return subscription.id;
        });
    }
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_ts_generator":"f2hGH","../store/state/data/customerSubscription":"3ipiV","@reglo/std":"1USo0","date-fns":"6cTOl","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"b17Tm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "disableSubscriptions", function() {
    return disableSubscriptions;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _customerSubscription = require("../store/state/data/customerSubscription");
var _std = require("@reglo/std");
function disableSubscriptions(deps) {
    return /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(subscriptionsIds) {
            var url;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            prepareUrl()
                        ];
                    case 1:
                        url = _state.sent();
                        return [
                            4,
                            deps.request.postRequest(url, {
                                subscriptions: subscriptionsIds.map(function(id) {
                                    return {
                                        id: id,
                                        status: 'CANCELLED'
                                    };
                                })
                            })
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(subscriptionsIds) {
            return _ref.apply(this, arguments);
        };
    }();
    function prepareUrl() {
        return _prepareUrl.apply(this, arguments);
    }
    function _prepareUrl() {
        _prepareUrl = (0, _asyncToGenerator._)(function() {
            var credentials, addressId;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            deps.getRechargeCredentials().then((0, _std.unwrap))
                        ];
                    case 1:
                        credentials = _state.sent();
                        addressId = selectAddressId();
                        return [
                            2,
                            `/tools/recurring/portal/${credentials.rechargeId}/addresses/${addressId}/subscriptions-bulk-update?token=${credentials.token}`
                        ];
                }
            });
        });
        return _prepareUrl.apply(this, arguments);
    }
    function selectAddressId() {
        var state = deps.getState((0, _customerSubscription.customerSubscriptionSelector));
        return (0, _std.unwrap)(state.addressId);
    }
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_ts_generator":"f2hGH","../store/state/data/customerSubscription":"3ipiV","@reglo/std":"1USo0","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"krepr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "enableSubscription", function() {
    return enableSubscription;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _customerSubscription = require("../store/state/data/customerSubscription");
var _std = require("@reglo/std");
function enableSubscription(deps) {
    return /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(subscriptionId) {
            var url;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            prepareUrl()
                        ];
                    case 1:
                        url = _state.sent();
                        return [
                            4,
                            deps.request.postRequest(url, {
                                subscriptions: [
                                    subscriptionId
                                ].map(function(id) {
                                    return {
                                        id: id,
                                        status: 'ACTIVE'
                                    };
                                })
                            })
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(subscriptionId) {
            return _ref.apply(this, arguments);
        };
    }();
    function prepareUrl() {
        return _prepareUrl.apply(this, arguments);
    }
    function _prepareUrl() {
        _prepareUrl = (0, _asyncToGenerator._)(function() {
            var credentials, addressId;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            deps.getRechargeCredentials().then((0, _std.unwrap))
                        ];
                    case 1:
                        credentials = _state.sent();
                        addressId = selectAddressId();
                        return [
                            2,
                            `/tools/recurring/portal/${credentials.rechargeId}/addresses/${addressId}/subscriptions-bulk-update?token=${credentials.token}`
                        ];
                }
            });
        });
        return _prepareUrl.apply(this, arguments);
    }
    function selectAddressId() {
        var state = deps.getState((0, _customerSubscription.customerSubscriptionSelector));
        return (0, _std.unwrap)(state.addressId);
    }
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_ts_generator":"f2hGH","../store/state/data/customerSubscription":"3ipiV","@reglo/std":"1USo0","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1N1UZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "logIn", function() {
    return logIn;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _either = require("fp-ts/Either");
var _htmlDecode = require("../../std/htmlDecode");
var _browser = require("@sentry/browser");
function logIn(deps) {
    return /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(credentials) {
            var response, data;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetch('/account/login', {
                                method: 'POST',
                                headers: {
                                    'Accept': 'application/json',
                                    'Content-Type': 'application/json'
                                },
                                body: JSON.stringify({
                                    customer: credentials
                                })
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        localStorage.setItem('d5fce58502353dc1954f719e02a60718', btoa(credentials.email));
                        _browser.setTag('customer_email', credentials.email);
                        if (!response.url.match('/account/login')) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            response.json().then((0, _htmlDecode.decodeShopifyJson))
                        ];
                    case 2:
                        data = _state.sent();
                        return [
                            2,
                            _either.right({
                                error: data.errors.form
                            })
                        ];
                    case 3:
                        return [
                            2,
                            _either.left(undefined)
                        ];
                }
            });
        });
        return function(credentials) {
            return _ref.apply(this, arguments);
        };
    }();
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_ts_generator":"f2hGH","fp-ts/Either":"jW2NS","../../std/htmlDecode":"410if","@sentry/browser":"g8Lrm","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"410if":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "decodeShopifyJson", function() {
    return decodeShopifyJson;
});
function decodeShopifyJson(input) {
    var result = {};
    for(var key in input){
        var value = input[key];
        if (typeof value === 'string') result[key] = value.replace('&#39;', '\'');
        else result[key] = decodeShopifyJson(value);
    }
    return result;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"32j87":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sendRecoverPasswordEmail", function() {
    return sendRecoverPasswordEmail;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _either = require("fp-ts/Either");
var _htmlDecode = require("../../std/htmlDecode");
function sendRecoverPasswordEmail(deps) {
    return /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(email) {
            var response, data;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetch('/account/recover', {
                                method: 'POST',
                                headers: {
                                    'Accept': 'application/json',
                                    'Content-Type': 'application/json'
                                },
                                body: JSON.stringify({
                                    email: email
                                })
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        return [
                            4,
                            response.json().then((0, _htmlDecode.decodeShopifyJson))
                        ];
                    case 2:
                        data = _state.sent();
                        if (data.errors) return [
                            2,
                            _either.right({
                                error: typeof data.errors === 'string' ? data.errors : data.errors.form
                            })
                        ];
                        return [
                            2,
                            _either.left(undefined)
                        ];
                }
            });
        });
        return function(email) {
            return _ref.apply(this, arguments);
        };
    }();
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_ts_generator":"f2hGH","fp-ts/Either":"jW2NS","../../std/htmlDecode":"410if","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"g7bud":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createAccount", function() {
    return createAccount;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _either = require("fp-ts/Either");
var _htmlDecode = require("../../std/htmlDecode");
function createAccount(deps) {
    return /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(params) {
            var response, data;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetch('/account', {
                                method: 'POST',
                                headers: {
                                    'Accept': 'application/json',
                                    'Content-Type': 'application/json'
                                },
                                body: JSON.stringify({
                                    customer: {
                                        first_name: params.firstName,
                                        last_name: params.lastName,
                                        email: params.email,
                                        password: params.password
                                    }
                                })
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        if (!response.url.match('/account/register')) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            response.json().then((0, _htmlDecode.decodeShopifyJson))
                        ];
                    case 2:
                        data = _state.sent();
                        return [
                            2,
                            _either.right({
                                errors: prepareErrors(data.errors)
                            })
                        ];
                    case 3:
                        return [
                            2,
                            _either.left(undefined)
                        ];
                }
            });
        });
        return function(params) {
            return _ref.apply(this, arguments);
        };
    }();
    function prepareErrors(errors) {
        var _errors_form;
        return {
            form: ((_errors_form = errors.form) === null || _errors_form === void 0 ? void 0 : _errors_form.match("Cette adresse e-mail est d\xe9j\xe0 associ\xe9e \xe0 un compte.")) ? "Cette adresse e-mail est d\xe9j\xe0 associ\xe9e \xe0 un compte." : errors.form,
            password: errors.password ? `Le mot de passe ${errors.password}` : undefined,
            email: errors.email ? `L'e-mail' ${errors.email}` : undefined
        };
    }
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_ts_generator":"f2hGH","fp-ts/Either":"jW2NS","../../std/htmlDecode":"410if","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"l23vG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "doesCustomerHasAccount", function() {
    return doesCustomerHasAccount;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
function doesCustomerHasAccount(deps) {
    return /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(email) {
            return (0, _tsGenerator._)(this, function(_state) {
                return [
                    2,
                    deps.apiRequest.postWithResponse('/doesCustomerHasAccount', {
                        email: email
                    }).then(function(response) {
                        return response.data;
                    })
                ];
            });
        });
        return function(email) {
            return _ref.apply(this, arguments);
        };
    }();
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_ts_generator":"f2hGH","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"bH4lH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sendAccountActivationEmail", function() {
    return sendAccountActivationEmail;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
function sendAccountActivationEmail(deps) {
    return /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(email) {
            return (0, _tsGenerator._)(this, function(_state) {
                return [
                    2,
                    deps.apiRequest.post('/sendCustomerAccountInviteEmail', {
                        email: email
                    })
                ];
            });
        });
        return function(email) {
            return _ref.apply(this, arguments);
        };
    }();
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_ts_generator":"f2hGH","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"80J3A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "updateSubscriptionQuantity", function() {
    return updateSubscriptionQuantity;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
function updateSubscriptionQuantity(deps) {
    return /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(params) {
            var subscriptionId, quantity;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        subscriptionId = params.subscriptionId, quantity = params.quantity;
                        return [
                            4,
                            deps.apiRequest.post(`/updateSubscriptionQuantity/${subscriptionId}`, {
                                quantity: quantity
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(params) {
            return _ref.apply(this, arguments);
        };
    }();
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_ts_generator":"f2hGH","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"6bGCj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "retrieveShippingRates", function() {
    return retrieveShippingRates;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
function retrieveShippingRates(deps) {
    return /*#__PURE__*/ (0, _asyncToGenerator._)(function() {
        return (0, _tsGenerator._)(this, function(_state) {
            return [
                2,
                deps.apiRequest.get('/shippingRates').then(function(response) {
                    return response.data;
                })
            ];
        });
    });
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_ts_generator":"f2hGH","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1rlsk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "track", function() {
    return track;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _analyticsBrowser = require("@amplitude/analytics-browser");
var _std = require("@reglo/std");
var _layout = require("../../dom/layout");
function track(deps) {
    return /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(name, properties) {
            var preparedProperties;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            prepareProperties(properties)
                        ];
                    case 1:
                        preparedProperties = _state.sent();
                        return [
                            4,
                            (0, _std.doNotWaitFor)(trackInAmplitude(name, preparedProperties))
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            (0, _std.doNotWaitFor)(trackInConsole(name, preparedProperties))
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(name, properties) {
            return _ref.apply(this, arguments);
        };
    }();
    function prepareProperties(properties) {
        return _prepareProperties.apply(this, arguments);
    }
    function _prepareProperties() {
        _prepareProperties = (0, _asyncToGenerator._)(function(properties) {
            var _tmp, _tmp1;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _tmp = [
                            (0, _objectSpread._)({}, properties ? properties : {})
                        ];
                        _tmp1 = {};
                        return [
                            4,
                            deps.location.getPath()
                        ];
                    case 1:
                        return [
                            2,
                            (0, _objectSpreadProps._).apply(void 0, _tmp.concat([
                                (_tmp1.path = _state.sent(), _tmp1.device = prepareDevice(), _tmp1)
                            ]))
                        ];
                }
            });
        });
        return _prepareProperties.apply(this, arguments);
    }
    function prepareDevice() {
        if (window.innerWidth < (0, _layout.Breakpoint).MD) return 'mobile';
        if (window.innerWidth < (0, _layout.Breakpoint).LG) return 'tablet';
        return 'desktop';
    }
    function trackInConsole(name, properties) {
        return _trackInConsole.apply(this, arguments);
    }
    function _trackInConsole() {
        _trackInConsole = (0, _asyncToGenerator._)(function(name, properties) {
            return (0, _tsGenerator._)(this, function(_state) {
                console.log('event:', name, properties);
                return [
                    2
                ];
            });
        });
        return _trackInConsole.apply(this, arguments);
    }
    function trackInApi(name, properties) {
        return _trackInApi.apply(this, arguments);
    }
    function _trackInApi() {
        _trackInApi = (0, _asyncToGenerator._)(function(name, properties) {
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            deps.request.postRequest(`${"/tools/reglo-api"}/events`, {
                                name: name,
                                properties: properties
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return _trackInApi.apply(this, arguments);
    }
    function trackInDatalayer(name, properties) {
        return _trackInDatalayer.apply(this, arguments);
    }
    function _trackInDatalayer() {
        _trackInDatalayer = (0, _asyncToGenerator._)(function(name, properties) {
            return (0, _tsGenerator._)(this, function(_state) {
                window.dataLayer.push((0, _objectSpread._)({
                    event: `c_${name}`
                }, properties));
                return [
                    2
                ];
            });
        });
        return _trackInDatalayer.apply(this, arguments);
    }
    function trackInAmplitude(name, properties) {
        return _trackInAmplitude.apply(this, arguments);
    }
    function _trackInAmplitude() {
        _trackInAmplitude = (0, _asyncToGenerator._)(function(name, properties) {
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            _analyticsBrowser.track(name, properties)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return _trackInAmplitude.apply(this, arguments);
    }
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_object_spread_props":"fLCYP","@swc/helpers/_/_ts_generator":"f2hGH","@amplitude/analytics-browser":"3318X","@reglo/std":"1USo0","../../dom/layout":"bHp5c","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"251TQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "updateShippingAddress", function() {
    return updateShippingAddress;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _storeFrontApi = require("@reglo/store-front-api");
var _customer = require("../store/state/data/customer");
function updateShippingAddress(deps) {
    return /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(shippingAddress) {
            return (0, _tsGenerator._)(this, function(_state) {
                return [
                    2,
                    deps.executeCommand({
                        type: (0, _storeFrontApi.UpdateShippingAddressKey),
                        payload: {
                            shippingAddress: (0, _objectSpread._)({
                                updateDate: new Date(),
                                customerId: retrieveCustomerId()
                            }, retrieveFullShippingAddress(), shippingAddress)
                        }
                    })
                ];
            });
        });
        return function(shippingAddress) {
            return _ref.apply(this, arguments);
        };
    }();
    function retrieveCustomerId() {
        return deps.getState((0, _customer.customerIdSelector)).toString();
    }
    function retrieveFullShippingAddress() {
        return deps.getState((0, _customer.shippingAddressSelector));
    }
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_object_spread":"4bEWH","@swc/helpers/_/_ts_generator":"f2hGH","@reglo/store-front-api":"gm0gL","../store/state/data/customer":"hDp3A","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"gm0gL":[function(require,module,exports,__globalThis) {
"use strict";
var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __exportStar = this && this.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) __createBinding(exports1, m, p);
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
__exportStar(require("d2f68125b8632392"), exports);

},{"d2f68125b8632392":"cNC6Z"}],"cNC6Z":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RequestPaymentMethodUpdateKey = exports.RequestPaymentMethodUpdate = exports.UpdateShippingAddressKey = void 0;
var requestPaymentMethodUpdate_1 = require("f607423fa5011250");
Object.defineProperty(exports, "RequestPaymentMethodUpdate", {
    enumerable: true,
    get: function get() {
        return requestPaymentMethodUpdate_1.RequestPaymentMethodUpdate;
    }
});
Object.defineProperty(exports, "RequestPaymentMethodUpdateKey", {
    enumerable: true,
    get: function get() {
        return requestPaymentMethodUpdate_1.RequestPaymentMethodUpdateKey;
    }
});
exports.UpdateShippingAddressKey = 'UpdateShippingAddress';

},{"f607423fa5011250":"2NbAB"}],"2NbAB":[function(require,module,exports,__globalThis) {
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
"use strict";
var __awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.requestPaymentMethodUpdate = exports.RequestPaymentMethodUpdate = exports.RequestPaymentMethodUpdateKey = void 0;
var std_1 = require("e232af3ed0e0d1c5");
exports.RequestPaymentMethodUpdateKey = 'RequestPaymentMethodUpdate';
exports.RequestPaymentMethodUpdate = (0, std_1.eventFactory)(exports.RequestPaymentMethodUpdateKey)();
function requestPaymentMethodUpdate(deps) {
    var _this = this;
    return function(event) {
        return __awaiter(_this, void 0, void 0, function() {
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            deps.shopifyApi.requestPaymentMethodUpdate(event.payload.paymentMethodId)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
    };
}
exports.requestPaymentMethodUpdate = requestPaymentMethodUpdate;

},{"@swc/helpers/_/_ts_generator":"f2hGH","e232af3ed0e0d1c5":"1USo0"}],"7iLIq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "updateSubscriptionFrequency", function() {
    return updateSubscriptionFrequency;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _customerSubscription = require("../store/state/data/customerSubscription");
var _std = require("@reglo/std");
function updateSubscriptionFrequency(deps) {
    return /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(frequencyInWeeks) {
            var url, subscriptionsIds;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            prepareUrl()
                        ];
                    case 1:
                        url = _state.sent();
                        subscriptionsIds = selectSubscriptionsIds();
                        return [
                            4,
                            deps.request.postRequest(url, {
                                subscriptions: subscriptionsIds.map(function(id) {
                                    return {
                                        id: id,
                                        order_interval_unit: 'week',
                                        order_interval_frequency: frequencyInWeeks,
                                        charge_interval_frequency: frequencyInWeeks
                                    };
                                })
                            })
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(frequencyInWeeks) {
            return _ref.apply(this, arguments);
        };
    }();
    function prepareUrl() {
        return _prepareUrl.apply(this, arguments);
    }
    function _prepareUrl() {
        _prepareUrl = (0, _asyncToGenerator._)(function() {
            var credentials, addressId;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            deps.getRechargeCredentials().then((0, _std.unwrap))
                        ];
                    case 1:
                        credentials = _state.sent();
                        addressId = selectAddressId();
                        return [
                            2,
                            `/tools/recurring/portal/${credentials.rechargeId}/addresses/${addressId}/subscriptions-bulk-update?token=${credentials.token}`
                        ];
                }
            });
        });
        return _prepareUrl.apply(this, arguments);
    }
    function selectAddressId() {
        var state = deps.getState((0, _customerSubscription.customerSubscriptionSelector));
        return (0, _std.unwrap)(state.addressId);
    }
    function selectSubscriptionsIds() {
        var state = deps.getState((0, _customerSubscription.customerSubscriptionSelector));
        return state.subscriptions.map(function(subscription) {
            return subscription.id;
        });
    }
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_ts_generator":"f2hGH","../store/state/data/customerSubscription":"3ipiV","@reglo/std":"1USo0","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"57slY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addProductToSubscription", function() {
    return addProductToSubscription;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _customerSubscription = require("../store/state/data/customerSubscription");
var _std = require("@reglo/std");
function addProductToSubscription(deps) {
    return /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(variantId) {
            var url, addressId, frequency, nextChargeDate;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            prepareUrl()
                        ];
                    case 1:
                        url = _state.sent();
                        addressId = selectAddressId();
                        frequency = selectFrequency();
                        nextChargeDate = selectNextChargeDate();
                        return [
                            4,
                            deps.request.postRequest(url, {
                                shopify_variant_id: variantId,
                                charge_interval_frequency: frequency.value,
                                order_interval_frequency: frequency.value,
                                order_interval_unit: frequency.unit,
                                next_charge_scheduled_at: nextChargeDate,
                                address_id: addressId,
                                quantity: 1
                            })
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(variantId) {
            return _ref.apply(this, arguments);
        };
    }();
    function prepareUrl() {
        return _prepareUrl.apply(this, arguments);
    }
    function _prepareUrl() {
        _prepareUrl = (0, _asyncToGenerator._)(function() {
            var credentials;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            deps.getRechargeCredentials().then((0, _std.unwrap))
                        ];
                    case 1:
                        credentials = _state.sent();
                        return [
                            2,
                            `/tools/recurring/portal/${credentials.rechargeId}/subscriptions?token=${credentials.token}`
                        ];
                }
            });
        });
        return _prepareUrl.apply(this, arguments);
    }
    function selectAddressId() {
        var state = deps.getState((0, _customerSubscription.customerSubscriptionSelector));
        return (0, _std.unwrap)(state.addressId);
    }
    function selectFrequency() {
        var _deps_getState_nextOrder;
        return (0, _std.unwrap)((_deps_getState_nextOrder = deps.getState((0, _customerSubscription.customerSubscriptionSelector)).nextOrder) === null || _deps_getState_nextOrder === void 0 ? void 0 : _deps_getState_nextOrder.frequency);
    }
    function selectNextChargeDate() {
        var _deps_getState_nextOrder;
        return (0, _std.unwrap)((_deps_getState_nextOrder = deps.getState((0, _customerSubscription.customerSubscriptionSelector)).nextOrder) === null || _deps_getState_nextOrder === void 0 ? void 0 : _deps_getState_nextOrder.date);
    }
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_ts_generator":"f2hGH","../store/state/data/customerSubscription":"3ipiV","@reglo/std":"1USo0","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"7zRx2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "swapProductToSubscription", function() {
    return swapProductToSubscription;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _std = require("@reglo/std");
function swapProductToSubscription(deps) {
    return /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(params) {
            var url;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            prepareUrl(params.subscriptionId)
                        ];
                    case 1:
                        url = _state.sent();
                        return [
                            4,
                            deps.request.postRequest(url, {
                                shopify_variant_id: params.variantId
                            })
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(params) {
            return _ref.apply(this, arguments);
        };
    }();
    function prepareUrl(subscriptionId) {
        return _prepareUrl.apply(this, arguments);
    }
    function _prepareUrl() {
        _prepareUrl = (0, _asyncToGenerator._)(function(subscriptionId) {
            var credentials;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            deps.getRechargeCredentials().then((0, _std.unwrap))
                        ];
                    case 1:
                        credentials = _state.sent();
                        return [
                            2,
                            `/tools/recurring/portal/${credentials.rechargeId}/subscriptions/${subscriptionId}/swap?token=${credentials.token}`
                        ];
                }
            });
        });
        return _prepareUrl.apply(this, arguments);
    }
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_ts_generator":"f2hGH","@reglo/std":"1USo0","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"lNiJa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "location", function() {
    return location;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
function location(deps) {
    return {
        getPath: getPath
    };
    function getPath() {
        return _getPath.apply(this, arguments);
    }
    function _getPath() {
        _getPath = (0, _asyncToGenerator._)(function() {
            return (0, _tsGenerator._)(this, function(_state) {
                return [
                    2,
                    window.location.pathname
                ];
            });
        });
        return _getPath.apply(this, arguments);
    }
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_ts_generator":"f2hGH","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"hlIB1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initHandlers", function() {
    return initHandlers;
});
var _startApp = require("../events/StartApp");
var _loadProductData = require("../useCases/loadProductData");
var _account = require("../events/Account");
var _intakeCalculator = require("../events/IntakeCalculator");
var _loadIntakeCalculator = require("../useCases/loadIntakeCalculator");
var _startDailyIntakeCalculation = require("../useCases/startDailyIntakeCalculation");
var _requestPaymentMethodUpdate = require("../useCases/requestPaymentMethodUpdate");
var _updateNextChargeDate = require("../useCases/updateNextChargeDate");
var _loadCustomerSubscriptions = require("../useCases/loadCustomerSubscriptions");
var _cancelSubscription = require("../useCases/cancelSubscription");
var _removeProductFromSubscription = require("../useCases/removeProductFromSubscription");
var _verifyAccountExistence = require("../useCases/verifyAccountExistence");
var _logInAccount = require("../useCases/logInAccount");
var _recoverPassword = require("../useCases/recoverPassword");
var _createAccount = require("../useCases/createAccount");
var _updateSubscriptionQuantity = require("../useCases/updateSubscriptionQuantity");
var _refreshCustomerSubscriptions = require("../useCases/refreshCustomerSubscriptions");
var _loadAccountSaga = require("../sagas/loadAccountSaga");
var _loadOrdersData = require("../useCases/loadOrdersData");
var _loadCustomerData = require("../useCases/loadCustomerData");
var _loadShippingRates = require("../useCases/loadShippingRates");
var _updateShippingAddress = require("../useCases/updateShippingAddress");
var _updateFrequency = require("../useCases/updateFrequency");
var _addProductToSubscription = require("../useCases/addProductToSubscription");
var _swapProductOfSubscription = require("../useCases/swapProductOfSubscription");
var _sections = require("../../../../sections");
var _startCheckout = require("../useCases/startCheckout");
var _trackSpentTime = require("../sagas/trackSpentTime");
var _trackEmailSignUp = require("../sagas/trackEmailSignUp");
var _components = require("../../../../snippets/components");
function initHandlers(param) {
    var eventBus = param.eventBus, deps = param.deps;
    (0, _sections.sectionsHandlers)({
        eventBus: eventBus,
        deps: deps
    });
    (0, _components.componentsHandlers)({
        eventBus: eventBus,
        deps: deps
    });
    eventBus.subscribeToAll((0, _loadAccountSaga.loadAccountSaga)(deps));
    eventBus.subscribeToAll((0, _trackEmailSignUp.trackEmailSignUp)(deps));
    eventBus.subscribeToAll((0, _trackSpentTime.trackSpentTime)(deps));
    eventBus.subscribeTo((0, _startApp.StartAppKey), (0, _loadProductData.loadProductData)(deps));
    eventBus.subscribeTo((0, _intakeCalculator.OpenIntakeCalculatorKey), (0, _loadIntakeCalculator.loadIntakeCalculator)(deps));
    eventBus.subscribeTo((0, _intakeCalculator.CalculateDailyIntakeKey), (0, _startDailyIntakeCalculation.startDailyIntakeCalculation)(deps));
    eventBus.subscribeTo((0, _account.RequestPaymentMethodUpdateKey), (0, _requestPaymentMethodUpdate.requestPaymentMethodUpdate)(deps));
    eventBus.subscribeTo((0, _updateNextChargeDate.UpdateNextChargeDateKey), (0, _updateNextChargeDate.updateNextChargeDate)(deps));
    eventBus.subscribeTo((0, _loadCustomerSubscriptions.LoadCustomerSubscriptionsKey), (0, _loadCustomerSubscriptions.loadCustomerSubscriptions)(deps));
    eventBus.subscribeTo((0, _refreshCustomerSubscriptions.RefreshCustomerSubscriptionsKey), (0, _refreshCustomerSubscriptions.refreshCustomerSubscriptions)(deps));
    eventBus.subscribeTo((0, _removeProductFromSubscription.RemoveProductFromSubscriptionKey), (0, _removeProductFromSubscription.removeProductFromSubscription)(deps));
    eventBus.subscribeTo((0, _cancelSubscription.CancelSubscriptionKey), (0, _cancelSubscription.cancelSubscription)(deps));
    eventBus.subscribeTo((0, _verifyAccountExistence.VerifyAccountExistenceKey), (0, _verifyAccountExistence.verifyAccountExistence)(deps));
    eventBus.subscribeTo((0, _logInAccount.LogInAccountKey), (0, _logInAccount.logInAccount)(deps));
    eventBus.subscribeTo((0, _recoverPassword.RecoverPasswordKey), (0, _recoverPassword.recoverPassword)(deps));
    eventBus.subscribeTo((0, _createAccount.CreateAccountKey), (0, _createAccount.createAccount)(deps));
    eventBus.subscribeTo((0, _updateSubscriptionQuantity.UpdateSubscriptionQuantityKey), (0, _updateSubscriptionQuantity.updateSubscriptionQuantity)(deps));
    eventBus.subscribeTo((0, _loadOrdersData.LoadOrdersDataKey), (0, _loadOrdersData.loadOrdersData)(deps));
    eventBus.subscribeTo((0, _loadCustomerData.LoadCustomerDataKey), (0, _loadCustomerData.loadCustomerData)(deps));
    eventBus.subscribeTo((0, _loadShippingRates.LoadShippingRatesKey), (0, _loadShippingRates.loadShippingRates)(deps));
    eventBus.subscribeTo((0, _updateShippingAddress.UpdateShippingAddressKey), (0, _updateShippingAddress.updateShippingAddress)(deps));
    eventBus.subscribeTo((0, _updateFrequency.UpdateFrequencyKey), (0, _updateFrequency.updateFrequency)(deps));
    eventBus.subscribeTo((0, _addProductToSubscription.AddProductToSubscriptionKey), (0, _addProductToSubscription.addProductToSubscription)(deps));
    eventBus.subscribeTo((0, _swapProductOfSubscription.SwapProductOfSubscriptionKey), (0, _swapProductOfSubscription.swapProductOfSubscription)(deps));
    eventBus.subscribeTo((0, _startCheckout.StartCheckoutKey), (0, _startCheckout.startCheckout)(deps));
    eventBus.subscribeToAll(function(event) {
        switch(event.type){
            case 0, _updateNextChargeDate.NextChargeDateUpdatedKey:
            case 0, _removeProductFromSubscription.ProductRemovedFromSubscriptionKey:
            case 0, _cancelSubscription.SubscriptionCancelledKey:
            case 0, _updateSubscriptionQuantity.SubscriptionQuantityUpdatedKey:
            case 0, _addProductToSubscription.ProductAddedToSubscriptionKey:
            case 0, _swapProductOfSubscription.ProductOfSubscriptionSwappedKey:
                return deps.publishEvent((0, _refreshCustomerSubscriptions.RefreshCustomerSubscriptions)());
        }
    });
}

},{"../events/StartApp":"ggoaD","../useCases/loadProductData":"8ltri","../events/Account":"em32I","../events/IntakeCalculator":"8FDos","../useCases/loadIntakeCalculator":"f7td4","../useCases/startDailyIntakeCalculation":"fREhI","../useCases/requestPaymentMethodUpdate":"1qVi5","../useCases/updateNextChargeDate":"hgcCc","../useCases/loadCustomerSubscriptions":"efjCG","../useCases/cancelSubscription":"qpH7L","../useCases/removeProductFromSubscription":"eGpss","../useCases/verifyAccountExistence":"6e41n","../useCases/logInAccount":"iGbZs","../useCases/recoverPassword":"1c5YK","../useCases/createAccount":"ypKSi","../useCases/updateSubscriptionQuantity":"2ruvf","../useCases/refreshCustomerSubscriptions":"f4vE2","../sagas/loadAccountSaga":"fo1BR","../useCases/loadOrdersData":"4CTLE","../useCases/loadCustomerData":"lIaYI","../useCases/loadShippingRates":"hpNjt","../useCases/updateShippingAddress":"bzbXd","../useCases/updateFrequency":"eXHAW","../useCases/addProductToSubscription":"76m1k","../useCases/swapProductOfSubscription":"5sLIq","../../../../sections":"8H2M7","../useCases/startCheckout":"dwgwB","../sagas/trackSpentTime":"jG4l8","../sagas/trackEmailSignUp":"ikSli","../../../../snippets/components":"1f8Ky","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"8ltri":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loadProductData", function() {
    return loadProductData;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _productDataLoaded = require("../events/ProductDataLoaded");
function loadProductData(deps) {
    return /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(event) {
            var data;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            deps.request.getRequest("/?view=data-products")
                        ];
                    case 1:
                        data = _state.sent();
                        return [
                            2,
                            (0, _productDataLoaded.ProductDataLoaded)(data)
                        ];
                }
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }();
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_ts_generator":"f2hGH","../events/ProductDataLoaded":"k7cce","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"f7td4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loadIntakeCalculator", function() {
    return loadIntakeCalculator;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _intakeCalculator = require("../events/IntakeCalculator");
function loadIntakeCalculator(deps) {
    return /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(event) {
            var execution;
            return (0, _tsGenerator._)(this, function(_state) {
                execution = execute();
                return [
                    2,
                    deps.waitAtLeast(execution, 500)
                ];
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }();
    function execute() {
        return _execute.apply(this, arguments);
    }
    function _execute() {
        _execute = (0, _asyncToGenerator._)(function() {
            var productId, intakeCalculatorData;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        productId = selectCurrentProductId();
                        return [
                            4,
                            deps.retrieveIntakeCalculatorData(productId)
                        ];
                    case 1:
                        intakeCalculatorData = _state.sent();
                        return [
                            2,
                            (0, _intakeCalculator.IntakeCalculatorDataLoaded)({
                                intakeCalculatorData: intakeCalculatorData
                            })
                        ];
                }
            });
        });
        return _execute.apply(this, arguments);
    }
    function selectCurrentProductId() {
        throw new Error();
    }
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_ts_generator":"f2hGH","../events/IntakeCalculator":"8FDos","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"fREhI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "startDailyIntakeCalculation", function() {
    return startDailyIntakeCalculation;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _intakeCalculator = require("../events/IntakeCalculator");
var _intakeCalculator1 = require("../store/state/views/intakeCalculator");
var _calculateDailyIntake = require("../views/services/calculateDailyIntake");
var _intakeCalculatorData = require("../store/state/data/intakeCalculatorData");
var _calculateOrderRecommendation = require("../views/services/calculateOrderRecommendation");
var _variants = require("../store/state/data/variants");
var _state = require("../../../../snippets/components/cart/state");
function startDailyIntakeCalculation(deps) {
    return /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(event) {
            var result;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        result = calculate();
                        if (!hasDailyIntake(result)) return [
                            2,
                            sendResult(result)
                        ];
                        return [
                            4,
                            startCalculation()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            sendDelayedResult(result)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }();
    function calculate() {
        var viewState = deps.getState((0, _intakeCalculator1.intakeCalculatorViewSelector));
        var dataState = deps.getState((0, _intakeCalculatorData.intakeCalculatorDataSelector));
        var variantsState = deps.getState((0, _variants.variantsSelector));
        var cartState = deps.getState((0, _state.cartSelector));
        throw new Error();
    }
    function startCalculation() {
        return _startCalculation.apply(this, arguments);
    }
    function _startCalculation() {
        _startCalculation = (0, _asyncToGenerator._)(function() {
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            deps.publishEvent((0, _intakeCalculator.StartDailyIntakeCalculation)())
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return _startCalculation.apply(this, arguments);
    }
    function sendResult(result) {
        return _sendResult.apply(this, arguments);
    }
    function _sendResult() {
        _sendResult = (0, _asyncToGenerator._)(function(result) {
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            deps.publishEvent(result)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return _sendResult.apply(this, arguments);
    }
    function sendDelayedResult(result) {
        var delay = 2000;
        deps.debounce(result, 'IntakeCalculationEnded', delay);
    }
    function hasDailyIntake(result) {
        return !!result.payload.dailyIntake;
    }
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_ts_generator":"f2hGH","../events/IntakeCalculator":"8FDos","../store/state/views/intakeCalculator":"eDiK8","../views/services/calculateDailyIntake":"2YKhy","../store/state/data/intakeCalculatorData":"ctRLt","../views/services/calculateOrderRecommendation":"dPO5l","../store/state/data/variants":"11hc8","../../../../snippets/components/cart/state":"1HyQc","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"2YKhy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CalculateDailyIntakeError", function() {
    return CalculateDailyIntakeError;
});
parcelHelpers.export(exports, "calculateDailyIntake", function() {
    return calculateDailyIntake;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _std = require("@reglo/std");
var CalculateDailyIntakeError = /*#__PURE__*/ function(CalculateDailyIntakeError) {
    CalculateDailyIntakeError["MISSING_WEIGHT_VALUE"] = "MISSING_WEIGHT_VALUE";
    CalculateDailyIntakeError["MISSING_ACTIVITY_VALUE"] = "MISSING_ACTIVITY_VALUE";
    CalculateDailyIntakeError["UNDER_MINIMUM"] = "UNDER_MINIMUM";
    CalculateDailyIntakeError["OVER_MAXIMUM"] = "OVER_MAXIMUM";
    return CalculateDailyIntakeError;
}({});
function calculateDailyIntake(data) {
    return function(params) {
        var errors = validateInputs(params);
        if (errors.length > 0) return {
            dailyIntake: null,
            errors: errors
        };
        if (!hasParams(params)) throw new Error();
        var animalWeight = params.animalWeight;
        if (weightIsLessThanSmallestValue(animalWeight)) {
            var upperValue = selectSmallestValue();
            var dailyIntake = calculateWithUpperValue(params, upperValue);
            return {
                dailyIntake: dailyIntake,
                errors: []
            };
        }
        var lowerValue = selectLowerValue(animalWeight);
        var upperValue1 = selectUpperValue(animalWeight);
        var dailyIntake1 = calculateWithLowerAndUpperValues(params, lowerValue, upperValue1);
        return {
            dailyIntake: dailyIntake1,
            errors: []
        };
    };
    function validateInputs(params) {
        var animalWeight = params.animalWeight, animalActivityLevel = params.animalActivityLevel;
        var errors = [];
        if (animalWeight === null) errors.push("MISSING_WEIGHT_VALUE");
        else {
            if (isUnderMinimum(animalWeight)) errors.push("UNDER_MINIMUM");
            if (isOverMaximum(animalWeight)) errors.push("OVER_MAXIMUM");
        }
        if (!animalActivityLevel) errors.push("MISSING_ACTIVITY_VALUE");
        return errors;
    }
    function hasParams(params) {
        return !!params.animalWeight && !!params.animalActivityLevel;
    }
    function calculateWithUpperValue(params, upperValue) {
        return params.animalWeight * params.animalActivityLevel * (upperValue.dailyIntake / upperValue.animalWeight);
    }
    function calculateWithLowerAndUpperValues(params, lowerValue, upperValue) {
        return ((params.animalWeight - lowerValue.animalWeight) * ((upperValue.dailyIntake - lowerValue.dailyIntake) / (upperValue.animalWeight - lowerValue.animalWeight)) + lowerValue.dailyIntake) * params.animalActivityLevel;
    }
    function isUnderMinimum(animalWeight) {
        return animalWeight < (0, _std.unwrap)(data.entity).minimalAnimalWeight;
    }
    function isOverMaximum(animalWeight) {
        var values = (0, _std.unwrap)(data.entity).values;
        return animalWeight > values[values.length - 1].animalWeight;
    }
    function weightIsLessThanSmallestValue(weight) {
        return weight <= selectSmallestValue().animalWeight;
    }
    function selectLowerValue(animalWeight) {
        var invertedArray = (0, _toConsumableArray._)(selectValues()).reverse();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = invertedArray[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var value = _step.value;
                if (value.animalWeight < animalWeight) return value;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        throw new Error(`Cannot find lower value for ${animalWeight}`);
    }
    function selectUpperValue(animalWeight) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = selectValues()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var value = _step.value;
                if (value.animalWeight >= animalWeight) return value;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        throw new Error(`Cannot find upper value for ${animalWeight}`);
    }
    function selectSmallestValue() {
        return selectValues()[0];
    }
    function selectValues() {
        var _data_entity;
        var _data_entity_values;
        return (_data_entity_values = (_data_entity = data.entity) === null || _data_entity === void 0 ? void 0 : _data_entity.values) !== null && _data_entity_values !== void 0 ? _data_entity_values : [];
    }
}

},{"@swc/helpers/_/_to_consumable_array":"eqNDD","@reglo/std":"1USo0","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"dPO5l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calculateOrderRecommendation", function() {
    return calculateOrderRecommendation;
});
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _std = require("@reglo/std");
var _selectedSubscriptionPlanSelector = require("../../../../../snippets/components/cart/selectors/selectedSubscriptionPlanSelector");
function calculateOrderRecommendation(states) {
    return function(dailyIntake) {
        if (!dailyIntake) return null;
        var MINIMUM = 3;
        var MAXIMUM = 8;
        var quantity = 1;
        var weekFrequency = 0;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = orderVariantsByDecreasingWeight()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var variant = _step.value;
                while(true){
                    weekFrequency = computeWeekFrequency({
                        quantity: quantity,
                        dailyIntake: dailyIntake,
                        variant: variant
                    });
                    if (weekFrequency < MINIMUM) {
                        quantity++;
                        continue;
                    }
                    if (weekFrequency > MAXIMUM) break;
                    var variantId = variant.variantId;
                    var subscriptionPlanId = selectSubscriptionPlanId(variant);
                    return {
                        quantity: quantity,
                        variantId: variantId,
                        subscriptionPlanId: subscriptionPlanId
                    };
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        throw new Error('never');
    };
    function computeWeekFrequency(params) {
        var quantity = params.quantity, variant = params.variant, dailyIntake = params.dailyIntake;
        var productWeight = selectProductWeight(variant);
        return Math.floor(productWeight * quantity / dailyIntake / 7 * 0.9);
    }
    function selectProductWeight(variant) {
        switch(variant.format.unit){
            case 'kg':
                return variant.format.value * 1000;
            case 'L':
                return 0;
            default:
                return 0;
        }
    }
    function orderVariantsByDecreasingWeight() {
        var variants = selectProductVariants();
        return (0, _toConsumableArray._)(variants).sort(function(a, b) {
            return selectProductWeight(b) - selectProductWeight(a);
        });
    }
    function selectProductVariants() {
        var variants = states.variantsState.entities;
        var productId = states.productSelectionViewState.productId;
        return variants.filter(function(variant) {
            return variant.productId === productId;
        });
    }
    function selectSubscriptionPlanId(variant) {
        var _selectedSubscriptionPlanSelector1;
        return (0, _std.unwrap)((_selectedSubscriptionPlanSelector1 = (0, _selectedSubscriptionPlanSelector.selectedSubscriptionPlanSelector)(variant.variantId, states.variantsState, states.cartState)) === null || _selectedSubscriptionPlanSelector1 === void 0 ? void 0 : _selectedSubscriptionPlanSelector1.subscriptionPlanId);
    }
}

},{"@swc/helpers/_/_to_consumable_array":"eqNDD","@reglo/std":"1USo0","../../../../../snippets/components/cart/selectors/selectedSubscriptionPlanSelector":"dXpbD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"1qVi5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "requestPaymentMethodUpdate", function() {
    return requestPaymentMethodUpdate;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _std = require("@reglo/std");
var _account = require("../events/Account");
var _customerSubscription = require("../store/state/data/customerSubscription");
function requestPaymentMethodUpdate(deps) {
    return /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(event) {
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            deps.waitAtLeast(request(), 2000)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            deps.publishEvent((0, _account.PaymentMethodUpdateRequested)())
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }();
    function request() {
        return _request.apply(this, arguments);
    }
    function _request() {
        _request = (0, _asyncToGenerator._)(function() {
            var paymentMethodId;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        paymentMethodId = selectPaymentMethodId();
                        return [
                            4,
                            deps.executeCommand({
                                type: 'RequestPaymentMethodUpdate',
                                payload: {
                                    paymentMethodId: paymentMethodId
                                }
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return _request.apply(this, arguments);
    }
    function selectPaymentMethodId() {
        var _state_paymentMethod;
        var state = deps.getState((0, _customerSubscription.customerSubscriptionSelector));
        return (0, _std.unwrap)((_state_paymentMethod = state.paymentMethod) === null || _state_paymentMethod === void 0 ? void 0 : _state_paymentMethod.shopifyId);
    }
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_ts_generator":"f2hGH","@reglo/std":"1USo0","../events/Account":"em32I","../store/state/data/customerSubscription":"3ipiV","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"jG4l8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "trackSpentTime", function() {
    return trackSpentTime;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _startApp = require("../events/StartApp");
function trackSpentTime(deps) {
    return /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(event) {
            return (0, _tsGenerator._)(this, function(_state) {
                if (event.type !== (0, _startApp.StartAppKey)) return [
                    2
                ];
                setTimeout(function() {
                    deps.track('Spent30Seconds');
                }, 30000);
                setTimeout(function() {
                    deps.track('Spent60Seconds');
                }, 60000);
                return [
                    2
                ];
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }();
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_ts_generator":"f2hGH","../events/StartApp":"ggoaD","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"ikSli":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EmailSignedUpKey", function() {
    return EmailSignedUpKey;
});
parcelHelpers.export(exports, "EmailSignedUp", function() {
    return EmailSignedUp;
});
parcelHelpers.export(exports, "trackEmailSignUp", function() {
    return trackEmailSignUp;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _eventFactory = require("../../std/eventFactory");
var EmailSignedUpKey = 'EmailSignedUp';
var EmailSignedUp = (0, _eventFactory.eventFactory)(EmailSignedUpKey)();
function trackEmailSignUp(deps) {
    startListener();
    return /*#__PURE__*/ function() {
        var _ref = (0, _asyncToGenerator._)(function(event) {
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (event.type !== EmailSignedUpKey) return [
                            2
                        ];
                        return [
                            4,
                            deps.track('EmailSignedUp')
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }();
    function startListener() {
        window.addEventListener('klaviyoForms', /*#__PURE__*/ function() {
            var _ref = (0, _asyncToGenerator._)(function(event) {
                return (0, _tsGenerator._)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!(event.detail.type === 'stepSubmit' && typeof event.detail.metaData['$email'] === 'string')) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                deps.publishEvent(EmailSignedUp())
                            ];
                        case 1:
                            _state.sent();
                            _state.label = 2;
                        case 2:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(event) {
                return _ref.apply(this, arguments);
            };
        }());
    }
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_ts_generator":"f2hGH","../../std/eventFactory":"f2PpV","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"3RamT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initSentry", function() {
    return initSentry;
});
var _browser = require("@sentry/browser");
function initSentry() {
    init();
    logEmail();
    logLiquidError();
    function init() {
        _browser.init({
            dsn: "https://65b8c2d31e3744fba1a8116995e4e37a@o961943.ingest.sentry.io/6072945",
            environment: "development"
        });
    }
    function logEmail() {
        var data = localStorage.getItem('d5fce58502353dc1954f719e02a60718');
        if (data) _browser.setTag('customer_email', atob(data));
    }
    function logLiquidError() {
        var hasLiquidError = document.body.outerHTML.match(/Liquid error/);
        if (hasLiquidError) _browser.captureException('Liquid error');
    }
}

},{"@sentry/browser":"g8Lrm","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}],"Hjlgq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initAmplitude", function() {
    return initAmplitude;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _analyticsBrowser = require("@amplitude/analytics-browser");
var _std = require("@reglo/std");
function initAmplitude(deps) {
    (0, _asyncToGenerator._)(function() {
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        _analyticsBrowser.init((0, _std.unwrap)("6997bdee06a32ba84c536dc0617ad496"), {
                            logLevel: _analyticsBrowser.Types.LogLevel.None
                        }).promise
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    })();
}

},{"@swc/helpers/_/_async_to_generator":"j0yZk","@swc/helpers/_/_ts_generator":"f2hGH","@amplitude/analytics-browser":"3318X","@reglo/std":"1USo0","@parcel/transformer-js/src/esmodule-helpers.js":"5iBF5"}]},["idGTa"], "idGTa", "parcelRequire7cb6", {}, "./", "/")

